// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"9ZVxM":[function(require,module,exports,__globalThis) {
require("347145c67ebe6afd").register(require("7edf7f1b19ce9206").getBundleURL('7YEHs'), JSON.parse("[\"7YEHs\",\"index.7d76a13e.js\",\"3leio\",\"favicon.522d4946.png\",\"i8Hl8\",\"logo-edge.27e55ffe.svg\",\"57QKW\",\"thumb-waiting.6bede8ca.svg\",\"6rV4h\",\"4Grid.4101bb9f.png\",\"3q3pR\",\"index.7eb490c8.css\"]"));

},{"347145c67ebe6afd":"gSiLw","7edf7f1b19ce9206":"a2ypy"}],"gSiLw":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"a2ypy":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"EdkZp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("react-dom/client");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _nunitoSans = require("@fontsource/nunito-sans");
var _roboto = require("@fontsource/roboto");
var _robotoMono = require("@fontsource/roboto-mono");
var _indexCss = require("./index.css");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
var _reactDnd = require("react-dnd");
var _reactDndHtml5Backend = require("react-dnd-html5-backend");
var _store = require("./store");
var _mixpanel = require("./mixpanel");
const container = document.getElementById('root');
const root = (0, _client.createRoot)(container);
const router = (0, _reactRouter.createHashRouter)([
    {
        path: '*',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {})
    }
]);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.StrictMode), {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRedux.Provider), {
        store: (0, _store.storeWithRoutes).store,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _store.RouteContext).Provider, {
            value: {
                routes: (0, _store.storeWithRoutes).routes
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDnd.DndProvider), {
                backend: (0, _reactDndHtml5Backend.HTML5Backend),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.RouterProvider), {
                    router: router
                })
            })
        })
    })
}));
(0, _mixpanel.mixpanel).init();

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dom/client":"hx7eL","react-redux":"l1pMU","react-router":"iaz4C","@fontsource/nunito-sans":"cMtSt","@fontsource/roboto":"3iCiG","@fontsource/roboto-mono":"gnB4D","./index.css":"dAGoq","./App":"2GmFE","react-dnd":"aAvQg","react-dnd-html5-backend":"9AiUJ","./store":"5LXiG","./mixpanel":"7xxdr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dlk8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"8eUfv"}],"8eUfv":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"9njXz"}],"9njXz":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"kgZgX"}],"kgZgX":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"hx7eL":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"2ApDx"}],"2ApDx":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"3ekrv"}],"3ekrv":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"9njXz","ece50e903283a22f":"eTyLO"}],"eTyLO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"i8Rha"}],"i8Rha":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"l1pMU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider_default);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
parcelHelpers.export(exports, "batch", ()=>batch);
parcelHelpers.export(exports, "connect", ()=>connect_default);
parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
parcelHelpers.export(exports, "useStore", ()=>useStore);
// src/utils/react.ts
var _react = require("react");
// src/hooks/useSelector.ts
var _withSelectorJs = require("use-sync-external-store/with-selector.js");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var IS_REACT_19 = /* @__PURE__ */ _react.version.startsWith("19");
var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for(IS_REACT_19 ? "react.transitional.element" : "react.element");
var REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Memo = REACT_MEMO_TYPE;
function isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof } = object;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function isContextConsumer(object) {
    return IS_REACT_19 ? typeOf(object) === REACT_CONSUMER_TYPE : typeOf(object) === REACT_CONTEXT_TYPE;
}
function isMemo(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    verify(mapStateToProps, "mapStateToProps");
    verify(mapDispatchToProps, "mapDispatchToProps");
    verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual, areOwnPropsEqual, areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps, initMapDispatchToProps, initMergeProps } = _b, options = __objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function verifyPlainObject(value, displayName, methodName) {
    if (!isPlainObject(value)) warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? wrapMapToPropsConstant((dispatch)=>({
            dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return __spreadValues(__spreadValues(__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName, areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>defaultMergeProps : typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify () {},
    get: ()=>[]
};
function createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub,
        notifyNestedSubs,
        handleChangeWrapper,
        isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var isDOM = /* @__PURE__ */ canUseDOM();
var isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var isReactNative = /* @__PURE__ */ isRunningInReactNative();
var getUseIsomorphicLayoutEffect = ()=>isDOM || isReactNative ? _react.useLayoutEffect : _react.useEffect;
var useIsomorphicLayoutEffect = /* @__PURE__ */ getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {
    [ForwardRef]: FORWARD_REF_STATICS,
    [Memo]: MEMO_STATICS
};
function getStatics(component) {
    if (isMemo(component)) return MEMO_STATICS;
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if (objectPrototype) {
            const inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        const targetStatics = getStatics(targetComponent);
        const sourceStatics = getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function getContext() {
    var _a;
    if (!_react.createContext) return {};
    const contextMap = (_a = gT[ContextKey]) != null ? _a : gT[ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get(_react.createContext);
    if (!realContext) {
        realContext = _react.createContext(null);
        contextMap.set(_react.createContext, realContext);
    }
    return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();
// src/components/connect.tsx
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function strictEqual(a, b) {
    return a === b;
}
var hasWarnedAboutDeprecatedPureOption = false;
function connect(mapStateToProps, mapDispatchToProps, mergeProps, { // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual = strictEqual, areOwnPropsEqual = shallowEqual, areStatePropsEqual = shallowEqual, areMergedPropsEqual = shallowEqual, // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, // the context consumer to use
context = ReactReduxContext } = {}) {
    const Context = context;
    const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges,
            displayName,
            wrappedComponentName,
            WrappedComponent,
            // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps,
            initMergeProps,
            areStatesEqual,
            areStatePropsEqual,
            areOwnPropsEqual,
            areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = _react.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = __objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = _react.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = _react.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = _react.useMemo(()=>{
                return finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = _react.useMemo(()=>{
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY;
                const subscription2 = createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = _react.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return __spreadProps(__spreadValues({}, contextValue), {
                    subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = _react.useRef(void 0);
            const lastWrapperProps = _react.useRef(wrapperProps);
            const childPropsFromStoreUpdate = _react.useRef(void 0);
            const renderIsScheduled = _react.useRef(false);
            const isMounted = _react.useRef(false);
            const latestSubscriptionCallbackError = _react.useRef(void 0);
            useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = _react.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = _react.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = _react.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = _react.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ _react.createElement(WrappedComponent, __spreadProps(__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = _react.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ _react.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = _react.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = _react.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ _react.createElement(Connect, __spreadProps(__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var connect_default = connect;
// src/components/Provider.tsx
function Provider(providerProps) {
    const { children, context, serverState, store } = providerProps;
    const contextValue = _react.useMemo(()=>{
        const subscription = createSubscription(store);
        const baseContextValue = {
            store,
            subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = _react.useMemo(()=>store.getState(), [
        store
    ]);
    useIsomorphicLayoutEffect(()=>{
        const { subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || ReactReduxContext;
    return /* @__PURE__ */ _react.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var Provider_default = Provider;
// src/hooks/useReduxContext.ts
function createReduxContextHook(context = ReactReduxContext) {
    return function useReduxContext2() {
        const contextValue = _react.useContext(context);
        return contextValue;
    };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();
// src/hooks/useStore.ts
function createStoreHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : // @ts-ignore
    createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var useStore = /* @__PURE__ */ createStoreHook();
// src/hooks/useDispatch.ts
function createDispatchHook(context = ReactReduxContext) {
    const useStore2 = context === ReactReduxContext ? useStore : createStoreHook(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
var refEquality = (a, b)=>a === b;
function createSelectorHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn = refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store, subscription, getServerState } = reduxContext;
        const firstRun = _react.useRef(true);
        const wrappedSelector = _react.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, _withSelectorJs.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        _react.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();
// src/exports.ts
var batch = defaultNoopBatch;

},{"react":"9njXz","use-sync-external-store/with-selector.js":"BHNHb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"BHNHb":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("fb829f0ea2e039c2");

},{"fb829f0ea2e039c2":"9TMXi"}],"9TMXi":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("d61ad6209fae81c7");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = React.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"d61ad6209fae81c7":"9njXz"}],"jiucr":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"iaz4C":[function(require,module,exports,__globalThis) {
/**
 * react-router v7.6.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Await", ()=>(0, _chunkDQRVZFIRMjs.Await));
parcelHelpers.export(exports, "BrowserRouter", ()=>(0, _chunkDQRVZFIRMjs.BrowserRouter));
parcelHelpers.export(exports, "Form", ()=>(0, _chunkDQRVZFIRMjs.Form));
parcelHelpers.export(exports, "HashRouter", ()=>(0, _chunkDQRVZFIRMjs.HashRouter));
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>(0, _chunkDQRVZFIRMjs.IDLE_BLOCKER));
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>(0, _chunkDQRVZFIRMjs.IDLE_FETCHER));
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>(0, _chunkDQRVZFIRMjs.IDLE_NAVIGATION));
parcelHelpers.export(exports, "Link", ()=>(0, _chunkDQRVZFIRMjs.Link));
parcelHelpers.export(exports, "Links", ()=>(0, _chunkDQRVZFIRMjs.Links));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _chunkDQRVZFIRMjs.MemoryRouter));
parcelHelpers.export(exports, "Meta", ()=>(0, _chunkDQRVZFIRMjs.Meta));
parcelHelpers.export(exports, "NavLink", ()=>(0, _chunkDQRVZFIRMjs.NavLink));
parcelHelpers.export(exports, "Navigate", ()=>(0, _chunkDQRVZFIRMjs.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _chunkDQRVZFIRMjs.Action));
parcelHelpers.export(exports, "Outlet", ()=>(0, _chunkDQRVZFIRMjs.Outlet));
parcelHelpers.export(exports, "PrefetchPageLinks", ()=>(0, _chunkDQRVZFIRMjs.PrefetchPageLinks));
parcelHelpers.export(exports, "Route", ()=>(0, _chunkDQRVZFIRMjs.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _chunkDQRVZFIRMjs.Router));
parcelHelpers.export(exports, "RouterProvider", ()=>(0, _chunkDQRVZFIRMjs.RouterProvider));
parcelHelpers.export(exports, "Routes", ()=>(0, _chunkDQRVZFIRMjs.Routes));
parcelHelpers.export(exports, "Scripts", ()=>(0, _chunkDQRVZFIRMjs.Scripts));
parcelHelpers.export(exports, "ScrollRestoration", ()=>(0, _chunkDQRVZFIRMjs.ScrollRestoration));
parcelHelpers.export(exports, "ServerRouter", ()=>(0, _chunkDQRVZFIRMjs.ServerRouter));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _chunkDQRVZFIRMjs.StaticRouter));
parcelHelpers.export(exports, "StaticRouterProvider", ()=>(0, _chunkDQRVZFIRMjs.StaticRouterProvider));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _chunkDQRVZFIRMjs.DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _chunkDQRVZFIRMjs.DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _chunkDQRVZFIRMjs.ErrorResponseImpl));
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>(0, _chunkDQRVZFIRMjs.FetchersContext));
parcelHelpers.export(exports, "UNSAFE_FrameworkContext", ()=>(0, _chunkDQRVZFIRMjs.FrameworkContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _chunkDQRVZFIRMjs.LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _chunkDQRVZFIRMjs.NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RemixErrorBoundary", ()=>(0, _chunkDQRVZFIRMjs.RemixErrorBoundary));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _chunkDQRVZFIRMjs.RouteContext));
parcelHelpers.export(exports, "UNSAFE_ServerMode", ()=>(0, _chunkDQRVZFIRMjs.ServerMode));
parcelHelpers.export(exports, "UNSAFE_SingleFetchRedirectSymbol", ()=>(0, _chunkDQRVZFIRMjs.SingleFetchRedirectSymbol));
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>(0, _chunkDQRVZFIRMjs.ViewTransitionContext));
parcelHelpers.export(exports, "UNSAFE_createBrowserHistory", ()=>(0, _chunkDQRVZFIRMjs.createBrowserHistory));
parcelHelpers.export(exports, "UNSAFE_createClientRoutes", ()=>(0, _chunkDQRVZFIRMjs.createClientRoutes));
parcelHelpers.export(exports, "UNSAFE_createClientRoutesWithHMRRevalidationOptOut", ()=>(0, _chunkDQRVZFIRMjs.createClientRoutesWithHMRRevalidationOptOut));
parcelHelpers.export(exports, "UNSAFE_createRouter", ()=>(0, _chunkDQRVZFIRMjs.createRouter));
parcelHelpers.export(exports, "UNSAFE_decodeViaTurboStream", ()=>(0, _chunkDQRVZFIRMjs.decodeViaTurboStream));
parcelHelpers.export(exports, "UNSAFE_deserializeErrors", ()=>(0, _chunkDQRVZFIRMjs.deserializeErrors));
parcelHelpers.export(exports, "UNSAFE_getHydrationData", ()=>(0, _chunkDQRVZFIRMjs.getHydrationData));
parcelHelpers.export(exports, "UNSAFE_getPatchRoutesOnNavigationFunction", ()=>(0, _chunkDQRVZFIRMjs.getPatchRoutesOnNavigationFunction));
parcelHelpers.export(exports, "UNSAFE_getTurboStreamSingleFetchDataStrategy", ()=>(0, _chunkDQRVZFIRMjs.getTurboStreamSingleFetchDataStrategy));
parcelHelpers.export(exports, "UNSAFE_hydrationRouteProperties", ()=>(0, _chunkDQRVZFIRMjs.hydrationRouteProperties));
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>(0, _chunkDQRVZFIRMjs.invariant));
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>(0, _chunkDQRVZFIRMjs.mapRouteProperties));
parcelHelpers.export(exports, "UNSAFE_shouldHydrateRouteLoader", ()=>(0, _chunkDQRVZFIRMjs.shouldHydrateRouteLoader));
parcelHelpers.export(exports, "UNSAFE_useFogOFWarDiscovery", ()=>(0, _chunkDQRVZFIRMjs.useFogOFWarDiscovery));
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>(0, _chunkDQRVZFIRMjs.useScrollRestoration));
parcelHelpers.export(exports, "createBrowserRouter", ()=>(0, _chunkDQRVZFIRMjs.createBrowserRouter));
parcelHelpers.export(exports, "createCookie", ()=>(0, _chunkDQRVZFIRMjs.createCookie));
parcelHelpers.export(exports, "createCookieSessionStorage", ()=>(0, _chunkDQRVZFIRMjs.createCookieSessionStorage));
parcelHelpers.export(exports, "createHashRouter", ()=>(0, _chunkDQRVZFIRMjs.createHashRouter));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _chunkDQRVZFIRMjs.createMemoryRouter));
parcelHelpers.export(exports, "createMemorySessionStorage", ()=>(0, _chunkDQRVZFIRMjs.createMemorySessionStorage));
parcelHelpers.export(exports, "createPath", ()=>(0, _chunkDQRVZFIRMjs.createPath));
parcelHelpers.export(exports, "createRequestHandler", ()=>(0, _chunkDQRVZFIRMjs.createRequestHandler));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _chunkDQRVZFIRMjs.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _chunkDQRVZFIRMjs.createRoutesFromElements));
parcelHelpers.export(exports, "createRoutesStub", ()=>(0, _chunkDQRVZFIRMjs.createRoutesStub));
parcelHelpers.export(exports, "createSearchParams", ()=>(0, _chunkDQRVZFIRMjs.createSearchParams));
parcelHelpers.export(exports, "createSession", ()=>(0, _chunkDQRVZFIRMjs.createSession));
parcelHelpers.export(exports, "createSessionStorage", ()=>(0, _chunkDQRVZFIRMjs.createSessionStorage));
parcelHelpers.export(exports, "createStaticHandler", ()=>(0, _chunkDQRVZFIRMjs.createStaticHandler));
parcelHelpers.export(exports, "createStaticRouter", ()=>(0, _chunkDQRVZFIRMjs.createStaticRouter));
parcelHelpers.export(exports, "data", ()=>(0, _chunkDQRVZFIRMjs.data));
parcelHelpers.export(exports, "generatePath", ()=>(0, _chunkDQRVZFIRMjs.generatePath));
parcelHelpers.export(exports, "href", ()=>(0, _chunkDQRVZFIRMjs.href));
parcelHelpers.export(exports, "isCookie", ()=>(0, _chunkDQRVZFIRMjs.isCookie));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _chunkDQRVZFIRMjs.isRouteErrorResponse));
parcelHelpers.export(exports, "isSession", ()=>(0, _chunkDQRVZFIRMjs.isSession));
parcelHelpers.export(exports, "matchPath", ()=>(0, _chunkDQRVZFIRMjs.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _chunkDQRVZFIRMjs.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _chunkDQRVZFIRMjs.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _chunkDQRVZFIRMjs.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _chunkDQRVZFIRMjs.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _chunkDQRVZFIRMjs.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _chunkDQRVZFIRMjs.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _chunkDQRVZFIRMjs.resolvePath));
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>(0, _chunkDQRVZFIRMjs.HistoryRouter));
parcelHelpers.export(exports, "unstable_RouterContextProvider", ()=>(0, _chunkDQRVZFIRMjs.unstable_RouterContextProvider));
parcelHelpers.export(exports, "unstable_createContext", ()=>(0, _chunkDQRVZFIRMjs.unstable_createContext));
parcelHelpers.export(exports, "unstable_setDevServerHooks", ()=>(0, _chunkDQRVZFIRMjs.setDevServerHooks));
parcelHelpers.export(exports, "unstable_usePrompt", ()=>(0, _chunkDQRVZFIRMjs.usePrompt));
parcelHelpers.export(exports, "useActionData", ()=>(0, _chunkDQRVZFIRMjs.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _chunkDQRVZFIRMjs.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _chunkDQRVZFIRMjs.useAsyncValue));
parcelHelpers.export(exports, "useBeforeUnload", ()=>(0, _chunkDQRVZFIRMjs.useBeforeUnload));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _chunkDQRVZFIRMjs.useBlocker));
parcelHelpers.export(exports, "useFetcher", ()=>(0, _chunkDQRVZFIRMjs.useFetcher));
parcelHelpers.export(exports, "useFetchers", ()=>(0, _chunkDQRVZFIRMjs.useFetchers));
parcelHelpers.export(exports, "useFormAction", ()=>(0, _chunkDQRVZFIRMjs.useFormAction));
parcelHelpers.export(exports, "useHref", ()=>(0, _chunkDQRVZFIRMjs.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _chunkDQRVZFIRMjs.useInRouterContext));
parcelHelpers.export(exports, "useLinkClickHandler", ()=>(0, _chunkDQRVZFIRMjs.useLinkClickHandler));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _chunkDQRVZFIRMjs.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _chunkDQRVZFIRMjs.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _chunkDQRVZFIRMjs.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _chunkDQRVZFIRMjs.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _chunkDQRVZFIRMjs.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _chunkDQRVZFIRMjs.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _chunkDQRVZFIRMjs.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _chunkDQRVZFIRMjs.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _chunkDQRVZFIRMjs.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _chunkDQRVZFIRMjs.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _chunkDQRVZFIRMjs.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _chunkDQRVZFIRMjs.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _chunkDQRVZFIRMjs.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _chunkDQRVZFIRMjs.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _chunkDQRVZFIRMjs.useRoutes));
parcelHelpers.export(exports, "useSearchParams", ()=>(0, _chunkDQRVZFIRMjs.useSearchParams));
parcelHelpers.export(exports, "useSubmit", ()=>(0, _chunkDQRVZFIRMjs.useSubmit));
parcelHelpers.export(exports, "useViewTransitionState", ()=>(0, _chunkDQRVZFIRMjs.useViewTransitionState));
var _chunkDQRVZFIRMjs = require("./chunk-DQRVZFIR.mjs");

},{"./chunk-DQRVZFIR.mjs":"fmrla","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fmrla":[function(require,module,exports,__globalThis) {
/**
 * react-router v7.6.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "unstable_createContext", ()=>unstable_createContext);
parcelHelpers.export(exports, "unstable_RouterContextProvider", ()=>unstable_RouterContextProvider);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "hydrationRouteProperties", ()=>hydrationRouteProperties);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromElements);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "SingleFetchRedirectSymbol", ()=>SingleFetchRedirectSymbol);
parcelHelpers.export(exports, "getTurboStreamSingleFetchDataStrategy", ()=>getTurboStreamSingleFetchDataStrategy);
parcelHelpers.export(exports, "decodeViaTurboStream", ()=>decodeViaTurboStream);
parcelHelpers.export(exports, "RemixErrorBoundary", ()=>RemixErrorBoundary);
parcelHelpers.export(exports, "createClientRoutesWithHMRRevalidationOptOut", ()=>createClientRoutesWithHMRRevalidationOptOut);
parcelHelpers.export(exports, "createClientRoutes", ()=>createClientRoutes);
parcelHelpers.export(exports, "shouldHydrateRouteLoader", ()=>shouldHydrateRouteLoader);
parcelHelpers.export(exports, "getPatchRoutesOnNavigationFunction", ()=>getPatchRoutesOnNavigationFunction);
parcelHelpers.export(exports, "useFogOFWarDiscovery", ()=>useFogOFWarDiscovery);
parcelHelpers.export(exports, "FrameworkContext", ()=>FrameworkContext);
parcelHelpers.export(exports, "Links", ()=>Links);
parcelHelpers.export(exports, "PrefetchPageLinks", ()=>PrefetchPageLinks);
parcelHelpers.export(exports, "Meta", ()=>Meta);
parcelHelpers.export(exports, "Scripts", ()=>Scripts);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "StaticRouterProvider", ()=>StaticRouterProvider);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler2);
parcelHelpers.export(exports, "createStaticRouter", ()=>createStaticRouter);
parcelHelpers.export(exports, "ServerRouter", ()=>ServerRouter);
parcelHelpers.export(exports, "createRoutesStub", ()=>createRoutesStub);
parcelHelpers.export(exports, "createCookie", ()=>createCookie);
parcelHelpers.export(exports, "isCookie", ()=>isCookie);
parcelHelpers.export(exports, "ServerMode", ()=>ServerMode);
parcelHelpers.export(exports, "setDevServerHooks", ()=>setDevServerHooks);
parcelHelpers.export(exports, "createRequestHandler", ()=>createRequestHandler);
parcelHelpers.export(exports, "createSession", ()=>createSession);
parcelHelpers.export(exports, "isSession", ()=>isSession);
parcelHelpers.export(exports, "createSessionStorage", ()=>createSessionStorage);
parcelHelpers.export(exports, "createCookieSessionStorage", ()=>createCookieSessionStorage);
parcelHelpers.export(exports, "createMemorySessionStorage", ()=>createMemorySessionStorage);
parcelHelpers.export(exports, "href", ()=>href);
parcelHelpers.export(exports, "deserializeErrors", ()=>deserializeErrors2);
parcelHelpers.export(exports, "getHydrationData", ()=>getHydrationData);
// lib/components.tsx
var _react = require("react");
// lib/server-runtime/cookies.ts
var _cookie = require("cookie");
// lib/server-runtime/headers.ts
var _setCookieParser = require("set-cookie-parser");
var $c64abefa466b2f68$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-DQRVZFIR.mjs"
});
var process = require("a23debd74b7af388");
var global = arguments[3];
var __typeError = (msg)=>{
    throw TypeError(msg);
};
var __accessCheck = (obj, member, msg)=>member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter)=>(__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value)=>member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var Action = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})(Action || {});
var PopStateEventType = "popstate";
function createMemoryHistory(options = {}) {
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function createBrowserHistory(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname, search, hash } = window2.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href2 = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href2 = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href2 + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? parsePath(to) : to,
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    };
    return location;
}
function createPath({ pathname = "/", search = "", hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    invariant(base, "No window.location.(origin|href) available to create URL");
    let href2 = typeof to === "string" ? to : createPath(to);
    href2 = href2.replace(/ $/, "%20");
    if (!isAbsolute && href2.startsWith("//")) href2 = base + href2;
    return new URL(href2, base);
}
// lib/router/utils.ts
function unstable_createContext(defaultValue) {
    return {
        defaultValue
    };
}
var _map;
var unstable_RouterContextProvider = class {
    constructor(init){
        __privateAdd(this, _map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    get(context) {
        if (__privateGet(this, _map).has(context)) return __privateGet(this, _map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    set(context, value) {
        __privateGet(this, _map).set(context, value);
    }
};
_map = new WeakMap();
var unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isUnsupportedLazyRouteObjectKey(key) {
    return unsupportedLazyRouteObjectKeys.has(key);
}
var unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "unstable_middleware",
    "children"
]);
function isUnsupportedLazyRouteFunctionKey(key) {
    return unsupportedLazyRouteFunctionKeys.has(key);
}
function isIndexRoute(route) {
    return route.index === true;
}
function convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, `Cannot specify children on an index route`);
        invariant(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if (isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function matchRoutes(routes, locationArg, basename = "/") {
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function generatePath(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify2(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName, isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive = false, end = true) {
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function resolvePath(to, fromPathname = "/") {
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function getResolveToMatches(matches) {
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = {
            ...toArg
        };
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function data(data2, init) {
    return new DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var redirect = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers
    });
};
var redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var ErrorResponseImpl = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "GET",
    ...validMutationMethodsArr
];
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_FETCHER = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let mapRouteProperties2 = init.mapRouteProperties || defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategyWithMiddleware;
    let future = {
        unstable_middleware: false,
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location, delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            // matches, errors, fetchers go through as-is
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }, {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path, submission, error } = normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = new unstable_RouterContextProvider(init.unstable_getContext ? await init.unstable_getContext() : void 0);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...getActionDataForCommit(pendingActionResult),
            loaderData,
            errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData
                    } : {}
                }, {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches, revalidatingFetchers } = getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches,
            loaderData,
            errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href2, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, href2, routeId, opts?.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let scopedContext = new unstable_RouterContextProvider(init.unstable_getContext ? await init.unstable_getContext() : void 0);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(void 0));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches, revalidatingFetchers } = getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset
        });
        redirect2 = findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset
            });
        }
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, getDoneFetcher(void 0));
            return;
        }
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission, fetcherSubmission, preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation({ currentLocation, nextLocation, historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch: fetch2,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || defaultMapRouteProperties;
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext, filterMatchesToLoad, skipLoaderErrorBubbling, skipRevalidation, dataStrategy, unstable_respond: respond } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new unstable_RouterContextProvider();
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return respond ? respond(staticContext) : staticContext;
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return respond ? respond(staticContext) : staticContext;
        }
        if (respond && matches.some((m)=>m.route.unstable_middleware || typeof m.route.lazy === "object" && m.route.lazy.unstable_middleware)) {
            invariant(requestContext instanceof unstable_RouterContextProvider, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            try {
                await loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await runMiddlewarePipeline({
                    request,
                    matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, true, async ()=>{
                    let result2 = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
                    if (isResponse(result2)) return result2;
                    renderedStaticContext = {
                        location,
                        basename,
                        ...result2
                    };
                    let res = await respond(renderedStaticContext);
                    return res;
                }, async (error, routeId)=>{
                    if (isResponse(error)) return error;
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        return respond(getStaticContextFromError(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, routeId).route.id));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        return respond({
                            matches,
                            location,
                            basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: isRouteErrorResponse(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        });
                    }
                });
                invariant(isResponse(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if (isResponse(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if (isResponse(result)) return result;
        return {
            location,
            basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId, requestContext, dataStrategy, unstable_respond: respond } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new unstable_RouterContextProvider();
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (respond && matches.some((m)=>m.route.unstable_middleware || typeof m.route.lazy === "object" && m.route.lazy.unstable_middleware)) {
            invariant(requestContext instanceof unstable_RouterContextProvider, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            await loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await runMiddlewarePipeline({
                request,
                matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, true, async ()=>{
                let result2 = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                if (isResponse(result2)) return respond(result2);
                let error2 = result2.errors ? Object.values(result2.errors)[0] : void 0;
                if (error2 !== void 0) throw error2;
                let value = result2.actionData ? Object.values(result2.actionData)[0] : Object.values(result2.loaderData)[0];
                return typeof value === "string" ? new Response(value) : Response.json(value);
            }, (error2)=>{
                if (isResponse(error2)) return respond(error2);
                return new Response(String(error2), {
                    status: 500,
                    statusText: "Unexpected Server Error"
                });
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error
            };
        } else {
            let dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if (isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if (isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, false);
                return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches,
            loaderData: {},
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
function getStaticContextFromError(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: void 0,
        text: void 0
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    let parsedPath = parsePath(path);
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: createPath(parsedPath),
        submission
    };
}
function getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult,
        actionStatus
    };
    let dsMatches = matches.map((match, index)=>{
        let { route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (route.loader == null) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if (isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate
        };
        let shouldLoad = shouldRevalidateLoader(match, shouldRevalidateArgs);
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if (shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches,
        revalidatingFetchers
    };
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>isSameRoute(aChild, bChild)));
}
var lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var loadLazyRouteProperty = ({ key, route, manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            invariant(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = loadLazyRouteProperty({
            key,
            route,
            manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise,
        lazyHandlerPromise
    };
}
function isNonNullable(value) {
    return value !== void 0;
}
function loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.unstable_middleware) return void 0;
        return loadLazyRouteProperty({
            key: "unstable_middleware",
            route,
            manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter(isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.unstable_middleware)) return defaultDataStrategy(args);
    return runMiddlewarePipeline(args, false, ()=>defaultDataStrategy(args), (error, routeId)=>({
            [routeId]: {
                type: "error",
                result: error
            }
        }));
}
async function runMiddlewarePipeline(args, propagateResult, handler, errorHandler) {
    let { matches, request, params, context } = args;
    let middlewareState = {
        handlerResult: void 0
    };
    try {
        let tuples = matches.flatMap((m)=>m.route.unstable_middleware ? m.route.unstable_middleware.map((fn)=>[
                    m.route.id,
                    fn
                ]) : []);
        let result = await callRouteMiddleware({
            request,
            params,
            context
        }, tuples, propagateResult, middlewareState, handler);
        return propagateResult ? result : middlewareState.handlerResult;
    } catch (e) {
        if (!middlewareState.middlewareError) throw e;
        let result = await errorHandler(middlewareState.middlewareError.error, middlewareState.middlewareError.routeId);
        if (propagateResult || !middlewareState.handlerResult) return result;
        return Object.assign(middlewareState.handlerResult, result);
    }
}
async function callRouteMiddleware(args, middlewares, propagateResult, middlewareState, handler, idx = 0) {
    let { request } = args;
    if (request.signal.aborted) {
        if (request.signal.reason) throw request.signal.reason;
        throw new Error(`Request aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
    }
    let tuple = middlewares[idx];
    if (!tuple) {
        middlewareState.handlerResult = await handler();
        return middlewareState.handlerResult;
    }
    let [routeId, middleware] = tuple;
    let nextCalled = false;
    let nextResult = void 0;
    let next = async ()=>{
        if (nextCalled) throw new Error("You may only call `next()` once per middleware");
        nextCalled = true;
        let result = await callRouteMiddleware(args, middlewares, propagateResult, middlewareState, handler, idx + 1);
        if (propagateResult) {
            nextResult = result;
            return nextResult;
        }
    };
    try {
        let result = await middleware({
            request: args.request,
            params: args.params,
            context: args.context
        }, next);
        if (nextCalled) {
            if (result === void 0) return nextResult;
            else return result;
        } else return next();
    } catch (error) {
        if (!middlewareState.middlewareError) middlewareState.middlewareError = {
            routeId,
            error
        };
        else if (middlewareState.middlewareError.error !== error) middlewareState.middlewareError = {
            routeId,
            error
        };
        throw error;
    }
}
function getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = loadLazyRouteProperty({
        key: "unstable_middleware",
        route: match.route,
        manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = loadLazyRoute(match.route, isMutationMethod(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, unstable_shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises,
        shouldLoad,
        unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return shouldRevalidateLoader(match, {
                ...unstable_shouldRevalidateArgs,
                defaultShouldRevalidate
            });
            return shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            if (isUsingNewApi || shouldLoad || handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) return callLoaderOrAction({
                request,
                match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride,
                scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: ()=>false,
            _lazyPromises: getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request,
        params: matches[0].params,
        context: scopedContext,
        matches
    };
    let unstable_runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `unstable_runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return runMiddlewarePipeline(typedDataStrategyArgs, false, ()=>cb({
                ...typedDataStrategyArgs,
                fetcherKey,
                unstable_runClientMiddleware: ()=>{
                    throw new Error("Cannot call `unstable_runClientMiddleware()` from within an `unstable_runClientMiddleware` handler");
                }
            }), (error, routeId)=>({
                [routeId]: {
                    type: "error",
                    result: error
                }
            }));
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey,
        unstable_runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function callLoaderOrAction({ request, match, lazyHandlerPromise, lazyRoutePromise, handlerOverride, scopedContext }) {
    let result;
    let onReject;
    let isAction = isMutationMethod(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new ErrorResponseImpl(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if (isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new ErrorResponseImpl(result.init?.status || 500, void 0, result.data),
                statusCode: isRouteErrorResponse(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : void 0
        };
    }
    if (isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) invariant(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, { pathname, routeId, method, type, message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath({
        ...parsedPath,
        hash: ""
    });
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function isRedirectDataStrategyResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectStatusCode(statusCode) {
    return redirectStatusCodes.has(statusCode);
}
function isRedirectResponse(result) {
    return isResponse(result) && isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toUpperCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toUpperCase());
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: void 0,
        json: void 0,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod,
        formAction,
        formEncType,
        formData: void 0,
        json,
        text: void 0
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise,
        //@ts-ignore
        resolve,
        //@ts-ignore
        reject
    };
}
var DataRouterContext = _react.createContext(null);
DataRouterContext.displayName = "DataRouter";
var DataRouterStateContext = _react.createContext(null);
DataRouterStateContext.displayName = "DataRouterState";
var ViewTransitionContext = _react.createContext({
    isTransitioning: false
});
ViewTransitionContext.displayName = "ViewTransition";
var FetchersContext = _react.createContext(/* @__PURE__ */ new Map());
FetchersContext.displayName = "Fetchers";
var AwaitContext = _react.createContext(null);
AwaitContext.displayName = "Await";
var NavigationContext = _react.createContext(null);
NavigationContext.displayName = "Navigation";
var LocationContext = _react.createContext(null);
LocationContext.displayName = "Location";
var RouteContext = _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
RouteContext.displayName = "Route";
var RouteErrorContext = _react.createContext(null);
RouteErrorContext.displayName = "RouteError";
var ENABLE_DEV_WARNINGS = true;
function useHref(to, { relative } = {}) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
function useLocation() {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return _react.useContext(LocationContext).location;
}
function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
function useMatch(pattern) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname } = useLocation();
    return _react.useMemo(()=>matchPath(pattern, decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) _react.useLayoutEffect(cb);
}
function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback((to, options = {})=>{
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = _react.createContext(null);
function useOutletContext() {
    return _react.useContext(OutletContext);
}
function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /* @__PURE__ */ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function useResolvedPath(to, { relative } = {}) {
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    return _react.useMemo(()=>resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if (ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
        invariant(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = matchRoutes(routes, {
        pathname: remainingPathname
    });
    if (ENABLE_DEV_WARNINGS) {
        warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ _react.createElement(LocationContext.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if (ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement("p", null, "\u{1F4BF} Hey developer \u{1F44B}"), /* @__PURE__ */ _react.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ _react.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ _react.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /* @__PURE__ */ _react.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = class extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function RenderedRoute({ routeContext, match, children }) {
    let dataRouterContext = _react.useContext(DataRouterContext);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        invariant(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ _react.createElement(RenderedRoute, {
                match,
                routeContext: {
                    outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError(hookName));
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    invariant(route, getDataRouterConsoleError(hookName));
    return route;
}
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    invariant(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function useRouteId() {
    return useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function useNavigation() {
    let state = useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function useRevalidator() {
    let dataRouterContext = useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = _react.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return _react.useMemo(()=>({
            revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function useMatches() {
    let { matches, loaderData } = useDataRouterState("useMatches" /* UseMatches */ );
    return _react.useMemo(()=>matches.map((m)=>convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function useLoaderData() {
    let state = useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function useRouteLoaderData(routeId) {
    let state = useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function useActionData() {
    let state = useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function useRouteError() {
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value?._data;
}
function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value?._error;
}
var blockerId = 0;
function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : IDLE_BLOCKER;
}
function useNavigateStable() {
    let { router } = useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(async (to, options = {})=>{
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) {
        alreadyWarned[key] = true;
        warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var alreadyWarned2 = {};
function warnOnce(condition, message) {
    if (!condition && !alreadyWarned2[message]) {
        alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.element) warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: _react.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.hydrateFallbackElement) warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: _react.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.errorElement) warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: _react.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var hydrationRouteProperties = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function createMemoryRouter(routes, opts) {
    return createRouter({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes,
        hydrationRouteProperties,
        mapRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function RouterProvider({ router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(/* @__PURE__ */ new Map());
    let setState = _react.useCallback((newState, { deletedFetchers, flushSync, viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else _react.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                _react.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /* @__PURE__ */ _react.createElement(Router, {
        basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator
    }, /* @__PURE__ */ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state
    })))))), null);
}
var MemoizedDataRoutes = _react.memo(DataRoutes);
function DataRoutes({ routes, future, state }) {
    return useRoutesImpl(routes, void 0, state, future);
}
function MemoryRouter({ basename, children, initialEntries, initialIndex }) {
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = createMemoryHistory({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function Navigate({ to, replace: replace2, state, relative }) {
    invariant(useInRouterContext(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = _react.useContext(NavigationContext);
    warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    let path = resolveTo(to, getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state,
            relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function Outlet(props) {
    return useOutlet(props.context);
}
function Route(_props) {
    invariant(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function Router({ basename: basenameProp = "/", children = null, location: locationProp, navigationType = "POP" /* Pop */ , navigator, static: staticProp = false }) {
    invariant(!useInRouterContext(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ _react.createElement(LocationContext.Provider, {
        children,
        value: locationContext
    }));
}
function Routes({ children, location }) {
    return useRoutes(createRoutesFromChildren(children), location);
}
function Await({ children, errorElement, resolve }) {
    return /* @__PURE__ */ _react.createElement(AwaitErrorBoundary, {
        resolve,
        errorElement
    }, /* @__PURE__ */ _react.createElement(ResolveAwait, null, children));
}
var AwaitErrorBoundary = class extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children
        });
        throw promise;
    }
};
function ResolveAwait({ children }) {
    let data2 = useAsyncValue();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, toRender);
}
function createRoutesFromChildren(children, parentPath = []) {
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!_react.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        invariant(element.type === Route, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        invariant(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var createRoutesFromElements = createRoutesFromChildren;
function renderMatches(matches) {
    return _renderMatches(matches);
}
// lib/dom/dom.ts
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event);
}
function createSearchParams(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) {
        warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${defaultEncType}"`);
        return null;
    }
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(form, target);
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
// lib/dom/ssr/invariant.ts
function invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await require(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $c64abefa466b2f68$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href2)=>({
                    rel: "stylesheet",
                    href: href2
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = getModuleLinkHrefs(matches, manifest);
    return dedupeLinkDescriptors(descriptors, preloads);
}
function getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href2)=>({
            rel: "stylesheet",
            href: href2
        }));
}
async function prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = getRouteCssDescriptors(route);
    await Promise.all(descriptors.map(prefetchStyleLink));
}
async function prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map(prefetchStyleLink));
}
async function prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return dedupeLinkDescriptors(links.flat(1).filter(isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function getModuleLinkHrefs(matches, manifest, { includeHydrateFallback } = {}) {
    return dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify(sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var _isPreloadSupported;
function isPreloadSupported() {
    if (_isPreloadSupported !== void 0) return _isPreloadSupported;
    let el = document.createElement("link");
    _isPreloadSupported = el.relList.supports("preload");
    el = null;
    return _isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function escapeHtml(html) {
    return html.replace(ESCAPE_REGEX, (match)=>ESCAPE_LOOKUP[match]);
}
function createHtml(html) {
    return {
        __html: html
    };
}
// vendor/turbo-stream-v2/utils.ts
var HOLE = -1;
var NAN = -2;
var NEGATIVE_INFINITY = -3;
var NEGATIVE_ZERO = -4;
var NULL = -5;
var POSITIVE_INFINITY = -6;
var UNDEFINED = -7;
var TYPE_BIGINT = "B";
var TYPE_DATE = "D";
var TYPE_ERROR = "E";
var TYPE_MAP = "M";
var TYPE_NULL_OBJECT = "N";
var TYPE_PROMISE = "P";
var TYPE_REGEXP = "R";
var TYPE_SET = "S";
var TYPE_SYMBOL = "Y";
var TYPE_URL = "U";
var TYPE_PREVIOUS_RESOLVED = "Z";
var Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function flatten(input) {
    const { indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return UNDEFINED;
    if (input === null) return NULL;
    if (Number.isNaN(input)) return NAN;
    if (input === Number.POSITIVE_INFINITY) return POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    stringify.call(this, input, index);
    return index;
}
function stringify(input, index) {
    const { deferred, plugins, postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flatten.call(this, k)}":${flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? flatten.call(this, input2[i]) : HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) str[index2] = `["${TYPE_DATE}",${input2.getTime()}]`;
                        else if (input2 instanceof URL) str[index2] = `["${TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${TYPE_SET}",${[
                                ...input2
                            ].map((val)=>flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    flatten.call(this, k),
                                    flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if (isPlainObject(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames;
}
// vendor/turbo-stream-v2/unflatten.ts
var globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function unflatten(parsed) {
    const { hydrated, values } = this;
    if (typeof parsed === "number") return hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return hydrate.call(this, startIndex);
}
function hydrate(index) {
    const { hydrated, values, deferred, plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case UNDEFINED:
                set(void 0);
                continue;
            case NULL:
                set(null);
                continue;
            case NAN:
                set(NaN);
                continue;
            case POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && globalObj && globalObj[errorType] ? new globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function decode(readable, options) {
    const { plugins } = options ?? {};
    const done = new Deferred2();
    const reader = readable.pipeThrough(createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins
    };
    const decoded = await decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: unflatten.call(this, line)
    };
}
async function decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function encode(input, options) {
    const { plugins, postPlugins, signal } = options ?? {};
    const encoder2 = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins,
        postPlugins,
        signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = flatten.call(encoder2, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder2.stringified.join(",")}]
`));
                lastSentIndex = encoder2.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder2.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder2.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder2.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder2.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = flatten.call(encoder2, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${TYPE_PROMISE}${deferredId}:[["${TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder2.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder2.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder2.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = flatten.call(encoder2, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${TYPE_ERROR}${deferredId}:[["${TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder2.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder2.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder2.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder2.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder2.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder2.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var SingleFetchRedirectSymbol = Symbol("SingleFetchRedirect");
var SingleFetchNoResultError = class extends Error {
};
var SINGLE_FETCH_REDIRECT_STATUS = 202;
var NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function StreamTransfer({ context, identifier, reader, textDecoder, nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done, value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ _react.createElement("script", {
        nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ _react.createElement(_react.Fragment, null, scriptTag, /* @__PURE__ */ _react.createElement("script", {
        nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ _react.createElement(_react.Fragment, null, scriptTag, /* @__PURE__ */ _react.createElement(_react.Suspense, null, /* @__PURE__ */ _react.createElement(StreamTransfer, {
        context,
        identifier: identifier + 1,
        reader,
        textDecoder,
        nonce
    })));
}
function getTurboStreamSingleFetchDataStrategy(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = getSingleFetchDataStrategyImpl(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.unstable_runClientMiddleware(dataStrategy);
}
function getSingleFetchDataStrategyImpl(getRouter, getRouteInfo, fetchAndDecode, ssr, basename) {
    return async (args)=>{
        let { request, matches, fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader, hasClientLoader } = getRouteInfo(m);
            return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename);
    };
}
async function singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if (isResponse(result.result) || isRouteErrorResponse(result.result) || isDataWithResponseInit(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: data(result.result, actionStatus)
        }
    };
}
async function nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.unstable_shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>createDeferred2());
    let singleFetchDfd = createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader, hasClientLoader, hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function singleFetchUrl(reqUrl, basename) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else if (basename && stripBasename(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.data`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request } = args;
    let url = singleFetchUrl(request.url, basename);
    if (request.method === "GET") {
        url = stripIndexParam(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await createRequestInit(request));
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new ErrorResponseImpl(404, "Not Found", true);
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: SINGLE_FETCH_REDIRECT_STATUS,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if (NO_BODY_STATUS_CODES.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes
            }
        };
    }
    invariant2(res.body, "No response body to decode");
    try {
        let decoded = await decodeViaTurboStream(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if (SingleFetchRedirectSymbol in typed) data2 = {
                redirect: typed[SingleFetchRedirectSymbol]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function decodeViaTurboStream(body, global2) {
    return decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new ErrorResponseImpl(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [SingleFetchRedirectSymbol]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate, reload, replace: replace2, status } = result.redirect;
        throw redirect(location, {
            status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise,
        //@ts-ignore
        resolve,
        //@ts-ignore
        reject
    };
}
var RemixErrorBoundary = class extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ _react.createElement(RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function RemixRootDefaultErrorBoundary({ error, isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ _react.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if (isRouteErrorResponse(error)) return /* @__PURE__ */ _react.createElement(BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ _react.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), ENABLE_DEV_WARNINGS ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ _react.createElement(BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp
    }, /* @__PURE__ */ _react.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ _react.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function BoundaryShell({ title, renderScripts, isOutsideRemixApp, children }) {
    let { routeModules } = useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ _react.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ _react.createElement("head", null, /* @__PURE__ */ _react.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ _react.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ _react.createElement("title", null, title)), /* @__PURE__ */ _react.createElement("body", null, /* @__PURE__ */ _react.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ _react.createElement(Scripts, null) : null)));
}
function RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ _react.createElement(BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, ENABLE_DEV_WARNINGS ? /* @__PURE__ */ _react.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ _react.createElement(RemixRootDefaultErrorBoundary, {
            error: useRouteError()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ _react.createElement(routeModule.Layout, null, /* @__PURE__ */ _react.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ _react.createElement(routeModule.Layout, null, /* @__PURE__ */ _react.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ _react.createElement(routeModule.Layout, null, /* @__PURE__ */ _react.createElement(HydrateFallback, null))
        } : {
            HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary,
        HydrateFallback
    };
}
function createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function createClientRoutesWithHMRRevalidationOptOut(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", groupRoutesByParentId(manifest), needsRevalidation);
}
function preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg), true);
    }
}
function noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new ErrorResponseImpl(405, "Method Not Allowed", new Error(msg), true);
}
function createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            require(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...getRouteComponents(route, routeModule, isSpaMode),
                unstable_middleware: routeModule.unstable_clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request, params, context }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request,
                            params,
                            context,
                            async serverLoader () {
                                preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = shouldHydrateRouteLoader(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request, params, context }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request,
                        params,
                        context,
                        async serverAction () {
                            preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader } = route.clientLoaderModule ? await require(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? require(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction } = await clientActionPromise;
                    invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                unstable_middleware: route.hasClientMiddleware ? async ()=>{
                    let { unstable_clientMiddleware } = route.clientMiddlewareModule ? await require(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    invariant2(unstable_clientMiddleware, "No `unstable_clientMiddleware` export found");
                    return unstable_clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        unstable_clientMiddleware: routeModule.unstable_clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function shouldHydrateRouteLoader(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var nextPaths = /* @__PURE__ */ new Set();
var discoveredPathsMaxSize = 1e3;
var discoveredPaths = /* @__PURE__ */ new Set();
var URL_LIMIT = 7680;
function isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function getPartialManifest({ sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = matchRoutes(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function getPatchRoutesOnNavigationFunction(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path, patch, signal, fetcherKey })=>{
        if (discoveredPaths.has(path)) return;
        await fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function useFogOFWarDiscovery(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    _react.useEffect(()=>{
        if (!isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!discoveredPaths.has(pathname)) nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from(nextPaths.keys()).filter((path)=>{
                if (discoveredPaths.has(path)) {
                    nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function getManifestPath(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    let url = new URL(getManifestPath(manifestPath, basename), window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > URL_LIMIT) {
        nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            if (sessionStorage.getItem(MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                console.error("Unable to discover routes due to manifest version mismatch.");
                return;
            }
            sessionStorage.setItem(MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        sessionStorage.removeItem(MANIFEST_VERSION_STORAGE_KEY);
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>addToFifoQueue(p, discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, createClientRoutes(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function addToFifoQueue(path, queue) {
    if (queue.size >= discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function useDataRouterContext2() {
    let context = _react.useContext(DataRouterContext);
    invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function useDataRouterStateContext() {
    let context = _react.useContext(DataRouterStateContext);
    invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var FrameworkContext = _react.createContext(void 0);
FrameworkContext.displayName = "FrameworkContext";
function useFrameworkContext() {
    let context = _react.useContext(FrameworkContext);
    invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = _react.useContext(FrameworkContext);
    let [maybePrefetch, setMaybePrefetch] = _react.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = _react.useState(false);
    let { onFocus, onBlur, onMouseEnter, onMouseLeave, onTouchStart } = theirElementProps;
    let ref = _react.useRef(null);
    _react.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    _react.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: composeEventHandlers(onFocus, setIntent),
            onBlur: composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function Links() {
    let { isSpaMode, manifest, routeModules, criticalCss } = useFrameworkContext();
    let { errors, matches: routerMatches } = useDataRouterStateContext();
    let matches = getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = _react.useMemo(()=>getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ _react.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ _react.createElement("link", {
        rel: "stylesheet",
        href: criticalCss.href
    }) : null, keyedLinks.map(({ key, link })=>isPageLinkDescriptor(link) ? /* @__PURE__ */ _react.createElement(PrefetchPageLinks, {
            key,
            ...link
        }) : /* @__PURE__ */ _react.createElement("link", {
            key,
            ...link
        })));
}
function PrefetchPageLinks({ page, ...dataLinkProps }) {
    let { router } = useDataRouterContext2();
    let matches = _react.useMemo(()=>matchRoutes(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ _react.createElement(PrefetchPageLinksImpl, {
        page,
        matches,
        ...dataLinkProps
    });
}
function useKeyedPrefetchLinks(matches) {
    let { manifest, routeModules } = useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = _react.useState([]);
    _react.useEffect(()=>{
        let interrupted = false;
        getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function PrefetchPageLinksImpl({ page, matches: nextMatches, ...linkProps }) {
    let location = useLocation();
    let { manifest, routeModules } = useFrameworkContext();
    let { basename } = useDataRouterContext2();
    let { loaderData, matches } = useDataRouterStateContext();
    let newMatchesForData = _react.useMemo(()=>getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = _react.useMemo(()=>getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = _react.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = singleFetchUrl(page, basename);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = _react.useMemo(()=>getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, dataHrefs.map((href2)=>/* @__PURE__ */ _react.createElement("link", {
            key: href2,
            rel: "prefetch",
            as: "fetch",
            href: href2,
            ...linkProps
        })), moduleHrefs.map((href2)=>/* @__PURE__ */ _react.createElement("link", {
            key: href2,
            rel: "modulepreload",
            href: href2,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key, link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ _react.createElement("link", {
            key,
            ...link
        })));
}
function Meta() {
    let { isSpaMode, routeModules } = useFrameworkContext();
    let { errors, matches: routerMatches, loaderData } = useDataRouterStateContext();
    let location = useLocation();
    let _matches = getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params,
            location,
            matches,
            error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName, ...rest } = metaProps;
            if (!isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ _react.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ _react.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ _react.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ _react.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ _react.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var isHydrated = false;
function Scripts(props) {
    let { manifest, serverHandoffString, isSpaMode, renderMeta, routeDiscovery, ssr } = useFrameworkContext();
    let { router, static: isStatic, staticContext } = useDataRouterContext2();
    let { matches: routerMatches } = useDataRouterStateContext();
    let enableFogOfWar = isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = getActiveMatches(routerMatches, null, isSpaMode);
    _react.useEffect(()=>{
        isHydrated = true;
    }, []);
    let initialScripts = _react.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule, clientLoaderModule, clientMiddlewareModule, hydrateFallbackModule, module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify(getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ _react.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let preloads = isHydrated ? [] : dedupe(manifest.entry.imports.concat(getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    return isHydrated ? null : /* @__PURE__ */ _react.createElement(_react.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ _react.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ _react.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ _react.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ _react.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if (isBrowser) window.__reactRouterVersion = "7.6.1";
} catch (e) {}
function createBrowserRouter(routes, opts) {
    return createRouter({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: createBrowserHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || parseHydrationData(),
        routes,
        mapRouteProperties,
        hydrationRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return createRouter({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || parseHydrationData(),
        routes,
        mapRouteProperties,
        hydrationRouteProperties,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: deserializeErrors(state.errors)
    };
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function BrowserRouter({ basename, children, window: window2 }) {
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = createBrowserHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HashRouter({ basename, children, window: window2 }) {
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HistoryRouter({ basename, children, history }) {
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let setState = _react.useCallback((newState)=>{
        _react.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
HistoryRouter.displayName = "unstable_HistoryRouter";
var ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var Link = _react.forwardRef(function LinkWithRef({ onClick, discover = "render", prefetch = "none", relative, reloadDocument, replace: replace2, state, target, to, preventScrollReset, viewTransition, ...rest }, forwardedRef) {
    let { basename } = _react.useContext(NavigationContext);
    let isAbsolute = typeof to === "string" && ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href2 = useHref(to, {
        relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = usePrefetchBehavior(prefetch, rest);
    let internalOnClick = useLinkClickHandler(to, {
        replace: replace2,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ _react.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href2,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: mergeRefs(forwardedRef, prefetchRef),
        target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ _react.createElement(_react.Fragment, null, link, /* @__PURE__ */ _react.createElement(PrefetchPageLinks, {
        page: href2
    })) : link;
});
Link.displayName = "Link";
var NavLink = _react.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children, ...rest }, ref) {
    let path = useResolvedPath(to, {
        relative: rest.relative
    });
    let location = useLocation();
    let routerState = _react.useContext(DataRouterStateContext);
    let { navigator, basename } = _react.useContext(NavigationContext);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ _react.createElement(Link, {
        ...rest,
        "aria-current": ariaCurrent,
        className,
        ref,
        style,
        to,
        viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
NavLink.displayName = "NavLink";
var Form = _react.forwardRef(({ discover = "render", fetcherKey, navigate, reloadDocument, replace: replace2, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition, ...props }, forwardedRef)=>{
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace: replace2,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /* @__PURE__ */ _react.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
Form.displayName = "Form";
function ScrollRestoration({ getKey, storageKey, ...props }) {
    let remixContext = _react.useContext(FrameworkContext);
    let { basename } = _react.useContext(NavigationContext);
    let location = useLocation();
    let matches = useMatches();
    useScrollRestoration({
        getKey,
        storageKey
    });
    let ssrKey = _react.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ _react.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
ScrollRestoration.displayName = "ScrollRestoration";
function getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function useDataRouterContext3(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError2(hookName));
    return ctx;
}
function useDataRouterState2(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError2(hookName));
    return state;
}
function useLinkClickHandler(to, { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = {}) {
    let navigate = useNavigate();
    let location = useLocation();
    let path = useResolvedPath(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : createPath(location) === createPath(path);
            navigate(to, {
                replace: replace2,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function useSearchParams(defaultInit) {
    warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = useLocation();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = useNavigate();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var fetcherId = 0;
var getUniqueFetcherId = ()=>`__${String(++fetcherId)}__`;
function useSubmit() {
    let { router } = useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename } = _react.useContext(NavigationContext);
    let currentRouteId = useRouteId();
    return _react.useCallback(async (target, options = {})=>{
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function useFormAction(action, { relative } = {}) {
    let { basename } = _react.useContext(NavigationContext);
    let routeContext = _react.useContext(RouteContext);
    invariant(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...useResolvedPath(action ? action : ".", {
            relative
        })
    };
    let location = useLocation();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function useFetcher({ key } = {}) {
    let { router } = useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext(RouteContext);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    invariant(fetcherData, `useFetcher must be used inside a FetchersContext`);
    invariant(route, `useFetcher must be used inside a RouteContext`);
    invariant(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = _react.useId();
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = _react.useCallback(async (href2, opts)=>{
        invariant(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href2, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm2 = _react.forwardRef((props, ref)=>{
            return /* @__PURE__ */ _react.createElement(Form, {
                ...props,
                navigate: false,
                fetcherKey,
                ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || IDLE_FETCHER;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>({
            Form: FetcherForm,
            submit,
            load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function useFetchers() {
    let state = useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key
        }));
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
function getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function useScrollRestoration({ getKey, storageKey } = {}) {
    let { router } = useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename } = _react.useContext(NavigationContext);
    let location = useLocation();
    let matches = useMatches();
    let navigation = useNavigation();
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = getScrollRestorationKey(location, matches, basename, getKey);
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {
            warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        _react.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        _react.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePrompt({ when, message }) {
    let blocker = useBlocker(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function useViewTransitionState(to, opts = {}) {
    let vtContext = _react.useContext(ViewTransitionContext);
    invariant(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename } = useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = useResolvedPath(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}
function StaticRouter({ basename, children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = getStatelessNavigator();
    return /* @__PURE__ */ _react.createElement(Router, {
        basename,
        children,
        location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function StaticRouterProvider({ context, router, hydrate: hydrate2 = true, nonce }) {
    invariant(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router,
        navigator: getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors(context.errors)
        };
        let json = htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state } = dataRouterContext.router;
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ _react.createElement(FetchersContext.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ _react.createElement(ViewTransitionContext.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ _react.createElement(Router, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ _react.createElement(DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state
    })))))), hydrateScript ? /* @__PURE__ */ _react.createElement("script", {
        suppressHydrationWarning: true,
        nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function DataRoutes2({ routes, future, state }) {
    return useRoutesImpl(routes, void 0, state, future);
}
function serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (isRouteErrorResponse(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function getStatelessNavigator() {
    return {
        createHref,
        encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function createStaticHandler2(routes, opts) {
    return createStaticHandler(routes, {
        ...opts,
        mapRouteProperties
    });
}
function createStaticRouter(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                unstable_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: IDLE_NAVIGATION,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref,
        encodeLocation,
        getFetcher () {
            return IDLE_FETCHER;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return IDLE_BLOCKER;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
}
function encodeLocation(to) {
    let href2 = typeof to === "string" ? to : createPath(to);
    href2 = href2.replace(/ $/, "%20");
    let encoded = ABSOLUTE_URL_REGEX3.test(href2) ? new URL(href2) : new URL(href2, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function htmlEscape(str) {
    return str.replace(ESCAPE_REGEX2, (match)=>ESCAPE_LOOKUP2[match]);
}
function ServerRouter({ context, url, nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest, routeModules, criticalCss, serverHandoffString } = context;
    let routes = createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && shouldHydrateRouteLoader(routeId, route.clientLoader, manifestRoute.hasLoader, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = createStaticRouter(routes, context.staticHandlerContext);
    return /* @__PURE__ */ _react.createElement(_react.Fragment, null, /* @__PURE__ */ _react.createElement(FrameworkContext.Provider, {
        value: {
            manifest,
            routeModules,
            criticalCss,
            serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            routeDiscovery: context.routeDiscovery,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ _react.createElement(RemixErrorBoundary, {
        location: router.state.location
    }, /* @__PURE__ */ _react.createElement(StaticRouterProvider, {
        router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ _react.createElement(_react.Suspense, null, /* @__PURE__ */ _react.createElement(StreamTransfer, {
        context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce
    })) : null);
}
function createRoutesStub(routes, unstable_getContext) {
    return function RoutesTestStub({ initialEntries, initialIndex, hydrationData, future }) {
        let routerRef = _react.useRef();
        let remixContextRef = _react.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {
                    unstable_subResourceIntegrity: future?.unstable_subResourceIntegrity === true,
                    unstable_middleware: future?.unstable_middleware === true
                },
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false,
                routeDiscovery: {
                    mode: "lazy",
                    manifestPath: "/__manifest"
                }
            };
            let patched = processRoutes(// @ts-expect-error `StubRouteObject` is stricter about `loader`/`action`
            // types compared to `AgnosticRouteObject`
            convertRoutesToDataRoutes(routes, (r)=>r), remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = createMemoryRouter(patched, {
                unstable_getContext,
                initialEntries,
                initialIndex,
                hydrationData
            });
        }
        return /* @__PURE__ */ _react.createElement(FrameworkContext.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ _react.createElement(RouterProvider, {
            router: routerRef.current
        }));
    };
}
function withComponentProps(Component4) {
    return function Wrapped() {
        return _react.createElement(Component4, {
            params: useParams(),
            loaderData: useLoaderData(),
            actionData: useActionData(),
            matches: useMatches()
        });
    };
}
function withHydrateFallbackProps(HydrateFallback) {
    return function Wrapped() {
        const props = {
            params: useParams(),
            loaderData: useLoaderData(),
            actionData: useActionData()
        };
        return _react.createElement(HydrateFallback, props);
    };
}
function withErrorBoundaryProps(ErrorBoundary) {
    return function Wrapped() {
        const props = {
            params: useParams(),
            loaderData: useLoaderData(),
            actionData: useActionData(),
            error: useRouteError()
        };
        return _react.createElement(ErrorBoundary, props);
    };
}
function processRoutes(routes, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component ? withComponentProps(route.Component) : void 0,
            HydrateFallback: route.HydrateFallback ? withHydrateFallbackProps(route.HydrateFallback) : void 0,
            ErrorBoundary: route.ErrorBoundary ? withErrorBoundaryProps(route.ErrorBoundary) : void 0,
            action: route.action,
            loader: route.loader,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should be stubbing loader/action/middleware,
            // not trying to re-implement the full loader/clientLoader/SSR/hydration
            // flow. That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasClientMiddleware: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            clientMiddlewareModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: newRoute.Component || Outlet,
            ErrorBoundary: newRoute.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = processRoutes(route.children, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var encoder = /* @__PURE__ */ new TextEncoder();
var sign = async (value, secret)=>{
    let data2 = encoder.encode(value);
    let key = await createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = encoder.encode(value);
    let key = await createKey2(secret, [
        "verify"
    ]);
    let signature = byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var createCookie = (name, cookieOptions = {})=>{
    let { secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, _cookie.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, _cookie.serialize)(name, value === "" ? "" : await encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var isCookie = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function encodeCookieValue(value, secrets) {
    let encoded = encodeData(value);
    if (secrets.length > 0) encoded = await sign(encoded, secrets[0]);
    return encoded;
}
async function decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await unsign(value, secret);
            if (unsignedValue !== false) return decodeData(unsignedValue);
        }
        return null;
    }
    return decodeData(value);
}
function encodeData(value) {
    return btoa(myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent(myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + hex(code, 2);
            else result += "%u" + hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function warnOnceAboutExpiresCookie(name, expires) {
    warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var ServerMode = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})(ServerMode || {});
function isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: sanitizeError(error, serverMode)
        });
    }, {});
}
function serializeError(error, serverMode) {
    let sanitized = sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (isRouteErrorResponse(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function matchServerRoutes(routes, pathname, basename) {
    let matches = matchRoutes(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function callRouteHandler(handler, args) {
    let result = await handler({
        request: stripRoutesParam(stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if (isDataWithResponseInit(result) && result.init && result.init.status && isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/dev.ts
var globalDevServerHooksKey = "__reactRouterDevServerHooks";
function setDevServerHooks(devServerHooks) {
    globalThis[globalDevServerHooksKey] = devServerHooks;
}
function getDevServerHooks() {
    return globalThis[globalDevServerHooksKey];
}
function getBuildTimeHeader(request, headerName) {
    if (typeof process !== "undefined") try {
        if (process.env?.IS_RR_BUILD_REQUEST === "yes") return request.headers.get(headerName);
    } catch (e) {}
    return null;
}
// lib/server-runtime/routes.ts
function groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function createRoutes(manifest, parentId = "", routesByParentId = groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: createRoutes(manifest, route.id, routesByParentId)
        }));
}
function createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            unstable_middleware: route.module.unstable_middleware,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                let preRenderedData = getBuildTimeHeader(args.request, "X-React-Router-Prerender-Data");
                if (preRenderedData != null) {
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await decodeViaTurboStream(stream, global);
                    let data2 = decoded.value;
                    if (data2 && SingleFetchRedirectSymbol in data2) {
                        let result = data2[SingleFetchRedirectSymbol];
                        let init = {
                            status: result.status
                        };
                        if (result.reload) throw redirectDocument(result.redirect, init);
                        else if (result.replace) throw replace(result.redirect, init);
                        else throw redirect(result.redirect, init);
                    } else {
                        invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                        let result = data2[route.id];
                        invariant3("data" in result, "Unable to process prerendered data");
                        return result.data;
                    }
                }
                let val = await callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function escapeHtml2(html) {
    return html.replace(ESCAPE_REGEX3, (match)=>ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function createServerHandoffString(serverHandoff) {
    return escapeHtml2(JSON.stringify(serverHandoff));
}
function getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders, actionData, loaderHeaders, loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id } = match.route;
        let route = build.routes[id];
        invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) prependCookies(errorHeaders, headers2);
            prependCookies(actionHeaders, headers2);
            prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders,
            parentHeaders,
            actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) prependCookies(errorHeaders, headers);
        prependCookies(actionHeaders, headers);
        prependCookies(loaderHeaders, headers);
        prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, _setCookieParser.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var SERVER_NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    ...NO_BODY_STATUS_CODES,
    304
]);
async function singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let respond2 = function(context) {
            let headers = getDocumentHeaders(build, context);
            if (isRedirectStatusCode(context.statusCode) && headers.has("Location")) return generateSingleFetchResponse(request, build, serverMode, {
                result: getSingleFetchRedirect(context.statusCode, headers, build.basename),
                headers,
                status: SINGLE_FETCH_REDIRECT_STATUS
            });
            if (context.errors) {
                Object.values(context.errors).forEach((err)=>{
                    if (!isRouteErrorResponse(err) || err.error) handleError(err);
                });
                context.errors = sanitizeErrors(context.errors, serverMode);
            }
            let singleFetchResult;
            if (context.errors) singleFetchResult = {
                error: Object.values(context.errors)[0]
            };
            else singleFetchResult = {
                data: Object.values(context.actionData || {})[0]
            };
            return generateSingleFetchResponse(request, build, serverMode, {
                result: singleFetchResult,
                headers,
                status: context.statusCode
            });
        };
        var respond = respond2;
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            skipRevalidation: true,
            unstable_respond: respond2
        });
        if (!isResponse(result)) result = respond2(result);
        if (isRedirectResponse(result)) return generateSingleFetchResponse(request, build, serverMode, {
            result: getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: SINGLE_FETCH_REDIRECT_STATUS
        });
        return result;
    } catch (error) {
        handleError(error);
        return generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error
            },
            headers: new Headers(),
            status: 500
        });
    }
}
async function singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let respond2 = function(context) {
            let headers = getDocumentHeaders(build, context);
            if (isRedirectStatusCode(context.statusCode) && headers.has("Location")) return generateSingleFetchResponse(request, build, serverMode, {
                result: {
                    [SingleFetchRedirectSymbol]: getSingleFetchRedirect(context.statusCode, headers, build.basename)
                },
                headers,
                status: SINGLE_FETCH_REDIRECT_STATUS
            });
            if (context.errors) {
                Object.values(context.errors).forEach((err)=>{
                    if (!isRouteErrorResponse(err) || err.error) handleError(err);
                });
                context.errors = sanitizeErrors(context.errors, serverMode);
            }
            let results = {};
            let loadedMatches = new Set(context.matches.filter((m)=>loadRouteIds ? loadRouteIds.has(m.route.id) : m.route.loader != null).map((m)=>m.route.id));
            if (context.errors) for (let [id, error] of Object.entries(context.errors))results[id] = {
                error
            };
            for (let [id, data2] of Object.entries(context.loaderData))if (!(id in results) && loadedMatches.has(id)) results[id] = {
                data: data2
            };
            return generateSingleFetchResponse(request, build, serverMode, {
                result: results,
                headers,
                status: context.statusCode
            });
        };
        var respond = respond2;
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let routesParam = new URL(request.url).searchParams.get("_routes");
        let loadRouteIds = routesParam ? new Set(routesParam.split(",")) : null;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            filterMatchesToLoad: (m)=>!loadRouteIds || loadRouteIds.has(m.route.id),
            skipLoaderErrorBubbling: true,
            unstable_respond: respond2
        });
        if (!isResponse(result)) result = respond2(result);
        if (isRedirectResponse(result)) return generateSingleFetchResponse(request, build, serverMode, {
            result: {
                [SingleFetchRedirectSymbol]: getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: SINGLE_FETCH_REDIRECT_STATUS
        });
        return result;
    } catch (error) {
        handleError(error);
        return generateSingleFetchResponse(request, build, serverMode, {
            result: {
                root: {
                    error
                }
            },
            headers: new Headers(),
            status: 500
        });
    }
}
function generateSingleFetchResponse(request, build, serverMode, { result, headers, status }) {
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if (SERVER_NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response(encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
function getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return encode(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name, message, stack } = serverMode === "production" /* Production */  ? sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof ErrorResponseImpl) {
                    let { data: data3, status, statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && SingleFetchRedirectSymbol in value) return [
                    "SingleFetchRedirect",
                    value[SingleFetchRedirectSymbol]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function derive(build, mode) {
    let routes = createRoutes(build.routes);
    let dataRoutes = createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        isRouteErrorResponse(error) && error.error ? error.error : error);
    });
    return {
        routes,
        dataRoutes,
        serverMode,
        staticHandler,
        errorHandler
    };
}
var createRequestHandler = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, initialContext) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let params = {};
        let loadContext;
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params,
                request
            });
        };
        if (_build.future.unstable_middleware) {
            if (initialContext == null) loadContext = new unstable_RouterContextProvider();
            else try {
                loadContext = new unstable_RouterContextProvider(initialContext);
            } catch (e) {
                let error = new Error(`Unable to create initial \`unstable_RouterContextProvider\` instance. Please confirm you are returning an instance of \`Map<unstable_routerContext, unknown>\` from your \`getLoadContext\` function.

Error: ${e instanceof Error ? e.toString() : e}`);
                handleError(error);
                return returnLastResortErrorResponse(error, serverMode);
            }
        } else loadContext = initialContext || {};
        let url = new URL(request.url);
        let normalizedBasename = _build.basename || "/";
        let normalizedPath = url.pathname;
        if (stripBasename(normalizedPath, normalizedBasename) === "/_root.data") normalizedPath = normalizedBasename;
        else if (normalizedPath.endsWith(".data")) normalizedPath = normalizedPath.replace(/\.data$/, "");
        if (stripBasename(normalizedPath, normalizedBasename) !== "/" && normalizedPath.endsWith("/")) normalizedPath = normalizedPath.slice(0, -1);
        let isSpaMode = getBuildTimeHeader(request, "X-React-Router-SPA-Mode") === "yes";
        if (!_build.ssr) {
            if (_build.prerender.length === 0) isSpaMode = true;
            else if (!_build.prerender.includes(normalizedPath) && !_build.prerender.includes(normalizedPath + "/")) {
                if (url.pathname.endsWith(".data")) {
                    errorHandler(new ErrorResponseImpl(404, "Not Found", `Refusing to SSR the path \`${normalizedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params,
                        request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else isSpaMode = true;
            }
        }
        let manifestUrl = getManifestPath(_build.routeDiscovery.manifestPath, normalizedBasename);
        if (url.pathname === manifestUrl) try {
            let res = await handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = matchServerRoutes(routes, normalizedPath, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = normalizedPath;
            let singleFetchMatches = matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request
                });
                if (isRedirectResponse(response)) {
                    let result = getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [SingleFetchRedirectSymbol]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response(encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: SINGLE_FETCH_REDIRECT_STATUS,
                        headers
                    });
                }
            }
        } else if (!isSpaMode && matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await handleResourceRequest(serverMode, _build, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let { pathname } = url;
            let criticalCss = void 0;
            if (_build.unstable_getCriticalCss) criticalCss = await _build.unstable_getCriticalCss({
                pathname
            });
            else if (mode === "development" /* Development */  && getDevServerHooks()?.getCriticalCss) criticalCss = await getDevServerHooks()?.getCriticalCss?.(pathname);
            response = await handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function handleManifestRequest(build, routes, url) {
    if (build.assets.version !== url.searchParams.get("version")) return new Response(null, {
        status: 204,
        headers: {
            "X-Remix-Reload-Document": "true"
        }
    });
    let patches = {};
    if (url.searchParams.has("p")) {
        let paths = /* @__PURE__ */ new Set();
        url.searchParams.getAll("p").forEach((path)=>{
            if (!path.startsWith("/")) path = `/${path}`;
            let segments = path.split("/").slice(1);
            segments.forEach((_, i)=>{
                let partialPath = segments.slice(0, i + 1).join("/");
                paths.add(`/${partialPath}`);
            });
        });
        for (let path of paths){
            let matches = matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let response = request.method !== "GET" ? await singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    return response;
}
async function handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss) {
    try {
        let response = await staticHandler.query(request, {
            requestContext: loadContext,
            unstable_respond: build.future.unstable_middleware ? (ctx)=>renderHtml(ctx, isSpaMode) : void 0
        });
        return isResponse(response) ? response : renderHtml(response, isSpaMode);
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    async function renderHtml(context, isSpaMode2) {
        if (isResponse(context)) return context;
        let headers = getDocumentHeaders(build, context);
        if (SERVER_NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
            status: context.statusCode,
            headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!isRouteErrorResponse(err) || err.error) handleError(err);
            });
            context.errors = sanitizeErrors(context.errors, serverMode);
        }
        let state = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors2(context.errors, serverMode)
        };
        let baseServerHandoff = {
            basename: build.basename,
            future: build.future,
            routeDiscovery: build.routeDiscovery,
            ssr: build.ssr,
            isSpaMode: isSpaMode2
        };
        let entryContext = {
            manifest: build.assets,
            routeModules: createEntryRouteModules(build.routes),
            staticHandlerContext: context,
            criticalCss,
            serverHandoffString: createServerHandoffString({
                ...baseServerHandoff,
                criticalCss
            }),
            serverHandoffStream: encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {},
            future: build.future,
            ssr: build.ssr,
            routeDiscovery: build.routeDiscovery,
            isSpaMode: isSpaMode2,
            serializeError: (err)=>serializeError(err, serverMode)
        };
        let handleDocumentRequestFunction = build.entry.module.default;
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error) {
            handleError(error);
            let errorForSecondRender = error;
            if (isResponse(error)) try {
                let data2 = await unwrapResponse(error);
                errorForSecondRender = new ErrorResponseImpl(error.status, error.statusText, data2);
            } catch (e) {}
            context = getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
            if (context.errors) context.errors = sanitizeErrors(context.errors, serverMode);
            let state2 = {
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: serializeErrors2(context.errors, serverMode)
            };
            entryContext = {
                ...entryContext,
                staticHandlerContext: context,
                serverHandoffString: createServerHandoffString(baseServerHandoff),
                serverHandoffStream: encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
                renderMeta: {}
            };
            try {
                return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
            } catch (error2) {
                handleError(error2);
                return returnLastResortErrorResponse(error2, serverMode);
            }
        }
    }
}
async function handleResourceRequest(serverMode, build, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId,
            requestContext: loadContext,
            unstable_respond: build.future.unstable_middleware ? (ctx)=>ctx : void 0
        });
        if (isResponse(response)) return response;
        if (typeof response === "string") return new Response(response);
        return Response.json(response);
    } catch (error) {
        if (isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if (isRouteErrorResponse(error)) {
            if (error) handleError(error);
            return errorResponseToJson(error, serverMode);
        }
        if (error instanceof Error && error.message === "Expected a response from queryRoute") {
            let newError = new Error("Expected a Response to be returned from resource route handler");
            handleError(newError);
            return returnLastResortErrorResponse(newError, serverMode);
        }
        handleError(error);
        return returnLastResortErrorResponse(error, serverMode);
    }
}
function errorResponseToJson(errorResponse, serverMode) {
    return Response.json(serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function flash(name) {
    return `__flash_${name}__`;
}
var createSession = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has(flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set(flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var isSession = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function createSessionStorage({ cookie: cookieArg, createData, readData, updateData, deleteData }) {
    let cookie = isCookie(cookieArg) ? cookieArg : createCookie(cookieArg?.name || "__session", cookieArg);
    warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return createSession(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function warnOnceAboutSigningSessionCookie(cookie) {
    warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://reactrouter.com/explanation/sessions-and-cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function createCookieSessionStorage({ cookie: cookieArg } = {}) {
    let cookie = isCookie(cookieArg) ? cookieArg : createCookie(cookieArg?.name || "__session", cookieArg);
    warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return createSession(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function createMemorySessionStorage({ cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return createSessionStorage({
        cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function href(path, ...args) {
    let params = args[0];
    return path.split("/").map((segment)=>{
        if (segment === "*") return params ? params["*"] : void 0;
        const match = segment.match(/^:([\w-]+)(\?)?/);
        if (!match) return segment;
        const param = match[1];
        const value = params ? params[param] : void 0;
        const isRequired = match[2] === void 0;
        if (isRequired && value === void 0) throw Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value;
    }).filter((segment)=>segment !== void 0).join("/");
}
// lib/dom/ssr/errors.ts
function deserializeErrors2(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/dom/ssr/hydration.tsx
function getHydrationData(state, routes, getRouteInfo, location, basename, isSpaMode) {
    let hydrationData = {
        ...state,
        loaderData: {
            ...state.loaderData
        }
    };
    let initialMatches = matchRoutes(routes, location, basename);
    if (initialMatches) for (let match of initialMatches){
        let routeId = match.route.id;
        let routeInfo = getRouteInfo(routeId);
        if (shouldHydrateRouteLoader(routeId, routeInfo.clientLoader, routeInfo.hasLoader, isSpaMode) && (routeInfo.hasHydrateFallback || !routeInfo.hasLoader)) delete hydrationData.loaderData[routeId];
        else if (!routeInfo.hasLoader) hydrationData.loaderData[routeId] = null;
    }
    return hydrationData;
}

},{"a23debd74b7af388":"5jT8D","react":"9njXz","cookie":"7xjGM","set-cookie-parser":"8NO3i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jT8D":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"7xjGM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parse = parse;
exports.serialize = serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const __toString = Object.prototype.toString;
const NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function parse(str, options) {
    const obj = new NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = startIndex(str, index, eqIdx);
        const keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function isDate(val) {
    return __toString.call(val) === "[object Date]";
}

},{}],"8NO3i":[function(require,module,exports,__globalThis) {
"use strict";
var defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter(isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, defaultParseOptions, options) : defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else cookie[key] = value;
    });
    return cookie;
}
function parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function parse(input, options) {
    options = options ? Object.assign({}, defaultParseOptions, options) : defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    options = options ? Object.assign({}, defaultParseOptions, options) : defaultParseOptions;
    if (!options.map) return input.filter(isNonEmptyString).map(function(str) {
        return parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter(isNonEmptyString).reduce(function(cookies, str) {
            var cookie = parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;

},{}],"cMtSt":[function() {},{}],"3iCiG":[function() {},{}],"gnB4D":[function() {},{}],"dAGoq":[function() {},{}],"2GmFE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _faviconPng = require("./img/favicon.png");
var _faviconPngDefault = parcelHelpers.interopDefault(_faviconPng);
var _snackbar = require("./components/common/Snackbar");
var _login = require("./components/login");
var _loggedin = require("./components/loggedin");
var _loggedinDefault = parcelHelpers.interopDefault(_loggedin);
var _types = require("common/api/v1/types");
var _uiActions = require("./redux/actions/uiActions");
var _themeSwitcher = require("./ThemeSwitcher");
var _logoFetcher = require("./components/common/LogoFetcher");
/**
 * Used just to add navigate to store middleware to use in redux epics
 */ const Initializer = ()=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _uiActions.init)(navigate));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch
    ]);
    return null;
};
function App() {
    const { source, type } = (0, _logoFetcher.useFetchedImage)((0, _types.ImageName).favicon);
    (0, _react.useEffect)(()=>{
        if (source === '') return; // fetch not complete yet
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            if (source === null) {
                // use default
                link.href = (0, _faviconPngDefault.default);
                link.type = 'image/png';
            } else {
                link.href = source;
                link.type = type;
            }
            document.getElementsByTagName('head')[0].appendChild(link);
        }
    }, [
        source
    ]);
    const isLoggedIn = (0, _reactRedux.useSelector)(({ userReducer })=>typeof userReducer.user === 'object' && !!userReducer.user && 'id' in userReducer.user, (0, _reactRedux.shallowEqual));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _themeSwitcher.ThemeSwitcher), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Initializer, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _snackbar.SnackbarProvider), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snackbar.Snackbar), {}),
                    isLoggedIn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loggedinDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _login.Login), {})
                ]
            })
        ]
    });
}
exports.default = App;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","./img/favicon.png":"6lP6a","./components/common/Snackbar":"11CWS","./components/login":"bJaMG","./components/loggedin":"9J59L","common/api/v1/types":"3qemx","./redux/actions/uiActions":"aO8kk","./ThemeSwitcher":"7t0FU","./components/common/LogoFetcher":"e3yqy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6lP6a":[function(require,module,exports,__globalThis) {
module.exports = require("970e82839136036a").getBundleURL('7YEHs') + "favicon.522d4946.png";

},{"970e82839136036a":"a2ypy"}],"11CWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnackbarProvider", ()=>SnackbarProvider);
parcelHelpers.export(exports, "Snackbar", ()=>Snackbar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _collapse = require("@mui/material/Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _warning = require("@mui/icons-material/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _error = require("@mui/icons-material/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _expandMore = require("@mui/icons-material/ExpandMore");
var _expandMoreDefault = parcelHelpers.interopDefault(_expandMore);
var _expandLess = require("@mui/icons-material/ExpandLess");
var _expandLessDefault = parcelHelpers.interopDefault(_expandLess);
var _styles = require("@mui/material/styles");
var _notistack = require("notistack");
var _notificationActions = require("../../redux/actions/notificationActions");
var _common = require("../../Common");
const StyledMaterialDesignContent = (0, _styles.styled)((0, _notistack.MaterialDesignContent))(({ theme })=>({
        '&.notistack-MuiContent-success': (0, _common.styles).success(theme),
        '&.notistack-MuiContent-error': (0, _common.styles).error(theme),
        '&.notistack-MuiContent-warning': (0, _common.styles).warning(theme),
        '&.notistack-MuiContent-info': (0, _common.styles).info(theme)
    }));
const iconProps = {
    style: {
        opacity: 0.6,
        marginRight: '12px'
    }
};
const SnackbarProvider = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _notistack.SnackbarProvider), {
        maxSnack: 3,
        Components: {
            success: StyledMaterialDesignContent,
            error: StyledMaterialDesignContent,
            warning: StyledMaterialDesignContent,
            info: StyledMaterialDesignContent
        },
        iconVariant: {
            success: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {
                ...iconProps
            }),
            error: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                ...iconProps
            }),
            warning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {
                ...iconProps
            }),
            info: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {
                ...iconProps
            })
        },
        children: [
            ' ',
            children
        ]
    });
const buttonStyle = {
    color: (theme)=>theme.palette.common.black,
    opacity: 0.6
};
const Snackbar = ()=>{
    const location = (0, _reactRouter.useLocation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const notifications = (0, _reactRedux.useSelector)(({ notificationsReducer: notifications })=>notifications);
    const errorSnackbarPosition = (0, _reactRedux.useSelector)(({ uiReducer })=>uiReducer.errorSnackbarPosition);
    const { enqueueSnackbar, closeSnackbar } = (0, _notistack.useSnackbar)();
    const [errorKeys, setErrorKeys] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        errorKeys.forEach((key)=>dispatch((0, _notificationActions.closeSnackbar)(key)));
        setErrorKeys([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        location.pathname
    ]);
    // Basic string message
    const enqueueBasicSnackbar = (notification)=>{
        enqueueSnackbar(notification.message, {
            anchorOrigin: {
                horizontal: 'right',
                vertical: 'bottom'
            },
            ...notification.options,
            action: defaultAction(notification.options.key || ''),
            onClose: defaultOnClose(notification),
            preventDuplicate: true
        });
    };
    // A new version is available, i.e. the client version is behind reported backend version
    const enqueueNewVersionSnackbar = (notification)=>{
        enqueueSnackbar('A new version is available', {
            anchorOrigin: {
                horizontal: 'right',
                vertical: 'bottom'
            },
            action: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            color: "primary",
                            size: "small",
                            onClick: ()=>window.location.reload(),
                            children: "Reload"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            color: "inherit",
                            onClick: ()=>dispatch((0, _notificationActions.closeSnackbar)(notification.options.key || '')),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {
                                sx: {
                                    opacity: buttonStyle.opacity
                                }
                            })
                        })
                    ]
                }),
            onClose: defaultOnClose(notification),
            ...notification.options,
            key: 'new-version',
            preventDuplicate: true
        });
    };
    // Fatal errors, encapsulating ErrorSnackbar
    const enqueueErrorSnackbar = (notification)=>{
        const anchorOrigin = {
            horizontal: errorSnackbarPosition.endsWith('-left') ? 'left' : 'right',
            vertical: errorSnackbarPosition.startsWith('top-') ? 'top' : 'bottom'
        };
        enqueueSnackbar(/*#__PURE__*/ (0, _jsxRuntime.jsx)(ErrorSnackbar, {
            error: notification.data
        }), {
            anchorOrigin,
            action: defaultAction(notification.options.key || ''),
            onClose: defaultOnClose(notification),
            ...notification.options,
            preventDuplicate: true
        });
        setErrorKeys([
            ...errorKeys,
            notification.options.key
        ]);
    };
    const defaultAction = (key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
            onClick: ()=>dispatch((0, _notificationActions.closeSnackbar)(key)),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {
                sx: buttonStyle,
                "data-test-id": "close-snackbar"
            })
        });
    const defaultOnClose = (notification)=>(event, reason)=>{
            if (notification.options.onClose) notification.options.onClose(event, reason);
            dispatch((0, _notificationActions.removeSnackbar)(notification.options.key || ''));
        };
    (0, _react.useEffect)(()=>{
        notifications.forEach((notification)=>{
            const key = notification.options.key || '';
            if (notification.dismissed) {
                closeSnackbar(key);
                dispatch((0, _notificationActions.removeSnackbar)(key));
                return;
            }
            switch(notification.type){
                case 'basic':
                    enqueueBasicSnackbar(notification);
                    break;
                case 'newVersionAvailableSnackbar':
                    enqueueNewVersionSnackbar(notification);
                    break;
                case 'fatalError':
                    enqueueErrorSnackbar(notification);
                    break;
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        notifications
    ]);
    return null;
};
/**
 * Specific snackbar to display error
 * @param error - NotificationErrorData
 */ const ErrorSnackbar = ({ error })=>{
    const [collapsed, setCollapsed] = (0, _react.useState)(false);
    let errorText = error.text;
    let errorTitle = error.text;
    if (error.httpStatusCode === 403) {
        errorTitle = 'Insufficient rights';
        errorText = 'Insufficient privilege for this user interaction, please contact your administrator';
    }
    if (error.httpStatusCode === 409) errorTitle = 'Conflict';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            maxWidth: 420
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    '& > *:first-child': {
                        flexGrow: 1
                    }
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        "data-test-id": "title",
                        children: errorTitle
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                        onClick: ()=>setCollapsed(!collapsed),
                        children: collapsed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandMoreDefault.default), {
                            sx: buttonStyle
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandLessDefault.default), {
                            sx: buttonStyle
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapseDefault.default), {
                in: !collapsed,
                children: [
                    errorText !== errorTitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "div",
                        variant: "body2",
                        children: errorText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "div",
                        variant: "body2",
                        "data-test-id": "details",
                        style: {
                            whiteSpace: 'pre-wrap'
                        },
                        children: formatErrorDetails(error.details)
                    })
                ]
            })
        ]
    });
};
function formatErrorDetails(details) {
    if (!details) return '';
    if (typeof details === 'string') return details;
    let detailsText = '';
    if (Array.isArray(details)) {
        detailsText += 'Details: ';
        for (const detail of details)detailsText += `${formatDetail(detail)}\n`;
    }
    return detailsText;
}
function formatDetail(detail) {
    if (!detail) return '';
    if (typeof detail === 'string') return detail;
    if (typeof detail.reason === 'string') return detail.reason;
    return JSON.stringify(detail);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/IconButton":"488As","@mui/material/Collapse":"c7nwP","@mui/material/Typography":"6NtGx","@mui/icons-material/CheckCircle":"crtKq","@mui/icons-material/Warning":"eRDc8","@mui/icons-material/Error":"4XfdO","@mui/icons-material/Info":"juq3i","@mui/icons-material/Close":"acjz6","@mui/icons-material/ExpandMore":"gUaK6","@mui/icons-material/ExpandLess":"fOT90","@mui/material/styles":"2UrBk","notistack":"iGc7o","../../redux/actions/notificationActions":"7LkQg","../../Common":"7DOrW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4QkF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("bdca5764f0a91ed8").default;
var _interopRequireDefault = require("9243eca8882c8a92").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    boxClasses: true
};
Object.defineProperty(exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return _boxClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Box.default;
    }
});
var _Box = _interopRequireDefault(require("c39f6702787c4f6"));
var _boxClasses = _interopRequireWildcard(require("cf08dc54881c9ac2"));
Object.keys(_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _boxClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _boxClasses[key];
        }
    });
});

},{"bdca5764f0a91ed8":"fiRIh","9243eca8882c8a92":"kZ6eK","c39f6702787c4f6":"kDPxV","cf08dc54881c9ac2":"3P50g"}],"fiRIh":[function(require,module,exports,__globalThis) {
var _typeof = require("41c629e90a135a51")["default"];
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (module.exports = _interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"41c629e90a135a51":"979to"}],"979to":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kZ6eK":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kDPxV":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("4ae2983abcd948ed").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _system = require("81978669f15f6d78");
var _propTypes = _interopRequireDefault(require("a7860eddc36b162"));
var _className = require("11dc183deb140f42");
var _styles = require("713ac09f33b52891");
var _identifier = _interopRequireDefault(require("21868ac231af1a51"));
var _boxClasses = _interopRequireDefault(require("34ac3023a7231ade"));
const defaultTheme = (0, _styles.createTheme)();
const Box = (0, _system.createBox)({
    themeId: _identifier.default,
    defaultTheme,
    defaultClassName: _boxClasses.default.root,
    generateClassName: _className.unstable_ClassNameGenerator.generate
});
var _default = exports.default = Box;

},{"4ae2983abcd948ed":"kZ6eK","81978669f15f6d78":"iFfXs","a7860eddc36b162":"bnNSm","11dc183deb140f42":"gC15W","713ac09f33b52891":"2UrBk","21868ac231af1a51":"gf60V","34ac3023a7231ade":"3P50g"}],"iFfXs":[function(require,module,exports,__globalThis) {
/**
 * @mui/system v7.1.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>(0, _styledEngine.css));
parcelHelpers.export(exports, "keyframes", ()=>(0, _styledEngine.keyframes));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _styledEngine.StyledEngineProvider));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "borders", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "breakpoints", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "cssContainerQueries", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "handleBreakpoints", ()=>(0, _indexJs2.handleBreakpoints));
parcelHelpers.export(exports, "mergeBreakpointsInOrder", ()=>(0, _indexJs2.mergeBreakpointsInOrder));
parcelHelpers.export(exports, "unstable_resolveBreakpointValues", ()=>(0, _indexJs2.resolveBreakpointValues));
parcelHelpers.export(exports, "compose", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "display", ()=>(0, _indexJsDefault5.default));
parcelHelpers.export(exports, "flexbox", ()=>(0, _indexJsDefault6.default));
parcelHelpers.export(exports, "grid", ()=>(0, _indexJsDefault7.default));
parcelHelpers.export(exports, "palette", ()=>(0, _indexJsDefault8.default));
parcelHelpers.export(exports, "positions", ()=>(0, _indexJsDefault9.default));
parcelHelpers.export(exports, "shadows", ()=>(0, _indexJsDefault10.default));
parcelHelpers.export(exports, "sizing", ()=>(0, _indexJsDefault11.default));
parcelHelpers.export(exports, "spacing", ()=>(0, _indexJsDefault12.default));
parcelHelpers.export(exports, "style", ()=>(0, _indexJsDefault13.default));
parcelHelpers.export(exports, "getPath", ()=>(0, _indexJs13.getPath));
parcelHelpers.export(exports, "getStyleValue", ()=>(0, _indexJs13.getStyleValue));
parcelHelpers.export(exports, "typography", ()=>(0, _indexJsDefault14.default));
parcelHelpers.export(exports, "unstable_styleFunctionSx", ()=>(0, _indexJsDefault15.default));
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>(0, _indexJs15.unstable_createStyleFunctionSx));
parcelHelpers.export(exports, "unstable_extendSxProp", ()=>(0, _indexJs15.extendSxProp));
parcelHelpers.export(exports, "unstable_defaultSxConfig", ()=>(0, _indexJs15.unstable_defaultSxConfig));
parcelHelpers.export(exports, "unstable_getThemeValue", ()=>(0, _indexJsDefault16.default));
parcelHelpers.export(exports, "Box", ()=>(0, _indexJsDefault17.default));
parcelHelpers.export(exports, "createBox", ()=>(0, _indexJsDefault18.default));
parcelHelpers.export(exports, "createStyled", ()=>(0, _indexJsDefault19.default));
parcelHelpers.export(exports, "styled", ()=>(0, _indexJsDefault20.default));
parcelHelpers.export(exports, "createTheme", ()=>(0, _indexJsDefault21.default));
parcelHelpers.export(exports, "createBreakpoints", ()=>(0, _createBreakpointsJsDefault.default));
parcelHelpers.export(exports, "createSpacing", ()=>(0, _createSpacingJsDefault.default));
parcelHelpers.export(exports, "shape", ()=>(0, _shapeJsDefault.default));
parcelHelpers.export(exports, "useThemeProps", ()=>(0, _indexJsDefault22.default));
parcelHelpers.export(exports, "getThemeProps", ()=>(0, _indexJs22.getThemeProps));
parcelHelpers.export(exports, "useTheme", ()=>(0, _indexJsDefault23.default));
parcelHelpers.export(exports, "useThemeWithoutDefault", ()=>(0, _indexJsDefault24.default));
parcelHelpers.export(exports, "useMediaQuery", ()=>(0, _indexJsDefault25.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _indexJsDefault26.default));
parcelHelpers.export(exports, "unstable_memoTheme", ()=>(0, _memoThemeJsDefault.default));
parcelHelpers.export(exports, "unstable_createCssVarsProvider", ()=>(0, _createCssVarsProviderJsDefault.default));
parcelHelpers.export(exports, "unstable_createGetCssVar", ()=>(0, _createGetCssVarJsDefault.default));
parcelHelpers.export(exports, "unstable_cssVarsParser", ()=>(0, _cssVarsParserJsDefault.default));
parcelHelpers.export(exports, "unstable_prepareCssVars", ()=>(0, _prepareCssVarsJsDefault.default));
parcelHelpers.export(exports, "unstable_createCssVarsTheme", ()=>(0, _createCssVarsThemeJsDefault.default));
parcelHelpers.export(exports, "responsivePropType", ()=>(0, _indexJsDefault27.default));
parcelHelpers.export(exports, "RtlProvider", ()=>(0, _indexJsDefault28.default));
/** ----------------- */ /** Layout components */ parcelHelpers.export(exports, "createContainer", ()=>(0, _createContainerJsDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _indexJsDefault29.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridJsDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackJsDefault.default));
// TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "experimental_sx", ()=>experimental_sx);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _styledEngine = require("@mui/styled-engine");
var _indexJs = require("./GlobalStyles/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./borders/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
parcelHelpers.exportAll(_indexJs1, exports);
var _indexJs2 = require("./breakpoints/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./cssContainerQueries/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./compose/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./display/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./flexbox/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
parcelHelpers.exportAll(_indexJs6, exports);
var _indexJs7 = require("./cssGrid/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
parcelHelpers.exportAll(_indexJs7, exports);
var _indexJs8 = require("./palette/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
parcelHelpers.exportAll(_indexJs8, exports);
var _indexJs9 = require("./positions/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
parcelHelpers.exportAll(_indexJs9, exports);
var _indexJs10 = require("./shadows/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./sizing/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
parcelHelpers.exportAll(_indexJs11, exports);
var _indexJs12 = require("./spacing/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
parcelHelpers.exportAll(_indexJs12, exports);
var _indexJs13 = require("./style/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./typography/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
parcelHelpers.exportAll(_indexJs14, exports);
var _indexJs15 = require("./styleFunctionSx/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./getThemeValue/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./Box/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./createBox/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./createStyled/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
parcelHelpers.exportAll(_indexJs19, exports);
var _indexJs20 = require("./styled/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./createTheme/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _createBreakpointsJs = require("./createBreakpoints/createBreakpoints.js");
var _createBreakpointsJsDefault = parcelHelpers.interopDefault(_createBreakpointsJs);
var _createSpacingJs = require("./createTheme/createSpacing.js");
var _createSpacingJsDefault = parcelHelpers.interopDefault(_createSpacingJs);
var _shapeJs = require("./createTheme/shape.js");
var _shapeJsDefault = parcelHelpers.interopDefault(_shapeJs);
var _indexJs22 = require("./useThemeProps/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./useTheme/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./useThemeWithoutDefault/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./useMediaQuery/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./colorManipulator/index.js");
parcelHelpers.exportAll(_indexJs26, exports);
var _indexJs27 = require("./ThemeProvider/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs27);
var _memoThemeJs = require("./memoTheme.js");
var _memoThemeJsDefault = parcelHelpers.interopDefault(_memoThemeJs);
var _createCssVarsProviderJs = require("./cssVars/createCssVarsProvider.js");
var _createCssVarsProviderJsDefault = parcelHelpers.interopDefault(_createCssVarsProviderJs);
var _createGetCssVarJs = require("./cssVars/createGetCssVar.js");
var _createGetCssVarJsDefault = parcelHelpers.interopDefault(_createGetCssVarJs);
var _cssVarsParserJs = require("./cssVars/cssVarsParser.js");
var _cssVarsParserJsDefault = parcelHelpers.interopDefault(_cssVarsParserJs);
var _prepareCssVarsJs = require("./cssVars/prepareCssVars.js");
var _prepareCssVarsJsDefault = parcelHelpers.interopDefault(_prepareCssVarsJs);
var _createCssVarsThemeJs = require("./cssVars/createCssVarsTheme.js");
var _createCssVarsThemeJsDefault = parcelHelpers.interopDefault(_createCssVarsThemeJs);
var _indexJs28 = require("./responsivePropType/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./RtlProvider/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs29);
parcelHelpers.exportAll(_indexJs29, exports);
var _indexJs30 = require("./version/index.js");
parcelHelpers.exportAll(_indexJs30, exports);
var _createContainerJs = require("./Container/createContainer.js");
var _createContainerJsDefault = parcelHelpers.interopDefault(_createContainerJs);
var _indexJs31 = require("./Container/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs31);
parcelHelpers.exportAll(_indexJs31, exports);
var _gridJs = require("./Grid/Grid.js");
var _gridJsDefault = parcelHelpers.interopDefault(_gridJs);
var _indexJs32 = require("./Grid/index.js");
parcelHelpers.exportAll(_indexJs32, exports);
var _stackJs = require("./Stack/Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _indexJs33 = require("./Stack/index.js");
parcelHelpers.exportAll(_indexJs33, exports);
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(19));
}

},{"@mui/utils/formatMuiErrorMessage":"gOgzd","@mui/styled-engine":"9ebNW","./GlobalStyles/index.js":"egiY5","./borders/index.js":"fI4be","./breakpoints/index.js":"dlsE8","./cssContainerQueries/index.js":"gdOTw","./compose/index.js":"fWaPb","./display/index.js":"4OYRs","./flexbox/index.js":"lFETv","./cssGrid/index.js":"f57xu","./palette/index.js":"eTtDc","./positions/index.js":"ld728","./shadows/index.js":"fY1wk","./sizing/index.js":"1xJe0","./spacing/index.js":"egxgQ","./style/index.js":"kKd3C","./typography/index.js":"auK1K","./styleFunctionSx/index.js":"8fFNO","./getThemeValue/index.js":"4awty","./Box/index.js":"25Rf0","./createBox/index.js":"7TlmG","./createStyled/index.js":"gy2Fg","./styled/index.js":"71lRH","./createTheme/index.js":"acrEQ","./createBreakpoints/createBreakpoints.js":"1bSZP","./createTheme/createSpacing.js":"9DrBd","./createTheme/shape.js":"cvee6","./useThemeProps/index.js":"lN0LR","./useTheme/index.js":"hP8yl","./useThemeWithoutDefault/index.js":"ixUYr","./useMediaQuery/index.js":"lO9cu","./colorManipulator/index.js":"4Ia8u","./ThemeProvider/index.js":"kQQhR","./memoTheme.js":"dXdvK","./cssVars/createCssVarsProvider.js":"kb1TN","./cssVars/createGetCssVar.js":"bKbie","./cssVars/cssVarsParser.js":"eZlgN","./cssVars/prepareCssVars.js":"82wxo","./cssVars/createCssVarsTheme.js":"7u4wK","./responsivePropType/index.js":"29LCr","./RtlProvider/index.js":"3ZzrW","./version/index.js":"bgf0C","./Container/createContainer.js":"jSdKs","./Container/index.js":"gjkxG","./Grid/Grid.js":"CDIjI","./Grid/index.js":"81RBb","./Stack/Stack.js":"iA9F0","./Stack/index.js":"5l9XM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gOgzd":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3789a633fdd91012").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _formatMuiErrorMessage.default;
    }
});
var _formatMuiErrorMessage = _interopRequireDefault(require("dea94008ecf6d708"));

},{"3789a633fdd91012":"kZ6eK","dea94008ecf6d708":"Tghup"}],"Tghup":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

},{}],"9ebNW":[function(require,module,exports,__globalThis) {
/**
 * @mui/styled-engine v7.1.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _react.ThemeContext));
parcelHelpers.export(exports, "keyframes", ()=>(0, _react.keyframes));
parcelHelpers.export(exports, "css", ()=>(0, _react.css));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "default", ()=>styled);
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "internal_mutateStyles", ()=>internal_mutateStyles);
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "internal_serializeStyles", ()=>internal_serializeStyles);
/* eslint-disable no-underscore-dangle */ var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _serialize = require("@emotion/serialize");
var _react = require("@emotion/react");
var _indexJs = require("./StyledEngineProvider/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./GlobalStyles/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
'use client';
function styled(tag, options) {
    const stylesFactory = (0, _styledDefault.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function internal_mutateStyles(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const wrapper = [];
function internal_serializeStyles(styles) {
    wrapper[0] = styles;
    return (0, _serialize.serializeStyles)(wrapper);
}

},{"@emotion/styled":"3YoOh","@emotion/serialize":"6P7Gu","@emotion/react":"lIeII","./StyledEngineProvider/index.js":"5UFRH","./GlobalStyles/index.js":"hsOEu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3YoOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newStyled);
var _emotionStyledBaseEsmJs = require("../base/dist/emotion-styled-base.esm.js");
var _emotionStyledBaseEsmJsDefault = parcelHelpers.interopDefault(_emotionStyledBaseEsmJs);
var _extends = require("@babel/runtime/helpers/extends");
var _react = require("@emotion/react");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _utils = require("@emotion/utils");
var _react1 = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var newStyled = (0, _emotionStyledBaseEsmJsDefault.default).bind(null);
tags.forEach(function(tagName) {
    newStyled[tagName] = newStyled(tagName);
});

},{"../base/dist/emotion-styled-base.esm.js":"8MyFy","@babel/runtime/helpers/extends":"ktcBy","@emotion/react":"lIeII","@emotion/serialize":"6P7Gu","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@emotion/utils":"du4W1","react":"9njXz","@emotion/is-prop-valid":"hCPdT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MyFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _utils = require("@emotion/utils");
var _react1 = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var isBrowser = typeof document !== 'undefined';
var isDevelopment = false;
var testOmitPropsOnStringTag = (0, _isPropValidDefault.default);
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react1.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, _react.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = _react1.useContext((0, _react.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, _serialize.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ _react1.createElement(_react1.Fragment, null, /*#__PURE__*/ _react1.createElement(Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ _react1.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, _extendsDefault.default)({}, options, nextOptions, {
                shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@emotion/react":"lIeII","@emotion/serialize":"6P7Gu","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@emotion/utils":"du4W1","react":"9njXz","@emotion/is-prop-valid":"hCPdT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAOJb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lIeII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElementD59E098FEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElementD59E098FEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElementD59E098FEsmJs.b));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElementD59E098FEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElementD59E098FEsmJs.d));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElementD59E098FEsmJs = require("./emotion-element-d59e098f.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var jsx = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, _emotionElementD59E098FEsmJs.h).call(props, 'css')) return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElementD59E098FEsmJs.E);
    createElementArgArray[1] = (0, _emotionElementD59E098FEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return _react.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})(jsx || (jsx = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElementD59E098FEsmJs.T)));
    if (!(0, _emotionElementD59E098FEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, _utils.insertStyles)(cache, serializedArr[i], false);
            if (!(0, _emotionElementD59E098FEsmJs.i) && res !== undefined) rules += res;
        }
        if (!(0, _emotionElementD59E098FEsmJs.i)) return rules;
    });
    if (!(0, _emotionElementD59E098FEsmJs.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElementD59E098FEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

},{"./emotion-element-d59e098f.esm.js":"8wFC4","react":"9njXz","@emotion/utils":"du4W1","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@emotion/serialize":"6P7Gu","@emotion/cache":"r7hGp","@babel/runtime/helpers/extends":"ktcBy","@emotion/weak-memoize":"8azSs","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"4kFGQ","hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8wFC4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>isDevelopment);
parcelHelpers.export(exports, "b", ()=>ThemeProvider);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "d", ()=>withTheme);
parcelHelpers.export(exports, "h", ()=>hasOwn);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _emotionReactIsolatedHnrsEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isDevelopment = false;
var isBrowser = typeof document !== 'undefined';
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: 'css'
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ _react.forwardRef(function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsEsmJsDefault.default)(WithTheme, Component);
}
var hasOwn = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if (hasOwn.call(props, _key)) newProps[_key] = props[_key];
    newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && !isDevelopment) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"9njXz","@emotion/cache":"r7hGp","@babel/runtime/helpers/esm/extends":"aAOJb","@emotion/weak-memoize":"8azSs","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"4kFGQ","@emotion/utils":"du4W1","@emotion/serialize":"6P7Gu","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"r7hGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isBrowser = typeof document !== 'undefined';
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + 'box-$1$2' + (0, _stylis.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-item-' + (0, _stylis.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-line-pack' + (0, _stylis.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + 'box-' + (0, _stylis.replace)(value, '-grow', '') + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, '$1' + (0, _stylis.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + '$1'), /(image-set)/, (0, _stylis.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + 'box-pack:$3' + (0, _stylis.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _stylis.WEBKIT) + '$2-$3' + '$1' + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, 'stretch') ? prefix((0, _stylis.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ':', ':' + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _stylis.WEBKIT) + '$2$3' + '$1' + (0, _stylis.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, '@', '@' + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var getServerStylisCache = isBrowser ? undefined : (0, _weakMemoizeDefault.default)(function() {
    return (0, _memoizeDefault.default)(function() {
        return {};
    });
});
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if (isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    if (!getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, _stylis.stringify),
            (0, _stylis.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, _stylis.stringify)
        ];
        var _serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis1 = function _stylis1(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), _serializer);
        };
        var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"4RXfS","stylis":"8LsfH","@emotion/weak-memoize":"8azSs","@emotion/memoize":"fCpYs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RXfS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
var isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8LsfH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8azSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fCpYs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kFGQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59Kh2":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"cPI6k"}],"cPI6k":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("569f914be4368a39");

},{"569f914be4368a39":"8jaqP"}],"8jaqP":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"du4W1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6P7Gu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if (isProcessableValue(asString)) string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
}

},{"@emotion/hash":"h2KJ7","@emotion/unitless":"bJPP1","@emotion/memoize":"fCpYs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h2KJ7":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bJPP1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kt8pI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var isBrowser = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ktcBy":[function(require,module,exports,__globalThis) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hCPdT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"fCpYs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5UFRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styledEngineProviderJsDefault.default));
var _styledEngineProviderJs = require("./StyledEngineProvider.js");
var _styledEngineProviderJsDefault = parcelHelpers.interopDefault(_styledEngineProviderJs);

},{"./StyledEngineProvider.js":"krEYG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"krEYG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TEST_INTERNALS_DO_NOT_USE", ()=>TEST_INTERNALS_DO_NOT_USE);
parcelHelpers.export(exports, "default", ()=>StyledEngineProvider);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _sheet = require("@emotion/sheet");
// To fix [Jest performance](https://github.com/mui/material-ui/issues/45638).
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const cacheMap = new Map();
const TEST_INTERNALS_DO_NOT_USE = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, _cacheDefault.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!insertionPoint) {
        insertionPoint = document.createElement('meta');
        insertionPoint.setAttribute('name', 'emotion-insertion-point');
        insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend(insertionPoint);
    }
}
function getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends (0, _sheet.StyleSheet) {
            insert(rule, options) {
                if (TEST_INTERNALS_DO_NOT_USE.insert) return TEST_INTERNALS_DO_NOT_USE.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.startsWith('@layer')) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function StyledEngineProvider(props) {
    const { injectFirst, enableCssLayer, children } = props;
    const cache = _react.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (cacheMap.has(cacheKey)) return cacheMap.get(cacheKey);
        const fresh = getCache(injectFirst, enableCssLayer);
        cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.CacheProvider), {
        value: cache,
        children: children
    }) : children;
}

},{"react":"9njXz","prop-types":"bnNSm","@emotion/react":"lIeII","@emotion/cache":"r7hGp","@emotion/sheet":"4RXfS","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnNSm":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"aLk8j"}],"aLk8j":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"di8d9"}],"di8d9":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"hsOEu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesJsDefault.default));
var _globalStylesJs = require("./GlobalStyles.js");
var _globalStylesJsDefault = parcelHelpers.interopDefault(_globalStylesJs);

},{"./GlobalStyles.js":"82ZXl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"82ZXl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GlobalStyles);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react1 = require("@emotion/react");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
    const { styles, defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Global), {
        styles: globalStyles
    });
}

},{"react":"9njXz","prop-types":"bnNSm","@emotion/react":"lIeII","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"egiY5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesJsDefault.default));
var _globalStylesJs = require("./GlobalStyles.js");
var _globalStylesJsDefault = parcelHelpers.interopDefault(_globalStylesJs);
parcelHelpers.exportAll(_globalStylesJs, exports);

},{"./GlobalStyles.js":"kiKWG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kiKWG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styledEngine = require("@mui/styled-engine");
var _indexJs = require("../useTheme/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function GlobalStyles({ styles, themeId, defaultTheme = {} }) {
    const upperTheme = (0, _indexJsDefault.default)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.GlobalStyles), {
        styles: globalStyles
    });
}
exports.default = GlobalStyles;

},{"react":"9njXz","prop-types":"bnNSm","@mui/styled-engine":"9ebNW","../useTheme/index.js":"hP8yl","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hP8yl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemeJsDefault.default));
var _useThemeJs = require("./useTheme.js");
var _useThemeJsDefault = parcelHelpers.interopDefault(_useThemeJs);
parcelHelpers.exportAll(_useThemeJs, exports);

},{"./useTheme.js":"b4g0E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4g0E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "systemDefaultTheme", ()=>systemDefaultTheme);
var _indexJs = require("../createTheme/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../useThemeWithoutDefault/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
'use client';
const systemDefaultTheme = (0, _indexJsDefault.default)();
function useTheme(defaultTheme = systemDefaultTheme) {
    return (0, _indexJsDefault1.default)(defaultTheme);
}
exports.default = useTheme;

},{"../createTheme/index.js":"acrEQ","../useThemeWithoutDefault/index.js":"ixUYr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"acrEQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createThemeJsDefault.default));
parcelHelpers.export(exports, "private_createBreakpoints", ()=>(0, _createBreakpointsJsDefault.default));
parcelHelpers.export(exports, "unstable_applyStyles", ()=>(0, _applyStylesJsDefault.default));
var _createThemeJs = require("./createTheme.js");
var _createThemeJsDefault = parcelHelpers.interopDefault(_createThemeJs);
var _createBreakpointsJs = require("../createBreakpoints/createBreakpoints.js");
var _createBreakpointsJsDefault = parcelHelpers.interopDefault(_createBreakpointsJs);
var _applyStylesJs = require("./applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);

},{"./createTheme.js":"9dkk1","../createBreakpoints/createBreakpoints.js":false,"./applyStyles.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9dkk1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _createBreakpointsJs = require("../createBreakpoints/createBreakpoints.js");
var _createBreakpointsJsDefault = parcelHelpers.interopDefault(_createBreakpointsJs);
var _indexJs = require("../cssContainerQueries/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _shapeJs = require("./shape.js");
var _shapeJsDefault = parcelHelpers.interopDefault(_shapeJs);
var _createSpacingJs = require("./createSpacing.js");
var _createSpacingJsDefault = parcelHelpers.interopDefault(_createSpacingJs);
var _styleFunctionSxJs = require("../styleFunctionSx/styleFunctionSx.js");
var _styleFunctionSxJsDefault = parcelHelpers.interopDefault(_styleFunctionSxJs);
var _defaultSxConfigJs = require("../styleFunctionSx/defaultSxConfig.js");
var _defaultSxConfigJsDefault = parcelHelpers.interopDefault(_defaultSxConfigJs);
var _applyStylesJs = require("./applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
function createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, _createBreakpointsJsDefault.default)(breakpointsInput);
    const spacing = (0, _createSpacingJsDefault.default)(spacingInput);
    let muiTheme = (0, _deepmergeDefault.default)({
        breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing,
        shape: {
            ...(0, _shapeJsDefault.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, _indexJsDefault.default)(muiTheme);
    muiTheme.applyStyles = (0, _applyStylesJsDefault.default);
    muiTheme = args.reduce((acc, argument)=>(0, _deepmergeDefault.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, _defaultSxConfigJsDefault.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSxJsDefault.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
exports.default = createTheme;

},{"@mui/utils/deepmerge":"7wtTC","../createBreakpoints/createBreakpoints.js":"1bSZP","../cssContainerQueries/index.js":"gdOTw","./shape.js":"cvee6","./createSpacing.js":"9DrBd","../styleFunctionSx/styleFunctionSx.js":"3nWVU","../styleFunctionSx/defaultSxConfig.js":"lMbjC","./applyStyles.js":"ebzhW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7wtTC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("be266a6c32a542a8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _deepmerge.default;
    }
});
var _deepmerge = _interopRequireWildcard(require("8cfea4a5b2a8b14f"));
Object.keys(_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _deepmerge[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _deepmerge[key];
        }
    });
});

},{"be266a6c32a542a8":"fiRIh","8cfea4a5b2a8b14f":"hSAmd"}],"hSAmd":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("1d13046138688e9e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deepmerge;
exports.isPlainObject = isPlainObject;
var React = _interopRequireWildcard(require("4493c42670b8e346"));
var _reactIs = require("f08e6f02d91d21a3");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
    if (/*#__PURE__*/ React.isValidElement(source) || (0, _reactIs.isValidElementType)(source) || !isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if (isPlainObject(target) && isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ React.isValidElement(source[key]) || (0, _reactIs.isValidElementType)(source[key])) output[key] = source[key];
        else if (isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

},{"1d13046138688e9e":"fiRIh","4493c42670b8e346":"9njXz","f08e6f02d91d21a3":"7MwU6"}],"7MwU6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("a620b46ed6d86cc0");

},{"a620b46ed6d86cc0":"4Bb1C"}],"4Bb1C":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                    case REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
exports.ContextConsumer = REACT_CONSUMER_TYPE;
exports.ContextProvider = REACT_CONTEXT_TYPE;
exports.Element = REACT_ELEMENT_TYPE;
exports.ForwardRef = REACT_FORWARD_REF_TYPE;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Lazy = REACT_LAZY_TYPE;
exports.Memo = REACT_MEMO_TYPE;
exports.Portal = REACT_PORTAL_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
exports.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
};
exports.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
};
exports.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
};
exports.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
exports.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
};
exports.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
};
exports.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
};
exports.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
};
exports.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
};
exports.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
exports.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
};
exports.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
exports.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
exports.typeOf = typeOf;

},{}],"1bSZP":[function(require,module,exports,__globalThis) {
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpointKeys", ()=>breakpointKeys);
parcelHelpers.export(exports, "default", ()=>createBreakpoints);
const breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function createBreakpoints(breakpoints) {
    const { // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit = 'px', step = 5, ...other } = breakpoints;
    const sortedValues = sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys,
        values: sortedValues,
        up,
        down,
        between,
        only,
        not,
        unit,
        ...other
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdOTw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cssContainerQueriesJsDefault.default));
parcelHelpers.export(exports, "isCqShorthand", ()=>(0, _cssContainerQueriesJs.isCqShorthand));
parcelHelpers.export(exports, "getContainerQuery", ()=>(0, _cssContainerQueriesJs.getContainerQuery));
parcelHelpers.export(exports, "sortContainerQueries", ()=>(0, _cssContainerQueriesJs.sortContainerQueries));
var _cssContainerQueriesJs = require("./cssContainerQueries.js");
var _cssContainerQueriesJsDefault = parcelHelpers.interopDefault(_cssContainerQueriesJs);

},{"./cssContainerQueries.js":"2n1ul","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2n1ul":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 eventhough 40rem > 300px
 */ parcelHelpers.export(exports, "sortContainerQueries", ()=>sortContainerQueries);
parcelHelpers.export(exports, "isCqShorthand", ()=>isCqShorthand);
parcelHelpers.export(exports, "getContainerQuery", ()=>getContainerQuery);
parcelHelpers.export(exports, "default", ()=>cssContainerQueries);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
function sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries
    };
}

},{"@mui/utils/formatMuiErrorMessage":"gOgzd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cvee6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shape = {
    borderRadius: 4
};
exports.default = shape;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DrBd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSpacing);
var _indexJs = require("../spacing/index.js");
function createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, _indexJs.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

},{"../spacing/index.js":"egxgQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"egxgQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _spacingJsDefault.default));
var _spacingJs = require("./spacing.js");
var _spacingJsDefault = parcelHelpers.interopDefault(_spacingJs);
parcelHelpers.exportAll(_spacingJs, exports);

},{"./spacing.js":"jYRMz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYRMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "marginKeys", ()=>marginKeys);
parcelHelpers.export(exports, "paddingKeys", ()=>paddingKeys);
parcelHelpers.export(exports, "createUnaryUnit", ()=>createUnaryUnit);
parcelHelpers.export(exports, "createUnarySpacing", ()=>createUnarySpacing);
parcelHelpers.export(exports, "getValue", ()=>getValue);
parcelHelpers.export(exports, "getStyleFromPropValue", ()=>getStyleFromPropValue);
parcelHelpers.export(exports, "margin", ()=>margin);
parcelHelpers.export(exports, "padding", ()=>padding);
var _indexJs = require("../responsivePropType/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../breakpoints/index.js");
var _indexJs2 = require("../style/index.js");
var _indexJs3 = require("../merge/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../memoize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs4);
const properties = {
    m: 'margin',
    p: 'padding'
};
const directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = (0, _indexJsDefault2.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if (aliases[prop]) prop = aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = properties[a];
    const direction = directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const spacingKeys = [
    ...marginKeys,
    ...paddingKeys
];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, _indexJs2.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function createUnarySpacing(theme) {
    return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = getValue(transformer, propValue);
            return acc;
        }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = getCssProperties(prop);
    const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, _indexJs1.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function style(props, keys) {
    const transformer = createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>resolveCssProperty(props, keys, prop, transformer)).reduce((0, _indexJsDefault1.default), {});
}
function margin(props) {
    return style(props, marginKeys);
}
margin.propTypes = {};
margin.filterProps = marginKeys;
function padding(props) {
    return style(props, paddingKeys);
}
padding.propTypes = {};
padding.filterProps = paddingKeys;
function spacing(props) {
    return style(props, spacingKeys);
}
spacing.propTypes = {};
spacing.filterProps = spacingKeys;
exports.default = spacing;

},{"../responsivePropType/index.js":"29LCr","../breakpoints/index.js":"dlsE8","../style/index.js":"kKd3C","../merge/index.js":"jyMgl","../memoize/index.js":"5F2Gg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"29LCr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _responsivePropTypeJsDefault.default));
var _responsivePropTypeJs = require("./responsivePropType.js");
var _responsivePropTypeJsDefault = parcelHelpers.interopDefault(_responsivePropTypeJs);

},{"./responsivePropType.js":"A4ix2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"A4ix2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const responsivePropType = {};
exports.default = responsivePropType;

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dlsE8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _breakpointsJsDefault.default));
var _breakpointsJs = require("./breakpoints.js");
var _breakpointsJsDefault = parcelHelpers.interopDefault(_breakpointsJs);
parcelHelpers.exportAll(_breakpointsJs, exports);

},{"./breakpoints.js":"4DEnZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4DEnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "values", ()=>values);
parcelHelpers.export(exports, "handleBreakpoints", ()=>handleBreakpoints);
parcelHelpers.export(exports, "createEmptyBreakpointObject", ()=>createEmptyBreakpointObject);
parcelHelpers.export(exports, "removeUnusedBreakpoints", ()=>removeUnusedBreakpoints);
parcelHelpers.export(exports, "mergeBreakpointsInOrder", ()=>mergeBreakpointsInOrder);
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
parcelHelpers.export(exports, "computeBreakpointsBase", ()=>computeBreakpointsBase);
parcelHelpers.export(exports, "resolveBreakpointValues", ()=>resolveBreakpointValues);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _indexJs = require("../merge/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../cssContainerQueries/index.js");
const values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${values[key]}px)`
};
const defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, _indexJs1.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, _indexJs1.getContainerQuery)(theme.containerQueries ? theme : defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, _indexJsDefault.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, _deepmergeDefault.default)(prev, next), {});
    return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
exports.default = breakpoints;

},{"prop-types":"bnNSm","@mui/utils/deepmerge":"7wtTC","../merge/index.js":"jyMgl","../cssContainerQueries/index.js":"gdOTw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyMgl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _mergeJsDefault.default));
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);

},{"./merge.js":"hylJi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hylJi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
function merge(acc, item) {
    if (!item) return acc;
    return (0, _deepmergeDefault.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
exports.default = merge;

},{"@mui/utils/deepmerge":"7wtTC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kKd3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styleJsDefault.default));
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
parcelHelpers.exportAll(_styleJs, exports);

},{"./style.js":"eOeiR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eOeiR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPath", ()=>getPath);
parcelHelpers.export(exports, "getStyleValue", ()=>getStyleValue);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _indexJs = require("../responsivePropType/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../breakpoints/index.js");
function getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function style(options) {
    const { prop, cssProperty = options.prop, themeKey, transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalizeDefault.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _indexJs1.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
exports.default = style;

},{"@mui/utils/capitalize":"5sWY4","../responsivePropType/index.js":"29LCr","../breakpoints/index.js":"dlsE8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5sWY4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f33d5c34454e99d8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _capitalize.default;
    }
});
var _capitalize = _interopRequireDefault(require("925664e156164044"));

},{"f33d5c34454e99d8":"kZ6eK","925664e156164044":"h29iZ"}],"h29iZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d039b89513d81de0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = capitalize;
var _formatMuiErrorMessage = _interopRequireDefault(require("a23f41b4ce1c9118"));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, _formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

},{"d039b89513d81de0":"kZ6eK","a23f41b4ce1c9118":"gOgzd"}],"5F2Gg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _memoizeJsDefault.default));
var _memoizeJs = require("./memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);

},{"./memoize.js":"e263e","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e263e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nWVU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>unstable_createStyleFunctionSx);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _indexJs = require("../merge/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../style/index.js");
var _indexJs2 = require("../breakpoints/index.js");
var _indexJs3 = require("../cssContainerQueries/index.js");
var _defaultSxConfigJs = require("./defaultSxConfig.js");
var _defaultSxConfigJsDefault = parcelHelpers.interopDefault(_defaultSxConfigJs);
function objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty = prop, themeKey, transform, style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, _indexJs1.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, _indexJs1.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, _indexJs1.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalizeDefault.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _indexJs2.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx, theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, _defaultSxConfigJsDefault.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, _indexJs2.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, _indexJsDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, _indexJs2.handleBreakpoints)({
                                theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if (objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme
                            });
                            else css = (0, _indexJsDefault.default)(css, breakpointsValues);
                        }
                    } else css = (0, _indexJsDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, _indexJs3.sortContainerQueries)(theme, (0, _indexJs2.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = [
    'sx'
];
exports.default = styleFunctionSx;

},{"@mui/utils/capitalize":"5sWY4","../merge/index.js":"jyMgl","../style/index.js":"kKd3C","../breakpoints/index.js":"dlsE8","../cssContainerQueries/index.js":"gdOTw","./defaultSxConfig.js":"lMbjC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lMbjC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../spacing/index.js");
var _indexJs1 = require("../borders/index.js");
var _indexJs2 = require("../cssGrid/index.js");
var _indexJs3 = require("../palette/index.js");
var _indexJs4 = require("../sizing/index.js");
const defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, _indexJs1.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, _indexJs1.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, _indexJs1.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, _indexJs1.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, _indexJs1.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, _indexJs1.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, _indexJs1.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, _indexJs3.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, _indexJs3.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, _indexJs3.paletteTransform)
    },
    // spacing
    p: {
        style: (0, _indexJs.padding)
    },
    pt: {
        style: (0, _indexJs.padding)
    },
    pr: {
        style: (0, _indexJs.padding)
    },
    pb: {
        style: (0, _indexJs.padding)
    },
    pl: {
        style: (0, _indexJs.padding)
    },
    px: {
        style: (0, _indexJs.padding)
    },
    py: {
        style: (0, _indexJs.padding)
    },
    padding: {
        style: (0, _indexJs.padding)
    },
    paddingTop: {
        style: (0, _indexJs.padding)
    },
    paddingRight: {
        style: (0, _indexJs.padding)
    },
    paddingBottom: {
        style: (0, _indexJs.padding)
    },
    paddingLeft: {
        style: (0, _indexJs.padding)
    },
    paddingX: {
        style: (0, _indexJs.padding)
    },
    paddingY: {
        style: (0, _indexJs.padding)
    },
    paddingInline: {
        style: (0, _indexJs.padding)
    },
    paddingInlineStart: {
        style: (0, _indexJs.padding)
    },
    paddingInlineEnd: {
        style: (0, _indexJs.padding)
    },
    paddingBlock: {
        style: (0, _indexJs.padding)
    },
    paddingBlockStart: {
        style: (0, _indexJs.padding)
    },
    paddingBlockEnd: {
        style: (0, _indexJs.padding)
    },
    m: {
        style: (0, _indexJs.margin)
    },
    mt: {
        style: (0, _indexJs.margin)
    },
    mr: {
        style: (0, _indexJs.margin)
    },
    mb: {
        style: (0, _indexJs.margin)
    },
    ml: {
        style: (0, _indexJs.margin)
    },
    mx: {
        style: (0, _indexJs.margin)
    },
    my: {
        style: (0, _indexJs.margin)
    },
    margin: {
        style: (0, _indexJs.margin)
    },
    marginTop: {
        style: (0, _indexJs.margin)
    },
    marginRight: {
        style: (0, _indexJs.margin)
    },
    marginBottom: {
        style: (0, _indexJs.margin)
    },
    marginLeft: {
        style: (0, _indexJs.margin)
    },
    marginX: {
        style: (0, _indexJs.margin)
    },
    marginY: {
        style: (0, _indexJs.margin)
    },
    marginInline: {
        style: (0, _indexJs.margin)
    },
    marginInlineStart: {
        style: (0, _indexJs.margin)
    },
    marginInlineEnd: {
        style: (0, _indexJs.margin)
    },
    marginBlock: {
        style: (0, _indexJs.margin)
    },
    marginBlockStart: {
        style: (0, _indexJs.margin)
    },
    marginBlockEnd: {
        style: (0, _indexJs.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, _indexJs2.gap)
    },
    rowGap: {
        style: (0, _indexJs2.rowGap)
    },
    columnGap: {
        style: (0, _indexJs2.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, _indexJs4.sizingTransform)
    },
    maxWidth: {
        style: (0, _indexJs4.maxWidth)
    },
    minWidth: {
        transform: (0, _indexJs4.sizingTransform)
    },
    height: {
        transform: (0, _indexJs4.sizingTransform)
    },
    maxHeight: {
        transform: (0, _indexJs4.sizingTransform)
    },
    minHeight: {
        transform: (0, _indexJs4.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
exports.default = defaultSxConfig;

},{"../spacing/index.js":"egxgQ","../borders/index.js":"fI4be","../cssGrid/index.js":"f57xu","../palette/index.js":"eTtDc","../sizing/index.js":"1xJe0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fI4be":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _bordersJsDefault.default));
var _bordersJs = require("./borders.js");
var _bordersJsDefault = parcelHelpers.interopDefault(_bordersJs);
parcelHelpers.exportAll(_bordersJs, exports);

},{"./borders.js":"jtv9u","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtv9u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "borderTransform", ()=>borderTransform);
parcelHelpers.export(exports, "border", ()=>border);
parcelHelpers.export(exports, "borderTop", ()=>borderTop);
parcelHelpers.export(exports, "borderRight", ()=>borderRight);
parcelHelpers.export(exports, "borderBottom", ()=>borderBottom);
parcelHelpers.export(exports, "borderLeft", ()=>borderLeft);
parcelHelpers.export(exports, "borderColor", ()=>borderColor);
parcelHelpers.export(exports, "borderTopColor", ()=>borderTopColor);
parcelHelpers.export(exports, "borderRightColor", ()=>borderRightColor);
parcelHelpers.export(exports, "borderBottomColor", ()=>borderBottomColor);
parcelHelpers.export(exports, "borderLeftColor", ()=>borderLeftColor);
parcelHelpers.export(exports, "outline", ()=>outline);
parcelHelpers.export(exports, "outlineColor", ()=>outlineColor);
parcelHelpers.export(exports, "borderRadius", ()=>borderRadius);
var _indexJs = require("../responsivePropType/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../style/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compose/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../spacing/index.js");
var _indexJs4 = require("../breakpoints/index.js");
function borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
    return (0, _indexJsDefault1.default)({
        prop,
        themeKey: 'borders',
        transform
    });
}
const border = createBorderStyle('border', borderTransform);
const borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = createBorderStyle('borderColor');
const borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = createBorderStyle('borderLeftColor');
const outline = createBorderStyle('outline', borderTransform);
const outlineColor = createBorderStyle('outlineColor');
const borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, _indexJs3.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, _indexJs3.getValue)(transformer, propValue)
            });
        return (0, _indexJs4.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
borderRadius.propTypes = {};
borderRadius.filterProps = [
    'borderRadius'
];
const borders = (0, _indexJsDefault2.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
exports.default = borders;

},{"../responsivePropType/index.js":"29LCr","../style/index.js":"kKd3C","../compose/index.js":"fWaPb","../spacing/index.js":"egxgQ","../breakpoints/index.js":"dlsE8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fWaPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _composeJsDefault.default));
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);

},{"./compose.js":"gfAnH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gfAnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../merge/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, _indexJsDefault.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
exports.default = compose;

},{"../merge/index.js":"jyMgl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f57xu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cssGridJsDefault.default));
var _cssGridJs = require("./cssGrid.js");
var _cssGridJsDefault = parcelHelpers.interopDefault(_cssGridJs);
parcelHelpers.exportAll(_cssGridJs, exports);

},{"./cssGrid.js":"8XKVH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8XKVH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gap", ()=>gap);
parcelHelpers.export(exports, "columnGap", ()=>columnGap);
parcelHelpers.export(exports, "rowGap", ()=>rowGap);
parcelHelpers.export(exports, "gridColumn", ()=>gridColumn);
parcelHelpers.export(exports, "gridRow", ()=>gridRow);
parcelHelpers.export(exports, "gridAutoFlow", ()=>gridAutoFlow);
parcelHelpers.export(exports, "gridAutoColumns", ()=>gridAutoColumns);
parcelHelpers.export(exports, "gridAutoRows", ()=>gridAutoRows);
parcelHelpers.export(exports, "gridTemplateColumns", ()=>gridTemplateColumns);
parcelHelpers.export(exports, "gridTemplateRows", ()=>gridTemplateRows);
parcelHelpers.export(exports, "gridTemplateAreas", ()=>gridTemplateAreas);
parcelHelpers.export(exports, "gridArea", ()=>gridArea);
var _indexJs = require("../style/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../compose/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../spacing/index.js");
var _indexJs3 = require("../breakpoints/index.js");
var _indexJs4 = require("../responsivePropType/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs4);
const gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, _indexJs2.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, _indexJs2.getValue)(transformer, propValue)
            });
        return (0, _indexJs3.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
gap.propTypes = {};
gap.filterProps = [
    'gap'
];
const columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, _indexJs2.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, _indexJs2.getValue)(transformer, propValue)
            });
        return (0, _indexJs3.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
columnGap.propTypes = {};
columnGap.filterProps = [
    'columnGap'
];
const rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, _indexJs2.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, _indexJs2.getValue)(transformer, propValue)
            });
        return (0, _indexJs3.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
rowGap.propTypes = {};
rowGap.filterProps = [
    'rowGap'
];
const gridColumn = (0, _indexJsDefault.default)({
    prop: 'gridColumn'
});
const gridRow = (0, _indexJsDefault.default)({
    prop: 'gridRow'
});
const gridAutoFlow = (0, _indexJsDefault.default)({
    prop: 'gridAutoFlow'
});
const gridAutoColumns = (0, _indexJsDefault.default)({
    prop: 'gridAutoColumns'
});
const gridAutoRows = (0, _indexJsDefault.default)({
    prop: 'gridAutoRows'
});
const gridTemplateColumns = (0, _indexJsDefault.default)({
    prop: 'gridTemplateColumns'
});
const gridTemplateRows = (0, _indexJsDefault.default)({
    prop: 'gridTemplateRows'
});
const gridTemplateAreas = (0, _indexJsDefault.default)({
    prop: 'gridTemplateAreas'
});
const gridArea = (0, _indexJsDefault.default)({
    prop: 'gridArea'
});
const grid = (0, _indexJsDefault1.default)(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
exports.default = grid;

},{"../style/index.js":"kKd3C","../compose/index.js":"fWaPb","../spacing/index.js":"egxgQ","../breakpoints/index.js":"dlsE8","../responsivePropType/index.js":"29LCr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eTtDc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paletteJsDefault.default));
var _paletteJs = require("./palette.js");
var _paletteJsDefault = parcelHelpers.interopDefault(_paletteJs);
parcelHelpers.exportAll(_paletteJs, exports);

},{"./palette.js":"7ILnI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ILnI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paletteTransform", ()=>paletteTransform);
parcelHelpers.export(exports, "color", ()=>color);
parcelHelpers.export(exports, "bgcolor", ()=>bgcolor);
parcelHelpers.export(exports, "backgroundColor", ()=>backgroundColor);
var _indexJs = require("../style/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../compose/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const color = (0, _indexJsDefault.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: paletteTransform
});
const bgcolor = (0, _indexJsDefault.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const backgroundColor = (0, _indexJsDefault.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const palette = (0, _indexJsDefault1.default)(color, bgcolor, backgroundColor);
exports.default = palette;

},{"../style/index.js":"kKd3C","../compose/index.js":"fWaPb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1xJe0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _sizingJsDefault.default));
var _sizingJs = require("./sizing.js");
var _sizingJsDefault = parcelHelpers.interopDefault(_sizingJs);
parcelHelpers.exportAll(_sizingJs, exports);

},{"./sizing.js":"2ey6L","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ey6L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sizingTransform", ()=>sizingTransform);
parcelHelpers.export(exports, "width", ()=>width);
parcelHelpers.export(exports, "maxWidth", ()=>maxWidth);
parcelHelpers.export(exports, "minWidth", ()=>minWidth);
parcelHelpers.export(exports, "height", ()=>height);
parcelHelpers.export(exports, "maxHeight", ()=>maxHeight);
parcelHelpers.export(exports, "minHeight", ()=>minHeight);
parcelHelpers.export(exports, "sizeWidth", ()=>sizeWidth);
parcelHelpers.export(exports, "sizeHeight", ()=>sizeHeight);
parcelHelpers.export(exports, "boxSizing", ()=>boxSizing);
var _indexJs = require("../style/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../compose/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../breakpoints/index.js");
function sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = (0, _indexJsDefault.default)({
    prop: 'width',
    transform: sizingTransform
});
const maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, _indexJs2.values)[propValue];
            if (!breakpoint) return {
                maxWidth: sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, _indexJs2.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
maxWidth.filterProps = [
    'maxWidth'
];
const minWidth = (0, _indexJsDefault.default)({
    prop: 'minWidth',
    transform: sizingTransform
});
const height = (0, _indexJsDefault.default)({
    prop: 'height',
    transform: sizingTransform
});
const maxHeight = (0, _indexJsDefault.default)({
    prop: 'maxHeight',
    transform: sizingTransform
});
const minHeight = (0, _indexJsDefault.default)({
    prop: 'minHeight',
    transform: sizingTransform
});
const sizeWidth = (0, _indexJsDefault.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: sizingTransform
});
const sizeHeight = (0, _indexJsDefault.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: sizingTransform
});
const boxSizing = (0, _indexJsDefault.default)({
    prop: 'boxSizing'
});
const sizing = (0, _indexJsDefault1.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
exports.default = sizing;

},{"../style/index.js":"kKd3C","../compose/index.js":"fWaPb","../breakpoints/index.js":"dlsE8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ebzhW":[function(require,module,exports,__globalThis) {
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>applyStyles);
function applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixUYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemeWithoutDefaultJsDefault.default));
var _useThemeWithoutDefaultJs = require("./useThemeWithoutDefault.js");
var _useThemeWithoutDefaultJsDefault = parcelHelpers.interopDefault(_useThemeWithoutDefaultJs);

},{"./useThemeWithoutDefault.js":"bDQgp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bDQgp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _styledEngine = require("@mui/styled-engine");
'use client';
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
    const contextTheme = _react.useContext((0, _styledEngine.ThemeContext));
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
exports.default = useTheme;

},{"react":"9njXz","@mui/styled-engine":"9ebNW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4OYRs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _displayJsDefault.default));
var _displayJs = require("./display.js");
var _displayJsDefault = parcelHelpers.interopDefault(_displayJs);
parcelHelpers.exportAll(_displayJs, exports);

},{"./display.js":"efoyr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"efoyr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "displayPrint", ()=>displayPrint);
parcelHelpers.export(exports, "displayRaw", ()=>displayRaw);
parcelHelpers.export(exports, "overflow", ()=>overflow);
parcelHelpers.export(exports, "textOverflow", ()=>textOverflow);
parcelHelpers.export(exports, "visibility", ()=>visibility);
parcelHelpers.export(exports, "whiteSpace", ()=>whiteSpace);
var _indexJs = require("../style/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../compose/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
const displayPrint = (0, _indexJsDefault.default)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: (value)=>({
            '@media print': {
                display: value
            }
        })
});
const displayRaw = (0, _indexJsDefault.default)({
    prop: 'display'
});
const overflow = (0, _indexJsDefault.default)({
    prop: 'overflow'
});
const textOverflow = (0, _indexJsDefault.default)({
    prop: 'textOverflow'
});
const visibility = (0, _indexJsDefault.default)({
    prop: 'visibility'
});
const whiteSpace = (0, _indexJsDefault.default)({
    prop: 'whiteSpace'
});
exports.default = (0, _indexJsDefault1.default)(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);

},{"../style/index.js":"kKd3C","../compose/index.js":"fWaPb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lFETv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _flexboxJsDefault.default));
var _flexboxJs = require("./flexbox.js");
var _flexboxJsDefault = parcelHelpers.interopDefault(_flexboxJs);
parcelHelpers.exportAll(_flexboxJs, exports);

},{"./flexbox.js":"8DHdt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8DHdt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flexBasis", ()=>flexBasis);
parcelHelpers.export(exports, "flexDirection", ()=>flexDirection);
parcelHelpers.export(exports, "flexWrap", ()=>flexWrap);
parcelHelpers.export(exports, "justifyContent", ()=>justifyContent);
parcelHelpers.export(exports, "alignItems", ()=>alignItems);
parcelHelpers.export(exports, "alignContent", ()=>alignContent);
parcelHelpers.export(exports, "order", ()=>order);
parcelHelpers.export(exports, "flex", ()=>flex);
parcelHelpers.export(exports, "flexGrow", ()=>flexGrow);
parcelHelpers.export(exports, "flexShrink", ()=>flexShrink);
parcelHelpers.export(exports, "alignSelf", ()=>alignSelf);
parcelHelpers.export(exports, "justifyItems", ()=>justifyItems);
parcelHelpers.export(exports, "justifySelf", ()=>justifySelf);
var _indexJs = require("../style/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../compose/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
const flexBasis = (0, _indexJsDefault.default)({
    prop: 'flexBasis'
});
const flexDirection = (0, _indexJsDefault.default)({
    prop: 'flexDirection'
});
const flexWrap = (0, _indexJsDefault.default)({
    prop: 'flexWrap'
});
const justifyContent = (0, _indexJsDefault.default)({
    prop: 'justifyContent'
});
const alignItems = (0, _indexJsDefault.default)({
    prop: 'alignItems'
});
const alignContent = (0, _indexJsDefault.default)({
    prop: 'alignContent'
});
const order = (0, _indexJsDefault.default)({
    prop: 'order'
});
const flex = (0, _indexJsDefault.default)({
    prop: 'flex'
});
const flexGrow = (0, _indexJsDefault.default)({
    prop: 'flexGrow'
});
const flexShrink = (0, _indexJsDefault.default)({
    prop: 'flexShrink'
});
const alignSelf = (0, _indexJsDefault.default)({
    prop: 'alignSelf'
});
const justifyItems = (0, _indexJsDefault.default)({
    prop: 'justifyItems'
});
const justifySelf = (0, _indexJsDefault.default)({
    prop: 'justifySelf'
});
const flexbox = (0, _indexJsDefault1.default)(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
exports.default = flexbox;

},{"../style/index.js":"kKd3C","../compose/index.js":"fWaPb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ld728":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _positionsJsDefault.default));
var _positionsJs = require("./positions.js");
var _positionsJsDefault = parcelHelpers.interopDefault(_positionsJs);
parcelHelpers.exportAll(_positionsJs, exports);

},{"./positions.js":"73BZn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"73BZn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "position", ()=>position);
parcelHelpers.export(exports, "zIndex", ()=>zIndex);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "left", ()=>left);
var _indexJs = require("../style/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../compose/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
const position = (0, _indexJsDefault.default)({
    prop: 'position'
});
const zIndex = (0, _indexJsDefault.default)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
const top = (0, _indexJsDefault.default)({
    prop: 'top'
});
const right = (0, _indexJsDefault.default)({
    prop: 'right'
});
const bottom = (0, _indexJsDefault.default)({
    prop: 'bottom'
});
const left = (0, _indexJsDefault.default)({
    prop: 'left'
});
exports.default = (0, _indexJsDefault1.default)(position, zIndex, top, right, bottom, left);

},{"../style/index.js":"kKd3C","../compose/index.js":"fWaPb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fY1wk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _shadowsJsDefault.default));
var _shadowsJs = require("./shadows.js");
var _shadowsJsDefault = parcelHelpers.interopDefault(_shadowsJs);

},{"./shadows.js":"inlBt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"inlBt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../style/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
const boxShadow = (0, _indexJsDefault.default)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
exports.default = boxShadow;

},{"../style/index.js":"kKd3C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"auK1K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _typographyJsDefault.default));
var _typographyJs = require("./typography.js");
var _typographyJsDefault = parcelHelpers.interopDefault(_typographyJs);
parcelHelpers.exportAll(_typographyJs, exports);

},{"./typography.js":"hsKWZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hsKWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fontFamily", ()=>fontFamily);
parcelHelpers.export(exports, "fontSize", ()=>fontSize);
parcelHelpers.export(exports, "fontStyle", ()=>fontStyle);
parcelHelpers.export(exports, "fontWeight", ()=>fontWeight);
parcelHelpers.export(exports, "letterSpacing", ()=>letterSpacing);
parcelHelpers.export(exports, "textTransform", ()=>textTransform);
parcelHelpers.export(exports, "lineHeight", ()=>lineHeight);
parcelHelpers.export(exports, "textAlign", ()=>textAlign);
parcelHelpers.export(exports, "typographyVariant", ()=>typographyVariant);
var _indexJs = require("../style/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../compose/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
const fontFamily = (0, _indexJsDefault.default)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
const fontSize = (0, _indexJsDefault.default)({
    prop: 'fontSize',
    themeKey: 'typography'
});
const fontStyle = (0, _indexJsDefault.default)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
const fontWeight = (0, _indexJsDefault.default)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
const letterSpacing = (0, _indexJsDefault.default)({
    prop: 'letterSpacing'
});
const textTransform = (0, _indexJsDefault.default)({
    prop: 'textTransform'
});
const lineHeight = (0, _indexJsDefault.default)({
    prop: 'lineHeight'
});
const textAlign = (0, _indexJsDefault.default)({
    prop: 'textAlign'
});
const typographyVariant = (0, _indexJsDefault.default)({
    prop: 'typography',
    cssProperty: false,
    themeKey: 'typography'
});
const typography = (0, _indexJsDefault1.default)(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign, textTransform);
exports.default = typography;

},{"../style/index.js":"kKd3C","../compose/index.js":"fWaPb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8fFNO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styleFunctionSxJsDefault.default));
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>(0, _styleFunctionSxJs.unstable_createStyleFunctionSx));
parcelHelpers.export(exports, "extendSxProp", ()=>(0, _extendSxPropJsDefault.default));
parcelHelpers.export(exports, "unstable_defaultSxConfig", ()=>(0, _defaultSxConfigJsDefault.default));
var _styleFunctionSxJs = require("./styleFunctionSx.js");
var _styleFunctionSxJsDefault = parcelHelpers.interopDefault(_styleFunctionSxJs);
var _extendSxPropJs = require("./extendSxProp.js");
var _extendSxPropJsDefault = parcelHelpers.interopDefault(_extendSxPropJs);
var _defaultSxConfigJs = require("./defaultSxConfig.js");
var _defaultSxConfigJsDefault = parcelHelpers.interopDefault(_defaultSxConfigJs);

},{"./styleFunctionSx.js":"3nWVU","./extendSxProp.js":"5v9Ym","./defaultSxConfig.js":"lMbjC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5v9Ym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extendSxProp);
var _deepmerge = require("@mui/utils/deepmerge");
var _defaultSxConfigJs = require("./defaultSxConfig.js");
var _defaultSxConfigJsDefault = parcelHelpers.interopDefault(_defaultSxConfigJs);
const splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, _defaultSxConfigJsDefault.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps, otherProps } = splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, _deepmerge.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

},{"@mui/utils/deepmerge":"7wtTC","./defaultSxConfig.js":"lMbjC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4awty":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getThemeValueJsDefault.default));
var _getThemeValueJs = require("./getThemeValue.js");
var _getThemeValueJsDefault = parcelHelpers.interopDefault(_getThemeValueJs);
parcelHelpers.exportAll(_getThemeValueJs, exports);

},{"./getThemeValue.js":"4bN3e","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4bN3e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleFunctionMapping", ()=>styleFunctionMapping);
parcelHelpers.export(exports, "propToStyleFunction", ()=>propToStyleFunction);
var _indexJs = require("../borders/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../display/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../flexbox/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../cssGrid/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../positions/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../palette/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../shadows/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("../sizing/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../spacing/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../typography/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
const filterPropsMapping = {
    borders: (0, _indexJsDefault.default).filterProps,
    display: (0, _indexJsDefault1.default).filterProps,
    flexbox: (0, _indexJsDefault2.default).filterProps,
    grid: (0, _indexJsDefault3.default).filterProps,
    positions: (0, _indexJsDefault4.default).filterProps,
    palette: (0, _indexJsDefault5.default).filterProps,
    shadows: (0, _indexJsDefault6.default).filterProps,
    sizing: (0, _indexJsDefault7.default).filterProps,
    spacing: (0, _indexJsDefault8.default).filterProps,
    typography: (0, _indexJsDefault9.default).filterProps
};
const styleFunctionMapping = {
    borders: (0, _indexJsDefault.default),
    display: (0, _indexJsDefault1.default),
    flexbox: (0, _indexJsDefault2.default),
    grid: (0, _indexJsDefault3.default),
    positions: (0, _indexJsDefault4.default),
    palette: (0, _indexJsDefault5.default),
    shadows: (0, _indexJsDefault6.default),
    sizing: (0, _indexJsDefault7.default),
    spacing: (0, _indexJsDefault8.default),
    typography: (0, _indexJsDefault9.default)
};
const propToStyleFunction = Object.keys(filterPropsMapping).reduce((acc, styleFnName)=>{
    filterPropsMapping[styleFnName].forEach((propName)=>{
        acc[propName] = styleFunctionMapping[styleFnName];
    });
    return acc;
}, {});
function getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme
    };
    const styleFunction = propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
exports.default = getThemeValue;

},{"../borders/index.js":"fI4be","../display/index.js":"4OYRs","../flexbox/index.js":"lFETv","../cssGrid/index.js":"f57xu","../positions/index.js":"ld728","../palette/index.js":"eTtDc","../shadows/index.js":"fY1wk","../sizing/index.js":"1xJe0","../spacing/index.js":"egxgQ","../typography/index.js":"auK1K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"25Rf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _boxJsDefault.default));
parcelHelpers.export(exports, "boxClasses", ()=>(0, _boxClassesJsDefault.default));
var _boxJs = require("./Box.js");
var _boxJsDefault = parcelHelpers.interopDefault(_boxJs);
var _boxClassesJs = require("./boxClasses.js");
var _boxClassesJsDefault = parcelHelpers.interopDefault(_boxClassesJs);
parcelHelpers.exportAll(_boxClassesJs, exports);

},{"./Box.js":"fp9Oa","./boxClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fp9Oa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classNameGenerator = require("@mui/utils/ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);
var _indexJs = require("../createBox/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _boxClassesJs = require("./boxClasses.js");
var _boxClassesJsDefault = parcelHelpers.interopDefault(_boxClassesJs);
'use client';
const Box = (0, _indexJsDefault.default)({
    defaultClassName: (0, _boxClassesJsDefault.default).root,
    generateClassName: (0, _classNameGeneratorDefault.default).generate
});
exports.default = Box;

},{"prop-types":"bnNSm","@mui/utils/ClassNameGenerator":"eyH7A","../createBox/index.js":"7TlmG","./boxClasses.js":"iuoVj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eyH7A":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("df424a7de586c49b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ClassNameGenerator.default;
    }
});
var _ClassNameGenerator = _interopRequireDefault(require("7e3b9dcb9e23db8f"));

},{"df424a7de586c49b":"kZ6eK","7e3b9dcb9e23db8f":"2rQ0S"}],"2rQ0S":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const defaultGenerator = (componentName)=>componentName;
const createClassNameGenerator = ()=>{
    let generate = defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = defaultGenerator;
        }
    };
};
const ClassNameGenerator = createClassNameGenerator();
var _default = exports.default = ClassNameGenerator;

},{}],"7TlmG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createBoxJsDefault.default));
var _createBoxJs = require("./createBox.js");
var _createBoxJsDefault = parcelHelpers.interopDefault(_createBoxJs);

},{"./createBox.js":"f1zba","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1zba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createBox);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styledEngine = require("@mui/styled-engine");
var _styledEngineDefault = parcelHelpers.interopDefault(_styledEngine);
var _indexJs = require("../styleFunctionSx/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../useTheme/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function createBox(options = {}) {
    const { themeId, defaultTheme, defaultClassName = 'MuiBox-root', generateClassName } = options;
    const BoxRoot = (0, _styledEngineDefault.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, _indexJsDefault.default));
    const Box = /*#__PURE__*/ _react.forwardRef(function Box(inProps, ref) {
        const theme = (0, _indexJsDefault1.default)(defaultTheme);
        const { className, component = 'div', ...other } = (0, _indexJs.extendSxProp)(inProps);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, _clsxDefault.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

},{"react":"9njXz","clsx":"d2NWs","@mui/styled-engine":"9ebNW","../styleFunctionSx/index.js":"8fFNO","../useTheme/index.js":"hP8yl","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d2NWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iuoVj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const boxClasses = (0, _generateUtilityClassesDefault.default)('MuiBox', [
    'root'
]);
exports.default = boxClasses;

},{"@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7pSUk":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5b5466efb44e16fa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _generateUtilityClasses.default;
    }
});
var _generateUtilityClasses = _interopRequireDefault(require("2fda49e444604093"));

},{"5b5466efb44e16fa":"kZ6eK","2fda49e444604093":"i4vWo"}],"i4vWo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ace5c1a216171e4d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = generateUtilityClasses;
var _generateUtilityClass = _interopRequireDefault(require("1c98b4da23a2701a"));
function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, _generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

},{"ace5c1a216171e4d":"kZ6eK","1c98b4da23a2701a":"jBs9M"}],"jBs9M":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("982aadf77fb2f660").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _generateUtilityClass.default;
    }
});
var _generateUtilityClass = _interopRequireWildcard(require("f12031ccb7ca5241"));
Object.keys(_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _generateUtilityClass[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _generateUtilityClass[key];
        }
    });
});

},{"982aadf77fb2f660":"fiRIh","f12031ccb7ca5241":"36Bdp"}],"36Bdp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e208e65ce194841a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = generateUtilityClass;
exports.globalStateClasses = void 0;
exports.isGlobalState = isGlobalState;
var _ClassNameGenerator = _interopRequireDefault(require("99373aa8fc6e45eb"));
const globalStateClasses = exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function isGlobalState(slot) {
    return globalStateClasses[slot] !== undefined;
}

},{"e208e65ce194841a":"kZ6eK","99373aa8fc6e45eb":"eyH7A"}],"gy2Fg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createStyledJsDefault.default));
var _createStyledJs = require("./createStyled.js");
var _createStyledJsDefault = parcelHelpers.interopDefault(_createStyledJs);
parcelHelpers.exportAll(_createStyledJs, exports);

},{"./createStyled.js":"9DdTb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DdTb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "systemDefaultTheme", ()=>systemDefaultTheme);
// Update /system/styled/#api in case if this changes
parcelHelpers.export(exports, "shouldForwardProp", ()=>shouldForwardProp);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _styledEngine = require("@mui/styled-engine");
var _styledEngineDefault = parcelHelpers.interopDefault(_styledEngine);
var _deepmerge = require("@mui/utils/deepmerge");
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _getDisplayName = require("@mui/utils/getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
var _indexJs = require("../createTheme/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../styleFunctionSx/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _preprocessStylesJs = require("../preprocessStyles.js");
var _preprocessStylesJsDefault = parcelHelpers.interopDefault(_preprocessStylesJs);
const systemDefaultTheme = (0, _indexJsDefault.default)();
function shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function attachTheme(props, themeId, defaultTheme) {
    props.theme = isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function createStyled(input = {}) {
    const { themeId, defaultTheme = systemDefaultTheme, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
    function styleAttachTheme(props) {
        attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, _styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, _indexJsDefault1.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if (isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, _styledEngineDefault.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return processStyle(props, style);
            };
            if ((0, _deepmerge.isPlainObject)(style)) {
                const serialized = (0, _preprocessStylesJsDefault.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, _indexJsDefault1.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, _capitalizeDefault.default)(componentSlot || '')}`;
    return `Styled(${(0, _getDisplayNameDefault.default)(tag)})`;
}
function generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

},{"@mui/styled-engine":"9ebNW","@mui/utils/deepmerge":"7wtTC","@mui/utils/capitalize":"5sWY4","@mui/utils/getDisplayName":"aDEY1","../createTheme/index.js":"acrEQ","../styleFunctionSx/index.js":"8fFNO","../preprocessStyles.js":"5D7Iq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDEY1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("42855b97e1633561").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _getDisplayName.default;
    }
});
var _getDisplayName = _interopRequireDefault(require("c6a5af84938e8b8d"));

},{"42855b97e1633561":"kZ6eK","c6a5af84938e8b8d":"ImY6e"}],"ImY6e":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getDisplayName;
var _reactIs = require("cc24738cf5c901a6");
function getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
    const functionName = getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case _reactIs.ForwardRef:
            return getWrappedName(Component, Component.render, 'ForwardRef');
        case _reactIs.Memo:
            return getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

},{"cc24738cf5c901a6":"7MwU6"}],"5D7Iq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>preprocessStyles);
var _styledEngine = require("@mui/styled-engine");
function preprocessStyles(input) {
    const { variants, ...style } = input;
    const result = {
        variants,
        style: (0, _styledEngine.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, _styledEngine.internal_serializeStyles)(variant.style);
    });
    return result;
}

},{"@mui/styled-engine":"9ebNW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71lRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styledJsDefault.default));
var _styledJs = require("./styled.js");
var _styledJsDefault = parcelHelpers.interopDefault(_styledJs);

},{"./styled.js":"kx1Oa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kx1Oa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../createStyled/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
const styled = (0, _indexJsDefault.default)();
exports.default = styled;

},{"../createStyled/index.js":"gy2Fg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lN0LR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemePropsJsDefault.default));
parcelHelpers.export(exports, "getThemeProps", ()=>(0, _getThemePropsJsDefault.default));
var _useThemePropsJs = require("./useThemeProps.js");
var _useThemePropsJsDefault = parcelHelpers.interopDefault(_useThemePropsJs);
var _getThemePropsJs = require("./getThemeProps.js");
var _getThemePropsJsDefault = parcelHelpers.interopDefault(_getThemePropsJs);

},{"./useThemeProps.js":"6gGPg","./getThemeProps.js":"4yUbB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6gGPg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useThemeProps);
var _getThemePropsJs = require("./getThemeProps.js");
var _getThemePropsJsDefault = parcelHelpers.interopDefault(_getThemePropsJs);
var _indexJs = require("../useTheme/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use client';
function useThemeProps({ props, name, defaultTheme, themeId }) {
    let theme = (0, _indexJsDefault.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, _getThemePropsJsDefault.default)({
        theme,
        name,
        props
    });
}

},{"./getThemeProps.js":"4yUbB","../useTheme/index.js":"hP8yl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4yUbB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getThemeProps);
var _resolveProps = require("@mui/utils/resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, _resolvePropsDefault.default)(theme.components[name].defaultProps, props);
}

},{"@mui/utils/resolveProps":"gFBtX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gFBtX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3f6928a0993e3b8c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _resolveProps.default;
    }
});
var _resolveProps = _interopRequireDefault(require("aef0274c88251f01"));

},{"3f6928a0993e3b8c":"kZ6eK","aef0274c88251f01":"cr7n5"}],"cr7n5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = resolveProps;
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function resolveProps(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

},{}],"lO9cu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useMediaQueryJsDefault.default));
var _useMediaQueryJs = require("./useMediaQuery.js");
var _useMediaQueryJsDefault = parcelHelpers.interopDefault(_useMediaQueryJs);
parcelHelpers.exportAll(_useMediaQueryJs, exports);

},{"./useMediaQuery.js":"83uqp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"83uqp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "unstable_createUseMediaQuery", ()=>unstable_createUseMediaQuery);
var _react = require("react");
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _indexJs = require("../useThemeProps/index.js");
var _indexJs1 = require("../useThemeWithoutDefault/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = _react.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const safeReact = {
    ..._react
};
const maybeReactUseSyncExternalStore = safeReact.useSyncExternalStore;
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = _react.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = _react.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = _react.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function unstable_createUseMediaQuery(params = {}) {
    const { themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, _indexJsDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches = false, matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia = null, noSsr = false } = (0, _indexJs.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const useMediaQuery = unstable_createUseMediaQuery();
exports.default = useMediaQuery;

},{"react":"9njXz","@mui/utils/useEnhancedEffect":"fIvqa","../useThemeProps/index.js":"lN0LR","../useThemeWithoutDefault/index.js":"ixUYr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fIvqa":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5b2184198e37aa64").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useEnhancedEffect.default;
    }
});
var _useEnhancedEffect = _interopRequireDefault(require("8f8a7b5a80fae0b2"));

},{"5b2184198e37aa64":"kZ6eK","8f8a7b5a80fae0b2":"leMnc"}],"leMnc":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("278d2b4895ae89f8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("c37b032de779b244"));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
var _default = exports.default = useEnhancedEffect;

},{"278d2b4895ae89f8":"fiRIh","c37b032de779b244":"9njXz"}],"4Ia8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorManipulatorJs = require("./colorManipulator.js");
parcelHelpers.exportAll(_colorManipulatorJs, exports);

},{"./colorManipulator.js":"f1h8G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1h8G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ parcelHelpers.export(exports, "hexToRgb", ()=>hexToRgb);
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ parcelHelpers.export(exports, "decomposeColor", ()=>decomposeColor);
parcelHelpers.export(exports, "colorChannel", ()=>colorChannel);
parcelHelpers.export(exports, "private_safeColorChannel", ()=>private_safeColorChannel);
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ parcelHelpers.export(exports, "recomposeColor", ()=>recomposeColor);
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ parcelHelpers.export(exports, "rgbToHex", ()=>rgbToHex);
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ parcelHelpers.export(exports, "hslToRgb", ()=>hslToRgb);
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ parcelHelpers.export(exports, "getLuminance", ()=>getLuminance);
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ parcelHelpers.export(exports, "getContrastRatio", ()=>getContrastRatio);
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "alpha", ()=>alpha);
parcelHelpers.export(exports, "private_safeAlpha", ()=>private_safeAlpha);
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "darken", ()=>darken);
parcelHelpers.export(exports, "private_safeDarken", ()=>private_safeDarken);
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "lighten", ()=>lighten);
parcelHelpers.export(exports, "private_safeLighten", ()=>private_safeLighten);
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "emphasize", ()=>emphasize);
parcelHelpers.export(exports, "private_safeEmphasize", ()=>private_safeEmphasize);
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ parcelHelpers.export(exports, "blend", ()=>blend);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
/* eslint-disable @typescript-eslint/naming-convention */ var _clamp = require("@mui/utils/clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function clampWrapper(value, min = 0, max = 1) {
    return (0, _clampDefault.default)(value, min, max);
}
function hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return decomposeColor(hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, _formatMuiErrorMessageDefault.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, _formatMuiErrorMessageDefault.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type,
        values,
        colorSpace
    };
}
const colorChannel = (color)=>{
    const decomposedColor = decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const private_safeColorChannel = (color, warning)=>{
    try {
        return colorChannel(color);
    } catch (error) {
        return color;
    }
};
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values } = decomposeColor(color);
    return `#${values.map((n, i)=>intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function hslToRgb(color) {
    color = decomposeColor(color);
    const { values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return recomposeColor({
        type,
        values: rgb
    });
}
function getLuminance(color) {
    color = decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function alpha(color, value) {
    color = decomposeColor(color);
    value = clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
    try {
        return alpha(color, value);
    } catch (error) {
        return color;
    }
}
function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
    try {
        return darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
    try {
        return lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
function emphasize(color, coefficient = 0.15) {
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
    try {
        return emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
function blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = decomposeColor(background);
    const overlayColor = decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

},{"@mui/utils/formatMuiErrorMessage":"gOgzd","@mui/utils/clamp":"flxMs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"flxMs":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2c1dbec64e810f4a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _clamp.default;
    }
});
var _clamp = _interopRequireDefault(require("4e47c829b3573509"));

},{"2c1dbec64e810f4a":"kZ6eK","4e47c829b3573509":"9aSXe"}],"9aSXe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var _default = exports.default = clamp;

},{}],"kQQhR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _themeProviderJsDefault.default));
var _themeProviderJs = require("./ThemeProvider.js");
var _themeProviderJsDefault = parcelHelpers.interopDefault(_themeProviderJs);

},{"./ThemeProvider.js":"64Y3c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"64Y3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _privateTheming = require("@mui/private-theming");
var _exactProp = require("@mui/utils/exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _styledEngine = require("@mui/styled-engine");
var _indexJs = require("../useThemeWithoutDefault/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../RtlProvider/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../DefaultPropsProvider/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return _react.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function ThemeProvider(props) {
    const { children, theme: localTheme, themeId } = props;
    const upperTheme = (0, _indexJsDefault.default)(EMPTY_THEME);
    const upperPrivateTheme = (0, _privateTheming.useTheme)() || EMPTY_THEME;
    const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privateTheming.ThemeProvider), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.ThemeContext).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault1.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault2.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
exports.default = ThemeProvider;

},{"react":"9njXz","prop-types":"bnNSm","@mui/private-theming":"eHvzD","@mui/utils/exactProp":"jInuK","@mui/styled-engine":"9ebNW","../useThemeWithoutDefault/index.js":"ixUYr","../RtlProvider/index.js":"3ZzrW","../DefaultPropsProvider/index.js":"8H9ap","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eHvzD":[function(require,module,exports,__globalThis) {
/**
 * @mui/private-theming v7.1.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "useTheme", ()=>(0, _indexJsDefault1.default));
var _indexJs = require("./ThemeProvider/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
parcelHelpers.exportAll(_indexJs, exports);
var _indexJs1 = require("./useTheme/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);

},{"./ThemeProvider/index.js":"4Od29","./useTheme/index.js":"7sfhH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Od29":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _themeProviderJsDefault.default));
parcelHelpers.export(exports, "unstable_nested", ()=>(0, _nestedJsDefault.default));
var _themeProviderJs = require("./ThemeProvider.js");
var _themeProviderJsDefault = parcelHelpers.interopDefault(_themeProviderJs);
var _nestedJs = require("./nested.js");
var _nestedJsDefault = parcelHelpers.interopDefault(_nestedJs);

},{"./ThemeProvider.js":"3DkgU","./nested.js":"4il7p","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3DkgU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _exactProp = require("@mui/utils/exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _themeContextJs = require("../useTheme/ThemeContext.js");
var _themeContextJsDefault = parcelHelpers.interopDefault(_themeContextJs);
var _indexJs = require("../useTheme/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _nestedJs = require("./nested.js");
var _nestedJsDefault = parcelHelpers.interopDefault(_nestedJs);
// To support composition of theme.
var _jsxRuntime = require("react/jsx-runtime");
function mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function ThemeProvider(props) {
    const { children, theme: localTheme } = props;
    const outerTheme = (0, _indexJsDefault.default)();
    const theme = _react.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, _nestedJsDefault.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeContextJsDefault.default).Provider, {
        value: theme,
        children: children
    });
}
exports.default = ThemeProvider;

},{"react":"9njXz","prop-types":"bnNSm","@mui/utils/exactProp":"jInuK","../useTheme/ThemeContext.js":"9rqT0","../useTheme/index.js":"7sfhH","./nested.js":"4il7p","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jInuK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cff61de3e8b80eda").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _exactProp.default;
    }
});
var _exactProp = _interopRequireDefault(require("a9c5129b5b75c120"));

},{"cff61de3e8b80eda":"kZ6eK","a9c5129b5b75c120":"cGeQ0"}],"cGeQ0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const specialProperty = 'exact-prop: \u200b';
function exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

},{}],"9rqT0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
'use client';
const ThemeContext = /*#__PURE__*/ _react.createContext(null);
exports.default = ThemeContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7sfhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemeJsDefault.default));
var _useThemeJs = require("./useTheme.js");
var _useThemeJsDefault = parcelHelpers.interopDefault(_useThemeJs);

},{"./useTheme.js":"1M6v7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1M6v7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _themeContextJs = require("./ThemeContext.js");
var _themeContextJsDefault = parcelHelpers.interopDefault(_themeContextJs);
function useTheme() {
    const theme = _react.useContext((0, _themeContextJsDefault.default));
    return theme;
}

},{"react":"9njXz","./ThemeContext.js":"9rqT0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4il7p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const hasSymbol = typeof Symbol === 'function' && Symbol.for;
exports.default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ZzrW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRtl", ()=>useRtl);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const RtlContext = /*#__PURE__*/ _react.createContext();
function RtlProvider({ value, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const useRtl = ()=>{
    const value = _react.useContext(RtlContext);
    return value ?? false;
};
exports.default = RtlProvider;

},{"react":"9njXz","prop-types":"bnNSm","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8H9ap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultPropsProviderJsDefault.default));
parcelHelpers.export(exports, "useDefaultProps", ()=>(0, _defaultPropsProviderJs.useDefaultProps));
var _defaultPropsProviderJs = require("./DefaultPropsProvider.js");
var _defaultPropsProviderJsDefault = parcelHelpers.interopDefault(_defaultPropsProviderJs);

},{"./DefaultPropsProvider.js":"jpKhv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jpKhv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDefaultProps", ()=>useDefaultProps);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _resolveProps = require("@mui/utils/resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const PropsContext = /*#__PURE__*/ _react.createContext(undefined);
function DefaultPropsProvider({ value, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropsContext.Provider, {
        value: value,
        children: children
    });
}
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, _resolvePropsDefault.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, _resolvePropsDefault.default)(config, props);
    return props;
}
function useDefaultProps({ props, name }) {
    const ctx = _react.useContext(PropsContext);
    return getThemeProps({
        props,
        name,
        theme: {
            components: ctx
        }
    });
}
exports.default = DefaultPropsProvider;

},{"react":"9njXz","prop-types":"bnNSm","@mui/utils/resolveProps":"gFBtX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dXdvK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unstable_memoTheme);
var _preprocessStylesJs = require("./preprocessStyles.js");
var _preprocessStylesJsDefault = parcelHelpers.interopDefault(_preprocessStylesJs);
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const arg = {
    theme: undefined
};
function unstable_memoTheme(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            arg.theme = props.theme;
            value = (0, _preprocessStylesJsDefault.default)(styleFn(arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

},{"./preprocessStyles.js":"5D7Iq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kb1TN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DISABLE_CSS_TRANSITION", ()=>DISABLE_CSS_TRANSITION);
parcelHelpers.export(exports, "default", ()=>createCssVarsProvider);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styledEngine = require("@mui/styled-engine");
var _privateTheming = require("@mui/private-theming");
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _indexJs = require("../ThemeProvider/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _initColorSchemeScriptJs = require("../InitColorSchemeScript/InitColorSchemeScript.js");
var _initColorSchemeScriptJsDefault = parcelHelpers.interopDefault(_initColorSchemeScriptJs);
var _useCurrentColorSchemeJs = require("./useCurrentColorScheme.js");
var _useCurrentColorSchemeJsDefault = parcelHelpers.interopDefault(_useCurrentColorSchemeJs);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function createCssVarsProvider(options) {
    const { themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, _initColorSchemeScriptJs.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, _initColorSchemeScriptJs.DEFAULT_COLOR_SCHEME_STORAGE_KEY), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme, resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ _react.createContext(undefined);
    const useColorScheme = ()=>_react.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children, theme: themeProp, modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange = designSystemTransitionOnChange, storageManager, storageWindow = typeof window === 'undefined' ? undefined : window, documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext = false, disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender = false, noSsr } = props;
        const hasMounted = _react.useRef(false);
        const upperTheme = (0, _privateTheming.useTheme)();
        const ctx = _react.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = _react.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes = defaultColorSchemes, components = defaultComponents, cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = _react.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode, systemMode, lightColorScheme, darkColorScheme, colorScheme: stateColorScheme, setColorScheme } = (0, _useCurrentColorSchemeJsDefault.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme,
            defaultDarkColorScheme,
            modeStorageKey,
            colorSchemeStorageKey,
            defaultMode,
            storageManager,
            storageWindow,
            noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = _react.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components,
                colorSchemes,
                cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, _useEnhancedEffectDefault.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        _react.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode(DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        _react.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = _react.useMemo(()=>({
                allColorSchemes,
                colorScheme,
                darkColorScheme,
                lightColorScheme,
                mode,
                setColorScheme,
                setMode: setMode,
                systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.GlobalStyles), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, _initColorSchemeScriptJsDefault.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme,
            defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider,
        useColorScheme,
        getInitColorSchemeScript
    };
}

},{"react":"9njXz","prop-types":"bnNSm","@mui/styled-engine":"9ebNW","@mui/private-theming":"eHvzD","@mui/utils/useEnhancedEffect":"fIvqa","../ThemeProvider/index.js":"kQQhR","../InitColorSchemeScript/InitColorSchemeScript.js":"kjnoJ","./useCurrentColorScheme.js":"dJBPl","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kjnoJ":[function(require,module,exports,__globalThis) {
/**
 * Split this component for RSC import
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_MODE_STORAGE_KEY", ()=>DEFAULT_MODE_STORAGE_KEY);
parcelHelpers.export(exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", ()=>DEFAULT_COLOR_SCHEME_STORAGE_KEY);
parcelHelpers.export(exports, "DEFAULT_ATTRIBUTE", ()=>DEFAULT_ATTRIBUTE);
parcelHelpers.export(exports, "default", ()=>InitColorSchemeScript);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const DEFAULT_MODE_STORAGE_KEY = 'mode';
const DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const DEFAULT_ATTRIBUTE = 'data-color-scheme';
function InitColorSchemeScript(options) {
    const { defaultMode = 'system', defaultLightColorScheme = 'light', defaultDarkColorScheme = 'dark', modeStorageKey = DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey = DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = DEFAULT_ATTRIBUTE, colorSchemeNode = 'document.documentElement', nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

},{"react":"9njXz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dJBPl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSystemMode", ()=>getSystemMode);
parcelHelpers.export(exports, "getColorScheme", ()=>getColorScheme);
parcelHelpers.export(exports, "default", ()=>useCurrentColorScheme);
var _react = require("react");
var _initColorSchemeScriptJs = require("../InitColorSchemeScript/InitColorSchemeScript.js");
var _localStorageManagerJs = require("./localStorageManager.js");
var _localStorageManagerJsDefault = parcelHelpers.interopDefault(_localStorageManagerJs);
'use client';
function noop() {}
function getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function getColorScheme(state) {
    return processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function useCurrentColorScheme(options) {
    const { defaultMode = 'light', defaultLightColorScheme, defaultDarkColorScheme, supportedColorSchemes = [], modeStorageKey = (0, _initColorSchemeScriptJs.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey = (0, _initColorSchemeScriptJs.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow = typeof window === 'undefined' ? undefined : window, storageManager = (0, _localStorageManagerJsDefault.default), noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = _react.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = _react.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = _react.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = _react.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: getSystemMode(initialMode),
            lightColorScheme,
            darkColorScheme
        };
    });
    const [isClient, setIsClient] = _react.useState(noSsr || !isMultiSchemes);
    _react.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = getColorScheme(state);
    const setMode = _react.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = _react.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = _react.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = _react.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    _react.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    _react.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode,
        setColorScheme
    };
}

},{"react":"9njXz","../InitColorSchemeScript/InitColorSchemeScript.js":"kjnoJ","./localStorageManager.js":"dtpSa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dtpSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function noop() {}
const localStorageManager = ({ key, storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
exports.default = localStorageManager;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bKbie":[function(require,module,exports,__globalThis) {
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createGetCssVar);
function createGetCssVar(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eZlgN":[function(require,module,exports,__globalThis) {
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignNestedKeys", ()=>assignNestedKeys);
parcelHelpers.export(exports, "walkObjectDeep", ()=>walkObjectDeep);
parcelHelpers.export(exports, "default", ()=>cssVarsParser);
const assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function cssVarsParser(theme, options) {
    const { prefix, shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css,
        vars,
        varsWithDefaults
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"82wxo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _cssVarsParserJs = require("./cssVarsParser.js");
var _cssVarsParserJsDefault = parcelHelpers.interopDefault(_cssVarsParserJs);
function prepareCssVars(theme, parserConfig = {}) {
    const { getSelector = defaultGetSelector, disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes = {}, components, defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, _cssVarsParserJsDefault.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars, css, varsWithDefaults } = (0, _cssVarsParserJsDefault.default)(scheme, parserConfig);
        themeVars = (0, _deepmergeDefault.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css,
            vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css, vars, varsWithDefaults } = (0, _cssVarsParserJsDefault.default)(defaultScheme, parserConfig);
        themeVars = (0, _deepmergeDefault.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css,
            vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, _deepmergeDefault.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars,
        generateStyleSheets
    };
}
exports.default = prepareCssVars;

},{"@mui/utils/deepmerge":"7wtTC","./cssVarsParser.js":"eZlgN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7u4wK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _prepareCssVarsJs = require("./prepareCssVars.js");
var _prepareCssVarsJsDefault = parcelHelpers.interopDefault(_prepareCssVarsJs);
var _getColorSchemeSelectorJs = require("./getColorSchemeSelector.js");
var _initColorSchemeScriptJs = require("../InitColorSchemeScript/InitColorSchemeScript.js");
function createCssVarsTheme({ colorSchemeSelector = `[${(0, _initColorSchemeScriptJs.DEFAULT_ATTRIBUTE)}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, _prepareCssVarsJsDefault.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, _getColorSchemeSelectorJs.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
exports.default = createCssVarsTheme;

},{"./prepareCssVars.js":"82wxo","./getColorSchemeSelector.js":"kCM0E","../InitColorSchemeScript/InitColorSchemeScript.js":"kjnoJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCM0E":[function(require,module,exports,__globalThis) {
/* eslint-disable import/prefer-default-export */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGetColorSchemeSelector", ()=>createGetColorSchemeSelector);
function createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bgf0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "major", ()=>major);
parcelHelpers.export(exports, "minor", ()=>minor);
parcelHelpers.export(exports, "patch", ()=>patch);
parcelHelpers.export(exports, "prerelease", ()=>prerelease);
const version = "7.1.1";
const major = Number("7");
const minor = Number("1");
const patch = Number("1");
const prerelease = undefined;
exports.default = version;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jSdKs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createContainer);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _indexJs = require("../useThemeProps/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../styled/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../createTheme/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const defaultTheme = (0, _indexJsDefault2.default)();
const defaultCreateStyledComponent = (0, _indexJsDefault1.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, _capitalizeDefault.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const useThemePropsDefault = (inProps)=>(0, _indexJsDefault.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme
    });
const useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, _generateUtilityClassDefault.default)(componentName, slot);
    };
    const { classes, fixed, disableGutters, maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, _capitalizeDefault.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, getContainerUtilityClass, classes);
};
function createContainer(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme, ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme, ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme, ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ _react.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className, component = 'div', disableGutters = false, fixed = false, maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component,
            disableGutters,
            fixed,
            maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, _jsxRuntime.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}

},{"react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/composeClasses":"59Equ","@mui/utils/capitalize":"5sWY4","../useThemeProps/index.js":"lN0LR","../styled/index.js":"71lRH","../createTheme/index.js":"acrEQ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59Equ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("88d7eed2910b0f5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _composeClasses.default;
    }
});
var _composeClasses = _interopRequireDefault(require("6d6e9f223fe30422"));

},{"88d7eed2910b0f5":"kZ6eK","6d6e9f223fe30422":"dR1Nm"}],"dR1Nm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

},{}],"gjkxG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _containerJsDefault.default));
parcelHelpers.export(exports, "containerClasses", ()=>(0, _containerClassesJsDefault.default));
var _containerJs = require("./Container.js");
var _containerJsDefault = parcelHelpers.interopDefault(_containerJs);
var _containerClassesJs = require("./containerClasses.js");
var _containerClassesJsDefault = parcelHelpers.interopDefault(_containerClassesJs);
parcelHelpers.exportAll(_containerClassesJs, exports);

},{"./Container.js":"eCM9C","./containerClasses.js":"emzQZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eCM9C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _createContainerJs = require("./createContainer.js");
var _createContainerJsDefault = parcelHelpers.interopDefault(_createContainerJs);
'use client';
/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */ const Container = (0, _createContainerJsDefault.default)();
exports.default = Container;

},{"prop-types":"bnNSm","./createContainer.js":"jSdKs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"emzQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContainerUtilityClass", ()=>getContainerUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getContainerUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiContainer', slot);
}
const containerClasses = (0, _generateUtilityClassesDefault.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
exports.default = containerClasses;

},{"@mui/utils/generateUtilityClasses":"7pSUk","@mui/utils/generateUtilityClass":"jBs9M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"CDIjI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _createGridJs = require("./createGrid.js");
var _createGridJsDefault = parcelHelpers.interopDefault(_createGridJs);
'use client';
/**
 *
 * Demos:
 *
 * - [Grid (Joy UI)](https://mui.com/joy-ui/react-grid/)
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */ const Grid = (0, _createGridJsDefault.default)();
exports.default = Grid;

},{"prop-types":"bnNSm","./createGrid.js":"gPzOQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPzOQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createGrid);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _isMuiElement = require("@mui/utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _indexJs = require("../styled/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../useThemeProps/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../useTheme/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../styleFunctionSx/index.js");
var _indexJs4 = require("../createTheme/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _gridGeneratorJs = require("./gridGenerator.js");
var _deleteLegacyGridPropsJs = require("./deleteLegacyGridProps.js");
var _deleteLegacyGridPropsJsDefault = parcelHelpers.interopDefault(_deleteLegacyGridPropsJs);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const defaultTheme = (0, _indexJsDefault3.default)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0, _indexJsDefault.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function useThemePropsDefault(props) {
    return (0, _indexJsDefault1.default)({
        props,
        name: 'MuiGrid',
        defaultTheme
    });
}
function createGrid(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, useTheme = (0, _indexJsDefault2.default), componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container, direction, spacing, wrap, size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, _gridGeneratorJs.generateDirectionClasses)(direction),
                ...(0, _gridGeneratorJs.generateSizeClassNames)(size),
                ...container ? (0, _gridGeneratorJs.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, _composeClassesDefault.default)(slots, (slot)=>(0, _generateUtilityClassDefault.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, _gridGeneratorJs.generateGridColumnsStyles), (0, _gridGeneratorJs.generateGridColumnSpacingStyles), (0, _gridGeneratorJs.generateGridRowSpacingStyles), (0, _gridGeneratorJs.generateGridSizeStyles), (0, _gridGeneratorJs.generateGridDirectionStyles), (0, _gridGeneratorJs.generateGridStyles), (0, _gridGeneratorJs.generateGridOffsetStyles));
    const Grid = /*#__PURE__*/ _react.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, _indexJs3.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, _deleteLegacyGridPropsJsDefault.default)(props, theme.breakpoints);
        const { className, children, columns: columnsProp = 12, container = false, component = 'div', direction = 'row', wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level,
            columns,
            container,
            direction,
            wrap,
            spacing,
            rowSpacing,
            columnSpacing,
            size,
            offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            ...other,
            children: _react.Children.map(children, (child)=>{
                if (/*#__PURE__*/ _react.isValidElement(child) && (0, _isMuiElementDefault.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ _react.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

},{"react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/utils/isMuiElement":"4sqhm","@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/composeClasses":"59Equ","../styled/index.js":"71lRH","../useThemeProps/index.js":"lN0LR","../useTheme/index.js":"hP8yl","../styleFunctionSx/index.js":"8fFNO","../createTheme/index.js":"acrEQ","./gridGenerator.js":"jOXzh","./deleteLegacyGridProps.js":"7MieY","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4sqhm":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("38811d70089ca4a7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _isMuiElement.default;
    }
});
var _isMuiElement = _interopRequireDefault(require("ab58aec94705640a"));

},{"38811d70089ca4a7":"kZ6eK","ab58aec94705640a":"hKtqe"}],"hKtqe":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("bd1e0132e26874b5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isMuiElement;
var React = _interopRequireWildcard(require("19a3b474c34b2695"));
function isMuiElement(element, muiNames) {
    return /*#__PURE__*/ React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

},{"bd1e0132e26874b5":"fiRIh","19a3b474c34b2695":"9njXz"}],"jOXzh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateGridSizeStyles", ()=>generateGridSizeStyles);
parcelHelpers.export(exports, "generateGridOffsetStyles", ()=>generateGridOffsetStyles);
parcelHelpers.export(exports, "generateGridColumnsStyles", ()=>generateGridColumnsStyles);
parcelHelpers.export(exports, "generateGridRowSpacingStyles", ()=>generateGridRowSpacingStyles);
parcelHelpers.export(exports, "generateGridColumnSpacingStyles", ()=>generateGridColumnSpacingStyles);
parcelHelpers.export(exports, "generateGridDirectionStyles", ()=>generateGridDirectionStyles);
parcelHelpers.export(exports, "generateGridStyles", ()=>generateGridStyles);
parcelHelpers.export(exports, "generateSizeClassNames", ()=>generateSizeClassNames);
parcelHelpers.export(exports, "generateSpacingClassNames", ()=>generateSpacingClassNames);
parcelHelpers.export(exports, "generateDirectionClasses", ()=>generateDirectionClasses);
var _traverseBreakpointsJs = require("./traverseBreakpoints.js");
function getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const selfColumnsVar = '--Grid-columns';
const parentColumnsVar = '--Grid-parent-columns';
const generateGridSizeStyles = ({ theme, ownerState })=>{
    const styles = {};
    (0, _traverseBreakpointsJs.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${parentColumnsVar}) - (var(${parentColumnsVar}) - ${value}) * (var(${getParentSpacingVar('column')}) / var(${parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const generateGridOffsetStyles = ({ theme, ownerState })=>{
    const styles = {};
    (0, _traverseBreakpointsJs.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${parentColumnsVar}) + var(${getParentSpacingVar('column')}) * ${value} / var(${parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const generateGridColumnsStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [selfColumnsVar]: 12
    };
    (0, _traverseBreakpointsJs.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [selfColumnsVar]: columns,
            '> *': {
                [parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const generateGridRowSpacingStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpointsJs.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [getSelfSpacingVar('row')]: spacing,
            '> *': {
                [getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const generateGridColumnSpacingStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpointsJs.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [getSelfSpacingVar('column')]: spacing,
            '> *': {
                [getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const generateGridDirectionStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpointsJs.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const generateGridStyles = ({ ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${getSelfSpacingVar('row')}) var(${getSelfSpacingVar('column')})`
        }
    };
};
const generateSizeClassNames = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};

},{"./traverseBreakpoints.js":"iBKZv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iBKZv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterBreakpointKeys", ()=>filterBreakpointKeys);
parcelHelpers.export(exports, "traverseBreakpoints", ()=>traverseBreakpoints);
const filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7MieY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deleteLegacyGridProps);
const getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const warnedAboutProps = [];
function deleteLegacyGridProps(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"81RBb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _gridJsDefault.default));
parcelHelpers.export(exports, "createGrid", ()=>(0, _createGridJsDefault.default));
parcelHelpers.export(exports, "gridClasses", ()=>(0, _gridClassesJsDefault.default));
parcelHelpers.export(exports, "unstable_traverseBreakpoints", ()=>(0, _traverseBreakpointsJs.traverseBreakpoints));
parcelHelpers.export(exports, "unstable_generateDirectionClasses", ()=>(0, _gridGeneratorJs.generateDirectionClasses));
parcelHelpers.export(exports, "unstable_generateSizeClassNames", ()=>(0, _gridGeneratorJs.generateSizeClassNames));
parcelHelpers.export(exports, "unstable_generateSpacingClassNames", ()=>(0, _gridGeneratorJs.generateSpacingClassNames));
var _gridJs = require("./Grid.js");
var _gridJsDefault = parcelHelpers.interopDefault(_gridJs);
var _createGridJs = require("./createGrid.js");
var _createGridJsDefault = parcelHelpers.interopDefault(_createGridJs);
var _gridPropsJs = require("./GridProps.js");
parcelHelpers.exportAll(_gridPropsJs, exports);
var _gridClassesJs = require("./gridClasses.js");
var _gridClassesJsDefault = parcelHelpers.interopDefault(_gridClassesJs);
parcelHelpers.exportAll(_gridClassesJs, exports);
var _traverseBreakpointsJs = require("./traverseBreakpoints.js");
var _gridGeneratorJs = require("./gridGenerator.js");

},{"./Grid.js":"CDIjI","./createGrid.js":"gPzOQ","./GridProps.js":"2Zbyd","./gridClasses.js":"dwK5f","./traverseBreakpoints.js":"iBKZv","./gridGenerator.js":"jOXzh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Zbyd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dwK5f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridUtilityClass", ()=>getGridUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getGridUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiGrid', slot);
}
const SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const GRID_SIZES = [
    'auto',
    'grow',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const gridClasses = (0, _generateUtilityClassesDefault.default)('MuiGrid', [
    'root',
    'container',
    'item',
    // spacings
    ...SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
exports.default = gridClasses;

},{"@mui/utils/generateUtilityClasses":"7pSUk","@mui/utils/generateUtilityClass":"jBs9M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iA9F0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _createStackJs = require("./createStack.js");
var _createStackJsDefault = parcelHelpers.interopDefault(_createStackJs);
'use client';
/**
 *
 * Demos:
 *
 * - [Stack (Joy UI)](https://mui.com/joy-ui/react-stack/)
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const Stack = (0, _createStackJsDefault.default)();
exports.default = Stack;

},{"prop-types":"bnNSm","./createStack.js":"j1dJ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j1dJ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "style", ()=>style);
parcelHelpers.export(exports, "default", ()=>createStack);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _indexJs = require("../styled/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../useThemeProps/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../styleFunctionSx/index.js");
var _indexJs3 = require("../createTheme/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../breakpoints/index.js");
var _indexJs5 = require("../spacing/index.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const defaultTheme = (0, _indexJsDefault2.default)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0, _indexJsDefault.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function useThemePropsDefault(props) {
    return (0, _indexJsDefault1.default)({
        props,
        name: 'MuiStack',
        defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function joinChildren(children, separator) {
    const childrenArray = _react.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ _react.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const style = ({ ownerState, theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, _indexJs4.handleBreakpoints)({
            theme
        }, (0, _indexJs4.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, _indexJs5.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, _indexJs4.resolveBreakpointValues)({
            values: ownerState.direction,
            base
        });
        const spacingValues = (0, _indexJs4.resolveBreakpointValues)({
            values: ownerState.spacing,
            base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, _indexJs5.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, _indexJs5.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, _deepmergeDefault.default)(styles, (0, _indexJs4.handleBreakpoints)({
            theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, _indexJs4.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function createStack(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, _composeClassesDefault.default)(slots, (slot)=>(0, _generateUtilityClassDefault.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent(style);
    const Stack = /*#__PURE__*/ _react.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, _indexJs2.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        const { component = 'div', direction = 'column', spacing = 0, divider, children, className, useFlexGap = false, ...other } = props;
        const ownerState = {
            direction,
            spacing,
            useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, _clsxDefault.default)(classes.root, className),
            ...other,
            children: divider ? joinChildren(children, divider) : children
        });
    });
    return Stack;
}

},{"react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/utils/deepmerge":"7wtTC","@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/composeClasses":"59Equ","../styled/index.js":"71lRH","../useThemeProps/index.js":"lN0LR","../styleFunctionSx/index.js":"8fFNO","../createTheme/index.js":"acrEQ","../breakpoints/index.js":"dlsE8","../spacing/index.js":"egxgQ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5l9XM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _stackJsDefault.default));
parcelHelpers.export(exports, "createStack", ()=>(0, _createStackJsDefault.default));
parcelHelpers.export(exports, "stackClasses", ()=>(0, _stackClassesJsDefault.default));
var _stackJs = require("./Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _createStackJs = require("./createStack.js");
var _createStackJsDefault = parcelHelpers.interopDefault(_createStackJs);
var _stackPropsJs = require("./StackProps.js");
parcelHelpers.exportAll(_stackPropsJs, exports);
var _stackClassesJs = require("./stackClasses.js");
var _stackClassesJsDefault = parcelHelpers.interopDefault(_stackClassesJs);
parcelHelpers.exportAll(_stackClassesJs, exports);

},{"./Stack.js":"iA9F0","./createStack.js":"j1dJ5","./StackProps.js":"e4VrU","./stackClasses.js":"5SlCw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e4VrU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5SlCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStackUtilityClass", ()=>getStackUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getStackUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiStack', slot);
}
const stackClasses = (0, _generateUtilityClassesDefault.default)('MuiStack', [
    'root'
]);
exports.default = stackClasses;

},{"@mui/utils/generateUtilityClasses":"7pSUk","@mui/utils/generateUtilityClass":"jBs9M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gC15W":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("bae74335ae73a284").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "unstable_ClassNameGenerator", {
    enumerable: true,
    get: function() {
        return _ClassNameGenerator.default;
    }
});
var _ClassNameGenerator = _interopRequireDefault(require("1c83b4866aaf0f08"));

},{"bae74335ae73a284":"kZ6eK","1c83b4866aaf0f08":"eyH7A"}],"2UrBk":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("bc33eca51e8cd6ee").default;
var _interopRequireDefault = require("656d435f2f5c6281").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    experimental_sx: true,
    THEME_ID: true,
    adaptV4Theme: true,
    hexToRgb: true,
    rgbToHex: true,
    hslToRgb: true,
    decomposeColor: true,
    recomposeColor: true,
    getContrastRatio: true,
    getLuminance: true,
    emphasize: true,
    alpha: true,
    darken: true,
    lighten: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    unstable_createBreakpoints: true,
    createTheme: true,
    unstable_createMuiStrictModeTheme: true,
    createStyles: true,
    unstable_getUnit: true,
    unstable_toUnitless: true,
    responsiveFontSizes: true,
    createTransitions: true,
    duration: true,
    easing: true,
    createColorScheme: true,
    useTheme: true,
    useThemeProps: true,
    styled: true,
    ThemeProvider: true,
    makeStyles: true,
    withStyles: true,
    withTheme: true,
    extendTheme: true,
    experimental_extendTheme: true,
    getOverlayAlpha: true,
    shouldSkipGeneratingVar: true,
    private_createTypography: true,
    private_createMixins: true,
    private_excludeVariablesFromRoot: true
};
Object.defineProperty(exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return _system.StyledEngineProvider;
    }
});
Object.defineProperty(exports, "THEME_ID", {
    enumerable: true,
    get: function() {
        return _identifier.default;
    }
});
Object.defineProperty(exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return _ThemeProvider.default;
    }
});
Object.defineProperty(exports, "adaptV4Theme", {
    enumerable: true,
    get: function() {
        return _adaptV4Theme.default;
    }
});
Object.defineProperty(exports, "alpha", {
    enumerable: true,
    get: function() {
        return _system.alpha;
    }
});
Object.defineProperty(exports, "createColorScheme", {
    enumerable: true,
    get: function() {
        return _createColorScheme.default;
    }
});
Object.defineProperty(exports, "createStyles", {
    enumerable: true,
    get: function() {
        return _createStyles.default;
    }
});
Object.defineProperty(exports, "createTheme", {
    enumerable: true,
    get: function() {
        return _createTheme.default;
    }
});
Object.defineProperty(exports, "createTransitions", {
    enumerable: true,
    get: function() {
        return _createTransitions.default;
    }
});
Object.defineProperty(exports, "css", {
    enumerable: true,
    get: function() {
        return _system.css;
    }
});
Object.defineProperty(exports, "darken", {
    enumerable: true,
    get: function() {
        return _system.darken;
    }
});
Object.defineProperty(exports, "decomposeColor", {
    enumerable: true,
    get: function() {
        return _system.decomposeColor;
    }
});
Object.defineProperty(exports, "duration", {
    enumerable: true,
    get: function() {
        return _createTransitions.duration;
    }
});
Object.defineProperty(exports, "easing", {
    enumerable: true,
    get: function() {
        return _createTransitions.easing;
    }
});
Object.defineProperty(exports, "emphasize", {
    enumerable: true,
    get: function() {
        return _system.emphasize;
    }
});
Object.defineProperty(exports, "experimental_extendTheme", {
    enumerable: true,
    get: function() {
        return _experimental_extendTheme.default;
    }
});
exports.experimental_sx = experimental_sx;
Object.defineProperty(exports, "extendTheme", {
    enumerable: true,
    get: function() {
        return _createThemeWithVars.default;
    }
});
Object.defineProperty(exports, "getContrastRatio", {
    enumerable: true,
    get: function() {
        return _system.getContrastRatio;
    }
});
Object.defineProperty(exports, "getLuminance", {
    enumerable: true,
    get: function() {
        return _system.getLuminance;
    }
});
Object.defineProperty(exports, "getOverlayAlpha", {
    enumerable: true,
    get: function() {
        return _getOverlayAlpha.default;
    }
});
Object.defineProperty(exports, "hexToRgb", {
    enumerable: true,
    get: function() {
        return _system.hexToRgb;
    }
});
Object.defineProperty(exports, "hslToRgb", {
    enumerable: true,
    get: function() {
        return _system.hslToRgb;
    }
});
Object.defineProperty(exports, "keyframes", {
    enumerable: true,
    get: function() {
        return _system.keyframes;
    }
});
Object.defineProperty(exports, "lighten", {
    enumerable: true,
    get: function() {
        return _system.lighten;
    }
});
Object.defineProperty(exports, "makeStyles", {
    enumerable: true,
    get: function() {
        return _makeStyles.default;
    }
});
Object.defineProperty(exports, "private_createMixins", {
    enumerable: true,
    get: function() {
        return _createMixins.default;
    }
});
Object.defineProperty(exports, "private_createTypography", {
    enumerable: true,
    get: function() {
        return _createTypography.default;
    }
});
Object.defineProperty(exports, "private_excludeVariablesFromRoot", {
    enumerable: true,
    get: function() {
        return _excludeVariablesFromRoot.default;
    }
});
Object.defineProperty(exports, "recomposeColor", {
    enumerable: true,
    get: function() {
        return _system.recomposeColor;
    }
});
Object.defineProperty(exports, "responsiveFontSizes", {
    enumerable: true,
    get: function() {
        return _responsiveFontSizes.default;
    }
});
Object.defineProperty(exports, "rgbToHex", {
    enumerable: true,
    get: function() {
        return _system.rgbToHex;
    }
});
Object.defineProperty(exports, "shouldSkipGeneratingVar", {
    enumerable: true,
    get: function() {
        return _shouldSkipGeneratingVar.default;
    }
});
Object.defineProperty(exports, "styled", {
    enumerable: true,
    get: function() {
        return _styled.default;
    }
});
Object.defineProperty(exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return _createBreakpoints.unstable_createBreakpoints;
    }
});
Object.defineProperty(exports, "unstable_createMuiStrictModeTheme", {
    enumerable: true,
    get: function() {
        return _createMuiStrictModeTheme.default;
    }
});
Object.defineProperty(exports, "unstable_getUnit", {
    enumerable: true,
    get: function() {
        return _cssUtils.getUnit;
    }
});
Object.defineProperty(exports, "unstable_toUnitless", {
    enumerable: true,
    get: function() {
        return _cssUtils.toUnitless;
    }
});
Object.defineProperty(exports, "useTheme", {
    enumerable: true,
    get: function() {
        return _useTheme.default;
    }
});
Object.defineProperty(exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return _useThemeProps.default;
    }
});
Object.defineProperty(exports, "withStyles", {
    enumerable: true,
    get: function() {
        return _withStyles.default;
    }
});
Object.defineProperty(exports, "withTheme", {
    enumerable: true,
    get: function() {
        return _withTheme.default;
    }
});
var _formatMuiErrorMessage = _interopRequireDefault(require("c0ea11b0d0ee46e9"));
var _identifier = _interopRequireDefault(require("1411653a979ee365"));
var _adaptV4Theme = _interopRequireDefault(require("32639deb47ca2947"));
var _system = require("f4740b7ec3eee5db");
var _createBreakpoints = require("cb741b34ee3fb698");
var _createTheme = _interopRequireDefault(require("66b82cbaa4922f10"));
var _createMuiStrictModeTheme = _interopRequireDefault(require("9f1fb6c15ec0e684"));
var _createStyles = _interopRequireDefault(require("85c6ef9a8eb2509d"));
var _cssUtils = require("b58d051c8868ec3e");
var _responsiveFontSizes = _interopRequireDefault(require("1812bb656c613f0"));
var _createTransitions = _interopRequireWildcard(require("c3f385ca754f813e"));
var _createColorScheme = _interopRequireDefault(require("7f521f396ecb130"));
var _useTheme = _interopRequireDefault(require("8984ba17a5155400"));
var _useThemeProps = _interopRequireDefault(require("40afcc7c450aa714"));
var _styled = _interopRequireDefault(require("3dc6006963d99db"));
var _ThemeProvider = _interopRequireDefault(require("5a16a7f3424e379f"));
var _makeStyles = _interopRequireDefault(require("e3a59da9cac07557"));
var _withStyles = _interopRequireDefault(require("bb1a6b61ba96c039"));
var _withTheme = _interopRequireDefault(require("f558bf98c9181d0b"));
var _ThemeProviderWithVars = require("58c40174a7445dd7");
Object.keys(_ThemeProviderWithVars).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _ThemeProviderWithVars[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _ThemeProviderWithVars[key];
        }
    });
});
var _createThemeWithVars = _interopRequireDefault(require("581bb5d9d37aae53"));
var _experimental_extendTheme = _interopRequireDefault(require("8593580881fd87f6"));
var _getOverlayAlpha = _interopRequireDefault(require("5cb652e37d50fb63"));
var _shouldSkipGeneratingVar = _interopRequireDefault(require("136232a63aeefdc9"));
var _createTypography = _interopRequireDefault(require("8d59ebf71aba2180"));
var _createMixins = _interopRequireDefault(require("53937cdf846376f7"));
var _excludeVariablesFromRoot = _interopRequireDefault(require("c93ac7b36e4d5e8"));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessage.default)(19));
} // The legacy utilities from @mui/styles
 // These are just empty functions that throws when invoked
 // TODO: Remove in v7
 // Private methods for creating parts of the theme

},{"bc33eca51e8cd6ee":"fiRIh","656d435f2f5c6281":"kZ6eK","c0ea11b0d0ee46e9":"gOgzd","1411653a979ee365":"gf60V","32639deb47ca2947":"eSxoR","f4740b7ec3eee5db":"iFfXs","cb741b34ee3fb698":"kPrUI","66b82cbaa4922f10":"iZK2b","9f1fb6c15ec0e684":"cgAln","85c6ef9a8eb2509d":"7e9nq","b58d051c8868ec3e":"j89Nf","1812bb656c613f0":"bLP32","c3f385ca754f813e":"1PwKJ","7f521f396ecb130":"ha33T","8984ba17a5155400":"7z5Ze","40afcc7c450aa714":"bvzB4","3dc6006963d99db":"iVEGR","5a16a7f3424e379f":"8AJZZ","e3a59da9cac07557":"bodjk","bb1a6b61ba96c039":"3X7DX","f558bf98c9181d0b":"2Jr4W","58c40174a7445dd7":"8j0rW","581bb5d9d37aae53":"lPCHl","8593580881fd87f6":"hheP7","5cb652e37d50fb63":"fzJyp","136232a63aeefdc9":"bvQ2q","8d59ebf71aba2180":"7UQh9","53937cdf846376f7":"kwHUg","c93ac7b36e4d5e8":"efGTY"}],"gf60V":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = exports.default = '$$material';

},{}],"eSxoR":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = adaptV4Theme;
var _system = require("cfff3bb9c605e1fa");
function adaptV4Theme(inputTheme) {
    const { defaultProps = {}, mixins = {}, overrides = {}, palette = {}, props = {}, styleOverrides = {}, ...other } = inputTheme;
    const theme = {
        ...other,
        components: {}
    };
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, _system.createSpacing)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, _system.createBreakpoints)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = {
        gutters: (styles = {})=>{
            return {
                paddingLeft: spacing(2),
                paddingRight: spacing(2),
                ...styles,
                [breakpoints.up('sm')]: {
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3),
                    ...styles[breakpoints.up('sm')]
                }
            };
        },
        ...mixins
    };
    const { type: typeInput, mode: modeInput, ...paletteRest } = palette;
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = {
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode,
        ...paletteRest
    };
    return theme;
}

},{"cfff3bb9c605e1fa":"iFfXs"}],"kPrUI":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4e75d35597054138").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return _createBreakpoints.default;
    }
});
var _createBreakpoints = _interopRequireDefault(require("251dd965507dcb6c"));

},{"4e75d35597054138":"kZ6eK","251dd965507dcb6c":"cQVkp"}],"cQVkp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.breakpointKeys = void 0;
exports.default = createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const breakpointKeys = exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
    const { // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit = 'px', step = 5, ...other } = breakpoints;
    const sortedValues = sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys,
        values: sortedValues,
        up,
        down,
        between,
        only,
        not,
        unit,
        ...other
    };
}

},{}],"iZK2b":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c139ce5a2fd60ad9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createTheme;
var _createPalette = _interopRequireDefault(require("4b3b307275544e3e"));
var _createThemeWithVars = _interopRequireDefault(require("c24e2aaf9dced62e"));
var _createThemeNoVars = _interopRequireDefault(require("f646c4d092aa4463"));
// eslint-disable-next-line consistent-return
function attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, _createPalette.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function createTheme(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette, cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, _createThemeNoVars.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, _createThemeNoVars.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, _createThemeWithVars.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

},{"c139ce5a2fd60ad9":"kZ6eK","4b3b307275544e3e":"6F39w","c24e2aaf9dced62e":"lPCHl","f646c4d092aa4463":"6dGGf"}],"6F39w":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("79c19e52234a3b88").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dark = void 0;
exports.default = createPalette;
exports.light = void 0;
var _formatMuiErrorMessage = _interopRequireDefault(require("b36f288268127ec3"));
var _deepmerge = _interopRequireDefault(require("cdbc596e645511e0"));
var _colorManipulator = require("5e041ec8f35613e4");
var _common = _interopRequireDefault(require("8478bc4032f0af31"));
var _grey = _interopRequireDefault(require("544d5705adcc77d0"));
var _purple = _interopRequireDefault(require("44e14b56e4719f91"));
var _red = _interopRequireDefault(require("b988cf8dec286cda"));
var _orange = _interopRequireDefault(require("b8447950ce9571f2"));
var _blue = _interopRequireDefault(require("8c9daa7d89ccd2e6"));
var _lightBlue = _interopRequireDefault(require("fcaaba7ffc5dacf"));
var _green = _interopRequireDefault(require("cf9736a34a7bfb45"));
function getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: _common.default.white,
            default: _common.default.white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const light = exports.light = getLight();
function getDark() {
    return {
        text: {
            primary: _common.default.white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: _common.default.white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const dark = exports.dark = getDark();
function addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffsetDark);
    }
}
function getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: _blue.default[200],
        light: _blue.default[50],
        dark: _blue.default[400]
    };
    return {
        main: _blue.default[700],
        light: _blue.default[400],
        dark: _blue.default[800]
    };
}
function getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: _purple.default[200],
        light: _purple.default[50],
        dark: _purple.default[400]
    };
    return {
        main: _purple.default[500],
        light: _purple.default[300],
        dark: _purple.default[700]
    };
}
function getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: _red.default[500],
        light: _red.default[300],
        dark: _red.default[700]
    };
    return {
        main: _red.default[700],
        light: _red.default[400],
        dark: _red.default[800]
    };
}
function getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: _lightBlue.default[400],
        light: _lightBlue.default[300],
        dark: _lightBlue.default[700]
    };
    return {
        main: _lightBlue.default[700],
        light: _lightBlue.default[500],
        dark: _lightBlue.default[900]
    };
}
function getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: _green.default[400],
        light: _green.default[300],
        dark: _green.default[700]
    };
    return {
        main: _green.default[800],
        light: _green.default[500],
        dark: _green.default[900]
    };
}
function getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: _orange.default[400],
        light: _orange.default[300],
        dark: _orange.default[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: _orange.default[500],
        dark: _orange.default[900]
    };
}
function createPalette(palette) {
    const { mode = 'light', contrastThreshold = 3, tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || getDefaultPrimary(mode);
    const secondary = palette.secondary || getDefaultSecondary(mode);
    const error = palette.error || getDefaultError(mode);
    const info = palette.info || getDefaultInfo(mode);
    const success = palette.success || getDefaultSuccess(mode);
    const warning = palette.warning || getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color, name, mainShade = 500, lightShade = 300, darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, _formatMuiErrorMessage.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, _formatMuiErrorMessage.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        addLightOrDark(color, 'light', lightShade, tonalOffset);
        addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = getLight();
    else if (mode === 'dark') modeHydrated = getDark();
    const paletteOutput = (0, _deepmerge.default)({
        // A collection of common colors.
        common: {
            ..._common.default
        },
        // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        // The grey colors.
        grey: _grey.default,
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        // Generate a rich color object.
        augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

},{"79c19e52234a3b88":"kZ6eK","b36f288268127ec3":"gOgzd","cdbc596e645511e0":"7wtTC","5e041ec8f35613e4":"hTYBL","8478bc4032f0af31":"by3PL","544d5705adcc77d0":"0ebz0","44e14b56e4719f91":"2jtr7","b988cf8dec286cda":"7dby9","b8447950ce9571f2":"kpNez","8c9daa7d89ccd2e6":"HIKnd","fcaaba7ffc5dacf":"eul0L","cf9736a34a7bfb45":"4QoRO"}],"hTYBL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _colorManipulator = require("310dda5cb8c2fab9");
Object.keys(_colorManipulator).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _colorManipulator[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _colorManipulator[key];
        }
    });
});

},{"310dda5cb8c2fab9":"ioMKX"}],"ioMKX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a54f4eea3def311f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.alpha = alpha;
exports.blend = blend;
exports.colorChannel = void 0;
exports.darken = darken;
exports.decomposeColor = decomposeColor;
exports.emphasize = emphasize;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.hexToRgb = hexToRgb;
exports.hslToRgb = hslToRgb;
exports.lighten = lighten;
exports.private_safeAlpha = private_safeAlpha;
exports.private_safeColorChannel = void 0;
exports.private_safeDarken = private_safeDarken;
exports.private_safeEmphasize = private_safeEmphasize;
exports.private_safeLighten = private_safeLighten;
exports.recomposeColor = recomposeColor;
exports.rgbToHex = rgbToHex;
var _formatMuiErrorMessage = _interopRequireDefault(require("47a311b376171898"));
var _clamp = _interopRequireDefault(require("dd0db14c48cc1331"));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function clampWrapper(value, min = 0, max = 1) {
    return (0, _clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return decomposeColor(hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, _formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, _formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type,
        values,
        colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const colorChannel = (color)=>{
    const decomposedColor = decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
exports.colorChannel = colorChannel;
const private_safeColorChannel = (color, warning)=>{
    try {
        return colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ exports.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values } = decomposeColor(color);
    return `#${values.map((n, i)=>intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function hslToRgb(color) {
    color = decomposeColor(color);
    const { values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return recomposeColor({
        type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function getLuminance(color) {
    color = decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function alpha(color, value) {
    color = decomposeColor(color);
    value = clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
    try {
        return alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
    try {
        return darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
    try {
        return lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function emphasize(color, coefficient = 0.15) {
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
    try {
        return emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = decomposeColor(background);
    const overlayColor = decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

},{"a54f4eea3def311f":"kZ6eK","47a311b376171898":"gOgzd","dd0db14c48cc1331":"flxMs"}],"by3PL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const common = {
    black: '#000',
    white: '#fff'
};
var _default = exports.default = common;

},{}],"0ebz0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var _default = exports.default = grey;

},{}],"2jtr7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var _default = exports.default = purple;

},{}],"7dby9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var _default = exports.default = red;

},{}],"kpNez":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var _default = exports.default = orange;

},{}],"HIKnd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var _default = exports.default = blue;

},{}],"eul0L":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var _default = exports.default = lightBlue;

},{}],"4QoRO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var _default = exports.default = green;

},{}],"lPCHl":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5f81dfc545723915").default;
var _interopRequireDefault = require("fcb783f3ff42c786").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createGetCssVar = void 0;
exports.default = createThemeWithVars;
var _formatMuiErrorMessage = _interopRequireDefault(require("6755cb5b22e54507"));
var _deepmerge = _interopRequireDefault(require("2055bbca4723f969"));
var _system = require("858bddc0b631ff42");
var _spacing = require("e646a306f93ba0ad");
var _cssVars = require("69c86399ea6bf11");
var _styleFunctionSx = _interopRequireWildcard(require("92b3f6046bbc2d3a"));
var _colorManipulator = require("b222a08a7cef997d");
var _createThemeNoVars = _interopRequireDefault(require("6f008f26f8dc6631"));
var _createColorScheme = _interopRequireWildcard(require("2815fd4257f65267"));
var _shouldSkipGeneratingVar = _interopRequireDefault(require("ff16feedae7c0470"));
var _createGetSelector = _interopRequireDefault(require("d6063b76d4888c6b"));
var _stringifyTheme = require("3a59c3495135737");
function assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, _colorManipulator.hslToRgb)(color);
}
function setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, _colorManipulator.private_safeColorChannel)(toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const createGetCssVar = (cssVarPrefix = 'mui')=>(0, _system.unstable_createGetCssVar)(cssVarPrefix);
exports.createGetCssVar = createGetCssVar;
function attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, _createColorScheme.default)({
            ...scheme,
            palette: {
                mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette, ...muiTheme } = (0, _createThemeNoVars.default)({
        ...restTheme,
        palette: {
            mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette,
        opacity: {
            ...(0, _createColorScheme.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, _createColorScheme.getOverlays)(mode)
    };
    return muiTheme;
}
/**
 * A default `createThemeWithVars` comes with a single color scheme, either `light` or `dark` based on the `defaultColorScheme`.
 * This is better suited for apps that only need a single color scheme.
 *
 * To enable built-in `light` and `dark` color schemes, either:
 * 1. provide a `colorSchemeSelector` to define how the color schemes will change.
 * 2. provide `colorSchemes.dark` will set `colorSchemeSelector: 'media'` by default.
 */ function createThemeWithVars(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme = false, cssVarPrefix = 'mui', shouldSkipGeneratingVar = _shouldSkipGeneratingVar.default, colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = createGetCssVar(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, _formatMuiErrorMessage.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme,
        ...muiTheme,
        cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector,
        getCssVar,
        colorSchemes,
        font: {
            ...(0, _cssVars.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            setColor(palette.common, 'background', '#fff');
            setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            setColor(palette.common, 'background', '#000');
            setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            setColor(palette.Alert, 'errorColor', (0, _colorManipulator.private_safeDarken)(palette.error.light, 0.6));
            setColor(palette.Alert, 'infoColor', (0, _colorManipulator.private_safeDarken)(palette.info.light, 0.6));
            setColor(palette.Alert, 'successColor', (0, _colorManipulator.private_safeDarken)(palette.success.light, 0.6));
            setColor(palette.Alert, 'warningColor', (0, _colorManipulator.private_safeDarken)(palette.warning.light, 0.6));
            setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            setColor(palette.Alert, 'errorFilledColor', silent(()=>palette.getContrastText(palette.error.main)));
            setColor(palette.Alert, 'infoFilledColor', silent(()=>palette.getContrastText(palette.info.main)));
            setColor(palette.Alert, 'successFilledColor', silent(()=>palette.getContrastText(palette.success.main)));
            setColor(palette.Alert, 'warningFilledColor', silent(()=>palette.getContrastText(palette.warning.main)));
            setColor(palette.Alert, 'errorStandardBg', (0, _colorManipulator.private_safeLighten)(palette.error.light, 0.9));
            setColor(palette.Alert, 'infoStandardBg', (0, _colorManipulator.private_safeLighten)(palette.info.light, 0.9));
            setColor(palette.Alert, 'successStandardBg', (0, _colorManipulator.private_safeLighten)(palette.success.light, 0.9));
            setColor(palette.Alert, 'warningStandardBg', (0, _colorManipulator.private_safeLighten)(palette.warning.light, 0.9));
            setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            setColor(palette.LinearProgress, 'primaryBg', (0, _colorManipulator.private_safeLighten)(palette.primary.main, 0.62));
            setColor(palette.LinearProgress, 'secondaryBg', (0, _colorManipulator.private_safeLighten)(palette.secondary.main, 0.62));
            setColor(palette.LinearProgress, 'errorBg', (0, _colorManipulator.private_safeLighten)(palette.error.main, 0.62));
            setColor(palette.LinearProgress, 'infoBg', (0, _colorManipulator.private_safeLighten)(palette.info.main, 0.62));
            setColor(palette.LinearProgress, 'successBg', (0, _colorManipulator.private_safeLighten)(palette.success.main, 0.62));
            setColor(palette.LinearProgress, 'warningBg', (0, _colorManipulator.private_safeLighten)(palette.warning.main, 0.62));
            setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            setColor(palette.Slider, 'primaryTrack', (0, _colorManipulator.private_safeLighten)(palette.primary.main, 0.62));
            setColor(palette.Slider, 'secondaryTrack', (0, _colorManipulator.private_safeLighten)(palette.secondary.main, 0.62));
            setColor(palette.Slider, 'errorTrack', (0, _colorManipulator.private_safeLighten)(palette.error.main, 0.62));
            setColor(palette.Slider, 'infoTrack', (0, _colorManipulator.private_safeLighten)(palette.info.main, 0.62));
            setColor(palette.Slider, 'successTrack', (0, _colorManipulator.private_safeLighten)(palette.success.main, 0.62));
            setColor(palette.Slider, 'warningTrack', (0, _colorManipulator.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, _colorManipulator.private_safeEmphasize)(palette.background.default, 0.8);
            setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            setColor(palette.SnackbarContent, 'color', silent(()=>palette.getContrastText(snackbarContentBackground)));
            setColor(palette.SpeedDialAction, 'fabHoverBg', (0, _colorManipulator.private_safeEmphasize)(palette.background.paper, 0.15));
            setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            setColor(palette.Switch, 'primaryDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.primary.main, 0.62));
            setColor(palette.Switch, 'secondaryDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.secondary.main, 0.62));
            setColor(palette.Switch, 'errorDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.error.main, 0.62));
            setColor(palette.Switch, 'infoDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.info.main, 0.62));
            setColor(palette.Switch, 'successDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.success.main, 0.62));
            setColor(palette.Switch, 'warningDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.warning.main, 0.62));
            setColor(palette.TableCell, 'border', (0, _colorManipulator.private_safeLighten)((0, _colorManipulator.private_safeAlpha)(palette.divider, 1), 0.88));
            setColor(palette.Tooltip, 'bg', (0, _colorManipulator.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            setColor(palette.Alert, 'errorColor', (0, _colorManipulator.private_safeLighten)(palette.error.light, 0.6));
            setColor(palette.Alert, 'infoColor', (0, _colorManipulator.private_safeLighten)(palette.info.light, 0.6));
            setColor(palette.Alert, 'successColor', (0, _colorManipulator.private_safeLighten)(palette.success.light, 0.6));
            setColor(palette.Alert, 'warningColor', (0, _colorManipulator.private_safeLighten)(palette.warning.light, 0.6));
            setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            setColor(palette.Alert, 'errorFilledColor', silent(()=>palette.getContrastText(palette.error.dark)));
            setColor(palette.Alert, 'infoFilledColor', silent(()=>palette.getContrastText(palette.info.dark)));
            setColor(palette.Alert, 'successFilledColor', silent(()=>palette.getContrastText(palette.success.dark)));
            setColor(palette.Alert, 'warningFilledColor', silent(()=>palette.getContrastText(palette.warning.dark)));
            setColor(palette.Alert, 'errorStandardBg', (0, _colorManipulator.private_safeDarken)(palette.error.light, 0.9));
            setColor(palette.Alert, 'infoStandardBg', (0, _colorManipulator.private_safeDarken)(palette.info.light, 0.9));
            setColor(palette.Alert, 'successStandardBg', (0, _colorManipulator.private_safeDarken)(palette.success.light, 0.9));
            setColor(palette.Alert, 'warningStandardBg', (0, _colorManipulator.private_safeDarken)(palette.warning.light, 0.9));
            setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            setColor(palette.LinearProgress, 'primaryBg', (0, _colorManipulator.private_safeDarken)(palette.primary.main, 0.5));
            setColor(palette.LinearProgress, 'secondaryBg', (0, _colorManipulator.private_safeDarken)(palette.secondary.main, 0.5));
            setColor(palette.LinearProgress, 'errorBg', (0, _colorManipulator.private_safeDarken)(palette.error.main, 0.5));
            setColor(palette.LinearProgress, 'infoBg', (0, _colorManipulator.private_safeDarken)(palette.info.main, 0.5));
            setColor(palette.LinearProgress, 'successBg', (0, _colorManipulator.private_safeDarken)(palette.success.main, 0.5));
            setColor(palette.LinearProgress, 'warningBg', (0, _colorManipulator.private_safeDarken)(palette.warning.main, 0.5));
            setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            setColor(palette.Slider, 'primaryTrack', (0, _colorManipulator.private_safeDarken)(palette.primary.main, 0.5));
            setColor(palette.Slider, 'secondaryTrack', (0, _colorManipulator.private_safeDarken)(palette.secondary.main, 0.5));
            setColor(palette.Slider, 'errorTrack', (0, _colorManipulator.private_safeDarken)(palette.error.main, 0.5));
            setColor(palette.Slider, 'infoTrack', (0, _colorManipulator.private_safeDarken)(palette.info.main, 0.5));
            setColor(palette.Slider, 'successTrack', (0, _colorManipulator.private_safeDarken)(palette.success.main, 0.5));
            setColor(palette.Slider, 'warningTrack', (0, _colorManipulator.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, _colorManipulator.private_safeEmphasize)(palette.background.default, 0.98);
            setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            setColor(palette.SnackbarContent, 'color', silent(()=>palette.getContrastText(snackbarContentBackground)));
            setColor(palette.SpeedDialAction, 'fabHoverBg', (0, _colorManipulator.private_safeEmphasize)(palette.background.paper, 0.15));
            setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            setColor(palette.Switch, 'primaryDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.primary.main, 0.55));
            setColor(palette.Switch, 'secondaryDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.secondary.main, 0.55));
            setColor(palette.Switch, 'errorDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.error.main, 0.55));
            setColor(palette.Switch, 'infoDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.info.main, 0.55));
            setColor(palette.Switch, 'successDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.success.main, 0.55));
            setColor(palette.Switch, 'warningDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.warning.main, 0.55));
            setColor(palette.TableCell, 'border', (0, _colorManipulator.private_safeDarken)((0, _colorManipulator.private_safeAlpha)(palette.divider, 1), 0.68));
            setColor(palette.Tooltip, 'bg', (0, _colorManipulator.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        setColorChannel(palette.background, 'paper');
        setColorChannel(palette.common, 'background');
        setColorChannel(palette.common, 'onBackground');
        setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) setColor(palette[color], 'mainChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.main)));
                if (colors.light) setColor(palette[color], 'lightChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.light)));
                if (colors.dark) setColor(palette[color], 'darkChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.dark)));
                if (colors.contrastText) setColor(palette[color], 'contrastTextChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    setColorChannel(palette[color], 'primary');
                    setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) setColorChannel(palette[color], 'active');
                    if (colors.selected) setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, _deepmerge.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme,
        shouldSkipGeneratingVar,
        getSelector: (0, _createGetSelector.default)(theme)
    };
    const { vars, generateThemeVars, generateStyleSheets } = (0, _cssVars.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, _system.createSpacing)(input.spacing, (0, _spacing.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, _cssVars.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ..._styleFunctionSx.unstable_defaultSxConfig,
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = _stringifyTheme.stringifyTheme; // for Pigment CSS integration
    return theme;
}

},{"5f81dfc545723915":"fiRIh","fcb783f3ff42c786":"kZ6eK","6755cb5b22e54507":"gOgzd","2055bbca4723f969":"7wtTC","858bddc0b631ff42":"iFfXs","e646a306f93ba0ad":"3PKpA","69c86399ea6bf11":"eehcx","92b3f6046bbc2d3a":"e1roB","b222a08a7cef997d":"hTYBL","6f008f26f8dc6631":"6dGGf","2815fd4257f65267":"ha33T","ff16feedae7c0470":"bvQ2q","d6063b76d4888c6b":"aCAJD","3a59c3495135737":"f6ZZU"}],"3PKpA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("606a2ed0ce831dd9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _spacing.default;
    }
});
var _spacing = _interopRequireWildcard(require("e86ea1f53daffa96"));
Object.keys(_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _spacing[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _spacing[key];
        }
    });
});

},{"606a2ed0ce831dd9":"fiRIh","e86ea1f53daffa96":"253jp"}],"253jp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("71d176b307068e0e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createUnarySpacing = createUnarySpacing;
exports.createUnaryUnit = createUnaryUnit;
exports.default = void 0;
exports.getStyleFromPropValue = getStyleFromPropValue;
exports.getValue = getValue;
exports.margin = margin;
exports.marginKeys = void 0;
exports.padding = padding;
exports.paddingKeys = void 0;
var _responsivePropType = _interopRequireDefault(require("e629f08b8f852dff"));
var _breakpoints = require("c3fa080d2d3f53d3");
var _style = require("2dd9a87d7c34c534");
var _merge = _interopRequireDefault(require("26bf834107052fd6"));
var _memoize = _interopRequireDefault(require("e1785f73db1c256a"));
const properties = {
    m: 'margin',
    p: 'padding'
};
const directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = (0, _memoize.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if (aliases[prop]) prop = aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = properties[a];
    const direction = directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const marginKeys = exports.marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const paddingKeys = exports.paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const spacingKeys = [
    ...marginKeys,
    ...paddingKeys
];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, _style.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function createUnarySpacing(theme) {
    return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = getValue(transformer, propValue);
            return acc;
        }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = getCssProperties(prop);
    const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function style(props, keys) {
    const transformer = createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>resolveCssProperty(props, keys, prop, transformer)).reduce(_merge.default, {});
}
function margin(props) {
    return style(props, marginKeys);
}
margin.propTypes = {};
margin.filterProps = marginKeys;
function padding(props) {
    return style(props, paddingKeys);
}
padding.propTypes = {};
padding.filterProps = paddingKeys;
function spacing(props) {
    return style(props, spacingKeys);
}
spacing.propTypes = {};
spacing.filterProps = spacingKeys;
var _default = exports.default = spacing;

},{"71d176b307068e0e":"kZ6eK","e629f08b8f852dff":"bqofx","c3fa080d2d3f53d3":"1dc0z","2dd9a87d7c34c534":"fiOnV","26bf834107052fd6":"4iLSQ","e1785f73db1c256a":"1Bq1a"}],"bqofx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ec6c7c0e1b7f6948").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _responsivePropType.default;
    }
});
var _responsivePropType = _interopRequireDefault(require("650457f449899290"));

},{"ec6c7c0e1b7f6948":"kZ6eK","650457f449899290":"fHaFb"}],"fHaFb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("297608686d02322a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("b35663a2342e647f"));
const responsivePropType = {};
var _default = exports.default = responsivePropType;

},{"297608686d02322a":"kZ6eK","b35663a2342e647f":"bnNSm"}],"1dc0z":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("298040812d0beba9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _breakpoints.default;
    }
});
var _breakpoints = _interopRequireWildcard(require("a155ccd2323803e9"));
Object.keys(_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _breakpoints[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _breakpoints[key];
        }
    });
});

},{"298040812d0beba9":"fiRIh","a155ccd2323803e9":"9z4df"}],"9z4df":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a6136cdc22d0813d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.computeBreakpointsBase = computeBreakpointsBase;
exports.createEmptyBreakpointObject = createEmptyBreakpointObject;
exports.default = void 0;
exports.handleBreakpoints = handleBreakpoints;
exports.mergeBreakpointsInOrder = mergeBreakpointsInOrder;
exports.removeUnusedBreakpoints = removeUnusedBreakpoints;
exports.resolveBreakpointValues = resolveBreakpointValues;
exports.values = void 0;
var _propTypes = _interopRequireDefault(require("8e5b28389e20e17b"));
var _deepmerge = _interopRequireDefault(require("1d9f2e62540cf7b6"));
var _merge = _interopRequireDefault(require("5d17e0af0929002b"));
var _cssContainerQueries = require("6bd2fe12ec9a2caa");
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${values[key]}px)`
};
const defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, _cssContainerQueries.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, _cssContainerQueries.getContainerQuery)(theme.containerQueries ? theme : defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, _merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, _deepmerge.default)(prev, next), {});
    return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var _default = exports.default = breakpoints;

},{"a6136cdc22d0813d":"kZ6eK","8e5b28389e20e17b":"bnNSm","1d9f2e62540cf7b6":"7wtTC","5d17e0af0929002b":"4iLSQ","6bd2fe12ec9a2caa":"9nycZ"}],"4iLSQ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("fc6ab35294d6090c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _merge.default;
    }
});
var _merge = _interopRequireDefault(require("5675c06187a9f579"));

},{"fc6ab35294d6090c":"kZ6eK","5675c06187a9f579":"drdlm"}],"drdlm":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cd412d495236e54a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("450a67cad5d36e5a"));
function merge(acc, item) {
    if (!item) return acc;
    return (0, _deepmerge.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var _default = exports.default = merge;

},{"cd412d495236e54a":"kZ6eK","450a67cad5d36e5a":"7wtTC"}],"9nycZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("b4cec13b20945773").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _cssContainerQueries.default;
    }
});
Object.defineProperty(exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return _cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return _cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return _cssContainerQueries.sortContainerQueries;
    }
});
var _cssContainerQueries = _interopRequireWildcard(require("59ff7536d9109ba6"));

},{"b4cec13b20945773":"fiRIh","59ff7536d9109ba6":"jRZqy"}],"jRZqy":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("63c97ab4ead71b1d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cssContainerQueries;
exports.getContainerQuery = getContainerQuery;
exports.isCqShorthand = isCqShorthand;
exports.sortContainerQueries = sortContainerQueries;
var _formatMuiErrorMessage = _interopRequireDefault(require("ed2a2f8b3caa624b"));
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 eventhough 40rem > 300px
 */ function sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries
    };
}

},{"63c97ab4ead71b1d":"kZ6eK","ed2a2f8b3caa624b":"gOgzd"}],"fiOnV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c8a7c8d9b8f4e240").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _style.default;
    }
});
var _style = _interopRequireWildcard(require("744c9014913efcd8"));
Object.keys(_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _style[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _style[key];
        }
    });
});

},{"c8a7c8d9b8f4e240":"fiRIh","744c9014913efcd8":"gkQEi"}],"gkQEi":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("15c10178470582d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPath = getPath;
exports.getStyleValue = getStyleValue;
var _capitalize = _interopRequireDefault(require("913a49dd101c73af"));
var _responsivePropType = _interopRequireDefault(require("5a0088855d5ded69"));
var _breakpoints = require("19752313f867dee4");
function getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function style(options) {
    const { prop, cssProperty = options.prop, themeKey, transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var _default = exports.default = style;

},{"15c10178470582d":"kZ6eK","913a49dd101c73af":"5sWY4","5a0088855d5ded69":"bqofx","19752313f867dee4":"1dc0z"}],"1Bq1a":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f213d6040afacb77").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _memoize.default;
    }
});
var _memoize = _interopRequireDefault(require("180b2e3d46554f10"));

},{"f213d6040afacb77":"kZ6eK","180b2e3d46554f10":"iye7y"}],"iye7y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = memoize;
function memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{}],"eehcx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a51126d5bd2275").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return _createCssVarsTheme.default;
    }
});
Object.defineProperty(exports, "createGetColorSchemeSelector", {
    enumerable: true,
    get: function() {
        return _getColorSchemeSelector.createGetColorSchemeSelector;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _createCssVarsProvider.default;
    }
});
Object.defineProperty(exports, "prepareCssVars", {
    enumerable: true,
    get: function() {
        return _prepareCssVars.default;
    }
});
Object.defineProperty(exports, "prepareTypographyVars", {
    enumerable: true,
    get: function() {
        return _prepareTypographyVars.default;
    }
});
var _createCssVarsProvider = _interopRequireDefault(require("dfae27ca31306a0e"));
var _prepareCssVars = _interopRequireDefault(require("d98545f5c0c0740e"));
var _prepareTypographyVars = _interopRequireDefault(require("c3dc230e2b940bd4"));
var _createCssVarsTheme = _interopRequireDefault(require("2bda82692be67aa8"));
var _getColorSchemeSelector = require("fd4cdf3817603102");

},{"a51126d5bd2275":"kZ6eK","dfae27ca31306a0e":"c7nFK","d98545f5c0c0740e":"dQWqG","c3dc230e2b940bd4":"iYBuE","2bda82692be67aa8":"fGQiW","fd4cdf3817603102":"lCjr9"}],"c7nFK":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7bb1b00c3ce16e70").default;
var _interopRequireWildcard = require("841305f8151d5761").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DISABLE_CSS_TRANSITION = void 0;
exports.default = createCssVarsProvider;
var React = _interopRequireWildcard(require("cf72253cf59a0c4a"));
var _propTypes = _interopRequireDefault(require("85ef376bdcc70ce"));
var _styledEngine = require("27fd9fa473c78e80");
var _privateTheming = require("45eb920496ba4f96");
var _useEnhancedEffect = _interopRequireDefault(require("4af90c5f9c5514e"));
var _ThemeProvider = _interopRequireDefault(require("90a7650b1c1f5bfe"));
var _InitColorSchemeScript = _interopRequireWildcard(require("c9120b7bafb1949e"));
var _useCurrentColorScheme = _interopRequireDefault(require("bdfdcd452b0a518"));
var _jsxRuntime = require("2547781ca18894b7");
const DISABLE_CSS_TRANSITION = exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function createCssVarsProvider(options) {
    const { themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = _InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = _InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme, resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ React.createContext(undefined);
    const useColorScheme = ()=>React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children, theme: themeProp, modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange = designSystemTransitionOnChange, storageManager, storageWindow = typeof window === 'undefined' ? undefined : window, documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext = false, disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender = false, noSsr } = props;
        const hasMounted = React.useRef(false);
        const upperTheme = (0, _privateTheming.useTheme)();
        const ctx = React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes = defaultColorSchemes, components = defaultComponents, cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode, systemMode, lightColorScheme, darkColorScheme, colorScheme: stateColorScheme, setColorScheme } = (0, _useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme,
            defaultDarkColorScheme,
            modeStorageKey,
            colorSchemeStorageKey,
            defaultMode,
            storageManager,
            storageWindow,
            noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components,
                colorSchemes,
                cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, _useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode(DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = React.useMemo(()=>({
                allColorSchemes,
                colorScheme,
                darkColorScheme,
                lightColorScheme,
                mode,
                setColorScheme,
                setMode: setMode,
                systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styledEngine.GlobalStyles, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, _InitColorSchemeScript.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme,
            defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider,
        useColorScheme,
        getInitColorSchemeScript
    };
}

},{"7bb1b00c3ce16e70":"kZ6eK","841305f8151d5761":"fiRIh","cf72253cf59a0c4a":"9njXz","85ef376bdcc70ce":"bnNSm","27fd9fa473c78e80":"9ebNW","45eb920496ba4f96":"eHvzD","4af90c5f9c5514e":"fIvqa","90a7650b1c1f5bfe":"7jEDU","c9120b7bafb1949e":"8DcsU","bdfdcd452b0a518":"9ueGc","2547781ca18894b7":"1dlk8"}],"7jEDU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9642812f9fa3db8d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ThemeProvider.default;
    }
});
var _ThemeProvider = _interopRequireDefault(require("7da009a5ef328225"));

},{"9642812f9fa3db8d":"kZ6eK","7da009a5ef328225":"7jyfu"}],"7jyfu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2f0cdb539014f0d4").default;
var _interopRequireWildcard = require("945ee145cb6db818").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f66bdf805eb6a174"));
var _propTypes = _interopRequireDefault(require("a7dc9850114c1c07"));
var _privateTheming = require("d2b933a117fa27b3");
var _exactProp = _interopRequireDefault(require("daa2a36d2d0ccf09"));
var _styledEngine = require("617d81d7a7442614");
var _useThemeWithoutDefault = _interopRequireDefault(require("44c8f2f530ac38e9"));
var _RtlProvider = _interopRequireDefault(require("31aada5253a2fae2"));
var _DefaultPropsProvider = _interopRequireDefault(require("c65b0fe1e1532163"));
var _jsxRuntime = require("d40852f22693d112");
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function ThemeProvider(props) {
    const { children, theme: localTheme, themeId } = props;
    const upperTheme = (0, _useThemeWithoutDefault.default)(EMPTY_THEME);
    const upperPrivateTheme = (0, _privateTheming.useTheme)() || EMPTY_THEME;
    const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_privateTheming.ThemeProvider, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styledEngine.ThemeContext.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var _default = exports.default = ThemeProvider;

},{"2f0cdb539014f0d4":"kZ6eK","945ee145cb6db818":"fiRIh","f66bdf805eb6a174":"9njXz","a7dc9850114c1c07":"bnNSm","d2b933a117fa27b3":"eHvzD","daa2a36d2d0ccf09":"jInuK","617d81d7a7442614":"9ebNW","44c8f2f530ac38e9":"f7Z9J","31aada5253a2fae2":"ck9Pb","c65b0fe1e1532163":"aF5dK","d40852f22693d112":"1dlk8"}],"f7Z9J":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("22da61490d6d52e6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useThemeWithoutDefault.default;
    }
});
var _useThemeWithoutDefault = _interopRequireDefault(require("f31bbf1bc32a60ae"));

},{"22da61490d6d52e6":"kZ6eK","f31bbf1bc32a60ae":"52wOa"}],"52wOa":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("cb4397c685c1a400").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d565964b4cacfe6d"));
var _styledEngine = require("c6c07bae4e5cb0af");
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
    const contextTheme = React.useContext(_styledEngine.ThemeContext);
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var _default = exports.default = useTheme;

},{"cb4397c685c1a400":"fiRIh","d565964b4cacfe6d":"9njXz","c6c07bae4e5cb0af":"9ebNW"}],"ck9Pb":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("75271e7f0a9be8b8").default;
var _interopRequireWildcard = require("8be47b4a0ee19137").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useRtl = exports.default = void 0;
var React = _interopRequireWildcard(require("9c011c2e93eae9d7"));
var _propTypes = _interopRequireDefault(require("1cdad4212e0b63a6"));
var _jsxRuntime = require("35bc5316f55d23ce");
const RtlContext = /*#__PURE__*/ React.createContext();
function RtlProvider({ value, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const useRtl = ()=>{
    const value = React.useContext(RtlContext);
    return value ?? false;
};
exports.useRtl = useRtl;
var _default = exports.default = RtlProvider;

},{"75271e7f0a9be8b8":"kZ6eK","8be47b4a0ee19137":"fiRIh","9c011c2e93eae9d7":"9njXz","1cdad4212e0b63a6":"bnNSm","35bc5316f55d23ce":"1dlk8"}],"aF5dK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("3212c96339aec0a5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DefaultPropsProvider.default;
    }
});
Object.defineProperty(exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return _DefaultPropsProvider.useDefaultProps;
    }
});
var _DefaultPropsProvider = _interopRequireWildcard(require("2efb2ac9cb89e9ff"));

},{"3212c96339aec0a5":"fiRIh","2efb2ac9cb89e9ff":"ebJGu"}],"ebJGu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("4ce0159cb79f502a").default;
var _interopRequireWildcard = require("337ded59bbe1d92b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.useDefaultProps = useDefaultProps;
var React = _interopRequireWildcard(require("deb15c239d6dfd29"));
var _propTypes = _interopRequireDefault(require("44902174b186aff9"));
var _resolveProps = _interopRequireDefault(require("79e1b19e0eadc3aa"));
var _jsxRuntime = require("899997d347218abd");
const PropsContext = /*#__PURE__*/ React.createContext(undefined);
function DefaultPropsProvider({ value, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropsContext.Provider, {
        value: value,
        children: children
    });
}
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, _resolveProps.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, _resolveProps.default)(config, props);
    return props;
}
function useDefaultProps({ props, name }) {
    const ctx = React.useContext(PropsContext);
    return getThemeProps({
        props,
        name,
        theme: {
            components: ctx
        }
    });
}
var _default = exports.default = DefaultPropsProvider;

},{"4ce0159cb79f502a":"kZ6eK","337ded59bbe1d92b":"fiRIh","deb15c239d6dfd29":"9njXz","44902174b186aff9":"bnNSm","79e1b19e0eadc3aa":"gFBtX","899997d347218abd":"1dlk8"}],"8DcsU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ef652579247cd5d5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_MODE_STORAGE_KEY = exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = exports.DEFAULT_ATTRIBUTE = void 0;
exports.default = InitColorSchemeScript;
var React = _interopRequireWildcard(require("b07e9c9c3771fb3a"));
var _jsxRuntime = require("e1ecb68d89a38c71");
/**
 * Split this component for RSC import
 */ const DEFAULT_MODE_STORAGE_KEY = exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const DEFAULT_COLOR_SCHEME_STORAGE_KEY = exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const DEFAULT_ATTRIBUTE = exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function InitColorSchemeScript(options) {
    const { defaultMode = 'system', defaultLightColorScheme = 'light', defaultDarkColorScheme = 'dark', modeStorageKey = DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey = DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = DEFAULT_ATTRIBUTE, colorSchemeNode = 'document.documentElement', nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

},{"ef652579247cd5d5":"fiRIh","b07e9c9c3771fb3a":"9njXz","e1ecb68d89a38c71":"1dlk8"}],"9ueGc":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c1c40b040dbdc7d5").default;
var _interopRequireWildcard = require("6fc06eaa0ead1cc3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useCurrentColorScheme;
exports.getColorScheme = getColorScheme;
exports.getSystemMode = getSystemMode;
var React = _interopRequireWildcard(require("a1e57bd1e615fdc1"));
var _InitColorSchemeScript = require("54b6e4d95dd85459");
var _localStorageManager = _interopRequireDefault(require("2cdbf5ace57ee651"));
function noop() {}
function getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function getColorScheme(state) {
    return processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function useCurrentColorScheme(options) {
    const { defaultMode = 'light', defaultLightColorScheme, defaultDarkColorScheme, supportedColorSchemes = [], modeStorageKey = _InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey = _InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow = typeof window === 'undefined' ? undefined : window, storageManager = _localStorageManager.default, noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: getSystemMode(initialMode),
            lightColorScheme,
            darkColorScheme
        };
    });
    const [isClient, setIsClient] = React.useState(noSsr || !isMultiSchemes);
    React.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = getColorScheme(state);
    const setMode = React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode,
        setColorScheme
    };
}

},{"c1c40b040dbdc7d5":"kZ6eK","6fc06eaa0ead1cc3":"fiRIh","a1e57bd1e615fdc1":"9njXz","54b6e4d95dd85459":"8DcsU","2cdbf5ace57ee651":"zEDtK"}],"zEDtK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function noop() {}
const localStorageManager = ({ key, storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var _default = exports.default = localStorageManager;

},{}],"dQWqG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e5e8499e17180f19").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("f9d07c742884f482"));
var _cssVarsParser = _interopRequireDefault(require("1bab20d6b631648d"));
function prepareCssVars(theme, parserConfig = {}) {
    const { getSelector = defaultGetSelector, disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes = {}, components, defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, _cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars, css, varsWithDefaults } = (0, _cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, _deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css,
            vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css, vars, varsWithDefaults } = (0, _cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, _deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css,
            vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, _deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars,
        generateStyleSheets
    };
}
var _default = exports.default = prepareCssVars;

},{"e5e8499e17180f19":"kZ6eK","f9d07c742884f482":"7wtTC","1bab20d6b631648d":"jM4Ep"}],"jM4Ep":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.assignNestedKeys = void 0;
exports.default = cssVarsParser;
exports.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ exports.assignNestedKeys = assignNestedKeys;
const walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
exports.walkObjectDeep = walkObjectDeep;
const getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function cssVarsParser(theme, options) {
    const { prefix, shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css,
        vars,
        varsWithDefaults
    };
}

},{}],"iYBuE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = prepareTypographyVars;
function prepareTypographyVars(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

},{}],"fGQiW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("191401da11436a57").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _prepareCssVars = _interopRequireDefault(require("1d6d5d48f41948fe"));
var _getColorSchemeSelector = require("57053e77e0adcb4d");
var _InitColorSchemeScript = require("bd22249bfb50e2b0");
function createCssVarsTheme({ colorSchemeSelector = `[${_InitColorSchemeScript.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, _prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, _getColorSchemeSelector.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
var _default = exports.default = createCssVarsTheme;

},{"191401da11436a57":"kZ6eK","1d6d5d48f41948fe":"dQWqG","57053e77e0adcb4d":"lCjr9","bd22249bfb50e2b0":"8DcsU"}],"lCjr9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createGetColorSchemeSelector = createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

},{}],"e1roB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ebf92742dab40c54").default;
var _interopRequireWildcard = require("7bd85c2d391b9be3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _styleFunctionSx.default;
    }
});
Object.defineProperty(exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return _extendSxProp.default;
    }
});
Object.defineProperty(exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return _styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return _defaultSxConfig.default;
    }
});
var _styleFunctionSx = _interopRequireWildcard(require("a36ab58f22476148"));
var _extendSxProp = _interopRequireDefault(require("2413bd638e69fe83"));
var _defaultSxConfig = _interopRequireDefault(require("465244391337dec0"));

},{"ebf92742dab40c54":"kZ6eK","7bd85c2d391b9be3":"fiRIh","a36ab58f22476148":"2FlmW","2413bd638e69fe83":"BWIBK","465244391337dec0":"fAPQU"}],"2FlmW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c0143919dad125fe").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.unstable_createStyleFunctionSx = unstable_createStyleFunctionSx;
var _capitalize = _interopRequireDefault(require("96896e59929bb199"));
var _merge = _interopRequireDefault(require("474adad98f2fe185"));
var _style = require("657abc912cdf60e4");
var _breakpoints = require("49e436695c9eeb7b");
var _cssContainerQueries = require("788160d5aa5dca63");
var _defaultSxConfig = _interopRequireDefault(require("ecd15981307fab21"));
function objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty = prop, themeKey, transform, style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, _style.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, _style.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, _style.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx, theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? _defaultSxConfig.default;
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, _breakpoints.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, _merge.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, _breakpoints.handleBreakpoints)({
                                theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if (objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme
                            });
                            else css = (0, _merge.default)(css, breakpointsValues);
                        }
                    } else css = (0, _merge.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, _cssContainerQueries.sortContainerQueries)(theme, (0, _breakpoints.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = [
    'sx'
];
var _default = exports.default = styleFunctionSx;

},{"c0143919dad125fe":"kZ6eK","96896e59929bb199":"5sWY4","474adad98f2fe185":"4iLSQ","657abc912cdf60e4":"fiOnV","49e436695c9eeb7b":"1dc0z","788160d5aa5dca63":"9nycZ","ecd15981307fab21":"fAPQU"}],"fAPQU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _spacing = require("c57d76f643a2b254");
var _borders = require("6c964eb5aa743c86");
var _cssGrid = require("10ca837dc3e62cc8");
var _palette = require("d96c52549a7b804d");
var _sizing = require("90d21174e5fb17be");
const defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: _borders.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: _palette.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: _palette.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: _palette.paletteTransform
    },
    // spacing
    p: {
        style: _spacing.padding
    },
    pt: {
        style: _spacing.padding
    },
    pr: {
        style: _spacing.padding
    },
    pb: {
        style: _spacing.padding
    },
    pl: {
        style: _spacing.padding
    },
    px: {
        style: _spacing.padding
    },
    py: {
        style: _spacing.padding
    },
    padding: {
        style: _spacing.padding
    },
    paddingTop: {
        style: _spacing.padding
    },
    paddingRight: {
        style: _spacing.padding
    },
    paddingBottom: {
        style: _spacing.padding
    },
    paddingLeft: {
        style: _spacing.padding
    },
    paddingX: {
        style: _spacing.padding
    },
    paddingY: {
        style: _spacing.padding
    },
    paddingInline: {
        style: _spacing.padding
    },
    paddingInlineStart: {
        style: _spacing.padding
    },
    paddingInlineEnd: {
        style: _spacing.padding
    },
    paddingBlock: {
        style: _spacing.padding
    },
    paddingBlockStart: {
        style: _spacing.padding
    },
    paddingBlockEnd: {
        style: _spacing.padding
    },
    m: {
        style: _spacing.margin
    },
    mt: {
        style: _spacing.margin
    },
    mr: {
        style: _spacing.margin
    },
    mb: {
        style: _spacing.margin
    },
    ml: {
        style: _spacing.margin
    },
    mx: {
        style: _spacing.margin
    },
    my: {
        style: _spacing.margin
    },
    margin: {
        style: _spacing.margin
    },
    marginTop: {
        style: _spacing.margin
    },
    marginRight: {
        style: _spacing.margin
    },
    marginBottom: {
        style: _spacing.margin
    },
    marginLeft: {
        style: _spacing.margin
    },
    marginX: {
        style: _spacing.margin
    },
    marginY: {
        style: _spacing.margin
    },
    marginInline: {
        style: _spacing.margin
    },
    marginInlineStart: {
        style: _spacing.margin
    },
    marginInlineEnd: {
        style: _spacing.margin
    },
    marginBlock: {
        style: _spacing.margin
    },
    marginBlockStart: {
        style: _spacing.margin
    },
    marginBlockEnd: {
        style: _spacing.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: _cssGrid.gap
    },
    rowGap: {
        style: _cssGrid.rowGap
    },
    columnGap: {
        style: _cssGrid.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: _sizing.sizingTransform
    },
    maxWidth: {
        style: _sizing.maxWidth
    },
    minWidth: {
        transform: _sizing.sizingTransform
    },
    height: {
        transform: _sizing.sizingTransform
    },
    maxHeight: {
        transform: _sizing.sizingTransform
    },
    minHeight: {
        transform: _sizing.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var _default = exports.default = defaultSxConfig;

},{"c57d76f643a2b254":"3PKpA","6c964eb5aa743c86":"afjq7","10ca837dc3e62cc8":"3nf7W","d96c52549a7b804d":"cHnmn","90d21174e5fb17be":"7bMrz"}],"afjq7":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("dcce089d5908f568").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _borders.default;
    }
});
var _borders = _interopRequireWildcard(require("5fdcb604265ccfdc"));
Object.keys(_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _borders[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _borders[key];
        }
    });
});

},{"dcce089d5908f568":"fiRIh","5fdcb604265ccfdc":"h03y2"}],"h03y2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e2dc5666a8871a7e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.borderTopColor = exports.borderTop = exports.borderRightColor = exports.borderRight = exports.borderRadius = exports.borderLeftColor = exports.borderLeft = exports.borderColor = exports.borderBottomColor = exports.borderBottom = exports.border = void 0;
exports.borderTransform = borderTransform;
exports.outlineColor = exports.outline = exports.default = void 0;
var _responsivePropType = _interopRequireDefault(require("2c25771648e887a7"));
var _style = _interopRequireDefault(require("c2fb266b8e96749a"));
var _compose = _interopRequireDefault(require("dc05a15740d248e0"));
var _spacing = require("63b2b7100e242903");
var _breakpoints = require("2b87fd0661fd640");
function borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
    return (0, _style.default)({
        prop,
        themeKey: 'borders',
        transform
    });
}
const border = exports.border = createBorderStyle('border', borderTransform);
const borderTop = exports.borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = exports.borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = exports.borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = exports.borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = exports.borderColor = createBorderStyle('borderColor');
const borderTopColor = exports.borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = exports.borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = exports.borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = exports.borderLeftColor = createBorderStyle('borderLeftColor');
const outline = exports.outline = createBorderStyle('outline', borderTransform);
const outlineColor = exports.outlineColor = createBorderStyle('outlineColor');
// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
exports.borderRadius = borderRadius;
borderRadius.propTypes = {};
borderRadius.filterProps = [
    'borderRadius'
];
const borders = (0, _compose.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
var _default = exports.default = borders;

},{"e2dc5666a8871a7e":"kZ6eK","2c25771648e887a7":"bqofx","c2fb266b8e96749a":"fiOnV","dc05a15740d248e0":"cHtKH","63b2b7100e242903":"3PKpA","2b87fd0661fd640":"1dc0z"}],"cHtKH":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3d74380f49397bed").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _compose.default;
    }
});
var _compose = _interopRequireDefault(require("d391cd3bb4012335"));

},{"3d74380f49397bed":"kZ6eK","d391cd3bb4012335":"9Kxq2"}],"9Kxq2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("14e4e4a88d602ae4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("ff50934fa3d5e60e"));
function compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, _merge.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var _default = exports.default = compose;

},{"14e4e4a88d602ae4":"kZ6eK","ff50934fa3d5e60e":"4iLSQ"}],"3nf7W":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5b680ec5197bb2fc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _cssGrid.default;
    }
});
var _cssGrid = _interopRequireWildcard(require("e0b08a3944a6d551"));
Object.keys(_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _cssGrid[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _cssGrid[key];
        }
    });
});

},{"5b680ec5197bb2fc":"fiRIh","e0b08a3944a6d551":"iq1ML"}],"iq1ML":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("300f35d57ddbfa95").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rowGap = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridTemplateAreas = exports.gridRow = exports.gridColumn = exports.gridAutoRows = exports.gridAutoFlow = exports.gridAutoColumns = exports.gridArea = exports.gap = exports.default = exports.columnGap = void 0;
var _style = _interopRequireDefault(require("927191ba8c0c341e"));
var _compose = _interopRequireDefault(require("d75713cdbc0b5233"));
var _spacing = require("55ed5a86f79ad101");
var _breakpoints = require("22f6d220a1401b69");
var _responsivePropType = _interopRequireDefault(require("d3962afb6cf389ca"));
// false positive
// eslint-disable-next-line react/function-component-definition
const gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
exports.gap = gap;
gap.propTypes = {};
gap.filterProps = [
    'gap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
exports.columnGap = columnGap;
columnGap.propTypes = {};
columnGap.filterProps = [
    'columnGap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
exports.rowGap = rowGap;
rowGap.propTypes = {};
rowGap.filterProps = [
    'rowGap'
];
const gridColumn = exports.gridColumn = (0, _style.default)({
    prop: 'gridColumn'
});
const gridRow = exports.gridRow = (0, _style.default)({
    prop: 'gridRow'
});
const gridAutoFlow = exports.gridAutoFlow = (0, _style.default)({
    prop: 'gridAutoFlow'
});
const gridAutoColumns = exports.gridAutoColumns = (0, _style.default)({
    prop: 'gridAutoColumns'
});
const gridAutoRows = exports.gridAutoRows = (0, _style.default)({
    prop: 'gridAutoRows'
});
const gridTemplateColumns = exports.gridTemplateColumns = (0, _style.default)({
    prop: 'gridTemplateColumns'
});
const gridTemplateRows = exports.gridTemplateRows = (0, _style.default)({
    prop: 'gridTemplateRows'
});
const gridTemplateAreas = exports.gridTemplateAreas = (0, _style.default)({
    prop: 'gridTemplateAreas'
});
const gridArea = exports.gridArea = (0, _style.default)({
    prop: 'gridArea'
});
const grid = (0, _compose.default)(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
var _default = exports.default = grid;

},{"300f35d57ddbfa95":"kZ6eK","927191ba8c0c341e":"fiOnV","d75713cdbc0b5233":"cHtKH","55ed5a86f79ad101":"3PKpA","22f6d220a1401b69":"1dc0z","d3962afb6cf389ca":"bqofx"}],"cHnmn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e353c406c441666e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _palette.default;
    }
});
var _palette = _interopRequireWildcard(require("7f0ad3806bebb455"));
Object.keys(_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _palette[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _palette[key];
        }
    });
});

},{"e353c406c441666e":"fiRIh","7f0ad3806bebb455":"eLwhj"}],"eLwhj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("34066a344d8daecf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.color = exports.bgcolor = exports.backgroundColor = void 0;
exports.paletteTransform = paletteTransform;
var _style = _interopRequireDefault(require("c7773e82f050f56b"));
var _compose = _interopRequireDefault(require("779f4fad9951137b"));
function paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const color = exports.color = (0, _style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: paletteTransform
});
const bgcolor = exports.bgcolor = (0, _style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const backgroundColor = exports.backgroundColor = (0, _style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const palette = (0, _compose.default)(color, bgcolor, backgroundColor);
var _default = exports.default = palette;

},{"34066a344d8daecf":"kZ6eK","c7773e82f050f56b":"fiOnV","779f4fad9951137b":"cHtKH"}],"7bMrz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("781c1f35f5805a82").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _sizing.default;
    }
});
var _sizing = _interopRequireWildcard(require("ae93bb06e3e389f4"));
Object.keys(_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _sizing[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _sizing[key];
        }
    });
});

},{"781c1f35f5805a82":"fiRIh","ae93bb06e3e389f4":"dfScd"}],"dfScd":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("149b7315c3e764d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sizeWidth = exports.sizeHeight = exports.minWidth = exports.minHeight = exports.maxWidth = exports.maxHeight = exports.height = exports.default = exports.boxSizing = void 0;
exports.sizingTransform = sizingTransform;
exports.width = void 0;
var _style = _interopRequireDefault(require("dc9f1f09def53b2b"));
var _compose = _interopRequireDefault(require("817e5b138a0e941c"));
var _breakpoints = require("d41bba6b0766ba5d");
function sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = exports.width = (0, _style.default)({
    prop: 'width',
    transform: sizingTransform
});
const maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || _breakpoints.values[propValue];
            if (!breakpoint) return {
                maxWidth: sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
exports.maxWidth = maxWidth;
maxWidth.filterProps = [
    'maxWidth'
];
const minWidth = exports.minWidth = (0, _style.default)({
    prop: 'minWidth',
    transform: sizingTransform
});
const height = exports.height = (0, _style.default)({
    prop: 'height',
    transform: sizingTransform
});
const maxHeight = exports.maxHeight = (0, _style.default)({
    prop: 'maxHeight',
    transform: sizingTransform
});
const minHeight = exports.minHeight = (0, _style.default)({
    prop: 'minHeight',
    transform: sizingTransform
});
const sizeWidth = exports.sizeWidth = (0, _style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: sizingTransform
});
const sizeHeight = exports.sizeHeight = (0, _style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: sizingTransform
});
const boxSizing = exports.boxSizing = (0, _style.default)({
    prop: 'boxSizing'
});
const sizing = (0, _compose.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
var _default = exports.default = sizing;

},{"149b7315c3e764d":"kZ6eK","dc9f1f09def53b2b":"fiOnV","817e5b138a0e941c":"cHtKH","d41bba6b0766ba5d":"1dc0z"}],"BWIBK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("87b2fb8bb141f448").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = extendSxProp;
var _deepmerge = require("5c6e7a57f2743787");
var _defaultSxConfig = _interopRequireDefault(require("b647cc6fd4459669"));
const splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? _defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps, otherProps } = splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, _deepmerge.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

},{"87b2fb8bb141f448":"kZ6eK","5c6e7a57f2743787":"7wtTC","b647cc6fd4459669":"fAPQU"}],"6dGGf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("2be5c52b86d300a3").default;
var _interopRequireDefault = require("d09250cc2407ae04").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _formatMuiErrorMessage = _interopRequireDefault(require("324bf15374e708d7"));
var _deepmerge = _interopRequireDefault(require("1db2837b4d664617"));
var _styleFunctionSx = _interopRequireWildcard(require("a8fc7d7f6962006c"));
var _createTheme = _interopRequireDefault(require("c4069d57bb9862e9"));
var _generateUtilityClass = _interopRequireDefault(require("f6ed377296c1c88b"));
var _createMixins = _interopRequireDefault(require("ee6257c8c4b958e5"));
var _createPalette = _interopRequireDefault(require("6bebf920f741886"));
var _createTypography = _interopRequireDefault(require("81f535204c25291"));
var _shadows = _interopRequireDefault(require("f94cdb124ded91df"));
var _createTransitions = _interopRequireDefault(require("f1c4130ac4e056bb"));
var _zIndex = _interopRequireDefault(require("6fafa75da1a8eb89"));
var _stringifyTheme = require("e4ec04f6efe6b39c");
function createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, _formatMuiErrorMessage.default)(20));
    const palette = (0, _createPalette.default)(paletteInput);
    const systemTheme = (0, _createTheme.default)(options);
    let muiTheme = (0, _deepmerge.default)(systemTheme, {
        mixins: (0, _createMixins.default)(systemTheme.breakpoints, mixinsInput),
        palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: _shadows.default.slice(),
        typography: (0, _createTypography.default)(palette, typographyInput),
        transitions: (0, _createTransitions.default)(transitionsInput),
        zIndex: {
            ..._zIndex.default
        }
    });
    muiTheme = (0, _deepmerge.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, _deepmerge.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ..._styleFunctionSx.unstable_defaultSxConfig,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = _stringifyTheme.stringifyTheme; // for Pigment CSS integration
    return muiTheme;
}
var _default = exports.default = createThemeNoVars;

},{"2be5c52b86d300a3":"fiRIh","d09250cc2407ae04":"kZ6eK","324bf15374e708d7":"gOgzd","1db2837b4d664617":"7wtTC","a8fc7d7f6962006c":"e1roB","c4069d57bb9862e9":"lBucb","f6ed377296c1c88b":"jBs9M","ee6257c8c4b958e5":"kwHUg","6bebf920f741886":"6F39w","81f535204c25291":"7UQh9","f94cdb124ded91df":"bBLf0","f1c4130ac4e056bb":"1PwKJ","6fafa75da1a8eb89":"lU1Yh","e4ec04f6efe6b39c":"f6ZZU"}],"lBucb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("dd1c30bf430b5bba").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _createTheme.default;
    }
});
Object.defineProperty(exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return _createBreakpoints.default;
    }
});
Object.defineProperty(exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return _applyStyles.default;
    }
});
var _createTheme = _interopRequireDefault(require("bdc18df69795eaba"));
var _createBreakpoints = _interopRequireDefault(require("48b86d2ba11b61d7"));
var _applyStyles = _interopRequireDefault(require("a63ca49c1a3790b7"));

},{"dd1c30bf430b5bba":"kZ6eK","bdc18df69795eaba":"crbT4","48b86d2ba11b61d7":"cQVkp","a63ca49c1a3790b7":"jKIbG"}],"crbT4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a7a69b6314ef6820").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("f08de1e574d96be4"));
var _createBreakpoints = _interopRequireDefault(require("fef76d655aaa132e"));
var _cssContainerQueries = _interopRequireDefault(require("83f3137514b70a38"));
var _shape = _interopRequireDefault(require("e487320954df9b05"));
var _createSpacing = _interopRequireDefault(require("4a83e44bc56a5742"));
var _styleFunctionSx = _interopRequireDefault(require("5ae03db25d336f5a"));
var _defaultSxConfig = _interopRequireDefault(require("e9031ccc4da151b1"));
var _applyStyles = _interopRequireDefault(require("555272fc77b24fc5"));
function createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
    const spacing = (0, _createSpacing.default)(spacingInput);
    let muiTheme = (0, _deepmerge.default)({
        breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing,
        shape: {
            ..._shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, _cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = _applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, _deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ..._defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var _default = exports.default = createTheme;

},{"a7a69b6314ef6820":"kZ6eK","f08de1e574d96be4":"7wtTC","fef76d655aaa132e":"cQVkp","83f3137514b70a38":"9nycZ","e487320954df9b05":"kAWBz","4a83e44bc56a5742":"3KIEP","5ae03db25d336f5a":"2FlmW","e9031ccc4da151b1":"fAPQU","555272fc77b24fc5":"jKIbG"}],"kAWBz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const shape = {
    borderRadius: 4
};
var _default = exports.default = shape;

},{}],"3KIEP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createSpacing;
var _spacing = require("2efeaeaa34925f80");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, _spacing.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

},{"2efeaeaa34925f80":"3PKpA"}],"jKIbG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

},{}],"kwHUg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createMixins;
function createMixins(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

},{}],"7UQh9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("54a4af4f31c2ae67").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createTypography;
var _deepmerge = _interopRequireDefault(require("fc5a66aff48a965b"));
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
    textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */ function createTypography(palette, typography) {
    const { fontFamily = defaultFontFamily, // The default font size of the Material Specification.
    fontSize = 14, // px
    fontWeightLight = 300, fontWeightRegular = 400, fontWeightMedium = 500, fontWeightBold = 700, // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily,
            fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === defaultFontFamily ? {
                letterSpacing: `${round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, _deepmerge.default)({
        htmlFontSize,
        pxToRem,
        fontFamily,
        fontSize,
        fontWeightLight,
        fontWeightRegular,
        fontWeightMedium,
        fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

},{"54a4af4f31c2ae67":"kZ6eK","fc5a66aff48a965b":"7wtTC"}],"bBLf0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = [
    'none',
    createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var _default = exports.default = shadows;

},{}],"1PwKJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createTransitions;
exports.easing = exports.duration = void 0;
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const duration = exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function createTransitions(inputTransitions) {
    const mergedEasing = {
        ...easing,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...duration,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration,
        create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

},{}],"lU1Yh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var _default = exports.default = zIndex;

},{}],"f6ZZU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stringifyTheme = stringifyTheme;
var _deepmerge = require("84e05c9c3ee55c0f");
/* eslint-disable import/prefer-default-export */ function isSerializable(val) {
    return (0, _deepmerge.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
/**
 * `baseTheme` usually comes from `createTheme()` or `extendTheme()`.
 *
 * This function is intended to be used with zero-runtime CSS-in-JS like Pigment CSS
 * For example, in a Next.js project:
 *
 * ```js
 * // next.config.js
 * const { extendTheme } = require('@mui/material/styles');
 *
 * const theme = extendTheme();
 * // `.toRuntimeSource` is Pigment CSS specific to create a theme that is available at runtime.
 * theme.toRuntimeSource = stringifyTheme;
 *
 * module.exports = withPigment({
 *  theme,
 * });
 * ```
 */ function stringifyTheme(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, _deepmerge.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

},{"84e05c9c3ee55c0f":"7wtTC"}],"ha33T":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("bc86a7efe9de09c4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createColorScheme;
exports.getOpacity = getOpacity;
exports.getOverlays = getOverlays;
var _createPalette = _interopRequireDefault(require("4b696985e81d4aff"));
var _getOverlayAlpha = _interopRequireDefault(require("82abbabeb8b2dafe"));
const defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, _getOverlayAlpha.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function getOpacity(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function getOverlays(mode) {
    return mode === 'dark' ? defaultDarkOverlays : [];
}
function createColorScheme(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, // need to cast to avoid module augmentation test
    opacity, overlays, ...rest } = options;
    const palette = (0, _createPalette.default)(paletteInput);
    return {
        palette,
        opacity: {
            ...getOpacity(palette.mode),
            ...opacity
        },
        overlays: overlays || getOverlays(palette.mode),
        ...rest
    };
}

},{"bc86a7efe9de09c4":"kZ6eK","4b696985e81d4aff":"6F39w","82abbabeb8b2dafe":"fzJyp"}],"fzJyp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getOverlayAlpha;
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function getOverlayAlpha(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

},{}],"bvQ2q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = shouldSkipGeneratingVar;
function shouldSkipGeneratingVar(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

},{}],"aCAJD":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("79f805c8fa661019").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _excludeVariablesFromRoot = _interopRequireDefault(require("a408096ac81f1ca8"));
var _default = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, _excludeVariablesFromRoot.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };
exports.default = _default;

},{"79f805c8fa661019":"kZ6eK","a408096ac81f1ca8":"efGTY"}],"efGTY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var _default = exports.default = excludeVariablesFromRoot;

},{}],"cgAln":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6f37ace8d03fcbd8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createMuiStrictModeTheme;
var _deepmerge = _interopRequireDefault(require("f94dbf41c5ebf831"));
var _createTheme = _interopRequireDefault(require("33a136564951c9bd"));
function createMuiStrictModeTheme(options, ...args) {
    return (0, _createTheme.default)((0, _deepmerge.default)({
        unstable_strictMode: true
    }, options), ...args);
}

},{"6f37ace8d03fcbd8":"kZ6eK","f94dbf41c5ebf831":"7wtTC","33a136564951c9bd":"iZK2b"}],"7e9nq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStyles;
let warnedOnce = false;
// To remove in v6
function createStyles(styles) {
    if (!warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        warnedOnce = true;
    }
    return styles;
}

},{}],"j89Nf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.alignProperty = alignProperty;
exports.convertLength = convertLength;
exports.fontGrid = fontGrid;
exports.getUnit = getUnit;
exports.isUnitless = isUnitless;
exports.responsiveProperty = responsiveProperty;
exports.toUnitless = toUnitless;
function isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
// Emulate the sass function "unitless"
function toUnitless(length) {
    return parseFloat(length);
}
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = toUnitless(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = toUnitless(length) * toUnitless(baseFontSize);
            else if (fromUnit === 'rem') pxLength = toUnitless(length) * toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / toUnitless(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function alignProperty({ size, grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function fontGrid({ lineHeight, pixels, htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ function responsiveProperty({ cssProperty, min, max, unit = 'rem', breakpoints = [
    600,
    900,
    1200
], transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

},{}],"bLP32":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("139e93f80f91b2b3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = responsiveFontSizes;
var _formatMuiErrorMessage = _interopRequireDefault(require("9670b5a70e093e47"));
var _cssUtils = require("b80d240c64240474");
function responsiveFontSizes(themeInput, options = {}) {
    const { breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign = false, factor = 2, variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = {
        ...themeInput
    };
    theme.typography = {
        ...theme.typography
    };
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, _cssUtils.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight } = style;
        if (!(0, _cssUtils.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, _formatMuiErrorMessage.default)(6));
        if (!(0, _cssUtils.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, _cssUtils.alignProperty)({
                size: value,
                grid: (0, _cssUtils.fontGrid)({
                    pixels: 4,
                    lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = {
            ...style,
            ...(0, _cssUtils.responsiveProperty)({
                cssProperty: 'fontSize',
                min: minFontSize,
                max: maxFontSize,
                unit: 'rem',
                breakpoints: breakpointValues,
                transform
            })
        };
    });
    return theme;
}

},{"139e93f80f91b2b3":"kZ6eK","9670b5a70e093e47":"gOgzd","b80d240c64240474":"j89Nf"}],"7z5Ze":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("feb7b0d36c75e8ae").default;
var _interopRequireWildcard = require("d7efdc309c65aa51").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useTheme;
var React = _interopRequireWildcard(require("24abc77f6a18d374"));
var _system = require("1097140d5166aa72");
var _defaultTheme = _interopRequireDefault(require("7139b85163eb890c"));
var _identifier = _interopRequireDefault(require("43499a47b97c1e50"));
function useTheme() {
    const theme = (0, _system.useTheme)(_defaultTheme.default);
    return theme[_identifier.default] || theme;
}

},{"feb7b0d36c75e8ae":"kZ6eK","d7efdc309c65aa51":"fiRIh","24abc77f6a18d374":"9njXz","1097140d5166aa72":"iFfXs","7139b85163eb890c":"053Do","43499a47b97c1e50":"gf60V"}],"053Do":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9e81faa37b5c64f5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createTheme = _interopRequireDefault(require("d0642249581d7a3c"));
const defaultTheme = (0, _createTheme.default)();
var _default = exports.default = defaultTheme;

},{"9e81faa37b5c64f5":"kZ6eK","d0642249581d7a3c":"iZK2b"}],"bvzB4":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("3bcd8afdf87699f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useThemeProps;
var _useThemeProps = _interopRequireDefault(require("717d09d63c8bb484"));
var _defaultTheme = _interopRequireDefault(require("8d648479469771e0"));
var _identifier = _interopRequireDefault(require("89a7c93b623a491f"));
function useThemeProps({ props, name }) {
    return (0, _useThemeProps.default)({
        props,
        name,
        defaultTheme: _defaultTheme.default,
        themeId: _identifier.default
    });
}

},{"3bcd8afdf87699f":"kZ6eK","717d09d63c8bb484":"tiL16","8d648479469771e0":"053Do","89a7c93b623a491f":"gf60V"}],"tiL16":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1c909ce09236dc56").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useThemeProps.default;
    }
});
Object.defineProperty(exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return _getThemeProps.default;
    }
});
var _useThemeProps = _interopRequireDefault(require("9ae2857601959f0a"));
var _getThemeProps = _interopRequireDefault(require("a3e4fe27a5e6a7f4"));

},{"1c909ce09236dc56":"kZ6eK","9ae2857601959f0a":"gXXn1","a3e4fe27a5e6a7f4":"gRUxU"}],"gXXn1":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("267804c15a5e3f7a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useThemeProps;
var _getThemeProps = _interopRequireDefault(require("dc2d62e4900991ca"));
var _useTheme = _interopRequireDefault(require("ebc6b593badac40c"));
function useThemeProps({ props, name, defaultTheme, themeId }) {
    let theme = (0, _useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, _getThemeProps.default)({
        theme,
        name,
        props
    });
}

},{"267804c15a5e3f7a":"kZ6eK","dc2d62e4900991ca":"gRUxU","ebc6b593badac40c":"jem9R"}],"gRUxU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("76bf39b56103a8b1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getThemeProps;
var _resolveProps = _interopRequireDefault(require("a769613b6a670c93"));
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, _resolveProps.default)(theme.components[name].defaultProps, props);
}

},{"76bf39b56103a8b1":"kZ6eK","a769613b6a670c93":"gFBtX"}],"jem9R":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a2c0d6dcb9e05d5e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useTheme.default;
    }
});
var _useTheme = _interopRequireWildcard(require("1e8d72b9c5b75a36"));
Object.keys(_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _useTheme[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useTheme[key];
        }
    });
});

},{"a2c0d6dcb9e05d5e":"fiRIh","1e8d72b9c5b75a36":"1MgoD"}],"1MgoD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("56d9c0ef8420c115").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.systemDefaultTheme = exports.default = void 0;
var _createTheme = _interopRequireDefault(require("828191d9ac14be9d"));
var _useThemeWithoutDefault = _interopRequireDefault(require("844ae56d568ac095"));
const systemDefaultTheme = exports.systemDefaultTheme = (0, _createTheme.default)();
function useTheme(defaultTheme = systemDefaultTheme) {
    return (0, _useThemeWithoutDefault.default)(defaultTheme);
}
var _default = exports.default = useTheme;

},{"56d9c0ef8420c115":"kZ6eK","828191d9ac14be9d":"lBucb","844ae56d568ac095":"f7Z9J"}],"iVEGR":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("d99545a5d902388c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
Object.defineProperty(exports, "rootShouldForwardProp", {
    enumerable: true,
    get: function() {
        return _rootShouldForwardProp.default;
    }
});
Object.defineProperty(exports, "slotShouldForwardProp", {
    enumerable: true,
    get: function() {
        return _slotShouldForwardProp.default;
    }
});
var _createStyled = _interopRequireDefault(require("d8aa72cfc340448f"));
var _defaultTheme = _interopRequireDefault(require("90774924bbe70948"));
var _identifier = _interopRequireDefault(require("687442fc376fa303"));
var _rootShouldForwardProp = _interopRequireDefault(require("7cd03bbdf15d8385"));
var _slotShouldForwardProp = _interopRequireDefault(require("224cb946ee7cdb91"));
const styled = (0, _createStyled.default)({
    themeId: _identifier.default,
    defaultTheme: _defaultTheme.default,
    rootShouldForwardProp: _rootShouldForwardProp.default
});
var _default = exports.default = styled;

},{"d99545a5d902388c":"kZ6eK","d8aa72cfc340448f":"6ySdS","90774924bbe70948":"053Do","687442fc376fa303":"gf60V","7cd03bbdf15d8385":"bTxRc","224cb946ee7cdb91":"94KY1"}],"6ySdS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("d3fcf02e78575e2e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _createStyled.default;
    }
});
var _createStyled = _interopRequireWildcard(require("5f89072a663e921"));
Object.keys(_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _createStyled[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _createStyled[key];
        }
    });
});

},{"d3fcf02e78575e2e":"fiRIh","5f89072a663e921":"ac1i8"}],"ac1i8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6133cdf82f560f08").default;
var _interopRequireWildcard = require("b44a5c6928314bca").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStyled;
exports.shouldForwardProp = shouldForwardProp;
exports.systemDefaultTheme = void 0;
var _styledEngine = _interopRequireWildcard(require("766c6067aca00c60"));
var _deepmerge = require("769865f2cfbbcf39");
var _capitalize = _interopRequireDefault(require("172c5cc1504f511f"));
var _getDisplayName = _interopRequireDefault(require("8c6347b34f380bc1"));
var _createTheme = _interopRequireDefault(require("332771a3a6457326"));
var _styleFunctionSx = _interopRequireDefault(require("6d6fee53ff3c0e51"));
var _preprocessStyles = _interopRequireDefault(require("ac41deb8895ce74c"));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const systemDefaultTheme = exports.systemDefaultTheme = (0, _createTheme.default)();
// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function attachTheme(props, themeId, defaultTheme) {
    props.theme = isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function createStyled(input = {}) {
    const { themeId, defaultTheme = systemDefaultTheme, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
    function styleAttachTheme(props) {
        attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, _styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== _styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if (isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, _styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return processStyle(props, style);
            };
            if ((0, _deepmerge.isPlainObject)(style)) {
                const serialized = (0, _preprocessStyles.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push(_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, _capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, _getDisplayName.default)(tag)})`;
}
function generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

},{"6133cdf82f560f08":"kZ6eK","b44a5c6928314bca":"fiRIh","766c6067aca00c60":"9ebNW","769865f2cfbbcf39":"7wtTC","172c5cc1504f511f":"5sWY4","8c6347b34f380bc1":"aDEY1","332771a3a6457326":"lBucb","6d6fee53ff3c0e51":"e1roB","ac41deb8895ce74c":"b8rSc"}],"b8rSc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = preprocessStyles;
var _styledEngine = require("83fa6b8ae50c7fe5");
function preprocessStyles(input) {
    const { variants, ...style } = input;
    const result = {
        variants,
        style: (0, _styledEngine.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, _styledEngine.internal_serializeStyles)(variant.style);
    });
    return result;
}

},{"83fa6b8ae50c7fe5":"9ebNW"}],"bTxRc":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8ce119b503ea7b7e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _slotShouldForwardProp = _interopRequireDefault(require("4a756d072331bfaa"));
const rootShouldForwardProp = (prop)=>(0, _slotShouldForwardProp.default)(prop) && prop !== 'classes';
var _default = exports.default = rootShouldForwardProp;

},{"8ce119b503ea7b7e":"kZ6eK","4a756d072331bfaa":"94KY1"}],"94KY1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
// copied from @mui/system/createStyled
function slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var _default = exports.default = slotShouldForwardProp;

},{}],"8AJZZ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("433d71143f0fcdaf").default;
var _interopRequireWildcard = require("b270c52e5b84c8ad").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ThemeProvider;
var React = _interopRequireWildcard(require("ed9d5db07fd3d386"));
var _ThemeProviderNoVars = _interopRequireDefault(require("d43ab048e22224e4"));
var _ThemeProviderWithVars = require("8d980353a70b90ed");
var _identifier = _interopRequireDefault(require("301d3a29f2c3b0c7"));
var _jsxRuntime = require("66cae6dc6416891c");
function ThemeProvider({ theme, ...props }) {
    const noVarsTheme = React.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = _identifier.default in theme ? theme[_identifier.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ThemeProviderNoVars.default, {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ThemeProviderWithVars.CssVarsProvider, {
        theme: theme,
        ...props
    });
}

},{"433d71143f0fcdaf":"kZ6eK","b270c52e5b84c8ad":"fiRIh","ed9d5db07fd3d386":"9njXz","d43ab048e22224e4":"9Ff5A","8d980353a70b90ed":"8j0rW","301d3a29f2c3b0c7":"gf60V","66cae6dc6416891c":"1dlk8"}],"9Ff5A":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("3e74b5da036ee91").default;
var _interopRequireWildcard = require("ebad3fdc5b5ed248").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ThemeProviderNoVars;
var React = _interopRequireWildcard(require("2fd8b94ea43b1eef"));
var _system = require("cdf7e555dbd00f83");
var _identifier = _interopRequireDefault(require("30b665409c125e55"));
var _jsxRuntime = require("ebf5484447691946");
function ThemeProviderNoVars({ theme: themeInput, ...props }) {
    const scopedTheme = _identifier.default in themeInput ? themeInput[_identifier.default] : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_system.ThemeProvider, {
        ...props,
        themeId: scopedTheme ? _identifier.default : undefined,
        theme: scopedTheme || themeInput
    });
}

},{"3e74b5da036ee91":"kZ6eK","ebad3fdc5b5ed248":"fiRIh","2fd8b94ea43b1eef":"9njXz","cdf7e555dbd00f83":"iFfXs","30b665409c125e55":"gf60V","ebf5484447691946":"1dlk8"}],"8j0rW":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("cd19e8039a6f1a60").default;
var _interopRequireWildcard = require("bbd879f63ed01aa2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CssVarsProvider = void 0;
exports.Experimental_CssVarsProvider = Experimental_CssVarsProvider;
exports.useColorScheme = exports.getInitColorSchemeScript = void 0;
var React = _interopRequireWildcard(require("cfbea76cbf8b162"));
var _styleFunctionSx = _interopRequireDefault(require("9fbcbdc79d259dbf"));
var _system = require("b3d4e8b78ec3a206");
var _createTheme = _interopRequireDefault(require("41d7f910ce792a63"));
var _createTypography = _interopRequireDefault(require("f9cae58df76cc598"));
var _identifier = _interopRequireDefault(require("c50fbd004b592cc"));
var _InitColorSchemeScript = require("5b87086df4521fe2");
var _jsxRuntime = require("de14be8af1e4e46c");
const { CssVarsProvider: InternalCssVarsProvider, useColorScheme, getInitColorSchemeScript: deprecatedGetInitColorSchemeScript } = (0, _system.unstable_createCssVarsProvider)({
    themeId: _identifier.default,
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, _createTheme.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: _InitColorSchemeScript.defaultConfig.colorSchemeStorageKey,
    modeStorageKey: _InitColorSchemeScript.defaultConfig.modeStorageKey,
    defaultColorScheme: {
        light: _InitColorSchemeScript.defaultConfig.defaultLightColorScheme,
        dark: _InitColorSchemeScript.defaultConfig.defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, _createTypography.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, _styleFunctionSx.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
exports.useColorScheme = useColorScheme;
let warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function Experimental_CssVarsProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalCssVarsProvider, {
        ...props
    });
}
let warnedInitScriptOnce = false;
// TODO: remove in v7
const getInitColorSchemeScript = (params)=>{
    if (!warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        warnedInitScriptOnce = true;
    }
    return deprecatedGetInitColorSchemeScript(params);
};
/**
 * TODO: remove this export in v7
 * @deprecated
 * The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
 *
 * You should use `ThemeProvider` and `createTheme()` instead:
 *
 * ```diff
 * - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
 * + import { ThemeProvider, createTheme } from '@mui/material/styles';
 *
 * - const theme = extendTheme();
 * + const theme = createTheme({
 * +   cssVariables: true,
 * +   colorSchemes: { light: true, dark: true },
 * + });
 *
 * - <CssVarsProvider theme={theme}>
 * + <ThemeProvider theme={theme}>
 * ```
 *
 * To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
 */ exports.getInitColorSchemeScript = getInitColorSchemeScript;
const CssVarsProvider = exports.CssVarsProvider = InternalCssVarsProvider;

},{"cd19e8039a6f1a60":"kZ6eK","bbd879f63ed01aa2":"fiRIh","cfbea76cbf8b162":"9njXz","9fbcbdc79d259dbf":"e1roB","b3d4e8b78ec3a206":"iFfXs","41d7f910ce792a63":"iZK2b","f9cae58df76cc598":"7UQh9","c50fbd004b592cc":"gf60V","5b87086df4521fe2":"eWVUC","de14be8af1e4e46c":"1dlk8"}],"eWVUC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a33605f43325825e").default;
var _interopRequireWildcard = require("15198445b8335617").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultConfig = exports.default = void 0;
var React = _interopRequireWildcard(require("46377c2e2918da93"));
var _propTypes = _interopRequireDefault(require("a6eb16577b32ed35"));
var _InitColorSchemeScript = _interopRequireDefault(require("667e1fde5c9bcab2"));
var _jsxRuntime = require("b8bd4967a49dc614");
const defaultConfig = exports.defaultConfig = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function InitColorSchemeScript(props) {
    const { defaultMode = 'system', defaultLightColorScheme = defaultConfig.defaultLightColorScheme, defaultDarkColorScheme = defaultConfig.defaultDarkColorScheme, modeStorageKey = defaultConfig.modeStorageKey, colorSchemeStorageKey = defaultConfig.colorSchemeStorageKey, attribute: initialAttribute = defaultConfig.attribute, colorSchemeNode = 'document.documentElement', nonce } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InitColorSchemeScript.default, {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var _default = exports.default = InitColorSchemeScript;

},{"a33605f43325825e":"kZ6eK","15198445b8335617":"fiRIh","46377c2e2918da93":"9njXz","a6eb16577b32ed35":"bnNSm","667e1fde5c9bcab2":"7Wnxw","b8bd4967a49dc614":"1dlk8"}],"7Wnxw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("68a81deed96e3567").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _InitColorSchemeScript.default;
    }
});
var _InitColorSchemeScript = _interopRequireDefault(require("cf35a495af265f47"));

},{"68a81deed96e3567":"kZ6eK","cf35a495af265f47":"8DcsU"}],"bodjk":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6ed35b9acf3cfd1f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = makeStyles;
var _formatMuiErrorMessage = _interopRequireDefault(require("6edeb122b8a28faa"));
function makeStyles() {
    throw new Error((0, _formatMuiErrorMessage.default)(14));
}

},{"6ed35b9acf3cfd1f":"kZ6eK","6edeb122b8a28faa":"gOgzd"}],"3X7DX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e494373cc6e4d212").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = withStyles;
var _formatMuiErrorMessage = _interopRequireDefault(require("164c15fd614691c1"));
function withStyles() {
    throw new Error((0, _formatMuiErrorMessage.default)(15));
}

},{"e494373cc6e4d212":"kZ6eK","164c15fd614691c1":"gOgzd"}],"2Jr4W":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("49f91e14d50a3bec").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = withTheme;
var _formatMuiErrorMessage = _interopRequireDefault(require("1385e2a734dd1d92"));
function withTheme() {
    throw new Error((0, _formatMuiErrorMessage.default)(16));
}

},{"49f91e14d50a3bec":"kZ6eK","1385e2a734dd1d92":"gOgzd"}],"hheP7":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("dfaaa5204740acdc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deprecatedExtendTheme;
var _createThemeWithVars = _interopRequireDefault(require("96e6da5092958cff"));
let warnedOnce = false;
function deprecatedExtendTheme(...args) {
    if (!warnedOnce) {
        console.warn([
            'MUI: The `experimental_extendTheme` has been stabilized.',
            '',
            "You should use `import { extendTheme } from '@mui/material/styles'`"
        ].join('\n'));
        warnedOnce = true;
    }
    return (0, _createThemeWithVars.default)(...args);
}

},{"dfaaa5204740acdc":"kZ6eK","96e6da5092958cff":"lPCHl"}],"3P50g":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("afcca6353909f959").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _generateUtilityClasses = _interopRequireDefault(require("7599f54375402750"));
const boxClasses = (0, _generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var _default = exports.default = boxClasses;

},{"afcca6353909f959":"kZ6eK","7599f54375402750":"7pSUk"}],"488As":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("df90105f43a3022a").default;
var _interopRequireDefault = require("347f8d13bd9af1df").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    iconButtonClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _IconButton.default;
    }
});
Object.defineProperty(exports, "iconButtonClasses", {
    enumerable: true,
    get: function() {
        return _iconButtonClasses.default;
    }
});
var _IconButton = _interopRequireDefault(require("fa270df85175ca33"));
var _iconButtonClasses = _interopRequireWildcard(require("56c80b4380d2b01b"));
Object.keys(_iconButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _iconButtonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _iconButtonClasses[key];
        }
    });
});

},{"df90105f43a3022a":"fiRIh","347f8d13bd9af1df":"kZ6eK","fa270df85175ca33":"dUu1x","56c80b4380d2b01b":"1EE51"}],"dUu1x":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5cb0526ccac645d4").default;
var _interopRequireWildcard = require("39a6f67351a12d79").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("ec4640ca6004c4bf"));
var _propTypes = _interopRequireDefault(require("4293ad2b7418a265"));
var _clsx = _interopRequireDefault(require("fcdc664994514088"));
var _chainPropTypes = _interopRequireDefault(require("644fa45b8c61f712"));
var _composeClasses = _interopRequireDefault(require("599b5090fa6fb595"));
var _colorManipulator = require("c51fa1f1ba50030c");
var _utils = require("5042f57fb185a269");
var _zeroStyled = require("b0089633db8b5837");
var _memoTheme = _interopRequireDefault(require("bff7a486408c477d"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("731e8f97b9229f64"));
var _DefaultPropsProvider = require("b6dc0c7b031dbfbb");
var _ButtonBase = _interopRequireDefault(require("7edb82dce9d803bc"));
var _CircularProgress = _interopRequireDefault(require("fb7ae26e8c733b6"));
var _capitalize = _interopRequireDefault(require("e370d1f7d0964609"));
var _iconButtonClasses = _interopRequireWildcard(require("75be6d8641c68bd2"));
var _jsxRuntime = require("352154b376e42346");
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, color, edge, size, loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, _capitalize.default)(color)}`,
            edge && `edge${(0, _capitalize.default)(edge)}`,
            `size${(0, _capitalize.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, _composeClasses.default)(slots, _iconButtonClasses.getIconButtonUtilityClass, classes);
};
const IconButtonRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, _capitalize.default)(ownerState.edge)}`],
            styles[`size${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, _memoTheme.default)(({ theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${_iconButtonClasses.default.disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${_iconButtonClasses.default.loading}`]: {
            color: 'transparent'
        }
    })));
const IconButtonLoadingIndicator = (0, _zeroStyled.styled)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const IconButton = /*#__PURE__*/ React.forwardRef(function IconButton(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge = false, children, className, color = 'default', disabled = false, disableFocusRipple = false, size = 'medium', id: idProp, loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, _utils.unstable_useId)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CircularProgress.default, {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge,
        color,
        disabled,
        disableFocusRipple,
        loading,
        loadingIndicator,
        size
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, _clsx.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, _jsxRuntime.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var _default = exports.default = IconButton;

},{"5cb0526ccac645d4":"kZ6eK","39a6f67351a12d79":"fiRIh","ec4640ca6004c4bf":"9njXz","4293ad2b7418a265":"bnNSm","fcdc664994514088":"d2NWs","644fa45b8c61f712":"4stnp","599b5090fa6fb595":"59Equ","c51fa1f1ba50030c":"hTYBL","5042f57fb185a269":"dEMJk","b0089633db8b5837":"hZXDo","bff7a486408c477d":"cJNjb","731e8f97b9229f64":"2r5WG","b6dc0c7b031dbfbb":"9bD8g","7edb82dce9d803bc":"7X8rf","fb7ae26e8c733b6":"kEtIR","e370d1f7d0964609":"eOYSA","75be6d8641c68bd2":"1EE51","352154b376e42346":"1dlk8"}],"4stnp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("bb36807493304a1c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _chainPropTypes.default;
    }
});
var _chainPropTypes = _interopRequireDefault(require("a1c6b87a39fc11ab"));

},{"bb36807493304a1c":"kZ6eK","a1c6b87a39fc11ab":"cuXr0"}],"cuXr0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = chainPropTypes;
function chainPropTypes(propType1, propType2) {
    return ()=>null;
}

},{}],"dEMJk":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a591c4d3ab4dfeda").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "capitalize", {
    enumerable: true,
    get: function() {
        return _capitalize.default;
    }
});
Object.defineProperty(exports, "createChainedFunction", {
    enumerable: true,
    get: function() {
        return _createChainedFunction.default;
    }
});
Object.defineProperty(exports, "createSvgIcon", {
    enumerable: true,
    get: function() {
        return _createSvgIcon.default;
    }
});
Object.defineProperty(exports, "debounce", {
    enumerable: true,
    get: function() {
        return _debounce.default;
    }
});
Object.defineProperty(exports, "deprecatedPropType", {
    enumerable: true,
    get: function() {
        return _deprecatedPropType.default;
    }
});
Object.defineProperty(exports, "isMuiElement", {
    enumerable: true,
    get: function() {
        return _isMuiElement.default;
    }
});
Object.defineProperty(exports, "mergeSlotProps", {
    enumerable: true,
    get: function() {
        return _mergeSlotProps.default;
    }
});
Object.defineProperty(exports, "ownerDocument", {
    enumerable: true,
    get: function() {
        return _ownerDocument.default;
    }
});
Object.defineProperty(exports, "ownerWindow", {
    enumerable: true,
    get: function() {
        return _ownerWindow.default;
    }
});
Object.defineProperty(exports, "requirePropFactory", {
    enumerable: true,
    get: function() {
        return _requirePropFactory.default;
    }
});
Object.defineProperty(exports, "setRef", {
    enumerable: true,
    get: function() {
        return _setRef.default;
    }
});
exports.unstable_ClassNameGenerator = void 0;
Object.defineProperty(exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return _memoTheme.default;
    }
});
Object.defineProperty(exports, "unstable_useEnhancedEffect", {
    enumerable: true,
    get: function() {
        return _useEnhancedEffect.default;
    }
});
Object.defineProperty(exports, "unstable_useId", {
    enumerable: true,
    get: function() {
        return _useId.default;
    }
});
Object.defineProperty(exports, "unsupportedProp", {
    enumerable: true,
    get: function() {
        return _unsupportedProp.default;
    }
});
Object.defineProperty(exports, "useControlled", {
    enumerable: true,
    get: function() {
        return _useControlled.default;
    }
});
Object.defineProperty(exports, "useEventCallback", {
    enumerable: true,
    get: function() {
        return _useEventCallback.default;
    }
});
Object.defineProperty(exports, "useForkRef", {
    enumerable: true,
    get: function() {
        return _useForkRef.default;
    }
});
var _ClassNameGenerator = _interopRequireDefault(require("e2720a033a4a6f1"));
var _capitalize = _interopRequireDefault(require("a3a21027b353816"));
var _createChainedFunction = _interopRequireDefault(require("c4c8f6998e37e707"));
var _createSvgIcon = _interopRequireDefault(require("74c6d2a0c4d331ca"));
var _debounce = _interopRequireDefault(require("2325201ba499a963"));
var _deprecatedPropType = _interopRequireDefault(require("361da9d5569a62a1"));
var _isMuiElement = _interopRequireDefault(require("1c7dc562c03cb50f"));
var _memoTheme = _interopRequireDefault(require("64febfa2f1f145bd"));
var _ownerDocument = _interopRequireDefault(require("18acc2fc9d676182"));
var _ownerWindow = _interopRequireDefault(require("49f223cff4f82f73"));
var _requirePropFactory = _interopRequireDefault(require("f2974ee97d34f30a"));
var _setRef = _interopRequireDefault(require("66a43b528e3ececa"));
var _useEnhancedEffect = _interopRequireDefault(require("55860ec665b38ef8"));
var _useId = _interopRequireDefault(require("9082778d133e9820"));
var _unsupportedProp = _interopRequireDefault(require("5f8e6b5b1acca6a7"));
var _useControlled = _interopRequireDefault(require("7ddbc474a1572a73"));
var _useEventCallback = _interopRequireDefault(require("1099941288fc705d"));
var _useForkRef = _interopRequireDefault(require("b11268c21d014fae"));
var _mergeSlotProps = _interopRequireDefault(require("180c57249b09195b"));
// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_ClassNameGenerator = exports.unstable_ClassNameGenerator = {
    configure: (generator)=>{
        _ClassNameGenerator.default.configure(generator);
    }
};

},{"a591c4d3ab4dfeda":"kZ6eK","e2720a033a4a6f1":"eyH7A","a3a21027b353816":"eOYSA","c4c8f6998e37e707":"lSQGp","74c6d2a0c4d331ca":"5sni0","2325201ba499a963":"bjUwl","361da9d5569a62a1":"a2Gdk","1c7dc562c03cb50f":"cF7sw","64febfa2f1f145bd":"cJNjb","18acc2fc9d676182":"1juJZ","49f223cff4f82f73":"lHNEW","f2974ee97d34f30a":"9hSkv","66a43b528e3ececa":"9pnGz","55860ec665b38ef8":"9wMvV","9082778d133e9820":"hOkl4","5f8e6b5b1acca6a7":"4ygWT","7ddbc474a1572a73":"2pWHX","1099941288fc705d":"9mQKD","b11268c21d014fae":"64cM2","180c57249b09195b":"8LtAL"}],"eOYSA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("423160055c093a91").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _capitalize = _interopRequireDefault(require("8095b576b96d0bd2"));
var _default = exports.default = _capitalize.default;

},{"423160055c093a91":"kZ6eK","8095b576b96d0bd2":"5sWY4"}],"lSQGp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4f5e2ba08f6b6c5f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createChainedFunction = _interopRequireDefault(require("22f2dc27c223cf7c"));
var _default = exports.default = _createChainedFunction.default;

},{"4f5e2ba08f6b6c5f":"kZ6eK","22f2dc27c223cf7c":"hSI0h"}],"hSI0h":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("79901e6f5e514c7e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _createChainedFunction.default;
    }
});
var _createChainedFunction = _interopRequireDefault(require("514b1bcfafb9a895"));

},{"79901e6f5e514c7e":"kZ6eK","514b1bcfafb9a895":"lnqb6"}],"lnqb6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createChainedFunction;
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

},{}],"5sni0":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("742fe9470a1cd84a").default;
var _interopRequireWildcard = require("1ea8e1ac27f005d9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createSvgIcon;
var React = _interopRequireWildcard(require("491ef7516f17432d"));
var _SvgIcon = _interopRequireDefault(require("4d6fdb062d666736"));
var _jsxRuntime = require("adccdf23df3fb541");
/**
 * Private module reserved for @mui packages.
 */ function createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SvgIcon.default, {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = _SvgIcon.default.muiName;
    return /*#__PURE__*/ React.memo(/*#__PURE__*/ React.forwardRef(Component));
}

},{"742fe9470a1cd84a":"kZ6eK","1ea8e1ac27f005d9":"fiRIh","491ef7516f17432d":"9njXz","4d6fdb062d666736":"4LtRe","adccdf23df3fb541":"1dlk8"}],"4LtRe":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("cdb65df936171f0e").default;
var _interopRequireDefault = require("3d06025143d4e55b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    svgIconClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _SvgIcon.default;
    }
});
Object.defineProperty(exports, "svgIconClasses", {
    enumerable: true,
    get: function() {
        return _svgIconClasses.default;
    }
});
var _SvgIcon = _interopRequireDefault(require("71838f8edf73a458"));
var _svgIconClasses = _interopRequireWildcard(require("35fc8f464fe4ed"));
Object.keys(_svgIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _svgIconClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _svgIconClasses[key];
        }
    });
});

},{"cdb65df936171f0e":"fiRIh","3d06025143d4e55b":"kZ6eK","71838f8edf73a458":"lSXhl","35fc8f464fe4ed":"8YJoq"}],"lSXhl":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b1c459c1454002de").default;
var _interopRequireWildcard = require("cdabeb0a9a8aacc9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("856b050480cbadcd"));
var _propTypes = _interopRequireDefault(require("185b836c89796c2"));
var _clsx = _interopRequireDefault(require("6ff052a76200a994"));
var _composeClasses = _interopRequireDefault(require("906db4ecb02596a3"));
var _capitalize = _interopRequireDefault(require("d088ca0acc34864e"));
var _zeroStyled = require("c1973db040dc31f6");
var _memoTheme = _interopRequireDefault(require("f30c3e16f4b9ac7b"));
var _DefaultPropsProvider = require("1634bd342f4e5520");
var _svgIconClasses = require("e4164114afe249ba");
var _jsxRuntime = require("8f0a852eb4418f43");
const useUtilityClasses = (ownerState)=>{
    const { color, fontSize, classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, _capitalize.default)(color)}`,
            `fontSize${(0, _capitalize.default)(fontSize)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _svgIconClasses.getSvgIconUtilityClass, classes);
};
const SvgIconRoot = (0, _zeroStyled.styled)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, _capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const SvgIcon = /*#__PURE__*/ React.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children, className, color = 'inherit', component = 'svg', fontSize = 'medium', htmlColor, inheritViewBox = false, titleAccess, viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ React.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color,
        component,
        fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox,
        viewBox,
        hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SvgIconRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
SvgIcon.muiName = 'SvgIcon';
var _default = exports.default = SvgIcon;

},{"b1c459c1454002de":"kZ6eK","cdabeb0a9a8aacc9":"fiRIh","856b050480cbadcd":"9njXz","185b836c89796c2":"bnNSm","6ff052a76200a994":"d2NWs","906db4ecb02596a3":"59Equ","d088ca0acc34864e":"eOYSA","c1973db040dc31f6":"hZXDo","f30c3e16f4b9ac7b":"cJNjb","1634bd342f4e5520":"9bD8g","e4164114afe249ba":"8YJoq","8f0a852eb4418f43":"1dlk8"}],"hZXDo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("576d998afe566c4c").default;
var _interopRequireWildcard = require("692bf23ee293f6e2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "css", {
    enumerable: true,
    get: function() {
        return _system.css;
    }
});
exports.globalCss = globalCss;
exports.internal_createExtendSxProp = internal_createExtendSxProp;
Object.defineProperty(exports, "keyframes", {
    enumerable: true,
    get: function() {
        return _system.keyframes;
    }
});
Object.defineProperty(exports, "styled", {
    enumerable: true,
    get: function() {
        return _styled.default;
    }
});
Object.defineProperty(exports, "useTheme", {
    enumerable: true,
    get: function() {
        return _useTheme.default;
    }
});
var React = _interopRequireWildcard(require("cbaeb174681314d2"));
var _styleFunctionSx = require("6641156fcd46c33d");
var _useTheme = _interopRequireDefault(require("c93ad108ee9bf40b"));
var _GlobalStyles = _interopRequireDefault(require("f49643ef56a032f2"));
var _jsxRuntime = require("bb304d39f7ef63a6");
var _system = require("4d65fbea719987c3");
var _styled = _interopRequireDefault(require("301db0d6f7301b2a"));
function globalCss(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, _jsxRuntime.jsx)(_GlobalStyles.default, {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme,
                    ...props
                }) : styles
        }));
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function internal_createExtendSxProp() {
    return _styleFunctionSx.extendSxProp;
}

},{"576d998afe566c4c":"kZ6eK","692bf23ee293f6e2":"fiRIh","cbaeb174681314d2":"9njXz","6641156fcd46c33d":"e1roB","c93ad108ee9bf40b":"7z5Ze","f49643ef56a032f2":"3lonT","bb304d39f7ef63a6":"1dlk8","4d65fbea719987c3":"iFfXs","301db0d6f7301b2a":"iVEGR"}],"3lonT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("91860b976275214f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _GlobalStyles.default;
    }
});
var _GlobalStyles = _interopRequireDefault(require("a4a777eb8a922a24"));

},{"91860b976275214f":"kZ6eK","a4a777eb8a922a24":"lwBff"}],"lwBff":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e196e562189bb01a").default;
var _interopRequireWildcard = require("d27a1071210137cb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("1748127d1d9b3bbe"));
var _propTypes = _interopRequireDefault(require("42360b37a8eb8c85"));
var _system = require("e83c0c49557b60a6");
var _defaultTheme = _interopRequireDefault(require("3024cba8f65311fc"));
var _identifier = _interopRequireDefault(require("17cb2205744e072a"));
var _jsxRuntime = require("8e0067399bf001fa");
function GlobalStyles(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_system.GlobalStyles, {
        ...props,
        defaultTheme: _defaultTheme.default,
        themeId: _identifier.default
    });
}
var _default = exports.default = GlobalStyles;

},{"e196e562189bb01a":"kZ6eK","d27a1071210137cb":"fiRIh","1748127d1d9b3bbe":"9njXz","42360b37a8eb8c85":"bnNSm","e83c0c49557b60a6":"iFfXs","3024cba8f65311fc":"053Do","17cb2205744e072a":"gf60V","8e0067399bf001fa":"1dlk8"}],"cJNjb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _system = require("1c694d6de33a9a08");
const memoTheme = _system.unstable_memoTheme;
var _default = exports.default = memoTheme;

},{"1c694d6de33a9a08":"iFfXs"}],"9bD8g":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ef37586520f897ec").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DefaultPropsProvider.default;
    }
});
Object.defineProperty(exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return _DefaultPropsProvider.useDefaultProps;
    }
});
var _DefaultPropsProvider = _interopRequireWildcard(require("2f91af313cbd04c8"));

},{"ef37586520f897ec":"fiRIh","2f91af313cbd04c8":"fiVjW"}],"fiVjW":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9fb043517e58f0e6").default;
var _interopRequireWildcard = require("a9380277186b83f8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.useDefaultProps = useDefaultProps;
var React = _interopRequireWildcard(require("d6113b33549a0d"));
var _propTypes = _interopRequireDefault(require("aad4829528327446"));
var _DefaultPropsProvider = _interopRequireWildcard(require("83508707173e79ee"));
var _jsxRuntime = require("87c97fbb0091d566");
function DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DefaultPropsProvider.default, {
        ...props
    });
}
var _default = exports.default = DefaultPropsProvider;
function useDefaultProps(params) {
    return (0, _DefaultPropsProvider.useDefaultProps)(params);
}

},{"9fb043517e58f0e6":"kZ6eK","a9380277186b83f8":"fiRIh","d6113b33549a0d":"9njXz","aad4829528327446":"bnNSm","83508707173e79ee":"aF5dK","87c97fbb0091d566":"1dlk8"}],"8YJoq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c3fac1542fd2bf84").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getSvgIconUtilityClass = getSvgIconUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("5f1dd0d477941669"));
var _generateUtilityClass = _interopRequireDefault(require("53f30eff9c212774"));
function getSvgIconUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiSvgIcon', slot);
}
const svgIconClasses = (0, _generateUtilityClasses.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var _default = exports.default = svgIconClasses;

},{"c3fac1542fd2bf84":"kZ6eK","5f1dd0d477941669":"7pSUk","53f30eff9c212774":"jBs9M"}],"bjUwl":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c171556961559af2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _debounce = _interopRequireDefault(require("11287f5ad608d78b"));
var _default = exports.default = _debounce.default;

},{"c171556961559af2":"kZ6eK","11287f5ad608d78b":"f6vcJ"}],"f6vcJ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a3becdb8c7cbcb7c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _debounce.default;
    }
});
var _debounce = _interopRequireWildcard(require("4b2abf07988b4df"));
Object.keys(_debounce).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _debounce[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _debounce[key];
        }
    });
});

},{"a3becdb8c7cbcb7c":"fiRIh","4b2abf07988b4df":"bcQUF"}],"bcQUF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

},{}],"a2Gdk":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7f10b4da78003777").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _deprecatedPropType = _interopRequireDefault(require("be2791345fbc53f6"));
var _default = exports.default = _deprecatedPropType.default;

},{"7f10b4da78003777":"kZ6eK","be2791345fbc53f6":"bCejB"}],"bCejB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1f481973754c8944").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _deprecatedPropType.default;
    }
});
var _deprecatedPropType = _interopRequireDefault(require("1cab4921ab9b2795"));

},{"1f481973754c8944":"kZ6eK","1cab4921ab9b2795":"4FENG"}],"4FENG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deprecatedPropType;
function deprecatedPropType(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}

},{}],"cF7sw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("69d77a7702e25f59").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isMuiElement = _interopRequireDefault(require("23285b96bca9b195"));
var _default = exports.default = _isMuiElement.default;

},{"69d77a7702e25f59":"kZ6eK","23285b96bca9b195":"4sqhm"}],"1juJZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c45363e193be81e6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _ownerDocument = _interopRequireDefault(require("12b30ba35bb7be6f"));
var _default = exports.default = _ownerDocument.default;

},{"c45363e193be81e6":"kZ6eK","12b30ba35bb7be6f":"8VgUE"}],"8VgUE":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9f2d06c503f836b5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ownerDocument.default;
    }
});
var _ownerDocument = _interopRequireDefault(require("6d6ee90026376a0b"));

},{"9f2d06c503f836b5":"kZ6eK","6d6ee90026376a0b":"fZ4nA"}],"fZ4nA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}

},{}],"lHNEW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b3f8904b4b5ae878").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _ownerWindow = _interopRequireDefault(require("8c474e1277a6552a"));
var _default = exports.default = _ownerWindow.default;

},{"b3f8904b4b5ae878":"kZ6eK","8c474e1277a6552a":"hiDmU"}],"hiDmU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ca87500865535871").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ownerWindow.default;
    }
});
var _ownerWindow = _interopRequireDefault(require("20b38ecbd8f1e81f"));

},{"ca87500865535871":"kZ6eK","20b38ecbd8f1e81f":"9bhhj"}],"9bhhj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1ad8c8c4fdb095e2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ownerWindow;
var _ownerDocument = _interopRequireDefault(require("cac48f005287af1e"));
function ownerWindow(node) {
    const doc = (0, _ownerDocument.default)(node);
    return doc.defaultView || window;
}

},{"1ad8c8c4fdb095e2":"kZ6eK","cac48f005287af1e":"8VgUE"}],"9hSkv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e870a32a7e459927").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _requirePropFactory = _interopRequireDefault(require("13974dee5374f82b"));
var _default = exports.default = _requirePropFactory.default;

},{"e870a32a7e459927":"kZ6eK","13974dee5374f82b":"3mu6c"}],"3mu6c":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c1bcf01a016f83f0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _requirePropFactory.default;
    }
});
var _requirePropFactory = _interopRequireDefault(require("b1f417e6f4e8785a"));

},{"c1bcf01a016f83f0":"kZ6eK","b1f417e6f4e8785a":"cVklQ"}],"cVklQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = requirePropFactory;
function requirePropFactory(componentNameInError, Component) {
    return ()=>()=>null;
}

},{}],"9pnGz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c67d917d7a7ca414").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _setRef = _interopRequireDefault(require("2dba42b25cb44440"));
var _default = exports.default = _setRef.default;

},{"c67d917d7a7ca414":"kZ6eK","2dba42b25cb44440":"8uRhj"}],"8uRhj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d564c69d8b111b7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _setRef.default;
    }
});
var _setRef = _interopRequireDefault(require("45a9b5e2f170cd8a"));

},{"d564c69d8b111b7":"kZ6eK","45a9b5e2f170cd8a":"3M6XL"}],"3M6XL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = setRef;
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

},{}],"9wMvV":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("6c922e75daaa07e0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useEnhancedEffect = _interopRequireDefault(require("1a913ef9e9d8a7d1"));
var _default = exports.default = _useEnhancedEffect.default;

},{"6c922e75daaa07e0":"kZ6eK","1a913ef9e9d8a7d1":"fIvqa"}],"hOkl4":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("60b5f8d5f58b4d94").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useId = _interopRequireDefault(require("fd0b7bed2beb7f87"));
var _default = exports.default = _useId.default;

},{"60b5f8d5f58b4d94":"kZ6eK","fd0b7bed2beb7f87":"50qgI"}],"50qgI":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("255675d84f92bae").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useId.default;
    }
});
var _useId = _interopRequireDefault(require("25989ce2deac7de"));

},{"255675d84f92bae":"kZ6eK","25989ce2deac7de":"fKcf0"}],"fKcf0":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("24efb0879cb32d1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useId;
var React = _interopRequireWildcard(require("38095c9d28295399"));
let globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = React.useState(idOverride);
    const id = idOverride || defaultId;
    React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            globalId += 1;
            setDefaultId(`mui-${globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const safeReact = {
    ...React
};
const maybeReactUseId = safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if (maybeReactUseId !== undefined) {
        const reactId = maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return useGlobalId(idOverride);
}

},{"24efb0879cb32d1":"fiRIh","38095c9d28295399":"9njXz"}],"4ygWT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("83dd737567779e99").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _unsupportedProp = _interopRequireDefault(require("afd6cb1cabd4dfbe"));
var _default = exports.default = _unsupportedProp.default;

},{"83dd737567779e99":"kZ6eK","afd6cb1cabd4dfbe":"5Zw9y"}],"5Zw9y":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("213b3de644fa3340").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _unsupportedProp.default;
    }
});
var _unsupportedProp = _interopRequireDefault(require("d18bb2c9d3d9c779"));

},{"213b3de644fa3340":"kZ6eK","d18bb2c9d3d9c779":"8GOyC"}],"8GOyC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = unsupportedProp;
function unsupportedProp(props, propName, componentName, location, propFullName) {
    return null;
}

},{}],"2pWHX":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e7c974dbb0b8c826").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useControlled = _interopRequireDefault(require("2103e9a9c4eb84f3"));
var _default = exports.default = _useControlled.default;

},{"e7c974dbb0b8c826":"kZ6eK","2103e9a9c4eb84f3":"jwZrv"}],"jwZrv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("d1a4ff17b7de5042").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useControlled.default;
    }
});
var _useControlled = _interopRequireWildcard(require("c45633a7233faed6"));
Object.keys(_useControlled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _useControlled[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useControlled[key];
        }
    });
});

},{"d1a4ff17b7de5042":"fiRIh","c45633a7233faed6":"gKIb8"}],"gKIb8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
// TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- process.env never changes, dependency arrays are intentionally ignored
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ var _interopRequireWildcard = require("5aa3c6f3be017418").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useControlled;
var React = _interopRequireWildcard(require("8ffaa81b2ea8b5bc"));
function useControlled(props) {
    const { controlled, default: defaultProp, name, state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = React.useRef(controlled !== undefined);
    const [valueState, setValue] = React.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = React.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefiend.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

},{"5aa3c6f3be017418":"fiRIh","8ffaa81b2ea8b5bc":"9njXz"}],"9mQKD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("970354d4e3339870").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useEventCallback = _interopRequireDefault(require("772b89b6d379b776"));
var _default = exports.default = _useEventCallback.default;

},{"970354d4e3339870":"kZ6eK","772b89b6d379b776":"feNJe"}],"feNJe":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("52c799e74f10efbb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useEventCallback.default;
    }
});
var _useEventCallback = _interopRequireDefault(require("e162981f063f520c"));

},{"52c799e74f10efbb":"kZ6eK","e162981f063f520c":"dIKeq"}],"dIKeq":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("97395a092909d98c").default;
var _interopRequireWildcard = require("b7e73551969fa13d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("564559aa06a2b11"));
var _useEnhancedEffect = _interopRequireDefault(require("deaacaef493326fc"));
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function useEventCallback(fn) {
    const ref = React.useRef(fn);
    (0, _useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var _default = exports.default = useEventCallback;

},{"97395a092909d98c":"kZ6eK","b7e73551969fa13d":"fiRIh","564559aa06a2b11":"9njXz","deaacaef493326fc":"fIvqa"}],"64cM2":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ff332da065083267").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useForkRef = _interopRequireDefault(require("1858f04130bf82b5"));
var _default = exports.default = _useForkRef.default;

},{"ff332da065083267":"kZ6eK","1858f04130bf82b5":"4xKTx"}],"4xKTx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e65de141a07c5e4b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useForkRef.default;
    }
});
var _useForkRef = _interopRequireDefault(require("76422d3c27bc6864"));

},{"e65de141a07c5e4b":"kZ6eK","76422d3c27bc6864":"iZRTB"}],"iZRTB":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("c5001007a90df00").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useForkRef;
var React = _interopRequireWildcard(require("ba3eef59680b5588"));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function useForkRef(...refs) {
    const cleanupRef = React.useRef(undefined);
    const refEffect = React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

},{"c5001007a90df00":"fiRIh","ba3eef59680b5588":"9njXz"}],"8LtAL":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("81f0e3985b2f1dea").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mergeSlotProps;
var _clsx = _interopRequireDefault(require("ad575678e61010cd"));
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function mergeSlotProps(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if (isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, _clsx.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, _clsx.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

},{"81f0e3985b2f1dea":"kZ6eK","ad575678e61010cd":"d2NWs"}],"2r5WG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createSimplePaletteValueFilter;
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
/**
 * Creates a filter function used to filter simple palette color options.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns ([, value]: [any, PaletteColorOptions]) => boolean
 */ function createSimplePaletteValueFilter(additionalPropertiesToCheck = []) {
    return ([, value])=>value && checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

},{}],"7X8rf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("cf6078b8729f8bf3").default;
var _interopRequireDefault = require("9a6c057b1b6ce92").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    buttonBaseClasses: true,
    touchRippleClasses: true
};
Object.defineProperty(exports, "buttonBaseClasses", {
    enumerable: true,
    get: function() {
        return _buttonBaseClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ButtonBase.default;
    }
});
Object.defineProperty(exports, "touchRippleClasses", {
    enumerable: true,
    get: function() {
        return _touchRippleClasses.default;
    }
});
var _ButtonBase = _interopRequireDefault(require("a85d586c7b8f12fe"));
var _buttonBaseClasses = _interopRequireWildcard(require("25af475015e422a7"));
Object.keys(_buttonBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _buttonBaseClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _buttonBaseClasses[key];
        }
    });
});
var _touchRippleClasses = _interopRequireWildcard(require("347956d2d4e441c7"));
Object.keys(_touchRippleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _touchRippleClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _touchRippleClasses[key];
        }
    });
});

},{"cf6078b8729f8bf3":"fiRIh","9a6c057b1b6ce92":"kZ6eK","a85d586c7b8f12fe":"58V6A","25af475015e422a7":"74GLw","347956d2d4e441c7":"6yCL4"}],"58V6A":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2d278fad42037054").default;
var _interopRequireWildcard = require("85c72d98677b7e18").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.ButtonBaseRoot = void 0;
var React = _interopRequireWildcard(require("fc0a47b0e4e3c1f5"));
var _propTypes = _interopRequireDefault(require("8c2452c513faa50d"));
var _clsx = _interopRequireDefault(require("b7c88ef6c21a9be4"));
var _refType = _interopRequireDefault(require("a7e34c73bcfa6fb7"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("bb4140718370eac2"));
var _composeClasses = _interopRequireDefault(require("a347242a6e1ecbce"));
var _isFocusVisible = _interopRequireDefault(require("7287f326a029723d"));
var _zeroStyled = require("9795100384e39a4a");
var _DefaultPropsProvider = require("130dc767a71b1f92");
var _useForkRef = _interopRequireDefault(require("68fd6d37dcf9c761"));
var _useEventCallback = _interopRequireDefault(require("9d7a7fd1761a51ee"));
var _useLazyRipple = _interopRequireDefault(require("fb4ed1485962e350"));
var _TouchRipple = _interopRequireDefault(require("3c37f7291221f940"));
var _buttonBaseClasses = _interopRequireWildcard(require("4c06fa9ddcc87d99"));
var _jsxRuntime = require("b6d396c4ea1f2add");
const useUtilityClasses = (ownerState)=>{
    const { disabled, focusVisible, focusVisibleClassName, classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _buttonBaseClasses.getButtonBaseUtilityClass, classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const ButtonBaseRoot = exports.ButtonBaseRoot = (0, _zeroStyled.styled)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${_buttonBaseClasses.default.disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const ButtonBase = /*#__PURE__*/ React.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action, centerRipple = false, children, className, component = 'button', disabled = false, disableRipple = false, disableTouchRipple = false, focusRipple = false, focusVisibleClassName, LinkComponent = 'a', onBlur, onClick, onContextMenu, onDragLeave, onFocus, onFocusVisible, onKeyDown, onKeyUp, onMouseDown, onMouseLeave, onMouseUp, onTouchEnd, onTouchMove, onTouchStart, tabIndex = 0, TouchRippleProps, touchRippleRef, type, ...other } = props;
    const buttonRef = React.useRef(null);
    const ripple = (0, _useLazyRipple.default)();
    const handleRippleRef = (0, _useForkRef.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = React.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    React.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    React.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, _isFocusVisible.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, _useEventCallback.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, _isFocusVisible.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, _useEventCallback.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, _useEventCallback.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, _useForkRef.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple,
        component,
        disabled,
        disableRipple,
        disableTouchRipple,
        focusRipple,
        tabIndex,
        focusVisible
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonBaseRoot, {
        as: ComponentProp,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TouchRipple.default, {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, _useEventCallback.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var _default = exports.default = ButtonBase;

},{"2d278fad42037054":"kZ6eK","85c72d98677b7e18":"fiRIh","fc0a47b0e4e3c1f5":"9njXz","8c2452c513faa50d":"bnNSm","b7c88ef6c21a9be4":"d2NWs","a7e34c73bcfa6fb7":"3TBXN","bb4140718370eac2":"40NoV","a347242a6e1ecbce":"59Equ","7287f326a029723d":"gHKhh","9795100384e39a4a":"hZXDo","130dc767a71b1f92":"9bD8g","68fd6d37dcf9c761":"64cM2","9d7a7fd1761a51ee":"9mQKD","fb4ed1485962e350":"7IPnv","3c37f7291221f940":"2FmiW","4c06fa9ddcc87d99":"74GLw","b6d396c4ea1f2add":"1dlk8"}],"3TBXN":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cb008783cc8dc54").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _refType.default;
    }
});
var _refType = _interopRequireDefault(require("2afcc5cf90f97a36"));

},{"cb008783cc8dc54":"kZ6eK","2afcc5cf90f97a36":"3ELPf"}],"3ELPf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a3e3dc00f37a8649").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("eb7a3c1f43d71682"));
const refType = _propTypes.default.oneOfType([
    _propTypes.default.func,
    _propTypes.default.object
]);
var _default = exports.default = refType;

},{"a3e3dc00f37a8649":"kZ6eK","eb7a3c1f43d71682":"bnNSm"}],"40NoV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3a45f789416feab6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _elementTypeAcceptingRef.default;
    }
});
var _elementTypeAcceptingRef = _interopRequireDefault(require("709d7c0410e451bb"));

},{"3a45f789416feab6":"kZ6eK","709d7c0410e451bb":"kFunI"}],"kFunI":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1ec95f6be3e7d93e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("a7d7ea52e9e01dd6"));
var _chainPropTypes = _interopRequireDefault(require("b8a0e4e92e2516e"));
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
var _default = exports.default = (0, _chainPropTypes.default)(_propTypes.default.elementType, elementTypeAcceptingRef);

},{"1ec95f6be3e7d93e":"kZ6eK","a7d7ea52e9e01dd6":"bnNSm","b8a0e4e92e2516e":"4stnp"}],"gHKhh":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f84b814f2c6c33db").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _isFocusVisible.default;
    }
});
var _isFocusVisible = _interopRequireDefault(require("16c35462159014ff"));

},{"f84b814f2c6c33db":"kZ6eK","16c35462159014ff":"kyjdO"}],"kyjdO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isFocusVisible;
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function isFocusVisible(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

},{}],"7IPnv":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("1f61cef572bb2c9b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useLazyRipple.default;
    }
});
var _useLazyRipple = _interopRequireDefault(require("6acc089effbe03d3"));

},{"1f61cef572bb2c9b":"kZ6eK","6acc089effbe03d3":"1b0on"}],"1b0on":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("34cbc0c1f7f39197").default;
var _interopRequireWildcard = require("1754be7aac1ebc11").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LazyRipple = void 0;
exports.default = useLazyRipple;
var React = _interopRequireWildcard(require("112813a49309c3fb"));
var _useLazyRef = _interopRequireDefault(require("7bf4d57d72a3e2e3"));
/**
 * Lazy initialization container for the Ripple instance. This improves
 * performance by delaying mounting the ripple until it's needed.
 */ class LazyRipple {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new LazyRipple();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, _useLazyRef.default)(LazyRipple.create).current;
        const [shouldMount, setShouldMount] = React.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        React.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
exports.LazyRipple = LazyRipple;
function useLazyRipple() {
    return LazyRipple.use();
}
function createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

},{"34cbc0c1f7f39197":"kZ6eK","1754be7aac1ebc11":"fiRIh","112813a49309c3fb":"9njXz","7bf4d57d72a3e2e3":"gb1Wb"}],"gb1Wb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("836bdefd4b9f7b13").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useLazyRef.default;
    }
});
var _useLazyRef = _interopRequireDefault(require("9658beffa027bb73"));

},{"836bdefd4b9f7b13":"kZ6eK","9658beffa027bb73":"kdSyV"}],"kdSyV":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("24405efd4ebf80a9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useLazyRef;
var React = _interopRequireWildcard(require("d4852ee2f430cca8"));
const UNINITIALIZED = {};
/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */ function useLazyRef(init, initArg) {
    const ref = React.useRef(UNINITIALIZED);
    if (ref.current === UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

},{"24405efd4ebf80a9":"fiRIh","d4852ee2f430cca8":"9njXz"}],"2FmiW":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("247fa3c87893431f").default;
var _interopRequireWildcard = require("6cac7d2a6cce139f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.TouchRippleRoot = exports.TouchRippleRipple = exports.DELAY_RIPPLE = void 0;
var React = _interopRequireWildcard(require("702c867e0f220b8"));
var _propTypes = _interopRequireDefault(require("19399190f0837309"));
var _reactTransitionGroup = require("af883ffd500329f2");
var _clsx = _interopRequireDefault(require("c708154ae2af06e7"));
var _useTimeout = _interopRequireDefault(require("875d0d4874bdf74f"));
var _zeroStyled = require("1dab485b923d5fbc");
var _DefaultPropsProvider = require("7b07da60b0ce8c49");
var _Ripple = _interopRequireDefault(require("2f8cc239ed445b3e"));
var _touchRippleClasses = _interopRequireDefault(require("9af765c53b9a290c"));
var _jsxRuntime = require("c2d459de8e919694");
const DURATION = 550;
const DELAY_RIPPLE = exports.DELAY_RIPPLE = 80;
const enterKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const exitKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const pulsateKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const TouchRippleRoot = exports.TouchRippleRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const TouchRippleRipple = exports.TouchRippleRipple = (0, _zeroStyled.styled)(_Ripple.default, {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${_touchRippleClasses.default.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${enterKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({ theme })=>theme.transitions.easing.easeInOut};
  }

  &.${_touchRippleClasses.default.ripplePulsate} {
    animation-duration: ${({ theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${_touchRippleClasses.default.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${_touchRippleClasses.default.childLeaving} {
    opacity: 0;
    animation-name: ${exitKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({ theme })=>theme.transitions.easing.easeInOut};
  }

  & .${_touchRippleClasses.default.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const TouchRipple = /*#__PURE__*/ React.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes = {}, className, ...other } = props;
    const [ripples, setRipples] = React.useState([]);
    const nextKey = React.useRef(0);
    const rippleCallback = React.useRef(null);
    React.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = React.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, _useTimeout.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = React.useRef(null);
    const container = React.useRef(null);
    const startCommit = React.useCallback((params)=>{
        const { pulsate, rippleX, rippleY, rippleSize, cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRipple, {
                    classes: {
                        ripple: (0, _clsx.default)(classes.ripple, _touchRippleClasses.default.ripple),
                        rippleVisible: (0, _clsx.default)(classes.rippleVisible, _touchRippleClasses.default.rippleVisible),
                        ripplePulsate: (0, _clsx.default)(classes.ripplePulsate, _touchRippleClasses.default.ripplePulsate),
                        child: (0, _clsx.default)(classes.child, _touchRippleClasses.default.child),
                        childLeaving: (0, _clsx.default)(classes.childLeaving, _touchRippleClasses.default.childLeaving),
                        childPulsate: (0, _clsx.default)(classes.childPulsate, _touchRippleClasses.default.childPulsate)
                    },
                    timeout: DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = React.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate = false, center = centerProp || options.pulsate, fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX, clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate,
                        rippleX,
                        rippleY,
                        rippleSize,
                        cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start(DELAY_RIPPLE, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = React.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = React.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    React.useImperativeHandle(ref, ()=>({
            pulsate,
            start,
            stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRoot, {
        className: (0, _clsx.default)(_touchRippleClasses.default.root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactTransitionGroup.TransitionGroup, {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var _default = exports.default = TouchRipple;

},{"247fa3c87893431f":"kZ6eK","6cac7d2a6cce139f":"fiRIh","702c867e0f220b8":"9njXz","19399190f0837309":"bnNSm","af883ffd500329f2":"hnCQJ","c708154ae2af06e7":"d2NWs","875d0d4874bdf74f":"k3sgs","1dab485b923d5fbc":"hZXDo","7b07da60b0ce8c49":"9bD8g","2f8cc239ed445b3e":"kgkkj","9af765c53b9a290c":"6yCL4","c2d459de8e919694":"1dlk8"}],"hnCQJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>(0, _csstransitionDefault.default));
parcelHelpers.export(exports, "ReplaceTransition", ()=>(0, _replaceTransitionDefault.default));
parcelHelpers.export(exports, "SwitchTransition", ()=>(0, _switchTransitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "config", ()=>(0, _configDefault.default));
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"iyv3L","./ReplaceTransition":"1v1ld","./SwitchTransition":"iEWMb","./TransitionGroup":"4WN9V","./Transition":"6LVcl","./config":"7vGu2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyv3L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ''
};
CSSTransition.propTypes = {};
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","dom-helpers/addClass":"16v5y","dom-helpers/removeClass":"cUvLe","react":"9njXz","./Transition":"6LVcl","./utils/PropTypes":"8gMVu","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGdYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cnxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9UMxe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16v5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

},{"./hasClass":"3I5QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3I5QN":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cUvLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LVcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","react-dom":"2ApDx","./config":"7vGu2","./utils/PropTypes":"8gMVu","./TransitionGroupContext":"162y0","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vGu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gMVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"162y0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V7Al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1v1ld":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle('onEnter', 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle('onEntering', 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle('onEntered', 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle('onExit', 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle('onExiting', 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle('onExited', 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = (0, _reactDefault.default).Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) {
            var maybeNode = child.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this);
            this.props[handler](maybeNode);
        }
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = (0, _reactDefault.default).Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupDefault.default), props, inProp ? (0, _reactDefault.default).cloneElement(first, {
            key: 'first',
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : (0, _reactDefault.default).cloneElement(second, {
            key: 'second',
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}((0, _reactDefault.default).Component);
ReplaceTransition.propTypes = {};
exports.default = ReplaceTransition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","react-dom":"2ApDx","./TransitionGroup":"4WN9V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4WN9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _childMapping = require("./utils/ChildMapping");
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, _assertThisInitializedDefault.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _childMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _childMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _childMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, _extendsDefault.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, _reactDefault.default).Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","./TransitionGroupContext":"162y0","./utils/ChildMapping":"kq3eN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJtsr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kq3eN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ parcelHelpers.export(exports, "getChildMapping", ()=>getChildMapping);
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ parcelHelpers.export(exports, "mergeChildMappings", ()=>mergeChildMappings);
parcelHelpers.export(exports, "getInitialChildMapping", ()=>getInitialChildMapping);
parcelHelpers.export(exports, "getNextChildMapping", ()=>getNextChildMapping);
var _react = require("react");
function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, _react.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, 'appear', props),
            enter: getProp(child, 'enter', props),
            exit: getProp(child, 'exit', props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iEWMb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modes", ()=>modes);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _transition = require("./Transition");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
    if (oldChildren === newChildren) return false;
    if ((0, _reactDefault.default).isValidElement(oldChildren) && (0, _reactDefault.default).isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) return false;
    return true;
}
var modes = {
    out: 'out-in',
    in: 'in-out'
};
var callHook = function callHook(element, name, cb) {
    return function() {
        var _element$props;
        element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
        cb();
    };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function(_ref) {
    var current = _ref.current, changeState = _ref.changeState;
    return (0, _reactDefault.default).cloneElement(current, {
        in: false,
        onExited: callHook(current, 'onExited', function() {
            changeState((0, _transition.ENTERING), null);
        })
    });
}, _leaveRenders[modes.in] = function(_ref2) {
    var current = _ref2.current, changeState = _ref2.changeState, children = _ref2.children;
    return [
        current,
        (0, _reactDefault.default).cloneElement(children, {
            in: true,
            onEntered: callHook(children, 'onEntered', function() {
                changeState((0, _transition.ENTERING));
            })
        })
    ];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function(_ref3) {
    var children = _ref3.children, changeState = _ref3.changeState;
    return (0, _reactDefault.default).cloneElement(children, {
        in: true,
        onEntered: callHook(children, 'onEntered', function() {
            changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                in: true
            }));
        })
    });
}, _enterRenders[modes.in] = function(_ref4) {
    var current = _ref4.current, children = _ref4.children, changeState = _ref4.changeState;
    return [
        (0, _reactDefault.default).cloneElement(current, {
            in: false,
            onExited: callHook(current, 'onExited', function() {
                changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                    in: true
                }));
            })
        }),
        (0, _reactDefault.default).cloneElement(children, {
            in: true
        })
    ];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */ var SwitchTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(SwitchTransition, _React$Component);
    function SwitchTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            status: (0, _transition.ENTERED),
            current: null
        };
        _this.appeared = false;
        _this.changeState = function(status, current) {
            if (current === void 0) current = _this.state.current;
            _this.setState({
                status: status,
                current: current
            });
        };
        return _this;
    }
    var _proto = SwitchTransition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
    };
    SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.children == null) return {
            current: null
        };
        if (state.status === (0, _transition.ENTERING) && props.mode === modes.in) return {
            status: (0, _transition.ENTERING)
        };
        if (state.current && areChildrenDifferent(state.current, props.children)) return {
            status: (0, _transition.EXITING)
        };
        return {
            current: (0, _reactDefault.default).cloneElement(props.children, {
                in: true
            })
        };
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, mode = _this$props.mode, _this$state = this.state, status = _this$state.status, current = _this$state.current;
        var data = {
            children: children,
            current: current,
            changeState: this.changeState,
            status: status
        };
        var component;
        switch(status){
            case 0, _transition.ENTERING:
                component = enterRenders[mode](data);
                break;
            case 0, _transition.EXITING:
                component = leaveRenders[mode](data);
                break;
            case 0, _transition.ENTERED:
                component = current;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: {
                isMounting: !this.appeared
            }
        }, component);
    };
    return SwitchTransition;
}((0, _reactDefault.default).Component);
SwitchTransition.propTypes = {};
SwitchTransition.defaultProps = {
    mode: modes.out
};
exports.default = SwitchTransition;

},{"@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","./Transition":"6LVcl","./TransitionGroupContext":"162y0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k3sgs":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("d338144ae0c91875").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Timeout", {
    enumerable: true,
    get: function() {
        return _useTimeout.Timeout;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useTimeout.default;
    }
});
var _useTimeout = _interopRequireWildcard(require("9025fa08960330bf"));

},{"d338144ae0c91875":"fiRIh","9025fa08960330bf":"fhu0J"}],"fhu0J":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("bf81aa3f5ab8196d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Timeout = void 0;
exports.default = useTimeout;
var _useLazyRef = _interopRequireDefault(require("bc754d7114476e87"));
var _useOnMount = _interopRequireDefault(require("cc5798607a2da1ee"));
class Timeout {
    static create() {
        return new Timeout();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
exports.Timeout = Timeout;
function useTimeout() {
    const timeout = (0, _useLazyRef.default)(Timeout.create).current;
    (0, _useOnMount.default)(timeout.disposeEffect);
    return timeout;
}

},{"bf81aa3f5ab8196d":"kZ6eK","bc754d7114476e87":"kdSyV","cc5798607a2da1ee":"9OHhF"}],"9OHhF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("63c5d5dade1a4650").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useOnMount;
var React = _interopRequireWildcard(require("61e6fb67d9541ebc"));
const EMPTY = [];
/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */ function useOnMount(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ React.useEffect(fn, EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

},{"63c5d5dade1a4650":"fiRIh","61e6fb67d9541ebc":"9njXz"}],"kgkkj":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("60aaa05408cd0b97").default;
var _interopRequireWildcard = require("ef98895d899bdcb0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("1e07b8756f3af310"));
var _propTypes = _interopRequireDefault(require("f7829bd2e31da2db"));
var _clsx = _interopRequireDefault(require("11bcbb6b18ebecfa"));
var _jsxRuntime = require("361bfdd49c2366e3");
/**
 * @ignore - internal component.
 */ function Ripple(props) {
    const { className, classes, pulsate = false, rippleX, rippleY, rippleSize, in: inProp, onExited, timeout } = props;
    const [leaving, setLeaving] = React.useState(false);
    const rippleClassName = (0, _clsx.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, _clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    React.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: childClassName
        })
    });
}
var _default = exports.default = Ripple;

},{"60aaa05408cd0b97":"kZ6eK","ef98895d899bdcb0":"fiRIh","1e07b8756f3af310":"9njXz","f7829bd2e31da2db":"bnNSm","11bcbb6b18ebecfa":"d2NWs","361bfdd49c2366e3":"1dlk8"}],"6yCL4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d48c7c5d63e0a806").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTouchRippleUtilityClass = getTouchRippleUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("356d32b17c00402f"));
var _generateUtilityClass = _interopRequireDefault(require("a0d83ebe14177528"));
function getTouchRippleUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTouchRipple', slot);
}
const touchRippleClasses = (0, _generateUtilityClasses.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var _default = exports.default = touchRippleClasses;

},{"d48c7c5d63e0a806":"kZ6eK","356d32b17c00402f":"7pSUk","a0d83ebe14177528":"jBs9M"}],"74GLw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e6205f4926c181a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getButtonBaseUtilityClass = getButtonBaseUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("b8b8220efa50e4de"));
var _generateUtilityClass = _interopRequireDefault(require("d2e1367652e76fd1"));
function getButtonBaseUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiButtonBase', slot);
}
const buttonBaseClasses = (0, _generateUtilityClasses.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var _default = exports.default = buttonBaseClasses;

},{"e6205f4926c181a":"kZ6eK","b8b8220efa50e4de":"7pSUk","d2e1367652e76fd1":"jBs9M"}],"kEtIR":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("1cdb8093585142e2").default;
var _interopRequireDefault = require("c19a7b1a08883629").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    circularProgressClasses: true
};
Object.defineProperty(exports, "circularProgressClasses", {
    enumerable: true,
    get: function() {
        return _circularProgressClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _CircularProgress.default;
    }
});
var _CircularProgress = _interopRequireDefault(require("2992ac707d860b8d"));
var _circularProgressClasses = _interopRequireWildcard(require("7e46a3c4523c5052"));
Object.keys(_circularProgressClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _circularProgressClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _circularProgressClasses[key];
        }
    });
});

},{"1cdb8093585142e2":"fiRIh","c19a7b1a08883629":"kZ6eK","2992ac707d860b8d":"baWTL","7e46a3c4523c5052":"hgPkl"}],"baWTL":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("74eeb7127a31fe24").default;
var _interopRequireWildcard = require("bc80a21e6e8c8685").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("5282f299884a4ddd"));
var _propTypes = _interopRequireDefault(require("c5a80c7ca54e9800"));
var _clsx = _interopRequireDefault(require("8ebf11079e695bac"));
var _chainPropTypes = _interopRequireDefault(require("c887a568da7accf7"));
var _composeClasses = _interopRequireDefault(require("f7eb1cfbf6f7c61e"));
var _zeroStyled = require("c473e8d32b430eb8");
var _memoTheme = _interopRequireDefault(require("42e865353262ed6c"));
var _DefaultPropsProvider = require("b0dc1ee986217846");
var _capitalize = _interopRequireDefault(require("7d3bd2b51530541a"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("c0b7024b2b8824c4"));
var _circularProgressClasses = require("f51c416fabb1c5");
var _jsxRuntime = require("49abca75623af759");
const SIZE = 44;
const circularRotateKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const circularDashKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const rotateAnimation = typeof circularRotateKeyframe !== 'string' ? (0, _zeroStyled.css)`
        animation: ${circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const dashAnimation = typeof circularDashKeyframe !== 'string' ? (0, _zeroStyled.css)`
        animation: ${circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, color, disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, _capitalize.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, _capitalize.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, _composeClasses.default)(slots, _circularProgressClasses.getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, _capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: rotateAnimation || {
                    animation: `${circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const CircularProgressSVG = (0, _zeroStyled.styled)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const CircularProgressCircle = (0, _zeroStyled.styled)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, _capitalize.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const CircularProgress = /*#__PURE__*/ React.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className, color = 'primary', disableShrink = false, size = 40, style, thickness = 3.6, value = 0, variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color,
        disableShrink,
        size,
        thickness,
        value,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressRoot, {
        className: (0, _clsx.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: SIZE,
                cy: SIZE,
                r: (SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var _default = exports.default = CircularProgress;

},{"74eeb7127a31fe24":"kZ6eK","bc80a21e6e8c8685":"fiRIh","5282f299884a4ddd":"9njXz","c5a80c7ca54e9800":"bnNSm","8ebf11079e695bac":"d2NWs","c887a568da7accf7":"4stnp","f7eb1cfbf6f7c61e":"59Equ","c473e8d32b430eb8":"hZXDo","42e865353262ed6c":"cJNjb","b0dc1ee986217846":"9bD8g","7d3bd2b51530541a":"eOYSA","c0b7024b2b8824c4":"2r5WG","f51c416fabb1c5":"hgPkl","49abca75623af759":"1dlk8"}],"hgPkl":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("497585b911b7f0be").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getCircularProgressUtilityClass = getCircularProgressUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("3af85bf0e971e54a"));
var _generateUtilityClass = _interopRequireDefault(require("51d3b3079d23c659"));
function getCircularProgressUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0, _generateUtilityClasses.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var _default = exports.default = circularProgressClasses;

},{"497585b911b7f0be":"kZ6eK","3af85bf0e971e54a":"7pSUk","51d3b3079d23c659":"jBs9M"}],"1EE51":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("58cce72a6054eefc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getIconButtonUtilityClass = getIconButtonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("64d56ededa4e156d"));
var _generateUtilityClass = _interopRequireDefault(require("c1d5b5e646973785"));
function getIconButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiIconButton', slot);
}
const iconButtonClasses = (0, _generateUtilityClasses.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var _default = exports.default = iconButtonClasses;

},{"58cce72a6054eefc":"kZ6eK","64d56ededa4e156d":"7pSUk","c1d5b5e646973785":"jBs9M"}],"c7nwP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("107896f679faaaf4").default;
var _interopRequireDefault = require("ec1f47aadb828702").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    collapseClasses: true
};
Object.defineProperty(exports, "collapseClasses", {
    enumerable: true,
    get: function() {
        return _collapseClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Collapse.default;
    }
});
var _Collapse = _interopRequireDefault(require("b7bee3c30058fd15"));
var _collapseClasses = _interopRequireWildcard(require("a4f219e85df099df"));
Object.keys(_collapseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _collapseClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _collapseClasses[key];
        }
    });
});

},{"107896f679faaaf4":"fiRIh","ec1f47aadb828702":"kZ6eK","b7bee3c30058fd15":"44ycR","a4f219e85df099df":"dXzq5"}],"44ycR":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("45a596ecff190f92").default;
var _interopRequireWildcard = require("370b7044e587274").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("240647eab5d59303"));
var _clsx = _interopRequireDefault(require("c4e121617a9accf3"));
var _propTypes = _interopRequireDefault(require("17bfef34df080eb8"));
var _reactTransitionGroup = require("a26887e8ff106293");
var _useTimeout = _interopRequireDefault(require("4693735d7a7b82d1"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("22948f89ffbfea48"));
var _composeClasses = _interopRequireDefault(require("b9aba8bf108eff41"));
var _zeroStyled = require("9763879e38fd6e96");
var _memoTheme = _interopRequireDefault(require("82e5a2a4d58a4b4c"));
var _DefaultPropsProvider = require("d72af9b43c4b862");
var _createTransitions = require("87cacc028f3f87c3");
var _utils = require("60575a4f729a4068");
var _utils2 = require("f197814beb84a497");
var _collapseClasses = require("a4ff8e5195bfc2d6");
var _jsxRuntime = require("1614fa8b5cb5808");
const useUtilityClasses = (ownerState)=>{
    const { orientation, classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, _composeClasses.default)(slots, _collapseClasses.getCollapseUtilityClass, classes);
};
const CollapseRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const CollapseWrapper = (0, _zeroStyled.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper'
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const CollapseWrapperInner = (0, _zeroStyled.styled)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner'
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Collapse = /*#__PURE__*/ React.forwardRef(function Collapse(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener, children, className, collapsedSize: collapsedSizeProp = '0px', component, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, orientation = 'vertical', style, timeout = _createTransitions.duration.standard, // eslint-disable-next-line react/prop-types
    TransitionComponent = _reactTransitionGroup.Transition, ...other } = props;
    const ownerState = {
        ...props,
        orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = useUtilityClasses(ownerState);
    const theme = (0, _zeroStyled.useTheme)();
    const timer = (0, _useTimeout.default)();
    const wrapperRef = React.useRef(null);
    const autoTransitionDuration = React.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = React.useRef(null);
    const handleRef = (0, _utils2.useForkRef)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseRoot, {
                as: component,
                className: (0, _clsx.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: {
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                    ...style
                },
                ref: handleRef,
                ownerState: {
                    ...ownerState,
                    state
                },
                ...restChildProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseWrapper, {
                    ownerState: {
                        ...ownerState,
                        state
                    },
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseWrapperInner, {
                        ownerState: {
                            ...ownerState,
                            state
                        },
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            })
    });
});
if (Collapse) Collapse.muiSupportAuto = true;
var _default = exports.default = Collapse;

},{"45a596ecff190f92":"kZ6eK","370b7044e587274":"fiRIh","240647eab5d59303":"9njXz","c4e121617a9accf3":"d2NWs","17bfef34df080eb8":"bnNSm","a26887e8ff106293":"hnCQJ","4693735d7a7b82d1":"k3sgs","22948f89ffbfea48":"40NoV","b9aba8bf108eff41":"59Equ","9763879e38fd6e96":"hZXDo","82e5a2a4d58a4b4c":"cJNjb","d72af9b43c4b862":"9bD8g","87cacc028f3f87c3":"1PwKJ","60575a4f729a4068":"k52HW","f197814beb84a497":"dEMJk","a4ff8e5195bfc2d6":"dXzq5","1614fa8b5cb5808":"1dlk8"}],"k52HW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;
const reflow = (node)=>node.scrollTop;
exports.reflow = reflow;
function getTransitionProps(props, options) {
    const { timeout, easing, style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

},{}],"dXzq5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cbd8754a3ce4af4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getCollapseUtilityClass = getCollapseUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("d350cfb98660a925"));
var _generateUtilityClass = _interopRequireDefault(require("12f17b8bdc47a53b"));
function getCollapseUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiCollapse', slot);
}
const collapseClasses = (0, _generateUtilityClasses.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var _default = exports.default = collapseClasses;

},{"cbd8754a3ce4af4":"kZ6eK","d350cfb98660a925":"7pSUk","12f17b8bdc47a53b":"jBs9M"}],"6NtGx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("686503cf0db0bbc3").default;
var _interopRequireDefault = require("1af5bdee89359abb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    typographyClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Typography.default;
    }
});
Object.defineProperty(exports, "typographyClasses", {
    enumerable: true,
    get: function() {
        return _typographyClasses.default;
    }
});
var _Typography = _interopRequireDefault(require("c24593d125509a80"));
var _typographyClasses = _interopRequireWildcard(require("bf77c632cdf202ef"));
Object.keys(_typographyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _typographyClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _typographyClasses[key];
        }
    });
});

},{"686503cf0db0bbc3":"fiRIh","1af5bdee89359abb":"kZ6eK","c24593d125509a80":"2UhKj","bf77c632cdf202ef":"dHynn"}],"2UhKj":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ff55df3c21e56d8f").default;
var _interopRequireWildcard = require("cedd4ff1f913f9ba").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.TypographyRoot = void 0;
var React = _interopRequireWildcard(require("3e58b55b7ed17ad3"));
var _propTypes = _interopRequireDefault(require("4a78ed0e3c262bc8"));
var _clsx = _interopRequireDefault(require("d232712f2779a928"));
var _composeClasses = _interopRequireDefault(require("5ee4b26a9d5cdfa8"));
var _zeroStyled = require("a08a8f36f35fb1b6");
var _memoTheme = _interopRequireDefault(require("a5235362fc6582e0"));
var _DefaultPropsProvider = require("f4d53fc38da01974");
var _capitalize = _interopRequireDefault(require("8284c3365cc01a59"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("4460d0e0b38769ff"));
var _typographyClasses = require("651a2c65367f2de2");
var _jsxRuntime = require("861a8a3b7809efdc");
const v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const extendSxProp = (0, _zeroStyled.internal_createExtendSxProp)();
const useUtilityClasses = (ownerState)=>{
    const { align, gutterBottom, noWrap, paragraph, variant, classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, _capitalize.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, _composeClasses.default)(slots, _typographyClasses.getTypographyUtilityClass, classes);
};
const TypographyRoot = exports.TypographyRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, _capitalize.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, _capitalize.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const Typography = /*#__PURE__*/ React.forwardRef(function Typography(inProps, ref) {
    const { color, ...themeProps } = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color
        }
    });
    const { align = 'inherit', className, component, gutterBottom = false, noWrap = false, paragraph = false, variant = 'body1', variantMapping = defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align,
        color,
        className,
        component,
        gutterBottom,
        noWrap,
        paragraph,
        variant,
        variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypographyRoot, {
        as: Component,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var _default = exports.default = Typography;

},{"ff55df3c21e56d8f":"kZ6eK","cedd4ff1f913f9ba":"fiRIh","3e58b55b7ed17ad3":"9njXz","4a78ed0e3c262bc8":"bnNSm","d232712f2779a928":"d2NWs","5ee4b26a9d5cdfa8":"59Equ","a08a8f36f35fb1b6":"hZXDo","a5235362fc6582e0":"cJNjb","f4d53fc38da01974":"9bD8g","8284c3365cc01a59":"eOYSA","4460d0e0b38769ff":"2r5WG","651a2c65367f2de2":"dHynn","861a8a3b7809efdc":"1dlk8"}],"dHynn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4e8b70295ff4d7e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTypographyUtilityClass = getTypographyUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4c513ddf48067935"));
var _generateUtilityClass = _interopRequireDefault(require("300e41a414e3d0e"));
function getTypographyUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTypography', slot);
}
const typographyClasses = (0, _generateUtilityClasses.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var _default = exports.default = typographyClasses;

},{"4e8b70295ff4d7e":"kZ6eK","4c513ddf48067935":"7pSUk","300e41a414e3d0e":"jBs9M"}],"crtKq":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("f67ab80c4d13eef3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("36ee8ae8473e27d8"));
var _jsxRuntime = require("52c745c00027fcc6");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');

},{"f67ab80c4d13eef3":"kZ6eK","36ee8ae8473e27d8":"2vOnF","52c745c00027fcc6":"1dlk8"}],"2vOnF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _utils.createSvgIcon;
    }
});
var _utils = require("21f2d1dcc9f0020d");

},{"21f2d1dcc9f0020d":"60iOt"}],"60iOt":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("fe68be4f4e9c9b7d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "capitalize", {
    enumerable: true,
    get: function() {
        return _capitalize.default;
    }
});
Object.defineProperty(exports, "createChainedFunction", {
    enumerable: true,
    get: function() {
        return _createChainedFunction.default;
    }
});
Object.defineProperty(exports, "createSvgIcon", {
    enumerable: true,
    get: function() {
        return _createSvgIcon.default;
    }
});
Object.defineProperty(exports, "debounce", {
    enumerable: true,
    get: function() {
        return _debounce.default;
    }
});
Object.defineProperty(exports, "deprecatedPropType", {
    enumerable: true,
    get: function() {
        return _deprecatedPropType.default;
    }
});
Object.defineProperty(exports, "isMuiElement", {
    enumerable: true,
    get: function() {
        return _isMuiElement.default;
    }
});
Object.defineProperty(exports, "mergeSlotProps", {
    enumerable: true,
    get: function() {
        return _mergeSlotProps.default;
    }
});
Object.defineProperty(exports, "ownerDocument", {
    enumerable: true,
    get: function() {
        return _ownerDocument.default;
    }
});
Object.defineProperty(exports, "ownerWindow", {
    enumerable: true,
    get: function() {
        return _ownerWindow.default;
    }
});
Object.defineProperty(exports, "requirePropFactory", {
    enumerable: true,
    get: function() {
        return _requirePropFactory.default;
    }
});
Object.defineProperty(exports, "setRef", {
    enumerable: true,
    get: function() {
        return _setRef.default;
    }
});
exports.unstable_ClassNameGenerator = void 0;
Object.defineProperty(exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return _memoTheme.default;
    }
});
Object.defineProperty(exports, "unstable_useEnhancedEffect", {
    enumerable: true,
    get: function() {
        return _useEnhancedEffect.default;
    }
});
Object.defineProperty(exports, "unstable_useId", {
    enumerable: true,
    get: function() {
        return _useId.default;
    }
});
Object.defineProperty(exports, "unsupportedProp", {
    enumerable: true,
    get: function() {
        return _unsupportedProp.default;
    }
});
Object.defineProperty(exports, "useControlled", {
    enumerable: true,
    get: function() {
        return _useControlled.default;
    }
});
Object.defineProperty(exports, "useEventCallback", {
    enumerable: true,
    get: function() {
        return _useEventCallback.default;
    }
});
Object.defineProperty(exports, "useForkRef", {
    enumerable: true,
    get: function() {
        return _useForkRef.default;
    }
});
var _ClassNameGenerator = _interopRequireDefault(require("c9fee60f48214d3"));
var _capitalize = _interopRequireDefault(require("c41a926b04503884"));
var _createChainedFunction = _interopRequireDefault(require("1146004479c2fe1b"));
var _createSvgIcon = _interopRequireDefault(require("36bfebe35ecd0024"));
var _debounce = _interopRequireDefault(require("48bded4c65db6527"));
var _deprecatedPropType = _interopRequireDefault(require("222fa68f40f8f2d3"));
var _isMuiElement = _interopRequireDefault(require("d06d3e567cf8d6a5"));
var _memoTheme = _interopRequireDefault(require("53c4db0492d69485"));
var _ownerDocument = _interopRequireDefault(require("d488249e22350b5e"));
var _ownerWindow = _interopRequireDefault(require("91466b50fbd787e4"));
var _requirePropFactory = _interopRequireDefault(require("5ae7b9617f5fe292"));
var _setRef = _interopRequireDefault(require("bd80a0ce8a6a3f24"));
var _useEnhancedEffect = _interopRequireDefault(require("e079abe502005455"));
var _useId = _interopRequireDefault(require("e3eca599e3d9d91d"));
var _unsupportedProp = _interopRequireDefault(require("844b385b0983c57c"));
var _useControlled = _interopRequireDefault(require("eb5d5bfe0ffc137a"));
var _useEventCallback = _interopRequireDefault(require("6acf69e34252b5e1"));
var _useForkRef = _interopRequireDefault(require("e817ca39c5cb7de4"));
var _mergeSlotProps = _interopRequireDefault(require("46e8fbb132108b0f"));
// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_ClassNameGenerator = exports.unstable_ClassNameGenerator = {
    configure: (generator)=>{
        _ClassNameGenerator.default.configure(generator);
    }
};

},{"fe68be4f4e9c9b7d":"kZ6eK","c9fee60f48214d3":"eyH7A","c41a926b04503884":"hBZko","1146004479c2fe1b":"8CRq6","36bfebe35ecd0024":"k1uMV","48bded4c65db6527":"cvBWT","222fa68f40f8f2d3":"3n9Eo","d06d3e567cf8d6a5":"bgSQq","53c4db0492d69485":"2zy52","d488249e22350b5e":"7Yspg","91466b50fbd787e4":"4Wjh2","5ae7b9617f5fe292":"g4unq","bd80a0ce8a6a3f24":"hWYln","e079abe502005455":"hXusa","e3eca599e3d9d91d":"iMSy2","844b385b0983c57c":"lTxN8","eb5d5bfe0ffc137a":"1VreF","6acf69e34252b5e1":"jTtn3","e817ca39c5cb7de4":"cq8Sn","46e8fbb132108b0f":"1XZUh"}],"hBZko":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("75f0dec6104f6363").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _capitalize = _interopRequireDefault(require("4a6ed00df881e6ba"));
var _default = exports.default = _capitalize.default;

},{"75f0dec6104f6363":"kZ6eK","4a6ed00df881e6ba":"5sWY4"}],"8CRq6":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b4afa8e66738decb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createChainedFunction = _interopRequireDefault(require("20638173a47f8954"));
var _default = exports.default = _createChainedFunction.default;

},{"b4afa8e66738decb":"kZ6eK","20638173a47f8954":"hSI0h"}],"k1uMV":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("eaa629dc12c59d1c").default;
var _interopRequireWildcard = require("2039f6f23990e2f5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createSvgIcon;
var React = _interopRequireWildcard(require("dd4de61ce89bf7c7"));
var _SvgIcon = _interopRequireDefault(require("7115e1344747904f"));
var _jsxRuntime = require("d845a6fc27363639");
/**
 * Private module reserved for @mui packages.
 */ function createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SvgIcon.default, {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = _SvgIcon.default.muiName;
    return /*#__PURE__*/ React.memo(/*#__PURE__*/ React.forwardRef(Component));
}

},{"eaa629dc12c59d1c":"kZ6eK","2039f6f23990e2f5":"fiRIh","dd4de61ce89bf7c7":"9njXz","7115e1344747904f":"lkqfz","d845a6fc27363639":"1dlk8"}],"lkqfz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("6923fccbc7caaaf7").default;
var _interopRequireDefault = require("6e85136b3fac334f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    svgIconClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _SvgIcon.default;
    }
});
Object.defineProperty(exports, "svgIconClasses", {
    enumerable: true,
    get: function() {
        return _svgIconClasses.default;
    }
});
var _SvgIcon = _interopRequireDefault(require("4a6edce592d9b10c"));
var _svgIconClasses = _interopRequireWildcard(require("dfef36d65b2dc626"));
Object.keys(_svgIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _svgIconClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _svgIconClasses[key];
        }
    });
});

},{"6923fccbc7caaaf7":"fiRIh","6e85136b3fac334f":"kZ6eK","4a6edce592d9b10c":"gCFP8","dfef36d65b2dc626":"5rRWg"}],"gCFP8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("61cf636d01386d66").default;
var _interopRequireWildcard = require("9936ddd8bdd8f37e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("45b04dd441f158ad"));
var _propTypes = _interopRequireDefault(require("8d84faf47fdd1ffe"));
var _clsx = _interopRequireDefault(require("8dc5af541bb865d3"));
var _composeClasses = _interopRequireDefault(require("92c3b024d68d3c69"));
var _capitalize = _interopRequireDefault(require("5ce4cb5d9c8fdaae"));
var _zeroStyled = require("66607a03afd6646c");
var _memoTheme = _interopRequireDefault(require("90201fdf4fdda7f0"));
var _DefaultPropsProvider = require("84de6c30d042e840");
var _svgIconClasses = require("d24176c80eb5e106");
var _jsxRuntime = require("929beafcb667b7c4");
const useUtilityClasses = (ownerState)=>{
    const { color, fontSize, classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, _capitalize.default)(color)}`,
            `fontSize${(0, _capitalize.default)(fontSize)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _svgIconClasses.getSvgIconUtilityClass, classes);
};
const SvgIconRoot = (0, _zeroStyled.styled)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, _capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const SvgIcon = /*#__PURE__*/ React.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children, className, color = 'inherit', component = 'svg', fontSize = 'medium', htmlColor, inheritViewBox = false, titleAccess, viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ React.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color,
        component,
        fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox,
        viewBox,
        hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SvgIconRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
SvgIcon.muiName = 'SvgIcon';
var _default = exports.default = SvgIcon;

},{"61cf636d01386d66":"kZ6eK","9936ddd8bdd8f37e":"fiRIh","45b04dd441f158ad":"9njXz","8d84faf47fdd1ffe":"bnNSm","8dc5af541bb865d3":"d2NWs","92c3b024d68d3c69":"59Equ","5ce4cb5d9c8fdaae":"hBZko","66607a03afd6646c":"89fxU","90201fdf4fdda7f0":"2zy52","84de6c30d042e840":"ff3VX","d24176c80eb5e106":"5rRWg","929beafcb667b7c4":"1dlk8"}],"89fxU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("407069ea89e26f09").default;
var _interopRequireWildcard = require("31f2783b9a91bef7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "css", {
    enumerable: true,
    get: function() {
        return _system.css;
    }
});
exports.globalCss = globalCss;
exports.internal_createExtendSxProp = internal_createExtendSxProp;
Object.defineProperty(exports, "keyframes", {
    enumerable: true,
    get: function() {
        return _system.keyframes;
    }
});
Object.defineProperty(exports, "styled", {
    enumerable: true,
    get: function() {
        return _styled.default;
    }
});
Object.defineProperty(exports, "useTheme", {
    enumerable: true,
    get: function() {
        return _useTheme.default;
    }
});
var React = _interopRequireWildcard(require("3e71abd26e55f26b"));
var _styleFunctionSx = require("bfd0e1aeb380e6d1");
var _useTheme = _interopRequireDefault(require("d299e6c723c421bf"));
var _GlobalStyles = _interopRequireDefault(require("27d002377f60cb4e"));
var _jsxRuntime = require("6713fc0ccce24c19");
var _system = require("4a4d550ba1eacd52");
var _styled = _interopRequireDefault(require("2ed34ee38246058d"));
function globalCss(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, _jsxRuntime.jsx)(_GlobalStyles.default, {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme,
                    ...props
                }) : styles
        }));
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function internal_createExtendSxProp() {
    return _styleFunctionSx.extendSxProp;
}

},{"407069ea89e26f09":"kZ6eK","31f2783b9a91bef7":"fiRIh","3e71abd26e55f26b":"9njXz","bfd0e1aeb380e6d1":"e1roB","d299e6c723c421bf":"d8hfc","27d002377f60cb4e":"Tt5ys","6713fc0ccce24c19":"1dlk8","4a4d550ba1eacd52":"iFfXs","2ed34ee38246058d":"bTnxF"}],"d8hfc":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("61e03a0156e416a1").default;
var _interopRequireWildcard = require("6ffa06d021160115").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useTheme;
var React = _interopRequireWildcard(require("8a40016487b63d87"));
var _system = require("457df495ffa84322");
var _defaultTheme = _interopRequireDefault(require("63ebbe502362c7c9"));
var _identifier = _interopRequireDefault(require("81c53f68f8a78aa5"));
function useTheme() {
    const theme = (0, _system.useTheme)(_defaultTheme.default);
    return theme[_identifier.default] || theme;
}

},{"61e03a0156e416a1":"kZ6eK","6ffa06d021160115":"fiRIh","8a40016487b63d87":"9njXz","457df495ffa84322":"iFfXs","63ebbe502362c7c9":"gDdTD","81c53f68f8a78aa5":"asvw3"}],"gDdTD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c992951b753a9ab3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createTheme = _interopRequireDefault(require("e0a3c219f881eb2a"));
const defaultTheme = (0, _createTheme.default)();
var _default = exports.default = defaultTheme;

},{"c992951b753a9ab3":"kZ6eK","e0a3c219f881eb2a":"itHnG"}],"itHnG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f53bf87bf42dedc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createTheme;
var _createPalette = _interopRequireDefault(require("ce01a4e2b614fac5"));
var _createThemeWithVars = _interopRequireDefault(require("9ef23b096d7a489b"));
var _createThemeNoVars = _interopRequireDefault(require("22170ee3bd11250f"));
// eslint-disable-next-line consistent-return
function attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, _createPalette.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function createTheme(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette, cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, _createThemeNoVars.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, _createThemeNoVars.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, _createThemeWithVars.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

},{"f53bf87bf42dedc":"kZ6eK","ce01a4e2b614fac5":"aVFYX","9ef23b096d7a489b":"256vF","22170ee3bd11250f":"1eZMt"}],"aVFYX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("11300292bb3e3dc3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dark = void 0;
exports.default = createPalette;
exports.light = void 0;
var _formatMuiErrorMessage = _interopRequireDefault(require("a2877fe4b287d6b0"));
var _deepmerge = _interopRequireDefault(require("fa27818bbfce2f16"));
var _colorManipulator = require("984635010f11e72f");
var _common = _interopRequireDefault(require("2df4f74bc61cb41e"));
var _grey = _interopRequireDefault(require("3b7e746b54059808"));
var _purple = _interopRequireDefault(require("38df14157d06197c"));
var _red = _interopRequireDefault(require("3b28d80ed8bb4b59"));
var _orange = _interopRequireDefault(require("90db4edb20684717"));
var _blue = _interopRequireDefault(require("9701b07c082fb52f"));
var _lightBlue = _interopRequireDefault(require("ecf564fbe0fdcdd4"));
var _green = _interopRequireDefault(require("827981c919ddbe32"));
function getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: _common.default.white,
            default: _common.default.white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const light = exports.light = getLight();
function getDark() {
    return {
        text: {
            primary: _common.default.white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: _common.default.white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const dark = exports.dark = getDark();
function addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffsetDark);
    }
}
function getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: _blue.default[200],
        light: _blue.default[50],
        dark: _blue.default[400]
    };
    return {
        main: _blue.default[700],
        light: _blue.default[400],
        dark: _blue.default[800]
    };
}
function getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: _purple.default[200],
        light: _purple.default[50],
        dark: _purple.default[400]
    };
    return {
        main: _purple.default[500],
        light: _purple.default[300],
        dark: _purple.default[700]
    };
}
function getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: _red.default[500],
        light: _red.default[300],
        dark: _red.default[700]
    };
    return {
        main: _red.default[700],
        light: _red.default[400],
        dark: _red.default[800]
    };
}
function getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: _lightBlue.default[400],
        light: _lightBlue.default[300],
        dark: _lightBlue.default[700]
    };
    return {
        main: _lightBlue.default[700],
        light: _lightBlue.default[500],
        dark: _lightBlue.default[900]
    };
}
function getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: _green.default[400],
        light: _green.default[300],
        dark: _green.default[700]
    };
    return {
        main: _green.default[800],
        light: _green.default[500],
        dark: _green.default[900]
    };
}
function getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: _orange.default[400],
        light: _orange.default[300],
        dark: _orange.default[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: _orange.default[500],
        dark: _orange.default[900]
    };
}
function createPalette(palette) {
    const { mode = 'light', contrastThreshold = 3, tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || getDefaultPrimary(mode);
    const secondary = palette.secondary || getDefaultSecondary(mode);
    const error = palette.error || getDefaultError(mode);
    const info = palette.info || getDefaultInfo(mode);
    const success = palette.success || getDefaultSuccess(mode);
    const warning = palette.warning || getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color, name, mainShade = 500, lightShade = 300, darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, _formatMuiErrorMessage.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, _formatMuiErrorMessage.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        addLightOrDark(color, 'light', lightShade, tonalOffset);
        addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = getLight();
    else if (mode === 'dark') modeHydrated = getDark();
    const paletteOutput = (0, _deepmerge.default)({
        // A collection of common colors.
        common: {
            ..._common.default
        },
        // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        // The grey colors.
        grey: _grey.default,
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        // Generate a rich color object.
        augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

},{"11300292bb3e3dc3":"kZ6eK","a2877fe4b287d6b0":"gOgzd","fa27818bbfce2f16":"7wtTC","984635010f11e72f":"hTYBL","2df4f74bc61cb41e":"kNQfe","3b7e746b54059808":"kAOPX","38df14157d06197c":"diL7Q","3b28d80ed8bb4b59":"hdlMU","90db4edb20684717":"kBlig","9701b07c082fb52f":"4VxbD","ecf564fbe0fdcdd4":"bZYpg","827981c919ddbe32":"jwjip"}],"kNQfe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const common = {
    black: '#000',
    white: '#fff'
};
var _default = exports.default = common;

},{}],"kAOPX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var _default = exports.default = grey;

},{}],"diL7Q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var _default = exports.default = purple;

},{}],"hdlMU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var _default = exports.default = red;

},{}],"kBlig":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var _default = exports.default = orange;

},{}],"4VxbD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var _default = exports.default = blue;

},{}],"bZYpg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var _default = exports.default = lightBlue;

},{}],"jwjip":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var _default = exports.default = green;

},{}],"256vF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("d8808f819a1bf945").default;
var _interopRequireDefault = require("bea5e0872ce0e7c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createGetCssVar = void 0;
exports.default = createThemeWithVars;
var _formatMuiErrorMessage = _interopRequireDefault(require("751b6f741077bdbc"));
var _deepmerge = _interopRequireDefault(require("e7792937e505ac24"));
var _system = require("9eb61503fd6adc33");
var _spacing = require("59490245e8036a49");
var _cssVars = require("2face3efcd065aaf");
var _styleFunctionSx = _interopRequireWildcard(require("a25b28b771837a2a"));
var _colorManipulator = require("6884cbd1e7c9be0a");
var _createThemeNoVars = _interopRequireDefault(require("27733fa219b7fb30"));
var _createColorScheme = _interopRequireWildcard(require("5e5614154b2981d1"));
var _shouldSkipGeneratingVar = _interopRequireDefault(require("dbc865706904d0d5"));
var _createGetSelector = _interopRequireDefault(require("2cca8165c721c3f"));
var _stringifyTheme = require("4b7f097c78e64286");
function assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, _colorManipulator.hslToRgb)(color);
}
function setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, _colorManipulator.private_safeColorChannel)(toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const createGetCssVar = (cssVarPrefix = 'mui')=>(0, _system.unstable_createGetCssVar)(cssVarPrefix);
exports.createGetCssVar = createGetCssVar;
function attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, _createColorScheme.default)({
            ...scheme,
            palette: {
                mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette, ...muiTheme } = (0, _createThemeNoVars.default)({
        ...restTheme,
        palette: {
            mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette,
        opacity: {
            ...(0, _createColorScheme.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, _createColorScheme.getOverlays)(mode)
    };
    return muiTheme;
}
/**
 * A default `createThemeWithVars` comes with a single color scheme, either `light` or `dark` based on the `defaultColorScheme`.
 * This is better suited for apps that only need a single color scheme.
 *
 * To enable built-in `light` and `dark` color schemes, either:
 * 1. provide a `colorSchemeSelector` to define how the color schemes will change.
 * 2. provide `colorSchemes.dark` will set `colorSchemeSelector: 'media'` by default.
 */ function createThemeWithVars(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme = false, cssVarPrefix = 'mui', shouldSkipGeneratingVar = _shouldSkipGeneratingVar.default, colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = createGetCssVar(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, _formatMuiErrorMessage.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme,
        ...muiTheme,
        cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector,
        getCssVar,
        colorSchemes,
        font: {
            ...(0, _cssVars.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            setColor(palette.common, 'background', '#fff');
            setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            setColor(palette.common, 'background', '#000');
            setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            setColor(palette.Alert, 'errorColor', (0, _colorManipulator.private_safeDarken)(palette.error.light, 0.6));
            setColor(palette.Alert, 'infoColor', (0, _colorManipulator.private_safeDarken)(palette.info.light, 0.6));
            setColor(palette.Alert, 'successColor', (0, _colorManipulator.private_safeDarken)(palette.success.light, 0.6));
            setColor(palette.Alert, 'warningColor', (0, _colorManipulator.private_safeDarken)(palette.warning.light, 0.6));
            setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            setColor(palette.Alert, 'errorFilledColor', silent(()=>palette.getContrastText(palette.error.main)));
            setColor(palette.Alert, 'infoFilledColor', silent(()=>palette.getContrastText(palette.info.main)));
            setColor(palette.Alert, 'successFilledColor', silent(()=>palette.getContrastText(palette.success.main)));
            setColor(palette.Alert, 'warningFilledColor', silent(()=>palette.getContrastText(palette.warning.main)));
            setColor(palette.Alert, 'errorStandardBg', (0, _colorManipulator.private_safeLighten)(palette.error.light, 0.9));
            setColor(palette.Alert, 'infoStandardBg', (0, _colorManipulator.private_safeLighten)(palette.info.light, 0.9));
            setColor(palette.Alert, 'successStandardBg', (0, _colorManipulator.private_safeLighten)(palette.success.light, 0.9));
            setColor(palette.Alert, 'warningStandardBg', (0, _colorManipulator.private_safeLighten)(palette.warning.light, 0.9));
            setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            setColor(palette.LinearProgress, 'primaryBg', (0, _colorManipulator.private_safeLighten)(palette.primary.main, 0.62));
            setColor(palette.LinearProgress, 'secondaryBg', (0, _colorManipulator.private_safeLighten)(palette.secondary.main, 0.62));
            setColor(palette.LinearProgress, 'errorBg', (0, _colorManipulator.private_safeLighten)(palette.error.main, 0.62));
            setColor(palette.LinearProgress, 'infoBg', (0, _colorManipulator.private_safeLighten)(palette.info.main, 0.62));
            setColor(palette.LinearProgress, 'successBg', (0, _colorManipulator.private_safeLighten)(palette.success.main, 0.62));
            setColor(palette.LinearProgress, 'warningBg', (0, _colorManipulator.private_safeLighten)(palette.warning.main, 0.62));
            setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            setColor(palette.Slider, 'primaryTrack', (0, _colorManipulator.private_safeLighten)(palette.primary.main, 0.62));
            setColor(palette.Slider, 'secondaryTrack', (0, _colorManipulator.private_safeLighten)(palette.secondary.main, 0.62));
            setColor(palette.Slider, 'errorTrack', (0, _colorManipulator.private_safeLighten)(palette.error.main, 0.62));
            setColor(palette.Slider, 'infoTrack', (0, _colorManipulator.private_safeLighten)(palette.info.main, 0.62));
            setColor(palette.Slider, 'successTrack', (0, _colorManipulator.private_safeLighten)(palette.success.main, 0.62));
            setColor(palette.Slider, 'warningTrack', (0, _colorManipulator.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, _colorManipulator.private_safeEmphasize)(palette.background.default, 0.8);
            setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            setColor(palette.SnackbarContent, 'color', silent(()=>palette.getContrastText(snackbarContentBackground)));
            setColor(palette.SpeedDialAction, 'fabHoverBg', (0, _colorManipulator.private_safeEmphasize)(palette.background.paper, 0.15));
            setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            setColor(palette.Switch, 'primaryDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.primary.main, 0.62));
            setColor(palette.Switch, 'secondaryDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.secondary.main, 0.62));
            setColor(palette.Switch, 'errorDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.error.main, 0.62));
            setColor(palette.Switch, 'infoDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.info.main, 0.62));
            setColor(palette.Switch, 'successDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.success.main, 0.62));
            setColor(palette.Switch, 'warningDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.warning.main, 0.62));
            setColor(palette.TableCell, 'border', (0, _colorManipulator.private_safeLighten)((0, _colorManipulator.private_safeAlpha)(palette.divider, 1), 0.88));
            setColor(palette.Tooltip, 'bg', (0, _colorManipulator.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            setColor(palette.Alert, 'errorColor', (0, _colorManipulator.private_safeLighten)(palette.error.light, 0.6));
            setColor(palette.Alert, 'infoColor', (0, _colorManipulator.private_safeLighten)(palette.info.light, 0.6));
            setColor(palette.Alert, 'successColor', (0, _colorManipulator.private_safeLighten)(palette.success.light, 0.6));
            setColor(palette.Alert, 'warningColor', (0, _colorManipulator.private_safeLighten)(palette.warning.light, 0.6));
            setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            setColor(palette.Alert, 'errorFilledColor', silent(()=>palette.getContrastText(palette.error.dark)));
            setColor(palette.Alert, 'infoFilledColor', silent(()=>palette.getContrastText(palette.info.dark)));
            setColor(palette.Alert, 'successFilledColor', silent(()=>palette.getContrastText(palette.success.dark)));
            setColor(palette.Alert, 'warningFilledColor', silent(()=>palette.getContrastText(palette.warning.dark)));
            setColor(palette.Alert, 'errorStandardBg', (0, _colorManipulator.private_safeDarken)(palette.error.light, 0.9));
            setColor(palette.Alert, 'infoStandardBg', (0, _colorManipulator.private_safeDarken)(palette.info.light, 0.9));
            setColor(palette.Alert, 'successStandardBg', (0, _colorManipulator.private_safeDarken)(palette.success.light, 0.9));
            setColor(palette.Alert, 'warningStandardBg', (0, _colorManipulator.private_safeDarken)(palette.warning.light, 0.9));
            setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            setColor(palette.LinearProgress, 'primaryBg', (0, _colorManipulator.private_safeDarken)(palette.primary.main, 0.5));
            setColor(palette.LinearProgress, 'secondaryBg', (0, _colorManipulator.private_safeDarken)(palette.secondary.main, 0.5));
            setColor(palette.LinearProgress, 'errorBg', (0, _colorManipulator.private_safeDarken)(palette.error.main, 0.5));
            setColor(palette.LinearProgress, 'infoBg', (0, _colorManipulator.private_safeDarken)(palette.info.main, 0.5));
            setColor(palette.LinearProgress, 'successBg', (0, _colorManipulator.private_safeDarken)(palette.success.main, 0.5));
            setColor(palette.LinearProgress, 'warningBg', (0, _colorManipulator.private_safeDarken)(palette.warning.main, 0.5));
            setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            setColor(palette.Slider, 'primaryTrack', (0, _colorManipulator.private_safeDarken)(palette.primary.main, 0.5));
            setColor(palette.Slider, 'secondaryTrack', (0, _colorManipulator.private_safeDarken)(palette.secondary.main, 0.5));
            setColor(palette.Slider, 'errorTrack', (0, _colorManipulator.private_safeDarken)(palette.error.main, 0.5));
            setColor(palette.Slider, 'infoTrack', (0, _colorManipulator.private_safeDarken)(palette.info.main, 0.5));
            setColor(palette.Slider, 'successTrack', (0, _colorManipulator.private_safeDarken)(palette.success.main, 0.5));
            setColor(palette.Slider, 'warningTrack', (0, _colorManipulator.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, _colorManipulator.private_safeEmphasize)(palette.background.default, 0.98);
            setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            setColor(palette.SnackbarContent, 'color', silent(()=>palette.getContrastText(snackbarContentBackground)));
            setColor(palette.SpeedDialAction, 'fabHoverBg', (0, _colorManipulator.private_safeEmphasize)(palette.background.paper, 0.15));
            setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            setColor(palette.Switch, 'primaryDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.primary.main, 0.55));
            setColor(palette.Switch, 'secondaryDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.secondary.main, 0.55));
            setColor(palette.Switch, 'errorDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.error.main, 0.55));
            setColor(palette.Switch, 'infoDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.info.main, 0.55));
            setColor(palette.Switch, 'successDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.success.main, 0.55));
            setColor(palette.Switch, 'warningDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.warning.main, 0.55));
            setColor(palette.TableCell, 'border', (0, _colorManipulator.private_safeDarken)((0, _colorManipulator.private_safeAlpha)(palette.divider, 1), 0.68));
            setColor(palette.Tooltip, 'bg', (0, _colorManipulator.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        setColorChannel(palette.background, 'paper');
        setColorChannel(palette.common, 'background');
        setColorChannel(palette.common, 'onBackground');
        setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) setColor(palette[color], 'mainChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.main)));
                if (colors.light) setColor(palette[color], 'lightChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.light)));
                if (colors.dark) setColor(palette[color], 'darkChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.dark)));
                if (colors.contrastText) setColor(palette[color], 'contrastTextChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    setColorChannel(palette[color], 'primary');
                    setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) setColorChannel(palette[color], 'active');
                    if (colors.selected) setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, _deepmerge.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme,
        shouldSkipGeneratingVar,
        getSelector: (0, _createGetSelector.default)(theme)
    };
    const { vars, generateThemeVars, generateStyleSheets } = (0, _cssVars.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, _system.createSpacing)(input.spacing, (0, _spacing.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, _cssVars.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ..._styleFunctionSx.unstable_defaultSxConfig,
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = _stringifyTheme.stringifyTheme; // for Pigment CSS integration
    return theme;
}

},{"d8808f819a1bf945":"fiRIh","bea5e0872ce0e7c":"kZ6eK","751b6f741077bdbc":"gOgzd","e7792937e505ac24":"7wtTC","9eb61503fd6adc33":"iFfXs","59490245e8036a49":"3PKpA","2face3efcd065aaf":"eehcx","a25b28b771837a2a":"e1roB","6884cbd1e7c9be0a":"hTYBL","27733fa219b7fb30":"1eZMt","5e5614154b2981d1":"c8Nxs","dbc865706904d0d5":"i7Nw9","2cca8165c721c3f":"6YtRe","4b7f097c78e64286":"iVLNe"}],"1eZMt":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("d9ce763f7b929c20").default;
var _interopRequireDefault = require("4ca1ae3b8db86e4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _formatMuiErrorMessage = _interopRequireDefault(require("2ce25b3954411343"));
var _deepmerge = _interopRequireDefault(require("dfbc1ae367572d65"));
var _styleFunctionSx = _interopRequireWildcard(require("bc903d7f62929142"));
var _createTheme = _interopRequireDefault(require("b30260b8d167117"));
var _generateUtilityClass = _interopRequireDefault(require("cc7616ad38094a17"));
var _createMixins = _interopRequireDefault(require("6738902b69256df3"));
var _createPalette = _interopRequireDefault(require("e87ac0dc0f47e984"));
var _createTypography = _interopRequireDefault(require("eacfc05dd7822340"));
var _shadows = _interopRequireDefault(require("720618e07ac7b6c0"));
var _createTransitions = _interopRequireDefault(require("81833621a096484c"));
var _zIndex = _interopRequireDefault(require("b63c3c17828ab144"));
var _stringifyTheme = require("402a5e9a32837486");
function createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, _formatMuiErrorMessage.default)(20));
    const palette = (0, _createPalette.default)(paletteInput);
    const systemTheme = (0, _createTheme.default)(options);
    let muiTheme = (0, _deepmerge.default)(systemTheme, {
        mixins: (0, _createMixins.default)(systemTheme.breakpoints, mixinsInput),
        palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: _shadows.default.slice(),
        typography: (0, _createTypography.default)(palette, typographyInput),
        transitions: (0, _createTransitions.default)(transitionsInput),
        zIndex: {
            ..._zIndex.default
        }
    });
    muiTheme = (0, _deepmerge.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, _deepmerge.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ..._styleFunctionSx.unstable_defaultSxConfig,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = _stringifyTheme.stringifyTheme; // for Pigment CSS integration
    return muiTheme;
}
var _default = exports.default = createThemeNoVars;

},{"d9ce763f7b929c20":"fiRIh","4ca1ae3b8db86e4":"kZ6eK","2ce25b3954411343":"gOgzd","dfbc1ae367572d65":"7wtTC","bc903d7f62929142":"e1roB","b30260b8d167117":"lBucb","cc7616ad38094a17":"jBs9M","6738902b69256df3":"dprtV","e87ac0dc0f47e984":"aVFYX","eacfc05dd7822340":"byLfw","720618e07ac7b6c0":"5byGs","81833621a096484c":"4xJuz","b63c3c17828ab144":"eqp2B","402a5e9a32837486":"iVLNe"}],"dprtV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createMixins;
function createMixins(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

},{}],"byLfw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("75255ca3acc1f720").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createTypography;
var _deepmerge = _interopRequireDefault(require("cacbc6b8de202000"));
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
    textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */ function createTypography(palette, typography) {
    const { fontFamily = defaultFontFamily, // The default font size of the Material Specification.
    fontSize = 14, // px
    fontWeightLight = 300, fontWeightRegular = 400, fontWeightMedium = 500, fontWeightBold = 700, // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily,
            fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === defaultFontFamily ? {
                letterSpacing: `${round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, _deepmerge.default)({
        htmlFontSize,
        pxToRem,
        fontFamily,
        fontSize,
        fontWeightLight,
        fontWeightRegular,
        fontWeightMedium,
        fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

},{"75255ca3acc1f720":"kZ6eK","cacbc6b8de202000":"7wtTC"}],"5byGs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = [
    'none',
    createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var _default = exports.default = shadows;

},{}],"4xJuz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createTransitions;
exports.easing = exports.duration = void 0;
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const duration = exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function createTransitions(inputTransitions) {
    const mergedEasing = {
        ...easing,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...duration,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration,
        create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

},{}],"eqp2B":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var _default = exports.default = zIndex;

},{}],"iVLNe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stringifyTheme = stringifyTheme;
var _deepmerge = require("252af5ceea3ec102");
/* eslint-disable import/prefer-default-export */ function isSerializable(val) {
    return (0, _deepmerge.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
/**
 * `baseTheme` usually comes from `createTheme()` or `extendTheme()`.
 *
 * This function is intended to be used with zero-runtime CSS-in-JS like Pigment CSS
 * For example, in a Next.js project:
 *
 * ```js
 * // next.config.js
 * const { extendTheme } = require('@mui/material/styles');
 *
 * const theme = extendTheme();
 * // `.toRuntimeSource` is Pigment CSS specific to create a theme that is available at runtime.
 * theme.toRuntimeSource = stringifyTheme;
 *
 * module.exports = withPigment({
 *  theme,
 * });
 * ```
 */ function stringifyTheme(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, _deepmerge.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

},{"252af5ceea3ec102":"7wtTC"}],"c8Nxs":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("618e944942a678bc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createColorScheme;
exports.getOpacity = getOpacity;
exports.getOverlays = getOverlays;
var _createPalette = _interopRequireDefault(require("d85774e08ce63ca1"));
var _getOverlayAlpha = _interopRequireDefault(require("37ea8458a36a9021"));
const defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, _getOverlayAlpha.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function getOpacity(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function getOverlays(mode) {
    return mode === 'dark' ? defaultDarkOverlays : [];
}
function createColorScheme(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, // need to cast to avoid module augmentation test
    opacity, overlays, ...rest } = options;
    const palette = (0, _createPalette.default)(paletteInput);
    return {
        palette,
        opacity: {
            ...getOpacity(palette.mode),
            ...opacity
        },
        overlays: overlays || getOverlays(palette.mode),
        ...rest
    };
}

},{"618e944942a678bc":"kZ6eK","d85774e08ce63ca1":"aVFYX","37ea8458a36a9021":"5bDnG"}],"5bDnG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getOverlayAlpha;
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function getOverlayAlpha(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

},{}],"i7Nw9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = shouldSkipGeneratingVar;
function shouldSkipGeneratingVar(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

},{}],"6YtRe":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d6ca57478bef72be").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _excludeVariablesFromRoot = _interopRequireDefault(require("85ae86ef6d080de1"));
var _default = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, _excludeVariablesFromRoot.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };
exports.default = _default;

},{"d6ca57478bef72be":"kZ6eK","85ae86ef6d080de1":"2gXZR"}],"2gXZR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var _default = exports.default = excludeVariablesFromRoot;

},{}],"asvw3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = exports.default = '$$material';

},{}],"Tt5ys":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f9880f8d885ac2e8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _GlobalStyles.default;
    }
});
var _GlobalStyles = _interopRequireDefault(require("b9f4976014d6913f"));

},{"f9880f8d885ac2e8":"kZ6eK","b9f4976014d6913f":"5IUCa"}],"5IUCa":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("1392d07de526b602").default;
var _interopRequireWildcard = require("b6c7628a193f95bd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("5856fa52a3decdab"));
var _propTypes = _interopRequireDefault(require("7185862242ebb481"));
var _system = require("b58da0205ef0cfe2");
var _defaultTheme = _interopRequireDefault(require("bbea7f156f2694a7"));
var _identifier = _interopRequireDefault(require("2e904b2a2708b805"));
var _jsxRuntime = require("33d9951a73ac4f90");
function GlobalStyles(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_system.GlobalStyles, {
        ...props,
        defaultTheme: _defaultTheme.default,
        themeId: _identifier.default
    });
}
var _default = exports.default = GlobalStyles;

},{"1392d07de526b602":"kZ6eK","b6c7628a193f95bd":"fiRIh","5856fa52a3decdab":"9njXz","7185862242ebb481":"bnNSm","b58da0205ef0cfe2":"iFfXs","bbea7f156f2694a7":"gDdTD","2e904b2a2708b805":"asvw3","33d9951a73ac4f90":"1dlk8"}],"bTnxF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("46f194eea215b25b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
Object.defineProperty(exports, "rootShouldForwardProp", {
    enumerable: true,
    get: function() {
        return _rootShouldForwardProp.default;
    }
});
Object.defineProperty(exports, "slotShouldForwardProp", {
    enumerable: true,
    get: function() {
        return _slotShouldForwardProp.default;
    }
});
var _createStyled = _interopRequireDefault(require("7541497f21100948"));
var _defaultTheme = _interopRequireDefault(require("a51c70a755109123"));
var _identifier = _interopRequireDefault(require("e01ea68023bdabf7"));
var _rootShouldForwardProp = _interopRequireDefault(require("b52a4685664121c4"));
var _slotShouldForwardProp = _interopRequireDefault(require("c865ce001be73693"));
const styled = (0, _createStyled.default)({
    themeId: _identifier.default,
    defaultTheme: _defaultTheme.default,
    rootShouldForwardProp: _rootShouldForwardProp.default
});
var _default = exports.default = styled;

},{"46f194eea215b25b":"kZ6eK","7541497f21100948":"6ySdS","a51c70a755109123":"gDdTD","e01ea68023bdabf7":"asvw3","b52a4685664121c4":"dIcrQ","c865ce001be73693":"arfz9"}],"dIcrQ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6404fb53913fc632").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _slotShouldForwardProp = _interopRequireDefault(require("3aac4bd51a94273"));
const rootShouldForwardProp = (prop)=>(0, _slotShouldForwardProp.default)(prop) && prop !== 'classes';
var _default = exports.default = rootShouldForwardProp;

},{"6404fb53913fc632":"kZ6eK","3aac4bd51a94273":"arfz9"}],"arfz9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
// copied from @mui/system/createStyled
function slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var _default = exports.default = slotShouldForwardProp;

},{}],"2zy52":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _system = require("f03a4bb5a097fe86");
const memoTheme = _system.unstable_memoTheme;
var _default = exports.default = memoTheme;

},{"f03a4bb5a097fe86":"iFfXs"}],"ff3VX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7ca0498996ac6a9a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DefaultPropsProvider.default;
    }
});
Object.defineProperty(exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return _DefaultPropsProvider.useDefaultProps;
    }
});
var _DefaultPropsProvider = _interopRequireWildcard(require("fa58f46e6a8e5fa6"));

},{"7ca0498996ac6a9a":"fiRIh","fa58f46e6a8e5fa6":"1g0Hr"}],"1g0Hr":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("934db433ace115f4").default;
var _interopRequireWildcard = require("482328344ea8d058").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.useDefaultProps = useDefaultProps;
var React = _interopRequireWildcard(require("61ef5b59ca892097"));
var _propTypes = _interopRequireDefault(require("a6d8746085aadd0f"));
var _DefaultPropsProvider = _interopRequireWildcard(require("86fb11f1887166d1"));
var _jsxRuntime = require("dc11d023c4c98e16");
function DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DefaultPropsProvider.default, {
        ...props
    });
}
var _default = exports.default = DefaultPropsProvider;
function useDefaultProps(params) {
    return (0, _DefaultPropsProvider.useDefaultProps)(params);
}

},{"934db433ace115f4":"kZ6eK","482328344ea8d058":"fiRIh","61ef5b59ca892097":"9njXz","a6d8746085aadd0f":"bnNSm","86fb11f1887166d1":"aF5dK","dc11d023c4c98e16":"1dlk8"}],"5rRWg":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6b145cf177abb3fd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getSvgIconUtilityClass = getSvgIconUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4bee8b0548abe6a0"));
var _generateUtilityClass = _interopRequireDefault(require("df2eb8ab8aaff529"));
function getSvgIconUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiSvgIcon', slot);
}
const svgIconClasses = (0, _generateUtilityClasses.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var _default = exports.default = svgIconClasses;

},{"6b145cf177abb3fd":"kZ6eK","4bee8b0548abe6a0":"7pSUk","df2eb8ab8aaff529":"jBs9M"}],"cvBWT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3822caca522cc087").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _debounce = _interopRequireDefault(require("4269fbe739e9527"));
var _default = exports.default = _debounce.default;

},{"3822caca522cc087":"kZ6eK","4269fbe739e9527":"f6vcJ"}],"3n9Eo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7ef2d20d084bd68a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _deprecatedPropType = _interopRequireDefault(require("151ffb2240185ab0"));
var _default = exports.default = _deprecatedPropType.default;

},{"7ef2d20d084bd68a":"kZ6eK","151ffb2240185ab0":"bCejB"}],"bgSQq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("55297cc2e8834fdd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isMuiElement = _interopRequireDefault(require("461ab8f5c7fe311b"));
var _default = exports.default = _isMuiElement.default;

},{"55297cc2e8834fdd":"kZ6eK","461ab8f5c7fe311b":"4sqhm"}],"7Yspg":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("28e50b3e9fd11f52").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _ownerDocument = _interopRequireDefault(require("ca94342cc2753d59"));
var _default = exports.default = _ownerDocument.default;

},{"28e50b3e9fd11f52":"kZ6eK","ca94342cc2753d59":"8VgUE"}],"4Wjh2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("aa797ec0df2f33ba").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _ownerWindow = _interopRequireDefault(require("9c4553051371c676"));
var _default = exports.default = _ownerWindow.default;

},{"aa797ec0df2f33ba":"kZ6eK","9c4553051371c676":"hiDmU"}],"g4unq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("56b7b495be505bcb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _requirePropFactory = _interopRequireDefault(require("f9f10cc361b82a43"));
var _default = exports.default = _requirePropFactory.default;

},{"56b7b495be505bcb":"kZ6eK","f9f10cc361b82a43":"3mu6c"}],"hWYln":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e24796f0966f49d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _setRef = _interopRequireDefault(require("fee9bdd29dfbbf15"));
var _default = exports.default = _setRef.default;

},{"e24796f0966f49d":"kZ6eK","fee9bdd29dfbbf15":"8uRhj"}],"hXusa":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("64b708bdadfd621a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useEnhancedEffect = _interopRequireDefault(require("2acbeb468710cf8f"));
var _default = exports.default = _useEnhancedEffect.default;

},{"64b708bdadfd621a":"kZ6eK","2acbeb468710cf8f":"fIvqa"}],"iMSy2":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("bb5749fb3ccef0e6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useId = _interopRequireDefault(require("949bff5092237717"));
var _default = exports.default = _useId.default;

},{"bb5749fb3ccef0e6":"kZ6eK","949bff5092237717":"50qgI"}],"lTxN8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3eca2a8869ff9e8c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _unsupportedProp = _interopRequireDefault(require("fca16de8fd487075"));
var _default = exports.default = _unsupportedProp.default;

},{"3eca2a8869ff9e8c":"kZ6eK","fca16de8fd487075":"5Zw9y"}],"1VreF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("12e10b690fd82a1b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useControlled = _interopRequireDefault(require("9a5904ff431507bf"));
var _default = exports.default = _useControlled.default;

},{"12e10b690fd82a1b":"kZ6eK","9a5904ff431507bf":"jwZrv"}],"jTtn3":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e78d2301afd5a250").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useEventCallback = _interopRequireDefault(require("db042c62a6b9bd92"));
var _default = exports.default = _useEventCallback.default;

},{"e78d2301afd5a250":"kZ6eK","db042c62a6b9bd92":"feNJe"}],"cq8Sn":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("69a3a6f070339fed").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useForkRef = _interopRequireDefault(require("751098f668527ee9"));
var _default = exports.default = _useForkRef.default;

},{"69a3a6f070339fed":"kZ6eK","751098f668527ee9":"4xKTx"}],"1XZUh":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("749246e667319985").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mergeSlotProps;
var _clsx = _interopRequireDefault(require("bafa59885bdd07cb"));
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function mergeSlotProps(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if (isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, _clsx.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, _clsx.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

},{"749246e667319985":"kZ6eK","bafa59885bdd07cb":"d2NWs"}],"eRDc8":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("8ee63de35adad671").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("844049b74d6acb38"));
var _jsxRuntime = require("59ceb3871d77d8c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), 'Warning');

},{"8ee63de35adad671":"kZ6eK","844049b74d6acb38":"2vOnF","59ceb3871d77d8c":"1dlk8"}],"4XfdO":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("7b6bec045d2c0e45").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("a0755c411e3b87b1"));
var _jsxRuntime = require("21c44aa95307b304");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error');

},{"7b6bec045d2c0e45":"kZ6eK","a0755c411e3b87b1":"2vOnF","21c44aa95307b304":"1dlk8"}],"juq3i":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("47a6f4581a16ed9c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("caa96ff3f2966434"));
var _jsxRuntime = require("36850a226f59e697");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), 'Info');

},{"47a6f4581a16ed9c":"kZ6eK","caa96ff3f2966434":"2vOnF","36850a226f59e697":"1dlk8"}],"acjz6":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("239535702eb5ed24").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6c62a682237a7579"));
var _jsxRuntime = require("61f3f716cbb9f2ed");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

},{"239535702eb5ed24":"kZ6eK","6c62a682237a7579":"2vOnF","61f3f716cbb9f2ed":"1dlk8"}],"gUaK6":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("31f98b340ff5cc06").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("25cc493e3d5769f7"));
var _jsxRuntime = require("14165500abad842a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

},{"31f98b340ff5cc06":"kZ6eK","25cc493e3d5769f7":"2vOnF","14165500abad842a":"1dlk8"}],"fOT90":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("533062d9db6c12ac").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("460e51dee7c985a"));
var _jsxRuntime = require("2eb8ba69d3ed640e");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');

},{"533062d9db6c12ac":"kZ6eK","460e51dee7c985a":"2vOnF","2eb8ba69d3ed640e":"1dlk8"}],"iGc7o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MaterialDesignContent", ()=>MaterialDesignContent$1);
parcelHelpers.export(exports, "SnackbarContent", ()=>SnackbarContent);
parcelHelpers.export(exports, "SnackbarProvider", ()=>SnackbarProvider);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "closeSnackbar", ()=>closeSnackbar);
parcelHelpers.export(exports, "enqueueSnackbar", ()=>enqueueSnackbar);
parcelHelpers.export(exports, "useSnackbar", ()=>useSnackbar);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _goober = require("goober");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var noOp = function noOp() {
    return '';
};
var SnackbarContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    enqueueSnackbar: noOp,
    closeSnackbar: noOp
});
var breakpoints = {
    downXs: '@media (max-width:599.95px)',
    upSm: '@media (min-width:600px)'
};
var capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + capitalise(anchor.vertical) + capitalise(anchor.horizontal);
};
var isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
var Transition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Transition, _React$Component);
    function Transition(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var appear = props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props["in"]) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    };
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props["in"]) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var enter = timeout;
        var exit = timeout;
        if (timeout != null && typeof timeout !== 'number' && typeof timeout !== 'string') {
            exit = timeout.exit;
            enter = timeout.enter;
        }
        return {
            exit: exit,
            enter: enter
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            this.cancelNextCallback();
            if (nextStatus === ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var isAppearing = mounting;
        var timeouts = this.getTimeouts();
        if (!mounting && !enter) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
            });
            return;
        }
        if (this.props.onEnter) this.props.onEnter(this.node, isAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            if (_this2.props.onEntering) _this2.props.onEntering(_this2.node, isAppearing);
            _this2.onTransitionEnd(timeouts.enter, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: EXITED
            }, function() {
                if (_this3.props.onExited) _this3.props.onExited(_this3.node);
            });
            return;
        }
        if (this.props.onExit) this.props.onExit(this.node);
        this.safeSetState({
            status: EXITING
        }, function() {
            if (_this3.props.onExiting) _this3.props.onExiting(_this3.node);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    if (_this3.props.onExited) _this3.props.onExited(_this3.node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null && this.nextCallback.cancel) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function() {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback();
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!this.node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(this.node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = _objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return children(status, childProps);
    };
    _createClass(Transition, [
        {
            key: "node",
            get: function get() {
                var _this$props$nodeRef;
                var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;
                if (!node) throw new Error('notistack - Custom snackbar is not refForwarding');
                return node;
            }
        }
    ]);
    return Transition;
}((0, _reactDefault.default).Component);
function noop() {}
Transition.defaultProps = {
    "in": false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
/**
 * Credit to MUI team @ https://mui.com
 */ /**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function useForkRef(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return (0, _react.useMemo)(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            setRef(refA, refValue);
            setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function getTransitionProps(props) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, mode = props.mode;
    return {
        duration: typeof timeout === 'object' ? timeout[mode] || 0 : timeout,
        easing: style.transitionTimingFunction,
        delay: style.transitionDelay
    };
}
/**
 * Credit to MUI team @ https://mui.com
 */ var defaultEasing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
/**
 * CSS hack to force a repaint
 */ var reflow = function reflow(node) {
    // We have to do something with node.scrollTop.
    // Otherwise it's removed from the compiled code by optimisers
    // eslint-disable-next-line no-self-assign
    node.scrollTop = node.scrollTop;
};
var formatMs = function formatMs(milliseconds) {
    return Math.round(milliseconds) + "ms";
};
function createTransition(props, options) {
    if (props === void 0) props = [
        'all'
    ];
    var _ref = options || {}, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 300 : _ref$duration, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? defaultEasing.easeInOut : _ref$easing, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
    var properties = Array.isArray(props) ? props : [
        props
    ];
    return properties.map(function(animatedProp) {
        var formattedDuration = typeof duration === 'string' ? duration : formatMs(duration);
        var formattedDelay = typeof delay === 'string' ? delay : formatMs(delay);
        return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
    }).join(',');
}
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}
function ownerWindow(node) {
    var doc = ownerDocument(node);
    return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */ function debounce(func, wait) {
    if (wait === void 0) wait = 166;
    var timeout;
    function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var later = function later() {
            // @ts-ignore
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */ function getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var containerWindow = ownerWindow(node);
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    switch(direction){
        case 'left':
            return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";
        case 'right':
            return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";
        case 'up':
            return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";
        default:
            // down
            return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
    }
}
function setTranslateValue(direction, node) {
    if (!node) return;
    var transform = getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var Slide = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props["in"], style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 0 : _props$timeout, onEnter = props.onEnter, onEntered = props.onEntered, onExit = props.onExit, onExited = props.onExited, other = _objectWithoutPropertiesLoose(props, [
        "children",
        "direction",
        "in",
        "style",
        "timeout",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var nodeRef = (0, _react.useRef)(null);
    var handleRefIntermediary = useForkRef(children.ref, nodeRef);
    var handleRef = useForkRef(handleRefIntermediary, ref);
    var handleEnter = function handleEnter(node, isAppearing) {
        setTranslateValue(direction, node);
        reflow(node);
        if (onEnter) onEnter(node, isAppearing);
    };
    var handleEntering = function handleEntering(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || defaultEasing.easeOut;
        var transitionProps = getTransitionProps({
            timeout: timeout,
            mode: 'enter',
            style: _extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = createTransition('-webkit-transform', transitionProps);
        node.style.transition = createTransition('transform', transitionProps);
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
    };
    var handleExit = function handleExit(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || defaultEasing.sharp;
        var transitionProps = getTransitionProps({
            timeout: timeout,
            mode: 'exit',
            style: _extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = createTransition('-webkit-transform', transitionProps);
        node.style.transition = createTransition('transform', transitionProps);
        setTranslateValue(direction, node);
        if (onExit) onExit(node);
    };
    var handleExited = function handleExited(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    };
    var updatePosition = (0, _react.useCallback)(function() {
        if (nodeRef.current) setTranslateValue(direction, nodeRef.current);
    }, [
        direction
    ]);
    (0, _react.useEffect)(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = debounce(function() {
            if (nodeRef.current) setTranslateValue(direction, nodeRef.current);
        });
        var containerWindow = ownerWindow(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    (0, _react.useEffect)(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return (0, _react.createElement)(Transition, Object.assign({
        appear: true,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: onEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        "in": inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return (0, _react.cloneElement)(children, _extends({
            ref: handleRef,
            style: _extends({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, {}, children.props.style)
        }, childProps));
    });
});
Slide.displayName = 'Slide';
var SvgIcon = function SvgIcon(props) {
    return (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 24 24",
        focusable: "false",
        style: {
            fontSize: 20,
            marginInlineEnd: 8,
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0
        }
    }, props));
};
var CheckIcon = function CheckIcon() {
    return (0, _reactDefault.default).createElement(SvgIcon, null, (0, _reactDefault.default).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var WarningIcon = function WarningIcon() {
    return (0, _reactDefault.default).createElement(SvgIcon, null, (0, _reactDefault.default).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var ErrorIcon = function ErrorIcon() {
    return (0, _reactDefault.default).createElement(SvgIcon, null, (0, _reactDefault.default).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var InfoIcon = function InfoIcon() {
    return (0, _reactDefault.default).createElement(SvgIcon, null, (0, _reactDefault.default).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, _reactDefault.default).createElement(CheckIcon, null),
    warning: /*#__PURE__*/ (0, _reactDefault.default).createElement(WarningIcon, null),
    error: /*#__PURE__*/ (0, _reactDefault.default).createElement(ErrorIcon, null),
    info: /*#__PURE__*/ (0, _reactDefault.default).createElement(InfoIcon, null)
};
var defaults = {
    maxSnack: 3,
    persist: false,
    hideIconVariant: false,
    disableWindowBlurListener: false,
    variant: 'default',
    autoHideDuration: 5000,
    iconVariant: defaultIconVariants,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    TransitionComponent: Slide,
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
    var isNumberOrNull = function isNumberOrNull(numberish) {
        return typeof numberish === 'number' || numberish === null;
    };
    if (isNumberOrNull(optionsDuration)) return optionsDuration;
    if (isNumberOrNull(propsDuration)) return propsDuration;
    return defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
    var is = function is(item, types) {
        return types.some(function(t) {
            return typeof item === t;
        });
    };
    if (is(optionsDuration, [
        'string',
        'number'
    ])) return optionsDuration;
    if (is(optionsDuration, [
        'object'
    ])) return _extends({}, defaults.transitionDuration, {}, is(propsDuration, [
        'object'
    ]) && propsDuration, {}, optionsDuration);
    if (is(propsDuration, [
        'string',
        'number'
    ])) return propsDuration;
    if (is(propsDuration, [
        'object'
    ])) return _extends({}, defaults.transitionDuration, {}, propsDuration);
    return defaults.transitionDuration;
};
var merge = function merge(options, props) {
    return function(name, shouldObjectMerge) {
        if (shouldObjectMerge === void 0) shouldObjectMerge = false;
        if (shouldObjectMerge) return _extends({}, defaults[name], {}, props[name], {}, options[name]);
        if (name === 'autoHideDuration') return getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
        if (name === 'transitionDuration') return getTransitionDuration(options.transitionDuration, props.transitionDuration);
        return options[name] || props[name] || defaults[name];
    };
};
function makeStyles(styles) {
    return Object.entries(styles).reduce(function(acc, _ref) {
        var _extends2;
        var key = _ref[0], value = _ref[1];
        return _extends({}, acc, (_extends2 = {}, _extends2[key] = (0, _goober.css)(value), _extends2));
    }, {});
}
var ComponentClasses = {
    SnackbarContainer: 'notistack-SnackbarContainer',
    Snackbar: 'notistack-Snackbar',
    CollapseWrapper: 'notistack-CollapseWrapper',
    MuiContent: 'notistack-MuiContent',
    MuiContentVariant: function MuiContentVariant(variant) {
        return "notistack-MuiContent-" + variant;
    }
};
var classes = /*#__PURE__*/ makeStyles({
    root: {
        height: 0
    },
    entered: {
        height: 'auto'
    }
});
var collapsedSize = '0px';
var timeout = 175;
var Collapse = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var children = props.children, inProp = props["in"], onExited = props.onExited;
    var wrapperRef = (0, _react.useRef)(null);
    var nodeRef = (0, _react.useRef)(null);
    var handleRef = useForkRef(ref, nodeRef);
    var getWrapperSize = function getWrapperSize() {
        return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    };
    var handleEnter = function handleEnter(node) {
        node.style.height = collapsedSize;
    };
    var handleEntering = function handleEntering(node) {
        var wrapperSize = getWrapperSize();
        var _getTransitionProps = getTransitionProps({
            timeout: timeout,
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, easing = _getTransitionProps.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = wrapperSize + "px";
        node.style.transitionTimingFunction = easing || '';
    };
    var handleEntered = function handleEntered(node) {
        node.style.height = 'auto';
    };
    var handleExit = function handleExit(node) {
        node.style.height = getWrapperSize() + "px";
    };
    var handleExiting = function handleExiting(node) {
        reflow(node);
        var _getTransitionProps2 = getTransitionProps({
            timeout: timeout,
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, easing = _getTransitionProps2.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = collapsedSize;
        node.style.transitionTimingFunction = easing || '';
    };
    return (0, _react.createElement)(Transition, {
        "in": inProp,
        unmountOnExit: true,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: onExited,
        onExiting: handleExiting,
        nodeRef: nodeRef,
        timeout: timeout
    }, function(state, childProps) {
        return (0, _react.createElement)("div", Object.assign({
            ref: handleRef,
            className: (0, _clsxDefault.default)(classes.root, state === 'entered' && classes.entered),
            style: _extends({
                pointerEvents: 'all',
                overflow: 'hidden',
                minHeight: collapsedSize,
                transition: createTransition('height')
            }, state === 'entered' && {
                overflow: 'visible'
            }, {}, state === 'exited' && !inProp && {
                visibility: 'hidden'
            })
        }, childProps), (0, _react.createElement)("div", {
            ref: wrapperRef,
            className: ComponentClasses.CollapseWrapper,
            // Hack to get children with a negative margin to not falsify the height computation.
            style: {
                display: 'flex',
                width: '100%'
            }
        }, children));
    });
});
Collapse.displayName = 'Collapse';
var direction = {
    right: 'left',
    left: 'right',
    bottom: 'up',
    top: 'down'
};
var getSlideDirection = function getSlideDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== 'center') return direction[anchorOrigin.horizontal];
    return direction[anchorOrigin.vertical];
};
/** Tranforms classes name */ var toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
    return "anchorOrigin" + originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
    if (classes === void 0) classes = {};
    var containerClasses = {
        containerRoot: true,
        containerAnchorOriginTopCenter: true,
        containerAnchorOriginBottomCenter: true,
        containerAnchorOriginTopRight: true,
        containerAnchorOriginBottomRight: true,
        containerAnchorOriginTopLeft: true,
        containerAnchorOriginBottomLeft: true
    };
    return Object.keys(classes).filter(function(key) {
        return !containerClasses[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return _extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var noOp$1 = function noOp() {
/* */ };
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function createChainedFunction(funcs, snackbarId) {
    // @ts-ignore
    return funcs.reduce(function(acc, func) {
        if (func === null || func === undefined) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (snackbarId && argums.indexOf(snackbarId) === -1) argums.push(snackbarId);
             // @ts-ignore
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, noOp$1);
}
/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ var useEnhancedEffect = typeof window !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useEventCallback(fn) {
    var ref = (0, _react.useRef)(fn);
    useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, _react.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
/**
 * Credit to MUI team @ https://mui.com
 */ var Snackbar = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var children = props.children, className = props.className, autoHideDuration = props.autoHideDuration, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, id = props.id, open = props.open, _props$SnackbarProps = props.SnackbarProps, SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
    var timerAutoHide = (0, _react.useRef)();
    var handleClose = useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, 'timeout', id);
        }, autoHideDurationParam);
    });
    (0, _react.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, _react.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (SnackbarProps.onMouseEnter) SnackbarProps.onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (SnackbarProps.onMouseLeave) SnackbarProps.onMouseLeave(event);
        handleResume();
    };
    (0, _react.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return function() {
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, _react.createElement)("div", Object.assign({
        ref: ref
    }, SnackbarProps, {
        className: (0, _clsxDefault.default)(ComponentClasses.Snackbar, className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }), children);
});
Snackbar.displayName = 'Snackbar';
var _root;
var classes$1 = /*#__PURE__*/ makeStyles({
    root: (_root = {
        display: 'flex',
        flexWrap: 'wrap',
        flexGrow: 1
    }, _root[breakpoints.upSm] = {
        flexGrow: 'initial',
        minWidth: '288px'
    }, _root)
});
var SnackbarContent = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "className"
    ]);
    return (0, _reactDefault.default).createElement("div", Object.assign({
        ref: ref,
        className: (0, _clsxDefault.default)(classes$1.root, className)
    }, props));
});
SnackbarContent.displayName = 'SnackbarContent';
var classes$2 = /*#__PURE__*/ makeStyles({
    root: {
        backgroundColor: '#313131',
        fontSize: '0.875rem',
        lineHeight: 1.43,
        letterSpacing: '0.01071em',
        color: '#fff',
        alignItems: 'center',
        padding: '6px 16px',
        borderRadius: '4px',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
    },
    lessPadding: {
        paddingLeft: "20px"
    },
    "default": {
        backgroundColor: '#313131'
    },
    success: {
        backgroundColor: '#43a047'
    },
    error: {
        backgroundColor: '#d32f2f'
    },
    warning: {
        backgroundColor: '#ff9800'
    },
    info: {
        backgroundColor: '#2196f3'
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 0'
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '-8px'
    }
});
var ariaDescribedby = 'notistack-snackbar';
var MaterialDesignContent = /*#__PURE__*/ (0, _react.forwardRef)(function(props, forwardedRef) {
    var id = props.id, message = props.message, componentOrFunctionAction = props.action, iconVariant = props.iconVariant, variant = props.variant, hideIconVariant = props.hideIconVariant, style = props.style, className = props.className;
    var icon = iconVariant[variant];
    var action = componentOrFunctionAction;
    if (typeof action === 'function') action = action(id);
    return (0, _reactDefault.default).createElement(SnackbarContent, {
        ref: forwardedRef,
        role: "alert",
        "aria-describedby": ariaDescribedby,
        style: style,
        className: (0, _clsxDefault.default)(ComponentClasses.MuiContent, ComponentClasses.MuiContentVariant(variant), classes$2.root, classes$2[variant], className, !hideIconVariant && icon && classes$2.lessPadding)
    }, (0, _reactDefault.default).createElement("div", {
        id: ariaDescribedby,
        className: classes$2.message
    }, !hideIconVariant ? icon : null, message), action && (0, _reactDefault.default).createElement("div", {
        className: classes$2.action
    }, action));
});
MaterialDesignContent.displayName = 'MaterialDesignContent';
var MaterialDesignContent$1 = /*#__PURE__*/ (0, _react.memo)(MaterialDesignContent);
var styles = /*#__PURE__*/ makeStyles({
    wrappedRoot: {
        width: '100%',
        position: 'relative',
        transform: 'translateX(0)',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minWidth: '288px'
    }
});
var SnackbarItem = function SnackbarItem(props) {
    var timeout = (0, _react.useRef)();
    var _useState = (0, _react.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    var handleClose = createChainedFunction([
        props.snack.onClose,
        props.onClose
    ]);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, 'instructed', props.snack.id);
    };
    var handleExitedScreen = (0, _react.useCallback)(function() {
        timeout.current = setTimeout(function() {
            setCollapsed(function(col) {
                return !col;
            });
        }, 125);
    }, []);
    (0, _react.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var snack = props.snack, allClasses = props.classes, _props$Component = props.Component, Component = _props$Component === void 0 ? MaterialDesignContent$1 : _props$Component;
    var classes = (0, _react.useMemo)(function() {
        return keepSnackbarClassKeys(allClasses);
    }, [
        allClasses
    ]);
    var open = snack.open, SnackbarProps = snack.SnackbarProps, TransitionComponent = snack.TransitionComponent, TransitionProps = snack.TransitionProps, transitionDuration = snack.transitionDuration, disableWindowBlurListener = snack.disableWindowBlurListener, componentOrFunctionContent = snack.content, otherSnack = _objectWithoutPropertiesLoose(snack, [
        "open",
        "SnackbarProps",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "disableWindowBlurListener",
        "content",
        "entered",
        "requestClose",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var transitionProps = _extends({
        direction: getSlideDirection(otherSnack.anchorOrigin),
        timeout: transitionDuration
    }, TransitionProps);
    var content = componentOrFunctionContent;
    if (typeof content === 'function') content = content(otherSnack.id, otherSnack.message);
    var callbacks = [
        'onEnter',
        'onEntered',
        'onExit',
        'onExited'
    ].reduce(function(acc, cbName) {
        var _extends2;
        return _extends({}, acc, (_extends2 = {}, _extends2[cbName] = createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], otherSnack.id), _extends2));
    }, {});
    return (0, _reactDefault.default).createElement(Collapse, {
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, _reactDefault.default).createElement(Snackbar, {
        open: open,
        id: otherSnack.id,
        disableWindowBlurListener: disableWindowBlurListener,
        autoHideDuration: otherSnack.autoHideDuration,
        className: (0, _clsxDefault.default)(styles.wrappedRoot, classes.root, classes[toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
        SnackbarProps: SnackbarProps,
        onClose: handleClose
    }, (0, _reactDefault.default).createElement(TransitionComponent, Object.assign({}, transitionProps, {
        appear: true,
        "in": open,
        onExit: callbacks.onExit,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ], otherSnack.id)
    }), content || (0, _reactDefault.default).createElement(Component, Object.assign({}, otherSnack)))));
};
var _root$1, _rootDense, _left, _right, _center;
var indents = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var collapseWrapper = "." + ComponentClasses.CollapseWrapper;
var xsWidthMargin = 16;
var styles$1 = /*#__PURE__*/ makeStyles({
    root: (_root$1 = {
        boxSizing: 'border-box',
        display: 'flex',
        maxHeight: '100%',
        position: 'fixed',
        zIndex: 1400,
        height: 'auto',
        width: 'auto',
        transition: /*#__PURE__*/ createTransition([
            'top',
            'right',
            'bottom',
            'left',
            'max-width'
        ], {
            duration: 300,
            easing: 'ease'
        }),
        // container itself is invisible and should not block clicks, clicks should be passed to its children
        // a pointerEvents: all is applied in the collapse component
        pointerEvents: 'none'
    }, _root$1[collapseWrapper] = {
        padding: indents.snackbar["default"] + "px 0px",
        transition: 'padding 300ms ease 0ms'
    }, _root$1.maxWidth = "calc(100% - " + indents.view["default"] * 2 + "px)", _root$1[breakpoints.downXs] = {
        width: '100%',
        maxWidth: "calc(100% - " + xsWidthMargin * 2 + "px)"
    }, _root$1),
    rootDense: (_rootDense = {}, _rootDense[collapseWrapper] = {
        padding: indents.snackbar.dense + "px 0px"
    }, _rootDense),
    top: {
        top: indents.view["default"] - indents.snackbar["default"] + "px",
        flexDirection: 'column'
    },
    bottom: {
        bottom: indents.view["default"] - indents.snackbar["default"] + "px",
        flexDirection: 'column-reverse'
    },
    left: (_left = {
        left: indents.view["default"] + "px"
    }, _left[breakpoints.upSm] = {
        alignItems: 'flex-start'
    }, _left[breakpoints.downXs] = {
        left: xsWidthMargin + "px"
    }, _left),
    right: (_right = {
        right: indents.view["default"] + "px"
    }, _right[breakpoints.upSm] = {
        alignItems: 'flex-end'
    }, _right[breakpoints.downXs] = {
        right: xsWidthMargin + "px"
    }, _right),
    center: (_center = {
        left: '50%',
        transform: 'translateX(-50%)'
    }, _center[breakpoints.upSm] = {
        alignItems: 'center'
    }, _center)
});
var SnackbarContainer = function SnackbarContainer(props) {
    var _props$classes = props.classes, classes = _props$classes === void 0 ? {} : _props$classes, anchorOrigin = props.anchorOrigin, dense = props.dense, children = props.children;
    var combinedClassname = (0, _clsxDefault.default)(ComponentClasses.SnackbarContainer, styles$1[anchorOrigin.vertical], styles$1[anchorOrigin.horizontal], styles$1.root, classes.containerRoot, classes["containerAnchorOrigin" + originKeyExtractor(anchorOrigin)], dense && styles$1.rootDense);
    return (0, _reactDefault.default).createElement("div", {
        className: combinedClassname
    }, children);
};
var SnackbarContainer$1 = /*#__PURE__*/ (0, _react.memo)(SnackbarContainer);
/* eslint-disable */ var __DEV__ = false;
var messages = {
    NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var warning = function(messageKey) {
    if (!__DEV__) return;
    var message = messages[messageKey];
    if (typeof console !== 'undefined') console.error("WARNING - notistack: " + message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var isOptions = function isOptions(messageOrOptions) {
    var isMessage = typeof messageOrOptions === 'string' || (0, _react.isValidElement)(messageOrOptions);
    return !isMessage;
};
var enqueueSnackbar;
var closeSnackbar;
var SnackbarProvider = /*#__PURE__*/ function(_Component) {
    _inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(messageOrOptions, optsOrUndefined) {
            if (optsOrUndefined === void 0) optsOrUndefined = {};
            if (messageOrOptions === undefined || messageOrOptions === null) throw new Error('enqueueSnackbar called with invalid argument');
            var opts = isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
            var message = isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;
            var key = opts.key, preventDuplicate = opts.preventDuplicate, options = _objectWithoutPropertiesLoose(opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = merge(options, _this.props);
            var snack = _extends({
                id: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                persist: merger('persist'),
                action: merger('action'),
                content: merger('content'),
                variant: merger('variant'),
                anchorOrigin: merger('anchorOrigin'),
                disableWindowBlurListener: merger('disableWindowBlurListener'),
                autoHideDuration: merger('autoHideDuration'),
                hideIconVariant: merger('hideIconVariant'),
                TransitionComponent: merger('TransitionComponent'),
                transitionDuration: merger('transitionDuration'),
                TransitionProps: merger('TransitionProps', true),
                iconVariant: merger('iconVariant', true),
                style: merger('style', true),
                SnackbarProps: merger('SnackbarProps', true),
                className: (0, _clsxDefault.default)(_this.props.className, options.className)
            });
            if (snack.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.id === id : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack(_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return _extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) ignore = true;
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return _extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, 'maxsnack', item.id);
                    if (_this.props.onClose) _this.props.onClose(null, 'maxsnack', item.id);
                    return _extends({}, item, {
                        open: false
                    });
                }
                return _extends({}, item);
            });
            return _extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!isDefined(key)) throw new Error('handleEnteredSnack Cannot be called with undefined key');
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.id === key ? _extends({}, item, {
                            entered: true
                        }) : _extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.id !== key) return _extends({}, item);
                        return item.entered ? _extends({}, item, {
                            open: false
                        }) : _extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.id !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.id === key;
            });
            if (isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, 'instructed', key);
            _this.handleCloseSnack(null, 'instructed', key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ _this.handleExitedSnack = function(node, key) {
            if (!isDefined(key)) throw new Error('handleExitedSnack Cannot be called with undefined key');
            _this.setState(function(state) {
                var newState = _this.processQueue(_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.id !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        enqueueSnackbar = _this.enqueueSnackbar;
        closeSnackbar = _this.closeSnackbar;
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar.bind(_assertThisInitialized(_this)),
                closeSnackbar: _this.closeSnackbar.bind(_assertThisInitialized(_this))
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? false : _this$props$dense, _this$props$Component = _this$props.Components, Components = _this$props$Component === void 0 ? {} : _this$props$Component, classes = _this$props.classes;
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return _extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            var nomineeSnack = snacks[0];
            return (0, _reactDefault.default).createElement(SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: nomineeSnack.anchorOrigin,
                classes: classes
            }, snacks.map(function(snack) {
                return (0, _reactDefault.default).createElement(SnackbarItem, {
                    key: snack.id,
                    snack: snack,
                    classes: classes,
                    Component: Components[snack.variant],
                    onClose: _this2.handleCloseSnack,
                    onEnter: _this2.props.onEnter,
                    onExit: _this2.props.onExit,
                    onExited: createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ], snack.id),
                    onEntered: createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ], snack.id)
                });
            }));
        });
        return (0, _reactDefault.default).createElement(SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, _reactDom.createPortal)(snackbars, domRoot) : snackbars);
    };
    _createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || defaults.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, _react.Component));
var useSnackbar = function() {
    return (0, _react.useContext)(SnackbarContext);
};

},{"react":"9njXz","react-dom":"2ApDx","clsx":"g4m1I","goober":"1oFXr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g4m1I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1oFXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>u);
parcelHelpers.export(exports, "extractCss", ()=>r);
parcelHelpers.export(exports, "glob", ()=>b);
parcelHelpers.export(exports, "keyframes", ()=>h);
parcelHelpers.export(exports, "setup", ()=>m);
parcelHelpers.export(exports, "styled", ()=>j);
let e = {
    data: ""
}, t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || e, r = (e)=>{
    let r = t(e), l = r.data;
    return r.data = "", l;
}, l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, a = /\/\*[^]*?\*\/|  +/g, n = /\n+/g, o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? o(c, n) : n + "{" + o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += o.p ? o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, c = {}, s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + s(e[r]);
        return t;
    }
    return e;
}, i = (e, t, r, i, p)=>{
    let u = s(e), d = c[u] || (c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = l.exec(e.replace(a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace(n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace(n, " ").trim();
            return o[0];
        })(e);
        c[d] = o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && c.g ? c.g : null;
    return r && (c.g = c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })(c[d], t, i, f), d;
}, p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function u(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return i(l.unshift ? l.raw ? p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, t(r.target), r.g, r.o, r.k);
}
let d, f, g, b = u.bind({
    g: 1
}), h = u.bind({
    k: 1
});
function m(e, t, r, l) {
    o.p = t, d = e, f = r, g = l;
}
function j(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: f && f()
            }, c), r.o = / *go\d+/.test(s), c.className = u.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), g && i[0] && g(c), d(i, c);
        }
        return t ? t(a) : a;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LkQg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enqueueSnackbar", ()=>enqueueSnackbar);
parcelHelpers.export(exports, "enqueueErrorSnackbar", ()=>enqueueErrorSnackbar);
parcelHelpers.export(exports, "enqueueSuccessSnackbar", ()=>enqueueSuccessSnackbar);
parcelHelpers.export(exports, "enqueueAlarmSnackbar", ()=>enqueueAlarmSnackbar);
parcelHelpers.export(exports, "enqueueNewVersionAvailableSnackbar", ()=>enqueueNewVersionAvailableSnackbar);
parcelHelpers.export(exports, "closeSnackbar", ()=>closeSnackbar);
parcelHelpers.export(exports, "removeSnackbar", ()=>removeSnackbar);
parcelHelpers.export(exports, "closeAllSnackbars", ()=>closeAllSnackbars);
var _toolkit = require("@reduxjs/toolkit");
var _applicationException = require("../../api/ApplicationException");
var _utils = require("../../utils");
const enqueueSnackbar = (0, _toolkit.createAction)('notification/enqueueSnackbar');
const enqueueErrorSnackbar = (0, _toolkit.createAsyncThunk)('notification/enqueueErrorSnackbar', async ({ error, operation }, { dispatch })=>{
    const e = (0, _applicationException.makeApplicationException)(error);
    // eslint-disable-next-line no-console
    console.error('error', JSON.stringify(e.errorInfo, null, 3));
    const data = {
        text: operation && formatOperationFailedTitle(operation, e) || e.errorInfo?.text || '',
        details: e.errorInfo?.details || '',
        httpStatusCode: e.errorInfo?.origin?.status || undefined
    };
    dispatch(enqueueSnackbar({
        message: e.errorInfo.text,
        type: 'fatalError',
        data,
        options: {
            variant: 'error',
            persist: true
        }
    }));
});
function formatOperationFailedTitle(operation, error) {
    const verb = error?.errorInfo.errorCode?.startsWith('4') ? 'Unable' : 'Failed';
    return `${verb} to ${operation}`;
}
const enqueueSuccessSnackbar = (0, _toolkit.createAsyncThunk)('notification/enqueueSuccessSnackbar', async (message, { dispatch })=>{
    dispatch(enqueueSnackbar({
        message,
        type: 'basic',
        options: {
            variant: 'success'
        }
    }));
});
const enqueueAlarmSnackbar = (0, _toolkit.createAsyncThunk)('notification/enqueueAlarmSnackbar', async ({ message, severity }, { dispatch, extra: { routes } })=>{
    if ((0, _utils.getCurrentPage)() !== routes.stream.route) dispatch(enqueueSnackbar({
        message,
        type: 'basic',
        data: routes.alarms({
            alarmTab: severity || undefined
        }),
        options: {
            variant: 'warning',
            anchorOrigin: {
                horizontal: 'right',
                vertical: 'top'
            }
        }
    }));
});
const enqueueNewVersionAvailableSnackbar = (0, _toolkit.createAsyncThunk)('notification/enqueueNewVersionAvailableSnackbar', async (_, { dispatch })=>{
    dispatch(enqueueSnackbar({
        type: 'newVersionAvailableSnackbar',
        options: {
            variant: 'info',
            persist: true
        }
    }));
});
const closeSnackbar = (0, _toolkit.createAction)('notification/closeSnackbar');
const removeSnackbar = (0, _toolkit.createAction)('notification/removeSnackbar');
const closeAllSnackbars = (0, _toolkit.createAction)('notification/closeAllSnackbars');

},{"@reduxjs/toolkit":"8ces8","../../api/ApplicationException":"5oMBs","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ces8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReducerType", ()=>ReducerType);
parcelHelpers.export(exports, "SHOULD_AUTOBATCH", ()=>SHOULD_AUTOBATCH);
parcelHelpers.export(exports, "TaskAbortError", ()=>TaskAbortError);
parcelHelpers.export(exports, "Tuple", ()=>Tuple);
parcelHelpers.export(exports, "addListener", ()=>addListener);
parcelHelpers.export(exports, "asyncThunkCreator", ()=>asyncThunkCreator);
parcelHelpers.export(exports, "autoBatchEnhancer", ()=>autoBatchEnhancer);
parcelHelpers.export(exports, "buildCreateSlice", ()=>buildCreateSlice);
parcelHelpers.export(exports, "clearAllListeners", ()=>clearAllListeners);
parcelHelpers.export(exports, "combineSlices", ()=>combineSlices);
parcelHelpers.export(exports, "configureStore", ()=>configureStore);
parcelHelpers.export(exports, "createAction", ()=>createAction);
parcelHelpers.export(exports, "createActionCreatorInvariantMiddleware", ()=>createActionCreatorInvariantMiddleware);
parcelHelpers.export(exports, "createAsyncThunk", ()=>createAsyncThunk);
parcelHelpers.export(exports, "createDraftSafeSelector", ()=>createDraftSafeSelector);
parcelHelpers.export(exports, "createDraftSafeSelectorCreator", ()=>createDraftSafeSelectorCreator);
parcelHelpers.export(exports, "createDynamicMiddleware", ()=>createDynamicMiddleware);
parcelHelpers.export(exports, "createEntityAdapter", ()=>createEntityAdapter);
parcelHelpers.export(exports, "createImmutableStateInvariantMiddleware", ()=>createImmutableStateInvariantMiddleware);
parcelHelpers.export(exports, "createListenerMiddleware", ()=>createListenerMiddleware);
parcelHelpers.export(exports, "createNextState", ()=>(0, _immer.produce));
parcelHelpers.export(exports, "createReducer", ()=>createReducer);
parcelHelpers.export(exports, "createSelector", ()=>(0, _reselect.createSelector));
parcelHelpers.export(exports, "createSelectorCreator", ()=>(0, _reselect.createSelectorCreator));
parcelHelpers.export(exports, "createSerializableStateInvariantMiddleware", ()=>createSerializableStateInvariantMiddleware);
parcelHelpers.export(exports, "createSlice", ()=>createSlice);
parcelHelpers.export(exports, "current", ()=>(0, _immer.current));
parcelHelpers.export(exports, "findNonSerializableValue", ()=>findNonSerializableValue);
parcelHelpers.export(exports, "formatProdErrorMessage", ()=>formatProdErrorMessage);
parcelHelpers.export(exports, "freeze", ()=>(0, _immer.freeze));
parcelHelpers.export(exports, "isActionCreator", ()=>isActionCreator);
parcelHelpers.export(exports, "isAllOf", ()=>isAllOf);
parcelHelpers.export(exports, "isAnyOf", ()=>isAnyOf);
parcelHelpers.export(exports, "isAsyncThunkAction", ()=>isAsyncThunkAction);
parcelHelpers.export(exports, "isDraft", ()=>(0, _immer.isDraft));
parcelHelpers.export(exports, "isFluxStandardAction", ()=>isFSA);
parcelHelpers.export(exports, "isFulfilled", ()=>isFulfilled);
parcelHelpers.export(exports, "isImmutableDefault", ()=>isImmutableDefault);
parcelHelpers.export(exports, "isPending", ()=>isPending);
parcelHelpers.export(exports, "isPlain", ()=>isPlain);
parcelHelpers.export(exports, "isRejected", ()=>isRejected);
parcelHelpers.export(exports, "isRejectedWithValue", ()=>isRejectedWithValue);
parcelHelpers.export(exports, "lruMemoize", ()=>(0, _reselect.lruMemoize));
parcelHelpers.export(exports, "miniSerializeError", ()=>miniSerializeError);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "original", ()=>(0, _immer.original));
parcelHelpers.export(exports, "prepareAutoBatched", ()=>prepareAutoBatched);
parcelHelpers.export(exports, "removeListener", ()=>removeListener);
parcelHelpers.export(exports, "unwrapResult", ()=>unwrapResult);
parcelHelpers.export(exports, "weakMapMemoize", ()=>(0, _reselect.weakMapMemoize));
// src/index.ts
var _redux = require("redux");
parcelHelpers.exportAll(_redux, exports);
var _immer = require("immer");
var _reselect = require("reselect");
// src/getDefaultMiddleware.ts
var _reduxThunk = require("redux-thunk");
var process = require("1acd36d7729a41f9");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __publicField = (obj, key, value)=>__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var createDraftSafeSelectorCreator = (...args)=>{
    const createSelector2 = (0, _reselect.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var createDraftSafeSelector = /* @__PURE__ */ createDraftSafeSelectorCreator((0, _reselect.weakMapMemoize));
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, _redux.compose;
    return (0, _redux.compose).apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error(formatProdErrorMessage(0));
            return __spreadValues(__spreadValues({
                type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, _redux.isAction)(action) && action.type === type;
    return actionCreator;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    hasMatchFunction(action);
}
function isFSA(action) {
    return (0, _redux.isAction)(action) && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var Tuple = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function freezeDraftable(val) {
    return (0, _immer.isDraftable)(val) ? (0, _immer.produce)(val, ()=>{}) : val;
}
function getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function createImmutableStateInvariantMiddleware(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function isPlain(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, _redux.isPlainObject)(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && isNestedFrozen(value)) cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
var buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk = true, immutableCheck = true, serializableCheck = true, actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new Tuple();
        if (thunk) {
            if (isBoolean(thunk)) middlewareArray.push((0, _reduxThunk.thunk));
            else middlewareArray.push((0, _reduxThunk.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = ()=>(payload)=>({
            payload,
            meta: {
                [SHOULD_AUTOBATCH]: true
            }
        });
var createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var autoBatchEnhancer = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch = true } = options != null ? options : {};
        let enhancerArray = new Tuple(middlewareEnhancer);
        if (autoBatch) enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function configureStore(options) {
    const getDefaultMiddleware = buildGetDefaultMiddleware();
    const { reducer, middleware, devTools = true, duplicateMiddlewareCheck = true, preloadedState, enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, _redux.isPlainObject)(reducer)) rootReducer = (0, _redux.combineReducers)(reducer);
    else throw new Error(formatProdErrorMessage(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, _redux.compose);
    if (devTools) finalCompose = composeWithDevTools(__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, _redux.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, _redux.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error(formatProdErrorMessage(28));
            if (type in actionsMap) throw new Error(formatProdErrorMessage(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher,
                reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if (isStateFunction(initialState)) getInitialState = ()=>freezeDraftable(initialState());
    else {
        const frozenInitialState = freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, _immer.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, _immer.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, _immer.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var matches = (matcher, action)=>{
    if (hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function isAnyOf(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>matches(matcher, action));
    };
}
function isAllOf(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>matches(matcher, action));
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isPending()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function isRejected(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isRejected()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function isRejectedWithValue(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return isAllOf(isRejected(...asyncThunks), hasFlag);
    if (!isAsyncThunkArray(asyncThunks)) return isRejectedWithValue()(asyncThunks[0]);
    return isAllOf(isRejected(...asyncThunks), hasFlag);
}
function isFulfilled(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isFulfilled()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function isAsyncThunkAction(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isAsyncThunkAction()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var miniSerializeError = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var externalAbortMessage = "External signal was aborted";
var createAsyncThunk = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = createAction(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload,
                error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort(externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort(externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState,
                            extra
                        });
                        if (isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId,
                            arg
                        }, {
                            getState,
                            extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch,
                                getState,
                                extra,
                                requestId,
                                signal: abortController.signal,
                                abort,
                                rejectWithValue: (value, meta)=>{
                                    return new RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof RejectWithValue) throw result;
                                if (result instanceof FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort,
                    requestId,
                    arg,
                    unwrap () {
                        return promise.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending,
            rejected,
            fulfilled,
            settled: isAnyOf(rejected, fulfilled),
            typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var asyncThunkCreator = {
    [asyncThunkSymbol]: createAsyncThunk
};
var ReducerType = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})(ReducerType || {});
function getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function buildCreateSlice({ creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[asyncThunkSymbol];
    return function createSlice2(options) {
        const { name, reducerPath = name } = options;
        if (!name) throw new Error(formatProdErrorMessage(11));
        typeof process;
        const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error(formatProdErrorMessage(12));
                if (type in context.sliceCaseReducersByType) throw new Error(formatProdErrorMessage(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName,
                type: getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return createReducer(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = wrapSelector(selector, selectState, ()=>getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice
            };
        }
        const slice = __spreadProps(__spreadValues({
            name,
            reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = __objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer
                }, config);
                return __spreadValues(__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return __spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare,
                reducer
            };
        },
        asyncThunk
    };
}
function handleNormalReducerDefinition({ type, reducerName, createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error(formatProdErrorMessage(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function handleThunkCaseReducerDefinition({ type, reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error(formatProdErrorMessage(18));
    const { payloadCreator, fulfilled, pending, rejected, settled, options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || noop,
        pending: pending || noop,
        rejected: rejected || noop,
        settled: settled || noop
    });
}
function noop() {}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign(getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState
    };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = createDraftSafeSelector } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds,
            selectEntities,
            selectAll,
            selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors
    };
}
var isDraftTyped = (0, _immer.isDraft);
function createSingleArgumentStateOperator(mutator) {
    const operator = createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if (isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, _immer.produce)(state, runMutator);
    };
}
function selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function getCurrent(value) {
    return (0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    const existingIdsArray = getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: __spreadValues(__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function createSortedStateAdapter(selectId, comparer) {
    const { removeOne, removeMany, removeAll } = createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has(selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = getCurrent(state.entities);
        const currentIds = getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne,
        removeMany,
        removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options = {}) {
    const { selectId, sortComparer } = __spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    const stateFactory = createInitialStateFactory(stateAdapter);
    const selectorsFactory = createSelectorsFactory();
    return __spreadValues(__spreadValues(__spreadValues({
        selectId,
        sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = `task-${cancelled}`;
var taskCompleted = `task-${completed}`;
var listenerCancelled = `${listener}-${cancelled}`;
var listenerCompleted = `${listener}-${completed}`;
var TaskAbortError = class {
    constructor(code){
        this.code = code;
        __publicField(this, "name", "TaskAbortError");
        __publicField(this, "message");
        this.message = `${task} ${cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError(formatProdErrorMessage(32));
};
var noop2 = ()=>{};
var catchRejection = (promise, onError = noop2)=>{
    promise.catch(onError);
    return promise;
};
var addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason } = signal;
        throw new TaskAbortError(reason);
    }
};
function raceWithSignal(signal, promise) {
    let cleanup = noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new TaskAbortError(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = noop2;
    });
}
var runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value
        };
    } catch (error) {
        return {
            status: error instanceof TaskAbortError ? "cancelled" : "rejected",
            error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var createPause = (signal)=>{
    return (promise)=>{
        return catchRejection(raceWithSignal(signal, promise).then((output)=>{
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = (signal)=>{
    const pause = createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign } = Object;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>addAbortSignalListener(parentAbortSignal, ()=>abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = runTask(async ()=>{
            validateActive(parentAbortSignal);
            validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: createPause(childAbortController.signal),
                delay: createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            validateActive(childAbortController.signal);
            return result2;
        }, ()=>abortControllerWithReason(childAbortController, taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch(noop2));
        return {
            result: createPause(parentAbortSignal)(result),
            cancel () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await raceWithSignal(signal, Promise.race(promises));
            validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>catchRejection(take(predicate, timeout));
};
var getListenerEntryPropsFrom = (options)=>{
    let { type, actionCreator, matcher, predicate, effect } = options;
    if (type) predicate = createAction(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error(formatProdErrorMessage(21));
    assertFunction(effect, "options.listener");
    return {
        predicate,
        type,
        effect
    };
};
var createListenerEntry = /* @__PURE__ */ assign((options)=>{
    const { type, predicate, effect } = getListenerEntryPropsFrom(options);
    const entry = {
        id: nanoid(),
        effect,
        type,
        predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error(formatProdErrorMessage(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>createListenerEntry
});
var findListenerEntry = (listenerMap, options)=>{
    const { type, effect, predicate } = getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        abortControllerWithReason(controller, listenerCancelled);
    });
};
var createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/add`), {
    withTypes: ()=>addListener
});
var clearAllListeners = /* @__PURE__ */ createAction(`${alm}/removeAll`);
var removeListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/remove`), {
    withTypes: ()=>removeListener
});
var defaultErrorHandler = (...args)=>{
    console.error(`${alm}/error`, ...args);
};
var createListenerMiddleware = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra, onError = defaultErrorHandler } = middlewareOptions;
    assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = findListenerEntry(listenerMap, options)) != null ? _a : createListenerEntry(options);
        return insertEntry(entry);
    };
    assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) cancelActiveListeners(entry);
        }
        return !!entry;
    };
    assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            assign({}, api, {
                getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take,
                delay: createDelay(internalTaskController.signal),
                pause: createPause(internalTaskController.signal),
                extra,
                signal: internalTaskController.signal,
                fork: createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            abortControllerWithReason(controller, listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    abortControllerWithReason(internalTaskController, listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof TaskAbortError)) safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            abortControllerWithReason(internalTaskController, listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, _redux.isAction)(action)) return next(action);
                if (addListener.match(action)) return startListening(action.payload);
                if (clearAllListeners.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if (removeListener.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === INTERNAL_NIL_TOKEN) throw new Error(formatProdErrorMessage(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware,
        startListening,
        stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var createMiddlewareEntry = (middleware)=>({
        middleware,
        applied: /* @__PURE__ */ new Map()
    });
var matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var createDynamicMiddleware = ()=>{
    const instanceId = nanoid();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign(createAction("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            getOrInsertComputed(middlewareMap, middleware2, createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, _redux.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = isAllOf(withMiddleware, matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware,
        addMiddleware,
        withMiddleware,
        instanceId
    };
};
var isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var getReducers = (slices)=>slices.flatMap((sliceOrMap)=>isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var isStateProxy = (value)=>!!value && !!value[ORIGINAL_STATE];
var stateProxyMap = /* @__PURE__ */ new WeakMap();
var createStateProxy = (state, reducerMap, initialStateCache)=>getOrInsertComputed(stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: nanoid()
                        });
                        if (typeof reducerResult === "undefined") throw new Error(formatProdErrorMessage(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var original = (state)=>{
    if (!isStateProxy(state)) throw new Error(formatProdErrorMessage(25));
    return state[ORIGINAL_STATE];
};
var emptyObject = {};
var noopReducer = (state = emptyObject)=>state;
function combineSlices(...slices) {
    const reducerMap = Object.fromEntries(getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, _redux.combineReducers)(reducerMap) : noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof process;
            return combinedReducer;
        }
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn(createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original
    });
    return Object.assign(combinedReducer, {
        inject,
        selector
    });
}
// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

},{"1acd36d7729a41f9":"5jT8D","redux":"iMGHt","immer":"c4YBZ","reselect":"bncE2","redux-thunk":"lC3q3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iMGHt":[function(require,module,exports,__globalThis) {
// src/utils/formatProdErrorMessage.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>actionTypes_default);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "isAction", ()=>isAction);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
function formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;
// src/utils/actionTypes.ts
var randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
    INIT: `@@redux/INIT${randomString()}`,
    REPLACE: `@@redux/REPLACE${randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    const constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error(formatProdErrorMessage(17));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: actionTypes_default.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe
                };
            },
            [symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: actionTypes_default.INIT
    });
    const store = {
        dispatch,
        subscribe,
        getState,
        replaceReducer,
        [symbol_observable_default]: observable
    };
    return store;
}
function legacy_createStore(reducer, preloadedState, enhancer) {
    return createStore(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === actionTypes_default.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: actionTypes_default.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: actionTypes_default.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
function combineReducers(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function compose(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error(formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = compose(...chain)(store.dispatch);
            return {
                ...store,
                dispatch
            };
        };
}
// src/utils/isAction.ts
function isAction(action) {
    return isPlainObject(action) && "type" in action && typeof action.type === "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4YBZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>Immer2);
parcelHelpers.export(exports, "applyPatches", ()=>applyPatches);
parcelHelpers.export(exports, "castDraft", ()=>castDraft);
parcelHelpers.export(exports, "castImmutable", ()=>castImmutable);
parcelHelpers.export(exports, "createDraft", ()=>createDraft);
parcelHelpers.export(exports, "current", ()=>current);
parcelHelpers.export(exports, "enableMapSet", ()=>enableMapSet);
parcelHelpers.export(exports, "enablePatches", ()=>enablePatches);
parcelHelpers.export(exports, "finishDraft", ()=>finishDraft);
parcelHelpers.export(exports, "freeze", ()=>freeze);
parcelHelpers.export(exports, "immerable", ()=>DRAFTABLE);
parcelHelpers.export(exports, "isDraft", ()=>isDraft);
parcelHelpers.export(exports, "isDraftable", ()=>isDraftable);
parcelHelpers.export(exports, "nothing", ()=>NOTHING);
parcelHelpers.export(exports, "original", ()=>original);
parcelHelpers.export(exports, "produce", ()=>produce);
parcelHelpers.export(exports, "produceWithPatches", ()=>produceWithPatches);
parcelHelpers.export(exports, "setAutoFreeze", ()=>setAutoFreeze);
parcelHelpers.export(exports, "setUseStrictShallowCopy", ()=>setUseStrictShallowCopy);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function getArchtype(thing) {
    const state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    const t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        const proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj, deep = false) {
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>freeze(value, true));
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    const plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_,
        immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    const state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    if (!state) {
        each(value, (key, childValue)=>finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, (key, childValue)=>finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    const { revoke, proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get (state, prop) {
        if (prop === DRAFT_STATE) return state;
        const source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys(latest(state));
    },
    set (state, prop, value) {
        const desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = peek(latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        die(11);
    },
    getPrototypeOf (state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, (key, fn)=>{
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    const state = draft[DRAFT_STATE];
    const source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    const desc = getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            let result;
            if (isDraftable(base)) {
                const scope = enterScope(this);
                const proxy = createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!isDraftable(base)) die(8);
        if (isDraft(base)) base = current(base);
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        proxy[DRAFT_STATE].isManual_ = true;
        leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[DRAFT_STATE];
        if (!state || !state.isManual_) die(9);
        const { scope_: scope } = state;
        usePatchesInScope(scope, patchListener);
        return processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = getPlugin("Patches").applyPatches_;
        if (isDraft(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function createProxy(value, parent) {
    const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, (key, childValue)=>{
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_, assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_, copy_ } = state;
        each(state.assigned_, (key, assignedValue)=>{
            const origValue = get(base_, key);
            const value = get(copy_, key);
            const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op,
                path
            } : {
                op,
                path,
                value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path
            } : op === REMOVE ? {
                op: ADD,
                path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_, copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: ADD,
                    path,
                    value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path,
                    value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path, op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            const type = getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create(getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_,
        generatePatches_,
        generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(key) {
            return latest(this[DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!latest(state).has(key) || latest(state).get(key) !== value) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[DRAFT_STATE];
            latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            const value = latest(state).get(key);
            if (state.finalized_ || !isDraftable(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return latest(this[DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if (isDraftable(value)) {
                    const draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_,
        proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bncE2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
parcelHelpers.export(exports, "lruMemoize", ()=>lruMemoize);
parcelHelpers.export(exports, "referenceEqualityCheck", ()=>referenceEqualityCheck);
parcelHelpers.export(exports, "setGlobalDevModeChecks", ()=>setGlobalDevModeChecks);
parcelHelpers.export(exports, "unstable_autotrackMemoize", ()=>autotrackMemoize);
parcelHelpers.export(exports, "weakMapMemoize", ()=>weakMapMemoize);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __publicField = (obj, key, value)=>{
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize, memoizeOptions } = options;
    const { inputSelectorResults, inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var setGlobalDevModeChecks = (devModeChecks)=>{
    Object.assign(globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck, inputStabilityCheck } = __spreadValues(__spreadValues({}, globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $REVISION = 0;
var CURRENT_TRACKER = null;
var Cell = class {
    constructor(initialValue, isEqual = tripleEq){
        __publicField(this, "revision", $REVISION);
        __publicField(this, "_value");
        __publicField(this, "_lastValue");
        __publicField(this, "_isEqual", tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$REVISION;
    }
};
function tripleEq(a, b) {
    return a === b;
}
var TrackingCache = class {
    constructor(fn){
        __publicField(this, "_cachedValue");
        __publicField(this, "_cachedRevision", -1);
        __publicField(this, "_deps", []);
        __publicField(this, "hits", 0);
        __publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = CURRENT_TRACKER;
            CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function getValue(cell) {
    if (!(cell instanceof Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function setValue(storage, value) {
    if (!(storage instanceof Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function createCell(initialValue, isEqual = tripleEq) {
    return new Cell(initialValue, isEqual);
}
function createCache(fn) {
    assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var neverEq = (a, b)=>false;
function createTag() {
    return createCell(null, neverEq);
}
function dirtyTag(tag, value) {
    setValue(tag, value);
}
var consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = createTag();
    getValue(tag);
};
var dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var REDUX_PROXY_LABEL = Symbol();
var nextId = 0;
var proto = Object.getPrototypeOf({});
var ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy(this, objectProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = createNode(childValue);
                if (childNode.tag) getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = createTag();
                    tag.value = childValue;
                }
                getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy([
            this
        ], arrayProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") consumeCollection(node);
        return objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return objectProxyHandler.has(node, prop);
    }
};
function createNode(value) {
    if (Array.isArray(value)) return new ArrayTreeNode(value);
    return new ObjectTreeNode(value);
}
function updateNode(node, newValue) {
    const { value, tags, children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            dirtyCollection(node);
            dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) updateNode(childNode, newChildValue);
        else {
            deleteNode(childNode);
            delete children[key];
        }
    }
}
function deleteNode(node) {
    if (node.tag) dirtyTag(node.tag, null);
    dirtyCollection(node);
    for(const key in node.tags)dirtyTag(node.tags[key], null);
    for(const key in node.children)deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key,
                value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            entries.unshift({
                key,
                value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get,
        put,
        getEntries,
        clear
    };
}
var referenceEqualityCheck = (a, b)=>a === b;
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function lruMemoize(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck = referenceEqualityCheck, maxSize = 1, resultEqualityCheck } = providedOptions;
    const comparator = createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function autotrackMemoize(func) {
    const node = createNode([]);
    let lastArgs = null;
    const shallowEqual = createCacheKeyComparator(referenceEqualityCheck);
    const cache = createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
    return {
        s: UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function weakMapMemoize(func, options = {}) {
    let fnNode = createCacheNode();
    const { resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new Ref(result) : result;
            }
        }
        terminatedNode.s = TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = __spreadValues(__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize, memoizeOptions = [], argsMemoize = weakMapMemoize, argsMemoizeOptions = [], devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
        const dependencies = getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc,
            memoizedResultFunc,
            dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize,
            argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);
// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign((inputSelectorsObject, selectorCreator = createSelector)=>{
    assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>createStructuredSelector
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lC3q3":[function(require,module,exports,__globalThis) {
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "thunk", ()=>thunk);
parcelHelpers.export(exports, "withExtraArgument", ()=>withExtraArgument);
function createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch, getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5oMBs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApplicationException", ()=>ApplicationException);
parcelHelpers.export(exports, "makeApplicationException", ()=>makeApplicationException);
class ApplicationException {
    constructor(errorInfo){
        this.errorInfo = errorInfo;
    }
}
function stringValueFromObject(key, obj) {
    const value = obj[key];
    return typeof value === 'string' && value ? value : undefined;
}
function makeApplicationException(error) {
    return error instanceof ApplicationException ? error : new ApplicationException({
        fatal: true,
        errorCode: 'http_get_general_error',
        text: stringValueFromObject('title', error) ?? stringValueFromObject('name', error) ?? 'Unable to fetch',
        details: stringValueFromObject('detail', error) ?? stringValueFromObject('message', error) ?? 'Http Request Failed',
        origin: error.response
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"342UB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listResult", ()=>listResult);
parcelHelpers.export(exports, "pluralize", ()=>pluralize);
parcelHelpers.export(exports, "pluralizeWord", ()=>pluralizeWord);
/**
 * Transforms object from form state removing empty strings '' and applying transformations added with parameter config
 * @param form
 * @param config - optional, applying some specific transformation. Watch tests and input/output forms for examples
 */ parcelHelpers.export(exports, "formTransform", ()=>formTransform);
parcelHelpers.export(exports, "getInterfaceName", ()=>getInterfaceName);
parcelHelpers.export(exports, "getIsStreamManager", ()=>getIsStreamManager);
parcelHelpers.export(exports, "DEFAULT_PAGINATION", ()=>DEFAULT_PAGINATION);
parcelHelpers.export(exports, "withDefaultPagination", ()=>withDefaultPagination);
/**
 * Defines if OutputOrRecipientList is Output
 * @param entity - Output | OutputRecipientList
 */ parcelHelpers.export(exports, "isOutput", ()=>isOutput);
/**
 * Defines if GroupOrGroupRecipientList is group
 * @param entity - Group or GroupRecipientList
 */ parcelHelpers.export(exports, "isGroup", ()=>isGroup);
parcelHelpers.export(exports, "toMapboxCoords", ()=>toMapboxCoords);
parcelHelpers.export(exports, "getBounds", ()=>getBounds);
parcelHelpers.export(exports, "createDefaultFiledValues", ()=>createDefaultFiledValues);
parcelHelpers.export(exports, "numericEnum", ()=>numericEnum);
parcelHelpers.export(exports, "inputOutputColor", ()=>inputOutputColor);
parcelHelpers.export(exports, "isEditableAppliance", ()=>isEditableAppliance);
parcelHelpers.export(exports, "isEditableGroup", ()=>isEditableGroup);
parcelHelpers.export(exports, "isEditableInterface", ()=>isEditableInterface);
parcelHelpers.export(exports, "getApplianceOwnerId", ()=>getApplianceOwnerId);
parcelHelpers.export(exports, "isEditableOutput", ()=>isEditableOutput);
parcelHelpers.export(exports, "isEditableRegion", ()=>isEditableRegion);
parcelHelpers.export(exports, "alarmsThatDisablePort", ()=>alarmsThatDisablePort);
parcelHelpers.export(exports, "isCoreNode", ()=>isCoreNode);
parcelHelpers.export(exports, "areSetsEqual", ()=>areSetsEqual);
parcelHelpers.export(exports, "getCurrentPage", ()=>getCurrentPage);
parcelHelpers.export(exports, "hasAccessToAppliance", ()=>hasAccessToAppliance);
parcelHelpers.export(exports, "formatTransformationType", ()=>formatTransformationType);
parcelHelpers.export(exports, "inputType", ()=>inputType);
parcelHelpers.export(exports, "inputTypeFromPort", ()=>inputTypeFromPort);
parcelHelpers.export(exports, "outputType", ()=>outputType);
parcelHelpers.export(exports, "makeAddressOptions", ()=>makeAddressOptions);
parcelHelpers.export(exports, "runningDifferentSoftwareVersion", ()=>runningDifferentSoftwareVersion);
parcelHelpers.export(exports, "portTypeFromPortMode", ()=>portTypeFromPortMode);
parcelHelpers.export(exports, "COAX_MODES", ()=>COAX_MODES);
var _mapboxGl = require("mapbox-gl");
var _types = require("common/api/v1/types");
var _react = require("react");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _cloneDeep = require("lodash/cloneDeep");
var _cloneDeepDefault = parcelHelpers.interopDefault(_cloneDeep);
var _hooks = require("./hooks");
parcelHelpers.exportAll(_hooks, exports);
var _validation = require("./validation");
parcelHelpers.exportAll(_validation, exports);
function listResult(items) {
    return {
        items: items.slice(),
        total: items.length
    };
}
const pluralize = (number, word, plural = `${word}s`)=>number === 11 || number.toString().slice(-1) !== '1' ? `${number} ${plural}` : `${number} ${word}`;
const pluralizeWord = (number, word, plural = `${word}s`)=>number === 11 || number.toString().slice(-1) !== '1' ? plural : word;
function formTransform(form, config) {
    if (form === null) {
        if (config && config._transform) return config._transform(form);
        return undefined;
    }
    if (typeof form !== 'object' || Array.isArray(form)) {
        if (config && config._transform) return config._transform(form);
        return form !== '' ? form : undefined;
    }
    const transformedForm = config && config._transform ? config._transform(form) : (0, _cloneDeepDefault.default)(form);
    if (!transformedForm) return undefined;
    return Object.entries(transformedForm).reduce((acc, [key, value1])=>{
        if ([
            '',
            null
        ].includes(value1)) {
            if (config && config[key] && config[key]._transform) return {
                ...acc,
                [key]: config[key]._transform(value1)
            };
            return acc;
        }
        if (Array.isArray(value1)) return {
            ...acc,
            [key]: value1.map((item)=>formTransform(item, config && config[key])).filter((e)=>e !== null && e !== undefined)
        };
        if (config && config[key] && config[key]._transform) return {
            ...acc,
            [key]: formTransform(config[key]._transform(value1), {
                ...config[key],
                _transform: undefined
            })
        };
        return {
            ...acc,
            [key]: formTransform(value1, config && config[key])
        };
    }, {});
}
const getInterfaceName = ({ name, appliance: { name: appliance = '' } })=>`${appliance}:${name}`;
const getIsStreamManager = (currentPage, routes)=>currentPage.startsWith(routes.stream.route);
const DEFAULT_PAGINATION = {
    pageNumber: '0',
    get rowsPerPage () {
        return localStorage.getItem('rowsPerPage') || '10';
    },
    set rowsPerPage (value){
        localStorage.setItem('rowsPerPage', value);
    }
};
const withDefaultPagination = (params)=>({
        ...params,
        pageNumber: params.pageNumber !== undefined ? params.pageNumber : DEFAULT_PAGINATION.pageNumber,
        rowsPerPage: params.rowsPerPage !== undefined ? params.rowsPerPage : DEFAULT_PAGINATION.rowsPerPage
    });
function isOutput(entity) {
    return 'ports' in entity;
}
function isGroup(entity) {
    return entity.object === (0, _types.EntityType).group;
}
const toMapboxCoords = ([lat, lng])=>[
        lng,
        lat
    ];
const getBounds = (coordinates)=>{
    const bounds = new (0, _mapboxGl.LngLatBounds)();
    coordinates.forEach((coords)=>bounds.extend(toMapboxCoords(coords)));
    return bounds;
};
const createDefaultFiledValues = (names, bools, special = {})=>names.reduce((acc, name)=>{
        let value1;
        if (name in special) value1 = special[name];
        else if (bools.includes(name)) value1 = false;
        else value1 = '';
        return {
            ...acc,
            [name]: value1
        };
    }, {});
const numericEnum = (enumToTransform)=>Object.entries(enumToTransform).reduce((acc, [key, value1])=>({
            ...acc,
            ...typeof value1 !== 'number' ? {} : {
                [key]: value1
            }
        }), {});
const inputOutputColor = ({ adminStatus })=>({
        color: adminStatus ? 'textPrimary' : 'textSecondary'
    });
const isEditableAppliance = (user, applianceOwner)=>applianceOwner && (applianceOwner === user.group || user.role === (0, _types.Role).super) || false;
const isEditableGroup = (groupId, user)=>user.role === (0, _types.Role).super || user.role === (0, _types.Role).admin && user.group === groupId;
const isEditableInterface = (applianceOwnerId, user)=>user.role === (0, _types.Role).super || user.role === (0, _types.Role).admin && applianceOwnerId === user.group;
const getApplianceOwnerId = (a)=>{
    if (!a?.owner) return '';
    return typeof a.owner === 'string' ? a.owner : a.owner.id;
};
const isEditableOutput = (ownerId, user)=>user.role === (0, _types.Role).super || user.role === (0, _types.Role).admin && ownerId === user.group;
const isEditableRegion = (user)=>user.role === (0, _types.Role).super;
const alarmsThatDisablePort = (appliance, portId)=>{
    if (!appliance) return;
    const portAlarms = appliance.alarms.filter((alarm)=>alarm.physicalPortId === portId);
    const alarmsThatCausePortBeDisabled = portAlarms.filter((portAlarm)=>{
        if (portAlarm.alarmCause === (0, _types.AlarmCause).INTERFACE_REMOVED_BUT_IN_USE) return true;
    });
    if (alarmsThatCausePortBeDisabled.length > 0) return alarmsThatCausePortBeDisabled;
    return;
};
function isCoreNode(applianceType) {
    return applianceType === (0, _types.ApplianceType).core;
}
function areSetsEqual(s1, s2) {
    if (s1.size !== s2.size) return false;
    for (const element of s1){
        if (!s2.has(element)) return false;
    }
    return true;
}
const getCurrentPage = ()=>{
    return document.location.hash?.slice(1).split('?').shift() || document.location.pathname;
};
function hasAccessToAppliance(appliance, user) {
    return 'owner' in appliance && user && appliance.owner === user.group || user.role === (0, _types.Role).super;
}
const formatTransformationType = (ingestTransformType)=>{
    switch(ingestTransformType){
        case 'mpts-demux':
            return 'MPTS Demux';
        case 'transcode':
            return 'Transcode';
        case 'audio-reshuffling':
            return 'Audio Reshuffling';
        default:
            return 'Transform';
    }
};
function inputType(input) {
    const ports = input.ports;
    if (input.deriveFrom?.ingestTransform) return [
        formatTransformationType(input.deriveFrom.ingestTransform.type)
    ];
    if (!ports || !ports.length) return [
        'Not configured'
    ];
    const portModes = Array.from(new Set(ports.map(inputTypeFromPort)));
    return portModes;
}
function inputTypeFromPort(port) {
    switch(port.mode){
        case (0, _types.CoaxPortMode).sdi:
        case (0, _types.MatroxPortMode).matroxSdi:
        case (0, _types.ComprimatoPortMode).comprimatoSdi:
            return 'SDI';
        case (0, _types.CoaxPortMode).asi:
            return 'ASI';
        case (0, _types.ComprimatoPortMode).comprimatoNdi:
            return 'NDI';
        case (0, _types.VideonPortMode).videonAuto:
            return 'Videon auto';
        case (0, _types.VideonPortMode).videonSdi:
            return 'Videon SDI';
        case (0, _types.VideonPortMode).videonHdmi:
            return 'Videon HDMI';
        case (0, _types.IpPortMode).rist:
            return 'RIST';
        case (0, _types.IpPortMode).rtmp:
            return 'RTMP';
        case (0, _types.IpPortMode).rtp:
            return 'RTP';
        case (0, _types.IpPortMode).udp:
            return 'UDP';
        case (0, _types.IpPortMode).generator:
            return 'Generator';
        case (0, _types.IpPortMode).zixi:
            switch(port.zixiMode){
                case (0, _types.ZixiMode).pull:
                    return 'Zixi pull';
                case (0, _types.ZixiMode).push:
                    return 'Zixi push';
            }
        case (0, _types.IpPortMode).srt:
            switch(port.srtMode){
                case (0, _types.SrtMode).listener:
                    return 'SRT listener';
                case (0, _types.SrtMode).caller:
                    return 'SRT caller';
                case (0, _types.SrtMode).rendezvous:
                    return 'SRT rendezvous';
            }
    }
}
function outputType(port) {
    if (!port) return 'Not configured';
    switch(port.mode){
        case (0, _types.CoaxPortMode).sdi:
        case (0, _types.ComprimatoPortMode).comprimatoSdi:
        case (0, _types.MatroxPortMode).matroxSdi:
            return 'SDI';
        case (0, _types.CoaxPortMode).asi:
            return 'ASI';
        case (0, _types.IpPortMode).rist:
            return 'RIST';
        case (0, _types.IpPortMode).rtmp:
            return 'RTMP';
        case (0, _types.IpPortMode).rtp:
            return 'RTP';
        case (0, _types.IpPortMode).udp:
            return 'UDP';
        case (0, _types.IpPortMode).zixi:
            switch(port.zixiMode){
                case (0, _types.ZixiMode).pull:
                    return 'Zixi pull';
                case (0, _types.ZixiMode).push:
                    return 'Zixi push';
            }
        case (0, _types.IpPortMode).srt:
            switch(port.srtMode){
                case (0, _types.SrtMode).listener:
                    return 'SRT listener';
                case (0, _types.SrtMode).caller:
                    return 'SRT caller';
                case (0, _types.SrtMode).rendezvous:
                    return 'SRT rendezvous';
            }
        case (0, _types.ComprimatoPortMode).comprimatoNdi:
            return 'NDI';
        default:
            return 'N/A';
    }
}
const makeAddressOptions = (currentAddress, addresses)=>{
    const availableAddresses = addresses.map(({ address, publicAddress })=>({
            name: `${address}${publicAddress ? ` (${publicAddress})` : ''}`,
            value: address
        }));
    if (currentAddress && !availableAddresses.find((a)=>a.value === currentAddress)) availableAddresses.unshift({
        name: currentAddress,
        disabled: true,
        tooltip: (0, _react.createElement)((0, _typographyDefault.default), {
            component: 'span',
            variant: 'body2',
            color: 'error'
        }, '(The current address is not available)')
    });
    return availableAddresses;
};
const runningDifferentSoftwareVersion = (version, buildInfo)=>{
    return buildInfo !== undefined && version !== undefined && version !== buildInfo.release;
};
function portTypeFromPortMode(portMode) {
    switch(portMode){
        case (0, _types.IpPortMode).rist:
            return (0, _types.PortType).ip;
        case (0, _types.IpPortMode).udp:
            return (0, _types.PortType).ip;
        case (0, _types.IpPortMode).rtp:
            return (0, _types.PortType).ip;
        case (0, _types.IpPortMode).srt:
            return (0, _types.PortType).ip;
        case (0, _types.IpPortMode).zixi:
            return (0, _types.PortType).ip;
        case (0, _types.IpPortMode).rtmp:
            return (0, _types.PortType).ip;
        case (0, _types.IpPortMode).generator:
            return (0, _types.PortType).ip;
        case (0, _types.CoaxPortMode).sdi:
            return (0, _types.PortType).coax;
        case (0, _types.CoaxPortMode).asi:
            return (0, _types.PortType).coax;
        case (0, _types.IpcPortMode).unix:
            return (0, _types.PortType).ip;
        case (0, _types.VideonPortMode).videonSdi:
            return (0, _types.PortType).videon;
        case (0, _types.VideonPortMode).videonHdmi:
            return (0, _types.PortType).videon;
        case (0, _types.VideonPortMode).videonAuto:
            return (0, _types.PortType).videon;
        case (0, _types.MatroxPortMode).matroxSdi:
            return (0, _types.PortType).coax;
        case (0, _types.ComprimatoPortMode).comprimatoSdi:
            return (0, _types.PortType).coax;
        case (0, _types.ComprimatoPortMode).comprimatoNdi:
            return (0, _types.PortType).ndi;
    }
}
const COAX_MODES = [
    ...Object.values((0, _types.CoaxPortMode)),
    ...Object.values((0, _types.MatroxPortMode)),
    (0, _types.ComprimatoPortMode).comprimatoSdi
];

},{"mapbox-gl":"8QZuN","common/api/v1/types":"3qemx","react":"9njXz","@mui/material/Typography":"6NtGx","lodash/cloneDeep":"kA4yF","./hooks":"5aY3q","./validation":"dAasQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8QZuN":[function(require,module,exports,__globalThis) {
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== 'undefined' && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: 'text/javascript'
            }));
        }
    }
    define([
        "exports"
    ], function(t1) {
        "use strict";
        var e1 = "undefined" != typeof self ? self : {}, r = "2.13.0";
        let n;
        const i = {
            API_URL: "https://api.mapbox.com",
            get API_URL_REGEX () {
                if (null == n) {
                    const t1 = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
                    try {
                        n = t1;
                    } catch (e1) {
                        n = t1;
                    }
                }
                return n;
            },
            get API_TILEJSON_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
            },
            get API_SPRITE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
            },
            get API_FONTS_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
            },
            get API_STYLE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
            },
            get API_CDN_URL_REGEX () {
                return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
            },
            get EVENTS_URL () {
                return this.API_URL ? 0 === this.API_URL.indexOf("https://api.mapbox.cn") ? "https://events.mapbox.cn/events/v2" : 0 === this.API_URL.indexOf("https://api.mapbox.com") ? "https://events.mapbox.com/events/v2" : null : null;
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            MAX_PARALLEL_IMAGE_REQUESTS: 16
        }, s = {
            supported: !1,
            testSupport: function(t1) {
                !l && o && (u ? c(t1) : a = t1);
            }
        };
        let a, o, l = !1, u = !1;
        function c(t1) {
            const e1 = t1.createTexture();
            t1.bindTexture(t1.TEXTURE_2D, e1);
            try {
                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, o), t1.isContextLost()) return;
                s.supported = !0;
            } catch (t1) {}
            t1.deleteTexture(e1), l = !0;
        }
        e1.document && (o = e1.document.createElement("img"), o.onload = function() {
            a && c(a), a = null, u = !0;
        }, o.onerror = function() {
            l = !0, a = null;
        }, o.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const h = "01";
        var p = f;
        function f(t1, e1, r, n) {
            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = e1, this.p2x = r, this.p2y = n;
        }
        f.prototype = {
            sampleCurveX: function(t1) {
                return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
            },
            sampleCurveY: function(t1) {
                return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
            },
            sampleCurveDerivativeX: function(t1) {
                return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
            },
            solveCurveX: function(t1, e1) {
                if (void 0 === e1 && (e1 = 1e-6), t1 < 0) return 0;
                if (t1 > 1) return 1;
                for(var r = t1, n = 0; n < 8; n++){
                    var i = this.sampleCurveX(r) - t1;
                    if (Math.abs(i) < e1) return r;
                    var s = this.sampleCurveDerivativeX(r);
                    if (Math.abs(s) < 1e-6) break;
                    r -= i / s;
                }
                var a = 0, o = 1;
                for(r = t1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t1) < e1)); n++)t1 > i ? a = r : o = r, r = .5 * (o - a) + a;
                return r;
            },
            solve: function(t1, e1) {
                return this.sampleCurveY(this.solveCurveX(t1, e1));
            }
        };
        var d = y;
        function y(t1, e1) {
            this.x = t1, this.y = e1;
        }
        y.prototype = {
            clone: function() {
                return new y(this.x, this.y);
            },
            add: function(t1) {
                return this.clone()._add(t1);
            },
            sub: function(t1) {
                return this.clone()._sub(t1);
            },
            multByPoint: function(t1) {
                return this.clone()._multByPoint(t1);
            },
            divByPoint: function(t1) {
                return this.clone()._divByPoint(t1);
            },
            mult: function(t1) {
                return this.clone()._mult(t1);
            },
            div: function(t1) {
                return this.clone()._div(t1);
            },
            rotate: function(t1) {
                return this.clone()._rotate(t1);
            },
            rotateAround: function(t1, e1) {
                return this.clone()._rotateAround(t1, e1);
            },
            matMult: function(t1) {
                return this.clone()._matMult(t1);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t1) {
                return this.x === t1.x && this.y === t1.y;
            },
            dist: function(t1) {
                return Math.sqrt(this.distSqr(t1));
            },
            distSqr: function(t1) {
                var e1 = t1.x - this.x, r = t1.y - this.y;
                return e1 * e1 + r * r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t1) {
                return Math.atan2(this.y - t1.y, this.x - t1.x);
            },
            angleWith: function(t1) {
                return this.angleWithSep(t1.x, t1.y);
            },
            angleWithSep: function(t1, e1) {
                return Math.atan2(this.x * e1 - this.y * t1, this.x * t1 + this.y * e1);
            },
            _matMult: function(t1) {
                var e1 = t1[2] * this.x + t1[3] * this.y;
                return this.x = t1[0] * this.x + t1[1] * this.y, this.y = e1, this;
            },
            _add: function(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            },
            _sub: function(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            },
            _mult: function(t1) {
                return this.x *= t1, this.y *= t1, this;
            },
            _div: function(t1) {
                return this.x /= t1, this.y /= t1, this;
            },
            _multByPoint: function(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            },
            _divByPoint: function(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var t1 = this.y;
                return this.y = this.x, this.x = -t1, this;
            },
            _rotate: function(t1) {
                var e1 = Math.cos(t1), r = Math.sin(t1), n = r * this.x + e1 * this.y;
                return this.x = e1 * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround: function(t1, e1) {
                var r = Math.cos(t1), n = Math.sin(t1), i = e1.y + n * (this.x - e1.x) + r * (this.y - e1.y);
                return this.x = e1.x + r * (this.x - e1.x) - n * (this.y - e1.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, y.convert = function(t1) {
            return t1 instanceof y ? t1 : Array.isArray(t1) ? new y(t1[0], t1[1]) : t1;
        };
        const m = Math.PI / 180, g = 180 / Math.PI;
        function x(t1) {
            return t1 * m;
        }
        function v(t1) {
            return t1 * g;
        }
        const b = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function w(t1) {
            if (t1 <= 0) return 0;
            if (t1 >= 1) return 1;
            const e1 = t1 * t1, r = e1 * t1;
            return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
        }
        function _(t1, e1, r, n) {
            const i = new p(t1, e1, r, n);
            return function(t1) {
                return i.solve(t1);
            };
        }
        const A = _(.25, .1, .25, 1);
        function S(t1, e1, r) {
            return Math.min(r, Math.max(e1, t1));
        }
        function k(t1, e1, r) {
            return (r = S((r - t1) / (e1 - t1), 0, 1)) * r * (3 - 2 * r);
        }
        function I(t1, e1, r) {
            const n = r - e1, i = ((t1 - e1) % n + n) % n + e1;
            return i === e1 ? r : i;
        }
        function M(t1, e1, r) {
            if (!t1.length) return r(null, []);
            let n = t1.length;
            const i = new Array(t1.length);
            let s = null;
            t1.forEach((t1, a)=>{
                e1(t1, (t1, e1)=>{
                    t1 && (s = t1), i[a] = e1, 0 == --n && r(s, i);
                });
            });
        }
        function T(t1) {
            const e1 = [];
            for(const r in t1)e1.push(t1[r]);
            return e1;
        }
        function z(t1, ...e1) {
            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
            return t1;
        }
        let B = 1;
        function E() {
            return B++;
        }
        function C() {
            return function t1(e1) {
                return e1 ? (e1 ^ Math.random() * (16 >> e1 / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, t1);
            }();
        }
        function P(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }
        function D(t1) {
            return !!t1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t1);
        }
        function V(t1, e1) {
            t1.forEach((t1)=>{
                e1[t1] && (e1[t1] = e1[t1].bind(e1));
            });
        }
        function L(t1, e1) {
            return -1 !== t1.indexOf(e1, t1.length - e1.length);
        }
        function F(t1, e1, r) {
            const n = {};
            for(const i in t1)n[i] = e1.call(r || this, t1[i], i, t1);
            return n;
        }
        function R(t1, e1, r) {
            const n = {};
            for(const i in t1)e1.call(r || this, t1[i], i, t1) && (n[i] = t1[i]);
            return n;
        }
        function j(t1) {
            return Array.isArray(t1) ? t1.map(j) : "object" == typeof t1 && t1 ? F(t1, j) : t1;
        }
        const U = {};
        function $(t1) {
            U[t1] || ("undefined" != typeof console && console.warn(t1), U[t1] = !0);
        }
        function O(t1, e1, r) {
            return (r.y - t1.y) * (e1.x - t1.x) > (e1.y - t1.y) * (r.x - t1.x);
        }
        function q(t1) {
            let e1 = 0;
            for(let r, n, i = 0, s = t1.length, a = s - 1; i < s; a = i++)r = t1[i], n = t1[a], e1 += (n.x - r.x) * (r.y + n.y);
            return e1;
        }
        function N() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function G(t1) {
            const e1 = {};
            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t1, r, n, i)=>{
                const s = n || i;
                return e1[r] = !s || s.toLowerCase(), "";
            }), e1["max-age"]) {
                const t1 = parseInt(e1["max-age"], 10);
                isNaN(t1) ? delete e1["max-age"] : e1["max-age"] = t1;
            }
            return e1;
        }
        let X = null;
        function Z(t1) {
            if (null == X) {
                const e1 = t1.navigator ? t1.navigator.userAgent : null;
                X = !!t1.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
            }
            return X;
        }
        function K(t1) {
            try {
                const r = e1[t1];
                return r.setItem("_mapbox_test_", 1), r.removeItem("_mapbox_test_"), !0;
            } catch (t1) {
                return !1;
            }
        }
        function Y(t1, e1) {
            return [
                t1[4 * e1],
                t1[4 * e1 + 1],
                t1[4 * e1 + 2],
                t1[4 * e1 + 3]
            ];
        }
        const H = "mapbox-tiles";
        let W, J, Q = 500, tt = 50;
        function et() {
            try {
                return e1.caches;
            } catch (t1) {}
        }
        function rt() {
            et() && !W && (W = e1.caches.open(H));
        }
        function nt(t1) {
            const e1 = t1.indexOf("?");
            if (e1 < 0) return t1;
            const r = function(t1) {
                const e1 = t1.indexOf("?");
                return e1 > 0 ? t1.slice(e1 + 1).split("&") : [];
            }(t1), n = r.filter((t1)=>{
                const e1 = t1.split("=");
                return "language" === e1[0] || "worldview" === e1[0];
            });
            return n.length ? `${t1.slice(0, e1)}?${n.join("&")}` : t1.slice(0, e1);
        }
        let it = 1 / 0;
        const st = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Image: "Image"
        };
        "function" == typeof Object.freeze && Object.freeze(st);
        class at extends Error {
            constructor(t1, e1, r){
                401 === e1 && gt(r) && (t1 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(t1), this.status = e1, this.url = r;
            }
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
        }
        const ot = N() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === e1.location.protocol ? e1.parent : e1).location.href;
        const lt = function(t1, r) {
            if (!(/^file:/.test(n = t1.url) || /^file:/.test(ot()) && !/^\w+:/.test(n))) {
                if (e1.fetch && e1.Request && e1.AbortController && e1.Request.prototype.hasOwnProperty("signal")) return function(t1, r) {
                    const n = new e1.AbortController, i = new e1.Request(t1.url, {
                        method: t1.method || "GET",
                        body: t1.body,
                        credentials: t1.credentials,
                        headers: t1.headers,
                        referrer: ot(),
                        signal: n.signal
                    });
                    let s = !1, a = !1;
                    const o = (l = i.url).indexOf("sku=") > 0 && gt(l);
                    var l;
                    "json" === t1.type && i.headers.set("Accept", "application/json");
                    const u = (n, s, l)=>{
                        if (a) return;
                        if (n && "SecurityError" !== n.message && $(n), s && l) return c(s);
                        const u = Date.now();
                        e1.fetch(i).then((e1)=>{
                            if (e1.ok) {
                                const t1 = o ? e1.clone() : null;
                                return c(e1, t1, u);
                            }
                            return r(new at(e1.statusText, e1.status, t1.url));
                        }).catch((e1)=>{
                            "AbortError" !== e1.name && r(new Error(`${e1.message} ${t1.url}`));
                        });
                    }, c = (n, o, l)=>{
                        ("arrayBuffer" === t1.type ? n.arrayBuffer() : "json" === t1.type ? n.json() : n.text()).then((t1)=>{
                            a || (o && l && function(t1, r, n) {
                                if (rt(), !W) return;
                                const i = {
                                    status: r.status,
                                    statusText: r.statusText,
                                    headers: new e1.Headers
                                };
                                r.headers.forEach((t1, e1)=>i.headers.set(e1, t1));
                                const s = G(r.headers.get("Cache-Control") || "");
                                if (s["no-store"]) return;
                                s["max-age"] && i.headers.set("Expires", new Date(n + 1e3 * s["max-age"]).toUTCString());
                                const a = i.headers.get("Expires");
                                a && (new Date(a).getTime() - n < 42e4 || function(t1, e1) {
                                    if (void 0 === J) try {
                                        new Response(new ReadableStream), J = !0;
                                    } catch (t1) {
                                        J = !1;
                                    }
                                    J ? e1(t1.body) : t1.blob().then(e1);
                                }(r, (r)=>{
                                    const n = new e1.Response(r, i);
                                    rt(), W && W.then((e1)=>e1.put(nt(t1.url), n)).catch((t1)=>$(t1.message));
                                }));
                            }(i, o, l), s = !0, r(null, t1, n.headers.get("Cache-Control"), n.headers.get("Expires")));
                        }).catch((t1)=>{
                            a || r(new Error(t1.message));
                        });
                    };
                    return o ? function(t1, e1) {
                        if (rt(), !W) return e1(null);
                        const r = nt(t1.url);
                        W.then((t1)=>{
                            t1.match(r).then((n)=>{
                                const i = function(t1) {
                                    if (!t1) return !1;
                                    const e1 = new Date(t1.headers.get("Expires") || 0), r = G(t1.headers.get("Cache-Control") || "");
                                    return e1 > Date.now() && !r["no-cache"];
                                }(n);
                                t1.delete(r), i && t1.put(r, n.clone()), e1(null, n, i);
                            }).catch(e1);
                        }).catch(e1);
                    }(i, u) : u(null, null), {
                        cancel: ()=>{
                            a = !0, s || n.abort();
                        }
                    };
                }(t1, r);
                if (N() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, r, void 0, !0);
            }
            var n;
            return function(t1, r) {
                const n = new e1.XMLHttpRequest;
                n.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (n.responseType = "arraybuffer");
                for(const e1 in t1.headers)n.setRequestHeader(e1, t1.headers[e1]);
                return "json" === t1.type && (n.responseType = "text", n.setRequestHeader("Accept", "application/json")), n.withCredentials = "include" === t1.credentials, n.onerror = ()=>{
                    r(new Error(n.statusText));
                }, n.onload = ()=>{
                    if ((n.status >= 200 && n.status < 300 || 0 === n.status) && null !== n.response) {
                        let e1 = n.response;
                        if ("json" === t1.type) try {
                            e1 = JSON.parse(n.response);
                        } catch (t1) {
                            return r(t1);
                        }
                        r(null, e1, n.getResponseHeader("Cache-Control"), n.getResponseHeader("Expires"));
                    } else r(new at(n.statusText, n.status, t1.url));
                }, n.send(t1.body), {
                    cancel: ()=>n.abort()
                };
            }(t1, r);
        }, ut = function(t1, e1) {
            return lt(z(t1, {
                type: "arrayBuffer"
            }), e1);
        };
        function ct(t1) {
            const r = e1.document.createElement("a");
            return r.href = t1, r.protocol === e1.document.location.protocol && r.host === e1.document.location.host;
        }
        const ht = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let pt, ft;
        pt = [], ft = 0;
        const dt = function(t1, r) {
            if (s.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), ft >= i.MAX_PARALLEL_IMAGE_REQUESTS) {
                const e1 = {
                    requestParameters: t1,
                    callback: r,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return pt.push(e1), e1;
            }
            ft++;
            let n = !1;
            const a = ()=>{
                if (!n) for(n = !0, ft--; pt.length && ft < i.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const t1 = pt.shift(), { requestParameters: e1, callback: r, cancelled: n } = t1;
                    n || (t1.cancel = dt(e1, r).cancel);
                }
            }, o = ut(t1, (t1, n, i, s)=>{
                a(), t1 ? r(t1) : n && (e1.createImageBitmap ? function(t1, r) {
                    const n = new e1.Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    e1.createImageBitmap(n).then((t1)=>{
                        r(null, t1);
                    }).catch((t1)=>{
                        r(new Error(`Could not load image because of ${t1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                    });
                }(n, (t1, e1)=>r(t1, e1, i, s)) : function(t1, r) {
                    const n = new e1.Image, i = e1.URL;
                    n.onload = ()=>{
                        r(null, n), i.revokeObjectURL(n.src), n.onload = null, e1.requestAnimationFrame(()=>{
                            n.src = ht;
                        });
                    }, n.onerror = ()=>r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    const s = new e1.Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    n.src = t1.byteLength ? i.createObjectURL(s) : ht;
                }(n, (t1, e1)=>r(t1, e1, i, s)));
            });
            return {
                cancel: ()=>{
                    o.cancel(), a();
                }
            };
        }, yt = "NO_ACCESS_TOKEN";
        function mt(t1) {
            return 0 === t1.indexOf("mapbox:");
        }
        function gt(t1) {
            return i.API_URL_REGEX.test(t1);
        }
        function xt(t1) {
            return i.API_CDN_URL_REGEX.test(t1);
        }
        function vt(t1) {
            return i.API_STYLE_REGEX.test(t1) && !bt(t1);
        }
        function bt(t1) {
            return i.API_SPRITE_REGEX.test(t1);
        }
        const wt = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function _t(t1) {
            const e1 = t1.match(wt);
            if (!e1) throw new Error("Unable to parse URL object");
            return {
                protocol: e1[1],
                authority: e1[2],
                path: e1[3] || "/",
                params: e1[4] ? e1[4].split("&") : []
            };
        }
        function At(t1) {
            const e1 = t1.params.length ? `?${t1.params.join("&")}` : "";
            return `${t1.protocol}://${t1.authority}${t1.path}${e1}`;
        }
        function St(t1) {
            if (!t1) return null;
            const r = t1.split(".");
            if (!r || 3 !== r.length) return null;
            try {
                return JSON.parse(decodeURIComponent(e1.atob(r[1]).split("").map((t1)=>"%" + ("00" + t1.charCodeAt(0).toString(16)).slice(-2)).join("")));
            } catch (t1) {
                return null;
            }
        }
        class kt {
            constructor(t1){
                this.type = t1, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
            getStorageKey(t1) {
                const r = St(i.ACCESS_TOKEN);
                let n = "";
                return n = r && r.u ? e1.btoa(encodeURIComponent(r.u).replace(/%([0-9A-F]{2})/g, (t1, e1)=>String.fromCharCode(Number("0x" + e1)))) : i.ACCESS_TOKEN || "", t1 ? `mapbox.eventData.${t1}:${n}` : `mapbox.eventData:${n}`;
            }
            fetchEventData() {
                const t1 = K("localStorage"), r = this.getStorageKey(), n = this.getStorageKey("uuid");
                if (t1) try {
                    const t1 = e1.localStorage.getItem(r);
                    t1 && (this.eventData = JSON.parse(t1));
                    const i = e1.localStorage.getItem(n);
                    i && (this.anonId = i);
                } catch (t1) {
                    $("Unable to read from LocalStorage");
                }
            }
            saveEventData() {
                const t1 = K("localStorage"), r = this.getStorageKey(), n = this.getStorageKey("uuid");
                if (t1) try {
                    e1.localStorage.setItem(n, this.anonId), Object.keys(this.eventData).length >= 1 && e1.localStorage.setItem(r, JSON.stringify(this.eventData));
                } catch (t1) {
                    $("Unable to write to LocalStorage");
                }
            }
            processRequests(t1) {}
            postEvent(t1, e1, r, n) {
                if (!i.EVENTS_URL) return;
                const s = _t(i.EVENTS_URL);
                s.params.push(`access_token=${n || i.ACCESS_TOKEN || ""}`);
                const a = {
                    event: this.type,
                    created: new Date(t1).toISOString()
                }, o = e1 ? z(a, e1) : a, l = {
                    url: At(s),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        o
                    ])
                };
                this.pendingRequest = function(t1, e1) {
                    return lt(z(t1, {
                        method: "POST"
                    }), e1);
                }(l, (t1)=>{
                    this.pendingRequest = null, r(t1), this.saveEventData(), this.processRequests(n);
                });
            }
            queueRequest(t1, e1) {
                this.queue.push(t1), this.processRequests(e1);
            }
        }
        const It = new class extends kt {
            constructor(t1){
                super("appUserTurnstile"), this._customAccessToken = t1;
            }
            postTurnstileEvent(t1, e1) {
                i.EVENTS_URL && i.ACCESS_TOKEN && Array.isArray(t1) && t1.some((t1)=>mt(t1) || gt(t1)) && this.queueRequest(Date.now(), e1);
            }
            processRequests(t1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const e1 = St(i.ACCESS_TOKEN), n = e1 ? e1.u : i.ACCESS_TOKEN;
                let s = n !== this.eventData.tokenU;
                D(this.anonId) || (this.anonId = C(), s = !0);
                const a = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const t1 = new Date(this.eventData.lastSuccess), e1 = new Date(a), r = (a - this.eventData.lastSuccess) / 864e5;
                    s = s || r >= 1 || r < -1 || t1.getDate() !== e1.getDate();
                } else s = !0;
                s ? this.postEvent(a, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: r,
                    skuId: h,
                    "enabled.telemetry": !1,
                    userId: this.anonId
                }, (t1)=>{
                    t1 || (this.eventData.lastSuccess = a, this.eventData.tokenU = n);
                }, t1) : this.processRequests();
            }
        }, Mt = It.postTurnstileEvent.bind(It), Tt = new class extends kt {
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
            postMapLoadEvent(t1, e1, r, n) {
                this.skuToken = e1, this.errorCb = n, i.EVENTS_URL && (r || i.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, r) : this.errorCb(new Error(yt)));
            }
            processRequests(t1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: e1, timestamp: n } = this.queue.shift();
                e1 && this.success[e1] || (this.anonId || this.fetchEventData(), D(this.anonId) || (this.anonId = C()), this.postEvent(n, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: r,
                    skuId: h,
                    skuToken: this.skuToken,
                    userId: this.anonId
                }, (t1)=>{
                    t1 ? this.errorCb(t1) : e1 && (this.success[e1] = !0);
                }, t1));
            }
        }, zt = Tt.postMapLoadEvent.bind(Tt), Bt = new class extends kt {
            constructor(){
                super("gljs.performance");
            }
            postPerformanceEvent(t1, e1) {
                i.EVENTS_URL && (t1 || i.ACCESS_TOKEN) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: e1
                }, t1);
            }
            processRequests(t1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: n, performanceData: i } = this.queue.shift(), s = function(t1) {
                    const n = e1.performance.getEntriesByType("resource"), i = e1.performance.getEntriesByType("mark"), s = function(t1) {
                        const e1 = {};
                        if (t1) {
                            for(const r in t1)if ("other" !== r) for (const n of t1[r]){
                                const t1 = `${r}ResolveRangeMin`, i = `${r}ResolveRangeMax`, s = `${r}RequestCount`, a = `${r}RequestCachedCount`;
                                e1[t1] = Math.min(e1[t1] || 1 / 0, n.startTime), e1[i] = Math.max(e1[i] || -1 / 0, n.responseEnd);
                                const o = (t1)=>{
                                    void 0 === e1[t1] && (e1[t1] = 0), ++e1[t1];
                                };
                                void 0 !== n.transferSize && 0 === n.transferSize && o(a), o(s);
                            }
                        }
                        return e1;
                    }(function(t1, e1) {
                        const r = {};
                        if (t1) for (const n of t1){
                            const t1 = e1(n);
                            void 0 === r[t1] && (r[t1] = []), r[t1].push(n);
                        }
                        return r;
                    }(n, Ft)), a = e1.devicePixelRatio, o = e1.navigator.connection || e1.navigator.mozConnection || e1.navigator.webkitConnection, l = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, u = (t1, e1, r)=>{
                        null != r && t1.push({
                            name: e1,
                            value: r.toString()
                        });
                    };
                    for(const t1 in s)u(l.counters, t1, s[t1]);
                    if (t1.interactionRange[0] !== 1 / 0 && t1.interactionRange[1] !== -1 / 0 && (u(l.counters, "interactionRangeMin", t1.interactionRange[0]), u(l.counters, "interactionRangeMax", t1.interactionRange[1])), i) for (const t1 of Object.keys(Vt)){
                        const e1 = Vt[t1], r = i.find((t1)=>t1.name === e1);
                        r && u(l.counters, e1, r.startTime);
                    }
                    return u(l.counters, "visibilityHidden", t1.visibilityHidden), u(l.attributes, "style", function(t1) {
                        if (t1) for (const e1 of t1){
                            const t1 = e1.name.split("?")[0];
                            if (vt(t1)) {
                                const e1 = t1.split("/").slice(-2);
                                if (2 === e1.length) return `mapbox://styles/${e1[0]}/${e1[1]}`;
                            }
                        }
                    }(n)), u(l.attributes, "terrainEnabled", t1.terrainEnabled ? "true" : "false"), u(l.attributes, "fogEnabled", t1.fogEnabled ? "true" : "false"), u(l.attributes, "projection", t1.projection), u(l.attributes, "zoom", t1.zoom), u(l.metadata, "devicePixelRatio", a), u(l.metadata, "connectionEffectiveType", o ? o.effectiveType : void 0), u(l.metadata, "navigatorUserAgent", e1.navigator.userAgent), u(l.metadata, "screenWidth", e1.screen.width), u(l.metadata, "screenHeight", e1.screen.height), u(l.metadata, "windowWidth", e1.innerWidth), u(l.metadata, "windowHeight", e1.innerHeight), u(l.metadata, "mapWidth", t1.width / a), u(l.metadata, "mapHeight", t1.height / a), u(l.metadata, "webglRenderer", t1.renderer), u(l.metadata, "webglVendor", t1.vendor), u(l.metadata, "sdkVersion", r), u(l.metadata, "sdkIdentifier", "mapbox-gl-js"), l;
                }(i);
                for (const t1 of s.metadata);
                for (const t1 of s.counters);
                for (const t1 of s.attributes);
                this.postEvent(n, s, ()=>{}, t1);
            }
        }, Et = Bt.postPerformanceEvent.bind(Bt), Ct = new class extends kt {
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
            getSession(t1, e1, r, n) {
                if (!i.API_URL || !i.SESSION_PATH) return;
                const s = _t(i.API_URL + i.SESSION_PATH);
                s.params.push(`sku=${e1 || ""}`), s.params.push(`access_token=${n || i.ACCESS_TOKEN || ""}`);
                const a = {
                    url: At(s),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = function(t1, e1) {
                    return lt(z(t1, {
                        method: "GET"
                    }), e1);
                }(a, (t1)=>{
                    this.pendingRequest = null, r(t1), this.saveEventData(), this.processRequests(n);
                });
            }
            getSessionAPI(t1, e1, r, n) {
                this.skuToken = e1, this.errorCb = n, i.SESSION_PATH && i.API_URL && (r || i.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, r) : this.errorCb(new Error(yt)));
            }
            processRequests(t1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: e1, timestamp: r } = this.queue.shift();
                e1 && this.success[e1] || this.getSession(r, this.skuToken, (t1)=>{
                    t1 ? this.errorCb(t1) : e1 && (this.success[e1] = !0);
                }, t1);
            }
        }, Pt = Ct.getSessionAPI.bind(Ct), Dt = new Set, Vt = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, Lt = {
            mark (t1) {
                e1.performance.mark(t1);
            },
            measure (t1, r, n) {
                e1.performance.measure(t1, r, n);
            }
        };
        function Ft(t1) {
            const e1 = t1.name.split("?")[0];
            return xt(e1) && e1.includes("mapbox-gl.js") ? "javascript" : xt(e1) && e1.includes("mapbox-gl.css") ? "css" : function(t1) {
                return i.API_FONTS_REGEX.test(t1);
            }(e1) ? "fontRange" : bt(e1) ? "sprite" : vt(e1) ? "style" : function(t1) {
                return i.API_TILEJSON_REGEX.test(t1);
            }(e1) ? "tilejson" : "other";
        }
        const Rt = e1.performance;
        function jt(t1) {
            const e1 = t1 ? t1.url.toString() : void 0;
            return Rt.getEntriesByName(e1);
        }
        let Ut, $t, Ot, qt;
        const Nt = {
            now: ()=>void 0 !== Ot ? Ot : e1.performance.now(),
            setNow (t1) {
                Ot = t1;
            },
            restoreNow () {
                Ot = void 0;
            },
            frame (t1) {
                const r = e1.requestAnimationFrame(t1);
                return {
                    cancel: ()=>e1.cancelAnimationFrame(r)
                };
            },
            getImageData (t1, r = 0) {
                const { width: n, height: i } = t1;
                qt || (qt = e1.document.createElement("canvas"));
                const s = qt.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!s) throw new Error("failed to create canvas 2d context");
                return (n > qt.width || i > qt.height) && (qt.width = n, qt.height = i), s.clearRect(-r, -r, n + 2 * r, i + 2 * r), s.drawImage(t1, 0, 0, n, i), s.getImageData(-r, -r, n + 2 * r, i + 2 * r);
            },
            resolveURL: (t1)=>(Ut || (Ut = e1.document.createElement("a")), Ut.href = t1, Ut.href),
            get devicePixelRatio () {
                return e1.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!e1.matchMedia && (null == $t && ($t = e1.matchMedia("(prefers-reduced-motion: reduce)")), $t.matches);
            }
        };
        function Gt(t1, e1, r) {
            r[t1] && -1 !== r[t1].indexOf(e1) || (r[t1] = r[t1] || [], r[t1].push(e1));
        }
        function Xt(t1, e1, r) {
            if (r && r[t1]) {
                const n = r[t1].indexOf(e1);
                -1 !== n && r[t1].splice(n, 1);
            }
        }
        class Zt {
            constructor(t1, e1 = {}){
                z(this, e1), this.type = t1;
            }
        }
        class Kt extends Zt {
            constructor(t1, e1 = {}){
                super("error", z({
                    error: t1
                }, e1));
            }
        }
        class Yt {
            on(t1, e1) {
                return this._listeners = this._listeners || {}, Gt(t1, e1, this._listeners), this;
            }
            off(t1, e1) {
                return Xt(t1, e1, this._listeners), Xt(t1, e1, this._oneTimeListeners), this;
            }
            once(t1, e1) {
                return e1 ? (this._oneTimeListeners = this._oneTimeListeners || {}, Gt(t1, e1, this._oneTimeListeners), this) : new Promise((e1)=>this.once(t1, e1));
            }
            fire(t1, e1) {
                "string" == typeof t1 && (t1 = new Zt(t1, e1 || {}));
                const r = t1.type;
                if (this.listens(r)) {
                    t1.target = this;
                    const e1 = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                    for (const r of e1)r.call(this, t1);
                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                    for (const e1 of n)Xt(r, e1, this._oneTimeListeners), e1.call(this, t1);
                    const i = this._eventedParent;
                    i && (z(t1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t1));
                } else t1 instanceof Kt && console.error(t1.error);
                return this;
            }
            listens(t1) {
                return !!(this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1));
            }
            setEventedParent(t1, e1) {
                return this._eventedParent = t1, this._eventedParentData = e1, this;
            }
        }
        var Ht = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360,"units":"degrees"},"pitch":{"type":"number","default":0,"units":"degrees"},"light":{"type":"light"},"terrain":{"type":"terrain"},"fog":{"type":"fog"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":{},"mapbox":{}},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":{}}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":{}}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":{}}},"url":{"required":true,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"hillshade":{},"background":{},"sky":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background","layout_sky"],"layout_background":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","private":true,"default":0,"minimum":0,"maximum":1,"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":{},"round":{},"square":{}},"default":"butt","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":{},"round":{},"miter":{}},"default":"miter","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"requires":[{"line-join":"miter"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"requires":[{"line-join":"round"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":{},"line":{},"line-center":{}},"default":"point","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"units":"pixels","requires":[{"symbol-placement":"line"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":{},"viewport-y":{},"source":{}},"default":"auto","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"units":"factor of the original icon size","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":{},"width":{},"height":{},"both":{}},"default":"none","requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"units":"pixels","requires":["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"requires":["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"units":"ems","requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":{},"left":{},"center":{},"right":{}},"default":"center","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","units":"ems","default":0,"requires":["text-field"],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["text-field",{"!":"text-variable-anchor"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"units":"degrees","requires":["text-field",{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":{},"vertical":{}},"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"requires":["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":{},"uppercase":{},"lowercase":{}},"default":"none","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","units":"ems","length":2,"default":[0,0],"requires":["text-field",{"!":"text-radial-offset"}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"requires":["text-field","icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},"in":{},"!in":{},"all":{},"any":{},"none":{},"has":{},"!has":{},"within":{}}},"geometry_type":{"type":"enum","values":{"Point":{},"LineString":{},"Polygon":{}}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":{},"exponential":{},"interval":{},"categorical":{}},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":{},"lab":{},"hcl":{}},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":{},"viewport":{}},"property-type":"data-constant","transition":false,"expression":{"interpolated":false,"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":{},"equalEarth":{},"equirectangular":{},"lambertConformalConic":{},"mercator":{},"naturalEarth":{},"winkelTripel":{},"globe":{}},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90],"transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90],"transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"requires":["source"]}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background","paint_sky"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"requires":[{"!":"fill-pattern"},{"fill-antialias":true}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","transition":false,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-extrusion-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-extrusion-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","transition":false,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"requires":["fill-extrusion-height"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","private":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"requires":["fill-extrusion-edge-radius"]}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"line-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["line-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"transition":false,"units":"line widths","requires":[{"!":"line-pattern"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","transition":false,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","transition":false,"requires":[{"!":"line-pattern"},{"source":"geojson","has":{"lineMetrics":true}}],"expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"transition":false,"requires":[{"source":"geojson","has":{"lineMetrics":true}}],"property-type":"constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["circle-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"transition":false,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"transition":false,"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["icon-image","icon-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["text-field","text-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"units":"degrees","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":{},"nearest":{}},"default":"linear","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"transition":false,"units":"milliseconds","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"transition":false,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_background":{"background-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"background-pattern"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":{},"atmosphere":{}},"default":"atmosphere","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"requires":[{"sky-type":"atmosphere"}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","requires":[{"sky-type":"atmosphere"}],"default":10,"minimum":0,"maximum":100,"transition":false,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","requires":[{"sky-type":"gradient"}],"value":"number","default":[0,0],"length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","requires":[{"sky-type":"gradient"}],"default":90,"minimum":0,"maximum":180,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"transition":false,"requires":[{"sky-type":"gradient"}],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"transition":{"duration":{"type":"number","default":300,"minimum":0,"units":"milliseconds"},"delay":{"type":"number","default":0,"minimum":0,"units":"milliseconds"}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
        function Wt(t1, ...e1) {
            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
            return t1;
        }
        function Jt(t1) {
            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
        }
        function Qt(t1) {
            if (Array.isArray(t1)) return t1.map(Qt);
            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                const e1 = {};
                for(const r in t1)e1[r] = Qt(t1[r]);
                return e1;
            }
            return Jt(t1);
        }
        class te extends Error {
            constructor(t1, e1){
                super(e1), this.message = e1, this.key = t1;
            }
        }
        var ee = te;
        class re {
            constructor(t1, e1 = []){
                this.parent = t1, this.bindings = {};
                for (const [t1, r] of e1)this.bindings[t1] = r;
            }
            concat(t1) {
                return new re(this, t1);
            }
            get(t1) {
                if (this.bindings[t1]) return this.bindings[t1];
                if (this.parent) return this.parent.get(t1);
                throw new Error(`${t1} not found in scope.`);
            }
            has(t1) {
                return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
            }
        }
        var ne = re;
        const ie = {
            kind: "null"
        }, se = {
            kind: "number"
        }, ae = {
            kind: "string"
        }, oe = {
            kind: "boolean"
        }, le = {
            kind: "color"
        }, ue = {
            kind: "object"
        }, ce = {
            kind: "value"
        }, he = {
            kind: "collator"
        }, pe = {
            kind: "formatted"
        }, fe = {
            kind: "resolvedImage"
        };
        function de(t1, e1) {
            return {
                kind: "array",
                itemType: t1,
                N: e1
            };
        }
        function ye(t1) {
            if ("array" === t1.kind) {
                const e1 = ye(t1.itemType);
                return "number" == typeof t1.N ? `array<${e1}, ${t1.N}>` : "value" === t1.itemType.kind ? "array" : `array<${e1}>`;
            }
            return t1.kind;
        }
        const me = [
            ie,
            se,
            ae,
            oe,
            le,
            pe,
            ue,
            de(ce),
            fe
        ];
        function ge(t1, e1) {
            if ("error" === e1.kind) return null;
            if ("array" === t1.kind) {
                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !ge(t1.itemType, e1.itemType)) && ("number" != typeof t1.N || t1.N === e1.N)) return null;
            } else {
                if (t1.kind === e1.kind) return null;
                if ("value" === t1.kind) {
                    for (const t1 of me)if (!ge(t1, e1)) return null;
                }
            }
            return `Expected ${ye(t1)} but found ${ye(e1)} instead.`;
        }
        function xe(t1, e1) {
            return e1.some((e1)=>e1.kind === t1.kind);
        }
        function ve(t1, e1) {
            return e1.some((e1)=>"null" === e1 ? null === t1 : "array" === e1 ? Array.isArray(t1) : "object" === e1 ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e1 === typeof t1);
        }
        var be, we = {
            transparent: [
                0,
                0,
                0,
                0
            ],
            aliceblue: [
                240,
                248,
                255,
                1
            ],
            antiquewhite: [
                250,
                235,
                215,
                1
            ],
            aqua: [
                0,
                255,
                255,
                1
            ],
            aquamarine: [
                127,
                255,
                212,
                1
            ],
            azure: [
                240,
                255,
                255,
                1
            ],
            beige: [
                245,
                245,
                220,
                1
            ],
            bisque: [
                255,
                228,
                196,
                1
            ],
            black: [
                0,
                0,
                0,
                1
            ],
            blanchedalmond: [
                255,
                235,
                205,
                1
            ],
            blue: [
                0,
                0,
                255,
                1
            ],
            blueviolet: [
                138,
                43,
                226,
                1
            ],
            brown: [
                165,
                42,
                42,
                1
            ],
            burlywood: [
                222,
                184,
                135,
                1
            ],
            cadetblue: [
                95,
                158,
                160,
                1
            ],
            chartreuse: [
                127,
                255,
                0,
                1
            ],
            chocolate: [
                210,
                105,
                30,
                1
            ],
            coral: [
                255,
                127,
                80,
                1
            ],
            cornflowerblue: [
                100,
                149,
                237,
                1
            ],
            cornsilk: [
                255,
                248,
                220,
                1
            ],
            crimson: [
                220,
                20,
                60,
                1
            ],
            cyan: [
                0,
                255,
                255,
                1
            ],
            darkblue: [
                0,
                0,
                139,
                1
            ],
            darkcyan: [
                0,
                139,
                139,
                1
            ],
            darkgoldenrod: [
                184,
                134,
                11,
                1
            ],
            darkgray: [
                169,
                169,
                169,
                1
            ],
            darkgreen: [
                0,
                100,
                0,
                1
            ],
            darkgrey: [
                169,
                169,
                169,
                1
            ],
            darkkhaki: [
                189,
                183,
                107,
                1
            ],
            darkmagenta: [
                139,
                0,
                139,
                1
            ],
            darkolivegreen: [
                85,
                107,
                47,
                1
            ],
            darkorange: [
                255,
                140,
                0,
                1
            ],
            darkorchid: [
                153,
                50,
                204,
                1
            ],
            darkred: [
                139,
                0,
                0,
                1
            ],
            darksalmon: [
                233,
                150,
                122,
                1
            ],
            darkseagreen: [
                143,
                188,
                143,
                1
            ],
            darkslateblue: [
                72,
                61,
                139,
                1
            ],
            darkslategray: [
                47,
                79,
                79,
                1
            ],
            darkslategrey: [
                47,
                79,
                79,
                1
            ],
            darkturquoise: [
                0,
                206,
                209,
                1
            ],
            darkviolet: [
                148,
                0,
                211,
                1
            ],
            deeppink: [
                255,
                20,
                147,
                1
            ],
            deepskyblue: [
                0,
                191,
                255,
                1
            ],
            dimgray: [
                105,
                105,
                105,
                1
            ],
            dimgrey: [
                105,
                105,
                105,
                1
            ],
            dodgerblue: [
                30,
                144,
                255,
                1
            ],
            firebrick: [
                178,
                34,
                34,
                1
            ],
            floralwhite: [
                255,
                250,
                240,
                1
            ],
            forestgreen: [
                34,
                139,
                34,
                1
            ],
            fuchsia: [
                255,
                0,
                255,
                1
            ],
            gainsboro: [
                220,
                220,
                220,
                1
            ],
            ghostwhite: [
                248,
                248,
                255,
                1
            ],
            gold: [
                255,
                215,
                0,
                1
            ],
            goldenrod: [
                218,
                165,
                32,
                1
            ],
            gray: [
                128,
                128,
                128,
                1
            ],
            green: [
                0,
                128,
                0,
                1
            ],
            greenyellow: [
                173,
                255,
                47,
                1
            ],
            grey: [
                128,
                128,
                128,
                1
            ],
            honeydew: [
                240,
                255,
                240,
                1
            ],
            hotpink: [
                255,
                105,
                180,
                1
            ],
            indianred: [
                205,
                92,
                92,
                1
            ],
            indigo: [
                75,
                0,
                130,
                1
            ],
            ivory: [
                255,
                255,
                240,
                1
            ],
            khaki: [
                240,
                230,
                140,
                1
            ],
            lavender: [
                230,
                230,
                250,
                1
            ],
            lavenderblush: [
                255,
                240,
                245,
                1
            ],
            lawngreen: [
                124,
                252,
                0,
                1
            ],
            lemonchiffon: [
                255,
                250,
                205,
                1
            ],
            lightblue: [
                173,
                216,
                230,
                1
            ],
            lightcoral: [
                240,
                128,
                128,
                1
            ],
            lightcyan: [
                224,
                255,
                255,
                1
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210,
                1
            ],
            lightgray: [
                211,
                211,
                211,
                1
            ],
            lightgreen: [
                144,
                238,
                144,
                1
            ],
            lightgrey: [
                211,
                211,
                211,
                1
            ],
            lightpink: [
                255,
                182,
                193,
                1
            ],
            lightsalmon: [
                255,
                160,
                122,
                1
            ],
            lightseagreen: [
                32,
                178,
                170,
                1
            ],
            lightskyblue: [
                135,
                206,
                250,
                1
            ],
            lightslategray: [
                119,
                136,
                153,
                1
            ],
            lightslategrey: [
                119,
                136,
                153,
                1
            ],
            lightsteelblue: [
                176,
                196,
                222,
                1
            ],
            lightyellow: [
                255,
                255,
                224,
                1
            ],
            lime: [
                0,
                255,
                0,
                1
            ],
            limegreen: [
                50,
                205,
                50,
                1
            ],
            linen: [
                250,
                240,
                230,
                1
            ],
            magenta: [
                255,
                0,
                255,
                1
            ],
            maroon: [
                128,
                0,
                0,
                1
            ],
            mediumaquamarine: [
                102,
                205,
                170,
                1
            ],
            mediumblue: [
                0,
                0,
                205,
                1
            ],
            mediumorchid: [
                186,
                85,
                211,
                1
            ],
            mediumpurple: [
                147,
                112,
                219,
                1
            ],
            mediumseagreen: [
                60,
                179,
                113,
                1
            ],
            mediumslateblue: [
                123,
                104,
                238,
                1
            ],
            mediumspringgreen: [
                0,
                250,
                154,
                1
            ],
            mediumturquoise: [
                72,
                209,
                204,
                1
            ],
            mediumvioletred: [
                199,
                21,
                133,
                1
            ],
            midnightblue: [
                25,
                25,
                112,
                1
            ],
            mintcream: [
                245,
                255,
                250,
                1
            ],
            mistyrose: [
                255,
                228,
                225,
                1
            ],
            moccasin: [
                255,
                228,
                181,
                1
            ],
            navajowhite: [
                255,
                222,
                173,
                1
            ],
            navy: [
                0,
                0,
                128,
                1
            ],
            oldlace: [
                253,
                245,
                230,
                1
            ],
            olive: [
                128,
                128,
                0,
                1
            ],
            olivedrab: [
                107,
                142,
                35,
                1
            ],
            orange: [
                255,
                165,
                0,
                1
            ],
            orangered: [
                255,
                69,
                0,
                1
            ],
            orchid: [
                218,
                112,
                214,
                1
            ],
            palegoldenrod: [
                238,
                232,
                170,
                1
            ],
            palegreen: [
                152,
                251,
                152,
                1
            ],
            paleturquoise: [
                175,
                238,
                238,
                1
            ],
            palevioletred: [
                219,
                112,
                147,
                1
            ],
            papayawhip: [
                255,
                239,
                213,
                1
            ],
            peachpuff: [
                255,
                218,
                185,
                1
            ],
            peru: [
                205,
                133,
                63,
                1
            ],
            pink: [
                255,
                192,
                203,
                1
            ],
            plum: [
                221,
                160,
                221,
                1
            ],
            powderblue: [
                176,
                224,
                230,
                1
            ],
            purple: [
                128,
                0,
                128,
                1
            ],
            rebeccapurple: [
                102,
                51,
                153,
                1
            ],
            red: [
                255,
                0,
                0,
                1
            ],
            rosybrown: [
                188,
                143,
                143,
                1
            ],
            royalblue: [
                65,
                105,
                225,
                1
            ],
            saddlebrown: [
                139,
                69,
                19,
                1
            ],
            salmon: [
                250,
                128,
                114,
                1
            ],
            sandybrown: [
                244,
                164,
                96,
                1
            ],
            seagreen: [
                46,
                139,
                87,
                1
            ],
            seashell: [
                255,
                245,
                238,
                1
            ],
            sienna: [
                160,
                82,
                45,
                1
            ],
            silver: [
                192,
                192,
                192,
                1
            ],
            skyblue: [
                135,
                206,
                235,
                1
            ],
            slateblue: [
                106,
                90,
                205,
                1
            ],
            slategray: [
                112,
                128,
                144,
                1
            ],
            slategrey: [
                112,
                128,
                144,
                1
            ],
            snow: [
                255,
                250,
                250,
                1
            ],
            springgreen: [
                0,
                255,
                127,
                1
            ],
            steelblue: [
                70,
                130,
                180,
                1
            ],
            tan: [
                210,
                180,
                140,
                1
            ],
            teal: [
                0,
                128,
                128,
                1
            ],
            thistle: [
                216,
                191,
                216,
                1
            ],
            tomato: [
                255,
                99,
                71,
                1
            ],
            turquoise: [
                64,
                224,
                208,
                1
            ],
            violet: [
                238,
                130,
                238,
                1
            ],
            wheat: [
                245,
                222,
                179,
                1
            ],
            white: [
                255,
                255,
                255,
                1
            ],
            whitesmoke: [
                245,
                245,
                245,
                1
            ],
            yellow: [
                255,
                255,
                0,
                1
            ],
            yellowgreen: [
                154,
                205,
                50,
                1
            ]
        };
        function _e(t1) {
            return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
        }
        function Ae(t1) {
            return _e("%" === t1[t1.length - 1] ? parseFloat(t1) / 100 * 255 : parseInt(t1));
        }
        function Se(t1) {
            var e1;
            return (e1 = "%" === t1[t1.length - 1] ? parseFloat(t1) / 100 : parseFloat(t1)) < 0 ? 0 : e1 > 1 ? 1 : e1;
        }
        function ke(t1, e1, r) {
            return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e1 - t1) * r * 6 : 2 * r < 1 ? e1 : 3 * r < 2 ? t1 + (e1 - t1) * (2 / 3 - r) * 6 : t1;
        }
        try {
            be = ({}).parseCSSColor = function(t1) {
                var e1, r = t1.replace(/ /g, "").toLowerCase();
                if (r in we) return we[r].slice();
                if ("#" === r[0]) return 4 === r.length ? (e1 = parseInt(r.substr(1), 16)) >= 0 && e1 <= 4095 ? [
                    (3840 & e1) >> 4 | (3840 & e1) >> 8,
                    240 & e1 | (240 & e1) >> 4,
                    15 & e1 | (15 & e1) << 4,
                    1
                ] : null : 7 === r.length && (e1 = parseInt(r.substr(1), 16)) >= 0 && e1 <= 16777215 ? [
                    (16711680 & e1) >> 16,
                    (65280 & e1) >> 8,
                    255 & e1,
                    1
                ] : null;
                var n = r.indexOf("("), i = r.indexOf(")");
                if (-1 !== n && i + 1 === r.length) {
                    var s = r.substr(0, n), a = r.substr(n + 1, i - (n + 1)).split(","), o = 1;
                    switch(s){
                        case "rgba":
                            if (4 !== a.length) return null;
                            o = Se(a.pop());
                        case "rgb":
                            return 3 !== a.length ? null : [
                                Ae(a[0]),
                                Ae(a[1]),
                                Ae(a[2]),
                                o
                            ];
                        case "hsla":
                            if (4 !== a.length) return null;
                            o = Se(a.pop());
                        case "hsl":
                            if (3 !== a.length) return null;
                            var l = (parseFloat(a[0]) % 360 + 360) % 360 / 360, u = Se(a[1]), c = Se(a[2]), h = c <= .5 ? c * (u + 1) : c + u - c * u, p = 2 * c - h;
                            return [
                                _e(255 * ke(p, h, l + 1 / 3)),
                                _e(255 * ke(p, h, l)),
                                _e(255 * ke(p, h, l - 1 / 3)),
                                o
                            ];
                        default:
                            return null;
                    }
                }
                return null;
            };
        } catch (t1) {}
        class Ie {
            constructor(t1, e1, r, n = 1){
                this.r = t1, this.g = e1, this.b = r, this.a = n;
            }
            static parse(t1) {
                if (!t1) return;
                if (t1 instanceof Ie) return t1;
                if ("string" != typeof t1) return;
                const e1 = be(t1);
                return e1 ? new Ie(e1[0] / 255 * e1[3], e1[1] / 255 * e1[3], e1[2] / 255 * e1[3], e1[3]) : void 0;
            }
            toString() {
                const [t1, e1, r, n] = this.toArray();
                return `rgba(${Math.round(t1)},${Math.round(e1)},${Math.round(r)},${n})`;
            }
            toArray() {
                const { r: t1, g: e1, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    255 * t1 / n,
                    255 * e1 / n,
                    255 * r / n,
                    n
                ];
            }
            toArray01() {
                const { r: t1, g: e1, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    t1 / n,
                    e1 / n,
                    r / n,
                    n
                ];
            }
            toArray01PremultipliedAlpha() {
                const { r: t1, g: e1, b: r, a: n } = this;
                return [
                    t1,
                    e1,
                    r,
                    n
                ];
            }
        }
        Ie.black = new Ie(0, 0, 0, 1), Ie.white = new Ie(1, 1, 1, 1), Ie.transparent = new Ie(0, 0, 0, 0), Ie.red = new Ie(1, 0, 0, 1), Ie.blue = new Ie(0, 0, 1, 1);
        var Me = Ie;
        class Te {
            constructor(t1, e1, r){
                this.sensitivity = t1 ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(t1, e1) {
                return this.collator.compare(t1, e1);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class ze {
            constructor(t1, e1, r, n, i){
                this.text = t1.normalize ? t1.normalize() : t1, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Be {
            constructor(t1){
                this.sections = t1;
            }
            static fromString(t1) {
                return new Be([
                    new ze(t1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t1)=>0 !== t1.text.length || t1.image && 0 !== t1.image.name.length);
            }
            static factory(t1) {
                return t1 instanceof Be ? t1 : Be.fromString(t1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t1)=>t1.text).join("");
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e1 of this.sections){
                    if (e1.image) {
                        t1.push([
                            "image",
                            e1.image.name
                        ]);
                        continue;
                    }
                    t1.push(e1.text);
                    const r = {};
                    e1.fontStack && (r["text-font"] = [
                        "literal",
                        e1.fontStack.split(",")
                    ]), e1.scale && (r["font-scale"] = e1.scale), e1.textColor && (r["text-color"] = [
                        "rgba"
                    ].concat(e1.textColor.toArray())), t1.push(r);
                }
                return t1;
            }
        }
        class Ee {
            constructor(t1){
                this.name = t1.name, this.available = t1.available;
            }
            toString() {
                return this.name;
            }
            static fromString(t1) {
                return t1 ? new Ee({
                    name: t1,
                    available: !1
                }) : null;
            }
            serialize() {
                return [
                    "image",
                    this.name
                ];
            }
        }
        function Ce(t1, e1, r, n) {
            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t1,
                e1,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t1,
                e1,
                r,
                n
            ] : [
                t1,
                e1,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Pe(t1) {
            if (null === t1) return !0;
            if ("string" == typeof t1) return !0;
            if ("boolean" == typeof t1) return !0;
            if ("number" == typeof t1) return !0;
            if (t1 instanceof Me) return !0;
            if (t1 instanceof Te) return !0;
            if (t1 instanceof Be) return !0;
            if (t1 instanceof Ee) return !0;
            if (Array.isArray(t1)) {
                for (const e1 of t1)if (!Pe(e1)) return !1;
                return !0;
            }
            if ("object" == typeof t1) {
                for(const e1 in t1)if (!Pe(t1[e1])) return !1;
                return !0;
            }
            return !1;
        }
        function De(t1) {
            if (null === t1) return ie;
            if ("string" == typeof t1) return ae;
            if ("boolean" == typeof t1) return oe;
            if ("number" == typeof t1) return se;
            if (t1 instanceof Me) return le;
            if (t1 instanceof Te) return he;
            if (t1 instanceof Be) return pe;
            if (t1 instanceof Ee) return fe;
            if (Array.isArray(t1)) {
                const e1 = t1.length;
                let r;
                for (const e1 of t1){
                    const t1 = De(e1);
                    if (r) {
                        if (r === t1) continue;
                        r = ce;
                        break;
                    }
                    r = t1;
                }
                return de(r || ce, e1);
            }
            return ue;
        }
        function Ve(t1) {
            const e1 = typeof t1;
            return null === t1 ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t1) : t1 instanceof Me || t1 instanceof Be || t1 instanceof Ee ? t1.toString() : JSON.stringify(t1);
        }
        class Le {
            constructor(t1, e1){
                this.type = t1, this.value = e1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`'literal' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (!Pe(t1[1])) return e1.error("invalid value");
                const r = t1[1];
                let n = De(r);
                const i = e1.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new Le(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof Me ? [
                    "rgba"
                ].concat(this.value.toArray()) : this.value instanceof Be ? this.value.serialize() : this.value;
            }
        }
        var Fe = Le, Re = class {
            constructor(t1){
                this.name = "ExpressionEvaluationError", this.message = t1;
            }
            toJSON() {
                return this.message;
            }
        };
        const je = {
            string: ae,
            number: se,
            boolean: oe,
            object: ue
        };
        class Ue {
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                let r, n = 1;
                const i = t1[0];
                if ("array" === i) {
                    let i, s;
                    if (t1.length > 2) {
                        const r = t1[1];
                        if ("string" != typeof r || !(r in je) || "object" === r) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = je[r], n++;
                    } else i = ce;
                    if (t1.length > 3) {
                        if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                        s = t1[2], n++;
                    }
                    r = de(i, s);
                } else r = je[i];
                const s = [];
                for(; n < t1.length; n++){
                    const r = e1.parse(t1[n], n, ce);
                    if (!r) return null;
                    s.push(r);
                }
                return new Ue(r, s);
            }
            evaluate(t1) {
                for(let e1 = 0; e1 < this.args.length; e1++){
                    const r = this.args[e1].evaluate(t1);
                    if (!ge(this.type, De(r))) return r;
                    if (e1 === this.args.length - 1) throw new Re(`Expected value to be of type ${ye(this.type)}, but found ${ye(De(r))} instead.`);
                }
                return null;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = this.type, e1 = [
                    t1.kind
                ];
                if ("array" === t1.kind) {
                    const r = t1.itemType;
                    if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                        e1.push(r.kind);
                        const n = t1.N;
                        ("number" == typeof n || this.args.length > 1) && e1.push(n);
                    }
                }
                return e1.concat(this.args.map((t1)=>t1.serialize()));
            }
        }
        var $e = Ue;
        class Oe {
            constructor(t1){
                this.type = pe, this.sections = t1;
            }
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                const r = t1[1];
                if (!Array.isArray(r) && "object" == typeof r) return e1.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t1.length - 1; ++r){
                    const s = t1[r];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let t1 = null;
                        if (s["font-scale"] && (t1 = e1.parse(s["font-scale"], 1, se), !t1)) return null;
                        let r = null;
                        if (s["text-font"] && (r = e1.parse(s["text-font"], 1, de(ae)), !r)) return null;
                        let a = null;
                        if (s["text-color"] && (a = e1.parse(s["text-color"], 1, le), !a)) return null;
                        const o = n[n.length - 1];
                        o.scale = t1, o.font = r, o.textColor = a;
                    } else {
                        const s = e1.parse(t1[r], 1, ce);
                        if (!s) return null;
                        const a = s.type.kind;
                        if ("string" !== a && "value" !== a && "null" !== a && "resolvedImage" !== a) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new Oe(n);
            }
            evaluate(t1) {
                return new Be(this.sections.map((e1)=>{
                    const r = e1.content.evaluate(t1);
                    return De(r) === fe ? new ze("", r, null, null, null) : new ze(Ve(r), null, e1.scale ? e1.scale.evaluate(t1) : null, e1.font ? e1.font.evaluate(t1).join(",") : null, e1.textColor ? e1.textColor.evaluate(t1) : null);
                }));
            }
            eachChild(t1) {
                for (const e1 of this.sections)t1(e1.content), e1.scale && t1(e1.scale), e1.font && t1(e1.font), e1.textColor && t1(e1.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e1 of this.sections){
                    t1.push(e1.content.serialize());
                    const r = {};
                    e1.scale && (r["font-scale"] = e1.scale.serialize()), e1.font && (r["text-font"] = e1.font.serialize()), e1.textColor && (r["text-color"] = e1.textColor.serialize()), t1.push(r);
                }
                return t1;
            }
        }
        class qe {
            constructor(t1){
                this.type = fe, this.input = t1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error("Expected two arguments.");
                const r = e1.parse(t1[1], 1, ae);
                return r ? new qe(r) : e1.error("No image name provided.");
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1), r = Ee.fromString(e1);
                return r && t1.availableImages && (r.available = t1.availableImages.indexOf(e1) > -1), r;
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "image",
                    this.input.serialize()
                ];
            }
        }
        const Ne = {
            "to-boolean": oe,
            "to-color": le,
            "to-number": se,
            "to-string": ae
        };
        class Ge {
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                const r = t1[0];
                if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e1.error("Expected one argument.");
                const n = Ne[r], i = [];
                for(let r = 1; r < t1.length; r++){
                    const n = e1.parse(t1[r], r, ce);
                    if (!n) return null;
                    i.push(n);
                }
                return new Ge(n, i);
            }
            evaluate(t1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
                if ("color" === this.type.kind) {
                    let e1, r;
                    for (const n of this.args){
                        if (e1 = n.evaluate(t1), r = null, e1 instanceof Me) return e1;
                        if ("string" == typeof e1) {
                            const r = t1.parseColor(e1);
                            if (r) return r;
                        } else if (Array.isArray(e1) && (r = e1.length < 3 || e1.length > 4 ? `Invalid rbga value ${JSON.stringify(e1)}: expected an array containing either three or four numeric values.` : Ce(e1[0], e1[1], e1[2], e1[3]), !r)) return new Me(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                    }
                    throw new Re(r || `Could not parse color from value '${"string" == typeof e1 ? e1 : String(JSON.stringify(e1))}'`);
                }
                if ("number" === this.type.kind) {
                    let e1 = null;
                    for (const r of this.args){
                        if (e1 = r.evaluate(t1), null === e1) return 0;
                        const n = Number(e1);
                        if (!isNaN(n)) return n;
                    }
                    throw new Re(`Could not convert ${JSON.stringify(e1)} to number.`);
                }
                return "formatted" === this.type.kind ? Be.fromString(Ve(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? Ee.fromString(Ve(this.args[0].evaluate(t1))) : Ve(this.args[0].evaluate(t1));
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new Oe([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new qe(this.args[0]).serialize();
                const t1 = [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((e1)=>{
                    t1.push(e1.serialize());
                }), t1;
            }
        }
        var Xe = Ge;
        const Ze = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        var Ke = class {
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null;
            }
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? Ze[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const t1 = this.featureDistanceData.center, e1 = this.featureDistanceData.scale, { x: r, y: n } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (r * e1 - t1[0]) + this.featureDistanceData.bearing[1] * (n * e1 - t1[1]);
                }
                return 0;
            }
            parseColor(t1) {
                let e1 = this._parseColorCache[t1];
                return e1 || (e1 = this._parseColorCache[t1] = Me.parse(t1)), e1;
            }
        };
        class Ye {
            constructor(t1, e1, r, n){
                this.name = t1, this.type = e1, this._evaluate = r, this.args = n;
            }
            evaluate(t1) {
                return this._evaluate(t1, this.args);
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((t1)=>t1.serialize()));
            }
            static parse(t1, e1) {
                const r = t1[0], n = Ye.definitions[r];
                if (!n) return e1.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, s = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, a = s.filter(([e1])=>!Array.isArray(e1) || e1.length === t1.length - 1);
                let o = null;
                for (const [n, s] of a){
                    o = new _r(e1.registry, e1.path, null, e1.scope);
                    const a = [];
                    let l = !1;
                    for(let e1 = 1; e1 < t1.length; e1++){
                        const r = t1[e1], i = Array.isArray(n) ? n[e1 - 1] : n.type, s = o.parse(r, 1 + a.length, i);
                        if (!s) {
                            l = !0;
                            break;
                        }
                        a.push(s);
                    }
                    if (!l) {
                        if (Array.isArray(n) && n.length !== a.length) o.error(`Expected ${n.length} arguments, but found ${a.length} instead.`);
                        else {
                            for(let t1 = 0; t1 < a.length; t1++){
                                const e1 = Array.isArray(n) ? n[t1] : n.type, r = a[t1];
                                o.concat(t1 + 1).checkSubtype(e1, r.type);
                            }
                            if (0 === o.errors.length) return new Ye(r, i, s, a);
                        }
                    }
                }
                if (1 === a.length) e1.errors.push(...o.errors);
                else {
                    const r = (a.length ? a : s).map(([t1])=>{
                        var e1;
                        return e1 = t1, Array.isArray(e1) ? `(${e1.map(ye).join(", ")})` : `(${ye(e1.type)}...)`;
                    }).join(" | "), n = [];
                    for(let r = 1; r < t1.length; r++){
                        const i = e1.parse(t1[r], 1 + n.length);
                        if (!i) return null;
                        n.push(ye(i.type));
                    }
                    e1.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t1, e1) {
                Ye.definitions = e1;
                for(const r in e1)t1[r] = Ye;
            }
        }
        var He = Ye;
        class We {
            constructor(t1, e1, r){
                this.type = he, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error("Expected one argument.");
                const r = t1[1];
                if ("object" != typeof r || Array.isArray(r)) return e1.error("Collator options argument must be an object.");
                const n = e1.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, oe);
                if (!n) return null;
                const i = e1.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, oe);
                if (!i) return null;
                let s = null;
                return r.locale && (s = e1.parse(r.locale, 1, ae), !s) ? null : new We(n, i, s);
            }
            evaluate(t1) {
                return new Te(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
            }
            eachChild(t1) {
                t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return t1["case-sensitive"] = this.caseSensitive.serialize(), t1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t1.locale = this.locale.serialize()), [
                    "collator",
                    t1
                ];
            }
        }
        const Je = 8192;
        function Qe(t1, e1) {
            t1[0] = Math.min(t1[0], e1[0]), t1[1] = Math.min(t1[1], e1[1]), t1[2] = Math.max(t1[2], e1[0]), t1[3] = Math.max(t1[3], e1[1]);
        }
        function tr(t1, e1) {
            return !(t1[0] <= e1[0] || t1[2] >= e1[2] || t1[1] <= e1[1] || t1[3] >= e1[3]);
        }
        function er(t1, e1) {
            const r = (180 + t1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1[1] * Math.PI / 360))) / 360, i = Math.pow(2, e1.z);
            return [
                Math.round(r * i * Je),
                Math.round(n * i * Je)
            ];
        }
        function rr(t1, e1, r) {
            const n = t1[0] - e1[0], i = t1[1] - e1[1], s = t1[0] - r[0], a = t1[1] - r[1];
            return n * a - s * i == 0 && n * s <= 0 && i * a <= 0;
        }
        function nr(t1, e1) {
            let r = !1;
            for(let a = 0, o = e1.length; a < o; a++){
                const o = e1[a];
                for(let e1 = 0, a = o.length; e1 < a - 1; e1++){
                    if (rr(t1, o[e1], o[e1 + 1])) return !1;
                    (i = o[e1])[1] > (n = t1)[1] != (s = o[e1 + 1])[1] > n[1] && n[0] < (s[0] - i[0]) * (n[1] - i[1]) / (s[1] - i[1]) + i[0] && (r = !r);
                }
            }
            var n, i, s;
            return r;
        }
        function ir(t1, e1) {
            for(let r = 0; r < e1.length; r++)if (nr(t1, e1[r])) return !0;
            return !1;
        }
        function sr(t1, e1, r, n) {
            const i = n[0] - r[0], s = n[1] - r[1], a = (t1[0] - r[0]) * s - i * (t1[1] - r[1]), o = (e1[0] - r[0]) * s - i * (e1[1] - r[1]);
            return a > 0 && o < 0 || a < 0 && o > 0;
        }
        function ar(t1, e1, r) {
            for (const u of r)for(let r = 0; r < u.length - 1; ++r)if (0 != (o = [
                (a = u[r + 1])[0] - (s = u[r])[0],
                a[1] - s[1]
            ])[0] * (l = [
                (i = e1)[0] - (n = t1)[0],
                i[1] - n[1]
            ])[1] - o[1] * l[0] && sr(n, i, s, a) && sr(s, a, n, i)) return !0;
            var n, i, s, a, o, l;
            return !1;
        }
        function or(t1, e1) {
            for(let r = 0; r < t1.length; ++r)if (!nr(t1[r], e1)) return !1;
            for(let r = 0; r < t1.length - 1; ++r)if (ar(t1[r], t1[r + 1], e1)) return !1;
            return !0;
        }
        function lr(t1, e1) {
            for(let r = 0; r < e1.length; r++)if (or(t1, e1[r])) return !0;
            return !1;
        }
        function ur(t1, e1, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const s = [];
                for(let n = 0; n < t1[i].length; n++){
                    const a = er(t1[i][n], r);
                    Qe(e1, a), s.push(a);
                }
                n.push(s);
            }
            return n;
        }
        function cr(t1, e1, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const s = ur(t1[i], e1, r);
                n.push(s);
            }
            return n;
        }
        function hr(t1, e1, r, n) {
            if (t1[0] < r[0] || t1[0] > r[2]) {
                const e1 = .5 * n;
                let i = t1[0] - r[0] > e1 ? -n : r[0] - t1[0] > e1 ? n : 0;
                0 === i && (i = t1[0] - r[2] > e1 ? -n : r[2] - t1[0] > e1 ? n : 0), t1[0] += i;
            }
            Qe(e1, t1);
        }
        function pr(t1, e1, r, n) {
            const i = Math.pow(2, n.z) * Je, s = [
                n.x * Je,
                n.y * Je
            ], a = [];
            if (!t1) return a;
            for (const n of t1)for (const t1 of n){
                const n = [
                    t1.x + s[0],
                    t1.y + s[1]
                ];
                hr(n, e1, r, i), a.push(n);
            }
            return a;
        }
        function fr(t1, e1, r, n) {
            const i = Math.pow(2, n.z) * Je, s = [
                n.x * Je,
                n.y * Je
            ], a = [];
            if (!t1) return a;
            for (const r of t1){
                const t1 = [];
                for (const n of r){
                    const r = [
                        n.x + s[0],
                        n.y + s[1]
                    ];
                    Qe(e1, r), t1.push(r);
                }
                a.push(t1);
            }
            if (e1[2] - e1[0] <= i / 2) {
                (o = e1)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t1 of a)for (const n of t1)hr(n, e1, r, i);
            }
            var o;
            return a;
        }
        class dr {
            constructor(t1, e1){
                this.type = oe, this.geojson = t1, this.geometries = e1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`'within' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (Pe(t1[1])) {
                    const e1 = t1[1];
                    if ("FeatureCollection" === e1.type) for(let t1 = 0; t1 < e1.features.length; ++t1){
                        const r = e1.features[t1].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new dr(e1, e1.features[t1].geometry);
                    }
                    else if ("Feature" === e1.type) {
                        const t1 = e1.geometry.type;
                        if ("Polygon" === t1 || "MultiPolygon" === t1) return new dr(e1, e1.geometry);
                    } else if ("Polygon" === e1.type || "MultiPolygon" === e1.type) return new dr(e1, e1);
                }
                return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t1) {
                if (null != t1.geometry() && null != t1.canonicalID()) {
                    if ("Point" === t1.geometryType()) return function(t1, e1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e1.type) {
                            const s = ur(e1.coordinates, n, i), a = pr(t1.geometry(), r, n, i);
                            if (!tr(r, n)) return !1;
                            for (const t1 of a)if (!nr(t1, s)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const s = cr(e1.coordinates, n, i), a = pr(t1.geometry(), r, n, i);
                            if (!tr(r, n)) return !1;
                            for (const t1 of a)if (!ir(t1, s)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e1.type) {
                            const s = ur(e1.coordinates, n, i), a = fr(t1.geometry(), r, n, i);
                            if (!tr(r, n)) return !1;
                            for (const t1 of a)if (!or(t1, s)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const s = cr(e1.coordinates, n, i), a = fr(t1.geometry(), r, n, i);
                            if (!tr(r, n)) return !1;
                            for (const t1 of a)if (!lr(t1, s)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
        }
        var yr = dr;
        function mr(t1) {
            if (t1 instanceof He) {
                if ("get" === t1.name && 1 === t1.args.length) return !1;
                if ("feature-state" === t1.name) return !1;
                if ("has" === t1.name && 1 === t1.args.length) return !1;
                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                if (/^filter-/.test(t1.name)) return !1;
            }
            if (t1 instanceof yr) return !1;
            let e1 = !0;
            return t1.eachChild((t1)=>{
                e1 && !mr(t1) && (e1 = !1);
            }), e1;
        }
        function gr(t1) {
            if (t1 instanceof He && "feature-state" === t1.name) return !1;
            let e1 = !0;
            return t1.eachChild((t1)=>{
                e1 && !gr(t1) && (e1 = !1);
            }), e1;
        }
        function xr(t1, e1) {
            if (t1 instanceof He && e1.indexOf(t1.name) >= 0) return !1;
            let r = !0;
            return t1.eachChild((t1)=>{
                r && !xr(t1, e1) && (r = !1);
            }), r;
        }
        class vr {
            constructor(t1, e1){
                this.type = e1.type, this.name = t1, this.boundExpression = e1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length || "string" != typeof t1[1]) return e1.error("'var' expression requires exactly one string literal argument.");
                const r = t1[1];
                return e1.scope.has(r) ? new vr(r, e1.scope.get(r)) : e1.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t1) {
                return this.boundExpression.evaluate(t1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
        }
        var br = vr;
        class wr {
            constructor(t1, e1 = [], r, n = new ne, i = []){
                this.registry = t1, this.path = e1, this.key = e1.map((t1)=>`[${t1}]`).join(""), this.scope = n, this.errors = i, this.expectedType = r;
            }
            parse(t1, e1, r, n, i = {}) {
                return e1 ? this.concat(e1, r, n)._parse(t1, i) : this._parse(t1, i);
            }
            _parse(t1, e1) {
                function r(t1, e1, r) {
                    return "assert" === r ? new $e(e1, [
                        t1
                    ]) : "coerce" === r ? new Xe(e1, [
                        t1
                    ]) : t1;
                }
                if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                    "literal",
                    t1
                ]), Array.isArray(t1)) {
                    if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = t1[0];
                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[n];
                    if (i) {
                        let n = i.parse(t1, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const t1 = this.expectedType, i = n.type;
                            if ("string" !== t1.kind && "number" !== t1.kind && "boolean" !== t1.kind && "object" !== t1.kind && "array" !== t1.kind || "value" !== i.kind) {
                                if ("color" !== t1.kind && "formatted" !== t1.kind && "resolvedImage" !== t1.kind || "value" !== i.kind && "string" !== i.kind) {
                                    if (this.checkSubtype(t1, i)) return null;
                                } else n = r(n, t1, e1.typeAnnotation || "coerce");
                            } else n = r(n, t1, e1.typeAnnotation || "assert");
                        }
                        if (!(n instanceof Fe) && "resolvedImage" !== n.type.kind && Ar(n)) {
                            const t1 = new Ke;
                            try {
                                n = new Fe(n.type, n.evaluate(t1));
                            } catch (t1) {
                                return this.error(t1.message), null;
                            }
                        }
                        return n;
                    }
                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === t1 ? "'undefined' value invalid. Use null instead." : "object" == typeof t1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t1} instead.`);
            }
            concat(t1, e1, r) {
                const n = "number" == typeof t1 ? this.path.concat(t1) : this.path, i = r ? this.scope.concat(r) : this.scope;
                return new wr(this.registry, n, e1 || null, i, this.errors);
            }
            error(t1, ...e1) {
                const r = `${this.key}${e1.map((t1)=>`[${t1}]`).join("")}`;
                this.errors.push(new ee(r, t1));
            }
            checkSubtype(t1, e1) {
                const r = ge(t1, e1);
                return r && this.error(r), r;
            }
        }
        var _r = wr;
        function Ar(t1) {
            if (t1 instanceof br) return Ar(t1.boundExpression);
            if (t1 instanceof He && "error" === t1.name) return !1;
            if (t1 instanceof We) return !1;
            if (t1 instanceof yr) return !1;
            const e1 = t1 instanceof Xe || t1 instanceof $e;
            let r = !0;
            return t1.eachChild((t1)=>{
                r = e1 ? r && Ar(t1) : r && t1 instanceof Fe;
            }), !!r && mr(t1) && xr(t1, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "sky-radial-progress",
                "accumulated",
                "is-supported-script",
                "pitch",
                "distance-from-center"
            ]);
        }
        function Sr(t1, e1) {
            const r = t1.length - 1;
            let n, i, s = 0, a = r, o = 0;
            for(; s <= a;)if (o = Math.floor((s + a) / 2), n = t1[o], i = t1[o + 1], n <= e1) {
                if (o === r || e1 < i) return o;
                s = o + 1;
            } else {
                if (!(n > e1)) throw new Re("Input is not a number.");
                a = o - 1;
            }
            return 0;
        }
        class kr {
            constructor(t1, e1, r){
                this.type = t1, this.input = e1, this.labels = [], this.outputs = [];
                for (const [t1, e1] of r)this.labels.push(t1), this.outputs.push(e1);
            }
            static parse(t1, e1) {
                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                const r = e1.parse(t1[1], 1, se);
                if (!r) return null;
                const n = [];
                let i = null;
                e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
                for(let r = 1; r < t1.length; r += 2){
                    const s = 1 === r ? -1 / 0 : t1[r], a = t1[r + 1], o = r, l = r + 1;
                    if ("number" != typeof s) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= s) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e1.parse(a, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        s,
                        u
                    ]);
                }
                return new kr(i, r, n);
            }
            evaluate(t1) {
                const e1 = this.labels, r = this.outputs;
                if (1 === e1.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e1[0]) return r[0].evaluate(t1);
                const i = e1.length;
                return n >= e1[i - 1] ? r[i - 1].evaluate(t1) : r[Sr(e1, n)].evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input);
                for (const e1 of this.outputs)t1(e1);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let e1 = 0; e1 < this.labels.length; e1++)e1 > 0 && t1.push(this.labels[e1]), t1.push(this.outputs[e1].serialize());
                return t1;
            }
        }
        var Ir = kr;
        function Mr(t1, e1, r) {
            return t1 * (1 - r) + e1 * r;
        }
        var Tr = Object.freeze({
            __proto__: null,
            number: Mr,
            color: function(t1, e1, r) {
                return new Me(Mr(t1.r, e1.r, r), Mr(t1.g, e1.g, r), Mr(t1.b, e1.b, r), Mr(t1.a, e1.a, r));
            },
            array: function(t1, e1, r) {
                return t1.map((t1, n)=>Mr(t1, e1[n], r));
            }
        });
        const zr = .95047, Br = 1.08883, Er = 4 / 29, Cr = 6 / 29, Pr = 3 * Cr * Cr, Dr = Math.PI / 180, Vr = 180 / Math.PI;
        function Lr(t1) {
            return t1 > .008856451679035631 ? Math.pow(t1, 1 / 3) : t1 / Pr + Er;
        }
        function Fr(t1) {
            return t1 > Cr ? t1 * t1 * t1 : Pr * (t1 - Er);
        }
        function Rr(t1) {
            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
        }
        function jr(t1) {
            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
        }
        function Ur(t1) {
            const e1 = jr(t1.r), r = jr(t1.g), n = jr(t1.b), i = Lr((.4124564 * e1 + .3575761 * r + .1804375 * n) / zr), s = Lr((.2126729 * e1 + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * s - 16,
                a: 500 * (i - s),
                b: 200 * (s - Lr((.0193339 * e1 + .119192 * r + .9503041 * n) / Br)),
                alpha: t1.a
            };
        }
        function $r(t1) {
            let e1 = (t1.l + 16) / 116, r = isNaN(t1.a) ? e1 : e1 + t1.a / 500, n = isNaN(t1.b) ? e1 : e1 - t1.b / 200;
            return e1 = 1 * Fr(e1), r = zr * Fr(r), n = Br * Fr(n), new Me(Rr(3.2404542 * r - 1.5371385 * e1 - .4985314 * n), Rr(-0.969266 * r + 1.8760108 * e1 + .041556 * n), Rr(.0556434 * r - .2040259 * e1 + 1.0572252 * n), t1.alpha);
        }
        function Or(t1, e1, r) {
            const n = e1 - t1;
            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const qr = {
            forward: Ur,
            reverse: $r,
            interpolate: function(t1, e1, r) {
                return {
                    l: Mr(t1.l, e1.l, r),
                    a: Mr(t1.a, e1.a, r),
                    b: Mr(t1.b, e1.b, r),
                    alpha: Mr(t1.alpha, e1.alpha, r)
                };
            }
        }, Nr = {
            forward: function(t1) {
                const { l: e1, a: r, b: n } = Ur(t1), i = Math.atan2(n, r) * Vr;
                return {
                    h: i < 0 ? i + 360 : i,
                    c: Math.sqrt(r * r + n * n),
                    l: e1,
                    alpha: t1.a
                };
            },
            reverse: function(t1) {
                const e1 = t1.h * Dr, r = t1.c;
                return $r({
                    l: t1.l,
                    a: Math.cos(e1) * r,
                    b: Math.sin(e1) * r,
                    alpha: t1.alpha
                });
            },
            interpolate: function(t1, e1, r) {
                return {
                    h: Or(t1.h, e1.h, r),
                    c: Mr(t1.c, e1.c, r),
                    l: Mr(t1.l, e1.l, r),
                    alpha: Mr(t1.alpha, e1.alpha, r)
                };
            }
        };
        var Gr = Object.freeze({
            __proto__: null,
            lab: qr,
            hcl: Nr
        });
        class Xr {
            constructor(t1, e1, r, n, i){
                this.type = t1, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t1, e1] of i)this.labels.push(t1), this.outputs.push(e1);
            }
            static interpolationFactor(t1, e1, r, n) {
                let i = 0;
                if ("exponential" === t1.name) i = Zr(e1, t1.base, r, n);
                else if ("linear" === t1.name) i = Zr(e1, 1, r, n);
                else if ("cubic-bezier" === t1.name) {
                    const s = t1.controlPoints;
                    i = new p(s[0], s[1], s[2], s[3]).solve(Zr(e1, 1, r, n));
                }
                return i;
            }
            static parse(t1, e1) {
                let [r, n, i, ...s] = t1;
                if (!Array.isArray(n) || 0 === n.length) return e1.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t1 = n[1];
                    if ("number" != typeof t1) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e1.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t1 = n.slice(1);
                        if (4 !== t1.length || t1.some((t1)=>"number" != typeof t1 || t1 < 0 || t1 > 1)) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t1
                        };
                    }
                }
                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                if (i = e1.parse(i, 2, se), !i) return null;
                const a = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = le : e1.expectedType && "value" !== e1.expectedType.kind && (o = e1.expectedType);
                for(let t1 = 0; t1 < s.length; t1 += 2){
                    const r = s[t1], n = s[t1 + 1], i = t1 + 3, l = t1 + 4;
                    if ("number" != typeof r) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (a.length && a[a.length - 1][0] >= r) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e1.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, a.push([
                        r,
                        u
                    ]);
                }
                return "number" === o.kind || "color" === o.kind || "array" === o.kind && "number" === o.itemType.kind && "number" == typeof o.N ? new Xr(o, r, n, i, a) : e1.error(`Type ${ye(o)} is not interpolatable.`);
            }
            evaluate(t1) {
                const e1 = this.labels, r = this.outputs;
                if (1 === e1.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e1[0]) return r[0].evaluate(t1);
                const i = e1.length;
                if (n >= e1[i - 1]) return r[i - 1].evaluate(t1);
                const s = Sr(e1, n), a = Xr.interpolationFactor(this.interpolation, n, e1[s], e1[s + 1]), o = r[s].evaluate(t1), l = r[s + 1].evaluate(t1);
                return "interpolate" === this.operator ? Tr[this.type.kind.toLowerCase()](o, l, a) : "interpolate-hcl" === this.operator ? Nr.reverse(Nr.interpolate(Nr.forward(o), Nr.forward(l), a)) : qr.reverse(qr.interpolate(qr.forward(o), qr.forward(l), a));
            }
            eachChild(t1) {
                t1(this.input);
                for (const e1 of this.outputs)t1(e1);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                let t1;
                t1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier"
                ].concat(this.interpolation.controlPoints);
                const e1 = [
                    this.operator,
                    t1,
                    this.input.serialize()
                ];
                for(let t1 = 0; t1 < this.labels.length; t1++)e1.push(this.labels[t1], this.outputs[t1].serialize());
                return e1;
            }
        }
        function Zr(t1, e1, r, n) {
            const i = n - r, s = t1 - r;
            return 0 === i ? 0 : 1 === e1 ? s / i : (Math.pow(e1, s) - 1) / (Math.pow(e1, i) - 1);
        }
        var Kr = Xr;
        class Yr {
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expectected at least one argument.");
                let r = null;
                const n = e1.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t1.slice(1)){
                    const t1 = e1.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t1) return null;
                    r = r || t1.type, i.push(t1);
                }
                const s = n && i.some((t1)=>ge(n, t1.type));
                return new Yr(s ? ce : r, i);
            }
            evaluate(t1) {
                let e1, r = null, n = 0;
                for (const i of this.args){
                    if (n++, r = i.evaluate(t1), r && r instanceof Ee && !r.available && (e1 || (e1 = r), r = null, n === this.args.length)) return e1;
                    if (null !== r) break;
                }
                return r;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "coalesce"
                ];
                return this.eachChild((e1)=>{
                    t1.push(e1.serialize());
                }), t1;
            }
        }
        var Hr = Yr;
        class Wr {
            constructor(t1, e1){
                this.type = e1.type, this.bindings = [].concat(t1), this.result = e1;
            }
            evaluate(t1) {
                return this.result.evaluate(t1);
            }
            eachChild(t1) {
                for (const e1 of this.bindings)t1(e1[1]);
                t1(this.result);
            }
            static parse(t1, e1) {
                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found ${t1.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t1.length - 1; n += 2){
                    const i = t1[n];
                    if ("string" != typeof i) return e1.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const s = e1.parse(t1[n + 1], n + 1);
                    if (!s) return null;
                    r.push([
                        i,
                        s
                    ]);
                }
                const n = e1.parse(t1[t1.length - 1], t1.length - 1, e1.expectedType, r);
                return n ? new Wr(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const t1 = [
                    "let"
                ];
                for (const [e1, r] of this.bindings)t1.push(e1, r.serialize());
                return t1.push(this.result.serialize()), t1;
            }
        }
        var Jr = Wr;
        class Qr {
            constructor(t1, e1, r){
                this.type = t1, this.index = e1, this.input = r;
            }
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, se), n = e1.parse(t1[2], 2, de(e1.expectedType || ce));
                return r && n ? new Qr(n.type.itemType, r, n) : null;
            }
            evaluate(t1) {
                const e1 = this.index.evaluate(t1), r = this.input.evaluate(t1);
                if (e1 < 0) throw new Re(`Array index out of bounds: ${e1} < 0.`);
                if (e1 >= r.length) throw new Re(`Array index out of bounds: ${e1} > ${r.length - 1}.`);
                if (e1 !== Math.floor(e1)) throw new Re(`Array index must be an integer, but found ${e1} instead.`);
                return r[e1];
            }
            eachChild(t1) {
                t1(this.index), t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        var tn = Qr;
        class en {
            constructor(t1, e1){
                this.type = oe, this.needle = t1, this.haystack = e1;
            }
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, ce), n = e1.parse(t1[2], 2, ce);
                return r && n ? xe(r.type, [
                    oe,
                    ae,
                    se,
                    ie,
                    ce
                ]) ? new en(r, n) : e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${ye(r.type)} instead`) : null;
            }
            evaluate(t1) {
                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (null == r) return !1;
                if (!ve(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Re(`Expected first argument to be of type boolean, string, number or null, but found ${ye(De(e1))} instead.`);
                if (!ve(r, [
                    "string",
                    "array"
                ])) throw new Re(`Expected second argument to be of type array or string, but found ${ye(De(r))} instead.`);
                return r.indexOf(e1) >= 0;
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "in",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        var rn = en;
        class nn {
            constructor(t1, e1, r){
                this.type = se, this.needle = t1, this.haystack = e1, this.fromIndex = r;
            }
            static parse(t1, e1) {
                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, ce), n = e1.parse(t1[2], 2, ce);
                if (!r || !n) return null;
                if (!xe(r.type, [
                    oe,
                    ae,
                    se,
                    ie,
                    ce
                ])) return e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${ye(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e1.parse(t1[3], 3, se);
                    return i ? new nn(r, n, i) : null;
                }
                return new nn(r, n);
            }
            evaluate(t1) {
                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (!ve(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Re(`Expected first argument to be of type boolean, string, number or null, but found ${ye(De(e1))} instead.`);
                if (!ve(r, [
                    "string",
                    "array"
                ])) throw new Re(`Expected second argument to be of type array or string, but found ${ye(De(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(t1);
                    return r.indexOf(e1, n);
                }
                return r.indexOf(e1);
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.fromIndex && void 0 !== this.fromIndex) {
                    const t1 = this.fromIndex.serialize();
                    return [
                        "index-of",
                        this.needle.serialize(),
                        this.haystack.serialize(),
                        t1
                    ];
                }
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        var sn = nn;
        class an {
            constructor(t1, e1, r, n, i, s){
                this.inputType = t1, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
            static parse(t1, e1) {
                if (t1.length < 5) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 1) return e1.error("Expected an even number of arguments.");
                let r, n;
                e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
                const i = {}, s = [];
                for(let a = 2; a < t1.length - 1; a += 2){
                    let o = t1[a];
                    const l = t1[a + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e1.concat(a);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t1 of o){
                        if ("number" != typeof t1 && "string" != typeof t1) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t1 && Math.abs(t1) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t1 && Math.floor(t1) !== t1) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, De(t1))) return null;
                        } else r = De(t1);
                        if (void 0 !== i[String(t1)]) return u.error("Branch labels must be unique.");
                        i[String(t1)] = s.length;
                    }
                    const c = e1.parse(l, a, n);
                    if (!c) return null;
                    n = n || c.type, s.push(c);
                }
                const a = e1.parse(t1[1], 1, ce);
                if (!a) return null;
                const o = e1.parse(t1[t1.length - 1], t1.length - 1, n);
                return o ? "value" !== a.type.kind && e1.concat(1).checkSubtype(r, a.type) ? null : new an(r, n, a, i, s, o) : null;
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1);
                return (De(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "match",
                    this.input.serialize()
                ], e1 = Object.keys(this.cases).sort(), r = [], n = {};
                for (const t1 of e1){
                    const e1 = n[this.cases[t1]];
                    void 0 === e1 ? (n[this.cases[t1]] = r.length, r.push([
                        this.cases[t1],
                        [
                            t1
                        ]
                    ])) : r[e1][1].push(t1);
                }
                const i = (t1)=>"number" === this.inputType.kind ? Number(t1) : t1;
                for (const [e1, n] of r)t1.push(1 === n.length ? i(n[0]) : n.map(i)), t1.push(this.outputs[e1].serialize());
                return t1.push(this.otherwise.serialize()), t1;
            }
        }
        var on = an;
        class ln {
            constructor(t1, e1, r){
                this.type = t1, this.branches = e1, this.otherwise = r;
            }
            static parse(t1, e1) {
                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
                let r;
                e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
                const n = [];
                for(let i = 1; i < t1.length - 1; i += 2){
                    const s = e1.parse(t1[i], i, oe);
                    if (!s) return null;
                    const a = e1.parse(t1[i + 1], i + 1, r);
                    if (!a) return null;
                    n.push([
                        s,
                        a
                    ]), r = r || a.type;
                }
                const i = e1.parse(t1[t1.length - 1], t1.length - 1, r);
                return i ? new ln(r, n, i) : null;
            }
            evaluate(t1) {
                for (const [e1, r] of this.branches)if (e1.evaluate(t1)) return r.evaluate(t1);
                return this.otherwise.evaluate(t1);
            }
            eachChild(t1) {
                for (const [e1, r] of this.branches)t1(e1), t1(r);
                t1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t1, e1])=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "case"
                ];
                return this.eachChild((e1)=>{
                    t1.push(e1.serialize());
                }), t1;
            }
        }
        var un = ln;
        class cn {
            constructor(t1, e1, r, n){
                this.type = t1, this.input = e1, this.beginIndex = r, this.endIndex = n;
            }
            static parse(t1, e1) {
                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, ce), n = e1.parse(t1[2], 2, se);
                if (!r || !n) return null;
                if (!xe(r.type, [
                    de(ce),
                    ae,
                    ce
                ])) return e1.error(`Expected first argument to be of type array or string, but found ${ye(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e1.parse(t1[3], 3, se);
                    return i ? new cn(r.type, r, n, i) : null;
                }
                return new cn(r.type, r, n);
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                if (!ve(e1, [
                    "string",
                    "array"
                ])) throw new Re(`Expected first argument to be of type array or string, but found ${ye(De(e1))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(t1);
                    return e1.slice(r, n);
                }
                return e1.slice(r);
            }
            eachChild(t1) {
                t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const t1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        t1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
        }
        var hn = cn;
        function pn(t1, e1) {
            return "==" === t1 || "!=" === t1 ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
        }
        function fn(t1, e1, r, n) {
            return 0 === n.compare(e1, r);
        }
        function dn(t1, e1, r) {
            const n = "==" !== t1 && "!=" !== t1;
            return class i {
                constructor(t1, e1, r){
                    this.type = oe, this.lhs = t1, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e1.type.kind;
                }
                static parse(t1, e1) {
                    if (3 !== t1.length && 4 !== t1.length) return e1.error("Expected two or three arguments.");
                    const r = t1[0];
                    let s = e1.parse(t1[1], 1, ce);
                    if (!s) return null;
                    if (!pn(r, s.type)) return e1.concat(1).error(`"${r}" comparisons are not supported for type '${ye(s.type)}'.`);
                    let a = e1.parse(t1[2], 2, ce);
                    if (!a) return null;
                    if (!pn(r, a.type)) return e1.concat(2).error(`"${r}" comparisons are not supported for type '${ye(a.type)}'.`);
                    if (s.type.kind !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e1.error(`Cannot compare types '${ye(s.type)}' and '${ye(a.type)}'.`);
                    n && ("value" === s.type.kind && "value" !== a.type.kind ? s = new $e(a.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === a.type.kind && (a = new $e(s.type, [
                        a
                    ])));
                    let o = null;
                    if (4 === t1.length) {
                        if ("string" !== s.type.kind && "string" !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                        if (o = e1.parse(t1[3], 3, he), !o) return null;
                    }
                    return new i(s, a, o);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), a = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e1 = De(s), r = De(a);
                        if (e1.kind !== r.kind || "string" !== e1.kind && "number" !== e1.kind) throw new Re(`Expected arguments for "${t1}" to be (string, string) or (number, number), but found (${e1.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t1 = De(s), r = De(a);
                        if ("string" !== t1.kind || "string" !== r.kind) return e1(i, s, a);
                    }
                    return this.collator ? r(i, s, a, this.collator.evaluate(i)) : e1(i, s, a);
                }
                eachChild(t1) {
                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const e1 = [
                        t1
                    ];
                    return this.eachChild((t1)=>{
                        e1.push(t1.serialize());
                    }), e1;
                }
            };
        }
        const yn = dn("==", function(t1, e1, r) {
            return e1 === r;
        }, fn), mn = dn("!=", function(t1, e1, r) {
            return e1 !== r;
        }, function(t1, e1, r, n) {
            return !fn(0, e1, r, n);
        }), gn = dn("<", function(t1, e1, r) {
            return e1 < r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) < 0;
        }), xn = dn(">", function(t1, e1, r) {
            return e1 > r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) > 0;
        }), vn = dn("<=", function(t1, e1, r) {
            return e1 <= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) <= 0;
        }), bn = dn(">=", function(t1, e1, r) {
            return e1 >= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) >= 0;
        });
        class wn {
            constructor(t1, e1, r, n, i, s){
                this.type = ae, this.number = t1, this.locale = e1, this.currency = r, this.unit = n, this.minFractionDigits = i, this.maxFractionDigits = s;
            }
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error("Expected two arguments.");
                const r = e1.parse(t1[1], 1, se);
                if (!r) return null;
                const n = t1[2];
                if ("object" != typeof n || Array.isArray(n)) return e1.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e1.parse(n.locale, 1, ae), !i)) return null;
                let s = null;
                if (n.currency && (s = e1.parse(n.currency, 1, ae), !s)) return null;
                let a = null;
                if (n.unit && (a = e1.parse(n.unit, 1, ae), !a)) return null;
                let o = null;
                if (n["min-fraction-digits"] && (o = e1.parse(n["min-fraction-digits"], 1, se), !o)) return null;
                let l = null;
                return n["max-fraction-digits"] && (l = e1.parse(n["max-fraction-digits"], 1, se), !l) ? null : new wn(r, i, s, a, o, l);
            }
            evaluate(t1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(t1) : void 0,
                    unit: this.unit ? this.unit.evaluate(t1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                }).format(this.number.evaluate(t1));
            }
            eachChild(t1) {
                t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.unit && t1(this.unit), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return this.locale && (t1.locale = this.locale.serialize()), this.currency && (t1.currency = this.currency.serialize()), this.unit && (t1.unit = this.unit.serialize()), this.minFractionDigits && (t1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    t1
                ];
            }
        }
        class _n {
            constructor(t1){
                this.type = se, this.input = t1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`Expected 1 argument, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e1.error(`Expected argument of type string or array, but found ${ye(r.type)} instead.`) : new _n(r) : null;
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1);
                if ("string" == typeof e1) return e1.length;
                if (Array.isArray(e1)) return e1.length;
                throw new Re(`Expected value to be of type string or array, but found ${ye(De(e1))} instead.`);
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "length"
                ];
                return this.eachChild((e1)=>{
                    t1.push(e1.serialize());
                }), t1;
            }
        }
        const An = {
            "==": yn,
            "!=": mn,
            ">": xn,
            "<": gn,
            ">=": bn,
            "<=": vn,
            array: $e,
            at: tn,
            boolean: $e,
            case: un,
            coalesce: Hr,
            collator: We,
            format: Oe,
            image: qe,
            in: rn,
            "index-of": sn,
            interpolate: Kr,
            "interpolate-hcl": Kr,
            "interpolate-lab": Kr,
            length: _n,
            let: Jr,
            literal: Fe,
            match: on,
            number: $e,
            "number-format": wn,
            object: $e,
            slice: hn,
            step: Ir,
            string: $e,
            "to-boolean": Xe,
            "to-color": Xe,
            "to-number": Xe,
            "to-string": Xe,
            var: br,
            within: yr
        };
        function Sn(t1, [e1, r, n, i]) {
            e1 = e1.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const s = i ? i.evaluate(t1) : 1, a = Ce(e1, r, n, s);
            if (a) throw new Re(a);
            return new Me(e1 / 255 * s, r / 255 * s, n / 255 * s, s);
        }
        function kn(t1, e1) {
            return t1 in e1;
        }
        function In(t1, e1) {
            const r = e1[t1];
            return void 0 === r ? null : r;
        }
        function Mn(t1) {
            return {
                type: t1
            };
        }
        He.register(An, {
            error: [
                {
                    kind: "error"
                },
                [
                    ae
                ],
                (t1, [e1])=>{
                    throw new Re(e1.evaluate(t1));
                }
            ],
            typeof: [
                ae,
                [
                    ce
                ],
                (t1, [e1])=>ye(De(e1.evaluate(t1)))
            ],
            "to-rgba": [
                de(se, 4),
                [
                    le
                ],
                (t1, [e1])=>e1.evaluate(t1).toArray()
            ],
            rgb: [
                le,
                [
                    se,
                    se,
                    se
                ],
                Sn
            ],
            rgba: [
                le,
                [
                    se,
                    se,
                    se,
                    se
                ],
                Sn
            ],
            has: {
                type: oe,
                overloads: [
                    [
                        [
                            ae
                        ],
                        (t1, [e1])=>kn(e1.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            ae,
                            ue
                        ],
                        (t1, [e1, r])=>kn(e1.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            get: {
                type: ce,
                overloads: [
                    [
                        [
                            ae
                        ],
                        (t1, [e1])=>In(e1.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            ae,
                            ue
                        ],
                        (t1, [e1, r])=>In(e1.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            "feature-state": [
                ce,
                [
                    ae
                ],
                (t1, [e1])=>In(e1.evaluate(t1), t1.featureState || {})
            ],
            properties: [
                ue,
                [],
                (t1)=>t1.properties()
            ],
            "geometry-type": [
                ae,
                [],
                (t1)=>t1.geometryType()
            ],
            id: [
                ce,
                [],
                (t1)=>t1.id()
            ],
            zoom: [
                se,
                [],
                (t1)=>t1.globals.zoom
            ],
            pitch: [
                se,
                [],
                (t1)=>t1.globals.pitch || 0
            ],
            "distance-from-center": [
                se,
                [],
                (t1)=>t1.distanceFromCenter()
            ],
            "heatmap-density": [
                se,
                [],
                (t1)=>t1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                se,
                [],
                (t1)=>t1.globals.lineProgress || 0
            ],
            "sky-radial-progress": [
                se,
                [],
                (t1)=>t1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                ce,
                [],
                (t1)=>void 0 === t1.globals.accumulated ? null : t1.globals.accumulated
            ],
            "+": [
                se,
                Mn(se),
                (t1, e1)=>{
                    let r = 0;
                    for (const n of e1)r += n.evaluate(t1);
                    return r;
                }
            ],
            "*": [
                se,
                Mn(se),
                (t1, e1)=>{
                    let r = 1;
                    for (const n of e1)r *= n.evaluate(t1);
                    return r;
                }
            ],
            "-": {
                type: se,
                overloads: [
                    [
                        [
                            se,
                            se
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) - r.evaluate(t1)
                    ],
                    [
                        [
                            se
                        ],
                        (t1, [e1])=>-e1.evaluate(t1)
                    ]
                ]
            },
            "/": [
                se,
                [
                    se,
                    se
                ],
                (t1, [e1, r])=>e1.evaluate(t1) / r.evaluate(t1)
            ],
            "%": [
                se,
                [
                    se,
                    se
                ],
                (t1, [e1, r])=>e1.evaluate(t1) % r.evaluate(t1)
            ],
            ln2: [
                se,
                [],
                ()=>Math.LN2
            ],
            pi: [
                se,
                [],
                ()=>Math.PI
            ],
            e: [
                se,
                [],
                ()=>Math.E
            ],
            "^": [
                se,
                [
                    se,
                    se
                ],
                (t1, [e1, r])=>Math.pow(e1.evaluate(t1), r.evaluate(t1))
            ],
            sqrt: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.sqrt(e1.evaluate(t1))
            ],
            log10: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN10
            ],
            ln: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1))
            ],
            log2: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN2
            ],
            sin: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.sin(e1.evaluate(t1))
            ],
            cos: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.cos(e1.evaluate(t1))
            ],
            tan: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.tan(e1.evaluate(t1))
            ],
            asin: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.asin(e1.evaluate(t1))
            ],
            acos: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.acos(e1.evaluate(t1))
            ],
            atan: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.atan(e1.evaluate(t1))
            ],
            min: [
                se,
                Mn(se),
                (t1, e1)=>Math.min(...e1.map((e1)=>e1.evaluate(t1)))
            ],
            max: [
                se,
                Mn(se),
                (t1, e1)=>Math.max(...e1.map((e1)=>e1.evaluate(t1)))
            ],
            abs: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.abs(e1.evaluate(t1))
            ],
            round: [
                se,
                [
                    se
                ],
                (t1, [e1])=>{
                    const r = e1.evaluate(t1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.floor(e1.evaluate(t1))
            ],
            ceil: [
                se,
                [
                    se
                ],
                (t1, [e1])=>Math.ceil(e1.evaluate(t1))
            ],
            "filter-==": [
                oe,
                [
                    ae,
                    ce
                ],
                (t1, [e1, r])=>t1.properties()[e1.value] === r.value
            ],
            "filter-id-==": [
                oe,
                [
                    ce
                ],
                (t1, [e1])=>t1.id() === e1.value
            ],
            "filter-type-==": [
                oe,
                [
                    ae
                ],
                (t1, [e1])=>t1.geometryType() === e1.value
            ],
            "filter-<": [
                oe,
                [
                    ae,
                    ce
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                oe,
                [
                    ce
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                oe,
                [
                    ae,
                    ce
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                oe,
                [
                    ce
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                oe,
                [
                    ae,
                    ce
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                oe,
                [
                    ce
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                oe,
                [
                    ae,
                    ce
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                oe,
                [
                    ce
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                oe,
                [
                    ce
                ],
                (t1, [e1])=>e1.value in t1.properties()
            ],
            "filter-has-id": [
                oe,
                [],
                (t1)=>null !== t1.id() && void 0 !== t1.id()
            ],
            "filter-type-in": [
                oe,
                [
                    de(ae)
                ],
                (t1, [e1])=>e1.value.indexOf(t1.geometryType()) >= 0
            ],
            "filter-id-in": [
                oe,
                [
                    de(ce)
                ],
                (t1, [e1])=>e1.value.indexOf(t1.id()) >= 0
            ],
            "filter-in-small": [
                oe,
                [
                    ae,
                    de(ce)
                ],
                (t1, [e1, r])=>r.value.indexOf(t1.properties()[e1.value]) >= 0
            ],
            "filter-in-large": [
                oe,
                [
                    ae,
                    de(ce)
                ],
                (t1, [e1, r])=>(function(t1, e1, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e1[i] === t1) return !0;
                            e1[i] > t1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t1.properties()[e1.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: oe,
                overloads: [
                    [
                        [
                            oe,
                            oe
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) && r.evaluate(t1)
                    ],
                    [
                        Mn(oe),
                        (t1, e1)=>{
                            for (const r of e1)if (!r.evaluate(t1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: oe,
                overloads: [
                    [
                        [
                            oe,
                            oe
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) || r.evaluate(t1)
                    ],
                    [
                        Mn(oe),
                        (t1, e1)=>{
                            for (const r of e1)if (r.evaluate(t1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                oe,
                [
                    oe
                ],
                (t1, [e1])=>!e1.evaluate(t1)
            ],
            "is-supported-script": [
                oe,
                [
                    ae
                ],
                (t1, [e1])=>{
                    const r = t1.globals && t1.globals.isSupportedScript;
                    return !r || r(e1.evaluate(t1));
                }
            ],
            upcase: [
                ae,
                [
                    ae
                ],
                (t1, [e1])=>e1.evaluate(t1).toUpperCase()
            ],
            downcase: [
                ae,
                [
                    ae
                ],
                (t1, [e1])=>e1.evaluate(t1).toLowerCase()
            ],
            concat: [
                ae,
                Mn(ce),
                (t1, e1)=>e1.map((e1)=>Ve(e1.evaluate(t1))).join("")
            ],
            "resolved-locale": [
                ae,
                [
                    he
                ],
                (t1, [e1])=>e1.evaluate(t1).resolvedLocale()
            ]
        });
        var Tn = An;
        function zn(t1) {
            return {
                result: "success",
                value: t1
            };
        }
        function Bn(t1) {
            return {
                result: "error",
                value: t1
            };
        }
        function En(t1) {
            return "data-driven" === t1["property-type"];
        }
        function Cn(t1) {
            return !!t1.expression && t1.expression.parameters.indexOf("zoom") > -1;
        }
        function Pn(t1) {
            return !!t1.expression && t1.expression.interpolated;
        }
        function Dn(t1) {
            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
        }
        function Vn(t1) {
            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
        }
        function Ln(t1) {
            return t1;
        }
        function Fn(t1, e1) {
            const r = "color" === e1.type, n = t1.stops && "object" == typeof t1.stops[0][0], i = n || !(n || void 0 !== t1.property), s = t1.type || (Pn(e1) ? "exponential" : "interval");
            if (r && ((t1 = Wt({}, t1)).stops && (t1.stops = t1.stops.map((t1)=>[
                    t1[0],
                    Me.parse(t1[1])
                ])), t1.default = Me.parse(t1.default ? t1.default : e1.default)), t1.colorSpace && "rgb" !== t1.colorSpace && !Gr[t1.colorSpace]) throw new Error(`Unknown color space: ${t1.colorSpace}`);
            let a, o, l;
            if ("exponential" === s) a = $n;
            else if ("interval" === s) a = Un;
            else if ("categorical" === s) {
                a = jn, o = Object.create(null);
                for (const e1 of t1.stops)o[e1[0]] = e1[1];
                l = typeof t1.stops[0][0];
            } else {
                if ("identity" !== s) throw new Error(`Unknown function type "${s}"`);
                a = On;
            }
            if (n) {
                const r = {}, n = [];
                for(let e1 = 0; e1 < t1.stops.length; e1++){
                    const i = t1.stops[e1], s = i[0].zoom;
                    void 0 === r[s] && (r[s] = {
                        zoom: s,
                        type: t1.type,
                        property: t1.property,
                        default: t1.default,
                        stops: []
                    }, n.push(s)), r[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t1 of n)i.push([
                    r[t1].zoom,
                    Fn(r[t1], e1)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: Kr.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r }, n)=>$n({
                            stops: i,
                            base: t1.base
                        }, e1, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === s ? {
                    name: "exponential",
                    base: void 0 !== t1.base ? t1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: Kr.interpolationFactor.bind(void 0, r),
                    zoomStops: t1.stops.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r })=>a(t1, e1, r, o, l)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t1.property] : void 0;
                    return void 0 === i ? Rn(t1.default, e1.default) : a(t1, e1, i, o, l);
                }
            };
        }
        function Rn(t1, e1, r) {
            return void 0 !== t1 ? t1 : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
        }
        function jn(t1, e1, r, n, i) {
            return Rn(typeof r === i ? n[r] : void 0, t1.default, e1.default);
        }
        function Un(t1, e1, r) {
            if ("number" !== Dn(r)) return Rn(t1.default, e1.default);
            const n = t1.stops.length;
            if (1 === n) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
            const i = Sr(t1.stops.map((t1)=>t1[0]), r);
            return t1.stops[i][1];
        }
        function $n(t1, e1, r) {
            const n = void 0 !== t1.base ? t1.base : 1;
            if ("number" !== Dn(r)) return Rn(t1.default, e1.default);
            const i = t1.stops.length;
            if (1 === i) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
            const s = Sr(t1.stops.map((t1)=>t1[0]), r), a = function(t1, e1, r, n) {
                const i = n - r, s = t1 - r;
                return 0 === i ? 0 : 1 === e1 ? s / i : (Math.pow(e1, s) - 1) / (Math.pow(e1, i) - 1);
            }(r, n, t1.stops[s][0], t1.stops[s + 1][0]), o = t1.stops[s][1], l = t1.stops[s + 1][1];
            let u = Tr[e1.type] || Ln;
            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                const e1 = Gr[t1.colorSpace];
                u = (t1, r)=>e1.reverse(e1.interpolate(e1.forward(t1), e1.forward(r), a));
            }
            return "function" == typeof o.evaluate ? {
                evaluate (...t1) {
                    const e1 = o.evaluate.apply(void 0, t1), r = l.evaluate.apply(void 0, t1);
                    if (void 0 !== e1 && void 0 !== r) return u(e1, r, a);
                }
            } : u(o, l, a);
        }
        function On(t1, e1, r) {
            return "color" === e1.type ? r = Me.parse(r) : "formatted" === e1.type ? r = Be.fromString(r.toString()) : "resolvedImage" === e1.type ? r = Ee.fromString(r.toString()) : Dn(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0), Rn(r, t1.default, e1.default);
        }
        class qn {
            constructor(t1, e1){
                this.expression = t1, this._warningHistory = {}, this._evaluator = new Ke, this._defaultValue = e1 ? function(t1) {
                    return "color" === t1.type && (Vn(t1.default) || Array.isArray(t1.default)) ? new Me(0, 0, 0, 0) : "color" === t1.type ? Me.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
                }(e1) : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null;
            }
            evaluateWithoutErrorHandling(t1, e1, r, n, i, s, a, o) {
                return this._evaluator.globals = t1, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(t1, e1, r, n, i, s, a, o) {
                this._evaluator.globals = t1, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null;
                try {
                    const t1 = this.expression.evaluate(this._evaluator);
                    if (null == t1 || "number" == typeof t1 && t1 != t1) return this._defaultValue;
                    if (this._enumValues && !(t1 in this._enumValues)) throw new Re(`Expected value to be one of ${Object.keys(this._enumValues).map((t1)=>JSON.stringify(t1)).join(", ")}, but found ${JSON.stringify(t1)} instead.`);
                    return t1;
                } catch (t1) {
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(t1.message)), this._defaultValue;
                }
            }
        }
        function Nn(t1) {
            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in Tn;
        }
        function Gn(t1, e1) {
            const r = new _r(Tn, [], e1 ? function(t1) {
                const e1 = {
                    color: le,
                    string: ae,
                    number: se,
                    enum: ae,
                    boolean: oe,
                    formatted: pe,
                    resolvedImage: fe
                };
                return "array" === t1.type ? de(e1[t1.value] || ce, t1.length) : e1[t1.type];
            }(e1) : void 0), n = r.parse(t1, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? zn(new qn(n, e1)) : Bn(r.errors);
        }
        class Xn {
            constructor(t1, e1){
                this.kind = t1, this._styleExpression = e1, this.isStateDependent = "constant" !== t1 && !gr(e1.expression);
            }
            evaluateWithoutErrorHandling(t1, e1, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, s);
            }
            evaluate(t1, e1, r, n, i, s) {
                return this._styleExpression.evaluate(t1, e1, r, n, i, s);
            }
        }
        class Zn {
            constructor(t1, e1, r, n){
                this.kind = t1, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t1 && !gr(e1.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(t1, e1, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, s);
            }
            evaluate(t1, e1, r, n, i, s) {
                return this._styleExpression.evaluate(t1, e1, r, n, i, s);
            }
            interpolationFactor(t1, e1, r) {
                return this.interpolationType ? Kr.interpolationFactor(this.interpolationType, t1, e1, r) : 0;
            }
        }
        function Kn(t1, e1) {
            if ("error" === (t1 = Gn(t1, e1)).result) return t1;
            const r = t1.value.expression, n = mr(r);
            if (!n && !En(e1)) return Bn([
                new ee("", "data expressions not supported")
            ]);
            const i = xr(r, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!i && !Cn(e1)) return Bn([
                new ee("", "zoom expressions not supported")
            ]);
            const s = Hn(r);
            return s || i ? s instanceof ee ? Bn([
                s
            ]) : s instanceof Kr && !Pn(e1) ? Bn([
                new ee("", '"interpolate" expressions cannot be used with this property')
            ]) : zn(s ? new Zn(n ? "camera" : "composite", t1.value, s.labels, s instanceof Kr ? s.interpolation : void 0) : new Xn(n ? "constant" : "source", t1.value)) : Bn([
                new ee("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class Yn {
            constructor(t1, e1){
                this._parameters = t1, this._specification = e1, Wt(this, Fn(this._parameters, this._specification));
            }
            static deserialize(t1) {
                return new Yn(t1._parameters, t1._specification);
            }
            static serialize(t1) {
                return {
                    _parameters: t1._parameters,
                    _specification: t1._specification
                };
            }
        }
        function Hn(t1) {
            let e1 = null;
            if (t1 instanceof Jr) e1 = Hn(t1.result);
            else if (t1 instanceof Hr) {
                for (const r of t1.args)if (e1 = Hn(r), e1) break;
            } else (t1 instanceof Ir || t1 instanceof Kr) && t1.input instanceof He && "zoom" === t1.input.name && (e1 = t1);
            return e1 instanceof ee || t1.eachChild((t1)=>{
                const r = Hn(t1);
                r instanceof ee ? e1 = r : !e1 && r ? e1 = new ee("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e1 && r && e1 !== r && (e1 = new ee("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e1;
        }
        class Wn {
            constructor(t1, e1, r, n){
                this.message = (t1 ? `${t1}: ` : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
            }
        }
        function Jn(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec || {}, i = t1.objectElementValidators || {}, s = t1.style, a = t1.styleSpec;
            let o = [];
            const l = Dn(r);
            if ("object" !== l) return [
                new Wn(e1, r, `object expected, ${l} found`)
            ];
            for(const t1 in r){
                const l = t1.split(".")[0], u = n[l] || n["*"];
                let c;
                i[l] ? c = i[l] : n[l] ? c = Ci : i["*"] ? c = i["*"] : n["*"] && (c = Ci), c ? o = o.concat(c({
                    key: (e1 ? `${e1}.` : e1) + t1,
                    value: r[t1],
                    valueSpec: u,
                    style: s,
                    styleSpec: a,
                    object: r,
                    objectKey: t1
                }, r)) : o.push(new Wn(e1, r[t1], `unknown property "${t1}"`));
            }
            for(const t1 in n)i[t1] || n[t1].required && void 0 === n[t1].default && void 0 === r[t1] && o.push(new Wn(e1, r, `missing required property "${t1}"`));
            return o;
        }
        function Qn(t1) {
            const e1 = t1.value, r = t1.valueSpec, n = t1.style, i = t1.styleSpec, s = t1.key, a = t1.arrayElementValidator || Ci;
            if ("array" !== Dn(e1)) return [
                new Wn(s, e1, `array expected, ${Dn(e1)} found`)
            ];
            if (r.length && e1.length !== r.length) return [
                new Wn(s, e1, `array length ${r.length} expected, length ${e1.length} found`)
            ];
            if (r["min-length"] && e1.length < r["min-length"]) return [
                new Wn(s, e1, `array length at least ${r["min-length"]} expected, length ${e1.length} found`)
            ];
            let o = {
                type: r.value,
                values: r.values,
                minimum: r.minimum,
                maximum: r.maximum,
                function: void 0
            };
            i.$version < 7 && (o.function = r.function), "object" === Dn(r.value) && (o = r.value);
            let l = [];
            for(let t1 = 0; t1 < e1.length; t1++)l = l.concat(a({
                array: e1,
                arrayIndex: t1,
                value: e1[t1],
                valueSpec: o,
                style: n,
                styleSpec: i,
                key: `${s}[${t1}]`
            }));
            return l;
        }
        function ti(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec;
            let i = Dn(r);
            if ("number" === i && r != r && (i = "NaN"), "number" !== i) return [
                new Wn(e1, r, `number expected, ${i} found`)
            ];
            if ("minimum" in n) {
                let i = n.minimum;
                if ("array" === Dn(n.minimum) && (i = n.minimum[t1.arrayIndex]), r < i) return [
                    new Wn(e1, r, `${r} is less than the minimum value ${i}`)
                ];
            }
            if ("maximum" in n) {
                let i = n.maximum;
                if ("array" === Dn(n.maximum) && (i = n.maximum[t1.arrayIndex]), r > i) return [
                    new Wn(e1, r, `${r} is greater than the maximum value ${i}`)
                ];
            }
            return [];
        }
        function ei(t1) {
            const e1 = t1.valueSpec, r = Jt(t1.value.type);
            let n, i, s, a = {};
            const o = "categorical" !== r && void 0 === t1.value.property, l = !o, u = "array" === Dn(t1.value.stops) && "array" === Dn(t1.value.stops[0]) && "object" === Dn(t1.value.stops[0][0]), c = Jn({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === r) return [
                            new Wn(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        let e1 = [];
                        const n = t1.value;
                        return e1 = e1.concat(Qn({
                            key: t1.key,
                            value: n,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: h
                        })), "array" === Dn(n) && 0 === n.length && e1.push(new Wn(t1.key, n, "array must have at least one stop")), e1;
                    },
                    default: function(t1) {
                        return Ci({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: e1,
                            style: t1.style,
                            styleSpec: t1.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && o && c.push(new Wn(t1.key, t1.value, 'missing required property "property"')), "identity" === r || t1.value.stops || c.push(new Wn(t1.key, t1.value, 'missing required property "stops"')), "exponential" === r && t1.valueSpec.expression && !Pn(t1.valueSpec) && c.push(new Wn(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (l && !En(t1.valueSpec) ? c.push(new Wn(t1.key, t1.value, "property functions not supported")) : o && !Cn(t1.valueSpec) && c.push(new Wn(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== t1.value.property || c.push(new Wn(t1.key, t1.value, '"property" property is required')), c;
            function h(t1) {
                let r = [];
                const n = t1.value, o = t1.key;
                if ("array" !== Dn(n)) return [
                    new Wn(o, n, `array expected, ${Dn(n)} found`)
                ];
                if (2 !== n.length) return [
                    new Wn(o, n, `array length 2 expected, length ${n.length} found`)
                ];
                if (u) {
                    if ("object" !== Dn(n[0])) return [
                        new Wn(o, n, `object expected, ${Dn(n[0])} found`)
                    ];
                    if (void 0 === n[0].zoom) return [
                        new Wn(o, n, "object stop key must have zoom")
                    ];
                    if (void 0 === n[0].value) return [
                        new Wn(o, n, "object stop key must have value")
                    ];
                    const e1 = Jt(n[0].zoom);
                    if ("number" != typeof e1) return [
                        new Wn(o, n[0].zoom, "stop zoom values must be numbers")
                    ];
                    if (s && s > e1) return [
                        new Wn(o, n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    e1 !== s && (s = e1, i = void 0, a = {}), r = r.concat(Jn({
                        key: `${o}[0]`,
                        value: n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: ti,
                            value: p
                        }
                    }));
                } else r = r.concat(p({
                    key: `${o}[0]`,
                    value: n[0],
                    valueSpec: {},
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, n));
                return Nn(Qt(n[1])) ? r.concat([
                    new Wn(`${o}[1]`, n[1], "expressions are not allowed in function stops.")
                ]) : r.concat(Ci({
                    key: `${o}[1]`,
                    value: n[1],
                    valueSpec: e1,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function p(t1, s) {
                const o = Dn(t1.value), l = Jt(t1.value), u = null !== t1.value ? t1.value : s;
                if (n) {
                    if (o !== n) return [
                        new Wn(t1.key, u, `${o} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o && "number" != typeof l && "string" != typeof l && "boolean" != typeof l) return [
                    new Wn(t1.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== r) {
                    let n = `number expected, ${o} found`;
                    return En(e1) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new Wn(t1.key, u, n)
                    ];
                }
                return "categorical" !== r || "number" !== o || "number" == typeof l && isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && "number" == typeof l && "number" == typeof i && void 0 !== i && l < i ? [
                    new Wn(t1.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === r && l in a ? [
                    new Wn(t1.key, u, "stop domain values must be unique")
                ] : (a[l] = !0, [])) : [
                    new Wn(t1.key, u, `integer expected, found ${String(l)}`)
                ];
            }
        }
        function ri(t1) {
            const e1 = ("property" === t1.expressionContext ? Kn : Gn)(Qt(t1.value), t1.valueSpec);
            if ("error" === e1.result) return e1.value.map((e1)=>new Wn(`${t1.key}${e1.key}`, t1.value, e1.message));
            const r = e1.value.expression || e1.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !r.outputDefined()) return [
                new Wn(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !gr(r)) return [
                new Wn(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext) return ni(r, t1);
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!xr(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new Wn(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !mr(r)) return [
                    new Wn(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function ni(t1, e1) {
            const r = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (e1.valueSpec && e1.valueSpec.expression) for (const t1 of e1.valueSpec.expression.parameters)r.delete(t1);
            if (0 === r.size) return [];
            const n = [];
            return t1 instanceof He && r.has(t1.name) ? [
                new Wn(e1.key, e1.value, `["${t1.name}"] expression is not supported in a filter for a ${e1.object.type} layer with id: ${e1.object.id}`)
            ] : (t1.eachChild((t1)=>{
                n.push(...ni(t1, e1));
            }), n);
        }
        function ii(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(Jt(r)) && i.push(new Wn(e1, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(Jt(r)) && i.push(new Wn(e1, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
        }
        function si(t1) {
            if (!0 === t1 || !1 === t1) return !0;
            if (!Array.isArray(t1) || 0 === t1.length) return !1;
            switch(t1[0]){
                case "has":
                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                case "in":
                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                case "any":
                case "all":
                    for (const e1 of t1.slice(1))if (!si(e1) && "boolean" != typeof e1) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function ai(t1, e1 = "fill") {
            if (null == t1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            si(t1) || (t1 = fi(t1));
            const r = t1;
            let n = !0;
            try {
                n = function(t1) {
                    if (!ui(t1)) return t1;
                    let e1 = Qt(t1);
                    return li(e1), e1 = oi(e1), e1;
                }(r);
            } catch (t1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(r, null, 2)}\n        `);
            }
            const i = Ht[`filter_${e1}`], s = Gn(n, i);
            let a = null;
            if ("error" === s.result) throw new Error(s.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
            a = (t1, e1, r)=>s.value.evaluate(t1, e1, {}, r);
            let o = null, l = null;
            if (n !== r) {
                const t1 = Gn(r, i);
                if ("error" === t1.result) throw new Error(t1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                o = (e1, r, n, i, s)=>t1.value.evaluate(e1, r, {}, n, void 0, void 0, i, s), l = !mr(t1.value.expression);
            }
            return {
                filter: a,
                dynamicFilter: o || void 0,
                needGeometry: pi(n),
                needFeature: !!l
            };
        }
        function oi(t1) {
            if (!Array.isArray(t1)) return t1;
            const e1 = function(t1) {
                if (ci.has(t1[0])) {
                    for(let e1 = 1; e1 < t1.length; e1++)if (ui(t1[e1])) return !0;
                }
                return t1;
            }(t1);
            return !0 === e1 ? e1 : e1.map((t1)=>oi(t1));
        }
        function li(t1) {
            let e1 = !1;
            const r = [];
            if ("case" === t1[0]) {
                for(let n = 1; n < t1.length - 1; n += 2)e1 = e1 || ui(t1[n]), r.push(t1[n + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("match" === t1[0]) {
                e1 = e1 || ui(t1[1]);
                for(let e1 = 2; e1 < t1.length - 1; e1 += 2)r.push(t1[e1 + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("step" === t1[0]) {
                e1 = e1 || ui(t1[1]);
                for(let e1 = 1; e1 < t1.length - 1; e1 += 2)r.push(t1[e1 + 1]);
            }
            e1 && (t1.length = 0, t1.push("any", ...r));
            for(let e1 = 1; e1 < t1.length; e1++)li(t1[e1]);
        }
        function ui(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("pitch" === (e1 = t1[0]) || "distance-from-center" === e1) return !0;
            var e1;
            for(let e1 = 1; e1 < t1.length; e1++)if (ui(t1[e1])) return !0;
            return !1;
        }
        const ci = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function hi(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function pi(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("within" === t1[0]) return !0;
            for(let e1 = 1; e1 < t1.length; e1++)if (pi(t1[e1])) return !0;
            return !1;
        }
        function fi(t1) {
            if (!t1) return !0;
            const e1 = t1[0];
            var r;
            return t1.length <= 1 ? "any" !== e1 : "==" === e1 ? di(t1[1], t1[2], "==") : "!=" === e1 ? gi(di(t1[1], t1[2], "==")) : "<" === e1 || ">" === e1 || "<=" === e1 || ">=" === e1 ? di(t1[1], t1[2], e1) : "any" === e1 ? (r = t1.slice(1), [
                "any"
            ].concat(r.map(fi))) : "all" === e1 ? [
                "all"
            ].concat(t1.slice(1).map(fi)) : "none" === e1 ? [
                "all"
            ].concat(t1.slice(1).map(fi).map(gi)) : "in" === e1 ? yi(t1[1], t1.slice(2)) : "!in" === e1 ? gi(yi(t1[1], t1.slice(2))) : "has" === e1 ? mi(t1[1]) : "!has" === e1 ? gi(mi(t1[1])) : "within" !== e1 || t1;
        }
        function di(t1, e1, r) {
            switch(t1){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e1
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e1
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t1,
                        e1
                    ];
            }
        }
        function yi(t1, e1) {
            if (0 === e1.length) return !1;
            switch(t1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                default:
                    return e1.length > 200 && !e1.some((t1)=>typeof t1 != typeof e1[0]) ? [
                        "filter-in-large",
                        t1,
                        [
                            "literal",
                            e1.sort(hi)
                        ]
                    ] : [
                        "filter-in-small",
                        t1,
                        [
                            "literal",
                            e1
                        ]
                    ];
            }
        }
        function mi(t1) {
            switch(t1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t1
                    ];
            }
        }
        function gi(t1) {
            return [
                "!",
                t1
            ];
        }
        function xi(t1) {
            return si(Qt(t1.value)) ? ri(Wt({}, t1, {
                expressionContext: "filter",
                valueSpec: t1.styleSpec[`filter_${t1.layerType || "fill"}`]
            })) : vi(t1);
        }
        function vi(t1) {
            const e1 = t1.value, r = t1.key;
            if ("array" !== Dn(e1)) return [
                new Wn(r, e1, `array expected, ${Dn(e1)} found`)
            ];
            const n = t1.styleSpec;
            let i, s = [];
            if (e1.length < 1) return [
                new Wn(r, e1, "filter array must have at least 1 element")
            ];
            switch(s = s.concat(ii({
                key: `${r}[0]`,
                value: e1[0],
                valueSpec: n.filter_operator,
                style: t1.style,
                styleSpec: t1.styleSpec
            })), Jt(e1[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    e1.length >= 2 && "$type" === Jt(e1[1]) && s.push(new Wn(r, e1, `"$type" cannot be use with operator "${e1[0]}"`));
                case "==":
                case "!=":
                    3 !== e1.length && s.push(new Wn(r, e1, `filter array for operator "${e1[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    e1.length >= 2 && (i = Dn(e1[1]), "string" !== i && s.push(new Wn(`${r}[1]`, e1[1], `string expected, ${i} found`)));
                    for(let a = 2; a < e1.length; a++)i = Dn(e1[a]), "$type" === Jt(e1[1]) ? s = s.concat(ii({
                        key: `${r}[${a}]`,
                        value: e1[a],
                        valueSpec: n.geometry_type,
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && s.push(new Wn(`${r}[${a}]`, e1[a], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let n = 1; n < e1.length; n++)s = s.concat(vi({
                        key: `${r}[${n}]`,
                        value: e1[n],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = Dn(e1[1]), 2 !== e1.length ? s.push(new Wn(r, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "string" !== i && s.push(new Wn(`${r}[1]`, e1[1], `string expected, ${i} found`));
                    break;
                case "within":
                    i = Dn(e1[1]), 2 !== e1.length ? s.push(new Wn(r, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "object" !== i && s.push(new Wn(`${r}[1]`, e1[1], `object expected, ${i} found`));
            }
            return s;
        }
        function bi(t1, e1) {
            const r = t1.key, n = t1.style, i = t1.styleSpec, s = t1.value, a = t1.objectKey, o = i[`${e1}_${t1.layerType}`];
            if (!o) return [];
            const l = a.match(/^(.*)-transition$/);
            if ("paint" === e1 && l && o[l[1]] && o[l[1]].transition) return Ci({
                key: r,
                value: s,
                valueSpec: i.transition,
                style: n,
                styleSpec: i
            });
            const u = t1.valueSpec || o[a];
            if (!u) return [
                new Wn(r, s, `unknown property "${a}"`)
            ];
            let c;
            if ("string" === Dn(s) && En(u) && !u.tokens && (c = /^{([^}]+)}$/.exec(s))) return [
                new Wn(r, s, `"${a}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(c[1])} }\`.`)
            ];
            const h = [];
            return "symbol" === t1.layerType && ("text-field" === a && n && !n.glyphs && h.push(new Wn(r, s, 'use of "text-field" requires a style "glyphs" property')), "text-font" === a && Vn(Qt(s)) && "identity" === Jt(s.type) && h.push(new Wn(r, s, '"text-font" does not support identity functions'))), h.concat(Ci({
                key: t1.key,
                value: s,
                valueSpec: u,
                style: n,
                styleSpec: i,
                expressionContext: "property",
                propertyType: e1,
                propertyKey: a
            }));
        }
        function wi(t1) {
            return bi(t1, "paint");
        }
        function _i(t1) {
            return bi(t1, "layout");
        }
        function Ai(t1) {
            let e1 = [];
            const r = t1.value, n = t1.key, i = t1.style, s = t1.styleSpec;
            r.type || r.ref || e1.push(new Wn(n, r, 'either "type" or "ref" is required'));
            let a = Jt(r.type);
            const o = Jt(r.ref);
            if (r.id) {
                const s = Jt(r.id);
                for(let a = 0; a < t1.arrayIndex; a++){
                    const t1 = i.layers[a];
                    Jt(t1.id) === s && e1.push(new Wn(n, r.id, `duplicate layer id "${r.id}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in r) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t1)=>{
                    t1 in r && e1.push(new Wn(n, r[t1], `"${t1}" is prohibited for ref layers`));
                }), i.layers.forEach((e1)=>{
                    Jt(e1.id) === o && (t1 = e1);
                }), t1 ? t1.ref ? e1.push(new Wn(n, r.ref, "ref cannot reference another ref layer")) : a = Jt(t1.type) : "string" == typeof o && e1.push(new Wn(n, r.ref, `ref layer "${o}" not found`));
            } else if ("background" !== a && "sky" !== a) {
                if (r.source) {
                    const t1 = i.sources && i.sources[r.source], s = t1 && Jt(t1.type);
                    t1 ? "vector" === s && "raster" === a ? e1.push(new Wn(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster" === s && "raster" !== a ? e1.push(new Wn(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== s || r["source-layer"] ? "raster-dem" === s && "hillshade" !== a ? e1.push(new Wn(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== a || !r.paint || !r.paint["line-gradient"] && !r.paint["line-trim-offset"] || "geojson" === s && t1.lineMetrics || e1.push(new Wn(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e1.push(new Wn(n, r, `layer "${r.id}" must specify a "source-layer"`)) : e1.push(new Wn(n, r.source, `source "${r.source}" not found`));
                } else e1.push(new Wn(n, r, 'missing required property "source"'));
            }
            return e1 = e1.concat(Jn({
                key: n,
                value: r,
                valueSpec: s.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>Ci({
                            key: `${n}.type`,
                            value: r.type,
                            valueSpec: s.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: r,
                            objectKey: "type"
                        }),
                    filter: (t1)=>xi(Wt({
                            layerType: a
                        }, t1)),
                    layout: (t1)=>Jn({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>_i(Wt({
                                        layerType: a
                                    }, t1))
                            }
                        }),
                    paint: (t1)=>Jn({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>wi(Wt({
                                        layerType: a
                                    }, t1))
                            }
                        })
                }
            })), e1;
        }
        function Si(t1) {
            const e1 = t1.value, r = t1.key, n = Dn(e1);
            return "string" !== n ? [
                new Wn(r, e1, `string expected, ${n} found`)
            ] : [];
        }
        const ki = {
            promoteId: function({ key: t1, value: e1 }) {
                if ("string" === Dn(e1)) return Si({
                    key: t1,
                    value: e1
                });
                {
                    const r = [];
                    for(const n in e1)r.push(...Si({
                        key: `${t1}.${n}`,
                        value: e1[n]
                    }));
                    return r;
                }
            }
        };
        function Ii(t1) {
            const e1 = t1.value, r = t1.key, n = t1.styleSpec, i = t1.style;
            if (!e1.type) return [
                new Wn(r, e1, '"type" is required')
            ];
            const s = Jt(e1.type);
            let a;
            switch(s){
                case "vector":
                case "raster":
                case "raster-dem":
                    return a = Jn({
                        key: r,
                        value: e1,
                        valueSpec: n[`source_${s.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: n,
                        objectElementValidators: ki
                    }), a;
                case "geojson":
                    if (a = Jn({
                        key: r,
                        value: e1,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        objectElementValidators: ki
                    }), e1.cluster) for(const t1 in e1.clusterProperties){
                        const [n, i] = e1.clusterProperties[t1], s = "string" == typeof n ? [
                            n,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t1
                            ]
                        ] : n;
                        a.push(...ri({
                            key: `${r}.${t1}.map`,
                            value: i,
                            expressionContext: "cluster-map"
                        })), a.push(...ri({
                            key: `${r}.${t1}.reduce`,
                            value: s,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return a;
                case "video":
                    return Jn({
                        key: r,
                        value: e1,
                        valueSpec: n.source_video,
                        style: i,
                        styleSpec: n
                    });
                case "image":
                    return Jn({
                        key: r,
                        value: e1,
                        valueSpec: n.source_image,
                        style: i,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new Wn(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return ii({
                        key: `${r}.type`,
                        value: e1.type,
                        valueSpec: {
                            values: Mi(n)
                        },
                        style: i,
                        styleSpec: n
                    });
            }
        }
        function Mi(t1) {
            return t1.source.reduce((e1, r)=>{
                const n = t1[r];
                return "enum" === n.type.type && (e1 = e1.concat(Object.keys(n.type.values))), e1;
            }, []);
        }
        function Ti(t1) {
            const e1 = t1.value, r = t1.styleSpec, n = r.light, i = t1.style;
            let s = [];
            const a = Dn(e1);
            if (void 0 === e1) return s;
            if ("object" !== a) return s = s.concat([
                new Wn("light", e1, `object expected, ${a} found`)
            ]), s;
            for(const t1 in e1){
                const a = t1.match(/^(.*)-transition$/);
                s = s.concat(a && n[a[1]] && n[a[1]].transition ? Ci({
                    key: t1,
                    value: e1[t1],
                    valueSpec: r.transition,
                    style: i,
                    styleSpec: r
                }) : n[t1] ? Ci({
                    key: t1,
                    value: e1[t1],
                    valueSpec: n[t1],
                    style: i,
                    styleSpec: r
                }) : [
                    new Wn(t1, e1[t1], `unknown property "${t1}"`)
                ]);
            }
            return s;
        }
        function zi(t1) {
            const e1 = t1.value, r = t1.key, n = t1.style, i = t1.styleSpec, s = i.terrain;
            let a = [];
            const o = Dn(e1);
            if (void 0 === e1) return a;
            if ("object" !== o) return a = a.concat([
                new Wn("terrain", e1, `object expected, ${o} found`)
            ]), a;
            for(const t1 in e1){
                const r = t1.match(/^(.*)-transition$/);
                a = a.concat(r && s[r[1]] && s[r[1]].transition ? Ci({
                    key: t1,
                    value: e1[t1],
                    valueSpec: i.transition,
                    style: n,
                    styleSpec: i
                }) : s[t1] ? Ci({
                    key: t1,
                    value: e1[t1],
                    valueSpec: s[t1],
                    style: n,
                    styleSpec: i
                }) : [
                    new Wn(t1, e1[t1], `unknown property "${t1}"`)
                ]);
            }
            if (e1.source) {
                const t1 = n.sources && n.sources[e1.source], i = t1 && Jt(t1.type);
                t1 ? "raster-dem" !== i && a.push(new Wn(r, e1.source, `terrain cannot be used with a source of type ${String(i)}, it only be used with a "raster-dem" source type`)) : a.push(new Wn(r, e1.source, `source "${e1.source}" not found`));
            } else a.push(new Wn(r, e1, 'terrain is missing required property "source"'));
            return a;
        }
        function Bi(t1) {
            const e1 = t1.value, r = t1.style, n = t1.styleSpec, i = n.fog;
            let s = [];
            const a = Dn(e1);
            if (void 0 === e1) return s;
            if ("object" !== a) return s = s.concat([
                new Wn("fog", e1, `object expected, ${a} found`)
            ]), s;
            for(const t1 in e1){
                const a = t1.match(/^(.*)-transition$/);
                s = s.concat(a && i[a[1]] && i[a[1]].transition ? Ci({
                    key: t1,
                    value: e1[t1],
                    valueSpec: n.transition,
                    style: r,
                    styleSpec: n
                }) : i[t1] ? Ci({
                    key: t1,
                    value: e1[t1],
                    valueSpec: i[t1],
                    style: r,
                    styleSpec: n
                }) : [
                    new Wn(t1, e1[t1], `unknown property "${t1}"`)
                ]);
            }
            return s;
        }
        const Ei = {
            "*": ()=>[],
            array: Qn,
            boolean: function(t1) {
                const e1 = t1.value, r = t1.key, n = Dn(e1);
                return "boolean" !== n ? [
                    new Wn(r, e1, `boolean expected, ${n} found`)
                ] : [];
            },
            number: ti,
            color: function(t1) {
                const e1 = t1.key, r = t1.value, n = Dn(r);
                return "string" !== n ? [
                    new Wn(e1, r, `color expected, ${n} found`)
                ] : null === be(r) ? [
                    new Wn(e1, r, `color expected, "${r}" found`)
                ] : [];
            },
            enum: ii,
            filter: xi,
            function: ei,
            layer: Ai,
            object: Jn,
            source: Ii,
            light: Ti,
            terrain: zi,
            fog: Bi,
            string: Si,
            formatted: function(t1) {
                return 0 === Si(t1).length ? [] : ri(t1);
            },
            resolvedImage: function(t1) {
                return 0 === Si(t1).length ? [] : ri(t1);
            },
            projection: function(t1) {
                const e1 = t1.value, r = t1.styleSpec, n = r.projection, i = t1.style;
                let s = [];
                const a = Dn(e1);
                if ("object" === a) for(const t1 in e1)s = s.concat(Ci({
                    key: t1,
                    value: e1[t1],
                    valueSpec: n[t1],
                    style: i,
                    styleSpec: r
                }));
                else "string" !== a && (s = s.concat([
                    new Wn("projection", e1, `object or string expected, ${a} found`)
                ]));
                return s;
            }
        };
        function Ci(t1) {
            const e1 = t1.value, r = t1.valueSpec, n = t1.styleSpec;
            return r.expression && Vn(Jt(e1)) ? ei(t1) : r.expression && Nn(Qt(e1)) ? ri(t1) : r.type && Ei[r.type] ? Ei[r.type](t1) : Jn(Wt({}, t1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function Pi(t1) {
            const e1 = t1.value, r = t1.key, n = Si(t1);
            return n.length || (-1 === e1.indexOf("{fontstack}") && n.push(new Wn(r, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && n.push(new Wn(r, e1, '"glyphs" url must include a "{range}" token'))), n;
        }
        function Di(t1, e1 = Ht) {
            return Fi(Ci({
                key: "",
                value: t1,
                valueSpec: e1.$root,
                styleSpec: e1,
                style: t1,
                objectElementValidators: {
                    glyphs: Pi,
                    "*": ()=>[]
                }
            }));
        }
        const Vi = (t1)=>Fi(wi(t1)), Li = (t1)=>Fi(_i(t1));
        function Fi(t1) {
            return t1.slice().sort((t1, e1)=>t1.line && e1.line ? t1.line - e1.line : 0);
        }
        function Ri(t1, e1) {
            let r = !1;
            if (e1 && e1.length) for (const n of e1)t1.fire(new Kt(new Error(n.message))), r = !0;
            return r;
        }
        var ji = Ui;
        function Ui(t1, e1, r) {
            var n = this.cells = [];
            if (t1 instanceof ArrayBuffer) {
                this.arrayBuffer = t1;
                var i = new Int32Array(this.arrayBuffer);
                t1 = i[0], this.d = (e1 = i[1]) + 2 * (r = i[2]);
                for(var s = 0; s < this.d * this.d; s++){
                    var a = i[3 + s], o = i[3 + s + 1];
                    n.push(a === o ? null : i.subarray(a, o));
                }
                var l = i[3 + n.length + 1];
                this.keys = i.subarray(i[3 + n.length], l), this.bboxes = i.subarray(l), this.insert = this._insertReadonly;
            } else {
                this.d = e1 + 2 * r;
                for(var u = 0; u < this.d * this.d; u++)n.push([]);
                this.keys = [], this.bboxes = [];
            }
            this.n = e1, this.extent = t1, this.padding = r, this.scale = e1 / t1, this.uid = 0;
            var c = r / e1 * t1;
            this.min = -c, this.max = t1 + c;
        }
        Ui.prototype.insert = function(t1, e1, r, n, i) {
            this._forEachCell(e1, r, n, i, this._insertCell, this.uid++), this.keys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
        }, Ui.prototype._insertReadonly = function() {
            throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
        }, Ui.prototype._insertCell = function(t1, e1, r, n, i, s) {
            this.cells[i].push(s);
        }, Ui.prototype.query = function(t1, e1, r, n, i) {
            var s = this.min, a = this.max;
            if (t1 <= s && e1 <= s && a <= r && a <= n && !i) return Array.prototype.slice.call(this.keys);
            var o = [];
            return this._forEachCell(t1, e1, r, n, this._queryCell, o, {}, i), o;
        }, Ui.prototype._queryCell = function(t1, e1, r, n, i, s, a, o) {
            var l = this.cells[i];
            if (null !== l) for(var u = this.keys, c = this.bboxes, h = 0; h < l.length; h++){
                var p = l[h];
                if (void 0 === a[p]) {
                    var f = 4 * p;
                    (o ? o(c[f + 0], c[f + 1], c[f + 2], c[f + 3]) : t1 <= c[f + 2] && e1 <= c[f + 3] && r >= c[f + 0] && n >= c[f + 1]) ? (a[p] = !0, s.push(u[p])) : a[p] = !1;
                }
            }
        }, Ui.prototype._forEachCell = function(t1, e1, r, n, i, s, a, o) {
            for(var l = this._convertToCellCoord(t1), u = this._convertToCellCoord(e1), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n), p = l; p <= c; p++)for(var f = u; f <= h; f++){
                var d = this.d * f + p;
                if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(f), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(f + 1))) && i.call(this, t1, e1, r, n, d, s, a, o)) return;
            }
        }, Ui.prototype._convertFromCellCoord = function(t1) {
            return (t1 - this.padding) / this.scale;
        }, Ui.prototype._convertToCellCoord = function(t1) {
            return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
        }, Ui.prototype.toArrayBuffer = function() {
            if (this.arrayBuffer) return this.arrayBuffer;
            for(var t1 = this.cells, e1 = 3 + this.cells.length + 1 + 1, r = 0, n = 0; n < this.cells.length; n++)r += this.cells[n].length;
            var i = new Int32Array(e1 + r + this.keys.length + this.bboxes.length);
            i[0] = this.extent, i[1] = this.n, i[2] = this.padding;
            for(var s = e1, a = 0; a < t1.length; a++){
                var o = t1[a];
                i[3 + a] = s, i.set(o, s), s += o.length;
            }
            return i[3 + t1.length] = s, i.set(this.keys, s), i[3 + t1.length + 1] = s += this.keys.length, i.set(this.bboxes, s), s += this.bboxes.length, i.buffer;
        };
        const $i = {};
        function Oi(t1, e1, r = {}) {
            Object.defineProperty(t1, "_classRegistryKey", {
                value: e1,
                writeable: !1
            }), $i[e1] = {
                klass: t1,
                omit: r.omit || []
            };
        }
        Oi(Object, "Object"), ji.serialize = function(t1, e1) {
            const r = t1.toArrayBuffer();
            return e1 && e1.push(r), {
                buffer: r
            };
        }, ji.deserialize = function(t1) {
            return new ji(t1.buffer);
        }, Object.defineProperty(ji, "name", {
            value: "Grid"
        }), Oi(ji, "Grid"), Oi(Me, "Color"), Oi(Error, "Error"), Oi(at, "AJAXError"), Oi(Ee, "ResolvedImage"), Oi(Yn, "StylePropertyFunction"), Oi(qn, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), Oi(Zn, "ZoomDependentExpression"), Oi(Xn, "ZoomConstantExpression"), Oi(He, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const t1 in Tn)$i[Tn[t1]._classRegistryKey] || Oi(Tn[t1], `Expression${t1}`);
        function qi(t1) {
            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
        }
        function Ni(t1) {
            return e1.ImageBitmap && t1 instanceof e1.ImageBitmap;
        }
        function Gi(t1, r) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp) return t1;
            if (qi(t1) || Ni(t1)) return r && r.push(t1), t1;
            if (ArrayBuffer.isView(t1)) {
                const e1 = t1;
                return r && r.push(e1.buffer), e1;
            }
            if (t1 instanceof e1.ImageData) return r && r.push(t1.data.buffer), t1;
            if (Array.isArray(t1)) {
                const e1 = [];
                for (const n of t1)e1.push(Gi(n, r));
                return e1;
            }
            if ("object" == typeof t1) {
                const e1 = t1.constructor, n = e1._classRegistryKey;
                if (!n) throw new Error(`can't serialize object of unregistered class ${n}`);
                const i = e1.serialize ? e1.serialize(t1, r) : {};
                if (!e1.serialize) {
                    for(const e1 in t1)t1.hasOwnProperty(e1) && ($i[n].omit.indexOf(e1) >= 0 || (i[e1] = Gi(t1[e1], r)));
                    t1 instanceof Error && (i.message = t1.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof t1);
        }
        function Xi(t1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || qi(t1) || Ni(t1) || ArrayBuffer.isView(t1) || t1 instanceof e1.ImageData) return t1;
            if (Array.isArray(t1)) return t1.map(Xi);
            if ("object" == typeof t1) {
                const e1 = t1.$name || "Object", { klass: r } = $i[e1];
                if (!r) throw new Error(`can't deserialize unregistered class ${e1}`);
                if (r.deserialize) return r.deserialize(t1);
                const n = Object.create(r.prototype);
                for (const e1 of Object.keys(t1))"$name" !== e1 && (n[e1] = Xi(t1[e1]));
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t1);
        }
        const Zi = (t1)=>t1 >= 1536 && t1 <= 1791, Ki = (t1)=>t1 >= 1872 && t1 <= 1919, Yi = (t1)=>t1 >= 2208 && t1 <= 2303, Hi = (t1)=>t1 >= 11904 && t1 <= 12031, Wi = (t1)=>t1 >= 12032 && t1 <= 12255, Ji = (t1)=>t1 >= 12272 && t1 <= 12287, Qi = (t1)=>t1 >= 12288 && t1 <= 12351, ts = (t1)=>t1 >= 12352 && t1 <= 12447, es = (t1)=>t1 >= 12448 && t1 <= 12543, rs = (t1)=>t1 >= 12544 && t1 <= 12591, ns = (t1)=>t1 >= 12704 && t1 <= 12735, is = (t1)=>t1 >= 12736 && t1 <= 12783, ss = (t1)=>t1 >= 12784 && t1 <= 12799, as = (t1)=>t1 >= 12800 && t1 <= 13055, os = (t1)=>t1 >= 13056 && t1 <= 13311, ls = (t1)=>t1 >= 13312 && t1 <= 19903, us = (t1)=>t1 >= 19968 && t1 <= 40959, cs = (t1)=>t1 >= 40960 && t1 <= 42127, hs = (t1)=>t1 >= 42128 && t1 <= 42191, ps = (t1)=>t1 >= 44032 && t1 <= 55215, fs = (t1)=>t1 >= 63744 && t1 <= 64255, ds = (t1)=>t1 >= 64336 && t1 <= 65023, ys = (t1)=>t1 >= 65040 && t1 <= 65055, ms = (t1)=>t1 >= 65072 && t1 <= 65103, gs = (t1)=>t1 >= 65104 && t1 <= 65135, xs = (t1)=>t1 >= 65136 && t1 <= 65279, vs = (t1)=>t1 >= 65280 && t1 <= 65519;
        function bs(t1) {
            for (const e1 of t1)if (As(e1.charCodeAt(0))) return !0;
            return !1;
        }
        function ws(t1) {
            for (const e1 of t1)if (!_s(e1.charCodeAt(0))) return !1;
            return !0;
        }
        function _s(t1) {
            return !(Zi(t1) || Ki(t1) || Yi(t1) || ds(t1) || xs(t1));
        }
        function As(t1) {
            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(ns(t1) || rs(t1) || ms(t1) && !(t1 >= 65097 && t1 <= 65103) || fs(t1) || os(t1) || Hi(t1) || is(t1) || !(!Qi(t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || ls(t1) || us(t1) || as(t1) || ((t1)=>t1 >= 12592 && t1 <= 12687)(t1) || ((t1)=>t1 >= 43360 && t1 <= 43391)(t1) || ((t1)=>t1 >= 55216 && t1 <= 55295)(t1) || ((t1)=>t1 >= 4352 && t1 <= 4607)(t1) || ps(t1) || ts(t1) || Ji(t1) || ((t1)=>t1 >= 12688 && t1 <= 12703)(t1) || Wi(t1) || ss(t1) || es(t1) && 12540 !== t1 || !(!vs(t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!gs(t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || ((t1)=>t1 >= 5120 && t1 <= 5759)(t1) || ((t1)=>t1 >= 6320 && t1 <= 6399)(t1) || ys(t1) || ((t1)=>t1 >= 19904 && t1 <= 19967)(t1) || cs(t1) || hs(t1))));
        }
        function Ss(t1) {
            return !(As(t1) || function(t1) {
                return !!(((t1)=>t1 >= 128 && t1 <= 255)(t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || ((t1)=>t1 >= 8192 && t1 <= 8303)(t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || ((t1)=>t1 >= 8448 && t1 <= 8527)(t1) || ((t1)=>t1 >= 8528 && t1 <= 8591)(t1) || ((t1)=>t1 >= 8960 && t1 <= 9215)(t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || ((t1)=>t1 >= 9216 && t1 <= 9279)(t1) && 9251 !== t1 || ((t1)=>t1 >= 9280 && t1 <= 9311)(t1) || ((t1)=>t1 >= 9312 && t1 <= 9471)(t1) || ((t1)=>t1 >= 9632 && t1 <= 9727)(t1) || ((t1)=>t1 >= 9728 && t1 <= 9983)(t1) && !(t1 >= 9754 && t1 <= 9759) || ((t1)=>t1 >= 11008 && t1 <= 11263)(t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || Qi(t1) || es(t1) || ((t1)=>t1 >= 57344 && t1 <= 63743)(t1) || ms(t1) || gs(t1) || vs(t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
            }(t1));
        }
        function ks(t1) {
            return t1 >= 1424 && t1 <= 2303 || ds(t1) || xs(t1);
        }
        function Is(t1, e1) {
            return !(!e1 && ks(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || ((t1)=>t1 >= 6016 && t1 <= 6143)(t1));
        }
        function Ms(t1) {
            for (const e1 of t1)if (ks(e1.charCodeAt(0))) return !0;
            return !1;
        }
        const Ts = "deferred", zs = "loading", Bs = "loaded";
        let Es = null, Cs = "unavailable", Ps = null;
        const Ds = function(t1) {
            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (Cs = "error"), Es && Es(t1);
        };
        function Vs() {
            Ls.fire(new Zt("pluginStateChange", {
                pluginStatus: Cs,
                pluginURL: Ps
            }));
        }
        const Ls = new Yt, Fs = function() {
            return Cs;
        }, Rs = function() {
            if (Cs !== Ts || !Ps) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Cs = zs, Vs(), Ps && ut({
                url: Ps
            }, (t1)=>{
                t1 ? Ds(t1) : (Cs = Bs, Vs());
            });
        }, js = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Cs === Bs || null != js.applyArabicShaping,
            isLoading: ()=>Cs === zs,
            setState (t1) {
                Cs = t1.pluginStatus, Ps = t1.pluginURL;
            },
            isParsed: ()=>null != js.applyArabicShaping && null != js.processBidirectionalText && null != js.processStyledBidirectionalText,
            getPluginURL: ()=>Ps
        };
        class Us {
            constructor(t1, e1){
                this.zoom = t1, e1 ? (this.now = e1.now, this.fadeDuration = e1.fadeDuration, this.transition = e1.transition, this.pitch = e1.pitch) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0);
            }
            isSupportedScript(t1) {
                return function(t1, e1) {
                    for (const r of t1)if (!Is(r.charCodeAt(0), e1)) return !1;
                    return !0;
                }(t1, js.isLoaded());
            }
        }
        class $s {
            constructor(t1, e1){
                this.property = t1, this.value = e1, this.expression = function(t1, e1) {
                    if (Vn(t1)) return new Yn(t1, e1);
                    if (Nn(t1)) {
                        const r = Kn(t1, e1);
                        if ("error" === r.result) throw new Error(r.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let r = t1;
                        return "string" == typeof t1 && "color" === e1.type && (r = Me.parse(t1)), {
                            kind: "constant",
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e1 ? t1.specification.default : e1, t1.specification);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t1, e1, r) {
                return this.property.possiblyEvaluate(this, t1, e1, r);
            }
        }
        class Os {
            constructor(t1){
                this.property = t1, this.value = new $s(t1, void 0);
            }
            transitioned(t1, e1) {
                return new Ns(this.property, this.value, e1, z({}, t1.transition, this.transition), t1.now);
            }
            untransitioned() {
                return new Ns(this.property, this.value, null, {}, 0);
            }
        }
        class qs {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues);
            }
            getValue(t1) {
                return j(this._values[t1].value.value);
            }
            setValue(t1, e1) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new Os(this._values[t1].property)), this._values[t1].value = new $s(this._values[t1].property, null === e1 ? void 0 : j(e1));
            }
            getTransition(t1) {
                return j(this._values[t1].transition);
            }
            setTransition(t1, e1) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new Os(this._values[t1].property)), this._values[t1].transition = j(e1) || void 0;
            }
            serialize() {
                const t1 = {};
                for (const e1 of Object.keys(this._values)){
                    const r = this.getValue(e1);
                    void 0 !== r && (t1[e1] = r);
                    const n = this.getTransition(e1);
                    void 0 !== n && (t1[`${e1}-transition`] = n);
                }
                return t1;
            }
            transitioned(t1, e1) {
                const r = new Gs(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t1, e1._values[n]);
                return r;
            }
            untransitioned() {
                const t1 = new Gs(this._properties);
                for (const e1 of Object.keys(this._values))t1._values[e1] = this._values[e1].untransitioned();
                return t1;
            }
        }
        class Ns {
            constructor(t1, e1, r, n, i){
                const s = n.delay || 0, a = n.duration || 0;
                i = i || 0, this.property = t1, this.value = e1, this.begin = i + s, this.end = this.begin + a, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(t1, e1, r) {
                const n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e1, r), s = this.prior;
                if (s) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return s.possiblyEvaluate(t1, e1, r);
                    {
                        const a = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(t1, e1, r), i, w(a));
                    }
                }
                return i;
            }
        }
        class Gs {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t1, e1, r) {
                const n = new Ks(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                return n;
            }
            hasTransition() {
                for (const t1 of Object.keys(this._values))if (this._values[t1].prior) return !0;
                return !1;
            }
        }
        class Xs {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPropertyValues);
            }
            getValue(t1) {
                return j(this._values[t1].value);
            }
            setValue(t1, e1) {
                this._values[t1] = new $s(this._values[t1].property, null === e1 ? void 0 : j(e1));
            }
            serialize() {
                const t1 = {};
                for (const e1 of Object.keys(this._values)){
                    const r = this.getValue(e1);
                    void 0 !== r && (t1[e1] = r);
                }
                return t1;
            }
            possiblyEvaluate(t1, e1, r) {
                const n = new Ks(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                return n;
            }
        }
        class Zs {
            constructor(t1, e1, r){
                this.property = t1, this.value = e1, this.parameters = r;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t1) {
                return "constant" === this.value.kind ? this.value.value : t1;
            }
            evaluate(t1, e1, r, n) {
                return this.property.evaluate(this.value, this.parameters, t1, e1, r, n);
            }
        }
        class Ks {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
            }
            get(t1) {
                return this._values[t1];
            }
        }
        class Ys {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e1) {
                return t1.expression.evaluate(e1);
            }
            interpolate(t1, e1, r) {
                const n = Tr[this.specification.type];
                return n ? n(t1, e1, r) : t1;
            }
        }
        class Hs {
            constructor(t1, e1){
                this.specification = t1, this.overrides = e1;
            }
            possiblyEvaluate(t1, e1, r, n) {
                return new Zs(this, "constant" === t1.expression.kind || "camera" === t1.expression.kind ? {
                    kind: "constant",
                    value: t1.expression.evaluate(e1, null, {}, r, n)
                } : t1.expression, e1);
            }
            interpolate(t1, e1, r) {
                if ("constant" !== t1.value.kind || "constant" !== e1.value.kind) return t1;
                if (void 0 === t1.value.value || void 0 === e1.value.value) return new Zs(this, {
                    kind: "constant",
                    value: void 0
                }, t1.parameters);
                const n = Tr[this.specification.type];
                return n ? new Zs(this, {
                    kind: "constant",
                    value: n(t1.value.value, e1.value.value, r)
                }, t1.parameters) : t1;
            }
            evaluate(t1, e1, r, n, i, s) {
                return "constant" === t1.kind ? t1.value : t1.evaluate(e1, r, n, i, s);
            }
        }
        class Ws {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e1, r, n) {
                return !!t1.expression.evaluate(e1, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class Js {
            constructor(t1){
                this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const e1 = new Us(0, {});
                for(const r in t1){
                    const n = t1[r];
                    n.specification.overridable && this.overridableProperties.push(r);
                    const i = this.defaultPropertyValues[r] = new $s(n, void 0), s = this.defaultTransitionablePropertyValues[r] = new Os(n);
                    this.defaultTransitioningPropertyValues[r] = s.untransitioned(), this.defaultPossiblyEvaluatedValues[r] = i.possiblyEvaluate(e1);
                }
            }
        }
        function Qs(t1, e1) {
            return 256 * (t1 = S(Math.floor(t1), 0, 255)) + S(Math.floor(e1), 0, 255);
        }
        Oi(Hs, "DataDrivenProperty"), Oi(Ys, "DataConstantProperty"), Oi(Ws, "ColorRampProperty");
        const ta = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class ea {
            constructor(t1, e1){
                this._structArray = t1, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class ra {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(t1, e1) {
                return t1._trim(), e1 && (t1.isTransferred = !0, e1.push(t1.arrayBuffer)), {
                    length: t1.length,
                    arrayBuffer: t1.arrayBuffer
                };
            }
            static deserialize(t1) {
                const e1 = Object.create(this.prototype);
                return e1.arrayBuffer = t1.arrayBuffer, e1.length = t1.length, e1.capacity = t1.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t1) {
                this.reserve(t1), this.length = t1;
            }
            reserve(t1) {
                if (t1 > this.capacity) {
                    this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e1 = this.uint8;
                    this._refreshViews(), e1 && this.uint8.set(e1);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
        }
        function na(t1, e1 = 1) {
            let r = 0, n = 0;
            return {
                members: t1.map((t1)=>{
                    const i = ta[t1.type].BYTES_PER_ELEMENT, s = r = ia(r, Math.max(e1, i)), a = t1.components || 1;
                    return n = Math.max(n, i), r += i * a, {
                        name: t1.name,
                        type: t1.type,
                        components: a,
                        offset: s
                    };
                }),
                size: ia(r, Math.max(n, e1)),
                alignment: e1
            };
        }
        function ia(t1, e1) {
            return Math.ceil(t1 / e1) * e1;
        }
        class sa extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.int16[n + 0] = e1, this.int16[n + 1] = r, t1;
            }
        }
        sa.prototype.bytesPerElement = 4, Oi(sa, "StructArrayLayout2i4");
        class aa extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }
        }
        aa.prototype.bytesPerElement = 6, Oi(aa, "StructArrayLayout3i6");
        class oa extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const s = 4 * t1;
                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, t1;
            }
        }
        oa.prototype.bytesPerElement = 8, Oi(oa, "StructArrayLayout4i8");
        class la extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, s, a);
            }
            emplace(t1, e1, r, n, i, s, a, o) {
                const l = 6 * t1, u = 12 * t1, c = 3 * t1;
                return this.int16[l + 0] = e1, this.int16[l + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = s, this.uint8[u + 7] = a, this.float32[c + 2] = o, t1;
            }
        }
        la.prototype.bytesPerElement = 12, Oi(la, "StructArrayLayout2i4ub1f12");
        class ua extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const s = 4 * t1;
                return this.float32[s + 0] = e1, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, t1;
            }
        }
        ua.prototype.bytesPerElement = 16, Oi(ua, "StructArrayLayout4f16");
        class ca extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i);
            }
            emplace(t1, e1, r, n, i, s) {
                const a = 6 * t1, o = 3 * t1;
                return this.uint16[a + 0] = e1, this.uint16[a + 1] = r, this.uint16[a + 2] = n, this.uint16[a + 3] = i, this.float32[o + 2] = s, t1;
            }
        }
        ca.prototype.bytesPerElement = 12, Oi(ca, "StructArrayLayout4ui1f12");
        class ha extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const s = 4 * t1;
                return this.uint16[s + 0] = e1, this.uint16[s + 1] = r, this.uint16[s + 2] = n, this.uint16[s + 3] = i, t1;
            }
        }
        ha.prototype.bytesPerElement = 8, Oi(ha, "StructArrayLayout4ui8");
        class pa extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i, s);
            }
            emplace(t1, e1, r, n, i, s, a) {
                const o = 6 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t1;
            }
        }
        pa.prototype.bytesPerElement = 12, Oi(pa, "StructArrayLayout6i12");
        class fa extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t1, e1, r, n, i, s, a, o, l, u, c, h);
            }
            emplace(t1, e1, r, n, i, s, a, o, l, u, c, h, p) {
                const f = 12 * t1;
                return this.int16[f + 0] = e1, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = a, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t1;
            }
        }
        fa.prototype.bytesPerElement = 24, Oi(fa, "StructArrayLayout4i4ui4i24");
        class da extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i, s);
            }
            emplace(t1, e1, r, n, i, s, a) {
                const o = 10 * t1, l = 5 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = a, t1;
            }
        }
        da.prototype.bytesPerElement = 20, Oi(da, "StructArrayLayout3i3f20");
        class ya extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.uint32[1 * t1 + 0] = e1, t1;
            }
        }
        ya.prototype.bytesPerElement = 4, Oi(ya, "StructArrayLayout1ul4");
        class ma extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o, l, u, c, h, p) {
                const f = this.length;
                return this.resize(f + 1), this.emplace(f, t1, e1, r, n, i, s, a, o, l, u, c, h, p);
            }
            emplace(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f) {
                const d = 20 * t1, y = 10 * t1;
                return this.int16[d + 0] = e1, this.int16[d + 1] = r, this.int16[d + 2] = n, this.int16[d + 3] = i, this.int16[d + 4] = s, this.float32[y + 3] = a, this.float32[y + 4] = o, this.float32[y + 5] = l, this.float32[y + 6] = u, this.int16[d + 14] = c, this.uint32[y + 8] = h, this.uint16[d + 18] = p, this.uint16[d + 19] = f, t1;
            }
        }
        ma.prototype.bytesPerElement = 40, Oi(ma, "StructArrayLayout5i4f1i1ul2ui40");
        class ga extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, s, a);
            }
            emplace(t1, e1, r, n, i, s, a, o) {
                const l = 8 * t1;
                return this.int16[l + 0] = e1, this.int16[l + 1] = r, this.int16[l + 2] = n, this.int16[l + 4] = i, this.int16[l + 5] = s, this.int16[l + 6] = a, this.int16[l + 7] = o, t1;
            }
        }
        ga.prototype.bytesPerElement = 16, Oi(ga, "StructArrayLayout3i2i2i16");
        class xa extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i);
            }
            emplace(t1, e1, r, n, i, s) {
                const a = 4 * t1, o = 8 * t1;
                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = s, t1;
            }
        }
        xa.prototype.bytesPerElement = 16, Oi(xa, "StructArrayLayout2f1f2i16");
        class va extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const s = 12 * t1, a = 3 * t1;
                return this.uint8[s + 0] = e1, this.uint8[s + 1] = r, this.float32[a + 1] = n, this.float32[a + 2] = i, t1;
            }
        }
        va.prototype.bytesPerElement = 12, Oi(va, "StructArrayLayout2ub2f12");
        class ba extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
            }
        }
        ba.prototype.bytesPerElement = 12, Oi(ba, "StructArrayLayout3f12");
        class wa extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
            }
        }
        wa.prototype.bytesPerElement = 6, Oi(wa, "StructArrayLayout3ui6");
        class _a extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b) {
                const w = this.length;
                return this.resize(w + 1), this.emplace(w, t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b);
            }
            emplace(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w) {
                const _ = 30 * t1, A = 15 * t1, S = 60 * t1;
                return this.int16[_ + 0] = e1, this.int16[_ + 1] = r, this.int16[_ + 2] = n, this.float32[A + 2] = i, this.float32[A + 3] = s, this.uint16[_ + 8] = a, this.uint16[_ + 9] = o, this.uint32[A + 5] = l, this.uint32[A + 6] = u, this.uint32[A + 7] = c, this.uint16[_ + 16] = h, this.uint16[_ + 17] = p, this.uint16[_ + 18] = f, this.float32[A + 10] = d, this.float32[A + 11] = y, this.uint8[S + 48] = m, this.uint8[S + 49] = g, this.uint8[S + 50] = x, this.uint32[A + 13] = v, this.int16[_ + 28] = b, this.uint8[S + 58] = w, t1;
            }
        }
        _a.prototype.bytesPerElement = 60, Oi(_a, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class Aa extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, I, M, T, z) {
                const B = this.length;
                return this.resize(B + 1), this.emplace(B, t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, I, M, T, z);
            }
            emplace(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, I, M, T, z, B) {
                const E = 38 * t1, C = 19 * t1;
                return this.int16[E + 0] = e1, this.int16[E + 1] = r, this.int16[E + 2] = n, this.float32[C + 2] = i, this.float32[C + 3] = s, this.int16[E + 8] = a, this.int16[E + 9] = o, this.int16[E + 10] = l, this.int16[E + 11] = u, this.int16[E + 12] = c, this.int16[E + 13] = h, this.uint16[E + 14] = p, this.uint16[E + 15] = f, this.uint16[E + 16] = d, this.uint16[E + 17] = y, this.uint16[E + 18] = m, this.uint16[E + 19] = g, this.uint16[E + 20] = x, this.uint16[E + 21] = v, this.uint16[E + 22] = b, this.uint16[E + 23] = w, this.uint16[E + 24] = _, this.uint16[E + 25] = A, this.uint16[E + 26] = S, this.uint16[E + 27] = k, this.uint16[E + 28] = I, this.uint32[C + 15] = M, this.float32[C + 16] = T, this.float32[C + 17] = z, this.float32[C + 18] = B, t1;
            }
        }
        Aa.prototype.bytesPerElement = 76, Oi(Aa, "StructArrayLayout3i2f6i15ui1ul3f76");
        class Sa extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.float32[1 * t1 + 0] = e1, t1;
            }
        }
        Sa.prototype.bytesPerElement = 4, Oi(Sa, "StructArrayLayout1f4");
        class ka extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i);
            }
            emplace(t1, e1, r, n, i, s) {
                const a = 5 * t1;
                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, this.float32[a + 4] = s, t1;
            }
        }
        ka.prototype.bytesPerElement = 20, Oi(ka, "StructArrayLayout5f20");
        class Ia extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const s = 6 * t1;
                return this.uint32[3 * t1 + 0] = e1, this.uint16[s + 2] = r, this.uint16[s + 3] = n, this.uint16[s + 4] = i, t1;
            }
        }
        Ia.prototype.bytesPerElement = 12, Oi(Ia, "StructArrayLayout1ul3ui12");
        class Ma extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.uint16[n + 0] = e1, this.uint16[n + 1] = r, t1;
            }
        }
        Ma.prototype.bytesPerElement = 4, Oi(Ma, "StructArrayLayout2ui4");
        class Ta extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.uint16[1 * t1 + 0] = e1, t1;
            }
        }
        Ta.prototype.bytesPerElement = 2, Oi(Ta, "StructArrayLayout1ui2");
        class za extends ra {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.float32[n + 0] = e1, this.float32[n + 1] = r, t1;
            }
        }
        za.prototype.bytesPerElement = 8, Oi(za, "StructArrayLayout2f8");
        class Ba extends ea {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        Ba.prototype.size = 40;
        class Ea extends ma {
            get(t1) {
                return new Ba(this, t1);
            }
        }
        Oi(Ea, "CollisionBoxArray");
        class Ca extends ea {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(t1) {
                this._structArray.uint8[this._pos1 + 49] = t1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(t1) {
                this._structArray.uint8[this._pos1 + 50] = t1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 13] = t1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(t1) {
                this._structArray.uint8[this._pos1 + 58] = t1;
            }
        }
        Ca.prototype.size = 60;
        class Pa extends _a {
            get(t1) {
                return new Ca(this, t1);
            }
        }
        Oi(Pa, "PlacedSymbolArray");
        class Da extends ea {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 13];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 28];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 15];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 15] = t1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 18];
            }
        }
        Da.prototype.size = 76;
        class Va extends Aa {
            get(t1) {
                return new Da(this, t1);
            }
        }
        Oi(Va, "SymbolInstanceArray");
        class La extends Sa {
            getoffsetX(t1) {
                return this.float32[1 * t1 + 0];
            }
        }
        Oi(La, "GlyphOffsetArray");
        class Fa extends sa {
            getx(t1) {
                return this.int16[2 * t1 + 0];
            }
            gety(t1) {
                return this.int16[2 * t1 + 1];
            }
        }
        Oi(Fa, "SymbolLineVertexArray");
        class Ra extends ea {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        Ra.prototype.size = 12;
        class ja extends Ia {
            get(t1) {
                return new Ra(this, t1);
            }
        }
        Oi(ja, "FeatureIndexArray");
        class Ua extends Ma {
            geta_centroid_pos0(t1) {
                return this.uint16[2 * t1 + 0];
            }
            geta_centroid_pos1(t1) {
                return this.uint16[2 * t1 + 1];
            }
        }
        Oi(Ua, "FillExtrusionCentroidArray");
        const $a = na([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), Oa = na([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        var qa = {}, Na = {
            get exports () {
                return qa;
            },
            set exports (t){
                qa = t;
            }
        }, Ga = {};
        ({
            get exports () {
                return Ga;
            },
            set exports (t){
                Ga = t;
            }
        }).exports = function(t1, e1) {
            var r, n, i, s, a, o, l, u;
            for(n = t1.length - (r = 3 & t1.length), i = e1, a = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t1.charCodeAt(u) | (255 & t1.charCodeAt(++u)) << 8 | (255 & t1.charCodeAt(++u)) << 16 | (255 & t1.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
            switch(l = 0, r){
                case 3:
                    l ^= (255 & t1.charCodeAt(u + 2)) << 16;
                case 2:
                    l ^= (255 & t1.charCodeAt(u + 1)) << 8;
                case 1:
                    i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
            }
            return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
        };
        var Xa = {};
        ({
            get exports () {
                return Xa;
            },
            set exports (t){
                Xa = t;
            }
        }).exports = function(t1, e1) {
            for(var r, n = t1.length, i = e1 ^ n, s = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(s) | (255 & t1.charCodeAt(++s)) << 8 | (255 & t1.charCodeAt(++s)) << 16 | (255 & t1.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
            switch(n){
                case 3:
                    i ^= (255 & t1.charCodeAt(s + 2)) << 16;
                case 2:
                    i ^= (255 & t1.charCodeAt(s + 1)) << 8;
                case 1:
                    i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
            }
            return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
        };
        var Za = Ga, Ka = Xa;
        Na.exports = Za, qa.murmur3 = Za, qa.murmur2 = Ka;
        class Ya {
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
            add(t1, e1, r, n) {
                this.ids.push(Ha(t1)), this.positions.push(e1, r, n);
            }
            getPositions(t1) {
                const e1 = Ha(t1);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const t1 = r + n >> 1;
                    this.ids[t1] >= e1 ? n = t1 : r = t1 + 1;
                }
                const i = [];
                for(; this.ids[r] === e1;)i.push({
                    index: this.positions[3 * r],
                    start: this.positions[3 * r + 1],
                    end: this.positions[3 * r + 2]
                }), r++;
                return i;
            }
            static serialize(t1, e1) {
                const r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                return Wa(r, n, 0, r.length - 1), e1 && e1.push(r.buffer, n.buffer), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t1) {
                const e1 = new Ya;
                return e1.ids = t1.ids, e1.positions = t1.positions, e1.indexed = !0, e1;
            }
        }
        function Ha(t1) {
            const e1 = +t1;
            return !isNaN(e1) && Number.MIN_SAFE_INTEGER <= e1 && e1 <= Number.MAX_SAFE_INTEGER ? e1 : qa(String(t1));
        }
        function Wa(t1, e1, r, n) {
            for(; r < n;){
                const i = t1[r + n >> 1];
                let s = r - 1, a = n + 1;
                for(;;){
                    do s++;
                    while (t1[s] < i);
                    do a--;
                    while (t1[a] > i);
                    if (s >= a) break;
                    Ja(t1, s, a), Ja(e1, 3 * s, 3 * a), Ja(e1, 3 * s + 1, 3 * a + 1), Ja(e1, 3 * s + 2, 3 * a + 2);
                }
                a - r < n - a ? (Wa(t1, e1, r, a), r = a + 1) : (Wa(t1, e1, a + 1, n), n = a);
            }
        }
        function Ja(t1, e1, r) {
            const n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        Oi(Ya, "FeaturePositionMap");
        class Qa {
            constructor(t1){
                this.gl = t1.gl, this.initialized = !1;
            }
            fetchUniformLocation(t1, e1) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(t1, e1), this.initialized = !0), !!this.location;
            }
        }
        class to extends Qa {
            constructor(t1){
                super(t1), this.current = 0;
            }
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && this.current !== r && (this.current = r, this.gl.uniform1f(this.location, r));
            }
        }
        class eo extends Qa {
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] && r[3] === this.current[3] || (this.current = r, this.gl.uniform4f(this.location, r[0], r[1], r[2], r[3])));
            }
        }
        class ro extends Qa {
            constructor(t1){
                super(t1), this.current = Me.transparent;
            }
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && (r.r === this.current.r && r.g === this.current.g && r.b === this.current.b && r.a === this.current.a || (this.current = r, this.gl.uniform4f(this.location, r.r, r.g, r.b, r.a)));
            }
        }
        const no = new Float32Array(16), io = new Float32Array(9), so = new Float32Array(4);
        function ao(t1) {
            return [
                Qs(255 * t1.r, 255 * t1.g),
                Qs(255 * t1.b, 255 * t1.a)
            ];
        }
        class oo {
            constructor(t1, e1, r){
                this.value = t1, this.uniformNames = e1.map((t1)=>`u_${t1}`), this.type = r;
            }
            setUniform(t1, e1, r, n, i) {
                e1.set(t1, i, n.constantOr(this.value));
            }
            getBinding(t1, e1) {
                return "color" === this.type ? new ro(t1) : new to(t1);
            }
        }
        class lo {
            constructor(t1, e1){
                this.uniformNames = e1.map((t1)=>`u_${t1}`), this.pattern = null, this.pixelRatio = 1;
            }
            setConstantPatternPositions(t1) {
                this.pixelRatio = t1.pixelRatio || 1, this.pattern = t1.tl.concat(t1.br);
            }
            setUniform(t1, e1, r, n, i) {
                const s = "u_pattern" === i || "u_dash" === i ? this.pattern : "u_pixel_ratio" === i ? this.pixelRatio : null;
                s && e1.set(t1, i, s);
            }
            getBinding(t1, e1) {
                return "u_pattern" === e1 || "u_dash" === e1 ? new eo(t1) : new to(t1);
            }
        }
        class uo {
            constructor(t1, e1, r, n){
                this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(t1, e1, r, n, i, s) {
                const a = this.paintVertexArray.length, o = this.expression.evaluate(new Us(0), e1, {}, i, n, s);
                this.paintVertexArray.resize(t1), this._setPaintValue(a, t1, o);
            }
            updatePaintArray(t1, e1, r, n, i) {
                const s = this.expression.evaluate({
                    zoom: 0
                }, r, n, void 0, i);
                this._setPaintValue(t1, e1, s);
            }
            _setPaintValue(t1, e1, r) {
                if ("color" === this.type) {
                    const n = ao(r);
                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                } else {
                    for(let n = t1; n < e1; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class co {
            constructor(t1, e1, r, n, i, s){
                this.expression = t1, this.uniformNames = e1.map((t1)=>`u_${t1}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
            populatePaintArray(t1, e1, r, n, i, s) {
                const a = this.expression.evaluate(new Us(this.zoom), e1, {}, i, n, s), o = this.expression.evaluate(new Us(this.zoom + 1), e1, {}, i, n, s), l = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValue(l, t1, a, o);
            }
            updatePaintArray(t1, e1, r, n, i) {
                const s = this.expression.evaluate({
                    zoom: this.zoom
                }, r, n, void 0, i), a = this.expression.evaluate({
                    zoom: this.zoom + 1
                }, r, n, void 0, i);
                this._setPaintValue(t1, e1, s, a);
            }
            _setPaintValue(t1, e1, r, n) {
                if ("color" === this.type) {
                    const i = ao(r), s = ao(n);
                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, i[0], i[1], s[0], s[1]);
                } else {
                    for(let i = t1; i < e1; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t1, e1, r, n, i) {
                const s = this.useIntegerZoom ? Math.floor(r.zoom) : r.zoom, a = S(this.expression.interpolationFactor(s, this.zoom, this.zoom + 1), 0, 1);
                e1.set(t1, i, a);
            }
            getBinding(t1, e1) {
                return new to(t1);
            }
        }
        class ho {
            constructor(t1, e1, r, n, i){
                this.expression = t1, this.layerId = i, this.paintVertexAttributes = ("array" === r ? Oa : $a).members;
                for(let t1 = 0; t1 < e1.length; ++t1);
                this.paintVertexArray = new n;
            }
            populatePaintArray(t1, e1, r) {
                const n = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValues(n, t1, e1.patterns && e1.patterns[this.layerId], r);
            }
            updatePaintArray(t1, e1, r, n, i, s) {
                this._setPaintValues(t1, e1, r.patterns && r.patterns[this.layerId], s);
            }
            _setPaintValues(t1, e1, r, n) {
                if (!n || !r) return;
                const i = n[r];
                if (!i) return;
                const { tl: s, br: a, pixelRatio: o } = i;
                for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, s[0], s[1], a[0], a[1], o);
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class po {
            constructor(t1, e1, r = ()=>!0){
                this.binders = {}, this._buffers = [];
                const n = [];
                for(const i in t1.paint._values){
                    if (!r(i)) continue;
                    const s = t1.paint.get(i);
                    if (!(s instanceof Zs && En(s.property.specification))) continue;
                    const a = mo(i, t1.type), o = s.value, l = s.property.specification.type, u = s.property.useIntegerZoom, c = "line-dasharray" === i || i.endsWith("pattern"), h = "line-dasharray" === i && "constant" !== t1.layout.get("line-cap").value.kind;
                    if ("constant" !== o.kind || h) {
                        if ("source" === o.kind || h || c) {
                            const e1 = vo(i, l, "source");
                            this.binders[i] = c ? new ho(o, a, l, e1, t1.id) : new uo(o, a, l, e1), n.push(`/a_${i}`);
                        } else {
                            const t1 = vo(i, l, "composite");
                            this.binders[i] = new co(o, a, l, u, e1, t1), n.push(`/z_${i}`);
                        }
                    } else this.binders[i] = c ? new lo(o.value, a) : new oo(o.value, a, l), n.push(`/u_${i}`);
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(t1) {
                const e1 = this.binders[t1];
                return e1 instanceof uo || e1 instanceof co ? e1.maxValue : 0;
            }
            populatePaintArrays(t1, e1, r, n, i, s) {
                for(const a in this.binders){
                    const o = this.binders[a];
                    (o instanceof uo || o instanceof co || o instanceof ho) && o.populatePaintArray(t1, e1, r, n, i, s);
                }
            }
            setConstantPatternPositions(t1) {
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    r instanceof lo && r.setConstantPatternPositions(t1);
                }
            }
            updatePaintArrays(t1, e1, r, n, i, s) {
                let a = !1;
                for(const o in t1){
                    const l = e1.getPositions(o);
                    for (const e1 of l){
                        const l = r.feature(e1.index);
                        for(const r in this.binders){
                            const u = this.binders[r];
                            if ((u instanceof uo || u instanceof co || u instanceof ho) && !0 === u.expression.isStateDependent) {
                                const c = n.paint.get(r);
                                u.expression = c.value, u.updatePaintArray(e1.start, e1.end, l, t1[o], i, s), a = !0;
                            }
                        }
                    }
                }
                return a;
            }
            defines() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    (r instanceof oo || r instanceof lo) && t1.push(...r.uniformNames.map((t1)=>`#define HAS_UNIFORM_${t1}`));
                }
                return t1;
            }
            getBinderAttributes() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (r instanceof uo || r instanceof co || r instanceof ho) for(let e1 = 0; e1 < r.paintVertexAttributes.length; e1++)t1.push(r.paintVertexAttributes[e1].name);
                }
                return t1;
            }
            getBinderUniforms() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (r instanceof oo || r instanceof lo || r instanceof co) for (const e1 of r.uniformNames)t1.push(e1);
                }
                return t1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t1) {
                const e1 = [];
                for(const r in this.binders){
                    const n = this.binders[r];
                    if (n instanceof oo || n instanceof lo || n instanceof co) for (const i of n.uniformNames)e1.push({
                        name: i,
                        property: r,
                        binding: n.getBinding(t1, i)
                    });
                }
                return e1;
            }
            setUniforms(t1, e1, r, n, i) {
                for (const { name: e1, property: s, binding: a } of r)this.binders[s].setUniform(t1, a, i, n.get(s), e1);
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const t1 in this.binders){
                    const e1 = this.binders[t1];
                    (e1 instanceof uo || e1 instanceof co || e1 instanceof ho) && e1.paintVertexBuffer && this._buffers.push(e1.paintVertexBuffer);
                }
            }
            upload(t1) {
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    (r instanceof uo || r instanceof co || r instanceof ho) && r.upload(t1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t1 in this.binders){
                    const e1 = this.binders[t1];
                    (e1 instanceof uo || e1 instanceof co || e1 instanceof ho) && e1.destroy();
                }
            }
        }
        class fo {
            constructor(t1, e1, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t1)this.programConfigurations[n.id] = new po(n, e1, r);
                this.needsUpload = !1, this._featureMap = new Ya, this._bufferOffset = 0;
            }
            populatePaintArrays(t1, e1, r, n, i, s, a) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t1, e1, n, i, s, a);
                void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t1), this._bufferOffset = t1, this.needsUpload = !0;
            }
            updatePaintArrays(t1, e1, r, n, i) {
                for (const s of r)this.needsUpload = this.programConfigurations[s.id].updatePaintArrays(t1, this._featureMap, e1, s, n, i) || this.needsUpload;
            }
            get(t1) {
                return this.programConfigurations[t1];
            }
            upload(t1) {
                if (this.needsUpload) {
                    for(const e1 in this.programConfigurations)this.programConfigurations[e1].upload(t1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
            }
        }
        const yo = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "line-dasharray": [
                "dash"
            ]
        };
        function mo(t1, e1) {
            return yo[t1] || [
                t1.replace(`${e1}-`, "").replace(/-/g, "_")
            ];
        }
        const go = {
            "line-pattern": {
                source: ca,
                composite: ca
            },
            "fill-pattern": {
                source: ca,
                composite: ca
            },
            "fill-extrusion-pattern": {
                source: ca,
                composite: ca
            },
            "line-dasharray": {
                source: ha,
                composite: ha
            }
        }, xo = {
            color: {
                source: za,
                composite: ua
            },
            number: {
                source: Sa,
                composite: za
            }
        };
        function vo(t1, e1, r) {
            const n = go[t1];
            return n && n[r] || xo[e1][r];
        }
        Oi(oo, "ConstantBinder"), Oi(lo, "PatternConstantBinder"), Oi(uo, "SourceExpressionBinder"), Oi(ho, "PatternCompositeBinder"), Oi(co, "CompositeExpressionBinder"), Oi(po, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), Oi(fo, "ProgramConfigurationSet");
        const bo = "-transition";
        class wo extends Yt {
            constructor(t1, e1){
                if (super(), this.id = t1.id, this.type = t1.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, "custom" !== t1.type && (this.metadata = t1.metadata, this.minzoom = t1.minzoom, this.maxzoom = t1.maxzoom, "background" !== t1.type && "sky" !== t1.type && (this.source = t1.source, this.sourceLayer = t1["source-layer"], this.filter = t1.filter), e1.layout && (this._unevaluatedLayout = new Xs(e1.layout)), e1.paint)) {
                    this._transitionablePaint = new qs(e1.paint);
                    for(const e1 in t1.paint)this.setPaintProperty(e1, t1.paint[e1], {
                        validate: !1
                    });
                    for(const e1 in t1.layout)this.setLayoutProperty(e1, t1.layout[e1], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Ks(e1.paint);
                }
            }
            getLayoutProperty(t1) {
                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
            }
            setLayoutProperty(t1, e1, r = {}) {
                null != e1 && this._validate(Li, `layers.${this.id}.layout.${t1}`, t1, e1, r) || ("visibility" !== t1 ? this._unevaluatedLayout.setValue(t1, e1) : this.visibility = e1);
            }
            getPaintProperty(t1) {
                return L(t1, bo) ? this._transitionablePaint.getTransition(t1.slice(0, -bo.length)) : this._transitionablePaint.getValue(t1);
            }
            setPaintProperty(t1, e1, r = {}) {
                if (null != e1 && this._validate(Vi, `layers.${this.id}.paint.${t1}`, t1, e1, r)) return !1;
                if (L(t1, bo)) return this._transitionablePaint.setTransition(t1.slice(0, -bo.length), e1 || void 0), !1;
                {
                    const r = this._transitionablePaint._values[t1], n = r.value.isDataDriven(), i = r.value;
                    this._transitionablePaint.setValue(t1, e1), this._handleSpecialPaintPropertyUpdate(t1);
                    const s = this._transitionablePaint._values[t1].value, a = s.isDataDriven(), o = L(t1, "pattern") || "line-dasharray" === t1;
                    return a || n || o || this._handleOverridablePaintPropertyUpdate(t1, i, s);
                }
            }
            _handleSpecialPaintPropertyUpdate(t1) {}
            getProgramIds() {
                return null;
            }
            getProgramConfiguration(t1) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                return !1;
            }
            isHidden(t1) {
                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t1, e1) {
                this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e1);
            }
            serialize() {
                const t1 = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t1.layout = t1.layout || {}, t1.layout.visibility = this.visibility), R(t1, (t1, e1)=>!(void 0 === t1 || "layout" === e1 && !Object.keys(t1).length || "paint" === e1 && !Object.keys(t1).length));
            }
            _validate(t1, e1, r, n, i = {}) {
                return (!i || !1 !== i.validate) && Ri(this, t1.call(Di, {
                    key: e1,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: Ht,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const t1 in this.paint._values){
                    const e1 = this.paint.get(t1);
                    if (e1 instanceof Zs && En(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                }
                return !1;
            }
            compileFilter() {
                this._filterCompiled || (this._featureFilter = ai(this.filter), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
        }
        const _o = na([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), Ao = na([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class So {
            constructor(t1 = []){
                this.segments = t1;
            }
            prepareSegment(t1, e1, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t1 > So.MAX_VERTEX_ARRAY_LENGTH && $(`Max vertices per segment is ${So.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t1}`), (!i || i.vertexLength + t1 > So.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e1.length,
                    primitiveOffset: r.length,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t1 of this.segments)for(const e1 in t1.vaos)t1.vaos[e1].destroy();
            }
            static simpleSegment(t1, e1, r, n) {
                return new So([
                    {
                        vertexOffset: t1,
                        primitiveOffset: e1,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        So.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Oi(So, "SegmentVector");
        var ko = 8192;
        class Io {
            constructor(t1, e1){
                t1 && (e1 ? this.setSouthWest(t1).setNorthEast(e1) : 4 === t1.length ? this.setSouthWest([
                    t1[0],
                    t1[1]
                ]).setNorthEast([
                    t1[2],
                    t1[3]
                ]) : this.setSouthWest(t1[0]).setNorthEast(t1[1]));
            }
            setNorthEast(t1) {
                return this._ne = t1 instanceof ru ? new ru(t1.lng, t1.lat) : ru.convert(t1), this;
            }
            setSouthWest(t1) {
                return this._sw = t1 instanceof ru ? new ru(t1.lng, t1.lat) : ru.convert(t1), this;
            }
            extend(t1) {
                const e1 = this._sw, r = this._ne;
                let n, i;
                if (t1 instanceof ru) n = t1, i = t1;
                else {
                    if (!(t1 instanceof Io)) return Array.isArray(t1) ? 4 === t1.length || t1.every(Array.isArray) ? this.extend(Io.convert(t1)) : this.extend(ru.convert(t1)) : "object" == typeof t1 && null !== t1 && t1.hasOwnProperty("lat") && t1.hasOwnProperty("lon") ? this.extend(ru.convert(t1)) : this;
                    if (n = t1._sw, i = t1._ne, !n || !i) return this;
                }
                return e1 || r ? (e1.lng = Math.min(n.lng, e1.lng), e1.lat = Math.min(n.lat, e1.lat), r.lng = Math.max(i.lng, r.lng), r.lat = Math.max(i.lat, r.lat)) : (this._sw = new ru(n.lng, n.lat), this._ne = new ru(i.lng, i.lat)), this;
            }
            getCenter() {
                return new ru((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new ru(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new ru(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(t1) {
                const { lng: e1, lat: r } = ru.convert(t1);
                let n = this._sw.lng <= e1 && e1 <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= e1 && e1 >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && n;
            }
            static convert(t1) {
                return !t1 || t1 instanceof Io ? t1 : new Io(t1);
            }
        }
        var Mo = 1e-6, To = "undefined" != typeof Float32Array ? Float32Array : Array;
        function zo() {
            var t1 = new To(9);
            return To != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
        }
        function Bo(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = r[0], f = r[1], d = r[2], y = r[3], m = r[4], g = r[5], x = r[6], v = r[7], b = r[8];
            return t1[0] = p * n + f * a + d * u, t1[1] = p * i + f * o + d * c, t1[2] = p * s + f * l + d * h, t1[3] = y * n + m * a + g * u, t1[4] = y * i + m * o + g * c, t1[5] = y * s + m * l + g * h, t1[6] = x * n + v * a + b * u, t1[7] = x * i + v * o + b * c, t1[8] = x * s + v * l + b * h, t1;
        }
        function Eo(t1) {
            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function Co(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = e1[3], a = e1[4], o = e1[5], l = e1[6], u = e1[7], c = e1[8], h = e1[9], p = e1[10], f = e1[11], d = e1[12], y = e1[13], m = e1[14], g = e1[15], x = r * o - n * a, v = r * l - i * a, b = r * u - s * a, w = n * l - i * o, _ = n * u - s * o, A = i * u - s * l, S = c * y - h * d, k = c * m - p * d, I = c * g - f * d, M = h * m - p * y, T = h * g - f * y, z = p * g - f * m, B = x * z - v * T + b * M + w * I - _ * k + A * S;
            return B ? (t1[0] = (o * z - l * T + u * M) * (B = 1 / B), t1[1] = (i * T - n * z - s * M) * B, t1[2] = (y * A - m * _ + g * w) * B, t1[3] = (p * _ - h * A - f * w) * B, t1[4] = (l * I - a * z - u * k) * B, t1[5] = (r * z - i * I + s * k) * B, t1[6] = (m * b - d * A - g * v) * B, t1[7] = (c * A - p * b + f * v) * B, t1[8] = (a * T - o * I + u * S) * B, t1[9] = (n * I - r * T - s * S) * B, t1[10] = (d * _ - y * b + g * x) * B, t1[11] = (h * b - c * _ - f * x) * B, t1[12] = (o * k - a * M - l * S) * B, t1[13] = (r * M - n * k + i * S) * B, t1[14] = (y * v - d * w - m * x) * B, t1[15] = (c * w - h * v + p * x) * B, t1) : null;
        }
        function Po(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], y = e1[12], m = e1[13], g = e1[14], x = e1[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return t1[0] = v * n + b * o + w * h + _ * y, t1[1] = v * i + b * l + w * p + _ * m, t1[2] = v * s + b * u + w * f + _ * g, t1[3] = v * a + b * c + w * d + _ * x, t1[4] = (v = r[4]) * n + (b = r[5]) * o + (w = r[6]) * h + (_ = r[7]) * y, t1[5] = v * i + b * l + w * p + _ * m, t1[6] = v * s + b * u + w * f + _ * g, t1[7] = v * a + b * c + w * d + _ * x, t1[8] = (v = r[8]) * n + (b = r[9]) * o + (w = r[10]) * h + (_ = r[11]) * y, t1[9] = v * i + b * l + w * p + _ * m, t1[10] = v * s + b * u + w * f + _ * g, t1[11] = v * a + b * c + w * d + _ * x, t1[12] = (v = r[12]) * n + (b = r[13]) * o + (w = r[14]) * h + (_ = r[15]) * y, t1[13] = v * i + b * l + w * p + _ * m, t1[14] = v * s + b * u + w * f + _ * g, t1[15] = v * a + b * c + w * d + _ * x, t1;
        }
        function Do(t1, e1, r) {
            var n, i, s, a, o, l, u, c, h, p, f, d, y = r[0], m = r[1], g = r[2];
            return e1 === t1 ? (t1[12] = e1[0] * y + e1[4] * m + e1[8] * g + e1[12], t1[13] = e1[1] * y + e1[5] * m + e1[9] * g + e1[13], t1[14] = e1[2] * y + e1[6] * m + e1[10] * g + e1[14], t1[15] = e1[3] * y + e1[7] * m + e1[11] * g + e1[15]) : (i = e1[1], s = e1[2], a = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], t1[0] = n = e1[0], t1[1] = i, t1[2] = s, t1[3] = a, t1[4] = o, t1[5] = l, t1[6] = u, t1[7] = c, t1[8] = h, t1[9] = p, t1[10] = f, t1[11] = d, t1[12] = n * y + o * m + h * g + e1[12], t1[13] = i * y + l * m + p * g + e1[13], t1[14] = s * y + u * m + f * g + e1[14], t1[15] = a * y + c * m + d * g + e1[15]), t1;
        }
        function Vo(t1, e1, r) {
            var n = r[0], i = r[1], s = r[2];
            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * s, t1[9] = e1[9] * s, t1[10] = e1[10] * s, t1[11] = e1[11] * s, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }
        function Lo(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e1[4], a = e1[5], o = e1[6], l = e1[7], u = e1[8], c = e1[9], h = e1[10], p = e1[11];
            return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = s * i + u * n, t1[5] = a * i + c * n, t1[6] = o * i + h * n, t1[7] = l * i + p * n, t1[8] = u * i - s * n, t1[9] = c * i - a * n, t1[10] = h * i - o * n, t1[11] = p * i - l * n, t1;
        }
        function Fo(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e1[0], a = e1[1], o = e1[2], l = e1[3], u = e1[8], c = e1[9], h = e1[10], p = e1[11];
            return e1 !== t1 && (t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = s * i - u * n, t1[1] = a * i - c * n, t1[2] = o * i - h * n, t1[3] = l * i - p * n, t1[8] = s * n + u * i, t1[9] = a * n + c * i, t1[10] = o * n + h * i, t1[11] = l * n + p * i, t1;
        }
        function Ro(t1, e1) {
            return t1[0] = e1[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e1[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e1[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function jo(t1, e1, r) {
            var n, i, s, a = r[0], o = r[1], l = r[2], u = Math.hypot(a, o, l);
            return u < Mo ? null : (a *= u = 1 / u, o *= u, l *= u, n = Math.sin(e1), i = Math.cos(e1), t1[0] = a * a * (s = 1 - i) + i, t1[1] = o * a * s + l * n, t1[2] = l * a * s - o * n, t1[3] = 0, t1[4] = a * o * s - l * n, t1[5] = o * o * s + i, t1[6] = l * o * s + a * n, t1[7] = 0, t1[8] = a * l * s + o * n, t1[9] = o * l * s - a * n, t1[10] = l * l * s + i, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1);
        }
        Math.hypot || (Math.hypot = function() {
            for(var t1 = 0, e1 = arguments.length; e1--;)t1 += arguments[e1] * arguments[e1];
            return Math.sqrt(t1);
        });
        var Uo = Po;
        function $o() {
            var t1 = new To(3);
            return To != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1;
        }
        function Oo(t1) {
            var e1 = new To(3);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1;
        }
        function qo(t1) {
            return Math.hypot(t1[0], t1[1], t1[2]);
        }
        function No(t1, e1, r) {
            var n = new To(3);
            return n[0] = t1, n[1] = e1, n[2] = r, n;
        }
        function Go(t1, e1, r) {
            return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
        }
        function Xo(t1, e1, r) {
            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
        }
        function Zo(t1, e1, r) {
            return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1;
        }
        function Ko(t1, e1, r) {
            return t1[0] = Math.min(e1[0], r[0]), t1[1] = Math.min(e1[1], r[1]), t1[2] = Math.min(e1[2], r[2]), t1;
        }
        function Yo(t1, e1, r) {
            return t1[0] = Math.max(e1[0], r[0]), t1[1] = Math.max(e1[1], r[1]), t1[2] = Math.max(e1[2], r[2]), t1;
        }
        function Ho(t1, e1, r) {
            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
        }
        function Wo(t1, e1, r, n) {
            return t1[0] = e1[0] + r[0] * n, t1[1] = e1[1] + r[1] * n, t1[2] = e1[2] + r[2] * n, t1;
        }
        function Jo(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = r * r + n * n + i * i;
            return s > 0 && (s = 1 / Math.sqrt(s)), t1[0] = e1[0] * s, t1[1] = e1[1] * s, t1[2] = e1[2] * s, t1;
        }
        function Qo(t1, e1) {
            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
        }
        function tl(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = r[0], o = r[1], l = r[2];
            return t1[0] = i * l - s * o, t1[1] = s * a - n * l, t1[2] = n * o - i * a, t1;
        }
        function el(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = r[3] * n + r[7] * i + r[11] * s + r[15];
            return t1[0] = (r[0] * n + r[4] * i + r[8] * s + r[12]) / (a = a || 1), t1[1] = (r[1] * n + r[5] * i + r[9] * s + r[13]) / a, t1[2] = (r[2] * n + r[6] * i + r[10] * s + r[14]) / a, t1;
        }
        function rl(t1, e1, r) {
            var n = r[0], i = r[1], s = r[2], a = e1[0], o = e1[1], l = e1[2], u = i * l - s * o, c = s * a - n * l, h = n * o - i * a, p = i * h - s * c, f = s * u - n * h, d = n * c - i * u, y = 2 * r[3];
            return c *= y, h *= y, f *= 2, d *= 2, t1[0] = a + (u *= y) + (p *= 2), t1[1] = o + c + f, t1[2] = l + h + d, t1;
        }
        var nl, il = Xo, sl = Zo, al = qo;
        function ol(t1, e1, r) {
            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1[3] = e1[3] * r, t1;
        }
        function ll(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = e1[3], a = r * r + n * n + i * i + s * s;
            return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = r * a, t1[1] = n * a, t1[2] = i * a, t1[3] = s * a, t1;
        }
        function ul(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3];
            return t1[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * a, t1[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * a, t1[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * a, t1[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * a, t1;
        }
        function cl() {
            var t1 = new To(4);
            return To != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1[3] = 1, t1;
        }
        function hl(t1) {
            return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1;
        }
        function pl(t1, e1, r) {
            r *= .5;
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l + a * o, t1[1] = i * l + s * o, t1[2] = s * l - i * o, t1[3] = a * l - n * o, t1;
        }
        function fl(t1, e1, r) {
            r *= .5;
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l - s * o, t1[1] = i * l + a * o, t1[2] = s * l + n * o, t1[3] = a * l - i * o, t1;
        }
        $o(), nl = new To(4), To != Float32Array && (nl[0] = 0, nl[1] = 0, nl[2] = 0, nl[3] = 0);
        var dl = ll;
        $o(), No(1, 0, 0), No(0, 1, 0), cl(), cl(), zo();
        const yl = na([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: ml } = yl, gl = na([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var xl = na([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class vl {
            constructor(t1, e1){
                this.pos = t1, this.dir = e1;
            }
            intersectsPlane(t1, e1, r) {
                const n = Qo(e1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((t1[0] - this.pos[0]) * e1[0] + (t1[1] - this.pos[1]) * e1[1] + (t1[2] - this.pos[2]) * e1[2]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, r[2] = this.pos[2] + this.dir[2] * i, !0;
            }
            closestPointOnSphere(t1, e1, r) {
                if (function(t1, e1) {
                    var r = t1[0], n = t1[1], i = t1[2], s = e1[0], a = e1[1], o = e1[2];
                    return Math.abs(r - s) <= Mo * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(n - a) <= Mo * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(i - o) <= Mo * Math.max(1, Math.abs(i), Math.abs(o));
                }(this.pos, t1) || 0 === e1) return r[0] = r[1] = r[2] = 0, !1;
                const [n, i, s] = this.dir, a = this.pos[0] - t1[0], o = this.pos[1] - t1[1], l = this.pos[2] - t1[2], u = n * n + i * i + s * s, c = 2 * (a * n + o * i + l * s), h = c * c - 4 * u * (a * a + o * o + l * l - e1 * e1);
                if (h < 0) {
                    const t1 = Math.max(-c / 2, 0), u = a + n * t1, h = o + i * t1, p = l + s * t1, f = Math.hypot(u, h, p);
                    return r[0] = u * e1 / f, r[1] = h * e1 / f, r[2] = p * e1 / f, !1;
                }
                {
                    const t1 = (-c - Math.sqrt(h)) / (2 * u);
                    if (t1 < 0) {
                        const t1 = Math.hypot(a, o, l);
                        return r[0] = a * e1 / t1, r[1] = o * e1 / t1, r[2] = l * e1 / t1, !1;
                    }
                    return r[0] = a + n * t1, r[1] = o + i * t1, r[2] = l + s * t1, !0;
                }
            }
        }
        class bl {
            constructor(t1, e1, r, n, i){
                this.TL = t1, this.TR = e1, this.BR = r, this.BL = n, this.horizon = i;
            }
            static fromInvProjectionMatrix(t1, e1, r) {
                const n = [
                    -1,
                    1,
                    1
                ], i = [
                    1,
                    1,
                    1
                ], s = [
                    1,
                    -1,
                    1
                ], a = [
                    -1,
                    -1,
                    1
                ], o = el(n, n, t1), l = el(i, i, t1), u = el(s, s, t1), c = el(a, a, t1);
                return new bl(o, l, u, c, e1 / r);
            }
        }
        class wl {
            constructor(t1, e1){
                this.points = t1, this.planes = e1;
            }
            static fromInvProjectionMatrix(t1, e1, r, n) {
                const i = Math.pow(2, r), s = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((r)=>{
                    const s = ul([], r, t1), a = 1 / s[3] / e1 * i;
                    return function(t1, e1, r) {
                        return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1[3] = e1[3] * r[3], t1;
                    }(s, s, [
                        a,
                        a,
                        n ? 1 / s[3] : a,
                        a
                    ]);
                }), a = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((t1)=>{
                    const e1 = Jo([], tl([], il([], s[t1[0]], s[t1[1]]), il([], s[t1[2]], s[t1[1]]))), r = -Qo(e1, s[t1[1]]);
                    return e1.concat(r);
                });
                return new wl(s, a);
            }
        }
        class _l {
            static fromPoints(t1) {
                const e1 = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], r = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const n of t1)Ko(e1, e1, n), Yo(r, r, n);
                return new _l(e1, r);
            }
            static applyTransform(t1, e1) {
                const r = t1.getCorners();
                for(let t1 = 0; t1 < r.length; ++t1)el(r[t1], r[t1], e1);
                return _l.fromPoints(r);
            }
            constructor(t1, e1){
                this.min = t1, this.max = e1, this.center = Ho([], Go([], this.min, this.max), .5);
            }
            quadrant(t1) {
                const e1 = [
                    t1 % 2 == 0,
                    t1 < 2
                ], r = Oo(this.min), n = Oo(this.max);
                for(let t1 = 0; t1 < e1.length; t1++)r[t1] = e1[t1] ? this.min[t1] : this.center[t1], n[t1] = e1[t1] ? this.center[t1] : this.max[t1];
                return n[2] = this.max[2], new _l(r, n);
            }
            distanceX(t1) {
                return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
            }
            distanceY(t1) {
                return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
            }
            distanceZ(t1) {
                return Math.max(Math.min(this.max[2], t1[2]), this.min[2]) - t1[2];
            }
            getCorners() {
                const t1 = this.min, e1 = this.max;
                return [
                    [
                        t1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        e1[2]
                    ]
                ];
            }
            intersects(t1) {
                const e1 = this.getCorners();
                let r = !0;
                for(let n = 0; n < t1.planes.length; n++){
                    const i = t1.planes[n];
                    let s = 0;
                    for(let t1 = 0; t1 < e1.length; t1++)s += Qo(i, e1[t1]) + i[3] >= 0;
                    if (0 === s) return 0;
                    s !== e1.length && (r = !1);
                }
                if (r) return 2;
                for(let e1 = 0; e1 < 3; e1++){
                    let r = Number.MAX_VALUE, n = -Number.MAX_VALUE;
                    for(let i = 0; i < t1.points.length; i++){
                        const s = t1.points[i][e1] - this.min[e1];
                        r = Math.min(r, s), n = Math.max(n, s);
                    }
                    if (n < 0 || r > this.max[e1] - this.min[e1]) return 0;
                }
                return 1;
            }
        }
        const Al = ko / Math.PI / 2, Sl = 64, kl = [
            Sl,
            32,
            16
        ], Il = -Al, Ml = Al, Tl = [
            new _l([
                Il,
                Il,
                Il
            ], [
                Ml,
                Ml,
                Ml
            ]),
            new _l([
                Il,
                Il,
                Il
            ], [
                0,
                0,
                Ml
            ]),
            new _l([
                0,
                Il,
                Il
            ], [
                Ml,
                0,
                Ml
            ]),
            new _l([
                Il,
                0,
                Il
            ], [
                0,
                Ml,
                Ml
            ]),
            new _l([
                0,
                0,
                Il
            ], [
                Ml,
                Ml,
                Ml
            ])
        ];
        function zl(t1) {
            return t1 * Al / tu;
        }
        function Bl(t1, e1, r, n = !0) {
            const i = Ho([], t1._camera.position, t1.worldSize), s = [
                e1,
                r,
                1,
                1
            ];
            ul(s, s, t1.pixelMatrixInverse), ol(s, s, 1 / s[3]);
            const a = Jo([], il([], s, i)), o = t1.globeMatrix, l = [
                o[12],
                o[13],
                o[14]
            ], u = il([], l, i), c = qo(u), h = Jo([], u), p = t1.worldSize / (2 * Math.PI), f = Qo(h, a), d = Math.asin(p / c);
            if (d < Math.acos(f)) {
                if (!n) return null;
                const t1 = [], e1 = [];
                Ho(t1, a, c / f), Jo(e1, il(e1, t1, u)), Jo(a, Go(a, u, Ho(a, e1, Math.tan(d) * c)));
            }
            const y = [];
            new vl(i, a).closestPointOnSphere(l, p, y);
            const m = Jo([], Y(o, 0)), g = Jo([], Y(o, 1)), x = Jo([], Y(o, 2)), b = Qo(m, y), w = Qo(g, y), _ = Qo(x, y), A = v(Math.asin(-w / p));
            let k = v(Math.atan2(b, _));
            k = t1.center.lng + function(t1, e1) {
                const r = (e1 - t1 + 180) % 360 - 180;
                return r < -180 ? r + 360 : r;
            }(t1.center.lng, k);
            const I = iu(k), M = S(su(A), 0, 1);
            return new pu(I, M);
        }
        class El {
            constructor(t1, e1, r){
                this.a = il([], t1, r), this.b = il([], e1, r), this.center = r;
                const n = Jo([], this.a), i = Jo([], this.b);
                this.angle = Math.acos(Qo(n, i));
            }
        }
        function Cl(t1, e1) {
            if (0 === t1.angle) return null;
            let r;
            return r = 0 === t1.a[e1] ? 1 / t1.angle * .5 * Math.PI : 1 / t1.angle * Math.atan(t1.b[e1] / t1.a[e1] / Math.sin(t1.angle) - 1 / Math.tan(t1.angle)), r < 0 || r > 1 ? null : function(t1, e1, r, n) {
                const i = Math.sin(r);
                return t1 * (Math.sin((1 - n) * r) / i) + e1 * (Math.sin(n * r) / i);
            }(t1.a[e1], t1.b[e1], t1.angle, S(r, 0, 1)) + t1.center[e1];
        }
        function Pl(t1) {
            if (t1.z <= 1) return Tl[t1.z + 2 * t1.y + t1.x];
            const e1 = jl(Rl(t1));
            return _l.fromPoints(e1);
        }
        function Dl(t1, e1, r) {
            return Ho(t1, t1, 1 - r), Wo(t1, t1, e1, r);
        }
        function Vl(t1, e1) {
            const r = Kl(e1.zoom);
            if (0 === r) return Pl(t1);
            const n = Rl(t1), i = jl(n), s = iu(n.getWest()) * e1.worldSize, a = iu(n.getEast()) * e1.worldSize, o = su(n.getNorth()) * e1.worldSize, l = su(n.getSouth()) * e1.worldSize, u = [
                s,
                o,
                0
            ], c = [
                a,
                o,
                0
            ], h = [
                s,
                l,
                0
            ], p = [
                a,
                l,
                0
            ], f = Co([], e1.globeMatrix);
            return el(u, u, f), el(c, c, f), el(h, h, f), el(p, p, f), i[0] = Dl(i[0], h, r), i[1] = Dl(i[1], p, r), i[2] = Dl(i[2], c, r), i[3] = Dl(i[3], u, r), _l.fromPoints(i);
        }
        function Ll(t1, e1, r) {
            for (const n of t1)el(n, n, e1), Ho(n, n, r);
        }
        function Fl(t1, e1, r) {
            const n = e1 / t1.worldSize, i = t1.globeMatrix;
            if (r.z <= 1) {
                const t1 = Pl(r).getCorners();
                return Ll(t1, i, n), _l.fromPoints(t1);
            }
            const s = Rl(r), a = jl(s);
            Ll(a, i, n);
            const o = Number.MAX_VALUE, l = [
                -o,
                -o,
                -o
            ], u = [
                o,
                o,
                o
            ];
            if (s.contains(t1.center)) {
                for (const t1 of a)Ko(u, u, t1), Yo(l, l, t1);
                l[2] = 0;
                const e1 = t1.point, r = [
                    e1.x * n,
                    e1.y * n,
                    0
                ];
                return Ko(u, u, r), Yo(l, l, r), new _l(u, l);
            }
            const c = [
                i[12] * n,
                i[13] * n,
                i[14] * n
            ], h = s.getCenter(), p = S(t1.center.lat, -cu, cu), f = S(h.lat, -cu, cu), d = iu(t1.center.lng), y = su(p);
            let m = d - iu(h.lng);
            const g = y - su(f);
            m > .5 ? m -= 1 : m < -0.5 && (m += 1);
            let v = 0;
            Math.abs(m) > Math.abs(g) ? v = m >= 0 ? 1 : 3 : (v = g >= 0 ? 0 : 2, Wo(c, c, [
                i[4] * n,
                i[5] * n,
                i[6] * n
            ], -Math.sin(x(g >= 0 ? s.getSouth() : s.getNorth())) * Al));
            const b = a[v], w = a[(v + 1) % 4], _ = new El(b, w, c), A = [
                Cl(_, 0) || b[0],
                Cl(_, 1) || b[1],
                Cl(_, 2) || b[2]
            ], k = Kl(t1.zoom);
            if (k > 0) {
                const n = function({ x: t1, y: e1, z: r }, n, i, s, a) {
                    const o = 1 / (1 << r);
                    let l = t1 * o, u = l + o, c = e1 * o, h = c + o, p = 0;
                    const f = (l + u) / 2 - s;
                    return f > .5 ? p = -1 : f < -0.5 && (p = 1), l = ((l + p) * n - (s *= n)) * i + s, u = ((u + p) * n - s) * i + s, c = (c * n - (a *= n)) * i + a, h = (h * n - a) * i + a, [
                        [
                            l,
                            h,
                            0
                        ],
                        [
                            u,
                            h,
                            0
                        ],
                        [
                            u,
                            c,
                            0
                        ],
                        [
                            l,
                            c,
                            0
                        ]
                    ];
                }(r, e1, t1._pixelsPerMercatorPixel, d, y);
                for(let t1 = 0; t1 < a.length; t1++)Dl(a[t1], n[t1], k);
                const i = Go([], n[v], n[(v + 1) % 4]);
                Ho(i, i, .5), Dl(A, i, k);
            }
            for (const t1 of a)Ko(u, u, t1), Yo(l, l, t1);
            return u[2] = Math.min(b[2], w[2]), Ko(u, u, A), Yo(l, l, A), new _l(u, l);
        }
        function Rl({ x: t1, y: e1, z: r }) {
            const n = 1 / (1 << r), i = new ru(ou(t1 * n), lu((e1 + 1) * n)), s = new ru(ou((t1 + 1) * n), lu(e1 * n));
            return new Io(i, s);
        }
        function jl(t1) {
            const e1 = x(t1.getNorth()), r = x(t1.getSouth()), n = Math.cos(e1), i = Math.cos(r), s = Math.sin(e1), a = Math.sin(r), o = t1.getWest(), l = t1.getEast();
            return [
                Ul(i, a, o),
                Ul(i, a, l),
                Ul(n, s, l),
                Ul(n, s, o)
            ];
        }
        function Ul(t1, e1, r, n = Al) {
            return r = x(r), [
                t1 * Math.sin(r) * n,
                -e1 * n,
                t1 * Math.cos(r) * n
            ];
        }
        function $l(t1, e1, r) {
            return Ul(Math.cos(x(t1)), Math.sin(x(t1)), e1, r);
        }
        function Ol(t1, e1, r, n) {
            const i = 1 << r.z, s = (t1 / ko + r.x) / i;
            return $l(lu((e1 / ko + r.y) / i), ou(s), n);
        }
        function ql({ min: t1, max: e1 }) {
            return 16383 / Math.max(e1[0] - t1[0], e1[1] - t1[1], e1[2] - t1[2]);
        }
        const Nl = new Float64Array(16);
        function Gl(t1) {
            const e1 = ql(t1), r = Ro(Nl, [
                e1,
                e1,
                e1
            ]);
            var n, i;
            return Do(r, r, ((n = [])[0] = -(i = t1.min)[0], n[1] = -i[1], n[2] = -i[2], n));
        }
        function Xl(t1) {
            const e1 = (n = t1.min, (r = Nl)[0] = 1, r[1] = 0, r[2] = 0, r[3] = 0, r[4] = 0, r[5] = 1, r[6] = 0, r[7] = 0, r[8] = 0, r[9] = 0, r[10] = 1, r[11] = 0, r[12] = n[0], r[13] = n[1], r[14] = n[2], r[15] = 1, r);
            var r, n;
            const i = 1 / ql(t1);
            return Vo(e1, e1, [
                i,
                i,
                i
            ]);
        }
        function Zl(t1, e1, r, n, i) {
            const s = function(t1) {
                const e1 = ko / (2 * Math.PI);
                return t1 / (2 * Math.PI) / e1;
            }(r), a = [
                t1,
                e1,
                -r / (2 * Math.PI)
            ], o = Eo(new Float64Array(16));
            return Do(o, o, a), Vo(o, o, [
                s,
                s,
                s
            ]), Lo(o, o, x(-i)), Fo(o, o, x(-n)), o;
        }
        function Kl(t1) {
            return k(5, 6, t1);
        }
        function Yl(t1, e1) {
            const r = $l(e1.lat, e1.lng), n = function(t1) {
                const e1 = $l(t1._center.lat, t1._center.lng);
                let r = tl([], No(0, 1, 0), e1);
                const n = jo([], -t1.angle, e1);
                r = el(r, r, n), jo(n, -t1._pitch, r);
                const i = Jo([], e1);
                return Ho(i, i, zl(t1.cameraToCenterDistance / t1.pixelsPerMeter)), el(i, i, n), Go([], e1, i);
            }(t1);
            var i, s, a, o, l, u, c, h, p, f;
            return a = (i = Xo([], n, r))[0], o = i[1], l = i[2], u = (s = r)[0], c = s[1], h = s[2], f = (p = Math.sqrt(a * a + o * o + l * l) * Math.sqrt(u * u + c * c + h * h)) && Qo(i, s) / p, Math.acos(Math.min(Math.max(f, -1), 1));
        }
        function Hl(t1, e1) {
            return Yl(t1, e1) > Math.PI / 2 * 1.01;
        }
        const Wl = x(85), Jl = Math.cos(Wl), Ql = Math.sin(Wl), tu = 6371008.8, eu = 2 * Math.PI * tu;
        class ru {
            constructor(t1, e1){
                if (isNaN(t1) || isNaN(e1)) throw new Error(`Invalid LngLat object: (${t1}, ${e1})`);
                if (this.lng = +t1, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new ru(I(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t1) {
                const e1 = Math.PI / 180, r = this.lat * e1, n = t1.lat * e1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e1);
                return tu * Math.acos(Math.min(i, 1));
            }
            toBounds(t1 = 0) {
                const e1 = 360 * t1 / 40075017, r = e1 / Math.cos(Math.PI / 180 * this.lat);
                return new Io(new ru(this.lng - r, this.lat - e1), new ru(this.lng + r, this.lat + e1));
            }
            toEcef(t1) {
                const e1 = zl(t1);
                return $l(this.lat, this.lng, Al + e1);
            }
            static convert(t1) {
                if (t1 instanceof ru) return t1;
                if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new ru(Number(t1[0]), Number(t1[1]));
                if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new ru(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        function nu(t1) {
            return eu * Math.cos(t1 * Math.PI / 180);
        }
        function iu(t1) {
            return (180 + t1) / 360;
        }
        function su(t1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
        }
        function au(t1, e1) {
            return t1 / nu(e1);
        }
        function ou(t1) {
            return 360 * t1 - 180;
        }
        function lu(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        function uu(t1, e1) {
            return t1 * nu(lu(e1));
        }
        const cu = 85.051129;
        function hu(t1) {
            return 1 / Math.cos(t1 * Math.PI / 180);
        }
        class pu {
            constructor(t1, e1, r = 0){
                this.x = +t1, this.y = +e1, this.z = +r;
            }
            static fromLngLat(t1, e1 = 0) {
                const r = ru.convert(t1);
                return new pu(iu(r.lng), su(r.lat), au(e1, r.lat));
            }
            toLngLat() {
                return new ru(ou(this.x), lu(this.y));
            }
            toAltitude() {
                return uu(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / eu * hu(lu(this.y));
            }
        }
        function fu(t1, e1, r, n, i, s, a, o, l) {
            const u = (e1 + n) / 2, c = (r + i) / 2, h = new d(u, c);
            o(h), function(t1, e1, r, n, i, s) {
                const a = r - i, o = n - s;
                return Math.abs((n - e1) * a - (r - t1) * o) / Math.hypot(a, o);
            }(h.x, h.y, s.x, s.y, a.x, a.y) >= l ? (fu(t1, e1, r, u, c, s, h, o, l), fu(t1, u, c, n, i, h, a, o, l)) : t1.push(a);
        }
        function du(t1, e1, r) {
            let n = t1[0], i = n.x, s = n.y;
            e1(n);
            const a = [
                n
            ];
            for(let o = 1; o < t1.length; o++){
                const l = t1[o], { x: u, y: c } = l;
                e1(l), fu(a, i, s, u, c, n, l, e1, r), i = u, s = c, n = l;
            }
            return a;
        }
        function yu(t1, e1, r, n) {
            if (n(e1, r)) {
                const i = e1.add(r)._mult(.5);
                yu(t1, e1, i, n), yu(t1, i, r, n);
            } else t1.push(r);
        }
        function mu(t1, e1) {
            let r = t1[0];
            const n = [
                r
            ];
            for(let i = 1; i < t1.length; i++){
                const s = t1[i];
                yu(n, r, s, e1), r = s;
            }
            return n;
        }
        const gu = Math.pow(2, 14) - 1, xu = -gu - 1;
        function vu(t1, e1) {
            const r = Math.round(t1.x * e1), n = Math.round(t1.y * e1);
            return t1.x = S(r, xu, gu), t1.y = S(n, xu, gu), (r < t1.x || r > t1.x + 1 || n < t1.y || n > t1.y + 1) && $("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t1;
        }
        function bu(t1, e1, r) {
            const n = t1.loadGeometry(), i = t1.extent, s = ko / i;
            if (e1 && r && r.projection.isReprojectedInTileSpace) {
                const s = 1 << e1.z, { scale: a, x: o, y: l, projection: u } = r, c = (t1)=>{
                    const r = ou((e1.x + t1.x / i) / s), n = lu((e1.y + t1.y / i) / s), c = u.project(r, n);
                    t1.x = (c.x * a - o) * i, t1.y = (c.y * a - l) * i;
                };
                for(let e1 = 0; e1 < n.length; e1++)if (1 !== t1.type) n[e1] = du(n[e1], c, 1);
                else {
                    const t1 = [];
                    for (const r of n[e1])r.x < 0 || r.x >= i || r.y < 0 || r.y >= i || (c(r), t1.push(r));
                    n[e1] = t1;
                }
            }
            for (const t1 of n)for (const e1 of t1)vu(e1, s);
            return n;
        }
        function wu(t1, e1) {
            return {
                type: t1.type,
                id: t1.id,
                properties: t1.properties,
                geometry: e1 ? bu(t1) : []
            };
        }
        function _u(t1, e1, r, n, i) {
            t1.emplaceBack(2 * e1 + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        function Au(t1, e1, r) {
            const n = 16384;
            t1.emplaceBack(e1.x, e1.y, e1.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class Su {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.projection = t1.projection, this.layoutVertexArray = new sa, this.indexArray = new wa, this.segments = new So, this.programConfigurations = new fo(t1.layers, t1.zoom), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
            populate(t1, e1, r, n) {
                const i = this.layers[0], s = [];
                let a = null;
                "circle" === i.type && (a = i.layout.get("circle-sort-key"));
                for (const { feature: e1, id: i, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = wu(e1, t1);
                    if (!this.layers[0]._featureFilter.filter(new Us(this.zoom), u, r)) continue;
                    const c = a ? a.evaluate(u, {}, r) : void 0, h = {
                        id: i,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : bu(e1, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                a && s.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                let o = null;
                "globe" === n.projection.name && (this.globeExtVertexArray = new pa, o = n.projection);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n, l = t1[s].feature;
                    this.addFeature(n, i, s, e1.availableImages, r, o), e1.featureIndex.insert(l, i, s, a, this.index);
                }
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, _o.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, Ao.members))), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
            }
            addFeature(t1, e1, r, n, i, s) {
                for (const r of e1)for (const e1 of r){
                    const r = e1.x, n = e1.y;
                    if (r < 0 || r >= ko || n < 0 || n >= ko) continue;
                    if (s) {
                        const t1 = s.projectTilePoint(r, n, i), e1 = s.upVector(i, r, n), a = this.globeExtVertexArray;
                        Au(a, t1, e1), Au(a, t1, e1), Au(a, t1, e1), Au(a, t1, e1);
                    }
                    const a = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), o = a.vertexLength;
                    _u(this.layoutVertexArray, r, n, -1, -1), _u(this.layoutVertexArray, r, n, 1, -1), _u(this.layoutVertexArray, r, n, 1, 1), _u(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(o, o + 1, o + 2), this.indexArray.emplaceBack(o, o + 2, o + 3), a.vertexLength += 4, a.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n, i);
            }
        }
        function ku(t1, e1) {
            for(let r = 0; r < t1.length; r++)if (Du(e1, t1[r])) return !0;
            for(let r = 0; r < e1.length; r++)if (Du(t1, e1[r])) return !0;
            return !!zu(t1, e1);
        }
        function Iu(t1, e1, r) {
            return !!Du(t1, e1) || !!Eu(e1, t1, r);
        }
        function Mu(t1, e1) {
            if (1 === t1.length) return Pu(e1, t1[0]);
            for(let r = 0; r < e1.length; r++){
                const n = e1[r];
                for(let e1 = 0; e1 < n.length; e1++)if (Du(t1, n[e1])) return !0;
            }
            for(let r = 0; r < t1.length; r++)if (Pu(e1, t1[r])) return !0;
            for(let r = 0; r < e1.length; r++)if (zu(t1, e1[r])) return !0;
            return !1;
        }
        function Tu(t1, e1, r) {
            if (t1.length > 1) {
                if (zu(t1, e1)) return !0;
                for(let n = 0; n < e1.length; n++)if (Eu(e1[n], t1, r)) return !0;
            }
            for(let n = 0; n < t1.length; n++)if (Eu(t1[n], e1, r)) return !0;
            return !1;
        }
        function zu(t1, e1) {
            if (0 === t1.length || 0 === e1.length) return !1;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1];
                for(let t1 = 0; t1 < e1.length - 1; t1++)if (Bu(n, i, e1[t1], e1[t1 + 1])) return !0;
            }
            return !1;
        }
        function Bu(t1, e1, r, n) {
            return O(t1, r, n) !== O(e1, r, n) && O(t1, e1, r) !== O(t1, e1, n);
        }
        function Eu(t1, e1, r) {
            const n = r * r;
            if (1 === e1.length) return t1.distSqr(e1[0]) < n;
            for(let r = 1; r < e1.length; r++)if (Cu(t1, e1[r - 1], e1[r]) < n) return !0;
            return !1;
        }
        function Cu(t1, e1, r) {
            const n = e1.distSqr(r);
            if (0 === n) return t1.distSqr(e1);
            const i = ((t1.x - e1.x) * (r.x - e1.x) + (t1.y - e1.y) * (r.y - e1.y)) / n;
            return t1.distSqr(i < 0 ? e1 : i > 1 ? r : r.sub(e1)._mult(i)._add(e1));
        }
        function Pu(t1, e1) {
            let r, n, i, s = !1;
            for(let a = 0; a < t1.length; a++){
                r = t1[a];
                for(let t1 = 0, a = r.length - 1; t1 < r.length; a = t1++)n = r[t1], i = r[a], n.y > e1.y != i.y > e1.y && e1.x < (i.x - n.x) * (e1.y - n.y) / (i.y - n.y) + n.x && (s = !s);
            }
            return s;
        }
        function Du(t1, e1) {
            let r = !1;
            for(let n = 0, i = t1.length - 1; n < t1.length; i = n++){
                const s = t1[n], a = t1[i];
                s.y > e1.y != a.y > e1.y && e1.x < (a.x - s.x) * (e1.y - s.y) / (a.y - s.y) + s.x && (r = !r);
            }
            return r;
        }
        function Vu(t1, e1, r, n, i) {
            for (const s of t1)if (e1 <= s.x && r <= s.y && n >= s.x && i >= s.y) return !0;
            const s = [
                new d(e1, r),
                new d(e1, i),
                new d(n, i),
                new d(n, r)
            ];
            if (t1.length > 2) {
                for (const e1 of s)if (Du(t1, e1)) return !0;
            }
            for(let e1 = 0; e1 < t1.length - 1; e1++)if (Lu(t1[e1], t1[e1 + 1], s)) return !0;
            return !1;
        }
        function Lu(t1, e1, r) {
            const n = r[0], i = r[2];
            if (t1.x < n.x && e1.x < n.x || t1.x > i.x && e1.x > i.x || t1.y < n.y && e1.y < n.y || t1.y > i.y && e1.y > i.y) return !1;
            const s = O(t1, e1, r[0]);
            return s !== O(t1, e1, r[1]) || s !== O(t1, e1, r[2]) || s !== O(t1, e1, r[3]);
        }
        function Fu(t1, e1, r) {
            const n = e1.paint.get(t1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e1.id).getMaxValue(t1);
        }
        function Ru(t1) {
            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
        }
        function ju(t1, e1, r, n, i) {
            if (!e1[0] && !e1[1]) return t1;
            const s = d.convert(e1)._mult(i);
            "viewport" === r && s._rotate(-n);
            const a = [];
            for(let e1 = 0; e1 < t1.length; e1++)a.push(t1[e1].sub(s));
            return a;
        }
        function Uu(t1, e1, r, n) {
            const i = d.convert(t1)._mult(n);
            return "viewport" === e1 && i._rotate(-r), i;
        }
        Oi(Su, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        const $u = new Js({
            "circle-sort-key": new Hs(Ht.layout_circle["circle-sort-key"])
        });
        var Ou = {
            paint: new Js({
                "circle-radius": new Hs(Ht.paint_circle["circle-radius"]),
                "circle-color": new Hs(Ht.paint_circle["circle-color"]),
                "circle-blur": new Hs(Ht.paint_circle["circle-blur"]),
                "circle-opacity": new Hs(Ht.paint_circle["circle-opacity"]),
                "circle-translate": new Ys(Ht.paint_circle["circle-translate"]),
                "circle-translate-anchor": new Ys(Ht.paint_circle["circle-translate-anchor"]),
                "circle-pitch-scale": new Ys(Ht.paint_circle["circle-pitch-scale"]),
                "circle-pitch-alignment": new Ys(Ht.paint_circle["circle-pitch-alignment"]),
                "circle-stroke-width": new Hs(Ht.paint_circle["circle-stroke-width"]),
                "circle-stroke-color": new Hs(Ht.paint_circle["circle-stroke-color"]),
                "circle-stroke-opacity": new Hs(Ht.paint_circle["circle-stroke-opacity"])
            }),
            layout: $u
        };
        function qu(t1, e1, r, n, i, s, a, o, l) {
            if (s && t1.queryGeometry.isAboveHorizon) return !1;
            s && (l *= t1.pixelToTileUnitsFactor);
            const u = t1.tileID.canonical, c = r.projection.upVectorScale(u, r.center.lat, r.worldSize).metersToTile;
            for (const h of e1)for (const e1 of h){
                const h = e1.add(o), p = i && r.elevation ? r.elevation.exaggeration() * i.getElevationAt(h.x, h.y, !0) : 0, f = r.projection.projectTilePoint(h.x, h.y, u);
                if (p > 0) {
                    const t1 = r.projection.upVector(u, h.x, h.y);
                    f.x += t1[0] * c * p, f.y += t1[1] * c * p, f.z += t1[2] * c * p;
                }
                const d = s ? h : Nu(f.x, f.y, f.z, n), y = s ? t1.tilespaceRays.map((t1)=>Zu(t1, p)) : t1.queryGeometry.screenGeometry, m = ul([], [
                    f.x,
                    f.y,
                    f.z,
                    1
                ], n);
                if (!a && s ? l *= m[3] / r.cameraToCenterDistance : a && !s && (l *= r.cameraToCenterDistance / m[3]), s) {
                    const t1 = lu((e1.y / ko + u.y) / (1 << u.z));
                    l /= r.projection.pixelsPerMeter(t1, 1) / au(1, t1);
                }
                if (Iu(y, d, l)) return !0;
            }
            return !1;
        }
        function Nu(t1, e1, r, n) {
            const i = ul([], [
                t1,
                e1,
                r,
                1
            ], n);
            return new d(i[0] / i[3], i[1] / i[3]);
        }
        const Gu = No(0, 0, 0), Xu = No(0, 0, 1);
        function Zu(t1, e1) {
            const r = $o();
            return Gu[2] = e1, t1.intersectsPlane(Gu, Xu, r), new d(r[0], r[1]);
        }
        class Ku extends Su {
        }
        function Yu(t1, { width: e1, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e1 * r * n) throw new RangeError("mismatched image size");
            } else i = new Uint8Array(e1 * r * n);
            return t1.width = e1, t1.height = r, t1.data = i, t1;
        }
        function Hu(t1, e1, r) {
            const { width: n, height: i } = e1;
            n === t1.width && i === t1.height || (Wu(t1, e1, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t1.width, n),
                height: Math.min(t1.height, i)
            }, r), t1.width = n, t1.height = i, t1.data = e1.data);
        }
        function Wu(t1, e1, r, n, i, s) {
            if (0 === i.width || 0 === i.height) return e1;
            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const a = t1.data, o = e1.data;
            for(let l = 0; l < i.height; l++){
                const u = ((r.y + l) * t1.width + r.x) * s, c = ((n.y + l) * e1.width + n.x) * s;
                for(let t1 = 0; t1 < i.width * s; t1++)o[c + t1] = a[u + t1];
            }
            return e1;
        }
        Oi(Ku, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class Ju {
            constructor(t1, e1){
                Yu(this, t1, 1, e1);
            }
            resize(t1) {
                Hu(this, new Ju(t1), 1);
            }
            clone() {
                return new Ju({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e1, r, n, i) {
                Wu(t1, e1, r, n, i, 1);
            }
        }
        class Qu {
            constructor(t1, e1){
                Yu(this, t1, 4, e1);
            }
            resize(t1) {
                Hu(this, new Qu(t1), 4);
            }
            replace(t1, e1) {
                e1 ? this.data.set(t1) : this.data = t1 instanceof Uint8ClampedArray ? new Uint8Array(t1.buffer) : t1;
            }
            clone() {
                return new Qu({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e1, r, n, i) {
                Wu(t1, e1, r, n, i, 4);
            }
        }
        Oi(Ju, "AlphaImage"), Oi(Qu, "RGBAImage");
        var tc = {
            paint: new Js({
                "heatmap-radius": new Hs(Ht.paint_heatmap["heatmap-radius"]),
                "heatmap-weight": new Hs(Ht.paint_heatmap["heatmap-weight"]),
                "heatmap-intensity": new Ys(Ht.paint_heatmap["heatmap-intensity"]),
                "heatmap-color": new Ws(Ht.paint_heatmap["heatmap-color"]),
                "heatmap-opacity": new Ys(Ht.paint_heatmap["heatmap-opacity"])
            })
        };
        function ec(t1) {
            const e1 = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new Qu({
                width: r,
                height: n
            }), s = (r, n, s)=>{
                e1[t1.evaluationKey] = s;
                const a = t1.expression.evaluate(e1);
                i.data[r + n + 0] = Math.floor(255 * a.r / a.a), i.data[r + n + 1] = Math.floor(255 * a.g / a.a), i.data[r + n + 2] = Math.floor(255 * a.b / a.a), i.data[r + n + 3] = Math.floor(255 * a.a);
            };
            if (t1.clips) for(let e1 = 0, i = 0; e1 < n; ++e1, i += 4 * r)for(let n = 0, a = 0; n < r; n++, a += 4){
                const o = n / (r - 1), { start: l, end: u } = t1.clips[e1];
                s(i, a, l * (1 - o) + u * o);
            }
            else for(let t1 = 0, e1 = 0; t1 < r; t1++, e1 += 4)s(0, e1, t1 / (r - 1));
            return i;
        }
        var rc = {
            paint: new Js({
                "hillshade-illumination-direction": new Ys(Ht.paint_hillshade["hillshade-illumination-direction"]),
                "hillshade-illumination-anchor": new Ys(Ht.paint_hillshade["hillshade-illumination-anchor"]),
                "hillshade-exaggeration": new Ys(Ht.paint_hillshade["hillshade-exaggeration"]),
                "hillshade-shadow-color": new Ys(Ht.paint_hillshade["hillshade-shadow-color"]),
                "hillshade-highlight-color": new Ys(Ht.paint_hillshade["hillshade-highlight-color"]),
                "hillshade-accent-color": new Ys(Ht.paint_hillshade["hillshade-accent-color"])
            })
        };
        const nc = na([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: ic } = nc;
        var sc = {};
        function ac(t1, e1, r) {
            r = r || 2;
            var n, i, s, a, o, l, u, c = e1 && e1.length, h = c ? e1[0] * r : t1.length, p = oc(t1, 0, h, r, !0), f = [];
            if (!p || p.next === p.prev) return f;
            if (c && (p = function(t1, e1, r, n) {
                var i, s, a, o = [];
                for(i = 0, s = e1.length; i < s; i++)(a = oc(t1, e1[i] * n, i < s - 1 ? e1[i + 1] * n : t1.length, n, !1)) === a.next && (a.steiner = !0), o.push(xc(a));
                for(o.sort(dc), i = 0; i < o.length; i++)r = yc(o[i], r);
                return r;
            }(t1, e1, p, r)), t1.length > 80 * r) {
                n = s = t1[0], i = a = t1[1];
                for(var d = r; d < h; d += r)(o = t1[d]) < n && (n = o), (l = t1[d + 1]) < i && (i = l), o > s && (s = o), l > a && (a = l);
                u = 0 !== (u = Math.max(s - n, a - i)) ? 32767 / u : 0;
            }
            return uc(p, f, r, n, i, u, 0), f;
        }
        function oc(t1, e1, r, n, i) {
            var s, a;
            if (i === Ec(t1, e1, r, n) > 0) for(s = e1; s < r; s += n)a = Tc(s, t1[s], t1[s + 1], a);
            else for(s = r - n; s >= e1; s -= n)a = Tc(s, t1[s], t1[s + 1], a);
            return a && _c(a, a.next) && (zc(a), a = a.next), a;
        }
        function lc(t1, e1) {
            if (!t1) return t1;
            e1 || (e1 = t1);
            var r, n = t1;
            do if (r = !1, n.steiner || !_c(n, n.next) && 0 !== wc(n.prev, n, n.next)) n = n.next;
            else {
                if (zc(n), (n = e1 = n.prev) === n.next) break;
                r = !0;
            }
            while (r || n !== e1);
            return e1;
        }
        function uc(t1, e1, r, n, i, s, a) {
            if (t1) {
                !a && s && function(t1, e1, r, n) {
                    var i = t1;
                    do 0 === i.z && (i.z = gc(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                    while (i !== t1);
                    i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                        var e1, r, n, i, s, a, o, l, u = 1;
                        do {
                            for(r = t1, t1 = null, s = null, a = 0; r;){
                                for(a++, n = r, o = 0, e1 = 0; e1 < u && (o++, n = n.nextZ); e1++);
                                for(l = u; o > 0 || l > 0 && n;)0 !== o && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, o--) : (i = n, n = n.nextZ, l--), s ? s.nextZ = i : t1 = i, i.prevZ = s, s = i;
                                r = n;
                            }
                            s.nextZ = null, u *= 2;
                        }while (a > 1);
                    }(i);
                }(t1, n, i, s);
                for(var o, l, u = t1; t1.prev !== t1.next;)if (o = t1.prev, l = t1.next, s ? hc(t1, n, i, s) : cc(t1)) e1.push(o.i / r | 0), e1.push(t1.i / r | 0), e1.push(l.i / r | 0), zc(t1), t1 = l.next, u = l.next;
                else if ((t1 = l) === u) {
                    a ? 1 === a ? uc(t1 = pc(lc(t1), e1, r), e1, r, n, i, s, 2) : 2 === a && fc(t1, e1, r, n, i, s) : uc(lc(t1), e1, r, n, i, s, 1);
                    break;
                }
            }
        }
        function cc(t1) {
            var e1 = t1.prev, r = t1, n = t1.next;
            if (wc(e1, r, n) >= 0) return !1;
            for(var i = e1.x, s = r.x, a = n.x, o = e1.y, l = r.y, u = n.y, c = i < s ? i < a ? i : a : s < a ? s : a, h = o < l ? o < u ? o : u : l < u ? l : u, p = i > s ? i > a ? i : a : s > a ? s : a, f = o > l ? o > u ? o : u : l > u ? l : u, d = n.next; d !== e1;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && vc(i, o, s, l, a, u, d.x, d.y) && wc(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function hc(t1, e1, r, n) {
            var i = t1.prev, s = t1, a = t1.next;
            if (wc(i, s, a) >= 0) return !1;
            for(var o = i.x, l = s.x, u = a.x, c = i.y, h = s.y, p = a.y, f = o < l ? o < u ? o : u : l < u ? l : u, d = c < h ? c < p ? c : p : h < p ? h : p, y = o > l ? o > u ? o : u : l > u ? l : u, m = c > h ? c > p ? c : p : h > p ? h : p, g = gc(f, d, e1, r, n), x = gc(y, m, e1, r, n), v = t1.prevZ, b = t1.nextZ; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== a && vc(o, c, l, h, u, p, v.x, v.y) && wc(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== a && vc(o, c, l, h, u, p, b.x, b.y) && wc(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== a && vc(o, c, l, h, u, p, v.x, v.y) && wc(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== a && vc(o, c, l, h, u, p, b.x, b.y) && wc(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function pc(t1, e1, r) {
            var n = t1;
            do {
                var i = n.prev, s = n.next.next;
                !_c(i, s) && Ac(i, n, n.next, s) && Ic(i, s) && Ic(s, i) && (e1.push(i.i / r | 0), e1.push(n.i / r | 0), e1.push(s.i / r | 0), zc(n), zc(n.next), n = t1 = s), n = n.next;
            }while (n !== t1);
            return lc(n);
        }
        function fc(t1, e1, r, n, i, s) {
            var a = t1;
            do {
                for(var o = a.next.next; o !== a.prev;){
                    if (a.i !== o.i && bc(a, o)) {
                        var l = Mc(a, o);
                        return a = lc(a, a.next), l = lc(l, l.next), uc(a, e1, r, n, i, s, 0), void uc(l, e1, r, n, i, s, 0);
                    }
                    o = o.next;
                }
                a = a.next;
            }while (a !== t1);
        }
        function dc(t1, e1) {
            return t1.x - e1.x;
        }
        function yc(t1, e1) {
            var r = function(t1, e1) {
                var r, n = e1, i = t1.x, s = t1.y, a = -1 / 0;
                do {
                    if (s <= n.y && s >= n.next.y && n.next.y !== n.y) {
                        var o = n.x + (s - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (o <= i && o > a && (a = o, r = n.x < n.next.x ? n : n.next, o === i)) return r;
                    }
                    n = n.next;
                }while (n !== e1);
                if (!r) return null;
                var l, u = r, c = r.x, h = r.y, p = 1 / 0;
                n = r;
                do i >= n.x && n.x >= c && i !== n.x && vc(s < h ? i : a, s, c, h, s < h ? a : i, s, n.x, n.y) && (l = Math.abs(s - n.y) / (i - n.x), Ic(n, t1) && (l < p || l === p && (n.x > r.x || n.x === r.x && mc(r, n))) && (r = n, p = l)), n = n.next;
                while (n !== u);
                return r;
            }(t1, e1);
            if (!r) return e1;
            var n = Mc(r, t1);
            return lc(n, n.next), lc(r, r.next);
        }
        function mc(t1, e1) {
            return wc(t1.prev, t1, e1.prev) < 0 && wc(e1.next, t1, t1.next) < 0;
        }
        function gc(t1, e1, r, n, i) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - r) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - n) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
        }
        function xc(t1) {
            var e1 = t1, r = t1;
            do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
            while (e1 !== t1);
            return r;
        }
        function vc(t1, e1, r, n, i, s, a, o) {
            return (i - a) * (e1 - o) >= (t1 - a) * (s - o) && (t1 - a) * (n - o) >= (r - a) * (e1 - o) && (r - a) * (s - o) >= (i - a) * (n - o);
        }
        function bc(t1, e1) {
            return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                var r = t1;
                do {
                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && Ac(r, r.next, t1, e1)) return !0;
                    r = r.next;
                }while (r !== t1);
                return !1;
            }(t1, e1) && (Ic(t1, e1) && Ic(e1, t1) && function(t1, e1) {
                var r = t1, n = !1, i = (t1.x + e1.x) / 2, s = (t1.y + e1.y) / 2;
                do r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t1);
                return n;
            }(t1, e1) && (wc(t1.prev, t1, e1.prev) || wc(t1, e1.prev, e1)) || _c(t1, e1) && wc(t1.prev, t1, t1.next) > 0 && wc(e1.prev, e1, e1.next) > 0);
        }
        function wc(t1, e1, r) {
            return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
        }
        function _c(t1, e1) {
            return t1.x === e1.x && t1.y === e1.y;
        }
        function Ac(t1, e1, r, n) {
            var i = kc(wc(t1, e1, r)), s = kc(wc(t1, e1, n)), a = kc(wc(r, n, t1)), o = kc(wc(r, n, e1));
            return i !== s && a !== o || !(0 !== i || !Sc(t1, r, e1)) || !(0 !== s || !Sc(t1, n, e1)) || !(0 !== a || !Sc(r, t1, n)) || !(0 !== o || !Sc(r, e1, n));
        }
        function Sc(t1, e1, r) {
            return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
        }
        function kc(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function Ic(t1, e1) {
            return wc(t1.prev, t1, t1.next) < 0 ? wc(t1, e1, t1.next) >= 0 && wc(t1, t1.prev, e1) >= 0 : wc(t1, e1, t1.prev) < 0 || wc(t1, t1.next, e1) < 0;
        }
        function Mc(t1, e1) {
            var r = new Bc(t1.i, t1.x, t1.y), n = new Bc(e1.i, e1.x, e1.y), i = t1.next, s = e1.prev;
            return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
        }
        function Tc(t1, e1, r, n) {
            var i = new Bc(t1, e1, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function zc(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function Bc(t1, e1, r) {
            this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function Ec(t1, e1, r, n) {
            for(var i = 0, s = e1, a = r - n; s < r; s += n)i += (t1[a] - t1[s]) * (t1[s + 1] + t1[a + 1]), a = s;
            return i;
        }
        function Cc(t1, e1, r, n, i) {
            Pc(t1, e1, r || 0, n || t1.length - 1, i || Vc);
        }
        function Pc(t1, e1, r, n, i) {
            for(; n > r;){
                if (n - r > 600) {
                    var s = n - r + 1, a = e1 - r + 1, o = Math.log(s), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (s - l) / s) * (a - s / 2 < 0 ? -1 : 1);
                    Pc(t1, e1, Math.max(r, Math.floor(e1 - a * l / s + u)), Math.min(n, Math.floor(e1 + (s - a) * l / s + u)), i);
                }
                var c = t1[e1], h = r, p = n;
                for(Dc(t1, r, e1), i(t1[n], c) > 0 && Dc(t1, r, n); h < p;){
                    for(Dc(t1, h, p), h++, p--; i(t1[h], c) < 0;)h++;
                    for(; i(t1[p], c) > 0;)p--;
                }
                0 === i(t1[r], c) ? Dc(t1, r, p) : Dc(t1, ++p, n), p <= e1 && (r = p + 1), e1 <= p && (n = p - 1);
            }
        }
        function Dc(t1, e1, r) {
            var n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        function Vc(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function Lc(t1, e1) {
            const r = t1.length;
            if (r <= 1) return [
                t1
            ];
            const n = [];
            let i, s;
            for(let e1 = 0; e1 < r; e1++){
                const r = q(t1[e1]);
                0 !== r && (t1[e1].area = Math.abs(r), void 0 === s && (s = r < 0), s === r < 0 ? (i && n.push(i), i = [
                    t1[e1]
                ]) : i.push(t1[e1]));
            }
            if (i && n.push(i), e1 > 1) for(let t1 = 0; t1 < n.length; t1++)n[t1].length <= e1 || (Cc(n[t1], e1, 1, n[t1].length - 1, Fc), n[t1] = n[t1].slice(0, e1));
            return n;
        }
        function Fc(t1, e1) {
            return e1.area - t1.area;
        }
        function Rc(t1, e1, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of e1){
                const e1 = r.paint.get(`${t1}-pattern`);
                e1.isConstant() || (i = !0);
                const s = e1.constantOr(null);
                s && (i = !0, n[s] = !0);
            }
            return i;
        }
        function jc(t1, e1, r, n, i) {
            const s = i.patternDependencies;
            for (const a of e1){
                const e1 = a.paint.get(`${t1}-pattern`).value;
                if ("constant" !== e1.kind) {
                    let t1 = e1.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages);
                    t1 = t1 && t1.name ? t1.name : t1, s[t1] = !0, r.patterns[a.id] = t1;
                }
            }
            return r;
        }
        ({
            get exports () {
                return sc;
            },
            set exports (t){
                sc = t;
            }
        }).exports = ac, sc.default = ac, ac.deviation = function(t1, e1, r, n) {
            var i = e1 && e1.length, s = Math.abs(Ec(t1, 0, i ? e1[0] * r : t1.length, r));
            if (i) for(var a = 0, o = e1.length; a < o; a++)s -= Math.abs(Ec(t1, e1[a] * r, a < o - 1 ? e1[a + 1] * r : t1.length, r));
            var l = 0;
            for(a = 0; a < n.length; a += 3){
                var u = n[a] * r, c = n[a + 1] * r, h = n[a + 2] * r;
                l += Math.abs((t1[u] - t1[h]) * (t1[c + 1] - t1[u + 1]) - (t1[u] - t1[c]) * (t1[h + 1] - t1[u + 1]));
            }
            return 0 === s && 0 === l ? 0 : Math.abs((l - s) / s);
        }, ac.flatten = function(t1) {
            for(var e1 = t1[0][0].length, r = {
                vertices: [],
                holes: [],
                dimensions: e1
            }, n = 0, i = 0; i < t1.length; i++){
                for(var s = 0; s < t1[i].length; s++)for(var a = 0; a < e1; a++)r.vertices.push(t1[i][s][a]);
                i > 0 && r.holes.push(n += t1[i - 1].length);
            }
            return r;
        };
        class Uc {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new sa, this.indexArray = new wa, this.indexArray2 = new Ma, this.programConfigurations = new fo(t1.layers, t1.zoom), this.segments = new So, this.segments2 = new So, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.projection = t1.projection;
            }
            populate(t1, e1, r, n) {
                this.hasPattern = Rc("fill", this.layers, e1);
                const i = this.layers[0].layout.get("fill-sort-key"), s = [];
                for (const { feature: a, id: o, index: l, sourceLayerIndex: u } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, c = wu(a, t1);
                    if (!this.layers[0]._featureFilter.filter(new Us(this.zoom), c, r)) continue;
                    const h = i ? i.evaluate(c, {}, r, e1.availableImages) : void 0, p = {
                        id: o,
                        properties: a.properties,
                        type: a.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t1 ? c.geometry : bu(a, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                i && s.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const t1 = jc("fill", this.layers, n, this.zoom, e1);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, s, r, {}, e1.availableImages);
                    e1.featureIndex.insert(t1[s].feature, i, s, a, this.index);
                }
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r, n);
            }
            addFeatures(t1, e1, r, n, i) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, ic), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t1, e1, r, n, i, s = []) {
                for (const t1 of Lc(e1, 500)){
                    let e1 = 0;
                    for (const r of t1)e1 += r.length;
                    const r = this.segments.prepareSegment(e1, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], s = [];
                    for (const e1 of t1){
                        if (0 === e1.length) continue;
                        e1 !== t1[0] && s.push(i.length / 2);
                        const r = this.segments2.prepareSegment(e1.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                        this.layoutVertexArray.emplaceBack(e1[0].x, e1[0].y), this.indexArray2.emplaceBack(n + e1.length - 1, n), i.push(e1[0].x), i.push(e1[0].y);
                        for(let t1 = 1; t1 < e1.length; t1++)this.layoutVertexArray.emplaceBack(e1[t1].x, e1[t1].y), this.indexArray2.emplaceBack(n + t1 - 1, n + t1), i.push(e1[t1].x), i.push(e1[t1].y);
                        r.vertexLength += e1.length, r.primitiveLength += e1.length;
                    }
                    const a = sc(i, s);
                    for(let t1 = 0; t1 < a.length; t1 += 3)this.indexArray.emplaceBack(n + a[t1], n + a[t1 + 1], n + a[t1 + 2]);
                    r.vertexLength += e1, r.primitiveLength += a.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n);
            }
        }
        Oi(Uc, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const $c = new Js({
            "fill-sort-key": new Hs(Ht.layout_fill["fill-sort-key"])
        });
        var Oc = {
            paint: new Js({
                "fill-antialias": new Ys(Ht.paint_fill["fill-antialias"]),
                "fill-opacity": new Hs(Ht.paint_fill["fill-opacity"]),
                "fill-color": new Hs(Ht.paint_fill["fill-color"]),
                "fill-outline-color": new Hs(Ht.paint_fill["fill-outline-color"]),
                "fill-translate": new Ys(Ht.paint_fill["fill-translate"]),
                "fill-translate-anchor": new Ys(Ht.paint_fill["fill-translate-anchor"]),
                "fill-pattern": new Hs(Ht.paint_fill["fill-pattern"])
            }),
            layout: $c
        };
        const qc = na([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), Nc = na([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), Gc = na([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: Xc } = qc;
        var Zc = {}, Kc = d, Yc = Hc;
        function Hc(t1, e1, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = n, this._values = i, t1.readFields(Wc, this, e1);
        }
        function Wc(t1, e1, r) {
            1 == t1 ? e1.id = r.readVarint() : 2 == t1 ? function(t1, e1) {
                for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = e1._keys[t1.readVarint()], i = e1._values[t1.readVarint()];
                    e1.properties[n] = i;
                }
            }(r, e1) : 3 == t1 ? e1.type = r.readVarint() : 4 == t1 && (e1._geometry = r.pos);
        }
        function Jc(t1) {
            for(var e1, r, n = 0, i = 0, s = t1.length, a = s - 1; i < s; a = i++)n += ((r = t1[a]).x - (e1 = t1[i]).x) * (e1.y + r.y);
            return n;
        }
        Hc.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], Hc.prototype.loadGeometry = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1, r = t1.readVarint() + t1.pos, n = 1, i = 0, s = 0, a = 0, o = []; t1.pos < r;){
                if (i <= 0) {
                    var l = t1.readVarint();
                    n = 7 & l, i = l >> 3;
                }
                if (i--, 1 === n || 2 === n) s += t1.readSVarint(), a += t1.readSVarint(), 1 === n && (e1 && o.push(e1), e1 = []), e1.push(new Kc(s, a));
                else {
                    if (7 !== n) throw new Error("unknown command " + n);
                    e1 && e1.push(e1[0].clone());
                }
            }
            return e1 && o.push(e1), o;
        }, Hc.prototype.bbox = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1 = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, s = 0, a = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t1.pos < e1;){
                if (n <= 0) {
                    var c = t1.readVarint();
                    r = 7 & c, n = c >> 3;
                }
                if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < a && (a = i), i > o && (o = i), (s += t1.readSVarint()) < l && (l = s), s > u && (u = s);
                else if (7 !== r) throw new Error("unknown command " + r);
            }
            return [
                a,
                l,
                o,
                u
            ];
        }, Hc.prototype.toGeoJSON = function(t1, e1, r) {
            var n, i, s = this.extent * Math.pow(2, r), a = this.extent * t1, o = this.extent * e1, l = this.loadGeometry(), u = Hc.types[this.type];
            function c(t1) {
                for(var e1 = 0; e1 < t1.length; e1++){
                    var r = t1[e1];
                    t1[e1] = [
                        360 * (r.x + a) / s - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + o) / s) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var h = [];
                    for(n = 0; n < l.length; n++)h[n] = l[n][0];
                    c(l = h);
                    break;
                case 2:
                    for(n = 0; n < l.length; n++)c(l[n]);
                    break;
                case 3:
                    for(l = function(t1) {
                        var e1 = t1.length;
                        if (e1 <= 1) return [
                            t1
                        ];
                        for(var r, n, i = [], s = 0; s < e1; s++){
                            var a = Jc(t1[s]);
                            0 !== a && (void 0 === n && (n = a < 0), n === a < 0 ? (r && i.push(r), r = [
                                t1[s]
                            ]) : r.push(t1[s]));
                        }
                        return r && i.push(r), i;
                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)c(l[n][i]);
            }
            1 === l.length ? l = l[0] : u = "Multi" + u;
            var p = {
                type: "Feature",
                geometry: {
                    type: u,
                    coordinates: l
                },
                properties: this.properties
            };
            return "id" in this && (p.id = this.id), p;
        };
        var Qc = Yc, th = eh;
        function eh(t1, e1) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(rh, this, e1), this.length = this._features.length;
        }
        function rh(t1, e1, r) {
            15 === t1 ? e1.version = r.readVarint() : 1 === t1 ? e1.name = r.readString() : 5 === t1 ? e1.extent = r.readVarint() : 2 === t1 ? e1._features.push(r.pos) : 3 === t1 ? e1._keys.push(r.readString()) : 4 === t1 && e1._values.push(function(t1) {
                for(var e1 = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = t1.readVarint() >> 3;
                    e1 = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                }
                return e1;
            }(r));
        }
        eh.prototype.feature = function(t1) {
            if (t1 < 0 || t1 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t1];
            var e1 = this._pbf.readVarint() + this._pbf.pos;
            return new Qc(this._pbf, e1, this.extent, this._keys, this._values);
        };
        var nh = th;
        function ih(t1, e1, r) {
            if (3 === t1) {
                var n = new nh(r, r.readVarint() + r.pos);
                n.length && (e1[n.name] = n);
            }
        }
        var sh = Zc.VectorTile = function(t1, e1) {
            this.layers = t1.readFields(ih, {}, e1);
        }, ah = Zc.VectorTileFeature = Yc;
        function oh(t1, e1, r, n) {
            const i = [], s = 0 === n ? (t1, e1, r, n, i, s)=>{
                t1.push(new d(s, r + (s - e1) / (n - e1) * (i - r)));
            } : (t1, e1, r, n, i, s)=>{
                t1.push(new d(e1 + (s - r) / (i - r) * (n - e1), s));
            };
            for (const a of t1){
                const t1 = [];
                for (const i of a){
                    if (i.length <= 2) continue;
                    const a = [];
                    for(let t1 = 0; t1 < i.length - 1; t1++){
                        const o = i[t1].x, l = i[t1].y, u = i[t1 + 1].x, c = i[t1 + 1].y, h = 0 === n ? o : l, p = 0 === n ? u : c;
                        h < e1 ? p > e1 && s(a, o, l, u, c, e1) : h > r ? p < r && s(a, o, l, u, c, r) : a.push(i[t1]), p < e1 && h >= e1 && s(a, o, l, u, c, e1), p > r && h <= r && s(a, o, l, u, c, r);
                    }
                    let o = i[i.length - 1];
                    const l = 0 === n ? o.x : o.y;
                    l >= e1 && l <= r && a.push(o), a.length && (o = a[a.length - 1], a[0].x === o.x && a[0].y === o.y || a.push(a[0]), t1.push(a));
                }
                t1.length && i.push(t1);
            }
            return i;
        }
        Zc.VectorTileLayer = th;
        const lh = ah.types, uh = Math.pow(2, 13);
        function ch(t1, e1, r, n, i, s, a, o) {
            t1.emplaceBack((e1 << 1) + a, (r << 1) + s, (Math.floor(n * uh) << 1) + i, Math.round(o));
        }
        function hh(t1, e1, r) {
            const n = 16384;
            t1.emplaceBack(e1.x, e1.y, e1.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class ph {
            constructor(){
                this.acc = new d(0, 0), this.polyCount = [];
            }
            startRing(t1) {
                this.currentPolyCount = {
                    edges: 0,
                    top: 0
                }, this.polyCount.push(this.currentPolyCount), this.min || (this.min = new d(t1.x, t1.y), this.max = new d(t1.x, t1.y));
            }
            append(t1, e1) {
                this.currentPolyCount.edges++, this.acc._add(t1);
                const r = this.min, n = this.max;
                t1.x < r.x ? r.x = t1.x : t1.x > n.x && (n.x = t1.x), t1.y < r.y ? r.y = t1.y : t1.y > n.y && (n.y = t1.y), ((0 === t1.x || t1.x === ko) && t1.x === e1.x) != ((0 === t1.y || t1.y === ko) && t1.y === e1.y) && this.processBorderOverlap(t1, e1), e1.x < 0 != t1.x < 0 && this.addBorderIntersection(0, Mr(e1.y, t1.y, (0 - e1.x) / (t1.x - e1.x))), e1.x > ko != t1.x > ko && this.addBorderIntersection(1, Mr(e1.y, t1.y, (ko - e1.x) / (t1.x - e1.x))), e1.y < 0 != t1.y < 0 && this.addBorderIntersection(2, Mr(e1.x, t1.x, (0 - e1.y) / (t1.y - e1.y))), e1.y > ko != t1.y > ko && this.addBorderIntersection(3, Mr(e1.x, t1.x, (ko - e1.y) / (t1.y - e1.y)));
            }
            addBorderIntersection(t1, e1) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const r = this.borders[t1];
                e1 < r[0] && (r[0] = e1), e1 > r[1] && (r[1] = e1);
            }
            processBorderOverlap(t1, e1) {
                if (t1.x === e1.x) {
                    if (t1.y === e1.y) return;
                    const r = 0 === t1.x ? 0 : 1;
                    this.addBorderIntersection(r, e1.y), this.addBorderIntersection(r, t1.y);
                } else {
                    const r = 0 === t1.y ? 2 : 3;
                    this.addBorderIntersection(r, e1.x), this.addBorderIntersection(r, t1.x);
                }
            }
            centroid() {
                const t1 = this.polyCount.reduce((t1, e1)=>t1 + e1.edges, 0);
                return 0 !== t1 ? this.acc.div(t1)._round() : new d(0, 0);
            }
            span() {
                return new d(this.max.x - this.min.x, this.max.y - this.min.y);
            }
            intersectsCount() {
                return this.borders.reduce((t1, e1)=>t1 + +(e1[0] !== Number.MAX_VALUE), 0);
            }
        }
        class fh {
            constructor(t1){
                this.zoom = t1.zoom, this.canonical = t1.canonical, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = t1.projection, this.layoutVertexArray = new oa, this.centroidVertexArray = new Ua, this.indexArray = new wa, this.programConfigurations = new fo(t1.layers, t1.zoom), this.segments = new So, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.enableTerrain = t1.enableTerrain;
            }
            populate(t1, e1, r, n) {
                this.features = [], this.hasPattern = Rc("fill-extrusion", this.layers, e1), this.featuresOnBorder = [], this.borders = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.tileToMeter = function(t1) {
                    const e1 = Math.exp(Math.PI * (1 - t1.y / (1 << t1.z) * 2));
                    return 80150034 * e1 / (e1 * e1 + 1) / ko / (1 << t1.z);
                }(r), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter;
                for (const { feature: i, id: s, index: a, sourceLayerIndex: o } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, l = wu(i, t1);
                    if (!this.layers[0]._featureFilter.filter(new Us(this.zoom), l, r)) continue;
                    const u = {
                        id: s,
                        sourceLayerIndex: o,
                        index: a,
                        geometry: t1 ? l.geometry : bu(i, r, n),
                        properties: i.properties,
                        type: i.type,
                        patterns: {}
                    }, c = this.layoutVertexArray.length;
                    this.hasPattern ? this.features.push(jc("fill-extrusion", this.layers, u, this.zoom, e1)) : this.addFeature(u, u.geometry, a, r, {}, e1.availableImages, n), e1.featureIndex.insert(i, u.geometry, a, o, this.index, c);
                }
                this.sortBorders();
            }
            addFeatures(t1, e1, r, n, i) {
                for (const t1 of this.features){
                    const { geometry: s } = t1;
                    this.addFeature(t1, s, t1.index, e1, r, n, i);
                }
                this.sortBorders();
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Xc), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = t1.createVertexBuffer(this.layoutVertexExtArray, Gc.members, !0))), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            uploadCentroid(t1) {
                0 !== this.centroidVertexArray.length && (this.centroidVertexBuffer ? this.needsCentroidUpdate && this.centroidVertexBuffer.updateData(this.centroidVertexArray) : this.centroidVertexBuffer = t1.createVertexBuffer(this.centroidVertexArray, Nc.members, !0), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t1, e1, r, n, i, s, a) {
                const o = [
                    new d(0, 0),
                    new d(ko, ko)
                ], l = a.projection, u = "globe" === l.name, c = this.enableTerrain && !u ? new ph : null, h = "Polygon" === lh[t1.type];
                u && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new pa);
                const p = Lc(e1, 500);
                for(let t1 = p.length - 1; t1 >= 0; t1--){
                    const e1 = p[t1];
                    (0 === e1.length || (f = e1[0]).every((t1)=>t1.x <= 0) || f.every((t1)=>t1.x >= ko) || f.every((t1)=>t1.y <= 0) || f.every((t1)=>t1.y >= ko)) && p.splice(t1, 1);
                }
                var f;
                let y;
                if (u) y = wh(p, o, n);
                else {
                    y = [];
                    for (const t1 of p)y.push({
                        polygon: t1,
                        bounds: o
                    });
                }
                const m = h ? this.edgeRadius : 0;
                for (const { polygon: t1, bounds: e1 } of y){
                    let r = 0, i = 0;
                    for (const e1 of t1)h && !e1[0].equals(e1[e1.length - 1]) && e1.push(e1[0]), i += h ? e1.length - 1 : e1.length;
                    const s = this.segments.prepareSegment((h ? 5 : 4) * i, this.layoutVertexArray, this.indexArray);
                    if (h) {
                        const e1 = [], i = [];
                        r = s.vertexLength;
                        for (const r of t1){
                            let a, o;
                            r.length && r !== t1[0] && i.push(e1.length / 2), a = r[1].sub(r[0])._perp()._unit();
                            for(let t1 = 1; t1 < r.length; t1++){
                                const i = r[t1], c = r[t1 === r.length - 1 ? 1 : t1 + 1];
                                let { x: h, y: p } = i;
                                if (m) {
                                    o = c.sub(i)._perp()._unit();
                                    const t1 = a.add(o)._unit(), e1 = m * Math.min(4, 1 / (a.x * t1.x + a.y * t1.y));
                                    h += e1 * t1.x, p += e1 * t1.y, a = o;
                                }
                                ch(this.layoutVertexArray, h, p, 0, 0, 1, 1, 0), s.vertexLength++, e1.push(i.x, i.y), u && hh(this.layoutVertexExtArray, l.projectTilePoint(h, p, n), l.upVector(n, h, p));
                            }
                        }
                        const a = sc(e1, i);
                        for(let t1 = 0; t1 < a.length; t1 += 3)this.indexArray.emplaceBack(r + a[t1], r + a[t1 + 2], r + a[t1 + 1]), s.primitiveLength++;
                    }
                    for (const i of t1){
                        c && i.length && c.startRing(i[0]);
                        let t1, a, o, p = i.length > 4 && xh(i[i.length - 2], i[0], i[1]), f = m ? yh(i[i.length - 2], i[0], i[1], m) : 0;
                        a = i[1].sub(i[0])._perp()._unit();
                        let d = !0;
                        for(let y = 1, g = 0; y < i.length; y++){
                            let x = i[y - 1], v = i[y];
                            const b = i[y === i.length - 1 ? 1 : y + 1];
                            if (c && h && c.currentPolyCount.top++, gh(v, x, e1)) {
                                m && (a = b.sub(v)._perp()._unit(), d = !d);
                                continue;
                            }
                            c && c.append(v, x);
                            const w = v.sub(x)._perp(), _ = w.x / (Math.abs(w.x) + Math.abs(w.y)), A = w.y > 0 ? 1 : 0, S = x.dist(v);
                            if (g + S > 32768 && (g = 0), m) {
                                o = b.sub(v)._perp()._unit();
                                let t1 = mh(x, v, b, dh(a, o), m);
                                isNaN(t1) && (t1 = 0);
                                const e1 = v.sub(x)._unit();
                                x = x.add(e1.mult(f))._round(), v = v.add(e1.mult(-t1))._round(), f = t1, a = o;
                            }
                            const k = s.vertexLength, I = i.length > 4 && xh(x, v, b);
                            let M = vh(g, p, d);
                            if (ch(this.layoutVertexArray, x.x, x.y, _, A, 0, 0, M), ch(this.layoutVertexArray, x.x, x.y, _, A, 0, 1, M), g += S, M = vh(g, I, !d), p = I, ch(this.layoutVertexArray, v.x, v.y, _, A, 0, 0, M), ch(this.layoutVertexArray, v.x, v.y, _, A, 0, 1, M), s.vertexLength += 4, this.indexArray.emplaceBack(k + 0, k + 1, k + 2), this.indexArray.emplaceBack(k + 1, k + 3, k + 2), s.primitiveLength += 2, m) {
                                const n = r + (1 === y ? i.length - 2 : y - 2), a = 1 === y ? r : n + 1;
                                if (this.indexArray.emplaceBack(k + 1, n, k + 3), this.indexArray.emplaceBack(n, a, k + 3), s.primitiveLength += 2, void 0 === t1 && (t1 = k), !gh(b, i[y], e1)) {
                                    const e1 = y === i.length - 1 ? t1 : s.vertexLength;
                                    this.indexArray.emplaceBack(k + 2, k + 3, e1), this.indexArray.emplaceBack(k + 3, e1 + 1, e1), this.indexArray.emplaceBack(k + 3, a, e1 + 1), s.primitiveLength += 3;
                                }
                                d = !d;
                            }
                            if (u) {
                                const t1 = this.layoutVertexExtArray, e1 = l.projectTilePoint(x.x, x.y, n), r = l.projectTilePoint(v.x, v.y, n), i = l.upVector(n, x.x, x.y), s = l.upVector(n, v.x, v.y);
                                hh(t1, e1, i), hh(t1, e1, i), hh(t1, r, s), hh(t1, r, s);
                            }
                        }
                        h && (r += i.length - 1);
                    }
                }
                if (c && c.polyCount.length > 0) {
                    if (c.borders) {
                        c.vertexArrayOffset = this.centroidVertexArray.length;
                        const t1 = c.borders, e1 = this.featuresOnBorder.push(c) - 1;
                        for(let r = 0; r < 4; r++)t1[r][0] !== Number.MAX_VALUE && this.borders[r].push(e1);
                    }
                    this.encodeCentroid(c.borders ? void 0 : c.centroid(), c);
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n);
            }
            sortBorders() {
                for(let t1 = 0; t1 < 4; t1++)this.borders[t1].sort((e1, r)=>this.featuresOnBorder[e1].borders[t1][0] - this.featuresOnBorder[r].borders[t1][0]);
            }
            encodeCentroid(t1, e1, r = !0) {
                let n, i;
                if (t1) {
                    if (0 !== t1.y) {
                        const r = e1.span()._mult(this.tileToMeter);
                        n = (Math.max(t1.x, 1) << 3) + Math.min(7, Math.round(r.x / 10)), i = (Math.max(t1.y, 1) << 3) + Math.min(7, Math.round(r.y / 10));
                    } else n = Math.ceil(7 * (t1.x + 450)), i = 0;
                } else n = 0, i = +r;
                let s = r ? this.centroidVertexArray.length : e1.vertexArrayOffset;
                for (const t1 of e1.polyCount){
                    r && this.centroidVertexArray.resize(this.centroidVertexArray.length + 4 * t1.edges + t1.top);
                    for(let e1 = 0; e1 < t1.top; e1++)this.centroidVertexArray.emplace(s++, n, i);
                    for(let e1 = 0; e1 < 2 * t1.edges; e1++)this.centroidVertexArray.emplace(s++, 0, i), this.centroidVertexArray.emplace(s++, n, i);
                }
            }
        }
        function dh(t1, e1) {
            const r = t1.add(e1)._unit();
            return t1.x * r.x + t1.y * r.y;
        }
        function yh(t1, e1, r, n) {
            const i = e1.sub(t1)._perp()._unit(), s = r.sub(e1)._perp()._unit();
            return mh(t1, e1, r, dh(i, s), n);
        }
        function mh(t1, e1, r, n, i) {
            const s = Math.sqrt(1 - n * n);
            return Math.min(t1.dist(e1) / 3, e1.dist(r) / 3, i * s / n);
        }
        function gh(t1, e1, r) {
            return t1.x < r[0].x && e1.x < r[0].x || t1.x > r[1].x && e1.x > r[1].x || t1.y < r[0].y && e1.y < r[0].y || t1.y > r[1].y && e1.y > r[1].y;
        }
        function xh(t1, e1, r) {
            if (t1.x < 0 || t1.x >= ko || e1.x < 0 || e1.x >= ko || r.x < 0 || r.x >= ko) return !1;
            const n = r.sub(e1), i = n.perp(), s = t1.sub(e1);
            return (n.x * s.x + n.y * s.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (s.x * s.x + s.y * s.y)) > -0.866 && i.x * s.x + i.y * s.y < 0;
        }
        function vh(t1, e1, r) {
            const n = e1 ? 2 | t1 : -3 & t1;
            return r ? 1 | n : -2 & n;
        }
        function bh() {
            const t1 = Math.PI / 32, e1 = Math.tan(t1), r = tu;
            return r * Math.sqrt(1 + 2 * e1 * e1) - r;
        }
        function wh(t1, e1, r) {
            const n = 1 << r.z, i = ou(r.x / n), s = ou((r.x + 1) / n), a = lu(r.y / n), o = lu((r.y + 1) / n);
            return function(t1, e1, r, n, i = 0, s) {
                const a = [];
                if (!t1.length || !r || !n) return a;
                const o = (t1, e1)=>{
                    for (const r of t1)a.push({
                        polygon: r,
                        bounds: e1
                    });
                }, l = Math.ceil(Math.log2(r)), u = Math.ceil(Math.log2(n)), c = l - u, h = [];
                for(let t1 = 0; t1 < Math.abs(c); t1++)h.push(c > 0 ? 0 : 1);
                for(let t1 = 0; t1 < Math.min(l, u); t1++)h.push(0), h.push(1);
                let p = t1;
                if (p = oh(p, e1[0].y - i, e1[1].y + i, 1), p = oh(p, e1[0].x - i, e1[1].x + i, 0), !p.length) return a;
                const f = [];
                for(h.length ? f.push({
                    polygons: p,
                    bounds: e1,
                    depth: 0
                }) : o(p, e1); f.length;){
                    const t1 = f.pop(), e1 = t1.depth, r = h[e1], n = t1.bounds[0], a = t1.bounds[1], l = 0 === r ? n.x : n.y, u = 0 === r ? a.x : a.y, c = s ? s(r, l, u) : .5 * (l + u), p = oh(t1.polygons, l - i, c + i, r), y = oh(t1.polygons, c - i, u + i, r);
                    if (p.length) {
                        const t1 = [
                            n,
                            new d(0 === r ? c : a.x, 1 === r ? c : a.y)
                        ];
                        h.length > e1 + 1 ? f.push({
                            polygons: p,
                            bounds: t1,
                            depth: e1 + 1
                        }) : o(p, t1);
                    }
                    if (y.length) {
                        const t1 = [
                            new d(0 === r ? c : n.x, 1 === r ? c : n.y),
                            a
                        ];
                        h.length > e1 + 1 ? f.push({
                            polygons: y,
                            bounds: t1,
                            depth: e1 + 1
                        }) : o(y, t1);
                    }
                }
                return a;
            }(t1, e1, Math.ceil((s - i) / 11.25), Math.ceil((a - o) / 11.25), 1, (t1, e1, i)=>{
                if (0 === t1) return .5 * (e1 + i);
                {
                    const t1 = lu((r.y + e1 / ko) / n);
                    return (su(.5 * (lu((r.y + i / ko) / n) + t1)) * n - r.y) * ko;
                }
            });
        }
        Oi(fh, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), Oi(ph, "PartMetadata");
        const _h = new Js({
            "fill-extrusion-edge-radius": new Ys(Ht["layout_fill-extrusion"]["fill-extrusion-edge-radius"])
        });
        var Ah = {
            paint: new Js({
                "fill-extrusion-opacity": new Ys(Ht["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                "fill-extrusion-color": new Hs(Ht["paint_fill-extrusion"]["fill-extrusion-color"]),
                "fill-extrusion-translate": new Ys(Ht["paint_fill-extrusion"]["fill-extrusion-translate"]),
                "fill-extrusion-translate-anchor": new Ys(Ht["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                "fill-extrusion-pattern": new Hs(Ht["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                "fill-extrusion-height": new Hs(Ht["paint_fill-extrusion"]["fill-extrusion-height"]),
                "fill-extrusion-base": new Hs(Ht["paint_fill-extrusion"]["fill-extrusion-base"]),
                "fill-extrusion-vertical-gradient": new Ys(Ht["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                "fill-extrusion-ambient-occlusion-intensity": new Ys(Ht["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                "fill-extrusion-ambient-occlusion-radius": new Ys(Ht["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"])
            }),
            layout: _h
        };
        function Sh(t1, e1, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t1 * n - 2 * Math.PI * 6378137 / 2,
                e1 * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        class kh {
            constructor(t1, e1, r){
                this.z = t1, this.x = e1, this.y = r, this.key = Th(0, t1, t1, e1, r);
            }
            equals(t1) {
                return this.z === t1.z && this.x === t1.x && this.y === t1.y;
            }
            url(t1, e1) {
                const r = function(t1, e1, r) {
                    var n = Sh(256 * t1, 256 * (e1 = Math.pow(2, r) - e1 - 1), r), i = Sh(256 * (t1 + 1), 256 * (e1 + 1), r);
                    return n[0] + "," + n[1] + "," + i[0] + "," + i[1];
                }(this.x, this.y, this.z), n = function(t1, e1, r) {
                    let n, i = "";
                    for(let s = t1; s > 0; s--)n = 1 << s - 1, i += (e1 & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t1[(this.x + this.y) % t1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === e1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", r);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class Ih {
            constructor(t1, e1){
                this.wrap = t1, this.canonical = e1, this.key = Th(t1, e1.z, e1.z, e1.x, e1.y);
            }
        }
        class Mh {
            constructor(t1, e1, r, n, i){
                this.overscaledZ = t1, this.wrap = e1, this.canonical = new kh(r, +n, +i), this.key = 0 === e1 && t1 === r ? this.canonical.key : Th(e1, t1, r, n, i);
            }
            equals(t1) {
                return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
            }
            scaledTo(t1) {
                const e1 = this.canonical.z - t1;
                return t1 > this.canonical.z ? new Mh(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Mh(t1, this.wrap, t1, this.canonical.x >> e1, this.canonical.y >> e1);
            }
            calculateScaledKey(t1, e1 = !0) {
                if (this.overscaledZ === t1 && e1) return this.key;
                if (t1 > this.canonical.z) return Th(this.wrap * +e1, t1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const r = this.canonical.z - t1;
                    return Th(this.wrap * +e1, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
                }
            }
            isChildOf(t1) {
                if (t1.wrap !== this.wrap) return !1;
                const e1 = this.canonical.z - t1.canonical.z;
                return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.x === this.canonical.x >> e1 && t1.canonical.y === this.canonical.y >> e1;
            }
            children(t1) {
                if (this.overscaledZ >= t1) return [
                    new Mh(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new Mh(e1, this.wrap, e1, r, n),
                    new Mh(e1, this.wrap, e1, r + 1, n),
                    new Mh(e1, this.wrap, e1, r, n + 1),
                    new Mh(e1, this.wrap, e1, r + 1, n + 1)
                ];
            }
            isLessThan(t1) {
                return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
            }
            wrapped() {
                return new Mh(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t1) {
                return new Mh(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Ih(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
        }
        function Th(t1, e1, r, n, i) {
            const s = 1 << Math.min(r, 22);
            let a = s * (i % s) + n % s;
            return t1 && r < 22 && (a += s * s * ((t1 < 0 ? -2 * t1 - 1 : 2 * t1) % (1 << 2 * (22 - r)))), 16 * (32 * a + r) + (e1 - r);
        }
        Oi(kh, "CanonicalTileID"), Oi(Mh, "OverscaledTileID", {
            omit: [
                "projMatrix"
            ]
        });
        class zh extends d {
            constructor(t1, e1, r){
                super(t1, e1), this.z = r;
            }
        }
        function Bh(t1, e1) {
            return t1.x * e1.x + t1.y * e1.y;
        }
        function Eh(t1, e1) {
            if (1 === t1.length) {
                let r = 0;
                const n = e1[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e1[r++], !i) return 1 / 0;
                for(; r < e1.length; r++){
                    const s = e1[r], a = t1[0], o = i.sub(n), l = s.sub(n), u = a.sub(n), c = Bh(o, o), h = Bh(o, l), p = Bh(l, l), f = Bh(u, o), d = Bh(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = n.z * (1 - m - g) + i.z * m + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t1 = 1 / 0;
                for (const r of e1)t1 = Math.min(t1, r.z);
                return t1;
            }
        }
        function Ch(t1, e1, r, n, i, s, a, o) {
            const l = a * i.getElevationAt(t1, e1, !0, !0), u = 0 !== s[0], c = u ? 0 === s[1] ? a * (s[0] / 7 - 450) : a * function(t1, e1, r) {
                const n = Math.floor(e1[0] / 8), i = Math.floor(e1[1] / 8), s = 10 * (e1[0] - 8 * n), a = 10 * (e1[1] - 8 * i), o = t1.getElevationAt(n, i, !0, !0), l = t1.getMeterToDEM(r), u = Math.floor(.5 * (s * l - 1)), c = Math.floor(.5 * (a * l - 1)), h = t1.tileCoordToPixel(n, i), p = 2 * u + 1, f = 2 * c + 1, d = function(t1, e1, r, n, i) {
                    return [
                        t1.getElevationAtPixel(e1, r, !0),
                        t1.getElevationAtPixel(e1 + i, r, !0),
                        t1.getElevationAtPixel(e1, r + i, !0),
                        t1.getElevationAtPixel(e1 + n, r + i, !0)
                    ];
                }(t1, h.x - u, h.y - c, p, f), y = Math.abs(d[0] - d[1]), m = Math.abs(d[2] - d[3]), g = Math.abs(d[0] - d[2]) + Math.abs(d[1] - d[3]), x = Math.min(.25, .5 * l * (y + m) / p), v = Math.min(.25, .5 * l * g / f);
                return o + Math.max(x * s, v * a);
            }(i, s, o) : l;
            return {
                base: l + (0 === r) ? -1 : r,
                top: u ? Math.max(c + n, l + r + 2) : l + n
            };
        }
        const Ph = na([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), { members: Dh } = Ph, Vh = na([
            {
                name: "a_packed",
                components: 4,
                type: "Float32"
            }
        ]), { members: Lh } = Vh, Fh = ah.types, Rh = Math.cos(Math.PI / 180 * 37.5);
        class jh {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.projection = t1.projection, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t1)=>{
                    this.gradients[t1.id] = {};
                }), this.layoutVertexArray = new la, this.layoutVertexArray2 = new ua, this.indexArray = new wa, this.programConfigurations = new fo(t1.layers, t1.zoom), this.segments = new So, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
            populate(t1, e1, r, n) {
                this.hasPattern = Rc("line", this.layers, e1);
                const i = this.layers[0].layout.get("line-sort-key"), s = [];
                for (const { feature: e1, id: a, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = wu(e1, t1);
                    if (!this.layers[0]._featureFilter.filter(new Us(this.zoom), u, r)) continue;
                    const c = i ? i.evaluate(u, {}, r) : void 0, h = {
                        id: a,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : bu(e1, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                i && s.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                const { lineAtlas: a, featureIndex: o } = e1, l = this.addConstantDashes(a);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: u } = n;
                    if (l && this.addFeatureDashes(n, a), this.hasPattern) {
                        const t1 = jc("line", this.layers, n, this.zoom, e1);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, s, r, a.positions, e1.availableImages);
                    o.insert(t1[s].feature, i, s, u, this.index);
                }
            }
            addConstantDashes(t1) {
                let e1 = !1;
                for (const r of this.layers){
                    const n = r.paint.get("line-dasharray").value, i = r.layout.get("line-cap").value;
                    if ("constant" !== n.kind || "constant" !== i.kind) e1 = !0;
                    else {
                        const e1 = i.value, r = n.value;
                        if (!r) continue;
                        t1.addDash(r, e1);
                    }
                }
                return e1;
            }
            addFeatureDashes(t1, e1) {
                const r = this.zoom;
                for (const n of this.layers){
                    const i = n.paint.get("line-dasharray").value, s = n.layout.get("line-cap").value;
                    if ("constant" === i.kind && "constant" === s.kind) continue;
                    let a, o;
                    if ("constant" === i.kind) {
                        if (a = i.value, !a) continue;
                    } else a = i.evaluate({
                        zoom: r
                    }, t1);
                    o = "constant" === s.kind ? s.value : s.evaluate({
                        zoom: r
                    }, t1), e1.addDash(a, o), t1.patterns[n.id] = e1.getKey(a, o);
                }
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r, n);
            }
            addFeatures(t1, e1, r, n, i) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, Lh)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Dh), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t1) {
                if (t1.properties && t1.properties.hasOwnProperty("mapbox_clip_start") && t1.properties.hasOwnProperty("mapbox_clip_end")) return {
                    start: +t1.properties.mapbox_clip_start,
                    end: +t1.properties.mapbox_clip_end
                };
            }
            addFeature(t1, e1, r, n, i, s) {
                const a = this.layers[0].layout, o = a.get("line-join").evaluate(t1, {}), l = a.get("line-cap").evaluate(t1, {}), u = a.get("line-miter-limit"), c = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t1);
                for (const r of e1)this.addLine(r, t1, o, l, u, c);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n);
            }
            addLine(t1, e1, r, n, i, s) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineSoFar = 0, this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e1 = 0; e1 < t1.length - 1; e1++)this.totalDistance += t1[e1].dist(t1[e1 + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const a = "Polygon" === Fh[e1.type];
                let o = t1.length;
                for(; o >= 2 && t1[o - 1].equals(t1[o - 2]);)o--;
                let l = 0;
                for(; l < o - 1 && t1[l].equals(t1[l + 1]);)l++;
                if (o < (a ? 3 : 2)) return;
                "bevel" === r && (i = 1.05);
                const u = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, c = this.segments.prepareSegment(10 * o, this.layoutVertexArray, this.indexArray);
                let h, p, f, d, y;
                this.e1 = this.e2 = -1, a && (h = t1[o - 2], y = t1[l].sub(h)._unit()._perp());
                for(let e1 = l; e1 < o; e1++){
                    if (f = e1 === o - 1 ? a ? t1[l + 1] : void 0 : t1[e1 + 1], f && t1[e1].equals(f)) continue;
                    y && (d = y), h && (p = h), h = t1[e1], y = f ? f.sub(h)._unit()._perp() : d, d = d || y;
                    let m = d.add(y);
                    0 === m.x && 0 === m.y || m._unit();
                    const g = d.x * y.x + d.y * y.y, x = m.x * y.x + m.y * y.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), w = x < Rh && p && f, _ = d.x * y.y - d.y * y.x > 0;
                    if (w && e1 > l) {
                        const t1 = h.dist(p);
                        if (t1 > 2 * u) {
                            const e1 = h.sub(h.sub(p)._mult(u / t1)._round());
                            this.updateDistance(p, e1), this.addCurrentVertex(e1, d, 0, 0, c), p = e1;
                        }
                    }
                    const A = p && f;
                    let S = A ? r : a ? "butt" : n;
                    if (A && "round" === S && (v < s ? S = "miter" : v <= 2 && (S = "fakeround")), "miter" === S && v > i && (S = "bevel"), "bevel" === S && (v > 2 && (S = "flipbevel"), v < i && (S = "miter")), p && this.updateDistance(p, h), "miter" === S) m._mult(v), this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("flipbevel" === S) {
                        if (v > 100) m = y.mult(-1);
                        else {
                            const t1 = v * d.add(y).mag() / d.sub(y).mag();
                            m._perp()._mult(t1 * (_ ? -1 : 1));
                        }
                        this.addCurrentVertex(h, m, 0, 0, c), this.addCurrentVertex(h, m.mult(-1), 0, 0, c);
                    } else if ("bevel" === S || "fakeround" === S) {
                        const t1 = -Math.sqrt(v * v - 1), e1 = _ ? t1 : 0, r = _ ? 0 : t1;
                        if (p && this.addCurrentVertex(h, d, e1, r, c), "fakeround" === S) {
                            const t1 = Math.round(180 * b / Math.PI / 20);
                            for(let e1 = 1; e1 < t1; e1++){
                                let r = e1 / t1;
                                if (.5 !== r) {
                                    const t1 = r - .5;
                                    r += r * t1 * (r - 1) * ((1.0904 + g * (g * (3.55645 - 1.43519 * g) - 3.2452)) * t1 * t1 + (.848013 + g * (.215638 * g - 1.06021)));
                                }
                                const n = y.sub(d)._mult(r)._add(d)._unit()._mult(_ ? -1 : 1);
                                this.addHalfVertex(h, n.x, n.y, !1, _, 0, c);
                            }
                        }
                        f && this.addCurrentVertex(h, y, -e1, -r, c);
                    } else if ("butt" === S) this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("square" === S) {
                        const t1 = p ? 1 : -1;
                        p || this.addCurrentVertex(h, m, t1, t1, c), this.addCurrentVertex(h, m, 0, 0, c), p && this.addCurrentVertex(h, m, t1, t1, c);
                    } else "round" === S && (p && (this.addCurrentVertex(h, d, 0, 0, c), this.addCurrentVertex(h, d, 1, 1, c, !0)), f && (this.addCurrentVertex(h, y, -1, -1, c, !0), this.addCurrentVertex(h, y, 0, 0, c)));
                    if (w && e1 < o - 1) {
                        const t1 = h.dist(f);
                        if (t1 > 2 * u) {
                            const e1 = h.add(f.sub(h)._mult(u / t1)._round());
                            this.updateDistance(h, e1), this.addCurrentVertex(e1, y, 0, 0, c), h = e1;
                        }
                    }
                }
            }
            addCurrentVertex(t1, e1, r, n, i, s = !1) {
                const a = e1.y * n - e1.x, o = -e1.y - e1.x * n;
                this.addHalfVertex(t1, e1.x + e1.y * r, e1.y - e1.x * r, s, !1, r, i), this.addHalfVertex(t1, a, o, s, !0, -n, i);
            }
            addHalfVertex({ x: t1, y: e1 }, r, n, i, s, a, o) {
                this.layoutVertexArray.emplaceBack((t1 << 1) + (i ? 1 : 0), (e1 << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1), 0, this.lineSoFar), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineClips.start, this.lineClips.end);
                const l = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, l), o.primitiveLength++), s ? this.e2 = l : this.e1 = l;
            }
            updateScaledDistance() {
                if (this.lineClips) {
                    const t1 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
                    this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = t1 * this.lineClips.start + this.distance;
                } else this.lineSoFar = this.distance;
            }
            updateDistance(t1, e1) {
                this.distance += t1.dist(e1), this.updateScaledDistance();
            }
        }
        Oi(jh, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const Uh = new Js({
            "line-cap": new Hs(Ht.layout_line["line-cap"]),
            "line-join": new Hs(Ht.layout_line["line-join"]),
            "line-miter-limit": new Ys(Ht.layout_line["line-miter-limit"]),
            "line-round-limit": new Ys(Ht.layout_line["line-round-limit"]),
            "line-sort-key": new Hs(Ht.layout_line["line-sort-key"])
        });
        var $h = {
            paint: new Js({
                "line-opacity": new Hs(Ht.paint_line["line-opacity"]),
                "line-color": new Hs(Ht.paint_line["line-color"]),
                "line-translate": new Ys(Ht.paint_line["line-translate"]),
                "line-translate-anchor": new Ys(Ht.paint_line["line-translate-anchor"]),
                "line-width": new Hs(Ht.paint_line["line-width"]),
                "line-gap-width": new Hs(Ht.paint_line["line-gap-width"]),
                "line-offset": new Hs(Ht.paint_line["line-offset"]),
                "line-blur": new Hs(Ht.paint_line["line-blur"]),
                "line-dasharray": new Hs(Ht.paint_line["line-dasharray"]),
                "line-pattern": new Hs(Ht.paint_line["line-pattern"]),
                "line-gradient": new Ws(Ht.paint_line["line-gradient"]),
                "line-trim-offset": new Ys(Ht.paint_line["line-trim-offset"])
            }),
            layout: Uh
        };
        const Oh = new class extends Hs {
            possiblyEvaluate(t1, e1) {
                return e1 = new Us(Math.floor(e1.zoom), {
                    now: e1.now,
                    fadeDuration: e1.fadeDuration,
                    transition: e1.transition
                }), super.possiblyEvaluate(t1, e1);
            }
            evaluate(t1, e1, r, n) {
                return e1 = z({}, e1, {
                    zoom: Math.floor(e1.zoom)
                }), super.evaluate(t1, e1, r, n);
            }
        }($h.paint.properties["line-width"].specification);
        function qh(t1, e1) {
            return e1 > 0 ? e1 + 2 * t1 : t1;
        }
        Oh.useIntegerZoom = !0;
        const Nh = na([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), Gh = na([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), Xh = na([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        na([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const Zh = na([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ]), Kh = na([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            }
        ]);
        na([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Yh = na([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), Hh = na([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        na([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), na([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), na([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            }
        ]), na([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), na([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        var Wh = 24;
        const Jh = 128;
        function Qh(t1, e1) {
            const { expression: r } = e1;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new Us(t1 + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e1, interpolationType: n } = r;
                let i = 0;
                for(; i < e1.length && e1[i] <= t1;)i++;
                i = Math.max(0, i - 1);
                let s = i;
                for(; s < e1.length && e1[s] < t1 + 1;)s++;
                s = Math.min(e1.length - 1, s);
                const a = e1[i], o = e1[s];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: a,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: a,
                    maxZoom: o,
                    minSize: r.evaluate(new Us(a)),
                    maxSize: r.evaluate(new Us(o)),
                    interpolationType: n
                };
            }
        }
        function tp(t1, { uSize: e1, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t1.kind ? n / Jh : "composite" === t1.kind ? Mr(n / Jh, i / Jh, r) : e1;
        }
        function ep(t1, e1) {
            let r = 0, n = 0;
            if ("constant" === t1.kind) n = t1.layoutSize;
            else if ("source" !== t1.kind) {
                const { interpolationType: i, minZoom: s, maxZoom: a } = t1, o = i ? S(Kr.interpolationFactor(i, e1, s, a), 0, 1) : 0;
                "camera" === t1.kind ? n = Mr(t1.minSize, t1.maxSize, o) : r = o;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }
        var rp = Object.freeze({
            __proto__: null,
            getSizeData: Qh,
            evaluateSizeForFeature: tp,
            evaluateSizeForZoom: ep,
            SIZE_PACK_FACTOR: Jh
        });
        function np(t1, e1, r) {
            return t1.sections.forEach((t1)=>{
                t1.text = function(t1, e1, r) {
                    const n = e1.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), js.applyArabicShaping && (t1 = js.applyArabicShaping(t1)), t1;
                }(t1.text, e1, r);
            }), t1;
        }
        const ip = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        function sp(t1) {
            return "\uFE36" === t1 || "\uFE48" === t1 || "\uFE38" === t1 || "\uFE44" === t1 || "\uFE42" === t1 || "\uFE3E" === t1 || "\uFE3C" === t1 || "\uFE3A" === t1 || "\uFE18" === t1 || "\uFE40" === t1 || "\uFE10" === t1 || "\uFE13" === t1 || "\uFE14" === t1 || "\uFF40" === t1 || "\uFFE3" === t1 || "\uFE11" === t1 || "\uFE12" === t1;
        }
        function ap(t1) {
            return "\uFE35" === t1 || "\uFE47" === t1 || "\uFE37" === t1 || "\uFE43" === t1 || "\uFE41" === t1 || "\uFE3D" === t1 || "\uFE3B" === t1 || "\uFE39" === t1 || "\uFE17" === t1 || "\uFE3F" === t1;
        }
        var op = cp, lp = function(t1, e1, r, n, i) {
            var s, a, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t1[e1 + h];
            for(h += p, s = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; s = 256 * s + t1[e1 + h], h += p, c -= 8);
            for(a = s & (1 << -c) - 1, s >>= -c, c += n; c > 0; a = 256 * a + t1[e1 + h], h += p, c -= 8);
            if (0 === s) s = 1 - u;
            else {
                if (s === l) return a ? NaN : 1 / 0 * (f ? -1 : 1);
                a += Math.pow(2, n), s -= u;
            }
            return (f ? -1 : 1) * a * Math.pow(2, s - n);
        }, up = function(t1, e1, r, n, i, s) {
            var a, o, l, u = 8 * s - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : s - 1, d = n ? 1 : -1, y = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
            for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (o = isNaN(e1) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), (e1 += a + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (a++, l /= 2), a + h >= c ? (o = 0, a = c) : a + h >= 1 ? (o = (e1 * l - 1) * Math.pow(2, i), a += h) : (o = e1 * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t1[r + f] = 255 & o, f += d, o /= 256, i -= 8);
            for(a = a << i | o, u += i; u > 0; t1[r + f] = 255 & a, f += d, a /= 256, u -= 8);
            t1[r + f - d] |= 128 * y;
        };
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ function cp(t1) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        cp.Varint = 0, cp.Fixed64 = 1, cp.Bytes = 2, cp.Fixed32 = 5;
        var hp = 4294967296, pp = 1 / hp, fp = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function dp(t1) {
            return t1.type === cp.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
        }
        function yp(t1, e1, r) {
            return r ? 4294967296 * e1 + (t1 >>> 0) : 4294967296 * (e1 >>> 0) + (t1 >>> 0);
        }
        function mp(t1, e1, r) {
            var n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
            r.realloc(n);
            for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
        }
        function gp(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeVarint(t1[r]);
        }
        function xp(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSVarint(t1[r]);
        }
        function vp(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFloat(t1[r]);
        }
        function bp(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeDouble(t1[r]);
        }
        function wp(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeBoolean(t1[r]);
        }
        function _p(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed32(t1[r]);
        }
        function Ap(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed32(t1[r]);
        }
        function Sp(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed64(t1[r]);
        }
        function kp(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed64(t1[r]);
        }
        function Ip(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + 16777216 * t1[e1 + 3];
        }
        function Mp(t1, e1, r) {
            t1[r] = e1, t1[r + 1] = e1 >>> 8, t1[r + 2] = e1 >>> 16, t1[r + 3] = e1 >>> 24;
        }
        function Tp(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + (t1[e1 + 3] << 24);
        }
        function zp(t1, e1, r) {
            e1.glyphs = [], 1 === t1 && r.readMessage(Bp, e1);
        }
        function Bp(t1, e1, r) {
            if (3 === t1) {
                const { id: t1, bitmap: n, width: i, height: s, left: a, top: o, advance: l } = r.readMessage(Ep, {});
                e1.glyphs.push({
                    id: t1,
                    bitmap: new Ju({
                        width: i + 6,
                        height: s + 6
                    }, n),
                    metrics: {
                        width: i,
                        height: s,
                        left: a,
                        top: o,
                        advance: l
                    }
                });
            } else 4 === t1 ? e1.ascender = r.readSVarint() : 5 === t1 && (e1.descender = r.readSVarint());
        }
        function Ep(t1, e1, r) {
            1 === t1 ? e1.id = r.readVarint() : 2 === t1 ? e1.bitmap = r.readBytes() : 3 === t1 ? e1.width = r.readVarint() : 4 === t1 ? e1.height = r.readVarint() : 5 === t1 ? e1.left = r.readSVarint() : 6 === t1 ? e1.top = r.readSVarint() : 7 === t1 && (e1.advance = r.readVarint());
        }
        function Cp(t1) {
            let e1 = 0, r = 0;
            for (const n of t1)e1 += n.w * n.h, r = Math.max(r, n.w);
            t1.sort((t1, e1)=>e1.h - t1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const e1 of t1)for(let t1 = n.length - 1; t1 >= 0; t1--){
                const r = n[t1];
                if (!(e1.w > r.w || e1.h > r.h)) {
                    if (e1.x = r.x, e1.y = r.y, s = Math.max(s, e1.y + e1.h), i = Math.max(i, e1.x + e1.w), e1.w === r.w && e1.h === r.h) {
                        const e1 = n.pop();
                        t1 < n.length && (n[t1] = e1);
                    } else e1.h === r.h ? (r.x += e1.w, r.w -= e1.w) : e1.w === r.w ? (r.y += e1.h, r.h -= e1.h) : (n.push({
                        x: r.x + e1.w,
                        y: r.y,
                        w: r.w - e1.w,
                        h: e1.h
                    }), r.y += e1.h, r.h -= e1.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: e1 / (i * s) || 0
            };
        }
        cp.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(t1, e1, r) {
                for(r = r || this.length; this.pos < r;){
                    var n = this.readVarint(), i = n >> 3, s = this.pos;
                    this.type = 7 & n, t1(i, e1, this), this.pos === s && this.skip(n);
                }
                return e1;
            },
            readMessage: function(t1, e1) {
                return this.readFields(t1, e1, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var t1 = Ip(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readSFixed32: function() {
                var t1 = Tp(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readFixed64: function() {
                var t1 = Ip(this.buf, this.pos) + Ip(this.buf, this.pos + 4) * hp;
                return this.pos += 8, t1;
            },
            readSFixed64: function() {
                var t1 = Ip(this.buf, this.pos) + Tp(this.buf, this.pos + 4) * hp;
                return this.pos += 8, t1;
            },
            readFloat: function() {
                var t1 = lp(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, t1;
            },
            readDouble: function() {
                var t1 = lp(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, t1;
            },
            readVarint: function(t1) {
                var e1, r, n = this.buf;
                return e1 = 127 & (r = n[this.pos++]), r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e1 : function(t1, e1, r) {
                    var n, i, s = r.buf;
                    if (n = (112 & (i = s[r.pos++])) >> 4, i < 128) return yp(t1, n, e1);
                    if (n |= (127 & (i = s[r.pos++])) << 3, i < 128) return yp(t1, n, e1);
                    if (n |= (127 & (i = s[r.pos++])) << 10, i < 128) return yp(t1, n, e1);
                    if (n |= (127 & (i = s[r.pos++])) << 17, i < 128) return yp(t1, n, e1);
                    if (n |= (127 & (i = s[r.pos++])) << 24, i < 128) return yp(t1, n, e1);
                    if (n |= (1 & (i = s[r.pos++])) << 31, i < 128) return yp(t1, n, e1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(e1 |= (15 & (r = n[this.pos])) << 28, t1, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var t1 = this.readVarint();
                return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.pos;
                return this.pos = t1, t1 - e1 >= 12 && fp ? function(t1, e1, r) {
                    return fp.decode(t1.subarray(e1, r));
                }(this.buf, e1, t1) : function(t1, e1, r) {
                    for(var n = "", i = e1; i < r;){
                        var s, a, o, l = t1[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                        if (i + c > r) break;
                        1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (s = t1[i + 1])) && (u = (31 & l) << 6 | 63 & s) <= 127 && (u = null) : 3 === c ? (a = t1[i + 2], 128 == (192 & (s = t1[i + 1])) && 128 == (192 & a) && ((u = (15 & l) << 12 | (63 & s) << 6 | 63 & a) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (a = t1[i + 2], o = t1[i + 3], 128 == (192 & (s = t1[i + 1])) && 128 == (192 & a) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & s) << 12 | (63 & a) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                    }
                    return n;
                }(this.buf, e1, t1);
            },
            readBytes: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t1);
                return this.pos = t1, e1;
            },
            readPackedVarint: function(t1, e1) {
                if (this.type !== cp.Bytes) return t1.push(this.readVarint(e1));
                var r = dp(this);
                for(t1 = t1 || []; this.pos < r;)t1.push(this.readVarint(e1));
                return t1;
            },
            readPackedSVarint: function(t1) {
                if (this.type !== cp.Bytes) return t1.push(this.readSVarint());
                var e1 = dp(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSVarint());
                return t1;
            },
            readPackedBoolean: function(t1) {
                if (this.type !== cp.Bytes) return t1.push(this.readBoolean());
                var e1 = dp(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readBoolean());
                return t1;
            },
            readPackedFloat: function(t1) {
                if (this.type !== cp.Bytes) return t1.push(this.readFloat());
                var e1 = dp(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFloat());
                return t1;
            },
            readPackedDouble: function(t1) {
                if (this.type !== cp.Bytes) return t1.push(this.readDouble());
                var e1 = dp(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readDouble());
                return t1;
            },
            readPackedFixed32: function(t1) {
                if (this.type !== cp.Bytes) return t1.push(this.readFixed32());
                var e1 = dp(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed32());
                return t1;
            },
            readPackedSFixed32: function(t1) {
                if (this.type !== cp.Bytes) return t1.push(this.readSFixed32());
                var e1 = dp(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed32());
                return t1;
            },
            readPackedFixed64: function(t1) {
                if (this.type !== cp.Bytes) return t1.push(this.readFixed64());
                var e1 = dp(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed64());
                return t1;
            },
            readPackedSFixed64: function(t1) {
                if (this.type !== cp.Bytes) return t1.push(this.readSFixed64());
                var e1 = dp(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed64());
                return t1;
            },
            skip: function(t1) {
                var e1 = 7 & t1;
                if (e1 === cp.Varint) for(; this.buf[this.pos++] > 127;);
                else if (e1 === cp.Bytes) this.pos = this.readVarint() + this.pos;
                else if (e1 === cp.Fixed32) this.pos += 4;
                else {
                    if (e1 !== cp.Fixed64) throw new Error("Unimplemented type: " + e1);
                    this.pos += 8;
                }
            },
            writeTag: function(t1, e1) {
                this.writeVarint(t1 << 3 | e1);
            },
            realloc: function(t1) {
                for(var e1 = this.length || 16; e1 < this.pos + t1;)e1 *= 2;
                if (e1 !== this.length) {
                    var r = new Uint8Array(e1);
                    r.set(this.buf), this.buf = r, this.length = e1;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(t1) {
                this.realloc(4), Mp(this.buf, t1, this.pos), this.pos += 4;
            },
            writeSFixed32: function(t1) {
                this.realloc(4), Mp(this.buf, t1, this.pos), this.pos += 4;
            },
            writeFixed64: function(t1) {
                this.realloc(8), Mp(this.buf, -1 & t1, this.pos), Mp(this.buf, Math.floor(t1 * pp), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(t1) {
                this.realloc(8), Mp(this.buf, -1 & t1, this.pos), Mp(this.buf, Math.floor(t1 * pp), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(t1) {
                (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e1) {
                    var r, n;
                    if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e1.realloc(10), function(t1, e1, r) {
                        r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, r.buf[r.pos] = 127 & (t1 >>>= 7);
                    }(r, 0, e1), function(t1, e1) {
                        var r = (7 & t1) << 4;
                        e1.buf[e1.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1)))));
                    }(n, e1);
                }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
            },
            writeSVarint: function(t1) {
                this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
            },
            writeBoolean: function(t1) {
                this.writeVarint(Boolean(t1));
            },
            writeString: function(t1) {
                t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                var e1 = this.pos;
                this.pos = function(t1, e1, r) {
                    for(var n, i, s = 0; s < e1.length; s++){
                        if ((n = e1.charCodeAt(s)) > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || s + 1 === e1.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                        n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, t1, this.pos);
                var r = this.pos - e1;
                r >= 128 && mp(e1, r, this), this.pos = e1 - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function(t1) {
                this.realloc(4), up(this.buf, t1, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(t1) {
                this.realloc(8), up(this.buf, t1, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(t1) {
                var e1 = t1.length;
                this.writeVarint(e1), this.realloc(e1);
                for(var r = 0; r < e1; r++)this.buf[this.pos++] = t1[r];
            },
            writeRawMessage: function(t1, e1) {
                this.pos++;
                var r = this.pos;
                t1(e1, this);
                var n = this.pos - r;
                n >= 128 && mp(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function(t1, e1, r) {
                this.writeTag(t1, cp.Bytes), this.writeRawMessage(e1, r);
            },
            writePackedVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, gp, e1);
            },
            writePackedSVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, xp, e1);
            },
            writePackedBoolean: function(t1, e1) {
                e1.length && this.writeMessage(t1, wp, e1);
            },
            writePackedFloat: function(t1, e1) {
                e1.length && this.writeMessage(t1, vp, e1);
            },
            writePackedDouble: function(t1, e1) {
                e1.length && this.writeMessage(t1, bp, e1);
            },
            writePackedFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, _p, e1);
            },
            writePackedSFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, Ap, e1);
            },
            writePackedFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, Sp, e1);
            },
            writePackedSFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, kp, e1);
            },
            writeBytesField: function(t1, e1) {
                this.writeTag(t1, cp.Bytes), this.writeBytes(e1);
            },
            writeFixed32Field: function(t1, e1) {
                this.writeTag(t1, cp.Fixed32), this.writeFixed32(e1);
            },
            writeSFixed32Field: function(t1, e1) {
                this.writeTag(t1, cp.Fixed32), this.writeSFixed32(e1);
            },
            writeFixed64Field: function(t1, e1) {
                this.writeTag(t1, cp.Fixed64), this.writeFixed64(e1);
            },
            writeSFixed64Field: function(t1, e1) {
                this.writeTag(t1, cp.Fixed64), this.writeSFixed64(e1);
            },
            writeVarintField: function(t1, e1) {
                this.writeTag(t1, cp.Varint), this.writeVarint(e1);
            },
            writeSVarintField: function(t1, e1) {
                this.writeTag(t1, cp.Varint), this.writeSVarint(e1);
            },
            writeStringField: function(t1, e1) {
                this.writeTag(t1, cp.Bytes), this.writeString(e1);
            },
            writeFloatField: function(t1, e1) {
                this.writeTag(t1, cp.Fixed32), this.writeFloat(e1);
            },
            writeDoubleField: function(t1, e1) {
                this.writeTag(t1, cp.Fixed64), this.writeDouble(e1);
            },
            writeBooleanField: function(t1, e1) {
                this.writeVarintField(t1, Boolean(e1));
            }
        };
        class Pp {
            constructor(t1, { pixelRatio: e1, version: r, stretchX: n, stretchY: i, content: s }){
                this.paddedRect = t1, this.pixelRatio = e1, this.stretchX = n, this.stretchY = i, this.content = s, this.version = r;
            }
            get tl() {
                return [
                    this.paddedRect.x + 1,
                    this.paddedRect.y + 1
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - 1,
                    this.paddedRect.y + this.paddedRect.h - 1
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2) / this.pixelRatio,
                    (this.paddedRect.h - 2) / this.pixelRatio
                ];
            }
        }
        class Dp {
            constructor(t1, e1){
                const r = {}, n = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(t1, r, i), this.addImages(e1, n, i);
                const { w: s, h: a } = Cp(i), o = new Qu({
                    width: s || 1,
                    height: a || 1
                });
                for(const e1 in t1){
                    const n = t1[e1], i = r[e1].paddedRect;
                    Qu.copy(n.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + 1,
                        y: i.y + 1
                    }, n.data);
                }
                for(const t1 in e1){
                    const r = e1[t1], i = n[t1].paddedRect, s = i.x + 1, a = i.y + 1, l = r.data.width, u = r.data.height;
                    Qu.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: a
                    }, r.data), Qu.copy(r.data, o, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: s,
                        y: a - 1
                    }, {
                        width: l,
                        height: 1
                    }), Qu.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: a + u
                    }, {
                        width: l,
                        height: 1
                    }), Qu.copy(r.data, o, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: s - 1,
                        y: a
                    }, {
                        width: 1,
                        height: u
                    }), Qu.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + l,
                        y: a
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = o, this.iconPositions = r, this.patternPositions = n;
            }
            addImages(t1, e1, r) {
                for(const n in t1){
                    const i = t1[n], s = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2,
                        h: i.data.height + 2
                    };
                    r.push(s), e1[n] = new Pp(s, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                }
            }
            patchUpdatedImages(t1, e1) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((e1)=>t1.hasImage(e1)), t1.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const r in t1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t1.getImage(r), e1), this.patchUpdatedImage(this.patternPositions[r], t1.getImage(r), e1);
            }
            patchUpdatedImage(t1, e1, r) {
                if (!t1 || !e1) return;
                if (t1.version === e1.version) return;
                t1.version = e1.version;
                const [n, i] = t1.tl;
                r.update(e1.data, void 0, {
                    x: n,
                    y: i
                });
            }
        }
        Oi(Pp, "ImagePosition"), Oi(Dp, "ImageAtlas");
        const Vp = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        };
        class Lp {
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
            static forText(t1, e1) {
                const r = new Lp;
                return r.scale = t1 || 1, r.fontStack = e1, r;
            }
            static forImage(t1) {
                const e1 = new Lp;
                return e1.imageName = t1, e1;
            }
        }
        class Fp {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(t1, e1) {
                const r = new Fp;
                for(let n = 0; n < t1.sections.length; n++){
                    const i = t1.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e1);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t1) {
                return this.sections[this.sectionIndex[t1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(t1) {
                return this.sectionIndex[t1];
            }
            getCharCode(t1) {
                return this.text.charCodeAt(t1);
            }
            verticalizePunctuation(t1) {
                this.text = function(t1, e1) {
                    let r = "";
                    for(let n = 0; n < t1.length; n++){
                        const i = t1.charCodeAt(n + 1) || null, s = t1.charCodeAt(n - 1) || null;
                        r += !e1 && (i && Ss(i) && !ip[t1[n + 1]] || s && Ss(s) && !ip[t1[n - 1]]) || !ip[t1[n]] ? t1[n] : ip[t1[n]];
                    }
                    return r;
                }(this.text, t1);
            }
            trim() {
                let t1 = 0;
                for(let e1 = 0; e1 < this.text.length && jp[this.text.charCodeAt(e1)]; e1++)t1++;
                let e1 = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t1 && jp[this.text.charCodeAt(r)]; r--)e1--;
                this.text = this.text.substring(t1, e1), this.sectionIndex = this.sectionIndex.slice(t1, e1);
            }
            substring(t1, e1) {
                const r = new Fp;
                return r.text = this.text.substring(t1, e1), r.sectionIndex = this.sectionIndex.slice(t1, e1), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t1, e1)=>Math.max(t1, this.sections[e1].scale), 0);
            }
            addTextSection(t1, e1) {
                this.text += t1.text, this.sections.push(Lp.forText(t1.scale, t1.fontStack || e1));
                const r = this.sections.length - 1;
                for(let e1 = 0; e1 < t1.text.length; ++e1)this.sectionIndex.push(r);
            }
            addImageSection(t1) {
                const e1 = t1.image ? t1.image.name : "";
                if (0 === e1.length) return void $("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(Lp.forImage(e1)), this.sectionIndex.push(this.sections.length - 1)) : $("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function Rp(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d) {
            const y = Fp.fromFeature(t1, i);
            h === Vp.vertical && y.verticalizePunctuation(p);
            let m = [];
            const g = function(t1, e1, r, n, i, s) {
                if (!t1) return [];
                const a = [], o = function(t1, e1, r, n, i, s) {
                    let a = 0;
                    for(let r = 0; r < t1.length(); r++){
                        const o = t1.getSection(r);
                        a += $p(t1.getCharCode(r), o, n, i, e1, s);
                    }
                    return a / Math.max(1, Math.ceil(a / r));
                }(t1, e1, r, n, i, s), l = t1.text.indexOf("\u200B") >= 0;
                let u = 0;
                for(let r = 0; r < t1.length(); r++){
                    const h = t1.getSection(r), p = t1.getCharCode(r);
                    if (jp[p] || (u += $p(p, h, n, i, e1, s)), r < t1.length() - 1) {
                        const e1 = !((c = p) < 11904 || !(ns(c) || rs(c) || ms(c) || fs(c) || os(c) || Hi(c) || is(c) || Qi(c) || ls(c) || us(c) || as(c) || vs(c) || ts(c) || Ji(c) || Wi(c) || ss(c) || es(c) || ys(c) || hs(c) || cs(c)));
                        (Up[p] || e1 || h.imageName) && a.push(Np(r + 1, u, o, a, qp(p, t1.getCharCode(r + 1), e1 && l), !1));
                    }
                }
                var c;
                return Gp(Np(t1.length(), u, o, a, 0, !0));
            }(y, u, s, e1, n, f), { processBidirectionalText: x, processStyledBidirectionalText: v } = js;
            if (x && 1 === y.sections.length) {
                const t1 = x(y.toString(), g);
                for (const e1 of t1){
                    const t1 = new Fp;
                    t1.text = e1, t1.sections = y.sections;
                    for(let r = 0; r < e1.length; r++)t1.sectionIndex.push(0);
                    m.push(t1);
                }
            } else if (v) {
                const t1 = v(y.text, y.sectionIndex, g);
                for (const e1 of t1){
                    const t1 = new Fp;
                    t1.text = e1[0], t1.sectionIndex = e1[1], t1.sections = y.sections, m.push(t1);
                }
            } else m = function(t1, e1) {
                const r = [], n = t1.text;
                let i = 0;
                for (const n of e1)r.push(t1.substring(i, n)), i = n;
                return i < n.length && r.push(t1.substring(i, n.length)), r;
            }(y, g);
            const b = [], w = {
                positionedLines: b,
                text: y.toString(),
                top: c[1],
                bottom: c[1],
                left: c[0],
                right: c[0],
                writingMode: h,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            return function(t1, e1, r, n, i, s, a, o, l, u, c, h) {
                let p = 0, f = 0, d = 0;
                const y = "right" === o ? 1 : "left" === o ? 0 : .5;
                let m = !1;
                for (const t1 of i){
                    const r = t1.getSections();
                    for (const t1 of r){
                        if (t1.imageName) continue;
                        const r = e1[t1.fontStack];
                        if (r && (m = void 0 !== r.ascender && void 0 !== r.descender, !m)) break;
                    }
                    if (!m) break;
                }
                let g = 0;
                for (const a of i){
                    a.trim();
                    const i = a.getMaxScale(), o = (i - 1) * Wh, v = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t1.positionedLines[g] = v;
                    const b = v.positionedGlyphs;
                    let w = 0;
                    if (!a.length()) {
                        f += s, ++g;
                        continue;
                    }
                    let _ = 0, A = 0;
                    for(let s = 0; s < a.length(); s++){
                        const o = a.getSection(s), d = a.getSectionIndex(s), y = a.getCharCode(s);
                        let g = o.scale, v = null, S = null, k = null, I = Wh, M = 0;
                        const T = !(l === Vp.horizontal || !c && !As(y) || c && (jp[y] || (x = y, Zi(x) || Ki(x) || Yi(x) || ds(x) || xs(x))));
                        if (o.imageName) {
                            const e1 = n[o.imageName];
                            if (!e1) continue;
                            k = o.imageName, t1.iconsInText = t1.iconsInText || !0, S = e1.paddedRect;
                            const r = e1.displaySize;
                            g = g * Wh / h, v = {
                                width: r[0],
                                height: r[1],
                                left: 1,
                                top: -3,
                                advance: T ? r[1] : r[0],
                                localGlyph: !1
                            }, M = m ? -v.height * g : i * Wh - 17 - r[1] * g, I = v.advance;
                            const s = (T ? r[0] : r[1]) * g - Wh * i;
                            s > 0 && s > w && (w = s);
                        } else {
                            const t1 = r[o.fontStack];
                            if (!t1) continue;
                            t1[y] && (S = t1[y]);
                            const n = e1[o.fontStack];
                            if (!n) continue;
                            const s = n.glyphs[y];
                            if (!s) continue;
                            if (v = s.metrics, I = 8203 !== y ? Wh : 0, m) {
                                const t1 = void 0 !== n.ascender ? Math.abs(n.ascender) : 0, e1 = void 0 !== n.descender ? Math.abs(n.descender) : 0, r = (t1 + e1) * g;
                                _ < r && (_ = r, A = (t1 - e1) / 2 * g), M = -t1 * g;
                            } else M = (i - g) * Wh - 17;
                        }
                        T ? (t1.verticalizable = !0, b.push({
                            glyph: y,
                            imageName: k,
                            x: p,
                            y: f + M,
                            vertical: T,
                            scale: g,
                            localGlyph: v.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: d,
                            metrics: v,
                            rect: S
                        }), p += I * g + u) : (b.push({
                            glyph: y,
                            imageName: k,
                            x: p,
                            y: f + M,
                            vertical: T,
                            scale: g,
                            localGlyph: v.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: d,
                            metrics: v,
                            rect: S
                        }), p += v.advance * g + u);
                    }
                    0 !== b.length && (d = Math.max(p - u, d), m ? Zp(b, y, w, A, s * i / 2) : Zp(b, y, w, 0, s / 2)), p = 0;
                    const S = s * i + w;
                    v.lineOffset = Math.max(w, o), f += S, ++g;
                }
                var x;
                const v = f, { horizontalAlign: b, verticalAlign: w } = Xp(a);
                (function(t1, e1, r, n, i, s) {
                    const a = (e1 - r) * i, o = -s * n;
                    for (const e1 of t1)for (const t1 of e1.positionedGlyphs)t1.x += a, t1.y += o;
                })(t1.positionedLines, y, b, w, d, v), t1.top += -w * v, t1.bottom = t1.top + v, t1.left += -b * d, t1.right = t1.left + d, t1.hasBaseline = m;
            }(w, e1, r, n, m, a, o, l, h, u, p, d), !function(t1) {
                for (const e1 of t1)if (0 !== e1.positionedGlyphs.length) return !1;
                return !0;
            }(b) && w;
        }
        const jp = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, Up = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function $p(t1, e1, r, n, i, s) {
            if (e1.imageName) {
                const t1 = n[e1.imageName];
                return t1 ? t1.displaySize[0] * e1.scale * Wh / s + i : 0;
            }
            {
                const n = r[e1.fontStack], s = n && n.glyphs[t1];
                return s ? s.metrics.advance * e1.scale + i : 0;
            }
        }
        function Op(t1, e1, r, n) {
            const i = Math.pow(t1 - e1, 2);
            return n ? t1 < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function qp(t1, e1, r) {
            let n = 0;
            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e1 && 65289 !== e1 || (n += 50), n;
        }
        function Np(t1, e1, r, n, i, s) {
            let a = null, o = Op(e1, r, i, s);
            for (const t1 of n){
                const n = Op(e1 - t1.x, r, i, s) + t1.badness;
                n <= o && (a = t1, o = n);
            }
            return {
                index: t1,
                x: e1,
                priorBreak: a,
                badness: o
            };
        }
        function Gp(t1) {
            return t1 ? Gp(t1.priorBreak).concat(t1.index) : [];
        }
        function Xp(t1) {
            let e1 = .5, r = .5;
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    e1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e1 = 0;
            }
            switch(t1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e1,
                verticalAlign: r
            };
        }
        function Zp(t1, e1, r, n, i) {
            if (!(e1 || r || n || i)) return;
            const s = t1.length - 1, a = t1[s], o = (a.x + a.metrics.advance * a.scale) * e1;
            for(let e1 = 0; e1 <= s; e1++)t1[e1].x -= o, t1[e1].y += r + n + i;
        }
        function Kp(t1, e1, r) {
            const { horizontalAlign: n, verticalAlign: i } = Xp(r), s = e1[0] - t1.displaySize[0] * n, a = e1[1] - t1.displaySize[1] * i;
            return {
                image: t1,
                top: a,
                bottom: a + t1.displaySize[1],
                left: s,
                right: s + t1.displaySize[0]
            };
        }
        function Yp(t1, e1, r, n, i, s) {
            const a = t1.image;
            let o;
            if (a.content) {
                const t1 = a.content, e1 = a.pixelRatio || 1;
                o = [
                    t1[0] / e1,
                    t1[1] / e1,
                    a.displaySize[0] - t1[2] / e1,
                    a.displaySize[1] - t1[3] / e1
                ];
            }
            const l = e1.left * s, u = e1.right * s;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - a.displaySize[0]) / 2, h = f + a.displaySize[0]);
            const d = e1.top * s, y = e1.bottom * s;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + y + n[2]) : (c = i[1] + (d + y - a.displaySize[1]) / 2, p = c + a.displaySize[1]), {
                image: a,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        class Hp extends d {
            constructor(t1, e1, r, n, i){
                super(t1, e1), this.angle = n, this.z = r, void 0 !== i && (this.segment = i);
            }
            clone() {
                return new Hp(this.x, this.y, this.z, this.angle, this.segment);
            }
        }
        function Wp(t1, e1, r, n, i) {
            if (void 0 === e1.segment) return !0;
            let s = e1, a = e1.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (a--, a < 0) return !1;
                o -= t1[a].dist(s), s = t1[a];
            }
            o += t1[a].dist(t1[a + 1]), a++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e1 = t1[a], r = t1[a + 1];
                if (!r) return !1;
                let s = t1[a - 1].angleTo(e1) - e1.angleTo(r);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: s
                }), u += s; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                a++, o += e1.dist(r);
            }
            return !0;
        }
        function Jp(t1) {
            let e1 = 0;
            for(let r = 0; r < t1.length - 1; r++)e1 += t1[r].dist(t1[r + 1]);
            return e1;
        }
        function Qp(t1, e1, r) {
            return t1 ? .6 * e1 * r : 0;
        }
        function tf(t1, e1) {
            return Math.max(t1 ? t1.right - t1.left : 0, e1 ? e1.right - e1.left : 0);
        }
        function ef(t1, e1, r, n, i, s) {
            const a = Qp(r, i, s), o = tf(r, n) * s;
            let l = 0;
            const u = Jp(t1) / 2;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1], s = n.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = Mr(n.x, i.x, c), p = Mr(n.y, i.y, c), f = new Hp(h, p, 0, i.angleTo(n), r);
                    return !a || Wp(t1, f, o, a, e1) ? f : void 0;
                }
                l += s;
            }
        }
        function rf(t1, e1, r, n, i, s, a, o, l) {
            const u = Qp(n, s, a), c = tf(n, i), h = c * a, p = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
            return e1 - h < e1 / 4 && (e1 = h + e1 / 4), nf(t1, p ? e1 / 2 * o % e1 : (c / 2 + 2 * s) * a * o % e1, e1, u, r, h, p, !1, l);
        }
        function nf(t1, e1, r, n, i, s, a, o, l) {
            const u = s / 2, c = Jp(t1);
            let h = 0, p = e1 - r, f = [];
            for(let e1 = 0; e1 < t1.length - 1; e1++){
                const a = t1[e1], o = t1[e1 + 1], d = a.dist(o), y = o.angleTo(a);
                for(; p + r < h + d;){
                    p += r;
                    const m = (p - h) / d, g = Mr(a.x, o.x, m), x = Mr(a.y, o.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new Hp(g, x, 0, y, e1);
                        r._round(), n && !Wp(t1, r, s, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || a || (f = nf(t1, h / 2, r, n, i, s, a, !0, l)), f;
        }
        function sf(t1, e1, r, n, i) {
            const s = [];
            for(let a = 0; a < t1.length; a++){
                const o = t1[a];
                let l;
                for(let t1 = 0; t1 < o.length - 1; t1++){
                    let a = o[t1], u = o[t1 + 1];
                    a.x < e1 && u.x < e1 || (a.x < e1 ? a = new d(e1, a.y + (e1 - a.x) / (u.x - a.x) * (u.y - a.y))._round() : u.x < e1 && (u = new d(e1, a.y + (e1 - a.x) / (u.x - a.x) * (u.y - a.y))._round()), a.y < r && u.y < r || (a.y < r ? a = new d(a.x + (r - a.y) / (u.y - a.y) * (u.x - a.x), r)._round() : u.y < r && (u = new d(a.x + (r - a.y) / (u.y - a.y) * (u.x - a.x), r)._round()), a.x >= n && u.x >= n || (a.x >= n ? a = new d(n, a.y + (n - a.x) / (u.x - a.x) * (u.y - a.y))._round() : u.x >= n && (u = new d(n, a.y + (n - a.x) / (u.x - a.x) * (u.y - a.y))._round()), a.y >= i && u.y >= i || (a.y >= i ? a = new d(a.x + (i - a.y) / (u.y - a.y) * (u.x - a.x), i)._round() : u.y >= i && (u = new d(a.x + (i - a.y) / (u.y - a.y) * (u.x - a.x), i)._round()), l && a.equals(l[l.length - 1]) || (l = [
                        a
                    ], s.push(l)), l.push(u)))));
                }
            }
            return s;
        }
        Oi(Hp, "Anchor");
        const af = 1e20;
        function of(t1, e1, r, n, i, s, a, o, l) {
            for(let u = e1; u < e1 + n; u++)lf(t1, r * s + u, s, i, a, o, l);
            for(let u = r; u < r + i; u++)lf(t1, u * s + e1, 1, n, a, o, l);
        }
        function lf(t1, e1, r, n, i, s, a) {
            s[0] = 0, a[0] = -af, a[1] = af, i[0] = t1[e1];
            for(let o = 1, l = 0, u = 0; o < n; o++){
                i[o] = t1[e1 + o * r];
                const n = o * o;
                do {
                    const t1 = s[l];
                    u = (i[o] - i[t1] + n - t1 * t1) / (o - t1) / 2;
                }while (u <= a[l] && --l > -1);
                l++, s[l] = o, a[l] = u, a[l + 1] = af;
            }
            for(let o = 0, l = 0; o < n; o++){
                for(; a[l + 1] < o;)l++;
                const n = s[l], u = o - n;
                t1[e1 + o * r] = i[n] + u * u;
            }
        }
        const uf = {
            none: 0,
            ideographs: 1,
            all: 2
        };
        class cf {
            constructor(t1, e1, r){
                this.requestManager = t1, this.localGlyphMode = e1, this.localFontFamily = r, this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
            setURL(t1) {
                this.url = t1;
            }
            getGlyphs(t1, e1) {
                const r = [];
                for(const e1 in t1)for (const n of t1[e1])r.push({
                    stack: e1,
                    id: n
                });
                M(r, ({ stack: t1, id: e1 }, r)=>{
                    let n = this.entries[t1];
                    n || (n = this.entries[t1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let i = n.glyphs[e1];
                    if (void 0 !== i) return void r(null, {
                        stack: t1,
                        id: e1,
                        glyph: i
                    });
                    if (i = this._tinySDF(n, t1, e1), i) return n.glyphs[e1] = i, void r(null, {
                        stack: t1,
                        id: e1,
                        glyph: i
                    });
                    const s = Math.floor(e1 / 256);
                    if (256 * s > 65535) return void r(new Error("glyphs > 65535 not supported"));
                    if (n.ranges[s]) return void r(null, {
                        stack: t1,
                        id: e1,
                        glyph: i
                    });
                    let a = n.requests[s];
                    a || (a = n.requests[s] = [], cf.loadGlyphRange(t1, s, this.url, this.requestManager, (t1, e1)=>{
                        if (e1) {
                            n.ascender = e1.ascender, n.descender = e1.descender;
                            for(const t1 in e1.glyphs)this._doesCharSupportLocalGlyph(+t1) || (n.glyphs[+t1] = e1.glyphs[+t1]);
                            n.ranges[s] = !0;
                        }
                        for (const r of a)r(t1, e1);
                        delete n.requests[s];
                    })), a.push((n, i)=>{
                        n ? r(n) : i && r(null, {
                            stack: t1,
                            id: e1,
                            glyph: i.glyphs[e1] || null
                        });
                    });
                }, (t1, r)=>{
                    if (t1) e1(t1);
                    else if (r) {
                        const t1 = {};
                        for (const { stack: e1, id: n, glyph: i } of r)void 0 === t1[e1] && (t1[e1] = {}), void 0 === t1[e1].glyphs && (t1[e1].glyphs = {}), t1[e1].glyphs[n] = i && {
                            id: i.id,
                            bitmap: i.bitmap.clone(),
                            metrics: i.metrics
                        }, t1[e1].ascender = this.entries[e1].ascender, t1[e1].descender = this.entries[e1].descender;
                        e1(null, t1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(t1) {
                return this.localGlyphMode !== uf.none && (this.localGlyphMode === uf.all ? !!this.localFontFamily : !!this.localFontFamily && (us(t1) || ps(t1) || ts(t1) || es(t1) || Qi(t1)));
            }
            _tinySDF(t1, e1, r) {
                const n = this.localFontFamily;
                if (!n || !this._doesCharSupportLocalGlyph(r)) return;
                let i = t1.tinySDF;
                if (!i) {
                    let r = "400";
                    /bold/i.test(e1) ? r = "900" : /medium/i.test(e1) ? r = "500" : /light/i.test(e1) && (r = "200"), i = t1.tinySDF = new cf.TinySDF({
                        fontFamily: n,
                        fontWeight: r,
                        fontSize: 48,
                        buffer: 6,
                        radius: 16
                    }), i.fontWeight = r;
                }
                if (this.localGlyphs[i.fontWeight][r]) return this.localGlyphs[i.fontWeight][r];
                const s = String.fromCharCode(r), { data: a, width: o, height: l, glyphWidth: u, glyphHeight: c, glyphLeft: h, glyphTop: p, glyphAdvance: f } = i.draw(s);
                return this.localGlyphs[i.fontWeight][r] = {
                    id: r,
                    bitmap: new Ju({
                        width: o,
                        height: l
                    }, a),
                    metrics: {
                        width: u / 2,
                        height: c / 2,
                        left: h / 2,
                        top: p / 2 - 27,
                        advance: f / 2,
                        localGlyph: !0
                    }
                };
            }
        }
        function hf(t1, e1, r, n) {
            const i = [], s = t1.image, a = s.pixelRatio, o = s.paddedRect.w - 2, l = s.paddedRect.h - 2, u = t1.right - t1.left, c = t1.bottom - t1.top, h = s.stretchX || [
                [
                    0,
                    o
                ]
            ], p = s.stretchY || [
                [
                    0,
                    l
                ]
            ], f = (t1, e1)=>t1 + e1[1] - e1[0], y = h.reduce(f, 0), m = p.reduce(f, 0), g = o - y, x = l - m;
            let v = 0, b = y, w = 0, _ = m, A = 0, S = g, k = 0, I = x;
            if (s.content && n) {
                const t1 = s.content;
                v = pf(h, 0, t1[0]), w = pf(p, 0, t1[1]), b = pf(h, t1[0], t1[2]), _ = pf(p, t1[1], t1[3]), A = t1[0] - v, k = t1[1] - w, S = t1[2] - t1[0] - b, I = t1[3] - t1[1] - _;
            }
            const M = (n, i, o, l)=>{
                const h = df(n.stretch - v, b, u, t1.left), p = yf(n.fixed - A, S, n.stretch, y), f = df(i.stretch - w, _, c, t1.top), g = yf(i.fixed - k, I, i.stretch, m), x = df(o.stretch - v, b, u, t1.left), M = yf(o.fixed - A, S, o.stretch, y), T = df(l.stretch - w, _, c, t1.top), z = yf(l.fixed - k, I, l.stretch, m), B = new d(h, f), E = new d(x, f), C = new d(x, T), P = new d(h, T), D = new d(p / a, g / a), V = new d(M / a, z / a), L = e1 * Math.PI / 180;
                if (L) {
                    const t1 = Math.sin(L), e1 = Math.cos(L), r = [
                        e1,
                        -t1,
                        t1,
                        e1
                    ];
                    B._matMult(r), E._matMult(r), P._matMult(r), C._matMult(r);
                }
                const F = n.stretch + n.fixed, R = i.stretch + i.fixed;
                return {
                    tl: B,
                    tr: E,
                    bl: P,
                    br: C,
                    tex: {
                        x: s.paddedRect.x + 1 + F,
                        y: s.paddedRect.y + 1 + R,
                        w: o.stretch + o.fixed - F,
                        h: l.stretch + l.fixed - R
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: D,
                    pixelOffsetBR: V,
                    minFontScaleX: S / a / u,
                    minFontScaleY: I / a / c,
                    isSDF: r
                };
            };
            if (n && (s.stretchX || s.stretchY)) {
                const t1 = ff(h, g, y), e1 = ff(p, x, m);
                for(let r = 0; r < t1.length - 1; r++){
                    const n = t1[r], s = t1[r + 1];
                    for(let t1 = 0; t1 < e1.length - 1; t1++)i.push(M(n, e1[t1], s, e1[t1 + 1]));
                }
            } else i.push(M({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: o + 1
            }, {
                fixed: 0,
                stretch: l + 1
            }));
            return i;
        }
        function pf(t1, e1, r) {
            let n = 0;
            for (const i of t1)n += Math.max(e1, Math.min(r, i[1])) - Math.max(e1, Math.min(r, i[0]));
            return n;
        }
        function ff(t1, e1, r) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [e1, r] of t1){
                const t1 = n[n.length - 1];
                n.push({
                    fixed: e1 - t1.stretch,
                    stretch: t1.stretch
                }), n.push({
                    fixed: e1 - t1.stretch,
                    stretch: t1.stretch + (r - e1)
                });
            }
            return n.push({
                fixed: e1 + 1,
                stretch: r
            }), n;
        }
        function df(t1, e1, r, n) {
            return t1 / e1 * r + n;
        }
        function yf(t1, e1, r, n) {
            return t1 - e1 * r / n;
        }
        function mf(t1, e1, r, n) {
            const i = e1 + t1.positionedLines[n].lineOffset;
            return 0 === n ? r + i / 2 : r + (i + (e1 + t1.positionedLines[n - 1].lineOffset)) / 2;
        }
        cf.loadGlyphRange = function(t1, e1, r, n, i) {
            const s = 256 * e1, a = s + 255, o = n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}", t1).replace("{range}", `${s}-${a}`), st.Glyphs);
            ut(o, (t1, e1)=>{
                if (t1) i(t1);
                else if (e1) {
                    const t1 = {}, r = function(t1) {
                        return new op(t1).readFields(zp, {});
                    }(e1);
                    for (const e1 of r.glyphs)t1[e1.id] = e1;
                    i(null, {
                        glyphs: t1,
                        ascender: r.ascender,
                        descender: r.descender
                    });
                }
            });
        }, cf.TinySDF = class {
            constructor({ fontSize: t1 = 24, buffer: e1 = 3, radius: r = 8, cutoff: n = .25, fontFamily: i = "sans-serif", fontWeight: s = "normal", fontStyle: a = "normal" } = {}){
                this.buffer = e1, this.cutoff = n, this.radius = r;
                const o = this.size = t1 + 4 * e1, l = this._createCanvas(o), u = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                u.font = `${a} ${s} ${t1}px ${i}`, u.textBaseline = "alphabetic", u.textAlign = "left", u.fillStyle = "black", this.gridOuter = new Float64Array(o * o), this.gridInner = new Float64Array(o * o), this.f = new Float64Array(o), this.z = new Float64Array(o + 1), this.v = new Uint16Array(o);
            }
            _createCanvas(t1) {
                const e1 = document.createElement("canvas");
                return e1.width = e1.height = t1, e1;
            }
            draw(t1) {
                const { width: e1, actualBoundingBoxAscent: r, actualBoundingBoxDescent: n, actualBoundingBoxLeft: i, actualBoundingBoxRight: s } = this.ctx.measureText(t1), a = Math.ceil(r), o = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(s - i))), l = Math.min(this.size - this.buffer, a + Math.ceil(n)), u = o + 2 * this.buffer, c = l + 2 * this.buffer, h = Math.max(u * c, 0), p = new Uint8ClampedArray(h), f = {
                    data: p,
                    width: u,
                    height: c,
                    glyphWidth: o,
                    glyphHeight: l,
                    glyphTop: a,
                    glyphLeft: 0,
                    glyphAdvance: e1
                };
                if (0 === o || 0 === l) return f;
                const { ctx: d, buffer: y, gridInner: m, gridOuter: g } = this;
                d.clearRect(y, y, o, l), d.fillText(t1, y, y + a);
                const x = d.getImageData(y, y, o, l);
                g.fill(af, 0, h), m.fill(0, 0, h);
                for(let t1 = 0; t1 < l; t1++)for(let e1 = 0; e1 < o; e1++){
                    const r = x.data[4 * (t1 * o + e1) + 3] / 255;
                    if (0 === r) continue;
                    const n = (t1 + y) * u + e1 + y;
                    if (1 === r) g[n] = 0, m[n] = af;
                    else {
                        const t1 = .5 - r;
                        g[n] = t1 > 0 ? t1 * t1 : 0, m[n] = t1 < 0 ? t1 * t1 : 0;
                    }
                }
                of(g, 0, 0, u, c, u, this.f, this.v, this.z), of(m, y, y, o, l, u, this.f, this.v, this.z);
                for(let t1 = 0; t1 < h; t1++){
                    const e1 = Math.sqrt(g[t1]) - Math.sqrt(m[t1]);
                    p[t1] = Math.round(255 - 255 * (e1 / this.radius + this.cutoff));
                }
                return f;
            }
        };
        class gf {
            constructor(t1 = [], e1 = xf){
                if (this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(let t1 = (this.length >> 1) - 1; t1 >= 0; t1--)this._down(t1);
            }
            push(t1) {
                this.data.push(t1), this.length++, this._up(this.length - 1);
            }
            pop() {
                if (0 === this.length) return;
                const t1 = this.data[0], e1 = this.data.pop();
                return this.length--, this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
            }
            peek() {
                return this.data[0];
            }
            _up(t1) {
                const { data: e1, compare: r } = this, n = e1[t1];
                for(; t1 > 0;){
                    const i = t1 - 1 >> 1, s = e1[i];
                    if (r(n, s) >= 0) break;
                    e1[t1] = s, t1 = i;
                }
                e1[t1] = n;
            }
            _down(t1) {
                const { data: e1, compare: r } = this, n = this.length >> 1, i = e1[t1];
                for(; t1 < n;){
                    let n = 1 + (t1 << 1), s = e1[n];
                    const a = n + 1;
                    if (a < this.length && r(e1[a], s) < 0 && (n = a, s = e1[a]), r(s, i) >= 0) break;
                    e1[t1] = s, t1 = n;
                }
                e1[t1] = i;
            }
        }
        function xf(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function vf(t1, e1 = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, s = -1 / 0, a = -1 / 0;
            const o = t1[0];
            for(let t1 = 0; t1 < o.length; t1++){
                const e1 = o[t1];
                (!t1 || e1.x < n) && (n = e1.x), (!t1 || e1.y < i) && (i = e1.y), (!t1 || e1.x > s) && (s = e1.x), (!t1 || e1.y > a) && (a = e1.y);
            }
            const l = Math.min(s - n, a - i);
            let u = l / 2;
            const c = new gf([], bf);
            if (0 === l) return new d(n, i);
            for(let e1 = n; e1 < s; e1 += l)for(let r = i; r < a; r += l)c.push(new wf(e1 + u, r + u, u, t1));
            let h = function(t1) {
                let e1 = 0, r = 0, n = 0;
                const i = t1[0];
                for(let t1 = 0, s = i.length, a = s - 1; t1 < s; a = t1++){
                    const s = i[t1], o = i[a], l = s.x * o.y - o.x * s.y;
                    r += (s.x + o.x) * l, n += (s.y + o.y) * l, e1 += 3 * l;
                }
                return new wf(r / e1, n / e1, 0, t1);
            }(t1), p = c.length;
            for(; c.length;){
                const n = c.pop();
                (n.d > h.d || !h.d) && (h = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, p)), n.max - h.d <= e1 || (u = n.h / 2, c.push(new wf(n.p.x - u, n.p.y - u, u, t1)), c.push(new wf(n.p.x + u, n.p.y - u, u, t1)), c.push(new wf(n.p.x - u, n.p.y + u, u, t1)), c.push(new wf(n.p.x + u, n.p.y + u, u, t1)), p += 4);
            }
            return r && (console.log(`num probes: ${p}`), console.log(`best distance: ${h.d}`)), h.p;
        }
        function bf(t1, e1) {
            return e1.max - t1.max;
        }
        function wf(t1, e1, r, n) {
            this.p = new d(t1, e1), this.h = r, this.d = function(t1, e1) {
                let r = !1, n = 1 / 0;
                for(let i = 0; i < e1.length; i++){
                    const s = e1[i];
                    for(let e1 = 0, i = s.length, a = i - 1; e1 < i; a = e1++){
                        const i = s[e1], o = s[a];
                        i.y > t1.y != o.y > t1.y && t1.x < (o.x - i.x) * (t1.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, Cu(t1, i, o));
                    }
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        const _f = Number.POSITIVE_INFINITY, Af = Math.sqrt(2);
        function Sf(t1, [e1, r]) {
            let n = 0, i = 0;
            if (r === _f) {
                e1 < 0 && (e1 = 0);
                const r = e1 / Af;
                switch(t1){
                    case "top-right":
                    case "top-left":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        i = 7 - r;
                        break;
                    case "bottom":
                        i = 7 - e1;
                        break;
                    case "top":
                        i = e1 - 7;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                        n = -r;
                        break;
                    case "top-left":
                    case "bottom-left":
                        n = r;
                        break;
                    case "left":
                        n = e1;
                        break;
                    case "right":
                        n = -e1;
                }
            } else {
                switch(e1 = Math.abs(e1), r = Math.abs(r), t1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e1;
                }
            }
            return [
                n,
                i
            ];
        }
        function kf(t1, e1, r, n, i, s, a, o, l, u) {
            t1.createArrays(), t1.tilePixelRatio = ko / (512 * t1.overscaling), t1.compareText = {}, t1.iconsNeedLinear = !1;
            const c = t1.layers[0].layout, h = t1.layers[0]._unevaluatedLayout._values, p = {};
            if ("composite" === t1.textSizeData.kind) {
                const { minZoom: e1, maxZoom: r } = t1.textSizeData;
                p.compositeTextSizes = [
                    h["text-size"].possiblyEvaluate(new Us(e1), o),
                    h["text-size"].possiblyEvaluate(new Us(r), o)
                ];
            }
            if ("composite" === t1.iconSizeData.kind) {
                const { minZoom: e1, maxZoom: r } = t1.iconSizeData;
                p.compositeIconSizes = [
                    h["icon-size"].possiblyEvaluate(new Us(e1), o),
                    h["icon-size"].possiblyEvaluate(new Us(r), o)
                ];
            }
            p.layoutTextSize = h["text-size"].possiblyEvaluate(new Us(l + 1), o), p.layoutIconSize = h["icon-size"].possiblyEvaluate(new Us(l + 1), o), p.textMaxSize = h["text-size"].possiblyEvaluate(new Us(18), o);
            const f = "map" === c.get("text-rotation-alignment") && "point" !== c.get("symbol-placement"), d = c.get("text-size");
            for (const s of t1.features){
                const l = c.get("text-font").evaluate(s, {}, o).join(","), h = d.evaluate(s, {}, o), y = p.layoutTextSize.evaluate(s, {}, o), m = (p.layoutIconSize.evaluate(s, {}, o), {
                    horizontal: {},
                    vertical: void 0
                }), g = s.text;
                let x, v = [
                    0,
                    0
                ];
                if (g) {
                    const n = g.toString(), a = c.get("text-letter-spacing").evaluate(s, {}, o) * Wh, u = c.get("text-line-height").evaluate(s, {}, o) * Wh, p = ws(n) ? a : 0, d = c.get("text-anchor").evaluate(s, {}, o), x = c.get("text-variable-anchor");
                    if (!x) {
                        const t1 = c.get("text-radial-offset").evaluate(s, {}, o);
                        v = t1 ? Sf(d, [
                            t1 * Wh,
                            _f
                        ]) : c.get("text-offset").evaluate(s, {}, o).map((t1)=>t1 * Wh);
                    }
                    let b = f ? "center" : c.get("text-justify").evaluate(s, {}, o);
                    const w = "point" === c.get("symbol-placement"), _ = w ? c.get("text-max-width").evaluate(s, {}, o) * Wh : 1 / 0, A = (s)=>{
                        t1.allowVerticalPlacement && bs(n) && (m.vertical = Rp(g, e1, r, i, l, _, u, d, s, p, v, Vp.vertical, !0, y, h));
                    };
                    if (!f && x) {
                        const t1 = "auto" === b ? x.map((t1)=>If(t1)) : [
                            b
                        ];
                        let n = !1;
                        for(let s = 0; s < t1.length; s++){
                            const a = t1[s];
                            if (!m.horizontal[a]) {
                                if (n) m.horizontal[a] = m.horizontal[0];
                                else {
                                    const t1 = Rp(g, e1, r, i, l, _, u, "center", a, p, v, Vp.horizontal, !1, y, h);
                                    t1 && (m.horizontal[a] = t1, n = 1 === t1.positionedLines.length);
                                }
                            }
                        }
                        A("left");
                    } else {
                        if ("auto" === b && (b = If(d)), w || c.get("text-writing-mode").indexOf("horizontal") >= 0 || !bs(n)) {
                            const t1 = Rp(g, e1, r, i, l, _, u, d, b, p, v, Vp.horizontal, !1, y, h);
                            t1 && (m.horizontal[b] = t1);
                        }
                        A(w ? "left" : b);
                    }
                }
                let b = !1;
                if (s.icon && s.icon.name) {
                    const e1 = n[s.icon.name];
                    e1 && (x = Kp(i[s.icon.name], c.get("icon-offset").evaluate(s, {}, o), c.get("icon-anchor").evaluate(s, {}, o)), b = e1.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = e1.sdf : t1.sdfIcons !== e1.sdf && $("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (e1.pixelRatio !== t1.pixelRatio || 0 !== c.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0));
                }
                const w = Bf(m.horizontal) || m.vertical;
                t1.iconsInText || (t1.iconsInText = !!w && w.iconsInText), (w || x) && Mf(t1, s, m, x, n, p, y, 0, v, b, a, o, u);
            }
            s && t1.generateCollisionDebugBuffers(l, t1.collisionBoxArray);
        }
        function If(t1) {
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Mf(t1, e1, r, n, i, s, a, o, l, u, c, h, p) {
            let f = s.textMaxSize.evaluate(e1, {}, h);
            void 0 === f && (f = a);
            const d = t1.layers[0].layout, y = d.get("icon-offset").evaluate(e1, {}, h), m = Bf(r.horizontal) || r.vertical, g = "globe" === p.name, v = a / 24, b = t1.tilePixelRatio * f / 24, w = (z = t1.overscaling, t1.zoom > 18 && z > 2 && (z >>= 1), Math.max(ko / (512 * z), 1) * d.get("symbol-spacing")), _ = d.get("text-padding") * t1.tilePixelRatio, A = d.get("icon-padding") * t1.tilePixelRatio, S = x(d.get("text-max-angle")), k = "map" === d.get("text-rotation-alignment") && "point" !== d.get("symbol-placement"), I = "map" === d.get("icon-rotation-alignment") && "point" !== d.get("symbol-placement"), M = d.get("symbol-placement"), T = w / 2;
            var z;
            const B = d.get("icon-text-fit");
            let E;
            n && "none" !== B && (t1.allowVerticalPlacement && r.vertical && (E = Yp(n, r.vertical, B, d.get("icon-text-fit-padding"), y, v)), m && (n = Yp(n, m, B, d.get("icon-text-fit-padding"), y, v)));
            const C = (a, o, f)=>{
                if (o.x < 0 || o.x >= ko || o.y < 0 || o.y >= ko) return;
                let d = null;
                if (g) {
                    const { x: t1, y: e1, z: r } = p.projectTilePoint(o.x, o.y, f);
                    d = {
                        anchor: new Hp(t1, e1, r, 0, void 0),
                        up: p.upVector(f, o.x, o.y)
                    };
                }
                !function(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S) {
                    const k = t1.addToLineVertexArray(e1, n);
                    let I, M, T, z, B, E, C, P = 0, D = 0, V = 0, L = 0, F = -1, R = -1;
                    const j = {};
                    let U = qa("");
                    const O = r ? r.anchor : e1;
                    let q = 0, N = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset") ? [q, N] = l.layout.get("text-offset").evaluate(b, {}, S).map((t1)=>t1 * Wh) : (q = l.layout.get("text-radial-offset").evaluate(b, {}, S) * Wh, N = _f), t1.allowVerticalPlacement && i.vertical) {
                        const t1 = i.vertical;
                        if (d) E = Cf(t1), o && (C = Cf(o));
                        else {
                            const r = l.layout.get("text-rotate").evaluate(b, {}, S) + 90;
                            T = Ef(u, O, e1, c, h, p, t1, f, r, y), o && (z = Ef(u, O, e1, c, h, p, o, g, r));
                        }
                    }
                    if (s) {
                        const n = l.layout.get("icon-rotate").evaluate(b, {}, S), i = "none" !== l.layout.get("icon-text-fit"), a = hf(s, n, _, i), f = o ? hf(o, n, _, i) : void 0;
                        M = Ef(u, O, e1, c, h, p, s, g, n), P = 4 * a.length;
                        const d = t1.iconSizeData;
                        let y = null;
                        "source" === d.kind ? (y = [
                            Jh * l.layout.get("icon-size").evaluate(b, {}, S)
                        ], y[0] > Tf && $(`${t1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === d.kind && (y = [
                            Jh * w.compositeIconSizes[0].evaluate(b, {}, S),
                            Jh * w.compositeIconSizes[1].evaluate(b, {}, S)
                        ], (y[0] > Tf || y[1] > Tf) && $(`${t1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), t1.addSymbols(t1.icon, a, y, v, x, b, !1, r, e1, k.lineStartIndex, k.lineLength, -1, A, S), F = t1.icon.placedSymbolArray.length - 1, f && (D = 4 * f.length, t1.addSymbols(t1.icon, f, y, v, x, b, Vp.vertical, r, e1, k.lineStartIndex, k.lineLength, -1, A, S), R = t1.icon.placedSymbolArray.length - 1);
                    }
                    for(const n in i.horizontal){
                        const s = i.horizontal[n];
                        I || (U = qa(s.text), d ? B = Cf(s) : I = Ef(u, O, e1, c, h, p, s, f, l.layout.get("text-rotate").evaluate(b, {}, S), y));
                        const o = 1 === s.positionedLines.length;
                        if (V += zf(t1, r, e1, s, a, l, d, b, y, k, i.vertical ? Vp.horizontal : Vp.horizontalOnly, o ? Object.keys(i.horizontal) : [
                            n
                        ], j, F, w, A, S), o) break;
                    }
                    i.vertical && (L += zf(t1, r, e1, i.vertical, a, l, d, b, y, k, Vp.vertical, [
                        "vertical"
                    ], j, R, w, A, S));
                    let G = -1;
                    const X = (t1, e1)=>t1 ? Math.max(t1, e1) : e1;
                    G = X(B, G), G = X(E, G), G = X(C, G);
                    const Z = G > -1 ? 1 : 0;
                    t1.glyphOffsetArray.length >= hd.MAX_GLYPHS && $("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, b.sortKey), t1.symbolInstances.emplaceBack(O.x, O.y, O.z, e1.x, e1.y, j.right >= 0 ? j.right : -1, j.center >= 0 ? j.center : -1, j.left >= 0 ? j.left : -1, j.vertical >= 0 ? j.vertical : -1, F, R, U, void 0 !== I ? I : t1.collisionBoxArray.length, void 0 !== I ? I + 1 : t1.collisionBoxArray.length, void 0 !== T ? T : t1.collisionBoxArray.length, void 0 !== T ? T + 1 : t1.collisionBoxArray.length, void 0 !== M ? M : t1.collisionBoxArray.length, void 0 !== M ? M + 1 : t1.collisionBoxArray.length, z || t1.collisionBoxArray.length, z ? z + 1 : t1.collisionBoxArray.length, c, V, L, P, D, Z, 0, q, N, G);
                }(t1, o, d, a, r, n, i, E, t1.layers[0], t1.collisionBoxArray, e1.index, e1.sourceLayerIndex, t1.index, _, k, l, 0, A, I, y, e1, s, u, c, h);
            };
            if ("line" === M) for (const i of sf(e1.geometry, 0, 0, ko, ko)){
                const e1 = rf(i, w, S, r.vertical || m, n, 24, b, t1.overscaling, ko);
                for (const r of e1){
                    const e1 = m;
                    e1 && Pf(t1, e1.text, T, r) || C(i, r, h);
                }
            }
            else if ("line-center" === M) {
                for (const t1 of e1.geometry)if (t1.length > 1) {
                    const e1 = ef(t1, S, r.vertical || m, n, 24, b);
                    e1 && C(t1, e1, h);
                }
            } else if ("Polygon" === e1.type) for (const t1 of Lc(e1.geometry, 0)){
                const e1 = vf(t1, 16);
                C(t1[0], new Hp(e1.x, e1.y, 0, 0, void 0), h);
            }
            else if ("LineString" === e1.type) for (const t1 of e1.geometry)C(t1, new Hp(t1[0].x, t1[0].y, 0, 0, void 0), h);
            else if ("Point" === e1.type) for (const t1 of e1.geometry)for (const e1 of t1)C([
                e1
            ], new Hp(e1.x, e1.y, 0, 0, void 0), h);
        }
        const Tf = 32640;
        function zf(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, y, m, g) {
            const x = function(t1, e1, r, n, i, s, a, o) {
                const l = [];
                if (0 === e1.positionedLines.length) return l;
                const u = n.layout.get("text-rotate").evaluate(s, {}) * Math.PI / 180, c = function(t1) {
                    const e1 = t1[0], r = t1[1], n = e1 * r;
                    return n > 0 ? [
                        e1,
                        -r
                    ] : n < 0 ? [
                        -e1,
                        r
                    ] : 0 === e1 ? [
                        r,
                        e1
                    ] : [
                        r,
                        -e1
                    ];
                }(r);
                let h = Math.abs(e1.top - e1.bottom);
                for (const t1 of e1.positionedLines)h -= t1.lineOffset;
                const p = e1.positionedLines.length, f = h / p;
                let y = e1.top - r[1];
                for(let t1 = 0; t1 < p; ++t1){
                    const n = e1.positionedLines[t1];
                    y = mf(e1, f, y, t1);
                    for (const t1 of n.positionedGlyphs){
                        if (!t1.rect) continue;
                        const n = t1.rect || {};
                        let s = 4, h = !0, p = 1, f = 0;
                        if (t1.imageName) {
                            const e1 = a[t1.imageName];
                            if (!e1) continue;
                            if (e1.sdf) {
                                $("SDF images are not supported in formatted text and will be ignored.");
                                continue;
                            }
                            h = !1, p = e1.pixelRatio, s = 1 / p;
                        }
                        const m = (i || o) && t1.vertical, g = t1.metrics.advance * t1.scale / 2, x = t1.metrics, v = t1.rect;
                        if (null === v) continue;
                        o && e1.verticalizable && (f = t1.imageName ? g - t1.metrics.width * t1.scale / 2 : 0);
                        const b = i ? [
                            t1.x + g,
                            t1.y
                        ] : [
                            0,
                            0
                        ];
                        let w = [
                            0,
                            0
                        ], _ = [
                            0,
                            0
                        ], A = !1;
                        i || (m ? (_ = [
                            t1.x + g + c[0],
                            t1.y + c[1] - f
                        ], A = !0) : w = [
                            t1.x + g + r[0],
                            t1.y + r[1] - f
                        ]);
                        const S = v.w * t1.scale / (p * (t1.localGlyph ? 2 : 1)), k = v.h * t1.scale / (p * (t1.localGlyph ? 2 : 1));
                        let I, M, T, z;
                        if (m) {
                            const e1 = t1.y - y, r = new d(-g, g - e1), n = -Math.PI / 2, i = new d(..._);
                            I = new d(-g + w[0], w[1]), I._rotateAround(n, r)._add(i), I.x += -e1 + g, I.y -= (x.left - s) * t1.scale;
                            const a = t1.imageName ? x.advance * t1.scale : Wh * t1.scale, o = String.fromCharCode(t1.glyph);
                            sp(o) ? I.x += (1 - s) * t1.scale : ap(o) ? I.x += a - x.height * t1.scale + (-s - 1) * t1.scale : I.x += t1.imageName || x.width + 2 * s === v.w && x.height + 2 * s === v.h ? (a - k) / 2 : (a - (x.height + 2 * s) * t1.scale) / 2, M = new d(I.x, I.y - S), T = new d(I.x + k, I.y), z = new d(I.x + k, I.y - S);
                        } else {
                            const e1 = (x.left - s) * t1.scale - g + w[0], r = (-x.top - s) * t1.scale + w[1], n = e1 + S, i = r + k;
                            I = new d(e1, r), M = new d(n, r), T = new d(e1, i), z = new d(n, i);
                        }
                        if (u) {
                            let t1;
                            t1 = i ? new d(0, 0) : A ? new d(c[0], c[1]) : new d(r[0], r[1]), I._rotateAround(u, t1), M._rotateAround(u, t1), T._rotateAround(u, t1), z._rotateAround(u, t1);
                        }
                        const B = new d(0, 0), E = new d(0, 0);
                        l.push({
                            tl: I,
                            tr: M,
                            bl: T,
                            br: z,
                            tex: n,
                            writingMode: e1.writingMode,
                            glyphOffset: b,
                            sectionIndex: t1.sectionIndex,
                            isSDF: h,
                            pixelOffsetTL: B,
                            pixelOffsetBR: E,
                            minFontScaleX: 0,
                            minFontScaleY: 0
                        });
                    }
                }
                return l;
            }(0, n, l, s, a, o, i, t1.allowVerticalPlacement), v = t1.textSizeData;
            let b = null;
            "source" === v.kind ? (b = [
                Jh * s.layout.get("text-size").evaluate(o, {}, g)
            ], b[0] > Tf && $(`${t1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === v.kind && (b = [
                Jh * y.compositeTextSizes[0].evaluate(o, {}, g),
                Jh * y.compositeTextSizes[1].evaluate(o, {}, g)
            ], (b[0] > Tf || b[1] > Tf) && $(`${t1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), t1.addSymbols(t1.text, x, b, l, a, o, c, e1, r, u.lineStartIndex, u.lineLength, f, m, g);
            for (const e1 of h)p[e1] = t1.text.placedSymbolArray.length - 1;
            return 4 * x.length;
        }
        function Bf(t1) {
            for(const e1 in t1)return t1[e1];
            return null;
        }
        function Ef(t1, e1, r, n, i, s, a, o, l, u) {
            let c = a.top, h = a.bottom, p = a.left, f = a.right;
            const y = a.collisionPadding;
            if (y && (p -= y[0], c -= y[1], f += y[2], h += y[3]), l) {
                const t1 = new d(p, c), e1 = new d(f, c), r = new d(p, h), n = new d(f, h), i = x(l);
                let s = new d(0, 0);
                u && (s = new d(u[0], u[1])), t1._rotateAround(i, s), e1._rotateAround(i, s), r._rotateAround(i, s), n._rotateAround(i, s), p = Math.min(t1.x, e1.x, r.x, n.x), f = Math.max(t1.x, e1.x, r.x, n.x), c = Math.min(t1.y, e1.y, r.y, n.y), h = Math.max(t1.y, e1.y, r.y, n.y);
            }
            return t1.emplaceBack(e1.x, e1.y, e1.z, r.x, r.y, p, c, f, h, o, n, i, s), t1.length - 1;
        }
        function Cf(t1) {
            t1.collisionPadding && (t1.top -= t1.collisionPadding[1], t1.bottom += t1.collisionPadding[3]);
            const e1 = t1.bottom - t1.top;
            return e1 > 0 ? Math.max(10, e1) : null;
        }
        function Pf(t1, e1, r, n) {
            const i = t1.compareText;
            if (e1 in i) {
                const t1 = i[e1];
                for(let e1 = t1.length - 1; e1 >= 0; e1--)if (n.dist(t1[e1]) < r) return !0;
            } else i[e1] = [];
            return i[e1].push(n), !1;
        }
        function Df(t1, e1) {
            const r = t1.fovAboveCenter, n = t1.elevation ? t1.elevation.getMinElevationBelowMSL() * e1 : 0, i = (t1._camera.position[2] * t1.worldSize - n) / Math.cos(t1._pitch), s = Math.sin(r) * i / Math.sin(Math.max(Math.PI / 2 - t1._pitch - r, .01)), a = Math.sin(t1._pitch) * s + i;
            return Math.min(1.01 * a, i * (1 / t1._horizonShift));
        }
        function Vf(t1, e1) {
            if (!e1.isReprojectedInTileSpace) return {
                scale: 1 << t1.z,
                x: t1.x,
                y: t1.y,
                x2: t1.x + 1,
                y2: t1.y + 1,
                projection: e1
            };
            const r = Math.pow(2, -t1.z), n = t1.x * r, i = (t1.x + 1) * r, s = t1.y * r, a = (t1.y + 1) * r, o = ou(n), l = ou(i), u = lu(s), c = lu(a), h = e1.project(o, u), p = e1.project(l, u), f = e1.project(l, c), d = e1.project(o, c);
            let y = Math.min(h.x, p.x, f.x, d.x), m = Math.min(h.y, p.y, f.y, d.y), g = Math.max(h.x, p.x, f.x, d.x), x = Math.max(h.y, p.y, f.y, d.y);
            const v = r / 16;
            function b(t1, r, n, i, s, a) {
                const o = (n + s) / 2, l = (i + a) / 2, u = e1.project(ou(o), lu(l)), c = Math.max(0, y - u.x, m - u.y, u.x - g, u.y - x);
                y = Math.min(y, u.x), g = Math.max(g, u.x), m = Math.min(m, u.y), x = Math.max(x, u.y), c > v && (b(t1, u, n, i, o, l), b(u, r, o, l, s, a));
            }
            b(h, p, n, s, i, s), b(p, f, i, s, i, a), b(f, d, i, a, n, a), b(d, h, n, a, n, s), y -= v, m -= v, g += v, x += v;
            const w = 1 / Math.max(g - y, x - m);
            return {
                scale: w,
                x: y * w,
                y: m * w,
                x2: g * w,
                y2: x * w,
                projection: e1
            };
        }
        const Lf = Eo(new Float32Array(16));
        class Ff {
            constructor(t1){
                this.spec = t1, this.name = t1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
            project(t1, e1) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(t1, e1) {
                return new ru(0, 0);
            }
            projectTilePoint(t1, e1, r) {
                return {
                    x: t1,
                    y: e1,
                    z: 0
                };
            }
            locationPoint(t1, e1, r = !0) {
                return t1._coordinatePoint(t1.locationCoordinate(e1), r);
            }
            pixelsPerMeter(t1, e1) {
                return au(1, t1) * e1;
            }
            pixelSpaceConversion(t1, e1, r) {
                return 1;
            }
            farthestPixelDistance(t1) {
                return Df(t1, t1.pixelsPerMeter);
            }
            pointCoordinate(t1, e1, r, n) {
                const i = t1.horizonLineFromTop(!1), s = new d(e1, Math.max(i, r));
                return t1.rayIntersectionCoordinate(t1.pointRayIntersection(s, n));
            }
            pointCoordinate3D(t1, e1, r) {
                const n = new d(e1, r);
                if (t1.elevation) return t1.elevation.pointCoordinate(n);
                {
                    const e1 = this.pointCoordinate(t1, n.x, n.y, 0);
                    return [
                        e1.x,
                        e1.y,
                        e1.z
                    ];
                }
            }
            isPointAboveHorizon(t1, e1) {
                if (t1.elevation) return !this.pointCoordinate3D(t1, e1.x, e1.y);
                const r = t1.horizonLineFromTop();
                return e1.y < r;
            }
            createInversionMatrix(t1, e1) {
                return Lf;
            }
            createTileMatrix(t1, e1, r) {
                let n, i, s;
                const a = r.canonical, o = Eo(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = Vf(a, this);
                    n = 1, i = l.x + r.wrap * l.scale, s = l.y, Vo(o, o, [
                        n / l.scale,
                        n / l.scale,
                        t1.pixelsPerMeter / e1
                    ]);
                } else n = e1 / t1.zoomScale(a.z), i = (a.x + Math.pow(2, a.z) * r.wrap) * n, s = a.y * n;
                return Do(o, o, [
                    i,
                    s,
                    0
                ]), Vo(o, o, [
                    n / ko,
                    n / ko,
                    1
                ]), o;
            }
            upVector(t1, e1, r) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(t1, e1, r) {
                return {
                    metersToTile: 1
                };
            }
        }
        class Rf extends Ff {
            constructor(t1){
                super(t1), this.range = [
                    4,
                    7
                ], this.center = t1.center || [
                    -96,
                    37.5
                ];
                const [e1, r] = this.parallels = t1.parallels || [
                    29.5,
                    45.5
                ], n = Math.sin(x(e1));
                this.n = (n + Math.sin(x(r))) / 2, this.c = 1 + n * (2 * this.n - n), this.r0 = Math.sqrt(this.c) / this.n;
            }
            project(t1, e1) {
                const { n: r, c: n, r0: i } = this, s = x(t1 - this.center[0]), a = x(e1), o = Math.sqrt(n - 2 * r * Math.sin(a)) / r;
                return {
                    x: o * Math.sin(s * r),
                    y: o * Math.cos(s * r) - i,
                    z: 0
                };
            }
            unproject(t1, e1) {
                const { n: r, c: n, r0: i } = this, s = i + e1;
                let a = Math.atan2(t1, Math.abs(s)) * Math.sign(s);
                s * r < 0 && (a -= Math.PI * Math.sign(t1) * Math.sign(s));
                const o = x(this.center[0]) * r;
                a = I(a, -Math.PI - o, Math.PI - o);
                const l = S(v(a / r) + this.center[0], -180, 180), u = Math.asin(S((n - (t1 * t1 + s * s) * r * r) / (2 * r), -1, 1)), c = S(v(u), -cu, cu);
                return new ru(l, c);
            }
        }
        const jf = 1.340264, Uf = -0.081106, $f = 893e-6, Of = .003796, qf = Math.sqrt(3) / 2;
        class Nf extends Ff {
            project(t1, e1) {
                e1 = e1 / 180 * Math.PI, t1 = t1 / 180 * Math.PI;
                const r = Math.asin(qf * Math.sin(e1)), n = r * r, i = n * n * n;
                return {
                    x: .5 * (t1 * Math.cos(r) / (qf * (jf + 3 * Uf * n + i * (7 * $f + 9 * Of * n))) / Math.PI + .5),
                    y: 1 - .5 * (r * (jf + Uf * n + i * ($f + Of * n)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e1) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e1 = (2 * (1 - e1) - 1) * Math.PI, n = r * r, i = n * n * n;
                for(let t1, s, a, o = 0; o < 12 && (s = r * (jf + Uf * n + i * ($f + Of * n)) - e1, a = jf + 3 * Uf * n + i * (7 * $f + 9 * Of * n), t1 = s / a, r = S(r - t1, -Math.PI / 3, Math.PI / 3), n = r * r, i = n * n * n, !(Math.abs(t1) < 1e-12)); ++o);
                const s = qf * t1 * (jf + 3 * Uf * n + i * (7 * $f + 9 * Of * n)) / Math.cos(r), a = Math.asin(Math.sin(r) / qf), o = S(180 * s / Math.PI, -180, 180), l = S(180 * a / Math.PI, -cu, cu);
                return new ru(o, l);
            }
        }
        class Gf extends Ff {
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(t1, e1) {
                return {
                    x: .5 + t1 / 360,
                    y: .5 - e1 / 360,
                    z: 0
                };
            }
            unproject(t1, e1) {
                const r = 360 * (t1 - .5), n = S(360 * (.5 - e1), -cu, cu);
                return new ru(r, n);
            }
        }
        const Xf = Math.PI / 2;
        function Zf(t1) {
            return Math.tan((Xf + t1) / 2);
        }
        class Kf extends Ff {
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    30
                ];
                const [e1, r] = this.parallels = t1.parallels || [
                    30,
                    30
                ];
                let n = x(e1), i = x(r);
                this.southernCenter = n + i < 0, this.southernCenter && (n = -n, i = -i);
                const s = Math.cos(n), a = Zf(n);
                this.n = n === i ? Math.sin(n) : Math.log(s / Math.cos(i)) / Math.log(Zf(i) / a), this.f = s * Math.pow(Zf(n), this.n) / this.n;
            }
            project(t1, e1) {
                e1 = x(e1), this.southernCenter && (e1 = -e1), t1 = x(t1 - this.center[0]);
                const r = 1e-6, { n: n, f: i } = this;
                i > 0 ? e1 < -Xf + r && (e1 = -Xf + r) : e1 > Xf - r && (e1 = Xf - r);
                const s = i / Math.pow(Zf(e1), n);
                let a = s * Math.sin(n * t1), o = i - s * Math.cos(n * t1);
                return a = .5 * (a / Math.PI + .5), o = .5 * (o / Math.PI + .5), {
                    x: a,
                    y: this.southernCenter ? o : 1 - o,
                    z: 0
                };
            }
            unproject(t1, e1) {
                t1 = (2 * t1 - .5) * Math.PI, this.southernCenter && (e1 = 1 - e1), e1 = (2 * (1 - e1) - .5) * Math.PI;
                const { n: r, f: n } = this, i = n - e1, s = Math.sign(i), a = Math.sign(r) * Math.sqrt(t1 * t1 + i * i);
                let o = Math.atan2(t1, Math.abs(i)) * s;
                i * r < 0 && (o -= Math.PI * Math.sign(t1) * s);
                const l = S(v(o / r) + this.center[0], -180, 180), u = S(v(2 * Math.atan(Math.pow(n / a, 1 / r)) - Xf), -cu, cu);
                return new ru(l, this.southernCenter ? -u : u);
            }
        }
        class Yf extends Ff {
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
            project(t1, e1) {
                return {
                    x: iu(t1),
                    y: su(e1),
                    z: 0
                };
            }
            unproject(t1, e1) {
                const r = ou(t1), n = lu(e1);
                return new ru(r, n);
            }
        }
        const Hf = x(cu);
        class Wf extends Ff {
            project(t1, e1) {
                const r = (e1 = x(e1)) * e1, n = r * r;
                return {
                    x: .5 * ((t1 = x(t1)) * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (e1 * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e1) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e1 = (2 * (1 - e1) - 1) * Math.PI, n = 25, i = 0, s = r * r;
                do {
                    s = r * r;
                    const t1 = s * s;
                    i = (r * (1.007226 + s * (.015085 + t1 * (.028874 * s - .044475 - .005916 * t1))) - e1) / (1.007226 + s * (.045255 + t1 * (.259866 * s - .311325 - .005916 * 11 * t1))), r = S(r - i, -Hf, Hf);
                }while (Math.abs(i) > 1e-6 && --n > 0);
                s = r * r;
                const a = S(v(t1 / (.8707 + s * (s * (s * s * s * (.003971 - .001529 * s) - .013791) - .131979))), -180, 180), o = v(r);
                return new ru(a, o);
            }
        }
        const Jf = x(cu);
        class Qf extends Ff {
            project(t1, e1) {
                e1 = x(e1), t1 = x(t1);
                const r = Math.cos(e1), n = 2 / Math.PI, i = Math.acos(r * Math.cos(t1 / 2)), s = Math.sin(i) / i, a = .5 * (t1 * n + 2 * r * Math.sin(t1 / 2) / s) || 0, o = .5 * (e1 + Math.sin(e1) / s) || 0;
                return {
                    x: .5 * (a / Math.PI + .5),
                    y: 1 - .5 * (o / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e1) {
                let r = t1 = (2 * t1 - .5) * Math.PI, n = e1 = (2 * (1 - e1) - 1) * Math.PI, i = 25;
                const s = 1e-6;
                let a = 0, o = 0;
                do {
                    const i = Math.cos(n), s = Math.sin(n), l = 2 * s * i, u = s * s, c = i * i, h = Math.cos(r / 2), p = Math.sin(r / 2), f = 2 * h * p, d = p * p, y = 1 - c * h * h, m = y ? 1 / y : 0, g = y ? Math.acos(i * h) * Math.sqrt(1 / y) : 0, x = .5 * (2 * g * i * p + 2 * r / Math.PI) - t1, v = .5 * (g * s + n) - e1, b = .5 * m * (c * d + g * i * h * u) + 1 / Math.PI, w = m * (f * l / 4 - g * s * p), _ = .125 * m * (l * p - g * s * c * f), A = .5 * m * (u * h + g * d * i) + .5, k = w * _ - A * b;
                    a = (v * w - x * A) / k, o = (x * _ - v * b) / k, r = S(r - a, -Math.PI, Math.PI), n = S(n - o, -Jf, Jf);
                }while ((Math.abs(a) > s || Math.abs(o) > s) && --i > 0);
                return new ru(v(r), v(n));
            }
        }
        class td extends Ff {
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    0
                ], this.parallels = t1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(x(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(t1, e1) {
                const { scale: r, cosPhi: n } = this;
                return {
                    x: x(t1) * n * r + .5,
                    y: -Math.sin(x(e1)) / n * r + .5,
                    z: 0
                };
            }
            unproject(t1, e1) {
                const { scale: r, cosPhi: n } = this, i = -(e1 - .5) / r, s = S(v((t1 - .5) / r) / n, -180, 180), a = Math.asin(S(i * n, -1, 1)), o = S(v(a), -cu, cu);
                return new ru(s, o);
            }
        }
        class ed extends Yf {
            constructor(t1){
                super(t1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
            projectTilePoint(t1, e1, r) {
                const n = Ol(t1, e1, r);
                return el(n, n, Gl(Pl(r))), {
                    x: n[0],
                    y: n[1],
                    z: n[2]
                };
            }
            locationPoint(t1, e1) {
                const r = $l(e1.lat, e1.lng), n = Jo([], r), i = t1.elevation ? t1.elevation.getAtPointOrZero(t1.locationCoordinate(e1), t1._centerAltitude) : t1._centerAltitude;
                Wo(r, r, n, au(1, 0) * ko * i);
                const s = Eo(new Float64Array(16));
                return Po(s, t1.pixelMatrix, t1.globeMatrix), el(r, r, s), new d(r[0], r[1]);
            }
            pixelsPerMeter(t1, e1) {
                return au(1, 0) * e1;
            }
            pixelSpaceConversion(t1, e1, r) {
                const n = au(1, t1) * e1, i = Mr(au(1, 45) * e1, n, r);
                return this.pixelsPerMeter(t1, e1) / i;
            }
            createTileMatrix(t1, e1, r) {
                const n = Xl(Pl(r.canonical));
                return Po(new Float64Array(16), t1.globeMatrix, n);
            }
            createInversionMatrix(t1, e1) {
                const { center: r } = t1, n = Gl(Pl(e1));
                return Fo(n, n, x(r.lng)), Lo(n, n, x(r.lat)), Vo(n, n, [
                    t1._pixelsPerMercatorPixel,
                    t1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(n);
            }
            pointCoordinate(t1, e1, r, n) {
                return Bl(t1, e1, r, !0) || new pu(0, 0);
            }
            pointCoordinate3D(t1, e1, r) {
                const n = this.pointCoordinate(t1, e1, r, 0);
                return [
                    n.x,
                    n.y,
                    n.z
                ];
            }
            isPointAboveHorizon(t1, e1) {
                return !Bl(t1, e1.x, e1.y, !1);
            }
            farthestPixelDistance(t1) {
                const e1 = function(t1, e1) {
                    const r = t1.cameraToCenterDistance, n = t1._centerAltitude * e1, i = t1._camera, s = t1._camera.forward(), a = Go([], Ho([], s, -r), [
                        0,
                        0,
                        n
                    ]), o = t1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -o
                    ], u = t1.width / t1.height, c = Math.tan(t1.fovAboveCenter), h = Ho([], i.up(), c), p = Ho([], i.right(), c * u), f = Jo([], Go([], Go([], s, h), p)), d = [];
                    let y;
                    if (new vl(a, f).closestPointOnSphere(l, o, d)) {
                        const e1 = Go([], d, l), r = il([], e1, a);
                        y = Math.cos(t1.fovAboveCenter) * qo(r);
                    } else {
                        const t1 = il([], a, l), e1 = il([], l, a);
                        Jo(e1, e1);
                        const r = qo(t1) - o;
                        y = Math.sqrt(r * (r + 2 * o));
                        const n = Math.acos(y / (o + r)) - Math.acos(Qo(s, e1));
                        y *= Math.cos(n);
                    }
                    return 1.01 * y;
                }(t1, this.pixelsPerMeter(t1.center.lat, t1.worldSize)), r = Kl(t1.zoom);
                if (r > 0) {
                    const n = Df(t1, au(1, t1.center.lat) * t1.worldSize), i = t1.worldSize / (2 * Math.PI), s = Math.max(t1.width, t1.height) / t1.worldSize * Math.PI;
                    return Mr(e1, n + i * (1 - Math.cos(s)), Math.pow(r, 10));
                }
                return e1;
            }
            upVector(t1, e1, r) {
                return Ol(e1, r, t1, 1);
            }
            upVectorScale(t1) {
                return {
                    metersToTile: zl(ql(Pl(t1)))
                };
            }
        }
        function rd(t1) {
            const e1 = t1.parallels, r = !!e1 && Math.abs(e1[0] + e1[1]) < .01;
            switch(t1.name){
                case "mercator":
                    return new Yf(t1);
                case "equirectangular":
                    return new Gf(t1);
                case "naturalEarth":
                    return new Wf(t1);
                case "equalEarth":
                    return new Nf(t1);
                case "winkelTripel":
                    return new Qf(t1);
                case "albers":
                    return r ? new td(t1) : new Rf(t1);
                case "lambertConformalConic":
                    return r ? new td(t1) : new Kf(t1);
                case "globe":
                    return new ed(t1);
            }
            throw new Error(`Invalid projection name: ${t1.name}`);
        }
        const nd = ah.types, id = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function sd(t1, e1, r, n, i, s, a, o, l, u, c, h, p) {
            const f = o ? Math.min(Tf, Math.round(o[0])) : 0, d = o ? Math.min(Tf, Math.round(o[1])) : 0;
            t1.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), s, a, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function ad(t1, e1, r, n, i, s, a) {
            t1.emplaceBack(e1, r, n, i, s, a);
        }
        function od(t1, e1, r, n, i) {
            t1.emplaceBack(e1, r, n, i), t1.emplaceBack(e1, r, n, i), t1.emplaceBack(e1, r, n, i), t1.emplaceBack(e1, r, n, i);
        }
        function ld(t1) {
            for (const e1 of t1.sections)if (Ms(e1.text)) return !0;
            return !1;
        }
        class ud {
            constructor(t1){
                this.layoutVertexArray = new fa, this.indexArray = new wa, this.programConfigurations = t1, this.segments = new So, this.dynamicLayoutVertexArray = new ua, this.opacityVertexArray = new ya, this.placedSymbolArray = new Pa, this.globeExtVertexArray = new da;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(t1, e1, r, n) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Nh.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, Xh.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, id, !0), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, Gh.members, !0)), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
            }
        }
        Oi(ud, "SymbolBuffers");
        class cd {
            constructor(t1, e1, r){
                this.layoutVertexArray = new t1, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new So, this.collisionVertexArray = new va, this.collisionVertexArrayExt = new ba;
            }
            upload(t1) {
                this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, Zh.members, !0), this.collisionVertexBufferExt = t1.createVertexBuffer(this.collisionVertexArrayExt, Kh.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
        }
        Oi(cd, "CollisionBuffers");
        class hd {
            constructor(t1){
                this.collisionBoxArray = t1.collisionBoxArray, this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.pixelRatio = t1.pixelRatio, this.sourceLayerIndex = t1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = Eo([]), this.placementViewportMatrix = Eo([]);
                const e1 = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = Qh(this.zoom, e1["text-size"]), this.iconSizeData = Qh(this.zoom, e1["icon-size"]);
                const r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
                this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i || "auto" === i && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r.get("text-writing-mode").map((t1)=>Vp[t1]), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.sourceID = t1.sourceID, this.projection = t1.projection;
            }
            createArrays() {
                this.text = new ud(new fo(this.layers, this.zoom, (t1)=>/^text/.test(t1))), this.icon = new ud(new fo(this.layers, this.zoom, (t1)=>/^icon/.test(t1))), this.glyphOffsetArray = new La, this.lineVertexArray = new Fa, this.symbolInstances = new Va;
            }
            calculateGlyphDependencies(t1, e1, r, n, i) {
                for(let r = 0; r < t1.length; r++)if (e1[t1.charCodeAt(r)] = !0, n && i) {
                    const n = ip[t1.charAt(r)];
                    n && (e1[n.charCodeAt(0)] = !0);
                }
            }
            populate(t1, e1, r, n) {
                const i = this.layers[0], s = i.layout, a = "globe" === this.projection.name, o = s.get("text-font"), l = s.get("text-field"), u = s.get("icon-image"), c = ("constant" !== l.value.kind || l.value.value instanceof Be && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== o.value.kind || o.value.value.length > 0), h = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, p = s.get("symbol-sort-key");
                if (this.features = [], !c && !h) return;
                const f = e1.iconDependencies, d = e1.glyphDependencies, y = e1.availableImages, m = new Us(this.zoom);
                for (const { feature: e1, id: l, index: u, sourceLayerIndex: g } of t1){
                    const t1 = i._featureFilter.needGeometry, x = wu(e1, t1);
                    if (!i._featureFilter.filter(m, x, r)) continue;
                    if (t1 || (x.geometry = bu(e1, r, n)), a && 1 !== e1.type && r.z <= 5) {
                        const t1 = x.geometry, e1 = .98078528056, n = (t1, n)=>Qo(Ol(t1.x, t1.y, r, 1), Ol(n.x, n.y, r, 1)) < e1;
                        for(let e1 = 0; e1 < t1.length; e1++)t1[e1] = mu(t1[e1], n);
                    }
                    let v, b;
                    if (c) {
                        const t1 = i.getValueAndResolveTokens("text-field", x, r, y), e1 = Be.factory(t1);
                        ld(e1) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === Fs() || this.hasRTLText && js.isParsed()) && (v = np(e1, i, x));
                    }
                    if (h) {
                        const t1 = i.getValueAndResolveTokens("icon-image", x, r, y);
                        b = t1 instanceof Ee ? t1 : Ee.fromString(t1);
                    }
                    if (!v && !b) continue;
                    const w = this.sortFeaturesByKey ? p.evaluate(x, {}, r) : void 0;
                    if (this.features.push({
                        id: l,
                        text: v,
                        icon: b,
                        index: u,
                        sourceLayerIndex: g,
                        geometry: x.geometry,
                        properties: e1.properties,
                        type: nd[e1.type],
                        sortKey: w
                    }), b && (f[b.name] = !0), v) {
                        const t1 = o.evaluate(x, {}, r).join(","), e1 = "map" === s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(Vp.vertical) >= 0;
                        for (const r of v.sections)if (r.image) f[r.image.name] = !0;
                        else {
                            const n = bs(v.toString()), i = r.fontStack || t1, s = d[i] = d[i] || {};
                            this.calculateGlyphDependencies(r.text, s, e1, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === s.get("symbol-placement") && (this.features = function(t1) {
                    const e1 = {}, r = {}, n = [];
                    let i = 0;
                    function s(e1) {
                        n.push(t1[e1]), i++;
                    }
                    function a(t1, e1, i) {
                        const s = r[t1];
                        return delete r[t1], r[e1] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
                    }
                    function o(t1, r, i) {
                        const s = e1[r];
                        return delete e1[r], e1[t1] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
                    }
                    function l(t1, e1, r) {
                        const n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                        return `${t1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t1.length; u++){
                        const c = t1[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            s(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e1 && r[f] !== e1[d]) {
                            const t1 = o(f, d, h), i = a(f, d, n[t1].geometry);
                            delete e1[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t1].geometry = null;
                        } else f in r ? a(f, d, h) : d in e1 ? o(f, d, h) : (s(u), e1[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t1)=>t1.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t1, e1)=>t1.sortKey - e1.sortKey);
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t1, e1, this.layers, r, n), this.icon.programConfigurations.updatePaintArrays(t1, e1, this.layers, r, n));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = rd(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t1, e1) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t1.segment) for (const { x: t1, y: r } of e1)this.lineVertexArray.emplaceBack(t1, r);
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f) {
                const d = t1.indexArray, y = t1.layoutVertexArray, m = t1.globeExtVertexArray, g = t1.segments.prepareSegment(4 * e1.length, y, d, this.canOverlap ? s.sortKey : void 0), x = this.glyphOffsetArray.length, v = g.vertexLength, b = this.allowVerticalPlacement && a === Vp.vertical ? Math.PI / 2 : 0, w = s.text && s.text.sections;
                for(let n = 0; n < e1.length; n++){
                    const { tl: i, tr: a, bl: u, br: c, tex: h, pixelOffsetTL: x, pixelOffsetBR: v, minFontScaleX: _, minFontScaleY: A, glyphOffset: S, isSDF: k, sectionIndex: I } = e1[n], M = g.vertexLength, T = S[1];
                    if (sd(y, l.x, l.y, i.x, T + i.y, h.x, h.y, r, k, x.x, x.y, _, A), sd(y, l.x, l.y, a.x, T + a.y, h.x + h.w, h.y, r, k, v.x, x.y, _, A), sd(y, l.x, l.y, u.x, T + u.y, h.x, h.y + h.h, r, k, x.x, v.y, _, A), sd(y, l.x, l.y, c.x, T + c.y, h.x + h.w, h.y + h.h, r, k, v.x, v.y, _, A), o) {
                        const { x: e1, y: r, z: n } = o.anchor, [i, s, a] = o.up;
                        ad(m, e1, r, n, i, s, a), ad(m, e1, r, n, i, s, a), ad(m, e1, r, n, i, s, a), ad(m, e1, r, n, i, s, a), od(t1.dynamicLayoutVertexArray, e1, r, n, b);
                    } else od(t1.dynamicLayoutVertexArray, l.x, l.y, l.z, b);
                    d.emplaceBack(M, M + 1, M + 2), d.emplaceBack(M + 1, M + 2, M + 3), g.vertexLength += 4, g.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(S[0]), n !== e1.length - 1 && I === e1[n + 1].sectionIndex || t1.programConfigurations.populatePaintArrays(y.length, s, s.index, {}, p, f, w && w[I]);
                }
                const _ = o ? o.anchor : l;
                t1.placedSymbolArray.emplaceBack(_.x, _.y, _.z, l.x, l.y, x, this.glyphOffsetArray.length - x, v, u, c, l.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], a, 0, !1, 0, h, 0);
            }
            _commitLayoutVertex(t1, e1, r, n, i, s, a) {
                t1.emplaceBack(e1, r, n, i, s, Math.round(a.x), Math.round(a.y));
            }
            _addCollisionDebugVertices(t1, e1, r, n, i, s, a) {
                const o = r.segments.prepareSegment(4, r.layoutVertexArray, r.indexArray), l = o.vertexLength, u = a.tileAnchorX, c = a.tileAnchorY;
                for(let t1 = 0; t1 < 4; t1++)r.collisionVertexArray.emplaceBack(0, 0, 0, 0);
                r.collisionVertexArrayExt.emplaceBack(e1, -t1.padding, -t1.padding), r.collisionVertexArrayExt.emplaceBack(e1, t1.padding, -t1.padding), r.collisionVertexArrayExt.emplaceBack(e1, t1.padding, t1.padding), r.collisionVertexArrayExt.emplaceBack(e1, -t1.padding, t1.padding), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new d(t1.x1, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new d(t1.x2, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new d(t1.x2, t1.y2)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new d(t1.x1, t1.y2)), o.vertexLength += 4;
                const h = r.indexArray;
                h.emplaceBack(l, l + 1), h.emplaceBack(l + 1, l + 2), h.emplaceBack(l + 2, l + 3), h.emplaceBack(l + 3, l), o.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(t1, e1, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceTextSize(t1, s, e1, a);
                    this._addCollisionDebugVertices(n, i, this.textCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            _addIconDebugCollisionBoxes(t1, e1, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceIconSize(t1, e1, s.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(n, i, this.iconCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            generateCollisionDebugBuffers(t1, e1) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new cd(ga, Yh.members, Ma), this.iconCollisionBox = new cd(ga, Yh.members, Ma);
                const r = ep(this.iconSizeData, t1), n = ep(this.textSizeData, t1);
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const s = this.symbolInstances.get(i);
                    this._addTextDebugCollisionBoxes(n, t1, e1, s.textBoxStartIndex, s.textBoxEndIndex, s), this._addTextDebugCollisionBoxes(n, t1, e1, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s), this._addIconDebugCollisionBoxes(r, t1, e1, s.iconBoxStartIndex, s.iconBoxEndIndex, s), this._addIconDebugCollisionBoxes(r, t1, e1, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s);
                }
            }
            getSymbolInstanceTextSize(t1, e1, r, n) {
                const i = this.text.placedSymbolArray.get(e1.rightJustifiedTextSymbolIndex >= 0 ? e1.rightJustifiedTextSymbolIndex : e1.centerJustifiedTextSymbolIndex >= 0 ? e1.centerJustifiedTextSymbolIndex : e1.leftJustifiedTextSymbolIndex >= 0 ? e1.leftJustifiedTextSymbolIndex : e1.verticalPlacedTextSymbolIndex >= 0 ? e1.verticalPlacedTextSymbolIndex : n), s = tp(this.textSizeData, t1, i) / Wh;
                return this.tilePixelRatio * s;
            }
            getSymbolInstanceIconSize(t1, e1, r) {
                const n = this.icon.placedSymbolArray.get(r), i = tp(this.iconSizeData, t1, n);
                return this.tilePixelRatio * i;
            }
            _commitDebugCollisionVertexUpdate(t1, e1, r) {
                t1.emplaceBack(e1, -r, -r), t1.emplaceBack(e1, r, -r), t1.emplaceBack(e1, r, r), t1.emplaceBack(e1, -r, r);
            }
            _updateTextDebugCollisionBoxes(t1, e1, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceTextSize(t1, s, e1, a);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i, n.padding);
                }
            }
            _updateIconDebugCollisionBoxes(t1, e1, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceIconSize(t1, e1, s);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i, n.padding);
                }
            }
            updateCollisionDebugBuffers(t1, e1) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const r = ep(this.iconSizeData, t1), n = ep(this.textSizeData, t1);
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const s = this.symbolInstances.get(i);
                    this._updateTextDebugCollisionBoxes(n, t1, e1, s.textBoxStartIndex, s.textBoxEndIndex, s), this._updateTextDebugCollisionBoxes(n, t1, e1, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s), this._updateIconDebugCollisionBoxes(r, t1, e1, s.iconBoxStartIndex, s.iconBoxEndIndex, s.placedIconSymbolIndex), this._updateIconDebugCollisionBoxes(r, t1, e1, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s.placedIconSymbolIndex);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(t1, e1, r, n, i, s, a, o, l) {
                const u = {};
                if (e1 < r) {
                    const { x1: r, y1: n, x2: i, y2: s, padding: a, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(e1);
                    u.textBox = {
                        x1: r,
                        y1: n,
                        x2: i,
                        y2: s,
                        padding: a,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.textFeatureIndex = f;
                }
                if (n < i) {
                    const { x1: e1, y1: r, x2: i, y2: s, padding: a, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(n);
                    u.verticalTextBox = {
                        x1: e1,
                        y1: r,
                        x2: i,
                        y2: s,
                        padding: a,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalTextFeatureIndex = f;
                }
                if (s < a) {
                    const { x1: e1, y1: r, x2: n, y2: i, padding: a, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(s);
                    u.iconBox = {
                        x1: e1,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: a,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.iconFeatureIndex = f;
                }
                if (o < l) {
                    const { x1: e1, y1: r, x2: n, y2: i, padding: s, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(o);
                    u.verticalIconBox = {
                        x1: e1,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: s,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalIconFeatureIndex = f;
                }
                return u;
            }
            deserializeCollisionBoxes(t1) {
                this.collisionArrays = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; e1++){
                    const r = this.symbolInstances.get(e1);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(t1, e1) {
                const r = t1.placedSymbolArray.get(e1), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e1 = r.vertexStartIndex; e1 < n; e1 += 4)t1.indexArray.emplaceBack(e1, e1 + 1, e1 + 2), t1.indexArray.emplaceBack(e1 + 1, e1 + 2, e1 + 3);
            }
            getSortedSymbolIndexes(t1) {
                if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e1 = Math.sin(t1), r = Math.cos(t1), n = [], i = [], s = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; ++t1){
                    s.push(t1);
                    const a = this.symbolInstances.get(t1);
                    n.push(0 | Math.round(e1 * a.tileAnchorX + r * a.tileAnchorY)), i.push(a.featureIndex);
                }
                return s.sort((t1, e1)=>n[t1] - n[e1] || i[e1] - i[t1]), s;
            }
            addToSortKeyRanges(t1, e1) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e1 ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                    sortKey: e1,
                    symbolInstanceStart: t1,
                    symbolInstanceEnd: t1 + 1
                });
            }
            sortFeatures(t1) {
                if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t1 of this.symbolInstanceIndexes){
                        const e1 = this.symbolInstances.get(t1);
                        this.featureSortOrder.push(e1.featureIndex);
                        const { rightJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: n, leftJustifiedTextSymbolIndex: i, verticalPlacedTextSymbolIndex: s, placedIconSymbolIndex: a, verticalPlacedIconSymbolIndex: o } = e1;
                        r >= 0 && this.addIndicesForPlacedSymbol(this.text, r), n >= 0 && n !== r && this.addIndicesForPlacedSymbol(this.text, n), i >= 0 && i !== n && i !== r && this.addIndicesForPlacedSymbol(this.text, i), s >= 0 && this.addIndicesForPlacedSymbol(this.text, s), a >= 0 && this.addIndicesForPlacedSymbol(this.icon, a), o >= 0 && this.addIndicesForPlacedSymbol(this.icon, o);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        Oi(hd, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), hd.MAX_GLYPHS = 65535, hd.addDynamicAttributes = od;
        const pd = new Js({
            "symbol-placement": new Ys(Ht.layout_symbol["symbol-placement"]),
            "symbol-spacing": new Ys(Ht.layout_symbol["symbol-spacing"]),
            "symbol-avoid-edges": new Ys(Ht.layout_symbol["symbol-avoid-edges"]),
            "symbol-sort-key": new Hs(Ht.layout_symbol["symbol-sort-key"]),
            "symbol-z-order": new Ys(Ht.layout_symbol["symbol-z-order"]),
            "icon-allow-overlap": new Ys(Ht.layout_symbol["icon-allow-overlap"]),
            "icon-ignore-placement": new Ys(Ht.layout_symbol["icon-ignore-placement"]),
            "icon-optional": new Ys(Ht.layout_symbol["icon-optional"]),
            "icon-rotation-alignment": new Ys(Ht.layout_symbol["icon-rotation-alignment"]),
            "icon-size": new Hs(Ht.layout_symbol["icon-size"]),
            "icon-text-fit": new Ys(Ht.layout_symbol["icon-text-fit"]),
            "icon-text-fit-padding": new Ys(Ht.layout_symbol["icon-text-fit-padding"]),
            "icon-image": new Hs(Ht.layout_symbol["icon-image"]),
            "icon-rotate": new Hs(Ht.layout_symbol["icon-rotate"]),
            "icon-padding": new Ys(Ht.layout_symbol["icon-padding"]),
            "icon-keep-upright": new Ys(Ht.layout_symbol["icon-keep-upright"]),
            "icon-offset": new Hs(Ht.layout_symbol["icon-offset"]),
            "icon-anchor": new Hs(Ht.layout_symbol["icon-anchor"]),
            "icon-pitch-alignment": new Ys(Ht.layout_symbol["icon-pitch-alignment"]),
            "text-pitch-alignment": new Ys(Ht.layout_symbol["text-pitch-alignment"]),
            "text-rotation-alignment": new Ys(Ht.layout_symbol["text-rotation-alignment"]),
            "text-field": new Hs(Ht.layout_symbol["text-field"]),
            "text-font": new Hs(Ht.layout_symbol["text-font"]),
            "text-size": new Hs(Ht.layout_symbol["text-size"]),
            "text-max-width": new Hs(Ht.layout_symbol["text-max-width"]),
            "text-line-height": new Hs(Ht.layout_symbol["text-line-height"]),
            "text-letter-spacing": new Hs(Ht.layout_symbol["text-letter-spacing"]),
            "text-justify": new Hs(Ht.layout_symbol["text-justify"]),
            "text-radial-offset": new Hs(Ht.layout_symbol["text-radial-offset"]),
            "text-variable-anchor": new Ys(Ht.layout_symbol["text-variable-anchor"]),
            "text-anchor": new Hs(Ht.layout_symbol["text-anchor"]),
            "text-max-angle": new Ys(Ht.layout_symbol["text-max-angle"]),
            "text-writing-mode": new Ys(Ht.layout_symbol["text-writing-mode"]),
            "text-rotate": new Hs(Ht.layout_symbol["text-rotate"]),
            "text-padding": new Ys(Ht.layout_symbol["text-padding"]),
            "text-keep-upright": new Ys(Ht.layout_symbol["text-keep-upright"]),
            "text-transform": new Hs(Ht.layout_symbol["text-transform"]),
            "text-offset": new Hs(Ht.layout_symbol["text-offset"]),
            "text-allow-overlap": new Ys(Ht.layout_symbol["text-allow-overlap"]),
            "text-ignore-placement": new Ys(Ht.layout_symbol["text-ignore-placement"]),
            "text-optional": new Ys(Ht.layout_symbol["text-optional"])
        });
        var fd = {
            paint: new Js({
                "icon-opacity": new Hs(Ht.paint_symbol["icon-opacity"]),
                "icon-color": new Hs(Ht.paint_symbol["icon-color"]),
                "icon-halo-color": new Hs(Ht.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new Hs(Ht.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new Hs(Ht.paint_symbol["icon-halo-blur"]),
                "icon-translate": new Ys(Ht.paint_symbol["icon-translate"]),
                "icon-translate-anchor": new Ys(Ht.paint_symbol["icon-translate-anchor"]),
                "text-opacity": new Hs(Ht.paint_symbol["text-opacity"]),
                "text-color": new Hs(Ht.paint_symbol["text-color"], {
                    runtimeType: le,
                    getOverride: (t1)=>t1.textColor,
                    hasOverride: (t1)=>!!t1.textColor
                }),
                "text-halo-color": new Hs(Ht.paint_symbol["text-halo-color"]),
                "text-halo-width": new Hs(Ht.paint_symbol["text-halo-width"]),
                "text-halo-blur": new Hs(Ht.paint_symbol["text-halo-blur"]),
                "text-translate": new Ys(Ht.paint_symbol["text-translate"]),
                "text-translate-anchor": new Ys(Ht.paint_symbol["text-translate-anchor"])
            }),
            layout: pd
        };
        class dd {
            constructor(t1){
                this.type = t1.property.overrides ? t1.property.overrides.runtimeType : ie, this.defaultValue = t1;
            }
            evaluate(t1) {
                if (t1.formattedSection) {
                    const e1 = this.defaultValue.property.overrides;
                    if (e1 && e1.hasOverride(t1.formattedSection)) return e1.getOverride(t1.formattedSection);
                }
                return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t1) {
                this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        Oi(dd, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        class yd extends wo {
            constructor(t1){
                super(t1, fd);
            }
            recalculate(t1, e1) {
                super.recalculate(t1, e1), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const r = this.layout.get("text-writing-mode");
                if (r) {
                    const t1 = [];
                    for (const e1 of r)t1.indexOf(e1) < 0 && t1.push(e1);
                    this.layout._values["text-writing-mode"] = t1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(t1, e1, r, n) {
                const i = this.layout.get(t1).evaluate(e1, {}, r, n), s = this._unevaluatedLayout._values[t1];
                return s.isDataDriven() || Nn(s.value) || !i ? i : function(t1, e1) {
                    return e1.replace(/{([^{}]+)}/g, (e1, r)=>r in t1 ? String(t1[r]) : "");
                }(e1.properties, i);
            }
            createBucket(t1) {
                return new hd(t1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const t1 of fd.paint.overridableProperties){
                    if (!yd.hasPaintOverride(this.layout, t1)) continue;
                    const e1 = this.paint.get(t1), r = new dd(e1), n = new qn(r, e1.property.specification);
                    let i = null;
                    i = "constant" === e1.value.kind || "source" === e1.value.kind ? new Xn("source", n) : new Zn("composite", n, e1.value.zoomStops, e1.value._interpolationType), this.paint._values[t1] = new Zs(e1.property, i, e1.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                return !(!this.layout || e1.isDataDriven() || r.isDataDriven()) && yd.hasPaintOverride(this.layout, t1);
            }
            static hasPaintOverride(t1, e1) {
                const r = t1.get("text-field"), n = fd.paint.properties[e1];
                let i = !1;
                const s = (t1)=>{
                    for (const e1 of t1)if (n.overrides && n.overrides.hasOverride(e1)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Be) s(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t1 = (e1)=>{
                        i || (e1 instanceof Fe && De(e1.value) === pe ? s(e1.value.sections) : e1 instanceof Oe ? s(e1.sections) : e1.eachChild(t1));
                    }, e1 = r.value;
                    e1._styleExpression && t1(e1._styleExpression.expression);
                }
                return i;
            }
            getProgramConfiguration(t1) {
                return new po(this, t1);
            }
        }
        var md = {
            paint: new Js({
                "background-color": new Ys(Ht.paint_background["background-color"]),
                "background-pattern": new Ys(Ht.paint_background["background-pattern"]),
                "background-opacity": new Ys(Ht.paint_background["background-opacity"])
            })
        }, gd = {
            paint: new Js({
                "raster-opacity": new Ys(Ht.paint_raster["raster-opacity"]),
                "raster-hue-rotate": new Ys(Ht.paint_raster["raster-hue-rotate"]),
                "raster-brightness-min": new Ys(Ht.paint_raster["raster-brightness-min"]),
                "raster-brightness-max": new Ys(Ht.paint_raster["raster-brightness-max"]),
                "raster-saturation": new Ys(Ht.paint_raster["raster-saturation"]),
                "raster-contrast": new Ys(Ht.paint_raster["raster-contrast"]),
                "raster-resampling": new Ys(Ht.paint_raster["raster-resampling"]),
                "raster-fade-duration": new Ys(Ht.paint_raster["raster-fade-duration"])
            })
        };
        class xd extends wo {
            constructor(t1){
                super(t1, {}), this.implementation = t1;
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isLayerDraped() {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(t1) {
                this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
            }
            onRemove(t1) {
                this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
            }
        }
        var vd = {
            paint: new Js({
                "sky-type": new Ys(Ht.paint_sky["sky-type"]),
                "sky-atmosphere-sun": new Ys(Ht.paint_sky["sky-atmosphere-sun"]),
                "sky-atmosphere-sun-intensity": new Ys(Ht.paint_sky["sky-atmosphere-sun-intensity"]),
                "sky-gradient-center": new Ys(Ht.paint_sky["sky-gradient-center"]),
                "sky-gradient-radius": new Ys(Ht.paint_sky["sky-gradient-radius"]),
                "sky-gradient": new Ws(Ht.paint_sky["sky-gradient"]),
                "sky-atmosphere-halo-color": new Ys(Ht.paint_sky["sky-atmosphere-halo-color"]),
                "sky-atmosphere-color": new Ys(Ht.paint_sky["sky-atmosphere-color"]),
                "sky-opacity": new Ys(Ht.paint_sky["sky-opacity"])
            })
        };
        function bd(t1, e1, r) {
            const n = [
                0,
                0,
                1
            ], i = hl([]);
            return fl(i, i, r ? -x(t1) + Math.PI : x(t1)), pl(i, i, -x(e1)), rl(n, n, i), Jo(n, n);
        }
        const wd = {
            circle: class extends wo {
                constructor(t1){
                    super(t1, Ou);
                }
                createBucket(t1) {
                    return new Su(t1);
                }
                queryRadius(t1) {
                    const e1 = t1;
                    return Fu("circle-radius", this, e1) + Fu("circle-stroke-width", this, e1) + Ru(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, s, a, o) {
                    const l = Uu(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), u = this.paint.get("circle-radius").evaluate(e1, r) + this.paint.get("circle-stroke-width").evaluate(e1, r);
                    return qu(t1, n, s, a, o, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, u);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getProgramConfiguration(t1) {
                    return new po(this, t1);
                }
            },
            heatmap: class extends wo {
                createBucket(t1) {
                    return new Ku(t1);
                }
                constructor(t1){
                    super(t1, tc), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "heatmap-color" === t1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = ec({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                queryRadius(t1) {
                    return Fu("heatmap-radius", this, t1);
                }
                queryIntersectsFeature(t1, e1, r, n, i, s, a, o) {
                    const l = this.paint.get("heatmap-radius").evaluate(e1, r);
                    return qu(t1, n, s, a, o, !0, !0, new d(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getProgramConfiguration(t1) {
                    return new po(this, t1);
                }
            },
            hillshade: class extends wo {
                constructor(t1){
                    super(t1, rc);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
            },
            fill: class extends wo {
                constructor(t1){
                    super(t1, Oc);
                }
                getProgramIds() {
                    const t1 = this.paint.get("fill-pattern"), e1 = t1 && t1.constantOr(1), r = [
                        e1 ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && r.push(e1 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r;
                }
                getProgramConfiguration(t1) {
                    return new po(this, t1);
                }
                recalculate(t1, e1) {
                    super.recalculate(t1, e1);
                    const r = this.paint._values["fill-outline-color"];
                    "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(t1) {
                    return new Uc(t1);
                }
                queryRadius() {
                    return Ru(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, s) {
                    return !t1.queryGeometry.isAboveHorizon && Mu(ju(t1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), n);
                }
                isTileClipped() {
                    return !0;
                }
            },
            "fill-extrusion": class extends wo {
                constructor(t1){
                    super(t1, Ah);
                }
                createBucket(t1) {
                    return new fh(t1);
                }
                queryRadius() {
                    return Ru(this.paint.get("fill-extrusion-translate"));
                }
                is3D() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                getProgramConfiguration(t1) {
                    return new po(this, t1);
                }
                queryIntersectsFeature(t1, e1, r, n, i, s, a, o, l) {
                    const u = Uu(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), c = this.paint.get("fill-extrusion-height").evaluate(e1, r), h = this.paint.get("fill-extrusion-base").evaluate(e1, r), p = [
                        0,
                        0
                    ], f = o && s.elevation, y = s.elevation ? s.elevation.exaggeration() : 1, m = t1.tile.getBucket(this);
                    if (f && m instanceof fh) {
                        const t1 = m.centroidVertexArray, e1 = l + 1;
                        e1 < t1.length && (p[0] = t1.geta_centroid_pos0(e1), p[1] = t1.geta_centroid_pos1(e1));
                    }
                    if (0 === p[0] && 1 === p[1]) return !1;
                    "globe" === s.projection.name && (n = wh([
                        n
                    ], [
                        new d(0, 0),
                        new d(ko, ko)
                    ], t1.tileID.canonical).map((t1)=>t1.polygon).flat());
                    const g = f ? o : null, [x, v] = function(t1, e1, r, n, i, s, a, o, l, u, c) {
                        return "globe" === t1.projection.name ? function(t1, e1, r, n, i, s, a, o, l, u, c) {
                            const h = [], p = [], f = t1.projection.upVectorScale(c, t1.center.lat, t1.worldSize).metersToTile, d = [
                                0,
                                0,
                                0,
                                1
                            ], y = [
                                0,
                                0,
                                0,
                                1
                            ], m = (t1, e1, r, n)=>{
                                t1[0] = e1, t1[1] = r, t1[2] = n, t1[3] = 1;
                            }, g = bh();
                            r > 0 && (r += g), n += g;
                            for (const g of e1){
                                const e1 = [], x = [];
                                for (const h of g){
                                    const p = h.x + i.x, g = h.y + i.y, v = t1.projection.projectTilePoint(p, g, c), b = t1.projection.upVector(c, h.x, h.y);
                                    let w = r, _ = n;
                                    if (a) {
                                        const t1 = Ch(p, g, r, n, a, o, l, u);
                                        w += t1.base, _ += t1.top;
                                    }
                                    0 !== r ? m(d, v.x + b[0] * f * w, v.y + b[1] * f * w, v.z + b[2] * f * w) : m(d, v.x, v.y, v.z), m(y, v.x + b[0] * f * _, v.y + b[1] * f * _, v.z + b[2] * f * _), el(d, d, s), el(y, y, s), e1.push(new zh(d[0], d[1], d[2])), x.push(new zh(y[0], y[1], y[2]));
                                }
                                h.push(e1), p.push(x);
                            }
                            return [
                                h,
                                p
                            ];
                        }(t1, e1, r, n, i, s, a, o, l, u, c) : a ? function(t1, e1, r, n, i, s, a, o, l) {
                            const u = [], c = [], h = [
                                0,
                                0,
                                0,
                                1
                            ];
                            for (const p of t1){
                                const t1 = [], f = [];
                                for (const u of p){
                                    const c = u.x + n.x, p = u.y + n.y, d = Ch(c, p, e1, r, s, a, o, l);
                                    h[0] = c, h[1] = p, h[2] = d.base, h[3] = 1, ul(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const y = new zh(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                                    h[0] = c, h[1] = p, h[2] = d.top, h[3] = 1, ul(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const m = new zh(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                                    t1.push(y), f.push(m);
                                }
                                u.push(t1), c.push(f);
                            }
                            return [
                                u,
                                c
                            ];
                        }(e1, r, n, i, s, a, o, l, u) : function(t1, e1, r, n, i) {
                            const s = [], a = [], o = i[8] * e1, l = i[9] * e1, u = i[10] * e1, c = i[11] * e1, h = i[8] * r, p = i[9] * r, f = i[10] * r, d = i[11] * r;
                            for (const e1 of t1){
                                const t1 = [], r = [];
                                for (const s of e1){
                                    const e1 = s.x + n.x, a = s.y + n.y, y = i[0] * e1 + i[4] * a + i[12], m = i[1] * e1 + i[5] * a + i[13], g = i[2] * e1 + i[6] * a + i[14], x = i[3] * e1 + i[7] * a + i[15], v = y + o, b = m + l, w = g + u, _ = Math.max(x + c, 1e-5), A = y + h, S = m + p, k = g + f, I = Math.max(x + d, 1e-5);
                                    t1.push(new zh(v / _, b / _, w / _)), r.push(new zh(A / I, S / I, k / I));
                                }
                                s.push(t1), a.push(r);
                            }
                            return [
                                s,
                                a
                            ];
                        }(e1, r, n, i, s);
                    }(s, n, h, c, u, a, g, p, y, s.center.lat, t1.tileID.canonical), b = t1.queryGeometry;
                    return function(t1, e1, r) {
                        let n = 1 / 0;
                        Mu(r, e1) && (n = Eh(r, e1[0]));
                        for(let i = 0; i < e1.length; i++){
                            const s = e1[i], a = t1[i];
                            for(let t1 = 0; t1 < s.length - 1; t1++){
                                const e1 = s[t1], i = [
                                    e1,
                                    s[t1 + 1],
                                    a[t1 + 1],
                                    a[t1],
                                    e1
                                ];
                                ku(r, i) && (n = Math.min(n, Eh(r, i)));
                            }
                        }
                        return n !== 1 / 0 && n;
                    }(x, v, b.isPointQuery() ? b.screenBounds : b.screenGeometry);
                }
            },
            line: class extends wo {
                constructor(t1){
                    super(t1, $h), this.gradientVersion = 0;
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    if ("line-gradient" === t1) {
                        const t1 = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = t1._styleExpression && t1._styleExpression.expression instanceof Ir, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    }
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                widthExpression() {
                    return this._transitionablePaint._values["line-width"].value.expression;
                }
                recalculate(t1, e1) {
                    super.recalculate(t1, e1), this.paint._values["line-floorwidth"] = Oh.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t1);
                }
                createBucket(t1) {
                    return new jh(t1);
                }
                getProgramIds() {
                    return [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                }
                getProgramConfiguration(t1) {
                    return new po(this, t1);
                }
                queryRadius(t1) {
                    const e1 = t1, r = qh(Fu("line-width", this, e1), Fu("line-gap-width", this, e1)), n = Fu("line-offset", this, e1);
                    return r / 2 + Math.abs(n) + Ru(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, s) {
                    if (t1.queryGeometry.isAboveHorizon) return !1;
                    const a = ju(t1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), o = t1.pixelToTileUnitsFactor / 2 * qh(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), l = this.paint.get("line-offset").evaluate(e1, r);
                    return l && (n = function(t1, e1) {
                        const r = [], n = new d(0, 0);
                        for(let i = 0; i < t1.length; i++){
                            const s = t1[i], a = [];
                            for(let t1 = 0; t1 < s.length; t1++){
                                const r = s[t1 - 1], i = s[t1], o = s[t1 + 1], l = 0 === t1 ? n : i.sub(r)._unit()._perp(), u = t1 === s.length - 1 ? n : o.sub(i)._unit()._perp(), c = l._add(u)._unit();
                                c._mult(1 / (c.x * u.x + c.y * u.y)), a.push(c._mult(e1)._add(i));
                            }
                            r.push(a);
                        }
                        return r;
                    }(n, l * t1.pixelToTileUnitsFactor)), function(t1, e1, r) {
                        for(let n = 0; n < e1.length; n++){
                            const i = e1[n];
                            if (t1.length >= 3) {
                                for(let e1 = 0; e1 < i.length; e1++)if (Du(t1, i[e1])) return !0;
                            }
                            if (Tu(t1, i, r)) return !0;
                        }
                        return !1;
                    }(a, n, o);
                }
                isTileClipped() {
                    return !0;
                }
            },
            symbol: yd,
            background: class extends wo {
                constructor(t1){
                    super(t1, md);
                }
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
            },
            raster: class extends wo {
                constructor(t1){
                    super(t1, gd);
                }
                getProgramIds() {
                    return [
                        "raster"
                    ];
                }
            },
            sky: class extends wo {
                constructor(t1){
                    super(t1, vd), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "sky-gradient" === t1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== t1 && "sky-atmosphere-halo-color" !== t1 && "sky-atmosphere-color" !== t1 && "sky-atmosphere-sun-intensity" !== t1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = ec({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(t1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const e1 = t1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== e1.azimuthal || this._lightPosition.polar !== e1.polar;
                    }
                    return !1;
                }
                getCenter(t1, e1) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const r = this.paint.get("sky-atmosphere-sun"), n = !r, i = t1.style.light, s = i.properties.get("position");
                        return n && "viewport" === i.properties.get("anchor") && $("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n ? bd(s.azimuthal, 90 - s.polar, e1) : bd(r[0], 90 - r[1], e1);
                    }
                    const r = this.paint.get("sky-gradient-center");
                    return bd(r[0], 90 - r[1], e1);
                }
                is3D() {
                    return !1;
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(t1) {
                    this._skyboxInvalidated = !1, this._lightPosition = t1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const t1 = this.paint.get("sky-type");
                    return "atmosphere" === t1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === t1 ? [
                        "skyboxGradient"
                    ] : null;
                }
            }
        };
        class _d {
            constructor(t1, e1, r, n){
                this.context = t1, this.format = r, this.texture = t1.gl.createTexture(), this.update(e1, n);
            }
            update(t1, r, n) {
                const { width: i, height: s } = t1, { context: a } = this, { gl: o } = a, { HTMLImageElement: l, HTMLCanvasElement: u, HTMLVideoElement: c, ImageData: h, ImageBitmap: p } = e1;
                if (o.bindTexture(o.TEXTURE_2D, this.texture), a.pixelStoreUnpackFlipY.set(!1), a.pixelStoreUnpack.set(1), a.pixelStoreUnpackPremultiplyAlpha.set(this.format === o.RGBA && (!r || !1 !== r.premultiply)), n || this.size && this.size[0] === i && this.size[1] === s) {
                    const { x: e1, y: r } = n || {
                        x: 0,
                        y: 0
                    };
                    t1 instanceof l || t1 instanceof u || t1 instanceof c || t1 instanceof h || p && t1 instanceof p ? o.texSubImage2D(o.TEXTURE_2D, 0, e1, r, o.RGBA, o.UNSIGNED_BYTE, t1) : o.texSubImage2D(o.TEXTURE_2D, 0, e1, r, i, s, o.RGBA, o.UNSIGNED_BYTE, t1.data);
                } else this.size = [
                    i,
                    s
                ], t1 instanceof l || t1 instanceof u || t1 instanceof c || t1 instanceof h || p && t1 instanceof p ? o.texImage2D(o.TEXTURE_2D, 0, this.format, this.format, o.UNSIGNED_BYTE, t1) : o.texImage2D(o.TEXTURE_2D, 0, this.format, i, s, 0, this.format, o.UNSIGNED_BYTE, t1.data);
                this.useMipmap = Boolean(r && r.useMipmap && this.isSizePowerOfTwo()), this.useMipmap && o.generateMipmap(o.TEXTURE_2D);
            }
            bind(t1, e1) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_2D, this.texture), t1 !== this.filter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, this.useMipmap ? t1 === n.NEAREST ? n.NEAREST_MIPMAP_NEAREST : n.LINEAR_MIPMAP_NEAREST : t1), this.filter = t1), e1 !== this.wrap && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e1), this.wrap = e1);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class Ad {
            constructor(t1){
                this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel = void 0, this._callback = ()=>{};
            }
        }
        class Sd {
            constructor(){
                this.tasks = {}, this.taskQueue = [], V([
                    "process"
                ], this), this.invoker = new Ad(this.process), this.nextId = 0;
            }
            add(t1, e1) {
                const r = this.nextId++, n = function({ type: t1, isSymbolTile: e1, zoom: r }) {
                    return r = r || 0, "message" === t1 ? 0 : "maybePrepare" !== t1 || e1 ? "parseTile" !== t1 || e1 ? "parseTile" === t1 && e1 ? 300 - r : "maybePrepare" === t1 && e1 ? 400 - r : 500 : 200 - r : 100 - r;
                }(e1);
                if (0 === n) {
                    N();
                    t1();
                    return {
                        cancel: ()=>{}
                    };
                }
                return this.tasks[r] = {
                    fn: t1,
                    metadata: e1,
                    priority: n,
                    id: r
                }, this.taskQueue.push(r), this.invoker.trigger(), {
                    cancel: ()=>{
                        delete this.tasks[r];
                    }
                };
            }
            process() {
                N();
                {
                    if (this.taskQueue = this.taskQueue.filter((t1)=>!!this.tasks[t1]), !this.taskQueue.length) return;
                    const t1 = this.pick();
                    if (null === t1) return;
                    const e1 = this.tasks[t1];
                    if (delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), !e1) return;
                    e1.fn();
                }
            }
            pick() {
                let t1 = null, e1 = 1 / 0;
                for(let r = 0; r < this.taskQueue.length; r++){
                    const n = this.tasks[this.taskQueue[r]];
                    n.priority < e1 && (e1 = n.priority, t1 = r);
                }
                if (null === t1) return null;
                const r = this.taskQueue[t1];
                return this.taskQueue.splice(t1, 1), r;
            }
            remove() {
                this.invoker.remove();
            }
        }
        class kd {
            constructor(t1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e1 = 0; e1 < t1.length; e1++){
                    const r = t1[e1];
                    this._stringToNumber[r] = e1, this._numberToString[e1] = r;
                }
            }
            encode(t1) {
                return this._stringToNumber[t1];
            }
            decode(t1) {
                return this._numberToString[t1];
            }
        }
        const Id = [
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class Md {
            constructor(t1, e1, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t1, this._z = e1, this._x = r, this._y = n, this.properties = t1.properties, this.id = i;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(t1) {
                this._geometry = t1;
            }
            toJSON() {
                const t1 = {
                    type: "Feature",
                    geometry: this.geometry,
                    properties: this.properties
                };
                void 0 !== this.id && (t1.id = this.id);
                for (const e1 of Id)void 0 !== this[e1] && (t1[e1] = this[e1]);
                return t1;
            }
        }
        const Td = 32, zd = 33, Bd = new Uint16Array(8184);
        for(let t1 = 0; t1 < 2046; t1++){
            let e1 = t1 + 2, r = 0, n = 0, i = 0, s = 0, a = 0, o = 0;
            for(1 & e1 ? i = s = a = Td : r = n = o = Td; (e1 >>= 1) > 1;){
                const t1 = r + i >> 1, l = n + s >> 1;
                1 & e1 ? (i = r, s = n, r = a, n = o) : (r = i, n = s, i = a, s = o), a = t1, o = l;
            }
            const l = 4 * t1;
            Bd[l + 0] = r, Bd[l + 1] = n, Bd[l + 2] = i, Bd[l + 3] = s;
        }
        const Ed = new Uint16Array(2178), Cd = new Uint8Array(1089), Pd = new Uint16Array(1089);
        function Dd(t1) {
            return 0 === t1 ? -0.03125 : 32 === t1 ? .03125 : 0;
        }
        var Vd = na([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        const Ld = {
            type: 2,
            extent: ko,
            loadGeometry: ()=>[
                    [
                        new d(0, 0),
                        new d(8193, 0),
                        new d(8193, 8193),
                        new d(0, 8193),
                        new d(0, 0)
                    ]
                ]
        };
        class Fd {
            constructor(t1, e1, r, n, i){
                this.tileID = t1, this.uid = E(), this.uses = 0, this.tileSize = e1, this.tileZoom = r, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = i, this.expiredRequestCount = 0, this.state = "loading", n && n.transform && (this.projection = n.transform.projection);
            }
            registerFadeDuration(t1) {
                const e1 = t1 + this.timeAdded;
                e1 < Nt.now() || this.fadeEndTime && e1 < this.fadeEndTime || (this.fadeEndTime = e1);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = Vf(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(t1, e1, r) {
                if (this.unloadVectorData(), this.state = "loaded", t1) {
                    t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = function(t1, e1) {
                        const r = {};
                        if (!e1) return r;
                        for (const n of t1){
                            const t1 = n.layerIds.map((t1)=>e1.getLayer(t1)).filter(Boolean);
                            if (0 !== t1.length) {
                                n.layers = t1, n.stateDependentLayerIds && (n.stateDependentLayers = n.stateDependentLayerIds.map((e1)=>t1.filter((t1)=>t1.id === e1)[0]));
                                for (const e1 of t1)r[e1.id] = n;
                            }
                        }
                        return r;
                    }(t1.buckets, e1.style), this.hasSymbolBuckets = !1;
                    for(const t1 in this.buckets){
                        const e1 = this.buckets[t1];
                        if (e1 instanceof hd) {
                            if (this.hasSymbolBuckets = !0, !r) break;
                            e1.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const t1 in this.buckets){
                        const e1 = this.buckets[t1];
                        if (e1 instanceof hd && e1.hasRTLText) {
                            this.hasRTLText = !0, js.isLoading() || js.isLoaded() || "deferred" !== Fs() || Rs();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const t1 in this.buckets){
                        const r = this.buckets[t1];
                        this.queryPadding = Math.max(this.queryPadding, e1.style.getLayer(t1).queryRadius(r));
                    }
                    t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage), t1.lineAtlas && (this.lineAtlas = t1.lineAtlas);
                } else this.collisionBoxArray = new Ea;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const t1 in this.buckets)this.buckets[t1].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            getBucket(t1) {
                return this.buckets[t1.id];
            }
            upload(t1) {
                for(const e1 in this.buckets){
                    const r = this.buckets[e1];
                    r.uploadPending() && r.upload(t1);
                }
                const e1 = t1.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new _d(t1, this.imageAtlas.image, e1.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new _d(t1, this.glyphAtlasImage, e1.ALPHA), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new _d(t1, this.lineAtlas.image, e1.ALPHA), this.lineAtlas.uploaded = !0);
            }
            prepare(t1) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(t1, this.imageAtlasTexture);
            }
            queryRenderedFeatures(t1, e1, r, n, i, s, a, o) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    tileResult: n,
                    pixelPosMatrix: a,
                    transform: s,
                    params: i,
                    tileTransform: this.tileTransform
                }, t1, e1, r) : {};
            }
            querySourceFeatures(t1, e1) {
                const r = this.latestFeatureIndex;
                if (!r || !r.rawTileData) return;
                const n = r.loadVTLayers(), i = e1 ? e1.sourceLayer : "", s = n._geojsonTileLayer || n[i];
                if (!s) return;
                const a = ai(e1 && e1.filter), { z: o, x: l, y: u } = this.tileID.canonical, c = {
                    z: o,
                    x: l,
                    y: u
                };
                for(let e1 = 0; e1 < s.length; e1++){
                    const n = s.feature(e1);
                    if (a.needGeometry) {
                        const t1 = wu(n, !0);
                        if (!a.filter(new Us(this.tileID.overscaledZ), t1, this.tileID.canonical)) continue;
                    } else if (!a.filter(new Us(this.tileID.overscaledZ), n)) continue;
                    const h = r.getId(n, i), p = new Md(n, o, l, u, h);
                    p.tile = c, t1.push(p);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(t1) {
                const e1 = this.expirationTime;
                if (t1.cacheControl) {
                    const e1 = G(t1.cacheControl);
                    e1["max-age"] && (this.expirationTime = Date.now() + 1e3 * e1["max-age"]);
                } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                if (this.expirationTime) {
                    const t1 = Date.now();
                    let r = !1;
                    if (this.expirationTime > t1) r = !1;
                    else if (e1) {
                        if (this.expirationTime < e1) r = !0;
                        else {
                            const n = this.expirationTime - e1;
                            n ? this.expirationTime = t1 + Math.max(n, 3e4) : r = !0;
                        }
                    } else r = !0;
                    r ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(t1, e1) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(t1).length || !e1) return;
                const r = this.latestFeatureIndex.loadVTLayers(), n = e1.style.listImages();
                for(const i in this.buckets){
                    if (!e1.style.hasLayer(i)) continue;
                    const s = this.buckets[i], a = s.layers[0].sourceLayer || "_geojsonTileLayer", o = r[a], l = t1[a];
                    if (!o || !l || 0 === Object.keys(l).length) continue;
                    if (s.update(l, o, n, this.imageAtlas && this.imageAtlas.patternPositions || {}), s instanceof jh || s instanceof Uc) {
                        const t1 = e1.style._getSourceCache(s.layers[0].source);
                        e1._terrain && e1._terrain.enabled && t1 && s.programConfigurations.needsUpload && e1._terrain._clearRenderCacheForTile(t1.id, this.tileID);
                    }
                    const u = e1 && e1.style && e1.style.getLayer(i);
                    u && (this.queryPadding = Math.max(this.queryPadding, u.queryRadius(s)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < Nt.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t1) {
                this.symbolFadeHoldUntil = Nt.now() + t1;
            }
            setTexture(t1, e1) {
                const r = e1.context, n = r.gl;
                this.texture = this.texture || e1.getTileTexture(t1.width), this.texture ? this.texture.update(t1, {
                    useMipmap: !0
                }) : (this.texture = new _d(r, t1, n.RGBA, {
                    useMipmap: !0
                }), this.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), r.extTextureFilterAnisotropic && n.texParameterf(n.TEXTURE_2D, r.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, r.extTextureFilterAnisotropicMax));
            }
            setDependencies(t1, e1) {
                const r = {};
                for (const t1 of e1)r[t1] = !0;
                this.dependencies[t1] = r;
            }
            hasDependency(t1, e1) {
                for (const r of t1){
                    const t1 = this.dependencies[r];
                    if (t1) {
                        for (const r of e1)if (t1[r]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(t1, e1) {
                if (!e1 || "mercator" === e1.name || this._tileDebugBuffer) return;
                const r = bu(Ld, this.tileID.canonical, this.tileTransform)[0], n = new sa, i = new Ta;
                for(let t1 = 0; t1 < r.length; t1++){
                    const { x: e1, y: s } = r[t1];
                    n.emplaceBack(e1, s), i.emplaceBack(t1);
                }
                i.emplaceBack(0), this._tileDebugIndexBuffer = t1.createIndexBuffer(i), this._tileDebugBuffer = t1.createVertexBuffer(n, xl.members), this._tileDebugSegments = So.simpleSegment(0, 0, n.length, i.length);
            }
            _makeTileBoundsBuffers(t1, e1) {
                if (this._tileBoundsBuffer || !e1 || "mercator" === e1.name) return;
                const r = bu(Ld, this.tileID.canonical, this.tileTransform)[0];
                let n, i;
                if (this.isRaster) {
                    const t1 = function(t1, e1) {
                        const r = Vf(t1, e1), n = Math.pow(2, t1.z);
                        for(let i = 0; i < zd; i++)for(let s = 0; s < zd; s++){
                            const a = ou((t1.x + (s + Dd(s)) / Td) / n), o = lu((t1.y + (i + Dd(i)) / Td) / n), l = e1.project(a, o), u = i * zd + s;
                            Ed[2 * u + 0] = Math.round((l.x * r.scale - r.x) * ko), Ed[2 * u + 1] = Math.round((l.y * r.scale - r.y) * ko);
                        }
                        Cd.fill(0), Pd.fill(0);
                        for(let t1 = 2045; t1 >= 0; t1--){
                            const e1 = 4 * t1, r = Bd[e1 + 0], n = Bd[e1 + 1], i = Bd[e1 + 2], s = Bd[e1 + 3], a = r + i >> 1, o = n + s >> 1, l = a + o - n, u = o + r - a, c = n * zd + r, h = s * zd + i, p = o * zd + a, f = Math.hypot((Ed[2 * c + 0] + Ed[2 * h + 0]) / 2 - Ed[2 * p + 0], (Ed[2 * c + 1] + Ed[2 * h + 1]) / 2 - Ed[2 * p + 1]) >= 16;
                            if (Cd[p] = Cd[p] || (f ? 1 : 0), t1 < 1022) {
                                const t1 = (n + u >> 1) * zd + (r + l >> 1), e1 = (s + u >> 1) * zd + (i + l >> 1);
                                Cd[p] = Cd[p] || Cd[t1] || Cd[e1];
                            }
                        }
                        const i = new oa, s = new wa;
                        let a = 0;
                        function o(t1, e1) {
                            const r = e1 * zd + t1;
                            return 0 === Pd[r] && (i.emplaceBack(Ed[2 * r + 0], Ed[2 * r + 1], t1 * ko / Td, e1 * ko / Td), Pd[r] = ++a), Pd[r] - 1;
                        }
                        function l(t1, e1, r, n, i, a) {
                            const u = t1 + r >> 1, c = e1 + n >> 1;
                            if (Math.abs(t1 - i) + Math.abs(e1 - a) > 1 && Cd[c * zd + u]) l(i, a, t1, e1, u, c), l(r, n, i, a, u, c);
                            else {
                                const l = o(t1, e1), u = o(r, n), c = o(i, a);
                                s.emplaceBack(l, u, c);
                            }
                        }
                        return l(0, 0, Td, Td, Td, 0), l(Td, Td, 0, 0, 0, Td), {
                            vertices: i,
                            indices: s
                        };
                    }(this.tileID.canonical, e1);
                    n = t1.vertices, i = t1.indices;
                } else {
                    n = new oa, i = new wa;
                    for (const { x: t1, y: e1 } of r)n.emplaceBack(t1, e1, 0, 0);
                    const t1 = sc(n.int16, void 0, 4);
                    for(let e1 = 0; e1 < t1.length; e1 += 3)i.emplaceBack(t1[e1], t1[e1 + 1], t1[e1 + 2]);
                }
                this._tileBoundsBuffer = t1.createVertexBuffer(n, Vd.members), this._tileBoundsIndexBuffer = t1.createIndexBuffer(i), this._tileBoundsSegments = So.simpleSegment(0, 0, n.length, i.length);
            }
            _makeGlobeTileDebugBuffers(t1, e1) {
                const r = e1.projection;
                if (!r || "globe" !== r.name || e1.freezeTileCoverage) return;
                const n = this.tileID.canonical, i = Gl(Vl(n, e1)), s = Kl(e1.zoom);
                let a;
                s > 0 && (a = Co(new Float64Array(16), e1.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(t1, n, e1, i, a, s), this._makeGlobeTileDebugTextBuffer(t1, n, e1, i, a, s);
            }
            _globePoint(t1, e1, r, n, i, s, a) {
                let o = Ol(t1, e1, r);
                if (s) {
                    const i = 1 << r.z, l = iu(n.center.lng), u = su(n.center.lat), c = (r.x + .5) / i - l;
                    let h = 0;
                    c > .5 ? h = -1 : c < -0.5 && (h = 1);
                    let p = (t1 / ko + r.x) / i + h, f = (e1 / ko + r.y) / i;
                    p = (p - l) * n._pixelsPerMercatorPixel + l, f = (f - u) * n._pixelsPerMercatorPixel + u;
                    const d = [
                        p * n.worldSize,
                        f * n.worldSize,
                        0
                    ];
                    el(d, d, s), o = Dl(o, d, a);
                }
                return el(o, o, i);
            }
            _makeGlobeTileDebugBorderBuffer(t1, e1, r, n, i, s) {
                const a = new sa, o = new Ta, l = new aa, u = (t1, u, c, h, p)=>{
                    const f = (c - t1) / (p - 1), d = (h - u) / (p - 1), y = a.length;
                    for(let c = 0; c < p; c++){
                        const h = t1 + c * f, p = u + c * d;
                        a.emplaceBack(h, p);
                        const m = this._globePoint(h, p, e1, r, n, i, s);
                        l.emplaceBack(m[0], m[1], m[2]), o.emplaceBack(y + c);
                    }
                }, c = ko;
                u(0, 0, c, 0, 16), u(c, 0, c, c, 16), u(c, c, 0, c, 16), u(0, c, 0, 0, 16), this._tileDebugIndexBuffer = t1.createIndexBuffer(o), this._tileDebugBuffer = t1.createVertexBuffer(a, xl.members), this._globeTileDebugBorderBuffer = t1.createVertexBuffer(l, gl.members), this._tileDebugSegments = So.simpleSegment(0, 0, a.length, o.length);
            }
            _makeGlobeTileDebugTextBuffer(t1, e1, r, n, i, s) {
                const a = new sa, o = new wa, l = new aa, u = 25;
                o.reserve(32), a.reserve(u), l.reserve(u);
                const c = (t1, e1)=>u * t1 + e1;
                for(let t1 = 0; t1 < u; t1++){
                    const o = 2048 * t1;
                    for(let t1 = 0; t1 < u; t1++){
                        const u = 2048 * t1;
                        a.emplaceBack(u, o);
                        const c = this._globePoint(u, o, e1, r, n, i, s);
                        l.emplaceBack(c[0], c[1], c[2]);
                    }
                }
                for(let t1 = 0; t1 < 4; t1++)for(let e1 = 0; e1 < 4; e1++){
                    const r = c(t1, e1), n = c(t1, e1 + 1), i = c(t1 + 1, e1), s = c(t1 + 1, e1 + 1);
                    o.emplaceBack(r, n, i), o.emplaceBack(i, n, s);
                }
                this._tileDebugTextIndexBuffer = t1.createIndexBuffer(o), this._tileDebugTextBuffer = t1.createVertexBuffer(a, xl.members), this._globeTileDebugTextBuffer = t1.createVertexBuffer(l, gl.members), this._tileDebugTextSegments = So.simpleSegment(0, 0, u, 32);
            }
        }
        class Rd {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(t1, e1, r) {
                const n = String(e1);
                if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][n] = this.stateChanges[t1][n] || {}, z(this.stateChanges[t1][n], r), null === this.deletedStates[t1]) {
                    this.deletedStates[t1] = {};
                    for(const e1 in this.state[t1])e1 !== n && (this.deletedStates[t1][e1] = null);
                } else if (this.deletedStates[t1] && null === this.deletedStates[t1][n]) {
                    this.deletedStates[t1][n] = {};
                    for(const e1 in this.state[t1][n])r[e1] || (this.deletedStates[t1][n][e1] = null);
                } else for(const e1 in r)this.deletedStates[t1] && this.deletedStates[t1][n] && null === this.deletedStates[t1][n][e1] && delete this.deletedStates[t1][n][e1];
            }
            removeFeatureState(t1, e1, r) {
                if (null === this.deletedStates[t1]) return;
                const n = String(e1);
                if (this.deletedStates[t1] = this.deletedStates[t1] || {}, r && void 0 !== e1) null !== this.deletedStates[t1][n] && (this.deletedStates[t1][n] = this.deletedStates[t1][n] || {}, this.deletedStates[t1][n][r] = null);
                else if (void 0 !== e1) {
                    if (this.stateChanges[t1] && this.stateChanges[t1][n]) for(r in this.deletedStates[t1][n] = {}, this.stateChanges[t1][n])this.deletedStates[t1][n][r] = null;
                    else this.deletedStates[t1][n] = null;
                } else this.deletedStates[t1] = null;
            }
            getState(t1, e1) {
                const r = String(e1), n = z({}, (this.state[t1] || {})[r], (this.stateChanges[t1] || {})[r]);
                if (null === this.deletedStates[t1]) return {};
                if (this.deletedStates[t1]) {
                    const r = this.deletedStates[t1][e1];
                    if (null === r) return {};
                    for(const t1 in r)delete n[t1];
                }
                return n;
            }
            initializeTileState(t1, e1) {
                t1.setFeatureState(this.state, e1);
            }
            coalesceChanges(t1, e1) {
                const r = {};
                for(const t1 in this.stateChanges){
                    this.state[t1] = this.state[t1] || {};
                    const e1 = {};
                    for(const r in this.stateChanges[t1])this.state[t1][r] || (this.state[t1][r] = {}), z(this.state[t1][r], this.stateChanges[t1][r]), e1[r] = this.state[t1][r];
                    r[t1] = e1;
                }
                for(const t1 in this.deletedStates){
                    this.state[t1] = this.state[t1] || {};
                    const e1 = {};
                    if (null === this.deletedStates[t1]) for(const r in this.state[t1])e1[r] = {}, this.state[t1][r] = {};
                    else for(const r in this.deletedStates[t1]){
                        if (null === this.deletedStates[t1][r]) this.state[t1][r] = {};
                        else if (this.state[t1][r]) for (const e1 of Object.keys(this.deletedStates[t1][r]))delete this.state[t1][r][e1];
                        e1[r] = this.state[t1][r];
                    }
                    r[t1] = r[t1] || {}, z(r[t1], e1);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r).length) for(const n in t1)t1[n].setFeatureState(r, e1);
            }
        }
        class jd {
            constructor(t1){
                this.size = t1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
            getElevation(t1, e1) {
                const r = this.toIdx(t1, e1);
                return {
                    min: this.minimums[r],
                    max: this.maximums[r]
                };
            }
            isLeaf(t1, e1) {
                return this.leaves[this.toIdx(t1, e1)];
            }
            toIdx(t1, e1) {
                return e1 * this.size + t1;
            }
        }
        function Ud(t1, e1, r, n) {
            let i = 0, s = Number.MAX_VALUE;
            for(let a = 0; a < 3; a++)if (Math.abs(n[a]) < 1e-15) {
                if (r[a] < t1[a] || r[a] > e1[a]) return null;
            } else {
                const o = 1 / n[a];
                let l = (t1[a] - r[a]) * o, u = (e1[a] - r[a]) * o;
                if (l > u) {
                    const t1 = l;
                    l = u, u = t1;
                }
                if (l > i && (i = l), u < s && (s = u), i > s) return null;
            }
            return i;
        }
        function $d(t1, e1, r, n, i, s, a, o, l, u, c) {
            const h = n - t1, p = i - e1, f = s - r, d = a - t1, y = o - e1, m = l - r, g = c[1] * m - c[2] * y, x = c[2] * d - c[0] * m, v = c[0] * y - c[1] * d, b = h * g + p * x + f * v;
            if (Math.abs(b) < 1e-15) return null;
            const w = 1 / b, _ = u[0] - t1, A = u[1] - e1, S = u[2] - r, k = (_ * g + A * x + S * v) * w;
            if (k < 0 || k > 1) return null;
            const I = A * f - S * p, M = S * h - _ * f, T = _ * p - A * h, z = (c[0] * I + c[1] * M + c[2] * T) * w;
            return z < 0 || k + z > 1 ? null : (d * I + y * M + m * T) * w;
        }
        function Od(t1, e1, r) {
            return (t1 - e1) / (r - e1);
        }
        function qd(t1, e1, r, n, i, s, a, o, l) {
            const u = 1 << r, c = s - n, h = a - i, p = (t1 + 1) / u * c + n, f = (e1 + 0) / u * h + i, d = (e1 + 1) / u * h + i;
            o[0] = (t1 + 0) / u * c + n, o[1] = f, l[0] = p, l[1] = d;
        }
        class Nd {
            constructor(t1){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t1, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const e1 = function(t1) {
                    const e1 = Math.ceil(Math.log2(t1.dim / 8)), r = [];
                    let n = Math.ceil(Math.pow(2, e1));
                    const i = 1 / n, s = (t1, e1, r, n, i)=>{
                        const s = n ? 1 : 0, a = (t1 + 1) * r - s, o = e1 * r, l = (e1 + 1) * r - s;
                        i[0] = t1 * r, i[1] = o, i[2] = a, i[3] = l;
                    };
                    let a = new jd(n);
                    const o = [];
                    for(let e1 = 0; e1 < n * n; e1++){
                        s(e1 % n, Math.floor(e1 / n), i, !1, o);
                        const r = Xd(o[0], o[1], t1), l = Xd(o[2], o[1], t1), u = Xd(o[2], o[3], t1), c = Xd(o[0], o[3], t1);
                        a.minimums.push(Math.min(r, l, u, c)), a.maximums.push(Math.max(r, l, u, c)), a.leaves.push(1);
                    }
                    for(r.push(a), n /= 2; n >= 1; n /= 2){
                        const t1 = r[r.length - 1];
                        a = new jd(n);
                        for(let e1 = 0; e1 < n * n; e1++){
                            s(e1 % n, Math.floor(e1 / n), 2, !0, o);
                            const r = t1.getElevation(o[0], o[1]), i = t1.getElevation(o[2], o[1]), l = t1.getElevation(o[2], o[3]), u = t1.getElevation(o[0], o[3]), c = t1.isLeaf(o[0], o[1]), h = t1.isLeaf(o[2], o[1]), p = t1.isLeaf(o[2], o[3]), f = t1.isLeaf(o[0], o[3]), d = Math.min(r.min, i.min, l.min, u.min), y = Math.max(r.max, i.max, l.max, u.max), m = c && h && p && f;
                            a.maximums.push(y), a.minimums.push(d), a.leaves.push(y - d <= 5 && m ? 1 : 0);
                        }
                        r.push(a);
                    }
                    return r;
                }(this.dem), r = e1.length - 1, n = e1[r];
                this._addNode(n.minimums[0], n.maximums[0], n.leaves[0]), this._construct(e1, 0, 0, r, 0);
            }
            raycastRoot(t1, e1, r, n, i, s, a = 1) {
                return Ud([
                    t1,
                    e1,
                    -100
                ], [
                    r,
                    n,
                    this.maximums[0] * a
                ], i, s);
            }
            raycast(t1, e1, r, n, i, s, a = 1) {
                if (!this.nodeCount) return null;
                const o = this.raycastRoot(t1, e1, r, n, i, s, a);
                if (null == o) return null;
                const l = [], u = [], c = [], h = [], p = [
                    {
                        idx: 0,
                        t: o,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; p.length > 0;){
                    const { idx: o, t: f, nodex: d, nodey: y, depth: m } = p.pop();
                    if (this.leaves[o]) {
                        qd(d, y, m, t1, e1, r, n, c, h);
                        const o = 1 << m, l = (d + 0) / o, u = (d + 1) / o, p = (y + 0) / o, g = (y + 1) / o, x = Xd(l, p, this.dem) * a, v = Xd(u, p, this.dem) * a, b = Xd(u, g, this.dem) * a, w = Xd(l, g, this.dem) * a, _ = $d(c[0], c[1], x, h[0], c[1], v, h[0], h[1], b, i, s), A = $d(h[0], h[1], b, c[0], h[1], w, c[0], c[1], x, i, s), S = Math.min(null !== _ ? _ : Number.MAX_VALUE, null !== A ? A : Number.MAX_VALUE);
                        if (S !== Number.MAX_VALUE) return S;
                        {
                            const t1 = Wo([], i, s, f);
                            if (Gd(x, v, w, b, Od(t1[0], c[0], h[0]), Od(t1[1], c[1], h[1])) >= t1[2]) return f;
                        }
                        continue;
                    }
                    let g = 0;
                    for(let p = 0; p < this._siblingOffset.length; p++){
                        qd((d << 1) + this._siblingOffset[p][0], (y << 1) + this._siblingOffset[p][1], m + 1, t1, e1, r, n, c, h), c[2] = -100, h[2] = this.maximums[this.childOffsets[o] + p] * a;
                        const f = Ud(c, h, i, s);
                        if (null != f) {
                            const t1 = f;
                            l[p] = t1;
                            let e1 = !1;
                            for(let r = 0; r < g && !e1; r++)t1 >= l[u[r]] && (u.splice(r, 0, p), e1 = !0);
                            e1 || (u[g] = p), g++;
                        }
                    }
                    for(let t1 = 0; t1 < g; t1++){
                        const e1 = u[t1];
                        p.push({
                            idx: this.childOffsets[o] + e1,
                            t: l[e1],
                            nodex: (d << 1) + this._siblingOffset[e1][0],
                            nodey: (y << 1) + this._siblingOffset[e1][1],
                            depth: m + 1
                        });
                    }
                }
                return null;
            }
            _addNode(t1, e1, r) {
                return this.minimums.push(t1), this.maximums.push(e1), this.leaves.push(r), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(t1, e1, r, n, i) {
                if (1 === t1[n].isLeaf(e1, r)) return;
                this.childOffsets[i] || (this.childOffsets[i] = this.nodeCount);
                const s = n - 1, a = t1[s];
                let o = 0, l = 0;
                for(let t1 = 0; t1 < this._siblingOffset.length; t1++){
                    const n = 2 * e1 + this._siblingOffset[t1][0], i = 2 * r + this._siblingOffset[t1][1], s = a.getElevation(n, i), u = a.isLeaf(n, i), c = this._addNode(s.min, s.max, u);
                    u && (o |= 1 << t1), l || (l = c);
                }
                for(let n = 0; n < this._siblingOffset.length; n++)o & 1 << n || this._construct(t1, 2 * e1 + this._siblingOffset[n][0], 2 * r + this._siblingOffset[n][1], s, l + n);
            }
        }
        function Gd(t1, e1, r, n, i, s) {
            return Mr(Mr(t1, r, s), Mr(e1, n, s), i);
        }
        function Xd(t1, e1, r) {
            const n = r.dim, i = S(t1 * n - .5, 0, n - 1), s = S(e1 * n - .5, 0, n - 1), a = Math.floor(i), o = Math.floor(s), l = Math.min(a + 1, n - 1), u = Math.min(o + 1, n - 1);
            return Gd(r.get(a, o), r.get(l, o), r.get(a, u), r.get(l, u), i - a, s - o);
        }
        const Zd = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        class Kd {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            constructor(t1, e1, r, n = !1, i = !1){
                if (this.uid = t1, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
                if (r && "mapbox" !== r && "terrarium" !== r) return $(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = e1.height;
                const s = this.dim = e1.height - 2, a = new Uint32Array(e1.data.buffer);
                if (this.pixels = new Uint8Array(e1.data.buffer), this.encoding = r || "mapbox", this.borderReady = n, !n) {
                    for(let t1 = 0; t1 < s; t1++)a[this._idx(-1, t1)] = a[this._idx(0, t1)], a[this._idx(s, t1)] = a[this._idx(s - 1, t1)], a[this._idx(t1, -1)] = a[this._idx(t1, 0)], a[this._idx(t1, s)] = a[this._idx(t1, s - 1)];
                    a[this._idx(-1, -1)] = a[this._idx(0, 0)], a[this._idx(s, -1)] = a[this._idx(s - 1, 0)], a[this._idx(-1, s)] = a[this._idx(0, s - 1)], a[this._idx(s, s)] = a[this._idx(s - 1, s - 1)], i && this._buildQuadTree();
                }
            }
            _buildQuadTree() {
                this._tree = new Nd(this);
            }
            get(t1, e1, r = !1) {
                r && (t1 = S(t1, -1, this.dim), e1 = S(e1, -1, this.dim));
                const n = 4 * this._idx(t1, e1);
                return ("terrarium" === this.encoding ? this._unpackTerrarium : this._unpackMapbox)(this.pixels[n], this.pixels[n + 1], this.pixels[n + 2]);
            }
            static getUnpackVector(t1) {
                return Zd[t1];
            }
            get unpackVector() {
                return Zd[this.encoding];
            }
            _idx(t1, e1) {
                if (t1 < -1 || t1 >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e1 + 1) * this.stride + (t1 + 1);
            }
            _unpackMapbox(t1, e1, r) {
                return (256 * t1 * 256 + 256 * e1 + r) / 10 - 1e4;
            }
            _unpackTerrarium(t1, e1, r) {
                return 256 * t1 + e1 + r / 256 - 32768;
            }
            static pack(t1, e1) {
                const r = [
                    0,
                    0,
                    0,
                    0
                ], n = Kd.getUnpackVector(e1);
                let i = Math.floor((t1 + n[3]) / n[2]);
                return r[2] = i % 256, i = Math.floor(i / 256), r[1] = i % 256, i = Math.floor(i / 256), r[0] = i, r;
            }
            getPixels() {
                return new Qu({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(t1, e1, r) {
                if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                let n = e1 * this.dim, i = e1 * this.dim + this.dim, s = r * this.dim, a = r * this.dim + this.dim;
                switch(e1){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        s = a - 1;
                        break;
                    case 1:
                        a = s + 1;
                }
                const o = -e1 * this.dim, l = -r * this.dim;
                for(let e1 = s; e1 < a; e1++)for(let r = n; r < i; r++){
                    const n = 4 * this._idx(r, e1), i = 4 * this._idx(r + o, e1 + l);
                    this.pixels[n + 0] = t1.pixels[i + 0], this.pixels[n + 1] = t1.pixels[i + 1], this.pixels[n + 2] = t1.pixels[i + 2], this.pixels[n + 3] = t1.pixels[i + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
        }
        Oi(Kd, "DEMData"), Oi(Nd, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        class Yd {
            constructor(t1, e1){
                this.max = t1, this.onRemove = e1, this.reset();
            }
            reset() {
                for(const t1 in this.data)for (const e1 of this.data[t1])e1.timeout && clearTimeout(e1.timeout), this.onRemove(e1.value);
                return this.data = {}, this.order = [], this;
            }
            add(t1, e1, r) {
                const n = t1.wrapped().key;
                void 0 === this.data[n] && (this.data[n] = []);
                const i = {
                    value: e1,
                    timeout: void 0
                };
                if (void 0 !== r && (i.timeout = setTimeout(()=>{
                    this.remove(t1, i);
                }, r)), this.data[n].push(i), this.order.push(n), this.order.length > this.max) {
                    const t1 = this._getAndRemoveByKey(this.order[0]);
                    t1 && this.onRemove(t1);
                }
                return this;
            }
            has(t1) {
                return t1.wrapped().key in this.data;
            }
            getAndRemove(t1) {
                return this.has(t1) ? this._getAndRemoveByKey(t1.wrapped().key) : null;
            }
            _getAndRemoveByKey(t1) {
                const e1 = this.data[t1].shift();
                return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t1].length && delete this.data[t1], this.order.splice(this.order.indexOf(t1), 1), e1.value;
            }
            getByKey(t1) {
                const e1 = this.data[t1];
                return e1 ? e1[0].value : null;
            }
            get(t1) {
                return this.has(t1) ? this.data[t1.wrapped().key][0].value : null;
            }
            remove(t1, e1) {
                if (!this.has(t1)) return this;
                const r = t1.wrapped().key, n = void 0 === e1 ? 0 : this.data[r].indexOf(e1), i = this.data[r][n];
                return this.data[r].splice(n, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[r].length && delete this.data[r], this.onRemove(i.value), this.order.splice(this.order.indexOf(r), 1), this;
            }
            setMaxSize(t1) {
                for(this.max = t1; this.order.length > this.max;){
                    const t1 = this._getAndRemoveByKey(this.order[0]);
                    t1 && this.onRemove(t1);
                }
                return this;
            }
            filter(t1) {
                const e1 = [];
                for(const r in this.data)for (const n of this.data[r])t1(n.value) || e1.push(n);
                for (const t1 of e1)this.remove(t1.value.tileID, t1);
            }
        }
        class Hd {
            constructor(t1, e1, r){
                this.func = t1, this.mask = e1, this.range = r;
            }
        }
        Hd.ReadOnly = !1, Hd.ReadWrite = !0, Hd.disabled = new Hd(519, Hd.ReadOnly, [
            0,
            1
        ]);
        const Wd = 7680;
        class Jd {
            constructor(t1, e1, r, n, i, s){
                this.test = t1, this.ref = e1, this.mask = r, this.fail = n, this.depthFail = i, this.pass = s;
            }
        }
        Jd.disabled = new Jd({
            func: 519,
            mask: 0
        }, 0, 0, Wd, Wd, Wd);
        class Qd {
            constructor(t1, e1, r){
                this.blendFunction = t1, this.blendColor = e1, this.mask = r;
            }
        }
        Qd.Replace = [
            1,
            0
        ], Qd.disabled = new Qd(Qd.Replace, Me.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Qd.unblended = new Qd(Qd.Replace, Me.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Qd.alphaBlended = new Qd([
            1,
            771
        ], Me.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        const ty = 1029, ey = 2305;
        class ry {
            constructor(t1, e1, r){
                this.enable = t1, this.mode = e1, this.frontFace = r;
            }
        }
        ry.disabled = new ry(!1, ty, ey), ry.backCCW = new ry(!0, ty, ey), ry.backCW = new ry(!0, ty, 2304), ry.frontCW = new ry(!0, 1028, 2304), ry.frontCCW = new ry(!0, 1028, ey);
        class ny extends Yt {
            constructor(t1, e1, r){
                super(), this.id = t1, this._onlySymbols = r, e1.on("data", (t1)=>{
                    "source" === t1.dataType && "metadata" === t1.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === t1.dataType && "content" === t1.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), e1.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = e1, this._tiles = {}, this._cache = new Yd(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = e1.minTileCacheSize, this._maxTileCacheSize = e1.maxTileCacheSize, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new Rd, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
            }
            onAdd(t1) {
                this.map = t1, this._minTileCacheSize = void 0 === this._minTileCacheSize && t1 ? t1._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && t1 ? t1._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const t1 in this._tiles){
                    const e1 = this._tiles[t1];
                    if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const t1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, t1 && this.reload(), this.transform && this.update(this.transform);
            }
            _loadTile(t1, e1) {
                return t1.isSymbolTile = this._onlySymbols, this._source.loadTile(t1, e1);
            }
            _unloadTile(t1) {
                if (this._source.unloadTile) return this._source.unloadTile(t1, ()=>{});
            }
            _abortTile(t1) {
                if (this._source.abortTile) return this._source.abortTile(t1, ()=>{});
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(t1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const e1 in this._tiles){
                    const r = this._tiles[e1];
                    r.upload(t1), r.prepare(this.map.style.imageManager);
                }
            }
            getIds() {
                return T(this._tiles).map((t1)=>t1.tileID).sort(iy).map((t1)=>t1.key);
            }
            getRenderableIds(t1) {
                const e1 = [];
                for(const r in this._tiles)this._isIdRenderable(+r, t1) && e1.push(this._tiles[r]);
                return t1 ? e1.sort((t1, e1)=>{
                    const r = t1.tileID, n = e1.tileID, i = new d(r.canonical.x, r.canonical.y)._rotate(this.transform.angle), s = new d(n.canonical.x, n.canonical.y)._rotate(this.transform.angle);
                    return r.overscaledZ - n.overscaledZ || s.y - i.y || s.x - i.x;
                }).map((t1)=>t1.tileID.key) : e1.map((t1)=>t1.tileID).sort(iy).map((t1)=>t1.key);
            }
            hasRenderableParent(t1) {
                const e1 = this.findLoadedParent(t1, 0);
                return !!e1 && this._isIdRenderable(e1.tileID.key);
            }
            _isIdRenderable(t1, e1) {
                return this._tiles[t1] && this._tiles[t1].hasData() && !this._coveredTiles[t1] && (e1 || !this._tiles[t1].holdingForFade());
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const t1 in this._tiles)"errored" !== this._tiles[t1].state && this._reloadTile(+t1, "reloading");
                }
            }
            _reloadTile(t1, e1) {
                const r = this._tiles[t1];
                r && ("loading" !== r.state && (r.state = e1), this._loadTile(r, this._tileLoaded.bind(this, r, t1, e1)));
            }
            _tileLoaded(t1, e1, r, n) {
                if (n) {
                    if (t1.state = "errored", 404 !== n.status) this._source.fire(new Kt(n, {
                        tile: t1
                    }));
                    else if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                        const t1 = this.map.painter.terrain;
                        this.update(this.transform, t1.getScaledDemTileSize(), !0), t1.resetTileLookupCache(this.id);
                    } else this.update(this.transform);
                } else t1.timeAdded = Nt.now(), "expired" === r && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(e1, t1), "raster-dem" === this._source.type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null), this._source.fire(new Zt("data", {
                    dataType: "source",
                    tile: t1,
                    coord: t1.tileID,
                    sourceCacheId: this.id
                }));
            }
            _backfillDEM(t1) {
                const e1 = this.getRenderableIds();
                for(let n = 0; n < e1.length; n++){
                    const i = e1[n];
                    if (t1.neighboringTiles && t1.neighboringTiles[i]) {
                        const e1 = this.getTileByID(i);
                        r(t1, e1), r(e1, t1);
                    }
                }
                function r(t1, e1) {
                    if (!t1.dem || t1.dem.borderReady) return;
                    t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0;
                    let r = e1.tileID.canonical.x - t1.tileID.canonical.x;
                    const n = e1.tileID.canonical.y - t1.tileID.canonical.y, i = Math.pow(2, t1.tileID.canonical.z), s = e1.tileID.key;
                    0 === r && 0 === n || Math.abs(n) > 1 || (Math.abs(r) > 1 && (1 === Math.abs(r + i) ? r += i : 1 === Math.abs(r - i) && (r -= i)), e1.dem && t1.dem && (t1.dem.backfillBorder(e1.dem, r, n), t1.neighboringTiles && t1.neighboringTiles[s] && (t1.neighboringTiles[s].backfilled = !0)));
                }
            }
            getTile(t1) {
                return this.getTileByID(t1.key);
            }
            getTileByID(t1) {
                return this._tiles[t1];
            }
            _retainLoadedChildren(t1, e1, r, n) {
                for(const i in this._tiles){
                    let s = this._tiles[i];
                    if (n[i] || !s.hasData() || s.tileID.overscaledZ <= e1 || s.tileID.overscaledZ > r) continue;
                    let a = s.tileID;
                    for(; s && s.tileID.overscaledZ > e1 + 1;){
                        const t1 = s.tileID.scaledTo(s.tileID.overscaledZ - 1);
                        s = this._tiles[t1.key], s && s.hasData() && (a = t1);
                    }
                    let o = a;
                    for(; o.overscaledZ > e1;)if (o = o.scaledTo(o.overscaledZ - 1), t1[o.key]) {
                        n[a.key] = a;
                        break;
                    }
                }
            }
            findLoadedParent(t1, e1) {
                if (t1.key in this._loadedParentTiles) {
                    const r = this._loadedParentTiles[t1.key];
                    return r && r.tileID.overscaledZ >= e1 ? r : null;
                }
                for(let r = t1.overscaledZ - 1; r >= e1; r--){
                    const e1 = t1.scaledTo(r), n = this._getLoadedTile(e1);
                    if (n) return n;
                }
            }
            _getLoadedTile(t1) {
                const e1 = this._tiles[t1.key];
                return e1 && e1.hasData() ? e1 : this._cache.getByKey(this._source.reparseOverscaled ? t1.wrapped().key : t1.canonical.key);
            }
            updateCacheSize(t1, e1) {
                e1 = e1 || this._source.tileSize;
                const r = Math.ceil(t1.width / e1) + 1, n = Math.ceil(t1.height / e1) + 1, i = Math.floor(r * n * 5), s = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, i) : i, a = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, s) : s;
                this._cache.setMaxSize(a);
            }
            handleWrapJump(t1) {
                const e1 = Math.round((t1 - (void 0 === this._prevLng ? t1 : this._prevLng)) / 360);
                if (this._prevLng = t1, e1) {
                    const t1 = {};
                    for(const r in this._tiles){
                        const n = this._tiles[r];
                        n.tileID = n.tileID.unwrapTo(n.tileID.wrap + e1), t1[n.tileID.key] = n;
                    }
                    this._tiles = t1;
                    for(const t1 in this._timers)clearTimeout(this._timers[t1]), delete this._timers[t1];
                    for(const t1 in this._tiles)this._setTileReloadTimer(+t1, this._tiles[t1]);
                }
            }
            update(t1, e1, r) {
                if (this.transform = t1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !r) return;
                let n;
                this.updateCacheSize(t1, e1), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? n = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new Mh(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y)) : (n = t1.coveringTiles({
                    tileSize: e1 || this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom && !r,
                    reparseOverscaled: this._source.reparseOverscaled,
                    isTerrainDEM: this.usedForTerrain
                }), this._source.hasTile && (n = n.filter((t1)=>this._source.hasTile(t1)))) : n = [];
                const i = this._updateRetainedTiles(n);
                if (sy(this._source.type) && 0 !== n.length) {
                    const t1 = {}, e1 = {}, r = Object.keys(i);
                    for (const n of r){
                        const r = i[n], s = this._tiles[n];
                        if (!s || s.fadeEndTime && s.fadeEndTime <= Nt.now()) continue;
                        const a = this.findLoadedParent(r, Math.max(r.overscaledZ - ny.maxOverzooming, this._source.minzoom));
                        a && (this._addTile(a.tileID), t1[a.tileID.key] = a.tileID), e1[n] = r;
                    }
                    const s = n[n.length - 1].overscaledZ;
                    for(const t1 in this._tiles){
                        const r = this._tiles[t1];
                        if (i[t1] || !r.hasData()) continue;
                        let n = r.tileID;
                        for(; n.overscaledZ > s;){
                            n = n.scaledTo(n.overscaledZ - 1);
                            const s = this._tiles[n.key];
                            if (s && s.hasData() && e1[n.key]) {
                                i[t1] = r.tileID;
                                break;
                            }
                        }
                    }
                    for(const e1 in t1)i[e1] || (this._coveredTiles[e1] = !0, i[e1] = t1[e1]);
                }
                for(const t1 in i)this._tiles[t1].clearFadeHold();
                const s = function(t1, e1) {
                    const r = [];
                    for(const n in t1)n in e1 || r.push(n);
                    return r;
                }(this._tiles, i);
                for (const t1 of s){
                    const e1 = this._tiles[t1];
                    e1.hasSymbolBuckets && !e1.holdingForFade() ? e1.setHoldDuration(this.map._fadeDuration) : e1.hasSymbolBuckets && !e1.symbolFadeFinished() || this._removeTile(+t1);
                }
                this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const t1 in this._tiles)this._tiles[t1].holdingForFade() && this._removeTile(+t1);
            }
            _updateRetainedTiles(t1) {
                const e1 = {};
                if (0 === t1.length) return e1;
                const r = {}, n = t1.reduce((t1, e1)=>Math.min(t1, e1.overscaledZ), 1 / 0), i = t1[0].overscaledZ, s = Math.max(i - ny.maxOverzooming, this._source.minzoom), a = Math.max(i + ny.maxUnderzooming, this._source.minzoom), o = {};
                for (const r of t1){
                    const t1 = this._addTile(r);
                    e1[r.key] = r, t1.hasData() || n < this._source.maxzoom && (o[r.key] = r);
                }
                this._retainLoadedChildren(o, n, a, e1);
                for (const n of t1){
                    let t1 = this._tiles[n.key];
                    if (t1.hasData()) continue;
                    if (n.canonical.z >= this._source.maxzoom) {
                        const t1 = n.children(this._source.maxzoom)[0], r = this.getTile(t1);
                        if (r && r.hasData()) {
                            e1[t1.key] = t1;
                            continue;
                        }
                    } else {
                        const t1 = n.children(this._source.maxzoom);
                        if (e1[t1[0].key] && e1[t1[1].key] && e1[t1[2].key] && e1[t1[3].key]) continue;
                    }
                    let i = t1.wasRequested();
                    for(let a = n.overscaledZ - 1; a >= s; --a){
                        const s = n.scaledTo(a);
                        if (r[s.key]) break;
                        if (r[s.key] = !0, t1 = this.getTile(s), !t1 && i && (t1 = this._addTile(s)), t1 && (e1[s.key] = s, i = t1.wasRequested(), t1.hasData())) break;
                    }
                }
                return e1;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const t1 in this._tiles){
                    const e1 = [];
                    let r, n = this._tiles[t1].tileID;
                    for(; n.overscaledZ > 0;){
                        if (n.key in this._loadedParentTiles) {
                            r = this._loadedParentTiles[n.key];
                            break;
                        }
                        e1.push(n.key);
                        const t1 = n.scaledTo(n.overscaledZ - 1);
                        if (r = this._getLoadedTile(t1), r) break;
                        n = t1;
                    }
                    for (const t1 of e1)this._loadedParentTiles[t1] = r;
                }
            }
            _addTile(t1) {
                let e1 = this._tiles[t1.key];
                if (e1) return e1;
                e1 = this._cache.getAndRemove(t1), e1 && (this._setTileReloadTimer(t1.key, e1), e1.tileID = t1, this._state.initializeTileState(e1, this.map ? this.map.painter : null), this._cacheTimers[t1.key] && (clearTimeout(this._cacheTimers[t1.key]), delete this._cacheTimers[t1.key], this._setTileReloadTimer(t1.key, e1)));
                const r = Boolean(e1);
                if (!r) {
                    const r = this.map ? this.map.painter : null;
                    e1 = new Fd(t1, this._source.tileSize * t1.overscaleFactor(), this.transform.tileZoom, r, this._isRaster), this._loadTile(e1, this._tileLoaded.bind(this, e1, t1.key, e1.state));
                }
                return e1 ? (e1.uses++, this._tiles[t1.key] = e1, r || this._source.fire(new Zt("dataloading", {
                    tile: e1,
                    coord: e1.tileID,
                    dataType: "source"
                })), e1) : null;
            }
            _setTileReloadTimer(t1, e1) {
                t1 in this._timers && (clearTimeout(this._timers[t1]), delete this._timers[t1]);
                const r = e1.getExpiryTimeout();
                r && (this._timers[t1] = setTimeout(()=>{
                    this._reloadTile(t1, "expired"), delete this._timers[t1];
                }, r));
            }
            _removeTile(t1) {
                const e1 = this._tiles[t1];
                e1 && (e1.uses--, delete this._tiles[t1], this._timers[t1] && (clearTimeout(this._timers[t1]), delete this._timers[t1]), e1.uses > 0 || (e1.hasData() && "reloading" !== e1.state ? this._cache.add(e1.tileID, e1, e1.getExpiryTimeout()) : (e1.aborted = !0, this._abortTile(e1), this._unloadTile(e1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const t1 in this._tiles)this._removeTile(+t1);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t1, e1, r) {
                const n = [], i = this.transform;
                if (!i) return n;
                const s = "globe" === i.projection.name, a = iu(i.center.lng);
                for(const o in this._tiles){
                    const l = this._tiles[o];
                    if (r && l.clearQueryDebugViz(), l.holdingForFade()) continue;
                    let u;
                    if (s) {
                        const t1 = l.tileID.canonical;
                        if (0 === t1.z) {
                            const e1 = [
                                Math.abs(S(a, ...ay(t1, -1)) - a),
                                Math.abs(S(a, ...ay(t1, 1)) - a)
                            ];
                            u = [
                                0,
                                2 * e1.indexOf(Math.min(...e1)) - 1
                            ];
                        } else {
                            const e1 = [
                                Math.abs(S(a, ...ay(t1, -1)) - a),
                                Math.abs(S(a, ...ay(t1, 0)) - a),
                                Math.abs(S(a, ...ay(t1, 1)) - a)
                            ];
                            u = [
                                e1.indexOf(Math.min(...e1)) - 1
                            ];
                        }
                    } else u = [
                        0
                    ];
                    for (const r of u){
                        const s = t1.containsTile(l, i, e1, r);
                        s && n.push(s);
                    }
                }
                return n;
            }
            getVisibleCoordinates(t1) {
                const e1 = this.getRenderableIds(t1).map((t1)=>this._tiles[t1].tileID);
                for (const t1 of e1)t1.projMatrix = this.transform.calculateProjMatrix(t1.toUnwrapped());
                return e1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (sy(this._source.type)) for(const t1 in this._tiles){
                    const e1 = this._tiles[t1];
                    if (void 0 !== e1.fadeEndTime && e1.fadeEndTime >= Nt.now()) return !0;
                }
                return !1;
            }
            setFeatureState(t1, e1, r) {
                this._state.updateState(t1 = t1 || "_geojsonTileLayer", e1, r);
            }
            removeFeatureState(t1, e1, r) {
                this._state.removeFeatureState(t1 = t1 || "_geojsonTileLayer", e1, r);
            }
            getFeatureState(t1, e1) {
                return this._state.getState(t1 = t1 || "_geojsonTileLayer", e1);
            }
            setDependencies(t1, e1, r) {
                const n = this._tiles[t1];
                n && n.setDependencies(e1, r);
            }
            reloadTilesForDependencies(t1, e1) {
                for(const r in this._tiles)this._tiles[r].hasDependency(t1, e1) && this._reloadTile(+r, "reloading");
                this._cache.filter((r)=>!r.hasDependency(t1, e1));
            }
            _preloadTiles(t1, e1) {
                const r = new Map, n = Array.isArray(t1) ? t1 : [
                    t1
                ], i = this.map.painter.terrain, s = this.usedForTerrain && i ? i.getScaledDemTileSize() : this._source.tileSize;
                for (const t1 of n){
                    const e1 = t1.coveringTiles({
                        tileSize: s,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const t1 of e1)r.set(t1.key, t1);
                    this.usedForTerrain && t1.updateElevation(!1);
                }
                M(Array.from(r.values()), (t1, e1)=>{
                    const r = new Fd(t1, this._source.tileSize * t1.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster);
                    this._loadTile(r, (t1)=>{
                        "raster-dem" === this._source.type && r.dem && this._backfillDEM(r), e1(t1, r);
                    });
                }, e1);
            }
        }
        function iy(t1, e1) {
            const r = Math.abs(2 * t1.wrap) - +(t1.wrap < 0), n = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
            return t1.overscaledZ - e1.overscaledZ || n - r || e1.canonical.y - t1.canonical.y || e1.canonical.x - t1.canonical.x;
        }
        function sy(t1) {
            return "raster" === t1 || "image" === t1 || "video" === t1 || "custom" === t1;
        }
        function ay(t1, e1) {
            const r = 1 << t1.z;
            return [
                t1.x / r + e1,
                (t1.x + 1) / r + e1
            ];
        }
        ny.maxOverzooming = 10, ny.maxUnderzooming = 3;
        class oy {
            constructor(t1, e1, r){
                this._demTile = t1, this._dem = this._demTile.dem, this._scale = e1, this._offset = r;
            }
            static create(t1, e1, r) {
                const n = r || t1.findDEMTileFor(e1);
                if (!n || !n.dem) return;
                const i = n.dem, s = n.tileID, a = 1 << e1.canonical.z - s.canonical.z;
                return new oy(n, n.tileSize / ko / a, [
                    (e1.canonical.x / a - s.canonical.x) * i.dim,
                    (e1.canonical.y / a - s.canonical.y) * i.dim
                ]);
            }
            tileCoordToPixel(t1, e1) {
                const r = e1 * this._scale + this._offset[1], n = Math.floor(t1 * this._scale + this._offset[0]), i = Math.floor(r);
                return new d(n, i);
            }
            getElevationAt(t1, e1, r, n) {
                const i = t1 * this._scale + this._offset[0], s = e1 * this._scale + this._offset[1], a = Math.floor(i), o = Math.floor(s), l = this._dem;
                return n = !!n, r ? Mr(Mr(l.get(a, o, n), l.get(a, o + 1, n), s - o), Mr(l.get(a + 1, o, n), l.get(a + 1, o + 1, n), s - o), i - a) : l.get(a, o, n);
            }
            getElevationAtPixel(t1, e1, r) {
                return this._dem.get(t1, e1, !!r);
            }
            getMeterToDEM(t1) {
                return (1 << this._demTile.tileID.canonical.z) * au(1, t1) * this._dem.stride;
            }
        }
        class ly {
            constructor(t1, e1){
                this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new ji(ko, 16, 0), this.featureIndexArray = new ja, this.promoteId = e1;
            }
            insert(t1, e1, r, n, i, s = 0) {
                const a = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i, s);
                const o = this.grid;
                for(let t1 = 0; t1 < e1.length; t1++){
                    const r = e1[t1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t1 = 0; t1 < r.length; t1++){
                        const e1 = r[t1];
                        n[0] = Math.min(n[0], e1.x), n[1] = Math.min(n[1], e1.y), n[2] = Math.max(n[2], e1.x), n[3] = Math.max(n[3], e1.y);
                    }
                    n[0] < ko && n[1] < ko && n[2] >= 0 && n[3] >= 0 && o.insert(a, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new sh(new op(this.rawTileData)).layers, this.sourceLayerCoder = new kd(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const t1 in this.vtLayers)this.vtFeatures[t1] = [];
                }
                return this.vtLayers;
            }
            query(t1, e1, r, n) {
                this.loadVTLayers();
                const i = t1.params || {}, s = ai(i.filter), a = t1.tileResult, o = t1.transform, l = a.bufferedTilespaceBounds, u = this.grid.query(l.min.x, l.min.y, l.max.x, l.max.y, (t1, e1, r, n)=>Vu(a.bufferedTilespaceGeometry, t1, e1, r, n));
                u.sort(cy);
                let c = null;
                o.elevation && u.length > 0 && (c = oy.create(o.elevation, this.tileID));
                const h = {};
                let p;
                for(let o = 0; o < u.length; o++){
                    const l = u[o];
                    if (l === p) continue;
                    p = l;
                    const f = this.featureIndexArray.get(l);
                    let d = null;
                    this.loadMatchingFeature(h, f, s, i.layers, i.availableImages, e1, r, n, (e1, r, n, i = 0)=>(d || (d = bu(e1, this.tileID.canonical, t1.tileTransform)), r.queryIntersectsFeature(a, e1, n, d, this.z, t1.transform, t1.pixelPosMatrix, c, i)));
                }
                return h;
            }
            loadMatchingFeature(t1, e1, r, n, i, s, a, o, l) {
                const { featureIndex: u, bucketIndex: c, sourceLayerIndex: h, layoutVertexArrayOffset: p } = e1, f = this.bucketLayerIDs[c];
                if (n && !function(t1, e1) {
                    for(let r = 0; r < t1.length; r++)if (e1.indexOf(t1[r]) >= 0) return !0;
                    return !1;
                }(n, f)) return;
                const d = this.sourceLayerCoder.decode(h), y = this.vtLayers[d].feature(u);
                if (r.needGeometry) {
                    const t1 = wu(y, !0);
                    if (!r.filter(new Us(this.tileID.overscaledZ), t1, this.tileID.canonical)) return;
                } else if (!r.filter(new Us(this.tileID.overscaledZ), y)) return;
                const m = this.getId(y, d);
                for(let e1 = 0; e1 < f.length; e1++){
                    const r = f[e1];
                    if (n && n.indexOf(r) < 0) continue;
                    const c = s[r];
                    if (!c) continue;
                    let h = {};
                    void 0 !== m && o && (h = o.getState(c.sourceLayer || "_geojsonTileLayer", m));
                    const d = z({}, a[r]);
                    d.paint = uy(d.paint, c.paint, y, h, i), d.layout = uy(d.layout, c.layout, y, h, i);
                    const g = !l || l(y, c, h, p);
                    if (!g) continue;
                    const x = new Md(y, this.z, this.x, this.y, m);
                    x.layer = d;
                    let v = t1[r];
                    void 0 === v && (v = t1[r] = []), v.push({
                        featureIndex: u,
                        feature: x,
                        intersectionZ: g
                    });
                }
            }
            lookupSymbolFeatures(t1, e1, r, n, i, s, a, o) {
                const l = {};
                this.loadVTLayers();
                const u = ai(i);
                for (const i of t1)this.loadMatchingFeature(l, {
                    bucketIndex: r,
                    sourceLayerIndex: n,
                    featureIndex: i,
                    layoutVertexArrayOffset: 0
                }, u, s, a, o, e1);
                return l;
            }
            loadFeature(t1) {
                const { featureIndex: e1, sourceLayerIndex: r } = t1;
                this.loadVTLayers();
                const n = this.sourceLayerCoder.decode(r), i = this.vtFeatures[n];
                if (i[e1]) return i[e1];
                const s = this.vtLayers[n].feature(e1);
                return i[e1] = s, s;
            }
            hasLayer(t1) {
                for (const e1 of this.bucketLayerIDs)for (const r of e1)if (t1 === r) return !0;
                return !1;
            }
            getId(t1, e1) {
                let r = t1.id;
                if (this.promoteId) {
                    const n = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1];
                    null != n && (r = t1.properties[n]), "boolean" == typeof r && (r = Number(r));
                }
                return r;
            }
        }
        function uy(t1, e1, r, n, i) {
            return F(t1, (t1, s)=>{
                const a = e1 instanceof Ks ? e1.get(s) : null;
                return a && a.evaluate ? a.evaluate(r, n, i) : a;
            });
        }
        function cy(t1, e1) {
            return e1 - t1;
        }
        Oi(ly, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        class hy {
            constructor(t1, e1){
                this.width = t1, this.height = e1, this.nextRow = 0, this.image = new Ju({
                    width: t1,
                    height: e1
                }), this.positions = {}, this.uploaded = !1;
            }
            getDash(t1, e1) {
                const r = this.getKey(t1, e1);
                return this.positions[r];
            }
            trim() {
                const t1 = this.width, e1 = this.height = P(this.nextRow);
                this.image.resize({
                    width: t1,
                    height: e1
                });
            }
            getKey(t1, e1) {
                return t1.join(",") + e1;
            }
            getDashRanges(t1, e1, r) {
                const n = [];
                let i = t1.length % 2 == 1 ? -t1[t1.length - 1] * r : 0, s = t1[0] * r, a = !0;
                n.push({
                    left: i,
                    right: s,
                    isDash: a,
                    zeroLength: 0 === t1[0]
                });
                let o = t1[0];
                for(let e1 = 1; e1 < t1.length; e1++){
                    a = !a;
                    const l = t1[e1];
                    i = o * r, o += l, s = o * r, n.push({
                        left: i,
                        right: s,
                        isDash: a,
                        zeroLength: 0 === l
                    });
                }
                return n;
            }
            addRoundDash(t1, e1, r) {
                const n = e1 / 2;
                for(let e1 = -r; e1 <= r; e1++){
                    const i = this.width * (this.nextRow + r + e1);
                    let s = 0, a = t1[s];
                    for(let o = 0; o < this.width; o++){
                        o / a.right > 1 && (a = t1[++s]);
                        const l = Math.abs(o - a.left), u = Math.abs(o - a.right), c = Math.min(l, u);
                        let h;
                        const p = e1 / r * (n + 1);
                        if (a.isDash) {
                            const t1 = n - Math.abs(p);
                            h = Math.sqrt(c * c + t1 * t1);
                        } else h = n - Math.sqrt(c * c + p * p);
                        this.image.data[i + o] = Math.max(0, Math.min(255, h + 128));
                    }
                }
            }
            addRegularDash(t1, e1) {
                for(let e1 = t1.length - 1; e1 >= 0; --e1){
                    const r = t1[e1], n = t1[e1 + 1];
                    r.zeroLength ? t1.splice(e1, 1) : n && n.isDash === r.isDash && (n.left = r.left, t1.splice(e1, 1));
                }
                const r = t1[0], n = t1[t1.length - 1];
                r.isDash === n.isDash && (r.left = n.left - this.width, n.right = r.right + this.width);
                const i = this.width * this.nextRow;
                let s = 0, a = t1[s];
                for(let r = 0; r < this.width; r++){
                    r / a.right > 1 && (a = t1[++s]);
                    const n = Math.abs(r - a.left), o = Math.abs(r - a.right), l = Math.min(n, o);
                    this.image.data[i + r] = Math.max(0, Math.min(255, (a.isDash ? l : -l) + e1 + 128));
                }
            }
            addDash(t1, e1) {
                const r = this.getKey(t1, e1);
                if (this.positions[r]) return this.positions[r];
                const n = "round" === e1, i = n ? 7 : 0, s = 2 * i + 1;
                if (this.nextRow + s > this.height) return $("LineAtlas out of space"), null;
                0 === t1.length && t1.push(1);
                let a = 0;
                for(let e1 = 0; e1 < t1.length; e1++)t1[e1] < 0 && ($("Negative value is found in line dasharray, replacing values with 0"), t1[e1] = 0), a += t1[e1];
                if (0 !== a) {
                    const r = this.width / a, s = this.getDashRanges(t1, this.width, r);
                    n ? this.addRoundDash(s, r, i) : this.addRegularDash(s, "square" === e1 ? .5 * r : 0);
                }
                const o = this.nextRow + i;
                this.nextRow += s;
                const l = {
                    tl: [
                        o,
                        i
                    ],
                    br: [
                        a,
                        0
                    ]
                };
                return this.positions[r] = l, l;
            }
        }
        Oi(hy, "LineAtlas");
        class py {
            constructor(t1){
                const e1 = {}, r = [];
                for(const n in t1){
                    const i = t1[n], s = e1[n] = {};
                    for(const t1 in i.glyphs){
                        const e1 = i.glyphs[+t1];
                        if (!e1 || 0 === e1.bitmap.width || 0 === e1.bitmap.height) continue;
                        const n = e1.metrics.localGlyph ? 2 : 1, a = {
                            x: 0,
                            y: 0,
                            w: e1.bitmap.width + 2 * n,
                            h: e1.bitmap.height + 2 * n
                        };
                        r.push(a), s[t1] = a;
                    }
                }
                const { w: n, h: i } = Cp(r), s = new Ju({
                    width: n || 1,
                    height: i || 1
                });
                for(const r in t1){
                    const n = t1[r];
                    for(const t1 in n.glyphs){
                        const i = n.glyphs[+t1];
                        if (!i || 0 === i.bitmap.width || 0 === i.bitmap.height) continue;
                        const a = e1[r][t1], o = i.metrics.localGlyph ? 2 : 1;
                        Ju.copy(i.bitmap, s, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + o,
                            y: a.y + o
                        }, i.bitmap);
                    }
                }
                this.image = s, this.positions = e1;
            }
        }
        Oi(py, "GlyphAtlas");
        class fy {
            constructor(t1){
                this.tileID = new Mh(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.collectResourceTiming, this.returnDependencies = !!t1.returnDependencies, this.promoteId = t1.promoteId, this.enableTerrain = !!t1.enableTerrain, this.isSymbolTile = t1.isSymbolTile, this.tileTransform = Vf(t1.tileID.canonical, t1.projection), this.projection = t1.projection;
            }
            parse(t1, e1, r, n, i) {
                this.status = "parsing", this.data = t1, this.collisionBoxArray = new Ea;
                const s = new kd(Object.keys(t1.layers).sort()), a = new ly(this.tileID, this.promoteId);
                a.bucketLayerIDs = [];
                const o = {}, l = new hy(256, 256), u = {
                    featureIndex: a,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    lineAtlas: l,
                    availableImages: r
                }, c = e1.familiesBySource[this.source];
                for(const e1 in c){
                    const n = t1.layers[e1];
                    if (!n) continue;
                    let i = !1, l = !1;
                    for (const t1 of c[e1])"symbol" === t1[0].type ? i = !0 : l = !0;
                    if (!0 === this.isSymbolTile && !i) continue;
                    if (!1 === this.isSymbolTile && !l) continue;
                    1 === n.version && $(`Vector tile source "${this.source}" layer "${e1}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const h = s.encode(e1), p = [];
                    for(let t1 = 0; t1 < n.length; t1++){
                        const r = n.feature(t1), i = a.getId(r, e1);
                        p.push({
                            feature: r,
                            id: i,
                            index: t1,
                            sourceLayerIndex: h
                        });
                    }
                    for (const t1 of c[e1]){
                        const e1 = t1[0];
                        void 0 !== this.isSymbolTile && "symbol" === e1.type !== this.isSymbolTile || e1.minzoom && this.zoom < Math.floor(e1.minzoom) || e1.maxzoom && this.zoom >= e1.maxzoom || "none" !== e1.visibility && (dy(t1, this.zoom, r), (o[e1.id] = e1.createBucket({
                            index: a.bucketLayerIDs.length,
                            layers: t1,
                            zoom: this.zoom,
                            canonical: this.canonical,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: h,
                            sourceID: this.source,
                            enableTerrain: this.enableTerrain,
                            projection: this.projection.spec,
                            availableImages: r
                        })).populate(p, u, this.tileID.canonical, this.tileTransform), a.bucketLayerIDs.push(t1.map((t1)=>t1.id)));
                    }
                }
                let h, p, f, d;
                l.trim();
                const y = {
                    type: "maybePrepare",
                    isSymbolTile: this.isSymbolTile,
                    zoom: this.zoom
                }, m = F(u.glyphDependencies, (t1)=>Object.keys(t1).map(Number));
                Object.keys(m).length ? n.send("getGlyphs", {
                    uid: this.uid,
                    stacks: m
                }, (t1, e1)=>{
                    h || (h = t1, p = e1, v.call(this));
                }, void 0, !1, y) : p = {};
                const g = Object.keys(u.iconDependencies);
                g.length ? n.send("getImages", {
                    icons: g,
                    source: this.source,
                    tileID: this.tileID,
                    type: "icons"
                }, (t1, e1)=>{
                    h || (h = t1, f = e1, v.call(this));
                }, void 0, !1, y) : f = {};
                const x = Object.keys(u.patternDependencies);
                function v() {
                    if (h) return i(h);
                    if (p && f && d) {
                        const t1 = new py(p), e1 = new Dp(f, d);
                        for(const n in o){
                            const i = o[n];
                            i instanceof hd ? (dy(i.layers, this.zoom, r), kf(i, p, t1.positions, f, e1.iconPositions, this.showCollisionBoxes, r, this.tileID.canonical, this.tileZoom, this.projection)) : i.hasPattern && (i instanceof jh || i instanceof Uc || i instanceof fh) && (dy(i.layers, this.zoom, r), i.addFeatures(u, this.tileID.canonical, e1.patternPositions, r, this.tileTransform));
                        }
                        this.status = "done", i(null, {
                            buckets: T(o).filter((t1)=>!t1.isEmpty()),
                            featureIndex: a,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: t1.image,
                            lineAtlas: l,
                            imageAtlas: e1,
                            glyphMap: this.returnDependencies ? p : null,
                            iconMap: this.returnDependencies ? f : null,
                            glyphPositions: this.returnDependencies ? t1.positions : null
                        });
                    }
                }
                x.length ? n.send("getImages", {
                    icons: x,
                    source: this.source,
                    tileID: this.tileID,
                    type: "patterns"
                }, (t1, e1)=>{
                    h || (h = t1, d = e1, v.call(this));
                }, void 0, !1, y) : d = {}, v.call(this);
            }
        }
        function dy(t1, e1, r) {
            const n = new Us(e1);
            for (const e1 of t1)e1.recalculate(n, r);
        }
        class yy {
            constructor(t1){
                this.entries = {}, this.scheduler = t1;
            }
            request(t1, e1, r, n) {
                const i = this.entries[t1] = this.entries[t1] || {
                    callbacks: []
                };
                if (i.result) {
                    const [t1, r] = i.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        n(t1, r);
                    }, e1) : n(t1, r), ()=>{};
                }
                return i.callbacks.push(n), i.cancel || (i.cancel = r((r, n)=>{
                    i.result = [
                        r,
                        n
                    ];
                    for (const t1 of i.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        t1(r, n);
                    }, e1) : t1(r, n);
                    setTimeout(()=>delete this.entries[t1], 3e3);
                })), ()=>{
                    i.result || (i.callbacks = i.callbacks.filter((t1)=>t1 !== n), i.callbacks.length || (i.cancel(), delete this.entries[t1]));
                };
            }
        }
        function my(t1, e1, r) {
            const n = JSON.stringify(t1.request);
            return t1.data && (this.deduped.entries[n] = {
                result: [
                    null,
                    t1.data
                ]
            }), this.deduped.request(n, {
                type: "parseTile",
                isSymbolTile: t1.isSymbolTile,
                zoom: t1.tileZoom
            }, (e1)=>{
                const n = ut(t1.request, (t1, n, i, s)=>{
                    t1 ? e1(t1) : n && e1(null, {
                        vectorTile: r ? void 0 : new sh(new op(n)),
                        rawData: n,
                        cacheControl: i,
                        expires: s
                    });
                });
                return ()=>{
                    n.cancel(), e1();
                };
            }, e1);
        }
        t1.ARRAY_TYPE = To, t1.AUTH_ERR_MSG = yt, t1.Aabb = _l, t1.Actor = class {
            constructor(t1, r, n){
                this.target = t1, this.parent = r, this.mapId = n, this.callbacks = {}, this.cancelCallbacks = {}, V([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.globalScope = N() ? t1 : e1, this.scheduler = new Sd;
            }
            send(t1, e1, r, n, i = !1, s) {
                const a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (r.metadata = s, this.callbacks[a] = r);
                const o = Z(this.globalScope) ? void 0 : [];
                return this.target.postMessage({
                    id: a,
                    type: t1,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: Gi(e1, o)
                }, o), {
                    cancel: ()=>{
                        r && delete this.callbacks[a], this.target.postMessage({
                            id: a,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(t1) {
                const e1 = t1.data, r = e1.id;
                if (r && (!e1.targetMapId || this.mapId === e1.targetMapId)) {
                    if ("<cancel>" === e1.type) {
                        const t1 = this.cancelCallbacks[r];
                        delete this.cancelCallbacks[r], t1 && t1.cancel();
                    } else if (e1.mustQueue || N()) {
                        const t1 = this.callbacks[r];
                        this.cancelCallbacks[r] = this.scheduler.add(()=>this.processTask(r, e1), t1 && t1.metadata || {
                            type: "message"
                        });
                    } else this.processTask(r, e1);
                }
            }
            processTask(t1, e1) {
                if ("<response>" === e1.type) {
                    const r = this.callbacks[t1];
                    delete this.callbacks[t1], r && (e1.error ? r(Xi(e1.error)) : r(null, Xi(e1.data)));
                } else {
                    const r = Z(this.globalScope) ? void 0 : [], n = e1.hasCallback ? (e1, n)=>{
                        delete this.cancelCallbacks[t1], this.target.postMessage({
                            id: t1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: e1 ? Gi(e1) : null,
                            data: Gi(n, r)
                        }, r);
                    } : (t1)=>{}, i = Xi(e1.data);
                    if (this.parent[e1.type]) this.parent[e1.type](e1.sourceMapId, i, n);
                    else if (this.parent.getWorkerSource) {
                        const t1 = e1.type.split(".");
                        this.parent.getWorkerSource(e1.sourceMapId, t1[0], i.source)[t1[1]](i, n);
                    } else n(new Error(`Could not find function ${e1.type}`));
                }
            }
            remove() {
                this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }, t1.CanonicalTileID = kh, t1.Color = Me, t1.ColorMode = Qd, t1.CullFaceMode = ry, t1.DEMData = Kd, t1.DataConstantProperty = Ys, t1.DedupedRequest = yy, t1.DepthMode = Hd, t1.EXTENT = ko, t1.Elevation = class {
            isDataAvailableAtPoint(t1) {
                const e1 = this._source();
                if (this.isUsingMockSource() || !e1 || t1.y < 0 || t1.y > 1) return !1;
                const r = e1.getSource().maxzoom, n = 1 << r, i = Math.floor(t1.x), s = Math.floor((t1.x - i) * n), a = Math.floor(t1.y * n), o = this.findDEMTileFor(new Mh(r, i, r, s, a));
                return !(!o || !o.dem);
            }
            getAtPointOrZero(t1, e1 = 0) {
                return this.getAtPoint(t1, e1) || 0;
            }
            getAtPoint(t1, e1, r = !0) {
                if (this.isUsingMockSource()) return null;
                null == e1 && (e1 = null);
                const n = this._source();
                if (!n) return e1;
                if (t1.y < 0 || t1.y > 1) return e1;
                const i = n.getSource().maxzoom, s = 1 << i, a = Math.floor(t1.x), o = t1.x - a, l = new Mh(i, a, i, Math.floor(o * s), Math.floor(t1.y * s)), u = this.findDEMTileFor(l);
                if (!u || !u.dem) return e1;
                const c = u.dem, h = 1 << u.tileID.canonical.z, p = (o * h - u.tileID.canonical.x) * c.dim, f = (t1.y * h - u.tileID.canonical.y) * c.dim, d = Math.floor(p), y = Math.floor(f);
                return (r ? this.exaggeration() : 1) * Mr(Mr(c.get(d, y), c.get(d, y + 1), f - y), Mr(c.get(d + 1, y), c.get(d + 1, y + 1), f - y), p - d);
            }
            getAtTileOffset(t1, e1, r) {
                const n = 1 << t1.canonical.z;
                return this.getAtPointOrZero(new pu(t1.wrap + (t1.canonical.x + e1 / ko) / n, (t1.canonical.y + r / ko) / n));
            }
            getAtTileOffsetFunc(t1, e1, r, n) {
                return (i)=>{
                    const s = this.getAtTileOffset(t1, i.x, i.y), a = n.upVector(t1.canonical, i.x, i.y);
                    return Ho(a, a, s * n.upVectorScale(t1.canonical, e1, r).metersToTile), a;
                };
            }
            getForTilePoints(t1, e1, r, n) {
                if (this.isUsingMockSource()) return !1;
                const i = oy.create(this, t1, n);
                return !!i && (e1.forEach((t1)=>{
                    t1[2] = this.exaggeration() * i.getElevationAt(t1[0], t1[1], r);
                }), !0);
            }
            getMinMaxForTile(t1) {
                if (this.isUsingMockSource()) return null;
                const e1 = this.findDEMTileFor(t1);
                if (!e1 || !e1.dem) return null;
                const r = e1.dem.tree, n = e1.tileID, i = 1 << t1.canonical.z - n.canonical.z;
                let s = t1.canonical.x / i - n.canonical.x, a = t1.canonical.y / i - n.canonical.y, o = 0;
                for(let e1 = 0; e1 < t1.canonical.z - n.canonical.z && !r.leaves[o]; e1++){
                    s *= 2, a *= 2;
                    const t1 = 2 * Math.floor(a) + Math.floor(s);
                    o = r.childOffsets[o] + t1, s %= 1, a %= 1;
                }
                return {
                    min: this.exaggeration() * r.minimums[o],
                    max: this.exaggeration() * r.maximums[o]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(t1, e1, r) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(t1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(t1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
        }, t1.ErrorEvent = Kt, t1.EvaluationParameters = Us, t1.Event = Zt, t1.Evented = Yt, t1.FillExtrusionBucket = fh, t1.Frustum = wl, t1.FrustumCorners = bl, t1.GLOBE_RADIUS = Al, t1.GLOBE_SCALE_MATCH_LATITUDE = 45, t1.GLOBE_ZOOM_THRESHOLD_MAX = 6, t1.GLOBE_ZOOM_THRESHOLD_MIN = 5, t1.GlobeSharedBuffers = class {
            constructor(t1){
                this._createGrid(t1), this._createPoles(t1);
            }
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const t1 of this._poleSegments)t1.destroy();
                for (const t1 of this._gridSegments)t1.withSkirts.destroy(), t1.withoutSkirts.destroy();
                if (this._wireframeIndexBuffer) {
                    this._wireframeIndexBuffer.destroy();
                    for (const t1 of this._wireframeSegments)t1.destroy();
                }
            }
            _fillGridMeshWithLods(t1, e1) {
                const r = new sa, n = new wa, i = [], s = t1 + 1 + 2, a = e1[0] + 1, o = e1[0] + 1 + (1 + e1.length), l = (t1, e1, r)=>{
                    let n = t1 === s - 1 ? t1 - 2 : 0 === t1 ? t1 : t1 - 1;
                    return n += r ? 24575 : 0, [
                        n,
                        e1
                    ];
                };
                for(let t1 = 0; t1 < s; ++t1)r.emplaceBack(...l(t1, 0, !0));
                for(let t1 = 0; t1 < a; ++t1)for(let e1 = 0; e1 < s; ++e1)r.emplaceBack(...l(e1, t1, (0 === e1 || e1 === s - 1) && !0));
                for(let t1 = 0; t1 < e1.length; ++t1){
                    const n = e1[t1];
                    for(let t1 = 0; t1 < s; ++t1)r.emplaceBack(...l(t1, n, !0));
                }
                for(let t1 = 0; t1 < e1.length; ++t1){
                    const a = n.length, l = e1[t1] + 1 + 2, u = new wa;
                    for(let r = 0; r < l - 1; r++){
                        const i = r === l - 2, a = i ? s * (o - e1.length + t1 - r) : s;
                        for(let t1 = 0; t1 < s - 1; t1++){
                            const e1 = r * s + t1;
                            0 === r || i || 0 === t1 || t1 === s - 2 ? (u.emplaceBack(e1 + 1, e1, e1 + a), u.emplaceBack(e1 + a, e1 + a + 1, e1 + 1)) : (n.emplaceBack(e1 + 1, e1, e1 + a), n.emplaceBack(e1 + a, e1 + a + 1, e1 + 1));
                        }
                    }
                    const c = So.simpleSegment(0, a, r.length, n.length - a);
                    for(let t1 = 0; t1 < u.uint16.length; t1 += 3)n.emplaceBack(u.uint16[t1], u.uint16[t1 + 1], u.uint16[t1 + 2]);
                    const h = So.simpleSegment(0, a, r.length, n.length - a);
                    i.push({
                        withoutSkirts: c,
                        withSkirts: h
                    });
                }
                return {
                    vertices: r,
                    indices: n,
                    segments: i
                };
            }
            _createGrid(t1) {
                const e1 = this._fillGridMeshWithLods(Sl, kl);
                this._gridSegments = e1.segments, this._gridBuffer = t1.createVertexBuffer(e1.vertices, xl.members), this._gridIndexBuffer = t1.createIndexBuffer(e1.indices, !0);
            }
            _createPoles(t1) {
                const e1 = new wa;
                for(let t1 = 0; t1 <= Sl; t1++)e1.emplaceBack(0, t1 + 1, t1 + 2);
                this._poleIndexBuffer = t1.createIndexBuffer(e1, !0);
                const r = new ka, n = new ka;
                this._poleSegments = [];
                for(let t1 = 0, e1 = 0; t1 < 5; t1++){
                    const i = 360 / (1 << t1);
                    r.emplaceBack(0, -Al, 0, .5, 0), n.emplaceBack(0, -Al, 0, .5, 1);
                    for(let t1 = 0; t1 <= Sl; t1++){
                        const e1 = t1 / Sl, s = Mr(0, i, e1), [a, o, l] = Ul(Jl, Ql, s, Al);
                        r.emplaceBack(a, o, l, e1, 0), n.emplaceBack(a, o, l, e1, 1);
                    }
                    this._poleSegments.push(So.simpleSegment(e1, 0, 66, 64)), e1 += 66;
                }
                this._poleNorthVertexBuffer = t1.createVertexBuffer(r, ml, !1), this._poleSouthVertexBuffer = t1.createVertexBuffer(n, ml, !1);
            }
            getGridBuffers(t1, e1) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    e1 ? this._gridSegments[t1].withSkirts : this._gridSegments[t1].withoutSkirts
                ];
            }
            getPoleBuffers(t1) {
                return [
                    this._poleNorthVertexBuffer,
                    this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[t1]
                ];
            }
            getWirefameBuffers(t1, e1) {
                if (!this._wireframeSegments) {
                    const e1 = new Ma, r = Sl, n = r + 1 + 2, i = 1;
                    this._wireframeSegments = [];
                    for(let t1 = 0, s = 0; t1 < kl.length; t1++){
                        const a = kl[t1];
                        for(let t1 = i; t1 < a + i; t1++)for(let s = i; s < r + i; s++){
                            const r = t1 * n + s;
                            e1.emplaceBack(r, r + 1), e1.emplaceBack(r, r + n), e1.emplaceBack(r, r + n + 1);
                        }
                        const o = a * r * 3;
                        this._wireframeSegments.push(So.simpleSegment(0, s, (a + 1) * n, o)), s += o;
                    }
                    this._wireframeIndexBuffer = t1.createIndexBuffer(e1);
                }
                return [
                    this._gridBuffer,
                    this._wireframeIndexBuffer,
                    this._wireframeSegments[e1]
                ];
            }
        }, t1.GlyphManager = cf, t1.ImagePosition = Pp, t1.LivePerformanceUtils = Lt, t1.LngLat = ru, t1.LngLatBounds = Io, t1.LocalGlyphMode = uf, t1.MAX_MERCATOR_LATITUDE = cu, t1.MercatorCoordinate = pu, t1.ONE_EM = Wh, t1.OverscaledTileID = Mh, t1.PerformanceMarkers = Vt, t1.Properties = Js, t1.RGBAImage = Qu, t1.Ray = vl, t1.RequestManager = class {
            constructor(t1, e1, r){
                this._transformRequestFn = t1, this._customAccessToken = e1, this._silenceAuthErrors = !!r, this._createSkuToken();
            }
            _createSkuToken() {
                const t1 = function() {
                    let t1 = "";
                    for(let e1 = 0; e1 < 10; e1++)t1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            h,
                            t1
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = t1.token, this._skuTokenExpiresAt = t1.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(t1, e1) {
                return this._transformRequestFn && this._transformRequestFn(t1, e1) || {
                    url: t1
                };
            }
            normalizeStyleURL(t1, e1) {
                if (!mt(t1)) return t1;
                const r = _t(t1);
                return r.path = `/styles/v1${r.path}`, this._makeAPIURL(r, this._customAccessToken || e1);
            }
            normalizeGlyphsURL(t1, e1) {
                if (!mt(t1)) return t1;
                const r = _t(t1);
                return r.path = `/fonts/v1${r.path}`, this._makeAPIURL(r, this._customAccessToken || e1);
            }
            normalizeSourceURL(t1, e1, r, n) {
                if (!mt(t1)) return t1;
                const i = _t(t1);
                return i.path = `/v4/${i.authority}.json`, i.params.push("secure"), r && i.params.push(`language=${r}`), n && i.params.push(`worldview=${n}`), this._makeAPIURL(i, this._customAccessToken || e1);
            }
            normalizeSpriteURL(t1, e1, r, n) {
                const i = _t(t1);
                return mt(t1) ? (i.path = `/styles/v1${i.path}/sprite${e1}${r}`, this._makeAPIURL(i, this._customAccessToken || n)) : (i.path += `${e1}${r}`, At(i));
            }
            normalizeTileURL(t1, e1, r) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !mt(t1)) return t1;
                const n = _t(t1);
                n.path = n.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${e1 || r && "raster" !== n.authority && 512 === r ? "@2x" : ""}${s.supported ? ".webp" : "$1"}`), "raster" === n.authority ? n.path = `/${i.RASTER_URL_PREFIX}${n.path}` : (n.path = n.path.replace(/^.+\/v4\//, "/"), n.path = `/${i.TILE_URL_VERSION}${n.path}`);
                const a = this._customAccessToken || function(t1) {
                    for (const e1 of t1){
                        const t1 = e1.match(/^access_token=(.*)$/);
                        if (t1) return t1[1];
                    }
                    return null;
                }(n.params) || i.ACCESS_TOKEN;
                return i.REQUIRE_ACCESS_TOKEN && a && this._skuToken && n.params.push(`sku=${this._skuToken}`), this._makeAPIURL(n, a);
            }
            canonicalizeTileURL(t1, e1) {
                const r = _t(t1);
                if (!r.path.match(/^(\/v4\/|\/raster\/v1\/)/) || !r.path.match(/\.[\w]+$/)) return t1;
                let n = "mapbox://";
                r.path.match(/^\/raster\/v1\//) ? n += `raster/${r.path.replace(`/${i.RASTER_URL_PREFIX}/`, "")}` : n += `tiles/${r.path.replace(`/${i.TILE_URL_VERSION}/`, "")}`;
                let s = r.params;
                return e1 && (s = s.filter((t1)=>!t1.match(/^access_token=/))), s.length && (n += `?${s.join("&")}`), n;
            }
            canonicalizeTileset(t1, e1) {
                const r = !!e1 && mt(e1), n = [];
                for (const e1 of t1.tiles || [])gt(e1) ? n.push(this.canonicalizeTileURL(e1, r)) : n.push(e1);
                return n;
            }
            _makeAPIURL(t1, e1) {
                const r = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", n = _t(i.API_URL);
                if (t1.protocol = n.protocol, t1.authority = n.authority, "http" === t1.protocol) {
                    const e1 = t1.params.indexOf("secure");
                    e1 >= 0 && t1.params.splice(e1, 1);
                }
                if ("/" !== n.path && (t1.path = `${n.path}${t1.path}`), !i.REQUIRE_ACCESS_TOKEN) return At(t1);
                if (e1 = e1 || i.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!e1) throw new Error(`An API access token is required to use Mapbox GL. ${r}`);
                    if ("s" === e1[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${r}`);
                }
                return t1.params = t1.params.filter((t1)=>-1 === t1.indexOf("access_token")), t1.params.push(`access_token=${e1 || ""}`), At(t1);
            }
        }, t1.ResourceType = st, t1.SegmentVector = So, t1.SourceCache = ny, t1.StencilMode = Jd, t1.StructArrayLayout1ui2 = Ta, t1.StructArrayLayout2f1f2i16 = xa, t1.StructArrayLayout2i4 = sa, t1.StructArrayLayout2ui4 = Ma, t1.StructArrayLayout3f12 = ba, t1.StructArrayLayout3ui6 = wa, t1.StructArrayLayout4i8 = oa, t1.StructArrayLayout5f20 = ka, t1.Texture = _d, t1.Tile = Fd, t1.Transitionable = qs, t1.Uniform1f = to, t1.Uniform1i = class extends Qa {
            constructor(t1){
                super(t1), this.current = 0;
            }
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && this.current !== r && (this.current = r, this.gl.uniform1i(this.location, r));
            }
        }, t1.Uniform2f = class extends Qa {
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0
                ];
            }
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && (r[0] === this.current[0] && r[1] === this.current[1] || (this.current = r, this.gl.uniform2f(this.location, r[0], r[1])));
            }
        }, t1.Uniform3f = class extends Qa {
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] || (this.current = r, this.gl.uniform3f(this.location, r[0], r[1], r[2])));
            }
        }, t1.Uniform4f = eo, t1.UniformColor = ro, t1.UniformMatrix2f = class extends Qa {
            constructor(t1){
                super(t1), this.current = so;
            }
            set(t1, e1, r) {
                if (this.fetchUniformLocation(t1, e1)) {
                    for(let t1 = 0; t1 < 4; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix2fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }, t1.UniformMatrix3f = class extends Qa {
            constructor(t1){
                super(t1), this.current = io;
            }
            set(t1, e1, r) {
                if (this.fetchUniformLocation(t1, e1)) {
                    for(let t1 = 0; t1 < 9; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix3fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }, t1.UniformMatrix4f = class extends Qa {
            constructor(t1){
                super(t1), this.current = no;
            }
            set(t1, e1, r) {
                if (this.fetchUniformLocation(t1, e1)) {
                    if (r[12] !== this.current[12] || r[0] !== this.current[0]) return this.current = r, void this.gl.uniformMatrix4fv(this.location, !1, r);
                    for(let t1 = 1; t1 < 16; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix4fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }, t1.UnwrappedTileID = Ih, t1.ValidationError = Wn, t1.VectorTileFeature = ah, t1.VectorTileWorkerSource = class extends Yt {
            constructor(t1, e1, r, n, i){
                super(), this.actor = t1, this.layerIndex = e1, this.availableImages = r, this.loadVectorData = i || my, this.loading = {}, this.loaded = {}, this.deduped = new yy(t1.scheduler), this.isSpriteLoaded = n, this.scheduler = t1.scheduler;
            }
            loadTile(t1, e1) {
                const r = t1.uid, n = t1 && t1.request, i = n && n.collectResourceTiming, s = this.loading[r] = new fy(t1);
                s.abort = this.loadVectorData(t1, (a, o)=>{
                    const l = !this.loading[r];
                    if (delete this.loading[r], l || a || !o) return s.status = "done", l || (this.loaded[r] = s), e1(a);
                    const u = o.rawData, c = {};
                    o.expires && (c.expires = o.expires), o.cacheControl && (c.cacheControl = o.cacheControl), s.vectorTile = o.vectorTile || new sh(new op(u));
                    const h = ()=>{
                        s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.actor, (t1, r)=>{
                            if (t1 || !r) return e1(t1);
                            const s = {};
                            if (i) {
                                const t1 = jt(n);
                                t1.length > 0 && (s.resourceTiming = JSON.parse(JSON.stringify(t1)));
                            }
                            e1(null, z({
                                rawTileData: u.slice(0)
                            }, r, c, s));
                        });
                    };
                    this.isSpriteLoaded ? h() : this.once("isSpriteLoaded", ()=>{
                        this.scheduler ? this.scheduler.add(h, {
                            type: "parseTile",
                            isSymbolTile: t1.isSymbolTile,
                            zoom: t1.tileZoom
                        }) : h();
                    }), this.loaded = this.loaded || {}, this.loaded[r] = s;
                });
            }
            reloadTile(t1, e1) {
                const r = this.loaded, n = t1.uid, i = this;
                if (r && r[n]) {
                    const s = r[n];
                    s.showCollisionBoxes = t1.showCollisionBoxes, s.enableTerrain = !!t1.enableTerrain, s.projection = t1.projection, s.tileTransform = Vf(t1.tileID.canonical, t1.projection);
                    const a = (t1, r)=>{
                        const n = s.reloadCallback;
                        n && (delete s.reloadCallback, s.parse(s.vectorTile, i.layerIndex, this.availableImages, i.actor, n)), e1(t1, r);
                    };
                    "parsing" === s.status ? s.reloadCallback = a : "done" === s.status && (s.vectorTile ? s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.actor, a) : a());
                }
            }
            abortTile(t1, e1) {
                const r = t1.uid, n = this.loading[r];
                n && (n.abort && n.abort(), delete this.loading[r]), e1();
            }
            removeTile(t1, e1) {
                const r = this.loaded, n = t1.uid;
                r && r[n] && delete r[n], e1();
            }
        }, t1.WritingMode = Vp, t1.ZoomDependentExpression = Zn, t1.add = Go, t1.addDynamicAttributes = od, t1.adjoint = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = e1[3], a = e1[4], o = e1[5], l = e1[6], u = e1[7], c = e1[8];
            return t1[0] = a * c - o * u, t1[1] = i * u - n * c, t1[2] = n * o - i * a, t1[3] = o * l - s * c, t1[4] = r * c - i * l, t1[5] = i * s - r * o, t1[6] = s * u - a * l, t1[7] = n * l - r * u, t1[8] = r * a - n * s, t1;
        }, t1.asyncAll = M, t1.bezier = _, t1.bindAll = V, t1.boundsAttributes = Vd, t1.bufferConvexPolygon = function(t1, e1) {
            const r = [];
            for(let n = 0; n < t1.length; n++){
                const i = I(n - 1, -1, t1.length - 1), s = I(n + 1, -1, t1.length - 1), a = t1[n], o = t1[s], l = t1[i].sub(a).unit(), u = o.sub(a).unit(), c = u.angleWithSep(l.x, l.y), h = l.add(u).unit().mult(-1 * e1 / Math.sin(c / 2));
                r.push(a.add(h));
            }
            return r;
        }, t1.cacheEntryPossiblyAdded = function(t1) {
            it++, it > tt && (t1.getActor().send("enforceCacheSizeLimit", Q), it = 0);
        }, t1.calculateGlobeLabelMatrix = function(t1, e1) {
            const { x: r, y: n } = t1.point, i = Zl(r, n, t1.worldSize / t1._pixelsPerMercatorPixel, 0, 0);
            return Po(i, i, Xl(Pl(e1)));
        }, t1.calculateGlobeMatrix = function(t1) {
            const { x: e1, y: r } = t1.point, { lng: n, lat: i } = t1._center;
            return Zl(e1, r, t1.worldSize, n, i);
        }, t1.calculateGlobeMercatorMatrix = function(t1) {
            const e1 = t1.pixelsPerMeter, r = e1 / au(1, t1.center.lat), n = Eo(new Float64Array(16));
            return Do(n, n, [
                t1.point.x,
                t1.point.y,
                0
            ]), Vo(n, n, [
                r,
                r,
                e1
            ]), Float32Array.from(n);
        }, t1.circumferenceAtLatitude = nu, t1.clamp = S, t1.clearTileCache = function(t1) {
            if (!et()) return;
            const r = e1.caches.delete(H);
            t1 && r.catch(t1).then(()=>t1());
        }, t1.clipLine = sf, t1.clone = function(t1) {
            var e1 = new To(16);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }, t1.clone$1 = j, t1.collisionCircleLayout = Hh, t1.config = i, t1.conjugate = function(t1, e1) {
            return t1[0] = -e1[0], t1[1] = -e1[1], t1[2] = -e1[2], t1[3] = e1[3], t1;
        }, t1.create = function() {
            var t1 = new To(16);
            return To != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
        }, t1.create$1 = zo, t1.createExpression = Gn, t1.createLayout = na, t1.createStyleLayer = function(t1) {
            return "custom" === t1.type ? new xd(t1) : new wd[t1.type](t1);
        }, t1.cross = tl, t1.degToRad = x, t1.distance = function(t1, e1) {
            return Math.hypot(e1[0] - t1[0], e1[1] - t1[1], e1[2] - t1[2]);
        }, t1.div = function(t1, e1, r) {
            return t1[0] = e1[0] / r[0], t1[1] = e1[1] / r[1], t1[2] = e1[2] / r[2], t1;
        }, t1.dot = Qo, t1.earthRadius = tu, t1.ease = A, t1.easeCubicInOut = w, t1.ecefToLatLng = function([t1, e1, r]) {
            const n = Math.hypot(t1, e1, r), i = Math.atan2(t1, r), s = .5 * Math.PI - Math.acos(-e1 / n);
            return new ru(v(i), v(s));
        }, t1.emitValidationErrors = Ri, t1.endsWith = L, t1.enforceCacheSizeLimit = function(t1) {
            rt(), W && W.then((e1)=>{
                e1.keys().then((r)=>{
                    for(let n = 0; n < r.length - t1; n++)e1.delete(r[n]);
                });
            });
        }, t1.evaluateSizeForFeature = tp, t1.evaluateSizeForZoom = ep, t1.evaluateVariableOffset = Sf, t1.evented = Ls, t1.exactEquals = function(t1, e1) {
            return t1[0] === e1[0] && t1[1] === e1[1] && t1[2] === e1[2] && t1[3] === e1[3];
        }, t1.exactEquals$1 = function(t1, e1) {
            return t1[0] === e1[0] && t1[1] === e1[1] && t1[2] === e1[2];
        }, t1.exported = Nt, t1.exported$1 = s, t1.extend = z, t1.extend$1 = Wt, t1.fillExtrusionHeightLift = bh, t1.filterObject = R, t1.fromMat4 = function(t1, e1) {
            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[4], t1[4] = e1[5], t1[5] = e1[6], t1[6] = e1[8], t1[7] = e1[9], t1[8] = e1[10], t1;
        }, t1.fromQuat = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = e1[3], a = r + r, o = n + n, l = i + i, u = r * a, c = n * a, h = n * o, p = i * a, f = i * o, d = i * l, y = s * a, m = s * o, g = s * l;
            return t1[0] = 1 - h - d, t1[1] = c + g, t1[2] = p - m, t1[3] = 0, t1[4] = c - g, t1[5] = 1 - u - d, t1[6] = f + y, t1[7] = 0, t1[8] = p + m, t1[9] = f - y, t1[10] = 1 - u - h, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }, t1.fromRotation = function(t1, e1) {
            var r = Math.sin(e1), n = Math.cos(e1);
            return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
        }, t1.fromScaling = Ro, t1.furthestTileCorner = function(t1) {
            const e1 = Math.round((t1 + 45 + 360) % 360 / 90) % 4;
            return b[e1];
        }, t1.getAABBPointSquareDist = function(t1, e1, r) {
            let n = 0;
            for(let i = 0; i < 2; ++i){
                const s = r ? r[i] : 0;
                t1[i] > s && (n += (t1[i] - s) * (t1[i] - s)), e1[i] < s && (n += (s - e1[i]) * (s - e1[i]));
            }
            return n;
        }, t1.getAnchorAlignment = Xp, t1.getAnchorJustification = If, t1.getBounds = function(t1) {
            let e1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of t1)e1 = Math.min(e1, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return {
                min: new d(e1, r),
                max: new d(n, i)
            };
        }, t1.getColumn = Y, t1.getGridMatrix = function(t1, e1, r, n) {
            const i = e1.getNorth(), s = e1.getSouth(), a = e1.getWest(), o = e1.getEast(), l = 1 << t1.z, u = o - a, c = i - s, h = u / Sl, p = -c / kl[r], f = [
                0,
                h,
                0,
                p,
                0,
                0,
                i,
                a,
                0
            ];
            if (t1.z > 0) {
                const t1 = 180 / n;
                Bo(f, f, [
                    t1 / u + 1,
                    0,
                    0,
                    0,
                    t1 / c + 1,
                    0,
                    -0.5 * t1 / h,
                    .5 * t1 / p,
                    1
                ]);
            }
            return f[2] = l, f[5] = t1.x, f[8] = t1.y, f;
        }, t1.getImage = dt, t1.getJSON = function(t1, e1) {
            return lt(z(t1, {
                type: "json"
            }), e1);
        }, t1.getLatitudinalLod = function(t1) {
            const e1 = cu - 5;
            t1 = S(t1, -e1, e1) / e1 * 90;
            const r = Math.pow(Math.abs(Math.sin(x(t1))), 3);
            return Math.round(r * (kl.length - 1));
        }, t1.getMapSessionAPI = Pt, t1.getPerformanceMeasurement = jt, t1.getProjection = rd, t1.getRTLTextPluginStatus = Fs, t1.getReferrer = ot, t1.getTilePoint = function(t1, { x: e1, y: r }, n = 0) {
            return new d(((e1 - n) * t1.scale - t1.x) * ko, (r * t1.scale - t1.y) * ko);
        }, t1.getTileVec3 = function(t1, e1, r = 0) {
            return No(((e1.x - r) * t1.scale - t1.x) * ko, (e1.y * t1.scale - t1.y) * ko, uu(e1.z, e1.y));
        }, t1.getVideo = function(t1, r) {
            const n = e1.document.createElement("video");
            n.muted = !0, n.onloadstart = function() {
                r(null, n);
            };
            for(let r = 0; r < t1.length; r++){
                const i = e1.document.createElement("source");
                ct(t1[r]) || (n.crossOrigin = "Anonymous"), i.src = t1[r], n.appendChild(i);
            }
            return {
                cancel: ()=>{}
            };
        }, t1.globeCenterToScreenPoint = function(t1) {
            const e1 = [
                0,
                0,
                0
            ], r = Eo(new Float64Array(16));
            return Po(r, t1.pixelMatrix, t1.globeMatrix), el(e1, e1, r), new d(e1[0], e1[1]);
        }, t1.globeDenormalizeECEF = Xl, t1.globeECEFOrigin = function(t1, e1) {
            const r = [
                0,
                0,
                0
            ];
            return el(r, r, Gl(Pl(e1.canonical))), el(r, r, t1), r;
        }, t1.globeMetersToEcef = zl, t1.globeNormalizeECEF = Gl, t1.globePixelsToTileUnits = function(t1, e1) {
            return ko / (512 * Math.pow(2, t1)) * ql(Pl(e1));
        }, t1.globePoleMatrixForTile = function(t1, e1, r) {
            const n = Eo(new Float64Array(16)), i = (e1 / (1 << t1) - .5) * Math.PI * 2;
            return Fo(n, r.globeMatrix, i), Float32Array.from(n);
        }, t1.globeTileBounds = Pl, t1.globeTiltAtLngLat = Yl, t1.globeToMercatorTransition = Kl, t1.globeUseCustomAntiAliasing = function(t1, e1, r) {
            const n = Kl(r.zoom), i = t1.style.map._antialias, s = !!e1.extStandardDerivatives, a = e1.extStandardDerivativesForceOff || t1.terrain && t1.terrain.exaggeration() > 0;
            return 0 === n && !i && !a && s;
        }, t1.identity = Eo, t1.identity$1 = hl, t1.invert = Co, t1.isFullscreen = function() {
            return !!e1.document.fullscreenElement || !!e1.document.webkitFullscreenElement;
        }, t1.isLngLatBehindGlobe = Hl, t1.isMapAuthenticated = function(t1) {
            return Dt.has(t1);
        }, t1.isMapboxURL = mt, t1.isSafariWithAntialiasingBug = function(t1) {
            const e1 = t1.navigator ? t1.navigator.userAgent : null;
            return !!Z(t1) && e1 && (e1.match("Version/15.4") || e1.match("Version/15.5") || e1.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
        }, t1.latFromMercatorY = lu, t1.latLngToECEF = $l, t1.len = al, t1.length = qo, t1.length$1 = function(t1) {
            return Math.hypot(t1[0], t1[1], t1[2], t1[3]);
        }, t1.lngFromMercatorX = ou, t1.loadVectorTile = my, t1.makeRequest = lt, t1.mapValue = function(t1, e1, r, n, i) {
            return S((t1 - e1) / (r - e1) * (i - n) + n, n, i);
        }, t1.mercatorScale = hu, t1.mercatorXfromLng = iu, t1.mercatorYfromLat = su, t1.mercatorZfromAltitude = au, t1.mul = Uo, t1.mul$1 = sl, t1.multiply = Po, t1.multiply$1 = Bo, t1.multiply$2 = Zo, t1.nextPowerOfTwo = P, t1.normalize = Jo, t1.normalize$1 = dl, t1.normalize$2 = ll, t1.number = Mr, t1.ortho = function(t1, e1, r, n, i, s, a) {
            var o = 1 / (e1 - r), l = 1 / (n - i), u = 1 / (s - a);
            return t1[0] = -2 * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * u, t1[11] = 0, t1[12] = (e1 + r) * o, t1[13] = (i + n) * l, t1[14] = (a + s) * u, t1[15] = 1, t1;
        }, t1.pbf = op, t1.perspective = function(t1, e1, r, n, i) {
            var s, a = 1 / Math.tan(e1 / 2);
            return t1[0] = a / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = a, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = (i + n) * (s = 1 / (n - i)), t1[14] = 2 * i * n * s) : (t1[10] = -1, t1[14] = -2 * n), t1;
        }, t1.pick = function(t1, e1) {
            const r = {};
            for(let n = 0; n < e1.length; n++){
                const i = e1[n];
                i in t1 && (r[i] = t1[i]);
            }
            return r;
        }, t1.plugin = js, t1.pointGeometry = d, t1.polesInViewport = function(t1) {
            const e1 = Eo(new Float64Array(16));
            Po(e1, t1.pixelMatrix, t1.globeMatrix);
            const r = [
                0,
                Il,
                0
            ], n = [
                0,
                Ml,
                0
            ];
            return el(r, r, e1), el(n, n, e1), [
                r[0] > 0 && r[0] <= t1.width && r[1] > 0 && r[1] <= t1.height && !Hl(t1, new ru(t1.center.lat, 90)),
                n[0] > 0 && n[0] <= t1.width && n[1] > 0 && n[1] <= t1.height && !Hl(t1, new ru(t1.center.lat, -90))
            ];
        }, t1.polygonContainsPoint = Du, t1.polygonIntersectsBox = Vu, t1.polygonIntersectsPolygon = ku, t1.polygonizeBounds = function(t1, e1, r = 0, n = !0) {
            const i = new d(r, r), s = t1.sub(i), a = e1.add(i), o = [
                s,
                new d(a.x, s.y),
                a,
                new d(s.x, a.y)
            ];
            return n && o.push(s.clone()), o;
        }, t1.posAttributes = xl, t1.postMapLoadEvent = zt, t1.postPerformanceEvent = Et, t1.postTurnstileEvent = Mt, t1.potpack = Cp, t1.prevPowerOfTwo = function(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t1) / Math.LN2));
        }, t1.radToDeg = v, t1.refProperties = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.registerForPluginStateChange = function(t1) {
            return t1({
                pluginStatus: Cs,
                pluginURL: Ps
            }), Ls.on("pluginStateChange", t1), t1;
        }, t1.removeAuthState = function(t1) {
            Dt.delete(t1);
        }, t1.renderColorRamp = ec, t1.resample = du, t1.rotateX = Lo, t1.rotateX$1 = pl, t1.rotateY = Fo, t1.rotateY$1 = fl, t1.rotateZ = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e1[0], a = e1[1], o = e1[2], l = e1[3], u = e1[4], c = e1[5], h = e1[6], p = e1[7];
            return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = s * i + u * n, t1[1] = a * i + c * n, t1[2] = o * i + h * n, t1[3] = l * i + p * n, t1[4] = u * i - s * n, t1[5] = c * i - a * n, t1[6] = h * i - o * n, t1[7] = p * i - l * n, t1;
        }, t1.rotateZ$1 = function(t1, e1, r) {
            r *= .5;
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l + i * o, t1[1] = i * l - n * o, t1[2] = s * l + a * o, t1[3] = a * l - s * o, t1;
        }, t1.scale = Vo, t1.scale$1 = ol, t1.scale$2 = Ho, t1.scaleAndAdd = Wo, t1.set = function(t1, e1, r, n) {
            return t1[0] = e1, t1[1] = r, t1[2] = n, t1;
        }, t1.setCacheLimits = function(t1, e1) {
            Q = t1, tt = e1;
        }, t1.setColumn = function(t1, e1, r) {
            t1[4 * e1 + 0] = r[0], t1[4 * e1 + 1] = r[1], t1[4 * e1 + 2] = r[2], t1[4 * e1 + 3] = r[3];
        }, t1.setRTLTextPlugin = function(t1, e1, r = !1) {
            if (Cs === Ts || Cs === zs || Cs === Bs) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            Ps = Nt.resolveURL(t1), Cs = Ts, Es = e1, Vs(), r || Rs();
        }, t1.smoothstep = k, t1.spec = Ht, t1.squaredLength = function(t1) {
            var e1 = t1[0], r = t1[1], n = t1[2];
            return e1 * e1 + r * r + n * n;
        }, t1.storeAuthState = function(t1, e1) {
            e1 ? Dt.add(t1) : Dt.delete(t1);
        }, t1.sub = il, t1.subtract = Xo, t1.symbolSize = rp, t1.tileAABB = function(t1, e1, r, n, i, s, a, o, l) {
            if ("globe" === l.name) return Fl(t1, e1, new kh(r, n, i));
            const u = Vf({
                z: r,
                x: n,
                y: i
            }, l);
            return new _l([
                (s + u.x / u.scale) * e1,
                e1 * (u.y / u.scale),
                a
            ], [
                (s + u.x2 / u.scale) * e1,
                e1 * (u.y2 / u.scale),
                o
            ]);
        }, t1.tileCornersToBounds = Rl, t1.tileTransform = Vf, t1.transformMat3 = function(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2];
            return t1[0] = n * r[0] + i * r[3] + s * r[6], t1[1] = n * r[1] + i * r[4] + s * r[7], t1[2] = n * r[2] + i * r[5] + s * r[8], t1;
        }, t1.transformMat4 = el, t1.transformMat4$1 = ul, t1.transformQuat = rl, t1.transitionTileAABBinECEF = Vl, t1.translate = Do, t1.transpose = function(t1, e1) {
            if (t1 === e1) {
                var r = e1[1], n = e1[2], i = e1[5];
                t1[1] = e1[3], t1[2] = e1[6], t1[3] = r, t1[5] = e1[7], t1[6] = n, t1[7] = i;
            } else t1[0] = e1[0], t1[1] = e1[3], t1[2] = e1[6], t1[3] = e1[1], t1[4] = e1[4], t1[5] = e1[7], t1[6] = e1[2], t1[7] = e1[5], t1[8] = e1[8];
            return t1;
        }, t1.triggerPluginCompletionEvent = Ds, t1.uniqueId = E, t1.updateGlobeVertexNormal = function(t1, e1, r, n, i) {
            const s = 5 * e1 + 2;
            t1.float32[s + 0] = r, t1.float32[s + 1] = n, t1.float32[s + 2] = i;
        }, t1.validateCustomStyleLayer = function(t1) {
            const e1 = [], r = t1.id;
            return void 0 === r && e1.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t1.render && e1.push({
                message: `layers.${r}: missing required method "render"`
            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e1.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e1;
        }, t1.validateFilter = (t1)=>Fi(xi(t1)), t1.validateFog = (t1)=>Fi(Bi(t1)), t1.validateLayer = (t1)=>Fi(Ai(t1)), t1.validateLight = (t1)=>Fi(Ti(t1)), t1.validateSource = (t1)=>Fi(Ii(t1)), t1.validateStyle = Di, t1.validateTerrain = (t1)=>Fi(zi(t1)), t1.values = T, t1.vectorTile = Zc, t1.version = r, t1.warnOnce = $, t1.window = e1, t1.wrap = I;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        function t1(e1) {
            if ("number" == typeof e1 || "boolean" == typeof e1 || "string" == typeof e1 || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                let r = "[";
                for (const o of e1)r += `${t1(o)},`;
                return `${r}]`;
            }
            let r = "{";
            for (const o of Object.keys(e1).sort())r += `${o}:${t1(e1[o])},`;
            return `${r}}`;
        }
        function r(r) {
            let o = "";
            for (const n of e1.refProperties)o += `/${t1(r[n])}`;
            return o;
        }
        class o {
            constructor(e1){
                this.keyCache = {}, e1 && this.replace(e1);
            }
            replace(e1) {
                this._layerConfigs = {}, this._layers = {}, this.update(e1, []);
            }
            update(t1, o) {
                for (const r of t1)this._layerConfigs[r.id] = r, (this._layers[r.id] = e1.createStyleLayer(r)).compileFilter(), this.keyCache[r.id] && delete this.keyCache[r.id];
                for (const e1 of o)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = {};
                const n = function(e1, t1) {
                    const o = {};
                    for(let n = 0; n < e1.length; n++){
                        const i = t1 && t1[e1[n].id] || r(e1[n]);
                        t1 && (t1[e1[n].id] = i);
                        let s = o[i];
                        s || (s = o[i] = []), s.push(e1[n]);
                    }
                    const n = [];
                    for(const e1 in o)n.push(o[e1]);
                    return n;
                }(e1.values(this._layerConfigs), this.keyCache);
                for (const e1 of n){
                    const t1 = e1.map((e1)=>this._layers[e1.id]), r = t1[0];
                    if ("none" === r.visibility) continue;
                    const o = r.source || "";
                    let n = this.familiesBySource[o];
                    n || (n = this.familiesBySource[o] = {});
                    const i = r.sourceLayer || "_geojsonTileLayer";
                    let s = n[i];
                    s || (s = n[i] = []), s.push(t1);
                }
            }
        }
        class n {
            loadTile(t1, r) {
                const { uid: o, encoding: n, rawImageData: i, padding: s, buildQuadTree: a } = t1, l = e1.window.ImageBitmap && i instanceof e1.window.ImageBitmap ? this.getImageData(i, s) : i;
                r(null, new e1.DEMData(o, l, n, s < 1, a));
            }
            getImageData(e1, t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e1.width, e1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e1.width, this.offscreenCanvas.height = e1.height, this.offscreenCanvasContext.drawImage(e1, 0, 0, e1.width, e1.height);
                const r = this.offscreenCanvasContext.getImageData(-t1, -t1, e1.width + 2 * t1, e1.height + 2 * t1);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), r;
            }
        }
        var i = function e1(t1, r) {
            var o, n = t1 && t1.type;
            if ("FeatureCollection" === n) for(o = 0; o < t1.features.length; o++)e1(t1.features[o], r);
            else if ("GeometryCollection" === n) for(o = 0; o < t1.geometries.length; o++)e1(t1.geometries[o], r);
            else if ("Feature" === n) e1(t1.geometry, r);
            else if ("Polygon" === n) s(t1.coordinates, r);
            else if ("MultiPolygon" === n) for(o = 0; o < t1.coordinates.length; o++)s(t1.coordinates[o], r);
            return t1;
        };
        function s(e1, t1) {
            if (0 !== e1.length) {
                a(e1[0], t1);
                for(var r = 1; r < e1.length; r++)a(e1[r], !t1);
            }
        }
        function a(e1, t1) {
            for(var r = 0, o = 0, n = 0, i = e1.length, s = i - 1; n < i; s = n++){
                var a = (e1[n][0] - e1[s][0]) * (e1[s][1] + e1[n][1]), l = r + a;
                o += Math.abs(r) >= Math.abs(a) ? r - l + a : a - l + r, r = l;
            }
            r + o >= 0 != !!t1 && e1.reverse();
        }
        const l = e1.VectorTileFeature.prototype.toGeoJSON;
        class u {
            constructor(t1){
                this._feature = t1, this.extent = e1.EXTENT, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
            }
            loadGeometry() {
                if (1 === this._feature.type) {
                    const t1 = [];
                    for (const r of this._feature.geometry)t1.push([
                        new e1.pointGeometry(r[0], r[1])
                    ]);
                    return t1;
                }
                {
                    const t1 = [];
                    for (const r of this._feature.geometry){
                        const o = [];
                        for (const t1 of r)o.push(new e1.pointGeometry(t1[0], t1[1]));
                        t1.push(o);
                    }
                    return t1;
                }
            }
            toGeoJSON(e1, t1, r) {
                return l.call(this, e1, t1, r);
            }
        }
        class h {
            constructor(t1){
                this.layers = {
                    _geojsonTileLayer: this
                }, this.name = "_geojsonTileLayer", this.extent = e1.EXTENT, this.length = t1.length, this._features = t1;
            }
            feature(e1) {
                return new u(this._features[e1]);
            }
        }
        var c = {}, f = {
            get exports () {
                return c;
            },
            set exports (e){
                c = e;
            }
        }, p = e1.pointGeometry, g = e1.vectorTile.VectorTileFeature, d = m;
        function m(e1, t1) {
            this.options = t1 || {}, this.features = e1, this.length = e1.length;
        }
        function y(e1, t1) {
            this.id = "number" == typeof e1.id ? e1.id : void 0, this.type = e1.type, this.rawGeometry = 1 === e1.type ? [
                e1.geometry
            ] : e1.geometry, this.properties = e1.tags, this.extent = t1 || 4096;
        }
        m.prototype.feature = function(e1) {
            return new y(this.features[e1], this.options.extent);
        }, y.prototype.loadGeometry = function() {
            var e1 = this.rawGeometry;
            this.geometry = [];
            for(var t1 = 0; t1 < e1.length; t1++){
                for(var r = e1[t1], o = [], n = 0; n < r.length; n++)o.push(new p(r[n][0], r[n][1]));
                this.geometry.push(o);
            }
            return this.geometry;
        }, y.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e1 = this.geometry, t1 = 1 / 0, r = -1 / 0, o = 1 / 0, n = -1 / 0, i = 0; i < e1.length; i++)for(var s = e1[i], a = 0; a < s.length; a++){
                var l = s[a];
                t1 = Math.min(t1, l.x), r = Math.max(r, l.x), o = Math.min(o, l.y), n = Math.max(n, l.y);
            }
            return [
                t1,
                o,
                r,
                n
            ];
        }, y.prototype.toGeoJSON = g.prototype.toGeoJSON;
        var v = e1.pbf, x = d;
        function w(e1) {
            var t1 = new v;
            return function(e1, t1) {
                for(var r in e1.layers)t1.writeMessage(3, S, e1.layers[r]);
            }(e1, t1), t1.finish();
        }
        function S(e1, t1) {
            var r;
            t1.writeVarintField(15, e1.version || 1), t1.writeStringField(1, e1.name || ""), t1.writeVarintField(5, e1.extent || 4096);
            var o = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(r = 0; r < e1.length; r++)o.feature = e1.feature(r), t1.writeMessage(2, M, o);
            var n = o.keys;
            for(r = 0; r < n.length; r++)t1.writeStringField(3, n[r]);
            var i = o.values;
            for(r = 0; r < i.length; r++)t1.writeMessage(4, T, i[r]);
        }
        function M(e1, t1) {
            var r = e1.feature;
            void 0 !== r.id && t1.writeVarintField(1, r.id), t1.writeMessage(2, P, e1), t1.writeVarintField(3, r.type), t1.writeMessage(4, I, r);
        }
        function P(e1, t1) {
            var r = e1.feature, o = e1.keys, n = e1.values, i = e1.keycache, s = e1.valuecache;
            for(var a in r.properties){
                var l = r.properties[a], u = i[a];
                if (null !== l) {
                    void 0 === u && (o.push(a), i[a] = u = o.length - 1), t1.writeVarint(u);
                    var h = typeof l;
                    "string" !== h && "boolean" !== h && "number" !== h && (l = JSON.stringify(l));
                    var c = h + ":" + l, f = s[c];
                    void 0 === f && (n.push(l), s[c] = f = n.length - 1), t1.writeVarint(f);
                }
            }
        }
        function b(e1, t1) {
            return (t1 << 3) + (7 & e1);
        }
        function k(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function I(e1, t1) {
            for(var r = e1.loadGeometry(), o = e1.type, n = 0, i = 0, s = r.length, a = 0; a < s; a++){
                var l = r[a], u = 1;
                1 === o && (u = l.length), t1.writeVarint(b(1, u));
                for(var h = 3 === o ? l.length - 1 : l.length, c = 0; c < h; c++){
                    1 === c && 1 !== o && t1.writeVarint(b(2, h - 1));
                    var f = l[c].x - n, p = l[c].y - i;
                    t1.writeVarint(k(f)), t1.writeVarint(k(p)), n += f, i += p;
                }
                3 === o && t1.writeVarint(b(7, 1));
            }
        }
        function T(e1, t1) {
            var r = typeof e1;
            "string" === r ? t1.writeStringField(1, e1) : "boolean" === r ? t1.writeBooleanField(7, e1) : "number" === r && (e1 % 1 != 0 ? t1.writeDoubleField(3, e1) : e1 < 0 ? t1.writeSVarintField(6, e1) : t1.writeVarintField(5, e1));
        }
        function _(e1, t1, r, o, n, i) {
            if (n - o <= r) return;
            const s = o + n >> 1;
            L(e1, t1, s, o, n, i % 2), _(e1, t1, r, o, s - 1, i + 1), _(e1, t1, r, s + 1, n, i + 1);
        }
        function L(e1, t1, r, o, n, i) {
            for(; n > o;){
                if (n - o > 600) {
                    const s = n - o + 1, a = r - o + 1, l = Math.log(s), u = .5 * Math.exp(2 * l / 3), h = .5 * Math.sqrt(l * u * (s - u) / s) * (a - s / 2 < 0 ? -1 : 1);
                    L(e1, t1, r, Math.max(o, Math.floor(r - a * u / s + h)), Math.min(n, Math.floor(r + (s - a) * u / s + h)), i);
                }
                const s = t1[2 * r + i];
                let a = o, l = n;
                for(C(e1, t1, o, r), t1[2 * n + i] > s && C(e1, t1, o, n); a < l;){
                    for(C(e1, t1, a, l), a++, l--; t1[2 * a + i] < s;)a++;
                    for(; t1[2 * l + i] > s;)l--;
                }
                t1[2 * o + i] === s ? C(e1, t1, o, l) : (l++, C(e1, t1, l, n)), l <= r && (o = l + 1), r <= l && (n = l - 1);
            }
        }
        function C(e1, t1, r, o) {
            O(e1, r, o), O(t1, 2 * r, 2 * o), O(t1, 2 * r + 1, 2 * o + 1);
        }
        function O(e1, t1, r) {
            const o = e1[t1];
            e1[t1] = e1[r], e1[r] = o;
        }
        function z(e1, t1, r, o) {
            const n = e1 - r, i = t1 - o;
            return n * n + i * i;
        }
        f.exports = w, c.fromVectorTileJs = w, c.fromGeojsonVt = function(e1, t1) {
            t1 = t1 || {};
            var r = {};
            for(var o in e1)r[o] = new x(e1[o].features, t1), r[o].name = o, r[o].version = t1.version, r[o].extent = t1.extent;
            return w({
                layers: r
            });
        }, c.GeoJSONWrapper = x;
        const E = (e1)=>e1[0], F = (e1)=>e1[1];
        class N {
            constructor(e1, t1 = E, r = F, o = 64, n = Float64Array){
                this.nodeSize = o, this.points = e1;
                const i = e1.length < 65536 ? Uint16Array : Uint32Array, s = this.ids = new i(e1.length), a = this.coords = new n(2 * e1.length);
                for(let o = 0; o < e1.length; o++)s[o] = o, a[2 * o] = t1(e1[o]), a[2 * o + 1] = r(e1[o]);
                _(s, a, o, 0, s.length - 1, 0);
            }
            range(e1, t1, r, o) {
                return function(e1, t1, r, o, n, i, s) {
                    const a = [
                        0,
                        e1.length - 1,
                        0
                    ], l = [];
                    let u, h;
                    for(; a.length;){
                        const c = a.pop(), f = a.pop(), p = a.pop();
                        if (f - p <= s) {
                            for(let s = p; s <= f; s++)u = t1[2 * s], h = t1[2 * s + 1], u >= r && u <= n && h >= o && h <= i && l.push(e1[s]);
                            continue;
                        }
                        const g = Math.floor((p + f) / 2);
                        u = t1[2 * g], h = t1[2 * g + 1], u >= r && u <= n && h >= o && h <= i && l.push(e1[g]);
                        const d = (c + 1) % 2;
                        (0 === c ? r <= u : o <= h) && (a.push(p), a.push(g - 1), a.push(d)), (0 === c ? n >= u : i >= h) && (a.push(g + 1), a.push(f), a.push(d));
                    }
                    return l;
                }(this.ids, this.coords, e1, t1, r, o, this.nodeSize);
            }
            within(e1, t1, r) {
                return function(e1, t1, r, o, n, i) {
                    const s = [
                        0,
                        e1.length - 1,
                        0
                    ], a = [], l = n * n;
                    for(; s.length;){
                        const u = s.pop(), h = s.pop(), c = s.pop();
                        if (h - c <= i) {
                            for(let n = c; n <= h; n++)z(t1[2 * n], t1[2 * n + 1], r, o) <= l && a.push(e1[n]);
                            continue;
                        }
                        const f = Math.floor((c + h) / 2), p = t1[2 * f], g = t1[2 * f + 1];
                        z(p, g, r, o) <= l && a.push(e1[f]);
                        const d = (u + 1) % 2;
                        (0 === u ? r - n <= p : o - n <= g) && (s.push(c), s.push(f - 1), s.push(d)), (0 === u ? r + n >= p : o + n >= g) && (s.push(f + 1), s.push(h), s.push(d));
                    }
                    return a;
                }(this.ids, this.coords, e1, t1, r, this.nodeSize);
            }
        }
        const j = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, Z = Math.fround || (G = new Float32Array(1), (e1)=>(G[0] = +e1, G[0]));
        var G;
        class J {
            constructor(e1){
                this.options = B(Object.create(j), e1), this.trees = new Array(this.options.maxZoom + 1);
            }
            load(e1) {
                const { log: t1, minZoom: r, maxZoom: o, nodeSize: n } = this.options;
                t1 && console.time("total time");
                const i = `prepare ${e1.length} points`;
                t1 && console.time(i), this.points = e1;
                let s = [];
                for(let t1 = 0; t1 < e1.length; t1++)e1[t1].geometry && s.push(Y(e1[t1], t1));
                this.trees[o + 1] = new N(s, R, q, n, Float32Array), t1 && console.timeEnd(i);
                for(let e1 = o; e1 >= r; e1--){
                    const r = +Date.now();
                    s = this._cluster(s, e1), this.trees[e1] = new N(s, R, q, n, Float32Array), t1 && console.log("z%d: %d clusters in %dms", e1, s.length, +Date.now() - r);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e1, t1) {
                let r = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const o = Math.max(-90, Math.min(90, e1[1]));
                let n = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) r = -180, n = 180;
                else if (r > n) {
                    const e1 = this.getClusters([
                        r,
                        o,
                        180,
                        i
                    ], t1), s = this.getClusters([
                        -180,
                        o,
                        n,
                        i
                    ], t1);
                    return e1.concat(s);
                }
                const s = this.trees[this._limitZoom(t1)], a = s.range(A(r), D(i), A(n), D(o)), l = [];
                for (const e1 of a){
                    const t1 = s.points[e1];
                    l.push(t1.numPoints ? X(t1) : this.points[t1.index]);
                }
                return l;
            }
            getChildren(e1) {
                const t1 = this._getOriginId(e1), r = this._getOriginZoom(e1), o = "No cluster with the specified id.", n = this.trees[r];
                if (!n) throw new Error(o);
                const i = n.points[t1];
                if (!i) throw new Error(o);
                const s = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), a = n.within(i.x, i.y, s), l = [];
                for (const t1 of a){
                    const r = n.points[t1];
                    r.parentId === e1 && l.push(r.numPoints ? X(r) : this.points[r.index]);
                }
                if (0 === l.length) throw new Error(o);
                return l;
            }
            getLeaves(e1, t1, r) {
                const o = [];
                return this._appendLeaves(o, e1, t1 = t1 || 10, r = r || 0, 0), o;
            }
            getTile(e1, t1, r) {
                const o = this.trees[this._limitZoom(e1)], n = Math.pow(2, e1), { extent: i, radius: s } = this.options, a = s / i, l = (r - a) / n, u = (r + 1 + a) / n, h = {
                    features: []
                };
                return this._addTileFeatures(o.range((t1 - a) / n, l, (t1 + 1 + a) / n, u), o.points, t1, r, n, h), 0 === t1 && this._addTileFeatures(o.range(1 - a / n, l, 1, u), o.points, n, r, n, h), t1 === n - 1 && this._addTileFeatures(o.range(0, l, a / n, u), o.points, -1, r, n, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e1) {
                let t1 = this._getOriginZoom(e1) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const r = this.getChildren(e1);
                    if (t1++, 1 !== r.length) break;
                    e1 = r[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e1, t1, r, o, n) {
                const i = this.getChildren(t1);
                for (const t1 of i){
                    const i = t1.properties;
                    if (i && i.cluster ? n + i.point_count <= o ? n += i.point_count : n = this._appendLeaves(e1, i.cluster_id, r, o, n) : n < o ? n++ : e1.push(t1), e1.length === r) break;
                }
                return n;
            }
            _addTileFeatures(e1, t1, r, o, n, i) {
                for (const s of e1){
                    const e1 = t1[s], a = e1.numPoints;
                    let l, u, h;
                    if (a) l = V(e1), u = e1.x, h = e1.y;
                    else {
                        const t1 = this.points[e1.index];
                        l = t1.properties, u = A(t1.geometry.coordinates[0]), h = D(t1.geometry.coordinates[1]);
                    }
                    const c = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (u * n - r)),
                                Math.round(this.options.extent * (h * n - o))
                            ]
                        ],
                        tags: l
                    };
                    let f;
                    a ? f = e1.id : this.options.generateId ? f = e1.index : this.points[e1.index].id && (f = this.points[e1.index].id), void 0 !== f && (c.id = f), i.features.push(c);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
            }
            _cluster(e1, t1) {
                const r = [], { radius: o, extent: n, reduce: i, minPoints: s } = this.options, a = o / (n * Math.pow(2, t1));
                for(let o = 0; o < e1.length; o++){
                    const n = e1[o];
                    if (n.zoom <= t1) continue;
                    n.zoom = t1;
                    const l = this.trees[t1 + 1], u = l.within(n.x, n.y, a), h = n.numPoints || 1;
                    let c = h;
                    for (const e1 of u){
                        const r = l.points[e1];
                        r.zoom > t1 && (c += r.numPoints || 1);
                    }
                    if (c > h && c >= s) {
                        let e1 = n.x * h, s = n.y * h, a = i && h > 1 ? this._map(n, !0) : null;
                        const f = (o << 5) + (t1 + 1) + this.points.length;
                        for (const r of u){
                            const o = l.points[r];
                            if (o.zoom <= t1) continue;
                            o.zoom = t1;
                            const u = o.numPoints || 1;
                            e1 += o.x * u, s += o.y * u, o.parentId = f, i && (a || (a = this._map(n, !0)), i(a, this._map(o)));
                        }
                        n.parentId = f, r.push(W(e1 / c, s / c, f, c, a));
                    } else if (r.push(n), c > 1) for (const e1 of u){
                        const o = l.points[e1];
                        o.zoom <= t1 || (o.zoom = t1, r.push(o));
                    }
                }
                return r;
            }
            _getOriginId(e1) {
                return e1 - this.points.length >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.points.length) % 32;
            }
            _map(e1, t1) {
                if (e1.numPoints) return t1 ? B({}, e1.properties) : e1.properties;
                const r = this.points[e1.index].properties, o = this.options.map(r);
                return t1 && o === r ? B({}, o) : o;
            }
        }
        function W(e1, t1, r, o, n) {
            return {
                x: Z(e1),
                y: Z(t1),
                zoom: 1 / 0,
                id: r,
                parentId: -1,
                numPoints: o,
                properties: n
            };
        }
        function Y(e1, t1) {
            const [r, o] = e1.geometry.coordinates;
            return {
                x: Z(A(r)),
                y: Z(D(o)),
                zoom: 1 / 0,
                index: t1,
                parentId: -1
            };
        }
        function X(e1) {
            var t1;
            return {
                type: "Feature",
                id: e1.id,
                properties: V(e1),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (t1 = e1.x, 360 * (t1 - .5)),
                        $(e1.y)
                    ]
                }
            };
        }
        function V(e1) {
            const t1 = e1.numPoints, r = t1 >= 1e4 ? `${Math.round(t1 / 1e3)}k` : t1 >= 1e3 ? Math.round(t1 / 100) / 10 + "k" : t1;
            return B(B({}, e1.properties), {
                cluster: !0,
                cluster_id: e1.id,
                point_count: t1,
                point_count_abbreviated: r
            });
        }
        function A(e1) {
            return e1 / 360 + .5;
        }
        function D(e1) {
            const t1 = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function $(e1) {
            const t1 = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function B(e1, t1) {
            for(const r in t1)e1[r] = t1[r];
            return e1;
        }
        function R(e1) {
            return e1.x;
        }
        function q(e1) {
            return e1.y;
        }
        function U(e1, t1, r, o) {
            for(var n, i = o, s = r - t1 >> 1, a = r - t1, l = e1[t1], u = e1[t1 + 1], h = e1[r], c = e1[r + 1], f = t1 + 3; f < r; f += 3){
                var p = Q(e1[f], e1[f + 1], l, u, h, c);
                if (p > i) n = f, i = p;
                else if (p === i) {
                    var g = Math.abs(f - s);
                    g < a && (n = f, a = g);
                }
            }
            i > o && (n - t1 > 3 && U(e1, t1, n, o), e1[n + 2] = i, r - n > 3 && U(e1, n, r, o));
        }
        function Q(e1, t1, r, o, n, i) {
            var s = n - r, a = i - o;
            if (0 !== s || 0 !== a) {
                var l = ((e1 - r) * s + (t1 - o) * a) / (s * s + a * a);
                l > 1 ? (r = n, o = i) : l > 0 && (r += s * l, o += a * l);
            }
            return (s = e1 - r) * s + (a = t1 - o) * a;
        }
        function H(e1, t1, r, o) {
            var n = {
                id: void 0 === e1 ? null : e1,
                type: t1,
                geometry: r,
                tags: o,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            return function(e1) {
                var t1 = e1.geometry, r = e1.type;
                if ("Point" === r || "MultiPoint" === r || "LineString" === r) K(e1, t1);
                else if ("Polygon" === r || "MultiLineString" === r) for(var o = 0; o < t1.length; o++)K(e1, t1[o]);
                else if ("MultiPolygon" === r) for(o = 0; o < t1.length; o++)for(var n = 0; n < t1[o].length; n++)K(e1, t1[o][n]);
            }(n), n;
        }
        function K(e1, t1) {
            for(var r = 0; r < t1.length; r += 3)e1.minX = Math.min(e1.minX, t1[r]), e1.minY = Math.min(e1.minY, t1[r + 1]), e1.maxX = Math.max(e1.maxX, t1[r]), e1.maxY = Math.max(e1.maxY, t1[r + 1]);
        }
        function ee(e1, t1, r, o) {
            if (t1.geometry) {
                var n = t1.geometry.coordinates, i = t1.geometry.type, s = Math.pow(r.tolerance / ((1 << r.maxZoom) * r.extent), 2), a = [], l = t1.id;
                if (r.promoteId ? l = t1.properties[r.promoteId] : r.generateId && (l = o || 0), "Point" === i) te(n, a);
                else if ("MultiPoint" === i) for(var u = 0; u < n.length; u++)te(n[u], a);
                else if ("LineString" === i) re(n, a, s, !1);
                else if ("MultiLineString" === i) {
                    if (r.lineMetrics) {
                        for(u = 0; u < n.length; u++)re(n[u], a = [], s, !1), e1.push(H(l, "LineString", a, t1.properties));
                        return;
                    }
                    oe(n, a, s, !1);
                } else if ("Polygon" === i) oe(n, a, s, !0);
                else {
                    if ("MultiPolygon" !== i) {
                        if ("GeometryCollection" === i) {
                            for(u = 0; u < t1.geometry.geometries.length; u++)ee(e1, {
                                id: l,
                                geometry: t1.geometry.geometries[u],
                                properties: t1.properties
                            }, r, o);
                            return;
                        }
                        throw new Error("Input data is not a valid GeoJSON object.");
                    }
                    for(u = 0; u < n.length; u++){
                        var h = [];
                        oe(n[u], h, s, !0), a.push(h);
                    }
                }
                e1.push(H(l, i, a, t1.properties));
            }
        }
        function te(e1, t1) {
            t1.push(ne(e1[0])), t1.push(ie(e1[1])), t1.push(0);
        }
        function re(e1, t1, r, o) {
            for(var n, i, s = 0, a = 0; a < e1.length; a++){
                var l = ne(e1[a][0]), u = ie(e1[a][1]);
                t1.push(l), t1.push(u), t1.push(0), a > 0 && (s += o ? (n * u - l * i) / 2 : Math.sqrt(Math.pow(l - n, 2) + Math.pow(u - i, 2))), n = l, i = u;
            }
            var h = t1.length - 3;
            t1[2] = 1, U(t1, 0, h, r), t1[h + 2] = 1, t1.size = Math.abs(s), t1.start = 0, t1.end = t1.size;
        }
        function oe(e1, t1, r, o) {
            for(var n = 0; n < e1.length; n++){
                var i = [];
                re(e1[n], i, r, o), t1.push(i);
            }
        }
        function ne(e1) {
            return e1 / 360 + .5;
        }
        function ie(e1) {
            var t1 = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function se(e1, t1, r, o, n, i, s, a) {
            if (o /= t1, i >= (r /= t1) && s < o) return e1;
            if (s < r || i >= o) return null;
            for(var l = [], u = 0; u < e1.length; u++){
                var h = e1[u], c = h.geometry, f = h.type, p = 0 === n ? h.minX : h.minY, g = 0 === n ? h.maxX : h.maxY;
                if (p >= r && g < o) l.push(h);
                else if (!(g < r || p >= o)) {
                    var d = [];
                    if ("Point" === f || "MultiPoint" === f) ae(c, d, r, o, n);
                    else if ("LineString" === f) le(c, d, r, o, n, !1, a.lineMetrics);
                    else if ("MultiLineString" === f) he(c, d, r, o, n, !1);
                    else if ("Polygon" === f) he(c, d, r, o, n, !0);
                    else if ("MultiPolygon" === f) for(var m = 0; m < c.length; m++){
                        var y = [];
                        he(c[m], y, r, o, n, !0), y.length && d.push(y);
                    }
                    if (d.length) {
                        if (a.lineMetrics && "LineString" === f) {
                            for(m = 0; m < d.length; m++)l.push(H(h.id, f, d[m], h.tags));
                            continue;
                        }
                        "LineString" !== f && "MultiLineString" !== f || (1 === d.length ? (f = "LineString", d = d[0]) : f = "MultiLineString"), "Point" !== f && "MultiPoint" !== f || (f = 3 === d.length ? "Point" : "MultiPoint"), l.push(H(h.id, f, d, h.tags));
                    }
                }
            }
            return l.length ? l : null;
        }
        function ae(e1, t1, r, o, n) {
            for(var i = 0; i < e1.length; i += 3){
                var s = e1[i + n];
                s >= r && s <= o && (t1.push(e1[i]), t1.push(e1[i + 1]), t1.push(e1[i + 2]));
            }
        }
        function le(e1, t1, r, o, n, i, s) {
            for(var a, l, u = ue(e1), h = 0 === n ? fe : pe, c = e1.start, f = 0; f < e1.length - 3; f += 3){
                var p = e1[f], g = e1[f + 1], d = e1[f + 2], m = e1[f + 3], y = e1[f + 4], v = 0 === n ? p : g, x = 0 === n ? m : y, w = !1;
                s && (a = Math.sqrt(Math.pow(p - m, 2) + Math.pow(g - y, 2))), v < r ? x > r && (l = h(u, p, g, m, y, r), s && (u.start = c + a * l)) : v > o ? x < o && (l = h(u, p, g, m, y, o), s && (u.start = c + a * l)) : ce(u, p, g, d), x < r && v >= r && (l = h(u, p, g, m, y, r), w = !0), x > o && v <= o && (l = h(u, p, g, m, y, o), w = !0), !i && w && (s && (u.end = c + a * l), t1.push(u), u = ue(e1)), s && (c += a);
            }
            var S = e1.length - 3;
            p = e1[S], g = e1[S + 1], d = e1[S + 2], (v = 0 === n ? p : g) >= r && v <= o && ce(u, p, g, d), S = u.length - 3, i && S >= 3 && (u[S] !== u[0] || u[S + 1] !== u[1]) && ce(u, u[0], u[1], u[2]), u.length && t1.push(u);
        }
        function ue(e1) {
            var t1 = [];
            return t1.size = e1.size, t1.start = e1.start, t1.end = e1.end, t1;
        }
        function he(e1, t1, r, o, n, i) {
            for(var s = 0; s < e1.length; s++)le(e1[s], t1, r, o, n, i, !1);
        }
        function ce(e1, t1, r, o) {
            e1.push(t1), e1.push(r), e1.push(o);
        }
        function fe(e1, t1, r, o, n, i) {
            var s = (i - t1) / (o - t1);
            return e1.push(i), e1.push(r + (n - r) * s), e1.push(1), s;
        }
        function pe(e1, t1, r, o, n, i) {
            var s = (i - r) / (n - r);
            return e1.push(t1 + (o - t1) * s), e1.push(i), e1.push(1), s;
        }
        function ge(e1, t1) {
            for(var r = [], o = 0; o < e1.length; o++){
                var n, i = e1[o], s = i.type;
                if ("Point" === s || "MultiPoint" === s || "LineString" === s) n = de(i.geometry, t1);
                else if ("MultiLineString" === s || "Polygon" === s) {
                    n = [];
                    for(var a = 0; a < i.geometry.length; a++)n.push(de(i.geometry[a], t1));
                } else if ("MultiPolygon" === s) for(n = [], a = 0; a < i.geometry.length; a++){
                    for(var l = [], u = 0; u < i.geometry[a].length; u++)l.push(de(i.geometry[a][u], t1));
                    n.push(l);
                }
                r.push(H(i.id, s, n, i.tags));
            }
            return r;
        }
        function de(e1, t1) {
            var r = [];
            r.size = e1.size, void 0 !== e1.start && (r.start = e1.start, r.end = e1.end);
            for(var o = 0; o < e1.length; o += 3)r.push(e1[o] + t1, e1[o + 1], e1[o + 2]);
            return r;
        }
        function me(e1, t1) {
            if (e1.transformed) return e1;
            var r, o, n, i = 1 << e1.z, s = e1.x, a = e1.y;
            for(r = 0; r < e1.features.length; r++){
                var l = e1.features[r], u = l.geometry, h = l.type;
                if (l.geometry = [], 1 === h) for(o = 0; o < u.length; o += 2)l.geometry.push(ye(u[o], u[o + 1], t1, i, s, a));
                else for(o = 0; o < u.length; o++){
                    var c = [];
                    for(n = 0; n < u[o].length; n += 2)c.push(ye(u[o][n], u[o][n + 1], t1, i, s, a));
                    l.geometry.push(c);
                }
            }
            return e1.transformed = !0, e1;
        }
        function ye(e1, t1, r, o, n, i) {
            return [
                Math.round(r * (e1 * o - n)),
                Math.round(r * (t1 * o - i))
            ];
        }
        function ve(e1, t1, r, o, n) {
            for(var i = t1 === n.maxZoom ? 0 : n.tolerance / ((1 << t1) * n.extent), s = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: 0,
                source: null,
                x: r,
                y: o,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            }, a = 0; a < e1.length; a++){
                s.numFeatures++, xe(s, e1[a], i, n);
                var l = e1[a].minX, u = e1[a].minY, h = e1[a].maxX, c = e1[a].maxY;
                l < s.minX && (s.minX = l), u < s.minY && (s.minY = u), h > s.maxX && (s.maxX = h), c > s.maxY && (s.maxY = c);
            }
            return s;
        }
        function xe(e1, t1, r, o) {
            var n = t1.geometry, i = t1.type, s = [];
            if ("Point" === i || "MultiPoint" === i) for(var a = 0; a < n.length; a += 3)s.push(n[a]), s.push(n[a + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === i) we(s, n, e1, r, !1, !1);
            else if ("MultiLineString" === i || "Polygon" === i) for(a = 0; a < n.length; a++)we(s, n[a], e1, r, "Polygon" === i, 0 === a);
            else if ("MultiPolygon" === i) for(var l = 0; l < n.length; l++){
                var u = n[l];
                for(a = 0; a < u.length; a++)we(s, u[a], e1, r, !0, 0 === a);
            }
            if (s.length) {
                var h = t1.tags || null;
                if ("LineString" === i && o.lineMetrics) {
                    for(var c in h = {}, t1.tags)h[c] = t1.tags[c];
                    h.mapbox_clip_start = n.start / n.size, h.mapbox_clip_end = n.end / n.size;
                }
                var f = {
                    geometry: s,
                    type: "Polygon" === i || "MultiPolygon" === i ? 3 : "LineString" === i || "MultiLineString" === i ? 2 : 1,
                    tags: h
                };
                null !== t1.id && (f.id = t1.id), e1.features.push(f);
            }
        }
        function we(e1, t1, r, o, n, i) {
            var s = o * o;
            if (o > 0 && t1.size < (n ? s : o)) r.numPoints += t1.length / 3;
            else {
                for(var a = [], l = 0; l < t1.length; l += 3)(0 === o || t1[l + 2] > s) && (r.numSimplified++, a.push(t1[l]), a.push(t1[l + 1])), r.numPoints++;
                n && function(e1, t1) {
                    for(var r = 0, o = 0, n = e1.length, i = n - 2; o < n; i = o, o += 2)r += (e1[o] - e1[i]) * (e1[o + 1] + e1[i + 1]);
                    if (r > 0 === t1) for(o = 0, n = e1.length; o < n / 2; o += 2){
                        var s = e1[o], a = e1[o + 1];
                        e1[o] = e1[n - 2 - o], e1[o + 1] = e1[n - 1 - o], e1[n - 2 - o] = s, e1[n - 1 - o] = a;
                    }
                }(a, i), e1.push(a);
            }
        }
        function Se(e1, t1) {
            var r = (t1 = this.options = function(e1, t1) {
                for(var r in t1)e1[r] = t1[r];
                return e1;
            }(Object.create(this.options), t1)).debug;
            if (r && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
            var o = function(e1, t1) {
                var r = [];
                if ("FeatureCollection" === e1.type) for(var o = 0; o < e1.features.length; o++)ee(r, e1.features[o], t1, o);
                else ee(r, "Feature" === e1.type ? e1 : {
                    geometry: e1
                }, t1);
                return r;
            }(e1, t1);
            this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), o = function(e1, t1) {
                var r = t1.buffer / t1.extent, o = e1, n = se(e1, 1, -1 - r, r, 0, -1, 2, t1), i = se(e1, 1, 1 - r, 2 + r, 0, -1, 2, t1);
                return (n || i) && (o = se(e1, 1, -r, 1 + r, 0, -1, 2, t1) || [], n && (o = ge(n, 1).concat(o)), i && (o = o.concat(ge(i, -1)))), o;
            }(o, t1), o.length && this.splitTile(o, 0, 0, 0), r && (o.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        function Me(e1, t1, r) {
            return 32 * ((1 << e1) * r + t1) + e1;
        }
        function Pe(e1, t1) {
            const r = e1.tileID.canonical;
            if (!this._geoJSONIndex) return t1(null, null);
            const o = this._geoJSONIndex.getTile(r.z, r.x, r.y);
            if (!o) return t1(null, null);
            const n = new h(o.features);
            let i = c(n);
            0 === i.byteOffset && i.byteLength === i.buffer.byteLength || (i = new Uint8Array(i)), t1(null, {
                vectorTile: n,
                rawData: i.buffer
            });
        }
        Se.prototype.options = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        }, Se.prototype.splitTile = function(e1, t1, r, o, n, i, s) {
            for(var a = [
                e1,
                t1,
                r,
                o
            ], l = this.options, u = l.debug; a.length;){
                o = a.pop(), r = a.pop(), t1 = a.pop(), e1 = a.pop();
                var h = 1 << t1, c = Me(t1, r, o), f = this.tiles[c];
                if (!f && (u > 1 && console.time("creation"), f = this.tiles[c] = ve(e1, t1, r, o, l), this.tileCoords.push({
                    z: t1,
                    x: r,
                    y: o
                }), u)) {
                    u > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, r, o, f.numFeatures, f.numPoints, f.numSimplified), console.timeEnd("creation"));
                    var p = "z" + t1;
                    this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
                }
                if (f.source = e1, n) {
                    if (t1 === l.maxZoom || t1 === n) continue;
                    var g = 1 << n - t1;
                    if (r !== Math.floor(i / g) || o !== Math.floor(s / g)) continue;
                } else if (t1 === l.indexMaxZoom || f.numPoints <= l.indexMaxPoints) continue;
                if (f.source = null, 0 !== e1.length) {
                    u > 1 && console.time("clipping");
                    var d, m, y, v, x, w, S = .5 * l.buffer / l.extent, M = .5 - S, P = .5 + S, b = 1 + S;
                    d = m = y = v = null, x = se(e1, h, r - S, r + P, 0, f.minX, f.maxX, l), w = se(e1, h, r + M, r + b, 0, f.minX, f.maxX, l), e1 = null, x && (d = se(x, h, o - S, o + P, 1, f.minY, f.maxY, l), m = se(x, h, o + M, o + b, 1, f.minY, f.maxY, l), x = null), w && (y = se(w, h, o - S, o + P, 1, f.minY, f.maxY, l), v = se(w, h, o + M, o + b, 1, f.minY, f.maxY, l), w = null), u > 1 && console.timeEnd("clipping"), a.push(d || [], t1 + 1, 2 * r, 2 * o), a.push(m || [], t1 + 1, 2 * r, 2 * o + 1), a.push(y || [], t1 + 1, 2 * r + 1, 2 * o), a.push(v || [], t1 + 1, 2 * r + 1, 2 * o + 1);
                }
            }
        }, Se.prototype.getTile = function(e1, t1, r) {
            var o = this.options, n = o.extent, i = o.debug;
            if (e1 < 0 || e1 > 24) return null;
            var s = 1 << e1, a = Me(e1, t1 = (t1 % s + s) % s, r);
            if (this.tiles[a]) return me(this.tiles[a], n);
            i > 1 && console.log("drilling down to z%d-%d-%d", e1, t1, r);
            for(var l, u = e1, h = t1, c = r; !l && u > 0;)u--, h = Math.floor(h / 2), c = Math.floor(c / 2), l = this.tiles[Me(u, h, c)];
            return l && l.source ? (i > 1 && console.log("found parent tile z%d-%d-%d", u, h, c), i > 1 && console.time("drilling down"), this.splitTile(l.source, u, h, c, e1, t1, r), i > 1 && console.timeEnd("drilling down"), this.tiles[a] ? me(this.tiles[a], n) : null) : null;
        };
        class be extends e1.VectorTileWorkerSource {
            constructor(e1, t1, r, o, n){
                super(e1, t1, r, o, Pe), n && (this.loadGeoJSON = n);
            }
            loadData(t1, r) {
                const o = t1 && t1.request, n = o && o.collectResourceTiming;
                this.loadGeoJSON(t1, (s, a)=>{
                    if (s || !a) return r(s);
                    if ("object" != typeof a) return r(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    {
                        i(a, !0);
                        try {
                            if (t1.filter) {
                                const r = e1.createExpression(t1.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === r.result) throw new Error(r.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                                const o = a.features.filter((e1)=>r.value.evaluate({
                                        zoom: 0
                                    }, e1));
                                a = {
                                    type: "FeatureCollection",
                                    features: o
                                };
                            }
                            this._geoJSONIndex = t1.cluster ? new J(function({ superclusterOptions: t1, clusterProperties: r }) {
                                if (!r || !t1) return t1;
                                const o = {}, n = {}, i = {
                                    accumulated: null,
                                    zoom: 0
                                }, s = {
                                    properties: null
                                }, a = Object.keys(r);
                                for (const t1 of a){
                                    const [i, s] = r[t1], a = e1.createExpression(s), l = e1.createExpression("string" == typeof i ? [
                                        i,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t1
                                        ]
                                    ] : i);
                                    o[t1] = a.value, n[t1] = l.value;
                                }
                                return t1.map = (e1)=>{
                                    s.properties = e1;
                                    const t1 = {};
                                    for (const e1 of a)t1[e1] = o[e1].evaluate(i, s);
                                    return t1;
                                }, t1.reduce = (e1, t1)=>{
                                    s.properties = t1;
                                    for (const t1 of a)i.accumulated = e1[t1], e1[t1] = n[t1].evaluate(i, s);
                                }, t1;
                            }(t1)).load(a.features) : function(e1, t1) {
                                return new Se(e1, t1);
                            }(a, t1.geojsonVtOptions);
                        } catch (s) {
                            return r(s);
                        }
                        this.loaded = {};
                        const l = {};
                        if (n) {
                            const r = e1.getPerformanceMeasurement(o);
                            r && (l.resourceTiming = {}, l.resourceTiming[t1.source] = JSON.parse(JSON.stringify(r)));
                        }
                        r(null, l);
                    }
                });
            }
            reloadTile(e1, t1) {
                const r = this.loaded;
                return r && r[e1.uid] ? super.reloadTile(e1, t1) : this.loadTile(e1, t1);
            }
            loadGeoJSON(t1, r) {
                if (t1.request) e1.getJSON(t1.request, r);
                else {
                    if ("string" != typeof t1.data) return r(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    try {
                        return r(null, JSON.parse(t1.data));
                    } catch (e1) {
                        return r(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    }
                }
            }
            getClusterExpansionZoom(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterChildren(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterLeaves(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset));
                } catch (e1) {
                    t1(e1);
                }
            }
        }
        class ke {
            constructor(t1){
                this.self = t1, this.actor = new e1.Actor(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.projections = {}, this.defaultProjection = e1.getProjection({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: e1.VectorTileWorkerSource,
                    geojson: be
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e1, t1)=>{
                    if (this.workerSourceTypes[e1]) throw new Error(`Worker source with name "${e1}" already registered.`);
                    this.workerSourceTypes[e1] = t1;
                }, this.self.registerRTLTextPlugin = (t1)=>{
                    if (e1.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
                    e1.plugin.applyArabicShaping = t1.applyArabicShaping, e1.plugin.processBidirectionalText = t1.processBidirectionalText, e1.plugin.processStyledBidirectionalText = t1.processStyledBidirectionalText;
                };
            }
            clearCaches(e1, t1, r) {
                delete this.layerIndexes[e1], delete this.availableImages[e1], delete this.workerSources[e1], delete this.demWorkerSources[e1], r();
            }
            checkIfReady(e1, t1, r) {
                r();
            }
            setReferrer(e1, t1) {
                this.referrer = t1;
            }
            spriteLoaded(t1, r) {
                this.isSpriteLoaded[t1] = r;
                for(const o in this.workerSources[t1]){
                    const n = this.workerSources[t1][o];
                    for(const t1 in n)n[t1] instanceof e1.VectorTileWorkerSource && (n[t1].isSpriteLoaded = r, n[t1].fire(new e1.Event("isSpriteLoaded")));
                }
            }
            setImages(e1, t1, r) {
                this.availableImages[e1] = t1;
                for(const r in this.workerSources[e1]){
                    const o = this.workerSources[e1][r];
                    for(const e1 in o)o[e1].availableImages = t1;
                }
                r();
            }
            enableTerrain(e1, t1, r) {
                this.terrain = t1, r();
            }
            setProjection(t1, r) {
                this.projections[t1] = e1.getProjection(r);
            }
            setLayers(e1, t1, r) {
                this.getLayerIndex(e1).replace(t1), r();
            }
            updateLayers(e1, t1, r) {
                this.getLayerIndex(e1).update(t1.layers, t1.removedIds), r();
            }
            loadTile(t1, r, o) {
                const n = this.enableTerrain ? e1.extend({
                    enableTerrain: this.terrain
                }, r) : r;
                n.projection = this.projections[t1] || this.defaultProjection, this.getWorkerSource(t1, r.type, r.source).loadTile(n, o);
            }
            loadDEMTile(t1, r, o) {
                const n = this.enableTerrain ? e1.extend({
                    buildQuadTree: this.terrain
                }, r) : r;
                this.getDEMWorkerSource(t1, r.source).loadTile(n, o);
            }
            reloadTile(t1, r, o) {
                const n = this.enableTerrain ? e1.extend({
                    enableTerrain: this.terrain
                }, r) : r;
                n.projection = this.projections[t1] || this.defaultProjection, this.getWorkerSource(t1, r.type, r.source).reloadTile(n, o);
            }
            abortTile(e1, t1, r) {
                this.getWorkerSource(e1, t1.type, t1.source).abortTile(t1, r);
            }
            removeTile(e1, t1, r) {
                this.getWorkerSource(e1, t1.type, t1.source).removeTile(t1, r);
            }
            removeSource(e1, t1, r) {
                if (!this.workerSources[e1] || !this.workerSources[e1][t1.type] || !this.workerSources[e1][t1.type][t1.source]) return;
                const o = this.workerSources[e1][t1.type][t1.source];
                delete this.workerSources[e1][t1.type][t1.source], void 0 !== o.removeSource ? o.removeSource(t1, r) : r();
            }
            loadWorkerSource(e1, t1, r) {
                try {
                    this.self.importScripts(t1.url), r();
                } catch (e1) {
                    r(e1.toString());
                }
            }
            syncRTLPluginState(t1, r, o) {
                try {
                    e1.plugin.setState(r);
                    const t1 = e1.plugin.getPluginURL();
                    if (e1.plugin.isLoaded() && !e1.plugin.isParsed() && null != t1) {
                        this.self.importScripts(t1);
                        const r = e1.plugin.isParsed();
                        o(r ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t1}`), r);
                    }
                } catch (e1) {
                    o(e1.toString());
                }
            }
            getAvailableImages(e1) {
                let t1 = this.availableImages[e1];
                return t1 || (t1 = []), t1;
            }
            getLayerIndex(e1) {
                let t1 = this.layerIndexes[e1];
                return t1 || (t1 = this.layerIndexes[e1] = new o), t1;
            }
            getWorkerSource(e1, t1, r) {
                if (this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][t1] || (this.workerSources[e1][t1] = {}), !this.workerSources[e1][t1][r]) {
                    const o = {
                        send: (t1, r, o, n, i, s)=>{
                            this.actor.send(t1, r, o, e1, i, s);
                        },
                        scheduler: this.actor.scheduler
                    };
                    this.workerSources[e1][t1][r] = new this.workerSourceTypes[t1](o, this.getLayerIndex(e1), this.getAvailableImages(e1), this.isSpriteLoaded[e1]);
                }
                return this.workerSources[e1][t1][r];
            }
            getDEMWorkerSource(e1, t1) {
                return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][t1] || (this.demWorkerSources[e1][t1] = new n), this.demWorkerSources[e1][t1];
            }
            enforceCacheSizeLimit(t1, r) {
                e1.enforceCacheSizeLimit(r);
            }
            getWorkerPerformanceMetrics(e1, t1, r) {
                r(void 0, void 0);
            }
        }
        return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new ke(self)), ke;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        function t1(e1, i) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(i) || e1.length !== i.length) return !1;
                for(let o = 0; o < e1.length; o++)if (!t1(e1[o], i[o])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== i) {
                if ("object" != typeof i) return !1;
                if (Object.keys(e1).length !== Object.keys(i).length) return !1;
                for(const o in e1)if (!t1(e1[o], i[o])) return !1;
                return !0;
            }
            return e1 === i;
        }
        var i = o;
        function o(e1) {
            return !function(e1) {
                var t1;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var e1, t1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        t1 = new Worker(o), e1 = !0;
                    } catch (t1) {
                        e1 = !1;
                    }
                    return t1 && t1.terminate(), URL.revokeObjectURL(o), e1;
                }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
                    var e1 = document.createElement("canvas");
                    e1.width = e1.height = 1;
                    var t1 = e1.getContext("2d");
                    if (!t1) return !1;
                    var i = t1.getImageData(0, 0, 1, 1);
                    return i && i.width === e1.width;
                }() ? (void 0 === r[t1 = e1 && e1.failIfMajorPerformanceCaveat] && (r[t1] = function(e1) {
                    var t1, i = function(e1) {
                        var t1 = document.createElement("canvas"), i = Object.create(o.webGLContextAttributes);
                        return i.failIfMajorPerformanceCaveat = e1, t1.getContext("webgl", i) || t1.getContext("experimental-webgl", i);
                    }(e1);
                    if (!i) return !1;
                    try {
                        t1 = i.createShader(i.VERTEX_SHADER);
                    } catch (e1) {
                        return !1;
                    }
                    return !(!t1 || i.isContextLost()) && (i.shaderSource(t1, "void main() {}"), i.compileShader(t1), !0 === i.getShaderParameter(t1, i.COMPILE_STATUS));
                }(t1)), r[t1] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL support") : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
            }(e1);
        }
        var r = {};
        function n(t1, i, o) {
            const r = e1.window.document.createElement(t1);
            return void 0 !== i && (r.className = i), o && o.appendChild(r), r;
        }
        function s(t1, i, o) {
            const r = e1.window.document.createElementNS("http://www.w3.org/2000/svg", t1);
            for (const e1 of Object.keys(i))r.setAttributeNS(null, e1, i[e1]);
            return o && o.appendChild(r), r;
        }
        o.webGLContextAttributes = {
            antialias: !1,
            alpha: !0,
            stencil: !0,
            depth: !0
        };
        const a = e1.window.document && e1.window.document.documentElement.style, l = a && void 0 !== a.userSelect ? "userSelect" : "WebkitUserSelect";
        let c;
        function h() {
            a && l && (c = a[l], a[l] = "none");
        }
        function u() {
            a && l && (a[l] = c);
        }
        function _(t1) {
            t1.preventDefault(), t1.stopPropagation(), e1.window.removeEventListener("click", _, !0);
        }
        function d() {
            e1.window.addEventListener("click", _, !0), e1.window.setTimeout(()=>{
                e1.window.removeEventListener("click", _, !0);
            }, 0);
        }
        function p(e1, t1) {
            const i = e1.getBoundingClientRect();
            return g(e1, i, t1);
        }
        function m(e1, t1) {
            const i = e1.getBoundingClientRect(), o = [];
            for(let r = 0; r < t1.length; r++)o.push(g(e1, i, t1[r]));
            return o;
        }
        function f(t1) {
            return void 0 !== e1.window.InstallTrigger && 2 === t1.button && t1.ctrlKey && e1.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : t1.button;
        }
        function g(t1, i, o) {
            const r = t1.offsetWidth === i.width ? 1 : t1.offsetWidth / i.width;
            return new e1.pointGeometry((o.clientX - i.left) * r, (o.clientY - i.top) * r);
        }
        function v(e1, t1) {
            var i = t1[0], o = t1[1], r = t1[2], n = t1[3], s = i * n - r * o;
            return s ? (e1[0] = n * (s = 1 / s), e1[1] = -o * s, e1[2] = -r * s, e1[3] = i * s, e1) : null;
        }
        function x(e1) {
            const { userImage: t1 } = e1;
            return !!(t1 && t1.render && t1.render()) && (e1.data.replace(new Uint8Array(t1.data.buffer)), !0);
        }
        class y extends e1.Evented {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new e1.RGBAImage({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            isLoaded() {
                return this.loaded;
            }
            setLoaded(e1) {
                if (this.loaded !== e1 && (this.loaded = e1, e1)) {
                    for (const { ids: e1, callback: t1 } of this.requestors)this._notify(e1, t1);
                    this.requestors = [];
                }
            }
            hasImage(e1) {
                return !!this.getImage(e1);
            }
            getImage(e1) {
                return this.images[e1];
            }
            addImage(e1, t1) {
                this._validate(e1, t1) && (this.images[e1] = t1);
            }
            _validate(t1, i) {
                let o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e1.ErrorEvent(new Error(`Image "${t1}" has invalid "stretchX" value`))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e1.ErrorEvent(new Error(`Image "${t1}" has invalid "stretchY" value`))), o = !1), this._validateContent(i.content, i) || (this.fire(new e1.ErrorEvent(new Error(`Image "${t1}" has invalid "content" value`))), o = !1), o;
            }
            _validateStretch(e1, t1) {
                if (!e1) return !0;
                let i = 0;
                for (const o of e1){
                    if (o[0] < i || o[1] < o[0] || t1 < o[1]) return !1;
                    i = o[1];
                }
                return !0;
            }
            _validateContent(e1, t1) {
                return !(e1 && (4 !== e1.length || e1[0] < 0 || t1.data.width < e1[0] || e1[1] < 0 || t1.data.height < e1[1] || e1[2] < 0 || t1.data.width < e1[2] || e1[3] < 0 || t1.data.height < e1[3] || e1[2] < e1[0] || e1[3] < e1[1]));
            }
            updateImage(e1, t1) {
                t1.version = this.images[e1].version + 1, this.images[e1] = t1, this.updatedImages[e1] = !0;
            }
            removeImage(e1) {
                const t1 = this.images[e1];
                delete this.images[e1], delete this.patterns[e1], t1.userImage && t1.userImage.onRemove && t1.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(e1, t1) {
                let i = !0;
                if (!this.isLoaded()) for (const t1 of e1)this.images[t1] || (i = !1);
                this.isLoaded() || i ? this._notify(e1, t1) : this.requestors.push({
                    ids: e1,
                    callback: t1
                });
            }
            _notify(t1, i) {
                const o = {};
                for (const i of t1){
                    this.images[i] || this.fire(new e1.Event("styleimagemissing", {
                        id: i
                    }));
                    const t1 = this.images[i];
                    t1 ? o[i] = {
                        data: t1.data.clone(),
                        pixelRatio: t1.pixelRatio,
                        sdf: t1.sdf,
                        version: t1.version,
                        stretchX: t1.stretchX,
                        stretchY: t1.stretchY,
                        content: t1.content,
                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                    } : e1.warnOnce(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                i(null, o);
            }
            getPixelSize() {
                const { width: e1, height: t1 } = this.atlasImage;
                return {
                    width: e1,
                    height: t1
                };
            }
            getPattern(t1) {
                const i = this.patterns[t1], o = this.getImage(t1);
                if (!o) return null;
                if (i && i.position.version === o.version) return i.position;
                if (i) i.position.version = o.version;
                else {
                    const i = {
                        w: o.data.width + 2,
                        h: o.data.height + 2,
                        x: 0,
                        y: 0
                    }, r = new e1.ImagePosition(i, o);
                    this.patterns[t1] = {
                        bin: i,
                        position: r
                    };
                }
                return this._updatePatternAtlas(), this.patterns[t1].position;
            }
            bind(t1) {
                const i = t1.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new e1.Texture(t1, this.atlasImage, i.RGBA), this.atlasTexture.bind(i.LINEAR, i.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const t1 = [];
                for(const e1 in this.patterns)t1.push(this.patterns[e1].bin);
                const { w: i, h: o } = e1.potpack(t1), r = this.atlasImage;
                r.resize({
                    width: i || 1,
                    height: o || 1
                });
                for(const t1 in this.patterns){
                    const { bin: i } = this.patterns[t1], o = i.x + 1, n = i.y + 1, s = this.images[t1].data, a = s.width, l = s.height;
                    e1.RGBAImage.copy(s, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: n
                    }, {
                        width: a,
                        height: l
                    }), e1.RGBAImage.copy(s, r, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: o,
                        y: n - 1
                    }, {
                        width: a,
                        height: 1
                    }), e1.RGBAImage.copy(s, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: n + l
                    }, {
                        width: a,
                        height: 1
                    }), e1.RGBAImage.copy(s, r, {
                        x: a - 1,
                        y: 0
                    }, {
                        x: o - 1,
                        y: n
                    }, {
                        width: 1,
                        height: l
                    }), e1.RGBAImage.copy(s, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + a,
                        y: n
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(e1) {
                for (const t1 of e1){
                    if (this.callbackDispatchedThisFrame[t1]) continue;
                    this.callbackDispatchedThisFrame[t1] = !0;
                    const e1 = this.images[t1];
                    x(e1) && this.updateImage(t1, e1);
                }
            }
        }
        const b = new e1.Properties({
            anchor: new e1.DataConstantProperty(e1.spec.light.anchor),
            position: new class {
                constructor(){
                    this.specification = e1.spec.light.position;
                }
                possiblyEvaluate(t1, i) {
                    return function([t1, i, o]) {
                        const r = e1.degToRad(i + 90), n = e1.degToRad(o);
                        return {
                            x: t1 * Math.cos(r) * Math.sin(n),
                            y: t1 * Math.sin(r) * Math.sin(n),
                            z: t1 * Math.cos(n),
                            azimuthal: i,
                            polar: o
                        };
                    }(t1.expression.evaluate(i));
                }
                interpolate(t1, i, o) {
                    return {
                        x: e1.number(t1.x, i.x, o),
                        y: e1.number(t1.y, i.y, o),
                        z: e1.number(t1.z, i.z, o),
                        azimuthal: e1.number(t1.azimuthal, i.azimuthal, o),
                        polar: e1.number(t1.polar, i.polar, o)
                    };
                }
            },
            color: new e1.DataConstantProperty(e1.spec.light.color),
            intensity: new e1.DataConstantProperty(e1.spec.light.intensity)
        }), w = "-transition";
        class T extends e1.Evented {
            constructor(t1){
                super(), this._transitionable = new e1.Transitionable(b), this.setLight(t1), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(t1, i = {}) {
                if (!this._validate(e1.validateLight, t1, i)) for(const i in t1){
                    const o = t1[i];
                    e1.endsWith(i, w) ? this._transitionable.setTransition(i.slice(0, -w.length), o) : this._transitionable.setValue(i, o);
                }
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && e1.emitValidationErrors(this, t1.call(e1.validateStyle, e1.extend({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.spec
                })));
            }
        }
        const E = new e1.Properties({
            source: new e1.DataConstantProperty(e1.spec.terrain.source),
            exaggeration: new e1.DataConstantProperty(e1.spec.terrain.exaggeration)
        }), C = "-transition";
        class M extends e1.Evented {
            constructor(t1, i){
                super(), this._transitionable = new e1.Transitionable(E), this.set(t1), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i;
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1) {
                for(const i in t1){
                    const o = t1[i];
                    e1.endsWith(i, C) ? this._transitionable.setTransition(i.slice(0, -C.length), o) : this._transitionable.setValue(i, o);
                }
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
        }
        function I(t1, i, o, r) {
            const n = e1.smoothstep(45, 65, o), [s, a] = S(t1, r), l = e1.length(i);
            let c = 1 - Math.min(1, Math.exp((l - s) / (a - s) * -6));
            return c *= c * c, c = Math.min(1, 1.00747 * c), c * n * t1.alpha;
        }
        function S(e1, t1) {
            const i = .5 / Math.tan(.5 * t1);
            return [
                e1.range[0] + i,
                e1.range[1] + i
            ];
        }
        const D = new e1.Properties({
            range: new e1.DataConstantProperty(e1.spec.fog.range),
            color: new e1.DataConstantProperty(e1.spec.fog.color),
            "high-color": new e1.DataConstantProperty(e1.spec.fog["high-color"]),
            "space-color": new e1.DataConstantProperty(e1.spec.fog["space-color"]),
            "horizon-blend": new e1.DataConstantProperty(e1.spec.fog["horizon-blend"]),
            "star-intensity": new e1.DataConstantProperty(e1.spec.fog["star-intensity"])
        }), L = "-transition";
        class A extends e1.Evented {
            constructor(t1, i){
                super(), this._transitionable = new e1.Transitionable(D), this.set(t1), this._transitioning = this._transitionable.untransitioned(), this._transform = i;
            }
            get state() {
                const t1 = this._transform, i = "globe" === t1.projection.name, o = e1.globeToMercatorTransition(t1.zoom), r = this.properties.get("range"), n = [
                    .5,
                    3
                ];
                return {
                    range: i ? [
                        e1.number(n[0], r[0], o),
                        e1.number(n[1], r[1], o)
                    ] : r,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i = {}) {
                if (!this._validate(e1.validateFog, t1, i)) {
                    for (const i of Object.keys(e1.spec.fog))t1 && void 0 === t1[i] && (t1[i] = e1.spec.fog[i].default);
                    for(const i in t1){
                        const o = t1[i];
                        e1.endsWith(i, L) ? this._transitionable.setTransition(i.slice(0, -L.length), o) : this._transitionable.setValue(i, o);
                    }
                }
            }
            getOpacity(t1) {
                if (!this._transform.projection.supportsFog) return 0;
                const i = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : e1.smoothstep(45, 65, t1)) * i.a;
            }
            getOpacityAtLatLng(t1, i) {
                return this._transform.projection.supportsFog ? function(t1, i, o) {
                    const r = e1.MercatorCoordinate.fromLngLat(i), n = o.elevation ? o.elevation.getAtPointOrZero(r) : 0, s = [
                        r.x,
                        r.y,
                        n
                    ];
                    return e1.transformMat4(s, s, o.mercatorFogMatrix), I(t1, s, o.pitch, o._fov);
                }(this.state, t1, i) : 0;
            }
            getFovAdjustedRange(e1) {
                return this._transform.projection.supportsFog ? S(this.state, e1) : [
                    0,
                    1
                ];
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && e1.emitValidationErrors(this, t1.call(e1.validateStyle, e1.extend({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.spec
                })));
            }
        }
        class z {
            constructor(t1, i){
                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = e1.uniqueId();
                const o = this.workerPool.acquire(this.id);
                for(let e1 = 0; e1 < o.length; e1++){
                    const t1 = new z.Actor(o[e1], i, this.id);
                    t1.name = `Worker ${e1}`, this.actors.push(t1);
                }
                this.ready = !1, this.broadcast("checkIfReady", null, ()=>{
                    this.ready = !0;
                });
            }
            broadcast(t1, i, o) {
                e1.asyncAll(this.actors, (e1, o)=>{
                    e1.send(t1, i, o);
                }, o = o || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((e1)=>{
                    e1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
        }
        function P(t1, i, o) {
            return i * (e1.EXTENT / (t1.tileSize * Math.pow(2, o - t1.tileID.overscaledZ)));
        }
        z.Actor = e1.Actor;
        class R {
            constructor(e1, t1, i, o){
                this.screenBounds = e1, this.cameraPoint = t1, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, o);
            }
            static createFromScreenPoints(t1, i) {
                let o, r;
                if (t1 instanceof e1.pointGeometry || "number" == typeof t1[0]) {
                    const n = e1.pointGeometry.convert(t1);
                    o = [
                        n
                    ], r = i.isPointAboveHorizon(n);
                } else {
                    const n = e1.pointGeometry.convert(t1[0]), s = e1.pointGeometry.convert(t1[1]);
                    o = [
                        n,
                        s
                    ], r = e1.polygonizeBounds(n, s).every((e1)=>i.isPointAboveHorizon(e1));
                }
                return new R(o, i.getCameraPoint(), r, i);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t1) {
                return e1.polygonizeBounds(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t1);
            }
            bufferedCameraGeometry(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.pointGeometry(1, 1)) : this.screenBounds[1], r = e1.polygonizeBounds(i, o, 0, !1);
                return this.cameraPoint.y > o.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < o.x ? r.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o.x ? r[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (r[3] = this.cameraPoint)), e1.bufferConvexPolygon(r, t1);
            }
            bufferedCameraGeometryGlobe(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.pointGeometry(1, 1)) : this.screenBounds[1], r = e1.polygonizeBounds(i, o, t1), n = this.cameraPoint.clone();
                switch(3 * ((n.y > i.y) + (n.y > o.y)) + ((n.x > i.x) + (n.x > o.x))){
                    case 0:
                        r[0] = n, r[4] = n.clone();
                        break;
                    case 1:
                        r.splice(1, 0, n);
                        break;
                    case 2:
                        r[1] = n;
                        break;
                    case 3:
                        r.splice(4, 0, n);
                        break;
                    case 5:
                        r.splice(2, 0, n);
                        break;
                    case 6:
                        r[3] = n;
                        break;
                    case 7:
                        r.splice(3, 0, n);
                        break;
                    case 8:
                        r[2] = n;
                }
                return r;
            }
            containsTile(t1, i, o, r = 0) {
                const n = t1.queryPadding / i._pixelsPerMercatorPixel + 1, s = o ? this._bufferedCameraMercator(n, i) : this._bufferedScreenMercator(n, i);
                let a = t1.tileID.wrap + (s.unwrapped ? r : 0);
                const l = s.polygon.map((i)=>e1.getTilePoint(t1.tileTransform, i, a));
                if (!e1.polygonIntersectsBox(l, 0, 0, e1.EXTENT, e1.EXTENT)) return;
                a = t1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r : 0);
                const c = this.screenGeometryMercator.polygon.map((i)=>e1.getTileVec3(t1.tileTransform, i, a)), h = c.map((t1)=>new e1.pointGeometry(t1[0], t1[1])), u = i.getFreeCameraOptions().position || new e1.MercatorCoordinate(0, 0, 0), _ = e1.getTileVec3(t1.tileTransform, u, a), d = c.map((t1)=>{
                    const i = e1.sub(t1, t1, _);
                    return e1.normalize(i, i), new e1.Ray(_, i);
                }), p = P(t1, 1, i.zoom) * i._pixelsPerMercatorPixel;
                var m;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: h,
                    tilespaceRays: d,
                    bufferedTilespaceGeometry: l,
                    bufferedTilespaceBounds: (m = e1.getBounds(l), m.min.x = e1.clamp(m.min.x, 0, e1.EXTENT), m.min.y = e1.clamp(m.min.y, 0, e1.EXTENT), m.max.x = e1.clamp(m.max.x, 0, e1.EXTENT), m.max.y = e1.clamp(m.max.y, 0, e1.EXTENT), m),
                    tile: t1,
                    tileID: t1.tileID,
                    pixelToTileUnitsFactor: p
                };
            }
            _bufferedScreenMercator(e1, t1) {
                const i = k(e1);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e1), t1) : {
                        polygon: this.bufferedScreenGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = o, o;
                }
            }
            _bufferedCameraMercator(e1, t1) {
                const i = k(e1);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e1), t1) : {
                        polygon: this.bufferedCameraGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = o, o;
                }
            }
            _projectAndResample(t1, i) {
                const o = function(t1, i) {
                    const o = e1.multiply([], i.pixelMatrix, i.globeMatrix), r = [
                        0,
                        -e1.GLOBE_RADIUS,
                        0,
                        1
                    ], n = [
                        0,
                        e1.GLOBE_RADIUS,
                        0,
                        1
                    ], s = [
                        0,
                        0,
                        0,
                        1
                    ];
                    e1.transformMat4$1(r, r, o), e1.transformMat4$1(n, n, o), e1.transformMat4$1(s, s, o);
                    const a = new e1.pointGeometry(r[0] / r[3], r[1] / r[3]), l = new e1.pointGeometry(n[0] / n[3], n[1] / n[3]), c = e1.polygonContainsPoint(t1, a) && r[3] < s[3], h = e1.polygonContainsPoint(t1, l) && n[3] < s[3];
                    if (!c && !h) return null;
                    const u = function(e1, t1, i) {
                        for(let o = 1; o < e1.length; o++){
                            const r = B(t1.pointCoordinate3D(e1[o - 1]).x), n = B(t1.pointCoordinate3D(e1[o]).x);
                            if (i < 0) {
                                if (r < n) return {
                                    idx: o,
                                    t: -r / (n - 1 - r)
                                };
                            } else if (n < r) return {
                                idx: o,
                                t: (1 - r) / (n + 1 - r)
                            };
                        }
                        return null;
                    }(t1, i, c ? -1 : 1);
                    if (!u) return null;
                    const { idx: _, t: d } = u;
                    let p = _ > 1 ? O(t1.slice(0, _), i) : [], m = _ < t1.length ? O(t1.slice(_), i) : [];
                    p = p.map((t1)=>new e1.pointGeometry(B(t1.x), t1.y)), m = m.map((t1)=>new e1.pointGeometry(B(t1.x), t1.y));
                    const f = [
                        ...p
                    ];
                    0 === f.length && f.push(m[m.length - 1]);
                    const g = e1.number(f[f.length - 1].y, (0 === m.length ? p[0] : m[0]).y, d);
                    let v;
                    return v = c ? [
                        new e1.pointGeometry(0, g),
                        new e1.pointGeometry(0, 0),
                        new e1.pointGeometry(1, 0),
                        new e1.pointGeometry(1, g)
                    ] : [
                        new e1.pointGeometry(1, g),
                        new e1.pointGeometry(1, 1),
                        new e1.pointGeometry(0, 1),
                        new e1.pointGeometry(0, g)
                    ], f.push(...v), 0 === m.length ? f.push(p[0]) : f.push(...m), {
                        polygon: f.map((t1)=>new e1.MercatorCoordinate(t1.x, t1.y)),
                        unwrapped: !1
                    };
                }(t1, i);
                if (o) return o;
                const r = function(t1, i) {
                    let o = !1, r = -1 / 0, n = 0;
                    for(let e1 = 0; e1 < t1.length - 1; e1++)t1[e1].x > r && (r = t1[e1].x, n = e1);
                    for(let e1 = 0; e1 < t1.length - 1; e1++){
                        const i = (n + e1) % (t1.length - 1), r = t1[i], s = t1[i + 1];
                        Math.abs(r.x - s.x) > .5 && (r.x < s.x ? (r.x += 1, 0 === i && (t1[t1.length - 1].x += 1)) : (s.x += 1, i + 1 === t1.length - 1 && (t1[0].x += 1)), o = !0);
                    }
                    const s = e1.mercatorXfromLng(i.center.lng);
                    return o && s < Math.abs(s - 1) && t1.forEach((e1)=>{
                        e1.x -= 1;
                    }), {
                        polygon: t1,
                        unwrapped: o
                    };
                }(O(t1, i).map((t1)=>new e1.pointGeometry(B(t1.x), t1.y)), i);
                return {
                    polygon: r.polygon.map((t1)=>new e1.MercatorCoordinate(t1.x, t1.y)),
                    unwrapped: r.unwrapped
                };
            }
        }
        function O(t1, i) {
            return e1.resample(t1, (e1)=>{
                const t1 = i.pointCoordinate3D(e1);
                e1.x = t1.x, e1.y = t1.y;
            }, 1 / 256);
        }
        function B(e1) {
            return e1 < 0 ? 1 + e1 % 1 : e1 % 1;
        }
        function k(e1) {
            return 100 * e1 | 0;
        }
        function F(t1, i, o, r, n) {
            const s = function(o, r) {
                if (o) return n(o);
                if (r) {
                    t1.url && r.tiles && t1.tiles && delete t1.tiles;
                    const o = e1.pick(e1.extend(r, t1), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    r.vector_layers && (o.vectorLayers = r.vector_layers, o.vectorLayerIds = o.vectorLayers.map((e1)=>e1.id)), o.tiles = i.canonicalizeTileset(o, t1.url), n(null, o);
                }
            };
            return t1.url ? e1.getJSON(i.transformRequest(i.normalizeSourceURL(t1.url, null, o, r), e1.ResourceType.Source), s) : e1.exported.frame(()=>s(null, t1));
        }
        class U {
            constructor(t1, i, o){
                this.bounds = e1.LngLatBounds.convert(this.validateBounds(t1)), this.minzoom = i || 0, this.maxzoom = o || 24;
            }
            validateBounds(e1) {
                return Array.isArray(e1) && 4 === e1.length ? [
                    Math.max(-180, e1[0]),
                    Math.max(-90, e1[1]),
                    Math.min(180, e1[2]),
                    Math.min(90, e1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(t1) {
                const i = Math.pow(2, t1.z), o = Math.floor(e1.mercatorXfromLng(this.bounds.getWest()) * i), r = Math.floor(e1.mercatorYfromLat(this.bounds.getNorth()) * i), n = Math.ceil(e1.mercatorXfromLng(this.bounds.getEast()) * i), s = Math.ceil(e1.mercatorYfromLat(this.bounds.getSouth()) * i);
                return t1.x >= o && t1.x < n && t1.y >= r && t1.y < s;
            }
        }
        class N {
            constructor(e1, t1, i){
                this.context = e1;
                const o = e1.gl;
                this.buffer = o.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), o.bufferData(o.ELEMENT_ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? o.DYNAMIC_DRAW : o.STATIC_DRAW), this.dynamicDraw || t1.destroy();
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t1 = this.context.gl;
                this.context.unbindVAO(), this.bind(), t1.bufferSubData(t1.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const G = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class j {
            constructor(e1, t1, i, o){
                this.length = t1.length, this.attributes = i, this.itemSize = t1.bytesPerElement, this.dynamicDraw = o, this.context = e1;
                const r = e1.gl;
                this.buffer = r.createBuffer(), e1.bindVertexBuffer.set(this.buffer), r.bufferData(r.ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || t1.destroy();
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t1 = this.context.gl;
                this.bind(), t1.bufferSubData(t1.ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            enableAttributes(e1, t1) {
                for(let i = 0; i < this.attributes.length; i++){
                    const o = t1.attributes[this.attributes[i].name];
                    void 0 !== o && e1.enableVertexAttribArray(o);
                }
            }
            setVertexAttribPointers(e1, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const r = this.attributes[o], n = t1.attributes[r.name];
                    void 0 !== n && e1.vertexAttribPointer(n, r.components, e1[G[r.type]], !1, this.itemSize, r.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class Z {
            constructor(e1){
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class V extends Z {
            getDefault() {
                return e1.Color.transparent;
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class W extends Z {
            getDefault() {
                return 1;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
            }
        }
        class X extends Z {
            getDefault() {
                return 0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
            }
        }
        class q extends Z {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class $ extends Z {
            getDefault() {
                return !0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class H extends Z {
            getDefault() {
                return 255;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Y extends Z {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e1) {
                const t1 = this.current;
                (e1.func !== t1.func || e1.ref !== t1.ref || e1.mask !== t1.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
            }
        }
        class K extends Z {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.KEEP,
                    e1.KEEP,
                    e1.KEEP
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
            }
        }
        class J extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.STENCIL_TEST) : t1.disable(t1.STENCIL_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Q extends Z {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class ee extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.DEPTH_TEST) : t1.disable(t1.DEPTH_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class te extends Z {
            getDefault() {
                return this.gl.LESS;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ie extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.BLEND) : t1.disable(t1.BLEND), this.current = e1, this.dirty = !1;
            }
        }
        class oe extends Z {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.ONE,
                    e1.ZERO
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || this.dirty) && (this.gl.blendFunc(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class re extends Z {
            getDefault() {
                return e1.Color.transparent;
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class ne extends Z {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.blendEquation(e1), this.current = e1, this.dirty = !1);
            }
        }
        class se extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.CULL_FACE) : t1.disable(t1.CULL_FACE), this.current = e1, this.dirty = !1;
            }
        }
        class ae extends Z {
            getDefault() {
                return this.gl.BACK;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class le extends Z {
            getDefault() {
                return this.gl.CCW;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ce extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
            }
        }
        class he extends Z {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ue extends Z {
            getDefault() {
                const e1 = this.gl;
                return [
                    0,
                    0,
                    e1.drawingBufferWidth,
                    e1.drawingBufferHeight
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class _e extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindFramebuffer(t1.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class de extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindRenderbuffer(t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class pe extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindTexture(t1.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
            }
        }
        class me extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindBuffer(t1.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class fe extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                const t1 = this.gl;
                t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class ge extends Z {
            constructor(e1){
                super(e1), this.vao = e1.extVertexArrayObject;
            }
            getDefault() {
                return null;
            }
            set(e1) {
                this.vao && (e1 !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ve extends Z {
            getDefault() {
                return 4;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
            }
        }
        class xe extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class ye extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class be extends Z {
            constructor(e1, t1){
                super(e1), this.context = e1, this.parent = t1;
            }
            getDefault() {
                return null;
            }
        }
        class we extends be {
            setDirty() {
                this.dirty = !0;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class Te extends be {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferRenderbuffer(t1.FRAMEBUFFER, this.attachment(), t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Ee extends Te {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        class Ce {
            constructor(e1, t1, i, o){
                this.context = e1, this.width = t1, this.height = i;
                const r = this.framebuffer = e1.gl.createFramebuffer();
                this.colorAttachment = new we(e1, r), o && (this.depthAttachment = new Te(e1, r));
            }
            destroy() {
                const e1 = this.context.gl, t1 = this.colorAttachment.get();
                if (t1 && e1.deleteTexture(t1), this.depthAttachment) {
                    const t1 = this.depthAttachment.get();
                    t1 && e1.deleteRenderbuffer(t1);
                }
                e1.deleteFramebuffer(this.framebuffer);
            }
        }
        class Me {
            constructor(e1, t1 = !1){
                if (this.gl = e1, this.isWebGL2 = t1, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), t1) {
                    const t1 = e1;
                    this.extVertexArrayObject = {
                        createVertexArrayOES: t1.createVertexArray.bind(e1),
                        deleteVertexArrayOES: t1.deleteVertexArray.bind(e1),
                        bindVertexArrayOES: t1.bindVertexArray.bind(e1)
                    };
                }
                this.clearColor = new V(this), this.clearDepth = new W(this), this.clearStencil = new X(this), this.colorMask = new q(this), this.depthMask = new $(this), this.stencilMask = new H(this), this.stencilFunc = new Y(this), this.stencilOp = new K(this), this.stencilTest = new J(this), this.depthRange = new Q(this), this.depthTest = new ee(this), this.depthFunc = new te(this), this.blend = new ie(this), this.blendFunc = new oe(this), this.blendColor = new re(this), this.blendEquation = new ne(this), this.cullFace = new se(this), this.cullFaceSide = new ae(this), this.frontFace = new le(this), this.program = new ce(this), this.activeTexture = new he(this), this.viewport = new ue(this), this.bindFramebuffer = new _e(this), this.bindRenderbuffer = new de(this), this.bindTexture = new pe(this), this.bindVertexBuffer = new me(this), this.bindElementBuffer = new fe(this), this.bindVertexArrayOES = this.extVertexArrayObject && new ge(this), this.pixelStoreUnpack = new ve(this), this.pixelStoreUnpackPremultiplyAlpha = new xe(this), this.pixelStoreUnpackFlipY = new ye(this), this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureFilterAnisotropicForceOff = !1, this.extStandardDerivativesForceOff = !1, this.extDebugRendererInfo = e1.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e1.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e1.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), t1 || (this.extTextureHalfFloat = e1.getExtension("OES_texture_half_float")), (t1 || this.extTextureHalfFloat && e1.getExtension("OES_texture_half_float_linear")) && (this.extRenderToTextureHalfFloat = e1.getExtension("EXT_color_buffer_half_float")), this.extStandardDerivatives = t1 || e1.getExtension("OES_standard_derivatives"), this.extTimerQuery = e1.getExtension("EXT_disjoint_timer_query"), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE);
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0), this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e1, t1) {
                return new N(this, e1, t1);
            }
            createVertexBuffer(e1, t1, i) {
                return new j(this, e1, t1, i);
            }
            createRenderbuffer(e1, t1, i) {
                const o = this.gl, r = o.createRenderbuffer();
                return this.bindRenderbuffer.set(r), o.renderbufferStorage(o.RENDERBUFFER, e1, t1, i), this.bindRenderbuffer.set(null), r;
            }
            createFramebuffer(e1, t1, i) {
                return new Ce(this, e1, t1, i);
            }
            clear({ color: e1, depth: t1, stencil: i }) {
                const o = this.gl;
                let r = 0;
                e1 && (r |= o.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t1 && (r |= o.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t1), this.depthMask.set(!0)), void 0 !== i && (r |= o.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), o.clear(r);
            }
            setCullFace(e1) {
                !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
            }
            setDepthMode(e1) {
                e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e1) {
                e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                    e1.fail,
                    e1.depthFail,
                    e1.pass
                ]), this.stencilFunc.set({
                    func: e1.test.func,
                    ref: e1.ref,
                    mask: e1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(i) {
                t1(i.blendFunction, e1.ColorMode.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(i.blendFunction), this.blendColor.set(i.blendColor)), this.colorMask.set(i.mask);
            }
            unbindVAO() {
                this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
            }
        }
        class Ie extends e1.Evented {
            constructor(t1, i, o, r){
                if (super(), this.id = t1, this.dispatcher = o, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, e1.extend(this, e1.pick(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = e1.extend({
                    type: "vector"
                }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(r), this._tileWorkers = {}, this._deduped = new e1.DedupedRequest;
            }
            load(t1) {
                this._loaded = !1, this.fire(new e1.Event("dataloading", {
                    dataType: "source"
                }));
                const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map._worldview;
                this._tileJSONRequest = F(this._options, this.map._requestManager, i, o, (r, n)=>{
                    this._tileJSONRequest = null, this._loaded = !0, r ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && 2 !== o.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e1.ErrorEvent(r))) : n && (e1.extend(this, n), n.bounds && (this.tileBounds = new U(n.bounds, this.minzoom, this.maxzoom)), e1.postTurnstileEvent(n.tiles, this.map._requestManager._customAccessToken), this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(r);
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest(), this.load(()=>this.map.style._clearSource(this.id));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove() {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return e1.extend({}, this._options);
            }
            loadTile(t1, i) {
                const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                    request: this.map._requestManager.transformRequest(o, e1.ResourceType.Tile),
                    data: void 0,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    tileZoom: t1.tileZoom,
                    zoom: t1.tileID.overscaledZ,
                    tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    pixelRatio: e1.exported.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId,
                    isSymbolTile: t1.isSymbolTile
                };
                if (r.request.collectResourceTiming = this._collectResourceTiming, t1.actor && "expired" !== t1.state) "loading" === t1.state ? t1.reloadCallback = i : t1.request = t1.actor.send("reloadTile", r, n.bind(this));
                else if (t1.actor = this._tileWorkers[o] = this._tileWorkers[o] || this.dispatcher.getActor(), this.dispatcher.ready) t1.request = t1.actor.send("loadTile", r, n.bind(this), void 0, !0);
                else {
                    const i = e1.loadVectorTile.call({
                        deduped: this._deduped
                    }, r, (e1, i)=>{
                        e1 || !i ? n.call(this, e1) : (r.data = {
                            cacheControl: i.cacheControl,
                            expires: i.expires,
                            rawData: i.rawData.slice(0)
                        }, t1.actor && t1.actor.send("loadTile", r, n.bind(this), void 0, !0));
                    }, !0);
                    t1.request = {
                        cancel: i
                    };
                }
                function n(o, r) {
                    return delete t1.request, t1.aborted ? i(null) : o && 404 !== o.status ? i(o) : (r && r.resourceTiming && (t1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && r && t1.setExpiryData(r), t1.loadVectorData(r, this.map.painter), e1.cacheEntryPossiblyAdded(this.dispatcher), i(null), void (t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null)));
                }
            }
            abortTile(e1) {
                e1.request && (e1.request.cancel(), delete e1.request), e1.actor && e1.actor.send("abortTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id
                });
            }
            unloadTile(e1) {
                e1.unloadVectorData(), e1.actor && e1.actor.send("removeTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id
                });
            }
            hasTransition() {
                return !1;
            }
            afterUpdate() {
                this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        class Se extends e1.Evented {
            constructor(t1, i, o, r){
                super(), this.id = t1, this.dispatcher = o, this.setEventedParent(r), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = e1.extend({
                    type: "raster"
                }, i), e1.extend(this, e1.pick(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load(t1) {
                this._loaded = !1, this.fire(new e1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = F(this._options, this.map._requestManager, null, null, (i, o)=>{
                    this._tileJSONRequest = null, this._loaded = !0, i ? this.fire(new e1.ErrorEvent(i)) : o && (e1.extend(this, o), o.bounds && (this.tileBounds = new U(o.bounds, this.minzoom, this.maxzoom)), e1.postTurnstileEvent(o.tiles), this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(i);
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest(), this.load(()=>this.map.style._clearSource(this.id));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove() {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return e1.extend({}, this._options);
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            loadTile(t1, i) {
                const o = e1.exported.devicePixelRatio >= 2, r = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), o, this.tileSize);
                t1.request = e1.getImage(this.map._requestManager.transformRequest(r, e1.ResourceType.Tile), (o, r, n, s)=>(delete t1.request, t1.aborted ? (t1.state = "unloaded", i(null)) : o ? (t1.state = "errored", i(o)) : r ? (this.map._refreshExpiredTiles && t1.setExpiryData({
                        cacheControl: n,
                        expires: s
                    }), t1.setTexture(r, this.map.painter), t1.state = "loaded", e1.cacheEntryPossiblyAdded(this.dispatcher), void i(null)) : i(null)));
            }
            static loadTileData(e1, t1, i) {
                e1.setTexture(t1, i);
            }
            static unloadTileData(e1, t1) {
                e1.texture && t1.saveTileTexture(e1.texture);
            }
            abortTile(e1, t1) {
                e1.request && (e1.request.cancel(), delete e1.request), t1();
            }
            unloadTile(e1, t1) {
                e1.texture && this.map.painter.saveTileTexture(e1.texture), t1();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        let De;
        function Le(t1, i, o, r, n, s, a, l) {
            const c = [
                t1,
                o,
                n,
                i,
                r,
                s,
                1,
                1,
                1
            ], h = [
                a,
                l,
                1
            ], u = e1.adjoint([], c), [_, d, p] = e1.transformMat3(h, h, e1.transpose(u, u));
            return e1.multiply$1(c, [
                _,
                0,
                0,
                0,
                d,
                0,
                0,
                0,
                p
            ], c);
        }
        class Ae extends e1.Evented {
            constructor(e1, t1, i, o){
                super(), this.id = e1, this.dispatcher = i, this.coordinates = t1.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(o), this.options = t1, this._dirty = !1;
            }
            load(t1, i) {
                this._loaded = i || !1, this.fire(new e1.Event("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, this._imageRequest = e1.getImage(this.map._requestManager.transformRequest(this.url, e1.ResourceType.Image), (i, o)=>{
                    if (this._imageRequest = null, this._loaded = !0, i) this.fire(new e1.ErrorEvent(i));
                    else if (o) {
                        const { HTMLImageElement: i } = e1.window;
                        this.image = o instanceof i ? e1.exported.getImageData(o) : o, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, t1 && (this.coordinates = t1), this._finishLoading();
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e1) {
                return this.image && e1.url ? (this._imageRequest && e1.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = e1.url, this.load(e1.coordinates, this._loaded), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new e1.Event("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove() {
                this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), this.texture && this.texture.destroy();
            }
            setCoordinates(t1) {
                this.coordinates = t1, this._boundsArray = void 0;
                const i = t1.map(e1.MercatorCoordinate.fromLngLat);
                return this.tileID = function(t1) {
                    let i = 1 / 0, o = 1 / 0, r = -1 / 0, n = -1 / 0;
                    for (const e1 of t1)i = Math.min(i, e1.x), o = Math.min(o, e1.y), r = Math.max(r, e1.x), n = Math.max(n, e1.y);
                    const s = Math.max(r - i, n - o), a = Math.max(0, Math.floor(-Math.log(s) / Math.LN2)), l = Math.pow(2, a);
                    return new e1.CanonicalTileID(a, Math.floor((i + r) / 2 * l), Math.floor((o + n) / 2 * l));
                }(i), this.minzoom = this.maxzoom = this.tileID.z, this.fire(new e1.Event("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                this._boundsArray = void 0;
            }
            _prepareData(t1) {
                for(const e1 in this.tiles){
                    const t1 = this.tiles[e1];
                    "loaded" !== t1.state && (t1.state = "loaded", t1.texture = this.texture);
                }
                if (this._boundsArray) return;
                const i = e1.tileTransform(this.tileID, this.map.transform.projection), [o, r, n, s] = this.coordinates.map((t1)=>{
                    const o = i.projection.project(t1[0], t1[1]);
                    return e1.getTilePoint(i, o)._round();
                });
                this.perspectiveTransform = function(t1, i, o, r, n, s, a, l, c, h) {
                    const u = Le(0, 0, t1, 0, 0, i, t1, i), _ = Le(o, r, n, s, a, l, c, h);
                    return e1.multiply$1(_, e1.adjoint(u, u), _), [
                        _[6] / _[8] * t1 / e1.EXTENT,
                        _[7] / _[8] * i / e1.EXTENT
                    ];
                }(this.width, this.height, o.x, o.y, r.x, r.y, s.x, s.y, n.x, n.y);
                const a = this._boundsArray = new e1.StructArrayLayout4i8;
                a.emplaceBack(o.x, o.y, 0, 0), a.emplaceBack(r.x, r.y, e1.EXTENT, 0), a.emplaceBack(s.x, s.y, 0, e1.EXTENT), a.emplaceBack(n.x, n.y, e1.EXTENT, e1.EXTENT), this.boundsBuffer && this.boundsBuffer.destroy(), this.boundsBuffer = t1.createVertexBuffer(a, e1.boundsAttributes.members), this.boundsSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || !this.image) return;
                const t1 = this.map.painter.context, i = t1.gl;
                this._dirty && (this.texture ? this.texture.update(this.image) : (this.texture = new e1.Texture(t1, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)), this._dirty = !1), this._prepareData(t1);
            }
            loadTile(e1, t1) {
                this.tileID && this.tileID.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}, t1(null)) : (e1.state = "errored", t1(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
        }
        const ze = {
            vector: Ie,
            raster: Se,
            "raster-dem": class extends Se {
                constructor(t1, i, o, r){
                    super(t1, i, o, r), this.type = "raster-dem", this.maxzoom = 22, this._options = e1.extend({
                        type: "raster-dem"
                    }, i), this.encoding = i.encoding || "mapbox";
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    function r(e1, o) {
                        e1 && (t1.state = "errored", i(e1)), o && (t1.dem = o, t1.dem.onDeserialize(), t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0, t1.state = "loaded", i(null));
                    }
                    t1.request = e1.getImage(this.map._requestManager.transformRequest(o, e1.ResourceType.Tile), (function(o, n, s, a) {
                        if (delete t1.request, t1.aborted) t1.state = "unloaded", i(null);
                        else if (o) t1.state = "errored", i(o);
                        else if (n) {
                            this.map._refreshExpiredTiles && t1.setExpiryData({
                                cacheControl: s,
                                expires: a
                            });
                            const i = e1.window.ImageBitmap && n instanceof e1.window.ImageBitmap && (null == De && (De = e1.window.OffscreenCanvas && new e1.window.OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof e1.window.createImageBitmap), De), o = 1 - (n.width - e1.prevPowerOfTwo(n.width)) / 2;
                            o < 1 || t1.neighboringTiles || (t1.neighboringTiles = this._getNeighboringTiles(t1.tileID));
                            const l = i ? n : e1.exported.getImageData(n, o), c = {
                                uid: t1.uid,
                                coord: t1.tileID,
                                source: this.id,
                                rawImageData: l,
                                encoding: this.encoding,
                                padding: o
                            };
                            t1.actor && "expired" !== t1.state || (t1.actor = this.dispatcher.getActor(), t1.actor.send("loadDEMTile", c, r.bind(this), void 0, !0));
                        }
                    }).bind(this));
                }
                _getNeighboringTiles(t1) {
                    const i = t1.canonical, o = Math.pow(2, i.z), r = (i.x - 1 + o) % o, n = 0 === i.x ? t1.wrap - 1 : t1.wrap, s = (i.x + 1 + o) % o, a = i.x + 1 === o ? t1.wrap + 1 : t1.wrap, l = {};
                    return l[new e1.OverscaledTileID(t1.overscaledZ, n, i.z, r, i.y).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, a, i.z, s, i.y).key] = {
                        backfilled: !1
                    }, i.y > 0 && (l[new e1.OverscaledTileID(t1.overscaledZ, n, i.z, r, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, t1.wrap, i.z, i.x, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, a, i.z, s, i.y - 1).key] = {
                        backfilled: !1
                    }), i.y + 1 < o && (l[new e1.OverscaledTileID(t1.overscaledZ, n, i.z, r, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, t1.wrap, i.z, i.x, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, a, i.z, s, i.y + 1).key] = {
                        backfilled: !1
                    }), l;
                }
                unloadTile(e1) {
                    e1.demTexture && this.map.painter.saveTileTexture(e1.demTexture), e1.fbo && (e1.fbo.destroy(), delete e1.fbo), e1.dem && delete e1.dem, delete e1.neighboringTiles, e1.state = "unloaded";
                }
            },
            geojson: class extends e1.Evented {
                constructor(t1, i, o, r){
                    super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = o.getActor(), this.setEventedParent(r), this._data = i.data, this._options = e1.extend({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                    const n = e1.EXTENT / this.tileSize;
                    this.workerOptions = e1.extend({
                        source: this.id,
                        cluster: i.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== i.buffer ? i.buffer : 128) * n,
                            tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * n,
                            extent: e1.EXTENT,
                            maxZoom: this.maxzoom,
                            lineMetrics: i.lineMetrics || !1,
                            generateId: i.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: e1.EXTENT,
                            radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * n,
                            log: !1,
                            generateId: i.generateId || !1
                        },
                        clusterProperties: i.clusterProperties,
                        filter: i.filter
                    }, i.workerOptions);
                }
                onAdd(e1) {
                    this.map = e1, this.setData(this._data);
                }
                setData(e1) {
                    return this._data = e1, this._updateWorkerData(), this;
                }
                getClusterExpansionZoom(e1, t1) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e1,
                        source: this.id
                    }, t1), this;
                }
                getClusterChildren(e1, t1) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e1,
                        source: this.id
                    }, t1), this;
                }
                getClusterLeaves(e1, t1, i, o) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        clusterId: e1,
                        limit: t1,
                        offset: i
                    }, o), this;
                }
                _updateWorkerData() {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new e1.Event("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const t1 = e1.extend({}, this.workerOptions), i = this._data;
                    "string" == typeof i ? (t1.request = this.map._requestManager.transformRequest(e1.exported.resolveURL(i), e1.ResourceType.Source), t1.request.collectResourceTiming = this._collectResourceTiming) : t1.data = JSON.stringify(i), this._pendingLoad = this.actor.send(`${this.type}.loadData`, t1, (t1, i)=>{
                        if (this._loaded = !0, this._pendingLoad = null, t1) this.fire(new e1.ErrorEvent(t1));
                        else {
                            const t1 = {
                                dataType: "source",
                                sourceDataType: this._metadataFired ? "content" : "metadata"
                            };
                            this._collectResourceTiming && i && i.resourceTiming && i.resourceTiming[this.id] && (t1.resourceTiming = i.resourceTiming[this.id]), this.fire(new e1.Event("data", t1)), this._metadataFired = !0;
                        }
                        this._coalesce && (this._updateWorkerData(), this._coalesce = !1);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(t1, i) {
                    const o = t1.actor ? "reloadTile" : "loadTile";
                    t1.actor = this.actor, t1.request = this.actor.send(o, {
                        type: this.type,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        pixelRatio: e1.exported.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId
                    }, (e1, r)=>(delete t1.request, t1.unloadVectorData(), t1.aborted ? i(null) : e1 ? i(e1) : (t1.loadVectorData(r, this.map.painter, "reloadTile" === o), i(null))), void 0, "loadTile" === o);
                }
                abortTile(e1) {
                    e1.request && (e1.request.cancel(), delete e1.request), e1.aborted = !0;
                }
                unloadTile(e1) {
                    e1.unloadVectorData(), this.actor.send("removeTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id
                    });
                }
                onRemove() {
                    this._pendingLoad && this._pendingLoad.cancel();
                }
                serialize() {
                    return e1.extend({}, this._options, {
                        type: this.type,
                        data: this._data
                    });
                }
                hasTransition() {
                    return !1;
                }
            },
            video: class extends Ae {
                constructor(e1, t1, i, o){
                    super(e1, t1, i, o), this.roundZoom = !0, this.type = "video", this.options = t1;
                }
                load() {
                    this._loaded = !1;
                    const t1 = this.options;
                    this.urls = [];
                    for (const i of t1.urls)this.urls.push(this.map._requestManager.transformRequest(i, e1.ResourceType.Source).url);
                    e1.getVideo(this.urls, (t1, i)=>{
                        this._loaded = !0, t1 ? this.fire(new e1.ErrorEvent(t1)) : i && (this.video = i, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(t1) {
                    if (this.video) {
                        const i = this.video.seekable;
                        t1 < i.start(0) || t1 > i.end(0) ? this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e1) {
                    this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const t1 = this.map.painter.context, i = t1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e1.Texture(t1, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
            },
            image: Ae,
            canvas: class extends Ae {
                constructor(t1, i, o, r){
                    super(t1, i, o, r), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1)) || this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof e1.window.HTMLCanvasElement || this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
                load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof e1.window.HTMLCanvasElement ? this.options.canvas : e1.window.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e1.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e1) {
                    this.map = e1, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove() {
                    this.pause();
                }
                prepare() {
                    let t1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context;
                    this.texture ? (t1 || this._playing) && this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new e1.Texture(i, this.canvas, i.gl.RGBA, {
                        premultiply: !0
                    }), this._prepareData(i);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e1 of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e1) || e1 <= 0) return !0;
                    return !1;
                }
            },
            custom: class extends e1.Evented {
                constructor(t1, i, o, r){
                    super(), this.id = t1, this.type = "custom", this._dataType = "raster", this._dispatcher = o, this._implementation = i, this.setEventedParent(r), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new e1.ErrorEvent(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e1.ErrorEvent(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new U(this._implementation.bounds, this.minzoom, this.maxzoom)), i.update = this._update.bind(this), i.clearTiles = this._clearTiles.bind(this), i.coveringTiles = this._coveringTiles.bind(this), e1.extend(this, e1.pick(i, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
                serialize() {
                    return e1.pick(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(t1) {
                    this._map = t1, this._loaded = !1, this.fire(new e1.Event("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(t1), this.load();
                }
                onRemove(e1) {
                    this._implementation.onRemove && this._implementation.onRemove(e1);
                }
                hasTile(e1) {
                    if (this._implementation.hasTile) {
                        const { x: t1, y: i, z: o } = e1.canonical;
                        return this._implementation.hasTile({
                            x: t1,
                            y: i,
                            z: o
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loadTile(t1, i) {
                    const { x: o, y: r, z: n } = t1.tileID.canonical, s = new e1.window.AbortController;
                    t1.request = Promise.resolve(this._implementation.loadTile({
                        x: o,
                        y: r,
                        z: n
                    }, {
                        signal: s.signal
                    })).then((function(o) {
                        return delete t1.request, t1.aborted ? (t1.state = "unloaded", i(null)) : void 0 === o ? (t1.state = "errored", i(null)) : null === o ? (this.loadTileData(t1, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), t1.state = "loaded", i(null)) : function(t1) {
                            return t1 instanceof e1.window.ImageData || t1 instanceof e1.window.HTMLCanvasElement || t1 instanceof e1.window.ImageBitmap || t1 instanceof e1.window.HTMLImageElement;
                        }(o) ? (this.loadTileData(t1, o), t1.state = "loaded", void i(null)) : (t1.state = "errored", i(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
                    }).bind(this)).catch((e1)=>{
                        20 !== e1.code && (t1.state = "errored", i(e1));
                    }), t1.request.cancel = ()=>s.abort();
                }
                loadTileData(e1, t1) {
                    Se.loadTileData(e1, t1, this._map.painter);
                }
                unloadTileData(e1) {
                    Se.unloadTileData(e1, this._map.painter);
                }
                unloadTile(e1, t1) {
                    if (this.unloadTileData(e1), this._implementation.unloadTile) {
                        const { x: t1, y: i, z: o } = e1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: t1,
                            y: i,
                            z: o
                        });
                    }
                    t1();
                }
                abortTile(e1, t1) {
                    e1.request && e1.request.cancel && (e1.request.cancel(), delete e1.request), t1();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this._map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e1)=>({
                            x: e1.canonical.x,
                            y: e1.canonical.y,
                            z: e1.canonical.z
                        }));
                }
                _clearTiles() {
                    this._map.style._clearSource(this.id);
                }
                _update() {
                    this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
            }
        }, Pe = function(t1, i, o, r) {
            const n = new ze[i.type](t1, i, o, r);
            if (n.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${n.id}`);
            return e1.bindAll([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], n), n;
        };
        function Re(t1, i) {
            const o = e1.identity([]);
            return e1.scale(o, o, [
                .5 * t1.width,
                .5 * -t1.height,
                1
            ]), e1.translate(o, o, [
                1,
                -1,
                0
            ]), e1.multiply(o, o, t1.calculateProjMatrix(i.toUnwrapped())), Float32Array.from(o);
        }
        function Oe(e1, t1, i, o, r, n, s, a = !1) {
            const l = e1.tilesIn(o, s, a);
            l.sort(ke);
            const c = [];
            for (const o of l)c.push({
                wrappedTileID: o.tile.tileID.wrapped().key,
                queryResults: o.tile.queryRenderedFeatures(t1, i, e1._state, o, r, n, Re(e1.transform, o.tile.tileID), a)
            });
            const h = function(e1) {
                const t1 = {}, i = {};
                for (const o of e1){
                    const e1 = o.queryResults, r = o.wrappedTileID, n = i[r] = i[r] || {};
                    for(const i in e1){
                        const o = e1[i], r = n[i] = n[i] || {}, s = t1[i] = t1[i] || [];
                        for (const e1 of o)r[e1.featureIndex] || (r[e1.featureIndex] = !0, s.push(e1));
                    }
                }
                return t1;
            }(c);
            for(const t1 in h)h[t1].forEach((t1)=>{
                const i = t1.feature, o = i.layer;
                o && "background" !== o.type && "sky" !== o.type && (i.source = o.source, o["source-layer"] && (i.sourceLayer = o["source-layer"]), i.state = void 0 !== i.id ? e1.getFeatureState(o["source-layer"], i.id) : {});
            });
            return h;
        }
        function Be(e1, t1) {
            const i = e1.getRenderableIds().map((t1)=>e1.getTileByID(t1)), o = [], r = {};
            for(let e1 = 0; e1 < i.length; e1++){
                const n = i[e1], s = n.tileID.canonical.key;
                r[s] || (r[s] = !0, n.querySourceFeatures(o, t1));
            }
            return o;
        }
        function ke(e1, t1) {
            const i = e1.tileID, o = t1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        function Fe() {
            return null != fn.workerClass ? new fn.workerClass : new e1.window.Worker(fn.workerUrl);
        }
        const Ue = "mapboxgl_preloaded_worker_pool";
        class Ne {
            constructor(){
                this.active = {};
            }
            acquire(e1) {
                if (!this.workers) for(this.workers = []; this.workers.length < Ne.workerCount;)this.workers.push(new Fe);
                return this.active[e1] = !0, this.workers.slice();
            }
            release(e1) {
                delete this.active[e1], 0 === this.numActive() && (this.workers.forEach((e1)=>{
                    e1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[Ue];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        let Ge;
        function je() {
            return Ge || (Ge = new Ne), Ge;
        }
        function Ze(t1, i) {
            const o = {};
            for(const e1 in t1)"ref" !== e1 && (o[e1] = t1[e1]);
            return e1.refProperties.forEach((e1)=>{
                e1 in i && (o[e1] = i[e1]);
            }), o;
        }
        function Ve(e1) {
            e1 = e1.slice();
            const t1 = Object.create(null);
            for(let i = 0; i < e1.length; i++)t1[e1[i].id] = e1[i];
            for(let i = 0; i < e1.length; i++)"ref" in e1[i] && (e1[i] = Ze(e1[i], t1[e1[i].ref]));
            return e1;
        }
        Ne.workerCount = 2;
        const We = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight",
            setTerrain: "setTerrain",
            setFog: "setFog",
            setProjection: "setProjection"
        };
        function Xe(e1, t1, i) {
            i.push({
                command: We.addSource,
                args: [
                    e1,
                    t1[e1]
                ]
            });
        }
        function qe(e1, t1, i) {
            t1.push({
                command: We.removeSource,
                args: [
                    e1
                ]
            }), i[e1] = !0;
        }
        function $e(e1, t1, i, o) {
            qe(e1, i, o), Xe(e1, t1, i);
        }
        function He(e1, i, o) {
            let r;
            for(r in e1[o])if (e1[o].hasOwnProperty(r) && "data" !== r && !t1(e1[o][r], i[o][r])) return !1;
            for(r in i[o])if (i[o].hasOwnProperty(r) && "data" !== r && !t1(e1[o][r], i[o][r])) return !1;
            return !0;
        }
        function Ye(e1, i, o, r, n, s) {
            let a;
            for(a in i = i || {}, e1 = e1 || {})e1.hasOwnProperty(a) && (t1(e1[a], i[a]) || o.push({
                command: s,
                args: [
                    r,
                    a,
                    i[a],
                    n
                ]
            }));
            for(a in i)i.hasOwnProperty(a) && !e1.hasOwnProperty(a) && (t1(e1[a], i[a]) || o.push({
                command: s,
                args: [
                    r,
                    a,
                    i[a],
                    n
                ]
            }));
        }
        function Ke(e1) {
            return e1.id;
        }
        function Je(e1, t1) {
            return e1[t1.id] = t1, e1;
        }
        class Qe {
            constructor(e1, t1){
                this.reset(e1, t1);
            }
            reset(e1, t1) {
                this.points = e1 || [], this._distances = [
                    0
                ];
                for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t1) {
                if (1 === this.points.length) return this.points[0];
                t1 = e1.clamp(t1, 0, 1);
                let i = 1, o = this._distances[i];
                const r = t1 * this.paddedLength + this.padding;
                for(; o < r && i < this._distances.length;)o = this._distances[++i];
                const n = i - 1, s = this._distances[n], a = o - s, l = a > 0 ? (r - s) / a : 0;
                return this.points[n].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        class et {
            constructor(e1, t1, i){
                const o = this.boxCells = [], r = this.circleCells = [];
                this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t1 / i);
                for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)o.push([]), r.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t1, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t1, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e1, t1, i, o, r) {
                this._forEachCell(t1, i, o, r, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(r);
            }
            insertCircle(e1, t1, i, o) {
                this._forEachCell(t1 - o, i - o, t1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t1), this.circles.push(i), this.circles.push(o);
            }
            _insertBoxCell(e1, t1, i, o, r, n) {
                this.boxCells[r].push(n);
            }
            _insertCircleCell(e1, t1, i, o, r, n) {
                this.circleCells[r].push(n);
            }
            _query(e1, t1, i, o, r, n) {
                if (i < 0 || e1 > this.width || o < 0 || t1 > this.height) return !r && [];
                const s = [];
                if (e1 <= 0 && t1 <= 0 && this.width <= i && this.height <= o) {
                    if (r) return !0;
                    for(let e1 = 0; e1 < this.boxKeys.length; e1++)s.push({
                        key: this.boxKeys[e1],
                        x1: this.bboxes[4 * e1],
                        y1: this.bboxes[4 * e1 + 1],
                        x2: this.bboxes[4 * e1 + 2],
                        y2: this.bboxes[4 * e1 + 3]
                    });
                    for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                        const t1 = this.circles[3 * e1], i = this.circles[3 * e1 + 1], o = this.circles[3 * e1 + 2];
                        s.push({
                            key: this.circleKeys[e1],
                            x1: t1 - o,
                            y1: i - o,
                            x2: t1 + o,
                            y2: i + o
                        });
                    }
                    return n ? s.filter(n) : s;
                }
                return this._forEachCell(e1, t1, i, o, this._queryCell, s, {
                    hitTest: r,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, n), r ? s.length > 0 : s;
            }
            _queryCircle(e1, t1, i, o, r) {
                const n = e1 - i, s = e1 + i, a = t1 - i, l = t1 + i;
                if (s < 0 || n > this.width || l < 0 || a > this.height) return !o && [];
                const c = [];
                return this._forEachCell(n, a, s, l, this._queryCellCircle, c, {
                    hitTest: o,
                    circle: {
                        x: e1,
                        y: t1,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r), o ? c.length > 0 : c;
            }
            query(e1, t1, i, o, r) {
                return this._query(e1, t1, i, o, !1, r);
            }
            hitTest(e1, t1, i, o, r) {
                return this._query(e1, t1, i, o, !0, r);
            }
            hitTestCircle(e1, t1, i, o) {
                return this._queryCircle(e1, t1, i, !0, o);
            }
            _queryCell(e1, t1, i, o, r, n, s, a) {
                const l = s.seenUids, c = this.boxCells[r];
                if (null !== c) {
                    const r = this.bboxes;
                    for (const h of c)if (!l.box[h]) {
                        l.box[h] = !0;
                        const c = 4 * h;
                        if (e1 <= r[c + 2] && t1 <= r[c + 3] && i >= r[c + 0] && o >= r[c + 1] && (!a || a(this.boxKeys[h]))) {
                            if (s.hitTest) return n.push(!0), !0;
                            n.push({
                                key: this.boxKeys[h],
                                x1: r[c],
                                y1: r[c + 1],
                                x2: r[c + 2],
                                y2: r[c + 3]
                            });
                        }
                    }
                }
                const h = this.circleCells[r];
                if (null !== h) {
                    const r = this.circles;
                    for (const c of h)if (!l.circle[c]) {
                        l.circle[c] = !0;
                        const h = 3 * c;
                        if (this._circleAndRectCollide(r[h], r[h + 1], r[h + 2], e1, t1, i, o) && (!a || a(this.circleKeys[c]))) {
                            if (s.hitTest) return n.push(!0), !0;
                            {
                                const e1 = r[h], t1 = r[h + 1], i = r[h + 2];
                                n.push({
                                    key: this.circleKeys[c],
                                    x1: e1 - i,
                                    y1: t1 - i,
                                    x2: e1 + i,
                                    y2: t1 + i
                                });
                            }
                        }
                    }
                }
            }
            _queryCellCircle(e1, t1, i, o, r, n, s, a) {
                const l = s.circle, c = s.seenUids, h = this.boxCells[r];
                if (null !== h) {
                    const e1 = this.bboxes;
                    for (const t1 of h)if (!c.box[t1]) {
                        c.box[t1] = !0;
                        const i = 4 * t1;
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e1[i + 0], e1[i + 1], e1[i + 2], e1[i + 3]) && (!a || a(this.boxKeys[t1]))) return n.push(!0), !0;
                    }
                }
                const u = this.circleCells[r];
                if (null !== u) {
                    const e1 = this.circles;
                    for (const t1 of u)if (!c.circle[t1]) {
                        c.circle[t1] = !0;
                        const i = 3 * t1;
                        if (this._circlesCollide(e1[i], e1[i + 1], e1[i + 2], l.x, l.y, l.radius) && (!a || a(this.circleKeys[t1]))) return n.push(!0), !0;
                    }
                }
            }
            _forEachCell(e1, t1, i, o, r, n, s, a) {
                const l = this._convertToXCellCoord(e1), c = this._convertToYCellCoord(t1), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(o);
                for(let _ = l; _ <= h; _++)for(let l = c; l <= u; l++)if (r.call(this, e1, t1, i, o, this.xCellCount * l + _, n, s, a)) return;
            }
            _convertToXCellCoord(e1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
            }
            _convertToYCellCoord(e1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
            }
            _circlesCollide(e1, t1, i, o, r, n) {
                const s = o - e1, a = r - t1, l = i + n;
                return l * l > s * s + a * a;
            }
            _circleAndRectCollide(e1, t1, i, o, r, n, s) {
                const a = (n - o) / 2, l = Math.abs(e1 - (o + a));
                if (l > a + i) return !1;
                const c = (s - r) / 2, h = Math.abs(t1 - (r + c));
                if (h > c + i) return !1;
                if (l <= a || h <= c) return !0;
                const u = l - a, _ = h - c;
                return u * u + _ * _ <= i * i;
            }
        }
        const tt = Math.tan(85 * Math.PI / 180);
        function it(t1, i, o, r, n, s, a) {
            const l = e1.create();
            if (o) {
                if ("globe" === s.name) {
                    const t1 = e1.calculateGlobeLabelMatrix(n, i);
                    e1.multiply(l, l, t1);
                } else {
                    const t1 = v([], a);
                    l[0] = t1[0], l[1] = t1[1], l[4] = t1[2], l[5] = t1[3], r || e1.rotateZ(l, l, n.angle);
                }
            } else e1.multiply(l, n.labelPlaneMatrix, t1);
            return l;
        }
        function ot(e1, t1, i, o, r, n, s) {
            const a = it(e1, t1, i, o, r, n, s);
            return "globe" === n.name && i || (a[2] = a[6] = a[10] = a[14] = 0), a;
        }
        function rt(t1, i, o, r, n, s, a) {
            if (o) {
                if ("globe" === s.name) {
                    const l = it(t1, i, o, r, n, s, a);
                    return e1.invert(l, l), e1.multiply(l, t1, l), l;
                }
                {
                    const i = e1.clone(t1), o = e1.identity([]);
                    return o[0] = a[0], o[1] = a[1], o[4] = a[2], o[5] = a[3], e1.multiply(i, i, o), r || e1.rotateZ(i, i, -n.angle), i;
                }
            }
            return n.glCoordMatrix;
        }
        function nt(t1, i, o, r) {
            const n = [
                t1,
                i,
                o,
                1
            ];
            o ? e1.transformMat4$1(n, n, r) : ft(n, n, r);
            const s = n[3];
            return n[0] /= s, n[1] /= s, n[2] /= s, n;
        }
        function st(e1, t1) {
            return Math.min(.5 + e1 / t1 * .5, 1.5);
        }
        function at(e1, t1) {
            const i = e1[0] / e1[3], o = e1[1] / e1[3];
            return i >= -t1[0] && i <= t1[0] && o >= -t1[1] && o <= t1[1];
        }
        function lt(t1, i, o, r, n, s, a, l, c, h) {
            const u = o.transform, _ = r ? t1.textSizeData : t1.iconSizeData, d = e1.evaluateSizeForZoom(_, o.transform.zoom), p = "globe" === u.projection.name, m = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], f = r ? t1.text.dynamicLayoutVertexArray : t1.icon.dynamicLayoutVertexArray;
            f.clear();
            let g = null;
            p && (g = r ? t1.text.globeExtVertexArray : t1.icon.globeExtVertexArray);
            const v = t1.lineVertexArray, x = r ? t1.text.placedSymbolArray : t1.icon.placedSymbolArray, y = o.transform.width / o.transform.height;
            let b, w = !1;
            for(let r = 0; r < x.length; r++){
                const p = x.get(r), { numGlyphs: T, writingMode: E } = p;
                if (E !== e1.WritingMode.vertical || w || b === e1.WritingMode.horizontal || (w = !0), b = E, (p.hidden || E === e1.WritingMode.vertical) && !w) {
                    mt(T, f);
                    continue;
                }
                w = !1;
                const C = new e1.pointGeometry(p.tileAnchorX, p.tileAnchorY);
                let { x: M, y: I, z: S } = u.projection.projectTilePoint(C.x, C.y, h.canonical);
                if (c) {
                    const [e1, t1, i] = c(C);
                    M += e1, I += t1, S += i;
                }
                const D = [
                    M,
                    I,
                    S,
                    1
                ];
                if (e1.transformMat4$1(D, D, i), !at(D, m)) {
                    mt(T, f);
                    continue;
                }
                const L = st(o.transform.cameraToCenterDistance, D[3]), A = e1.evaluateSizeForFeature(_, d, p), z = a ? A / L : A * L, P = nt(M, I, S, n);
                if (P[3] <= 0) {
                    mt(T, f);
                    continue;
                }
                let R = {};
                const O = a ? null : c, B = ut(p, z, !1, l, i, n, s, t1.glyphOffsetArray, v, f, g, P, C, R, y, O, u.projection, h, a);
                w = B.useVertical, O && B.needsFlipping && (R = {}), (B.notEnoughRoom || w || B.needsFlipping && ut(p, z, !0, l, i, n, s, t1.glyphOffsetArray, v, f, g, P, C, R, y, O, u.projection, h, a).notEnoughRoom) && mt(T, f);
            }
            r ? (t1.text.dynamicLayoutVertexBuffer.updateData(f), g && t1.text.globeExtVertexBuffer.updateData(g)) : (t1.icon.dynamicLayoutVertexBuffer.updateData(f), g && t1.icon.globeExtVertexBuffer.updateData(g));
        }
        function ct(e1, t1, i, o, r, n, s, a, l, c, h, u, _, d, p, m) {
            const { lineStartIndex: f, glyphStartIndex: g, segment: v } = a, x = g + a.numGlyphs, y = f + a.lineLength, b = t1.getoffsetX(g), w = t1.getoffsetX(x - 1), T = pt(e1 * b, i, o, r, n, s, v, f, y, l, c, h, u, _, !0, d, p, m);
            if (!T) return null;
            const E = pt(e1 * w, i, o, r, n, s, v, f, y, l, c, h, u, _, !0, d, p, m);
            return E ? {
                first: T,
                last: E
            } : null;
        }
        function ht(t1, i, o, r) {
            return t1 === e1.WritingMode.horizontal && Math.abs(r) > Math.abs(o) ? {
                useVertical: !0
            } : t1 === e1.WritingMode.vertical ? r > 0 ? {
                needsFlipping: !0
            } : null : 0 !== i && function(e1, t1) {
                return 0 === e1 || Math.abs(t1 / e1) > tt;
            }(o, r) ? 1 === i ? {
                needsFlipping: !0
            } : null : o < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function ut(t1, i, o, r, n, s, a, l, c, h, u, _, d, p, m, f, g, v, x) {
            const y = i / 24, b = t1.lineOffsetX * y, w = t1.lineOffsetY * y, { lineStartIndex: T, glyphStartIndex: E, numGlyphs: C, segment: M, writingMode: I, flipState: S } = t1, D = T + t1.lineLength, L = (t1)=>{
                if (u) {
                    const [i, o, r] = t1.up, n = h.length;
                    e1.updateGlobeVertexNormal(u, n + 0, i, o, r), e1.updateGlobeVertexNormal(u, n + 1, i, o, r), e1.updateGlobeVertexNormal(u, n + 2, i, o, r), e1.updateGlobeVertexNormal(u, n + 3, i, o, r);
                }
                const [i, o, r] = t1.point;
                e1.addDynamicAttributes(h, i, o, r, t1.angle);
            };
            if (C > 1) {
                const e1 = ct(y, l, b, w, o, _, d, t1, c, s, p, f, !1, g, v, x);
                if (!e1) return {
                    notEnoughRoom: !0
                };
                if (r && !o) {
                    let [i, o, r] = e1.first.point, [n, s, l] = e1.last.point;
                    [i, o] = nt(i, o, r, a), [n, s] = nt(n, s, l, a);
                    const c = ht(I, S, (n - i) * m, s - o);
                    if (t1.flipState = c && c.needsFlipping ? 1 : 2, c) return c;
                }
                L(e1.first);
                for(let e1 = E + 1; e1 < E + C - 1; e1++){
                    const t1 = pt(y * l.getoffsetX(e1), b, w, o, _, d, M, T, D, c, s, p, f, !1, !1, g, v, x);
                    if (!t1) return h.length -= 4 * (e1 - E), {
                        notEnoughRoom: !0
                    };
                    L(t1);
                }
                L(e1.last);
            } else {
                if (r && !o) {
                    const i = nt(d.x, d.y, 0, n), o = T + M + 1, r = new e1.pointGeometry(c.getx(o), c.gety(o)), s = nt(r.x, r.y, 0, n), a = s[3] > 0 ? s : dt(d, r, i, 1, n, void 0, g, v.canonical), l = ht(I, S, (a[0] - i[0]) * m, a[1] - i[1]);
                    if (t1.flipState = l && l.needsFlipping ? 1 : 2, l) return l;
                }
                const i = pt(y * l.getoffsetX(E), b, w, o, _, d, M, T, D, c, s, p, f, !1, !1, g, v, x);
                if (!i) return {
                    notEnoughRoom: !0
                };
                L(i);
            }
            return {};
        }
        function _t(e1, t1, i, o, r) {
            const { x: n, y: s, z: a } = o.projectTilePoint(e1.x, e1.y, t1);
            if (!r) return nt(n, s, a, i);
            const [l, c, h] = r(e1);
            return nt(n + l, s + c, a + h, i);
        }
        function dt(t1, i, o, r, n, s, a, l) {
            const c = _t(t1.sub(i)._unit()._add(t1), l, n, a, s);
            return e1.sub(c, o, c), e1.normalize(c, c), e1.scaleAndAdd(c, o, c, r);
        }
        function pt(t1, i, o, r, n, s, a, l, c, h, u, _, d, p, m, f, g, v) {
            const x = r ? t1 - i : t1 + i;
            let y = x > 0 ? 1 : -1, b = 0;
            r && (y *= -1, b = Math.PI), y < 0 && (b += Math.PI);
            let w = l + a + (y > 0 ? 0 : 1) | 0, T = n, E = n, C = 0, M = 0;
            const I = Math.abs(x), S = [], D = [];
            let L = s, A = L;
            const z = ()=>dt(A, L, E, I - C + 1, u, d, f, g.canonical);
            for(; C + M <= I;){
                if (w += y, w < l || w >= c) return null;
                if (E = T, A = L, S.push(E), p && D.push(A), L = new e1.pointGeometry(h.getx(w), h.gety(w)), T = _[w], !T) {
                    const e1 = _t(L, g.canonical, u, f, d);
                    T = e1[3] > 0 ? _[w] = e1 : z();
                }
                C += M, M = e1.distance(E, T);
            }
            m && d && (_[w] && (T = z(), M = e1.distance(E, T)), _[w] = T);
            const P = (I - C) / M, R = L.sub(A)._mult(P)._add(A), O = e1.sub([], T, E), B = e1.scaleAndAdd([], E, O, P);
            let k = [
                0,
                0,
                1
            ], F = O[0], U = O[1];
            if (v && (k = f.upVector(g.canonical, R.x, R.y), 0 !== k[0] || 0 !== k[1] || 1 !== k[2])) {
                const t1 = [
                    k[2],
                    0,
                    -k[0]
                ], i = e1.cross([], k, t1);
                e1.normalize(t1, t1), e1.normalize(i, i), F = e1.dot(O, t1), U = e1.dot(O, i);
            }
            if (o) {
                const t1 = e1.cross([], k, O);
                e1.normalize(t1, t1), e1.scaleAndAdd(B, B, t1, o * y);
            }
            const N = b + Math.atan2(U, F);
            return S.push(B), p && D.push(R), {
                point: B,
                angle: N,
                path: S,
                tilePath: D,
                up: k
            };
        }
        function mt(e1, t1) {
            const i = t1.length, o = i + 4 * e1;
            t1.resize(o), t1.float32.fill(-1 / 0, 4 * i, 4 * o);
        }
        function ft(e1, t1, i) {
            const o = t1[0], r = t1[1];
            return e1[0] = i[0] * o + i[4] * r + i[12], e1[1] = i[1] * o + i[5] * r + i[13], e1[3] = i[3] * o + i[7] * r + i[15], e1;
        }
        const gt = 100;
        class vt {
            constructor(e1, t1, i = new et(e1.width + 200, e1.height + 200, 25), o = new et(e1.width + 200, e1.height + 200, 25)){
                this.transform = e1, this.grid = i, this.ignoredGrid = o, this.pitchfactor = Math.cos(e1._pitch) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + gt, this.screenBottomBoundary = e1.height + gt, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.fogState = t1;
            }
            placeCollisionBox(e1, t1, i, o, r, n, s, a) {
                let l = i.projectedAnchorX, c = i.projectedAnchorY, h = i.projectedAnchorZ;
                const u = i.elevation, _ = i.tileID, d = e1.getProjection();
                if (u && _) {
                    const [e1, t1, o] = d.upVector(_.canonical, i.tileAnchorX, i.tileAnchorY), r = d.upVectorScale(_.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    l += e1 * u * r, c += t1 * u * r, h += o * u * r;
                }
                const p = this.projectAndGetPerspectiveRatio(s, l, c, h, i.tileID, "globe" === d.name || !!u || this.transform.pitch > 0, d), m = n * p.perspectiveRatio, f = (i.x1 * t1 + o.x - i.padding) * m + p.point.x, g = (i.y1 * t1 + o.y - i.padding) * m + p.point.y, v = (i.x2 * t1 + o.x + i.padding) * m + p.point.x, x = (i.y2 * t1 + o.y + i.padding) * m + p.point.y, y = p.perspectiveRatio <= .55 || p.occluded;
                return !this.isInsideGrid(f, g, v, x) || !r && this.grid.hitTest(f, g, v, x, a) || y ? {
                    box: [],
                    offscreen: !1,
                    occluded: p.occluded
                } : {
                    box: [
                        f,
                        g,
                        v,
                        x
                    ],
                    offscreen: this.isOffscreen(f, g, v, x),
                    occluded: !1
                };
            }
            placeCollisionCircles(t1, i, o, r, n, s, a, l, c, h, u, _, d, p, m) {
                const f = [], g = this.transform.elevation, v = t1.getProjection(), x = g ? g.getAtTileOffsetFunc(m, this.transform.center.lat, this.transform.worldSize, v) : null, y = new e1.pointGeometry(o.tileAnchorX, o.tileAnchorY);
                let { x: b, y: w, z: T } = v.projectTilePoint(y.x, y.y, m.canonical);
                if (x) {
                    const [e1, t1, i] = x(y);
                    b += e1, w += t1, T += i;
                }
                const E = "globe" === v.name, C = this.projectAndGetPerspectiveRatio(a, b, w, T, m, E || !!g || this.transform.pitch > 0, v), { perspectiveRatio: M } = C, I = (u ? s / M : s * M) / e1.ONE_EM, S = nt(b, w, T, l), D = C.signedDistanceFromCamera > 0 ? ct(I, n, o.lineOffsetX * I, o.lineOffsetY * I, !1, S, y, o, r, l, {}, g && !u ? x : null, u && !!g, v, m, u) : null;
                let L = !1, A = !1, z = !0;
                if (D && !C.occluded) {
                    const t1 = .5 * d * M + p, o = new e1.pointGeometry(-100, -100), r = new e1.pointGeometry(this.screenRightBoundary, this.screenBottomBoundary), n = new Qe, { first: s, last: a } = D, l = s.path.length;
                    let u = [];
                    for(let e1 = l - 1; e1 >= 1; e1--)u.push(s.path[e1]);
                    for(let e1 = 1; e1 < a.path.length; e1++)u.push(a.path[e1]);
                    const m = 2.5 * t1;
                    c && (u = u.map(([e1, t1, i], o)=>(x && !E && (i = x(o < l - 1 ? s.tilePath[l - 1 - o] : a.tilePath[o - l + 2])[2]), nt(e1, t1, i, c))), u.some((e1)=>e1[3] <= 0) && (u = []));
                    let g = [];
                    if (u.length > 0) {
                        let t1 = 1 / 0, i = -1 / 0, n = 1 / 0, s = -1 / 0;
                        for (const e1 of u)t1 = Math.min(t1, e1[0]), n = Math.min(n, e1[1]), i = Math.max(i, e1[0]), s = Math.max(s, e1[1]);
                        i >= o.x && t1 <= r.x && s >= o.y && n <= r.y && (g = [
                            u.map((t1)=>new e1.pointGeometry(t1[0], t1[1]))
                        ], (t1 < o.x || i > r.x || n < o.y || s > r.y) && (g = e1.clipLine(g, o.x, o.y, r.x, r.y)));
                    }
                    for (const e1 of g){
                        n.reset(e1, .25 * t1);
                        let o = 0;
                        o = n.length <= .5 * t1 ? 1 : Math.ceil(n.paddedLength / m) + 1;
                        for(let e1 = 0; e1 < o; e1++){
                            const r = e1 / Math.max(o - 1, 1), s = n.lerp(r), a = s.x + gt, l = s.y + gt;
                            f.push(a, l, t1, 0);
                            const c = a - t1, u = l - t1, d = a + t1, p = l + t1;
                            if (z = z && this.isOffscreen(c, u, d, p), A = A || this.isInsideGrid(c, u, d, p), !i && this.grid.hitTestCircle(a, l, t1, _) && (L = !0, !h)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: L,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !h && L || !A ? [] : f,
                    offscreen: z,
                    collisionDetected: L,
                    occluded: C.occluded
                };
            }
            queryRenderedSymbols(t1) {
                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let o = 1 / 0, r = 1 / 0, n = -1 / 0, s = -1 / 0;
                for (const a of t1){
                    const t1 = new e1.pointGeometry(a.x + gt, a.y + gt);
                    o = Math.min(o, t1.x), r = Math.min(r, t1.y), n = Math.max(n, t1.x), s = Math.max(s, t1.y), i.push(t1);
                }
                const a = this.grid.query(o, r, n, s).concat(this.ignoredGrid.query(o, r, n, s)), l = {}, c = {};
                for (const t1 of a){
                    const o = t1.key;
                    if (void 0 === l[o.bucketInstanceId] && (l[o.bucketInstanceId] = {}), l[o.bucketInstanceId][o.featureIndex]) continue;
                    const r = [
                        new e1.pointGeometry(t1.x1, t1.y1),
                        new e1.pointGeometry(t1.x2, t1.y1),
                        new e1.pointGeometry(t1.x2, t1.y2),
                        new e1.pointGeometry(t1.x1, t1.y2)
                    ];
                    e1.polygonIntersectsPolygon(i, r) && (l[o.bucketInstanceId][o.featureIndex] = !0, void 0 === c[o.bucketInstanceId] && (c[o.bucketInstanceId] = []), c[o.bucketInstanceId].push(o.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e1, t1, i, o, r) {
                (t1 ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: r
                }, e1[0], e1[1], e1[2], e1[3]);
            }
            insertCollisionCircles(e1, t1, i, o, r) {
                const n = t1 ? this.ignoredGrid : this.grid, s = {
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: r
                };
                for(let t1 = 0; t1 < e1.length; t1 += 4)n.insertCircle(s, e1[t1], e1[t1 + 1], e1[t1 + 2]);
            }
            projectAndGetPerspectiveRatio(t1, i, o, r, n, s, a) {
                const l = [
                    i,
                    o,
                    r,
                    1
                ];
                let c = !1;
                if (r || this.transform.pitch > 0) {
                    e1.transformMat4$1(l, l, t1);
                    const s = "globe" === a.name;
                    if (this.fogState && n && !s) {
                        const t1 = function(t1, i, o, r, n, s) {
                            const a = s.calculateFogTileMatrix(n), l = [
                                i,
                                o,
                                r
                            ];
                            return e1.transformMat4(l, l, a), I(t1, l, s.pitch, s._fov);
                        }(this.fogState, i, o, r, n.toUnwrapped(), this.transform);
                        c = t1 > .9;
                    }
                } else ft(l, l, t1);
                const h = l[3];
                return {
                    point: new e1.pointGeometry((l[0] / h + 1) / 2 * this.transform.width + gt, (-l[1] / h + 1) / 2 * this.transform.height + gt),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(a) / h * .5, 1.5),
                    signedDistanceFromCamera: h,
                    occluded: s && l[2] > h || c
                };
            }
            isOffscreen(e1, t1, i, o) {
                return i < gt || e1 >= this.screenRightBoundary || o < gt || t1 > this.screenBottomBoundary;
            }
            isInsideGrid(e1, t1, i, o) {
                return i >= 0 && e1 < this.gridRightBoundary && o >= 0 && t1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t1 = e1.identity([]);
                return e1.translate(t1, t1, [
                    -100,
                    -100,
                    0
                ]), t1;
            }
        }
        function xt(t1, i, o) {
            const r = i.createTileMatrix(t1, t1.worldSize, o.toUnwrapped());
            return e1.multiply(new Float32Array(16), t1.projMatrix, r);
        }
        function yt(e1, t1, i) {
            if (t1.projection.name === i.projection.name) return e1.projMatrix;
            const o = i.clone();
            return o.setProjection(t1.projection), xt(o, t1.getProjection(), e1);
        }
        function bt(e1, t1, i) {
            return t1.name === i.projection.name ? e1.projMatrix : xt(i, t1, e1);
        }
        class wt {
            constructor(e1, t1, i, o){
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t1 : -t1))) : o && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class Tt {
            constructor(e1, t1, i, o, r, n = !1){
                this.text = new wt(e1 ? e1.text : null, t1, i, r), this.icon = new wt(e1 ? e1.icon : null, t1, o, r), this.clipped = n;
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class Et {
            constructor(e1, t1, i, o = !1){
                this.text = e1, this.icon = t1, this.skipFade = i, this.clipped = o;
            }
        }
        class Ct {
            constructor(){
                this.invProjMatrix = e1.create(), this.viewportMatrix = e1.create(), this.circles = [];
            }
        }
        class Mt {
            constructor(e1, t1, i, o, r){
                this.bucketInstanceId = e1, this.featureIndex = t1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = r;
            }
        }
        class It {
            constructor(e1){
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e1]) {
                    const t1 = ++this.maxGroupID;
                    this.collisionGroups[e1] = {
                        ID: t1,
                        predicate: (e1)=>e1.collisionGroupID === t1
                    };
                }
                return this.collisionGroups[e1];
            }
        }
        function St(t1, i, o, r, n) {
            const { horizontalAlign: s, verticalAlign: a } = e1.getAnchorAlignment(t1), l = -(s - .5) * i, c = -(a - .5) * o, h = e1.evaluateVariableOffset(t1, r);
            return new e1.pointGeometry(l + h[0] * n, c + h[1] * n);
        }
        function Dt(t1, i, o, r, n) {
            const s = new e1.pointGeometry(t1, i);
            return o && s._rotate(r ? n : -n), s;
        }
        class Lt {
            constructor(e1, t1, i, o, r){
                this.transform = e1.clone(), this.projection = e1.projection.name, this.collisionIndex = new vt(this.transform, r), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t1, this.retainedQueryData = {}, this.collisionGroups = new It(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
            }
            getBucketParts(t1, i, o, r) {
                const n = o.getBucket(i), s = o.latestFeatureIndex;
                if (!n || !s || i.id !== n.layerIds[0]) return;
                const a = n.layers[0].layout, l = o.collisionBoxArray, c = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), h = o.tileSize / e1.EXTENT, u = o.tileID.toUnwrapped();
                this.transform.setProjection(n.projection);
                const _ = (d = o.tileID, p = n.getProjection(), m = this.transform, p.name === this.projection ? m.calculateProjMatrix(d.toUnwrapped()) : xt(m, p, d));
                var d, p, m;
                const f = "map" === a.get("text-pitch-alignment"), g = "map" === a.get("text-rotation-alignment");
                i.compileFilter();
                const v = i.dynamicFilter(), x = i.dynamicFilterNeedsFeature(), y = this.transform.calculatePixelsToTileUnitsMatrix(o), b = ot(_, o.tileID.canonical, f, g, this.transform, n.getProjection(), y);
                let w = null;
                if (f) {
                    const t1 = rt(_, o.tileID.canonical, f, g, this.transform, n.getProjection(), y);
                    w = e1.multiply([], this.transform.labelPlaneMatrix, t1);
                }
                let T = null;
                v && o.latestFeatureIndex && (T = {
                    unwrappedTileID: u,
                    dynamicFilter: v,
                    dynamicFilterNeedsFeature: x,
                    featureIndex: o.latestFeatureIndex
                }), this.retainedQueryData[n.bucketInstanceId] = new Mt(n.bucketInstanceId, s, n.sourceLayerIndex, n.index, o.tileID);
                const E = {
                    bucket: n,
                    layout: a,
                    posMatrix: _,
                    textLabelPlaneMatrix: b,
                    labelToScreenMatrix: w,
                    clippingData: T,
                    scale: c,
                    textPixelRatio: h,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: l,
                    partiallyEvaluatedTextSize: e1.evaluateSizeForZoom(n.textSizeData, this.transform.zoom),
                    partiallyEvaluatedIconSize: e1.evaluateSizeForZoom(n.iconSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(n.sourceID)
                };
                if (r) for (const e1 of n.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: o, symbolInstanceEnd: r } = e1;
                    t1.push({
                        sortKey: i,
                        symbolInstanceStart: o,
                        symbolInstanceEnd: r,
                        parameters: E
                    });
                }
                else t1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: n.symbolInstances.length,
                    parameters: E
                });
            }
            attemptAnchorPlacement(e1, t1, i, o, r, n, s, a, l, c, h, u, _, d, p, m, f, g) {
                const { textOffset0: v, textOffset1: x, crossTileID: y } = u, b = [
                    v,
                    x
                ], w = St(e1, i, o, b, r), T = this.collisionIndex.placeCollisionBox(d, r, t1, Dt(w.x, w.y, n, s, this.transform.angle), h, a, l, c.predicate);
                if (m) {
                    const e1 = d.getSymbolInstanceIconSize(g, this.transform.zoom, u.placedIconSymbolIndex);
                    if (0 === this.collisionIndex.placeCollisionBox(d, e1, m, Dt(w.x, w.y, n, s, this.transform.angle), h, a, l, c.predicate).box.length) return;
                }
                if (T.box.length > 0) {
                    let t1;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[y] && this.prevPlacement.placements[y] && this.prevPlacement.placements[y].text && (t1 = this.prevPlacement.variableOffsets[y].anchor), this.variableOffsets[y] = {
                        textOffset: b,
                        width: i,
                        height: o,
                        anchor: e1,
                        textScale: r,
                        prevAnchor: t1
                    }, this.markUsedJustification(d, e1, u, p), d.allowVerticalPlacement && (this.markUsedOrientation(d, p, u), this.placedOrientations[y] = p), {
                        shift: w,
                        placedGlyphBoxes: T
                    };
                }
            }
            placeLayerBucketPart(t1, i, o, r) {
                const { bucket: n, layout: s, posMatrix: a, textLabelPlaneMatrix: l, labelToScreenMatrix: c, clippingData: h, textPixelRatio: u, holdingForFade: _, collisionBoxArray: d, partiallyEvaluatedTextSize: p, partiallyEvaluatedIconSize: m, collisionGroup: f } = t1.parameters, g = s.get("text-optional"), v = s.get("icon-optional"), x = s.get("text-allow-overlap"), y = s.get("icon-allow-overlap"), b = "map" === s.get("text-rotation-alignment"), w = "map" === s.get("text-pitch-alignment"), T = "none" !== s.get("icon-text-fit"), E = "viewport-y" === s.get("symbol-z-order");
                this.transform.setProjection(n.projection);
                let C = x && (y || !n.hasIconData() || v), M = y && (x || !n.hasTextData() || g);
                !n.collisionArrays && d && n.deserializeCollisionBoxes(d), o && r && n.updateCollisionDebugBuffers(this.transform.zoom, d);
                const I = (t1, r, d)=>{
                    const { crossTileID: E, numVerticalGlyphVertices: I } = t1;
                    if (h) {
                        const o = {
                            zoom: this.transform.zoom,
                            pitch: this.transform.pitch
                        };
                        let r = null;
                        if (h.dynamicFilterNeedsFeature) {
                            const e1 = this.retainedQueryData[n.bucketInstanceId];
                            r = h.featureIndex.loadFeature({
                                featureIndex: t1.featureIndex,
                                bucketIndex: e1.bucketIndex,
                                sourceLayerIndex: e1.sourceLayerIndex,
                                layoutVertexArrayOffset: 0
                            });
                        }
                        if (!(0, h.dynamicFilter)(o, r, this.retainedQueryData[n.bucketInstanceId].tileID.canonical, new e1.pointGeometry(t1.tileAnchorX, t1.tileAnchorY), this.transform.calculateDistanceTileData(h.unwrappedTileID))) return this.placements[E] = new Et(!1, !1, !1, !0), void (i[E] = !0);
                    }
                    if (i[E]) return;
                    if (_) return void (this.placements[E] = new Et(!1, !1, !1));
                    let S = !1, D = !1, L = !0, A = !1, z = !1, P = null, R = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, O = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, B = null, k = null, F = null, U = 0, N = 0, G = 0;
                    d.textFeatureIndex ? U = d.textFeatureIndex : t1.useRuntimeCollisionCircles && (U = t1.featureIndex), d.verticalTextFeatureIndex && (N = d.verticalTextFeatureIndex);
                    const j = (e1)=>{
                        e1.tileID = this.retainedQueryData[n.bucketInstanceId].tileID;
                        const t1 = this.transform.elevation;
                        (t1 || e1.elevation) && (e1.elevation = t1 ? t1.getAtTileOffset(e1.tileID, e1.tileAnchorX, e1.tileAnchorY) : 0);
                    }, Z = d.textBox;
                    if (Z) {
                        j(Z);
                        const i = (i)=>{
                            let o = e1.WritingMode.horizontal;
                            if (n.allowVerticalPlacement && !i && this.prevPlacement) {
                                const e1 = this.prevPlacement.placedOrientations[E];
                                e1 && (this.placedOrientations[E] = e1, o = e1, this.markUsedOrientation(n, o, t1));
                            }
                            return o;
                        }, o = (t1, i)=>{
                            if (n.allowVerticalPlacement && I > 0 && d.verticalTextBox) {
                                for (const o of n.writingModes)if (o === e1.WritingMode.vertical ? (R = i(), O = R) : R = t1(), R && R.box && R.box.length) break;
                            } else R = t1();
                        };
                        if (s.get("text-variable-anchor")) {
                            let l = s.get("text-variable-anchor");
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[E]) {
                                const e1 = this.prevPlacement.variableOffsets[E];
                                l.indexOf(e1.anchor) > 0 && (l = l.filter((t1)=>t1 !== e1.anchor), l.unshift(e1.anchor));
                            }
                            const c = (e1, i, o)=>{
                                const s = n.getSymbolInstanceTextSize(p, t1, this.transform.zoom, r), c = (e1.x2 - e1.x1) * s + 2 * e1.padding, h = (e1.y2 - e1.y1) * s + 2 * e1.padding, _ = T && !y ? i : null;
                                _ && j(_);
                                let d = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const g = x ? 2 * l.length : l.length;
                                for(let i = 0; i < g; ++i){
                                    const g = this.attemptAnchorPlacement(l[i % l.length], e1, c, h, s, b, w, u, a, f, i >= l.length, t1, r, n, o, _, p, m);
                                    if (g && (d = g.placedGlyphBoxes, d && d.box && d.box.length)) {
                                        S = !0, P = g.shift;
                                        break;
                                    }
                                }
                                return d;
                            };
                            o(()=>c(Z, d.iconBox, e1.WritingMode.horizontal), ()=>{
                                const t1 = d.verticalTextBox;
                                return t1 && j(t1), n.allowVerticalPlacement && !(R && R.box && R.box.length) && I > 0 && t1 ? c(t1, d.verticalIconBox, e1.WritingMode.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), R && (S = R.box, L = R.offscreen, A = R.occluded);
                            const h = i(R && R.box);
                            if (!S && this.prevPlacement) {
                                const e1 = this.prevPlacement.variableOffsets[E];
                                e1 && (this.variableOffsets[E] = e1, this.markUsedJustification(n, e1.anchor, t1, h));
                            }
                        } else {
                            const s = (i, o)=>{
                                const s = n.getSymbolInstanceTextSize(p, t1, this.transform.zoom, r), l = this.collisionIndex.placeCollisionBox(n, s, i, new e1.pointGeometry(0, 0), x, u, a, f.predicate);
                                return l && l.box && l.box.length && (this.markUsedOrientation(n, o, t1), this.placedOrientations[E] = o), l;
                            };
                            o(()=>s(Z, e1.WritingMode.horizontal), ()=>{
                                const t1 = d.verticalTextBox;
                                return n.allowVerticalPlacement && I > 0 && t1 ? (j(t1), s(t1, e1.WritingMode.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), i(R && R.box && R.box.length);
                        }
                    }
                    if (B = R, S = B && B.box && B.box.length > 0, L = B && B.offscreen, A = B && B.occluded, t1.useRuntimeCollisionCircles) {
                        const i = n.text.placedSymbolArray.get(t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex), r = e1.evaluateSizeForFeature(n.textSizeData, p, i), h = s.get("text-padding");
                        k = this.collisionIndex.placeCollisionCircles(n, x, i, n.lineVertexArray, n.glyphOffsetArray, r, a, l, c, o, w, f.predicate, t1.collisionCircleDiameter * r / e1.ONE_EM, h, this.retainedQueryData[n.bucketInstanceId].tileID), S = x || k.circles.length > 0 && !k.collisionDetected, L = L && k.offscreen, A = k.occluded;
                    }
                    if (d.iconFeatureIndex && (G = d.iconFeatureIndex), d.iconBox) {
                        const i = (i)=>{
                            j(i);
                            const o = T && P ? Dt(P.x, P.y, b, w, this.transform.angle) : new e1.pointGeometry(0, 0), r = n.getSymbolInstanceIconSize(m, this.transform.zoom, t1.placedIconSymbolIndex);
                            return this.collisionIndex.placeCollisionBox(n, r, i, o, y, u, a, f.predicate);
                        };
                        O && O.box && O.box.length && d.verticalIconBox ? (F = i(d.verticalIconBox), D = F.box.length > 0) : (F = i(d.iconBox), D = F.box.length > 0), L = L && F.offscreen, z = F.occluded;
                    }
                    const V = g || 0 === t1.numHorizontalGlyphVertices && 0 === I, W = v || 0 === t1.numIconVertices;
                    if (V || W ? W ? V || (D = D && S) : S = D && S : D = S = D && S, S && B && B.box && this.collisionIndex.insertCollisionBox(B.box, s.get("text-ignore-placement"), n.bucketInstanceId, O && O.box && N ? N : U, f.ID), D && F && this.collisionIndex.insertCollisionBox(F.box, s.get("icon-ignore-placement"), n.bucketInstanceId, G, f.ID), k && (S && this.collisionIndex.insertCollisionCircles(k.circles, s.get("text-ignore-placement"), n.bucketInstanceId, U, f.ID), o)) {
                        const e1 = n.bucketInstanceId;
                        let t1 = this.collisionCircleArrays[e1];
                        void 0 === t1 && (t1 = this.collisionCircleArrays[e1] = new Ct);
                        for(let e1 = 0; e1 < k.circles.length; e1 += 4)t1.circles.push(k.circles[e1 + 0]), t1.circles.push(k.circles[e1 + 1]), t1.circles.push(k.circles[e1 + 2]), t1.circles.push(k.collisionDetected ? 1 : 0);
                    }
                    const X = "globe" !== n.projection.name;
                    C = C && (X || !A), M = M && (X || !z), this.placements[E] = new Et(S || C, D || M, L || n.justReloaded), i[E] = !0;
                };
                if (E) {
                    const e1 = n.getSortedSymbolIndexes(this.transform.angle);
                    for(let t1 = e1.length - 1; t1 >= 0; --t1){
                        const i = e1[t1];
                        I(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                } else for(let e1 = t1.symbolInstanceStart; e1 < t1.symbolInstanceEnd; e1++)I(n.symbolInstances.get(e1), e1, n.collisionArrays[e1]);
                if (o && n.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[n.bucketInstanceId];
                    e1.invert(t1.invProjMatrix, a), t1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                n.justReloaded = !1;
            }
            markUsedJustification(t1, i, o, r) {
                const { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: s, rightJustifiedTextSymbolIndex: a, verticalPlacedTextSymbolIndex: l, crossTileID: c } = o, h = e1.getAnchorJustification(i), u = r === e1.WritingMode.vertical ? l : "left" === h ? n : "center" === h ? s : "right" === h ? a : -1;
                n >= 0 && (t1.text.placedSymbolArray.get(n).crossTileID = u >= 0 && n !== u ? 0 : c), s >= 0 && (t1.text.placedSymbolArray.get(s).crossTileID = u >= 0 && s !== u ? 0 : c), a >= 0 && (t1.text.placedSymbolArray.get(a).crossTileID = u >= 0 && a !== u ? 0 : c), l >= 0 && (t1.text.placedSymbolArray.get(l).crossTileID = u >= 0 && l !== u ? 0 : c);
            }
            markUsedOrientation(t1, i, o) {
                const r = i === e1.WritingMode.horizontal || i === e1.WritingMode.horizontalOnly ? i : 0, n = i === e1.WritingMode.vertical ? i : 0, { leftJustifiedTextSymbolIndex: s, centerJustifiedTextSymbolIndex: a, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = o, h = t1.text.placedSymbolArray;
                s >= 0 && (h.get(s).placedOrientation = r), a >= 0 && (h.get(a).placedOrientation = r), l >= 0 && (h.get(l).placedOrientation = r), c >= 0 && (h.get(c).placedOrientation = n);
            }
            commit(e1) {
                this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t1 ? t1.zoomAdjustment(this.transform.zoom) : 0;
                const o = t1 ? t1.symbolFadeChange(e1) : 1, r = t1 ? t1.opacities : {}, n = t1 ? t1.variableOffsets : {}, s = t1 ? t1.placedOrientations : {};
                for(const e1 in this.placements){
                    const t1 = this.placements[e1], n = r[e1];
                    n ? (this.opacities[e1] = new Tt(n, o, t1.text, t1.icon, null, t1.clipped), i = i || t1.text !== n.text.placed || t1.icon !== n.icon.placed) : (this.opacities[e1] = new Tt(null, o, t1.text, t1.icon, t1.skipFade, t1.clipped), i = i || t1.text || t1.icon);
                }
                for(const e1 in r){
                    const t1 = r[e1];
                    if (!this.opacities[e1]) {
                        const r = new Tt(t1, o, !1, !1);
                        r.isHidden() || (this.opacities[e1] = r, i = i || t1.text.placed || t1.icon.placed);
                    }
                }
                for(const e1 in n)this.variableOffsets[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.variableOffsets[e1] = n[e1]);
                for(const e1 in s)this.placedOrientations[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.placedOrientations[e1] = s[e1]);
                i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t1 ? t1.lastPlacementChangeTime : e1);
            }
            updateLayerOpacities(e1, t1) {
                const i = {};
                for (const o of t1){
                    const t1 = o.getBucket(e1);
                    t1 && o.latestFeatureIndex && e1.id === t1.layerIds[0] && this.updateBucketOpacities(t1, i, o.collisionBoxArray);
                }
            }
            updateBucketOpacities(t1, i, o) {
                t1.hasTextData() && t1.text.opacityVertexArray.clear(), t1.hasIconData() && t1.icon.opacityVertexArray.clear(), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                const r = t1.layers[0].layout, n = !!t1.layers[0].dynamicFilter(), s = new Tt(null, 0, !1, !1, !0), a = r.get("text-allow-overlap"), l = r.get("icon-allow-overlap"), c = r.get("text-variable-anchor"), h = "map" === r.get("text-rotation-alignment"), u = "map" === r.get("text-pitch-alignment"), _ = "none" !== r.get("icon-text-fit"), d = new Tt(null, 0, a && (l || !t1.hasIconData() || r.get("icon-optional")), l && (a || !t1.hasTextData() || r.get("text-optional")), !0);
                !t1.collisionArrays && o && (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && t1.deserializeCollisionBoxes(o);
                const p = (e1, t1, i)=>{
                    for(let o = 0; o < t1 / 4; o++)e1.opacityVertexArray.emplaceBack(i);
                };
                let m = 0;
                for(let o = 0; o < t1.symbolInstances.length; o++){
                    const r = t1.symbolInstances.get(o), { numHorizontalGlyphVertices: a, numVerticalGlyphVertices: l, crossTileID: f, numIconVertices: g } = r;
                    let v = this.opacities[f];
                    i[f] ? v = s : v || (v = d, this.opacities[f] = v), i[f] = !0;
                    const x = a > 0 || l > 0, y = g > 0, b = this.placedOrientations[f], w = b === e1.WritingMode.vertical, T = b === e1.WritingMode.horizontal || b === e1.WritingMode.horizontalOnly;
                    if (!x && !y || v.isHidden() || m++, x) {
                        const e1 = Ut(v.text);
                        p(t1.text, a, w ? Nt : e1), p(t1.text, l, T ? Nt : e1);
                        const i = v.text.isHidden(), { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: n, rightJustifiedTextSymbolIndex: s, verticalPlacedTextSymbolIndex: c } = r, h = t1.text.placedSymbolArray, u = i || w ? 1 : 0;
                        o >= 0 && (h.get(o).hidden = u), n >= 0 && (h.get(n).hidden = u), s >= 0 && (h.get(s).hidden = u), c >= 0 && (h.get(c).hidden = i || T ? 1 : 0);
                        const _ = this.variableOffsets[f];
                        _ && this.markUsedJustification(t1, _.anchor, r, b);
                        const d = this.placedOrientations[f];
                        d && (this.markUsedJustification(t1, "left", r, d), this.markUsedOrientation(t1, d, r));
                    }
                    if (y) {
                        const e1 = Ut(v.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: o } = r, n = t1.icon.placedSymbolArray, s = v.icon.isHidden() ? 1 : 0;
                        i >= 0 && (p(t1.icon, g, w ? Nt : e1), n.get(i).hidden = s), o >= 0 && (p(t1.icon, r.numVerticalIconVertices, T ? Nt : e1), n.get(o).hidden = s);
                    }
                    if (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) {
                        const i = t1.collisionArrays[o];
                        if (i) {
                            let o = new e1.pointGeometry(0, 0), r = !0;
                            if (i.textBox || i.verticalTextBox) {
                                if (c) {
                                    const e1 = this.variableOffsets[f];
                                    e1 ? (o = St(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textScale), h && o._rotate(u ? this.transform.angle : -this.transform.angle)) : r = !1;
                                }
                                n && (r = !v.clipped), i.textBox && At(t1.textCollisionBox.collisionVertexArray, v.text.placed, !r || w, o.x, o.y), i.verticalTextBox && At(t1.textCollisionBox.collisionVertexArray, v.text.placed, !r || T, o.x, o.y);
                            }
                            const s = r && Boolean(!T && i.verticalIconBox);
                            i.iconBox && At(t1.iconCollisionBox.collisionVertexArray, v.icon.placed, s, _ ? o.x : 0, _ ? o.y : 0), i.verticalIconBox && At(t1.iconCollisionBox.collisionVertexArray, v.icon.placed, !s, _ ? o.x : 0, _ ? o.y : 0);
                        }
                    }
                }
                if (t1.fullyClipped = 0 === m, t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.bucketInstanceId in this.collisionCircleArrays) {
                    const e1 = this.collisionCircleArrays[t1.bucketInstanceId];
                    t1.placementInvProjMatrix = e1.invProjMatrix, t1.placementViewportMatrix = e1.viewportMatrix, t1.collisionCircleArray = e1.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                }
            }
            symbolFadeChange(e1) {
                return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e1) {
                return Math.max(0, (this.transform.zoom - e1) / 1.5);
            }
            hasTransitions(e1) {
                return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e1, t1) {
                const i = this.zoomAtLastRecencyCheck === t1 ? 1 - this.zoomAdjustment(t1) : 1;
                return this.zoomAtLastRecencyCheck = t1, this.commitTime + this.fadeDuration * i > e1;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function At(e1, t1, i, o, r) {
            e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0);
        }
        const zt = Math.pow(2, 25), Pt = Math.pow(2, 24), Rt = Math.pow(2, 17), Ot = Math.pow(2, 16), Bt = Math.pow(2, 9), kt = Math.pow(2, 8), Ft = Math.pow(2, 1);
        function Ut(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            const t1 = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * zt + t1 * Pt + i * Rt + t1 * Ot + i * Bt + t1 * kt + i * Ft + t1;
        }
        const Nt = 0;
        class Gt {
            constructor(e1){
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && void 0 !== e1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
            continuePlacement(e1, t1, i, o, r) {
                const n = this._bucketParts;
                for(; this._currentTileIndex < e1.length;)if (t1.getBucketParts(n, o, e1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, n.sort((e1, t1)=>e1.sortKey - t1.sortKey)); this._currentPartIndex < n.length;){
                    const e1 = n[this._currentPartIndex];
                    if (t1.placeLayerBucketPart(e1, this._seenCrossTileIDs, i, 0 === e1.symbolInstanceStart), this._currentPartIndex++, r()) return !0;
                }
                return !1;
            }
        }
        class jt {
            constructor(e1, t1, i, o, r, n, s, a){
                this.placement = new Lt(e1, r, n, s, a), this._currentPlacementIndex = t1.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = o, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(t1, i, o) {
                const r = e1.exported.now(), n = ()=>{
                    const t1 = e1.exported.now() - r;
                    return !this._forceFullPlacement && t1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const e1 = i[t1[this._currentPlacementIndex]], r = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === e1.type && (!e1.minzoom || e1.minzoom <= r) && (!e1.maxzoom || e1.maxzoom > r)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new Gt(e1)), this._inProgressLayer.continuePlacement(o[e1.source], this.placement, this._showCollisionBoxes, e1, n)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e1) {
                return this.placement.commit(e1), this.placement;
            }
        }
        const Zt = 512 / e1.EXTENT / 2;
        class Vt {
            constructor(e1, t1, i){
                this.tileID = e1, this.indexedSymbolInstances = {}, this.bucketInstanceId = i;
                for(let i = 0; i < t1.length; i++){
                    const o = t1.get(i), r = o.key;
                    this.indexedSymbolInstances[r] || (this.indexedSymbolInstances[r] = []), this.indexedSymbolInstances[r].push({
                        crossTileID: o.crossTileID,
                        coord: this.getScaledCoordinates(o, e1)
                    });
                }
            }
            getScaledCoordinates(t1, i) {
                const o = Zt / Math.pow(2, i.canonical.z - this.tileID.canonical.z);
                return {
                    x: Math.floor((i.canonical.x * e1.EXTENT + t1.tileAnchorX) * o),
                    y: Math.floor((i.canonical.y * e1.EXTENT + t1.tileAnchorY) * o)
                };
            }
            findMatches(e1, t1, i) {
                const o = this.tileID.canonical.z < t1.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t1.canonical.z);
                for(let r = 0; r < e1.length; r++){
                    const n = e1.get(r);
                    if (n.crossTileID) continue;
                    const s = this.indexedSymbolInstances[n.key];
                    if (!s) continue;
                    const a = this.getScaledCoordinates(n, t1);
                    for (const e1 of s)if (Math.abs(e1.coord.x - a.x) <= o && Math.abs(e1.coord.y - a.y) <= o && !i[e1.crossTileID]) {
                        i[e1.crossTileID] = !0, n.crossTileID = e1.crossTileID;
                        break;
                    }
                }
            }
        }
        class Wt {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Xt {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e1) {
                const t1 = Math.round((e1 - this.lng) / 360);
                if (0 !== t1) for(const e1 in this.indexes){
                    const i = this.indexes[e1], o = {};
                    for(const e1 in i){
                        const r = i[e1];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + t1), o[r.tileID.key] = r;
                    }
                    this.indexes[e1] = o;
                }
                this.lng = e1;
            }
            addBucket(e1, t1, i) {
                if (this.indexes[e1.overscaledZ] && this.indexes[e1.overscaledZ][e1.key]) {
                    if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++)t1.symbolInstances.get(e1).crossTileID = 0;
                this.usedCrossTileIDs[e1.overscaledZ] || (this.usedCrossTileIDs[e1.overscaledZ] = {});
                const o = this.usedCrossTileIDs[e1.overscaledZ];
                for(const i in this.indexes){
                    const r = this.indexes[i];
                    if (Number(i) > e1.overscaledZ) for(const i in r){
                        const n = r[i];
                        n.tileID.isChildOf(e1) && n.findMatches(t1.symbolInstances, e1, o);
                    }
                    else {
                        const n = r[e1.scaledTo(Number(i)).key];
                        n && n.findMatches(t1.symbolInstances, e1, o);
                    }
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++){
                    const r = t1.symbolInstances.get(e1);
                    r.crossTileID || (r.crossTileID = i.generate(), o[r.crossTileID] = !0);
                }
                return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new Vt(e1, t1.symbolInstances, t1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e1, t1) {
                for(const i in t1.indexedSymbolInstances)for (const o of t1.indexedSymbolInstances[i])delete this.usedCrossTileIDs[e1][o.crossTileID];
            }
            removeStaleBuckets(e1) {
                let t1 = !1;
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    for(const r in o)e1[o[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[r]), delete o[r], t1 = !0);
                }
                return t1;
            }
        }
        class qt {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Wt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e1, t1, i, o) {
                let r = this.layerIndexes[e1.id];
                void 0 === r && (r = this.layerIndexes[e1.id] = new Xt);
                let n = !1;
                const s = {};
                "globe" !== o.name && r.handleWrapJump(i);
                for (const i of t1){
                    const t1 = i.getBucket(e1);
                    t1 && e1.id === t1.layerIds[0] && (t1.bucketInstanceId || (t1.bucketInstanceId = ++this.maxBucketInstanceId), r.addBucket(i.tileID, t1, this.crossTileIDs) && (n = !0), s[t1.bucketInstanceId] = !0);
                }
                return r.removeStaleBuckets(s) && (n = !0), n;
            }
            pruneUnusedLayers(e1) {
                const t1 = {};
                e1.forEach((e1)=>{
                    t1[e1] = !0;
                });
                for(const e1 in this.layerIndexes)t1[e1] || delete this.layerIndexes[e1];
            }
        }
        const $t = (t1, i)=>e1.emitValidationErrors(t1, i && i.filter((e1)=>"source.canvas" !== e1.identifier)), Ht = e1.pick(We, [
            "addLayer",
            "removeLayer",
            "setPaintProperty",
            "setLayoutProperty",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setProjection"
        ]), Yt = e1.pick(We, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), Kt = {
            version: 8,
            layers: [],
            sources: {}
        }, Jt = {
            fill: !0,
            line: !0,
            background: !0,
            hillshade: !0,
            raster: !0
        };
        class Qt extends e1.Evented {
            constructor(t1, i = {}){
                super(), this.map = t1, this.dispatcher = new z(je(), this), this.imageManager = new y, this.imageManager.setEventedParent(this), this.glyphManager = new e1.GlyphManager(t1._requestManager, i.localFontFamily ? e1.LocalGlyphMode.all : i.localIdeographFontFamily ? e1.LocalGlyphMode.ideographs : e1.LocalGlyphMode.none, i.localFontFamily || i.localIdeographFontFamily), this.crossTileSymbolIndex = new qt, this._layers = {}, this._num3DLayers = 0, this._numSymbolLayers = 0, this._numCircleLayers = 0, this._serializedLayers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = !1, this._availableImages = [], this._order = [], this._drapedFirstOrder = [], this._markersNeedUpdate = !1, this._resetUpdates(), this.dispatcher.broadcast("setReferrer", e1.getReferrer());
                const o = this;
                this._rtlTextPluginCallback = Qt.registerForPluginStateChange((t1)=>{
                    o.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: t1.pluginStatus,
                        pluginURL: t1.pluginURL
                    }, (t1, i)=>{
                        if (e1.triggerPluginCompletionEvent(t1), i && i.every((e1)=>e1)) for(const e1 in o._sourceCaches){
                            const t1 = o._sourceCaches[e1], i = t1.getSource().type;
                            "vector" !== i && "geojson" !== i || t1.reload();
                        }
                    });
                }), this.on("data", (e1)=>{
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    const t1 = this.getSource(e1.sourceId);
                    if (t1 && t1.vectorLayerIds) for(const e1 in this._layers){
                        const i = this._layers[e1];
                        i.source === t1.id && this._validateLayer(i);
                    }
                });
            }
            loadURL(t1, i = {}) {
                this.fire(new e1.Event("dataloading", {
                    dataType: "style"
                }));
                const o = "boolean" == typeof i.validate ? i.validate : !e1.isMapboxURL(t1);
                t1 = this.map._requestManager.normalizeStyleURL(t1, i.accessToken);
                const r = this.map._requestManager.transformRequest(t1, e1.ResourceType.Style);
                this._request = e1.getJSON(r, (t1, i)=>{
                    this._request = null, t1 ? this.fire(new e1.ErrorEvent(t1)) : i && this._load(i, o);
                });
            }
            loadJSON(t1, i = {}) {
                this.fire(new e1.Event("dataloading", {
                    dataType: "style"
                })), this._request = e1.exported.frame(()=>{
                    this._request = null, this._load(t1, !1 !== i.validate);
                });
            }
            loadEmpty() {
                this.fire(new e1.Event("dataloading", {
                    dataType: "style"
                })), this._load(Kt, !1);
            }
            _updateLayerCount(e1, t1) {
                const i = t1 ? 1 : -1;
                e1.is3D() && (this._num3DLayers += i), "circle" === e1.type && (this._numCircleLayers += i), "symbol" === e1.type && (this._numSymbolLayers += i);
            }
            _load(t1, i) {
                if (i && $t(this, e1.validateStyle(t1))) return;
                this._loaded = !0, this.stylesheet = e1.clone$1(t1), this._updateMapProjection();
                for(const e1 in t1.sources)this.addSource(e1, t1.sources[e1], {
                    validate: !1
                });
                this._changed = !1, t1.sprite ? this._loadSprite(t1.sprite) : (this.imageManager.setLoaded(!0), this.dispatcher.broadcast("spriteLoaded", !0)), this.glyphManager.setURL(t1.glyphs);
                const o = Ve(this.stylesheet.layers);
                this._order = o.map((e1)=>e1.id), this._layers = {}, this._serializedLayers = {};
                for (let t1 of o)t1 = e1.createStyleLayer(t1), t1.setEventedParent(this, {
                    layer: {
                        id: t1.id
                    }
                }), this._layers[t1.id] = t1, this._serializedLayers[t1.id] = t1.serialize(), this._updateLayerCount(t1, !0);
                this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new T(this.stylesheet.light), this.stylesheet.terrain && !this.terrainSetForDrapingOnly() && this._createTerrain(this.stylesheet.terrain, 1), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this._updateDrapeFirstLayers(), this.fire(new e1.Event("data", {
                    dataType: "style"
                })), this.fire(new e1.Event("style.load"));
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            setProjection(e1) {
                e1 ? this.stylesheet.projection = e1 : delete this.stylesheet.projection, this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? this.getTerrain() || this.stylesheet.terrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null));
            }
            _updateMapProjection() {
                this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.stylesheet.projection);
            }
            _loadSprite(t1) {
                this._spriteRequest = function(t1, i, o) {
                    let r, n, s;
                    const a = e1.exported.devicePixelRatio > 1 ? "@2x" : "";
                    let l = e1.getJSON(i.transformRequest(i.normalizeSpriteURL(t1, a, ".json"), e1.ResourceType.SpriteJSON), (e1, t1)=>{
                        l = null, s || (s = e1, r = t1, h());
                    }), c = e1.getImage(i.transformRequest(i.normalizeSpriteURL(t1, a, ".png"), e1.ResourceType.SpriteImage), (e1, t1)=>{
                        c = null, s || (s = e1, n = t1, h());
                    });
                    function h() {
                        if (s) o(s);
                        else if (r && n) {
                            const t1 = e1.exported.getImageData(n), i = {};
                            for(const o in r){
                                const { width: n, height: s, x: a, y: l, sdf: c, pixelRatio: h, stretchX: u, stretchY: _, content: d } = r[o], p = new e1.RGBAImage({
                                    width: n,
                                    height: s
                                });
                                e1.RGBAImage.copy(t1, p, {
                                    x: a,
                                    y: l
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: n,
                                    height: s
                                }), i[o] = {
                                    data: p,
                                    pixelRatio: h,
                                    sdf: c,
                                    stretchX: u,
                                    stretchY: _,
                                    content: d
                                };
                            }
                            o(null, i);
                        }
                    }
                    return {
                        cancel () {
                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                        }
                    };
                }(t1, this.map._requestManager, (t1, i)=>{
                    if (this._spriteRequest = null, t1) this.fire(new e1.ErrorEvent(t1));
                    else if (i) for(const e1 in i)this.imageManager.addImage(e1, i[e1]);
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), this.dispatcher.broadcast("setImages", this._availableImages), this.dispatcher.broadcast("spriteLoaded", !0), this.fire(new e1.Event("data", {
                        dataType: "style"
                    }));
                });
            }
            _validateLayer(t1) {
                const i = this.getSource(t1.source);
                if (!i) return;
                const o = t1.sourceLayer;
                o && ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(o)) && this.fire(new e1.ErrorEvent(new Error(`Source layer "${o}" does not exist on source "${i.id}" as specified by style layer "${t1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const e1 in this._sourceCaches)if (!this._sourceCaches[e1].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }
            _serializeLayers(e1) {
                const t1 = [];
                for (const i of e1){
                    const e1 = this._layers[i];
                    "custom" !== e1.type && t1.push(e1.serialize());
                }
                return t1;
            }
            hasTransitions() {
                if (this.light && this.light.hasTransition()) return !0;
                if (this.fog && this.fog.hasTransition()) return !0;
                for(const e1 in this._sourceCaches)if (this._sourceCaches[e1].hasTransition()) return !0;
                for(const e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }
            get order() {
                return this.map._optimizeForTerrain && this.terrain ? this._drapedFirstOrder : this._order;
            }
            isLayerDraped(e1) {
                return !!this.terrain && ("function" == typeof e1.isLayerDraped ? e1.isLayerDraped() : Jt[e1.type]);
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            update(t1) {
                if (!this._loaded) return;
                const i = this._changed;
                if (this._changed) {
                    const e1 = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (e1.length || i.length) && this._updateWorkerLayers(e1, i);
                    for(const e1 in this._updatedSources){
                        const t1 = this._updatedSources[e1];
                        "reload" === t1 ? this._reloadSource(e1) : "clear" === t1 && this._clearSource(e1);
                    }
                    this._updateTilesForChangedImages();
                    for(const e1 in this._updatedPaintProps)this._layers[e1].updateTransitions(t1);
                    this.light.updateTransitions(t1), this.fog && this.fog.updateTransitions(t1), this._resetUpdates();
                }
                const o = {};
                for(const e1 in this._sourceCaches){
                    const t1 = this._sourceCaches[e1];
                    o[e1] = t1.used, t1.used = !1;
                }
                for (const e1 of this._order){
                    const i = this._layers[e1];
                    if (i.recalculate(t1, this._availableImages), !i.isHidden(t1.zoom)) {
                        const e1 = this._getLayerSourceCache(i);
                        e1 && (e1.used = !0);
                    }
                    const o = this.map.painter;
                    if (o) {
                        const e1 = i.getProgramIds();
                        if (!e1) continue;
                        const r = i.getProgramConfiguration(t1.zoom);
                        for (const t1 of e1)o.useProgram(t1, r);
                    }
                }
                for(const t1 in o){
                    const i = this._sourceCaches[t1];
                    o[t1] !== i.used && i.getSource().fire(new e1.Event("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: i.getSource().id
                    }));
                }
                this.light.recalculate(t1), this.terrain && this.terrain.recalculate(t1), this.fog && this.fog.recalculate(t1), this.z = t1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), i && this.fire(new e1.Event("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const e1 = Object.keys(this._changedImages);
                if (e1.length) {
                    for(const t1 in this._sourceCaches)this._sourceCaches[t1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e1);
                    this._changedImages = {};
                }
            }
            _updateWorkerLayers(e1, t1) {
                this.dispatcher.broadcast("updateLayers", {
                    layers: this._serializeLayers(e1),
                    removedIds: t1
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
            }
            setState(i) {
                if (this._checkLoaded(), $t(this, e1.validateStyle(i))) return !1;
                (i = e1.clone$1(i)).layers = Ve(i.layers);
                const o = (function(e1, i) {
                    if (!e1) return [
                        {
                            command: We.setStyle,
                            args: [
                                i
                            ]
                        }
                    ];
                    let o = [];
                    try {
                        if (!t1(e1.version, i.version)) return [
                            {
                                command: We.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        t1(e1.center, i.center) || o.push({
                            command: We.setCenter,
                            args: [
                                i.center
                            ]
                        }), t1(e1.zoom, i.zoom) || o.push({
                            command: We.setZoom,
                            args: [
                                i.zoom
                            ]
                        }), t1(e1.bearing, i.bearing) || o.push({
                            command: We.setBearing,
                            args: [
                                i.bearing
                            ]
                        }), t1(e1.pitch, i.pitch) || o.push({
                            command: We.setPitch,
                            args: [
                                i.pitch
                            ]
                        }), t1(e1.sprite, i.sprite) || o.push({
                            command: We.setSprite,
                            args: [
                                i.sprite
                            ]
                        }), t1(e1.glyphs, i.glyphs) || o.push({
                            command: We.setGlyphs,
                            args: [
                                i.glyphs
                            ]
                        }), t1(e1.transition, i.transition) || o.push({
                            command: We.setTransition,
                            args: [
                                i.transition
                            ]
                        }), t1(e1.light, i.light) || o.push({
                            command: We.setLight,
                            args: [
                                i.light
                            ]
                        }), t1(e1.fog, i.fog) || o.push({
                            command: We.setFog,
                            args: [
                                i.fog
                            ]
                        }), t1(e1.projection, i.projection) || o.push({
                            command: We.setProjection,
                            args: [
                                i.projection
                            ]
                        });
                        const r = {}, n = [];
                        !function(e1, i, o, r) {
                            let n;
                            for(n in i = i || {}, e1 = e1 || {})e1.hasOwnProperty(n) && (i.hasOwnProperty(n) || qe(n, o, r));
                            for(n in i)i.hasOwnProperty(n) && (e1.hasOwnProperty(n) ? t1(e1[n], i[n]) || ("geojson" === e1[n].type && "geojson" === i[n].type && He(e1, i, n) ? o.push({
                                command: We.setGeoJSONSourceData,
                                args: [
                                    n,
                                    i[n].data
                                ]
                            }) : $e(n, i, o, r)) : Xe(n, i, o));
                        }(e1.sources, i.sources, n, r);
                        const s = [];
                        e1.layers && e1.layers.forEach((e1)=>{
                            e1.source && r[e1.source] ? o.push({
                                command: We.removeLayer,
                                args: [
                                    e1.id
                                ]
                            }) : s.push(e1);
                        });
                        let a = e1.terrain;
                        a && r[a.source] && (o.push({
                            command: We.setTerrain,
                            args: [
                                void 0
                            ]
                        }), a = void 0), o = o.concat(n), t1(a, i.terrain) || o.push({
                            command: We.setTerrain,
                            args: [
                                i.terrain
                            ]
                        }), function(e1, i, o) {
                            i = i || [];
                            const r = (e1 = e1 || []).map(Ke), n = i.map(Ke), s = e1.reduce(Je, {}), a = i.reduce(Je, {}), l = r.slice(), c = Object.create(null);
                            let h, u, _, d, p, m, f;
                            for(h = 0, u = 0; h < r.length; h++)_ = r[h], a.hasOwnProperty(_) ? u++ : (o.push({
                                command: We.removeLayer,
                                args: [
                                    _
                                ]
                            }), l.splice(l.indexOf(_, u), 1));
                            for(h = 0, u = 0; h < n.length; h++)_ = n[n.length - 1 - h], l[l.length - 1 - h] !== _ && (s.hasOwnProperty(_) ? (o.push({
                                command: We.removeLayer,
                                args: [
                                    _
                                ]
                            }), l.splice(l.lastIndexOf(_, l.length - u), 1)) : u++, m = l[l.length - h], o.push({
                                command: We.addLayer,
                                args: [
                                    a[_],
                                    m
                                ]
                            }), l.splice(l.length - h, 0, _), c[_] = !0);
                            for(h = 0; h < n.length; h++)if (_ = n[h], d = s[_], p = a[_], !c[_] && !t1(d, p)) {
                                if (t1(d.source, p.source) && t1(d["source-layer"], p["source-layer"]) && t1(d.type, p.type)) {
                                    for(f in Ye(d.layout, p.layout, o, _, null, We.setLayoutProperty), Ye(d.paint, p.paint, o, _, null, We.setPaintProperty), t1(d.filter, p.filter) || o.push({
                                        command: We.setFilter,
                                        args: [
                                            _,
                                            p.filter
                                        ]
                                    }), t1(d.minzoom, p.minzoom) && t1(d.maxzoom, p.maxzoom) || o.push({
                                        command: We.setLayerZoomRange,
                                        args: [
                                            _,
                                            p.minzoom,
                                            p.maxzoom
                                        ]
                                    }), d)d.hasOwnProperty(f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? Ye(d[f], p[f], o, _, f.slice(6), We.setPaintProperty) : t1(d[f], p[f]) || o.push({
                                        command: We.setLayerProperty,
                                        args: [
                                            _,
                                            f,
                                            p[f]
                                        ]
                                    }));
                                    for(f in p)p.hasOwnProperty(f) && !d.hasOwnProperty(f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? Ye(d[f], p[f], o, _, f.slice(6), We.setPaintProperty) : t1(d[f], p[f]) || o.push({
                                        command: We.setLayerProperty,
                                        args: [
                                            _,
                                            f,
                                            p[f]
                                        ]
                                    }));
                                } else o.push({
                                    command: We.removeLayer,
                                    args: [
                                        _
                                    ]
                                }), m = l[l.lastIndexOf(_) + 1], o.push({
                                    command: We.addLayer,
                                    args: [
                                        p,
                                        m
                                    ]
                                });
                            }
                        }(s, i.layers, o);
                    } catch (e1) {
                        console.warn("Unable to compute style diff:", e1), o = [
                            {
                                command: We.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                    }
                    return o;
                })(this.serialize(), i).filter((e1)=>!(e1.command in Yt));
                if (0 === o.length) return !1;
                const r = o.filter((e1)=>!(e1.command in Ht));
                if (r.length > 0) throw new Error(`Unimplemented: ${r.map((e1)=>e1.command).join(", ")}.`);
                return o.forEach((e1)=>{
                    "setTransition" !== e1.command && "setProjection" !== e1.command && this[e1.command].apply(this, e1.args);
                }), this.stylesheet = i, this._updateMapProjection(), !0;
            }
            addImage(t1, i) {
                return this.getImage(t1) ? this.fire(new e1.ErrorEvent(new Error("An image with this name already exists."))) : (this.imageManager.addImage(t1, i), this._afterImageUpdated(t1), this);
            }
            updateImage(e1, t1) {
                this.imageManager.updateImage(e1, t1);
            }
            getImage(e1) {
                return this.imageManager.getImage(e1);
            }
            removeImage(t1) {
                return this.getImage(t1) ? (this.imageManager.removeImage(t1), this._afterImageUpdated(t1), this) : this.fire(new e1.ErrorEvent(new Error("No image with this name exists.")));
            }
            _afterImageUpdated(t1) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[t1] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new e1.Event("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            addSource(t1, i, o = {}) {
                if (this._checkLoaded(), void 0 !== this.getSource(t1)) throw new Error("There is already a source with this ID");
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(e1.validateSource, `sources.${t1}`, i, null, o)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const r = Pe(t1, i, this.dispatcher, this);
                r.setEventedParent(this, ()=>({
                        isSourceLoaded: this._isSourceCacheLoaded(t1),
                        source: r.serialize(),
                        sourceId: t1
                    }));
                const n = (i)=>{
                    const o = (i ? "symbol:" : "other:") + t1, n = this._sourceCaches[o] = new e1.SourceCache(o, r, i);
                    (i ? this._symbolSourceCaches : this._otherSourceCaches)[t1] = n, n.style = this, n.onAdd(this.map);
                };
                n(!1), "vector" !== i.type && "geojson" !== i.type || n(!0), r.onAdd && r.onAdd(this.map), this._changed = !0;
            }
            removeSource(t1) {
                this._checkLoaded();
                const i = this.getSource(t1);
                if (!i) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t1) return this.fire(new e1.ErrorEvent(new Error(`Source "${t1}" cannot be removed while layer "${i}" is using it.`)));
                if (this.terrain && this.terrain.get().source === t1) return this.fire(new e1.ErrorEvent(new Error(`Source "${t1}" cannot be removed while terrain is using it.`)));
                const o = this._getSourceCaches(t1);
                for (const t1 of o)delete this._sourceCaches[t1.id], delete this._updatedSources[t1.id], t1.fire(new e1.Event("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: t1.getSource().id
                })), t1.setEventedParent(null), t1.clearTiles();
                return delete this._otherSourceCaches[t1], delete this._symbolSourceCaches[t1], i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this._changed = !0, this;
            }
            setGeoJSONSourceData(e1, t1) {
                this._checkLoaded(), this.getSource(e1).setData(t1), this._changed = !0;
            }
            getSource(e1) {
                const t1 = this._getSourceCache(e1);
                return t1 && t1.getSource();
            }
            _getSources() {
                const e1 = [];
                for(const t1 in this._otherSourceCaches){
                    const i = this._getSourceCache(t1);
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            addLayer(t1, i, o = {}) {
                this._checkLoaded();
                const r = t1.id;
                if (this.getLayer(r)) return void this.fire(new e1.ErrorEvent(new Error(`Layer with id "${r}" already exists on this map`)));
                let n;
                if ("custom" === t1.type) {
                    if ($t(this, e1.validateCustomStyleLayer(t1))) return;
                    n = e1.createStyleLayer(t1);
                } else {
                    if ("object" == typeof t1.source && (this.addSource(r, t1.source), t1 = e1.clone$1(t1), t1 = e1.extend(t1, {
                        source: r
                    })), this._validate(e1.validateLayer, `layers.${r}`, t1, {
                        arrayIndex: -1
                    }, o)) return;
                    n = e1.createStyleLayer(t1), this._validateLayer(n), n.setEventedParent(this, {
                        layer: {
                            id: r
                        }
                    }), this._serializedLayers[n.id] = n.serialize(), this._updateLayerCount(n, !0);
                }
                const s = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === s) return void this.fire(new e1.ErrorEvent(new Error(`Layer with id "${i}" does not exist on this map.`)));
                this._order.splice(s, 0, r), this._layerOrderChanged = !0, this._layers[r] = n;
                const a = this._getLayerSourceCache(n);
                if (this._removedLayers[r] && n.source && a && "custom" !== n.type) {
                    const e1 = this._removedLayers[r];
                    delete this._removedLayers[r], e1.type !== n.type ? this._updatedSources[n.source] = "clear" : (this._updatedSources[n.source] = "reload", a.pause());
                }
                this._updateLayer(n), n.onAdd && n.onAdd(this.map), this._updateDrapeFirstLayers();
            }
            moveLayer(t1, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[t1]) return void this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style and cannot be moved.`)));
                if (t1 === i) return;
                const o = this._order.indexOf(t1);
                this._order.splice(o, 1);
                const r = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === r ? this.fire(new e1.ErrorEvent(new Error(`Layer with id "${i}" does not exist on this map.`))) : (this._order.splice(r, 0, t1), this._layerOrderChanged = !0, this._updateDrapeFirstLayers());
            }
            removeLayer(t1) {
                this._checkLoaded();
                const i = this._layers[t1];
                if (!i) return void this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style and cannot be removed.`)));
                i.setEventedParent(null), this._updateLayerCount(i, !1);
                const o = this._order.indexOf(t1);
                this._order.splice(o, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[t1] = i, delete this._layers[t1], delete this._serializedLayers[t1], delete this._updatedLayers[t1], delete this._updatedPaintProps[t1], i.onRemove && i.onRemove(this.map), this._updateDrapeFirstLayers();
            }
            getLayer(e1) {
                return this._layers[e1];
            }
            hasLayer(e1) {
                return e1 in this._layers;
            }
            hasLayerType(e1) {
                for(const t1 in this._layers)if (this._layers[t1].type === e1) return !0;
                return !1;
            }
            setLayerZoomRange(t1, i, o) {
                this._checkLoaded();
                const r = this.getLayer(t1);
                r ? r.minzoom === i && r.maxzoom === o || (null != i && (r.minzoom = i), null != o && (r.maxzoom = o), this._updateLayer(r)) : this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style and cannot have zoom extent.`)));
            }
            setFilter(i, o, r = {}) {
                this._checkLoaded();
                const n = this.getLayer(i);
                if (n) {
                    if (!t1(n.filter, o)) return null == o ? (n.filter = void 0, void this._updateLayer(n)) : void (this._validate(e1.validateFilter, `layers.${n.id}.filter`, o, {
                        layerType: n.type
                    }, r) || (n.filter = e1.clone$1(o), this._updateLayer(n)));
                } else this.fire(new e1.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be filtered.`)));
            }
            getFilter(t1) {
                const i = this.getLayer(t1);
                return i && e1.clone$1(i.filter);
            }
            setLayoutProperty(i, o, r, n = {}) {
                this._checkLoaded();
                const s = this.getLayer(i);
                s ? t1(s.getLayoutProperty(o), r) || (s.setLayoutProperty(o, r, n), this._updateLayer(s)) : this.fire(new e1.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be styled.`)));
            }
            getLayoutProperty(t1, i) {
                const o = this.getLayer(t1);
                if (o) return o.getLayoutProperty(i);
                this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style.`)));
            }
            setPaintProperty(i, o, r, n = {}) {
                this._checkLoaded();
                const s = this.getLayer(i);
                s ? t1(s.getPaintProperty(o), r) || (s.setPaintProperty(o, r, n) && this._updateLayer(s), this._changed = !0, this._updatedPaintProps[i] = !0) : this.fire(new e1.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be styled.`)));
            }
            getPaintProperty(e1, t1) {
                const i = this.getLayer(e1);
                return i && i.getPaintProperty(t1);
            }
            setFeatureState(t1, i) {
                this._checkLoaded();
                const o = t1.source, r = t1.sourceLayer, n = this.getSource(o);
                if (!n) return void this.fire(new e1.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));
                const s = n.type;
                if ("geojson" === s && r) return void this.fire(new e1.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === s && !r) return void this.fire(new e1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === t1.id && this.fire(new e1.ErrorEvent(new Error("The feature id parameter must be provided.")));
                const a = this._getSourceCaches(o);
                for (const e1 of a)e1.setFeatureState(r, t1.id, i);
            }
            removeFeatureState(t1, i) {
                this._checkLoaded();
                const o = t1.source, r = this.getSource(o);
                if (!r) return void this.fire(new e1.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));
                const n = r.type, s = "vector" === n ? t1.sourceLayer : void 0;
                if ("vector" === n && !s) return void this.fire(new e1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (i && "string" != typeof t1.id && "number" != typeof t1.id) return void this.fire(new e1.ErrorEvent(new Error("A feature id is required to remove its specific state property.")));
                const a = this._getSourceCaches(o);
                for (const e1 of a)e1.removeFeatureState(s, t1.id, i);
            }
            getFeatureState(t1) {
                this._checkLoaded();
                const i = t1.source, o = t1.sourceLayer, r = this.getSource(i);
                if (r) {
                    if ("vector" !== r.type || o) return void 0 === t1.id && this.fire(new e1.ErrorEvent(new Error("The feature id parameter must be provided."))), this._getSourceCaches(i)[0].getFeatureState(o, t1.id);
                    this.fire(new e1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                } else this.fire(new e1.ErrorEvent(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                return e1.extend({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }
            serialize() {
                const t1 = {};
                for(const e1 in this._sourceCaches){
                    const i = this._sourceCaches[e1].getSource();
                    t1[i.id] || (t1[i.id] = i.serialize());
                }
                return e1.filterObject({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    light: this.stylesheet.light,
                    terrain: this.getTerrain() || void 0,
                    fog: this.stylesheet.fog,
                    center: this.stylesheet.center,
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: t1,
                    layers: this._serializeLayers(this._order)
                }, (e1)=>void 0 !== e1);
            }
            _updateLayer(e1) {
                this._updatedLayers[e1.id] = !0;
                const t1 = this._getLayerSourceCache(e1);
                e1.source && !this._updatedSources[e1.source] && t1 && "raster" !== t1.getSource().type && (this._updatedSources[e1.source] = "reload", t1.pause()), this._changed = !0, e1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e1) {
                const t1 = (e1)=>"fill-extrusion" === this._layers[e1].type, i = {}, o = [];
                for(let r = this._order.length - 1; r >= 0; r--){
                    const n = this._order[r];
                    if (t1(n)) {
                        i[n] = r;
                        for (const t1 of e1){
                            const e1 = t1[n];
                            if (e1) for (const t1 of e1)o.push(t1);
                        }
                    }
                }
                o.sort((e1, t1)=>t1.intersectionZ - e1.intersectionZ);
                const r = [];
                for(let n = this._order.length - 1; n >= 0; n--){
                    const s = this._order[n];
                    if (t1(s)) for(let e1 = o.length - 1; e1 >= 0; e1--){
                        const t1 = o[e1].feature;
                        if (i[t1.layer.id] < n) break;
                        r.push(t1), o.pop();
                    }
                    else for (const t1 of e1){
                        const e1 = t1[s];
                        if (e1) for (const t1 of e1)r.push(t1.feature);
                    }
                }
                return r;
            }
            queryRenderedFeatures(t1, i, o) {
                i && i.filter && this._validate(e1.validateFilter, "queryRenderedFeatures.filter", i.filter, null, i);
                const r = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e1.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
                    for (const t1 of i.layers){
                        const i = this._layers[t1];
                        if (!i) return this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        r[i.source] = !0;
                    }
                }
                const n = [];
                i.availableImages = this._availableImages;
                const s = i && i.layers ? i.layers.some((e1)=>{
                    const t1 = this.getLayer(e1);
                    return t1 && t1.is3D();
                }) : this.has3DLayers(), a = R.createFromScreenPoints(t1, o);
                for(const e1 in this._sourceCaches){
                    const t1 = this._sourceCaches[e1].getSource().id;
                    i.layers && !r[t1] || n.push(Oe(this._sourceCaches[e1], this._layers, this._serializedLayers, a, i, o, s, !!this.map._showQueryGeometry));
                }
                return this.placement && n.push(function(e1, t1, i, o, r, n, s) {
                    const a = {}, l = n.queryRenderedSymbols(o), c = [];
                    for (const e1 of Object.keys(l).map(Number))c.push(s[e1]);
                    c.sort(ke);
                    for (const i of c){
                        const o = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t1, i.bucketIndex, i.sourceLayerIndex, r.filter, r.layers, r.availableImages, e1);
                        for(const e1 in o){
                            const t1 = a[e1] = a[e1] || [], r = o[e1];
                            r.sort((e1, t1)=>{
                                const o = i.featureSortOrder;
                                if (o) {
                                    const i = o.indexOf(e1.featureIndex);
                                    return o.indexOf(t1.featureIndex) - i;
                                }
                                return t1.featureIndex - e1.featureIndex;
                            });
                            for (const e1 of r)t1.push(e1);
                        }
                    }
                    for(const t1 in a)a[t1].forEach((o)=>{
                        const r = o.feature, n = i(e1[t1]).getFeatureState(r.layer["source-layer"], r.id);
                        r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = n;
                    });
                    return a;
                }(this._layers, this._serializedLayers, this._getLayerSourceCache.bind(this), a.screenGeometry, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(n);
            }
            querySourceFeatures(t1, i) {
                i && i.filter && this._validate(e1.validateFilter, "querySourceFeatures.filter", i.filter, null, i);
                const o = this._getSourceCaches(t1);
                let r = [];
                for (const e1 of o)r = r.concat(Be(e1, i));
                return r;
            }
            addSourceType(e1, t1, i) {
                return Qt.getSourceType(e1) ? i(new Error(`A source type called "${e1}" already exists.`)) : (Qt.setSourceType(e1, t1), t1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: e1,
                    url: t1.workerSourceURL
                }, i) : i(null, null));
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(e1, i = {}) {
                this._checkLoaded();
                const o = this.light.getLight();
                let r = !1;
                for(const i in e1)if (!t1(e1[i], o[i])) {
                    r = !0;
                    break;
                }
                if (!r) return;
                const n = this._setTransitionParameters({
                    duration: 300,
                    delay: 0
                });
                this.light.setLight(e1, i), this.light.updateTransitions(n);
            }
            getTerrain() {
                return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            setTerrain(i, o = 1) {
                if (this._checkLoaded(), !i) return delete this.terrain, delete this.stylesheet.terrain, this.dispatcher.broadcast("enableTerrain", !1), this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                if (1 === o) {
                    if ("object" == typeof i.source) {
                        const t1 = "terrain-dem-src";
                        this.addSource(t1, i.source), i = e1.clone$1(i), i = e1.extend(i, {
                            source: t1
                        });
                    }
                    if (this._validate(e1.validateTerrain, "terrain", i)) return;
                }
                if (!this.terrain || this.terrain && o !== this.terrain.drapeRenderMode) this._createTerrain(i, o);
                else {
                    const o = this.terrain, r = o.get();
                    for (const t1 of Object.keys(e1.spec.terrain))!i.hasOwnProperty(t1) && e1.spec.terrain[t1].default && (i[t1] = e1.spec.terrain[t1].default);
                    for(const e1 in i)if (!t1(i[e1], r[e1])) {
                        o.set(i), this.stylesheet.terrain = i;
                        const e1 = this._setTransitionParameters({
                            duration: 0
                        });
                        o.updateTransitions(e1);
                        break;
                    }
                }
                this._updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e1) {
                const t1 = this.fog = new A(e1, this.map.transform);
                this.stylesheet.fog = e1;
                const i = this._setTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e1 of this.map._markers)e1._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(e1) {
                if (this._checkLoaded(), !e1) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
                if (this.fog) {
                    const i = this.fog, o = i.get();
                    0 === Object.keys(e1).length && i.set(e1);
                    for(const r in e1)if (!t1(e1[r], o[r])) {
                        i.set(e1), this.stylesheet.fog = e1;
                        const t1 = this._setTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(t1);
                        break;
                    }
                } else this._createFog(e1);
                this._markersNeedUpdate = !0;
            }
            _setTransitionParameters(t1) {
                return {
                    now: e1.exported.now(),
                    transition: e1.extend(t1, this.stylesheet.transition)
                };
            }
            _updateDrapeFirstLayers() {
                if (!this.map._optimizeForTerrain || !this.terrain) return;
                const e1 = this._order.filter((e1)=>this.isLayerDraped(this._layers[e1])), t1 = this._order.filter((e1)=>!this.isLayerDraped(this._layers[e1]));
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e1), this._drapedFirstOrder.push(...t1);
            }
            _createTerrain(e1, t1) {
                const i = this.terrain = new M(e1, t1);
                this.stylesheet.terrain = e1, this.dispatcher.broadcast("enableTerrain", !this.terrainSetForDrapingOnly()), this._force3DLayerUpdate();
                const o = this._setTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(o);
            }
            _force3DLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "fill-extrusion" === t1.type && this._updateLayer(t1);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "symbol" === t1.type && this._updateLayer(t1);
                }
            }
            _validate(t1, i, o, r, n = {}) {
                return (!n || !1 !== n.validate) && $t(this, t1.call(e1.validateStyle, e1.extend({
                    key: i,
                    style: this.serialize(),
                    value: o,
                    styleSpec: e1.spec
                }, r)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e1.evented.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e1 in this._layers)this._layers[e1].setEventedParent(null);
                for(const e1 in this._sourceCaches)this._sourceCaches[e1].clearTiles(), this._sourceCaches[e1].setEventedParent(null);
                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
            }
            _clearSource(e1) {
                const t1 = this._getSourceCaches(e1);
                for (const e1 of t1)e1.clearTiles();
            }
            _reloadSource(e1) {
                const t1 = this._getSourceCaches(e1);
                for (const e1 of t1)e1.resume(), e1.reload();
            }
            _reloadSources() {
                for (const e1 of this._getSources())e1.reload && e1.reload();
            }
            _updateSources(e1) {
                for(const t1 in this._sourceCaches)this._sourceCaches[t1].update(e1);
            }
            _generateCollisionBoxes() {
                for(const e1 in this._sourceCaches){
                    const t1 = this._sourceCaches[e1];
                    t1.resume(), t1.reload();
                }
            }
            _updatePlacement(t1, i, o, r, n = !1) {
                let s = !1, a = !1;
                const l = {};
                for (const e1 of this._order){
                    const i = this._layers[e1];
                    if ("symbol" !== i.type) continue;
                    if (!l[i.source]) {
                        const e1 = this._getLayerSourceCache(i);
                        if (!e1) continue;
                        l[i.source] = e1.getRenderableIds(!0).map((t1)=>e1.getTileByID(t1)).sort((e1, t1)=>t1.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t1.tileID) ? -1 : 1));
                    }
                    const o = this.crossTileSymbolIndex.addLayer(i, l[i.source], t1.center.lng, t1.projection);
                    s = s || o;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), n = n || this._layerOrderChanged || 0 === o, this._layerOrderChanged && this.fire(new e1.Event("neworder")), (n || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e1.exported.now(), t1.zoom)) && (this.pauseablePlacement = new jt(t1, this._order, n, i, o, r, this.placement, this.fog && t1.projection.supportsFog ? this.fog.state : null), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e1.exported.now()), a = !0), s && this.pauseablePlacement.placement.setStale()), a || s) for (const e1 of this._order){
                    const t1 = this._layers[e1];
                    "symbol" === t1.type && this.placement.updateLayerOpacities(t1, l[t1.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e1.exported.now());
            }
            _releaseSymbolFadeTiles() {
                for(const e1 in this._sourceCaches)this._sourceCaches[e1].releaseSymbolFadeTiles();
            }
            getImages(e1, t1, i) {
                this.imageManager.getImages(t1.icons, i), this._updateTilesForChangedImages();
                const o = (e1)=>{
                    e1 && e1.setDependencies(t1.tileID.key, t1.type, t1.icons);
                };
                o(this._otherSourceCaches[t1.source]), o(this._symbolSourceCaches[t1.source]);
            }
            getGlyphs(e1, t1, i) {
                this.glyphManager.getGlyphs(t1.stacks, i);
            }
            getResource(t1, i, o) {
                return e1.makeRequest(i, o);
            }
            _getSourceCache(e1) {
                return this._otherSourceCaches[e1];
            }
            _getLayerSourceCache(e1) {
                return "symbol" === e1.type ? this._symbolSourceCaches[e1.source] : this._otherSourceCaches[e1.source];
            }
            _getSourceCaches(e1) {
                const t1 = [];
                return this._otherSourceCaches[e1] && t1.push(this._otherSourceCaches[e1]), this._symbolSourceCaches[e1] && t1.push(this._symbolSourceCaches[e1]), t1;
            }
            _isSourceCacheLoaded(t1) {
                const i = this._getSourceCaches(t1);
                return 0 === i.length ? (this.fire(new e1.ErrorEvent(new Error(`There is no source with ID '${t1}'`))), !1) : i.every((e1)=>e1.loaded());
            }
            has3DLayers() {
                return this._num3DLayers > 0;
            }
            hasSymbolLayers() {
                return this._numSymbolLayers > 0;
            }
            hasCircleLayers() {
                return this._numCircleLayers > 0;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            destroy() {
                this._clearWorkerCaches(), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
        }
        Qt.getSourceType = function(e1) {
            return ze[e1];
        }, Qt.setSourceType = function(e1, t1) {
            ze[e1] = t1;
        }, Qt.registerForPluginStateChange = e1.registerForPluginStateChange;
        var ei = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#define EXTENT 8192.0\n#define HALF_PI PI/2.0\n#define QUARTER_PI PI/4.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0", ti = "attribute highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;varying highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", ii = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\nconst float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}\n#ifdef TERRAIN\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;\n#else\nuniform sampler2D u_dem;uniform sampler2D u_dem_prev;\n#endif\nuniform vec4 u_dem_unpack;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;uniform sampler2D u_depth;uniform vec2 u_depth_size_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float decodeElevation(vec4 v) {return dot(vec4(v.xyz*255.0,-1.0),u_dem_unpack);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem,pos));\n#ifdef TERRAIN_DEM_NEAREST_FILTER\nreturn u_exaggeration*tl;\n#endif\nfloat tr=decodeElevation(texture2D(u_dem,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem_prev,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem_prev,pos));float tr=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem_prev,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}bool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;float depth=unpack_depth(texture2D(u_depth,(coord.xy+1.0)*0.5));return coord.z > depth+0.0005;}float occlusionFade(vec4 frag) {vec3 coord=frag.xyz/frag.w;vec3 df=vec3(5.0*u_depth_size_inv,0.0);vec2 uv=0.5*coord.xy+0.5;vec4 depth=vec4(\nunpack_depth(texture2D(u_depth,uv-df.xz)),unpack_depth(texture2D(u_depth,uv+df.xz)),unpack_depth(texture2D(u_depth,uv-df.zy)),unpack_depth(texture2D(u_depth,uv+df.zy))\n);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z-0.001)-depth),0.0,1.0));}vec4 fourSample(vec2 pos,vec2 off) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nfloat tl=texture2D(u_dem,pos).a;float tr=texture2D(u_dem,pos+vec2(off.x,0.0)).a;float bl=texture2D(u_dem,pos+vec2(0.0,off.y)).a;float br=texture2D(u_dem,pos+off).a;\n#else\nvec4 demtl=vec4(texture2D(u_dem,pos).xyz*255.0,-1.0);float tl=dot(demtl,u_dem_unpack);vec4 demtr=vec4(texture2D(u_dem,pos+vec2(off.x,0.0)).xyz*255.0,-1.0);float tr=dot(demtr,u_dem_unpack);vec4 dembl=vec4(texture2D(u_dem,pos+vec2(0.0,off.y)).xyz*255.0,-1.0);float bl=dot(dembl,u_dem_unpack);vec4 dembr=vec4(texture2D(u_dem,pos+off).xyz*255.0,-1.0);float br=dot(dembr,u_dem_unpack);\n#endif\nreturn vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }bool isOccluded(vec4 frag) { return false; }float occlusionFade(vec4 frag) { return 1.0; }\n#endif", oi = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;varying vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", ri = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump float u_fog_temporal_offset;varying vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,opacity);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec3 fog_dither(vec3 color) {vec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif";
        let ni = {}, si = {};
        const ai = [];
        _i(ei, ai), _i(ii, ai), _i(oi, ai), _i(ri, ai), ni = di("", ii), si = di(ri, oi);
        const li = di("\n#if __VERSION__ >=300\n#define varying in\n#define gl_FragColor glFragColor\n#define texture2D texture\n#define textureCube texture\nout vec4 glFragColor;\n#endif\nhighp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}", "\n#if __VERSION__ >=300\n#define attribute in\n#define varying out\n#define texture2D texture\n#endif\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}const vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);//Normalized device coordinate that is not rendered."), ci = ei, hi = "\n#ifdef GL_ES\nprecision mediump float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif";
        var ui = {
            background: di("uniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nvarying vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform vec4 u_color;varying vec4 v_color;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting(u_color);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            backgroundPattern: di("uniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos;void main() {vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            circle: di("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\ngl_FragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}"),
            clippingMask: di("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: di("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {gl_FragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),
            heatmapTexture: di("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),
            collisionBox: di("varying float v_placed;varying float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);gl_FragColor =mix(red,blue,step(0.5,v_placed))*0.5;gl_FragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", "attribute vec3 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;attribute float a_size_scale;attribute vec2 a_padding;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*elevation(a_anchor_pos),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: di("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos_2f;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: di("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;\n#endif\nvarying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}"),
            fill: di("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            fillOutline: di("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            fillOutlinePattern: di("uniform vec2 u_texsize;uniform sampler2D u_image;varying vec2 v_pos;varying vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos;varying vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            fillPattern: di("uniform vec2 u_texsize;uniform sampler2D u_image;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec4 out_color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            fillExtrusion: di("varying vec4 v_color;\n#ifdef RENDER_SHADOWS\nvarying highp vec4 v_pos_light_view_0;varying highp vec4 v_pos_light_view_1;varying float v_depth;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#ifdef ZERO_ROOF_RADIUS\nvarying vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS)\nvarying highp vec3 v_normal;\n#endif\nvoid main() {\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS)\nvec3 normal=v_normal;\n#endif\nfloat z;vec4 color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);color=mix(v_color,v_roof_color,z);\n#else\ncolor=v_color;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);color.rgb=color.rgb*shade;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef ZERO_ROOF_RADIUS\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#endif\ncolor.xyz=shadowed_color_normal(color.xyz,normalize(normal),v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec4 v_color;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;varying highp vec4 v_pos_light_view_0;varying highp vec4 v_pos_light_view_1;varying float v_depth;\n#endif\n#ifdef ZERO_ROOF_RADIUS\nvarying vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS)\nvarying highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS)\nv_normal=normal;\n#endif\nbase=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele;vec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nv_pos_light_view_0=u_light_matrix_0*vec4(pos,1);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1);v_depth=gl_Position.w;\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}v_color=vec4(0.0,0.0,0.0,1.0);\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting(color,NdotL);\n#else\nv_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));\n#endif\nv_color*=u_opacity;\n#ifdef ZERO_ROOF_RADIUS\nv_roof_color=vec4(0.0,0.0,0.0,1.0);\n#ifdef LIGHTING_3D_MODE\nv_roof_color=apply_lighting(color,calculate_NdotL(vec3(0.0,0.0,1.0)));\n#else\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));\n#endif\nv_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),
            fillExtrusionPattern: di("uniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nvarying float v_NdotL;\n#endif\nvarying vec2 v_pos;varying vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec4 out_color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,v_NdotL)*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec2 v_pos;varying vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nvarying float v_NdotL;\n#endif\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_NdotL=NdotL;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif \n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}"),
            hillshadePrepare: di("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nreturn texture2D(u_image,coord).a/4.0;\n#else\nvec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;\n#endif\n}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: di("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;void main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\ngl_FragColor=apply_lighting(gl_FragColor);\n#endif\n#ifdef FOG\ngl_FragColor=fog_dither(fog_apply_premultiplied(gl_FragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            line: di("uniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;varying vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\nuniform float u_border_width;uniform vec4 u_border_color;float luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture2D(u_dash_image,v_tex).a;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;alpha*=linearstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture2D(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trimmed=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {out_color=vec4(0,0,0,0);trimmed=0.0;}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef RENDER_LINE_ALPHA_DISCARD\nif (alpha < u_alpha_discard_threshold) {discard;}\n#endif\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=(u_border_width+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);\n#ifdef RENDER_LINE_BORDER_AUTO\nfloat Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}\n#else\nout_color.rgb=mix(u_border_color.rgb*u_border_color.a*trimmed,out_color.rgb,smoothAlpha);\n#endif\n}\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define EXTRUDE_SCALE 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nattribute highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nattribute float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;varying vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/floorwidth,(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),
            linePattern: di("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_tile_units_to_pixels;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;vec2 pattern_size=vec2(display_size.x/u_tile_units_to_pixels,display_size.y);float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x=mod(v_linesofar/pattern_size.x*aspect,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));vec4 color=texture2D(u_image,pos);\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting(color);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_linesofar;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),
            raster: di("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply(out_color,v_fog_pos));\n#endif\ngl_FragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {float w=1.0+dot(a_texture_pos,u_perspective_transform);gl_Position=u_matrix*vec4(a_pos*w,0,w);v_pos0=a_texture_pos/8192.0;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            symbolIcon: di("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjected_point;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetProjected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\noffsetProjected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetProjected_point.xy/offsetProjected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change))*projection_transition_fade;}"),
            symbolSDF: di("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat gamma_scale=gl_Position.w;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade);}"),
            symbolTextAndIcon: di("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offset_projected_point=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projected_point.xy/projected_point.w;vec2 b=offset_projected_point.xy/offset_projected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*font_scale);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade,is_sdf);}"),
            terrainRaster: di("uniform sampler2D u_image0;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nvarying vec4 v_pos_light_view_0;varying vec4 v_pos_light_view_1;varying float v_depth;\n#endif\nvoid main() {vec4 color=texture2D(u_image0,v_pos0);\n#ifdef RENDER_SHADOWS\ncolor.xyz=shadowed_color(color.xyz,v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\ngl_FragColor=color;\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_skirt_height;attribute vec2 a_pos;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;varying vec4 v_pos_light_view_0;varying vec4 v_pos_light_view_1;varying float v_depth;\n#endif\nconst float wireframeOffset=0.00015;void main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;\n#ifdef TERRAIN_WIREFRAME\nelevation+=wireframeOffset;\n#endif\nv_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);v_depth=gl_Position.w;\n#endif\n}"),
            terrainDepth: di("#ifdef GL_ES\nprecision highp float;\n#endif\nvarying float v_depth;void main() {gl_FragColor=pack_depth(v_depth);}", "uniform mat4 u_matrix;attribute vec2 a_pos;varying float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}"),
            skybox: di("\nvarying lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=textureCube(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);gl_FragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", ti),
            skyboxGradient: di("varying highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture2D(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);gl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", ti),
            skyboxCapture: di("\nvarying highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;\n#ifdef GL_ES\nprecision highp float;\n#endif\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;gl_FragColor=vec4(color,1.0);}", "attribute highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;varying highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: di("uniform sampler2D u_image0;varying vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture2D(u_image0,v_pos0);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#else\ncolor=texture2D(u_image0,v_pos0);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color;\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nattribute vec3 a_globe_pos;attribute vec2 a_uv;\n#else\nattribute vec2 a_pos;\n#endif\nvarying vec2 v_pos0;const float wireframeOffset=1e3;float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(QUARTER_PI+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);\n#ifdef TERRAIN_WIREFRAME\nheight+=wireframeOffset;\n#endif\nglobe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}"),
            globeAtmosphere: di("uniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec3 u_start_color;uniform vec4 u_color;uniform vec4 u_space_color;uniform vec4 u_high_color;uniform float u_star_intensity;uniform float u_star_size;uniform float u_star_density;uniform float u_horizon_angle;uniform mat4 u_rotation_matrix;varying highp vec3 v_ray_dir;varying highp vec3 v_horizon_dir;highp float random(highp vec3 p) {p=fract(p*vec3(23.2342,97.1231,91.2342));p+=dot(p.zxy,p.yxz+123.1234);return fract(p.x*p.y);}float stars(vec3 p,float scale,vec2 offset) {vec2 uv_scale=(u_viewport/u_star_size)*scale;vec3 position=vec3(p.xy*uv_scale+offset*u_viewport,p.z);vec3 q=fract(position)-0.5;vec3 id=floor(position);float random_visibility=step(random(id),u_star_density);float circle=smoothstep(0.5+u_star_intensity,0.5,length(q));return circle*random_visibility;}void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {discard;return;}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(dot(dir,horizon_dir)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;float closest_point_to_center=length(closest_point-u_globe_pos);float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;vec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c =mix(color_stop_2,c2,t);float a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);vec2 uv=gl_FragCoord.xy/u_viewport-0.5;float aspect_ratio=u_viewport.x/u_viewport.y;vec4 uv_dir=vec4(normalize(vec3(uv.x*aspect_ratio,uv.y,1.0)),1.0);uv_dir=u_rotation_matrix*uv_dir;vec3 n=abs(uv_dir.xyz);vec2 uv_remap=(n.x > n.y && n.x > n.z) ? uv_dir.yz/uv_dir.x:\n(n.y > n.x && n.y > n.z) ? uv_dir.zx/uv_dir.y:\nuv_dir.xy/uv_dir.z;uv_remap.x/=aspect_ratio;vec3 D=vec3(uv_remap,1.0);highp float star_field=0.0;if (u_star_intensity > 0.0) {star_field+=stars(D,1.2,vec2(0.0,0.0));star_field+=stars(D,1.0,vec2(1.0,0.0));star_field+=stars(D,0.8,vec2(0.0,1.0));star_field+=stars(D,0.6,vec2(1.0,1.0));star_field*=(1.0-pow(t,0.25+(1.0-u_high_color.a)*0.75));c+=star_field*alpha_2;}c=dither(c,gl_FragCoord.xy+u_temporal_offset);gl_FragColor=vec4(c,a);}", "attribute vec3 a_pos;attribute vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;varying highp vec3 v_ray_dir;varying highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}")
        };
        function _i(e1, t1) {
            const i = e1.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
            for (let e1 of i)if (e1 = e1.trim(), "#" === e1[0] && e1.includes("if") && !e1.includes("endif")) {
                e1 = e1.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
                const i = e1.split(" ");
                for (const e1 of i)t1.includes(e1) || t1.push(e1);
            }
        }
        function di(e1, t1) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, o = t1.match(/attribute (highp |mediump |lowp )?([\w]+) ([\w]+)/g), r = {}, n = [
                ...ai
            ];
            return _i(e1, n), _i(t1, n), {
                fragmentSource: e1 = e1.replace(i, (e1, t1, i, o, n)=>(r[n] = !0, "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${n}\nvarying ${i} ${o} ${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = u_${n};\n#endif\n`)),
                vertexSource: t1 = t1.replace(i, (e1, t1, i, o, n)=>{
                    const s = "float" === o ? "vec2" : "vec4", a = n.match(/color/) ? "color" : s;
                    return r[n] ? "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nattribute ${i} ${s} a_${n};\nvarying ${i} ${o} ${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n` : "vec4" === a ? `\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = a_${n};\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = unpack_mix_${a}(a_${n}, u_${n}_t);\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n` : "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nattribute ${i} ${s} a_${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n` : "vec4" === a ? `\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = a_${n};\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = unpack_mix_${a}(a_${n}, u_${n}_t);\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`;
                }),
                staticAttributes: o,
                usedDefines: n
            };
        }
        class pi {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
            bind(e1, t1, i, o, r, n, s) {
                this.context = e1;
                let a = this.boundPaintVertexBuffers.length !== o.length;
                for(let e1 = 0; !a && e1 < o.length; e1++)this.boundPaintVertexBuffers[e1] !== o[e1] && (a = !0);
                let l = this.boundDynamicVertexBuffers.length !== s.length;
                for(let e1 = 0; !l && e1 < s.length; e1++)this.boundDynamicVertexBuffers[e1] !== s[e1] && (l = !0);
                if (!e1.extVertexArrayObject || !this.vao || this.boundProgram !== t1 || this.boundLayoutVertexBuffer !== i || a || l || this.boundIndexBuffer !== r || this.boundVertexOffset !== n) this.freshBind(t1, i, o, r, n, s);
                else {
                    e1.bindVertexArrayOES.set(this.vao);
                    for (const e1 of s)e1 && e1.bind();
                    r && r.dynamicDraw && r.bind();
                }
            }
            freshBind(e1, t1, i, o, r, n) {
                let s;
                const a = e1.numAttributes, l = this.context, c = l.gl;
                if (l.extVertexArrayObject) this.vao && this.destroy(), this.vao = l.extVertexArrayObject.createVertexArrayOES(), l.bindVertexArrayOES.set(this.vao), s = 0, this.boundProgram = e1, this.boundLayoutVertexBuffer = t1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = r, this.boundDynamicVertexBuffers = n;
                else {
                    s = l.currentNumAttributes || 0;
                    for(let e1 = a; e1 < s; e1++)c.disableVertexAttribArray(e1);
                }
                t1.enableAttributes(c, e1), t1.bind(), t1.setVertexAttribPointers(c, e1, r);
                for (const t1 of i)t1.enableAttributes(c, e1), t1.bind(), t1.setVertexAttribPointers(c, e1, r);
                for (const t1 of n)t1 && (t1.enableAttributes(c, e1), t1.bind(), t1.setVertexAttribPointers(c, e1, r));
                o && o.bind(), l.currentNumAttributes = a;
            }
            destroy() {
                this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
            }
        }
        function mi(t1, i) {
            const o = Math.pow(2, i.canonical.z), r = i.canonical.y;
            return [
                new e1.MercatorCoordinate(0, r / o).toLngLat().lat,
                new e1.MercatorCoordinate(0, (r + 1) / o).toLngLat().lat
            ];
        }
        function fi(t1, i, o, r, n, s, a) {
            const l = t1.context, c = l.gl, h = o.fbo;
            if (!h) return;
            t1.prepareDrawTile();
            const u = t1.useProgram("hillshade");
            l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment.get());
            const _ = ((e1, t1, i, o)=>{
                const r = i.paint.get("hillshade-shadow-color"), n = i.paint.get("hillshade-highlight-color"), s = i.paint.get("hillshade-accent-color");
                let a = i.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                "viewport" === i.paint.get("hillshade-illumination-anchor") && (a -= e1.transform.angle);
                const l = !e1.options.moving;
                return {
                    u_matrix: o || e1.transform.calculateProjMatrix(t1.tileID.toUnwrapped(), l),
                    u_image: 0,
                    u_latrange: mi(0, t1.tileID),
                    u_light: [
                        i.paint.get("hillshade-exaggeration"),
                        a
                    ],
                    u_shadow: r,
                    u_highlight: n,
                    u_accent: s
                };
            })(t1, o, r, t1.terrain ? i.projMatrix : null);
            t1.prepareDrawProgram(l, u, i.toUnwrapped());
            const { tileBoundsBuffer: d, tileBoundsIndexBuffer: p, tileBoundsSegments: m } = t1.getTileBoundsBuffers(o);
            u.draw(l, c.TRIANGLES, n, s, a, e1.CullFaceMode.disabled, _, r.id, d, p, m);
        }
        function gi(t1, i, o) {
            if (!i.needsDEMTextureUpload) return;
            const r = t1.context, n = r.gl;
            r.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t1.getTileTexture(o.stride);
            const s = o.getPixels();
            i.demTexture ? i.demTexture.update(s, {
                premultiply: !1
            }) : i.demTexture = new e1.Texture(r, s, n.RGBA, {
                premultiply: !1
            }), i.needsDEMTextureUpload = !1;
        }
        function vi(t1, i, o, r, n, s) {
            const a = t1.context, l = a.gl;
            if (!i.dem) return;
            const c = i.dem;
            if (a.activeTexture.set(l.TEXTURE1), gi(t1, i, c), !i.demTexture) return;
            i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
            const h = c.dim;
            a.activeTexture.set(l.TEXTURE0);
            let u = i.fbo;
            if (!u) {
                const t1 = new e1.Texture(a, {
                    width: h,
                    height: h,
                    data: null
                }, l.RGBA);
                t1.bind(l.LINEAR, l.CLAMP_TO_EDGE), u = i.fbo = a.createFramebuffer(h, h, !0), u.colorAttachment.set(t1.texture);
            }
            a.bindFramebuffer.set(u.framebuffer), a.viewport.set([
                0,
                0,
                h,
                h
            ]);
            const { tileBoundsBuffer: _, tileBoundsIndexBuffer: d, tileBoundsSegments: p } = t1.getMercatorTileBoundsBuffers();
            t1.useProgram("hillshadePrepare").draw(a, l.TRIANGLES, r, n, s, e1.CullFaceMode.disabled, ((t1, i)=>{
                const o = i.stride, r = e1.create();
                return e1.ortho(r, 0, e1.EXTENT, -e1.EXTENT, 0, 0, 1), e1.translate(r, r, [
                    0,
                    -e1.EXTENT,
                    0
                ]), {
                    u_matrix: r,
                    u_image: 1,
                    u_dimension: [
                        o,
                        o
                    ],
                    u_zoom: t1.overscaledZ,
                    u_unpack: i.unpackVector
                };
            })(i.tileID, c), o.id, _, d, p), i.needsHillshadePrepare = !1;
        }
        const xi = (t1)=>({
                u_matrix: new e1.UniformMatrix4f(t1),
                u_image0: new e1.Uniform1i(t1),
                u_skirt_height: new e1.Uniform1f(t1)
            }), yi = (e1, t1)=>({
                u_matrix: e1,
                u_image0: 0,
                u_skirt_height: t1
            }), bi = (e1, t1, i, o, r, n, s, a, l, c, h, u, _, d, p)=>({
                u_proj_matrix: Float32Array.from(e1),
                u_globe_matrix: t1,
                u_normalize_matrix: Float32Array.from(o),
                u_merc_matrix: i,
                u_zoom_transition: r,
                u_merc_center: n,
                u_image0: 0,
                u_frustum_tl: s,
                u_frustum_tr: a,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: u,
                u_viewport: _,
                u_grid_matrix: p ? Float32Array.from(p) : new Float32Array(9),
                u_skirt_height: d
            });
        function wi(e1, t1) {
            return null != e1 && null != t1 && !(!e1.hasData() || !t1.hasData()) && null != e1.demTexture && null != t1.demTexture && e1.tileID.key !== t1.tileID.key;
        }
        const Ti = new class {
            constructor(){
                this.operations = {};
            }
            newMorphing(e1, t1, i, o, r) {
                if (e1 in this.operations) {
                    const t1 = this.operations[e1];
                    t1.to.tileID.key !== i.tileID.key && (t1.queued = i);
                } else this.operations[e1] = {
                    startTime: o,
                    phase: 0,
                    duration: r,
                    from: t1,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e1) {
                if (!(e1 in this.operations)) return null;
                const t1 = this.operations[e1];
                return {
                    from: t1.from,
                    to: t1.to,
                    phase: t1.phase
                };
            }
            update(e1) {
                for(const t1 in this.operations){
                    const i = this.operations[t1];
                    for(i.phase = (e1 - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e1)) {
                        delete this.operations[t1];
                        break;
                    }
                }
            }
            _nextOp(e1, t1) {
                return !!e1.queued && (e1.from = e1.to, e1.to = e1.queued, e1.queued = null, e1.phase = 0, e1.startTime = t1, !0);
            }
            _validOp(e1) {
                return e1.from.hasData() && e1.to.hasData();
            }
        }, Ei = {
            0: null,
            1: "TERRAIN_VERTEX_MORPHING",
            2: "TERRAIN_WIREFRAME"
        };
        function Ci(e1) {
            return 6 * Math.pow(1.5, 22 - e1);
        }
        function Mi(e1, t1) {
            const i = 1 << e1.z;
            return !t1 && (0 === e1.x || e1.x === i - 1) || 0 === e1.y || e1.y === i - 1;
        }
        const Ii = (e1)=>({
                u_matrix: e1
            });
        function Si(t1, i, o, r, n) {
            if (n > 0) {
                const s = e1.exported.now(), a = (s - t1.timeAdded) / n, l = i ? (s - i.timeAdded) / n : -1, c = o.getSource(), h = r.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), u = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), _ = u && t1.refreshedUponExpiration ? 1 : e1.clamp(u ? a : 1 - l, 0, 1);
                return t1.refreshedUponExpiration && a >= 1 && (t1.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - _
                } : {
                    opacity: _,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        class Di extends e1.SourceCache {
            constructor(e1){
                const t1 = {
                    type: "raster-dem",
                    maxzoom: e1.transform.maxZoom
                }, i = new z(je(), null), o = Pe("mock-dem", t1, i, e1.style);
                super("mock-dem", o, !1), o.setEventedParent(this), this._sourceLoaded = !0;
            }
            _loadTile(e1, t1) {
                e1.state = "loaded", t1(null);
            }
        }
        class Li extends e1.SourceCache {
            constructor(e1){
                const t1 = Pe("proxy", {
                    type: "geojson",
                    maxzoom: e1.transform.maxZoom
                }, new z(je(), null), e1.style);
                super("proxy", t1, !1), t1.setEventedParent(this), this.map = this.getSource().map = e1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            update(t1, i, o) {
                if (t1.freezeTileCoverage) return;
                this.transform = t1;
                const r = t1.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((i, o)=>{
                    if (i[o.key] = "", !this._tiles[o.key]) {
                        const i = new e1.Tile(o, this._source.tileSize * o.overscaleFactor(), t1.tileZoom);
                        i.state = "loaded", this._tiles[o.key] = i;
                    }
                    return i;
                }, {});
                for(const e1 in this._tiles)e1 in r || (this.freeFBO(e1), this._tiles[e1].unloadVectorData(), delete this._tiles[e1]);
            }
            freeFBO(e1) {
                const t1 = this.proxyCachedFBO[e1];
                if (void 0 !== t1) {
                    const i = Object.values(t1);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e1];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e1)=>e1.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class Ai extends e1.OverscaledTileID {
            constructor(e1, t1, i){
                super(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y), this.proxyTileKey = t1, this.projMatrix = i;
            }
        }
        class zi extends e1.Elevation {
            constructor(t1, i){
                super(), this.painter = t1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [o, r, n] = function(t1) {
                    const i = new e1.StructArrayLayout2i4, o = new e1.StructArrayLayout3ui6, r = 131;
                    i.reserve(17161), o.reserve(33800);
                    const n = e1.EXTENT / 128, s = e1.EXTENT + n / 2, a = s + n;
                    for(let t1 = -n; t1 < a; t1 += n)for(let o = -n; o < a; o += n){
                        const r = o < 0 || o > s || t1 < 0 || t1 > s ? 24575 : 0, n = e1.clamp(Math.round(o), 0, e1.EXTENT), a = e1.clamp(Math.round(t1), 0, e1.EXTENT);
                        i.emplaceBack(n + r, a);
                    }
                    const l = (e1, t1)=>{
                        const i = t1 * r + e1;
                        o.emplaceBack(i + 1, i, i + r), o.emplaceBack(i + r, i + r + 1, i + 1);
                    };
                    for(let e1 = 1; e1 < 129; e1++)for(let t1 = 1; t1 < 129; t1++)l(t1, e1);
                    return [
                        0,
                        129
                    ].forEach((e1)=>{
                        for(let t1 = 0; t1 < 130; t1++)l(t1, e1), l(e1, t1);
                    }), [
                        i,
                        o,
                        32768
                    ];
                }(), s = t1.context;
                this.gridBuffer = s.createVertexBuffer(o, e1.posAttributes.members), this.gridIndexBuffer = s.createIndexBuffer(r), this.gridSegments = e1.SegmentVector.simpleSegment(0, 0, o.length, r.length), this.gridNoSkirtSegments = e1.SegmentVector.simpleSegment(0, 0, o.length, n), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new Li(i.map), this.orthoMatrix = e1.create(), e1.ortho(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, e1.EXTENT, 0, e1.EXTENT, 0, 1);
                const a = s.gl;
                this._overlapStencilMode = new e1.StencilMode({
                    func: a.GEQUAL,
                    mask: 255
                }, 0, 255, a.KEEP, a.KEEP, a.REPLACE), this._previousZoom = t1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new Di(i.map);
            }
            set style(e1) {
                e1.on("data", this._onStyleDataEvent.bind(this)), e1.on("neworder", this._checkRenderCacheEfficiency.bind(this)), this._style = e1, this._checkRenderCacheEfficiency(), this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(t1, i, o) {
                if (t1 && t1.terrain) {
                    this._style !== t1 && (this.style = t1), this.enabled = !0;
                    const r = t1.terrain.properties;
                    this.sourceCache = 0 === t1.terrain.drapeRenderMode ? this._mockSourceCache : t1._getSourceCache(r.get("source")), this._exaggeration = r.get("exaggeration");
                    const n = ()=>{
                        this.sourceCache.used && e1.warnOnce(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const t1 = this.getScaledDemTileSize();
                        this.sourceCache.update(i, t1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, n(), this._initializing = !0), n(), i.updateElevation(!0, o), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0;
                } else this._disable();
            }
            resetTileLookupCache(e1) {
                this._findCoveringTileCache[e1] = {};
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _checkRenderCacheEfficiency() {
                const t1 = this.renderCacheEfficiency(this._style);
                this._style.map._optimizeForTerrain || 100 !== t1.efficiency && e1.warnOnce(`Terrain render cache efficiency is not optimal (${t1.efficiency}%) and performance\n                may be affected negatively, consider placing all background, fill and line layers before layer\n                with id '${t1.firstUndrapedLayer}' or create a map using optimizeForTerrain: true option.`);
            }
            _onStyleDataEvent(e1) {
                e1.coord && "source" === e1.dataType ? this._clearRenderCacheForTile(e1.sourceCacheId, e1.coord) : "style" === e1.dataType && (this._invalidateRenderCache = !0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._sharedDepthStencil = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e1 in this._style._sourceCaches)this._style._sourceCaches[e1].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this._emptyDepthBufferTexture && this._emptyDepthBufferTexture.destroy(), this.pool.forEach((e1)=>e1.fb.destroy()), this.pool = [], this._depthFBO && (this._depthFBO.destroy(), this._depthFBO = void 0, this._depthTexture = void 0);
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this._exaggeration;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e1 = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e1,
                    e1
                ];
            }
            set useVertexMorphing(e1) {
                this._useVertexMorphing = e1;
            }
            updateTileBinding(t1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const i = this.proxySourceCache, o = this.painter.transform;
                this._initializing && (this._initializing = 0 === o._centerAltitude && -1 === this.getAtPointOrZero(e1.MercatorCoordinate.fromLngLat(o.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const r = this.proxyCoords = i.getIds().map((e1)=>{
                    const t1 = i.getTileByID(e1).tileID;
                    return t1.projMatrix = o.calculateProjMatrix(t1.toUnwrapped()), t1;
                });
                !function(t1, i) {
                    const o = i.transform.pointCoordinate(i.transform.getCameraPoint()), r = new e1.pointGeometry(o.x, o.y);
                    t1.sort((t1, i)=>{
                        if (i.overscaledZ - t1.overscaledZ) return i.overscaledZ - t1.overscaledZ;
                        const o = new e1.pointGeometry(t1.canonical.x + (1 << t1.canonical.z) * t1.wrap, t1.canonical.y), n = new e1.pointGeometry(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y), s = r.mult(1 << t1.canonical.z);
                        return s.x -= .5, s.y -= .5, s.distSqr(o) - s.distSqr(n);
                    });
                }(r, this.painter), this._previousZoom = o.zoom;
                const n = this.proxyToSource || {};
                this.proxyToSource = {}, r.forEach((e1)=>{
                    this.proxyToSource[e1.key] = {};
                }), this.terrainTileForTile = {};
                const s = this._style._sourceCaches;
                for(const e1 in s){
                    const i = s[e1];
                    if (!i.used) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, t1[e1], n), i.usedForTerrain) continue;
                    const o = t1[e1];
                    i.getSource().reparseOverscaled && this._assignTerrainTiles(o);
                }
                this.proxiedCoords[i.id] = r.map((e1)=>new Ai(e1, e1.key, this.orthoMatrix)), this._assignTerrainTiles(r), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(n), this.renderingToTexture = !1, this._updateTimestamp = e1.exported.now();
                const a = {};
                this._visibleDemTiles = [];
                for (const e1 of this.proxyCoords){
                    const t1 = this.terrainTileForTile[e1.key];
                    if (!t1) continue;
                    const i = t1.tileID.key;
                    i in a || (this._visibleDemTiles.push(t1), a[i] = i);
                }
            }
            _assignTerrainTiles(e1) {
                this._initializing || e1.forEach((e1)=>{
                    if (this.terrainTileForTile[e1.key]) return;
                    const t1 = this._findTileCoveringTileID(e1, this.sourceCache);
                    t1 && (this.terrainTileForTile[e1.key] = t1);
                });
            }
            _prepareDEMTextures() {
                const e1 = this.painter.context, t1 = e1.gl;
                for(const i in this.terrainTileForTile){
                    const o = this.terrainTileForTile[i], r = o.dem;
                    !r || o.demTexture && !o.needsDEMTextureUpload || (e1.activeTexture.set(t1.TEXTURE1), gi(this.painter, o, r));
                }
            }
            _prepareDemTileUniforms(e1, t1, i, o) {
                if (!t1 || null == t1.demTexture) return !1;
                const r = e1.tileID.canonical, n = Math.pow(2, t1.tileID.canonical.z - r.z), s = o || "";
                return i[`u_dem_tl${s}`] = [
                    r.x * n % 1,
                    r.y * n % 1
                ], i[`u_dem_scale${s}`] = n, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            get emptyDepthBufferTexture() {
                const t1 = this.painter.context, i = t1.gl;
                if (!this._emptyDepthBufferTexture) {
                    const o = new e1.RGBAImage({
                        width: 1,
                        height: 1
                    }, Uint8Array.of(255, 255, 255, 255));
                    this._emptyDepthBufferTexture = new e1.Texture(t1, o, i.RGBA, {
                        premultiply: !1
                    });
                }
                return this._emptyDepthBufferTexture;
            }
            _getLoadedAreaMinimum() {
                let e1 = 0;
                const t1 = this._visibleDemTiles.reduce((t1, i)=>{
                    if (!i.dem) return t1;
                    const o = i.dem.tree.minimums[0];
                    return o > 0 && e1++, t1 + o;
                }, 0);
                return e1 ? t1 / e1 : 0;
            }
            _updateEmptyDEMTexture() {
                const t1 = this.painter.context, i = t1.gl;
                t1.activeTexture.set(i.TEXTURE2);
                const o = this._getLoadedAreaMinimum(), r = new e1.RGBAImage({
                    width: 1,
                    height: 1
                }, new Uint8Array(e1.DEMData.pack(o, this.sourceCache.getSource().encoding)));
                this._emptyDEMTextureDirty = !1;
                let n = this._emptyDEMTexture;
                return n ? n.update(r, {
                    premultiply: !1
                }) : n = this._emptyDEMTexture = new e1.Texture(t1, r, i.RGBA, {
                    premultiply: !1
                }), n;
            }
            setupElevationDraw(t1, i, o) {
                const r = this.painter.context, n = r.gl, s = (a = this.sourceCache.getSource().encoding, {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_unpack: e1.DEMData.getUnpackVector(a),
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_exaggeration: 0
                });
                var a;
                s.u_dem_size = this.sourceCache.getSource().tileSize, s.u_exaggeration = this.exaggeration();
                let l = null, c = null, h = 1;
                if (o && o.morphing && this._useVertexMorphing) {
                    const e1 = o.morphing.srcDemTile, i = o.morphing.dstDemTile;
                    h = o.morphing.phase, e1 && i && (this._prepareDemTileUniforms(t1, e1, s, "_prev") && (c = e1), this._prepareDemTileUniforms(t1, i, s) && (l = i));
                }
                if (c && l ? (r.activeTexture.set(n.TEXTURE2), l.demTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE, n.NEAREST), r.activeTexture.set(n.TEXTURE4), c.demTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE, n.NEAREST), s.u_dem_lerp = h) : (l = this.terrainTileForTile[t1.tileID.key], r.activeTexture.set(n.TEXTURE2), (this._prepareDemTileUniforms(t1, l, s) ? l.demTexture : this.emptyDEMTexture).bind(n.NEAREST, n.CLAMP_TO_EDGE)), r.activeTexture.set(n.TEXTURE3), o && o.useDepthForOcclusion ? (this._depthTexture && this._depthTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE), this._depthFBO && (s.u_depth_size_inv = [
                    1 / this._depthFBO.width,
                    1 / this._depthFBO.height
                ])) : (this.emptyDepthBufferTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE), s.u_depth_size_inv = [
                    1,
                    1
                ]), o && o.useMeterToDem && l) {
                    const t1 = (1 << l.tileID.canonical.z) * e1.mercatorZfromAltitude(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    s.u_meter_to_dem = t1;
                }
                if (o && o.labelPlaneMatrixInv && (s.u_label_plane_matrix_inv = o.labelPlaneMatrixInv), i.setTerrainUniformValues(r, s), "globe" === this.painter.transform.projection.name) {
                    const e1 = this.globeUniformValues(this.painter.transform, t1.tileID.canonical, o && o.useDenormalizedUpVectorScale);
                    i.setGlobeUniformValues(r, e1);
                }
            }
            globeUniformValues(t1, i, o) {
                const r = t1.projection;
                return {
                    u_tile_tl_up: r.upVector(i, 0, 0),
                    u_tile_tr_up: r.upVector(i, e1.EXTENT, 0),
                    u_tile_br_up: r.upVector(i, e1.EXTENT, e1.EXTENT),
                    u_tile_bl_up: r.upVector(i, 0, e1.EXTENT),
                    u_tile_up_scale: o ? e1.globeMetersToEcef(1) : r.upVectorScale(i, t1.center.lat, t1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(t1) {
                const i = this.painter, o = this.painter.context;
                0 !== t1.length && (o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(t1, i, o, r, n) {
                    if ("globe" === t1.transform.projection.name) !function(t1, i, o, r, n) {
                        const s = t1.context, a = s.gl;
                        let l, c;
                        const h = t1.options.showTerrainWireframe ? 2 : 0, u = t1.transform, _ = e1.globeUseCustomAntiAliasing(t1, s, u), d = (e1, i)=>{
                            if (c === e1) return;
                            const o = [
                                Ei[e1],
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            _ && o.push("CUSTOM_ANTIALIASING"), i && o.push(Ei[h]), l = t1.useProgram("globeRaster", null, o), c = e1;
                        }, p = t1.colorModeForRenderPass(), m = new e1.DepthMode(a.LEQUAL, e1.DepthMode.ReadWrite, t1.depthRangeFor3D);
                        Ti.update(n);
                        const f = e1.calculateGlobeMercatorMatrix(u), g = [
                            e1.mercatorXfromLng(u.center.lng),
                            e1.mercatorYfromLat(u.center.lat)
                        ], v = h ? [
                            !1,
                            !0
                        ] : [
                            !1
                        ], x = t1.globeSharedBuffers, y = [
                            u.width * e1.exported.devicePixelRatio,
                            u.height * e1.exported.devicePixelRatio
                        ], b = Float32Array.from(u.globeMatrix), w = {
                            useDenormalizedUpVectorScale: !0
                        };
                        if (v.forEach((h)=>{
                            const u = t1.transform, _ = Ci(u.zoom) * i.exaggeration();
                            c = -1;
                            const v = h ? a.LINES : a.TRIANGLES;
                            for (const c of r){
                                const r = o.getTile(c), T = e1.StencilMode.disabled, E = i.prevTerrainTileForTile[c.key], C = i.terrainTileForTile[c.key];
                                wi(E, C) && Ti.newMorphing(c.key, E, C, n, 250), s.activeTexture.set(a.TEXTURE0), r.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const M = Ti.getMorphValuesForProxy(c.key), I = M ? 1 : 0;
                                M && e1.extend$1(w, {
                                    morphing: {
                                        srcDemTile: M.from,
                                        dstDemTile: M.to,
                                        phase: e1.easeCubicInOut(M.phase)
                                    }
                                });
                                const S = e1.tileCornersToBounds(c.canonical), D = e1.getLatitudinalLod(S.getCenter().lat), L = e1.getGridMatrix(c.canonical, S, D, u.worldSize / u._pixelsPerMercatorPixel), A = e1.globeNormalizeECEF(e1.globeTileBounds(c.canonical)), z = bi(u.projMatrix, b, f, A, e1.globeToMercatorTransition(u.zoom), g, u.frustumCorners.TL, u.frustumCorners.TR, u.frustumCorners.BR, u.frustumCorners.BL, u.globeCenterInViewSpace, u.globeRadius, y, _, L);
                                if (d(I, h), i.setupElevationDraw(r, l, w), t1.prepareDrawProgram(s, l, c.toUnwrapped()), x) {
                                    const [i, o, r] = h ? x.getWirefameBuffers(t1.context, D) : x.getGridBuffers(D, 0 !== _);
                                    l.draw(s, v, m, T, p, e1.CullFaceMode.backCCW, z, "globe_raster", i, o, r);
                                }
                            }
                        }), x) {
                            const n = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            _ && n.push("CUSTOM_ANTIALIASING"), l = t1.useProgram("globeRaster", null, n);
                            for (const n of r){
                                const { x: r, y: c, z: h } = n.canonical, _ = 0 === c, d = c === (1 << h) - 1, [f, v, b, T] = x.getPoleBuffers(h);
                                if (T && (_ || d)) {
                                    const c = o.getTile(n);
                                    s.activeTexture.set(a.TEXTURE0), c.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                    let x = e1.globePoleMatrixForTile(h, r, u);
                                    const E = e1.globeNormalizeECEF(e1.globeTileBounds(n.canonical)), C = (t1, i)=>t1.draw(s, a.TRIANGLES, m, e1.StencilMode.disabled, p, e1.CullFaceMode.disabled, bi(u.projMatrix, x, x, E, 0, g, u.frustumCorners.TL, u.frustumCorners.TR, u.frustumCorners.BR, u.frustumCorners.BL, u.globeCenterInViewSpace, u.globeRadius, y, 0), "globe_pole_raster", i, b, T);
                                    i.setupElevationDraw(c, l, w), t1.prepareDrawProgram(s, l, n.toUnwrapped()), _ && C(l, f), d && (x = e1.scale(e1.create(), x, [
                                        1,
                                        -1,
                                        1
                                    ]), C(l, v));
                                }
                            }
                        }
                    }(t1, i, o, r, n);
                    else {
                        const s = t1.context, a = s.gl;
                        let l, c;
                        const h = t1.options.showTerrainWireframe ? 2 : 0, u = (e1, i)=>{
                            if (c === e1) return;
                            const o = [
                                Ei[e1]
                            ];
                            i && o.push(Ei[h]), l = t1.useProgram("terrainRaster", null, o), c = e1;
                        }, _ = t1.colorModeForRenderPass(), d = new e1.DepthMode(a.LEQUAL, e1.DepthMode.ReadWrite, t1.depthRangeFor3D);
                        Ti.update(n);
                        const p = t1.transform, m = Ci(p.zoom) * i.exaggeration();
                        (h ? [
                            !1,
                            !0
                        ] : [
                            !1
                        ]).forEach((h)=>{
                            c = -1;
                            const f = h ? a.LINES : a.TRIANGLES, [g, v] = h ? i.getWirefameBuffer() : [
                                i.gridIndexBuffer,
                                i.gridSegments
                            ];
                            for (const c of r){
                                const r = o.getTile(c), x = e1.StencilMode.disabled, y = i.prevTerrainTileForTile[c.key], b = i.terrainTileForTile[c.key];
                                wi(y, b) && Ti.newMorphing(c.key, y, b, n, 250), s.activeTexture.set(a.TEXTURE0), r.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST);
                                const w = Ti.getMorphValuesForProxy(c.key), T = w ? 1 : 0;
                                let E;
                                w && (E = {
                                    morphing: {
                                        srcDemTile: w.from,
                                        dstDemTile: w.to,
                                        phase: e1.easeCubicInOut(w.phase)
                                    }
                                });
                                const C = yi(c.projMatrix, Mi(c.canonical, p.renderWorldCopies) ? m / 10 : m);
                                u(T, h), i.setupElevationDraw(r, l, E), t1.prepareDrawProgram(s, l, c.toUnwrapped()), l.draw(s, f, d, x, _, e1.CullFaceMode.backCCW, C, "terrain_raster", i.gridBuffer, g, v);
                            }
                        });
                    }
                }(i, this, this.proxySourceCache, t1, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t1.splice(0, t1.length));
            }
            renderBatch(t1) {
                if (0 === this._drapedRenderBatches.length) return t1 + 1;
                this.renderingToTexture = !0;
                const i = this.painter, o = this.painter.context, r = this.proxySourceCache, n = this.proxiedCoords[r.id], s = this._drapedRenderBatches.shift(), a = [], l = i.style.order;
                let c = 0;
                for (const h of n){
                    const n = r.getTileByID(h.proxyTileKey), u = r.proxyCachedFBO[h.key] ? r.proxyCachedFBO[h.key][t1] : void 0, _ = void 0 !== u ? r.renderCache[u] : this.pool[c++], d = void 0 !== u;
                    if (n.texture = _.tex, d && !_.dirty) {
                        a.push(n.tileID);
                        continue;
                    }
                    let p;
                    o.bindFramebuffer.set(_.fb.framebuffer), this.renderedToTile = !1, _.dirty && (o.clear({
                        color: e1.Color.transparent,
                        stencil: 0
                    }), _.dirty = !1);
                    for(let e1 = s.start; e1 <= s.end; ++e1){
                        const t1 = i.style._layers[l[e1]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style._getLayerSourceCache(t1), n = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!n) continue;
                        const s = n;
                        o.viewport.set([
                            0,
                            0,
                            _.fb.width,
                            _.fb.height
                        ]), p !== (r ? r.id : null) && (this._setupStencil(_, n, t1, r), p = r ? r.id : null), i.renderLayer(i, r, t1, s);
                    }
                    this.renderedToTile ? (_.dirty = !0, a.push(n.tileID)) : d || --c, 5 === c && (c = 0, this.renderToBackBuffer(a));
                }
                return this.renderToBackBuffer(a), this.renderingToTexture = !1, o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), s.end + 1;
            }
            postRender() {}
            renderCacheEfficiency(e1) {
                const t1 = e1.order.length;
                if (0 === t1) return {
                    efficiency: 100
                };
                let i, o = 0, r = 0, n = !1;
                for(let s = 0; s < t1; ++s){
                    const t1 = e1._layers[e1.order[s]];
                    this._style.isLayerDraped(t1) ? (n && ++o, ++r) : n || (n = !0, i = t1.id);
                }
                return 0 === r ? {
                    efficiency: 100
                } : {
                    efficiency: 100 * (1 - o / r),
                    firstUndrapedLayer: i
                };
            }
            getMinElevationBelowMSL() {
                let e1 = 0;
                return this._visibleDemTiles.filter((e1)=>e1.dem).forEach((t1)=>{
                    e1 = Math.min(e1, t1.dem.tree.minimums[0]);
                }), 0 === e1 ? e1 : (e1 - 30) * this._exaggeration;
            }
            raycast(e1, t1, i) {
                if (!this._visibleDemTiles) return null;
                const o = this._visibleDemTiles.filter((e1)=>e1.dem).map((o)=>{
                    const r = o.tileID, n = 1 << r.overscaledZ, { x: s, y: a } = r.canonical, l = s / n, c = (s + 1) / n, h = a / n, u = (a + 1) / n;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: u,
                        t: o.dem.tree.raycastRoot(l, h, c, u, e1, t1, i),
                        tile: o
                    };
                });
                o.sort((e1, t1)=>(null !== e1.t ? e1.t : Number.MAX_VALUE) - (null !== t1.t ? t1.t : Number.MAX_VALUE));
                for (const r of o){
                    if (null == r.t) return null;
                    const o = r.tile.dem.tree.raycast(r.minx, r.miny, r.maxx, r.maxy, e1, t1, i);
                    if (null != o) return o;
                }
                return null;
            }
            _createFBO() {
                const t1 = this.painter.context, i = t1.gl, o = this.drapeBufferSize;
                t1.activeTexture.set(i.TEXTURE0);
                const r = new e1.Texture(t1, {
                    width: o[0],
                    height: o[1],
                    data: null
                }, i.RGBA);
                r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                const n = t1.createFramebuffer(o[0], o[1], !1);
                return n.colorAttachment.set(r.texture), n.depthAttachment = new Ee(t1, n.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t1.createRenderbuffer(t1.gl.DEPTH_STENCIL, o[0], o[1]), this._stencilRef = 0, n.depthAttachment.set(this._sharedDepthStencil), t1.clear({
                    stencil: 0
                })) : n.depthAttachment.set(this._sharedDepthStencil), t1.extTextureFilterAnisotropic && !t1.extTextureFilterAnisotropicForceOff && i.texParameterf(i.TEXTURE_2D, t1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t1.extTextureFilterAnisotropicMax), {
                    fb: n,
                    tex: r,
                    dirty: !1
                };
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._style.light && this._style.light.hasTransition()) return !0;
                for(const e1 in this._style._sourceCaches)if (this._style._sourceCaches[e1].hasTransition()) return !0;
                return this._style.order.some((e1)=>{
                    const t1 = this._style._layers[e1], i = t1.isHidden(this.painter.transform.zoom);
                    return "custom" === t1.type ? !i && t1.shouldRedrape() : !i && t1.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let t1 = !1;
                for (const e1 of this._style._getSources())if (e1 instanceof Ie) {
                    t1 = !0;
                    break;
                }
                if (!t1) return;
                const i = {};
                for(let t1 = 0; t1 < this._style.order.length; ++t1){
                    const o = this._style._layers[this._style.order[t1]], r = this._style._getLayerSourceCache(o);
                    if (r && !i[r.id] && !o.isHidden(this.painter.transform.zoom) && "line" === o.type && o.widthExpression() instanceof e1.ZoomDependentExpression) {
                        i[r.id] = !0;
                        for (const e1 of this.proxyCoords){
                            const t1 = this.proxyToSource[e1.key][r.id];
                            if (t1) for (const e1 of t1)this._clearRenderCacheForTile(r.id, e1);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e1 = !1;
                for(const t1 in this._style._sourceCaches)if (this._style._sourceCaches[t1]._source instanceof Se) {
                    e1 = !0;
                    break;
                }
                if (!e1) return;
                const t1 = {};
                for(let e1 = 0; e1 < this._style.order.length; ++e1){
                    const i = this._style._layers[this._style.order[e1]], o = this._style._getLayerSourceCache(i);
                    if (!o || t1[o.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const r = i.paint.get("raster-fade-duration");
                    for (const e1 of this.proxyCoords){
                        const t1 = this.proxyToSource[e1.key][o.id];
                        if (t1) for (const e1 of t1){
                            const t1 = Si(o.getTile(e1), o.findLoadedParent(e1, 0), o, this.painter.transform, r);
                            (1 !== t1.opacity || 0 !== t1.mix) && this._clearRenderCacheForTile(o.id, e1);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                const e1 = this._style.order, t1 = e1.length;
                if (0 === t1) return;
                const i = [];
                let o, r = 0, n = this._style._layers[e1[r]];
                for(; !this._style.isLayerDraped(n) && n.isHidden(this.painter.transform.zoom) && ++r < t1;)n = this._style._layers[e1[r]];
                for(; r < t1; ++r){
                    const t1 = this._style._layers[e1[r]];
                    t1.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(t1) ? void 0 === o && (o = r) : void 0 !== o && (i.push({
                        start: o,
                        end: r - 1
                    }), o = void 0));
                }
                void 0 !== o && i.push({
                    start: o,
                    end: r - 1
                }), this._drapedRenderBatches = i;
            }
            _setupRenderCache(e1) {
                const t1 = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this._invalidateRenderCache) {
                    if (this._invalidateRenderCache = !1, t1.renderCache.length > t1.renderCachePool.length) {
                        const e1 = Object.values(t1.proxyCachedFBO);
                        t1.proxyCachedFBO = {};
                        for(let i = 0; i < e1.length; ++i){
                            const o = Object.values(e1[i]);
                            t1.renderCachePool.push(...o);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, o = this._tilesDirty;
                for(let r = i.length - 1; r >= 0; r--){
                    const n = i[r];
                    if (t1.getTileByID(n.key), void 0 !== t1.proxyCachedFBO[n.key]) {
                        const i = e1[n.key], r = this.proxyToSource[n.key];
                        let s = 0;
                        for(const e1 in r){
                            const t1 = r[e1], n = i[e1];
                            if (!n || n.length !== t1.length || t1.some((t1, i)=>t1 !== n[i] || o[e1] && o[e1].hasOwnProperty(t1.key))) {
                                s = -1;
                                break;
                            }
                            ++s;
                        }
                        for(const e1 in t1.proxyCachedFBO[n.key])t1.renderCache[t1.proxyCachedFBO[n.key][e1]].dirty = s < 0 || s !== Object.values(i).length;
                    }
                }
                const r = [
                    ...this._drapedRenderBatches
                ];
                r.sort((e1, t1)=>t1.end - t1.start - (e1.end - e1.start));
                for (const e1 of r)for (const o of i){
                    if (t1.proxyCachedFBO[o.key]) continue;
                    let i = t1.renderCachePool.pop();
                    void 0 === i && t1.renderCache.length < 50 && (i = t1.renderCache.length, t1.renderCache.push(this._createFBO())), void 0 !== i && (t1.proxyCachedFBO[o.key] = {}, t1.proxyCachedFBO[o.key][e1.start] = i, t1.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e1, t1, i, o) {
                if (!o || !this._sourceTilesOverlap[o.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const r = this.painter.context, n = r.gl;
                if (t1.length <= 1) return void (this._overlapStencilType = !1);
                let s;
                if (i.isTileClipped()) s = t1.length, this._overlapStencilMode.test = {
                    func: n.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t1[0].overscaledZ > t1[t1.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
                    s = 1, this._overlapStencilMode.test = {
                        func: n.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + s > 255 && (r.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += s, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t1, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(t1) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[t1.key]), this._overlapStencilMode) : e1.StencilMode.disabled;
            }
            _renderTileClippingMasks(t1, i) {
                const o = this.painter, r = this.painter.context, n = r.gl;
                o._tileClippingMaskIDs = {}, r.setColorMode(e1.ColorMode.disabled), r.setDepthMode(e1.DepthMode.disabled);
                const s = o.useProgram("clippingMask");
                for (const a of t1){
                    const t1 = o._tileClippingMaskIDs[a.key] = --i;
                    s.draw(r, n.TRIANGLES, e1.DepthMode.disabled, new e1.StencilMode({
                        func: n.ALWAYS,
                        mask: 0
                    }, t1, 255, n.KEEP, n.KEEP, n.REPLACE), e1.ColorMode.disabled, e1.CullFaceMode.disabled, Ii(a.projMatrix), "$clipping", o.tileExtentBuffer, o.quadTriangleIndexBuffer, o.tileExtentSegments);
                }
            }
            pointCoordinate(t1) {
                const i = this.painter.transform;
                if (t1.x < 0 || t1.x > i.width || t1.y < 0 || t1.y > i.height) return null;
                const o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e1.transformMat4$1(o, o, i.pixelMatrixInverse), e1.scale$1(o, o, 1 / o[3]), o[0] /= i.worldSize, o[1] /= i.worldSize;
                const r = i._camera.position, n = e1.mercatorZfromAltitude(1, i.center.lat), s = [
                    r[0],
                    r[1],
                    r[2] / n,
                    0
                ], a = e1.subtract([], o.slice(0, 3), s);
                e1.normalize(a, a);
                const l = this.raycast(s, a, this._exaggeration);
                return null !== l && l ? (e1.scaleAndAdd(s, s, a, l), s[3] = s[2], s[2] *= n, s) : null;
            }
            drawDepth() {
                const t1 = this.painter, i = t1.context, o = this.proxySourceCache, r = Math.ceil(t1.width), n = Math.ceil(t1.height);
                if (!this._depthFBO || this._depthFBO.width === r && this._depthFBO.height === n || (this._depthFBO.destroy(), this._depthFBO = void 0, this._depthTexture = void 0), !this._depthFBO) {
                    const t1 = i.gl, o = i.createFramebuffer(r, n, !0);
                    i.activeTexture.set(t1.TEXTURE0);
                    const s = new e1.Texture(i, {
                        width: r,
                        height: n,
                        data: null
                    }, t1.RGBA);
                    s.bind(t1.NEAREST, t1.CLAMP_TO_EDGE), o.colorAttachment.set(s.texture);
                    const a = i.createRenderbuffer(i.gl.DEPTH_COMPONENT16, r, n);
                    o.depthAttachment.set(a), this._depthFBO = o, this._depthTexture = s;
                }
                i.bindFramebuffer.set(this._depthFBO.framebuffer), i.viewport.set([
                    0,
                    0,
                    r,
                    n
                ]), function(t1, i, o, r) {
                    if ("globe" === t1.transform.projection.name) return;
                    const n = t1.context, s = n.gl;
                    n.clear({
                        depth: 1
                    });
                    const a = t1.useProgram("terrainDepth"), l = new e1.DepthMode(s.LESS, e1.DepthMode.ReadWrite, t1.depthRangeFor3D);
                    for (const t1 of r){
                        const r = o.getTile(t1), c = yi(t1.projMatrix, 0);
                        i.setupElevationDraw(r, a), a.draw(n, s.TRIANGLES, l, e1.StencilMode.disabled, e1.ColorMode.unblended, e1.CullFaceMode.backCCW, c, "terrain_depth", i.gridBuffer, i.gridIndexBuffer, i.gridNoSkirtSegments);
                    }
                }(t1, this, o, this.proxyCoords);
            }
            _setupProxiedCoordsForOrtho(e1, t1, i) {
                if (e1.getSource() instanceof Ae) return this._setupProxiedCoordsForImageSource(e1, t1, i);
                this._findCoveringTileCache[e1.id] = this._findCoveringTileCache[e1.id] || {};
                const o = this.proxiedCoords[e1.id] = [], r = this.proxyCoords;
                for(let t1 = 0; t1 < r.length; t1++){
                    const n = r[t1], s = this._findTileCoveringTileID(n, e1);
                    if (s) {
                        const t1 = this._createProxiedId(n, s, i[n.key] && i[n.key][e1.id]);
                        o.push(t1), this.proxyToSource[n.key][e1.id] = [
                            t1
                        ];
                    }
                }
                let n = !1;
                for(let r = 0; r < t1.length; r++){
                    const s = e1.getTile(t1[r]);
                    if (!s || !s.hasData()) continue;
                    const a = this._findTileCoveringTileID(s.tileID, this.proxySourceCache);
                    if (a && a.tileID.canonical.z !== s.tileID.canonical.z) {
                        const t1 = this.proxyToSource[a.tileID.key][e1.id], r = this._createProxiedId(a.tileID, s, i[a.tileID.key] && i[a.tileID.key][e1.id]);
                        t1 ? t1.splice(t1.length - 1, 0, r) : this.proxyToSource[a.tileID.key][e1.id] = [
                            r
                        ], o.push(r), n = !0;
                    }
                }
                this._sourceTilesOverlap[e1.id] = n;
            }
            _setupProxiedCoordsForImageSource(t1, i, o) {
                if (!t1.getSource().loaded()) return;
                const r = this.proxiedCoords[t1.id] = [], n = this.proxyCoords, s = t1.getSource(), a = new e1.pointGeometry(s.tileID.x, s.tileID.y)._div(1 << s.tileID.z), l = s.coordinates.map(e1.MercatorCoordinate.fromLngLat).reduce((e1, t1)=>(e1.min.x = Math.min(e1.min.x, t1.x - a.x), e1.min.y = Math.min(e1.min.y, t1.y - a.y), e1.max.x = Math.max(e1.max.x, t1.x - a.x), e1.max.y = Math.max(e1.max.y, t1.y - a.y), e1), {
                    min: new e1.pointGeometry(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new e1.pointGeometry(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), c = (t1, i)=>{
                    const o = t1.wrap + t1.canonical.x / (1 << t1.canonical.z), r = t1.canonical.y / (1 << t1.canonical.z), n = e1.EXTENT / (1 << t1.canonical.z), s = i.wrap + i.canonical.x / (1 << i.canonical.z), a = i.canonical.y / (1 << i.canonical.z);
                    return o + n < s + l.min.x || o > s + l.max.x || r + n < a + l.min.y || r > a + l.max.y;
                };
                for(let e1 = 0; e1 < n.length; e1++){
                    const s = n[e1];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const n = t1.getTile(i[e1]);
                        if (!n || !n.hasData()) continue;
                        if (c(s, n.tileID)) continue;
                        const a = this._createProxiedId(s, n, o[s.key] && o[s.key][t1.id]), l = this.proxyToSource[s.key][t1.id];
                        l ? l.push(a) : this.proxyToSource[s.key][t1.id] = [
                            a
                        ], r.push(a);
                    }
                }
            }
            _createProxiedId(t1, i, o) {
                let r = this.orthoMatrix;
                if (o) {
                    const e1 = o.find((e1)=>e1.key === i.tileID.key);
                    if (e1) return e1;
                }
                if (i.tileID.key !== t1.key) {
                    const o = t1.canonical.z - i.tileID.canonical.z;
                    let n, s, a;
                    r = e1.create();
                    const l = i.tileID.wrap - t1.wrap << t1.overscaledZ;
                    o > 0 ? (n = e1.EXTENT >> o, s = n * ((i.tileID.canonical.x << o) - t1.canonical.x + l), a = n * ((i.tileID.canonical.y << o) - t1.canonical.y)) : (n = e1.EXTENT << -o, s = e1.EXTENT * (i.tileID.canonical.x - (t1.canonical.x + l << -o)), a = e1.EXTENT * (i.tileID.canonical.y - (t1.canonical.y << -o))), e1.ortho(r, 0, n, 0, n, 0, 1), e1.translate(r, r, [
                        s,
                        a,
                        0
                    ]);
                }
                return new Ai(i.tileID, t1.key, r);
            }
            _findTileCoveringTileID(t1, i) {
                let o = i.getTile(t1);
                if (o && o.hasData()) return o;
                const r = this._findCoveringTileCache[i.id], n = r[t1.key];
                if (o = n ? i.getTileByID(n) : null, o && o.hasData() || null === n) return o;
                let s = o ? o.tileID : t1, a = s.overscaledZ;
                const l = i.getSource().minzoom, c = [];
                if (!n) {
                    const r = i.getSource().maxzoom;
                    if (t1.canonical.z >= r) {
                        const o = t1.canonical.z - r;
                        i.getSource().reparseOverscaled ? (a = Math.max(t1.canonical.z + 2, i.transform.tileZoom), s = new e1.OverscaledTileID(a, t1.wrap, r, t1.canonical.x >> o, t1.canonical.y >> o)) : 0 !== o && (a = r, s = new e1.OverscaledTileID(a, t1.wrap, r, t1.canonical.x >> o, t1.canonical.y >> o));
                    }
                    s.key !== t1.key && (c.push(s.key), o = i.getTile(s));
                }
                const h = (e1)=>{
                    c.forEach((t1)=>{
                        r[t1] = e1;
                    }), c.length = 0;
                };
                for(a -= 1; a >= l && (!o || !o.hasData()); a--){
                    o && h(o.tileID.key);
                    const e1 = s.calculateScaledKey(a);
                    if (o = i.getTileByID(e1), o && o.hasData()) break;
                    const t1 = r[e1];
                    if (null === t1) break;
                    void 0 === t1 ? c.push(e1) : o = i.getTileByID(t1);
                }
                return h(o ? o.tileID.key : null), o && o.hasData() ? o : null;
            }
            findDEMTileFor(e1) {
                return this.enabled ? this._findTileCoveringTileID(e1, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e1, t1) {
                let i = this._tilesDirty[e1];
                i || (i = this._tilesDirty[e1] = {}), i[t1.key] = !0;
            }
            getWirefameBuffer() {
                if (!this.wireframeSegments) {
                    const t1 = function(t1) {
                        let i = 0;
                        const o = new e1.StructArrayLayout2ui4, r = 131;
                        for(let e1 = 1; e1 < 129; e1++){
                            for(let t1 = 1; t1 < 129; t1++)i = e1 * r + t1, o.emplaceBack(i, i + 1), o.emplaceBack(i, i + r), o.emplaceBack(i + 1, i + r), 128 === e1 && o.emplaceBack(i + r, i + r + 1);
                            o.emplaceBack(i + 1, i + 1 + r);
                        }
                        return o;
                    }();
                    this.wireframeIndexBuffer = this.painter.context.createIndexBuffer(t1), this.wireframeSegments = e1.SegmentVector.simpleSegment(0, 0, this.gridBuffer.length, t1.length);
                }
                return [
                    this.wireframeIndexBuffer,
                    this.wireframeSegments
                ];
            }
        }
        class Pi {
            static cacheKey(e1, t1, i, o) {
                let r = `${t1}${o ? o.cacheKey : ""}`;
                for (const t1 of i)e1.usedDefines.includes(t1) && (r += `/${t1}`);
                return r;
            }
            constructor(t1, i, o, r, n, s){
                const a = t1.gl;
                this.program = a.createProgram();
                const l = function(e1) {
                    const t1 = [];
                    for(let i = 0; i < e1.length; i++){
                        if (null === e1[i]) continue;
                        const o = e1[i].split(" ");
                        t1.push(o.pop());
                    }
                    return t1;
                }(o.staticAttributes), c = r ? r.getBinderAttributes() : [], h = l.concat(c);
                let u = r ? r.defines() : [];
                u = u.concat(s.map((e1)=>`#define ${e1}`));
                const _ = t1.isWebGL2 ? "#version 300 es\n" : "", d = _ + u.concat(t1.extStandardDerivatives && 0 === _.length ? "#extension GL_OES_standard_derivatives : enable\n".concat(hi) : hi, hi, ci, li.fragmentSource, si.fragmentSource, o.fragmentSource).join("\n"), p = _ + u.concat("\n#ifdef GL_ES\nprecision highp float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif", ci, li.vertexSource, si.vertexSource, ni.vertexSource, o.vertexSource).join("\n"), m = a.createShader(a.FRAGMENT_SHADER);
                if (a.isContextLost()) return void (this.failedToCreate = !0);
                a.shaderSource(m, d), a.compileShader(m), a.attachShader(this.program, m);
                const f = a.createShader(a.VERTEX_SHADER);
                if (a.isContextLost()) this.failedToCreate = !0;
                else {
                    a.shaderSource(f, p), a.compileShader(f), a.attachShader(this.program, f), this.attributes = {}, this.numAttributes = h.length;
                    for(let e1 = 0; e1 < this.numAttributes; e1++)h[e1] && (a.bindAttribLocation(this.program, e1, h[e1]), this.attributes[h[e1]] = e1);
                    a.linkProgram(this.program), a.deleteShader(f), a.deleteShader(m), this.fixedUniforms = n(t1), this.binderUniforms = r ? r.getUniforms(t1) : [], s.includes("TERRAIN") && (this.terrainUniforms = ((t1)=>({
                            u_dem: new e1.Uniform1i(t1),
                            u_dem_prev: new e1.Uniform1i(t1),
                            u_dem_unpack: new e1.Uniform4f(t1),
                            u_dem_tl: new e1.Uniform2f(t1),
                            u_dem_scale: new e1.Uniform1f(t1),
                            u_dem_tl_prev: new e1.Uniform2f(t1),
                            u_dem_scale_prev: new e1.Uniform1f(t1),
                            u_dem_size: new e1.Uniform1f(t1),
                            u_dem_lerp: new e1.Uniform1f(t1),
                            u_exaggeration: new e1.Uniform1f(t1),
                            u_depth: new e1.Uniform1i(t1),
                            u_depth_size_inv: new e1.Uniform2f(t1),
                            u_meter_to_dem: new e1.Uniform1f(t1),
                            u_label_plane_matrix_inv: new e1.UniformMatrix4f(t1)
                        }))(t1)), s.includes("GLOBE") && (this.globeUniforms = ((t1)=>({
                            u_tile_tl_up: new e1.Uniform3f(t1),
                            u_tile_tr_up: new e1.Uniform3f(t1),
                            u_tile_br_up: new e1.Uniform3f(t1),
                            u_tile_bl_up: new e1.Uniform3f(t1),
                            u_tile_up_scale: new e1.Uniform1f(t1)
                        }))(t1)), s.includes("FOG") && (this.fogUniforms = ((t1)=>({
                            u_fog_matrix: new e1.UniformMatrix4f(t1),
                            u_fog_range: new e1.Uniform2f(t1),
                            u_fog_color: new e1.Uniform4f(t1),
                            u_fog_horizon_blend: new e1.Uniform1f(t1),
                            u_fog_temporal_offset: new e1.Uniform1f(t1),
                            u_frustum_tl: new e1.Uniform3f(t1),
                            u_frustum_tr: new e1.Uniform3f(t1),
                            u_frustum_br: new e1.Uniform3f(t1),
                            u_frustum_bl: new e1.Uniform3f(t1),
                            u_globe_pos: new e1.Uniform3f(t1),
                            u_globe_radius: new e1.Uniform1f(t1),
                            u_globe_transition: new e1.Uniform1f(t1),
                            u_is_globe: new e1.Uniform1i(t1),
                            u_viewport: new e1.Uniform2f(t1)
                        }))(t1));
                }
            }
            setTerrainUniformValues(e1, t1) {
                if (!this.terrainUniforms) return;
                const i = this.terrainUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1] && i[e1].set(this.program, e1, t1[e1]);
                }
            }
            setGlobeUniformValues(e1, t1) {
                if (!this.globeUniforms) return;
                const i = this.globeUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1] && i[e1].set(this.program, e1, t1[e1]);
                }
            }
            setFogUniformValues(e1, t1) {
                if (!this.fogUniforms) return;
                const i = this.fogUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1].set(this.program, e1, t1[e1]);
                }
            }
            draw(e1, t1, i, o, r, n, s, a, l, c, h, u, _, d, p) {
                const m = e1.gl;
                if (this.failedToCreate) return;
                e1.program.set(this.program), e1.setDepthMode(i), e1.setStencilMode(o), e1.setColorMode(r), e1.setCullFace(n);
                for (const e1 of Object.keys(this.fixedUniforms))this.fixedUniforms[e1].set(this.program, e1, s[e1]);
                d && d.setUniforms(this.program, e1, this.binderUniforms, u, {
                    zoom: _
                });
                const f = {
                    [m.LINES]: 2,
                    [m.TRIANGLES]: 3,
                    [m.LINE_STRIP]: 1
                }[t1];
                for (const i of h.get()){
                    const o = i.vaos || (i.vaos = {});
                    (o[a] || (o[a] = new pi)).bind(e1, this, l, d ? d.getPaintVertexBuffers() : [], c, i.vertexOffset, p || []), m.drawElements(t1, i.primitiveLength * f, m.UNSIGNED_SHORT, i.primitiveOffset * f * 2);
                }
            }
        }
        function Ri(e1, t1) {
            const i = Math.pow(2, t1.tileID.overscaledZ), o = t1.tileSize * Math.pow(2, e1.transform.tileZoom) / i, r = o * (t1.tileID.canonical.x + t1.tileID.wrap * i), n = o * t1.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: t1.imageAtlasTexture.size,
                u_tile_units_to_pixels: 1 / P(t1, 1, e1.transform.tileZoom),
                u_pixel_coord_upper: [
                    r >> 16,
                    n >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & r,
                    65535 & n
                ]
            };
        }
        const Oi = e1.create(), Bi = (t1, i, o, r, n, s, a, l, c, h, u)=>{
            const _ = i.style.light, d = _.properties.get("position"), p = [
                d.x,
                d.y,
                d.z
            ], m = e1.create$1();
            "viewport" === _.properties.get("anchor") && (e1.fromRotation(m, -i.transform.angle), e1.transformMat3(p, p, m));
            const f = _.properties.get("color"), g = i.transform, v = {
                u_matrix: t1,
                u_lightpos: p,
                u_lightintensity: _.properties.get("intensity"),
                u_lightcolor: [
                    f.r,
                    f.g,
                    f.b
                ],
                u_vertical_gradient: +o,
                u_opacity: r,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: Oi,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_ao: n,
                u_edge_radius: s
            };
            return "globe" === g.projection.name && (v.u_tile_id = [
                a.canonical.x,
                a.canonical.y,
                1 << a.canonical.z
            ], v.u_zoom_transition = c, v.u_inv_rot_matrix = u, v.u_merc_center = h, v.u_up_dir = g.projection.upVector(new e1.CanonicalTileID(0, 0, 0), h[0] * e1.EXTENT, h[1] * e1.EXTENT), v.u_height_lift = l), v;
        }, ki = (t1, i, o, r, n, s, a, l, c, h, u, _)=>{
            const d = Bi(t1, i, o, r, n, s, a, c, h, u, _), p = {
                u_height_factor: -Math.pow(2, a.overscaledZ) / l.tileSize / 8
            };
            return e1.extend(d, Ri(i, l), p);
        }, Fi = (e1)=>({
                u_matrix: e1
            }), Ui = (t1, i, o)=>e1.extend(Fi(t1), Ri(i, o)), Ni = (e1, t1)=>({
                u_matrix: e1,
                u_world: t1
            }), Gi = (t1, i, o, r)=>e1.extend(Ui(t1, i, o), {
                u_world: r
            }), ji = e1.create(), Zi = (t1, i, o, r, n, s)=>{
            const a = t1.transform, l = "globe" === a.projection.name;
            let c;
            if ("map" === s.paint.get("circle-pitch-alignment")) {
                if (l) {
                    const t1 = e1.globePixelsToTileUnits(a.zoom, i.canonical) * a._pixelsPerMercatorPixel;
                    c = Float32Array.from([
                        t1,
                        0,
                        0,
                        t1
                    ]);
                } else c = a.calculatePixelsToTileUnitsMatrix(o);
            } else c = new Float32Array([
                a.pixelsToGLUnits[0],
                0,
                0,
                a.pixelsToGLUnits[1]
            ]);
            const h = {
                u_camera_to_center_distance: a.cameraToCenterDistance,
                u_matrix: t1.translatePosMatrix(i.projMatrix, o, s.paint.get("circle-translate"), s.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: e1.exported.devicePixelRatio,
                u_extrude_scale: c,
                u_inv_rot_matrix: ji,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (l) {
                h.u_inv_rot_matrix = r, h.u_merc_center = n, h.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], h.u_zoom_transition = e1.globeToMercatorTransition(a.zoom);
                const t1 = n[0] * e1.EXTENT, o = n[1] * e1.EXTENT;
                h.u_up_dir = a.projection.upVector(new e1.CanonicalTileID(0, 0, 0), t1, o);
            }
            return h;
        }, Vi = (e1)=>{
            const t1 = [];
            return "map" === e1.paint.get("circle-pitch-alignment") && t1.push("PITCH_WITH_MAP"), "map" === e1.paint.get("circle-pitch-scale") && t1.push("SCALE_WITH_MAP"), t1;
        }, Wi = (t1, i, o, r)=>{
            const n = e1.EXTENT / o.tileSize;
            return {
                u_matrix: t1,
                u_camera_to_center_distance: i.getCameraToCenterDistance(r),
                u_extrude_scale: [
                    i.pixelsToGLUnits[0] / n,
                    i.pixelsToGLUnits[1] / n
                ]
            };
        }, Xi = (e1, t1, i = 1)=>({
                u_matrix: e1,
                u_color: t1,
                u_overlay: 0,
                u_overlay_scale: i
            }), qi = e1.create(), $i = (t1, i, o, r, n, s, a)=>{
            const l = t1.transform, c = "globe" === l.projection.name, h = c ? e1.globePixelsToTileUnits(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : P(o, 1, s), u = {
                u_matrix: i.projMatrix,
                u_extrude_scale: h,
                u_intensity: a,
                u_inv_rot_matrix: qi,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (c) {
                u.u_inv_rot_matrix = r, u.u_merc_center = n, u.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], u.u_zoom_transition = e1.globeToMercatorTransition(l.zoom);
                const t1 = n[0] * e1.EXTENT, o = n[1] * e1.EXTENT;
                u.u_up_dir = l.projection.upVector(new e1.CanonicalTileID(0, 0, 0), t1, o);
            }
            return u;
        }, Hi = (e1, t1, i, o, r, n, s)=>{
            const a = e1.transform, l = a.calculatePixelsToTileUnitsMatrix(t1);
            return {
                u_matrix: Ji(e1, t1, i, o),
                u_pixels_to_tile_units: l,
                u_device_pixel_ratio: n,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_image_height: r,
                u_texsize: Qi(i) ? t1.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: Ki(t1, e1.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: s
            };
        }, Yi = (e1, t1, i, o, r)=>{
            const n = e1.transform;
            return {
                u_matrix: Ji(e1, t1, i, o),
                u_texsize: t1.imageAtlasTexture.size,
                u_pixels_to_tile_units: n.calculatePixelsToTileUnitsMatrix(t1),
                u_device_pixel_ratio: r,
                u_image: 0,
                u_tile_units_to_pixels: Ki(t1, n),
                u_units_to_pixels: [
                    1 / n.pixelsToGLUnits[0],
                    1 / n.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0
            };
        };
        function Ki(e1, t1) {
            return 1 / P(e1, 1, t1.tileZoom);
        }
        function Ji(e1, t1, i, o) {
            return e1.translatePosMatrix(o || t1.tileID.projMatrix, t1, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        function Qi(e1) {
            const t1 = e1.paint.get("line-dasharray").value;
            return t1.value || "constant" !== t1.kind;
        }
        const eo = (e1, t1, i, o, r, n)=>{
            var s, a;
            return {
                u_matrix: e1,
                u_tl_parent: t1,
                u_scale_parent: i,
                u_fade_t: o.mix,
                u_opacity: o.opacity * r.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: r.paint.get("raster-brightness-min"),
                u_brightness_high: r.paint.get("raster-brightness-max"),
                u_saturation_factor: (a = r.paint.get("raster-saturation"), a > 0 ? 1 - 1 / (1.001 - a) : -a),
                u_contrast_factor: (s = r.paint.get("raster-contrast"), s > 0 ? 1 / (1 - s) : 1 + s),
                u_spin_weights: to(r.paint.get("raster-hue-rotate")),
                u_perspective_transform: n
            };
        };
        function to(e1) {
            e1 *= Math.PI / 180;
            const t1 = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t1 - i + 1) / 3,
                (Math.sqrt(3) * t1 - i + 1) / 3
            ];
        }
        const io = e1.create(), oo = (t1, i, o, r, n, s, a, l, c, h, u, _, d, p, m, f)=>{
            const g = n.transform, v = {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: i ? i.uSizeT : 0,
                u_size: i ? i.uSize : 0,
                u_camera_to_center_distance: g.cameraToCenterDistance,
                u_rotate_symbol: +o,
                u_aspect_ratio: g.width / g.height,
                u_fade_change: n.options.fadeDuration ? n.symbolFadeChange : 1,
                u_matrix: s,
                u_label_plane_matrix: a,
                u_coord_matrix: l,
                u_is_text: +c,
                u_pitch_with_map: +r,
                u_texsize: h,
                u_texture: 0,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: io,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: io,
                u_up_vector: [
                    0,
                    -1,
                    0
                ]
            };
            return "globe" === f.name && (v.u_tile_id = [
                u.canonical.x,
                u.canonical.y,
                1 << u.canonical.z
            ], v.u_zoom_transition = _, v.u_inv_rot_matrix = p, v.u_merc_center = d, v.u_camera_forward = g._camera.forward(), v.u_ecef_origin = e1.globeECEFOrigin(g.globeMatrix, u.toUnwrapped()), v.u_tile_matrix = Float32Array.from(g.globeMatrix), v.u_up_vector = m), v;
        }, ro = (t1, i, o, r, n, s, a, l, c, h, u, _, d, p, m, f, g)=>e1.extend(oo(t1, i, o, r, n, s, a, l, c, h, _, d, p, m, f, g), {
                u_gamma_scale: r ? n.transform.cameraToCenterDistance * Math.cos(n.terrain ? 0 : n.transform._pitch) : 1,
                u_device_pixel_ratio: e1.exported.devicePixelRatio,
                u_is_halo: +u
            }), no = (t1, i, o, r, n, s, a, l, c, h, u, _, d, p, m, f)=>e1.extend(ro(t1, i, o, r, n, s, a, l, !0, c, !0, u, _, d, p, m, f), {
                u_texsize_icon: h,
                u_texture_icon: 1
            }), so = (e1, t1, i)=>({
                u_matrix: e1,
                u_opacity: t1,
                u_color: i
            }), ao = (t1, i, o, r, n)=>e1.extend(function(e1, t1, i) {
                const o = t1.imageManager.getPattern(e1.toString()), { width: r, height: n } = t1.imageManager.getPixelSize(), s = Math.pow(2, i.tileID.overscaledZ), a = i.tileSize * Math.pow(2, t1.transform.tileZoom) / s, l = a * (i.tileID.canonical.x + i.tileID.wrap * s), c = a * i.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl: o.tl,
                    u_pattern_br: o.br,
                    u_texsize: [
                        r,
                        n
                    ],
                    u_pattern_size: o.displaySize,
                    u_tile_units_to_pixels: 1 / P(i, 1, t1.transform.tileZoom),
                    u_pixel_coord_upper: [
                        l >> 16,
                        c >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & l,
                        65535 & c
                    ]
                };
            }(r, o, n), {
                u_matrix: t1,
                u_opacity: i
            }), lo = {
            fillExtrusion: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_lightpos: new e1.Uniform3f(t1),
                    u_lightintensity: new e1.Uniform1f(t1),
                    u_lightcolor: new e1.Uniform3f(t1),
                    u_vertical_gradient: new e1.Uniform1f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_edge_radius: new e1.Uniform1f(t1),
                    u_ao: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_up_dir: new e1.Uniform3f(t1),
                    u_height_lift: new e1.Uniform1f(t1)
                }),
            fillExtrusionPattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_lightpos: new e1.Uniform3f(t1),
                    u_lightintensity: new e1.Uniform1f(t1),
                    u_lightcolor: new e1.Uniform3f(t1),
                    u_vertical_gradient: new e1.Uniform1f(t1),
                    u_height_factor: new e1.Uniform1f(t1),
                    u_edge_radius: new e1.Uniform1f(t1),
                    u_ao: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_up_dir: new e1.Uniform3f(t1),
                    u_height_lift: new e1.Uniform1f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_pixel_coord_upper: new e1.Uniform2f(t1),
                    u_pixel_coord_lower: new e1.Uniform2f(t1),
                    u_tile_units_to_pixels: new e1.Uniform1f(t1),
                    u_opacity: new e1.Uniform1f(t1)
                }),
            fill: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1)
                }),
            fillPattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_pixel_coord_upper: new e1.Uniform2f(t1),
                    u_pixel_coord_lower: new e1.Uniform2f(t1),
                    u_tile_units_to_pixels: new e1.Uniform1f(t1)
                }),
            fillOutline: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_world: new e1.Uniform2f(t1)
                }),
            fillOutlinePattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_world: new e1.Uniform2f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_pixel_coord_upper: new e1.Uniform2f(t1),
                    u_pixel_coord_lower: new e1.Uniform2f(t1),
                    u_tile_units_to_pixels: new e1.Uniform1f(t1)
                }),
            circle: (t1)=>({
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_extrude_scale: new e1.UniformMatrix2f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_up_dir: new e1.Uniform3f(t1)
                }),
            collisionBox: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_extrude_scale: new e1.Uniform2f(t1)
                }),
            collisionCircle: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_inv_matrix: new e1.UniformMatrix4f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_viewport_size: new e1.Uniform2f(t1)
                }),
            debug: (t1)=>({
                    u_color: new e1.UniformColor(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_overlay: new e1.Uniform1i(t1),
                    u_overlay_scale: new e1.Uniform1f(t1)
                }),
            clippingMask: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1)
                }),
            heatmap: (t1)=>({
                    u_extrude_scale: new e1.Uniform1f(t1),
                    u_intensity: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_up_dir: new e1.Uniform3f(t1)
                }),
            heatmapTexture: (t1)=>({
                    u_image: new e1.Uniform1i(t1),
                    u_color_ramp: new e1.Uniform1i(t1),
                    u_opacity: new e1.Uniform1f(t1)
                }),
            hillshade: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_latrange: new e1.Uniform2f(t1),
                    u_light: new e1.Uniform2f(t1),
                    u_shadow: new e1.UniformColor(t1),
                    u_highlight: new e1.UniformColor(t1),
                    u_accent: new e1.UniformColor(t1)
                }),
            hillshadePrepare: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_dimension: new e1.Uniform2f(t1),
                    u_zoom: new e1.Uniform1f(t1),
                    u_unpack: new e1.Uniform4f(t1)
                }),
            line: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_pixels_to_tile_units: new e1.UniformMatrix2f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_units_to_pixels: new e1.Uniform2f(t1),
                    u_dash_image: new e1.Uniform1i(t1),
                    u_gradient_image: new e1.Uniform1i(t1),
                    u_image_height: new e1.Uniform1f(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_tile_units_to_pixels: new e1.Uniform1f(t1),
                    u_alpha_discard_threshold: new e1.Uniform1f(t1),
                    u_trim_offset: new e1.Uniform2f(t1)
                }),
            linePattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_pixels_to_tile_units: new e1.UniformMatrix2f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_units_to_pixels: new e1.Uniform2f(t1),
                    u_tile_units_to_pixels: new e1.Uniform1f(t1),
                    u_alpha_discard_threshold: new e1.Uniform1f(t1)
                }),
            raster: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_tl_parent: new e1.Uniform2f(t1),
                    u_scale_parent: new e1.Uniform1f(t1),
                    u_fade_t: new e1.Uniform1f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_image0: new e1.Uniform1i(t1),
                    u_image1: new e1.Uniform1i(t1),
                    u_brightness_low: new e1.Uniform1f(t1),
                    u_brightness_high: new e1.Uniform1f(t1),
                    u_saturation_factor: new e1.Uniform1f(t1),
                    u_contrast_factor: new e1.Uniform1f(t1),
                    u_spin_weights: new e1.Uniform3f(t1),
                    u_perspective_transform: new e1.Uniform2f(t1)
                }),
            symbolIcon: (t1)=>({
                    u_is_size_zoom_constant: new e1.Uniform1i(t1),
                    u_is_size_feature_constant: new e1.Uniform1i(t1),
                    u_size_t: new e1.Uniform1f(t1),
                    u_size: new e1.Uniform1f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_rotate_symbol: new e1.Uniform1i(t1),
                    u_aspect_ratio: new e1.Uniform1f(t1),
                    u_fade_change: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_label_plane_matrix: new e1.UniformMatrix4f(t1),
                    u_coord_matrix: new e1.UniformMatrix4f(t1),
                    u_is_text: new e1.Uniform1i(t1),
                    u_pitch_with_map: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_camera_forward: new e1.Uniform3f(t1),
                    u_tile_matrix: new e1.UniformMatrix4f(t1),
                    u_up_vector: new e1.Uniform3f(t1),
                    u_ecef_origin: new e1.Uniform3f(t1),
                    u_texture: new e1.Uniform1i(t1)
                }),
            symbolSDF: (t1)=>({
                    u_is_size_zoom_constant: new e1.Uniform1i(t1),
                    u_is_size_feature_constant: new e1.Uniform1i(t1),
                    u_size_t: new e1.Uniform1f(t1),
                    u_size: new e1.Uniform1f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_rotate_symbol: new e1.Uniform1i(t1),
                    u_aspect_ratio: new e1.Uniform1f(t1),
                    u_fade_change: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_label_plane_matrix: new e1.UniformMatrix4f(t1),
                    u_coord_matrix: new e1.UniformMatrix4f(t1),
                    u_is_text: new e1.Uniform1i(t1),
                    u_pitch_with_map: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_texture: new e1.Uniform1i(t1),
                    u_gamma_scale: new e1.Uniform1f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_camera_forward: new e1.Uniform3f(t1),
                    u_tile_matrix: new e1.UniformMatrix4f(t1),
                    u_up_vector: new e1.Uniform3f(t1),
                    u_ecef_origin: new e1.Uniform3f(t1),
                    u_is_halo: new e1.Uniform1i(t1)
                }),
            symbolTextAndIcon: (t1)=>({
                    u_is_size_zoom_constant: new e1.Uniform1i(t1),
                    u_is_size_feature_constant: new e1.Uniform1i(t1),
                    u_size_t: new e1.Uniform1f(t1),
                    u_size: new e1.Uniform1f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_rotate_symbol: new e1.Uniform1i(t1),
                    u_aspect_ratio: new e1.Uniform1f(t1),
                    u_fade_change: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_label_plane_matrix: new e1.UniformMatrix4f(t1),
                    u_coord_matrix: new e1.UniformMatrix4f(t1),
                    u_is_text: new e1.Uniform1i(t1),
                    u_pitch_with_map: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_texsize_icon: new e1.Uniform2f(t1),
                    u_texture: new e1.Uniform1i(t1),
                    u_texture_icon: new e1.Uniform1i(t1),
                    u_gamma_scale: new e1.Uniform1f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_is_halo: new e1.Uniform1i(t1)
                }),
            background: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_color: new e1.UniformColor(t1)
                }),
            backgroundPattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_pattern_tl: new e1.Uniform2f(t1),
                    u_pattern_br: new e1.Uniform2f(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_pattern_size: new e1.Uniform2f(t1),
                    u_pixel_coord_upper: new e1.Uniform2f(t1),
                    u_pixel_coord_lower: new e1.Uniform2f(t1),
                    u_tile_units_to_pixels: new e1.Uniform1f(t1)
                }),
            terrainRaster: xi,
            terrainDepth: xi,
            skybox: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_sun_direction: new e1.Uniform3f(t1),
                    u_cubemap: new e1.Uniform1i(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_temporal_offset: new e1.Uniform1f(t1)
                }),
            skyboxGradient: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_color_ramp: new e1.Uniform1i(t1),
                    u_center_direction: new e1.Uniform3f(t1),
                    u_radius: new e1.Uniform1f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_temporal_offset: new e1.Uniform1f(t1)
                }),
            skyboxCapture: (t1)=>({
                    u_matrix_3f: new e1.UniformMatrix3f(t1),
                    u_sun_direction: new e1.Uniform3f(t1),
                    u_sun_intensity: new e1.Uniform1f(t1),
                    u_color_tint_r: new e1.Uniform4f(t1),
                    u_color_tint_m: new e1.Uniform4f(t1),
                    u_luminance: new e1.Uniform1f(t1)
                }),
            globeRaster: (t1)=>({
                    u_proj_matrix: new e1.UniformMatrix4f(t1),
                    u_globe_matrix: new e1.UniformMatrix4f(t1),
                    u_normalize_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_matrix: new e1.UniformMatrix4f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_image0: new e1.Uniform1i(t1),
                    u_grid_matrix: new e1.UniformMatrix3f(t1),
                    u_skirt_height: new e1.Uniform1f(t1),
                    u_frustum_tl: new e1.Uniform3f(t1),
                    u_frustum_tr: new e1.Uniform3f(t1),
                    u_frustum_br: new e1.Uniform3f(t1),
                    u_frustum_bl: new e1.Uniform3f(t1),
                    u_globe_pos: new e1.Uniform3f(t1),
                    u_globe_radius: new e1.Uniform1f(t1),
                    u_viewport: new e1.Uniform2f(t1)
                }),
            globeAtmosphere: (t1)=>({
                    u_frustum_tl: new e1.Uniform3f(t1),
                    u_frustum_tr: new e1.Uniform3f(t1),
                    u_frustum_br: new e1.Uniform3f(t1),
                    u_frustum_bl: new e1.Uniform3f(t1),
                    u_horizon: new e1.Uniform1f(t1),
                    u_transition: new e1.Uniform1f(t1),
                    u_fadeout_range: new e1.Uniform1f(t1),
                    u_color: new e1.Uniform4f(t1),
                    u_high_color: new e1.Uniform4f(t1),
                    u_space_color: new e1.Uniform4f(t1),
                    u_star_intensity: new e1.Uniform1f(t1),
                    u_star_density: new e1.Uniform1f(t1),
                    u_star_size: new e1.Uniform1f(t1),
                    u_temporal_offset: new e1.Uniform1f(t1),
                    u_horizon_angle: new e1.Uniform1f(t1),
                    u_rotation_matrix: new e1.UniformMatrix4f(t1)
                })
        };
        let co;
        function ho(t1, i, o, r, n, s, a) {
            const l = t1.context, c = l.gl, h = t1.transform, u = t1.useProgram("collisionBox"), _ = [];
            let d = 0, p = 0;
            for(let m = 0; m < r.length; m++){
                const f = r[m], g = i.getTile(f), v = g.getBucket(o);
                if (!v) continue;
                const x = yt(f, v, h);
                let y = x;
                0 === n[0] && 0 === n[1] || (y = t1.translatePosMatrix(x, g, n, s));
                const b = a ? v.textCollisionBox : v.iconCollisionBox, w = v.collisionCircleArray;
                if (w.length > 0) {
                    const t1 = e1.create(), i = y;
                    e1.mul(t1, v.placementInvProjMatrix, h.glCoordMatrix), e1.mul(t1, t1, v.placementViewportMatrix), _.push({
                        circleArray: w,
                        circleOffset: p,
                        transform: i,
                        invTransform: t1,
                        projection: v.getProjection()
                    }), d += w.length / 4, p = d;
                }
                b && (t1.terrain && t1.terrain.setupElevationDraw(g, u), u.draw(l, c.LINES, e1.DepthMode.disabled, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.disabled, Wi(y, h, g, v.getProjection()), o.id, b.layoutVertexBuffer, b.indexBuffer, b.segments, null, h.zoom, null, [
                    b.collisionVertexBuffer,
                    b.collisionVertexBufferExt
                ]));
            }
            if (!a || !_.length) return;
            const m = t1.useProgram("collisionCircle"), f = new e1.StructArrayLayout2f1f2i16;
            f.resize(4 * d), f._trim();
            let g = 0;
            for (const e1 of _)for(let t1 = 0; t1 < e1.circleArray.length / 4; t1++){
                const i = 4 * t1, o = e1.circleArray[i + 0], r = e1.circleArray[i + 1], n = e1.circleArray[i + 2], s = e1.circleArray[i + 3];
                f.emplace(g++, o, r, n, s, 0), f.emplace(g++, o, r, n, s, 1), f.emplace(g++, o, r, n, s, 2), f.emplace(g++, o, r, n, s, 3);
            }
            (!co || co.length < 2 * d) && (co = function(t1) {
                const i = 2 * t1, o = new e1.StructArrayLayout3ui6;
                o.resize(i), o._trim();
                for(let e1 = 0; e1 < i; e1++){
                    const t1 = 6 * e1;
                    o.uint16[t1 + 0] = 4 * e1 + 0, o.uint16[t1 + 1] = 4 * e1 + 1, o.uint16[t1 + 2] = 4 * e1 + 2, o.uint16[t1 + 3] = 4 * e1 + 2, o.uint16[t1 + 4] = 4 * e1 + 3, o.uint16[t1 + 5] = 4 * e1 + 0;
                }
                return o;
            }(d));
            const v = l.createIndexBuffer(co, !0), x = l.createVertexBuffer(f, e1.collisionCircleLayout.members, !0);
            for (const i of _){
                const r = {
                    u_matrix: i.transform,
                    u_inv_matrix: i.invTransform,
                    u_camera_to_center_distance: (y = h).getCameraToCenterDistance(i.projection),
                    u_viewport_size: [
                        y.width,
                        y.height
                    ]
                };
                m.draw(l, c.TRIANGLES, e1.DepthMode.disabled, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.disabled, r, o.id, x, v, e1.SegmentVector.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, h.zoom);
            }
            var y;
            x.destroy(), v.destroy();
        }
        const uo = e1.create();
        function _o({ width: t1, height: i, anchor: o, textOffset: r, textScale: n }, s) {
            const { horizontalAlign: a, verticalAlign: l } = e1.getAnchorAlignment(o), c = -(a - .5) * t1, h = -(l - .5) * i, u = e1.evaluateVariableOffset(o, r);
            return new e1.pointGeometry((c / n + u[0]) * s, (h / n + u[1]) * s);
        }
        function po(t1, i, o, r, n, s, a, l, c, h, u) {
            const _ = t1.text.placedSymbolArray, d = t1.text.dynamicLayoutVertexArray, p = t1.icon.dynamicLayoutVertexArray, m = {}, f = t1.getProjection(), g = bt(l, f, s), v = s.elevation, x = f.upVectorScale(l.canonical, s.center.lat, s.worldSize).metersToTile;
            d.clear();
            for(let p = 0; p < _.length; p++){
                const y = _.get(p), { tileAnchorX: b, tileAnchorY: w, numGlyphs: T } = y, E = t1.allowVerticalPlacement && !y.placedOrientation, C = y.hidden || !y.crossTileID || E ? null : r[y.crossTileID];
                if (C) {
                    let r = 0, _ = 0, p = 0;
                    if (v) {
                        const e1 = v ? v.getAtTileOffset(l, b, w) : 0, [t1, i, o] = f.upVector(l.canonical, b, w);
                        r = e1 * t1 * x, _ = e1 * i * x, p = e1 * o * x;
                    }
                    let [E, M, I, S] = nt(y.projectedAnchorX + r, y.projectedAnchorY + _, y.projectedAnchorZ + p, o ? g : a);
                    const D = st(s.getCameraToCenterDistance(f), S);
                    let L = n.evaluateSizeForFeature(t1.textSizeData, h, y) * D / e1.ONE_EM;
                    o && (L *= t1.tilePixelRatio / c);
                    const A = _o(C, L);
                    o ? ({ x: E, y: M, z: I } = f.projectTilePoint(b + A.x, w + A.y, l.canonical), [E, M, I] = nt(E + r, M + _, I + p, a)) : (i && A._rotate(-s.angle), E += A.x, M += A.y, I = 0);
                    const z = t1.allowVerticalPlacement && y.placedOrientation === e1.WritingMode.vertical ? Math.PI / 2 : 0;
                    for(let t1 = 0; t1 < T; t1++)e1.addDynamicAttributes(d, E, M, I, z);
                    u && y.associatedIconIndex >= 0 && (m[y.associatedIconIndex] = {
                        x: E,
                        y: M,
                        z: I,
                        angle: z
                    });
                } else mt(T, d);
            }
            if (u) {
                p.clear();
                const i = t1.icon.placedSymbolArray;
                for(let t1 = 0; t1 < i.length; t1++){
                    const o = i.get(t1), { numGlyphs: r } = o, n = m[t1];
                    if (o.hidden || !n) mt(r, p);
                    else {
                        const { x: t1, y: i, z: o, angle: s } = n;
                        for(let n = 0; n < r; n++)e1.addDynamicAttributes(p, t1, i, o, s);
                    }
                }
                t1.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            t1.text.dynamicLayoutVertexBuffer.updateData(d);
        }
        function mo(e1, t1, i) {
            return i.iconsInText && t1 ? "symbolTextAndIcon" : e1 ? "symbolSDF" : "symbolIcon";
        }
        function fo(t1, i, o, r, n, s, a, l, c, h, u, _) {
            const d = t1.context, p = d.gl, m = t1.transform, f = "map" === l, g = "map" === c, v = f && "point" !== o.layout.get("symbol-placement"), x = f && !g && !v, y = void 0 !== o.layout.get("symbol-sort-key").constantOr(1);
            let b = !1;
            const w = t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly), T = [
                e1.mercatorXfromLng(m.center.lng),
                e1.mercatorYfromLat(m.center.lat)
            ], E = o.layout.get("text-variable-anchor"), C = "globe" === m.projection.name, M = [], I = [
                0,
                -1,
                0
            ];
            let S = I;
            !C && !m.mercatorFromTransition || f || (S = function(t1) {
                const i = t1._camera.getWorldToCamera(t1.worldSize, 1), o = e1.multiply([], i, t1.globeMatrix);
                e1.invert(o, o);
                const r = [
                    0,
                    0,
                    0
                ], n = [
                    0,
                    1,
                    0,
                    0
                ];
                return e1.transformMat4$1(n, n, o), r[0] = n[0], r[1] = n[1], r[2] = n[2], e1.normalize(r, r), r;
            }(m));
            for (const l of r){
                const r = i.getTile(l), c = r.getBucket(o);
                if (!c) continue;
                if ("mercator" === c.projection.name && C) continue;
                const u = n ? c.text : c.icon;
                if (!u || c.fullyClipped || !u.segments.get().length) continue;
                const _ = u.programConfigurations.get(o.id), d = n || c.sdfIcons, w = n ? c.textSizeData : c.iconSizeData, D = g || 0 !== m.pitch, L = e1.evaluateSizeForZoom(w, m.zoom);
                let A, z, P, R, O = [
                    0,
                    0
                ], B = null;
                if (n) {
                    if (z = r.glyphAtlasTexture, P = p.LINEAR, A = r.glyphAtlasTexture.size, c.iconsInText) {
                        O = r.imageAtlasTexture.size, B = r.imageAtlasTexture;
                        const e1 = "composite" === w.kind || "camera" === w.kind;
                        R = D || t1.options.rotating || t1.options.zooming || e1 ? p.LINEAR : p.NEAREST;
                    }
                } else {
                    const e1 = 1 !== o.layout.get("icon-size").constantOr(0) || c.iconsNeedLinear;
                    z = r.imageAtlasTexture, P = d || t1.options.rotating || t1.options.zooming || e1 || D ? p.LINEAR : p.NEAREST, A = r.imageAtlasTexture.size;
                }
                const k = "globe" === c.projection.name, F = k ? S : I, U = k ? e1.globeToMercatorTransition(m.zoom) : 0, N = bt(l, c.getProjection(), m), G = m.calculatePixelsToTileUnitsMatrix(r), j = it(N, r.tileID.canonical, g, f, m, c.getProjection(), G), Z = t1.terrain && g && v ? e1.invert(e1.create(), j) : uo, V = rt(N, r.tileID.canonical, g, f, m, c.getProjection(), G), W = E && c.hasTextData(), X = "none" !== o.layout.get("icon-text-fit") && W && c.hasIconData();
                if (v) {
                    const e1 = m.elevation, i = e1 ? e1.getAtTileOffsetFunc(l, m.center.lat, m.worldSize, c.getProjection()) : null, o = ot(N, r.tileID.canonical, g, f, m, c.getProjection(), G);
                    lt(c, N, t1, n, o, V, g, h, i, l);
                }
                const q = v || n && E || X, $ = t1.translatePosMatrix(N, r, s, a), H = q ? uo : j, Y = t1.translatePosMatrix(V, r, s, a, !0), K = c.getProjection().createInversionMatrix(m, l.canonical), J = [];
                t1.terrainRenderModeElevated() && g && J.push("PITCH_WITH_MAP_TERRAIN"), k && J.push("PROJECTION_GLOBE_VIEW"), q && J.push("PROJECTED_POS_ON_VIEWPORT");
                const Q = d && 0 !== o.paint.get(n ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let ee;
                ee = d ? c.iconsInText ? no(w.kind, L, x, g, t1, $, H, Y, A, O, l, U, T, K, F, c.getProjection()) : ro(w.kind, L, x, g, t1, $, H, Y, n, A, !0, l, U, T, K, F, c.getProjection()) : oo(w.kind, L, x, g, t1, $, H, Y, n, A, l, U, T, K, F, c.getProjection());
                const te = {
                    program: t1.useProgram(mo(d, n, c), _, J),
                    buffers: u,
                    uniformValues: ee,
                    atlasTexture: z,
                    atlasTextureIcon: B,
                    atlasInterpolation: P,
                    atlasInterpolationIcon: R,
                    isSDF: d,
                    hasHalo: Q,
                    tile: r,
                    labelPlaneMatrixInv: Z
                };
                if (y && c.canOverlap) {
                    b = !0;
                    const t1 = u.segments.get();
                    for (const i of t1)M.push({
                        segments: new e1.SegmentVector([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: te
                    });
                } else M.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: te
                });
            }
            b && M.sort((e1, t1)=>e1.sortKey - t1.sortKey);
            for (const e1 of M){
                const i = e1.state;
                if (t1.terrain && t1.terrain.setupElevationDraw(i.tile, i.program, {
                    useDepthForOcclusion: !C,
                    labelPlaneMatrixInv: i.labelPlaneMatrixInv
                }), d.activeTexture.set(p.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, p.CLAMP_TO_EDGE), i.atlasTextureIcon && (d.activeTexture.set(p.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, p.CLAMP_TO_EDGE)), i.isSDF) {
                    const r = i.uniformValues;
                    i.hasHalo && (r.u_is_halo = 1, go(i.buffers, e1.segments, o, t1, i.program, w, u, _, r)), r.u_is_halo = 0;
                }
                go(i.buffers, e1.segments, o, t1, i.program, w, u, _, i.uniformValues);
            }
        }
        function go(t1, i, o, r, n, s, a, l, c) {
            const h = r.context, u = [
                t1.dynamicLayoutVertexBuffer,
                t1.opacityVertexBuffer,
                t1.globeExtVertexBuffer
            ];
            n.draw(h, h.gl.TRIANGLES, s, a, l, e1.CullFaceMode.disabled, c, o.id, t1.layoutVertexBuffer, t1.indexBuffer, i, o.paint, r.transform.zoom, t1.programConfigurations.get(o.id), u);
        }
        function vo(t1, i, o, r, n, s, a) {
            const l = t1.context.gl, c = o.paint.get("fill-pattern"), h = c && c.constantOr(1);
            let u, _, d, p, m;
            a ? (_ = h && !o.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", u = l.LINES) : (_ = h ? "fillPattern" : "fill", u = l.TRIANGLES);
            for (const f of r){
                const r = i.getTile(f);
                if (h && !r.patternsLoaded()) continue;
                const g = r.getBucket(o);
                if (!g) continue;
                t1.prepareDrawTile();
                const v = g.programConfigurations.get(o.id), x = t1.useProgram(_, v);
                h && (t1.context.activeTexture.set(l.TEXTURE0), r.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), v.updatePaintBuffers());
                const y = c.constantOr(null);
                if (y && r.imageAtlas) {
                    const e1 = r.imageAtlas.patternPositions[y.toString()];
                    e1 && v.setConstantPatternPositions(e1);
                }
                const b = t1.translatePosMatrix(f.projMatrix, r, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor"));
                if (a) {
                    p = g.indexBuffer2, m = g.segments2;
                    const e1 = t1.terrain && t1.terrain.renderingToTexture ? t1.terrain.drapeBufferSize : [
                        l.drawingBufferWidth,
                        l.drawingBufferHeight
                    ];
                    d = "fillOutlinePattern" === _ && h ? Gi(b, t1, r, e1) : Ni(b, e1);
                } else p = g.indexBuffer, m = g.segments, d = h ? Ui(b, t1, r) : Fi(b);
                t1.prepareDrawProgram(t1.context, x, f.toUnwrapped()), x.draw(t1.context, u, n, t1.stencilModeForClipping(f), s, e1.CullFaceMode.disabled, d, o.id, g.layoutVertexBuffer, p, m, o.paint, t1.transform.zoom, v);
            }
        }
        function xo(t1, i, o, r, n, s, a) {
            const l = t1.context, c = l.gl, h = t1.transform, u = o.paint.get("fill-extrusion-pattern"), _ = u.constantOr(1), d = o.paint.get("fill-extrusion-opacity"), p = [
                o.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                o.paint.get("fill-extrusion-ambient-occlusion-radius")
            ], m = o.layout.get("fill-extrusion-edge-radius"), f = "globe" === h.projection.name ? e1.fillExtrusionHeightLift() : 0, g = "globe" === h.projection.name, v = g ? e1.globeToMercatorTransition(h.zoom) : 0, x = [
                e1.mercatorXfromLng(h.center.lng),
                e1.mercatorYfromLat(h.center.lat)
            ], y = [];
            g && y.push("PROJECTION_GLOBE_VIEW"), p[0] > 0 && y.push("FAUX_AO");
            for (const b of r){
                const r = i.getTile(b), w = r.getBucket(o);
                if (!w || w.projection.name !== h.projection.name) continue;
                const T = w.programConfigurations.get(o.id), E = t1.useProgram(_ ? "fillExtrusionPattern" : "fillExtrusion", T, y);
                if (t1.terrain) {
                    const e1 = t1.terrain;
                    if (t1.style.terrainSetForDrapingOnly()) e1.setupElevationDraw(r, E, {
                        useMeterToDem: !0
                    });
                    else {
                        if (!w.enableTerrain) continue;
                        if (e1.setupElevationDraw(r, E, {
                            useMeterToDem: !0
                        }), yo(l, i, b, w, o, e1), !w.centroidVertexBuffer) {
                            const e1 = E.attributes.a_centroid_pos;
                            void 0 !== e1 && c.vertexAttrib2f(e1, 0, 0);
                        }
                    }
                }
                _ && (t1.context.activeTexture.set(c.TEXTURE0), r.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), T.updatePaintBuffers());
                const C = u.constantOr(null);
                if (C && r.imageAtlas) {
                    const e1 = r.imageAtlas.patternPositions[C.toString()];
                    e1 && T.setConstantPatternPositions(e1);
                }
                const M = t1.translatePosMatrix(b.projMatrix, r, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), I = h.projection.createInversionMatrix(h, b.canonical), S = o.paint.get("fill-extrusion-vertical-gradient"), D = _ ? ki(M, t1, S, d, p, m, b, r, f, v, x, I) : Bi(M, t1, S, d, p, m, b, f, v, x, I);
                t1.prepareDrawProgram(l, E, b.toUnwrapped());
                const L = [];
                t1.terrain && L.push(w.centroidVertexBuffer), g && L.push(w.layoutVertexExtBuffer), E.draw(l, l.gl.TRIANGLES, n, s, a, e1.CullFaceMode.backCCW, D, o.id, w.layoutVertexBuffer, w.indexBuffer, w.segments, o.paint, t1.transform.zoom, T, L);
            }
        }
        function yo(t1, i, o, r, n, s) {
            const a = [
                (t1)=>{
                    let i = t1.canonical.x - 1, o = t1.wrap;
                    return i < 0 && (i = (1 << t1.canonical.z) - 1, o--), new e1.OverscaledTileID(t1.overscaledZ, o, t1.canonical.z, i, t1.canonical.y);
                },
                (t1)=>{
                    let i = t1.canonical.x + 1, o = t1.wrap;
                    return i === 1 << t1.canonical.z && (i = 0, o++), new e1.OverscaledTileID(t1.overscaledZ, o, t1.canonical.z, i, t1.canonical.y);
                },
                (t1)=>new e1.OverscaledTileID(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, (0 === t1.canonical.y ? 1 << t1.canonical.z : t1.canonical.y) - 1),
                (t1)=>new e1.OverscaledTileID(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y === (1 << t1.canonical.z) - 1 ? 0 : t1.canonical.y + 1)
            ], l = (e1)=>{
                const t1 = i.getSource().minzoom, o = (e1)=>{
                    const t1 = i.getTileByID(e1);
                    if (t1 && t1.hasData()) return t1.getBucket(n);
                }, r = [
                    0,
                    -1,
                    1
                ];
                for (const i of r){
                    if (e1.overscaledZ + i < t1) continue;
                    const r = o(e1.calculateScaledKey(e1.overscaledZ + i));
                    if (r) return r;
                }
            }, c = [
                0,
                0,
                0
            ], h = (t1, i)=>(c[0] = Math.min(t1.min.y, i.min.y), c[1] = Math.max(t1.max.y, i.max.y), c[2] = e1.EXTENT - i.min.x > t1.max.x ? i.min.x - e1.EXTENT : t1.max.x, c), u = (t1, i)=>(c[0] = Math.min(t1.min.x, i.min.x), c[1] = Math.max(t1.max.x, i.max.x), c[2] = e1.EXTENT - i.min.y > t1.max.y ? i.min.y - e1.EXTENT : t1.max.y, c), _ = [
                (e1, t1)=>h(e1, t1),
                (e1, t1)=>h(t1, e1),
                (e1, t1)=>u(e1, t1),
                (e1, t1)=>u(t1, e1)
            ], d = new e1.pointGeometry(0, 0);
            let p, m, f;
            const g = (t1, i, r, n, a)=>{
                const l = [
                    [
                        n ? r : t1,
                        n ? t1 : r,
                        0
                    ],
                    [
                        n ? r : i,
                        n ? i : r,
                        0
                    ]
                ], c = a < 0 ? e1.EXTENT + a : a, h = [
                    n ? c : (t1 + i) / 2,
                    n ? (t1 + i) / 2 : c,
                    0
                ];
                return 0 === r && a < 0 || 0 !== r && a > 0 ? s.getForTilePoints(f, [
                    h
                ], !0, m) : l.push(h), s.getForTilePoints(o, l, !0, p), Math.max(l[0][2], l[1][2], h[2]) / s.exaggeration();
            };
            for(let t1 = 0; t1 < 4; t1++){
                const i = (t1 < 2 ? 1 : 5) - t1, n = r.borders[t1];
                if (0 === n.length) continue;
                const c = f = a[t1](o), h = l(c);
                if (!(h && h instanceof e1.FillExtrusionBucket && h.enableTerrain)) continue;
                if (r.borderDoneWithNeighborZ[t1] === h.canonical.z && h.borderDoneWithNeighborZ[i] === r.canonical.z) continue;
                if (m = s.findDEMTileFor(c), !m || !m.dem) continue;
                if (!p) {
                    const e1 = s.findDEMTileFor(o);
                    if (!e1 || !e1.dem) return;
                    p = e1;
                }
                const u = h.borders[i];
                let v = 0;
                const x = h.borderDoneWithNeighborZ[i] !== r.canonical.z;
                if (r.canonical.z === h.canonical.z) {
                    for(let o = 0; o < n.length; o++){
                        const s = r.featuresOnBorder[n[o]], a = s.borders[t1];
                        let l;
                        for(; v < u.length && (l = h.featuresOnBorder[u[v]], !(l.borders[i][1] > a[0] + 3));)x && h.encodeCentroid(void 0, l, !1), v++;
                        if (l && v < u.length) {
                            const o = v;
                            let n = 0;
                            for(; !(l.borders[i][0] > a[1] - 3) && (n++, ++v !== u.length);)l = h.featuresOnBorder[u[v]];
                            if (l = h.featuresOnBorder[u[o]], s.intersectsCount() > 1 || l.intersectsCount() > 1 || 1 !== n) {
                                1 !== n && (v = o), r.encodeCentroid(void 0, s, !1), x && h.encodeCentroid(void 0, l, !1);
                                continue;
                            }
                            const c = _[t1](s, l), p = t1 % 2 ? e1.EXTENT - 1 : 0;
                            d.x = g(c[0], Math.min(e1.EXTENT - 1, c[1]), p, t1 < 2, c[2]), d.y = 0, r.encodeCentroid(d, s, !1), x && h.encodeCentroid(d, l, !1);
                        } else r.encodeCentroid(void 0, s, !1);
                    }
                    r.borderDoneWithNeighborZ[t1] = h.canonical.z, r.needsCentroidUpdate = !0, x && (h.borderDoneWithNeighborZ[i] = r.canonical.z, h.needsCentroidUpdate = !0);
                } else {
                    for (const e1 of n)r.encodeCentroid(void 0, r.featuresOnBorder[e1], !1);
                    if (x) {
                        for (const e1 of u)h.encodeCentroid(void 0, h.featuresOnBorder[e1], !1);
                        h.borderDoneWithNeighborZ[i] = r.canonical.z, h.needsCentroidUpdate = !0;
                    }
                    r.borderDoneWithNeighborZ[t1] = h.canonical.z, r.needsCentroidUpdate = !0;
                }
            }
            (r.needsCentroidUpdate || !r.centroidVertexBuffer && 0 !== r.centroidVertexArray.length) && r.uploadCentroid(t1);
        }
        const bo = new e1.Color(1, 0, 0, 1), wo = new e1.Color(0, 1, 0, 1), To = new e1.Color(0, 0, 1, 1), Eo = new e1.Color(1, 0, 1, 1), Co = new e1.Color(0, 1, 1, 1);
        function Mo(t1, i, o) {
            const r = t1.context, n = t1.transform, s = r.gl, a = "globe" === n.projection.name, l = a ? [
                "PROJECTION_GLOBE_VIEW"
            ] : null;
            let c = o.projMatrix;
            if (a && e1.globeToMercatorTransition(n.zoom) > 0) {
                const t1 = e1.transitionTileAABBinECEF(o.canonical, n), i = e1.globeDenormalizeECEF(t1);
                c = e1.multiply(new Float32Array(16), n.globeMatrix, i), e1.multiply(c, n.projMatrix, c);
            }
            const h = t1.useProgram("debug", null, l), u = i.getTileByID(o.key);
            t1.terrain && t1.terrain.setupElevationDraw(u, h);
            const _ = e1.DepthMode.disabled, d = e1.StencilMode.disabled, p = t1.colorModeForRenderPass(), m = "$debug";
            r.activeTexture.set(s.TEXTURE0), t1.emptyTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE), a ? u._makeGlobeTileDebugBuffers(t1.context, n) : u._makeDebugTileBoundsBuffers(t1.context, n.projection);
            const f = u._tileDebugBuffer || t1.debugBuffer, g = u._tileDebugIndexBuffer || t1.debugIndexBuffer, v = u._tileDebugSegments || t1.debugSegments;
            h.draw(r, s.LINE_STRIP, _, d, p, e1.CullFaceMode.disabled, Xi(c, e1.Color.red), m, f, g, v, null, null, null, [
                u._globeTileDebugBorderBuffer
            ]);
            const x = u.latestRawTileData, y = Math.floor((x && x.byteLength || 0) / 1024), b = i.getTile(o).tileSize, w = 512 / Math.min(b, 512) * (o.overscaledZ / n.zoom) * .5;
            let T = o.canonical.toString();
            o.overscaledZ !== o.canonical.z && (T += ` => ${o.overscaledZ}`), T += ` ${y}kb`, function(e1, t1) {
                e1.initDebugOverlayCanvas();
                const i = e1.debugOverlayCanvas, o = e1.context.gl, r = e1.debugOverlayCanvas.getContext("2d");
                r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(t1, 5, 5), r.strokeText(t1, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }(t1, T);
            const E = u._tileDebugTextBuffer || t1.debugBuffer, C = u._tileDebugTextIndexBuffer || t1.quadTriangleIndexBuffer, M = u._tileDebugTextSegments || t1.debugSegments;
            h.draw(r, s.TRIANGLES, _, d, e1.ColorMode.alphaBlended, e1.CullFaceMode.disabled, Xi(c, e1.Color.transparent, w), m, E, C, M, null, null, null, [
                u._globeTileDebugTextBuffer
            ]);
        }
        function Io(e1, t1, i, o) {
            Do(e1, 0, t1 + i / 2, e1.transform.width, i, o);
        }
        function So(e1, t1, i, o) {
            Do(e1, t1 - i / 2, 0, i, e1.transform.height, o);
        }
        function Do(t1, i, o, r, n, s) {
            const a = t1.context, l = a.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * e1.exported.devicePixelRatio, o * e1.exported.devicePixelRatio, r * e1.exported.devicePixelRatio, n * e1.exported.devicePixelRatio), a.clear({
                color: s
            }), l.disable(l.SCISSOR_TEST);
        }
        const Lo = e1.createLayout([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: Ao } = Lo;
        function zo(e1, t1, i, o) {
            e1.emplaceBack(t1, i, o);
        }
        class Po {
            constructor(t1){
                this.vertexArray = new e1.StructArrayLayout3f12, this.indices = new e1.StructArrayLayout3ui6, zo(this.vertexArray, -1, -1, 1), zo(this.vertexArray, 1, -1, 1), zo(this.vertexArray, -1, 1, 1), zo(this.vertexArray, 1, 1, 1), zo(this.vertexArray, -1, -1, -1), zo(this.vertexArray, 1, -1, -1), zo(this.vertexArray, -1, 1, -1), zo(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, Ao), this.indexBuffer = t1.createIndexBuffer(this.indices), this.segment = e1.SegmentVector.simpleSegment(0, 0, 36, 12);
            }
        }
        function Ro(t1, i, o, r, n, s) {
            const a = t1.gl, l = i.paint.get("sky-atmosphere-color"), c = i.paint.get("sky-atmosphere-halo-color"), h = i.paint.get("sky-atmosphere-sun-intensity"), u = ((e1, t1, i, o, r)=>({
                    u_matrix_3f: e1,
                    u_sun_direction: t1,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        o.r,
                        o.g,
                        o.b,
                        o.a
                    ],
                    u_color_tint_m: [
                        r.r,
                        r.g,
                        r.b,
                        r.a
                    ],
                    u_luminance: 5e-5
                }))(e1.fromMat4(e1.create$1(), r), n, h, l, c);
            a.framebufferTexture2D(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_CUBE_MAP_POSITIVE_X + s, i.skyboxTexture, 0), o.draw(t1, a.TRIANGLES, e1.DepthMode.disabled, e1.StencilMode.disabled, e1.ColorMode.unblended, e1.CullFaceMode.frontCW, u, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
        }
        const Oo = e1.createLayout([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class Bo {
            constructor(t1){
                const i = new e1.StructArrayLayout5f20;
                i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
                const o = new e1.StructArrayLayout3ui6;
                o.emplaceBack(0, 1, 2), o.emplaceBack(2, 3, 0), this.vertexBuffer = t1.createVertexBuffer(i, Oo.members), this.indexBuffer = t1.createIndexBuffer(o), this.segments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
        }
        const ko = {
            symbol: function(t1, i, o, r, n) {
                if ("translucent" !== t1.renderPass) return;
                const s = e1.StencilMode.disabled, a = t1.colorModeForRenderPass();
                o.layout.get("text-variable-anchor") && function(t1, i, o, r, n, s, a) {
                    const l = i.transform, c = "map" === n, h = "map" === s;
                    for (const i of t1){
                        const t1 = r.getTile(i), n = t1.getBucket(o);
                        if (!n || !n.text || !n.text.segments.get().length) continue;
                        const s = e1.evaluateSizeForZoom(n.textSizeData, l.zoom), u = bt(i, n.getProjection(), l), _ = l.calculatePixelsToTileUnitsMatrix(t1), d = it(u, t1.tileID.canonical, h, c, l, n.getProjection(), _), p = "none" !== o.layout.get("icon-text-fit") && n.hasIconData();
                        if (s) {
                            const o = Math.pow(2, l.zoom - t1.tileID.overscaledZ);
                            po(n, c, h, a, e1.symbolSize, l, d, i, o, s, p);
                        }
                    }
                }(r, t1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), n), 0 !== o.paint.get("icon-opacity").constantOr(1) && fo(t1, i, o, r, !1, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), o.layout.get("icon-rotation-alignment"), o.layout.get("icon-pitch-alignment"), o.layout.get("icon-keep-upright"), s, a), 0 !== o.paint.get("text-opacity").constantOr(1) && fo(t1, i, o, r, !0, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), o.layout.get("text-keep-upright"), s, a), i.map.showCollisionBoxes && (ho(t1, i, o, r, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), ho(t1, i, o, r, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(t1, i, o, r) {
                if ("translucent" !== t1.renderPass) return;
                const n = o.paint.get("circle-opacity"), s = o.paint.get("circle-stroke-width"), a = o.paint.get("circle-stroke-opacity"), l = void 0 !== o.layout.get("circle-sort-key").constantOr(1);
                if (0 === n.constantOr(1) && (0 === s.constantOr(1) || 0 === a.constantOr(1))) return;
                const c = t1.context, h = c.gl, u = t1.transform, _ = t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly), d = e1.StencilMode.disabled, p = t1.colorModeForRenderPass(), m = "globe" === u.projection.name, f = [
                    e1.mercatorXfromLng(u.center.lng),
                    e1.mercatorYfromLat(u.center.lat)
                ], g = [];
                for(let n = 0; n < r.length; n++){
                    const s = r[n], a = i.getTile(s), c = a.getBucket(o);
                    if (!c || c.projection.name !== u.projection.name) continue;
                    const h = c.programConfigurations.get(o.id), _ = Vi(o);
                    m && _.push("PROJECTION_GLOBE_VIEW");
                    const d = t1.useProgram("circle", h, _), p = c.layoutVertexBuffer, v = c.globeExtVertexBuffer, x = c.indexBuffer, y = u.projection.createInversionMatrix(u, s.canonical), b = {
                        programConfiguration: h,
                        program: d,
                        layoutVertexBuffer: p,
                        globeExtVertexBuffer: v,
                        indexBuffer: x,
                        uniformValues: Zi(t1, s, a, y, f, o),
                        tile: a
                    };
                    if (l) {
                        const t1 = c.segments.get();
                        for (const i of t1)g.push({
                            segments: new e1.SegmentVector([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: b
                        });
                    } else g.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: b
                    });
                }
                l && g.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                const v = {
                    useDepthForOcclusion: !m
                };
                for (const i of g){
                    const { programConfiguration: r, program: n, layoutVertexBuffer: s, globeExtVertexBuffer: a, indexBuffer: l, uniformValues: m, tile: f } = i.state, g = i.segments;
                    t1.terrain && t1.terrain.setupElevationDraw(f, n, v), t1.prepareDrawProgram(c, n, f.tileID.toUnwrapped()), n.draw(c, h.TRIANGLES, _, d, p, e1.CullFaceMode.disabled, m, o.id, s, l, g, o.paint, u.zoom, r, [
                        a
                    ]);
                }
            },
            heatmap: function(t1, i, o, r) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === t1.renderPass) {
                        const n = t1.context, s = n.gl, a = e1.StencilMode.disabled, l = new e1.ColorMode([
                            s.ONE,
                            s.ONE
                        ], e1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(e1, t1, i, o) {
                            const r = e1.gl, n = t1.width * o, s = t1.height * o;
                            e1.activeTexture.set(r.TEXTURE1), e1.viewport.set([
                                0,
                                0,
                                n,
                                s
                            ]);
                            let a = i.heatmapFbo;
                            if (!a || a && (a.width !== n || a.height !== s)) {
                                a && a.destroy();
                                const t1 = r.createTexture();
                                r.bindTexture(r.TEXTURE_2D, t1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), a = i.heatmapFbo = e1.createFramebuffer(n, s, !1), function(e1, t1, i, o, r, n) {
                                    const s = e1.gl;
                                    s.texImage2D(s.TEXTURE_2D, 0, e1.isWebGL2 && e1.extRenderToTextureHalfFloat ? s.RGBA16F : s.RGBA, r, n, 0, s.RGBA, e1.extRenderToTextureHalfFloat ? e1.isWebGL2 ? s.HALF_FLOAT : e1.extTextureHalfFloat.HALF_FLOAT_OES : s.UNSIGNED_BYTE, null), o.colorAttachment.set(i);
                                }(e1, 0, t1, a, n, s);
                            } else r.bindTexture(r.TEXTURE_2D, a.colorAttachment.get()), e1.bindFramebuffer.set(a.framebuffer);
                        }(n, t1, o, "globe" === t1.transform.projection.name ? .5 : .25), n.clear({
                            color: e1.Color.transparent
                        });
                        const c = t1.transform, h = "globe" === c.projection.name, u = h ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : null, _ = h ? e1.CullFaceMode.frontCCW : e1.CullFaceMode.disabled, d = [
                            e1.mercatorXfromLng(c.center.lng),
                            e1.mercatorYfromLat(c.center.lat)
                        ];
                        for(let p = 0; p < r.length; p++){
                            const m = r[p];
                            if (i.hasRenderableParent(m)) continue;
                            const f = i.getTile(m), g = f.getBucket(o);
                            if (!g || g.projection.name !== c.projection.name) continue;
                            const v = g.programConfigurations.get(o.id), x = t1.useProgram("heatmap", v, u), { zoom: y } = t1.transform;
                            t1.terrain && t1.terrain.setupElevationDraw(f, x), t1.prepareDrawProgram(n, x, m.toUnwrapped());
                            const b = c.projection.createInversionMatrix(c, m.canonical);
                            x.draw(n, s.TRIANGLES, e1.DepthMode.disabled, a, l, _, $i(t1, m, f, b, d, y, o.paint.get("heatmap-intensity")), o.id, g.layoutVertexBuffer, g.indexBuffer, g.segments, o.paint, t1.transform.zoom, v, h ? [
                                g.globeExtVertexBuffer
                            ] : null);
                        }
                        n.viewport.set([
                            0,
                            0,
                            t1.width,
                            t1.height
                        ]);
                    } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, i) {
                        const o = t1.context, r = o.gl, n = i.heatmapFbo;
                        if (!n) return;
                        o.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, n.colorAttachment.get()), o.activeTexture.set(r.TEXTURE1);
                        let s = i.colorRampTexture;
                        s || (s = i.colorRampTexture = new e1.Texture(o, i.colorRamp, r.RGBA)), s.bind(r.LINEAR, r.CLAMP_TO_EDGE), t1.useProgram("heatmapTexture").draw(o, r.TRIANGLES, e1.DepthMode.disabled, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.disabled, ((e1, t1, i, o)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t1.paint.get("heatmap-opacity")
                            }))(0, i), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
                    }(t1, o));
                }
            },
            line: function(t1, i, o, r) {
                if ("translucent" !== t1.renderPass) return;
                const n = o.paint.get("line-opacity"), s = o.paint.get("line-width");
                if (0 === n.constantOr(1) || 0 === s.constantOr(1)) return;
                const a = t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly), l = t1.colorModeForRenderPass(), c = t1.terrain && t1.terrain.renderingToTexture ? 1 : e1.exported.devicePixelRatio, h = o.paint.get("line-dasharray"), u = h.constantOr(1), _ = o.layout.get("line-cap"), d = o.paint.get("line-pattern"), p = d.constantOr(1), m = o.paint.get("line-gradient"), f = p ? "linePattern" : "line", g = t1.context, v = g.gl, x = ((e1)=>{
                    const t1 = [];
                    Qi(e1) && t1.push("RENDER_LINE_DASH"), e1.paint.get("line-gradient") && t1.push("RENDER_LINE_GRADIENT");
                    const i = e1.paint.get("line-trim-offset");
                    0 === i[0] && 0 === i[1] || t1.push("RENDER_LINE_TRIM_OFFSET");
                    const o = e1.paint.get("line-pattern").constantOr(1), r = 1 !== e1.paint.get("line-opacity").constantOr(1);
                    return !o && r && t1.push("RENDER_LINE_ALPHA_DISCARD"), t1;
                })(o);
                let y = x.includes("RENDER_LINE_ALPHA_DISCARD");
                t1.terrain && t1.terrain.clipOrMaskOverlapStencilType() && (y = !1);
                for (const n of r){
                    const r = i.getTile(n);
                    if (p && !r.patternsLoaded()) continue;
                    const s = r.getBucket(o);
                    if (!s) continue;
                    t1.prepareDrawTile();
                    const b = s.programConfigurations.get(o.id), w = t1.useProgram(f, b, x), T = d.constantOr(null);
                    if (T && r.imageAtlas) {
                        const e1 = r.imageAtlas.patternPositions[T.toString()];
                        e1 && b.setConstantPatternPositions(e1);
                    }
                    const E = h.constantOr(null), C = _.constantOr(null);
                    if (!p && E && C && r.lineAtlas) {
                        const e1 = r.lineAtlas.getDash(E, C);
                        e1 && b.setConstantPatternPositions(e1);
                    }
                    let [M, I] = o.paint.get("line-trim-offset");
                    if ("round" === C || "square" === C) {
                        const e1 = 1;
                        M !== I && (0 === M && (M -= e1), 1 === I && (I += e1));
                    }
                    const S = t1.terrain ? n.projMatrix : null, D = p ? Yi(t1, r, o, S, c) : Hi(t1, r, o, S, s.lineClipsArray.length, c, [
                        M,
                        I
                    ]);
                    if (m) {
                        const r = s.gradients[o.id];
                        let a = r.texture;
                        if (o.gradientVersion !== r.version) {
                            let l = 256;
                            if (o.stepInterpolant) {
                                const o = i.getSource().maxzoom, r = n.canonical.z === o ? Math.ceil(1 << t1.transform.maxZoom - n.canonical.z) : 1;
                                l = e1.clamp(e1.nextPowerOfTwo(s.maxLineLength / e1.EXTENT * 1024 * r), 256, g.maxTextureSize);
                            }
                            r.gradient = e1.renderColorRamp({
                                expression: o.gradientExpression(),
                                evaluationKey: "lineProgress",
                                resolution: l,
                                image: r.gradient || void 0,
                                clips: s.lineClipsArray
                            }), r.texture ? r.texture.update(r.gradient) : r.texture = new e1.Texture(g, r.gradient, v.RGBA), r.version = o.gradientVersion, a = r.texture;
                        }
                        g.activeTexture.set(v.TEXTURE1), a.bind(o.stepInterpolant ? v.NEAREST : v.LINEAR, v.CLAMP_TO_EDGE);
                    }
                    u && (g.activeTexture.set(v.TEXTURE0), r.lineAtlasTexture.bind(v.LINEAR, v.REPEAT), b.updatePaintBuffers()), p && (g.activeTexture.set(v.TEXTURE0), r.imageAtlasTexture.bind(v.LINEAR, v.CLAMP_TO_EDGE), b.updatePaintBuffers()), t1.prepareDrawProgram(g, w, n.toUnwrapped());
                    const L = (i)=>{
                        w.draw(g, v.TRIANGLES, a, i, l, e1.CullFaceMode.disabled, D, o.id, s.layoutVertexBuffer, s.indexBuffer, s.segments, o.paint, t1.transform.zoom, b, [
                            s.layoutVertexBuffer2
                        ]);
                    };
                    if (y) {
                        const i = t1.stencilModeForClipping(n).ref;
                        0 === i && t1.terrain && g.clear({
                            stencil: 0
                        });
                        const o = {
                            func: v.EQUAL,
                            mask: 255
                        };
                        D.u_alpha_discard_threshold = .8, L(new e1.StencilMode(o, i, 255, v.KEEP, v.KEEP, v.INVERT)), D.u_alpha_discard_threshold = 0, L(new e1.StencilMode(o, i, 255, v.KEEP, v.KEEP, v.KEEP));
                    } else L(t1.stencilModeForClipping(n));
                }
                y && (t1.resetStencilClippingMasks(), t1.terrain && g.clear({
                    stencil: 0
                }));
            },
            fill: function(t1, i, o, r) {
                const n = o.paint.get("fill-color"), s = o.paint.get("fill-opacity");
                if (0 === s.constantOr(1)) return;
                const a = t1.colorModeForRenderPass(), l = o.paint.get("fill-pattern"), c = t1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === n.constantOr(e1.Color.transparent).a && 1 === s.constantOr(0) ? "opaque" : "translucent";
                if (t1.renderPass === c) {
                    const n = t1.depthModeForSublayer(1, "opaque" === t1.renderPass ? e1.DepthMode.ReadWrite : e1.DepthMode.ReadOnly);
                    vo(t1, i, o, r, n, a, !1);
                }
                if ("translucent" === t1.renderPass && o.paint.get("fill-antialias")) {
                    const n = t1.depthModeForSublayer(o.getPaintProperty("fill-outline-color") ? 2 : 0, e1.DepthMode.ReadOnly);
                    vo(t1, i, o, r, n, a, !0);
                }
            },
            "fill-extrusion": function(t1, i, o, r) {
                const n = o.paint.get("fill-extrusion-opacity");
                if (0 !== n && "translucent" === t1.renderPass) {
                    const s = new e1.DepthMode(t1.context.gl.LEQUAL, e1.DepthMode.ReadWrite, t1.depthRangeFor3D);
                    if (1 !== n || o.paint.get("fill-extrusion-pattern").constantOr(1)) xo(t1, i, o, r, s, e1.StencilMode.disabled, e1.ColorMode.disabled), xo(t1, i, o, r, s, t1.stencilModeFor3D(), t1.colorModeForRenderPass()), t1.resetStencilClippingMasks();
                    else {
                        const n = t1.colorModeForRenderPass();
                        xo(t1, i, o, r, s, e1.StencilMode.disabled, n);
                    }
                }
            },
            hillshade: function(t1, i, o, r) {
                if ("offscreen" !== t1.renderPass && "translucent" !== t1.renderPass) return;
                const n = t1.context, s = t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly), a = t1.colorModeForRenderPass(), l = t1.terrain && t1.terrain.renderingToTexture, [c, h] = "translucent" !== t1.renderPass || l ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r);
                for (const r of h){
                    const n = i.getTile(r);
                    if (n.needsHillshadePrepare && "offscreen" === t1.renderPass) vi(t1, n, o, s, e1.StencilMode.disabled, a);
                    else if ("translucent" === t1.renderPass) {
                        const e1 = l && t1.terrain ? t1.terrain.stencilModeForRTTOverlap(r) : c[r.overscaledZ];
                        fi(t1, r, n, o, s, e1, a);
                    }
                }
                n.viewport.set([
                    0,
                    0,
                    t1.width,
                    t1.height
                ]), t1.resetStencilClippingMasks();
            },
            raster: function(t1, i, o, r, n, s) {
                if ("translucent" !== t1.renderPass) return;
                if (0 === o.paint.get("raster-opacity")) return;
                if (!r.length) return;
                const a = t1.context, l = a.gl, c = i.getSource(), h = t1.useProgram("raster"), u = t1.colorModeForRenderPass(), _ = t1.terrain && t1.terrain.renderingToTexture, [d, p] = c instanceof Ae || _ ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r), m = p[p.length - 1].overscaledZ, f = !t1.options.moving;
                for (const r of p){
                    const n = _ ? e1.DepthMode.disabled : t1.depthModeForSublayer(r.overscaledZ - m, 1 === o.paint.get("raster-opacity") ? e1.DepthMode.ReadWrite : e1.DepthMode.ReadOnly, l.LESS), p = r.toUnwrapped(), g = i.getTile(r);
                    if (_ && (!g || !g.hasData())) continue;
                    const v = _ ? r.projMatrix : t1.transform.calculateProjMatrix(p, f), x = t1.terrain && _ ? t1.terrain.stencilModeForRTTOverlap(r) : d[r.overscaledZ], y = s ? 0 : o.paint.get("raster-fade-duration");
                    g.registerFadeDuration(y);
                    const b = i.findLoadedParent(r, 0), w = Si(g, b, i, t1.transform, y);
                    let T, E;
                    t1.terrain && t1.terrain.prepareDrawTile();
                    const C = "nearest" === o.paint.get("raster-resampling") ? l.NEAREST : l.LINEAR;
                    a.activeTexture.set(l.TEXTURE0), g.texture.bind(C, l.CLAMP_TO_EDGE), a.activeTexture.set(l.TEXTURE1), b ? (b.texture.bind(C, l.CLAMP_TO_EDGE), T = Math.pow(2, b.tileID.overscaledZ - g.tileID.overscaledZ), E = [
                        g.tileID.canonical.x * T % 1,
                        g.tileID.canonical.y * T % 1
                    ]) : g.texture.bind(C, l.CLAMP_TO_EDGE);
                    const M = eo(v, E || [
                        0,
                        0
                    ], T || 1, w, o, c instanceof Ae ? c.perspectiveTransform : [
                        0,
                        0
                    ]);
                    if (t1.prepareDrawProgram(a, h, p), c instanceof Ae) c.boundsBuffer && c.boundsSegments && h.draw(a, l.TRIANGLES, n, e1.StencilMode.disabled, u, e1.CullFaceMode.disabled, M, o.id, c.boundsBuffer, t1.quadTriangleIndexBuffer, c.boundsSegments);
                    else {
                        const { tileBoundsBuffer: i, tileBoundsIndexBuffer: r, tileBoundsSegments: s } = t1.getTileBoundsBuffers(g);
                        h.draw(a, l.TRIANGLES, n, x, u, e1.CullFaceMode.disabled, M, o.id, i, r, s);
                    }
                }
                t1.resetStencilClippingMasks();
            },
            background: function(t1, i, o, r) {
                const n = o.paint.get("background-color"), s = o.paint.get("background-opacity");
                if (0 === s) return;
                const a = t1.context, l = a.gl, c = t1.transform, h = c.tileSize, u = o.paint.get("background-pattern");
                if (t1.isPatternMissing(u)) return;
                const _ = !u && 1 === n.a && 1 === s && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== _) return;
                const d = e1.StencilMode.disabled, p = t1.depthModeForSublayer(0, "opaque" === _ ? e1.DepthMode.ReadWrite : e1.DepthMode.ReadOnly), m = t1.colorModeForRenderPass(), f = t1.useProgram(u ? "backgroundPattern" : "background");
                let g, v = r;
                v || (g = t1.getBackgroundTiles(), v = Object.values(g).map((e1)=>e1.tileID)), u && (a.activeTexture.set(l.TEXTURE0), t1.imageManager.bind(t1.context));
                for (const _ of v){
                    const v = _.toUnwrapped(), x = r ? _.projMatrix : t1.transform.calculateProjMatrix(v);
                    t1.prepareDrawTile();
                    const y = i ? i.getTile(_) : g ? g[_.key] : new e1.Tile(_, h, c.zoom, t1), b = u ? ao(x, s, t1, u, {
                        tileID: _,
                        tileSize: h
                    }) : so(x, s, n);
                    t1.prepareDrawProgram(a, f, v);
                    const { tileBoundsBuffer: w, tileBoundsIndexBuffer: T, tileBoundsSegments: E } = t1.getTileBoundsBuffers(y);
                    f.draw(a, l.TRIANGLES, p, d, m, e1.CullFaceMode.disabled, b, o.id, w, T, E);
                }
            },
            sky: function(t1, i, o) {
                const r = t1.transform, n = "mercator" === r.projection.name || "globe" === r.projection.name ? 1 : e1.smoothstep(7, 8, r.zoom), s = o.paint.get("sky-opacity") * n;
                if (0 === s) return;
                const a = t1.context, l = o.paint.get("sky-type"), c = new e1.DepthMode(a.gl.LEQUAL, e1.DepthMode.ReadOnly, [
                    0,
                    1
                ]), h = t1.frameCounter / 1e3 % 1;
                "atmosphere" === l ? "offscreen" === t1.renderPass ? o.needsSkyboxCapture(t1) && (function(t1, i, o, r) {
                    const n = t1.context, s = n.gl;
                    let a = i.skyboxFbo;
                    if (!a) {
                        a = i.skyboxFbo = n.createFramebuffer(32, 32, !1), i.skyboxGeometry = new Po(n), i.skyboxTexture = n.gl.createTexture(), s.bindTexture(s.TEXTURE_CUBE_MAP, i.skyboxTexture), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_MAG_FILTER, s.LINEAR);
                        for(let e1 = 0; e1 < 6; ++e1)s.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + e1, 0, s.RGBA, 32, 32, 0, s.RGBA, s.UNSIGNED_BYTE, null);
                    }
                    n.bindFramebuffer.set(a.framebuffer), n.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const l = i.getCenter(t1, !0), c = t1.useProgram("skyboxCapture"), h = new Float64Array(16);
                    e1.identity(h), e1.rotateY(h, h, .5 * -Math.PI), Ro(n, i, c, h, l, 0), e1.identity(h), e1.rotateY(h, h, .5 * Math.PI), Ro(n, i, c, h, l, 1), e1.identity(h), e1.rotateX(h, h, .5 * -Math.PI), Ro(n, i, c, h, l, 2), e1.identity(h), e1.rotateX(h, h, .5 * Math.PI), Ro(n, i, c, h, l, 3), e1.identity(h), Ro(n, i, c, h, l, 4), e1.identity(h), e1.rotateY(h, h, Math.PI), Ro(n, i, c, h, l, 5), n.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }(t1, o), o.markSkyboxValid(t1)) : "sky" === t1.renderPass && function(t1, i, o, r, n) {
                    const s = t1.context, a = s.gl, l = t1.transform, c = t1.useProgram("skybox");
                    s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_CUBE_MAP, i.skyboxTexture);
                    const h = ((e1, t1, i, o, r)=>({
                            u_matrix: e1,
                            u_sun_direction: t1,
                            u_cubemap: 0,
                            u_opacity: o,
                            u_temporal_offset: r
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), 0, r, n);
                    t1.prepareDrawProgram(s, c), c.draw(s, a.TRIANGLES, o, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.backCW, h, "skybox", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, o, c, s, h) : "gradient" === l && "sky" === t1.renderPass && function(t1, i, o, r, n) {
                    const s = t1.context, a = s.gl, l = t1.transform, c = t1.useProgram("skyboxGradient");
                    i.skyboxGeometry || (i.skyboxGeometry = new Po(s)), s.activeTexture.set(a.TEXTURE0);
                    let h = i.colorRampTexture;
                    h || (h = i.colorRampTexture = new e1.Texture(s, i.colorRamp, a.RGBA)), h.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                    const u = ((t1, i, o, r, n)=>({
                            u_matrix: t1,
                            u_color_ramp: 0,
                            u_center_direction: i,
                            u_radius: e1.degToRad(o),
                            u_opacity: r,
                            u_temporal_offset: n
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), i.paint.get("sky-gradient-radius"), r, n);
                    t1.prepareDrawProgram(s, c), c.draw(s, a.TRIANGLES, o, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.backCW, u, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, o, c, s, h);
            },
            debug: function(e1, t1, i) {
                for(let o = 0; o < i.length; o++)Mo(e1, t1, i[o]);
            },
            custom: function(t1, i, o, r) {
                const n = t1.context, s = o.implementation;
                if (!t1.transform.projection.unsupportedLayers || !t1.transform.projection.unsupportedLayers.includes("custom") || t1.terrain && (t1.terrain.renderingToTexture || "offscreen" === t1.renderPass) && o.isLayerDraped()) {
                    if ("offscreen" === t1.renderPass) {
                        const i = s.prerender;
                        if (i) {
                            if (t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), "globe" === t1.transform.projection.name) {
                                const o = t1.transform.pointMerc;
                                i.call(s, n.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e1.globeToMercatorTransition(t1.transform.zoom), [
                                    o.x,
                                    o.y
                                ], t1.transform.pixelsPerMeterRatio);
                            } else i.call(s, n.gl, t1.transform.customLayerMatrix());
                            n.setDirty(), t1.setBaseState();
                        }
                    } else if ("translucent" === t1.renderPass) {
                        if (t1.terrain && t1.terrain.renderingToTexture) {
                            const i = s.renderToTile;
                            if (i) {
                                const o = r[0].canonical, a = new e1.MercatorCoordinate(o.x + r[0].wrap * (1 << o.z), o.y, o.z);
                                n.setDepthMode(e1.DepthMode.disabled), n.setStencilMode(e1.StencilMode.disabled), n.setColorMode(t1.colorModeForRenderPass()), t1.setCustomLayerDefaults(), i.call(s, n.gl, a), n.setDirty(), t1.setBaseState();
                            }
                            return;
                        }
                        t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), n.setStencilMode(e1.StencilMode.disabled);
                        const i = "3d" === s.renderingMode ? new e1.DepthMode(t1.context.gl.LEQUAL, e1.DepthMode.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly);
                        if (n.setDepthMode(i), "globe" === t1.transform.projection.name) {
                            const i = t1.transform.pointMerc;
                            s.render(n.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e1.globeToMercatorTransition(t1.transform.zoom), [
                                i.x,
                                i.y
                            ], t1.transform.pixelsPerMeterRatio);
                        } else s.render(n.gl, t1.transform.customLayerMatrix());
                        n.setDirty(), t1.setBaseState(), n.bindFramebuffer.set(null);
                    }
                } else e1.warnOnce("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
            }
        };
        class Fo {
            constructor(t1, i, o = !1){
                this.context = new Me(t1, o), this.transform = i, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.setup(), this.numSublayers = e1.SourceCache.maxUnderzooming + e1.SourceCache.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new qt, this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {};
            }
            updateTerrain(e1, t1) {
                const i = !!e1 && !!e1.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new zi(this, e1));
                const o = this._terrain;
                this.transform.elevation = i ? o : null, o.update(e1, this.transform, t1);
            }
            _updateFog(e1) {
                const t1 = e1.fog;
                if (!t1 || "globe" === this.transform.projection.name || t1.getOpacity(this.transform.pitch) < 1 || t1.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, o] = t1.getFovAdjustedRange(this.transform._fov);
                if (i > o) return void (this.transform.fogCullDistSq = null);
                const r = i + .78 * (o - i);
                this.transform.fogCullDistSq = r * r;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled ? this._terrain : null;
            }
            resize(t1, i) {
                if (this.width = t1 * e1.exported.devicePixelRatio, this.height = i * e1.exported.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e1 of this.style.order)this.style._layers[e1].resize();
            }
            setup() {
                const t1 = this.context, i = new e1.StructArrayLayout2i4;
                i.emplaceBack(0, 0), i.emplaceBack(e1.EXTENT, 0), i.emplaceBack(0, e1.EXTENT), i.emplaceBack(e1.EXTENT, e1.EXTENT), this.tileExtentBuffer = t1.createVertexBuffer(i, e1.posAttributes.members), this.tileExtentSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const o = new e1.StructArrayLayout2i4;
                o.emplaceBack(0, 0), o.emplaceBack(e1.EXTENT, 0), o.emplaceBack(0, e1.EXTENT), o.emplaceBack(e1.EXTENT, e1.EXTENT), this.debugBuffer = t1.createVertexBuffer(o, e1.posAttributes.members), this.debugSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 5);
                const r = new e1.StructArrayLayout2i4;
                r.emplaceBack(-1, -1), r.emplaceBack(1, -1), r.emplaceBack(-1, 1), r.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(r, e1.posAttributes.members), this.viewportSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const n = new e1.StructArrayLayout4i8;
                n.emplaceBack(0, 0, 0, 0), n.emplaceBack(e1.EXTENT, 0, e1.EXTENT, 0), n.emplaceBack(0, e1.EXTENT, 0, e1.EXTENT), n.emplaceBack(e1.EXTENT, e1.EXTENT, e1.EXTENT, e1.EXTENT), this.mercatorBoundsBuffer = t1.createVertexBuffer(n, e1.boundsAttributes.members), this.mercatorBoundsSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const s = new e1.StructArrayLayout3ui6;
                s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(s);
                const a = new e1.StructArrayLayout1ui2;
                for (const e1 of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])a.emplaceBack(e1);
                this.debugIndexBuffer = t1.createIndexBuffer(a), this.emptyTexture = new e1.Texture(t1, new e1.RGBAImage({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), t1.gl.RGBA), this.identityMat = e1.create();
                const l = this.context.gl;
                this.stencilClearMode = new e1.StencilMode({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(e1.window.performance.now()), this.atmosphereBuffer = new Bo(this.context);
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e1) {
                return e1._makeTileBoundsBuffers(this.context, this.transform.projection), e1._tileBoundsBuffer ? {
                    tileBoundsBuffer: e1._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e1._tileBoundsIndexBuffer,
                    tileBoundsSegments: e1._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const t1 = this.context, i = t1.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.useProgram("clippingMask").draw(t1, i.TRIANGLES, e1.DepthMode.disabled, this.stencilClearMode, e1.ColorMode.disabled, e1.CullFaceMode.disabled, Ii(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(t1, i, o) {
                if (!i || this.currentStencilSource === i.id || !t1.isTileClipped() || !o || 0 === o.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e1 = !1;
                    for (const t1 of o)if (void 0 === this._tileClippingMaskIDs[t1.key]) {
                        e1 = !0;
                        break;
                    }
                    if (!e1) return;
                }
                this.currentStencilSource = i.id;
                const r = this.context, n = r.gl;
                this.nextStencilID + o.length > 256 && this.clearStencil(), r.setColorMode(e1.ColorMode.disabled), r.setDepthMode(e1.DepthMode.disabled);
                const s = this.useProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const t1 of o){
                    const o = i.getTile(t1), a = this._tileClippingMaskIDs[t1.key] = this.nextStencilID++, { tileBoundsBuffer: l, tileBoundsIndexBuffer: c, tileBoundsSegments: h } = this.getTileBoundsBuffers(o);
                    s.draw(r, n.TRIANGLES, e1.DepthMode.disabled, new e1.StencilMode({
                        func: n.ALWAYS,
                        mask: 0
                    }, a, 255, n.KEEP, n.KEEP, n.REPLACE), e1.ColorMode.disabled, e1.CullFaceMode.disabled, Ii(t1.projMatrix), "$clipping", l, c, h);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const t1 = this.nextStencilID++, i = this.context.gl;
                return new e1.StencilMode({
                    func: i.NOTEQUAL,
                    mask: 255
                }, t1, 255, i.KEEP, i.KEEP, i.REPLACE);
            }
            stencilModeForClipping(t1) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(t1);
                const i = this.context.gl;
                return new e1.StencilMode({
                    func: i.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[t1.key], 0, i.KEEP, i.KEEP, i.REPLACE);
            }
            stencilConfigForOverlap(t1) {
                const i = this.context.gl, o = t1.sort((e1, t1)=>t1.overscaledZ - e1.overscaledZ), r = o[o.length - 1].overscaledZ, n = o[0].overscaledZ - r + 1;
                if (n > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + n > 256 && this.clearStencil();
                    const t1 = {};
                    for(let o = 0; o < n; o++)t1[o + r] = new e1.StencilMode({
                        func: i.GEQUAL,
                        mask: 255
                    }, o + this.nextStencilID, 255, i.KEEP, i.KEEP, i.REPLACE);
                    return this.nextStencilID += n, [
                        t1,
                        o
                    ];
                }
                return [
                    {
                        [r]: e1.StencilMode.disabled
                    },
                    o
                ];
            }
            colorModeForRenderPass() {
                const t1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new e1.ColorMode([
                        t1.CONSTANT_COLOR,
                        t1.ONE
                    ], new e1.Color(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? e1.ColorMode.unblended : e1.ColorMode.alphaBlended;
            }
            depthModeForSublayer(t1, i, o) {
                if (!this.opaquePassEnabledForLayer()) return e1.DepthMode.disabled;
                const r = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
                return new e1.DepthMode(o || this.context.gl.LEQUAL, i, [
                    r,
                    r
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(t1, i) {
                this.style = t1, this.options = i, this.imageManager = t1.imageManager, this.glyphManager = t1.glyphManager, this.symbolFadeChange = t1.placement.symbolFadeChange(e1.exported.now()), this.imageManager.beginFrame();
                const o = this.style.order, r = this.style._sourceCaches;
                for(const e1 in r){
                    const t1 = r[e1];
                    t1.used && t1.prepare(this.context);
                }
                const n = {}, s = {}, a = {};
                for(const e1 in r){
                    const t1 = r[e1];
                    n[e1] = t1.getVisibleCoordinates(), s[e1] = n[e1].slice().reverse(), a[e1] = t1.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let e1 = 0; e1 < o.length; e1++)if (this.style._layers[o[e1]].is3D()) {
                    this.opaquePassCutoff = e1;
                    break;
                }
                if (this.terrain && (this.terrain.updateTileBinding(a), this.opaquePassCutoff = 0), "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e1.GlobeSharedBuffers(this.context)), e1.isMapAuthenticated(this.context.gl)) {
                    this.renderPass = "offscreen";
                    for (const e1 of o){
                        const i = this.style._layers[e1], o = t1._getLayerSourceCache(i);
                        if (!i.hasOffscreenPass() || i.isHidden(this.transform.zoom)) continue;
                        const r = o ? s[o.id] : void 0;
                        ("custom" === i.type || i.isSky() || r && r.length) && this.renderLayer(this, o, i, r);
                    }
                    if (this.depthRangeFor3D = [
                        0,
                        1 - (t1.order.length + 2) * this.numSublayers * this.depthEpsilon
                    ], this.terrain && (this.style.hasSymbolLayers() || this.style.hasCircleLayers()) && this.terrain.drawDepth(), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                        0,
                        0,
                        this.width,
                        this.height
                    ]), this.context.clear({
                        color: i.showOverdrawInspector ? e1.Color.black : e1.Color.transparent,
                        depth: 1
                    }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", !this.terrain) for(this.currentLayer = o.length - 1; this.currentLayer >= 0; this.currentLayer--){
                        const e1 = this.style._layers[o[this.currentLayer]], i = t1._getLayerSourceCache(e1);
                        if (e1.isSky()) continue;
                        const r = i ? s[i.id] : void 0;
                        this._renderTileClippingMasks(e1, i, r), this.renderLayer(this, i, e1, r);
                    }
                    if (this.style.fog && this.transform.projection.supportsFog && function(t1, i) {
                        const o = t1.context, r = o.gl, n = t1.transform, s = new e1.DepthMode(r.LEQUAL, e1.DepthMode.ReadOnly, [
                            0,
                            1
                        ]), a = t1.useProgram("globeAtmosphere", null, "globe" === n.projection.name ? [
                            "PROJECTION_GLOBE_VIEW",
                            "FOG"
                        ] : [
                            "FOG"
                        ]), l = e1.globeToMercatorTransition(n.zoom), c = i.properties.get("color").toArray01(), h = i.properties.get("high-color").toArray01(), u = i.properties.get("space-color").toArray01PremultipliedAlpha(), _ = e1.identity$1([]);
                        e1.rotateY$1(_, _, -e1.degToRad(n._center.lng)), e1.rotateX$1(_, _, e1.degToRad(n._center.lat)), e1.rotateZ$1(_, _, n.angle), e1.rotateX$1(_, _, -n._pitch);
                        const d = e1.fromQuat(new Float32Array(16), _), p = e1.mapValue(i.properties.get("star-intensity"), 0, 1, 0, .25), m = 5e-4, f = e1.mapValue(i.properties.get("horizon-blend"), 0, 1, m, .25), g = e1.globeUseCustomAntiAliasing(t1, o, n) && f === m ? n.worldSize / (2 * Math.PI * 1.025) - 1 : n.globeRadius, v = t1.frameCounter / 1e3 % 1, x = e1.length(n.globeCenterInViewSpace), y = Math.sqrt(Math.pow(x, 2) - Math.pow(g, 2)), b = Math.acos(y / x), w = ((t1, i, o, r, n, s, a, l, c, h, u, _, d, p)=>({
                                u_frustum_tl: t1,
                                u_frustum_tr: i,
                                u_frustum_br: o,
                                u_frustum_bl: r,
                                u_horizon: n,
                                u_transition: s,
                                u_fadeout_range: a,
                                u_color: l,
                                u_high_color: c,
                                u_space_color: h,
                                u_star_intensity: u,
                                u_star_size: 5 * e1.exported.devicePixelRatio,
                                u_star_density: 0,
                                u_temporal_offset: _,
                                u_horizon_angle: d,
                                u_rotation_matrix: p
                            }))(n.frustumCorners.TL, n.frustumCorners.TR, n.frustumCorners.BR, n.frustumCorners.BL, n.frustumCorners.horizon, l, f, c, h, u, p, v, b, d);
                        t1.prepareDrawProgram(o, a);
                        const T = t1.atmosphereBuffer;
                        T && a.draw(o, r.TRIANGLES, s, e1.StencilMode.disabled, e1.ColorMode.alphaBlended, e1.CullFaceMode.backCW, w, "skybox", T.vertexBuffer, T.indexBuffer, T.segments);
                    }(this, this.style.fog), this.renderPass = "sky", (e1.globeToMercatorTransition(this.transform.zoom) > 0 || "globe" !== this.transform.projection.name) && this.transform.isHorizonVisible()) for(this.currentLayer = 0; this.currentLayer < o.length; this.currentLayer++){
                        const e1 = this.style._layers[o[this.currentLayer]], i = t1._getLayerSourceCache(e1);
                        e1.isSky() && this.renderLayer(this, i, e1, i ? s[i.id] : void 0);
                    }
                    for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < o.length;){
                        const e1 = this.style._layers[o[this.currentLayer]], i = t1._getLayerSourceCache(e1);
                        if (e1.isSky()) {
                            ++this.currentLayer;
                            continue;
                        }
                        if (this.terrain && this.style.isLayerDraped(e1)) {
                            if (e1.isHidden(this.transform.zoom)) {
                                ++this.currentLayer;
                                continue;
                            }
                            this.currentLayer = this.terrain.renderBatch(this.currentLayer);
                            continue;
                        }
                        const r = i ? ("symbol" === e1.type ? a : s)[i.id] : void 0;
                        this._renderTileClippingMasks(e1, i, i ? n[i.id] : void 0), this.renderLayer(this, i, e1, r), ++this.currentLayer;
                    }
                    if (this.terrain && this.terrain.postRender(), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                        let i = null;
                        e1.values(this.style._layers).forEach((e1)=>{
                            const o = t1._getLayerSourceCache(e1);
                            o && !e1.isHidden(this.transform.zoom) && (!i || i.getSource().maxzoom < o.getSource().maxzoom) && (i = o);
                        }), i && this.options.showTileBoundaries && ko.debug(this, i, i.getVisibleCoordinates());
                    }
                    this.options.showPadding && function(e1) {
                        const t1 = e1.transform.padding;
                        Io(e1, e1.transform.height - (t1.top || 0), 3, bo), Io(e1, t1.bottom || 0, 3, wo), So(e1, t1.left || 0, 3, To), So(e1, e1.transform.width - (t1.right || 0), 3, Eo);
                        const i = e1.transform.centerPoint;
                        !function(e1, t1, i, o) {
                            Do(e1, t1 - 1, i - 10, 2, 20, o), Do(e1, t1 - 10, i - 1, 20, 2, o);
                        }(e1, i.x, e1.transform.height - i.y, Co);
                    }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(e1.window.performance.now()), this.saveCanvasCopy());
                }
            }
            renderLayer(e1, t1, i, o) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || o && o.length) && (this.id = i.id, this.gpuTimingStart(i), (!e1.transform.projection.unsupportedLayers || !e1.transform.projection.unsupportedLayers.includes(i.type) || e1.terrain && "custom" === i.type) && ko[i.type](e1, t1, i, o, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e1) {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery;
                let i = this.gpuTimers[e1.id];
                i || (i = this.gpuTimers[e1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: t1.createQueryEXT()
                }), i.calls++, t1.beginQueryEXT(t1.TIME_ELAPSED_EXT, i.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e1 = this.context.extTimerQuery, t1 = e1.createQueryEXT();
                    this.deferredRenderGpuTimeQueries.push(t1), e1.beginQueryEXT(e1.TIME_ELAPSED_EXT, t1);
                }
            }
            gpuTimingDeferredRenderEnd() {
                if (!this.options.gpuTimingDeferredRender) return;
                const e1 = this.context.extTimerQuery;
                e1.endQueryEXT(e1.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                if (!this.options.gpuTiming) return;
                const e1 = this.context.extTimerQuery;
                e1.endQueryEXT(e1.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e1 = this.gpuTimers;
                return this.gpuTimers = {}, e1;
            }
            collectDeferredRenderGpuQueries() {
                const e1 = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e1;
            }
            queryGpuTimers(e1) {
                const t1 = {};
                for(const i in e1){
                    const o = e1[i], r = this.context.extTimerQuery, n = r.getQueryObjectEXT(o.query, r.QUERY_RESULT_EXT) / 1e6;
                    r.deleteQueryEXT(o.query), t1[i] = n;
                }
                return t1;
            }
            queryGpuTimeDeferredRender(e1) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t1 = this.context.extTimerQuery;
                let i = 0;
                for (const o of e1)i += t1.getQueryObjectEXT(o, t1.QUERY_RESULT_EXT) / 1e6, t1.deleteQueryEXT(o);
                return i;
            }
            translatePosMatrix(t1, i, o, r, n) {
                if (!o[0] && !o[1]) return t1;
                const s = n ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
                if (s) {
                    const e1 = Math.sin(s), t1 = Math.cos(s);
                    o = [
                        o[0] * t1 - o[1] * e1,
                        o[0] * e1 + o[1] * t1
                    ];
                }
                const a = [
                    n ? o[0] : P(i, o[0], this.transform.zoom),
                    n ? o[1] : P(i, o[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e1.translate(l, t1, a), l;
            }
            saveTileTexture(e1) {
                const t1 = this._tileTextures[e1.size[0]];
                t1 ? t1.push(e1) : this._tileTextures[e1.size[0]] = [
                    e1
                ];
            }
            getTileTexture(e1) {
                const t1 = this._tileTextures[e1];
                return t1 && t1.length > 0 ? t1.pop() : null;
            }
            isPatternMissing(e1) {
                return null === e1 || void 0 !== e1 && !this.imageManager.getPattern(e1.toString());
            }
            terrainRenderModeElevated() {
                return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture;
            }
            currentGlobalDefines() {
                const e1 = this.terrain && this.terrain.renderingToTexture, t1 = this.terrain && 0 === this.terrain.exaggeration(), i = this.style && this.style.fog, o = [];
                return this.terrainRenderModeElevated() && o.push("TERRAIN"), "globe" === this.transform.projection.name && o.push("GLOBE"), t1 && o.push("ZERO_EXAGGERATION"), i && !e1 && 0 !== i.getOpacity(this.transform.pitch) && o.push("FOG"), e1 && o.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && o.push("OVERDRAW_INSPECTOR"), o;
            }
            useProgram(e1, t1, i) {
                this.cache = this.cache || {};
                const o = i || [], r = this.currentGlobalDefines().concat(o), n = Pi.cacheKey(ui[e1], e1, r, t1);
                return this.cache[n] || (this.cache[n] = new Pi(this.context, e1, ui[e1], t1, lo[e1], r)), this.cache[n];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = e1.window.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e1.Texture(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.atmosphereBuffer && this.atmosphereBuffer.destroy();
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            prepareDrawProgram(t1, i, o) {
                if (this.terrain && this.terrain.renderingToTexture) return;
                const r = this.style.fog;
                if (r) {
                    const n = r.getOpacity(this.transform.pitch), s = ((t1, i, o, r, n, s, a, l, c, h, u)=>{
                        const _ = t1.transform, d = i.properties.get("color").toArray01();
                        d[3] = r;
                        const p = t1.frameCounter / 1e3 % 1;
                        return {
                            u_fog_matrix: o ? _.calculateFogTileMatrix(o) : t1.identityMat,
                            u_fog_range: i.getFovAdjustedRange(_._fov),
                            u_fog_color: d,
                            u_fog_horizon_blend: i.properties.get("horizon-blend"),
                            u_fog_temporal_offset: p,
                            u_frustum_tl: n,
                            u_frustum_tr: s,
                            u_frustum_br: a,
                            u_frustum_bl: l,
                            u_globe_pos: c,
                            u_globe_radius: h,
                            u_viewport: u,
                            u_globe_transition: e1.globeToMercatorTransition(_.zoom),
                            u_is_globe: +("globe" === _.projection.name)
                        };
                    })(this, r, o, n, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * e1.exported.devicePixelRatio,
                        this.transform.height * e1.exported.devicePixelRatio
                    ]);
                    i.setFogUniformValues(t1, s);
                }
            }
            setTileLoadedFlag(e1) {
                this.tileLoaded = e1;
            }
            saveCanvasCopy() {
                const e1 = this.canvasCopy();
                e1 && (this.frameCopies.push(e1), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e1 = this.context.gl, t1 = e1.createTexture();
                return e1.bindTexture(e1.TEXTURE_2D, t1), e1.copyTexImage2D(e1.TEXTURE_2D, 0, e1.RGBA, 0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight, 0), t1;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e1 = this.style && this.style.fog;
                return !!e1 && 0 !== e1.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const t1 = this._backgroundTiles, i = this._backgroundTiles = {}, o = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const r of o)i[r.key] = t1[r.key] || new e1.Tile(r, 512, this.transform.tileZoom, this);
                return i;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
        }
        class Uo {
            constructor(e1 = 0, t1 = 0, i = 0, o = 0){
                if (isNaN(e1) || e1 < 0 || isNaN(t1) || t1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e1, this.bottom = t1, this.left = i, this.right = o;
            }
            interpolate(t1, i, o) {
                return null != i.top && null != t1.top && (this.top = e1.number(t1.top, i.top, o)), null != i.bottom && null != t1.bottom && (this.bottom = e1.number(t1.bottom, i.bottom, o)), null != i.left && null != t1.left && (this.left = e1.number(t1.left, i.left, o)), null != i.right && null != t1.right && (this.right = e1.number(t1.right, i.right, o)), this;
            }
            getCenter(t1, i) {
                const o = e1.clamp((this.left + t1 - this.right) / 2, 0, t1), r = e1.clamp((this.top + i - this.bottom) / 2, 0, i);
                return new e1.pointGeometry(o, r);
            }
            equals(e1) {
                return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
            }
            clone() {
                return new Uo(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        function No(t1, i) {
            const o = e1.getColumn(t1, 3);
            e1.fromQuat(t1, i), e1.setColumn(t1, 3, o);
        }
        function Go(t1, i) {
            const o = e1.identity$1([]);
            return e1.rotateZ$1(o, o, -i), e1.rotateX$1(o, o, -t1), o;
        }
        function jo(t1, i) {
            const o = [
                t1[0],
                t1[1],
                0
            ], r = [
                i[0],
                i[1],
                0
            ];
            if (e1.length(o) >= 1e-15) {
                const t1 = e1.normalize([], o);
                e1.scale$2(r, t1, e1.dot(r, t1)), i[0] = r[0], i[1] = r[1];
            }
            const n = e1.cross([], i, t1);
            if (e1.len(n) < 1e-15) return null;
            const s = Math.atan2(-n[1], n[0]);
            return Go(Math.atan2(Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]), -t1[2]), s);
        }
        class Zo {
            constructor(e1, t1){
                this.position = e1, this.orientation = t1;
            }
            get position() {
                return this._position;
            }
            set position(t1) {
                if (t1) {
                    const i = t1 instanceof e1.MercatorCoordinate ? t1 : new e1.MercatorCoordinate(t1[0], t1[1], t1[2]);
                    this._renderWorldCopies && (i.x = e1.wrap(i.x, 0, 1)), this._position = i;
                } else this._position = null;
            }
            lookAtPoint(t1, i) {
                if (this.orientation = null, !this.position) return;
                const o = this._elevation ? this._elevation.getAtPointOrZero(e1.MercatorCoordinate.fromLngLat(t1)) : 0, r = this.position, n = e1.MercatorCoordinate.fromLngLat(t1, o), s = [
                    n.x - r.x,
                    n.y - r.y,
                    n.z - r.z
                ];
                i || (i = [
                    0,
                    0,
                    1
                ]), i[2] = Math.abs(i[2]), this.orientation = jo(s, i);
            }
            setPitchBearing(t1, i) {
                this.orientation = Go(e1.degToRad(t1), e1.degToRad(-i));
            }
        }
        class Vo {
            constructor(t1, i){
                this._transform = e1.identity([]), this.orientation = i, this.position = t1;
            }
            get mercatorPosition() {
                const t1 = this.position;
                return new e1.MercatorCoordinate(t1[0], t1[1], t1[2]);
            }
            get position() {
                const t1 = e1.getColumn(this._transform, 3);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            set position(t1) {
                var i;
                t1 && e1.setColumn(this._transform, 3, [
                    (i = t1)[0],
                    i[1],
                    i[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(t1) {
                this._orientation = t1 || e1.identity$1([]), t1 && No(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e1 = this.forward(), t1 = this.right();
                return {
                    bearing: Math.atan2(-t1[1], t1[0]),
                    pitch: Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2])
                };
            }
            setPitchBearing(e1, t1) {
                this._orientation = Go(e1, t1), No(this._transform, this._orientation);
            }
            forward() {
                const t1 = e1.getColumn(this._transform, 2);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            up() {
                const t1 = e1.getColumn(this._transform, 1);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            right() {
                const t1 = e1.getColumn(this._transform, 0);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            getCameraToWorld(t1, i) {
                const o = new Float64Array(16);
                return e1.invert(o, this.getWorldToCamera(t1, i)), o;
            }
            getWorldToCameraPosition(t1, i, o) {
                const r = this.position;
                e1.scale$2(r, r, -t1);
                const n = new Float64Array(16);
                return e1.fromScaling(n, [
                    o,
                    o,
                    o
                ]), e1.translate(n, n, r), n[10] *= i, n;
            }
            getWorldToCamera(t1, i) {
                const o = new Float64Array(16), r = new Float64Array(4), n = this.position;
                return e1.conjugate(r, this._orientation), e1.scale$2(n, n, -t1), e1.fromQuat(o, r), e1.translate(o, o, n), o[1] *= -1, o[5] *= -1, o[9] *= -1, o[13] *= -1, o[8] *= i, o[9] *= i, o[10] *= i, o[11] *= i, o;
            }
            getCameraToClipPerspective(t1, i, o, r) {
                const n = new Float64Array(16);
                return e1.perspective(n, t1, i, o, r), n;
            }
            getDistanceToElevation(t1, i = !1) {
                const o = 0 === t1 ? 0 : e1.mercatorZfromAltitude(t1, i ? e1.latFromMercatorY(this.position[1]) : this.position[1]), r = this.forward();
                return (o - this.position[2]) / r[2];
            }
            clone() {
                return new Vo([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
        }
        function Wo(t1, i) {
            const o = qo(t1.projection, t1.zoom, t1.width, t1.height), r = function(t1, i, o, r, n) {
                const s = new e1.LngLat(o.lng - 180 * $o, o.lat), a = new e1.LngLat(o.lng + 180 * $o, o.lat), l = t1.project(s.lng, s.lat), c = t1.project(a.lng, a.lat), h = -Math.atan2(c.y - l.y, c.x - l.x), u = e1.MercatorCoordinate.fromLngLat(o);
                u.y = e1.clamp(u.y, -0.999975, .999975);
                const _ = u.toLngLat(), d = t1.project(_.lng, _.lat), p = e1.MercatorCoordinate.fromLngLat(_);
                p.x += $o;
                const m = p.toLngLat(), f = t1.project(m.lng, m.lat), g = Yo(f.x - d.x, f.y - d.y, h), v = e1.MercatorCoordinate.fromLngLat(_);
                v.y += $o;
                const x = v.toLngLat(), y = t1.project(x.lng, x.lat), b = Yo(y.x - d.x, y.y - d.y, h), w = Math.abs(g.x) / Math.abs(b.y), T = e1.identity([]);
                e1.rotateZ(T, T, -h * (1 - (n ? 0 : r)));
                const E = e1.identity([]);
                return e1.scale(E, E, [
                    1,
                    1 - (1 - w) * r,
                    1
                ]), E[4] = -b.x / b.y * r, e1.rotateZ(E, E, h), e1.multiply(E, T, E), E;
            }(t1.projection, 0, t1.center, o, i), n = Xo(t1);
            return e1.scale(r, r, [
                n,
                n,
                1
            ]), r;
        }
        function Xo(t1) {
            const i = t1.projection, o = qo(t1.projection, t1.zoom, t1.width, t1.height), r = Ho(i, t1.center), n = Ho(i, e1.LngLat.convert(i.center));
            return Math.pow(2, r * o + (1 - o) * n);
        }
        function qo(t1, i, o, r, n = 1 / 0) {
            const s = t1.range;
            if (!s) return 0;
            const a = Math.min(n, Math.max(o, r)), l = Math.log(a / 1024) / Math.LN2;
            return e1.smoothstep(s[0] + l, s[1] + l, i);
        }
        const $o = 1 / 4e4;
        function Ho(t1, i) {
            const o = e1.clamp(i.lat, -e1.MAX_MERCATOR_LATITUDE, e1.MAX_MERCATOR_LATITUDE), r = new e1.LngLat(i.lng - 180 * $o, o), n = new e1.LngLat(i.lng + 180 * $o, o), s = t1.project(r.lng, o), a = t1.project(n.lng, o), l = e1.MercatorCoordinate.fromLngLat(r), c = e1.MercatorCoordinate.fromLngLat(n), h = a.x - s.x, u = a.y - s.y, _ = c.x - l.x, d = c.y - l.y, p = Math.sqrt((_ * _ + d * d) / (h * h + u * u));
            return Math.log(p) / Math.LN2;
        }
        function Yo(e1, t1, i) {
            const o = Math.cos(i), r = Math.sin(i);
            return {
                x: e1 * o - t1 * r,
                y: e1 * r + t1 * o
            };
        }
        class Ko {
            constructor(t1, i, o, r, n, s, a){
                this.tileSize = 512, this._renderWorldCopies = void 0 === n || n, this._minZoom = t1 || 0, this._maxZoom = i || 22, this._minPitch = null == o ? 0 : o, this._maxPitch = null == r ? 60 : r, this.setProjection(s), this.setMaxBounds(a), this.width = 0, this.height = 0, this._center = new e1.LngLat(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = !0, this._edgeInsets = new Uo, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Vo, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._horizonShift = .1;
            }
            clone() {
                const e1 = new Ko(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
                return e1._elevation = this._elevation, e1._centerAltitude = this._centerAltitude, e1._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e1.tileSize = this.tileSize, e1.mercatorFromTransition = this.mercatorFromTransition, e1.width = this.width, e1.height = this.height, e1.cameraElevationReference = this.cameraElevationReference, e1._center = this._center, e1._setZoom(this.zoom), e1._seaLevelZoom = this._seaLevelZoom, e1.angle = this.angle, e1._fov = this._fov, e1._pitch = this._pitch, e1._nearZ = this._nearZ, e1._farZ = this._farZ, e1._averageElevation = this._averageElevation, e1._unmodified = this._unmodified, e1._edgeInsets = this._edgeInsets.clone(), e1._camera = this._camera.clone(), e1._calcMatrices(), e1.freezeTileCoverage = this.freezeTileCoverage, e1.frustumCorners = this.frustumCorners, e1;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e1) {
                this._elevation !== e1 && (this._elevation = e1, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            updateElevation(e1, t1 = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e1 || i) && this._constrainCamera(t1), this._calcMatrices();
            }
            getProjection() {
                return e1.pick(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(i) {
                this.projectionOptions = i || {
                    name: "mercator"
                };
                const o = this.projection ? this.getProjection() : void 0;
                this.projection = e1.getProjection(this.projectionOptions);
                const r = !t1(o, this.getProjection());
                return r && this._calcMatrices(), this.mercatorFromTransition = !1, r;
            }
            setMercatorFromTransition() {
                const t1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = e1.getProjection({
                    name: "mercator"
                });
                const i = t1 !== this.projection.name;
                return i && this._calcMatrices(), i;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e1) {
                this._minZoom !== e1 && (this._minZoom = e1, this.zoom = Math.max(this.zoom, e1));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e1) {
                this._maxZoom !== e1 && (this._maxZoom = e1, this.zoom = Math.min(this.zoom, e1));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e1) {
                this._minPitch !== e1 && (this._minPitch = e1, this.pitch = Math.max(this.pitch, e1));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e1) {
                this._maxPitch !== e1 && (this._maxPitch = e1, this.pitch = Math.min(this.pitch, e1));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e1) {
                void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get cameraWorldSize() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return e1.mercatorZfromAltitude(this.center.lat, this.cameraWorldSizeForFog);
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new e1.pointGeometry(this.width, this.height);
            }
            get bearing() {
                return e1.wrap(this.rotation, -180, 180);
            }
            set bearing(e1) {
                this.rotation = e1;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(t1) {
                const i = -t1 * Math.PI / 180;
                var o;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = (o = new e1.ARRAY_TYPE(4), e1.ARRAY_TYPE != Float32Array && (o[1] = 0, o[2] = 0), o[0] = 1, o[3] = 1, o), function(e1, t1, i) {
                    var o = t1[0], r = t1[1], n = t1[2], s = t1[3], a = Math.sin(i), l = Math.cos(i);
                    e1[0] = o * l + n * a, e1[1] = r * l + s * a, e1[2] = o * -a + n * l, e1[3] = r * -a + s * l;
                }(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(t1) {
                const i = e1.clamp(t1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e1 = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e1);
            }
            set fov(t1) {
                t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = e1.degToRad(t1), this._calcMatrices());
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e1) {
                this._averageElevation = e1, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e1) {
                const t1 = Math.min(Math.max(e1, this.minZoom), this.maxZoom);
                this._zoom !== t1 && (this._unmodified = !1, this._setZoom(t1), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e1) {
                this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom;
            }
            _updateCameraOnTerrain() {
                if (!this._elevation || !this._elevation.isDataAvailableAtPoint(this.locationCoordinate(this.center))) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const e1 = this._elevation;
                this._centerAltitude = e1.getAtPointOrZero(this.locationCoordinate(this.center)), this._centerAltitudeValidForExaggeration = e1.exaggeration(), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                void 0 !== this._centerAltitudeValidForExaggeration && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const t1 = this._elevation, i = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], o = this.horizonLineFromTop();
                let r = 0, n = 0;
                for(let s = 0; s < i.length; s++){
                    const a = new e1.pointGeometry(i[s][0] * this.width, o + i[s][1] * (this.height - o)), l = t1.pointCoordinate(a);
                    if (!l) continue;
                    const c = 1 / Math.hypot(l[0] - this._camera.position[0], l[1] - this._camera.position[1]);
                    r += l[3] * c, n += c;
                }
                return 0 === n ? NaN : r / n;
            }
            get center() {
                return this._center;
            }
            set center(e1) {
                e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e1 = this._seaLevelZoom, t1 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t1, o = this._mercatorZfromZoom(e1), r = this._mercatorZfromZoom(this._maxZoom), n = Math.max(o - i, r);
                this._setZoom(this._zoomFromMercatorZ(n));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e1) {
                this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
            }
            computeZoomRelativeTo(t1) {
                const i = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t1.toAltitude()));
                let o;
                o = t1.z < this._camera.position[2] ? [
                    i.x,
                    i.y,
                    i.z
                ] : [
                    t1.x,
                    t1.y,
                    t1.z
                ];
                const r = e1.length(e1.sub([], this._camera.position, o));
                return e1.clamp(this._zoomFromMercatorZ(r), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(t1) {
                if (!this.height) return;
                if (!t1.position && !t1.orientation) return;
                this._updateCameraState();
                let i = !1;
                if (t1.orientation && !e1.exactEquals(t1.orientation, this._camera.orientation) && (i = this._setCameraOrientation(t1.orientation)), t1.position) {
                    const o = [
                        t1.position.x,
                        t1.position.y,
                        t1.position.z
                    ];
                    e1.exactEquals$1(o, this._camera.position) || (this._setCameraPosition(o), i = !0);
                }
                i && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const t1 = this._camera.position, i = new Zo;
                return i.position = new e1.MercatorCoordinate(t1[0], t1[1], t1[2]), i.orientation = this._camera.orientation, i._elevation = this.elevation, i._renderWorldCopies = this.renderWorldCopies, i;
            }
            _setCameraOrientation(t1) {
                if (!e1.length$1(t1)) return !1;
                e1.normalize$1(t1, t1);
                const i = e1.transformQuat([], [
                    0,
                    0,
                    -1
                ], t1), o = e1.transformQuat([], [
                    0,
                    -1,
                    0
                ], t1);
                if (o[2] < 0) return !1;
                const r = jo(i, o);
                return !!r && (this._camera.orientation = r, !0);
            }
            _setCameraPosition(t1) {
                const i = this.zoomScale(this.minZoom) * this.tileSize, o = this.zoomScale(this.maxZoom) * this.tileSize, r = this.cameraToCenterDistance;
                t1[2] = e1.clamp(t1[2], r / o, r / i), this._camera.position = t1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e1) {
                return this._edgeInsets.equals(e1);
            }
            interpolatePadding(e1, t1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e1, t1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e1) {
                const t1 = (e1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e1.tileSize));
                return Math.max(0, t1);
            }
            getVisibleUnwrappedCoordinates(t1) {
                const i = [
                    new e1.UnwrappedTileID(0, t1)
                ];
                if (this.renderWorldCopies) {
                    const o = this.pointCoordinate(new e1.pointGeometry(0, 0)), r = this.pointCoordinate(new e1.pointGeometry(this.width, 0)), n = this.pointCoordinate(new e1.pointGeometry(this.width, this.height)), s = this.pointCoordinate(new e1.pointGeometry(0, this.height)), a = Math.floor(Math.min(o.x, r.x, n.x, s.x)), l = Math.floor(Math.max(o.x, r.x, n.x, s.x)), c = 1;
                    for(let o = a - c; o <= l + c; o++)0 !== o && i.push(new e1.UnwrappedTileID(o, t1));
                }
                return i;
            }
            coveringTiles(t1) {
                let i = this.coveringZoomLevel(t1);
                const o = i, r = this.elevation && !t1.isTerrainDEM, n = "mercator" === this.projection.name;
                if (void 0 !== t1.minzoom && i < t1.minzoom) return [];
                void 0 !== t1.maxzoom && i > t1.maxzoom && (i = t1.maxzoom);
                const s = this.locationCoordinate(this.center), a = this.center.lat, l = 1 << i, c = [
                    l * s.x,
                    l * s.y,
                    0
                ], h = "globe" === this.projection.name, u = !h, _ = e1.Frustum.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i, u), d = h ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), p = l * e1.mercatorZfromAltitude(1, this.center.lat), m = this._camera.position[2] / e1.mercatorZfromAltitude(1, this.center.lat), f = [
                    l * d.x,
                    l * d.y,
                    m * (u ? 1 : p)
                ], g = this.cameraToCenterDistance / t1.tileSize * (t1.roundZoom ? 1 : .502), v = this.pitch <= 60 && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace ? i : 0, x = t1.isTerrainDEM && this._elevation ? 1e4 * this._elevation.exaggeration() : this._centerAltitude, y = t1.isTerrainDEM ? -x : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, b = this.projection.isReprojectedInTileSpace ? Xo(this) : 1, w = (t1)=>{
                    const i = 1 / 4e4, o = new e1.MercatorCoordinate(t1.x + i, t1.y, t1.z), r = new e1.MercatorCoordinate(t1.x, t1.y + i, t1.z), n = t1.toLngLat(), s = o.toLngLat(), a = r.toLngLat(), l = this.locationCoordinate(n), c = this.locationCoordinate(s), h = this.locationCoordinate(a), u = Math.hypot(c.x - l.x, c.y - l.y), _ = Math.hypot(h.x - l.x, h.y - l.y);
                    return Math.sqrt(u * _) * b / i;
                }, T = (t1)=>{
                    const i = x, o = y;
                    return {
                        aabb: e1.tileAABB(this, l, 0, 0, 0, t1, o, i, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: o,
                        maxZ: i,
                        wrap: t1,
                        fullyVisible: !1
                    };
                }, E = [];
                let C = [];
                const M = i, I = t1.reparseOverscaled ? o : i, S = (e1)=>e1 * e1, D = S((m - this._centerAltitude) * p), L = (e1)=>{
                    if (!this._elevation || !e1.tileID || !n) return;
                    const t1 = this._elevation.getMinMaxForTile(e1.tileID), i = e1.aabb;
                    t1 ? (i.min[2] = t1.min, i.max[2] = t1.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e1.shouldSplit = A(e1), e1.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, A = (t1)=>{
                    if (t1.zoom < v) return !0;
                    if (t1.zoom === M) return !1;
                    if (null != t1.shouldSplit) return t1.shouldSplit;
                    const i = t1.aabb.distanceX(f), n = t1.aabb.distanceY(f);
                    let s = D, l = 1;
                    if (h) {
                        s = S(t1.aabb.distanceZ(f));
                        const i = Math.pow(2, t1.zoom), o = e1.latFromMercatorY((t1.y + 1) / i), r = e1.latFromMercatorY(t1.y / i), n = Math.min(Math.max(a, o), r), c = e1.circumferenceAtLatitude(n) / e1.circumferenceAtLatitude(a);
                        if (l = n === a ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, c / this._mercatorScaleRatio), this.zoom <= e1.GLOBE_ZOOM_THRESHOLD_MIN && t1.zoom === M - 1 && c >= .9) return !0;
                    } else if (r && (s = S(t1.aabb.distanceZ(f) * p)), this.projection.isReprojectedInTileSpace && o <= 5) {
                        const i = Math.pow(2, t1.zoom), o = w(new e1.MercatorCoordinate((t1.x + .5) / i, (t1.y + .5) / i));
                        l = o > .85 ? 1 : o;
                    }
                    const c = i * i + n * n + s, u = S((1 << M - t1.zoom) * g * l * ((e1, t1)=>{
                        if (t1 * S(.707) < e1) return 1;
                        const i = Math.sqrt(t1 / e1);
                        return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                    })(Math.max(s, D), c));
                    return c < u;
                };
                if (this.renderWorldCopies) for(let e1 = 1; e1 <= 3; e1++)E.push(T(-e1)), E.push(T(e1));
                for(E.push(T(0)); E.length > 0;){
                    const o = E.pop(), s = o.x, a = o.y;
                    let u = o.fullyVisible;
                    if (!u) {
                        const e1 = o.aabb.intersects(_);
                        if (0 === e1) continue;
                        u = 2 === e1;
                    }
                    if (o.zoom !== M && A(o)) for(let t1 = 0; t1 < 4; t1++){
                        const i = (s << 1) + t1 % 2, c = (a << 1) + (t1 >> 1), _ = {
                            aabb: n ? o.aabb.quadrant(t1) : e1.tileAABB(this, l, o.zoom + 1, i, c, o.wrap, o.minZ, o.maxZ, this.projection),
                            zoom: o.zoom + 1,
                            x: i,
                            y: c,
                            wrap: o.wrap,
                            fullyVisible: u,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: o.minZ,
                            maxZ: o.maxZ
                        };
                        r && !h && (_.tileID = new e1.OverscaledTileID(o.zoom + 1 === M ? I : o.zoom + 1, o.wrap, o.zoom + 1, i, c), L(_)), E.push(_);
                    }
                    else {
                        const r = o.zoom === M ? I : o.zoom;
                        if (t1.minzoom && t1.minzoom > r) continue;
                        const n = c[0] - (.5 + s + (o.wrap << o.zoom)) * (1 << i - o.zoom), l = c[1] - .5 - a, h = o.tileID ? o.tileID : new e1.OverscaledTileID(r, o.wrap, o.zoom, s, a);
                        C.push({
                            tileID: h,
                            distanceSq: n * n + l * l
                        });
                    }
                }
                if (this.fogCullDistSq) {
                    const i = this.fogCullDistSq, o = this.horizonLineFromTop();
                    C = C.filter((r)=>{
                        const n = [
                            0,
                            0,
                            0,
                            1
                        ], s = [
                            e1.EXTENT,
                            e1.EXTENT,
                            0,
                            1
                        ], a = this.calculateFogTileMatrix(r.tileID.toUnwrapped());
                        e1.transformMat4$1(n, n, a), e1.transformMat4$1(s, s, a);
                        const l = e1.getAABBPointSquareDist(n, s);
                        if (0 === l) return !0;
                        let c = !1;
                        const h = this._elevation;
                        if (h && l > i && 0 !== o) {
                            const i = this.calculateProjMatrix(r.tileID.toUnwrapped());
                            let n;
                            t1.isTerrainDEM || (n = h.getMinMaxForTile(r.tileID)), n || (n = {
                                min: y,
                                max: x
                            });
                            const s = e1.furthestTileCorner(this.rotation), a = [
                                s[0] * e1.EXTENT,
                                s[1] * e1.EXTENT,
                                n.max
                            ];
                            e1.transformMat4(a, a, i), c = (1 - a[1]) * this.height * .5 < o;
                        }
                        return l < i || c;
                    });
                }
                return C.sort((e1, t1)=>e1.distanceSq - t1.distanceSq).map((e1)=>e1.tileID);
            }
            resize(e1, t1) {
                this.width = e1, this.height = t1, this.pixelsToGLUnits = [
                    2 / e1,
                    -2 / t1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e1) {
                return Math.pow(2, e1);
            }
            scaleZoom(e1) {
                return Math.log(e1) / Math.LN2;
            }
            project(t1) {
                const i = e1.clamp(t1.lat, -e1.MAX_MERCATOR_LATITUDE, e1.MAX_MERCATOR_LATITUDE), o = this.projection.project(t1.lng, i);
                return new e1.pointGeometry(o.x * this.worldSize, o.y * this.worldSize);
            }
            unproject(e1) {
                return this.projection.unproject(e1.x / this.worldSize, e1.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / e1.mercatorZfromAltitude(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(t1, i) {
                let o, r;
                const n = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e1 = this.worldSize;
                    o = (i.x - n.x) / e1, r = (i.y - n.y) / e1;
                } else {
                    const e1 = this.pointCoordinate(i), t1 = this.pointCoordinate(n);
                    o = e1.x - t1.x, r = e1.y - t1.y;
                }
                const s = this.locationCoordinate(t1);
                this.setLocation(new e1.MercatorCoordinate(s.x - o, s.y - r));
            }
            setLocation(e1) {
                this.center = this.coordinateLocation(e1), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e1) {
                return this.projection.locationPoint(this, e1);
            }
            locationPoint3D(e1) {
                return this.projection.locationPoint(this, e1, !0);
            }
            pointLocation(e1) {
                return this.coordinateLocation(this.pointCoordinate(e1));
            }
            pointLocation3D(e1) {
                return this.coordinateLocation(this.pointCoordinate3D(e1));
            }
            locationCoordinate(t1, i) {
                const o = i ? e1.mercatorZfromAltitude(i, t1.lat) : void 0, r = this.projection.project(t1.lng, t1.lat);
                return new e1.MercatorCoordinate(r.x, r.y, o);
            }
            coordinateLocation(e1) {
                return this.projection.unproject(e1.x, e1.y);
            }
            pointRayIntersection(t1, i) {
                const o = null != i ? i : this._centerAltitude, r = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], n = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e1.transformMat4$1(r, r, this.pixelMatrixInverse), e1.transformMat4$1(n, n, this.pixelMatrixInverse);
                const s = n[3];
                e1.scale$1(r, r, 1 / r[3]), e1.scale$1(n, n, 1 / s);
                const a = r[2], l = n[2];
                return {
                    p0: r,
                    p1: n,
                    t: a === l ? 0 : (o - a) / (l - a)
                };
            }
            screenPointToMercatorRay(t1) {
                const i = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                return e1.transformMat4$1(i, i, this.pixelMatrixInverse), e1.transformMat4$1(o, o, this.pixelMatrixInverse), e1.scale$1(i, i, 1 / i[3]), e1.scale$1(o, o, 1 / o[3]), i[2] = e1.mercatorZfromAltitude(i[2], this._center.lat) * this.worldSize, o[2] = e1.mercatorZfromAltitude(o[2], this._center.lat) * this.worldSize, e1.scale$1(i, i, 1 / this.worldSize), e1.scale$1(o, o, 1 / this.worldSize), new e1.Ray([
                    i[0],
                    i[1],
                    i[2]
                ], e1.normalize([], e1.sub([], o, i)));
            }
            rayIntersectionCoordinate(t1) {
                const { p0: i, p1: o, t: r } = t1, n = e1.mercatorZfromAltitude(i[2], this._center.lat), s = e1.mercatorZfromAltitude(o[2], this._center.lat);
                return new e1.MercatorCoordinate(e1.number(i[0], o[0], r) / this.worldSize, e1.number(i[1], o[1], r) / this.worldSize, e1.number(n, s, r));
            }
            pointCoordinate(e1, t1 = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e1.x, e1.y, t1);
            }
            pointCoordinate3D(t1) {
                if (!this.elevation) return this.pointCoordinate(t1);
                let i = this.projection.pointCoordinate3D(this, t1.x, t1.y);
                if (i) return new e1.MercatorCoordinate(i[0], i[1], i[2]);
                let o = 0, r = this.horizonLineFromTop();
                if (t1.y > r) return this.pointCoordinate(t1);
                const n = .02 * r, s = t1.clone();
                for(let t1 = 0; t1 < 10 && r - o > n; t1++){
                    s.y = e1.number(o, r, .66);
                    const t1 = this.projection.pointCoordinate3D(this, s.x, s.y);
                    t1 ? (r = s.y, i = t1) : o = s.y;
                }
                return i ? new e1.MercatorCoordinate(i[0], i[1], i[2]) : this.pointCoordinate(t1);
            }
            isPointAboveHorizon(e1) {
                return this.projection.isPointAboveHorizon(this, e1);
            }
            _coordinatePoint(t1, i) {
                const o = i && this.elevation ? this.elevation.getAtPointOrZero(t1, this._centerAltitude) : this._centerAltitude, r = [
                    t1.x * this.worldSize,
                    t1.y * this.worldSize,
                    o + t1.toAltitude(),
                    1
                ];
                return e1.transformMat4$1(r, r, this.pixelMatrix), r[3] > 0 ? new e1.pointGeometry(r[0] / r[3], r[1] / r[3]) : new e1.pointGeometry(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: t1, left: i } = this._edgeInsets, o = this.height - this._edgeInsets.bottom, r = this.width - this._edgeInsets.right, n = this.pointLocation3D(new e1.pointGeometry(i, t1)), s = this.pointLocation3D(new e1.pointGeometry(r, t1)), a = this.pointLocation3D(new e1.pointGeometry(r, o)), l = this.pointLocation3D(new e1.pointGeometry(i, o));
                let c = Math.min(n.lng, s.lng, a.lng, l.lng), h = Math.max(n.lng, s.lng, a.lng, l.lng), u = Math.min(n.lat, s.lat, a.lat, l.lat), _ = Math.max(n.lat, s.lat, a.lat, l.lat);
                const d = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, m = (t1, i, o, r, n)=>{
                    const s = (t1 + o) / 2, a = (i + r) / 2, l = new e1.pointGeometry(s, a), { lng: f, lat: g } = this.pointLocation3D(l), v = Math.max(0, c - f, u - g, f - h, g - _);
                    c = Math.min(c, f), h = Math.max(h, f), u = Math.min(u, g), _ = Math.max(_, g), (n < p || v > d) && (m(t1, i, s, a, n + 1), m(s, a, o, r, n + 1));
                };
                if (m(i, t1, r, t1, 1), m(r, t1, r, o, 1), m(r, o, i, o, 1), m(i, o, i, t1, 1), "globe" === this.projection.name) {
                    const [t1, i] = e1.polesInViewport(this);
                    t1 ? (_ = 90, h = 180, c = -180) : i && (u = -90, h = 180, c = -180);
                }
                return new e1.LngLatBounds(new e1.LngLat(c, u), new e1.LngLat(h, _));
            }
            _getBoundsRectangular(t1, i) {
                const { top: o, left: r } = this._edgeInsets, n = this.height - this._edgeInsets.bottom, s = this.width - this._edgeInsets.right, a = new e1.pointGeometry(r, o), l = new e1.pointGeometry(s, o), c = new e1.pointGeometry(s, n), h = new e1.pointGeometry(r, n);
                let u = this.pointCoordinate(a, t1), _ = this.pointCoordinate(l, t1);
                const d = this.pointCoordinate(c, i), p = this.pointCoordinate(h, i), m = (e1, t1)=>(t1.y - e1.y) / (t1.x - e1.x);
                return u.y > 1 && _.y >= 0 ? u = new e1.MercatorCoordinate((1 - p.y) / m(p, u) + p.x, 1) : u.y < 0 && _.y <= 1 && (u = new e1.MercatorCoordinate(-p.y / m(p, u) + p.x, 0)), _.y > 1 && u.y >= 0 ? _ = new e1.MercatorCoordinate((1 - d.y) / m(d, _) + d.x, 1) : _.y < 0 && u.y <= 1 && (_ = new e1.MercatorCoordinate(-d.y / m(d, _) + d.x, 0)), (new e1.LngLatBounds).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(_)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(d));
            }
            _getBoundsRectangularTerrain() {
                const e1 = this.elevation;
                if (!e1.visibleDemTiles.length || e1.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t1 = e1.visibleDemTiles.reduce((e1, t1)=>{
                    if (t1.dem) {
                        const i = t1.dem.tree;
                        e1.min = Math.min(e1.min, i.minimums[0]), e1.max = Math.max(e1.max, i.maximums[0]);
                    }
                    return e1;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t1.min * e1.exaggeration(), t1.max * e1.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e1 = !0) {
                const t1 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) + this.centerOffset.y, i = this.height / 2 - t1 * (1 - this._horizonShift);
                return e1 ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(t1) {
                this.maxBounds = t1, this.minLat = -e1.MAX_MERCATOR_LATITUDE, this.maxLat = e1.MAX_MERCATOR_LATITUDE, this.minLng = -180, this.maxLng = 180, t1 && (this.minLat = t1.getSouth(), this.maxLat = t1.getNorth(), this.minLng = t1.getWest(), this.maxLng = t1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e1.mercatorXfromLng(this.minLng) * this.tileSize, this.worldMaxX = e1.mercatorXfromLng(this.maxLng) * this.tileSize, this.worldMinY = e1.mercatorYfromLat(this.maxLat) * this.tileSize, this.worldMaxY = e1.mercatorYfromLat(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e1, t1) {
                return this.projection.createTileMatrix(this, t1, e1);
            }
            calculateDistanceTileData(t1) {
                const i = t1.key, o = this._distanceTileDataCache;
                if (o[i]) return o[i];
                const r = t1.canonical, n = 1 / this.height, s = this.cameraWorldSize, a = s / this.zoomScale(r.z), l = (r.x + Math.pow(2, r.z) * t1.wrap) * a, c = r.y * a, h = this.point;
                h.x *= s / this.worldSize, h.y *= s / this.worldSize;
                const u = this.angle, _ = Math.sin(-u), d = -Math.cos(-u);
                return o[i] = {
                    bearing: [
                        _,
                        d
                    ],
                    center: [
                        (h.x - l) * n,
                        (h.y - c) * n
                    ],
                    scale: a / e1.EXTENT * n
                }, o[i];
            }
            calculateFogTileMatrix(t1) {
                const i = t1.key, o = this._fogTileMatrixCache;
                if (o[i]) return o[i];
                const r = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t1);
                return e1.multiply(r, this.worldToFogMatrix, r), o[i] = new Float32Array(r), o[i];
            }
            calculateProjMatrix(t1, i = !1) {
                const o = t1.key, r = i ? this._alignedProjMatrixCache : this._projMatrixCache;
                if (r[o]) return r[o];
                const n = this.calculatePosMatrix(t1, this.worldSize);
                return e1.multiply(n, this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : i ? this.alignedProjMatrix : this.projMatrix, n), r[o] = new Float32Array(n), r[o];
            }
            calculatePixelsToTileUnitsMatrix(t1) {
                const i = t1.tileID.key, o = this._pixelsToTileUnitsCache;
                if (o[i]) return o[i];
                const r = function(t1, i) {
                    const { scale: o } = t1.tileTransform, r = o * e1.EXTENT / (t1.tileSize * Math.pow(2, i.zoom - t1.tileID.overscaledZ + t1.tileID.canonical.z));
                    var n, s, a, l, c, h, u, _;
                    return n = new Float32Array(4), l = (s = i.inverseAdjustmentMatrix)[1], c = s[2], h = s[3], _ = (a = [
                        r,
                        r
                    ])[1], n[0] = s[0] * (u = a[0]), n[1] = l * u, n[2] = c * _, n[3] = h * _, n;
                }(t1, this);
                return o[i] = r, o[i];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const t1 = 1 / this.worldSize, i = e1.fromScaling([], [
                        t1,
                        t1,
                        t1
                    ]);
                    return e1.multiply(i, i, this.globeMatrix), i;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const t1 = this._elevation;
                this._updateCameraState();
                const i = e1.mercatorZfromAltitude(1, this._center.lat) * this.worldSize, o = this._computeCameraPosition(i), r = this._camera.forward(), n = e1.mercatorZfromAltitude(1, this._center.lat);
                o[2] /= n, r[2] /= n, e1.normalize(r, r);
                const s = t1.raycast(o, r, t1.exaggeration());
                if (s) {
                    const t1 = e1.scaleAndAdd([], o, r, s), i = new e1.MercatorCoordinate(t1[0], t1[1], e1.mercatorZfromAltitude(t1[2], e1.latFromMercatorY(t1[1]))), a = (i.z + e1.length([
                        i.x - o[0],
                        i.y - o[1],
                        i.z - o[2] * n
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(a), this._centerAltitude = i.toAltitude(), this._center = this.coordinateLocation(i), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(t1 = !1) {
                if (!this._elevation) return;
                const i = this._elevation, o = e1.mercatorZfromAltitude(1, this._center.lat) * this.worldSize, r = this._computeCameraPosition(o), n = i.getAtPointOrZero(new e1.MercatorCoordinate(...r)), s = this.pixelsPerMeter / this.worldSize * n, a = this._minimumHeightOverTerrain(), l = r[2] - s;
                if (l <= a) {
                    if (l < 0 || t1) {
                        const t1 = this.locationCoordinate(this._center, this._centerAltitude), i = [
                            r[0],
                            r[1],
                            t1.z - r[2]
                        ], o = e1.length(i);
                        i[2] -= (a - l) / this._pixelsPerMercatorPixel;
                        const n = e1.length(i);
                        if (0 === n) return;
                        e1.scale$2(i, i, o / n * this._pixelsPerMercatorPixel), this._camera.position = [
                            r[0],
                            r[1],
                            t1.z * this._pixelsPerMercatorPixel - i[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const t1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || t1) {
                    const i = this.center;
                    return i.lat = e1.clamp(i.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t1) && (i.lng = e1.clamp(i.lng, this.minLng, this.maxLng)), this.center = i, void (this._constraining = !1);
                }
                const i = this._unmodified, { x: o, y: r } = this.point;
                let n = 0, s = o, a = r;
                const l = this.width / 2, c = this.height / 2, h = this.worldMinY * this.scale, u = this.worldMaxY * this.scale;
                if (r - c < h && (a = h + c), r + c > u && (a = u - c), u - h < this.height && (n = Math.max(n, this.height / (u - h)), a = (u + h) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e1 = this.worldMinX * this.scale, t1 = this.worldMaxX * this.scale, i = this.worldSize / 2 - (e1 + t1) / 2;
                    s = (o + i + this.worldSize) % this.worldSize - i, s - l < e1 && (s = e1 + l), s + l > t1 && (s = t1 - l), t1 - e1 < this.width && (n = Math.max(n, this.width / (t1 - e1)), s = (t1 + e1) / 2);
                }
                s === o && a === r || (this.center = this.unproject(new e1.pointGeometry(s, a))), n && (this.zoom += this.scaleZoom(n)), this._constrainCamera(), this._unmodified = i, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e1 = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e1 = Math.max(e1, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e1;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const t1 = this.centerOffset, i = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = e1.mercatorZfromAltitude(1, this.center.lat) / e1.mercatorZfromAltitude(1, e1.GLOBE_SCALE_MATCH_LATITUDE));
                const o = qo(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, o), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const r = "meters" === this.projection.zAxisUnit ? i : 1, n = this._camera.getWorldToCamera(this.worldSize, r), s = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                s[8] = 2 * -t1.x / this.width, s[9] = 2 * t1.y / this.height;
                let a = e1.mul([], s, n);
                if (this.projection.isReprojectedInTileSpace) {
                    const t1 = this.locationCoordinate(this.center), i = e1.identity([]);
                    e1.translate(i, i, [
                        t1.x * this.worldSize,
                        t1.y * this.worldSize,
                        0
                    ]), e1.multiply(i, i, Wo(this)), e1.translate(i, i, [
                        -t1.x * this.worldSize,
                        -t1.y * this.worldSize,
                        0
                    ]), e1.multiply(a, a, i), this.inverseAdjustmentMatrix = function(e1) {
                        const t1 = Wo(e1, !0);
                        return v([], [
                            t1[0],
                            t1[1],
                            t1[4],
                            t1[5]
                        ]);
                    }(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                this.mercatorMatrix = e1.scale([], a, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / r,
                    1
                ]), this.projMatrix = a, this.invProjMatrix = e1.invert(new Float64Array(16), this.projMatrix);
                const l = e1.invert([], s);
                this.frustumCorners = e1.FrustumCorners.fromInvProjectionMatrix(l, this.horizonLineFromTop(), this.height);
                const c = new Float32Array(16);
                e1.identity(c), e1.scale(c, c, [
                    1,
                    -1,
                    1
                ]), e1.rotateX(c, c, this._pitch), e1.rotateZ(c, c, this.angle);
                const h = e1.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ), u = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                h[8] = 2 * -t1.x / this.width, h[9] = 2 * (t1.y + u) / this.height, this.skyboxMatrix = e1.multiply(c, h, c);
                const _ = this.point, d = _.x, p = _.y, m = this.width % 2 / 2, f = this.height % 2 / 2, g = Math.cos(this.angle), x = Math.sin(this.angle), y = d - Math.round(d) + g * m + x * f, b = p - Math.round(p) + g * f + x * m, w = new Float64Array(a);
                if (e1.translate(w, w, [
                    y > .5 ? y - 1 : y,
                    b > .5 ? b - 1 : b,
                    0
                ]), this.alignedProjMatrix = w, a = e1.create(), e1.scale(a, a, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), e1.translate(a, a, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = a, a = e1.create(), e1.scale(a, a, [
                    1,
                    -1,
                    1
                ]), e1.translate(a, a, [
                    -1,
                    -1,
                    0
                ]), e1.scale(a, a, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = a, this.pixelMatrix = e1.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix), this._calcFogMatrices(), this._distanceTileDataCache = {}, a = e1.invert(new Float64Array(16), this.pixelMatrix), !a) throw new Error("failed to invert matrix");
                if (this.pixelMatrixInverse = a, "globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = e1.calculateGlobeMatrix(this);
                    const t1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = e1.transformMat4(t1, t1, n), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = a;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const t1 = this.cameraWorldSizeForFog, i = this.cameraPixelsPerMeter, o = this._camera.position, r = 1 / this.height / this._pixelsPerMercatorPixel, n = [
                    t1,
                    t1,
                    i
                ];
                e1.scale$2(n, n, r), e1.scale$2(o, o, -1), e1.multiply$2(o, o, n);
                const s = e1.create();
                e1.translate(s, s, o), e1.scale(s, s, n), this.mercatorFogMatrix = s, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t1, i, r);
            }
            _computeCameraPosition(e1) {
                const t1 = (e1 = e1 || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), o = this.point, r = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t1 - e1 / this.worldSize * this._centerAltitude;
                return [
                    o.x / this.worldSize - i[0] * r,
                    o.y / this.worldSize - i[1] * r,
                    e1 / this.worldSize * this._centerAltitude - i[2] * r
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(t1) {
                const i = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o = this._camera.position[2], r = t1[2];
                let n = 1;
                this.projection.wrap && (this.center = this.center.wrap()), r > 0 && (n = Math.min((i - o) / r, 1)), this._camera.position = e1.scaleAndAdd([], this._camera.position, t1, n), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const t1 = this._camera.position, i = this._camera.forward(), { pitch: o, bearing: r } = this._camera.getPitchBearing(), n = e1.mercatorZfromAltitude(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, s = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e1.degToRad(this._maxPitch)), a = Math.max((t1[2] - n) / Math.cos(o), s), l = this._zoomFromMercatorZ(a);
                e1.scaleAndAdd(t1, t1, i, a), this._pitch = e1.clamp(o, e1.degToRad(this.minPitch), e1.degToRad(this.maxPitch)), this.angle = e1.wrap(r, -Math.PI, Math.PI), this._setZoom(e1.clamp(l, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e1.MercatorCoordinate(t1[0], t1[1], t1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e1) {
                return Math.pow(2, e1) * this.tileSize;
            }
            _mercatorZfromZoom(e1) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e1);
            }
            _minimumHeightOverTerrain() {
                const e1 = Math.min((null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom) + 4, this._maxZoom);
                return this._mercatorZfromZoom(e1);
            }
            _zoomFromMercatorZ(e1) {
                return this.scaleZoom(this.cameraToCenterDistance / (e1 * this.tileSize));
            }
            zoomFromMercatorZAdjusted(t1) {
                let i = 0, o = e1.GLOBE_ZOOM_THRESHOLD_MAX, r = 0, n = 1 / 0;
                for(; o - i > 1e-6 && o > i;){
                    const e1 = i + .5 * (o - i), s = this.tileSize * Math.pow(2, e1), a = this.getCameraToCenterDistance(this.projection, e1, s), l = this.scaleZoom(a / (t1 * this.tileSize)), c = Math.abs(e1 - l);
                    c < n && (n = c, r = e1), e1 < l ? i = e1 : o = e1;
                }
                return r;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (e1.warnOnce("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(t1, i) {
                const o = Math.min(t1.x, i.x), r = Math.max(t1.x, i.x), n = Math.min(t1.y, i.y), s = Math.max(t1.y, i.y);
                if (n < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const a = [
                    new e1.pointGeometry(o, n),
                    new e1.pointGeometry(r, s),
                    new e1.pointGeometry(o, s),
                    new e1.pointGeometry(r, n)
                ], l = this.renderWorldCopies ? -3 : 0, c = this.renderWorldCopies ? 4 : 1;
                for (const e1 of a){
                    const t1 = this.pointRayIntersection(e1);
                    if (t1.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t1);
                    if (i.x < l || i.y < 0 || i.x > c || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + e1.radToDeg(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e1.pointGeometry(0, 0), new e1.pointGeometry(this.width, this.height));
            }
            zoomDeltaToMovement(t1, i) {
                const o = e1.length(e1.sub([], this._camera.position, t1)), r = this._zoomFromMercatorZ(o) + i;
                return o - this._mercatorZfromZoom(r);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const t1 = function([t1, i, o], r) {
                        const n = [
                            t1,
                            i,
                            o,
                            1
                        ];
                        e1.transformMat4$1(n, n, r);
                        const s = n[3] = Math.max(n[3], 1e-6);
                        return n[0] /= s, n[1] /= s, n[2] /= s, n;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new e1.pointGeometry(t1[0], t1[1]);
                }
                {
                    const t1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new e1.pointGeometry(0, t1));
                }
            }
            getCameraToCenterDistance(e1, t1 = this.zoom, i = this.worldSize) {
                const o = qo(e1, t1, this.width, this.height, 1024), r = e1.pixelSpaceConversion(this.center.lat, i, o);
                return .5 / Math.tan(.5 * this._fov) * this.height * r;
            }
            getWorldToCameraMatrix() {
                const t1 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
                return "globe" === this.projection.name && e1.multiply(t1, t1, this.globeMatrix), t1;
            }
        }
        function Jo(e1, t1) {
            let i = !1, o = null;
            const r = ()=>{
                o = null, i && (e1(), o = setTimeout(r, t1), i = !1);
            };
            return ()=>(i = !0, o || r(), o);
        }
        class Qo {
            constructor(t1){
                this._hashName = t1 && encodeURIComponent(t1), e1.bindAll([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = Jo(this._updateHashUnthrottled.bind(this), 300);
            }
            addTo(t1) {
                return this._map = t1, e1.window.addEventListener("hashchange", this._onHashChange, !1), t1.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), e1.window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const t1 = this._map;
                if (!t1) return "";
                const i = er(t1);
                if (this._hashName) {
                    const t1 = this._hashName;
                    let o = !1;
                    const r = e1.window.location.hash.slice(1).split("&").map((e1)=>{
                        const r = e1.split("=")[0];
                        return r === t1 ? (o = !0, `${r}=${i}`) : e1;
                    }).filter((e1)=>e1);
                    return o || r.push(`${t1}=${i}`), `#${r.join("&")}`;
                }
                return `#${i}`;
            }
            _getCurrentHash() {
                const t1 = e1.window.location.hash.replace("#", "");
                if (this._hashName) {
                    let e1;
                    return t1.split("&").map((e1)=>e1.split("=")).forEach((t1)=>{
                        t1[0] === this._hashName && (e1 = t1);
                    }), (e1 && e1[1] || "").split("/");
                }
                return t1.split("/");
            }
            _onHashChange() {
                const e1 = this._map;
                if (!e1) return !1;
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((e1)=>isNaN(e1))) {
                    const i = e1.dragRotate.isEnabled() && e1.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : e1.getBearing();
                    return e1.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: i,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                const t1 = e1.window.location.href.replace(/(#.+)?$/, this.getHashString());
                e1.window.history.replaceState(e1.window.history.state, null, t1);
            }
        }
        function er(e1, t1) {
            const i = e1.getCenter(), o = Math.round(100 * e1.getZoom()) / 100, r = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), n = Math.pow(10, r), s = Math.round(i.lng * n) / n, a = Math.round(i.lat * n) / n, l = e1.getBearing(), c = e1.getPitch();
            let h = t1 ? `/${s}/${a}/${o}` : `${o}/${a}/${s}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const tr = {
            linearity: .3,
            easing: e1.bezier(0, 0, .3, 1)
        }, ir = e1.extend({
            deceleration: 2500,
            maxSpeed: 1400
        }, tr), or = e1.extend({
            deceleration: 20,
            maxSpeed: 1400
        }, tr), rr = e1.extend({
            deceleration: 1e3,
            maxSpeed: 360
        }, tr), nr = e1.extend({
            deceleration: 1e3,
            maxSpeed: 90
        }, tr);
        class sr {
            constructor(e1){
                this._map = e1, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(t1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: e1.exported.now(),
                    settings: t1
                });
            }
            _drainInertiaBuffer() {
                const t1 = this._inertiaBuffer, i = e1.exported.now();
                for(; t1.length > 0 && i - t1[0].time > 160;)t1.shift();
            }
            _onMoveEnd(t1) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e1.pointGeometry(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e1 } of this._inertiaBuffer)i.zoom += e1.zoomDelta || 0, i.bearing += e1.bearingDelta || 0, i.pitch += e1.pitchDelta || 0, e1.panDelta && i.pan._add(e1.panDelta), e1.around && (i.around = e1.around), e1.pinchAround && (i.pinchAround = e1.pinchAround);
                const o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r = {};
                if (i.pan.mag()) {
                    const n = lr(i.pan.mag(), o, e1.extend({}, ir, t1 || {}));
                    r.offset = i.pan.mult(n.amount / i.pan.mag()), r.center = this._map.transform.center, ar(r, n);
                }
                if (i.zoom) {
                    const e1 = lr(i.zoom, o, or);
                    r.zoom = this._map.transform.zoom + e1.amount, ar(r, e1);
                }
                if (i.bearing) {
                    const t1 = lr(i.bearing, o, rr);
                    r.bearing = this._map.transform.bearing + e1.clamp(t1.amount, -179, 179), ar(r, t1);
                }
                if (i.pitch) {
                    const e1 = lr(i.pitch, o, nr);
                    r.pitch = this._map.transform.pitch + e1.amount, ar(r, e1);
                }
                if (r.zoom || r.bearing) {
                    const e1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    r.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
                }
                return this.clear(), r.noMoveStart = !0, r;
            }
        }
        function ar(e1, t1) {
            (!e1.duration || e1.duration < t1.duration) && (e1.duration = t1.duration, e1.easing = t1.easing);
        }
        function lr(t1, i, o) {
            const { maxSpeed: r, linearity: n, deceleration: s } = o, a = e1.clamp(t1 * n / (i / 1e3), -r, r), l = Math.abs(a) / (s * n);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: a * (l / 2)
            };
        }
        class cr extends e1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o, r = {}){
                const n = p(i.getCanvasContainer(), o), s = i.unproject(n);
                super(t1, e1.extend({
                    point: n,
                    lngLat: s,
                    originalEvent: o
                }, r)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class hr extends e1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o){
                const r = "touchend" === t1 ? o.changedTouches : o.touches, n = m(i.getCanvasContainer(), r), s = n.map((e1)=>i.unproject(e1)), a = n.reduce((e1, t1, i, o)=>e1.add(t1.div(o.length)), new e1.pointGeometry(0, 0));
                super(t1, {
                    points: n,
                    point: a,
                    lngLats: s,
                    lngLat: i.unproject(a),
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
        }
        class ur extends e1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t1, i){
                super(e1, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class _r {
            constructor(e1, t1){
                this._map = e1, this._clickTolerance = t1.clickTolerance;
            }
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e1) {
                return this._firePreventable(new ur(e1.type, this._map, e1));
            }
            mousedown(e1, t1) {
                return this._mousedownPos = t1, this._firePreventable(new cr(e1.type, this._map, e1));
            }
            mouseup(e1) {
                this._map.fire(new cr(e1.type, this._map, e1));
            }
            preclick(t1) {
                const i = e1.extend({}, t1);
                i.type = "preclick", this._map.fire(new cr(i.type, this._map, i));
            }
            click(e1, t1) {
                this._mousedownPos && this._mousedownPos.dist(t1) >= this._clickTolerance || (this.preclick(e1), this._map.fire(new cr(e1.type, this._map, e1)));
            }
            dblclick(e1) {
                return this._firePreventable(new cr(e1.type, this._map, e1));
            }
            mouseover(e1) {
                this._map.fire(new cr(e1.type, this._map, e1));
            }
            mouseout(e1) {
                this._map.fire(new cr(e1.type, this._map, e1));
            }
            touchstart(e1) {
                return this._firePreventable(new hr(e1.type, this._map, e1));
            }
            touchmove(e1) {
                this._map.fire(new hr(e1.type, this._map, e1));
            }
            touchend(e1) {
                this._map.fire(new hr(e1.type, this._map, e1));
            }
            touchcancel(e1) {
                this._map.fire(new hr(e1.type, this._map, e1));
            }
            _firePreventable(e1) {
                if (this._map.fire(e1), e1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class dr {
            constructor(e1){
                this._map = e1;
            }
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e1) {
                this._map.fire(new cr(e1.type, this._map, e1));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new cr("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e1) {
                this._delayContextMenu ? this._contextMenuEvent = e1 : this._map.fire(new cr(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class pr {
            constructor(e1, t1){
                this._map = e1, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t1.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e1, t1) {
                this.isEnabled() && e1.shiftKey && 0 === e1.button && (h(), this._startPos = this._lastPos = t1, this._active = !0);
            }
            mousemoveWindow(e1, t1) {
                if (!this._active) return;
                const i = t1, o = this._startPos, r = this._lastPos;
                if (!o || !r || r.equals(i) || !this._box && i.dist(o) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = n("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e1));
                const s = Math.min(o.x, i.x), a = Math.max(o.x, i.x), l = Math.min(o.y, i.y), c = Math.max(o.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${s}px,${l}px)`, this._box.style.width = a - s + "px", this._box.style.height = c - l + "px");
                });
            }
            mouseupWindow(t1, i) {
                if (!this._active) return;
                const o = this._startPos, r = i;
                if (o && 0 === t1.button) {
                    if (this.reset(), d(), o.x !== r.x || o.y !== r.y) return this._map.fire(new e1.Event("boxzoomend", {
                        originalEvent: t1
                    })), {
                        cameraAnimation: (e1)=>e1.fitScreenCoordinates(o, r, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", t1);
                }
            }
            keydown(e1) {
                this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), u(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t1, i) {
                return this._map.fire(new e1.Event(t1, {
                    originalEvent: i
                }));
            }
        }
        function mr(e1, t1) {
            const i = {};
            for(let o = 0; o < e1.length; o++)i[e1[o].identifier] = t1[o];
            return i;
        }
        class fr {
            constructor(e1){
                this.reset(), this.numTouches = e1.numTouches;
            }
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(t1, i, o) {
                (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t1.timeStamp), o.length === this.numTouches && (this.centroid = function(t1) {
                    const i = new e1.pointGeometry(0, 0);
                    for (const e1 of t1)i._add(e1);
                    return i.div(t1.length);
                }(i), this.touches = mr(o, i)));
            }
            touchmove(e1, t1, i) {
                if (this.aborted || !this.centroid) return;
                const o = mr(i, t1);
                for(const e1 in this.touches){
                    const t1 = this.touches[e1], i = o[e1];
                    (!i || i.dist(t1) > 30) && (this.aborted = !0);
                }
            }
            touchend(e1, t1, i) {
                if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e1 = !this.aborted && this.centroid;
                    if (this.reset(), e1) return e1;
                }
            }
        }
        class gr {
            constructor(e1){
                this.singleTap = new fr(e1), this.numTaps = e1.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e1, t1, i) {
                this.singleTap.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this.singleTap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const o = this.singleTap.touchend(e1, t1, i);
                if (o) {
                    const t1 = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(o) < 30;
                    if (t1 && i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
                }
            }
        }
        class vr {
            constructor(){
                this._zoomIn = new gr({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new gr({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e1, t1, i) {
                this._zoomIn.touchstart(e1, t1, i), this._zoomOut.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this._zoomIn.touchmove(e1, t1, i), this._zoomOut.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const o = this._zoomIn.touchend(e1, t1, i), r = this._zoomOut.touchend(e1, t1, i);
                return o ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() + 1,
                            around: t1.unproject(o)
                        }, {
                            originalEvent: e1
                        })
                }) : r ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() - 1,
                            around: t1.unproject(r)
                        }, {
                            originalEvent: e1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        const xr = {
            0: 1,
            2: 2
        };
        class yr {
            constructor(e1){
                this.reset(), this._clickTolerance = e1.clickTolerance || 1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e1, t1) {
                return !1;
            }
            _move(e1, t1) {
                return {};
            }
            mousedown(e1, t1) {
                if (this._lastPoint) return;
                const i = f(e1);
                this._correctButton(e1, i) && (this._lastPoint = t1, this._eventButton = i);
            }
            mousemoveWindow(e1, t1) {
                const i = this._lastPoint;
                if (i) {
                    if (e1.preventDefault(), null != this._eventButton && function(e1, t1) {
                        const i = xr[t1];
                        return void 0 === e1.buttons || (e1.buttons & i) !== i;
                    }(e1, this._eventButton)) this.reset();
                    else if (this._moved || !(t1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t1, this._move(i, t1);
                }
            }
            mouseupWindow(e1) {
                this._lastPoint && f(e1) === this._eventButton && (this._moved && d(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class br extends yr {
            mousedown(e1, t1) {
                super.mousedown(e1, t1), this._lastPoint && (this._active = !0);
            }
            _correctButton(e1, t1) {
                return 0 === t1 && !e1.ctrlKey;
            }
            _move(e1, t1) {
                return {
                    around: t1,
                    panDelta: t1.sub(e1)
                };
            }
        }
        class wr extends yr {
            _correctButton(e1, t1) {
                return 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = .8 * (t1.x - e1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e1) {
                e1.preventDefault();
            }
        }
        class Tr extends yr {
            _correctButton(e1, t1) {
                return 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = -0.5 * (t1.y - e1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e1) {
                e1.preventDefault();
            }
        }
        class Er {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e1.bindAll([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e1.pointGeometry(0, 0);
            }
            touchstart(e1, t1, i) {
                return this._calculateTransform(e1, t1, i);
            }
            touchmove(t1, i, o) {
                if (this._active && !(o.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === o.length && !e1.isFullscreen()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return t1.cancelable && t1.preventDefault(), this._calculateTransform(t1, i, o);
                }
            }
            touchend(e1, t1, i) {
                this._calculateTransform(e1, t1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t1, i, o) {
                o.length > 0 && (this._active = !0);
                const r = mr(o, i), n = new e1.pointGeometry(0, 0), s = new e1.pointGeometry(0, 0);
                let a = 0;
                for(const e1 in r){
                    const t1 = r[e1], i = this._touches[e1];
                    i && (n._add(t1), s._add(t1.sub(i)), a++, r[e1] = t1);
                }
                if (this._touches = r, a < this._minTouches || !s.mag()) return;
                const l = s.div(a);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: n.div(a),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = n("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "null");
                }, 500);
            }
        }
        class Cr {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e1) {}
            _move(e1, t1, i) {
                return {};
            }
            touchstart(e1, t1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t1[0],
                    t1[1]
                ]));
            }
            touchmove(e1, t1, i) {
                const o = this._firstTwoTouches;
                if (!o) return;
                e1.preventDefault();
                const [r, n] = o, s = Mr(i, t1, r), a = Mr(i, t1, n);
                if (!s || !a) return;
                const l = this._aroundCenter ? null : s.add(a).div(2);
                return this._move([
                    s,
                    a
                ], l, e1);
            }
            touchend(e1, t1, i) {
                if (!this._firstTwoTouches) return;
                const [o, r] = this._firstTwoTouches, n = Mr(i, t1, o), s = Mr(i, t1, r);
                n && s || (this._active && d(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e1) {
                this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function Mr(e1, t1, i) {
            for(let o = 0; o < e1.length; o++)if (e1[o].identifier === i) return t1[o];
        }
        function Ir(e1, t1) {
            return Math.log(e1 / t1) / Math.LN2;
        }
        class Sr extends Cr {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e1) {
                this._startDistance = this._distance = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._distance;
                if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(Ir(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Ir(this._distance, i),
                    pinchAround: t1
                };
            }
        }
        function Dr(e1, t1) {
            return 180 * e1.angleWith(t1) / Math.PI;
        }
        class Lr extends Cr {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e1) {
                this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._vector;
                if (this._vector = e1[0].sub(e1[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: Dr(this._vector, i),
                    pinchAround: t1
                };
            }
            _isBelowThreshold(e1) {
                this._minDiameter = Math.min(this._minDiameter, e1.mag());
                const t1 = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const o = Dr(e1, i);
                return Math.abs(o) < t1;
            }
        }
        function Ar(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        class zr extends Cr {
            constructor(e1){
                super(), this._map = e1;
            }
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e1) {
                this._lastPoints = e1, Ar(e1[0].sub(e1[1])) && (this._valid = !1);
            }
            _move(t1, i, o) {
                const r = this._lastPoints;
                if (!r) return;
                const n = t1[0].sub(r[0]), s = t1[1].sub(r[1]);
                return this._map._cooperativeGestures && !e1.isFullscreen() && o.touches.length < 3 || (this._valid = this.gestureBeginsVertically(n, s, o.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (n.y + s.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e1, t1, i) {
                if (void 0 !== this._valid) return this._valid;
                const o = e1.mag() >= 2, r = t1.mag() >= 2;
                if (!o && !r) return;
                if (!o || !r) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const n = e1.y > 0 == t1.y > 0;
                return Ar(e1) && Ar(t1) && n;
            }
        }
        const Pr = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class Rr {
            constructor(){
                const e1 = Pr;
                this._panStep = e1.panStep, this._bearingStep = e1.bearingStep, this._pitchStep = e1.pitchStep, this._rotationDisabled = !1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e1) {
                if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                let t1 = 0, i = 0, o = 0, r = 0, n = 0;
                switch(e1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t1 = -1;
                        break;
                    case 37:
                        e1.shiftKey ? i = -1 : (e1.preventDefault(), r = -1);
                        break;
                    case 39:
                        e1.shiftKey ? i = 1 : (e1.preventDefault(), r = 1);
                        break;
                    case 38:
                        e1.shiftKey ? o = 1 : (e1.preventDefault(), n = -1);
                        break;
                    case 40:
                        e1.shiftKey ? o = -1 : (e1.preventDefault(), n = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, o = 0), {
                    cameraAnimation: (s)=>{
                        const a = s.getZoom();
                        s.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: Or,
                            zoom: t1 ? Math.round(a) + t1 * (e1.shiftKey ? 2 : 1) : a,
                            bearing: s.getBearing() + i * this._bearingStep,
                            pitch: s.getPitch() + o * this._pitchStep,
                            offset: [
                                -r * this._panStep,
                                -n * this._panStep
                            ],
                            center: s.getCenter()
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function Or(e1) {
            return e1 * (2 - e1);
        }
        const Br = 4.000244140625;
        class kr {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._handler = i, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222, e1.bindAll([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
            setZoomRate(e1) {
                this._defaultZoomRate = e1;
            }
            setWheelZoomRate(e1) {
                this._wheelZoomRate = e1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(t1.ctrlKey || t1.metaKey || this.isZooming() || e1.isFullscreen())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = t1.deltaMode === e1.window.WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                const o = e1.exported.now(), r = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % Br == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= i, this._active || this._start(t1)), t1.preventDefault();
            }
            _onTimeout(e1) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t1 = p(this._el, e1);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t1, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t1 = this._map.transform;
                "wheel" === this._type && t1.projection.wrap && (t1._center.lng >= 180 || t1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const i = ()=>t1._terrainEnabled() && this._aroundCoord ? t1.computeZoomRelativeTo(this._aroundCoord) : t1.zoom;
                if (0 !== this._delta) {
                    const e1 = "wheel" === this._type && Math.abs(this._delta) > Br ? this._wheelZoomRate : this._defaultZoomRate;
                    let o = 2 / (1 + Math.exp(-Math.abs(this._delta * e1)));
                    this._delta < 0 && 0 !== o && (o = 1 / o);
                    const r = i(), n = Math.pow(2, r), s = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : n;
                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(s * o))), "wheel" === this._type && (this._startZoom = r, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const o = "number" == typeof this._targetZoom ? this._targetZoom : i(), r = this._startZoom, n = this._easing;
                let s, a = !1;
                if ("wheel" === this._type && r && n) {
                    const t1 = Math.min((e1.exported.now() - this._lastWheelEventTime) / 200, 1), i = n(t1);
                    s = e1.number(r, o, i), t1 < 1 ? this._frameId || (this._frameId = !0) : a = !0;
                } else s = o, a = !0;
                return this._active = !0, a && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200)), {
                    noInertia: !0,
                    needsRenderFrame: !a,
                    zoomDelta: s - i(),
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t1) {
                let i = e1.ease;
                if (this._prevEase) {
                    const t1 = this._prevEase, o = (e1.exported.now() - t1.start) / t1.duration, r = t1.easing(o + .01) - t1.easing(o), n = .27 / Math.sqrt(r * r + 1e-4) * .01, s = Math.sqrt(.0729 - n * n);
                    i = e1.bezier(n, s, .25, 1);
                }
                return this._prevEase = {
                    start: e1.exported.now(),
                    duration: t1,
                    easing: i
                }, i;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = n("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(e1.window.navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "null");
                }, 200);
            }
        }
        class Fr {
            constructor(e1, t1){
                this._clickZoom = e1, this._tapZoom = t1;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Ur {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e1, t1) {
                return e1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e1.shiftKey ? -1 : 1),
                            around: i.unproject(t1)
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Nr {
            constructor(){
                this._tap = new gr({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e1, t1, i) {
                this._swipePoint || (this._tapTime && e1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e1, t1, i));
            }
            touchmove(e1, t1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const o = t1[0], r = o.y - this._swipePoint.y;
                        return this._swipePoint = o, e1.preventDefault(), this._active = !0, {
                            zoomDelta: r / 128
                        };
                    }
                } else this._tap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e1, t1, i) && (this._tapTime = e1.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Gr {
            constructor(e1, t1, i){
                this._el = e1, this._mousePan = t1, this._touchPan = i;
            }
            enable(e1) {
                this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class jr {
            constructor(e1, t1, i){
                this._pitchWithRotate = e1.pitchWithRotate, this._mouseRotate = t1, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class Zr {
            constructor(e1, t1, i, o){
                this._el = e1, this._touchZoom = t1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(e1) {
                this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        const Vr = (e1)=>e1.zoom || e1.drag || e1.pitch || e1.rotate;
        class Wr extends e1.Event {
        }
        class Xr {
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
            setup(t1, i) {
                const o = e1.sub([], i, t1);
                this.radius = e1.length(o[2] < 0 ? e1.div([], o, this.constants) : [
                    o[0],
                    o[1],
                    0
                ]);
            }
            projectRay(t1) {
                e1.div(t1, t1, this.constants), e1.normalize(t1, t1), e1.mul$1(t1, t1, this.constants);
                const i = e1.scale$2([], t1, this.radius);
                if (i[2] > 0) {
                    const t1 = e1.scale$2([], [
                        0,
                        0,
                        1
                    ], e1.dot(i, [
                        0,
                        0,
                        1
                    ])), o = e1.scale$2([], e1.normalize([], [
                        i[0],
                        i[1],
                        0
                    ]), this.radius), r = e1.add([], i, e1.scale$2([], e1.sub([], e1.add([], o, t1), i), 2));
                    i[0] = r[0], i[1] = r[1];
                }
                return i;
            }
        }
        function qr(e1) {
            return e1.panDelta && e1.panDelta.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta;
        }
        class $r {
            constructor(t1, i){
                this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new sr(t1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new Xr, this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), e1.bindAll([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const o = this._el;
                this._listeners = [
                    [
                        o,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        o,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "touchend",
                        void 0
                    ],
                    [
                        o,
                        "touchcancel",
                        void 0
                    ],
                    [
                        o,
                        "mousedown",
                        void 0
                    ],
                    [
                        o,
                        "mousemove",
                        void 0
                    ],
                    [
                        o,
                        "mouseup",
                        void 0
                    ],
                    [
                        e1.window.document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        e1.window.document,
                        "mouseup",
                        void 0
                    ],
                    [
                        o,
                        "mouseover",
                        void 0
                    ],
                    [
                        o,
                        "mouseout",
                        void 0
                    ],
                    [
                        o,
                        "dblclick",
                        void 0
                    ],
                    [
                        o,
                        "click",
                        void 0
                    ],
                    [
                        o,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        o,
                        "keyup",
                        void 0
                    ],
                    [
                        o,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "contextmenu",
                        void 0
                    ],
                    [
                        e1.window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [t1, i, o] of this._listeners)t1.addEventListener(i, t1 === e1.window.document ? this.handleWindowEvent : this.handleEvent, o);
            }
            destroy() {
                for (const [t1, i, o] of this._listeners)t1.removeEventListener(i, t1 === e1.window.document ? this.handleWindowEvent : this.handleEvent, o);
            }
            _addDefaultHandlers(e1) {
                const t1 = this._map, i = t1.getCanvasContainer();
                this._add("mapEvent", new _r(t1, e1));
                const o = t1.boxZoom = new pr(t1, e1);
                this._add("boxZoom", o);
                const r = new vr, n = new Ur;
                t1.doubleClickZoom = new Fr(n, r), this._add("tapZoom", r), this._add("clickZoom", n);
                const s = new Nr;
                this._add("tapDragZoom", s);
                const a = t1.touchPitch = new zr(t1);
                this._add("touchPitch", a);
                const l = new wr(e1), c = new Tr(e1);
                t1.dragRotate = new jr(e1, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new br(e1), u = new Er(t1, e1);
                t1.dragPan = new Gr(i, h, u), this._add("mousePan", h), this._add("touchPan", u, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const _ = new Lr, d = new Sr;
                t1.touchZoomRotate = new Zr(i, d, _, s), this._add("touchRotate", _, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", d, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new dr(t1));
                const p = t1.scrollZoom = new kr(t1, this);
                this._add("scrollZoom", p, [
                    "mousePan"
                ]);
                const m = t1.keyboard = new Rr;
                this._add("keyboard", m);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e1.interactive && e1[i] && t1[i].enable(e1[i]);
            }
            _add(e1, t1, i) {
                this._handlers.push({
                    handlerName: e1,
                    handler: t1,
                    allowed: i
                }), this._handlersById[e1] = t1;
            }
            stop(e1) {
                if (!this._updatingCamera) {
                    for (const { handler: e1 } of this._handlers)e1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!Vr(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e1, t1, i) {
                for(const o in e1)if (o !== i && (!t1 || t1.indexOf(o) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(e1) {
                this.handleEvent(e1, `${e1.type}Window`);
            }
            _getMapTouches(e1) {
                const t1 = [];
                for (const i of e1)this._el.contains(i.target) && t1.push(i);
                return t1;
            }
            handleEvent(e1, t1) {
                this._updatingCamera = !0;
                const i = "renderFrame" === e1.type, o = i ? void 0 : e1, r = {
                    needsRenderFrame: !1
                }, n = {}, s = {}, a = e1.touches ? this._getMapTouches(e1.touches) : void 0, l = a ? m(this._el, a) : i ? void 0 : p(this._el, e1);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let u;
                    this._blockedByActive(s, h, i) ? c.reset() : c[t1 || e1.type] && (u = c[t1 || e1.type](e1, l, a), this.mergeHandlerResult(r, n, u, i, o), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || c.isActive()) && (s[i] = c);
                }
                const c = {};
                for(const e1 in this._previousActiveHandlers)s[e1] || (c[e1] = o);
                this._previousActiveHandlers = s, (Object.keys(c).length || qr(r)) && (this._changes.push([
                    r,
                    n,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(s).length || qr(r)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: h } = r;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(t1, i, o, r, n) {
                if (!o) return;
                e1.extend(t1, o);
                const s = {
                    handlerName: r,
                    originalEvent: o.originalEvent || n
                };
                void 0 !== o.zoomDelta && (i.zoom = s), void 0 !== o.panDelta && (i.drag = s), void 0 !== o.pitchDelta && (i.pitch = s), void 0 !== o.bearingDelta && (i.rotate = s);
            }
            _applyChanges() {
                const t1 = {}, i = {}, o = {};
                for (const [r, n, s] of this._changes)r.panDelta && (t1.panDelta = (t1.panDelta || new e1.pointGeometry(0, 0))._add(r.panDelta)), r.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + r.pitchDelta), void 0 !== r.around && (t1.around = r.around), void 0 !== r.aroundCoord && (t1.aroundCoord = r.aroundCoord), void 0 !== r.pinchAround && (t1.pinchAround = r.pinchAround), r.noInertia && (t1.noInertia = r.noInertia), e1.extend(i, n), e1.extend(o, s);
                this._updateMapTransform(t1, i, o), this._changes = [];
            }
            _updateMapTransform(t1, i, o) {
                const r = this._map, n = r.transform, s = (e1)=>[
                        e1.x,
                        e1.y,
                        e1.z
                    ];
                if (((e1)=>{
                    const t1 = this._eventsInProgress.drag;
                    return t1 && !this._handlersById[t1.handlerName].isActive();
                })() && !qr(t1)) {
                    const e1 = n.zoom;
                    n.cameraElevationReference = "sea", n.recenterOnTerrain(), n.cameraElevationReference = "ground", e1 !== n.zoom && this._map._update(!0);
                }
                if (n._isCameraConstrained && r._stop(!0), !qr(t1)) return void this._fireEvents(i, o, !0);
                let { panDelta: a, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: u, aroundCoord: _, pinchAround: d } = t1;
                n._isCameraConstrained && (l > 0 && (l = 0), n._isCameraConstrained = !1), void 0 !== d && (u = d), (l || ((e1)=>i.drag && !this._eventsInProgress.drag)()) && u && (this._dragOrigin = s(n.pointCoordinate3D(u)), this._trackingEllipsoid.setup(n._camera.position, this._dragOrigin)), n.cameraElevationReference = "sea", r._stop(!0), u = u || r.transform.centerPoint, c && (n.bearing += c), h && (n.pitch += h), n._updateCameraState();
                const p = [
                    0,
                    0,
                    0
                ];
                if (a) {
                    if ("mercator" === n.projection.name) {
                        const e1 = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(u).dir), t1 = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(u.sub(a)).dir);
                        p[0] = t1[0] - e1[0], p[1] = t1[1] - e1[1];
                    } else {
                        const t1 = n.pointCoordinate(u);
                        if ("globe" === n.projection.name) {
                            a = a.rotate(-n.angle);
                            const i = n._pixelsPerMercatorPixel / n.worldSize;
                            p[0] = -a.x * e1.mercatorScale(e1.latFromMercatorY(t1.y)) * i, p[1] = -a.y * e1.mercatorScale(n.center.lat) * i;
                        } else {
                            const e1 = n.pointCoordinate(u.sub(a));
                            t1 && e1 && (p[0] = e1.x - t1.x, p[1] = e1.y - t1.y);
                        }
                    }
                }
                const m = n.zoom, f = [
                    0,
                    0,
                    0
                ];
                if (l) {
                    const t1 = s(_ || n.pointCoordinate3D(u)), i = {
                        dir: e1.normalize([], e1.sub([], t1, n._camera.position))
                    };
                    if (i.dir[2] < 0) {
                        const o = n.zoomDeltaToMovement(t1, l);
                        e1.scale$2(f, i.dir, o);
                    }
                }
                const g = e1.add(p, p, f);
                n._translateCameraConstrained(g), l && Math.abs(n.zoom - m) > 1e-4 && n.recenterOnTerrain(), n.cameraElevationReference = "ground", this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(i, o, !0);
            }
            _fireEvents(t1, i, o) {
                const r = Vr(this._eventsInProgress), n = Vr(t1), s = {};
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._eventsInProgress[e1] || (s[`${e1}start`] = i), this._eventsInProgress[e1] = t1[e1];
                }
                !r && n && this._fireEvent("movestart", n.originalEvent);
                for(const e1 in s)this._fireEvent(e1, s[e1]);
                n && this._fireEvent("move", n.originalEvent);
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._fireEvent(e1, i);
                }
                const a = {};
                let l;
                for(const e1 in this._eventsInProgress){
                    const { handlerName: t1, originalEvent: o } = this._eventsInProgress[e1];
                    this._handlersById[t1].isActive() || (delete this._eventsInProgress[e1], l = i[t1] || o, a[`${e1}end`] = l);
                }
                for(const e1 in a)this._fireEvent(e1, a[e1]);
                const c = Vr(this._eventsInProgress);
                if (o && (r || n) && !c) {
                    this._updatingCamera = !0;
                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
                    t1 ? (i(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), this._map.easeTo(t1, {
                        originalEvent: l
                    })) : (this._map.fire(new e1.Event("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(t1, i) {
                this._map.fire(new e1.Event(t1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
                    this._frameId = void 0, this.handleEvent(new Wr("renderFrame", {
                        timeStamp: e1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        const Hr = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class Yr extends e1.Evented {
            constructor(t1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = i.bearingSnap, e1.bindAll([
                    "_renderFrameCallback"
                ], this);
            }
            getCenter() {
                return new e1.LngLat(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e1, t1) {
                return this.jumpTo({
                    center: e1
                }, t1);
            }
            panBy(t1, i, o) {
                return t1 = e1.pointGeometry.convert(t1).mult(-1), this.panTo(this.transform.center, e1.extend({
                    offset: t1
                }, i), o);
            }
            panTo(t1, i, o) {
                return this.easeTo(e1.extend({
                    center: t1
                }, i), o);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e1, t1) {
                return this.jumpTo({
                    zoom: e1
                }, t1), this;
            }
            zoomTo(t1, i, o) {
                return this.easeTo(e1.extend({
                    zoom: t1
                }, i), o);
            }
            zoomIn(e1, t1) {
                return this.zoomTo(this.getZoom() + 1, e1, t1), this;
            }
            zoomOut(e1, t1) {
                return this.zoomTo(this.getZoom() - 1, e1, t1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e1, t1) {
                return this.jumpTo({
                    bearing: e1
                }, t1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e1, t1) {
                return this.jumpTo({
                    padding: e1
                }, t1), this;
            }
            rotateTo(t1, i, o) {
                return this.easeTo(e1.extend({
                    bearing: t1
                }, i), o);
            }
            resetNorth(t1, i) {
                return this.rotateTo(0, e1.extend({
                    duration: 1e3
                }, t1), i), this;
            }
            resetNorthPitch(t1, i) {
                return this.easeTo(e1.extend({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, t1), i), this;
            }
            snapToNorth(e1, t1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e1, t1) {
                return this.jumpTo({
                    pitch: e1
                }, t1), this;
            }
            cameraForBounds(t1, i) {
                t1 = e1.LngLatBounds.convert(t1);
                const o = i && i.bearing || 0, r = i && i.pitch || 0, n = t1.getNorthWest(), s = t1.getSouthEast();
                return this._cameraForBounds(this.transform, n, s, o, r, i);
            }
            _extendCameraOptions(t1) {
                const i = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (t1 = e1.extend({
                    padding: i,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, t1)).padding) {
                    const e1 = t1.padding;
                    t1.padding = {
                        top: e1,
                        bottom: e1,
                        right: e1,
                        left: e1
                    };
                }
                return t1.padding = e1.extend(i, t1.padding), t1;
            }
            _minimumAABBFrustumDistance(e1, t1) {
                const i = t1.max[0] - t1.min[0], o = t1.max[1] - t1.min[1];
                return i / o > e1.aspect ? i / (2 * Math.tan(.5 * e1.fovX) * e1.aspect) : o / (2 * Math.tan(.5 * e1.fovY) * e1.aspect);
            }
            _cameraForBoundsOnGlobe(t1, i, o, r, n, s) {
                const a = t1.clone(), l = this._extendCameraOptions(s);
                a.bearing = r, a.pitch = n;
                const c = e1.LngLat.convert(i), h = e1.LngLat.convert(o), u = .5 * (c.lat + h.lat), _ = .5 * (c.lng + h.lng), d = e1.latLngToECEF(u, _), p = e1.normalize([], d), m = e1.normalize([], e1.cross([], p, [
                    0,
                    1,
                    0
                ])), f = e1.cross([], m, p), g = [
                    m[0],
                    m[1],
                    m[2],
                    0,
                    f[0],
                    f[1],
                    f[2],
                    0,
                    p[0],
                    p[1],
                    p[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], v = [
                    d,
                    e1.latLngToECEF(c.lat, c.lng),
                    e1.latLngToECEF(h.lat, c.lng),
                    e1.latLngToECEF(h.lat, h.lng),
                    e1.latLngToECEF(c.lat, h.lng),
                    e1.latLngToECEF(u, c.lng),
                    e1.latLngToECEF(u, h.lng),
                    e1.latLngToECEF(c.lat, _),
                    e1.latLngToECEF(h.lat, _)
                ];
                let x = e1.Aabb.fromPoints(v.map((t1)=>[
                        e1.dot(m, t1),
                        e1.dot(f, t1),
                        e1.dot(p, t1)
                    ]));
                const y = e1.transformMat4([], x.center, g);
                0 === e1.squaredLength(y) && e1.set(y, 0, 0, 1), e1.normalize(y, y), e1.scale$2(y, y, e1.GLOBE_RADIUS), a.center = e1.ecefToLatLng(y);
                const b = a.getWorldToCameraMatrix(), w = e1.invert(new Float64Array(16), b);
                x = e1.Aabb.applyTransform(x, e1.multiply([], b, g)), e1.transformMat4(y, y, b);
                const T = .5 * (x.max[2] - x.min[2]), E = this._minimumAABBFrustumDistance(a, x), C = e1.scale$2([], [
                    0,
                    0,
                    1
                ], T), M = e1.add(C, y, C), I = E + (0 === a.pitch ? 0 : e1.distance(y, M)), S = a.globeCenterInViewSpace, D = e1.sub([], y, [
                    S[0],
                    S[1],
                    S[2]
                ]);
                e1.normalize(D, D), e1.scale$2(D, D, I);
                const L = e1.add([], y, D);
                e1.transformMat4(L, L, w);
                const A = e1.earthRadius / e1.GLOBE_RADIUS, z = e1.length(L), P = e1.mercatorZfromAltitude(Math.max(z * A - e1.earthRadius, Number.EPSILON), 0), R = Math.min(a.zoomFromMercatorZAdjusted(P), l.maxZoom);
                return R > .5 * (e1.GLOBE_ZOOM_THRESHOLD_MIN + e1.GLOBE_ZOOM_THRESHOLD_MAX) ? (a.setProjection({
                    name: "mercator"
                }), a.zoom = R, this._cameraForBounds(a, i, o, r, n, s)) : {
                    center: a.center,
                    zoom: R,
                    bearing: r,
                    pitch: n
                };
            }
            queryTerrainElevation(t1, i) {
                const o = this.transform.elevation;
                return o ? (i = e1.extend({}, {
                    exaggerated: !0
                }, i), o.getAtPoint(e1.MercatorCoordinate.fromLngLat(t1), null, i.exaggerated)) : null;
            }
            _cameraForBounds(t1, i, o, r, n, s) {
                if ("globe" === t1.projection.name) return this._cameraForBoundsOnGlobe(t1, i, o, r, n, s);
                const a = t1.clone(), l = this._extendCameraOptions(s), c = a.padding;
                a.bearing = r, a.pitch = n;
                const h = e1.LngLat.convert(i), u = e1.LngLat.convert(o), _ = new e1.LngLat(h.lng, u.lat), d = new e1.LngLat(u.lng, h.lat), p = a.project(h), m = a.project(u), f = this.queryTerrainElevation(h), g = this.queryTerrainElevation(u), v = this.queryTerrainElevation(_), x = this.queryTerrainElevation(d), y = [
                    [
                        p.x,
                        p.y,
                        Math.min(f || 0, g || 0, v || 0, x || 0)
                    ],
                    [
                        m.x,
                        m.y,
                        Math.max(f || 0, g || 0, v || 0, x || 0)
                    ]
                ];
                let b = e1.Aabb.fromPoints(y);
                const w = a.getWorldToCameraMatrix(), T = e1.invert(new Float64Array(16), w);
                b = e1.Aabb.applyTransform(b, w);
                const E = e1.sub([], b.max, b.min), C = c.left || 0, M = c.right || 0, I = c.bottom || 0, S = c.top || 0, { left: D, right: L, top: A, bottom: z } = l.padding, P = .5 * (C + M), R = .5 * (S + I), O = Math.min(a.scaleZoom(a.scale * Math.min((a.width - (C + M + D + L)) / E[0], (a.height - (I + S + z + A)) / E[1])), l.maxZoom), B = a.scale / a.zoomScale(O);
                b = new e1.Aabb([
                    b.min[0] - (D + P) * B,
                    b.min[1] - (z + R) * B,
                    b.min[2]
                ], [
                    b.max[0] + (L + P) * B,
                    b.max[1] + (A + R) * B,
                    b.max[2]
                ]);
                const k = .5 * E[2], F = this._minimumAABBFrustumDistance(a, b), U = [
                    0,
                    0,
                    1,
                    0
                ];
                e1.transformMat4$1(U, U, w), e1.normalize$2(U, U);
                const N = e1.scale$2([], U, F + k), G = e1.add([], b.center, N), j = ("number" == typeof l.offset.x && "number" == typeof l.offset.y ? new e1.pointGeometry(l.offset.x, l.offset.y) : e1.pointGeometry.convert(l.offset)).rotate(-e1.degToRad(r));
                b.center[0] -= j.x * B, b.center[1] += j.y * B, e1.transformMat4(b.center, b.center, T), e1.transformMat4(G, G, T);
                const Z = [
                    b.center[0],
                    b.center[1],
                    G[2] * a.pixelsPerMeter
                ];
                e1.scale$2(Z, Z, 1 / a.worldSize);
                const V = e1.lngFromMercatorX(Z[0]), W = e1.latFromMercatorY(Z[1]), X = Math.min(a._zoomFromMercatorZ(Z[2]), l.maxZoom), q = new e1.LngLat(V, W);
                return a.mercatorFromTransition && X < .5 * (e1.GLOBE_ZOOM_THRESHOLD_MIN + e1.GLOBE_ZOOM_THRESHOLD_MAX) ? (a.setProjection({
                    name: "globe"
                }), a.zoom = X, this._cameraForBounds(a, i, o, r, n, s)) : {
                    center: q,
                    zoom: X,
                    bearing: r,
                    pitch: n
                };
            }
            fitBounds(e1, t1, i) {
                const o = this.cameraForBounds(e1, t1);
                return this._fitInternal(o, t1, i);
            }
            fitScreenCoordinates(t1, i, o, r, n) {
                const s = e1.pointGeometry.convert(t1), a = e1.pointGeometry.convert(i), l = new e1.pointGeometry(Math.min(s.x, a.x), Math.min(s.y, a.y)), c = new e1.pointGeometry(Math.max(s.x, a.x), Math.max(s.y, a.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(s, a)) return this;
                const h = this.transform.pointLocation3D(l), u = this.transform.pointLocation3D(c), _ = this.transform.pointLocation3D(new e1.pointGeometry(l.x, c.y)), d = this.transform.pointLocation3D(new e1.pointGeometry(c.x, l.y)), p = [
                    Math.min(h.lng, u.lng, _.lng, d.lng),
                    Math.min(h.lat, u.lat, _.lat, d.lat)
                ], m = [
                    Math.max(h.lng, u.lng, _.lng, d.lng),
                    Math.max(h.lat, u.lat, _.lat, d.lat)
                ], f = r && r.pitch ? r.pitch : this.getPitch(), g = this._cameraForBounds(this.transform, p, m, o, f, r);
                return this._fitInternal(g, r, n);
            }
            _fitInternal(t1, i, o) {
                return t1 ? (delete (i = e1.extend(t1, i)).padding, i.linear ? this.easeTo(i, o) : this.flyTo(i, o)) : this;
            }
            jumpTo(t1, i) {
                this.stop();
                const o = t1.preloadOnly ? this.transform.clone() : this.transform;
                let r = !1, n = !1, s = !1;
                return "zoom" in t1 && o.zoom !== +t1.zoom && (r = !0, o.zoom = +t1.zoom), void 0 !== t1.center && (o.center = e1.LngLat.convert(t1.center)), "bearing" in t1 && o.bearing !== +t1.bearing && (n = !0, o.bearing = +t1.bearing), "pitch" in t1 && o.pitch !== +t1.pitch && (s = !0, o.pitch = +t1.pitch), null == t1.padding || o.isPaddingEqual(t1.padding) || (o.padding = t1.padding), t1.preloadOnly ? (this._preloadTiles(o), this) : (this.fire(new e1.Event("movestart", i)).fire(new e1.Event("move", i)), r && this.fire(new e1.Event("zoomstart", i)).fire(new e1.Event("zoom", i)).fire(new e1.Event("zoomend", i)), n && this.fire(new e1.Event("rotatestart", i)).fire(new e1.Event("rotate", i)).fire(new e1.Event("rotateend", i)), s && this.fire(new e1.Event("pitchstart", i)).fire(new e1.Event("pitch", i)).fire(new e1.Event("pitchend", i)), this.fire(new e1.Event("moveend", i)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || e1.warnOnce(Hr), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t1, i) {
                const o = this.transform;
                if (!o.projection.supportsFreeCamera) return e1.warnOnce(Hr), this;
                this.stop();
                const r = o.zoom, n = o.pitch, s = o.bearing;
                o.setFreeCameraOptions(t1);
                const a = r !== o.zoom, l = n !== o.pitch, c = s !== o.bearing;
                return this.fire(new e1.Event("movestart", i)).fire(new e1.Event("move", i)), a && this.fire(new e1.Event("zoomstart", i)).fire(new e1.Event("zoom", i)).fire(new e1.Event("zoomend", i)), c && this.fire(new e1.Event("rotatestart", i)).fire(new e1.Event("rotate", i)).fire(new e1.Event("rotateend", i)), l && this.fire(new e1.Event("pitchstart", i)).fire(new e1.Event("pitch", i)).fire(new e1.Event("pitchend", i)), this.fire(new e1.Event("moveend", i)), this;
            }
            easeTo(t1, i) {
                this._stop(!1, t1.easeId), (!1 === (t1 = e1.extend({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e1.ease
                }, t1)).animate || !t1.essential && e1.exported.prefersReducedMotion) && (t1.duration = 0);
                const o = this.transform, r = this.getZoom(), n = this.getBearing(), s = this.getPitch(), a = this.getPadding(), l = "zoom" in t1 ? +t1.zoom : r, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, n) : n, h = "pitch" in t1 ? +t1.pitch : s, u = "padding" in t1 ? t1.padding : o.padding, _ = e1.pointGeometry.convert(t1.offset);
                let d, p, m;
                if ("globe" === o.projection.name) {
                    const i = e1.MercatorCoordinate.fromLngLat(o.center), r = _.rotate(-o.angle);
                    i.x += r.x / o.worldSize, i.y += r.y / o.worldSize;
                    const n = i.toLngLat(), s = e1.LngLat.convert(t1.center || n);
                    this._normalizeCenter(s), d = o.centerPoint.add(r), p = new e1.pointGeometry(i.x, i.y).mult(o.worldSize), m = new e1.pointGeometry(e1.mercatorXfromLng(s.lng), e1.mercatorYfromLat(s.lat)).mult(o.worldSize).sub(p);
                } else {
                    d = o.centerPoint.add(_);
                    const i = o.pointLocation(d), r = e1.LngLat.convert(t1.center || i);
                    this._normalizeCenter(r), p = o.project(i), m = o.project(r).sub(p);
                }
                const f = o.zoomScale(l - r);
                let g, v;
                t1.around && (g = e1.LngLat.convert(t1.around), v = o.locationPoint(g));
                const x = this._zooming || l !== r, y = this._rotating || n !== c, b = this._pitching || h !== s, w = !o.isPaddingEqual(u), T = (o)=>(T)=>{
                        if (x && (o.zoom = e1.number(r, l, T)), y && (o.bearing = e1.number(n, c, T)), b && (o.pitch = e1.number(s, h, T)), w && (o.interpolatePadding(a, u, T), d = o.centerPoint.add(_)), g) o.setLocationAtPoint(g, v);
                        else {
                            const e1 = o.zoomScale(o.zoom - r), t1 = l > r ? Math.min(2, f) : Math.max(.5, f), i = Math.pow(t1, 1 - T), n = o.unproject(p.add(m.mult(T * i)).mult(e1));
                            o.setLocationAtPoint(o.renderWorldCopies ? n.wrap() : n, d);
                        }
                        return t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(T, t1.duration, o);
                    return this._preloadTiles(e1), this;
                }
                const E = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = x, this._rotating = y, this._pitching = b, this._padding = w, this._easeId = t1.easeId, this._prepareEase(i, t1.noMoveStart, E), this._ease(T(o), (e1)=>{
                    o.recenterOnTerrain(), this._afterEase(i, e1);
                }, t1), this;
            }
            _prepareEase(t1, i, o = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", i || o.moving || this.fire(new e1.Event("movestart", t1)), this._zooming && !o.zooming && this.fire(new e1.Event("zoomstart", t1)), this._rotating && !o.rotating && this.fire(new e1.Event("rotatestart", t1)), this._pitching && !o.pitching && this.fire(new e1.Event("pitchstart", t1));
            }
            _fireMoveEvents(t1) {
                this.fire(new e1.Event("move", t1)), this._zooming && this.fire(new e1.Event("zoom", t1)), this._rotating && this.fire(new e1.Event("rotate", t1)), this._pitching && this.fire(new e1.Event("pitch", t1));
            }
            _afterEase(t1, i) {
                if (this._easeId && i && this._easeId === i) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const o = this._zooming, r = this._rotating, n = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new e1.Event("zoomend", t1)), r && this.fire(new e1.Event("rotateend", t1)), n && this.fire(new e1.Event("pitchend", t1)), this.fire(new e1.Event("moveend", t1));
            }
            flyTo(t1, i) {
                if (!t1.essential && e1.exported.prefersReducedMotion) {
                    const o = e1.pick(t1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(o, i);
                }
                this.stop(), t1 = e1.extend({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e1.ease
                }, t1);
                const o = this.transform, r = this.getZoom(), n = this.getBearing(), s = this.getPitch(), a = this.getPadding(), l = "zoom" in t1 ? e1.clamp(+t1.zoom, o.minZoom, o.maxZoom) : r, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, n) : n, h = "pitch" in t1 ? +t1.pitch : s, u = "padding" in t1 ? t1.padding : o.padding, _ = o.zoomScale(l - r), d = e1.pointGeometry.convert(t1.offset);
                let p = o.centerPoint.add(d);
                const m = o.pointLocation(p), f = e1.LngLat.convert(t1.center || m);
                this._normalizeCenter(f);
                const g = o.project(m), v = o.project(f).sub(g);
                let x = t1.curve;
                const y = Math.max(o.width, o.height), b = y / _, w = v.mag();
                if ("minZoom" in t1) {
                    const i = e1.clamp(Math.min(t1.minZoom, r, l), o.minZoom, o.maxZoom), n = y / o.zoomScale(i - r);
                    x = Math.sqrt(n / w * 2);
                }
                const T = x * x;
                function E(e1) {
                    const t1 = (b * b - y * y + (e1 ? -1 : 1) * T * T * w * w) / (2 * (e1 ? b : y) * T * w);
                    return Math.log(Math.sqrt(t1 * t1 + 1) - t1);
                }
                function C(e1) {
                    return (Math.exp(e1) - Math.exp(-e1)) / 2;
                }
                function M(e1) {
                    return (Math.exp(e1) + Math.exp(-e1)) / 2;
                }
                const I = E(0);
                let S = function(e1) {
                    return M(I) / M(I + x * e1);
                }, D = function(e1) {
                    var t1;
                    return y * ((M(I) * (C(t1 = I + x * e1) / M(t1)) - C(I)) / T) / w;
                }, L = (E(1) - I) / x;
                if (Math.abs(w) < 1e-6 || !isFinite(L)) {
                    if (Math.abs(y - b) < 1e-6) return this.easeTo(t1, i);
                    const e1 = b < y ? -1 : 1;
                    L = Math.abs(Math.log(b / y)) / x, D = function() {
                        return 0;
                    }, S = function(t1) {
                        return Math.exp(e1 * x * t1);
                    };
                }
                t1.duration = "duration" in t1 ? +t1.duration : 1e3 * L / ("screenSpeed" in t1 ? +t1.screenSpeed / x : +t1.speed), t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0);
                const A = n !== c, z = h !== s, P = !o.isPaddingEqual(u), R = (o)=>(_)=>{
                        const m = _ * L, x = 1 / S(m);
                        o.zoom = 1 === _ ? l : r + o.scaleZoom(x), A && (o.bearing = e1.number(n, c, _)), z && (o.pitch = e1.number(s, h, _)), P && (o.interpolatePadding(a, u, _), p = o.centerPoint.add(d));
                        const y = 1 === _ ? f : o.unproject(g.add(v.mult(D(m))).mult(x));
                        return o.setLocationAtPoint(o.renderWorldCopies ? y.wrap() : y, p), o._updateCameraOnTerrain(), t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(R, t1.duration, o);
                    return this._preloadTiles(e1), this;
                }
                return this._zooming = !0, this._rotating = A, this._pitching = z, this._padding = P, this._prepareEase(i, !1), this._ease(R(o), ()=>this._afterEase(i), t1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(e1, t1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const e1 = this._onEaseEnd;
                    this._onEaseEnd = void 0, e1.call(this, t1);
                }
                if (!e1) {
                    const e1 = this.handlers;
                    e1 && e1.stop(!1);
                }
                return this;
            }
            _ease(t1, i, o) {
                !1 === o.animate || 0 === o.duration ? (t1(1), i()) : (this._easeStart = e1.exported.now(), this._easeOptions = o, this._onEaseFrame = t1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const t1 = Math.min((e1.exported.now() - this._easeStart) / this._easeOptions.duration, 1), i = this._onEaseFrame;
                i && i(this._easeOptions.easing(t1)), t1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t1, i) {
                t1 = e1.wrap(t1, -180, 180);
                const o = Math.abs(t1 - i);
                return Math.abs(t1 - 360 - i) < o && (t1 -= 360), Math.abs(t1 + 360 - i) < o && (t1 += 360), t1;
            }
            _normalizeCenter(e1) {
                const t1 = this.transform;
                if (!t1.renderWorldCopies || t1.maxBounds) return;
                const i = e1.lng - t1.center.lng;
                e1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _emulate(e1, t1, i) {
                const o = Math.ceil(15 * t1 / 1e3), r = [], n = e1(i.clone());
                for(let e1 = 0; e1 <= o; e1++){
                    const t1 = n(e1 / o);
                    r.push(t1.clone());
                }
                return r;
            }
        }
        class Kr {
            constructor(t1 = {}){
                this.options = t1, e1.bindAll([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e1) {
                const t1 = this.options && this.options.compact;
                return this._map = e1, this._container = n("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = n("button", "mapboxgl-ctrl-attrib-button", this._container), n("span", "mapboxgl-ctrl-icon", this._compactButton).setAttribute("aria-hidden", "true"), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = n("div", "mapboxgl-ctrl-attrib-inner", this._container), this._innerContainer.setAttribute("role", "list"), t1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(e1, t1) {
                const i = this._map._getUIString(`AttributionControl.${t1}`);
                e1.setAttribute("aria-label", i), e1.removeAttribute("title"), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let t1 = this._editLink;
                t1 || (t1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const i = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || e1.config.ACCESS_TOKEN
                    }
                ];
                if (t1) {
                    const o = i.reduce((e1, t1, o)=>(t1.value && (e1 += `${t1.key}=${t1.value}${o < i.length - 1 ? "&" : ""}`), e1), "?");
                    t1.href = `${e1.config.FEEDBACK_URL}/${o}#${er(this._map, !0)}`, t1.rel = "noopener nofollow", this._setElementTitle(t1, "MapFeedback");
                }
            }
            _updateData(e1) {
                !e1 || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType && "style" !== e1.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e1 = [];
                if (this._map.style.stylesheet) {
                    const e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                const t1 = this._map.style._sourceCaches;
                for(const i in t1){
                    const o = t1[i];
                    if (o.used) {
                        const t1 = o.getSource();
                        t1.attribution && e1.indexOf(t1.attribution) < 0 && e1.push(t1.attribution);
                    }
                }
                e1.sort((e1, t1)=>e1.length - t1.length), e1 = e1.filter((t1, i)=>{
                    for(let o = i + 1; o < e1.length; o++)if (e1[o].indexOf(t1) >= 0) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = [
                    ...this.options.customAttribution,
                    ...e1
                ] : e1.unshift(this.options.customAttribution));
                const i = e1.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
        }
        class Jr {
            constructor(){
                e1.bindAll([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
            onAdd(e1) {
                this._map = e1, this._container = n("div", "mapboxgl-ctrl");
                const t1 = n("a", "mapboxgl-ctrl-logo");
                return t1.target = "_blank", t1.rel = "noopener nofollow", t1.href = "https://www.mapbox.com/", t1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e1) {
                e1 && "metadata" !== e1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e1 = this._map.style._sourceCaches;
                if (0 === Object.entries(e1).length) return !0;
                for(const t1 in e1){
                    const i = e1[t1].getSource();
                    if (i.hasOwnProperty("mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e1 = this._container.children;
                if (e1.length) {
                    const t1 = e1[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t1.classList.add("mapboxgl-compact") : t1.classList.remove("mapboxgl-compact");
                }
            }
        }
        class Qr {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e1) {
                const t1 = ++this._id;
                return this._queue.push({
                    callback: e1,
                    id: t1,
                    cancelled: !1
                }), t1;
            }
            remove(e1) {
                const t1 = this._currentlyRunning, i = t1 ? this._queue.concat(t1) : this._queue;
                for (const t1 of i)if (t1.id === e1) return void (t1.cancelled = !0);
            }
            run(e1 = 0) {
                const t1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t1)if (!i.cancelled && (i.callback(e1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        function en(t1, i, o) {
            if (t1 = new e1.LngLat(t1.lng, t1.lat), i) {
                const r = new e1.LngLat(t1.lng - 360, t1.lat), n = new e1.LngLat(t1.lng + 360, t1.lat), s = 360 * Math.ceil(Math.abs(t1.lng - o.center.lng) / 360), a = o.locationPoint(t1).distSqr(i), l = i.x < 0 || i.y < 0 || i.x > o.width || i.y > o.height;
                o.locationPoint(r).distSqr(i) < a && (l || Math.abs(r.lng - o.center.lng) < s) ? t1 = r : o.locationPoint(n).distSqr(i) < a && (l || Math.abs(n.lng - o.center.lng) < s) && (t1 = n);
            }
            for(; Math.abs(t1.lng - o.center.lng) > 180;){
                const e1 = o.locationPoint(t1);
                if (e1.x >= 0 && e1.y >= 0 && e1.x <= o.width && e1.y <= o.height) break;
                t1.lng > o.center.lng ? t1.lng -= 360 : t1.lng += 360;
            }
            return t1;
        }
        const tn = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        class on extends e1.Evented {
            constructor(t1, i){
                if (super(), (t1 instanceof e1.window.HTMLElement || i) && (t1 = e1.extend({
                    element: t1
                }, i)), e1.bindAll([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this), this._anchor = t1 && t1.anchor || "center", this._color = t1 && t1.color || "#3FB1CE", this._scale = t1 && t1.scale || 1, this._draggable = t1 && t1.draggable || !1, this._clickTolerance = t1 && t1.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = t1 && t1.rotation || 0, this._rotationAlignment = t1 && t1.rotationAlignment || "auto", this._pitchAlignment = t1 && t1.pitchAlignment && t1.pitchAlignment || "auto", this._updateMoving = ()=>this._update(!0), this._occludedOpacity = t1 && t1.occludedOpacity || .2, t1 && t1.element) this._element = t1.element, this._offset = e1.pointGeometry.convert(t1 && t1.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = n("div");
                    const i = 41, o = 27, r = s("svg", {
                        display: "block",
                        height: i * this._scale + "px",
                        width: o * this._scale + "px",
                        viewBox: `0 0 ${o} ${i}`
                    }, this._element), a = s("radialGradient", {
                        id: "shadowGradient"
                    }, s("defs", {}, r));
                    s("stop", {
                        offset: "10%",
                        "stop-opacity": .4
                    }, a), s("stop", {
                        offset: "100%",
                        "stop-opacity": .05
                    }, a), s("ellipse", {
                        cx: 13.5,
                        cy: 34.8,
                        rx: 10.5,
                        ry: 5.25,
                        fill: "url(#shadowGradient)"
                    }, r), s("path", {
                        fill: this._color,
                        d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                    }, r), s("path", {
                        opacity: .25,
                        d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                    }, r), s("circle", {
                        fill: "white",
                        cx: 13.5,
                        cy: 13.5,
                        r: 5.5
                    }, r), this._offset = e1.pointGeometry.convert(t1 && t1.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e1)=>{
                    e1.preventDefault();
                }), this._element.addEventListener("mousedown", (e1)=>{
                    e1.preventDefault();
                });
                const o = this._element.classList;
                for(const e1 in tn)o.remove(`mapboxgl-marker-anchor-${e1}`);
                o.add(`mapboxgl-marker-anchor-${this._anchor}`), this._popup = null;
            }
            addTo(e1) {
                return e1 === this._map || (this.remove(), this._map = e1, e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._updateMoving), e1.on("moveend", this._update), e1.on("remove", this._clearFadeTimer), e1._addMarker(this), this.setDraggable(this._draggable), this._update(), e1.on("click", this._onMapClick)), this;
            }
            remove() {
                const e1 = this._map;
                return e1 && (e1.off("click", this._onMapClick), e1.off("move", this._updateMoving), e1.off("moveend", this._update), e1.off("mousedown", this._addDragHandler), e1.off("touchstart", this._addDragHandler), e1.off("mouseup", this._onUp), e1.off("touchend", this._onUp), e1.off("mousemove", this._onMove), e1.off("touchmove", this._onMove), e1.off("remove", this._clearFadeTimer), e1._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t1) {
                return this._lngLat = e1.LngLat.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(e1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                    if (!("offset" in e1.options)) {
                        const t1 = 38.1, i = 13.5, o = Math.sqrt(Math.pow(i, 2) / 2);
                        e1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t1
                            ],
                            "bottom-left": [
                                o,
                                -1 * (t1 - i + o)
                            ],
                            "bottom-right": [
                                -o,
                                -1 * (t1 - i + o)
                            ],
                            left: [
                                i,
                                -1 * (t1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (t1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e1, e1._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e1) {
                const t1 = e1.code, i = e1.charCode || e1.keyCode;
                "Space" !== t1 && "Enter" !== t1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e1) {
                const t1 = e1.originalEvent.target, i = this._element;
                this._popup && (t1 === i || i.contains(t1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e1 = this._popup;
                return e1 ? (e1.isOpen() ? (e1.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e1.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e1 = this._map, t1 = this._pos;
                if (!e1 || !t1) return !1;
                const i = e1.unproject(t1), o = e1.getFreeCameraOptions();
                if (!o.position) return !1;
                const r = o.position.toLngLat();
                return r.distanceTo(i) < .9 * r.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const t1 = this._map;
                if (!t1) return;
                const i = this._pos;
                if (!i || i.x < 0 || i.x > t1.transform.width || i.y < 0 || i.y > t1.transform.height) return void this._clearFadeTimer();
                const o = t1.unproject(i);
                let r;
                t1._showingGlobe() && e1.isLngLatBehindGlobe(t1.transform, this._lngLat) ? r = 0 : (r = 1 - t1._queryFogOpacity(o), t1.transform._terrainEnabled() && t1.getTerrain() && this._behindTerrain() && (r *= this._occludedOpacity)), this._element.style.opacity = `${r}`, this._element.style.pointerEvents = r > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(r), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e1 = this._pos;
                if (!e1 || !this._map) return;
                const t1 = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e1.x}px,${e1.y}px)\n            ${tn[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t1.x}px,${t1.y}px)\n        `;
            }
            _calculateXYTransform() {
                const t1 = this._pos, i = this._map, o = this.getPitchAlignment();
                if (!i || !t1 || "map" !== o) return "";
                if (!i._showingGlobe()) {
                    const e1 = i.getPitch();
                    return e1 ? `rotateX(${e1}deg)` : "";
                }
                const r = e1.radToDeg(e1.globeTiltAtLngLat(i.transform, this._lngLat)), n = t1.sub(e1.globeCenterToScreenPoint(i.transform)), s = Math.abs(n.x) + Math.abs(n.y);
                if (0 === s) return "";
                const a = r / s;
                return `rotateX(${-n.y * a}deg) rotateY(${n.x * a}deg)`;
            }
            _calculateZTransform() {
                const t1 = this._pos, i = this._map;
                if (!i || !t1) return "";
                let o = 0;
                const r = this.getRotationAlignment();
                if ("map" === r) {
                    if (i._showingGlobe()) {
                        const t1 = i.project(new e1.LngLat(this._lngLat.lng, this._lngLat.lat + .001)), r = i.project(new e1.LngLat(this._lngLat.lng, this._lngLat.lat - .001)).sub(t1);
                        o = e1.radToDeg(Math.atan2(r.y, r.x)) - 90;
                    } else o = -i.getBearing();
                } else if ("horizon" === r) {
                    const r = e1.smoothstep(4, 6, i.getZoom()), n = e1.globeCenterToScreenPoint(i.transform);
                    n.y += r * i.transform.height;
                    const s = t1.sub(n), a = e1.radToDeg(Math.atan2(s.y, s.x));
                    o = (a > 90 ? a - 270 : a + 90) * (1 - r);
                }
                return o += this._rotation, o ? `rotateZ(${o}deg)` : "";
            }
            _update(t1) {
                e1.window.cancelAnimationFrame(this._updateFrameId);
                const i = this._map;
                i && (i.transform.renderWorldCopies && (this._lngLat = en(this._lngLat, this._pos, i.transform)), this._pos = i.project(this._lngLat), !0 === t1 ? this._updateFrameId = e1.window.requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), i._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (i._showingGlobe() || i.getTerrain() || i.getFog()) && !this._fadeTimer && (this._fadeTimer = setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t1) {
                return this._offset = e1.pointGeometry.convert(t1), this._update(), this;
            }
            _onMove(t1) {
                const i = this._map;
                if (!i) return;
                const o = this._pointerdownPos, r = this._positionDelta;
                if (o && r) {
                    if (!this._isDragging) {
                        const e1 = this._clickTolerance || i._clickTolerance;
                        if (t1.point.dist(o) < e1) return;
                        this._isDragging = !0;
                    }
                    this._pos = t1.point.sub(r), this._lngLat = i.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e1.Event("dragstart"))), this.fire(new e1.Event("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const t1 = this._map;
                t1 && (t1.off("mousemove", this._onMove), t1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e1.Event("dragend")), this._state = "inactive";
            }
            _addDragHandler(e1) {
                const t1 = this._map, i = this._pos;
                t1 && i && this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(i), this._pointerdownPos = e1.point, this._state = "pending", t1.on("mousemove", this._onMove), t1.on("touchmove", this._onMove), t1.once("mouseup", this._onUp), t1.once("touchend", this._onUp));
            }
            setDraggable(e1) {
                this._draggable = !!e1;
                const t1 = this._map;
                return t1 && (e1 ? (t1.on("mousedown", this._addDragHandler), t1.on("touchstart", this._addDragHandler)) : (t1.off("mousedown", this._addDragHandler), t1.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e1) {
                return this._rotation = e1 || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e1) {
                return this._rotationAlignment = e1 || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e1) {
                return this._pitchAlignment = e1 || "auto", this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e1) {
                return this._occludedOpacity = e1 || .2, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
        }
        const rn = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, nn = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function sn(t1 = new e1.pointGeometry(0, 0), i = "bottom") {
            if ("number" == typeof t1) {
                const o = Math.round(Math.sqrt(.5 * Math.pow(t1, 2)));
                switch(i){
                    case "top":
                        return new e1.pointGeometry(0, t1);
                    case "top-left":
                        return new e1.pointGeometry(o, o);
                    case "top-right":
                        return new e1.pointGeometry(-o, o);
                    case "bottom":
                        return new e1.pointGeometry(0, -t1);
                    case "bottom-left":
                        return new e1.pointGeometry(o, -o);
                    case "bottom-right":
                        return new e1.pointGeometry(-o, -o);
                    case "left":
                        return new e1.pointGeometry(t1, 0);
                    case "right":
                        return new e1.pointGeometry(-t1, 0);
                }
                return new e1.pointGeometry(0, 0);
            }
            return t1 instanceof e1.pointGeometry || Array.isArray(t1) ? e1.pointGeometry.convert(t1) : e1.pointGeometry.convert(t1[i] || [
                0,
                0
            ]);
        }
        class an {
            constructor(e1){
                this.jumpTo(e1);
            }
            getValue(t1) {
                if (t1 <= this._startTime) return this._start;
                if (t1 >= this._endTime) return this._end;
                const i = e1.easeCubicInOut((t1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - i) + this._end * i;
            }
            isEasing(e1) {
                return e1 >= this._startTime && e1 <= this._endTime;
            }
            jumpTo(e1) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e1, this._end = e1;
            }
            easeTo(e1, t1, i) {
                this._start = this.getValue(t1), this._end = e1, this._startTime = t1, this._endTime = t1 + i;
            }
        }
        const ln = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        }, cn = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            optimizeForTerrain: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            crossSourceCollisions: !0
        }, hn = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class un {
            constructor(t1, i, o = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new wr({
                    clickTolerance: t1.dragRotate._mouseRotate._clickTolerance
                }), this.map = t1, o && (this.mousePitch = new Tr({
                    clickTolerance: t1.dragRotate._mousePitch._clickTolerance
                })), e1.bindAll([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
            }
            down(e1, t1) {
                this.mouseRotate.mousedown(e1, t1), this.mousePitch && this.mousePitch.mousedown(e1, t1), h();
            }
            move(e1, t1) {
                const i = this.map, o = this.mouseRotate.mousemoveWindow(e1, t1), r = o && o.bearingDelta;
                if (r && i.setBearing(i.getBearing() + r), this.mousePitch) {
                    const o = this.mousePitch.mousemoveWindow(e1, t1), r = o && o.pitchDelta;
                    r && i.setPitch(i.getPitch() + r);
                }
            }
            off() {
                const e1 = this.element;
                e1.removeEventListener("mousedown", this.mousedown), e1.removeEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), e1.removeEventListener("touchmove", this.touchmove), e1.removeEventListener("touchend", this.touchend), e1.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                u(), e1.window.removeEventListener("mousemove", this.mousemove), e1.window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(t1) {
                this.down(e1.extend({}, t1, {
                    ctrlKey: !0,
                    preventDefault: ()=>t1.preventDefault()
                }), p(this.element, t1)), e1.window.addEventListener("mousemove", this.mousemove), e1.window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e1) {
                this.move(e1, p(this.element, e1));
            }
            mouseup(e1) {
                this.mouseRotate.mouseupWindow(e1), this.mousePitch && this.mousePitch.mouseupWindow(e1), this.offTemp();
            }
            touchstart(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = m(this.element, e1.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }, this._startPos));
            }
            touchmove(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._lastPos = m(this.element, e1.targetTouches)[0], this.move({
                    preventDefault: ()=>e1.preventDefault()
                }, this._lastPos));
            }
            touchend(e1) {
                0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
        }
        const _n = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1
        }, dn = {
            maxWidth: 100,
            unit: "metric"
        };
        function pn(e1, t1, i) {
            const o = mn(t1), r = o / t1, n = {
                kilometer: "km",
                meter: "m",
                mile: "mi",
                foot: "ft",
                "nautical-mile": "nm"
            }[i];
            this._map._requestDomTask(()=>{
                this._container.style.width = e1 * r + "px", this._container.innerHTML = `${o}&nbsp;${n}`;
            });
        }
        function mn(e1) {
            const t1 = Math.pow(10, `${Math.floor(e1)}`.length - 1);
            let i = e1 / t1;
            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
                const t1 = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                return Math.round(e1 * t1) / t1;
            }(i), t1 * i;
        }
        const fn = {
            version: e1.version,
            supported: i,
            setRTLTextPlugin: e1.setRTLTextPlugin,
            getRTLTextPluginStatus: e1.getRTLTextPluginStatus,
            Map: class extends Yr {
                constructor(t1){
                    if (e1.LivePerformanceUtils.mark(e1.PerformanceMarkers.create), null != (t1 = e1.extend({}, cn, t1)).minZoom && null != t1.maxZoom && t1.minZoom > t1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != t1.minPitch && null != t1.maxPitch && t1.minPitch > t1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != t1.minPitch && t1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != t1.maxPitch && t1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1.antialias && e1.isSafariWithAntialiasingBug(e1.window) && (t1.antialias = !1, e1.warnOnce("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new Ko(t1.minZoom, t1.maxZoom, t1.minPitch, t1.maxPitch, t1.renderWorldCopies), t1), this._interactive = t1.interactive, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t1.preserveDrawingBuffer, this._antialias = t1.antialias, this._useWebGL2 = t1.useWebGL2, this._trackResize = t1.trackResize, this._bearingSnap = t1.bearingSnap, this._refreshExpiredTiles = t1.refreshExpiredTiles, this._fadeDuration = t1.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = t1.crossSourceCollisions, this._collectResourceTiming = t1.collectResourceTiming, this._optimizeForTerrain = t1.optimizeForTerrain, this._language = this._parseLanguage(t1.language), this._worldview = t1.worldview, this._renderTaskQueue = new Qr, this._domRenderTaskQueue = new Qr, this._controls = [], this._markers = [], this._popups = [], this._mapId = e1.uniqueId(), this._locale = e1.extend({}, ln, t1.locale), this._clickTolerance = t1.clickTolerance, this._cooperativeGestures = t1.cooperativeGestures, this._performanceMetricsCollection = t1.performanceMetricsCollection, this._containerWidth = 0, this._containerHeight = 0, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new an(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._requestManager = new e1.RequestManager(t1.transformRequest, t1.accessToken, t1.testMode), this._silenceAuthErrors = !!t1.testMode, "string" == typeof t1.container) {
                        if (this._container = e1.window.document.getElementById(t1.container), !this._container) throw new Error(`Container '${t1.container}' not found.`);
                    } else {
                        if (!(t1.container instanceof e1.window.HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = t1.container;
                    }
                    if (this._container.childNodes.length > 0 && e1.warnOnce("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t1.maxBounds && this.setMaxBounds(t1.maxBounds), e1.bindAll([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), void 0 !== e1.window && (e1.window.addEventListener("online", this._onWindowOnline, !1), e1.window.addEventListener("resize", this._onWindowResize, !1), e1.window.addEventListener("orientationchange", this._onWindowResize, !1), e1.window.addEventListener("webkitfullscreenchange", this._onWindowResize, !1), e1.window.addEventListener("visibilitychange", this._onVisibilityChange, !1)), this.handlers = new $r(this, t1), this._localFontFamily = t1.localFontFamily, this._localIdeographFontFamily = t1.localIdeographFontFamily, t1.style && this.setStyle(t1.style, {
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }), t1.projection && this.setProjection(t1.projection), this._hash = t1.hash && new Qo("string" == typeof t1.hash && t1.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                        center: t1.center,
                        zoom: t1.zoom,
                        bearing: t1.bearing,
                        pitch: t1.pitch
                    }), t1.bounds && (this.resize(), this.fitBounds(t1.bounds, e1.extend({}, t1.fitBoundsOptions, {
                        duration: 0
                    })))), this.resize(), t1.attributionControl && this.addControl(new Kr({
                        customAttribution: t1.customAttribution
                    })), this._logoControl = new Jr, this.addControl(this._logoControl, t1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                    }), this.on("data", (t1)=>{
                        this._update("style" === t1.dataType), this.fire(new e1.Event(`${t1.dataType}data`, t1));
                    }), this.on("dataloading", (t1)=>{
                        this.fire(new e1.Event(`${t1.dataType}dataloading`, t1));
                    });
                }
                _getMapId() {
                    return this._mapId;
                }
                addControl(t1, i) {
                    if (void 0 === i && (i = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e1.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const o = t1.onAdd(this);
                    this._controls.push(t1);
                    const r = this._controlPositions[i];
                    return -1 !== i.indexOf("bottom") ? r.insertBefore(o, r.firstChild) : r.appendChild(o), this;
                }
                removeControl(t1) {
                    if (!t1 || !t1.onRemove) return this.fire(new e1.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(t1);
                    return i > -1 && this._controls.splice(i, 1), t1.onRemove(this), this;
                }
                hasControl(e1) {
                    return this._controls.indexOf(e1) > -1;
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(t1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const i = !this._moving;
                    return i && this.fire(new e1.Event("movestart", t1)).fire(new e1.Event("move", t1)), this.fire(new e1.Event("resize", t1)), i && this.fire(new e1.Event("moveend", t1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(e1.LngLatBounds.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = null == t1 ? -2 : t1) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 ? this.setZoom(t1) : this.fire(new e1.Event("zoomstart")).fire(new e1.Event("zoom")).fire(new e1.Event("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = null == t1 ? 22 : t1) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 ? this.setZoom(t1) : this.fire(new e1.Event("zoomstart")).fire(new e1.Event("zoom")).fire(new e1.Event("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = null == t1 ? 0 : t1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 ? this.setPitch(t1) : this.fire(new e1.Event("pitchstart")).fire(new e1.Event("pitch")).fire(new e1.Event("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = null == t1 ? 85 : t1) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 ? this.setPitch(t1) : this.fire(new e1.Event("pitchstart")).fire(new e1.Event("pitch")).fire(new e1.Event("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e1) {
                    return this.transform.renderWorldCopies = e1, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(t1) {
                    return "auto" === t1 ? e1.window.navigator.language : Array.isArray(t1) ? 0 === t1.length ? void 0 : t1.map((t1)=>"auto" === t1 ? e1.window.navigator.language : t1) : t1;
                }
                setLanguage(e1) {
                    const t1 = this._parseLanguage(e1);
                    if (!this.style || t1 === this._language) return this;
                    this._language = t1, this.style._reloadSources();
                    for (const e1 of this._controls)e1._setLanguage && e1._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e1) {
                    return this.style && e1 !== this._worldview ? (this._worldview = e1, this.style._reloadSources(), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e1) {
                    return this._lazyInitEmptyStyle(), e1 ? "string" == typeof e1 && (e1 = {
                        name: e1
                    }) : e1 = null, this._useExplicitProjection = !!e1, this._prioritizeAndUpdateProjection(e1, this.style.stylesheet ? this.style.stylesheet.projection : null);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const t1 = this.transform, i = t1.projection.name;
                    let o;
                    "globe" === i && t1.zoom >= e1.GLOBE_ZOOM_THRESHOLD_MAX ? (t1.setMercatorFromTransition(), o = !0) : "mercator" === i && t1.zoom < e1.GLOBE_ZOOM_THRESHOLD_MAX && (t1.setProjection({
                        name: "globe"
                    }), o = !0), o && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
                }
                _prioritizeAndUpdateProjection(e1, t1) {
                    return this._updateProjection(e1 || t1 || {
                        name: "mercator"
                    });
                }
                _updateProjection(t1) {
                    let i;
                    if (i = "globe" === t1.name && this.transform.zoom >= e1.GLOBE_ZOOM_THRESHOLD_MAX ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t1), this.style.applyProjectionUpdate(), i) {
                        this.painter.clearBackgroundTiles();
                        for(const e1 in this.style._sourceCaches)this.style._sourceCaches[e1].clearTiles();
                        this._update(!0), this._forceMarkerAndPopupUpdate(!0);
                    }
                    return this;
                }
                project(t1) {
                    return this.transform.locationPoint3D(e1.LngLat.convert(t1));
                }
                unproject(t1) {
                    return this.transform.pointLocation3D(e1.pointGeometry.convert(t1));
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e1, t1, i) {
                    if ("mouseenter" === e1 || "mouseover" === e1) {
                        let o = !1;
                        const r = (r)=>{
                            const n = t1.filter((e1)=>this.getLayer(e1)), s = n.length ? this.queryRenderedFeatures(r.point, {
                                layers: n
                            }) : [];
                            s.length ? o || (o = !0, i.call(this, new cr(e1, this, r.originalEvent, {
                                features: s
                            }))) : o = !1;
                        }, n = ()=>{
                            o = !1;
                        };
                        return {
                            layers: new Set(t1),
                            listener: i,
                            delegates: {
                                mousemove: r,
                                mouseout: n
                            }
                        };
                    }
                    if ("mouseleave" === e1 || "mouseout" === e1) {
                        let o = !1;
                        const r = (r)=>{
                            const n = t1.filter((e1)=>this.getLayer(e1));
                            (n.length ? this.queryRenderedFeatures(r.point, {
                                layers: n
                            }) : []).length ? o = !0 : o && (o = !1, i.call(this, new cr(e1, this, r.originalEvent)));
                        }, n = (t1)=>{
                            o && (o = !1, i.call(this, new cr(e1, this, t1.originalEvent)));
                        };
                        return {
                            layers: new Set(t1),
                            listener: i,
                            delegates: {
                                mousemove: r,
                                mouseout: n
                            }
                        };
                    }
                    {
                        const o = (e1)=>{
                            const o = t1.filter((e1)=>this.getLayer(e1)), r = o.length ? this.queryRenderedFeatures(e1.point, {
                                layers: o
                            }) : [];
                            r.length && (e1.features = r, i.call(this, e1), delete e1.features);
                        };
                        return {
                            layers: new Set(t1),
                            listener: i,
                            delegates: {
                                [e1]: o
                            }
                        };
                    }
                }
                on(e1, t1, i) {
                    if (void 0 === i) return super.on(e1, t1);
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    const o = this._createDelegatedListener(e1, t1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e1] = this._delegatedListeners[e1] || [], this._delegatedListeners[e1].push(o);
                    for(const e1 in o.delegates)this.on(e1, o.delegates[e1]);
                    return this;
                }
                once(e1, t1, i) {
                    if (void 0 === i) return super.once(e1, t1);
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    const o = this._createDelegatedListener(e1, t1, i);
                    for(const e1 in o.delegates)this.once(e1, o.delegates[e1]);
                    return this;
                }
                off(e1, t1, i) {
                    if (void 0 === i) return super.off(e1, t1);
                    t1 = new Set(Array.isArray(t1) ? t1 : [
                        t1
                    ]);
                    const o = (e1, t1)=>{
                        if (e1.size !== t1.size) return !1;
                        for (const i of e1)if (!t1.has(i)) return !1;
                        return !0;
                    }, r = this._delegatedListeners ? this._delegatedListeners[e1] : void 0;
                    return r && ((e1)=>{
                        for(let r = 0; r < e1.length; r++){
                            const n = e1[r];
                            if (n.listener === i && o(n.layers, t1)) {
                                for(const e1 in n.delegates)this.off(e1, n.delegates[e1]);
                                return e1.splice(r, 1), this;
                            }
                        }
                    })(r), this;
                }
                queryRenderedFeatures(t1, i) {
                    return this.style ? (void 0 !== i || void 0 === t1 || t1 instanceof e1.pointGeometry || Array.isArray(t1) || (i = t1, t1 = void 0), this.style.queryRenderedFeatures(t1 = t1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], i = i || {}, this.transform)) : [];
                }
                querySourceFeatures(e1, t1) {
                    return this.style.querySourceFeatures(e1, t1);
                }
                setStyle(t1, i) {
                    return !1 !== (i = e1.extend({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily
                    }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && i.localFontFamily === this._localFontFamily && this.style && t1 ? (this._diffStyle(t1, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._updateStyle(t1, i));
                }
                _getUIString(e1) {
                    const t1 = this._locale[e1];
                    if (null == t1) throw new Error(`Missing UI string '${e1}'`);
                    return t1;
                }
                _updateStyle(e1, t1) {
                    return this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), e1 && (this.style = new Qt(this, t1 || {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), "string" == typeof e1 ? this.style.loadURL(e1) : this.style.loadJSON(e1)), this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new Qt(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                _diffStyle(t1, i) {
                    if ("string" == typeof t1) {
                        const o = this._requestManager.normalizeStyleURL(t1), r = this._requestManager.transformRequest(o, e1.ResourceType.Style);
                        e1.getJSON(r, (t1, o)=>{
                            t1 ? this.fire(new e1.ErrorEvent(t1)) : o && this._updateDiff(o, i);
                        });
                    } else "object" == typeof t1 && this._updateDiff(t1, i);
                }
                _updateDiff(t1, i) {
                    try {
                        this.style.setState(t1) && this._update(!0);
                    } catch (o) {
                        e1.warnOnce(`Unable to perform style diff: ${o.message || o.error || o}.  Rebuilding the style from scratch.`), this._updateStyle(t1, i);
                    }
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (e1.warnOnce("There is no style added to the map."), !1);
                }
                addSource(e1, t1) {
                    return this._lazyInitEmptyStyle(), this.style.addSource(e1, t1), this._update(!0);
                }
                isSourceLoaded(e1) {
                    return !!this.style && this.style._isSourceCacheLoaded(e1);
                }
                areTilesLoaded() {
                    const e1 = this.style && this.style._sourceCaches;
                    for(const t1 in e1){
                        const i = e1[t1]._tiles;
                        for(const e1 in i){
                            const t1 = i[e1];
                            if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                        }
                    }
                    return !0;
                }
                addSourceType(e1, t1, i) {
                    this._lazyInitEmptyStyle(), this.style.addSourceType(e1, t1, i);
                }
                removeSource(e1) {
                    return this.style.removeSource(e1), this._updateTerrain(), this._update(!0);
                }
                getSource(e1) {
                    return this.style.getSource(e1);
                }
                addImage(t1, i, { pixelRatio: o = 1, sdf: r = !1, stretchX: n, stretchY: s, content: a } = {}) {
                    if (this._lazyInitEmptyStyle(), i instanceof e1.window.HTMLImageElement || e1.window.ImageBitmap && i instanceof e1.window.ImageBitmap) {
                        const { width: l, height: c, data: h } = e1.exported.getImageData(i);
                        this.style.addImage(t1, {
                            data: new e1.RGBAImage({
                                width: l,
                                height: c
                            }, h),
                            pixelRatio: o,
                            stretchX: n,
                            stretchY: s,
                            content: a,
                            sdf: r,
                            version: 0
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new e1.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: l, height: c } = i, h = i;
                        this.style.addImage(t1, {
                            data: new e1.RGBAImage({
                                width: l,
                                height: c
                            }, new Uint8Array(h.data)),
                            pixelRatio: o,
                            stretchX: n,
                            stretchY: s,
                            content: a,
                            sdf: r,
                            version: 0,
                            userImage: h
                        }), h.onAdd && h.onAdd(this, t1);
                    }
                }
                updateImage(t1, i) {
                    const o = this.style.getImage(t1);
                    if (!o) return void this.fire(new e1.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const r = i instanceof e1.window.HTMLImageElement || e1.window.ImageBitmap && i instanceof e1.window.ImageBitmap ? e1.exported.getImageData(i) : i, { width: n, height: s } = r;
                    void 0 !== n && void 0 !== s ? n === o.data.width && s === o.data.height ? (o.data.replace(r.data, !(i instanceof e1.window.HTMLImageElement || e1.window.ImageBitmap && i instanceof e1.window.ImageBitmap)), this.style.updateImage(t1, o)) : this.fire(new e1.ErrorEvent(new Error(`The width and height of the updated image (${n}, ${s})\n                must be that same as the previous version of the image\n                (${o.data.width}, ${o.data.height})`))) : this.fire(new e1.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                }
                hasImage(t1) {
                    return t1 ? !!this.style.getImage(t1) : (this.fire(new e1.ErrorEvent(new Error("Missing required image id"))), !1);
                }
                removeImage(e1) {
                    this.style.removeImage(e1);
                }
                loadImage(t1, i) {
                    e1.getImage(this._requestManager.transformRequest(t1, e1.ResourceType.Image), (t1, o)=>{
                        i(t1, o instanceof e1.window.HTMLImageElement ? e1.exported.getImageData(o) : o);
                    });
                }
                listImages() {
                    return this.style.listImages();
                }
                addLayer(e1, t1) {
                    return this._lazyInitEmptyStyle(), this.style.addLayer(e1, t1), this._update(!0);
                }
                moveLayer(e1, t1) {
                    return this.style.moveLayer(e1, t1), this._update(!0);
                }
                removeLayer(e1) {
                    return this.style.removeLayer(e1), this._update(!0);
                }
                getLayer(e1) {
                    return this.style.getLayer(e1);
                }
                setLayerZoomRange(e1, t1, i) {
                    return this.style.setLayerZoomRange(e1, t1, i), this._update(!0);
                }
                setFilter(e1, t1, i = {}) {
                    return this.style.setFilter(e1, t1, i), this._update(!0);
                }
                getFilter(e1) {
                    return this.style.getFilter(e1);
                }
                setPaintProperty(e1, t1, i, o = {}) {
                    return this.style.setPaintProperty(e1, t1, i, o), this._update(!0);
                }
                getPaintProperty(e1, t1) {
                    return this.style.getPaintProperty(e1, t1);
                }
                setLayoutProperty(e1, t1, i, o = {}) {
                    return this.style.setLayoutProperty(e1, t1, i, o), this._update(!0);
                }
                getLayoutProperty(e1, t1) {
                    return this.style.getLayoutProperty(e1, t1);
                }
                setLight(e1, t1 = {}) {
                    return this._lazyInitEmptyStyle(), this.style.setLight(e1, t1), this._update(!0);
                }
                getLight() {
                    return this.style.getLight();
                }
                setTerrain(e1) {
                    return this._lazyInitEmptyStyle(), !e1 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e1), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e1), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                _queryFogOpacity(t1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e1.LngLat.convert(t1), this.transform) : 0;
                }
                setFeatureState(e1, t1) {
                    return this.style.setFeatureState(e1, t1), this._update();
                }
                removeFeatureState(e1, t1) {
                    return this.style.removeFeatureState(e1, t1), this._update();
                }
                getFeatureState(e1) {
                    return this.style.getFeatureState(e1);
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const t1 = this._container.getBoundingClientRect().width || 400, i = this._container.getBoundingClientRect().height || 300;
                    let o, r, n, s = this._container;
                    for(; s && (!r || !n);){
                        const t1 = e1.window.getComputedStyle(s).transform;
                        t1 && "none" !== t1 && (o = t1.match(/matrix.*\((.+)\)/)[1].split(", "), o[0] && "0" !== o[0] && "1" !== o[0] && (r = o[0]), o[3] && "0" !== o[3] && "1" !== o[3] && (n = o[3])), s = s.parentElement;
                    }
                    this._containerWidth = r ? Math.abs(t1 / r) : t1, this._containerHeight = n ? Math.abs(i / n) : i;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== e1.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e1.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e1 = this._container;
                    e1.classList.add("mapboxgl-map"), (this._missingCSSCanary = n("div", "mapboxgl-canary", e1)).style.visibility = "hidden", this._detectMissingCSS();
                    const t1 = this._canvasContainer = n("div", "mapboxgl-canvas-container", e1);
                    this._interactive && t1.classList.add("mapboxgl-interactive"), this._canvas = n("canvas", "mapboxgl-canvas", t1), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = n("div", "mapboxgl-control-container", e1), o = this._controlPositions = {};
                    [
                        "top-left",
                        "top-right",
                        "bottom-left",
                        "bottom-right"
                    ].forEach((e1)=>{
                        o[e1] = n("div", `mapboxgl-ctrl-${e1}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(t1, i) {
                    const o = e1.exported.devicePixelRatio || 1;
                    this._canvas.width = o * Math.ceil(t1), this._canvas.height = o * Math.ceil(i), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${i}px`;
                }
                _addMarker(e1) {
                    this._markers.push(e1);
                }
                _removeMarker(e1) {
                    const t1 = this._markers.indexOf(e1);
                    -1 !== t1 && this._markers.splice(t1, 1);
                }
                _addPopup(e1) {
                    this._popups.push(e1);
                }
                _removePopup(e1) {
                    const t1 = this._popups.indexOf(e1);
                    -1 !== t1 && this._popups.splice(t1, 1);
                }
                _setupPainter() {
                    const t1 = e1.extend({}, i.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), o = this._useWebGL2 && this._canvas.getContext("webgl2", t1), r = o || this._canvas.getContext("webgl", t1) || this._canvas.getContext("experimental-webgl", t1);
                    r ? (this._useWebGL2 && !o && e1.warnOnce("Failed to create WebGL 2 context. Using WebGL 1."), e1.storeAuthState(r, !0), this.painter = new Fo(r, this.transform, !!o), this.on("data", (e1)=>{
                        "source" === e1.dataType && this.painter.setTileLoadedFlag(!0);
                    }), e1.exported$1.testSupport(r)) : this.fire(new e1.ErrorEvent(new Error("Failed to initialize WebGL")));
                }
                _contextLost(t1) {
                    t1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e1.Event("webglcontextlost", {
                        originalEvent: t1
                    }));
                }
                _contextRestored(t1) {
                    this._setupPainter(), this.resize(), this._update(), this.fire(new e1.Event("webglcontextrestored", {
                        originalEvent: t1
                    }));
                }
                _onMapScroll(e1) {
                    if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                _update(e1) {
                    return this.style ? (this._styleDirty = this._styleDirty || e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e1) {
                    return this._update(), this._renderTaskQueue.add(e1);
                }
                _cancelRenderFrame(e1) {
                    this._renderTaskQueue.remove(e1);
                }
                _requestDomTask(e1) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e1() : this._domRenderTaskQueue.add(e1);
                }
                _render(t1) {
                    let i;
                    const o = this.painter.context.extTimerQuery, r = e1.exported.now();
                    if (this.listens("gpu-timing-frame") && (i = o.createQueryEXT(), o.beginQueryEXT(o.TIME_ELAPSED_EXT, i)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], e1.window.performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], e1.window.performance.now())), this._renderTaskQueue.run(t1), this._domRenderTaskQueue.run(t1), this._removed) return;
                    this._updateProjectionTransition();
                    const n = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const t1 = this.transform.zoom, i = this.transform.pitch, o = e1.exported.now(), r = new e1.EvaluationParameters(t1, {
                            now: o,
                            fadeDuration: n,
                            pitch: i,
                            transition: this.style.getTransition()
                        });
                        this.style.update(r);
                    }
                    this.style && this.style.fog && this.style.fog.hasTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let s = !1;
                    if (this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), s = this._updateAverageElevation(r), this.style._updateSources(this.transform), this._forceMarkerAndPopupUpdate()) : s = this._updateAverageElevation(r), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, n, this._crossSourceCollisions), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showTerrainWireframe: this.showTerrainWireframe,
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: n,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming
                    }), this.fire(new e1.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new e1.Event("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), i) {
                        const t1 = e1.exported.now() - r;
                        o.endQueryEXT(o.TIME_ELAPSED_EXT, i), setTimeout(()=>{
                            const n = o.getQueryObjectEXT(i, o.QUERY_RESULT_EXT) / 1e6;
                            o.deleteQueryEXT(i), this.fire(new e1.Event("gpu-timing-frame", {
                                cpuTime: t1,
                                gpuTime: n
                            })), e1.window.performance.mark("frame-gpu", {
                                startTime: r,
                                detail: {
                                    gpuTime: n
                                }
                            });
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const t1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(t1);
                            this.fire(new e1.Event("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const t1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimeDeferredRender(t1);
                            this.fire(new e1.Event("gpu-timing-deferred-render", {
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    const a = this._sourcesDirty || this._styleDirty || this._placementDirty || s;
                    if (a || this._repaint) this.triggerRepaint();
                    else {
                        const t1 = !this.isMoving() && this.loaded();
                        if (t1 && (s = this._updateAverageElevation(r, !0)), s) this.triggerRepaint();
                        else if (this._triggerFrame(!1), t1 && (this.fire(new e1.Event("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                            const t1 = this._calculateSpeedIndex();
                            this.fire(new e1.Event("speedindexcompleted", {
                                speedIndex: t1
                            })), this.speedIndexTiming = !1;
                        }
                    }
                    !this._loaded || this._fullyLoaded || a || (this._fullyLoaded = !0, e1.LivePerformanceUtils.mark(e1.PerformanceMarkers.fullLoad), this._performanceMetricsCollection && e1.postPerformanceEvent(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: !!this.painter.style.getTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e1) {
                    for (const t1 of this._markers)e1 && !this.getRenderWorldCopies() && (t1._lngLat = t1._lngLat.wrap()), t1._update();
                    for (const t1 of this._popups)!e1 || this.getRenderWorldCopies() || t1._trackPointer || (t1._lngLat = t1._lngLat.wrap()), t1._update();
                }
                _updateAverageElevation(e1, t1 = !1) {
                    const i = (e1)=>(this.transform.averageElevation = e1, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    if ((t1 || e1 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e1)) {
                        const t1 = this.transform.averageElevation;
                        let o = this.transform.sampleAverageElevation(), r = !1;
                        this.transform.elevation && (r = this.transform.elevation.exaggeration() !== this._averageElevationExaggeration, this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(o) ? o = 0 : this._averageElevationLastSampledAt = e1;
                        const n = Math.abs(t1 - o);
                        if (n > 1) {
                            if (this._isInitialLoad || r) return this._averageElevation.jumpTo(o), i(o);
                            this._averageElevation.easeTo(o, e1, 300);
                        } else if (n > 1e-4) return this._averageElevation.jumpTo(o), i(o);
                    }
                    return !!this._averageElevation.isEasing(e1) && i(this._averageElevation.getValue(e1));
                }
                _authenticate() {
                    e1.getMapSessionAPI(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t1)=>{
                        if (t1 && (t1.message === e1.AUTH_ERR_MSG || 401 === t1.status)) {
                            const t1 = this.painter.context.gl;
                            e1.storeAuthState(t1, !1), this._logoControl instanceof Jr && this._logoControl._updateLogo(), t1 && t1.clear(t1.DEPTH_BUFFER_BIT | t1.COLOR_BUFFER_BIT | t1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e1.ErrorEvent(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                        }
                    }), e1.postMapLoadEvent(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _updateTerrain() {
                    const e1 = this._isDragging();
                    this.painter.updateTerrain(this.style, e1);
                }
                _calculateSpeedIndex() {
                    const e1 = this.painter.canvasCopy(), t1 = this.painter.getCanvasCopiesAndTimestamps();
                    t1.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, o = i.createFramebuffer();
                    function r(e1) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e1, 0);
                        const t1 = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t1), t1;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, o), this._canvasPixelComparison(r(e1), t1.canvasCopies.map(r), t1.timeStamps);
                }
                _canvasPixelComparison(e1, t1, i) {
                    let o = i[1] - i[0];
                    const r = e1.length / 4;
                    for(let n = 0; n < t1.length; n++){
                        const s = t1[n];
                        let a = 0;
                        for(let t1 = 0; t1 < s.length; t1 += 4)s[t1] === e1[t1] && s[t1 + 1] === e1[t1 + 1] && s[t1 + 2] === e1[t1 + 2] && s[t1 + 3] === e1[t1 + 3] && (a += 1);
                        o += (i[n + 2] - i[n + 1]) * (1 - a / r);
                    }
                    return o;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const e1 of this._controls)e1.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), void 0 !== e1.window && (e1.window.removeEventListener("resize", this._onWindowResize, !1), e1.window.removeEventListener("orientationchange", this._onWindowResize, !1), e1.window.removeEventListener("webkitfullscreenchange", this._onWindowResize, !1), e1.window.removeEventListener("online", this._onWindowOnline, !1), e1.window.removeEventListener("visibilitychange", this._onVisibilityChange, !1));
                    const t1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    t1 && t1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), e1.removeAuthState(this.painter.context.gl), this._removed = !0, this.fire(new e1.Event("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(t1) {
                    this._renderNextFrame = this._renderNextFrame || t1, this.style && !this._frame && (this._frame = e1.exported.frame((e1)=>{
                        const t1 = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t1 && this._render(e1);
                    }));
                }
                _preloadTiles(t1) {
                    const i = this.style ? Object.values(this.style._sourceCaches) : [];
                    return e1.asyncAll(i, (e1, i)=>e1._preloadTiles(t1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e1) {
                    this._trackResize && this.resize({
                        originalEvent: e1
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === e1.window.document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e1) {
                    this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e1) {
                    this._showTerrainWireframe !== e1 && (this._showTerrainWireframe = e1, this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e1) {
                    this._speedIndexTiming !== e1 && (this._speedIndexTiming = e1, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e1) {
                    this._showPadding !== e1 && (this._showPadding = e1, this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e1) {
                    this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e1) {
                    this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e1) {
                    this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e1) {
                    this._vertices = e1, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e1) {
                    this._showTileAABBs !== e1 && (this._showTileAABBs = e1, e1 && this._update());
                }
                _setCacheLimits(t1, i) {
                    e1.setCacheLimits(t1, i);
                }
                get version() {
                    return e1.version;
                }
            },
            NavigationControl: class {
                constructor(t1){
                    this.options = e1.extend({}, hn, t1), this._container = n("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (e1.bindAll([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e1)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e1
                        });
                    }), n("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e1)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e1
                        });
                    }), n("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e1.bindAll([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e1)=>{
                        const t1 = this._map;
                        t1 && (this.options.visualizePitch ? t1.resetNorthPitch({}, {
                            originalEvent: e1
                        }) : t1.resetNorth({}, {
                            originalEvent: e1
                        }));
                    }), this._compassIcon = n("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
                _updateZoomButtons() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = e1.getZoom(), i = t1 === e1.getMaxZoom(), o = t1 === e1.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = o, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", o.toString());
                }
                _rotateCompassArrow() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e1.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e1.transform.pitch}deg) rotateZ(${e1.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e1.transform.angle * (180 / Math.PI)}deg)`;
                    e1._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t1);
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e1.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e1.on("pitch", this._rotateCompassArrow), e1.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new un(e1, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e1 = this._map;
                    e1 && (this._container.remove(), this.options.showZoom && e1.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e1.off("pitch", this._rotateCompassArrow), e1.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e1, t1) {
                    const i = n("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e1, t1) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t1}`);
                    e1.setAttribute("aria-label", i), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
                }
            },
            GeolocateControl: class extends e1.Evented {
                constructor(t1){
                    super(), this.options = e1.extend({
                        geolocation: e1.window.navigator.geolocation
                    }, _n, t1), e1.bindAll([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = Jo(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
                onAdd(e1) {
                    return this._map = e1, this._container = n("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(t1) {
                    const i = (e1 = !!this.options.geolocation)=>{
                        this._supportsGeolocation = e1, t1(e1);
                    };
                    void 0 !== this._supportsGeolocation ? t1(this._supportsGeolocation) : void 0 !== e1.window.navigator.permissions ? e1.window.navigator.permissions.query({
                        name: "geolocation"
                    }).then((e1)=>i("denied" !== e1.state)).catch(()=>i()) : i();
                }
                _isOutOfMapMaxBounds(e1) {
                    const t1 = this._map.getMaxBounds(), i = e1.coords;
                    return !!t1 && (i.longitude < t1.getWest() || i.longitude > t1.getEast() || i.latitude < t1.getSouth() || i.latitude > t1.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                    }
                }
                _onSuccess(t1) {
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e1.Event("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = t1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t1), this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"), this.fire(new e1.Event("geolocate", t1)), this._finish();
                    }
                }
                _updateCamera(t1) {
                    const i = new e1.LngLat(t1.coords.longitude, t1.coords.latitude), o = t1.coords.accuracy, r = this._map.getBearing(), n = e1.extend({
                        bearing: r
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(i.toBounds(o), n, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(t1) {
                    if (t1) {
                        const i = new e1.LngLat(t1.coords.longitude, t1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.transform, i = e1.mercatorZfromAltitude(1, t1._center.lat) * t1.worldSize, o = Math.ceil(2 * this._accuracy * i);
                    this._circleElement.style.width = `${o}px`, this._circleElement.style.height = `${o}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._dotElement.classList.add("mapboxgl-user-location-show-heading")) : (this._dotElement.classList.remove("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(t1) {
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === t1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === t1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"), this.fire(new e1.Event("error", t1)), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _setupUI(t1) {
                    if (void 0 !== this._map) {
                        if (this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this._geolocateButton = n("button", "mapboxgl-ctrl-geolocate", this._container), n("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t1) {
                            e1.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", t1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t1);
                        } else {
                            const e1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = n("div", "mapboxgl-user-location"), this._dotElement.appendChild(n("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(n("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new on({
                            element: this._dotElement,
                            rotationAlignment: "map",
                            pitchAlignment: "map"
                        }), this._circleElement = n("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new on({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                            t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t1.originalEvent && "resize" === t1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e1.Event("trackuserlocationend")));
                        });
                    }
                }
                _onDeviceOrientation(e1) {
                    this._userLocationDotMarker && (e1.webkitCompassHeading ? this._heading = e1.webkitCompassHeading : !0 === e1.absolute && (this._heading = -1 * e1.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return e1.warnOnce("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new e1.Event("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e1.Event("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e1.Event("trackuserlocationstart"));
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                break;
                            case "BACKGROUND":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                break;
                            case "BACKGROUND_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e1;
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e1 = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e1 = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e1), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                    return !0;
                }
                _addDeviceOrientationListener() {
                    const t1 = ()=>{
                        e1.window.addEventListener("ondeviceorientationabsolute" in e1.window ? "deviceorientationabsolute" : "deviceorientation", this._onDeviceOrientation);
                    };
                    void 0 !== e1.window.DeviceMotionEvent && "function" == typeof e1.window.DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((e1)=>{
                        "granted" === e1 && t1();
                    }).catch(console.error) : t1();
                }
                _clearWatch() {
                    this.options.geolocation.clearWatch(this._geolocationWatchID), e1.window.removeEventListener("deviceorientation", this._onDeviceOrientation), e1.window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
            },
            AttributionControl: Kr,
            ScaleControl: class {
                constructor(t1){
                    this.options = e1.extend({}, dn, t1), function() {
                        try {
                            return new Intl.NumberFormat("en", {
                                style: "unit",
                                unitDisplay: "narrow",
                                unit: "meter"
                            }), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }() || (this._setScale = pn.bind(this)), e1.bindAll([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e1 = this.options.maxWidth || 100, t1 = this._map, i = t1._containerHeight / 2, o = t1._containerWidth / 2 - e1 / 2, r = t1.unproject([
                        o,
                        i
                    ]), n = t1.unproject([
                        o + e1,
                        i
                    ]), s = r.distanceTo(n);
                    if ("imperial" === this.options.unit) {
                        const t1 = 3.2808 * s;
                        t1 > 5280 ? this._setScale(e1, t1 / 5280, "mile") : this._setScale(e1, t1, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e1, s / 1852, "nautical-mile") : s >= 1e3 ? this._setScale(e1, s / 1e3, "kilometer") : this._setScale(e1, s, "meter");
                }
                _setScale(e1, t1, i) {
                    const o = mn(t1), r = o / t1;
                    this._map._requestDomTask(()=>{
                        this._container.style.width = e1 * r + "px", this._container.innerHTML = "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "narrow",
                            unit: i
                        }).format(o) : `${o}&nbsp;nm`;
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this._language = e1.getLanguage(), this._container = n("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e1.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e1) {
                    this._language = e1, this._update();
                }
                setUnit(e1) {
                    this.options.unit = e1, this._update();
                }
            },
            FullscreenControl: class {
                constructor(t1){
                    this._fullscreen = !1, t1 && t1.container && (t1.container instanceof e1.window.HTMLElement ? this._container = t1.container : e1.warnOnce("Full screen control 'container' must be a DOM element.")), e1.bindAll([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in e1.window.document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in e1.window.document && (this._fullscreenchange = "webkitfullscreenchange");
                }
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = n("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e1.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, e1.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!e1.window.document.fullscreenEnabled && !e1.window.document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const t1 = this._fullscreenButton = n("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    n("span", "mapboxgl-ctrl-icon", t1).setAttribute("aria-hidden", "true"), t1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), e1.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e1 = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e1), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e1);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (e1.window.document.fullscreenElement || e1.window.document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? e1.window.document.exitFullscreen ? e1.window.document.exitFullscreen() : e1.window.document.webkitCancelFullScreen && e1.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
            },
            Popup: class extends e1.Evented {
                constructor(t1){
                    super(), this.options = e1.extend(Object.create(rn), t1), e1.bindAll([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(t1 && t1.className ? t1.className.trim().split(/\s+/) : []);
                }
                addTo(t1) {
                    return this._map && this.remove(), this._map = t1, this.options.closeOnClick && t1.on("preclick", this._onClose), this.options.closeOnMove && t1.on("move", this._onClose), t1.on("remove", this.remove), this._update(), t1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t1.on("mousemove", this._onMouseEvent), t1.on("mouseup", this._onMouseEvent), t1._canvasContainer.classList.add("mapboxgl-track-pointer")) : t1.on("move", this._update), this.fire(new e1.Event("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const t1 = this._map;
                    return t1 && (t1.off("move", this._update), t1.off("move", this._onClose), t1.off("preclick", this._onClose), t1.off("click", this._onClose), t1.off("remove", this.remove), t1.off("mousemove", this._onMouseEvent), t1.off("mouseup", this._onMouseEvent), t1.off("drag", this._onMouseEvent), t1._canvasContainer && t1._canvasContainer.classList.remove("mapboxgl-track-pointer"), t1._removePopup(this), this._map = void 0), this.fire(new e1.Event("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(t1) {
                    this._lngLat = e1.LngLat.convert(t1), this._pos = null, this._trackPointer = !1, this._update();
                    const i = this._map;
                    return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e1 = this._map;
                    return e1 && (e1.off("move", this._update), e1.on("mousemove", this._onMouseEvent), e1.on("drag", this._onMouseEvent), e1._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(t1) {
                    return this.setDOMContent(e1.window.document.createTextNode(t1));
                }
                setHTML(t1) {
                    const i = e1.window.document.createDocumentFragment(), o = e1.window.document.createElement("body");
                    let r;
                    for(o.innerHTML = t1; r = o.firstChild, r;)i.appendChild(r);
                    return this.setDOMContent(i);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e1) {
                    return this.options.maxWidth = e1, this._update(), this;
                }
                setDOMContent(e1) {
                    let t1 = this._content;
                    if (t1) for(; t1.hasChildNodes();)t1.firstChild && t1.removeChild(t1.firstChild);
                    else t1 = this._content = n("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t1.appendChild(e1), this.options.closeButton) {
                        const e1 = this._closeButton = n("button", "mapboxgl-popup-close-button", t1);
                        e1.type = "button", e1.setAttribute("aria-label", "Close popup"), e1.setAttribute("aria-hidden", "true"), e1.innerHTML = "&#215;", e1.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e1) {
                    return this._classList.add(e1), this._updateClassList(), this;
                }
                removeClassName(e1) {
                    return this._classList.delete(e1), this._updateClassList(), this;
                }
                setOffset(e1) {
                    return this.options.offset = e1, this._update(), this;
                }
                toggleClassName(e1) {
                    let t1;
                    return this._classList.delete(e1) ? t1 = !1 : (this._classList.add(e1), t1 = !0), this._updateClassList(), t1;
                }
                _onMouseEvent(e1) {
                    this._update(e1.point);
                }
                _getAnchor(e1) {
                    if (this.options.anchor) return this.options.anchor;
                    const t1 = this._map, i = this._container, o = this._pos;
                    if (!t1 || !i || !o) return "bottom";
                    const r = i.offsetWidth, n = i.offsetHeight, s = o.x < r / 2, a = o.x > t1.transform.width - r / 2;
                    if (o.y + e1 < n) return s ? "top-left" : a ? "top-right" : "top";
                    if (o.y > t1.transform.height - n) {
                        if (s) return "bottom-left";
                        if (a) return "bottom-right";
                    }
                    return s ? "left" : a ? "right" : "bottom";
                }
                _updateClassList() {
                    const e1 = this._container;
                    if (!e1) return;
                    const t1 = [
                        ...this._classList
                    ];
                    t1.push("mapboxgl-popup"), this._anchor && t1.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t1.push("mapboxgl-popup-track-pointer"), e1.className = t1.join(" ");
                }
                _update(t1) {
                    const i = this._map, o = this._content;
                    if (!i || !this._lngLat && !this._trackPointer || !o) return;
                    let r = this._container;
                    if (r || (r = this._container = n("div", "mapboxgl-popup", i.getContainer()), this._tip = n("div", "mapboxgl-popup-tip", r), r.appendChild(o)), this.options.maxWidth && r.style.maxWidth !== this.options.maxWidth && (r.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = en(this._lngLat, this._pos, i.transform)), !this._trackPointer || t1) {
                        const e1 = this._pos = this._trackPointer && t1 ? t1 : i.project(this._lngLat), o = sn(this.options.offset), r = this._anchor = this._getAnchor(o.y), n = sn(this.options.offset, r), s = e1.add(n).round();
                        i._requestDomTask(()=>{
                            this._container && r && (this._container.style.transform = `${tn[r]} translate(${s.x}px,${s.y}px)`);
                        });
                    }
                    if (!this._marker && i._showingGlobe()) {
                        const t1 = e1.isLngLatBehindGlobe(i.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(t1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e1 = this._container.querySelector(nn);
                    e1 && e1.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e1) {
                    this._container && (this._container.style.opacity = `${e1}`), this._content && (this._content.style.pointerEvents = e1 ? "auto" : "none");
                }
            },
            Marker: on,
            Style: Qt,
            LngLat: e1.LngLat,
            LngLatBounds: e1.LngLatBounds,
            Point: e1.pointGeometry,
            MercatorCoordinate: e1.MercatorCoordinate,
            FreeCameraOptions: Zo,
            Evented: e1.Evented,
            config: e1.config,
            prewarm: function() {
                je().acquire(Ue);
            },
            clearPrewarmedResources: function() {
                const e1 = Ge;
                e1 && (e1.isPreloaded() && 1 === e1.numActive() ? (e1.release(Ue), Ge = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get accessToken () {
                return e1.config.ACCESS_TOKEN;
            },
            set accessToken (t){
                e1.config.ACCESS_TOKEN = t;
            },
            get baseApiUrl () {
                return e1.config.API_URL;
            },
            set baseApiUrl (t){
                e1.config.API_URL = t;
            },
            get workerCount () {
                return Ne.workerCount;
            },
            set workerCount (e){
                Ne.workerCount = e;
            },
            get maxParallelImageRequests () {
                return e1.config.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (t){
                e1.config.MAX_PARALLEL_IMAGE_REQUESTS = t;
            },
            clearStorage (t1) {
                e1.clearTileCache(t1);
            },
            workerUrl: "",
            workerClass: null,
            setNow: e1.exported.setNow,
            restoreNow: e1.exported.restoreNow
        };
        return fn;
    });
    //
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});

},{}],"3qemx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MatroxEncoderAACFormat = exports.MatroxEncoderAACEncoder = exports.MatroxEncoderBitrateControlMode = exports.MatroxEncoderEncodingMode = exports.MatroxEncoderIncludeOption = exports.MatroxEncoderProcessorFrameRate = exports.MatroxEncoderVideoProfile = exports.MatroxEncoderPixelFormat = exports.MatroxEncoderFlipOption = exports.MatroxEncoderPivotOption = exports.MatroxEncoderScalingOption = exports.RawVideo = exports.VideoCodec = exports.AudioSystemStandard = exports.AudioCodec = exports.AudioLayout = exports.sdiAudioPairs = exports.OutputAdminStatus = exports.OutputRedundancyMode = exports.HandoverMethod = exports.VideoPreviewMode = exports.ThumbnailMode = exports.InputAdminStatus = exports.PIDRuleAction = exports.PortType = exports.ApplianceConnectionState = exports.MatroxDecoderFramerateFamily = exports.MatroxDecoderGenlockSource = exports.MatroxEncoderGenlockResolution = exports.MatroxEncoderIOConfig = exports.ApplianceType = exports.MatroxEncoderAACQualityLevel = exports.PrometheusAlerts = exports.AlarmType = exports.VaAlarmOwnSeverityLevels = exports.AlarmSeverityLevels = exports.AlarmCause = exports.AuditOperation = exports.AuditLogOperationResult = exports.SrtRateLimiting = exports.SrtKeylen = exports.ZixiMode = exports.SrtMode = exports.RistProfile = exports.RistserverLogLevel = exports.EdgeProduct = exports.LogLevel = exports.DelayMode = exports.UdpOutputStatusCode = exports.RistInputMultipathState = void 0;
exports.ExternalRegionMode = exports.ApplianceRealm = exports.ListKubernetesNodeSortableField = exports.ContainerTerminatedReason = exports.UsageDetailType = exports.TunnelType = exports.OutputOperStatus = exports.InputOperStatus = exports.Nimbra400AlarmsFilter = exports.BroadcastStandard = exports.TranscodeAcceleratorType = exports.KubernetesProvider = exports.SsoConfigSource = exports.OidcPrompt = exports.ExpFeatures = exports.InputAccessType = exports.MetricWindow = exports.ComprimatoMetricType = exports.MatroxMetricType = exports.AsiMetricType = exports.SdiMetricType = exports.VideonMetricType = exports.RistSimpleProfileMetricType = exports.MptsMetricType = exports.TrancodeStreamMetricType = exports.RtmpMetricType = exports.SrtMetricType = exports.ZixiMetricType = exports.RistMetricType = exports.VaObjectOutputType = exports.VaObjectInputType = exports.SsoStrategy = exports.Role = exports.MatroxDecoderOutputResolutionFamilyThree = exports.MatroxDecoderOutputResolutionFamilyTwo = exports.MatroxDecoderOutputResolutionFamilyOne = exports.MatroxAudioChannelPair = exports.ZixiLinkMode = exports.ZixiDecryptType = exports.OutputPortFec = exports.Output3gLevel = exports.ComprimatoPortMode = exports.VideonPortMode = exports.MatroxPortMode = exports.CoaxPortMode = exports.IpPortMode = exports.IpcPortMode = exports.MatroxVideoFlags = exports.VideonVideoFlags = exports.Nimbra400VideoFlags = void 0;
exports.AdBreakStatus = exports.AdCreativeStatus = exports.AdCreativeEvent = exports.AdPodStatus = exports.ListAdBreakSortableField = exports.ListAdCreativeSortableField = exports.ListAdPodSortableField = exports.ACCESS_SCOPE_DESCRIPTIONS = exports.ACCESS_SCOPE_FRIENDLY_NAMES = exports.ACCESS_SCOPE_NAMES_LIST = exports.ACCESS_SCOPES = exports.ListServiceSortableField = exports.NetworkSortableField = exports.IpMappingType = exports.GraphNodeType = exports.ListIpMappingSortableField = exports.ListApplianceSortableField = exports.ApplianceSummarySortableField = exports.ListGroupSortableField = exports.ListOutputSortableField = exports.ListInputSortableField = exports.ListApiTokenSortableField = exports.ListUserSortableField = exports.ListAlarmSortableField = exports.ListPortSortableField = exports.ImageName = exports.EntityType = void 0;
const rist_1 = require("7e08ee1024fb6a8f");
Object.defineProperty(exports, "RistInputMultipathState", {
    enumerable: true,
    get: function() {
        return rist_1.RistInputMultipathState;
    }
});
Object.defineProperty(exports, "UdpOutputStatusCode", {
    enumerable: true,
    get: function() {
        return rist_1.UdpOutputStatusCode;
    }
});
var rist_2 = require("7e08ee1024fb6a8f");
Object.defineProperty(exports, "DelayMode", {
    enumerable: true,
    get: function() {
        return rist_2.DelayMode;
    }
});
var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["fatal"] = 0] = "fatal";
    LogLevel[LogLevel["error"] = 1] = "error";
    LogLevel[LogLevel["warn"] = 2] = "warn";
    LogLevel[LogLevel["info"] = 3] = "info";
    LogLevel[LogLevel["debug"] = 4] = "debug";
    LogLevel[LogLevel["trace"] = 5] = "trace";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
var EdgeProduct;
(function(EdgeProduct) {
    EdgeProduct["edge"] = "edge";
    EdgeProduct["loci"] = "loci";
})(EdgeProduct || (exports.EdgeProduct = EdgeProduct = {}));
// Key is what we call it in NM to be consistent with LogLevel, and the value is what the ristserver accepts
var RistserverLogLevel;
(function(RistserverLogLevel) {
    RistserverLogLevel["fatal"] = "critical";
    RistserverLogLevel["error"] = "error";
    RistserverLogLevel["warn"] = "warning";
    RistserverLogLevel["info"] = "info";
    RistserverLogLevel["debug"] = "debug";
    RistserverLogLevel["trace"] = "trace";
})(RistserverLogLevel || (exports.RistserverLogLevel = RistserverLogLevel = {}));
var RistProfile;
(function(RistProfile) {
    RistProfile["simple"] = "simple";
    RistProfile["main"] = "main";
})(RistProfile || (exports.RistProfile = RistProfile = {}));
var SrtMode;
(function(SrtMode) {
    SrtMode["listener"] = "listener";
    SrtMode["caller"] = "caller";
    SrtMode["rendezvous"] = "rendezvous";
})(SrtMode || (exports.SrtMode = SrtMode = {}));
var ZixiMode;
(function(ZixiMode) {
    ZixiMode["pull"] = "pull";
    ZixiMode["push"] = "push";
})(ZixiMode || (exports.ZixiMode = ZixiMode = {}));
var SrtKeylen;
(function(SrtKeylen) {
    SrtKeylen["aes128"] = "16";
    SrtKeylen["aes192"] = "24";
    SrtKeylen["aes256"] = "32";
    SrtKeylen["none"] = "-1";
})(SrtKeylen || (exports.SrtKeylen = SrtKeylen = {}));
var SrtRateLimiting;
(function(SrtRateLimiting) {
    SrtRateLimiting["notEnforced"] = "Not enforced";
    SrtRateLimiting["absolute"] = "Absolute";
    SrtRateLimiting["relativeToInput"] = "Relative to input";
})(SrtRateLimiting || (exports.SrtRateLimiting = SrtRateLimiting = {}));
var AuditLogOperationResult;
(function(AuditLogOperationResult) {
    AuditLogOperationResult["error"] = "error";
    AuditLogOperationResult["success"] = "success";
})(AuditLogOperationResult || (exports.AuditLogOperationResult = AuditLogOperationResult = {}));
var AuditOperation;
(function(AuditOperation) {
    AuditOperation["create"] = "create";
    AuditOperation["delete"] = "delete";
    AuditOperation["update"] = "update";
    AuditOperation["login"] = "login";
    AuditOperation["logout"] = "logout";
    AuditOperation["switchInput"] = "switchInput";
    AuditOperation["tcpdumpInput"] = "tcpdumpInput";
    AuditOperation["updateInputRecipients"] = "updateInputRecipients";
    AuditOperation["sendToOutputs"] = "sendToOutputs";
    AuditOperation["updateApplianceVersion"] = "updateApplianceVersion";
    AuditOperation["registerAppliance"] = "registerAppliance";
    AuditOperation["reregisterAppliance"] = "reregisterAppliance";
    AuditOperation["updateApplianceBasicInfo"] = "updateApplianceBasicInfo";
    AuditOperation["updateApplianceIpConfig"] = "updateApplianceIpConfig";
    AuditOperation["restartAppliance"] = "restartAppliance";
    AuditOperation["updateApplianceImage"] = "updateApplianceImage";
    AuditOperation["startCloudApplianceInstance"] = "startCloudApplianceInstance";
    AuditOperation["stopCloudApplianceInstance"] = "stopCloudApplianceInstance";
    AuditOperation["beginSystemUpgrade"] = "beginSystemUpgrade";
    AuditOperation["completeSystemUpgrade"] = "completeSystemUpgrade";
    AuditOperation["toggle"] = "toggle";
})(AuditOperation || (exports.AuditOperation = AuditOperation = {}));
var AlarmCause;
(function(AlarmCause) {
    AlarmCause["INTERFACE_REMOVED_BUT_IN_USE"] = "Interface removed but still in use";
    AlarmCause["CORE_APPLIANCE_PUBLIC_IP_MISSING"] = "Appliance needs public ip mapping";
    AlarmCause["CORE_INPUT_INVALID_ADDRESS"] = "Core input configured on an address that is not available";
    AlarmCause["CORE_OUTPUT_INVALID_ADDRESS"] = "Core output configured on an address that is not available";
    AlarmCause["FIREWALL_NFT_ERROR"] = "Failed to apply firewall settings using nftables";
    AlarmCause["MPTS_SUPPORT_ERROR"] = "Failed to run mpts demux binary";
    AlarmCause["MPTS_STARTUP_ERROR"] = "Unknown error when starting the mpts demux binary";
    AlarmCause["MPTS_UNEXPECTED_EXIT"] = "The mpts demux binary unexpectedly exited";
    AlarmCause["MPTS_CALL_TIMEOUT"] = "The mpts demux binary did not give a timely response to an api call";
    AlarmCause["BACKUP_JOB_FAILED"] = "Backup job failed";
    AlarmCause["RTMP_RECEIVER_EXITED"] = "RTMP receiver exited unexpectedly";
    AlarmCause["RTMP_SENDER_EXITED"] = "RTMP sender exited unexpectedly";
    AlarmCause["TRANSCODE_EXITED"] = "Transcode process exited unexpectedly";
    AlarmCause["TRANSCODE_MISSING_PID"] = "Audio reshuffling failed due to missing PID";
    AlarmCause["TRANSCODE_MISALIGNED_STREAMS"] = "Stream timestamps are misaligned";
    AlarmCause["INPUT_MAX_BITRATE_EXCEEDED"] = "Ingested stream traffic exceeds the maximum bitrate";
    AlarmCause["INPUT_UNHEALTHY"] = "Input is unhealthy";
    AlarmCause["OUTPUT_UNHEALTHY"] = "Output is unhealthy";
    AlarmCause["APPLIANCE_OFFLINE"] = "Appliance is offline";
    AlarmCause["APPLIANCE_HIGH_CPU_USAGE"] = "High CPU usage detected";
    AlarmCause["TRANSCODE_ACCELERATOR_HIGH_USAGE"] = "High transcode accelerator usage detected";
    // Nimbra 400 alarms
    AlarmCause["VA_LOSS_OF_SIGNAL"] = "Loss of signal";
    AlarmCause["VA_CALL_ESTABLISHMENT_ERROR"] = "Call establishment error";
    AlarmCause["VA_CONFIGURATION_OR_CUSTOMIZATION_ERROR"] = "Configuration or customization error";
    AlarmCause["VA_RESOURCE_CAPACITY"] = "Resource at or nearing capacity";
    AlarmCause["VA_SOFTWARE_PROGRAM_ERROR"] = "Software program error";
    // Edge-data alarms
    AlarmCause["RISTSERVER_ADD_CHANNEL"] = "Failed to add channel";
    AlarmCause["RISTSERVER_ADD_INPUT_STREAM_RIST"] = "Failed to add input stream rist";
    AlarmCause["RISTSERVER_ADD_INPUT_STREAM_RTP"] = "Failed to add input stream rtp";
    AlarmCause["RISTSERVER_ADD_INPUT_STREAM_UDP"] = "Failed to add input stream udp";
    AlarmCause["RISTSERVER_ADD_INPUT_STREAM_ADDRESS_ALREADY_IN_USE"] = "Address already in use";
    AlarmCause["RISTSERVER_ADD_OUTPUT_STREAM_RIST"] = "Failed to add output stream rist";
    AlarmCause["RISTSERVER_ADD_OUTPUT_STREAM_RTP"] = "Failed to add output stream rtp";
    AlarmCause["RISTSERVER_ADD_OUTPUT_STREAM_UDP"] = "Failed to add output stream udp";
    AlarmCause["RISTSERVER_ADD_TUNNEL_CLIENT"] = "Failed to add tunnel client";
    AlarmCause["RISTSERVER_ADD_TUNNEL_SERVER"] = "Failed to add tunnel server";
    AlarmCause["RISTSERVER_GET_DELTA_STATISTICS"] = "Failed to get delta statistics";
    AlarmCause["RISTSERVER_REMOVE_CHANNEL"] = "Failed to remove channel";
    AlarmCause["RISTSERVER_REMOVE_INPUT_STREAM"] = "Failed to remove input stream";
    AlarmCause["RISTSERVER_REMOVE_OUTPUT_STREAM"] = "Failed to remove output stream";
    AlarmCause["RISTSERVER_REMOVE_TUNNEL"] = "Failed to remove tunnel";
    AlarmCause["RISTSERVER_SET_INPUT_MULTIPATH_PARAMS"] = "Failed to set input multipath params";
    AlarmCause["RISTSERVER_SET_LOGGING_OPTIONS"] = "Failed to set logging options";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_MAXBITRATE"] = "Failed to set output stream max bitrate";
    AlarmCause["RISTSERVER_GET_STATISTICS"] = "Failed to get statistics";
    AlarmCause["RISTSERVER_GET_STATUS"] = "Failed to get status";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_NEW_AD_PLAYLIST"] = "Failed to set output stream new ad playlist";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_NOTIFY_SCTE"] = "Failed to set output stream notify scte";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_AD_INSERTION"] = "Failed to set output stream ad insertion";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_AD_SCTE_35_SOURCE"] = "Failed to set output stream ad insertion SCTE source filter";
    AlarmCause["RISTSERVER_SET_AD_FILE_AVAILABILITY"] = "Failed to set ad file availability";
    AlarmCause["HANDOVER_PROCESS_ADD_INPUT"] = "Failed to add input";
    AlarmCause["HANDOVER_PROCESS_ADD_OUTPUT"] = "Failed to add output";
    AlarmCause["MATROX_CONFIG_MISMATCH"] = "Configuration error - unable to set up appliance";
    AlarmCause["MATROX_FETCH_STATE"] = "Failed to fetch state";
    AlarmCause["MATROX_MISCONFIGURED_GENLOCK"] = "Misconfigured genlock";
    AlarmCause["MATROX_UPDATE_GENLOCK"] = "Failed to update genlock";
    AlarmCause["MATROX_MISCONFIGURED_IO_CONFIG"] = "Misconfigured I/O config";
    AlarmCause["MATROX_UPDATE_IO_CONFIG"] = "Failed to update I/O config";
    AlarmCause["MATROX_MISCONFIGURED_SDI_PORTS"] = "Misconfigured SDI ports";
    AlarmCause["MATROX_UPDATE_SDI_PORT"] = "Failed to update SDI port";
    AlarmCause["MATROX_MISCONFIGURED_PIPELINE"] = "Misconfigured pipeline";
    AlarmCause["MATROX_ADD_MISSING_PIPELINE"] = "Failed to add missing pipeline";
    AlarmCause["MATROX_DELETE_OBSOLETE_MPEG2TS_INPUT"] = "Failed to delete obsolete MPEG2TS input";
    AlarmCause["MATROX_DELETE_OBSOLETE_PROCESSOR"] = "Failed to delete obsolete processor";
    AlarmCause["MATROX_DELETE_OBSOLETE_ENCODER"] = "Failed to delete obsolete encoder";
    AlarmCause["MATROX_DELETE_OBSOLETE_MPEG2TS_OUTPUT"] = "Failed to delete obsolete MPEG2TS output";
    AlarmCause["COMPRIMATO_UNHEALTHY_PIPELINE"] = "Unhealthy Comprimato pipeline";
    AlarmCause["STORAGE_THRESHOLD_ALERT"] = "Storage threshold alert";
    AlarmCause["UNHEALTHY_INSTANCES_ALERT"] = "Unhealthy instances alert";
    AlarmCause["KAFKA_UNAVAILABLE"] = "Redpanda unavailable";
    AlarmCause["K8S_SYSTEM_ALERT"] = "Kubernetes system alert";
    AlarmCause["DOWNLOAD_AD_FILE"] = "Failed to download ad file";
    AlarmCause["PARSE_VAST_RESPONSE"] = "Failed to parse VAST response";
})(AlarmCause || (exports.AlarmCause = AlarmCause = {}));
/**
 * @OAS_DESCRIPTION Alarm severity levels
 *
 * * critical - Critical alarms are service-affecting meaning several streams are not being delivered correctly.
 *   Critical alarms require immediate attention even if they occur outside working hours. For example if a video-node
 *   is overloaded.
 *
 * * major - Some functionallity is missing or degraded. This could be the control-plane is not working correctly or a
 *   stream cannot be delivered correctly. For example metrics being unavailable.
 *
 * * minor - A fault has occurred but it is currently not service-affecting. For example a database is operating without
 *   adequate redundancy.
 *
 * * warning - Warnings does not affect the service. They indicate potential future problems if not addressed. For
 *   example high disk usage.
 */ var AlarmSeverityLevels;
(function(AlarmSeverityLevels) {
    AlarmSeverityLevels["critical"] = "critical";
    AlarmSeverityLevels["major"] = "major";
    AlarmSeverityLevels["minor"] = "minor";
    AlarmSeverityLevels["warning"] = "warning";
})(AlarmSeverityLevels || (exports.AlarmSeverityLevels = AlarmSeverityLevels = {}));
var VaAlarmOwnSeverityLevels;
(function(VaAlarmOwnSeverityLevels) {
    VaAlarmOwnSeverityLevels["cleared"] = "cleared";
})(VaAlarmOwnSeverityLevels || (exports.VaAlarmOwnSeverityLevels = VaAlarmOwnSeverityLevels = {}));
var AlarmType;
(function(AlarmType) {
    AlarmType["va"] = "va";
    AlarmType["edge"] = "edge";
    AlarmType["backend"] = "backend";
    AlarmType["backupMonitor"] = "backup-monitor";
    AlarmType["prometheus"] = "prometheus";
})(AlarmType || (exports.AlarmType = AlarmType = {}));
var PrometheusAlerts;
(function(PrometheusAlerts) {
    // These values MUST match the rule names in the prometheus.values file
    PrometheusAlerts["LowRedpandaDiskSpace"] = "LowRedpandaDiskSpace";
    PrometheusAlerts["HighNodeDiskUsage"] = "HighNodeDiskUsage";
    PrometheusAlerts["ReducedCloudNativePGAvailability"] = "ReducedCloudNativePGAvailability";
    PrometheusAlerts["CloudNativePGReplicationLag"] = "CloudNativePGReplicationLag";
    PrometheusAlerts["CloudNativePGReplicationFailure"] = "CloudNativePGReplicationFailure";
    PrometheusAlerts["ReducedCloudNativePGReplication"] = "ReducedCloudNativePGReplication";
    PrometheusAlerts["ReducedRedisAvailability"] = "ReducedRedisAvailability";
    PrometheusAlerts["KafkaSendErrors"] = "KafkaSendErrors";
    PrometheusAlerts["ReducedRedpandaAvailability"] = "ReducedRedpandaAvailability";
    PrometheusAlerts["RedpandaConsumerGroupLag"] = "RedpandaConsumerGroupLag";
    PrometheusAlerts["ReducedRedpandaToClickHouseAvailability"] = "ReducedRedpandaToClickHouseAvailability";
    PrometheusAlerts["ReducedClickHouseAvailability"] = "ReducedClickHouseAvailability";
    PrometheusAlerts["ClickHouseHighLatency"] = "ClickHouseHighLatency";
    PrometheusAlerts["KubeClientCertificateExpiration"] = "KubeClientCertificateExpiration";
})(PrometheusAlerts || (exports.PrometheusAlerts = PrometheusAlerts = {}));
var MatroxEncoderAACQualityLevel;
(function(MatroxEncoderAACQualityLevel) {
    MatroxEncoderAACQualityLevel["low"] = "Level0";
    MatroxEncoderAACQualityLevel["medium"] = "Level1";
    MatroxEncoderAACQualityLevel["high"] = "Level2";
    MatroxEncoderAACQualityLevel["unknown"] = "LevelUnknown";
})(MatroxEncoderAACQualityLevel || (exports.MatroxEncoderAACQualityLevel = MatroxEncoderAACQualityLevel = {}));
var ApplianceType;
(function(ApplianceType) {
    ApplianceType["nimbraVAdocker"] = "nimbraVAdocker";
    ApplianceType["nimbra410"] = "nimbra410";
    ApplianceType["nimbra412"] = "nimbra412";
    ApplianceType["nimbra414"] = "nimbra414";
    ApplianceType["nimbra414b"] = "nimbra414b";
    ApplianceType["nimbraVA225"] = "nimbraVA225";
    ApplianceType["nimbraVA220"] = "nimbraVA220";
    ApplianceType["edgeConnect"] = "edgeConnect";
    ApplianceType["core"] = "core";
    ApplianceType["thumb"] = "thumb";
    ApplianceType["videon"] = "videon";
    ApplianceType["matroxMonarchEdgeE4_8Bit"] = "matroxMonarchEdgeE4_8Bit";
    ApplianceType["matroxMonarchEdgeE4_10Bit"] = "matroxMonarchEdgeE4_10Bit";
    ApplianceType["matroxMonarchEdgeD4"] = "matroxMonarchEdgeD4";
    ApplianceType["matroxMonarchEdgeS1"] = "matroxMonarchEdgeS1";
    ApplianceType["comprimato"] = "comprimato";
    ApplianceType["mediakindRx1"] = "mediakindRx1";
    ApplianceType["mediakindCe1"] = "mediakindCe1";
    ApplianceType["riversilica"] = "riversilica";
    ApplianceType["nimbra204"] = "nimbra204";
})(ApplianceType || (exports.ApplianceType = ApplianceType = {}));
var MatroxEncoderIOConfig;
(function(MatroxEncoderIOConfig) {
    MatroxEncoderIOConfig["fourZero"] = "4:0";
    MatroxEncoderIOConfig["threeOne"] = "3:1";
    MatroxEncoderIOConfig["twoTwo"] = "2:2";
})(MatroxEncoderIOConfig || (exports.MatroxEncoderIOConfig = MatroxEncoderIOConfig = {}));
var MatroxEncoderGenlockResolution;
(function(MatroxEncoderGenlockResolution) {
    MatroxEncoderGenlockResolution["ntsc"] = "NTSC";
    MatroxEncoderGenlockResolution["pal"] = "PAL";
})(MatroxEncoderGenlockResolution || (exports.MatroxEncoderGenlockResolution = MatroxEncoderGenlockResolution = {}));
var MatroxDecoderGenlockSource;
(function(MatroxDecoderGenlockSource) {
    MatroxDecoderGenlockSource["internal"] = "internal";
    MatroxDecoderGenlockSource["external"] = "external";
})(MatroxDecoderGenlockSource || (exports.MatroxDecoderGenlockSource = MatroxDecoderGenlockSource = {}));
var MatroxDecoderFramerateFamily;
(function(MatroxDecoderFramerateFamily) {
    MatroxDecoderFramerateFamily["familyOne"] = "25/50";
    MatroxDecoderFramerateFamily["familyTwo"] = "29.97/59.94";
    MatroxDecoderFramerateFamily["familyThree"] = "30/60";
})(MatroxDecoderFramerateFamily || (exports.MatroxDecoderFramerateFamily = MatroxDecoderFramerateFamily = {}));
var ApplianceConnectionState;
(function(ApplianceConnectionState) {
    ApplianceConnectionState["connected"] = "connected";
    ApplianceConnectionState["missing"] = "missing";
    ApplianceConnectionState["neverConnected"] = "neverConnected";
})(ApplianceConnectionState || (exports.ApplianceConnectionState = ApplianceConnectionState = {}));
var PortType;
(function(PortType) {
    PortType["ip"] = "ip";
    PortType["coax"] = "coax";
    PortType["videon"] = "videon";
    PortType["ndi"] = "ndi";
})(PortType || (exports.PortType = PortType = {}));
var PIDRuleAction;
(function(PIDRuleAction) {
    PIDRuleAction["Map"] = "map";
    PIDRuleAction["Delete"] = "delete";
    PIDRuleAction["SetNull"] = "setNull";
})(PIDRuleAction || (exports.PIDRuleAction = PIDRuleAction = {}));
var InputAdminStatus;
(function(InputAdminStatus) {
    InputAdminStatus[InputAdminStatus["off"] = 0] = "off";
    InputAdminStatus[InputAdminStatus["on"] = 1] = "on";
})(InputAdminStatus || (exports.InputAdminStatus = InputAdminStatus = {}));
var ThumbnailMode;
(function(ThumbnailMode) {
    ThumbnailMode[ThumbnailMode["none"] = 0] = "none";
    ThumbnailMode[ThumbnailMode["edge"] = 1] = "edge";
    ThumbnailMode[ThumbnailMode["core"] = 2] = "core";
})(ThumbnailMode || (exports.ThumbnailMode = ThumbnailMode = {}));
var VideoPreviewMode;
(function(VideoPreviewMode) {
    VideoPreviewMode["off"] = "off";
    VideoPreviewMode["ondemand"] = "on demand";
    VideoPreviewMode["alwayson"] = "always on";
})(VideoPreviewMode || (exports.VideoPreviewMode = VideoPreviewMode = {}));
var HandoverMethod;
(function(HandoverMethod) {
    HandoverMethod["udp"] = "udp";
    HandoverMethod["unix"] = "unix";
})(HandoverMethod || (exports.HandoverMethod = HandoverMethod = {}));
var OutputRedundancyMode;
(function(OutputRedundancyMode) {
    OutputRedundancyMode[OutputRedundancyMode["none"] = 0] = "none";
    OutputRedundancyMode[OutputRedundancyMode["failover"] = 1] = "failover";
    OutputRedundancyMode[OutputRedundancyMode["active"] = 2] = "active";
})(OutputRedundancyMode || (exports.OutputRedundancyMode = OutputRedundancyMode = {}));
/**
 * @OAS_DESCRIPTION Output enabled/disabled status.
 * * Disabled: 0
 * * Enabled: 1
 */ var OutputAdminStatus;
(function(OutputAdminStatus) {
    OutputAdminStatus[OutputAdminStatus["off"] = 0] = "off";
    OutputAdminStatus[OutputAdminStatus["on"] = 1] = "on";
})(OutputAdminStatus || (exports.OutputAdminStatus = OutputAdminStatus = {}));
const SDI_AUDIO_PAIRS = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8
];
exports.sdiAudioPairs = [
    ...SDI_AUDIO_PAIRS
]; // get the not ReadOnly array
var AudioLayout;
(function(AudioLayout) {
    AudioLayout["mono"] = "mono";
    AudioLayout["stereo"] = "stereo";
})(AudioLayout || (exports.AudioLayout = AudioLayout = {}));
var AudioCodec;
(function(AudioCodec) {
    AudioCodec["mpeg2"] = "mpeg-2";
    AudioCodec["aacLc"] = "aac-lc";
    AudioCodec["heAac"] = "he-aac";
    AudioCodec["heAacV2"] = "he-aac v2";
    AudioCodec["aes3"] = "aes3";
    AudioCodec["ac3pt"] = "ac3pt";
    AudioCodec["ac3"] = "ac3";
    AudioCodec["aacLatm"] = "aac latm";
    AudioCodec["aacAdts"] = "aac adts";
    AudioCodec["raw"] = "raw";
})(AudioCodec || (exports.AudioCodec = AudioCodec = {}));
var AudioSystemStandard;
(function(AudioSystemStandard) {
    AudioSystemStandard["systemA"] = "System A";
    AudioSystemStandard["systemB"] = "System B";
})(AudioSystemStandard || (exports.AudioSystemStandard = AudioSystemStandard = {}));
var VideoCodec;
(function(VideoCodec) {
    VideoCodec["h264"] = "h.264";
    VideoCodec["h265"] = "h.265";
})(VideoCodec || (exports.VideoCodec = VideoCodec = {}));
exports.RawVideo = 'RAW';
var MatroxEncoderScalingOption;
(function(MatroxEncoderScalingOption) {
    // Unscaled from top left
    MatroxEncoderScalingOption["noScalingAtTopLeft"] = "noScalingAtTopLeft";
    // Unscaled centered
    MatroxEncoderScalingOption["noScalingAtCenter"] = "noScalingAtCenter";
    // Stretched to all edges
    MatroxEncoderScalingOption["scaleToFitDestination"] = "scaleToFitDestination";
    // Scaled to all edges
    MatroxEncoderScalingOption["scaleToFillButKeepContentAspectRatio"] = "scaleToFillButKeepContentAspectRatio";
    // Scaling to the nearest edge
    MatroxEncoderScalingOption["scaleToFitAllContent"] = "scaleToFitAllContent";
})(MatroxEncoderScalingOption || (exports.MatroxEncoderScalingOption = MatroxEncoderScalingOption = {}));
var MatroxEncoderPivotOption;
(function(MatroxEncoderPivotOption) {
    MatroxEncoderPivotOption["none"] = "none";
    MatroxEncoderPivotOption["by90Degrees"] = "by90Degrees";
    MatroxEncoderPivotOption["by180Degrees"] = "by180Degrees";
    MatroxEncoderPivotOption["by270Degrees"] = "by270Degrees";
})(MatroxEncoderPivotOption || (exports.MatroxEncoderPivotOption = MatroxEncoderPivotOption = {}));
var MatroxEncoderFlipOption;
(function(MatroxEncoderFlipOption) {
    MatroxEncoderFlipOption["none"] = "none";
    MatroxEncoderFlipOption["horizontally"] = "horizontally";
    MatroxEncoderFlipOption["vertically"] = "vertically";
    MatroxEncoderFlipOption["bothAxis"] = "bothAxis";
})(MatroxEncoderFlipOption || (exports.MatroxEncoderFlipOption = MatroxEncoderFlipOption = {}));
var MatroxEncoderPixelFormat;
(function(MatroxEncoderPixelFormat) {
    MatroxEncoderPixelFormat["YUV420_8bits"] = "YUV420_8bits";
    MatroxEncoderPixelFormat["YUV422_8bits"] = "YUV422_8bits";
    MatroxEncoderPixelFormat["YUV422_10bits"] = "YUV422_10bits";
    MatroxEncoderPixelFormat["YUV420_10bits"] = "YUV420_10bits";
})(MatroxEncoderPixelFormat || (exports.MatroxEncoderPixelFormat = MatroxEncoderPixelFormat = {}));
var MatroxEncoderVideoProfile;
(function(MatroxEncoderVideoProfile) {
    MatroxEncoderVideoProfile["Baseline"] = "Baseline";
    MatroxEncoderVideoProfile["Main"] = "Main";
    MatroxEncoderVideoProfile["High"] = "High";
    MatroxEncoderVideoProfile["High10Bit"] = "High 10-bit";
    MatroxEncoderVideoProfile["High422"] = "High YUV 4:2:2";
})(MatroxEncoderVideoProfile || (exports.MatroxEncoderVideoProfile = MatroxEncoderVideoProfile = {}));
var MatroxEncoderProcessorFrameRate;
(function(MatroxEncoderProcessorFrameRate) {
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["twentyFive"] = 25] = "twentyFive";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["twentyNineNinetySeven"] = 29.97] = "twentyNineNinetySeven";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["thirty"] = 30] = "thirty";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["fifty"] = 50] = "fifty";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["fiftyNineNinetyFour"] = 59.94] = "fiftyNineNinetyFour";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["sixty"] = 60] = "sixty";
})(MatroxEncoderProcessorFrameRate || (exports.MatroxEncoderProcessorFrameRate = MatroxEncoderProcessorFrameRate = {}));
var MatroxEncoderIncludeOption;
(function(MatroxEncoderIncludeOption) {
    MatroxEncoderIncludeOption["none"] = "none";
    MatroxEncoderIncludeOption["audioOnly"] = "audioOnly";
    MatroxEncoderIncludeOption["videoOnly"] = "videoOnly";
    MatroxEncoderIncludeOption["audioAndVideo"] = "audioAndVideo";
})(MatroxEncoderIncludeOption || (exports.MatroxEncoderIncludeOption = MatroxEncoderIncludeOption = {}));
var MatroxEncoderEncodingMode;
(function(MatroxEncoderEncodingMode) {
    MatroxEncoderEncodingMode["lowLatency"] = "lowLatency";
    MatroxEncoderEncodingMode["highQuality"] = "highQuality";
})(MatroxEncoderEncodingMode || (exports.MatroxEncoderEncodingMode = MatroxEncoderEncodingMode = {}));
var MatroxEncoderBitrateControlMode;
(function(MatroxEncoderBitrateControlMode) {
    MatroxEncoderBitrateControlMode["constant"] = "constant";
    MatroxEncoderBitrateControlMode["variable"] = "variable";
})(MatroxEncoderBitrateControlMode || (exports.MatroxEncoderBitrateControlMode = MatroxEncoderBitrateControlMode = {}));
var MatroxEncoderAACEncoder;
(function(MatroxEncoderAACEncoder) {
    MatroxEncoderAACEncoder["lc"] = "lc";
    MatroxEncoderAACEncoder["hev1"] = "hev1";
    MatroxEncoderAACEncoder["hev2"] = "hev2";
})(MatroxEncoderAACEncoder || (exports.MatroxEncoderAACEncoder = MatroxEncoderAACEncoder = {}));
var MatroxEncoderAACFormat;
(function(MatroxEncoderAACFormat) {
    MatroxEncoderAACFormat["noContainer"] = "noContainer";
    MatroxEncoderAACFormat["adts"] = "adts";
    MatroxEncoderAACFormat["adif"] = "adif";
    MatroxEncoderAACFormat["unknown"] = "unknown";
})(MatroxEncoderAACFormat || (exports.MatroxEncoderAACFormat = MatroxEncoderAACFormat = {}));
var Nimbra400VideoFlags;
(function(Nimbra400VideoFlags) {
    Nimbra400VideoFlags["smpte12mTimecode"] = "smpte12mTimecode";
})(Nimbra400VideoFlags || (exports.Nimbra400VideoFlags = Nimbra400VideoFlags = {}));
var VideonVideoFlags;
(function(VideonVideoFlags) {
    VideonVideoFlags["limitTo30Fps"] = "limitTo30Fps";
    VideonVideoFlags["klvTimeCodeInsertion"] = "klvTimeCodeInsertion";
    VideonVideoFlags["scte35Insertion"] = "scte35Insertion";
    VideonVideoFlags["cea708_608Captions"] = "cea708_608Captions";
    VideonVideoFlags["smpte2038Insertion"] = "smpte2038Insertion";
})(VideonVideoFlags || (exports.VideonVideoFlags = VideonVideoFlags = {}));
var MatroxVideoFlags;
(function(MatroxVideoFlags) {
    MatroxVideoFlags["ForceCAVLCEntropyEncoding"] = "ForceCAVLCEntropyEncoding";
})(MatroxVideoFlags || (exports.MatroxVideoFlags = MatroxVideoFlags = {}));
/**
 * @OAS_DESCRIPTION Supported transport protocols over IPC.
 */ var IpcPortMode;
(function(IpcPortMode) {
    IpcPortMode["unix"] = "unix";
})(IpcPortMode || (exports.IpcPortMode = IpcPortMode = {}));
/**
 * @OAS_DESCRIPTION Supported transport protocols over IP.
 */ var IpPortMode;
(function(IpPortMode) {
    IpPortMode["rist"] = "rist";
    IpPortMode["udp"] = "udp";
    IpPortMode["rtp"] = "rtp";
    IpPortMode["srt"] = "srt";
    IpPortMode["zixi"] = "zixi";
    IpPortMode["rtmp"] = "rtmp";
    IpPortMode["generator"] = "generator";
})(IpPortMode || (exports.IpPortMode = IpPortMode = {}));
/**
 * @OAS_DESCRIPTION Supported video ports
 */ var CoaxPortMode;
(function(CoaxPortMode) {
    // 'hdmi' = 'hdmi',
    CoaxPortMode["sdi"] = "sdi";
    CoaxPortMode["asi"] = "asi";
})(CoaxPortMode || (exports.CoaxPortMode = CoaxPortMode = {}));
var MatroxPortMode;
(function(MatroxPortMode) {
    MatroxPortMode["matroxSdi"] = "matroxSdi";
})(MatroxPortMode || (exports.MatroxPortMode = MatroxPortMode = {}));
var VideonPortMode;
(function(VideonPortMode) {
    VideonPortMode["videonSdi"] = "videonSdi";
    VideonPortMode["videonHdmi"] = "videonHdmi";
    VideonPortMode["videonAuto"] = "videonAuto";
})(VideonPortMode || (exports.VideonPortMode = VideonPortMode = {}));
var ComprimatoPortMode;
(function(ComprimatoPortMode) {
    ComprimatoPortMode["comprimatoSdi"] = "comprimatoSdi";
    ComprimatoPortMode["comprimatoNdi"] = "comprimatoNdi";
})(ComprimatoPortMode || (exports.ComprimatoPortMode = ComprimatoPortMode = {}));
var Output3gLevel;
(function(Output3gLevel) {
    Output3gLevel["A"] = "A";
    Output3gLevel["B"] = "B";
})(Output3gLevel || (exports.Output3gLevel = Output3gLevel = {}));
var OutputPortFec;
(function(OutputPortFec) {
    OutputPortFec["1D"] = "1D";
    OutputPortFec["2D"] = "2D";
})(OutputPortFec || (exports.OutputPortFec = OutputPortFec = {}));
var ZixiDecryptType;
(function(ZixiDecryptType) {
    ZixiDecryptType["none"] = "none";
    ZixiDecryptType["aes128"] = "aes128";
    ZixiDecryptType["aes192"] = "aes192";
    ZixiDecryptType["aes256"] = "aes256";
})(ZixiDecryptType || (exports.ZixiDecryptType = ZixiDecryptType = {}));
var ZixiLinkMode;
(function(ZixiLinkMode) {
    ZixiLinkMode["single"] = "single";
    ZixiLinkMode["standby"] = "standby";
    ZixiLinkMode["bonded"] = "bonded";
})(ZixiLinkMode || (exports.ZixiLinkMode = ZixiLinkMode = {}));
var MatroxAudioChannelPair;
(function(MatroxAudioChannelPair) {
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel1And2"] = 3] = "channel1And2";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel3And4"] = 12] = "channel3And4";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel5And6"] = 48] = "channel5And6";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel7And8"] = 192] = "channel7And8";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel9And10"] = 768] = "channel9And10";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel11And12"] = 3072] = "channel11And12";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel13And14"] = 12288] = "channel13And14";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel15And16"] = 49152] = "channel15And16";
})(MatroxAudioChannelPair || (exports.MatroxAudioChannelPair = MatroxAudioChannelPair = {}));
// Applicable when device "Genlock Framrate family" is set to "25/50"
var MatroxDecoderOutputResolutionFamilyOne;
(function(MatroxDecoderOutputResolutionFamilyOne) {
    MatroxDecoderOutputResolutionFamilyOne["720p50"] = "720p50";
    MatroxDecoderOutputResolutionFamilyOne["1080p25"] = "1080p25";
    MatroxDecoderOutputResolutionFamilyOne["1080p50"] = "1080p50";
    MatroxDecoderOutputResolutionFamilyOne["1080i25"] = "1080i25";
    MatroxDecoderOutputResolutionFamilyOne["2160p50"] = "2160p50";
})(MatroxDecoderOutputResolutionFamilyOne || (exports.MatroxDecoderOutputResolutionFamilyOne = MatroxDecoderOutputResolutionFamilyOne = {}));
// Applicable when device "Genlock Framrate family" is set to "29.97/59.94"
var MatroxDecoderOutputResolutionFamilyTwo;
(function(MatroxDecoderOutputResolutionFamilyTwo) {
    MatroxDecoderOutputResolutionFamilyTwo["720p59.94"] = "720p59.94";
    MatroxDecoderOutputResolutionFamilyTwo["1080p23.98"] = "1080p23.98";
    MatroxDecoderOutputResolutionFamilyTwo["1080p29.97"] = "1080p29.97";
    MatroxDecoderOutputResolutionFamilyTwo["1080p59.94"] = "1080p59.94";
    MatroxDecoderOutputResolutionFamilyTwo["1080i29.97"] = "1080i29.97";
    MatroxDecoderOutputResolutionFamilyTwo["2160p59.94"] = "2160p59.94";
})(MatroxDecoderOutputResolutionFamilyTwo || (exports.MatroxDecoderOutputResolutionFamilyTwo = MatroxDecoderOutputResolutionFamilyTwo = {}));
// Applicable when device "Genlock Framrate family" is set to "30/60"
var MatroxDecoderOutputResolutionFamilyThree;
(function(MatroxDecoderOutputResolutionFamilyThree) {
    MatroxDecoderOutputResolutionFamilyThree["720p60"] = "720p60";
    MatroxDecoderOutputResolutionFamilyThree["1080p24"] = "1080p24";
    MatroxDecoderOutputResolutionFamilyThree["1080p30"] = "1080p30";
    MatroxDecoderOutputResolutionFamilyThree["1080p60"] = "1080p60";
    MatroxDecoderOutputResolutionFamilyThree["1080i30"] = "1080i30";
    MatroxDecoderOutputResolutionFamilyThree["2160p60"] = "2160p60";
})(MatroxDecoderOutputResolutionFamilyThree || (exports.MatroxDecoderOutputResolutionFamilyThree = MatroxDecoderOutputResolutionFamilyThree = {}));
var Role;
(function(Role) {
    Role["basic"] = "basic";
    Role["admin"] = "admin";
    Role["super"] = "super";
})(Role || (exports.Role = Role = {}));
var SsoStrategy;
(function(SsoStrategy) {
    SsoStrategy["saml"] = "saml";
    SsoStrategy["oidc"] = "oidc";
})(SsoStrategy || (exports.SsoStrategy = SsoStrategy = {}));
var VaObjectInputType;
(function(VaObjectInputType) {
    VaObjectInputType["sdiInput"] = "sdi-input";
    VaObjectInputType["encoder"] = "encoder";
    VaObjectInputType["udpSink"] = "udp-sink";
    VaObjectInputType["ristSink"] = "rist-sink";
    VaObjectInputType["srtSink"] = "srt-sink";
    VaObjectInputType["edgeSource"] = "edge-source";
    VaObjectInputType["asiInput"] = "asi-input";
    VaObjectInputType["pullSink"] = "pull-sink";
    VaObjectInputType["pushSink"] = "push-sink";
})(VaObjectInputType || (exports.VaObjectInputType = VaObjectInputType = {}));
var VaObjectOutputType;
(function(VaObjectOutputType) {
    VaObjectOutputType["sdiOutput"] = "sdi-output";
    VaObjectOutputType["decoder"] = "decoder";
    VaObjectOutputType["udpSource"] = "udp-source";
    VaObjectOutputType["ristSource"] = "rist-source";
    VaObjectOutputType["srtSource"] = "srt-source";
    VaObjectOutputType["edgeSink"] = "edge-sink";
    VaObjectOutputType["asiOutput"] = "asi-output";
    VaObjectOutputType["pullSource"] = "pull-source";
    VaObjectOutputType["pushSource"] = "push-source";
})(VaObjectOutputType || (exports.VaObjectOutputType = VaObjectOutputType = {}));
/**
 * RistMetricType: the possible types of metric objects emitted from the ristServer
 */ var RistMetricType;
(function(RistMetricType) {
    RistMetricType["ristInput"] = "ristInput";
    RistMetricType["ristOutput"] = "ristOutput";
    RistMetricType["udpInput"] = "udpInput";
    RistMetricType["udpOutput"] = "udpOutput";
    RistMetricType["unixInput"] = "unixInput";
    RistMetricType["unixOutput"] = "unixOutput";
    RistMetricType["rtpInput"] = "rtpInput";
    RistMetricType["rtpOutput"] = "rtpOutput";
    RistMetricType["channel"] = "channel";
})(RistMetricType || (exports.RistMetricType = RistMetricType = {}));
var ZixiMetricType;
(function(ZixiMetricType) {
    ZixiMetricType["zixiOutput"] = "zixiOutput";
    ZixiMetricType["zixiInput"] = "zixiInput";
})(ZixiMetricType || (exports.ZixiMetricType = ZixiMetricType = {}));
var SrtMetricType;
(function(SrtMetricType) {
    SrtMetricType["srtOutput"] = "srtOutput";
    SrtMetricType["srtInput"] = "srtInput";
})(SrtMetricType || (exports.SrtMetricType = SrtMetricType = {}));
var RtmpMetricType;
(function(RtmpMetricType) {
    RtmpMetricType["rtmpInput"] = "rtmpInput";
    RtmpMetricType["rtmpOutput"] = "rtmpOutput";
})(RtmpMetricType || (exports.RtmpMetricType = RtmpMetricType = {}));
var TrancodeStreamMetricType;
(function(TrancodeStreamMetricType) {
    TrancodeStreamMetricType["transcodeStream"] = "transcodeStream";
})(TrancodeStreamMetricType || (exports.TrancodeStreamMetricType = TrancodeStreamMetricType = {}));
var MptsMetricType;
(function(MptsMetricType) {
    MptsMetricType["mptsDemux"] = "mptsDemux";
// mptsInput = 'mptsInput',
// mptsOutput = 'mptsOutput',
})(MptsMetricType || (exports.MptsMetricType = MptsMetricType = {}));
var RistSimpleProfileMetricType;
(function(RistSimpleProfileMetricType) {
    RistSimpleProfileMetricType["ristSimpleInput"] = "ristSimpleInput";
    RistSimpleProfileMetricType["ristSimpleOutput"] = "ristSimpleOutput";
})(RistSimpleProfileMetricType || (exports.RistSimpleProfileMetricType = RistSimpleProfileMetricType = {}));
var VideonMetricType;
(function(VideonMetricType) {
    VideonMetricType["videonAutoInput"] = "videonAutoInput";
    VideonMetricType["videonHdmiInput"] = "videonHdmiInput";
    VideonMetricType["videonSdiInput"] = "videonSdiInput";
})(VideonMetricType || (exports.VideonMetricType = VideonMetricType = {}));
var SdiMetricType;
(function(SdiMetricType) {
    SdiMetricType["sdiInput"] = "sdiInput";
    SdiMetricType["sdiOutput"] = "sdiOutput";
})(SdiMetricType || (exports.SdiMetricType = SdiMetricType = {}));
var AsiMetricType;
(function(AsiMetricType) {
    AsiMetricType["asiInput"] = "asiInput";
    AsiMetricType["asiOutput"] = "asiOutput";
})(AsiMetricType || (exports.AsiMetricType = AsiMetricType = {}));
var MatroxMetricType;
(function(MatroxMetricType) {
    MatroxMetricType["matroxSdiInput"] = "matroxSdiInput";
    MatroxMetricType["matroxSdiOutput"] = "matroxSdiOutput";
})(MatroxMetricType || (exports.MatroxMetricType = MatroxMetricType = {}));
var ComprimatoMetricType;
(function(ComprimatoMetricType) {
    ComprimatoMetricType["comprimatoSdiInput"] = "comprimatoSdiInput";
    ComprimatoMetricType["comprimatoNdiInput"] = "comprimatoNdiInput";
    ComprimatoMetricType["comprimatoNdiOutput"] = "comprimatoNdiOutput";
    ComprimatoMetricType["comprimatoSdiOutput"] = "comprimatoSdiOutput";
})(ComprimatoMetricType || (exports.ComprimatoMetricType = ComprimatoMetricType = {}));
var MetricWindow;
(function(MetricWindow) {
    MetricWindow["s10"] = "10 seconds";
    MetricWindow["m1"] = "1 minute";
    MetricWindow["m15"] = "15 minutes";
    MetricWindow["h1"] = "1 hour";
    MetricWindow["h24"] = "24 hours";
})(MetricWindow || (exports.MetricWindow = MetricWindow = {}));
/**
 * @OAS_DESCRIPTION Describes the kind of access a group has to an input.
 * * View: 1
 * * Pull: 2
 */ var InputAccessType;
(function(InputAccessType) {
    InputAccessType[InputAccessType["view"] = 1] = "view";
    InputAccessType[InputAccessType["pull"] = 2] = "pull";
})(InputAccessType || (exports.InputAccessType = InputAccessType = {}));
var ExpFeatures;
(function(ExpFeatures) {
    // These currently need to be  abc = 'abc' and not abc = 'friendly name for abc'
    ExpFeatures["OASResponseValidation"] = "OASResponseValidation";
    ExpFeatures["ExtDerivedInput"] = "ExtDerivedInput";
    ExpFeatures["ExtSelectableDelayMode"] = "ExtSelectableDelayMode";
    ExpFeatures["ExtHealthAlarms"] = "ExtHealthAlarms";
    ExpFeatures["AdInsertion"] = "AdInsertion";
    // TODO: remove this when all customers have upgraded to >=R3.14.0
    ExpFeatures["AllowLegacyExternalRegions"] = "AllowLegacyExternalRegions";
})(ExpFeatures || (exports.ExpFeatures = ExpFeatures = {}));
var OidcPrompt;
(function(OidcPrompt) {
    OidcPrompt["none"] = "none";
    OidcPrompt["login"] = "login";
    OidcPrompt["select_account"] = "select_account";
})(OidcPrompt || (exports.OidcPrompt = OidcPrompt = {}));
var SsoConfigSource;
(function(SsoConfigSource) {
    SsoConfigSource["metadata"] = "metadata";
    SsoConfigSource["manual"] = "manual";
})(SsoConfigSource || (exports.SsoConfigSource = SsoConfigSource = {}));
var KubernetesProvider;
(function(KubernetesProvider) {
    KubernetesProvider["metal"] = "metal";
    KubernetesProvider["alibaba"] = "alibaba";
    KubernetesProvider["aws"] = "aws";
    KubernetesProvider["google"] = "google";
    KubernetesProvider["azure"] = "azure";
    KubernetesProvider["oracle"] = "oracle";
})(KubernetesProvider || (exports.KubernetesProvider = KubernetesProvider = {}));
var TranscodeAcceleratorType;
(function(TranscodeAcceleratorType) {
    TranscodeAcceleratorType["nvidia"] = "nvidia";
    TranscodeAcceleratorType["netint"] = "netint";
    TranscodeAcceleratorType["xilinx_u30"] = "xilinx_u30";
    TranscodeAcceleratorType["videotoolbox"] = "videotoolbox";
    TranscodeAcceleratorType["cpu"] = "cpu";
})(TranscodeAcceleratorType || (exports.TranscodeAcceleratorType = TranscodeAcceleratorType = {}));
var BroadcastStandard;
(function(BroadcastStandard) {
    BroadcastStandard["dvb"] = "dvb";
    BroadcastStandard["atsc"] = "atsc";
})(BroadcastStandard || (exports.BroadcastStandard = BroadcastStandard = {}));
var Nimbra400AlarmsFilter;
(function(Nimbra400AlarmsFilter) {
    Nimbra400AlarmsFilter["edgeManagedServices"] = "edgeManagedServices";
    Nimbra400AlarmsFilter["all"] = "all";
    Nimbra400AlarmsFilter["none"] = "none";
})(Nimbra400AlarmsFilter || (exports.Nimbra400AlarmsFilter = Nimbra400AlarmsFilter = {}));
var InputOperStatus;
(function(InputOperStatus) {
    InputOperStatus["notConfigured"] = "notConfigured";
    InputOperStatus["metricsMissing"] = "metricsMissing";
    InputOperStatus["allOk"] = "allOk";
    InputOperStatus["inputError"] = "inputError";
    InputOperStatus["tr101290Priority1Error"] = "tr101290Priority1Error";
    InputOperStatus["transportError"] = "transportError";
    InputOperStatus["alarm"] = "alarm";
    InputOperStatus["reducedRedundancy"] = "reducedRedundancy";
})(InputOperStatus || (exports.InputOperStatus = InputOperStatus = {}));
var OutputOperStatus;
(function(OutputOperStatus) {
    OutputOperStatus["notConfigured"] = "notConfigured";
    OutputOperStatus["metricsMissing"] = "metricsMissing";
    OutputOperStatus["tr101290Priority1Error"] = "tr101290Priority1Error";
    OutputOperStatus["reducedRedundancy"] = "reducedRedundancy";
    OutputOperStatus["allOk"] = "allOk";
    // The output is successfully sending data to the configured destination but has not (yet) received an ACK from the receiver
    // Applicable for Rist Simple Profile, but not for e.g. SRT or RTMP since they won't actually send any data until a connection has been established.
    OutputOperStatus["notAcknowledged"] = "notAcknowledged";
    OutputOperStatus["inputError"] = "inputError";
    OutputOperStatus["outputError"] = "outputError";
    OutputOperStatus["alarm"] = "alarm";
})(OutputOperStatus || (exports.OutputOperStatus = OutputOperStatus = {}));
var TunnelType;
(function(TunnelType) {
    // Used by external appliances (edgeConnect, VA, etc) connecting to core nodes.
    // Uses "public" ip mapping.
    TunnelType[TunnelType["external"] = 1] = "external";
    // Used for communication between core appliances (video and thumb) within the same region.
    // Uses "internal" ip mapping.
    TunnelType[TunnelType["internal"] = 2] = "internal";
    // Used for communication between different regions.
    // Uses "inter region" ip mapping.
    TunnelType[TunnelType["interRegion"] = 3] = "interRegion";
})(TunnelType || (exports.TunnelType = TunnelType = {}));
var UsageDetailType;
(function(UsageDetailType) {
    UsageDetailType["input"] = "input";
    UsageDetailType["output"] = "output";
})(UsageDetailType || (exports.UsageDetailType = UsageDetailType = {}));
var ContainerTerminatedReason;
(function(ContainerTerminatedReason) {
    ContainerTerminatedReason["completed"] = "Completed";
})(ContainerTerminatedReason || (exports.ContainerTerminatedReason = ContainerTerminatedReason = {}));
var ListKubernetesNodeSortableField;
(function(ListKubernetesNodeSortableField) {
    ListKubernetesNodeSortableField["name"] = "name";
    ListKubernetesNodeSortableField["region"] = "region";
    ListKubernetesNodeSortableField["status"] = "status";
})(ListKubernetesNodeSortableField || (exports.ListKubernetesNodeSortableField = ListKubernetesNodeSortableField = {}));
var ApplianceRealm;
(function(ApplianceRealm) {
    ApplianceRealm["core"] = "core";
    ApplianceRealm["edge"] = "edge";
})(ApplianceRealm || (exports.ApplianceRealm = ApplianceRealm = {}));
/**
 * @OAS_DESCRIPTION Region mode
 * * 0 - The core region for Nimbra Edge, there can only be one
 * * 1 - External region, managed by kubernetes. Video/thumb nodes are managed by the kubernetes cluster
 * * 2 - External region, manually managed
 */ var ExternalRegionMode;
(function(ExternalRegionMode) {
    ExternalRegionMode[ExternalRegionMode["core"] = 0] = "core";
    ExternalRegionMode[ExternalRegionMode["externalK8s"] = 1] = "externalK8s";
    ExternalRegionMode[ExternalRegionMode["external"] = 2] = "external";
})(ExternalRegionMode || (exports.ExternalRegionMode = ExternalRegionMode = {}));
var EntityType;
(function(EntityType) {
    EntityType["alarm"] = "alarm";
    EntityType["appliance"] = "appliance";
    EntityType["alarmLog"] = "alarm-log";
    EntityType["auditLog"] = "audit-log";
    EntityType["distribution"] = "distribution";
    EntityType["input"] = "input";
    EntityType["group"] = "group";
    EntityType["groupAndRecipientList"] = "groupAndRecipientList";
    EntityType["groupRecipientList"] = "groupRecipientList";
    EntityType["output"] = "output";
    EntityType["outputAndRecipientList"] = "outputAndRecipientList";
    EntityType["outputRecipientList"] = "outputRecipientList";
    EntityType["port"] = "port";
    EntityType["region"] = "region";
    EntityType["user"] = "user";
    EntityType["ipMapping"] = "ip-mapping";
    EntityType["system"] = "system";
})(EntityType || (exports.EntityType = EntityType = {}));
/// Allowed names of images that may exist in database.
var ImageName;
(function(ImageName) {
    ImageName["product"] = "product";
    ImageName["serviceProvider"] = "serviceProvider";
    ImageName["favicon"] = "favicon";
})(ImageName || (exports.ImageName = ImageName = {}));
var ListPortSortableField;
(function(ListPortSortableField) {
    ListPortSortableField["portName"] = "portName";
    ListPortSortableField["address"] = "address";
    ListPortSortableField["publicAddress"] = "publicAddress";
    ListPortSortableField["applianceName"] = "applianceName";
    ListPortSortableField["ownerGroupName"] = "ownerGroupName";
})(ListPortSortableField || (exports.ListPortSortableField = ListPortSortableField = {}));
var ListAlarmSortableField;
(function(ListAlarmSortableField) {
    ListAlarmSortableField["time"] = "time";
    ListAlarmSortableField["applianceName"] = "applianceName";
    ListAlarmSortableField["alarmCause"] = "alarmCause";
    ListAlarmSortableField["text"] = "text";
})(ListAlarmSortableField || (exports.ListAlarmSortableField = ListAlarmSortableField = {}));
var ListUserSortableField;
(function(ListUserSortableField) {
    ListUserSortableField["userName"] = "userName";
    ListUserSortableField["groupName"] = "groupName";
    ListUserSortableField["role"] = "role";
})(ListUserSortableField || (exports.ListUserSortableField = ListUserSortableField = {}));
var ListApiTokenSortableField;
(function(ListApiTokenSortableField) {
    ListApiTokenSortableField["name"] = "name";
    ListApiTokenSortableField["userName"] = "userName";
    ListApiTokenSortableField["groupName"] = "groupName";
    ListApiTokenSortableField["role"] = "role";
    ListApiTokenSortableField["expiresAt"] = "expiresAt";
})(ListApiTokenSortableField || (exports.ListApiTokenSortableField = ListApiTokenSortableField = {}));
var ListInputSortableField;
(function(ListInputSortableField) {
    ListInputSortableField["inputName"] = "inputName";
    ListInputSortableField["applianceName"] = "applianceName";
    ListInputSortableField["protocol"] = "protocol";
    ListInputSortableField["creationDate"] = "creationDate";
    ListInputSortableField["lastModified"] = "lastModified";
    ListInputSortableField["accessType"] = "accessType";
    ListInputSortableField["ownerGroupName"] = "ownerGroupName";
    ListInputSortableField["healthStatus"] = "healthStatus";
})(ListInputSortableField || (exports.ListInputSortableField = ListInputSortableField = {}));
var ListOutputSortableField;
(function(ListOutputSortableField) {
    ListOutputSortableField["id"] = "id";
    ListOutputSortableField["outputName"] = "outputName";
    ListOutputSortableField["applianceName"] = "applianceName";
    ListOutputSortableField["protocol"] = "protocol";
    ListOutputSortableField["creationDate"] = "creationDate";
    ListOutputSortableField["lastModified"] = "lastModified";
    ListOutputSortableField["inputName"] = "inputName";
    ListOutputSortableField["ownerGroupName"] = "ownerGroupName";
    ListOutputSortableField["healthStatus"] = "healthStatus";
})(ListOutputSortableField || (exports.ListOutputSortableField = ListOutputSortableField = {}));
var ListGroupSortableField;
(function(ListGroupSortableField) {
    ListGroupSortableField["groupName"] = "groupName";
    ListGroupSortableField["numberOfUsers"] = "numberOfUsers";
    ListGroupSortableField["numberOfAppliances"] = "numberOfAppliances";
    ListGroupSortableField["numberOfPorts"] = "numberOfPorts";
})(ListGroupSortableField || (exports.ListGroupSortableField = ListGroupSortableField = {}));
var ApplianceSummarySortableField;
(function(ApplianceSummarySortableField) {
    ApplianceSummarySortableField["applianceName"] = "applianceName";
    ApplianceSummarySortableField["regionName"] = "regionName";
    ApplianceSummarySortableField["ownerGroupName"] = "ownerGroupName";
})(ApplianceSummarySortableField || (exports.ApplianceSummarySortableField = ApplianceSummarySortableField = {}));
var ListApplianceSortableField;
(function(ListApplianceSortableField) {
    ListApplianceSortableField["applianceName"] = "applianceName";
    ListApplianceSortableField["applianceType"] = "applianceType";
    ListApplianceSortableField["regionName"] = "regionName";
    ListApplianceSortableField["secondaryRegionName"] = "secondaryRegionName";
    ListApplianceSortableField["ownerGroupName"] = "ownerGroupName";
    ListApplianceSortableField["lastSeen"] = "lastSeen";
    ListApplianceSortableField["numActiveAlarms"] = "numActiveAlarms";
})(ListApplianceSortableField || (exports.ListApplianceSortableField = ListApplianceSortableField = {}));
var ListIpMappingSortableField;
(function(ListIpMappingSortableField) {
    ListIpMappingSortableField["regionName"] = "regionName";
    ListIpMappingSortableField["applianceName"] = "applianceName";
    ListIpMappingSortableField["interfaceName"] = "interfaceName";
    ListIpMappingSortableField["privateAddress"] = "privateAddress";
    ListIpMappingSortableField["publicAddress"] = "publicAddress";
    ListIpMappingSortableField["internalAddress"] = "internalAddress";
    ListIpMappingSortableField["interRegionAddress"] = "interRegionAddress";
})(ListIpMappingSortableField || (exports.ListIpMappingSortableField = ListIpMappingSortableField = {}));
var GraphNodeType;
(function(GraphNodeType) {
    // A logical port of the input we are currently looking at.
    // If it is a parent input, it will have derivedInput(s) in the graph.
    // If it is a derived input, it will have parentInputLogicalPort(s) in the graph.
    GraphNodeType["inputLogicalPort"] = "inputLogicalPort";
    GraphNodeType["parentInputLogicalPort"] = "parentInputLogicalPort";
    // Derived/child input of the (parent) input being inspected.
    GraphNodeType["derivedInput"] = "derivedInput";
    // The edge-appliance where the input resides
    GraphNodeType["inputEdgeAppliance"] = "inputEdgeAppliance";
    // The core-appliance where the input resides
    GraphNodeType["inputRegionCore"] = "inputRegionCore";
    GraphNodeType["thumbAppliance"] = "thumbAppliance";
    // An output
    GraphNodeType["output"] = "output";
    // The core-appliance where the output resides
    GraphNodeType["outputRegionCore"] = "outputRegionCore";
    // The edge-appliance, in the same region as the input, where the output resides
    GraphNodeType["inputRegionOutputEdgeAppliance"] = "inputRegionOutputEdgeAppliance";
    // The edge-appliance, in a different region than the input, where the output resides
    GraphNodeType["outputRegionOutputEdgeAppliance"] = "outputRegionOutputEdgeAppliance";
})(GraphNodeType || (exports.GraphNodeType = GraphNodeType = {}));
var IpMappingType;
(function(IpMappingType) {
    // A user configured IP mapping
    IpMappingType["mapped"] = "mapped";
    // A suggested (incomplete) IP mapping suggested by the system
    IpMappingType["suggested"] = "suggested";
})(IpMappingType || (exports.IpMappingType = IpMappingType = {}));
var NetworkSortableField;
(function(NetworkSortableField) {
    NetworkSortableField["id"] = "id";
    NetworkSortableField["name"] = "name";
})(NetworkSortableField || (exports.NetworkSortableField = NetworkSortableField = {}));
var ListServiceSortableField;
(function(ListServiceSortableField) {
    ListServiceSortableField["purpose"] = "purpose";
    ListServiceSortableField["product"] = "product";
})(ListServiceSortableField || (exports.ListServiceSortableField = ListServiceSortableField = {}));
var ACCESS_SCOPES;
(function(ACCESS_SCOPES) {
    ACCESS_SCOPES[ACCESS_SCOPES["api"] = 1] = "api";
    ACCESS_SCOPES[ACCESS_SCOPES["read_appliance_summary"] = 2] = "read_appliance_summary";
    ACCESS_SCOPES[ACCESS_SCOPES["post_cloud_appliance_audit_log"] = 3] = "post_cloud_appliance_audit_log";
})(ACCESS_SCOPES || (exports.ACCESS_SCOPES = ACCESS_SCOPES = {}));
exports.ACCESS_SCOPE_NAMES_LIST = Object.keys(ACCESS_SCOPES).filter((key)=>isNaN(Number(key)));
exports.ACCESS_SCOPE_FRIENDLY_NAMES = {
    api: 'Full read/write access',
    read_appliance_summary: 'Read appliance summary',
    post_cloud_appliance_audit_log: 'Post cloud appliance audit log'
};
exports.ACCESS_SCOPE_DESCRIPTIONS = {
    api: 'Access to everything user has access to',
    read_appliance_summary: 'Read appliance summary (id, name, hostname, type, tags, isActive)',
    post_cloud_appliance_audit_log: 'Allow external appliance automation tools to record events in the audit log'
};
var ListAdPodSortableField;
(function(ListAdPodSortableField) {
    ListAdPodSortableField["name"] = "name";
    ListAdPodSortableField["createdAt"] = "createdAt";
})(ListAdPodSortableField || (exports.ListAdPodSortableField = ListAdPodSortableField = {}));
var ListAdCreativeSortableField;
(function(ListAdCreativeSortableField) {
    ListAdCreativeSortableField["name"] = "name";
    ListAdCreativeSortableField["fileSize"] = "fileSize";
    ListAdCreativeSortableField["duration"] = "duration";
    ListAdCreativeSortableField["createdAt"] = "createdAt";
})(ListAdCreativeSortableField || (exports.ListAdCreativeSortableField = ListAdCreativeSortableField = {}));
var ListAdBreakSortableField;
(function(ListAdBreakSortableField) {
    ListAdBreakSortableField["startsAt"] = "startsAt";
    ListAdBreakSortableField["createdAt"] = "createdAt";
})(ListAdBreakSortableField || (exports.ListAdBreakSortableField = ListAdBreakSortableField = {}));
var AdPodStatus;
(function(AdPodStatus) {
    AdPodStatus["pending"] = "pending";
    AdPodStatus["healthy"] = "healthy";
    AdPodStatus["unhealthy"] = "unhealthy";
    AdPodStatus["inactive"] = "inactive";
})(AdPodStatus || (exports.AdPodStatus = AdPodStatus = {}));
var AdCreativeEvent;
(function(AdCreativeEvent) {
    AdCreativeEvent["probeOk"] = "probeOk";
    AdCreativeEvent["probeFailed"] = "probeFailed";
    AdCreativeEvent["thumbnailOk"] = "thumbnailOk";
    AdCreativeEvent["thumbnailFailed"] = "thumbnailFailed";
    AdCreativeEvent["uploadOk"] = "uploadOk";
    AdCreativeEvent["uploadFailed"] = "uploadFailed";
})(AdCreativeEvent || (exports.AdCreativeEvent = AdCreativeEvent = {}));
var AdCreativeStatus;
(function(AdCreativeStatus) {
    AdCreativeStatus["pending"] = "pending";
    AdCreativeStatus["active"] = "active";
    AdCreativeStatus["thumbnailFailed"] = "thumbnailFailed";
    AdCreativeStatus["uploadFailed"] = "uploadFailed";
    AdCreativeStatus["probeFailed"] = "probeFailed";
})(AdCreativeStatus || (exports.AdCreativeStatus = AdCreativeStatus = {}));
var AdBreakStatus;
(function(AdBreakStatus) {
    AdBreakStatus["pending"] = "pending";
    AdBreakStatus["playing"] = "playing";
    AdBreakStatus["playOk"] = "playOk";
    AdBreakStatus["playFailed"] = "playFailed";
    AdBreakStatus["collectingStats"] = "collectingStats";
})(AdBreakStatus || (exports.AdBreakStatus = AdBreakStatus = {}));

},{"7e08ee1024fb6a8f":"eyUJa"}],"eyUJa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UdpOutputStatusCode = exports.UdpInputStatusCode = exports.RtpInputStatusCode = exports.ChannelState = exports.RistOutputMultipathState = exports.RistInputMultipathState = exports.RistMultipathPolicy = exports.DelayMode = exports.Importance = exports.RistServerFecMode = void 0;
var RistServerFecMode;
(function(RistServerFecMode) {
    RistServerFecMode[RistServerFecMode["none"] = 0] = "none";
    RistServerFecMode[RistServerFecMode["1D"] = 1] = "1D";
    RistServerFecMode[RistServerFecMode["2D"] = 2] = "2D";
})(RistServerFecMode || (exports.RistServerFecMode = RistServerFecMode = {}));
// for the rist-server
var Importance;
(function(Importance) {
    Importance["vital"] = "vital";
    Importance["nonvital"] = "nonvital";
})(Importance || (exports.Importance = Importance = {}));
// for the rist-server
var DelayMode;
(function(DelayMode) {
    // basedOnRtpAndArrivalTime = 0,
    DelayMode[DelayMode["basedOnArrivalTime"] = 1] = "basedOnArrivalTime";
    DelayMode[DelayMode["basedOnOriginTime"] = 2] = "basedOnOriginTime";
})(DelayMode || (exports.DelayMode = DelayMode = {}));
// for the rist-server
var RistMultipathPolicy;
(function(RistMultipathPolicy) {
    // Of all healthy paths, the one with the highest priority is chosen.
    // The others are sent inhibit messages to prevent them from sending RTP.
    RistMultipathPolicy["failover"] = "failover";
    // No inhibit messages are sent on any input paths.
    RistMultipathPolicy["redundancy"] = "redundancy";
    // Propagate is failover with propagation of inhibit on all rist inputs
    // when all rist outputs are inhibited and no udp output is vital.
    // As soon as one rist output is resumed, propagation of inhibit stops.
    RistMultipathPolicy["propagate"] = "propagate";
})(RistMultipathPolicy || (exports.RistMultipathPolicy = RistMultipathPolicy = {}));
// for the rist-server
var RistInputMultipathState;
(function(RistInputMultipathState) {
    RistInputMultipathState["active"] = "active";
    RistInputMultipathState["standby"] = "standby";
})(RistInputMultipathState || (exports.RistInputMultipathState = RistInputMultipathState = {}));
// for the rist-server
var RistOutputMultipathState;
(function(RistOutputMultipathState) {
    RistOutputMultipathState["active"] = "active";
    RistOutputMultipathState["inhibited"] = "inhibited";
})(RistOutputMultipathState || (exports.RistOutputMultipathState = RistOutputMultipathState = {}));
var ChannelState;
(function(ChannelState) {
    ChannelState["activated"] = "activated";
    ChannelState["deactivated"] = "deactivated";
})(ChannelState || (exports.ChannelState = ChannelState = {}));
// for the rist-server
var RtpInputStatusCode;
(function(RtpInputStatusCode) {
    RtpInputStatusCode["ok"] = "ok";
    RtpInputStatusCode["oddSsrc"] = "odd_ssrc";
    RtpInputStatusCode["unknown"] = "unknown";
})(RtpInputStatusCode || (exports.RtpInputStatusCode = RtpInputStatusCode = {}));
// for the rist-server
var UdpInputStatusCode;
(function(UdpInputStatusCode) {
    UdpInputStatusCode["active"] = "active";
    UdpInputStatusCode["standby"] = "standby";
})(UdpInputStatusCode || (exports.UdpInputStatusCode = UdpInputStatusCode = {}));
// for the rist-server
var UdpOutputStatusCode;
(function(UdpOutputStatusCode) {
    UdpOutputStatusCode["playing"] = "playing";
    UdpOutputStatusCode["noData"] = "no_data";
    UdpOutputStatusCode["noOriginTime"] = "no_origin_time";
    UdpOutputStatusCode["noCommonTimeBase"] = "no_common_time_base";
    UdpOutputStatusCode["lagging"] = "lagging";
})(UdpOutputStatusCode || (exports.UdpOutputStatusCode = UdpOutputStatusCode = {}));

},{}],"kA4yF":[function(require,module,exports,__globalThis) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"dqsfF"}],"dqsfF":[function(require,module,exports,__globalThis) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"cltFt","3a79976eb46af94a":"gM7YB","bc83a05a4f99d69b":"aKTSf","e6b4c3e6c85df6bb":"7HkQg","f340cc553ba5643c":"c7Ii5","e72e99883a50402d":"aNaSh","dc840ead07f1054":"lWbYv","309288e8ee190af0":"4A2Va","687fa30fede0b048":"7bLYw","bb0ba724f98b094d":"lOHy9","12bae1dca0e83064":"iZ6gY","4c3204eaea28d680":"1chae","fd7741200b462cdf":"cSkwN","f93a1d24ac08e076":"jeUN0","630039e80f692f17":"fGkGx","f37949484ab52dae":"1DVeR","ac876cc65d29c86e":"26W2O","1056c031d98783c0":"hm6iH","1800fb3122907fc2":"6hgJK","31f022f648037bd3":"7SeAd","5f3267fbd9848a7d":"9qKxr","7d3f3bdc4f2e7bb8":"6emcB"}],"cltFt":[function(require,module,exports,__globalThis) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"iugcK","ceda2a63c77c915":"5KcsT","91ee1b348d9d7172":"hJzOg","3fe28318f65b9332":"ck5Lg","724ca4def8b84e06":"Ez0QG","e9ceacb40d9582bd":"iepWB"}],"iugcK":[function(require,module,exports,__globalThis) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"5b3H7","b700cb849df2c166":"bZ5tW","d76dd90eead6cced":"11sMk","3d210628ba60ec8":"TkrmM","76026bf2d4cfff93":"cCYah"}],"5b3H7":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"bZ5tW":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"5AZA1"}],"5AZA1":[function(require,module,exports,__globalThis) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"evtiM"}],"evtiM":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"11sMk":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"5AZA1"}],"TkrmM":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"5AZA1"}],"cCYah":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"5AZA1"}],"5KcsT":[function(require,module,exports,__globalThis) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"iugcK"}],"hJzOg":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"ck5Lg":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"Ez0QG":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"iepWB":[function(require,module,exports,__globalThis) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"iugcK","1494efbafafa9552":"bEqpc","6049e8027fe9407f":"lV1BE"}],"bEqpc":[function(require,module,exports,__globalThis) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"ed0752fe9f482107":"bz0ok","29224713b8d411e6":"gVq56"}],"bz0ok":[function(require,module,exports,__globalThis) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"i4SFU","16db51a0e009bd8c":"fQ3rQ"}],"i4SFU":[function(require,module,exports,__globalThis) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"3A7xI","cabbc2adfaeb27d9":"eUAv3","cbb5703fe1562e7f":"6hgJK","388b819f47a43aa5":"2HVCC"}],"3A7xI":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"5ltt8","3cba3c966459d528":"6hgJK"}],"5ltt8":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"crlKT","9b2aaf31b7bdd837":"66zQh","46d5beb3375f8a28":"7zYCt"}],"crlKT":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"gVq56"}],"gVq56":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"egvmL"}],"egvmL":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"66zQh":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"crlKT"}],"7zYCt":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"6hgJK":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"eUAv3":[function(require,module,exports,__globalThis) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"h0VAr"}],"h0VAr":[function(require,module,exports,__globalThis) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"gVq56"}],"2HVCC":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"fQ3rQ":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"lV1BE":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"6JGdu","d2967b0e32ccfa56":"jD16i","ca21409ea89624c0":"9OB5v","f88fd07f8dd1f67d":"hsHKK","dbf3eae765642a3b":"5bQCB"}],"6JGdu":[function(require,module,exports,__globalThis) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"1q5yZ","a07dcf3fd3097a0c":"iugcK","92c01c953ef00ded":"bEqpc"}],"1q5yZ":[function(require,module,exports,__globalThis) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"77BkF","bc25d439ccd1fb47":"jt1rM","f096b37295a92ab0":"finz6","d88173cbc6a133c8":"5E27p","afb9b3bae0461cbf":"giimS"}],"77BkF":[function(require,module,exports,__globalThis) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"lElJo"}],"lElJo":[function(require,module,exports,__globalThis) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"bz0ok"}],"jt1rM":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"finz6":[function(require,module,exports,__globalThis) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"lElJo"}],"5E27p":[function(require,module,exports,__globalThis) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"lElJo"}],"giimS":[function(require,module,exports,__globalThis) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"lElJo"}],"jD16i":[function(require,module,exports,__globalThis) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"hINJU"}],"hINJU":[function(require,module,exports,__globalThis) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"5JCrb"}],"5JCrb":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"9OB5v":[function(require,module,exports,__globalThis) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"hINJU"}],"hsHKK":[function(require,module,exports,__globalThis) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"hINJU"}],"5bQCB":[function(require,module,exports,__globalThis) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"hINJU"}],"gM7YB":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"aKTSf":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"ba13n","b62ef95b3cf1cde1":"evtiM"}],"ba13n":[function(require,module,exports,__globalThis) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"fUDy8"}],"fUDy8":[function(require,module,exports,__globalThis) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"bz0ok"}],"7HkQg":[function(require,module,exports,__globalThis) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"vDc33","fcf23a0242ef0da9":"9qKxr"}],"vDc33":[function(require,module,exports,__globalThis) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"aKTSf","9cddf6ac1a092765":"ba13n"}],"9qKxr":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"aB7KR","e8453365fdacc8da":"f4fT3","7760b47b02971dfa":"kzICo"}],"aB7KR":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"iMrJS","9cdb51ffa56f149b":"bpegN","38cd49f1e493b3d7":"1DVeR","b379831fe1873fed":"26W2O","f362a34cd8321bb7":"bxLaX","c019db5297494469":"hq5rz"}],"iMrJS":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"bpegN":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"5IKlp","bead821d6af018b5":"4gOki"}],"5IKlp":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"5ltt8","b6cdbe52dcf709f8":"4gOki"}],"4gOki":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"1DVeR":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"26W2O":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"gVq56","a1e87b138cf75d1d":"gotX4"}],"gotX4":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"bxLaX":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"hq5rz":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"jRqan","903f50eb1c16d257":"jVyhK","fa49853a82034c30":"bPzLC"}],"jRqan":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"5ltt8","f661b3a120d7a4cb":"aFNSq","cdd86c83797c0618":"4gOki"}],"aFNSq":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"jVyhK":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"bPzLC":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"egvmL"}],"f4fT3":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"6l00J","3ec652610d8dd5d3":"39iyK"}],"6l00J":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"39iyK":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"3OxAn"}],"3OxAn":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"kzICo":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"3A7xI","f3db08d4d1110aaf":"aFNSq"}],"c7Ii5":[function(require,module,exports,__globalThis) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"vDc33","7697a1565646c93":"6emcB"}],"6emcB":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"aB7KR","194eb1a802636842":"5O0AO","ac15afdc3ddd76cd":"kzICo"}],"5O0AO":[function(require,module,exports,__globalThis) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"6hgJK","f7d53cd92b2b977b":"6l00J","c039208a16eb68bd":"8srRf"}],"8srRf":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"aNaSh":[function(require,module,exports,__globalThis) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"gVq56"}],"lWbYv":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"4A2Va":[function(require,module,exports,__globalThis) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"vDc33","39cbde2205d9399c":"igqw1"}],"igqw1":[function(require,module,exports,__globalThis) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"egrke","6b1c62cea92cdb9":"gRVIR"}],"egrke":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"gRVIR":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"7bLYw":[function(require,module,exports,__globalThis) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"vDc33","9b660e6b0c20d303":"IRyaH"}],"IRyaH":[function(require,module,exports,__globalThis) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"8JuEE","6ccae2aa7cfa3c66":"9DBU4","bdb501682ee9305d":"igqw1","7641fe4ae6d2cc96":"gRVIR"}],"8JuEE":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"9DBU4":[function(require,module,exports,__globalThis) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"3OxAn"}],"lOHy9":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"hu5MU","aa79b69a13f924db":"igqw1","e3ad83e53433bc8a":"9qKxr"}],"hu5MU":[function(require,module,exports,__globalThis) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"8JuEE","148b85918856c33a":"1DVeR"}],"iZ6gY":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"hu5MU","feede5d0a2d06427":"IRyaH","287f70f798405911":"6emcB"}],"1chae":[function(require,module,exports,__globalThis) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"7C8Fy","28e3344aae951f13":"bEqpc","b286298be5b1d9a4":"97fST","3ae50c158f89813":"juoJE","9f458755f627d456":"9vICk","8e9160b373d7fe66":"5ltt8","b210627dd951641f":"2HVCC"}],"7C8Fy":[function(require,module,exports,__globalThis) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"a6517d0448dad786":"bz0ok","f83c375075418382":"gVq56"}],"97fST":[function(require,module,exports,__globalThis) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"6940648d854355b5":"bz0ok","a5c6637bac681a0":"gVq56"}],"juoJE":[function(require,module,exports,__globalThis) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"56b792d64741a4ff":"bz0ok","ca486d41cdf819d4":"gVq56"}],"9vICk":[function(require,module,exports,__globalThis) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"4507415bd8810d3c":"bz0ok","7a9a6581834a8452":"gVq56"}],"cSkwN":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"jeUN0":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"ZLaCu","dbf04edaab2ae376":"kzyXT","763300f2dd9bdaf3":"aRqyO","c30e64d90e4b92d1":"2D8ix","d1edd8349e9ad54d":"WFexx"}],"ZLaCu":[function(require,module,exports,__globalThis) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"eHExv"}],"eHExv":[function(require,module,exports,__globalThis) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"gVq56"}],"kzyXT":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"ZLaCu"}],"aRqyO":[function(require,module,exports,__globalThis) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"2D8ix":[function(require,module,exports,__globalThis) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"crlKT"}],"WFexx":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"ZLaCu"}],"fGkGx":[function(require,module,exports,__globalThis) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"5YCvM","8c92276927b7c3e0":"9DBU4","e939f15d7a0f64a5":"6l00J"}],"5YCvM":[function(require,module,exports,__globalThis) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"6hgJK"}],"hm6iH":[function(require,module,exports,__globalThis) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"iXyzE","6a7e6b1a2d9fb1d5":"jVyhK","7d4f449dd306450f":"bPzLC"}],"iXyzE":[function(require,module,exports,__globalThis) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"1chae","88260e33e0003386":"4gOki"}],"7SeAd":[function(require,module,exports,__globalThis) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"2H7vq","3cb35dba719c68b1":"jVyhK","7a3e899a332ff7be":"bPzLC"}],"2H7vq":[function(require,module,exports,__globalThis) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"1chae","b6fc875bc5f351c9":"4gOki"}],"5aY3q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
parcelHelpers.export(exports, "useConfirmationDialog", ()=>useConfirmationDialog);
parcelHelpers.export(exports, "usePageParams", ()=>usePageParams);
// Non-react-js debounce version
// Return the latest value if it's been more than <delay>ms since it was last called.
// Otherwise, it will return the previous value.
parcelHelpers.export(exports, "useDebounce", ()=>useDebounce);
parcelHelpers.export(exports, "useDebouncedCallback", ()=>useDebouncedCallback);
parcelHelpers.export(exports, "useDebouncedFilter", ()=>useDebouncedFilter);
parcelHelpers.export(exports, "useInputsSelector", ()=>useInputsSelector);
parcelHelpers.export(exports, "useOutputsSelector", ()=>useOutputsSelector);
parcelHelpers.export(exports, "useGroupsSelector", ()=>useGroupsSelector);
parcelHelpers.export(exports, "useSettingsSelector", ()=>useSettingsSelector);
parcelHelpers.export(exports, "useAlarmsSelector", ()=>useAlarmsSelector);
parcelHelpers.export(exports, "useAlarmLogsSelector", ()=>useAlarmLogsSelector);
parcelHelpers.export(exports, "useInterfacesSelector", ()=>useInterfacesSelector);
parcelHelpers.export(exports, "useApplianceSelector", ()=>useApplianceSelector);
parcelHelpers.export(exports, "useOutputListsSelector", ()=>useOutputListsSelector);
parcelHelpers.export(exports, "useOutputsWithListsSelector", ()=>useOutputsWithListsSelector);
parcelHelpers.export(exports, "useGroupListsSelector", ()=>useGroupListsSelector);
parcelHelpers.export(exports, "useAuditSelector", ()=>useAuditSelector);
parcelHelpers.export(exports, "useAdAuditSelector", ()=>useAdAuditSelector);
parcelHelpers.export(exports, "useAdCreativeSelector", ()=>useAdCreativeSelector);
parcelHelpers.export(exports, "useAdPodsSelector", ()=>useAdPodsSelector);
parcelHelpers.export(exports, "useAdBreaksSelector", ()=>useAdBreaksSelector);
parcelHelpers.export(exports, "useRegionsSelector", ()=>useRegionsSelector);
parcelHelpers.export(exports, "useAddressMappingSelector", ()=>useAddressMappingSelector);
parcelHelpers.export(exports, "useKubernetesNodesSelector", ()=>useKubernetesNodesSelector);
parcelHelpers.export(exports, "useNetworksSelector", ()=>useNetworksSelector);
parcelHelpers.export(exports, "useUsageSelector", ()=>useUsageSelector);
parcelHelpers.export(exports, "usePageParamsFilteredSelector", ()=>usePageParamsFilteredSelector);
parcelHelpers.export(exports, "usePageParamsFiltered", ()=>usePageParamsFiltered);
parcelHelpers.export(exports, "useSelfStatePagination", ()=>useSelfStatePagination);
parcelHelpers.export(exports, "useUser", ()=>useUser);
parcelHelpers.export(exports, "useIntervalNoInitial", ()=>useIntervalNoInitial);
parcelHelpers.export(exports, "useInterval", ()=>useInterval);
parcelHelpers.export(exports, "useIntervalState", ()=>useIntervalState);
parcelHelpers.export(exports, "useAppliancePhysicalPorts", ()=>useAppliancePhysicalPorts);
parcelHelpers.export(exports, "default", ()=>useWindowDimensions);
parcelHelpers.export(exports, "useMobile", ()=>useMobile);
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _notificationActions = require("../redux/actions/notificationActions");
var _ = require(".");
var _confirmDialog = require("../components/common/ConfirmDialog");
var _types = require("common/api/v1/types");
var _inputsActions = require("../redux/actions/inputsActions");
var _outputsActions = require("../redux/actions/outputsActions");
var _groupActions = require("../redux/actions/groupActions");
var _portActions = require("../redux/actions/portActions");
var _applianceActions = require("../redux/actions/applianceActions");
var _outputListsActions = require("../redux/actions/outputListsActions");
var _groupListsActions = require("../redux/actions/groupListsActions");
var _auditActions = require("../redux/actions/auditActions");
var _alarmLogsActions = require("../redux/actions/alarmLogsActions");
var _regionsActions = require("../redux/actions/regionsActions");
var _applicationException = require("../api/ApplicationException");
var _params = require("./params");
var _addressMappingActions = require("../redux/actions/addressMappingActions");
var _alarmsActions = require("../redux/actions/alarmsActions");
var _k8SActions = require("../redux/actions/k8sActions");
var _networkActions = require("../redux/actions/networkActions");
var _settingsActions = require("../redux/actions/settingsActions");
var _usageActions = require("../redux/actions/usageActions");
var _reactAsyncHook = require("react-async-hook");
var _adCreativeActions = require("../redux/actions/adCreativeActions");
var _adPodActions = require("../redux/actions/adPodActions");
var _adBreakActions = require("../redux/actions/adBreakActions");
const usePrevious = (value)=>{
    const ref = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
const useConfirmationDialog = ()=>{
    const { showConfirmation } = (0, _react.useContext)((0, _confirmDialog.ConfirmDialogContext));
    return showConfirmation;
};
function usePageParams() {
    const navigate = (0, _reactRouter.useNavigate)();
    const location = (0, _reactRouter.useLocation)();
    const pageParams = (0, _react.useMemo)(()=>(0, _params.parseSearchParams)(location.search), [
        location.search
    ]);
    const setPageParams = (newParams)=>{
        if (!newParams) {
            navigate(location.pathname, {
                replace: true
            });
            return;
        }
        const currentParams = new URLSearchParams(location.search);
        for(const key in newParams){
            const value = newParams[key]?.toString();
            if (!value) currentParams.delete(key);
            else {
                currentParams.delete(key) // Delete and set to maintain same order as in newParams
                ;
                currentParams.set(key, value);
            }
        }
        const search = currentParams.toString();
        if (!search) return navigate(location.pathname, {
            replace: true
        });
        return navigate(location.pathname + '?' + search, {
            replace: true
        });
    };
    return [
        pageParams,
        setPageParams
    ];
}
function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, _react.useState)(value);
    (0, _react.useEffect)(()=>{
        if (delay > 0) {
            const handler = setTimeout(()=>setDebouncedValue(value), delay);
            return ()=>clearTimeout(handler);
        } else setDebouncedValue(value);
    }, [
        value
    ]);
    return debouncedValue;
}
const useDebouncedCallback = (func, delay = 200)=>{
    const timeout = (0, _react.useRef)();
    return (0, _react.useCallback)((...args)=>{
        const later = ()=>{
            clearTimeout(timeout.current);
            func(...args);
        };
        clearTimeout(timeout.current);
        timeout.current = setTimeout(later, delay);
    }, [
        func,
        delay
    ]);
};
const useDebouncedFilter = (filter, onChange, onInit = false)=>{
    const [debouncedFilter, setDebouncedFilter] = (0, _react.useState)(filter);
    const timer = (0, _react.useRef)();
    const clearTimer = ()=>timer.current && clearTimeout(timer.current);
    (0, _react.useEffect)(()=>{
        clearTimer();
        timer.current = setTimeout(()=>setDebouncedFilter(filter), 500);
        return clearTimer;
    }, [
        filter
    ]);
    const [initial, setInitial] = (0, _react.useState)(!onInit);
    (0, _react.useEffect)(()=>{
        onChange && !initial && onChange(debouncedFilter);
        setInitial(false);
    }, [
        debouncedFilter
    ]);
    return debouncedFilter;
};
/**
 * helper to get the entity selector based on api requests
 * @param action: action to dispatch to get entities
 * @param reducer: reducer name from the redux store to get values from
 * @param requestParams: api request params to dispatch action with
 */ const useEntitySelector = (action, reducer, requestParams)=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        switch(reducer){
            case 'inputsReducer':
                dispatch((0, _inputsActions.clearInputs)());
                break;
            case 'outputsReducer':
                dispatch((0, _outputsActions.clearOutputs)());
                break;
            case 'groupsReducer':
                dispatch((0, _groupActions.clearGroups)());
                break;
            case 'alarmsReducer':
                dispatch((0, _alarmsActions.clearAlarms)());
                break;
            case 'portsReducer':
                dispatch((0, _portActions.clearPorts)());
                break;
            case 'appliancesReducer':
                dispatch((0, _applianceActions.clearAppliances)());
                break;
            case 'outputListsReducer':
                dispatch((0, _outputListsActions.clearOutputLists)());
                break;
            case 'regionsReducer':
                dispatch((0, _regionsActions.clearRegions)());
                break;
            case 'addressMappingsReducer':
                dispatch((0, _addressMappingActions.clearIpMappings)());
                break;
            case 'k8sReducer':
                dispatch((0, _k8SActions.clearKubernetesNodes)());
                break;
            default:
        }
    }, [
        dispatch
    ]);
    (0, _react.useEffect)(()=>{
        const promise = dispatch(action(requestParams));
        return ()=>{
            promise.abort();
        };
    }, [
        dispatch,
        Object.entries(requestParams).join(',')
    ]);
    return (0, _reactRedux.useSelector)((state)=>state[reducer], (0, _reactRedux.shallowEqual));
};
const useInputsSelector = (requestParams)=>useEntitySelector((0, _inputsActions.getInputs), 'inputsReducer', requestParams);
const useOutputsSelector = (requestParams)=>useEntitySelector((0, _outputsActions.getOutputs), 'outputsReducer', requestParams);
const useGroupsSelector = (requestParams)=>useEntitySelector((0, _groupActions.getGroups), 'groupsReducer', requestParams);
const useSettingsSelector = ()=>useEntitySelector((0, _settingsActions.getSettings), 'settingsReducer', {
        pageNumber: '0',
        rowsPerPage: '0'
    });
const useAlarmsSelector = (requestParams)=>useEntitySelector((0, _alarmsActions.getAlarms), 'alarmsReducer', requestParams);
const useAlarmLogsSelector = (requestParams)=>useEntitySelector((0, _alarmLogsActions.getAlarmLogs), 'alarmLogsReducer', requestParams);
const useInterfacesSelector = (requestParams)=>useEntitySelector((0, _portActions.getPorts), 'portsReducer', requestParams);
const useApplianceSelector = (requestParams)=>useEntitySelector((0, _applianceActions.getAppliances), 'appliancesReducer', requestParams);
const useOutputListsSelector = (requestParams)=>useEntitySelector((0, _outputListsActions.getOutputLists), 'outputListsReducer', requestParams);
const useOutputsWithListsSelector = (requestParams)=>useEntitySelector((0, _outputsActions.getOutputsWithLists), 'outputsReducer', requestParams);
const useGroupListsSelector = (requestParams)=>useEntitySelector((0, _groupListsActions.getGroupLists), 'groupListsReducer', requestParams);
const useAuditSelector = (requestParams)=>useEntitySelector((0, _auditActions.getAudit), 'auditReducer', requestParams);
const useAdAuditSelector = (requestParams)=>useEntitySelector((0, _auditActions.getAudit), 'adAuditReducer', requestParams);
const useAdCreativeSelector = (requestParams)=>useEntitySelector((0, _adCreativeActions.listAdCreatives), 'adCreativeReducer', requestParams);
const useAdPodsSelector = (requestParams)=>useEntitySelector((0, _adPodActions.listAdPods), 'adPodReducer', requestParams);
const useAdBreaksSelector = (requestParams)=>useEntitySelector((0, _adBreakActions.listAdBreaks), 'adBreakReducer', requestParams);
const useRegionsSelector = (requestParams)=>useEntitySelector((0, _regionsActions.getRegions), 'regionsReducer', requestParams);
const useAddressMappingSelector = (requestParams)=>useEntitySelector((0, _addressMappingActions.getIpMappings), 'addressMappingReducer', requestParams);
const useKubernetesNodesSelector = (requestParams)=>useEntitySelector((0, _k8SActions.getKubernetesNodes), 'k8sReducer', requestParams);
const useNetworksSelector = (requestParams)=>useEntitySelector((0, _networkActions.getNetworks), 'networksReducer', requestParams);
const useUsageSelector = (requestParams)=>useEntitySelector((0, _usageActions.readUsage), 'usageReducer', requestParams);
const usePageParamsFilteredSelector = (selectorHook, initialPageParams = {})=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [params, setPageParams] = usePageParams();
    (0, _react.useEffect)(()=>{
        setPageParams(initialPageParams);
    }, [
        dispatch
    ]);
    return selectorHook((0, _.withDefaultPagination)(Object.assign(params, initialPageParams)));
};
const usePageParamsFiltered = (initialPageParams = {})=>{
    const [params, setPageParams] = usePageParams();
    (0, _react.useEffect)(()=>{
        setPageParams(initialPageParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, _.withDefaultPagination)(Object.assign(params, initialPageParams));
};
const useSelfStatePagination = ({ params, api, updateOn, ignore = false })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { filter = '', ...rest } = params;
    const debouncedFilter = useDebouncedFilter(filter);
    const [state, setState] = (0, _react.useState)({
        items: [],
        total: 0
    });
    const [loading, setLoading] = (0, _react.useState)(false);
    const [updateFlag, setUpdateFlag] = (0, _react.useState)(false);
    const [isFirst, setIsFirst] = (0, _react.useState)(true);
    (0, _react.useEffect)(()=>{
        if (!isFirst) setUpdateFlag(!updateFlag);
        setIsFirst(false);
    }, [
        updateOn
    ]);
    const fetchPage = async ()=>{
        setLoading(true);
        try {
            const parameters = {
                filter: debouncedFilter,
                ...rest
            };
            const withDefault = (0, _.withDefaultPagination)(parameters);
            const res = await api(withDefault);
            setState(res);
        } catch (error) {
            const applicationException = (0, _applicationException.makeApplicationException)(error);
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: applicationException
            }));
        }
        setLoading(false);
    };
    (0, _react.useEffect)(()=>{
        // Prevent multiple changes (i.e. change of filter + something else) to fire 2 requests: 1 immediately and the second one after debounce :
        // This effect is triggered one or more properties have changed, e.g. either filter, pageNumber, rowsPerPage, etc.
        // If something other than the filter has changed, e.g. pageNumber, then we go ahead and fetch.
        // If the filter has changed (either alone or together with other properties, e.g. pageNumber) we wait until the debounce.
        const shouldWaitForDebounce = debouncedFilter != filter;
        if (shouldWaitForDebounce) return;
        !ignore && fetchPage();
    }, [
        Object.values({
            ...rest,
            updateFlag
        }).concat(debouncedFilter).join(',')
    ]);
    return {
        ...state,
        loading
    };
};
const useUser = ()=>{
    return (0, _reactRedux.useSelector)(({ userReducer })=>userReducer.user, (0, _reactRedux.shallowEqual));
};
const useIntervalNoInitial = (callback, delay)=>{
    const savedCallback = (0, _react.useRef)(callback);
    // Remember the latest callback if it changes.
    (0, _react.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, _react.useEffect)(()=>{
        // Don't schedule if no delay is specified.
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>clearInterval(id);
    }, [
        delay
    ]);
};
function useInterval(callback, delay) {
    const callbackRef = (0, _react.useRef)(callback);
    const timerIdRef = (0, _react.useRef)(null);
    const isCancelledRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const clearTimer = ()=>{
        if (timerIdRef.current !== null) {
            clearTimeout(timerIdRef.current);
            timerIdRef.current = null;
        }
    };
    const tick = (0, _react.useCallback)(async ()=>{
        if (isCancelledRef.current) return;
        try {
            await callbackRef.current();
        } catch  {
        // Ignore errors
        }
        if (isCancelledRef.current) return;
        timerIdRef.current = setTimeout(()=>void tick(), delay);
    }, [
        delay
    ]);
    // Manual trigger: runs immediately and restarts timer
    const trigger = (0, _react.useCallback)(()=>{
        clearTimer();
        tick();
    }, [
        tick
    ]);
    (0, _react.useEffect)(()=>{
        isCancelledRef.current = false;
        tick();
        return ()=>{
            isCancelledRef.current = true;
            clearTimer();
        };
    }, [
        tick
    ]);
    return {
        trigger
    };
}
function useIntervalState(callback, delay) {
    const [state, setState] = (0, _react.useState)();
    const { trigger } = useInterval(async ()=>{
        setState(await callback());
    }, delay);
    return state === undefined ? {
        hasResult: false,
        trigger
    } : {
        hasResult: true,
        result: state,
        trigger
    };
}
const useAppliancePhysicalPorts = (selectedAppliance, applianceApi, direction, requestingServiceId)=>{
    const { result, error, loading } = (0, _reactAsyncHook.useAsync)(async ()=>{
        if (!selectedAppliance?.id) return undefined;
        const physicalPorts = await applianceApi.listAppliancePhysicalPorts(selectedAppliance.id);
        return physicalPorts.filter((p)=>!p.direction || p.direction === direction).map((p)=>{
            const conflictingPorts = p.occupiedPorts.filter((op)=>{
                const belongsToOtherInput = op.inputId && op.inputId !== requestingServiceId;
                const belongsToOtherOutput = op.outputId && op.outputId !== requestingServiceId;
                return !!belongsToOtherInput || !!belongsToOtherOutput // else belongs to the requesting input/output - i.e. not conflicting
                ;
            });
            return {
                ...p,
                occupiedPorts: conflictingPorts
            };
        }).sort((p1, p2)=>{
            if (p1.portType !== (0, _types.PortType).ip && p2.portType === (0, _types.PortType).ip) return -1;
            if (p2.portType !== (0, _types.PortType).ip && p1.portType === (0, _types.PortType).ip) return 1;
            return 0;
        });
    }, [
        selectedAppliance?.id
    ]);
    return {
        result,
        error,
        loading
    };
};
function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}
function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = (0, _react.useState)(getWindowDimensions());
    (0, _react.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    return windowDimensions;
}
function useMobile() {
    const windowDimensions = useWindowDimensions();
    return {
        isMobile: windowDimensions.width < 768
    };
}

},{"react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","../redux/actions/notificationActions":"7LkQg",".":"342UB","../components/common/ConfirmDialog":"7JKPn","common/api/v1/types":"3qemx","../redux/actions/inputsActions":"l0Ua8","../redux/actions/outputsActions":"alMzI","../redux/actions/groupActions":"bqPI2","../redux/actions/portActions":"5YSBF","../redux/actions/applianceActions":"TaoIu","../redux/actions/outputListsActions":"ce4Vm","../redux/actions/groupListsActions":"k9GYr","../redux/actions/auditActions":"jEYBl","../redux/actions/alarmLogsActions":"gRXht","../redux/actions/regionsActions":"d48MN","../api/ApplicationException":"5oMBs","./params":"5D6YE","../redux/actions/addressMappingActions":"aRUIy","../redux/actions/alarmsActions":"2PZQF","../redux/actions/k8sActions":"lYa8m","../redux/actions/networkActions":"gfZop","../redux/actions/settingsActions":"4RBnR","../redux/actions/usageActions":"6CX5c","react-async-hook":"3D6Y9","../redux/actions/adCreativeActions":"gzqhz","../redux/actions/adPodActions":"2olSr","../redux/actions/adBreakActions":"baydX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7JKPn":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-empty-function */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmDialogContext", ()=>ConfirmDialogContext);
parcelHelpers.export(exports, "ConfirmDialogProvider", ()=>ConfirmDialogProvider);
parcelHelpers.export(exports, "ConfirmationDialogResult", ()=>ConfirmationDialogResult);
parcelHelpers.export(exports, "useConfirmationDialog", ()=>useConfirmationDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
const ConfirmDialogContext = /*#__PURE__*/ (0, _react.createContext)({
    showConfirmation: ()=>{},
    hideConfirmation: ()=>{},
    isShown: false,
    onOkAction: ()=>{},
    onCancelAction: ()=>{},
    comp: undefined,
    confirmText: undefined,
    buttonProps: undefined
});
/**
 * Common confirm dialog to be shown
 */ const ConfirmDialog = ()=>{
    const { hideConfirmation, isShown, onOkAction, onCancelAction, comp, confirmText, buttonProps } = (0, _react.useContext)(ConfirmDialogContext);
    const { text: textOk = 'OK', ...restOk } = (buttonProps || {
        ok: {
            text: 'OK'
        }
    }).ok || {};
    const { text: textCancel = 'Cancel', ...restCancel } = (buttonProps || {
        cancel: {
            text: 'Cancel'
        }
    }).cancel || {};
    const [confirmTextValue, setConfirmTextValue] = (0, _react.useState)('');
    const [closeReason, setCloseReason] = (0, _react.useState)('cancel');
    const handleOk = ()=>{
        setCloseReason('ok');
        hideConfirmation();
        setConfirmTextValue('');
    };
    const handleClose = ()=>{
        setCloseReason('cancel');
        hideConfirmation();
        setConfirmTextValue('');
    };
    /* Callback after transition */ const handleTransitionExited = ()=>{
        closeReason === 'ok' ? onOkAction?.() : onCancelAction?.();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: isShown,
        disableRestoreFocus: true,
        onClose: (_event, reason)=>{
            if (reason === 'backdropClick') return;
            handleClose();
        },
        onTransitionExited: handleTransitionExited,
        "data-test-id": "confirm-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentTextDefault.default), {
                        gutterBottom: true,
                        component: "div",
                        children: comp
                    }),
                    confirmText && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentTextDefault.default), {
                                gutterBottom: true,
                                children: [
                                    "To confirm, type",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            fontStyle: 'italic',
                                            fontWeight: 'bold'
                                        },
                                        "data-test-id": "confirm-text-value",
                                        children: confirmText?.toLowerCase()
                                    }),
                                    ' ',
                                    "below"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                "data-test-id": "confirm-text-field",
                                autoFocus: true,
                                fullWidth: true,
                                placeholder: confirmText?.toLowerCase(),
                                value: confirmTextValue,
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter' && confirmTextValue.toLowerCase() === confirmText.toLowerCase()) handleOk();
                                },
                                onChange: (e)=>setConfirmTextValue(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogActionsDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "outlined",
                        color: "secondary",
                        onClick: handleClose,
                        "data-test-id": "cancel-btn",
                        ...restCancel,
                        children: textCancel
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        "data-test-id": "ok-btn",
                        variant: "contained",
                        color: "primary",
                        disabled: confirmText ? confirmTextValue.toLowerCase() !== confirmText?.toLowerCase() : false,
                        onClick: handleOk,
                        ...restOk,
                        children: textOk
                    })
                ]
            })
        ]
    });
};
const ConfirmDialogProvider = ({ children })=>{
    const [state, setState] = (0, _react.useState)({
        isShown: false,
        onOkAction: undefined,
        comp: undefined,
        buttonProps: undefined
    });
    const value = {
        showConfirmation: (onOkAction, comp, confirmText, buttonProps, onCancelAction)=>setState({
                isShown: true,
                onOkAction,
                onCancelAction,
                comp,
                confirmText,
                buttonProps
            }),
        hideConfirmation: ()=>setState({
                isShown: false,
                onOkAction: state.onOkAction,
                comp: state.comp,
                confirmText: state.confirmText,
                buttonProps: state.buttonProps
            }),
        ...state
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ConfirmDialogContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmDialog, {})
        ]
    });
};
var ConfirmationDialogResult = /*#__PURE__*/ function(ConfirmationDialogResult) {
    ConfirmationDialogResult[ConfirmationDialogResult["OK"] = 0] = "OK";
    ConfirmationDialogResult[ConfirmationDialogResult["Cancel"] = 1] = "Cancel";
    return ConfirmationDialogResult;
}({});
const useConfirmationDialog = ()=>{
    const { showConfirmation, hideConfirmation } = (0, _react.useContext)(ConfirmDialogContext);
    const showConfirmationAsync = (comp, confirmText, buttonProps)=>{
        return new Promise((resolve)=>{
            showConfirmation(()=>resolve(0), comp, confirmText, buttonProps, ()=>resolve(1));
        });
    };
    return {
        showConfirmation,
        showConfirmationAsync,
        hideConfirmation
    };
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Dialog":"aOxpM","@mui/material/DialogActions":"h1RVn","@mui/material/DialogContent":"l4i9c","@mui/material/DialogContentText":"7bReD","@mui/material/Button":"3qJY9","@mui/material/TextField":"l88b4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aOxpM":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("74ca1d6f8f78fdf3").default;
var _interopRequireDefault = require("1dc81bb2fcd0b35a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dialogClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Dialog.default;
    }
});
Object.defineProperty(exports, "dialogClasses", {
    enumerable: true,
    get: function() {
        return _dialogClasses.default;
    }
});
var _Dialog = _interopRequireDefault(require("8ba6156418f81d5e"));
var _dialogClasses = _interopRequireWildcard(require("37726e4bcef867ae"));
Object.keys(_dialogClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dialogClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dialogClasses[key];
        }
    });
});

},{"74ca1d6f8f78fdf3":"fiRIh","1dc81bb2fcd0b35a":"kZ6eK","8ba6156418f81d5e":"ihf2y","37726e4bcef867ae":"1DsZ8"}],"ihf2y":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("71b64f6647bc14e8").default;
var _interopRequireWildcard = require("e284479366a7820a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d2b6ff6fa5edccc5"));
var _propTypes = _interopRequireDefault(require("e473a0a5f168159e"));
var _clsx = _interopRequireDefault(require("62bf0b577b71b1a"));
var _composeClasses = _interopRequireDefault(require("432bca16102a2497"));
var _useId = _interopRequireDefault(require("51b3a029b8f21658"));
var _capitalize = _interopRequireDefault(require("e4be56fa6b313fe2"));
var _Modal = _interopRequireDefault(require("325df8711ed74448"));
var _Fade = _interopRequireDefault(require("292b35a4073a122"));
var _Paper = _interopRequireDefault(require("a09fa162736245b"));
var _dialogClasses = _interopRequireWildcard(require("ff5cbb02037a6e99"));
var _DialogContext = _interopRequireDefault(require("a63c70e80ed4c60c"));
var _Backdrop = _interopRequireDefault(require("a672660a9394c1ab"));
var _zeroStyled = require("c3cb9db128d7d32a");
var _memoTheme = _interopRequireDefault(require("86c873ae8627122"));
var _DefaultPropsProvider = require("ea556a5ac4712d63");
var _useSlot = _interopRequireDefault(require("d0c41022181dcd3a"));
var _jsxRuntime = require("ea4db0e0c9256d94");
const DialogBackdrop = (0, _zeroStyled.styled)(_Backdrop.default, {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const useUtilityClasses = (ownerState)=>{
    const { classes, scroll, maxWidth, fullWidth, fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, _capitalize.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, _capitalize.default)(scroll)}`,
            `paperWidth${(0, _capitalize.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, _composeClasses.default)(slots, _dialogClasses.getDialogUtilityClass, classes);
};
const DialogRoot = (0, _zeroStyled.styled)(_Modal.default, {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const DialogContainer = (0, _zeroStyled.styled)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, _capitalize.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const DialogPaper = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, _capitalize.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, _capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${_dialogClasses.default.paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${_dialogClasses.default.paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${_dialogClasses.default.paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const Dialog = /*#__PURE__*/ React.forwardRef(function Dialog(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, _zeroStyled.useTheme)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent, BackdropProps, children, className, disableEscapeKeyDown = false, fullScreen = false, fullWidth = false, maxWidth = 'sm', onClick, onClose, open, PaperComponent = _Paper.default, PaperProps = {}, scroll = 'paper', slots = {}, slotProps = {}, TransitionComponent = _Fade.default, transitionDuration = defaultTransitionDuration, TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown,
        fullScreen,
        fullWidth,
        maxWidth,
        scroll
    };
    const classes = useUtilityClasses(ownerState);
    const backdropClick = React.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, _useId.default)(ariaLabelledbyProp);
    const dialogContextValue = React.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        elementType: DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, _useSlot.default)('backdrop', {
        elementType: DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, _useSlot.default)('paper', {
        elementType: DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        ownerState,
        className: (0, _clsx.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, _useSlot.default)('container', {
        elementType: DialogContainer,
        externalForwardedProps,
        ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, _useSlot.default)('transition', {
        elementType: _Fade.default,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DialogContext.default.Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var _default = exports.default = Dialog;

},{"71b64f6647bc14e8":"kZ6eK","e284479366a7820a":"fiRIh","d2b6ff6fa5edccc5":"9njXz","e473a0a5f168159e":"bnNSm","62bf0b577b71b1a":"d2NWs","432bca16102a2497":"59Equ","51b3a029b8f21658":"50qgI","e4be56fa6b313fe2":"eOYSA","325df8711ed74448":"6Q8b8","292b35a4073a122":"c0CXk","a09fa162736245b":"aexCI","ff5cbb02037a6e99":"1DsZ8","a63c70e80ed4c60c":"9TzT8","a672660a9394c1ab":"9g9OF","c3cb9db128d7d32a":"hZXDo","86c873ae8627122":"cJNjb","ea556a5ac4712d63":"9bD8g","d0c41022181dcd3a":"h76AU","ea4db0e0c9256d94":"1dlk8"}],"6Q8b8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("b8a01a3f90b5fa45").default;
var _interopRequireDefault = require("543b78a0cd4ab93f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    ModalManager: true,
    modalClasses: true
};
Object.defineProperty(exports, "ModalManager", {
    enumerable: true,
    get: function() {
        return _ModalManager.ModalManager;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Modal.default;
    }
});
Object.defineProperty(exports, "modalClasses", {
    enumerable: true,
    get: function() {
        return _modalClasses.default;
    }
});
var _ModalManager = require("e637f6c3f1f5320e");
var _Modal = _interopRequireDefault(require("95210f8dbf21bba6"));
var _modalClasses = _interopRequireWildcard(require("cefc898e9a9c92fa"));
Object.keys(_modalClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _modalClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _modalClasses[key];
        }
    });
});

},{"b8a01a3f90b5fa45":"fiRIh","543b78a0cd4ab93f":"kZ6eK","e637f6c3f1f5320e":"1rqLY","95210f8dbf21bba6":"aa5fH","cefc898e9a9c92fa":"2XlRR"}],"1rqLY":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f57427b08da14b8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalManager = void 0;
exports.ariaHidden = ariaHidden;
var _ownerWindow = _interopRequireDefault(require("78248113be9c2f6a"));
var _ownerDocument = _interopRequireDefault(require("4ae7620f39e15f23"));
var _getScrollbarSize = _interopRequireDefault(require("f6a52ed9aaf6855b"));
// Is a vertical scrollbar displayed?
function isOverflowing(container) {
    const doc = (0, _ownerDocument.default)(container);
    if (doc.body === container) return (0, _ownerWindow.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function getPaddingRight(element) {
    return parseInt((0, _ownerWindow.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) ariaHidden(element, hide);
    });
}
function findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if (isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, _getScrollbarSize.default)((0, _ownerWindow.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, _ownerDocument.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, _ownerWindow.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value, el, property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ class ModalManager {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) ariaHidden(modal.modalRef, false);
        const hiddenSiblings = getHiddenSiblings(container);
        ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container,
            restore: null,
            hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            ariaHidden(modal.modalRef, ariaHiddenState);
            ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) ariaHidden(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}
exports.ModalManager = ModalManager;

},{"f57427b08da14b8":"kZ6eK","78248113be9c2f6a":"hiDmU","4ae7620f39e15f23":"8VgUE","f6a52ed9aaf6855b":"3Gyjq"}],"3Gyjq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7793e2f1dba572e5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _getScrollbarSize.default;
    }
});
var _getScrollbarSize = _interopRequireDefault(require("60a9403d6dbac79"));

},{"7793e2f1dba572e5":"kZ6eK","60a9403d6dbac79":"1pYuy"}],"1pYuy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

},{}],"aa5fH":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("99f35d8764cd715d").default;
var _interopRequireWildcard = require("fd38b1f6ce503090").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("68bf48cb43b91c7d"));
var _propTypes = _interopRequireDefault(require("864347d6ee6aafaf"));
var _clsx = _interopRequireDefault(require("a60156eb8e9fa189"));
var _HTMLElementType = _interopRequireDefault(require("25a3fa1e5bd32cb0"));
var _elementAcceptingRef = _interopRequireDefault(require("7b538dd6cfe307ce"));
var _composeClasses = _interopRequireDefault(require("99d8feb74c01b1ae"));
var _Unstable_TrapFocus = _interopRequireDefault(require("78d3862d10e299b0"));
var _Portal = _interopRequireDefault(require("f13a625a5a3420d7"));
var _zeroStyled = require("ebff343097bc2168");
var _memoTheme = _interopRequireDefault(require("23c6c5c3504067c1"));
var _DefaultPropsProvider = require("e60809c83c857d15");
var _Backdrop = _interopRequireDefault(require("dd927a31debeda27"));
var _useModal = _interopRequireDefault(require("da875099b158a6d"));
var _modalClasses = require("2cafcd6275373f0b");
var _useSlot = _interopRequireDefault(require("cca0ce791c662d3d"));
var _jsxRuntime = require("7906e0a8ad12a51f");
const useUtilityClasses = (ownerState)=>{
    const { open, exited, classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, _composeClasses.default)(slots, _modalClasses.getModalUtilityClass, classes);
};
const ModalRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const ModalBackdrop = (0, _zeroStyled.styled)(_Backdrop.default, {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const Modal = /*#__PURE__*/ React.forwardRef(function Modal(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent = ModalBackdrop, BackdropProps, classes: classesProp, className, closeAfterTransition = false, children, container, component, components = {}, componentsProps = {}, disableAutoFocus = false, disableEnforceFocus = false, disableEscapeKeyDown = false, disablePortal = false, disableRestoreFocus = false, disableScrollLock = false, hideBackdrop = false, keepMounted = false, onClose, onTransitionEnter, onTransitionExited, open, slotProps = {}, slots = {}, // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition,
        disableAutoFocus,
        disableEnforceFocus,
        disableEscapeKeyDown,
        disablePortal,
        disableRestoreFocus,
        disableScrollLock,
        hideBackdrop,
        keepMounted
    };
    const { getRootProps, getBackdropProps, getTransitionProps, portalRef, isTopModal, exited, hasTransition } = (0, _useModal.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited
    };
    const classes = useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter, onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        ref,
        elementType: ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component
        },
        getSlotProps: getRootProps,
        ownerState,
        className: (0, _clsx.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, _useSlot.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, _clsx.default)(BackdropProps?.className, classes?.backdrop),
        ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Portal.default, {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Unstable_TrapFocus.default, {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ React.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var _default = exports.default = Modal;

},{"99f35d8764cd715d":"kZ6eK","fd38b1f6ce503090":"fiRIh","68bf48cb43b91c7d":"9njXz","864347d6ee6aafaf":"bnNSm","a60156eb8e9fa189":"d2NWs","25a3fa1e5bd32cb0":"eESPP","7b538dd6cfe307ce":"doIJ9","99d8feb74c01b1ae":"59Equ","78d3862d10e299b0":"9ifty","f13a625a5a3420d7":"kRqG5","ebff343097bc2168":"hZXDo","23c6c5c3504067c1":"cJNjb","e60809c83c857d15":"9bD8g","dd927a31debeda27":"9g9OF","da875099b158a6d":"cTwxl","2cafcd6275373f0b":"2XlRR","cca0ce791c662d3d":"h76AU","7906e0a8ad12a51f":"1dlk8"}],"eESPP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("89e8fb25f09695e1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _HTMLElementType.default;
    }
});
var _HTMLElementType = _interopRequireDefault(require("88ee6fc53668f5c7"));

},{"89e8fb25f09695e1":"kZ6eK","88ee6fc53668f5c7":"9UTM3"}],"9UTM3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HTMLElementType;
function HTMLElementType(props, propName, componentName, location, propFullName) {
    return null;
}

},{}],"doIJ9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7fc48d3f4c1a7848").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _elementAcceptingRef.default;
    }
});
var _elementAcceptingRef = _interopRequireDefault(require("33b2c982f56ea448"));

},{"7fc48d3f4c1a7848":"kZ6eK","33b2c982f56ea448":"1Kq8s"}],"1Kq8s":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2e0404c999c8e2a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("2c3874f1da222af4"));
var _chainPropTypes = _interopRequireDefault(require("dd4339d41498058b"));
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === 'function' && !isClassComponent(elementType)) warningHint = 'Did you accidentally use a plain function component for an element instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
const elementAcceptingRef = (0, _chainPropTypes.default)(_propTypes.default.element, acceptingRef);
elementAcceptingRef.isRequired = (0, _chainPropTypes.default)(_propTypes.default.element.isRequired, acceptingRef);
var _default = exports.default = elementAcceptingRef;

},{"2e0404c999c8e2a":"kZ6eK","2c3874f1da222af4":"bnNSm","dd4339d41498058b":"4stnp"}],"9ifty":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8bb5738900eb7519").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FocusTrap.default;
    }
});
var _FocusTrap = _interopRequireDefault(require("49901fda82ad011a"));

},{"8bb5738900eb7519":"kZ6eK","49901fda82ad011a":"hZaJu"}],"hZaJu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ var _interopRequireDefault = require("67d8d4467cdd2fa4").default;
var _interopRequireWildcard = require("ed433a7b2789741a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("106e17caf89cb855"));
var _propTypes = _interopRequireDefault(require("b585109415d3400"));
var _useForkRef = _interopRequireDefault(require("d41927cbe3f166d0"));
var _ownerDocument = _interopRequireDefault(require("ffc9a2c84f50e76b"));
var _getReactElementRef = _interopRequireDefault(require("1988925517ac4f1c"));
var _exactProp = _interopRequireDefault(require("55bdb78405064931"));
var _elementAcceptingRef = _interopRequireDefault(require("a6d4c3d282d9d833"));
var _jsxRuntime = require("8806cbc8fddda6c5");
// Inspired by https://github.com/focus-trap/tabbable
const candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) return false;
    return true;
}
function defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = getTabIndex(node);
        if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function FocusTrap(props) {
    const { children, disableAutoFocus = false, disableEnforceFocus = false, disableRestoreFocus = false, getTabbable = defaultGetTabbable, isEnabled = defaultIsEnabled, open } = props;
    const ignoreNextEnforceFocus = React.useRef(false);
    const sentinelStart = React.useRef(null);
    const sentinelEnd = React.useRef(null);
    const nodeToRestore = React.useRef(null);
    const reactFocusEventTarget = React.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = React.useRef(false);
    const rootRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)((0, _getReactElementRef.default)(children), rootRef);
    const lastKeydown = React.useRef(null);
    React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _ownerDocument.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _ownerDocument.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ React.cloneElement(children, {
                ref: handleRef,
                onFocus
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var _default = exports.default = FocusTrap;

},{"67d8d4467cdd2fa4":"kZ6eK","ed433a7b2789741a":"fiRIh","106e17caf89cb855":"9njXz","b585109415d3400":"bnNSm","d41927cbe3f166d0":"4xKTx","ffc9a2c84f50e76b":"8VgUE","1988925517ac4f1c":"gaXcx","55bdb78405064931":"jInuK","a6d4c3d282d9d833":"doIJ9","8806cbc8fddda6c5":"1dlk8"}],"gaXcx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ba38391dd04895bb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _getReactElementRef.default;
    }
});
var _getReactElementRef = _interopRequireDefault(require("d5faa0be1bd4dc03"));

},{"ba38391dd04895bb":"kZ6eK","d5faa0be1bd4dc03":"lMT7O"}],"lMT7O":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e26e8640d8955c2a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getReactElementRef;
var React = _interopRequireWildcard(require("729ffe9102f7414d"));
/**
 * Returns the ref of a React element handling differences between React 19 and older versions.
 * It will throw runtime error if the element is not a valid React element.
 *
 * @param element React.ReactElement
 * @returns React.Ref<any> | null
 */ function getReactElementRef(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt(React.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

},{"e26e8640d8955c2a":"fiRIh","729ffe9102f7414d":"9njXz"}],"kRqG5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e8ce880a7e90a07").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Portal.default;
    }
});
var _Portal = _interopRequireDefault(require("4e4af648b3d26b7e"));

},{"e8ce880a7e90a07":"kZ6eK","4e4af648b3d26b7e":"8YUDu"}],"8YUDu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e3ffe1e4676279bf").default;
var _interopRequireWildcard = require("880d78b19d46e4e3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("b1a238d480106920"));
var ReactDOM = _interopRequireWildcard(require("c99df8e0c6870c09"));
var _propTypes = _interopRequireDefault(require("c4e1178c39923835"));
var _useEnhancedEffect = _interopRequireDefault(require("aecb918d27c9940c"));
var _useForkRef = _interopRequireDefault(require("8e2a017884a8e3fe"));
var _setRef = _interopRequireDefault(require("1182776ae4b3f121"));
var _getReactElementRef = _interopRequireDefault(require("f01f7e549c35f0f"));
var _exactProp = _interopRequireDefault(require("f8ebde9ec5e9633f"));
var _HTMLElementType = _interopRequireDefault(require("7f2af4e2df7a2c1b"));
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const Portal = /*#__PURE__*/ React.forwardRef(function Portal(props, forwardedRef) {
    const { children, container, disablePortal = false } = props;
    const [mountNode, setMountNode] = React.useState(null);
    const handleRef = (0, _useForkRef.default)(/*#__PURE__*/ React.isValidElement(children) ? (0, _getReactElementRef.default)(children) : null, forwardedRef);
    (0, _useEnhancedEffect.default)(()=>{
        if (!disablePortal) setMountNode(getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, _useEnhancedEffect.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, _setRef.default)(forwardedRef, mountNode);
            return ()=>{
                (0, _setRef.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ React.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ React.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ ReactDOM.createPortal(children, mountNode) : mountNode;
});
var _default = exports.default = Portal;

},{"e3ffe1e4676279bf":"kZ6eK","880d78b19d46e4e3":"fiRIh","b1a238d480106920":"9njXz","c99df8e0c6870c09":"2ApDx","c4e1178c39923835":"bnNSm","aecb918d27c9940c":"fIvqa","8e2a017884a8e3fe":"4xKTx","1182776ae4b3f121":"8uRhj","f01f7e549c35f0f":"gaXcx","f8ebde9ec5e9633f":"jInuK","7f2af4e2df7a2c1b":"eESPP"}],"9g9OF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("fe8719236f0197cd").default;
var _interopRequireDefault = require("f55e26ee3b1dda60").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    backdropClasses: true
};
Object.defineProperty(exports, "backdropClasses", {
    enumerable: true,
    get: function() {
        return _backdropClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Backdrop.default;
    }
});
var _Backdrop = _interopRequireDefault(require("6ddd6448376fe4d4"));
var _backdropClasses = _interopRequireWildcard(require("1d9093a3c0bdfaf7"));
Object.keys(_backdropClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _backdropClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _backdropClasses[key];
        }
    });
});

},{"fe8719236f0197cd":"fiRIh","f55e26ee3b1dda60":"kZ6eK","6ddd6448376fe4d4":"3HRVb","1d9093a3c0bdfaf7":"2hFqf"}],"3HRVb":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7faa948ca1812ea4").default;
var _interopRequireWildcard = require("8a6d0d6cdc9c1f26").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f9e9fa69f1edd909"));
var _propTypes = _interopRequireDefault(require("f4262bb31e04da00"));
var _clsx = _interopRequireDefault(require("28a60ce48d8146b9"));
var _composeClasses = _interopRequireDefault(require("a819c29b22dc35fd"));
var _zeroStyled = require("ef3443ff48c861d9");
var _DefaultPropsProvider = require("54b3d1d380684647");
var _useSlot = _interopRequireDefault(require("d09015380c4c931"));
var _Fade = _interopRequireDefault(require("ea27c9f16526cbf6"));
var _backdropClasses = require("c43ae96c875bb577");
var _jsxRuntime = require("daacaf70f3636065");
const useUtilityClasses = (ownerState)=>{
    const { classes, invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, _composeClasses.default)(slots, _backdropClasses.getBackdropUtilityClass, classes);
};
const BackdropRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const Backdrop = /*#__PURE__*/ React.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children, className, component = 'div', invisible = false, open, components = {}, componentsProps = {}, slotProps = {}, slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component,
        invisible
    };
    const classes = useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        elementType: BackdropRoot,
        externalForwardedProps,
        className: (0, _clsx.default)(classes.root, className),
        ownerState
    });
    const [TransitionSlot, transitionProps] = (0, _useSlot.default)('transition', {
        elementType: _Fade.default,
        externalForwardedProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var _default = exports.default = Backdrop;

},{"7faa948ca1812ea4":"kZ6eK","8a6d0d6cdc9c1f26":"fiRIh","f9e9fa69f1edd909":"9njXz","f4262bb31e04da00":"bnNSm","28a60ce48d8146b9":"d2NWs","a819c29b22dc35fd":"59Equ","ef3443ff48c861d9":"hZXDo","54b3d1d380684647":"9bD8g","d09015380c4c931":"h76AU","ea27c9f16526cbf6":"c0CXk","c43ae96c875bb577":"2hFqf","daacaf70f3636065":"1dlk8"}],"h76AU":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c0fadf77837586d0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useSlot;
var _useForkRef = _interopRequireDefault(require("20a15be521f7b683"));
var _appendOwnerState = _interopRequireDefault(require("b64aedfaa3d1d1fa"));
var _resolveComponentProps = _interopRequireDefault(require("7dfd954e3ffa0806"));
var _mergeSlotProps = _interopRequireDefault(require("b71d9a8277d2ed6c"));
/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */ function useSlot(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className, elementType: initialElementType, ownerState, externalForwardedProps, internalForwardedProps, shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots = {
        [name]: undefined
    }, slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, _resolveComponentProps.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef } = (0, _mergeSlotProps.default)({
        className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, _useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, _appendOwnerState.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

},{"c0fadf77837586d0":"kZ6eK","20a15be521f7b683":"4xKTx","b64aedfaa3d1d1fa":"76Wn8","7dfd954e3ffa0806":"gGfhx","b71d9a8277d2ed6c":"dA16c"}],"76Wn8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f39f3c9d877a1779").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _appendOwnerState.default;
    }
});
var _appendOwnerState = _interopRequireDefault(require("2e6275f4a9983e72"));

},{"f39f3c9d877a1779":"kZ6eK","2e6275f4a9983e72":"9tRBH"}],"9tRBH":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ecd59038b56a9182").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isHostComponent = _interopRequireDefault(require("3524ff737db859f2"));
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, _isHostComponent.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var _default = exports.default = appendOwnerState;

},{"ecd59038b56a9182":"kZ6eK","3524ff737db859f2":"1RRaz"}],"1RRaz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a5c1dd68c83c8a7d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _isHostComponent.default;
    }
});
var _isHostComponent = _interopRequireDefault(require("5f850c24eda5a08"));

},{"a5c1dd68c83c8a7d":"kZ6eK","5f850c24eda5a08":"eKNum"}],"eKNum":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function isHostComponent(element) {
    return typeof element === 'string';
}
var _default = exports.default = isHostComponent;

},{}],"gGfhx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("fa4698c3c8093423").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _resolveComponentProps.default;
    }
});
var _resolveComponentProps = _interopRequireDefault(require("93453399dc57a26"));

},{"fa4698c3c8093423":"kZ6eK","93453399dc57a26":"62NbB"}],"62NbB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var _default = exports.default = resolveComponentProps;

},{}],"dA16c":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c55bd06aa78c45db").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _mergeSlotProps.default;
    }
});
var _mergeSlotProps = _interopRequireDefault(require("3b012fe1851f4206"));

},{"c55bd06aa78c45db":"kZ6eK","3b012fe1851f4206":"fR2kq"}],"fR2kq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c2fc8ee98c82c801").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _clsx = _interopRequireDefault(require("37572fd2c795853f"));
var _extractEventHandlers = _interopRequireDefault(require("dbe821ec9b52ba7"));
var _omitEventHandlers = _interopRequireDefault(require("c7ececfe474ab351"));
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function mergeSlotProps(parameters) {
    const { getSlotProps, additionalProps, externalSlotProps, externalForwardedProps, className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, _clsx.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, _extractEventHandlers.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, _omitEventHandlers.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, _omitEventHandlers.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, _clsx.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props,
        internalRef: internalSlotProps.ref
    };
}
var _default = exports.default = mergeSlotProps;

},{"c2fc8ee98c82c801":"kZ6eK","37572fd2c795853f":"d2NWs","dbe821ec9b52ba7":"9lxhE","c7ececfe474ab351":"lt2mo"}],"9lxhE":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("fc1dc899b8527ecb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _extractEventHandlers.default;
    }
});
var _extractEventHandlers = _interopRequireDefault(require("7fe6d30ce968b905"));

},{"fc1dc899b8527ecb":"kZ6eK","7fe6d30ce968b905":"f9te9"}],"f9te9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var _default = exports.default = extractEventHandlers;

},{}],"lt2mo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7649c2d092210c94").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _omitEventHandlers.default;
    }
});
var _omitEventHandlers = _interopRequireDefault(require("4626b8f552d7ff36"));

},{"7649c2d092210c94":"kZ6eK","4626b8f552d7ff36":"ba3xc"}],"ba3xc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var _default = exports.default = omitEventHandlers;

},{}],"c0CXk":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("317cd744d22ce526").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Fade.default;
    }
});
var _Fade = _interopRequireDefault(require("ca325d3832c0c077"));

},{"317cd744d22ce526":"kZ6eK","ca325d3832c0c077":"bKLOu"}],"bKLOu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("97042e51f49a6c63").default;
var _interopRequireWildcard = require("75eb50823a557212").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("b557508449614dc1"));
var _propTypes = _interopRequireDefault(require("2f00be8fb1d0fc95"));
var _reactTransitionGroup = require("2c5bc91fcd089e45");
var _elementAcceptingRef = _interopRequireDefault(require("f55d1b591287018b"));
var _getReactElementRef = _interopRequireDefault(require("d3db898363d62d26"));
var _zeroStyled = require("3b75843d454c30ff");
var _utils = require("84715525acac8539");
var _useForkRef = _interopRequireDefault(require("93d2e64e4f163a88"));
var _jsxRuntime = require("e8b165cf5fa9e6c");
const styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Fade = /*#__PURE__*/ React.forwardRef(function Fade(props, ref) {
    const theme = (0, _zeroStyled.useTheme)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = defaultTimeout, // eslint-disable-next-line react/prop-types
    TransitionComponent = _reactTransitionGroup.Transition, ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(nodeRef, (0, _getReactElementRef.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ React.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var _default = exports.default = Fade;

},{"97042e51f49a6c63":"kZ6eK","75eb50823a557212":"fiRIh","b557508449614dc1":"9njXz","2f00be8fb1d0fc95":"bnNSm","2c5bc91fcd089e45":"hnCQJ","f55d1b591287018b":"doIJ9","d3db898363d62d26":"gaXcx","3b75843d454c30ff":"hZXDo","84715525acac8539":"k52HW","93d2e64e4f163a88":"64cM2","e8b165cf5fa9e6c":"1dlk8"}],"2hFqf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ae16df971959dba8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getBackdropUtilityClass = getBackdropUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("f789d21cd095023c"));
var _generateUtilityClass = _interopRequireDefault(require("3439b99b167912f7"));
function getBackdropUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiBackdrop', slot);
}
const backdropClasses = (0, _generateUtilityClasses.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var _default = exports.default = backdropClasses;

},{"ae16df971959dba8":"kZ6eK","f789d21cd095023c":"7pSUk","3439b99b167912f7":"jBs9M"}],"cTwxl":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("40a19548f5ef65e3").default;
var _interopRequireWildcard = require("696017abec5a0b8c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("5bf00ac8f146fc9b"));
var _ownerDocument = _interopRequireDefault(require("cfc375a8cf5d3791"));
var _useForkRef = _interopRequireDefault(require("f54b1ec232bbebd1"));
var _useEventCallback = _interopRequireDefault(require("83f66939ba814e3e"));
var _createChainedFunction = _interopRequireDefault(require("b72d719c3705c8d7"));
var _extractEventHandlers = _interopRequireDefault(require("35b46f4c443f587"));
var _ModalManager = require("b9ba757ee9a051a4");
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const manager = new _ModalManager.ModalManager();
function useModal(parameters) {
    const { container, disableEscapeKeyDown = false, disableScrollLock = false, closeAfterTransition = false, onTransitionEnter, onTransitionExited, children, onClose, open, rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = React.useRef({});
    const mountNodeRef = React.useRef(null);
    const modalRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(modalRef, rootRef);
    const [exited, setExited] = React.useState(!open);
    const hasTransition = getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, _ownerDocument.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, _useEventCallback.default)(()=>{
        const resolvedContainer = getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>manager.isTopModal(getModal());
    const handlePortalRef = (0, _useEventCallback.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, _ModalManager.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = React.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    React.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    React.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, _extractEventHandlers.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, _createChainedFunction.default)(handleEnter, children?.props.onEnter ?? noop),
            onExited: (0, _createChainedFunction.default)(handleExited, children?.props.onExited ?? noop)
        };
    };
    return {
        getRootProps,
        getBackdropProps,
        getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal,
        exited,
        hasTransition
    };
}
var _default = exports.default = useModal;

},{"40a19548f5ef65e3":"kZ6eK","696017abec5a0b8c":"fiRIh","5bf00ac8f146fc9b":"9njXz","cfc375a8cf5d3791":"8VgUE","f54b1ec232bbebd1":"4xKTx","83f66939ba814e3e":"feNJe","b72d719c3705c8d7":"hSI0h","35b46f4c443f587":"9lxhE","b9ba757ee9a051a4":"1rqLY"}],"2XlRR":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c2800b56aca539e6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getModalUtilityClass = getModalUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4a4ac750e94ce259"));
var _generateUtilityClass = _interopRequireDefault(require("fd2e7adaa905b143"));
function getModalUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiModal', slot);
}
const modalClasses = (0, _generateUtilityClasses.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var _default = exports.default = modalClasses;

},{"c2800b56aca539e6":"kZ6eK","4a4ac750e94ce259":"7pSUk","fd2e7adaa905b143":"jBs9M"}],"aexCI":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("1aef29f8297b37f4").default;
var _interopRequireDefault = require("a4d6f5ccd3338c26").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    paperClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Paper.default;
    }
});
Object.defineProperty(exports, "paperClasses", {
    enumerable: true,
    get: function() {
        return _paperClasses.default;
    }
});
var _Paper = _interopRequireDefault(require("165ed773fc5a0b08"));
var _paperClasses = _interopRequireWildcard(require("40da18b891ba8fde"));
Object.keys(_paperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _paperClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _paperClasses[key];
        }
    });
});

},{"1aef29f8297b37f4":"fiRIh","a4d6f5ccd3338c26":"kZ6eK","165ed773fc5a0b08":"1sndB","40da18b891ba8fde":"lPVTs"}],"1sndB":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("4cd1006303594c74").default;
var _interopRequireWildcard = require("bc30e47b6788061").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("54d58d19755ef8b1"));
var _propTypes = _interopRequireDefault(require("52282f50896d28be"));
var _clsx = _interopRequireDefault(require("865a3d23e93d7f7c"));
var _integerPropType = _interopRequireDefault(require("e452496b65aabf01"));
var _chainPropTypes = _interopRequireDefault(require("5ed3bc4c86acb72d"));
var _composeClasses = _interopRequireDefault(require("7db36b4c9e8a56b5"));
var _colorManipulator = require("7e5b416565242c68");
var _zeroStyled = require("de8c991be6cfd6d4");
var _memoTheme = _interopRequireDefault(require("92634e3a91a36828"));
var _DefaultPropsProvider = require("68b67cf4672f178f");
var _getOverlayAlpha = _interopRequireDefault(require("8d50633e4f5b5779"));
var _paperClasses = require("5f980eac8a0e0920");
var _jsxRuntime = require("cddb72b894fc3905");
const useUtilityClasses = (ownerState)=>{
    const { square, elevation, variant, classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, _composeClasses.default)(slots, _paperClasses.getPaperUtilityClass, classes);
};
const PaperRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const Paper = /*#__PURE__*/ React.forwardRef(function Paper(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, _zeroStyled.useTheme)();
    const { className, component = 'div', elevation = 1, square = false, variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component,
        elevation,
        square,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlpha.default)(elevation))}, ${(0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlpha.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var _default = exports.default = Paper;

},{"4cd1006303594c74":"kZ6eK","bc30e47b6788061":"fiRIh","54d58d19755ef8b1":"9njXz","52282f50896d28be":"bnNSm","865a3d23e93d7f7c":"d2NWs","e452496b65aabf01":"iZJbi","5ed3bc4c86acb72d":"4stnp","7db36b4c9e8a56b5":"59Equ","7e5b416565242c68":"hTYBL","de8c991be6cfd6d4":"hZXDo","92634e3a91a36828":"cJNjb","68b67cf4672f178f":"9bD8g","8d50633e4f5b5779":"fzJyp","5f980eac8a0e0920":"lPVTs","cddb72b894fc3905":"1dlk8"}],"iZJbi":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e485af0a19552395").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _integerPropType.default;
    }
});
var _integerPropType = _interopRequireWildcard(require("e47cf4fd98822eb0"));
Object.keys(_integerPropType).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _integerPropType[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _integerPropType[key];
        }
    });
});

},{"e485af0a19552395":"fiRIh","e47cf4fd98822eb0":"gMjSi"}],"gMjSi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTypeByValue = getTypeByValue;
function getTypeByValue(value) {
    const valueType = typeof value;
    switch(valueType){
        case 'number':
            if (Number.isNaN(value)) return 'NaN';
            if (!Number.isFinite(value)) return 'Infinity';
            if (value !== Math.floor(value)) return 'float';
            return 'number';
        case 'object':
            if (value === null) return 'null';
            return value.constructor.name;
        default:
            return valueType;
    }
}
function requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !Number.isInteger(propValue)) {
        const propType = getTypeByValue(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function validator(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return requiredInteger(props, propName, componentName, location);
}
function validatorNoop() {
    return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = validatorNoop;
var _default = exports.default = integerPropType;

},{}],"lPVTs":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7420c2eaa0bb0276").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPaperUtilityClass = getPaperUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("ced88160e8185495"));
var _generateUtilityClass = _interopRequireDefault(require("de3c5df0ade9a8ef"));
function getPaperUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPaper', slot);
}
const paperClasses = (0, _generateUtilityClasses.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var _default = exports.default = paperClasses;

},{"7420c2eaa0bb0276":"kZ6eK","ced88160e8185495":"7pSUk","de3c5df0ade9a8ef":"jBs9M"}],"1DsZ8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("21a5f61fcc17a3a9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDialogUtilityClass = getDialogUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("7d51de827b3d6dc4"));
var _generateUtilityClass = _interopRequireDefault(require("78fb9bf058db34d9"));
function getDialogUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDialog', slot);
}
const dialogClasses = (0, _generateUtilityClasses.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var _default = exports.default = dialogClasses;

},{"21a5f61fcc17a3a9":"kZ6eK","7d51de827b3d6dc4":"7pSUk","78fb9bf058db34d9":"jBs9M"}],"9TzT8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("82a6f8df55b86dba").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("ae833e9bca3bae9e"));
const DialogContext = /*#__PURE__*/ React.createContext({});
var _default = exports.default = DialogContext;

},{"82a6f8df55b86dba":"fiRIh","ae833e9bca3bae9e":"9njXz"}],"h1RVn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("65d522fed23002c4").default;
var _interopRequireDefault = require("d736f7b885b579ac").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dialogActionsClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DialogActions.default;
    }
});
Object.defineProperty(exports, "dialogActionsClasses", {
    enumerable: true,
    get: function() {
        return _dialogActionsClasses.default;
    }
});
var _DialogActions = _interopRequireDefault(require("bde71bb71e715c07"));
var _dialogActionsClasses = _interopRequireWildcard(require("539d3f0cebd21149"));
Object.keys(_dialogActionsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dialogActionsClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dialogActionsClasses[key];
        }
    });
});

},{"65d522fed23002c4":"fiRIh","d736f7b885b579ac":"kZ6eK","bde71bb71e715c07":"8xE8c","539d3f0cebd21149":"kJYVi"}],"8xE8c":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("563ef45257e7226d").default;
var _interopRequireWildcard = require("74452e3150966b9c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("2bca740c895fc7a5"));
var _propTypes = _interopRequireDefault(require("26b61a8fed04c81b"));
var _clsx = _interopRequireDefault(require("5d85aa1826006f98"));
var _composeClasses = _interopRequireDefault(require("cd2eeebb60d9540b"));
var _zeroStyled = require("cc43a7a71e29d838");
var _DefaultPropsProvider = require("8bc5fbc169b02ce4");
var _dialogActionsClasses = require("3635314fb75903fa");
var _jsxRuntime = require("1455fa1da9a0c4d4");
const useUtilityClasses = (ownerState)=>{
    const { classes, disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, _composeClasses.default)(slots, _dialogActionsClasses.getDialogActionsUtilityClass, classes);
};
const DialogActionsRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const DialogActions = /*#__PURE__*/ React.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className, disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogActionsRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var _default = exports.default = DialogActions;

},{"563ef45257e7226d":"kZ6eK","74452e3150966b9c":"fiRIh","2bca740c895fc7a5":"9njXz","26b61a8fed04c81b":"bnNSm","5d85aa1826006f98":"d2NWs","cd2eeebb60d9540b":"59Equ","cc43a7a71e29d838":"hZXDo","8bc5fbc169b02ce4":"9bD8g","3635314fb75903fa":"kJYVi","1455fa1da9a0c4d4":"1dlk8"}],"kJYVi":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1587fb79fc1cdf43").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDialogActionsUtilityClass = getDialogActionsUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("86e59a78fd1a92e7"));
var _generateUtilityClass = _interopRequireDefault(require("d1366d78c6f6f332"));
function getDialogActionsUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDialogActions', slot);
}
const dialogActionsClasses = (0, _generateUtilityClasses.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var _default = exports.default = dialogActionsClasses;

},{"1587fb79fc1cdf43":"kZ6eK","86e59a78fd1a92e7":"7pSUk","d1366d78c6f6f332":"jBs9M"}],"l4i9c":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c39346025106405e").default;
var _interopRequireDefault = require("cf35b1dbfa36c6b4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dialogContentClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DialogContent.default;
    }
});
Object.defineProperty(exports, "dialogContentClasses", {
    enumerable: true,
    get: function() {
        return _dialogContentClasses.default;
    }
});
var _DialogContent = _interopRequireDefault(require("e4141079a7db29be"));
var _dialogContentClasses = _interopRequireWildcard(require("6d2032c7fb383458"));
Object.keys(_dialogContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dialogContentClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dialogContentClasses[key];
        }
    });
});

},{"c39346025106405e":"fiRIh","cf35b1dbfa36c6b4":"kZ6eK","e4141079a7db29be":"1ZkSM","6d2032c7fb383458":"iTRii"}],"1ZkSM":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c3ae8ff4c5ae3e63").default;
var _interopRequireWildcard = require("52f02f3dc24d84d1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("6d5d62c2b22a53de"));
var _propTypes = _interopRequireDefault(require("b93cd4a0ee64219f"));
var _clsx = _interopRequireDefault(require("4cf8765c395b85ff"));
var _composeClasses = _interopRequireDefault(require("c10497225cc36568"));
var _zeroStyled = require("1a9177ad3c361fc5");
var _memoTheme = _interopRequireDefault(require("535fecf3ae41dcb0"));
var _DefaultPropsProvider = require("565d88702033d066");
var _dialogContentClasses = require("210aaa6b82fe5045");
var _dialogTitleClasses = _interopRequireDefault(require("d52b008640628a0"));
var _jsxRuntime = require("e7085b6613abfa0d");
const useUtilityClasses = (ownerState)=>{
    const { classes, dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, _composeClasses.default)(slots, _dialogContentClasses.getDialogContentUtilityClass, classes);
};
const DialogContentRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState })=>!ownerState.dividers,
                style: {
                    [`.${_dialogTitleClasses.default.root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const DialogContent = /*#__PURE__*/ React.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className, dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogContentRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var _default = exports.default = DialogContent;

},{"c3ae8ff4c5ae3e63":"kZ6eK","52f02f3dc24d84d1":"fiRIh","6d5d62c2b22a53de":"9njXz","b93cd4a0ee64219f":"bnNSm","4cf8765c395b85ff":"d2NWs","c10497225cc36568":"59Equ","1a9177ad3c361fc5":"hZXDo","535fecf3ae41dcb0":"cJNjb","565d88702033d066":"9bD8g","210aaa6b82fe5045":"iTRii","d52b008640628a0":"7xkge","e7085b6613abfa0d":"1dlk8"}],"iTRii":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7acbabee84f067da").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDialogContentUtilityClass = getDialogContentUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("ac418cff7c7a5fe0"));
var _generateUtilityClass = _interopRequireDefault(require("efb231ad6bfda382"));
function getDialogContentUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDialogContent', slot);
}
const dialogContentClasses = (0, _generateUtilityClasses.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var _default = exports.default = dialogContentClasses;

},{"7acbabee84f067da":"kZ6eK","ac418cff7c7a5fe0":"7pSUk","efb231ad6bfda382":"jBs9M"}],"7xkge":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4a3e54f112fd53c1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDialogTitleUtilityClass = getDialogTitleUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("b087f4c5ac9a7629"));
var _generateUtilityClass = _interopRequireDefault(require("558cbed79c40339c"));
function getDialogTitleUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDialogTitle', slot);
}
const dialogTitleClasses = (0, _generateUtilityClasses.default)('MuiDialogTitle', [
    'root'
]);
var _default = exports.default = dialogTitleClasses;

},{"4a3e54f112fd53c1":"kZ6eK","b087f4c5ac9a7629":"7pSUk","558cbed79c40339c":"jBs9M"}],"7bReD":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("f0bdd921eb2fa893").default;
var _interopRequireDefault = require("5d9beee3d359b168").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dialogContentTextClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DialogContentText.default;
    }
});
Object.defineProperty(exports, "dialogContentTextClasses", {
    enumerable: true,
    get: function() {
        return _dialogContentTextClasses.default;
    }
});
var _DialogContentText = _interopRequireDefault(require("472da4d01963e28c"));
var _dialogContentTextClasses = _interopRequireWildcard(require("cd759bdf794b2188"));
Object.keys(_dialogContentTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dialogContentTextClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dialogContentTextClasses[key];
        }
    });
});

},{"f0bdd921eb2fa893":"fiRIh","5d9beee3d359b168":"kZ6eK","472da4d01963e28c":"e09gY","cd759bdf794b2188":"lNxzx"}],"e09gY":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("903b4583eebdf4f8").default;
var _interopRequireWildcard = require("e3667335d645ccf0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("8de6625bca6a570c"));
var _propTypes = _interopRequireDefault(require("b38d22455e65daf5"));
var _clsx = _interopRequireDefault(require("9602953111f777be"));
var _composeClasses = _interopRequireDefault(require("f2120674c8658be"));
var _rootShouldForwardProp = _interopRequireDefault(require("5c589a2b7db713b4"));
var _zeroStyled = require("5c9244d4eb11835e");
var _DefaultPropsProvider = require("f297811fbae6521d");
var _Typography = _interopRequireDefault(require("a38959d4d4e72719"));
var _dialogContentTextClasses = require("adcf2cb2d0be5af2");
var _jsxRuntime = require("40ad58abd163ad52");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _dialogContentTextClasses.getDialogContentTextUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const DialogContentTextRoot = (0, _zeroStyled.styled)(_Typography.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root'
})({});
const DialogContentText = /*#__PURE__*/ React.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children, className, ...ownerState } = props;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
var _default = exports.default = DialogContentText;

},{"903b4583eebdf4f8":"kZ6eK","e3667335d645ccf0":"fiRIh","8de6625bca6a570c":"9njXz","b38d22455e65daf5":"bnNSm","9602953111f777be":"d2NWs","f2120674c8658be":"59Equ","5c589a2b7db713b4":"bTxRc","5c9244d4eb11835e":"hZXDo","f297811fbae6521d":"9bD8g","a38959d4d4e72719":"6NtGx","adcf2cb2d0be5af2":"lNxzx","40ad58abd163ad52":"1dlk8"}],"lNxzx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("92b47cfcd6f85b50").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDialogContentTextUtilityClass = getDialogContentTextUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("996b68c69211f22a"));
var _generateUtilityClass = _interopRequireDefault(require("5a1c62f82adcd5ea"));
function getDialogContentTextUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDialogContentText', slot);
}
const dialogContentTextClasses = (0, _generateUtilityClasses.default)('MuiDialogContentText', [
    'root'
]);
var _default = exports.default = dialogContentTextClasses;

},{"92b47cfcd6f85b50":"kZ6eK","996b68c69211f22a":"7pSUk","5a1c62f82adcd5ea":"jBs9M"}],"3qJY9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c1511efacf5fd0bf").default;
var _interopRequireDefault = require("ce21920b323f3799").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    buttonClasses: true
};
Object.defineProperty(exports, "buttonClasses", {
    enumerable: true,
    get: function() {
        return _buttonClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Button.default;
    }
});
var _Button = _interopRequireDefault(require("2cfbd774a1ef6243"));
var _buttonClasses = _interopRequireWildcard(require("111f29b87659d99"));
Object.keys(_buttonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _buttonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _buttonClasses[key];
        }
    });
});

},{"c1511efacf5fd0bf":"fiRIh","ce21920b323f3799":"kZ6eK","2cfbd774a1ef6243":"eJBER","111f29b87659d99":"e3NFp"}],"eJBER":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("16b95c2769640a0d").default;
var _interopRequireWildcard = require("9ff936aeefc475d7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("36bbb1a064708463"));
var _propTypes = _interopRequireDefault(require("a67d314f786ba2a0"));
var _clsx = _interopRequireDefault(require("681aaf897c339f80"));
var _resolveProps = _interopRequireDefault(require("5ed22a5fc18a8788"));
var _composeClasses = _interopRequireDefault(require("3e94e2604d40728f"));
var _colorManipulator = require("33dca120c1771bea");
var _utils = require("a94bb239923392a5");
var _rootShouldForwardProp = _interopRequireDefault(require("7cfd5b72194df594"));
var _zeroStyled = require("d177c4bea98ca06a");
var _memoTheme = _interopRequireDefault(require("8d07117a4d0b344d"));
var _DefaultPropsProvider = require("4a902ec486481370");
var _ButtonBase = _interopRequireDefault(require("6d7f3b9693e9a487"));
var _CircularProgress = _interopRequireDefault(require("2a58367e6e4ae247"));
var _capitalize = _interopRequireDefault(require("d4a35aec5709cb53"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("722df525cdf52390"));
var _buttonClasses = _interopRequireWildcard(require("7d5e1335298dbced"));
var _ButtonGroupContext = _interopRequireDefault(require("9dd6cbca3f6cb215"));
var _ButtonGroupButtonContext = _interopRequireDefault(require("205f2b03eda4d51a"));
var _jsxRuntime = require("e6a55304a23b58ee");
const useUtilityClasses = (ownerState)=>{
    const { color, disableElevation, fullWidth, size, variant, loading, loadingPosition, classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, _capitalize.default)(color)}`,
            `size${(0, _capitalize.default)(size)}`,
            `${variant}Size${(0, _capitalize.default)(size)}`,
            `color${(0, _capitalize.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, _capitalize.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, _capitalize.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, _capitalize.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _buttonClasses.getButtonUtilityClass, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const ButtonRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, _capitalize.default)(ownerState.color)}`],
            styles[`size${(0, _capitalize.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, _capitalize.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${_buttonClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${_buttonClasses.default.focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${_buttonClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${_buttonClasses.default.disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${_buttonClasses.default.focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${_buttonClasses.default.disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${_buttonClasses.default.loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const ButtonStartIcon = (0, _zeroStyled.styled)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})(({ theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...commonIconStyles
        ]
    }));
const ButtonEndIcon = (0, _zeroStyled.styled)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})(({ theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...commonIconStyles
        ]
    }));
const ButtonLoadingIndicator = (0, _zeroStyled.styled)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const ButtonLoadingIconPlaceholder = (0, _zeroStyled.styled)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const Button = /*#__PURE__*/ React.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = React.useContext(_ButtonGroupContext.default);
    const buttonGroupButtonContextPositionClassName = React.useContext(_ButtonGroupButtonContext.default);
    const resolvedProps = (0, _resolveProps.default)(contextProps, inProps);
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children, color = 'primary', component = 'button', className, disabled = false, disableElevation = false, disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName, fullWidth = false, id: idProp, loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition = 'center', size = 'medium', startIcon: startIconProp, type, variant = 'text', ...other } = props;
    const loadingId = (0, _utils.unstable_useId)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CircularProgress.default, {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color,
        component,
        disabled,
        disableElevation,
        disableFocusRipple,
        fullWidth,
        loading,
        loadingIndicator,
        loadingPosition,
        size,
        type,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, _jsxRuntime.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonRoot, {
        ownerState: ownerState,
        className: (0, _clsx.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var _default = exports.default = Button;

},{"16b95c2769640a0d":"kZ6eK","9ff936aeefc475d7":"fiRIh","36bbb1a064708463":"9njXz","a67d314f786ba2a0":"bnNSm","681aaf897c339f80":"d2NWs","5ed22a5fc18a8788":"gFBtX","3e94e2604d40728f":"59Equ","33dca120c1771bea":"hTYBL","a94bb239923392a5":"dEMJk","7cfd5b72194df594":"bTxRc","d177c4bea98ca06a":"hZXDo","8d07117a4d0b344d":"cJNjb","4a902ec486481370":"9bD8g","6d7f3b9693e9a487":"7X8rf","2a58367e6e4ae247":"kEtIR","d4a35aec5709cb53":"eOYSA","722df525cdf52390":"2r5WG","7d5e1335298dbced":"e3NFp","9dd6cbca3f6cb215":"fyAGU","205f2b03eda4d51a":"a118j","e6a55304a23b58ee":"1dlk8"}],"e3NFp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4809139f54f3024b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getButtonUtilityClass = getButtonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("83f701b401fc441f"));
var _generateUtilityClass = _interopRequireDefault(require("b7ce2dee8f5dd80a"));
function getButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiButton', slot);
}
const buttonClasses = (0, _generateUtilityClasses.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var _default = exports.default = buttonClasses;

},{"4809139f54f3024b":"kZ6eK","83f701b401fc441f":"7pSUk","b7ce2dee8f5dd80a":"jBs9M"}],"fyAGU":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("e08965872c01c1f2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e0e5b38425e963d"));
/**
 * @ignore - internal component.
 */ const ButtonGroupContext = /*#__PURE__*/ React.createContext({});
var _default = exports.default = ButtonGroupContext;

},{"e08965872c01c1f2":"fiRIh","e0e5b38425e963d":"9njXz"}],"a118j":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("8d51635cfb1b1eb9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("9b20a88149747a16"));
/**
 * @ignore - internal component.
 */ const ButtonGroupButtonContext = /*#__PURE__*/ React.createContext(undefined);
var _default = exports.default = ButtonGroupButtonContext;

},{"8d51635cfb1b1eb9":"fiRIh","9b20a88149747a16":"9njXz"}],"l88b4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a515bc1538bfbf93").default;
var _interopRequireDefault = require("dad221dc938d779f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    textFieldClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TextField.default;
    }
});
Object.defineProperty(exports, "textFieldClasses", {
    enumerable: true,
    get: function() {
        return _textFieldClasses.default;
    }
});
var _TextField = _interopRequireDefault(require("abefa3725fb8e670"));
var _textFieldClasses = _interopRequireWildcard(require("47fffd66e4eda170"));
Object.keys(_textFieldClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _textFieldClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _textFieldClasses[key];
        }
    });
});

},{"a515bc1538bfbf93":"fiRIh","dad221dc938d779f":"kZ6eK","abefa3725fb8e670":"deVMm","47fffd66e4eda170":"iYZBG"}],"deVMm":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b064fc9ef6e5e913").default;
var _interopRequireWildcard = require("ed92ada1af790ed7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("cf72366cec72336d"));
var _propTypes = _interopRequireDefault(require("4926cbc4c2984ef3"));
var _clsx = _interopRequireDefault(require("733ab94ae9ffcf10"));
var _composeClasses = _interopRequireDefault(require("d963d4cafe195987"));
var _useId = _interopRequireDefault(require("dd2d613fb6095759"));
var _refType = _interopRequireDefault(require("51c00c8574848034"));
var _zeroStyled = require("c1b3a5a49cef7c7e");
var _DefaultPropsProvider = require("87c4ab0476a7bb14");
var _Input = _interopRequireDefault(require("d42a47c414d83c70"));
var _FilledInput = _interopRequireDefault(require("df7dcfd5889e8481"));
var _OutlinedInput = _interopRequireDefault(require("9c887fc542492708"));
var _InputLabel = _interopRequireDefault(require("d6af0010e39d0063"));
var _FormControl = _interopRequireDefault(require("7b794960eadd865d"));
var _FormHelperText = _interopRequireDefault(require("1ad660d5e6250733"));
var _Select = _interopRequireDefault(require("5c4f9b98d2243b91"));
var _textFieldClasses = require("f4c8de7fb3272e5f");
var _useSlot = _interopRequireDefault(require("c723bbff7caf740e"));
var _jsxRuntime = require("e8ba8e222d99e3f5");
const variantComponent = {
    standard: _Input.default,
    filled: _FilledInput.default,
    outlined: _OutlinedInput.default
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _textFieldClasses.getTextFieldUtilityClass, classes);
};
const TextFieldRoot = (0, _zeroStyled.styled)(_FormControl.default, {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const TextField = /*#__PURE__*/ React.forwardRef(function TextField(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete, autoFocus = false, children, className, color = 'primary', defaultValue, disabled = false, error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth = false, helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef, label, maxRows, minRows, multiline = false, name, onBlur, onChange, onFocus, placeholder, required = false, rows, select = false, SelectProps: SelectPropsProp, slots = {}, slotProps = {}, type, value, variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus,
        color,
        disabled,
        error,
        fullWidth,
        multiline,
        required,
        select,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const id = (0, _useId.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = variantComponent[variant];
    const externalForwardedProps = {
        slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        elementType: TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref,
        additionalProps: {
            disabled,
            error,
            fullWidth,
            required,
            color,
            variant
        }
    });
    const [InputSlot, inputProps] = (0, _useSlot.default)('input', {
        elementType: InputComponent,
        externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, _useSlot.default)('inputLabel', {
        elementType: _InputLabel.default,
        externalForwardedProps,
        ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, _useSlot.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps,
        ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, _useSlot.default)('formHelperText', {
        elementType: _FormHelperText.default,
        externalForwardedProps,
        ownerState
    });
    const [SelectSlot, selectProps] = (0, _useSlot.default)('select', {
        elementType: _Select.default,
        externalForwardedProps,
        ownerState
    });
    const InputElement = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var _default = exports.default = TextField;

},{"b064fc9ef6e5e913":"kZ6eK","ed92ada1af790ed7":"fiRIh","cf72366cec72336d":"9njXz","4926cbc4c2984ef3":"bnNSm","733ab94ae9ffcf10":"d2NWs","d963d4cafe195987":"59Equ","dd2d613fb6095759":"50qgI","51c00c8574848034":"3TBXN","c1b3a5a49cef7c7e":"hZXDo","87c4ab0476a7bb14":"9bD8g","d42a47c414d83c70":"6uyCU","df7dcfd5889e8481":"jRM32","9c887fc542492708":"h57br","d6af0010e39d0063":"5EJtb","7b794960eadd865d":"ioFZ4","1ad660d5e6250733":"9uvlb","5c4f9b98d2243b91":"kyj0v","f4c8de7fb3272e5f":"iYZBG","c723bbff7caf740e":"h76AU","e8ba8e222d99e3f5":"1dlk8"}],"6uyCU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ca95d2b4a975c310").default;
var _interopRequireDefault = require("3451f1f18367acb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    inputClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Input.default;
    }
});
Object.defineProperty(exports, "inputClasses", {
    enumerable: true,
    get: function() {
        return _inputClasses.default;
    }
});
var _Input = _interopRequireDefault(require("a358bc9e296a004a"));
var _inputClasses = _interopRequireWildcard(require("581668995896cf36"));
Object.keys(_inputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _inputClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _inputClasses[key];
        }
    });
});

},{"ca95d2b4a975c310":"fiRIh","3451f1f18367acb":"kZ6eK","a358bc9e296a004a":"dnUdg","581668995896cf36":"2rE1a"}],"dnUdg":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("77662be842c9394d").default;
var _interopRequireWildcard = require("584b7462bf253fcb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f418eb8abc5d37b2"));
var _propTypes = _interopRequireDefault(require("71638ca8160e64bc"));
var _composeClasses = _interopRequireDefault(require("81676f76abeae07b"));
var _deepmerge = _interopRequireDefault(require("a171675507d3e59f"));
var _refType = _interopRequireDefault(require("677b89d4bc89eab1"));
var _InputBase = _interopRequireDefault(require("5ddf5d2104dca588"));
var _rootShouldForwardProp = _interopRequireDefault(require("cf2c8e5ea7c5b9fe"));
var _zeroStyled = require("560ef2476cdf7136");
var _memoTheme = _interopRequireDefault(require("bf8029c03193631"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("a75cecccd61e392b"));
var _DefaultPropsProvider = require("541e7cd8e24d2934");
var _inputClasses = _interopRequireWildcard(require("cc800d9576138e32"));
var _InputBase2 = require("9d6332908f86d3a9");
var _jsxRuntime = require("5cac257164abe24a");
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _inputClasses.getInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const InputRoot = (0, _zeroStyled.styled)(_InputBase2.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _InputBase2.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${_inputClasses.default.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${_inputClasses.default.error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${_inputClasses.default.disabled}, .${_inputClasses.default.error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${_inputClasses.default.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const InputInput = (0, _zeroStyled.styled)(_InputBase2.InputBaseInput, {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: _InputBase2.inputOverridesResolver
})({});
const Input = /*#__PURE__*/ React.forwardRef(function Input(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline = false, components = {}, componentsProps: componentsPropsProp, fullWidth = false, inputComponent = 'input', multiline = false, slotProps, slots = {}, type = 'text', ...other } = props;
    const classes = useUtilityClasses(props);
    const ownerState = {
        disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, _deepmerge.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? InputRoot;
    const InputSlot = slots.input ?? components.Input ?? InputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
Input.muiName = 'Input';
var _default = exports.default = Input;

},{"77662be842c9394d":"kZ6eK","584b7462bf253fcb":"fiRIh","f418eb8abc5d37b2":"9njXz","71638ca8160e64bc":"bnNSm","81676f76abeae07b":"59Equ","a171675507d3e59f":"7wtTC","677b89d4bc89eab1":"3TBXN","5ddf5d2104dca588":"dfAmq","cf2c8e5ea7c5b9fe":"bTxRc","560ef2476cdf7136":"hZXDo","bf8029c03193631":"cJNjb","a75cecccd61e392b":"2r5WG","541e7cd8e24d2934":"9bD8g","cc800d9576138e32":"2rE1a","9d6332908f86d3a9":"cGABN","5cac257164abe24a":"1dlk8"}],"dfAmq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("72a6ba3e64cb0a5b").default;
var _interopRequireDefault = require("961d1b0fcdb9416").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    inputBaseClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _InputBase.default;
    }
});
Object.defineProperty(exports, "inputBaseClasses", {
    enumerable: true,
    get: function() {
        return _inputBaseClasses.default;
    }
});
var _InputBase = _interopRequireDefault(require("7ff2fac9713661b4"));
var _inputBaseClasses = _interopRequireWildcard(require("61c8428058f850da"));
Object.keys(_inputBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _inputBaseClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _inputBaseClasses[key];
        }
    });
});

},{"72a6ba3e64cb0a5b":"fiRIh","961d1b0fcdb9416":"kZ6eK","7ff2fac9713661b4":"cGABN","61c8428058f850da":"7XvSk"}],"cGABN":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("45a827b473f31492").default;
var _interopRequireWildcard = require("e38d1443bf1f3403").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rootOverridesResolver = exports.inputOverridesResolver = exports.default = exports.InputBaseRoot = exports.InputBaseInput = void 0;
var _formatMuiErrorMessage = _interopRequireDefault(require("17bdbad4914fd39e"));
var React = _interopRequireWildcard(require("f8d2ee2ab89dacca"));
var _propTypes = _interopRequireDefault(require("9428c2b1b2e333cd"));
var _clsx = _interopRequireDefault(require("39488aabbdbe9a80"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("da96238e25bb466"));
var _refType = _interopRequireDefault(require("8708da7ca24bab80"));
var _composeClasses = _interopRequireDefault(require("97d0f332b443a7d6"));
var _TextareaAutosize = _interopRequireDefault(require("af71593a1aa25c62"));
var _isHostComponent = _interopRequireDefault(require("4bde2b9bb2e4702f"));
var _formControlState = _interopRequireDefault(require("55d091942b18a7dc"));
var _FormControlContext = _interopRequireDefault(require("761667c1b179ddc5"));
var _useFormControl = _interopRequireDefault(require("abdcfc0186f96b5d"));
var _zeroStyled = require("d94f05d17f7ce7c4");
var _memoTheme = _interopRequireDefault(require("f9f6e9b933937f8d"));
var _DefaultPropsProvider = require("c4e5df124d119cb0");
var _capitalize = _interopRequireDefault(require("8e546082f017dac5"));
var _useForkRef = _interopRequireDefault(require("4cdabade3aedf6c9"));
var _useEnhancedEffect = _interopRequireDefault(require("7387bae9a4549900"));
var _utils = require("1bf09aa10f0ce7c4");
var _inputBaseClasses = _interopRequireWildcard(require("b1fc8683fe303477"));
var _jsxRuntime = require("8920bd33be17827e");
var _InputGlobalStyles;
const rootOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, _capitalize.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
exports.rootOverridesResolver = rootOverridesResolver;
const inputOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
exports.inputOverridesResolver = inputOverridesResolver;
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, error, endAdornment, focused, formControl, fullWidth, hiddenLabel, multiline, readOnly, size, startAdornment, type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalize.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, _capitalize.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, _composeClasses.default)(slots, _inputBaseClasses.getInputBaseUtilityClass, classes);
};
const InputBaseRoot = exports.InputBaseRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: rootOverridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${_inputBaseClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState, size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const InputBaseInput = exports.InputBaseInput = (0, _zeroStyled.styled)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: inputOverridesResolver
})((0, _memoTheme.default)(({ theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${_inputBaseClasses.default.formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${_inputBaseClasses.default.disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const InputGlobalStyles = (0, _zeroStyled.globalCss)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const InputBase = /*#__PURE__*/ React.forwardRef(function InputBase(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete, autoFocus, className, color, components = {}, componentsProps = {}, defaultValue, disabled, disableInjectingGlobalStyles, endAdornment, error, fullWidth = false, id, inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin, maxRows, minRows, multiline = false, name, onBlur, onChange, onClick, onFocus, onKeyDown, onKeyUp, placeholder, readOnly, renderSuffix, rows, size, slotProps = {}, slots = {}, startAdornment, type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = React.useRef(value != null);
    const inputRef = React.useRef();
    const handleInputRefWarning = React.useCallback((instance)=>{}, []);
    const handleInputRef = (0, _useForkRef.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = React.useState(false);
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    React.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = React.useCallback((obj)=>{
        if ((0, _utils.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, _useEnhancedEffect.default)(()=>{
        if (isControlled) checkDirty({
            value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, _formatMuiErrorMessage.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    React.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows,
            minRows,
            ...inputProps
        };
        InputComponent = _TextareaAutosize.default;
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    React.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        startAdornment,
        type
    };
    const classes = useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || InputBaseRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || InputBaseInput;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            (_InputGlobalStyles || (_InputGlobalStyles = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, _isHostComponent.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, _clsx.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormControlContext.default.Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, _isHostComponent.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, _clsx.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var _default = exports.default = InputBase;

},{"45a827b473f31492":"kZ6eK","e38d1443bf1f3403":"fiRIh","17bdbad4914fd39e":"gOgzd","f8d2ee2ab89dacca":"9njXz","9428c2b1b2e333cd":"bnNSm","39488aabbdbe9a80":"d2NWs","da96238e25bb466":"40NoV","8708da7ca24bab80":"3TBXN","97d0f332b443a7d6":"59Equ","af71593a1aa25c62":"8FydA","4bde2b9bb2e4702f":"19YEO","55d091942b18a7dc":"9soGV","761667c1b179ddc5":"44WyX","abdcfc0186f96b5d":"51J7f","d94f05d17f7ce7c4":"hZXDo","f9f6e9b933937f8d":"cJNjb","c4e5df124d119cb0":"9bD8g","8e546082f017dac5":"eOYSA","4cdabade3aedf6c9":"64cM2","7387bae9a4549900":"9wMvV","1bf09aa10f0ce7c4":"lXe4p","b1fc8683fe303477":"7XvSk","8920bd33be17827e":"1dlk8"}],"8FydA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("53fff7007c69fa26").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TextareaAutosize.default;
    }
});
var _TextareaAutosize = _interopRequireDefault(require("7bc6293dc6aa1109"));

},{"53fff7007c69fa26":"kZ6eK","7bc6293dc6aa1109":"dHf35"}],"dHf35":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("15ac931166673647").default;
var _interopRequireWildcard = require("f21c12c698c42fc6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("816bebc7747e915d"));
var _propTypes = _interopRequireDefault(require("4efdf7d109b572d9"));
var _debounce = _interopRequireDefault(require("4f9a0df347f113e3"));
var _useForkRef = _interopRequireDefault(require("16edc904b3a4c619"));
var _useEnhancedEffect = _interopRequireDefault(require("a9789e7b54614964"));
var _useEventCallback = _interopRequireDefault(require("8206f29e1f0b64f2"));
var _ownerWindow = _interopRequireDefault(require("d78090db7cef5330"));
var _jsxRuntime = require("ec5ccd315754825d");
function getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function isEmpty(obj) {
    return isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const TextareaAutosize = /*#__PURE__*/ React.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange, maxRows, minRows = 1, style, value, ...other } = props;
    const { current: isControlled } = React.useRef(value != null);
    const textareaRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(forwardedRef, textareaRef);
    const heightRef = React.useRef(null);
    const hiddenTextareaRef = React.useRef(null);
    const calculateTextareaStyles = React.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, _ownerWindow.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
        const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle,
            overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, _useEventCallback.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = React.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = React.useRef(-1);
    (0, _useEnhancedEffect.default)(()=>{
        const debouncedHandleResize = (0, _debounce.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, _ownerWindow.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, _useEnhancedEffect.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var _default = exports.default = TextareaAutosize;

},{"15ac931166673647":"kZ6eK","f21c12c698c42fc6":"fiRIh","816bebc7747e915d":"9njXz","4efdf7d109b572d9":"bnNSm","4f9a0df347f113e3":"f6vcJ","16edc904b3a4c619":"4xKTx","a9789e7b54614964":"fIvqa","8206f29e1f0b64f2":"feNJe","d78090db7cef5330":"hiDmU","ec5ccd315754825d":"1dlk8"}],"19YEO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function isHostComponent(element) {
    return typeof element === 'string';
}
var _default = exports.default = isHostComponent;

},{}],"9soGV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formControlState;
function formControlState({ props, states, muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

},{}],"44WyX":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("9a1c525c76ac6d6e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("338ef3a314b2893b"));
/**
 * @ignore - internal component.
 */ const FormControlContext = /*#__PURE__*/ React.createContext(undefined);
var _default = exports.default = FormControlContext;

},{"9a1c525c76ac6d6e":"fiRIh","338ef3a314b2893b":"9njXz"}],"51J7f":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c332207aef4e5839").default;
var _interopRequireWildcard = require("d8a9c6e9134eba2f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useFormControl;
var React = _interopRequireWildcard(require("ac3b541c75c1ab96"));
var _FormControlContext = _interopRequireDefault(require("e1b5dc43f13343ca"));
function useFormControl() {
    return React.useContext(_FormControlContext.default);
}

},{"c332207aef4e5839":"kZ6eK","d8a9c6e9134eba2f":"fiRIh","ac3b541c75c1ab96":"9njXz","e1b5dc43f13343ca":"44WyX"}],"lXe4p":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasValue = hasValue;
exports.isAdornedStart = isAdornedStart;
exports.isFilled = isFilled;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isFilled(obj, SSR = false) {
    return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}
// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function isAdornedStart(obj) {
    return obj.startAdornment;
}

},{}],"7XvSk":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("79ab84077682ef7b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getInputBaseUtilityClass = getInputBaseUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("5ec7082e43362368"));
var _generateUtilityClass = _interopRequireDefault(require("85a3b1f6e1f8faa1"));
function getInputBaseUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiInputBase', slot);
}
const inputBaseClasses = (0, _generateUtilityClasses.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var _default = exports.default = inputBaseClasses;

},{"79ab84077682ef7b":"kZ6eK","5ec7082e43362368":"7pSUk","85a3b1f6e1f8faa1":"jBs9M"}],"2rE1a":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1a973528fe163f80").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getInputUtilityClass = getInputUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("84ad1f32d6f54ed2"));
var _generateUtilityClass = _interopRequireDefault(require("10de4e6845343996"));
var _InputBase = require("c3b28531b5ace5b8");
function getInputUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiInput', slot);
}
const inputClasses = {
    ..._InputBase.inputBaseClasses,
    ...(0, _generateUtilityClasses.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var _default = exports.default = inputClasses;

},{"1a973528fe163f80":"kZ6eK","84ad1f32d6f54ed2":"7pSUk","10de4e6845343996":"jBs9M","c3b28531b5ace5b8":"dfAmq"}],"jRM32":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("550ed4a44218995b").default;
var _interopRequireDefault = require("35e77a81f333149e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    filledInputClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FilledInput.default;
    }
});
Object.defineProperty(exports, "filledInputClasses", {
    enumerable: true,
    get: function() {
        return _filledInputClasses.default;
    }
});
var _FilledInput = _interopRequireDefault(require("a6a933534e86b881"));
var _filledInputClasses = _interopRequireWildcard(require("7517b1f5f8faeb5d"));
Object.keys(_filledInputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _filledInputClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _filledInputClasses[key];
        }
    });
});

},{"550ed4a44218995b":"fiRIh","35e77a81f333149e":"kZ6eK","a6a933534e86b881":"6EaGG","7517b1f5f8faeb5d":"eyL27"}],"6EaGG":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("864f7d7f4773aded").default;
var _interopRequireWildcard = require("8495b8f5d45fd4e2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("5d9b599d28c8139c"));
var _deepmerge = _interopRequireDefault(require("a7588788b4388d41"));
var _refType = _interopRequireDefault(require("c2cc9fb4a84f409c"));
var _propTypes = _interopRequireDefault(require("4c07b4abf8931e1a"));
var _composeClasses = _interopRequireDefault(require("dc82a99fc93674b4"));
var _InputBase = _interopRequireDefault(require("6401178c8fa12aad"));
var _rootShouldForwardProp = _interopRequireDefault(require("c22028aab528946b"));
var _zeroStyled = require("7eb285e36f7a2c57");
var _memoTheme = _interopRequireDefault(require("f1b23071840ede58"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("654d2b60a66b3ea3"));
var _DefaultPropsProvider = require("4de75646f5b5766c");
var _filledInputClasses = _interopRequireWildcard(require("8548bc35efbfc533"));
var _InputBase2 = require("e12005c660523fb4");
var _utils = require("21a0c61f2fdc6df0");
var _jsxRuntime = require("9c994e0c102c8f11");
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline, startAdornment, endAdornment, size, hiddenLabel, multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, _utils.capitalize)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _filledInputClasses.getFilledInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const FilledInputRoot = (0, _zeroStyled.styled)(_InputBase2.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _InputBase2.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${_filledInputClasses.default.focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${_filledInputClasses.default.disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${_filledInputClasses.default.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${_filledInputClasses.default.error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${_filledInputClasses.default.disabled}, .${_filledInputClasses.default.error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${_filledInputClasses.default.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState, size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const FilledInputInput = (0, _zeroStyled.styled)(_InputBase2.InputBaseInput, {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: _InputBase2.inputOverridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const FilledInput = /*#__PURE__*/ React.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline = false, components = {}, componentsProps: componentsPropsProp, fullWidth = false, hiddenLabel, // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline = false, slotProps, slots = {}, type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline,
        fullWidth,
        inputComponent,
        multiline,
        type
    };
    const classes = useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState
        },
        input: {
            ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, _deepmerge.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? FilledInputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
FilledInput.muiName = 'Input';
var _default = exports.default = FilledInput;

},{"864f7d7f4773aded":"kZ6eK","8495b8f5d45fd4e2":"fiRIh","5d9b599d28c8139c":"9njXz","a7588788b4388d41":"7wtTC","c2cc9fb4a84f409c":"3TBXN","4c07b4abf8931e1a":"bnNSm","dc82a99fc93674b4":"59Equ","6401178c8fa12aad":"dfAmq","c22028aab528946b":"bTxRc","7eb285e36f7a2c57":"hZXDo","f1b23071840ede58":"cJNjb","654d2b60a66b3ea3":"2r5WG","4de75646f5b5766c":"9bD8g","8548bc35efbfc533":"eyL27","e12005c660523fb4":"cGABN","21a0c61f2fdc6df0":"dEMJk","9c994e0c102c8f11":"1dlk8"}],"eyL27":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d677d7298609562f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFilledInputUtilityClass = getFilledInputUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("e962f3dddb34dab9"));
var _generateUtilityClass = _interopRequireDefault(require("3b64ecff6df3541"));
var _InputBase = require("b8a1931e96867143");
function getFilledInputUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiFilledInput', slot);
}
const filledInputClasses = {
    ..._InputBase.inputBaseClasses,
    ...(0, _generateUtilityClasses.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var _default = exports.default = filledInputClasses;

},{"d677d7298609562f":"kZ6eK","e962f3dddb34dab9":"7pSUk","3b64ecff6df3541":"jBs9M","b8a1931e96867143":"dfAmq"}],"h57br":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("924646d2f9e2fc60").default;
var _interopRequireDefault = require("df85b5f6407976f1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    outlinedInputClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _OutlinedInput.default;
    }
});
Object.defineProperty(exports, "outlinedInputClasses", {
    enumerable: true,
    get: function() {
        return _outlinedInputClasses.default;
    }
});
var _OutlinedInput = _interopRequireDefault(require("2176d873e79fc7b"));
var _outlinedInputClasses = _interopRequireWildcard(require("6cdd98b84b25856d"));
Object.keys(_outlinedInputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _outlinedInputClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _outlinedInputClasses[key];
        }
    });
});

},{"924646d2f9e2fc60":"fiRIh","df85b5f6407976f1":"kZ6eK","2176d873e79fc7b":"1ccYF","6cdd98b84b25856d":"dgsBP"}],"1ccYF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("940a12f1e55f2f2f").default;
var _interopRequireWildcard = require("cb1f31ee8801cf52").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("525cf9ccd9a1aaf6"));
var _propTypes = _interopRequireDefault(require("c3d9ce03aa36e6d5"));
var _refType = _interopRequireDefault(require("5d769f3d358c2822"));
var _composeClasses = _interopRequireDefault(require("39e19d9a75017e37"));
var _NotchedOutline = _interopRequireDefault(require("a06ca2663768a8b8"));
var _useFormControl = _interopRequireDefault(require("696f2e2030593673"));
var _formControlState = _interopRequireDefault(require("7457a95490dc0110"));
var _rootShouldForwardProp = _interopRequireDefault(require("635adddbf2a61bee"));
var _zeroStyled = require("1cabdceb37edc791");
var _memoTheme = _interopRequireDefault(require("8e9c5f6b3d1414"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("2e31d44b113b6535"));
var _DefaultPropsProvider = require("ba09d11f1cac184f");
var _outlinedInputClasses = _interopRequireWildcard(require("c16a5dbf6523abe"));
var _InputBase = _interopRequireWildcard(require("cda62537cb0c6316"));
var _useSlot = _interopRequireDefault(require("c9bf4e9e7bb11f5a"));
var _jsxRuntime = require("782fdf756e9e0f05");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _outlinedInputClasses.getOutlinedInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const OutlinedInputRoot = (0, _zeroStyled.styled)(_InputBase.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: _InputBase.rootOverridesResolver
})((0, _memoTheme.default)(({ theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${_outlinedInputClasses.default.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${_outlinedInputClasses.default.notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${_outlinedInputClasses.default.focused} .${_outlinedInputClasses.default.notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&.${_outlinedInputClasses.default.focused} .${_outlinedInputClasses.default.notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${_outlinedInputClasses.default.error} .${_outlinedInputClasses.default.notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${_outlinedInputClasses.default.disabled} .${_outlinedInputClasses.default.notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState, size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const NotchedOutlineRoot = (0, _zeroStyled.styled)(_NotchedOutline.default, {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, _memoTheme.default)(({ theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const OutlinedInputInput = (0, _zeroStyled.styled)(_InputBase.InputBaseInput, {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: _InputBase.inputOverridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const OutlinedInput = /*#__PURE__*/ React.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components = {}, fullWidth = false, inputComponent = 'input', label, multiline = false, notched, slots = {}, slotProps = {}, type = 'text', ...other } = props;
    const classes = useUtilityClasses(props);
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        type
    };
    const RootSlot = slots.root ?? components.Root ?? OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, _useSlot.default)('notchedOutline', {
        elementType: NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState,
        externalForwardedProps: {
            slots,
            slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
OutlinedInput.muiName = 'Input';
var _default = exports.default = OutlinedInput;

},{"940a12f1e55f2f2f":"kZ6eK","cb1f31ee8801cf52":"fiRIh","525cf9ccd9a1aaf6":"9njXz","c3d9ce03aa36e6d5":"bnNSm","5d769f3d358c2822":"3TBXN","39e19d9a75017e37":"59Equ","a06ca2663768a8b8":"eVv6c","696f2e2030593673":"51J7f","7457a95490dc0110":"9soGV","635adddbf2a61bee":"bTxRc","1cabdceb37edc791":"hZXDo","8e9c5f6b3d1414":"cJNjb","2e31d44b113b6535":"2r5WG","ba09d11f1cac184f":"9bD8g","c16a5dbf6523abe":"dgsBP","cda62537cb0c6316":"cGABN","c9bf4e9e7bb11f5a":"h76AU","782fdf756e9e0f05":"1dlk8"}],"eVv6c":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("7528f37abc83f0f5").default;
var _interopRequireDefault = require("f851724b2bea409b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NotchedOutline;
var React = _interopRequireWildcard(require("321c5cf8b4d4211b"));
var _propTypes = _interopRequireDefault(require("8c2ee6573f03352c"));
var _rootShouldForwardProp = _interopRequireDefault(require("b25c29673caa1214"));
var _zeroStyled = require("23af104147890cf0");
var _memoTheme = _interopRequireDefault(require("e476d3eeda592853"));
var _jsxRuntime = require("8203ad69aadf6bc8");
var _span;
const NotchedOutlineRoot = (0, _zeroStyled.styled)('fieldset', {
    shouldForwardProp: _rootShouldForwardProp.default
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const NotchedOutlineLegend = (0, _zeroStyled.styled)('legend', {
    shouldForwardProp: _rootShouldForwardProp.default
})((0, _memoTheme.default)(({ theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function NotchedOutline(props) {
    const { children, classes, className, label, notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched,
        withLabel
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: label
            }) : _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

},{"7528f37abc83f0f5":"fiRIh","f851724b2bea409b":"kZ6eK","321c5cf8b4d4211b":"9njXz","8c2ee6573f03352c":"bnNSm","b25c29673caa1214":"bTxRc","23af104147890cf0":"hZXDo","e476d3eeda592853":"cJNjb","8203ad69aadf6bc8":"1dlk8"}],"dgsBP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2e3a234b5d39b121").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getOutlinedInputUtilityClass = getOutlinedInputUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("5c5466eac74f1e47"));
var _generateUtilityClass = _interopRequireDefault(require("3ec278d801096ff9"));
var _InputBase = require("6fd98b1b5448b2c9");
function getOutlinedInputUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiOutlinedInput', slot);
}
const outlinedInputClasses = {
    ..._InputBase.inputBaseClasses,
    ...(0, _generateUtilityClasses.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var _default = exports.default = outlinedInputClasses;

},{"2e3a234b5d39b121":"kZ6eK","5c5466eac74f1e47":"7pSUk","3ec278d801096ff9":"jBs9M","6fd98b1b5448b2c9":"dfAmq"}],"5EJtb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("d0096fe01d284004").default;
var _interopRequireDefault = require("5a6fcb75464618e6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    inputLabelClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _InputLabel.default;
    }
});
Object.defineProperty(exports, "inputLabelClasses", {
    enumerable: true,
    get: function() {
        return _inputLabelClasses.default;
    }
});
var _InputLabel = _interopRequireDefault(require("25eae4538c07c56e"));
var _inputLabelClasses = _interopRequireWildcard(require("40b59cc7d5f4d57f"));
Object.keys(_inputLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _inputLabelClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _inputLabelClasses[key];
        }
    });
});

},{"d0096fe01d284004":"fiRIh","5a6fcb75464618e6":"kZ6eK","25eae4538c07c56e":"24Fks","40b59cc7d5f4d57f":"28YOC"}],"24Fks":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("58ea084c233ada8e").default;
var _interopRequireWildcard = require("68e0eba79af47e65").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("6e1be012f835e28e"));
var _propTypes = _interopRequireDefault(require("f7c8ef33ee1db392"));
var _composeClasses = _interopRequireDefault(require("eec2d459ad028d41"));
var _clsx = _interopRequireDefault(require("5a5fed07064b3f85"));
var _formControlState = _interopRequireDefault(require("a73213360db4d145"));
var _useFormControl = _interopRequireDefault(require("663ec30e7a5b3802"));
var _FormLabel = _interopRequireWildcard(require("eab498034bd05dab"));
var _capitalize = _interopRequireDefault(require("e5d6c30a7d2ec712"));
var _rootShouldForwardProp = _interopRequireDefault(require("566c352883990fbb"));
var _zeroStyled = require("e6a9001ea1916c60");
var _memoTheme = _interopRequireDefault(require("f5594094eee6ae99"));
var _DefaultPropsProvider = require("d9b56f39bfd84a5c");
var _inputLabelClasses = require("c97c4858eff1183d");
var _jsxRuntime = require("6b92aa33c2a59289");
const useUtilityClasses = (ownerState)=>{
    const { classes, formControl, size, shrink, disableAnimation, variant, required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, _capitalize.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _inputLabelClasses.getInputLabelUtilityClasses, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const InputLabelRoot = (0, _zeroStyled.styled)(_FormLabel.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_FormLabel.formLabelClasses.asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant, ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant, ownerState, size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant, ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const InputLabel = /*#__PURE__*/ React.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation = false, margin, shrink: shrinkProp, variant, className, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation,
        formControl: muiFormControl,
        shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var _default = exports.default = InputLabel;

},{"58ea084c233ada8e":"kZ6eK","68e0eba79af47e65":"fiRIh","6e1be012f835e28e":"9njXz","f7c8ef33ee1db392":"bnNSm","eec2d459ad028d41":"59Equ","5a5fed07064b3f85":"d2NWs","a73213360db4d145":"9soGV","663ec30e7a5b3802":"51J7f","eab498034bd05dab":"a5RcZ","e5d6c30a7d2ec712":"eOYSA","566c352883990fbb":"bTxRc","e6a9001ea1916c60":"hZXDo","f5594094eee6ae99":"cJNjb","d9b56f39bfd84a5c":"9bD8g","c97c4858eff1183d":"28YOC","6b92aa33c2a59289":"1dlk8"}],"a5RcZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("9cdbd0d3b15276dd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    formLabelClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FormLabel.default;
    }
});
Object.defineProperty(exports, "formLabelClasses", {
    enumerable: true,
    get: function() {
        return _formLabelClasses.default;
    }
});
var _FormLabel = _interopRequireWildcard(require("b7974fa03679eab8"));
Object.keys(_FormLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _FormLabel[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _FormLabel[key];
        }
    });
});
var _formLabelClasses = _interopRequireWildcard(require("a5490313c93f6f8c"));
Object.keys(_formLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _formLabelClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _formLabelClasses[key];
        }
    });
});

},{"9cdbd0d3b15276dd":"fiRIh","b7974fa03679eab8":"i8Gvt","a5490313c93f6f8c":"c9mRr"}],"i8Gvt":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ee826fc12b3d9356").default;
var _interopRequireWildcard = require("298f6dcb12dcb609").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.FormLabelRoot = void 0;
var React = _interopRequireWildcard(require("68f3ce9b8f5fc159"));
var _propTypes = _interopRequireDefault(require("b2ddd316176c3ded"));
var _clsx = _interopRequireDefault(require("342154f950d66775"));
var _composeClasses = _interopRequireDefault(require("7ee1ee5408bb276f"));
var _formControlState = _interopRequireDefault(require("d6f316ad8f8c8176"));
var _useFormControl = _interopRequireDefault(require("fdf19cdafdb70530"));
var _capitalize = _interopRequireDefault(require("a9ac7bb7ced5cc0d"));
var _zeroStyled = require("421665df146cede5");
var _memoTheme = _interopRequireDefault(require("7f20632644df59f6"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("62e1d1dcb9f3331b"));
var _DefaultPropsProvider = require("84d91a4fcd859307");
var _formLabelClasses = _interopRequireWildcard(require("26541c3d77205d1c"));
var _jsxRuntime = require("87336b4b5605d00a");
const useUtilityClasses = (ownerState)=>{
    const { classes, color, focused, disabled, error, filled, required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalize.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, _composeClasses.default)(slots, _formLabelClasses.getFormLabelUtilityClasses, classes);
};
const FormLabelRoot = exports.FormLabelRoot = (0, _zeroStyled.styled)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&.${_formLabelClasses.default.focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${_formLabelClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${_formLabelClasses.default.error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const AsteriskComponent = (0, _zeroStyled.styled)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, _memoTheme.default)(({ theme })=>({
        [`&.${_formLabelClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const FormLabel = /*#__PURE__*/ React.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children, className, color, component = 'label', disabled, error, filled, focused, required, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormLabelRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var _default = exports.default = FormLabel;

},{"ee826fc12b3d9356":"kZ6eK","298f6dcb12dcb609":"fiRIh","68f3ce9b8f5fc159":"9njXz","b2ddd316176c3ded":"bnNSm","342154f950d66775":"d2NWs","7ee1ee5408bb276f":"59Equ","d6f316ad8f8c8176":"9soGV","fdf19cdafdb70530":"51J7f","a9ac7bb7ced5cc0d":"eOYSA","421665df146cede5":"hZXDo","7f20632644df59f6":"cJNjb","62e1d1dcb9f3331b":"2r5WG","84d91a4fcd859307":"9bD8g","26541c3d77205d1c":"c9mRr","87336b4b5605d00a":"1dlk8"}],"c9mRr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("df59f556138cdeea").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFormLabelUtilityClasses = getFormLabelUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("8b0291750fa95a2d"));
var _generateUtilityClass = _interopRequireDefault(require("90fc682e8927a0fd"));
function getFormLabelUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiFormLabel', slot);
}
const formLabelClasses = (0, _generateUtilityClasses.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var _default = exports.default = formLabelClasses;

},{"df59f556138cdeea":"kZ6eK","8b0291750fa95a2d":"7pSUk","90fc682e8927a0fd":"jBs9M"}],"28YOC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("666f7ea83c66797b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getInputLabelUtilityClasses = getInputLabelUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("b063e0ecd22e2a2d"));
var _generateUtilityClass = _interopRequireDefault(require("2c7460156cfa6022"));
function getInputLabelUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiInputLabel', slot);
}
const inputLabelClasses = (0, _generateUtilityClasses.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var _default = exports.default = inputLabelClasses;

},{"666f7ea83c66797b":"kZ6eK","b063e0ecd22e2a2d":"7pSUk","2c7460156cfa6022":"jBs9M"}],"ioFZ4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("2ce70c20ad304347").default;
var _interopRequireDefault = require("2c2c1f89b69ef738").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    useFormControl: true,
    formControlClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FormControl.default;
    }
});
Object.defineProperty(exports, "formControlClasses", {
    enumerable: true,
    get: function() {
        return _formControlClasses.default;
    }
});
Object.defineProperty(exports, "useFormControl", {
    enumerable: true,
    get: function() {
        return _useFormControl.default;
    }
});
var _FormControl = _interopRequireDefault(require("e968305f6deaa343"));
var _useFormControl = _interopRequireDefault(require("4234845ab18b4cb3"));
var _formControlClasses = _interopRequireWildcard(require("343b8dd9988de1f7"));
Object.keys(_formControlClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _formControlClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _formControlClasses[key];
        }
    });
});

},{"2ce70c20ad304347":"fiRIh","2c2c1f89b69ef738":"kZ6eK","e968305f6deaa343":"hk0yx","4234845ab18b4cb3":"51J7f","343b8dd9988de1f7":"cf7az"}],"hk0yx":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("d05b673b5f75b65c").default;
var _interopRequireWildcard = require("8c4861e8b388bd6f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("1cce66551b0e082e"));
var _propTypes = _interopRequireDefault(require("91d9b12aac26bf70"));
var _clsx = _interopRequireDefault(require("501d9a3119e53abf"));
var _composeClasses = _interopRequireDefault(require("8e7b0ad9763243fe"));
var _zeroStyled = require("a81299cd1ef2806a");
var _DefaultPropsProvider = require("eb7e4a2f332eb5bc");
var _utils = require("e599063008752823");
var _capitalize = _interopRequireDefault(require("ac214d0ac61e24a9"));
var _isMuiElement = _interopRequireDefault(require("5c37a5d019ff1e89"));
var _FormControlContext = _interopRequireDefault(require("7677bdad0bc95490"));
var _formControlClasses = require("88f5e72319afa188");
var _jsxRuntime = require("210be4d28fefdfa8");
const useUtilityClasses = (ownerState)=>{
    const { classes, margin, fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, _capitalize.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, _composeClasses.default)(slots, _formControlClasses.getFormControlUtilityClasses, classes);
};
const FormControlRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, _capitalize.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const FormControl = /*#__PURE__*/ React.forwardRef(function FormControl(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children, className, color = 'primary', component = 'div', disabled = false, error = false, focused: visuallyFocused, fullWidth = false, hiddenLabel = false, margin = 'none', required = false, size = 'medium', variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color,
        component,
        disabled,
        error,
        fullWidth,
        hiddenLabel,
        margin,
        required,
        size,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = React.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) React.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElement.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, _isMuiElement.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, _utils.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = React.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) React.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElement.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, _utils.isFilled)(child.props, true) || (0, _utils.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = React.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = React.useRef(false);
    const onFilled = React.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = React.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = React.useMemo(()=>{
        return {
            adornedStart,
            setAdornedStart,
            color,
            disabled,
            error,
            filled,
            focused,
            fullWidth,
            hiddenLabel,
            size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty,
            onFilled,
            registerEffect,
            required,
            variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormControlContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var _default = exports.default = FormControl;

},{"d05b673b5f75b65c":"kZ6eK","8c4861e8b388bd6f":"fiRIh","1cce66551b0e082e":"9njXz","91d9b12aac26bf70":"bnNSm","501d9a3119e53abf":"d2NWs","8e7b0ad9763243fe":"59Equ","a81299cd1ef2806a":"hZXDo","eb7e4a2f332eb5bc":"9bD8g","e599063008752823":"lXe4p","ac214d0ac61e24a9":"eOYSA","5c37a5d019ff1e89":"cF7sw","7677bdad0bc95490":"44WyX","88f5e72319afa188":"cf7az","210be4d28fefdfa8":"1dlk8"}],"cf7az":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d42f76814a93148e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFormControlUtilityClasses = getFormControlUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("bebe8481deef66ad"));
var _generateUtilityClass = _interopRequireDefault(require("9e54634ff39aead4"));
function getFormControlUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiFormControl', slot);
}
const formControlClasses = (0, _generateUtilityClasses.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var _default = exports.default = formControlClasses;

},{"d42f76814a93148e":"kZ6eK","bebe8481deef66ad":"7pSUk","9e54634ff39aead4":"jBs9M"}],"9uvlb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7068654e8c2405a7").default;
var _interopRequireDefault = require("f23c19fa3877a811").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    formHelperTextClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FormHelperText.default;
    }
});
Object.defineProperty(exports, "formHelperTextClasses", {
    enumerable: true,
    get: function() {
        return _formHelperTextClasses.default;
    }
});
var _FormHelperText = _interopRequireDefault(require("128bdc005c21a748"));
var _formHelperTextClasses = _interopRequireWildcard(require("4658ada446ccd062"));
Object.keys(_formHelperTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _formHelperTextClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _formHelperTextClasses[key];
        }
    });
});

},{"7068654e8c2405a7":"fiRIh","f23c19fa3877a811":"kZ6eK","128bdc005c21a748":"2gcVw","4658ada446ccd062":"IMDs1"}],"2gcVw":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("d897e84e6305fcd4").default;
var _interopRequireDefault = require("a040f2f720d400a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("968e0517e6c32c46"));
var _propTypes = _interopRequireDefault(require("d3cc4e7aeb820a75"));
var _clsx = _interopRequireDefault(require("7c1843dec7ba0a51"));
var _composeClasses = _interopRequireDefault(require("94ab6a6cee25524c"));
var _formControlState = _interopRequireDefault(require("8c2a9a72e40a7d06"));
var _useFormControl = _interopRequireDefault(require("8fef3c1e0dcff417"));
var _zeroStyled = require("4b657df00e79562e");
var _memoTheme = _interopRequireDefault(require("5523ee4afda7d505"));
var _DefaultPropsProvider = require("3548040e26fb5171");
var _capitalize = _interopRequireDefault(require("efb2afc430804422"));
var _formHelperTextClasses = _interopRequireWildcard(require("e21ad8aa8ce191bb"));
var _jsxRuntime = require("ac3f1ecb41255bf4");
var _span;
const useUtilityClasses = (ownerState)=>{
    const { classes, contained, size, disabled, error, filled, focused, required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, _capitalize.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, _composeClasses.default)(slots, _formHelperTextClasses.getFormHelperTextUtilityClasses, classes);
};
const FormHelperTextRoot = (0, _zeroStyled.styled)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, _capitalize.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${_formHelperTextClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${_formHelperTextClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const FormHelperText = /*#__PURE__*/ React.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children, className, component = 'p', disabled, error, filled, focused, margin, required, variant, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormHelperTextRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var _default = exports.default = FormHelperText;

},{"d897e84e6305fcd4":"fiRIh","a040f2f720d400a":"kZ6eK","968e0517e6c32c46":"9njXz","d3cc4e7aeb820a75":"bnNSm","7c1843dec7ba0a51":"d2NWs","94ab6a6cee25524c":"59Equ","8c2a9a72e40a7d06":"9soGV","8fef3c1e0dcff417":"51J7f","4b657df00e79562e":"hZXDo","5523ee4afda7d505":"cJNjb","3548040e26fb5171":"9bD8g","efb2afc430804422":"eOYSA","e21ad8aa8ce191bb":"IMDs1","ac3f1ecb41255bf4":"1dlk8"}],"IMDs1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("17057bb8f5da5054").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFormHelperTextUtilityClasses = getFormHelperTextUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("ce4e1302e66a32f"));
var _generateUtilityClass = _interopRequireDefault(require("e856173a6ea99dca"));
function getFormHelperTextUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiFormHelperText', slot);
}
const formHelperTextClasses = (0, _generateUtilityClasses.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var _default = exports.default = formHelperTextClasses;

},{"17057bb8f5da5054":"kZ6eK","ce4e1302e66a32f":"7pSUk","e856173a6ea99dca":"jBs9M"}],"kyj0v":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("29c123870cda48b7").default;
var _interopRequireDefault = require("664f89e094b0ccac").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    selectClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Select.default;
    }
});
Object.defineProperty(exports, "selectClasses", {
    enumerable: true,
    get: function() {
        return _selectClasses.default;
    }
});
var _Select = _interopRequireDefault(require("42455fcdd1a79c61"));
var _selectClasses = _interopRequireWildcard(require("be9f4fe788954f2a"));
Object.keys(_selectClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _selectClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _selectClasses[key];
        }
    });
});

},{"29c123870cda48b7":"fiRIh","664f89e094b0ccac":"kZ6eK","42455fcdd1a79c61":"3j0QB","be9f4fe788954f2a":"kYWMa"}],"3j0QB":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("fe0933668b56e108").default;
var _interopRequireWildcard = require("a1d861b675cf6746").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("552a3a2fe68aac30"));
var _propTypes = _interopRequireDefault(require("4ef4ee1c78b79646"));
var _clsx = _interopRequireDefault(require("4ef75c7e2c8aa436"));
var _deepmerge = _interopRequireDefault(require("a797834fb1f3f2c0"));
var _composeClasses = _interopRequireDefault(require("f777c468602dcb3b"));
var _getReactElementRef = _interopRequireDefault(require("73a4ffc2f3d3986a"));
var _SelectInput = _interopRequireDefault(require("309de10c91cbd6ac"));
var _formControlState = _interopRequireDefault(require("d89e3ab88d1958eb"));
var _useFormControl = _interopRequireDefault(require("a0701b433642adad"));
var _ArrowDropDown = _interopRequireDefault(require("bc5133baef9060f0"));
var _Input = _interopRequireDefault(require("b004294b9ef084f5"));
var _NativeSelectInput = _interopRequireDefault(require("8f792c63378d10d"));
var _FilledInput = _interopRequireDefault(require("f787abd1d90506c0"));
var _OutlinedInput = _interopRequireDefault(require("335eb9ca0eebf13c"));
var _DefaultPropsProvider = require("98834d4fbee0e32d");
var _useForkRef = _interopRequireDefault(require("b0fb940168a5f084"));
var _zeroStyled = require("6e02ff64cb638ad3");
var _rootShouldForwardProp = _interopRequireDefault(require("94fa2388701d1264"));
var _selectClasses = require("6470a140b4e32298");
var _jsxRuntime = require("988286710df4aaac");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _selectClasses.getSelectUtilityClasses, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) && prop !== 'variant'
};
const StyledInput = (0, _zeroStyled.styled)(_Input.default, styledRootConfig)('');
const StyledOutlinedInput = (0, _zeroStyled.styled)(_OutlinedInput.default, styledRootConfig)('');
const StyledFilledInput = (0, _zeroStyled.styled)(_FilledInput.default, styledRootConfig)('');
const Select = /*#__PURE__*/ React.forwardRef(function Select(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth = false, children, classes: classesProp = {}, className, defaultOpen = false, displayEmpty = false, IconComponent = _ArrowDropDown.default, id, input, inputProps, label, labelId, MenuProps, multiple = false, native = false, onClose, onOpen, open, renderValue, SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant,
        classes: classesProp
    };
    const classes = useUtilityClasses(ownerState);
    const { root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, _useForkRef.default)(ref, (0, _getReactElementRef.default)(InputComponent));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(React.Fragment, {
        children: /*#__PURE__*/ React.cloneElement(InputComponent, {
            // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children,
                error: fcs.error,
                IconComponent,
                variant,
                type: undefined,
                // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id
                } : {
                    autoWidth,
                    defaultOpen,
                    displayEmpty,
                    labelId,
                    MenuProps,
                    onClose,
                    onOpen,
                    open,
                    renderValue,
                    SelectDisplayProps: {
                        id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, _deepmerge.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, _clsx.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant
            },
            ...other
        })
    });
});
Select.muiName = 'Select';
var _default = exports.default = Select;

},{"fe0933668b56e108":"kZ6eK","a1d861b675cf6746":"fiRIh","552a3a2fe68aac30":"9njXz","4ef4ee1c78b79646":"bnNSm","4ef75c7e2c8aa436":"d2NWs","a797834fb1f3f2c0":"7wtTC","f777c468602dcb3b":"59Equ","73a4ffc2f3d3986a":"gaXcx","309de10c91cbd6ac":"2o4g0","d89e3ab88d1958eb":"9soGV","a0701b433642adad":"51J7f","bc5133baef9060f0":"kLz8E","b004294b9ef084f5":"6uyCU","8f792c63378d10d":"bzDqw","f787abd1d90506c0":"jRM32","335eb9ca0eebf13c":"h57br","98834d4fbee0e32d":"9bD8g","b0fb940168a5f084":"64cM2","6e02ff64cb638ad3":"hZXDo","94fa2388701d1264":"bTxRc","6470a140b4e32298":"kYWMa","988286710df4aaac":"1dlk8"}],"2o4g0":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2c91a8a897c75410").default;
var _interopRequireWildcard = require("15566045783c7a21").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _formatMuiErrorMessage = _interopRequireDefault(require("774124158a59859a"));
var React = _interopRequireWildcard(require("864eb2e3e2d909df"));
var _reactIs = require("927c533bbf95f01");
var _propTypes = _interopRequireDefault(require("d4c85fab06372684"));
var _clsx = _interopRequireDefault(require("2e1a27bc1cb430e3"));
var _composeClasses = _interopRequireDefault(require("cb37b9fee7b7edcf"));
var _useId = _interopRequireDefault(require("6635232fccabc03a"));
var _refType = _interopRequireDefault(require("c9ca7057afc297a9"));
var _ownerDocument = _interopRequireDefault(require("e7f4002e4f8a8cf9"));
var _capitalize = _interopRequireDefault(require("e197a79cc6a09d4b"));
var _Menu = _interopRequireDefault(require("1d87484f70c320e3"));
var _NativeSelectInput = require("b49e761ffb1bf576");
var _utils = require("8f558ac5ce395aa4");
var _zeroStyled = require("6020b9679180bcfe");
var _slotShouldForwardProp = _interopRequireDefault(require("751a924819287ec0"));
var _useForkRef = _interopRequireDefault(require("a1d903787bf396b6"));
var _useControlled = _interopRequireDefault(require("a1d3196f5bb85f6f"));
var _selectClasses = _interopRequireWildcard(require("ee0ccf45c25c0073"));
var _jsxRuntime = require("baffbee9a16a629f");
var _span;
const SelectSelect = (0, _zeroStyled.styled)(_NativeSelectInput.StyledSelectSelect, {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${_selectClasses.default.select}`]: styles.select
            },
            {
                [`&.${_selectClasses.default.select}`]: styles[ownerState.variant]
            },
            {
                [`&.${_selectClasses.default.error}`]: styles.error
            },
            {
                [`&.${_selectClasses.default.multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${_selectClasses.default.select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const SelectIcon = (0, _zeroStyled.styled)(_NativeSelectInput.StyledSelectIcon, {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalize.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const SelectNativeInput = (0, _zeroStyled.styled)('input', {
    shouldForwardProp: (prop)=>(0, _slotShouldForwardProp.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, _capitalize.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, _composeClasses.default)(slots, _selectClasses.getSelectUtilityClasses, classes);
};
/**
 * @ignore - internal component.
 */ const SelectInput = /*#__PURE__*/ React.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus, autoWidth, children, className, defaultOpen, defaultValue, disabled, displayEmpty, error = false, IconComponent, inputRef: inputRefProp, labelId, MenuProps = {}, multiple, name, onBlur, onChange, onClose, onFocus, onOpen, open: openProp, readOnly, renderValue, required, SelectDisplayProps = {}, tabIndex: tabIndexProp, // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, _useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, _useControlled.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = React.useRef(null);
    const displayRef = React.useRef(null);
    const [displayNode, setDisplayNode] = React.useState(null);
    const { current: isOpenControlled } = React.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = React.useState();
    const handleRef = (0, _useForkRef.default)(ref, inputRefProp);
    const handleDisplayRef = React.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    React.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    React.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    React.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    React.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, _ownerDocument.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = React.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value,
                    name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, _utils.isFilled)({
        value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, _formatMuiErrorMessage.default)(2));
            selected = value.some((v)=>areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ React.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant,
        value,
        open,
        error
    };
    const classes = useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, _useId.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, _clsx.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: isEmpty(display) ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Menu.default, {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var _default = exports.default = SelectInput;

},{"2c91a8a897c75410":"kZ6eK","15566045783c7a21":"fiRIh","774124158a59859a":"gOgzd","864eb2e3e2d909df":"9njXz","927c533bbf95f01":"bmrco","d4c85fab06372684":"bnNSm","2e1a27bc1cb430e3":"d2NWs","cb37b9fee7b7edcf":"59Equ","6635232fccabc03a":"50qgI","c9ca7057afc297a9":"3TBXN","e7f4002e4f8a8cf9":"1juJZ","e197a79cc6a09d4b":"eOYSA","1d87484f70c320e3":"bmUG8","b49e761ffb1bf576":"bzDqw","8f558ac5ce395aa4":"lXe4p","6020b9679180bcfe":"hZXDo","751a924819287ec0":"94KY1","a1d903787bf396b6":"64cM2","a1d3196f5bb85f6f":"2pWHX","ee0ccf45c25c0073":"kYWMa","baffbee9a16a629f":"1dlk8"}],"bmrco":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("17b8b44361a5973d");

},{"17b8b44361a5973d":"9aXL2"}],"9aXL2":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                    case REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
exports.ContextConsumer = REACT_CONSUMER_TYPE;
exports.ContextProvider = REACT_CONTEXT_TYPE;
exports.Element = REACT_ELEMENT_TYPE;
exports.ForwardRef = REACT_FORWARD_REF_TYPE;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Lazy = REACT_LAZY_TYPE;
exports.Memo = REACT_MEMO_TYPE;
exports.Portal = REACT_PORTAL_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
exports.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
};
exports.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
};
exports.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
};
exports.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
exports.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
};
exports.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
};
exports.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
};
exports.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
};
exports.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
};
exports.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
exports.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
};
exports.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
exports.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
exports.typeOf = typeOf;

},{}],"bmUG8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7d2bcc4ccfe7fbf2").default;
var _interopRequireWildcard = require("fa25efe3ea65d97").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.MenuPaper = void 0;
var React = _interopRequireWildcard(require("b09491450beeb32e"));
var _reactIs = require("b13a38ab81dc1f3");
var _propTypes = _interopRequireDefault(require("3864fd903d0e02fa"));
var _clsx = _interopRequireDefault(require("dc3fd1984388511b"));
var _composeClasses = _interopRequireDefault(require("d43917043aacc43c"));
var _HTMLElementType = _interopRequireDefault(require("5a1c90add0052b3e"));
var _RtlProvider = require("b1d631f7ea9eec48");
var _useSlotProps = _interopRequireDefault(require("19525cd11cd7154b"));
var _MenuList = _interopRequireDefault(require("630cba316bc32f89"));
var _Popover = _interopRequireWildcard(require("4453bfee9034d68f"));
var _rootShouldForwardProp = _interopRequireDefault(require("e1a78d8bb29f140d"));
var _zeroStyled = require("95bc8b11628a2c50");
var _DefaultPropsProvider = require("d5c71198bf36b9dd");
var _menuClasses = require("6ea2f33cf73ee7db");
var _useSlot = _interopRequireDefault(require("7ae90a085b0e0b5c"));
var _jsxRuntime = require("e0ff6772a05d0762");
const RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, _composeClasses.default)(slots, _menuClasses.getMenuUtilityClass, classes);
};
const MenuRoot = (0, _zeroStyled.styled)(_Popover.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const MenuPaper = exports.MenuPaper = (0, _zeroStyled.styled)(_Popover.PopoverPaper, {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const MenuMenuList = (0, _zeroStyled.styled)(_MenuList.default, {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Menu = /*#__PURE__*/ React.forwardRef(function Menu(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus = true, children, className, disableAutoFocusItem = false, MenuListProps = {}, onClose, open, PaperProps = {}, PopoverClasses, transitionDuration = 'auto', TransitionProps: { onEntering, ...TransitionProps } = {}, variant = 'selectedMenu', slots = {}, slotProps = {}, ...other } = props;
    const isRtl = (0, _RtlProvider.useRtl)();
    const ownerState = {
        ...props,
        autoFocus,
        disableAutoFocusItem,
        MenuListProps,
        onEntering,
        PaperProps,
        transitionDuration,
        TransitionProps,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = React.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    React.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, _useSlotProps.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, _useSlot.default)('paper', {
        className: classes.paper,
        elementType: MenuPaper,
        externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState
    });
    const [ListSlot, listSlotProps] = (0, _useSlot.default)('list', {
        className: (0, _clsx.default)(classes.list, MenuListProps.className),
        elementType: MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var _default = exports.default = Menu;

},{"7d2bcc4ccfe7fbf2":"kZ6eK","fa25efe3ea65d97":"fiRIh","b09491450beeb32e":"9njXz","b13a38ab81dc1f3":"bmrco","3864fd903d0e02fa":"bnNSm","dc3fd1984388511b":"d2NWs","d43917043aacc43c":"59Equ","5a1c90add0052b3e":"eESPP","b1d631f7ea9eec48":"ck9Pb","19525cd11cd7154b":"kr4RG","630cba316bc32f89":"aWbyd","4453bfee9034d68f":"lzCUD","e1a78d8bb29f140d":"bTxRc","95bc8b11628a2c50":"hZXDo","d5c71198bf36b9dd":"9bD8g","6ea2f33cf73ee7db":"67qUP","7ae90a085b0e0b5c":"h76AU","e0ff6772a05d0762":"1dlk8"}],"kr4RG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e27cd92635d16b56").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useSlotProps.default;
    }
});
var _useSlotProps = _interopRequireDefault(require("29750db15f9876da"));

},{"e27cd92635d16b56":"kZ6eK","29750db15f9876da":"4SZbc"}],"4SZbc":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a21f35e014bd8f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useForkRef = _interopRequireDefault(require("c814754bf676d4d8"));
var _appendOwnerState = _interopRequireDefault(require("91c0e9e36f102bb9"));
var _mergeSlotProps = _interopRequireDefault(require("230f6b30cc66f46c"));
var _resolveComponentProps = _interopRequireDefault(require("7d3d64e9007ca80e"));
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function useSlotProps(parameters) {
    const { elementType, externalSlotProps, ownerState, skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, _resolveComponentProps.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef } = (0, _mergeSlotProps.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, _useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, _appendOwnerState.default)(elementType, {
        ...mergedProps,
        ref
    }, ownerState);
    return props;
}
var _default = exports.default = useSlotProps;

},{"a21f35e014bd8f":"kZ6eK","c814754bf676d4d8":"4xKTx","91c0e9e36f102bb9":"76Wn8","230f6b30cc66f46c":"dA16c","7d3d64e9007ca80e":"gGfhx"}],"aWbyd":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("625a344d1e4d0e24").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _MenuList.default;
    }
});
var _MenuList = _interopRequireDefault(require("1c76b23259110a0b"));

},{"625a344d1e4d0e24":"kZ6eK","1c76b23259110a0b":"hXCU1"}],"hXCU1":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("28e9ecf4ceadd660").default;
var _interopRequireWildcard = require("6e47a045e4e4a1a5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("4785e92961640b41"));
var _reactIs = require("3531a55f317e8ac3");
var _propTypes = _interopRequireDefault(require("62a33f8e912899f3"));
var _ownerDocument = _interopRequireDefault(require("8f6d2ae2519921e5"));
var _List = _interopRequireDefault(require("b174aff5a5214863"));
var _getScrollbarSize = _interopRequireDefault(require("f130ce32440d72ec"));
var _useForkRef = _interopRequireDefault(require("78cf83213bf2b296"));
var _useEnhancedEffect = _interopRequireDefault(require("67407ced67daf5dc"));
var _utils = require("2fa0e99f8f5609d6");
var _jsxRuntime = require("d8aace21edcc2691");
function nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const MenuList = /*#__PURE__*/ React.forwardRef(function MenuList(props, ref) {
    const { // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus = false, autoFocusItem = false, children, className, disabledItemsFocusable = false, disableListWrap = false, onKeyDown, variant = 'selectedMenu', ...other } = props;
    const listRef = React.useRef(null);
    const textCriteriaRef = React.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    React.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, _getScrollbarSize.default)((0, _utils.ownerWindow)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, _ownerDocument.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, _useForkRef.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    React.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = React.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ React.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_List.default, {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var _default = exports.default = MenuList;

},{"28e9ecf4ceadd660":"kZ6eK","6e47a045e4e4a1a5":"fiRIh","4785e92961640b41":"9njXz","3531a55f317e8ac3":"bmrco","62a33f8e912899f3":"bnNSm","8f6d2ae2519921e5":"1juJZ","b174aff5a5214863":"a52pA","f130ce32440d72ec":"hbpFK","78cf83213bf2b296":"64cM2","67407ced67daf5dc":"9wMvV","2fa0e99f8f5609d6":"dEMJk","d8aace21edcc2691":"1dlk8"}],"a52pA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a29be849fd175390").default;
var _interopRequireDefault = require("efc6dab70a92d8a0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _List.default;
    }
});
Object.defineProperty(exports, "listClasses", {
    enumerable: true,
    get: function() {
        return _listClasses.default;
    }
});
var _List = _interopRequireDefault(require("11c50538174f4c17"));
var _listClasses = _interopRequireWildcard(require("60a4e19015851e02"));
Object.keys(_listClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listClasses[key];
        }
    });
});

},{"a29be849fd175390":"fiRIh","efc6dab70a92d8a0":"kZ6eK","11c50538174f4c17":"8FGnu","60a4e19015851e02":"1zrhO"}],"8FGnu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a7c4df55bfa928dc").default;
var _interopRequireWildcard = require("4f42d2affd5bdda3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("64cfdfba9a63b8b4"));
var _propTypes = _interopRequireDefault(require("5456c4b3772efe85"));
var _clsx = _interopRequireDefault(require("30f2402f4c647807"));
var _composeClasses = _interopRequireDefault(require("662d4b2a95ce86db"));
var _zeroStyled = require("86a9c847ca38d700");
var _DefaultPropsProvider = require("f66c87ee14519f00");
var _ListContext = _interopRequireDefault(require("5d7599b8238c51d4"));
var _listClasses = require("6b627d23e6a2934a");
var _jsxRuntime = require("bfc480d0235e4ba6");
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePadding, dense, subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, _composeClasses.default)(slots, _listClasses.getListUtilityClass, classes);
};
const ListRoot = (0, _zeroStyled.styled)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const List = /*#__PURE__*/ React.forwardRef(function List(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children, className, component = 'ul', dense = false, disablePadding = false, subheader, ...other } = props;
    const context = React.useMemo(()=>({
            dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component,
        dense,
        disablePadding
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
        value: context,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListRoot, {
            as: component,
            className: (0, _clsx.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var _default = exports.default = List;

},{"a7c4df55bfa928dc":"kZ6eK","4f42d2affd5bdda3":"fiRIh","64cfdfba9a63b8b4":"9njXz","5456c4b3772efe85":"bnNSm","30f2402f4c647807":"d2NWs","662d4b2a95ce86db":"59Equ","86a9c847ca38d700":"hZXDo","f66c87ee14519f00":"9bD8g","5d7599b8238c51d4":"7jlk2","6b627d23e6a2934a":"1zrhO","bfc480d0235e4ba6":"1dlk8"}],"7jlk2":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("8198d04a604212ac").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e17532f09b021fb3"));
/**
 * @ignore - internal component.
 */ const ListContext = /*#__PURE__*/ React.createContext({});
var _default = exports.default = ListContext;

},{"8198d04a604212ac":"fiRIh","e17532f09b021fb3":"9njXz"}],"1zrhO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("15d90765fce10af8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListUtilityClass = getListUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("fba542f767d9fab6"));
var _generateUtilityClass = _interopRequireDefault(require("d811091dded13c3f"));
function getListUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiList', slot);
}
const listClasses = (0, _generateUtilityClasses.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var _default = exports.default = listClasses;

},{"15d90765fce10af8":"kZ6eK","fba542f767d9fab6":"7pSUk","d811091dded13c3f":"jBs9M"}],"hbpFK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c19a25143021d409").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _getScrollbarSize = _interopRequireDefault(require("296d7ffe70c50ace"));
var _default = exports.default = _getScrollbarSize.default;

},{"c19a25143021d409":"kZ6eK","296d7ffe70c50ace":"3Gyjq"}],"lzCUD":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("eaf30806455d66e6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    popoverClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Popover.default;
    }
});
Object.defineProperty(exports, "popoverClasses", {
    enumerable: true,
    get: function() {
        return _popoverClasses.default;
    }
});
var _Popover = _interopRequireWildcard(require("23b11f7b4f089caf"));
Object.keys(_Popover).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _Popover[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Popover[key];
        }
    });
});
var _popoverClasses = _interopRequireWildcard(require("892e9c05cd898ffc"));
Object.keys(_popoverClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _popoverClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _popoverClasses[key];
        }
    });
});

},{"eaf30806455d66e6":"fiRIh","23b11f7b4f089caf":"irXsp","892e9c05cd898ffc":"11M99"}],"irXsp":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("d02faa1f94849667").default;
var _interopRequireWildcard = require("803995a04fcdc874").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.PopoverRoot = exports.PopoverPaper = void 0;
exports.getOffsetLeft = getOffsetLeft;
exports.getOffsetTop = getOffsetTop;
var React = _interopRequireWildcard(require("3a71e7afb74f5ee1"));
var _propTypes = _interopRequireDefault(require("e1050643ac7034c4"));
var _clsx = _interopRequireDefault(require("7cf3e7a209054002"));
var _composeClasses = _interopRequireDefault(require("6c31be3eee190cf5"));
var _HTMLElementType = _interopRequireDefault(require("39dd8c09c5739430"));
var _refType = _interopRequireDefault(require("fcfb935e1d0e605"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("9b4437a0a5d99c6"));
var _integerPropType = _interopRequireDefault(require("87b1876eed4577ee"));
var _chainPropTypes = _interopRequireDefault(require("60a72b1659428a30"));
var _isHostComponent = _interopRequireDefault(require("6d4aa1fcff749255"));
var _zeroStyled = require("a6f12e9643e607ae");
var _DefaultPropsProvider = require("a88ff89b80522b9f");
var _debounce = _interopRequireDefault(require("28e9ccaacfe7abee"));
var _ownerDocument = _interopRequireDefault(require("e99a5ba4600a77e2"));
var _ownerWindow = _interopRequireDefault(require("4909046a380cee94"));
var _Grow = _interopRequireDefault(require("775b77a991acfaa2"));
var _Modal = _interopRequireDefault(require("62cf054322aedfe0"));
var _Paper = _interopRequireDefault(require("f0c871cb2951007b"));
var _popoverClasses = require("30f103b45938e3c0");
var _useSlot = _interopRequireDefault(require("36cb8b99faa4ae84"));
var _utils = require("1f620bbd8eadf21a");
var _jsxRuntime = require("319cd2b7c66759df");
function getOffsetTop(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function getOffsetLeft(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, _composeClasses.default)(slots, _popoverClasses.getPopoverUtilityClass, classes);
};
const PopoverRoot = exports.PopoverRoot = (0, _zeroStyled.styled)(_Modal.default, {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const PopoverPaper = exports.PopoverPaper = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Popover = /*#__PURE__*/ React.forwardRef(function Popover(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action, anchorEl, anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition, anchorReference = 'anchorEl', children, className, container: containerProp, elevation = 8, marginThreshold = 16, open, PaperProps: PaperPropsProp = {}, // TODO: remove in v7
    slots = {}, slotProps = {}, transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps = {}, // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = React.useRef();
    const ownerState = {
        ...props,
        anchorOrigin,
        anchorReference,
        elevation,
        marginThreshold,
        transformOrigin,
        TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps
    };
    const classes = useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = React.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocument.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = React.useCallback((elemRect)=>{
        return {
            vertical: getOffsetTop(elemRect, transformOrigin.vertical),
            horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = React.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, _ownerWindow.default)(resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = React.useState(open);
    const setPositioningStyles = React.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    React.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    React.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    React.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    React.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, _debounce.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, _ownerWindow.default)(resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, _useSlot.default)('transition', {
        elementType: _Grow.default,
        externalForwardedProps,
        ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, _ownerDocument.default)(resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, _useSlot.default)('root', {
        ref,
        elementType: PopoverRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, _utils.mergeSlotProps)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container,
            open
        },
        ownerState,
        className: (0, _clsx.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, _useSlot.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: PopoverPaper,
        externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, _isHostComponent.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var _default = exports.default = Popover;

},{"d02faa1f94849667":"kZ6eK","803995a04fcdc874":"fiRIh","3a71e7afb74f5ee1":"9njXz","e1050643ac7034c4":"bnNSm","7cf3e7a209054002":"d2NWs","6c31be3eee190cf5":"59Equ","39dd8c09c5739430":"eESPP","fcfb935e1d0e605":"3TBXN","9b4437a0a5d99c6":"40NoV","87b1876eed4577ee":"iZJbi","60a72b1659428a30":"4stnp","6d4aa1fcff749255":"19YEO","a6f12e9643e607ae":"hZXDo","a88ff89b80522b9f":"9bD8g","28e9ccaacfe7abee":"bjUwl","e99a5ba4600a77e2":"1juJZ","4909046a380cee94":"lHNEW","775b77a991acfaa2":"do65J","62cf054322aedfe0":"6Q8b8","f0c871cb2951007b":"aexCI","30f103b45938e3c0":"11M99","36cb8b99faa4ae84":"h76AU","1f620bbd8eadf21a":"dEMJk","319cd2b7c66759df":"1dlk8"}],"do65J":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("77d8ba0f16687386").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Grow.default;
    }
});
var _Grow = _interopRequireDefault(require("b104d3eeb93326"));

},{"77d8ba0f16687386":"kZ6eK","b104d3eeb93326":"c78sw"}],"c78sw":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("d5816c8a995b0c78").default;
var _interopRequireWildcard = require("aa831ae03aba732f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("1b75bb2c8b945036"));
var _propTypes = _interopRequireDefault(require("4ab72691b18ee874"));
var _useTimeout = _interopRequireDefault(require("8576f61184b44e73"));
var _elementAcceptingRef = _interopRequireDefault(require("cc0f3ba849e0eba1"));
var _getReactElementRef = _interopRequireDefault(require("382657b6084b209"));
var _reactTransitionGroup = require("bba94398a39fb4e2");
var _zeroStyled = require("d6b00cebbee44e94");
var _utils = require("d90763d0f7f80c89");
var _useForkRef = _interopRequireDefault(require("e8995d4100209b69"));
var _jsxRuntime = require("9ffa93ccb60bfe06");
function getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const styles = {
    entering: {
        opacity: 1,
        transform: getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Grow = /*#__PURE__*/ React.forwardRef(function Grow(props, ref) {
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = 'auto', // eslint-disable-next-line react/prop-types
    TransitionComponent = _reactTransitionGroup.Transition, ...other } = props;
    const timer = (0, _useTimeout.default)();
    const autoTimeout = React.useRef();
    const theme = (0, _zeroStyled.useTheme)();
    const nodeRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(nodeRef, (0, _getReactElementRef.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration,
                delay
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration,
                delay
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay: isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ React.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if (Grow) Grow.muiSupportAuto = true;
var _default = exports.default = Grow;

},{"d5816c8a995b0c78":"kZ6eK","aa831ae03aba732f":"fiRIh","1b75bb2c8b945036":"9njXz","4ab72691b18ee874":"bnNSm","8576f61184b44e73":"k3sgs","cc0f3ba849e0eba1":"doIJ9","382657b6084b209":"gaXcx","bba94398a39fb4e2":"hnCQJ","d6b00cebbee44e94":"hZXDo","d90763d0f7f80c89":"k52HW","e8995d4100209b69":"64cM2","9ffa93ccb60bfe06":"1dlk8"}],"11M99":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("65dd355db3322898").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPopoverUtilityClass = getPopoverUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("fd2d45efca6e242d"));
var _generateUtilityClass = _interopRequireDefault(require("6688106bbf854c6e"));
function getPopoverUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPopover', slot);
}
const popoverClasses = (0, _generateUtilityClasses.default)('MuiPopover', [
    'root',
    'paper'
]);
var _default = exports.default = popoverClasses;

},{"65dd355db3322898":"kZ6eK","fd2d45efca6e242d":"7pSUk","6688106bbf854c6e":"jBs9M"}],"67qUP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b82d435b5918c413").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getMenuUtilityClass = getMenuUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("e8afccb8dc959570"));
var _generateUtilityClass = _interopRequireDefault(require("d5ebbe328e156697"));
function getMenuUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiMenu', slot);
}
const menuClasses = (0, _generateUtilityClasses.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var _default = exports.default = menuClasses;

},{"b82d435b5918c413":"kZ6eK","e8afccb8dc959570":"7pSUk","d5ebbe328e156697":"jBs9M"}],"bzDqw":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("41af5607de784cf8").default;
var _interopRequireWildcard = require("b5b8221f48afdf34").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.StyledSelectSelect = exports.StyledSelectIcon = void 0;
var React = _interopRequireWildcard(require("583f1830ebd2ce59"));
var _propTypes = _interopRequireDefault(require("9ccd5569a0fcf7b7"));
var _clsx = _interopRequireDefault(require("64c5463457948f13"));
var _refType = _interopRequireDefault(require("48309fa23a070b3d"));
var _composeClasses = _interopRequireDefault(require("60585e269f0f7256"));
var _capitalize = _interopRequireDefault(require("2d780c6609966a3c"));
var _nativeSelectClasses = _interopRequireWildcard(require("273d13c4294d522e"));
var _zeroStyled = require("3bb4b1e91d1216cb");
var _rootShouldForwardProp = _interopRequireDefault(require("8d1c4f0841f8b08d"));
var _jsxRuntime = require("a2752397de34d2b7");
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, _capitalize.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, _composeClasses.default)(slots, _nativeSelectClasses.getNativeSelectUtilityClasses, classes);
};
const StyledSelectSelect = exports.StyledSelectSelect = (0, _zeroStyled.styled)('select')(({ theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${_nativeSelectClasses.default.disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const NativeSelectSelect = (0, _zeroStyled.styled)(StyledSelectSelect, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: _rootShouldForwardProp.default,
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${_nativeSelectClasses.default.multiple}`]: styles.multiple
            }
        ];
    }
})({});
const StyledSelectIcon = exports.StyledSelectIcon = (0, _zeroStyled.styled)('svg')(({ theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${_nativeSelectClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const NativeSelectIcon = (0, _zeroStyled.styled)(StyledSelectIcon, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalize.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const NativeSelectInput = /*#__PURE__*/ React.forwardRef(function NativeSelectInput(props, ref) {
    const { className, disabled, error, IconComponent, inputRef, variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled,
        variant,
        error
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, _clsx.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var _default = exports.default = NativeSelectInput;

},{"41af5607de784cf8":"kZ6eK","b5b8221f48afdf34":"fiRIh","583f1830ebd2ce59":"9njXz","9ccd5569a0fcf7b7":"bnNSm","64c5463457948f13":"d2NWs","48309fa23a070b3d":"3TBXN","60585e269f0f7256":"59Equ","2d780c6609966a3c":"eOYSA","273d13c4294d522e":"2ZAAm","3bb4b1e91d1216cb":"hZXDo","8d1c4f0841f8b08d":"bTxRc","a2752397de34d2b7":"1dlk8"}],"2ZAAm":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5811e950cc85300e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getNativeSelectUtilityClasses = getNativeSelectUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("245b3ea192d7d556"));
var _generateUtilityClass = _interopRequireDefault(require("fdafd1b44c41321f"));
function getNativeSelectUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiNativeSelect', slot);
}
const nativeSelectClasses = (0, _generateUtilityClasses.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var _default = exports.default = nativeSelectClasses;

},{"5811e950cc85300e":"kZ6eK","245b3ea192d7d556":"7pSUk","fdafd1b44c41321f":"jBs9M"}],"kYWMa":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("32af622827c855b6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getSelectUtilityClasses = getSelectUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("571834f8e5a82ccf"));
var _generateUtilityClass = _interopRequireDefault(require("39ba9081d97f21be"));
function getSelectUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiSelect', slot);
}
const selectClasses = (0, _generateUtilityClasses.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var _default = exports.default = selectClasses;

},{"32af622827c855b6":"kZ6eK","571834f8e5a82ccf":"7pSUk","39ba9081d97f21be":"jBs9M"}],"kLz8E":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("6a86099815c70446").default;
var _interopRequireWildcard = require("2b47091f55aeb285").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("8a13c2f5fd56994a"));
var _createSvgIcon = _interopRequireDefault(require("7ee097eca9c1c404"));
var _jsxRuntime = require("29720717239688ae");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

},{"6a86099815c70446":"kZ6eK","2b47091f55aeb285":"fiRIh","8a13c2f5fd56994a":"9njXz","7ee097eca9c1c404":"5sni0","29720717239688ae":"1dlk8"}],"iYZBG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b9d9e7e39a3f138c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTextFieldUtilityClass = getTextFieldUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("cf2d04d10534364a"));
var _generateUtilityClass = _interopRequireDefault(require("bc0f826e926e1841"));
function getTextFieldUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTextField', slot);
}
const textFieldClasses = (0, _generateUtilityClasses.default)('MuiTextField', [
    'root'
]);
var _default = exports.default = textFieldClasses;

},{"b9d9e7e39a3f138c":"kZ6eK","cf2d04d10534364a":"7pSUk","bc0f826e926e1841":"jBs9M"}],"l0Ua8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DraftActions", ()=>DraftActions);
parcelHelpers.export(exports, "DraftSources", ()=>DraftSources);
parcelHelpers.export(exports, "createInput", ()=>createInput);
parcelHelpers.export(exports, "updateInput", ()=>updateInput);
parcelHelpers.export(exports, "getInputs", ()=>getInputs);
parcelHelpers.export(exports, "clearInputFormErrors", ()=>clearInputFormErrors);
parcelHelpers.export(exports, "clearInputs", ()=>clearInputs);
parcelHelpers.export(exports, "removeInput", ()=>removeInput);
parcelHelpers.export(exports, "rerouteInput", ()=>rerouteInput);
parcelHelpers.export(exports, "pcapInput", ()=>pcapInput);
parcelHelpers.export(exports, "removeInputs", ()=>removeInputs);
parcelHelpers.export(exports, "updateInputDistribution", ()=>updateInputDistribution);
parcelHelpers.export(exports, "draftInputs", ()=>draftInputs);
parcelHelpers.export(exports, "enableInputs", ()=>enableInputs);
parcelHelpers.export(exports, "disableInputs", ()=>disableInputs);
parcelHelpers.export(exports, "updateInputRecipients", ()=>updateInputRecipients);
parcelHelpers.export(exports, "registerInputObserver", ()=>registerInputObserver);
parcelHelpers.export(exports, "unregisterInputObserver", ()=>unregisterInputObserver);
parcelHelpers.export(exports, "getBareInputs", ()=>getBareInputs);
var _util = require("common/util");
var _applicationException = require("../../api/ApplicationException");
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
var _params = require("../../utils/params");
var DraftActions = /*#__PURE__*/ function(DraftActions) {
    DraftActions["delete"] = "delete";
    DraftActions["share"] = "share";
    DraftActions["send"] = "send";
    DraftActions["disable"] = "disable";
    return DraftActions;
}({});
var DraftSources = /*#__PURE__*/ function(DraftSources) {
    DraftSources["batch"] = "batch";
    DraftSources["actionMenu"] = "actionMenu";
    return DraftSources;
}({});
const createInput = (0, _toolkit.createAsyncThunk)('inputs/createInput', async (inputInit, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        const input = await api.inputApi.createInput(inputInit);
        navigate()(routes.inputs());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Created Input: ${input.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'create input'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const updateInput = (0, _toolkit.createAsyncThunk)('inputs/updateInput', async (input, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        await api.inputApi.updateInput(input.id, input);
        navigate()(routes.inputs());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Edited Input: ${input.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update input'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const getInputs = (0, _toolkit.createAsyncThunk)('inputs/getInputs', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.inputApi.getInputs((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch inputs'
        }));
        throw err;
    }
});
const clearInputFormErrors = (0, _toolkit.createAction)('inputs/clearInputFormErrors');
const clearInputs = (0, _toolkit.createAction)('inputs/clearInputs');
const removeInput = (0, _toolkit.createAsyncThunk)('inputs/removeInput', async ({ inputId, redirect }, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const input = await api.inputApi.removeInput(inputId);
        redirect && navigate()(routes.inputs());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Removed Input: ${input.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'delete input'
        }));
        throw err;
    }
});
const rerouteInput = (0, _toolkit.createAsyncThunk)('inputs/rerouteInput', async ({ inputId, avoidApplianceId }, { dispatch, extra: { api } })=>{
    try {
        const input = await api.inputApi.rerouteInput(inputId, avoidApplianceId);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Rerouted Input: ${input.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'reroute input'
        }));
        throw err;
    }
});
const pcapInput = (0, _toolkit.createAsyncThunk)('inputs/pcapInput', async ({ inputId, applianceId }, { dispatch, extra: { api } })=>{
    try {
        await api.inputApi.pcapInput(inputId, applianceId);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Initiated packet capture`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'initiating packet capture'
        }));
        throw err;
    }
});
const removeInputs = (0, _toolkit.createAsyncThunk)('inputs/removeInputs', async (ids, { dispatch, extra: { api } })=>{
    try {
        await api.inputApi.removeInputs(ids);
        dispatch(getInputs((0, _utils.withDefaultPagination)((0, _params.getLocationParams)())));
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`${(0, _utils.pluralize)(ids.length, 'input')} removed`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: `delete ${(0, _utils.pluralize)(ids.length, 'input')}`
        }));
        throw err;
    }
});
const updateInputDistribution = (0, _toolkit.createAsyncThunk)('inputs/updateInputDistribution', async ({ id, permissions, listPermissions }, { dispatch, extra: { api }, getState })=>{
    try {
        await api.inputApi.updateInputDistribution(id, permissions, listPermissions);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Updated input share configuration'));
        const group = getState().userReducer.user.group;
        if (permissions.find((i)=>i.permission.groupId === group)) dispatch(getInputs((0, _utils.withDefaultPagination)((0, _params.getLocationParams)())));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update input sharing'
        }));
        throw err;
    }
});
const draftInputs = (0, _toolkit.createAction)('inputs/draftInputs');
const enableInputs = (0, _toolkit.createAsyncThunk)('inputs/enableInputs', async (ids, { dispatch, extra: { api } })=>{
    try {
        const res = await api.inputApi.enableInputs(ids);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Input${ids.length > 1 ? 's' : ''} enabled`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'enable inputs'
        }));
        throw err;
    }
});
const disableInputs = (0, _toolkit.createAsyncThunk)('inputs/disableInputs', async (ids, { dispatch, extra: { api } })=>{
    try {
        const res = await api.inputApi.disableInputs(ids);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Input${ids.length > 1 ? 's' : ''} disabled`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'disable inputs'
        }));
        throw err;
    }
});
const updateInputRecipients = (0, _toolkit.createAsyncThunk)('inputs/updateInputRecipients', async (params, { dispatch, extra: { api } })=>{
    try {
        await api.inputApi.updateInputRecipients(params);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Updated input recipients'));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'send input to outputs'
        }));
    }
});
let hasStartedFetchingInputs = false;
const registerInputObserver = (0, _toolkit.createAsyncThunk)('inputs/registerInputObserver', async (_, { dispatch, getState })=>{
    if (!hasStartedFetchingInputs) {
        hasStartedFetchingInputs = true;
        while(true){
            await (0, _util.sleep)(10000);
            try {
                if (getState().userReducer.user.id && !getState().userReducer.changingUser) // Await so it doesn't queue up requests if the backend is slow, now it will sleep 10s after each fetch
                await dispatch(getBareInputs());
            } catch  {
            // nop
            }
        }
    }
});
const unregisterInputObserver = (0, _toolkit.createAction)('inputs/unregisterInputObserver');
const getBareInputs = (0, _toolkit.createAsyncThunk)('inputs/getBareInputs', async (_, { getState, extra: { api } })=>{
    const inputIds = Object.keys(getState().inputsReducer.inputsToObserve);
    if (inputIds.length > 0) return await api.inputApi.listInputs({
        filter: {
            ids: inputIds
        }
    });
    else return {
        total: 0,
        items: []
    };
});

},{"common/util":"jV4UZ","../../api/ApplicationException":"5oMBs","@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","../../utils/params":"5D6YE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jV4UZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notNull = exports.toSnakeCase = exports.isValidDate = exports.equals = exports.Deferred = exports.sleep = exports.sortByStreamId = void 0;
exports.compareSimple = compareSimple;
exports.compare = compare;
exports.sort = sort;
exports.computeNextBackoffInterval = computeNextBackoffInterval;
exports.withTimeout = withTimeout;
exports.orTimeout = orTimeout;
exports.retry = retry;
exports.equalsMap = equalsMap;
exports.ageSeconds = ageSeconds;
exports.awaitCondition = awaitCondition;
exports.isValidUuid = isValidUuid;
exports.isValidUuidV4 = isValidUuidV4;
exports.clone = clone;
exports.omitProperties = omitProperties;
exports.applianceCommandSuccessResult = applianceCommandSuccessResult;
exports.applianceCommandErrorResult = applianceCommandErrorResult;
exports.pick = pick;
exports.assertExclude = assertExclude;
exports.pairs = pairs;
exports.max = max;
exports.omitNullValuesShallow = omitNullValuesShallow;
exports.sortObjectByKeys = sortObjectByKeys;
exports.areObjectsEqual = areObjectsEqual;
const canonicalize_1 = require("5215faf2fe024c6f");
const serialization_1 = require("41f50c31d3e87e7d");
function compareSimple(t1, t2) {
    if (t1 < t2) return -1;
    if (t1 > t2) return 1;
    return 0;
}
function compare(t1, t2, map) {
    const v1 = map(t1);
    const v2 = map(t2);
    for(let i = 0; i < v1.length; i++){
        const r = compareSimple(v1[i], v2[i]);
        if (r !== 0) return r;
    }
    return 0;
}
function sort(...k) {
    return (t1, t2)=>compare(t1, t2, (t)=>k.map((keyOrSelector)=>typeof keyOrSelector !== 'function' ? t[keyOrSelector] : keyOrSelector(t)));
}
const sortByStreamId = (a, b)=>{
    if (a.streamId === b.streamId) return 0;
    if (a.streamId > b.streamId) return 1;
    return -1;
};
exports.sortByStreamId = sortByStreamId;
// Credit: https://github.com/ide/backoff
// MIT License
// Copyright (c) 2019 James Ide
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
function computeNextBackoffInterval(initialBackoff, previousRetryCount, { multiplier = 1.5, randomizationFactor = 0.25, minBackoff = initialBackoff, maxBackoff = Infinity } = {}) {
    assert(initialBackoff > 0, `The initial backoff interval must be positive`);
    assert(previousRetryCount >= 0, `The previous retry count must not be negative`);
    assert(multiplier >= 1, `The backoff multiplier must be greater than or equal to 1`);
    assert(0 <= randomizationFactor && randomizationFactor <= 1, `The randomization factor must be between 0 and 1, inclusive`);
    assert(minBackoff >= 0, `The minimum backoff interval must be positive`);
    const nextBackoff = initialBackoff * multiplier ** previousRetryCount;
    // Apply jitter within the negative to positive range of the randomization factor
    const jitterFactor = 1 - randomizationFactor + 2 * randomizationFactor * Math.random();
    return Math.min(Math.max(nextBackoff * jitterFactor, minBackoff), maxBackoff);
}
function assert(cond, message) {
    if (!cond) throw new Error(message);
}
const sleep = (ms)=>new Promise((res)=>setTimeout(res, ms));
exports.sleep = sleep;
function withTimeout(timeoutMs, fn) {
    return ()=>{
        const timeout = (0, exports.sleep)(timeoutMs).then(()=>Promise.reject(new Error('Timeout')));
        return Promise.race([
            fn(),
            timeout
        ]);
    };
}
async function orTimeout(p, timeoutMs) {
    return await Promise.race([
        p,
        (0, exports.sleep)(timeoutMs).then(()=>{
            throw new Error(`Timeout ${timeoutMs}ms`);
        })
    ]);
}
async function retry(op, opt) {
    const { maxRetries, initialBackoff, maxBackoff } = opt;
    let lastError;
    for(let i = 0; i <= maxRetries; i++)try {
        return await op();
    } catch (e) {
        lastError = e;
        if (i < maxRetries) {
            const nextSleep = computeNextBackoffInterval(initialBackoff, i, {
                maxBackoff: maxBackoff | Infinity
            });
            await (0, exports.sleep)(nextSleep);
            continue;
        }
    }
    throw lastError;
}
function equalsMap(map) {
    return (t1, t2)=>{
        return map(t1) === map(t2);
    };
}
function ageSeconds(d, dateNow = new Date()) {
    let date;
    if (typeof d === 'string') date = Date.parse(d);
    else date = d.valueOf();
    return Math.floor((dateNow.valueOf() - date) / 1000);
}
class Deferred {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
exports.Deferred = Deferred;
async function awaitCondition(cond, timeoutMs, intervalMs, throwOnError = false) {
    let v = false;
    const start = Date.now();
    function maybeThrow(p) {
        return p.catch((e)=>{
            if (throwOnError) throw e;
            return false;
        });
    }
    while(!(v = await maybeThrow(cond())) && Date.now() - start < timeoutMs)await (0, exports.sleep)(intervalMs);
    return v;
}
function isValidUuid(uuid, version) {
    const uuidRegex = version ? new RegExp(`^[0-9a-f]{8}-[0-9a-f]{4}-${version}[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$`, 'i') : /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
}
/** @deprecated Use isValidUuid instead. isValidUuidV4 also allows uuid v1-v5. */ function isValidUuidV4(uuid) {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
}
function clone(t) {
    return (0, serialization_1.jsonParse)((0, serialization_1.jsonStringify)(t));
}
function omitProperties(t, ...k) {
    const c = clone(t);
    for (const p of k)delete c[p];
    return c;
}
function applianceCommandSuccessResult(command, result) {
    return {
        type: 'commandResult',
        data: {
            success: true,
            result: result || {},
            command
        }
    };
}
function applianceCommandErrorResult(command, errorMessage) {
    return {
        type: 'commandResult',
        data: {
            success: false,
            errorMessage,
            command
        }
    };
}
const equals = (objA, objB)=>{
    return (0, canonicalize_1.canonicalize)(objA) == (0, canonicalize_1.canonicalize)(objB);
};
exports.equals = equals;
function pick(t, ...pickKeys) {
    if (!t) return t;
    const o = {};
    for (const k of pickKeys)o[k] = t[k];
    return o;
}
function assertExclude(value, excluded, errorMessage) {
    if (value == excluded) throw new Error(errorMessage || `Unexpected value: ${excluded}`);
    return value;
}
/**
 * Return pairs with one item from each of the sequences
 *
 * @param itemsA itemsA[i] == result[i][0]
 * @param itemsB itemsB[i] == result[i][1]
 */ function pairs(itemsA, itemsB) {
    if (itemsA.length !== itemsB.length) throw new Error(`Can only pair sequences of the same length (${itemsA.length} != ${itemsB.length})`);
    const result = [];
    for(let i = 0; i < itemsA.length; i++)result.push([
        itemsA[i],
        itemsB[i]
    ]);
    return result;
}
function max(nums) {
    let leader = Number.NEGATIVE_INFINITY;
    for (const n of nums)if (n > leader) leader = n;
    return leader;
}
const isValidDate = (date)=>Object.prototype.toString.call(date) === '[object Date]' && Number.isFinite(date.getTime());
exports.isValidDate = isValidDate;
function omitNullValuesShallow(obj) {
    const returned = {};
    for (const k of Object.keys(obj))if (obj[k] !== null) returned[k] = obj[k];
    return returned;
}
const toSnakeCase = (input)=>{
    return input.split(/(?=[A-Z])/).join('_').toLowerCase();
};
exports.toSnakeCase = toSnakeCase;
const notNull = (v)=>v !== null;
exports.notNull = notNull;
function sortObjectByKeys(unsorted) {
    return Object.keys(unsorted).sort().reduce((sorted, key)=>{
        const value = unsorted[key];
        const isObject = !!(value && typeof value === 'object' && !Array.isArray(value));
        return {
            ...sorted,
            [key]: isObject ? sortObjectByKeys(value) : value
        };
    }, {});
}
function areObjectsEqual(a, b) {
    if (a && b) return JSON.stringify(sortObjectByKeys(a)) === JSON.stringify(sortObjectByKeys(b));
    return !a && !b;
}

},{"5215faf2fe024c6f":"6YrYz","41f50c31d3e87e7d":"j24dT"}],"6YrYz":[function(require,module,exports,__globalThis) {
"use strict";
/* eslint no-param-reassign: 'off' */ /* eslint valid-typeof: 'off' */ // https://tools.ietf.org/html/draft-rundgren-json-canonicalization-scheme-06
// JSON canonicalize function. Creates crypto safe predictable canocalization of JSON as defined by draft-rundgren-json-canonicalization-scheme
// Implementation from https://github.com/erdtman/canonicalize adapted to typescript
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canonicalize = canonicalize;
// Changed serialization to remove undefined properties
// NOTE! Be careful with updating this function as it might cause MAJOR SERVICE DISRUPTIONS if all stream configurations are suddenly considered new
function canonicalize(object) {
    return serialize(object);
    function serialize(object) {
        if (typeof object === 'bigint') return JSON.stringify(`${object.toString()}n`);
        if (object === null || typeof object !== 'object' || object.toJSON != null) return JSON.stringify(object);
        if (Array.isArray(object) && object.length === 0) return '[]';
        if (Array.isArray(object) && object.length === 1) return '[' + serialize(object[0]) + ']';
        if (Array.isArray(object)) return '[' + object.reduce((t, cv, ci)=>{
            t = ci === 1 ? serialize(t) : t;
            return t + ',' + serialize(cv);
        }) + ']';
        const keys = Object.entries(object).filter(([_, v])=>typeof v !== 'undefined').map(([k])=>k);
        if (keys.length === 0) return '{}';
        if (keys.length === 1) {
            // eslint-disable-next-line no-constant-binary-expression
            object[keys[0]];
            return '{' + serialize(keys[0]) + ':' + serialize(object[keys[0]]) + '}';
        }
        return '{' + keys.sort().filter((k)=>typeof object[k] !== 'undefined').reduce((t, cv, ci)=>{
            t = ci === 1 ? serialize(t) + ':' + serialize(object[t]) : t;
            return t + ',' + serialize(cv) + ':' + serialize(object[cv]);
        }) + '}';
    }
}

},{}],"j24dT":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.jsonStringify = jsonStringify;
exports.jsonParse = jsonParse;
exports.tryStringify = tryStringify;
exports.tryConvertDates = tryConvertDates;
const fast_safe_stringify_1 = __importDefault(require("4d717f1d6ab4e8a7"));
const bigintRegex = /^bigint\((-?[\d]*)\)$/;
const buffer64Regex = /^buffer64\(-?([\d]*)\)$/;
function bigIntReplacer(_key, value) {
    if (typeof value === 'bigint') return `bigint(${value.toString()})`;
    return value;
}
function bigIntAndDateAndBufferReviver(key, value) {
    if (typeof value === 'string') {
        const bigIntMatch = bigintRegex.exec(value);
        if (bigIntMatch) return BigInt(bigIntMatch[1]);
        const bufferMatch = buffer64Regex.exec(value);
        if (bufferMatch) return base64ToUint8Array(bufferMatch[1]);
        if (key.endsWith('At') || key.endsWith('Date')) return new Date(value);
    }
    return value;
}
function base64ToUint8Array(base64) {
    if (globalThis.Buffer) return globalThis.Buffer.from(base64, 'base64');
    else return Uint8Array.from(atob(base64), (c)=>c.charCodeAt(0));
}
function jsonStringify(o, space) {
    // TODO: Use fastSafeStringify instead?
    return JSON.stringify(o, bigIntReplacer, space);
}
function jsonParse(s) {
    return JSON.parse(s, bigIntAndDateAndBufferReviver);
}
function tryStringify(o) {
    try {
        return typeof o === 'string' ? o : (0, fast_safe_stringify_1.default)(o);
    } catch  {
        // E.g. due circular dependencies
        return undefined;
    }
}
const isISOString = (s)=>{
    return typeof s === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/.test(s);
};
/**  Covert ISOString to Date recursively */ function tryConvertDates(item) {
    if (!item) return item;
    if (Array.isArray(item)) return item.map(tryConvertDates);
    else if (typeof item === 'object') {
        for (const key of Object.keys(item))item[key] = tryConvertDates(item[key]);
        return item;
    } else if (isISOString(item)) return item.endsWith('Z') ? new Date(item) : new Date(item + '.000Z');
    else return item;
}

},{"4d717f1d6ab4e8a7":"3Hs43"}],"3Hs43":[function(require,module,exports,__globalThis) {
module.exports = stringify;
stringify.default = stringify;
stringify.stable = deterministicStringify;
stringify.stableStringify = deterministicStringify;
var LIMIT_REPLACE_NODE = '[...]';
var CIRCULAR_REPLACE_NODE = '[Circular]';
var arr = [];
var replacerStack = [];
function defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function stringify(obj, replacer, spacer, options) {
    if (typeof options === 'undefined') options = defaultOptions();
    decirc(obj, '', 0, [], undefined, 0, options);
    var res;
    try {
        if (replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]');
    } finally{
        while(arr.length !== 0){
            var part = arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        arr.push([
            parent,
            k,
            val
        ]);
    }
}
function decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === 'object' && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== 'undefined' && depth > options.depthLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== 'undefined' && edgeIndex + 1 > options.edgesLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === 'undefined') options = defaultOptions();
    var tmp = deterministicDecirc(obj, '', 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if (replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]');
    } finally{
        // Ensure that we restore the object as it was.
        while(arr.length !== 0){
            var part = arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === 'object' && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === 'function') return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== 'undefined' && depth > options.depthLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== 'undefined' && edgeIndex + 1 > options.edgesLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort(compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== 'undefined') {
                arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function replaceGetterValues(replacer) {
    replacer = typeof replacer !== 'undefined' ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if (replacerStack.length > 0) for(var i = 0; i < replacerStack.length; i++){
            var part = replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

},{}],"5D6YE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSearchParams", ()=>parseSearchParams);
parcelHelpers.export(exports, "getLocationParams", ()=>getLocationParams);
function parseSearchParams(search) {
    const searchParamsMap = new URLSearchParams(search);
    return [
        ...searchParamsMap.entries()
    ].reduce((a, [key, value])=>{
        return {
            ...a,
            [key]: value
        };
    }, {});
}
const getLocationParams = ()=>{
    const search = document.location.href.split('?').pop();
    if (!search) return {};
    return parseSearchParams(search);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"alMzI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DraftActions", ()=>DraftActions);
parcelHelpers.export(exports, "DraftSources", ()=>DraftSources);
parcelHelpers.export(exports, "draftOutputs", ()=>draftOutputs);
parcelHelpers.export(exports, "createOutput", ()=>createOutput);
parcelHelpers.export(exports, "updateOutput", ()=>updateOutput);
parcelHelpers.export(exports, "removeOutput", ()=>removeOutput);
parcelHelpers.export(exports, "removeOutputs", ()=>removeOutputs);
parcelHelpers.export(exports, "registerOutputObserver", ()=>registerOutputObserver);
parcelHelpers.export(exports, "unregisterOutputObserver", ()=>unregisterOutputObserver);
parcelHelpers.export(exports, "getBareOutputs", ()=>getBareOutputs);
parcelHelpers.export(exports, "getOutputs", ()=>getOutputs);
parcelHelpers.export(exports, "getOutputsWithLists", ()=>getOutputsWithLists);
parcelHelpers.export(exports, "getTotalOutputCount", ()=>getTotalOutputCount);
parcelHelpers.export(exports, "enableOutputs", ()=>enableOutputs);
parcelHelpers.export(exports, "disableOutputs", ()=>disableOutputs);
parcelHelpers.export(exports, "setInputOfOutput", ()=>setInputOfOutput);
parcelHelpers.export(exports, "clearOutputFormErrors", ()=>clearOutputFormErrors);
parcelHelpers.export(exports, "clearOutputs", ()=>clearOutputs);
var _toolkit = require("@reduxjs/toolkit");
var _util = require("common/util");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
var _params = require("../../utils/params");
var _applicationException = require("../../api/ApplicationException");
var DraftActions = /*#__PURE__*/ function(DraftActions) {
    DraftActions["delete"] = "delete";
    DraftActions["disable"] = "disable";
    return DraftActions;
}({});
var DraftSources = /*#__PURE__*/ function(DraftSources) {
    DraftSources["batch"] = "batch";
    DraftSources["actionMenu"] = "actionMenu";
    return DraftSources;
}({});
const draftOutputs = (0, _toolkit.createAction)('outputs/draftOutputs');
const createOutput = (0, _toolkit.createAsyncThunk)('outputs/createOutput', async ({ output, redirect }, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        await api.outputApi.createOutput(output);
        redirect && navigate()(routes.outputs());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Created output: ${output.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'create output'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const updateOutput = (0, _toolkit.createAsyncThunk)('outputs/updateOutput', async ({ output, redirect }, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.outputApi.updateOutput(output.id, output);
        redirect && navigate()(routes.outputs());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Edited output: ${output.name}`));
        if ((0, _utils.getCurrentPage)() === routes.outputs.route) dispatch(getOutputs((0, _utils.withDefaultPagination)((0, _params.getLocationParams)())));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update output'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const removeOutput = (0, _toolkit.createAsyncThunk)('outputs/removeOutput', async ({ output, redirect }, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        await api.outputApi.removeOutput(output.id);
        redirect && navigate()(routes.outputs());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Removed output: ${output.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'delete output'
        }));
        throw err;
    }
});
const removeOutputs = (0, _toolkit.createAsyncThunk)('outputs/removeOutputs', async (ids, { dispatch, extra: { api } })=>{
    try {
        const deleteResult = await api.outputApi.removeOutputs(ids);
        const notDeleted = deleteResult.notDeleted.length;
        if (notDeleted > 0) {
            const errorMessage = `Failed to delete ${notDeleted} ${(0, _utils.pluralize)(notDeleted, 'output')}. Try deleting each output individually to see the error message.`;
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: new (0, _applicationException.ApplicationException)({
                    details: errorMessage,
                    text: errorMessage,
                    errorCode: '',
                    fatal: false,
                    origin: undefined
                }),
                operation: `delete ${(0, _utils.pluralize)(notDeleted, 'output')}`
            }));
        } else dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`${(0, _utils.pluralize)(ids.length, 'Output')} removed`));
        dispatch(getOutputs((0, _utils.withDefaultPagination)((0, _params.getLocationParams)())));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: `delete ${(0, _utils.pluralize)(ids.length, 'output')}`
        }));
        throw err;
    }
});
let hasStartedFetchingOutputs = false;
const registerOutputObserver = (0, _toolkit.createAsyncThunk)('outputs/registerOutputObserver', async (_, { dispatch, getState })=>{
    if (!hasStartedFetchingOutputs) {
        hasStartedFetchingOutputs = true;
        while(true){
            await (0, _util.sleep)(10000);
            try {
                if (getState().userReducer.user.id && !getState().userReducer.changingUser) // Await so it doesn't queue up requests if the backend is slow, now it will sleep 10s after each fetch
                await dispatch(getBareOutputs());
            } catch  {
            // nop
            }
        }
    }
});
const unregisterOutputObserver = (0, _toolkit.createAction)('outputs/unregisterOutputObserver');
const getBareOutputs = (0, _toolkit.createAsyncThunk)('outputs/getBareOutputs', async (_, { getState, extra: { api } })=>{
    const outputIds = Object.keys(getState().outputsReducer.outputsToObserve);
    if (outputIds.length > 0) return await api.outputApi.getBareOutputs({
        ids: outputIds
    });
    else return {
        total: 0,
        items: []
    };
});
const getOutputs = (0, _toolkit.createAsyncThunk)('outputs/getOutputs', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.outputApi.getOutputs((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch outputs'
        }));
        throw err;
    }
});
const getOutputsWithLists = (0, _toolkit.createAsyncThunk)('outputs/getOutputsWithLists', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.outputApi.getOutputsWithLists((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch outputs and lists'
        }));
        throw err;
    }
});
const getTotalOutputCount = (0, _toolkit.createAsyncThunk)('outputs/getTotalOutputCount', async (_, { dispatch, extra: { api } })=>{
    try {
        return await api.outputApi.getTotalOutputCount();
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch output count'
        }));
        throw err;
    }
});
const enableOutputs = (0, _toolkit.createAsyncThunk)('outputs/enableOutputs', async (ids, { dispatch, extra: { api } })=>{
    try {
        const res = await api.outputApi.enableOutputs(ids);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Output${ids.length > 1 ? 's' : ''} enabled`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'enable outputs'
        }));
        throw err;
    }
});
const disableOutputs = (0, _toolkit.createAsyncThunk)('outputs/disableOutputs', async (ids, { dispatch, extra: { api } })=>{
    try {
        const res = await api.outputApi.disableOutputs(ids);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Output${ids.length > 1 ? 's' : ''} disabled`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'disable outputs'
        }));
        throw err;
    }
});
const setInputOfOutput = (0, _toolkit.createAsyncThunk)('outputs/setInputOfOutput', async ({ output, inputId }, { dispatch, rejectWithValue, extra: { api } })=>{
    try {
        const res = await api.outputApi.setInputOfOutput(output.id, inputId);
        const msg = inputId ? `Switched input of '${output.name}'` : `Cleared input of '${output.name}'`;
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(msg));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'switch input of output'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const clearOutputFormErrors = (0, _toolkit.createAction)('outputs/clearOutputFormErrors');
const clearOutputs = (0, _toolkit.createAction)('outputs/clearOutputs');

},{"@reduxjs/toolkit":"8ces8","common/util":"jV4UZ","./notificationActions":"7LkQg","../../utils":"342UB","../../utils/params":"5D6YE","../../api/ApplicationException":"5oMBs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bqPI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGroup", ()=>createGroup);
parcelHelpers.export(exports, "removeGroup", ()=>removeGroup);
parcelHelpers.export(exports, "updateGroup", ()=>updateGroup);
parcelHelpers.export(exports, "getGroups", ()=>getGroups);
parcelHelpers.export(exports, "getGroup", ()=>getGroup);
parcelHelpers.export(exports, "clearGroup", ()=>clearGroup);
parcelHelpers.export(exports, "clearGroups", ()=>clearGroups);
var _toolkit = require("@reduxjs/toolkit");
var _applicationException = require("../../api/ApplicationException");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
const createGroup = (0, _toolkit.createAsyncThunk)('group/createGroup', async (group, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        await api.groupsApi.createGroup(group);
        navigate()(routes.groups());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Created Group ${group.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'create group'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const removeGroup = (0, _toolkit.createAsyncThunk)('groups/removeGroup', async (groupId, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.groupsApi.removeGroup(groupId);
        navigate()(routes.groups());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Removed Group: ${res.name}`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'delete group'
        }));
        throw err;
    }
});
const updateGroup = (0, _toolkit.createAsyncThunk)('group/updateGroup', async (group, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        await api.groupsApi.updateGroup(group.id, {
            name: group.name,
            applianceSecret: group.applianceSecret || ''
        });
        navigate()(routes.groups());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Edited Group: ${group.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update group'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const getGroups = (0, _toolkit.createAsyncThunk)('group/getGroups', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.groupsApi.getPureGroups((0, _utils.withDefaultPagination)(params));
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'get groups'
        }));
        throw error;
    }
});
const getGroup = (0, _toolkit.createAsyncThunk)('group/getGroup', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.groupsApi.getGroup(id);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'get group'
        }));
        throw error;
    }
});
const clearGroup = (0, _toolkit.createAction)('group/clearGroup');
const clearGroups = (0, _toolkit.createAction)('group/clearGroups');

},{"@reduxjs/toolkit":"8ces8","../../api/ApplicationException":"5oMBs","./notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5YSBF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPort", ()=>getPort);
parcelHelpers.export(exports, "getPorts", ()=>getPorts);
parcelHelpers.export(exports, "updatePort", ()=>updatePort);
parcelHelpers.export(exports, "clearPort", ()=>clearPort);
parcelHelpers.export(exports, "clearPorts", ()=>clearPorts);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
const getPort = (0, _toolkit.createAsyncThunk)('port/getPort', async (id, { extra: { api } })=>{
    return await api.portsApi.getPort(id);
});
const getPorts = (0, _toolkit.createAsyncThunk)('port/getPorts', async (params, { extra: { api } })=>{
    return await api.portsApi.getPorts((0, _utils.withDefaultPagination)((0, _utils.withDefaultPagination)(params)));
});
const updatePort = (0, _toolkit.createAsyncThunk)('port/updatePort', async ({ appliance, sharedPorts }, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.portsApi.updatePort(appliance.id, sharedPorts);
        navigate()(routes.interfaces());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Interface of ${appliance.name} updated`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update port'
        }));
        throw err;
    }
});
const clearPort = (0, _toolkit.createAction)('port/clearPort');
const clearPorts = (0, _toolkit.createAction)('port/clearPorts');

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"TaoIu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeAppliance", ()=>removeAppliance);
parcelHelpers.export(exports, "removeAppliances", ()=>removeAppliances);
parcelHelpers.export(exports, "updateAppliance", ()=>updateAppliance);
parcelHelpers.export(exports, "getAppliances", ()=>getAppliances);
parcelHelpers.export(exports, "getGeoAppliances", ()=>getGeoAppliances);
parcelHelpers.export(exports, "getAppliance", ()=>getAppliance);
parcelHelpers.export(exports, "getTotalRegions", ()=>getTotalRegions);
parcelHelpers.export(exports, "clearAppliance", ()=>clearAppliance);
parcelHelpers.export(exports, "clearAppliances", ()=>clearAppliances);
parcelHelpers.export(exports, "restartAppliance", ()=>restartAppliance);
parcelHelpers.export(exports, "restartAppliances", ()=>restartAppliances);
parcelHelpers.export(exports, "recreateTunnels", ()=>recreateTunnels);
parcelHelpers.export(exports, "getApplianceConfig", ()=>getApplianceConfig);
parcelHelpers.export(exports, "clearCachedApplianceConfig", ()=>clearCachedApplianceConfig);
parcelHelpers.export(exports, "initAppliance", ()=>initAppliance);
parcelHelpers.export(exports, "registerApplianceObserver", ()=>registerApplianceObserver);
parcelHelpers.export(exports, "unregisterApplianceObserver", ()=>unregisterApplianceObserver);
parcelHelpers.export(exports, "getBareAppliances", ()=>getBareAppliances);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _util = require("common/util");
var _types = require("common/api/v1/types");
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
var _params = require("../../utils/params");
const removeAppliance = (0, _toolkit.createAsyncThunk)('appliance', async (id, { dispatch, extra: { api } })=>{
    try {
        await api.appliancesApi.removeAppliance(id);
        dispatch(getAppliances((0, _utils.withDefaultPagination)((0, _params.getLocationParams)())));
        return id;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'delete appliance'
        }));
        throw err;
    }
});
const removeAppliances = (0, _toolkit.createAsyncThunk)('appliance/removeAppliances', async (ids, { dispatch })=>{
    ids.forEach((id)=>{
        dispatch(removeAppliance(id));
    });
    dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Appliances are being deleted'));
});
const updateAppliance = (0, _toolkit.createAsyncThunk)('appliance/updateAppliance', async ({ appliance, redirect, values }, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.appliancesApi.updateAppliance(appliance.id, values);
        redirect && navigate()(routes.appliances());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Appliance ${appliance.name} updated`));
        dispatch(getAppliances((0, _utils.withDefaultPagination)((0, _params.getLocationParams)())));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update appliance'
        }));
        throw err;
    }
});
const getAppliances = (0, _toolkit.createAsyncThunk)('appliance/getAppliances', async (params, { dispatch, getState, extra: { api } })=>{
    try {
        return await api.appliancesApi.getAppliances((0, _utils.withDefaultPagination)({
            ...params,
            isSystemProvider: (0, _getDefault.default)(getState(), 'value.userReducer.user.role') === (0, _types.Role).super
        }));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch appliances'
        }));
        throw err;
    }
});
const getGeoAppliances = (0, _toolkit.createAsyncThunk)('appliance/getGeoAppliances', async (params, { dispatch, getState, extra: { api } })=>{
    try {
        return await api.appliancesApi.getGeoAppliances((0, _utils.withDefaultPagination)({
            ...params,
            isSystemProvider: (0, _getDefault.default)(getState(), 'value.userReducer.user.role') === (0, _types.Role).super
        }));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch geo appliances'
        }));
        throw err;
    }
});
const getAppliance = (0, _toolkit.createAsyncThunk)('appliance/getAppliance', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.appliancesApi.getAppliance(id);
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch appliance'
        }));
        throw 'Failed to fetch appliance';
    }
});
const getTotalRegions = (0, _toolkit.createAsyncThunk)('appliance/getTotalRegions', async (_, { extra: { api } })=>{
    const { total } = await api.regionApi.getRegions((0, _utils.withDefaultPagination)({}));
    return {
        totalRegions: total
    };
});
const clearAppliance = (0, _toolkit.createAction)('appliances/clearAppliance');
const clearAppliances = (0, _toolkit.createAction)('appliances/clearAppliances');
const restartAppliance = (0, _toolkit.createAsyncThunk)('appliance/restartAppliance', async ({ id, showSuccessSnackbar }, { dispatch, extra: { api } })=>{
    try {
        const res = await api.appliancesApi.restart(id);
        if (showSuccessSnackbar) dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Appliance restarted'));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'restart appliance'
        }));
        throw err;
    }
});
const restartAppliances = (0, _toolkit.createAsyncThunk)('appliance/restartAppliances', async ({ ids }, { dispatch })=>{
    ids.forEach((id)=>{
        dispatch(restartAppliance({
            id,
            showSuccessSnackbar: false
        }));
    });
    dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Appliances are restarting'));
});
const recreateTunnels = (0, _toolkit.createAsyncThunk)('appliance/recreateTunnels', async ({ id }, { dispatch, extra: { api } })=>{
    try {
        const res = await api.appliancesApi.recreateTunnels(id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Appliance tunnels recreated'));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'recreate appliance tunnels'
        }));
        throw err;
    }
});
const getApplianceConfig = (0, _toolkit.createAsyncThunk)('appliance/getApplianceConfig', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.appliancesApi.getConfig(id);
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch appliance config'
        }));
        throw err;
    }
});
const clearCachedApplianceConfig = (0, _toolkit.createAsyncThunk)('appliance/clearCachedApplianceConfig', async (id, { dispatch, extra: { api } })=>{
    try {
        await api.appliancesApi.clearCachedApplianceConfig(id);
        await dispatch(getApplianceConfig(id));
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Appliance config regenerated'));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'regenerate appliance config'
        }));
        throw err;
    }
});
const initAppliance = (0, _toolkit.createAsyncThunk)('appliance/initAppliance', async (_, { getState, dispatch })=>{
    const user = getState().userReducer.user;
    if ('id' in user && user.role !== (0, _types.Role).basic) dispatch(getTotalRegions());
});
let hasStartedFetchingAppliances = false;
const registerApplianceObserver = (0, _toolkit.createAsyncThunk)('appliance/registerApplianceObserver', async (_, { dispatch, getState, extra: { routes } })=>{
    if (!hasStartedFetchingAppliances) {
        hasStartedFetchingAppliances = true;
        while(true){
            // Await so it doesn't queue up requests if the backend is slow, now it will sleep 10s after each fetch
            await (0, _util.sleep)(10000);
            if (!(0, _utils.getIsStreamManager)((0, _utils.getCurrentPage)(), routes) && !!getState().userReducer.user.id && !getState().userReducer.changingUser) await dispatch(getBareAppliances());
        }
    }
});
const unregisterApplianceObserver = (0, _toolkit.createAction)('appliance/unregisterApplianceObserver');
const getBareAppliances = (0, _toolkit.createAsyncThunk)('appliances/getBareAppliances', async (_, { getState, extra: { api } })=>{
    const applianceIds = Object.keys(getState().appliancesReducer.appliancesToObserve);
    if (applianceIds.length > 0) return await api.appliancesApi.listAppliances({
        filter: {
            ids: applianceIds
        }
    });
    else return {
        total: 0,
        items: []
    };
});

},{"lodash/get":"dBTJh","common/util":"jV4UZ","common/api/v1/types":"3qemx","@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","../../utils/params":"5D6YE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dBTJh":[function(require,module,exports,__globalThis) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"5Vkba"}],"5Vkba":[function(require,module,exports,__globalThis) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"1tEcE","c3296f04fad32769":"b5swP"}],"1tEcE":[function(require,module,exports,__globalThis) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"1DVeR","e823e604d75f975b":"c7lh2","f5fff1c342107fbd":"6K5tB","b04e8cc634273c23":"iEDGT"}],"c7lh2":[function(require,module,exports,__globalThis) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"1DVeR","4cdff6c9e9ff5d38":"fMaHV"}],"fMaHV":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"5ltt8","74644060ad1a1d3c":"4gOki"}],"6K5tB":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"9EwFx"}],"9EwFx":[function(require,module,exports,__globalThis) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"kx0Xn"}],"kx0Xn":[function(require,module,exports,__globalThis) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"lV1BE"}],"iEDGT":[function(require,module,exports,__globalThis) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"E4Kq0"}],"E4Kq0":[function(require,module,exports,__globalThis) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"crlKT","8439a3a1551d0706":"chzeu","4b12c9f502d3288a":"1DVeR","a0ebd327d618908a":"fMaHV"}],"chzeu":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"b5swP":[function(require,module,exports,__globalThis) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"fMaHV"}],"ce4Vm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOutputList", ()=>createOutputList);
parcelHelpers.export(exports, "removeOutputList", ()=>removeOutputList);
parcelHelpers.export(exports, "updateOutputList", ()=>updateOutputList);
parcelHelpers.export(exports, "getOutputLists", ()=>getOutputLists);
parcelHelpers.export(exports, "getOutputList", ()=>getOutputList);
parcelHelpers.export(exports, "clearOutputList", ()=>clearOutputList);
parcelHelpers.export(exports, "clearOutputLists", ()=>clearOutputLists);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
var _applicationException = require("../../api/ApplicationException");
const createOutputList = (0, _toolkit.createAsyncThunk)('outputLists/createOutputList', async (outputList, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.outputListsApi.createOutputList(outputList);
        navigate()(routes.outputLists());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Created output list ${outputList.name}`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'create output list'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const removeOutputList = (0, _toolkit.createAsyncThunk)('outputLists/removeOutputList', async (outputListId, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.outputListsApi.removeOutputList(outputListId);
        navigate()(routes.outputLists());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Removed output list: ${res.name}`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'delete output list'
        }));
        throw err;
    }
});
const updateOutputList = (0, _toolkit.createAsyncThunk)('outputLists/updateOutputList', async ({ outputList, withRedirection }, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.outputListsApi.updateOutputList(outputList.id, outputList);
        withRedirection && navigate()(routes.outputLists());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Edited output list: ${outputList.name}`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update output list'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const getOutputLists = (0, _toolkit.createAsyncThunk)('outputLists/getOutputLists', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.outputListsApi.getOutputLists((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch output lists'
        }));
        throw err;
    }
});
const getOutputList = (0, _toolkit.createAsyncThunk)('outputLists/getOutputList', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.outputListsApi.getOutputList(id);
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch output list'
        }));
        throw err;
    }
});
const clearOutputList = (0, _toolkit.createAction)('outputLists/clearOutputList');
const clearOutputLists = (0, _toolkit.createAction)('outputLists/clearOutputLists');

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","../../api/ApplicationException":"5oMBs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k9GYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGroupList", ()=>createGroupList);
parcelHelpers.export(exports, "removeGroupList", ()=>removeGroupList);
parcelHelpers.export(exports, "updateGroupList", ()=>updateGroupList);
parcelHelpers.export(exports, "getGroupLists", ()=>getGroupLists);
parcelHelpers.export(exports, "getGroupList", ()=>getGroupList);
parcelHelpers.export(exports, "clearGroupList", ()=>clearGroupList);
var _toolkit = require("@reduxjs/toolkit");
var _applicationException = require("../../api/ApplicationException");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
const createGroupList = (0, _toolkit.createAsyncThunk)('groupLists/createGroupList', async (groupList, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.groupListsApi.createGroupList(groupList);
        navigate()(routes.groupLists());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Created group list ${groupList.name}`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'create group list'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const removeGroupList = (0, _toolkit.createAsyncThunk)('groupList/removeGroupList', async (groupListId, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.groupListsApi.removeGroupList(groupListId);
        navigate()(routes.groupLists());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Removed group list: ${res.name}`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'delete group list'
        }));
        throw err;
    }
});
const updateGroupList = (0, _toolkit.createAsyncThunk)('groupLists/updateGroupList', async ({ groupList, withRedirection }, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.groupListsApi.updateGroupList(groupList.id, groupList);
        withRedirection && navigate()(routes.groupLists());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Edited group list: ${groupList.name}`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update group list'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const getGroupLists = (0, _toolkit.createAsyncThunk)('groupLists/getGroupLists', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.groupListsApi.getGroupLists((0, _utils.withDefaultPagination)(params));
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'get group lists'
        }));
        throw error;
    }
});
const getGroupList = (0, _toolkit.createAsyncThunk)('groupLists/getGroupList', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.groupListsApi.getGroupList(id);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'get group list'
        }));
        throw error;
    }
});
const clearGroupList = (0, _toolkit.createAction)('groupLists/clearGroupList');

},{"@reduxjs/toolkit":"8ces8","../../api/ApplicationException":"5oMBs","./notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jEYBl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAudit", ()=>getAudit);
var _toolkit = require("@reduxjs/toolkit");
var _utils = require("../../utils");
var _notificationActions = require("./notificationActions");
const getAudit = (0, _toolkit.createAsyncThunk)('audit/getAudit', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.auditApi.getAudit((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch audit log'
        }));
        throw err;
    }
});

},{"@reduxjs/toolkit":"8ces8","../../utils":"342UB","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gRXht":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAlarmLogs", ()=>getAlarmLogs);
var _toolkit = require("@reduxjs/toolkit");
var _utils = require("../../utils");
var _notificationActions = require("./notificationActions");
const getAlarmLogs = (0, _toolkit.createAsyncThunk)('audit/getAlarmLogs', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.alarmLogsApi.getAlarmLogs((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch alarm log'
        }));
        throw err;
    }
});

},{"@reduxjs/toolkit":"8ces8","../../utils":"342UB","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d48MN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegions", ()=>getRegions);
parcelHelpers.export(exports, "getRegionDetails", ()=>getRegionDetails);
parcelHelpers.export(exports, "updateRegion", ()=>updateRegion);
parcelHelpers.export(exports, "setDefaultRegion", ()=>setDefaultRegion);
parcelHelpers.export(exports, "deleteRegion", ()=>deleteRegion);
parcelHelpers.export(exports, "clearRegions", ()=>clearRegions);
parcelHelpers.export(exports, "clearRegion", ()=>clearRegion);
var _toolkit = require("@reduxjs/toolkit");
var _index = require("../../utils/index");
var _notificationActions = require("./notificationActions");
const getRegions = (0, _toolkit.createAsyncThunk)('regions/getRegions', async (params, { extra: { api } })=>{
    return api.regionApi.getRegions((0, _index.withDefaultPagination)(params));
});
const getRegionDetails = (0, _toolkit.createAsyncThunk)('regions/getRegionDetails', async (id, { dispatch, extra: { api } })=>{
    try {
        const region = await api.regionApi.getRegion(id);
        const details = await api.regionApi.getRegionDetails(id, region.external).catch((error)=>{
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error,
                operation: 'fetch region details'
            }));
            return {
                videoScale: {
                    currentReplicas: 'N/A'
                },
                thumbScale: {
                    currentReplicas: 'N/A'
                }
            };
        });
        return {
            region,
            ...details
        };
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch region'
        }));
        throw err;
    }
});
const updateRegion = (0, _toolkit.createAsyncThunk)('regions/updateRegion', async (params, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        if (params.videoScaleCount !== undefined) await api.regionApi.setVideoScale(params.regionId, params.videoScaleCount);
        if (params.thumbScaleCount !== undefined) await api.regionApi.setThumbScale(params.regionId, params.thumbScaleCount);
        navigate()(routes.regions());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Updated region: ${params.regionName}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update region'
        }));
        throw err;
    }
});
const setDefaultRegion = (0, _toolkit.createAsyncThunk)('regions/setDefaultRegion', async (params, { dispatch, extra: { api } })=>{
    try {
        const res = await api.regionApi.setDefaultRegion(params.regionId);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Updated default region: ${params.regionName}`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update default region'
        }));
        throw err;
    }
});
const deleteRegion = (0, _toolkit.createAsyncThunk)('regions/deleteRegion', async (region, { dispatch, extra: { api } })=>{
    try {
        await api.regionApi.deleteRegion(region.id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Deleted region: ${region.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'delete region'
        }));
        throw err;
    }
});
const clearRegions = (0, _toolkit.createAction)('regions/clearRegions');
const clearRegion = (0, _toolkit.createAction)('kubernetes/clearRegion');

},{"@reduxjs/toolkit":"8ces8","../../utils/index":"342UB","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRUIy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIpMapping", ()=>createIpMapping);
parcelHelpers.export(exports, "updateIpMapping", ()=>updateIpMapping);
parcelHelpers.export(exports, "getIpMappings", ()=>getIpMappings);
parcelHelpers.export(exports, "getIpMapping", ()=>getIpMapping);
parcelHelpers.export(exports, "removeIpMapping", ()=>removeIpMapping);
parcelHelpers.export(exports, "writeModelFromReadModel", ()=>writeModelFromReadModel);
parcelHelpers.export(exports, "clearIpMappings", ()=>clearIpMappings);
parcelHelpers.export(exports, "clearEditMapping", ()=>clearEditMapping);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
const prefix = 'addressMapping';
const createIpMapping = (0, _toolkit.createAsyncThunk)(`${prefix}/createIpMapping`, async (ipMapping, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        await api.addressMappingsApi.setIpMapping(ipMapping);
        navigate()(routes.addressMappings());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Created ip mapping for ${ipMapping.privateIp}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'create ip mapping'
        }));
        throw err;
    }
});
const updateIpMapping = (0, _toolkit.createAsyncThunk)(`${prefix}/updateIpMapping`, async (ipMapping, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        await api.addressMappingsApi.updateIpMapping(ipMapping);
        navigate()(routes.addressMappings());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Update ip mapping for ${ipMapping.privateIp}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update ip mapping'
        }));
        throw err;
    }
});
const getIpMappings = (0, _toolkit.createAsyncThunk)(`${prefix}/getIpMappings`, async (params, { extra: { api } })=>{
    return await api.addressMappingsApi.getIpMappings((0, _utils.withDefaultPagination)(params));
});
const getIpMapping = (0, _toolkit.createAsyncThunk)(`${prefix}/getIpMapping`, async (key, { extra: { api } })=>{
    return await api.addressMappingsApi.getIpMapping(key);
});
const removeIpMapping = (0, _toolkit.createAsyncThunk)(`${prefix}/removeIpMapping`, async (ipMapping, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.addressMappingsApi.removeIpMapping(ipMapping);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Removed ip mapping: ${ipMapping.privateIp}`));
        navigate()(routes.addressMappings());
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'remove ip mapping'
        }));
        throw err;
    }
});
function writeModelFromReadModel(ipMapping) {
    const { internalIp, interRegionIp, privateIp, publicIp, region } = ipMapping;
    return {
        internalIp,
        interRegionIp,
        privateIp,
        publicIp,
        region: typeof region === 'string' ? region : region.id
    };
}
const clearIpMappings = (0, _toolkit.createAction)(`${prefix}/clearIpMappings`);
const clearEditMapping = (0, _toolkit.createAction)(`${prefix}/clearEditMapping`);

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2PZQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readAlarmsInBackground", ()=>readAlarmsInBackground);
parcelHelpers.export(exports, "getAlarms", ()=>getAlarms);
parcelHelpers.export(exports, "clearAlarm", ()=>clearAlarm);
parcelHelpers.export(exports, "clearAlarms", ()=>clearAlarms);
parcelHelpers.export(exports, "initAlarms", ()=>initAlarms);
parcelHelpers.export(exports, "setCriticalAlarmsAmount", ()=>setCriticalAlarmsAmount);
var _toolkit = require("@reduxjs/toolkit");
var _util = require("common/util");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
var _types = require("common/api/v1/types");
const getIsCritical = (alarms)=>alarms.length > 200;
let isInitial = true;
const readAlarmsInBackground = (0, _toolkit.createAsyncThunk)('alarms/readAlarms', async ({ silent }, { dispatch, getState, extra: { api } })=>{
    try {
        const { items: activeAlarms, total } = await api.alarmsApi.readAlarmsInBackground();
        {
            const actions = [];
            const isCritical = getIsCritical(activeAlarms);
            if (isCritical) actions.push(setCriticalAlarmsAmount(true));
            else if (!isInitial) {
                const { items: previousAlarms } = getState().alarmsReducer.alarmsForNotifications;
                let alarm = null;
                let amount = 0;
                activeAlarms.some((item)=>{
                    if (!previousAlarms.find(({ alarmId })=>alarmId === item.alarmId)) {
                        const severity = item.alarmSeverity;
                        if (severity !== (0, _types.VaAlarmOwnSeverityLevels).cleared) {
                            if (amount) {
                                alarm = {
                                    message: 'You have new active alarms'
                                };
                                return true;
                            } else {
                                amount++;
                                alarm = {
                                    message: `ALARM: ${item.alarmCause}`,
                                    severity
                                };
                            }
                        }
                    }
                });
                if (alarm && userHasAlarmNotificationEnabled(getState().userReducer.user)) actions.push((0, _notificationActions.enqueueAlarmSnackbar)(alarm));
                if (getState().alarmsReducer.isCriticalAmount) actions.push(setCriticalAlarmsAmount(false));
            }
            if (isInitial) isInitial = false;
            actions.forEach((action)=>dispatch(action));
            return {
                items: activeAlarms,
                total
            };
        }
    } catch (err) {
        if (!silent) dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch alarms'
        }));
        throw err;
    }
});
const getAlarms = (0, _toolkit.createAsyncThunk)('alarms/getAlarms', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.alarmsApi.getAlarms((0, _utils.withDefaultPagination)({
            ...params,
            rowsPerPage: '200'
        }));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch alarms'
        }));
        throw err;
    }
});
const clearAlarm = (0, _toolkit.createAsyncThunk)('alarms/clearAlarm', async (params, { dispatch, extra: { api } })=>{
    try {
        await api.alarmsApi.updateAlarm(params.alarmId, {
            status: 'CLEAR'
        });
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('1 alarm cleared'));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'clear alarm'
        }));
        throw err;
    }
});
const clearAlarms = (0, _toolkit.createAction)('alarms/clearAlarms');
let isPollingForAlarms = false;
const initAlarms = (0, _toolkit.createAsyncThunk)('alarms/initAlarms', async (_, { dispatch, getState, extra: { routes } })=>{
    if (isPollingForAlarms) return;
    isPollingForAlarms = true;
    while(true){
        await (0, _util.sleep)(10000);
        if (!(0, _utils.getIsStreamManager)((0, _utils.getCurrentPage)(), routes) && !!getState().userReducer.user.id && !getState().userReducer.changingUser) await dispatch(readAlarmsInBackground({
            silent: true
        }));
    }
});
const setCriticalAlarmsAmount = (0, _toolkit.createAsyncThunk)('alarms/setCriticalAlarmsAmount', async (isCritical, { dispatch, getState })=>{
    if (isCritical && userHasAlarmNotificationEnabled(getState().userReducer.user)) dispatch((0, _notificationActions.enqueueAlarmSnackbar)({
        message: 'Too many alarms present!'
    }));
});
function userHasAlarmNotificationEnabled(persistedUser) {
    // Defensive (paranoid?) programming required since the user can tamper with the local storage
    return persistedUser && typeof persistedUser === 'object' && 'settings' in persistedUser && persistedUser.settings && typeof persistedUser.settings === 'object' && 'alarm' in persistedUser.settings && persistedUser.settings.alarm && typeof persistedUser.settings.alarm === 'object' && 'notificationsEnabled' in persistedUser.settings.alarm ? Boolean(persistedUser.settings.alarm.notificationsEnabled) : true;
}

},{"@reduxjs/toolkit":"8ces8","common/util":"jV4UZ","./notificationActions":"7LkQg","../../utils":"342UB","common/api/v1/types":"3qemx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lYa8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getKubernetesNodes", ()=>getKubernetesNodes);
parcelHelpers.export(exports, "getKubernetesNode", ()=>getKubernetesNode);
parcelHelpers.export(exports, "updateKubernetesNode", ()=>updateKubernetesNode);
parcelHelpers.export(exports, "getResourceUsage", ()=>getResourceUsage);
parcelHelpers.export(exports, "clearKubernetesNode", ()=>clearKubernetesNode);
parcelHelpers.export(exports, "clearKubernetesNodes", ()=>clearKubernetesNodes);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
const getKubernetesNodes = (0, _toolkit.createAsyncThunk)('kubernetes/getNodes', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.kubernetesApi.getKubernetesNodes((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch nodes'
        }));
        throw err;
    }
});
const getKubernetesNode = (0, _toolkit.createAsyncThunk)('kubernetes/getNode', async ({ regionId, name }, { dispatch, extra: { api } })=>{
    try {
        return await api.kubernetesApi.getKubernetesNode(regionId, name);
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch node'
        }));
        throw err;
    }
});
const updateKubernetesNode = (0, _toolkit.createAsyncThunk)('kubernetes/updateNode', async (update, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const updatedNode = await api.kubernetesApi.updateKubernetesNode(update.regionId, update.name, update);
        navigate()(routes.kubernetesNodes());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Updated Node: ${update.name}`));
        return updatedNode;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update node'
        }));
        throw err;
    }
});
const getResourceUsage = (0, _toolkit.createAsyncThunk)('kubernetes/getResourceUsage', async (_, { extra: { api } })=>{
    return api.kubernetesApi.getResourceUsage();
});
const clearKubernetesNode = (0, _toolkit.createAction)('kubernetes/clearNode');
const clearKubernetesNodes = (0, _toolkit.createAction)('kubernetes/clearNodes');

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gfZop":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNetwork", ()=>createNetwork);
parcelHelpers.export(exports, "removeNetwork", ()=>removeNetwork);
parcelHelpers.export(exports, "updateNetwork", ()=>updateNetwork);
parcelHelpers.export(exports, "getNetworks", ()=>getNetworks);
parcelHelpers.export(exports, "getNetwork", ()=>getNetwork);
parcelHelpers.export(exports, "clearNetwork", ()=>clearNetwork);
parcelHelpers.export(exports, "clearNetworks", ()=>clearNetworks);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
var _applicationException = require("../../api/ApplicationException");
const createNetwork = (0, _toolkit.createAsyncThunk)('networks/createNetwork', async (network, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        await api.networksApi.createNetwork(network);
        navigate()(routes.networks());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Created Network ${network.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'create network'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const removeNetwork = (0, _toolkit.createAsyncThunk)('networks/removeNetwork', async (id, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.networksApi.removeNetwork(id);
        navigate()(routes.networks());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Removed Network: ${res.name}`));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'delete network'
        }));
        throw err;
    }
});
const updateNetwork = (0, _toolkit.createAsyncThunk)('networks/updateNetwork', async (network, { dispatch, rejectWithValue, extra: { routes, api, navigate } })=>{
    try {
        await api.networksApi.updateNetwork(network.id, {
            name: network.name,
            enabled: network.enabled
        });
        navigate()(routes.networks());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Updated Network: ${network.name}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update network'
        }));
        if (err instanceof (0, _applicationException.ApplicationException)) return rejectWithValue(err.errorInfo);
        throw err;
    }
});
const getNetworks = (0, _toolkit.createAsyncThunk)('networks/getNetworks', async (params, { extra: { api } })=>{
    return await api.networksApi.getNetworks((0, _utils.withDefaultPagination)(params));
});
const getNetwork = (0, _toolkit.createAsyncThunk)('networks/getNetwork', async (id, { extra: { api } })=>{
    return await api.networksApi.getNetwork(id);
});
const clearNetwork = (0, _toolkit.createAction)('networks/clearNetwork');
const clearNetworks = (0, _toolkit.createAction)('networks/clearNetworks');

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","../../api/ApplicationException":"5oMBs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RBnR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSettings", ()=>getSettings);
parcelHelpers.export(exports, "getSettingsAsync", ()=>getSettingsAsync);
parcelHelpers.export(exports, "saveSettings", ()=>saveSettings);
parcelHelpers.export(exports, "createBackup", ()=>createBackup);
parcelHelpers.export(exports, "setImage", ()=>setImage);
parcelHelpers.export(exports, "setImageToDelete", ()=>setImageToDelete);
parcelHelpers.export(exports, "saveImages", ()=>saveImages);
parcelHelpers.export(exports, "saveTls", ()=>saveTls);
parcelHelpers.export(exports, "setDevMode", ()=>setDevMode);
var _toolkit = require("@reduxjs/toolkit");
var _types = require("common/api/v1/types");
var _notificationActions = require("./notificationActions");
const getSettings = (0, _toolkit.createAsyncThunk)('settings/getSettings', async (_, { extra: { api } })=>{
    const [settings, tls] = await Promise.all([
        api.settingsApi.getSettings(),
        api.tlsApi.getTls()
    ]);
    return {
        settings,
        tls
    };
});
const getSettingsAsync = async ({ dispatch, settingsApi })=>{
    try {
        return await settingsApi.getSettings();
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch settings'
        }));
        throw err;
    }
};
const saveSettings = (0, _toolkit.createAsyncThunk)('settings/saveSettings', async (payload, { dispatch, extra: { api } })=>{
    try {
        const res = await api.settingsApi.saveSettings(payload);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Global settings updated'));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update global settings'
        }));
        throw err;
    }
});
const createBackup = (0, _toolkit.createAsyncThunk)('settings/createBackup', async (payload, { dispatch, extra: { api } })=>{
    try {
        await api.settingsApi.createBackupAsync(payload);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`${payload.type} backup job created`));
        return;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: `create ${payload.type} backup`
        }));
        throw error;
    }
});
const setImage = (0, _toolkit.createAction)('settings/setImage');
const setImageToDelete = (0, _toolkit.createAction)('settings/setImageToDelete');
const saveImages = (0, _toolkit.createAsyncThunk)('settings/saveImages', async ({ snackbar }, { dispatch, getState, extra: { api } })=>{
    try {
        const { serviceProvider, product, favicon, toDelete } = getState().settingsReducer;
        const requests = [];
        if (serviceProvider) requests.push(api.imageApi.setImage({
            name: (0, _types.ImageName).serviceProvider,
            image: serviceProvider.base64
        }));
        if (product) requests.push(api.imageApi.setImage({
            name: (0, _types.ImageName).product,
            image: product.base64
        }));
        if (favicon) requests.push(api.imageApi.setImage({
            name: (0, _types.ImageName).favicon,
            image: favicon.base64
        }));
        if (toDelete[(0, _types.ImageName).serviceProvider]) requests.push(api.imageApi.deleteImage((0, _types.ImageName).serviceProvider));
        if (toDelete[(0, _types.ImageName).product]) requests.push(api.imageApi.deleteImage((0, _types.ImageName).product));
        if (toDelete[(0, _types.ImageName).favicon]) requests.push(api.imageApi.deleteImage((0, _types.ImageName).favicon));
        await Promise.all(requests);
        if (snackbar) dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Images saved successfully'));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update image'
        }));
        throw err;
    }
});
const saveTls = (0, _toolkit.createAsyncThunk)('settings/saveTls', async (payload, { dispatch, extra: { api } })=>{
    try {
        const res = await api.tlsApi.saveTls(payload);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('TLS certificate saved successfully'));
        return res;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update tls settings'
        }));
        throw err;
    }
});
const setDevMode = (0, _toolkit.createAction)('settings/devMode', (enabled)=>{
    if (enabled) localStorage.setItem('dev-mode', 'enabled');
    else localStorage.removeItem('dev-mode');
    return {
        payload: enabled
    };
});

},{"@reduxjs/toolkit":"8ces8","common/api/v1/types":"3qemx","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6CX5c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readUsage", ()=>readUsage);
var _toolkit = require("@reduxjs/toolkit");
var _utils = require("../../utils");
var _notificationActions = require("./notificationActions");
const readUsage = (0, _toolkit.createAsyncThunk)('usage/readUsage', async ({ startDate, endDate, ...params }, { dispatch, extra: { api } })=>{
    try {
        return await api.usageApi.readUsage({
            startDate,
            endDate,
            ...(0, _utils.withDefaultPagination)(params)
        });
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch usage'
        }));
        throw err;
    }
});

},{"@reduxjs/toolkit":"8ces8","../../utils":"342UB","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3D6Y9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAsync", ()=>useAsync);
parcelHelpers.export(exports, "useAsyncAbortable", ()=>useAsyncAbortable);
parcelHelpers.export(exports, "useAsyncCallback", ()=>useAsyncCallback);
var _react = require("react");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// A type of promise-like that resolves synchronously and supports only one observer
const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";
// Asynchronously await a promise and pass the result to a finally continuation
function _finallyRethrows(body, finalizer) {
    try {
        var result = body();
    } catch (e) {
        return finalizer(true, e);
    }
    if (result && result.then) return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
    return finalizer(false, value);
}
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect); // Assign current value to a ref and returns a stable getter to get the latest value.
// This way we are sure to always get latest value provided to hook and
// avoid weird issues due to closures capturing stale values...
// See https://github.com/facebook/react/issues/16956
// See https://overreacted.io/making-setinterval-declarative-with-react-hooks/
var useGetter = function useGetter(t) {
    var ref = (0, _react.useRef)(t);
    useIsomorphicLayoutEffect(function() {
        ref.current = t;
    });
    return (0, _react.useCallback)(function() {
        return ref.current;
    }, [
        ref
    ]);
};
var InitialAsyncState = {
    status: 'not-requested',
    loading: false,
    result: undefined,
    error: undefined
};
var InitialAsyncLoadingState = {
    status: 'loading',
    loading: true,
    result: undefined,
    error: undefined
};
var defaultSetLoading = function defaultSetLoading(_asyncState) {
    return InitialAsyncLoadingState;
};
var defaultSetResult = function defaultSetResult(result, _asyncState) {
    return {
        status: 'success',
        loading: false,
        result: result,
        error: undefined
    };
};
var defaultSetError = function defaultSetError(error, _asyncState) {
    return {
        status: 'error',
        loading: false,
        result: undefined,
        error: error
    };
};
var noop = function noop() {};
var DefaultOptions = {
    initialState: function initialState(options) {
        return options && options.executeOnMount ? InitialAsyncLoadingState : InitialAsyncState;
    },
    executeOnMount: true,
    executeOnUpdate: true,
    setLoading: defaultSetLoading,
    setResult: defaultSetResult,
    setError: defaultSetError,
    onSuccess: noop,
    onError: noop
};
var normalizeOptions = function normalizeOptions(options) {
    return _extends({}, DefaultOptions, {}, options);
};
var useAsyncState = function useAsyncState(options) {
    var _useState = (0, _react.useState)(function() {
        return options.initialState(options);
    }), value1 = _useState[0], setValue = _useState[1];
    var reset = (0, _react.useCallback)(function() {
        return setValue(options.initialState(options));
    }, [
        setValue,
        options
    ]);
    var setLoading = (0, _react.useCallback)(function() {
        return setValue(options.setLoading(value1));
    }, [
        value1,
        setValue
    ]);
    var setResult = (0, _react.useCallback)(function(result) {
        return setValue(options.setResult(result, value1));
    }, [
        value1,
        setValue
    ]);
    var setError = (0, _react.useCallback)(function(error) {
        return setValue(options.setError(error, value1));
    }, [
        value1,
        setValue
    ]);
    var merge = (0, _react.useCallback)(function(state) {
        return setValue(_extends({}, value1, {}, state));
    }, [
        value1,
        setValue
    ]);
    return {
        value: value1,
        set: setValue,
        merge: merge,
        reset: reset,
        setLoading: setLoading,
        setResult: setResult,
        setError: setError
    };
};
var useIsMounted = function useIsMounted() {
    var ref = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        ref.current = true;
        return function() {
            ref.current = false;
        };
    }, []);
    return function() {
        return ref.current;
    };
};
var useCurrentPromise = function useCurrentPromise() {
    var ref = (0, _react.useRef)(null);
    return {
        set: function set(promise) {
            return ref.current = promise;
        },
        get: function get() {
            return ref.current;
        },
        is: function is(promise) {
            return ref.current === promise;
        }
    };
}; // Relaxed interface which accept both async and sync functions
// Accepting sync function is convenient for useAsyncCallback
var useAsyncInternal = function useAsyncInternal(asyncFunction, params, options) {
    // Fallback missing params, only for JS users forgetting the deps array, to prevent infinite loops
    // https://github.com/slorber/react-async-hook/issues/27
    // @ts-ignore
    !params && (params = []);
    var normalizedOptions = normalizeOptions(options);
    var _useState2 = (0, _react.useState)(null), currentParams = _useState2[0], setCurrentParams = _useState2[1];
    var AsyncState = useAsyncState(normalizedOptions);
    var isMounted = useIsMounted();
    var CurrentPromise = useCurrentPromise(); // We only want to handle the promise result/error
    // if it is the last operation and the comp is still mounted
    var shouldHandlePromise = function shouldHandlePromise(p) {
        return isMounted() && CurrentPromise.is(p);
    };
    var executeAsyncOperation = function executeAsyncOperation() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // async ensures errors thrown synchronously are caught (ie, bug when formatting api payloads)
        // async ensures promise-like and synchronous functions are handled correctly too
        // see https://github.com/slorber/react-async-hook/issues/24
        var promise = function() {
            try {
                return Promise.resolve(asyncFunction.apply(void 0, args));
            } catch (e) {
                return Promise.reject(e);
            }
        }();
        setCurrentParams(args);
        CurrentPromise.set(promise);
        AsyncState.setLoading();
        promise.then(function(result) {
            if (shouldHandlePromise(promise)) AsyncState.setResult(result);
            normalizedOptions.onSuccess(result, {
                isCurrent: function isCurrent() {
                    return CurrentPromise.is(promise);
                }
            });
        }, function(error) {
            if (shouldHandlePromise(promise)) AsyncState.setError(error);
            normalizedOptions.onError(error, {
                isCurrent: function isCurrent() {
                    return CurrentPromise.is(promise);
                }
            });
        });
        return promise;
    };
    var getLatestExecuteAsyncOperation = useGetter(executeAsyncOperation);
    var executeAsyncOperationMemo = (0, _react.useCallback)(function() {
        return getLatestExecuteAsyncOperation().apply(void 0, arguments);
    }, [
        getLatestExecuteAsyncOperation
    ]); // Keep this outside useEffect, because inside isMounted()
    // will be true as the component is already mounted when it's run
    var isMounting = !isMounted();
    (0, _react.useEffect)(function() {
        var execute = function execute() {
            return getLatestExecuteAsyncOperation().apply(void 0, params);
        };
        isMounting && normalizedOptions.executeOnMount && execute();
        !isMounting && normalizedOptions.executeOnUpdate && execute();
    }, params);
    return _extends({}, AsyncState.value, {
        set: AsyncState.set,
        merge: AsyncState.merge,
        reset: AsyncState.reset,
        execute: executeAsyncOperationMemo,
        currentPromise: CurrentPromise.get(),
        currentParams: currentParams
    });
};
function useAsync(asyncFunction, params, options) {
    return useAsyncInternal(asyncFunction, params, options);
}
var useAsyncAbortable = function useAsyncAbortable(asyncFunction, params, options) {
    var abortControllerRef = (0, _react.useRef)(); // Wrap the original async function and enhance it with abortion login
    var asyncFunctionWrapper = function asyncFunctionWrapper() {
        for(var _len2 = arguments.length, p = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)p[_key2] = arguments[_key2];
        try {
            // Cancel previous async call
            if (abortControllerRef.current) abortControllerRef.current.abort();
             // Create/store new abort controller for next async call
            var abortController = new AbortController();
            abortControllerRef.current = abortController;
            return Promise.resolve(_finallyRethrows(function() {
                // @ts-ignore // TODO how to type this?
                return Promise.resolve(asyncFunction.apply(void 0, [
                    abortController.signal
                ].concat(p)));
            }, function(_wasThrown, _result) {
                // Unset abortController ref if response is already there,
                // as it's not needed anymore to try to abort it (would it be no-op?)
                if (abortControllerRef.current === abortController) abortControllerRef.current = undefined;
                if (_wasThrown) throw _result;
                return _result;
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    return useAsync(asyncFunctionWrapper, params, options);
};
var useAsyncCallback = function useAsyncCallback(asyncFunction, options) {
    return useAsyncInternal(asyncFunction, // because async function is only executed manually
    [], _extends({}, options, {
        executeOnMount: false,
        executeOnUpdate: false
    }));
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gzqhz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listAdCreatives", ()=>listAdCreatives);
parcelHelpers.export(exports, "getAdCreative", ()=>getAdCreative);
parcelHelpers.export(exports, "createAdCreative", ()=>createAdCreative);
parcelHelpers.export(exports, "updateAdCreative", ()=>updateAdCreative);
parcelHelpers.export(exports, "deleteAdCreative", ()=>deleteAdCreative);
parcelHelpers.export(exports, "deleteAdCreatives", ()=>deleteAdCreatives);
parcelHelpers.export(exports, "createAdCreativeEvent", ()=>createAdCreativeEvent);
parcelHelpers.export(exports, "clearAdCreative", ()=>clearAdCreative);
parcelHelpers.export(exports, "clearAdCreatives", ()=>clearAdCreatives);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
const listAdCreatives = (0, _toolkit.createAsyncThunk)('adCreatives/listAdCreatives', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.adCreativesApi.listAdCreatives((0, _utils.withDefaultPagination)(params));
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'fetch Ad Creatives'
        }));
        throw error;
    }
});
const getAdCreative = (0, _toolkit.createAsyncThunk)('adCreatives/getAdCreative', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.adCreativesApi.getAdCreative(id);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'fetch Ad Creative'
        }));
        throw error;
    }
});
const createAdCreative = (0, _toolkit.createAsyncThunk)('adCreatives/createAdCreative', async (adCreativeInit, { dispatch, extra: { api } })=>{
    try {
        const res = await api.adCreativesApi.createAdCreative(adCreativeInit);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Creative created'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'create Ad Creative'
        }));
        throw error;
    }
});
const updateAdCreative = (0, _toolkit.createAsyncThunk)('adCreatives/updateAdCreative', async (adCreative, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.adCreativesApi.updateAdCreative(adCreative.id, adCreative);
        navigate()(routes.adCreatives());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Creative saved'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'update Ad Creative'
        }));
        throw error;
    }
});
const deleteAdCreative = (0, _toolkit.createAsyncThunk)('adCreatives/deleteAdCreative', async (id, { dispatch, extra: { api } })=>{
    try {
        const res = await api.adCreativesApi.deleteAdCreative(id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Creative deleted'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'delete Ad Creative'
        }));
        throw error;
    }
});
const deleteAdCreatives = (0, _toolkit.createAsyncThunk)('adCreatives/deleteAdCreatives', async (ids, { dispatch, extra: { api } })=>{
    try {
        for (const id of ids)await api.adCreativesApi.deleteAdCreative(id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Creative deleted'));
        return ids;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'delete Ad Creative'
        }));
        throw error;
    }
});
const createAdCreativeEvent = (0, _toolkit.createAsyncThunk)('adCreatives/createAdCreativeEvent', async (adCreativeEventInit, { dispatch, extra: { api } })=>{
    try {
        return await api.adCreativesApi.createAdCreativeEvent(adCreativeEventInit.id, adCreativeEventInit);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'create Ad Creative Event'
        }));
        throw error;
    }
});
const clearAdCreative = (0, _toolkit.createAction)('adCreatives/clearAdCreative');
const clearAdCreatives = (0, _toolkit.createAction)('adCreatives/clearAdCreatives');

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2olSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listAdPods", ()=>listAdPods);
parcelHelpers.export(exports, "getAdPod", ()=>getAdPod);
parcelHelpers.export(exports, "createAdPod", ()=>createAdPod);
parcelHelpers.export(exports, "updateAdPod", ()=>updateAdPod);
parcelHelpers.export(exports, "deleteAdPod", ()=>deleteAdPod);
parcelHelpers.export(exports, "deleteAdPods", ()=>deleteAdPods);
parcelHelpers.export(exports, "clearAdPod", ()=>clearAdPod);
parcelHelpers.export(exports, "clearAdPods", ()=>clearAdPods);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
const listAdPods = (0, _toolkit.createAsyncThunk)('adPods/listAdPods', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.adPodsApi.listAdPods(params);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'fetch Ad Pods'
        }));
        throw error;
    }
});
const getAdPod = (0, _toolkit.createAsyncThunk)('adPods/getAdPod', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.adPodsApi.getAdPod(id);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'fetch Ad Pod'
        }));
        throw error;
    }
});
const createAdPod = (0, _toolkit.createAsyncThunk)('adPods/createAdPod', async (adPodInit, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.adPodsApi.createAdPod(adPodInit);
        navigate()(routes.adPods());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Pod created'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'create Ad Pod'
        }));
        throw error;
    }
});
const updateAdPod = (0, _toolkit.createAsyncThunk)('adPods/updateAdPod', async (adPod, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.adPodsApi.updateAdPod(adPod.id, adPod);
        navigate()(routes.adPods());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Pod saved'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'update Ad Pod'
        }));
        throw error;
    }
});
const deleteAdPod = (0, _toolkit.createAsyncThunk)('adPods/deleteAdPod', async (id, { dispatch, extra: { api } })=>{
    try {
        const res = await api.adPodsApi.deleteAdPod(id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Pod deleted'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'delete Ad Pod'
        }));
        throw error;
    }
});
const deleteAdPods = (0, _toolkit.createAsyncThunk)('adPods/deleteAdPods', async (ids, { dispatch, extra: { api } })=>{
    try {
        for (const id of ids)await api.adPodsApi.deleteAdPod(id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Pod deleted'));
        return ids;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'delete Ad Pod'
        }));
        throw error;
    }
});
const clearAdPod = (0, _toolkit.createAction)('adPods/clearAdPod');
const clearAdPods = (0, _toolkit.createAction)('adPods/clearAdPods');

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"baydX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listAdBreaks", ()=>listAdBreaks);
parcelHelpers.export(exports, "getAdBreak", ()=>getAdBreak);
parcelHelpers.export(exports, "deleteAdBreak", ()=>deleteAdBreak);
parcelHelpers.export(exports, "deleteAdBreaks", ()=>deleteAdBreaks);
parcelHelpers.export(exports, "clearAdBreak", ()=>clearAdBreak);
parcelHelpers.export(exports, "clearAdBreaks", ()=>clearAdBreaks);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
const listAdBreaks = (0, _toolkit.createAsyncThunk)('adBreaks/listAdBreaks', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.adBreaksApi.listAdBreaks(params);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'fetch Ad Breaks'
        }));
        throw error;
    }
});
const getAdBreak = (0, _toolkit.createAsyncThunk)('adBreaks/getAdBreak', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.adBreaksApi.getAdBreak(id);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'fetch Ad Break'
        }));
        throw error;
    }
});
const deleteAdBreak = (0, _toolkit.createAsyncThunk)('adBreaks/deleteAdBreak', async (id, { dispatch, extra: { api } })=>{
    try {
        const res = await api.adBreaksApi.deleteAdBreak(id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Break deleted'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'delete Ad Break'
        }));
        throw error;
    }
});
const deleteAdBreaks = (0, _toolkit.createAsyncThunk)('adBreaks/deleteAdBreaks', async (ids, { dispatch, extra: { api } })=>{
    try {
        for (const id of ids)await api.adBreaksApi.deleteAdBreak(id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Break deleted'));
        return ids;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'delete Ad Break'
        }));
        throw error;
    }
});
const clearAdBreak = (0, _toolkit.createAction)('adBreaks/clearAdBreak');
const clearAdBreaks = (0, _toolkit.createAction)('adBreaks/clearAdBreaks');

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAasQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validate", ()=>validate);
var _validateJs = require("validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _helpers = require("common/api/v1/helpers");
var _types = require("common/api/v1/types");
var _ports = require("common/ports");
var _addrv4 = require("common/addrv4");
var _utils = require("common/utils");
(0, _validateJsDefault.default).validators.username = (0, _helpers.validateUsername);
(0, _validateJsDefault.default).validators.pwd = (0, _helpers.validatePassword);
(0, _validateJsDefault.default).validators.presence.message = "Can't be blank";
/**
 * Validator to use instead of numericality
 */ (0, _validateJsDefault.default).validators.number = (value, constraints)=>{
    if (value === '') return;
    const err = (0, _validateJs.single)(value, {
        numericality: {
            ...constraints,
            noStrings: false
        }
    });
    return Array.isArray(err) ? err.join(', ') : err;
};
(0, _validateJsDefault.default).validators.integers = (input)=>{
    if (input === '') return;
    const values = Array.isArray(input) ? input : [
        input
    ];
    const errors = values.filter((v)=>!Number.isInteger(Number(v))).map((v)=>`${v} must be an integer`);
    if (errors.length > 0) return errors.join(', ');
};
(0, _validateJsDefault.default).validators.pid = (value)=>{
    if (value === '') return;
    const MIN = 32 // 1-31 are reserved
    ;
    const MAX = 8190 // 8191 (0x1FFF) is Null packets
    ;
    const RESERVED = [
        8187
    ] // 0x1FFB. See https://en.wikipedia.org/wiki/MPEG_transport_stream
    ;
    const err = (0, _validateJs.single)(value, {
        numericality: {
            greaterThanOrEqualTo: MIN,
            lessThanOrEqualTo: MAX,
            message: `Must be between ${MIN} - ${MAX}`
        },
        exclusion: {
            within: RESERVED,
            message: '%{value} is reserved'
        }
    });
    return Array.isArray(err) ? err.join(', ') : err;
};
/**
 * Validator to use for IP fields
 */ (0, _validateJsDefault.default).validators.ip = (value = '')=>{
    if (value === '') return;
    if (!value.match(/^(?:(?:^|\.)(?:2(?:5[0-5]|[0-4]\d)|1?\d?\d)){4}$/gm)) return 'Must be valid ipv4 address';
    return;
};
/**
 * Validator to use for multicast address fields
 */ (0, _validateJsDefault.default).validators.multicastAddress = (value = '')=>{
    if (value === '') return;
    const ipError = (0, _validateJsDefault.default).validators.ip(value);
    const firstPart = parseInt(value.split('.')[0], 10);
    if (ipError || !(224 <= firstPart && firstPart <= 239)) return 'Multicast address must be in range 224.0.0.0/4 (224.0.0.0 to 239.255.255.255)';
    return;
};
(0, _validateJsDefault.default).validators.ipv4CidrBlock = (inputValue = '')=>{
    if (inputValue === '') return;
    const cidrBlocks = Array.isArray(inputValue) ? inputValue : inputValue.split(',');
    for (const cidr of cidrBlocks){
        if (!cidr.match(/^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([0-9]|[1-2][0-9]|3[0-2]))$/)) return `${cidr} is not a valid CIDR block`;
    }
    const overlapping = (0, _addrv4.getOverlappingCidrBlocks)(cidrBlocks);
    if (overlapping) return `${overlapping.cidr2.toString()} overlaps with ${overlapping.cidr1.toString()}`;
    return;
};
/**
 * Validator to use for string fields
 */ (0, _validateJsDefault.default).validators.format = (value = '', constraints)=>{
    if (value === '') return;
    if (constraints.prefixes) {
        const match = constraints.prefixes.find((prefix)=>value.startsWith(prefix));
        if (!match) return `Must start with ${constraints.prefixes.join(' or ')}`;
    }
};
(0, _validateJsDefault.default).validators.urlWithoutSubpath = (value = '')=>{
    try {
        const { pathname } = new URL(value);
        if (pathname && pathname !== '/') return 'Must not contain subpath';
    } catch (e) {
        return 'Must be a valid URL';
    }
};
/**
 * Validator to use for IP/hostname fields
 */ (0, _validateJsDefault.default).validators.ipOrHostname = (value = '')=>{
    if (value === '') return;
    const validHostnamePattern = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/gm;
    const validIpPattern = /^(?:(?:^|\.)(?:2(?:5[0-5]|[0-4]\d)|1?\d?\d)){4}$/gm;
    if (!value.match(validIpPattern) && !value.match(validHostnamePattern)) return 'Must be valid ipv4 address or FQDN';
    return;
};
/**
 * Validator to use for port fields
 */ (0, _validateJsDefault.default).validators.port = (value = '', constraints)=>{
    if (value === '') return;
    if (!value?.toString().match(/^[0-9]+$/)) return 'Must be a valid port number';
    const MAX = 65535;
    const MIN = 1024;
    const even = constraints && constraints.even || void 0;
    const evenMessage = even ? 'an even number in the range ' : '';
    const err = (0, _validateJs.single)(value, {
        numericality: {
            greaterThanOrEqualTo: MIN,
            lessThanOrEqualTo: MAX,
            message: `Must be ${evenMessage}${MIN} - ${MAX}`,
            even
        }
    });
    const port = parseInt(value);
    const isInInternalRangeError = constraints.disallowInternal && constraints.isUdp && (0, _ports.UDP_TUNNEL_PORT_RANGE_START) <= port && port <= (0, _ports.UDP_TUNNEL_PORT_RANGE_END) ? `UDP ports ${0, _ports.UDP_TUNNEL_PORT_RANGE_START} to ${0, _ports.UDP_TUNNEL_PORT_RANGE_END} are reserved for internal use` : undefined;
    const errorMessage = Array.isArray(err) ? err.join(', ') : err;
    if (isInInternalRangeError) return isInInternalRangeError;
    const isInHandoverRangeError = constraints.disallowInternal && constraints.isUdp && (0, _ports.UDP_HANDOVER_PORT_RANGE_START) <= port && port <= (0, _ports.UDP_HANDOVER_PORT_RANGE_END) ? `UDP ports ${0, _ports.UDP_HANDOVER_PORT_RANGE_START} to ${0, _ports.UDP_HANDOVER_PORT_RANGE_END} are reserved for internal use` : undefined;
    if (isInHandoverRangeError) return isInHandoverRangeError;
    const isUsingReservedTcpPort = constraints.disallowInternal && !constraints.isUdp && port === (0, _ports.TCP_EDGE_CONTROL_HTTP_PORT);
    if (isUsingReservedTcpPort) return `TCP port ${0, _ports.TCP_EDGE_CONTROL_HTTP_PORT} is reserved for internal use`;
    return errorMessage;
};
/**
 * Validator to use for field's value length
 * @param value
 * @param constraints - {minimum: min length, tooShort: text for error, maximum: max length, tooLong: text for error}
 */ (0, _validateJsDefault.default).validators.len = (value = '', constraints)=>{
    if (value === '') return;
    if (constraints.minimum && value.length < constraints.minimum) return constraints.tooShort || `Must be at least ${constraints.minimum} characters long`;
    if (constraints.maximum && value.length > constraints.maximum) return constraints.tooLong || `Must be no more than ${constraints.maximum} characters long`;
    return;
};
/**
 * Validator to use for hexadecimal fields
 */ (0, _validateJsDefault.default).validators.hexadecimal = (value = '')=>{
    if (value === '') return;
    if (!value.match(/^[\d\sa-fA-F]+$/gm)) return 'Must be valid hexadecimal';
    return;
};
/**
 * Validator to use for alphanumeric fields
 */ (0, _validateJsDefault.default).validators.alphanumeric = (value = '')=>{
    if (value === '') return;
    if (!value.match((0, _helpers.REGEX_ALPHANUMERIC))) return 'Must be alphanumeric';
    return;
};
/**
 * Validator to use for alphanumeric fields
 */ (0, _validateJsDefault.default).validators.noAmpersand = (value = '')=>{
    if (value === '') return;
    if (value.includes('&')) return 'Must not contain ampersand (&)';
    return;
};
/**
 * Validator to verify that the received address is in the list of valid addresses,
 * e.g. used for validating that a selected address belongs to the selected interface
 * @param value - the value to check
 * @param addresses - a list of valid addresses
 */ (0, _validateJsDefault.default).validators.addressIn = (value = '', { addresses })=>{
    const validAddresses = (addresses || []).reduce((acc, address)=>{
        acc.add(address.address);
        address.publicAddress && acc.add(address.publicAddress);
        address.internalAddress && acc.add(address.internalAddress);
        address.interRegionPublicAddress && acc.add(address.interRegionPublicAddress);
        return acc;
    }, new Set());
    if (!validAddresses.has(value)) {
        const formattedValidAddresses = Array.from(validAddresses).map((address)=>`'${address || 'any'}'`).sort();
        return `Must be ${formattedValidAddresses.join(' or ')}`;
    }
};
(0, _validateJsDefault.default).validators.k8sMemoryString = (value = '', { min, max, message })=>{
    const parsed = (0, _utils.parseK8sMemoryString)(value);
    if (Number.isNaN(parsed)) return 'Invalid value. Supports suffixes like G, M, Gi and Mi';
    if (min !== undefined) {
        const parsedMin = (0, _utils.parseK8sMemoryString)(min);
        if (Number.isNaN(parsedMin)) return 'Invalid minimum value';
        if (parsed < parsedMin) return message || `Must be at least ${min}`;
    }
    if (max !== undefined) {
        const parsedMax = (0, _utils.parseK8sMemoryString)(max);
        if (Number.isNaN(parsedMax)) return 'Invalid maximum value';
        if (parsed > parsedMax) return message || `Must be at most ${max}`;
    }
};
(0, _validateJsDefault.default).validators.k8sName = (value = '')=>{
    if (!value) return;
    if (value.startsWith('-') || value.endsWith('-')) return 'Name cannot start or end with hyphen';
    if (!value.match(/^[a-z0-9-]+$/)) return 'Only lowercase letters, numbers and hyphens are allowed';
};
/**
 * Validator to verify that the received value is one of the set of valid values,
 * e.g. used for validating that a selected value belongs to a certain enum
 * @param value - the value to check
 * @param validValues - a set of valid values
 */ (0, _validateJsDefault.default).validators.oneOf = (value = '', { validValues })=>{
    if (validValues.size > 0 && !validValues.has(value)) {
        const prefix = `Must be ${validValues.size === 1 ? '' : 'one of:'}`;
        return `${prefix} ${Array.from(validValues).join(', ')}`;
    }
};
(0, _validateJsDefault.default).validators.notOneOf = (value = '', { invalidValues, errorMsg })=>{
    if (value && invalidValues.has(value)) return errorMsg;
};
(0, _validateJsDefault.default).validators.isPortAvailable = (value = '', portInfo)=>{
    if (portInfo.isMulticast) return;
    if (portInfo.isPortDisabled) return;
    const numericValue = Number(value);
    if (!value || !numericValue || isNaN(numericValue)) return;
    const isRtcp = portInfo.mode === (0, _types.IpPortMode).rist || portInfo.mode === (0, _types.IpPortMode).rtp && !!portInfo.isRtpRtcp;
    const requestedLocalPorts = portInfo.isInput ? (0, _ports.getLocalPortNumbersUsedByInputProtocol)({
        ...portInfo,
        localBasePort: numericValue,
        isFec: portInfo.isFec ?? false,
        isRtcp,
        isMulticast: portInfo.isMulticast ?? false
    }) : (0, _ports.getLocalPortNumbersUsedByOutputProtocol)({
        ...portInfo,
        localBasePort: numericValue
    });
    const isUDP = (0, _ports.isUdpBasedProtocol)(portInfo.mode);
    const potentiallyConflictingPorts = portInfo.existingLogicalPortsOnSameNic.filter((lp)=>!lp.isDisabled && (isUDP ? (0, _ports.isUdpBasedProtocol)(lp.portMode) : (0, _ports.isTcpBasedProtocol)(portInfo.mode)));
    for (const rp of requestedLocalPorts){
        const portOccupant = potentiallyConflictingPorts.find((o)=>o.localPortNumbers.includes(rp));
        if (portOccupant) return `${isUDP ? 'UDP' : 'TCP'} port ${rp} on the selected interface is already in use by a ${portOccupant.portMode.toUpperCase()}-${portOccupant.inputId ? 'input' : portOccupant.outputId ? 'output' : 'service'}, but required by the selected protocol.`;
    }
};
(0, _validateJsDefault.default).validators.urlNoSubpath = (value = '')=>{
    if (value === '') return;
    if (value.includes('/')) return 'Must not contain subpath';
};
const validate = (constraints)=>(value)=>{
        if (typeof value === 'string' && value.match(/(^\s|\s$)/)) return 'Leading and trailing spaces are not allowed.';
        const err = (0, _validateJs.single)(value, {
            ...constraints,
            presence: constraints.presence ? {
                ...constraints.presence,
                allowEmpty: false
            } : undefined,
            numericality: constraints.numericality ? {
                ...constraints.numericality,
                notValid: ' '
            } : undefined
        });
        return Array.isArray(err) ? err.join(', ') : err;
    };

},{"validate.js":"emzWS","common/api/v1/helpers":"6jovr","common/api/v1/types":"3qemx","common/ports":"5XehL","common/addrv4":"dUez3","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"emzWS":[function(require,module,exports,__globalThis) {
/*!
 * validate.js 0.13.1
 *
 * (c) 2013-2019 Nicklas Ansman, 2013 Wrapp
 * Validate.js may be freely distributed under the MIT license.
 * For all details and documentation:
 * http://validatejs.org/
 */ (function(exports1, module1, define1) {
    "use strict";
    // The main function that calls the validators specified by the constraints.
    // The options are the following:
    //   - format (string) - An option that controls how the returned value is formatted
    //     * flat - Returns a flat array of just the error messages
    //     * grouped - Returns the messages grouped by attribute (default)
    //     * detailed - Returns an array of the raw validation data
    //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
    //
    // Please note that the options are also passed to each validator.
    var validate = function(attributes, constraints, options) {
        options = v.extend({}, v.options, options);
        var results = v.runValidations(attributes, constraints, options), attr, validator;
        if (results.some(function(r) {
            return v.isPromise(r.error);
        })) throw new Error("Use validate.async if you want support for promises");
        return validate.processValidationResults(results, options);
    };
    var v = validate;
    // Copies over attributes from one or more sources to a single destination.
    // Very much similar to underscore's extend.
    // The first argument is the target object and the remaining arguments will be
    // used as sources.
    v.extend = function(obj) {
        [].slice.call(arguments, 1).forEach(function(source) {
            for(var attr in source)obj[attr] = source[attr];
        });
        return obj;
    };
    v.extend(validate, {
        // This is the version of the library as a semver.
        // The toString function will allow it to be coerced into a string
        version: {
            major: 0,
            minor: 13,
            patch: 1,
            metadata: null,
            toString: function() {
                var version = v.format("%{major}.%{minor}.%{patch}", v.version);
                if (!v.isEmpty(v.version.metadata)) version += "+" + v.version.metadata;
                return version;
            }
        },
        // Below is the dependencies that are used in validate.js
        // The constructor of the Promise implementation.
        // If you are using Q.js, RSVP or any other A+ compatible implementation
        // override this attribute to be the constructor of that promise.
        // Since jQuery promises aren't A+ compatible they won't work.
        Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,
        EMPTY_STRING_REGEXP: /^\s*$/,
        // Runs the validators specified by the constraints object.
        // Will return an array of the format:
        //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
        runValidations: function(attributes, constraints, options) {
            var results = [], attr, validatorName, value, validators, validator, validatorOptions, error;
            if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) attributes = v.collectFormValues(attributes);
            // Loops through each constraints, finds the correct validator and run it.
            for(attr in constraints){
                value = v.getDeepObjectValue(attributes, attr);
                // This allows the constraints for an attribute to be a function.
                // The function will be called with the value, attribute name, the complete dict of
                // attributes as well as the options and constraints passed in.
                // This is useful when you want to have different
                // validations depending on the attribute value.
                validators = v.result(constraints[attr], value, attributes, attr, options, constraints);
                for(validatorName in validators){
                    validator = v.validators[validatorName];
                    if (!validator) {
                        error = v.format("Unknown validator %{name}", {
                            name: validatorName
                        });
                        throw new Error(error);
                    }
                    validatorOptions = validators[validatorName];
                    // This allows the options to be a function. The function will be
                    // called with the value, attribute name, the complete dict of
                    // attributes as well as the options and constraints passed in.
                    // This is useful when you want to have different
                    // validations depending on the attribute value.
                    validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
                    if (!validatorOptions) continue;
                    results.push({
                        attribute: attr,
                        value: value,
                        validator: validatorName,
                        globalOptions: options,
                        attributes: attributes,
                        options: validatorOptions,
                        error: validator.call(validator, value, validatorOptions, attr, attributes, options)
                    });
                }
            }
            return results;
        },
        // Takes the output from runValidations and converts it to the correct
        // output format.
        processValidationResults: function(errors, options) {
            errors = v.pruneEmptyErrors(errors, options);
            errors = v.expandMultipleErrors(errors, options);
            errors = v.convertErrorMessages(errors, options);
            var format = options.format || "grouped";
            if (typeof v.formatters[format] === 'function') errors = v.formatters[format](errors);
            else throw new Error(v.format("Unknown format %{format}", options));
            return v.isEmpty(errors) ? undefined : errors;
        },
        // Runs the validations with support for promises.
        // This function will return a promise that is settled when all the
        // validation promises have been completed.
        // It can be called even if no validations returned a promise.
        async: function(attributes, constraints, options) {
            options = v.extend({}, v.async.options, options);
            var WrapErrors = options.wrapErrors || function(errors) {
                return errors;
            };
            // Removes unknown attributes
            if (options.cleanAttributes !== false) attributes = v.cleanAttributes(attributes, constraints);
            var results = v.runValidations(attributes, constraints, options);
            return new v.Promise(function(resolve, reject) {
                v.waitForResults(results).then(function() {
                    var errors = v.processValidationResults(results, options);
                    if (errors) reject(new WrapErrors(errors, options, attributes, constraints));
                    else resolve(attributes);
                }, function(err) {
                    reject(err);
                });
            });
        },
        single: function(value, constraints, options) {
            options = v.extend({}, v.single.options, options, {
                format: "flat",
                fullMessages: false
            });
            return v({
                single: value
            }, {
                single: constraints
            }, options);
        },
        // Returns a promise that is resolved when all promises in the results array
        // are settled. The promise returned from this function is always resolved,
        // never rejected.
        // This function modifies the input argument, it replaces the promises
        // with the value returned from the promise.
        waitForResults: function(results) {
            // Create a sequence of all the results starting with a resolved promise.
            return results.reduce(function(memo, result) {
                // If this result isn't a promise skip it in the sequence.
                if (!v.isPromise(result.error)) return memo;
                return memo.then(function() {
                    return result.error.then(function(error) {
                        result.error = error || null;
                    });
                });
            }, new v.Promise(function(r) {
                r();
            })); // A resolved promise
        },
        // If the given argument is a call: function the and: function return the value
        // otherwise just return the value. Additional arguments will be passed as
        // arguments to the function.
        // Example:
        // ```
        // result('foo') // 'foo'
        // result(Math.max, 1, 2) // 2
        // ```
        result: function(value) {
            var args = [].slice.call(arguments, 1);
            if (typeof value === 'function') value = value.apply(null, args);
            return value;
        },
        // Checks if the value is a number. This function does not consider NaN a
        // number like many other `isNumber` functions do.
        isNumber: function(value) {
            return typeof value === 'number' && !isNaN(value);
        },
        // Returns false if the object is not a function
        isFunction: function(value) {
            return typeof value === 'function';
        },
        // A simple check to verify that the value is an integer. Uses `isNumber`
        // and a simple modulo check.
        isInteger: function(value) {
            return v.isNumber(value) && value % 1 === 0;
        },
        // Checks if the value is a boolean
        isBoolean: function(value) {
            return typeof value === 'boolean';
        },
        // Uses the `Object` function to check if the given argument is an object.
        isObject: function(obj) {
            return obj === Object(obj);
        },
        // Simply checks if the object is an instance of a date
        isDate: function(obj) {
            return obj instanceof Date;
        },
        // Returns false if the object is `null` of `undefined`
        isDefined: function(obj) {
            return obj !== null && obj !== undefined;
        },
        // Checks if the given argument is a promise. Anything with a `then`
        // function is considered a promise.
        isPromise: function(p) {
            return !!p && v.isFunction(p.then);
        },
        isJqueryElement: function(o) {
            return o && v.isString(o.jquery);
        },
        isDomElement: function(o) {
            if (!o) return false;
            if (!o.querySelectorAll || !o.querySelector) return false;
            if (v.isObject(document) && o === document) return true;
            // http://stackoverflow.com/a/384380/699304
            /* istanbul ignore else */ if (typeof HTMLElement === "object") return o instanceof HTMLElement;
            else return o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
        },
        isEmpty: function(value) {
            var attr;
            // Null and undefined are empty
            if (!v.isDefined(value)) return true;
            // functions are non empty
            if (v.isFunction(value)) return false;
            // Whitespace only strings are empty
            if (v.isString(value)) return v.EMPTY_STRING_REGEXP.test(value);
            // For arrays we use the length property
            if (v.isArray(value)) return value.length === 0;
            // Dates have no attributes but aren't empty
            if (v.isDate(value)) return false;
            // If we find at least one property we consider it non empty
            if (v.isObject(value)) {
                for(attr in value)return false;
                return true;
            }
            return false;
        },
        // Formats the specified strings with the given values like so:
        // ```
        // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
        // ```
        // If you want to write %{...} without having it replaced simply
        // prefix it with % like this `Foo: %%{foo}` and it will be returned
        // as `"Foo: %{foo}"`
        format: v.extend(function(str, vals) {
            if (!v.isString(str)) return str;
            return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
                if (m1 === '%') return "%{" + m2 + "}";
                else return String(vals[m2]);
            });
        }, {
            // Finds %{key} style patterns in the given string
            FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
        }),
        // "Prettifies" the given string.
        // Prettifying means replacing [.\_-] with spaces as well as splitting
        // camel case words.
        prettify: function(str) {
            if (v.isNumber(str)) {
                // If there are more than 2 decimals round it to two
                if (str * 100 % 1 === 0) return "" + str;
                else return parseFloat(Math.round(str * 100) / 100).toFixed(2);
            }
            if (v.isArray(str)) return str.map(function(s) {
                return v.prettify(s);
            }).join(", ");
            if (v.isObject(str)) {
                if (!v.isDefined(str.toString)) return JSON.stringify(str);
                return str.toString();
            }
            // Ensure the string is actually a string
            str = "" + str;
            return str// Splits keys separated by periods
            .replace(/([^\s])\.([^\s])/g, '$1 $2')// Removes backslashes
            .replace(/\\+/g, '')// Replaces - and - with space
            .replace(/[_-]/g, ' ')// Splits camel cased words
            .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
                return "" + m1 + " " + m2.toLowerCase();
            }).toLowerCase();
        },
        stringifyValue: function(value, options) {
            var prettify = options && options.prettify || v.prettify;
            return prettify(value);
        },
        isString: function(value) {
            return typeof value === 'string';
        },
        isArray: function(value) {
            return ({}).toString.call(value) === '[object Array]';
        },
        // Checks if the object is a hash, which is equivalent to an object that
        // is neither an array nor a function.
        isHash: function(value) {
            return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
        },
        contains: function(obj, value) {
            if (!v.isDefined(obj)) return false;
            if (v.isArray(obj)) return obj.indexOf(value) !== -1;
            return value in obj;
        },
        unique: function(array) {
            if (!v.isArray(array)) return array;
            return array.filter(function(el, index, array) {
                return array.indexOf(el) == index;
            });
        },
        forEachKeyInKeypath: function(object, keypath, callback) {
            if (!v.isString(keypath)) return undefined;
            var key = "", i, escape = false;
            for(i = 0; i < keypath.length; ++i)switch(keypath[i]){
                case '.':
                    if (escape) {
                        escape = false;
                        key += '.';
                    } else {
                        object = callback(object, key, false);
                        key = "";
                    }
                    break;
                case '\\':
                    if (escape) {
                        escape = false;
                        key += '\\';
                    } else escape = true;
                    break;
                default:
                    escape = false;
                    key += keypath[i];
                    break;
            }
            return callback(object, key, true);
        },
        getDeepObjectValue: function(obj, keypath) {
            if (!v.isObject(obj)) return undefined;
            return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
                if (v.isObject(obj)) return obj[key];
            });
        },
        // This returns an object with all the values of the form.
        // It uses the input name as key and the value as value
        // So for example this:
        // <input type="text" name="email" value="foo@bar.com" />
        // would return:
        // {email: "foo@bar.com"}
        collectFormValues: function(form, options) {
            var values = {}, i, j, input, inputs, option, value;
            if (v.isJqueryElement(form)) form = form[0];
            if (!form) return values;
            options = options || {};
            inputs = form.querySelectorAll("input[name], textarea[name]");
            for(i = 0; i < inputs.length; ++i){
                input = inputs.item(i);
                if (v.isDefined(input.getAttribute("data-ignored"))) continue;
                var name = input.name.replace(/\./g, "\\\\.");
                value = v.sanitizeFormValue(input.value, options);
                if (input.type === "number") value = value ? +value : null;
                else if (input.type === "checkbox") {
                    if (input.attributes.value) {
                        if (!input.checked) value = values[name] || null;
                    } else value = input.checked;
                } else if (input.type === "radio") {
                    if (!input.checked) value = values[name] || null;
                }
                values[name] = value;
            }
            inputs = form.querySelectorAll("select[name]");
            for(i = 0; i < inputs.length; ++i){
                input = inputs.item(i);
                if (v.isDefined(input.getAttribute("data-ignored"))) continue;
                if (input.multiple) {
                    value = [];
                    for(j in input.options){
                        option = input.options[j];
                        if (option && option.selected) value.push(v.sanitizeFormValue(option.value, options));
                    }
                } else {
                    var _val = typeof input.options[input.selectedIndex] !== 'undefined' ? input.options[input.selectedIndex].value : /* istanbul ignore next */ '';
                    value = v.sanitizeFormValue(_val, options);
                }
                values[input.name] = value;
            }
            return values;
        },
        sanitizeFormValue: function(value, options) {
            if (options.trim && v.isString(value)) value = value.trim();
            if (options.nullify !== false && value === "") return null;
            return value;
        },
        capitalize: function(str) {
            if (!v.isString(str)) return str;
            return str[0].toUpperCase() + str.slice(1);
        },
        // Remove all errors who's error attribute is empty (null or undefined)
        pruneEmptyErrors: function(errors) {
            return errors.filter(function(error) {
                return !v.isEmpty(error.error);
            });
        },
        // In
        // [{error: ["err1", "err2"], ...}]
        // Out
        // [{error: "err1", ...}, {error: "err2", ...}]
        //
        // All attributes in an error with multiple messages are duplicated
        // when expanding the errors.
        expandMultipleErrors: function(errors) {
            var ret = [];
            errors.forEach(function(error) {
                // Removes errors without a message
                if (v.isArray(error.error)) error.error.forEach(function(msg) {
                    ret.push(v.extend({}, error, {
                        error: msg
                    }));
                });
                else ret.push(error);
            });
            return ret;
        },
        // Converts the error mesages by prepending the attribute name unless the
        // message is prefixed by ^
        convertErrorMessages: function(errors, options) {
            options = options || {};
            var ret = [], prettify = options.prettify || v.prettify;
            errors.forEach(function(errorInfo) {
                var error = v.result(errorInfo.error, errorInfo.value, errorInfo.attribute, errorInfo.options, errorInfo.attributes, errorInfo.globalOptions);
                if (!v.isString(error)) {
                    ret.push(errorInfo);
                    return;
                }
                if (error[0] === '^') error = error.slice(1);
                else if (options.fullMessages !== false) error = v.capitalize(prettify(errorInfo.attribute)) + " " + error;
                error = error.replace(/\\\^/g, "^");
                error = v.format(error, {
                    value: v.stringifyValue(errorInfo.value, options)
                });
                ret.push(v.extend({}, errorInfo, {
                    error: error
                }));
            });
            return ret;
        },
        // In:
        // [{attribute: "<attributeName>", ...}]
        // Out:
        // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
        groupErrorsByAttribute: function(errors) {
            var ret = {};
            errors.forEach(function(error) {
                var list = ret[error.attribute];
                if (list) list.push(error);
                else ret[error.attribute] = [
                    error
                ];
            });
            return ret;
        },
        // In:
        // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
        // Out:
        // ["<message 1>", "<message 2>"]
        flattenErrorsToArray: function(errors) {
            return errors.map(function(error) {
                return error.error;
            }).filter(function(value, index, self) {
                return self.indexOf(value) === index;
            });
        },
        cleanAttributes: function(attributes, whitelist) {
            function whitelistCreator(obj, key, last) {
                if (v.isObject(obj[key])) return obj[key];
                return obj[key] = last ? true : {};
            }
            function buildObjectWhitelist(whitelist) {
                var ow = {}, lastObject, attr;
                for(attr in whitelist){
                    if (!whitelist[attr]) continue;
                    v.forEachKeyInKeypath(ow, attr, whitelistCreator);
                }
                return ow;
            }
            function cleanRecursive(attributes, whitelist) {
                if (!v.isObject(attributes)) return attributes;
                var ret = v.extend({}, attributes), w, attribute;
                for(attribute in attributes){
                    w = whitelist[attribute];
                    if (v.isObject(w)) ret[attribute] = cleanRecursive(ret[attribute], w);
                    else if (!w) delete ret[attribute];
                }
                return ret;
            }
            if (!v.isObject(whitelist) || !v.isObject(attributes)) return {};
            whitelist = buildObjectWhitelist(whitelist);
            return cleanRecursive(attributes, whitelist);
        },
        exposeModule: function(validate, root, exports1, module1, define1) {
            if (exports1) {
                if (module1 && module1.exports) exports1 = module1.exports = validate;
                exports1.validate = validate;
            } else {
                root.validate = validate;
                if (validate.isFunction(define1) && define1.amd) define1([], function() {
                    return validate;
                });
            }
        },
        warn: function(msg) {
            if (typeof console !== "undefined" && console.warn) console.warn("[validate.js] " + msg);
        },
        error: function(msg) {
            if (typeof console !== "undefined" && console.error) console.error("[validate.js] " + msg);
        }
    });
    validate.validators = {
        // Presence validates that the value isn't empty
        presence: function(value, options) {
            options = v.extend({}, this.options, options);
            if (options.allowEmpty !== false ? !v.isDefined(value) : v.isEmpty(value)) return options.message || this.message || "can't be blank";
        },
        length: function(value, options, attribute) {
            // Empty values are allowed
            if (!v.isDefined(value)) return;
            options = v.extend({}, this.options, options);
            var is = options.is, maximum = options.maximum, minimum = options.minimum, tokenizer = options.tokenizer || function(val) {
                return val;
            }, err, errors = [];
            value = tokenizer(value);
            var length = value.length;
            if (!v.isNumber(length)) return options.message || this.notValid || "has an incorrect length";
            // Is checks
            if (v.isNumber(is) && length !== is) {
                err = options.wrongLength || this.wrongLength || "is the wrong length (should be %{count} characters)";
                errors.push(v.format(err, {
                    count: is
                }));
            }
            if (v.isNumber(minimum) && length < minimum) {
                err = options.tooShort || this.tooShort || "is too short (minimum is %{count} characters)";
                errors.push(v.format(err, {
                    count: minimum
                }));
            }
            if (v.isNumber(maximum) && length > maximum) {
                err = options.tooLong || this.tooLong || "is too long (maximum is %{count} characters)";
                errors.push(v.format(err, {
                    count: maximum
                }));
            }
            if (errors.length > 0) return options.message || errors;
        },
        numericality: function(value, options, attribute, attributes, globalOptions) {
            // Empty values are fine
            if (!v.isDefined(value)) return;
            options = v.extend({}, this.options, options);
            var errors = [], name, count, checks = {
                greaterThan: function(v, c) {
                    return v > c;
                },
                greaterThanOrEqualTo: function(v, c) {
                    return v >= c;
                },
                equalTo: function(v, c) {
                    return v === c;
                },
                lessThan: function(v, c) {
                    return v < c;
                },
                lessThanOrEqualTo: function(v, c) {
                    return v <= c;
                },
                divisibleBy: function(v, c) {
                    return v % c === 0;
                }
            }, prettify = options.prettify || globalOptions && globalOptions.prettify || v.prettify;
            // Strict will check that it is a valid looking number
            if (v.isString(value) && options.strict) {
                var pattern = "^-?(0|[1-9]\\d*)";
                if (!options.onlyInteger) pattern += "(\\.\\d+)?";
                pattern += "$";
                if (!new RegExp(pattern).test(value)) return options.message || options.notValid || this.notValid || this.message || "must be a valid number";
            }
            // Coerce the value to a number unless we're being strict.
            if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) value = +value;
            // If it's not a number we shouldn't continue since it will compare it.
            if (!v.isNumber(value)) return options.message || options.notValid || this.notValid || this.message || "is not a number";
            // Same logic as above, sort of. Don't bother with comparisons if this
            // doesn't pass.
            if (options.onlyInteger && !v.isInteger(value)) return options.message || options.notInteger || this.notInteger || this.message || "must be an integer";
            for(name in checks){
                count = options[name];
                if (v.isNumber(count) && !checks[name](value, count)) {
                    // This picks the default message if specified
                    // For example the greaterThan check uses the message from
                    // this.notGreaterThan so we capitalize the name and prepend "not"
                    var key = "not" + v.capitalize(name);
                    var msg = options[key] || this[key] || this.message || "must be %{type} %{count}";
                    errors.push(v.format(msg, {
                        count: count,
                        type: prettify(name)
                    }));
                }
            }
            if (options.odd && value % 2 !== 1) errors.push(options.notOdd || this.notOdd || this.message || "must be odd");
            if (options.even && value % 2 !== 0) errors.push(options.notEven || this.notEven || this.message || "must be even");
            if (errors.length) return options.message || errors;
        },
        datetime: v.extend(function(value, options) {
            if (!v.isFunction(this.parse) || !v.isFunction(this.format)) throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
            // Empty values are fine
            if (!v.isDefined(value)) return;
            options = v.extend({}, this.options, options);
            var err, errors = [], earliest = options.earliest ? this.parse(options.earliest, options) : NaN, latest = options.latest ? this.parse(options.latest, options) : NaN;
            value = this.parse(value, options);
            // 86400000 is the number of milliseconds in a day, this is used to remove
            // the time from the date
            if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
                err = options.notValid || options.message || this.notValid || "must be a valid date";
                return v.format(err, {
                    value: arguments[0]
                });
            }
            if (!isNaN(earliest) && value < earliest) {
                err = options.tooEarly || options.message || this.tooEarly || "must be no earlier than %{date}";
                err = v.format(err, {
                    value: this.format(value, options),
                    date: this.format(earliest, options)
                });
                errors.push(err);
            }
            if (!isNaN(latest) && value > latest) {
                err = options.tooLate || options.message || this.tooLate || "must be no later than %{date}";
                err = v.format(err, {
                    date: this.format(latest, options),
                    value: this.format(value, options)
                });
                errors.push(err);
            }
            if (errors.length) return v.unique(errors);
        }, {
            parse: null,
            format: null
        }),
        date: function(value, options) {
            options = v.extend({}, options, {
                dateOnly: true
            });
            return v.validators.datetime.call(v.validators.datetime, value, options);
        },
        format: function(value, options) {
            if (v.isString(options) || options instanceof RegExp) options = {
                pattern: options
            };
            options = v.extend({}, this.options, options);
            var message = options.message || this.message || "is invalid", pattern = options.pattern, match;
            // Empty values are allowed
            if (!v.isDefined(value)) return;
            if (!v.isString(value)) return message;
            if (v.isString(pattern)) pattern = new RegExp(options.pattern, options.flags);
            match = pattern.exec(value);
            if (!match || match[0].length != value.length) return message;
        },
        inclusion: function(value, options) {
            // Empty values are fine
            if (!v.isDefined(value)) return;
            if (v.isArray(options)) options = {
                within: options
            };
            options = v.extend({}, this.options, options);
            if (v.contains(options.within, value)) return;
            var message = options.message || this.message || "^%{value} is not included in the list";
            return v.format(message, {
                value: value
            });
        },
        exclusion: function(value, options) {
            // Empty values are fine
            if (!v.isDefined(value)) return;
            if (v.isArray(options)) options = {
                within: options
            };
            options = v.extend({}, this.options, options);
            if (!v.contains(options.within, value)) return;
            var message = options.message || this.message || "^%{value} is restricted";
            if (v.isString(options.within[value])) value = options.within[value];
            return v.format(message, {
                value: value
            });
        },
        email: v.extend(function(value, options) {
            options = v.extend({}, this.options, options);
            var message = options.message || this.message || "is not a valid email";
            // Empty values are fine
            if (!v.isDefined(value)) return;
            if (!v.isString(value)) return message;
            if (!this.PATTERN.exec(value)) return message;
        }, {
            PATTERN: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
        }),
        equality: function(value, options, attribute, attributes, globalOptions) {
            if (!v.isDefined(value)) return;
            if (v.isString(options)) options = {
                attribute: options
            };
            options = v.extend({}, this.options, options);
            var message = options.message || this.message || "is not equal to %{attribute}";
            if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) throw new Error("The attribute must be a non empty string");
            var otherValue = v.getDeepObjectValue(attributes, options.attribute), comparator = options.comparator || function(v1, v2) {
                return v1 === v2;
            }, prettify = options.prettify || globalOptions && globalOptions.prettify || v.prettify;
            if (!comparator(value, otherValue, options, attribute, attributes)) return v.format(message, {
                attribute: prettify(options.attribute)
            });
        },
        // A URL validator that is used to validate URLs with the ability to
        // restrict schemes and some domains.
        url: function(value, options) {
            if (!v.isDefined(value)) return;
            options = v.extend({}, this.options, options);
            var message = options.message || this.message || "is not a valid url", schemes = options.schemes || this.schemes || [
                'http',
                'https'
            ], allowLocal = options.allowLocal || this.allowLocal || false, allowDataUrl = options.allowDataUrl || this.allowDataUrl || false;
            if (!v.isString(value)) return message;
            // https://gist.github.com/dperini/729294
            var regex = "^(?:(?:" + schemes.join("|") + ")://)" + // user:pass authentication
            "(?:\\S+(?::\\S*)?@)?" + "(?:";
            var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
            if (allowLocal) tld += "?";
            else regex += // IP address exclusion
            // private & local networks
            "(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
            regex += // IP address dotted notation octets
            // excludes loopback network 0.0.0.0
            // excludes reserved space >= 224.0.0.0
            // excludes network & broacast addresses
            // (first & last IP address of each class)
            "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" + tld + ")" + // port number
            "(?::\\d{2,5})?" + // resource path
            "(?:[/?#]\\S*)?" + "$";
            if (allowDataUrl) {
                // RFC 2397
                var mediaType = "\\w+\\/[-+.\\w]+(?:;[\\w=]+)*";
                var urlchar = "[A-Za-z0-9-_.!~\\*'();\\/?:@&=+$,%]*";
                var dataurl = "data:(?:" + mediaType + ")?(?:;base64)?," + urlchar;
                regex = "(?:" + regex + ")|(?:^" + dataurl + "$)";
            }
            var PATTERN = new RegExp(regex, 'i');
            if (!PATTERN.exec(value)) return message;
        },
        type: v.extend(function(value, originalOptions, attribute, attributes, globalOptions) {
            if (v.isString(originalOptions)) originalOptions = {
                type: originalOptions
            };
            if (!v.isDefined(value)) return;
            var options = v.extend({}, this.options, originalOptions);
            var type = options.type;
            if (!v.isDefined(type)) throw new Error("No type was specified");
            var check;
            if (v.isFunction(type)) check = type;
            else check = this.types[type];
            if (!v.isFunction(check)) throw new Error("validate.validators.type.types." + type + " must be a function.");
            if (!check(value, options, attribute, attributes, globalOptions)) {
                var message = originalOptions.message || this.messages[type] || this.message || options.message || (v.isFunction(type) ? "must be of the correct type" : "must be of type %{type}");
                if (v.isFunction(message)) message = message(value, originalOptions, attribute, attributes, globalOptions);
                return v.format(message, {
                    attribute: v.prettify(attribute),
                    type: type
                });
            }
        }, {
            types: {
                object: function(value) {
                    return v.isObject(value) && !v.isArray(value);
                },
                array: v.isArray,
                integer: v.isInteger,
                number: v.isNumber,
                string: v.isString,
                date: v.isDate,
                boolean: v.isBoolean
            },
            messages: {}
        })
    };
    validate.formatters = {
        detailed: function(errors) {
            return errors;
        },
        flat: v.flattenErrorsToArray,
        grouped: function(errors) {
            var attr;
            errors = v.groupErrorsByAttribute(errors);
            for(attr in errors)errors[attr] = v.flattenErrorsToArray(errors[attr]);
            return errors;
        },
        constraint: function(errors) {
            var attr;
            errors = v.groupErrorsByAttribute(errors);
            for(attr in errors)errors[attr] = errors[attr].map(function(result) {
                return result.validator;
            }).sort();
            return errors;
        }
    };
    validate.exposeModule(validate, this, exports1, module1, define1);
}).call(this, /* istanbul ignore next */ exports, /* istanbul ignore next */ module, typeof define !== 'undefined' ? /* istanbul ignore next */ define : null);

},{}],"6jovr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapOutputOperStatusFromInt = exports.mapInputOperStatusFromInt = exports.outputOperStatusValues = exports.inputOperStatusValues = exports.roleLevels = exports.DATE_FORMAT_LONGER = exports.DATE_FORMAT_LONG = exports.DATE_FORMAT_SHORT = exports.endOfDayMaxNowUTC = exports.endOfDayUTC = exports.startOfDayUTC = exports.dateToYearMonthDayMaxNowString = exports.dateToYearMonthDayString = exports.startOfMonthUTC = exports.ElementaryStreamTypeName = exports.APPLIANCE_ONLINE_THRESHOLD_SEC = exports.sentenceCase = exports.formatMs = exports.formatFileSize = exports.isOutput = exports.getEntityTypeName = exports.validate = exports.validateUsername = exports.REGEX_ALPHANUMERIC = exports.validatePassword = exports.getTransferredString = exports.getProductName = exports.getInputOperState = exports.isUdpOutputOrUnixOutput1m = exports.MIN_CONTROL_TRAFFIC_BITRATE = exports.MIN_VIDEO_BITRATE_BPS = exports.MIN_AUDIO_BITRATE_BPS = exports.METRICS_FRESHNESS_LIMIT_SECONDS = void 0;
exports.getMinimumAcceptableInputBitrateBps = getMinimumAcceptableInputBitrateBps;
exports.outputStatus = outputStatus;
exports.inputStatus = inputStatus;
exports.getOutputOperState = getOutputOperState;
exports.isAnyRistServerInputMetrics = isAnyRistServerInputMetrics;
exports.isRistServerEgressMetrics = isRistServerEgressMetrics;
exports.isRistServerEgressMetricType = isRistServerEgressMetricType;
exports.getMetricTypeForOutput = getMetricTypeForOutput;
exports.isRistInputMetrics = isRistInputMetrics;
exports.isRistOutputMetrics = isRistOutputMetrics;
exports.isUnixInputMetrics = isUnixInputMetrics;
exports.isUdpInputMetrics = isUdpInputMetrics;
exports.isOutputMetricsWithPacketsLost = isOutputMetricsWithPacketsLost;
exports.isUdpOutputMetrics = isUdpOutputMetrics;
exports.isUnixOutputMetrics = isUnixOutputMetrics;
exports.isUdpOutputOrUnixOutputMetrics = isUdpOutputOrUnixOutputMetrics;
exports.isRtpInputMetrics = isRtpInputMetrics;
exports.isMptsMetrics = isMptsMetrics;
exports.isTranscodeStreamMetrics = isTranscodeStreamMetrics;
exports.isRtpOutputMetrics = isRtpOutputMetrics;
exports.isRistSimpleProfileInputMetrics = isRistSimpleProfileInputMetrics;
exports.isRistSimpleProfileOutputMetrics = isRistSimpleProfileOutputMetrics;
exports.isZixiInputMetrics = isZixiInputMetrics;
exports.isZixiOutputMetric = isZixiOutputMetric;
exports.isSrtInputMetric = isSrtInputMetric;
exports.isSrtOutputMetric = isSrtOutputMetric;
exports.isRtmpInputMetric = isRtmpInputMetric;
exports.isRtmpOutputMetric = isRtmpOutputMetric;
exports.isRistServerChannelMetrics = isRistServerChannelMetrics;
exports.isRistServerPortMode = isRistServerPortMode;
exports.isMatroxPortMode = isMatroxPortMode;
exports.isGenericVideoAppliancePortMode = isGenericVideoAppliancePortMode;
exports.isIpPortMode = isIpPortMode;
exports.isIpPort = isIpPort;
exports.isVideonPortMode = isVideonPortMode;
exports.isVideonPort = isVideonPort;
exports.isComprimatoPortMode = isComprimatoPortMode;
exports.getActiveChannelOnAppliance = getActiveChannelOnAppliance;
exports.notUndefined = notUndefined;
exports.notUndefinedOrNull = notUndefinedOrNull;
exports.getFormattedTransportStreamContent = getFormattedTransportStreamContent;
exports.getInputPidsOnInputAppliance = getInputPidsOnInputAppliance;
exports.getTransportStreamContentInfo = getTransportStreamContentInfo;
exports.tsInfoServiceName = tsInfoServiceName;
exports.audioFormatFromTransportStream = audioFormatFromTransportStream;
exports.videoFormatFromTransportStream = videoFormatFromTransportStream;
exports.formatBitrate = formatBitrate;
exports.getApplianceStatus = getApplianceStatus;
exports.formatGraphNodeId = formatGraphNodeId;
exports.splitGraphNodeId = splitGraphNodeId;
exports.isMpts = isMpts;
exports.getVideoCodecFromPids = getVideoCodecFromPids;
exports.getVideoCodec = getVideoCodec;
exports.getAudioCodec = getAudioCodec;
exports.endOfMonthUTC = endOfMonthUTC;
exports.addMonthUTC = addMonthUTC;
exports.prettyFormatError = prettyFormatError;
exports.isIpcPortMode = isIpcPortMode;
exports.omit = omit;
exports.getRoleLevel = getRoleLevel;
exports.maxRole = maxRole;
exports.applyCodecRestrictions = applyCodecRestrictions;
exports.isNameValueOption = isNameValueOption;
exports.formatOutputStreamContents = formatOutputStreamContents;
exports.productIdFromEdgeProduct = productIdFromEdgeProduct;
exports.inputOperStatusToInt = inputOperStatusToInt;
exports.inputOperStatusFromInt = inputOperStatusFromInt;
exports.outputOperStatusToInt = outputOperStatusToInt;
exports.outputOperStatusFromInt = outputOperStatusFromInt;
const constants_1 = require("82aaf4a767a9e10a");
const util_1 = require("50c586c7ddf85cf9");
const types_1 = require("af0c702c5878db37");
const errors_1 = require("78ad9b6bc1a39296");
const rist_1 = require("d31aa438306f35ec");
const serialization_1 = require("3bbfbd02a5b8851e");
const applianceTypeUtil_1 = require("647fafa74ca14ae9");
exports.METRICS_FRESHNESS_LIMIT_SECONDS = 30;
exports.MIN_AUDIO_BITRATE_BPS = 8000; // 8 Kbps
exports.MIN_VIDEO_BITRATE_BPS = 100000; // 0.1 Mbps
// Note on value 5.5kbps:
// Inspecting an inhibited/standy RIST-stream in the service overview suggests that ~11kbps is normal bitrate for traffic only so I simply halved that.
// TODO: Ask stream team for an appropriate value
exports.MIN_CONTROL_TRAFFIC_BITRATE = 5500;
function getMinimumAcceptableInputBitrateBps(tsInfo) {
    const pids = tsInfo?.pids;
    if (!pids) // Not a TS-stream?
    return exports.MIN_VIDEO_BITRATE_BPS;
    const { hasMpegTsAudio, hasMpegTsVideo } = getTransportStreamContentInfo(pids);
    if (hasMpegTsAudio && hasMpegTsVideo) return exports.MIN_VIDEO_BITRATE_BPS;
    if (hasMpegTsVideo) return exports.MIN_VIDEO_BITRATE_BPS;
    if (hasMpegTsAudio) return exports.MIN_AUDIO_BITRATE_BPS;
    // No audio or video found in the TS-stream - only private data? We have no idea what is acceptable. Return MIN_VIDEO_BITRATE_BPS for backwards compatibility.
    return exports.MIN_VIDEO_BITRATE_BPS;
}
const isUdpOutputOrUnixOutput1m = (ristMetrics)=>(ristMetrics.type === 'udpOutput' || ristMetrics.type === 'unixOutput') && ristMetrics.window === types_1.MetricWindow.m1;
exports.isUdpOutputOrUnixOutput1m = isUdpOutputOrUnixOutput1m;
function outputStatus(state, title) {
    return {
        state,
        title
    };
}
function inputStatus(state, title) {
    return {
        state,
        title
    };
}
function getOutputOperState(o) {
    return o.health || {
        state: types_1.OutputOperStatus.metricsMissing,
        title: 'Health status missing'
    };
}
function isAnyRistServerInputMetrics(ristMetrics) {
    return ristMetrics.type === types_1.RistMetricType.ristInput || ristMetrics.type === types_1.RistMetricType.udpInput || ristMetrics.type === types_1.RistMetricType.unixInput || ristMetrics.type === types_1.RistMetricType.rtpInput || ristMetrics.type === types_1.RistSimpleProfileMetricType.ristSimpleInput;
}
function isRistServerEgressMetrics(m) {
    return m.window === types_1.MetricWindow.s10 && isRistServerEgressMetricType(m.type) && !!m.isEgress;
}
function isRistServerEgressMetricType(type) {
    const ristServerEgressMetricTypes = [
        types_1.RistMetricType.udpOutput,
        types_1.RistMetricType.unixOutput,
        types_1.RistMetricType.rtpOutput,
        types_1.RistSimpleProfileMetricType.ristSimpleOutput
    ];
    if (isMatroxMetricType(type) || isComprimatoMetricType(type)) return false;
    return ristServerEgressMetricTypes.includes(type);
}
function isComprimatoMetricType(type) {
    return type in types_1.ComprimatoMetricType;
}
function isMatroxMetricType(type) {
    return type in types_1.MatroxMetricType;
}
function getMetricTypeForOutput(outputPortMode, applianceType) {
    if ((0, applianceTypeUtil_1.isVaApplianceType)(applianceType)) return types_1.RistMetricType.rtpOutput;
    switch(outputPortMode){
        case types_1.CoaxPortMode.asi:
            return types_1.RistMetricType.rtpOutput;
        case types_1.CoaxPortMode.sdi:
            return types_1.RistMetricType.rtpOutput;
        case types_1.IpPortMode.udp:
            return types_1.RistMetricType.udpOutput;
        case types_1.IpPortMode.rtp:
            return types_1.RistMetricType.rtpOutput;
        case types_1.IpPortMode.rist:
            return types_1.RistSimpleProfileMetricType.ristSimpleOutput;
        case types_1.IpPortMode.srt:
            return types_1.SrtMetricType.srtOutput;
        case types_1.IpPortMode.zixi:
            return types_1.ZixiMetricType.zixiOutput;
        case types_1.IpPortMode.rtmp:
            return types_1.RtmpMetricType.rtmpOutput;
        case types_1.MatroxPortMode.matroxSdi:
            return types_1.MatroxMetricType.matroxSdiOutput;
        case types_1.ComprimatoPortMode.comprimatoNdi:
            return types_1.ComprimatoMetricType.comprimatoNdiOutput;
        case types_1.ComprimatoPortMode.comprimatoSdi:
            return types_1.ComprimatoMetricType.comprimatoSdiOutput;
        case types_1.IpcPortMode.unix:
            return types_1.RistMetricType.unixOutput;
    }
}
function isRistInputMetrics(m) {
    return m.type === types_1.RistMetricType.ristInput;
}
function isRistOutputMetrics(m) {
    return m.type === types_1.RistMetricType.ristOutput;
}
function isUnixInputMetrics(m) {
    return m.type === types_1.RistMetricType.unixInput;
}
function isUdpInputMetrics(m) {
    return m.type === types_1.RistMetricType.udpInput;
}
function isOutputMetricsWithPacketsLost(m) {
    return isUdpOutputMetrics(m) || isRtpOutputMetrics(m);
}
function isUdpOutputMetrics(m) {
    return m.type === types_1.RistMetricType.udpOutput;
}
function isUnixOutputMetrics(m) {
    return m.type === types_1.RistMetricType.unixOutput;
}
function isUdpOutputOrUnixOutputMetrics(m) {
    return isUdpOutputMetrics(m) || isUnixOutputMetrics(m);
}
function isRtpInputMetrics(m) {
    return m.type === types_1.RistMetricType.rtpInput;
}
function isMptsMetrics(m) {
    return m.type === types_1.MptsMetricType.mptsDemux;
}
function isTranscodeStreamMetrics(m) {
    return m.type === types_1.TrancodeStreamMetricType.transcodeStream;
}
function isRtpOutputMetrics(m) {
    return m.type === types_1.RistMetricType.rtpOutput;
}
function isRistSimpleProfileInputMetrics(m) {
    return m.type === types_1.RistSimpleProfileMetricType.ristSimpleInput;
}
function isRistSimpleProfileOutputMetrics(m) {
    return m.type === types_1.RistSimpleProfileMetricType.ristSimpleOutput;
}
function isZixiInputMetrics(m) {
    return m.type === types_1.ZixiMetricType.zixiInput;
}
function isZixiOutputMetric(m) {
    return m.type === types_1.ZixiMetricType.zixiOutput;
}
function isSrtInputMetric(m) {
    return m.type === types_1.SrtMetricType.srtInput;
}
function isSrtOutputMetric(m) {
    return m.type === types_1.SrtMetricType.srtOutput;
}
function isRtmpInputMetric(m) {
    return m.type === types_1.RtmpMetricType.rtmpInput;
}
function isRtmpOutputMetric(m) {
    return m.type === types_1.RtmpMetricType.rtmpOutput;
}
function isRistServerChannelMetrics(ristMetrics) {
    return ristMetrics.type === types_1.RistMetricType.channel;
}
function isRistServerPortMode(mode) {
    return mode === types_1.IpPortMode.udp || mode === types_1.IpPortMode.rtp || mode === types_1.IpPortMode.rist;
}
function isMatroxPortMode(portMode) {
    return portMode in types_1.MatroxPortMode;
}
function isGenericVideoAppliancePortMode(portMode) {
    return portMode in types_1.CoaxPortMode;
}
function isIpPortMode(portMode) {
    return portMode in types_1.IpPortMode;
}
function isIpPort(inputPort) {
    return isIpPortMode(inputPort.mode);
}
function isVideonPortMode(portMode) {
    return portMode in types_1.VideonPortMode;
}
// There are currently no Videon output ports
function isVideonPort(port) {
    return isVideonPortMode(port.mode);
}
function isComprimatoPortMode(portMode) {
    return portMode in types_1.ComprimatoPortMode;
}
const getInputOperState = (input)=>{
    return input.health || {
        state: types_1.InputOperStatus.metricsMissing,
        title: 'Health status missing'
    };
};
exports.getInputOperState = getInputOperState;
function getActiveChannelOnAppliance(applianceId, ristMetrics) {
    return ristMetrics.find((m)=>m.type === types_1.RistMetricType.channel && m.applianceId === applianceId && m.state === rist_1.ChannelState.activated)?.channelId ?? // Backwards compatibility for appliances that don't have "channel.state" introduced in R3.15.0: Use first found channelId
    ristMetrics.find((m)=>m.type === types_1.RistMetricType.channel && m.applianceId === applianceId)?.channelId;
}
const getProductName = (type)=>({
        [types_1.ApplianceType.nimbraVAdocker]: 'Edge Connect+',
        [types_1.ApplianceType.nimbra410]: 'Nimbra 410',
        [types_1.ApplianceType.nimbra412]: 'Nimbra 412',
        [types_1.ApplianceType.nimbra414]: 'Nimbra 414',
        [types_1.ApplianceType.nimbra414b]: 'Nimbra 414b',
        [types_1.ApplianceType.nimbraVA225]: 'Nimbra VA 225',
        [types_1.ApplianceType.nimbraVA220]: 'Nimbra VA 220',
        [types_1.ApplianceType.edgeConnect]: 'Edge Connect',
        [types_1.ApplianceType.core]: 'Core node',
        [types_1.ApplianceType.thumb]: 'Core thumb',
        [types_1.ApplianceType.videon]: 'Videon',
        [types_1.ApplianceType.matroxMonarchEdgeE4_8Bit]: 'Monarch EDGE E4 (8 bit)',
        [types_1.ApplianceType.matroxMonarchEdgeE4_10Bit]: 'Monarch EDGE E4 (10 bit)',
        [types_1.ApplianceType.matroxMonarchEdgeD4]: 'Monarch EDGE D4',
        [types_1.ApplianceType.matroxMonarchEdgeS1]: 'Monarch EDGE S1',
        [types_1.ApplianceType.comprimato]: 'Comprimato',
        [types_1.ApplianceType.mediakindRx1]: 'Mediakind RX1',
        [types_1.ApplianceType.mediakindCe1]: 'Mediakind CE1',
        [types_1.ApplianceType.riversilica]: 'RiverSilica',
        [types_1.ApplianceType.nimbra204]: 'Nimbra 204'
    })[type] || type;
exports.getProductName = getProductName;
const getTransferredString = (gbValue)=>{
    if (gbValue === undefined) return;
    let measure = 'GB';
    let value = gbValue;
    if (Math.floor(gbValue) > 0) value = gbValue.toFixed(2);
    else {
        measure = 'MB';
        value = (gbValue * 1e3).toFixed(2);
        if (parseFloat(value) === 0) value = `~${value}`;
    }
    return `${value} ${measure}`;
};
exports.getTransferredString = getTransferredString;
const validatePassword = (value)=>{
    const minPwdLength = 8;
    if (value.length > 0) {
        if (value.length < minPwdLength) return `Password must contain at least ${minPwdLength} characters`;
    }
    return undefined;
};
exports.validatePassword = validatePassword;
function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
exports.REGEX_ALPHANUMERIC = /^[a-zA-Z0-9]*$/m;
const validateUsername = (value)=>{
    if (!emailIsValid(value)) return `Must be a valid email address`;
    return undefined;
};
exports.validateUsername = validateUsername;
const validate = (fieldname, validationErrorInfo)=>{
    if (validationErrorInfo) throw new errors_1.InvalidParametersError(errors_1.ErrorCode.invalidParameters, [
        {
            name: fieldname,
            reason: validationErrorInfo
        }
    ]);
};
exports.validate = validate;
const getEntityTypeName = (entityType)=>{
    switch(entityType){
        case types_1.EntityType.outputRecipientList:
            return 'output list';
        case types_1.EntityType.groupRecipientList:
            return 'group list';
        default:
            return entityType;
    }
};
exports.getEntityTypeName = getEntityTypeName;
function notUndefined(x) {
    return x !== undefined;
}
function notUndefinedOrNull(x) {
    return x !== undefined && x !== null;
}
function getFormattedTransportStreamContent(tsInfo) {
    if (!tsInfo) return 'N/A';
    const pids = tsInfo.pids;
    if (!pids) return 'No pids';
    const streamIsMpts = isMpts([
        tsInfo
    ]);
    if (streamIsMpts) return 'MPTS';
    const { hasMpegTsAudio, hasMpegTsVideo } = getTransportStreamContentInfo(pids);
    if (hasMpegTsVideo) return videoFormatFromTransportStream(pids);
    else if (hasMpegTsAudio) return audioFormatFromTransportStream(pids);
    return `No audio/video`;
}
function getInputPidsOnInputAppliance(input, channelId) {
    if (!input || !channelId) return [];
    const inputApplianceIds = input.appliances?.map((appliance)=>appliance.id);
    if (!inputApplianceIds) return [];
    const tsInfo = input.tsInfo;
    if (!tsInfo) return [];
    const inputApplianceTsInfo = tsInfo.find((tsInfo)=>inputApplianceIds.includes(tsInfo.applianceId) && tsInfo.channelId === channelId);
    return inputApplianceTsInfo?.pids || [];
}
function getTransportStreamContentInfo(pids) {
    return {
        hasMpegTsAudio: pids.some((p)=>p?.streamInfo?.audio !== undefined),
        hasMpegTsVideo: pids.some((p)=>p?.streamInfo?.video !== undefined)
    };
}
function tsInfoServiceName(info) {
    const firstService = info?.services?.[0];
    const noInfo = 'no info';
    if (!firstService) return noInfo;
    return `${firstService.name || firstService.type?.description || noInfo}`;
}
function audioFormatFromTransportStream(tsPids) {
    // TODO: Handle MPTS - we currently extract the first found audio entry
    const audioPid = tsPids.find((p)=>p?.streamInfo?.audio);
    if (!audioPid) return 'No audio';
    const audio = audioPid.streamInfo.audio;
    const sampleRate = audio.sampleRate ? `${audio.sampleRate / 1000}kHz ` : '';
    const codec = getFormattedElementaryStreamType(audioPid);
    return `${sampleRate}${codec}`;
}
function formattedVideoHeight({ height, isHEVC, isInterlaced }) {
    const multiplier = isInterlaced && isHEVC ? 2 : 1; // EDGE-5073: HEVC reports half the expected size for interlaced
    return (height * multiplier).toString();
}
function formattedVideoRate({ framerate, isHEVC, isInterlaced }) {
    const fieldrate = isHEVC ? framerate : framerate * 2; // EDGE-5073: HEVC already reports fieldrate * 2
    return (isInterlaced ? fieldrate : framerate).toFixed(2);
}
function videoFormatFromTransportStream(tsPids) {
    // TODO: Handle MPTS - we currently extract the first found video entry
    const videoPid = tsPids.find((p)=>!!p?.streamInfo?.video);
    if (!videoPid) return 'No video';
    const streamInfo = videoPid.streamInfo;
    const isHEVC = getElementaryStreamType(streamInfo.type?.value) === ElementaryStreamTypeName.h265;
    const isInterlaced = streamInfo.video.interlaced === 'yes';
    const videoHeight = streamInfo.video.videoSize?.vertical !== undefined ? formattedVideoHeight({
        height: streamInfo.video.videoSize.vertical,
        isHEVC,
        isInterlaced
    }) : '';
    const scanMode = streamInfo.video.interlaced ? isInterlaced ? 'i' : 'p' : '?';
    const frameOrFieldrate = streamInfo.video.frameRate !== undefined ? formattedVideoRate({
        framerate: streamInfo.video.frameRate,
        isHEVC,
        isInterlaced
    }) : '';
    const formattedCodec = getFormattedElementaryStreamType(videoPid);
    return `${videoHeight}${scanMode}${frameOrFieldrate} ${formattedCodec}`;
}
const isOutput = (inputOrOutput)=>{
    return inputOrOutput.type === 'push-rist-output' || inputOrOutput.type === 'rist-simple-output' || inputOrOutput.type === 'srt-output' || inputOrOutput.type === 'zixi-output' || inputOrOutput.type === 'udp-output' || inputOrOutput.type === 'rtp-output' || inputOrOutput.type === 'rtmp-output';
};
exports.isOutput = isOutput;
/**
 * Format bitrate into kbps, Mbps, Gbps, Tbps depending on the size.
 * @param bps - bitrate in bps
 */ function formatBitrate(bps) {
    if (typeof bps === 'string') // eslint-disable-next-line no-param-reassign
    bps = parseInt(bps);
    if (typeof bps !== 'number' || !Number.isFinite(bps)) return 'N/A';
    const units = [
        [
            'kbps',
            0
        ],
        [
            'Mbps',
            2
        ],
        [
            'Gbps',
            3
        ],
        [
            'Tbps',
            3
        ]
    ];
    const absBps = Math.max(bps, 0);
    const log = Math.floor(Math.log10(absBps));
    const size = Math.max(Math.floor(log / 3) - 1, 0);
    const [unit, decimals] = units[size];
    const val = absBps / Math.pow(10, (size + 1) * 3);
    const formattedVal = val.toFixed(decimals);
    return `${formattedVal} ${unit}`;
}
/**
 * Format file size into TB, GB, MB, KB depending on the size.
 * @param bytes - file size in bytes
 */ const formatFileSize = (bytes)=>{
    if (typeof bytes === 'string') // eslint-disable-next-line no-param-reassign
    bytes = parseInt(bytes);
    if (typeof bytes !== 'number' || !Number.isFinite(bytes)) return 'N/A';
    const units = [
        [
            'B',
            0
        ],
        [
            'KB',
            0
        ],
        [
            'MB',
            1
        ],
        [
            'GB',
            2
        ],
        [
            'TB',
            3
        ]
    ];
    const absBytes = Math.max(bytes, 0);
    const log = Math.floor(Math.log10(absBytes));
    const size = Math.max(Math.floor(log / 3), 0);
    const [unit, decimals] = units[size];
    const val = absBytes / Math.pow(10, size * 3);
    const formattedVal = val.toFixed(decimals);
    return `${formattedVal} ${unit}`;
};
exports.formatFileSize = formatFileSize;
/**
 * Format milliseconds into human-friendly string like "1m40s", "2h3m", or "500ms"
 * @param ms - milliseconds
 */ const formatMs = (ms)=>{
    if (typeof ms === 'string') ms = parseInt(ms);
    if (typeof ms !== 'number' || !Number.isFinite(ms)) return 'N/A';
    const isNegative = ms < 0;
    ms = Math.abs(ms);
    const totalSeconds = Math.floor(ms / 1000);
    const milliseconds = ms % 1000;
    const seconds = totalSeconds % 60;
    const totalMinutes = Math.floor(totalSeconds / 60);
    const minutes = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);
    let result;
    if (hours > 0) result = `${hours}h${minutes}m`;
    else if (minutes > 0) result = `${minutes}m${seconds}s`;
    else if (seconds > 0) result = `${seconds}s`;
    else result = `${milliseconds}ms`;
    return isNegative ? `-${result}` : result;
};
exports.formatMs = formatMs;
const sentenceCase = (input)=>{
    const spaced = input.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
    const normalized = spaced.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
    const lowerCased = normalized.toLowerCase();
    return lowerCased.charAt(0).toUpperCase() + lowerCased.slice(1);
};
exports.sentenceCase = sentenceCase;
exports.APPLIANCE_ONLINE_THRESHOLD_SEC = 15;
function getApplianceStatus(appliance, formatDistanceToNow) {
    if (!appliance.lastMessageAt) return {
        title: `Never connected`,
        state: types_1.ApplianceConnectionState.neverConnected
    };
    if ((0, util_1.ageSeconds)(appliance.lastMessageAt) > exports.APPLIANCE_ONLINE_THRESHOLD_SEC) return {
        title: `Last seen ${formatDistanceToNow(appliance.lastMessageAt)} ago`,
        state: types_1.ApplianceConnectionState.missing
    };
    return {
        title: `Last seen less than ${exports.APPLIANCE_ONLINE_THRESHOLD_SEC} seconds ago`,
        state: types_1.ApplianceConnectionState.connected
    };
}
function formatGraphNodeId({ type, id }) {
    return `${type}::${id}`;
}
function splitGraphNodeId(nodeId) {
    const [type, id] = nodeId.split('::');
    return {
        type,
        id
    };
}
var ElementaryStreamTypeName;
(function(ElementaryStreamTypeName) {
    ElementaryStreamTypeName["h262"] = "h262";
    ElementaryStreamTypeName["mpeg1"] = "mpeg-1";
    ElementaryStreamTypeName["mpeg2"] = "mpeg-2";
    ElementaryStreamTypeName["adtsAac"] = "adts-aac";
    ElementaryStreamTypeName["h263"] = "h263";
    ElementaryStreamTypeName["h264"] = "h264";
    ElementaryStreamTypeName["j2k"] = "j2k";
    ElementaryStreamTypeName["h265"] = "h265";
    ElementaryStreamTypeName["jpegxs"] = "jpeg-xs";
    ElementaryStreamTypeName["ac3"] = "ac3";
    ElementaryStreamTypeName["eac3"] = "eac3";
})(ElementaryStreamTypeName || (exports.ElementaryStreamTypeName = ElementaryStreamTypeName = {}));
function isMpts(tsInfo) {
    return tsInfo?.some((tsInfo)=>(tsInfo.services?.length || 1) > 1);
}
function getVideoCodecFromPids(pids) {
    const videoPid = pids.find((p)=>p?.streamInfo?.video !== undefined);
    if (!videoPid) return null;
    return getElementaryStreamType(videoPid.streamInfo?.type?.value);
}
function getVideoCodec(tsInfo) {
    return getVideoCodecFromPids(tsInfo.pids || []);
}
function getAudioCodec(tsInfo) {
    const audioPid = tsInfo.pids?.find((p)=>p?.streamInfo?.audio !== undefined);
    if (!audioPid) return null;
    return getElementaryStreamType(audioPid.streamInfo?.type?.value);
}
function getFormattedElementaryStreamType(pid) {
    const streamTypeValue = pid.streamInfo?.type?.value;
    if (streamTypeValue) {
        const mappedStreamType = getElementaryStreamType(streamTypeValue);
        if (mappedStreamType !== null) return mappedStreamType.toString();
    }
    const pidDescription = pid.description;
    if (pidDescription) return pidDescription;
    if (streamTypeValue) return `(${streamTypeValue})`;
    return '?';
}
/**
 * https://en.wikipedia.org/wiki/Program-specific_information#Elementary_stream_types
 */ function getElementaryStreamType(streamType) {
    switch(streamType){
        case 1:
            return ElementaryStreamTypeName.mpeg1; // Video
        case 2:
            return ElementaryStreamTypeName.h262;
        case 3:
            return ElementaryStreamTypeName.mpeg1; // Audio
        case 4:
            return ElementaryStreamTypeName.mpeg2; // Audio
        case 15:
            return ElementaryStreamTypeName.adtsAac; // Audio
        case 16:
            return ElementaryStreamTypeName.h263;
        case 27:
            return ElementaryStreamTypeName.h264;
        case 33:
            return ElementaryStreamTypeName.j2k;
        case 36:
            return ElementaryStreamTypeName.h265;
        case 50:
            return ElementaryStreamTypeName.jpegxs;
        case 129:
            return ElementaryStreamTypeName.ac3; // Audio
        case 132:
            return ElementaryStreamTypeName.eac3; // Audio
        case 135:
            return ElementaryStreamTypeName.eac3; // Audio
    }
    return null;
}
// return start of month in UTC
const startOfMonthUTC = (value)=>{
    const month = value.getUTCMonth() + 1;
    const monthStr = month < 10 ? `0${month}` : `${month}`;
    return new Date(`${value.getUTCFullYear()}-${monthStr}-01T00:00:00.000Z`);
};
exports.startOfMonthUTC = startOfMonthUTC;
function endOfMonthUTC(d) {
    const endDate = new Date(d);
    endDate.setUTCDate(1);
    endDate.setUTCMonth(endDate.getUTCMonth() + 1);
    endDate.setUTCDate(0);
    endDate.setUTCHours(23, 59, 59, 999);
    return endDate;
}
function addMonthUTC(d, n = 1) {
    const addedMonth = new Date(d);
    const date = addedMonth.getUTCDate();
    addedMonth.setUTCDate(1);
    const nextMonth = addedMonth.getUTCMonth() + n;
    addedMonth.setUTCMonth(nextMonth);
    addedMonth.setUTCDate(Math.min(date, endOfMonthUTC(addedMonth).getUTCDate()));
    return addedMonth;
}
const dateToYearMonthDayString = (d)=>{
    return d.toISOString().substring(0, 10);
};
exports.dateToYearMonthDayString = dateToYearMonthDayString;
const dateToYearMonthDayMaxNowString = (d)=>{
    d = d.getTime() > Date.now() ? new Date() : d;
    return (0, exports.dateToYearMonthDayString)(d);
};
exports.dateToYearMonthDayMaxNowString = dateToYearMonthDayMaxNowString;
const startOfDayUTC = (d)=>{
    return new Date((0, exports.dateToYearMonthDayString)(d));
};
exports.startOfDayUTC = startOfDayUTC;
const endOfDayUTC = (d)=>{
    return new Date(`${(0, exports.dateToYearMonthDayString)(d)}T23:59:59.999Z`);
};
exports.endOfDayUTC = endOfDayUTC;
const endOfDayMaxNowUTC = (d)=>{
    const endOfDay = (0, exports.endOfDayUTC)(d);
    return endOfDay.getTime() > Date.now() ? new Date() : endOfDay;
};
exports.endOfDayMaxNowUTC = endOfDayMaxNowUTC;
function prettyFormatError(e) {
    const str = e?.toString();
    if (str === '[object Object]') return (0, serialization_1.tryStringify)(e);
    return str;
}
function isIpcPortMode(portMode) {
    return portMode in types_1.IpcPortMode;
}
exports.DATE_FORMAT_SHORT = 'yyyy-MM-dd';
exports.DATE_FORMAT_LONG = 'yyyy-MM-dd HH:mm:ss';
exports.DATE_FORMAT_LONGER = 'yyyy-MM-dd HH:mm:ss.SSS';
function omit(t, ...omitKeys) {
    const o = {
        ...t
    };
    for (const k of omitKeys)delete o[k];
    return o;
}
exports.roleLevels = Object.freeze([
    types_1.Role.basic,
    types_1.Role.admin,
    types_1.Role.super
]);
function getRoleLevel(role) {
    const index = exports.roleLevels.findIndex((r)=>r === role);
    if (index === -1) throw new Error(`Invalid role: ${role}`);
    return index;
}
function maxRole(...roles) {
    if (roles.length === 0) throw new Error(`maxRole expects at least one role as input`);
    let maxRole1 = roles[0];
    for (const role of roles)if (getRoleLevel(role) > getRoleLevel(maxRole1)) maxRole1 = role;
    return maxRole1;
}
function applyCodecRestrictions(options, property, encoderSettings, restrictions) {
    // Yes, the typing here could be improved
    const opts = options || [];
    if (!Array.isArray(opts)) return opts;
    const propRestrictions = restrictions && restrictions[property];
    if (!propRestrictions) return opts;
    const determinant = propRestrictions.determinedBy;
    if (!(determinant in encoderSettings)) return opts;
    const determinantValue = encoderSettings[determinant];
    const mappedValues = propRestrictions.mapping[determinantValue];
    if (!Array.isArray(mappedValues)) return opts;
    return opts.filter((o)=>{
        return mappedValues.includes(isNameValueOption(o) ? o.value : o);
    });
}
function isNameValueOption(v) {
    return typeof v === 'object' && typeof v['name'] === 'string' && 'value' in v;
}
function formatOutputStreamContents({ ports, tsInfo }) {
    if (isMatroxPortMode(ports[0].mode)) return formatFromMatroxOutputPort(ports[0]);
    else return getFormattedTransportStreamContent((tsInfo || [])[0]);
}
function productIdFromEdgeProduct(edgeProduct) {
    switch(edgeProduct){
        case types_1.EdgeProduct.loci:
            return constants_1.PRODUCTS.connectIt.id;
        case types_1.EdgeProduct.edge:
            return constants_1.PRODUCTS.nimbraEdge.id;
    }
}
function formatFromMatroxOutputPort(port) {
    return port.decoderSettings.outputSettings.resolution;
}
// This is how the status is stored in the database and the order used for sorting
exports.inputOperStatusValues = {
    allOk: 0,
    reducedRedundancy: 10,
    notConfigured: 20,
    metricsMissing: 30,
    tr101290Priority1Error: 40,
    transportError: 50,
    alarm: 60,
    inputError: 70
};
// This is how the status is stored in the database and the order used for sorting
exports.outputOperStatusValues = {
    allOk: 0,
    reducedRedundancy: 10,
    notAcknowledged: 20,
    notConfigured: 30,
    metricsMissing: 40,
    inputError: 50,
    tr101290Priority1Error: 60,
    alarm: 70,
    outputError: 80
};
exports.mapInputOperStatusFromInt = new Map(Object.entries(exports.inputOperStatusValues).map(([key, value])=>[
        value,
        key
    ]));
exports.mapOutputOperStatusFromInt = new Map(Object.entries(exports.outputOperStatusValues).map(([key, value])=>[
        value,
        key
    ]));
function inputOperStatusToInt(status) {
    return exports.inputOperStatusValues[status] ?? 80;
}
function inputOperStatusFromInt(status) {
    return exports.mapInputOperStatusFromInt.get(status) ?? types_1.InputOperStatus.inputError;
}
function outputOperStatusToInt(status) {
    return exports.outputOperStatusValues[status] ?? 80;
}
function outputOperStatusFromInt(status) {
    return exports.mapOutputOperStatusFromInt.get(status) ?? types_1.OutputOperStatus.outputError;
}

},{"82aaf4a767a9e10a":"bdiC1","50c586c7ddf85cf9":"jV4UZ","af0c702c5878db37":"3qemx","78ad9b6bc1a39296":"lwLel","d31aa438306f35ec":"eyUJa","3bbfbd02a5b8851e":"j24dT","647fafa74ca14ae9":"3z9on"}],"bdiC1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NIMBRA_OS_ID = exports.TOPIC_AD_CREATIVES_TO_PROBE = exports.TOPIC_ADS_TO_TRANSCODE = exports.TOPIC_AD_VAST_REQUESTS = exports.TOPIC_AD_EVENTS = exports.TOPIC_AD_PLAYLISTS = exports.TOPIC_AD_AUDIT_LOG = exports.PRODUCTS = exports.COOKIE_APPLIANCE_PROXY = exports.HEADER_EDGE_DATA_CONTAINER_ID = exports.TS_ANALYSIS_INTERVAL_SECONDS = exports.EDGE_SUPER_API_TOKEN_SECRET_NAME = exports.EDGE_OPERATOR_API_TOKEN_NAME = exports.defaultRegionName = exports.defaultRegionId = exports.SRT_STATS_INTERVAL = exports.USE_ORIGIN_TIMING = exports.DEFAULT_DELAY_MODE = exports.DEFAULT_BUFFER_DURATION = void 0;
exports.findProductById = findProductById;
exports.DEFAULT_BUFFER_DURATION = 6000;
exports.DEFAULT_DELAY_MODE = parseInt('2');
exports.USE_ORIGIN_TIMING = true;
exports.SRT_STATS_INTERVAL = 10;
exports.defaultRegionId = '69920e49-31c4-476a-b6bb-023305262007';
exports.defaultRegionName = 'default';
exports.EDGE_OPERATOR_API_TOKEN_NAME = 'edge-operator-api-token';
exports.EDGE_SUPER_API_TOKEN_SECRET_NAME = 'edge-operator-api-token';
exports.TS_ANALYSIS_INTERVAL_SECONDS = 10;
exports.HEADER_EDGE_DATA_CONTAINER_ID = 'edge-data-container-id';
// EDGE-4072: Sticky ingress during UI proxy:
// ensure that all communicating parties are routed
// through the same edge-api instance by setting this cookie.
exports.COOKIE_APPLIANCE_PROXY = 'applianceproxy';
exports.PRODUCTS = {
    nimbraEdge: {
        id: '705be4c2-0e82-4356-9ce2-6484c116796f',
        name: 'Nimbra Edge'
    },
    connectIt: {
        id: 'd0b70d6d-8db6-4524-8d4f-7ee716af241a',
        name: 'Connect iT'
    }
};
function findProductById(productId) {
    return Object.values(exports.PRODUCTS).find((p)=>p.id === productId);
}
exports.TOPIC_AD_AUDIT_LOG = 'ad_audit_log';
exports.TOPIC_AD_PLAYLISTS = 'ad_playlists';
exports.TOPIC_AD_EVENTS = 'ad_events';
exports.TOPIC_AD_VAST_REQUESTS = 'ad_vast_requests';
exports.TOPIC_ADS_TO_TRANSCODE = 'ads_to_transcode';
exports.TOPIC_AD_CREATIVES_TO_PROBE = 'ad_creatives_to_probe';
exports.NIMBRA_OS_ID = 'nimbraos';

},{}],"lwLel":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseError = exports.RequestTimeoutError = exports.NetworkError = exports.NetworkErrorCodes = exports.SsoFailedError = exports.OriginIsUnreachableError = exports.ServiceUnavailableError = exports.InvalidParametersError = exports.PayloadTooLargeError = exports.ForbiddenError = exports.UnauthorizedError = exports.UnsupportedMediaTypeError = exports.BadRequestError = exports.NotImplementedError = exports.ServerError = exports.ConflictError = exports.TimeoutError = exports.NotFoundError = exports.EdgeApiHttpError = exports.ErrorCode = void 0;
exports.errorTitle = errorTitle;
exports.throwApiError = throwApiError;
const httpError_1 = require("a53200e2a0693e7d");
var ErrorCode;
(function(ErrorCode) {
    ErrorCode["unknownError"] = "unknownError";
    ErrorCode["internalServerError"] = "internalServerError";
    ErrorCode["notImplementedError"] = "notImplementedError";
    ErrorCode["serviceUnavailableError"] = "serviceUnavailable";
    ErrorCode["originIsUnreachableError"] = "originIsUnreachableError";
    ErrorCode["portIsTaken"] = "portIsTaken";
    ErrorCode["notFound"] = "notFound";
    ErrorCode["timeout"] = "timeout";
    ErrorCode["conflict"] = "conflict";
    ErrorCode["badRequest"] = "badRequest";
    ErrorCode["unsupportedMediaType"] = "unsupportedMediaType";
    ErrorCode["unauthorized"] = "unauthorized";
    ErrorCode["mfaRequired"] = "mfaRequired";
    ErrorCode["forbidden"] = "forbidden";
    ErrorCode["payloadTooLarge"] = "payloadTooLarge";
    ErrorCode["gatewayTimeout"] = "gatewayTimeout";
    ErrorCode["noPortAccess"] = "noPortAccess";
    ErrorCode["outputDeniedNoServiceAccess"] = "outputDeniedNoServiceAccess";
    ErrorCode["outputInvalidNoSuchPort"] = "outputInvalidNoSuchPort";
    ErrorCode["serviceNotFound"] = "serviceNotFound";
    ErrorCode["invalidApplianceId"] = "invalidApplianceId";
    ErrorCode["userNotFound"] = "userNotFound";
    ErrorCode["missingParameter"] = "missingParameter";
    ErrorCode["usernameTaken"] = "usernameTaken";
    ErrorCode["nameTaken"] = "nameTaken";
    ErrorCode["invalidParameters"] = "invalidParameters";
    ErrorCode["tooManyLoginAttempts"] = "tooManyLoginAttempts";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
function errorTitle(errorCode) {
    return errorTitles[errorCode];
}
const errorTitles = {
    [ErrorCode.portIsTaken]: 'The port is already taken',
    [ErrorCode.unknownError]: 'Unknown error',
    [ErrorCode.internalServerError]: 'Internal server error',
    [ErrorCode.notImplementedError]: 'Not Implemented',
    [ErrorCode.serviceUnavailableError]: 'Service is unavailable',
    [ErrorCode.originIsUnreachableError]: 'Origin is unreachable',
    [ErrorCode.notFound]: 'The resource could not be found',
    [ErrorCode.timeout]: 'The request timed out',
    [ErrorCode.conflict]: 'The request resulted in a conflict',
    [ErrorCode.badRequest]: 'The request was invalid',
    [ErrorCode.unsupportedMediaType]: 'The media type is not supported',
    [ErrorCode.unauthorized]: 'Authentication required',
    [ErrorCode.mfaRequired]: 'MFA required',
    [ErrorCode.forbidden]: 'Access denied',
    [ErrorCode.payloadTooLarge]: 'Payload too large',
    [ErrorCode.gatewayTimeout]: 'Gateway timeout',
    [ErrorCode.noPortAccess]: 'You are not the owner of this port',
    [ErrorCode.outputDeniedNoServiceAccess]: 'The subscription was denied because the user group does not have access to the service',
    [ErrorCode.outputInvalidNoSuchPort]: 'The subscription request was invalid because the specified port does not exist',
    [ErrorCode.serviceNotFound]: 'The service could not be found',
    [ErrorCode.invalidApplianceId]: 'The provided appliance id was invalid',
    [ErrorCode.userNotFound]: 'The user was not found',
    [ErrorCode.missingParameter]: 'One or more parameters are missing',
    [ErrorCode.usernameTaken]: 'The specified username was already taken',
    [ErrorCode.nameTaken]: 'The specified name was already taken',
    [ErrorCode.invalidParameters]: 'One or more parameters are invalid.',
    [ErrorCode.tooManyLoginAttempts]: 'Too many login attempts.'
};
function defaultTitle(type) {
    return errorTitles[type];
}
class EdgeApiHttpError extends httpError_1.HttpError {
    constructor(status, type, title, detail = ''){
        super(status, type, title, detail);
        this.type = type;
    }
    toJSON() {
        const { status, title, detail, type } = this;
        return {
            status,
            title: title || defaultTitle(type),
            detail,
            type
        };
    }
    toString() {
        return `Error: HTTP ${this.status} ${this.title}${this.detail ? ` (${typeof this.detail === 'object' ? JSON.stringify(this.detail) : this.detail})` : ''}`;
    }
}
exports.EdgeApiHttpError = EdgeApiHttpError;
const errors = new Map();
function createError(httpCode, errorCode) {
    const Cls = class extends EdgeApiHttpError {
        constructor(type = errorCode, detail = '', title = ''){
            super(httpCode, type, title || defaultTitle(type), detail);
            Error.captureStackTrace(this, Cls);
        }
    };
    Object.defineProperty(Cls, 'name', {
        value: errorCode
    });
    errors.set(httpCode, Cls);
    return Cls;
}
function throwApiError(e, apiError) {
    if (e instanceof EdgeApiHttpError) throw e;
    else throw apiError;
}
exports.NotFoundError = createError(httpError_1.HttpStatusCode.NotFound, ErrorCode.notFound);
exports.TimeoutError = createError(httpError_1.HttpStatusCode.GatewayTimeout, ErrorCode.gatewayTimeout);
exports.ConflictError = createError(httpError_1.HttpStatusCode.Conflict, ErrorCode.conflict);
exports.ServerError = createError(httpError_1.HttpStatusCode.ServerError, ErrorCode.internalServerError);
exports.NotImplementedError = createError(httpError_1.HttpStatusCode.NotImplemented, ErrorCode.notImplementedError);
exports.BadRequestError = createError(httpError_1.HttpStatusCode.BadRequest, ErrorCode.badRequest);
exports.UnsupportedMediaTypeError = createError(httpError_1.HttpStatusCode.UnsupportedMediaType, ErrorCode.unsupportedMediaType);
exports.UnauthorizedError = createError(httpError_1.HttpStatusCode.Unauthorized, ErrorCode.unauthorized);
exports.ForbiddenError = createError(httpError_1.HttpStatusCode.Forbidden, ErrorCode.forbidden);
exports.PayloadTooLargeError = createError(httpError_1.HttpStatusCode.PayloadTooLarge, ErrorCode.payloadTooLarge);
exports.InvalidParametersError = createError(httpError_1.HttpStatusCode.BadRequest, ErrorCode.invalidParameters);
exports.ServiceUnavailableError = createError(httpError_1.HttpStatusCode.ServiceUnavailable, ErrorCode.serviceUnavailableError);
exports.OriginIsUnreachableError = createError(httpError_1.HttpStatusCode.OriginIsUnreachable, ErrorCode.originIsUnreachableError);
class SsoFailedError extends Error {
}
exports.SsoFailedError = SsoFailedError;
var NetworkErrorCodes;
(function(NetworkErrorCodes) {
    NetworkErrorCodes["ECONNRESET"] = "ECONNRESET";
    NetworkErrorCodes["ECONNREFUSED"] = "ECONNREFUSED";
    NetworkErrorCodes["ETIMEDOUT"] = "ETIMEDOUT";
    NetworkErrorCodes["ENOTFOUND"] = "ENOTFOUND";
    NetworkErrorCodes["EAI_AGAIN"] = "EAI_AGAIN";
    NetworkErrorCodes["EHOSTUNREACH"] = "EHOSTUNREACH";
    NetworkErrorCodes["ERR_INVALID_URL"] = "ERR_INVALID_URL";
    NetworkErrorCodes["DEPTH_ZERO_SELF_SIGNED_CERT"] = "DEPTH_ZERO_SELF_SIGNED_CERT";
    NetworkErrorCodes["OTHER"] = "OTHER";
})(NetworkErrorCodes || (exports.NetworkErrorCodes = NetworkErrorCodes = {}));
class NetworkError extends Error {
    constructor(message, originalErrorCode, cause, constructorOpt){
        super(message, {
            cause
        });
        this.message = message;
        this.originalErrorCode = originalErrorCode;
        this.cause = cause;
        if (!(originalErrorCode in NetworkErrorCodes)) this.code = NetworkErrorCodes.OTHER;
        else this.code = originalErrorCode;
        Error.captureStackTrace(this, constructorOpt || NetworkError);
    }
}
exports.NetworkError = NetworkError;
class RequestTimeoutError extends Error {
}
exports.RequestTimeoutError = RequestTimeoutError;
const parseError = (error)=>{
    if (error instanceof NetworkError) return error;
    if (error instanceof RequestTimeoutError) return error;
    if (error instanceof httpError_1.GenericHttpError) {
        if (typeof error.body === 'object') {
            const httpStatus = 'status' in error.body ? error.body.status : error.status;
            if (httpStatus) {
                const ErrorCls = errors.get(httpStatus);
                if (ErrorCls) return new ErrorCls(error.body.type, error.body.detail, error.body.title);
                else return new EdgeApiHttpError(httpStatus, error.body.type, error.body.detail, error.body.title);
            }
        } else return new EdgeApiHttpError(error && error.status || 0, ErrorCode.unknownError, `HTTP ${error.status} - body parsing failed`);
    }
    const otherError = error;
    return new EdgeApiHttpError(otherError.status || 0, ErrorCode.unknownError, otherError.message || 'Unknown error');
};
exports.parseError = parseError;

},{"a53200e2a0693e7d":"lhmJf"}],"lhmJf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GenericHttpError = exports.HttpError = exports.HttpStatusCode = void 0;
exports.isHttpSuccess = isHttpSuccess;
const serialization_1 = require("e0770cfa2231b615");
function isHttpSuccess(code) {
    return code >= 200 && code <= 299;
}
var HttpStatusCode;
(function(HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["Ok"] = 200] = "Ok";
    HttpStatusCode[HttpStatusCode["Created"] = 201] = "Created";
    HttpStatusCode[HttpStatusCode["Accepted"] = 202] = "Accepted";
    HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
    HttpStatusCode[HttpStatusCode["Found"] = 302] = "Found";
    HttpStatusCode[HttpStatusCode["NotModified"] = 304] = "NotModified";
    HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
    HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
    HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
    HttpStatusCode[HttpStatusCode["NotFound"] = 404] = "NotFound";
    HttpStatusCode[HttpStatusCode["UnsupportedMediaType"] = 406] = "UnsupportedMediaType";
    HttpStatusCode[HttpStatusCode["Conflict"] = 409] = "Conflict";
    HttpStatusCode[HttpStatusCode["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    HttpStatusCode[HttpStatusCode["ServerError"] = 500] = "ServerError";
    HttpStatusCode[HttpStatusCode["NotImplemented"] = 501] = "NotImplemented";
    HttpStatusCode[HttpStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpStatusCode[HttpStatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
    HttpStatusCode[HttpStatusCode["OriginIsUnreachable"] = 523] = "OriginIsUnreachable";
})(HttpStatusCode || (exports.HttpStatusCode = HttpStatusCode = {}));
class HttpError extends Error {
    constructor(status, type, title, detail = ''){
        super(`HTTP ${status} ${title}${detail ? ` (${typeof detail === 'string' ? detail : (0, serialization_1.jsonStringify)(detail)})` : ''}`);
        this.status = status;
        this.type = type;
        this.title = title;
        this.detail = detail;
    }
    toJSON() {
        const { status, title, detail, type } = this;
        return {
            status,
            title,
            detail,
            type
        };
    }
    toString() {
        return (0, serialization_1.jsonStringify)(this.toJSON());
    }
}
exports.HttpError = HttpError;
class GenericHttpError extends Error {
    constructor(status, body, headers){
        super();
        this.status = status;
        this.body = body;
        this.headers = headers;
    }
}
exports.GenericHttpError = GenericHttpError;

},{"e0770cfa2231b615":"j24dT"}],"3z9on":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isVaApplianceType = isVaApplianceType;
exports.isMatroxApplianceType = isMatroxApplianceType;
exports.isGenericVideoApplianceType = isGenericVideoApplianceType;
const types_1 = require("7eca050c61cf8b16");
function isVaApplianceType(applianceType) {
    return [
        types_1.ApplianceType.nimbraVA220,
        types_1.ApplianceType.nimbraVA225,
        types_1.ApplianceType.nimbra410,
        types_1.ApplianceType.nimbra412,
        types_1.ApplianceType.nimbra414,
        types_1.ApplianceType.nimbra414b,
        types_1.ApplianceType.nimbraVAdocker
    ].includes(applianceType);
}
function isMatroxApplianceType(applianceType) {
    return [
        types_1.ApplianceType.matroxMonarchEdgeE4_8Bit,
        types_1.ApplianceType.matroxMonarchEdgeE4_10Bit,
        types_1.ApplianceType.matroxMonarchEdgeD4,
        types_1.ApplianceType.matroxMonarchEdgeS1
    ].includes(applianceType);
}
function isGenericVideoApplianceType(applianceType) {
    return applianceType === types_1.ApplianceType.riversilica || applianceType === types_1.ApplianceType.nimbra204;
}

},{"7eca050c61cf8b16":"3qemx"}],"5XehL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UDP_HANDOVER_PORT_RANGE_END = exports.UDP_HANDOVER_PORT_RANGE_START = exports.UDP_TUNNEL_PORT_RANGE_END = exports.UDP_TUNNEL_PORT_RANGE_START = exports.TCP_THUMB_EDGE_CONTROL_HTTP_PORT = exports.TCP_EDGE_CONTROL_HTTP_PORT = void 0;
exports.isIpBasedProtocol = isIpBasedProtocol;
exports.isUdpBasedProtocol = isUdpBasedProtocol;
exports.isTcpBasedProtocol = isTcpBasedProtocol;
exports.getLocalPortFromPortDbConfiguration = getLocalPortFromPortDbConfiguration;
exports.getLocalPortNumbersUsedByInputPort = getLocalPortNumbersUsedByInputPort;
exports.getLocalPortNumbersUsedByOutputPort = getLocalPortNumbersUsedByOutputPort;
exports.getLocalPortNumbersUsedByInputProtocol = getLocalPortNumbersUsedByInputProtocol;
exports.getLocalPortNumbersUsedByOutputProtocol = getLocalPortNumbersUsedByOutputProtocol;
exports.physicalPortTypeMatchesPortMode = physicalPortTypeMatchesPortMode;
const helpers_1 = require("857edcb3deff8572");
const types_1 = require("d29e05c191fde1ec");
exports.TCP_EDGE_CONTROL_HTTP_PORT = 8081;
// TODO: We don't check for conflicts on the thumb port to be backwards compatible with potentially existing services.
// This could cause issues if the thumb appliance is located on the video node.
exports.TCP_THUMB_EDGE_CONTROL_HTTP_PORT = 8082;
// TODO: EDGE-4269: Use GlobalSettings.ristTunnelBasePort instead of UDP_TUNNEL_PORT_RANGE_START when checking for reserved ports.
exports.UDP_TUNNEL_PORT_RANGE_START = 20000;
exports.UDP_TUNNEL_PORT_RANGE_END = 20999;
exports.UDP_HANDOVER_PORT_RANGE_START = 30000;
exports.UDP_HANDOVER_PORT_RANGE_END = 30999;
function isIpBasedProtocol(mode) {
    return mode in types_1.IpPortMode;
}
function isUdpBasedProtocol(mode) {
    return isIpBasedProtocol(mode) && !isTcpBasedProtocol(mode);
}
function isTcpBasedProtocol(mode) {
    return mode === types_1.IpPortMode.rtmp;
}
function getLocalPortFromPortDbConfiguration(configuration) {
    // Rendezvous 'remotePort' is also the local listen port
    if ('remotePort' in configuration && 'srtMode' in configuration && configuration.srtMode === types_1.SrtMode.rendezvous) return configuration.remotePort;
    if ('localPort' in configuration && configuration.localPort) return configuration.localPort;
    return 0;
}
function getLocalPortNumbersUsedByInputPort(port) {
    let localBasePort = undefined;
    switch(port.mode){
        case types_1.IpPortMode.generator:
            if (typeof port.port === 'number') localBasePort = port.port;
            break;
        case types_1.IpPortMode.udp:
        case types_1.IpPortMode.rtp:
        case types_1.IpPortMode.rist:
        case types_1.IpPortMode.rtmp:
            localBasePort = port.port;
            break;
        case types_1.IpPortMode.srt:
            switch(port.srtMode){
                case types_1.SrtMode.rendezvous:
                    localBasePort = port.remotePort;
                    break;
                case types_1.SrtMode.caller:
                case types_1.SrtMode.listener:
                    localBasePort = port.localPort;
                    break;
            }
            break;
    }
    return localBasePort ? getLocalPortNumbersUsedByInputProtocol({
        mode: port.mode,
        localBasePort,
        isFec: 'fec' in port && !!port.fec,
        isRtcp: port.mode === types_1.IpPortMode.rtp && port.rtcp === true,
        isMulticast: 'multicastAddress' in port && !!port.multicastAddress
    }) : [];
}
function getLocalPortNumbersUsedByOutputPort(port) {
    let localBasePort = undefined;
    switch(port.mode){
        case types_1.IpPortMode.rtp:
        case types_1.IpPortMode.udp:
        case types_1.IpPortMode.rist:
            localBasePort = port.localPort;
            break;
        case types_1.IpPortMode.srt:
            switch(port.srtMode){
                case types_1.SrtMode.rendezvous:
                    localBasePort = port.remotePort;
                    break;
                case types_1.SrtMode.caller:
                case types_1.SrtMode.listener:
                    localBasePort = port.localPort;
                    break;
            }
            break;
    }
    return localBasePort ? getLocalPortNumbersUsedByOutputProtocol({
        mode: port.mode,
        localBasePort
    }) : [];
}
function getLocalPortNumbersUsedByInputProtocol(port) {
    const portNumbers = new Set();
    switch(port.mode){
        case types_1.IpPortMode.rist:
            portNumbers.add(port.localBasePort);
            portNumbers.add(port.localBasePort + 1); // RTCP
            break;
        case types_1.IpPortMode.udp:
            // EDGE-4003: Don't check for conflicts against multicast ports
            if (!port.isMulticast) portNumbers.add(port.localBasePort);
            break;
        case types_1.IpPortMode.rtp:
            // EDGE-4003: Don't check for conflicts against multicast ports
            if (!port.isMulticast) {
                portNumbers.add(port.localBasePort);
                if (port.isRtcp) portNumbers.add(port.localBasePort + 1);
                if (port.isFec) {
                    portNumbers.add(port.localBasePort + 2);
                    portNumbers.add(port.localBasePort + 4);
                }
            }
            break;
        case types_1.IpPortMode.rtmp:
        case types_1.IpPortMode.srt:
        case types_1.IpPortMode.generator:
            portNumbers.add(port.localBasePort);
            break;
    }
    return Array.from(portNumbers);
}
function getLocalPortNumbersUsedByOutputProtocol(port) {
    const portNumbers = new Set();
    switch(port.mode){
        case types_1.IpPortMode.udp:
        case types_1.IpPortMode.rtp:
        case types_1.IpPortMode.srt:
        case types_1.IpPortMode.rist:
            portNumbers.add(port.localBasePort);
            break;
    }
    return Array.from(portNumbers);
}
function physicalPortTypeMatchesPortMode(physicalPortType, mode) {
    switch(physicalPortType){
        case types_1.PortType.coax:
            return mode in types_1.CoaxPortMode || mode in types_1.MatroxPortMode || mode === types_1.ComprimatoPortMode.comprimatoSdi;
        case types_1.PortType.ndi:
            return mode === types_1.ComprimatoPortMode.comprimatoNdi;
        case types_1.PortType.videon:
            return mode in types_1.VideonPortMode;
        case types_1.PortType.ip:
            return (0, helpers_1.isIpPortMode)(mode);
    }
}

},{"857edcb3deff8572":"6jovr","d29e05c191fde1ec":"3qemx"}],"dUez3":[function(require,module,exports,__globalThis) {
/* eslint eqeqeq: 'off' */ /* eslint no-param-reassign: 'off' */ /*

The MIT License (MIT)

Copyright (c) 2015 Chris Corbyn.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/ 'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Addrv4 = void 0;
exports.getOverlappingCidrBlocks = getOverlappingCidrBlocks;
/*! The address used when not specified */ const DEFAULT_ADDRESS = 0;
/*! The prefix length used when not specified */ const DEFAULT_PREFIX = 32;
/*! The lowest permissible address */ const MIN_ADDRESS = 0;
/*! The highest permissible address */ const MAX_ADDRESS = 0xffffffff;
function getOverlappingCidrBlocks(cidrBlocks) {
    for(let i = 0; i < cidrBlocks.length; ++i)for(let j = 0; j < cidrBlocks.length; ++j){
        if (i === j) continue;
        const cidr1 = cidrBlocks[i];
        const cidr2 = cidrBlocks[j];
        const addr1 = Addrv4.make(cidr1);
        const addr2 = Addrv4.make(cidr2);
        const isOverlappingCidrBlocks = addr1.intersect(addr2) !== undefined;
        if (isOverlappingCidrBlocks) return {
            cidr1: addr1,
            cidr2: addr2
        };
    }
    return undefined;
}
class Addrv4 {
    /**
     * Representation of an IPv4 address or CIDR.
     *
     * For convenience, this constructor may be invoked as a regular function.
     *
     * @constructor
     *
     * @param {Object} address
     *   either a string or an integer
     *
     * @param {Number} prefix, optional
     *   the length of the netmask prefix
     *
     * @throws {Error}
     *   if the address is not valid
     */ static make(address, prefix) {
        try {
            switch(typeof address){
                case 'undefined':
                    return Addrv4.make(DEFAULT_ADDRESS, prefix);
                case 'string':
                    return Addrv4.parseString(address, prefix);
                case 'number':
                    return Addrv4.parseNumber(address, prefix);
                default:
                    throw new Error(`Invalid Addr type: ${typeof address}`);
            }
        } catch (e) {
            throw new Error(`Invalid Addr: ${address}: ${e.toString()}`);
        }
    }
    /*! Parse an IPv4 address string with optional prefix */ static parseString(address, prefix) {
        const parts = address.split('/');
        if (parts.length > 2) throw new Error(`Invalid Addr: ${address}`);
        const octets = parts[0].split('.').map((n)=>Addrv4.parseByte(n, 255));
        const intval = Addrv4.octetsToInt(octets);
        const prefixByte = Addrv4.parseByte(typeof prefix === 'undefined' ? parts[1] || DEFAULT_PREFIX.toString() : prefix.toString(), 32);
        return new Addrv4(intval, octets, prefixByte);
    }
    /*! Parse an IPv4 address integer with optional prefix */ static parseNumber(address, prefix) {
        if (address > MAX_ADDRESS || address < MIN_ADDRESS) throw new Error(`Invalid Addrv4 ${address}`);
        const octets = [
            255,
            255,
            255,
            255
        ].map(function(octet, offset) {
            return address >>> offset * 8 & octet;
        }).reverse();
        const intval = Addrv4.octetsToInt(octets);
        const prefixByte = Addrv4.parseByte(typeof prefix === 'undefined' ? DEFAULT_PREFIX.toString() : prefix.toString(), 32);
        return new Addrv4(intval, octets, prefixByte);
    }
    constructor(intval, octets, prefix){
        this.intval = intval;
        this.octets = octets;
        this.prefix = prefix;
        this.octets;
    }
    /*! Convert the given octets to an integer */ static octetsToInt(octets) {
        return [
            ...octets
        ].reverse().map(function(octet, offset) {
            return octet * (1 << offset * 8);
        }).reduce(function(x, y) {
            return x + y;
        });
    }
    /**
     * Perform a parseInt(), only if a valid byte value with an optional max.
     *
     * @param {String} n
     *   the value to parse
     *
     * @param {Number} max
     *   the maximum allowed value
     *
     * @return {Number}
     *   the parsed integer
     */ static parseByte(n, max) {
        max = max || 255;
        if (/^[0-9]+$/.test(n)) {
            const m = parseInt(n);
            if (m <= max) return m;
        }
        throw new Error(`${n}: must be a decimal value <= ${max}`);
    }
    /**
     * Return the CIDR range that is the intersection of `this` and `other`.
     *
     * Because CIDR subnets cannot possibly partially overlap, in practice this
     * method returns either `this` or `other` where there is a match. The
     * returned Addrv4 will always be the smallest range.
     *
     * @param {Addrv4} other
     *   another Addrv4 to intersect with
     *
     * @return {Addrv4}
     *   the intersection of the two Addrv4, or undefined if not possible
     */ intersect(other) {
        return this.contains(other) && other || other.contains(this) && this || undefined;
    }
    /**
     * Return true if this Addrv4 completely contains another Addrv4.
     *
     * @param {Addrv4} other
     *   the other Addrv4 to check
     *
     * @return {Boolean}
     *   true if other is a subset of this, false if not
     */ contains(other) {
        return this.onNetwork(other.network()) && this.onNetwork(other.broadcast());
    }
    /*! Return true if a fixed IP is on this network */ onNetwork(ip) {
        return (this.netmask().toInt() & ip.toInt()) >>> 0 == this.network().toInt();
    }
    /**
     * Return the broadcast address from this Addr.
     *
     * This equates to the last address in the CIDR range.
     *
     * @return {Number}
     *   the broadcast address
     */ broadcast() {
        return Addrv4.make((this.network().toInt() | ~this.netmask().toInt()) >>> 0);
    }
    /**
     * Return the network address from this Addrv4.
     *
     * This equates to the first address in the CIDR range.
     *
     * @return {Addrv4}
     *   the network address
     */ network() {
        return Addrv4.make((this.toInt() & this.netmask().toInt()) >>> 0);
    }
    /**
     * Return the integer representation of this Addrv4.
     *
     * @return {Number}
     *   the integer value of the Addrv4
     */ toInt() {
        return this.intval;
    }
    /**
     * Return the netmask value for this Addrv4.
     *
     * @return {Addrv4}
     *   the netmask
     */ netmask() {
        switch(this.prefix){
            case 0:
                return Addrv4.make(0x00000000);
            case 32:
                return Addrv4.make(0xffffffff);
            default:
                return Addrv4.make(~(0xffffffff >>> this.prefix) >>> 0);
        }
    }
    /**
     * Return the string representation of this Addr.
     *
     * @return {String}
     *   the string representation, including the mask
     */ toString() {
        return [
            this.octets.join('.'),
            this.prefix
        ].join('/');
    }
}
exports.Addrv4 = Addrv4;

},{}],"2AqiH":[function(require,module,exports,__globalThis) {
var Buffer = require("9bf96bf0e324064f").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.distinct = void 0;
exports.inputRedundancy = inputRedundancy;
exports.whitelistCidrBlockToArray = whitelistCidrBlockToArray;
exports.edgifyVaTr101 = edgifyVaTr101;
exports.group = group;
exports.canonicalizePortConfig = canonicalizePortConfig;
exports.formatVaSmpte2038 = formatVaSmpte2038;
exports.pick = pick;
exports.pickNonNullish = pickNonNullish;
exports.valuesToString = valuesToString;
exports.generateRandomMacAddress = generateRandomMacAddress;
exports.execAsync = execAsync;
exports.parseK8sMemoryString = parseK8sMemoryString;
const canonicalize_1 = require("8cf7e96650c44a39");
const child_process_1 = require("4ce23a9bed9dc5c1");
function inputRedundancy({ ports }) {
    return (ports && ports[0] && ports[0].copies || 1) > 1;
}
function whitelistCidrBlockToArray(whitelistCidrBlock) {
    return whitelistCidrBlock && whitelistCidrBlock.length > 0 ? [
        whitelistCidrBlock
    ].flat() : [];
}
function edgifyVaTr101(tr101) {
    return {
        prio1: {
            TS_sync_loss: tr101.prio1['1'].count,
            Sync_byte_error: tr101.prio1['2'].count,
            PAT_error: tr101.prio1['3'].count,
            Continuity_count_error: tr101.prio1['5'].count,
            PMT_error: tr101.prio1['6'].count,
            PID_error: tr101.prio1['8'].count
        },
        prio2: {
            Transport_error: tr101.prio2['1'].count,
            CRC_error: tr101.prio2['2'].count,
            PCR_error: tr101.prio2['3'].count,
            PCR_accuracy_error: tr101.prio2['6'].count,
            PTS_error: tr101.prio2['7'].count,
            CAT_error: tr101.prio2['8'].count
        }
    };
}
function group(items, selector) {
    return items.reduce((acc, cur)=>{
        const v = selector(cur);
        if (typeof acc[v] === 'undefined') acc[v] = [];
        acc[v].push(cur);
        return acc;
    }, {});
}
function canonicalizePortConfig(p) {
    return (0, canonicalize_1.canonicalize)({
        ...p,
        meta: void 0
    });
}
function formatVaSmpte2038(smpte2038) {
    const anc = Object.keys(smpte2038).reduce((acc, setting)=>{
        acc[setting] = Object.keys(smpte2038[setting]).reduce((settingObj, flag)=>{
            // eslint-disable-next-line no-param-reassign
            settingObj[flag] = smpte2038[setting][flag] ? 'yes' : 'no';
            return settingObj;
        }, {});
        return acc;
    }, {});
    return anc;
}
function pick(t, ...pickKeys) {
    if (!t) return t;
    const o = {};
    for (const k of pickKeys)o[k] = t[k];
    return o;
}
function pickNonNullish(t, ...pickKeys) {
    const o = {};
    for (const k of pickKeys){
        const val = t[k];
        if (val == null) continue;
        o[k] = t[k];
    }
    return o;
}
function valuesToString(t) {
    const v = {};
    for (const k of Object.keys(t))v[k] = `${t[k]}`;
    return v;
}
function generateRandomMacAddress() {
    return 'XX:XX:XX:XX:XX:XX'.replace(/X/g, ()=>Math.floor(Math.random() * 16).toString(16));
}
function maybeBufferToUtf8(b) {
    if (Buffer.isBuffer(b)) return b.toString('utf8');
    return b;
}
function execAsync(cmd, opts = {}) {
    return new Promise((res)=>{
        (0, child_process_1.exec)(cmd, opts, (err, stdout, stderr)=>{
            if (err) return res([
                err,
                null
            ]);
            return res([
                null,
                {
                    stdout: maybeBufferToUtf8(stdout),
                    stderr: maybeBufferToUtf8(stderr)
                }
            ]);
        });
    });
}
const distinct = (array, equals = (v1, v2)=>v1 === v2)=>{
    return array.reduce((acc, cur)=>{
        if (!acc.find((v)=>equals(v, cur))) acc.push(cur);
        return acc;
    }, []);
};
exports.distinct = distinct;
/**
 * k8sMemoryParser parses k8s memory string to bytes
 * @param input - string to parse
 * @returns number - parsed bytes
 * @example
 * k8sMemoryParser('1Gi') // 1073741824
 * k8sMemoryParser('1G') // 1000000000
 * k8sMemoryParser('1M') // 1000000
 * k8sMemoryParser('1024') // 1024
 */ function parseK8sMemoryString(input) {
    const memoryMultipliers = {
        '': 1,
        k: 1000,
        M: 1000 ** 2,
        G: 1000 ** 3,
        T: 1000 ** 4,
        P: 1000 ** 5,
        E: 1000 ** 6,
        Ki: 1024,
        Mi: 1024 ** 2,
        Gi: 1024 ** 3,
        Ti: 1024 ** 4,
        Pi: 1024 ** 5,
        Ei: 1024 ** 6
    };
    const index = input.search(/[a-zA-Z]/);
    const number = input.slice(0, index);
    const unit = input.slice(index);
    if (index === -1) return parseInt(input, 10);
    if (unit in memoryMultipliers) return parseInt(number, 10) * memoryMultipliers[unit];
    return NaN;
}

},{"9bf96bf0e324064f":"dB11O","8cf7e96650c44a39":"6YrYz","4ce23a9bed9dc5c1":"aBjM4"}],"dB11O":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"ettWx","aceacb6a4531a9d2":"6DXND"}],"ettWx":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"6DXND":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"aBjM4":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"7DOrW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styles", ()=>styles);
var _styles = require("@mui/material/styles");
const styles = {
    success: (theme)=>({
            backgroundColor: (0, _styles.darken)(theme.palette.success.light, 0.5),
            color: theme.palette.common.white
        }),
    warning: (theme)=>({
            backgroundColor: theme.palette.warning.light,
            color: theme.palette.common.black
        }),
    error: (theme)=>({
            backgroundColor: (0, _styles.darken)(theme.palette.error.light, 0.5),
            color: theme.palette.common.white
        }),
    info: (theme)=>({
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.getContrastText(theme.palette.background.paper),
            border: `1px solid ${theme.palette.grey[700]}`
        }),
    rotating: {
        animation: 'spin 2s linear infinite',
        '@keyframes spin': {
            '100%': {
                transform: 'rotate(-360deg)'
            }
        }
    }
};

},{"@mui/material/styles":"2UrBk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bJaMG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Login", ()=>Login);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _cssBaseline = require("@mui/material/CssBaseline");
var _cssBaselineDefault = parcelHelpers.interopDefault(_cssBaseline);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _container = require("@mui/material/Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _styles = require("@mui/material/styles");
var _errors = require("common/errors");
var _loading = require("../common/Loading");
var _userActions = require("../../redux/actions/userActions");
var _logoFetcher = require("../common/LogoFetcher");
var _types = require("common/api/v1/types");
var _notificationActions = require("../../redux/actions/notificationActions");
const Form = (0, _styles.styled)('form')(({ theme })=>({
        width: '100%',
        marginTop: theme.spacing(1)
    }));
const styles = {
    paper: {
        marginTop: (theme)=>theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    submit: {
        margin: (theme)=>theme.spacing(3, 0, 2)
    }
};
const commonInputProps = {
    variant: 'outlined',
    margin: 'normal',
    required: true,
    fullWidth: true,
    InputLabelProps: {
        shrink: true
    }
};
const ErrorHelper = ({ shown })=>shown ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
        error: true,
        variant: "filled",
        children: "Your authentication information is incorrect."
    }) : null;
const Login = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { loading, loginFail } = (0, _reactRedux.useSelector)((state)=>({
            loading: state.userReducer.loading,
            loginFail: state.userReducer.loginFail
        }), (0, _reactRedux.shallowEqual));
    const isMFARequired = loginFail?.details === (0, _errors.errorTitle)((0, _errors.ErrorCode).mfaRequired);
    const [user, setUser] = (0, _react.useState)({
        username: '',
        password: ''
    });
    const [ssoLoginMethods, setSsoLoginMethods] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        const fetchLoginMethods = async ()=>{
            try {
                const res = await dispatch((0, _userActions.getLoginMethods)()) // Await the async action dispatch
                ;
                setSsoLoginMethods(res?.payload || []);
            } catch  {
                setSsoLoginMethods([]);
            }
        };
        fetchLoginMethods();
        handleSsoCallback();
    }, [
        dispatch
    ]);
    const handleLogin = (e)=>{
        e.preventDefault();
        dispatch((0, _userActions.loginUser)(user));
        setUser({
            ...user,
            otp: undefined
        });
    };
    const handleSsoLogin = (ssoStrategy)=>{
        window.location.href = `/api/sso/${ssoStrategy}`;
    };
    const handleSsoCallback = ()=>{
        const params = new URLSearchParams(window.location.search);
        const errorInfo = params.get('ssoerror');
        if (errorInfo) {
            dispatch((0, _notificationActions.enqueueSnackbar)({
                message: errorInfo,
                type: 'fatalError',
                data: {
                    text: 'SSO Login failed',
                    details: errorInfo,
                    httpStatusCode: 0
                },
                options: {
                    variant: 'error',
                    persist: true
                }
            }));
            history.pushState({}, '', '/');
        }
        if (params.has('ssologin')) {
            dispatch((0, _userActions.fetchCurrentUser)())?.then(()=>{
                history.pushState({}, '', '/');
            });
            return;
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _containerDefault.default), {
        component: "main",
        maxWidth: "xs",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cssBaselineDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loading.Loading), {
                loading: loading
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: styles.paper,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoFetcher.LoginLogo), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "h1",
                        variant: "h5",
                        children: "Sign in"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Form, {
                        noValidate: true,
                        onSubmit: handleLogin,
                        children: [
                            !isMFARequired ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                        ...commonInputProps,
                                        value: user.username,
                                        onChange: (e)=>setUser({
                                                ...user,
                                                username: e.target.value
                                            }),
                                        id: "email",
                                        label: "Email Address",
                                        autoComplete: "email",
                                        autoFocus: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                        ...commonInputProps,
                                        value: user.password,
                                        onChange: (e)=>setUser({
                                                ...user,
                                                password: e.target.value
                                            }),
                                        label: "Password",
                                        type: "password",
                                        id: "password",
                                        autoComplete: "current-password"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                ...commonInputProps,
                                onChange: (e)=>setUser({
                                        ...user,
                                        otp: e.target.value
                                    }),
                                id: "mfacode",
                                label: "MFA code",
                                autoComplete: "one-time-code",
                                autoFocus: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ErrorHelper, {
                                shown: loginFail !== undefined && !isMFARequired
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                id: "login-button",
                                type: "submit",
                                fullWidth: true,
                                variant: "contained",
                                color: "primary",
                                sx: styles.submit,
                                disabled: !user.username || !user.password || isMFARequired && !user.otp,
                                children: "Sign In"
                            })
                        ]
                    }),
                    ssoLoginMethods?.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop: 2,
                                    marginBottom: 2,
                                    width: '80%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        sx: {
                                            flex: 1,
                                            height: '1px',
                                            bgcolor: 'grey.500'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        variant: "body1",
                                        sx: {
                                            marginX: 2
                                        },
                                        children: "or sign in with"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        sx: {
                                            flex: 1,
                                            height: '1px',
                                            bgcolor: 'grey.500'
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: 2
                                },
                                children: ssoLoginMethods.filter((m)=>Object.values((0, _types.SsoStrategy)).includes(m.strategy)).map((ssoLoginMethod)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        "data-testid": `sso-${ssoLoginMethod.strategy}`,
                                        variant: "outlined",
                                        color: "secondary",
                                        onClick: ()=>handleSsoLogin(ssoLoginMethod.strategy),
                                        fullWidth: true,
                                        children: ssoLoginMethod.displayName
                                    }, ssoLoginMethod.strategy))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/CssBaseline":"armer","@mui/material/TextField":"l88b4","@mui/material/Typography":"6NtGx","@mui/material/Container":"376wa","@mui/material/FormHelperText":"9uvlb","@mui/material/styles":"2UrBk","common/errors":"lwLel","../common/Loading":"crGi4","../../redux/actions/userActions":"2tWgd","../common/LogoFetcher":"e3yqy","common/api/v1/types":"3qemx","../../redux/actions/notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"armer":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5485d59ac3181381").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _CssBaseline.default;
    }
});
var _CssBaseline = _interopRequireDefault(require("12cfc915d936505a"));

},{"5485d59ac3181381":"kZ6eK","12cfc915d936505a":"ePpli"}],"ePpli":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("af67959fb50c28d9").default;
var _interopRequireWildcard = require("b1a1bc76961191fb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.styles = exports.html = exports.default = exports.body = void 0;
var React = _interopRequireWildcard(require("e99dfb0527cad6a9"));
var _propTypes = _interopRequireDefault(require("b09d7ef38d95b137"));
var _zeroStyled = require("83a8e06459833f81");
var _DefaultPropsProvider = require("54b28fdb8e69fedf");
var _jsxRuntime = require("db27be6144e89923");
// to determine if the global styles are static or dynamic
const isDynamicSupport = typeof (0, _zeroStyled.globalCss)({}) === 'function';
const html = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
exports.html = html;
const body = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
exports.body = body;
const styles = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: html(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...body(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
exports.styles = styles;
const SELECTOR = 'mui-ecs';
const staticStyles = (theme)=>{
    const result = styles(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const GlobalStyles = (0, _zeroStyled.globalCss)(isDynamicSupport ? ({ theme, enableColorScheme })=>styles(theme, enableColorScheme) : ({ theme })=>staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function CssBaseline(inProps) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children, enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            isDynamicSupport && /*#__PURE__*/ (0, _jsxRuntime.jsx)(GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var _default = exports.default = CssBaseline;

},{"af67959fb50c28d9":"kZ6eK","b1a1bc76961191fb":"fiRIh","e99dfb0527cad6a9":"9njXz","b09d7ef38d95b137":"bnNSm","83a8e06459833f81":"hZXDo","54b28fdb8e69fedf":"9bD8g","db27be6144e89923":"1dlk8"}],"376wa":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("2a3fee8a4658aa45").default;
var _interopRequireDefault = require("432320ff99417c05").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    containerClasses: true
};
Object.defineProperty(exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return _containerClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Container.default;
    }
});
var _Container = _interopRequireDefault(require("8ad66a709cc33d7"));
var _containerClasses = _interopRequireWildcard(require("ed4ffc6a97a31493"));
Object.keys(_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _containerClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _containerClasses[key];
        }
    });
});

},{"2a3fee8a4658aa45":"fiRIh","432320ff99417c05":"kZ6eK","8ad66a709cc33d7":"cIDQi","ed4ffc6a97a31493":"bly4X"}],"cIDQi":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("d305b0d213647fa1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("14a0e4b37cf11224"));
var _system = require("137589d834ae7041");
var _capitalize = _interopRequireDefault(require("66923b280cf2be04"));
var _styled = _interopRequireDefault(require("19d4b99fbd4dda8a"));
var _DefaultPropsProvider = require("ed814b43cc6828db");
const Container = (0, _system.createContainer)({
    createStyledComponent: (0, _styled.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, _capitalize.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, _DefaultPropsProvider.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var _default = exports.default = Container;

},{"d305b0d213647fa1":"kZ6eK","14a0e4b37cf11224":"bnNSm","137589d834ae7041":"iFfXs","66923b280cf2be04":"eOYSA","19d4b99fbd4dda8a":"iVEGR","ed814b43cc6828db":"9bD8g"}],"bly4X":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d87d1793d1da562d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getContainerUtilityClass = getContainerUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("11453d66e7e13508"));
var _generateUtilityClass = _interopRequireDefault(require("f354cb02905fed3f"));
function getContainerUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiContainer', slot);
}
const containerClasses = (0, _generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var _default = exports.default = containerClasses;

},{"d87d1793d1da562d":"kZ6eK","11453d66e7e13508":"7pSUk","f354cb02905fed3f":"jBs9M"}],"crGi4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Loading", ()=>Loading);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _modal = require("@mui/material/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
const styles = {
    layout: (theme)=>({
            position: 'relative',
            width: 'auto',
            display: 'block',
            marginLeft: theme.spacing(3),
            marginRight: theme.spacing(3),
            outline: 0,
            [theme.breakpoints.up(400 + parseInt(theme.spacing(6).slice(0, -2)))]: {
                width: 400,
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        }),
    progressBox: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 0
    },
    progress: {
        margin: (theme)=>theme.spacing(2),
        outline: 0
    }
};
const Loading = ({ loading = false })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        open: loading,
        sx: styles.layout,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.progressBox,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                sx: styles.progress
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","@mui/material/CircularProgress":"kEtIR","@mui/material/Modal":"6Q8b8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2tWgd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loginUser", ()=>loginUser);
parcelHelpers.export(exports, "loginCurrentUser", ()=>loginCurrentUser);
parcelHelpers.export(exports, "setAuthorizationError", ()=>setAuthorizationError);
parcelHelpers.export(exports, "createUser", ()=>createUser);
parcelHelpers.export(exports, "updateUser", ()=>updateUser);
parcelHelpers.export(exports, "removeUser", ()=>removeUser);
parcelHelpers.export(exports, "saveUserSettings", ()=>saveUserSettings);
parcelHelpers.export(exports, "logoutAndNavigateToMainPage", ()=>logoutAndNavigateToMainPage);
parcelHelpers.export(exports, "logoutUser", ()=>logoutUser);
parcelHelpers.export(exports, "impersonateUser", ()=>impersonateUser);
parcelHelpers.export(exports, "stopImpersonation", ()=>stopImpersonation);
parcelHelpers.export(exports, "getLoginMethods", ()=>getLoginMethods);
parcelHelpers.export(exports, "getUsers", ()=>getUsers);
parcelHelpers.export(exports, "fetchCurrentUser", ()=>fetchCurrentUser);
parcelHelpers.export(exports, "getSsoMetadataSaml", ()=>getSsoMetadataSaml);
parcelHelpers.export(exports, "getSsoMetadataOidc", ()=>getSsoMetadataOidc);
var _toolkit = require("@reduxjs/toolkit");
var _types = require("common/api/v1/types");
var _applianceActions = require("./applianceActions");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
var _localstorage = require("../../localstorage");
var _applicationException = require("../../api/ApplicationException");
var _mixpanel = require("../../mixpanel");
const loginUser = (0, _toolkit.createAsyncThunk)('user/login', async ({ username, password, otp }, { dispatch, extra: { api } })=>{
    try {
        const enrichedUser = await api.userApi.loginUser(username, password, otp);
        const userSettings = await api.userApi.getUserSettings(enrichedUser.id).catch((error)=>{
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: (0, _applicationException.makeApplicationException)(error)
            }));
            // We don't want to prevent the user from logging in if getUserSettings() for some reason fails.
            // Should not happen but better safe than sorry...?
            return {
                alarm: {
                    notificationsEnabled: true
                }
            };
        });
        const user = {
            ...enrichedUser,
            settings: userSettings
        };
        const queryParams = new URLSearchParams(window.location.search);
        const redirect = queryParams.get('rd');
        if (redirect) window.open(redirect);
        // Store logged in user in local storage to support user refreshing the page without having to log in again
        (0, _localstorage.saveState)({
            userReducer: {
                user
            }
        });
        setTimeout(()=>{
            dispatch((0, _applianceActions.initAppliance)());
        }, 0) // Run after this thunk has finished to let reducers run and set user
        ;
        dispatch(setAuthorizationError(undefined));
        return user;
    } catch (err) {
        const { errorInfo } = err;
        errorInfo?.errorCode === '401' ? dispatch(setAuthorizationError(errorInfo)) : dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: new (0, _applicationException.ApplicationException)(errorInfo)
        }));
        throw errorInfo;
    }
});
const loginCurrentUser = (0, _toolkit.createAsyncThunk)('user/loginCurrentUser', async (_, { dispatch, extra: { api } })=>{
    try {
        const user = await api.userApi.getCurrentEnrichedUser();
        const queryParams = new URLSearchParams(window.location.search);
        const redirect = queryParams.get('rd');
        if (redirect) window.open(redirect);
        (0, _localstorage.saveState)({
            userReducer: {
                user
            }
        });
        setTimeout(()=>{
            dispatch((0, _applianceActions.initAppliance)());
        }, 0) // Run after this thunk has finished to let reducers run and set user
        ;
        dispatch(setAuthorizationError(undefined));
        return user;
    } catch (err) {
        const { errorInfo } = err;
        errorInfo?.errorCode === '401' ? dispatch(setAuthorizationError(errorInfo)) : dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: new (0, _applicationException.ApplicationException)(errorInfo)
        }));
        throw errorInfo;
    }
});
const setAuthorizationError = (0, _toolkit.createAction)('user/setAuthorizationError');
const createUser = (0, _toolkit.createAsyncThunk)('user/createUser', async (user, { dispatch, extra: { api, navigate, routes } })=>{
    try {
        await api.userApi.createUser(user);
        navigate()(routes.users());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Added new User: ${user.username}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'create user'
        }));
        throw err;
    }
});
const updateUser = (0, _toolkit.createAsyncThunk)('user/updateUser', async (user, { dispatch, extra: { api, navigate, routes } })=>{
    try {
        await api.userApi.updateUser(user);
        navigate()(routes.users());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Edited User: ${user.username}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update user'
        }));
        throw err;
    }
});
const removeUser = async (user, { dispatch, userApi, navigate, routes, refreshUsers })=>{
    try {
        await userApi.removeUser(user.id);
        if (refreshUsers) refreshUsers();
        else navigate(routes.users());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Removed User: ${user.username}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'delete user'
        }));
        throw {
            error: err,
            userID: user.id
        };
    }
};
const saveUserSettings = (0, _toolkit.createAsyncThunk)('user/saveUserSettings', async (payload, { dispatch, extra: { api: { userApi } } })=>{
    try {
        await userApi.setUserSettings(payload.userId, payload.settings);
        await dispatch(fetchCurrentUser());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Updated user settings`));
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'update user settings'
        }));
        throw error;
    }
});
const logoutAndNavigateToMainPage = (0, _toolkit.createAsyncThunk)('user/logoutAndNavigateToMainPage', async (_, { dispatch })=>{
    await dispatch(logoutUser()) // logoutUser needs to run in order for reducers to run before
    ;
    // eslint-disable-next-line @typescript-eslint/await-thenable
    await dispatch((0, _notificationActions.closeAllSnackbars)());
    await dispatch(navigateToMainOnUserLogout());
});
const logoutUser = (0, _toolkit.createAsyncThunk)('user/logoutUser', async (_, { extra: { api } })=>{
    await api.userApi.logoutUser();
    (0, _localstorage.clearState)();
    (0, _mixpanel.mixpanel).reset();
});
const impersonateUser = (0, _toolkit.createAsyncThunk)('user/impersonateUser', async (userId, { dispatch, extra: { api, navigate, routes } })=>{
    try {
        const user = await api.userApi.impersonateUser(userId);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Logged in as ${user.username}`));
        (0, _localstorage.saveState)({
            userReducer: {
                user
            }
        });
        navigate()(user.role === (0, _types.Role).basic ? routes.stream() : routes.overview());
        return user;
    } catch (err) {
        // api.impersonateUser() performs multiple requests.
        // If the first request (impersonateUser) succeeds the edgeToken request cookie will be updated to the impersonated user.
        // If then one of the subsequent requests fails an error is thrown and the impersonation operation is aborted,
        // but the edgeToken cookie is still the impersonated one and will incorrectly be used in all future requests.
        // Solution: explicitly stop impersonation upon failure.
        dispatch(stopImpersonation({
            showSuccessSnackbar: false
        }));
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'impersonate user'
        }));
        throw err;
    }
});
const stopImpersonation = (0, _toolkit.createAsyncThunk)('user/stopImpersonation', async (args, { dispatch, extra: { api, navigate, routes } })=>{
    try {
        const user = await api.userApi.stopImpersonation();
        if (args.showSuccessSnackbar) dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Switched back to ${user.username}`));
        (0, _localstorage.saveState)({
            userReducer: {
                user
            }
        });
        navigate()(user.role === (0, _types.Role).basic ? routes.stream() : routes.overview());
        return user;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'switch back to impersonator'
        }));
        throw err;
    }
});
const navigateToMainOnUserLogout = (0, _toolkit.createAsyncThunk)('user/navigateToMainOnUserLogout', async (_, { extra: { navigate } })=>{
    navigate()('/');
});
const getLoginMethods = (0, _toolkit.createAsyncThunk)('user/getLoginMethods', async (_, { dispatch, extra: { api } })=>{
    return await api.userApi.getLoginMethods().catch((err)=>{
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch login methods'
        }));
        throw err;
    });
});
const getUsers = async (params, { dispatch, userApi })=>{
    try {
        return await userApi.getUsers((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch users'
        }));
        throw err;
    }
};
const fetchCurrentUser = (0, _toolkit.createAsyncThunk)('user/current-user/fetch', async (_, { dispatch, extra: { api } })=>{
    try {
        const user = await api.userApi.getCurrentEnrichedUser();
        (0, _localstorage.saveState)({
            userReducer: {
                user
            }
        });
        return user;
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch current-user'
        }));
        throw err;
    }
});
const getSsoMetadataSaml = (0, _toolkit.createAsyncThunk)('sso/getSamlMetadata', async (url, { dispatch, extra: { api } })=>{
    try {
        return await api.userApi.getSsoMetadataDataSaml(url);
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch saml metadata'
        }));
        throw err;
    }
});
const getSsoMetadataOidc = (0, _toolkit.createAsyncThunk)('sso/getSamlMetadata', async (url, { dispatch, extra: { api } })=>{
    try {
        return await api.userApi.getSsoMetadataDataOidc(url);
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch oidc metadata'
        }));
        throw err;
    }
});

},{"@reduxjs/toolkit":"8ces8","common/api/v1/types":"3qemx","./applianceActions":"TaoIu","./notificationActions":"7LkQg","../../utils":"342UB","../../localstorage":"7NDOS","../../api/ApplicationException":"5oMBs","../../mixpanel":"7xxdr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7NDOS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOCAL_STORAGE_TAGS_HISTORY_KEY", ()=>LOCAL_STORAGE_TAGS_HISTORY_KEY);
parcelHelpers.export(exports, "LOCAL_STORAGE_UI_SNACKBAR_ERROR_POSITION_KEY", ()=>LOCAL_STORAGE_UI_SNACKBAR_ERROR_POSITION_KEY);
parcelHelpers.export(exports, "loadState", ()=>loadState);
parcelHelpers.export(exports, "saveState", ()=>saveState);
parcelHelpers.export(exports, "clearState", ()=>clearState);
parcelHelpers.export(exports, "getItem", ()=>getItem);
const EDGE_STATE_KEY = 'edge-state';
const LOCAL_STORAGE_TAGS_HISTORY_KEY = 'edge.tags.history';
const LOCAL_STORAGE_UI_SNACKBAR_ERROR_POSITION_KEY = 'edge.ui.snackbar.error.position';
const loadState = ()=>{
    try {
        const serializedState = localStorage.getItem(EDGE_STATE_KEY);
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return undefined;
    }
};
const saveState = (state)=>{
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(EDGE_STATE_KEY, serializedState);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
    }
};
const clearState = ()=>{
    localStorage.removeItem(EDGE_STATE_KEY);
};
const getItem = (key)=>{
    try {
        return localStorage.getItem(key);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7xxdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixpanel", ()=>mixpanel);
parcelHelpers.export(exports, "useComponentTracking", ()=>useComponentTracking);
parcelHelpers.export(exports, "usePageTracking", ()=>usePageTracking);
var _react = require("react");
var _reactRouter = require("react-router");
var _loaderModuleCore = require("mixpanel-browser/src/loaders/loader-module-core");
var _loaderModuleCoreDefault = parcelHelpers.interopDefault(_loaderModuleCore);
var _env = require("./env");
const SOURCE = 'network-manager';
const EVENT = {
    clickComponent: 'Clicked Component',
    clickLink: 'Clicked Link',
    searchedResource: 'Searched Resource',
    viewedComponent: 'Viewed Component',
    viewedPage: 'Viewed Page'
};
const init = ()=>{
    if (!(0, _env.MIXPANEL_TOKEN)) return;
    // https://github.com/mixpanel/mixpanel-js/blob/master/doc/readme.io/javascript-full-api-reference.md#mixpanelset_config
    (0, _loaderModuleCoreDefault.default).init((0, _env.MIXPANEL_TOKEN), {
        debug: !(0, _env.IS_PROD),
        persistence: 'localStorage',
        ip: false
    });
};
const addUserInfo = (user)=>{
    if (!(0, _env.MIXPANEL_TOKEN)) return;
    (0, _loaderModuleCoreDefault.default).register({
        role: user.role
    });
};
const addBuildInfo = (buildInfo)=>{
    if (!(0, _env.MIXPANEL_TOKEN)) return;
    (0, _loaderModuleCoreDefault.default).register({
        build_info_product: buildInfo.product,
        build_info_release: buildInfo.release,
        build_info_build_time: buildInfo.buildTime
    });
};
const trackEvent = (...args)=>{
    if (!(0, _env.MIXPANEL_TOKEN)) return;
    (0, _loaderModuleCoreDefault.default).track(...args);
};
const trackClickComponent = (props)=>{
    trackEvent(EVENT.clickComponent, props);
};
const trackClickLink = (props)=>{
    trackEvent(EVENT.clickLink, props);
};
const trackSearchResource = (props)=>{
    trackEvent(EVENT.searchedResource, props);
};
const reset = ()=>{
    try {
        (0, _loaderModuleCoreDefault.default).reset();
    } catch (_) {
    // noop
    }
};
const mixpanel = {
    init,
    addUserInfo,
    addBuildInfo,
    trackClickComponent,
    trackClickLink,
    trackSearchResource,
    reset
};
function useComponentTracking(props) {
    (0, _react.useEffect)(()=>{
        if (!(0, _env.MIXPANEL_TOKEN)) return;
        (0, _loaderModuleCoreDefault.default).time_event(EVENT.viewedComponent);
        return ()=>(0, _loaderModuleCoreDefault.default).track(EVENT.viewedComponent, props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
function usePageTracking() {
    const location = (0, _reactRouter.useLocation)();
    (0, _react.useEffect)(()=>{
        if (!(0, _env.MIXPANEL_TOKEN)) return;
        (0, _loaderModuleCoreDefault.default).time_event(EVENT.viewedPage);
        return ()=>(0, _loaderModuleCoreDefault.default).track(EVENT.viewedPage, {
                source: SOURCE,
                path: location.pathname
            });
    }, [
        location.pathname
    ]);
}

},{"react":"9njXz","react-router":"iaz4C","mixpanel-browser/src/loaders/loader-module-core":"hDCYP","./env":"cPu8n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hDCYP":[function(require,module,exports,__globalThis) {
/* eslint camelcase: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mixpanelCoreJs = require("../mixpanel-core.js");
var _bundleLoadersJs = require("./bundle-loaders.js");
var mixpanel = (0, _mixpanelCoreJs.init_as_module)((0, _bundleLoadersJs.loadThrowError));
exports.default = mixpanel;

},{"../mixpanel-core.js":"c8BRH","./bundle-loaders.js":"dqbHB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c8BRH":[function(require,module,exports,__globalThis) {
/* eslint camelcase: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init_from_snippet", ()=>init_from_snippet);
parcelHelpers.export(exports, "init_as_module", ()=>init_as_module);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _utils = require("./utils");
var _utils1 = require("./recorder/utils");
var _window = require("./window");
var _autocapture = require("./autocapture");
var _flags = require("./flags");
var _domTrackers = require("./dom-trackers");
var _requestBatcher = require("./request-batcher");
var _mixpanelGroup = require("./mixpanel-group");
var _mixpanelPeople = require("./mixpanel-people");
var _mixpanelPersistence = require("./mixpanel-persistence");
var _gdprUtils = require("./gdpr-utils");
var _indexedDb = require("./storage/indexed-db");
/*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ /*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var init_type; // MODULE or SNIPPET loader
// allow bundlers to specify how extra code (recorder bundle) should be loaded
// eslint-disable-next-line no-unused-vars
var load_extra_bundle = function(src, _onload) {
    throw new Error(src + ' not available in this build.');
};
var mixpanel_master; // main mixpanel instance / object
var INIT_MODULE = 0;
var INIT_SNIPPET = 1;
var IDENTITY_FUNC = function(x) {
    return x;
};
/** @const */ var PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var PAYLOAD_TYPE_BASE64 = 'base64';
/** @const */ var PAYLOAD_TYPE_JSON = 'json';
/** @const */ var DEVICE_ID_PREFIX = '$device:';
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var USE_XHR = (0, _window.window).XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var ENQUEUE_REQUESTS = !USE_XHR && (0, _utils.userAgent).indexOf('MSIE') === -1 && (0, _utils.userAgent).indexOf('Mozilla') === -1;
// save reference to navigator.sendBeacon so it can be minified
var sendBeacon = null;
if ((0, _utils.navigator)['sendBeacon']) sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return (0, _utils.navigator)['sendBeacon'].apply((0, _utils.navigator), arguments);
};
var DEFAULT_API_ROUTES = {
    'track': 'track/',
    'engage': 'engage/',
    'groups': 'groups/',
    'record': 'record/',
    'flags': 'flags/'
};
/*
 * Module-level globals
 */ var DEFAULT_CONFIG = {
    'api_host': 'https://api-js.mixpanel.com',
    'api_routes': DEFAULT_API_ROUTES,
    'api_method': 'POST',
    'api_transport': 'XHR',
    'api_payload_format': PAYLOAD_TYPE_BASE64,
    'app_host': 'https://mixpanel.com',
    'autocapture': false,
    'cdn': 'https://cdn.mxpnl.com',
    'cross_site_cookie': false,
    'cross_subdomain_cookie': true,
    'error_reporter': (0, _utils.NOOP_FUNC),
    'flags': false,
    'persistence': 'cookie',
    'persistence_name': '',
    'cookie_domain': '',
    'cookie_name': '',
    'loaded': (0, _utils.NOOP_FUNC),
    'mp_loader': null,
    'track_marketing': true,
    'track_pageview': false,
    'skip_first_touch_marketing': false,
    'store_google': true,
    'stop_utm_persistence': false,
    'save_referrer': true,
    'test': false,
    'verbose': false,
    'img': false,
    'debug': false,
    'track_links_timeout': 300,
    'cookie_expiration': 365,
    'upgrade': false,
    'disable_persistence': false,
    'disable_cookie': false,
    'secure_cookie': false,
    'ip': true,
    'opt_out_tracking_by_default': false,
    'opt_out_persistence_by_default': false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix': null,
    'property_blacklist': [],
    'xhr_headers': {},
    'ignore_dnt': false,
    'batch_requests': true,
    'batch_size': 50,
    'batch_flush_interval_ms': 5000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true,
    'hooks': {},
    'record_block_class': new RegExp('^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$'),
    'record_block_selector': 'img, video',
    'record_canvas': false,
    'record_collect_fonts': false,
    'record_heatmap_data': false,
    'record_idle_timeout_ms': 1800000,
    'record_mask_text_class': new RegExp('^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$'),
    'record_mask_text_selector': '*',
    'record_max_ms': (0, _utils.MAX_RECORDING_MS),
    'record_min_ms': 0,
    'record_sessions_percent': 0,
    'recorder_src': 'https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js'
};
var DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var create_mplib = function(token, config, name) {
    var instance, target = name === PRIMARY_INSTANCE_NAME ? mixpanel_master : mixpanel_master[name];
    if (target && init_type === INIT_MODULE) instance = target;
    else {
        if (target && !(0, _utils._).isArray(target)) {
            (0, _utils.console).error('You have already initialized ' + name);
            return;
        }
        instance = new MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance['people'] = new (0, _mixpanelPeople.MixpanelPeople)();
    instance['people']._init(instance);
    if (!instance.get_config('skip_first_touch_marketing')) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = (0, _utils._).info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        (0, _utils._).each(utm_params, function(utm_value, utm_key) {
            initial_utm_params['initial_' + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance['people'].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    (0, _configDefault.default).DEBUG = (0, _configDefault.default).DEBUG || instance.get_config('debug');
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!(0, _utils._).isUndefined(target) && (0, _utils._).isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ MixpanelLib.prototype.init = function(token, config, name) {
    if ((0, _utils._).isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }
    var instance = create_mplib(token, config, name);
    mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this['__loaded'] = true;
    this['config'] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com/)) variable_features['api_payload_format'] = PAYLOAD_TYPE_JSON;
    }
    this.set_config((0, _utils._).extend({}, DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': (name === PRIMARY_INSTANCE_NAME ? name : PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));
    this['_jsc'] = (0, _utils.NOOP_FUNC);
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!(0, _utils._).localStorage.is_supported(true) || !USE_XHR) {
            this._batch_requests = false;
            (0, _utils.console).log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
            (0, _utils._).each(this.get_batcher_configs(), function(batcher_config) {
                (0, _utils.console).log('Clearing batch queue ' + batcher_config.queue_key);
                (0, _utils._).localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if (sendBeacon && (0, _window.window).addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = (0, _utils._).bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                (0, _window.window).addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) flush_on_unload();
                });
                (0, _window.window).addEventListener('visibilitychange', function() {
                    if ((0, _utils.document)['visibilityState'] === 'hidden') flush_on_unload();
                });
            }
        }
    }
    this['persistence'] = this['cookie'] = new (0, _mixpanelPersistence.MixpanelPersistence)(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = (0, _utils._).UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        'distinct_id': DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    this.flags = new (0, _flags.FeatureFlagManager)({
        getConfigFunc: (0, _utils._).bind(this.get_config, this),
        getDistinctIdFunc: (0, _utils._).bind(this.get_distinct_id, this),
        trackingFunc: (0, _utils._).bind(this.track, this)
    });
    this.flags.init();
    this['flags'] = this.flags;
    this.autocapture = new (0, _autocapture.Autocapture)(this);
    this.autocapture.init();
    this._init_tab_id();
    this._check_and_start_session_recording();
};
/**
 * Assigns a unique UUID to this tab / window by leveraging sessionStorage.
 * This is primarily used for session recording, where data must be isolated to the current tab.
 */ MixpanelLib.prototype._init_tab_id = function() {
    if ((0, _utils._).sessionStorage.is_supported()) try {
        var key_suffix = this.get_config('name') + '_' + this.get_config('token');
        var tab_id_key = 'mp_tab_id_' + key_suffix;
        // A flag is used to determine if sessionStorage is copied over and we need to generate a new tab ID.
        // This enforces a unique ID in the cases like duplicated tab, window.open(...)
        var should_generate_new_tab_id_key = 'mp_gen_new_tab_id_' + key_suffix;
        if ((0, _utils._).sessionStorage.get(should_generate_new_tab_id_key) || !(0, _utils._).sessionStorage.get(tab_id_key)) (0, _utils._).sessionStorage.set(tab_id_key, '$tab-' + (0, _utils._).UUID());
        (0, _utils._).sessionStorage.set(should_generate_new_tab_id_key, '1');
        this.tab_id = (0, _utils._).sessionStorage.get(tab_id_key);
        // Remove the flag when the tab is unloaded to indicate the stored tab ID can be reused. This event is not reliable to detect all page unloads,
        // but reliable in cases where the user remains in the tab e.g. a refresh or href navigation.
        // If the flag is absent, this indicates to the next SDK instance that we can reuse the stored tab_id.
        (0, _window.window).addEventListener('beforeunload', function() {
            (0, _utils._).sessionStorage.remove(should_generate_new_tab_id_key);
        });
    } catch (err) {
        this.report_error('Error initializing tab id', err);
    }
    else this.report_error('Session storage is not supported, cannot keep track of unique tab ID.');
};
MixpanelLib.prototype.get_tab_id = function() {
    return this.tab_id || null;
};
MixpanelLib.prototype._should_load_recorder = function() {
    var recording_registry_idb = new (0, _indexedDb.IDBStorageWrapper)((0, _indexedDb.RECORDING_REGISTRY_STORE_NAME));
    var tab_id = this.get_tab_id();
    return recording_registry_idb.init().then(function() {
        return recording_registry_idb.getAll();
    }).then(function(recordings) {
        for(var i = 0; i < recordings.length; i++){
            // if there are expired recordings in the registry, we should load the recorder to flush them
            // if there's a recording for this tab id, we should load the recorder to continue the recording
            if ((0, _utils1.isRecordingExpired)(recordings[i]) || recordings[i]['tabId'] === tab_id) return true;
        }
        return false;
    }).catch((0, _utils._).bind(function(err) {
        this.report_error('Error checking recording registry', err);
    }, this));
};
MixpanelLib.prototype._check_and_start_session_recording = (0, _gdprUtils.addOptOutCheckMixpanelLib)(function(force_start) {
    if (!(0, _window.window)['MutationObserver']) {
        (0, _utils.console).critical('Browser does not support MutationObserver; skipping session recording');
        return;
    }
    var loadRecorder = (0, _utils._).bind(function(startNewIfInactive) {
        var handleLoadedRecorder = (0, _utils._).bind(function() {
            this._recorder = this._recorder || new (0, _window.window)['__mp_recorder'](this);
            this._recorder['resumeRecording'](startNewIfInactive);
        }, this);
        if ((0, _utils._).isUndefined((0, _window.window)['__mp_recorder'])) load_extra_bundle(this.get_config('recorder_src'), handleLoadedRecorder);
        else handleLoadedRecorder();
    }, this);
    /**
     * If the user is sampled or start_session_recording is called, we always load the recorder since it's guaranteed a recording should start.
     * Otherwise, if the recording registry has any records then it's likely there's a recording in progress or orphaned data that needs to be flushed.
     */ var is_sampled = this.get_config('record_sessions_percent') > 0 && Math.random() * 100 <= this.get_config('record_sessions_percent');
    if (force_start || is_sampled) loadRecorder(true);
    else this._should_load_recorder().then(function(shouldLoad) {
        if (shouldLoad) loadRecorder(false);
    });
});
MixpanelLib.prototype.start_session_recording = function() {
    this._check_and_start_session_recording(true);
};
MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) this._recorder['stopRecording']();
};
MixpanelLib.prototype.pause_session_recording = function() {
    if (this._recorder) this._recorder['pauseRecording']();
};
MixpanelLib.prototype.resume_session_recording = function() {
    if (this._recorder) this._recorder['resumeRecording']();
};
MixpanelLib.prototype.is_recording_heatmap_data = function() {
    return this._get_session_replay_id() && this.get_config('record_heatmap_data');
};
MixpanelLib.prototype.get_session_recording_properties = function() {
    var props = {};
    var replay_id = this._get_session_replay_id();
    if (replay_id) props['$mp_replay_id'] = replay_id;
    return props;
};
MixpanelLib.prototype.get_session_replay_url = function() {
    var replay_url = null;
    var replay_id = this._get_session_replay_id();
    if (replay_id) {
        var query_params = (0, _utils._).HTTPBuildQuery({
            'replay_id': replay_id,
            'distinct_id': this.get_distinct_id(),
            'token': this.get_config('token')
        });
        replay_url = 'https://mixpanel.com/projects/replay-redirect?' + query_params;
    }
    return replay_url;
};
MixpanelLib.prototype._get_session_replay_id = function() {
    var replay_id = null;
    if (this._recorder) replay_id = this._recorder['replayId'];
    return replay_id || null;
};
// "private" public method to reach into the recorder in test cases
MixpanelLib.prototype.__get_recorder = function() {
    return this._recorder;
};
// Private methods
MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
    this['people'].set_once(this['persistence'].get_referrer_info());
    // `store_google` is now deprecated and previously stored UTM parameters are cleared
    // from persistence by default.
    if (this.get_config('store_google') && this.get_config('stop_utm_persistence')) {
        var utm_params = (0, _utils._).info.campaignParams(null);
        (0, _utils._).each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword((0, _utils.document).referrer);
    // Registering super properties for UTM persistence by 'store_google' is deprecated.
    if (this.get_config('store_google') && !this.get_config('stop_utm_persistence')) this.register((0, _utils._).info.campaignParams());
    if (this.get_config('save_referrer')) this['persistence'].update_referrer_info((0, _utils.document).referrer);
};
MixpanelLib.prototype._dom_loaded = function() {
    (0, _utils._).each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) (0, _utils._).each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }
    if (!DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ((0, _utils._).isUndefined(callback)) return null;
    if (USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if (ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;
    if (!callback && ((0, _utils._).isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = (0, _utils._).extend(DEFAULT_OPTIONS, options || {});
    if (!USE_XHR) options.method = 'GET';
    var use_post = options.method === 'POST';
    var use_sendBeacon = sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) verbose_mode = true;
    if (this.get_config('test')) data['test'] = 1;
    if (verbose_mode) data['verbose'] = 1;
    if (this.get_config('img')) data['img'] = 1;
    if (!USE_XHR) {
        if (callback) data['callback'] = callback;
        else if (verbose_mode || this.get_config('test')) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data['callback'] = '(function(){})';
    }
    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();
    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }
    url += '?' + (0, _utils._).HTTPBuildQuery(data);
    var lib = this;
    if ('img' in data) {
        var img = (0, _utils.document).createElement('img');
        img.src = url;
        (0, _utils.document).body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if (USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config('xhr_headers');
        if (use_post) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        (0, _utils._).each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== 'undefined') {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = (0, _utils._).JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = 'timeout';
                    else error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) {
                            var response_headers = req['responseHeaders'] || {};
                            callback({
                                status: 0,
                                httpStatusCode: req['status'],
                                error: error,
                                retryAfter: response_headers['Retry-After']
                            });
                        } else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = (0, _utils.document).createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = (0, _utils.document).getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    (0, _utils._).each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ((0, _utils._).isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === 'function') item.call(this);
            else if ((0, _utils._).isArray(item) && fn_name === 'alias') alias_calls.push(item);
            else if ((0, _utils._).isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        (0, _utils._).each(calls, function(item) {
            if ((0, _utils._).isArray(item[0])) {
                // chained call
                var caller = context;
                (0, _utils._).each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = '__mpq_' + this.get_config('token');
    var api_routes = this.get_config('api_routes');
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: 'events',
            endpoint: '/' + api_routes['track'],
            queue_key: queue_prefix + '_ev'
        },
        people: {
            type: 'people',
            endpoint: '/' + api_routes['engage'],
            queue_key: queue_prefix + '_pp'
        },
        groups: {
            type: 'groups',
            endpoint: '/' + api_routes['groups'],
            queue_key: queue_prefix + '_gr'
        }
    };
    return this._batcher_configs;
};
MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = (0, _utils._).bind(function(attrs) {
            return new (0, _requestBatcher.RequestBatcher)(attrs.queue_key, {
                libConfig: this['config'],
                errorReporter: this.get_config('error_reporter'),
                sendRequestFunc: (0, _utils._).bind(function(data, options, cb) {
                    this._send_request(this.get_config('api_host') + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: (0, _utils._).bind(function(item) {
                    return this._run_hook('before_send_' + attrs.type, item);
                }, this),
                stopAllBatchingFunc: (0, _utils._).bind(this.stop_batch_senders, this),
                usePersistence: true
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config('batch_autostart')) this.start_batch_senders();
};
MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        (0, _utils._).each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    (0, _utils._).each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ MixpanelLib.prototype.disable = function(events) {
    if (typeof events === 'undefined') this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = (0, _utils.JSONStringify)(data);
    if (this.get_config('api_payload_format') === PAYLOAD_TYPE_BASE64) encoded_data = (0, _utils._).base64Encode(encoded_data);
    return {
        'data': encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = (0, _utils._).truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || (0, _utils.NOOP_FUNC);
    var request_enqueued_or_initiated = true;
    var send_request_immediately = (0, _utils._).bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        if (truncated_data) {
            (0, _utils.console).log('MIXPANEL REQUEST:');
            (0, _utils.console).log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data).then(function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ MixpanelLib.prototype.track = (0, _gdprUtils.addOptOutCheckMixpanelLib)(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') callback = (0, _utils.NOOP_FUNC);
    if ((0, _utils._).isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = (0, _utils._).extend({}, properties);
    properties['token'] = this.get_config('token');
    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!(0, _utils._).isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config('track_marketing') ? (0, _utils._).info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = (0, _utils._).extend({}, (0, _utils._).info.properties({
        'mp_loader': this.get_config('mp_loader')
    }), marketing_properties, this['persistence'].properties(), this.unpersisted_superprops, this.get_session_recording_properties(), properties);
    var property_blacklist = this.get_config('property_blacklist');
    if ((0, _utils._).isArray(property_blacklist)) (0, _utils._).each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_config('api_host') + '/' + this.get_config('api_routes')['track'],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ MixpanelLib.prototype.set_group = (0, _gdprUtils.addOptOutCheckMixpanelLib)(function(group_key, group_ids, callback) {
    if (!(0, _utils._).isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ MixpanelLib.prototype.add_group = (0, _gdprUtils.addOptOutCheckMixpanelLib)(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this['people'].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ MixpanelLib.prototype.remove_group = (0, _gdprUtils.addOptOutCheckMixpanelLib)(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this['people'].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ MixpanelLib.prototype.track_with_groups = (0, _gdprUtils.addOptOutCheckMixpanelLib)(function(event_name, properties, groups, callback) {
    var tracking_props = (0, _utils._).extend({}, properties || {});
    (0, _utils._).each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};
MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new (0, _mixpanelGroup.MixpanelGroup)();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ MixpanelLib.prototype.track_pageview = (0, _gdprUtils.addOptOutCheckMixpanelLib)(function(properties, options) {
    if (typeof properties !== 'object') properties = {};
    options = options || {};
    var event_name = options['event_name'] || '$mp_web_page_view';
    var default_page_properties = (0, _utils._).extend((0, _utils._).info.mpPageViewProperties(), (0, _utils._).info.campaignParams(), (0, _utils._).info.clickParams());
    var event_properties = (0, _utils._).extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, (0, _domTrackers.LinkTracker), arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, (0, _domTrackers.FormTracker), arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ MixpanelLib.prototype.time_event = function(event_name) {
    if ((0, _utils._).isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this['persistence'].set_event_timer(event_name, new Date().getTime());
};
var REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var options_for_register = function(days_or_options) {
    var options;
    if ((0, _utils._).isObject(days_or_options)) options = days_or_options;
    else if (!(0, _utils._).isUndefined(days_or_options)) options = {
        'days': days_or_options
    };
    else options = {};
    return (0, _utils._).extend({}, REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register(props, options['days']);
    else (0, _utils._).extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register_once(props, default_value, options['days']);
    else {
        if (typeof default_value === 'undefined') default_value = 'None';
        (0, _utils._).each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ MixpanelLib.prototype.unregister = function(property, options) {
    options = options_for_register(options);
    if (options['persistent']) this['persistence'].unregister(property);
    else delete this.unpersisted_superprops[property];
};
MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === 'string' && new_distinct_id.indexOf(DEVICE_ID_PREFIX) === 0) {
            this.report_error('distinct_id cannot have $device: prefix');
            return -1;
        }
        this.register({
            '$user_id': new_distinct_id
        });
    }
    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property((0, _mixpanelPersistence.ALIAS_ID_KEY))) {
        this.unregister((0, _mixpanelPersistence.ALIAS_ID_KEY));
        this.register({
            'distinct_id': new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track('$identify', {
        'distinct_id': new_distinct_id,
        '$anon_distinct_id': previous_distinct_id
    }, {
        skip_hooks: true
    });
    // check feature flags again if distinct id has changed
    if (new_distinct_id !== previous_distinct_id) this.flags.fetchFlags();
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = (0, _utils._).UUID();
    this.register_once({
        'distinct_id': DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property((0, _mixpanelPersistence.PEOPLE_DISTINCT_ID_KEY))) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }
    var _this = this;
    if ((0, _utils._).isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single((0, _mixpanelPersistence.ALIAS_ID_KEY), alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ MixpanelLib.prototype.set_config = function(config) {
    if ((0, _utils._).isObject(config)) {
        (0, _utils._).extend(this['config'], config);
        var new_batch_size = config['batch_size'];
        if (new_batch_size) (0, _utils._).each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config('persistence_name')) this['config']['persistence_name'] = this['config']['cookie_name'];
        if (!this.get_config('disable_persistence')) this['config']['disable_persistence'] = this['config']['disable_cookie'];
        if (this['persistence']) this['persistence'].update_config(this['config']);
        (0, _configDefault.default).DEBUG = (0, _configDefault.default).DEBUG || this.get_config('debug');
        if (('autocapture' in config || 'record_heatmap_data' in config) && this.autocapture) this.autocapture.init();
    }
};
/**
 * returns the current config object for the library.
 */ MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || IDENTITY_FUNC).apply(this, (0, _utils.slice).call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence'].load_prop([
        property_name
    ]);
};
MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== PRIMARY_INSTANCE_NAME) name = PRIMARY_INSTANCE_NAME + '.' + name;
    return name;
};
MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return (0, _utils._).isBlockedUA((0, _utils.userAgent)) || this._flags.disable_all_events || (0, _utils._).include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && (0, _utils._).localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            'persistence_type': 'cookie'
        })) this.opt_in_tracking({
            'enable_persistence': false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            'persistence_type': 'cookie'
        })) this.opt_out_tracking({
            'clear_persistence': false
        });
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        'clear_persistence': true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config('opt_out_tracking_by_default') || (0, _utils._).cookie.get('mp_optout'))) {
        (0, _utils._).cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) disabled = true;
    else if (options && options['enable_persistence']) disabled = false;
    else return;
    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) this['persistence'].set_disabled(disabled);
    if (disabled) {
        this.stop_batch_senders();
        this.stop_session_recording();
    } else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = (0, _utils._).extend({
        'track': (0, _utils._).bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!(0, _utils._).localStorage.is_supported()) options['persistence_type'] = 'cookie';
    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = (0, _utils._).extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func((0, _gdprUtils.optIn), options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = (0, _utils._).extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }
    this._gdpr_call_func((0, _gdprUtils.optOut), options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func((0, _gdprUtils.hasOptedIn), options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func((0, _gdprUtils.hasOptedOut), options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = (0, _utils._).extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func((0, _gdprUtils.clearOptInOut), options);
    this._gdpr_update_persistence(options);
};
MixpanelLib.prototype.report_error = function(msg, err) {
    (0, _utils.console).error.apply((0, _utils.console).error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config('error_reporter')(msg, err);
    } catch (err) {
        (0, _utils.console).error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
MixpanelLib.prototype['init'] = MixpanelLib.prototype.init;
MixpanelLib.prototype['reset'] = MixpanelLib.prototype.reset;
MixpanelLib.prototype['disable'] = MixpanelLib.prototype.disable;
MixpanelLib.prototype['time_event'] = MixpanelLib.prototype.time_event;
MixpanelLib.prototype['track'] = MixpanelLib.prototype.track;
MixpanelLib.prototype['track_links'] = MixpanelLib.prototype.track_links;
MixpanelLib.prototype['track_forms'] = MixpanelLib.prototype.track_forms;
MixpanelLib.prototype['track_pageview'] = MixpanelLib.prototype.track_pageview;
MixpanelLib.prototype['register'] = MixpanelLib.prototype.register;
MixpanelLib.prototype['register_once'] = MixpanelLib.prototype.register_once;
MixpanelLib.prototype['unregister'] = MixpanelLib.prototype.unregister;
MixpanelLib.prototype['identify'] = MixpanelLib.prototype.identify;
MixpanelLib.prototype['alias'] = MixpanelLib.prototype.alias;
MixpanelLib.prototype['name_tag'] = MixpanelLib.prototype.name_tag;
MixpanelLib.prototype['set_config'] = MixpanelLib.prototype.set_config;
MixpanelLib.prototype['get_config'] = MixpanelLib.prototype.get_config;
MixpanelLib.prototype['get_property'] = MixpanelLib.prototype.get_property;
MixpanelLib.prototype['get_distinct_id'] = MixpanelLib.prototype.get_distinct_id;
MixpanelLib.prototype['toString'] = MixpanelLib.prototype.toString;
MixpanelLib.prototype['opt_out_tracking'] = MixpanelLib.prototype.opt_out_tracking;
MixpanelLib.prototype['opt_in_tracking'] = MixpanelLib.prototype.opt_in_tracking;
MixpanelLib.prototype['has_opted_out_tracking'] = MixpanelLib.prototype.has_opted_out_tracking;
MixpanelLib.prototype['has_opted_in_tracking'] = MixpanelLib.prototype.has_opted_in_tracking;
MixpanelLib.prototype['clear_opt_in_out_tracking'] = MixpanelLib.prototype.clear_opt_in_out_tracking;
MixpanelLib.prototype['get_group'] = MixpanelLib.prototype.get_group;
MixpanelLib.prototype['set_group'] = MixpanelLib.prototype.set_group;
MixpanelLib.prototype['add_group'] = MixpanelLib.prototype.add_group;
MixpanelLib.prototype['remove_group'] = MixpanelLib.prototype.remove_group;
MixpanelLib.prototype['track_with_groups'] = MixpanelLib.prototype.track_with_groups;
MixpanelLib.prototype['start_batch_senders'] = MixpanelLib.prototype.start_batch_senders;
MixpanelLib.prototype['stop_batch_senders'] = MixpanelLib.prototype.stop_batch_senders;
MixpanelLib.prototype['start_session_recording'] = MixpanelLib.prototype.start_session_recording;
MixpanelLib.prototype['stop_session_recording'] = MixpanelLib.prototype.stop_session_recording;
MixpanelLib.prototype['pause_session_recording'] = MixpanelLib.prototype.pause_session_recording;
MixpanelLib.prototype['resume_session_recording'] = MixpanelLib.prototype.resume_session_recording;
MixpanelLib.prototype['get_session_recording_properties'] = MixpanelLib.prototype.get_session_recording_properties;
MixpanelLib.prototype['get_session_replay_url'] = MixpanelLib.prototype.get_session_replay_url;
MixpanelLib.prototype['get_tab_id'] = MixpanelLib.prototype.get_tab_id;
MixpanelLib.prototype['DEFAULT_API_ROUTES'] = DEFAULT_API_ROUTES;
// Exports intended only for testing
MixpanelLib.prototype['__get_recorder'] = MixpanelLib.prototype.__get_recorder;
// MixpanelPersistence Exports
(0, _mixpanelPersistence.MixpanelPersistence).prototype['properties'] = (0, _mixpanelPersistence.MixpanelPersistence).prototype.properties;
(0, _mixpanelPersistence.MixpanelPersistence).prototype['update_search_keyword'] = (0, _mixpanelPersistence.MixpanelPersistence).prototype.update_search_keyword;
(0, _mixpanelPersistence.MixpanelPersistence).prototype['update_referrer_info'] = (0, _mixpanelPersistence.MixpanelPersistence).prototype.update_referrer_info;
(0, _mixpanelPersistence.MixpanelPersistence).prototype['get_cross_subdomain'] = (0, _mixpanelPersistence.MixpanelPersistence).prototype.get_cross_subdomain;
(0, _mixpanelPersistence.MixpanelPersistence).prototype['clear'] = (0, _mixpanelPersistence.MixpanelPersistence).prototype.clear;
var instances = {};
var extend_mp = function() {
    // add all the sub mixpanel instances
    (0, _utils._).each(instances, function(instance, name) {
        if (name !== PRIMARY_INSTANCE_NAME) mixpanel_master[name] = instance;
    });
    // add private functions as _
    mixpanel_master['_'] = (0, _utils._);
};
var override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!mixpanel_master[name]) {
                mixpanel_master[name] = instances[name] = create_mplib(token, config, name);
                mixpanel_master[name]._loaded();
            }
            return mixpanel_master[name];
        } else {
            var instance = mixpanel_master;
            if (instances[PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = instances[PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = create_mplib(token, config, PRIMARY_INSTANCE_NAME);
                instance._loaded();
                instances[PRIMARY_INSTANCE_NAME] = instance;
            }
            mixpanel_master = instance;
            if (init_type === INIT_SNIPPET) (0, _window.window)[PRIMARY_INSTANCE_NAME] = mixpanel_master;
            extend_mp();
        }
    };
};
var add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        DOM_LOADED = true;
        ENQUEUE_REQUESTS = false;
        (0, _utils._).each(instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            (0, _utils.document).documentElement.doScroll('left');
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ((0, _utils.document).addEventListener) {
        if ((0, _utils.document).readyState === 'complete') // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else (0, _utils.document).addEventListener('DOMContentLoaded', dom_loaded_handler, false);
    } else if ((0, _utils.document).attachEvent) {
        // IE
        (0, _utils.document).attachEvent('onreadystatechange', dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = (0, _window.window).frameElement === null;
        } catch (e) {
        // noop
        }
        if ((0, _utils.document).documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    (0, _utils._).register_event((0, _window.window), 'load', dom_loaded_handler, true);
};
function init_from_snippet(bundle_loader) {
    load_extra_bundle = bundle_loader;
    init_type = INIT_SNIPPET;
    mixpanel_master = (0, _window.window)[PRIMARY_INSTANCE_NAME];
    // Initialization
    if ((0, _utils._).isUndefined(mixpanel_master)) {
        // mixpanel wasn't initialized properly, report error and quit
        (0, _utils.console).critical('"mixpanel" object not initialized. Ensure you are using the latest version of the Mixpanel JS Library along with the snippet we provide.');
        return;
    }
    if (mixpanel_master['__loaded'] || mixpanel_master['config'] && mixpanel_master['persistence']) {
        // lib has already been loaded at least once; we don't want to override the global object this time so bomb early
        (0, _utils.console).critical('The Mixpanel library has already been downloaded at least once. Ensure that the Mixpanel code snippet only appears once on the page (and is not double-loaded by a tag manager) in order to avoid errors.');
        return;
    }
    var snippet_version = mixpanel_master['__SV'] || 0;
    if (snippet_version < 1.1) {
        // mixpanel wasn't initialized properly, report error and quit
        (0, _utils.console).critical('Version mismatch; please ensure you\'re using the latest version of the Mixpanel code snippet.');
        return;
    }
    // Load instances of the Mixpanel Library
    (0, _utils._).each(mixpanel_master['_i'], function(item) {
        if (item && (0, _utils._).isArray(item)) instances[item[item.length - 1]] = create_mplib.apply(this, item);
    });
    override_mp_init_func();
    mixpanel_master['init']();
    // Fire loaded events after updating the window's mixpanel object
    (0, _utils._).each(instances, function(instance) {
        instance._loaded();
    });
    add_dom_loaded_handler();
}
function init_as_module(bundle_loader) {
    load_extra_bundle = bundle_loader;
    init_type = INIT_MODULE;
    mixpanel_master = new MixpanelLib();
    override_mp_init_func();
    mixpanel_master['init']();
    add_dom_loaded_handler();
    return mixpanel_master;
}

},{"./config":"dsCxa","./utils":"7v0z9","./recorder/utils":"4QRGB","./window":"hzg1R","./autocapture":"ei8GX","./flags":"3iAPt","./dom-trackers":"7g9m5","./request-batcher":"2Zs9E","./mixpanel-group":"arC6u","./mixpanel-people":"liflk","./mixpanel-persistence":"f96Cp","./gdpr-utils":"eQMdi","./storage/indexed-db":"a6eJh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dsCxa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var Config = {
    DEBUG: false,
    LIB_VERSION: '2.64.0'
};
exports.default = Config;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7v0z9":[function(require,module,exports,__globalThis) {
/* eslint camelcase: "off", eqeqeq: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_);
parcelHelpers.export(exports, "batchedThrottle", ()=>batchedThrottle);
parcelHelpers.export(exports, "cheap_guid", ()=>cheap_guid);
parcelHelpers.export(exports, "console_with_prefix", ()=>console_with_prefix);
parcelHelpers.export(exports, "console", ()=>console);
parcelHelpers.export(exports, "document", ()=>document);
parcelHelpers.export(exports, "extract_domain", ()=>extract_domain);
parcelHelpers.export(exports, "JSONParse", ()=>JSONParse);
parcelHelpers.export(exports, "JSONStringify", ()=>JSONStringify);
parcelHelpers.export(exports, "isOnline", ()=>isOnline);
parcelHelpers.export(exports, "localStorageSupported", ()=>localStorageSupported);
parcelHelpers.export(exports, "MAX_RECORDING_MS", ()=>MAX_RECORDING_MS);
parcelHelpers.export(exports, "MAX_VALUE_FOR_MIN_RECORDING_MS", ()=>MAX_VALUE_FOR_MIN_RECORDING_MS);
parcelHelpers.export(exports, "navigator", ()=>navigator);
parcelHelpers.export(exports, "NOOP_FUNC", ()=>NOOP_FUNC);
parcelHelpers.export(exports, "safewrap", ()=>safewrap);
parcelHelpers.export(exports, "safewrapClass", ()=>safewrapClass);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "userAgent", ()=>userAgent);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _promisePolyfill = require("./promise-polyfill");
var _window = require("./window");
// Maximum allowed session recording length
var MAX_RECORDING_MS = 86400000; // 24 hours
// Maximum allowed value for minimum session recording length
var MAX_VALUE_FOR_MIN_RECORDING_MS = 8000; // 8 seconds
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var ArrayProto = Array.prototype, FuncProto = Function.prototype, ObjProto = Object.prototype, slice = ArrayProto.slice, toString = ObjProto.toString, hasOwnProperty = ObjProto.hasOwnProperty, windowConsole = (0, _window.window).console, navigator = (0, _window.window).navigator, document = (0, _window.window).document, windowOpera = (0, _window.window).opera, screen = (0, _window.window).screen, userAgent = navigator.userAgent;
var nativeBind = FuncProto.bind, nativeForEach = ArrayProto.forEach, nativeIndexOf = ArrayProto.indexOf, nativeMap = ArrayProto.map, nativeIsArray = Array.isArray, breaker = {};
var _ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};
// Console override
var console = {
    /** @type {function(...*)} */ log: function() {
        if ((0, _configDefault.default).DEBUG && !_.isUndefined(windowConsole) && windowConsole) try {
            windowConsole.log.apply(windowConsole, arguments);
        } catch (err) {
            _.each(arguments, function(arg) {
                windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ((0, _configDefault.default).DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            var args = [
                'Mixpanel warning:'
            ].concat(_.toArray(arguments));
            try {
                windowConsole.warn.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ((0, _configDefault.default).DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!_.isUndefined(windowConsole) && windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    }
};
var log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply(console, arguments);
    };
};
var console_with_prefix = function(prefix) {
    return {
        log: log_func_with_prefix(console.log, prefix),
        error: log_func_with_prefix(console.error, prefix),
        critical: log_func_with_prefix(console.critical, prefix)
    };
};
var safewrap = function(f) {
    return function() {
        try {
            return f.apply(this, arguments);
        } catch (e) {
            console.critical('Implementation error. Please turn on debug and contact support@mixpanel.com.');
            if ((0, _configDefault.default).DEBUG) console.critical(e);
        }
    };
};
var safewrapClass = function(klass) {
    var proto = klass.prototype;
    for(var func in proto)if (typeof proto[func] === 'function') proto[func] = safewrap(proto[func]);
};
// UNDERSCORE
// Embed part of the Underscore Library
_.bind = function(func, context) {
    var args, bound;
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError();
    args = slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat(slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ _.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if (nativeForEach && obj.forEach === nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) return;
    }
    else {
        for(var key in obj)if (hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === breaker) return;
        }
    }
};
_.extend = function(obj) {
    _.each(slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
_.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
_.isArguments = function(obj) {
    return !!(obj && hasOwnProperty.call(obj, 'callee'));
};
_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if (_.isArray(iterable)) return slice.call(iterable);
    if (_.isArguments(iterable)) return slice.call(iterable);
    return _.values(iterable);
};
_.map = function(arr, callback, context) {
    if (nativeMap && arr.map === nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        _.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    _.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    _.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
    _.each(obj, function(value) {
        if (found || (found = value === target)) return breaker;
    });
    return found;
};
_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
_.isObject = function(obj) {
    return obj === Object(obj) && !_.isArray(obj);
};
_.isEmptyObject = function(obj) {
    if (_.isObject(obj)) {
        for(var key in obj){
            if (hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
_.isUndefined = function(obj) {
    return obj === void 0;
};
_.isString = function(obj) {
    return toString.call(obj) == '[object String]';
};
_.isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
};
_.isNumber = function(obj) {
    return toString.call(obj) == '[object Number]';
};
_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
_.encodeDates = function(obj) {
    _.each(obj, function(v, k) {
        if (_.isDate(v)) obj[k] = _.formatDate(v);
        else if (_.isObject(v)) obj[k] = _.encodeDates(v); // recurse
    });
    return obj;
};
_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
};
_.strip_empty_properties = function(p) {
    var ret = {};
    _.each(p, function(v, k) {
        if (_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ _.truncate = function(obj, length) {
    var ret;
    if (typeof obj === 'string') ret = obj.slice(0, length);
    else if (_.isArray(obj)) {
        ret = [];
        _.each(obj, function(val) {
            ret.push(_.truncate(val, length));
        });
    } else if (_.isObject(obj)) {
        ret = {};
        _.each(obj, function(val, key) {
            ret[key] = _.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' && typeof value.toJSON === 'function') value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case 'string':
                    return quote(value);
                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';
                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return 'null';
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if (toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || 'null';
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if (hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ': ' : ':') + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ _.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        '\\': '\\',
        '/': '/',
        'b': '\b',
        'f': '\f',
        'n': '\n',
        'r': '\r',
        't': '\t'
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error('Expected \'' + c + '\' instead of \'' + ch + '\'');
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = '';
        if (ch === '-') {
            string = '-';
            next('-');
        }
        while(ch >= '0' && ch <= '9'){
            string += ch;
            next();
        }
        if (ch === '.') {
            string += '.';
            while(next() && ch >= '0' && ch <= '9')string += ch;
        }
        if (ch === 'e' || ch === 'E') {
            string += ch;
            next();
            if (ch === '-' || ch === '+') {
                string += ch;
                next();
            }
            while(ch >= '0' && ch <= '9'){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error('Bad number');
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = '', uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === '\\') {
                next();
                if (ch === 'u') {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === 'string') string += escapee[ch];
                else break;
            } else string += ch;
        }
        error('Bad string');
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= ' ')next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === '[') {
            next('[');
            white();
            if (ch === ']') {
                next(']');
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === ']') {
                    next(']');
                    return array;
                }
                next(',');
                white();
            }
        }
        error('Bad array');
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === '{') {
            next('{');
            white();
            if (ch === '}') {
                next('}');
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(':');
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === '}') {
                    next('}');
                    return object;
                }
                next(',');
                white();
            }
        }
        error('Bad object');
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) error('Syntax error');
        return result;
    };
}();
_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
    if (!data) return data;
    data = _.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join('');
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
};
_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '', start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
_.UUID = function() {
    try {
        // use native Crypto API when available
        return (0, _window.window)['crypto']['randomUUID']();
    } catch (err) {
        // fall back to generating our own UUID
        // based on https://gist.github.com/scwood/3bff42cc005cc20ab7ec98f0d8e1d59d
        var uuid = new Array(36);
        for(var i = 0; i < 36; i++)uuid[i] = Math.floor(Math.random() * 16);
        uuid[14] = 4; // set bits 12-15 of time-high-and-version to 0100
        uuid[19] = uuid[19] &= -5; // set bit 6 of clock-seq-and-reserved to zero
        uuid[19] = uuid[19] |= 8; // set bit 7 of clock-seq-and-reserved to one
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        return _.map(uuid, function(x) {
            return x.toString(16);
        }).join('');
    }
};
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var BLOCKED_UA_STRS = [
    'ahrefsbot',
    'ahrefssiteaudit',
    'amazonbot',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'chrome-lighthouse',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandex',
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf(BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ _.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if (_.isUndefined(arg_separator)) arg_separator = '&';
    _.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });
    return tmp_arr.join(arg_separator);
};
_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/g, '\\[').replace(/[\]]/g, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)', regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== 'string' && results[1].length) return '';
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            console.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = _.JSONDecode(_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = extract_domain(document.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = extract_domain(document.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        document.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        _.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};
var _testStorageSupported = function(storage) {
    var supported = true;
    try {
        var key = '__mplss_' + cheap_guid(8), val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    return supported;
};
var _localStorageSupported = null;
var localStorageSupported = function(storage, forceCheck) {
    if (_localStorageSupported !== null && !forceCheck) return _localStorageSupported;
    return _localStorageSupported = _testStorageSupported(storage || (0, _window.window).localStorage);
};
var _sessionStorageSupported = null;
var sessionStorageSupported = function(storage, forceCheck) {
    if (_sessionStorageSupported !== null && !forceCheck) return _sessionStorageSupported;
    return _sessionStorageSupported = _testStorageSupported(storage || (0, _window.window).sessionStorage);
};
function _storageWrapper(storage, name, is_supported_fn) {
    var log_error = function(msg) {
        console.error(name + ' error: ' + msg);
    };
    return {
        is_supported: function(forceCheck) {
            var supported = is_supported_fn(storage, forceCheck);
            if (!supported) console.error(name + ' unsupported');
            return supported;
        },
        error: log_error,
        get: function(key) {
            try {
                return storage.getItem(key);
            } catch (err) {
                log_error(err);
            }
            return null;
        },
        parse: function(key) {
            try {
                return _.JSONDecode(storage.getItem(key)) || {};
            } catch (err) {
            // noop
            }
            return null;
        },
        set: function(key, value) {
            try {
                storage.setItem(key, value);
            } catch (err) {
                log_error(err);
            }
        },
        remove: function(key) {
            try {
                storage.removeItem(key);
            } catch (err) {
                log_error(err);
            }
        }
    };
}
_.localStorage = _storageWrapper((0, _window.window).localStorage, 'localStorage', localStorageSupported);
_.sessionStorage = _storageWrapper((0, _window.window).sessionStorage, 'sessionStorage', sessionStorageSupported);
_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            console.error('No valid element provided to register_event');
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent((0, _window.window).event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if (_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!document.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            document
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = document.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = '*';
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && _.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match(TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = '*';
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case '=':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case '~':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
                        };
                        break;
                    case '|':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
                        };
                        break;
                    case '^':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case '$':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case '*':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if (_.isElement(query)) return [
            query
        ];
        else if (_.isObject(query) && !_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var CAMPAIGN_KEYWORDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'utm_source_platform',
    'utm_campaign_id',
    'utm_creative_format',
    'utm_marketing_tactic'
];
var CLICK_IDS = [
    'dclid',
    'fbclid',
    'gclid',
    'ko_click_id',
    'li_fat_id',
    'msclkid',
    'sccid',
    'ttclid',
    'twclid',
    'wbraid'
];
_.info = {
    campaignParams: function(default_value) {
        var kw = '', params = {};
        _.each(CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = _.getQueryParam(document.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = '', params = {};
        _.each(CLICK_IDS, function(idkey) {
            id = _.getQueryParam(document.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return _.extend(_.info.campaignParams(), _.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) return 'google';
        else if (referrer.search('https?://(.*)bing.com') === 0) return 'bing';
        else if (referrer.search('https?://(.*)yahoo.com') === 0) return 'yahoo';
        else if (referrer.search('https?://(.*)duckduckgo.com') === 0) return 'duckduckgo';
        else return null;
    },
    searchInfo: function(referrer) {
        var search = _.info.searchEngine(referrer), param = search != 'yahoo' ? 'q' : 'p', ret = {};
        if (search !== null) {
            ret['$search_engine'] = search;
            var keyword = _.getQueryParam(referrer, param);
            if (keyword.length) ret['mp_keyword'] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || _.includes(user_agent, ' OPR/')) {
            if (_.includes(user_agent, 'Mini')) return 'Opera Mini';
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if (_.includes(user_agent, 'IEMobile') || _.includes(user_agent, 'WPDesktop')) return 'Internet Explorer Mobile';
        else if (_.includes(user_agent, 'SamsungBrowser/')) // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
        else if (_.includes(user_agent, 'Edge') || _.includes(user_agent, 'Edg/')) return 'Microsoft Edge';
        else if (_.includes(user_agent, 'FBIOS')) return 'Facebook Mobile';
        else if (_.includes(user_agent, 'Chrome')) return 'Chrome';
        else if (_.includes(user_agent, 'CriOS')) return 'Chrome iOS';
        else if (_.includes(user_agent, 'UCWEB') || _.includes(user_agent, 'UCBrowser')) return 'UC Browser';
        else if (_.includes(user_agent, 'FxiOS')) return 'Firefox iOS';
        else if (_.includes(vendor, 'Apple')) {
            if (_.includes(user_agent, 'Mobile')) return 'Mobile Safari';
            return 'Safari';
        } else if (_.includes(user_agent, 'Android')) return 'Android Mobile';
        else if (_.includes(user_agent, 'Konqueror')) return 'Konqueror';
        else if (_.includes(user_agent, 'Firefox')) return 'Firefox';
        else if (_.includes(user_agent, 'MSIE') || _.includes(user_agent, 'Trident/')) return 'Internet Explorer';
        else if (_.includes(user_agent, 'Gecko')) return 'Mozilla';
        else return '';
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = _.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return 'Windows Phone';
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) return 'iOS';
        else if (/Android/.test(a)) return 'Android';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return 'BlackBerry';
        else if (/Mac/i.test(a)) return 'Mac OS X';
        else if (/Linux/.test(a)) return 'Linux';
        else if (/CrOS/.test(a)) return 'Chrome OS';
        else return '';
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return 'Windows Phone';
        else if (/iPad/.test(user_agent)) return 'iPad';
        else if (/iPod/.test(user_agent)) return 'iPod Touch';
        else if (/iPhone/.test(user_agent)) return 'iPhone';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if (/Android/.test(user_agent)) return 'Android';
        else return '';
    },
    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) return split[2];
        return '';
    },
    currentUrl: function() {
        return (0, _window.window).location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== 'object') extra_props = {};
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator.vendor, windowOpera),
            '$referrer': document.referrer,
            '$referring_domain': _.info.referringDomain(document.referrer),
            '$device': _.info.device(userAgent)
        }), {
            '$current_url': _.info.currentUrl(),
            '$browser_version': _.info.browserVersion(userAgent, navigator.vendor, windowOpera),
            '$screen_height': screen.height,
            '$screen_width': screen.width,
            'mp_lib': 'web',
            '$lib_version': (0, _configDefault.default).LIB_VERSION,
            '$insert_id': cheap_guid(),
            'time': _.timestamp() / 1000 // epoch time in seconds
        }, _.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator.vendor, windowOpera)
        }), {
            '$browser_version': _.info.browserVersion(userAgent, navigator.vendor, windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return _.strip_empty_properties({
            'current_page_title': document.title,
            'current_domain': (0, _window.window).location.hostname,
            'current_url_path': (0, _window.window).location.pathname,
            'current_url_protocol': (0, _window.window).location.protocol,
            'current_url_search': (0, _window.window).location.search
        });
    }
};
/**
 * Returns a throttled function that will only run at most every `waitMs` and returns a promise that resolves with the next invocation.
 * Throttled calls will build up a batch of args and invoke the callback with all args since the last invocation.
 */ var batchedThrottle = function(fn, waitMs) {
    var timeoutPromise = null;
    var throttledItems = [];
    return function(item) {
        var self = this;
        throttledItems.push(item);
        if (!timeoutPromise) timeoutPromise = new (0, _promisePolyfill.Promise)(function(resolve) {
            setTimeout(function() {
                var returnValue = fn.apply(self, [
                    throttledItems
                ]);
                timeoutPromise = null;
                throttledItems = [];
                resolve(returnValue);
            }, waitMs);
        });
        return timeoutPromise;
    };
};
var cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var extract_domain = function(hostname) {
    var domain_regex = DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') domain_regex = SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};
/**
 * Check whether we have network connection. default to true for browsers that don't support navigator.onLine (IE)
 * @returns {boolean}
 */ var isOnline = function() {
    var onLine = (0, _window.window).navigator['onLine'];
    return _.isUndefined(onLine) || onLine;
};
var NOOP_FUNC = function() {};
var JSONStringify = null, JSONParse = null;
if (typeof JSON !== 'undefined') {
    JSONStringify = JSON.stringify;
    JSONParse = JSON.parse;
}
JSONStringify = JSONStringify || _.JSONEncode;
JSONParse = JSONParse || _.JSONDecode;
// UNMINIFIED EXPORTS (for closure compiler)
_['info'] = _.info;
_['info']['browser'] = _.info.browser;
_['info']['browserVersion'] = _.info.browserVersion;
_['info']['device'] = _.info.device;
_['info']['properties'] = _.info.properties;
_['isBlockedUA'] = _.isBlockedUA;
_['isEmptyObject'] = _.isEmptyObject;
_['isObject'] = _.isObject;
_['JSONDecode'] = _.JSONDecode;
_['JSONEncode'] = _.JSONEncode;
_['toArray'] = _.toArray;
_['NPO'] = (0, _promisePolyfill.NpoPromise);

},{"./config":"dsCxa","./promise-polyfill":"4m5ur","./window":"hzg1R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4m5ur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Promise", ()=>PromisePolyfill);
parcelHelpers.export(exports, "NpoPromise", ()=>NpoPromise);
var _window = require("./window");
/**
 * Promise polyfill sourced from https://github.com/getify/native-promise-only.
 * Modified to
 *  - remove UMD wrapper and export as an object, so that we don't globally polyfill Promise.
 *  - rename access notation for dynamically referenced props to avoid minification, e.g. this.__NPO__ -> this['__NPO__']
*/ /*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/ /*jshint validthis:true */ 'use strict';
var setImmediate = (0, _window.window)['setImmediate'];
var builtInProp, cycle, schedulingQueue, ToString = Object.prototype.toString, timer = typeof setImmediate !== 'undefined' ? function timer(fn) {
    return setImmediate(fn);
} : setTimeout;
// dammit, IE8.
try {
    Object.defineProperty({}, 'x', {});
    builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
            value: val,
            writable: true,
            configurable: config !== false
        });
    };
} catch (err) {
    builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
    };
}
// Note: using a queue instead of array for efficiency
schedulingQueue = function Queue() {
    var first, last, item;
    function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
    }
    return {
        add: function add(fn, self) {
            item = new Item(fn, self);
            if (last) last.next = item;
            else first = item;
            last = item;
            item = void 0;
        },
        drain: function drain() {
            var f = first;
            first = last = cycle = void 0;
            while(f){
                f.fn.call(f.self);
                f = f.next;
            }
        }
    };
}();
function schedule(fn, self) {
    schedulingQueue.add(fn, self);
    if (!cycle) cycle = timer(schedulingQueue.drain);
}
// promise duck typing
function isThenable(o) {
    var _then, oType = typeof o;
    if (o !== null && (oType === 'object' || oType === 'function')) _then = o.then;
    return typeof _then === 'function' ? _then : false;
}
function notify() {
    for(var i = 0; i < this.chain.length; i++)notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    this.chain.length = 0;
}
// NOTE: This is a separate function to isolate
// the `try..catch` so that other code can be
// optimized better
function notifyIsolated(self, cb, chain) {
    var ret, _then;
    try {
        if (cb === false) chain.reject(self.msg);
        else {
            if (cb === true) ret = self.msg;
            else ret = cb.call(void 0, self.msg);
            if (ret === chain.promise) chain.reject(TypeError('Promise-chain cycle'));
            else if (_then = isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
            else chain.resolve(ret);
        }
    } catch (err) {
        chain.reject(err);
    }
}
function resolve(msg) {
    var _then, self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    try {
        // eslint-disable-next-line no-cond-assign
        if (_then = isThenable(msg)) schedule(function() {
            var defWrapper = new MakeDefWrapper(self);
            try {
                _then.call(msg, function $resolve$() {
                    resolve.apply(defWrapper, arguments);
                }, function $reject$() {
                    reject.apply(defWrapper, arguments);
                });
            } catch (err) {
                reject.call(defWrapper, err);
            }
        });
        else {
            self.msg = msg;
            self.state = 1;
            if (self.chain.length > 0) schedule(notify, self);
        }
    } catch (err) {
        reject.call(new MakeDefWrapper(self), err);
    }
}
function reject(msg) {
    var self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    self.msg = msg;
    self.state = 2;
    if (self.chain.length > 0) schedule(notify, self);
}
function iteratePromises(Constructor, arr, resolver, rejecter) {
    for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
        }, rejecter);
    })(idx);
}
function MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
}
function MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
}
function NpoPromise(executor) {
    if (typeof executor !== 'function') throw TypeError('Not a function');
    if (this['__NPO__'] !== 0) throw TypeError('Not a promise');
    // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise
    this['__NPO__'] = 1;
    var def = new MakeDef(this);
    this['then'] = function then(success, failure) {
        var o = {
            success: typeof success === 'function' ? success : true,
            failure: typeof failure === 'function' ? failure : false
        };
        // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.
        o.promise = new this.constructor(function extractChain(resolve, reject) {
            if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
            o.resolve = resolve;
            o.reject = reject;
        });
        def.chain.push(o);
        if (def.state !== 0) schedule(notify, def);
        return o.promise;
    };
    this['catch'] = function $catch$(failure) {
        return this.then(void 0, failure);
    };
    try {
        executor.call(void 0, function publicResolve(msg) {
            resolve.call(def, msg);
        }, function publicReject(msg) {
            reject.call(def, msg);
        });
    } catch (err) {
        reject.call(def, err);
    }
}
var PromisePrototype = builtInProp({}, 'constructor', NpoPromise, /*configurable=*/ false);
// Note: Android 4 cannot use `Object.defineProperty(..)` here
NpoPromise.prototype = PromisePrototype;
// built-in "brand" to signal an "uninitialized" promise
builtInProp(PromisePrototype, '__NPO__', 0, /*configurable=*/ false);
builtInProp(NpoPromise, 'resolve', function Promise$resolve(msg) {
    var Constructor = this;
    // spec mandated checks
    // note: best "isPromise" check that's practical for now
    if (msg && typeof msg === 'object' && msg['__NPO__'] === 1) return msg;
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        resolve(msg);
    });
});
builtInProp(NpoPromise, 'reject', function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        reject(msg);
    });
});
builtInProp(NpoPromise, 'all', function Promise$all(arr) {
    var Constructor = this;
    // spec mandated checks
    if (ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    if (arr.length === 0) return Constructor.resolve([]);
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        var len = arr.length, msgs = Array(len), count = 0;
        iteratePromises(Constructor, arr, function resolver(idx, msg) {
            msgs[idx] = msg;
            if (++count === len) resolve(msgs);
        }, reject);
    });
});
builtInProp(NpoPromise, 'race', function Promise$race(arr) {
    var Constructor = this;
    // spec mandated checks
    if (ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        iteratePromises(Constructor, arr, function resolver(idx, msg) {
            resolve(msg);
        }, reject);
    });
});
var PromisePolyfill;
if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) PromisePolyfill = Promise;
else PromisePolyfill = NpoPromise;

},{"./window":"hzg1R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hzg1R":[function(require,module,exports,__globalThis) {
// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "window", ()=>win);
var win;
if (typeof window === 'undefined') {
    var loc = {
        hostname: ''
    };
    win = {
        crypto: {
            randomUUID: function() {
                throw Error('unsupported');
            }
        },
        navigator: {
            userAgent: '',
            onLine: true
        },
        document: {
            createElement: function() {
                return {};
            },
            location: loc,
            referrer: ''
        },
        screen: {
            width: 0,
            height: 0
        },
        location: loc,
        addEventListener: function() {},
        removeEventListener: function() {}
    };
} else win = window;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4QRGB":[function(require,module,exports,__globalThis) {
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 * @returns {boolean}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRecordingExpired", ()=>isRecordingExpired);
parcelHelpers.export(exports, "RECORD_ENQUEUE_THROTTLE_MS", ()=>RECORD_ENQUEUE_THROTTLE_MS);
var isRecordingExpired = function(serializedRecording) {
    var now = Date.now();
    return !serializedRecording || now > serializedRecording['maxExpires'] || now > serializedRecording['idleExpires'];
};
var RECORD_ENQUEUE_THROTTLE_MS = 250;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ei8GX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Autocapture", ()=>Autocapture);
var _utils = require("../utils");
var _window = require("../window");
var _utils1 = require("./utils");
var AUTOCAPTURE_CONFIG_KEY = 'autocapture';
var LEGACY_PAGEVIEW_CONFIG_KEY = 'track_pageview';
var PAGEVIEW_OPTION_FULL_URL = 'full-url';
var PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING = 'url-with-path-and-query-string';
var PAGEVIEW_OPTION_URL_WITH_PATH = 'url-with-path';
var CONFIG_ALLOW_ELEMENT_CALLBACK = 'allow_element_callback';
var CONFIG_ALLOW_SELECTORS = 'allow_selectors';
var CONFIG_ALLOW_URL_REGEXES = 'allow_url_regexes';
var CONFIG_BLOCK_ATTRS = 'block_attrs';
var CONFIG_BLOCK_ELEMENT_CALLBACK = 'block_element_callback';
var CONFIG_BLOCK_SELECTORS = 'block_selectors';
var CONFIG_BLOCK_URL_REGEXES = 'block_url_regexes';
var CONFIG_CAPTURE_EXTRA_ATTRS = 'capture_extra_attrs';
var CONFIG_CAPTURE_TEXT_CONTENT = 'capture_text_content';
var CONFIG_SCROLL_CAPTURE_ALL = 'scroll_capture_all';
var CONFIG_SCROLL_CHECKPOINTS = 'scroll_depth_percent_checkpoints';
var CONFIG_TRACK_CLICK = 'click';
var CONFIG_TRACK_INPUT = 'input';
var CONFIG_TRACK_PAGEVIEW = 'pageview';
var CONFIG_TRACK_SCROLL = 'scroll';
var CONFIG_TRACK_SUBMIT = 'submit';
var CONFIG_DEFAULTS = {};
CONFIG_DEFAULTS[CONFIG_ALLOW_SELECTORS] = [];
CONFIG_DEFAULTS[CONFIG_ALLOW_URL_REGEXES] = [];
CONFIG_DEFAULTS[CONFIG_BLOCK_ATTRS] = [];
CONFIG_DEFAULTS[CONFIG_BLOCK_ELEMENT_CALLBACK] = null;
CONFIG_DEFAULTS[CONFIG_BLOCK_SELECTORS] = [];
CONFIG_DEFAULTS[CONFIG_BLOCK_URL_REGEXES] = [];
CONFIG_DEFAULTS[CONFIG_CAPTURE_EXTRA_ATTRS] = [];
CONFIG_DEFAULTS[CONFIG_CAPTURE_TEXT_CONTENT] = false;
CONFIG_DEFAULTS[CONFIG_SCROLL_CAPTURE_ALL] = false;
CONFIG_DEFAULTS[CONFIG_SCROLL_CHECKPOINTS] = [
    25,
    50,
    75,
    100
];
CONFIG_DEFAULTS[CONFIG_TRACK_CLICK] = true;
CONFIG_DEFAULTS[CONFIG_TRACK_INPUT] = true;
CONFIG_DEFAULTS[CONFIG_TRACK_PAGEVIEW] = PAGEVIEW_OPTION_FULL_URL;
CONFIG_DEFAULTS[CONFIG_TRACK_SCROLL] = true;
CONFIG_DEFAULTS[CONFIG_TRACK_SUBMIT] = true;
var DEFAULT_PROPS = {
    '$mp_autocapture': true
};
var MP_EV_CLICK = '$mp_click';
var MP_EV_INPUT = '$mp_input_change';
var MP_EV_SCROLL = '$mp_scroll';
var MP_EV_SUBMIT = '$mp_submit';
/**
 * Autocapture: manages automatic event tracking
 * @constructor
 */ var Autocapture = function(mp) {
    this.mp = mp;
};
Autocapture.prototype.init = function() {
    if (!(0, _utils1.minDOMApisSupported)()) {
        (0, _utils1.logger).critical('Autocapture unavailable: missing required DOM APIs');
        return;
    }
    this.initPageviewTracking();
    this.initClickTracking();
    this.initInputTracking();
    this.initScrollTracking();
    this.initSubmitTracking();
};
Autocapture.prototype.getFullConfig = function() {
    var autocaptureConfig = this.mp.get_config(AUTOCAPTURE_CONFIG_KEY);
    if (!autocaptureConfig) // Autocapture is completely off
    return {};
    else if ((0, _utils._).isObject(autocaptureConfig)) return (0, _utils._).extend({}, CONFIG_DEFAULTS, autocaptureConfig);
    else // Autocapture config is non-object truthy value, return default
    return CONFIG_DEFAULTS;
};
Autocapture.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
Autocapture.prototype.currentUrlBlocked = function() {
    var i;
    var currentUrl = (0, _utils._).info.currentUrl();
    var allowUrlRegexes = this.getConfig(CONFIG_ALLOW_URL_REGEXES) || [];
    if (allowUrlRegexes.length) {
        // we're using an allowlist, only track if current URL matches
        var allowed = false;
        for(i = 0; i < allowUrlRegexes.length; i++){
            var allowRegex = allowUrlRegexes[i];
            try {
                if (currentUrl.match(allowRegex)) {
                    allowed = true;
                    break;
                }
            } catch (err) {
                (0, _utils1.logger).critical('Error while checking block URL regex: ' + allowRegex, err);
                return true;
            }
        }
        if (!allowed) // wasn't allowed by any regex
        return true;
    }
    var blockUrlRegexes = this.getConfig(CONFIG_BLOCK_URL_REGEXES) || [];
    if (!blockUrlRegexes || !blockUrlRegexes.length) return false;
    for(i = 0; i < blockUrlRegexes.length; i++)try {
        if (currentUrl.match(blockUrlRegexes[i])) return true;
    } catch (err) {
        (0, _utils1.logger).critical('Error while checking block URL regex: ' + blockUrlRegexes[i], err);
        return true;
    }
    return false;
};
Autocapture.prototype.pageviewTrackingConfig = function() {
    // supports both autocapture config and old track_pageview config
    if (this.mp.get_config(AUTOCAPTURE_CONFIG_KEY)) return this.getConfig(CONFIG_TRACK_PAGEVIEW);
    else return this.mp.get_config(LEGACY_PAGEVIEW_CONFIG_KEY);
};
// helper for event handlers
Autocapture.prototype.trackDomEvent = function(ev, mpEventName) {
    if (this.currentUrlBlocked()) return;
    var props = (0, _utils1.getPropsForDOMEvent)(ev, {
        allowElementCallback: this.getConfig(CONFIG_ALLOW_ELEMENT_CALLBACK),
        allowSelectors: this.getConfig(CONFIG_ALLOW_SELECTORS),
        blockAttrs: this.getConfig(CONFIG_BLOCK_ATTRS),
        blockElementCallback: this.getConfig(CONFIG_BLOCK_ELEMENT_CALLBACK),
        blockSelectors: this.getConfig(CONFIG_BLOCK_SELECTORS),
        captureExtraAttrs: this.getConfig(CONFIG_CAPTURE_EXTRA_ATTRS),
        captureTextContent: this.getConfig(CONFIG_CAPTURE_TEXT_CONTENT),
        capturedForHeatMap: mpEventName === MP_EV_CLICK && !this.getConfig(CONFIG_TRACK_CLICK) && this.mp.is_recording_heatmap_data()
    });
    if (props) {
        (0, _utils._).extend(props, DEFAULT_PROPS);
        this.mp.track(mpEventName, props);
    }
};
Autocapture.prototype.initClickTracking = function() {
    (0, _window.window).removeEventListener((0, _utils1.EV_CLICK), this.listenerClick);
    if (!this.getConfig(CONFIG_TRACK_CLICK) && !this.mp.get_config('record_heatmap_data')) return;
    (0, _utils1.logger).log('Initializing click tracking');
    this.listenerClick = (0, _window.window).addEventListener((0, _utils1.EV_CLICK), (function(ev) {
        if (!this.getConfig(CONFIG_TRACK_CLICK) && !this.mp.is_recording_heatmap_data()) return;
        this.trackDomEvent(ev, MP_EV_CLICK);
    }).bind(this));
};
Autocapture.prototype.initInputTracking = function() {
    (0, _window.window).removeEventListener((0, _utils1.EV_CHANGE), this.listenerChange);
    if (!this.getConfig(CONFIG_TRACK_INPUT)) return;
    (0, _utils1.logger).log('Initializing input tracking');
    this.listenerChange = (0, _window.window).addEventListener((0, _utils1.EV_CHANGE), (function(ev) {
        if (!this.getConfig(CONFIG_TRACK_INPUT)) return;
        this.trackDomEvent(ev, MP_EV_INPUT);
    }).bind(this));
};
Autocapture.prototype.initPageviewTracking = function() {
    (0, _window.window).removeEventListener((0, _utils1.EV_POPSTATE), this.listenerPopstate);
    (0, _window.window).removeEventListener((0, _utils1.EV_HASHCHANGE), this.listenerHashchange);
    (0, _window.window).removeEventListener((0, _utils1.EV_MP_LOCATION_CHANGE), this.listenerLocationchange);
    if (!this.pageviewTrackingConfig()) return;
    (0, _utils1.logger).log('Initializing pageview tracking');
    var previousTrackedUrl = '';
    var tracked = false;
    if (!this.currentUrlBlocked()) tracked = this.mp.track_pageview(DEFAULT_PROPS);
    if (tracked) previousTrackedUrl = (0, _utils._).info.currentUrl();
    this.listenerPopstate = (0, _window.window).addEventListener((0, _utils1.EV_POPSTATE), function() {
        (0, _window.window).dispatchEvent(new Event((0, _utils1.EV_MP_LOCATION_CHANGE)));
    });
    this.listenerHashchange = (0, _window.window).addEventListener((0, _utils1.EV_HASHCHANGE), function() {
        (0, _window.window).dispatchEvent(new Event((0, _utils1.EV_MP_LOCATION_CHANGE)));
    });
    var nativePushState = (0, _window.window).history.pushState;
    if (typeof nativePushState === 'function') (0, _window.window).history.pushState = function(state, unused, url) {
        nativePushState.call((0, _window.window).history, state, unused, url);
        (0, _window.window).dispatchEvent(new Event((0, _utils1.EV_MP_LOCATION_CHANGE)));
    };
    var nativeReplaceState = (0, _window.window).history.replaceState;
    if (typeof nativeReplaceState === 'function') (0, _window.window).history.replaceState = function(state, unused, url) {
        nativeReplaceState.call((0, _window.window).history, state, unused, url);
        (0, _window.window).dispatchEvent(new Event((0, _utils1.EV_MP_LOCATION_CHANGE)));
    };
    this.listenerLocationchange = (0, _window.window).addEventListener((0, _utils1.EV_MP_LOCATION_CHANGE), (0, _utils.safewrap)((function() {
        if (this.currentUrlBlocked()) return;
        var currentUrl = (0, _utils._).info.currentUrl();
        var shouldTrack = false;
        var didPathChange = currentUrl.split('#')[0].split('?')[0] !== previousTrackedUrl.split('#')[0].split('?')[0];
        var trackPageviewOption = this.pageviewTrackingConfig();
        if (trackPageviewOption === PAGEVIEW_OPTION_FULL_URL) shouldTrack = currentUrl !== previousTrackedUrl;
        else if (trackPageviewOption === PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING) shouldTrack = currentUrl.split('#')[0] !== previousTrackedUrl.split('#')[0];
        else if (trackPageviewOption === PAGEVIEW_OPTION_URL_WITH_PATH) shouldTrack = didPathChange;
        if (shouldTrack) {
            var tracked = this.mp.track_pageview(DEFAULT_PROPS);
            if (tracked) previousTrackedUrl = currentUrl;
            if (didPathChange) {
                this.lastScrollCheckpoint = 0;
                (0, _utils1.logger).log('Path change: re-initializing scroll depth checkpoints');
            }
        }
    }).bind(this)));
};
Autocapture.prototype.initScrollTracking = function() {
    (0, _window.window).removeEventListener((0, _utils1.EV_SCROLLEND), this.listenerScroll);
    if (!this.getConfig(CONFIG_TRACK_SCROLL)) return;
    (0, _utils1.logger).log('Initializing scroll tracking');
    this.lastScrollCheckpoint = 0;
    this.listenerScroll = (0, _window.window).addEventListener((0, _utils1.EV_SCROLLEND), (0, _utils.safewrap)((function() {
        if (!this.getConfig(CONFIG_TRACK_SCROLL)) return;
        if (this.currentUrlBlocked()) return;
        var shouldTrack = this.getConfig(CONFIG_SCROLL_CAPTURE_ALL);
        var scrollCheckpoints = (this.getConfig(CONFIG_SCROLL_CHECKPOINTS) || []).slice().sort(function(a, b) {
            return a - b;
        });
        var scrollTop = (0, _window.window).scrollY;
        var props = (0, _utils._).extend({
            '$scroll_top': scrollTop
        }, DEFAULT_PROPS);
        try {
            var scrollHeight = (0, _utils.document).body.scrollHeight;
            var scrollPercentage = Math.round(scrollTop / (scrollHeight - (0, _window.window).innerHeight) * 100);
            props['$scroll_height'] = scrollHeight;
            props['$scroll_percentage'] = scrollPercentage;
            if (scrollPercentage > this.lastScrollCheckpoint) for(var i = 0; i < scrollCheckpoints.length; i++){
                var checkpoint = scrollCheckpoints[i];
                if (scrollPercentage >= checkpoint && this.lastScrollCheckpoint < checkpoint) {
                    props['$scroll_checkpoint'] = checkpoint;
                    this.lastScrollCheckpoint = checkpoint;
                    shouldTrack = true;
                }
            }
        } catch (err) {
            (0, _utils1.logger).critical('Error while calculating scroll percentage', err);
        }
        if (shouldTrack) this.mp.track(MP_EV_SCROLL, props);
    }).bind(this)));
};
Autocapture.prototype.initSubmitTracking = function() {
    (0, _window.window).removeEventListener((0, _utils1.EV_SUBMIT), this.listenerSubmit);
    if (!this.getConfig(CONFIG_TRACK_SUBMIT)) return;
    (0, _utils1.logger).log('Initializing submit tracking');
    this.listenerSubmit = (0, _window.window).addEventListener((0, _utils1.EV_SUBMIT), (function(ev) {
        if (!this.getConfig(CONFIG_TRACK_SUBMIT)) return;
        this.trackDomEvent(ev, MP_EV_SUBMIT);
    }).bind(this));
};
// TODO integrate error_reporter from mixpanel instance
(0, _utils.safewrapClass)(Autocapture);

},{"../utils":"7v0z9","../window":"hzg1R","./utils":"gercJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gercJ":[function(require,module,exports,__globalThis) {
// stateless utils
// mostly from https://github.com/mixpanel/mixpanel-js/blob/989ada50f518edab47b9c4fd9535f9fbd5ec5fc0/src/autotrack-utils.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPropsForDOMEvent", ()=>getPropsForDOMEvent);
parcelHelpers.export(exports, "getSafeText", ()=>getSafeText);
parcelHelpers.export(exports, "logger", ()=>logger);
parcelHelpers.export(exports, "minDOMApisSupported", ()=>minDOMApisSupported);
parcelHelpers.export(exports, "shouldTrackDomEvent", ()=>shouldTrackDomEvent);
parcelHelpers.export(exports, "shouldTrackElementDetails", ()=>shouldTrackElementDetails);
parcelHelpers.export(exports, "shouldTrackValue", ()=>shouldTrackValue);
parcelHelpers.export(exports, "EV_CHANGE", ()=>EV_CHANGE);
parcelHelpers.export(exports, "EV_CLICK", ()=>EV_CLICK);
parcelHelpers.export(exports, "EV_HASHCHANGE", ()=>EV_HASHCHANGE);
parcelHelpers.export(exports, "EV_MP_LOCATION_CHANGE", ()=>EV_MP_LOCATION_CHANGE);
parcelHelpers.export(exports, "EV_POPSTATE", ()=>EV_POPSTATE);
parcelHelpers.export(exports, "EV_SCROLLEND", ()=>EV_SCROLLEND);
parcelHelpers.export(exports, "EV_SUBMIT", ()=>EV_SUBMIT);
var _utils = require("../utils"); // eslint-disable-line camelcase
var _window = require("../window");
var EV_CHANGE = 'change';
var EV_CLICK = 'click';
var EV_HASHCHANGE = 'hashchange';
var EV_MP_LOCATION_CHANGE = 'mp_locationchange';
var EV_POPSTATE = 'popstate';
// TODO scrollend isn't available in Safari: document or polyfill?
var EV_SCROLLEND = 'scrollend';
var EV_SUBMIT = 'submit';
var CLICK_EVENT_PROPS = [
    'clientX',
    'clientY',
    'offsetX',
    'offsetY',
    'pageX',
    'pageY',
    'screenX',
    'screenY',
    'x',
    'y'
];
var OPT_IN_CLASSES = [
    'mp-include'
];
var OPT_OUT_CLASSES = [
    'mp-no-track'
];
var SENSITIVE_DATA_CLASSES = OPT_OUT_CLASSES.concat([
    'mp-sensitive'
]);
var TRACKED_ATTRS = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'href',
    'name',
    'role',
    'title',
    'type'
];
var logger = (0, _utils.console_with_prefix)('autocapture');
function getClasses(el) {
    var classes = {};
    var classList = getClassName(el).split(' ');
    for(var i = 0; i < classList.length; i++){
        var cls = classList[i];
        if (cls) classes[cls] = true;
    }
    return classes;
}
/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */ function getClassName(el) {
    switch(typeof el.className){
        case 'string':
            return el.className;
        case 'object':
            return el.className.baseVal || el.getAttribute('class') || '';
        default:
            return '';
    }
}
function getPreviousElementSibling(el) {
    if (el.previousElementSibling) return el.previousElementSibling;
    else {
        do el = el.previousSibling;
        while (el && !isElementNode(el));
        return el;
    }
}
function getPropertiesFromElement(el, ev, blockAttrsSet, extraAttrs, allowElementCallback, allowSelectors) {
    var props = {
        '$classes': getClassName(el).split(' '),
        '$tag_name': el.tagName.toLowerCase()
    };
    var elId = el.id;
    if (elId) props['$id'] = elId;
    if (shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors)) (0, _utils._).each(TRACKED_ATTRS.concat(extraAttrs), function(attr) {
        if (el.hasAttribute(attr) && !blockAttrsSet[attr]) {
            var attrVal = el.getAttribute(attr);
            if (shouldTrackValue(attrVal)) props['$attr-' + attr] = attrVal;
        }
    });
    var nthChild = 1;
    var nthOfType = 1;
    var currentElem = el;
    while(currentElem = getPreviousElementSibling(currentElem)){
        nthChild++;
        if (currentElem.tagName === el.tagName) nthOfType++;
    }
    props['$nth_child'] = nthChild;
    props['$nth_of_type'] = nthOfType;
    return props;
}
function getPropsForDOMEvent(ev, config) {
    var allowElementCallback = config.allowElementCallback;
    var allowSelectors = config.allowSelectors || [];
    var blockAttrs = config.blockAttrs || [];
    var blockElementCallback = config.blockElementCallback;
    var blockSelectors = config.blockSelectors || [];
    var captureTextContent = config.captureTextContent || false;
    var captureExtraAttrs = config.captureExtraAttrs || [];
    var capturedForHeatMap = config.capturedForHeatMap || false;
    // convert array to set every time, as the config may have changed
    var blockAttrsSet = {};
    (0, _utils._).each(blockAttrs, function(attr) {
        blockAttrsSet[attr] = true;
    });
    var props = null;
    var target = typeof ev.target === 'undefined' ? ev.srcElement : ev.target;
    if (isTextNode(target)) target = target.parentNode;
    if (shouldTrackDomEvent(target, ev) && isElementAllowed(target, ev, allowElementCallback, allowSelectors) && !isElementBlocked(target, ev, blockElementCallback, blockSelectors)) {
        var targetElementList = [
            target
        ];
        var curEl = target;
        while(curEl.parentNode && !isTag(curEl, 'body')){
            targetElementList.push(curEl.parentNode);
            curEl = curEl.parentNode;
        }
        var elementsJson = [];
        var href, explicitNoTrack = false;
        (0, _utils._).each(targetElementList, function(el) {
            var shouldTrackDetails = shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors);
            // if the element or a parent element is an anchor tag
            // include the href as a property
            if (!blockAttrsSet['href'] && el.tagName.toLowerCase() === 'a') {
                href = el.getAttribute('href');
                href = shouldTrackDetails && shouldTrackValue(href) && href;
            }
            if (isElementBlocked(el, ev, blockElementCallback, blockSelectors)) explicitNoTrack = true;
            elementsJson.push(getPropertiesFromElement(el, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors));
        }, this);
        if (!explicitNoTrack) {
            var docElement = (0, _utils.document)['documentElement'];
            props = {
                '$event_type': ev.type,
                '$host': (0, _window.window).location.host,
                '$pathname': (0, _window.window).location.pathname,
                '$elements': elementsJson,
                '$el_attr__href': href,
                '$viewportHeight': Math.max(docElement['clientHeight'], (0, _window.window)['innerHeight'] || 0),
                '$viewportWidth': Math.max(docElement['clientWidth'], (0, _window.window)['innerWidth'] || 0)
            };
            (0, _utils._).each(captureExtraAttrs, function(attr) {
                if (!blockAttrsSet[attr] && target.hasAttribute(attr)) {
                    var attrVal = target.getAttribute(attr);
                    if (shouldTrackValue(attrVal)) props['$el_attr__' + attr] = attrVal;
                }
            });
            if (captureTextContent) {
                elementText = getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (ev.type === EV_CLICK) {
                (0, _utils._).each(CLICK_EVENT_PROPS, function(prop) {
                    if (prop in ev) props['$' + prop] = ev[prop];
                });
                if (capturedForHeatMap) props['$captured_for_heatmap'] = true;
                target = guessRealClickTarget(ev);
            }
            // prioritize text content from "real" click target if different from original target
            if (captureTextContent) {
                var elementText = getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (target) {
                // target may have been recalculated; check allowlists and blocklists again
                if (!isElementAllowed(target, ev, allowElementCallback, allowSelectors) || isElementBlocked(target, ev, blockElementCallback, blockSelectors)) return null;
                var targetProps = getPropertiesFromElement(target, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors);
                props['$target'] = targetProps;
                // pull up more props onto main event props
                props['$el_classes'] = targetProps['$classes'];
                (0, _utils._).extend(props, (0, _utils._).strip_empty_properties({
                    '$el_id': targetProps['$id'],
                    '$el_tag_name': targetProps['$tag_name']
                }));
            }
        }
    }
    return props;
}
/**
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {string} the element's direct text content
 */ function getSafeText(el, ev, allowElementCallback, allowSelectors) {
    var elText = '';
    if (shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) && el.childNodes && el.childNodes.length) (0, _utils._).each(el.childNodes, function(child) {
        if (isTextNode(child) && child.textContent) elText += (0, _utils._).trim(child.textContent)// scrub potentially sensitive values
        .split(/(\s+)/).filter(shouldTrackValue).join('')// normalize whitespace
        .replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ')// truncate
        .substring(0, 255);
    });
    return (0, _utils._).trim(elText);
}
function guessRealClickTarget(ev) {
    var target = ev.target;
    var composedPath = ev['composedPath']();
    for(var i = 0; i < composedPath.length; i++){
        var node = composedPath[i];
        if (isTag(node, 'a') || isTag(node, 'button') || isTag(node, 'input') || isTag(node, 'select') || node.getAttribute && node.getAttribute('role') === 'button') {
            target = node;
            break;
        }
        if (node === target) break;
    }
    return target;
}
function isElementAllowed(el, ev, allowElementCallback, allowSelectors) {
    if (allowElementCallback) try {
        if (!allowElementCallback(el, ev)) return false;
    } catch (err) {
        logger.critical('Error while checking element in allowElementCallback', err);
        return false;
    }
    if (!allowSelectors.length) // no allowlist; all elements are fair game
    return true;
    for(var i = 0; i < allowSelectors.length; i++){
        var sel = allowSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            logger.critical('Error while checking selector: ' + sel, err);
        }
    }
    return false;
}
function isElementBlocked(el, ev, blockElementCallback, blockSelectors) {
    var i;
    if (blockElementCallback) try {
        if (blockElementCallback(el, ev)) return true;
    } catch (err) {
        logger.critical('Error while checking element in blockElementCallback', err);
        return true;
    }
    if (blockSelectors && blockSelectors.length) // programmatically prevent tracking of elements that match CSS selectors
    for(i = 0; i < blockSelectors.length; i++){
        var sel = blockSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            logger.critical('Error while checking selector: ' + sel, err);
        }
    }
    // allow users to programmatically prevent tracking of elements by adding default classes such as 'mp-no-track'
    var classes = getClasses(el);
    for(i = 0; i < OPT_OUT_CLASSES.length; i++){
        if (classes[OPT_OUT_CLASSES[i]]) return true;
    }
    return false;
}
/*
 * Check whether a DOM node has nodeType Node.ELEMENT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of the correct nodeType
 */ function isElementNode(node) {
    return node && node.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}
/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */ function isTag(el, tag) {
    return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}
/*
 * Check whether a DOM node is a TEXT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of type Node.TEXT_NODE
 */ function isTextNode(node) {
    return node && node.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}
function minDOMApisSupported() {
    try {
        var testEl = (0, _utils.document).createElement('div');
        return !!testEl['matches'];
    } catch (err) {
        return false;
    }
}
/*
 * Check whether a DOM event should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} ev - event to check
 * @returns {boolean} whether the event should be tracked
 */ function shouldTrackDomEvent(el, ev) {
    if (!el || isTag(el, 'html') || !isElementNode(el)) return false;
    var tag = el.tagName.toLowerCase();
    switch(tag){
        case 'form':
            return ev.type === EV_SUBMIT;
        case 'input':
            if ([
                'button',
                'submit'
            ].indexOf(el.getAttribute('type')) === -1) return ev.type === EV_CHANGE;
            else return ev.type === EV_CLICK;
        case 'select':
        case 'textarea':
            return ev.type === EV_CHANGE;
        default:
            return ev.type === EV_CLICK;
    }
}
/*
 * Check whether a DOM element should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {boolean} whether the element should be tracked
 */ function shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) {
    var i;
    if (!isElementAllowed(el, ev, allowElementCallback, allowSelectors)) return false;
    for(var curEl = el; curEl.parentNode && !isTag(curEl, 'body'); curEl = curEl.parentNode){
        var classes = getClasses(curEl);
        for(i = 0; i < SENSITIVE_DATA_CLASSES.length; i++){
            if (classes[SENSITIVE_DATA_CLASSES[i]]) return false;
        }
    }
    var elClasses = getClasses(el);
    for(i = 0; i < OPT_IN_CLASSES.length; i++){
        if (elClasses[OPT_IN_CLASSES[i]]) return true;
    }
    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    if (isTag(el, 'input') || isTag(el, 'select') || isTag(el, 'textarea') || el.getAttribute('contenteditable') === 'true') return false;
    // don't include hidden or password fields
    var type = el.type || '';
    if (typeof type === 'string') switch(type.toLowerCase()){
        case 'hidden':
            return false;
        case 'password':
            return false;
    }
    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || '';
    if (typeof name === 'string') {
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) return false;
    }
    return true;
}
/*
 * Check whether a string value should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be tracked
 */ function shouldTrackValue(value) {
    if (value === null || (0, _utils._).isUndefined(value)) return false;
    if (typeof value === 'string') {
        value = (0, _utils._).trim(value);
        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || '').replace(/[- ]/g, ''))) return false;
        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) return false;
    }
    return true;
}

},{"../utils":"7v0z9","../window":"hzg1R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3iAPt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeatureFlagManager", ()=>FeatureFlagManager);
var _utils = require("../utils"); // eslint-disable-line camelcase
var _window = require("../window");
var fetch = (0, _window.window)['fetch'];
var logger = (0, _utils.console_with_prefix)('flags');
var FLAGS_CONFIG_KEY = 'flags';
var CONFIG_CONTEXT = 'context';
var CONFIG_DEFAULTS = {};
CONFIG_DEFAULTS[CONFIG_CONTEXT] = {};
/**
 * FeatureFlagManager: support for Mixpanel's feature flagging product
 * @constructor
 */ var FeatureFlagManager = function(initOptions) {
    this.getMpConfig = initOptions.getConfigFunc;
    this.getDistinctId = initOptions.getDistinctIdFunc;
    this.track = initOptions.trackingFunc;
};
FeatureFlagManager.prototype.init = function() {
    if (!minApisSupported()) {
        logger.critical('Feature Flags unavailable: missing minimum required APIs');
        return;
    }
    this.flags = null;
    this.fetchFlags();
    this.trackedFeatures = new Set();
};
FeatureFlagManager.prototype.getFullConfig = function() {
    var ffConfig = this.getMpConfig(FLAGS_CONFIG_KEY);
    if (!ffConfig) // flags are completely off
    return {};
    else if ((0, _utils._).isObject(ffConfig)) return (0, _utils._).extend({}, CONFIG_DEFAULTS, ffConfig);
    else // config is non-object truthy value, return default
    return CONFIG_DEFAULTS;
};
FeatureFlagManager.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
FeatureFlagManager.prototype.isEnabled = function() {
    return !!this.getMpConfig(FLAGS_CONFIG_KEY);
};
FeatureFlagManager.prototype.areFeaturesReady = function() {
    if (!this.isEnabled()) logger.error('Feature Flags not enabled');
    return !!this.flags;
};
FeatureFlagManager.prototype.fetchFlags = function() {
    if (!this.isEnabled()) return;
    var distinctId = this.getDistinctId();
    logger.log('Fetching flags for distinct ID: ' + distinctId);
    var reqParams = {
        'context': (0, _utils._).extend({
            'distinct_id': distinctId
        }, this.getConfig(CONFIG_CONTEXT))
    };
    this.fetchPromise = (0, _window.window)['fetch'](this.getMpConfig('api_host') + '/' + this.getMpConfig('api_routes')['flags'], {
        'method': 'POST',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.getMpConfig('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        'body': JSON.stringify(reqParams)
    }).then((function(response) {
        return response.json().then((function(responseBody) {
            var responseFlags = responseBody['flags'];
            if (!responseFlags) throw new Error('No flags in API response');
            var flags = new Map();
            (0, _utils._).each(responseFlags, function(data, key) {
                flags.set(key, {
                    'key': data['variant_key'],
                    'data': data['variant_value']
                });
            });
            this.flags = flags;
        }).bind(this)).catch(function(error) {
            logger.error(error);
        });
    }).bind(this)).catch(function() {});
};
FeatureFlagManager.prototype.getFeature = function(featureName, fallback) {
    if (!this.fetchPromise) return new Promise(function(resolve) {
        logger.critical('Feature Flags not initialized');
        resolve(fallback);
    });
    return this.fetchPromise.then((function() {
        return this.getFeatureSync(featureName, fallback);
    }).bind(this)).catch(function(error) {
        logger.error(error);
        return fallback;
    });
};
FeatureFlagManager.prototype.getFeatureSync = function(featureName, fallback) {
    if (!this.areFeaturesReady()) {
        logger.log('Flags not loaded yet');
        return fallback;
    }
    var feature = this.flags.get(featureName);
    if (!feature) {
        logger.log('No flag found: "' + featureName + '"');
        return fallback;
    }
    this.trackFeatureCheck(featureName, feature);
    return feature;
};
FeatureFlagManager.prototype.getFeatureData = function(featureName, fallbackValue) {
    return this.getFeature(featureName, {
        'data': fallbackValue
    }).then(function(feature) {
        return feature['data'];
    }).catch(function(error) {
        logger.error(error);
        return fallbackValue;
    });
};
FeatureFlagManager.prototype.getFeatureDataSync = function(featureName, fallbackValue) {
    return this.getFeatureSync(featureName, {
        'data': fallbackValue
    })['data'];
};
FeatureFlagManager.prototype.isFeatureEnabled = function(featureName, fallbackValue) {
    return this.getFeatureData(featureName).then((function() {
        return this.isFeatureEnabledSync(featureName, fallbackValue);
    }).bind(this)).catch(function(error) {
        logger.error(error);
        return fallbackValue;
    });
};
FeatureFlagManager.prototype.isFeatureEnabledSync = function(featureName, fallbackValue) {
    fallbackValue = fallbackValue || false;
    var val = this.getFeatureDataSync(featureName, fallbackValue);
    if (val !== true && val !== false) {
        logger.error('Feature flag "' + featureName + '" value: ' + val + ' is not a boolean; returning fallback value: ' + fallbackValue);
        val = fallbackValue;
    }
    return val;
};
FeatureFlagManager.prototype.trackFeatureCheck = function(featureName, feature) {
    if (this.trackedFeatures.has(featureName)) return;
    this.trackedFeatures.add(featureName);
    this.track('$experiment_started', {
        'Experiment name': featureName,
        'Variant name': feature['key'],
        '$experiment_type': 'feature_flag'
    });
};
function minApisSupported() {
    return !!fetch && typeof Promise !== 'undefined' && typeof Map !== 'undefined' && typeof Set !== 'undefined';
}
(0, _utils.safewrapClass)(FeatureFlagManager);
FeatureFlagManager.prototype['are_features_ready'] = FeatureFlagManager.prototype.areFeaturesReady;
FeatureFlagManager.prototype['get_feature'] = FeatureFlagManager.prototype.getFeature;
FeatureFlagManager.prototype['get_feature_data'] = FeatureFlagManager.prototype.getFeatureData;
FeatureFlagManager.prototype['get_feature_data_sync'] = FeatureFlagManager.prototype.getFeatureDataSync;
FeatureFlagManager.prototype['get_feature_sync'] = FeatureFlagManager.prototype.getFeatureSync;
FeatureFlagManager.prototype['is_feature_enabled'] = FeatureFlagManager.prototype.isFeatureEnabled;
FeatureFlagManager.prototype['is_feature_enabled_sync'] = FeatureFlagManager.prototype.isFeatureEnabledSync;

},{"../utils":"7v0z9","../window":"hzg1R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7g9m5":[function(require,module,exports,__globalThis) {
/* eslint camelcase: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormTracker", ()=>FormTracker);
parcelHelpers.export(exports, "LinkTracker", ()=>LinkTracker);
var _utils = require("./utils");
/**
 * DomTracker Object
 * @constructor
 */ var DomTracker = function() {};
// interface
DomTracker.prototype.create_properties = function() {};
DomTracker.prototype.event_handler = function() {};
DomTracker.prototype.after_track_handler = function() {};
DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = (0, _utils._).dom_query(query);
    if (elements.length === 0) {
        (0, _utils.console).error('The DOM query (' + query + ') returned 0 elements');
        return;
    }
    (0, _utils._).each(elements, function(element) {
        (0, _utils._).register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === 'function') props = properties(element);
    else props = (0, _utils._).extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var LinkTracker = function() {
    this.override_event = 'click';
};
(0, _utils._).inherit(LinkTracker, DomTracker);
LinkTracker.prototype.create_properties = function(properties, element) {
    var props = LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props['url'] = element.href;
    return props;
};
LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var FormTracker = function() {
    this.override_event = 'submit';
};
(0, _utils._).inherit(FormTracker, DomTracker);
FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};

},{"./utils":"7v0z9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Zs9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestBatcher", ()=>RequestBatcher);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _promisePolyfill = require("./promise-polyfill");
var _requestQueue = require("./request-queue");
var _utils = require("./utils"); // eslint-disable-line camelcase
// maximum interval between request retries after exponential backoff
var MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var logger = (0, _utils.console_with_prefix)('batch');
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new (0, _requestQueue.RequestQueue)(storageKey, {
        errorReporter: (0, _utils._).bind(this.reportError, this),
        queueStorage: options.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        sharedLockTimeoutMS: options.sharedLockTimeoutMS,
        usePersistence: options.usePersistence,
        enqueueThrottleMs: options.enqueueThrottleMs
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];
    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
    // Make the flush occur at the interval specified by flushIntervalMs, default behavior will attempt consecutive flushes
    // as long as the queue is not empty. This is useful for high-frequency events like Session Replay where we might end up
    // in a request loop and get ratelimited by the server.
    this.flushOnlyOnInterval = options.flushOnlyOnInterval || false;
    this._flushPromise = null;
};
/**
 * Add one item to queue.
 */ RequestBatcher.prototype.enqueue = function(item) {
    return this.queue.enqueue(item, this.flushInterval);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    return this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ RequestBatcher.prototype.clear = function() {
    return this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout((0, _utils._).bind(function() {
        if (!this.stopped) this._flushPromise = this.flush();
    }, this), this.flushInterval);
};
/**
 * Send a request using the sendRequest callback, but promisified.
 * TODO: sendRequest should be promisified in the first place.
 */ RequestBatcher.prototype.sendRequestPromise = function(data, options) {
    return new (0, _promisePolyfill.Promise)((0, _utils._).bind(function(resolve) {
        this.sendRequest(data, options, resolve);
    }, this));
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ RequestBatcher.prototype.flush = function(options) {
    if (this.requestInProgress) {
        logger.log('Flush: Request already in progress');
        return (0, _promisePolyfill.Promise).resolve();
    }
    this.requestInProgress = true;
    options = options || {};
    var timeoutMS = this.libConfig['batch_request_timeout_ms'];
    var startTime = new Date().getTime();
    var currentBatchSize = this.batchSize;
    return this.queue.fillBatch(currentBatchSize).then((0, _utils._).bind(function(batch) {
        // if there's more items in the queue than the batch size, attempt
        // to flush again after the current batch is done.
        var attemptSecondaryFlush = batch.length === currentBatchSize;
        var dataForRequest = [];
        var transformedItems = {};
        (0, _utils._).each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload['event'] && payload['properties']) payload['properties'] = (0, _utils._).extend({}, payload['properties'], {
                    'mp_sent_by_lib_version': (0, _configDefault.default).LIB_VERSION
                });
                var addPayload = true;
                var itemId = item['id'];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError('[dupe] item ID sent too many times, not sending', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError('[dupe] found item with no ID', {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.requestInProgress = false;
            this.resetFlush();
            return (0, _promisePolyfill.Promise).resolve(); // nothing to do
        }
        var removeItemsFromQueue = (0, _utils._).bind(function() {
            return this.queue.removeItemsByID((0, _utils._).map(batch, function(item) {
                return item['id'];
            })).then((0, _utils._).bind(function(succeeded) {
                // client-side dedupe
                (0, _utils._).each(batch, (0, _utils._).bind(function(item) {
                    var itemId = item['id'];
                    if (itemId) {
                        this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                        this.itemIdsSentSuccessfully[itemId]++;
                        if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError('[dupe] item ID sent too many times', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                    } else this.reportError('[dupe] found item with no ID while removing', {
                        item: item
                    });
                }, this));
                if (succeeded) {
                    this.consecutiveRemovalFailures = 0;
                    if (this.flushOnlyOnInterval && !attemptSecondaryFlush) {
                        this.resetFlush(); // schedule next batch with a delay
                        return (0, _promisePolyfill.Promise).resolve();
                    } else return this.flush(); // handle next batch if the queue isn't empty
                } else {
                    if (++this.consecutiveRemovalFailures > 5) {
                        this.reportError('Too many queue failures; disabling batching system.');
                        this.stopAllBatching();
                    } else this.resetFlush();
                    return (0, _promisePolyfill.Promise).resolve();
                }
            }, this));
        }, this);
        var batchSendCallback = (0, _utils._).bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                if (options.unloading) // update persisted data to include hook transformations
                return this.queue.updatePayloads(transformedItems);
                else if ((0, _utils._).isObject(res) && res.error === 'timeout' && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError('Network timeout; retrying');
                    return this.flush();
                } else if ((0, _utils._).isObject(res) && (res.httpStatusCode >= 500 || res.httpStatusCode === 429 || res.httpStatusCode <= 0 && !(0, _utils.isOnline)() || res.error === 'timeout')) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    if (res.retryAfter) retryMS = parseInt(res.retryAfter, 10) * 1000 || retryMS;
                    retryMS = Math.min(MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                    return (0, _promisePolyfill.Promise).resolve();
                } else if ((0, _utils._).isObject(res) && res.httpStatusCode === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                        return (0, _promisePolyfill.Promise).resolve();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        return removeItemsFromQueue();
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                return removeItemsFromQueue();
            } catch (err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = 'sendBeacon';
        logger.log('MIXPANEL REQUEST:', dataForRequest);
        return this.sendRequestPromise(dataForRequest, requestOptions).then(batchSendCallback);
    }, this)).catch((0, _utils._).bind(function(err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }, this));
};
/**
 * Log error to global logger and optional user-defined logger.
 */ RequestBatcher.prototype.reportError = function(msg, err) {
    logger.error.apply(logger.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        logger.error(err);
    }
};

},{"./config":"dsCxa","./promise-polyfill":"4m5ur","./request-queue":"dxEkI","./utils":"7v0z9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dxEkI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestQueue", ()=>RequestQueue);
var _sharedLock = require("./shared-lock");
var _utils = require("./utils"); // eslint-disable-line camelcase
var _window = require("./window");
var _localStorage = require("./storage/local-storage");
var _promisePolyfill = require("./promise-polyfill");
var logger = (0, _utils.console_with_prefix)('batch');
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.usePersistence = options.usePersistence;
    if (this.usePersistence) {
        this.queueStorage = options.queueStorage || new (0, _localStorage.LocalStorageWrapper)();
        this.lock = new (0, _sharedLock.SharedLock)(storageKey, {
            storage: options.sharedLockStorage || (0, _window.window).localStorage,
            timeoutMS: options.sharedLockTimeoutMS
        });
    }
    this.reportError = options.errorReporter || (0, _utils._).bind(logger.error, logger);
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
    this.initialized = false;
    if (options.enqueueThrottleMs) this.enqueuePersisted = (0, _utils.batchedThrottle)((0, _utils._).bind(this._enqueuePersisted, this), options.enqueueThrottleMs);
    else this.enqueuePersisted = (0, _utils._).bind(function(queueEntry) {
        return this._enqueuePersisted([
            queueEntry
        ]);
    }, this);
};
RequestQueue.prototype.ensureInit = function() {
    if (this.initialized) return (0, _promisePolyfill.Promise).resolve();
    return this.queueStorage.init().then((0, _utils._).bind(function() {
        this.initialized = true;
    }, this)).catch((0, _utils._).bind(function(err) {
        this.reportError('Error initializing queue persistence. Disabling persistence', err);
        this.initialized = true;
        this.usePersistence = false;
    }, this));
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ RequestQueue.prototype.enqueue = function(item, flushInterval) {
    var queueEntry = {
        'id': (0, _utils.cheap_guid)(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };
    if (!this.usePersistence) {
        this.memQueue.push(queueEntry);
        return (0, _promisePolyfill.Promise).resolve(true);
    } else return this.enqueuePersisted(queueEntry);
};
RequestQueue.prototype._enqueuePersisted = function(queueEntries) {
    var enqueueItem = (0, _utils._).bind(function() {
        return this.ensureInit().then((0, _utils._).bind(function() {
            return this.readFromStorage();
        }, this)).then((0, _utils._).bind(function(storedQueue) {
            return this.saveToStorage(storedQueue.concat(queueEntries));
        }, this)).then((0, _utils._).bind(function(succeeded) {
            // only add to in-memory queue when storage succeeds
            if (succeeded) this.memQueue = this.memQueue.concat(queueEntries);
            return succeeded;
        }, this)).catch((0, _utils._).bind(function(err) {
            this.reportError('Error enqueueing items', err, queueEntries);
            return false;
        }, this));
    }, this);
    return this.lock.withLock(enqueueItem, this.pid).catch((0, _utils._).bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (this.usePersistence && batch.length < batchSize) // don't need lock just to read events; localStorage is thread-safe
    // and the worst that could happen is a duplicate send of some
    // orphaned events, which will be deduplicated on the server side
    return this.ensureInit().then((0, _utils._).bind(function() {
        return this.readFromStorage();
    }, this)).then((0, _utils._).bind(function(storedQueue) {
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            (0, _utils._).each(batch, function(item) {
                idsInBatch[item['id']] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
        return batch;
    }, this));
    else return (0, _promisePolyfill.Promise).resolve(batch);
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    (0, _utils._).each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ RequestQueue.prototype.removeItemsByID = function(ids) {
    var idSet = {}; // poor man's Set
    (0, _utils._).each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = filterOutIDsAndInvalid(this.memQueue, idSet);
    if (!this.usePersistence) return (0, _promisePolyfill.Promise).resolve(true);
    else {
        var removeFromStorage = (0, _utils._).bind(function() {
            return this.ensureInit().then((0, _utils._).bind(function() {
                return this.readFromStorage();
            }, this)).then((0, _utils._).bind(function(storedQueue) {
                storedQueue = filterOutIDsAndInvalid(storedQueue, idSet);
                return this.saveToStorage(storedQueue);
            }, this)).then((0, _utils._).bind(function() {
                return this.readFromStorage();
            }, this)).then((0, _utils._).bind(function(storedQueue) {
                // an extra check: did storage report success but somehow
                // the items are still there?
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item['id'] && !!idSet[item['id']]) throw new Error('Item not removed from storage');
                }
                return true;
            }, this)).catch((0, _utils._).bind(function(err) {
                this.reportError('Error removing items', err, ids);
                return false;
            }, this));
        }, this);
        return this.lock.withLock(removeFromStorage, this.pid).catch((0, _utils._).bind(function(err) {
            this.reportError('Error acquiring storage lock', err);
            if (!(0, _utils.localStorageSupported)(this.lock.storage, true)) // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            return removeFromStorage().then((0, _utils._).bind(function(success) {
                if (!success) // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                return this.queueStorage.removeItem(this.storageKey).then(function() {
                    return success;
                });
                return success;
            }, this)).catch((0, _utils._).bind(function(err) {
                this.reportError('Error clearing queue', err);
                return false;
            }, this));
            else return false;
        }, this));
    }
};
// internal helper for RequestQueue.updatePayloads
var updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    (0, _utils._).each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ RequestQueue.prototype.updatePayloads = function(itemsToUpdate) {
    this.memQueue = updatePayloads(this.memQueue, itemsToUpdate);
    if (!this.usePersistence) return (0, _promisePolyfill.Promise).resolve(true);
    else return this.lock.withLock((0, _utils._).bind(function lockAcquired() {
        return this.ensureInit().then((0, _utils._).bind(function() {
            return this.readFromStorage();
        }, this)).then((0, _utils._).bind(function(storedQueue) {
            storedQueue = updatePayloads(storedQueue, itemsToUpdate);
            return this.saveToStorage(storedQueue);
        }, this)).catch((0, _utils._).bind(function(err) {
            this.reportError('Error updating items', itemsToUpdate, err);
            return false;
        }, this));
    }, this), this.pid).catch((0, _utils._).bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ RequestQueue.prototype.readFromStorage = function() {
    return this.ensureInit().then((0, _utils._).bind(function() {
        return this.queueStorage.getItem(this.storageKey);
    }, this)).then((0, _utils._).bind(function(storageEntry) {
        if (storageEntry) {
            if (!(0, _utils._).isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
        return storageEntry || [];
    }, this)).catch((0, _utils._).bind(function(err) {
        this.reportError('Error retrieving queue', err);
        return [];
    }, this));
};
/**
 * Serialize the given items array to localStorage.
 */ RequestQueue.prototype.saveToStorage = function(queue) {
    return this.ensureInit().then((0, _utils._).bind(function() {
        return this.queueStorage.setItem(this.storageKey, queue);
    }, this)).then(function() {
        return true;
    }).catch((0, _utils._).bind(function(err) {
        this.reportError('Error saving queue', err);
        return false;
    }, this));
};
/**
 * Clear out queues (memory and localStorage).
 */ RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    if (this.usePersistence) return this.ensureInit().then((0, _utils._).bind(function() {
        return this.queueStorage.removeItem(this.storageKey);
    }, this));
    else return (0, _promisePolyfill.Promise).resolve();
};

},{"./shared-lock":"gkHuT","./utils":"7v0z9","./window":"hzg1R","./storage/local-storage":"kgakj","./promise-polyfill":"4m5ur","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gkHuT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SharedLock", ()=>SharedLock);
var _promisePolyfill = require("./promise-polyfill");
var _utils = require("./utils"); // eslint-disable-line camelcase
var _window = require("./window");
var logger = (0, _utils.console_with_prefix)('lock');
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || (0, _window.window).localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
    // dependency-inject promise implementation for testing purposes
    this.promiseImpl = options.promiseImpl || (0, _promisePolyfill.Promise);
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
SharedLock.prototype.withLock = function(lockedCB, pid) {
    var Promise = this.promiseImpl;
    return new Promise((0, _utils._).bind(function(resolve, reject) {
        var i = pid || new Date().getTime() + '|' + Math.random();
        var startTime = new Date().getTime();
        var key = this.storageKey;
        var pollIntervalMS = this.pollIntervalMS;
        var timeoutMS = this.timeoutMS;
        var storage = this.storage;
        var keyX = key + ':X';
        var keyY = key + ':Y';
        var keyZ = key + ':Z';
        var delay = function(cb) {
            if (new Date().getTime() - startTime > timeoutMS) {
                logger.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
                storage.removeItem(keyZ);
                storage.removeItem(keyY);
                loop();
                return;
            }
            setTimeout(function() {
                try {
                    cb();
                } catch (err) {
                    reject(err);
                }
            }, pollIntervalMS * (Math.random() + 0.1));
        };
        var waitFor = function(predicate, cb) {
            if (predicate()) cb();
            else delay(function() {
                waitFor(predicate, cb);
            });
        };
        var getSetY = function() {
            var valY = storage.getItem(keyY);
            if (valY && valY !== i) return false;
            else {
                storage.setItem(keyY, i);
                if (storage.getItem(keyY) === i) return true;
                else {
                    if (!(0, _utils.localStorageSupported)(storage, true)) reject(new Error('localStorage support dropped while acquiring lock'));
                    return false;
                }
            }
        };
        var loop = function() {
            storage.setItem(keyX, i);
            waitFor(getSetY, function() {
                if (storage.getItem(keyX) === i) {
                    criticalSection();
                    return;
                }
                delay(function() {
                    if (storage.getItem(keyY) !== i) {
                        loop();
                        return;
                    }
                    waitFor(function() {
                        return !storage.getItem(keyZ);
                    }, criticalSection);
                });
            });
        };
        var criticalSection = function() {
            storage.setItem(keyZ, '1');
            var removeLock = function() {
                storage.removeItem(keyZ);
                if (storage.getItem(keyY) === i) storage.removeItem(keyY);
                if (storage.getItem(keyX) === i) storage.removeItem(keyX);
            };
            lockedCB().then(function(ret) {
                removeLock();
                resolve(ret);
            }).catch(function(err) {
                removeLock();
                reject(err);
            });
        };
        try {
            if ((0, _utils.localStorageSupported)(storage, true)) loop();
            else throw new Error('localStorage support check failed');
        } catch (err) {
            reject(err);
        }
    }, this));
};

},{"./promise-polyfill":"4m5ur","./utils":"7v0z9","./window":"hzg1R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kgakj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalStorageWrapper", ()=>LocalStorageWrapper);
var _promisePolyfill = require("../promise-polyfill");
var _utils = require("../utils"); // eslint-disable-line camelcase
var _window = require("../window");
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var LocalStorageWrapper = function(storageOverride) {
    this.storage = storageOverride || (0, _window.window).localStorage;
};
LocalStorageWrapper.prototype.init = function() {
    return (0, _promisePolyfill.Promise).resolve();
};
LocalStorageWrapper.prototype.setItem = function(key, value) {
    return new (0, _promisePolyfill.Promise)((0, _utils._).bind(function(resolve, reject) {
        try {
            this.storage.setItem(key, (0, _utils.JSONStringify)(value));
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
LocalStorageWrapper.prototype.getItem = function(key) {
    return new (0, _promisePolyfill.Promise)((0, _utils._).bind(function(resolve, reject) {
        var item;
        try {
            item = (0, _utils.JSONParse)(this.storage.getItem(key));
        } catch (e) {
            reject(e);
        }
        resolve(item);
    }, this));
};
LocalStorageWrapper.prototype.removeItem = function(key) {
    return new (0, _promisePolyfill.Promise)((0, _utils._).bind(function(resolve, reject) {
        try {
            this.storage.removeItem(key);
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};

},{"../promise-polyfill":"4m5ur","../utils":"7v0z9","../window":"hzg1R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"arC6u":[function(require,module,exports,__globalThis) {
/* eslint camelcase: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MixpanelGroup", ()=>MixpanelGroup);
var _gdprUtils = require("./gdpr-utils");
var _apiActions = require("./api-actions");
var _utils = require("./utils");
/**
 * Mixpanel Group Object
 * @constructor
 */ var MixpanelGroup = function() {};
(0, _utils._).extend(MixpanelGroup.prototype, (0, _apiActions.apiActions));
MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ MixpanelGroup.prototype.set = (0, _gdprUtils.addOptOutCheckMixpanelGroup)(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ((0, _utils._).isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ MixpanelGroup.prototype.set_once = (0, _gdprUtils.addOptOutCheckMixpanelGroup)(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ((0, _utils._).isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ MixpanelGroup.prototype.unset = (0, _gdprUtils.addOptOutCheckMixpanelGroup)(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ MixpanelGroup.prototype.union = (0, _gdprUtils.addOptOutCheckMixpanelGroup)(function(list_name, values, callback) {
    if ((0, _utils._).isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ MixpanelGroup.prototype['delete'] = (0, _gdprUtils.addOptOutCheckMixpanelGroup)(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ MixpanelGroup.prototype.remove = (0, _gdprUtils.addOptOutCheckMixpanelGroup)(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');
    var date_encoded_data = (0, _utils._).encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['groups'],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};
MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};
// MixpanelGroup Exports
MixpanelGroup.prototype['remove'] = MixpanelGroup.prototype.remove;
MixpanelGroup.prototype['set'] = MixpanelGroup.prototype.set;
MixpanelGroup.prototype['set_once'] = MixpanelGroup.prototype.set_once;
MixpanelGroup.prototype['union'] = MixpanelGroup.prototype.union;
MixpanelGroup.prototype['unset'] = MixpanelGroup.prototype.unset;
MixpanelGroup.prototype['toString'] = MixpanelGroup.prototype.toString;

},{"./gdpr-utils":"eQMdi","./api-actions":"i2epH","./utils":"7v0z9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eQMdi":[function(require,module,exports,__globalThis) {
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ parcelHelpers.export(exports, "optIn", ()=>optIn);
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ parcelHelpers.export(exports, "optOut", ()=>optOut);
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ parcelHelpers.export(exports, "hasOptedIn", ()=>hasOptedIn);
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ parcelHelpers.export(exports, "hasOptedOut", ()=>hasOptedOut);
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ parcelHelpers.export(exports, "addOptOutCheckMixpanelLib", ()=>addOptOutCheckMixpanelLib);
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ parcelHelpers.export(exports, "addOptOutCheckMixpanelPeople", ()=>addOptOutCheckMixpanelPeople);
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ parcelHelpers.export(exports, "addOptOutCheckMixpanelGroup", ()=>addOptOutCheckMixpanelGroup);
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ parcelHelpers.export(exports, "clearOptInOut", ()=>clearOptInOut);
var _utils = require("./utils");
var _window = require("./window");
/**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';
function optIn(token, options) {
    _optInOut(true, token, options);
}
function optOut(token, options) {
    _optInOut(false, token, options);
}
function hasOptedIn(token, options) {
    return _getStorageValue(token, options) === '1';
}
function hasOptedOut(token, options) {
    if (_hasDoNotTrackFlagOn(options)) {
        (0, _utils.console).warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = _getStorageValue(token, options) === '0';
    if (optedOut) (0, _utils.console).warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    return optedOut;
}
function addOptOutCheckMixpanelLib(method) {
    return _addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
function addOptOutCheckMixpanelPeople(method) {
    return _addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
function addOptOutCheckMixpanelGroup(method) {
    return _addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
function clearOptInOut(token, options) {
    options = options || {};
    _getStorage(options).remove(_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function _getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? (0, _utils._).localStorage : (0, _utils._).cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function _getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function _getStorageValue(token, options) {
    return _getStorage(options).get(_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function _hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win = options && options.window || (0, _window.window);
    var nav = win['navigator'] || {};
    var hasDntOn = false;
    (0, _utils._).each([
        nav['doNotTrack'],
        nav['msDoNotTrack'],
        win['doNotTrack']
    ], function(dntValue) {
        if ((0, _utils._).includes([
            true,
            1,
            '1',
            'yes'
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function _optInOut(optValue, token, options) {
    if (!(0, _utils._).isString(token) || !token.length) {
        (0, _utils.console).error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }
    options = options || {};
    _getStorage(options).set(_getStorageKey(token, options), optValue ? 1 : 0, (0, _utils._).isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || '$opt_in', options.trackProperties, {
        'send_immediately': true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function _addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests
            if (token) optedOut = hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            (0, _utils.console).error('Unexpected error when checking tracking opt-out status: ' + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === 'function') callback(0);
        return;
    };
}

},{"./utils":"7v0z9","./window":"hzg1R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i2epH":[function(require,module,exports,__globalThis) {
/* eslint camelcase: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SET_ACTION", ()=>SET_ACTION);
parcelHelpers.export(exports, "SET_ONCE_ACTION", ()=>SET_ONCE_ACTION);
parcelHelpers.export(exports, "UNSET_ACTION", ()=>UNSET_ACTION);
parcelHelpers.export(exports, "ADD_ACTION", ()=>ADD_ACTION);
parcelHelpers.export(exports, "APPEND_ACTION", ()=>APPEND_ACTION);
parcelHelpers.export(exports, "UNION_ACTION", ()=>UNION_ACTION);
parcelHelpers.export(exports, "REMOVE_ACTION", ()=>REMOVE_ACTION);
parcelHelpers.export(exports, "DELETE_ACTION", ()=>DELETE_ACTION);
parcelHelpers.export(exports, "apiActions", ()=>apiActions);
var _utils = require("./utils");
/** @const */ var SET_ACTION = '$set';
/** @const */ var SET_ONCE_ACTION = '$set_once';
/** @const */ var UNSET_ACTION = '$unset';
/** @const */ var ADD_ACTION = '$add';
/** @const */ var APPEND_ACTION = '$append';
/** @const */ var UNION_ACTION = '$union';
/** @const */ var REMOVE_ACTION = '$remove';
/** @const */ var DELETE_ACTION = '$delete';
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ((0, _utils._).isObject(prop)) (0, _utils._).each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!(0, _utils._).isArray(prop)) prop = [
            prop
        ];
        (0, _utils._).each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ((0, _utils._).isObject(prop)) (0, _utils._).each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ((0, _utils._).isObject(list_name)) (0, _utils._).each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = (0, _utils._).isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = (0, _utils._).isArray(values) ? values : [
            values
        ];
        data[UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ((0, _utils._).isObject(list_name)) (0, _utils._).each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ((0, _utils._).isObject(list_name)) (0, _utils._).each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[DELETE_ACTION] = '';
        return data;
    }
};

},{"./utils":"7v0z9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"liflk":[function(require,module,exports,__globalThis) {
/* eslint camelcase: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MixpanelPeople", ()=>MixpanelPeople);
var _gdprUtils = require("./gdpr-utils");
var _apiActions = require("./api-actions");
var _utils = require("./utils");
/**
 * Mixpanel People Object
 * @constructor
 */ var MixpanelPeople = function() {};
(0, _utils._).extend(MixpanelPeople.prototype, (0, _apiActions.apiActions));
MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ MixpanelPeople.prototype.set = (0, _gdprUtils.addOptOutCheckMixpanelPeople)(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ((0, _utils._).isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) this._mixpanel['persistence'].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[0, _apiActions.SET_ACTION] = (0, _utils._).extend({}, (0, _utils._).info.people_properties(), data[0, _apiActions.SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ MixpanelPeople.prototype.set_once = (0, _gdprUtils.addOptOutCheckMixpanelPeople)(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ((0, _utils._).isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ MixpanelPeople.prototype.unset = (0, _gdprUtils.addOptOutCheckMixpanelPeople)(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ MixpanelPeople.prototype.increment = (0, _gdprUtils.addOptOutCheckMixpanelPeople)(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ((0, _utils._).isObject(prop)) {
        (0, _utils._).each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    (0, _utils.console).error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ((0, _utils._).isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[0, _apiActions.ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ MixpanelPeople.prototype.append = (0, _gdprUtils.addOptOutCheckMixpanelPeople)(function(list_name, value, callback) {
    if ((0, _utils._).isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ MixpanelPeople.prototype.remove = (0, _gdprUtils.addOptOutCheckMixpanelPeople)(function(list_name, value, callback) {
    if ((0, _utils._).isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ MixpanelPeople.prototype.union = (0, _gdprUtils.addOptOutCheckMixpanelPeople)(function(list_name, values, callback) {
    if ((0, _utils._).isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ MixpanelPeople.prototype.track_charge = (0, _gdprUtils.addOptOutCheckMixpanelPeople)(function(amount, properties, callback) {
    if (!(0, _utils._).isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            (0, _utils.console).error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }
    return this.append('$transactions', (0, _utils._).extend({
        '$amount': amount
    }, properties), callback);
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        (0, _utils.console).error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {
        '$delete': this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};
MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) data['$device_id'] = device_id;
    if (user_id) data['$user_id'] = user_id;
    if (had_persisted_distinct_id) data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    var date_encoded_data = (0, _utils._).encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!(0, _utils._).isUndefined(callback)) {
            if (this._get_config('verbose')) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return (0, _utils._).truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['engage'],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
MixpanelPeople.prototype._enqueue = function(data) {
    if ((0, _apiActions.SET_ACTION) in data) this._mixpanel['persistence']._add_to_people_queue((0, _apiActions.SET_ACTION), data);
    else if ((0, _apiActions.SET_ONCE_ACTION) in data) this._mixpanel['persistence']._add_to_people_queue((0, _apiActions.SET_ONCE_ACTION), data);
    else if ((0, _apiActions.UNSET_ACTION) in data) this._mixpanel['persistence']._add_to_people_queue((0, _apiActions.UNSET_ACTION), data);
    else if ((0, _apiActions.ADD_ACTION) in data) this._mixpanel['persistence']._add_to_people_queue((0, _apiActions.ADD_ACTION), data);
    else if ((0, _apiActions.APPEND_ACTION) in data) this._mixpanel['persistence']._add_to_people_queue((0, _apiActions.APPEND_ACTION), data);
    else if ((0, _apiActions.REMOVE_ACTION) in data) this._mixpanel['persistence']._add_to_people_queue((0, _apiActions.REMOVE_ACTION), data);
    else if ((0, _apiActions.UNION_ACTION) in data) this._mixpanel['persistence']._add_to_people_queue((0, _apiActions.UNION_ACTION), data);
    else (0, _utils.console).error('Invalid call to _enqueue():', data);
};
MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = (0, _utils._).extend({}, this._mixpanel['persistence'].load_queue(action));
    var action_params = queued_data;
    if (!(0, _utils._).isUndefined(queued_data) && (0, _utils._).isObject(queued_data) && !(0, _utils._).isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        _this._mixpanel['persistence'].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            if (!(0, _utils._).isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue((0, _apiActions.SET_ACTION), this.set, _set_callback);
    this._flush_one_queue((0, _apiActions.SET_ONCE_ACTION), this.set_once, _set_once_callback);
    this._flush_one_queue((0, _apiActions.UNSET_ACTION), this.unset, _unset_callback, function(queue) {
        return (0, _utils._).keys(queue);
    });
    this._flush_one_queue((0, _apiActions.ADD_ACTION), this.increment, _add_callback);
    this._flush_one_queue((0, _apiActions.UNION_ACTION), this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel['persistence'].load_queue((0, _apiActions.APPEND_ACTION));
    if (!(0, _utils._).isUndefined($append_queue) && (0, _utils._).isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue((0, _apiActions.APPEND_ACTION), $append_item);
            if (!(0, _utils._).isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel['persistence'].load_queue((0, _apiActions.APPEND_ACTION));
            $append_item = $append_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!(0, _utils._).isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel['persistence'].load_queue((0, _apiActions.REMOVE_ACTION));
    if (!(0, _utils._).isUndefined($remove_queue) && (0, _utils._).isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue((0, _apiActions.REMOVE_ACTION), $remove_item);
            if (!(0, _utils._).isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel['persistence'].load_queue((0, _apiActions.REMOVE_ACTION));
            $remove_item = $remove_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!(0, _utils._).isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};
// MixpanelPeople Exports
MixpanelPeople.prototype['set'] = MixpanelPeople.prototype.set;
MixpanelPeople.prototype['set_once'] = MixpanelPeople.prototype.set_once;
MixpanelPeople.prototype['unset'] = MixpanelPeople.prototype.unset;
MixpanelPeople.prototype['increment'] = MixpanelPeople.prototype.increment;
MixpanelPeople.prototype['append'] = MixpanelPeople.prototype.append;
MixpanelPeople.prototype['remove'] = MixpanelPeople.prototype.remove;
MixpanelPeople.prototype['union'] = MixpanelPeople.prototype.union;
MixpanelPeople.prototype['track_charge'] = MixpanelPeople.prototype.track_charge;
MixpanelPeople.prototype['clear_charges'] = MixpanelPeople.prototype.clear_charges;
MixpanelPeople.prototype['delete_user'] = MixpanelPeople.prototype.delete_user;
MixpanelPeople.prototype['toString'] = MixpanelPeople.prototype.toString;

},{"./gdpr-utils":"eQMdi","./api-actions":"i2epH","./utils":"7v0z9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f96Cp":[function(require,module,exports,__globalThis) {
/* eslint camelcase: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MixpanelPersistence", ()=>MixpanelPersistence);
parcelHelpers.export(exports, "SET_QUEUE_KEY", ()=>SET_QUEUE_KEY);
parcelHelpers.export(exports, "SET_ONCE_QUEUE_KEY", ()=>SET_ONCE_QUEUE_KEY);
parcelHelpers.export(exports, "UNSET_QUEUE_KEY", ()=>UNSET_QUEUE_KEY);
parcelHelpers.export(exports, "ADD_QUEUE_KEY", ()=>ADD_QUEUE_KEY);
parcelHelpers.export(exports, "APPEND_QUEUE_KEY", ()=>APPEND_QUEUE_KEY);
parcelHelpers.export(exports, "REMOVE_QUEUE_KEY", ()=>REMOVE_QUEUE_KEY);
parcelHelpers.export(exports, "UNION_QUEUE_KEY", ()=>UNION_QUEUE_KEY);
parcelHelpers.export(exports, "PEOPLE_DISTINCT_ID_KEY", ()=>PEOPLE_DISTINCT_ID_KEY);
parcelHelpers.export(exports, "ALIAS_ID_KEY", ()=>ALIAS_ID_KEY);
parcelHelpers.export(exports, "EVENT_TIMERS_KEY", ()=>EVENT_TIMERS_KEY);
var _apiActions = require("./api-actions");
var _utils = require("./utils");
/*
 * Constants
 */ /** @const */ var SET_QUEUE_KEY = '__mps';
/** @const */ var SET_ONCE_QUEUE_KEY = '__mpso';
/** @const */ var UNSET_QUEUE_KEY = '__mpus';
/** @const */ var ADD_QUEUE_KEY = '__mpa';
/** @const */ var APPEND_QUEUE_KEY = '__mpap';
/** @const */ var REMOVE_QUEUE_KEY = '__mpr';
/** @const */ var UNION_QUEUE_KEY = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var ALIAS_ID_KEY = '__alias';
/** @const */ var EVENT_TIMERS_KEY = '__timers';
/** @const */ var RESERVED_PROPERTIES = [
    SET_QUEUE_KEY,
    SET_ONCE_QUEUE_KEY,
    UNSET_QUEUE_KEY,
    ADD_QUEUE_KEY,
    APPEND_QUEUE_KEY,
    REMOVE_QUEUE_KEY,
    UNION_QUEUE_KEY,
    PEOPLE_DISTINCT_ID_KEY,
    ALIAS_ID_KEY,
    EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;
    if (config['persistence_name']) this.name = 'mp_' + config['persistence_name'];
    else this.name = 'mp_' + config['token'] + '_mixpanel';
    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        (0, _utils.console).critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }
    if (storage_type === 'localStorage' && (0, _utils._).localStorage.is_supported()) this.storage = (0, _utils._).localStorage;
    else this.storage = (0, _utils._).cookie;
    this.load();
    this.update_config(config);
    this.upgrade();
    this.save();
};
MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    (0, _utils._).each(this['props'], function(v, k) {
        if (!(0, _utils._).include(RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this['props'] = (0, _utils._).extend({}, entry);
};
MixpanelPersistence.prototype.upgrade = function() {
    var old_cookie, old_localstorage;
    // if transferring from cookie to localStorage or vice-versa, copy existing
    // super properties over to new storage mode
    if (this.storage === (0, _utils._).localStorage) {
        old_cookie = (0, _utils._).cookie.parse(this.name);
        (0, _utils._).cookie.remove(this.name);
        (0, _utils._).cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    } else if (this.storage === (0, _utils._).cookie) {
        old_localstorage = (0, _utils._).localStorage.parse(this.name);
        (0, _utils._).localStorage.remove(this.name);
        if (old_localstorage) this.register_once(old_localstorage);
    }
};
MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, (0, _utils.JSONStringify)(this['props']), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this['props'][key];
};
MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ((0, _utils._).isObject(props)) {
        if (typeof default_value === 'undefined') default_value = 'None';
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        (0, _utils._).each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) this['props'][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ MixpanelPersistence.prototype.register = function(props, days) {
    if ((0, _utils._).isObject(props)) {
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        (0, _utils._).extend(this['props'], props);
        this.save();
        return true;
    }
    return false;
};
MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};
MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register((0, _utils._).info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': (0, _utils._).info.referringDomain(referrer) || '$direct'
    }, '');
};
MixpanelPersistence.prototype.get_referrer_info = function() {
    return (0, _utils._).strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};
MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};
MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue((0, _apiActions.SET_ACTION)), set_once_q = this._get_or_create_queue((0, _apiActions.SET_ONCE_ACTION)), unset_q = this._get_or_create_queue((0, _apiActions.UNSET_ACTION)), add_q = this._get_or_create_queue((0, _apiActions.ADD_ACTION)), union_q = this._get_or_create_queue((0, _apiActions.UNION_ACTION)), remove_q = this._get_or_create_queue((0, _apiActions.REMOVE_ACTION), []), append_q = this._get_or_create_queue((0, _apiActions.APPEND_ACTION), []);
    if (q_key === SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        (0, _utils._).extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue((0, _apiActions.ADD_ACTION), q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue((0, _apiActions.UNION_ACTION), q_data);
        this._pop_from_people_queue((0, _apiActions.UNSET_ACTION), q_data);
    } else if (q_key === SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        (0, _utils._).each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue((0, _apiActions.UNSET_ACTION), q_data);
    } else if (q_key === UNSET_QUEUE_KEY) (0, _utils._).each(q_data, function(prop) {
        // undo previously-queued actions on this key
        (0, _utils._).each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        (0, _utils._).each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === ADD_QUEUE_KEY) {
        (0, _utils._).each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue((0, _apiActions.UNSET_ACTION), q_data);
    } else if (q_key === UNION_QUEUE_KEY) {
        (0, _utils._).each(q_data, function(v, k) {
            if ((0, _utils._).isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // Prevent duplicate values
                (0, _utils._).each(v, function(item) {
                    if (!(0, _utils._).include(union_q[k], item)) union_q[k].push(item);
                });
            }
        });
        this._pop_from_people_queue((0, _apiActions.UNSET_ACTION), q_data);
    } else if (q_key === REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue((0, _apiActions.APPEND_ACTION), q_data);
    } else if (q_key === APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue((0, _apiActions.UNSET_ACTION), q_data);
    }
    (0, _utils.console).log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    (0, _utils.console).log(data);
    this.save();
};
MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this['props'][this._get_queue_key(queue)];
    if (!(0, _utils._).isUndefined(q)) (0, _utils._).each(data, function(v, k) {
        if (queue === (0, _apiActions.APPEND_ACTION) || queue === (0, _apiActions.REMOVE_ACTION)) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        (0, _utils._).each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === (0, _apiActions.SET_ACTION)) return SET_QUEUE_KEY;
    else if (queue === (0, _apiActions.SET_ONCE_ACTION)) return SET_ONCE_QUEUE_KEY;
    else if (queue === (0, _apiActions.UNSET_ACTION)) return UNSET_QUEUE_KEY;
    else if (queue === (0, _apiActions.ADD_ACTION)) return ADD_QUEUE_KEY;
    else if (queue === (0, _apiActions.APPEND_ACTION)) return APPEND_QUEUE_KEY;
    else if (queue === (0, _apiActions.REMOVE_ACTION)) return REMOVE_QUEUE_KEY;
    else if (queue === (0, _apiActions.UNION_ACTION)) return UNION_QUEUE_KEY;
    else (0, _utils.console).error('Invalid queue:', queue);
};
MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = (0, _utils._).isUndefined(default_val) ? {} : default_val;
    return this['props'][key] || (this['props'][key] = default_val);
};
MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop(EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this['props'][EVENT_TIMERS_KEY] = timers;
    this.save();
};
MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop(EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!(0, _utils._).isUndefined(timestamp)) {
        delete this['props'][EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};

},{"./api-actions":"i2epH","./utils":"7v0z9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6eJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IDBStorageWrapper", ()=>IDBStorageWrapper);
parcelHelpers.export(exports, "RECORDING_EVENTS_STORE_NAME", ()=>RECORDING_EVENTS_STORE_NAME);
parcelHelpers.export(exports, "RECORDING_REGISTRY_STORE_NAME", ()=>RECORDING_REGISTRY_STORE_NAME);
var _promisePolyfill = require("../promise-polyfill");
var _window = require("../window");
var MIXPANEL_DB_NAME = 'mixpanelBrowserDb';
var RECORDING_EVENTS_STORE_NAME = 'mixpanelRecordingEvents';
var RECORDING_REGISTRY_STORE_NAME = 'mixpanelRecordingRegistry';
// note: increment the version number when adding new object stores
var DB_VERSION = 1;
var OBJECT_STORES = [
    RECORDING_EVENTS_STORE_NAME,
    RECORDING_REGISTRY_STORE_NAME
];
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var IDBStorageWrapper = function(storeName) {
    /**
     * @type {Promise<IDBDatabase>|null}
     */ this.dbPromise = null;
    this.storeName = storeName;
};
IDBStorageWrapper.prototype._openDb = function() {
    return new (0, _promisePolyfill.Promise)(function(resolve, reject) {
        var openRequest = (0, _window.window).indexedDB.open(MIXPANEL_DB_NAME, DB_VERSION);
        openRequest['onerror'] = function() {
            reject(openRequest.error);
        };
        openRequest['onsuccess'] = function() {
            resolve(openRequest.result);
        };
        openRequest['onupgradeneeded'] = function(ev) {
            var db = ev.target.result;
            OBJECT_STORES.forEach(function(storeName) {
                db.createObjectStore(storeName);
            });
        };
    });
};
IDBStorageWrapper.prototype.init = function() {
    if (!(0, _window.window).indexedDB) return (0, _promisePolyfill.Promise).reject('indexedDB is not supported in this browser');
    if (!this.dbPromise) this.dbPromise = this._openDb();
    return this.dbPromise.then(function(dbOrError) {
        if (dbOrError instanceof (0, _window.window)['IDBDatabase']) return (0, _promisePolyfill.Promise).resolve();
        else return (0, _promisePolyfill.Promise).reject(dbOrError);
    });
};
/**
 * @param {IDBTransactionMode} mode
 * @param {function(IDBObjectStore): void} storeCb
 */ IDBStorageWrapper.prototype.makeTransaction = function(mode, storeCb) {
    var storeName = this.storeName;
    var doTransaction = function(db) {
        return new (0, _promisePolyfill.Promise)(function(resolve, reject) {
            var transaction = db.transaction(storeName, mode);
            transaction.oncomplete = function() {
                resolve(transaction);
            };
            transaction.onabort = transaction.onerror = function() {
                reject(transaction.error);
            };
            storeCb(transaction.objectStore(storeName));
        });
    };
    return this.dbPromise.then(doTransaction).catch((function(err) {
        if (err && err['name'] === 'InvalidStateError') {
            // try reopening the DB if the connection is closed
            this.dbPromise = this._openDb();
            return this.dbPromise.then(doTransaction);
        } else return (0, _promisePolyfill.Promise).reject(err);
    }).bind(this));
};
IDBStorageWrapper.prototype.setItem = function(key, value) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.put(value, key);
    });
};
IDBStorageWrapper.prototype.getItem = function(key) {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.get(key);
    }).then(function() {
        return req.result;
    });
};
IDBStorageWrapper.prototype.removeItem = function(key) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.delete(key);
    });
};
IDBStorageWrapper.prototype.getAll = function() {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.getAll();
    }).then(function() {
        return req.result;
    });
};

},{"../promise-polyfill":"4m5ur","../window":"hzg1R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dqbHB":[function(require,module,exports,__globalThis) {
// For loading separate bundles asynchronously via script tag
// so that we don't load them until they are needed at runtime.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadAsync", ()=>loadAsync);
// For builds that have everything in one bundle, no extra work.
parcelHelpers.export(exports, "loadNoop", ()=>loadNoop);
// For builds that do NOT want any extra bundles (e.g. session recorder)
// and just the main SDK, throw an error when trying to load a separate bundle.
// eslint-disable-next-line no-unused-vars
parcelHelpers.export(exports, "loadThrowError", ()=>loadThrowError);
function loadAsync(src, onload) {
    var scriptEl = document.createElement('script');
    scriptEl.type = 'text/javascript';
    scriptEl.async = true;
    scriptEl.onload = onload;
    scriptEl.src = src;
    document.head.appendChild(scriptEl);
}
function loadNoop(_src, onload) {
    onload();
}
function loadThrowError(src, _onload) {
    throw new Error('This build of Mixpanel only includes core SDK functionality, could not load ' + src);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cPu8n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_PROD", ()=>IS_PROD);
parcelHelpers.export(exports, "REACT_APP_EDGE_PRODUCT", ()=>REACT_APP_EDGE_PRODUCT);
parcelHelpers.export(exports, "IS_CONNECT_IT", ()=>IS_CONNECT_IT);
parcelHelpers.export(exports, "MAPBOX_TOKEN", ()=>MAPBOX_TOKEN);
parcelHelpers.export(exports, "MIXPANEL_TOKEN", ()=>MIXPANEL_TOKEN);
var _constants = require("common/constants");
var _helpers = require("common/api/v1/helpers");
var _types = require("common/api/v1/types");
const IS_PROD = true;
const REACT_APP_EDGE_PRODUCT = (0, _helpers.productIdFromEdgeProduct)("edge");
const IS_CONNECT_IT = REACT_APP_EDGE_PRODUCT === (0, _constants.PRODUCTS).connectIt.id;
const MAPBOX_TOKEN = "pk.eyJ1IjoibmV0aW5zaWdodCIsImEiOiJjbDJraHlzOTgxMW5rM25vN215c2s1Z3h5In0.e9JUcUPxMb66oLO951G6kQ";
const MIXPANEL_TOKEN = window.Cypress ? undefined : "b23a3b369dbb94283642070d2a60f3ba";

},{"common/constants":"bdiC1","common/api/v1/helpers":"6jovr","common/api/v1/types":"3qemx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e3yqy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchedImage", ()=>useFetchedImage);
parcelHelpers.export(exports, "TopLeftLogo", ()=>TopLeftLogo);
parcelHelpers.export(exports, "LoginLogo", ()=>LoginLogo);
parcelHelpers.export(exports, "FaviconLogo", ()=>FaviconLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _logoEdgeSvg = require("../../img/logo-edge.svg");
var _logoEdgeSvgDefault = parcelHelpers.interopDefault(_logoEdgeSvg);
var _faviconPng = require("../../img/favicon.png");
var _faviconPngDefault = parcelHelpers.interopDefault(_faviconPng);
var _types = require("common/api/v1/types");
var _store = require("../../store");
const ALT_DEFAULT = 'Nimbra Edge';
const styles = {
    topLeftContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '55px',
        height: '30px',
        overflow: 'hidden'
    },
    faviconContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '32px',
        height: '32px',
        position: 'relative',
        overflow: 'hidden'
    },
    topLeftDefault: {
        fontFamily: 'Nunito Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '14px',
        lineHeight: '90%'
    },
    loginContainer: {
        display: 'block',
        position: 'relative',
        width: '396px',
        margin: (theme)=>theme.spacing(2, 0)
    },
    draftImg: {
        background: (theme)=>theme.palette.background.default
    }
};
const LoginImg = (0, _styles.styled)('img')({
    height: '44px',
    margin: '0 auto',
    display: 'block'
});
const api = (0, _store.Api);
const useFetchedImage = (name)=>{
    const [source, setSource] = (0, _react.useState)('');
    const [type, setType] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        api.imageApi.getImageDetails(name).then((data)=>{
            setSource(`/api/media/${data.id}`);
            setType(data.type);
        }).catch((err)=>{
            if (err?.errorInfo?.errorCode == 404) setSource(null);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        source,
        type
    };
};
const TopLeftLogo = ({ image, isDraft, onClick })=>{
    const { source } = useFetchedImage((0, _types.ImageName).serviceProvider);
    const { deleted, customTabTitle } = (0, _reactRedux.useSelector)(({ settingsReducer })=>({
            deleted: settingsReducer.toDelete.serviceProvider,
            customTabTitle: settingsReducer.settings?.customTabTitle
        }), (0, _reactRedux.shallowEqual));
    const showDefault = isDraft && deleted || source === null && !image;
    const showSource = (!!source || !!image) && (!deleted || !isDraft);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            ...styles.topLeftContainer,
            ...isDraft ? styles.draftImg : {}
        },
        "data-test-id": "corner-logo",
        onClick: onClick,
        children: [
            showSource ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                height: "100%",
                src: image || source || undefined,
                alt: customTabTitle || ALT_DEFAULT
            }) : null,
            showDefault ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                color: "textPrimary",
                sx: styles.topLeftDefault,
                children: "Nimbra Edge"
            }) : null
        ]
    });
};
const LoginLogo = ({ image, isDraft })=>{
    const { source } = useFetchedImage((0, _types.ImageName).product);
    const { deleted, customTabTitle } = (0, _reactRedux.useSelector)(({ settingsReducer })=>({
            deleted: settingsReducer.toDelete.product,
            customTabTitle: settingsReducer.settings?.customTabTitle
        }), (0, _reactRedux.shallowEqual));
    if (source === '') return null // fetching not complete yet
    ;
    const showDefault = isDraft && deleted || source === null && !image;
    const showSource = (!!source || !!image) && (!deleted || !isDraft);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: isDraft ? {
            ...styles.loginContainer,
            ...styles.draftImg
        } : styles.loginContainer,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginImg, {
                src: image || source || undefined,
                alt: customTabTitle || ALT_DEFAULT,
                style: {
                    display: showSource ? 'block' : 'none'
                },
                "data-test-id": "service-provider-logo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginImg, {
                src: (0, _logoEdgeSvgDefault.default),
                alt: customTabTitle || ALT_DEFAULT,
                style: {
                    display: showDefault ? 'block' : 'none'
                },
                "data-test-id": "default-logo"
            })
        ]
    });
};
const FaviconLogo = ({ image, isDraft })=>{
    const { source } = useFetchedImage((0, _types.ImageName).favicon);
    const { deleted, customTabTitle } = (0, _reactRedux.useSelector)(({ settingsReducer })=>({
            deleted: settingsReducer.toDelete.favicon,
            customTabTitle: settingsReducer.settings?.customTabTitle
        }), (0, _reactRedux.shallowEqual));
    if (source === '') return null // fetching not complete yet
    ;
    // show original if no image provided by user, no image uploaded before, or user clicked restore default
    const providedSource = source || image;
    const restoreDefault = deleted && isDraft;
    const showDefault = restoreDefault || !providedSource;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: isDraft ? {
            ...styles.faviconContainer,
            ...styles.draftImg
        } : styles.faviconContainer,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            height: "100%",
            src: showDefault ? (0, _faviconPngDefault.default) : providedSource,
            alt: `${customTabTitle || ALT_DEFAULT} favicon`,
            "data-test-id": "favicon-logo"
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","@mui/material/styles":"2UrBk","../../img/logo-edge.svg":"fwWe9","../../img/favicon.png":"6lP6a","common/api/v1/types":"3qemx","../../store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fwWe9":[function(require,module,exports,__globalThis) {
module.exports = require("4d7575656fc1c9c0").getBundleURL('7YEHs') + "logo-edge.27e55ffe.svg";

},{"4d7575656fc1c9c0":"a2ypy"}],"5LXiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Api", ()=>Api);
parcelHelpers.export(exports, "storeWithRoutes", ()=>storeWithRoutes);
parcelHelpers.export(exports, "RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _toolkit = require("@reduxjs/toolkit");
var _reducers = require("./redux/reducers");
var _reducersDefault = parcelHelpers.interopDefault(_reducers);
var _api = require("./api/Api");
var _localstorage = require("./localstorage");
var _network = require("./api/network");
var _routes = require("./utils/routes");
var _react = require("react");
const edgeClient = new (0, _network.BrowserEdgeClient)({
    baseUrl: ''
});
const Api = new (0, _api.Api)(edgeClient);
const persistedState = (0, _localstorage.loadState)();
/**
 * Container to have access to Navigation API managed by react-router from redux epics
 */ const navigateContainer = {
    navigate: {},
    setNavigate (navigate) {
        Object.assign(this, {
            navigate
        });
    }
};
const getCachedUrlParamsFn = ()=>store.getState().urlParamReducer.cachedUrlParams;
const routes = (0, _routes.makeRoutes)(getCachedUrlParamsFn);
const dependencies = {
    api: Api,
    routes,
    setNavigate (n) {
        navigateContainer.setNavigate(n);
    },
    navigate: ()=>navigateContainer.navigate
};
const store = (0, _toolkit.configureStore)({
    reducer: (0, _reducersDefault.default),
    preloadedState: persistedState,
    devTools: true,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: {
                isSerializable: (value)=>value instanceof Date || (0, _toolkit.isPlain)(value)
            },
            thunk: {
                extraArgument: dependencies
            }
        })
});
const storeWithRoutes = {
    store,
    routes
};
const RouteContext = (0, _react.createContext)({
    routes
});
const useRoutes = ()=>{
    const { routes } = (0, _react.useContext)(RouteContext);
    return routes;
};
exports.default = store;

},{"@reduxjs/toolkit":"8ces8","./redux/reducers":"j7DXo","./api/Api":"cQGur","./localstorage":"7NDOS","./api/network":"aULa1","./utils/routes":"cqMGU","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j7DXo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redux = require("redux");
var _alarmLogsReducers = require("./alarmLogsReducers");
var _alarmLogsReducersDefault = parcelHelpers.interopDefault(_alarmLogsReducers);
var _alarmsReducers = require("./alarmsReducers");
var _alarmsReducersDefault = parcelHelpers.interopDefault(_alarmsReducers);
var _appliancesReducer = require("./appliancesReducer");
var _appliancesReducerDefault = parcelHelpers.interopDefault(_appliancesReducer);
var _auditReducers = require("./auditReducers");
var _auditReducersDefault = parcelHelpers.interopDefault(_auditReducers);
var _billingReducers = require("./billingReducers");
var _billingReducersDefault = parcelHelpers.interopDefault(_billingReducers);
var _usageReducers = require("./usageReducers");
var _usageReducersDefault = parcelHelpers.interopDefault(_usageReducers);
var _inputsReducer = require("./inputsReducer");
var _inputsReducerDefault = parcelHelpers.interopDefault(_inputsReducer);
var _graphReducer = require("./graphReducer");
var _graphReducerDefault = parcelHelpers.interopDefault(_graphReducer);
var _groupListsReducer = require("./groupListsReducer");
var _groupListsReducerDefault = parcelHelpers.interopDefault(_groupListsReducer);
var _notificationsReducer = require("./notificationsReducer");
var _notificationsReducerDefault = parcelHelpers.interopDefault(_notificationsReducer);
var _groupsReducer = require("./groupsReducer");
var _groupsReducerDefault = parcelHelpers.interopDefault(_groupsReducer);
var _outputsReducer = require("./outputsReducer");
var _outputsReducerDefault = parcelHelpers.interopDefault(_outputsReducer);
var _outputListsReducer = require("./outputListsReducer");
var _outputListsReducerDefault = parcelHelpers.interopDefault(_outputListsReducer);
var _portsReducer = require("./portsReducer");
var _portsReducerDefault = parcelHelpers.interopDefault(_portsReducer);
var _regionsReducer = require("./regionsReducer");
var _regionsReducerDefault = parcelHelpers.interopDefault(_regionsReducer);
var _serviceOverviewReducers = require("./serviceOverviewReducers");
var _serviceOverviewReducersDefault = parcelHelpers.interopDefault(_serviceOverviewReducers);
var _settingsReducer = require("./settingsReducer");
var _settingsReducerDefault = parcelHelpers.interopDefault(_settingsReducer);
var _uiReducer = require("./uiReducer");
var _uiReducerDefault = parcelHelpers.interopDefault(_uiReducer);
var _urlParamReducer = require("./urlParamReducer");
var _urlParamReducerDefault = parcelHelpers.interopDefault(_urlParamReducer);
var _userReducer = require("./userReducer");
var _userReducerDefault = parcelHelpers.interopDefault(_userReducer);
var _buildInfoReducer = require("./buildInfoReducer");
var _buildInfoReducerDefault = parcelHelpers.interopDefault(_buildInfoReducer);
var _thumbnailReducer = require("./thumbnailReducer");
var _thumbnailReducerDefault = parcelHelpers.interopDefault(_thumbnailReducer);
var _addressMappingReducer = require("./addressMappingReducer");
var _addressMappingReducerDefault = parcelHelpers.interopDefault(_addressMappingReducer);
var _k8SReducer = require("./k8sReducer");
var _k8SReducerDefault = parcelHelpers.interopDefault(_k8SReducer);
var _networksReducer = require("./networksReducer");
var _networksReducerDefault = parcelHelpers.interopDefault(_networksReducer);
var _overlaysReducer = require("./overlaysReducer");
var _overlaysReducerDefault = parcelHelpers.interopDefault(_overlaysReducer);
var _adInsertionReducer = require("./adInsertionReducer");
var _adInsertionReducerDefault = parcelHelpers.interopDefault(_adInsertionReducer);
var _adAuditReducer = require("./adAuditReducer");
var _adAuditReducerDefault = parcelHelpers.interopDefault(_adAuditReducer);
var _adCreativeReducer = require("./adCreativeReducer");
var _adCreativeReducerDefault = parcelHelpers.interopDefault(_adCreativeReducer);
var _adPodReducer = require("./adPodReducer");
var _adPodReducerDefault = parcelHelpers.interopDefault(_adPodReducer);
var _adBreakReducer = require("./adBreakReducer");
var _adBreakReducerDefault = parcelHelpers.interopDefault(_adBreakReducer);
var _tagsReducer = require("./tagsReducer");
var _tagsReducerDefault = parcelHelpers.interopDefault(_tagsReducer);
const reducerMap = {
    addressMappingReducer: (0, _addressMappingReducerDefault.default),
    alarmLogsReducer: (0, _alarmLogsReducersDefault.default),
    alarmsReducer: (0, _alarmsReducersDefault.default),
    appliancesReducer: (0, _appliancesReducerDefault.default),
    auditReducer: (0, _auditReducersDefault.default),
    billingReducer: (0, _billingReducersDefault.default),
    buildInfoReducer: (0, _buildInfoReducerDefault.default),
    graphReducer: (0, _graphReducerDefault.default),
    groupListsReducer: (0, _groupListsReducerDefault.default),
    groupsReducer: (0, _groupsReducerDefault.default),
    inputsReducer: (0, _inputsReducerDefault.default),
    k8sReducer: (0, _k8SReducerDefault.default),
    networksReducer: (0, _networksReducerDefault.default),
    notificationsReducer: (0, _notificationsReducerDefault.default),
    outputsReducer: (0, _outputsReducerDefault.default),
    outputListsReducer: (0, _outputListsReducerDefault.default),
    portsReducer: (0, _portsReducerDefault.default),
    regionsReducer: (0, _regionsReducerDefault.default),
    serviceOverviewReducer: (0, _serviceOverviewReducersDefault.default),
    overlaysReducer: (0, _overlaysReducerDefault.default),
    adInsertionReducer: (0, _adInsertionReducerDefault.default),
    settingsReducer: (0, _settingsReducerDefault.default),
    thumbnailReducer: (0, _thumbnailReducerDefault.default),
    uiReducer: (0, _uiReducerDefault.default),
    urlParamReducer: (0, _urlParamReducerDefault.default),
    usageReducer: (0, _usageReducersDefault.default),
    userReducer: (0, _userReducerDefault.default),
    adAuditReducer: (0, _adAuditReducerDefault.default),
    adCreativeReducer: (0, _adCreativeReducerDefault.default),
    adPodReducer: (0, _adPodReducerDefault.default),
    adBreakReducer: (0, _adBreakReducerDefault.default),
    tagsReducer: (0, _tagsReducerDefault.default)
};
exports.default = (0, _redux.combineReducers)(reducerMap);

},{"redux":"iMGHt","./alarmLogsReducers":"htckG","./alarmsReducers":"eYnvn","./appliancesReducer":"abQuG","./auditReducers":"o9nMs","./billingReducers":"2PIxd","./usageReducers":"2WmSz","./inputsReducer":"742I9","./graphReducer":"6yl9Q","./groupListsReducer":"ftaZl","./notificationsReducer":"2jKnN","./groupsReducer":"3I5sc","./outputsReducer":"74FGl","./outputListsReducer":"lYjCy","./portsReducer":"b3OuY","./regionsReducer":"hkHST","./serviceOverviewReducers":"bOo7a","./settingsReducer":"cuGyr","./uiReducer":"1YMe4","./urlParamReducer":"9a85w","./userReducer":"zTJwy","./buildInfoReducer":"1vvXA","./thumbnailReducer":"1mbTt","./addressMappingReducer":"f6CUJ","./k8sReducer":"9Gq1L","./networksReducer":"ePWWY","./overlaysReducer":"jYa0b","./adInsertionReducer":"cJsMx","./adAuditReducer":"8H1Ji","./adCreativeReducer":"fSSxy","./adPodReducer":"axiN1","./adBreakReducer":"FWK4i","./tagsReducer":"gk2S4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htckG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateAlarmLogs", ()=>initialStateAlarmLogs);
var _toolkit = require("@reduxjs/toolkit");
var _alarmLogsActions = require("../actions/alarmLogsActions");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
const initialStateAlarmLogs = {
    alarmLogs: [],
    total: 0,
    loading: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _alarmLogsActions.getAlarmLogs));
const alarmLogsSlice = (0, _toolkit.createSlice)({
    name: 'alarmLogs',
    initialState: initialStateAlarmLogs,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _alarmLogsActions.getAlarmLogs).fulfilled, (state, { payload: { items: alarmLogs, total } })=>({
                ...state,
                alarmLogs,
                total
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateAlarmLogs).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = alarmLogsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/alarmLogsActions":"gRXht","../actions/userActions":"2tWgd","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ix9iK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Set state.loading=true if more pending actions have been dispatched than fulfilled/rejected for the specified asyncThunks. In other words, there is a request pending. */ parcelHelpers.export(exports, "createLoadingReducer", ()=>createLoadingReducer);
var _toolkit = require("@reduxjs/toolkit");
function createLoadingReducer(...asyncThunks) {
    let pendingCount = 0;
    const pending = (0, _toolkit.isPending)(...asyncThunks);
    const isLoadingAction = (0, _toolkit.isAsyncThunkAction)(...asyncThunks);
    const loadingReducer = (state, action)=>{
        if (pending(action)) pendingCount++;
        else {
            pendingCount--;
            if (pendingCount < 0) pendingCount = 0;
        }
        const silent = action.meta?.arg?.silent;
        const loading = silent ? false : pendingCount !== 0;
        return {
            ...state,
            loading
        };
    };
    return {
        isLoadingAction,
        loadingReducer
    };
}

},{"@reduxjs/toolkit":"8ces8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eYnvn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateAlarms", ()=>initialStateAlarms);
var _toolkit = require("@reduxjs/toolkit");
var _alarmsActions = require("../actions/alarmsActions");
var _shared = require("./shared");
const initialStateAlarms = {
    alarms: [],
    alarmsForNotifications: {
        items: [],
        total: 0
    },
    loading: false,
    total: 0,
    loadingInBackground: false,
    isCriticalAmount: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _alarmsActions.getAlarms));
const alarmsSlice = (0, _toolkit.createSlice)({
    name: 'alarms',
    initialState: initialStateAlarms,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _alarmsActions.readAlarmsInBackground).pending, (state, { meta: { arg: { silent } } })=>({
                ...state,
                loadingInBackground: !silent
            })).addCase((0, _alarmsActions.readAlarmsInBackground).rejected, (state)=>({
                ...state,
                loadingInBackground: false
            })).addCase((0, _alarmsActions.readAlarmsInBackground).fulfilled, (state, { payload: alarmsForNotifications })=>({
                ...state,
                alarmsForNotifications,
                loadingInBackground: false
            })).addCase((0, _alarmsActions.getAlarms).fulfilled, (state, { payload: alarms })=>({
                ...state,
                alarms: alarms.items,
                total: alarms.total
            })).addCase((0, _alarmsActions.setCriticalAlarmsAmount).pending, (state, { meta: { arg: isCriticalAmount } })=>({
                ...state,
                isCriticalAmount
            })).addCase((0, _alarmsActions.clearAlarms), (state)=>({
                ...state,
                alarms: []
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = alarmsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/alarmsActions":"2PZQF","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"abQuG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _applianceActions = require("../actions/applianceActions");
var _userActions = require("../actions/userActions");
var _actions = require("../actions");
var _toolkit = require("@reduxjs/toolkit");
var _shared = require("./shared");
const initialStateAppliances = {
    appliances: [],
    geoAppliances: [],
    loading: false,
    total: 0,
    totalGeoAppliances: 0,
    appliancesToObserve: {}
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _applianceActions.getApplianceConfig), (0, _applianceActions.clearCachedApplianceConfig), (0, _applianceActions.removeAppliance), (0, _applianceActions.getAppliance), (0, _applianceActions.getAppliances), (0, _applianceActions.getGeoAppliances));
const appliancesSlice = (0, _toolkit.createSlice)({
    name: 'appliances',
    initialState: initialStateAppliances,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _applianceActions.updateAppliance).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _applianceActions.restartAppliance).pending, (state, { meta: { arg } })=>{
            const appliances = state.appliances.map((appliance)=>appliance.id === arg.id ? {
                    ...appliance,
                    _restarting: true
                } : appliance);
            return {
                ...state,
                appliances,
                restarting: true
            };
        }).addCase((0, _applianceActions.recreateTunnels).pending, (state)=>({
                ...state,
                recreatingTunnels: true
            })).addCase((0, _applianceActions.getAppliances).fulfilled, (state, { payload: { total, items: appliances } })=>({
                ...state,
                appliances,
                total
            })).addCase((0, _applianceActions.getGeoAppliances).fulfilled, (state, { payload: { total, items: geoAppliances } })=>({
                ...state,
                geoAppliances,
                totalGeoAppliances: total
            })).addCase((0, _applianceActions.updateAppliance).fulfilled, (state)=>({
                ...state,
                saving: undefined
            })).addCase((0, _applianceActions.updateAppliance).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _applianceActions.getAppliance).fulfilled, (state, { payload: appliance })=>({
                ...state,
                appliance
            })).addCase((0, _applianceActions.clearAppliance), (state)=>({
                ...state,
                appliance: undefined,
                restarting: undefined
            })).addCase((0, _applianceActions.clearAppliances), (state)=>({
                ...state,
                appliances: []
            })).addCase((0, _applianceActions.getTotalRegions).fulfilled, (state, { payload: { totalRegions } })=>({
                ...state,
                totalRegions
            })).addCase((0, _applianceActions.getApplianceConfig).fulfilled, (state, { payload: config })=>({
                ...state,
                config
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateAppliances).addCase((0, _applianceActions.registerApplianceObserver).pending, (state, { meta: { arg: { applianceIds } } })=>{
            const appliancesToObserve = {
                ...state.appliancesToObserve
            };
            for (const applianceId of applianceIds)appliancesToObserve[applianceId] = (appliancesToObserve[applianceId] || 0) + 1;
            return {
                ...state,
                appliancesToObserve
            };
        }).addCase((0, _applianceActions.unregisterApplianceObserver), (state, { payload: { applianceIds } })=>{
            const newObservers = {
                ...state.appliancesToObserve
            };
            for (const applianceId of applianceIds){
                const numObservers = (newObservers[applianceId] || 0) - 1;
                if (numObservers < 1) delete newObservers[applianceId];
                else newObservers[applianceId] = numObservers;
            }
            return {
                ...state,
                appliancesToObserve: newObservers
            };
        }).addCase((0, _applianceActions.getBareAppliances).fulfilled, (state, { payload: bareAppliances })=>{
            const updateApplianceStatusAndAlarms = (enrichedAppliance)=>{
                const bareAppliance = bareAppliances.items.find((i)=>i.id === enrichedAppliance.id);
                if (!bareAppliance) return enrichedAppliance;
                return {
                    ...enrichedAppliance,
                    alarms: bareAppliance.alarms,
                    health: bareAppliance.health,
                    version: bareAppliance.version,
                    lastMessageAt: bareAppliance.lastMessageAt
                };
            };
            return {
                ...state,
                appliances: state.appliances.map(updateApplianceStatusAndAlarms),
                appliance: state.appliance ? updateApplianceStatusAndAlarms(state.appliance) : undefined
            };
        }).addMatcher((0, _actions.isOneOf)([
            (0, _applianceActions.restartAppliance).fulfilled
        ]), (state, { meta: { arg }, payload: appliance })=>{
            const appliances = state.appliances.map((a)=>a.id === arg.id ? {
                    ...a,
                    version: appliance.version,
                    _restarting: false
                } : a);
            return {
                ...state,
                appliances,
                restarting: false
            };
        }).addMatcher((0, _actions.isOneOf)([
            (0, _applianceActions.restartAppliance).rejected
        ]), (state, { meta: { arg } })=>{
            const appliances = state.appliances.map((a)=>a.id === arg.id ? {
                    ...a,
                    _restarting: false
                } : a);
            return {
                ...state,
                appliances,
                restarting: false
            };
        }).addMatcher((0, _actions.isOneOf)([
            (0, _applianceActions.recreateTunnels).fulfilled,
            (0, _applianceActions.recreateTunnels).rejected
        ]), (state)=>({
                ...state,
                recreatingTunnels: false
            })).addMatcher((0, _actions.isOneOf)([
            (0, _applianceActions.removeAppliance).pending,
            (0, _applianceActions.getAppliance).pending,
            (0, _applianceActions.getAppliances).pending,
            (0, _applianceActions.getGeoAppliances).pending
        ]), (state)=>({
                ...state,
                error: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _applianceActions.removeAppliance).rejected,
            (0, _applianceActions.getAppliance).rejected,
            (0, _applianceActions.getAppliances).rejected,
            (0, _applianceActions.getGeoAppliances).rejected
        ]), (state, { error })=>{
            return {
                ...state,
                error
            };
        }).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = appliancesSlice.reducer;

},{"../actions/applianceActions":"TaoIu","../actions/userActions":"2tWgd","../actions":"jgJYX","@reduxjs/toolkit":"8ces8","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jgJYX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isOneOf", ()=>isOneOf);
const isOneOf = (actions)=>(action)=>actions.map(({ type })=>type).includes(action.type);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"o9nMs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateAudit", ()=>initialStateAudit);
var _toolkit = require("@reduxjs/toolkit");
var _auditActions = require("../actions/auditActions");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
const initialStateAudit = {
    audit: [],
    total: 0,
    loading: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _auditActions.getAudit));
const auditSlice = (0, _toolkit.createSlice)({
    name: 'audit',
    initialState: initialStateAudit,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _auditActions.getAudit).fulfilled, (state, { payload: { items: audit, total } })=>({
                ...state,
                audit,
                total
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateAudit).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = auditSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/auditActions":"jEYBl","../actions/userActions":"2tWgd","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2PIxd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateBilling", ()=>initialStateBilling);
var _toolkit = require("@reduxjs/toolkit");
var _billingActions = require("../actions/billingActions");
var _shared = require("./shared");
const initialStateBilling = {
    billing: undefined,
    loading: false,
    error: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _billingActions.readBilling));
const billingSlice = (0, _toolkit.createSlice)({
    name: 'billing',
    initialState: initialStateBilling,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _billingActions.readBilling).pending, (state)=>({
                ...state,
                error: false,
                billing: undefined
            })).addCase((0, _billingActions.readBilling).fulfilled, (state, { payload: billing })=>({
                ...state,
                error: false,
                billing
            })).addCase((0, _billingActions.readBilling).rejected, (state)=>({
                ...state,
                error: true,
                billing: undefined
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = billingSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/billingActions":"dBFQZ","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dBFQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readBilling", ()=>readBilling);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
const readBilling = (0, _toolkit.createAsyncThunk)('billing/readBilling', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.billingApi.readBilling(params);
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch billing'
        }));
        throw err;
    }
});

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2WmSz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateUsage", ()=>initialStateUsage);
parcelHelpers.export(exports, "usageSlice", ()=>usageSlice);
var _toolkit = require("@reduxjs/toolkit");
var _usageActions = require("../actions/usageActions");
var _shared = require("./shared");
const initialStateUsage = {
    usage: undefined,
    loading: false,
    error: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _usageActions.readUsage));
const usageSlice = (0, _toolkit.createSlice)({
    name: 'usage',
    initialState: initialStateUsage,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _usageActions.readUsage).pending, (state)=>({
                ...state,
                error: false,
                usage: undefined
            })).addCase((0, _usageActions.readUsage).fulfilled, (state, { payload: usage })=>({
                ...state,
                error: false,
                usage
            })).addCase((0, _usageActions.readUsage).rejected, (state)=>({
                ...state,
                error: true,
                usage: undefined
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = usageSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/usageActions":"6CX5c","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"742I9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectInputs", ()=>selectInputs);
var _inputsActions = require("../actions/inputsActions");
var _userActions = require("../actions/userActions");
var _actions = require("../actions");
var _toolkit = require("@reduxjs/toolkit");
var _shared = require("./shared");
const initialStateInputs = {
    inputs: [],
    total: 0,
    loading: false,
    rerouting: false,
    dialogSaving: false,
    draft: {
        inputs: []
    },
    inputsToObserve: {},
    observedInputs: []
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _inputsActions.getInputs), (0, _inputsActions.removeInput), (0, _inputsActions.removeInputs));
const inputsSlice = (0, _toolkit.createSlice)({
    name: 'inputs',
    initialState: initialStateInputs,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _inputsActions.getInputs).fulfilled, (state, { payload: { items: inputs, total } })=>({
                ...state,
                inputs,
                total
            })).addCase((0, _inputsActions.clearInputFormErrors), (state)=>({
                ...state,
                formErrors: undefined
            })).addCase((0, _inputsActions.draftInputs), (state, { payload: draft })=>({
                ...state,
                draft
            })).addCase((0, _inputsActions.clearInputs), (state)=>({
                ...state,
                inputs: [],
                draft: {
                    inputs: []
                }
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateInputs).addCase((0, _inputsActions.registerInputObserver).pending, (state, { meta: { arg: { inputIds } } })=>{
            const inputsToObserve = {
                ...state.inputsToObserve
            };
            for (const inputId of inputIds)inputsToObserve[inputId] = (inputsToObserve[inputId] || 0) + 1;
            return {
                ...state,
                inputsToObserve
            };
        }).addCase((0, _inputsActions.unregisterInputObserver), (state, { payload: { inputIds } })=>{
            const newObservers = {
                ...state.inputsToObserve
            };
            for (const inputId of inputIds){
                const numberOfObservers = (newObservers[inputId] || 0) - 1;
                if (numberOfObservers < 1) delete newObservers[inputId];
                else newObservers[inputId] = numberOfObservers;
            }
            const observedInputIds = Object.keys(newObservers);
            return {
                ...state,
                inputsToObserve: newObservers,
                observedInputs: state.observedInputs.filter((i)=>observedInputIds.includes(i.id))
            };
        }).addCase((0, _inputsActions.getBareInputs).fulfilled, (state, { payload: bareInputs })=>{
            const updateInputMetricsAndTsInfo = (enrichedInput)=>{
                const bareInput = bareInputs.items.find((i)=>i.id === enrichedInput.id);
                return bareInput ? {
                    ...enrichedInput,
                    metrics: bareInput.metrics,
                    health: bareInput.health,
                    tsInfo: bareInput.tsInfo
                } : enrichedInput;
            };
            const observedInputIds = Object.keys(state.inputsToObserve);
            const observedInputs = observedInputIds.map((id)=>bareInputs.items.find((i)=>i.id === id)).filter(Boolean);
            return {
                ...state,
                inputs: state.inputs.map(updateInputMetricsAndTsInfo),
                observedInputs
            };
        }).addCase((0, _inputsActions.enableInputs).fulfilled, (state, { payload: enableInputs })=>{
            const enableInput = (input)=>{
                const enabledInput = enableInputs.find((i)=>i.id === input.id);
                if (enabledInput) return {
                    ...input,
                    adminStatus: enabledInput.adminStatus
                };
                return input;
            };
            return {
                ...state,
                inputs: state.inputs.map(enableInput),
                observedInputs: state.observedInputs.map(enableInput)
            };
        }).addCase((0, _inputsActions.disableInputs).fulfilled, (state, { payload: disableInputs })=>{
            const disableInput = (input)=>{
                const disabledInput = disableInputs.find((i)=>i.id === input.id);
                if (disabledInput) return {
                    ...input,
                    adminStatus: disabledInput.adminStatus
                };
                return input;
            };
            return {
                ...state,
                inputs: state.inputs.map(disableInput),
                observedInputs: state.observedInputs.map(disableInput)
            };
        }).addMatcher((0, _actions.isOneOf)([
            (0, _inputsActions.updateInputDistribution).fulfilled,
            (0, _inputsActions.updateInputDistribution).rejected,
            (0, _inputsActions.updateInputRecipients).fulfilled,
            (0, _inputsActions.updateInputRecipients).rejected
        ]), (state)=>({
                ...state,
                dialogSaving: false
            })).addMatcher((0, _actions.isOneOf)([
            (0, _inputsActions.getInputs).pending,
            (0, _inputsActions.removeInput).pending,
            (0, _inputsActions.removeInputs).pending
        ]), (state)=>({
                ...state,
                formErrors: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _inputsActions.createInput).pending,
            (0, _inputsActions.updateInput).pending
        ]), (state)=>({
                ...state,
                saving: true,
                formErrors: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _inputsActions.updateInputDistribution).pending,
            (0, _inputsActions.updateInputRecipients).pending
        ]), (state)=>({
                ...state,
                dialogSaving: true
            })).addMatcher((0, _actions.isOneOf)([
            (0, _inputsActions.rerouteInput).pending
        ]), (state)=>({
                ...state,
                rerouting: true
            })).addMatcher((0, _actions.isOneOf)([
            (0, _inputsActions.rerouteInput).fulfilled,
            (0, _inputsActions.rerouteInput).rejected
        ]), (state)=>({
                ...state,
                rerouting: false
            })).addMatcher((0, _actions.isOneOf)([
            (0, _inputsActions.createInput).fulfilled,
            (0, _inputsActions.updateInput).fulfilled
        ]), (state)=>({
                ...state,
                saving: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _inputsActions.createInput).rejected,
            (0, _inputsActions.updateInput).rejected
        ]), (state, { payload })=>({
                ...state,
                saving: false,
                formErrors: payload?.details
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = inputsSlice.reducer;
const selectInputs = ({ inputsReducer })=>({
        inputs: inputsReducer.inputs,
        total: inputsReducer.total
    });

},{"../actions/inputsActions":"l0Ua8","../actions/userActions":"2tWgd","../actions":"jgJYX","@reduxjs/toolkit":"8ces8","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6yl9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolkit = require("@reduxjs/toolkit");
var _graphActions = require("../actions/graphActions");
var _shared = require("./shared");
const initialState = {
    graph: undefined,
    loading: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _graphActions.readGraph));
const graphSlice = (0, _toolkit.createSlice)({
    name: 'graph',
    initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _graphActions.readGraph).fulfilled, (state, { payload })=>({
                ...state,
                graph: payload
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = graphSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/graphActions":"kJItV","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kJItV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readGraph", ()=>readGraph);
var _toolkit = require("@reduxjs/toolkit");
const readGraph = (0, _toolkit.createAsyncThunk)('graph/readGraph', async (_, { extra: { api } })=>{
    const response = await api.graphApi.readGraph();
    return response;
});

},{"@reduxjs/toolkit":"8ces8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ftaZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateGroupLists", ()=>initialStateGroupLists);
var _toolkit = require("@reduxjs/toolkit");
var _groupListsActions = require("../actions/groupListsActions");
var _userActions = require("../actions/userActions");
var _actions = require("../actions");
var _shared = require("./shared");
const initialStateGroupLists = {
    groupLists: [],
    loading: false,
    total: 0
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _groupListsActions.removeGroupList), (0, _groupListsActions.getGroupLists));
const groupListsSlice = (0, _toolkit.createSlice)({
    name: 'groupLists',
    initialState: initialStateGroupLists,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _groupListsActions.getGroupLists).fulfilled, (state, { payload: { items: groupLists, total } })=>({
                ...state,
                groupLists,
                total
            })).addCase((0, _groupListsActions.getGroupList).fulfilled, (state, { payload: groupList })=>({
                ...state,
                groupList
            })).addCase((0, _groupListsActions.clearGroupList), (state)=>({
                ...state,
                groupList: undefined,
                formErrors: undefined
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateGroupLists).addCase((0, _groupListsActions.removeGroupList).fulfilled, (state, { payload: { id } })=>({
                ...state,
                groupLists: state.groupLists.filter((groupList)=>groupList.id !== id),
                total: state.total - 1
            })).addMatcher((0, _actions.isOneOf)([
            (0, _groupListsActions.updateGroupList).pending,
            (0, _groupListsActions.createGroupList).pending
        ]), (state)=>({
                ...state,
                saving: true
            })).addMatcher((0, _actions.isOneOf)([
            (0, _groupListsActions.createGroupList).fulfilled,
            (0, _groupListsActions.updateGroupList).fulfilled
        ]), (state)=>({
                ...state,
                saving: undefined,
                formErrors: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _groupListsActions.updateGroupList).rejected,
            (0, _groupListsActions.createGroupList).rejected
        ]), (state, { payload })=>({
                ...state,
                saving: false,
                formErrors: payload?.details
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = groupListsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/groupListsActions":"k9GYr","../actions/userActions":"2tWgd","../actions":"jgJYX","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jKnN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notificationsSlice", ()=>notificationsSlice);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("../actions/notificationActions");
const initialNotifications = [];
const notificationsSlice = (0, _toolkit.createSlice)({
    name: 'notifications',
    initialState: initialNotifications,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _notificationActions.enqueueSnackbar), (state, { payload: notification })=>[
                ...state.map((item)=>{
                    if (item.type === 'newVersionAvailableSnackbar') return item;
                    return {
                        ...item,
                        dismissed: true
                    };
                }),
                {
                    ...notification,
                    options: {
                        ...notification.options,
                        key: `${new Date().getTime()} ${Math.random()}`
                    }
                }
            ]).addCase((0, _notificationActions.closeSnackbar), (state, { payload: key })=>state.map((item)=>item.options.key === key ? {
                    ...item,
                    dismissed: true
                } : {
                    ...item
                })).addCase((0, _notificationActions.closeAllSnackbars), (state)=>state.map((item)=>({
                    ...item,
                    dismissed: true
                }))).addCase((0, _notificationActions.removeSnackbar), (state, { payload: key })=>state.filter((item)=>item.options.key !== key));
    }
});
exports.default = notificationsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3I5sc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateGroups", ()=>initialStateGroups);
var _toolkit = require("@reduxjs/toolkit");
var _groupActions = require("../actions/groupActions");
var _userActions = require("../actions/userActions");
var _actions = require("../actions");
var _shared = require("./shared");
const initialStateGroups = {
    groups: [],
    loading: false,
    total: 0
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _groupActions.removeGroup), (0, _groupActions.getGroups));
const groupsSlice = (0, _toolkit.createSlice)({
    name: 'groups',
    initialState: initialStateGroups,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _groupActions.getGroup).fulfilled, (state, { payload: group })=>({
                ...state,
                group
            })).addCase((0, _groupActions.clearGroup), (state)=>({
                ...state,
                group: undefined,
                formErrors: undefined
            })).addCase((0, _groupActions.clearGroups), (state)=>({
                ...state,
                groups: []
            })).addCase((0, _groupActions.removeGroup).fulfilled, (state, { payload: { id } })=>({
                ...state,
                groups: state.groups.filter((group)=>group.id !== id),
                total: state.total - 1
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateGroups).addCase((0, _groupActions.getGroups).fulfilled, (state, { payload: { items: groups, total } })=>({
                ...state,
                groups,
                total
            })).addMatcher((0, _actions.isOneOf)([
            (0, _groupActions.updateGroup).pending,
            (0, _groupActions.createGroup).pending
        ]), (state)=>({
                ...state,
                saving: true
            })).addMatcher((0, _actions.isOneOf)([
            (0, _groupActions.createGroup).fulfilled,
            (0, _groupActions.updateGroup).fulfilled
        ]), (state)=>({
                ...state,
                saving: undefined,
                formErrors: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _groupActions.updateGroup).rejected,
            (0, _groupActions.createGroup).rejected
        ]), (state, { payload })=>({
                ...state,
                saving: false,
                formErrors: payload?.details
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = groupsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/groupActions":"bqPI2","../actions/userActions":"2tWgd","../actions":"jgJYX","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"74FGl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectOutputs", ()=>selectOutputs);
var _toolkit = require("@reduxjs/toolkit");
var _outputsActions = require("../actions/outputsActions");
var _userActions = require("../actions/userActions");
var _actions = require("../actions");
var _serviceOverviewActions = require("../actions/serviceOverviewActions");
var _utils = require("../../utils");
var _shared = require("./shared");
const initialStateOutputs = {
    loading: false,
    outputs: [],
    outputsWithLists: [],
    outputsToObserve: {},
    total: 0,
    draft: {
        outputs: []
    },
    observedOutputs: []
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _outputsActions.getOutputs), (0, _outputsActions.removeOutputs), (0, _outputsActions.getOutputsWithLists), (0, _outputsActions.getTotalOutputCount));
const outputsSlice = (0, _toolkit.createSlice)({
    name: 'outputs',
    initialState: initialStateOutputs,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _outputsActions.createOutput).fulfilled, (state)=>({
                ...state,
                saving: undefined,
                formErrors: undefined
            })).addCase((0, _outputsActions.updateOutput).fulfilled, (state, { payload: updatedOutput })=>({
                ...state,
                saving: undefined,
                outputs: state.outputs.map((outp)=>outp.id === updatedOutput.id ? {
                        ...updatedOutput
                    } : outp)
            })).addCase((0, _outputsActions.getOutputs).fulfilled, (state, { payload: { items: outputs, total } })=>({
                ...state,
                outputs,
                total
            })).addCase((0, _outputsActions.getOutputsWithLists).fulfilled, (state, { payload: { items: outputsWithLists, total } })=>({
                ...state,
                outputsWithLists,
                total
            })).addCase((0, _outputsActions.getTotalOutputCount).fulfilled, (state, { payload: total })=>({
                ...state,
                total
            })).addCase((0, _outputsActions.clearOutputFormErrors), (state)=>({
                ...state,
                formErrors: undefined
            })).addCase((0, _outputsActions.clearOutputs), (state)=>({
                ...state,
                outputs: [],
                outputsWithLists: []
            })).addCase((0, _outputsActions.draftOutputs), (state, { payload: draft })=>({
                ...state,
                draft
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateOutputs).addCase((0, _outputsActions.registerOutputObserver).pending, (state, { meta: { arg: { outputIds } } })=>{
            const outputsToObserve = {
                ...state.outputsToObserve
            };
            for (const outputId of outputIds)outputsToObserve[outputId] = (outputsToObserve[outputId] || 0) + 1;
            return {
                ...state,
                outputsToObserve
            };
        }).addCase((0, _outputsActions.unregisterOutputObserver), (state, { payload: { outputIds } })=>{
            const newObservers = {
                ...state.outputsToObserve
            };
            for (const outputId of outputIds){
                const numberOfObservers = (newObservers[outputId] || 0) - 1;
                if (numberOfObservers < 1) delete newObservers[outputId];
                else newObservers[outputId] = numberOfObservers;
            }
            const observedOutputIds = Object.keys(newObservers);
            return {
                ...state,
                outputsToObserve: newObservers,
                observedOutputs: state.observedOutputs.filter((o)=>observedOutputIds.includes(o.id))
            };
        }).addCase((0, _outputsActions.getBareOutputs).fulfilled, (state, { payload: bareOutputs })=>{
            const updateOutputMetrics = (enrichedOutput)=>{
                const bareOutput = bareOutputs.items.find((o)=>o.id === enrichedOutput.id);
                return bareOutput ? {
                    ...enrichedOutput,
                    metrics: bareOutput.metrics,
                    health: bareOutput.health
                } : enrichedOutput;
            };
            const observedOutputIds = Object.keys(state.outputsToObserve);
            const observedOutputs = observedOutputIds.map((id)=>bareOutputs.items.find((i)=>i.id === id)).filter(Boolean);
            return {
                ...state,
                outputs: state.outputs.map(updateOutputMetrics),
                outputsWithLists: state.outputsWithLists.reduce((acc, outputOrRecipientList)=>{
                    acc.push((0, _utils.isOutput)(outputOrRecipientList) ? updateOutputMetrics(outputOrRecipientList) : outputOrRecipientList);
                    return acc;
                }, []),
                observedOutputs
            };
        }).addCase((0, _serviceOverviewActions.getService).fulfilled, (state, { payload: { objects: { outputs } } })=>({
                ...state,
                outputs: outputs.items
            })).addCase((0, _outputsActions.enableOutputs).fulfilled, (state, { payload: enableOutputs })=>{
            const enableOutput = (output)=>{
                const enabledOutput = enableOutputs.find((o)=>o.id === output.id);
                if (enabledOutput) return {
                    ...output,
                    adminStatus: enabledOutput.adminStatus
                };
                return output;
            };
            return {
                ...state,
                outputs: state.outputs.map(enableOutput),
                observedOutputs: state.observedOutputs.map(enableOutput)
            };
        }).addCase((0, _outputsActions.disableOutputs).fulfilled, (state, { payload: disableOutputs })=>{
            const disableOutput = (output)=>{
                const disabledOutput = disableOutputs.find((o)=>o.id === output.id);
                if (disabledOutput) return {
                    ...output,
                    adminStatus: disabledOutput.adminStatus
                };
                return output;
            };
            return {
                ...state,
                outputs: state.outputs.map(disableOutput),
                observedOutputs: state.observedOutputs.map(disableOutput)
            };
        }).addCase((0, _outputsActions.setInputOfOutput).fulfilled, (state, { payload: updatedOutput })=>({
                ...state,
                saving: undefined,
                outputs: state.outputs.map((outp)=>outp.id === updatedOutput.id ? {
                        ...updatedOutput
                    } : outp)
            })).addMatcher((0, _actions.isOneOf)([
            (0, _outputsActions.createOutput).pending,
            (0, _outputsActions.updateOutput).pending,
            (0, _outputsActions.setInputOfOutput).pending
        ]), (state)=>({
                ...state,
                saving: true,
                formErrors: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _outputsActions.createOutput).rejected,
            (0, _outputsActions.updateOutput).rejected,
            (0, _outputsActions.setInputOfOutput).rejected
        ]), (state, { payload })=>({
                ...state,
                saving: false,
                formErrors: payload?.details
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = outputsSlice.reducer;
const selectOutputs = ({ outputsReducer })=>({
        outputs: outputsReducer.outputs,
        total: outputsReducer.total
    });

},{"@reduxjs/toolkit":"8ces8","../actions/outputsActions":"alMzI","../actions/userActions":"2tWgd","../actions":"jgJYX","../actions/serviceOverviewActions":"ak7dX","../../utils":"342UB","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ak7dX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOCAL_STORAGE_SO_ANIMATION", ()=>LOCAL_STORAGE_SO_ANIMATION);
parcelHelpers.export(exports, "getService", ()=>getService);
parcelHelpers.export(exports, "selectTr101290Window", ()=>selectTr101290Window);
parcelHelpers.export(exports, "clearService", ()=>clearService);
parcelHelpers.export(exports, "refresh", ()=>refresh);
parcelHelpers.export(exports, "setEnableAnimations", ()=>setEnableAnimations);
var _toolkit = require("@reduxjs/toolkit");
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _utils = require("../../utils");
var _params = require("../../utils/params");
const LOCAL_STORAGE_SO_ANIMATION = 'so-animations';
const getService = (0, _toolkit.createAsyncThunk)('serviceOverview/getService', async ({ params, inputId, outputId }, { getState, extra: { api } })=>{
    const { tr101290Window } = getState().serviceOverviewReducer;
    const serviceOverview = await api.inputApi.getOverview(inputId, {
        ...(0, _utils.withDefaultPagination)(params),
        inputTr101290Window: tr101290Window,
        output: outputId
    });
    return serviceOverview;
});
const selectTr101290Window = (0, _toolkit.createAsyncThunk)('serviceOverview/selectTr101290Window', async (_, { dispatch })=>{
    await dispatch(refresh());
});
const clearService = (0, _toolkit.createAction)('serviceOverviewActions/clearService');
const refresh = (0, _toolkit.createAsyncThunk)('serviceOverview/refresh', async (_, { dispatch, getState })=>{
    dispatch(getService({
        params: (0, _utils.withDefaultPagination)((0, _omitDefault.default)((0, _params.getLocationParams)(), 'outputId')),
        inputId: getState().serviceOverviewReducer.input?.id || '',
        outputId: (0, _params.getLocationParams)().outputId
    }));
});
const setEnableAnimations = (0, _toolkit.createAction)('serviceOverviewActions/enableAnimations', (isEnabled)=>{
    if (isEnabled) localStorage.setItem(LOCAL_STORAGE_SO_ANIMATION, 'enabled');
    else localStorage.removeItem(LOCAL_STORAGE_SO_ANIMATION);
    return {
        payload: isEnabled
    };
});

},{"@reduxjs/toolkit":"8ces8","lodash/omit":"fhxvC","../../utils":"342UB","../../utils/params":"5D6YE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhxvC":[function(require,module,exports,__globalThis) {
var arrayMap = require("edf8d2f2f36e65cf"), baseClone = require("dd27ddc2340179e5"), baseUnset = require("589767d435c41297"), castPath = require("565c158f6d380e60"), copyObject = require("9b4f3122fc9cc1a6"), customOmitClone = require("1c19467b6c51de37"), flatRest = require("24ab2b6e4b71312a"), getAllKeysIn = require("e20a1a7cbb58999e");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var omit = flatRest(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    var length = paths.length;
    while(length--)baseUnset(result, paths[length]);
    return result;
});
module.exports = omit;

},{"edf8d2f2f36e65cf":"chzeu","dd27ddc2340179e5":"dqsfF","589767d435c41297":"dGTca","565c158f6d380e60":"1tEcE","9b4f3122fc9cc1a6":"vDc33","1c19467b6c51de37":"bUGk9","24ab2b6e4b71312a":"j0z0i","e20a1a7cbb58999e":"iZ6gY"}],"dGTca":[function(require,module,exports,__globalThis) {
var castPath = require("f9ed36b4ad99fc49"), last = require("bbfbe3a50d8efe39"), parent = require("b7b0084465c39aec"), toKey = require("7b9792fcc4179101");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
}
module.exports = baseUnset;

},{"f9ed36b4ad99fc49":"1tEcE","bbfbe3a50d8efe39":"glvbo","b7b0084465c39aec":"bcyN4","7b9792fcc4179101":"b5swP"}],"glvbo":[function(require,module,exports,__globalThis) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"bcyN4":[function(require,module,exports,__globalThis) {
var baseGet = require("cbcb75b7339c1ad"), baseSlice = require("3443758a32fd0de1");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
module.exports = parent;

},{"cbcb75b7339c1ad":"5Vkba","3443758a32fd0de1":"7H7oa"}],"7H7oa":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"bUGk9":[function(require,module,exports,__globalThis) {
var isPlainObject = require("e34ef634df1bf68a");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
}
module.exports = customOmitClone;

},{"e34ef634df1bf68a":"lCxAG"}],"lCxAG":[function(require,module,exports,__globalThis) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"5ltt8","2ca5b85a120835de":"9DBU4","963b65e043435612":"4gOki"}],"j0z0i":[function(require,module,exports,__globalThis) {
var flatten = require("199f7cbd69032298"), overRest = require("aa5c38699e42775a"), setToString = require("6a66c8b3fbd122d5");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + '');
}
module.exports = flatRest;

},{"199f7cbd69032298":"cPyWt","aa5c38699e42775a":"rlFXD","6a66c8b3fbd122d5":"cmKNW"}],"cPyWt":[function(require,module,exports,__globalThis) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"iu9J0"}],"iu9J0":[function(require,module,exports,__globalThis) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"8JuEE","ec5f080ebf5764e8":"6OjlR"}],"6OjlR":[function(require,module,exports,__globalThis) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"crlKT","ee6f325d7f5309b1":"bpegN","ff8d93236e335297":"1DVeR"}],"rlFXD":[function(require,module,exports,__globalThis) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"bZSxb"}],"bZSxb":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"cmKNW":[function(require,module,exports,__globalThis) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"i2oRN","9114f59293388d49":"9rYPt"}],"i2oRN":[function(require,module,exports,__globalThis) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"bvu2c","eff1240bc0447727":"fUDy8","b00d1e57326793e1":"2HXBf"}],"bvu2c":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"2HXBf":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"9rYPt":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"lYjCy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateOutputLists", ()=>initialStateOutputLists);
var _toolkit = require("@reduxjs/toolkit");
var _outputListsActions = require("../actions/outputListsActions");
var _userActions = require("../actions/userActions");
var _actions = require("../actions");
var _shared = require("./shared");
const initialStateOutputLists = {
    outputLists: [],
    loading: false,
    total: 0
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _outputListsActions.removeOutputList), (0, _outputListsActions.getOutputLists));
const outputListsSlice = (0, _toolkit.createSlice)({
    name: 'outputLists',
    initialState: initialStateOutputLists,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _outputListsActions.getOutputLists).fulfilled, (state, { payload: { items: outputLists, total } })=>({
                ...state,
                outputLists,
                total
            })).addCase((0, _outputListsActions.getOutputList).fulfilled, (state, { payload: outputList })=>({
                ...state,
                outputList
            })).addCase((0, _outputListsActions.clearOutputList), (state)=>({
                ...state,
                outputList: undefined,
                formErrors: undefined
            })).addCase((0, _outputListsActions.clearOutputLists), (state)=>({
                ...state,
                outputLists: []
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateOutputLists).addCase((0, _outputListsActions.removeOutputList).fulfilled, (state, { payload: { id } })=>({
                ...state,
                outputLists: state.outputLists.filter((outputList)=>outputList.id !== id),
                total: state.total - 1
            })).addMatcher((0, _actions.isOneOf)([
            (0, _outputListsActions.updateOutputList).pending,
            (0, _outputListsActions.createOutputList).pending
        ]), (state)=>({
                ...state,
                saving: true
            })).addMatcher((0, _actions.isOneOf)([
            (0, _outputListsActions.createOutputList).fulfilled,
            (0, _outputListsActions.updateOutputList).fulfilled
        ]), (state)=>({
                ...state,
                saving: undefined,
                formErrors: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _outputListsActions.updateOutputList).rejected,
            (0, _outputListsActions.createOutputList).rejected
        ]), (state, { payload })=>({
                ...state,
                saving: false,
                formErrors: payload?.details
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = outputListsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/outputListsActions":"ce4Vm","../actions/userActions":"2tWgd","../actions":"jgJYX","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b3OuY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStatePorts", ()=>initialStatePorts);
var _toolkit = require("@reduxjs/toolkit");
var _portActions = require("../actions/portActions");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
const initialStatePorts = {
    ports: [],
    loading: false,
    total: 0
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _portActions.getPorts));
const portsSlice = (0, _toolkit.createSlice)({
    name: 'ports',
    initialState: initialStatePorts,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _portActions.getPort).fulfilled, (state, { payload: port })=>({
                ...state,
                port
            })).addCase((0, _portActions.getPorts).fulfilled, (state, { payload: { items: ports, total } })=>({
                ...state,
                ports,
                total
            })).addCase((0, _portActions.clearPort), (state)=>({
                ...state,
                port: undefined
            })).addCase((0, _portActions.clearPorts), (state)=>({
                ...state,
                ports: []
            })).addCase((0, _portActions.updatePort).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _portActions.updatePort).fulfilled, (state)=>({
                ...state,
                saving: undefined
            })).addCase((0, _portActions.updatePort).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStatePorts).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = portsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/portActions":"5YSBF","../actions/userActions":"2tWgd","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hkHST":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateRegions", ()=>initialStateRegions);
var _toolkit = require("@reduxjs/toolkit");
var _regionsActions = require("../actions/regionsActions");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
const initialStateRegions = {
    regions: [],
    total: 0,
    loading: false,
    saving: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _regionsActions.getRegions), (0, _regionsActions.getRegionDetails), (0, _regionsActions.setDefaultRegion));
const regionSlice = (0, _toolkit.createSlice)({
    name: 'region',
    initialState: initialStateRegions,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _regionsActions.getRegions).fulfilled, (state, { payload: { items: regions, total } })=>({
                ...state,
                regions,
                total
            })).addCase((0, _regionsActions.getRegionDetails).fulfilled, (state, { payload: regionDetails })=>({
                ...state,
                regionDetails
            })).addCase((0, _regionsActions.clearRegion), (state)=>({
                ...state,
                regionDetails: undefined
            })).addCase((0, _regionsActions.clearRegions), (state)=>({
                ...state,
                regions: []
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateRegions).addCase((0, _regionsActions.updateRegion).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _regionsActions.updateRegion).fulfilled, (state)=>({
                ...state,
                saving: false,
                regionDetails: undefined
            })).addCase((0, _regionsActions.updateRegion).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _regionsActions.setDefaultRegion).fulfilled, (state, { payload: { id } })=>({
                ...state,
                regions: state.regions.map((r)=>({
                        ...r,
                        default_region: r.id === id
                    }))
            })).addCase((0, _regionsActions.deleteRegion).fulfilled, (state)=>({
                ...state,
                regionDetails: undefined
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = regionSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/regionsActions":"d48MN","../actions/userActions":"2tWgd","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bOo7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateServiceOverview", ()=>initialStateServiceOverview);
var _toolkit = require("@reduxjs/toolkit");
var _types = require("common/api/v1/types");
var _serviceOverviewActions = require("../actions/serviceOverviewActions");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
const initialStateServiceOverview = {
    loading: false,
    graph: {
        nodes: {},
        edges: []
    },
    appliances: [],
    tunnels: [],
    outputs: {
        items: [],
        total: 0
    },
    derivedInputs: [],
    tr101290Window: (0, _types.MetricWindow).m1,
    isAnimationEnabled: localStorage.getItem((0, _serviceOverviewActions.LOCAL_STORAGE_SO_ANIMATION)) === 'enabled'
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _serviceOverviewActions.getService));
const serviceOverviewSlice = (0, _toolkit.createSlice)({
    name: 'serviceOverview',
    initialState: initialStateServiceOverview,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _serviceOverviewActions.getService).fulfilled, (state, { payload: { input, parent, graph, objects: { tunnels, appliances, outputs, derivedInputs } } })=>({
                ...state,
                input: input || state.input,
                parent: parent ?? undefined,
                graph,
                appliances,
                tunnels,
                outputs,
                derivedInputs
            })).addCase((0, _serviceOverviewActions.selectTr101290Window).pending, (state, { meta: { arg: tr101290Window } })=>({
                ...state,
                tr101290Window
            })).addCase((0, _serviceOverviewActions.clearService), (prevState)=>({
                ...initialStateServiceOverview,
                tr101290Window: prevState.tr101290Window,
                isAnimationEnabled: prevState.isAnimationEnabled
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateServiceOverview).addCase((0, _serviceOverviewActions.setEnableAnimations), (state, { payload })=>({
                ...state,
                isAnimationEnabled: payload
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = serviceOverviewSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","common/api/v1/types":"3qemx","../actions/serviceOverviewActions":"ak7dX","../actions/userActions":"2tWgd","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cuGyr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateSettings", ()=>initialStateSettings);
var _toolkit = require("@reduxjs/toolkit");
var _types = require("common/api/v1/types");
var _settingsActions = require("../actions/settingsActions");
var _userActions = require("../actions/userActions");
var _actions = require("../actions");
var _shared = require("./shared");
const initialStateSettings = {
    loading: false,
    saving: false,
    savingImages: false,
    savingTls: false,
    toDelete: {
        [(0, _types.ImageName).product]: false,
        [(0, _types.ImageName).serviceProvider]: false,
        [(0, _types.ImageName).favicon]: false
    },
    devMode: localStorage.getItem('dev-mode') === 'enabled'
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _settingsActions.getSettings));
const settingsSlice = (0, _toolkit.createSlice)({
    name: 'settings',
    initialState: initialStateSettings,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _settingsActions.saveSettings).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _settingsActions.getSettings).fulfilled, (state, { payload: { settings, tls } })=>({
                ...state,
                settings,
                tls
            })).addCase((0, _settingsActions.saveSettings).fulfilled, (state, { payload: settings })=>({
                ...state,
                saving: false,
                settings
            })).addCase((0, _settingsActions.saveSettings).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _settingsActions.setImage), (state, { payload: { name, file } })=>({
                ...state,
                [name]: {
                    ...file,
                    file: file?.file?.slice()
                },
                toDelete: {
                    ...state.toDelete,
                    [name]: false
                }
            })).addCase((0, _settingsActions.setImageToDelete), (state, { payload: name })=>({
                ...state,
                toDelete: {
                    ...state.toDelete,
                    [name]: true
                },
                [name]: undefined
            })).addCase((0, _settingsActions.saveImages).pending, (state)=>({
                ...state,
                savingImages: true
            })).addCase((0, _settingsActions.saveTls).pending, (state)=>({
                ...state,
                savingTls: true
            })).addCase((0, _settingsActions.saveTls).rejected, (state)=>({
                ...state,
                savingTls: false
            })).addCase((0, _settingsActions.saveTls).fulfilled, (state, { payload: tls })=>({
                ...state,
                savingTls: false,
                tls
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateSettings).addCase((0, _settingsActions.setDevMode), (state, { payload })=>({
                ...state,
                devMode: payload
            })).addMatcher((0, _actions.isOneOf)([
            (0, _settingsActions.saveImages).fulfilled,
            (0, _settingsActions.saveImages).rejected
        ]), (state)=>({
                ...state,
                savingImages: false
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = settingsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","common/api/v1/types":"3qemx","../actions/settingsActions":"4RBnR","../actions/userActions":"2tWgd","../actions":"jgJYX","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1YMe4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateUi", ()=>initialStateUi);
var _uiActions = require("../actions/uiActions");
var _userActions = require("../actions/userActions");
var _toolkit = require("@reduxjs/toolkit");
var _localstorage = require("../../localstorage");
const initialStateUi = {
    errorSnackbarPosition: localStorage.getItem((0, _localstorage.LOCAL_STORAGE_UI_SNACKBAR_ERROR_POSITION_KEY)) ?? 'bottom-right'
};
const uiSlice = (0, _toolkit.createSlice)({
    name: 'ui',
    initialState: initialStateUi,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _uiActions.toggleSidebarMenu), (state, { payload: isOpen })=>({
                ...state,
                open: isOpen ?? !state.open
            })).addCase((0, _uiActions.changeErrorSnackbarPosition).fulfilled, (state, { payload })=>({
                ...state,
                errorSnackbarPosition: payload
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateUi);
    }
});
exports.default = uiSlice.reducer;

},{"../actions/uiActions":"aO8kk","../actions/userActions":"2tWgd","@reduxjs/toolkit":"8ces8","../../localstorage":"7NDOS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aO8kk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "toggleSidebarMenu", ()=>toggleSidebarMenu);
parcelHelpers.export(exports, "changeErrorSnackbarPosition", ()=>changeErrorSnackbarPosition);
var _toolkit = require("@reduxjs/toolkit");
var _localstorage = require("../../localstorage");
var _alarmsActions = require("./alarmsActions");
var _applianceActions = require("./applianceActions");
var _buildInfoActions = require("./buildInfoActions");
const init = (0, _toolkit.createAsyncThunk)('ui/init', async (navigate, { dispatch, extra: { setNavigate } })=>{
    setNavigate(navigate);
    dispatch((0, _applianceActions.initAppliance)());
    dispatch((0, _alarmsActions.initAlarms)());
    dispatch((0, _buildInfoActions.initBuildInfo)());
});
const toggleSidebarMenu = (0, _toolkit.createAction)('ui/toggleSidebarMenu');
const changeErrorSnackbarPosition = (0, _toolkit.createAsyncThunk)('ui/changeErrorSnackbarPosition', async (position)=>{
    localStorage.setItem((0, _localstorage.LOCAL_STORAGE_UI_SNACKBAR_ERROR_POSITION_KEY), position);
    return position;
});

},{"@reduxjs/toolkit":"8ces8","../../localstorage":"7NDOS","./alarmsActions":"2PZQF","./applianceActions":"TaoIu","./buildInfoActions":"hmDSc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hmDSc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBuildInfo", ()=>getBuildInfo);
parcelHelpers.export(exports, "initBuildInfo", ()=>initBuildInfo);
var _util = require("common/util");
var _notificationActions = require("./notificationActions");
var _mixpanel = require("../../mixpanel");
var _toolkit = require("@reduxjs/toolkit");
var _buildInfoUtils = require("common/buildInfoUtils");
const newVersionSnackbarVisible = ()=>document.querySelector('[data-reload-page-new-version]') !== null;
const getBuildInfo = (0, _toolkit.createAsyncThunk)('buildInfo/readBuildInfo', async (_, { dispatch, getState, extra: { api } })=>{
    const { buildInfo: currentBuildInfo } = getState().buildInfoReducer;
    const buildInfo = await api.buildInfoApi.readBuildInfo();
    if (currentBuildInfo && (0, _buildInfoUtils.areComparable)(currentBuildInfo.release, buildInfo.release)) {
        const current = (0, _buildInfoUtils.releaseTagToNumber)(currentBuildInfo.release);
        const release = (0, _buildInfoUtils.releaseTagToNumber)(buildInfo.release);
        if (current < release && !newVersionSnackbarVisible()) dispatch((0, _notificationActions.enqueueNewVersionAvailableSnackbar)());
    }
    return buildInfo;
});
let initialized = false;
const initBuildInfo = (0, _toolkit.createAsyncThunk)('buildInfo/initBuildInfo', async (_, { dispatch })=>{
    if (initialized) return;
    initialized = true;
    while(true){
        try {
            // Await so it doesn't queue up requests if the backend is slow
            const buildInfo = await dispatch(getBuildInfo()).unwrap();
            (0, _mixpanel.mixpanel).addBuildInfo(buildInfo);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
        await (0, _util.sleep)(30000);
    }
});

},{"common/util":"jV4UZ","./notificationActions":"7LkQg","../../mixpanel":"7xxdr","@reduxjs/toolkit":"8ces8","common/buildInfoUtils":"7U3XK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7U3XK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.areComparable = areComparable;
exports.isReleaseBuild = isReleaseBuild;
exports.isDevBuild = isDevBuild;
exports.comparableReleaseTagToNumber = comparableReleaseTagToNumber;
exports.releaseTagToNumber = releaseTagToNumber;
exports.isReleaseGreaterThanOrEqualToVersion = isReleaseGreaterThanOrEqualToVersion;
const ciSomethingPattern = /^ci-([1-9][0-9]+)$/;
const rSomethingPattern = /^R([1-9]+)\.([0-9]+)\.([0-9]+)(-rc[1-9][0-9]*)?$/;
function areComparable(releaseName1, releaseName2) {
    if (releaseName1.startsWith(releaseName2[0])) {
        // The releases need to be in the same 'series'
        if (isUnderstandableReleaseTag(releaseName1) && isUnderstandableReleaseTag(releaseName2)) return true;
    }
    return false;
}
function isUnderstandableReleaseTag(releaseTag) {
    return isReleaseBuild(releaseTag) || isDevBuild(releaseTag);
}
function isReleaseBuild(releaseTag) {
    return rSomethingPattern.test(releaseTag);
}
function isDevBuild(releaseTag) {
    return ciSomethingPattern.test(releaseTag);
}
function findComparableTag(refTag, candidateTags) {
    return candidateTags.find((t)=>areComparable(refTag, t));
}
function comparableReleaseTagToNumber(referenceReleaseTag, candidateTags) {
    const relatedTag = findComparableTag(referenceReleaseTag, candidateTags);
    if (!relatedTag) return NaN;
    return releaseTagToNumber(relatedTag);
}
function releaseTagToNumber(releaseTag) {
    const rSomethingResult = releaseTag.match(rSomethingPattern);
    if (rSomethingResult) {
        const parts = rSomethingResult.slice(1).filter((v)=>v).map((v)=>v.replace('-rc', ''));
        return numberFromParts(parts);
    }
    const ciSomethingResult = releaseTag.match(ciSomethingPattern);
    if (ciSomethingResult) return numberFromParts(ciSomethingResult.slice(1));
    throw new Error(`Could not convert ${releaseTag} to number`);
}
function numberFromParts(parts) {
    const maxParts = 4;
    if (parts.length > maxParts) throw new Error(`Cannot get version int from ${parts.length} parts`);
    let resultNumber = 0;
    let factor = Math.pow(10, 3 * maxParts);
    for (const n of parts){
        resultNumber = resultNumber + factor * parseInt(n);
        factor = factor / 1000;
    }
    return resultNumber;
}
function isReleaseGreaterThanOrEqualToVersion(releaseVersion, version) {
    if (!version) return false;
    if (isReleaseBuild(version)) {
        const releaseNum = releaseTagToNumber(version);
        const introducedInReleaseNumber = releaseTagToNumber(releaseVersion);
        return releaseNum >= introducedInReleaseNumber;
    }
    return true;
}

},{}],"9a85w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolkit = require("@reduxjs/toolkit");
var _urlParamActions = require("../actions/urlParamActions");
var _userActions = require("../actions/userActions");
const initialState = {
    cachedUrlParams: {}
};
const slice = (0, _toolkit.createSlice)({
    name: 'urlParam',
    initialState: {
        ...initialState
    },
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _urlParamActions.saveUrlParams), (state, { payload: { key, urlParams } })=>{
            return {
                ...state,
                cachedUrlParams: {
                    ...state.cachedUrlParams,
                    [key]: urlParams
                }
            };
        }).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialState);
    }
});
exports.default = slice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/urlParamActions":"abdT4","../actions/userActions":"2tWgd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"abdT4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveUrlParams", ()=>saveUrlParams);
var _toolkit = require("@reduxjs/toolkit");
const saveUrlParams = (0, _toolkit.createAction)('urlParam/saveUrlParams', (cacheKey, urlParams)=>{
    return {
        payload: {
            key: cacheKey,
            urlParams
        }
    };
});

},{"@reduxjs/toolkit":"8ces8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"zTJwy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolkit = require("@reduxjs/toolkit");
var _userActions = require("../actions/userActions");
var _actions = require("../actions");
var _shared = require("./shared");
const initialStateUser = {
    user: {},
    loading: false,
    changingUser: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _userActions.loginUser), (0, _userActions.logoutUser), (0, _userActions.impersonateUser), (0, _userActions.stopImpersonation), (0, _userActions.fetchCurrentUser));
const userSlice = (0, _toolkit.createSlice)({
    name: 'user',
    initialState: initialStateUser,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _userActions.setAuthorizationError), (state, { payload: loginFail })=>({
                ...state,
                loginFail,
                changingUser: false
            })).addCase((0, _userActions.loginUser).fulfilled, (state, { payload })=>({
                ...state,
                user: payload,
                changingUser: false
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateUser).addCase((0, _userActions.impersonateUser).fulfilled, (state, { payload: user })=>({
                ...state,
                user,
                changingUser: false
            })).addCase((0, _userActions.stopImpersonation).fulfilled, (state, { payload: user })=>({
                ...state,
                user,
                changingUser: false
            })).addCase((0, _userActions.fetchCurrentUser).fulfilled, (state, { payload })=>({
                ...state,
                user: payload
            })).addMatcher((0, _actions.isOneOf)([
            (0, _userActions.loginUser).pending,
            (0, _userActions.logoutUser).pending,
            (0, _userActions.impersonateUser).pending,
            (0, _userActions.stopImpersonation).pending
        ]), (state)=>({
                ...state,
                changingUser: true
            })).addMatcher((0, _actions.isOneOf)([
            (0, _userActions.loginUser).rejected,
            (0, _userActions.logoutUser).rejected,
            (0, _userActions.impersonateUser).rejected,
            (0, _userActions.stopImpersonation).rejected
        ]), (state)=>({
                ...state,
                changingUser: false
            })).addMatcher((0, _actions.isOneOf)([
            (0, _userActions.createUser).pending,
            (0, _userActions.updateUser).pending
        ]), (state)=>({
                ...state,
                saving: true
            })).addMatcher((0, _actions.isOneOf)([
            (0, _userActions.createUser).fulfilled,
            (0, _userActions.updateUser).fulfilled
        ]), (state)=>({
                ...state,
                saving: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _userActions.createUser).rejected,
            (0, _userActions.updateUser).rejected
        ]), (state)=>({
                ...state,
                saving: false
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = userSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/userActions":"2tWgd","../actions":"jgJYX","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1vvXA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buildInfoActions = require("../actions/buildInfoActions");
var _toolkit = require("@reduxjs/toolkit");
var _shared = require("./shared");
const initialState = {
    buildInfo: undefined,
    loading: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _buildInfoActions.getBuildInfo));
const buildInfoSlice = (0, _toolkit.createSlice)({
    name: 'buildInfo',
    initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _buildInfoActions.getBuildInfo).fulfilled, (state, { payload: buildInfo })=>({
                ...state,
                buildInfo
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = buildInfoSlice.reducer;

},{"../actions/buildInfoActions":"hmDSc","@reduxjs/toolkit":"8ces8","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mbTt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolkit = require("@reduxjs/toolkit");
var _thumbnailActions = require("../actions/thumbnailActions");
var _thumbnailFetcher = require("../../thumbnail/ThumbnailFetcher");
const initialState = {
    thumbnails: {}
};
const thumbnailsSlice = (0, _toolkit.createSlice)({
    name: 'thumbnails',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _thumbnailActions.onThumbnailsFetched), (state, { payload: inputThumbnailMap })=>{
            const allThumbs = {
                ...state.thumbnails,
                ...inputThumbnailMap
            };
            for (const path of Object.keys(allThumbs)){
                const thumbnail = allThumbs[path];
                if ((0, _thumbnailFetcher.ThumbnailFetcher).isThumbnailStale(thumbnail)) delete allThumbs[path];
            }
            return {
                ...state,
                thumbnails: allThumbs
            };
        });
    }
});
exports.default = thumbnailsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/thumbnailActions":"aJBQE","../../thumbnail/ThumbnailFetcher":"3OAtq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJBQE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onThumbnailsFetched", ()=>onThumbnailsFetched);
var _toolkit = require("@reduxjs/toolkit");
const onThumbnailsFetched = (0, _toolkit.createAction)('thumbnails/onThumbnailsFetched');

},{"@reduxjs/toolkit":"8ces8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3OAtq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThumbnailFetcher", ()=>ThumbnailFetcher);
var _thumbnailActions = require("../redux/actions/thumbnailActions");
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
const ongoingRequests = new Set();
class ThumbnailFetcher {
    static #_ = this.fetchThumbnailWithPath = async (path)=>{
        const thumbnails = (0, _storeDefault.default).getState().thumbnailReducer.thumbnails;
        const cachedThumbnail = thumbnails[path];
        if (!ThumbnailFetcher.isThumbnailCacheDurationExceeded(cachedThumbnail)) //console.log(`Returning cached thumbnail '${inputId}'`)
        return;
        const isFetchInProgress = ongoingRequests.has(path);
        if (isFetchInProgress) //console.log(`Already fetching thumb for input '${inputId}'`)
        return;
        try {
            ongoingRequests.add(path);
            const fetchedThumbnail = await ThumbnailFetcher.doFetchThumbnailWithPath(path);
            (0, _storeDefault.default).dispatch((0, _thumbnailActions.onThumbnailsFetched)({
                [path]: fetchedThumbnail
            }));
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(`Failed fetching thumb: `, error);
        } finally{
            ongoingRequests.delete(path);
        }
    };
    static #_2 = this.doFetchThumbnailWithPath = async (path)=>{
        //console.log(`Fetching thumb for input '${inputId}'`)
        const response = await fetch(`${path}.jpg?${Math.floor(Date.now() / 1000)}`);
        if (!response.ok) throw new Error(`Response not 200`);
        const blob = await response.blob();
        const date = response.headers.get('Date');
        const lastModified = response.headers.get('Last-Modified');
        if (!date || !lastModified || !blob) throw new Error(`Did not receive expected fields`);
        return {
            serverFetchDate: new Date(date),
            serverLastModified: new Date(lastModified),
            localFetchDate: new Date(),
            url: URL.createObjectURL(blob)
        };
    };
    static isThumbnailCacheDurationExceeded(thumbnail) {
        if (!thumbnail) return true;
        const MAX_CACHE_DURATION_MS = 5000;
        const wasFetchedTooLongAgo = new Date().getTime() - thumbnail.localFetchDate.getTime() > MAX_CACHE_DURATION_MS;
        return wasFetchedTooLongAgo;
    }
    static isThumbnailStale(thumbnail) {
        if (!thumbnail) return true;
        // Reasoning behind MAX_THUMBNAIL_AGE_MS:
        // ristserver in R3.21.0 with thumbnailMode="edge" uses the received thumbnailConfig.intervalSeconds property of 5s
        // as a minimum/"not more frequently than" value and generates thumbnails as soon as it receives I-frames.
        // This means that the thumbnail interval is directly dependent on the GOP-size/I-frame interval of the incoming stream,
        // e.g. a GOP size of 600 (the max allowed value in a MatroxE4 encoder) and frame rate of 30 resulted in thumbnails
        // being generated every ~23s, so 15s was too short in this case.
        const MAX_THUMBNAIL_AGE_MS = 30000;
        const wasStaleImageServed = thumbnail.serverFetchDate.getTime() - thumbnail.serverLastModified.getTime() > MAX_THUMBNAIL_AGE_MS;
        return wasStaleImageServed;
    }
}

},{"../redux/actions/thumbnailActions":"aJBQE","../store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f6CUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateAddressMapping", ()=>initialStateAddressMapping);
var _toolkit = require("@reduxjs/toolkit");
var _addressMappingActions = require("../actions/addressMappingActions");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
const initialStateAddressMapping = {
    loading: false,
    ipMappings: []
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _addressMappingActions.createIpMapping), (0, _addressMappingActions.updateIpMapping), (0, _addressMappingActions.removeIpMapping), (0, _addressMappingActions.getIpMappings), (0, _addressMappingActions.getIpMapping));
const addressMappingSlice = (0, _toolkit.createSlice)({
    name: 'addressMappings',
    initialState: initialStateAddressMapping,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateAddressMapping).addCase((0, _addressMappingActions.clearEditMapping), (state)=>({
                ...state,
                ipMapping: undefined
            })).addCase((0, _addressMappingActions.getIpMapping).fulfilled, (state, { payload: mapping })=>({
                ...state,
                ipMapping: mapping
            })).addCase((0, _addressMappingActions.getIpMappings).fulfilled, (state, { payload: ipMappings })=>({
                ...state,
                ipMappings
            })).addCase((0, _addressMappingActions.removeIpMapping).fulfilled, (state, { payload: ipMappings })=>({
                ...state,
                ipMappings
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = addressMappingSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/addressMappingActions":"aRUIy","../actions/userActions":"2tWgd","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Gq1L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolkit = require("@reduxjs/toolkit");
var _userActions = require("../actions/userActions");
var _k8SActions = require("../actions/k8sActions");
var _shared = require("./shared");
const initialStateNodes = {
    kubernetesNodes: [],
    kubernetesNode: undefined,
    resourceUsage: [],
    loading: false,
    loadingResourceUsage: false,
    saving: false,
    total: 0
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _k8SActions.getKubernetesNodes), (0, _k8SActions.getKubernetesNode));
const nodesSlice = (0, _toolkit.createSlice)({
    name: 'kubernetesNodes',
    initialState: initialStateNodes,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _k8SActions.getKubernetesNodes).fulfilled, (state, { payload: { items: kubernetesNodes, total, errors } })=>({
                ...state,
                kubernetesNodes: kubernetesNodes,
                total,
                errors
            })).addCase((0, _k8SActions.getKubernetesNode).fulfilled, (state, { payload: kubernetesNode })=>({
                ...state,
                kubernetesNode
            })).addCase((0, _k8SActions.updateKubernetesNode).fulfilled, (state, { payload: kubernetesNode })=>({
                ...state,
                kubernetesNode,
                formErrors: undefined
            })).addCase((0, _k8SActions.clearKubernetesNode), (state)=>({
                ...state,
                kubernetesNode: undefined,
                formErrors: undefined
            })).addCase((0, _k8SActions.clearKubernetesNodes), (state)=>({
                ...state,
                kubernetesNodes: [],
                formErrors: undefined
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateNodes).addCase((0, _k8SActions.getResourceUsage).pending, (state)=>({
                ...state,
                loadingResourceUsage: true
            })).addCase((0, _k8SActions.getResourceUsage).rejected, (state)=>({
                ...state,
                loadingResourceUsage: false
            })).addCase((0, _k8SActions.getResourceUsage).fulfilled, (state, { payload: resourceUsage })=>({
                ...state,
                resourceUsage,
                loadingResourceUsage: false
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = nodesSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/userActions":"2tWgd","../actions/k8sActions":"lYa8m","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePWWY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateNetworks", ()=>initialStateNetworks);
var _toolkit = require("@reduxjs/toolkit");
var _userActions = require("../actions/userActions");
var _actions = require("../actions");
var _networkActions = require("../actions/networkActions");
var _shared = require("./shared");
const initialStateNetworks = {
    networks: [],
    loading: false,
    total: 0
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _networkActions.removeNetwork), (0, _networkActions.getNetworks));
const networksSlice = (0, _toolkit.createSlice)({
    name: 'networks',
    initialState: initialStateNetworks,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _networkActions.getNetwork).fulfilled, (state, { payload: network })=>({
                ...state,
                network
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateNetworks).addCase((0, _networkActions.clearNetwork), (state)=>({
                ...state,
                network: undefined,
                formErrors: undefined
            })).addCase((0, _networkActions.clearNetworks), (state)=>({
                ...state,
                networks: []
            })).addCase((0, _networkActions.getNetworks).fulfilled, (state, { payload: { items: networks, total } })=>({
                ...state,
                networks,
                total
            })).addMatcher((0, _actions.isOneOf)([
            (0, _networkActions.updateNetwork).pending,
            (0, _networkActions.createNetwork).pending
        ]), (state)=>({
                ...state,
                saving: true
            })).addMatcher((0, _actions.isOneOf)([
            (0, _networkActions.createNetwork).fulfilled,
            (0, _networkActions.updateNetwork).fulfilled
        ]), (state)=>({
                ...state,
                saving: undefined,
                formErrors: undefined
            })).addMatcher((0, _actions.isOneOf)([
            (0, _networkActions.updateNetwork).rejected,
            (0, _networkActions.createNetwork).rejected
        ]), (state, { payload })=>({
                ...state,
                saving: false,
                formErrors: payload?.details
            })).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = networksSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/userActions":"2tWgd","../actions":"jgJYX","../actions/networkActions":"gfZop","./shared":"ix9iK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYa0b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateOverlays", ()=>initialStateOverlays);
var _overlaysActions = require("../actions/overlaysActions");
var _shared = require("./shared");
var _toolkit = require("@reduxjs/toolkit");
var _userActions = require("../actions/userActions");
const initialStateOverlays = {
    loading: false,
    saving: false,
    overlays: [],
    total: 0,
    selectedOverlay: undefined
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _overlaysActions.listOverlays));
const overlaysSlice = (0, _toolkit.createSlice)({
    name: 'overlays',
    initialState: initialStateOverlays,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _overlaysActions.updateOverlay).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _overlaysActions.updateOverlay).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _overlaysActions.updateOverlay).fulfilled, (state, { payload: overlay })=>({
                ...state,
                saving: false,
                overlays: [
                    overlay,
                    ...state.overlays.filter((o)=>o.id !== overlay.id)
                ]
            })).addCase((0, _overlaysActions.deleteOverlay).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _overlaysActions.deleteOverlay).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _overlaysActions.deleteOverlay).fulfilled, (state, { payload: e })=>({
                ...state,
                saving: false,
                overlays: state.overlays.filter((o)=>o.id !== e.id)
            })).addCase((0, _overlaysActions.listOverlays).fulfilled, (state, { payload: { items, total } })=>({
                ...state,
                overlays: items,
                total
            })).addCase((0, _overlaysActions.getOverlay).fulfilled, (state, { payload: overlay })=>({
                ...state,
                selectedOverlay: overlay
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateOverlays).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = overlaysSlice.reducer;

},{"../actions/overlaysActions":"ff6Jg","./shared":"ix9iK","@reduxjs/toolkit":"8ces8","../actions/userActions":"2tWgd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ff6Jg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listOverlaysHook", ()=>listOverlaysHook);
parcelHelpers.export(exports, "listOverlays", ()=>listOverlays);
parcelHelpers.export(exports, "getOverlay", ()=>getOverlay);
parcelHelpers.export(exports, "updateOverlay", ()=>updateOverlay);
parcelHelpers.export(exports, "deleteOverlay", ()=>deleteOverlay);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
const listOverlaysHook = async (params, { dispatch, overlaysApi })=>{
    try {
        return await overlaysApi.listOverlays((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch overlays'
        }));
        throw err;
    }
};
const listOverlays = (0, _toolkit.createAsyncThunk)('overlays/listOverlays', async (params, { extra: { api } })=>{
    return await api.overlaysApi.listOverlays(params);
});
const getOverlay = (0, _toolkit.createAsyncThunk)('overlays/getOverlay', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.overlaysApi.getOverlay(id);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'get overlay'
        }));
        throw error;
    }
});
const updateOverlay = (0, _toolkit.createAsyncThunk)('overlays/updateOverlay', async (overlay, { dispatch, extra: { api } })=>{
    try {
        const res = await api.overlaysApi.updateOverlay(overlay);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Overlay saved'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'update overlay'
        }));
        throw error;
    }
});
const deleteOverlay = (0, _toolkit.createAsyncThunk)('overlays/deleteOverlay', async (id, { dispatch, extra: { api } })=>{
    try {
        const res = await api.overlaysApi.deleteOverlay(id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Overlay deleted'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'delete overlay'
        }));
        throw error;
    }
});

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cJsMx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateAdInsertionReducer", ()=>initialStateAdInsertionReducer);
var _shared = require("./shared");
var _toolkit = require("@reduxjs/toolkit");
var _userActions = require("../actions/userActions");
var _adServerActions = require("../actions/adServerActions");
const initialStateAdInsertionReducer = {
    loading: false,
    saving: false,
    adServers: [],
    selectedAdServer: undefined
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _adServerActions.listAdServers));
const adInsertionSlice = (0, _toolkit.createSlice)({
    name: 'adServers',
    initialState: initialStateAdInsertionReducer,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _adServerActions.getAdServer).fulfilled, (state, { payload: selectedAdServer })=>({
                ...state,
                selectedAdServer
            })).addCase((0, _adServerActions.clearAdServer), (state)=>({
                ...state,
                selectedAdServer: undefined,
                formErrors: undefined
            })).addCase((0, _adServerActions.updateAdServer).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _adServerActions.updateAdServer).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _adServerActions.updateAdServer).fulfilled, (state, { payload: adServer })=>({
                ...state,
                saving: false,
                adServers: [
                    adServer,
                    ...state.adServers.filter((o)=>o.id !== adServer.id)
                ],
                formErrors: undefined
            })).addCase((0, _adServerActions.deleteAdServer).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _adServerActions.deleteAdServer).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _adServerActions.deleteAdServer).fulfilled, (state, { payload: e })=>({
                ...state,
                saving: false,
                adServers: state.adServers.filter((o)=>o.id !== e.id),
                formErrors: undefined
            })).addCase((0, _adServerActions.listAdServers).fulfilled, (state, { payload: adServers })=>({
                ...state,
                adServers: adServers.items
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateAdInsertionReducer).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = adInsertionSlice.reducer;

},{"./shared":"ix9iK","@reduxjs/toolkit":"8ces8","../actions/userActions":"2tWgd","../actions/adServerActions":"h89Of","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h89Of":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listAdServersHook", ()=>listAdServersHook);
parcelHelpers.export(exports, "listAdServers", ()=>listAdServers);
parcelHelpers.export(exports, "getAdServer", ()=>getAdServer);
parcelHelpers.export(exports, "createAdServer", ()=>createAdServer);
parcelHelpers.export(exports, "updateAdServer", ()=>updateAdServer);
parcelHelpers.export(exports, "deleteAdServer", ()=>deleteAdServer);
parcelHelpers.export(exports, "clearAdServer", ()=>clearAdServer);
parcelHelpers.export(exports, "clearAdServers", ()=>clearAdServers);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
const listAdServersHook = async (params, { dispatch, adServersApi })=>{
    try {
        return await adServersApi.listAdServers((0, _utils.withDefaultPagination)(params));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch overlays'
        }));
        throw err;
    }
};
const listAdServers = (0, _toolkit.createAsyncThunk)('adServers/listAdServers', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.adServersApi.listAdServers(params);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'fetch Ad Servers'
        }));
        throw error;
    }
});
const getAdServer = (0, _toolkit.createAsyncThunk)('adServers/getAdServer', async (id, { dispatch, extra: { api } })=>{
    try {
        return await api.adServersApi.getAdServer(id);
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'fetch Ad Server'
        }));
        throw error;
    }
});
const createAdServer = (0, _toolkit.createAsyncThunk)('adServers/createAdServer', async (adServer, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.adServersApi.createAdServer(adServer);
        navigate()(routes.adServers());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Server created'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'create Ad Server'
        }));
        throw error;
    }
});
const updateAdServer = (0, _toolkit.createAsyncThunk)('adServers/updateAdServer', async (adServer, { dispatch, extra: { routes, api, navigate } })=>{
    try {
        const res = await api.adServersApi.updateAdServer(adServer.id, adServer);
        navigate()(routes.adServers());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Server saved'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'update Ad Server'
        }));
        throw error;
    }
});
const deleteAdServer = (0, _toolkit.createAsyncThunk)('adServers/deleteAdServer', async (id, { dispatch, extra: { api } })=>{
    try {
        const res = await api.adServersApi.deleteAdServer(id);
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Ad Server deleted'));
        return res;
    } catch (error) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error,
            operation: 'delete Ad Server'
        }));
        throw error;
    }
});
const clearAdServer = (0, _toolkit.createAction)('adServers/clearAdServer');
const clearAdServers = (0, _toolkit.createAction)('adServers/clearAdServers');

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8H1Ji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStateAdAudit", ()=>initialStateAdAudit);
var _toolkit = require("@reduxjs/toolkit");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
var _adAuditActions = require("../actions/adAuditActions");
const initialStateAdAudit = {
    adAudit: [],
    total: 0,
    loading: false
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _adAuditActions.getAdAudit));
const adAuditSlice = (0, _toolkit.createSlice)({
    name: 'adAudit',
    initialState: initialStateAdAudit,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _adAuditActions.getAdAudit).fulfilled, (state, { payload: { items: adAudit, total } })=>({
                ...state,
                adAudit,
                total,
                loading: false
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialStateAdAudit).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = adAuditSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/userActions":"2tWgd","./shared":"ix9iK","../actions/adAuditActions":"ddShH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ddShH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAdAudit", ()=>getAdAudit);
var _toolkit = require("@reduxjs/toolkit");
var _utils = require("../../utils");
const getAdAudit = (0, _toolkit.createAsyncThunk)('audit/getAdAudit', async (params, { extra: { api } })=>{
    return await api.adAuditApi.getAdAudit((0, _utils.withDefaultPagination)(params));
});

},{"@reduxjs/toolkit":"8ces8","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fSSxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialAdCreatives", ()=>initialAdCreatives);
var _toolkit = require("@reduxjs/toolkit");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
var _adCreativeActions = require("../actions/adCreativeActions");
const initialAdCreatives = {
    adCreatives: [],
    selectedAdCreative: undefined,
    total: 0,
    loading: false,
    saving: false,
    formErrors: undefined
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _adCreativeActions.listAdCreatives));
const adCreativeSlice = (0, _toolkit.createSlice)({
    name: 'adCreative',
    initialState: initialAdCreatives,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _adCreativeActions.getAdCreative).fulfilled, (state, { payload: selectedAdCreative })=>({
                ...state,
                selectedAdCreative
            })).addCase((0, _adCreativeActions.clearAdCreative), (state)=>({
                ...state,
                selectedAdCreative: undefined
            })).addCase((0, _adCreativeActions.updateAdCreative).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _adCreativeActions.updateAdCreative).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _adCreativeActions.updateAdCreative).fulfilled, (state, { payload: adCreative })=>({
                ...state,
                adCreatives: [
                    adCreative,
                    ...state.adCreatives.filter((o)=>o.id !== adCreative.id)
                ],
                saving: false
            })).addCase((0, _adCreativeActions.deleteAdCreative).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _adCreativeActions.deleteAdCreative).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _adCreativeActions.deleteAdCreative).fulfilled, (state, { payload: e })=>({
                ...state,
                adCreatives: state.adCreatives.filter((o)=>o.id !== e.id),
                saving: false
            })).addCase((0, _adCreativeActions.deleteAdCreatives).fulfilled, (state, { payload: ids })=>({
                ...state,
                adCreatives: state.adCreatives.filter((o)=>!ids.includes(o.id)),
                saving: false
            })).addCase((0, _adCreativeActions.listAdCreatives).fulfilled, (state, { payload: adCreatives })=>({
                ...state,
                adCreatives: adCreatives.items,
                total: adCreatives.total,
                loading: false
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialAdCreatives).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = adCreativeSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/userActions":"2tWgd","./shared":"ix9iK","../actions/adCreativeActions":"gzqhz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axiN1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialAdPods", ()=>initialAdPods);
var _toolkit = require("@reduxjs/toolkit");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
var _adPodActions = require("../actions/adPodActions");
const initialAdPods = {
    adPods: [],
    selectedAdPod: undefined,
    total: 0,
    loading: false,
    saving: false,
    formErrors: undefined
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _adPodActions.listAdPods));
const adPodSlice = (0, _toolkit.createSlice)({
    name: 'adPod',
    initialState: initialAdPods,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _adPodActions.getAdPod).fulfilled, (state, { payload: selectedAdPod })=>({
                ...state,
                selectedAdPod
            })).addCase((0, _adPodActions.clearAdPod), (state)=>({
                ...state,
                selectedAdPod: undefined
            })).addCase((0, _adPodActions.updateAdPod).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _adPodActions.updateAdPod).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _adPodActions.updateAdPod).fulfilled, (state, { payload: adPod })=>({
                ...state,
                adPods: [
                    adPod,
                    ...state.adPods.filter((o)=>o.id !== adPod.id)
                ]
            })).addCase((0, _adPodActions.deleteAdPod).pending, (state)=>({
                ...state,
                saving: true
            })).addCase((0, _adPodActions.deleteAdPod).rejected, (state)=>({
                ...state,
                saving: false
            })).addCase((0, _adPodActions.deleteAdPod).fulfilled, (state, { payload: e })=>({
                ...state,
                adPods: state.adPods.filter((o)=>o.id !== e.id),
                saving: false
            })).addCase((0, _adPodActions.deleteAdPods).fulfilled, (state, { payload: ids })=>({
                ...state,
                adPods: state.adPods.filter((o)=>!ids.includes(o.id)),
                saving: false
            })).addCase((0, _adPodActions.listAdPods).fulfilled, (state, { payload: adPods })=>({
                ...state,
                adPods: adPods.items,
                total: adPods.total,
                loading: false
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialAdPods).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = adPodSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/userActions":"2tWgd","./shared":"ix9iK","../actions/adPodActions":"2olSr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"FWK4i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialAdBreaks", ()=>initialAdBreaks);
var _toolkit = require("@reduxjs/toolkit");
var _userActions = require("../actions/userActions");
var _shared = require("./shared");
var _adBreakActions = require("../actions/adBreakActions");
const initialAdBreaks = {
    adBreaks: [],
    selectedAdBreak: undefined,
    total: 0,
    loading: false,
    formErrors: undefined
};
const { isLoadingAction, loadingReducer } = (0, _shared.createLoadingReducer)((0, _adBreakActions.listAdBreaks));
const adBreakSlice = (0, _toolkit.createSlice)({
    name: 'adBreak',
    initialState: initialAdBreaks,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase((0, _adBreakActions.getAdBreak).fulfilled, (state, { payload: selectedAdBreak })=>({
                ...state,
                selectedAdBreak
            })).addCase((0, _adBreakActions.clearAdBreak), (state)=>({
                ...state,
                selectedAdBreak: undefined
            })).addCase((0, _adBreakActions.deleteAdBreak).pending, (state)=>({
                ...state
            })).addCase((0, _adBreakActions.deleteAdBreak).rejected, (state)=>({
                ...state
            })).addCase((0, _adBreakActions.deleteAdBreak).fulfilled, (state, { payload: e })=>({
                ...state,
                adBreaks: state.adBreaks.filter((o)=>o.id !== e.id)
            })).addCase((0, _adBreakActions.deleteAdBreaks).fulfilled, (state, { payload: ids })=>({
                ...state,
                adBreaks: state.adBreaks.filter((o)=>!ids.includes(o.id))
            })).addCase((0, _adBreakActions.listAdBreaks).fulfilled, (state, { payload: adBreaks })=>({
                ...state,
                adBreaks: adBreaks.items,
                total: adBreaks.total,
                loading: false
            })).addCase((0, _userActions.logoutUser).fulfilled, ()=>initialAdBreaks).addMatcher(isLoadingAction, loadingReducer);
    }
});
exports.default = adBreakSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../actions/userActions":"2tWgd","./shared":"ix9iK","../actions/adBreakActions":"baydX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gk2S4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toolkit = require("@reduxjs/toolkit");
var _localstorage = require("../../localstorage");
var _actions = require("../actions");
var _tagsAction = require("../actions/tagsAction");
const initialState = {
    searchHistory: JSON.parse(localStorage.getItem((0, _localstorage.LOCAL_STORAGE_TAGS_HISTORY_KEY)) ?? '[]')
};
const tagsSlice = (0, _toolkit.createSlice)({
    name: 'tags',
    initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addMatcher((0, _actions.isOneOf)([
            (0, _tagsAction.updateSearchHistory).fulfilled,
            (0, _tagsAction.deleteSearchHistory).fulfilled
        ]), (_, { payload })=>({
                searchHistory: payload
            }));
    }
});
exports.default = tagsSlice.reducer;

},{"@reduxjs/toolkit":"8ces8","../../localstorage":"7NDOS","../actions":"jgJYX","../actions/tagsAction":"6HCqL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HCqL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateSearchHistory", ()=>updateSearchHistory);
parcelHelpers.export(exports, "deleteSearchHistory", ()=>deleteSearchHistory);
var _toolkit = require("@reduxjs/toolkit");
var _localstorage = require("../../localstorage");
const HISTORY_LEN = 10;
const updateSearchHistory = (0, _toolkit.createAsyncThunk)('tags/updateSearchHistory', async (tags)=>{
    const history = JSON.parse(localStorage.getItem((0, _localstorage.LOCAL_STORAGE_TAGS_HISTORY_KEY)) ?? '[]');
    if (!tags || history.some((h)=>h === tags)) return history;
    const newHistory = [
        ...history,
        tags
    ].slice(-HISTORY_LEN);
    localStorage.setItem((0, _localstorage.LOCAL_STORAGE_TAGS_HISTORY_KEY), JSON.stringify(newHistory));
    return newHistory;
});
const deleteSearchHistory = (0, _toolkit.createAsyncThunk)('tags/deleteSearchHistory', async (tags)=>{
    const history = JSON.parse(localStorage.getItem((0, _localstorage.LOCAL_STORAGE_TAGS_HISTORY_KEY)) ?? '[]');
    if (!tags) return history;
    const newHistory = history.filter((h)=>h !== tags);
    localStorage.setItem((0, _localstorage.LOCAL_STORAGE_TAGS_HISTORY_KEY), JSON.stringify(newHistory));
    return newHistory;
});

},{"@reduxjs/toolkit":"8ces8","../../localstorage":"7NDOS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cQGur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Api", ()=>Api);
var _api = require("./inputs/api");
var _api1 = require("./outputs/api");
var _api2 = require("./user/api");
var _api3 = require("./service/api");
var _api4 = require("./appliances/api");
var _api5 = require("./ports/api");
var _api6 = require("./groups/api");
var _api7 = require("./alarms/api");
var _api8 = require("./alarmLogs/api");
var _api9 = require("./bitrates/api");
var _api10 = require("./billing/api");
var _api11 = require("./usage/api");
var _api12 = require("./graph/api");
var _api13 = require("./location/api");
var _api14 = require("./region/api");
var _api15 = require("./outputLists/api");
var _api16 = require("./groupLists/api");
var _api17 = require("./adAudit/api");
var _api18 = require("./settings/api");
var _api19 = require("./status/api");
var _api20 = require("./image/api");
var _api21 = require("./tls/api");
var _api22 = require("./buildInfo/api");
var _api23 = require("./addressMappings/api");
var _api24 = require("./kubernetes/api");
var _api25 = require("./networks/api");
var _api26 = require("./apiTokens/api");
var _api27 = require("./tunnel/api");
var _api28 = require("./overlays/api");
var _api29 = require("./tags/api");
var _api30 = require("./adServers/api");
var _api31 = require("./audit/api");
var _api32 = require("./adInsertionDemo/api");
var _api33 = require("./adCreatives/api");
var _api34 = require("./adPods/api");
var _api35 = require("./adBreaks/api");
var _api36 = require("./adStorage/api");
class Api {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
        this.adAuditApi = new (0, _api17.AdAuditApi)(this.edgeClient);
        this.addressMappingsApi = new (0, _api23.AddressMappingApi)(this.edgeClient);
        this.adInsertionDemoApi = new (0, _api32.AdInsertionDemoApi)(this.edgeClient);
        this.apiTokensApi = new (0, _api26.ApiTokenApi)(this.edgeClient);
        this.alarmsApi = new (0, _api7.AlarmsApi)(this.edgeClient);
        this.alarmLogsApi = new (0, _api8.AlarmLogsApi)(this.edgeClient);
        this.appliancesApi = new (0, _api4.AppliancesApi)(this.edgeClient);
        this.auditApi = new (0, _api31.AuditApi)(this.edgeClient);
        this.billingApi = new (0, _api10.BillingApi)(this.edgeClient);
        this.usageApi = new (0, _api11.UsageApi)(this.edgeClient);
        this.bitratesApi = new (0, _api9.BitratesApi)(this.edgeClient);
        this.graphApi = new (0, _api12.GraphApi)(this.edgeClient);
        this.groupListsApi = new (0, _api16.GroupListApi)(this.edgeClient);
        this.imageApi = new (0, _api20.ImageApi)(this.edgeClient);
        this.inputApi = new (0, _api.InputApi)(this.edgeClient);
        this.locationApi = new (0, _api13.LocationApi)();
        this.groupsApi = new (0, _api6.GroupsApi)(this.edgeClient);
        this.outputApi = new (0, _api1.OutputApi)(this.edgeClient);
        this.outputListsApi = new (0, _api15.OutputListApi)(this.edgeClient);
        this.portsApi = new (0, _api5.PortsApi)(this.edgeClient);
        this.regionApi = new (0, _api14.RegionApi)(this.edgeClient);
        this.overlaysApi = new (0, _api28.OverlaysApi)(this.edgeClient);
        this.adServersApi = new (0, _api30.AdServersApi)(this.edgeClient);
        this.adCreativesApi = new (0, _api33.AdCreativesApi)(this.edgeClient);
        this.adPodsApi = new (0, _api34.AdPodsApi)(this.edgeClient);
        this.adBreaksApi = new (0, _api35.AdBreaksApi)(this.edgeClient);
        this.adStorageApi = new (0, _api36.AdStorageApi)(this.edgeClient);
        this.settingsApi = new (0, _api18.SettingsApi)(this.edgeClient);
        this.statusApi = new (0, _api19.StatusApi)(this.edgeClient);
        this.tagApi = new (0, _api29.TagApi)(this.edgeClient);
        this.tlsApi = new (0, _api21.TlsApi)(this.edgeClient);
        this.userApi = new (0, _api2.UserApi)(this.edgeClient);
        this.serviceApi = new (0, _api3.ServiceApi)(this.edgeClient);
        this.buildInfoApi = new (0, _api22.BuildInfoApi)(this.edgeClient);
        this.kubernetesApi = new (0, _api24.KubernetesApi)(this.edgeClient);
        this.networksApi = new (0, _api25.NetworksApi)(this.edgeClient);
        this.tunnelApi = new (0, _api27.TunnelApi)(this.edgeClient);
    }
    isAborted(...args) {
        return this.edgeClient.isAborted(...args);
    }
}

},{"./inputs/api":"fNMtN","./outputs/api":"dWiei","./user/api":"1LNAe","./service/api":"fv1YY","./appliances/api":"kMHoT","./ports/api":"ftAJR","./groups/api":"1rDiO","./alarms/api":"dFZEf","./alarmLogs/api":"66OTB","./bitrates/api":"4swtU","./billing/api":"gYpft","./usage/api":"ctkth","./graph/api":"hQ63R","./location/api":"89tYq","./region/api":"7dQe4","./outputLists/api":"5Bis9","./groupLists/api":"hG5Rc","./adAudit/api":"6b3Zb","./settings/api":"3ieXz","./status/api":"ewLUJ","./image/api":"1CcpL","./tls/api":"28Obc","./buildInfo/api":"hMHEl","./addressMappings/api":"6ci3g","./kubernetes/api":"h5EIR","./networks/api":"buscV","./apiTokens/api":"92yiB","./tunnel/api":"10MoA","./overlays/api":"ikwub","./tags/api":"91TDM","./adServers/api":"bsq2u","./audit/api":"kTQ3B","./adInsertionDemo/api":"eNlcT","./adCreatives/api":"dxRWQ","./adPods/api":"jS2ec","./adBreaks/api":"gzLmX","./adStorage/api":"6LYeH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNMtN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PermissionAction", ()=>PermissionAction);
parcelHelpers.export(exports, "InputApi", ()=>InputApi);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _nmTypes = require("../nm-types");
var PermissionAction = /*#__PURE__*/ function(PermissionAction) {
    PermissionAction["add"] = "add";
    PermissionAction["change"] = "change";
    PermissionAction["remove"] = "remove";
    return PermissionAction;
}({});
class InputApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    rerouteInput(id, avoidApplianceId) {
        return this.edgeClient.rerouteInput(id, {
            avoidApplianceId
        });
    }
    pcapInput(id, applianceId) {
        return this.edgeClient.pcapInput(id, {
            applianceId
        }).then(()=>void 0);
    }
    createInput(input) {
        return this.edgeClient.createInput(input);
    }
    updateInput(id, input) {
        return this.edgeClient.updateInput(id, input);
    }
    removeInput(id) {
        return this.edgeClient.deleteInput(id);
    }
    removeInputs(ids) {
        return this.edgeClient.deleteInputs({
            ids
        });
    }
    readInputDistribution(id) {
        return this.edgeClient.listInputDistributions(id);
    }
    /**
   * Updating groups access to the input
   * @param id - input id
   * @param permissions - GroupInputPermission and the PermissionAction to apply on it (change access type or remove access)
   * @param listPermissions - new permissions to create { [inputId ]: InputAccessType}
   */ async updateInputDistribution(id, permissions, listPermissions) {
        const distribution = await this.readInputDistribution(id);
        const added = permissions.filter(({ action })=>action === "add");
        const newDistributions = distribution.reduce((acc, perm)=>{
            const edited = permissions.find(({ permission: { groupId: id } })=>perm.groupId === id);
            if (!edited) return [
                ...acc,
                perm
            ];
            if (edited.action === "change") return [
                ...acc,
                {
                    ...edited.permission,
                    accessType: perm.accessType === (0, _types.InputAccessType).pull ? (0, _types.InputAccessType).view : (0, _types.InputAccessType).pull
                }
            ];
            return acc;
        }, []).concat(added.map(({ permission })=>permission));
        const groupRecipientLists = Object.entries(listPermissions).map(([key, value])=>({
                type: 'groupList',
                groupListId: key,
                accessType: value
            }));
        const inputDistributionResponse = await this.edgeClient.setInputDistributions(id, [
            ...newDistributions,
            ...groupRecipientLists
        ]);
        return inputDistributionResponse;
    }
    /**
   * Sending/canceling sending the input to outputs
   * @param id - input id
   * @param listsAdded - outputLists id array to send
   * @param outputsAdded - output id array to send
   * @param outputsRemoved - output id array to cancel sending
   */ async updateInputRecipients({ id, listsAdded, outputsAdded, outputsRemoved }) {
        await this.edgeClient.updateRecipientsInput(id, {
            addOutputIds: outputsAdded,
            removeOutputIds: outputsRemoved,
            outputRecipientLists: listsAdded
        });
    }
    getInputHealth(id) {
        return this.edgeClient.getInputHealth(id);
    }
    /**
   * Returns input populating its ports with physical ports populated with appliance
   * @param inputId
   * @param filter
   */ async getInput(inputId, filter) {
        const input = await this.edgeClient.getInput(inputId, {
            filter
        });
        // TODO: Consider using listAppliancePhysicalPorts() to patch the input ports rather than all the below.
        // Also, the below doesn't work for regional inputs belonging to a different group than the core video appliances,
        // resulting in that port._port becomes { _appliance: undefined }
        const ports = await Promise.all((input.ports || []).map((p)=>// TODO: Will throw for regional ports when non-super user does not have access to appliance
            // TODO: Future improvement: Reduce number of network requests by listPorts({ filter: ids })
            this.edgeClient.getPort(p.physicalPort).catch(()=>{
                // Temporary HACK to make service overview work for shared inputs (EDGE-1709)
                return {};
            })));
        const applianceIds = Array.from(new Set(input.appliances?.map((a)=>a.id))).filter((id)=>!!id);
        const appliances = applianceIds.length > 0 ? (await this.edgeClient.listAppliances({
            filter: {
                ids: applianceIds
            }
        })).items : [];
        const applianceOwnerIds = appliances.map((0, _utils.getApplianceOwnerId));
        const ownerIds = Array.from(new Set([
            input.owner,
            ...applianceOwnerIds
        ].filter((o)=>!!o)));
        const owners = ownerIds.length > 0 ? (await this.edgeClient.listGroups({
            filter: {
                ids: ownerIds
            }
        })).items : [];
        const enrichedInput = {
            ...input,
            _owner: owners.find((o)=>o.id == input.owner),
            ports: (input.ports || []).map((inputPort, ind)=>{
                const port = ports[ind];
                const _appliance = appliances.find(({ id })=>port && id === port.appliance.id);
                return {
                    ...inputPort,
                    _port: {
                        ...port,
                        _appliance
                    }
                };
            })
        };
        return enrichedInput;
    }
    /**
   * Returns ListResult of inputs populated with their owners
   * @param requestParams
   */ async getInputs(requestParams) {
        const { items, total } = await this.getBareInputs(requestParams);
        const groupIds = Array.from(new Set(items.filter((input)=>input.owner).map((input)=>input.owner)));
        const groups = groupIds.length > 0 ? (await this.edgeClient.listGroups({
            filter: {
                ids: groupIds
            }
        })).items : [];
        return {
            items: items.map((input)=>({
                    ...input,
                    _owner: groups.find((g)=>g.id === input.owner)
                })),
            total
        };
    }
    getBareInputs({ canSubscribe, applianceId, appliances, regions, filter: searchName, derived, owner, adminStatus, health, tags, ...params }) {
        const filter = {
            canSubscribe,
            applianceId,
            inputApplianceRegions: regions?.split(','),
            inputApplianceNames: appliances?.split(','),
            searchName,
            derived,
            ownerGroupName: owner,
            adminStatus: adminStatus && [
                (0, _types.InputAdminStatus).on.toString(),
                (0, _types.InputAdminStatus).off.toString()
            ].includes(adminStatus) ? Number(adminStatus) : undefined,
            healthStatuses: health === (0, _nmTypes.InputFilterHealthStatus).healthy ? [
                (0, _types.InputOperStatus).allOk
            ] : health === (0, _nmTypes.InputFilterHealthStatus).unhealthy ? Object.values((0, _types.InputOperStatus)).filter((s)=>s !== (0, _types.InputOperStatus).allOk) : undefined,
            tags: tags?.split(',')
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.listInputs(query);
    }
    listInputs(query) {
        return this.edgeClient.listInputs(query);
    }
    getOverview(inputId, { output, filter: searchName, input, inputTr101290Window, ...params }) {
        const filter = {
            searchName,
            input,
            output,
            inputTr101290Window
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.getInputServiceOverview(inputId, query);
    }
    enableInputPreview(inputId) {
        return this.edgeClient.enableInputPreview(inputId);
    }
    enableInputs(ids) {
        return this.edgeClient.setInputAdminStatuses(ids.map((id)=>({
                id,
                adminStatus: (0, _types.InputAdminStatus).on
            })));
    }
    disableInputs(ids) {
        return this.edgeClient.setInputAdminStatuses(ids.map((id)=>({
                id,
                adminStatus: (0, _types.InputAdminStatus).off
            })));
    }
}

},{"common/api/v1/types":"3qemx","../../utils":"342UB","../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bcYl5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputFilterHealthStatus", ()=>InputFilterHealthStatus);
parcelHelpers.export(exports, "OutputFilterHealthStatus", ()=>OutputFilterHealthStatus);
/** Returns Query<TFilter, SortOrder<TSortOrder>> (i.e. single SortOrder) for backend APIs that only accept queries with a single sort param **/ parcelHelpers.export(exports, "singleSortQueryFromPaginatedRequestParams", ()=>singleSortQueryFromPaginatedRequestParams);
parcelHelpers.export(exports, "SrtBondingMode", ()=>SrtBondingMode);
parcelHelpers.export(exports, "srtCallerBondingOptions", ()=>srtCallerBondingOptions);
parcelHelpers.export(exports, "srtListenerBondingOptions", ()=>srtListenerBondingOptions);
parcelHelpers.export(exports, "nullBondingOptions", ()=>nullBondingOptions);
parcelHelpers.export(exports, "srtBondingOptions", ()=>srtBondingOptions);
var _types = require("common/api/v1/types");
var InputFilterHealthStatus = /*#__PURE__*/ function(InputFilterHealthStatus) {
    InputFilterHealthStatus["healthy"] = "healthy";
    InputFilterHealthStatus["unhealthy"] = "unhealthy";
    return InputFilterHealthStatus;
}({});
var OutputFilterHealthStatus = /*#__PURE__*/ function(OutputFilterHealthStatus) {
    OutputFilterHealthStatus["healthy"] = "healthy";
    OutputFilterHealthStatus["unhealthy"] = "unhealthy";
    return OutputFilterHealthStatus;
}({});
function singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams }) {
    const { pageNumber, rowsPerPage, asc, desc } = paginatedRequestParams;
    return {
        filter,
        skip: +pageNumber * +rowsPerPage,
        limit: +rowsPerPage,
        order: makeSortOrder({
            asc,
            desc
        })
    };
}
/** For backend APIs that receive queries with a single sort order **/ function makeSortOrder({ asc, desc }) {
    if (asc !== undefined) return {
        descending: false,
        field: asc
    };
    else if (desc !== undefined) return {
        descending: true,
        field: desc
    };
    return undefined;
}
var SrtBondingMode = /*#__PURE__*/ function(SrtBondingMode) {
    SrtBondingMode[SrtBondingMode["none"] = 0] = "none";
    // bondingMode == 1 just signifies that bonding is enabled for the listener case
    // (since listeners can only indicate whether bonding is enabled or not)
    SrtBondingMode[SrtBondingMode["activeActive"] = 1] = "activeActive";
    SrtBondingMode[SrtBondingMode["activeBackup"] = 2] = "activeBackup";
    return SrtBondingMode;
}({});
const srtCallerBondingOptions = [
    {
        name: 'None',
        value: 0
    },
    {
        name: 'Active-Active',
        value: 1
    },
    {
        name: 'Active-Backup',
        value: 2
    }
];
const srtListenerBondingOptions = [
    {
        name: 'None',
        value: 0
    },
    {
        name: 'Bonded',
        value: 1
    }
];
const nullBondingOptions = [
    {
        name: 'None',
        value: 0
    }
];
function srtBondingOptions(srtMode) {
    if (srtMode === (0, _types.SrtMode).caller) return srtCallerBondingOptions;
    else if (srtMode === (0, _types.SrtMode).listener) return srtListenerBondingOptions;
    return nullBondingOptions;
}

},{"common/api/v1/types":"3qemx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dWiei":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OutputApi", ()=>OutputApi);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _nmTypes = require("../nm-types");
class OutputApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    createOutput(output) {
        return this.edgeClient.createOutput(output);
    }
    /**
   * Updates output populating response with input and group objects if present
   * @param id - output id
   * @param output - output object
   */ async updateOutput(id, output) {
        const outputRes = await this.edgeClient.updateOutput(id, output);
        return this.getEnrichedOutput(outputRes);
    }
    removeOutput(id) {
        return this.edgeClient.deleteOutput(id);
    }
    removeOutputs(ids) {
        return this.edgeClient.deleteOutputs({
            ids
        });
    }
    getOutputHealth(id) {
        return this.edgeClient.getOutputHealth(id);
    }
    getBareOutputs(filter, limit) {
        return this.edgeClient.listOutputs({
            filter,
            limit
        });
    }
    /**
   * Returns ListResult of outputs populating them with input and group objects
   * @param hasInput - to show only those which are streaming any input
   * @param applianceId - to show only those which ports belong to this appliance
   * @param input - to show only those which are streaming this input
   * @param notInput - to show only those which are not streaming this input
   * @param inputTr101290Window - Desired input tr101290 metrics window size
   * @param searchName - Term to search for
   * @param params - pagination parameters
   */ async getOutputs({ hasInput, applianceId, appliances, regions, input, inputName, group, notInput, inputTr101290Window, filter: searchName, adminStatus, health, tags, ...params }) {
        const filter = {
            notBelongingToInputIds: notInput ? [
                notInput
            ] : undefined,
            belongingToInputIds: input ? [
                input
            ] : undefined,
            hasInput: hasInput,
            appliance: applianceId,
            applianceNames: appliances?.split(','),
            inputName,
            groupName: group,
            regionNames: regions?.split(','),
            inputTr101290Window,
            searchName,
            adminStatus: adminStatus && [
                (0, _types.OutputAdminStatus).on.toString(),
                (0, _types.OutputAdminStatus).off.toString()
            ].includes(adminStatus) ? Number(adminStatus) : undefined,
            healthStatuses: health === (0, _nmTypes.OutputFilterHealthStatus).healthy ? [
                (0, _types.OutputOperStatus).allOk
            ] : health === (0, _nmTypes.OutputFilterHealthStatus).unhealthy ? Object.values((0, _types.OutputOperStatus)).filter((s)=>s !== (0, _types.OutputOperStatus).allOk) : undefined,
            tags: tags?.split(',')
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        const { total, items } = await this.edgeClient.listOutputs(query);
        const inputIds = Array.from(new Set(items.filter((output)=>output.input).map((output)=>output.input)));
        const inputs = inputIds.length > 0 ? (await this.edgeClient.listInputs({
            filter: {
                ids: inputIds
            }
        })).items : [];
        const groupIds = Array.from(new Set(items.filter((output)=>output.group).map((output)=>output.group)));
        const groups = groupIds.length > 0 ? (await this.edgeClient.listGroups({
            filter: {
                ids: groupIds
            }
        })).items : [];
        return {
            items: items.map((output)=>{
                let _input, _group;
                if (output.input) _input = inputs.find(({ id })=>id === output.input);
                if (output.group) _group = groups.find(({ id })=>id === output.group);
                return {
                    ...output,
                    _input,
                    _group
                };
            }),
            total
        };
    }
    /**
   * Returns output populating it with input object if present and its ports with physical port and appliance
   * @param outputId
   * @param filter
   */ async getOutput(outputId, filter) {
        const output = await this.edgeClient.getOutput(outputId, {
            filter
        });
        const input = output.input ? await this.edgeClient.getInput(output.input) : undefined;
        // TODO: Future improvement: Reduce number of network requests by listPorts({ filter: ids })
        const ports = await Promise.all(output.ports.map((port)=>this.edgeClient.listPorts({
                filter: {
                    id: port.physicalPort
                }
            })));
        const applianceIds = Array.from(new Set([
            ...(input?.appliances || []).map((a)=>a.id),
            ...output.appliances.map((a)=>a.id),
            ...ports.map(({ items })=>items[0]?.appliance?.id)
        ].filter((id)=>!!id)));
        const appliances = (await this.edgeClient.listAppliances({
            filter: {
                ids: applianceIds
            }
        })).items;
        const inputAppliances = appliances.filter((a)=>!!input?.appliances?.find((ia)=>ia.id === a.id));
        const inputApplianceOwnerIds = inputAppliances.map((0, _utils.getApplianceOwnerId));
        const outputAppliances = appliances.filter((a)=>output.appliances.find((oa)=>oa.id === a.id));
        const outputApplianceOwnerIds = outputAppliances.map((0, _utils.getApplianceOwnerId));
        const groupIds = Array.from(new Set([
            output.group,
            ...outputApplianceOwnerIds,
            input?.owner,
            ...inputApplianceOwnerIds
        ].filter((o)=>!!o)));
        const groups = (await this.edgeClient.listGroups({
            filter: {
                ids: groupIds
            }
        })).items;
        const enrichedOutputWithPorts = {
            ...output,
            _group: groups.find((g)=>g.id === output.group),
            _input: input && {
                ...input,
                _owner: groups.find((g)=>g.id === input.owner)
            },
            ports: output.ports.map((p, ind)=>{
                const port = ports[ind].items[0];
                const _appliance = appliances.find(({ id })=>id === port?.appliance.id);
                return {
                    ...p,
                    _port: {
                        ...port,
                        _appliance: _appliance
                    }
                };
            })
        };
        return enrichedOutputWithPorts;
    }
    /**
   * Returns ListResult of mix of outputLists and outputs populated with input and group object
   * @param notInput
   * @param searchName - term to search for
   * @param params
   */ async getOutputsWithLists({ notInput, filter: searchName, ...params }) {
        const filter = {
            notBelongingToInputIds: notInput ? [
                notInput
            ] : undefined,
            searchName
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        const { items, total } = await this.edgeClient.listOutputAndRecipientLists(query);
        const { inputIds, groupIds } = items.reduce((acc, item)=>{
            if ((0, _utils.isOutput)(item)) {
                if (item.input) acc.inputIds.push(item.input);
            }
            if (item.group) acc.groupIds.push(item.group);
            return acc;
        }, {
            inputIds: [],
            groupIds: []
        });
        const inputs = (await this.edgeClient.listInputs({
            filter: {
                ids: Array.from(new Set(inputIds))
            }
        })).items;
        const groups = (await this.edgeClient.listGroups({
            filter: {
                ids: Array.from(new Set(groupIds))
            }
        })).items;
        return {
            items: items.map((item)=>{
                if ((0, _utils.isOutput)(item)) {
                    let _input, _group;
                    if (item.input) _input = inputs.find(({ id })=>id === item.input);
                    if (item.group) _group = groups.find(({ id })=>id === item.group);
                    return {
                        ...item,
                        _input,
                        _group
                    };
                } else {
                    if (item.group) return {
                        ...item,
                        _group: groups.find(({ id })=>id === item.group)
                    };
                }
                return item;
            }),
            total
        };
    }
    /**
   * Returns number of outputs
   */ async getTotalOutputCount() {
        return (await this.edgeClient.listOutputs({
            skip: 0,
            limit: 1
        })).total;
    }
    enableOutputs(ids) {
        return this.edgeClient.setOutputAdminStatuses(ids.map((id)=>({
                id,
                adminStatus: (0, _types.OutputAdminStatus).on
            })));
    }
    disableOutputs(ids) {
        return this.edgeClient.setOutputAdminStatuses(ids.map((id)=>({
                id,
                adminStatus: (0, _types.OutputAdminStatus).off
            })));
    }
    /**
   * Set input for an output populating response with input and group objects if present
   * @param outputId - output id
   * @param inputId - input id
   */ async setInputOfOutput(outputId, inputId) {
        const output = await this.edgeClient.setOutputInput(outputId, {
            input: inputId || null
        });
        return this.getEnrichedOutput(output);
    }
    async getEnrichedOutput(output) {
        const enrichedOutput = {
            ...output
        };
        if (output.input !== undefined) {
            const input = await this.edgeClient.getInput(output.input);
            enrichedOutput._input = input;
        }
        if (output.group !== '') {
            const group = await this.edgeClient.getGroup(output.group);
            enrichedOutput._group = group;
        }
        return enrichedOutput;
    }
}

},{"common/api/v1/types":"3qemx","../../utils":"342UB","../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1LNAe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserApi", ()=>UserApi);
var _fetch = require("../../utils/fetch");
var _applicationException = require("../ApplicationException");
var _nmTypes = require("../nm-types");
var _helpers = require("common/api/v1/helpers");
class UserApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async loginUser(username, password, otp) {
        const res = await (0, _fetch.fetch)('/api/login/', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username,
                password,
                otp
            })
        });
        if (res.status === 200) {
            const result = res.body;
            const userGroup = await this.edgeClient.getGroup(result.user.group);
            return {
                ...result.user,
                _group: (0, _helpers.omit)(userGroup, 'applianceSecret')
            };
        }
        throw new (0, _applicationException.ApplicationException)({
            fatal: true,
            errorCode: 'authentication_fail',
            details: 'Failed to login',
            text: 'Failed to login',
            origin: res
        });
    }
    async logoutUser() {
        const { success } = await this.edgeClient.logout();
        return success;
    }
    async impersonateUser(userId) {
        const { user } = await this.edgeClient.impersonate(userId);
        const settings = await this.getUserSettings(userId);
        const userGroup = await this.edgeClient.getGroup(user.group);
        return {
            ...user,
            _group: (0, _helpers.omit)(userGroup, 'applianceSecret'),
            settings
        };
    }
    async stopImpersonation() {
        const { user } = await this.edgeClient.unimpersonate();
        const settings = await this.getUserSettings(user.id);
        const userGroup = await this.edgeClient.getGroup(user.group);
        return {
            ...user,
            _group: (0, _helpers.omit)(userGroup, 'applianceSecret'),
            settings
        };
    }
    createUser(user) {
        return this.edgeClient.createUser(user);
    }
    removeUser(userID) {
        return this.edgeClient.deleteUser(userID);
    }
    updateUser(user) {
        return this.edgeClient.updateUser(user.id, user);
    }
    getLoginMethods() {
        return this.edgeClient.listLoginMethods();
    }
    getSsoMetadataDataSaml(url) {
        return this.edgeClient.getSsoMetadataSaml({
            url: url
        });
    }
    getSsoMetadataDataOidc(url) {
        return this.edgeClient.getSsoMetadataOidc({
            url: url
        });
    }
    /**
   * Returns user with group object populated
   * @param userId
   */ async getUser(userId) {
        const user = await this.edgeClient.getUser(userId);
        return {
            ...user,
            _group: await this.edgeClient.getGroup(user.group)
        };
    }
    getUserSettings(userId) {
        return this.edgeClient.getUserSettings(userId);
    }
    setUserSettings(userId, settings) {
        return this.edgeClient.setUserSettings(userId, settings);
    }
    /**
   * Returns ListResult of users with group object populated
   * @param userId
   */ async getUsers({ owner, filter: searchName, ...params }) {
        const filter = {
            group: owner,
            searchName
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        const { items: users, total } = await this.edgeClient.listUsers(query);
        const groupIds = users.map((user)=>user.group);
        const groups = (await this.edgeClient.listGroups({
            filter: {
                ids: Array.from(new Set(groupIds))
            }
        })).items;
        return {
            items: users.map((user)=>({
                    ...user,
                    _group: groups.find(({ id })=>id === user.group)
                })),
            total
        };
    }
    async getCurrentEnrichedUser() {
        const currentUser = await this.edgeClient.getCurrentUser();
        const group = await this.edgeClient.getGroup(currentUser.group);
        const settings = await this.getUserSettings(currentUser.id);
        return {
            ...currentUser,
            _group: group,
            settings
        };
    }
    async configureTOTP() {
        return this.edgeClient.totpCurrentUsers();
    }
    async verifyTOTP(token) {
        await this.edgeClient.setCurrentUserTotpVerify({
            token
        });
    }
    async deleteTOTP() {
        await this.edgeClient.deleteCurrentUserTotps();
    }
}

},{"../../utils/fetch":"bwcMB","../ApplicationException":"5oMBs","../nm-types":"bcYl5","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bwcMB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetch", ()=>fetch);
var _serialization = require("common/serialization");
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _applicationException = require("../api/ApplicationException");
var _localstorage = require("../localstorage");
const fetch = async (...args)=>{
    const response = await window.fetch(...args);
    const contentType = response.headers.get('content-type');
    const body = contentType?.includes('application/json') ? (0, _serialization.tryConvertDates)(await response.json()) : await response.text();
    if (!response.ok) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        if (response.status === 401 && !(0, _storeDefault.default).getState().userReducer.changingUser) {
            (0, _localstorage.clearState)();
            document.cookie = 'edgetoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
            if (// Response from login request
            response.url !== '/api/login/' && // Already logged out
            window.location.hash !== '#/') window.location.assign('/');
        }
        const defaultTitle = `Unexpected status code: ${response.status}`;
        throw new (0, _applicationException.ApplicationException)({
            fatal: response.status !== 409,
            errorCode: `${response.status}`,
            text: body?.title || defaultTitle,
            details: body?.detail || body?.title || response.statusText,
            origin: ''
        });
    }
    return {
        status: response.status,
        headers: Object.fromEntries(response.headers.entries()),
        body
    };
};

},{"common/serialization":"j24dT","../store":"5LXiG","../api/ApplicationException":"5oMBs","../localstorage":"7NDOS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fv1YY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceApi", ()=>ServiceApi);
var _nmTypes = require("../nm-types");
class ServiceApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    updateService(service) {
        return this.edgeClient.updateService(service.id, service);
    }
    /**
   * Returns service
   * @param serviceId
   */ async getService(serviceId) {
        return this.edgeClient.getService(serviceId);
    }
    async getServices({ filter: searchName, includeHidden, ...params }) {
        const filter = {
            searchName,
            includeHidden
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        const { items, total } = await this.edgeClient.listServices(query);
        return {
            items,
            total
        };
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kMHoT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppliancesApi", ()=>AppliancesApi);
var _utils = require("../../utils");
var _nmTypes = require("../nm-types");
class AppliancesApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    listAppliancePcaps(id) {
        return this.edgeClient.listAppliancePcaps(id);
    }
    listApplianceNdiSources(id) {
        return this.edgeClient.listApplianceNdiSources(id);
    }
    recreateTunnels(id) {
        return this.edgeClient.recreateApplianceTunnels(id);
    }
    deletePcap(applianceId, pcapId) {
        return this.edgeClient.deleteAppliancePcap(applianceId, pcapId);
    }
    removeAppliance(id) {
        return this.edgeClient.deleteAppliance(id);
    }
    updateAppliance(id, values) {
        return this.edgeClient.updateAppliance(id, values);
    }
    /**
   * Getting appliance populating it with full owner object and physical ports' owners as well
   * @param id - appliance Id
   */ async getAppliance(id) {
        const appliance = await this.edgeClient.getAppliance(id);
        const applianceOwnerId = (0, _utils.getApplianceOwnerId)(appliance);
        const groupIds = Array.from(new Set([
            applianceOwnerId,
            ...appliance.physicalPorts.map((p)=>p.owner)
        ]));
        const groups = (await this.edgeClient.listGroups({
            filter: {
                ids: groupIds
            }
        })).items;
        const enrichedAppliance = {
            ...appliance,
            owner: groups.find(({ id })=>id === applianceOwnerId),
            _physicalPorts: appliance.physicalPorts.map((port)=>({
                    ...port,
                    _owner: groups.find(({ id })=>id === port.owner)
                }))
        };
        return enrichedAppliance;
    }
    /**
   * Getting ListResult of appliances populating each item with owner group object
   * @param requestParams
   */ async getAppliances(requestParams) {
        const applianceList = await this.getBareAppliances(requestParams);
        if (applianceList.items.length === 0) return {
            ...applianceList,
            items: []
        };
        const groupIds = applianceList.items.reduce((acc, a)=>{
            const id = typeof a.owner === 'string' ? a.owner : a.owner.id;
            if (acc.includes(id)) return acc;
            return acc.concat(id);
        }, []);
        const groups = (await this.edgeClient.listGroups({
            filter: {
                ids: groupIds
            }
        })).items;
        const groupsMap = groups.reduce((acc, item)=>({
                ...acc,
                [item.id]: item
            }), {});
        return {
            ...applianceList,
            items: applianceList.items.map((a)=>({
                    ...a,
                    _owner: groupsMap[typeof a.owner === 'string' ? a.owner : a.owner.id]
                }))
        };
    }
    getBareAppliances({ owner: groupId, groupName, filter: searchName, types, regions, tags, ...params }) {
        const filter = {
            group: groupId,
            groupName,
            searchName,
            regionNames: regions?.split(','),
            types: types?.split(','),
            tags: tags?.split(',')
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.listAppliances(query);
    }
    listAppliances(query) {
        return this.edgeClient.listAppliances(query);
    }
    listRegisteredApplianceTypes() {
        return this.edgeClient.listApplianceRegisteredTypes();
    }
    /**
   * Returns appliances with coordination to show on map
   * @param searchName - term to search for
   * @param paginatedRequestParams
   */ getGeoAppliances({ filter: searchName, ...paginatedRequestParams }) {
        const filter = {
            searchName
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams
        });
        return this.edgeClient.listGeoAppliances(query);
    }
    /**
   * Command to restart appliance
   * @param id
   */ restart(id) {
        return this.edgeClient.restartAppliance(id, {
            timeoutMs: 180000
        });
    }
    /**
   * Command to upgrade image for appliance
   * @param id
   */ upgradeImage(id, imageVersion) {
        return this.edgeClient.upgradeImageAppliance(id, {
            imageVersion
        });
    }
    /**
   * Returns appliance configuration for super user
   * @param id
   */ getConfig(id) {
        return this.edgeClient.getApplianceConfig(id, '');
    }
    listApplianceInputs(id, params) {
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter: undefined,
            paginatedRequestParams: params
        });
        return this.edgeClient.listApplianceInputs(id, query);
    }
    listApplianceOutputs(id, params) {
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter: undefined,
            paginatedRequestParams: params
        });
        return this.edgeClient.listApplianceOutputs(id, query);
    }
    async listAppliancePhysicalPorts(id) {
        const { appliance, physicalPorts } = await this.edgeClient.getAppliancePorts(id);
        return physicalPorts.map((p)=>({
                ...p,
                appliance
            }));
    }
    clearCachedApplianceConfig(id) {
        return this.edgeClient.clearApplianceConfig(id);
    }
    listApplianceCommands(id) {
        return this.edgeClient.listApplianceCommands(id);
    }
}

},{"../../utils":"342UB","../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ftAJR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortsApi", ()=>PortsApi);
var _utils = require("../../utils");
var _nmTypes = require("../nm-types");
var _array = require("../../utils/array");
class PortsApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async updatePort(id, sharedPorts) {
        return await this.edgeClient.setAppliancePorts(id, sharedPorts);
    }
    /**
   * Returns interface with populated appliance and owner
   * @param portId
   */ async getPort(portId) {
        const port = await this.edgeClient.getPort(portId);
        const barePortAppliance = await this.edgeClient.getAppliance(port.appliance.id);
        const groupIds = [
            port.owner,
            barePortAppliance.owner
        ].filter((id)=>!!id);
        const groups = (await this.edgeClient.listGroups({
            filter: {
                ids: groupIds
            }
        })).items;
        const portOwner = groups.find((group)=>group.id == port.owner);
        const portApplianceOwner = groups.find((group)=>group.id == barePortAppliance.owner);
        const enrichedPortAppliance = {
            ...barePortAppliance,
            _owner: portApplianceOwner
        };
        return {
            ...port,
            _owner: portOwner,
            _appliance: enrichedPortAppliance
        };
    }
    /**
   * Returns ListResult of interfaces with appliance, owner, inputs and output using it populated
   */ async getPorts(params) {
        const ports = await this.getBarePorts(params);
        const { applianceIds, groupIds } = ports.items.reduce((acc, port)=>{
            acc.groupIds.add(port.owner);
            acc.applianceIds.add(port.appliance.id);
            return acc;
        }, {
            groupIds: new Set(),
            applianceIds: new Set()
        });
        const appliances = await fetchInBatches(applianceIds, (ids)=>this.edgeClient.listAppliances({
                filter: {
                    ids
                }
            }));
        const groupsToFetch = new Set([
            ...groupIds,
            ...appliances.map((a)=>(0, _utils.getApplianceOwnerId)(a)).filter((id)=>!!id)
        ]);
        const groups = await fetchInBatches(groupsToFetch, (ids)=>this.edgeClient.listGroups({
                filter: {
                    ids
                }
            }));
        return {
            ...ports,
            items: ports.items.map((port)=>{
                const portAppliance = appliances.find(({ id })=>id === port.appliance.id);
                const portApplianceOwner = groups.find((g)=>g.id == portAppliance?.owner);
                const enrichedAppliance = portAppliance && portApplianceOwner && {
                    ...portAppliance,
                    _owner: portApplianceOwner
                };
                const enrichedPort = {
                    ...port,
                    _appliance: enrichedAppliance,
                    _owner: groups.find(({ id })=>id === port.owner)
                };
                return enrichedPort;
            })
        };
    }
    /**
   * Returns ListResult of interfaces
   * @param owner - to show only those belonging to this group
   * @param portType - to show only those of this PortType
   * @param applianceType - to show only those of this ApplianceType
   * @param appliance - to show only those of this appliance
   * @param searchName - term to search for
   * @param params - pagination parameters
   */ getBarePorts({ owner, portType, applianceType, appliance, network, filter: searchName, ...params }) {
        const filter = {
            owner,
            appliance,
            applianceType,
            portType,
            searchName,
            network
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.listPorts(query);
    }
    listPorts(query) {
        return this.edgeClient.listPorts(query);
    }
    allocateCoreVideoAppliance(params, options) {
        return this.edgeClient.createApplianceAllocation(params, options);
    }
}
// Batch requests to prevent error '414 Request-URI Too Large'.
// e.g. ~188 ids seems to be the highest possible value when listing inputs
async function fetchInBatches(ids, fetchFn, maxBatchSize = 150) {
    const chunks = (0, _array.arrayToChunks)(Array.from(ids), maxBatchSize);
    const allItems = [];
    for (const ids of chunks){
        const listResult = await fetchFn(ids);
        allItems.push(...listResult.items);
    }
    return allItems;
}

},{"../../utils":"342UB","../nm-types":"bcYl5","../../utils/array":"E5h2D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"E5h2D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayToChunks", ()=>arrayToChunks);
function arrayToChunks(array, chunkSize) {
    const chunks = [];
    const numberOfChunks = Math.ceil(array.length / chunkSize);
    for(let i = 0; i < numberOfChunks; i++){
        const begin = i * chunkSize;
        const end = begin + chunkSize;
        const chunk = array.slice(begin, end);
        chunks.push(chunk);
    }
    return chunks;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1rDiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupsApi", ()=>GroupsApi);
var _nmTypes = require("../nm-types");
class GroupsApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    createGroup(group) {
        return this.edgeClient.createGroup(group);
    }
    updateGroup(id, group) {
        return this.edgeClient.updateGroup(id, group);
    }
    removeGroup(id) {
        return this.edgeClient.deleteGroup(id);
    }
    getGroup(groupId) {
        return this.edgeClient.getGroup(groupId);
    }
    /**
   * Returns ListResult of groups and groupLists mixed
   * @param inputNotShared - to show those which are not yet have access to this input
   * @param userGroup - we don't want to share input to the user's group since it already has access obviously
   * @param searchName - term to search for
   * @param params - pagination params
   */ getGroupsWithLists({ inputNotShared, userGroup, filter: searchName, ...params }) {
        const filter = {
            withoutAccessToAnyInputs: inputNotShared ? [
                inputNotShared
            ] : undefined,
            excludeIds: userGroup ? [
                userGroup
            ] : undefined,
            searchName
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listGroupAndRecipientLists(query);
    }
    /**
   * Returns groups without any data population
   * @param inputNotShared - to show those which are not yet have access to this input
   * @param inputShared - to show those which are already have access to this input
   * @param userGroup - if we want to exclude user's group from response
   * @param searchName - term to search for
   * @param params - pagination params
   */ async getPureGroups({ inputNotShared, inputShared, userGroup, filter: searchName, ...params }) {
        const filter = {
            withAccessToAnyInputs: inputShared ? [
                inputShared
            ] : undefined,
            withoutAccessToAnyInputs: inputNotShared ? [
                inputNotShared
            ] : undefined,
            excludeIds: userGroup ? [
                userGroup
            ] : undefined,
            searchName
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listGroups(query);
    }
    /**
   * Returns groups with their access to the input set with params.inputShared
   * @param params - pagination params with inputShared required
   */ async getGroupPermissions(params) {
        const { items, total } = await this.getPureGroups(params);
        let list;
        if (params.inputShared) {
            const distribution = await this.edgeClient.listInputDistributions(params.inputShared);
            list = items.reduce((acc, group)=>{
                const permission = distribution.find(({ groupId })=>groupId === group.id);
                return [
                    ...acc,
                    {
                        ...group,
                        _permission: permission
                    }
                ];
            }, []);
        } else list = items;
        return {
            items: list,
            total
        };
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFZEf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlarmsApi", ()=>AlarmsApi);
var _nmTypes = require("../nm-types");
class AlarmsApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    /**
   * Gets alarms and populates each with affected entities
   */ readAlarmsInBackground() {
        return this.edgeClient.listAlarms();
    }
    async getAlarms({ filter: searchName, applianceId, ...params }) {
        const filter = {
            searchName,
            applianceId
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        const { items: alarms, total } = await this.edgeClient.listAlarms(query);
        const { affectedInputs, affectedOutputs } = alarms.reduce((acc, alarm)=>{
            if (alarm.affectedInput) acc.affectedInputs.add(alarm.affectedInput);
            if (alarm.affectedOutput) acc.affectedOutputs.add(alarm.affectedOutput);
            return acc;
        }, {
            affectedInputs: new Set(),
            affectedOutputs: new Set()
        });
        const inputs = affectedInputs.size > 0 ? (await this.edgeClient.listInputs({
            filter: {
                ids: [
                    ...affectedInputs
                ]
            }
        })).items : [];
        const outputs = affectedOutputs.size > 0 ? (await this.edgeClient.listOutputs({
            filter: {
                ids: [
                    ...affectedOutputs
                ]
            }
        })).items : [];
        return {
            total,
            items: alarms.map((alarm)=>{
                return {
                    ...alarm,
                    _input: alarm.affectedInput ? inputs.find(({ id })=>id === alarm.affectedInput) : undefined,
                    _output: alarm.affectedOutput ? outputs.find(({ id })=>id === alarm.affectedOutput) : undefined
                };
            })
        };
    }
    async updateAlarm(alarmId, params) {
        const encodedAlarmId = encodeURIComponent(alarmId);
        return this.edgeClient.setAlarm(encodedAlarmId, params);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"66OTB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlarmLogsApi", ()=>AlarmLogsApi);
var _nmTypes = require("../nm-types");
class AlarmLogsApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    getAlarmLogs({ fromDate, toDate, severity, searchName, ...params }) {
        const filter = {
            fromDate: fromDate,
            toDate: toDate,
            severity,
            searchName
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listAlarmLogs(query);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4swtU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BitratesApi", ()=>BitratesApi);
class BitratesApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    readBitrates() {
        return this.edgeClient.getDashboardBitrates();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gYpft":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BillingApi", ()=>BillingApi);
class BillingApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    readBilling(params) {
        return this.edgeClient.getBillingReport({
            startDate: params.startDate.toISOString(),
            endDate: params.endDate.toISOString()
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ctkth":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UsageApi", ()=>UsageApi);
var _nmTypes = require("../nm-types");
class UsageApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    readUsage({ startDate, endDate, type, format, ...params }) {
        const filter = {
            startDate,
            endDate,
            type,
            format
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.getUsageReport(query);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQ63R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphApi", ()=>GraphApi);
class GraphApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    readGraph() {
        return this.edgeClient.getServiceGraphConfig();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"89tYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationApi", ()=>LocationApi);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _fetch = require("../../utils/fetch");
const getOSMProp = (region, propName)=>(0, _getDefault.default)(region, `properties.${propName}`);
class LocationApi {
    /**
   * Using free API https://photon.komoot.io to get geoLocation for substring of place name
   * @param filter
   */ async searchLocation({ filter = '' }) {
        if (!filter) return {
            items: [],
            total: 0
        };
        const url = `https://photon.komoot.io/api/?q=${filter}&osm_tag=place:city&osm_tag=place:town&osm_tag=place:municipality&osm_tag=place:province`;
        const body = await (0, _fetch.fetch)(url).then((res)=>res.body);
        const list = body.features.reduce((acc, item)=>[
                ...acc,
                {
                    id: String(getOSMProp(item, 'osm_id')),
                    location: [
                        getOSMProp(item, 'name'),
                        getOSMProp(item, 'state'),
                        getOSMProp(item, 'country')
                    ].filter(Boolean).join(', '),
                    coordinates: [
                        item.geometry.coordinates[1],
                        item.geometry.coordinates[0]
                    ]
                }
            ], []);
        return {
            items: list,
            total: list.length
        };
    }
}

},{"lodash/get":"dBTJh","../../utils/fetch":"bwcMB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7dQe4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RegionApi", ()=>RegionApi);
var _types = require("common/api/v1/types");
var _nmTypes = require("../nm-types");
class RegionApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    #externalToText(external) {
        switch(external){
            case (0, _types.ExternalRegionMode).core:
                return 'core';
            case (0, _types.ExternalRegionMode).externalK8s:
                return 'external (kubernetes)';
            case (0, _types.ExternalRegionMode).external:
                return 'external';
            default:
                return 'N/A';
        }
    }
    async getRegions({ filter: searchName, ...params }, onlyVideoRegions = false) {
        const filter = {
            searchName,
            onlyVideoRegions
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        const res = await this.edgeClient.listRegions(query);
        return {
            ...res,
            items: res.items.map((r)=>({
                    ...r,
                    _externalText: this.#externalToText(r.external)
                }))
        };
    }
    async getRegion(id) {
        const region = await this.edgeClient.getRegion(id);
        const appliancesTotal = await this.edgeClient.listAppliances({
            filter: {
                regionNames: [
                    region.name
                ]
            }
        }).then((res)=>res.total);
        return {
            ...region,
            _externalText: this.#externalToText(region.external),
            appliancesTotal
        };
    }
    async getRegionDetails(id, external) {
        const [videoScale, thumbScale] = external !== (0, _types.ExternalRegionMode).external ? await Promise.all([
            this.edgeClient.getRegionVideoScale(id).then((res)=>({
                    replicas: res.replicas ?? res.currentReplicas,
                    currentReplicas: res.currentReplicas
                })),
            this.edgeClient.getRegionThumbScale(id).then((res)=>({
                    replicas: res.replicas ?? res.currentReplicas,
                    currentReplicas: res.currentReplicas
                }))
        ]) : await Promise.all([
            this.edgeClient.listAppliances({
                filter: {
                    region: id,
                    type: (0, _types.ApplianceType).core
                }
            }).then((res)=>({
                    currentReplicas: res.total
                })),
            this.edgeClient.listAppliances({
                filter: {
                    region: id,
                    type: (0, _types.ApplianceType).thumb
                }
            }).then((res)=>({
                    currentReplicas: res.total
                }))
        ]);
        return {
            videoScale,
            thumbScale
        };
    }
    setVideoScale(regionId, count) {
        return this.edgeClient.setRegionVideoScale(regionId, {
            count,
            waitSeconds: 1
        });
    }
    setThumbScale(regionId, count) {
        return this.edgeClient.setRegionThumbScale(regionId, {
            count,
            waitSeconds: 1
        });
    }
    async setDefaultRegion(regionId) {
        return this.edgeClient.setRegionDefaultRegion({
            id: regionId
        });
    }
    async deleteRegion(regionId) {
        await this.edgeClient.deleteRegion(regionId);
    }
}

},{"common/api/v1/types":"3qemx","../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Bis9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OutputListApi", ()=>OutputListApi);
var _nmTypes = require("../nm-types");
class OutputListApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    createOutputList(outputList) {
        return this.edgeClient.createOutputRecipientList(outputList);
    }
    updateOutputList(id, update) {
        return this.edgeClient.updateOutputRecipientList(id, update);
    }
    removeOutputList(id) {
        return this.edgeClient.deleteOutputRecipientList(id);
    }
    async getOutputList(id) {
        const outputList = await this.edgeClient.getOutputRecipientList(id);
        const group = await this.edgeClient.getGroup(outputList.group);
        return {
            ...outputList,
            _group: group
        };
    }
    async getOutputLists(params) {
        const filter = {
            searchName: params.filter,
            group: params.group
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        const { total, items } = await this.edgeClient.listOutputRecipientLists(query);
        const groupIds = Array.from(new Set(items.filter((outputList)=>outputList.group).map((output)=>output.group)));
        const groups = groupIds.length > 0 ? (await this.edgeClient.listGroups({
            filter: {
                ids: groupIds
            }
        })).items : [];
        return {
            items: items.map((output)=>({
                    ...output,
                    _group: output.group ? groups.find(({ id })=>id === output.group) : undefined
                })),
            total
        };
    }
    /**
   * Returns outputs for this outputList
   * @param listId - groupList id
   * @param inList - true to show those outputs that are already in list, false - for others
   * @param params - pagination parameters
   * @param group - we can only add own group's outputs to output lists
   * @param searchName - term to search for
   */ getOutputs(listId, inList, { group, filter: searchName, ...params }) {
        const filter = {
            group,
            searchName
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return inList ? this.edgeClient.listOutputRecipientListOutputs(listId, query) : this.edgeClient.listOutputRecipientListOutputsNotInLists(listId, query);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hG5Rc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupListApi", ()=>GroupListApi);
var _nmTypes = require("../nm-types");
class GroupListApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    createGroupList(outputList) {
        return this.edgeClient.createGroupRecipientList(outputList);
    }
    updateGroupList(id, update) {
        return this.edgeClient.updateGroupRecipientList(id, update);
    }
    removeGroupList(id) {
        return this.edgeClient.deleteGroupRecipientList(id);
    }
    getGroupList(id) {
        return this.edgeClient.getGroupRecipientList(id);
    }
    getGroupLists(params) {
        const filter = {
            searchName: params.filter
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listGroupRecipientLists(query);
    }
    /**
   * Getting groups to select for the group list
   * @param listId - groupList id
   * @param inList - true to show those in list already, false - those that available to add to the list
   * @param userGroup - we have to exclude user's group from the response, it makes no sense to have your own group in any groupList
   * @param searchName - term to search form
   * @param params - pagination parameters
   */ getGroups(listId, inList, { userGroup, filter: searchName, ...params }) {
        const filter = {
            searchName,
            excludeIds: userGroup ? [
                userGroup
            ] : undefined
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return inList ? this.edgeClient.listGroupRecipientListGroups(listId, query) : this.edgeClient.listGroupRecipientListGroupsNotInLists(listId, query);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6b3Zb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdAuditApi", ()=>AdAuditApi);
var _nmTypes = require("../nm-types");
class AdAuditApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    getAdAudit(params) {
        const filter = {
            filter: params.filter,
            fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
            toDate: params.toDate ? new Date(params.toDate) : undefined,
            entityType: params.entityType,
            method: params.method,
            result: params.result,
            message: params.message,
            status: params.status,
            eventId: params.eventId ? Number(params.eventId) : undefined,
            outputId: params.outputId,
            streamId: params.streamId ? Number(params.streamId) : undefined,
            channelId: params.channelId ? Number(params.channelId) : undefined,
            component: params.component,
            pod: params.pod,
            entity: params.entity,
            entityId: params.entityId,
            entityName: params.entityName,
            source: params.source,
            target: params.target,
            traceId: params.traceId,
            adBreakId: params.adBreakId
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listAdAuditLogs(query);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ieXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SettingsApi", ()=>SettingsApi);
class SettingsApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    getSettings() {
        return this.edgeClient.getGlobalsettings();
    }
    saveSettings(params) {
        return this.edgeClient.setGlobalsettings(params);
    }
    async createBackupAsync(params) {
        await this.edgeClient.createBackup(params);
    }
    async testS3Write(params) {
        await this.edgeClient.testBackupExternalS3s(params);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewLUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusApi", ()=>StatusApi);
class StatusApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async listStatus() {
        return this.edgeClient.listStatuses();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1CcpL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageApi", ()=>ImageApi);
class ImageApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    getImageDetails(name) {
        return this.edgeClient.getImage(name);
    }
    setImage(data) {
        return this.edgeClient.createImage(data);
    }
    deleteImage(name) {
        return this.edgeClient.deleteImage(name);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"28Obc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TlsApi", ()=>TlsApi);
class TlsApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    getTls() {
        return this.edgeClient.getTls();
    }
    saveTls(params) {
        return this.edgeClient.setTls(params);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hMHEl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuildInfoApi", ()=>BuildInfoApi);
class BuildInfoApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    readBuildInfo() {
        return this.edgeClient.getBuildInfo();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ci3g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressMappingApi", ()=>AddressMappingApi);
var _nmTypes = require("../nm-types");
class AddressMappingApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async getIpMapping({ privateIp, region }) {
        return this.edgeClient.getIpMapping(region, privateIp);
    }
    setIpMapping(ipMapping) {
        return this.edgeClient.createIpMapping(ipMapping);
    }
    updateIpMapping(ipMapping) {
        const { region, privateIp } = ipMapping;
        return this.edgeClient.updateIpMapping(region, privateIp, ipMapping);
    }
    getIpMappings({ filter, ...params }) {
        const searchFilter = {};
        if (filter) searchFilter.searchName = filter;
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter: searchFilter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listIpMappings(query);
    }
    removeIpMapping({ region, privateIp }) {
        return this.edgeClient.deleteIpMapping(region, privateIp);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h5EIR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KubernetesApi", ()=>KubernetesApi);
var _nmTypes = require("../nm-types");
class KubernetesApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async getKubernetesNodes({ filter: searchName, name, ...params }) {
        const filter = {
            searchName,
            name
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listKubernetesNodes(query);
    }
    async getKubernetesNode(regionId, name) {
        return this.edgeClient.getKubernetesNode(regionId, name);
    }
    async updateKubernetesNode(regionId, name, update) {
        return this.edgeClient.updateKubernetesNode(regionId, name, update);
    }
    async getResourceUsage() {
        return this.edgeClient.listResourceUsages();
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"buscV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworksApi", ()=>NetworksApi);
var _nmTypes = require("../nm-types");
class NetworksApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    createNetwork(network) {
        return this.edgeClient.createNetwork(network);
    }
    getNetwork(id) {
        return this.edgeClient.getNetwork(id);
    }
    getNetworks({ filter, port, ids, ...params }) {
        const searchFilter = {};
        if (filter) searchFilter.searchName = filter;
        if (port) searchFilter.port = port;
        if (ids) searchFilter.ids = ids;
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter: searchFilter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listNetworks(query);
    }
    removeNetwork(id) {
        return this.edgeClient.deleteNetwork(id);
    }
    updateNetwork(id, network) {
        return this.edgeClient.updateNetwork(id, network);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"92yiB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApiTokenApi", ()=>ApiTokenApi);
class ApiTokenApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    /**
   * Creates and ensures a super user API token to be used by the Edge Operator. This needs to be done before installing the Operator in an existing cluster.
   */ ensureOperatorToken() {
        return this.edgeClient.setApiTokenEnsureOperatorToken();
    }
    createApiToken(apiToken) {
        return this.edgeClient.createApiToken(apiToken);
    }
    async removeApiToken(id) {
        await this.edgeClient.deleteApiToken(id);
    }
    getApiTokens() {
        return this.edgeClient.listApiTokens();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"10MoA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TunnelApi", ()=>TunnelApi);
var _nmTypes = require("../nm-types");
class TunnelApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    listTunnels(filter) {
        return this.edgeClient.listTunnels({
            filter
        });
    }
    listTunnelOutputs(id, paginatedRequestParams) {
        const filter = undefined;
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams
        });
        return this.edgeClient.listTunnelOutputs(id.toString(), query);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ikwub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverlaysApi", ()=>OverlaysApi);
var _nmTypes = require("../nm-types");
class OverlaysApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    listOverlays({ filter, ...params }) {
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter: filter ? {
                searchName: filter
            } : {},
            paginatedRequestParams: params
        });
        return this.edgeClient.listOverlays(query);
    }
    getOverlay(id) {
        return this.edgeClient.getOverlay(id);
    }
    updateOverlay(overlay) {
        return this.edgeClient.createOverlay(overlay);
    }
    deleteOverlay(id) {
        return this.edgeClient.deleteOverlay(id);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"91TDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagApi", ()=>TagApi);
var _nmTypes = require("../nm-types");
class TagApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    fetchTags({ filter: searchName, ...paginatedRequestParams }) {
        const filter = {
            searchName
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams
        });
        return this.listTags(query);
    }
    listTags(query) {
        return this.edgeClient.listTags(query);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bsq2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdServersApi", ()=>AdServersApi);
var _nmTypes = require("../nm-types");
class AdServersApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async listAdServers({ filter, ...params }) {
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter: filter ? {
                searchName: filter
            } : {},
            paginatedRequestParams: params
        });
        return this.edgeClient.listAdServers(query);
    }
    getAdServer(id) {
        return this.edgeClient.getAdServer(id);
    }
    createAdServer(adServer) {
        return this.edgeClient.createAdServer(adServer);
    }
    updateAdServer(id, adServer) {
        return this.edgeClient.updateAdServer(id, adServer);
    }
    deleteAdServer(id) {
        return this.edgeClient.deleteAdServer(id);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kTQ3B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuditApi", ()=>AuditApi);
var _nmTypes = require("../nm-types");
class AuditApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    getAudit({ entity, entityName, fromDate, operation, toDate, username, result, ...params }) {
        const filter = {
            entity,
            entityName,
            fromDate: fromDate,
            operation,
            result,
            toDate: toDate,
            username
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listAuditLogs(query);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNlcT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdInsertionDemoApi", ()=>AdInsertionDemoApi);
class AdInsertionDemoApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    triggerAdBreak(params) {
        return this.edgeClient.createScte104Injection(params);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dxRWQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdCreativesApi", ()=>AdCreativesApi);
var _nmTypes = require("../nm-types");
class AdCreativesApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async listAdCreatives(params) {
        const filter = {
            searchName: params.filter,
            fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
            toDate: params.toDate ? new Date(params.toDate) : undefined,
            status: params.status
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listAdCreatives(query);
    }
    getAdCreative(id) {
        return this.edgeClient.getAdCreative(id);
    }
    createAdCreative(adCreative) {
        return this.edgeClient.createAdCreative(adCreative);
    }
    updateAdCreative(id, adCreative) {
        return this.edgeClient.updateAdCreative(id, adCreative);
    }
    deleteAdCreative(id) {
        return this.edgeClient.deleteAdCreative(id);
    }
    createAdCreativeEvent(id, adCreativeEvent) {
        return this.edgeClient.setAdCreativeEvent(id, adCreativeEvent);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jS2ec":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdPodsApi", ()=>AdPodsApi);
var _nmTypes = require("../nm-types");
class AdPodsApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async listAdPods(params) {
        const filter = {
            searchName: params.filter,
            fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
            toDate: params.toDate ? new Date(params.toDate) : undefined,
            adCreativeId: params.adCreativeId,
            status: params.status
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listAdPods(query);
    }
    getAdPod(id) {
        return this.edgeClient.getAdPod(id);
    }
    createAdPod(adPod) {
        return this.edgeClient.createAdPod(adPod);
    }
    updateAdPod(id, adPod) {
        return this.edgeClient.updateAdPod(id, adPod);
    }
    deleteAdPod(id) {
        return this.edgeClient.deleteAdPod(id);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gzLmX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdBreaksApi", ()=>AdBreaksApi);
var _nmTypes = require("../nm-types");
class AdBreaksApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async listAdBreaks(params) {
        const filter = {
            searchName: params.filter,
            fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
            toDate: params.toDate ? new Date(params.toDate) : undefined,
            status: params.status,
            adId: params.adId
        };
        const query = (0, _nmTypes.singleSortQueryFromPaginatedRequestParams)({
            filter,
            paginatedRequestParams: params
        });
        return this.edgeClient.listAdBreaks(query);
    }
    getAdBreak(id) {
        return this.edgeClient.getAdBreak(id);
    }
    deleteAdBreak(id) {
        return this.edgeClient.deleteAdBreak(id);
    }
}

},{"../nm-types":"bcYl5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LYeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdStorageApi", ()=>AdStorageApi);
class AdStorageApi {
    constructor(edgeClient){
        this.edgeClient = edgeClient;
    }
    async getAdStorageStatus() {
        return this.edgeClient.getAdStorage();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aULa1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserEdgeClient", ()=>BrowserEdgeClient);
var _uuid = require("uuid");
var _fetch = require("../utils/fetch");
var _edgeClient = require("common/generated/edgeClient");
class BrowserEdgeClient extends (0, _edgeClient.EdgeClient) {
    constructor(params){
        super(params), this.isAborted = (e)=>{
            return e.name === 'AbortError';
        };
    }
    async _request({ method, url, body, optionsOverrides }) {
        try {
            const res = await request({
                method,
                url,
                body,
                json: true,
                requestId: _uuid.v4(),
                throwOnNon200: true,
                ...optionsOverrides
            });
            return res;
        } catch (e) {
            // eslint-disable-next-line no-console
            if (!this.isAborted(e)) console.error(`Error: performing '${method.toUpperCase()}' towards '${url}': `, e);
            throw e;
        }
    }
}
const request = async (options)=>{
    const { url, method, headers, body, json, requestId, signal } = options;
    const inferredHeaders = {};
    if (requestId) inferredHeaders['x-request-id'] = requestId;
    if (json) inferredHeaders['content-type'] = 'application/json';
    // The number of milliseconds before the request times out and is aborted
    const timeout = AbortSignal.timeout(options.timeoutMs ?? 20000);
    return (0, _fetch.fetch)(url, {
        method,
        headers: {
            ...inferredHeaders,
            ...headers
        },
        body: JSON.stringify(body),
        signal: anySignal(signal ? [
            signal,
            timeout
        ] : [
            timeout
        ])
    });
};
// TODO: Replace with AbortSignal.any()
// https://caniuse.com/mdn-api_abortsignal_any_static
// https://github.com/whatwg/fetch/issues/905
function anySignal(signals) {
    const controller = new AbortController();
    for (const signal of signals){
        if (signal.aborted) return signal;
        signal.addEventListener('abort', ()=>controller.abort(signal.reason), {
            signal: controller.signal
        });
    }
    return controller.signal;
}

},{"uuid":"dccyI","../utils/fetch":"bwcMB","common/generated/edgeClient":"cw0Az","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dccyI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":"MINPT","./v3.js":"l8r9S","./v4.js":"cC6Yd","./v5.js":"9dRKK","./nil.js":"EVaWu","./version.js":"dZEXW","./validate.js":"7jWwq","./stringify.js":"iykyo","./parse.js":"9cVnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"MINPT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js"); // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;
let _clockseq; // Previous uuid creation time
let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    let i = buf && offset || 0;
    const b = buf || new Array(16);
    options = options || {};
    let node = options.node || _nodeId;
    let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        const seedBytes = options.random || (options.rng || (0, _rngJsDefault.default))();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
    const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
     // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
     // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000; // `time_low`
    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff; // `time_mid`
    const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff; // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
    b[i++] = clockseq & 0xff; // `node`
    for(let n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf || (0, _stringifyJs.unsafeStringify)(b);
}
exports.default = v1;

},{"./rng.js":"cHxBo","./stringify.js":"iykyo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cHxBo":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iykyo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"7jWwq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7jWwq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"1ehxJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ehxJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l8r9S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
var _md5Js = require("./md5.js");
var _md5JsDefault = parcelHelpers.interopDefault(_md5Js);
const v3 = (0, _v35JsDefault.default)('v3', 0x30, (0, _md5JsDefault.default));
exports.default = v3;

},{"./v35.js":"1xNuQ","./md5.js":"ikyWi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1xNuQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DNS", ()=>DNS);
parcelHelpers.export(exports, "URL", ()=>URL);
parcelHelpers.export(exports, "default", ()=>v35);
var _stringifyJs = require("./stringify.js");
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
function stringToBytes(str) {
    str = unescape(encodeURIComponent(str)); // UTF8 escape
    const bytes = [];
    for(let i = 0; i < str.length; ++i)bytes.push(str.charCodeAt(i));
    return bytes;
}
const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(name, version, hashfunc) {
    function generateUUID(value, namespace, buf, offset) {
        var _namespace;
        if (typeof value === 'string') value = stringToBytes(value);
        if (typeof namespace === 'string') namespace = (0, _parseJsDefault.default)(namespace);
        if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
         // Compute hash of namespace and value, Per 4.3
        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
        // hashfunc([...namespace, ... value])`
        let bytes = new Uint8Array(16 + value.length);
        bytes.set(namespace);
        bytes.set(value, namespace.length);
        bytes = hashfunc(bytes);
        bytes[6] = bytes[6] & 0x0f | version;
        bytes[8] = bytes[8] & 0x3f | 0x80;
        if (buf) {
            offset = offset || 0;
            for(let i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
            return buf;
        }
        return (0, _stringifyJs.unsafeStringify)(bytes);
    } // Function#name is not settable on some platforms (#270)
    try {
        generateUUID.name = name; // eslint-disable-next-line no-empty
    } catch (err) {} // For CommonJS default export support
    generateUUID.DNS = DNS;
    generateUUID.URL = URL;
    return generateUUID;
}

},{"./stringify.js":"iykyo","./parse.js":"9cVnA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9cVnA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function parse(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    let v;
    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff; // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff; // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff; // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff; // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
exports.default = parse;

},{"./validate.js":"7jWwq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ikyWi":[function(require,module,exports,__globalThis) {
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function md5(bytes) {
    if (typeof bytes === 'string') {
        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = new Uint8Array(msg.length);
        for(let i = 0; i < msg.length; ++i)bytes[i] = msg.charCodeAt(i);
    }
    return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */ function md5ToHexEncodedArray(input) {
    const output = [];
    const length32 = input.length * 32;
    const hexTab = '0123456789abcdef';
    for(let i = 0; i < length32; i += 8){
        const x = input[i >> 5] >>> i % 32 & 0xff;
        const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
        output.push(hex);
    }
    return output;
}
/**
 * Calculate output length with padding and bit length
 */ function getOutputLength(inputLength8) {
    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */ function wordsToMd5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[getOutputLength(len) - 1] = len;
    let a = 1732584193;
    let b = -271733879;
    let c = -1732584194;
    let d = 271733878;
    for(let i = 0; i < x.length; i += 16){
        const olda = a;
        const oldb = b;
        const oldc = c;
        const oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */ function bytesToWords(input) {
    if (input.length === 0) return [];
    const length8 = input.length * 8;
    const output = new Uint32Array(getOutputLength(length8));
    for(let i = 0; i < length8; i += 8)output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
    return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function safeAdd(x, y) {
    const lsw = (x & 0xffff) + (y & 0xffff);
    const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
    return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
    return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
exports.default = md5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cC6Yd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"f6vss","./rng.js":"cHxBo","./stringify.js":"iykyo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f6vss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9dRKK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
var _sha1Js = require("./sha1.js");
var _sha1JsDefault = parcelHelpers.interopDefault(_sha1Js);
const v5 = (0, _v35JsDefault.default)('v5', 0x50, (0, _sha1JsDefault.default));
exports.default = v5;

},{"./v35.js":"1xNuQ","./sha1.js":"cJuJk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cJuJk":[function(require,module,exports,__globalThis) {
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function f(s, x, y, z) {
    switch(s){
        case 0:
            return x & y ^ ~x & z;
        case 1:
            return x ^ y ^ z;
        case 2:
            return x & y ^ x & z ^ y & z;
        case 3:
            return x ^ y ^ z;
    }
}
function ROTL(x, n) {
    return x << n | x >>> 32 - n;
}
function sha1(bytes) {
    const K = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ];
    const H = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    if (typeof bytes === 'string') {
        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = [];
        for(let i = 0; i < msg.length; ++i)bytes.push(msg.charCodeAt(i));
    } else if (!Array.isArray(bytes)) // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
    bytes.push(0x80);
    const l = bytes.length / 4 + 2;
    const N = Math.ceil(l / 16);
    const M = new Array(N);
    for(let i = 0; i < N; ++i){
        const arr = new Uint32Array(16);
        for(let j = 0; j < 16; ++j)arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
        M[i] = arr;
    }
    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
    M[N - 1][14] = Math.floor(M[N - 1][14]);
    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
    for(let i = 0; i < N; ++i){
        const W = new Uint32Array(80);
        for(let t = 0; t < 16; ++t)W[t] = M[i][t];
        for(let t = 16; t < 80; ++t)W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
        let a = H[0];
        let b = H[1];
        let c = H[2];
        let d = H[3];
        let e = H[4];
        for(let t = 0; t < 80; ++t){
            const s = Math.floor(t / 20);
            const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
            e = d;
            d = c;
            c = ROTL(b, 30) >>> 0;
            b = a;
            a = T;
        }
        H[0] = H[0] + a >>> 0;
        H[1] = H[1] + b >>> 0;
        H[2] = H[2] + c >>> 0;
        H[3] = H[3] + d >>> 0;
        H[4] = H[4] + e >>> 0;
    }
    return [
        H[0] >> 24 & 0xff,
        H[0] >> 16 & 0xff,
        H[0] >> 8 & 0xff,
        H[0] & 0xff,
        H[1] >> 24 & 0xff,
        H[1] >> 16 & 0xff,
        H[1] >> 8 & 0xff,
        H[1] & 0xff,
        H[2] >> 24 & 0xff,
        H[2] >> 16 & 0xff,
        H[2] >> 8 & 0xff,
        H[2] & 0xff,
        H[3] >> 24 & 0xff,
        H[3] >> 16 & 0xff,
        H[3] >> 8 & 0xff,
        H[3] & 0xff,
        H[4] >> 24 & 0xff,
        H[4] >> 16 & 0xff,
        H[4] >> 8 & 0xff,
        H[4] & 0xff
    ];
}
exports.default = sha1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"EVaWu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '00000000-0000-0000-0000-000000000000';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dZEXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function version(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    return parseInt(uuid.slice(14, 15), 16);
}
exports.default = version;

},{"./validate.js":"7jWwq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cw0Az":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EdgeClient = void 0;
const query_1 = require("563d7657061966f1");
class EdgeClient {
    constructor(params){
        this.cookieJar = {};
        this.apiKey = params.apiKey;
        const baseUrlList = [
            ...new Set([
                params.baseUrl,
                ...params.failbackUrls ?? []
            ])
        ];
        let currentUrl = 0;
        this.baseUrls = {
            get length () {
                return baseUrlList.length;
            },
            reset () {
                currentUrl = 0;
                return baseUrlList[currentUrl];
            },
            next: ()=>{
                currentUrl = (currentUrl + 1) % baseUrlList.length;
                return {
                    value: baseUrlList[currentUrl],
                    done: false
                };
            }
        };
        this._baseUrl = baseUrlList[0];
        this._baseUrlLastSet = Date.now();
    }
    async health(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health`,
            optionsOverrides
        });
        return result.body;
    }
    async listStatuses(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/status`,
            optionsOverrides
        });
        return result.body;
    }
    async createApiToken(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/api-token/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listApiTokens(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/api-token/`,
            optionsOverrides
        });
        return result.body;
    }
    async deleteApiToken(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/api-token/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async setApiTokenEnsureOperatorToken(optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/api-token/ensure-operator-token`,
            optionsOverrides
        });
        return result.body;
    }
    async getIpMapping(region, privateIp, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            optionsOverrides
        });
        return result.body;
    }
    async updateIpMapping(region, privateIp, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listIpMappings(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ip-mapping/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async createIpMapping(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ip-mapping/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteIpMapping(region, privateIp, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            optionsOverrides
        });
        return result.body;
    }
    async createEcho(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/echo`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listOverlays(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/overlay/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async createOverlay(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/overlay/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getOverlay(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/overlay/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async deleteOverlay(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/overlay/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listAdServers(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/adServer/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getAdServer(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/adServer/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async createAdServer(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/adServer/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async updateAdServer(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/adServer/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteAdServer(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/adServer/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async createAdPod(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-pod/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getAdPod(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-pod/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listAdPods(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-pod/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async updateAdPod(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-pod/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteAdPod(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/ad-pod/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async createAdCreative(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-creative/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getAdCreative(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-creative/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listAdCreatives(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-creative/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async updateAdCreative(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-creative/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteAdCreative(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/ad-creative/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async setAdCreativeEvent(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/ad-creative/${id}/event`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getAdBreak(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-break/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listAdBreaks(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-break/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async createAdBreak(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-break/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteAdBreak(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/ad-break/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async getAdStorage(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-storage`,
            optionsOverrides
        });
        return result.body;
    }
    async createScte104Injection(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/scte104-injection`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getTls(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tls`,
            optionsOverrides
        });
        return result.body;
    }
    async setTls(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/tls`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async syncTls(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/tls/sync`,
            optionsOverrides
        });
        return result.body;
    }
    async getGlobalsettings(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/globalsettings`,
            optionsOverrides
        });
        return result.body;
    }
    async setGlobalsettings(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/globalsettings`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteGlobalsettings(optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/globalsettings`,
            optionsOverrides
        });
        return result.body;
    }
    async testBackupExternalS3s(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/backup/externalS3/test`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async createBackup(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/backup`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getRegion(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/region/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listRegions(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/region/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async createRegion(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/region/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async setRegionDefaultRegion(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/region/default-region`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteRegion(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/region/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async getImage(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/image/${name}`,
            optionsOverrides
        });
        return result.body;
    }
    async createImage(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/image/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteImage(name, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/image/${name}`,
            optionsOverrides
        });
        return result.body;
    }
    async getMedia(id, optionsOverrides = {
        json: false
    }) {
        const result = await this._get({
            resource: `/api/media/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listApplianceInternalStatuses(secret, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/internal-statuses`,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async listApplianceSummaries(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/summary`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listAppliances(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listApplianceRegisteredTypes(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/registered-types`,
            optionsOverrides
        });
        return result.body;
    }
    async clearApplianceConfig(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/config/clear`,
            optionsOverrides
        });
        return result.body;
    }
    async listApplianceNdiSources(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/ndi-sources`,
            optionsOverrides
        });
        return result.body;
    }
    async getAppliance(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async upgradeAppliance(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/upgrade`,
            optionsOverrides
        });
        return result.body;
    }
    async recreateApplianceTunnels(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/tunnels/recreate`,
            optionsOverrides
        });
        return result.body;
    }
    async restartAppliance(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/restart`,
            optionsOverrides
        });
        return result.body;
    }
    async upgradeImageAppliance(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/upgrade-image`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async commandAppliance(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/command`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listApplianceCommands(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/command`,
            optionsOverrides
        });
        return result.body;
    }
    async getAppliancePorts(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/ports`,
            optionsOverrides
        });
        return result.body;
    }
    async setAppliancePorts(id, body, optionsOverrides = {}) {
        const result = await this._patch({
            resource: `/api/appliance/${id}/ports`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async updateAppliance(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteAppliance(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/appliance/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async proxyApplianceGet(id, path, optionsOverrides = {
        json: false
    }) {
        const result = await this._get({
            resource: `/api/appliance/${id}/proxy${path}`,
            optionsOverrides
        });
        return result.body;
    }
    async proxyAppliancePost(id, path, body, optionsOverrides = {
        json: false
    }) {
        const result = await this._post({
            resource: `/api/appliance/${id}/proxy${path}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async proxyAppliancePut(id, path, body, optionsOverrides = {
        json: false
    }) {
        const result = await this._put({
            resource: `/api/appliance/${id}/proxy${path}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async proxyApplianceDelete(id, path, optionsOverrides = {
        json: false
    }) {
        const result = await this._delete({
            resource: `/api/appliance/${id}/proxy${path}`,
            optionsOverrides
        });
        return result.body;
    }
    async listApplianceInputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/inputs`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listApplianceOutputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/outputs`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listAppliancePcaps(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/pcap/`,
            optionsOverrides
        });
        return result.body;
    }
    async getAppliancePcap(applianceId, pcapId, optionsOverrides = {
        json: false
    }) {
        const result = await this._get({
            resource: `/api/appliance/${applianceId}/pcap/${pcapId}`,
            optionsOverrides
        });
        return result.body;
    }
    async deleteAppliancePcap(applianceId, pcapId, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/appliance/${applianceId}/pcap/${pcapId}`,
            optionsOverrides
        });
        return result.body;
    }
    async listGeoAppliances(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/geoAppliance/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listTunnels(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tunnel/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listTunnelOutputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tunnel/${id}/outputs`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async createApplianceAllocation(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance-allocation`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getSanity(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/sanity`,
            optionsOverrides
        });
        return result.body;
    }
    async getTestSleep(s, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/test/sleep/${s}`,
            optionsOverrides
        });
        return result.body;
    }
    async setStatefulsetScale(name, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/statefulset/${name}/scale`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getStatefulsetScale(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/statefulset/${name}/scale`,
            optionsOverrides
        });
        return result.body;
    }
    async setStatefulsetTag(name, container, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/statefulset/${name}/${container}/tag`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getStatefulsetTag(name, container, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/statefulset/${name}/${container}/tag`,
            optionsOverrides
        });
        return result.body;
    }
    async setDeploymentTag(name, container, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/deployment/${name}/${container}/tag`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getDeploymentScale(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/deployment/${name}/scale`,
            optionsOverrides
        });
        return result.body;
    }
    async setDeploymentScale(name, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/deployment/${name}/scale`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getDeployment(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/deployment/${name}`,
            optionsOverrides
        });
        return result.body;
    }
    async getPodStatus(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/${name}/status`,
            optionsOverrides
        });
        return result.body;
    }
    async getPodLogs(name, containerName, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/${name}/logs/${containerName}`,
            optionsOverrides
        });
        return result.body;
    }
    async deletePod(name, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/k8s/pod/${name}`,
            optionsOverrides
        });
        return result.body;
    }
    async getPod(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/${name}`,
            optionsOverrides
        });
        return result.body;
    }
    async listPods(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/`,
            optionsOverrides
        });
        return result.body;
    }
    async listKubernetesNodes(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/node/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listIngresses(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/ingress/`,
            optionsOverrides
        });
        return result.body;
    }
    async listResourceUsages(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/resourceUsage/`,
            optionsOverrides
        });
        return result.body;
    }
    async getKubernetesNode(regionId, name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${regionId}/node/${name}`,
            optionsOverrides
        });
        return result.body;
    }
    async updateKubernetesNode(regionId, name, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/k8s/region/${regionId}/node/${name}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listRegionKubernetesNodes(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${id}/node/`,
            optionsOverrides
        });
        return result.body;
    }
    async getRegionVideoScale(regionId, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${regionId}/videoscale/`,
            optionsOverrides
        });
        return result.body;
    }
    async setRegionVideoScale(regionId, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/region/${regionId}/videoscale/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getRegionThumbScale(regionId, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${regionId}/thumbscale/`,
            optionsOverrides
        });
        return result.body;
    }
    async setRegionThumbScale(regionId, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/region/${regionId}/thumbscale/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listAlarms(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/alarm/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async setAlarm(alarmId, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/alarm/${alarmId}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async backupMonitorAlarms(body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/alarm/backup-monitor/`,
            body,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async getPort(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/port/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listPorts(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/port/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async login(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/login/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listLoginMethods(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/login-methods`,
            optionsOverrides
        });
        return result.body;
    }
    async getSsoMetadataSaml(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/sso-metadata/saml`,
            regularQueryParams,
            optionsOverrides
        });
        return result.body;
    }
    async getSsoMetadataOidc(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/sso-metadata/oidc`,
            regularQueryParams,
            optionsOverrides
        });
        return result.body;
    }
    async impersonate(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/impersonate/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async unimpersonate(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/unimpersonate`,
            optionsOverrides
        });
        return result.body;
    }
    async getCurrentUser(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/current-user`,
            optionsOverrides
        });
        return result.body;
    }
    async totpCurrentUsers(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/current-user/totp`,
            optionsOverrides
        });
        return result.body;
    }
    async setCurrentUserTotpVerify(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/current-user/totp/verify`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteCurrentUserTotps(optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/current-user/totp`,
            optionsOverrides
        });
        return result.body;
    }
    async logout(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/logout/`,
            optionsOverrides
        });
        return result.body;
    }
    async getCheckSuperAuthentication(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/check-super-authentication`,
            optionsOverrides
        });
        return result.body;
    }
    async getAuthRequest(role, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/auth/request/${role}`,
            optionsOverrides
        });
        return result.body;
    }
    async listUsers(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/user/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getUser(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/user/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async createUser(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/user/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteUser(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/user/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async updateUser(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/user/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getUserSettings(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/user/${id}/settings`,
            optionsOverrides
        });
        return result.body;
    }
    async setUserSettings(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/user/${id}/settings`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async updateGroup(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/group/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async createGroup(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/group/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listGroups(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/group/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getGroup(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/group/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async deleteGroup(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/group/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async getGroupCoreSecret(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/group/${id}/core-secret`,
            optionsOverrides
        });
        return result.body;
    }
    async setGroupCoreSecret(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/group/${id}/core-secret`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getInputServiceOverview(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/service-overview`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getServiceGraphConfig(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/service-graph/config`,
            optionsOverrides
        });
        return result.body;
    }
    async createInput(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getInputStreamGraph(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/stream-graph`,
            optionsOverrides
        });
        return result.body;
    }
    async listInputs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getInput(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async updateInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async pcapInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/pcap/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async sendToOutputsInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/sendToOutputs`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async updateRecipientsInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/updateRecipients`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async rerouteInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/reroute`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async enableInputPreview(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/preview/enable`,
            optionsOverrides
        });
        return result.body;
    }
    async deleteInput(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/input/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async deleteInputs(regularQueryParams, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/input`,
            regularQueryParams,
            optionsOverrides
        });
        return result.body;
    }
    async listInputDistributions(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/distribution/`,
            optionsOverrides
        });
        return result.body;
    }
    async setInputDistributions(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/input/${id}/distribution/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getInputHealth(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/health/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getInputHlsAccess(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/hls-access`,
            optionsOverrides
        });
        return result.body;
    }
    async getChannelCheckThumbReadAccess(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/channel/${id}/check-thumb-read-access`,
            optionsOverrides
        });
        return result.body;
    }
    async setInputAdminStatuses(body, optionsOverrides = {}) {
        const result = await this._patch({
            resource: `/api/input/admin-status`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async updateOutput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/output/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async setOutputInput(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/output/${id}/input`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async createOutput(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/output/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listOutputs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/output/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getOutput(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/output/${id}`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getOutputHealth(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/output/${id}/health/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async deleteOutput(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/output/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async deleteOutputs(regularQueryParams, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/output`,
            regularQueryParams,
            optionsOverrides
        });
        return result.body;
    }
    async setOutputAdminStatuses(body, optionsOverrides = {}) {
        const result = await this._patch({
            resource: `/api/output/admin-status`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getDashboardBitrates(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/dashboard/bitrates/`,
            optionsOverrides
        });
        return result.body;
    }
    async getThumbRoutes(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/thumb-routes`,
            optionsOverrides
        });
        return result.body;
    }
    async region(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/internal/region/${id}/rpc`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listRawThumbRoutes(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/raw-thumb-routes`,
            optionsOverrides
        });
        return result.body;
    }
    async getBuildInfo(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/build-info`,
            optionsOverrides
        });
        return result.body;
    }
    async listRpcSessions(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/rpc-session/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async deleteRpcSession(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/rpc-session/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listAlarmLogs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/alarm-log/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async cloudApplianceAuditLogs(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/audit-log/cloud-appliance/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async beginAuditLogSystemUpgrades(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/audit-log/system/upgrade/begin`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async completeAuditLogSystemUpgrades(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/audit-log/system/upgrade/complete`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async listAuditLogs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/audit-log/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listAdAuditLogs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-audit-log/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getOutputRecipientList(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listOutputRecipientListOutputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/${id}/outputs`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listOutputRecipientListOutputsNotInLists(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/${id}/outputsNotInList`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listOutputRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async createOutputRecipientList(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/outputRecipientList/`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async updateOutputRecipientList(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/outputRecipientList/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteOutputRecipientList(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/outputRecipientList/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listOutputAndRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputAndRecipientList/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listGroupRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getGroupRecipientList(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listGroupRecipientListGroups(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/${id}/groups`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listGroupRecipientListGroupsNotInLists(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/${id}/groupsNotInList`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async createGroupRecipientList(body, query, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/groupRecipientList/`,
            query,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async updateGroupRecipientList(id, body, query, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/groupRecipientList/${id}`,
            query,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteGroupRecipientList(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/groupRecipientList/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listGroupAndRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupAndRecipientList/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getCoreSecret(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/core-secret`,
            optionsOverrides
        });
        return result.body;
    }
    async getBillingReport(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/billing-report`,
            regularQueryParams,
            optionsOverrides
        });
        return result.body;
    }
    async getUsageReport(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/usage-report`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listNetworks(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/network`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getNetwork(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/network/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async createNetwork(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/network`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async updateNetwork(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/network/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async deleteNetwork(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/network/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async listTags(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tag/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async listServices(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/service/`,
            query,
            optionsOverrides
        });
        return result.body;
    }
    async getService(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/service/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async updateService(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/service/${id}`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getGrafanaDashboardsHome(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/grafana/api/dashboards/home`,
            optionsOverrides
        });
        return result.body;
    }
    async listGrafanaDashboards(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/grafana/api/search`,
            regularQueryParams,
            optionsOverrides
        });
        return result.body;
    }
    async setGrafanaUserHelpflags(flag, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/grafana/api/user/helpflags/${flag}`,
            optionsOverrides
        });
        return result.body;
    }
    async createGrafanaApiUserStarsDashboard(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/grafana/api/user/stars/dashboard/${id}`,
            optionsOverrides
        });
        return result.body;
    }
    async getHealthBackendAppliance(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health-backend-appliance`,
            optionsOverrides
        });
        return result.body;
    }
    async registerAppliance(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/register`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getApplianceConfig(id, secret, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/config`,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async sendApplianceVersionMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/version`,
            body,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async sendApplianceSrtStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/srt-stats`,
            body,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async sendApplianceRtmpStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/rtmp-stats`,
            body,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async sendApplianceZixiBroadcasterStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/zixi-broadcaster-stats`,
            body,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async sendApplianceAdStageStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/ad-stage-stats`,
            body,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async sendApplianceProgressMessage(id, cmdId, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/command/${cmdId}/progress`,
            body,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async messageAppliance(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message`,
            body,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async logAppliance(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/log`,
            body,
            optionsOverrides: {
                ...optionsOverrides,
                headers: {
                    ...optionsOverrides.headers,
                    'edge-secret': secret
                }
            }
        });
        return result.body;
    }
    async getCoreSecretAppliance(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/core-secret-appliance`,
            optionsOverrides
        });
        return result.body;
    }
    async getThumbWriteAccess(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/auth/thumb-write-access`,
            optionsOverrides
        });
        return result.body;
    }
    async getHealthStreamMonitor(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health-stream-monitor`,
            optionsOverrides
        });
        return result.body;
    }
    async getApplianceSoftware(optionsOverrides = {
        json: false
    }) {
        const result = await this._get({
            resource: `/api/appliance/software`,
            optionsOverrides
        });
        return result.body;
    }
    async applianceSoftware(body, optionsOverrides = {
        json: false
    }) {
        const result = await this._post({
            resource: `/api/appliance/software`,
            body,
            optionsOverrides
        });
        return result.body;
    }
    async getHealthAdService(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health-ad-service`,
            optionsOverrides
        });
        return result.body;
    }
    get baseUrl() {
        if (Date.now() - this._baseUrlLastSet > 60000) this.baseUrl = this.baseUrls.reset();
        return this._baseUrl;
    }
    set baseUrl(url) {
        this._baseUrlLastSet = Date.now();
        this._baseUrl = url;
    }
    async _get(params) {
        return this._call('GET', params);
    }
    async _post(params) {
        return this._call('POST', params);
    }
    async _put(params) {
        return this._call('PUT', params);
    }
    async _delete(params) {
        return this._call('DELETE', params);
    }
    async _patch(params) {
        return this._call('PATCH', params);
    }
    _call(method, params) {
        const queryParams = Object.assign({}, params.regularQueryParams);
        if (params.query) {
            const queryObject = (0, query_1.toQueryParams)(params.query);
            Object.assign(queryParams, queryObject);
        }
        const queryString = Object.entries(queryParams).reduce((acc, [key, value])=>{
            return [
                ...acc,
                value === undefined || value === null ? `${this.encode(key)}=` : `${this.encode(key)}=${this.encode(value)}`
            ];
        }, []).join('&');
        const url = `${this.baseUrl}${params.resource}?${queryString}`;
        return this.request({
            method,
            url,
            body: params.body,
            optionsOverrides: params.optionsOverrides
        });
    }
    async request(params, attempt = 1) {
        try {
            return await this._request(params);
        } catch (err) {
            if (this.baseUrls.length > attempt) {
                this.baseUrl = this.baseUrls.next().value;
                return this.request(params, attempt + 1);
            }
            throw err;
        }
    }
    /// https://github.com/axios/axios/blob/master/lib/helpers/buildURL.js
    encode(val) {
        return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    }
}
exports.EdgeClient = EdgeClient;

},{"563d7657061966f1":"2pYyl"}],"2pYyl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toQueryParams = toQueryParams;
exports.fromQueryParams = fromQueryParams;
exports.fromCustomQueryParams = fromCustomQueryParams;
const serialization_1 = require("58022871cd4655ea");
function toQueryParams(q) {
    return {
        q: JSON.stringify(q)
    };
}
function fromQueryParams(q) {
    if (!q.q) return {};
    let obj;
    try {
        obj = (0, serialization_1.jsonParse)(q.q);
    } catch (e) {
        // Try to decodeURIComponent first to support older API clients
        obj = (0, serialization_1.jsonParse)(decodeURIComponent(q.q));
    }
    return obj;
}
function fromCustomQueryParams(q) {
    if (!q.q) return {};
    let obj;
    try {
        obj = (0, serialization_1.jsonParse)(q.q);
    } catch (e) {
        // Try to decodeURIComponent first to support older API clients
        obj = (0, serialization_1.jsonParse)(decodeURIComponent(q.q));
    }
    return obj;
}

},{"58022871cd4655ea":"j24dT"}],"cqMGU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUB_PATH", ()=>SUB_PATH);
parcelHelpers.export(exports, "ROUTES", ()=>ROUTES);
parcelHelpers.export(exports, "api", ()=>api);
parcelHelpers.export(exports, "makeRoutes", ()=>makeRoutes);
parcelHelpers.export(exports, "doesPathBelongTo", ()=>doesPathBelongTo);
var _pathToRegexp = require("path-to-regexp");
var _drop = require("lodash/fp/drop");
var _dropDefault = parcelHelpers.interopDefault(_drop);
var _omit = require("lodash/fp/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _reactRouter = require("react-router");
/**
 * Generates url using path-to-regexp, using params as both path and query parameters
 * @param path
 * @param params
 */ const getUrl = (path, params)=>{
    if (!params) return path;
    const keys = (0, _dropDefault.default)(1, (0, _pathToRegexp.parse)(path));
    const pathParams = keys.map(({ name })=>name);
    if (Object.entries(params).some(([key, value])=>pathParams.includes(key) && !value)) return '';
    const searchParams = Object.entries((0, _omitDefault.default)(pathParams, params));
    const queryString = searchParams.length ? searchParams.reduce((acc, [key, value], ind)=>value !== undefined ? `${acc}${ind ? '&' : '?'}${key}=${encodeURIComponent(value)}` : acc, '') : '';
    return `${(0, _pathToRegexp.compile)(path)(params)}${queryString}`;
};
/**
 * Returns Route which is route creator (to use with path-parameters to get the url) with access to the initial path
 * @param path - path with ':<...>' to use as path params
 */ const getRoute = (path, getDefaultUrlParamsFn)=>{
    const outFunc = (urlParams)=>getUrl(path, urlParams ?? getDefaultUrlParamsFn?.());
    outFunc.route = path;
    return outFunc;
};
const getCreateRoute = (path, query)=>getRoute(`${path}/${SUB_PATH.NEW}` + (query ? `\\?${query}` : ''));
const getUpdateRoute = (path)=>getRoute(`${path}/${SUB_PATH.UPDATE}`);
const getViewRoute = (path)=>getRoute(`${path}/${SUB_PATH.VIEW}`);
const getCopyRoute = (path)=>getRoute(`${path}/${SUB_PATH.COPY}`);
const SUB_PATH = {
    NEW: 'new',
    UPDATE: 'update/:id',
    VIEW: 'view/:id',
    COPY: 'copy/:id'
};
const root = {
    alarms: '/alarms',
    alarmLogs: '/alarmLogs',
    audit: '/audit',
    appliances: '/settings/appliances',
    billing: '/settings/billing',
    usage: '/settings/usage',
    globalSettings: '/globalSettings',
    production: '/production',
    adInsertion: '/adInsertion',
    adCreatives: '/adInsertion/adCreatives',
    adPods: '/adInsertion/adPods',
    graph: '/graph',
    inputs: '/inputs',
    interfaces: '/settings/interfaces',
    groups: '/settings/groups',
    groupLists: '/settings/groups/lists',
    outputs: '/outputs',
    outputLists: '/outputs/lists',
    overview: '/overview',
    profile: '/profile',
    regions: '/settings/regions',
    service: '/service/:id',
    setting: '/settings',
    status: '/status',
    tunnels: '/settings/tunnels',
    users: '/settings/users',
    services: '/settings/services',
    nodes: '/settings/kubernetesNodes',
    addresses: '/settings/addresses',
    addressMappings: '/settings/addressMappings',
    networks: '/settings/networks',
    // Stream Manager
    stream: '/stream',
    streamProfile: '/stream/profile',
    // Event Manager
    events: '/events',
    eventsProfile: '/events/profile'
};
const ROUTES = root;
const api = {
    billing: (params)=>{
        return getRoute('/api/billing-report')({
            startDate: params.startDate.toISOString(),
            endDate: params.endDate.toISOString(),
            format: params.format
        });
    },
    usage: (params)=>{
        const filter = {
            startDate: params.startDate,
            endDate: params.endDate,
            format: params.format,
            type: params.type
        };
        return getRoute('/api/usage-report')() + `?q=${encodeURIComponent(JSON.stringify({
            filter
        }))}`;
    },
    appliance: (params)=>getRoute('/api/appliance/:id/proxy')({
            id: params.id
        })
};
const makeRoutes = (getCachedUrlParams)=>({
        overview: getRoute(root.overview),
        graph: getRoute(root.graph),
        service: getRoute(root.service),
        globalSettings: getRoute(root.globalSettings),
        production: getRoute(root.production),
        overlaysNew: getCreateRoute(`${root.production}/overlays`),
        overlaysUpdate: getUpdateRoute(`${root.production}/overlays`),
        overlaysCopy: getCopyRoute(`${root.production}/overlays/`),
        adInsertion: getRoute(root.adInsertion),
        adAudit: getRoute(`${root.adInsertion}/adAudit`),
        adServers: getRoute(`${root.adInsertion}/adServers`),
        adServersNew: getCreateRoute(`${root.adInsertion}/adServers`),
        adServersUpdate: getUpdateRoute(`${root.adInsertion}/adServers`),
        adServersCopy: getCopyRoute(`${root.adInsertion}/adServers/`),
        adCreatives: getRoute(`${root.adCreatives}`),
        adCreativesNew: getCreateRoute(`${root.adCreatives}`),
        adCreativesUpdate: getUpdateRoute(`${root.adCreatives}`),
        adPods: getRoute(`${root.adPods}`),
        adPodsNew: getCreateRoute(`${root.adPods}`),
        adPodsUpdate: getUpdateRoute(`${root.adPods}`),
        adBreaks: getRoute(`${root.adInsertion}/adBreaks`),
        adBreaksHistory: getRoute(`${root.adInsertion}/adBreaks/history`),
        adBreaksView: getViewRoute(`${root.adInsertion}/adBreaks`),
        inputs: getRoute(root.inputs, ()=>getCachedUrlParams()['inputs']),
        inputsNew: getCreateRoute(root.inputs),
        inputsUpdate: getUpdateRoute(root.inputs),
        inputsCopy: getRoute(`${root.inputs}/copy/:id`),
        inputsDerive: getCreateRoute(root.inputs, `deriveFrom=:id`),
        outputs: getRoute(root.outputs, ()=>getCachedUrlParams()['outputs']),
        outputsNew: getCreateRoute(root.outputs),
        outputsUpdate: getUpdateRoute(root.outputs),
        outputsCopy: getRoute(`${root.outputs}/copy/:id`),
        outputLists: getRoute(root.outputLists, ()=>getCachedUrlParams()['outputLists']),
        outputListsNew: getCreateRoute(root.outputLists),
        outputListsUpdate: getUpdateRoute(root.outputLists),
        alarms: getRoute(root.alarms, ()=>getCachedUrlParams()['alarms']),
        alarmLogs: getRoute(root.alarmLogs),
        appliances: getRoute(root.appliances, ()=>getCachedUrlParams()['appliances']),
        appliancesConfig: getRoute(`${root.appliances}/:id/config`),
        appliancesUpdate: getUpdateRoute(root.appliances),
        groups: getRoute(root.groups, ()=>getCachedUrlParams()['groups']),
        groupsNew: getCreateRoute(root.groups),
        groupsUpdate: getUpdateRoute(root.groups),
        groupLists: getRoute(root.groupLists, ()=>getCachedUrlParams()['groupLists']),
        groupListsNew: getCreateRoute(root.groupLists),
        groupListsUpdate: getUpdateRoute(root.groupLists),
        users: getRoute(root.users, ()=>getCachedUrlParams()['users']),
        usersNew: getCreateRoute(root.users),
        usersUpdate: getUpdateRoute(root.users),
        profile: getRoute(root.profile),
        services: getRoute(root.services, ()=>getCachedUrlParams()['k8sServices']),
        servicesUpdate: getUpdateRoute(root.services),
        addressMappings: getRoute(root.addressMappings, ()=>getCachedUrlParams()['addressMappings']),
        addressMappingsNew: getCreateRoute(root.addressMappings),
        addressMappingsUpdate: getRoute(`${root.addressMappings}/update/:region/:privateIp`),
        interfaces: getRoute(root.interfaces, ()=>getCachedUrlParams()['interfaces']),
        interfacesUpdate: getUpdateRoute(root.interfaces),
        settings: getRoute(root.setting),
        status: getRoute(root.status),
        tunnel: getRoute(`${root.tunnels}/:tunnelId`),
        billing: getRoute(root.billing),
        usage: getRoute(root.usage),
        audit: getRoute(root.audit),
        regions: getRoute(root.regions, ()=>getCachedUrlParams()['regions']),
        regionsUpdate: getRoute(`${root.regions}/update/:id`),
        kubernetesNodes: getRoute(root.nodes, ()=>getCachedUrlParams()['k8sNodes']),
        kubernetesNodesUpdate: getRoute(`${root.nodes}/update/:regionId/node/:name`),
        networks: getRoute(root.networks, ()=>getCachedUrlParams()['networks']),
        networkNew: getCreateRoute(root.networks),
        networkUpdate: getUpdateRoute(root.networks),
        // Stream Manager
        stream: getRoute(root.stream),
        streamProfile: getRoute(root.streamProfile),
        // Event Manager
        events: getRoute(root.events),
        eventsProfile: getRoute(root.eventsProfile)
    });
function doesPathBelongTo(path, parentPath) {
    return !!(0, _reactRouter.matchPath)({
        path: parentPath,
        end: false
    }, path);
}

},{"path-to-regexp":"3G4we","lodash/fp/drop":"ayQaK","lodash/fp/omit":"lRr4P","react-router":"iaz4C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3G4we":[function(require,module,exports,__globalThis) {
/**
 * Tokenize input string.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse a string for the raw tokens.
 */ parcelHelpers.export(exports, "parse", ()=>parse);
/**
 * Compile a string to a template function for the path.
 */ parcelHelpers.export(exports, "compile", ()=>compile);
/**
 * Expose a method for transforming tokens into the path function.
 */ parcelHelpers.export(exports, "tokensToFunction", ()=>tokensToFunction);
/**
 * Create path match function from `path-to-regexp` spec.
 */ parcelHelpers.export(exports, "match", ()=>match);
/**
 * Create a path match function from `path-to-regexp` output.
 */ parcelHelpers.export(exports, "regexpToFunction", ()=>regexpToFunction);
/**
 * Expose a function for taking tokens and returning a RegExp.
 */ parcelHelpers.export(exports, "tokensToRegexp", ()=>tokensToRegexp);
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */ parcelHelpers.export(exports, "pathToRegexp", ()=>pathToRegexp);
function lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function parse(str, options) {
    if (options === void 0) options = {};
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat(escapeString(delimiter), "]+?");
        return "(?:(?!".concat(escapeString(prevText), ")[^").concat(escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
function tokensToFunction(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
}
function regexpToFunction(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return pathToRegexp(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), flags(options));
}
/**
 * Create a path regexp from string input.
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat(escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat(escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += escapeString(encode(token));
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, flags(options));
}
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp) return regexpToRegexp(path, keys);
    if (Array.isArray(path)) return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ayQaK":[function(require,module,exports,__globalThis) {
var convert = require("92dad1d54e43eb1a"), func = convert('drop', require("7ce94f1a14c5705e"));
func.placeholder = require("740646d8827bb632");
module.exports = func;

},{"92dad1d54e43eb1a":"8yrvu","7ce94f1a14c5705e":"7Gazm","740646d8827bb632":"6JeHm"}],"8yrvu":[function(require,module,exports,__globalThis) {
var baseConvert = require("2a5242b946fc600a"), util = require("8624431b35d95b16");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function convert(name, func, options) {
    return baseConvert(util, name, func, options);
}
module.exports = convert;

},{"2a5242b946fc600a":"5yR1q","8624431b35d95b16":"jaFVn"}],"5yR1q":[function(require,module,exports,__globalThis) {
var mapping = require("72915459611a16e2"), fallbackHolder = require("d891236dde43882c");
/** Built-in value reference. */ var push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) push.apply(otherArgs, array);
        if (start != lastIndex) push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : fallbackHolder, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys(mapping.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray(cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = mapping.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && mapping.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
            var data = mapping.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]) ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = mapping.aliasToReal[name] || name, methodName = mapping.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return baseArity(rearg(baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = mapping.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if (mapping.mutate.array[realName]) wrapped = wrapImmutable(func, cloneArray);
            else if (mapping.mutate.object[realName]) wrapped = wrapImmutable(func, createCloner(func));
            else if (mapping.mutate.set[realName]) wrapped = wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each(mapping.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = mapping.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each(mapping.aryMethod[aryKey], function(key) {
            var func = _[mapping.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each(mapping.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = baseConvert;

},{"72915459611a16e2":"eqKX7","d891236dde43882c":"6JeHm"}],"eqKX7":[function(require,module,exports,__globalThis) {
/** Used to map aliases to their real names. */ exports.aliasToReal = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
/** Used to map ary to method names. */ exports.aryMethod = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
/** Used to map ary to rearg configs. */ exports.aryRearg = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
/** Used to map method names to their iteratee ary. */ exports.iterateeAry = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
/** Used to map method names to iteratee rearg configs. */ exports.iterateeRearg = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
/** Used to map method names to rearg configs. */ exports.methodRearg = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
/** Used to map method names to spread configs. */ exports.methodSpread = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
/** Used to identify methods which mutate arrays or objects. */ exports.mutate = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
/** Used to map real names to their aliases. */ exports.realToAlias = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = exports.aliasToReal, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
/** Used to map method names to other names. */ exports.remap = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
/** Used to track methods that skip fixing their arity. */ exports.skipFixed = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
/** Used to track methods that skip rearranging arguments. */ exports.skipRearg = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

},{}],"6JeHm":[function(require,module,exports,__globalThis) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

},{}],"jaFVn":[function(require,module,exports,__globalThis) {
module.exports = {
    'ary': require("b44cdf6e5c6e7245"),
    'assign': require("7f3d12d09010b347"),
    'clone': require("322c77af1577a812"),
    'curry': require("34c2493e9bbbb635"),
    'forEach': require("ae172961026deee2"),
    'isArray': require("ce92c2c538897425"),
    'isError': require("deeaef070d3a24de"),
    'isFunction': require("f7f3d93fa5df0312"),
    'isWeakMap': require("1e13747d39fad3a5"),
    'iteratee': require("ce2689cc69cc73c7"),
    'keys': require("100a971116f0fd63"),
    'rearg': require("cd4587c51cd57c3"),
    'toInteger': require("d8296eb6235b6fb8"),
    'toPath': require("518d749e15880a87")
};

},{"b44cdf6e5c6e7245":"6kL8s","7f3d12d09010b347":"7HkQg","322c77af1577a812":"cpXM6","34c2493e9bbbb635":"dG1mQ","ae172961026deee2":"gM7YB","ce92c2c538897425":"1DVeR","deeaef070d3a24de":"irrJW","f7f3d93fa5df0312":"3A7xI","1e13747d39fad3a5":"dyQGi","ce2689cc69cc73c7":"4GaQu","100a971116f0fd63":"f4fT3","cd4587c51cd57c3":"jCwMn","d8296eb6235b6fb8":"fCKw5","518d749e15880a87":"6Z7Je"}],"6kL8s":[function(require,module,exports,__globalThis) {
var createWrap = require("7f2e0f00c58fa327");
/** Used to compose bitmasks for function metadata. */ var WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = ary;

},{"7f2e0f00c58fa327":"yelhl"}],"yelhl":[function(require,module,exports,__globalThis) {
var baseSetData = require("409194a967409865"), createBind = require("f88dc89f94fe40a3"), createCurry = require("29ea913928e7d154"), createHybrid = require("2adf83513657047c"), createPartial = require("c86d22b8cb5bc4fc"), getData = require("2d859c2fc32d8003"), mergeData = require("58e166128ff051de"), setData = require("f669ed19558981e5"), setWrapToString = require("3a1920f3fd9cced0"), toInteger = require("16ec8d22e97f7e63");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
    arity = arity === undefined ? arity : toInteger(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : getData(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) mergeData(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
    else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
    else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
    else result = createHybrid.apply(undefined, newData);
    var setter = data ? baseSetData : setData;
    return setWrapToString(setter(result, newData), func, bitmask);
}
module.exports = createWrap;

},{"409194a967409865":"d8rLT","f88dc89f94fe40a3":"7mtoO","29ea913928e7d154":"1Z4b7","2adf83513657047c":"1AzzM","c86d22b8cb5bc4fc":"krEwG","2d859c2fc32d8003":"9ducP","58e166128ff051de":"cRU6f","f669ed19558981e5":"jAsXT","3a1920f3fd9cced0":"64jjY","16ec8d22e97f7e63":"fCKw5"}],"d8rLT":[function(require,module,exports,__globalThis) {
var identity = require("64b374501e4aa524"), metaMap = require("e1fa1ff9966d0e31");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var baseSetData = !metaMap ? identity : function(func, data) {
    metaMap.set(func, data);
    return func;
};
module.exports = baseSetData;

},{"64b374501e4aa524":"2HXBf","e1fa1ff9966d0e31":"1fOev"}],"1fOev":[function(require,module,exports,__globalThis) {
var WeakMap = require("e4c0cdd8d94afe67");
/** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
module.exports = metaMap;

},{"e4c0cdd8d94afe67":"9vICk"}],"7mtoO":[function(require,module,exports,__globalThis) {
var createCtor = require("ccaaf0e66be6c54a"), root = require("d1dd8dedf8fd24c7");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createBind(func, bitmask, thisArg) {
    var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
    function wrapper() {
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = createBind;

},{"ccaaf0e66be6c54a":"a8B6b","d1dd8dedf8fd24c7":"gVq56"}],"a8B6b":[function(require,module,exports,__globalThis) {
var baseCreate = require("df50f76f41ee2ce5"), isObject = require("b541546f05e2a238");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
    };
}
module.exports = createCtor;

},{"df50f76f41ee2ce5":"5YCvM","b541546f05e2a238":"6hgJK"}],"1Z4b7":[function(require,module,exports,__globalThis) {
var apply = require("388fbbd86e6fe243"), createCtor = require("77e2a1940f4ba2c8"), createHybrid = require("a562f889cf091133"), createRecurry = require("7e279b7556b7064c"), getHolder = require("4927f0c28406c6ff"), replaceHolders = require("90abff02836ba632"), root = require("c9c2f614b542db58");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createCurry(func, bitmask, arity) {
    var Ctor = createCtor(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = getHolder(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
        length -= holders.length;
        if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return apply(fn, this, args);
    }
    return wrapper;
}
module.exports = createCurry;

},{"388fbbd86e6fe243":"bZSxb","77e2a1940f4ba2c8":"a8B6b","a562f889cf091133":"1AzzM","7e279b7556b7064c":"bvRkH","4927f0c28406c6ff":"dOKzp","90abff02836ba632":"h7BZg","c9c2f614b542db58":"gVq56"}],"1AzzM":[function(require,module,exports,__globalThis) {
var composeArgs = require("e5b1f7769f51a295"), composeArgsRight = require("7521cffaa8d6168b"), countHolders = require("48392761c9fdbe47"), createCtor = require("ad0b9ebe1b614b63"), createRecurry = require("534414524611b6c2"), getHolder = require("1bb141c8de8d25e5"), reorder = require("3f41ce0b0d04374f"), replaceHolders = require("d8aa89cb216e33ea"), root = require("e22e533ef0983b6c");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_ARY_FLAG = 128, WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
        if (partials) args = composeArgs(args, partials, holders, isCurried);
        if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = reorder(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = createHybrid;

},{"e5b1f7769f51a295":"6aIsd","7521cffaa8d6168b":"2fvWS","48392761c9fdbe47":"7jAjF","ad0b9ebe1b614b63":"a8B6b","534414524611b6c2":"bvRkH","1bb141c8de8d25e5":"dOKzp","3f41ce0b0d04374f":"1P5bt","d8aa89cb216e33ea":"h7BZg","e22e533ef0983b6c":"gVq56"}],"6aIsd":[function(require,module,exports,__globalThis) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = composeArgs;

},{}],"2fvWS":[function(require,module,exports,__globalThis) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = composeArgsRight;

},{}],"7jAjF":[function(require,module,exports,__globalThis) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = countHolders;

},{}],"bvRkH":[function(require,module,exports,__globalThis) {
var isLaziable = require("e94afdb912b40a39"), setData = require("d53c8677d10257d3"), setWrapToString = require("87f278675d13ada5");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
    if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if (isLaziable(func)) setData(result, newData);
    result.placeholder = placeholder;
    return setWrapToString(result, func, bitmask);
}
module.exports = createRecurry;

},{"e94afdb912b40a39":"42nVD","d53c8677d10257d3":"jAsXT","87f278675d13ada5":"64jjY"}],"42nVD":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("56693ece680765d7"), getData = require("60c1c90169f6a5fe"), getFuncName = require("c8348f842539c358"), lodash = require("81fdf3ae1e47ec3e");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function isLaziable(func) {
    var funcName = getFuncName(func), other = lodash[funcName];
    if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
    if (func === other) return true;
    var data = getData(other);
    return !!data && func === data[0];
}
module.exports = isLaziable;

},{"56693ece680765d7":"amUJv","60c1c90169f6a5fe":"9ducP","c8348f842539c358":"fQChO","81fdf3ae1e47ec3e":"3MrYj"}],"amUJv":[function(require,module,exports,__globalThis) {
var baseCreate = require("e4056cbc3b9903bd"), baseLodash = require("3dfa16f8f7f9ba49");
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;
module.exports = LazyWrapper;

},{"e4056cbc3b9903bd":"5YCvM","3dfa16f8f7f9ba49":"lmQjQ"}],"lmQjQ":[function(require,module,exports,__globalThis) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function baseLodash() {
// No operation performed.
}
module.exports = baseLodash;

},{}],"9ducP":[function(require,module,exports,__globalThis) {
var metaMap = require("64c6b8282a70671c"), noop = require("19698e8556ad5081");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var getData = !metaMap ? noop : function(func) {
    return metaMap.get(func);
};
module.exports = getData;

},{"64c6b8282a70671c":"1fOev","19698e8556ad5081":"enX86"}],"enX86":[function(require,module,exports,__globalThis) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"fQChO":[function(require,module,exports,__globalThis) {
var realNames = require("14ca6afa60113322");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function getFuncName(func) {
    var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = getFuncName;

},{"14ca6afa60113322":"ecbA8"}],"ecbA8":[function(require,module,exports,__globalThis) {
/** Used to lookup unminified function names. */ var realNames = {};
module.exports = realNames;

},{}],"3MrYj":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("e957c6a134f81ad3"), LodashWrapper = require("dc12267c6e1ac251"), baseLodash = require("2e62ee2285f7942e"), isArray = require("7d71cf75ddd5142"), isObjectLike = require("31691bc364b8b2af"), wrapperClone = require("d2329b4b44e63943");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function lodash(value) {
    if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) return value;
        if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
    }
    return new LodashWrapper(value);
}
// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;
module.exports = lodash;

},{"e957c6a134f81ad3":"amUJv","dc12267c6e1ac251":"7XVPJ","2e62ee2285f7942e":"lmQjQ","7d71cf75ddd5142":"1DVeR","31691bc364b8b2af":"4gOki","d2329b4b44e63943":"iLXws"}],"7XVPJ":[function(require,module,exports,__globalThis) {
var baseCreate = require("1f2f5be1a3c6d678"), baseLodash = require("2c2205c836afd08b");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;
module.exports = LodashWrapper;

},{"1f2f5be1a3c6d678":"5YCvM","2c2205c836afd08b":"lmQjQ"}],"iLXws":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("c911f6aa155b3acf"), LodashWrapper = require("8e63eae4d3286327"), copyArray = require("633c60334a2eb5ec");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function wrapperClone(wrapper) {
    if (wrapper instanceof LazyWrapper) return wrapper.clone();
    var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = copyArray(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = wrapperClone;

},{"c911f6aa155b3acf":"amUJv","8e63eae4d3286327":"7XVPJ","633c60334a2eb5ec":"lWbYv"}],"jAsXT":[function(require,module,exports,__globalThis) {
var baseSetData = require("8a974c6f711104d4"), shortOut = require("8d948a175fb74005");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var setData = shortOut(baseSetData);
module.exports = setData;

},{"8a974c6f711104d4":"d8rLT","8d948a175fb74005":"9rYPt"}],"64jjY":[function(require,module,exports,__globalThis) {
var getWrapDetails = require("ce1525e50ee5903f"), insertWrapDetails = require("8ac4da188da03fb"), setToString = require("f6a71ef5006628a0"), updateWrapDetails = require("b632a55f254888a4");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}
module.exports = setWrapToString;

},{"ce1525e50ee5903f":"kcSId","8ac4da188da03fb":"uHDx1","f6a71ef5006628a0":"cmKNW","b632a55f254888a4":"VRqyq"}],"kcSId":[function(require,module,exports,__globalThis) {
/** Used to match wrap detail comments. */ var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function getWrapDetails(source) {
    var match = source.match(reWrapDetails);
    return match ? match[1].split(reSplitDetails) : [];
}
module.exports = getWrapDetails;

},{}],"uHDx1":[function(require,module,exports,__globalThis) {
/** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = insertWrapDetails;

},{}],"VRqyq":[function(require,module,exports,__globalThis) {
var arrayEach = require("a7a49cef037dbfe1"), arrayIncludes = require("af2237e87f92af85");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
    [
        'ary',
        WRAP_ARY_FLAG
    ],
    [
        'bind',
        WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        WRAP_FLIP_FLAG
    ],
    [
        'partial',
        WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function updateWrapDetails(details, bitmask) {
    arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = updateWrapDetails;

},{"a7a49cef037dbfe1":"gM7YB","af2237e87f92af85":"3t5Fw"}],"3t5Fw":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"1LJGE"}],"1LJGE":[function(require,module,exports,__globalThis) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"9mWam","c991ed2b82d165b":"dG3he","c0bb8190b05a00a5":"4WTof"}],"9mWam":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"dG3he":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"4WTof":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"dOKzp":[function(require,module,exports,__globalThis) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = getHolder;

},{}],"1P5bt":[function(require,module,exports,__globalThis) {
var copyArray = require("c6e993da92674ed"), isIndex = require("2f2bb616bb09517c");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function reorder(array, indexes) {
    var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
    while(length--){
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = reorder;

},{"c6e993da92674ed":"lWbYv","2f2bb616bb09517c":"bxLaX"}],"h7BZg":[function(require,module,exports,__globalThis) {
/** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = replaceHolders;

},{}],"krEwG":[function(require,module,exports,__globalThis) {
var apply = require("efc11e615cec5fee"), createCtor = require("2c37aff03fcedfc"), root = require("d72e13e375eeb85f");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return apply(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = createPartial;

},{"efc11e615cec5fee":"bZSxb","2c37aff03fcedfc":"a8B6b","d72e13e375eeb85f":"gVq56"}],"cRU6f":[function(require,module,exports,__globalThis) {
var composeArgs = require("a3cfccd73f098250"), composeArgsRight = require("7f237b86dc59ec17"), replaceHolders = require("35c070da925561c8");
/** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
    var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = mergeData;

},{"a3cfccd73f098250":"6aIsd","7f237b86dc59ec17":"2fvWS","35c070da925561c8":"h7BZg"}],"fCKw5":[function(require,module,exports,__globalThis) {
var toFinite = require("e624a4916a3de577");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"e624a4916a3de577":"b6tZP"}],"b6tZP":[function(require,module,exports,__globalThis) {
var toNumber = require("90c5878489629896");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"90c5878489629896":"3MLIQ"}],"3MLIQ":[function(require,module,exports,__globalThis) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"57o9c","faaa289d287a34a5":"6hgJK","47b3bd23f771891":"fMaHV"}],"57o9c":[function(require,module,exports,__globalThis) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"gJ6UK"}],"gJ6UK":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"cpXM6":[function(require,module,exports,__globalThis) {
var baseClone = require("38689aaf6b27bf48");
/** Used to compose bitmasks for cloning. */ var CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function clone(value) {
    return baseClone(value, CLONE_SYMBOLS_FLAG);
}
module.exports = clone;

},{"38689aaf6b27bf48":"dqsfF"}],"dG1mQ":[function(require,module,exports,__globalThis) {
var createWrap = require("f4f4b9996fdaa75c");
/** Used to compose bitmasks for function metadata. */ var WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = curry.placeholder;
    return result;
}
// Assign default placeholders.
curry.placeholder = {};
module.exports = curry;

},{"f4f4b9996fdaa75c":"yelhl"}],"irrJW":[function(require,module,exports,__globalThis) {
var baseGetTag = require("8f666395b51fa86"), isObjectLike = require("612368b1182b3d4d"), isPlainObject = require("412a2247173a1a29");
/** `Object#toString` result references. */ var domExcTag = '[object DOMException]', errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function isError(value) {
    if (!isObjectLike(value)) return false;
    var tag = baseGetTag(value);
    return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
}
module.exports = isError;

},{"8f666395b51fa86":"5ltt8","612368b1182b3d4d":"4gOki","412a2247173a1a29":"lCxAG"}],"dyQGi":[function(require,module,exports,__globalThis) {
var getTag = require("259f8d0f34774d94"), isObjectLike = require("a5cb83d878dfe581");
/** `Object#toString` result references. */ var weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function isWeakMap(value) {
    return isObjectLike(value) && getTag(value) == weakMapTag;
}
module.exports = isWeakMap;

},{"259f8d0f34774d94":"1chae","a5cb83d878dfe581":"4gOki"}],"4GaQu":[function(require,module,exports,__globalThis) {
var baseClone = require("a4946ae031ea7d7b"), baseIteratee = require("4e7d4405a5c7dced");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function iteratee(func) {
    return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}
module.exports = iteratee;

},{"a4946ae031ea7d7b":"dqsfF","4e7d4405a5c7dced":"6jZAq"}],"6jZAq":[function(require,module,exports,__globalThis) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"1Dnfv","4f010869f7b63154":"flZVA","28f06147d1eb9502":"2HXBf","3c56f88c4debf449":"1DVeR","aee920e0ef5bf111":"bSOBT"}],"1Dnfv":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"5GI5z","89e9034a8071e297":"eEnTQ","782598b150762386":"18Sgh"}],"5GI5z":[function(require,module,exports,__globalThis) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"cltFt","9003c0cc8ac007b6":"hrIE8"}],"hrIE8":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"9gcZQ","809bbb0c20650dbc":"4gOki"}],"9gcZQ":[function(require,module,exports,__globalThis) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"cltFt","96bc8a1825db53a5":"cXMUl","8bdece495e87fb69":"7eeNO","bb94920432a68eca":"kyaB8","45495edff98e5837":"1chae","18256411ae9e2858":"1DVeR","e5ba7abf54247fc5":"26W2O","50d786bb5c7366af":"hq5rz"}],"cXMUl":[function(require,module,exports,__globalThis) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"irm8l","1ee20de911db0cb0":"bjRBC","defff3d81be91b23":"c2cDw"}],"irm8l":[function(require,module,exports,__globalThis) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"lV1BE","9a831e81e9a1f98c":"blGac","1a2b6c8a7399c39f":"h2eS8"}],"blGac":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"h2eS8":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"bjRBC":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"c2cDw":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"7eeNO":[function(require,module,exports,__globalThis) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"crlKT","dbf6aa5033a0f48":"eHExv","539966708f906e61":"evtiM","8142d4017f0a425f":"cXMUl","48cddf732eff33ba":"7z4fi","9dc78b26c5daba20":"lxNlE"}],"7z4fi":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"lxNlE":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"kyaB8":[function(require,module,exports,__globalThis) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"lOHy9"}],"eEnTQ":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"6mRk0","94ffded3a85af2f6":"9qKxr"}],"6mRk0":[function(require,module,exports,__globalThis) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"6hgJK"}],"18Sgh":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"flZVA":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"hrIE8","d5ca180f7d6f956a":"dBTJh","3462bb3f546fa1f7":"105Hu","f5fef07966a1c4ee":"c7lh2","2a1cd212d48516":"6mRk0","885e72ee7fc6d296":"18Sgh","cd65eaf4a3af29f6":"b5swP"}],"105Hu":[function(require,module,exports,__globalThis) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"fdP9g","b0aefd36de99e579":"7O6Cp"}],"fdP9g":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"7O6Cp":[function(require,module,exports,__globalThis) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"1tEcE","47ffafdab3ba0d6f":"bpegN","93ebd263ff0131c1":"1DVeR","252ef74480e01958":"bxLaX","23c2f64e75e90a2":"aFNSq","af5ade297cb685ee":"b5swP"}],"bSOBT":[function(require,module,exports,__globalThis) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"fzLOJ","abf31da39349df22":"f5Egk","a387ef4a4373de2c":"c7lh2","9315973458389ae7":"b5swP"}],"fzLOJ":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"f5Egk":[function(require,module,exports,__globalThis) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"5Vkba"}],"jCwMn":[function(require,module,exports,__globalThis) {
var createWrap = require("d8337f5753aaeac9"), flatRest = require("2580769a56732128");
/** Used to compose bitmasks for function metadata. */ var WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var rearg = flatRest(function(func, indexes) {
    return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = rearg;

},{"d8337f5753aaeac9":"yelhl","2580769a56732128":"j0z0i"}],"6Z7Je":[function(require,module,exports,__globalThis) {
var arrayMap = require("7ba7869940617745"), copyArray = require("8a8afdd7f66c30d3"), isArray = require("1326c29ab72d9c5a"), isSymbol = require("a182054f85505cf4"), stringToPath = require("e75722fcac9a080"), toKey = require("43c6affe82c9fa11"), toString = require("b80a77da9aba90a8");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function toPath(value) {
    if (isArray(value)) return arrayMap(value, toKey);
    return isSymbol(value) ? [
        value
    ] : copyArray(stringToPath(toString(value)));
}
module.exports = toPath;

},{"7ba7869940617745":"chzeu","8a8afdd7f66c30d3":"lWbYv","1326c29ab72d9c5a":"1DVeR","a182054f85505cf4":"fMaHV","e75722fcac9a080":"6K5tB","43c6affe82c9fa11":"b5swP","b80a77da9aba90a8":"iEDGT"}],"7Gazm":[function(require,module,exports,__globalThis) {
var baseSlice = require("88b6483542ea1f55"), toInteger = require("e5707388140bdea");
/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */ function drop(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    n = guard || n === undefined ? 1 : toInteger(n);
    return baseSlice(array, n < 0 ? 0 : n, length);
}
module.exports = drop;

},{"88b6483542ea1f55":"7H7oa","e5707388140bdea":"fCKw5"}],"lRr4P":[function(require,module,exports,__globalThis) {
var convert = require("d5be53e890d63df3"), func = convert('omit', require("da4242b56288b18d"));
func.placeholder = require("f16d7b9917d65e9a");
module.exports = func;

},{"d5be53e890d63df3":"8yrvu","da4242b56288b18d":"fhxvC","f16d7b9917d65e9a":"6JeHm"}],"9J59L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _eventManagerContainer = require("./EventManagerContainer");
var _streamManagerContainer = require("./StreamManagerContainer");
var _networkManagerContainer = require("./NetworkManagerContainer");
var _utils = require("../../utils");
var _mixpanel = require("../../mixpanel");
var _types = require("common/api/v1/types");
var _confirmDialog = require("../common/ConfirmDialog");
var _contentDialog = require("../common/ContentDialog");
var _reactHelmetAsync = require("react-helmet-async");
const LoggedIn = ()=>{
    const user = (0, _utils.useUser)();
    (0, _mixpanel.mixpanel).addUserInfo(user);
    (0, _mixpanel.usePageTracking)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHelmetAsync.HelmetProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDialog.ConfirmDialogProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentDialog.ContentDialogProvider), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                            path: `${(0, _routes.ROUTES).stream}/*`,
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _streamManagerContainer.StreamManagerContainer), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                            path: `${(0, _routes.ROUTES).events}/*`,
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventManagerContainer.EventManagerContainer), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                            path: "/*",
                            element: user.role === (0, _types.Role).basic ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Navigate), {
                                to: (0, _routes.ROUTES).stream,
                                replace: true
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkManagerContainer.NetworkManagerContainer), {})
                        })
                    ]
                })
            })
        })
    });
};
exports.default = LoggedIn;

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","./EventManagerContainer":"e8iP1","./StreamManagerContainer":"h0485","./NetworkManagerContainer":"g2VXu","../../utils":"342UB","../../mixpanel":"7xxdr","common/api/v1/types":"3qemx","../common/ConfirmDialog":"7JKPn","../common/ContentDialog":"5kpCR","react-helmet-async":"grBm0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e8iP1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventManagerContainer", ()=>EventManagerContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _container = require("@mui/material/Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _alarmsActions = require("../../redux/actions/alarmsActions");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _emsidebar = require("../partials/EMSidebar");
var _errorBoundary = require("../common/ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _eventPage = require("../events/EventPage");
var _profile = require("../profile");
const EventManagerContainer = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _alarmsActions.readAlarmsInBackground)({}));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            sx: {
                height: '100vh',
                width: '100vw',
                display: 'flex'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emsidebar.EMSidebar), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _containerDefault.default), {
                        component: "main",
                        maxWidth: false,
                        sx: {
                            overflowX: 'auto'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventPage.EventPage), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: (0, _routes.ROUTES).profile,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profile.Profile), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","@mui/material/Box":"c4QkF","@mui/material/Container":"376wa","../../redux/actions/alarmsActions":"2PZQF","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","../partials/EMSidebar":"4n8dE","../common/ErrorBoundary":"44DTp","../events/EventPage":"3FxKD","../profile":"dfRs7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Msr5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFound", ()=>NotFound);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _wrapper = require("./Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
const NotFound = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: "Not Found",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            children: "Sorry, the page you are looking for is not available."
        })
    });

},{"react/jsx-runtime":"1dlk8","@mui/material/Typography":"6NtGx","./Wrapper":"8oy7r","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8oy7r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _appBar = require("@mui/material/AppBar");
var _appBarDefault = parcelHelpers.interopDefault(_appBar);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _menu = require("@mui/icons-material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _uiActions = require("../../redux/actions/uiActions");
var _utils = require("../../utils");
var _store = require("../../store");
var _constants = require("common/constants");
var _common = require("../../themes/common");
var _breadcrumbs = require("@mui/material/Breadcrumbs");
var _breadcrumbsDefault = parcelHelpers.interopDefault(_breadcrumbs);
var _link = require("./Link");
var _helpers = require("common/api/v1/helpers");
var _reactRouter = require("react-router");
var _pageTitle = require("./PageTitle");
// Find the parent path for the breadcrumbs
function getParentPath(routesList, pathname, entityIndex) {
    function getRawParentPath() {
        // do not link the breadcrumb for the service overview since there is no parent
        if (pathname.startsWith('/service')) return null;
        const parts = pathname.split('/').filter(Boolean);
        let countOfParentParts = entityIndex + 1;
        // settings menu is separate so we need to keep it in the path
        if (parts[0] === 'settings') countOfParentParts++;
        return `/${parts.slice(0, countOfParentParts).join('/')}`;
    }
    const rawParentPath = getRawParentPath();
    if (!rawParentPath) return null;
    // We need to match the parent path with the routes from redux store to get the correct filter params
    const parentPathWithFilterParams = routesList.find((route)=>{
        const routeWithoutQueryParams = route.split('?')[0];
        // search for an exact match in the route list (without query params) and return the one that matches
        return (0, _reactRouter.matchPath)({
            path: routeWithoutQueryParams,
            end: true
        }, rawParentPath);
    });
    return parentPathWithFilterParams ?? rawParentPath;
}
function BreadcrumbWrapper({ entities }) {
    const { pathname } = (0, _reactRouter.useLocation)();
    const routes = (0, _store.useRoutes)();
    const routesList = (0, _react.useMemo)(()=>{
        return Object.values(routes).map((routeFunc)=>routeFunc());
    }, [
        routes
    ]);
    const separator = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        component: "h1",
        variant: "h2",
        color: "inherit",
        noWrap: true,
        children: "/"
    }, "separator");
    const genBreadcrumbTextElement = (text, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            "data-testid": `breadcrumb-${index}-text`,
            component: "h1",
            variant: "h2",
            color: "inherit",
            noWrap: true,
            children: text
        }, `breadcrumb-${text}`);
    const genBreadcrumbLinkElement = (text, link, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            "data-testid": `breadcrumb-${index}-link`,
            underline: "hover",
            to: link,
            children: genBreadcrumbTextElement(text, index)
        }, `breadcrumb-${text}-link`);
    const genBreadcrumbElement = (listLength, text, index)=>{
        if (index < listLength - 1) {
            const parentPath = getParentPath(routesList, pathname, index);
            if (parentPath) return genBreadcrumbLinkElement(text, parentPath, index);
        }
        return genBreadcrumbTextElement(text, index);
    };
    // make all the breadcrumbs link except the last one
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breadcrumbsDefault.default), {
        sx: {
            color: 'inherit'
        },
        separator: separator,
        "aria-label": "breadcrumb",
        children: entities.map((text, index)=>genBreadcrumbElement(entities.length, text, index))
    });
}
const LicenseWarning = ({ daysUntilLicenseExpires })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            textAlign: 'center',
            margin: '0 -24px',
            padding: '12px',
            fontSize: '20px',
            backgroundColor: ((0, _common.defaultCommon).palette?.error).main ?? 'red'
        },
        children: daysUntilLicenseExpires >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "The license will expire in ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                    children: daysUntilLicenseExpires
                }),
                " day(s)"
            ]
        }) : 'The license has expired'
    });
/**
 * Common wrapper for edge manager page content
 * @param name - the entities of the page (could be a string or an array)
 * @param isStreamManager - true for Stream Manager.
 * @param children - content of the page
 */ const Wrapper = ({ name, isStreamManager, children, actions, fullWidth })=>{
    // Styles to be applied on the <Pagination> component's closest scrollable ancestor
    // in order to make it able to float/be sticky.
    const floatingPaginationStyles = {
        position: 'relative',
        height: '100%',
        width: '100%',
        ...fullWidth ? {} : {
            maxWidth: '1920px'
        }
    };
    // Ensure that name is an array of strings, and remove undefined child entities
    const entities = (Array.isArray(name) ? name : [
        name
    ]).filter((0, _helpers.notUndefinedOrNull));
    const dispatch = (0, _reactRedux.useDispatch)();
    const ToggleSidebarMenuAction = ()=>dispatch((0, _uiActions.toggleSidebarMenu)());
    const { settings } = (0, _utils.useSettingsSelector)();
    const entitlements = settings?.entitlements;
    let daysUntilLicenseExpires = Infinity;
    if (entitlements && entitlements.product === (0, _constants.PRODUCTS).connectIt.id) {
        if (entitlements.expiresAt) {
            const now = new Date();
            daysUntilLicenseExpires = Math.floor((entitlements.expiresAt.getTime() - now.getTime()) / 86400000);
        }
    }
    const showLicenseWarning = entitlements?.product === (0, _constants.PRODUCTS).connectIt.id && !isStreamManager && daysUntilLicenseExpires <= 14;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageTitle.PageTitle), {
                title: entities.toReversed().join(' - ')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                style: floatingPaginationStyles,
                children: [
                    showLicenseWarning && entitlements.expiresAt && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LicenseWarning, {
                        daysUntilLicenseExpires: daysUntilLicenseExpires
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appBarDefault.default), {
                        position: "relative",
                        "data-test-id": "app-bar",
                        color: "transparent",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
                            disableGutters: true,
                            children: [
                                !isStreamManager ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                    "data-test-id": "toggle-sidebar-btn",
                                    edge: "start",
                                    color: "inherit",
                                    "aria-label": "Toggle sidebar",
                                    onClick: ToggleSidebarMenuAction,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {})
                                }) : null,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbWrapper, {
                                    entities: entities
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    sx: {
                                        flexGrow: 1
                                    }
                                }),
                                actions
                            ]
                        })
                    }),
                    children
                ]
            })
        ]
    });
};
exports.default = Wrapper;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/AppBar":"6sika","@mui/material/Box":"c4QkF","@mui/material/Toolbar":"5Kohb","@mui/material/IconButton":"488As","@mui/material/Typography":"6NtGx","@mui/icons-material/Menu":"cjVda","../../redux/actions/uiActions":"aO8kk","../../utils":"342UB","../../store":"5LXiG","common/constants":"bdiC1","../../themes/common":"e6yiH","@mui/material/Breadcrumbs":"gqEKl","./Link":"l3o6V","common/api/v1/helpers":"6jovr","react-router":"iaz4C","./PageTitle":"5VKx3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6sika":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("f898a98e8f691c41").default;
var _interopRequireDefault = require("240e265c09a60138").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    appBarClasses: true
};
Object.defineProperty(exports, "appBarClasses", {
    enumerable: true,
    get: function() {
        return _appBarClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _AppBar.default;
    }
});
var _AppBar = _interopRequireDefault(require("ed009feba4fe1c51"));
var _appBarClasses = _interopRequireWildcard(require("9826e612764930ae"));
Object.keys(_appBarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _appBarClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _appBarClasses[key];
        }
    });
});

},{"f898a98e8f691c41":"fiRIh","240e265c09a60138":"kZ6eK","ed009feba4fe1c51":"5Ugng","9826e612764930ae":"2TlOr"}],"5Ugng":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7c06ce0eb9f30608").default;
var _interopRequireWildcard = require("1ebbbd635194a424").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("1a15bbfea64ee1e8"));
var _propTypes = _interopRequireDefault(require("2ab590b32eb14ddc"));
var _clsx = _interopRequireDefault(require("63577695a0707767"));
var _composeClasses = _interopRequireDefault(require("ed5b50839f7d96db"));
var _zeroStyled = require("e342e5dac071e291");
var _memoTheme = _interopRequireDefault(require("9e131632f28f58db"));
var _DefaultPropsProvider = require("324691819f23ddd6");
var _capitalize = _interopRequireDefault(require("ba82cdb8cc21c32a"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("81c49b4034eca33"));
var _Paper = _interopRequireDefault(require("9394a2804053213d"));
var _appBarClasses = require("b17a151b23cc9900");
var _jsxRuntime = require("2208d5dc35e82dd3");
const useUtilityClasses = (ownerState)=>{
    const { color, position, classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalize.default)(color)}`,
            `position${(0, _capitalize.default)(position)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _appBarClasses.getAppBarUtilityClass, classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const joinVars = (var1, var2)=>var1 ? `${var1?.replace(')', '')}, ${var2})` : var2;
const AppBarRoot = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, _capitalize.default)(ownerState.position)}`],
            styles[`color${(0, _capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: 'fixed'
                },
                style: {
                    position: 'fixed',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0,
                    '@media print': {
                        // Prevent the app bar to be visible on each printed page.
                        position: 'absolute'
                    }
                }
            },
            {
                props: {
                    position: 'absolute'
                },
                style: {
                    position: 'absolute',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'sticky'
                },
                style: {
                    position: 'sticky',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'static'
                },
                style: {
                    position: 'static'
                }
            },
            {
                props: {
                    position: 'relative'
                },
                style: {
                    position: 'relative'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    '--AppBar-color': 'inherit'
                }
            },
            {
                props: {
                    color: 'default'
                },
                style: {
                    '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles('dark', {
                        '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        '--AppBar-background': (theme.vars ?? theme).palette[color].main,
                        '--AppBar-color': (theme.vars ?? theme).palette[color].contrastText
                    }
                })),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars ? joinVars(theme.vars.palette.AppBar.darkBg, 'var(--AppBar-background)') : null,
                        color: theme.vars ? joinVars(theme.vars.palette.AppBar.darkColor, 'var(--AppBar-color)') : null
                    })
                }
            },
            {
                props: {
                    color: 'transparent'
                },
                style: {
                    '--AppBar-background': 'transparent',
                    '--AppBar-color': 'inherit',
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundImage: 'none'
                    })
                }
            }
        ]
    })));
const AppBar = /*#__PURE__*/ React.forwardRef(function AppBar(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className, color = 'primary', enableColorOnDark = false, position = 'fixed', ...other } = props;
    const ownerState = {
        ...props,
        color,
        position,
        enableColorOnDark
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, _clsx.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref,
        ...other
    });
});
var _default = exports.default = AppBar;

},{"7c06ce0eb9f30608":"kZ6eK","1ebbbd635194a424":"fiRIh","1a15bbfea64ee1e8":"9njXz","2ab590b32eb14ddc":"bnNSm","63577695a0707767":"d2NWs","ed5b50839f7d96db":"59Equ","e342e5dac071e291":"hZXDo","9e131632f28f58db":"cJNjb","324691819f23ddd6":"9bD8g","ba82cdb8cc21c32a":"eOYSA","81c49b4034eca33":"2r5WG","9394a2804053213d":"aexCI","b17a151b23cc9900":"2TlOr","2208d5dc35e82dd3":"1dlk8"}],"2TlOr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("de62556dd4e876d2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getAppBarUtilityClass = getAppBarUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("38084c6ec3ebb63e"));
var _generateUtilityClass = _interopRequireDefault(require("81923c5a9fc1fcc6"));
function getAppBarUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiAppBar', slot);
}
const appBarClasses = (0, _generateUtilityClasses.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var _default = exports.default = appBarClasses;

},{"de62556dd4e876d2":"kZ6eK","38084c6ec3ebb63e":"7pSUk","81923c5a9fc1fcc6":"jBs9M"}],"5Kohb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c1b27002c760bcdf").default;
var _interopRequireDefault = require("490cbdc4190c381a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    toolbarClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Toolbar.default;
    }
});
Object.defineProperty(exports, "toolbarClasses", {
    enumerable: true,
    get: function() {
        return _toolbarClasses.default;
    }
});
var _Toolbar = _interopRequireDefault(require("fee9812ae7bba44d"));
var _toolbarClasses = _interopRequireWildcard(require("ac6cbeecbb0ab45c"));
Object.keys(_toolbarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _toolbarClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _toolbarClasses[key];
        }
    });
});

},{"c1b27002c760bcdf":"fiRIh","490cbdc4190c381a":"kZ6eK","fee9812ae7bba44d":"6IVv9","ac6cbeecbb0ab45c":"fEwvj"}],"6IVv9":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("68ece5178bb82886").default;
var _interopRequireWildcard = require("d031ef24fda2fa46").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("ec4b6b2b2b8bb8d8"));
var _propTypes = _interopRequireDefault(require("933f90c412fff195"));
var _clsx = _interopRequireDefault(require("abe395dd8545372b"));
var _composeClasses = _interopRequireDefault(require("d40f4ba9c19319c5"));
var _zeroStyled = require("b0ed4f370b15005d");
var _memoTheme = _interopRequireDefault(require("b23e1f05c089fab7"));
var _DefaultPropsProvider = require("20f1655251ccdecc");
var _toolbarClasses = require("f2d0c4e6cbd55b7c");
var _jsxRuntime = require("43c63ac31138fba3");
const useUtilityClasses = (ownerState)=>{
    const { classes, disableGutters, variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, _composeClasses.default)(slots, _toolbarClasses.getToolbarUtilityClass, classes);
};
const ToolbarRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const Toolbar = /*#__PURE__*/ React.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className, component = 'div', disableGutters = false, variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component,
        disableGutters,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToolbarRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var _default = exports.default = Toolbar;

},{"68ece5178bb82886":"kZ6eK","d031ef24fda2fa46":"fiRIh","ec4b6b2b2b8bb8d8":"9njXz","933f90c412fff195":"bnNSm","abe395dd8545372b":"d2NWs","d40f4ba9c19319c5":"59Equ","b0ed4f370b15005d":"hZXDo","b23e1f05c089fab7":"cJNjb","20f1655251ccdecc":"9bD8g","f2d0c4e6cbd55b7c":"fEwvj","43c63ac31138fba3":"1dlk8"}],"fEwvj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("80c0bb79f3eee579").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getToolbarUtilityClass = getToolbarUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("35919266533ff342"));
var _generateUtilityClass = _interopRequireDefault(require("39100a78bda009e4"));
function getToolbarUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiToolbar', slot);
}
const toolbarClasses = (0, _generateUtilityClasses.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var _default = exports.default = toolbarClasses;

},{"80c0bb79f3eee579":"kZ6eK","35919266533ff342":"7pSUk","39100a78bda009e4":"jBs9M"}],"cjVda":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("1a2787d0d84e43df").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b37f83d3ef950822"));
var _jsxRuntime = require("cebdb6f22315edc5");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');

},{"1a2787d0d84e43df":"kZ6eK","b37f83d3ef950822":"2vOnF","cebdb6f22315edc5":"1dlk8"}],"e6yiH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NimbraGreyLight", ()=>NimbraGreyLight);
parcelHelpers.export(exports, "NimbraGreyDark", ()=>NimbraGreyDark);
parcelHelpers.export(exports, "NimbraBlueLight", ()=>NimbraBlueLight);
parcelHelpers.export(exports, "NimbraBlueDark", ()=>NimbraBlueDark);
parcelHelpers.export(exports, "NimbraGrey", ()=>NimbraGrey);
parcelHelpers.export(exports, "NimbraBlue", ()=>NimbraBlue);
parcelHelpers.export(exports, "defaultCommon", ()=>defaultCommon);
const NimbraGreyLight = {
    50: '#E6EDFA',
    100: '#E1E8F6',
    200: '#DBE2EF',
    300: '#CED5E2',
    400: '#AEB5C2',
    500: '#9198A6',
    600: '#6C7280',
    700: '#59606E',
    800: '#3D4451',
    900: '#202631',
    1000: '#14161A'
};
const NimbraGreyDark = {
    50: '#E6EDFA',
    100: '#E1E8F6',
    200: '#DBE2EF',
    300: '#CED5E2',
    400: '#AEB5C2',
    500: '#9198A6',
    600: '#6C7280',
    700: '#59606E',
    800: '#3D4451',
    900: '#202631',
    1000: '#14161A'
};
const NimbraBlueLight = {
    50: '#E0ECFD',
    100: '#B2D1FF',
    200: '#7EAEF7',
    300: '#448AFA',
    400: '#1F71FF',
    500: '#0055FF',
    600: '#0041E5',
    700: '#0730C5',
    800: '#001EAA',
    900: '#052159'
};
const NimbraBlueDark = {
    50: '#E7EDF6',
    100: '#C1D4F0',
    200: '#9AB4DB',
    300: '#6A93D4',
    400: '#4B7DD2',
    500: '#3366CC',
    600: '#2E55B7',
    700: '#30479C',
    800: '#223488',
    900: '#182746'
};
const NimbraGrey = NimbraGreyDark;
const NimbraBlue = NimbraBlueDark;
const hStyles = [
    36,
    25,
    20,
    18,
    16,
    14
].reduce((acc, item, ind)=>({
        ...acc,
        [`h${ind + 1}`]: {
            fontFamily: "'Nunito Sans', sans-serif",
            fontWeight: 'bold',
            fontSize: `${item}px`,
            lineHeight: 1.6
        }
    }), {});
const defaultCommon = {
    palette: {
        primary: {
            main: NimbraBlue[500],
            light: NimbraBlue[300],
            dark: NimbraBlue[900]
        },
        secondary: {
            main: NimbraBlue[400],
            light: NimbraBlue[200],
            dark: NimbraBlue[800]
        },
        error: {
            main: '#D4626F',
            dark: '#C0767E',
            light: '#E84E5F'
        },
        success: {
            main: '#79D0B7',
            dark: '#8BBEAF',
            light: '#67E2BF'
        },
        warning: {
            main: '#E8CD5C',
            dark: '#D5C16F',
            light: '#FAD84A'
        },
        contrastThreshold: 3,
        grey: NimbraGrey
    },
    typography: {
        ...hStyles,
        fontFamily: "'Roboto', sans-serif"
    },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: NimbraGrey[700]
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                docked: {
                    width: 240
                },
                paperAnchorLeft: {
                    width: 240,
                    zIndex: 'unset'
                },
                paperAnchorRight: {
                    width: 240,
                    zIndex: 'unset'
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: 'none'
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: `1px solid ${NimbraGreyLight[800]}`
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                regular: {
                    zIndex: 'unset'
                }
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gqEKl":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("6fa0bc2258c5acf1").default;
var _interopRequireDefault = require("535d5ee8d1f7ae00").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    breadcrumbsClasses: true
};
Object.defineProperty(exports, "breadcrumbsClasses", {
    enumerable: true,
    get: function() {
        return _breadcrumbsClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Breadcrumbs.default;
    }
});
var _Breadcrumbs = _interopRequireDefault(require("39eb954a468880ae"));
var _breadcrumbsClasses = _interopRequireWildcard(require("f2b82ac34be63b31"));
Object.keys(_breadcrumbsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _breadcrumbsClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _breadcrumbsClasses[key];
        }
    });
});

},{"6fa0bc2258c5acf1":"fiRIh","535d5ee8d1f7ae00":"kZ6eK","39eb954a468880ae":"gZ8Ql","f2b82ac34be63b31":"kpxUH"}],"gZ8Ql":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c57171f4c4b92f11").default;
var _interopRequireWildcard = require("9899f452b655a9a3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("fb511c742edae720"));
var _reactIs = require("ced7b0ff80fcf973");
var _propTypes = _interopRequireDefault(require("64b1e7739fb89804"));
var _clsx = _interopRequireDefault(require("2b2483763888cb17"));
var _integerPropType = _interopRequireDefault(require("3b66e4f245f7439d"));
var _composeClasses = _interopRequireDefault(require("7b2c882a0d41649a"));
var _useSlotProps = _interopRequireDefault(require("b5ee777d753a3360"));
var _zeroStyled = require("4a6b405695e047e1");
var _DefaultPropsProvider = require("6efdbe03fe725663");
var _Typography = _interopRequireDefault(require("c97b10c4c5a0d86a"));
var _BreadcrumbCollapsed = _interopRequireDefault(require("89e871757650c7e4"));
var _breadcrumbsClasses = _interopRequireWildcard(require("5f14dba7fdb06593"));
var _jsxRuntime = require("9311efb83bd1c098");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        li: [
            'li'
        ],
        ol: [
            'ol'
        ],
        separator: [
            'separator'
        ]
    };
    return (0, _composeClasses.default)(slots, _breadcrumbsClasses.getBreadcrumbsUtilityClass, classes);
};
const BreadcrumbsRoot = (0, _zeroStyled.styled)(_Typography.default, {
    name: 'MuiBreadcrumbs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${_breadcrumbsClasses.default.li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const BreadcrumbsOl = (0, _zeroStyled.styled)('ol', {
    name: 'MuiBreadcrumbs',
    slot: 'Ol'
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
const BreadcrumbsSeparator = (0, _zeroStyled.styled)('li', {
    name: 'MuiBreadcrumbs',
    slot: 'Separator'
})({
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
});
function insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const Breadcrumbs = /*#__PURE__*/ React.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiBreadcrumbs'
    });
    const { children, className, component = 'nav', slots = {}, slotProps = {}, expandText = 'Show path', itemsAfterCollapse = 1, itemsBeforeCollapse = 1, maxItems = 8, separator = '/', ...other } = props;
    const [expanded, setExpanded] = React.useState(false);
    const ownerState = {
        ...props,
        component,
        expanded,
        expandText,
        itemsAfterCollapse,
        itemsBeforeCollapse,
        maxItems,
        separator
    };
    const classes = useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, _useSlotProps.default)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState
    });
    const listRef = React.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BreadcrumbCollapsed.default, {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = React.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ React.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbsRoot, {
        ref: ref,
        component: component,
        color: "textSecondary",
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    });
});
var _default = exports.default = Breadcrumbs;

},{"c57171f4c4b92f11":"kZ6eK","9899f452b655a9a3":"fiRIh","fb511c742edae720":"9njXz","ced7b0ff80fcf973":"bmrco","64b1e7739fb89804":"bnNSm","2b2483763888cb17":"d2NWs","3b66e4f245f7439d":"iZJbi","7b2c882a0d41649a":"59Equ","b5ee777d753a3360":"kr4RG","4a6b405695e047e1":"hZXDo","6efdbe03fe725663":"9bD8g","c97b10c4c5a0d86a":"6NtGx","89e871757650c7e4":"8y44j","5f14dba7fdb06593":"kpxUH","9311efb83bd1c098":"1dlk8"}],"8y44j":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("df5d483e4df224d1").default;
var _interopRequireWildcard = require("8a8da5d92d45a9e9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("1920a69797e12858"));
var _propTypes = _interopRequireDefault(require("87f5168a58dfdc5c"));
var _colorManipulator = require("36acfabf73ee69da");
var _zeroStyled = require("fab790e46ce7f534");
var _memoTheme = _interopRequireDefault(require("c966a27889f56778"));
var _MoreHoriz = _interopRequireDefault(require("8c3deda25f02b6fe"));
var _ButtonBase = _interopRequireDefault(require("df1bd6c31379ade7"));
var _jsxRuntime = require("708d8c083f30c45e");
const BreadcrumbCollapsedButton = (0, _zeroStyled.styled)(_ButtonBase.default)((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`,
        ...theme.palette.mode === 'light' ? {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.grey[700]
        } : {
            backgroundColor: theme.palette.grey[700],
            color: theme.palette.grey[100]
        },
        borderRadius: 2,
        '&:hover, &:focus': {
            ...theme.palette.mode === 'light' ? {
                backgroundColor: theme.palette.grey[200]
            } : {
                backgroundColor: theme.palette.grey[600]
            }
        },
        '&:active': {
            boxShadow: theme.shadows[0],
            ...theme.palette.mode === 'light' ? {
                backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.grey[200], 0.12)
            } : {
                backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.grey[600], 0.12)
            }
        }
    })));
const BreadcrumbCollapsedIcon = (0, _zeroStyled.styled)(_MoreHoriz.default)({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function BreadcrumbCollapsed(props) {
    const { slots = {}, slotProps = {}, ...otherProps } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbCollapsedButton, {
            focusRipple: true,
            ...otherProps,
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbCollapsedIcon, {
                as: slots.CollapsedIcon,
                ownerState: ownerState,
                ...slotProps.collapsedIcon
            })
        })
    });
}
var _default = exports.default = BreadcrumbCollapsed;

},{"df5d483e4df224d1":"kZ6eK","8a8da5d92d45a9e9":"fiRIh","1920a69797e12858":"9njXz","87f5168a58dfdc5c":"bnNSm","36acfabf73ee69da":"hTYBL","fab790e46ce7f534":"hZXDo","c966a27889f56778":"cJNjb","8c3deda25f02b6fe":"3M0xm","df1bd6c31379ade7":"7X8rf","708d8c083f30c45e":"1dlk8"}],"3M0xm":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("dfb460bba940a4dc").default;
var _interopRequireWildcard = require("7584d61263358cc0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e97952542cf8b72a"));
var _createSvgIcon = _interopRequireDefault(require("3dd17aa277559cc2"));
var _jsxRuntime = require("d703c54673bf2b48");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');

},{"dfb460bba940a4dc":"kZ6eK","7584d61263358cc0":"fiRIh","e97952542cf8b72a":"9njXz","3dd17aa277559cc2":"5sni0","d703c54673bf2b48":"1dlk8"}],"kpxUH":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4a26dc136182d12d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getBreadcrumbsUtilityClass = getBreadcrumbsUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("5a4076c2f5d43d60"));
var _generateUtilityClass = _interopRequireDefault(require("817e0225e27fec"));
function getBreadcrumbsUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiBreadcrumbs', slot);
}
const breadcrumbsClasses = (0, _generateUtilityClasses.default)('MuiBreadcrumbs', [
    'root',
    'ol',
    'li',
    'separator'
]);
var _default = exports.default = breadcrumbsClasses;

},{"4a26dc136182d12d":"kZ6eK","5a4076c2f5d43d60":"7pSUk","817e0225e27fec":"jBs9M"}],"l3o6V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "ExternalLink", ()=>ExternalLink);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _mixpanel = require("../../mixpanel");
const classes = {
    link: ({ underline })=>({
            textDecoration: underline === 'always' ? 'underline' : 'none',
            '&:hover': {
                color: 'inherit',
                textDecoration: underline === 'none' ? 'none' : 'underline'
            }
        })
};
const Link = ({ underline = 'none', children, muiStyle, style, available = true, to, trackEvent, ...rest })=>{
    if (!available || to === '') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: children
    });
    const handleClick = ()=>{
        if (trackEvent) (0, _mixpanel.mixpanel).trackClickLink({
            ...trackEvent,
            to
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
        "data-testid": `routerlink-${to}`,
        ...rest,
        to: to,
        style: {
            ...classes.link({
                underline
            }),
            ...style || {}
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            underline: underline,
            component: "span",
            sx: muiStyle,
            onClick: handleClick,
            children: children
        })
    });
};
const ExternalLink = ({ underline = 'none', trackEvent, children, ...rest })=>{
    const handleClick = (...args)=>{
        if (trackEvent && rest.href) (0, _mixpanel.mixpanel).trackClickLink({
            ...trackEvent,
            to: rest.href
        });
        rest.onClick?.(...args);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
        rel: "noopener noreferrer",
        target: "_blank",
        underline: underline,
        sx: classes.link({
            underline
        }),
        onClick: handleClick,
        ...rest,
        children: children
    });
};
const NavLink = ({ underline = 'none', children, muiStyle, trackEvent, ...rest })=>{
    const handleClick = ()=>{
        if (trackEvent) (0, _mixpanel.mixpanel).trackClickLink({
            ...trackEvent,
            to: rest.to
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.NavLink), {
        ...rest,
        style: classes.link({
            underline
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            underline: underline,
            component: "span",
            sx: muiStyle,
            onClick: handleClick,
            children: children
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","@mui/material/Link":"chNUC","../../mixpanel":"7xxdr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chNUC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("6040c90003045440").default;
var _interopRequireDefault = require("c6111948769affed").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    linkClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Link.default;
    }
});
Object.defineProperty(exports, "linkClasses", {
    enumerable: true,
    get: function() {
        return _linkClasses.default;
    }
});
var _Link = _interopRequireDefault(require("6cd297db75591f2e"));
var _linkClasses = _interopRequireWildcard(require("d74358dcf739001"));
Object.keys(_linkClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _linkClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _linkClasses[key];
        }
    });
});

},{"6040c90003045440":"fiRIh","c6111948769affed":"kZ6eK","6cd297db75591f2e":"a0kV0","d74358dcf739001":"bQk4m"}],"a0kV0":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("6a8702ee983cdc0f").default;
var _interopRequireWildcard = require("d5c1f56b0d196e7e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("5084621daafdd449"));
var _propTypes = _interopRequireDefault(require("73183298bbefbe91"));
var _clsx = _interopRequireDefault(require("e9c3dd8b5f3f6681"));
var _colorManipulator = require("86f3927a7ba86b5c");
var _elementTypeAcceptingRef = _interopRequireDefault(require("58fbb5141abfc7f4"));
var _composeClasses = _interopRequireDefault(require("d0980a32ff29c2f3"));
var _isFocusVisible = _interopRequireDefault(require("4b12f0ffc99e31a5"));
var _capitalize = _interopRequireDefault(require("c9d112d421e89ca6"));
var _zeroStyled = require("476b6bf09087296");
var _memoTheme = _interopRequireDefault(require("150a467f18203e05"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("dc92d2906e969d10"));
var _DefaultPropsProvider = require("2213755a1de3f97e");
var _Typography = _interopRequireDefault(require("9b3fdb6047a1c994"));
var _linkClasses = _interopRequireWildcard(require("4bcfb393b9c8c8aa"));
var _getTextDecoration = _interopRequireDefault(require("e7890751a88c903"));
var _jsxRuntime = require("15bcda5c60ac4d87");
const v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const useUtilityClasses = (ownerState)=>{
    const { classes, component, focusVisible, underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, _capitalize.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, _composeClasses.default)(slots, _linkClasses.getLinkUtilityClass, classes);
};
const LinkRoot = (0, _zeroStyled.styled)(_Typography.default, {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, _capitalize.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline, ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color
                    },
                    style: {
                        '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.4)` : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.secondaryChannel} / 0.4)` : (0, _colorManipulator.alpha)(theme.palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${_linkClasses.default.focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const Link = /*#__PURE__*/ React.forwardRef(function Link(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, _zeroStyled.useTheme)();
    const { className, color = 'primary', component = 'a', onBlur, onFocus, TypographyClasses, underline = 'always', variant = 'inherit', sx, ...other } = props;
    const [focusVisible, setFocusVisible] = React.useState(false);
    const handleBlur = (event)=>{
        if (!(0, _isFocusVisible.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, _isFocusVisible.default)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color,
        component,
        focusVisible,
        underline,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkRoot, {
        color: color,
        className: (0, _clsx.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...v6Colors[color] === undefined ? [
                {
                    color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !v6Colors[color] && {
                '--Link-underlineColor': (0, _getTextDecoration.default)({
                    theme,
                    ownerState
                })
            }
        }
    });
});
var _default = exports.default = Link;

},{"6a8702ee983cdc0f":"kZ6eK","d5c1f56b0d196e7e":"fiRIh","5084621daafdd449":"9njXz","73183298bbefbe91":"bnNSm","e9c3dd8b5f3f6681":"d2NWs","86f3927a7ba86b5c":"hTYBL","58fbb5141abfc7f4":"40NoV","d0980a32ff29c2f3":"59Equ","4b12f0ffc99e31a5":"gHKhh","c9d112d421e89ca6":"eOYSA","476b6bf09087296":"hZXDo","150a467f18203e05":"cJNjb","dc92d2906e969d10":"2r5WG","2213755a1de3f97e":"9bD8g","9b3fdb6047a1c994":"6NtGx","4bcfb393b9c8c8aa":"bQk4m","e7890751a88c903":"iXnDs","15bcda5c60ac4d87":"1dlk8"}],"bQk4m":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c4f90aaff9a81ea6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getLinkUtilityClass = getLinkUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("69327a502f2ee111"));
var _generateUtilityClass = _interopRequireDefault(require("97ae0335acd0145c"));
function getLinkUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiLink', slot);
}
const linkClasses = (0, _generateUtilityClasses.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var _default = exports.default = linkClasses;

},{"c4f90aaff9a81ea6":"kZ6eK","69327a502f2ee111":"7pSUk","97ae0335acd0145c":"jBs9M"}],"iXnDs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _style = require("c01d75d0e353d500");
var _colorManipulator = require("4de575699bde6406");
const getTextDecoration = ({ theme, ownerState })=>{
    const transformedColor = ownerState.color;
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, _style.getPath)(theme, `palette.${transformedColor}.main`, false) || (0, _style.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, _style.getPath)(theme, `palette.${transformedColor}.mainChannel`) || (0, _style.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, _colorManipulator.alpha)(color, 0.4);
};
var _default = exports.default = getTextDecoration;

},{"c01d75d0e353d500":"fiOnV","4de575699bde6406":"hTYBL"}],"5VKx3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageTitle", ()=>PageTitle);
var _jsxRuntime = require("react/jsx-runtime");
var _constants = require("common/constants");
var _react = require("react");
var _reactHelmetAsync = require("react-helmet-async");
var _utils = require("../../utils");
const defaultProductName = (0, _constants.PRODUCTS).nimbraEdge.name;
const PageTitle = ({ title })=>{
    const { settings } = (0, _utils.useSettingsSelector)();
    const [productName, setProductName] = (0, _react.useState)(window.document.title.split(' - ')[1] ?? defaultProductName);
    (0, _react.useEffect)(()=>{
        if (!settings) return;
        if (settings?.customTabTitle) {
            setProductName(settings.customTabTitle);
            return;
        }
        setProductName(defaultProductName);
    }, [
        settings
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHelmetAsync.Helmet), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("title", {
            children: [
                title,
                " - ",
                productName
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","common/constants":"bdiC1","react":"9njXz","react-helmet-async":"grBm0","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grBm0":[function(require,module,exports,__globalThis) {
// src/index.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Helmet", ()=>Helmet);
parcelHelpers.export(exports, "HelmetData", ()=>HelmetData);
parcelHelpers.export(exports, "HelmetProvider", ()=>HelmetProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
// src/constants.ts
var TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})(TAG_NAMES || {});
var SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var VALID_TAG_NAMES = Object.values(TAG_NAMES);
var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var HTML_TAG_MAP = Object.entries(REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var getTitleFromPropsList = (propsList)=>{
    let innermostTitle = getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var getOnChangeClientState = (propsList)=>getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var reducePropsToState = (propsList)=>({
        baseTag: getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: getAnyTrueFromPropsList(propsList, HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if (checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = generateElementAttributesAsString(attributes);
    const flattenedTitle = flattenArray(title);
    return attributeString ? `<${type} ${HELMET_ATTRIBUTE}="true" ${attributeString}>${encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${HELMET_ATTRIBUTE}="true">${encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [HELMET_ATTRIBUTE]: true
    };
    const props = convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, _reactDefault.default).createElement("title" /* TITLE */ , props, title)
    ];
};
var generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, _reactDefault.default).createElement(type, mappedTag);
    });
var getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>convertElementAttributesToReactProps(tags),
                toString: ()=>generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>generateTagsAsReactComponent(type, tags),
                toString: ()=>generateTagsAsString(type, tags, encode)
            };
    }
};
var getPriorityMethods = ({ metaTags, linkTags, scriptTags, encode })=>{
    const meta = prioritizer(metaTags, SEO_PRIORITY_TAGS.meta);
    const link = prioritizer(linkTags, SEO_PRIORITY_TAGS.link);
    const script = prioritizer(scriptTags, SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var mapStateOnServer = (props)=>{
    const { baseTag, bodyAttributes, encode = true, htmlAttributes, noscriptTags, styleTags, title = "", titleAttributes, prioritizeSeoTags } = props;
    let { linkTags, metaTags, scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>{},
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods, linkTags, metaTags, scriptTags } = getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: getMethodsForTag("title" /* TITLE */ , {
            title,
            titleAttributes
        }, encode)
    };
};
var server_default = mapStateOnServer;
// src/HelmetData.ts
var instances = [];
var isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var HelmetData = class {
    instances = [];
    canUseDOM = isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? instances : this.instances).indexOf(instance);
                (this.canUseDOM ? instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
// src/Provider.tsx
var defaultValue = {};
var Context = (0, _reactDefault.default).createContext(defaultValue);
var HelmetProvider = class _HelmetProvider extends (0, _react.Component) {
    static canUseDOM = isDocument;
    helmetData;
    constructor(props){
        super(props);
        this.helmetData = new HelmetData(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        return /* @__PURE__ */ (0, _reactDefault.default).createElement(Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute(HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags,
        newTags
    };
};
var updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute(HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = flattenArray(title);
    updateAttributes("title" /* TITLE */ , attributes);
};
var commitTagChanges = (newState, cb)=>{
    const { baseTag, bodyAttributes, htmlAttributes, linkTags, metaTags, noscriptTags, onChangeClientState, scriptTags, styleTags, title, titleAttributes } = newState;
    updateAttributes("body" /* BODY */ , bodyAttributes);
    updateAttributes("html" /* HTML */ , htmlAttributes);
    updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: updateTags("base" /* BASE */ , baseTag),
        linkTags: updateTags("link" /* LINK */ , linkTags),
        metaTags: updateTags("meta" /* META */ , metaTags),
        noscriptTags: updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags, oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var _helmetCallback = null;
var handleStateChangeOnClient = (newState)=>{
    if (_helmetCallback) cancelAnimationFrame(_helmetCallback);
    if (newState.defer) _helmetCallback = requestAnimationFrame(()=>{
        commitTagChanges(newState, ()=>{
            _helmetCallback = null;
        });
    });
    else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};
var client_default = handleStateChangeOnClient;
// src/Dispatcher.tsx
var HelmetDispatcher = class extends (0, _react.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, _shallowequalDefault.default)(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances, setHelmet } = this.props.context;
        let serverState = null;
        const state = reducePropsToState(helmetInstances.get().map((instance)=>{
            const props = {
                ...instance.props
            };
            delete props.context;
            return props;
        }));
        if (HelmetProvider.canUseDOM) client_default(state);
        else if (server_default) serverState = server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
// src/index.tsx
var Helmet = class extends (0, _react.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, _reactFastCompareDefault.default)(without(this.props, "helmetData"), without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, _invariantDefault.default)(VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, _invariantDefault.default)(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, _reactDefault.default).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof HelmetData)) {
            const data = helmetData;
            helmetData = new HelmetData(data.context, true);
            delete newProps.helmetData;
        }
        return helmetData ? /* @__PURE__ */ (0, _reactDefault.default).createElement(HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, _reactDefault.default).createElement(Context.Consumer, null, (context)=>/* @__PURE__ */ (0, _reactDefault.default).createElement(HelmetDispatcher, {
                ...newProps,
                context
            }));
    }
};

},{"react":"9njXz","react-fast-compare":"iL7zI","invariant":"eNRZI","shallowequal":"e670Y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iL7zI":[function(require,module,exports,__globalThis) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"eNRZI":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"e670Y":[function(require,module,exports,__globalThis) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"4n8dE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMSidebar", ()=>EMSidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _event = require("@mui/icons-material/Event");
var _eventDefault = parcelHelpers.interopDefault(_event);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _types = require("common/api/v1/types");
var _store = require("../../store");
var _tagsAction = require("../../redux/actions/tagsAction");
var _hooks = require("../../utils/hooks");
var _index = require("../common/SidebarMenu/index");
const showHover = {
    opacity: 0,
    '&:hover, .MuiStack-root:hover &': {
        opacity: 1
    }
};
const EMSidebar = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { searchHistory } = (0, _reactRedux.useSelector)(({ tagsReducer })=>tagsReducer, (0, _reactRedux.shallowEqual));
    const routes = (0, _store.useRoutes)();
    const { settings } = (0, _hooks.useSettingsSelector)();
    const handleDeleteSearchHistory = (e, tags)=>{
        e.preventDefault();
        dispatch((0, _tagsAction.deleteSearchHistory)(tags));
    };
    const defaultOrder = settings?.expFeatures?.ExtHealthAlarms ? (0, _types.ListOutputSortableField).healthStatus : undefined // 'healthStatus' for Input/Output
    ;
    const menuItems = ()=>[
            {
                name: 'Events',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventDefault.default), {}),
                children: searchHistory.map((tags)=>({
                        name: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                tags,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                    title: "Remove from search history",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                        size: "small",
                                        onClick: (ev)=>handleDeleteSearchHistory(ev, tags),
                                        sx: showHover,
                                        "aria-label": "Delete history",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {
                                            fontSize: "small"
                                        })
                                    })
                                })
                            ]
                        }),
                        url: routes.events({
                            tags,
                            desc: defaultOrder
                        })
                    })).toReversed()
            }
        ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Sidebar), {
        logoLink: routes.events(),
        title: "Event Manager",
        menuItems: menuItems,
        profileUrl: routes.eventsProfile()
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","@mui/material/IconButton":"488As","@mui/material/Stack":"6thYv","@mui/material/Tooltip":"2soEB","@mui/icons-material/Event":"3S0ly","@mui/icons-material/Close":"acjz6","common/api/v1/types":"3qemx","../../store":"5LXiG","../../redux/actions/tagsAction":"6HCqL","../../utils/hooks":"5aY3q","../common/SidebarMenu/index":"f2Iey","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6thYv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("28b0a067692d318b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Stack.default;
    }
});
Object.defineProperty(exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return _stackClasses.default;
    }
});
var _Stack = _interopRequireDefault(require("ec8c60d6e5a80054"));
var _stackClasses = _interopRequireDefault(require("2945cc14f6b4b544"));

},{"28b0a067692d318b":"kZ6eK","ec8c60d6e5a80054":"fQyuW","2945cc14f6b4b544":"7wBQG"}],"fQyuW":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("69dd9184a5a17b21").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("4ecb826f6979ef84"));
var _system = require("b893ad8e6a2b9720");
var _styled = _interopRequireDefault(require("289e438d2408323a"));
var _DefaultPropsProvider = require("f0a140d29ab63ad0");
const Stack = (0, _system.createStack)({
    createStyledComponent: (0, _styled.default)('div', {
        name: 'MuiStack',
        slot: 'Root'
    }),
    useThemeProps: (inProps)=>(0, _DefaultPropsProvider.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var _default = exports.default = Stack;

},{"69dd9184a5a17b21":"kZ6eK","4ecb826f6979ef84":"bnNSm","b893ad8e6a2b9720":"iFfXs","289e438d2408323a":"iVEGR","f0a140d29ab63ad0":"9bD8g"}],"7wBQG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5e73a30702ccd0cc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getStackUtilityClass = getStackUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("78a99e557184e8f6"));
var _generateUtilityClass = _interopRequireDefault(require("89a403f68ac38da"));
function getStackUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiStack', slot);
}
const stackClasses = (0, _generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var _default = exports.default = stackClasses;

},{"5e73a30702ccd0cc":"kZ6eK","78a99e557184e8f6":"7pSUk","89a403f68ac38da":"jBs9M"}],"2soEB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("caf09d354454de1a").default;
var _interopRequireDefault = require("a3e85cc19f5eecb7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tooltipClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Tooltip.default;
    }
});
Object.defineProperty(exports, "tooltipClasses", {
    enumerable: true,
    get: function() {
        return _tooltipClasses.default;
    }
});
var _Tooltip = _interopRequireDefault(require("2b20eaad530e5310"));
var _tooltipClasses = _interopRequireWildcard(require("c7b7cc266b0e0ab8"));
Object.keys(_tooltipClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tooltipClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tooltipClasses[key];
        }
    });
});

},{"caf09d354454de1a":"fiRIh","a3e85cc19f5eecb7":"kZ6eK","2b20eaad530e5310":"3abjG","c7b7cc266b0e0ab8":"51AbZ"}],"3abjG":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("32796bd95ee3d4ed").default;
var _interopRequireWildcard = require("23a1c0a9d15860a5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.testReset = testReset;
var React = _interopRequireWildcard(require("43c6b60161290ce6"));
var _propTypes = _interopRequireDefault(require("32ce64f7140116dd"));
var _clsx = _interopRequireDefault(require("adb4ca74fe769f8"));
var _useTimeout = _interopRequireWildcard(require("2fdb78bcd2de3b2b"));
var _elementAcceptingRef = _interopRequireDefault(require("4821d4ac1f00940f"));
var _composeClasses = _interopRequireDefault(require("7f71923510204ec1"));
var _colorManipulator = require("29bc102c0dd91727");
var _RtlProvider = require("8e8bdabd1fd5c3aa");
var _isFocusVisible = _interopRequireDefault(require("6f5cd81681aef3e2"));
var _getReactElementRef = _interopRequireDefault(require("b2efa944c0b86c10"));
var _zeroStyled = require("db695326a5c5e8f3");
var _memoTheme = _interopRequireDefault(require("ebe70eb68cc06ca"));
var _DefaultPropsProvider = require("c9819d69a3fcbdb3");
var _capitalize = _interopRequireDefault(require("141a08a719146d24"));
var _Grow = _interopRequireDefault(require("32627a51d73a9753"));
var _Popper = _interopRequireDefault(require("32848faf67e4b925"));
var _useEventCallback = _interopRequireDefault(require("90b6f4e75361de2a"));
var _useForkRef = _interopRequireDefault(require("9900687051e21dac"));
var _useId = _interopRequireDefault(require("6dec8f6c4e5719eb"));
var _useControlled = _interopRequireDefault(require("6cf86571b57cb40a"));
var _useSlot = _interopRequireDefault(require("134926a9c364b40"));
var _tooltipClasses = _interopRequireWildcard(require("df099a642f61dc2d"));
var _jsxRuntime = require("4abb2ad55bc4904b");
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses = (ownerState)=>{
    const { classes, disableInteractive, arrow, touch, placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, _capitalize.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, _composeClasses.default)(slots, _tooltipClasses.getTooltipUtilityClass, classes);
};
const TooltipPopper = (0, _zeroStyled.styled)(_Popper.default, {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${_tooltipClasses.default.arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${_tooltipClasses.default.arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${_tooltipClasses.default.arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${_tooltipClasses.default.arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${_tooltipClasses.default.arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${_tooltipClasses.default.arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${_tooltipClasses.default.arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${_tooltipClasses.default.arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const TooltipTooltip = (0, _zeroStyled.styled)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, _capitalize.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _colorManipulator.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${_tooltipClasses.default.popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${_tooltipClasses.default.popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.touch,
                style: {
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.touch,
                style: {
                    [`.${_tooltipClasses.default.popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const TooltipArrow = (0, _zeroStyled.styled)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow'
})((0, _memoTheme.default)(({ theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _colorManipulator.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let hystersisOpen = false;
const hystersisTimer = new _useTimeout.Timeout();
let cursorPosition = {
    x: 0,
    y: 0
};
function testReset() {
    hystersisOpen = false;
    hystersisTimer.clear();
}
function composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const Tooltip = /*#__PURE__*/ React.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow = false, children: childrenProp, classes: classesProp, components = {}, componentsProps = {}, describeChild = false, disableFocusListener = false, disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener = false, enterDelay = 100, enterNextDelay = 0, enterTouchDelay = 700, followCursor = false, id: idProp, leaveDelay = 0, leaveTouchDelay = 1500, onClose, onOpen, open: openProp, placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps = {}, slotProps = {}, slots = {}, title, TransitionComponent: TransitionComponentProp, TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ React.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, _zeroStyled.useTheme)();
    const isRtl = (0, _RtlProvider.useRtl)();
    const [childNode, setChildNode] = React.useState();
    const [arrowRef, setArrowRef] = React.useState(null);
    const ignoreNonTouchEvents = React.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, _useTimeout.default)();
    const enterTimer = (0, _useTimeout.default)();
    const leaveTimer = (0, _useTimeout.default)();
    const touchTimer = (0, _useTimeout.default)();
    const [openState, setOpenState] = (0, _useControlled.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, _useId.default)(idProp);
    const prevUserSelect = React.useRef();
    const stopTouchInteraction = (0, _useEventCallback.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    React.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        hystersisTimer.clear();
        hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, _useEventCallback.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        hystersisTimer.start(800 + leaveDelay, ()=>{
            hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || hystersisOpen && enterNextDelay) enterTimer.start(hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = React.useState(false);
    const handleBlur = (event)=>{
        if (!(0, _isFocusVisible.default)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, _isFocusVisible.default)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    React.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, _useForkRef.default)((0, _getReactElementRef.default)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = React.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, _clsx.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl,
        arrow,
        disableInteractive,
        placement,
        PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = React.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, _useSlot.default)('popper', {
        elementType: TooltipPopper,
        externalForwardedProps,
        ownerState,
        className: (0, _clsx.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, _useSlot.default)('transition', {
        elementType: _Grow.default,
        externalForwardedProps,
        ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, _useSlot.default)('tooltip', {
        elementType: TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps,
        ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, _useSlot.default)('arrow', {
        elementType: TooltipArrow,
        className: classes.arrow,
        externalForwardedProps,
        ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ React.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperSlot, {
                as: PopperComponentProp ?? _Popper.default,
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: cursorPosition.y,
                            left: cursorPosition.x,
                            right: cursorPosition.x,
                            bottom: cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var _default = exports.default = Tooltip;

},{"32796bd95ee3d4ed":"kZ6eK","23a1c0a9d15860a5":"fiRIh","43c6b60161290ce6":"9njXz","32ce64f7140116dd":"bnNSm","adb4ca74fe769f8":"d2NWs","2fdb78bcd2de3b2b":"k3sgs","4821d4ac1f00940f":"doIJ9","7f71923510204ec1":"59Equ","29bc102c0dd91727":"hTYBL","8e8bdabd1fd5c3aa":"ck9Pb","6f5cd81681aef3e2":"gHKhh","b2efa944c0b86c10":"gaXcx","db695326a5c5e8f3":"hZXDo","ebe70eb68cc06ca":"cJNjb","c9819d69a3fcbdb3":"9bD8g","141a08a719146d24":"eOYSA","32627a51d73a9753":"do65J","32848faf67e4b925":"2EMLo","90b6f4e75361de2a":"9mQKD","9900687051e21dac":"64cM2","6dec8f6c4e5719eb":"hOkl4","6cf86571b57cb40a":"2pWHX","134926a9c364b40":"h76AU","df099a642f61dc2d":"51AbZ","4abb2ad55bc4904b":"1dlk8"}],"2EMLo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f6fc39116c892e17").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Popper.default;
    }
});
var _Popper = _interopRequireDefault(require("b378d745562487c"));
var _popperClasses = require("8cc53a97ebe1c5e8");
Object.keys(_popperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _popperClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _popperClasses[key];
        }
    });
});

},{"f6fc39116c892e17":"kZ6eK","b378d745562487c":"8CeLY","8cc53a97ebe1c5e8":"dmLj2"}],"8CeLY":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("c7afa561e9ec0b9c").default;
var _interopRequireDefault = require("678f26e65f17ac4c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _RtlProvider = require("25180902d9640137");
var _refType = _interopRequireDefault(require("500bde1bf1986a24"));
var _HTMLElementType = _interopRequireDefault(require("be05367c725e5661"));
var _propTypes = _interopRequireDefault(require("4d39258cba1b8575"));
var React = _interopRequireWildcard(require("6afb39ebaf041cf4"));
var _BasePopper = _interopRequireDefault(require("e21ce73d76442724"));
var _zeroStyled = require("e0a4790be642b844");
var _DefaultPropsProvider = require("2ae9b024fa501d2a");
var _jsxRuntime = require("100930607c99be37");
const PopperRoot = (0, _zeroStyled.styled)(_BasePopper.default, {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const Popper = /*#__PURE__*/ React.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, _RtlProvider.useRtl)();
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl, component, components, componentsProps, container, disablePortal, keepMounted, modifiers, open, placement, popperOptions, popperRef, transition, slots, slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl,
        container,
        disablePortal,
        keepMounted,
        modifiers,
        open,
        placement,
        popperOptions,
        popperRef,
        transition,
        ...other
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var _default = exports.default = Popper;

},{"c7afa561e9ec0b9c":"fiRIh","678f26e65f17ac4c":"kZ6eK","25180902d9640137":"ck9Pb","500bde1bf1986a24":"3TBXN","be05367c725e5661":"eESPP","4d39258cba1b8575":"bnNSm","6afb39ebaf041cf4":"9njXz","e21ce73d76442724":"4B9s4","e0a4790be642b844":"hZXDo","2ae9b024fa501d2a":"9bD8g","100930607c99be37":"1dlk8"}],"4B9s4":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a7045943e94d2233").default;
var _interopRequireWildcard = require("2c30409b1f6a0d28").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("c0a92a12b39554aa"));
var _ownerDocument = _interopRequireDefault(require("ea5531945ecd5541"));
var _useEnhancedEffect = _interopRequireDefault(require("bdd2b0aed153bc46"));
var _useForkRef = _interopRequireDefault(require("18545e2561a624a"));
var _chainPropTypes = _interopRequireDefault(require("3a8d2d19465efff8"));
var _HTMLElementType = _interopRequireDefault(require("a0e8769e8dd38644"));
var _refType = _interopRequireDefault(require("4a1cc5675f5e4927"));
var _core = require("eff5859b6ebbdf3d");
var _propTypes = _interopRequireDefault(require("45998a3321e9ca"));
var _composeClasses = _interopRequireDefault(require("6a542103e9424733"));
var _useSlotProps = _interopRequireDefault(require("66fa5079bd9ede0b"));
var _Portal = _interopRequireDefault(require("45e792efb9a5c284"));
var _popperClasses = require("1649991d306490d6");
var _jsxRuntime = require("efbb4b23f7ba7c6a");
function flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function isVirtualElement(element) {
    return !isHTMLElement(element);
}
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _popperClasses.getPopperUtilityClass, classes);
};
const defaultPopperOptions = {};
const PopperTooltip = /*#__PURE__*/ React.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl, children, direction, disablePortal, modifiers, open, placement: initialPlacement, popperOptions, popperRef: popperRefProp, slotProps = {}, slots = {}, TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = React.useRef(null);
    const ownRef = (0, _useForkRef.default)(tooltipRef, forwardedRef);
    const popperRef = React.useRef(null);
    const handlePopperRef = (0, _useForkRef.default)(popperRef, popperRefProp);
    const handlePopperRefRef = React.useRef(handlePopperRef);
    (0, _useEnhancedEffect.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    React.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = React.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = React.useState(resolveAnchorEl(anchorEl));
    React.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    React.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement(resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, _useEnhancedEffect.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, _core.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, _useSlotProps.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const Popper = /*#__PURE__*/ React.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl, children, container: containerProp, direction = 'ltr', disablePortal = false, keepMounted = false, modifiers, open, placement = 'bottom', popperOptions = defaultPopperOptions, popperRef, style, transition = false, slotProps = {}, slots = {}, ...other } = props;
    const [exited, setExited] = React.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) ? (0, _ownerDocument.default)(resolvedAnchorEl).body : (0, _ownerDocument.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Portal.default, {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var _default = exports.default = Popper;

},{"a7045943e94d2233":"kZ6eK","2c30409b1f6a0d28":"fiRIh","c0a92a12b39554aa":"9njXz","ea5531945ecd5541":"8VgUE","bdd2b0aed153bc46":"fIvqa","18545e2561a624a":"4xKTx","3a8d2d19465efff8":"4stnp","a0e8769e8dd38644":"eESPP","4a1cc5675f5e4927":"3TBXN","eff5859b6ebbdf3d":"4kymL","45998a3321e9ca":"bnNSm","6a542103e9424733":"59Equ","66fa5079bd9ede0b":"kr4RG","45e792efb9a5c284":"kRqG5","1649991d306490d6":"dmLj2","efbb4b23f7ba7c6a":"1dlk8"}],"4kymL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":"gVkdf","./modifiers/index.js":"lQ8FR","./createPopper.js":"b4uCU","./popper.js":"23oSG","./popper-lite.js":"89NyG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVkdf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lQ8FR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyStyles", ()=>(0, _applyStylesJsDefault.default));
parcelHelpers.export(exports, "arrow", ()=>(0, _arrowJsDefault.default));
parcelHelpers.export(exports, "computeStyles", ()=>(0, _computeStylesJsDefault.default));
parcelHelpers.export(exports, "eventListeners", ()=>(0, _eventListenersJsDefault.default));
parcelHelpers.export(exports, "flip", ()=>(0, _flipJsDefault.default));
parcelHelpers.export(exports, "hide", ()=>(0, _hideJsDefault.default));
parcelHelpers.export(exports, "offset", ()=>(0, _offsetJsDefault.default));
parcelHelpers.export(exports, "popperOffsets", ()=>(0, _popperOffsetsJsDefault.default));
parcelHelpers.export(exports, "preventOverflow", ()=>(0, _preventOverflowJsDefault.default));
var _applyStylesJs = require("./applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _arrowJs = require("./arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _computeStylesJs = require("./computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _eventListenersJs = require("./eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _hideJs = require("./hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _offsetJs = require("./offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _popperOffsetsJs = require("./popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _preventOverflowJs = require("./preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);

},{"./applyStyles.js":"ewuA1","./arrow.js":"5Trmz","./computeStyles.js":"jvHvj","./eventListeners.js":"5tT8s","./flip.js":"8WVPr","./hide.js":"6kFua","./offset.js":"2lcLd","./popperOffsets.js":"hVDuj","./preventOverflow.js":"jUko2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewuA1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: [
        'computeStyles'
    ]
};

},{"../dom-utils/getNodeName.js":"jyQUh","../dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyQUh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bDAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ynkX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Trmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"5S4fc","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/contains.js":"eGlaM","../dom-utils/getOffsetParent.js":"bLvkb","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/within.js":"cdkh1","../utils/mergePaddingObject.js":"43lYJ","../utils/expandToHashMap.js":"16QKI","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5S4fc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bweSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XyXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"1bDAn","../utils/math.js":"8B7aS","./getWindow.js":"3ynkX","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B7aS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAhTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fpMW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGlaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLvkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"3ynkX","./getNodeName.js":"jyQUh","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./isTableElement.js":"btBRX","./getParentNode.js":"k0cfu","../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uZSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btBRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"jyQUh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k0cfu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"jyQUh","./getDocumentElement.js":"gcVmr","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcVmr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avEhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdkh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43lYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"gtdyp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtdyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16QKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jvHvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"gVkdf","../dom-utils/getOffsetParent.js":"bLvkb","../dom-utils/getWindow.js":"3ynkX","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getComputedStyle.js":"5uZSa","../utils/getBasePlacement.js":"5S4fc","../utils/getVariation.js":"4BYPr","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4BYPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tT8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WVPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"htgah","../utils/getBasePlacement.js":"5S4fc","../utils/getOppositeVariationPlacement.js":"3n1hw","../utils/detectOverflow.js":"6v2ts","../utils/computeAutoPlacement.js":"clJeY","../enums.js":"gVkdf","../utils/getVariation.js":"4BYPr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htgah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3n1hw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6v2ts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"YPNSr","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getBoundingClientRect.js":"4XyXs","./computeOffsets.js":"gnv44","./rectToClientRect.js":"5PWlE","../enums.js":"gVkdf","../dom-utils/instanceOf.js":"1bDAn","./mergePaddingObject.js":"43lYJ","./expandToHashMap.js":"16QKI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"YPNSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"gVkdf","./getViewportRect.js":"2wQ5y","./getDocumentRect.js":"3LAyO","./listScrollParents.js":"1qClO","./getOffsetParent.js":"bLvkb","./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./getBoundingClientRect.js":"4XyXs","./getParentNode.js":"k0cfu","./contains.js":"eGlaM","./getNodeName.js":"jyQUh","../utils/rectToClientRect.js":"5PWlE","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wQ5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"3ynkX","./getDocumentElement.js":"gcVmr","./getWindowScrollBarX.js":"kaNJ3","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaNJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"4XyXs","./getDocumentElement.js":"gcVmr","./getWindowScroll.js":"btekq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btekq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3LAyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./getWindowScrollBarX.js":"kaNJ3","./getWindowScroll.js":"btekq","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qClO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"1igW6","./getParentNode.js":"k0cfu","./getWindow.js":"3ynkX","./isScrollParent.js":"eD7m7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1igW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"k0cfu","./isScrollParent.js":"eD7m7","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eD7m7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"5uZSa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PWlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnv44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"5S4fc","./getVariation.js":"4BYPr","./getMainAxisFromPlacement.js":"avEhJ","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"clJeY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"4BYPr","../enums.js":"gVkdf","./detectOverflow.js":"6v2ts","./getBasePlacement.js":"5S4fc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kFua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"gVkdf","../utils/detectOverflow.js":"6v2ts","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lcLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"5S4fc","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVDuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"gnv44","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUko2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"gVkdf","../utils/getBasePlacement.js":"5S4fc","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/getAltAxis.js":"l4M4a","../utils/within.js":"cdkh1","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/getOffsetParent.js":"bLvkb","../utils/detectOverflow.js":"6v2ts","../utils/getVariation.js":"4BYPr","../utils/getFreshSideObject.js":"gtdyp","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4M4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4uCU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"4mQXp","./dom-utils/getLayoutRect.js":"bweSm","./dom-utils/listScrollParents.js":"1qClO","./dom-utils/getOffsetParent.js":"bLvkb","./utils/orderModifiers.js":"4RWkj","./utils/debounce.js":"gcfKw","./utils/mergeByName.js":"kcmZR","./utils/detectOverflow.js":"6v2ts","./dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mQXp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","./getNodeScroll.js":"8P5ka","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","./getWindowScrollBarX.js":"kaNJ3","./getDocumentElement.js":"gcVmr","./isScrollParent.js":"eD7m7","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8P5ka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"btekq","./getWindow.js":"3ynkX","./instanceOf.js":"1bDAn","./getHTMLElementScroll.js":"hYXUH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYXUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RWkj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcfKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kcmZR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"23oSG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"b4uCU","./modifiers/eventListeners.js":"5tT8s","./modifiers/popperOffsets.js":"hVDuj","./modifiers/computeStyles.js":"jvHvj","./modifiers/applyStyles.js":"ewuA1","./modifiers/offset.js":"2lcLd","./modifiers/flip.js":"8WVPr","./modifiers/preventOverflow.js":"jUko2","./modifiers/arrow.js":"5Trmz","./modifiers/hide.js":"6kFua","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"89NyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"b4uCU","./modifiers/eventListeners.js":"5tT8s","./modifiers/popperOffsets.js":"hVDuj","./modifiers/computeStyles.js":"jvHvj","./modifiers/applyStyles.js":"ewuA1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dmLj2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d75dc289c08d68ff").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPopperUtilityClass = getPopperUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("3311ca31931d791b"));
var _generateUtilityClass = _interopRequireDefault(require("6455116b5add92e7"));
function getPopperUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPopper', slot);
}
const popperClasses = (0, _generateUtilityClasses.default)('MuiPopper', [
    'root'
]);
var _default = exports.default = popperClasses;

},{"d75dc289c08d68ff":"kZ6eK","3311ca31931d791b":"7pSUk","6455116b5add92e7":"jBs9M"}],"51AbZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e4f9d437dc196b2b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTooltipUtilityClass = getTooltipUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("239457b808d7ade8"));
var _generateUtilityClass = _interopRequireDefault(require("605ba83517a7a652"));
function getTooltipUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTooltip', slot);
}
const tooltipClasses = (0, _generateUtilityClasses.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var _default = exports.default = tooltipClasses;

},{"e4f9d437dc196b2b":"kZ6eK","239457b808d7ade8":"7pSUk","605ba83517a7a652":"jBs9M"}],"3S0ly":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("6c26dfedec07d8f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("eeb4d66cac4fed2b"));
var _jsxRuntime = require("db326bdff09e0b74");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M17 12h-5v5h5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1zm3 18H5V8h14z"
}), 'Event');

},{"6c26dfedec07d8f":"kZ6eK","eeb4d66cac4fed2b":"2vOnF","db326bdff09e0b74":"1dlk8"}],"f2Iey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sidebar", ()=>Sidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _drawer = require("@mui/material/Drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _swipeableDrawer = require("@mui/material/SwipeableDrawer");
var _swipeableDrawerDefault = parcelHelpers.interopDefault(_swipeableDrawer);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _powerSettingsNew = require("@mui/icons-material/PowerSettingsNew");
var _powerSettingsNewDefault = parcelHelpers.interopDefault(_powerSettingsNew);
var _person = require("@mui/icons-material/Person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _switchAccount = require("@mui/icons-material/SwitchAccount");
var _switchAccountDefault = parcelHelpers.interopDefault(_switchAccount);
var _types = require("common/api/v1/types");
var _util = require("common/util");
var _userActions = require("../../../redux/actions/userActions");
var _uiActions = require("../../../redux/actions/uiActions");
var _utils = require("../../../utils");
var _topLeftNav = require("../../partials/TopLeftNav");
var _menuItem = require("./MenuItem");
var _index = require("../../../utils/index");
var _devModeSwitch = require("./DevModeSwitch");
var _devModeSwitchDefault = parcelHelpers.interopDefault(_devModeSwitch);
var _globalCreate = require("./GlobalCreate");
const styles = {
    open: {
        transition: (theme)=>theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            })
    },
    close: {
        transition: (theme)=>theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            }),
        width: 0
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh'
    },
    list: {
        overflowY: 'auto'
    },
    menuBottom: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end'
    },
    version: {
        fontSize: '10px',
        padding: (theme)=>theme.spacing(1, 2)
    }
};
const AppVersion = ({ buildInfo })=>{
    if (!buildInfo) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        sx: styles.version,
        children: '\u00A0'
    });
    const commit = buildInfo.commit ? `, ${buildInfo.commit}` : '';
    const buildTime = buildInfo.buildTime.toISOString().slice(0, 19);
    const versionInfo = `${buildInfo.release}, ${buildTime}${commit}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        sx: styles.version,
        children: versionInfo
    });
};
const Sidebar = ({ title, logoLink, menuItems, profileUrl })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { isMobile } = (0, _index.useMobile)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _uiActions.toggleSidebarMenu)(!isMobile));
    }, [
        dispatch,
        isMobile
    ]);
    const { open } = (0, _reactRedux.useSelector)(({ uiReducer })=>({
            open: uiReducer.open
        }), (0, _reactRedux.shallowEqual));
    const { buildInfo } = (0, _reactRedux.useSelector)(({ buildInfoReducer })=>({
            buildInfo: buildInfoReducer.buildInfo
        }), (0, _util.equals));
    const user = (0, _utils.useUser)();
    const { numAlarms, hasCriticalAlarm } = (0, _reactRedux.useSelector)(({ alarmsReducer })=>({
            numAlarms: alarmsReducer.alarmsForNotifications.total,
            hasCriticalAlarm: alarmsReducer.alarmsForNotifications.items.some((alarm)=>alarm.alarmSeverity === (0, _types.AlarmSeverityLevels).critical)
        }), (0, _reactRedux.shallowEqual));
    const { devMode } = (0, _index.useSettingsSelector)();
    const { cachedUrlParams } = (0, _reactRedux.useSelector)(({ urlParamReducer })=>({
            cachedUrlParams: urlParamReducer.cachedUrlParams
        }), (0, _util.equals));
    const logoutUserAction = ()=>void dispatch((0, _userActions.logoutAndNavigateToMainPage)());
    const stopImpersonationAction = ()=>void dispatch((0, _userActions.stopImpersonation)({
            showSuccessSnackbar: true
        }));
    const handleOpen = ()=>dispatch((0, _uiActions.toggleSidebarMenu)(true));
    const handleClose = ()=>dispatch((0, _uiActions.toggleSidebarMenu)(false));
    const handleClickLogo = ()=>{
        if (isMobile) handleClose();
    };
    const menu = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        component: "nav",
        id: "sidebar",
        "data-test-isopen": open,
        sx: styles.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topLeftNav.TopLeftNav), {
                title: title,
                logoLink: logoLink,
                onClickLogo: handleClickLogo
            }),
            title === 'Network Manager' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalCreate.GlobalCreate), {
                devMode: devMode
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                id: "menu",
                disablePadding: true,
                sx: styles.list,
                children: menuItems({
                    userRole: user.role,
                    alarms: {
                        total: numAlarms,
                        hasCritical: hasCriticalAlarm
                    },
                    onClick: isMobile ? handleClose : undefined,
                    devMode
                }).map((item, ind)=>{
                    return /*#__PURE__*/ (0, _react.createElement)((0, _menuItem.SidebarMenuItem), {
                        ...item,
                        key: item.url || ind
                    });
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: styles.menuBottom,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItem.SidebarMenuItem), {
                        name: user.username,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personDefault.default), {}),
                        url: profileUrl,
                        id: "profile",
                        secondaryText: user.impersonatedBy && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "body2",
                            component: "div",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                style: {
                                    opacity: 0.5
                                },
                                children: [
                                    "(by ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        "data-test-id": "current-impersonator",
                                        children: user.impersonatedBy.username
                                    }),
                                    ")"
                                ]
                            })
                        })
                    }, "/profile"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                    user.impersonatedBy ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItem.SidebarMenuItem), {
                        name: "Switch to admin",
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchAccountDefault.default), {}),
                        id: "stop-impersonation",
                        onClick: stopImpersonationAction
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItem.SidebarMenuItem), {
                        name: "Log out",
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _powerSettingsNewDefault.default), {}),
                        id: "logout-button",
                        onClick: logoutUserAction
                    }, "/logout"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _devModeSwitchDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppVersion, {
                            buildInfo: buildInfo
                        })
                    })
                ]
            })
        ]
    });
    return isMobile ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _swipeableDrawerDefault.default), {
        anchor: "left",
        disableSwipeToOpen: true,
        open: open,
        onOpen: handleOpen,
        onClose: handleClose,
        sx: {
            visibility: open !== true ? 'hidden' : undefined
        },
        children: menu
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerDefault.default), {
        variant: "persistent",
        anchor: "left",
        open: open !== false,
        sx: open !== false ? styles.open : styles.close,
        children: menu
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/Divider":"9Ul8c","@mui/material/Drawer":"exzU8","@mui/material/List":"a52pA","@mui/material/SwipeableDrawer":"ebYch","@mui/material/Typography":"6NtGx","@mui/icons-material/PowerSettingsNew":"fkySZ","@mui/icons-material/Person":"6tc0D","@mui/icons-material/SwitchAccount":"E2xek","common/api/v1/types":"3qemx","common/util":"jV4UZ","../../../redux/actions/userActions":"2tWgd","../../../redux/actions/uiActions":"aO8kk","../../../utils":"342UB","../../partials/TopLeftNav":"eWUlU","./MenuItem":"bsK1A","../../../utils/index":"342UB","./DevModeSwitch":"14jwF","./GlobalCreate":"fdM7M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Ul8c":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5aed8c2179e3546d").default;
var _interopRequireDefault = require("39d68ebd9ca4f335").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dividerClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Divider.default;
    }
});
Object.defineProperty(exports, "dividerClasses", {
    enumerable: true,
    get: function() {
        return _dividerClasses.default;
    }
});
var _Divider = _interopRequireDefault(require("bc619c596286bb28"));
var _dividerClasses = _interopRequireWildcard(require("38c77826218cc605"));
Object.keys(_dividerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dividerClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dividerClasses[key];
        }
    });
});

},{"5aed8c2179e3546d":"fiRIh","39d68ebd9ca4f335":"kZ6eK","bc619c596286bb28":"4QydN","38c77826218cc605":"8220S"}],"4QydN":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7b37a86cb77091d9").default;
var _interopRequireWildcard = require("2c36da831d2a8352").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("b0a03e1a9fd1ae2c"));
var _propTypes = _interopRequireDefault(require("69619206d4623d04"));
var _clsx = _interopRequireDefault(require("3230f28dce370b99"));
var _composeClasses = _interopRequireDefault(require("7035f64cfb306690"));
var _colorManipulator = require("8db64d9eed9c9127");
var _zeroStyled = require("a6e41679107fae7c");
var _memoTheme = _interopRequireDefault(require("6042c1b3f85ee7a2"));
var _DefaultPropsProvider = require("f0913d9d142d98f1");
var _dividerClasses = require("18286d416814af9c");
var _jsxRuntime = require("ea2d8d2af6495806");
const useUtilityClasses = (ownerState)=>{
    const { absolute, children, classes, flexItem, light, orientation, textAlign, variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, _composeClasses.default)(slots, _dividerClasses.getDividerUtilityClass, classes);
};
const DividerRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, _colorManipulator.alpha)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const DividerWrapper = (0, _zeroStyled.styled)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const Divider = /*#__PURE__*/ React.forwardRef(function Divider(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute = false, children, className, orientation = 'horizontal', component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem = false, light = false, role = component !== 'hr' ? 'separator' : undefined, textAlign = 'center', variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute,
        component,
        flexItem,
        light,
        orientation,
        role,
        textAlign,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if (Divider) Divider.muiSkipListHighlight = true;
var _default = exports.default = Divider;

},{"7b37a86cb77091d9":"kZ6eK","2c36da831d2a8352":"fiRIh","b0a03e1a9fd1ae2c":"9njXz","69619206d4623d04":"bnNSm","3230f28dce370b99":"d2NWs","7035f64cfb306690":"59Equ","8db64d9eed9c9127":"hTYBL","a6e41679107fae7c":"hZXDo","6042c1b3f85ee7a2":"cJNjb","f0913d9d142d98f1":"9bD8g","18286d416814af9c":"8220S","ea2d8d2af6495806":"1dlk8"}],"8220S":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7de2ac817370c1f6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDividerUtilityClass = getDividerUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("81191e8587684b19"));
var _generateUtilityClass = _interopRequireDefault(require("1830a9bd46fea04"));
function getDividerUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDivider', slot);
}
const dividerClasses = (0, _generateUtilityClasses.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var _default = exports.default = dividerClasses;

},{"7de2ac817370c1f6":"kZ6eK","81191e8587684b19":"7pSUk","1830a9bd46fea04":"jBs9M"}],"exzU8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7d8522dca5be1117").default;
var _interopRequireDefault = require("bf2881a0f53ff542").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    drawerClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Drawer.default;
    }
});
Object.defineProperty(exports, "drawerClasses", {
    enumerable: true,
    get: function() {
        return _drawerClasses.default;
    }
});
var _Drawer = _interopRequireDefault(require("7dbbbbae722308da"));
var _drawerClasses = _interopRequireWildcard(require("b8f29460234a5a54"));
Object.keys(_drawerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _drawerClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _drawerClasses[key];
        }
    });
});

},{"7d8522dca5be1117":"fiRIh","bf2881a0f53ff542":"kZ6eK","7dbbbbae722308da":"bbkeu","b8f29460234a5a54":"zUtww"}],"bbkeu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("575032c30b4873d9").default;
var _interopRequireWildcard = require("b3dcd7a59805eebb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getAnchor = getAnchor;
exports.isHorizontal = isHorizontal;
var React = _interopRequireWildcard(require("14ef4d74ec2a3e2d"));
var _propTypes = _interopRequireDefault(require("fe437497cfd584be"));
var _clsx = _interopRequireDefault(require("d943833b349d5705"));
var _integerPropType = _interopRequireDefault(require("f42fbc03dfb1c62f"));
var _composeClasses = _interopRequireDefault(require("8b7655588d79c415"));
var _RtlProvider = require("7824eeac1694099");
var _Modal = _interopRequireDefault(require("f516ec39d9f7edc3"));
var _Slide = _interopRequireDefault(require("4ee1154b714e0387"));
var _Paper = _interopRequireDefault(require("8b77422c97b1bc74"));
var _capitalize = _interopRequireDefault(require("b1995d071d051c56"));
var _rootShouldForwardProp = _interopRequireDefault(require("690e6493fe0f2a7c"));
var _zeroStyled = require("54a0e86dfc83b66");
var _memoTheme = _interopRequireDefault(require("e1d39efbb89e1ca1"));
var _DefaultPropsProvider = require("41cadedaa9ad67e7");
var _drawerClasses = require("5f9703ffa5f59d08");
var _useSlot = _interopRequireDefault(require("de3e080cc65dede3"));
var _utils = require("2376e07c7a5a0e94");
var _jsxRuntime = require("b3d53e8de62cddcf");
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, anchor, variant } = ownerState;
    const slots = {
        root: [
            'root',
            `anchor${(0, _capitalize.default)(anchor)}`
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, _capitalize.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, _capitalize.default)(anchor)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _drawerClasses.getDrawerUtilityClass, classes);
};
const DrawerRoot = (0, _zeroStyled.styled)(_Modal.default, {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const DrawerDockedRoot = (0, _zeroStyled.styled)('div', {
    shouldForwardProp: _rootShouldForwardProp.default,
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver
})({
    flex: '0 0 auto'
});
const DrawerPaper = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, _capitalize.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, _capitalize.default)(ownerState.anchor)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchor === 'left' && ownerState.variant !== 'temporary',
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchor === 'top' && ownerState.variant !== 'temporary',
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchor === 'right' && ownerState.variant !== 'temporary',
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary',
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function isHorizontal(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function getAnchor({ direction }, anchor) {
    return direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const Drawer = /*#__PURE__*/ React.forwardRef(function Drawer(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, _zeroStyled.useTheme)();
    const isRtl = (0, _RtlProvider.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps, children, className, elevation = 16, hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp, ...ModalProps } = {}, onClose, open = false, PaperProps = {}, SlideProps, // eslint-disable-next-line react/prop-types
    TransitionComponent, transitionDuration = defaultTransitionDuration, variant = 'temporary', slots = {}, slotProps = {}, ...other } = props;
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = React.useRef(false);
    React.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = getAnchor({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = {
        ...props,
        anchor,
        elevation,
        open,
        variant,
        ...other
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            paper: PaperProps,
            transition: SlideProps,
            ...slotProps,
            backdrop: (0, _utils.mergeSlotProps)(slotProps.backdrop || {
                ...BackdropProps,
                ...BackdropPropsProp
            }, {
                transitionDuration
            })
        }
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        ref,
        elementType: DrawerRoot,
        className: (0, _clsx.default)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            ...ModalProps
        },
        additionalProps: {
            open,
            onClose,
            hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    });
    const [PaperSlot, paperSlotProps] = (0, _useSlot.default)('paper', {
        elementType: DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, _clsx.default)(classes.paper, PaperProps.className),
        ownerState,
        externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true
        }
    });
    const [DockedSlot, dockedSlotProps] = (0, _useSlot.default)('docked', {
        elementType: DrawerDockedRoot,
        ref,
        className: (0, _clsx.default)(classes.root, classes.docked, className),
        ownerState,
        externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    });
    const [TransitionSlot, transitionSlotProps] = (0, _useSlot.default)('transition', {
        elementType: _Slide.default,
        ownerState,
        externalForwardedProps,
        additionalProps: {
            in: open,
            direction: oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current
        }
    });
    const drawer = /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperSlot, {
        ...paperSlotProps,
        children: children
    });
    if (variant === 'permanent') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: drawer
    });
    const slidingDrawer = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, {
        ...transitionSlotProps,
        children: drawer
    });
    if (variant === 'persistent') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: slidingDrawer
    });
    // variant === temporary
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, {
        ...rootSlotProps,
        children: slidingDrawer
    });
});
var _default = exports.default = Drawer;

},{"575032c30b4873d9":"kZ6eK","b3dcd7a59805eebb":"fiRIh","14ef4d74ec2a3e2d":"9njXz","fe437497cfd584be":"bnNSm","d943833b349d5705":"d2NWs","f42fbc03dfb1c62f":"iZJbi","8b7655588d79c415":"59Equ","7824eeac1694099":"ck9Pb","f516ec39d9f7edc3":"6Q8b8","4ee1154b714e0387":"j5qNZ","8b77422c97b1bc74":"aexCI","b1995d071d051c56":"eOYSA","690e6493fe0f2a7c":"bTxRc","54a0e86dfc83b66":"hZXDo","e1d39efbb89e1ca1":"cJNjb","41cadedaa9ad67e7":"9bD8g","5f9703ffa5f59d08":"zUtww","de3e080cc65dede3":"h76AU","2376e07c7a5a0e94":"dEMJk","b3d53e8de62cddcf":"1dlk8"}],"j5qNZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d935be4ea6fdf641").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Slide.default;
    }
});
var _Slide = _interopRequireDefault(require("2b5e5db2eb8b884b"));

},{"d935be4ea6fdf641":"kZ6eK","2b5e5db2eb8b884b":"cdf22"}],"cdf22":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("681162636a08b725").default;
var _interopRequireWildcard = require("419785494058b3ad").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.setTranslateValue = setTranslateValue;
var React = _interopRequireWildcard(require("514e4f5954fc2b2f"));
var _propTypes = _interopRequireDefault(require("595f3f5a647400ed"));
var _reactTransitionGroup = require("d5d5659b55b4aae9");
var _chainPropTypes = _interopRequireDefault(require("ace188f165474735"));
var _HTMLElementType = _interopRequireDefault(require("c5114051fcf58580"));
var _elementAcceptingRef = _interopRequireDefault(require("2e22c2075af7b9d9"));
var _getReactElementRef = _interopRequireDefault(require("772585c68427bdf1"));
var _debounce = _interopRequireDefault(require("1b65fe367871f663"));
var _useForkRef = _interopRequireDefault(require("50597ba9a6ed186e"));
var _zeroStyled = require("6b0481ac25e16335");
var _utils = require("f67de76037578982");
var _utils2 = require("19a35211f1de781a");
var _jsxRuntime = require("85148c0bd2f162cb");
// Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.
function getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, _utils2.ownerWindow)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node, containerProp) {
    const resolvedContainer = resolveContainer(containerProp);
    const transform = getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Slide = /*#__PURE__*/ React.forwardRef(function Slide(props, ref) {
    const theme = (0, _zeroStyled.useTheme)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener, appear = true, children, container: containerProp, direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = defaultTimeout, // eslint-disable-next-line react/prop-types
    TransitionComponent = _reactTransitionGroup.Transition, ...other } = props;
    const childrenRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)((0, _getReactElementRef.default)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        setTranslateValue(direction, node, containerProp);
        (0, _utils.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, _utils.getTransitionProps)({
            timeout,
            style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
            ...transitionProps
        });
        node.style.transition = theme.transitions.create('transform', {
            ...transitionProps
        });
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, _utils.getTransitionProps)({
            timeout,
            style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        setTranslateValue(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = React.useCallback(()=>{
        if (childrenRef.current) setTranslateValue(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    React.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, _debounce.default)(()=>{
            if (childrenRef.current) setTranslateValue(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, _utils2.ownerWindow)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    React.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ React.cloneElement(children, {
                ref: handleRef,
                style: {
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...style,
                    ...children.props.style
                },
                ...restChildProps
            });
        }
    });
});
var _default = exports.default = Slide;

},{"681162636a08b725":"kZ6eK","419785494058b3ad":"fiRIh","514e4f5954fc2b2f":"9njXz","595f3f5a647400ed":"bnNSm","d5d5659b55b4aae9":"hnCQJ","ace188f165474735":"4stnp","c5114051fcf58580":"eESPP","2e22c2075af7b9d9":"doIJ9","772585c68427bdf1":"gaXcx","1b65fe367871f663":"bjUwl","50597ba9a6ed186e":"64cM2","6b0481ac25e16335":"hZXDo","f67de76037578982":"k52HW","19a35211f1de781a":"dEMJk","85148c0bd2f162cb":"1dlk8"}],"zUtww":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5e8658de8032f74e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDrawerUtilityClass = getDrawerUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("b220c1e747ad796b"));
var _generateUtilityClass = _interopRequireDefault(require("713b4472ee359d24"));
function getDrawerUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDrawer', slot);
}
const drawerClasses = (0, _generateUtilityClasses.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'anchorLeft',
    'anchorRight',
    'anchorTop',
    'anchorBottom',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var _default = exports.default = drawerClasses;

},{"5e8658de8032f74e":"kZ6eK","b220c1e747ad796b":"7pSUk","713b4472ee359d24":"jBs9M"}],"ebYch":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("24643fd3bf7b61a1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _SwipeableDrawer.default;
    }
});
var _SwipeableDrawer = _interopRequireDefault(require("c5eeed83182e7867"));

},{"24643fd3bf7b61a1":"kZ6eK","c5eeed83182e7867":"6AYiq"}],"6AYiq":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("f089f14c935a5ee5").default;
var _interopRequireWildcard = require("68b6506eaa7efc4a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.reset = reset;
var React = _interopRequireWildcard(require("f43f4a820223268e"));
var ReactDOM = _interopRequireWildcard(require("317ee58648582c7b"));
var _propTypes = _interopRequireDefault(require("1d23b32da97246ba"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("f58b2813d78eeeb6"));
var _NoSsr = _interopRequireDefault(require("f2f4d6ea804a16b5"));
var _Drawer = _interopRequireWildcard(require("ceccb64606585e25"));
var _useForkRef = _interopRequireDefault(require("91ed1da5c44b42cd"));
var _ownerDocument = _interopRequireDefault(require("f32b0cbf78cdc29"));
var _ownerWindow = _interopRequireDefault(require("2768af5eeb1547c7"));
var _useEventCallback = _interopRequireDefault(require("96a341d89bb48e0c"));
var _useEnhancedEffect = _interopRequireDefault(require("c48c5086f72e03dd"));
var _zeroStyled = require("e30f4d3bc02a51ef");
var _DefaultPropsProvider = require("38f3f5cd10fee417");
var _utils = require("5e40eb546198c145");
var _utils2 = require("787aef3ba5b2eccd");
var _useSlot = _interopRequireDefault(require("f6c854b3a95a4174"));
var _SwipeArea = _interopRequireDefault(require("4fd2f51db45179ad"));
var _jsxRuntime = require("fd5cc5bec775536f");
// This value is closed to what browsers are using internally to
// trigger a native scroll.
const UNCERTAINTY_THRESHOLD = 3; // px
// This is the part of the drawer displayed on touch start.
const DRAG_STARTED_SIGNAL = 20; // px
// We can only have one instance at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
let claimedSwipeInstance = null;
// Exported for test purposes.
function reset() {
    claimedSwipeInstance = null;
}
function calculateCurrentX(anchor, touches, doc) {
    return anchor === 'right' ? doc.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}
function calculateCurrentY(anchor, touches, containerWindow) {
    return anchor === 'bottom' ? containerWindow.innerHeight - touches[0].clientY : touches[0].clientY;
}
function getMaxTranslate(horizontalSwipe, paperInstance) {
    return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}
function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
    return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}
/**
 * @param {Element | null} element
 * @param {Element} rootNode
 */ function getDomTreeShapes(element, rootNode) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
    const domTreeShapes = [];
    while(element && element !== rootNode.parentElement){
        const style = (0, _ownerWindow.default)(rootNode).getComputedStyle(element);
        if (// Ignore the scroll children if the element is absolute positioned.
        style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
        style.getPropertyValue('overflow-x') === 'hidden') ;
        else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) // Ignore the nodes that have no width.
        // Keep elements with a scroll
        domTreeShapes.push(element);
        element = element.parentElement;
    }
    return domTreeShapes;
}
/**
 * @param {object} param0
 * @param {ReturnType<getDomTreeShapes>} param0.domTreeShapes
 */ function computeHasNativeHandler({ domTreeShapes, start, current, anchor }) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
    const axisProperties = {
        scrollPosition: {
            x: 'scrollLeft',
            y: 'scrollTop'
        },
        scrollLength: {
            x: 'scrollWidth',
            y: 'scrollHeight'
        },
        clientLength: {
            x: 'clientWidth',
            y: 'clientHeight'
        }
    };
    return domTreeShapes.some((shape)=>{
        // Determine if we are going backward or forward.
        let goingForward = current >= start;
        if (anchor === 'top' || anchor === 'left') goingForward = !goingForward;
        const axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
        const scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
        const areNotAtStart = scrollPosition > 0;
        const areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
        if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) return true;
        return false;
    });
}
const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
const SwipeableDrawer = /*#__PURE__*/ React.forwardRef(function SwipeableDrawer(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        name: 'MuiSwipeableDrawer',
        props: inProps
    });
    const theme = (0, _zeroStyled.useTheme)();
    const transitionDurationDefault = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor = 'left', disableBackdropTransition = false, disableDiscovery = false, disableSwipeToOpen = iOS, hideBackdrop, hysteresis = 0.52, allowSwipeInChildren = false, minFlingVelocity = 450, ModalProps: { BackdropProps, ...ModalPropsProp } = {}, onClose, onOpen, open = false, PaperProps = {}, SwipeAreaProps, swipeAreaWidth = 20, transitionDuration = transitionDurationDefault, variant = 'temporary', // Mobile first.
    slots = {}, slotProps = {}, ...other } = props;
    const [maybeSwiping, setMaybeSwiping] = React.useState(false);
    const swipeInstance = React.useRef({
        isSwiping: null
    });
    const swipeAreaRef = React.useRef();
    const backdropRef = React.useRef();
    const paperRef = React.useRef();
    const handleRef = (0, _useForkRef.default)(PaperProps.ref, paperRef);
    const touchDetected = React.useRef(false);
    // Ref for transition duration based on / to match swipe speed
    const calculatedDurationRef = React.useRef();
    // Use a ref so the open value used is always up to date inside useCallback.
    (0, _useEnhancedEffect.default)(()=>{
        calculatedDurationRef.current = null;
    }, [
        open
    ]);
    const setPosition = React.useCallback((translate, options = {})=>{
        const { mode = null, changeTransition = true } = options;
        const anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
        const rtlTranslateMultiplier = [
            'right',
            'bottom'
        ].includes(anchorRtl) ? 1 : -1;
        const horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
        const transform = horizontalSwipe ? `translate(${rtlTranslateMultiplier * translate}px, 0)` : `translate(0, ${rtlTranslateMultiplier * translate}px)`;
        const drawerStyle = paperRef.current.style;
        drawerStyle.webkitTransform = transform;
        drawerStyle.transform = transform;
        let transition = '';
        if (mode) transition = theme.transitions.create('all', (0, _utils.getTransitionProps)({
            easing: undefined,
            style: undefined,
            timeout: transitionDuration
        }, {
            mode
        }));
        if (changeTransition) {
            drawerStyle.webkitTransition = transition;
            drawerStyle.transition = transition;
        }
        if (!disableBackdropTransition && !hideBackdrop) {
            const backdropStyle = backdropRef.current.style;
            backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);
            if (changeTransition) {
                backdropStyle.webkitTransition = transition;
                backdropStyle.transition = transition;
            }
        }
    }, [
        anchor,
        disableBackdropTransition,
        hideBackdrop,
        theme,
        transitionDuration
    ]);
    const handleBodyTouchEnd = (0, _useEventCallback.default)((nativeEvent)=>{
        if (!touchDetected.current) return;
        // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- claimedSwipeInstance is a singleton
        claimedSwipeInstance = null;
        touchDetected.current = false;
        ReactDOM.flushSync(()=>{
            setMaybeSwiping(false);
        });
        // The swipe wasn't started.
        if (!swipeInstance.current.isSwiping) {
            swipeInstance.current.isSwiping = null;
            return;
        }
        swipeInstance.current.isSwiping = null;
        const anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
        const horizontal = (0, _Drawer.isHorizontal)(anchor);
        let current;
        if (horizontal) current = calculateCurrentX(anchorRtl, nativeEvent.changedTouches, (0, _ownerDocument.default)(nativeEvent.currentTarget));
        else current = calculateCurrentY(anchorRtl, nativeEvent.changedTouches, (0, _ownerWindow.default)(nativeEvent.currentTarget));
        const startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
        const maxTranslate = getMaxTranslate(horizontal, paperRef.current);
        const currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
        const translateRatio = currentTranslate / maxTranslate;
        if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) // Calculate transition duration to match swipe speed
        calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
        if (open) {
            if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) onClose();
            else // Reset the position, the swipe was aborted.
            setPosition(0, {
                mode: 'exit'
            });
            return;
        }
        if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) onOpen();
        else // Reset the position, the swipe was aborted.
        setPosition(getMaxTranslate(horizontal, paperRef.current), {
            mode: 'enter'
        });
    });
    const startMaybeSwiping = (force = false)=>{
        if (!maybeSwiping) {
            // on Safari Mobile, if you want to be able to have the 'click' event fired on child elements, nothing in the DOM can be changed.
            // this is because Safari Mobile will not fire any mouse events (still fires touch though) if the DOM changes during mousemove.
            // so do this change on first touchmove instead of touchstart
            if (force || !(disableDiscovery && allowSwipeInChildren)) ReactDOM.flushSync(()=>{
                setMaybeSwiping(true);
            });
            const horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
            if (!open && paperRef.current) // The ref may be null when a parent component updates while swiping.
            setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 15 : -DRAG_STARTED_SIGNAL), {
                changeTransition: false
            });
            swipeInstance.current.velocity = 0;
            swipeInstance.current.lastTime = null;
            swipeInstance.current.lastTranslate = null;
            swipeInstance.current.paperHit = false;
            touchDetected.current = true;
        }
    };
    const handleBodyTouchMove = (0, _useEventCallback.default)((nativeEvent)=>{
        // the ref may be null when a parent component updates while swiping
        if (!paperRef.current || !touchDetected.current) return;
        // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
        if (claimedSwipeInstance !== null && claimedSwipeInstance !== swipeInstance.current) return;
        startMaybeSwiping(true);
        const anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
        const horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
        const currentX = calculateCurrentX(anchorRtl, nativeEvent.touches, (0, _ownerDocument.default)(nativeEvent.currentTarget));
        const currentY = calculateCurrentY(anchorRtl, nativeEvent.touches, (0, _ownerWindow.default)(nativeEvent.currentTarget));
        if (open && paperRef.current.contains(nativeEvent.target) && claimedSwipeInstance === null) {
            const domTreeShapes = getDomTreeShapes(nativeEvent.target, paperRef.current);
            const hasNativeHandler = computeHasNativeHandler({
                domTreeShapes,
                start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
                current: horizontalSwipe ? currentX : currentY,
                anchor
            });
            if (hasNativeHandler) {
                claimedSwipeInstance = true;
                return;
            }
            claimedSwipeInstance = swipeInstance.current;
        }
        // We don't know yet.
        if (swipeInstance.current.isSwiping == null) {
            const dx = Math.abs(currentX - swipeInstance.current.startX);
            const dy = Math.abs(currentY - swipeInstance.current.startY);
            const definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;
            if (definitelySwiping && nativeEvent.cancelable) nativeEvent.preventDefault();
            if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
                swipeInstance.current.isSwiping = definitelySwiping;
                if (!definitelySwiping) {
                    handleBodyTouchEnd(nativeEvent);
                    return;
                }
                // Shift the starting point.
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
                // Compensate for the part of the drawer displayed on touch start.
                if (!disableDiscovery && !open) {
                    if (horizontalSwipe) swipeInstance.current.startX -= DRAG_STARTED_SIGNAL;
                    else swipeInstance.current.startY -= DRAG_STARTED_SIGNAL;
                }
            }
        }
        if (!swipeInstance.current.isSwiping) return;
        const maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
        let startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
        if (open && !swipeInstance.current.paperHit) startLocation = Math.min(startLocation, maxTranslate);
        const translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
        if (open) {
            if (!swipeInstance.current.paperHit) {
                const paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
                if (paperHit) {
                    swipeInstance.current.paperHit = true;
                    swipeInstance.current.startX = currentX;
                    swipeInstance.current.startY = currentY;
                } else return;
            } else if (translate === 0) {
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
            }
        }
        if (swipeInstance.current.lastTranslate === null) {
            swipeInstance.current.lastTranslate = translate;
            swipeInstance.current.lastTime = performance.now() + 1;
        }
        const velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3;
        // Low Pass filter.
        swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
        swipeInstance.current.lastTranslate = translate;
        swipeInstance.current.lastTime = performance.now();
        // We are swiping, let's prevent the scroll event on iOS.
        if (nativeEvent.cancelable) nativeEvent.preventDefault();
        setPosition(translate);
    });
    const handleBodyTouchStart = (0, _useEventCallback.default)((nativeEvent)=>{
        // We are not supposed to handle this touch move.
        // Example of use case: ignore the event if there is a Slider.
        if (nativeEvent.defaultPrevented) return;
        // We can only have one node at the time claiming ownership for handling the swipe.
        if (nativeEvent.defaultMuiPrevented) return;
        // At least one element clogs the drawer interaction zone.
        if (open && (hideBackdrop || !backdropRef.current.contains(nativeEvent.target)) && !paperRef.current.contains(nativeEvent.target)) return;
        const anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
        const horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
        const currentX = calculateCurrentX(anchorRtl, nativeEvent.touches, (0, _ownerDocument.default)(nativeEvent.currentTarget));
        const currentY = calculateCurrentY(anchorRtl, nativeEvent.touches, (0, _ownerWindow.default)(nativeEvent.currentTarget));
        if (!open) {
            // logic for if swipe should be ignored:
            // if disableSwipeToOpen
            // if target != swipeArea, and target is not a child of paper ref
            // if is a child of paper ref, and `allowSwipeInChildren` does not allow it
            if (disableSwipeToOpen || !(nativeEvent.target === swipeAreaRef.current || paperRef.current?.contains(nativeEvent.target) && (typeof allowSwipeInChildren === 'function' ? allowSwipeInChildren(nativeEvent, swipeAreaRef.current, paperRef.current) : allowSwipeInChildren))) return;
            if (horizontalSwipe) {
                if (currentX > swipeAreaWidth) return;
            } else if (currentY > swipeAreaWidth) return;
        }
        nativeEvent.defaultMuiPrevented = true;
        claimedSwipeInstance = null;
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
        startMaybeSwiping();
    });
    React.useEffect(()=>{
        if (variant === 'temporary') {
            const doc = (0, _ownerDocument.default)(paperRef.current);
            doc.addEventListener('touchstart', handleBodyTouchStart);
            // A blocking listener prevents Firefox's navbar to auto-hide on scroll.
            // It only needs to prevent scrolling on the drawer's content when open.
            // When closed, the overlay prevents scrolling.
            doc.addEventListener('touchmove', handleBodyTouchMove, {
                passive: !open
            });
            doc.addEventListener('touchend', handleBodyTouchEnd);
            return ()=>{
                doc.removeEventListener('touchstart', handleBodyTouchStart);
                doc.removeEventListener('touchmove', handleBodyTouchMove, {
                    passive: !open
                });
                doc.removeEventListener('touchend', handleBodyTouchEnd);
            };
        }
        return undefined;
    }, [
        variant,
        open,
        handleBodyTouchStart,
        handleBodyTouchMove,
        handleBodyTouchEnd
    ]);
    React.useEffect(()=>()=>{
            // We need to release the lock.
            if (claimedSwipeInstance === swipeInstance.current) claimedSwipeInstance = null;
        }, []);
    React.useEffect(()=>{
        if (!open) setMaybeSwiping(false);
    }, [
        open
    ]);
    const [SwipeAreaSlot, swipeAreaSlotProps] = (0, _useSlot.default)('swipeArea', {
        ref: swipeAreaRef,
        elementType: _SwipeArea.default,
        ownerState: props,
        externalForwardedProps: {
            slots,
            slotProps: {
                swipeArea: SwipeAreaProps,
                ...slotProps
            }
        },
        additionalProps: {
            width: swipeAreaWidth,
            anchor
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Drawer.default, {
                open: variant === 'temporary' && maybeSwiping ? true : open,
                variant: variant,
                ModalProps: {
                    BackdropProps: {
                        ...BackdropProps,
                        ref: backdropRef
                    },
                    // Ensures that paperRef.current will be defined inside the touch start event handler
                    // See https://github.com/mui/material-ui/issues/30414 for more information
                    ...variant === 'temporary' && {
                        keepMounted: true
                    },
                    ...ModalPropsProp
                },
                hideBackdrop: hideBackdrop,
                anchor: anchor,
                transitionDuration: calculatedDurationRef.current || transitionDuration,
                onClose: onClose,
                ref: ref,
                slots: slots,
                slotProps: {
                    ...slotProps,
                    backdrop: (0, _utils2.mergeSlotProps)(slotProps.backdrop ?? BackdropProps, {
                        ref: backdropRef
                    }),
                    paper: (0, _utils2.mergeSlotProps)(slotProps.paper ?? PaperProps, {
                        style: {
                            pointerEvents: variant === 'temporary' && !open && !allowSwipeInChildren ? 'none' : ''
                        },
                        ref: handleRef
                    })
                },
                ...other
            }),
            !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_NoSsr.default, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwipeAreaSlot, {
                    ...swipeAreaSlotProps
                })
            })
        ]
    });
});
var _default = exports.default = SwipeableDrawer;

},{"f089f14c935a5ee5":"kZ6eK","68b6506eaa7efc4a":"fiRIh","f43f4a820223268e":"9njXz","317ee58648582c7b":"2ApDx","1d23b32da97246ba":"bnNSm","f58b2813d78eeeb6":"40NoV","f2f4d6ea804a16b5":"lljNi","ceccb64606585e25":"bbkeu","91ed1da5c44b42cd":"64cM2","f32b0cbf78cdc29":"1juJZ","2768af5eeb1547c7":"lHNEW","96a341d89bb48e0c":"9mQKD","c48c5086f72e03dd":"9wMvV","e30f4d3bc02a51ef":"hZXDo","38f3f5cd10fee417":"9bD8g","5e40eb546198c145":"k52HW","787aef3ba5b2eccd":"dEMJk","f6c854b3a95a4174":"h76AU","4fd2f51db45179ad":"a0suI","fd5cc5bec775536f":"1dlk8"}],"lljNi":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b9b9b0c755ed6082").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _NoSsr.default;
    }
});
var _NoSsr = _interopRequireDefault(require("e74ef92c98078db2"));

},{"b9b9b0c755ed6082":"kZ6eK","e74ef92c98078db2":"dItUc"}],"dItUc":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("260f82920b2d036b").default;
var _interopRequireWildcard = require("155c7bef820fd12c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d4474ec9af39bd47"));
var _propTypes = _interopRequireDefault(require("2997096cf0699895"));
var _useEnhancedEffect = _interopRequireDefault(require("d664a3beca901d07"));
var _exactProp = _interopRequireDefault(require("7cd4ae3e39663f0d"));
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * * Escape hatch for broken dependencies not supporting SSR.
 * * Improve the time-to-first paint on the client by only rendering above the fold.
 * * Reduce the rendering time on the server.
 * * Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://mui.com/material-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://mui.com/material-ui/api/no-ssr/)
 */ function NoSsr(props) {
    const { children, defer = false, fallback = null } = props;
    const [mountedState, setMountedState] = React.useState(false);
    (0, _useEnhancedEffect.default)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    React.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    // TODO casting won't be needed at one point https://github.com/DefinitelyTyped/DefinitelyTyped/pull/65135
    return mountedState ? children : fallback;
}
var _default = exports.default = NoSsr;

},{"260f82920b2d036b":"kZ6eK","155c7bef820fd12c":"fiRIh","d4474ec9af39bd47":"9njXz","2997096cf0699895":"bnNSm","d664a3beca901d07":"fIvqa","7cd4ae3e39663f0d":"jInuK"}],"a0suI":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("8014b51625a21af3").default;
var _interopRequireWildcard = require("ec0aacbfb7070f29").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("bbbc11ba9a36de2d"));
var _propTypes = _interopRequireDefault(require("9fbe52621843dd78"));
var _clsx = _interopRequireDefault(require("bf97465c345225c5"));
var _zeroStyled = require("bd1185f886566ab7");
var _memoTheme = _interopRequireDefault(require("d83e22a72b39628f"));
var _rootShouldForwardProp = _interopRequireDefault(require("2f7e74592f3156c9"));
var _capitalize = _interopRequireDefault(require("2da4e8b1de33d0a5"));
var _Drawer = require("335f81b5190d3e39");
var _jsxRuntime = require("1cfbe5a2b7df2d5e");
const SwipeAreaRoot = (0, _zeroStyled.styled)('div', {
    shouldForwardProp: _rootShouldForwardProp.default
})((0, _memoTheme.default)(({ theme })=>({
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: theme.zIndex.drawer - 1,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    right: 'auto'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    bottom: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    bottom: 0,
                    right: 0
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ const SwipeArea = /*#__PURE__*/ React.forwardRef(function SwipeArea(props, ref) {
    const { anchor, classes = {}, className, width, style, ...other } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwipeAreaRoot, {
        className: (0, _clsx.default)('PrivateSwipeArea-root', classes.root, classes[`anchor${(0, _capitalize.default)(anchor)}`], className),
        ref: ref,
        style: {
            [(0, _Drawer.isHorizontal)(anchor) ? 'width' : 'height']: width,
            ...style
        },
        ownerState: ownerState,
        ...other
    });
});
var _default = exports.default = SwipeArea;

},{"8014b51625a21af3":"kZ6eK","ec0aacbfb7070f29":"fiRIh","bbbc11ba9a36de2d":"9njXz","9fbe52621843dd78":"bnNSm","bf97465c345225c5":"d2NWs","bd1185f886566ab7":"hZXDo","d83e22a72b39628f":"cJNjb","2f7e74592f3156c9":"bTxRc","2da4e8b1de33d0a5":"eOYSA","335f81b5190d3e39":"bbkeu","1cfbe5a2b7df2d5e":"1dlk8"}],"fkySZ":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("aa03de5a3fcdb4c4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("5c286046cf51c0dd"));
var _jsxRuntime = require("aa19f3fa683baffa");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M13 3h-2v10h2zm4.83 2.17-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83"
}), 'PowerSettingsNew');

},{"aa03de5a3fcdb4c4":"kZ6eK","5c286046cf51c0dd":"2vOnF","aa19f3fa683baffa":"1dlk8"}],"6tc0D":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("ffa2e5f361de2684").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("7ba8b00450bd1ab6"));
var _jsxRuntime = require("8bc838c1ac3a31d0");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), 'Person');

},{"ffa2e5f361de2684":"kZ6eK","7ba8b00450bd1ab6":"2vOnF","8bc838c1ac3a31d0":"1dlk8"}],"E2xek":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("52e3f87548a1ed7d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("ce7639b27bea51d0"));
var _jsxRuntime = require("15a968c4027eaa72");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-6 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m6 12H8v-1.5c0-1.99 4-3 6-3s6 1.01 6 3z"
}), 'SwitchAccount');

},{"52e3f87548a1ed7d":"kZ6eK","ce7639b27bea51d0":"2vOnF","15a968c4027eaa72":"1dlk8"}],"eWUlU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TopLeftNav", ()=>TopLeftNav);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _expandMore = require("@mui/icons-material/ExpandMore");
var _expandMoreDefault = parcelHelpers.interopDefault(_expandMore);
var _types = require("common/api/v1/types");
var _link = require("../common/Link");
var _logoFetcher = require("../common/LogoFetcher");
var _store = require("../../store");
var _hooks = require("../../utils/hooks");
const styles = {
    logoWrapper: {
        display: 'flex',
        alignItems: 'center',
        minHeight: '48px',
        marginY: 1,
        marginX: 2
    },
    system: {
        lineHeight: '14px'
    },
    group: {
        fontSize: '10px',
        lineHeight: '12px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    buttonWrapper: {
        textTransform: 'none',
        overflow: 'hidden'
    },
    icon: {
        color: (theme)=>theme.palette.text.secondary
    },
    serviceSelector: {
        color: (theme)=>theme.palette.text.primary
    }
};
const TopLeftNav = ({ title, onClickLogo, logoLink })=>{
    const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
    const routes = (0, _store.useRoutes)();
    const user = (0, _hooks.useUser)();
    const { settings } = (0, _hooks.useSettingsSelector)();
    const handleOpen = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>setAnchorEl(null);
    const defaultOrder = settings?.expFeatures?.ExtHealthAlarms ? (0, _types.ListOutputSortableField).healthStatus : undefined // 'healthStatus' for Input/Output
    ;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.logoWrapper,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                to: logoLink,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoFetcher.TopLeftLogo), {
                    onClick: onClickLogo
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                sx: {
                    marginLeft: 1
                },
                onClick: handleOpen,
                endIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandMoreDefault.default), {
                    sx: styles.icon
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: styles.buttonWrapper,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            component: "div",
                            sx: styles.system,
                            variant: "caption",
                            color: "textPrimary",
                            align: "left",
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            component: "div",
                            sx: styles.group,
                            variant: "caption",
                            color: "textSecondary",
                            align: "left",
                            children: !!user._group && user._group.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                anchorEl: anchorEl,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: [
                    user.role !== (0, _types.Role).basic ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        disabled: title === 'Network Manager',
                        component: (0, _link.Link),
                        to: routes.overview(),
                        muiStyle: styles.serviceSelector,
                        onClick: handleClose,
                        children: "Network Manager"
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        disabled: title === 'Stream Manager',
                        component: (0, _link.Link),
                        to: routes.stream(),
                        muiStyle: styles.serviceSelector,
                        onClick: handleClose,
                        children: "Stream Manager"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        disabled: title === 'Event Manager',
                        component: (0, _link.Link),
                        to: routes.events({
                            desc: defaultOrder
                        }),
                        muiStyle: styles.serviceSelector,
                        onClick: handleClose,
                        children: "Event Manager"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Typography":"6NtGx","@mui/material/Menu":"1ut4X","@mui/material/MenuItem":"krMs8","@mui/icons-material/ExpandMore":"gUaK6","common/api/v1/types":"3qemx","../common/Link":"l3o6V","../common/LogoFetcher":"e3yqy","../../store":"5LXiG","../../utils/hooks":"5aY3q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ut4X":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("77e960cc40c3be8").default;
var _interopRequireDefault = require("bd4bf55cb4f652f3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    menuClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Menu.default;
    }
});
Object.defineProperty(exports, "menuClasses", {
    enumerable: true,
    get: function() {
        return _menuClasses.default;
    }
});
var _Menu = _interopRequireDefault(require("9b789642f37ea686"));
var _menuClasses = _interopRequireWildcard(require("6ef1dd55c5e29f57"));
Object.keys(_menuClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _menuClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _menuClasses[key];
        }
    });
});

},{"77e960cc40c3be8":"fiRIh","bd4bf55cb4f652f3":"kZ6eK","9b789642f37ea686":"bmUG8","6ef1dd55c5e29f57":"67qUP"}],"krMs8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("3e1d2a383635c929").default;
var _interopRequireDefault = require("c5c8c0e0e59d37d9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    menuItemClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _MenuItem.default;
    }
});
Object.defineProperty(exports, "menuItemClasses", {
    enumerable: true,
    get: function() {
        return _menuItemClasses.default;
    }
});
var _MenuItem = _interopRequireDefault(require("462d8df62db13eb2"));
var _menuItemClasses = _interopRequireWildcard(require("5f93693f96ce43d0"));
Object.keys(_menuItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _menuItemClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _menuItemClasses[key];
        }
    });
});

},{"3e1d2a383635c929":"fiRIh","c5c8c0e0e59d37d9":"kZ6eK","462d8df62db13eb2":"jE5ee","5f93693f96ce43d0":"6d0cf"}],"jE5ee":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a2753d9b707a44a6").default;
var _interopRequireWildcard = require("840a66e5ba38c42f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.overridesResolver = exports.default = void 0;
var React = _interopRequireWildcard(require("12b3010416478682"));
var _propTypes = _interopRequireDefault(require("5598d41a3c673755"));
var _clsx = _interopRequireDefault(require("890ee92071bb0214"));
var _composeClasses = _interopRequireDefault(require("2daa05c7e76eaf31"));
var _colorManipulator = require("3a8b1e2713bd9828");
var _rootShouldForwardProp = _interopRequireDefault(require("4822d1291dfc03f5"));
var _zeroStyled = require("b4fffed28ba33411");
var _memoTheme = _interopRequireDefault(require("59768084fecfc96e"));
var _DefaultPropsProvider = require("3255cdf22829c873");
var _ListContext = _interopRequireDefault(require("cce315ca8af8865d"));
var _ButtonBase = _interopRequireDefault(require("7c1a56921dd66254"));
var _useEnhancedEffect = _interopRequireDefault(require("a6bf152eb595db3a"));
var _useForkRef = _interopRequireDefault(require("d06786d323869417"));
var _Divider = require("78156bafc7811dc4");
var _ListItemIcon = require("f0f8f08c430b0913");
var _ListItemText = require("dcbd04bd8ca818df");
var _menuItemClasses = _interopRequireWildcard(require("7491cfc51fe7ffa"));
var _jsxRuntime = require("93fc29f3a6cf0a5e");
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
exports.overridesResolver = overridesResolver;
const useUtilityClasses = (ownerState)=>{
    const { disabled, dense, divider, disableGutters, selected, classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _menuItemClasses.getMenuItemUtilityClass, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const MenuItemRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${_menuItemClasses.default.selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${_menuItemClasses.default.focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${_menuItemClasses.default.selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${_menuItemClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${_menuItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${_Divider.dividerClasses.root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${_Divider.dividerClasses.inset}`]: {
            marginLeft: 52
        },
        [`& .${_ListItemText.listItemTextClasses.root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${_ListItemText.listItemTextClasses.inset}`]: {
            paddingLeft: 36
        },
        [`& .${_ListItemIcon.listItemIconClasses.root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${_ListItemIcon.listItemIconClasses.root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const MenuItem = /*#__PURE__*/ React.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus = false, component = 'li', dense = false, divider = false, disableGutters = false, focusVisibleClassName, role = 'menuitem', tabIndex: tabIndexProp, className, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const childContext = React.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = React.useRef(null);
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider,
        disableGutters
    };
    const classes = useUtilityClasses(props);
    const handleRef = (0, _useForkRef.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, _clsx.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var _default = exports.default = MenuItem;

},{"a2753d9b707a44a6":"kZ6eK","840a66e5ba38c42f":"fiRIh","12b3010416478682":"9njXz","5598d41a3c673755":"bnNSm","890ee92071bb0214":"d2NWs","2daa05c7e76eaf31":"59Equ","3a8b1e2713bd9828":"hTYBL","4822d1291dfc03f5":"bTxRc","b4fffed28ba33411":"hZXDo","59768084fecfc96e":"cJNjb","3255cdf22829c873":"9bD8g","cce315ca8af8865d":"7jlk2","7c1a56921dd66254":"7X8rf","a6bf152eb595db3a":"9wMvV","d06786d323869417":"64cM2","78156bafc7811dc4":"9Ul8c","f0f8f08c430b0913":"2WZ7w","dcbd04bd8ca818df":"1ZvGq","7491cfc51fe7ffa":"6d0cf","93fc29f3a6cf0a5e":"1dlk8"}],"2WZ7w":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a7cab25d9acefdc1").default;
var _interopRequireDefault = require("cfc9a84f8f455625").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemIconClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItemIcon.default;
    }
});
Object.defineProperty(exports, "listItemIconClasses", {
    enumerable: true,
    get: function() {
        return _listItemIconClasses.default;
    }
});
var _ListItemIcon = _interopRequireDefault(require("63dfa4a7cab327a5"));
var _listItemIconClasses = _interopRequireWildcard(require("cddc519ab04d15fc"));
Object.keys(_listItemIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemIconClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemIconClasses[key];
        }
    });
});

},{"a7cab25d9acefdc1":"fiRIh","cfc9a84f8f455625":"kZ6eK","63dfa4a7cab327a5":"i7pEz","cddc519ab04d15fc":"b8uxK"}],"i7pEz":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("225d3c6ff0c19091").default;
var _interopRequireWildcard = require("bf0061f7524a0a87").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("9865721531bae26a"));
var _propTypes = _interopRequireDefault(require("d8645794640cb286"));
var _clsx = _interopRequireDefault(require("698330de586611c6"));
var _composeClasses = _interopRequireDefault(require("2341fd5357ea1701"));
var _zeroStyled = require("7d2bb11ed1ddf12e");
var _memoTheme = _interopRequireDefault(require("2a17734a3adc917"));
var _DefaultPropsProvider = require("f0486bb885513dd");
var _listItemIconClasses = require("b693fb8f10531c42");
var _ListContext = _interopRequireDefault(require("74804cba83ca447e"));
var _jsxRuntime = require("b377a62bd2603863");
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, _composeClasses.default)(slots, _listItemIconClasses.getListItemIconUtilityClass, classes);
};
const ListItemIconRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const ListItemIcon = /*#__PURE__*/ React.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemIconRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var _default = exports.default = ListItemIcon;

},{"225d3c6ff0c19091":"kZ6eK","bf0061f7524a0a87":"fiRIh","9865721531bae26a":"9njXz","d8645794640cb286":"bnNSm","698330de586611c6":"d2NWs","2341fd5357ea1701":"59Equ","7d2bb11ed1ddf12e":"hZXDo","2a17734a3adc917":"cJNjb","f0486bb885513dd":"9bD8g","b693fb8f10531c42":"b8uxK","74804cba83ca447e":"7jlk2","b377a62bd2603863":"1dlk8"}],"b8uxK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3afe92104740bd7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemIconUtilityClass = getListItemIconUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("dbc2861019b7c2bb"));
var _generateUtilityClass = _interopRequireDefault(require("7f49555dc89bea3b"));
function getListItemIconUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItemIcon', slot);
}
const listItemIconClasses = (0, _generateUtilityClasses.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var _default = exports.default = listItemIconClasses;

},{"3afe92104740bd7":"kZ6eK","dbc2861019b7c2bb":"7pSUk","7f49555dc89bea3b":"jBs9M"}],"1ZvGq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("74b3538e9e0caf92").default;
var _interopRequireDefault = require("b63c6f72eb830a43").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemTextClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItemText.default;
    }
});
Object.defineProperty(exports, "listItemTextClasses", {
    enumerable: true,
    get: function() {
        return _listItemTextClasses.default;
    }
});
var _ListItemText = _interopRequireDefault(require("f6ce8929b201c6fd"));
var _listItemTextClasses = _interopRequireWildcard(require("5586d2549579cc89"));
Object.keys(_listItemTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemTextClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemTextClasses[key];
        }
    });
});

},{"74b3538e9e0caf92":"fiRIh","b63c6f72eb830a43":"kZ6eK","f6ce8929b201c6fd":"cTQKN","5586d2549579cc89":"7pOow"}],"cTQKN":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("56ddb8e7e385bab8").default;
var _interopRequireWildcard = require("da03cad74be4ebda").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("725842233d20d423"));
var _propTypes = _interopRequireDefault(require("f9f3a9f92923ec06"));
var _clsx = _interopRequireDefault(require("6bef36b24e0796d6"));
var _composeClasses = _interopRequireDefault(require("c2d6b14a2b73e1f0"));
var _Typography = _interopRequireWildcard(require("66b9baf04dea9be5"));
var _ListContext = _interopRequireDefault(require("c85cf02511b1e76f"));
var _zeroStyled = require("72f033697c022ad2");
var _DefaultPropsProvider = require("d8e44e07eb53265b");
var _listItemTextClasses = _interopRequireWildcard(require("4c36e99f453ca80e"));
var _useSlot = _interopRequireDefault(require("937a7362c21cc0ff"));
var _jsxRuntime = require("227d97559bfc15f2");
const useUtilityClasses = (ownerState)=>{
    const { classes, inset, primary, secondary, dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, _composeClasses.default)(slots, _listItemTextClasses.getListItemTextUtilityClass, classes);
};
const ListItemTextRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_listItemTextClasses.default.primary}`]: styles.primary
            },
            {
                [`& .${_listItemTextClasses.default.secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${_Typography.typographyClasses.root}:where(& .${_listItemTextClasses.default.primary})`]: {
        display: 'block'
    },
    [`.${_Typography.typographyClasses.root}:where(& .${_listItemTextClasses.default.secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const ListItemText = /*#__PURE__*/ React.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children, className, disableTypography = false, inset = false, primary: primaryProp, primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps, slots = {}, slotProps = {}, ...other } = props;
    const { dense } = React.useContext(_ListContext.default);
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography,
        inset,
        primary: !!primary,
        secondary: !!secondary,
        dense
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        className: (0, _clsx.default)(classes.root, className),
        elementType: ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState,
        ref
    });
    const [PrimarySlot, primarySlotProps] = (0, _useSlot.default)('primary', {
        className: classes.primary,
        elementType: _Typography.default,
        externalForwardedProps,
        ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, _useSlot.default)('secondary', {
        className: classes.secondary,
        elementType: _Typography.default,
        externalForwardedProps,
        ownerState
    });
    if (primary != null && primary.type !== _Typography.default && !disableTypography) primary = /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== _Typography.default && !disableTypography) secondary = /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var _default = exports.default = ListItemText;

},{"56ddb8e7e385bab8":"kZ6eK","da03cad74be4ebda":"fiRIh","725842233d20d423":"9njXz","f9f3a9f92923ec06":"bnNSm","6bef36b24e0796d6":"d2NWs","c2d6b14a2b73e1f0":"59Equ","66b9baf04dea9be5":"6NtGx","c85cf02511b1e76f":"7jlk2","72f033697c022ad2":"hZXDo","d8e44e07eb53265b":"9bD8g","4c36e99f453ca80e":"7pOow","937a7362c21cc0ff":"h76AU","227d97559bfc15f2":"1dlk8"}],"7pOow":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ae3b48f463574b1e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemTextUtilityClass = getListItemTextUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("a2163119f6e8ea3d"));
var _generateUtilityClass = _interopRequireDefault(require("d7a9988fa4ed48aa"));
function getListItemTextUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItemText', slot);
}
const listItemTextClasses = (0, _generateUtilityClasses.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var _default = exports.default = listItemTextClasses;

},{"ae3b48f463574b1e":"kZ6eK","a2163119f6e8ea3d":"7pSUk","d7a9988fa4ed48aa":"jBs9M"}],"6d0cf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5c761e84511c7958").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getMenuItemUtilityClass = getMenuItemUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4010a964c50f8829"));
var _generateUtilityClass = _interopRequireDefault(require("2c14d29d66f0ee6f"));
function getMenuItemUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiMenuItem', slot);
}
const menuItemClasses = (0, _generateUtilityClasses.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var _default = exports.default = menuItemClasses;

},{"5c761e84511c7958":"kZ6eK","4010a964c50f8829":"7pSUk","2c14d29d66f0ee6f":"jBs9M"}],"bsK1A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SidebarMenuItem", ()=>SidebarMenuItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _collapse = require("@mui/material/Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _keyboardArrowDown = require("@mui/icons-material/KeyboardArrowDown");
var _keyboardArrowDownDefault = parcelHelpers.interopDefault(_keyboardArrowDown);
var _keyboardArrowRight = require("@mui/icons-material/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _styles = require("@mui/material/styles");
var _link = require("../Link");
var _routes = require("../../../utils/routes");
const styles = {
    listItem: {
        padding: (theme)=>theme.spacing(1.2, 2) + ' !important',
        cursor: 'pointer'
    },
    link: {
        display: 'block',
        outline: 'none',
        transition: (theme)=>theme.transitions.create('background'),
        '&:hover, &:focus': {
            background: (theme)=>(0, _styles.alpha)(theme.palette.common.white, 0.15)
        },
        [`&.selected, &.selected:hover`]: {
            background: (theme)=>theme.palette.primary.main
        }
    }
};
const link = ({ theme })=>({
        display: 'block',
        outline: 'none',
        transition: theme.transitions.create('background'),
        '&:hover, &:focus': {
            background: (0, _styles.alpha)(theme.palette.common.white, 0.15)
        },
        [`&.selected, &.selected:hover`]: {
            background: theme.palette.primary.main
        }
    });
const StyledNavLink = (0, _styles.styled)((0, _link.NavLink))(link);
const SidebarMenuItem = ({ name, url, icon, children, iconColor, onClick, id, secondaryText })=>{
    const currentPath = (0, _reactRouter.useLocation)().pathname;
    const shouldBeExpanded = children?.some((child)=>{
        if (child?.url) {
            const element = document.createElement('a');
            element.href = child.url;
            const menuItemPath = element.pathname;
            return (0, _routes.doesPathBelongTo)(currentPath, menuItemPath);
        }
        return false;
    }) || false;
    const [expanded, setExpanded] = (0, _react.useState)(shouldBeExpanded);
    (0, _react.useEffect)(()=>{
        setExpanded(shouldBeExpanded);
    }, [
        currentPath,
        shouldBeExpanded
    ]);
    const handleOnClick = children ? ()=>setExpanded(!expanded) : onClick;
    const leftPadding = '34px';
    const listItem = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
        dense: true,
        onClick: handleOnClick,
        sx: styles.listItem,
        id: id,
        component: "div",
        children: [
            !!icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                sx: {
                    minWidth: leftPadding,
                    color: iconColor || 'inherit'
                },
                children: icon
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                sx: {
                    paddingLeft: icon ? 0 : leftPadding
                },
                primary: name,
                secondary: secondaryText
            }),
            !!children && (expanded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowDownDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowRightDefault.default), {}))
        ]
    });
    return url ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledNavLink, {
        to: url,
        className: ({ isActive })=>isActive ? 'selected' : '',
        children: listItem
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            listItem,
            !!children && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
                in: expanded,
                "data-testid": `${name}-sub`,
                children: children.map((child, ind)=>{
                    const key = child?.url || `${name}-${ind}`;
                    return !!child && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarMenuItem, {
                                ...child
                            }),
                            child.divider && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                                variant: "middle"
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","@mui/material/Collapse":"c7nwP","@mui/material/ListItem":"fosVg","@mui/material/ListItemIcon":"2WZ7w","@mui/material/ListItemText":"1ZvGq","@mui/material/Divider":"9Ul8c","@mui/icons-material/KeyboardArrowDown":"2TA6B","@mui/icons-material/KeyboardArrowRight":"d6UJH","@mui/material/styles":"2UrBk","../Link":"l3o6V","../../../utils/routes":"cqMGU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fosVg":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("b8cad02c6421810a").default;
var _interopRequireDefault = require("5a3b7e052b201b7d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItem.default;
    }
});
Object.defineProperty(exports, "listItemClasses", {
    enumerable: true,
    get: function() {
        return _listItemClasses.default;
    }
});
var _ListItem = _interopRequireDefault(require("5043a9ca7446c828"));
var _listItemClasses = _interopRequireWildcard(require("198c0eb7b8009a4"));
Object.keys(_listItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemClasses[key];
        }
    });
});

},{"b8cad02c6421810a":"fiRIh","5a3b7e052b201b7d":"kZ6eK","5043a9ca7446c828":"gHKYa","198c0eb7b8009a4":"ejtQO"}],"gHKYa":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("16ac7054e82eb598").default;
var _interopRequireWildcard = require("db0476a62bc7bf8c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.overridesResolver = exports.default = exports.ListItemRoot = void 0;
var React = _interopRequireWildcard(require("e7b5fd07567570b2"));
var _propTypes = _interopRequireDefault(require("1e071990cea7ca3b"));
var _clsx = _interopRequireDefault(require("4c50f82dd3d2d308"));
var _composeClasses = _interopRequireDefault(require("b2d5c0c5430285ec"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("6d6b98e116456696"));
var _chainPropTypes = _interopRequireDefault(require("210c1d45ef608e49"));
var _isHostComponent = _interopRequireDefault(require("422d0b51af5cee87"));
var _zeroStyled = require("81d0697177015d1a");
var _memoTheme = _interopRequireDefault(require("bc47fd5cd419dc07"));
var _DefaultPropsProvider = require("a92c819f9ec59d89");
var _isMuiElement = _interopRequireDefault(require("1fac792743aa5ef2"));
var _useForkRef = _interopRequireDefault(require("4d0e307aa52dc54"));
var _ListContext = _interopRequireDefault(require("decb08a8ce39c224"));
var _listItemClasses = require("db7a19a28978bde2");
var _ListItemButton = require("f6c765b514760b70");
var _ListItemSecondaryAction = _interopRequireDefault(require("4c526483f865b2b7"));
var _jsxRuntime = require("b451dfb1d63a536");
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
exports.overridesResolver = overridesResolver;
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes, dense, disableGutters, disablePadding, divider, hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, _composeClasses.default)(slots, _listItemClasses.getListItemUtilityClass, classes);
};
const ListItemRoot = exports.ListItemRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${_ListItemButton.listItemButtonClasses.root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const ListItemContainer = (0, _zeroStyled.styled)('li', {
    name: 'MuiListItem',
    slot: 'Container'
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const ListItem = /*#__PURE__*/ React.forwardRef(function ListItem(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems = 'center', children: childrenProp, className, component: componentProp, components = {}, componentsProps = {}, ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense = false, disableGutters = false, disablePadding = false, divider = false, secondaryAction, slotProps = {}, slots = {}, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const childContext = React.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems,
            disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = React.useRef(null);
    const children = React.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in a future major release
    const hasSecondaryAction = children.length && (0, _isMuiElement.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems,
        dense: childContext.dense,
        disableGutters,
        disablePadding,
        divider,
        hasSecondaryAction
    };
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRef.default)(listItemRef, ref);
    const Root = slots.root || components.Root || ListItemRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, _clsx.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in a future major release
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListItemContainer, {
                as: ContainerComponent,
                className: (0, _clsx.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
                        ...rootProps,
                        ...!(0, _isHostComponent.default)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, _isHostComponent.default)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListItemSecondaryAction.default, {
                    children: secondaryAction
                })
            ]
        })
    });
});
var _default = exports.default = ListItem;

},{"16ac7054e82eb598":"kZ6eK","db0476a62bc7bf8c":"fiRIh","e7b5fd07567570b2":"9njXz","1e071990cea7ca3b":"bnNSm","4c50f82dd3d2d308":"d2NWs","b2d5c0c5430285ec":"59Equ","6d6b98e116456696":"40NoV","210c1d45ef608e49":"4stnp","422d0b51af5cee87":"19YEO","81d0697177015d1a":"hZXDo","bc47fd5cd419dc07":"cJNjb","a92c819f9ec59d89":"9bD8g","1fac792743aa5ef2":"cF7sw","4d0e307aa52dc54":"64cM2","decb08a8ce39c224":"7jlk2","db7a19a28978bde2":"ejtQO","f6c765b514760b70":"cWRPN","4c526483f865b2b7":"1wcqe","b451dfb1d63a536":"1dlk8"}],"ejtQO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a0fbf072363378").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemUtilityClass = getListItemUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("9d567ff55a2f034c"));
var _generateUtilityClass = _interopRequireDefault(require("2c2677dbca66767d"));
function getListItemUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItem', slot);
}
const listItemClasses = (0, _generateUtilityClasses.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var _default = exports.default = listItemClasses;

},{"a0fbf072363378":"kZ6eK","9d567ff55a2f034c":"7pSUk","2c2677dbca66767d":"jBs9M"}],"cWRPN":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7916a345506d610a").default;
var _interopRequireDefault = require("af7a245f7bd4b199").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemButtonClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItemButton.default;
    }
});
Object.defineProperty(exports, "listItemButtonClasses", {
    enumerable: true,
    get: function() {
        return _listItemButtonClasses.default;
    }
});
var _ListItemButton = _interopRequireDefault(require("e86df1533bb49362"));
var _listItemButtonClasses = _interopRequireWildcard(require("945618413062ae2"));
Object.keys(_listItemButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemButtonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemButtonClasses[key];
        }
    });
});

},{"7916a345506d610a":"fiRIh","af7a245f7bd4b199":"kZ6eK","e86df1533bb49362":"8R8QI","945618413062ae2":"aqUbY"}],"8R8QI":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7eda84615cea832c").default;
var _interopRequireWildcard = require("c2930ac6f1441990").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.overridesResolver = exports.default = void 0;
var React = _interopRequireWildcard(require("630bc205437c66f"));
var _propTypes = _interopRequireDefault(require("2a72f67bae18e59d"));
var _clsx = _interopRequireDefault(require("a7e16be7eba77b6e"));
var _composeClasses = _interopRequireDefault(require("7b6ec45447739d4a"));
var _colorManipulator = require("fc81f985efc7d200");
var _zeroStyled = require("836b5d042e44e84e");
var _memoTheme = _interopRequireDefault(require("a4d1eee37a358139"));
var _DefaultPropsProvider = require("524d0be437a393a3");
var _rootShouldForwardProp = _interopRequireDefault(require("549f7d643f2fca2b"));
var _ButtonBase = _interopRequireDefault(require("1450f01c16e0f8e9"));
var _useEnhancedEffect = _interopRequireDefault(require("891a156af85e80fe"));
var _useForkRef = _interopRequireDefault(require("6db70282f600d9ec"));
var _ListContext = _interopRequireDefault(require("356bf3b5f1040db1"));
var _listItemButtonClasses = _interopRequireWildcard(require("4813bc1371b31196"));
var _jsxRuntime = require("84d4d93e5c1b9e3c");
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
exports.overridesResolver = overridesResolver;
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes, dense, disabled, disableGutters, divider, selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _listItemButtonClasses.getListItemButtonUtilityClass, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const ListItemButtonRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${_listItemButtonClasses.default.selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${_listItemButtonClasses.default.focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${_listItemButtonClasses.default.selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${_listItemButtonClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${_listItemButtonClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const ListItemButton = /*#__PURE__*/ React.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems = 'center', autoFocus = false, component = 'div', children, dense = false, disableGutters = false, divider = false, focusVisibleClassName, selected = false, className, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const childContext = React.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems,
            disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = React.useRef(null);
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        alignItems,
        dense: childContext.dense,
        disableGutters,
        divider,
        selected
    };
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRef.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemButtonRoot, {
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            ...other,
            classes: classes,
            children: children
        })
    });
});
var _default = exports.default = ListItemButton;

},{"7eda84615cea832c":"kZ6eK","c2930ac6f1441990":"fiRIh","630bc205437c66f":"9njXz","2a72f67bae18e59d":"bnNSm","a7e16be7eba77b6e":"d2NWs","7b6ec45447739d4a":"59Equ","fc81f985efc7d200":"hTYBL","836b5d042e44e84e":"hZXDo","a4d1eee37a358139":"cJNjb","524d0be437a393a3":"9bD8g","549f7d643f2fca2b":"bTxRc","1450f01c16e0f8e9":"7X8rf","891a156af85e80fe":"9wMvV","6db70282f600d9ec":"64cM2","356bf3b5f1040db1":"7jlk2","4813bc1371b31196":"aqUbY","84d4d93e5c1b9e3c":"1dlk8"}],"aqUbY":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("32cef171caf747fd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemButtonUtilityClass = getListItemButtonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("2a67b30173b5d560"));
var _generateUtilityClass = _interopRequireDefault(require("750a9e813546927c"));
function getListItemButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItemButton', slot);
}
const listItemButtonClasses = (0, _generateUtilityClasses.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var _default = exports.default = listItemButtonClasses;

},{"32cef171caf747fd":"kZ6eK","2a67b30173b5d560":"7pSUk","750a9e813546927c":"jBs9M"}],"1wcqe":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("f091f62f69a1ab01").default;
var _interopRequireDefault = require("515694cc9ce7208e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemSecondaryActionClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItemSecondaryAction.default;
    }
});
Object.defineProperty(exports, "listItemSecondaryActionClasses", {
    enumerable: true,
    get: function() {
        return _listItemSecondaryActionClasses.default;
    }
});
var _ListItemSecondaryAction = _interopRequireDefault(require("6dfaf075d590276"));
var _listItemSecondaryActionClasses = _interopRequireWildcard(require("b3697ccc77045ba0"));
Object.keys(_listItemSecondaryActionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemSecondaryActionClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemSecondaryActionClasses[key];
        }
    });
});

},{"f091f62f69a1ab01":"fiRIh","515694cc9ce7208e":"kZ6eK","6dfaf075d590276":"2Q18k","b3697ccc77045ba0":"dSfNZ"}],"2Q18k":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("4486bc90c834c55b").default;
var _interopRequireWildcard = require("228845a67f10b840").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("2f2e26b4325be332"));
var _propTypes = _interopRequireDefault(require("d0177c870038da3"));
var _clsx = _interopRequireDefault(require("9302ed49a97ad7ed"));
var _composeClasses = _interopRequireDefault(require("b96a0fb841652a5e"));
var _zeroStyled = require("bc6f60e62cc4a4");
var _DefaultPropsProvider = require("3a37f0ae65a5d43");
var _ListContext = _interopRequireDefault(require("efec3fa5e6fd0cf0"));
var _listItemSecondaryActionClasses = require("de6e2572e25a0d92");
var _jsxRuntime = require("ce3494e980f06c1f");
const useUtilityClasses = (ownerState)=>{
    const { disableGutters, classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, _composeClasses.default)(slots, _listItemSecondaryActionClasses.getListItemSecondaryActionClassesUtilityClass, classes);
};
const ListItemSecondaryActionRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const ListItemSecondaryAction = /*#__PURE__*/ React.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemSecondaryActionRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var _default = exports.default = ListItemSecondaryAction;

},{"4486bc90c834c55b":"kZ6eK","228845a67f10b840":"fiRIh","2f2e26b4325be332":"9njXz","d0177c870038da3":"bnNSm","9302ed49a97ad7ed":"d2NWs","b96a0fb841652a5e":"59Equ","bc6f60e62cc4a4":"hZXDo","3a37f0ae65a5d43":"9bD8g","efec3fa5e6fd0cf0":"7jlk2","de6e2572e25a0d92":"dSfNZ","ce3494e980f06c1f":"1dlk8"}],"dSfNZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5fc74f8c0cbfaffe").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemSecondaryActionClassesUtilityClass = getListItemSecondaryActionClassesUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("43b7965a904c5b48"));
var _generateUtilityClass = _interopRequireDefault(require("5b1301c9a39bece8"));
function getListItemSecondaryActionClassesUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItemSecondaryAction', slot);
}
const listItemSecondaryActionClasses = (0, _generateUtilityClasses.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var _default = exports.default = listItemSecondaryActionClasses;

},{"5fc74f8c0cbfaffe":"kZ6eK","43b7965a904c5b48":"7pSUk","5b1301c9a39bece8":"jBs9M"}],"2TA6B":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("7ec71bc9dc97a207").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b6cb72f80fd9dc2d"));
var _jsxRuntime = require("5e0be801818a8cb1");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');

},{"7ec71bc9dc97a207":"kZ6eK","b6cb72f80fd9dc2d":"2vOnF","5e0be801818a8cb1":"1dlk8"}],"d6UJH":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("2dfd7b2d38f9c33a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b0c93802295799a4"));
var _jsxRuntime = require("3e900950a1367c45");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"
}), 'KeyboardArrowRight');

},{"2dfd7b2d38f9c33a":"kZ6eK","b0c93802295799a4":"2vOnF","3e900950a1367c45":"1dlk8"}],"14jwF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DevModeSwitch);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _settingsActions = require("../../../redux/actions/settingsActions");
var _utils = require("../../../utils");
function DevModeSwitch({ children }) {
    const [clicks, setClicks] = (0, _react.useState)(0);
    const inc = ()=>setClicks((i)=>i + 1);
    const dispatch = (0, _reactRedux.useDispatch)();
    const { devMode } = (0, _utils.useSettingsSelector)();
    (0, _react.useEffect)(()=>{
        const n = 7 - clicks;
        if (n === 0) {
            dispatch((0, _settingsActions.setDevMode)(true));
            // eslint-disable-next-line no-console
            console.log('Development mode activated');
            setClicks(0);
        } else if (clicks > 0) // eslint-disable-next-line no-console
        console.log(`Click ${(0, _utils.pluralize)(n, 'more time')} to activate development mode`);
    }, [
        dispatch,
        clicks
    ]);
    if (devMode) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                sx: {
                    m: '16px',
                    mb: '8px',
                    mt: 0
                },
                label: "Dev mode",
                size: "small",
                color: "warning",
                onDelete: ()=>dispatch((0, _settingsActions.setDevMode)(false))
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        onClick: inc,
        children: children
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Chip":"5cK8z","../../../redux/actions/settingsActions":"4RBnR","../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5cK8z":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("f3b7fffa7afa1c9c").default;
var _interopRequireDefault = require("87079cab0311460d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    chipClasses: true
};
Object.defineProperty(exports, "chipClasses", {
    enumerable: true,
    get: function() {
        return _chipClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Chip.default;
    }
});
var _Chip = _interopRequireDefault(require("ab746630c55f4da5"));
var _chipClasses = _interopRequireWildcard(require("ec1bef03382a61b8"));
Object.keys(_chipClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _chipClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _chipClasses[key];
        }
    });
});

},{"f3b7fffa7afa1c9c":"fiRIh","87079cab0311460d":"kZ6eK","ab746630c55f4da5":"kBrko","ec1bef03382a61b8":"csO1S"}],"kBrko":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("790afb04e3db7286").default;
var _interopRequireWildcard = require("64d8e6b723d3d851").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("140749520f1c2c9b"));
var _propTypes = _interopRequireDefault(require("fdbbf52fdfbd7bb9"));
var _clsx = _interopRequireDefault(require("43eb7f8f2d8181dc"));
var _composeClasses = _interopRequireDefault(require("2c815ea6300e2eea"));
var _colorManipulator = require("142b28119b67c46e");
var _Cancel = _interopRequireDefault(require("ae849bce92cb9434"));
var _useForkRef = _interopRequireDefault(require("a44330521aa1ec9f"));
var _unsupportedProp = _interopRequireDefault(require("7c3f0ab7940626e9"));
var _capitalize = _interopRequireDefault(require("8ba32b01208fa3a3"));
var _ButtonBase = _interopRequireDefault(require("5ff41dab59f3c1ac"));
var _zeroStyled = require("d9531f3e62e79d2e");
var _memoTheme = _interopRequireDefault(require("4f9c39643c60f67f"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("3a1184b68aea605d"));
var _DefaultPropsProvider = require("1015e878cc0215f9");
var _chipClasses = _interopRequireWildcard(require("32f87e9a86bc5afa"));
var _jsxRuntime = require("ef3a2e9793583fa3");
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, size, color, iconColor, onDelete, clickable, variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, _capitalize.default)(size)}`,
            `color${(0, _capitalize.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, _capitalize.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, _capitalize.default)(color)}`,
            `${variant}${(0, _capitalize.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, _capitalize.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, _capitalize.default)(size)}`,
            `avatarColor${(0, _capitalize.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, _capitalize.default)(size)}`,
            `iconColor${(0, _capitalize.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, _capitalize.default)(size)}`,
            `deleteIconColor${(0, _capitalize.default)(color)}`,
            `deleteIcon${(0, _capitalize.default)(variant)}Color${(0, _capitalize.default)(color)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _chipClasses.getChipUtilityClass, classes);
};
const ChipRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { color, iconColor, clickable, onDelete, size, variant } = ownerState;
        return [
            {
                [`& .${_chipClasses.default.avatar}`]: styles.avatar
            },
            {
                [`& .${_chipClasses.default.avatar}`]: styles[`avatar${(0, _capitalize.default)(size)}`]
            },
            {
                [`& .${_chipClasses.default.avatar}`]: styles[`avatarColor${(0, _capitalize.default)(color)}`]
            },
            {
                [`& .${_chipClasses.default.icon}`]: styles.icon
            },
            {
                [`& .${_chipClasses.default.icon}`]: styles[`icon${(0, _capitalize.default)(size)}`]
            },
            {
                [`& .${_chipClasses.default.icon}`]: styles[`iconColor${(0, _capitalize.default)(iconColor)}`]
            },
            {
                [`& .${_chipClasses.default.deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, _capitalize.default)(size)}`]
            },
            {
                [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIconColor${(0, _capitalize.default)(color)}`]
            },
            {
                [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, _capitalize.default)(variant)}Color${(0, _capitalize.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, _capitalize.default)(size)}`],
            styles[`color${(0, _capitalize.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, _capitalize.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, _capitalize.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, _capitalize.default)(color)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${_chipClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${_chipClasses.default.avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${_chipClasses.default.avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${_chipClasses.default.avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${_chipClasses.default.avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${_chipClasses.default.icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${_chipClasses.default.deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${_chipClasses.default.icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${_chipClasses.default.deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${_chipClasses.default.deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].contrastTextChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${_chipClasses.default.icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${_chipClasses.default.icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${_chipClasses.default.focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color,
                        onDelete: true
                    },
                    style: {
                        [`&.${_chipClasses.default.focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
                    },
                    [`&.${_chipClasses.default.focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${_chipClasses.default.focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${_chipClasses.default.clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${_chipClasses.default.focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${_chipClasses.default.avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${_chipClasses.default.avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${_chipClasses.default.icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${_chipClasses.default.iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${_chipClasses.default.deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${_chipClasses.default.deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.7)}`,
                        [`&.${_chipClasses.default.clickable}:hover`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        },
                        [`&.${_chipClasses.default.focusVisible}`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.focusOpacity)
                        },
                        [`& .${_chipClasses.default.deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const ChipLabel = (0, _zeroStyled.styled)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, _capitalize.default)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const Chip = /*#__PURE__*/ React.forwardRef(function Chip(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className, clickable: clickableProp, color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled = false, icon: iconProp, label, onClick, onDelete, onKeyDown, onKeyUp, size = 'medium', variant = 'filled', tabIndex, skipFocusWhenDisabled = false, // TODO v6: Rename to `focusableWhenDisabled`.
    ...other } = props;
    const chipRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? _ButtonBase.default : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component,
        disabled,
        size,
        color,
        iconColor: /*#__PURE__*/ React.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const moreProps = component === _ButtonBase.default ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ React.isValidElement(deleteIconProp) ? /*#__PURE__*/ React.cloneElement(deleteIconProp, {
        className: (0, _clsx.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Cancel.default, {
        className: classes.deleteIcon,
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ React.isValidElement(avatarProp)) avatar = /*#__PURE__*/ React.cloneElement(avatarProp, {
        className: (0, _clsx.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ React.isValidElement(iconProp)) icon = /*#__PURE__*/ React.cloneElement(iconProp, {
        className: (0, _clsx.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ChipRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState,
        ...moreProps,
        ...other,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChipLabel, {
                className: classes.label,
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    });
});
var _default = exports.default = Chip;

},{"790afb04e3db7286":"kZ6eK","64d8e6b723d3d851":"fiRIh","140749520f1c2c9b":"9njXz","fdbbf52fdfbd7bb9":"bnNSm","43eb7f8f2d8181dc":"d2NWs","2c815ea6300e2eea":"59Equ","142b28119b67c46e":"hTYBL","ae849bce92cb9434":"8fU4U","a44330521aa1ec9f":"64cM2","7c3f0ab7940626e9":"4ygWT","8ba32b01208fa3a3":"eOYSA","5ff41dab59f3c1ac":"7X8rf","d9531f3e62e79d2e":"hZXDo","4f9c39643c60f67f":"cJNjb","3a1184b68aea605d":"2r5WG","1015e878cc0215f9":"9bD8g","32f87e9a86bc5afa":"csO1S","ef3a2e9793583fa3":"1dlk8"}],"8fU4U":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("f9311891e1b03b6f").default;
var _interopRequireWildcard = require("79c89c4fb5ddd8e7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("9a60454583dd8072"));
var _createSvgIcon = _interopRequireDefault(require("50524fba09936a7a"));
var _jsxRuntime = require("28e1ccc475913f1f");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

},{"f9311891e1b03b6f":"kZ6eK","79c89c4fb5ddd8e7":"fiRIh","9a60454583dd8072":"9njXz","50524fba09936a7a":"5sni0","28e1ccc475913f1f":"1dlk8"}],"csO1S":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8f9bbe87910681e5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getChipUtilityClass = getChipUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("5e148c32be85ef5c"));
var _generateUtilityClass = _interopRequireDefault(require("4ace27b03551a40b"));
function getChipUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiChip', slot);
}
const chipClasses = (0, _generateUtilityClasses.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var _default = exports.default = chipClasses;

},{"8f9bbe87910681e5":"kZ6eK","5e148c32be85ef5c":"7pSUk","4ace27b03551a40b":"jBs9M"}],"fdM7M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalCreate", ()=>GlobalCreate);
var _jsxRuntime = require("react/jsx-runtime");
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _react = require("react");
var _reactRouter = require("react-router");
var _store = require("../../../store");
var _utils = require("../../../utils");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _listSubheader = require("@mui/material/ListSubheader");
var _listSubheaderDefault = parcelHelpers.interopDefault(_listSubheader);
var _types = require("common/api/v1/types");
var _addEdgeConnectDialog = require("../../appliances/AddEdgeConnectDialog");
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemButton = require("@mui/material/ListItemButton");
var _listItemButtonDefault = parcelHelpers.interopDefault(_listItemButton);
const GlobalCreate = ({ devMode })=>{
    const { settings } = (0, _utils.useSettingsSelector)();
    const expFeatures = settings?.expFeatures;
    const routes = (0, _store.useRoutes)();
    const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
    const open = Boolean(anchorEl);
    const user = (0, _utils.useUser)();
    const [showAddEdgeConnectDialog, setShowAddEdgeConnectDialog] = (0, _react.useState)(false);
    if (![
        (0, _types.Role).super,
        (0, _types.Role).admin
    ].includes(user.role)) return null;
    const handleClick = (event)=>{
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event)=>{
        event.stopPropagation();
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemButtonDefault.default), {
                dense: true,
                onClick: handleClick,
                sx: {
                    padding: (theme)=>theme.spacing(1.2, 2) + ' !important',
                    flexGrow: 0,
                    cursor: 'pointer'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                        sx: {
                            minWidth: '34px',
                            color: 'inherit'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                        sx: {
                            paddingLeft: 0
                        },
                        primary: "Create new..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listSubheaderDefault.default), {
                        children: "Streaming"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        component: (0, _reactRouter.Link),
                        to: routes.inputsNew(),
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            primary: "Input"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        component: (0, _reactRouter.Link),
                        to: routes.outputsNew(),
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            primary: "Output"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        component: (0, _reactRouter.Link),
                        to: routes.outputListsNew(),
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            primary: "Output List"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listSubheaderDefault.default), {
                        children: "Administration"
                    }),
                    user.role === (0, _types.Role).super && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        component: (0, _reactRouter.Link),
                        to: routes.usersNew(),
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            primary: "User"
                        })
                    }),
                    user.role === (0, _types.Role).super && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        component: (0, _reactRouter.Link),
                        to: routes.groupsNew(),
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            primary: "Group"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        component: (0, _reactRouter.Link),
                        to: routes.groupListsNew(),
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            primary: "Group List"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: (e)=>{
                            handleClose(e);
                            setShowAddEdgeConnectDialog(true);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            primary: "Edge Connect"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listSubheaderDefault.default), {
                        children: "Networking"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        component: (0, _reactRouter.Link),
                        to: routes.addressMappingsNew(),
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            primary: "Address Mapping"
                        })
                    }),
                    user.role === (0, _types.Role).super && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        component: (0, _reactRouter.Link),
                        to: routes.networkNew(),
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            primary: "Network"
                        })
                    }),
                    devMode && expFeatures?.ExtDerivedInput && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listSubheaderDefault.default), {
                                children: "Transcoding"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                component: (0, _reactRouter.Link),
                                to: routes.overlaysNew(),
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                    primary: "Overlay"
                                })
                            })
                        ]
                    }),
                    expFeatures?.AdInsertion && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listSubheaderDefault.default), {
                                children: "Ad insertion"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                component: (0, _reactRouter.Link),
                                to: routes.adCreativesNew(),
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                    primary: "Creative"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                component: (0, _reactRouter.Link),
                                to: routes.adPodsNew(),
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                    primary: "Pod"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                component: (0, _reactRouter.Link),
                                to: routes.adServersNew(),
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                    primary: "External Ad Server"
                                })
                            })
                        ]
                    })
                ]
            }),
            showAddEdgeConnectDialog && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEdgeConnectDialog.AddEdgeConnectDialog), {
                user: user,
                open: showAddEdgeConnectDialog,
                onClose: ()=>setShowAddEdgeConnectDialog(false)
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/icons-material/Add":"jrNj7","@mui/material/ListItemText":"1ZvGq","@mui/material/Menu":"1ut4X","@mui/material/MenuItem":"krMs8","react":"9njXz","react-router":"iaz4C","../../../store":"5LXiG","../../../utils":"342UB","@mui/material/Divider":"9Ul8c","@mui/material/ListSubheader":"ldVLf","common/api/v1/types":"3qemx","../../appliances/AddEdgeConnectDialog":"bq9W1","@mui/material/ListItemIcon":"2WZ7w","@mui/material/ListItemButton":"cWRPN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jrNj7":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("18a23610d276482a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("ed61619ca1b8a2c"));
var _jsxRuntime = require("423147912c296b5f");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');

},{"18a23610d276482a":"kZ6eK","ed61619ca1b8a2c":"2vOnF","423147912c296b5f":"1dlk8"}],"ldVLf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("474e56f030cb38cc").default;
var _interopRequireDefault = require("2a7cde5d5e7aed8c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listSubheaderClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListSubheader.default;
    }
});
Object.defineProperty(exports, "listSubheaderClasses", {
    enumerable: true,
    get: function() {
        return _listSubheaderClasses.default;
    }
});
var _ListSubheader = _interopRequireDefault(require("9a2d7c0765cc4795"));
var _listSubheaderClasses = _interopRequireWildcard(require("9a5bb8983b034d6c"));
Object.keys(_listSubheaderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listSubheaderClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listSubheaderClasses[key];
        }
    });
});

},{"474e56f030cb38cc":"fiRIh","2a7cde5d5e7aed8c":"kZ6eK","9a2d7c0765cc4795":"bXg4b","9a5bb8983b034d6c":"6f9dn"}],"bXg4b":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c6cf97472336c946").default;
var _interopRequireWildcard = require("6d841e255d64e54f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("656dd3a36fd7eea3"));
var _propTypes = _interopRequireDefault(require("cc75123b9b1e03da"));
var _clsx = _interopRequireDefault(require("52f92b367038d103"));
var _composeClasses = _interopRequireDefault(require("3a33c93a5978e1c1"));
var _zeroStyled = require("fb34b9426f252a91");
var _memoTheme = _interopRequireDefault(require("9d1017815a62dd9a"));
var _DefaultPropsProvider = require("d4037a88b79b7cc6");
var _capitalize = _interopRequireDefault(require("b86760d37330bf67"));
var _listSubheaderClasses = require("ec47f39857cd8a75");
var _jsxRuntime = require("b50421bace1ecd54");
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disableGutters, inset, disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, _capitalize.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, _composeClasses.default)(slots, _listSubheaderClasses.getListSubheaderUtilityClass, classes);
};
const ListSubheaderRoot = (0, _zeroStyled.styled)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const ListSubheader = /*#__PURE__*/ React.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className, color = 'default', component = 'li', disableGutters = false, disableSticky = false, inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color,
        component,
        disableGutters,
        disableSticky,
        inset
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListSubheaderRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if (ListSubheader) ListSubheader.muiSkipListHighlight = true;
var _default = exports.default = ListSubheader;

},{"c6cf97472336c946":"kZ6eK","6d841e255d64e54f":"fiRIh","656dd3a36fd7eea3":"9njXz","cc75123b9b1e03da":"bnNSm","52f92b367038d103":"d2NWs","3a33c93a5978e1c1":"59Equ","fb34b9426f252a91":"hZXDo","9d1017815a62dd9a":"cJNjb","d4037a88b79b7cc6":"9bD8g","b86760d37330bf67":"eOYSA","ec47f39857cd8a75":"6f9dn","b50421bace1ecd54":"1dlk8"}],"6f9dn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("117e0a356c47c414").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListSubheaderUtilityClass = getListSubheaderUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("379d89a398706b01"));
var _generateUtilityClass = _interopRequireDefault(require("43fc7a3aa562b66c"));
function getListSubheaderUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListSubheader', slot);
}
const listSubheaderClasses = (0, _generateUtilityClasses.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var _default = exports.default = listSubheaderClasses;

},{"117e0a356c47c414":"kZ6eK","379d89a398706b01":"7pSUk","43fc7a3aa562b66c":"jBs9M"}],"bq9W1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddEdgeConnectDialog", ()=>AddEdgeConnectDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _react = require("react");
var _utils = require("../../utils");
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _tooltip = require("../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _xDatePickers = require("@mui/x-date-pickers");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _contentCopy = require("@mui/icons-material/ContentCopy");
var _contentCopyDefault = parcelHelpers.interopDefault(_contentCopy);
var _reactSyntaxHighlighter = require("react-syntax-highlighter");
var _code = require("../../themes/code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactRedux = require("react-redux");
var _types = require("common/api/v1/types");
var _groupActions = require("../../redux/actions/groupActions");
const AddEdgeConnectDialog = ({ open, onClose, user })=>{
    const theme = (0, _styles.useTheme)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const [showCopied, setShowCopied] = (0, _react.useState)(false);
    const [groups, setGroups] = (0, _react.useState)([]);
    const fetchAllGroups = async ()=>{
        return dispatch((0, _groupActions.getGroups)({
            pageNumber: '0',
            rowsPerPage: '1000'
        })).then((res)=>{
            return res.payload.items;
        });
    };
    const fetchUserGroup = async ()=>{
        return dispatch((0, _groupActions.getGroup)(user.group)).then((res)=>res.payload);
    };
    (0, _react.useEffect)(()=>{
        fetchUserGroup().then((group)=>{
            if (!group) return;
            setCopyCommandGroup(group.name);
            // Only superusers can see appliance secrets in all groups
            if (user.role === (0, _types.Role).super) fetchAllGroups().then((groups)=>{
                setGroups(groups);
            });
            else setGroups([
                group
            ]);
        });
    }, []);
    const regionSel = (0, _utils.useRegionsSelector)((0, _utils.withDefaultPagination)({
        pageNumber: '0',
        rowsPerPage: '1000'
    }));
    const [copyCommandGroup, setCopyCommandGroup] = (0, _react.useState)('system');
    const [copyCommandName, setCopyCommandName] = (0, _react.useState)('edge-connect');
    const [copyCommandRegion, setCopyCommandRegion] = (0, _react.useState)('');
    const copyCommand = ()=>{
        if (!groups) return undefined;
        const matchedGroup = groups.filter((group)=>group.name === copyCommandGroup);
        if (matchedGroup.length === 0) return undefined;
        const secret = matchedGroup[0].applianceSecret;
        if (!secret) return undefined;
        return `curl --output connectit "${window.location.origin}/connectit"
chmod +x connectit
sudo SECRET="${secret}" ./connectit install edge-connect \\
  --url "${window.location.origin}" \\
  --name "${copyCommandName}"` + (copyCommandRegion ? ` \\
  --region "${copyCommandRegion}"` : '');
    };
    const onCopy = ()=>{
        const cmd = copyCommand();
        if (!cmd) return;
        navigator.clipboard.writeText(cmd);
        setShowCopied(true);
        setTimeout(()=>{
            setShowCopied(false);
        }, 1500);
    };
    const handleClose = ()=>{
        onClose();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: open,
        onClose: handleClose,
        maxWidth: "md",
        fullWidth: true,
        disableRestoreFocus: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        mt: 3,
                        mb: 1,
                        width: 'auto',
                        maxWidth: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                display: 'flex',
                                alignItems: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    variant: "h4",
                                    children: "Start an Edge Connect"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                    title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                variant: "inherit",
                                                children: "Run this command on a Linux machine to install Edge Connect."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                variant: "inherit",
                                                children: "Docker must be installed before running the command."
                                            })
                                        ]
                                    }),
                                    sx: {
                                        ml: 1,
                                        mr: 1,
                                        scale: 1.1
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                    variant: "outlined",
                                    size: "small",
                                    label: "Name",
                                    value: copyCommandName,
                                    error: copyCommandName.length === 0,
                                    onChange: (e)=>setCopyCommandName(e.target.value.replace(/[^a-zA-Z0-9_.-]/g, '')),
                                    sx: {
                                        width: '150px',
                                        ml: 2
                                    }
                                }),
                                groups.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                                    variant: "outlined",
                                    size: "small",
                                    sx: {
                                        minWidth: '100px',
                                        maxWidth: '300px',
                                        ml: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                            children: "Group"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                                            label: "Group",
                                            value: copyCommandGroup,
                                            onChange: (e)=>setCopyCommandGroup(e.target.value),
                                            children: groups.map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                                    value: group.name,
                                                    children: group.name
                                                }, group.id))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                                    variant: "outlined",
                                    size: "small",
                                    sx: {
                                        minWidth: '170px',
                                        ml: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                            children: "Region (Optional)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                                            label: "Region (Optional)",
                                            value: copyCommandRegion,
                                            onChange: (e)=>setCopyCommandRegion(e.target.value),
                                            endAdornment: copyCommandRegion.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
                                                sx: {
                                                    marginRight: '10px'
                                                },
                                                position: "end",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                                    sx: {
                                                        scale: 0.8
                                                    },
                                                    onClick: ()=>{
                                                        setCopyCommandRegion('');
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.ClearIcon), {})
                                                })
                                            }),
                                            children: regionSel.regions.map((region)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                                    value: region.name,
                                                    children: region.name
                                                }, region.id))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                            sx: {
                                borderStyle: 'none'
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                position: 'relative',
                                display: 'inline-block',
                                maxWidth: '100%'
                            },
                            children: [
                                navigator.clipboard && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        position: 'absolute',
                                        mt: 2,
                                        mr: 1,
                                        top: 4,
                                        right: 4,
                                        zIndex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "body2",
                                            sx: {
                                                mr: 1,
                                                opacity: showCopied ? 1 : 0,
                                                visibility: showCopied ? 'visible' : 'hidden',
                                                transition: 'opacity 0.3s ease, visibility 0.3s ease'
                                            },
                                            children: "Copied!"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                            onClick: onCopy,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentCopyDefault.default), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSyntaxHighlighter.Prism), {
                                    language: "bash",
                                    style: (0, _codeDefault.default),
                                    codeTagProps: {
                                        style: {
                                            backgroundColor: 'transparent'
                                        }
                                    },
                                    customStyle: {
                                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                        border: '1px solid ' + theme.palette.divider,
                                        width: 'auto'
                                    },
                                    children: copyCommand() || 'Loading...\n\n\n'
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogActionsDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: handleClose,
                    color: "primary",
                    autoFocus: true,
                    children: "Close"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/styles":"2UrBk","react":"9njXz","../../utils":"342UB","@mui/material/Dialog":"aOxpM","@mui/material/DialogContent":"l4i9c","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","../common/Tooltip":"crjvg","@mui/icons-material/HelpOutline":"2sIqE","@mui/material/TextField":"l88b4","@mui/material/FormControl":"ioFZ4","@mui/material/InputLabel":"5EJtb","@mui/material/Select":"kyj0v","@mui/material/MenuItem":"krMs8","@mui/material/InputAdornment":"3vWJT","@mui/material/IconButton":"488As","@mui/x-date-pickers":"gSoHo","@mui/material/Divider":"9Ul8c","@mui/icons-material/ContentCopy":"ivEEo","react-syntax-highlighter":"jg2jw","../../themes/code":"goW8x","@mui/material/DialogActions":"h1RVn","@mui/material/Button":"3qJY9","react-redux":"l1pMU","common/api/v1/types":"3qemx","../../redux/actions/groupActions":"bqPI2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"crjvg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
const Tooltip = ({ children, disablePortal, ...props })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        PopperProps: {
            disablePortal: disablePortal ?? true
        },
        slotProps: {
            tooltip: {
                sx: {
                    textTransform: 'none'
                }
            }
        },
        ...props,
        children: children
    });
};
exports.default = Tooltip;

},{"react/jsx-runtime":"1dlk8","@mui/material/Tooltip":"2soEB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2sIqE":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("509afa7612b9b99b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("98602eb403d8e69c"));
var _jsxRuntime = require("f33202b211d6d45a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), 'HelpOutline');

},{"509afa7612b9b99b":"kZ6eK","98602eb403d8e69c":"2vOnF","f33202b211d6d45a":"1dlk8"}],"3vWJT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("37eff11afc8217fd").default;
var _interopRequireDefault = require("66868f9581a3e8aa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    inputAdornmentClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _InputAdornment.default;
    }
});
Object.defineProperty(exports, "inputAdornmentClasses", {
    enumerable: true,
    get: function() {
        return _inputAdornmentClasses.default;
    }
});
var _InputAdornment = _interopRequireDefault(require("b2e8aa9b92ec3f94"));
var _inputAdornmentClasses = _interopRequireWildcard(require("a527904544d9d692"));
Object.keys(_inputAdornmentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _inputAdornmentClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _inputAdornmentClasses[key];
        }
    });
});

},{"37eff11afc8217fd":"fiRIh","66868f9581a3e8aa":"kZ6eK","b2e8aa9b92ec3f94":"6rlqs","a527904544d9d692":"6Ay2n"}],"6rlqs":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("c495c5928d78cbdf").default;
var _interopRequireDefault = require("64a8b07d3aacb582").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("6e6155e9fe67682a"));
var _propTypes = _interopRequireDefault(require("af52419d48dd22e5"));
var _clsx = _interopRequireDefault(require("78352ade51774897"));
var _composeClasses = _interopRequireDefault(require("cc56c9086f099af5"));
var _capitalize = _interopRequireDefault(require("91052b6b316a3dd1"));
var _Typography = _interopRequireDefault(require("7e35693935c7d088"));
var _FormControlContext = _interopRequireDefault(require("4e86efd253d5390e"));
var _useFormControl = _interopRequireDefault(require("1f92c352270ebea8"));
var _zeroStyled = require("a34d60f66a5983e1");
var _memoTheme = _interopRequireDefault(require("120a717529faa85b"));
var _DefaultPropsProvider = require("28c23f4955ce8bba");
var _inputAdornmentClasses = _interopRequireWildcard(require("c78580d7c67d1072"));
var _jsxRuntime = require("6ff19590fd76a22a");
var _span;
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, _capitalize.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePointerEvents, hiddenLabel, position, size, variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, _capitalize.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, _capitalize.default)(size)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _inputAdornmentClasses.getInputAdornmentUtilityClass, classes);
};
const InputAdornmentRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${_inputAdornmentClasses.default.positionStart}&:not(.${_inputAdornmentClasses.default.hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const InputAdornment = /*#__PURE__*/ React.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children, className, component = 'div', disablePointerEvents = false, disableTypography = false, position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents,
        position,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormControlContext.default.Provider, {
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Typography.default, {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var _default = exports.default = InputAdornment;

},{"c495c5928d78cbdf":"fiRIh","64a8b07d3aacb582":"kZ6eK","6e6155e9fe67682a":"9njXz","af52419d48dd22e5":"bnNSm","78352ade51774897":"d2NWs","cc56c9086f099af5":"59Equ","91052b6b316a3dd1":"eOYSA","7e35693935c7d088":"6NtGx","4e86efd253d5390e":"44WyX","1f92c352270ebea8":"51J7f","a34d60f66a5983e1":"hZXDo","120a717529faa85b":"cJNjb","28c23f4955ce8bba":"9bD8g","c78580d7c67d1072":"6Ay2n","6ff19590fd76a22a":"1dlk8"}],"6Ay2n":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7d6e4af70deed730").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getInputAdornmentUtilityClass = getInputAdornmentUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("21c434ebf84e4d88"));
var _generateUtilityClass = _interopRequireDefault(require("6db6438332726b56"));
function getInputAdornmentUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiInputAdornment', slot);
}
const inputAdornmentClasses = (0, _generateUtilityClasses.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var _default = exports.default = inputAdornmentClasses;

},{"7d6e4af70deed730":"kZ6eK","21c434ebf84e4d88":"7pSUk","6db6438332726b56":"jBs9M"}],"gSoHo":[function(require,module,exports,__globalThis) {
/**
 * @mui/x-date-pickers v8.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Clocks
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_DESKTOP_MODE_MEDIA_QUERY", ()=>(0, _utilsJs.DEFAULT_DESKTOP_MODE_MEDIA_QUERY));
var _indexJs = require("./TimeClock/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _indexJs1 = require("./DigitalClock/index.js");
parcelHelpers.exportAll(_indexJs1, exports);
var _indexJs2 = require("./MultiSectionDigitalClock/index.js");
parcelHelpers.exportAll(_indexJs2, exports);
var _indexJs3 = require("./LocalizationProvider/index.js");
parcelHelpers.exportAll(_indexJs3, exports);
var _indexJs4 = require("./PickersDay/index.js");
parcelHelpers.exportAll(_indexJs4, exports);
var _pickersLocaleTextApiJs = require("./locales/utils/pickersLocaleTextApi.js");
parcelHelpers.exportAll(_pickersLocaleTextApiJs, exports);
// Fields
var _indexJs5 = require("./DateField/index.js");
parcelHelpers.exportAll(_indexJs5, exports);
var _indexJs6 = require("./TimeField/index.js");
parcelHelpers.exportAll(_indexJs6, exports);
var _indexJs7 = require("./DateTimeField/index.js");
parcelHelpers.exportAll(_indexJs7, exports);
// Calendars
var _indexJs8 = require("./DateCalendar/index.js");
parcelHelpers.exportAll(_indexJs8, exports);
var _indexJs9 = require("./MonthCalendar/index.js");
parcelHelpers.exportAll(_indexJs9, exports);
var _indexJs10 = require("./YearCalendar/index.js");
parcelHelpers.exportAll(_indexJs10, exports);
var _indexJs11 = require("./DayCalendarSkeleton/index.js");
parcelHelpers.exportAll(_indexJs11, exports);
// New Pickers
var _indexJs12 = require("./DatePicker/index.js");
parcelHelpers.exportAll(_indexJs12, exports);
var _indexJs13 = require("./DesktopDatePicker/index.js");
parcelHelpers.exportAll(_indexJs13, exports);
var _indexJs14 = require("./MobileDatePicker/index.js");
parcelHelpers.exportAll(_indexJs14, exports);
var _indexJs15 = require("./StaticDatePicker/index.js");
parcelHelpers.exportAll(_indexJs15, exports);
var _indexJs16 = require("./TimePicker/index.js");
parcelHelpers.exportAll(_indexJs16, exports);
var _indexJs17 = require("./DesktopTimePicker/index.js");
parcelHelpers.exportAll(_indexJs17, exports);
var _indexJs18 = require("./MobileTimePicker/index.js");
parcelHelpers.exportAll(_indexJs18, exports);
var _indexJs19 = require("./StaticTimePicker/index.js");
parcelHelpers.exportAll(_indexJs19, exports);
var _indexJs20 = require("./DateTimePicker/index.js");
parcelHelpers.exportAll(_indexJs20, exports);
var _indexJs21 = require("./DesktopDateTimePicker/index.js");
parcelHelpers.exportAll(_indexJs21, exports);
var _indexJs22 = require("./MobileDateTimePicker/index.js");
parcelHelpers.exportAll(_indexJs22, exports);
var _indexJs23 = require("./StaticDateTimePicker/index.js");
parcelHelpers.exportAll(_indexJs23, exports);
// View renderers
var _indexJs24 = require("./dateViewRenderers/index.js");
parcelHelpers.exportAll(_indexJs24, exports);
var _indexJs25 = require("./timeViewRenderers/index.js");
parcelHelpers.exportAll(_indexJs25, exports);
// Layout
var _indexJs26 = require("./PickersLayout/index.js");
parcelHelpers.exportAll(_indexJs26, exports);
var _indexJs27 = require("./PickersActionBar/index.js");
parcelHelpers.exportAll(_indexJs27, exports);
var _indexJs28 = require("./PickersShortcuts/index.js");
parcelHelpers.exportAll(_indexJs28, exports);
// Other slots
var _indexJs29 = require("./PickersCalendarHeader/index.js");
parcelHelpers.exportAll(_indexJs29, exports);
// Field utilities
var _indexJs30 = require("./PickersTextField/index.js");
parcelHelpers.exportAll(_indexJs30, exports);
var _indexJs31 = require("./PickersSectionList/index.js");
parcelHelpers.exportAll(_indexJs31, exports);
var _utilsJs = require("./internals/utils/utils.js");
var _indexJs32 = require("./models/index.js");
parcelHelpers.exportAll(_indexJs32, exports);
var _indexJs33 = require("./icons/index.js");
parcelHelpers.exportAll(_indexJs33, exports);
var _indexJs34 = require("./hooks/index.js");
parcelHelpers.exportAll(_indexJs34, exports);
var _indexJs35 = require("./validation/index.js");
parcelHelpers.exportAll(_indexJs35, exports);
var _indexJs36 = require("./managers/index.js");
parcelHelpers.exportAll(_indexJs36, exports);

},{"./TimeClock/index.js":false,"./DigitalClock/index.js":false,"./MultiSectionDigitalClock/index.js":false,"./LocalizationProvider/index.js":"6A4sI","./PickersDay/index.js":false,"./locales/utils/pickersLocaleTextApi.js":false,"./DateField/index.js":false,"./TimeField/index.js":false,"./DateTimeField/index.js":false,"./DateCalendar/index.js":false,"./MonthCalendar/index.js":false,"./YearCalendar/index.js":false,"./DayCalendarSkeleton/index.js":false,"./DatePicker/index.js":"bEcHA","./DesktopDatePicker/index.js":false,"./MobileDatePicker/index.js":false,"./StaticDatePicker/index.js":false,"./TimePicker/index.js":false,"./DesktopTimePicker/index.js":false,"./MobileTimePicker/index.js":false,"./StaticTimePicker/index.js":false,"./DateTimePicker/index.js":"77pDg","./DesktopDateTimePicker/index.js":false,"./MobileDateTimePicker/index.js":false,"./StaticDateTimePicker/index.js":false,"./dateViewRenderers/index.js":false,"./timeViewRenderers/index.js":false,"./PickersLayout/index.js":false,"./PickersActionBar/index.js":false,"./PickersShortcuts/index.js":false,"./PickersCalendarHeader/index.js":false,"./PickersTextField/index.js":false,"./PickersSectionList/index.js":false,"./internals/utils/utils.js":false,"./models/index.js":false,"./icons/index.js":"8RbJX","./hooks/index.js":false,"./validation/index.js":false,"./managers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljZfh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeClock", ()=>(0, _timeClockJs.TimeClock));
parcelHelpers.export(exports, "clockClasses", ()=>(0, _clockClassesJs.clockClasses));
parcelHelpers.export(exports, "clockNumberClasses", ()=>(0, _clockNumberClassesJs.clockNumberClasses));
parcelHelpers.export(exports, "timeClockClasses", ()=>(0, _timeClockClassesJs.timeClockClasses));
parcelHelpers.export(exports, "getTimeClockUtilityClass", ()=>(0, _timeClockClassesJs.getTimeClockUtilityClass));
parcelHelpers.export(exports, "clockPointerClasses", ()=>(0, _clockPointerClassesJs.clockPointerClasses));
var _timeClockJs = require("./TimeClock.js");
var _clockClassesJs = require("./clockClasses.js");
var _clockNumberClassesJs = require("./clockNumberClasses.js");
var _timeClockClassesJs = require("./timeClockClasses.js");
var _clockPointerClassesJs = require("./clockPointerClasses.js");

},{"./TimeClock.js":"9PHHO","./clockClasses.js":false,"./clockNumberClasses.js":false,"./timeClockClasses.js":false,"./clockPointerClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PHHO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeClock", ()=>TimeClock);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _indexJs = require("../internals/components/PickersArrowSwitcher/index.js");
var _timeUtilsJs = require("../internals/utils/time-utils.js");
var _useViewsJs = require("../internals/hooks/useViews.js");
var _dateHelpersHooksJs = require("../internals/hooks/date-helpers-hooks.js");
var _indexJs1 = require("../internals/components/PickerViewRoot/index.js");
var _timeClockClassesJs = require("./timeClockClasses.js");
var _clockJs = require("./Clock.js");
var _clockNumbersJs = require("./ClockNumbers.js");
var _useControlledValueJs = require("../internals/hooks/useControlledValue.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _useClockReferenceDateJs = require("../internals/hooks/useClockReferenceDate.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "timezone"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _timeClockClassesJs.getTimeClockUtilityClass), classes);
};
const TimeClockRoot = (0, _styles.styled)((0, _indexJs1.PickerViewRoot), {
    name: 'MuiTimeClock',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
const TimeClockArrowSwitcher = (0, _styles.styled)((0, _indexJs.PickersArrowSwitcher), {
    name: 'MuiTimeClock',
    slot: 'ArrowSwitcher'
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const TIME_CLOCK_DEFAULT_VIEWS = [
    'hours',
    'minutes'
];
const TimeClock = /*#__PURE__*/ _react.forwardRef(function TimeClock(inProps, ref) {
    const utils = (0, _useUtilsJs.useUtils)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiTimeClock'
    });
    const { ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock = false, autoFocus, slots, slotProps, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation = false, maxTime, minTime, disableFuture, disablePast, minutesStep = 1, shouldDisableTime, showViewSwitcher, onChange, view: inView, views = TIME_CLOCK_DEFAULT_VIEWS, openTo, onViewChange, focusedView, onFocusedViewChange, className, classes: classesProp, disabled, readOnly, timezone: timezoneProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { value, handleValueChange, timezone } = (0, _useControlledValueJs.useControlledValue)({
        name: 'TimeClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: (0, _valueManagersJs.singleItemValueManager)
    });
    const valueOrReferenceDate = (0, _useClockReferenceDateJs.useClockReferenceDate)({
        value,
        referenceDate: referenceDateProp,
        utils,
        props,
        timezone
    });
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const now = (0, _useUtilsJs.useNow)(timezone);
    const selectedId = (0, _useIdDefault.default)();
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const { view, setView, previousView, nextView, setValueAndGoToNextView } = (0, _useViewsJs.useViews)({
        view: inView,
        views,
        openTo,
        onViewChange,
        onChange: handleValueChange,
        focusedView,
        onFocusedViewChange
    });
    const { meridiemMode, handleMeridiemChange } = (0, _dateHelpersHooksJs.useMeridiemMode)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = _react.useCallback((rawValue, viewType)=>{
        const isAfter = (0, _timeUtilsJs.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start, end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, _timeUtilsJs.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (utils.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const viewProps = _react.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, _timeUtilsJs.convertValueToMeridiem)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish, 'hours');
                    };
                    const viewValue = utils.getHours(valueOrReferenceDate);
                    let viewRange;
                    if (ampm) {
                        if (viewValue > 12) viewRange = [
                            12,
                            23
                        ];
                        else viewRange = [
                            0,
                            11
                        ];
                    } else viewRange = [
                        0,
                        23
                    ];
                    return {
                        onChange: handleHoursChange,
                        viewValue,
                        children: (0, _clockNumbersJs.getHourNumbers)({
                            value,
                            utils,
                            ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: translations.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, 'hours'),
                            selectedId
                        }),
                        viewRange
                    };
                }
            case 'minutes':
                {
                    const minutesValue = utils.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minuteValue), isFinish, 'minutes');
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, _clockNumbersJs.getMinutesNumbers)({
                            utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: translations.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, 'minutes'),
                            selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            case 'seconds':
                {
                    const secondsValue = utils.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, secondValue), isFinish, 'seconds');
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, _clockNumbersJs.getMinutesNumbers)({
                            utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: translations.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, 'seconds'),
                            selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        utils,
        value,
        ampm,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TimeClockRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockJs.Clock), (0, _extendsDefault.default)({
                autoFocus: autoFocus ?? !!focusedView,
                ampmInClock: ampmInClock && views.includes('hours'),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: translations.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: translations.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","prop-types":"bnNSm","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","@mui/utils/useId":"50qgI","../hooks/usePickerTranslations.js":"3Zb4l","../internals/hooks/useUtils.js":"dJQ8a","../internals/components/PickersArrowSwitcher/index.js":"gUvEC","../internals/utils/time-utils.js":"7FMia","../internals/hooks/useViews.js":"cVwkb","../internals/hooks/date-helpers-hooks.js":"ifoSw","../internals/components/PickerViewRoot/index.js":"gmdrj","./timeClockClasses.js":"5OwTo","./Clock.js":"hLm0B","./ClockNumbers.js":"3VZT4","../internals/hooks/useControlledValue.js":"hTAsm","../internals/utils/valueManagers.js":"bimTj","../internals/hooks/useClockReferenceDate.js":"dPXXC","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c9RfU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("9e0b4dc971269a3").default;
var _interopRequireDefault = require("2d7e4e1648158fbb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    experimental_sx: true,
    THEME_ID: true,
    adaptV4Theme: true,
    hexToRgb: true,
    rgbToHex: true,
    hslToRgb: true,
    decomposeColor: true,
    recomposeColor: true,
    getContrastRatio: true,
    getLuminance: true,
    emphasize: true,
    alpha: true,
    darken: true,
    lighten: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    unstable_createBreakpoints: true,
    createTheme: true,
    unstable_createMuiStrictModeTheme: true,
    createStyles: true,
    unstable_getUnit: true,
    unstable_toUnitless: true,
    responsiveFontSizes: true,
    createTransitions: true,
    duration: true,
    easing: true,
    createColorScheme: true,
    useTheme: true,
    useThemeProps: true,
    styled: true,
    ThemeProvider: true,
    makeStyles: true,
    withStyles: true,
    withTheme: true,
    extendTheme: true,
    experimental_extendTheme: true,
    getOverlayAlpha: true,
    shouldSkipGeneratingVar: true,
    private_createTypography: true,
    private_createMixins: true,
    private_excludeVariablesFromRoot: true
};
Object.defineProperty(exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return _system.StyledEngineProvider;
    }
});
Object.defineProperty(exports, "THEME_ID", {
    enumerable: true,
    get: function() {
        return _identifier.default;
    }
});
Object.defineProperty(exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return _ThemeProvider.default;
    }
});
Object.defineProperty(exports, "adaptV4Theme", {
    enumerable: true,
    get: function() {
        return _adaptV4Theme.default;
    }
});
Object.defineProperty(exports, "alpha", {
    enumerable: true,
    get: function() {
        return _system.alpha;
    }
});
Object.defineProperty(exports, "createColorScheme", {
    enumerable: true,
    get: function() {
        return _createColorScheme.default;
    }
});
Object.defineProperty(exports, "createStyles", {
    enumerable: true,
    get: function() {
        return _createStyles.default;
    }
});
Object.defineProperty(exports, "createTheme", {
    enumerable: true,
    get: function() {
        return _createTheme.default;
    }
});
Object.defineProperty(exports, "createTransitions", {
    enumerable: true,
    get: function() {
        return _createTransitions.default;
    }
});
Object.defineProperty(exports, "css", {
    enumerable: true,
    get: function() {
        return _system.css;
    }
});
Object.defineProperty(exports, "darken", {
    enumerable: true,
    get: function() {
        return _system.darken;
    }
});
Object.defineProperty(exports, "decomposeColor", {
    enumerable: true,
    get: function() {
        return _system.decomposeColor;
    }
});
Object.defineProperty(exports, "duration", {
    enumerable: true,
    get: function() {
        return _createTransitions.duration;
    }
});
Object.defineProperty(exports, "easing", {
    enumerable: true,
    get: function() {
        return _createTransitions.easing;
    }
});
Object.defineProperty(exports, "emphasize", {
    enumerable: true,
    get: function() {
        return _system.emphasize;
    }
});
Object.defineProperty(exports, "experimental_extendTheme", {
    enumerable: true,
    get: function() {
        return _experimental_extendTheme.default;
    }
});
exports.experimental_sx = experimental_sx;
Object.defineProperty(exports, "extendTheme", {
    enumerable: true,
    get: function() {
        return _createThemeWithVars.default;
    }
});
Object.defineProperty(exports, "getContrastRatio", {
    enumerable: true,
    get: function() {
        return _system.getContrastRatio;
    }
});
Object.defineProperty(exports, "getLuminance", {
    enumerable: true,
    get: function() {
        return _system.getLuminance;
    }
});
Object.defineProperty(exports, "getOverlayAlpha", {
    enumerable: true,
    get: function() {
        return _getOverlayAlpha.default;
    }
});
Object.defineProperty(exports, "hexToRgb", {
    enumerable: true,
    get: function() {
        return _system.hexToRgb;
    }
});
Object.defineProperty(exports, "hslToRgb", {
    enumerable: true,
    get: function() {
        return _system.hslToRgb;
    }
});
Object.defineProperty(exports, "keyframes", {
    enumerable: true,
    get: function() {
        return _system.keyframes;
    }
});
Object.defineProperty(exports, "lighten", {
    enumerable: true,
    get: function() {
        return _system.lighten;
    }
});
Object.defineProperty(exports, "makeStyles", {
    enumerable: true,
    get: function() {
        return _makeStyles.default;
    }
});
Object.defineProperty(exports, "private_createMixins", {
    enumerable: true,
    get: function() {
        return _createMixins.default;
    }
});
Object.defineProperty(exports, "private_createTypography", {
    enumerable: true,
    get: function() {
        return _createTypography.default;
    }
});
Object.defineProperty(exports, "private_excludeVariablesFromRoot", {
    enumerable: true,
    get: function() {
        return _excludeVariablesFromRoot.default;
    }
});
Object.defineProperty(exports, "recomposeColor", {
    enumerable: true,
    get: function() {
        return _system.recomposeColor;
    }
});
Object.defineProperty(exports, "responsiveFontSizes", {
    enumerable: true,
    get: function() {
        return _responsiveFontSizes.default;
    }
});
Object.defineProperty(exports, "rgbToHex", {
    enumerable: true,
    get: function() {
        return _system.rgbToHex;
    }
});
Object.defineProperty(exports, "shouldSkipGeneratingVar", {
    enumerable: true,
    get: function() {
        return _shouldSkipGeneratingVar.default;
    }
});
Object.defineProperty(exports, "styled", {
    enumerable: true,
    get: function() {
        return _styled.default;
    }
});
Object.defineProperty(exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return _createBreakpoints.unstable_createBreakpoints;
    }
});
Object.defineProperty(exports, "unstable_createMuiStrictModeTheme", {
    enumerable: true,
    get: function() {
        return _createMuiStrictModeTheme.default;
    }
});
Object.defineProperty(exports, "unstable_getUnit", {
    enumerable: true,
    get: function() {
        return _cssUtils.getUnit;
    }
});
Object.defineProperty(exports, "unstable_toUnitless", {
    enumerable: true,
    get: function() {
        return _cssUtils.toUnitless;
    }
});
Object.defineProperty(exports, "useTheme", {
    enumerable: true,
    get: function() {
        return _useTheme.default;
    }
});
Object.defineProperty(exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return _useThemeProps.default;
    }
});
Object.defineProperty(exports, "withStyles", {
    enumerable: true,
    get: function() {
        return _withStyles.default;
    }
});
Object.defineProperty(exports, "withTheme", {
    enumerable: true,
    get: function() {
        return _withTheme.default;
    }
});
var _formatMuiErrorMessage = _interopRequireDefault(require("1426be4a4155a7db"));
var _identifier = _interopRequireDefault(require("60e446a07e752fc1"));
var _adaptV4Theme = _interopRequireDefault(require("4e01c7764d7ad72b"));
var _system = require("50a86352ec4c604d");
var _createBreakpoints = require("fc745d3a8e6128b6");
var _createTheme = _interopRequireDefault(require("c02345c0d2fe9c26"));
var _createMuiStrictModeTheme = _interopRequireDefault(require("325a3b3f8eefd8c8"));
var _createStyles = _interopRequireDefault(require("bf76f6a96f96ef46"));
var _cssUtils = require("d74cc28e333acb9c");
var _responsiveFontSizes = _interopRequireDefault(require("996875b8cae62043"));
var _createTransitions = _interopRequireWildcard(require("c5eb00d594046f72"));
var _createColorScheme = _interopRequireDefault(require("4050e24442ae9870"));
var _useTheme = _interopRequireDefault(require("be60b7a50df0d204"));
var _useThemeProps = _interopRequireDefault(require("9ef0b9dc8ad1fc2a"));
var _styled = _interopRequireDefault(require("7525de448df38c88"));
var _ThemeProvider = _interopRequireDefault(require("755dbd5cca9108e5"));
var _makeStyles = _interopRequireDefault(require("4ca70a1175195400"));
var _withStyles = _interopRequireDefault(require("6a3fda33b23d335a"));
var _withTheme = _interopRequireDefault(require("de95f5b02dd259e3"));
var _ThemeProviderWithVars = require("597fd1722bc1e31a");
Object.keys(_ThemeProviderWithVars).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _ThemeProviderWithVars[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _ThemeProviderWithVars[key];
        }
    });
});
var _createThemeWithVars = _interopRequireDefault(require("c58e64473d69acc5"));
var _experimental_extendTheme = _interopRequireDefault(require("7b6ebb63ac28ee0a"));
var _getOverlayAlpha = _interopRequireDefault(require("24dd3ab8b230fd52"));
var _shouldSkipGeneratingVar = _interopRequireDefault(require("9ccd3464d7f82d2f"));
var _createTypography = _interopRequireDefault(require("1935a726b59862c"));
var _createMixins = _interopRequireDefault(require("1388ea8ab0baac7a"));
var _excludeVariablesFromRoot = _interopRequireDefault(require("37713734b0c1956"));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessage.default)(19));
} // The legacy utilities from @mui/styles
 // These are just empty functions that throws when invoked
 // TODO: Remove in v7
 // Private methods for creating parts of the theme

},{"9e0b4dc971269a3":"fiRIh","2d7e4e1648158fbb":"kZ6eK","1426be4a4155a7db":"gOgzd","60e446a07e752fc1":"asvw3","4e01c7764d7ad72b":"dLuKA","50a86352ec4c604d":"iFfXs","fc745d3a8e6128b6":"kPrUI","c02345c0d2fe9c26":"itHnG","325a3b3f8eefd8c8":"61Xm8","bf76f6a96f96ef46":"2udPr","d74cc28e333acb9c":"a70O5","996875b8cae62043":"6Byx5","c5eb00d594046f72":"4xJuz","4050e24442ae9870":"c8Nxs","be60b7a50df0d204":"d8hfc","9ef0b9dc8ad1fc2a":"9ffJF","7525de448df38c88":"bTnxF","755dbd5cca9108e5":"1Q7kB","4ca70a1175195400":"irmH0","6a3fda33b23d335a":"bWZlL","de95f5b02dd259e3":"lTNkx","597fd1722bc1e31a":"gdMqB","c58e64473d69acc5":"256vF","7b6ebb63ac28ee0a":"lPQpc","24dd3ab8b230fd52":"5bDnG","9ccd3464d7f82d2f":"i7Nw9","1935a726b59862c":"byLfw","1388ea8ab0baac7a":"dprtV","37713734b0c1956":"2gXZR"}],"dLuKA":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = adaptV4Theme;
var _system = require("3242de34b3b788aa");
function adaptV4Theme(inputTheme) {
    const { defaultProps = {}, mixins = {}, overrides = {}, palette = {}, props = {}, styleOverrides = {}, ...other } = inputTheme;
    const theme = {
        ...other,
        components: {}
    };
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, _system.createSpacing)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, _system.createBreakpoints)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = {
        gutters: (styles = {})=>{
            return {
                paddingLeft: spacing(2),
                paddingRight: spacing(2),
                ...styles,
                [breakpoints.up('sm')]: {
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3),
                    ...styles[breakpoints.up('sm')]
                }
            };
        },
        ...mixins
    };
    const { type: typeInput, mode: modeInput, ...paletteRest } = palette;
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = {
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode,
        ...paletteRest
    };
    return theme;
}

},{"3242de34b3b788aa":"iFfXs"}],"61Xm8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f0500c51d91f5f68").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createMuiStrictModeTheme;
var _deepmerge = _interopRequireDefault(require("bac7ee1d4630c8a4"));
var _createTheme = _interopRequireDefault(require("8175099ea82f8d89"));
function createMuiStrictModeTheme(options, ...args) {
    return (0, _createTheme.default)((0, _deepmerge.default)({
        unstable_strictMode: true
    }, options), ...args);
}

},{"f0500c51d91f5f68":"kZ6eK","bac7ee1d4630c8a4":"7wtTC","8175099ea82f8d89":"itHnG"}],"2udPr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStyles;
let warnedOnce = false;
// To remove in v6
function createStyles(styles) {
    if (!warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        warnedOnce = true;
    }
    return styles;
}

},{}],"a70O5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.alignProperty = alignProperty;
exports.convertLength = convertLength;
exports.fontGrid = fontGrid;
exports.getUnit = getUnit;
exports.isUnitless = isUnitless;
exports.responsiveProperty = responsiveProperty;
exports.toUnitless = toUnitless;
function isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
// Emulate the sass function "unitless"
function toUnitless(length) {
    return parseFloat(length);
}
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = toUnitless(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = toUnitless(length) * toUnitless(baseFontSize);
            else if (fromUnit === 'rem') pxLength = toUnitless(length) * toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / toUnitless(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function alignProperty({ size, grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function fontGrid({ lineHeight, pixels, htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ function responsiveProperty({ cssProperty, min, max, unit = 'rem', breakpoints = [
    600,
    900,
    1200
], transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

},{}],"6Byx5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6abea5402ef82489").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = responsiveFontSizes;
var _formatMuiErrorMessage = _interopRequireDefault(require("ce2f38ea61eee0ac"));
var _cssUtils = require("4eca37b22368d6d4");
function responsiveFontSizes(themeInput, options = {}) {
    const { breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign = false, factor = 2, variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = {
        ...themeInput
    };
    theme.typography = {
        ...theme.typography
    };
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, _cssUtils.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight } = style;
        if (!(0, _cssUtils.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, _formatMuiErrorMessage.default)(6));
        if (!(0, _cssUtils.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, _cssUtils.alignProperty)({
                size: value,
                grid: (0, _cssUtils.fontGrid)({
                    pixels: 4,
                    lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = {
            ...style,
            ...(0, _cssUtils.responsiveProperty)({
                cssProperty: 'fontSize',
                min: minFontSize,
                max: maxFontSize,
                unit: 'rem',
                breakpoints: breakpointValues,
                transform
            })
        };
    });
    return theme;
}

},{"6abea5402ef82489":"kZ6eK","ce2f38ea61eee0ac":"gOgzd","4eca37b22368d6d4":"a70O5"}],"9ffJF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e55debba6a3a698f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useThemeProps;
var _useThemeProps = _interopRequireDefault(require("f37c43e4f51955ae"));
var _defaultTheme = _interopRequireDefault(require("76daab5ec9258913"));
var _identifier = _interopRequireDefault(require("f7d86afa37ac55f0"));
function useThemeProps({ props, name }) {
    return (0, _useThemeProps.default)({
        props,
        name,
        defaultTheme: _defaultTheme.default,
        themeId: _identifier.default
    });
}

},{"e55debba6a3a698f":"kZ6eK","f37c43e4f51955ae":"tiL16","76daab5ec9258913":"gDdTD","f7d86afa37ac55f0":"asvw3"}],"1Q7kB":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ec96335914447116").default;
var _interopRequireWildcard = require("4473e0986fd3d9eb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ThemeProvider;
var React = _interopRequireWildcard(require("ffff5d2b95997a92"));
var _ThemeProviderNoVars = _interopRequireDefault(require("dd88efac0a0d0447"));
var _ThemeProviderWithVars = require("56240afa2f411c2");
var _identifier = _interopRequireDefault(require("2373d5eac4aed5f8"));
var _jsxRuntime = require("abee41afeef16458");
function ThemeProvider({ theme, ...props }) {
    const noVarsTheme = React.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = _identifier.default in theme ? theme[_identifier.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ThemeProviderNoVars.default, {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ThemeProviderWithVars.CssVarsProvider, {
        theme: theme,
        ...props
    });
}

},{"ec96335914447116":"kZ6eK","4473e0986fd3d9eb":"fiRIh","ffff5d2b95997a92":"9njXz","dd88efac0a0d0447":"1odew","56240afa2f411c2":"gdMqB","2373d5eac4aed5f8":"asvw3","abee41afeef16458":"1dlk8"}],"1odew":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a93a67505f03cc38").default;
var _interopRequireWildcard = require("1db8d7324e225fd3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ThemeProviderNoVars;
var React = _interopRequireWildcard(require("3fe683a4b392ee76"));
var _system = require("b57fa2925038b41e");
var _identifier = _interopRequireDefault(require("37fefba726673ef6"));
var _jsxRuntime = require("bf89517dbf20f6ff");
function ThemeProviderNoVars({ theme: themeInput, ...props }) {
    const scopedTheme = _identifier.default in themeInput ? themeInput[_identifier.default] : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_system.ThemeProvider, {
        ...props,
        themeId: scopedTheme ? _identifier.default : undefined,
        theme: scopedTheme || themeInput
    });
}

},{"a93a67505f03cc38":"kZ6eK","1db8d7324e225fd3":"fiRIh","3fe683a4b392ee76":"9njXz","b57fa2925038b41e":"iFfXs","37fefba726673ef6":"asvw3","bf89517dbf20f6ff":"1dlk8"}],"gdMqB":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("f71f1606772f3699").default;
var _interopRequireWildcard = require("f45e67c3152f4567").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CssVarsProvider = void 0;
exports.Experimental_CssVarsProvider = Experimental_CssVarsProvider;
exports.useColorScheme = exports.getInitColorSchemeScript = void 0;
var React = _interopRequireWildcard(require("6bf61cb1c17e6356"));
var _styleFunctionSx = _interopRequireDefault(require("dde767c79e68e2dc"));
var _system = require("d484ec0e330425d2");
var _createTheme = _interopRequireDefault(require("51df668dd926bb48"));
var _createTypography = _interopRequireDefault(require("95a4777f6a634239"));
var _identifier = _interopRequireDefault(require("bd071396e0851da4"));
var _InitColorSchemeScript = require("bd1e778adf083ad9");
var _jsxRuntime = require("be4becea9d8a6c73");
const { CssVarsProvider: InternalCssVarsProvider, useColorScheme, getInitColorSchemeScript: deprecatedGetInitColorSchemeScript } = (0, _system.unstable_createCssVarsProvider)({
    themeId: _identifier.default,
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, _createTheme.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: _InitColorSchemeScript.defaultConfig.colorSchemeStorageKey,
    modeStorageKey: _InitColorSchemeScript.defaultConfig.modeStorageKey,
    defaultColorScheme: {
        light: _InitColorSchemeScript.defaultConfig.defaultLightColorScheme,
        dark: _InitColorSchemeScript.defaultConfig.defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, _createTypography.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, _styleFunctionSx.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
exports.useColorScheme = useColorScheme;
let warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function Experimental_CssVarsProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalCssVarsProvider, {
        ...props
    });
}
let warnedInitScriptOnce = false;
// TODO: remove in v7
const getInitColorSchemeScript = (params)=>{
    if (!warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        warnedInitScriptOnce = true;
    }
    return deprecatedGetInitColorSchemeScript(params);
};
/**
 * TODO: remove this export in v7
 * @deprecated
 * The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
 *
 * You should use `ThemeProvider` and `createTheme()` instead:
 *
 * ```diff
 * - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
 * + import { ThemeProvider, createTheme } from '@mui/material/styles';
 *
 * - const theme = extendTheme();
 * + const theme = createTheme({
 * +   cssVariables: true,
 * +   colorSchemes: { light: true, dark: true },
 * + });
 *
 * - <CssVarsProvider theme={theme}>
 * + <ThemeProvider theme={theme}>
 * ```
 *
 * To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
 */ exports.getInitColorSchemeScript = getInitColorSchemeScript;
const CssVarsProvider = exports.CssVarsProvider = InternalCssVarsProvider;

},{"f71f1606772f3699":"kZ6eK","f45e67c3152f4567":"fiRIh","6bf61cb1c17e6356":"9njXz","dde767c79e68e2dc":"e1roB","d484ec0e330425d2":"iFfXs","51df668dd926bb48":"itHnG","95a4777f6a634239":"byLfw","bd071396e0851da4":"asvw3","bd1e778adf083ad9":"2AVL2","be4becea9d8a6c73":"1dlk8"}],"2AVL2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4aa77561176f0b87").default;
var _interopRequireWildcard = require("215d8ee5be69ebdf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultConfig = exports.default = void 0;
var React = _interopRequireWildcard(require("69b0ba915d677858"));
var _propTypes = _interopRequireDefault(require("61b47b75a330a65a"));
var _InitColorSchemeScript = _interopRequireDefault(require("c6b16aa0a6624eae"));
var _jsxRuntime = require("7a3f1a6efb295a5d");
const defaultConfig = exports.defaultConfig = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function InitColorSchemeScript(props) {
    const { defaultMode = 'system', defaultLightColorScheme = defaultConfig.defaultLightColorScheme, defaultDarkColorScheme = defaultConfig.defaultDarkColorScheme, modeStorageKey = defaultConfig.modeStorageKey, colorSchemeStorageKey = defaultConfig.colorSchemeStorageKey, attribute: initialAttribute = defaultConfig.attribute, colorSchemeNode = 'document.documentElement', nonce } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InitColorSchemeScript.default, {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var _default = exports.default = InitColorSchemeScript;

},{"4aa77561176f0b87":"kZ6eK","215d8ee5be69ebdf":"fiRIh","69b0ba915d677858":"9njXz","61b47b75a330a65a":"bnNSm","c6b16aa0a6624eae":"7Wnxw","7a3f1a6efb295a5d":"1dlk8"}],"irmH0":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2813beb5fcead744").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = makeStyles;
var _formatMuiErrorMessage = _interopRequireDefault(require("10fbff6465919068"));
function makeStyles() {
    throw new Error((0, _formatMuiErrorMessage.default)(14));
}

},{"2813beb5fcead744":"kZ6eK","10fbff6465919068":"gOgzd"}],"bWZlL":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("554aba97516b6810").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = withStyles;
var _formatMuiErrorMessage = _interopRequireDefault(require("564138a0de96cd90"));
function withStyles() {
    throw new Error((0, _formatMuiErrorMessage.default)(15));
}

},{"554aba97516b6810":"kZ6eK","564138a0de96cd90":"gOgzd"}],"lTNkx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("92b08439aff2893b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = withTheme;
var _formatMuiErrorMessage = _interopRequireDefault(require("b3de7d1a7b044330"));
function withTheme() {
    throw new Error((0, _formatMuiErrorMessage.default)(16));
}

},{"92b08439aff2893b":"kZ6eK","b3de7d1a7b044330":"gOgzd"}],"lPQpc":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4a6bddfaeb4e9e51").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deprecatedExtendTheme;
var _createThemeWithVars = _interopRequireDefault(require("22d932b106c1ff8d"));
let warnedOnce = false;
function deprecatedExtendTheme(...args) {
    if (!warnedOnce) {
        console.warn([
            'MUI: The `experimental_extendTheme` has been stabilized.',
            '',
            "You should use `import { extendTheme } from '@mui/material/styles'`"
        ].join('\n'));
        warnedOnce = true;
    }
    return (0, _createThemeWithVars.default)(...args);
}

},{"4a6bddfaeb4e9e51":"kZ6eK","22d932b106c1ff8d":"256vF"}],"3Zb4l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePickerTranslations", ()=>usePickerTranslations);
var _useUtilsJs = require("../internals/hooks/useUtils.js");
'use client';
const usePickerTranslations = ()=>(0, _useUtilsJs.useLocalizationContext)().localeText;

},{"../internals/hooks/useUtils.js":"dJQ8a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dJQ8a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLocalizationContext", ()=>useLocalizationContext);
parcelHelpers.export(exports, "useUtils", ()=>useUtils);
parcelHelpers.export(exports, "useDefaultDates", ()=>useDefaultDates);
parcelHelpers.export(exports, "useNow", ()=>useNow);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _localizationProviderJs = require("../../LocalizationProvider/LocalizationProvider.js");
var _enUSJs = require("../../locales/enUS.js");
const useLocalizationContext = ()=>{
    const localization = _react.useContext((0, _localizationProviderJs.MuiPickersAdapterContext));
    if (localization === null) throw new Error([
        'MUI X: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.utils === null) throw new Error([
        'MUI X: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = _react.useMemo(()=>(0, _extendsDefault.default)({}, (0, _enUSJs.DEFAULT_LOCALE), localization.localeText), [
        localization.localeText
    ]);
    return _react.useMemo(()=>(0, _extendsDefault.default)({}, localization, {
            localeText
        }), [
        localization,
        localeText
    ]);
};
const useUtils = ()=>useLocalizationContext().utils;
const useDefaultDates = ()=>useLocalizationContext().defaultDates;
const useNow = (timezone)=>{
    const utils = useUtils();
    const now = _react.useRef(undefined);
    if (now.current === undefined) now.current = utils.date(undefined, timezone);
    return now.current;
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../../LocalizationProvider/LocalizationProvider.js":"3BMNW","../../locales/enUS.js":"2faYg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3BMNW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiPickersAdapterContext", ()=>MuiPickersAdapterContext);
parcelHelpers.export(exports, "LocalizationProvider", ()=>LocalizationProvider);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "localeText"
];
const MuiPickersAdapterContext = /*#__PURE__*/ _react.createContext(null);
const LocalizationProvider = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, _objectWithoutPropertiesLooseDefault.default)(inProps, _excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = _react.useContext(MuiPickersAdapterContext) ?? {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, _styles.useThemeProps)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children, dateAdapter: DateAdapter, dateFormats, dateLibInstance, adapterLocale, localeText: themeLocaleText } = props;
    const localeText = _react.useMemo(()=>(0, _extendsDefault.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = _react.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            'MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/quickstart/#installation'
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = _react.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = _react.useMemo(()=>{
        return {
            utils,
            defaultDates,
            localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MuiPickersAdapterContext.Provider, {
        value: contextValue,
        children: children
    });
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/material/styles":"c9RfU","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2faYg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCALE", ()=>DEFAULT_LOCALE);
parcelHelpers.export(exports, "enUS", ()=>enUS);
var _getPickersLocalizationJs = require("./utils/getPickersLocalization.js");
// This object is not Partial<PickersLocaleText> because it is the default values
const enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange labels
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    nextStepButtonLabel: 'Next',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    timeRangePickerToolbarTitle: 'Select time range',
    // Clock labels
    clockLabelText: (view, formattedTime)=>`Select ${view}. ${!formattedTime ? 'No time selected' : `Selected time is ${formattedTime}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open Picker labels
    openDatePickerDialogue: (formattedDate)=>formattedDate ? `Choose date, selected date is ${formattedDate}` : 'Choose date',
    openTimePickerDialogue: (formattedTime)=>formattedTime ? `Choose time, selected time is ${formattedTime}` : 'Choose time',
    openRangePickerDialogue: (formattedRange)=>formattedRange ? `Choose range, selected range is ${formattedRange}` : 'Choose range',
    fieldClearLabel: 'Clear',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    // View names
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    // Common
    empty: 'Empty'
};
const DEFAULT_LOCALE = enUSPickers;
const enUS = (0, _getPickersLocalizationJs.getPickersLocalization)(enUSPickers);

},{"./utils/getPickersLocalization.js":"hSYAS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hSYAS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersLocalization", ()=>getPickersLocalization);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const getPickersLocalization = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, _extendsDefault.default)({}, pickersTranslations)
                }
            }
        }
    };
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUvEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersArrowSwitcher", ()=>(0, _pickersArrowSwitcherJs.PickersArrowSwitcher));
parcelHelpers.export(exports, "pickersArrowSwitcherClasses", ()=>(0, _pickersArrowSwitcherClassesJs.pickersArrowSwitcherClasses));
parcelHelpers.export(exports, "getPickersArrowSwitcherUtilityClass", ()=>(0, _pickersArrowSwitcherClassesJs.getPickersArrowSwitcherUtilityClass));
var _pickersArrowSwitcherJs = require("./PickersArrowSwitcher.js");
var _pickersArrowSwitcherClassesJs = require("./pickersArrowSwitcherClasses.js");

},{"./PickersArrowSwitcher.js":"3kRWE","./pickersArrowSwitcherClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3kRWE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersArrowSwitcher", ()=>PickersArrowSwitcher);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _rtlProvider = require("@mui/system/RtlProvider");
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _indexJs = require("../../../icons/index.js");
var _pickersArrowSwitcherClassesJs = require("./pickersArrowSwitcherClasses.js");
var _usePickerPrivateContextJs = require("../../hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId",
    "classes"
], _excluded2 = [
    "ownerState"
], _excluded3 = [
    "ownerState"
];
const PickersArrowSwitcherRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root'
})({
    display: 'flex'
});
const PickersArrowSwitcherSpacer = (0, _styles.styled)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer'
})(({ theme })=>({
        width: theme.spacing(3)
    }));
const PickersArrowSwitcherButton = (0, _styles.styled)((0, _iconButtonDefault.default), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button'
})({
    variants: [
        {
            props: {
                isButtonHidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ],
        previousIconButton: [
            'previousIconButton'
        ],
        nextIconButton: [
            'nextIconButton'
        ],
        leftArrowIcon: [
            'leftArrowIcon'
        ],
        rightArrowIcon: [
            'rightArrowIcon'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersArrowSwitcherClassesJs.getPickersArrowSwitcherUtilityClass), classes);
};
const PickersArrowSwitcher = /*#__PURE__*/ _react.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, _rtlProvider.useRtl)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children, className, slots, slotProps, isNextDisabled, isNextHidden, onGoToNext, nextLabel, isPreviousDisabled, isPreviousHidden, onGoToPrevious, previousLabel, labelId, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const classes = useUtilityClasses(classesProp);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, _useSlotPropsDefault.default)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, _extendsDefault.default)({}, ownerState, {
            isButtonHidden: previousProps.isHidden ?? false
        }),
        className: (0, _clsxDefault.default)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, _useSlotPropsDefault.default)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, _extendsDefault.default)({}, ownerState, {
            isButtonHidden: nextProps.isHidden ?? false
        }),
        className: (0, _clsxDefault.default)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? (0, _indexJs.ArrowLeftIcon);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? (0, _indexJs.ArrowRightIcon);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, _useSlotPropsDefault.default)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps2, _excluded3);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersArrowSwitcherRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PreviousIconButton, (0, _extendsDefault.default)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(RightArrowIcon, (0, _extendsDefault.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftArrowIcon, (0, _extendsDefault.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextIconButton, (0, _extendsDefault.default)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftArrowIcon, (0, _extendsDefault.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(RightArrowIcon, (0, _extendsDefault.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","@mui/material/Typography":"2wCD5","@mui/system/RtlProvider":"ck9Pb","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","@mui/utils/useSlotProps":"kr4RG","@mui/material/IconButton":"bXjnZ","../../../icons/index.js":"8RbJX","./pickersArrowSwitcherClasses.js":"lVyql","../../hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wCD5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ad9436f9c705699b").default;
var _interopRequireDefault = require("9fe783a6c8bd3a06").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    typographyClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Typography.default;
    }
});
Object.defineProperty(exports, "typographyClasses", {
    enumerable: true,
    get: function() {
        return _typographyClasses.default;
    }
});
var _Typography = _interopRequireDefault(require("6cac80498254eafe"));
var _typographyClasses = _interopRequireWildcard(require("e698cb73fb00ce6d"));
Object.keys(_typographyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _typographyClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _typographyClasses[key];
        }
    });
});

},{"ad9436f9c705699b":"fiRIh","9fe783a6c8bd3a06":"kZ6eK","6cac80498254eafe":"7vbx5","e698cb73fb00ce6d":"7JIT0"}],"7vbx5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("29832c84122f038b").default;
var _interopRequireWildcard = require("f9284f18f32b29ef").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.TypographyRoot = void 0;
var React = _interopRequireWildcard(require("b17e5109419248a7"));
var _propTypes = _interopRequireDefault(require("f0cf6fbe354b7d65"));
var _clsx = _interopRequireDefault(require("71ca9b6715f84763"));
var _composeClasses = _interopRequireDefault(require("9ec2b2b0041cf1c5"));
var _zeroStyled = require("5077ea93c74e5d43");
var _memoTheme = _interopRequireDefault(require("4076d486fb34bf95"));
var _DefaultPropsProvider = require("5a901e81ef5715d1");
var _capitalize = _interopRequireDefault(require("3d51e07104d52b93"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("dcc178672edf1cbd"));
var _typographyClasses = require("af613e50d3f213c4");
var _jsxRuntime = require("6b94c8e123fd171e");
const v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const extendSxProp = (0, _zeroStyled.internal_createExtendSxProp)();
const useUtilityClasses = (ownerState)=>{
    const { align, gutterBottom, noWrap, paragraph, variant, classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, _capitalize.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, _composeClasses.default)(slots, _typographyClasses.getTypographyUtilityClass, classes);
};
const TypographyRoot = exports.TypographyRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, _capitalize.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, _capitalize.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const Typography = /*#__PURE__*/ React.forwardRef(function Typography(inProps, ref) {
    const { color, ...themeProps } = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color
        }
    });
    const { align = 'inherit', className, component, gutterBottom = false, noWrap = false, paragraph = false, variant = 'body1', variantMapping = defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align,
        color,
        className,
        component,
        gutterBottom,
        noWrap,
        paragraph,
        variant,
        variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypographyRoot, {
        as: Component,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var _default = exports.default = Typography;

},{"29832c84122f038b":"kZ6eK","f9284f18f32b29ef":"fiRIh","b17e5109419248a7":"9njXz","f0cf6fbe354b7d65":"bnNSm","71ca9b6715f84763":"d2NWs","9ec2b2b0041cf1c5":"59Equ","5077ea93c74e5d43":"89fxU","4076d486fb34bf95":"2zy52","5a901e81ef5715d1":"ff3VX","3d51e07104d52b93":"hBZko","dcc178672edf1cbd":"yHYvD","af613e50d3f213c4":"7JIT0","6b94c8e123fd171e":"1dlk8"}],"yHYvD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createSimplePaletteValueFilter;
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
/**
 * Creates a filter function used to filter simple palette color options.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns ([, value]: [any, PaletteColorOptions]) => boolean
 */ function createSimplePaletteValueFilter(additionalPropertiesToCheck = []) {
    return ([, value])=>value && checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

},{}],"7JIT0":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e01dbbe41bd2788e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTypographyUtilityClass = getTypographyUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("1dd4280384e8cce"));
var _generateUtilityClass = _interopRequireDefault(require("ce5411f127704b12"));
function getTypographyUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTypography', slot);
}
const typographyClasses = (0, _generateUtilityClasses.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var _default = exports.default = typographyClasses;

},{"e01dbbe41bd2788e":"kZ6eK","1dd4280384e8cce":"7pSUk","ce5411f127704b12":"jBs9M"}],"bXjnZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("613e3345a96b1857").default;
var _interopRequireDefault = require("9a67949f9ed04aca").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    iconButtonClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _IconButton.default;
    }
});
Object.defineProperty(exports, "iconButtonClasses", {
    enumerable: true,
    get: function() {
        return _iconButtonClasses.default;
    }
});
var _IconButton = _interopRequireDefault(require("5325a124eeb7a817"));
var _iconButtonClasses = _interopRequireWildcard(require("6822f57beb9e8e05"));
Object.keys(_iconButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _iconButtonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _iconButtonClasses[key];
        }
    });
});

},{"613e3345a96b1857":"fiRIh","9a67949f9ed04aca":"kZ6eK","5325a124eeb7a817":"gWbyX","6822f57beb9e8e05":"bLPmg"}],"gWbyX":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("767aa00d2a30b0c8").default;
var _interopRequireWildcard = require("2c7f93f0b6902743").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e5e92329b6c3faf2"));
var _propTypes = _interopRequireDefault(require("e8fbb78e9bc38b9b"));
var _clsx = _interopRequireDefault(require("fe047a9f652db967"));
var _chainPropTypes = _interopRequireDefault(require("63ebe34b5452d445"));
var _composeClasses = _interopRequireDefault(require("9ea7044ab81a16da"));
var _colorManipulator = require("905a89c3721204aa");
var _utils = require("67b1983799f64dbe");
var _zeroStyled = require("a9b2ae47864a1bba");
var _memoTheme = _interopRequireDefault(require("9d760fa19ff921ba"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("30f0241083a6ab0"));
var _DefaultPropsProvider = require("99c230c926e07b6e");
var _ButtonBase = _interopRequireDefault(require("4580ee3b7bd6d53a"));
var _CircularProgress = _interopRequireDefault(require("482f418e47a09742"));
var _capitalize = _interopRequireDefault(require("71259e2c3bead8ac"));
var _iconButtonClasses = _interopRequireWildcard(require("a6dd3d339367e59a"));
var _jsxRuntime = require("de535db8d6af31da");
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, color, edge, size, loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, _capitalize.default)(color)}`,
            edge && `edge${(0, _capitalize.default)(edge)}`,
            `size${(0, _capitalize.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, _composeClasses.default)(slots, _iconButtonClasses.getIconButtonUtilityClass, classes);
};
const IconButtonRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, _capitalize.default)(ownerState.edge)}`],
            styles[`size${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, _memoTheme.default)(({ theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${_iconButtonClasses.default.disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${_iconButtonClasses.default.loading}`]: {
            color: 'transparent'
        }
    })));
const IconButtonLoadingIndicator = (0, _zeroStyled.styled)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const IconButton = /*#__PURE__*/ React.forwardRef(function IconButton(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge = false, children, className, color = 'default', disabled = false, disableFocusRipple = false, size = 'medium', id: idProp, loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, _utils.unstable_useId)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CircularProgress.default, {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge,
        color,
        disabled,
        disableFocusRipple,
        loading,
        loadingIndicator,
        size
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, _clsx.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, _jsxRuntime.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var _default = exports.default = IconButton;

},{"767aa00d2a30b0c8":"kZ6eK","2c7f93f0b6902743":"fiRIh","e5e92329b6c3faf2":"9njXz","e8fbb78e9bc38b9b":"bnNSm","fe047a9f652db967":"d2NWs","63ebe34b5452d445":"4stnp","9ea7044ab81a16da":"59Equ","905a89c3721204aa":"hTYBL","67b1983799f64dbe":"60iOt","a9b2ae47864a1bba":"89fxU","9d760fa19ff921ba":"2zy52","30f0241083a6ab0":"yHYvD","99c230c926e07b6e":"ff3VX","4580ee3b7bd6d53a":"ajcyv","482f418e47a09742":"bK4ky","71259e2c3bead8ac":"hBZko","a6dd3d339367e59a":"bLPmg","de535db8d6af31da":"1dlk8"}],"ajcyv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("66d72c59b5f8d14a").default;
var _interopRequireDefault = require("28efbad31020a5d9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    buttonBaseClasses: true,
    touchRippleClasses: true
};
Object.defineProperty(exports, "buttonBaseClasses", {
    enumerable: true,
    get: function() {
        return _buttonBaseClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ButtonBase.default;
    }
});
Object.defineProperty(exports, "touchRippleClasses", {
    enumerable: true,
    get: function() {
        return _touchRippleClasses.default;
    }
});
var _ButtonBase = _interopRequireDefault(require("b0dcdf9e97a7aeab"));
var _buttonBaseClasses = _interopRequireWildcard(require("bbae292c07b938bc"));
Object.keys(_buttonBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _buttonBaseClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _buttonBaseClasses[key];
        }
    });
});
var _touchRippleClasses = _interopRequireWildcard(require("8acde9f2f766ab07"));
Object.keys(_touchRippleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _touchRippleClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _touchRippleClasses[key];
        }
    });
});

},{"66d72c59b5f8d14a":"fiRIh","28efbad31020a5d9":"kZ6eK","b0dcdf9e97a7aeab":"2xcyI","bbae292c07b938bc":"flxF9","8acde9f2f766ab07":"H6sp0"}],"2xcyI":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2c955254ef2e13dd").default;
var _interopRequireWildcard = require("e071521434168a8c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.ButtonBaseRoot = void 0;
var React = _interopRequireWildcard(require("8481a3c8ce9d2c22"));
var _propTypes = _interopRequireDefault(require("55c10e0f5d30ebbf"));
var _clsx = _interopRequireDefault(require("e01c8d8fa94d94dc"));
var _refType = _interopRequireDefault(require("9593e200a8649ea8"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("f957b9cfd9d07b9b"));
var _composeClasses = _interopRequireDefault(require("1bf19d6d08d55283"));
var _isFocusVisible = _interopRequireDefault(require("778c94b921e14bcf"));
var _zeroStyled = require("c0d7cd53e55010cb");
var _DefaultPropsProvider = require("9d7f3864c6d6caa0");
var _useForkRef = _interopRequireDefault(require("6b1e4e1a97e702b2"));
var _useEventCallback = _interopRequireDefault(require("720bdb63fdaab791"));
var _useLazyRipple = _interopRequireDefault(require("a3d9cc12be9bd1e0"));
var _TouchRipple = _interopRequireDefault(require("736a798a91d840c6"));
var _buttonBaseClasses = _interopRequireWildcard(require("987347f84317bbfd"));
var _jsxRuntime = require("c853e24e0fb731ab");
const useUtilityClasses = (ownerState)=>{
    const { disabled, focusVisible, focusVisibleClassName, classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _buttonBaseClasses.getButtonBaseUtilityClass, classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const ButtonBaseRoot = exports.ButtonBaseRoot = (0, _zeroStyled.styled)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${_buttonBaseClasses.default.disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const ButtonBase = /*#__PURE__*/ React.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action, centerRipple = false, children, className, component = 'button', disabled = false, disableRipple = false, disableTouchRipple = false, focusRipple = false, focusVisibleClassName, LinkComponent = 'a', onBlur, onClick, onContextMenu, onDragLeave, onFocus, onFocusVisible, onKeyDown, onKeyUp, onMouseDown, onMouseLeave, onMouseUp, onTouchEnd, onTouchMove, onTouchStart, tabIndex = 0, TouchRippleProps, touchRippleRef, type, ...other } = props;
    const buttonRef = React.useRef(null);
    const ripple = (0, _useLazyRipple.default)();
    const handleRippleRef = (0, _useForkRef.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = React.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    React.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    React.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, _isFocusVisible.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, _useEventCallback.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, _isFocusVisible.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, _useEventCallback.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, _useEventCallback.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, _useForkRef.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple,
        component,
        disabled,
        disableRipple,
        disableTouchRipple,
        focusRipple,
        tabIndex,
        focusVisible
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonBaseRoot, {
        as: ComponentProp,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TouchRipple.default, {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, _useEventCallback.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var _default = exports.default = ButtonBase;

},{"2c955254ef2e13dd":"kZ6eK","e071521434168a8c":"fiRIh","8481a3c8ce9d2c22":"9njXz","55c10e0f5d30ebbf":"bnNSm","e01c8d8fa94d94dc":"d2NWs","9593e200a8649ea8":"3TBXN","f957b9cfd9d07b9b":"40NoV","1bf19d6d08d55283":"59Equ","778c94b921e14bcf":"gHKhh","c0d7cd53e55010cb":"89fxU","9d7f3864c6d6caa0":"ff3VX","6b1e4e1a97e702b2":"cq8Sn","720bdb63fdaab791":"jTtn3","a3d9cc12be9bd1e0":"adG7S","736a798a91d840c6":"9I8Ri","987347f84317bbfd":"flxF9","c853e24e0fb731ab":"1dlk8"}],"adG7S":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2cd68f5bdf56db52").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useLazyRipple.default;
    }
});
var _useLazyRipple = _interopRequireDefault(require("7bda0fd9ac206624"));

},{"2cd68f5bdf56db52":"kZ6eK","7bda0fd9ac206624":"dE8kh"}],"dE8kh":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("eb6648f4f74e2475").default;
var _interopRequireWildcard = require("2fe878bc6ccf95f6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LazyRipple = void 0;
exports.default = useLazyRipple;
var React = _interopRequireWildcard(require("1211e31124a91760"));
var _useLazyRef = _interopRequireDefault(require("6243647e1c08a9df"));
/**
 * Lazy initialization container for the Ripple instance. This improves
 * performance by delaying mounting the ripple until it's needed.
 */ class LazyRipple {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new LazyRipple();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, _useLazyRef.default)(LazyRipple.create).current;
        const [shouldMount, setShouldMount] = React.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        React.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
exports.LazyRipple = LazyRipple;
function useLazyRipple() {
    return LazyRipple.use();
}
function createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

},{"eb6648f4f74e2475":"kZ6eK","2fe878bc6ccf95f6":"fiRIh","1211e31124a91760":"9njXz","6243647e1c08a9df":"gb1Wb"}],"9I8Ri":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b567e695c0eec974").default;
var _interopRequireWildcard = require("1835a7c83712e9be").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.TouchRippleRoot = exports.TouchRippleRipple = exports.DELAY_RIPPLE = void 0;
var React = _interopRequireWildcard(require("392d2bfae43eb5f0"));
var _propTypes = _interopRequireDefault(require("4a2cb738bcba2c57"));
var _reactTransitionGroup = require("a2782369d35c9a16");
var _clsx = _interopRequireDefault(require("c02484845ba8cfcf"));
var _useTimeout = _interopRequireDefault(require("18b96c871515d1f0"));
var _zeroStyled = require("88106a92e12835b7");
var _DefaultPropsProvider = require("4f6a73baf94431a8");
var _Ripple = _interopRequireDefault(require("c9d65d2e84f31d3"));
var _touchRippleClasses = _interopRequireDefault(require("23f132bf503da5f8"));
var _jsxRuntime = require("7a8f6e21643e1f7");
const DURATION = 550;
const DELAY_RIPPLE = exports.DELAY_RIPPLE = 80;
const enterKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const exitKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const pulsateKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const TouchRippleRoot = exports.TouchRippleRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const TouchRippleRipple = exports.TouchRippleRipple = (0, _zeroStyled.styled)(_Ripple.default, {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${_touchRippleClasses.default.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${enterKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({ theme })=>theme.transitions.easing.easeInOut};
  }

  &.${_touchRippleClasses.default.ripplePulsate} {
    animation-duration: ${({ theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${_touchRippleClasses.default.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${_touchRippleClasses.default.childLeaving} {
    opacity: 0;
    animation-name: ${exitKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({ theme })=>theme.transitions.easing.easeInOut};
  }

  & .${_touchRippleClasses.default.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const TouchRipple = /*#__PURE__*/ React.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes = {}, className, ...other } = props;
    const [ripples, setRipples] = React.useState([]);
    const nextKey = React.useRef(0);
    const rippleCallback = React.useRef(null);
    React.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = React.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, _useTimeout.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = React.useRef(null);
    const container = React.useRef(null);
    const startCommit = React.useCallback((params)=>{
        const { pulsate, rippleX, rippleY, rippleSize, cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRipple, {
                    classes: {
                        ripple: (0, _clsx.default)(classes.ripple, _touchRippleClasses.default.ripple),
                        rippleVisible: (0, _clsx.default)(classes.rippleVisible, _touchRippleClasses.default.rippleVisible),
                        ripplePulsate: (0, _clsx.default)(classes.ripplePulsate, _touchRippleClasses.default.ripplePulsate),
                        child: (0, _clsx.default)(classes.child, _touchRippleClasses.default.child),
                        childLeaving: (0, _clsx.default)(classes.childLeaving, _touchRippleClasses.default.childLeaving),
                        childPulsate: (0, _clsx.default)(classes.childPulsate, _touchRippleClasses.default.childPulsate)
                    },
                    timeout: DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = React.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate = false, center = centerProp || options.pulsate, fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX, clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate,
                        rippleX,
                        rippleY,
                        rippleSize,
                        cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start(DELAY_RIPPLE, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = React.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = React.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    React.useImperativeHandle(ref, ()=>({
            pulsate,
            start,
            stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRoot, {
        className: (0, _clsx.default)(_touchRippleClasses.default.root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactTransitionGroup.TransitionGroup, {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var _default = exports.default = TouchRipple;

},{"b567e695c0eec974":"kZ6eK","1835a7c83712e9be":"fiRIh","392d2bfae43eb5f0":"9njXz","4a2cb738bcba2c57":"bnNSm","a2782369d35c9a16":"hnCQJ","c02484845ba8cfcf":"d2NWs","18b96c871515d1f0":"k3sgs","88106a92e12835b7":"89fxU","4f6a73baf94431a8":"ff3VX","c9d65d2e84f31d3":"fUW0U","23f132bf503da5f8":"H6sp0","7a8f6e21643e1f7":"1dlk8"}],"fUW0U":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("3690c8bf136551e2").default;
var _interopRequireWildcard = require("a841cab47ac83eca").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("2f41207afb3063"));
var _propTypes = _interopRequireDefault(require("b1d16dedfc42b5cf"));
var _clsx = _interopRequireDefault(require("4f8810837dfd6104"));
var _jsxRuntime = require("d606bfd32ed8d643");
/**
 * @ignore - internal component.
 */ function Ripple(props) {
    const { className, classes, pulsate = false, rippleX, rippleY, rippleSize, in: inProp, onExited, timeout } = props;
    const [leaving, setLeaving] = React.useState(false);
    const rippleClassName = (0, _clsx.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, _clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    React.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: childClassName
        })
    });
}
var _default = exports.default = Ripple;

},{"3690c8bf136551e2":"kZ6eK","a841cab47ac83eca":"fiRIh","2f41207afb3063":"9njXz","b1d16dedfc42b5cf":"bnNSm","4f8810837dfd6104":"d2NWs","d606bfd32ed8d643":"1dlk8"}],"H6sp0":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("937ab16aead69169").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTouchRippleUtilityClass = getTouchRippleUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("6a1e2dac67630739"));
var _generateUtilityClass = _interopRequireDefault(require("2b3d66e8e63885c6"));
function getTouchRippleUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTouchRipple', slot);
}
const touchRippleClasses = (0, _generateUtilityClasses.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var _default = exports.default = touchRippleClasses;

},{"937ab16aead69169":"kZ6eK","6a1e2dac67630739":"7pSUk","2b3d66e8e63885c6":"jBs9M"}],"flxF9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e6c1de48f44d23c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getButtonBaseUtilityClass = getButtonBaseUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("1f2bfc9395fb86bb"));
var _generateUtilityClass = _interopRequireDefault(require("f7753f545790a3ad"));
function getButtonBaseUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiButtonBase', slot);
}
const buttonBaseClasses = (0, _generateUtilityClasses.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var _default = exports.default = buttonBaseClasses;

},{"e6c1de48f44d23c":"kZ6eK","1f2bfc9395fb86bb":"7pSUk","f7753f545790a3ad":"jBs9M"}],"bK4ky":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("4fdd07ef778f223d").default;
var _interopRequireDefault = require("9b25eaaf7f6c7f1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    circularProgressClasses: true
};
Object.defineProperty(exports, "circularProgressClasses", {
    enumerable: true,
    get: function() {
        return _circularProgressClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _CircularProgress.default;
    }
});
var _CircularProgress = _interopRequireDefault(require("9aebb94456c71ddb"));
var _circularProgressClasses = _interopRequireWildcard(require("9adfc68e6537c7c6"));
Object.keys(_circularProgressClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _circularProgressClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _circularProgressClasses[key];
        }
    });
});

},{"4fdd07ef778f223d":"fiRIh","9b25eaaf7f6c7f1":"kZ6eK","9aebb94456c71ddb":"fseyv","9adfc68e6537c7c6":"6HS9Q"}],"fseyv":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9a47bc67518d5550").default;
var _interopRequireWildcard = require("98cfe1cc6eabb541").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("ce256639286eb79c"));
var _propTypes = _interopRequireDefault(require("9214780bbd89770a"));
var _clsx = _interopRequireDefault(require("33bd5d7d97e996a3"));
var _chainPropTypes = _interopRequireDefault(require("11e1e6fb5eb8869c"));
var _composeClasses = _interopRequireDefault(require("266cabb7ae13b22"));
var _zeroStyled = require("9f96b7c67d434611");
var _memoTheme = _interopRequireDefault(require("fc2f50ce6f9894e3"));
var _DefaultPropsProvider = require("77cc971ccd91b1ed");
var _capitalize = _interopRequireDefault(require("8f4d30c769c37cff"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("bfa4fe5fbfd21b68"));
var _circularProgressClasses = require("6477b35769ae981e");
var _jsxRuntime = require("83f58c0a280911d9");
const SIZE = 44;
const circularRotateKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const circularDashKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const rotateAnimation = typeof circularRotateKeyframe !== 'string' ? (0, _zeroStyled.css)`
        animation: ${circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const dashAnimation = typeof circularDashKeyframe !== 'string' ? (0, _zeroStyled.css)`
        animation: ${circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, color, disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, _capitalize.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, _capitalize.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, _composeClasses.default)(slots, _circularProgressClasses.getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, _capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: rotateAnimation || {
                    animation: `${circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const CircularProgressSVG = (0, _zeroStyled.styled)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const CircularProgressCircle = (0, _zeroStyled.styled)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, _capitalize.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const CircularProgress = /*#__PURE__*/ React.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className, color = 'primary', disableShrink = false, size = 40, style, thickness = 3.6, value = 0, variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color,
        disableShrink,
        size,
        thickness,
        value,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressRoot, {
        className: (0, _clsx.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: SIZE,
                cy: SIZE,
                r: (SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var _default = exports.default = CircularProgress;

},{"9a47bc67518d5550":"kZ6eK","98cfe1cc6eabb541":"fiRIh","ce256639286eb79c":"9njXz","9214780bbd89770a":"bnNSm","33bd5d7d97e996a3":"d2NWs","11e1e6fb5eb8869c":"4stnp","266cabb7ae13b22":"59Equ","9f96b7c67d434611":"89fxU","fc2f50ce6f9894e3":"2zy52","77cc971ccd91b1ed":"ff3VX","8f4d30c769c37cff":"hBZko","bfa4fe5fbfd21b68":"yHYvD","6477b35769ae981e":"6HS9Q","83f58c0a280911d9":"1dlk8"}],"6HS9Q":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ef3458c08725a5d5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getCircularProgressUtilityClass = getCircularProgressUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("7fc2a9bb5ad3b93f"));
var _generateUtilityClass = _interopRequireDefault(require("8d28c6c6efd8d002"));
function getCircularProgressUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0, _generateUtilityClasses.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var _default = exports.default = circularProgressClasses;

},{"ef3458c08725a5d5":"kZ6eK","7fc2a9bb5ad3b93f":"7pSUk","8d28c6c6efd8d002":"jBs9M"}],"bLPmg":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("24656ccdcfba9dff").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getIconButtonUtilityClass = getIconButtonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4152fe903d5916d6"));
var _generateUtilityClass = _interopRequireDefault(require("b47076616d8647c0"));
function getIconButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiIconButton', slot);
}
const iconButtonClasses = (0, _generateUtilityClasses.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var _default = exports.default = iconButtonClasses;

},{"24656ccdcfba9dff":"kZ6eK","4152fe903d5916d6":"7pSUk","b47076616d8647c0":"jBs9M"}],"8RbJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowDropDownIcon", ()=>ArrowDropDownIcon);
parcelHelpers.export(exports, "ArrowLeftIcon", ()=>ArrowLeftIcon);
parcelHelpers.export(exports, "ArrowRightIcon", ()=>ArrowRightIcon);
parcelHelpers.export(exports, "CalendarIcon", ()=>CalendarIcon);
parcelHelpers.export(exports, "ClockIcon", ()=>ClockIcon);
parcelHelpers.export(exports, "DateRangeIcon", ()=>DateRangeIcon);
parcelHelpers.export(exports, "TimeIcon", ()=>TimeIcon);
parcelHelpers.export(exports, "ClearIcon", ()=>ClearIcon);
var _utils = require("@mui/material/utils");
var _react = require("react");
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
const ArrowDropDownIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const ArrowLeftIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const ArrowRightIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const CalendarIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const ClockIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const DateRangeIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const TimeIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
const ClearIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

},{"@mui/material/utils":"60iOt","react":"9njXz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lVyql":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersArrowSwitcherUtilityClass", ()=>getPickersArrowSwitcherUtilityClass);
parcelHelpers.export(exports, "pickersArrowSwitcherClasses", ()=>pickersArrowSwitcherClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getPickersArrowSwitcherUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersArrowSwitcher', slot);
}
const pickersArrowSwitcherClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button',
    'previousIconButton',
    'nextIconButton',
    'leftArrowIcon',
    'rightArrowIcon'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4puZL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePickerPrivateContext", ()=>usePickerPrivateContext);
var _react = require("react");
var _pickerProviderJs = require("../components/PickerProvider.js");
'use client';
const usePickerPrivateContext = ()=>_react.useContext((0, _pickerProviderJs.PickerPrivateContext));

},{"react":"9njXz","../components/PickerProvider.js":"lJDhK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lJDhK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerActionsContext", ()=>PickerActionsContext);
parcelHelpers.export(exports, "PickerPrivateContext", ()=>PickerPrivateContext);
parcelHelpers.export(exports, "PickerProvider", ()=>PickerProvider);
var _react = require("react");
var _indexJs = require("../../LocalizationProvider/index.js");
var _useIsValidValueJs = require("../../hooks/useIsValidValue.js");
var _useNullableFieldPrivateContextJs = require("../hooks/useNullableFieldPrivateContext.js");
var _usePickerContextJs = require("../../hooks/usePickerContext.js");
var _jsxRuntime = require("react/jsx-runtime");
const PickerActionsContext = /*#__PURE__*/ _react.createContext(null);
const PickerPrivateContext = /*#__PURE__*/ _react.createContext({
    ownerState: {
        isPickerDisabled: false,
        isPickerReadOnly: false,
        isPickerValueEmpty: false,
        isPickerOpen: false,
        pickerVariant: 'desktop',
        pickerOrientation: 'portrait'
    },
    rootRefObject: {
        current: null
    },
    labelId: undefined,
    dismissViews: ()=>{},
    hasUIView: true,
    getCurrentViewMode: ()=>'UI',
    triggerElement: null,
    viewContainerRole: null,
    defaultActionBarActions: [],
    onPopperExited: undefined
});
function PickerProvider(props) {
    const { contextValue, actionsContextValue, privateContextValue, fieldPrivateContextValue, isValidContextValue, localeText, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usePickerContextJs.PickerContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerActionsContext.Provider, {
            value: actionsContextValue,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerPrivateContext.Provider, {
                value: privateContextValue,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useNullableFieldPrivateContextJs.PickerFieldPrivateContext).Provider, {
                    value: fieldPrivateContextValue,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useIsValidValueJs.IsValidValueContext).Provider, {
                        value: isValidContextValue,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.LocalizationProvider), {
                            localeText: localeText,
                            children: children
                        })
                    })
                })
            })
        })
    });
}

},{"react":"9njXz","../../LocalizationProvider/index.js":"6A4sI","../../hooks/useIsValidValue.js":"lKU6V","../hooks/useNullableFieldPrivateContext.js":"3cpM2","../../hooks/usePickerContext.js":"hyseP","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6A4sI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalizationProvider", ()=>(0, _localizationProviderJs.LocalizationProvider));
parcelHelpers.export(exports, "MuiPickersAdapterContext", ()=>(0, _localizationProviderJs.MuiPickersAdapterContext));
var _localizationProviderJs = require("./LocalizationProvider.js");

},{"./LocalizationProvider.js":"3BMNW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lKU6V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsValidValueContext", ()=>IsValidValueContext);
parcelHelpers.export(exports, "useIsValidValue", ()=>useIsValidValue);
var _react = require("react");
'use client';
const IsValidValueContext = /*#__PURE__*/ _react.createContext(()=>true);
function useIsValidValue() {
    return _react.useContext(IsValidValueContext);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cpM2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerFieldPrivateContext", ()=>PickerFieldPrivateContext);
parcelHelpers.export(exports, "useNullableFieldPrivateContext", ()=>useNullableFieldPrivateContext);
var _react = require("react");
const PickerFieldPrivateContext = /*#__PURE__*/ _react.createContext(null);
function useNullableFieldPrivateContext() {
    return _react.useContext(PickerFieldPrivateContext);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hyseP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerContext", ()=>PickerContext);
parcelHelpers.export(exports, "usePickerContext", ()=>usePickerContext);
var _react = require("react");
'use client';
const PickerContext = /*#__PURE__*/ _react.createContext(null);
const usePickerContext = ()=>{
    const value = _react.useContext(PickerContext);
    if (value == null) throw new Error('MUI X: The `usePickerContext` hook can only be called inside the context of a Picker component');
    return value;
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7FMia":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EXPORTED_TIME_VIEWS", ()=>EXPORTED_TIME_VIEWS);
parcelHelpers.export(exports, "TIME_VIEWS", ()=>TIME_VIEWS);
parcelHelpers.export(exports, "isTimeView", ()=>isTimeView);
parcelHelpers.export(exports, "isInternalTimeView", ()=>isInternalTimeView);
parcelHelpers.export(exports, "getMeridiem", ()=>getMeridiem);
parcelHelpers.export(exports, "convertValueToMeridiem", ()=>convertValueToMeridiem);
parcelHelpers.export(exports, "convertToMeridiem", ()=>convertToMeridiem);
parcelHelpers.export(exports, "getSecondsInDay", ()=>getSecondsInDay);
parcelHelpers.export(exports, "createIsAfterIgnoreDatePart", ()=>createIsAfterIgnoreDatePart);
parcelHelpers.export(exports, "resolveTimeFormat", ()=>resolveTimeFormat);
var _viewsJs = require("./views.js");
const EXPORTED_TIME_VIEWS = [
    'hours',
    'minutes',
    'seconds'
];
const TIME_VIEWS = [
    'hours',
    'minutes',
    'seconds',
    'meridiem'
];
const isTimeView = (view)=>EXPORTED_TIME_VIEWS.includes(view);
const isInternalTimeView = (view)=>TIME_VIEWS.includes(view);
const getMeridiem = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const convertValueToMeridiem = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const convertToMeridiem = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = convertValueToMeridiem(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const getSecondsInDay = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
    };
const resolveTimeFormat = (utils, { format, views, ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};

},{"./views.js":"lfBM6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lfBM6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areViewsEqual", ()=>areViewsEqual);
parcelHelpers.export(exports, "applyDefaultViewProps", ()=>applyDefaultViewProps);
const areViewsEqual = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const applyDefaultViewProps = ({ openTo, defaultOpenTo, views, defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI X: The `views` prop must contain at least one view.');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVwkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useViews", ()=>useViews);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useControlled = require("@mui/utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _createStepNavigationJs = require("../utils/createStepNavigation.js");
let warnedOnceNotValidView = false;
function useViews({ onChange, onViewChange, openTo, view: inView, views, autoFocus, focusedView: inFocusedView, onFocusedViewChange, getStepNavigation }) {
    const previousOpenTo = _react.useRef(openTo);
    const previousViews = _react.useRef(views);
    const defaultView = _react.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, _useControlledDefault.default)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = _react.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, _useControlledDefault.default)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    const stepNavigation = getStepNavigation ? getStepNavigation({
        setView,
        view,
        defaultView: defaultView.current,
        views
    }) : (0, _createStepNavigationJs.DEFAULT_STEP_NAVIGATION);
    _react.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, _useEventCallbackDefault.default)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, _useEventCallbackDefault.default)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, _useEventCallbackDefault.default)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, _useEventCallbackDefault.default)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // The selected view can be different from the active view,
        // This can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        let currentView = null;
        if (selectedView != null && selectedView !== view) currentView = selectedView;
        else if (isSelectionFinishedOnCurrentView) currentView = view;
        if (currentView == null) return;
        const viewToNavigateTo = views[views.indexOf(currentView) + 1];
        if (viewToNavigateTo == null || !stepNavigation.areViewsInSameStep(currentView, viewToNavigateTo)) return;
        handleChangeView(viewToNavigateTo);
    });
    return (0, _extendsDefault.default)({}, stepNavigation, {
        view,
        setView: handleChangeView,
        focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView,
        previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView,
        setValueAndGoToNextView
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/utils/useEventCallback":"feNJe","@mui/utils/useControlled":"jwZrv","../utils/createStepNavigation.js":"8euDC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8euDC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_STEP_NAVIGATION", ()=>DEFAULT_STEP_NAVIGATION);
/**
 * Create an object that determines whether there is a next step and allows to go to the next step.
 * @param {CreateStepNavigationParameters<TStep>} parameters The parameters of the createStepNavigation function
 * @returns {CreateStepNavigationReturnValue} The return value of the createStepNavigation function
 */ parcelHelpers.export(exports, "createStepNavigation", ()=>createStepNavigation);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const DEFAULT_STEP_NAVIGATION = {
    hasNextStep: false,
    hasSeveralSteps: false,
    goToNextStep: ()=>{},
    areViewsInSameStep: ()=>true
};
function createStepNavigation(parameters) {
    const { steps, isViewMatchingStep, onStepChange } = parameters;
    return (parametersBis)=>{
        if (steps == null) return DEFAULT_STEP_NAVIGATION;
        const currentStepIndex = steps.findIndex((step)=>isViewMatchingStep(parametersBis.view, step));
        const nextStep = currentStepIndex === -1 || currentStepIndex === steps.length - 1 ? null : steps[currentStepIndex + 1];
        return {
            hasNextStep: nextStep != null,
            hasSeveralSteps: steps.length > 1,
            goToNextStep: ()=>{
                if (nextStep == null) return;
                onStepChange((0, _extendsDefault.default)({}, parametersBis, {
                    step: nextStep
                }));
            },
            areViewsInSameStep: (viewA, viewB)=>{
                const stepA = steps.find((step)=>isViewMatchingStep(viewA, step));
                const stepB = steps.find((step)=>isViewMatchingStep(viewB, step));
                return stepA === stepB;
            }
        };
    };
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ifoSw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNextMonthDisabled", ()=>useNextMonthDisabled);
parcelHelpers.export(exports, "usePreviousMonthDisabled", ()=>usePreviousMonthDisabled);
parcelHelpers.export(exports, "useMeridiemMode", ()=>useMeridiemMode);
var _react = require("react");
var _useUtilsJs = require("./useUtils.js");
var _timeUtilsJs = require("../utils/time-utils.js");
function useNextMonthDisabled(month, { disableFuture, maxDate, timezone }) {
    const utils = (0, _useUtilsJs.useUtils)();
    return _react.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function usePreviousMonthDisabled(month, { disablePast, minDate, timezone }) {
    const utils = (0, _useUtilsJs.useUtils)();
    return _react.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function useMeridiemMode(date, ampm, onChange, selectionState) {
    const utils = (0, _useUtilsJs.useUtils)();
    const cleanDate = _react.useMemo(()=>!utils.isValid(date) ? null : date, [
        utils,
        date
    ]);
    const meridiemMode = (0, _timeUtilsJs.getMeridiem)(cleanDate, utils);
    const handleMeridiemChange = _react.useCallback((mode)=>{
        const timeWithMeridiem = cleanDate == null ? null : (0, _timeUtilsJs.convertToMeridiem)(cleanDate, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState ?? 'partial');
    }, [
        ampm,
        cleanDate,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode,
        handleMeridiemChange
    };
}

},{"react":"9njXz","./useUtils.js":"dJQ8a","../utils/time-utils.js":"7FMia","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gmdrj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerViewRoot", ()=>(0, _pickerViewRootJs.PickerViewRoot));
var _pickerViewRootJs = require("./PickerViewRoot.js");

},{"./PickerViewRoot.js":"auYlq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"auYlq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerViewRoot", ()=>PickerViewRoot);
var _styles = require("@mui/material/styles");
var _dimensionsJs = require("../../constants/dimensions.js");
const PickerViewRoot = (0, _styles.styled)('div')({
    overflow: 'hidden',
    width: (0, _dimensionsJs.DIALOG_WIDTH),
    maxHeight: (0, _dimensionsJs.VIEW_HEIGHT),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});

},{"@mui/material/styles":"c9RfU","../../constants/dimensions.js":"i0BgX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0BgX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DAY_SIZE", ()=>DAY_SIZE);
parcelHelpers.export(exports, "DAY_MARGIN", ()=>DAY_MARGIN);
parcelHelpers.export(exports, "DIALOG_WIDTH", ()=>DIALOG_WIDTH);
parcelHelpers.export(exports, "MAX_CALENDAR_HEIGHT", ()=>MAX_CALENDAR_HEIGHT);
parcelHelpers.export(exports, "VIEW_HEIGHT", ()=>VIEW_HEIGHT);
parcelHelpers.export(exports, "DIGITAL_CLOCK_VIEW_HEIGHT", ()=>DIGITAL_CLOCK_VIEW_HEIGHT);
parcelHelpers.export(exports, "MULTI_SECTION_CLOCK_SECTION_WIDTH", ()=>MULTI_SECTION_CLOCK_SECTION_WIDTH);
const DAY_SIZE = 36;
const DAY_MARGIN = 2;
const DIALOG_WIDTH = 320;
const MAX_CALENDAR_HEIGHT = 280;
const VIEW_HEIGHT = 336;
const DIGITAL_CLOCK_VIEW_HEIGHT = 232;
const MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5OwTo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTimeClockUtilityClass", ()=>getTimeClockUtilityClass);
parcelHelpers.export(exports, "timeClockClasses", ()=>timeClockClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getTimeClockUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTimeClock', slot);
}
const timeClockClasses = (0, _generateUtilityClassesDefault.default)('MuiTimeClock', [
    'root',
    'arrowSwitcher'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hLm0B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - internal component.
 */ parcelHelpers.export(exports, "Clock", ()=>Clock);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _clockPointerJs = require("./ClockPointer.js");
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _sharedJs = require("./shared.js");
var _clockClassesJs = require("./clockClasses.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton',
            ownerState.clockMeridiemMode === 'am' && 'selected'
        ],
        pmButton: [
            'pmButton',
            ownerState.clockMeridiemMode === 'pm' && 'selected'
        ],
        meridiemText: [
            'meridiemText'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _clockClassesJs.getClockUtilityClass), classes);
};
const ClockRoot = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'Root'
})(({ theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const ClockClock = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'Clock'
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const ClockWrapper = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'Wrapper'
})({
    '&:focus': {
        outline: 'none'
    }
});
const ClockSquareMask = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'SquareMask'
})({
    width: '100%',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    outline: 0,
    // Disable scroll capabilities.
    touchAction: 'none',
    userSelect: 'none',
    variants: [
        {
            props: {
                isClockDisabled: false
            },
            style: {
                '@media (pointer: fine)': {
                    cursor: 'pointer',
                    borderRadius: '50%'
                },
                '&:active': {
                    cursor: 'move'
                }
            }
        }
    ]
});
const ClockPin = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'Pin'
})(({ theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const meridiemButtonCommonStyles = (theme, clockMeridiemMode)=>({
        zIndex: 1,
        bottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, _sharedJs.CLOCK_HOUR_WIDTH),
        variants: [
            {
                props: {
                    clockMeridiemMode
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    });
const ClockAmButton = (0, _styles.styled)((0, _iconButtonDefault.default), {
    name: 'MuiClock',
    slot: 'AmButton'
})(({ theme })=>(0, _extendsDefault.default)({}, meridiemButtonCommonStyles(theme, 'am'), {
        // keeping it here to make TS happy
        position: 'absolute',
        left: 8
    }));
const ClockPmButton = (0, _styles.styled)((0, _iconButtonDefault.default), {
    name: 'MuiClock',
    slot: 'PmButton'
})(({ theme })=>(0, _extendsDefault.default)({}, meridiemButtonCommonStyles(theme, 'pm'), {
        // keeping it here to make TS happy
        position: 'absolute',
        right: 8
    }));
const ClockMeridiemText = (0, _styles.styled)((0, _typographyDefault.default), {
    name: 'MuiClock',
    slot: 'MeridiemText'
})({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
function Clock(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm, ampmInClock, autoFocus, children, value, handleMeridiemChange, isTimeDisabled, meridiemMode, minutesStep = 1, onChange, selectedId, type, viewValue, viewRange: [minViewValue, maxViewValue], disabled = false, readOnly, className, classes: classesProp } = props;
    const utils = (0, _useUtilsJs.useUtils)();
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const ownerState = (0, _extendsDefault.default)({}, pickerOwnerState, {
        isClockDisabled: disabled,
        clockMeridiemMode: meridiemMode
    });
    const isMoving = _react.useRef(false);
    const classes = useUtilityClasses(classesProp, ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === 'hours' && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX, offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, _sharedJs.getMinutes)(offsetX, offsetY, minutesStep) : (0, _sharedJs.getHours)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchSelection = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
        event.preventDefault();
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const isPointerBetweenTwoClockValues = type === 'hours' ? false : viewValue % 5 !== 0;
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = _react.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const clampValue = (newValue)=>Math.max(minViewValue, Math.min(maxViewValue, newValue));
    const circleValue = (newValue)=>(newValue + (maxViewValue + 1)) % (maxViewValue + 1);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // reset both hours and minutes
                handleValueChange(minViewValue, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(maxViewValue, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(circleValue(viewValue + keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(circleValue(viewValue - keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'PageUp':
                handleValueChange(clampValue(viewValue + 5), 'partial');
                event.preventDefault();
                break;
            case 'PageDown':
                handleValueChange(clampValue(viewValue - 5), 'partial');
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleValueChange(viewValue, 'finish');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ClockRoot, {
        className: (0, _clsxDefault.default)(classes.root, className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockSquareMask, {
                        onTouchMove: handleTouchSelection,
                        onTouchStart: handleTouchSelection,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: ownerState,
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockPointerJs.ClockPointer), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                isBetweenTwoClockValues: isPointerBetweenTwoClockValues
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": translations.clockLabelText(type, value == null ? null : utils.format(value, ampm ? 'fullTime12h' : 'fullTime24h')),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, _dateUtilsJs.formatMeridiem)(utils, 'am'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, _dateUtilsJs.formatMeridiem)(utils, 'am')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, _dateUtilsJs.formatMeridiem)(utils, 'pm'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, _dateUtilsJs.formatMeridiem)(utils, 'pm')
                        })
                    })
                ]
            })
        ]
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","clsx":"d2NWs","@mui/material/IconButton":"bXjnZ","@mui/material/Typography":"2wCD5","@mui/material/styles":"c9RfU","@mui/utils/useEnhancedEffect":"fIvqa","@mui/utils/composeClasses":"59Equ","./ClockPointer.js":"5ISwZ","../hooks/usePickerTranslations.js":"3Zb4l","../internals/hooks/useUtils.js":"dJQ8a","./shared.js":"fjbRH","./clockClasses.js":"fHXpc","../internals/utils/date-utils.js":"jrk9G","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ISwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - internal component.
 */ parcelHelpers.export(exports, "ClockPointer", ()=>ClockPointer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _sharedJs = require("./shared.js");
var _clockPointerClassesJs = require("./clockPointerClasses.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "classes",
    "isBetweenTwoClockValues",
    "isInner",
    "type",
    "viewValue"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _clockPointerClassesJs.getClockPointerUtilityClass), classes);
};
const ClockPointerRoot = (0, _styles.styled)('div', {
    name: 'MuiClockPointer',
    slot: 'Root'
})(({ theme })=>({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px',
        variants: [
            {
                props: {
                    isClockPointerAnimated: true
                },
                style: {
                    transition: theme.transitions.create([
                        'transform',
                        'height'
                    ])
                }
            }
        ]
    }));
const ClockPointerThumb = (0, _styles.styled)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb'
})(({ theme })=>({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${(0, _sharedJs.CLOCK_HOUR_WIDTH) / 2}px)`,
        border: `${((0, _sharedJs.CLOCK_HOUR_WIDTH) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: 'content-box',
        variants: [
            {
                props: {
                    isClockPointerBetweenTwoValues: false
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    }));
function ClockPointer(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className, classes: classesProp, isBetweenTwoClockValues, isInner, type, viewValue } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const previousType = _react.useRef(type);
    _react.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const ownerState = (0, _extendsDefault.default)({}, pickerOwnerState, {
        isClockPointerAnimated: previousType.current !== type,
        isClockPointerBetweenTwoValues: isBetweenTwoClockValues
    });
    const classes = useUtilityClasses(classesProp);
    const getAngleStyle = ()=>{
        const max = type === 'hours' ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === 'hours' && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, _sharedJs.CLOCK_WIDTH)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPointerRoot, (0, _extendsDefault.default)({
        style: getAngleStyle(),
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","./shared.js":"fjbRH","./clockPointerClasses.js":"h3cqU","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fjbRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_WIDTH", ()=>CLOCK_WIDTH);
parcelHelpers.export(exports, "CLOCK_HOUR_WIDTH", ()=>CLOCK_HOUR_WIDTH);
parcelHelpers.export(exports, "getMinutes", ()=>getMinutes);
parcelHelpers.export(exports, "getHours", ()=>getHours);
const CLOCK_WIDTH = 220;
const CLOCK_HOUR_WIDTH = 36;
const clockCenter = {
    x: CLOCK_WIDTH / 2,
    y: CLOCK_WIDTH / 2
};
const baseClockPoint = {
    x: clockCenter.x,
    y: 0
};
const cx = baseClockPoint.x - clockCenter.x;
const cy = baseClockPoint.y - clockCenter.y;
const rad2deg = (rad)=>rad * (180 / Math.PI);
const getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - clockCenter.x;
    const y = offsetY - clockCenter.y;
    const atan = Math.atan2(cx, cy) - Math.atan2(x, y);
    let deg = rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value,
        distance
    };
};
const getMinutes = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value } = getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const getHours = (offsetX, offsetY, ampm)=>{
    const { value, distance } = getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < CLOCK_WIDTH / 2 - CLOCK_HOUR_WIDTH) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h3cqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClockPointerUtilityClass", ()=>getClockPointerUtilityClass);
parcelHelpers.export(exports, "clockPointerClasses", ()=>clockPointerClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getClockPointerUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiClockPointer', slot);
}
const clockPointerClasses = (0, _generateUtilityClassesDefault.default)('MuiClockPointer', [
    'root',
    'thumb'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fHXpc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClockUtilityClass", ()=>getClockUtilityClass);
parcelHelpers.export(exports, "clockClasses", ()=>clockClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getClockUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiClock', slot);
}
const clockClasses = (0, _generateUtilityClassesDefault.default)('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton',
    'meridiemText',
    'selected'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jrk9G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeDateAndTime", ()=>mergeDateAndTime);
parcelHelpers.export(exports, "findClosestEnabledDate", ()=>findClosestEnabledDate);
parcelHelpers.export(exports, "replaceInvalidDateByNull", ()=>replaceInvalidDateByNull);
parcelHelpers.export(exports, "applyDefaultDate", ()=>applyDefaultDate);
parcelHelpers.export(exports, "areDatesEqual", ()=>areDatesEqual);
parcelHelpers.export(exports, "getMonthsInYear", ()=>getMonthsInYear);
parcelHelpers.export(exports, "getTodayDate", ()=>getTodayDate);
parcelHelpers.export(exports, "formatMeridiem", ()=>formatMeridiem);
parcelHelpers.export(exports, "DATE_VIEWS", ()=>DATE_VIEWS);
parcelHelpers.export(exports, "isDatePickerView", ()=>isDatePickerView);
parcelHelpers.export(exports, "resolveDateFormat", ()=>resolveDateFormat);
parcelHelpers.export(exports, "getWeekdays", ()=>getWeekdays);
var _viewsJs = require("./views.js");
const mergeDateAndTime = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    mergedDate = utils.setMilliseconds(mergedDate, utils.getMilliseconds(timeParam));
    return mergedDate;
};
const findClosestEnabledDate = ({ date, disableFuture, disablePast, maxDate, minDate, isDateDisabled, utils, timezone })=>{
    const today = mergeDateAndTime(utils, utils.date(undefined, timezone), date);
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const replaceInvalidDateByNull = (utils, value)=>!utils.isValid(value) ? null : value;
const applyDefaultDate = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const areDatesEqual = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const getMonthsInYear = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const getTodayDate = (utils, timezone, valueType)=>valueType === 'date' ? utils.startOfDay(utils.date(undefined, timezone)) : utils.date(undefined, timezone);
const formatMeridiem = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === 'am' ? 2 : 14);
    return utils.format(date, 'meridiem');
};
const DATE_VIEWS = [
    'year',
    'month',
    'day'
];
const isDatePickerView = (view)=>DATE_VIEWS.includes(view);
const resolveDateFormat = (utils, { format, views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'year'
    ])) return formats.year;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'month'
    ])) return formats.month;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, _viewsJs.areViewsEqual)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const getWeekdays = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};

},{"./views.js":"lfBM6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3VZT4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHourNumbers", ()=>getHourNumbers);
parcelHelpers.export(exports, "getMinutesNumbers", ()=>getMinutesNumbers);
var _react = require("react");
var _clockNumberJs = require("./ClockNumber.js");
var _jsxRuntime = require("react/jsx-runtime");
const getHourNumbers = ({ ampm, value, getClockNumberText, isDisabled, selectedId, utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockNumberJs.ClockNumber), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const getMinutesNumbers = ({ utils, value, isDisabled, getClockNumberText, selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockNumberJs.ClockNumber), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};

},{"react":"9njXz","./ClockNumber.js":"9Djz0","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Djz0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - internal component.
 */ parcelHelpers.export(exports, "ClockNumber", ()=>ClockNumber);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _sharedJs = require("./shared.js");
var _clockNumberClassesJs = require("./clockNumberClasses.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "classes",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root',
            ownerState.isClockNumberSelected && 'selected',
            ownerState.isClockNumberDisabled && 'disabled'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _clockNumberClassesJs.getClockNumberUtilityClass), classes);
};
const ClockNumberRoot = (0, _styles.styled)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, _clockNumberClassesJs.clockNumberClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, _clockNumberClassesJs.clockNumberClasses).selected}`]: styles.selected
            }
        ]
})(({ theme })=>({
        height: (0, _sharedJs.CLOCK_HOUR_WIDTH),
        width: (0, _sharedJs.CLOCK_HOUR_WIDTH),
        position: 'absolute',
        left: `calc((100% - ${0, _sharedJs.CLOCK_HOUR_WIDTH}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, _clockNumberClassesJs.clockNumberClasses).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, _clockNumberClassesJs.clockNumberClasses).disabled}`]: {
            pointerEvents: 'none',
            color: (theme.vars || theme).palette.text.disabled
        },
        variants: [
            {
                props: {
                    isClockNumberInInnerRing: true
                },
                style: (0, _extendsDefault.default)({}, theme.typography.body2, {
                    color: (theme.vars || theme).palette.text.secondary
                })
            }
        ]
    }));
function ClockNumber(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className, classes: classesProp, disabled, index, inner, label, selected } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const ownerState = (0, _extendsDefault.default)({}, pickerOwnerState, {
        isClockNumberInInnerRing: inner,
        isClockNumberSelected: selected,
        isClockNumberDisabled: disabled
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, _sharedJs.CLOCK_WIDTH) - (0, _sharedJs.CLOCK_HOUR_WIDTH) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockNumberRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, _sharedJs.CLOCK_WIDTH) - (0, _sharedJs.CLOCK_HOUR_WIDTH)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","clsx":"d2NWs","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","./shared.js":"fjbRH","./clockNumberClasses.js":"il2xC","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"il2xC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClockNumberUtilityClass", ()=>getClockNumberUtilityClass);
parcelHelpers.export(exports, "clockNumberClasses", ()=>clockNumberClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getClockNumberUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiClockNumber', slot);
}
const clockNumberClasses = (0, _generateUtilityClassesDefault.default)('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hTAsm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControlledValue", ()=>useControlledValue);
var _react = require("react");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useControlled = require("@mui/utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useUtilsJs = require("./useUtils.js");
const useControlledValue = ({ name, timezone: timezoneProp, value: valueProp, defaultValue, referenceDate, onChange: onChangeProp, valueManager })=>{
    const utils = (0, _useUtilsJs.useUtils)();
    const [valueWithInputTimezone, setValue] = (0, _useControlledDefault.default)({
        name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const inputTimezone = _react.useMemo(()=>valueManager.getTimezone(utils, valueWithInputTimezone), [
        utils,
        valueManager,
        valueWithInputTimezone
    ]);
    const setInputTimezone = (0, _useEventCallbackDefault.default)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = _react.useMemo(()=>{
        if (timezoneProp) return timezoneProp;
        if (inputTimezone) return inputTimezone;
        if (referenceDate) return utils.getTimezone(referenceDate);
        return 'default';
    }, [
        timezoneProp,
        inputTimezone,
        referenceDate,
        utils
    ]);
    const valueWithTimezoneToRender = _react.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, valueWithInputTimezone), [
        valueManager,
        utils,
        timezoneToRender,
        valueWithInputTimezone
    ]);
    const handleValueChange = (0, _useEventCallbackDefault.default)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        setValue(newValueWithInputTimezone);
        onChangeProp?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange,
        timezone: timezoneToRender
    };
};

},{"react":"9njXz","@mui/utils/useEventCallback":"feNJe","@mui/utils/useControlled":"jwZrv","./useUtils.js":"dJQ8a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bimTj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "singleItemValueManager", ()=>singleItemValueManager);
parcelHelpers.export(exports, "singleItemFieldValueManager", ()=>singleItemFieldValueManager);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _dateUtilsJs = require("./date-utils.js");
var _getDefaultReferenceDateJs = require("./getDefaultReferenceDate.js");
var _useFieldUtilsJs = require("../hooks/useField/useField.utils.js");
const _excluded = [
    "value",
    "referenceDate"
];
const singleItemValueManager = {
    emptyValue: null,
    getTodayValue: (0, _dateUtilsJs.getTodayDate),
    getInitialReferenceValue: (_ref)=>{
        let { value, referenceDate } = _ref, params = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
        if (params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, _getDefaultReferenceDateJs.getDefaultReferenceDate)(params);
    },
    cleanValue: (0, _dateUtilsJs.replaceInvalidDateByNull),
    areValuesEqual: (0, _dateUtilsJs.areDatesEqual),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>utils.isValid(value) ? utils.getTimezone(value) : null,
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const singleItemFieldValueManager = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>utils.isValid(value) ? value : prevReferenceValue,
    getSectionsFromValue: (date, getSectionsFromDate)=>getSectionsFromDate(date),
    getV7HiddenInputValueFromSections: (0, _useFieldUtilsJs.createDateStrForV7HiddenInputFromSections),
    getV6InputValueFromSections: (0, _useFieldUtilsJs.createDateStrForV6InputFromSections),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue),
    getDateFromSection: (value)=>value,
    getDateSectionsFromValue: (sections)=>sections,
    updateDateInValue: (value, activeSection, activeDate)=>activeDate,
    clearDateSections: (sections)=>sections.map((section)=>(0, _extendsDefault.default)({}, section, {
                value: ''
            }))
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","./date-utils.js":"jrk9G","./getDefaultReferenceDate.js":"1Z5lc","../hooks/useField/useField.utils.js":"jBxFh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Z5lc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SECTION_TYPE_GRANULARITY", ()=>SECTION_TYPE_GRANULARITY);
parcelHelpers.export(exports, "getSectionTypeGranularity", ()=>getSectionTypeGranularity);
parcelHelpers.export(exports, "getDefaultReferenceDate", ()=>getDefaultReferenceDate);
var _timeUtilsJs = require("./time-utils.js");
var _dateUtilsJs = require("./date-utils.js");
const SECTION_TYPE_GRANULARITY = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const getSectionTypeGranularity = (sections)=>Math.max(...sections.map((section)=>SECTION_TYPE_GRANULARITY[section.type] ?? 1));
const roundDate = (utils, granularity, date)=>{
    if (granularity === SECTION_TYPE_GRANULARITY.year) return utils.startOfYear(date);
    if (granularity === SECTION_TYPE_GRANULARITY.month) return utils.startOfMonth(date);
    if (granularity === SECTION_TYPE_GRANULARITY.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < SECTION_TYPE_GRANULARITY.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < SECTION_TYPE_GRANULARITY.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < SECTION_TYPE_GRANULARITY.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const getDefaultReferenceDate = ({ props, utils, granularity, timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : roundDate(utils, granularity, (0, _dateUtilsJs.getTodayDate)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, _timeUtilsJs.createIsAfterIgnoreDatePart)(props.disableIgnoringDatePartForTimeValidation ?? false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, _dateUtilsJs.mergeDateAndTime)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, _dateUtilsJs.mergeDateAndTime)(utils, referenceDate, props.maxTime));
    return referenceDate;
};

},{"./time-utils.js":"7FMia","./date-utils.js":"jrk9G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jBxFh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDateSectionConfigFromFormatToken", ()=>getDateSectionConfigFromFormatToken);
parcelHelpers.export(exports, "getDaysInWeekStr", ()=>getDaysInWeekStr);
parcelHelpers.export(exports, "getLetterEditingOptions", ()=>getLetterEditingOptions);
parcelHelpers.export(exports, "FORMAT_SECONDS_NO_LEADING_ZEROS", ()=>FORMAT_SECONDS_NO_LEADING_ZEROS);
parcelHelpers.export(exports, "getLocalizedDigits", ()=>getLocalizedDigits);
parcelHelpers.export(exports, "removeLocalizedDigits", ()=>removeLocalizedDigits);
parcelHelpers.export(exports, "applyLocalizedDigits", ()=>applyLocalizedDigits);
parcelHelpers.export(exports, "isStringNumber", ()=>isStringNumber);
parcelHelpers.export(exports, "cleanLeadingZeros", ()=>cleanLeadingZeros);
parcelHelpers.export(exports, "cleanDigitSectionValue", ()=>cleanDigitSectionValue);
parcelHelpers.export(exports, "getSectionVisibleValue", ()=>getSectionVisibleValue);
parcelHelpers.export(exports, "changeSectionValueFormat", ()=>changeSectionValueFormat);
parcelHelpers.export(exports, "doesSectionFormatHaveLeadingZeros", ()=>doesSectionFormatHaveLeadingZeros);
parcelHelpers.export(exports, "getDateFromDateSections", ()=>getDateFromDateSections);
parcelHelpers.export(exports, "createDateStrForV7HiddenInputFromSections", ()=>createDateStrForV7HiddenInputFromSections);
parcelHelpers.export(exports, "createDateStrForV6InputFromSections", ()=>createDateStrForV6InputFromSections);
parcelHelpers.export(exports, "getSectionsBoundaries", ()=>getSectionsBoundaries);
parcelHelpers.export(exports, "validateSections", ()=>validateSections);
parcelHelpers.export(exports, "mergeDateIntoReferenceDate", ()=>mergeDateIntoReferenceDate);
parcelHelpers.export(exports, "isAndroid", ()=>isAndroid);
parcelHelpers.export(exports, "getSectionOrder", ()=>getSectionOrder);
parcelHelpers.export(exports, "parseSelectedSections", ()=>parseSelectedSections);
var _dateUtilsJs = require("../../utils/date-utils.js");
const getDateSectionConfigFromFormatToken = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const getDaysInWeekStr = (utils, format)=>{
    const elements = [];
    const now = utils.date(undefined, 'default');
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const getLetterEditingOptions = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, _dateUtilsJs.getMonthsInYear)(utils, utils.date(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case 'weekDay':
            return getDaysInWeekStr(utils, format);
        case 'meridiem':
            {
                const now = utils.date(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const FORMAT_SECONDS_NO_LEADING_ZEROS = 's';
const NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const getLocalizedDigits = (utils)=>{
    const today = utils.date(undefined);
    const formattedZero = utils.formatByString(utils.setSeconds(today, 0), FORMAT_SECONDS_NO_LEADING_ZEROS);
    if (formattedZero === '0') return NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>utils.formatByString(utils.setSeconds(today, index), FORMAT_SECONDS_NO_LEADING_ZEROS));
};
const removeLocalizedDigits = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
const applyLocalizedDigits = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
const isStringNumber = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = removeLocalizedDigits(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== ' ' && !Number.isNaN(Number(nonLocalizedValueStr));
};
const cleanLeadingZeros = (valueStr, size)=>{
    // Remove the leading zeros and then add back as many as needed.
    return Number(valueStr).toString().padStart(size, '0');
};
const cleanDigitSectionValue = (utils, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = cleanLeadingZeros(valueStr, section.maxLength);
    return applyLocalizedDigits(valueStr, localizedDigits);
};
const getSectionVisibleValue = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number(removeLocalizedDigits(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const changeSectionValueFormat = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const isFourDigitYearFormat = (utils, format)=>utils.formatByString(utils.date(undefined, 'system'), format).length === 4;
const doesSectionFormatHaveLeadingZeros = (utils, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = utils.date(undefined, 'default');
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            // Remove once https://github.com/iamkun/dayjs/pull/2847 is merged and bump dayjs version
            if (utils.lib === 'dayjs' && format === 'YY') return true;
            return utils.formatByString(utils.setYear(now, 1), format).startsWith('0');
        case 'month':
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case 'day':
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case 'hours':
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case 'minutes':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const getDateFromDateSections = (utils, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push(getSectionVisibleValue(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const createDateStrForV7HiddenInputFromSections = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join('');
const createDateStrForV6InputFromSections = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = getSectionVisibleValue(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const getSectionsBoundaries = (utils, localizedDigits, timezone)=>{
    const today = utils.date(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth, longestMonth } = (0, _dateUtilsJs.getMonthsInYear)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format })=>({
                minimum: 0,
                maximum: isFourDigitYearFormat(utils, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate })=>({
                minimum: 1,
                maximum: utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format, contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = getDaysInWeekStr(utils, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = removeLocalizedDigits(utils.formatByString(utils.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number(removeLocalizedDigits(utils.formatByString(utils.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let warnedOnceInvalidSection = false;
const validateSections = (sections, valueType)=>{};
const transferDateSectionValue = (utils, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case 'month':
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                let dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                if (section.hasLeadingZerosInInput) dayInWeekStrOfActiveDate = cleanLeadingZeros(dayInWeekStrOfActiveDate, section.maxLength);
                const formattedDaysInWeek = getDaysInWeekStr(utils, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case 'minutes':
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case 'seconds':
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const mergeDateIntoReferenceDate = (utils, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>reliableSectionModificationOrder[a.type] - reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return transferDateSectionValue(utils, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const isAndroid = ()=>navigator.userAgent.toLowerCase().includes('android');
const getSectionOrder = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex,
                rightIndex
            };
        });
        return {
            neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(' ') && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ');
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex,
            rightIndex
        };
    });
    return {
        neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
const parseSelectedSections = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === 'all') return 'all';
    if (typeof selectedSections === 'string') {
        const index = sections.findIndex((section)=>section.type === selectedSections);
        return index === -1 ? null : index;
    }
    return selectedSections;
};

},{"../../utils/date-utils.js":"jrk9G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dPXXC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClockReferenceDate", ()=>useClockReferenceDate);
var _react = require("react");
var _valueManagersJs = require("../utils/valueManagers.js");
var _dateUtilsJs = require("../utils/date-utils.js");
var _getDefaultReferenceDateJs = require("../utils/getDefaultReferenceDate.js");
const useClockReferenceDate = ({ value, referenceDate: referenceDateProp, utils, props, timezone })=>{
    const referenceDate = _react.useMemo(()=>(0, _valueManagersJs.singleItemValueManager).getInitialReferenceValue({
            value,
            utils,
            props,
            referenceDate: referenceDateProp,
            granularity: (0, _getDefaultReferenceDateJs.SECTION_TYPE_GRANULARITY).day,
            timezone,
            getTodayDate: ()=>(0, _dateUtilsJs.getTodayDate)(utils, timezone, 'date')
        }), // We only want to compute the reference date on mount.
    [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value ?? referenceDate;
};

},{"react":"9njXz","../utils/valueManagers.js":"bimTj","../utils/date-utils.js":"jrk9G","../utils/getDefaultReferenceDate.js":"1Z5lc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDNgV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DigitalClock", ()=>(0, _digitalClockJs.DigitalClock));
parcelHelpers.export(exports, "DigitalClockItem", ()=>(0, _digitalClockJs.DigitalClockItem));
parcelHelpers.export(exports, "digitalClockClasses", ()=>(0, _digitalClockClassesJs.digitalClockClasses));
parcelHelpers.export(exports, "getDigitalClockUtilityClass", ()=>(0, _digitalClockClassesJs.getDigitalClockUtilityClass));
var _digitalClockJs = require("./DigitalClock.js");
var _digitalClockClassesJs = require("./digitalClockClasses.js");

},{"./DigitalClock.js":"8UB7Q","./digitalClockClasses.js":"7Pn3c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8UB7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DigitalClockItem", ()=>DigitalClockItem);
parcelHelpers.export(exports, "DigitalClock", ()=>DigitalClock);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _styles = require("@mui/material/styles");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _menuList = require("@mui/material/MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _timeUtilsJs = require("../internals/utils/time-utils.js");
var _indexJs = require("../internals/components/PickerViewRoot/index.js");
var _digitalClockClassesJs = require("./digitalClockClasses.js");
var _useViewsJs = require("../internals/hooks/useViews.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _useControlledValueJs = require("../internals/hooks/useControlledValue.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _useClockReferenceDateJs = require("../internals/hooks/useClockReferenceDate.js");
var _utilsJs = require("../internals/utils/utils.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        list: [
            'list'
        ],
        item: [
            'item'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _digitalClockClassesJs.getDigitalClockUtilityClass), classes);
};
const DigitalClockRoot = (0, _styles.styled)((0, _indexJs.PickerViewRoot), {
    name: 'MuiDigitalClock',
    slot: 'Root'
})({
    overflowY: 'auto',
    width: '100%',
    scrollbarWidth: 'thin',
    '@media (prefers-reduced-motion: no-preference)': {
        scrollBehavior: 'auto'
    },
    maxHeight: (0, _dimensionsJs.DIGITAL_CLOCK_VIEW_HEIGHT),
    variants: [
        {
            props: {
                hasDigitalClockAlreadyBeenRendered: true
            },
            style: {
                '@media (prefers-reduced-motion: no-preference)': {
                    scrollBehavior: 'smooth'
                }
            }
        }
    ]
});
const DigitalClockList = (0, _styles.styled)((0, _menuListDefault.default), {
    name: 'MuiDigitalClock',
    slot: 'List'
})({
    padding: 0
});
const DigitalClockItem = (0, _styles.styled)((0, _menuItemDefault.default), {
    name: 'MuiDigitalClock',
    slot: 'Item',
    shouldForwardProp: (prop)=>prop !== 'itemValue' && prop !== 'formattedValue'
})(({ theme })=>({
        padding: '8px 16px',
        margin: '2px 4px',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const DigitalClock = /*#__PURE__*/ _react.forwardRef(function DigitalClock(inProps, ref) {
    const utils = (0, _useUtilsJs.useUtils)();
    const containerRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(ref, containerRef);
    const listRef = _react.useRef(null);
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDigitalClock'
    });
    const { ampm = utils.is12HourCycleInCurrentLocale(), timeStep = 30, autoFocus, slots, slotProps, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation = false, maxTime, minTime, disableFuture, disablePast, minutesStep = 1, shouldDisableTime, onChange, view: inView, openTo, onViewChange, focusedView, onFocusedViewChange, className, classes: classesProp, disabled, readOnly, views = [
        'hours'
    ], skipDisabled = false, timezone: timezoneProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { value, handleValueChange: handleRawValueChange, timezone } = (0, _useControlledValueJs.useControlledValue)({
        name: 'DigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: (0, _valueManagersJs.singleItemValueManager)
    });
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const now = (0, _useUtilsJs.useNow)(timezone);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const ownerState = (0, _extendsDefault.default)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = useUtilityClasses(classesProp);
    const ClockItem = slots?.digitalClockItem ?? DigitalClockItem;
    const clockItemProps = (0, _useSlotPropsDefault.default)({
        elementType: ClockItem,
        externalSlotProps: slotProps?.digitalClockItem,
        ownerState,
        className: classes.item
    });
    const valueOrReferenceDate = (0, _useClockReferenceDateJs.useClockReferenceDate)({
        value,
        referenceDate: referenceDateProp,
        utils,
        props,
        timezone
    });
    const handleValueChange = (0, _useEventCallbackDefault.default)((newValue)=>handleRawValueChange(newValue, 'finish', 'hours'));
    const { setValueAndGoToNextView } = (0, _useViewsJs.useViews)({
        view: inView,
        views,
        openTo,
        onViewChange,
        onChange: handleValueChange,
        focusedView,
        onFocusedViewChange
    });
    const handleItemSelect = (0, _useEventCallbackDefault.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish');
    });
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
        if (!activeItem) return;
        const offsetTop = activeItem.offsetTop;
        if (autoFocus || !!focusedView) activeItem.focus();
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = _react.useCallback((valueToCheck)=>{
        const isAfter = (0, _timeUtilsJs.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (utils.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, 'hours');
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        utils,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableTime
    ]);
    const timeOptions = _react.useMemo(()=>{
        const result = [];
        const startOfDay = utils.startOfDay(valueOrReferenceDate);
        let nextTimeStepOption = startOfDay;
        while(utils.isSameDay(valueOrReferenceDate, nextTimeStepOption)){
            result.push(nextTimeStepOption);
            nextTimeStepOption = utils.addMinutes(nextTimeStepOption, timeStep);
        }
        return result;
    }, [
        valueOrReferenceDate,
        timeStep,
        utils
    ]);
    const focusedOptionIndex = timeOptions.findIndex((option)=>utils.isEqual(option, valueOrReferenceDate));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, _utilsJs.getFocusedListItemIndex)(listRef.current) - 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, _utilsJs.getFocusedListItemIndex)(listRef.current) + 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DigitalClockRoot, (0, _extendsDefault.default)({
        ref: handleRef,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DigitalClockList, {
            ref: listRef,
            role: "listbox",
            "aria-label": translations.timePickerToolbarTitle,
            className: classes.list,
            onKeyDown: handleKeyDown,
            children: timeOptions.map((option, index)=>{
                const optionDisabled = isTimeDisabled(option);
                if (skipDisabled && optionDisabled) return null;
                const isSelected = utils.isEqual(option, value);
                const formattedValue = utils.format(option, ampm ? 'fullTime12h' : 'fullTime24h');
                const isFocused = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0;
                const tabIndex = isFocused ? 0 : -1;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockItem, (0, _extendsDefault.default)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || optionDisabled,
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected,
                    tabIndex: tabIndex,
                    itemValue: option,
                    formattedValue: formattedValue
                }, clockItemProps, {
                    children: formattedValue
                }), `${option.valueOf()}-${formattedValue}`);
            })
        })
    }));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","prop-types":"bnNSm","@mui/utils/useSlotProps":"kr4RG","@mui/material/styles":"c9RfU","@mui/utils/useEventCallback":"feNJe","@mui/utils/composeClasses":"59Equ","@mui/material/MenuItem":"a18vm","@mui/material/MenuList":"eogrV","@mui/utils/useForkRef":"4xKTx","@mui/utils/useEnhancedEffect":"fIvqa","../hooks/usePickerTranslations.js":"3Zb4l","../internals/hooks/useUtils.js":"dJQ8a","../internals/utils/time-utils.js":"7FMia","../internals/components/PickerViewRoot/index.js":"gmdrj","./digitalClockClasses.js":"7Pn3c","../internals/hooks/useViews.js":"cVwkb","../internals/constants/dimensions.js":"i0BgX","../internals/hooks/useControlledValue.js":"hTAsm","../internals/utils/valueManagers.js":"bimTj","../internals/hooks/useClockReferenceDate.js":"dPXXC","../internals/utils/utils.js":"k4iiH","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a18vm":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("515155cb9b095ca1").default;
var _interopRequireDefault = require("3aa5f4a64af9b499").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    menuItemClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _MenuItem.default;
    }
});
Object.defineProperty(exports, "menuItemClasses", {
    enumerable: true,
    get: function() {
        return _menuItemClasses.default;
    }
});
var _MenuItem = _interopRequireDefault(require("eb2ada4041462e16"));
var _menuItemClasses = _interopRequireWildcard(require("463e2bea5a6b46a3"));
Object.keys(_menuItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _menuItemClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _menuItemClasses[key];
        }
    });
});

},{"515155cb9b095ca1":"fiRIh","3aa5f4a64af9b499":"kZ6eK","eb2ada4041462e16":"keBEM","463e2bea5a6b46a3":"hUxvt"}],"keBEM":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("eb7fb7ce22bbea36").default;
var _interopRequireWildcard = require("11ad58092be56afe").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.overridesResolver = exports.default = void 0;
var React = _interopRequireWildcard(require("17bf1afd25ab215b"));
var _propTypes = _interopRequireDefault(require("ff052f7f6e07bc3c"));
var _clsx = _interopRequireDefault(require("358f32fd004fa282"));
var _composeClasses = _interopRequireDefault(require("a9c6b02935278f0a"));
var _colorManipulator = require("13fbb5fde79f1d64");
var _rootShouldForwardProp = _interopRequireDefault(require("f60bcb9873c65a51"));
var _zeroStyled = require("dc7a3a80e5fd4137");
var _memoTheme = _interopRequireDefault(require("557b6d5a3b1c3b5e"));
var _DefaultPropsProvider = require("3f3b83a997438ea4");
var _ListContext = _interopRequireDefault(require("455b936ac441ebf"));
var _ButtonBase = _interopRequireDefault(require("3a76a873027ad9ee"));
var _useEnhancedEffect = _interopRequireDefault(require("c7cc41ca97aaca00"));
var _useForkRef = _interopRequireDefault(require("d53be1bfd33341b7"));
var _Divider = require("ffe1b0a76a4ff283");
var _ListItemIcon = require("14e337a370bdbc00");
var _ListItemText = require("200a2f5566697f27");
var _menuItemClasses = _interopRequireWildcard(require("27994eebd6e2678d"));
var _jsxRuntime = require("cc4859e6e5238a90");
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
exports.overridesResolver = overridesResolver;
const useUtilityClasses = (ownerState)=>{
    const { disabled, dense, divider, disableGutters, selected, classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _menuItemClasses.getMenuItemUtilityClass, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const MenuItemRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${_menuItemClasses.default.selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${_menuItemClasses.default.focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${_menuItemClasses.default.selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${_menuItemClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${_menuItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${_Divider.dividerClasses.root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${_Divider.dividerClasses.inset}`]: {
            marginLeft: 52
        },
        [`& .${_ListItemText.listItemTextClasses.root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${_ListItemText.listItemTextClasses.inset}`]: {
            paddingLeft: 36
        },
        [`& .${_ListItemIcon.listItemIconClasses.root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${_ListItemIcon.listItemIconClasses.root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const MenuItem = /*#__PURE__*/ React.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus = false, component = 'li', dense = false, divider = false, disableGutters = false, focusVisibleClassName, role = 'menuitem', tabIndex: tabIndexProp, className, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const childContext = React.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = React.useRef(null);
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider,
        disableGutters
    };
    const classes = useUtilityClasses(props);
    const handleRef = (0, _useForkRef.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, _clsx.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var _default = exports.default = MenuItem;

},{"eb7fb7ce22bbea36":"kZ6eK","11ad58092be56afe":"fiRIh","17bf1afd25ab215b":"9njXz","ff052f7f6e07bc3c":"bnNSm","358f32fd004fa282":"d2NWs","a9c6b02935278f0a":"59Equ","13fbb5fde79f1d64":"hTYBL","f60bcb9873c65a51":"dIcrQ","dc7a3a80e5fd4137":"89fxU","557b6d5a3b1c3b5e":"2zy52","3f3b83a997438ea4":"ff3VX","455b936ac441ebf":"lt3pu","3a76a873027ad9ee":"ajcyv","c7cc41ca97aaca00":"hXusa","d53be1bfd33341b7":"cq8Sn","ffe1b0a76a4ff283":"5Ykub","14e337a370bdbc00":"fp9B2","200a2f5566697f27":"8IBhx","27994eebd6e2678d":"hUxvt","cc4859e6e5238a90":"1dlk8"}],"lt3pu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("aacb1cc9e4da6753").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f46b79777d2a0daa"));
/**
 * @ignore - internal component.
 */ const ListContext = /*#__PURE__*/ React.createContext({});
var _default = exports.default = ListContext;

},{"aacb1cc9e4da6753":"fiRIh","f46b79777d2a0daa":"9njXz"}],"5Ykub":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5d9e6a9fd773e836").default;
var _interopRequireDefault = require("f274d23d5340d6aa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dividerClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Divider.default;
    }
});
Object.defineProperty(exports, "dividerClasses", {
    enumerable: true,
    get: function() {
        return _dividerClasses.default;
    }
});
var _Divider = _interopRequireDefault(require("456c4dd076371889"));
var _dividerClasses = _interopRequireWildcard(require("b1821713f4a1b185"));
Object.keys(_dividerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dividerClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dividerClasses[key];
        }
    });
});

},{"5d9e6a9fd773e836":"fiRIh","f274d23d5340d6aa":"kZ6eK","456c4dd076371889":"1fvTD","b1821713f4a1b185":"kFVvv"}],"1fvTD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("54aaf3b66f160d74").default;
var _interopRequireWildcard = require("a19dbe1a6fe3b0bb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d6d9493a08481b39"));
var _propTypes = _interopRequireDefault(require("c01ae6936d7812fc"));
var _clsx = _interopRequireDefault(require("ebe23c05bfde0cc8"));
var _composeClasses = _interopRequireDefault(require("5b4b568a518587f3"));
var _colorManipulator = require("751f567c0ac2c6dc");
var _zeroStyled = require("5b8ebab1fc2bbbc8");
var _memoTheme = _interopRequireDefault(require("6adfd901e4c08fef"));
var _DefaultPropsProvider = require("f7083e5a9d62fc1d");
var _dividerClasses = require("4d0c0bad5d633585");
var _jsxRuntime = require("17583787ed12ae85");
const useUtilityClasses = (ownerState)=>{
    const { absolute, children, classes, flexItem, light, orientation, textAlign, variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, _composeClasses.default)(slots, _dividerClasses.getDividerUtilityClass, classes);
};
const DividerRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, _colorManipulator.alpha)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const DividerWrapper = (0, _zeroStyled.styled)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const Divider = /*#__PURE__*/ React.forwardRef(function Divider(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute = false, children, className, orientation = 'horizontal', component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem = false, light = false, role = component !== 'hr' ? 'separator' : undefined, textAlign = 'center', variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute,
        component,
        flexItem,
        light,
        orientation,
        role,
        textAlign,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if (Divider) Divider.muiSkipListHighlight = true;
var _default = exports.default = Divider;

},{"54aaf3b66f160d74":"kZ6eK","a19dbe1a6fe3b0bb":"fiRIh","d6d9493a08481b39":"9njXz","c01ae6936d7812fc":"bnNSm","ebe23c05bfde0cc8":"d2NWs","5b4b568a518587f3":"59Equ","751f567c0ac2c6dc":"hTYBL","5b8ebab1fc2bbbc8":"89fxU","6adfd901e4c08fef":"2zy52","f7083e5a9d62fc1d":"ff3VX","4d0c0bad5d633585":"kFVvv","17583787ed12ae85":"1dlk8"}],"kFVvv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c9fc195dac236b7c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDividerUtilityClass = getDividerUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("608039264ba9a8c2"));
var _generateUtilityClass = _interopRequireDefault(require("d159d850bf4c0c29"));
function getDividerUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDivider', slot);
}
const dividerClasses = (0, _generateUtilityClasses.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var _default = exports.default = dividerClasses;

},{"c9fc195dac236b7c":"kZ6eK","608039264ba9a8c2":"7pSUk","d159d850bf4c0c29":"jBs9M"}],"fp9B2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("9366f147b97c3236").default;
var _interopRequireDefault = require("b0890a8420c8f142").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemIconClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItemIcon.default;
    }
});
Object.defineProperty(exports, "listItemIconClasses", {
    enumerable: true,
    get: function() {
        return _listItemIconClasses.default;
    }
});
var _ListItemIcon = _interopRequireDefault(require("e9ca96ea06b19251"));
var _listItemIconClasses = _interopRequireWildcard(require("9fb0c10c361d27c6"));
Object.keys(_listItemIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemIconClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemIconClasses[key];
        }
    });
});

},{"9366f147b97c3236":"fiRIh","b0890a8420c8f142":"kZ6eK","e9ca96ea06b19251":"3rp2p","9fb0c10c361d27c6":"6cdKu"}],"3rp2p":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("aed3ba522b5a54b0").default;
var _interopRequireWildcard = require("96eb3adb1bab316").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("433e6943f954cc8f"));
var _propTypes = _interopRequireDefault(require("a3fd3c29af49f6f2"));
var _clsx = _interopRequireDefault(require("4ac60cdaed4ae697"));
var _composeClasses = _interopRequireDefault(require("8a55523a7faa9e11"));
var _zeroStyled = require("179da17a0da058a9");
var _memoTheme = _interopRequireDefault(require("cd0d0097bbfd88c8"));
var _DefaultPropsProvider = require("21f0f5e9d6dbedc1");
var _listItemIconClasses = require("da2b63e33e502e59");
var _ListContext = _interopRequireDefault(require("b9cc896e1452ebf4"));
var _jsxRuntime = require("b31134d8a64c3e05");
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, _composeClasses.default)(slots, _listItemIconClasses.getListItemIconUtilityClass, classes);
};
const ListItemIconRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const ListItemIcon = /*#__PURE__*/ React.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemIconRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var _default = exports.default = ListItemIcon;

},{"aed3ba522b5a54b0":"kZ6eK","96eb3adb1bab316":"fiRIh","433e6943f954cc8f":"9njXz","a3fd3c29af49f6f2":"bnNSm","4ac60cdaed4ae697":"d2NWs","8a55523a7faa9e11":"59Equ","179da17a0da058a9":"89fxU","cd0d0097bbfd88c8":"2zy52","21f0f5e9d6dbedc1":"ff3VX","da2b63e33e502e59":"6cdKu","b9cc896e1452ebf4":"lt3pu","b31134d8a64c3e05":"1dlk8"}],"6cdKu":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e115f5949005c3be").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemIconUtilityClass = getListItemIconUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("a6b680f25e4d11ec"));
var _generateUtilityClass = _interopRequireDefault(require("fd1da30dc231c493"));
function getListItemIconUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItemIcon', slot);
}
const listItemIconClasses = (0, _generateUtilityClasses.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var _default = exports.default = listItemIconClasses;

},{"e115f5949005c3be":"kZ6eK","a6b680f25e4d11ec":"7pSUk","fd1da30dc231c493":"jBs9M"}],"8IBhx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("bb4c5c9ad8094b57").default;
var _interopRequireDefault = require("661116602d05477e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemTextClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItemText.default;
    }
});
Object.defineProperty(exports, "listItemTextClasses", {
    enumerable: true,
    get: function() {
        return _listItemTextClasses.default;
    }
});
var _ListItemText = _interopRequireDefault(require("bf1147d778b4b533"));
var _listItemTextClasses = _interopRequireWildcard(require("8e64f48555dbe8bc"));
Object.keys(_listItemTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemTextClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemTextClasses[key];
        }
    });
});

},{"bb4c5c9ad8094b57":"fiRIh","661116602d05477e":"kZ6eK","bf1147d778b4b533":"eWU8B","8e64f48555dbe8bc":"8YFwN"}],"eWU8B":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c4e19e0ff5476288").default;
var _interopRequireWildcard = require("32cd566beed93921").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("60ec19f648141b40"));
var _propTypes = _interopRequireDefault(require("f2cfbaa4687cb426"));
var _clsx = _interopRequireDefault(require("c98423829b86d29d"));
var _composeClasses = _interopRequireDefault(require("b2e1ebc56ca3399c"));
var _Typography = _interopRequireWildcard(require("898d97cbb2ca2092"));
var _ListContext = _interopRequireDefault(require("7e70c16b063246bc"));
var _zeroStyled = require("68ea3b271d88281a");
var _DefaultPropsProvider = require("88ae50c9a7c15853");
var _listItemTextClasses = _interopRequireWildcard(require("a1af58ca474c987c"));
var _useSlot = _interopRequireDefault(require("8a4474cde72d9c3a"));
var _jsxRuntime = require("b927ecd302eaee97");
const useUtilityClasses = (ownerState)=>{
    const { classes, inset, primary, secondary, dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, _composeClasses.default)(slots, _listItemTextClasses.getListItemTextUtilityClass, classes);
};
const ListItemTextRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_listItemTextClasses.default.primary}`]: styles.primary
            },
            {
                [`& .${_listItemTextClasses.default.secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${_Typography.typographyClasses.root}:where(& .${_listItemTextClasses.default.primary})`]: {
        display: 'block'
    },
    [`.${_Typography.typographyClasses.root}:where(& .${_listItemTextClasses.default.secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const ListItemText = /*#__PURE__*/ React.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children, className, disableTypography = false, inset = false, primary: primaryProp, primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps, slots = {}, slotProps = {}, ...other } = props;
    const { dense } = React.useContext(_ListContext.default);
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography,
        inset,
        primary: !!primary,
        secondary: !!secondary,
        dense
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        className: (0, _clsx.default)(classes.root, className),
        elementType: ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState,
        ref
    });
    const [PrimarySlot, primarySlotProps] = (0, _useSlot.default)('primary', {
        className: classes.primary,
        elementType: _Typography.default,
        externalForwardedProps,
        ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, _useSlot.default)('secondary', {
        className: classes.secondary,
        elementType: _Typography.default,
        externalForwardedProps,
        ownerState
    });
    if (primary != null && primary.type !== _Typography.default && !disableTypography) primary = /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== _Typography.default && !disableTypography) secondary = /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var _default = exports.default = ListItemText;

},{"c4e19e0ff5476288":"kZ6eK","32cd566beed93921":"fiRIh","60ec19f648141b40":"9njXz","f2cfbaa4687cb426":"bnNSm","c98423829b86d29d":"d2NWs","b2e1ebc56ca3399c":"59Equ","898d97cbb2ca2092":"2wCD5","7e70c16b063246bc":"lt3pu","68ea3b271d88281a":"89fxU","88ae50c9a7c15853":"ff3VX","a1af58ca474c987c":"8YFwN","8a4474cde72d9c3a":"29rI6","b927ecd302eaee97":"1dlk8"}],"8YFwN":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a2272412c83d0cbe").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemTextUtilityClass = getListItemTextUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("44b583039a7dc04c"));
var _generateUtilityClass = _interopRequireDefault(require("f267ebe3d0b2da10"));
function getListItemTextUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItemText', slot);
}
const listItemTextClasses = (0, _generateUtilityClasses.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var _default = exports.default = listItemTextClasses;

},{"a2272412c83d0cbe":"kZ6eK","44b583039a7dc04c":"7pSUk","f267ebe3d0b2da10":"jBs9M"}],"29rI6":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e960f80c2ea04b02").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useSlot;
var _useForkRef = _interopRequireDefault(require("c6bb183be2cb6543"));
var _appendOwnerState = _interopRequireDefault(require("7872344afb3f5f21"));
var _resolveComponentProps = _interopRequireDefault(require("ebdc1b0c47c1fd9f"));
var _mergeSlotProps = _interopRequireDefault(require("acc0177a7dccc5ff"));
/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */ function useSlot(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className, elementType: initialElementType, ownerState, externalForwardedProps, internalForwardedProps, shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots = {
        [name]: undefined
    }, slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, _resolveComponentProps.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef } = (0, _mergeSlotProps.default)({
        className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, _useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, _appendOwnerState.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

},{"e960f80c2ea04b02":"kZ6eK","c6bb183be2cb6543":"4xKTx","7872344afb3f5f21":"76Wn8","ebdc1b0c47c1fd9f":"gGfhx","acc0177a7dccc5ff":"dA16c"}],"hUxvt":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("dcfdac8f6d2c98f9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getMenuItemUtilityClass = getMenuItemUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("2c56e82abe854745"));
var _generateUtilityClass = _interopRequireDefault(require("a566c01cd7cffb21"));
function getMenuItemUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiMenuItem', slot);
}
const menuItemClasses = (0, _generateUtilityClasses.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var _default = exports.default = menuItemClasses;

},{"dcfdac8f6d2c98f9":"kZ6eK","2c56e82abe854745":"7pSUk","a566c01cd7cffb21":"jBs9M"}],"eogrV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3063f3dec00c0f76").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _MenuList.default;
    }
});
var _MenuList = _interopRequireDefault(require("fd3973baf2fff39d"));

},{"3063f3dec00c0f76":"kZ6eK","fd3973baf2fff39d":"1myh4"}],"1myh4":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("af3efd51ca66f274").default;
var _interopRequireWildcard = require("f6cc58c9f4ce8aa2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("fb0ab43ae749c844"));
var _reactIs = require("104bcda0ba1857d8");
var _propTypes = _interopRequireDefault(require("a3fb681bddf29b00"));
var _ownerDocument = _interopRequireDefault(require("309c2b7b0246a6a8"));
var _List = _interopRequireDefault(require("2e8f3500f1a613a"));
var _getScrollbarSize = _interopRequireDefault(require("4a281b1b2c414afc"));
var _useForkRef = _interopRequireDefault(require("7e28cd578407aa11"));
var _useEnhancedEffect = _interopRequireDefault(require("d84443bd1cb089f0"));
var _utils = require("dded14a26131cf01");
var _jsxRuntime = require("aa2e14075c03328c");
function nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const MenuList = /*#__PURE__*/ React.forwardRef(function MenuList(props, ref) {
    const { // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus = false, autoFocusItem = false, children, className, disabledItemsFocusable = false, disableListWrap = false, onKeyDown, variant = 'selectedMenu', ...other } = props;
    const listRef = React.useRef(null);
    const textCriteriaRef = React.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    React.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, _getScrollbarSize.default)((0, _utils.ownerWindow)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, _ownerDocument.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, _useForkRef.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    React.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = React.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ React.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_List.default, {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var _default = exports.default = MenuList;

},{"af3efd51ca66f274":"kZ6eK","f6cc58c9f4ce8aa2":"fiRIh","fb0ab43ae749c844":"9njXz","104bcda0ba1857d8":"8oKlE","a3fb681bddf29b00":"bnNSm","309c2b7b0246a6a8":"7Yspg","2e8f3500f1a613a":"4j4o2","4a281b1b2c414afc":"jyGpq","7e28cd578407aa11":"cq8Sn","d84443bd1cb089f0":"hXusa","dded14a26131cf01":"60iOt","aa2e14075c03328c":"1dlk8"}],"8oKlE":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("ae7bfd90e5772027");

},{"ae7bfd90e5772027":"73dbz"}],"73dbz":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                    case REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
exports.ContextConsumer = REACT_CONSUMER_TYPE;
exports.ContextProvider = REACT_CONTEXT_TYPE;
exports.Element = REACT_ELEMENT_TYPE;
exports.ForwardRef = REACT_FORWARD_REF_TYPE;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Lazy = REACT_LAZY_TYPE;
exports.Memo = REACT_MEMO_TYPE;
exports.Portal = REACT_PORTAL_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
exports.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
};
exports.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
};
exports.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
};
exports.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
exports.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
};
exports.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
};
exports.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
};
exports.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
};
exports.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
};
exports.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
exports.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
};
exports.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
exports.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
exports.typeOf = typeOf;

},{}],"4j4o2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7e88d043d70dc713").default;
var _interopRequireDefault = require("2efa099242bc206b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _List.default;
    }
});
Object.defineProperty(exports, "listClasses", {
    enumerable: true,
    get: function() {
        return _listClasses.default;
    }
});
var _List = _interopRequireDefault(require("9c0ad6a123feee66"));
var _listClasses = _interopRequireWildcard(require("6b4be05652065423"));
Object.keys(_listClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listClasses[key];
        }
    });
});

},{"7e88d043d70dc713":"fiRIh","2efa099242bc206b":"kZ6eK","9c0ad6a123feee66":"2Kstk","6b4be05652065423":"9MNNM"}],"2Kstk":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("1e431ac42e3b4dac").default;
var _interopRequireWildcard = require("87f3919a79713920").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("16454989d124dbb5"));
var _propTypes = _interopRequireDefault(require("fdf6f94620ab562c"));
var _clsx = _interopRequireDefault(require("642b1d86aab0c419"));
var _composeClasses = _interopRequireDefault(require("29376c81f19d6caa"));
var _zeroStyled = require("3041ae5ef8ab33d7");
var _DefaultPropsProvider = require("4176a394cd3cf41");
var _ListContext = _interopRequireDefault(require("eb541db66a8af363"));
var _listClasses = require("da448f7af990a16c");
var _jsxRuntime = require("7d935834dd678f7c");
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePadding, dense, subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, _composeClasses.default)(slots, _listClasses.getListUtilityClass, classes);
};
const ListRoot = (0, _zeroStyled.styled)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const List = /*#__PURE__*/ React.forwardRef(function List(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children, className, component = 'ul', dense = false, disablePadding = false, subheader, ...other } = props;
    const context = React.useMemo(()=>({
            dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component,
        dense,
        disablePadding
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
        value: context,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListRoot, {
            as: component,
            className: (0, _clsx.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var _default = exports.default = List;

},{"1e431ac42e3b4dac":"kZ6eK","87f3919a79713920":"fiRIh","16454989d124dbb5":"9njXz","fdf6f94620ab562c":"bnNSm","642b1d86aab0c419":"d2NWs","29376c81f19d6caa":"59Equ","3041ae5ef8ab33d7":"89fxU","4176a394cd3cf41":"ff3VX","eb541db66a8af363":"lt3pu","da448f7af990a16c":"9MNNM","7d935834dd678f7c":"1dlk8"}],"9MNNM":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2859de64be934c60").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListUtilityClass = getListUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4ae5dc5f2c9ba0df"));
var _generateUtilityClass = _interopRequireDefault(require("bf3de708cabf7f76"));
function getListUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiList', slot);
}
const listClasses = (0, _generateUtilityClasses.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var _default = exports.default = listClasses;

},{"2859de64be934c60":"kZ6eK","4ae5dc5f2c9ba0df":"7pSUk","bf3de708cabf7f76":"jBs9M"}],"jyGpq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("14aeba6e2c2560a1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _getScrollbarSize = _interopRequireDefault(require("f913b445e0b609e7"));
var _default = exports.default = _getScrollbarSize.default;

},{"14aeba6e2c2560a1":"kZ6eK","f913b445e0b609e7":"3Gyjq"}],"7Pn3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDigitalClockUtilityClass", ()=>getDigitalClockUtilityClass);
parcelHelpers.export(exports, "digitalClockClasses", ()=>digitalClockClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getDigitalClockUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDigitalClock', slot);
}
const digitalClockClasses = (0, _generateUtilityClassesDefault.default)('MuiDigitalClock', [
    'root',
    'list',
    'item'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k4iiH":[function(require,module,exports,__globalThis) {
/* Use it instead of .includes method for IE support */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayIncludes", ()=>arrayIncludes);
parcelHelpers.export(exports, "onSpaceOrEnter", ()=>onSpaceOrEnter);
parcelHelpers.export(exports, "executeInTheNextEventLoopTick", ()=>executeInTheNextEventLoopTick);
parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
parcelHelpers.export(exports, "getFocusedListItemIndex", ()=>getFocusedListItemIndex);
parcelHelpers.export(exports, "DEFAULT_DESKTOP_MODE_MEDIA_QUERY", ()=>DEFAULT_DESKTOP_MODE_MEDIA_QUERY);
parcelHelpers.export(exports, "mergeSx", ()=>mergeSx);
function arrayIncludes(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const onSpaceOrEnter = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const executeInTheNextEventLoopTick = (fn)=>{
    setTimeout(fn, 0);
};
const getActiveElement = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return getActiveElement(activeEl.shadowRoot);
    return activeEl;
};
const getFocusedListItemIndex = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf(getActiveElement(document));
};
const DEFAULT_DESKTOP_MODE_MEDIA_QUERY = '@media (pointer: fine)';
function mergeSx(...sxProps) {
    return sxProps.reduce((acc, sxProp)=>{
        if (Array.isArray(sxProp)) acc.push(...sxProp);
        else if (sxProp != null) acc.push(sxProp);
        return acc;
    }, []);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BKf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiSectionDigitalClock", ()=>(0, _multiSectionDigitalClockJs.MultiSectionDigitalClock));
parcelHelpers.export(exports, "multiSectionDigitalClockSectionClasses", ()=>(0, _multiSectionDigitalClockSectionClassesJs.multiSectionDigitalClockSectionClasses));
parcelHelpers.export(exports, "multiSectionDigitalClockClasses", ()=>(0, _multiSectionDigitalClockClassesJs.multiSectionDigitalClockClasses));
parcelHelpers.export(exports, "getMultiSectionDigitalClockUtilityClass", ()=>(0, _multiSectionDigitalClockClassesJs.getMultiSectionDigitalClockUtilityClass));
var _multiSectionDigitalClockJs = require("./MultiSectionDigitalClock.js");
var _multiSectionDigitalClockSectionClassesJs = require("./multiSectionDigitalClockSectionClasses.js");
var _multiSectionDigitalClockClassesJs = require("./multiSectionDigitalClockClasses.js");

},{"./MultiSectionDigitalClock.js":"heWFO","./multiSectionDigitalClockSectionClasses.js":"fyfPU","./multiSectionDigitalClockClasses.js":"NV6O2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"heWFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiSectionDigitalClock", ()=>MultiSectionDigitalClock);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _rtlProvider = require("@mui/system/RtlProvider");
var _styles = require("@mui/material/styles");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _timeUtilsJs = require("../internals/utils/time-utils.js");
var _useViewsJs = require("../internals/hooks/useViews.js");
var _dateHelpersHooksJs = require("../internals/hooks/date-helpers-hooks.js");
var _indexJs = require("../internals/components/PickerViewRoot/index.js");
var _multiSectionDigitalClockClassesJs = require("./multiSectionDigitalClockClasses.js");
var _multiSectionDigitalClockSectionJs = require("./MultiSectionDigitalClockSection.js");
var _multiSectionDigitalClockUtilsJs = require("./MultiSectionDigitalClock.utils.js");
var _useControlledValueJs = require("../internals/hooks/useControlledValue.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _useClockReferenceDateJs = require("../internals/hooks/useClockReferenceDate.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _multiSectionDigitalClockClassesJs.getMultiSectionDigitalClockUtilityClass), classes);
};
const MultiSectionDigitalClockRoot = (0, _styles.styled)((0, _indexJs.PickerViewRoot), {
    name: 'MuiMultiSectionDigitalClock',
    slot: 'Root'
})(({ theme })=>({
        flexDirection: 'row',
        width: '100%',
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const MultiSectionDigitalClock = /*#__PURE__*/ _react.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const utils = (0, _useUtilsJs.useUtils)();
    const isRtl = (0, _rtlProvider.useRtl)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClock'
    });
    const { ampm = utils.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus, slots, slotProps, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation = false, maxTime, minTime, disableFuture, disablePast, minutesStep = 1, shouldDisableTime, onChange, view: inView, views: inViews = [
        'hours',
        'minutes'
    ], openTo, onViewChange, focusedView: inFocusedView, onFocusedViewChange, className, classes: classesProp, disabled, readOnly, skipDisabled = false, timezone: timezoneProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { value, handleValueChange: handleRawValueChange, timezone } = (0, _useControlledValueJs.useControlledValue)({
        name: 'MultiSectionDigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: (0, _valueManagersJs.singleItemValueManager)
    });
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const now = (0, _useUtilsJs.useNow)(timezone);
    const timeSteps = _react.useMemo(()=>(0, _extendsDefault.default)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, _useClockReferenceDateJs.useClockReferenceDate)({
        value,
        referenceDate: referenceDateProp,
        utils,
        props,
        timezone
    });
    const handleValueChange = (0, _useEventCallbackDefault.default)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = _react.useMemo(()=>{
        if (!ampm || !inViews.includes('hours')) return inViews;
        return inViews.includes('meridiem') ? inViews : [
            ...inViews,
            'meridiem'
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view, setValueAndGoToNextView, focusedView } = (0, _useViewsJs.useViews)({
        view: inView,
        views,
        openTo,
        onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, _useEventCallbackDefault.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish', 'meridiem');
    });
    const { meridiemMode, handleMeridiemChange } = (0, _dateHelpersHooksJs.useMeridiemMode)(valueOrReferenceDate, ampm, handleMeridiemValueChange, 'finish');
    const isTimeDisabled = _react.useCallback((rawValue, viewType)=>{
        const isAfter = (0, _timeUtilsJs.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start, end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, _timeUtilsJs.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (utils.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = _react.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case 'hours':
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, _timeUtilsJs.convertValueToMeridiem)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), 'finish', 'hours');
                    },
                    items: (0, _multiSectionDigitalClockUtilsJs.getHourSectionOptions)({
                        now,
                        value,
                        ampm,
                        utils,
                        isDisabled: (hours)=>isTimeDisabled(hours, 'hours'),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: translations.hoursClockNumberText,
                        valueOrReferenceDate
                    })
                };
            case 'minutes':
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minutes), 'finish', 'minutes');
                    },
                    items: (0, _multiSectionDigitalClockUtilsJs.getTimeSectionOptions)({
                        value: utils.getMinutes(valueOrReferenceDate),
                        utils,
                        isDisabled: (minutes)=>isTimeDisabled(minutes, 'minutes'),
                        resolveLabel: (minutes)=>utils.format(utils.setMinutes(now, minutes), 'minutes'),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: translations.minutesClockNumberText
                    })
                };
            case 'seconds':
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, seconds), 'finish', 'seconds');
                    },
                    items: (0, _multiSectionDigitalClockUtilsJs.getTimeSectionOptions)({
                        value: utils.getSeconds(valueOrReferenceDate),
                        utils,
                        isDisabled: (seconds)=>isTimeDisabled(seconds, 'seconds'),
                        resolveLabel: (seconds)=>utils.format(utils.setSeconds(now, seconds), 'seconds'),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: translations.secondsClockNumberText
                    })
                };
            case 'meridiem':
                {
                    const amLabel = (0, _dateUtilsJs.formatMeridiem)(utils, 'am');
                    const pmLabel = (0, _dateUtilsJs.formatMeridiem)(utils, 'pm');
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: 'am',
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === 'am',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'am',
                                ariaLabel: amLabel
                            },
                            {
                                value: 'pm',
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === 'pm',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'pm',
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        utils,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewsToRender = _react.useMemo(()=>{
        if (!isRtl) return views;
        const digitViews = views.filter((v)=>v !== 'meridiem');
        digitViews.reverse();
        if (views.includes('meridiem')) digitViews.push('meridiem');
        return digitViews;
    }, [
        isRtl,
        views
    ]);
    const viewTimeOptions = _react.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, _extendsDefault.default)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MultiSectionDigitalClockRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: viewsToRender.map((timeView)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiSectionDigitalClockSectionJs.MultiSectionDigitalClockSection), {
                items: viewTimeOptions[timeView].items,
                onChange: viewTimeOptions[timeView].onChange,
                active: view === timeView,
                autoFocus: autoFocus || focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots,
                slotProps: slotProps,
                skipDisabled: skipDisabled,
                "aria-label": translations.selectViewText(timeView)
            }, timeView))
    }));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","prop-types":"bnNSm","@mui/system/RtlProvider":"ck9Pb","@mui/material/styles":"c9RfU","@mui/utils/useEventCallback":"feNJe","@mui/utils/composeClasses":"59Equ","../hooks/usePickerTranslations.js":"3Zb4l","../internals/hooks/useUtils.js":"dJQ8a","../internals/utils/time-utils.js":"7FMia","../internals/hooks/useViews.js":"cVwkb","../internals/hooks/date-helpers-hooks.js":"ifoSw","../internals/components/PickerViewRoot/index.js":"gmdrj","./multiSectionDigitalClockClasses.js":"NV6O2","./MultiSectionDigitalClockSection.js":"1mXrV","./MultiSectionDigitalClock.utils.js":"fe0sJ","../internals/hooks/useControlledValue.js":"hTAsm","../internals/utils/valueManagers.js":"bimTj","../internals/hooks/useClockReferenceDate.js":"dPXXC","../internals/utils/date-utils.js":"jrk9G","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"NV6O2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMultiSectionDigitalClockUtilityClass", ()=>getMultiSectionDigitalClockUtilityClass);
parcelHelpers.export(exports, "multiSectionDigitalClockClasses", ()=>multiSectionDigitalClockClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getMultiSectionDigitalClockUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiMultiSectionDigitalClock', slot);
}
const multiSectionDigitalClockClasses = (0, _generateUtilityClassesDefault.default)('MuiMultiSectionDigitalClock', [
    'root'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mXrV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiSectionDigitalClockSection", ()=>MultiSectionDigitalClockSection);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _menuList = require("@mui/material/MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _multiSectionDigitalClockSectionClassesJs = require("./multiSectionDigitalClockSectionClasses.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _utilsJs = require("../internals/utils/utils.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "autoFocus",
    "onChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        item: [
            'item'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _multiSectionDigitalClockSectionClassesJs.getMultiSectionDigitalClockSectionUtilityClass), classes);
};
const MultiSectionDigitalClockSectionRoot = (0, _styles.styled)((0, _menuListDefault.default), {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Root'
})(({ theme })=>({
        maxHeight: (0, _dimensionsJs.DIGITAL_CLOCK_VIEW_HEIGHT),
        width: 56,
        padding: 0,
        overflow: 'hidden',
        scrollbarWidth: 'thin',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: 'auto'
        },
        '@media (pointer: fine)': {
            '&:hover': {
                overflowY: 'auto'
            }
        },
        '@media (pointer: none), (pointer: coarse)': {
            overflowY: 'auto'
        },
        '&:not(:first-of-type)': {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        '&::after': {
            display: 'block',
            content: '""',
            // subtracting the height of one item, extra margin and borders to make sure the max height is correct
            height: 'calc(100% - 40px - 6px)'
        },
        variants: [
            {
                props: {
                    hasDigitalClockAlreadyBeenRendered: true
                },
                style: {
                    '@media (prefers-reduced-motion: no-preference)': {
                        scrollBehavior: 'smooth'
                    }
                }
            }
        ]
    }));
const MultiSectionDigitalClockSectionItem = (0, _styles.styled)((0, _menuItemDefault.default), {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Item'
})(({ theme })=>({
        padding: 8,
        margin: '2px 4px',
        width: (0, _dimensionsJs.MULTI_SECTION_CLOCK_SECTION_WIDTH),
        justifyContent: 'center',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const MultiSectionDigitalClockSection = /*#__PURE__*/ _react.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    const containerRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(ref, containerRef);
    const previousActive = _react.useRef(null);
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClockSection'
    });
    const { autoFocus, onChange, className, classes: classesProp, disabled, readOnly, items, active, slots, slotProps, skipDisabled } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const ownerState = (0, _extendsDefault.default)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = useUtilityClasses(classesProp);
    const DigitalClockSectionItem = slots?.digitalClockSectionItem ?? MultiSectionDigitalClockSectionItem;
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const focusedOptionIndex = items.findIndex((item)=>item.isFocused(item.value));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, _utilsJs.getFocusedListItemIndex)(containerRef.current) - 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, _utilsJs.getFocusedListItemIndex)(containerRef.current) + 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MultiSectionDigitalClockSectionRoot, (0, _extendsDefault.default)({
        ref: handleRef,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox",
        onKeyDown: handleKeyDown
    }, other, {
        children: items.map((option, index)=>{
            const isItemDisabled = option.isDisabled?.(option.value);
            const isDisabled = disabled || isItemDisabled;
            if (skipDisabled && isDisabled) return null;
            const isSelected = option.isSelected(option.value);
            const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DigitalClockSectionItem, (0, _extendsDefault.default)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: isDisabled,
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly || isDisabled || undefined,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                tabIndex: tabIndex,
                className: classes.item
            }, slotProps?.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","@mui/material/MenuList":"eogrV","@mui/material/MenuItem":"a18vm","@mui/utils/useForkRef":"4xKTx","@mui/utils/useEnhancedEffect":"fIvqa","./multiSectionDigitalClockSectionClasses.js":"fyfPU","../internals/constants/dimensions.js":"i0BgX","../internals/utils/utils.js":"k4iiH","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fyfPU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMultiSectionDigitalClockSectionUtilityClass", ()=>getMultiSectionDigitalClockSectionUtilityClass);
parcelHelpers.export(exports, "multiSectionDigitalClockSectionClasses", ()=>multiSectionDigitalClockSectionClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getMultiSectionDigitalClockSectionUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiMultiSectionDigitalClockSection', slot);
}
const multiSectionDigitalClockSectionClasses = (0, _generateUtilityClassesDefault.default)('MuiMultiSectionDigitalClockSection', [
    'root',
    'item'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fe0sJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHourSectionOptions", ()=>getHourSectionOptions);
parcelHelpers.export(exports, "getTimeSectionOptions", ()=>getTimeSectionOptions);
const getHourSectionOptions = ({ now, value, utils, ampm, isDisabled, resolveAriaLabel, timeStep, valueOrReferenceDate })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const result = [];
    const isSelected = (hour, overriddenCurrentHours)=>{
        const resolvedCurrentHours = overriddenCurrentHours ?? currentHours;
        if (resolvedCurrentHours === null) return false;
        if (ampm) {
            if (hour === 12) return resolvedCurrentHours === 12 || resolvedCurrentHours === 0;
            return resolvedCurrentHours === hour || resolvedCurrentHours - 12 === hour;
        }
        return resolvedCurrentHours === hour;
    };
    const isFocused = (hour)=>{
        return isSelected(hour, utils.getHours(valueOrReferenceDate));
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = utils.format(utils.setHours(now, hour), ampm ? 'hours12h' : 'hours24h');
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = utils.formatNumber(label);
        result.push({
            value: hour,
            label,
            isSelected,
            isDisabled,
            isFocused,
            ariaLabel
        });
    }
    return result;
};
const getTimeSectionOptions = ({ value, utils, isDisabled, timeStep, resolveLabel, resolveAriaLabel, hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    const isFocused = (timeValue)=>{
        return value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: utils.formatNumber(resolveLabel(timeValue)),
                isDisabled,
                isSelected,
                isFocused,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"KpZjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersDay", ()=>(0, _pickersDayJs.PickersDay));
parcelHelpers.export(exports, "pickersDayClasses", ()=>(0, _pickersDayClassesJs.pickersDayClasses));
parcelHelpers.export(exports, "getPickersDayUtilityClass", ()=>(0, _pickersDayClassesJs.getPickersDayUtilityClass));
var _pickersDayJs = require("./PickersDay.js");
var _pickersDayClassesJs = require("./pickersDayClasses.js");

},{"./PickersDay.js":"lRmdY","./pickersDayClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRmdY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersDay", ()=>PickersDay);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _buttonBase = require("@mui/material/ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _styles = require("@mui/material/styles");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _pickersDayClassesJs = require("./pickersDayClasses.js");
var _usePickerDayOwnerStateJs = require("./usePickerDayOwnerState.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "autoFocus",
    "className",
    "classes",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "children",
    "isFirstVisibleCell",
    "isLastVisibleCell",
    "day",
    "selected",
    "disabled",
    "today",
    "outsideCurrentMonth",
    "disableMargin",
    "disableHighlightToday",
    "showDaysOutsideCurrentMonth"
];
const useUtilityClasses = (classes, ownerState)=>{
    const { isDaySelected, isDayDisabled, isDayCurrent, isDayOutsideMonth, disableMargin, disableHighlightToday, showDaysOutsideCurrentMonth } = ownerState;
    const isHiddenDaySpacingFiller = isDayOutsideMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            isDaySelected && !isHiddenDaySpacingFiller && 'selected',
            isDayDisabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && isDayCurrent && 'today',
            isDayOutsideMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersDayClassesJs.getPickersDayUtilityClass), classes);
};
const styleArg = ({ theme })=>(0, _extendsDefault.default)({}, theme.typography.caption, {
        width: (0, _dimensionsJs.DAY_SIZE),
        height: (0, _dimensionsJs.DAY_SIZE),
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, _pickersDayClassesJs.pickersDayClasses).selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, _pickersDayClassesJs.pickersDayClasses).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, _pickersDayClassesJs.pickersDayClasses).disabled}:not(.${(0, _pickersDayClassesJs.pickersDayClasses).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, _pickersDayClassesJs.pickersDayClasses).disabled}&.${(0, _pickersDayClassesJs.pickersDayClasses).selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${(0, _dimensionsJs.DAY_MARGIN)}px`
                }
            },
            {
                props: {
                    isDayOutsideMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    isDayCurrent: true
                },
                style: {
                    [`&:not(.${(0, _pickersDayClassesJs.pickersDayClasses).selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.isDayCurrent && styles.today,
        !ownerState.isDayOutsideMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.isDayOutsideMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const PickersDayRoot = (0, _styles.styled)((0, _buttonBaseDefault.default), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver
})(styleArg);
const PickersDayFiller = (0, _styles.styled)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver
})(({ theme })=>(0, _extendsDefault.default)({}, styleArg({
        theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const noop = ()=>{};
const PickersDayRaw = /*#__PURE__*/ _react.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus = false, className, classes: classesProp, isAnimating, onClick, onDaySelect, onFocus = noop, onBlur = noop, onKeyDown = noop, onMouseDown = noop, onMouseEnter = noop, children, day, selected, disabled, today, outsideCurrentMonth, disableMargin, disableHighlightToday, showDaysOutsideCurrentMonth } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _usePickerDayOwnerStateJs.usePickerDayOwnerState)({
        day,
        selected,
        disabled,
        today,
        outsideCurrentMonth,
        disableMargin,
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    const utils = (0, _useUtilsJs.useUtils)();
    const ref = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersDayFiller, {
        className: (0, _clsxDefault.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersDayRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
});
const PickersDay = /*#__PURE__*/ _react.memo(PickersDayRaw);

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/material/ButtonBase":"ajcyv","@mui/utils/useEnhancedEffect":"fIvqa","@mui/utils/composeClasses":"59Equ","@mui/utils/useForkRef":"4xKTx","@mui/material/styles":"c9RfU","../internals/hooks/useUtils.js":"dJQ8a","../internals/constants/dimensions.js":"i0BgX","./pickersDayClasses.js":"bzVmZ","./usePickerDayOwnerState.js":"dZmIX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bzVmZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersDayUtilityClass", ()=>getPickersDayUtilityClass);
parcelHelpers.export(exports, "pickersDayClasses", ()=>pickersDayClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getPickersDayUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersDay', slot);
}
const pickersDayClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dZmIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePickerDayOwnerState", ()=>usePickerDayOwnerState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
function usePickerDayOwnerState(parameters) {
    const { disabled, selected, today, outsideCurrentMonth, day, disableMargin, disableHighlightToday, showDaysOutsideCurrentMonth } = parameters;
    const utils = (0, _useUtilsJs.useUtils)();
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    return _react.useMemo(()=>(0, _extendsDefault.default)({}, pickerOwnerState, {
            day,
            isDaySelected: selected ?? false,
            isDayDisabled: disabled ?? false,
            isDayCurrent: today ?? false,
            isDayOutsideMonth: outsideCurrentMonth ?? false,
            isDayStartOfWeek: utils.isSameDay(day, utils.startOfWeek(day)),
            isDayEndOfWeek: utils.isSameDay(day, utils.endOfWeek(day)),
            disableMargin: disableMargin ?? false,
            disableHighlightToday: disableHighlightToday ?? false,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth ?? false
        }), [
        utils,
        pickerOwnerState,
        day,
        selected,
        disabled,
        today,
        outsideCurrentMonth,
        disableMargin,
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    ]);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../internals/hooks/usePickerPrivateContext.js":"4puZL","../internals/hooks/useUtils.js":"dJQ8a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNKm6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateField", ()=>(0, _dateFieldJs.DateField));
parcelHelpers.export(exports, "unstable_useDateField", ()=>(0, _useDateFieldJs.useDateField));
var _dateFieldJs = require("./DateField.js");
var _useDateFieldJs = require("./useDateField.js");

},{"./DateField.js":"8syjX","./useDateField.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8syjX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateField", ()=>DateField);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _useDateFieldJs = require("./useDateField.js");
var _pickerFieldUIJs = require("../internals/components/PickerFieldUI.js");
var _indexJs = require("../icons/index.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const DateField = /*#__PURE__*/ _react.forwardRef(function DateField(inProps, inRef) {
    const themeProps = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { slots, slotProps } = themeProps, other = (0, _objectWithoutPropertiesLooseDefault.default)(themeProps, _excluded);
    const textFieldProps = (0, _pickerFieldUIJs.useFieldTextFieldProps)({
        slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, _useDateFieldJs.useDateField)(textFieldProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickerFieldUIJs.PickerFieldUI), {
        slots: slots,
        slotProps: slotProps,
        fieldResponse: fieldResponse,
        defaultOpenPickerIcon: (0, _indexJs.CalendarIcon)
    });
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/material/styles":"c9RfU","@mui/utils/refType":"3TBXN","./useDateField.js":"7VsoM","../internals/components/PickerFieldUI.js":"cxHPG","../icons/index.js":"8RbJX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7VsoM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDateField", ()=>useDateField);
var _indexJs = require("../internals/hooks/useField/index.js");
var _indexJs1 = require("../managers/index.js");
'use client';
const useDateField = (props)=>{
    const manager = (0, _indexJs1.useDateManager)(props);
    return (0, _indexJs.useField)({
        manager,
        props
    });
};

},{"../internals/hooks/useField/index.js":"21jpU","../managers/index.js":"6sU7F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21jpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useField", ()=>(0, _useFieldJs.useField));
parcelHelpers.export(exports, "createDateStrForV7HiddenInputFromSections", ()=>(0, _useFieldUtilsJs.createDateStrForV7HiddenInputFromSections));
parcelHelpers.export(exports, "createDateStrForV6InputFromSections", ()=>(0, _useFieldUtilsJs.createDateStrForV6InputFromSections));
parcelHelpers.export(exports, "useFieldInternalPropsWithDefaults", ()=>(0, _useFieldInternalPropsWithDefaultsJs.useFieldInternalPropsWithDefaults));
var _useFieldJs = require("./useField.js");
var _useFieldUtilsJs = require("./useField.utils.js");
var _useFieldInternalPropsWithDefaultsJs = require("./useFieldInternalPropsWithDefaults.js");

},{"./useField.js":"8nXXa","./useField.utils.js":false,"./useFieldInternalPropsWithDefaults.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8nXXa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useField", ()=>useField);
var _useFieldV7TextFieldJs = require("./useFieldV7TextField.js");
var _useFieldV6TextFieldJs = require("./useFieldV6TextField.js");
var _useNullableFieldPrivateContextJs = require("../useNullableFieldPrivateContext.js");
const useField = (parameters)=>{
    const fieldPrivateContext = (0, _useNullableFieldPrivateContextJs.useNullableFieldPrivateContext)();
    const enableAccessibleFieldDOMStructure = parameters.props.enableAccessibleFieldDOMStructure ?? fieldPrivateContext?.enableAccessibleFieldDOMStructure ?? true;
    const useFieldTextField = enableAccessibleFieldDOMStructure ? (0, _useFieldV7TextFieldJs.useFieldV7TextField) : (0, _useFieldV6TextFieldJs.useFieldV6TextField);
    return useFieldTextField(parameters);
};

},{"./useFieldV7TextField.js":"jdwta","./useFieldV6TextField.js":"5f8Ud","../useNullableFieldPrivateContext.js":"3cpM2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdwta":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFieldV7TextField", ()=>useFieldV7TextField);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useFieldUtilsJs = require("./useField.utils.js");
var _utilsJs = require("../../utils/utils.js");
var _indexJs = require("../../../hooks/index.js");
var _useFieldCharacterEditingJs = require("./useFieldCharacterEditing.js");
var _useFieldStateJs = require("./useFieldState.js");
var _useFieldInternalPropsWithDefaultsJs = require("./useFieldInternalPropsWithDefaults.js");
var _syncSelectionToDOMJs = require("./syncSelectionToDOM.js");
var _useFieldRootPropsJs = require("./useFieldRootProps.js");
var _useFieldHiddenInputPropsJs = require("./useFieldHiddenInputProps.js");
var _useFieldSectionContainerPropsJs = require("./useFieldSectionContainerProps.js");
var _useFieldSectionContentPropsJs = require("./useFieldSectionContentProps.js");
const useFieldV7TextField = (parameters)=>{
    const { props, manager, skipContextFieldRefAssignment, manager: { valueType, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps, forwardedProps } = (0, _indexJs.useSplitFieldProps)(props, valueType);
    const internalPropsWithDefaults = (0, _useFieldInternalPropsWithDefaultsJs.useFieldInternalPropsWithDefaults)({
        manager,
        internalProps,
        skipContextFieldRefAssignment
    });
    const { sectionListRef: sectionListRefProp, onBlur, onClick, onFocus, onInput, onPaste, onKeyDown, onClear, clearable } = forwardedProps;
    const { disabled = false, readOnly = false, autoFocus = false, focused: focusedProp, unstableFieldRef } = internalPropsWithDefaults;
    const sectionListRef = _react.useRef(null);
    const handleSectionListRef = (0, _useForkRefDefault.default)(sectionListRefProp, sectionListRef);
    const domGetters = _react.useMemo(()=>({
            isReady: ()=>sectionListRef.current != null,
            getRoot: ()=>sectionListRef.current.getRoot(),
            getSectionContainer: (sectionIndex)=>sectionListRef.current.getSectionContainer(sectionIndex),
            getSectionContent: (sectionIndex)=>sectionListRef.current.getSectionContent(sectionIndex),
            getSectionIndexFromDOMElement: (element)=>sectionListRef.current.getSectionIndexFromDOMElement(element)
        }), [
        sectionListRef
    ]);
    const stateResponse = (0, _useFieldStateJs.useFieldState)({
        manager,
        internalPropsWithDefaults,
        forwardedProps
    });
    const { // States and derived states
    areAllSectionsEmpty, error, parsedSelectedSections, sectionOrder, state, value, // Methods to update the states
    clearValue, setSelectedSections } = stateResponse;
    const applyCharacterEditing = (0, _useFieldCharacterEditingJs.useFieldCharacterEditing)({
        stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const [focused, setFocused] = _react.useState(false);
    function focusField(newSelectedSections = 0) {
        if (disabled || !sectionListRef.current || // if the field is already focused, we don't need to focus it again
        getActiveSectionIndex(sectionListRef) != null) return;
        const newParsedSelectedSections = (0, _useFieldUtilsJs.parseSelectedSections)(newSelectedSections, state.sections);
        setFocused(true);
        sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
    }
    const rootProps = (0, _useFieldRootPropsJs.useFieldRootProps)({
        manager,
        internalPropsWithDefaults,
        stateResponse,
        applyCharacterEditing,
        focused,
        setFocused,
        domGetters
    });
    const hiddenInputProps = (0, _useFieldHiddenInputPropsJs.useFieldHiddenInputProps)({
        manager,
        stateResponse
    });
    const createSectionContainerProps = (0, _useFieldSectionContainerPropsJs.useFieldSectionContainerProps)({
        stateResponse,
        internalPropsWithDefaults
    });
    const createSectionContentProps = (0, _useFieldSectionContentPropsJs.useFieldSectionContentProps)({
        manager,
        stateResponse,
        applyCharacterEditing,
        internalPropsWithDefaults,
        domGetters,
        focused
    });
    const handleRootKeyDown = (0, _useEventCallbackDefault.default)((event)=>{
        onKeyDown?.(event);
        rootProps.onKeyDown(event);
    });
    const handleRootBlur = (0, _useEventCallbackDefault.default)((event)=>{
        onBlur?.(event);
        rootProps.onBlur(event);
    });
    const handleRootFocus = (0, _useEventCallbackDefault.default)((event)=>{
        onFocus?.(event);
        rootProps.onFocus(event);
    });
    const handleRootClick = (0, _useEventCallbackDefault.default)((event)=>{
        // The click event on the clear or open button would propagate to the input, trigger this handler and result in an inadvertent section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a propagated call, which should be skipped.
        if (event.isDefaultPrevented()) return;
        onClick?.(event);
        rootProps.onClick(event);
    });
    const handleRootPaste = (0, _useEventCallbackDefault.default)((event)=>{
        onPaste?.(event);
        rootProps.onPaste(event);
    });
    const handleRootInput = (0, _useEventCallbackDefault.default)((event)=>{
        onInput?.(event);
        rootProps.onInput(event);
    });
    const handleClear = (0, _useEventCallbackDefault.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!isFieldFocused(sectionListRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const elements = _react.useMemo(()=>{
        return state.sections.map((section, sectionIndex)=>{
            const content = createSectionContentProps(section, sectionIndex);
            return {
                container: createSectionContainerProps(sectionIndex),
                content: createSectionContentProps(section, sectionIndex),
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator,
                    'data-range-position': section.isEndFormatSeparator ? content['data-range-position'] : undefined
                }
            };
        });
    }, [
        state.sections,
        createSectionContainerProps,
        createSectionContentProps
    ]);
    _react.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            'MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`',
            'You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.',
            '',
            'If you want to keep using an `<input />` HTML element for the editing, please add the `enableAccessibleFieldDOMStructure={false}` prop to your Picker or Field component:',
            '',
            '<DatePicker enableAccessibleFieldDOMStructure={false} slots={{ textField: MyCustomTextField }} />',
            '',
            'Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element'
        ].join('\n'));
        if (autoFocus && !disabled && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === 'all') sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === 'number') {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    (0, _useEnhancedEffectDefault.default)(()=>{
        (0, _syncSelectionToDOMJs.syncSelectionToDOM)({
            focused,
            domGetters,
            stateResponse
        });
    });
    _react.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>getActiveSectionIndex(sectionListRef),
            setSelectedSections: (newSelectedSections)=>{
                if (disabled || !sectionListRef.current) return;
                const newParsedSelectedSections = (0, _useFieldUtilsJs.parseSelectedSections)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === 'all' ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            focusField,
            isFieldFocused: ()=>isFieldFocused(sectionListRef)
        }));
    return (0, _extendsDefault.default)({}, forwardedProps, rootProps, {
        onBlur: handleRootBlur,
        onClick: handleRootClick,
        onFocus: handleRootFocus,
        onInput: handleRootInput,
        onPaste: handleRootPaste,
        onKeyDown: handleRootKeyDown,
        onClear: handleClear
    }, hiddenInputProps, {
        error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        focused: focusedProp ?? focused,
        sectionListRef: handleSectionListRef,
        // Additional
        enableAccessibleFieldDOMStructure: true,
        elements,
        areAllSectionsEmpty,
        disabled,
        readOnly,
        autoFocus,
        openPickerAriaLabel
    });
};
function getActiveSectionIndex(sectionListRef) {
    const activeElement = (0, _utilsJs.getActiveElement)(document);
    if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
    return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
}
function isFieldFocused(sectionListRef) {
    const activeElement = (0, _utilsJs.getActiveElement)(document);
    return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/utils/useForkRef":"4xKTx","@mui/utils/useEventCallback":"feNJe","@mui/utils/useEnhancedEffect":"fIvqa","./useField.utils.js":"jBxFh","../../utils/utils.js":"k4iiH","../../../hooks/index.js":"a3BuB","./useFieldCharacterEditing.js":"dyBHh","./useFieldState.js":"g8jQp","./useFieldInternalPropsWithDefaults.js":"lew7h","./syncSelectionToDOM.js":"7JKKV","./useFieldRootProps.js":"39MF8","./useFieldHiddenInputProps.js":"bVc7T","./useFieldSectionContainerProps.js":"kDdnK","./useFieldSectionContentProps.js":"ks20r","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a3BuB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePickerTranslations", ()=>(0, _usePickerTranslationsJs.usePickerTranslations));
parcelHelpers.export(exports, "useSplitFieldProps", ()=>(0, _useSplitFieldPropsJs.useSplitFieldProps));
parcelHelpers.export(exports, "useParsedFormat", ()=>(0, _useParsedFormatJs.useParsedFormat));
parcelHelpers.export(exports, "usePickerContext", ()=>(0, _usePickerContextJs.usePickerContext));
parcelHelpers.export(exports, "usePickerActionsContext", ()=>(0, _usePickerActionsContextJs.usePickerActionsContext));
parcelHelpers.export(exports, "useIsValidValue", ()=>(0, _useIsValidValueJs.useIsValidValue));
var _usePickerTranslationsJs = require("./usePickerTranslations.js");
var _useSplitFieldPropsJs = require("./useSplitFieldProps.js");
var _useParsedFormatJs = require("./useParsedFormat.js");
var _usePickerContextJs = require("./usePickerContext.js");
var _usePickerActionsContextJs = require("./usePickerActionsContext.js");
var _useIsValidValueJs = require("./useIsValidValue.js");

},{"./usePickerTranslations.js":"3Zb4l","./useSplitFieldProps.js":"6cwCM","./useParsedFormat.js":false,"./usePickerContext.js":"hyseP","./usePickerActionsContext.js":"38Rcy","./useIsValidValue.js":"lKU6V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cwCM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSplitFieldProps", ()=>useSplitFieldProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _extractValidationPropsJs = require("../validation/extractValidationProps.js");
'use client';
const SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef',
    'unstableStartFieldRef',
    'unstableEndFieldRef',
    'enableAccessibleFieldDOMStructure',
    'disabled',
    'readOnly',
    'dateSeparator',
    'autoFocus',
    'focused'
];
const useSplitFieldProps = (props, valueType)=>{
    return _react.useMemo(()=>{
        const forwardedProps = (0, _extendsDefault.default)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === 'date') (0, _extractValidationPropsJs.DATE_VALIDATION_PROP_NAMES).forEach(extractProp);
        else if (valueType === 'time') (0, _extractValidationPropsJs.TIME_VALIDATION_PROP_NAMES).forEach(extractProp);
        else if (valueType === 'date-time') {
            (0, _extractValidationPropsJs.DATE_VALIDATION_PROP_NAMES).forEach(extractProp);
            (0, _extractValidationPropsJs.TIME_VALIDATION_PROP_NAMES).forEach(extractProp);
            (0, _extractValidationPropsJs.DATE_TIME_VALIDATION_PROP_NAMES).forEach(extractProp);
        }
        return {
            forwardedProps,
            internalProps
        };
    }, [
        props,
        valueType
    ]);
}; /**
 * Extract the internal props from the props received by the field component.
 * This makes sure that the internal props not defined in the props are not present in the result.
 */ 

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../validation/extractValidationProps.js":"l4tVF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4tVF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATE_VALIDATION_PROP_NAMES", ()=>DATE_VALIDATION_PROP_NAMES);
parcelHelpers.export(exports, "TIME_VALIDATION_PROP_NAMES", ()=>TIME_VALIDATION_PROP_NAMES);
parcelHelpers.export(exports, "DATE_TIME_VALIDATION_PROP_NAMES", ()=>DATE_TIME_VALIDATION_PROP_NAMES);
parcelHelpers.export(exports, "extractValidationProps", ()=>extractValidationProps);
const DATE_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const TIME_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const DATE_TIME_VALIDATION_PROP_NAMES = [
    'minDateTime',
    'maxDateTime'
];
const VALIDATION_PROP_NAMES = [
    ...DATE_VALIDATION_PROP_NAMES,
    ...TIME_VALIDATION_PROP_NAMES,
    ...DATE_TIME_VALIDATION_PROP_NAMES
];
const extractValidationProps = (props)=>VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38Rcy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePickerActionsContext", ()=>usePickerActionsContext);
var _react = require("react");
var _pickerProviderJs = require("../internals/components/PickerProvider.js");
'use client';
const usePickerActionsContext = ()=>{
    const value = _react.useContext((0, _pickerProviderJs.PickerActionsContext));
    if (value == null) throw new Error([
        'MUI X: The `usePickerActionsContext` can only be called in fields that are used as a slot of a Picker component'
    ].join('\n'));
    return value;
};

},{"react":"9njXz","../internals/components/PickerProvider.js":"lJDhK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dyBHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFieldCharacterEditing", ()=>useFieldCharacterEditing);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useUtilsJs = require("../useUtils.js");
var _useFieldUtilsJs = require("./useField.utils.js");
const isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const useFieldCharacterEditing = ({ stateResponse: { // States and derived states
localizedDigits, sectionsValueBoundaries, state, timezone, // Methods to update the states
setCharacterQuery, setTempAndroidValueStr, updateSectionValue } })=>{
    const utils = (0, _useUtilsJs.useUtils)();
    const applyQuery = ({ keyPressed, sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = state.sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (state.characterQuery != null && (!isValidQueryValue || isValidQueryValue(state.characterQuery.value)) && state.characterQuery.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${state.characterQuery.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!isQueryResponseWithoutValue(queryResponse)) {
                setCharacterQuery({
                    sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if (isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            setCharacterQuery(null);
            return null;
        }
        setCharacterQuery({
            sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if (isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, _useFieldUtilsJs.getLetterEditingOptions)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, _useFieldUtilsJs.getDateSectionConfigFromFormatToken)(utils, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if (isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, _extendsDefault.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, _useFieldUtilsJs.changeSectionValueFormat)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = ({ queryValue, skipIfBelowMinimum, section })=>{
            const cleanQueryValue = (0, _useFieldUtilsJs.removeLocalizedDigits)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (skipIfBelowMinimum && queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, _useFieldUtilsJs.cleanDigitSectionValue)(utils, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue({
                queryValue,
                skipIfBelowMinimum: false,
                section: activeSection
            });
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, _useFieldUtilsJs.doesSectionFormatHaveLeadingZeros)(utils, 'digit', 'month', 'MM');
                const response = getNewSectionValue({
                    queryValue,
                    skipIfBelowMinimum: true,
                    section: {
                        type: activeSection.type,
                        format: 'MM',
                        hasLeadingZerosInFormat,
                        hasLeadingZerosInInput: true,
                        contentType: 'digit',
                        maxLength: 2
                    }
                });
                if (isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, _useFieldUtilsJs.changeSectionValueFormat)(utils, response.sectionValue, 'MM', activeSection.format);
                return (0, _extendsDefault.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue({
                    queryValue,
                    skipIfBelowMinimum: true,
                    section: activeSection
                });
                if (isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, _useFieldUtilsJs.getDaysInWeekStr)(utils, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, _extendsDefault.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, _useFieldUtilsJs.isStringNumber)(queryValue, localizedDigits));
    };
    return (0, _useEventCallbackDefault.default)((params)=>{
        const section = state.sections[params.sectionIndex];
        const isNumericEditing = (0, _useFieldUtilsJs.isStringNumber)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, _extendsDefault.default)({}, params, {
            keyPressed: (0, _useFieldUtilsJs.applyLocalizedDigits)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            section,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
}; /**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */  /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ 

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/useEventCallback":"feNJe","../useUtils.js":"dJQ8a","./useField.utils.js":"jBxFh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g8jQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFieldState", ()=>useFieldState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useControlled = require("@mui/utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _rtlProvider = require("@mui/system/RtlProvider");
var _usePickerTranslationsJs = require("../../../hooks/usePickerTranslations.js");
var _useUtilsJs = require("../useUtils.js");
var _useFieldUtilsJs = require("./useField.utils.js");
var _buildSectionsFromFormatJs = require("./buildSectionsFromFormat.js");
var _indexJs = require("../../../validation/index.js");
var _useControlledValueJs = require("../useControlledValue.js");
var _getDefaultReferenceDateJs = require("../../utils/getDefaultReferenceDate.js");
const QUERY_LIFE_DURATION_MS = 5000;
const useFieldState = (parameters)=>{
    const utils = (0, _useUtilsJs.useUtils)();
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const adapter = (0, _useUtilsJs.useLocalizationContext)();
    const isRtl = (0, _rtlProvider.useRtl)();
    const { manager: { validator, valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults, internalPropsWithDefaults: { value: valueProp, defaultValue, referenceDate: referenceDateProp, onChange, format, formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange, shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure = true }, forwardedProps: { error: errorProp } } = parameters;
    const { value, handleValueChange, timezone } = (0, _useControlledValueJs.useControlledValue)({
        name: 'a field component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager
    });
    const valueRef = _react.useRef(value);
    _react.useEffect(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
    const { hasValidationError } = (0, _indexJs.useValidation)({
        props: internalPropsWithDefaults,
        validator,
        timezone,
        value,
        onError: internalPropsWithDefaults.onError
    });
    const error = _react.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (errorProp !== undefined) return errorProp;
        return hasValidationError;
    }, [
        hasValidationError,
        errorProp
    ]);
    const localizedDigits = _react.useMemo(()=>(0, _useFieldUtilsJs.getLocalizedDigits)(utils), [
        utils
    ]);
    const sectionsValueBoundaries = _react.useMemo(()=>(0, _useFieldUtilsJs.getSectionsBoundaries)(utils, localizedDigits, timezone), [
        utils,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = _react.useCallback((valueToAnalyze)=>fieldValueManager.getSectionsFromValue(valueToAnalyze, (date)=>(0, _buildSectionsFromFormatJs.buildSectionsFromFormat)({
                utils,
                localeText: translations,
                localizedDigits,
                format,
                date,
                formatDensity,
                shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure,
                isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = _react.useState(()=>{
        const sections = getSectionsFromValue(value);
        (0, _useFieldUtilsJs.validateSections)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections,
            lastExternalValue: value,
            lastSectionsDependencies: {
                format,
                isRtl,
                locale: utils.locale
            },
            tempValueStrAndroid: null,
            characterQuery: null
        };
        const granularity = (0, _getDefaultReferenceDateJs.getSectionTypeGranularity)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value,
            utils,
            props: internalPropsWithDefaults,
            granularity,
            timezone
        });
        return (0, _extendsDefault.default)({}, stateWithoutReferenceDate, {
            referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, _useControlledDefault.default)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = _react.useMemo(()=>(0, _useFieldUtilsJs.parseSelectedSections)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;
    const sectionOrder = _react.useMemo(()=>(0, _useFieldUtilsJs.getSectionOrder)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const areAllSectionsEmpty = _react.useMemo(()=>state.sections.every((section)=>section.value === ''), [
        state.sections
    ]);
    const publishValue = (newValue)=>{
        const context = {
            validationError: validator({
                adapter,
                value: newValue,
                timezone,
                props: internalPropsWithDefaults
            })
        };
        handleValueChange(newValue, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, _extendsDefault.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const sectionToUpdateOnNextInvalidDateRef = _react.useRef(null);
    const updateSectionValueOnNextInvalidDateTimeout = (0, _useTimeoutDefault.default)();
    const setSectionUpdateToApplyOnNextInvalidDate = (newSectionValue)=>{
        if (activeSectionIndex == null) return;
        sectionToUpdateOnNextInvalidDateRef.current = {
            sectionIndex: activeSectionIndex,
            value: newSectionValue
        };
        updateSectionValueOnNextInvalidDateTimeout.start(0, ()=>{
            sectionToUpdateOnNextInvalidDateRef.current = null;
        });
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(utils, value, valueManager.emptyValue)) setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                sections: prevState.sections.map((section)=>(0, _extendsDefault.default)({}, section, {
                        value: ''
                    })),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(valueManager.emptyValue);
        }
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        if (activeSection.value === '') return;
        setSectionUpdateToApplyOnNextInvalidDate('');
        if (fieldValueManager.getDateFromSection(value, activeSection) === null) setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                sections: setSectionValue(activeSectionIndex, ''),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(fieldValueManager.updateDateInValue(value, activeSection, null));
        }
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (!utils.isValid(date)) return null;
            const sections = (0, _buildSectionsFromFormatJs.buildSectionsFromFormat)({
                utils,
                localeText: translations,
                localizedDigits,
                format,
                date,
                formatDensity,
                shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure,
                isRtl
            });
            return (0, _useFieldUtilsJs.mergeDateIntoReferenceDate)(utils, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        publishValue(newValue);
    };
    const cleanActiveDateSectionsIfValueNullTimeout = (0, _useTimeoutDefault.default)();
    const updateSectionValue = ({ section, newSectionValue, shouldGoToNextSection })=>{
        updateSectionValueOnNextInvalidDateTimeout.clear();
        cleanActiveDateSectionsIfValueNullTimeout.clear();
        const activeDate = fieldValueManager.getDateFromSection(value, section);
        /**
     * Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * Try to build a valid date from the new section value
     */ const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = fieldValueManager.getDateSectionsFromValue(newSections, section);
        const newActiveDate = (0, _useFieldUtilsJs.getDateFromDateSections)(utils, newActiveDateSections, localizedDigits);
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (utils.isValid(newActiveDate)) {
            const mergedDate = (0, _useFieldUtilsJs.mergeDateIntoReferenceDate)(utils, newActiveDate, newActiveDateSections, fieldValueManager.getDateFromSection(state.referenceValue, section), true);
            if (activeDate == null) cleanActiveDateSectionsIfValueNullTimeout.start(0, ()=>{
                if (valueRef.current === value) setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                        sections: fieldValueManager.clearDateSections(state.sections, section),
                        tempValueStrAndroid: null
                    }));
            });
            return publishValue(fieldValueManager.updateDateInValue(value, section, mergedDate));
        }
        /**
     * If all the sections are filled but the date is invalid and the previous date is valid or null,
     * Then we publish an invalid date.
     */ if (newActiveDateSections.every((sectionBis)=>sectionBis.value !== '') && (activeDate == null || utils.isValid(activeDate))) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
        }
        /**
     * If the previous date is not null,
     * Then we publish the date as `null`.
     */ if (activeDate != null) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, null));
        }
        /**
     * If the previous date is already null,
     * Then we don't publish the date and we update the sections.
     */ return setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                tempValueStrAndroid
            }));
    const setCharacterQuery = (0, _useEventCallbackDefault.default)((newCharacterQuery)=>{
        setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                characterQuery: newCharacterQuery
            }));
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) {
        let sections;
        if (sectionToUpdateOnNextInvalidDateRef.current != null && !utils.isValid(fieldValueManager.getDateFromSection(value, state.sections[sectionToUpdateOnNextInvalidDateRef.current.sectionIndex]))) sections = setSectionValue(sectionToUpdateOnNextInvalidDateRef.current.sectionIndex, sectionToUpdateOnNextInvalidDateRef.current.value);
        else sections = getSectionsFromValue(value);
        setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                lastExternalValue: value,
                sections,
                sectionsDependencies: {
                    format,
                    isRtl,
                    locale: utils.locale
                },
                referenceValue: fieldValueManager.updateReferenceValue(utils, value, prevState.referenceValue),
                tempValueStrAndroid: null
            }));
    }
    if (isRtl !== state.lastSectionsDependencies.isRtl || format !== state.lastSectionsDependencies.format || utils.locale !== state.lastSectionsDependencies.locale) {
        const sections = getSectionsFromValue(value);
        (0, _useFieldUtilsJs.validateSections)(sections, valueType);
        setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                lastSectionsDependencies: {
                    format,
                    isRtl,
                    locale: utils.locale
                },
                sections,
                tempValueStrAndroid: null,
                characterQuery: null
            }));
    }
    if (state.characterQuery != null && !error && activeSectionIndex == null) setCharacterQuery(null);
    if (state.characterQuery != null && state.sections[state.characterQuery.sectionIndex]?.type !== state.characterQuery.sectionType) setCharacterQuery(null);
    _react.useEffect(()=>{
        if (sectionToUpdateOnNextInvalidDateRef.current != null) sectionToUpdateOnNextInvalidDateRef.current = null;
    });
    const cleanCharacterQueryTimeout = (0, _useTimeoutDefault.default)();
    _react.useEffect(()=>{
        if (state.characterQuery != null) cleanCharacterQueryTimeout.start(QUERY_LIFE_DURATION_MS, ()=>setCharacterQuery(null));
        return ()=>{};
    }, [
        state.characterQuery,
        setCharacterQuery,
        cleanCharacterQueryTimeout
    ]);
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    _react.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) clearActiveSection();
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        // States and derived states
        activeSectionIndex,
        areAllSectionsEmpty,
        error,
        localizedDigits,
        parsedSelectedSections,
        sectionOrder,
        sectionsValueBoundaries,
        state,
        timezone,
        value,
        // Methods to update the states
        clearValue,
        clearActiveSection,
        setCharacterQuery,
        setSelectedSections,
        setTempAndroidValueStr,
        updateSectionValue,
        updateValueFromValueStr,
        // Utilities methods
        getSectionsFromValue
    };
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/utils/useControlled":"jwZrv","@mui/utils/useTimeout":"k3sgs","@mui/utils/useEventCallback":"feNJe","@mui/system/RtlProvider":"ck9Pb","../../../hooks/usePickerTranslations.js":"3Zb4l","../useUtils.js":"dJQ8a","./useField.utils.js":"jBxFh","./buildSectionsFromFormat.js":"baYJ6","../../../validation/index.js":"973pf","../useControlledValue.js":"hTAsm","../../utils/getDefaultReferenceDate.js":"1Z5lc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"baYJ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSectionsFromFormat", ()=>buildSectionsFromFormat);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _useFieldUtilsJs = require("./useField.utils.js");
const expandFormat = ({ utils, format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the component.');
    }
    return nextFormat;
};
const getEscapedPartsFromFormat = ({ utils, expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const getSectionPlaceholder = (utils, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.date(undefined, 'default'), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const createSection = ({ utils, date, shouldRespectLeadingZeros, localeText, localizedDigits, now, token, startSeparator })=>{
    if (token === '') throw new Error('MUI X: Should not call `commitToken` with an empty token');
    const sectionConfig = (0, _useFieldUtilsJs.getDateSectionConfigFromFormatToken)(utils, token);
    const hasLeadingZerosInFormat = (0, _useFieldUtilsJs.doesSectionFormatHaveLeadingZeros)(utils, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = utils.isValid(date);
    let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? utils.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxLength' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, _useFieldUtilsJs.applyLocalizedDigits)((0, _useFieldUtilsJs.cleanLeadingZeros)((0, _useFieldUtilsJs.removeLocalizedDigits)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, _extendsDefault.default)({}, sectionConfig, {
        format: token,
        maxLength,
        value: sectionValue,
        placeholder: getSectionPlaceholder(utils, localeText, sectionConfig, token),
        hasLeadingZerosInFormat,
        hasLeadingZerosInInput,
        startSeparator,
        endSeparator: '',
        modified: false
    });
};
const buildSections = (parameters)=>{
    const { utils, expandedFormat, escapedParts } = parameters;
    const now = utils.date(undefined);
    const sections = [];
    let startSeparator = '';
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push(createSection((0, _extendsDefault.default)({}, parameters, {
                    now,
                    token: firstWord,
                    startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else {
                    sections[sections.length - 1].endSeparator += char;
                    sections[sections.length - 1].isEndFormatSeparator = true;
                }
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const postProcessSections = ({ isRtl, formatDensity, sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const buildSectionsFromFormat = (parameters)=>{
    let expandedFormat = expandFormat(parameters);
    if (parameters.isRtl && parameters.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = getEscapedPartsFromFormat((0, _extendsDefault.default)({}, parameters, {
        expandedFormat
    }));
    const sections = buildSections((0, _extendsDefault.default)({}, parameters, {
        expandedFormat,
        escapedParts
    }));
    return postProcessSections((0, _extendsDefault.default)({}, parameters, {
        sections
    }));
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","./useField.utils.js":"jBxFh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"973pf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateDate", ()=>(0, _validateDateJs.validateDate));
parcelHelpers.export(exports, "validateTime", ()=>(0, _validateTimeJs.validateTime));
parcelHelpers.export(exports, "validateDateTime", ()=>(0, _validateDateTimeJs.validateDateTime));
parcelHelpers.export(exports, "extractValidationProps", ()=>(0, _extractValidationPropsJs.extractValidationProps));
parcelHelpers.export(exports, "useValidation", ()=>(0, _useValidationJs.useValidation));
var _validateDateJs = require("./validateDate.js");
var _validateTimeJs = require("./validateTime.js");
var _validateDateTimeJs = require("./validateDateTime.js");
var _extractValidationPropsJs = require("./extractValidationProps.js");
var _useValidationJs = require("./useValidation.js");

},{"./validateDate.js":"8peQb","./validateTime.js":false,"./validateDateTime.js":"6exQc","./extractValidationProps.js":"l4tVF","./useValidation.js":"pDG3a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8peQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateDate", ()=>validateDate);
var _valueManagersJs = require("../internals/utils/valueManagers.js");
const validateDate = ({ props, value, timezone, adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate, shouldDisableMonth, shouldDisableYear, disablePast, disableFuture, minDate, maxDate } = props;
    const now = adapter.utils.date(undefined, timezone);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
validateDate.valueManager = (0, _valueManagersJs.singleItemValueManager);

},{"../internals/utils/valueManagers.js":"bimTj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gxIke":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateTime", ()=>validateTime);
var _timeUtilsJs = require("../internals/utils/time-utils.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
const validateTime = ({ adapter, value, timezone, props })=>{
    if (value === null) return null;
    const { minTime, maxTime, minutesStep, shouldDisableTime, disableIgnoringDatePartForTimeValidation = false, disablePast, disableFuture } = props;
    const now = adapter.utils.date(undefined, timezone);
    const isAfter = (0, _timeUtilsJs.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfter(minTime, value)):
            return 'minTime';
        case Boolean(maxTime && isAfter(value, maxTime)):
            return 'maxTime';
        case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBefore(value, now)):
            return 'disablePast';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'seconds')):
            return 'shouldDisableTime-seconds';
        case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
            return 'minutesStep';
        default:
            return null;
    }
};
validateTime.valueManager = (0, _valueManagersJs.singleItemValueManager);

},{"../internals/utils/time-utils.js":"7FMia","../internals/utils/valueManagers.js":"bimTj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6exQc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateDateTime", ()=>validateDateTime);
var _validateDateJs = require("./validateDate.js");
var _validateTimeJs = require("./validateTime.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
const validateDateTime = ({ adapter, value, timezone, props })=>{
    const dateValidationResult = (0, _validateDateJs.validateDate)({
        adapter,
        value,
        timezone,
        props
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, _validateTimeJs.validateTime)({
        adapter,
        value,
        timezone,
        props
    });
};
validateDateTime.valueManager = (0, _valueManagersJs.singleItemValueManager);

},{"./validateDate.js":"8peQb","./validateTime.js":"gxIke","../internals/utils/valueManagers.js":"bimTj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"pDG3a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Utility hook to check if a given value is valid based on the provided validation props.
 * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
 * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
 * @param {UseValidationOptions<TValue, TError, TValidationProps>} options The options to configure the hook.
 * @param {TValue} options.value The value to validate.
 * @param {PickersTimezone} options.timezone The timezone to use for the validation.
 * @param {Validator<TValue, TError, TValidationProps>} options.validator The validator function to use.
 * @param {TValidationProps} options.props The validation props, they differ depending on the component.
 * @param {(error: TError, value: TValue) => void} options.onError Callback fired when the error associated with the current value changes.
 */ parcelHelpers.export(exports, "useValidation", ()=>useValidation);
var _react = require("react");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useUtilsJs = require("../internals/hooks/useUtils.js");
'use client';
function useValidation(options) {
    const { props, validator, value, timezone, onError } = options;
    const adapter = (0, _useUtilsJs.useLocalizationContext)();
    const previousValidationErrorRef = _react.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter,
        value,
        timezone,
        props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    _react.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, _useEventCallbackDefault.default)((newValue)=>{
        return validator({
            adapter,
            value: newValue,
            timezone,
            props
        });
    });
    return {
        validationError,
        hasValidationError,
        getValidationErrorForNewValue
    };
}

},{"react":"9njXz","@mui/utils/useEventCallback":"feNJe","../internals/hooks/useUtils.js":"dJQ8a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lew7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Applies the default values to the field internal props.
 * This is a temporary hook that will be removed during a follow up when `useField` will receive the internal props without the defaults.
 * It is only here to allow the migration to be done in smaller steps.
 */ parcelHelpers.export(exports, "useFieldInternalPropsWithDefaults", ()=>useFieldInternalPropsWithDefaults);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useNullablePickerContextJs = require("../useNullablePickerContext.js");
var _useNullableFieldPrivateContextJs = require("../useNullableFieldPrivateContext.js");
function useFieldInternalPropsWithDefaults(parameters) {
    const { manager: { internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToFieldInternalProps }, internalProps, skipContextFieldRefAssignment } = parameters;
    const pickerContext = (0, _useNullablePickerContextJs.useNullablePickerContext)();
    const fieldPrivateContext = (0, _useNullableFieldPrivateContextJs.useNullableFieldPrivateContext)();
    const handleFieldRef = (0, _useForkRefDefault.default)(internalProps.unstableFieldRef, skipContextFieldRefAssignment ? null : fieldPrivateContext?.fieldRef);
    const setValue = pickerContext?.setValue;
    const handleChangeFromPicker = _react.useCallback((newValue, ctx)=>{
        return setValue?.(newValue, {
            validationError: ctx.validationError,
            shouldClose: false
        });
    }, [
        setValue
    ]);
    const internalPropsWithDefaultsFromContext = _react.useMemo(()=>{
        // If one of the context is null,
        // Then the field is used as a standalone component and the other context will be null as well.
        if (fieldPrivateContext != null && pickerContext != null) return (0, _extendsDefault.default)({
            value: pickerContext.value,
            onChange: handleChangeFromPicker,
            timezone: pickerContext.timezone,
            disabled: pickerContext.disabled,
            readOnly: pickerContext.readOnly,
            autoFocus: pickerContext.autoFocus && !pickerContext.open,
            focused: pickerContext.open ? true : undefined,
            format: pickerContext.fieldFormat,
            formatDensity: fieldPrivateContext.formatDensity,
            enableAccessibleFieldDOMStructure: fieldPrivateContext.enableAccessibleFieldDOMStructure,
            selectedSections: fieldPrivateContext.selectedSections,
            onSelectedSectionsChange: fieldPrivateContext.onSelectedSectionsChange,
            unstableFieldRef: handleFieldRef
        }, internalProps);
        return internalProps;
    }, [
        pickerContext,
        fieldPrivateContext,
        internalProps,
        handleChangeFromPicker,
        handleFieldRef
    ]);
    return useApplyDefaultValuesToFieldInternalProps(internalPropsWithDefaultsFromContext);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/utils/useForkRef":"4xKTx","../useNullablePickerContext.js":"aFzJC","../useNullableFieldPrivateContext.js":"3cpM2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFzJC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNullablePickerContext", ()=>useNullablePickerContext);
var _react = require("react");
var _usePickerContextJs = require("../../hooks/usePickerContext.js");
'use client';
const useNullablePickerContext = ()=>_react.useContext((0, _usePickerContextJs.PickerContext));

},{"react":"9njXz","../../hooks/usePickerContext.js":"hyseP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7JKKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "syncSelectionToDOM", ()=>syncSelectionToDOM);
var _utilsJs = require("../../utils/utils.js");
function syncSelectionToDOM(parameters) {
    const { focused, domGetters, stateResponse: { // States and derived states
    parsedSelectedSections, state } } = parameters;
    if (!domGetters.isReady()) return;
    const selection = document.getSelection();
    if (!selection) return;
    if (parsedSelectedSections == null) {
        // If the selection contains an element inside the field, we reset it.
        if (selection.rangeCount > 0 && domGetters.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
        if (focused) domGetters.getRoot().blur();
        return;
    }
    // On multi input range pickers we want to update selection range only for the active input
    if (!domGetters.getRoot().contains((0, _utilsJs.getActiveElement)(document))) return;
    const range = new window.Range();
    let target;
    if (parsedSelectedSections === 'all') target = domGetters.getRoot();
    else {
        const section = state.sections[parsedSelectedSections];
        if (section.type === 'empty') target = domGetters.getSectionContainer(parsedSelectedSections);
        else target = domGetters.getSectionContent(parsedSelectedSections);
    }
    range.selectNodeContents(target);
    target.focus();
    selection.removeAllRanges();
    selection.addRange(range);
}

},{"../../utils/utils.js":"k4iiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"39MF8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generate the props to pass to the root element of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the root element of the field.
 */ parcelHelpers.export(exports, "useFieldRootProps", ()=>useFieldRootProps);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _useFieldRootHandleKeyDownJs = require("./useFieldRootHandleKeyDown.js");
var _utilsJs = require("../../utils/utils.js");
var _syncSelectionToDOMJs = require("./syncSelectionToDOM.js");
function useFieldRootProps(parameters) {
    const { manager, focused, setFocused, domGetters, stateResponse, applyCharacterEditing, internalPropsWithDefaults, stateResponse: { // States and derived states
    parsedSelectedSections, sectionOrder, state, // Methods to update the states
    clearValue, setCharacterQuery, setSelectedSections, updateValueFromValueStr }, internalPropsWithDefaults: { disabled = false, readOnly = false } } = parameters;
    // TODO: Inline onContainerKeyDown once the old DOM structure is removed
    const handleKeyDown = (0, _useFieldRootHandleKeyDownJs.useFieldRootHandleKeyDown)({
        manager,
        internalPropsWithDefaults,
        stateResponse
    });
    const containerClickTimeout = (0, _useTimeoutDefault.default)();
    const handleClick = (0, _useEventCallbackDefault.default)((event)=>{
        if (disabled || !domGetters.isReady()) return;
        setFocused(true);
        if (parsedSelectedSections === 'all') containerClickTimeout.start(0, ()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = domGetters.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleInput = (0, _useEventCallbackDefault.default)((event)=>{
        if (!domGetters.isReady() || parsedSelectedSections !== 'all') return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        domGetters.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        (0, _syncSelectionToDOMJs.syncSelectionToDOM)({
            focused,
            domGetters,
            stateResponse
        });
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else {
            if (parsedSelectedSections === 'all') setSelectedSections(0);
            applyCharacterEditing({
                keyPressed,
                sectionIndex: 0
            });
        }
    });
    const handlePaste = (0, _useEventCallbackDefault.default)((event)=>{
        if (readOnly || parsedSelectedSections !== 'all') {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleFocus = (0, _useEventCallbackDefault.default)(()=>{
        if (focused || disabled || !domGetters.isReady()) return;
        const activeElement = (0, _utilsJs.getActiveElement)(document);
        setFocused(true);
        const isFocusInsideASection = domGetters.getSectionIndexFromDOMElement(activeElement) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleBlur = (0, _useEventCallbackDefault.default)(()=>{
        setTimeout(()=>{
            if (!domGetters.isReady()) return;
            const activeElement = (0, _utilsJs.getActiveElement)(document);
            const shouldBlur = !domGetters.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    return {
        // Event handlers
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onClick: handleClick,
        onPaste: handlePaste,
        onInput: handleInput,
        // Other
        contentEditable: parsedSelectedSections === 'all',
        tabIndex: parsedSelectedSections === 0 ? -1 : 0 // TODO: Try to set to undefined when there is a section selected.
    };
}

},{"@mui/utils/useEventCallback":"feNJe","@mui/utils/useTimeout":"k3sgs","./useFieldRootHandleKeyDown.js":"8YGNf","../../utils/utils.js":"k4iiH","./syncSelectionToDOM.js":"7JKKV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8YGNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the `onKeyDown` handler to pass to the root element of the field.
 */ parcelHelpers.export(exports, "useFieldRootHandleKeyDown", ()=>useFieldRootHandleKeyDown);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useUtilsJs = require("../useUtils.js");
var _useFieldUtilsJs = require("./useField.utils.js");
function useFieldRootHandleKeyDown(parameters) {
    const utils = (0, _useUtilsJs.useUtils)();
    const { manager: { internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: { minutesStep, disabled, readOnly }, stateResponse: { // States and derived states
    state, value, activeSectionIndex, parsedSelectedSections, sectionsValueBoundaries, localizedDigits, timezone, sectionOrder, // Methods to update the states
    clearValue, clearActiveSection, setSelectedSections, updateSectionValue } } = parameters;
    return (0, _useEventCallbackDefault.default)((event)=>{
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'A' && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === 'all') clearValue();
                else clearActiveSection();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    // if all sections are selected, mark the currently editing one as selected
                    if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
                    const activeSection = state.sections[activeSectionIndex];
                    const newSectionValue = adjustSectionValue(utils, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, fieldValueManager.getDateFromSection(value, activeSection), {
                        minutesStep
                    });
                    updateSectionValue({
                        section: activeSection,
                        newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
}
function getDeltaFromKeyCode(keyCode) {
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
}
function adjustSectionValue(utils, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes) {
    const delta = getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>(0, _useFieldUtilsJs.cleanDigitSectionValue)(utils, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === 'minutes' && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        let newSectionValueNumber;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return utils.formatByString(utils.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        } else {
            const currentSectionValue = parseInt((0, _useFieldUtilsJs.removeLocalizedDigits)(section.value, localizedDigits), 10);
            newSectionValueNumber = currentSectionValue + delta * step;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = (0, _useFieldUtilsJs.getLetterEditingOptions)(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
}

},{"@mui/utils/useEventCallback":"feNJe","../useUtils.js":"dJQ8a","./useField.utils.js":"jBxFh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bVc7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generate the props to pass to the hidden input element of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldHiddenInputPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldHiddenInputPropsReturnValue} The props to forward to the hidden input element of the field.
 */ parcelHelpers.export(exports, "useFieldHiddenInputProps", ()=>useFieldHiddenInputProps);
var _react = require("react");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
function useFieldHiddenInputProps(parameters) {
    const { manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { // States and derived states
    areAllSectionsEmpty, state, // Methods to update the states
    updateValueFromValueStr } } = parameters;
    const handleChange = (0, _useEventCallbackDefault.default)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = _react.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    return {
        value: valueStr,
        onChange: handleChange
    };
}

},{"react":"9njXz","@mui/utils/useEventCallback":"feNJe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kDdnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generate the props to pass to the container element of each section of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the container element of each section of the field.
 */ parcelHelpers.export(exports, "useFieldSectionContainerProps", ()=>useFieldSectionContainerProps);
var _react = require("react");
function useFieldSectionContainerProps(parameters) {
    const { stateResponse: { // Methods to update the states
    setSelectedSections }, internalPropsWithDefaults: { disabled = false } } = parameters;
    const createHandleClick = _react.useCallback((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (disabled || event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return _react.useCallback((sectionIndex)=>({
            'data-sectionindex': sectionIndex,
            onClick: createHandleClick(sectionIndex)
        }), [
        createHandleClick
    ]);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ks20r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generate the props to pass to the content element of each section of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the content element of each section of the field.
 */ parcelHelpers.export(exports, "useFieldSectionContentProps", ()=>useFieldSectionContentProps);
var _react = require("react");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _useUtilsJs = require("../useUtils.js");
var _indexJs = require("../../../hooks/index.js");
var _syncSelectionToDOMJs = require("./syncSelectionToDOM.js");
function useFieldSectionContentProps(parameters) {
    const utils = (0, _useUtilsJs.useUtils)();
    const translations = (0, _indexJs.usePickerTranslations)();
    const id = (0, _useIdDefault.default)();
    const { focused, domGetters, stateResponse, applyCharacterEditing, manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { // States and derived states
    parsedSelectedSections, sectionsValueBoundaries, state, value, // Methods to update the states
    clearActiveSection, setCharacterQuery, setSelectedSections, updateSectionValue, updateValueFromValueStr }, internalPropsWithDefaults: { disabled = false, readOnly = false } } = parameters;
    const isContainerEditable = parsedSelectedSections === 'all';
    const isEditable = !isContainerEditable && !disabled && !readOnly;
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, _useEventCallbackDefault.default)((sectionIndex)=>{
        if (!domGetters.isReady()) return;
        const section = state.sections[sectionIndex];
        domGetters.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        (0, _syncSelectionToDOMJs.syncSelectionToDOM)({
            focused,
            domGetters,
            stateResponse
        });
    });
    const handleInput = (0, _useEventCallbackDefault.default)((event)=>{
        if (!domGetters.isReady()) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        const sectionIndex = domGetters.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === '') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === 'insertParagraph' || inputType === 'insertLineBreak') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            revertDOMSectionChange(sectionIndex);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed,
            sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    const handleMouseUp = (0, _useEventCallbackDefault.default)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handlePaste = (0, _useEventCallbackDefault.default)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== 'number') return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
        if (isValidPastedValue) {
            setCharacterQuery(null);
            updateSectionValue({
                section: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            setCharacterQuery(null);
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleDragOver = (0, _useEventCallbackDefault.default)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const createFocusHandler = _react.useCallback((sectionIndex)=>()=>{
            if (disabled) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return _react.useCallback((section, sectionIndex)=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: fieldValueManager.getDateFromSection(value, section),
            contentType: section.contentType,
            format: section.format
        });
        return {
            // Event handlers
            onInput: handleInput,
            onPaste: handlePaste,
            onMouseUp: handleMouseUp,
            onDragOver: handleDragOver,
            onFocus: createFocusHandler(sectionIndex),
            // Aria attributes
            'aria-labelledby': `${id}-${section.type}`,
            'aria-readonly': readOnly,
            'aria-valuenow': getSectionValueNow(section, utils),
            'aria-valuemin': sectionBoundaries.minimum,
            'aria-valuemax': sectionBoundaries.maximum,
            'aria-valuetext': section.value ? getSectionValueText(section, utils) : translations.empty,
            'aria-label': translations[section.type],
            'aria-disabled': disabled,
            // Other
            tabIndex: isContainerEditable || sectionIndex > 0 ? -1 : 0,
            contentEditable: !isContainerEditable && !disabled && !readOnly,
            role: 'spinbutton',
            id: `${id}-${section.type}`,
            'data-range-position': section.dateName || undefined,
            spellCheck: isEditable ? false : undefined,
            autoCapitalize: isEditable ? 'off' : undefined,
            autoCorrect: isEditable ? 'off' : undefined,
            children: section.value || section.placeholder,
            inputMode: section.contentType === 'letter' ? 'text' : 'numeric'
        };
    }, [
        sectionsValueBoundaries,
        id,
        isContainerEditable,
        disabled,
        readOnly,
        isEditable,
        translations,
        utils,
        handleInput,
        handlePaste,
        handleMouseUp,
        handleDragOver,
        createFocusHandler,
        fieldValueManager,
        value
    ]);
}
function getSectionValueText(section, utils) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'month':
            {
                if (section.contentType === 'digit') return utils.format(utils.setMonth(utils.date(), Number(section.value) - 1), 'month');
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.format(parsedDate, 'month') : undefined;
            }
        case 'day':
            return section.contentType === 'digit' ? utils.format(utils.setDate(utils.startOfYear(utils.date()), Number(section.value)), 'dayOfMonthFull') : section.value;
        case 'weekDay':
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
}
function getSectionValueNow(section, utils) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'weekDay':
            if (section.contentType === 'letter') // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case 'meridiem':
            {
                const parsedDate = utils.parse(`01:00 ${section.value}`, `${utils.formats.hours12h}:${utils.formats.minutes} ${section.format}`);
                if (parsedDate) return utils.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case 'day':
            return section.contentType === 'digit-with-letter' ? parseInt(section.value, 10) : Number(section.value);
        case 'month':
            {
                if (section.contentType === 'digit') return Number(section.value);
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== 'letter' ? Number(section.value) : undefined;
    }
}

},{"react":"9njXz","@mui/utils/useEventCallback":"feNJe","@mui/utils/useId":"50qgI","../useUtils.js":"dJQ8a","../../../hooks/index.js":"a3BuB","./syncSelectionToDOM.js":"7JKKV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5f8Ud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPositionPropertiesToSections", ()=>addPositionPropertiesToSections);
parcelHelpers.export(exports, "useFieldV6TextField", ()=>useFieldV6TextField);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _rtlProvider = require("@mui/system/RtlProvider");
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _indexJs = require("../../../hooks/index.js");
var _utilsJs = require("../../utils/utils.js");
var _useFieldUtilsJs = require("./useField.utils.js");
var _useFieldCharacterEditingJs = require("./useFieldCharacterEditing.js");
var _useFieldRootHandleKeyDownJs = require("./useFieldRootHandleKeyDown.js");
var _useFieldStateJs = require("./useFieldState.js");
var _useFieldInternalPropsWithDefaultsJs = require("./useFieldInternalPropsWithDefaults.js");
const cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const addPositionPropertiesToSections = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, _useFieldUtilsJs.getSectionVisibleValue)(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === '' ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, _extendsDefault.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput,
            endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const useFieldV6TextField = (parameters)=>{
    const isRtl = (0, _rtlProvider.useRtl)();
    const focusTimeout = (0, _useTimeoutDefault.default)();
    const selectionSyncTimeout = (0, _useTimeoutDefault.default)();
    const { props, manager, skipContextFieldRefAssignment, manager: { valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps, forwardedProps } = (0, _indexJs.useSplitFieldProps)(props, valueType);
    const internalPropsWithDefaults = (0, _useFieldInternalPropsWithDefaultsJs.useFieldInternalPropsWithDefaults)({
        manager,
        internalProps,
        skipContextFieldRefAssignment
    });
    const { onFocus, onClick, onPaste, onBlur, onKeyDown, onClear, clearable, inputRef: inputRefProp, placeholder: inPlaceholder } = forwardedProps;
    const { readOnly = false, disabled = false, autoFocus = false, focused, unstableFieldRef } = internalPropsWithDefaults;
    const inputRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(inputRefProp, inputRef);
    const stateResponse = (0, _useFieldStateJs.useFieldState)({
        manager,
        internalPropsWithDefaults,
        forwardedProps
    });
    const { // States and derived states
    activeSectionIndex, areAllSectionsEmpty, error, localizedDigits, parsedSelectedSections, sectionOrder, state, value, // Methods to update the states
    clearValue, clearActiveSection, setCharacterQuery, setSelectedSections, setTempAndroidValueStr, updateSectionValue, updateValueFromValueStr, // Utilities methods
    getSectionsFromValue } = stateResponse;
    const applyCharacterEditing = (0, _useFieldCharacterEditingJs.useFieldCharacterEditing)({
        stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const sections = _react.useMemo(()=>addPositionPropertiesToSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    function syncSelectionFromDOM() {
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    }
    function focusField(newSelectedSection = 0) {
        if ((0, _utilsJs.getActiveElement)(document) === inputRef.current) return;
        inputRef.current?.focus();
        setSelectedSections(newSelectedSection);
    }
    const handleInputFocus = (0, _useEventCallbackDefault.default)((event)=>{
        onFocus?.(event);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        focusTimeout.start(0, ()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, _useEventCallbackDefault.default)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, _useEventCallbackDefault.default)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData('text');
        if (typeof parsedSelectedSections === 'number') {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                setCharacterQuery(null);
                updateSectionValue({
                    section: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, _useEventCallbackDefault.default)((event)=>{
        onBlur?.(event);
        setSelectedSections(null);
    });
    const handleInputChange = (0, _useEventCallbackDefault.default)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = cleanString(valueStr);
        if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === 'all' && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - cleanString(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, _useFieldUtilsJs.isAndroid)()) setTempAndroidValueStr(valueStr);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const handleClear = (0, _useEventCallbackDefault.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!isFieldFocused(inputRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerKeyDown = (0, _useFieldRootHandleKeyDownJs.useFieldRootHandleKeyDown)({
        manager,
        internalPropsWithDefaults,
        stateResponse
    });
    const wrappedHandleContainerKeyDown = (0, _useEventCallbackDefault.default)((event)=>{
        onKeyDown?.(event);
        handleContainerKeyDown(event);
    });
    const placeholder = _react.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = _react.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    _react.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, _utilsJs.getActiveElement)(document)) setSelectedSections('all');
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, _useEnhancedEffectDefault.default)(()=>{
        function syncSelectionToDOM() {
            if (!inputRef.current) return;
            if (parsedSelectedSections == null) {
                if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                // setting selection range to 0 causes issues in Safari.
                // https://bugs.webkit.org/show_bug.cgi?id=224425
                inputRef.current.scrollLeft = 0;
                return;
            }
            // On multi input range pickers we want to update selection range only for the active input
            // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current !== (0, _utilsJs.getActiveElement)(document)) return;
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            if (parsedSelectedSections === 'all') inputRef.current.select();
            else {
                const selectedSection = sections[parsedSelectedSections];
                const selectionStart = selectedSection.type === 'empty' ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                const selectionEnd = selectedSection.type === 'empty' ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                    if (inputRef.current === (0, _utilsJs.getActiveElement)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                }
                selectionSyncTimeout.start(0, ()=>{
                    // handle case when the selection is not updated correctly
                    // could happen on Android
                    if (inputRef.current && inputRef.current === (0, _utilsJs.getActiveElement)(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
                    // https://github.com/mui/mui-x/pull/13652
                    inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) syncSelectionToDOM();
                });
            }
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
        syncSelectionToDOM();
    });
    const inputMode = _react.useMemo(()=>{
        if (activeSectionIndex == null) return 'text';
        if (state.sections[activeSectionIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, _utilsJs.getActiveElement)(document);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    _react.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            focusField,
            isFieldFocused: ()=>isFieldFocused(inputRef)
        }));
    return (0, _extendsDefault.default)({}, forwardedProps, {
        error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        onBlur: handleContainerBlur,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onPaste: handleInputPaste,
        onKeyDown: wrappedHandleContainerKeyDown,
        onClear: handleClear,
        inputRef: handleRef,
        // Additional
        enableAccessibleFieldDOMStructure: false,
        placeholder,
        inputMode,
        autoComplete: 'off',
        value: shouldShowPlaceholder ? '' : valueStr,
        onChange: handleInputChange,
        focused,
        disabled,
        readOnly,
        autoFocus,
        openPickerAriaLabel
    });
};
function isFieldFocused(inputRef) {
    return inputRef.current === (0, _utilsJs.getActiveElement)(document);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/system/RtlProvider":"ck9Pb","@mui/utils/useEnhancedEffect":"fIvqa","@mui/utils/useEventCallback":"feNJe","@mui/utils/useTimeout":"k3sgs","@mui/utils/useForkRef":"4xKTx","../../../hooks/index.js":"a3BuB","../../utils/utils.js":"k4iiH","./useField.utils.js":"jBxFh","./useFieldCharacterEditing.js":"dyBHh","./useFieldRootHandleKeyDown.js":"8YGNf","./useFieldState.js":"g8jQp","./useFieldInternalPropsWithDefaults.js":"lew7h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6sU7F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDateManager", ()=>(0, _useDateManagerJs.useDateManager));
parcelHelpers.export(exports, "useTimeManager", ()=>(0, _useTimeManagerJs.useTimeManager));
parcelHelpers.export(exports, "useDateTimeManager", ()=>(0, _useDateTimeManagerJs.useDateTimeManager));
var _useDateManagerJs = require("./useDateManager.js");
var _useTimeManagerJs = require("./useTimeManager.js");
var _useDateTimeManagerJs = require("./useDateTimeManager.js");

},{"./useDateManager.js":"jZ2tS","./useTimeManager.js":false,"./useDateTimeManager.js":"iOnPY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jZ2tS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDateManager", ()=>useDateManager);
parcelHelpers.export(exports, "useApplyDefaultValuesToDateValidationProps", ()=>useApplyDefaultValuesToDateValidationProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _indexJs = require("../validation/index.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
'use client';
function useDateManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure = true } = parameters;
    return _react.useMemo(()=>({
            valueType: 'date',
            validator: (0, _indexJs.validateDate),
            internal_valueManager: (0, _valueManagersJs.singleItemValueManager),
            internal_fieldValueManager: (0, _valueManagersJs.singleItemFieldValueManager),
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToDateFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function useOpenPickerButtonAriaLabel(value) {
    const utils = (0, _useUtilsJs.useUtils)();
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    return _react.useMemo(()=>{
        const formattedValue = utils.isValid(value) ? utils.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        utils
    ]);
}
function useApplyDefaultValuesToDateFieldInternalProps(internalProps) {
    const utils = (0, _useUtilsJs.useUtils)();
    const validationProps = useApplyDefaultValuesToDateValidationProps(internalProps);
    return _react.useMemo(()=>(0, _extendsDefault.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? utils.formats.keyboardDate
        }), [
        internalProps,
        validationProps,
        utils
    ]);
}
function useApplyDefaultValuesToDateValidationProps(props) {
    const utils = (0, _useUtilsJs.useUtils)();
    const defaultDates = (0, _useUtilsJs.useDefaultDates)();
    return _react.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            minDate: (0, _dateUtilsJs.applyDefaultDate)(utils, props.minDate, defaultDates.minDate),
            maxDate: (0, _dateUtilsJs.applyDefaultDate)(utils, props.maxDate, defaultDates.maxDate)
        }), [
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        utils,
        defaultDates
    ]);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../internals/utils/date-utils.js":"jrk9G","../internals/utils/valueManagers.js":"bimTj","../validation/index.js":"973pf","../internals/hooks/useUtils.js":"dJQ8a","../hooks/usePickerTranslations.js":"3Zb4l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iOnPY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDateTimeManager", ()=>useDateTimeManager);
parcelHelpers.export(exports, "useApplyDefaultValuesToDateTimeValidationProps", ()=>useApplyDefaultValuesToDateTimeValidationProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _indexJs = require("../validation/index.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
'use client';
function useDateTimeManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure = true } = parameters;
    return _react.useMemo(()=>({
            valueType: 'date-time',
            validator: (0, _indexJs.validateDateTime),
            internal_valueManager: (0, _valueManagersJs.singleItemValueManager),
            internal_fieldValueManager: (0, _valueManagersJs.singleItemFieldValueManager),
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToDateTimeFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function useOpenPickerButtonAriaLabel(value) {
    const utils = (0, _useUtilsJs.useUtils)();
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    return _react.useMemo(()=>{
        const formattedValue = utils.isValid(value) ? utils.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        utils
    ]);
}
function useApplyDefaultValuesToDateTimeFieldInternalProps(internalProps) {
    const utils = (0, _useUtilsJs.useUtils)();
    const validationProps = useApplyDefaultValuesToDateTimeValidationProps(internalProps);
    const ampm = _react.useMemo(()=>internalProps.ampm ?? utils.is12HourCycleInCurrentLocale(), [
        internalProps.ampm,
        utils
    ]);
    return _react.useMemo(()=>(0, _extendsDefault.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? (ampm ? utils.formats.keyboardDateTime12h : utils.formats.keyboardDateTime24h)
        }), [
        internalProps,
        validationProps,
        ampm,
        utils
    ]);
}
function useApplyDefaultValuesToDateTimeValidationProps(props) {
    const utils = (0, _useUtilsJs.useUtils)();
    const defaultDates = (0, _useUtilsJs.useDefaultDates)();
    return _react.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            // TODO: Explore if we can remove it from the public API
            disableIgnoringDatePartForTimeValidation: !!props.minDateTime || !!props.maxDateTime || !!props.disableFuture || !!props.disablePast,
            minDate: (0, _dateUtilsJs.applyDefaultDate)(utils, props.minDateTime ?? props.minDate, defaultDates.minDate),
            maxDate: (0, _dateUtilsJs.applyDefaultDate)(utils, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
            minTime: props.minDateTime ?? props.minTime,
            maxTime: props.maxDateTime ?? props.maxTime
        }), [
        props.minDateTime,
        props.maxDateTime,
        props.minTime,
        props.maxTime,
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        utils,
        defaultDates
    ]);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../internals/utils/date-utils.js":"jrk9G","../internals/utils/valueManagers.js":"bimTj","../validation/index.js":"973pf","../internals/hooks/useUtils.js":"dJQ8a","../hooks/usePickerTranslations.js":"3Zb4l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cxHPG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanFieldResponse", ()=>cleanFieldResponse);
parcelHelpers.export(exports, "PickerFieldUIContext", ()=>PickerFieldUIContext);
parcelHelpers.export(exports, "PickerFieldUI", ()=>PickerFieldUI);
parcelHelpers.export(exports, "mergeSlotProps", ()=>mergeSlotProps);
/**
 * The `textField` slot props cannot be handled inside `PickerFieldUI` because it would be a breaking change to not pass the enriched props to `useField`.
 * Once the non-accessible DOM structure will be removed, we will be able to remove the `textField` slot and clean this logic.
 */ parcelHelpers.export(exports, "useFieldTextFieldProps", ()=>useFieldTextFieldProps);
parcelHelpers.export(exports, "PickerFieldUIContextProvider", ()=>PickerFieldUIContextProvider);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _resolveComponentProps = require("@mui/utils/resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _useFieldOwnerStateJs = require("../hooks/useFieldOwnerState.js");
var _indexJs = require("../../hooks/index.js");
var _indexJs1 = require("../../icons/index.js");
var _useNullablePickerContextJs = require("../hooks/useNullablePickerContext.js");
var _indexJs2 = require("../../PickersTextField/index.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "enableAccessibleFieldDOMStructure"
], _excluded2 = [
    "InputProps",
    "readOnly",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], _excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], _excluded4 = [
    "ownerState"
], _excluded5 = [
    "ownerState"
], _excluded6 = [
    "ownerState"
], _excluded7 = [
    "ownerState"
], _excluded8 = [
    "InputProps",
    "inputProps"
];
const cleanFieldResponse = (_ref)=>{
    let { enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps, readOnly, onClear, clearable, clearButtonPosition, openPickerButtonPosition, openPickerAriaLabel } = fieldResponse, other = (0, _objectWithoutPropertiesLooseDefault.default)(fieldResponse, _excluded2);
        return {
            clearable,
            onClear,
            clearButtonPosition,
            openPickerButtonPosition,
            openPickerAriaLabel,
            textFieldProps: (0, _extendsDefault.default)({}, other, {
                InputProps: (0, _extendsDefault.default)({}, InputProps ?? {}, {
                    readOnly
                })
            })
        };
    }
    const { onPaste, onKeyDown, inputMode, readOnly, InputProps, inputProps, inputRef, onClear, clearable, clearButtonPosition, openPickerButtonPosition, openPickerAriaLabel } = fieldResponse, other = (0, _objectWithoutPropertiesLooseDefault.default)(fieldResponse, _excluded3);
    return {
        clearable,
        onClear,
        clearButtonPosition,
        openPickerButtonPosition,
        openPickerAriaLabel,
        textFieldProps: (0, _extendsDefault.default)({}, other, {
            InputProps: (0, _extendsDefault.default)({}, InputProps ?? {}, {
                readOnly
            }),
            inputProps: (0, _extendsDefault.default)({}, inputProps ?? {}, {
                inputMode,
                onPaste,
                onKeyDown,
                ref: inputRef
            })
        })
    };
};
const PickerFieldUIContext = /*#__PURE__*/ _react.createContext({
    slots: {},
    slotProps: {},
    inputRef: undefined
});
function PickerFieldUI(props) {
    const { slots, slotProps, fieldResponse, defaultOpenPickerIcon } = props;
    const translations = (0, _indexJs.usePickerTranslations)();
    const pickerContext = (0, _useNullablePickerContextJs.useNullablePickerContext)();
    const pickerFieldUIContext = _react.useContext(PickerFieldUIContext);
    const { textFieldProps, onClear, clearable, openPickerAriaLabel, clearButtonPosition: clearButtonPositionProp = 'end', openPickerButtonPosition: openPickerButtonPositionProp = 'end' } = cleanFieldResponse(fieldResponse);
    const ownerState = (0, _useFieldOwnerStateJs.useFieldOwnerState)(textFieldProps);
    const handleClickOpeningButton = (0, _useEventCallbackDefault.default)((event)=>{
        event.preventDefault();
        pickerContext?.setOpen((prev)=>!prev);
    });
    const triggerStatus = pickerContext ? pickerContext.triggerStatus : 'hidden';
    const clearButtonPosition = clearable ? clearButtonPositionProp : null;
    const openPickerButtonPosition = triggerStatus !== 'hidden' ? openPickerButtonPositionProp : null;
    const TextField = slots?.textField ?? pickerFieldUIContext.slots.textField ?? (fieldResponse.enableAccessibleFieldDOMStructure === false ? (0, _textFieldDefault.default) : (0, _indexJs2.PickersTextField));
    const InputAdornment = slots?.inputAdornment ?? pickerFieldUIContext.slots.inputAdornment ?? (0, _inputAdornmentDefault.default);
    const _useSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: InputAdornment,
        externalSlotProps: mergeSlotProps(pickerFieldUIContext.slotProps.inputAdornment, slotProps?.inputAdornment),
        additionalProps: {
            position: 'start'
        },
        ownerState: (0, _extendsDefault.default)({}, ownerState, {
            position: 'start'
        })
    }), startInputAdornmentProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded4);
    const _useSlotProps2 = (0, _useSlotPropsDefault.default)({
        elementType: InputAdornment,
        externalSlotProps: slotProps?.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: (0, _extendsDefault.default)({}, ownerState, {
            position: 'end'
        })
    }), endInputAdornmentProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps2, _excluded5);
    const OpenPickerButton = pickerFieldUIContext.slots.openPickerButton ?? (0, _iconButtonDefault.default);
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps3 = (0, _useSlotPropsDefault.default)({
        elementType: OpenPickerButton,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerButton,
        additionalProps: {
            disabled: triggerStatus === 'disabled',
            onClick: handleClickOpeningButton,
            'aria-label': openPickerAriaLabel,
            edge: // open button is always rendered at the edge
            textFieldProps.variant !== 'standard' ? openPickerButtonPosition : false
        },
        ownerState
    }), openPickerButtonProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps3, _excluded6);
    const OpenPickerIcon = pickerFieldUIContext.slots.openPickerIcon ?? defaultOpenPickerIcon;
    const openPickerIconProps = (0, _useSlotPropsDefault.default)({
        elementType: OpenPickerIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerIcon,
        ownerState
    });
    const ClearButton = slots?.clearButton ?? pickerFieldUIContext.slots.clearButton ?? (0, _iconButtonDefault.default);
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps4 = (0, _useSlotPropsDefault.default)({
        elementType: ClearButton,
        externalSlotProps: mergeSlotProps(pickerFieldUIContext.slotProps.clearButton, slotProps?.clearButton),
        className: 'clearButton',
        additionalProps: {
            title: translations.fieldClearLabel,
            tabIndex: -1,
            onClick: onClear,
            disabled: fieldResponse.disabled || fieldResponse.readOnly,
            edge: // clear button can only be at the edge if it's position differs from the open button
            textFieldProps.variant !== 'standard' && clearButtonPosition !== openPickerButtonPosition ? clearButtonPosition : false
        },
        ownerState
    }), clearButtonProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps4, _excluded7);
    const ClearIcon = slots?.clearIcon ?? pickerFieldUIContext.slots.clearIcon ?? (0, _indexJs1.ClearIcon);
    const clearIconProps = (0, _useSlotPropsDefault.default)({
        elementType: ClearIcon,
        externalSlotProps: mergeSlotProps(pickerFieldUIContext.slotProps.clearIcon, slotProps?.clearIcon),
        additionalProps: {
            fontSize: 'small'
        },
        ownerState
    });
    textFieldProps.ref = (0, _useForkRefDefault.default)(textFieldProps.ref, pickerContext?.rootRef);
    if (!textFieldProps.InputProps) textFieldProps.InputProps = {};
    if (pickerContext) textFieldProps.InputProps.ref = pickerContext.triggerRef;
    if (!textFieldProps.InputProps?.startAdornment && (clearButtonPosition === 'start' || openPickerButtonPosition === 'start')) textFieldProps.InputProps.startAdornment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InputAdornment, (0, _extendsDefault.default)({}, startInputAdornmentProps, {
        children: [
            openPickerButtonPosition === 'start' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpenPickerButton, (0, _extendsDefault.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpenPickerIcon, (0, _extendsDefault.default)({}, openPickerIconProps))
            })),
            clearButtonPosition === 'start' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearButton, (0, _extendsDefault.default)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearIcon, (0, _extendsDefault.default)({}, clearIconProps))
            }))
        ]
    }));
    if (!textFieldProps.InputProps?.endAdornment && (clearButtonPosition === 'end' || openPickerButtonPosition === 'end')) textFieldProps.InputProps.endAdornment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InputAdornment, (0, _extendsDefault.default)({}, endInputAdornmentProps, {
        children: [
            clearButtonPosition === 'end' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearButton, (0, _extendsDefault.default)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearIcon, (0, _extendsDefault.default)({}, clearIconProps))
            })),
            openPickerButtonPosition === 'end' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpenPickerButton, (0, _extendsDefault.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpenPickerIcon, (0, _extendsDefault.default)({}, openPickerIconProps))
            }))
        ]
    }));
    if (clearButtonPosition != null) textFieldProps.sx = [
        {
            '& .clearButton': {
                opacity: 1
            },
            '@media (pointer: fine)': {
                '& .clearButton': {
                    opacity: 0
                },
                '&:hover, &:focus-within': {
                    '.clearButton': {
                        opacity: 1
                    }
                }
            }
        },
        ...Array.isArray(textFieldProps.sx) ? textFieldProps.sx : [
            textFieldProps.sx
        ]
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextField, (0, _extendsDefault.default)({}, textFieldProps));
}
function mergeSlotProps(slotPropsA, slotPropsB) {
    if (!slotPropsA) return slotPropsB;
    if (!slotPropsB) return slotPropsA;
    return (ownerState)=>{
        return (0, _extendsDefault.default)({}, (0, _resolveComponentPropsDefault.default)(slotPropsB, ownerState), (0, _resolveComponentPropsDefault.default)(slotPropsA, ownerState));
    };
}
function useFieldTextFieldProps(parameters) {
    const { ref, externalForwardedProps, slotProps } = parameters;
    const pickerFieldUIContext = _react.useContext(PickerFieldUIContext);
    const pickerContext = (0, _useNullablePickerContextJs.useNullablePickerContext)();
    const ownerState = (0, _useFieldOwnerStateJs.useFieldOwnerState)(externalForwardedProps);
    const { InputProps, inputProps } = externalForwardedProps, otherExternalForwardedProps = (0, _objectWithoutPropertiesLooseDefault.default)(externalForwardedProps, _excluded8);
    const textFieldProps = (0, _useSlotPropsDefault.default)({
        elementType: (0, _indexJs2.PickersTextField),
        externalSlotProps: mergeSlotProps(pickerFieldUIContext.slotProps.textField, slotProps?.textField),
        externalForwardedProps: otherExternalForwardedProps,
        additionalProps: {
            ref,
            sx: pickerContext?.rootSx,
            label: pickerContext?.label,
            name: pickerContext?.name,
            className: pickerContext?.rootClassName,
            inputRef: pickerFieldUIContext.inputRef
        },
        ownerState
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, _extendsDefault.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, _extendsDefault.default)({}, InputProps, textFieldProps.InputProps);
    return textFieldProps;
}
function PickerFieldUIContextProvider(props) {
    const { slots = {}, slotProps = {}, inputRef, children } = props;
    const contextValue = _react.useMemo(()=>({
            inputRef,
            slots: {
                openPickerButton: slots.openPickerButton,
                openPickerIcon: slots.openPickerIcon,
                textField: slots.textField,
                inputAdornment: slots.inputAdornment,
                clearIcon: slots.clearIcon,
                clearButton: slots.clearButton
            },
            slotProps: {
                openPickerButton: slotProps.openPickerButton,
                openPickerIcon: slotProps.openPickerIcon,
                textField: slotProps.textField,
                inputAdornment: slotProps.inputAdornment,
                clearIcon: slotProps.clearIcon,
                clearButton: slotProps.clearButton
            }
        }), [
        inputRef,
        slots.openPickerButton,
        slots.openPickerIcon,
        slots.textField,
        slots.inputAdornment,
        slots.clearIcon,
        slots.clearButton,
        slotProps.openPickerButton,
        slotProps.openPickerIcon,
        slotProps.textField,
        slotProps.inputAdornment,
        slotProps.clearIcon,
        slotProps.clearButton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerFieldUIContext.Provider, {
        value: contextValue,
        children: children
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","@mui/utils/useEventCallback":"feNJe","@mui/utils/useForkRef":"4xKTx","@mui/utils/resolveComponentProps":"gGfhx","@mui/material/TextField":"amnzu","@mui/material/IconButton":"bXjnZ","@mui/material/InputAdornment":"jiJDh","@mui/utils/useSlotProps":"kr4RG","../hooks/useFieldOwnerState.js":"2guyG","../../hooks/index.js":"a3BuB","../../icons/index.js":"8RbJX","../hooks/useNullablePickerContext.js":"aFzJC","../../PickersTextField/index.js":"h8KWZ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"amnzu":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("4c02f4f3cb75a0c2").default;
var _interopRequireDefault = require("eb4fe52a999b630").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    textFieldClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TextField.default;
    }
});
Object.defineProperty(exports, "textFieldClasses", {
    enumerable: true,
    get: function() {
        return _textFieldClasses.default;
    }
});
var _TextField = _interopRequireDefault(require("16ee36e5e2b76e60"));
var _textFieldClasses = _interopRequireWildcard(require("cc0da13d8dab45b5"));
Object.keys(_textFieldClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _textFieldClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _textFieldClasses[key];
        }
    });
});

},{"4c02f4f3cb75a0c2":"fiRIh","eb4fe52a999b630":"kZ6eK","16ee36e5e2b76e60":"iJGzx","cc0da13d8dab45b5":"cVE4u"}],"iJGzx":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("41bd205dbbbf0737").default;
var _interopRequireWildcard = require("12137971a868c93f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("4c23740f93c5da9c"));
var _propTypes = _interopRequireDefault(require("8f62b02b611af11c"));
var _clsx = _interopRequireDefault(require("914a9079efb19a80"));
var _composeClasses = _interopRequireDefault(require("2460a9fa9cc7e867"));
var _useId = _interopRequireDefault(require("a0622eb50ebca443"));
var _refType = _interopRequireDefault(require("e52cce72937857be"));
var _zeroStyled = require("2dfef62995528194");
var _DefaultPropsProvider = require("400508f6e444c4b");
var _Input = _interopRequireDefault(require("e88e3283fb99aecf"));
var _FilledInput = _interopRequireDefault(require("ac3aba2078e18122"));
var _OutlinedInput = _interopRequireDefault(require("8734fc9a19e3f5e3"));
var _InputLabel = _interopRequireDefault(require("3aeef808a1aa390"));
var _FormControl = _interopRequireDefault(require("fb4a54f9a54b3338"));
var _FormHelperText = _interopRequireDefault(require("64f2a8c8764c516d"));
var _Select = _interopRequireDefault(require("a49c88f47083f481"));
var _textFieldClasses = require("1c5ffb7e4ff23ca0");
var _useSlot = _interopRequireDefault(require("89f4fc325f93bafd"));
var _jsxRuntime = require("4f376df8b9556cf0");
const variantComponent = {
    standard: _Input.default,
    filled: _FilledInput.default,
    outlined: _OutlinedInput.default
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _textFieldClasses.getTextFieldUtilityClass, classes);
};
const TextFieldRoot = (0, _zeroStyled.styled)(_FormControl.default, {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const TextField = /*#__PURE__*/ React.forwardRef(function TextField(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete, autoFocus = false, children, className, color = 'primary', defaultValue, disabled = false, error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth = false, helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef, label, maxRows, minRows, multiline = false, name, onBlur, onChange, onFocus, placeholder, required = false, rows, select = false, SelectProps: SelectPropsProp, slots = {}, slotProps = {}, type, value, variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus,
        color,
        disabled,
        error,
        fullWidth,
        multiline,
        required,
        select,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const id = (0, _useId.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = variantComponent[variant];
    const externalForwardedProps = {
        slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        elementType: TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref,
        additionalProps: {
            disabled,
            error,
            fullWidth,
            required,
            color,
            variant
        }
    });
    const [InputSlot, inputProps] = (0, _useSlot.default)('input', {
        elementType: InputComponent,
        externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, _useSlot.default)('inputLabel', {
        elementType: _InputLabel.default,
        externalForwardedProps,
        ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, _useSlot.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps,
        ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, _useSlot.default)('formHelperText', {
        elementType: _FormHelperText.default,
        externalForwardedProps,
        ownerState
    });
    const [SelectSlot, selectProps] = (0, _useSlot.default)('select', {
        elementType: _Select.default,
        externalForwardedProps,
        ownerState
    });
    const InputElement = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var _default = exports.default = TextField;

},{"41bd205dbbbf0737":"kZ6eK","12137971a868c93f":"fiRIh","4c23740f93c5da9c":"9njXz","8f62b02b611af11c":"bnNSm","914a9079efb19a80":"d2NWs","2460a9fa9cc7e867":"59Equ","a0622eb50ebca443":"50qgI","e52cce72937857be":"3TBXN","2dfef62995528194":"89fxU","400508f6e444c4b":"ff3VX","e88e3283fb99aecf":"4s0JB","ac3aba2078e18122":"bo4qf","8734fc9a19e3f5e3":"8eUp2","3aeef808a1aa390":"iTW3B","fb4a54f9a54b3338":"kkska","64f2a8c8764c516d":"dlh9L","a49c88f47083f481":"aY7hn","1c5ffb7e4ff23ca0":"cVE4u","89f4fc325f93bafd":"29rI6","4f376df8b9556cf0":"1dlk8"}],"4s0JB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("fa0da2b3845fcf98").default;
var _interopRequireDefault = require("7bd8edfbf3e91d6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    inputClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Input.default;
    }
});
Object.defineProperty(exports, "inputClasses", {
    enumerable: true,
    get: function() {
        return _inputClasses.default;
    }
});
var _Input = _interopRequireDefault(require("503a5f57d2ab3fc0"));
var _inputClasses = _interopRequireWildcard(require("10960cfdcdd6a9d9"));
Object.keys(_inputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _inputClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _inputClasses[key];
        }
    });
});

},{"fa0da2b3845fcf98":"fiRIh","7bd8edfbf3e91d6":"kZ6eK","503a5f57d2ab3fc0":"cAJhD","10960cfdcdd6a9d9":"hyHMe"}],"cAJhD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("94e0b927b419d586").default;
var _interopRequireWildcard = require("d17b3710d0030274").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("936b3f55f915c41e"));
var _propTypes = _interopRequireDefault(require("a21c44bc961e3c45"));
var _composeClasses = _interopRequireDefault(require("437c806ed11fda49"));
var _deepmerge = _interopRequireDefault(require("c6ab98433824dcf4"));
var _refType = _interopRequireDefault(require("beacdd1904f6c4c0"));
var _InputBase = _interopRequireDefault(require("8190d2d3aaa013ae"));
var _rootShouldForwardProp = _interopRequireDefault(require("f3dc08e659b6286"));
var _zeroStyled = require("16de88518c69dd9b");
var _memoTheme = _interopRequireDefault(require("ed4503b48e7db253"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("262789cc37295fe4"));
var _DefaultPropsProvider = require("47a8b1daf837b6fe");
var _inputClasses = _interopRequireWildcard(require("24a281b4d56a3ccd"));
var _InputBase2 = require("5cbb77f2fdabc3ce");
var _jsxRuntime = require("d2ceeeefd604ec58");
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _inputClasses.getInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const InputRoot = (0, _zeroStyled.styled)(_InputBase2.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _InputBase2.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${_inputClasses.default.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${_inputClasses.default.error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${_inputClasses.default.disabled}, .${_inputClasses.default.error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${_inputClasses.default.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const InputInput = (0, _zeroStyled.styled)(_InputBase2.InputBaseInput, {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: _InputBase2.inputOverridesResolver
})({});
const Input = /*#__PURE__*/ React.forwardRef(function Input(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline = false, components = {}, componentsProps: componentsPropsProp, fullWidth = false, inputComponent = 'input', multiline = false, slotProps, slots = {}, type = 'text', ...other } = props;
    const classes = useUtilityClasses(props);
    const ownerState = {
        disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, _deepmerge.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? InputRoot;
    const InputSlot = slots.input ?? components.Input ?? InputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
Input.muiName = 'Input';
var _default = exports.default = Input;

},{"94e0b927b419d586":"kZ6eK","d17b3710d0030274":"fiRIh","936b3f55f915c41e":"9njXz","a21c44bc961e3c45":"bnNSm","437c806ed11fda49":"59Equ","c6ab98433824dcf4":"7wtTC","beacdd1904f6c4c0":"3TBXN","8190d2d3aaa013ae":"c1XNn","f3dc08e659b6286":"dIcrQ","16de88518c69dd9b":"89fxU","ed4503b48e7db253":"2zy52","262789cc37295fe4":"yHYvD","47a8b1daf837b6fe":"ff3VX","24a281b4d56a3ccd":"hyHMe","5cbb77f2fdabc3ce":"aTW7W","d2ceeeefd604ec58":"1dlk8"}],"c1XNn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7b0a4051b16cff18").default;
var _interopRequireDefault = require("d3c596438dfaad7a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    inputBaseClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _InputBase.default;
    }
});
Object.defineProperty(exports, "inputBaseClasses", {
    enumerable: true,
    get: function() {
        return _inputBaseClasses.default;
    }
});
var _InputBase = _interopRequireDefault(require("65ae712aa73158f6"));
var _inputBaseClasses = _interopRequireWildcard(require("c4020941ecd08f1b"));
Object.keys(_inputBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _inputBaseClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _inputBaseClasses[key];
        }
    });
});

},{"7b0a4051b16cff18":"fiRIh","d3c596438dfaad7a":"kZ6eK","65ae712aa73158f6":"aTW7W","c4020941ecd08f1b":"d0rpO"}],"aTW7W":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("139a8ab2136e9e13").default;
var _interopRequireWildcard = require("d84a3ac96dbbd3cb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rootOverridesResolver = exports.inputOverridesResolver = exports.default = exports.InputBaseRoot = exports.InputBaseInput = void 0;
var _formatMuiErrorMessage = _interopRequireDefault(require("9b247d4a85e1de1f"));
var React = _interopRequireWildcard(require("85c89b9d81402058"));
var _propTypes = _interopRequireDefault(require("7b5ec669f882d0a"));
var _clsx = _interopRequireDefault(require("5b8c8fd7a58c549e"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("be7afb7ed5010010"));
var _refType = _interopRequireDefault(require("2828a2c57638e1e6"));
var _composeClasses = _interopRequireDefault(require("26d30b4e3b3f4e1f"));
var _TextareaAutosize = _interopRequireDefault(require("fbc7a46726c8b135"));
var _isHostComponent = _interopRequireDefault(require("b123831d69a43533"));
var _formControlState = _interopRequireDefault(require("2c8d78326039bc98"));
var _FormControlContext = _interopRequireDefault(require("3e0678017bec5e25"));
var _useFormControl = _interopRequireDefault(require("e759dfb85bc3fddb"));
var _zeroStyled = require("6f808c453ba852b2");
var _memoTheme = _interopRequireDefault(require("9ecb474986898267"));
var _DefaultPropsProvider = require("a8b7e244306f5654");
var _capitalize = _interopRequireDefault(require("6c0679be321beb81"));
var _useForkRef = _interopRequireDefault(require("ee25c235ff9de6b1"));
var _useEnhancedEffect = _interopRequireDefault(require("1c2d710637347fbf"));
var _utils = require("83cb20c45597d190");
var _inputBaseClasses = _interopRequireWildcard(require("d1b637e48316b981"));
var _jsxRuntime = require("48625fe1b11badb9");
var _InputGlobalStyles;
const rootOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, _capitalize.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
exports.rootOverridesResolver = rootOverridesResolver;
const inputOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
exports.inputOverridesResolver = inputOverridesResolver;
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, error, endAdornment, focused, formControl, fullWidth, hiddenLabel, multiline, readOnly, size, startAdornment, type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalize.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, _capitalize.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, _composeClasses.default)(slots, _inputBaseClasses.getInputBaseUtilityClass, classes);
};
const InputBaseRoot = exports.InputBaseRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: rootOverridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${_inputBaseClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState, size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const InputBaseInput = exports.InputBaseInput = (0, _zeroStyled.styled)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: inputOverridesResolver
})((0, _memoTheme.default)(({ theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${_inputBaseClasses.default.formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${_inputBaseClasses.default.disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const InputGlobalStyles = (0, _zeroStyled.globalCss)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const InputBase = /*#__PURE__*/ React.forwardRef(function InputBase(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete, autoFocus, className, color, components = {}, componentsProps = {}, defaultValue, disabled, disableInjectingGlobalStyles, endAdornment, error, fullWidth = false, id, inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin, maxRows, minRows, multiline = false, name, onBlur, onChange, onClick, onFocus, onKeyDown, onKeyUp, placeholder, readOnly, renderSuffix, rows, size, slotProps = {}, slots = {}, startAdornment, type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = React.useRef(value != null);
    const inputRef = React.useRef();
    const handleInputRefWarning = React.useCallback((instance)=>{}, []);
    const handleInputRef = (0, _useForkRef.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = React.useState(false);
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    React.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = React.useCallback((obj)=>{
        if ((0, _utils.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, _useEnhancedEffect.default)(()=>{
        if (isControlled) checkDirty({
            value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, _formatMuiErrorMessage.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    React.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows,
            minRows,
            ...inputProps
        };
        InputComponent = _TextareaAutosize.default;
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    React.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        startAdornment,
        type
    };
    const classes = useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || InputBaseRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || InputBaseInput;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            (_InputGlobalStyles || (_InputGlobalStyles = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, _isHostComponent.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, _clsx.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormControlContext.default.Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, _isHostComponent.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, _clsx.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var _default = exports.default = InputBase;

},{"139a8ab2136e9e13":"kZ6eK","d84a3ac96dbbd3cb":"fiRIh","9b247d4a85e1de1f":"gOgzd","85c89b9d81402058":"9njXz","7b5ec669f882d0a":"bnNSm","5b8c8fd7a58c549e":"d2NWs","be7afb7ed5010010":"40NoV","2828a2c57638e1e6":"3TBXN","26d30b4e3b3f4e1f":"59Equ","fbc7a46726c8b135":"9RmQq","b123831d69a43533":"iMS0l","2c8d78326039bc98":"lhkcI","3e0678017bec5e25":"lcpxD","e759dfb85bc3fddb":"H1I5Z","6f808c453ba852b2":"89fxU","9ecb474986898267":"2zy52","a8b7e244306f5654":"ff3VX","6c0679be321beb81":"hBZko","ee25c235ff9de6b1":"cq8Sn","1c2d710637347fbf":"hXusa","83cb20c45597d190":"ukWip","d1b637e48316b981":"d0rpO","48625fe1b11badb9":"1dlk8"}],"9RmQq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1a4b6ca1c8c17ca9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TextareaAutosize.default;
    }
});
var _TextareaAutosize = _interopRequireDefault(require("1c918738cf2f4a23"));

},{"1a4b6ca1c8c17ca9":"kZ6eK","1c918738cf2f4a23":"kpeK4"}],"kpeK4":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("671baff553aa964f").default;
var _interopRequireWildcard = require("17d9e3b5117d3c63").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("2f5a417e39778d5e"));
var _propTypes = _interopRequireDefault(require("1c38f4efc1995f7f"));
var _debounce = _interopRequireDefault(require("26247ff2b4258e48"));
var _useForkRef = _interopRequireDefault(require("980d51af9be2cb02"));
var _useEnhancedEffect = _interopRequireDefault(require("4749cd82e60bdba6"));
var _useEventCallback = _interopRequireDefault(require("72751643c33d7cea"));
var _ownerWindow = _interopRequireDefault(require("ba78e781099409a1"));
var _jsxRuntime = require("ef4b121b168dbc9b");
function getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function isEmpty(obj) {
    return isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const TextareaAutosize = /*#__PURE__*/ React.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange, maxRows, minRows = 1, style, value, ...other } = props;
    const { current: isControlled } = React.useRef(value != null);
    const textareaRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(forwardedRef, textareaRef);
    const heightRef = React.useRef(null);
    const hiddenTextareaRef = React.useRef(null);
    const calculateTextareaStyles = React.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, _ownerWindow.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
        const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle,
            overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, _useEventCallback.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = React.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = React.useRef(-1);
    (0, _useEnhancedEffect.default)(()=>{
        const debouncedHandleResize = (0, _debounce.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, _ownerWindow.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, _useEnhancedEffect.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var _default = exports.default = TextareaAutosize;

},{"671baff553aa964f":"kZ6eK","17d9e3b5117d3c63":"fiRIh","2f5a417e39778d5e":"9njXz","1c38f4efc1995f7f":"bnNSm","26247ff2b4258e48":"f6vcJ","980d51af9be2cb02":"4xKTx","4749cd82e60bdba6":"fIvqa","72751643c33d7cea":"feNJe","ba78e781099409a1":"hiDmU","ef4b121b168dbc9b":"1dlk8"}],"iMS0l":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function isHostComponent(element) {
    return typeof element === 'string';
}
var _default = exports.default = isHostComponent;

},{}],"lhkcI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formControlState;
function formControlState({ props, states, muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

},{}],"lcpxD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("6800875d1b299b1e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("cdc6c34b9f4a6ec5"));
/**
 * @ignore - internal component.
 */ const FormControlContext = /*#__PURE__*/ React.createContext(undefined);
var _default = exports.default = FormControlContext;

},{"6800875d1b299b1e":"fiRIh","cdc6c34b9f4a6ec5":"9njXz"}],"H1I5Z":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9be40b8c3595545f").default;
var _interopRequireWildcard = require("7aad941089b868cf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useFormControl;
var React = _interopRequireWildcard(require("33b729b897a3eede"));
var _FormControlContext = _interopRequireDefault(require("1b127e4709b87af"));
function useFormControl() {
    return React.useContext(_FormControlContext.default);
}

},{"9be40b8c3595545f":"kZ6eK","7aad941089b868cf":"fiRIh","33b729b897a3eede":"9njXz","1b127e4709b87af":"lcpxD"}],"ukWip":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasValue = hasValue;
exports.isAdornedStart = isAdornedStart;
exports.isFilled = isFilled;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isFilled(obj, SSR = false) {
    return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}
// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function isAdornedStart(obj) {
    return obj.startAdornment;
}

},{}],"d0rpO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("97f35616e29d4834").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getInputBaseUtilityClass = getInputBaseUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("23cf3b4dfcf7279e"));
var _generateUtilityClass = _interopRequireDefault(require("314f9924ee01ada5"));
function getInputBaseUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiInputBase', slot);
}
const inputBaseClasses = (0, _generateUtilityClasses.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var _default = exports.default = inputBaseClasses;

},{"97f35616e29d4834":"kZ6eK","23cf3b4dfcf7279e":"7pSUk","314f9924ee01ada5":"jBs9M"}],"hyHMe":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("824a16c89caf542b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getInputUtilityClass = getInputUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("811fa8bc62cdac0c"));
var _generateUtilityClass = _interopRequireDefault(require("535fcf8acd0c6173"));
var _InputBase = require("357930070707c3dd");
function getInputUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiInput', slot);
}
const inputClasses = {
    ..._InputBase.inputBaseClasses,
    ...(0, _generateUtilityClasses.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var _default = exports.default = inputClasses;

},{"824a16c89caf542b":"kZ6eK","811fa8bc62cdac0c":"7pSUk","535fcf8acd0c6173":"jBs9M","357930070707c3dd":"c1XNn"}],"bo4qf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("b60bf1cc59c5b762").default;
var _interopRequireDefault = require("5c675df5c64ec52f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    filledInputClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FilledInput.default;
    }
});
Object.defineProperty(exports, "filledInputClasses", {
    enumerable: true,
    get: function() {
        return _filledInputClasses.default;
    }
});
var _FilledInput = _interopRequireDefault(require("19799eb2e6977786"));
var _filledInputClasses = _interopRequireWildcard(require("f913b3914efaf4c1"));
Object.keys(_filledInputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _filledInputClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _filledInputClasses[key];
        }
    });
});

},{"b60bf1cc59c5b762":"fiRIh","5c675df5c64ec52f":"kZ6eK","19799eb2e6977786":"krW6P","f913b3914efaf4c1":"9EyvX"}],"krW6P":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("decf3e5d1ba15fcf").default;
var _interopRequireWildcard = require("fcd8a3aa78903b1d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("2782addfff09e86c"));
var _deepmerge = _interopRequireDefault(require("ee02a6d002b4bca2"));
var _refType = _interopRequireDefault(require("a2e665d9d2c93d89"));
var _propTypes = _interopRequireDefault(require("a7e257dee8804b76"));
var _composeClasses = _interopRequireDefault(require("8c8d80440a941e09"));
var _InputBase = _interopRequireDefault(require("8048a87fe27e8f91"));
var _rootShouldForwardProp = _interopRequireDefault(require("61750d47f34bce78"));
var _zeroStyled = require("18c7a44b42f4f1e");
var _memoTheme = _interopRequireDefault(require("c729b5bc7b68cf9a"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("aa6126683992611"));
var _DefaultPropsProvider = require("447cbf94eaceb7e2");
var _filledInputClasses = _interopRequireWildcard(require("ee65372c153ba47f"));
var _InputBase2 = require("c4b98c84d607814e");
var _utils = require("1880d8bb95fe2984");
var _jsxRuntime = require("135c663b3aea1316");
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline, startAdornment, endAdornment, size, hiddenLabel, multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, _utils.capitalize)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _filledInputClasses.getFilledInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const FilledInputRoot = (0, _zeroStyled.styled)(_InputBase2.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _InputBase2.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${_filledInputClasses.default.focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${_filledInputClasses.default.disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${_filledInputClasses.default.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${_filledInputClasses.default.error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${_filledInputClasses.default.disabled}, .${_filledInputClasses.default.error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${_filledInputClasses.default.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState, size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const FilledInputInput = (0, _zeroStyled.styled)(_InputBase2.InputBaseInput, {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: _InputBase2.inputOverridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const FilledInput = /*#__PURE__*/ React.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline = false, components = {}, componentsProps: componentsPropsProp, fullWidth = false, hiddenLabel, // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline = false, slotProps, slots = {}, type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline,
        fullWidth,
        inputComponent,
        multiline,
        type
    };
    const classes = useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState
        },
        input: {
            ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, _deepmerge.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? FilledInputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
FilledInput.muiName = 'Input';
var _default = exports.default = FilledInput;

},{"decf3e5d1ba15fcf":"kZ6eK","fcd8a3aa78903b1d":"fiRIh","2782addfff09e86c":"9njXz","ee02a6d002b4bca2":"7wtTC","a2e665d9d2c93d89":"3TBXN","a7e257dee8804b76":"bnNSm","8c8d80440a941e09":"59Equ","8048a87fe27e8f91":"c1XNn","61750d47f34bce78":"dIcrQ","18c7a44b42f4f1e":"89fxU","c729b5bc7b68cf9a":"2zy52","aa6126683992611":"yHYvD","447cbf94eaceb7e2":"ff3VX","ee65372c153ba47f":"9EyvX","c4b98c84d607814e":"aTW7W","1880d8bb95fe2984":"60iOt","135c663b3aea1316":"1dlk8"}],"9EyvX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("74e69fbf1f692e2d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFilledInputUtilityClass = getFilledInputUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("c78ff326a512a6ea"));
var _generateUtilityClass = _interopRequireDefault(require("a984948816b73184"));
var _InputBase = require("24524925760e11ec");
function getFilledInputUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiFilledInput', slot);
}
const filledInputClasses = {
    ..._InputBase.inputBaseClasses,
    ...(0, _generateUtilityClasses.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var _default = exports.default = filledInputClasses;

},{"74e69fbf1f692e2d":"kZ6eK","c78ff326a512a6ea":"7pSUk","a984948816b73184":"jBs9M","24524925760e11ec":"c1XNn"}],"8eUp2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("f1569b323bf29244").default;
var _interopRequireDefault = require("33f7e2dfe2695b1e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    outlinedInputClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _OutlinedInput.default;
    }
});
Object.defineProperty(exports, "outlinedInputClasses", {
    enumerable: true,
    get: function() {
        return _outlinedInputClasses.default;
    }
});
var _OutlinedInput = _interopRequireDefault(require("fe30d7908a87816b"));
var _outlinedInputClasses = _interopRequireWildcard(require("d3cad66e0e2ffa4a"));
Object.keys(_outlinedInputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _outlinedInputClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _outlinedInputClasses[key];
        }
    });
});

},{"f1569b323bf29244":"fiRIh","33f7e2dfe2695b1e":"kZ6eK","fe30d7908a87816b":"c8yfD","d3cad66e0e2ffa4a":"72KPB"}],"c8yfD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("79ac90d953b1c830").default;
var _interopRequireWildcard = require("298daacc4e38b4f5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("bd29ee888c6071d2"));
var _propTypes = _interopRequireDefault(require("93b2e643a885e990"));
var _refType = _interopRequireDefault(require("7195ff1b080ebf62"));
var _composeClasses = _interopRequireDefault(require("71b96d7cd88f9c08"));
var _NotchedOutline = _interopRequireDefault(require("3445f4a639870ada"));
var _useFormControl = _interopRequireDefault(require("216da0f4be323364"));
var _formControlState = _interopRequireDefault(require("c7e32115ecc65eba"));
var _rootShouldForwardProp = _interopRequireDefault(require("8fa824893d6920a7"));
var _zeroStyled = require("bc3b5689186fd5ac");
var _memoTheme = _interopRequireDefault(require("e4ff3ccc69b28fdf"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("4e7abb8f78353870"));
var _DefaultPropsProvider = require("b4f3cc50e95709df");
var _outlinedInputClasses = _interopRequireWildcard(require("a09d4b47cd7efd9"));
var _InputBase = _interopRequireWildcard(require("a8e55e55a4bd87fc"));
var _useSlot = _interopRequireDefault(require("bad335861aa74616"));
var _jsxRuntime = require("b79e5165c8239a2f");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _outlinedInputClasses.getOutlinedInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const OutlinedInputRoot = (0, _zeroStyled.styled)(_InputBase.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: _InputBase.rootOverridesResolver
})((0, _memoTheme.default)(({ theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${_outlinedInputClasses.default.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${_outlinedInputClasses.default.notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${_outlinedInputClasses.default.focused} .${_outlinedInputClasses.default.notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&.${_outlinedInputClasses.default.focused} .${_outlinedInputClasses.default.notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${_outlinedInputClasses.default.error} .${_outlinedInputClasses.default.notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${_outlinedInputClasses.default.disabled} .${_outlinedInputClasses.default.notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState, size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const NotchedOutlineRoot = (0, _zeroStyled.styled)(_NotchedOutline.default, {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, _memoTheme.default)(({ theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const OutlinedInputInput = (0, _zeroStyled.styled)(_InputBase.InputBaseInput, {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: _InputBase.inputOverridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const OutlinedInput = /*#__PURE__*/ React.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components = {}, fullWidth = false, inputComponent = 'input', label, multiline = false, notched, slots = {}, slotProps = {}, type = 'text', ...other } = props;
    const classes = useUtilityClasses(props);
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        type
    };
    const RootSlot = slots.root ?? components.Root ?? OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, _useSlot.default)('notchedOutline', {
        elementType: NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState,
        externalForwardedProps: {
            slots,
            slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
OutlinedInput.muiName = 'Input';
var _default = exports.default = OutlinedInput;

},{"79ac90d953b1c830":"kZ6eK","298daacc4e38b4f5":"fiRIh","bd29ee888c6071d2":"9njXz","93b2e643a885e990":"bnNSm","7195ff1b080ebf62":"3TBXN","71b96d7cd88f9c08":"59Equ","3445f4a639870ada":"eCmf6","216da0f4be323364":"H1I5Z","c7e32115ecc65eba":"lhkcI","8fa824893d6920a7":"dIcrQ","bc3b5689186fd5ac":"89fxU","e4ff3ccc69b28fdf":"2zy52","4e7abb8f78353870":"yHYvD","b4f3cc50e95709df":"ff3VX","a09d4b47cd7efd9":"72KPB","a8e55e55a4bd87fc":"aTW7W","bad335861aa74616":"29rI6","b79e5165c8239a2f":"1dlk8"}],"eCmf6":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("d4ca256048c53d54").default;
var _interopRequireDefault = require("7407df9aefbf29a3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NotchedOutline;
var React = _interopRequireWildcard(require("f554547e42938df7"));
var _propTypes = _interopRequireDefault(require("9e9b853b11ffea64"));
var _rootShouldForwardProp = _interopRequireDefault(require("da64dd61b595a93e"));
var _zeroStyled = require("8a89104e022286cb");
var _memoTheme = _interopRequireDefault(require("60ca8e5cb2ab2a5a"));
var _jsxRuntime = require("6ed570dae113f3ea");
var _span;
const NotchedOutlineRoot = (0, _zeroStyled.styled)('fieldset', {
    shouldForwardProp: _rootShouldForwardProp.default
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const NotchedOutlineLegend = (0, _zeroStyled.styled)('legend', {
    shouldForwardProp: _rootShouldForwardProp.default
})((0, _memoTheme.default)(({ theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function NotchedOutline(props) {
    const { children, classes, className, label, notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched,
        withLabel
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: label
            }) : _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

},{"d4ca256048c53d54":"fiRIh","7407df9aefbf29a3":"kZ6eK","f554547e42938df7":"9njXz","9e9b853b11ffea64":"bnNSm","da64dd61b595a93e":"dIcrQ","8a89104e022286cb":"89fxU","60ca8e5cb2ab2a5a":"2zy52","6ed570dae113f3ea":"1dlk8"}],"72KPB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a6b44a20028acebf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getOutlinedInputUtilityClass = getOutlinedInputUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("d4370c764ff9a251"));
var _generateUtilityClass = _interopRequireDefault(require("b68e0628748ba6bb"));
var _InputBase = require("6b03113572bd7102");
function getOutlinedInputUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiOutlinedInput', slot);
}
const outlinedInputClasses = {
    ..._InputBase.inputBaseClasses,
    ...(0, _generateUtilityClasses.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var _default = exports.default = outlinedInputClasses;

},{"a6b44a20028acebf":"kZ6eK","d4370c764ff9a251":"7pSUk","b68e0628748ba6bb":"jBs9M","6b03113572bd7102":"c1XNn"}],"iTW3B":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ceb519b59d647f9d").default;
var _interopRequireDefault = require("7711cb922c65062").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    inputLabelClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _InputLabel.default;
    }
});
Object.defineProperty(exports, "inputLabelClasses", {
    enumerable: true,
    get: function() {
        return _inputLabelClasses.default;
    }
});
var _InputLabel = _interopRequireDefault(require("ed272e6895abc367"));
var _inputLabelClasses = _interopRequireWildcard(require("f98bd4d1983362fa"));
Object.keys(_inputLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _inputLabelClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _inputLabelClasses[key];
        }
    });
});

},{"ceb519b59d647f9d":"fiRIh","7711cb922c65062":"kZ6eK","ed272e6895abc367":"e3dDT","f98bd4d1983362fa":"1o1Mc"}],"e3dDT":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ff1d18b3c70aeae4").default;
var _interopRequireWildcard = require("f9d89421c9d8d17a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("544685f31ece9c14"));
var _propTypes = _interopRequireDefault(require("6926e8a8c644bc18"));
var _composeClasses = _interopRequireDefault(require("b8bf1e97e2b4d849"));
var _clsx = _interopRequireDefault(require("4bc66914629b5f46"));
var _formControlState = _interopRequireDefault(require("4d77610341932ca1"));
var _useFormControl = _interopRequireDefault(require("e5a341fc3075e372"));
var _FormLabel = _interopRequireWildcard(require("d2c604bcce0cf894"));
var _capitalize = _interopRequireDefault(require("672fcccc60ce0b2d"));
var _rootShouldForwardProp = _interopRequireDefault(require("7d9d52deb89ced9e"));
var _zeroStyled = require("46240a326ce58610");
var _memoTheme = _interopRequireDefault(require("6b0548d990a45bbc"));
var _DefaultPropsProvider = require("ca75e13d99e5262a");
var _inputLabelClasses = require("f33a2a50db7df693");
var _jsxRuntime = require("e394be33f73b6e11");
const useUtilityClasses = (ownerState)=>{
    const { classes, formControl, size, shrink, disableAnimation, variant, required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, _capitalize.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _inputLabelClasses.getInputLabelUtilityClasses, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const InputLabelRoot = (0, _zeroStyled.styled)(_FormLabel.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_FormLabel.formLabelClasses.asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant, ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant, ownerState, size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant, ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const InputLabel = /*#__PURE__*/ React.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation = false, margin, shrink: shrinkProp, variant, className, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation,
        formControl: muiFormControl,
        shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var _default = exports.default = InputLabel;

},{"ff1d18b3c70aeae4":"kZ6eK","f9d89421c9d8d17a":"fiRIh","544685f31ece9c14":"9njXz","6926e8a8c644bc18":"bnNSm","b8bf1e97e2b4d849":"59Equ","4bc66914629b5f46":"d2NWs","4d77610341932ca1":"lhkcI","e5a341fc3075e372":"H1I5Z","d2c604bcce0cf894":"haS5J","672fcccc60ce0b2d":"hBZko","7d9d52deb89ced9e":"dIcrQ","46240a326ce58610":"89fxU","6b0548d990a45bbc":"2zy52","ca75e13d99e5262a":"ff3VX","f33a2a50db7df693":"1o1Mc","e394be33f73b6e11":"1dlk8"}],"haS5J":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5348526cfde564b5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    formLabelClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FormLabel.default;
    }
});
Object.defineProperty(exports, "formLabelClasses", {
    enumerable: true,
    get: function() {
        return _formLabelClasses.default;
    }
});
var _FormLabel = _interopRequireWildcard(require("36393ffa41bdaf04"));
Object.keys(_FormLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _FormLabel[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _FormLabel[key];
        }
    });
});
var _formLabelClasses = _interopRequireWildcard(require("749c995de37c106d"));
Object.keys(_formLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _formLabelClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _formLabelClasses[key];
        }
    });
});

},{"5348526cfde564b5":"fiRIh","36393ffa41bdaf04":"dI3Wb","749c995de37c106d":"5s17K"}],"dI3Wb":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a3651b3b6adac932").default;
var _interopRequireWildcard = require("543d939aea530df").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.FormLabelRoot = void 0;
var React = _interopRequireWildcard(require("cdee5f07494c0c57"));
var _propTypes = _interopRequireDefault(require("62ec910ca622185f"));
var _clsx = _interopRequireDefault(require("441eaeab5212ee93"));
var _composeClasses = _interopRequireDefault(require("9738976c0f99fbe9"));
var _formControlState = _interopRequireDefault(require("1f3b2cab58a06fdf"));
var _useFormControl = _interopRequireDefault(require("14d0f123c78df74f"));
var _capitalize = _interopRequireDefault(require("94f875b6af2548b3"));
var _zeroStyled = require("58cc670023cd608f");
var _memoTheme = _interopRequireDefault(require("17fca1bd3000b96c"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("6e7ca8812eae491e"));
var _DefaultPropsProvider = require("cf01510425dce87b");
var _formLabelClasses = _interopRequireWildcard(require("d2df69bba54830e3"));
var _jsxRuntime = require("4f4828a6c08b92df");
const useUtilityClasses = (ownerState)=>{
    const { classes, color, focused, disabled, error, filled, required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalize.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, _composeClasses.default)(slots, _formLabelClasses.getFormLabelUtilityClasses, classes);
};
const FormLabelRoot = exports.FormLabelRoot = (0, _zeroStyled.styled)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&.${_formLabelClasses.default.focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${_formLabelClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${_formLabelClasses.default.error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const AsteriskComponent = (0, _zeroStyled.styled)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, _memoTheme.default)(({ theme })=>({
        [`&.${_formLabelClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const FormLabel = /*#__PURE__*/ React.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children, className, color, component = 'label', disabled, error, filled, focused, required, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormLabelRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var _default = exports.default = FormLabel;

},{"a3651b3b6adac932":"kZ6eK","543d939aea530df":"fiRIh","cdee5f07494c0c57":"9njXz","62ec910ca622185f":"bnNSm","441eaeab5212ee93":"d2NWs","9738976c0f99fbe9":"59Equ","1f3b2cab58a06fdf":"lhkcI","14d0f123c78df74f":"H1I5Z","94f875b6af2548b3":"hBZko","58cc670023cd608f":"89fxU","17fca1bd3000b96c":"2zy52","6e7ca8812eae491e":"yHYvD","cf01510425dce87b":"ff3VX","d2df69bba54830e3":"5s17K","4f4828a6c08b92df":"1dlk8"}],"5s17K":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a121f31bea2f3570").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFormLabelUtilityClasses = getFormLabelUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("832525c10626aa22"));
var _generateUtilityClass = _interopRequireDefault(require("668a07cf536323f"));
function getFormLabelUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiFormLabel', slot);
}
const formLabelClasses = (0, _generateUtilityClasses.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var _default = exports.default = formLabelClasses;

},{"a121f31bea2f3570":"kZ6eK","832525c10626aa22":"7pSUk","668a07cf536323f":"jBs9M"}],"1o1Mc":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("34ca20e1f148e7c2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getInputLabelUtilityClasses = getInputLabelUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("979ff0f7419db92d"));
var _generateUtilityClass = _interopRequireDefault(require("d9a4eb1875639647"));
function getInputLabelUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiInputLabel', slot);
}
const inputLabelClasses = (0, _generateUtilityClasses.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var _default = exports.default = inputLabelClasses;

},{"34ca20e1f148e7c2":"kZ6eK","979ff0f7419db92d":"7pSUk","d9a4eb1875639647":"jBs9M"}],"kkska":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("54da1614801e9821").default;
var _interopRequireDefault = require("3f74a33235133757").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    useFormControl: true,
    formControlClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FormControl.default;
    }
});
Object.defineProperty(exports, "formControlClasses", {
    enumerable: true,
    get: function() {
        return _formControlClasses.default;
    }
});
Object.defineProperty(exports, "useFormControl", {
    enumerable: true,
    get: function() {
        return _useFormControl.default;
    }
});
var _FormControl = _interopRequireDefault(require("e3c9aee59261db7c"));
var _useFormControl = _interopRequireDefault(require("59d2da54c3c84a6a"));
var _formControlClasses = _interopRequireWildcard(require("85683dd9fa533889"));
Object.keys(_formControlClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _formControlClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _formControlClasses[key];
        }
    });
});

},{"54da1614801e9821":"fiRIh","3f74a33235133757":"kZ6eK","e3c9aee59261db7c":"3jmNx","59d2da54c3c84a6a":"H1I5Z","85683dd9fa533889":"1V6jF"}],"3jmNx":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("da8b5212d065996d").default;
var _interopRequireWildcard = require("4006c34710820ab").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f2b5d09889747e7f"));
var _propTypes = _interopRequireDefault(require("760f666ea1ce68f5"));
var _clsx = _interopRequireDefault(require("37984779932b77c8"));
var _composeClasses = _interopRequireDefault(require("d67f516786485d9"));
var _zeroStyled = require("ca7af6b0c2d6d12c");
var _DefaultPropsProvider = require("16337176a2ab99b");
var _utils = require("8858a81d4cb4d993");
var _capitalize = _interopRequireDefault(require("6b54eac3ef77dd84"));
var _isMuiElement = _interopRequireDefault(require("b47fde6fca32766a"));
var _FormControlContext = _interopRequireDefault(require("c243bd0a195317f6"));
var _formControlClasses = require("6ff6cd1688927876");
var _jsxRuntime = require("eb722b1a4e1bfed7");
const useUtilityClasses = (ownerState)=>{
    const { classes, margin, fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, _capitalize.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, _composeClasses.default)(slots, _formControlClasses.getFormControlUtilityClasses, classes);
};
const FormControlRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, _capitalize.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const FormControl = /*#__PURE__*/ React.forwardRef(function FormControl(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children, className, color = 'primary', component = 'div', disabled = false, error = false, focused: visuallyFocused, fullWidth = false, hiddenLabel = false, margin = 'none', required = false, size = 'medium', variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color,
        component,
        disabled,
        error,
        fullWidth,
        hiddenLabel,
        margin,
        required,
        size,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = React.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) React.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElement.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, _isMuiElement.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, _utils.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = React.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) React.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElement.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, _utils.isFilled)(child.props, true) || (0, _utils.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = React.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = React.useRef(false);
    const onFilled = React.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = React.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = React.useMemo(()=>{
        return {
            adornedStart,
            setAdornedStart,
            color,
            disabled,
            error,
            filled,
            focused,
            fullWidth,
            hiddenLabel,
            size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty,
            onFilled,
            registerEffect,
            required,
            variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormControlContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var _default = exports.default = FormControl;

},{"da8b5212d065996d":"kZ6eK","4006c34710820ab":"fiRIh","f2b5d09889747e7f":"9njXz","760f666ea1ce68f5":"bnNSm","37984779932b77c8":"d2NWs","d67f516786485d9":"59Equ","ca7af6b0c2d6d12c":"89fxU","16337176a2ab99b":"ff3VX","8858a81d4cb4d993":"ukWip","6b54eac3ef77dd84":"hBZko","b47fde6fca32766a":"bgSQq","c243bd0a195317f6":"lcpxD","6ff6cd1688927876":"1V6jF","eb722b1a4e1bfed7":"1dlk8"}],"1V6jF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f23496c424275c16").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFormControlUtilityClasses = getFormControlUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("72ceb76e401dd16d"));
var _generateUtilityClass = _interopRequireDefault(require("14e3bc65eb32d756"));
function getFormControlUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiFormControl', slot);
}
const formControlClasses = (0, _generateUtilityClasses.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var _default = exports.default = formControlClasses;

},{"f23496c424275c16":"kZ6eK","72ceb76e401dd16d":"7pSUk","14e3bc65eb32d756":"jBs9M"}],"dlh9L":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("702e12928a659aa8").default;
var _interopRequireDefault = require("ac47383ba37e59b1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    formHelperTextClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FormHelperText.default;
    }
});
Object.defineProperty(exports, "formHelperTextClasses", {
    enumerable: true,
    get: function() {
        return _formHelperTextClasses.default;
    }
});
var _FormHelperText = _interopRequireDefault(require("1aed5fcc1494d276"));
var _formHelperTextClasses = _interopRequireWildcard(require("2195dac666abecc7"));
Object.keys(_formHelperTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _formHelperTextClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _formHelperTextClasses[key];
        }
    });
});

},{"702e12928a659aa8":"fiRIh","ac47383ba37e59b1":"kZ6eK","1aed5fcc1494d276":"kz0AS","2195dac666abecc7":"7464F"}],"kz0AS":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("919e50928dec4672").default;
var _interopRequireDefault = require("f6d0869da0cd9f28").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("9644a55c072574ac"));
var _propTypes = _interopRequireDefault(require("510b1df143ca356a"));
var _clsx = _interopRequireDefault(require("c68e93f814a40b35"));
var _composeClasses = _interopRequireDefault(require("500487be26355326"));
var _formControlState = _interopRequireDefault(require("66be0436560f82f0"));
var _useFormControl = _interopRequireDefault(require("f8f112f91a156516"));
var _zeroStyled = require("c1729472a6d64f4");
var _memoTheme = _interopRequireDefault(require("47825f789e221cb9"));
var _DefaultPropsProvider = require("f4f1ab4bba881ea8");
var _capitalize = _interopRequireDefault(require("44ee8c24a848a72d"));
var _formHelperTextClasses = _interopRequireWildcard(require("3e5a8e153d6ac67b"));
var _jsxRuntime = require("b9a48e3c43008a90");
var _span;
const useUtilityClasses = (ownerState)=>{
    const { classes, contained, size, disabled, error, filled, focused, required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, _capitalize.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, _composeClasses.default)(slots, _formHelperTextClasses.getFormHelperTextUtilityClasses, classes);
};
const FormHelperTextRoot = (0, _zeroStyled.styled)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, _capitalize.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${_formHelperTextClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${_formHelperTextClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const FormHelperText = /*#__PURE__*/ React.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children, className, component = 'p', disabled, error, filled, focused, margin, required, variant, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormHelperTextRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var _default = exports.default = FormHelperText;

},{"919e50928dec4672":"fiRIh","f6d0869da0cd9f28":"kZ6eK","9644a55c072574ac":"9njXz","510b1df143ca356a":"bnNSm","c68e93f814a40b35":"d2NWs","500487be26355326":"59Equ","66be0436560f82f0":"lhkcI","f8f112f91a156516":"H1I5Z","c1729472a6d64f4":"89fxU","47825f789e221cb9":"2zy52","f4f1ab4bba881ea8":"ff3VX","44ee8c24a848a72d":"hBZko","3e5a8e153d6ac67b":"7464F","b9a48e3c43008a90":"1dlk8"}],"7464F":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("24cc23b4b7729a1b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFormHelperTextUtilityClasses = getFormHelperTextUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("6b2fcf24341cc6a2"));
var _generateUtilityClass = _interopRequireDefault(require("690e355765a20ce0"));
function getFormHelperTextUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiFormHelperText', slot);
}
const formHelperTextClasses = (0, _generateUtilityClasses.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var _default = exports.default = formHelperTextClasses;

},{"24cc23b4b7729a1b":"kZ6eK","6b2fcf24341cc6a2":"7pSUk","690e355765a20ce0":"jBs9M"}],"aY7hn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c73bc7f741241428").default;
var _interopRequireDefault = require("f6d1a42b42e136c7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    selectClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Select.default;
    }
});
Object.defineProperty(exports, "selectClasses", {
    enumerable: true,
    get: function() {
        return _selectClasses.default;
    }
});
var _Select = _interopRequireDefault(require("5faf8639dc46cc11"));
var _selectClasses = _interopRequireWildcard(require("618617ae7f9100db"));
Object.keys(_selectClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _selectClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _selectClasses[key];
        }
    });
});

},{"c73bc7f741241428":"fiRIh","f6d1a42b42e136c7":"kZ6eK","5faf8639dc46cc11":"hFsCY","618617ae7f9100db":"fqIdL"}],"hFsCY":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("93bbde75ed1e5090").default;
var _interopRequireWildcard = require("56a2114fec3cd5d8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("113c07dea1e3f6dd"));
var _propTypes = _interopRequireDefault(require("25367308614fe13"));
var _clsx = _interopRequireDefault(require("d15abbd07c9f9d55"));
var _deepmerge = _interopRequireDefault(require("df050269a0a37c2c"));
var _composeClasses = _interopRequireDefault(require("b67179b14f0b473f"));
var _getReactElementRef = _interopRequireDefault(require("e555c5cdd4d20072"));
var _SelectInput = _interopRequireDefault(require("8f79fb01132cfdab"));
var _formControlState = _interopRequireDefault(require("a4563260f4931b95"));
var _useFormControl = _interopRequireDefault(require("45da69f3d9f02553"));
var _ArrowDropDown = _interopRequireDefault(require("9453867fb92bb07d"));
var _Input = _interopRequireDefault(require("4bd42655605bd5f4"));
var _NativeSelectInput = _interopRequireDefault(require("ae74f3702935e7e9"));
var _FilledInput = _interopRequireDefault(require("2487a8f44a2b5ec4"));
var _OutlinedInput = _interopRequireDefault(require("3301915bd0a0a89e"));
var _DefaultPropsProvider = require("519dba447b489c90");
var _useForkRef = _interopRequireDefault(require("1e2157cbac522e5f"));
var _zeroStyled = require("a98132d7a8ddbba6");
var _rootShouldForwardProp = _interopRequireDefault(require("4e9ed667c71d9e87"));
var _selectClasses = require("ce7a7d369c8a780");
var _jsxRuntime = require("609dad94f1114a77");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _selectClasses.getSelectUtilityClasses, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) && prop !== 'variant'
};
const StyledInput = (0, _zeroStyled.styled)(_Input.default, styledRootConfig)('');
const StyledOutlinedInput = (0, _zeroStyled.styled)(_OutlinedInput.default, styledRootConfig)('');
const StyledFilledInput = (0, _zeroStyled.styled)(_FilledInput.default, styledRootConfig)('');
const Select = /*#__PURE__*/ React.forwardRef(function Select(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth = false, children, classes: classesProp = {}, className, defaultOpen = false, displayEmpty = false, IconComponent = _ArrowDropDown.default, id, input, inputProps, label, labelId, MenuProps, multiple = false, native = false, onClose, onOpen, open, renderValue, SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant,
        classes: classesProp
    };
    const classes = useUtilityClasses(ownerState);
    const { root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, _useForkRef.default)(ref, (0, _getReactElementRef.default)(InputComponent));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(React.Fragment, {
        children: /*#__PURE__*/ React.cloneElement(InputComponent, {
            // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children,
                error: fcs.error,
                IconComponent,
                variant,
                type: undefined,
                // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id
                } : {
                    autoWidth,
                    defaultOpen,
                    displayEmpty,
                    labelId,
                    MenuProps,
                    onClose,
                    onOpen,
                    open,
                    renderValue,
                    SelectDisplayProps: {
                        id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, _deepmerge.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, _clsx.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant
            },
            ...other
        })
    });
});
Select.muiName = 'Select';
var _default = exports.default = Select;

},{"93bbde75ed1e5090":"kZ6eK","56a2114fec3cd5d8":"fiRIh","113c07dea1e3f6dd":"9njXz","25367308614fe13":"bnNSm","d15abbd07c9f9d55":"d2NWs","df050269a0a37c2c":"7wtTC","b67179b14f0b473f":"59Equ","e555c5cdd4d20072":"gaXcx","8f79fb01132cfdab":"1Uroj","a4563260f4931b95":"lhkcI","45da69f3d9f02553":"H1I5Z","9453867fb92bb07d":"1gNb2","4bd42655605bd5f4":"4s0JB","ae74f3702935e7e9":"lLoCh","2487a8f44a2b5ec4":"bo4qf","3301915bd0a0a89e":"8eUp2","519dba447b489c90":"ff3VX","1e2157cbac522e5f":"cq8Sn","a98132d7a8ddbba6":"89fxU","4e9ed667c71d9e87":"dIcrQ","ce7a7d369c8a780":"fqIdL","609dad94f1114a77":"1dlk8"}],"1Uroj":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2dcaaf4a0b3cb6fd").default;
var _interopRequireWildcard = require("e535d2c867c0a27a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _formatMuiErrorMessage = _interopRequireDefault(require("3c3cac9d61491089"));
var React = _interopRequireWildcard(require("3c469517deae4a96"));
var _reactIs = require("2ecab7697139abc7");
var _propTypes = _interopRequireDefault(require("51d93a7519ebd480"));
var _clsx = _interopRequireDefault(require("24443e84f73fc196"));
var _composeClasses = _interopRequireDefault(require("97520f077d789fbe"));
var _useId = _interopRequireDefault(require("df35067d8c20b327"));
var _refType = _interopRequireDefault(require("5525f205a1f00712"));
var _ownerDocument = _interopRequireDefault(require("11ad95d8de84e77b"));
var _capitalize = _interopRequireDefault(require("2173ab0fc1c2ef20"));
var _Menu = _interopRequireDefault(require("191d8dd618fa072c"));
var _NativeSelectInput = require("aaa9d1532938c0b7");
var _utils = require("f4ad016a67051320");
var _zeroStyled = require("850443f0680e53da");
var _slotShouldForwardProp = _interopRequireDefault(require("34c3736ff647462d"));
var _useForkRef = _interopRequireDefault(require("e61d3b170d141b26"));
var _useControlled = _interopRequireDefault(require("68ab02022f2a99cd"));
var _selectClasses = _interopRequireWildcard(require("db093cec63cfa5e"));
var _jsxRuntime = require("7252c74c1bf897de");
var _span;
const SelectSelect = (0, _zeroStyled.styled)(_NativeSelectInput.StyledSelectSelect, {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${_selectClasses.default.select}`]: styles.select
            },
            {
                [`&.${_selectClasses.default.select}`]: styles[ownerState.variant]
            },
            {
                [`&.${_selectClasses.default.error}`]: styles.error
            },
            {
                [`&.${_selectClasses.default.multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${_selectClasses.default.select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const SelectIcon = (0, _zeroStyled.styled)(_NativeSelectInput.StyledSelectIcon, {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalize.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const SelectNativeInput = (0, _zeroStyled.styled)('input', {
    shouldForwardProp: (prop)=>(0, _slotShouldForwardProp.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, _capitalize.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, _composeClasses.default)(slots, _selectClasses.getSelectUtilityClasses, classes);
};
/**
 * @ignore - internal component.
 */ const SelectInput = /*#__PURE__*/ React.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus, autoWidth, children, className, defaultOpen, defaultValue, disabled, displayEmpty, error = false, IconComponent, inputRef: inputRefProp, labelId, MenuProps = {}, multiple, name, onBlur, onChange, onClose, onFocus, onOpen, open: openProp, readOnly, renderValue, required, SelectDisplayProps = {}, tabIndex: tabIndexProp, // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, _useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, _useControlled.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = React.useRef(null);
    const displayRef = React.useRef(null);
    const [displayNode, setDisplayNode] = React.useState(null);
    const { current: isOpenControlled } = React.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = React.useState();
    const handleRef = (0, _useForkRef.default)(ref, inputRefProp);
    const handleDisplayRef = React.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    React.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    React.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    React.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    React.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, _ownerDocument.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = React.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value,
                    name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, _utils.isFilled)({
        value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, _formatMuiErrorMessage.default)(2));
            selected = value.some((v)=>areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ React.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant,
        value,
        open,
        error
    };
    const classes = useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, _useId.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, _clsx.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: isEmpty(display) ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Menu.default, {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var _default = exports.default = SelectInput;

},{"2dcaaf4a0b3cb6fd":"kZ6eK","e535d2c867c0a27a":"fiRIh","3c3cac9d61491089":"gOgzd","3c469517deae4a96":"9njXz","2ecab7697139abc7":"8oKlE","51d93a7519ebd480":"bnNSm","24443e84f73fc196":"d2NWs","97520f077d789fbe":"59Equ","df35067d8c20b327":"50qgI","5525f205a1f00712":"3TBXN","11ad95d8de84e77b":"7Yspg","2173ab0fc1c2ef20":"hBZko","191d8dd618fa072c":"4D7gU","aaa9d1532938c0b7":"lLoCh","f4ad016a67051320":"ukWip","850443f0680e53da":"89fxU","34c3736ff647462d":"arfz9","e61d3b170d141b26":"cq8Sn","68ab02022f2a99cd":"1VreF","db093cec63cfa5e":"fqIdL","7252c74c1bf897de":"1dlk8"}],"4D7gU":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("6e7fe602c94d049d").default;
var _interopRequireWildcard = require("a14427d2a7fa95aa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.MenuPaper = void 0;
var React = _interopRequireWildcard(require("17752790e9a58fb6"));
var _reactIs = require("dee3a340caad57f5");
var _propTypes = _interopRequireDefault(require("b0824527a5464a8"));
var _clsx = _interopRequireDefault(require("dd82522aff5fb751"));
var _composeClasses = _interopRequireDefault(require("5c104cbe74671d9c"));
var _HTMLElementType = _interopRequireDefault(require("cf6a0cac381df419"));
var _RtlProvider = require("7dd4e6a941df6a94");
var _useSlotProps = _interopRequireDefault(require("9926bba8c4a2420c"));
var _MenuList = _interopRequireDefault(require("30c135df728122aa"));
var _Popover = _interopRequireWildcard(require("920beaa26e7926a3"));
var _rootShouldForwardProp = _interopRequireDefault(require("42c0a7e8c59c1c26"));
var _zeroStyled = require("e5586972303e3ccb");
var _DefaultPropsProvider = require("979da5c46d324a78");
var _menuClasses = require("e32dcf1e37ef3050");
var _useSlot = _interopRequireDefault(require("239065236171afb2"));
var _jsxRuntime = require("33296ca58d4ad465");
const RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, _composeClasses.default)(slots, _menuClasses.getMenuUtilityClass, classes);
};
const MenuRoot = (0, _zeroStyled.styled)(_Popover.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const MenuPaper = exports.MenuPaper = (0, _zeroStyled.styled)(_Popover.PopoverPaper, {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const MenuMenuList = (0, _zeroStyled.styled)(_MenuList.default, {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Menu = /*#__PURE__*/ React.forwardRef(function Menu(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus = true, children, className, disableAutoFocusItem = false, MenuListProps = {}, onClose, open, PaperProps = {}, PopoverClasses, transitionDuration = 'auto', TransitionProps: { onEntering, ...TransitionProps } = {}, variant = 'selectedMenu', slots = {}, slotProps = {}, ...other } = props;
    const isRtl = (0, _RtlProvider.useRtl)();
    const ownerState = {
        ...props,
        autoFocus,
        disableAutoFocusItem,
        MenuListProps,
        onEntering,
        PaperProps,
        transitionDuration,
        TransitionProps,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = React.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    React.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, _useSlotProps.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, _useSlot.default)('paper', {
        className: classes.paper,
        elementType: MenuPaper,
        externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState
    });
    const [ListSlot, listSlotProps] = (0, _useSlot.default)('list', {
        className: (0, _clsx.default)(classes.list, MenuListProps.className),
        elementType: MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var _default = exports.default = Menu;

},{"6e7fe602c94d049d":"kZ6eK","a14427d2a7fa95aa":"fiRIh","17752790e9a58fb6":"9njXz","dee3a340caad57f5":"8oKlE","b0824527a5464a8":"bnNSm","dd82522aff5fb751":"d2NWs","5c104cbe74671d9c":"59Equ","cf6a0cac381df419":"eESPP","7dd4e6a941df6a94":"ck9Pb","9926bba8c4a2420c":"kr4RG","30c135df728122aa":"eogrV","920beaa26e7926a3":"keu0V","42c0a7e8c59c1c26":"dIcrQ","e5586972303e3ccb":"89fxU","979da5c46d324a78":"ff3VX","e32dcf1e37ef3050":"3yXu4","239065236171afb2":"29rI6","33296ca58d4ad465":"1dlk8"}],"keu0V":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e1d3d4d22a9973b9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    popoverClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Popover.default;
    }
});
Object.defineProperty(exports, "popoverClasses", {
    enumerable: true,
    get: function() {
        return _popoverClasses.default;
    }
});
var _Popover = _interopRequireWildcard(require("de2a55fd63511f9e"));
Object.keys(_Popover).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _Popover[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Popover[key];
        }
    });
});
var _popoverClasses = _interopRequireWildcard(require("3cd1a0e7d785a66"));
Object.keys(_popoverClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _popoverClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _popoverClasses[key];
        }
    });
});

},{"e1d3d4d22a9973b9":"fiRIh","de2a55fd63511f9e":"1alPY","3cd1a0e7d785a66":"1QYLF"}],"1alPY":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5b0ead908cd93c4e").default;
var _interopRequireWildcard = require("5e9246abce8eee88").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.PopoverRoot = exports.PopoverPaper = void 0;
exports.getOffsetLeft = getOffsetLeft;
exports.getOffsetTop = getOffsetTop;
var React = _interopRequireWildcard(require("327ada6ac149cac0"));
var _propTypes = _interopRequireDefault(require("bc48ddb793ba306"));
var _clsx = _interopRequireDefault(require("ba308cad39e78ce"));
var _composeClasses = _interopRequireDefault(require("a05ff2f2bba87a8c"));
var _HTMLElementType = _interopRequireDefault(require("e9f0e380766ceafc"));
var _refType = _interopRequireDefault(require("f8bd6118823bc7fb"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("6f68e0d77a07dcd1"));
var _integerPropType = _interopRequireDefault(require("fd08136e3401a8ff"));
var _chainPropTypes = _interopRequireDefault(require("4479506e8836bc53"));
var _isHostComponent = _interopRequireDefault(require("f52980a8554368b6"));
var _zeroStyled = require("ebb4088eecdeeb62");
var _DefaultPropsProvider = require("4b60e915c6e3a8c9");
var _debounce = _interopRequireDefault(require("b02f72e4c0344330"));
var _ownerDocument = _interopRequireDefault(require("ff9d88affe8bfd9b"));
var _ownerWindow = _interopRequireDefault(require("e3fec83b77f1224d"));
var _Grow = _interopRequireDefault(require("d3bb7ae422c40fb"));
var _Modal = _interopRequireDefault(require("9bea3a8daaf3d0f8"));
var _Paper = _interopRequireDefault(require("173a894ed000e25d"));
var _popoverClasses = require("162b3054360e7c1b");
var _useSlot = _interopRequireDefault(require("b7d69ce8e4181b6e"));
var _utils = require("70361df7144d5abb");
var _jsxRuntime = require("46b7b2a0e5e4bb84");
function getOffsetTop(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function getOffsetLeft(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, _composeClasses.default)(slots, _popoverClasses.getPopoverUtilityClass, classes);
};
const PopoverRoot = exports.PopoverRoot = (0, _zeroStyled.styled)(_Modal.default, {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const PopoverPaper = exports.PopoverPaper = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Popover = /*#__PURE__*/ React.forwardRef(function Popover(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action, anchorEl, anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition, anchorReference = 'anchorEl', children, className, container: containerProp, elevation = 8, marginThreshold = 16, open, PaperProps: PaperPropsProp = {}, // TODO: remove in v7
    slots = {}, slotProps = {}, transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps = {}, // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = React.useRef();
    const ownerState = {
        ...props,
        anchorOrigin,
        anchorReference,
        elevation,
        marginThreshold,
        transformOrigin,
        TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps
    };
    const classes = useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = React.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocument.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = React.useCallback((elemRect)=>{
        return {
            vertical: getOffsetTop(elemRect, transformOrigin.vertical),
            horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = React.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, _ownerWindow.default)(resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = React.useState(open);
    const setPositioningStyles = React.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    React.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    React.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    React.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    React.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, _debounce.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, _ownerWindow.default)(resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, _useSlot.default)('transition', {
        elementType: _Grow.default,
        externalForwardedProps,
        ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, _ownerDocument.default)(resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, _useSlot.default)('root', {
        ref,
        elementType: PopoverRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, _utils.mergeSlotProps)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container,
            open
        },
        ownerState,
        className: (0, _clsx.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, _useSlot.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: PopoverPaper,
        externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, _isHostComponent.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var _default = exports.default = Popover;

},{"5b0ead908cd93c4e":"kZ6eK","5e9246abce8eee88":"fiRIh","327ada6ac149cac0":"9njXz","bc48ddb793ba306":"bnNSm","ba308cad39e78ce":"d2NWs","a05ff2f2bba87a8c":"59Equ","e9f0e380766ceafc":"eESPP","f8bd6118823bc7fb":"3TBXN","6f68e0d77a07dcd1":"40NoV","fd08136e3401a8ff":"iZJbi","4479506e8836bc53":"4stnp","f52980a8554368b6":"iMS0l","ebb4088eecdeeb62":"89fxU","4b60e915c6e3a8c9":"ff3VX","b02f72e4c0344330":"cvBWT","ff9d88affe8bfd9b":"7Yspg","e3fec83b77f1224d":"4Wjh2","d3bb7ae422c40fb":"4LWtg","9bea3a8daaf3d0f8":"akOht","173a894ed000e25d":"arHf6","162b3054360e7c1b":"1QYLF","b7d69ce8e4181b6e":"29rI6","70361df7144d5abb":"60iOt","46b7b2a0e5e4bb84":"1dlk8"}],"4LWtg":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("402de305bca1fbc6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Grow.default;
    }
});
var _Grow = _interopRequireDefault(require("9398f82f6390721b"));

},{"402de305bca1fbc6":"kZ6eK","9398f82f6390721b":"bcxqT"}],"bcxqT":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9f686df99c231199").default;
var _interopRequireWildcard = require("1240d096ffdc3c1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("87b97835440184fc"));
var _propTypes = _interopRequireDefault(require("b9041bdde6f96af9"));
var _useTimeout = _interopRequireDefault(require("cb7381b8f1f34100"));
var _elementAcceptingRef = _interopRequireDefault(require("2fb1bbf6fb16eed5"));
var _getReactElementRef = _interopRequireDefault(require("e7f496efb9c32b18"));
var _reactTransitionGroup = require("4042d5ca18a587f0");
var _zeroStyled = require("68fbc3b08c2ad217");
var _utils = require("144a3934b9f5c8cd");
var _useForkRef = _interopRequireDefault(require("36211d6d5aa453b"));
var _jsxRuntime = require("159b38b7c9cb929a");
function getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const styles = {
    entering: {
        opacity: 1,
        transform: getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Grow = /*#__PURE__*/ React.forwardRef(function Grow(props, ref) {
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = 'auto', // eslint-disable-next-line react/prop-types
    TransitionComponent = _reactTransitionGroup.Transition, ...other } = props;
    const timer = (0, _useTimeout.default)();
    const autoTimeout = React.useRef();
    const theme = (0, _zeroStyled.useTheme)();
    const nodeRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(nodeRef, (0, _getReactElementRef.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration,
                delay
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration,
                delay
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay: isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ React.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if (Grow) Grow.muiSupportAuto = true;
var _default = exports.default = Grow;

},{"9f686df99c231199":"kZ6eK","1240d096ffdc3c1":"fiRIh","87b97835440184fc":"9njXz","b9041bdde6f96af9":"bnNSm","cb7381b8f1f34100":"k3sgs","2fb1bbf6fb16eed5":"doIJ9","e7f496efb9c32b18":"gaXcx","4042d5ca18a587f0":"hnCQJ","68fbc3b08c2ad217":"89fxU","144a3934b9f5c8cd":"3QK1j","36211d6d5aa453b":"cq8Sn","159b38b7c9cb929a":"1dlk8"}],"3QK1j":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;
const reflow = (node)=>node.scrollTop;
exports.reflow = reflow;
function getTransitionProps(props, options) {
    const { timeout, easing, style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

},{}],"akOht":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ae0371c72601352d").default;
var _interopRequireDefault = require("4ce748c60138a119").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    ModalManager: true,
    modalClasses: true
};
Object.defineProperty(exports, "ModalManager", {
    enumerable: true,
    get: function() {
        return _ModalManager.ModalManager;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Modal.default;
    }
});
Object.defineProperty(exports, "modalClasses", {
    enumerable: true,
    get: function() {
        return _modalClasses.default;
    }
});
var _ModalManager = require("25b3ac199963d1b0");
var _Modal = _interopRequireDefault(require("e2f48b65a6447305"));
var _modalClasses = _interopRequireWildcard(require("30e676db7031e25e"));
Object.keys(_modalClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _modalClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _modalClasses[key];
        }
    });
});

},{"ae0371c72601352d":"fiRIh","4ce748c60138a119":"kZ6eK","25b3ac199963d1b0":"gr6Q3","e2f48b65a6447305":"16Ewb","30e676db7031e25e":"bbWSZ"}],"gr6Q3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2b2dde22f9a9f0cb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalManager = void 0;
exports.ariaHidden = ariaHidden;
var _ownerWindow = _interopRequireDefault(require("40a3b58e2443a2ae"));
var _ownerDocument = _interopRequireDefault(require("b839b628d3d2c8b0"));
var _getScrollbarSize = _interopRequireDefault(require("33d75fb4e53f83"));
// Is a vertical scrollbar displayed?
function isOverflowing(container) {
    const doc = (0, _ownerDocument.default)(container);
    if (doc.body === container) return (0, _ownerWindow.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function getPaddingRight(element) {
    return parseInt((0, _ownerWindow.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) ariaHidden(element, hide);
    });
}
function findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if (isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, _getScrollbarSize.default)((0, _ownerWindow.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, _ownerDocument.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, _ownerWindow.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value, el, property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ class ModalManager {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) ariaHidden(modal.modalRef, false);
        const hiddenSiblings = getHiddenSiblings(container);
        ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container,
            restore: null,
            hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            ariaHidden(modal.modalRef, ariaHiddenState);
            ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) ariaHidden(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}
exports.ModalManager = ModalManager;

},{"2b2dde22f9a9f0cb":"kZ6eK","40a3b58e2443a2ae":"hiDmU","b839b628d3d2c8b0":"8VgUE","33d75fb4e53f83":"3Gyjq"}],"16Ewb":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2136a78a23bbe0dd").default;
var _interopRequireWildcard = require("bd099673a16526a5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("52d855ffffd3bf3c"));
var _propTypes = _interopRequireDefault(require("18a5ef9d7f55d97c"));
var _clsx = _interopRequireDefault(require("a4333d3ff4eec8f6"));
var _HTMLElementType = _interopRequireDefault(require("49e0e894c23c8a65"));
var _elementAcceptingRef = _interopRequireDefault(require("a5a384c0548aebcd"));
var _composeClasses = _interopRequireDefault(require("522fbe334734ab8f"));
var _Unstable_TrapFocus = _interopRequireDefault(require("e6019914ef8e1b15"));
var _Portal = _interopRequireDefault(require("9dc0a08f03a3d68d"));
var _zeroStyled = require("33c23470eee1bbc8");
var _memoTheme = _interopRequireDefault(require("fd77f2873bb79535"));
var _DefaultPropsProvider = require("b06fc6fbaee606e5");
var _Backdrop = _interopRequireDefault(require("f757c1128a392d9c"));
var _useModal = _interopRequireDefault(require("994381de7459b72"));
var _modalClasses = require("d78e4d2974110068");
var _useSlot = _interopRequireDefault(require("50b1c90841e52052"));
var _jsxRuntime = require("33082184095a9ae9");
const useUtilityClasses = (ownerState)=>{
    const { open, exited, classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, _composeClasses.default)(slots, _modalClasses.getModalUtilityClass, classes);
};
const ModalRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const ModalBackdrop = (0, _zeroStyled.styled)(_Backdrop.default, {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const Modal = /*#__PURE__*/ React.forwardRef(function Modal(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent = ModalBackdrop, BackdropProps, classes: classesProp, className, closeAfterTransition = false, children, container, component, components = {}, componentsProps = {}, disableAutoFocus = false, disableEnforceFocus = false, disableEscapeKeyDown = false, disablePortal = false, disableRestoreFocus = false, disableScrollLock = false, hideBackdrop = false, keepMounted = false, onClose, onTransitionEnter, onTransitionExited, open, slotProps = {}, slots = {}, // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition,
        disableAutoFocus,
        disableEnforceFocus,
        disableEscapeKeyDown,
        disablePortal,
        disableRestoreFocus,
        disableScrollLock,
        hideBackdrop,
        keepMounted
    };
    const { getRootProps, getBackdropProps, getTransitionProps, portalRef, isTopModal, exited, hasTransition } = (0, _useModal.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited
    };
    const classes = useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter, onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        ref,
        elementType: ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component
        },
        getSlotProps: getRootProps,
        ownerState,
        className: (0, _clsx.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, _useSlot.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, _clsx.default)(BackdropProps?.className, classes?.backdrop),
        ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Portal.default, {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Unstable_TrapFocus.default, {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ React.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var _default = exports.default = Modal;

},{"2136a78a23bbe0dd":"kZ6eK","bd099673a16526a5":"fiRIh","52d855ffffd3bf3c":"9njXz","18a5ef9d7f55d97c":"bnNSm","a4333d3ff4eec8f6":"d2NWs","49e0e894c23c8a65":"eESPP","a5a384c0548aebcd":"doIJ9","522fbe334734ab8f":"59Equ","e6019914ef8e1b15":"6WLXP","9dc0a08f03a3d68d":"gdTpC","33c23470eee1bbc8":"89fxU","fd77f2873bb79535":"2zy52","b06fc6fbaee606e5":"ff3VX","f757c1128a392d9c":"j7994","994381de7459b72":"ehXGi","d78e4d2974110068":"bbWSZ","50b1c90841e52052":"29rI6","33082184095a9ae9":"1dlk8"}],"6WLXP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4452e118bbccff73").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FocusTrap.default;
    }
});
var _FocusTrap = _interopRequireDefault(require("5763cc51f1cb2189"));

},{"4452e118bbccff73":"kZ6eK","5763cc51f1cb2189":"e2A5w"}],"e2A5w":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ var _interopRequireDefault = require("7bba7d805cbdb9bb").default;
var _interopRequireWildcard = require("bd9f985bcd6ced6e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("3628b66e6dfe0391"));
var _propTypes = _interopRequireDefault(require("265ba9a37a5a40f1"));
var _useForkRef = _interopRequireDefault(require("14a61c8d06a06448"));
var _ownerDocument = _interopRequireDefault(require("ec65676d45e37b8a"));
var _getReactElementRef = _interopRequireDefault(require("931f427bbd6572b3"));
var _exactProp = _interopRequireDefault(require("7b581f7486abedd"));
var _elementAcceptingRef = _interopRequireDefault(require("2fa23af39b0ee99"));
var _jsxRuntime = require("7b1be9e99921e9d2");
// Inspired by https://github.com/focus-trap/tabbable
const candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) return false;
    return true;
}
function defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = getTabIndex(node);
        if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function FocusTrap(props) {
    const { children, disableAutoFocus = false, disableEnforceFocus = false, disableRestoreFocus = false, getTabbable = defaultGetTabbable, isEnabled = defaultIsEnabled, open } = props;
    const ignoreNextEnforceFocus = React.useRef(false);
    const sentinelStart = React.useRef(null);
    const sentinelEnd = React.useRef(null);
    const nodeToRestore = React.useRef(null);
    const reactFocusEventTarget = React.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = React.useRef(false);
    const rootRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)((0, _getReactElementRef.default)(children), rootRef);
    const lastKeydown = React.useRef(null);
    React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _ownerDocument.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _ownerDocument.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ React.cloneElement(children, {
                ref: handleRef,
                onFocus
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var _default = exports.default = FocusTrap;

},{"7bba7d805cbdb9bb":"kZ6eK","bd9f985bcd6ced6e":"fiRIh","3628b66e6dfe0391":"9njXz","265ba9a37a5a40f1":"bnNSm","14a61c8d06a06448":"4xKTx","ec65676d45e37b8a":"8VgUE","931f427bbd6572b3":"gaXcx","7b581f7486abedd":"jInuK","2fa23af39b0ee99":"doIJ9","7b1be9e99921e9d2":"1dlk8"}],"gdTpC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a82b907c840a8cb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Portal.default;
    }
});
var _Portal = _interopRequireDefault(require("abe16231f31b8b80"));

},{"a82b907c840a8cb":"kZ6eK","abe16231f31b8b80":"3t9n5"}],"3t9n5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a305e0f1f931ebf6").default;
var _interopRequireWildcard = require("8e592d796a7a7d3a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("571111d11e5a435b"));
var ReactDOM = _interopRequireWildcard(require("cc2a3f43f35ed13d"));
var _propTypes = _interopRequireDefault(require("317de9743800d2a0"));
var _useEnhancedEffect = _interopRequireDefault(require("76917d1776e31772"));
var _useForkRef = _interopRequireDefault(require("c7ffdee01f0617e6"));
var _setRef = _interopRequireDefault(require("1e0a5687d4afbf36"));
var _getReactElementRef = _interopRequireDefault(require("fe3ca14eef140fc3"));
var _exactProp = _interopRequireDefault(require("47e13bcfd3636134"));
var _HTMLElementType = _interopRequireDefault(require("8d53306b435c9785"));
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const Portal = /*#__PURE__*/ React.forwardRef(function Portal(props, forwardedRef) {
    const { children, container, disablePortal = false } = props;
    const [mountNode, setMountNode] = React.useState(null);
    const handleRef = (0, _useForkRef.default)(/*#__PURE__*/ React.isValidElement(children) ? (0, _getReactElementRef.default)(children) : null, forwardedRef);
    (0, _useEnhancedEffect.default)(()=>{
        if (!disablePortal) setMountNode(getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, _useEnhancedEffect.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, _setRef.default)(forwardedRef, mountNode);
            return ()=>{
                (0, _setRef.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ React.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ React.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ ReactDOM.createPortal(children, mountNode) : mountNode;
});
var _default = exports.default = Portal;

},{"a305e0f1f931ebf6":"kZ6eK","8e592d796a7a7d3a":"fiRIh","571111d11e5a435b":"9njXz","cc2a3f43f35ed13d":"2ApDx","317de9743800d2a0":"bnNSm","76917d1776e31772":"fIvqa","c7ffdee01f0617e6":"4xKTx","1e0a5687d4afbf36":"8uRhj","fe3ca14eef140fc3":"gaXcx","47e13bcfd3636134":"jInuK","8d53306b435c9785":"eESPP"}],"j7994":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("593ef55fd897046e").default;
var _interopRequireDefault = require("1903dc05c83558cb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    backdropClasses: true
};
Object.defineProperty(exports, "backdropClasses", {
    enumerable: true,
    get: function() {
        return _backdropClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Backdrop.default;
    }
});
var _Backdrop = _interopRequireDefault(require("7e484e23cc90fefb"));
var _backdropClasses = _interopRequireWildcard(require("5a86ad5b2e11eba3"));
Object.keys(_backdropClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _backdropClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _backdropClasses[key];
        }
    });
});

},{"593ef55fd897046e":"fiRIh","1903dc05c83558cb":"kZ6eK","7e484e23cc90fefb":"cd60q","5a86ad5b2e11eba3":"slXk3"}],"cd60q":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("4ca3f81ddf47e1ca").default;
var _interopRequireWildcard = require("35eddf3873bc8d2b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("5090ff25dad8be84"));
var _propTypes = _interopRequireDefault(require("f62c3bb7e6ed9a37"));
var _clsx = _interopRequireDefault(require("cc4294489f7e14fd"));
var _composeClasses = _interopRequireDefault(require("70cfa4497ba46a52"));
var _zeroStyled = require("cdb830dab25c715");
var _DefaultPropsProvider = require("1b3cb4e399d22511");
var _useSlot = _interopRequireDefault(require("47fc04374b26c64d"));
var _Fade = _interopRequireDefault(require("64887255165aed3d"));
var _backdropClasses = require("5f64f2a6dfb40c3e");
var _jsxRuntime = require("c126780ba3efac18");
const useUtilityClasses = (ownerState)=>{
    const { classes, invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, _composeClasses.default)(slots, _backdropClasses.getBackdropUtilityClass, classes);
};
const BackdropRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const Backdrop = /*#__PURE__*/ React.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children, className, component = 'div', invisible = false, open, components = {}, componentsProps = {}, slotProps = {}, slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component,
        invisible
    };
    const classes = useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        elementType: BackdropRoot,
        externalForwardedProps,
        className: (0, _clsx.default)(classes.root, className),
        ownerState
    });
    const [TransitionSlot, transitionProps] = (0, _useSlot.default)('transition', {
        elementType: _Fade.default,
        externalForwardedProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var _default = exports.default = Backdrop;

},{"4ca3f81ddf47e1ca":"kZ6eK","35eddf3873bc8d2b":"fiRIh","5090ff25dad8be84":"9njXz","f62c3bb7e6ed9a37":"bnNSm","cc4294489f7e14fd":"d2NWs","70cfa4497ba46a52":"59Equ","cdb830dab25c715":"89fxU","1b3cb4e399d22511":"ff3VX","47fc04374b26c64d":"29rI6","64887255165aed3d":"8DwqP","5f64f2a6dfb40c3e":"slXk3","c126780ba3efac18":"1dlk8"}],"8DwqP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7bdf32b70925fad1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Fade.default;
    }
});
var _Fade = _interopRequireDefault(require("79b13ce0b9abff92"));

},{"7bdf32b70925fad1":"kZ6eK","79b13ce0b9abff92":"3s8eU"}],"3s8eU":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("42b633c2f98a26bf").default;
var _interopRequireWildcard = require("56932de67ca6e437").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("a1b1e6ee935f1a0a"));
var _propTypes = _interopRequireDefault(require("b7d27567cbef186f"));
var _reactTransitionGroup = require("8dff7d03a72bdab8");
var _elementAcceptingRef = _interopRequireDefault(require("869f8532d3efaf99"));
var _getReactElementRef = _interopRequireDefault(require("10d15568538f413b"));
var _zeroStyled = require("1faf7e79538394c4");
var _utils = require("a2b9f759929bab29");
var _useForkRef = _interopRequireDefault(require("f86caa19df42bdde"));
var _jsxRuntime = require("a371859ecab2f362");
const styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Fade = /*#__PURE__*/ React.forwardRef(function Fade(props, ref) {
    const theme = (0, _zeroStyled.useTheme)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = defaultTimeout, // eslint-disable-next-line react/prop-types
    TransitionComponent = _reactTransitionGroup.Transition, ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(nodeRef, (0, _getReactElementRef.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ React.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var _default = exports.default = Fade;

},{"42b633c2f98a26bf":"kZ6eK","56932de67ca6e437":"fiRIh","a1b1e6ee935f1a0a":"9njXz","b7d27567cbef186f":"bnNSm","8dff7d03a72bdab8":"hnCQJ","869f8532d3efaf99":"doIJ9","10d15568538f413b":"gaXcx","1faf7e79538394c4":"89fxU","a2b9f759929bab29":"3QK1j","f86caa19df42bdde":"cq8Sn","a371859ecab2f362":"1dlk8"}],"slXk3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("abec8fbd95771f91").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getBackdropUtilityClass = getBackdropUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("c7c7f039bc146c88"));
var _generateUtilityClass = _interopRequireDefault(require("a09027eb332557d7"));
function getBackdropUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiBackdrop', slot);
}
const backdropClasses = (0, _generateUtilityClasses.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var _default = exports.default = backdropClasses;

},{"abec8fbd95771f91":"kZ6eK","c7c7f039bc146c88":"7pSUk","a09027eb332557d7":"jBs9M"}],"ehXGi":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9a3a6bbf57d0fa81").default;
var _interopRequireWildcard = require("6b236119c247499").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("710f03af68b0c961"));
var _ownerDocument = _interopRequireDefault(require("d381b4d14c45664c"));
var _useForkRef = _interopRequireDefault(require("5d6cbff0169bc4d3"));
var _useEventCallback = _interopRequireDefault(require("157c6b8a6dc3e984"));
var _createChainedFunction = _interopRequireDefault(require("8967fa15701e54df"));
var _extractEventHandlers = _interopRequireDefault(require("d023343846da80a7"));
var _ModalManager = require("c2be68ae7e38012");
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const manager = new _ModalManager.ModalManager();
function useModal(parameters) {
    const { container, disableEscapeKeyDown = false, disableScrollLock = false, closeAfterTransition = false, onTransitionEnter, onTransitionExited, children, onClose, open, rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = React.useRef({});
    const mountNodeRef = React.useRef(null);
    const modalRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(modalRef, rootRef);
    const [exited, setExited] = React.useState(!open);
    const hasTransition = getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, _ownerDocument.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, _useEventCallback.default)(()=>{
        const resolvedContainer = getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>manager.isTopModal(getModal());
    const handlePortalRef = (0, _useEventCallback.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, _ModalManager.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = React.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    React.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    React.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, _extractEventHandlers.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, _createChainedFunction.default)(handleEnter, children?.props.onEnter ?? noop),
            onExited: (0, _createChainedFunction.default)(handleExited, children?.props.onExited ?? noop)
        };
    };
    return {
        getRootProps,
        getBackdropProps,
        getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal,
        exited,
        hasTransition
    };
}
var _default = exports.default = useModal;

},{"9a3a6bbf57d0fa81":"kZ6eK","6b236119c247499":"fiRIh","710f03af68b0c961":"9njXz","d381b4d14c45664c":"8VgUE","5d6cbff0169bc4d3":"4xKTx","157c6b8a6dc3e984":"feNJe","8967fa15701e54df":"hSI0h","d023343846da80a7":"9lxhE","c2be68ae7e38012":"gr6Q3"}],"bbWSZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5a10c15a2222e76a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getModalUtilityClass = getModalUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("7363119092d53a3e"));
var _generateUtilityClass = _interopRequireDefault(require("9993efa0cf6fad72"));
function getModalUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiModal', slot);
}
const modalClasses = (0, _generateUtilityClasses.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var _default = exports.default = modalClasses;

},{"5a10c15a2222e76a":"kZ6eK","7363119092d53a3e":"7pSUk","9993efa0cf6fad72":"jBs9M"}],"arHf6":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("1a15425af575814").default;
var _interopRequireDefault = require("502f5cb55eabcc34").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    paperClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Paper.default;
    }
});
Object.defineProperty(exports, "paperClasses", {
    enumerable: true,
    get: function() {
        return _paperClasses.default;
    }
});
var _Paper = _interopRequireDefault(require("90967a777ed8b3e2"));
var _paperClasses = _interopRequireWildcard(require("556f99d46cdfcefc"));
Object.keys(_paperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _paperClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _paperClasses[key];
        }
    });
});

},{"1a15425af575814":"fiRIh","502f5cb55eabcc34":"kZ6eK","90967a777ed8b3e2":"cTBJg","556f99d46cdfcefc":"3JLuT"}],"cTBJg":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ad5438173171835e").default;
var _interopRequireWildcard = require("bdfe31587d6172").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("1479baa2ef87e775"));
var _propTypes = _interopRequireDefault(require("61ef64a093397acc"));
var _clsx = _interopRequireDefault(require("93a22d205cc517d4"));
var _integerPropType = _interopRequireDefault(require("3cab26a0d36c9e1e"));
var _chainPropTypes = _interopRequireDefault(require("e4f8bb946e6e1f99"));
var _composeClasses = _interopRequireDefault(require("978c80495be7eb62"));
var _colorManipulator = require("b81345d1a3619252");
var _zeroStyled = require("f39c5ce3474dd913");
var _memoTheme = _interopRequireDefault(require("9b58fad6d20e311e"));
var _DefaultPropsProvider = require("68efba4f82314e29");
var _getOverlayAlpha = _interopRequireDefault(require("d702e92d4649d529"));
var _paperClasses = require("b6f95c8289db90a");
var _jsxRuntime = require("911284f711ba98ab");
const useUtilityClasses = (ownerState)=>{
    const { square, elevation, variant, classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, _composeClasses.default)(slots, _paperClasses.getPaperUtilityClass, classes);
};
const PaperRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const Paper = /*#__PURE__*/ React.forwardRef(function Paper(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, _zeroStyled.useTheme)();
    const { className, component = 'div', elevation = 1, square = false, variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component,
        elevation,
        square,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlpha.default)(elevation))}, ${(0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlpha.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var _default = exports.default = Paper;

},{"ad5438173171835e":"kZ6eK","bdfe31587d6172":"fiRIh","1479baa2ef87e775":"9njXz","61ef64a093397acc":"bnNSm","93a22d205cc517d4":"d2NWs","3cab26a0d36c9e1e":"iZJbi","e4f8bb946e6e1f99":"4stnp","978c80495be7eb62":"59Equ","b81345d1a3619252":"hTYBL","f39c5ce3474dd913":"89fxU","9b58fad6d20e311e":"2zy52","68efba4f82314e29":"ff3VX","d702e92d4649d529":"5bDnG","b6f95c8289db90a":"3JLuT","911284f711ba98ab":"1dlk8"}],"3JLuT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f81a37999885f0fe").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPaperUtilityClass = getPaperUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("6edf324be06730bc"));
var _generateUtilityClass = _interopRequireDefault(require("d193dbccee3f98a6"));
function getPaperUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPaper', slot);
}
const paperClasses = (0, _generateUtilityClasses.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var _default = exports.default = paperClasses;

},{"f81a37999885f0fe":"kZ6eK","6edf324be06730bc":"7pSUk","d193dbccee3f98a6":"jBs9M"}],"1QYLF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3aaec368e55dfa16").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPopoverUtilityClass = getPopoverUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("614bcc7dd24e62f7"));
var _generateUtilityClass = _interopRequireDefault(require("613128809f7c7deb"));
function getPopoverUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPopover', slot);
}
const popoverClasses = (0, _generateUtilityClasses.default)('MuiPopover', [
    'root',
    'paper'
]);
var _default = exports.default = popoverClasses;

},{"3aaec368e55dfa16":"kZ6eK","614bcc7dd24e62f7":"7pSUk","613128809f7c7deb":"jBs9M"}],"3yXu4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7f974c4f97bb8649").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getMenuUtilityClass = getMenuUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4214a2b15b209d"));
var _generateUtilityClass = _interopRequireDefault(require("1944b522d8c329b9"));
function getMenuUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiMenu', slot);
}
const menuClasses = (0, _generateUtilityClasses.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var _default = exports.default = menuClasses;

},{"7f974c4f97bb8649":"kZ6eK","4214a2b15b209d":"7pSUk","1944b522d8c329b9":"jBs9M"}],"lLoCh":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b9f9a287758b610a").default;
var _interopRequireWildcard = require("473ac7f0e5c5189e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.StyledSelectSelect = exports.StyledSelectIcon = void 0;
var React = _interopRequireWildcard(require("da33ae65bafb3bce"));
var _propTypes = _interopRequireDefault(require("d43ae970a173897c"));
var _clsx = _interopRequireDefault(require("fc57e7285106c28a"));
var _refType = _interopRequireDefault(require("8dc14a6b4835779e"));
var _composeClasses = _interopRequireDefault(require("96c23634ce795558"));
var _capitalize = _interopRequireDefault(require("553d75d5d71065dc"));
var _nativeSelectClasses = _interopRequireWildcard(require("5cd6ca97f6cb34a"));
var _zeroStyled = require("92d82a0fce46eab4");
var _rootShouldForwardProp = _interopRequireDefault(require("94e1cd0924ad2605"));
var _jsxRuntime = require("db175c71a74869af");
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, _capitalize.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, _composeClasses.default)(slots, _nativeSelectClasses.getNativeSelectUtilityClasses, classes);
};
const StyledSelectSelect = exports.StyledSelectSelect = (0, _zeroStyled.styled)('select')(({ theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${_nativeSelectClasses.default.disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const NativeSelectSelect = (0, _zeroStyled.styled)(StyledSelectSelect, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: _rootShouldForwardProp.default,
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${_nativeSelectClasses.default.multiple}`]: styles.multiple
            }
        ];
    }
})({});
const StyledSelectIcon = exports.StyledSelectIcon = (0, _zeroStyled.styled)('svg')(({ theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${_nativeSelectClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const NativeSelectIcon = (0, _zeroStyled.styled)(StyledSelectIcon, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalize.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const NativeSelectInput = /*#__PURE__*/ React.forwardRef(function NativeSelectInput(props, ref) {
    const { className, disabled, error, IconComponent, inputRef, variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled,
        variant,
        error
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, _clsx.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var _default = exports.default = NativeSelectInput;

},{"b9f9a287758b610a":"kZ6eK","473ac7f0e5c5189e":"fiRIh","da33ae65bafb3bce":"9njXz","d43ae970a173897c":"bnNSm","fc57e7285106c28a":"d2NWs","8dc14a6b4835779e":"3TBXN","96c23634ce795558":"59Equ","553d75d5d71065dc":"hBZko","5cd6ca97f6cb34a":"N1g2C","92d82a0fce46eab4":"89fxU","94e1cd0924ad2605":"dIcrQ","db175c71a74869af":"1dlk8"}],"N1g2C":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("81c09defb24fa7e3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getNativeSelectUtilityClasses = getNativeSelectUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("a7758fc91e129f5e"));
var _generateUtilityClass = _interopRequireDefault(require("499937912c7d3d75"));
function getNativeSelectUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiNativeSelect', slot);
}
const nativeSelectClasses = (0, _generateUtilityClasses.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var _default = exports.default = nativeSelectClasses;

},{"81c09defb24fa7e3":"kZ6eK","a7758fc91e129f5e":"7pSUk","499937912c7d3d75":"jBs9M"}],"fqIdL":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7ac3f177bbc3ffed").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getSelectUtilityClasses = getSelectUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("fe9c09f0ae73b6f6"));
var _generateUtilityClass = _interopRequireDefault(require("5f1758b509923b22"));
function getSelectUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiSelect', slot);
}
const selectClasses = (0, _generateUtilityClasses.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var _default = exports.default = selectClasses;

},{"7ac3f177bbc3ffed":"kZ6eK","fe9c09f0ae73b6f6":"7pSUk","5f1758b509923b22":"jBs9M"}],"1gNb2":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("116b18b7337a1d5e").default;
var _interopRequireWildcard = require("77440cdb4402b513").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("8bddc1e9f815f2e2"));
var _createSvgIcon = _interopRequireDefault(require("5f82fc045a666558"));
var _jsxRuntime = require("7073e13fc7ccfa3b");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

},{"116b18b7337a1d5e":"kZ6eK","77440cdb4402b513":"fiRIh","8bddc1e9f815f2e2":"9njXz","5f82fc045a666558":"k1uMV","7073e13fc7ccfa3b":"1dlk8"}],"cVE4u":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("651f7e9e440d3731").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTextFieldUtilityClass = getTextFieldUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("efd8830ac762e392"));
var _generateUtilityClass = _interopRequireDefault(require("482f1884079f605d"));
function getTextFieldUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTextField', slot);
}
const textFieldClasses = (0, _generateUtilityClasses.default)('MuiTextField', [
    'root'
]);
var _default = exports.default = textFieldClasses;

},{"651f7e9e440d3731":"kZ6eK","efd8830ac762e392":"7pSUk","482f1884079f605d":"jBs9M"}],"jiJDh":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("4a5f3f236284522b").default;
var _interopRequireDefault = require("dc5a13cde09fb57c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    inputAdornmentClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _InputAdornment.default;
    }
});
Object.defineProperty(exports, "inputAdornmentClasses", {
    enumerable: true,
    get: function() {
        return _inputAdornmentClasses.default;
    }
});
var _InputAdornment = _interopRequireDefault(require("f498c9f388d2b896"));
var _inputAdornmentClasses = _interopRequireWildcard(require("50ff0c91b417a60b"));
Object.keys(_inputAdornmentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _inputAdornmentClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _inputAdornmentClasses[key];
        }
    });
});

},{"4a5f3f236284522b":"fiRIh","dc5a13cde09fb57c":"kZ6eK","f498c9f388d2b896":"hJGIl","50ff0c91b417a60b":"hwNA5"}],"hJGIl":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("772cac3832bb0753").default;
var _interopRequireDefault = require("b77e4f13ef5b0baa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("36310392581b242c"));
var _propTypes = _interopRequireDefault(require("6e982cae324746c4"));
var _clsx = _interopRequireDefault(require("2dc9b9bc23174634"));
var _composeClasses = _interopRequireDefault(require("36bdbad4e7d84f43"));
var _capitalize = _interopRequireDefault(require("2d865a0141ed4b1e"));
var _Typography = _interopRequireDefault(require("7550df7397596265"));
var _FormControlContext = _interopRequireDefault(require("ecdcc37618f72a94"));
var _useFormControl = _interopRequireDefault(require("e82f287cb3a76ebb"));
var _zeroStyled = require("7d1a81459d101eed");
var _memoTheme = _interopRequireDefault(require("8f8b9558394c3f9b"));
var _DefaultPropsProvider = require("334a2ef49e55f233");
var _inputAdornmentClasses = _interopRequireWildcard(require("3a7ba3d0a2e02e7c"));
var _jsxRuntime = require("45a913d5f9ff4efc");
var _span;
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, _capitalize.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePointerEvents, hiddenLabel, position, size, variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, _capitalize.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, _capitalize.default)(size)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _inputAdornmentClasses.getInputAdornmentUtilityClass, classes);
};
const InputAdornmentRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${_inputAdornmentClasses.default.positionStart}&:not(.${_inputAdornmentClasses.default.hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const InputAdornment = /*#__PURE__*/ React.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children, className, component = 'div', disablePointerEvents = false, disableTypography = false, position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents,
        position,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormControlContext.default.Provider, {
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Typography.default, {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var _default = exports.default = InputAdornment;

},{"772cac3832bb0753":"fiRIh","b77e4f13ef5b0baa":"kZ6eK","36310392581b242c":"9njXz","6e982cae324746c4":"bnNSm","2dc9b9bc23174634":"d2NWs","36bdbad4e7d84f43":"59Equ","2d865a0141ed4b1e":"hBZko","7550df7397596265":"2wCD5","ecdcc37618f72a94":"lcpxD","e82f287cb3a76ebb":"H1I5Z","7d1a81459d101eed":"89fxU","8f8b9558394c3f9b":"2zy52","334a2ef49e55f233":"ff3VX","3a7ba3d0a2e02e7c":"hwNA5","45a913d5f9ff4efc":"1dlk8"}],"hwNA5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f4513cbc2f2e22b7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getInputAdornmentUtilityClass = getInputAdornmentUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4c70040ca8a6c893"));
var _generateUtilityClass = _interopRequireDefault(require("cc8ab8d29e776c92"));
function getInputAdornmentUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiInputAdornment', slot);
}
const inputAdornmentClasses = (0, _generateUtilityClasses.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var _default = exports.default = inputAdornmentClasses;

},{"f4513cbc2f2e22b7":"kZ6eK","4c70040ca8a6c893":"7pSUk","cc8ab8d29e776c92":"jBs9M"}],"2guyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFieldOwnerState", ()=>useFieldOwnerState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _rtlProvider = require("@mui/system/RtlProvider");
var _usePickerPrivateContextJs = require("./usePickerPrivateContext.js");
function useFieldOwnerState(parameters) {
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const isRtl = (0, _rtlProvider.useRtl)();
    return _react.useMemo(()=>(0, _extendsDefault.default)({}, pickerOwnerState, {
            isFieldDisabled: parameters.disabled ?? false,
            isFieldReadOnly: parameters.readOnly ?? false,
            isFieldRequired: parameters.required ?? false,
            fieldDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        parameters.disabled,
        parameters.readOnly,
        parameters.required,
        isRtl
    ]);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/system/RtlProvider":"ck9Pb","./usePickerPrivateContext.js":"4puZL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h8KWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersTextField", ()=>(0, _pickersTextFieldJs.PickersTextField));
parcelHelpers.export(exports, "pickersTextFieldClasses", ()=>(0, _pickersTextFieldClassesJs.pickersTextFieldClasses));
parcelHelpers.export(exports, "getPickersTextFieldUtilityClass", ()=>(0, _pickersTextFieldClassesJs.getPickersTextFieldUtilityClass));
var _pickersTextFieldJs = require("./PickersTextField.js");
var _pickersTextFieldClassesJs = require("./pickersTextFieldClasses.js");
var _indexJs = require("./PickersInput/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _indexJs1 = require("./PickersFilledInput/index.js");
parcelHelpers.exportAll(_indexJs1, exports);
var _indexJs2 = require("./PickersOutlinedInput/index.js");
parcelHelpers.exportAll(_indexJs2, exports);
var _indexJs3 = require("./PickersInputBase/index.js");
parcelHelpers.exportAll(_indexJs3, exports);

},{"./PickersTextField.js":"3cVjO","./pickersTextFieldClasses.js":false,"./PickersInput/index.js":false,"./PickersFilledInput/index.js":false,"./PickersOutlinedInput/index.js":false,"./PickersInputBase/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cVjO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersTextField", ()=>PickersTextField);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _pickersTextFieldClassesJs = require("./pickersTextFieldClasses.js");
var _indexJs = require("./PickersOutlinedInput/index.js");
var _indexJs1 = require("./PickersFilledInput/index.js");
var _indexJs2 = require("./PickersInput/index.js");
var _useFieldOwnerStateJs = require("../internals/hooks/useFieldOwnerState.js");
var _usePickerTextFieldOwnerStateJs = require("./usePickerTextFieldOwnerState.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "onFocus",
    "onBlur",
    "className",
    "classes",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps",
    "data-active-range-position"
];
const VARIANT_COMPONENT = {
    standard: (0, _indexJs2.PickersInput),
    filled: (0, _indexJs1.PickersFilledInput),
    outlined: (0, _indexJs.PickersOutlinedInput)
};
const PickersTextFieldRoot = (0, _styles.styled)((0, _formControlDefault.default), {
    name: 'MuiPickersTextField',
    slot: 'Root'
})({
    maxWidth: '100%'
});
const useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused, isFieldDisabled, isFieldRequired } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldRequired && 'required'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersTextFieldClassesJs.getPickersTextFieldUtilityClass), classes);
};
const PickersTextField = /*#__PURE__*/ _react.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { // Props used by FormControl
    onFocus, onBlur, className, classes: classesProp, color = 'primary', disabled = false, error = false, variant = 'outlined', required = false, // Props used by PickersInput
    InputProps, inputProps, inputRef, sectionListRef, elements, areAllSectionsEmpty, onClick, onKeyDown, onKeyUp, onPaste, onInput, endAdornment, startAdornment, tabIndex, contentEditable, focused, value, onChange, fullWidth, id: idProp, name, // Props used by FormHelperText
    helperText, FormHelperTextProps, // Props used by InputLabel
    label, InputLabelProps, // @ts-ignore
    'data-active-range-position': dataActiveRangePosition } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootRef = _react.useRef(null);
    const handleRootRef = (0, _useForkRefDefault.default)(ref, rootRef);
    const id = (0, _useIdDefault.default)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const fieldOwnerState = (0, _useFieldOwnerStateJs.useFieldOwnerState)({
        disabled: props.disabled,
        required: props.required,
        readOnly: InputProps?.readOnly
    });
    const ownerState = _react.useMemo(()=>(0, _extendsDefault.default)({}, fieldOwnerState, {
            isFieldValueEmpty: areAllSectionsEmpty,
            isFieldFocused: focused ?? false,
            hasFieldError: error ?? false,
            inputSize: props.size ?? 'medium',
            inputColor: color ?? 'primary',
            isInputInFullWidth: fullWidth ?? false,
            hasStartAdornment: Boolean(startAdornment ?? InputProps?.startAdornment),
            hasEndAdornment: Boolean(endAdornment ?? InputProps?.endAdornment),
            inputHasLabel: !!label
        }), [
        fieldOwnerState,
        areAllSectionsEmpty,
        focused,
        error,
        props.size,
        color,
        fullWidth,
        startAdornment,
        endAdornment,
        InputProps?.startAdornment,
        InputProps?.endAdornment,
        label
    ]);
    const classes = useUtilityClasses(classesProp, ownerState);
    const PickersInputComponent = VARIANT_COMPONENT[variant];
    const inputAdditionalProps = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') inputAdditionalProps.notched = InputLabelProps.shrink;
        inputAdditionalProps.label = label;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usePickerTextFieldOwnerStateJs.PickerTextFieldOwnerStateContext).Provider, {
        value: ownerState,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersTextFieldRoot, (0, _extendsDefault.default)({
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: handleRootRef,
            focused: focused,
            disabled: disabled,
            variant: variant,
            error: error,
            color: color,
            fullWidth: fullWidth,
            required: required,
            ownerState: ownerState
        }, other, {
            children: [
                label != null && label !== '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), (0, _extendsDefault.default)({
                    htmlFor: id,
                    id: inputLabelId
                }, InputLabelProps, {
                    children: label
                })),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersInputComponent, (0, _extendsDefault.default)({
                    elements: elements,
                    areAllSectionsEmpty: areAllSectionsEmpty,
                    onClick: onClick,
                    onKeyDown: onKeyDown,
                    onKeyUp: onKeyUp,
                    onInput: onInput,
                    onPaste: onPaste,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    endAdornment: endAdornment,
                    startAdornment: startAdornment,
                    tabIndex: tabIndex,
                    contentEditable: contentEditable,
                    value: value,
                    onChange: onChange,
                    id: id,
                    fullWidth: fullWidth,
                    inputProps: inputProps,
                    inputRef: inputRef,
                    sectionListRef: sectionListRef,
                    label: label,
                    name: name,
                    role: "group",
                    "aria-labelledby": inputLabelId,
                    "aria-describedby": helperTextId,
                    "aria-live": helperTextId ? 'polite' : undefined,
                    "data-active-range-position": dataActiveRangePosition
                }, inputAdditionalProps, InputProps)),
                helperText && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), (0, _extendsDefault.default)({
                    id: helperTextId
                }, FormHelperTextProps, {
                    children: helperText
                }))
            ]
        }))
    });
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/material/styles":"c9RfU","@mui/utils/refType":"3TBXN","@mui/utils/useForkRef":"4xKTx","@mui/utils/composeClasses":"59Equ","@mui/utils/useId":"50qgI","@mui/material/InputLabel":"iTW3B","@mui/material/FormHelperText":"dlh9L","@mui/material/FormControl":"kkska","./pickersTextFieldClasses.js":"2NFsN","./PickersOutlinedInput/index.js":"6V3jz","./PickersFilledInput/index.js":"fdFVM","./PickersInput/index.js":"l8q9U","../internals/hooks/useFieldOwnerState.js":"2guyG","./usePickerTextFieldOwnerState.js":"2vGeV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2NFsN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersTextFieldUtilityClass", ()=>getPickersTextFieldUtilityClass);
parcelHelpers.export(exports, "pickersTextFieldClasses", ()=>pickersTextFieldClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getPickersTextFieldUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersTextField', slot);
}
const pickersTextFieldClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6V3jz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersOutlinedInput", ()=>(0, _pickersOutlinedInputJs.PickersOutlinedInput));
parcelHelpers.export(exports, "getPickersOutlinedInputUtilityClass", ()=>(0, _pickersOutlinedInputClassesJs.getPickersOutlinedInputUtilityClass));
parcelHelpers.export(exports, "pickersOutlinedInputClasses", ()=>(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses));
var _pickersOutlinedInputJs = require("./PickersOutlinedInput.js");
var _pickersOutlinedInputClassesJs = require("./pickersOutlinedInputClasses.js");

},{"./PickersOutlinedInput.js":"dj7UO","./pickersOutlinedInputClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dj7UO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersOutlinedInput", ()=>PickersOutlinedInput);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _formControl = require("@mui/material/FormControl");
var _styles = require("@mui/material/styles");
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _pickersOutlinedInputClassesJs = require("./pickersOutlinedInputClasses.js");
var _outlineJs = require("./Outline.js");
var _outlineJsDefault = parcelHelpers.interopDefault(_outlineJs);
var _indexJs = require("../PickersInputBase/index.js");
var _pickersInputBaseJs = require("../PickersInputBase/PickersInputBase.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "classes",
    "notched"
];
const PickersOutlinedInputRoot = (0, _styles.styled)((0, _pickersInputBaseJs.PickersInputBaseRoot), {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root'
})(({ theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).focused} .${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).disabled}`]: {
            [`& .${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            '*': {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).error} .${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    inputColor: color
                },
                style: {
                    [`&.${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).focused}:not(.${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).error}) .${(0, _pickersOutlinedInputClassesJs.pickersOutlinedInputClasses).notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const PickersOutlinedInputSectionsContainer = (0, _styles.styled)((0, _pickersInputBaseJs.PickersInputBaseSectionsContainer), {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer'
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _pickersOutlinedInputClassesJs.getPickersOutlinedInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const PickersOutlinedInput = /*#__PURE__*/ _react.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label, classes: classesProp, notched } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _formControl.useFormControl)();
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.PickersInputBase), (0, _extendsDefault.default)({
        slots: {
            root: PickersOutlinedInputRoot,
            input: PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlineJsDefault.default), {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== '' && muiFormControl?.required ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
PickersOutlinedInput.muiName = 'Input';

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/material/FormControl":"kkska","@mui/material/styles":"c9RfU","@mui/utils/refType":"3TBXN","@mui/utils/composeClasses":"59Equ","./pickersOutlinedInputClasses.js":"hO8kE","./Outline.js":"6avXU","../PickersInputBase/index.js":"dnBHf","../PickersInputBase/PickersInputBase.js":"fDMVQ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hO8kE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersOutlinedInputUtilityClass", ()=>getPickersOutlinedInputUtilityClass);
parcelHelpers.export(exports, "pickersOutlinedInputClasses", ()=>pickersOutlinedInputClasses);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _indexJs = require("../PickersInputBase/index.js");
function getPickersOutlinedInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersOutlinedInput', slot);
}
const pickersOutlinedInputClasses = (0, _extendsDefault.default)({}, (0, _indexJs.pickersInputBaseClasses), (0, _generateUtilityClassesDefault.default)('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/generateUtilityClasses":"7pSUk","@mui/utils/generateUtilityClass":"jBs9M","../PickersInputBase/index.js":"dnBHf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dnBHf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersInputBase", ()=>(0, _pickersInputBaseJs.PickersInputBase));
parcelHelpers.export(exports, "pickersInputBaseClasses", ()=>(0, _pickersInputBaseClassesJs.pickersInputBaseClasses));
parcelHelpers.export(exports, "getPickersInputBaseUtilityClass", ()=>(0, _pickersInputBaseClassesJs.getPickersInputBaseUtilityClass));
var _pickersInputBaseJs = require("./PickersInputBase.js");
var _pickersInputBaseClassesJs = require("./pickersInputBaseClasses.js");

},{"./PickersInputBase.js":"fDMVQ","./pickersInputBaseClasses.js":"jkkZ0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fDMVQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersInputBaseRoot", ()=>PickersInputBaseRoot);
parcelHelpers.export(exports, "PickersInputBaseSectionsContainer", ()=>PickersInputBaseSectionsContainer);
parcelHelpers.export(exports, "PickersInputBase", ()=>PickersInputBase);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _formControl = require("@mui/material/FormControl");
var _styles = require("@mui/material/styles");
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _visuallyHidden = require("@mui/utils/visuallyHidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _pickersInputBaseClassesJs = require("./pickersInputBaseClasses.js");
var _indexJs = require("../../PickersSectionList/index.js");
var _usePickerTextFieldOwnerStateJs = require("../usePickerTextFieldOwnerState.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "onFocus",
    "onBlur",
    "classes",
    "ownerState"
];
const round = (value)=>Math.round(value * 1e5) / 1e5;
const PickersInputBaseRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root'
})(({ theme })=>(0, _extendsDefault.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        letterSpacing: `${round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    isInputInFullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const PickersInputBaseSectionsContainer = (0, _styles.styled)((0, _indexJs.Unstable_PickersSectionListRoot), {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer'
})(({ theme })=>({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        // Baseline behavior
        width: '182px',
        variants: [
            {
                props: {
                    fieldDirection: 'rtl'
                },
                style: {
                    textAlign: 'right /*! @noflip */'
                }
            },
            {
                props: {
                    inputSize: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true
                },
                style: {
                    color: 'currentColor',
                    opacity: 0
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: false
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            }
        ]
    }));
const PickersInputBaseSection = (0, _styles.styled)((0, _indexJs.Unstable_PickersSectionListSection), {
    name: 'MuiPickersInputBase',
    slot: 'Section'
})(({ theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        display: 'inline-block',
        whiteSpace: 'nowrap'
    }));
const PickersInputBaseSectionContent = (0, _styles.styled)((0, _indexJs.Unstable_PickersSectionListSectionContent), {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content // FIXME: Inconsistent naming with slot
})(({ theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        // 23px
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none'
    }));
const PickersInputBaseSectionSeparator = (0, _styles.styled)((0, _indexJs.Unstable_PickersSectionListSectionSeparator), {
    name: 'MuiPickersInputBase',
    slot: 'Separator'
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const PickersInputBaseInput = (0, _styles.styled)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput // FIXME: Inconsistent naming with slot
})((0, _extendsDefault.default)({}, (0, _visuallyHiddenDefault.default)));
const PickersInputBaseActiveBar = (0, _styles.styled)('div', {
    name: 'MuiPickersInputBase',
    slot: 'ActiveBar'
})(({ theme, ownerState })=>({
        display: 'none',
        position: 'absolute',
        height: 2,
        bottom: 2,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        transition: theme.transitions.create([
            'width',
            'left'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.primary.main,
        '[data-active-range-position="start"] &, [data-active-range-position="end"] &': {
            display: 'block'
        },
        '[data-active-range-position="start"] &': {
            left: ownerState.sectionOffsets[0]
        },
        '[data-active-range-position="end"] &': {
            left: ownerState.sectionOffsets[1]
        }
    }));
const useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused, isFieldDisabled, isFieldReadOnly, hasFieldError, inputSize, isInputInFullWidth, inputColor, hasStartAdornment, hasEndAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldReadOnly && 'readOnly',
            hasFieldError && 'error',
            isInputInFullWidth && 'fullWidth',
            `color${(0, _capitalizeDefault.default)(inputColor)}`,
            inputSize === 'small' && 'inputSizeSmall',
            hasStartAdornment && 'adornedStart',
            hasEndAdornment && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ],
        activeBar: [
            'activeBar'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersInputBaseClassesJs.getPickersInputBaseUtilityClass), classes);
};
function resolveSectionElementWidth(sectionElement, rootRef, index, dateRangePosition) {
    if (sectionElement.content.id) {
        const activeSectionElements = rootRef.current?.querySelectorAll(`[data-sectionindex="${index}"] [data-range-position="${dateRangePosition}"]`);
        if (activeSectionElements) return Array.from(activeSectionElements).reduce((currentActiveBarWidth, element)=>{
            return currentActiveBarWidth + element.offsetWidth;
        }, 0);
    }
    return 0;
}
function resolveSectionWidthAndOffsets(elements, rootRef) {
    let activeBarWidth = 0;
    const activeRangePosition = rootRef.current?.getAttribute('data-active-range-position');
    if (activeRangePosition === 'end') for(let i = elements.length - 1; i >= elements.length / 2; i -= 1)activeBarWidth += resolveSectionElementWidth(elements[i], rootRef, i, 'end');
    else for(let i = 0; i < elements.length / 2; i += 1)activeBarWidth += resolveSectionElementWidth(elements[i], rootRef, i, 'start');
    return {
        activeBarWidth,
        sectionOffsets: [
            rootRef.current?.querySelector(`[data-sectionindex="0"]`)?.offsetLeft || 0,
            rootRef.current?.querySelector(`[data-sectionindex="${elements.length / 2}"]`)?.offsetLeft || 0
        ]
    };
}
/**
 * @ignore - internal component.
 */ const PickersInputBase = /*#__PURE__*/ _react.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements, areAllSectionsEmpty, value, onChange, id, endAdornment, startAdornment, renderSuffix, slots, slotProps, contentEditable, tabIndex, onInput, onPaste, onKeyDown, name, readOnly, inputProps, inputRef, sectionListRef, onFocus, onBlur, classes: classesProp, ownerState: ownerStateProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerStateContext = (0, _usePickerTextFieldOwnerStateJs.usePickerTextFieldOwnerState)();
    const rootRef = _react.useRef(null);
    const activeBarRef = _react.useRef(null);
    const sectionOffsetsRef = _react.useRef([]);
    const handleRootRef = (0, _useForkRefDefault.default)(ref, rootRef);
    const handleInputRef = (0, _useForkRefDefault.default)(inputProps?.ref, inputRef);
    const muiFormControl = (0, _formControl.useFormControl)();
    if (!muiFormControl) throw new Error('MUI X: PickersInputBase should always be used inside a PickersTextField component');
    const ownerState = ownerStateProp ?? ownerStateContext;
    const handleInputFocus = (event)=>{
        muiFormControl.onFocus?.(event);
        onFocus?.(event);
    };
    const handleHiddenInputFocus = (event)=>{
        handleInputFocus(event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown?.(event);
        if (event.key === 'Enter' && !event.defaultMuiPrevented) {
            // Do nothing if it's a multi input field
            if (rootRef.current?.dataset.multiInput) return;
            const closestForm = rootRef.current?.closest('form');
            const submitTrigger = closestForm?.querySelector('[type="submit"]');
            if (!closestForm || !submitTrigger) // do nothing if there is no form or no submit button (trigger)
            return;
            event.preventDefault();
            // native input trigger submit with the `submitter` field set
            closestForm.requestSubmit(submitTrigger);
        }
    };
    const handleInputBlur = (event)=>{
        muiFormControl.onBlur?.(event);
        onBlur?.(event);
    };
    _react.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    _react.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const classes = useUtilityClasses(classesProp, ownerState);
    const InputRoot = slots?.root || PickersInputBaseRoot;
    const inputRootProps = (0, _useSlotPropsDefault.default)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState
    });
    const InputSectionsContainer = slots?.input || PickersInputBaseSectionsContainer;
    const isSingleInputRange = elements.some((element)=>element.content['data-range-position'] !== undefined);
    _react.useEffect(()=>{
        if (!isSingleInputRange || !ownerState.isPickerOpen) return;
        const { activeBarWidth, sectionOffsets } = resolveSectionWidthAndOffsets(elements, rootRef);
        sectionOffsetsRef.current = [
            sectionOffsets[0],
            sectionOffsets[1]
        ];
        if (activeBarRef.current) activeBarRef.current.style.width = `${activeBarWidth}px`;
    }, [
        elements,
        isSingleInputRange,
        ownerState.isPickerOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InputRoot, (0, _extendsDefault.default)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.Unstable_PickersSectionList), {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: handleInputBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: handleKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: PickersInputBaseSection,
                    sectionContent: PickersInputBaseSectionContent,
                    sectionSeparator: PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: (0, _extendsDefault.default)({}, slotProps?.input, {
                        ownerState
                    }),
                    sectionContent: {
                        className: (0, _pickersInputBaseClassesJs.pickersInputBaseClasses).sectionContent
                    },
                    sectionSeparator: ({ separatorPosition })=>({
                            className: separatorPosition === 'before' ? (0, _pickersInputBaseClassesJs.pickersInputBaseClasses).sectionBefore : (0, _pickersInputBaseClassesJs.pickersInputBaseClasses).sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, _extendsDefault.default)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersInputBaseInput, (0, _extendsDefault.default)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled,
                onFocus: handleHiddenInputFocus
            }, inputProps, {
                ref: handleInputRef
            })),
            isSingleInputRange && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersInputBaseActiveBar, {
                className: classes.activeBar,
                ref: activeBarRef,
                ownerState: {
                    sectionOffsets: sectionOffsetsRef.current
                }
            })
        ]
    }));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/material/FormControl":"kkska","@mui/material/styles":"c9RfU","@mui/utils/useForkRef":"4xKTx","@mui/utils/refType":"3TBXN","@mui/utils/composeClasses":"59Equ","@mui/utils/capitalize":"5sWY4","@mui/utils/useSlotProps":"kr4RG","@mui/utils/visuallyHidden":"1dLhw","./pickersInputBaseClasses.js":"jkkZ0","../../PickersSectionList/index.js":"b9FiY","../usePickerTextFieldOwnerState.js":"2vGeV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dLhw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d5c007b7db1d04b8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _visuallyHidden.default;
    }
});
var _visuallyHidden = _interopRequireDefault(require("34c70a15530efd2"));

},{"d5c007b7db1d04b8":"kZ6eK","34c70a15530efd2":"WKD8K"}],"WKD8K":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var _default = exports.default = visuallyHidden;

},{}],"jkkZ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersInputBaseUtilityClass", ()=>getPickersInputBaseUtilityClass);
parcelHelpers.export(exports, "pickersInputBaseClasses", ()=>pickersInputBaseClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getPickersInputBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersInputBase', slot);
}
const pickersInputBaseClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'error',
    'notchedOutline',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input',
    'activeBar'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b9FiY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Unstable_PickersSectionList", ()=>(0, _pickersSectionListJs.PickersSectionList));
parcelHelpers.export(exports, "Unstable_PickersSectionListRoot", ()=>(0, _pickersSectionListJs.PickersSectionListRoot));
parcelHelpers.export(exports, "Unstable_PickersSectionListSection", ()=>(0, _pickersSectionListJs.PickersSectionListSection));
parcelHelpers.export(exports, "Unstable_PickersSectionListSectionSeparator", ()=>(0, _pickersSectionListJs.PickersSectionListSectionSeparator));
parcelHelpers.export(exports, "Unstable_PickersSectionListSectionContent", ()=>(0, _pickersSectionListJs.PickersSectionListSectionContent));
parcelHelpers.export(exports, "getPickersSectionListUtilityClass", ()=>(0, _pickersSectionListClassesJs.getPickersSectionListUtilityClass));
parcelHelpers.export(exports, "pickersSectionListClasses", ()=>(0, _pickersSectionListClassesJs.pickersSectionListClasses));
var _pickersSectionListJs = require("./PickersSectionList.js");
var _pickersSectionListClassesJs = require("./pickersSectionListClasses.js");

},{"./PickersSectionList.js":"dKx9r","./pickersSectionListClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dKx9r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersSectionListRoot", ()=>PickersSectionListRoot);
parcelHelpers.export(exports, "PickersSectionListSection", ()=>PickersSectionListSection);
parcelHelpers.export(exports, "PickersSectionListSectionSeparator", ()=>PickersSectionListSectionSeparator);
parcelHelpers.export(exports, "PickersSectionListSectionContent", ()=>PickersSectionListSectionContent);
parcelHelpers.export(exports, "PickersSectionList", ()=>PickersSectionList);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _styles = require("@mui/material/styles");
var _pickersSectionListClassesJs = require("./pickersSectionListClasses.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef",
    "classes"
];
const PickersSectionListRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root'
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const PickersSectionListSection = (0, _styles.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section'
})({});
const PickersSectionListSectionSeparator = (0, _styles.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator'
})({
    whiteSpace: 'pre'
});
const PickersSectionListSectionContent = (0, _styles.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent'
})({
    outline: 'none'
});
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersSectionListClassesJs.getPickersSectionListUtilityClass), classes);
};
function PickersSection(props) {
    const { slots, slotProps, element, classes } = props;
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const Section = slots?.section ?? PickersSectionListSection;
    const sectionProps = (0, _useSlotPropsDefault.default)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState
    });
    const SectionContent = slots?.sectionContent ?? PickersSectionListSectionContent;
    const sectionContentProps = (0, _useSlotPropsDefault.default)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState
    });
    const SectionSeparator = slots?.sectionSeparator ?? PickersSectionListSectionSeparator;
    const sectionSeparatorBeforeProps = (0, _useSlotPropsDefault.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: (0, _extendsDefault.default)({}, ownerState, {
            separatorPosition: 'before'
        })
    });
    const sectionSeparatorAfterProps = (0, _useSlotPropsDefault.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: (0, _extendsDefault.default)({}, ownerState, {
            separatorPosition: 'after'
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Section, (0, _extendsDefault.default)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionSeparator, (0, _extendsDefault.default)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionContent, (0, _extendsDefault.default)({}, sectionContentProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionSeparator, (0, _extendsDefault.default)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const PickersSectionList = /*#__PURE__*/ _react.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots, slotProps, elements, sectionListRef, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(classesProp);
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const rootRef = _react.useRef(null);
    const handleRootRef = (0, _useForkRefDefault.default)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    _react.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${(0, _pickersSectionListClassesJs.pickersSectionListClasses).section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${(0, _pickersSectionListClassesJs.pickersSectionListClasses).section}[data-sectionindex="${index}"] .${(0, _pickersSectionListClassesJs.pickersSectionListClasses).sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains((0, _pickersSectionListClassesJs.pickersSectionListClasses).section)) sectionContainer = element;
                else if (element.classList.contains((0, _pickersSectionListClassesJs.pickersSectionListClasses).sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? PickersSectionListRoot;
    const rootProps = (0, _useSlotPropsDefault.default)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content, before, after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/utils/useSlotProps":"kr4RG","@mui/utils/composeClasses":"59Equ","@mui/utils/useForkRef":"4xKTx","@mui/material/styles":"c9RfU","./pickersSectionListClasses.js":"kljIe","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kljIe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersSectionListUtilityClass", ()=>getPickersSectionListUtilityClass);
parcelHelpers.export(exports, "pickersSectionListClasses", ()=>pickersSectionListClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getPickersSectionListUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersSectionList', slot);
}
const pickersSectionListClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2vGeV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerTextFieldOwnerStateContext", ()=>PickerTextFieldOwnerStateContext);
parcelHelpers.export(exports, "usePickerTextFieldOwnerState", ()=>usePickerTextFieldOwnerState);
var _react = require("react");
'use client';
const PickerTextFieldOwnerStateContext = /*#__PURE__*/ _react.createContext(null);
const usePickerTextFieldOwnerState = ()=>{
    const value = _react.useContext(PickerTextFieldOwnerStateContext);
    if (value == null) throw new Error([
        'MUI X: The `usePickerTextFieldOwnerState` can only be called in components that are used inside a PickerTextField component'
    ].join('\n'));
    return value;
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6avXU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Outline);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _styles = require("@mui/material/styles");
var _createStyled = require("@mui/system/createStyled");
var _usePickerTextFieldOwnerStateJs = require("../usePickerTextFieldOwnerState.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const OutlineRoot = (0, _styles.styled)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline'
})(({ theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const OutlineLabel = (0, _styles.styled)('span')(({ theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const OutlineLegend = (0, _styles.styled)('legend', {
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'notched'
})(({ theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    inputHasLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    inputHasLabel: true
                },
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    inputHasLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function Outline(props) {
    const { className, label, notched } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _usePickerTextFieldOwnerStateJs.usePickerTextFieldOwnerState)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutlineRoot, (0, _extendsDefault.default)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutlineLegend, {
            ownerState: ownerState,
            notched: notched,
            children: label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, _jsxRuntime.jsx)(OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","@mui/material/styles":"c9RfU","@mui/system/createStyled":"6ySdS","../usePickerTextFieldOwnerState.js":"2vGeV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fdFVM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersFilledInput", ()=>(0, _pickersFilledInputJs.PickersFilledInput));
parcelHelpers.export(exports, "getPickersFilledInputUtilityClass", ()=>(0, _pickersFilledInputClassesJs.getPickersFilledInputUtilityClass));
parcelHelpers.export(exports, "pickersFilledInputClasses", ()=>(0, _pickersFilledInputClassesJs.pickersFilledInputClasses));
var _pickersFilledInputJs = require("./PickersFilledInput.js");
var _pickersFilledInputClassesJs = require("./pickersFilledInputClasses.js");

},{"./PickersFilledInput.js":"fnycp","./pickersFilledInputClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fnycp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersFilledInput", ()=>PickersFilledInput);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _system = require("@mui/system");
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _pickersFilledInputClassesJs = require("./pickersFilledInputClasses.js");
var _indexJs = require("../PickersInputBase/index.js");
var _pickersInputBaseJs = require("../PickersInputBase/PickersInputBase.js");
var _usePickerTextFieldOwnerStateJs = require("../usePickerTextFieldOwnerState.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "hiddenLabel",
    "classes"
];
const PickersFilledInputRoot = (0, _styles.styled)((0, _pickersInputBaseJs.PickersInputBaseRoot), {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _system.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, _pickersFilledInputClassesJs.pickersFilledInputClasses).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, _pickersFilledInputClassesJs.pickersFilledInputClasses).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, _pickersFilledInputClassesJs.pickersFilledInputClasses).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, _pickersFilledInputClassesJs.pickersFilledInputClasses).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, _pickersFilledInputClassesJs.pickersFilledInputClasses).disabled}, .${(0, _pickersFilledInputClassesJs.pickersFilledInputClasses).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, _pickersFilledInputClassesJs.pickersFilledInputClasses).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: {
                    hasStartAdornment: true
                },
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: {
                    hasEndAdornment: true
                },
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const PickersFilledSectionsContainer = (0, _styles.styled)((0, _pickersInputBaseJs.PickersInputBaseSectionsContainer), {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    shouldForwardProp: (prop)=>(0, _system.shouldForwardProp)(prop) && prop !== 'hiddenLabel'
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: {
                hasStartAdornment: true
            },
            style: {
                paddingLeft: 0
            }
        },
        {
            props: {
                hasEndAdornment: true
            },
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                inputSize: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _pickersFilledInputClassesJs.getPickersFilledInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const PickersFilledInput = /*#__PURE__*/ _react.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label, disableUnderline = false, hiddenLabel = false, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const pickerTextFieldOwnerState = (0, _usePickerTextFieldOwnerStateJs.usePickerTextFieldOwnerState)();
    const ownerState = (0, _extendsDefault.default)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.PickersInputBase), (0, _extendsDefault.default)({
        slots: {
            root: PickersFilledInputRoot,
            input: PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline
            },
            input: {
                hiddenLabel
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref,
        ownerState: ownerState
    }));
});
PickersFilledInput.muiName = 'Input';

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/material/styles":"c9RfU","@mui/system":"iFfXs","@mui/utils/refType":"3TBXN","@mui/utils/composeClasses":"59Equ","./pickersFilledInputClasses.js":"6Yj2p","../PickersInputBase/index.js":"dnBHf","../PickersInputBase/PickersInputBase.js":"fDMVQ","../usePickerTextFieldOwnerState.js":"2vGeV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Yj2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersFilledInputUtilityClass", ()=>getPickersFilledInputUtilityClass);
parcelHelpers.export(exports, "pickersFilledInputClasses", ()=>pickersFilledInputClasses);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _indexJs = require("../PickersInputBase/index.js");
function getPickersFilledInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersFilledInput', slot);
}
const pickersFilledInputClasses = (0, _extendsDefault.default)({}, (0, _indexJs.pickersInputBaseClasses), (0, _generateUtilityClassesDefault.default)('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/generateUtilityClasses":"7pSUk","@mui/utils/generateUtilityClass":"jBs9M","../PickersInputBase/index.js":"dnBHf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l8q9U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersInput", ()=>(0, _pickersInputJs.PickersInput));
parcelHelpers.export(exports, "getPickersInputUtilityClass", ()=>(0, _pickersInputClassesJs.getPickersInputUtilityClass));
parcelHelpers.export(exports, "pickersInputClasses", ()=>(0, _pickersInputClassesJs.pickersInputClasses));
var _pickersInputJs = require("./PickersInput.js");
var _pickersInputClassesJs = require("./pickersInputClasses.js");

},{"./PickersInput.js":"9bRRC","./pickersInputClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9bRRC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersInput", ()=>PickersInput);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _createStyled = require("@mui/system/createStyled");
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _pickersInputClassesJs = require("./pickersInputClasses.js");
var _indexJs = require("../PickersInputBase/index.js");
var _pickersInputBaseJs = require("../PickersInputBase/PickersInputBase.js");
var _usePickerTextFieldOwnerStateJs = require("../usePickerTextFieldOwnerState.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState",
    "classes"
];
const PickersInputRoot = (0, _styles.styled)((0, _pickersInputBaseJs.PickersInputBaseRoot), {
    name: 'MuiPickersInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, _pickersInputClassesJs.pickersInputClasses).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, _pickersInputClassesJs.pickersInputClasses).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, _pickersInputClassesJs.pickersInputClasses).disabled}, .${(0, _pickersInputClassesJs.pickersInputClasses).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, _pickersInputClassesJs.pickersInputClasses).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _pickersInputClassesJs.getPickersInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const PickersInput = /*#__PURE__*/ _react.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label, disableUnderline = false, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const pickerTextFieldOwnerState = (0, _usePickerTextFieldOwnerStateJs.usePickerTextFieldOwnerState)();
    const ownerState = (0, _extendsDefault.default)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.PickersInputBase), (0, _extendsDefault.default)({
        slots: {
            root: PickersInputRoot
        },
        slotProps: {
            root: {
                disableUnderline
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
PickersInput.muiName = 'Input';

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/material/styles":"c9RfU","@mui/system/createStyled":"6ySdS","@mui/utils/refType":"3TBXN","@mui/utils/composeClasses":"59Equ","./pickersInputClasses.js":"6FavK","../PickersInputBase/index.js":"dnBHf","../PickersInputBase/PickersInputBase.js":"fDMVQ","../usePickerTextFieldOwnerState.js":"2vGeV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6FavK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersInputUtilityClass", ()=>getPickersInputUtilityClass);
parcelHelpers.export(exports, "pickersInputClasses", ()=>pickersInputClasses);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _indexJs = require("../PickersInputBase/index.js");
function getPickersInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersFilledInput', slot);
}
const pickersInputClasses = (0, _extendsDefault.default)({}, (0, _indexJs.pickersInputBaseClasses), (0, _generateUtilityClassesDefault.default)('MuiPickersInput', [
    'root',
    'underline',
    'input'
]));

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/generateUtilityClasses":"7pSUk","@mui/utils/generateUtilityClass":"jBs9M","../PickersInputBase/index.js":"dnBHf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jI1xE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimeField", ()=>(0, _dateTimeFieldJs.DateTimeField));
parcelHelpers.export(exports, "unstable_useDateTimeField", ()=>(0, _useDateTimeFieldJs.useDateTimeField));
var _dateTimeFieldJs = require("./DateTimeField.js");
var _useDateTimeFieldJs = require("./useDateTimeField.js");

},{"./DateTimeField.js":"fK1nE","./useDateTimeField.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fK1nE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimeField", ()=>DateTimeField);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _useDateTimeFieldJs = require("./useDateTimeField.js");
var _pickerFieldUIJs = require("../internals/components/PickerFieldUI.js");
var _indexJs = require("../icons/index.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [DateTimeField](http://mui.com/x/react-date-pickers/date-time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateTimeField API](https://mui.com/x/api/date-pickers/date-time-field/)
 */ const DateTimeField = /*#__PURE__*/ _react.forwardRef(function DateTimeField(inProps, inRef) {
    const themeProps = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimeField'
    });
    const { slots, slotProps } = themeProps, other = (0, _objectWithoutPropertiesLooseDefault.default)(themeProps, _excluded);
    const textFieldProps = (0, _pickerFieldUIJs.useFieldTextFieldProps)({
        slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, _useDateTimeFieldJs.useDateTimeField)(textFieldProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickerFieldUIJs.PickerFieldUI), {
        slots: slots,
        slotProps: slotProps,
        fieldResponse: fieldResponse,
        defaultOpenPickerIcon: (0, _indexJs.CalendarIcon)
    });
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/material/styles":"c9RfU","@mui/utils/refType":"3TBXN","./useDateTimeField.js":"1PGgt","../internals/components/PickerFieldUI.js":"cxHPG","../icons/index.js":"8RbJX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1PGgt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDateTimeField", ()=>useDateTimeField);
var _indexJs = require("../internals/hooks/useField/index.js");
var _indexJs1 = require("../managers/index.js");
'use client';
const useDateTimeField = (props)=>{
    const manager = (0, _indexJs1.useDateTimeManager)(props);
    return (0, _indexJs.useField)({
        manager,
        props
    });
};

},{"../internals/hooks/useField/index.js":"21jpU","../managers/index.js":"6sU7F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Dkam":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateCalendar", ()=>(0, _dateCalendarJs.DateCalendar));
parcelHelpers.export(exports, "getDateCalendarUtilityClass", ()=>(0, _dateCalendarClassesJs.getDateCalendarUtilityClass));
parcelHelpers.export(exports, "dateCalendarClasses", ()=>(0, _dateCalendarClassesJs.dateCalendarClasses));
parcelHelpers.export(exports, "dayCalendarClasses", ()=>(0, _dayCalendarClassesJs.dayCalendarClasses));
parcelHelpers.export(exports, "pickersFadeTransitionGroupClasses", ()=>(0, _pickersFadeTransitionGroupClassesJs.pickersFadeTransitionGroupClasses));
parcelHelpers.export(exports, "pickersSlideTransitionClasses", ()=>(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses));
var _dateCalendarJs = require("./DateCalendar.js");
var _dateCalendarClassesJs = require("./dateCalendarClasses.js");
var _dayCalendarClassesJs = require("./dayCalendarClasses.js");
var _pickersFadeTransitionGroupClassesJs = require("./pickersFadeTransitionGroupClasses.js");
var _pickersSlideTransitionClassesJs = require("./pickersSlideTransitionClasses.js");

},{"./DateCalendar.js":"60Ct5","./dateCalendarClasses.js":false,"./dayCalendarClasses.js":false,"./pickersFadeTransitionGroupClasses.js":false,"./pickersSlideTransitionClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"60Ct5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateCalendar", ()=>DateCalendar);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useCalendarStateJs = require("./useCalendarState.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _pickersFadeTransitionGroupJs = require("./PickersFadeTransitionGroup.js");
var _dayCalendarJs = require("./DayCalendar.js");
var _indexJs = require("../MonthCalendar/index.js");
var _indexJs1 = require("../YearCalendar/index.js");
var _useViewsJs = require("../internals/hooks/useViews.js");
var _indexJs2 = require("../PickersCalendarHeader/index.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _indexJs3 = require("../internals/components/PickerViewRoot/index.js");
var _useReduceAnimationsJs = require("../internals/hooks/useReduceAnimations.js");
var _dateCalendarClassesJs = require("./dateCalendarClasses.js");
var _useControlledValueJs = require("../internals/hooks/useControlledValue.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _useDateManagerJs = require("../managers/useDateManager.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dateCalendarClassesJs.getDateCalendarUtilityClass), classes);
};
function useDateCalendarDefaultizedProps(props, name) {
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const reduceAnimations = (0, _useReduceAnimationsJs.useReduceAnimations)(themeProps.reduceAnimations);
    const validationProps = (0, _useDateManagerJs.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, _extendsDefault.default)({}, themeProps, validationProps, {
        loading: themeProps.loading ?? false,
        openTo: themeProps.openTo ?? 'day',
        views: themeProps.views ?? [
            'year',
            'day'
        ],
        reduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "..."
            }))
    });
}
const DateCalendarRoot = (0, _styles.styled)((0, _indexJs3.PickerViewRoot), {
    name: 'MuiDateCalendar',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    height: (0, _dimensionsJs.VIEW_HEIGHT)
});
const DateCalendarViewTransitionContainer = (0, _styles.styled)((0, _pickersFadeTransitionGroupJs.PickersFadeTransitionGroup), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer'
})({});
const DateCalendar = /*#__PURE__*/ _react.forwardRef(function DateCalendar(inProps, ref) {
    const utils = (0, _useUtilsJs.useUtils)();
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const id = (0, _useIdDefault.default)();
    const props = useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus, onViewChange, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableFuture, disablePast, onChange, onMonthChange, reduceAnimations, shouldDisableDate, shouldDisableMonth, shouldDisableYear, view: inView, views, openTo, className, classes: classesProp, disabled, readOnly, minDate, maxDate, disableHighlightToday, focusedView: focusedViewProp, onFocusedViewChange, showDaysOutsideCurrentMonth, fixedWeekNumber, dayOfWeekFormatter, slots, slotProps, loading, renderLoading, displayWeekNumber, yearsOrder, yearsPerRow, monthsPerRow, timezone: timezoneProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { value, handleValueChange, timezone } = (0, _useControlledValueJs.useControlledValue)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: (0, _valueManagersJs.singleItemValueManager)
    });
    const { view, setView, focusedView, setFocusedView, goToNextView, setValueAndGoToNextView } = (0, _useViewsJs.useViews)({
        view: inView,
        views,
        openTo,
        onChange: handleValueChange,
        onViewChange,
        autoFocus,
        focusedView: focusedViewProp,
        onFocusedViewChange
    });
    const { referenceDate, calendarState, setVisibleDate, isDateDisabled, onMonthSwitchingAnimationEnd } = (0, _useCalendarStateJs.useCalendarState)({
        value,
        referenceDate: referenceDateProp,
        reduceAnimations,
        onMonthChange,
        minDate,
        maxDate,
        shouldDisableDate,
        disablePast,
        disableFuture,
        timezone,
        getCurrentMonthFromVisibleDate: (visibleDate, prevMonth)=>{
            if (utils.isSameMonth(visibleDate, prevMonth)) return prevMonth;
            return utils.startOfMonth(visibleDate);
        }
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? (0, _indexJs2.PickersCalendarHeader);
    const calendarHeaderProps = (0, _useSlotPropsDefault.default)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views,
            view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (month)=>setVisibleDate({
                    target: month,
                    reason: 'header-navigation'
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled,
            disablePast,
            disableFuture,
            reduceAnimations,
            timezone,
            labelId: gridLabelId
        },
        ownerState
    });
    const handleDateMonthChange = (0, _useEventCallbackDefault.default)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, _dateUtilsJs.findClosestEnabledDate)({
            utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast,
            disableFuture,
            isDateDisabled,
            timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfMonth,
                reason: 'cell-interaction'
            });
        }
    });
    const handleDateYearChange = (0, _useEventCallbackDefault.default)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, _dateUtilsJs.findClosestEnabledDate)({
            utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast,
            disableFuture,
            isDateDisabled,
            timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfYear,
                reason: 'cell-interaction'
            });
        }
    });
    const handleSelectedDayChange = (0, _useEventCallbackDefault.default)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, _dateUtilsJs.mergeDateAndTime)(utils, day, value ?? referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    _react.useEffect(()=>{
        if (utils.isValid(value)) setVisibleDate({
            target: value,
            reason: 'controlled-value-change'
        });
    }, [
        value
    ]); // eslint-disable-line
    const classes = useUtilityClasses(classesProp);
    const baseDateValidationProps = {
        disablePast,
        disableFuture,
        maxDate,
        minDate
    };
    const commonViewProps = {
        disableHighlightToday,
        readOnly,
        disabled,
        timezone,
        gridLabelId,
        slots,
        slotProps
    };
    const prevOpenViewRef = _react.useRef(view);
    _react.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = _react.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DateCalendarRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarHeader, (0, _extendsDefault.default)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs1.YearCalendar), (0, _extendsDefault.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.MonthCalendar), (0, _extendsDefault.default)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dayCalendarJs.DayCalendar), (0, _extendsDefault.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            hasFocus: hasFocus,
                            onFocusedDayChange: (focusedDate)=>setVisibleDate({
                                    target: focusedDate,
                                    reason: 'cell-interaction'
                                }),
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/utils/useSlotProps":"kr4RG","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","@mui/utils/useId":"50qgI","@mui/utils/useEventCallback":"feNJe","./useCalendarState.js":"cDJfv","../internals/hooks/useUtils.js":"dJQ8a","./PickersFadeTransitionGroup.js":"gbr76","./DayCalendar.js":"aTstA","../MonthCalendar/index.js":"fB3vE","../YearCalendar/index.js":"2zxHb","../internals/hooks/useViews.js":"cVwkb","../PickersCalendarHeader/index.js":"hCqwQ","../internals/utils/date-utils.js":"jrk9G","../internals/components/PickerViewRoot/index.js":"gmdrj","../internals/hooks/useReduceAnimations.js":"ktpTF","./dateCalendarClasses.js":"iTZOH","../internals/hooks/useControlledValue.js":"hTAsm","../internals/utils/valueManagers.js":"bimTj","../internals/constants/dimensions.js":"i0BgX","../internals/hooks/usePickerPrivateContext.js":"4puZL","../managers/useDateManager.js":"jZ2tS","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cDJfv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCalendarState", ()=>useCalendarState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useIsDateDisabledJs = require("./useIsDateDisabled.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _getDefaultReferenceDateJs = require("../internals/utils/getDefaultReferenceDate.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
'use client';
const createCalendarStateReducer = (reduceAnimations, utils)=>(state, action)=>{
        switch(action.type){
            case 'setVisibleDate':
                return (0, _extendsDefault.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.month,
                    isMonthSwitchingAnimating: !utils.isSameMonth(action.month, state.currentMonth) && !reduceAnimations && !action.skipAnimation,
                    focusedDay: action.focusedDay
                });
            case 'changeMonthTimezone':
                {
                    const newTimezone = action.newTimezone;
                    if (utils.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = utils.setTimezone(state.currentMonth, newTimezone);
                    if (utils.getMonth(newCurrentMonth) !== utils.getMonth(state.currentMonth)) newCurrentMonth = utils.setMonth(newCurrentMonth, utils.getMonth(state.currentMonth));
                    return (0, _extendsDefault.default)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case 'finishMonthSwitchingAnimation':
                return (0, _extendsDefault.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            default:
                throw new Error('missing support');
        }
    };
const useCalendarState = (params)=>{
    const { value, referenceDate: referenceDateProp, disableFuture, disablePast, maxDate, minDate, onMonthChange, onYearChange, reduceAnimations, shouldDisableDate, timezone, getCurrentMonthFromVisibleDate } = params;
    const utils = (0, _useUtilsJs.useUtils)();
    const reducerFn = _react.useRef(createCalendarStateReducer(Boolean(reduceAnimations), utils)).current;
    const referenceDate = _react.useMemo(()=>{
        return (0, _valueManagersJs.singleItemValueManager).getInitialReferenceValue({
            value,
            utils,
            timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: (0, _getDefaultReferenceDateJs.SECTION_TYPE_GRANULARITY).day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = _react.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const isDateDisabled = (0, _useIsDateDisabledJs.useIsDateDisabled)({
        shouldDisableDate,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    _react.useEffect(()=>{
        dispatch({
            type: 'changeMonthTimezone',
            newTimezone: utils.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        utils
    ]);
    const setVisibleDate = (0, _useEventCallbackDefault.default)(({ target, reason })=>{
        if (reason === 'cell-interaction' && calendarState.focusedDay != null && utils.isSameDay(target, calendarState.focusedDay)) return;
        const skipAnimation = reason === 'cell-interaction';
        let month;
        let focusedDay;
        if (reason === 'cell-interaction') {
            month = getCurrentMonthFromVisibleDate(target, calendarState.currentMonth);
            focusedDay = target;
        } else {
            month = utils.isSameMonth(target, calendarState.currentMonth) ? calendarState.currentMonth : utils.startOfMonth(target);
            focusedDay = target;
            // If the date is disabled, we try to find a non-disabled date inside the same month.
            if (isDateDisabled(focusedDay)) {
                const startOfMonth = utils.startOfMonth(target);
                const endOfMonth = utils.endOfMonth(target);
                focusedDay = (0, _dateUtilsJs.findClosestEnabledDate)({
                    utils,
                    date: focusedDay,
                    minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
                    maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
                    disablePast,
                    disableFuture,
                    isDateDisabled,
                    timezone
                });
            }
        }
        const hasChangedMonth = !utils.isSameMonth(calendarState.currentMonth, month);
        const hasChangedYear = !utils.isSameYear(calendarState.currentMonth, month);
        if (hasChangedMonth) onMonthChange?.(month);
        if (hasChangedYear) onYearChange?.(utils.startOfYear(month));
        dispatch({
            type: 'setVisibleDate',
            month,
            direction: utils.isAfterDay(month, calendarState.currentMonth) ? 'left' : 'right',
            focusedDay: calendarState.focusedDay != null && focusedDay != null && utils.isSameDay(focusedDay, calendarState.focusedDay) ? calendarState.focusedDay : focusedDay,
            skipAnimation
        });
    });
    const onMonthSwitchingAnimationEnd = _react.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    return {
        referenceDate,
        calendarState,
        setVisibleDate,
        isDateDisabled,
        onMonthSwitchingAnimationEnd
    };
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/utils/useEventCallback":"feNJe","./useIsDateDisabled.js":"gzaki","../internals/hooks/useUtils.js":"dJQ8a","../internals/utils/valueManagers.js":"bimTj","../internals/utils/getDefaultReferenceDate.js":"1Z5lc","../internals/utils/date-utils.js":"jrk9G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gzaki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsDateDisabled", ()=>useIsDateDisabled);
var _react = require("react");
var _indexJs = require("../validation/index.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
'use client';
const useIsDateDisabled = ({ shouldDisableDate, shouldDisableMonth, shouldDisableYear, minDate, maxDate, disableFuture, disablePast, timezone })=>{
    const adapter = (0, _useUtilsJs.useLocalizationContext)();
    return _react.useCallback((day)=>(0, _indexJs.validateDate)({
            adapter,
            value: day,
            timezone,
            props: {
                shouldDisableDate,
                shouldDisableMonth,
                shouldDisableYear,
                minDate,
                maxDate,
                disableFuture,
                disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};

},{"react":"9njXz","../validation/index.js":"973pf","../internals/hooks/useUtils.js":"dJQ8a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gbr76":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - do not document.
 */ parcelHelpers.export(exports, "PickersFadeTransitionGroup", ()=>PickersFadeTransitionGroup);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactTransitionGroup = require("react-transition-group");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _pickersFadeTransitionGroupClassesJs = require("./pickersFadeTransitionGroupClasses.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersFadeTransitionGroupClassesJs.getPickersFadeTransitionGroupUtilityClass), classes);
};
const PickersFadeTransitionGroupRoot = (0, _styles.styled)((0, _reactTransitionGroup.TransitionGroup), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root'
})({
    display: 'block',
    position: 'relative'
});
function PickersFadeTransitionGroup(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { className, reduceAnimations, transKey, classes: classesProp } = props;
    const { children } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(classesProp);
    const theme = (0, _styles.useTheme)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersFadeTransitionGroupRoot, {
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","react-transition-group":"hnCQJ","@mui/material/Fade":"8DwqP","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","./pickersFadeTransitionGroupClasses.js":"94SDr","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"94SDr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersFadeTransitionGroupUtilityClass", ()=>getPickersFadeTransitionGroupUtilityClass);
parcelHelpers.export(exports, "pickersFadeTransitionGroupClasses", ()=>pickersFadeTransitionGroupClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const getPickersFadeTransitionGroupUtilityClass = (slot)=>(0, _generateUtilityClassDefault.default)('MuiPickersFadeTransitionGroup', slot);
const pickersFadeTransitionGroupClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersFadeTransitionGroup', [
    'root'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aTstA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - do not document.
 */ parcelHelpers.export(exports, "DayCalendar", ()=>DayCalendar);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _rtlProvider = require("@mui/system/RtlProvider");
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _indexJs = require("../PickersDay/index.js");
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _pickersSlideTransitionJs = require("./PickersSlideTransition.js");
var _useIsDateDisabledJs = require("./useIsDateDisabled.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _dayCalendarClassesJs = require("./dayCalendarClasses.js");
var _usePickerDayOwnerStateJs = require("../PickersDay/usePickerDayOwnerState.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "parentProps",
    "day",
    "focusedDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], _excluded2 = [
    "ownerState"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dayCalendarClassesJs.getDayCalendarUtilityClass), classes);
};
const weeksContainerHeight = ((0, _dimensionsJs.DAY_SIZE) + (0, _dimensionsJs.DAY_MARGIN) * 2) * 6;
const PickersCalendarDayRoot = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root'
})({});
const PickersCalendarDayHeader = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const PickersCalendarWeekDayLabel = (0, _styles.styled)((0, _typographyDefault.default), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel'
})(({ theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const PickersCalendarWeekNumberLabel = (0, _styles.styled)((0, _typographyDefault.default), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel'
})(({ theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.disabled
    }));
const PickersCalendarWeekNumber = (0, _styles.styled)((0, _typographyDefault.default), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber'
})(({ theme })=>(0, _extendsDefault.default)({}, theme.typography.caption, {
        width: (0, _dimensionsJs.DAY_SIZE),
        height: (0, _dimensionsJs.DAY_SIZE),
        padding: 0,
        margin: `0 ${(0, _dimensionsJs.DAY_MARGIN)}px`,
        color: (theme.vars || theme).palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const PickersCalendarLoadingContainer = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: weeksContainerHeight
});
const PickersCalendarSlideTransition = (0, _styles.styled)((0, _pickersSlideTransitionJs.PickersSlideTransition), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition'
})({
    minHeight: weeksContainerHeight
});
const PickersCalendarWeekContainer = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer'
})({
    overflow: 'hidden'
});
const PickersCalendarWeek = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer'
})({
    margin: `${(0, _dimensionsJs.DAY_MARGIN)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function WrappedDay(_ref) {
    let { parentProps, day, focusedDay, selectedDays, isDateDisabled, currentMonthNumber, isViewFocused } = _ref, other = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const { disabled, disableHighlightToday, isMonthSwitchingAnimating, showDaysOutsideCurrentMonth, slots, slotProps, timezone } = parentProps;
    const utils = (0, _useUtilsJs.useUtils)();
    const now = (0, _useUtilsJs.useNow)(timezone);
    const isFocusableDay = focusedDay != null && utils.isSameDay(day, focusedDay);
    const isFocusedDay = isViewFocused && isFocusableDay;
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const isDisabled = _react.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const isOutsideCurrentMonth = _react.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const ownerState = (0, _usePickerDayOwnerStateJs.usePickerDayOwnerState)({
        day,
        selected: isSelected,
        disabled: isDisabled,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        disableMargin: undefined,
        // This prop can only be defined using slotProps.day so the ownerState for useSlotProps cannot have its value.
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    });
    const Day = slots?.day ?? (0, _indexJs.PickersDay);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, _extendsDefault.default)({
            disableHighlightToday,
            showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, _extendsDefault.default)({}, ownerState, {
            day,
            isDayDisabled: isDisabled,
            isDaySelected: isSelected
        })
    }), dayProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded2);
    const isFirstVisibleCell = _react.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = _react.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Day, (0, _extendsDefault.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: !isOutsideCurrentMonth && isFocusedDay,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function DayCalendar(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const utils = (0, _useUtilsJs.useUtils)();
    const { onFocusedDayChange, className, classes: classesProp, currentMonth, selectedDays, focusedDay, loading, onSelectedDaysChange, onMonthSwitchingAnimationEnd, readOnly, reduceAnimations, renderLoading = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: "..."
        }), slideDirection, TransitionProps, disablePast, disableFuture, minDate, maxDate, shouldDisableDate, shouldDisableMonth, shouldDisableYear, dayOfWeekFormatter = (date)=>utils.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus, onFocusedViewChange, gridLabelId, displayWeekNumber, fixedWeekNumber, timezone } = props;
    const now = (0, _useUtilsJs.useNow)(timezone);
    const classes = useUtilityClasses(classesProp);
    const isRtl = (0, _rtlProvider.useRtl)();
    const isDateDisabled = (0, _useIsDateDisabledJs.useIsDateDisabled)({
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disablePast,
        disableFuture,
        timezone
    });
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const handleDaySelect = (0, _useEventCallbackDefault.default)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            onFocusedViewChange?.(true);
        }
    };
    const handleKeyDown = (0, _useEventCallbackDefault.default)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, _dateUtilsJs.findClosestEnabledDate)({
                        utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled,
                        timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, _dateUtilsJs.findClosestEnabledDate)({
                        utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled,
                        timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, _useEventCallbackDefault.default)((event, day)=>focusDay(day));
    const handleBlur = (0, _useEventCallbackDefault.default)((event, day)=>{
        if (focusedDay != null && utils.isSameDay(focusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const currentYearNumber = utils.getYear(currentMonth);
    const validSelectedDays = _react.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = _react.useMemo(()=>/*#__PURE__*/ _react.createRef(), [
        transitionKey
    ]);
    const weeksToDisplay = _react.useMemo(()=>{
        const toDisplay = utils.getWeekArray(currentMonth);
        let nextMonth = utils.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, _dateUtilsJs.getWeekdays)(utils, now).map((weekday, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(weekday, 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarSlideTransition, (0, _extendsDefault.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, _clsxDefault.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        isViewFocused: hasFocus,
                                        focusedDay: focusedDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/utils/useEventCallback":"feNJe","@mui/material/Typography":"2wCD5","@mui/utils/useSlotProps":"kr4RG","@mui/system/RtlProvider":"ck9Pb","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","clsx":"d2NWs","../PickersDay/index.js":"KpZjj","../hooks/usePickerTranslations.js":"3Zb4l","../internals/hooks/useUtils.js":"dJQ8a","../internals/constants/dimensions.js":"i0BgX","./PickersSlideTransition.js":"fpqkv","./useIsDateDisabled.js":"gzaki","../internals/utils/date-utils.js":"jrk9G","./dayCalendarClasses.js":"CUxzk","../PickersDay/usePickerDayOwnerState.js":"dZmIX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fpqkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - do not document.
 */ parcelHelpers.export(exports, "PickersSlideTransition", ()=>PickersSlideTransition);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _reactTransitionGroup = require("react-transition-group");
var _pickersSlideTransitionClassesJs = require("./pickersSlideTransitionClasses.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const useUtilityClasses = (classes, ownerState)=>{
    const { slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersSlideTransitionClassesJs.getPickersSlideTransitionUtilityClass), classes);
};
const PickersSlideTransitionRoot = (0, _styles.styled)((0, _reactTransitionGroup.TransitionGroup), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, _pickersSlideTransitionClassesJs.pickersSlideTransitionClasses)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function PickersSlideTransition(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children, className, reduceAnimations, slideDirection, transKey, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const ownerState = (0, _extendsDefault.default)({}, pickerOwnerState, {
        slideDirection
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    const theme = (0, _styles.useTheme)();
    if (reduceAnimations) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsxDefault.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersSlideTransitionRoot, {
        className: (0, _clsxDefault.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ _react.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.CSSTransition), (0, _extendsDefault.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","react-transition-group":"hnCQJ","./pickersSlideTransitionClasses.js":"38dM4","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38dM4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersSlideTransitionUtilityClass", ()=>getPickersSlideTransitionUtilityClass);
parcelHelpers.export(exports, "pickersSlideTransitionClasses", ()=>pickersSlideTransitionClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const getPickersSlideTransitionUtilityClass = (slot)=>(0, _generateUtilityClassDefault.default)('MuiPickersSlideTransition', slot);
const pickersSlideTransitionClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"CUxzk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDayCalendarUtilityClass", ()=>getDayCalendarUtilityClass);
parcelHelpers.export(exports, "dayCalendarClasses", ()=>dayCalendarClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const getDayCalendarUtilityClass = (slot)=>(0, _generateUtilityClassDefault.default)('MuiDayCalendar', slot);
const dayCalendarClasses = (0, _generateUtilityClassesDefault.default)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fB3vE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthCalendar", ()=>(0, _monthCalendarJs.MonthCalendar));
parcelHelpers.export(exports, "monthCalendarClasses", ()=>(0, _monthCalendarClassesJs.monthCalendarClasses));
parcelHelpers.export(exports, "getMonthCalendarUtilityClass", ()=>(0, _monthCalendarClassesJs.getMonthCalendarUtilityClass));
var _monthCalendarJs = require("./MonthCalendar.js");
var _monthCalendarClassesJs = require("./monthCalendarClasses.js");

},{"./MonthCalendar.js":"eBGS9","./monthCalendarClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eBGS9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMonthCalendarDefaultizedProps", ()=>useMonthCalendarDefaultizedProps);
parcelHelpers.export(exports, "MonthCalendar", ()=>MonthCalendar);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _rtlProvider = require("@mui/system/RtlProvider");
var _createStyled = require("@mui/system/createStyled");
var _styles = require("@mui/material/styles");
var _useControlled = require("@mui/utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _monthCalendarButtonJs = require("./MonthCalendarButton.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _monthCalendarClassesJs = require("./monthCalendarClasses.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _getDefaultReferenceDateJs = require("../internals/utils/getDefaultReferenceDate.js");
var _useControlledValueJs = require("../internals/hooks/useControlledValue.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _useDateManagerJs = require("../managers/useDateManager.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "autoFocus",
    "className",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _monthCalendarClassesJs.getMonthCalendarUtilityClass), classes);
};
function useMonthCalendarDefaultizedProps(props, name) {
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const validationProps = (0, _useDateManagerJs.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, _extendsDefault.default)({}, themeProps, validationProps, {
        monthsPerRow: themeProps.monthsPerRow ?? 3
    });
}
const MonthCalendarRoot = (0, _styles.styled)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'monthsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 16,
    padding: '8px 0',
    width: (0, _dimensionsJs.DIALOG_WIDTH),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    variants: [
        {
            props: {
                monthsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                columnGap: 0
            }
        }
    ]
});
const MonthCalendar = /*#__PURE__*/ _react.forwardRef(function MonthCalendar(inProps, ref) {
    const props = useMonthCalendarDefaultizedProps(inProps, 'MuiMonthCalendar');
    const { autoFocus, className, classes: classesProp, value: valueProp, defaultValue, referenceDate: referenceDateProp, disabled, disableFuture, disablePast, maxDate, minDate, onChange, shouldDisableMonth, readOnly, onMonthFocus, hasFocus, onFocusedViewChange, monthsPerRow, timezone: timezoneProp, gridLabelId, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { value, handleValueChange, timezone } = (0, _useControlledValueJs.useControlledValue)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: (0, _valueManagersJs.singleItemValueManager)
    });
    const now = (0, _useUtilsJs.useNow)(timezone);
    const isRtl = (0, _rtlProvider.useRtl)();
    const utils = (0, _useUtilsJs.useUtils)();
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const referenceDate = _react.useMemo(()=>(0, _valueManagersJs.singleItemValueManager).getInitialReferenceValue({
            value,
            utils,
            props,
            timezone,
            referenceDate: referenceDateProp,
            granularity: (0, _getDefaultReferenceDateJs.SECTION_TYPE_GRANULARITY).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = useUtilityClasses(classesProp);
    const todayMonth = _react.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = _react.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedMonth, setFocusedMonth] = _react.useState(()=>selectedMonth || utils.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, _useControlledDefault.default)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, _useEventCallbackDefault.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = _react.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, _useEventCallbackDefault.default)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, _useEventCallbackDefault.default)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    _react.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, _useEventCallbackDefault.default)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, _useEventCallbackDefault.default)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, _useEventCallbackDefault.default)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MonthCalendarRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        monthsPerRow: monthsPerRow
    }, other, {
        children: (0, _dateUtilsJs.getMonthsInYear)(utils, value ?? referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            const monthLabel = utils.format(month, 'month');
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _monthCalendarButtonJs.MonthCalendarButton), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? 'date' : undefined,
                "aria-label": monthLabel,
                slots: slots,
                slotProps: slotProps,
                classes: classesProp,
                children: monthText
            }, monthText);
        })
    }));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/system/RtlProvider":"ck9Pb","@mui/system/createStyled":"6ySdS","@mui/material/styles":"c9RfU","@mui/utils/useControlled":"jwZrv","@mui/utils/composeClasses":"59Equ","@mui/utils/useEventCallback":"feNJe","./MonthCalendarButton.js":"f0xnp","../internals/hooks/useUtils.js":"dJQ8a","./monthCalendarClasses.js":"cLgTD","../internals/utils/date-utils.js":"jrk9G","../internals/utils/valueManagers.js":"bimTj","../internals/utils/getDefaultReferenceDate.js":"1Z5lc","../internals/hooks/useControlledValue.js":"hTAsm","../internals/constants/dimensions.js":"i0BgX","../internals/hooks/usePickerPrivateContext.js":"4puZL","../managers/useDateManager.js":"jZ2tS","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f0xnp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthCalendarButton", ()=>MonthCalendarButton);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _styles = require("@mui/material/styles");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _monthCalendarClassesJs = require("./monthCalendarClasses.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isMonthDisabled && 'disabled',
            ownerState.isMonthSelected && 'selected'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _monthCalendarClassesJs.getMonthCalendarUtilityClass), classes);
};
const DefaultMonthButton = (0, _styles.styled)('button', {
    name: 'MuiMonthCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, _monthCalendarClassesJs.monthCalendarClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, _monthCalendarClassesJs.monthCalendarClasses).selected}`]: styles.selected
            }
        ]
})(({ theme })=>(0, _extendsDefault.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, _monthCalendarClassesJs.monthCalendarClasses).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, _monthCalendarClassesJs.monthCalendarClasses).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const MonthCalendarButton = /*#__PURE__*/ _react.memo(function MonthCalendarButton(props) {
    const { autoFocus, classes: classesProp, disabled, selected, value, onClick, onKeyDown, onFocus, onBlur, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ref = _react.useRef(null);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const ownerState = (0, _extendsDefault.default)({}, pickerOwnerState, {
        isMonthDisabled: disabled,
        isMonthSelected: selected
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? DefaultMonthButton;
    const monthButtonProps = (0, _useSlotPropsDefault.default)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled,
            ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MonthButton, (0, _extendsDefault.default)({}, monthButtonProps));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/material/styles":"c9RfU","@mui/utils/useSlotProps":"kr4RG","@mui/utils/composeClasses":"59Equ","@mui/utils/useEnhancedEffect":"fIvqa","../internals/hooks/usePickerPrivateContext.js":"4puZL","./monthCalendarClasses.js":"cLgTD","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cLgTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMonthCalendarUtilityClass", ()=>getMonthCalendarUtilityClass);
parcelHelpers.export(exports, "monthCalendarClasses", ()=>monthCalendarClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getMonthCalendarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiMonthCalendar', slot);
}
const monthCalendarClasses = (0, _generateUtilityClassesDefault.default)('MuiMonthCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2zxHb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearCalendar", ()=>(0, _yearCalendarJs.YearCalendar));
parcelHelpers.export(exports, "yearCalendarClasses", ()=>(0, _yearCalendarClassesJs.yearCalendarClasses));
parcelHelpers.export(exports, "getYearCalendarUtilityClass", ()=>(0, _yearCalendarClassesJs.getYearCalendarUtilityClass));
var _yearCalendarJs = require("./YearCalendar.js");
var _yearCalendarClassesJs = require("./yearCalendarClasses.js");

},{"./YearCalendar.js":"8gEQf","./yearCalendarClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gEQf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearCalendar", ()=>YearCalendar);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _rtlProvider = require("@mui/system/RtlProvider");
var _createStyled = require("@mui/system/createStyled");
var _styles = require("@mui/material/styles");
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useControlled = require("@mui/utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _yearCalendarButtonJs = require("./YearCalendarButton.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _yearCalendarClassesJs = require("./yearCalendarClasses.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _getDefaultReferenceDateJs = require("../internals/utils/getDefaultReferenceDate.js");
var _useControlledValueJs = require("../internals/hooks/useControlledValue.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _useDateManagerJs = require("../managers/useDateManager.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "autoFocus",
    "className",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _yearCalendarClassesJs.getYearCalendarUtilityClass), classes);
};
function useYearCalendarDefaultizedProps(props, name) {
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const validationProps = (0, _useDateManagerJs.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, _extendsDefault.default)({}, themeProps, validationProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        yearsOrder: themeProps.yearsOrder ?? 'asc'
    });
}
const YearCalendarRoot = (0, _styles.styled)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'yearsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 12,
    padding: '6px 0',
    overflowY: 'auto',
    height: '100%',
    width: (0, _dimensionsJs.DIALOG_WIDTH),
    maxHeight: (0, _dimensionsJs.MAX_CALENDAR_HEIGHT),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative',
    variants: [
        {
            props: {
                yearsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                columnGap: 0,
                padding: '0 2px'
            }
        }
    ]
});
const YearCalendarButtonFiller = (0, _styles.styled)('div', {
    name: 'MuiYearCalendar',
    slot: 'ButtonFiller'
})({
    height: 36,
    width: 72
});
const YearCalendar = /*#__PURE__*/ _react.forwardRef(function YearCalendar(inProps, ref) {
    const props = useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus, className, classes: classesProp, value: valueProp, defaultValue, referenceDate: referenceDateProp, disabled, disableFuture, disablePast, maxDate, minDate, onChange, readOnly, shouldDisableYear, onYearFocus, hasFocus, onFocusedViewChange, yearsOrder, yearsPerRow, timezone: timezoneProp, gridLabelId, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { value, handleValueChange, timezone } = (0, _useControlledValueJs.useControlledValue)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: (0, _valueManagersJs.singleItemValueManager)
    });
    const now = (0, _useUtilsJs.useNow)(timezone);
    const isRtl = (0, _rtlProvider.useRtl)();
    const utils = (0, _useUtilsJs.useUtils)();
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const referenceDate = _react.useMemo(()=>(0, _valueManagersJs.singleItemValueManager).getInitialReferenceValue({
            value,
            utils,
            props,
            timezone,
            referenceDate: referenceDateProp,
            granularity: (0, _getDefaultReferenceDateJs.SECTION_TYPE_GRANULARITY).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = useUtilityClasses(classesProp);
    const todayYear = _react.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = _react.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedYear, setFocusedYear] = _react.useState(()=>selectedYear || utils.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, _useControlledDefault.default)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, _useEventCallbackDefault.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = _react.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, _useEventCallbackDefault.default)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, _useEventCallbackDefault.default)((year)=>{
        if (!isYearDisabled(utils.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    _react.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
    const handleKeyDown = (0, _useEventCallbackDefault.default)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, _useEventCallbackDefault.default)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, _useEventCallbackDefault.default)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(ref, scrollerRef);
    _react.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = utils.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === 'desc') yearRange.reverse();
    let fillerAmount = yearsPerRow - yearRange.length % yearsPerRow;
    if (fillerAmount === yearsPerRow) fillerAmount = 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(YearCalendarRoot, (0, _extendsDefault.default)({
        ref: handleRef,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        yearsPerRow: yearsPerRow
    }, other, {
        children: [
            yearRange.map((year)=>{
                const yearNumber = utils.getYear(year);
                const isSelected = yearNumber === selectedYear;
                const isDisabled = disabled || isYearDisabled(year);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _yearCalendarButtonJs.YearCalendarButton), {
                    selected: isSelected,
                    value: yearNumber,
                    onClick: handleYearSelection,
                    onKeyDown: handleKeyDown,
                    autoFocus: internalHasFocus && yearNumber === focusedYear,
                    disabled: isDisabled,
                    tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                    onFocus: handleYearFocus,
                    onBlur: handleYearBlur,
                    "aria-current": todayYear === yearNumber ? 'date' : undefined,
                    slots: slots,
                    slotProps: slotProps,
                    classes: classesProp,
                    children: utils.format(year, 'year')
                }, utils.format(year, 'year'));
            }),
            Array.from({
                length: fillerAmount
            }, (_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(YearCalendarButtonFiller, {}, index))
        ]
    }));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/system/RtlProvider":"ck9Pb","@mui/system/createStyled":"6ySdS","@mui/material/styles":"c9RfU","@mui/utils/useForkRef":"4xKTx","@mui/utils/composeClasses":"59Equ","@mui/utils/useControlled":"jwZrv","@mui/utils/useEventCallback":"feNJe","./YearCalendarButton.js":"fADj7","../internals/hooks/useUtils.js":"dJQ8a","./yearCalendarClasses.js":"ixJ0J","../internals/utils/valueManagers.js":"bimTj","../internals/utils/getDefaultReferenceDate.js":"1Z5lc","../internals/hooks/useControlledValue.js":"hTAsm","../internals/constants/dimensions.js":"i0BgX","../internals/hooks/usePickerPrivateContext.js":"4puZL","../managers/useDateManager.js":"jZ2tS","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fADj7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearCalendarButton", ()=>YearCalendarButton);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _styles = require("@mui/material/styles");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _yearCalendarClassesJs = require("./yearCalendarClasses.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isYearDisabled && 'disabled',
            ownerState.isYearSelected && 'selected'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _yearCalendarClassesJs.getYearCalendarUtilityClass), classes);
};
const DefaultYearButton = (0, _styles.styled)('button', {
    name: 'MuiYearCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, _yearCalendarClassesJs.yearCalendarClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, _yearCalendarClassesJs.yearCalendarClasses).selected}`]: styles.selected
            }
        ]
})(({ theme })=>(0, _extendsDefault.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, _yearCalendarClassesJs.yearCalendarClasses).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, _yearCalendarClassesJs.yearCalendarClasses).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const YearCalendarButton = /*#__PURE__*/ _react.memo(function YearCalendarButton(props) {
    const { autoFocus, classes: classesProp, disabled, selected, value, onClick, onKeyDown, onFocus, onBlur, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ref = _react.useRef(null);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const ownerState = (0, _extendsDefault.default)({}, pickerOwnerState, {
        isYearDisabled: disabled,
        isYearSelected: selected
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? DefaultYearButton;
    const yearButtonProps = (0, _useSlotPropsDefault.default)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled,
            ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(YearButton, (0, _extendsDefault.default)({}, yearButtonProps));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/material/styles":"c9RfU","@mui/utils/useSlotProps":"kr4RG","@mui/utils/composeClasses":"59Equ","@mui/utils/useEnhancedEffect":"fIvqa","../internals/hooks/usePickerPrivateContext.js":"4puZL","./yearCalendarClasses.js":"ixJ0J","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixJ0J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getYearCalendarUtilityClass", ()=>getYearCalendarUtilityClass);
parcelHelpers.export(exports, "yearCalendarClasses", ()=>yearCalendarClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getYearCalendarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiYearCalendar', slot);
}
const yearCalendarClasses = (0, _generateUtilityClassesDefault.default)('MuiYearCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hCqwQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pickersCalendarHeaderClasses", ()=>(0, _pickersCalendarHeaderClassesJs.pickersCalendarHeaderClasses));
parcelHelpers.export(exports, "PickersCalendarHeader", ()=>(0, _pickersCalendarHeaderJs.PickersCalendarHeader));
var _pickersCalendarHeaderClassesJs = require("./pickersCalendarHeaderClasses.js");
var _pickersCalendarHeaderJs = require("./PickersCalendarHeader.js");

},{"./pickersCalendarHeaderClasses.js":false,"./PickersCalendarHeader.js":"4xtGa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"62Bwq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersCalendarHeaderUtilityClass", ()=>getPickersCalendarHeaderUtilityClass);
parcelHelpers.export(exports, "pickersCalendarHeaderClasses", ()=>pickersCalendarHeaderClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const getPickersCalendarHeaderUtilityClass = (slot)=>(0, _generateUtilityClassDefault.default)('MuiPickersCalendarHeader', slot);
const pickersCalendarHeaderClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4xtGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersCalendarHeader", ()=>PickersCalendarHeader);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _styles = require("@mui/material/styles");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _pickersFadeTransitionGroupJs = require("../DateCalendar/PickersFadeTransitionGroup.js");
var _indexJs = require("../icons/index.js");
var _indexJs1 = require("../internals/components/PickersArrowSwitcher/index.js");
var _dateHelpersHooksJs = require("../internals/hooks/date-helpers-hooks.js");
var _pickersCalendarHeaderClassesJs = require("./pickersCalendarHeaderClasses.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "classes",
    "timezone",
    "format"
], _excluded2 = [
    "ownerState"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersCalendarHeaderClassesJs.getPickersCalendarHeaderUtilityClass), classes);
};
const PickersCalendarHeaderRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root'
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const PickersCalendarHeaderLabelContainer = (0, _styles.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer'
})(({ theme })=>(0, _extendsDefault.default)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const PickersCalendarHeaderLabel = (0, _styles.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label'
})({
    marginRight: 6
});
const PickersCalendarHeaderSwitchViewButton = (0, _styles.styled)((0, _iconButtonDefault.default), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton'
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${(0, _pickersCalendarHeaderClassesJs.pickersCalendarHeaderClasses).switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const PickersCalendarHeaderSwitchViewIcon = (0, _styles.styled)((0, _indexJs.ArrowDropDownIcon), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon'
})(({ theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const PickersCalendarHeader = /*#__PURE__*/ _react.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const utils = (0, _useUtilsJs.useUtils)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots, slotProps, currentMonth: month, disabled, disableFuture, disablePast, maxDate, minDate, onMonthChange, onViewChange, view, reduceAnimations, views, labelId, className, classes: classesProp, timezone, format = `${utils.formats.month} ${utils.formats.year}` } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const classes = useUtilityClasses(classesProp);
    const SwitchViewButton = slots?.switchViewButton ?? PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, _useSlotPropsDefault.default)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1));
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1));
    const isNextMonthDisabled = (0, _dateHelpersHooksJs.useNextMonthDisabled)(month, {
        disableFuture,
        maxDate,
        timezone
    });
    const isPreviousMonthDisabled = (0, _dateHelpersHooksJs.usePreviousMonthDisabled)(month, {
        disablePast,
        minDate,
        timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const label = utils.formatByString(month, format);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarHeaderRoot, (0, _extendsDefault.default)({}, other, {
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersFadeTransitionGroupJs.PickersFadeTransitionGroup), {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchViewButton, (0, _extendsDefault.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchViewIcon, (0, _extendsDefault.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                in: view === 'day',
                appear: !reduceAnimations,
                enter: !reduceAnimations,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs1.PickersArrowSwitcher), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/material/Fade":"8DwqP","@mui/material/styles":"c9RfU","@mui/utils/useSlotProps":"kr4RG","@mui/utils/composeClasses":"59Equ","@mui/material/IconButton":"bXjnZ","../hooks/usePickerTranslations.js":"3Zb4l","../internals/hooks/useUtils.js":"dJQ8a","../DateCalendar/PickersFadeTransitionGroup.js":"gbr76","../icons/index.js":"8RbJX","../internals/components/PickersArrowSwitcher/index.js":"gUvEC","../internals/hooks/date-helpers-hooks.js":"ifoSw","./pickersCalendarHeaderClasses.js":"62Bwq","../internals/hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ktpTF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slowAnimationDevices", ()=>slowAnimationDevices);
parcelHelpers.export(exports, "useReduceAnimations", ()=>useReduceAnimations);
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
const PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const androidVersion = mobileVersionMatches && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null;
const iOSVersion = mobileVersionMatches && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null;
const slowAnimationDevices = androidVersion && androidVersion < 10 || iOSVersion && iOSVersion < 13 || false;
function useReduceAnimations(customReduceAnimations) {
    const prefersReduced = (0, _useMediaQueryDefault.default)(PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    if (customReduceAnimations != null) return customReduceAnimations;
    return prefersReduced || slowAnimationDevices;
}

},{"@mui/material/useMediaQuery":"bnRpi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnRpi":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("56cf755b9aaac458").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useMediaQuery = require("a782b9ccbdb1eac6");
var _identifier = _interopRequireDefault(require("c6512e71130d3866"));
const useMediaQuery = (0, _useMediaQuery.unstable_createUseMediaQuery)({
    themeId: _identifier.default
});
var _default = exports.default = useMediaQuery;

},{"56cf755b9aaac458":"kZ6eK","a782b9ccbdb1eac6":"epnHo","c6512e71130d3866":"asvw3"}],"epnHo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("78998556127ac12a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useMediaQuery.default;
    }
});
var _useMediaQuery = _interopRequireWildcard(require("99a218613f3a2f91"));
Object.keys(_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _useMediaQuery[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useMediaQuery[key];
        }
    });
});

},{"78998556127ac12a":"fiRIh","99a218613f3a2f91":"bfOI5"}],"bfOI5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b4c32fb802515b3b").default;
var _interopRequireWildcard = require("8e3005a8a53e6cc8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.unstable_createUseMediaQuery = unstable_createUseMediaQuery;
var React = _interopRequireWildcard(require("5a8463084267210b"));
var _useEnhancedEffect = _interopRequireDefault(require("6a2bcf140a4dd33a"));
var _useThemeProps = require("c2bc66fdb0c07b7");
var _useThemeWithoutDefault = _interopRequireDefault(require("281c0e6b8a4c918b"));
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = React.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, _useEnhancedEffect.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const safeReact = {
    ...React
};
const maybeReactUseSyncExternalStore = safeReact.useSyncExternalStore;
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = React.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = React.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = React.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createUseMediaQuery(params = {}) {
    const { themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, _useThemeWithoutDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches = false, matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia = null, noSsr = false } = (0, _useThemeProps.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const useMediaQuery = unstable_createUseMediaQuery();
var _default = exports.default = useMediaQuery;

},{"b4c32fb802515b3b":"kZ6eK","8e3005a8a53e6cc8":"fiRIh","5a8463084267210b":"9njXz","6a2bcf140a4dd33a":"fIvqa","c2bc66fdb0c07b7":"tiL16","281c0e6b8a4c918b":"f7Z9J"}],"iTZOH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDateCalendarUtilityClass", ()=>getDateCalendarUtilityClass);
parcelHelpers.export(exports, "dateCalendarClasses", ()=>dateCalendarClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const getDateCalendarUtilityClass = (slot)=>(0, _generateUtilityClassDefault.default)('MuiDateCalendar', slot);
const dateCalendarClasses = (0, _generateUtilityClassesDefault.default)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bEcHA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>(0, _datePickerJs.DatePicker));
parcelHelpers.export(exports, "DatePickerToolbar", ()=>(0, _datePickerToolbarJs.DatePickerToolbar));
parcelHelpers.export(exports, "datePickerToolbarClasses", ()=>(0, _datePickerToolbarClassesJs.datePickerToolbarClasses));
var _datePickerJs = require("./DatePicker.js");
var _datePickerToolbarJs = require("./DatePickerToolbar.js");
var _datePickerToolbarClassesJs = require("./datePickerToolbarClasses.js");

},{"./DatePicker.js":"fGAYG","./DatePickerToolbar.js":false,"./datePickerToolbarClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fGAYG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>DatePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _styles = require("@mui/material/styles");
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _indexJs = require("../DesktopDatePicker/index.js");
var _indexJs1 = require("../MobileDatePicker/index.js");
var _utilsJs = require("../internals/utils/utils.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const DatePicker = /*#__PURE__*/ _react.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery = (0, _utilsJs.DEFAULT_DESKTOP_MODE_MEDIA_QUERY) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, _useMediaQueryDefault.default)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.DesktopDatePicker), (0, _extendsDefault.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs1.MobileDatePicker), (0, _extendsDefault.default)({
        ref: ref
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/material/useMediaQuery":"bnRpi","@mui/material/styles":"c9RfU","@mui/utils/refType":"3TBXN","../DesktopDatePicker/index.js":"4d4Zu","../MobileDatePicker/index.js":"6L3BH","../internals/utils/utils.js":"k4iiH","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4d4Zu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesktopDatePicker", ()=>(0, _desktopDatePickerJs.DesktopDatePicker));
var _desktopDatePickerJs = require("./DesktopDatePicker.js");

},{"./DesktopDatePicker.js":"zyjOH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"zyjOH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesktopDatePicker", ()=>DesktopDatePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _resolveComponentProps = require("@mui/utils/resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _sharedJs = require("../DatePicker/shared.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _indexJs = require("../validation/index.js");
var _indexJs1 = require("../internals/hooks/useDesktopPicker/index.js");
var _indexJs2 = require("../DateField/index.js");
var _indexJs3 = require("../dateViewRenderers/index.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const DesktopDatePicker = /*#__PURE__*/ _react.forwardRef(function DesktopDatePicker(inProps, ref) {
    const utils = (0, _useUtilsJs.useUtils)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, _sharedJs.useDatePickerDefaultizedProps)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, _extendsDefault.default)({
        day: (0, _indexJs3.renderDateViewCalendar),
        month: (0, _indexJs3.renderDateViewCalendar),
        year: (0, _indexJs3.renderDateViewCalendar)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, _extendsDefault.default)({}, defaultizedProps, {
        closeOnSelect: defaultizedProps.closeOnSelect ?? true,
        viewRenderers,
        format: (0, _dateUtilsJs.resolveDateFormat)(utils, defaultizedProps, false),
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        slots: (0, _extendsDefault.default)({
            field: (0, _indexJs2.DateField)
        }, defaultizedProps.slots),
        slotProps: (0, _extendsDefault.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, _extendsDefault.default)({}, (0, _resolveComponentPropsDefault.default)(defaultizedProps.slotProps?.field, ownerState), (0, _indexJs.extractValidationProps)(defaultizedProps)),
            toolbar: (0, _extendsDefault.default)({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker } = (0, _indexJs1.useDesktopPicker)({
        ref,
        props,
        valueManager: (0, _valueManagersJs.singleItemValueManager),
        valueType: 'date',
        validator: (0, _indexJs.validateDate),
        steps: null
    });
    return renderPicker();
});
DesktopDatePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default true
   */ closeOnSelect: (0, _propTypesDefault.default).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, _propTypesDefault.default).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, _propTypesDefault.default).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, _propTypesDefault.default).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, _propTypesDefault.default).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, _propTypesDefault.default).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, _propTypesDefault.default).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, _propTypesDefault.default).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, _refTypeDefault.default),
    /**
   * The label content.
   */ label: (0, _propTypesDefault.default).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, _propTypesDefault.default).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, _propTypesDefault.default).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, _propTypesDefault.default).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, _propTypesDefault.default).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, _propTypesDefault.default).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, _propTypesDefault.default).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, _propTypesDefault.default).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, _propTypesDefault.default).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, _propTypesDefault.default).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, _propTypesDefault.default).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, _propTypesDefault.default).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, _propTypesDefault.default).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, _propTypesDefault.default).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, _propTypesDefault.default).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, _propTypesDefault.default).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, _propTypesDefault.default).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, _propTypesDefault.default).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, _propTypesDefault.default).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, _propTypesDefault.default).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, _propTypesDefault.default).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).bool
        ])),
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, _propTypesDefault.default).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, _propTypesDefault.default).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, _propTypesDefault.default).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, _propTypesDefault.default).shape({
        day: (0, _propTypesDefault.default).func,
        month: (0, _propTypesDefault.default).func,
        year: (0, _propTypesDefault.default).func
    }),
    /**
   * Available views.
   */ views: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, _propTypesDefault.default).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, _propTypesDefault.default).oneOf([
        3,
        4
    ])
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/utils/resolveComponentProps":"gGfhx","@mui/utils/refType":"3TBXN","../internals/utils/valueManagers.js":"bimTj","../DatePicker/shared.js":"7bXUZ","../internals/hooks/useUtils.js":"dJQ8a","../validation/index.js":"973pf","../internals/hooks/useDesktopPicker/index.js":"8Uqxx","../DateField/index.js":"fNKm6","../dateViewRenderers/index.js":"4liGN","../internals/utils/date-utils.js":"jrk9G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7bXUZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDatePickerDefaultizedProps", ()=>useDatePickerDefaultizedProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _styles = require("@mui/material/styles");
var _viewsJs = require("../internals/utils/views.js");
var _datePickerToolbarJs = require("./DatePickerToolbar.js");
var _useDateManagerJs = require("../managers/useDateManager.js");
function useDatePickerDefaultizedProps(props, name) {
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const validationProps = (0, _useDateManagerJs.useApplyDefaultValuesToDateValidationProps)(themeProps);
    const localeText = _react.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, _extendsDefault.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, _extendsDefault.default)({}, themeProps, validationProps, {
        localeText
    }, (0, _viewsJs.applyDefaultViewProps)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        slots: (0, _extendsDefault.default)({
            toolbar: (0, _datePickerToolbarJs.DatePickerToolbar)
        }, themeProps.slots)
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/material/styles":"c9RfU","../internals/utils/views.js":"lfBM6","./DatePickerToolbar.js":"cbtkt","../managers/useDateManager.js":"jZ2tS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cbtkt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerToolbar", ()=>DatePickerToolbar);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _pickersToolbarJs = require("../internals/components/PickersToolbar.js");
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _datePickerToolbarClassesJs = require("./datePickerToolbarClasses.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _useToolbarOwnerStateJs = require("../internals/hooks/useToolbarOwnerState.js");
var _indexJs = require("../hooks/index.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "toolbarFormat",
    "toolbarPlaceholder",
    "className",
    "classes"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _datePickerToolbarClassesJs.getDatePickerToolbarUtilityClass), classes);
};
const DatePickerToolbarRoot = (0, _styles.styled)((0, _pickersToolbarJs.PickersToolbar), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root'
})({});
const DatePickerToolbarTitle = (0, _styles.styled)((0, _typographyDefault.default), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title'
})({
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: 'auto 16px auto auto'
            }
        }
    ]
});
const DatePickerToolbar = /*#__PURE__*/ _react.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { toolbarFormat, toolbarPlaceholder = "\u2013\u2013", className, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const utils = (0, _useUtilsJs.useUtils)();
    const { value, views, orientation } = (0, _indexJs.usePickerContext)();
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const ownerState = (0, _useToolbarOwnerStateJs.useToolbarOwnerState)();
    const classes = useUtilityClasses(classesProp);
    const dateText = _react.useMemo(()=>{
        if (!utils.isValid(value)) return toolbarPlaceholder;
        const formatFromViews = (0, _dateUtilsJs.resolveDateFormat)(utils, {
            format: toolbarFormat,
            views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatePickerToolbarRoot, (0, _extendsDefault.default)({
        ref: ref,
        toolbarTitle: translations.datePickerToolbarTitle,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatePickerToolbarTitle, {
            variant: "h4",
            align: orientation === 'landscape' ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","prop-types":"bnNSm","@mui/material/Typography":"2wCD5","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","../internals/components/PickersToolbar.js":"j4xaV","../hooks/usePickerTranslations.js":"3Zb4l","../internals/hooks/useUtils.js":"dJQ8a","./datePickerToolbarClasses.js":"hpFrT","../internals/utils/date-utils.js":"jrk9G","../internals/hooks/useToolbarOwnerState.js":"5ZzMj","../hooks/index.js":"a3BuB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j4xaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersToolbar", ()=>PickersToolbar);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _createStyled = require("@mui/system/createStyled");
var _pickersToolbarClassesJs = require("./pickersToolbarClasses.js");
var _useToolbarOwnerStateJs = require("../hooks/useToolbarOwnerState.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "className",
    "classes",
    "toolbarTitle",
    "hidden",
    "titleId",
    "classes",
    "landscapeDirection"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ],
        content: [
            'content'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersToolbarClassesJs.getPickersToolbarUtilityClass), classes);
};
const PickersToolbarRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root'
})(({ theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    pickerOrientation: 'landscape'
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const PickersToolbarContent = (0, _styles.styled)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'landscapeDirection'
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const PickersToolbar = /*#__PURE__*/ _react.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children, className, classes: classesProp, toolbarTitle, hidden, titleId, landscapeDirection } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _useToolbarOwnerStateJs.useToolbarOwnerState)();
    const classes = useUtilityClasses(classesProp);
    if (hidden) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersToolbarRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                className: classes.title,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                landscapeDirection: landscapeDirection,
                children: children
            })
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","@mui/material/Typography":"2wCD5","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","@mui/system/createStyled":"6ySdS","./pickersToolbarClasses.js":"cfogx","../hooks/useToolbarOwnerState.js":"5ZzMj","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cfogx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersToolbarUtilityClass", ()=>getPickersToolbarUtilityClass);
parcelHelpers.export(exports, "pickersToolbarClasses", ()=>pickersToolbarClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getPickersToolbarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersToolbar', slot);
}
const pickersToolbarClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersToolbar', [
    'root',
    'title',
    'content'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ZzMj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToolbarOwnerState", ()=>useToolbarOwnerState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _rtlProvider = require("@mui/system/RtlProvider");
var _usePickerPrivateContextJs = require("./usePickerPrivateContext.js");
function useToolbarOwnerState() {
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const isRtl = (0, _rtlProvider.useRtl)();
    return _react.useMemo(()=>(0, _extendsDefault.default)({}, pickerOwnerState, {
            toolbarDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        isRtl
    ]);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/system/RtlProvider":"ck9Pb","./usePickerPrivateContext.js":"4puZL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hpFrT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDatePickerToolbarUtilityClass", ()=>getDatePickerToolbarUtilityClass);
parcelHelpers.export(exports, "datePickerToolbarClasses", ()=>datePickerToolbarClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getDatePickerToolbarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDatePickerToolbar', slot);
}
const datePickerToolbarClasses = (0, _generateUtilityClassesDefault.default)('MuiDatePickerToolbar', [
    'root',
    'title'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Uqxx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDesktopPicker", ()=>(0, _useDesktopPickerJs.useDesktopPicker));
var _useDesktopPickerJs = require("./useDesktopPicker.js");

},{"./useDesktopPicker.js":"6niiw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6niiw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDesktopPicker", ()=>useDesktopPicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _pickerPopperJs = require("../../components/PickerPopper/PickerPopper.js");
var _indexJs = require("../usePicker/index.js");
var _indexJs1 = require("../../../PickersLayout/index.js");
var _pickerProviderJs = require("../../components/PickerProvider.js");
var _pickerFieldUIJs = require("../../components/PickerFieldUI.js");
var _createNonRangePickerStepNavigationJs = require("../../utils/createNonRangePickerStepNavigation.js");
/**
 * Hook managing all the single-date desktop pickers:
 * - DesktopDatePicker
 * - DesktopDateTimePicker
 * - DesktopTimePicker
 */ var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "props",
    "steps"
], _excluded2 = [
    "ownerState"
];
const useDesktopPicker = (_ref)=>{
    let { props, steps } = _ref, pickerParams = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const { slots, slotProps: innerSlotProps, label, inputRef, localeText } = props;
    const getStepNavigation = (0, _createNonRangePickerStepNavigationJs.createNonRangePickerStepNavigation)({
        steps
    });
    const { providerProps, renderCurrentView, ownerState } = (0, _indexJs.usePicker)((0, _extendsDefault.default)({}, pickerParams, {
        props,
        localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'desktop',
        getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, _extendsDefault.default)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState
    }), fieldProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded2);
    const Layout = slots.layout ?? (0, _indexJs1.PickersLayout);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, _extendsDefault.default)({}, innerSlotProps, {
        toolbar: (0, _extendsDefault.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, _extendsDefault.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickerProviderJs.PickerProvider), (0, _extendsDefault.default)({}, providerProps, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pickerFieldUIJs.PickerFieldUIContextProvider), {
                slots: slots,
                slotProps: slotProps,
                inputRef: inputRef,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Field, (0, _extendsDefault.default)({}, fieldProps)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickerPopperJs.PickerPopper), {
                        slots: slots,
                        slotProps: slotProps,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layout, (0, _extendsDefault.default)({}, slotProps?.layout, {
                            slots: slots,
                            slotProps: slotProps,
                            children: renderCurrentView()
                        }))
                    })
                ]
            })
        }));
    return {
        renderPicker
    };
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","@mui/utils/useSlotProps":"kr4RG","../../components/PickerPopper/PickerPopper.js":"cylRn","../usePicker/index.js":"dE5KP","../../../PickersLayout/index.js":"9qQLb","../../components/PickerProvider.js":"lJDhK","../../components/PickerFieldUI.js":"cxHPG","../../utils/createNonRangePickerStepNavigation.js":"8zYJh","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cylRn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerPopper", ()=>PickerPopper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _grow = require("@mui/material/Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _popper = require("@mui/material/Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _unstableTrapFocus = require("@mui/material/Unstable_TrapFocus");
var _unstableTrapFocusDefault = parcelHelpers.interopDefault(_unstableTrapFocus);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _ownerDocument = require("@mui/utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styles = require("@mui/material/styles");
var _pickerPopperClassesJs = require("./pickerPopperClasses.js");
var _utilsJs = require("../../utils/utils.js");
var _usePickerPrivateContextJs = require("../../hooks/usePickerPrivateContext.js");
var _indexJs = require("../../../hooks/index.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "PaperComponent",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickerPopperClassesJs.getPickerPopperUtilityClass), classes);
};
const PickerPopperRoot = (0, _styles.styled)((0, _popperDefault.default), {
    name: 'MuiPickerPopper',
    slot: 'Root'
})(({ theme })=>({
        zIndex: theme.zIndex.modal
    }));
const PickerPopperPaper = (0, _styles.styled)((0, _paperDefault.default), {
    name: 'MuiPickerPopper',
    slot: 'Paper'
})({
    outline: 0,
    transformOrigin: 'top center',
    variants: [
        {
            props: ({ popperPlacement })=>[
                    'top',
                    'top-start',
                    'top-end'
                ].includes(popperPlacement),
            style: {
                transformOrigin: 'bottom center'
            }
        }
    ]
});
function clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function useClickAwayListener(active, onClickAway) {
    const movedRef = _react.useRef(false);
    const syntheticEventRef = _react.useRef(false);
    const nodeRef = _react.useRef(null);
    const activatedRef = _react.useRef(false);
    _react.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, _useEventCallbackDefault.default)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, _ownerDocumentDefault.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    _react.useEffect(()=>{
        if (active) {
            const doc = (0, _ownerDocumentDefault.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    _react.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, _ownerDocumentDefault.default)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const PickerPopperPaperWrapper = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { PaperComponent, ownerState, children, paperSlotProps, paperClasses, onPaperClick, onPaperTouchStart } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const paperProps = (0, _useSlotPropsDefault.default)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref
        },
        className: paperClasses,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperComponent, (0, _extendsDefault.default)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function PickerPopper(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickerPopper'
    });
    const { children, placement = 'bottom-start', slots, slotProps, classes: classesProp } = props;
    const { open, popupRef, reduceAnimations } = (0, _indexJs.usePickerContext)();
    const { dismissViews, getCurrentViewMode, onPopperExited, triggerElement, viewContainerRole } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    _react.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === 'Escape') dismissViews();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        dismissViews,
        open
    ]);
    const lastFocusedElementRef = _react.useRef(null);
    _react.useEffect(()=>{
        if (viewContainerRole === 'tooltip' || getCurrentViewMode() === 'field') return;
        if (open) lastFocusedElementRef.current = (0, _utilsJs.getActiveElement)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        viewContainerRole,
        getCurrentViewMode
    ]);
    const classes = useUtilityClasses(classesProp);
    const { ownerState: pickerOwnerState, rootRefObject } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const ownerState = (0, _extendsDefault.default)({}, pickerOwnerState, {
        popperPlacement: placement
    });
    const handleClickAway = (0, _useEventCallbackDefault.default)(()=>{
        if (viewContainerRole === 'tooltip') (0, _utilsJs.executeInTheNextEventLoopTick)(()=>{
            if (rootRefObject.current?.contains((0, _utilsJs.getActiveElement)(document)) || popupRef.current?.contains((0, _utilsJs.getActiveElement)(document))) return;
            dismissViews();
        });
        else dismissViews();
    });
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = useClickAwayListener(open, handleClickAway);
    const paperRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(paperRef, popupRef);
    const handlePaperRef = (0, _useForkRefDefault.default)(handleRef, clickAwayRef);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            dismissViews();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? (0, _fadeDefault.default) : (0, _growDefault.default);
    const FocusTrap = slots?.desktopTrapFocus ?? (0, _unstableTrapFocusDefault.default);
    const Paper = slots?.desktopPaper ?? PickerPopperPaper;
    const Popper = slots?.popper ?? PickerPopperRoot;
    const popperProps = (0, _useSlotPropsDefault.default)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: viewContainerRole == null ? undefined : viewContainerRole,
            open,
            placement,
            anchorEl: triggerElement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Popper, (0, _extendsDefault.default)({}, popperProps, {
        children: ({ TransitionProps })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(FocusTrap, (0, _extendsDefault.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: viewContainerRole === 'tooltip',
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Transition, (0, _extendsDefault.default)({}, TransitionProps, slotProps?.desktopTransition, {
                    onExited: (event)=>{
                        onPopperExited?.();
                        slotProps?.desktopTransition?.onExited?.(event);
                        TransitionProps?.onExited?.();
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","@mui/utils/useSlotProps":"kr4RG","@mui/material/Grow":"4LWtg","@mui/material/Fade":"8DwqP","@mui/material/Paper":"arHf6","@mui/material/Popper":"lX4bO","@mui/material/Unstable_TrapFocus":"6WLXP","@mui/utils/useForkRef":"4xKTx","@mui/utils/useEventCallback":"feNJe","@mui/utils/ownerDocument":"8VgUE","@mui/utils/composeClasses":"59Equ","@mui/material/styles":"c9RfU","./pickerPopperClasses.js":"jH9ZH","../../utils/utils.js":"k4iiH","../../hooks/usePickerPrivateContext.js":"4puZL","../../../hooks/index.js":"a3BuB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lX4bO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e7bbfe73179b25f2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Popper.default;
    }
});
var _Popper = _interopRequireDefault(require("3f36e30c859554b4"));
var _popperClasses = require("f9c6c7963e5410ff");
Object.keys(_popperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _popperClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _popperClasses[key];
        }
    });
});

},{"e7bbfe73179b25f2":"kZ6eK","3f36e30c859554b4":"69dVP","f9c6c7963e5410ff":"4R31f"}],"69dVP":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("6fb9e52526fd4165").default;
var _interopRequireDefault = require("5f51fab47a525fb0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _RtlProvider = require("394d889e40f7f575");
var _refType = _interopRequireDefault(require("513b716decdc79fe"));
var _HTMLElementType = _interopRequireDefault(require("6dbd46d586b3ad70"));
var _propTypes = _interopRequireDefault(require("ef72fc5969d38c20"));
var React = _interopRequireWildcard(require("f356e785ed29cbea"));
var _BasePopper = _interopRequireDefault(require("f2e365724dc1dc99"));
var _zeroStyled = require("9ee03dd414f0bda8");
var _DefaultPropsProvider = require("1be9cc762df51032");
var _jsxRuntime = require("2f0d05af153dc17e");
const PopperRoot = (0, _zeroStyled.styled)(_BasePopper.default, {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const Popper = /*#__PURE__*/ React.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, _RtlProvider.useRtl)();
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl, component, components, componentsProps, container, disablePortal, keepMounted, modifiers, open, placement, popperOptions, popperRef, transition, slots, slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl,
        container,
        disablePortal,
        keepMounted,
        modifiers,
        open,
        placement,
        popperOptions,
        popperRef,
        transition,
        ...other
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var _default = exports.default = Popper;

},{"6fb9e52526fd4165":"fiRIh","5f51fab47a525fb0":"kZ6eK","394d889e40f7f575":"ck9Pb","513b716decdc79fe":"3TBXN","6dbd46d586b3ad70":"eESPP","ef72fc5969d38c20":"bnNSm","f356e785ed29cbea":"9njXz","f2e365724dc1dc99":"2cLAp","9ee03dd414f0bda8":"89fxU","1be9cc762df51032":"ff3VX","2f0d05af153dc17e":"1dlk8"}],"2cLAp":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2010a32e2f28a372").default;
var _interopRequireWildcard = require("137691bda5b6cb97").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("97627872a183479d"));
var _ownerDocument = _interopRequireDefault(require("42d5b063bbb2f2f0"));
var _useEnhancedEffect = _interopRequireDefault(require("497bc3c09977e25a"));
var _useForkRef = _interopRequireDefault(require("3bbf585692f1203b"));
var _chainPropTypes = _interopRequireDefault(require("3ca9ca45565aa996"));
var _HTMLElementType = _interopRequireDefault(require("e9faf62d5afca28b"));
var _refType = _interopRequireDefault(require("68d3222e4ac4b675"));
var _core = require("3a8fbe189ceb59d7");
var _propTypes = _interopRequireDefault(require("651025cbe6300d79"));
var _composeClasses = _interopRequireDefault(require("890717589098baf1"));
var _useSlotProps = _interopRequireDefault(require("329facdb3257739a"));
var _Portal = _interopRequireDefault(require("e6b43a3e27504e1d"));
var _popperClasses = require("5b29f028edcfede2");
var _jsxRuntime = require("5180f8da3723b36c");
function flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function isVirtualElement(element) {
    return !isHTMLElement(element);
}
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _popperClasses.getPopperUtilityClass, classes);
};
const defaultPopperOptions = {};
const PopperTooltip = /*#__PURE__*/ React.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl, children, direction, disablePortal, modifiers, open, placement: initialPlacement, popperOptions, popperRef: popperRefProp, slotProps = {}, slots = {}, TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = React.useRef(null);
    const ownRef = (0, _useForkRef.default)(tooltipRef, forwardedRef);
    const popperRef = React.useRef(null);
    const handlePopperRef = (0, _useForkRef.default)(popperRef, popperRefProp);
    const handlePopperRefRef = React.useRef(handlePopperRef);
    (0, _useEnhancedEffect.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    React.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = React.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = React.useState(resolveAnchorEl(anchorEl));
    React.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    React.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement(resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, _useEnhancedEffect.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, _core.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, _useSlotProps.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const Popper = /*#__PURE__*/ React.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl, children, container: containerProp, direction = 'ltr', disablePortal = false, keepMounted = false, modifiers, open, placement = 'bottom', popperOptions = defaultPopperOptions, popperRef, style, transition = false, slotProps = {}, slots = {}, ...other } = props;
    const [exited, setExited] = React.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) ? (0, _ownerDocument.default)(resolvedAnchorEl).body : (0, _ownerDocument.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Portal.default, {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var _default = exports.default = Popper;

},{"2010a32e2f28a372":"kZ6eK","137691bda5b6cb97":"fiRIh","97627872a183479d":"9njXz","42d5b063bbb2f2f0":"8VgUE","497bc3c09977e25a":"fIvqa","3bbf585692f1203b":"4xKTx","3ca9ca45565aa996":"4stnp","e9faf62d5afca28b":"eESPP","68d3222e4ac4b675":"3TBXN","3a8fbe189ceb59d7":"4kymL","651025cbe6300d79":"bnNSm","890717589098baf1":"59Equ","329facdb3257739a":"kr4RG","e6b43a3e27504e1d":"gdTpC","5b29f028edcfede2":"4R31f","5180f8da3723b36c":"1dlk8"}],"4R31f":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7e2bad21cbc23520").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPopperUtilityClass = getPopperUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("8469036fa538e739"));
var _generateUtilityClass = _interopRequireDefault(require("39a2b3a4bff8f01c"));
function getPopperUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPopper', slot);
}
const popperClasses = (0, _generateUtilityClasses.default)('MuiPopper', [
    'root'
]);
var _default = exports.default = popperClasses;

},{"7e2bad21cbc23520":"kZ6eK","8469036fa538e739":"7pSUk","39a2b3a4bff8f01c":"jBs9M"}],"jH9ZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickerPopperUtilityClass", ()=>getPickerPopperUtilityClass);
parcelHelpers.export(exports, "pickerPopperClasses", ()=>pickerPopperClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getPickerPopperUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickerPopper', slot);
}
const pickerPopperClasses = (0, _generateUtilityClassesDefault.default)('MuiPickerPopper', [
    'root',
    'paper'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dE5KP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePicker", ()=>(0, _usePickerJs.usePicker));
var _usePickerJs = require("./usePicker.js");

},{"./usePicker.js":"ffTqa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffTqa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePicker", ()=>usePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _useUtilsJs = require("../useUtils.js");
var _useReduceAnimationsJs = require("../useReduceAnimations.js");
var _timeUtilsJs = require("../../utils/time-utils.js");
var _useViewsJs = require("../useViews.js");
var _useOrientationJs = require("./hooks/useOrientation.js");
var _useValueAndOpenStatesJs = require("./hooks/useValueAndOpenStates.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "sx"
];
const usePicker = ({ ref, props, valueManager, valueType, variant, validator, onPopperExited, autoFocusView, rendererInterceptor: RendererInterceptor, localeText, viewContainerRole, getStepNavigation })=>{
    const { // View props
    views, view: viewProp, openTo, onViewChange, viewRenderers, reduceAnimations: reduceAnimationsProp, orientation: orientationProp, disableOpenPicker, closeOnSelect, // Form props
    disabled, readOnly, // Field props
    formatDensity, enableAccessibleFieldDOMStructure, selectedSections, onSelectedSectionsChange, format, label, // Other props
    autoFocus, name } = props;
    const { className, sx } = props, propsToForwardToView = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    /**
   * TODO: Improve how we generate the aria-label and aria-labelledby attributes.
   */ const labelId = (0, _useIdDefault.default)();
    const utils = (0, _useUtilsJs.useUtils)();
    const adapter = (0, _useUtilsJs.useLocalizationContext)();
    const reduceAnimations = (0, _useReduceAnimationsJs.useReduceAnimations)(reduceAnimationsProp);
    const orientation = (0, _useOrientationJs.useOrientation)(views, orientationProp);
    const { current: initialView } = _react.useRef(openTo ?? null);
    /**
   * Refs
   */ const [triggerElement, triggerRef] = _react.useState(null);
    const popupRef = _react.useRef(null);
    const fieldRef = _react.useRef(null);
    const rootRefObject = _react.useRef(null);
    const rootRef = (0, _useForkRefDefault.default)(ref, rootRefObject);
    const { timezone, state, setOpen, setValue, setValueFromView, value, viewValue } = (0, _useValueAndOpenStatesJs.useValueAndOpenStates)({
        props,
        valueManager,
        validator
    });
    const { view, setView, defaultView, focusedView, setFocusedView, setValueAndGoToNextView, goToNextStep, hasNextStep, hasSeveralSteps } = (0, _useViewsJs.useViews)({
        view: viewProp,
        views,
        openTo,
        onChange: setValueFromView,
        onViewChange,
        autoFocus: autoFocusView,
        getStepNavigation
    });
    const clearValue = (0, _useEventCallbackDefault.default)(()=>setValue(valueManager.emptyValue));
    const setValueToToday = (0, _useEventCallbackDefault.default)(()=>setValue(valueManager.getTodayValue(utils, timezone, valueType)));
    const acceptValueChanges = (0, _useEventCallbackDefault.default)(()=>setValue(value));
    const cancelValueChanges = (0, _useEventCallbackDefault.default)(()=>setValue(state.lastCommittedValue, {
            skipPublicationIfPristine: true
        }));
    const dismissViews = (0, _useEventCallbackDefault.default)(()=>{
        setValue(value, {
            skipPublicationIfPristine: true
        });
    });
    const { hasUIView, viewModeLookup, timeViewsCount } = _react.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            const viewMode = viewRenderers[viewForReduce] == null ? 'field' : 'UI';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') {
                acc.hasUIView = true;
                if ((0, _timeUtilsJs.isTimeView)(viewForReduce)) acc.timeViewsCount += 1;
            }
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {},
            timeViewsCount: 0
        }), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const getCurrentViewMode = (0, _useEventCallbackDefault.default)(()=>currentViewMode);
    const [popperView, setPopperView] = _react.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, _useEnhancedEffectDefault.default)(()=>{
        // Handle case of Date Time Picker without time renderers
        if (currentViewMode === 'field' && state.open) {
            setOpen(false);
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (!state.open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        state.open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const ownerState = _react.useMemo(()=>({
            isPickerValueEmpty: valueManager.areValuesEqual(utils, value, valueManager.emptyValue),
            isPickerOpen: state.open,
            isPickerDisabled: props.disabled ?? false,
            isPickerReadOnly: props.readOnly ?? false,
            pickerOrientation: orientation,
            pickerVariant: variant
        }), [
        utils,
        valueManager,
        value,
        state.open,
        orientation,
        variant,
        props.disabled,
        props.readOnly
    ]);
    const triggerStatus = _react.useMemo(()=>{
        if (disableOpenPicker || !hasUIView) return 'hidden';
        if (disabled || readOnly) return 'disabled';
        return 'enabled';
    }, [
        disableOpenPicker,
        hasUIView,
        disabled,
        readOnly
    ]);
    const wrappedGoToNextStep = (0, _useEventCallbackDefault.default)(goToNextStep);
    const defaultActionBarActions = _react.useMemo(()=>{
        if (closeOnSelect && !hasSeveralSteps) return [];
        return [
            'cancel',
            'nextOrAccept'
        ];
    }, [
        closeOnSelect,
        hasSeveralSteps
    ]);
    const actionsContextValue = _react.useMemo(()=>({
            setValue,
            setOpen,
            clearValue,
            setValueToToday,
            acceptValueChanges,
            cancelValueChanges,
            setView,
            goToNextStep: wrappedGoToNextStep
        }), [
        setValue,
        setOpen,
        clearValue,
        setValueToToday,
        acceptValueChanges,
        cancelValueChanges,
        setView,
        wrappedGoToNextStep
    ]);
    const contextValue = _react.useMemo(()=>(0, _extendsDefault.default)({}, actionsContextValue, {
            value,
            timezone,
            open: state.open,
            views,
            view: popperView,
            initialView,
            disabled: disabled ?? false,
            readOnly: readOnly ?? false,
            autoFocus: autoFocus ?? false,
            variant,
            orientation,
            popupRef,
            reduceAnimations,
            triggerRef,
            triggerStatus,
            hasNextStep,
            fieldFormat: format ?? '',
            name,
            label,
            rootSx: sx,
            rootRef,
            rootClassName: className
        }), [
        actionsContextValue,
        value,
        rootRef,
        variant,
        orientation,
        reduceAnimations,
        disabled,
        readOnly,
        format,
        className,
        name,
        label,
        sx,
        triggerStatus,
        hasNextStep,
        timezone,
        state.open,
        popperView,
        views,
        initialView,
        autoFocus
    ]);
    const privateContextValue = _react.useMemo(()=>({
            dismissViews,
            ownerState,
            hasUIView,
            getCurrentViewMode,
            rootRefObject,
            labelId,
            triggerElement,
            viewContainerRole,
            defaultActionBarActions,
            onPopperExited
        }), [
        dismissViews,
        ownerState,
        hasUIView,
        getCurrentViewMode,
        labelId,
        triggerElement,
        viewContainerRole,
        defaultActionBarActions,
        onPopperExited
    ]);
    const fieldPrivateContextValue = _react.useMemo(()=>({
            formatDensity,
            enableAccessibleFieldDOMStructure,
            selectedSections,
            onSelectedSectionsChange,
            fieldRef
        }), [
        formatDensity,
        enableAccessibleFieldDOMStructure,
        selectedSections,
        onSelectedSectionsChange,
        fieldRef
    ]);
    const isValidContextValue = (testedValue)=>{
        const error = validator({
            adapter,
            value: testedValue,
            timezone,
            props
        });
        return !valueManager.hasError(error);
    };
    const renderCurrentView = ()=>{
        if (popperView == null) return null;
        const renderer = viewRenderers[popperView];
        if (renderer == null) return null;
        const rendererProps = (0, _extendsDefault.default)({}, propsToForwardToView, {
            views,
            timezone,
            value: viewValue,
            onChange: setValueAndGoToNextView,
            view: popperView,
            onViewChange: setView,
            showViewSwitcher: timeViewsCount > 1,
            timeViewsCount
        }, viewContainerRole === 'tooltip' ? {
            focusedView: null,
            onFocusedViewChange: ()=>{}
        } : {
            focusedView,
            onFocusedViewChange: setFocusedView
        });
        if (RendererInterceptor) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RendererInterceptor, {
            viewRenderers: viewRenderers,
            popperView: popperView,
            rendererProps: rendererProps
        });
        return renderer(rendererProps);
    };
    return {
        providerProps: {
            localeText,
            contextValue,
            privateContextValue,
            actionsContextValue,
            fieldPrivateContextValue,
            isValidContextValue
        },
        renderCurrentView,
        ownerState
    };
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","@mui/utils/useEnhancedEffect":"fIvqa","@mui/utils/useEventCallback":"feNJe","@mui/utils/useForkRef":"4xKTx","@mui/utils/useId":"50qgI","../useUtils.js":"dJQ8a","../useReduceAnimations.js":"ktpTF","../../utils/time-utils.js":"7FMia","../useViews.js":"cVwkb","./hooks/useOrientation.js":"11CtY","./hooks/useValueAndOpenStates.js":"ahQH9","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"11CtY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOrientation", ()=>useOrientation);
var _react = require("react");
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _utilsJs = require("../../../utils/utils.js");
function getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
function useOrientation(views, customOrientation) {
    const [orientation, setOrientation] = _react.useState(getOrientation);
    (0, _useEnhancedEffectDefault.default)(()=>{
        const eventHandler = ()=>{
            setOrientation(getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, _utilsJs.arrayIncludes)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return 'portrait';
    return customOrientation ?? orientation;
}

},{"react":"9njXz","@mui/utils/useEnhancedEffect":"fIvqa","../../../utils/utils.js":"k4iiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ahQH9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useValueAndOpenStates", ()=>useValueAndOpenStates);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _warning = require("@mui/x-internals/warning");
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useControlledValueJs = require("../../useControlledValue.js");
var _useUtilsJs = require("../../useUtils.js");
var _indexJs = require("../../../../validation/index.js");
function useValueAndOpenStates(parameters) {
    const { props, valueManager, validator } = parameters;
    const { value: valueProp, defaultValue: defaultValueProp, onChange, referenceDate, timezone: timezoneProp, onAccept, closeOnSelect, open: openProp, onOpen, onClose } = props;
    const { current: defaultValue } = _react.useRef(defaultValueProp);
    const { current: isValueControlled } = _react.useRef(valueProp !== undefined);
    const { current: isOpenControlled } = _react.useRef(openProp !== undefined);
    const utils = (0, _useUtilsJs.useUtils)();
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const { timezone, value, handleValueChange } = (0, _useControlledValueJs.useControlledValue)({
        name: 'a picker component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate,
        onChange,
        valueManager
    });
    const [state, setState] = _react.useState(()=>({
            open: false,
            lastExternalValue: value,
            clockShallowValue: undefined,
            lastCommittedValue: value,
            hasBeenModifiedSinceMount: false
        }));
    const { getValidationErrorForNewValue } = (0, _indexJs.useValidation)({
        props,
        validator,
        timezone,
        value,
        onError: props.onError
    });
    const setOpen = (0, _useEventCallbackDefault.default)((action)=>{
        const newOpen = typeof action === 'function' ? action(state.open) : action;
        if (!isOpenControlled) setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                open: newOpen
            }));
        if (newOpen && onOpen) onOpen();
        if (!newOpen) onClose?.();
    });
    const setValue = (0, _useEventCallbackDefault.default)((newValue, options)=>{
        const { changeImportance = 'accept', skipPublicationIfPristine = false, validationError, shortcut, shouldClose = changeImportance === 'accept' } = options ?? {};
        let shouldFireOnChange;
        let shouldFireOnAccept;
        if (!skipPublicationIfPristine && !isValueControlled && !state.hasBeenModifiedSinceMount) {
            // If the value is not controlled and the value has never been modified before,
            // Then clicking on any value (including the one equal to `defaultValue`) should call `onChange` and `onAccept`
            shouldFireOnChange = true;
            shouldFireOnAccept = changeImportance === 'accept';
        } else {
            shouldFireOnChange = !valueManager.areValuesEqual(utils, newValue, value);
            shouldFireOnAccept = changeImportance === 'accept' && !valueManager.areValuesEqual(utils, newValue, state.lastCommittedValue);
        }
        setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                // We reset the shallow value whenever we fire onChange.
                clockShallowValue: shouldFireOnChange ? undefined : prevState.clockShallowValue,
                lastCommittedValue: shouldFireOnAccept ? value : prevState.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                cachedContext = {
                    validationError: validationError == null ? getValidationErrorForNewValue(newValue) : validationError
                };
                if (shortcut) cachedContext.shortcut = shortcut;
            }
            return cachedContext;
        };
        if (shouldFireOnChange) handleValueChange(newValue, getContext());
        if (shouldFireOnAccept && onAccept) onAccept(newValue, getContext());
        if (shouldClose) setOpen(false);
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
            lastExternalValue: value,
            clockShallowValue: undefined,
            hasBeenModifiedSinceMount: true
        }));
    const setValueFromView = (0, _useEventCallbackDefault.default)((newValue, selectionState = 'partial')=>{
        // TODO: Expose a new method (private?) like `setView` that only updates the clock shallow value.
        if (selectionState === 'shallow') {
            setState((prev)=>(0, _extendsDefault.default)({}, prev, {
                    clockShallowValue: newValue,
                    hasBeenModifiedSinceMount: true
                }));
            return;
        }
        setValue(newValue, {
            changeImportance: selectionState === 'finish' && closeOnSelect ? 'accept' : 'set'
        });
    });
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    _react.useEffect(()=>{
        if (isOpenControlled) {
            if (openProp === undefined) throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setState((prevState)=>(0, _extendsDefault.default)({}, prevState, {
                    open: openProp
                }));
        }
    }, [
        isOpenControlled,
        openProp
    ]);
    const viewValue = _react.useMemo(()=>valueManager.cleanValue(utils, state.clockShallowValue === undefined ? value : state.clockShallowValue), [
        utils,
        valueManager,
        state.clockShallowValue,
        value
    ]);
    return {
        timezone,
        state,
        setValue,
        setValueFromView,
        setOpen,
        value,
        viewValue
    };
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/x-internals/warning":"gernP","@mui/utils/useEventCallback":"feNJe","../../useControlledValue.js":"hTAsm","../../useUtils.js":"dJQ8a","../../../../validation/index.js":"973pf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gernP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "clearWarningsCache", {
    enumerable: true,
    get: function() {
        return _warning.clearWarningsCache;
    }
});
Object.defineProperty(exports, "warnOnce", {
    enumerable: true,
    get: function() {
        return _warning.warnOnce;
    }
});
var _warning = require("f7f8947a801f6f55");

},{"f7f8947a801f6f55":"3vfXv"}],"3vfXv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearWarningsCache = clearWarningsCache;
exports.warnOnce = warnOnce;
const warnedOnceCache = new Set();
/**
 * Logs a message to the console on development mode. The warning will only be logged once.
 *
 * The message is the log's cache key. Two identical messages will only be logged once.
 *
 * This function is a no-op in production.
 *
 * @param message the message to log
 * @param gravity the gravity of the warning. Defaults to `'warning'`.
 * @returns
 */ function warnOnce(message, gravity = 'warning') {
    return;
}
function clearWarningsCache() {
    warnedOnceCache.clear();
}

},{}],"9qQLb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersLayout", ()=>(0, _pickersLayoutJs.PickersLayout));
parcelHelpers.export(exports, "PickersLayoutRoot", ()=>(0, _pickersLayoutJs.PickersLayoutRoot));
parcelHelpers.export(exports, "PickersLayoutContentWrapper", ()=>(0, _pickersLayoutJs.PickersLayoutContentWrapper));
parcelHelpers.export(exports, "usePickerLayout", ()=>(0, _usePickerLayoutJsDefault.default));
parcelHelpers.export(exports, "pickersLayoutClasses", ()=>(0, _pickersLayoutClassesJs.pickersLayoutClasses));
var _pickersLayoutJs = require("./PickersLayout.js");
var _usePickerLayoutJs = require("./usePickerLayout.js");
var _usePickerLayoutJsDefault = parcelHelpers.interopDefault(_usePickerLayoutJs);
var _pickersLayoutClassesJs = require("./pickersLayoutClasses.js");

},{"./PickersLayout.js":"69Zap","./usePickerLayout.js":"1dWql","./pickersLayoutClasses.js":"fQdRG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"69Zap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersLayoutRoot", ()=>PickersLayoutRoot);
parcelHelpers.export(exports, "PickersLayoutContentWrapper", ()=>PickersLayoutContentWrapper);
parcelHelpers.export(exports, "PickersLayout", ()=>PickersLayout);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _pickersLayoutClassesJs = require("./pickersLayoutClasses.js");
var _usePickerLayoutJs = require("./usePickerLayout.js");
var _usePickerLayoutJsDefault = parcelHelpers.interopDefault(_usePickerLayoutJs);
var _usePickerContextJs = require("../hooks/usePickerContext.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersLayoutClassesJs.getPickersLayoutUtilityClass), classes);
};
const PickersLayoutRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root'
})({
    display: 'grid',
    gridAutoColumns: 'max-content auto max-content',
    gridAutoRows: 'max-content auto max-content',
    [`& .${(0, _pickersLayoutClassesJs.pickersLayoutClasses).actionBar}`]: {
        gridColumn: '1 / 4',
        gridRow: 3
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                [`& .${(0, _pickersLayoutClassesJs.pickersLayoutClasses).toolbar}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                },
                [`.${(0, _pickersLayoutClassesJs.pickersLayoutClasses).shortcuts}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                }
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                layoutDirection: 'rtl'
            },
            style: {
                [`& .${(0, _pickersLayoutClassesJs.pickersLayoutClasses).toolbar}`]: {
                    gridColumn: 3
                }
            }
        },
        {
            props: {
                pickerOrientation: 'portrait'
            },
            style: {
                [`& .${(0, _pickersLayoutClassesJs.pickersLayoutClasses).toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                },
                [`& .${(0, _pickersLayoutClassesJs.pickersLayoutClasses).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                }
            }
        },
        {
            props: {
                pickerOrientation: 'portrait',
                layoutDirection: 'rtl'
            },
            style: {
                [`& .${(0, _pickersLayoutClassesJs.pickersLayoutClasses).shortcuts}`]: {
                    gridColumn: 3
                }
            }
        }
    ]
});
const PickersLayoutContentWrapper = (0, _styles.styled)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper'
})({
    gridColumn: '2 / 4',
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const PickersLayout = /*#__PURE__*/ _react.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar, content, tabs, actionBar, shortcuts, ownerState } = (0, _usePickerLayoutJsDefault.default)(props);
    const { orientation, variant } = (0, _usePickerContextJs.usePickerContext)();
    const { sx, className, classes: classesProp } = props;
    const classes = useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersLayoutRoot, {
        ref: ref,
        sx: sx,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersLayoutContentWrapper, {
                className: classes.contentWrapper,
                ownerState: ownerState,
                children: variant === 'desktop' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});

},{"react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","./pickersLayoutClasses.js":"fQdRG","./usePickerLayout.js":"1dWql","../hooks/usePickerContext.js":"hyseP","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fQdRG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersLayoutUtilityClass", ()=>getPickersLayoutUtilityClass);
parcelHelpers.export(exports, "pickersLayoutClasses", ()=>pickersLayoutClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getPickersLayoutUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersLayout', slot);
}
const pickersLayoutClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dWql":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _rtlProvider = require("@mui/system/RtlProvider");
var _indexJs = require("../PickersActionBar/index.js");
var _pickersLayoutClassesJs = require("./pickersLayoutClasses.js");
var _indexJs1 = require("../PickersShortcuts/index.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _indexJs2 = require("../hooks/index.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "ownerState"
];
function toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersLayoutClassesJs.getPickersLayoutUtilityClass), classes);
};
const usePickerLayout = (props)=>{
    const { ownerState: pickerOwnerState, defaultActionBarActions } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const { view } = (0, _indexJs2.usePickerContext)();
    const isRtl = (0, _rtlProvider.useRtl)();
    const { children, slots, slotProps, classes: classesProp } = props;
    const ownerState = _react.useMemo(()=>(0, _extendsDefault.default)({}, pickerOwnerState, {
            layoutDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        isRtl
    ]);
    const classes = useUtilityClasses(classesProp, ownerState);
    // Action bar
    const ActionBar = slots?.actionBar ?? (0, _indexJs.PickersActionBar);
    const _useSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            actions: defaultActionBarActions
        },
        className: classes.actionBar,
        ownerState
    }), actionBarProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded);
    const actionBar = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBar, (0, _extendsDefault.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, _useSlotPropsDefault.default)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        className: classes.toolbar,
        ownerState
    });
    const toolbar = toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Toolbar, (0, _extendsDefault.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tabs, (0, _extendsDefault.default)({
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? (0, _indexJs1.PickersShortcuts);
    const shortcutsProps = (0, _useSlotPropsDefault.default)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        className: classes.shortcuts,
        ownerState
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Shortcuts, (0, _extendsDefault.default)({}, shortcutsProps)) : null;
    return {
        toolbar,
        content,
        tabs,
        actionBar,
        shortcuts,
        ownerState
    };
};
exports.default = usePickerLayout;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/utils/useSlotProps":"kr4RG","@mui/utils/composeClasses":"59Equ","@mui/system/RtlProvider":"ck9Pb","../PickersActionBar/index.js":"58DGg","./pickersLayoutClasses.js":"fQdRG","../PickersShortcuts/index.js":"6yPS4","../internals/hooks/usePickerPrivateContext.js":"4puZL","../hooks/index.js":"a3BuB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"58DGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersActionBar", ()=>(0, _pickersActionBarJs.PickersActionBar));
var _pickersActionBarJs = require("./PickersActionBar.js");

},{"./PickersActionBar.js":"l6MJ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l6MJ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersActionBar", ()=>PickersActionBar);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _indexJs = require("../hooks/index.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "actions"
];
const PickersActionBarRoot = (0, _styles.styled)((0, _dialogActionsDefault.default), {
    name: 'MuiPickersLayout',
    slot: 'ActionBar'
})({});
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function PickersActionBarComponent(props) {
    const { actions } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const { clearValue, setValueToToday, acceptValueChanges, cancelValueChanges, goToNextStep, hasNextStep } = (0, _indexJs.usePickerContext)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: clearValue,
                    children: translations.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: cancelValueChanges,
                    children: translations.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: setValueToToday,
                    children: translations.todayButtonLabel
                }, actionType);
            case 'next':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
            case 'nextOrAccept':
                if (hasNextStep) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersActionBarRoot, (0, _extendsDefault.default)({}, other, {
        children: buttons
    }));
}
const PickersActionBar = /*#__PURE__*/ _react.memo(PickersActionBarComponent);

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/material/styles":"c9RfU","@mui/material/Button":"c6Y0y","@mui/material/DialogActions":"5WZHz","../hooks/usePickerTranslations.js":"3Zb4l","../hooks/index.js":"a3BuB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6Y0y":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("73bf7d5265b8a8d0").default;
var _interopRequireDefault = require("2c0f2b1b0217f8c7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    buttonClasses: true
};
Object.defineProperty(exports, "buttonClasses", {
    enumerable: true,
    get: function() {
        return _buttonClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Button.default;
    }
});
var _Button = _interopRequireDefault(require("1497637fbb05ec54"));
var _buttonClasses = _interopRequireWildcard(require("a7f7e573d5342952"));
Object.keys(_buttonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _buttonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _buttonClasses[key];
        }
    });
});

},{"73bf7d5265b8a8d0":"fiRIh","2c0f2b1b0217f8c7":"kZ6eK","1497637fbb05ec54":"f9Ua7","a7f7e573d5342952":"jMRzq"}],"f9Ua7":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("506654892c77ed4f").default;
var _interopRequireWildcard = require("2535502db42460fa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("ab48e3be261e143d"));
var _propTypes = _interopRequireDefault(require("e8229488ed4bf5c1"));
var _clsx = _interopRequireDefault(require("95c160a86913a41a"));
var _resolveProps = _interopRequireDefault(require("935087f478dd31f5"));
var _composeClasses = _interopRequireDefault(require("3b294694ee77a55c"));
var _colorManipulator = require("acc7069a628a41f4");
var _utils = require("40d330ae2a2ccad5");
var _rootShouldForwardProp = _interopRequireDefault(require("9228b952502de7c1"));
var _zeroStyled = require("287ed45affaf72f2");
var _memoTheme = _interopRequireDefault(require("4cdafd8e1ea069eb"));
var _DefaultPropsProvider = require("5161db5991b24b30");
var _ButtonBase = _interopRequireDefault(require("239e8aa9585befc8"));
var _CircularProgress = _interopRequireDefault(require("3436bcdb0130204f"));
var _capitalize = _interopRequireDefault(require("ef3816b680bb3236"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("585462192f02c1e3"));
var _buttonClasses = _interopRequireWildcard(require("c5f7f493a4591ac3"));
var _ButtonGroupContext = _interopRequireDefault(require("d0a94e57a7eb62f4"));
var _ButtonGroupButtonContext = _interopRequireDefault(require("cb734c01b229ccc0"));
var _jsxRuntime = require("4bbef115a735e352");
const useUtilityClasses = (ownerState)=>{
    const { color, disableElevation, fullWidth, size, variant, loading, loadingPosition, classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, _capitalize.default)(color)}`,
            `size${(0, _capitalize.default)(size)}`,
            `${variant}Size${(0, _capitalize.default)(size)}`,
            `color${(0, _capitalize.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, _capitalize.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, _capitalize.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, _capitalize.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _buttonClasses.getButtonUtilityClass, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const ButtonRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, _capitalize.default)(ownerState.color)}`],
            styles[`size${(0, _capitalize.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, _capitalize.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${_buttonClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${_buttonClasses.default.focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${_buttonClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${_buttonClasses.default.disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${_buttonClasses.default.focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${_buttonClasses.default.disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${_buttonClasses.default.loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const ButtonStartIcon = (0, _zeroStyled.styled)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})(({ theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...commonIconStyles
        ]
    }));
const ButtonEndIcon = (0, _zeroStyled.styled)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})(({ theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...commonIconStyles
        ]
    }));
const ButtonLoadingIndicator = (0, _zeroStyled.styled)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const ButtonLoadingIconPlaceholder = (0, _zeroStyled.styled)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const Button = /*#__PURE__*/ React.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = React.useContext(_ButtonGroupContext.default);
    const buttonGroupButtonContextPositionClassName = React.useContext(_ButtonGroupButtonContext.default);
    const resolvedProps = (0, _resolveProps.default)(contextProps, inProps);
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children, color = 'primary', component = 'button', className, disabled = false, disableElevation = false, disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName, fullWidth = false, id: idProp, loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition = 'center', size = 'medium', startIcon: startIconProp, type, variant = 'text', ...other } = props;
    const loadingId = (0, _utils.unstable_useId)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CircularProgress.default, {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color,
        component,
        disabled,
        disableElevation,
        disableFocusRipple,
        fullWidth,
        loading,
        loadingIndicator,
        loadingPosition,
        size,
        type,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, _jsxRuntime.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonRoot, {
        ownerState: ownerState,
        className: (0, _clsx.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var _default = exports.default = Button;

},{"506654892c77ed4f":"kZ6eK","2535502db42460fa":"fiRIh","ab48e3be261e143d":"9njXz","e8229488ed4bf5c1":"bnNSm","95c160a86913a41a":"d2NWs","935087f478dd31f5":"gFBtX","3b294694ee77a55c":"59Equ","acc7069a628a41f4":"hTYBL","40d330ae2a2ccad5":"60iOt","9228b952502de7c1":"dIcrQ","287ed45affaf72f2":"89fxU","4cdafd8e1ea069eb":"2zy52","5161db5991b24b30":"ff3VX","239e8aa9585befc8":"ajcyv","3436bcdb0130204f":"bK4ky","ef3816b680bb3236":"hBZko","585462192f02c1e3":"yHYvD","c5f7f493a4591ac3":"jMRzq","d0a94e57a7eb62f4":"cbh6e","cb734c01b229ccc0":"iTQbB","4bbef115a735e352":"1dlk8"}],"jMRzq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b8ca6bbb85bd086a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getButtonUtilityClass = getButtonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("26ac7707a0fd3585"));
var _generateUtilityClass = _interopRequireDefault(require("8c07485910a0809e"));
function getButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiButton', slot);
}
const buttonClasses = (0, _generateUtilityClasses.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var _default = exports.default = buttonClasses;

},{"b8ca6bbb85bd086a":"kZ6eK","26ac7707a0fd3585":"7pSUk","8c07485910a0809e":"jBs9M"}],"cbh6e":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("17af94e85f2186cc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e0ee77527d55029c"));
/**
 * @ignore - internal component.
 */ const ButtonGroupContext = /*#__PURE__*/ React.createContext({});
var _default = exports.default = ButtonGroupContext;

},{"17af94e85f2186cc":"fiRIh","e0ee77527d55029c":"9njXz"}],"iTQbB":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("f8ba5e6551670d8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("45c716251d0e73a"));
/**
 * @ignore - internal component.
 */ const ButtonGroupButtonContext = /*#__PURE__*/ React.createContext(undefined);
var _default = exports.default = ButtonGroupButtonContext;

},{"f8ba5e6551670d8":"fiRIh","45c716251d0e73a":"9njXz"}],"5WZHz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("79618e16dcb88ed0").default;
var _interopRequireDefault = require("dd47ed25275fde61").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dialogActionsClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DialogActions.default;
    }
});
Object.defineProperty(exports, "dialogActionsClasses", {
    enumerable: true,
    get: function() {
        return _dialogActionsClasses.default;
    }
});
var _DialogActions = _interopRequireDefault(require("d71279baec7e1b35"));
var _dialogActionsClasses = _interopRequireWildcard(require("c8a632aab2ccfe75"));
Object.keys(_dialogActionsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dialogActionsClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dialogActionsClasses[key];
        }
    });
});

},{"79618e16dcb88ed0":"fiRIh","dd47ed25275fde61":"kZ6eK","d71279baec7e1b35":"eMT6z","c8a632aab2ccfe75":"gGxDJ"}],"eMT6z":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("de48014f6811fec8").default;
var _interopRequireWildcard = require("55ab40ce56c68ab5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("fa6a4b085100f504"));
var _propTypes = _interopRequireDefault(require("1675aa641a1fd953"));
var _clsx = _interopRequireDefault(require("e857ef4518b652a8"));
var _composeClasses = _interopRequireDefault(require("28229e48e215e7d9"));
var _zeroStyled = require("c083616ba9eb1a53");
var _DefaultPropsProvider = require("742bb4c6450d038a");
var _dialogActionsClasses = require("8875703bb57632e5");
var _jsxRuntime = require("2b31c9b075b8caa1");
const useUtilityClasses = (ownerState)=>{
    const { classes, disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, _composeClasses.default)(slots, _dialogActionsClasses.getDialogActionsUtilityClass, classes);
};
const DialogActionsRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const DialogActions = /*#__PURE__*/ React.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className, disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogActionsRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var _default = exports.default = DialogActions;

},{"de48014f6811fec8":"kZ6eK","55ab40ce56c68ab5":"fiRIh","fa6a4b085100f504":"9njXz","1675aa641a1fd953":"bnNSm","e857ef4518b652a8":"d2NWs","28229e48e215e7d9":"59Equ","c083616ba9eb1a53":"89fxU","742bb4c6450d038a":"ff3VX","8875703bb57632e5":"gGxDJ","2b31c9b075b8caa1":"1dlk8"}],"gGxDJ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f2f03f50dea81e0c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDialogActionsUtilityClass = getDialogActionsUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("186d900262bf5de"));
var _generateUtilityClass = _interopRequireDefault(require("b713432d4fd65ca3"));
function getDialogActionsUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDialogActions', slot);
}
const dialogActionsClasses = (0, _generateUtilityClasses.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var _default = exports.default = dialogActionsClasses;

},{"f2f03f50dea81e0c":"kZ6eK","186d900262bf5de":"7pSUk","b713432d4fd65ca3":"jBs9M"}],"6yPS4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersShortcuts", ()=>(0, _pickersShortcutsJs.PickersShortcuts));
var _pickersShortcutsJs = require("./PickersShortcuts.js");

},{"./PickersShortcuts.js":"fsEke","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fsEke":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersShortcuts", ()=>PickersShortcuts);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _styles = require("@mui/material/styles");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _indexJs = require("../hooks/index.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "items",
    "changeImportance"
], _excluded2 = [
    "getValue"
];
const PickersShortcutsRoot = (0, _styles.styled)((0, _listDefault.default), {
    name: 'MuiPickersLayout',
    slot: 'Shortcuts'
})({});
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function PickersShortcuts(props) {
    const { items, changeImportance = 'accept' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { setValue } = (0, _indexJs.usePickerActionsContext)();
    const isValidValue = (0, _indexJs.useIsValidValue)();
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue } = _ref, item = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded2);
        const newValue = getValue({
            isValid: isValidValue
        });
        return (0, _extendsDefault.default)({}, item, {
            label: item.label,
            onClick: ()=>{
                setValue(newValue, {
                    changeImportance,
                    shortcut: item
                });
            },
            disabled: !isValidValue(newValue)
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersShortcutsRoot, (0, _extendsDefault.default)({
        dense: true,
        sx: [
            {
                maxHeight: (0, _dimensionsJs.VIEW_HEIGHT),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), (0, _extendsDefault.default)({}, item))
            }, item.id ?? item.label);
        })
    }));
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","@mui/material/styles":"c9RfU","prop-types":"bnNSm","@mui/material/List":"4j4o2","@mui/material/ListItem":"2EejF","@mui/material/Chip":"eSSCi","../internals/constants/dimensions.js":"i0BgX","../hooks/index.js":"a3BuB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2EejF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7559167cc9abd6c9").default;
var _interopRequireDefault = require("ff602dfebc203aa5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItem.default;
    }
});
Object.defineProperty(exports, "listItemClasses", {
    enumerable: true,
    get: function() {
        return _listItemClasses.default;
    }
});
var _ListItem = _interopRequireDefault(require("e06471669f7d6090"));
var _listItemClasses = _interopRequireWildcard(require("4920dd2253841260"));
Object.keys(_listItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemClasses[key];
        }
    });
});

},{"7559167cc9abd6c9":"fiRIh","ff602dfebc203aa5":"kZ6eK","e06471669f7d6090":"4Mboj","4920dd2253841260":"btYc1"}],"4Mboj":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("90cb0377b2d2004").default;
var _interopRequireWildcard = require("566b2e9fd788eeb9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.overridesResolver = exports.default = exports.ListItemRoot = void 0;
var React = _interopRequireWildcard(require("3e74b5067d1facbb"));
var _propTypes = _interopRequireDefault(require("dd56d46be420ae84"));
var _clsx = _interopRequireDefault(require("bc1736db31d53fd0"));
var _composeClasses = _interopRequireDefault(require("935b37f3f142f26c"));
var _elementTypeAcceptingRef = _interopRequireDefault(require("34e3b2a94ff9d43"));
var _chainPropTypes = _interopRequireDefault(require("57712f3ea6565340"));
var _isHostComponent = _interopRequireDefault(require("c64636237c0e4107"));
var _zeroStyled = require("1c37970cf36f8e90");
var _memoTheme = _interopRequireDefault(require("15903b0e58ea4842"));
var _DefaultPropsProvider = require("917fb013bd98ebda");
var _isMuiElement = _interopRequireDefault(require("21b5fd11357b59cc"));
var _useForkRef = _interopRequireDefault(require("1e9c4ef6af0baf2a"));
var _ListContext = _interopRequireDefault(require("fc866cd6fe28baf9"));
var _listItemClasses = require("4ca2b8b2792be4ef");
var _ListItemButton = require("3398d2f3bc7756e9");
var _ListItemSecondaryAction = _interopRequireDefault(require("99c6234eb1e35904"));
var _jsxRuntime = require("5e4e5ff735f84856");
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
exports.overridesResolver = overridesResolver;
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes, dense, disableGutters, disablePadding, divider, hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, _composeClasses.default)(slots, _listItemClasses.getListItemUtilityClass, classes);
};
const ListItemRoot = exports.ListItemRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${_ListItemButton.listItemButtonClasses.root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const ListItemContainer = (0, _zeroStyled.styled)('li', {
    name: 'MuiListItem',
    slot: 'Container'
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const ListItem = /*#__PURE__*/ React.forwardRef(function ListItem(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems = 'center', children: childrenProp, className, component: componentProp, components = {}, componentsProps = {}, ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense = false, disableGutters = false, disablePadding = false, divider = false, secondaryAction, slotProps = {}, slots = {}, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const childContext = React.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems,
            disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = React.useRef(null);
    const children = React.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in a future major release
    const hasSecondaryAction = children.length && (0, _isMuiElement.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems,
        dense: childContext.dense,
        disableGutters,
        disablePadding,
        divider,
        hasSecondaryAction
    };
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRef.default)(listItemRef, ref);
    const Root = slots.root || components.Root || ListItemRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, _clsx.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in a future major release
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListItemContainer, {
                as: ContainerComponent,
                className: (0, _clsx.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
                        ...rootProps,
                        ...!(0, _isHostComponent.default)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, _isHostComponent.default)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListItemSecondaryAction.default, {
                    children: secondaryAction
                })
            ]
        })
    });
});
var _default = exports.default = ListItem;

},{"90cb0377b2d2004":"kZ6eK","566b2e9fd788eeb9":"fiRIh","3e74b5067d1facbb":"9njXz","dd56d46be420ae84":"bnNSm","bc1736db31d53fd0":"d2NWs","935b37f3f142f26c":"59Equ","34e3b2a94ff9d43":"40NoV","57712f3ea6565340":"4stnp","c64636237c0e4107":"iMS0l","1c37970cf36f8e90":"89fxU","15903b0e58ea4842":"2zy52","917fb013bd98ebda":"ff3VX","21b5fd11357b59cc":"bgSQq","1e9c4ef6af0baf2a":"cq8Sn","fc866cd6fe28baf9":"lt3pu","4ca2b8b2792be4ef":"btYc1","3398d2f3bc7756e9":"3RKQ6","99c6234eb1e35904":"fztfw","5e4e5ff735f84856":"1dlk8"}],"btYc1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6c30f3ba95aeafcd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemUtilityClass = getListItemUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("cc84596877cd2b0b"));
var _generateUtilityClass = _interopRequireDefault(require("d4327e9c08ea084f"));
function getListItemUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItem', slot);
}
const listItemClasses = (0, _generateUtilityClasses.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var _default = exports.default = listItemClasses;

},{"6c30f3ba95aeafcd":"kZ6eK","cc84596877cd2b0b":"7pSUk","d4327e9c08ea084f":"jBs9M"}],"3RKQ6":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("12b09c4fc79d7497").default;
var _interopRequireDefault = require("889f3aebd4f7d5f8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemButtonClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItemButton.default;
    }
});
Object.defineProperty(exports, "listItemButtonClasses", {
    enumerable: true,
    get: function() {
        return _listItemButtonClasses.default;
    }
});
var _ListItemButton = _interopRequireDefault(require("9fb6a35be7b27cc0"));
var _listItemButtonClasses = _interopRequireWildcard(require("31f315218439056e"));
Object.keys(_listItemButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemButtonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemButtonClasses[key];
        }
    });
});

},{"12b09c4fc79d7497":"fiRIh","889f3aebd4f7d5f8":"kZ6eK","9fb6a35be7b27cc0":"j7NAr","31f315218439056e":"3VzXh"}],"j7NAr":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("99044e2884099098").default;
var _interopRequireWildcard = require("2027670980dec104").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.overridesResolver = exports.default = void 0;
var React = _interopRequireWildcard(require("ac7012a4fe966ed4"));
var _propTypes = _interopRequireDefault(require("270c4df638171a20"));
var _clsx = _interopRequireDefault(require("80cd2bcd1b5438e2"));
var _composeClasses = _interopRequireDefault(require("cf65b0a61ccf068d"));
var _colorManipulator = require("4bf7eccbbf7abd03");
var _zeroStyled = require("3bc87ea2d775418");
var _memoTheme = _interopRequireDefault(require("f4ca7cd4062b9cdf"));
var _DefaultPropsProvider = require("78dce487d90b9a8f");
var _rootShouldForwardProp = _interopRequireDefault(require("8208e75de81ca84b"));
var _ButtonBase = _interopRequireDefault(require("8eebd13f3ac46c49"));
var _useEnhancedEffect = _interopRequireDefault(require("3509369760d84b1f"));
var _useForkRef = _interopRequireDefault(require("78a08833665fd7ec"));
var _ListContext = _interopRequireDefault(require("1f3c214ce98dfcd4"));
var _listItemButtonClasses = _interopRequireWildcard(require("109101e83f1c8068"));
var _jsxRuntime = require("8b76016f2e1ee1f");
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
exports.overridesResolver = overridesResolver;
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes, dense, disabled, disableGutters, divider, selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _listItemButtonClasses.getListItemButtonUtilityClass, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const ListItemButtonRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${_listItemButtonClasses.default.selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${_listItemButtonClasses.default.focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${_listItemButtonClasses.default.selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${_listItemButtonClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${_listItemButtonClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const ListItemButton = /*#__PURE__*/ React.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems = 'center', autoFocus = false, component = 'div', children, dense = false, disableGutters = false, divider = false, focusVisibleClassName, selected = false, className, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const childContext = React.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems,
            disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = React.useRef(null);
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        alignItems,
        dense: childContext.dense,
        disableGutters,
        divider,
        selected
    };
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRef.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemButtonRoot, {
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            ...other,
            classes: classes,
            children: children
        })
    });
});
var _default = exports.default = ListItemButton;

},{"99044e2884099098":"kZ6eK","2027670980dec104":"fiRIh","ac7012a4fe966ed4":"9njXz","270c4df638171a20":"bnNSm","80cd2bcd1b5438e2":"d2NWs","cf65b0a61ccf068d":"59Equ","4bf7eccbbf7abd03":"hTYBL","3bc87ea2d775418":"89fxU","f4ca7cd4062b9cdf":"2zy52","78dce487d90b9a8f":"ff3VX","8208e75de81ca84b":"dIcrQ","8eebd13f3ac46c49":"ajcyv","3509369760d84b1f":"hXusa","78a08833665fd7ec":"cq8Sn","1f3c214ce98dfcd4":"lt3pu","109101e83f1c8068":"3VzXh","8b76016f2e1ee1f":"1dlk8"}],"3VzXh":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6d05dd3af998900f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemButtonUtilityClass = getListItemButtonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("a2e7fdfb35a5c4ee"));
var _generateUtilityClass = _interopRequireDefault(require("b11aeb329499bc7f"));
function getListItemButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItemButton', slot);
}
const listItemButtonClasses = (0, _generateUtilityClasses.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var _default = exports.default = listItemButtonClasses;

},{"6d05dd3af998900f":"kZ6eK","a2e7fdfb35a5c4ee":"7pSUk","b11aeb329499bc7f":"jBs9M"}],"fztfw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("cf1f1232e0eb8730").default;
var _interopRequireDefault = require("8e6c41d04caf4ffd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    listItemSecondaryActionClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ListItemSecondaryAction.default;
    }
});
Object.defineProperty(exports, "listItemSecondaryActionClasses", {
    enumerable: true,
    get: function() {
        return _listItemSecondaryActionClasses.default;
    }
});
var _ListItemSecondaryAction = _interopRequireDefault(require("350ee2d947890b6c"));
var _listItemSecondaryActionClasses = _interopRequireWildcard(require("67b9d740400c19d"));
Object.keys(_listItemSecondaryActionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _listItemSecondaryActionClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _listItemSecondaryActionClasses[key];
        }
    });
});

},{"cf1f1232e0eb8730":"fiRIh","8e6c41d04caf4ffd":"kZ6eK","350ee2d947890b6c":"hnDQ8","67b9d740400c19d":"3z898"}],"hnDQ8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2172d57b313b32e8").default;
var _interopRequireWildcard = require("6b02929f93d6b2b3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("6c877055e61cd302"));
var _propTypes = _interopRequireDefault(require("a73c88fbdf1289ca"));
var _clsx = _interopRequireDefault(require("4be8df2f48c98fb7"));
var _composeClasses = _interopRequireDefault(require("73dff2660ce9192a"));
var _zeroStyled = require("8f44b1c3967d7f2b");
var _DefaultPropsProvider = require("29921628376744ce");
var _ListContext = _interopRequireDefault(require("3a4e47dd8b5967ec"));
var _listItemSecondaryActionClasses = require("8d0703a327d8a23a");
var _jsxRuntime = require("c8e77c2a54946f2a");
const useUtilityClasses = (ownerState)=>{
    const { disableGutters, classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, _composeClasses.default)(slots, _listItemSecondaryActionClasses.getListItemSecondaryActionClassesUtilityClass, classes);
};
const ListItemSecondaryActionRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const ListItemSecondaryAction = /*#__PURE__*/ React.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className, ...other } = props;
    const context = React.useContext(_ListContext.default);
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemSecondaryActionRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var _default = exports.default = ListItemSecondaryAction;

},{"2172d57b313b32e8":"kZ6eK","6b02929f93d6b2b3":"fiRIh","6c877055e61cd302":"9njXz","a73c88fbdf1289ca":"bnNSm","4be8df2f48c98fb7":"d2NWs","73dff2660ce9192a":"59Equ","8f44b1c3967d7f2b":"89fxU","29921628376744ce":"ff3VX","3a4e47dd8b5967ec":"lt3pu","8d0703a327d8a23a":"3z898","c8e77c2a54946f2a":"1dlk8"}],"3z898":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d05dd6a6ad1202f3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getListItemSecondaryActionClassesUtilityClass = getListItemSecondaryActionClassesUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("e07fb3dcb6d40c4d"));
var _generateUtilityClass = _interopRequireDefault(require("5b85da2095b48ba3"));
function getListItemSecondaryActionClassesUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiListItemSecondaryAction', slot);
}
const listItemSecondaryActionClasses = (0, _generateUtilityClasses.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var _default = exports.default = listItemSecondaryActionClasses;

},{"d05dd6a6ad1202f3":"kZ6eK","e07fb3dcb6d40c4d":"7pSUk","5b85da2095b48ba3":"jBs9M"}],"eSSCi":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("68faceaa9334abf1").default;
var _interopRequireDefault = require("118328c6f9267bd5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    chipClasses: true
};
Object.defineProperty(exports, "chipClasses", {
    enumerable: true,
    get: function() {
        return _chipClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Chip.default;
    }
});
var _Chip = _interopRequireDefault(require("c295a0ec5ca421de"));
var _chipClasses = _interopRequireWildcard(require("561e7a2481980bec"));
Object.keys(_chipClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _chipClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _chipClasses[key];
        }
    });
});

},{"68faceaa9334abf1":"fiRIh","118328c6f9267bd5":"kZ6eK","c295a0ec5ca421de":"lDpp0","561e7a2481980bec":"hzEJn"}],"lDpp0":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b9252277ffb01b6f").default;
var _interopRequireWildcard = require("952b31b8aa0527ee").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("3db6172f71133a3f"));
var _propTypes = _interopRequireDefault(require("1a2be9762e63f293"));
var _clsx = _interopRequireDefault(require("7c326484c592edd0"));
var _composeClasses = _interopRequireDefault(require("2dd88dbac8cc10d9"));
var _colorManipulator = require("76ce2a4acee7f1d");
var _Cancel = _interopRequireDefault(require("23182059f34a186c"));
var _useForkRef = _interopRequireDefault(require("8cce578ca010fd0b"));
var _unsupportedProp = _interopRequireDefault(require("7491a37485ccc882"));
var _capitalize = _interopRequireDefault(require("f1d6fcab82646fec"));
var _ButtonBase = _interopRequireDefault(require("40dd718d8d245ddf"));
var _zeroStyled = require("1062367f8fae9c95");
var _memoTheme = _interopRequireDefault(require("726b3672767f3723"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("6fd794204c535fca"));
var _DefaultPropsProvider = require("aa3a53421af03225");
var _chipClasses = _interopRequireWildcard(require("92e2eac2d5fc0d16"));
var _useSlot = _interopRequireDefault(require("2b396b35b8286164"));
var _jsxRuntime = require("acf7ea1b5e380551");
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, size, color, iconColor, onDelete, clickable, variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, _capitalize.default)(size)}`,
            `color${(0, _capitalize.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, _capitalize.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, _capitalize.default)(color)}`,
            `${variant}${(0, _capitalize.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, _capitalize.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, _capitalize.default)(size)}`,
            `avatarColor${(0, _capitalize.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, _capitalize.default)(size)}`,
            `iconColor${(0, _capitalize.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, _capitalize.default)(size)}`,
            `deleteIconColor${(0, _capitalize.default)(color)}`,
            `deleteIcon${(0, _capitalize.default)(variant)}Color${(0, _capitalize.default)(color)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _chipClasses.getChipUtilityClass, classes);
};
const ChipRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { color, iconColor, clickable, onDelete, size, variant } = ownerState;
        return [
            {
                [`& .${_chipClasses.default.avatar}`]: styles.avatar
            },
            {
                [`& .${_chipClasses.default.avatar}`]: styles[`avatar${(0, _capitalize.default)(size)}`]
            },
            {
                [`& .${_chipClasses.default.avatar}`]: styles[`avatarColor${(0, _capitalize.default)(color)}`]
            },
            {
                [`& .${_chipClasses.default.icon}`]: styles.icon
            },
            {
                [`& .${_chipClasses.default.icon}`]: styles[`icon${(0, _capitalize.default)(size)}`]
            },
            {
                [`& .${_chipClasses.default.icon}`]: styles[`iconColor${(0, _capitalize.default)(iconColor)}`]
            },
            {
                [`& .${_chipClasses.default.deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, _capitalize.default)(size)}`]
            },
            {
                [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIconColor${(0, _capitalize.default)(color)}`]
            },
            {
                [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, _capitalize.default)(variant)}Color${(0, _capitalize.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, _capitalize.default)(size)}`],
            styles[`color${(0, _capitalize.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, _capitalize.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, _capitalize.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, _capitalize.default)(color)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${_chipClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${_chipClasses.default.avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${_chipClasses.default.avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${_chipClasses.default.avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${_chipClasses.default.avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${_chipClasses.default.icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${_chipClasses.default.deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${_chipClasses.default.icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${_chipClasses.default.deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${_chipClasses.default.deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].contrastTextChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${_chipClasses.default.icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${_chipClasses.default.icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${_chipClasses.default.focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color,
                        onDelete: true
                    },
                    style: {
                        [`&.${_chipClasses.default.focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
                    },
                    [`&.${_chipClasses.default.focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${_chipClasses.default.focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${_chipClasses.default.clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${_chipClasses.default.focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${_chipClasses.default.avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${_chipClasses.default.avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${_chipClasses.default.icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${_chipClasses.default.iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${_chipClasses.default.deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${_chipClasses.default.deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.7)}`,
                        [`&.${_chipClasses.default.clickable}:hover`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        },
                        [`&.${_chipClasses.default.focusVisible}`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.focusOpacity)
                        },
                        [`& .${_chipClasses.default.deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const ChipLabel = (0, _zeroStyled.styled)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, _capitalize.default)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const Chip = /*#__PURE__*/ React.forwardRef(function Chip(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className, clickable: clickableProp, color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled = false, icon: iconProp, label, onClick, onDelete, onKeyDown, onKeyUp, size = 'medium', variant = 'filled', tabIndex, skipFocusWhenDisabled = false, // TODO v6: Rename to `focusableWhenDisabled`.
    slots = {}, slotProps = {}, ...other } = props;
    const chipRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? _ButtonBase.default : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component,
        disabled,
        size,
        color,
        iconColor: /*#__PURE__*/ React.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const moreProps = component === _ButtonBase.default ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ React.isValidElement(deleteIconProp) ? /*#__PURE__*/ React.cloneElement(deleteIconProp, {
        className: (0, _clsx.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Cancel.default, {
        className: classes.deleteIcon,
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ React.isValidElement(avatarProp)) avatar = /*#__PURE__*/ React.cloneElement(avatarProp, {
        className: (0, _clsx.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ React.isValidElement(iconProp)) icon = /*#__PURE__*/ React.cloneElement(iconProp, {
        className: (0, _clsx.default)(classes.icon, iconProp.props.className)
    });
    const externalForwardedProps = {
        slots,
        slotProps
    };
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        elementType: ChipRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState,
        // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
        shouldForwardComponentProp: true,
        ref: handleRef,
        className: (0, _clsx.default)(classes.root, className),
        additionalProps: {
            disabled: clickable && disabled ? true : undefined,
            tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
            ...moreProps
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    onClick(event);
                },
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onKeyUp: (event)=>{
                    handlers.onKeyUp?.(event);
                    handleKeyUp(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, _useSlot.default)('label', {
        elementType: ChipLabel,
        externalForwardedProps,
        ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        as: component,
        ...rootProps,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LabelSlot, {
                ...labelProps,
                children: label
            }),
            deleteIcon
        ]
    });
});
var _default = exports.default = Chip;

},{"b9252277ffb01b6f":"kZ6eK","952b31b8aa0527ee":"fiRIh","3db6172f71133a3f":"9njXz","1a2be9762e63f293":"bnNSm","7c326484c592edd0":"d2NWs","2dd88dbac8cc10d9":"59Equ","76ce2a4acee7f1d":"hTYBL","23182059f34a186c":"kdAWN","8cce578ca010fd0b":"cq8Sn","7491a37485ccc882":"lTxN8","f1d6fcab82646fec":"hBZko","40dd718d8d245ddf":"ajcyv","1062367f8fae9c95":"89fxU","726b3672767f3723":"2zy52","6fd794204c535fca":"yHYvD","aa3a53421af03225":"ff3VX","92e2eac2d5fc0d16":"hzEJn","2b396b35b8286164":"29rI6","acf7ea1b5e380551":"1dlk8"}],"kdAWN":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("3bf0434a5b42f718").default;
var _interopRequireWildcard = require("c48fb5ec42f35613").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d17d29376876ceff"));
var _createSvgIcon = _interopRequireDefault(require("ed5e6b56da3abfde"));
var _jsxRuntime = require("7aad839d9b4d48c4");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

},{"3bf0434a5b42f718":"kZ6eK","c48fb5ec42f35613":"fiRIh","d17d29376876ceff":"9njXz","ed5e6b56da3abfde":"k1uMV","7aad839d9b4d48c4":"1dlk8"}],"hzEJn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("df5eec3ca28cd042").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getChipUtilityClass = getChipUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("6f190a2bad1af171"));
var _generateUtilityClass = _interopRequireDefault(require("4f142cdc3efe66cf"));
function getChipUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiChip', slot);
}
const chipClasses = (0, _generateUtilityClasses.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var _default = exports.default = chipClasses;

},{"df5eec3ca28cd042":"kZ6eK","6f190a2bad1af171":"7pSUk","4f142cdc3efe66cf":"jBs9M"}],"8zYJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNonRangePickerStepNavigation", ()=>createNonRangePickerStepNavigation);
var _createStepNavigationJs = require("./createStepNavigation.js");
function createNonRangePickerStepNavigation(parameters) {
    const { steps } = parameters;
    return (0, _createStepNavigationJs.createStepNavigation)({
        steps,
        isViewMatchingStep: (view, step)=>{
            return step.views == null || step.views.includes(view);
        },
        onStepChange: ({ step, defaultView, setView, view, views })=>{
            const targetView = step.views == null ? defaultView : step.views.find((viewBis)=>views.includes(viewBis));
            if (targetView !== view) setView(targetView);
        }
    });
}

},{"./createStepNavigation.js":"8euDC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4liGN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderDateViewCalendar", ()=>(0, _dateViewRenderersJs.renderDateViewCalendar));
var _dateViewRenderersJs = require("./dateViewRenderers.js");

},{"./dateViewRenderers.js":"jDGGo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jDGGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderDateViewCalendar", ()=>renderDateViewCalendar);
var _react = require("react");
var _indexJs = require("../DateCalendar/index.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _jsxRuntime = require("react/jsx-runtime");
const renderDateViewCalendar = ({ view, onViewChange, views, focusedView, onFocusedViewChange, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minDate, maxDate, shouldDisableDate, shouldDisableMonth, shouldDisableYear, reduceAnimations, onMonthChange, monthsPerRow, onYearChange, yearsOrder, yearsPerRow, slots, slotProps, loading, renderLoading, disableHighlightToday, readOnly, disabled, showDaysOutsideCurrentMonth, dayOfWeekFormatter, sx, autoFocus, fixedWeekNumber, displayWeekNumber, timezone })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.DateCalendar), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, _dateUtilsJs.isDatePickerView)),
        focusedView: focusedView && (0, _dateUtilsJs.isDatePickerView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });

},{"react":"9njXz","../DateCalendar/index.js":"7Dkam","../internals/utils/date-utils.js":"jrk9G","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6L3BH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileDatePicker", ()=>(0, _mobileDatePickerJs.MobileDatePicker));
var _mobileDatePickerJs = require("./MobileDatePicker.js");

},{"./MobileDatePicker.js":"4xNFd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4xNFd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileDatePicker", ()=>MobileDatePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _resolveComponentProps = require("@mui/utils/resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _indexJs = require("../internals/hooks/useMobilePicker/index.js");
var _sharedJs = require("../DatePicker/shared.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _indexJs1 = require("../validation/index.js");
var _indexJs2 = require("../DateField/index.js");
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _indexJs3 = require("../dateViewRenderers/index.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const MobileDatePicker = /*#__PURE__*/ _react.forwardRef(function MobileDatePicker(inProps, ref) {
    const utils = (0, _useUtilsJs.useUtils)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, _sharedJs.useDatePickerDefaultizedProps)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, _extendsDefault.default)({
        day: (0, _indexJs3.renderDateViewCalendar),
        month: (0, _indexJs3.renderDateViewCalendar),
        year: (0, _indexJs3.renderDateViewCalendar)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, _extendsDefault.default)({}, defaultizedProps, {
        viewRenderers,
        format: (0, _dateUtilsJs.resolveDateFormat)(utils, defaultizedProps, false),
        slots: (0, _extendsDefault.default)({
            field: (0, _indexJs2.DateField)
        }, defaultizedProps.slots),
        slotProps: (0, _extendsDefault.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, _extendsDefault.default)({}, (0, _resolveComponentPropsDefault.default)(defaultizedProps.slotProps?.field, ownerState), (0, _indexJs1.extractValidationProps)(defaultizedProps)),
            toolbar: (0, _extendsDefault.default)({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker } = (0, _indexJs.useMobilePicker)({
        ref,
        props,
        valueManager: (0, _valueManagersJs.singleItemValueManager),
        valueType: 'date',
        validator: (0, _indexJs1.validateDate),
        steps: null
    });
    return renderPicker();
});
MobileDatePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: (0, _propTypesDefault.default).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, _propTypesDefault.default).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, _propTypesDefault.default).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, _propTypesDefault.default).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, _propTypesDefault.default).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, _propTypesDefault.default).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, _propTypesDefault.default).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, _propTypesDefault.default).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, _refTypeDefault.default),
    /**
   * The label content.
   */ label: (0, _propTypesDefault.default).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, _propTypesDefault.default).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, _propTypesDefault.default).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, _propTypesDefault.default).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, _propTypesDefault.default).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, _propTypesDefault.default).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, _propTypesDefault.default).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, _propTypesDefault.default).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, _propTypesDefault.default).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, _propTypesDefault.default).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, _propTypesDefault.default).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, _propTypesDefault.default).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, _propTypesDefault.default).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, _propTypesDefault.default).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, _propTypesDefault.default).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, _propTypesDefault.default).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, _propTypesDefault.default).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, _propTypesDefault.default).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, _propTypesDefault.default).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, _propTypesDefault.default).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, _propTypesDefault.default).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).bool
        ])),
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, _propTypesDefault.default).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, _propTypesDefault.default).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, _propTypesDefault.default).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, _propTypesDefault.default).shape({
        day: (0, _propTypesDefault.default).func,
        month: (0, _propTypesDefault.default).func,
        year: (0, _propTypesDefault.default).func
    }),
    /**
   * Available views.
   */ views: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, _propTypesDefault.default).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, _propTypesDefault.default).oneOf([
        3,
        4
    ])
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/utils/resolveComponentProps":"gGfhx","@mui/utils/refType":"3TBXN","../internals/hooks/useMobilePicker/index.js":"5OIPf","../DatePicker/shared.js":"7bXUZ","../internals/hooks/useUtils.js":"dJQ8a","../validation/index.js":"973pf","../DateField/index.js":"fNKm6","../internals/utils/valueManagers.js":"bimTj","../dateViewRenderers/index.js":"4liGN","../internals/utils/date-utils.js":"jrk9G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5OIPf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMobilePicker", ()=>(0, _useMobilePickerJs.useMobilePicker));
var _useMobilePickerJs = require("./useMobilePicker.js");

},{"./useMobilePicker.js":"kDltR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kDltR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMobilePicker", ()=>useMobilePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _pickersModalDialogJs = require("../../components/PickersModalDialog.js");
var _indexJs = require("../usePicker/index.js");
var _indexJs1 = require("../../../PickersLayout/index.js");
var _pickerProviderJs = require("../../components/PickerProvider.js");
var _pickerFieldUIJs = require("../../components/PickerFieldUI.js");
var _createNonRangePickerStepNavigationJs = require("../../utils/createNonRangePickerStepNavigation.js");
/**
 * Hook managing all the single-date mobile pickers:
 * - MobileDatePicker
 * - MobileDateTimePicker
 * - MobileTimePicker
 */ var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "props",
    "steps"
], _excluded2 = [
    "ownerState"
];
const useMobilePicker = (_ref)=>{
    let { props, steps } = _ref, pickerParams = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const { slots, slotProps: innerSlotProps, label, inputRef, localeText } = props;
    const getStepNavigation = (0, _createNonRangePickerStepNavigationJs.createNonRangePickerStepNavigation)({
        steps
    });
    const { providerProps, renderCurrentView, ownerState } = (0, _indexJs.usePicker)((0, _extendsDefault.default)({}, pickerParams, {
        props,
        localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'mobile',
        getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, _extendsDefault.default)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState
    }), fieldProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded2);
    const Layout = slots.layout ?? (0, _indexJs1.PickersLayout);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, _extendsDefault.default)({}, innerSlotProps, {
        toolbar: (0, _extendsDefault.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, _extendsDefault.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickerProviderJs.PickerProvider), (0, _extendsDefault.default)({}, providerProps, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pickerFieldUIJs.PickerFieldUIContextProvider), {
                slots: slots,
                slotProps: slotProps,
                inputRef: inputRef,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Field, (0, _extendsDefault.default)({}, fieldProps)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersModalDialogJs.PickersModalDialog), {
                        slots: slots,
                        slotProps: slotProps,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layout, (0, _extendsDefault.default)({}, slotProps?.layout, {
                            slots: slots,
                            slotProps: slotProps,
                            children: renderCurrentView()
                        }))
                    })
                ]
            })
        }));
    return {
        renderPicker
    };
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","@mui/utils/useSlotProps":"kr4RG","../../components/PickersModalDialog.js":"geCVG","../usePicker/index.js":"dE5KP","../../../PickersLayout/index.js":"9qQLb","../../components/PickerProvider.js":"lJDhK","../../components/PickerFieldUI.js":"cxHPG","../../utils/createNonRangePickerStepNavigation.js":"8zYJh","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"geCVG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersModalDialog", ()=>PickersModalDialog);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _styles = require("@mui/material/styles");
var _dimensionsJs = require("../constants/dimensions.js");
var _indexJs = require("../../hooks/index.js");
var _usePickerPrivateContextJs = require("../hooks/usePickerPrivateContext.js");
var _jsxRuntime = require("react/jsx-runtime");
const PickersModalDialogRoot = (0, _styles.styled)((0, _dialogDefault.default))({
    [`& .${(0, _dialog.dialogClasses).container}`]: {
        outline: 0
    },
    [`& .${(0, _dialog.dialogClasses).paper}`]: {
        outline: 0,
        minWidth: (0, _dimensionsJs.DIALOG_WIDTH)
    }
});
const PickersModalDialogContent = (0, _styles.styled)((0, _dialogContentDefault.default))({
    '&:first-of-type': {
        padding: 0
    }
});
function PickersModalDialog(props) {
    const { children, slots, slotProps } = props;
    const { open } = (0, _indexJs.usePickerContext)();
    const { dismissViews, onPopperExited } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const Dialog = slots?.dialog ?? PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? (0, _fadeDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Dialog, (0, _extendsDefault.default)({
        open: open,
        onClose: ()=>{
            dismissViews();
            onPopperExited?.();
        }
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersModalDialogContent, {
            children: children
        })
    }));
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/material/DialogContent":"gD0J9","@mui/material/Fade":"8DwqP","@mui/material/Dialog":"255tO","@mui/material/styles":"c9RfU","../constants/dimensions.js":"i0BgX","../../hooks/index.js":"a3BuB","../hooks/usePickerPrivateContext.js":"4puZL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gD0J9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("787e247665fceb48").default;
var _interopRequireDefault = require("820a5e7da33c4db6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dialogContentClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DialogContent.default;
    }
});
Object.defineProperty(exports, "dialogContentClasses", {
    enumerable: true,
    get: function() {
        return _dialogContentClasses.default;
    }
});
var _DialogContent = _interopRequireDefault(require("fc8199f73e9b2c32"));
var _dialogContentClasses = _interopRequireWildcard(require("6c3962a6b0ed75ae"));
Object.keys(_dialogContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dialogContentClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dialogContentClasses[key];
        }
    });
});

},{"787e247665fceb48":"fiRIh","820a5e7da33c4db6":"kZ6eK","fc8199f73e9b2c32":"4yW2t","6c3962a6b0ed75ae":"c7aZj"}],"4yW2t":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("65ccf5abc283a41c").default;
var _interopRequireWildcard = require("847682c4ad843d76").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e3d88dddbcd1cba4"));
var _propTypes = _interopRequireDefault(require("4380947b205246fd"));
var _clsx = _interopRequireDefault(require("b14d1699ca29fa61"));
var _composeClasses = _interopRequireDefault(require("19d4234a5b78bf31"));
var _zeroStyled = require("e851ce6d6442bf57");
var _memoTheme = _interopRequireDefault(require("dab0fd9c68be52bb"));
var _DefaultPropsProvider = require("5c1383cc5925c340");
var _dialogContentClasses = require("271c09dec02f683d");
var _dialogTitleClasses = _interopRequireDefault(require("275a6022e91c9c82"));
var _jsxRuntime = require("c0d12f043e85a6f4");
const useUtilityClasses = (ownerState)=>{
    const { classes, dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, _composeClasses.default)(slots, _dialogContentClasses.getDialogContentUtilityClass, classes);
};
const DialogContentRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState })=>!ownerState.dividers,
                style: {
                    [`.${_dialogTitleClasses.default.root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const DialogContent = /*#__PURE__*/ React.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className, dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogContentRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var _default = exports.default = DialogContent;

},{"65ccf5abc283a41c":"kZ6eK","847682c4ad843d76":"fiRIh","e3d88dddbcd1cba4":"9njXz","4380947b205246fd":"bnNSm","b14d1699ca29fa61":"d2NWs","19d4234a5b78bf31":"59Equ","e851ce6d6442bf57":"89fxU","dab0fd9c68be52bb":"2zy52","5c1383cc5925c340":"ff3VX","271c09dec02f683d":"c7aZj","275a6022e91c9c82":"8b2cc","c0d12f043e85a6f4":"1dlk8"}],"c7aZj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1fab028c2106e83b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDialogContentUtilityClass = getDialogContentUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("f4dad2bd3c3a75a5"));
var _generateUtilityClass = _interopRequireDefault(require("3ae0512c98ee7359"));
function getDialogContentUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDialogContent', slot);
}
const dialogContentClasses = (0, _generateUtilityClasses.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var _default = exports.default = dialogContentClasses;

},{"1fab028c2106e83b":"kZ6eK","f4dad2bd3c3a75a5":"7pSUk","3ae0512c98ee7359":"jBs9M"}],"8b2cc":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9dec8ff5d78dfb22").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDialogTitleUtilityClass = getDialogTitleUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("8f39532065380a87"));
var _generateUtilityClass = _interopRequireDefault(require("8927cbf9a9b81a2d"));
function getDialogTitleUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDialogTitle', slot);
}
const dialogTitleClasses = (0, _generateUtilityClasses.default)('MuiDialogTitle', [
    'root'
]);
var _default = exports.default = dialogTitleClasses;

},{"9dec8ff5d78dfb22":"kZ6eK","8f39532065380a87":"7pSUk","8927cbf9a9b81a2d":"jBs9M"}],"255tO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c292badef4f7b65").default;
var _interopRequireDefault = require("27913aff4983182b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dialogClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Dialog.default;
    }
});
Object.defineProperty(exports, "dialogClasses", {
    enumerable: true,
    get: function() {
        return _dialogClasses.default;
    }
});
var _Dialog = _interopRequireDefault(require("d3f01af3691d531a"));
var _dialogClasses = _interopRequireWildcard(require("578cc2c26745050a"));
Object.keys(_dialogClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dialogClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dialogClasses[key];
        }
    });
});

},{"c292badef4f7b65":"fiRIh","27913aff4983182b":"kZ6eK","d3f01af3691d531a":"apEQC","578cc2c26745050a":"7FBQB"}],"apEQC":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("6f1757b67301d24").default;
var _interopRequireWildcard = require("ae672ed0248ba9a2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e48c3d65f1e67d1b"));
var _propTypes = _interopRequireDefault(require("30f807c3834f05e0"));
var _clsx = _interopRequireDefault(require("7f554e1f2a365947"));
var _composeClasses = _interopRequireDefault(require("5c45f70cfe3fe9e9"));
var _useId = _interopRequireDefault(require("8064bcde1b250d0a"));
var _capitalize = _interopRequireDefault(require("8d9106abfb75ea76"));
var _Modal = _interopRequireDefault(require("5f96bd8c6ecd41e9"));
var _Fade = _interopRequireDefault(require("a276ff91e6705a1c"));
var _Paper = _interopRequireDefault(require("8f247edec94112d1"));
var _dialogClasses = _interopRequireWildcard(require("66c0d0b12895dbf5"));
var _DialogContext = _interopRequireDefault(require("5a8267ec543d53eb"));
var _Backdrop = _interopRequireDefault(require("fe4639f7b27cd259"));
var _zeroStyled = require("2c1427ffbb83ea28");
var _memoTheme = _interopRequireDefault(require("66932a3b884343ff"));
var _DefaultPropsProvider = require("d517611cb9cc4877");
var _useSlot = _interopRequireDefault(require("29443d181f74e13a"));
var _jsxRuntime = require("84e59129bc9be280");
const DialogBackdrop = (0, _zeroStyled.styled)(_Backdrop.default, {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const useUtilityClasses = (ownerState)=>{
    const { classes, scroll, maxWidth, fullWidth, fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, _capitalize.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, _capitalize.default)(scroll)}`,
            `paperWidth${(0, _capitalize.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, _composeClasses.default)(slots, _dialogClasses.getDialogUtilityClass, classes);
};
const DialogRoot = (0, _zeroStyled.styled)(_Modal.default, {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const DialogContainer = (0, _zeroStyled.styled)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, _capitalize.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const DialogPaper = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, _capitalize.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, _capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${_dialogClasses.default.paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${_dialogClasses.default.paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${_dialogClasses.default.paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const Dialog = /*#__PURE__*/ React.forwardRef(function Dialog(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, _zeroStyled.useTheme)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent, BackdropProps, children, className, disableEscapeKeyDown = false, fullScreen = false, fullWidth = false, maxWidth = 'sm', onClick, onClose, open, PaperComponent = _Paper.default, PaperProps = {}, scroll = 'paper', slots = {}, slotProps = {}, TransitionComponent = _Fade.default, transitionDuration = defaultTransitionDuration, TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown,
        fullScreen,
        fullWidth,
        maxWidth,
        scroll
    };
    const classes = useUtilityClasses(ownerState);
    const backdropClick = React.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, _useId.default)(ariaLabelledbyProp);
    const dialogContextValue = React.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        elementType: DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, _useSlot.default)('backdrop', {
        elementType: DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, _useSlot.default)('paper', {
        elementType: DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        ownerState,
        className: (0, _clsx.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, _useSlot.default)('container', {
        elementType: DialogContainer,
        externalForwardedProps,
        ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, _useSlot.default)('transition', {
        elementType: _Fade.default,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DialogContext.default.Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var _default = exports.default = Dialog;

},{"6f1757b67301d24":"kZ6eK","ae672ed0248ba9a2":"fiRIh","e48c3d65f1e67d1b":"9njXz","30f807c3834f05e0":"bnNSm","7f554e1f2a365947":"d2NWs","5c45f70cfe3fe9e9":"59Equ","8064bcde1b250d0a":"50qgI","8d9106abfb75ea76":"hBZko","5f96bd8c6ecd41e9":"akOht","a276ff91e6705a1c":"8DwqP","8f247edec94112d1":"arHf6","66c0d0b12895dbf5":"7FBQB","5a8267ec543d53eb":"8O3Tg","fe4639f7b27cd259":"j7994","2c1427ffbb83ea28":"89fxU","66932a3b884343ff":"2zy52","d517611cb9cc4877":"ff3VX","29443d181f74e13a":"29rI6","84e59129bc9be280":"1dlk8"}],"7FBQB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5577fdfa3012b0fc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getDialogUtilityClass = getDialogUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("3557df371f0c78f1"));
var _generateUtilityClass = _interopRequireDefault(require("ed4b99c3905eb0bd"));
function getDialogUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDialog', slot);
}
const dialogClasses = (0, _generateUtilityClasses.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var _default = exports.default = dialogClasses;

},{"5577fdfa3012b0fc":"kZ6eK","3557df371f0c78f1":"7pSUk","ed4b99c3905eb0bd":"jBs9M"}],"8O3Tg":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("30ead9ae8e3387b7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("748394ddf2a020a9"));
const DialogContext = /*#__PURE__*/ React.createContext({});
var _default = exports.default = DialogContext;

},{"30ead9ae8e3387b7":"fiRIh","748394ddf2a020a9":"9njXz"}],"77pDg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimePicker", ()=>(0, _dateTimePickerJs.DateTimePicker));
parcelHelpers.export(exports, "DateTimePickerTabs", ()=>(0, _dateTimePickerTabsJs.DateTimePickerTabs));
parcelHelpers.export(exports, "dateTimePickerTabsClasses", ()=>(0, _dateTimePickerTabsClassesJs.dateTimePickerTabsClasses));
parcelHelpers.export(exports, "DateTimePickerToolbar", ()=>(0, _dateTimePickerToolbarJs.DateTimePickerToolbar));
parcelHelpers.export(exports, "dateTimePickerToolbarClasses", ()=>(0, _dateTimePickerToolbarClassesJs.dateTimePickerToolbarClasses));
var _dateTimePickerJs = require("./DateTimePicker.js");
var _dateTimePickerTabsJs = require("./DateTimePickerTabs.js");
var _dateTimePickerTabsClassesJs = require("./dateTimePickerTabsClasses.js");
var _dateTimePickerToolbarJs = require("./DateTimePickerToolbar.js");
var _dateTimePickerToolbarClassesJs = require("./dateTimePickerToolbarClasses.js");

},{"./DateTimePicker.js":"8T5lA","./DateTimePickerTabs.js":false,"./dateTimePickerTabsClasses.js":false,"./DateTimePickerToolbar.js":false,"./dateTimePickerToolbarClasses.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8T5lA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimePicker", ()=>DateTimePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _styles = require("@mui/material/styles");
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _indexJs = require("../DesktopDateTimePicker/index.js");
var _indexJs1 = require("../MobileDateTimePicker/index.js");
var _utilsJs = require("../internals/utils/utils.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateTimePicker API](https://mui.com/x/api/date-pickers/date-time-picker/)
 */ const DateTimePicker = /*#__PURE__*/ _react.forwardRef(function DateTimePicker(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimePicker'
    });
    const { desktopModeMediaQuery = (0, _utilsJs.DEFAULT_DESKTOP_MODE_MEDIA_QUERY) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, _useMediaQueryDefault.default)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.DesktopDateTimePicker), (0, _extendsDefault.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs1.MobileDateTimePicker), (0, _extendsDefault.default)({
        ref: ref
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/material/useMediaQuery":"bnRpi","@mui/material/styles":"c9RfU","@mui/utils/refType":"3TBXN","../DesktopDateTimePicker/index.js":"67mSj","../MobileDateTimePicker/index.js":"kUDlR","../internals/utils/utils.js":"k4iiH","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67mSj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesktopDateTimePicker", ()=>(0, _desktopDateTimePickerJs.DesktopDateTimePicker));
parcelHelpers.export(exports, "DesktopDateTimePickerLayout", ()=>(0, _desktopDateTimePickerLayoutJs.DesktopDateTimePickerLayout));
var _desktopDateTimePickerJs = require("./DesktopDateTimePicker.js");
var _desktopDateTimePickerLayoutJs = require("./DesktopDateTimePickerLayout.js");

},{"./DesktopDateTimePicker.js":"hngol","./DesktopDateTimePickerLayout.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hngol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesktopDateTimePicker", ()=>DesktopDateTimePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _resolveComponentProps = require("@mui/utils/resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _indexJs = require("../DateTimeField/index.js");
var _sharedJs = require("../DateTimePicker/shared.js");
var _dateViewRenderersJs = require("../dateViewRenderers/dateViewRenderers.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _indexJs1 = require("../validation/index.js");
var _indexJs2 = require("../internals/hooks/useDesktopPicker/index.js");
var _dateTimeUtilsJs = require("../internals/utils/date-time-utils.js");
var _indexJs3 = require("../timeViewRenderers/index.js");
var _indexJs4 = require("../MultiSectionDigitalClock/index.js");
var _indexJs5 = require("../DigitalClock/index.js");
var _desktopDateTimePickerLayoutJs = require("./DesktopDateTimePickerLayout.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _timeUtilsJs = require("../internals/utils/time-utils.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "openTo",
    "focusedView",
    "timeViewsCount"
];
const rendererInterceptor = function RendererInterceptor(props) {
    const { viewRenderers, popperView, rendererProps } = props;
    const { openTo, focusedView, timeViewsCount } = rendererProps, otherProps = (0, _objectWithoutPropertiesLooseDefault.default)(rendererProps, _excluded);
    const finalProps = (0, _extendsDefault.default)({}, otherProps, {
        // we control the focused view manually
        autoFocus: false,
        focusedView: null,
        sx: [
            {
                [`&.${(0, _indexJs4.multiSectionDigitalClockClasses).root}`]: {
                    borderBottom: 0
                },
                [`&.${(0, _indexJs4.multiSectionDigitalClockClasses).root}, .${(0, _indexJs4.multiSectionDigitalClockSectionClasses).root}, &.${(0, _indexJs5.digitalClockClasses).root}`]: {
                    maxHeight: (0, _dimensionsJs.VIEW_HEIGHT)
                }
            }
        ]
    });
    const isTimeViewActive = (0, _timeUtilsJs.isInternalTimeView)(popperView);
    const dateView = isTimeViewActive ? 'day' : popperView;
    const timeView = isTimeViewActive ? popperView : 'hours';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            viewRenderers[dateView]?.((0, _extendsDefault.default)({}, rendererProps, {
                view: !isTimeViewActive ? popperView : 'day',
                focusedView: focusedView && (0, _dateUtilsJs.isDatePickerView)(focusedView) ? focusedView : null,
                views: rendererProps.views.filter((0, _dateUtilsJs.isDatePickerView)),
                sx: [
                    {
                        gridColumn: 1
                    },
                    ...finalProps.sx
                ]
            })),
            timeViewsCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                        orientation: "vertical",
                        sx: {
                            gridColumn: 2
                        }
                    }),
                    viewRenderers[timeView]?.((0, _extendsDefault.default)({}, finalProps, {
                        view: isTimeViewActive ? popperView : 'hours',
                        focusedView: focusedView && (0, _timeUtilsJs.isInternalTimeView)(focusedView) ? focusedView : null,
                        openTo: (0, _timeUtilsJs.isInternalTimeView)(openTo) ? openTo : 'hours',
                        views: rendererProps.views.filter((0, _timeUtilsJs.isInternalTimeView)),
                        sx: [
                            {
                                gridColumn: 3
                            },
                            ...finalProps.sx
                        ]
                    }))
                ]
            })
        ]
    });
};
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDateTimePicker API](https://mui.com/x/api/date-pickers/desktop-date-time-picker/)
 */ const DesktopDateTimePicker = /*#__PURE__*/ _react.forwardRef(function DesktopDateTimePicker(inProps, ref) {
    const utils = (0, _useUtilsJs.useUtils)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, _sharedJs.useDateTimePickerDefaultizedProps)(inProps, 'MuiDesktopDateTimePicker');
    const renderTimeView = defaultizedProps.shouldRenderTimeInASingleColumn ? (0, _indexJs3.renderDigitalClockTimeView) : (0, _indexJs3.renderMultiSectionDigitalClockTimeView);
    const viewRenderers = (0, _extendsDefault.default)({
        day: (0, _dateViewRenderersJs.renderDateViewCalendar),
        month: (0, _dateViewRenderersJs.renderDateViewCalendar),
        year: (0, _dateViewRenderersJs.renderDateViewCalendar),
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? true;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === (0, _indexJs3.renderMultiSectionDigitalClockTimeView).name;
    const views = !shouldHoursRendererContainMeridiemView ? defaultizedProps.views.filter((view)=>view !== 'meridiem') : defaultizedProps.views;
    // Props with the default values specific to the desktop variant
    const props = (0, _extendsDefault.default)({}, defaultizedProps, {
        viewRenderers,
        format: (0, _dateTimeUtilsJs.resolveDateTimeFormat)(utils, defaultizedProps),
        views,
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        ampmInClock,
        slots: (0, _extendsDefault.default)({
            field: (0, _indexJs.DateTimeField),
            layout: (0, _desktopDateTimePickerLayoutJs.DesktopDateTimePickerLayout)
        }, defaultizedProps.slots),
        slotProps: (0, _extendsDefault.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, _extendsDefault.default)({}, (0, _resolveComponentPropsDefault.default)(defaultizedProps.slotProps?.field, ownerState), (0, _indexJs1.extractValidationProps)(defaultizedProps)),
            toolbar: (0, _extendsDefault.default)({
                hidden: true,
                ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, _extendsDefault.default)({
                hidden: true
            }, defaultizedProps.slotProps?.tabs)
        })
    });
    const { renderPicker } = (0, _indexJs2.useDesktopPicker)({
        ref,
        props,
        valueManager: (0, _valueManagersJs.singleItemValueManager),
        valueType: 'date-time',
        validator: (0, _indexJs1.validateDateTime),
        rendererInterceptor,
        steps: null
    });
    return renderPicker();
});
DesktopDateTimePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, _propTypesDefault.default).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: (0, _propTypesDefault.default).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, _propTypesDefault.default).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, _propTypesDefault.default).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, _propTypesDefault.default).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, _propTypesDefault.default).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, _propTypesDefault.default).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, _propTypesDefault.default).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, _propTypesDefault.default).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, _propTypesDefault.default).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, _refTypeDefault.default),
    /**
   * The label content.
   */ label: (0, _propTypesDefault.default).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, _propTypesDefault.default).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, _propTypesDefault.default).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, _propTypesDefault.default).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, _propTypesDefault.default).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, _propTypesDefault.default).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, _propTypesDefault.default).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, _propTypesDefault.default).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, _propTypesDefault.default).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, _propTypesDefault.default).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, _propTypesDefault.default).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, _propTypesDefault.default).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, _propTypesDefault.default).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, _propTypesDefault.default).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, _propTypesDefault.default).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, _propTypesDefault.default).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, _propTypesDefault.default).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, _propTypesDefault.default).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, _propTypesDefault.default).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, _propTypesDefault.default).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, _propTypesDefault.default).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, _propTypesDefault.default).func,
    /**
   * Disable specific time.
   * @param {PickerValidDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, _propTypesDefault.default).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, _propTypesDefault.default).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, _propTypesDefault.default).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, _propTypesDefault.default).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, _propTypesDefault.default).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).bool
        ])),
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, _propTypesDefault.default).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, _propTypesDefault.default).shape({
        hours: (0, _propTypesDefault.default).number,
        minutes: (0, _propTypesDefault.default).number,
        seconds: (0, _propTypesDefault.default).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, _propTypesDefault.default).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, _propTypesDefault.default).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, _propTypesDefault.default).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, _propTypesDefault.default).shape({
        day: (0, _propTypesDefault.default).func,
        hours: (0, _propTypesDefault.default).func,
        meridiem: (0, _propTypesDefault.default).func,
        minutes: (0, _propTypesDefault.default).func,
        month: (0, _propTypesDefault.default).func,
        seconds: (0, _propTypesDefault.default).func,
        year: (0, _propTypesDefault.default).func
    }),
    /**
   * Available views.
   */ views: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, _propTypesDefault.default).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, _propTypesDefault.default).oneOf([
        3,
        4
    ])
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/utils/resolveComponentProps":"gGfhx","@mui/utils/refType":"3TBXN","@mui/material/Divider":"5Ykub","../internals/utils/valueManagers.js":"bimTj","../DateTimeField/index.js":"jI1xE","../DateTimePicker/shared.js":"cte17","../dateViewRenderers/dateViewRenderers.js":"jDGGo","../internals/hooks/useUtils.js":"dJQ8a","../validation/index.js":"973pf","../internals/hooks/useDesktopPicker/index.js":"8Uqxx","../internals/utils/date-time-utils.js":"2q1gF","../timeViewRenderers/index.js":"lWq1R","../MultiSectionDigitalClock/index.js":"6BKf0","../DigitalClock/index.js":"aDNgV","./DesktopDateTimePickerLayout.js":"esKHK","../internals/constants/dimensions.js":"i0BgX","../internals/utils/time-utils.js":"7FMia","../internals/utils/date-utils.js":"jrk9G","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cte17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDateTimePickerDefaultizedProps", ()=>useDateTimePickerDefaultizedProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _styles = require("@mui/material/styles");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _dateTimePickerTabsJs = require("./DateTimePickerTabs.js");
var _dateTimePickerToolbarJs = require("./DateTimePickerToolbar.js");
var _viewsJs = require("../internals/utils/views.js");
var _dateTimeUtilsJs = require("../internals/utils/date-time-utils.js");
var _useDateTimeManagerJs = require("../managers/useDateTimeManager.js");
function useDateTimePickerDefaultizedProps(props, name) {
    const utils = (0, _useUtilsJs.useUtils)();
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const validationProps = (0, _useDateTimeManagerJs.useApplyDefaultValuesToDateTimeValidationProps)(themeProps);
    const ampm = themeProps.ampm ?? utils.is12HourCycleInCurrentLocale();
    const localeText = _react.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, _extendsDefault.default)({}, themeProps.localeText, {
            dateTimePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const { openTo, views: defaultViews } = (0, _viewsJs.applyDefaultViewProps)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day',
            'hours',
            'minutes'
        ],
        defaultOpenTo: 'day'
    });
    const { shouldRenderTimeInASingleColumn, thresholdToRenderTimeInASingleColumn, views, timeSteps } = (0, _dateTimeUtilsJs.resolveTimeViewsResponse)({
        thresholdToRenderTimeInASingleColumn: themeProps.thresholdToRenderTimeInASingleColumn,
        ampm,
        timeSteps: themeProps.timeSteps,
        views: defaultViews
    });
    return (0, _extendsDefault.default)({}, themeProps, validationProps, {
        timeSteps,
        openTo,
        shouldRenderTimeInASingleColumn,
        thresholdToRenderTimeInASingleColumn,
        views,
        ampm,
        localeText,
        orientation: themeProps.orientation ?? 'portrait',
        slots: (0, _extendsDefault.default)({
            toolbar: (0, _dateTimePickerToolbarJs.DateTimePickerToolbar),
            tabs: (0, _dateTimePickerTabsJs.DateTimePickerTabs)
        }, themeProps.slots),
        slotProps: (0, _extendsDefault.default)({}, themeProps.slotProps, {
            toolbar: (0, _extendsDefault.default)({
                ampm
            }, themeProps.slotProps?.toolbar)
        })
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/material/styles":"c9RfU","../internals/hooks/useUtils.js":"dJQ8a","./DateTimePickerTabs.js":"g907c","./DateTimePickerToolbar.js":"fUSiQ","../internals/utils/views.js":"lfBM6","../internals/utils/date-time-utils.js":"2q1gF","../managers/useDateTimeManager.js":"iOnPY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g907c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimePickerTabs", ()=>DateTimePickerTabs);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tab = require("@mui/material/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabs = require("@mui/material/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _indexJs = require("../icons/index.js");
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _dateTimePickerTabsClassesJs = require("./dateTimePickerTabsClasses.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _usePickerPrivateContextJs = require("../internals/hooks/usePickerPrivateContext.js");
var _indexJs1 = require("../hooks/index.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const viewToTab = (view)=>{
    if ((0, _dateUtilsJs.isDatePickerView)(view)) return 'date';
    return 'time';
};
const tabToView = (tab)=>{
    if (tab === 'date') return 'day';
    return 'hours';
};
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dateTimePickerTabsClassesJs.getDateTimePickerTabsUtilityClass), classes);
};
const DateTimePickerTabsRoot = (0, _styles.styled)((0, _tabsDefault.default), {
    name: 'MuiDateTimePickerTabs',
    slot: 'Root'
})(({ theme })=>({
        boxShadow: `0 -1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
        '&:last-child': {
            boxShadow: `0 1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
            [`& .${(0, _tabs.tabsClasses).indicator}`]: {
                bottom: 'auto',
                top: 0
            }
        }
    }));
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerTabs API](https://mui.com/x/api/date-pickers/date-time-picker-tabs/)
 */ const DateTimePickerTabs = function DateTimePickerTabs(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimePickerTabs'
    });
    const { dateIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.DateRangeIcon), {}), timeIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.TimeIcon), {}), hidden = typeof window === 'undefined' || window.innerHeight < 667, className, classes: classesProp, sx } = props;
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const { ownerState } = (0, _usePickerPrivateContextJs.usePickerPrivateContext)();
    const { view, setView } = (0, _indexJs1.usePickerContext)();
    const classes = useUtilityClasses(classesProp);
    const handleChange = (event, value)=>{
        setView(tabToView(value));
    };
    if (hidden) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DateTimePickerTabsRoot, {
        ownerState: ownerState,
        variant: "fullWidth",
        value: viewToTab(view),
        onChange: handleChange,
        className: (0, _clsxDefault.default)(className, classes.root),
        sx: sx,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                value: "date",
                "aria-label": translations.dateTableLabel,
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
                    children: dateIcon
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                value: "time",
                "aria-label": translations.timeTableLabel,
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
                    children: timeIcon
                })
            })
        ]
    });
};

},{"react":"9njXz","clsx":"d2NWs","prop-types":"bnNSm","@mui/material/Tab":"bmkB3","@mui/material/Tabs":"g7Izf","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","../icons/index.js":"8RbJX","../hooks/usePickerTranslations.js":"3Zb4l","./dateTimePickerTabsClasses.js":"9WlZY","../internals/utils/date-utils.js":"jrk9G","../internals/hooks/usePickerPrivateContext.js":"4puZL","../hooks/index.js":"a3BuB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bmkB3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e8ddf1b727aba80f").default;
var _interopRequireDefault = require("47d0820a1fc02ae").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tabClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Tab.default;
    }
});
Object.defineProperty(exports, "tabClasses", {
    enumerable: true,
    get: function() {
        return _tabClasses.default;
    }
});
var _Tab = _interopRequireDefault(require("b76f849aa8f288cf"));
var _tabClasses = _interopRequireWildcard(require("4d11d2c4e1925e02"));
Object.keys(_tabClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tabClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tabClasses[key];
        }
    });
});

},{"e8ddf1b727aba80f":"fiRIh","47d0820a1fc02ae":"kZ6eK","b76f849aa8f288cf":"5g0Pq","4d11d2c4e1925e02":"1Tlfp"}],"5g0Pq":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("8729d350f43684e7").default;
var _interopRequireWildcard = require("835b0a53733ea75f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("9152f409c691ced7"));
var _propTypes = _interopRequireDefault(require("a353353cecf84544"));
var _clsx = _interopRequireDefault(require("737ad620202cc4db"));
var _composeClasses = _interopRequireDefault(require("f360f1269d36e966"));
var _ButtonBase = _interopRequireDefault(require("d5c2ce9b7ce70c5c"));
var _capitalize = _interopRequireDefault(require("78a3e6e89cc8d513"));
var _zeroStyled = require("a41119088f4b74e4");
var _memoTheme = _interopRequireDefault(require("4a0b94e0337d695d"));
var _DefaultPropsProvider = require("a2005df334636d8a");
var _unsupportedProp = _interopRequireDefault(require("5b7b5d07cfc5170c"));
var _tabClasses = _interopRequireWildcard(require("af5bc7a1e07c9e1e"));
var _jsxRuntime = require("b43df650a1352b01");
const useUtilityClasses = (ownerState)=>{
    const { classes, textColor, fullWidth, wrapped, icon, label, selected, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, _capitalize.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, _composeClasses.default)(slots, _tabClasses.getTabUtilityClass, classes);
};
const TabRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, _capitalize.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${_tabClasses.default.iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${_tabClasses.default.icon}`]: styles.icon
            }
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState, iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${_tabClasses.default.icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState, iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${_tabClasses.default.icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState, iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${_tabClasses.default.icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState, iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${_tabClasses.default.icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${_tabClasses.default.selected}`]: {
                        opacity: 1
                    },
                    [`&.${_tabClasses.default.disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${_tabClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${_tabClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${_tabClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${_tabClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const Tab = /*#__PURE__*/ React.forwardRef(function Tab(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className, disabled = false, disableFocusRipple = false, // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition = 'top', // eslint-disable-next-line react/prop-types
    indicator, label, onChange, onClick, onFocus, // eslint-disable-next-line react/prop-types
    selected, // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value, wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled,
        disableFocusRipple,
        selected,
        icon: !!iconProp,
        iconPosition,
        label: !!label,
        fullWidth,
        textColor,
        wrapped
    };
    const classes = useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ React.isValidElement(iconProp) ? /*#__PURE__*/ React.cloneElement(iconProp, {
        className: (0, _clsx.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var _default = exports.default = Tab;

},{"8729d350f43684e7":"kZ6eK","835b0a53733ea75f":"fiRIh","9152f409c691ced7":"9njXz","a353353cecf84544":"bnNSm","737ad620202cc4db":"d2NWs","f360f1269d36e966":"59Equ","d5c2ce9b7ce70c5c":"ajcyv","78a3e6e89cc8d513":"hBZko","a41119088f4b74e4":"89fxU","4a0b94e0337d695d":"2zy52","a2005df334636d8a":"ff3VX","5b7b5d07cfc5170c":"lTxN8","af5bc7a1e07c9e1e":"1Tlfp","b43df650a1352b01":"1dlk8"}],"1Tlfp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("25fc695dbb7a1d8f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTabUtilityClass = getTabUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("49e3b3e03905d4d1"));
var _generateUtilityClass = _interopRequireDefault(require("decb9aa4275dd038"));
function getTabUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTab', slot);
}
const tabClasses = (0, _generateUtilityClasses.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var _default = exports.default = tabClasses;

},{"25fc695dbb7a1d8f":"kZ6eK","49e3b3e03905d4d1":"7pSUk","decb9aa4275dd038":"jBs9M"}],"g7Izf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("424effd77f727fd4").default;
var _interopRequireDefault = require("19b815a92379667c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tabsClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Tabs.default;
    }
});
Object.defineProperty(exports, "tabsClasses", {
    enumerable: true,
    get: function() {
        return _tabsClasses.default;
    }
});
var _Tabs = _interopRequireDefault(require("cd963b1335679d96"));
var _tabsClasses = _interopRequireWildcard(require("fec46653ec579918"));
Object.keys(_tabsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tabsClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tabsClasses[key];
        }
    });
});

},{"424effd77f727fd4":"fiRIh","19b815a92379667c":"kZ6eK","cd963b1335679d96":"91Lez","fec46653ec579918":"W2KpW"}],"91Lez":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("8bb8d651aff7a05c").default;
var _interopRequireWildcard = require("e1c33d4bab21eee1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("958fde7868f5c3ca"));
var _reactIs = require("40723a1e9a9bd300");
var _propTypes = _interopRequireDefault(require("1a3a5fb3f6e3e9e0"));
var _clsx = _interopRequireDefault(require("9bf8efedf13bf091"));
var _refType = _interopRequireDefault(require("d57f53f163f49b1a"));
var _composeClasses = _interopRequireDefault(require("3f66d53771ac5e11"));
var _RtlProvider = require("e5a967763cec448");
var _useSlotProps = _interopRequireDefault(require("ec6ee5268883b9c9"));
var _zeroStyled = require("5612a729715738fe");
var _memoTheme = _interopRequireDefault(require("ec7f47706f9280c4"));
var _DefaultPropsProvider = require("4181bf2e9fb6f26e");
var _debounce = _interopRequireDefault(require("56b161176b5ea8b1"));
var _animate = _interopRequireDefault(require("a2a498361bd78261"));
var _ScrollbarSize = _interopRequireDefault(require("389043e2ad344868"));
var _TabScrollButton = _interopRequireDefault(require("3d1e5a2dd8d855e5"));
var _useEventCallback = _interopRequireDefault(require("404ba74763323c1d"));
var _tabsClasses = _interopRequireWildcard(require("2991c68bb1f53d2"));
var _ownerDocument = _interopRequireDefault(require("1e0974e185aa88b4"));
var _ownerWindow = _interopRequireDefault(require("5c5c76f45f8cac11"));
var _useSlot = _interopRequireDefault(require("70fd24ef1775165a"));
var _jsxRuntime = require("86af32aadf102910");
const nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const useUtilityClasses = (ownerState)=>{
    const { vertical, fixed, hideScrollbar, scrollableX, scrollableY, centered, scrollButtonsHideMobile, classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, _composeClasses.default)(slots, _tabsClasses.getTabsUtilityClass, classes);
};
const TabsRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_tabsClasses.default.scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${_tabsClasses.default.scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${_tabsClasses.default.scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const TabsScroller = (0, _zeroStyled.styled)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const List = (0, _zeroStyled.styled)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const TabsIndicator = (0, _zeroStyled.styled)('span', {
    name: 'MuiTabs',
    slot: 'Indicator'
})((0, _memoTheme.default)(({ theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const TabsScrollbarSize = (0, _zeroStyled.styled)(_ScrollbarSize.default)({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const defaultIndicatorStyle = {};
let warnedOnceTabPresent = false;
const Tabs = /*#__PURE__*/ React.forwardRef(function Tabs(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, _zeroStyled.useTheme)();
    const isRtl = (0, _RtlProvider.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action, centered = false, children: childrenProp, className, component = 'div', allowScrollButtonsMobile = false, indicatorColor = 'primary', onChange, orientation = 'horizontal', ScrollButtonComponent, // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus, slots = {}, slotProps = {}, TabIndicatorProps = {}, // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value, variant = 'standard', visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component,
        allowScrollButtonsMobile,
        indicatorColor,
        orientation,
        vertical,
        scrollButtons,
        textColor,
        variant,
        visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, _useSlotProps.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState
    });
    const endScrollButtonIconProps = (0, _useSlotProps.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState
    });
    const [mounted, setMounted] = React.useState(false);
    const [indicatorStyle, setIndicatorStyle] = React.useState(defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = React.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = React.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = React.useState(false);
    const [scrollerStyle, setScrollerStyle] = React.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = React.useRef(null);
    const tabListRef = React.useRef(null);
    const externalForwardedProps = {
        slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButton: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta,
            tabMeta
        };
    };
    const updateIndicatorState = (0, _useEventCallback.default)(()=>{
        const { tabsMeta, tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation = true } = {})=>{
        if (animation) (0, _animate.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, _useSlot.default)('scrollbar', {
        className: (0, _clsx.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = React.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, _useSlot.default)('scrollButtons', {
        className: (0, _clsx.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: _TabScrollButton.default,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, _useEventCallback.default)((animation)=>{
        const { tabsMeta, tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation
            });
        }
    });
    const updateScrollButtonState = (0, _useEventCallback.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    React.useEffect(()=>{
        const handleResize = (0, _debounce.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, _ownerWindow.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ React.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    React.useEffect(()=>{
        setMounted(true);
    }, []);
    React.useEffect(()=>{
        updateIndicatorState();
    });
    React.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView(defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    React.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, _useSlot.default)('indicator', {
        className: (0, _clsx.default)(classes.indicator, TabIndicatorProps.className),
        elementType: TabsIndicator,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, _jsxRuntime.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = React.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ React.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected,
            selectionFollowsFocus,
            onChange,
            textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, _ownerDocument.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                moveFocus(list, currentFocus, previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                moveFocus(list, currentFocus, nextItem);
                break;
            case 'Home':
                event.preventDefault();
                moveFocus(list, null, nextItem);
                break;
            case 'End':
                event.preventDefault();
                moveFocus(list, null, previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        ref,
        className: (0, _clsx.default)(classes.root, className),
        elementType: TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component
        },
        ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, _useSlot.default)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: TabsScroller,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, _useSlot.default)('list', {
        ref: tabListRef,
        className: (0, _clsx.default)(classes.list, classes.flexContainer),
        elementType: List,
        externalForwardedProps,
        ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var _default = exports.default = Tabs;

},{"8bb8d651aff7a05c":"kZ6eK","e1c33d4bab21eee1":"fiRIh","958fde7868f5c3ca":"9njXz","40723a1e9a9bd300":"8oKlE","1a3a5fb3f6e3e9e0":"bnNSm","9bf8efedf13bf091":"d2NWs","d57f53f163f49b1a":"3TBXN","3f66d53771ac5e11":"59Equ","e5a967763cec448":"ck9Pb","ec6ee5268883b9c9":"kr4RG","5612a729715738fe":"89fxU","ec7f47706f9280c4":"2zy52","4181bf2e9fb6f26e":"ff3VX","56b161176b5ea8b1":"cvBWT","a2a498361bd78261":"7Sg0D","389043e2ad344868":"iW43j","3d1e5a2dd8d855e5":"kialp","404ba74763323c1d":"jTtn3","2991c68bb1f53d2":"W2KpW","1e0974e185aa88b4":"7Yspg","5c5c76f45f8cac11":"4Wjh2","70fd24ef1775165a":"29rI6","86af32aadf102910":"1dlk8"}],"7Sg0D":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = animate;
function easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function animate(property, element, to, options = {}, cb = ()=>{}) {
    const { ease = easeInOutSin, duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

},{}],"iW43j":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9d67e7481d50c21d").default;
var _interopRequireWildcard = require("4c06bf9353e1b90c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ScrollbarSize;
var React = _interopRequireWildcard(require("b16af2c966fe2de"));
var _propTypes = _interopRequireDefault(require("6f660f7ed404522d"));
var _debounce = _interopRequireDefault(require("905e772c3be1417"));
var _utils = require("b681604ff5ef59e2");
var _jsxRuntime = require("125ab5608fec4ae1");
const styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */ function ScrollbarSize(props) {
    const { onChange, ...other } = props;
    const scrollbarHeight = React.useRef();
    const nodeRef = React.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const handleResize = (0, _debounce.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, _utils.ownerWindow)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    React.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles,
        ...other,
        ref: nodeRef
    });
}

},{"9d67e7481d50c21d":"kZ6eK","4c06bf9353e1b90c":"fiRIh","b16af2c966fe2de":"9njXz","6f660f7ed404522d":"bnNSm","905e772c3be1417":"cvBWT","b681604ff5ef59e2":"60iOt","125ab5608fec4ae1":"1dlk8"}],"kialp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("161bbe45f2ea6657").default;
var _interopRequireDefault = require("a52d9ef7db5a50e5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tabScrollButtonClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TabScrollButton.default;
    }
});
Object.defineProperty(exports, "tabScrollButtonClasses", {
    enumerable: true,
    get: function() {
        return _tabScrollButtonClasses.default;
    }
});
var _TabScrollButton = _interopRequireDefault(require("ec69f4fbc38b2acb"));
var _tabScrollButtonClasses = _interopRequireWildcard(require("4d770cc9672b24ce"));
Object.keys(_tabScrollButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tabScrollButtonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tabScrollButtonClasses[key];
        }
    });
});

},{"161bbe45f2ea6657":"fiRIh","a52d9ef7db5a50e5":"kZ6eK","ec69f4fbc38b2acb":"2fZuG","4d770cc9672b24ce":"g9GGO"}],"2fZuG":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
/* eslint-disable jsx-a11y/aria-role */ var _interopRequireDefault = require("4ce09d37ceccda7c").default;
var _interopRequireWildcard = require("a99485c155597af1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("3ac5373133344353"));
var _propTypes = _interopRequireDefault(require("2a214b5ce43a7ee8"));
var _clsx = _interopRequireDefault(require("4b36e4daebb28487"));
var _composeClasses = _interopRequireDefault(require("72d13e51f2c99be"));
var _RtlProvider = require("78a25b4330e97d3d");
var _useSlotProps = _interopRequireDefault(require("cb4a03b0b2809326"));
var _KeyboardArrowLeft = _interopRequireDefault(require("f25fed0ec1558293"));
var _KeyboardArrowRight = _interopRequireDefault(require("3de0d4da996224cd"));
var _ButtonBase = _interopRequireDefault(require("18d75a5fc681c76f"));
var _zeroStyled = require("45db5aca542d770f");
var _DefaultPropsProvider = require("b1346d37e954416b");
var _tabScrollButtonClasses = _interopRequireWildcard(require("d591a58d073ad898"));
var _jsxRuntime = require("23f6e16c772a4682");
const useUtilityClasses = (ownerState)=>{
    const { classes, orientation, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, _composeClasses.default)(slots, _tabScrollButtonClasses.getTabScrollButtonUtilityClass, classes);
};
const TabScrollButtonRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${_tabScrollButtonClasses.default.disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const TabScrollButton = /*#__PURE__*/ React.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className, slots = {}, slotProps = {}, direction, orientation, disabled, ...other } = props;
    const isRtl = (0, _RtlProvider.useRtl)();
    const ownerState = {
        isRtl,
        ...props
    };
    const classes = useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? _KeyboardArrowLeft.default;
    const EndButtonIcon = slots.EndScrollButtonIcon ?? _KeyboardArrowRight.default;
    const startButtonIconProps = (0, _useSlotProps.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState
    });
    const endButtonIconProps = (0, _useSlotProps.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabScrollButtonRoot, {
        component: "div",
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var _default = exports.default = TabScrollButton;

},{"4ce09d37ceccda7c":"kZ6eK","a99485c155597af1":"fiRIh","3ac5373133344353":"9njXz","2a214b5ce43a7ee8":"bnNSm","4b36e4daebb28487":"d2NWs","72d13e51f2c99be":"59Equ","78a25b4330e97d3d":"ck9Pb","cb4a03b0b2809326":"kr4RG","f25fed0ec1558293":"g1fhR","3de0d4da996224cd":"5QNCT","18d75a5fc681c76f":"ajcyv","45db5aca542d770f":"89fxU","b1346d37e954416b":"ff3VX","d591a58d073ad898":"g9GGO","23f6e16c772a4682":"1dlk8"}],"g1fhR":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7794274b28267a33").default;
var _interopRequireWildcard = require("49a2c3f510732cf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("a290498f16dece77"));
var _createSvgIcon = _interopRequireDefault(require("c634a4ae51410b86"));
var _jsxRuntime = require("4ef103b5fce37f00");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

},{"7794274b28267a33":"kZ6eK","49a2c3f510732cf":"fiRIh","a290498f16dece77":"9njXz","c634a4ae51410b86":"k1uMV","4ef103b5fce37f00":"1dlk8"}],"5QNCT":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("316147d74e9a3bd4").default;
var _interopRequireWildcard = require("fe3f0cc89f3f4544").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("2608fcf007b2b786"));
var _createSvgIcon = _interopRequireDefault(require("8d38370efb128aca"));
var _jsxRuntime = require("b7eb36f63370128");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

},{"316147d74e9a3bd4":"kZ6eK","fe3f0cc89f3f4544":"fiRIh","2608fcf007b2b786":"9njXz","8d38370efb128aca":"k1uMV","b7eb36f63370128":"1dlk8"}],"g9GGO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("70c3dfef4b8fcc61").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTabScrollButtonUtilityClass = getTabScrollButtonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("c3b3cb3343031a57"));
var _generateUtilityClass = _interopRequireDefault(require("85a03e1afe52984a"));
function getTabScrollButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTabScrollButton', slot);
}
const tabScrollButtonClasses = (0, _generateUtilityClasses.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var _default = exports.default = tabScrollButtonClasses;

},{"70c3dfef4b8fcc61":"kZ6eK","c3b3cb3343031a57":"7pSUk","85a03e1afe52984a":"jBs9M"}],"W2KpW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2d51b16bfc9129d9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTabsUtilityClass = getTabsUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("8e22269940ccc63b"));
var _generateUtilityClass = _interopRequireDefault(require("6d83eeaad09c92f7"));
function getTabsUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTabs', slot);
}
const tabsClasses = (0, _generateUtilityClasses.default)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var _default = exports.default = tabsClasses;

},{"2d51b16bfc9129d9":"kZ6eK","8e22269940ccc63b":"7pSUk","6d83eeaad09c92f7":"jBs9M"}],"9WlZY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDateTimePickerTabsUtilityClass", ()=>getDateTimePickerTabsUtilityClass);
parcelHelpers.export(exports, "dateTimePickerTabsClasses", ()=>dateTimePickerTabsClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getDateTimePickerTabsUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDateTimePickerTabs', slot);
}
const dateTimePickerTabsClasses = (0, _generateUtilityClassesDefault.default)('MuiDateTimePickerTabs', [
    'root'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fUSiQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimePickerToolbarOverrideContext", ()=>DateTimePickerToolbarOverrideContext);
parcelHelpers.export(exports, "DateTimePickerToolbar", ()=>DateTimePickerToolbar);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _createStyled = require("@mui/system/createStyled");
var _pickersToolbarTextJs = require("../internals/components/PickersToolbarText.js");
var _pickersToolbarJs = require("../internals/components/PickersToolbar.js");
var _pickersToolbarButtonJs = require("../internals/components/PickersToolbarButton.js");
var _usePickerTranslationsJs = require("../hooks/usePickerTranslations.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _dateTimePickerToolbarClassesJs = require("./dateTimePickerToolbarClasses.js");
var _dateHelpersHooksJs = require("../internals/hooks/date-helpers-hooks.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
var _pickersToolbarTextClassesJs = require("../internals/components/pickersToolbarTextClasses.js");
var _pickersToolbarClassesJs = require("../internals/components/pickersToolbarClasses.js");
var _usePickerContextJs = require("../hooks/usePickerContext.js");
var _useToolbarOwnerStateJs = require("../internals/hooks/useToolbarOwnerState.js");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "ampm",
    "ampmInClock",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "className",
    "classes"
];
const useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation, toolbarDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        dateContainer: [
            'dateContainer'
        ],
        timeContainer: [
            'timeContainer',
            toolbarDirection === 'rtl' && 'timeLabelReverse'
        ],
        timeDigitsContainer: [
            'timeDigitsContainer',
            toolbarDirection === 'rtl' && 'timeLabelReverse'
        ],
        separator: [
            'separator'
        ],
        ampmSelection: [
            'ampmSelection',
            pickerOrientation === 'landscape' && 'ampmLandscape'
        ],
        ampmLabel: [
            'ampmLabel'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dateTimePickerToolbarClassesJs.getDateTimePickerToolbarUtilityClass), classes);
};
const DateTimePickerToolbarRoot = (0, _styles.styled)((0, _pickersToolbarJs.PickersToolbar), {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})(({ theme })=>({
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: 'space-around',
        position: 'relative',
        variants: [
            {
                props: {
                    toolbarVariant: 'desktop'
                },
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    [`& .${(0, _pickersToolbarClassesJs.pickersToolbarClasses).content} .${(0, _pickersToolbarTextClassesJs.pickersToolbarTextClasses).root}[data-selected]`]: {
                        color: (theme.vars || theme).palette.primary.main,
                        fontWeight: theme.typography.fontWeightBold
                    }
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    pickerOrientation: 'landscape'
                },
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    pickerOrientation: 'portrait'
                },
                style: {
                    paddingLeft: 24,
                    paddingRight: 0
                }
            }
        ]
    }));
const DateTimePickerToolbarDateContainer = (0, _styles.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'DateContainer'
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
});
const DateTimePickerToolbarTimeContainer = (0, _styles.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeContainer',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    display: 'flex',
    flexDirection: 'row',
    variants: [
        {
            props: {
                toolbarDirection: 'rtl'
            },
            style: {
                flexDirection: 'row-reverse'
            }
        },
        {
            props: {
                toolbarVariant: 'desktop',
                pickerOrientation: 'portrait'
            },
            style: {
                gap: 9,
                marginRight: 4,
                alignSelf: 'flex-end'
            }
        },
        {
            props: ({ pickerOrientation, toolbarVariant })=>pickerOrientation === 'landscape' && toolbarVariant !== 'desktop',
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ pickerOrientation, toolbarVariant, toolbarDirection })=>pickerOrientation === 'landscape' && toolbarVariant !== 'desktop' && toolbarDirection === 'rtl',
            style: {
                flexDirection: 'column-reverse'
            }
        }
    ]
});
const DateTimePickerToolbarTimeDigitsContainer = (0, _styles.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeDigitsContainer',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    display: 'flex',
    variants: [
        {
            props: {
                toolbarDirection: 'rtl'
            },
            style: {
                flexDirection: 'row-reverse'
            }
        },
        {
            props: {
                toolbarVariant: 'desktop'
            },
            style: {
                gap: 1.5
            }
        }
    ]
});
const DateTimePickerToolbarSeparator = (0, _styles.styled)((0, _pickersToolbarTextJs.PickersToolbarText), {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Separator',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    margin: '0 4px 0 2px',
    cursor: 'default',
    variants: [
        {
            props: {
                toolbarVariant: 'desktop'
            },
            style: {
                margin: 0
            }
        }
    ]
});
// Taken from TimePickerToolbar
const DateTimePickerToolbarAmPmSelection = (0, _styles.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'AmPmSelection',
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, _dateTimePickerToolbarClassesJs.dateTimePickerToolbarClasses).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, _dateTimePickerToolbarClassesJs.dateTimePickerToolbarClasses).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: 'flex',
    flexDirection: 'column',
    marginRight: 'auto',
    marginLeft: 12,
    [`& .${(0, _dateTimePickerToolbarClassesJs.dateTimePickerToolbarClasses).ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: '4px 0 auto',
                flexDirection: 'row',
                justifyContent: 'space-around',
                width: '100%'
            }
        }
    ]
});
const DateTimePickerToolbarOverrideContext = /*#__PURE__*/ _react.createContext(null);
function DateTimePickerToolbar(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimePickerToolbar'
    });
    const { ampm, ampmInClock, toolbarFormat, toolbarPlaceholder = "\u2013\u2013", toolbarTitle: inToolbarTitle, className, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { value: valueContext, setValue: setValueContext, disabled, readOnly, variant, orientation, view: viewContext, setView: setViewContext, views } = (0, _usePickerContextJs.usePickerContext)();
    const translations = (0, _usePickerTranslationsJs.usePickerTranslations)();
    const ownerState = (0, _useToolbarOwnerStateJs.useToolbarOwnerState)();
    const classes = useUtilityClasses(classesProp, ownerState);
    const utils = (0, _useUtilsJs.useUtils)();
    const overrides = _react.useContext(DateTimePickerToolbarOverrideContext);
    const value = overrides ? overrides.value : valueContext;
    const setValue = overrides ? overrides.setValue : setValueContext;
    const view = overrides ? overrides.view : viewContext;
    const setView = overrides ? overrides.setView : setViewContext;
    const { meridiemMode, handleMeridiemChange } = (0, _dateHelpersHooksJs.useMeridiemMode)(value, ampm, (newValue)=>setValue(newValue, {
            changeImportance: 'set'
        }));
    const toolbarVariant = overrides?.forceDesktopVariant ? 'desktop' : variant;
    const isDesktop = toolbarVariant === 'desktop';
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const toolbarTitle = inToolbarTitle ?? translations.dateTimePickerToolbarTitle;
    const dateText = _react.useMemo(()=>{
        if (!utils.isValid(value)) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(value, toolbarFormat);
        return utils.format(value, 'shortDate');
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils
    ]);
    const formatSection = (format, fallback)=>{
        if (!utils.isValid(value)) return fallback;
        return utils.format(value, format);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DateTimePickerToolbarRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        toolbarTitle: toolbarTitle,
        toolbarVariant: toolbarVariant
    }, other, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DateTimePickerToolbarDateContainer, {
                className: classes.dateContainer,
                ownerState: ownerState,
                children: [
                    views.includes('year') && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersToolbarButtonJs.PickersToolbarButton), {
                        tabIndex: -1,
                        variant: "subtitle1",
                        onClick: ()=>setView('year'),
                        selected: view === 'year',
                        value: formatSection('year', "\u2013")
                    }),
                    views.includes('day') && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersToolbarButtonJs.PickersToolbarButton), {
                        tabIndex: -1,
                        variant: isDesktop ? 'h5' : 'h4',
                        onClick: ()=>setView('day'),
                        selected: view === 'day',
                        value: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DateTimePickerToolbarTimeContainer, {
                className: classes.timeContainer,
                ownerState: ownerState,
                toolbarVariant: toolbarVariant,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DateTimePickerToolbarTimeDigitsContainer, {
                        className: classes.timeDigitsContainer,
                        ownerState: ownerState,
                        toolbarVariant: toolbarVariant,
                        children: [
                            views.includes('hours') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersToolbarButtonJs.PickersToolbarButton), {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? (0, _dimensionsJs.MULTI_SECTION_CLOCK_SECTION_WIDTH) : undefined,
                                        onClick: ()=>setView('hours'),
                                        selected: view === 'hours',
                                        value: formatSection(ampm ? 'hours12h' : 'hours24h', '--')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState,
                                        toolbarVariant: toolbarVariant
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersToolbarButtonJs.PickersToolbarButton), {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? (0, _dimensionsJs.MULTI_SECTION_CLOCK_SECTION_WIDTH) : undefined,
                                        onClick: ()=>setView('minutes'),
                                        selected: view === 'minutes' || !views.includes('minutes') && view === 'hours',
                                        value: formatSection('minutes', '--'),
                                        disabled: !views.includes('minutes')
                                    })
                                ]
                            }),
                            views.includes('seconds') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState,
                                        toolbarVariant: toolbarVariant
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersToolbarButtonJs.PickersToolbarButton), {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? (0, _dimensionsJs.MULTI_SECTION_CLOCK_SECTION_WIDTH) : undefined,
                                        onClick: ()=>setView('seconds'),
                                        selected: view === 'seconds',
                                        value: formatSection('seconds', '--')
                                    })
                                ]
                            })
                        ]
                    }),
                    showAmPmControl && !isDesktop && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DateTimePickerToolbarAmPmSelection, {
                        className: classes.ampmSelection,
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersToolbarButtonJs.PickersToolbarButton), {
                                variant: "subtitle2",
                                selected: meridiemMode === 'am',
                                typographyClassName: classes.ampmLabel,
                                value: (0, _dateUtilsJs.formatMeridiem)(utils, 'am'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersToolbarButtonJs.PickersToolbarButton), {
                                variant: "subtitle2",
                                selected: meridiemMode === 'pm',
                                typographyClassName: classes.ampmLabel,
                                value: (0, _dateUtilsJs.formatMeridiem)(utils, 'pm'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                                disabled: disabled
                            })
                        ]
                    }),
                    ampm && isDesktop && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersToolbarButtonJs.PickersToolbarButton), {
                        variant: "h5",
                        onClick: ()=>setView('meridiem'),
                        selected: view === 'meridiem',
                        value: value && meridiemMode ? (0, _dateUtilsJs.formatMeridiem)(utils, meridiemMode) : '--',
                        width: (0, _dimensionsJs.MULTI_SECTION_CLOCK_SECTION_WIDTH)
                    })
                ]
            })
        ]
    }));
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","prop-types":"bnNSm","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","@mui/system/createStyled":"6ySdS","../internals/components/PickersToolbarText.js":"baw8g","../internals/components/PickersToolbar.js":"j4xaV","../internals/components/PickersToolbarButton.js":"hiLjt","../hooks/usePickerTranslations.js":"3Zb4l","../internals/hooks/useUtils.js":"dJQ8a","./dateTimePickerToolbarClasses.js":"1N3eB","../internals/hooks/date-helpers-hooks.js":"ifoSw","../internals/constants/dimensions.js":"i0BgX","../internals/utils/date-utils.js":"jrk9G","../internals/components/pickersToolbarTextClasses.js":"10Juy","../internals/components/pickersToolbarClasses.js":"cfogx","../hooks/usePickerContext.js":"hyseP","../internals/hooks/useToolbarOwnerState.js":"5ZzMj","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"baw8g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersToolbarText", ()=>PickersToolbarText);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _pickersToolbarTextClassesJs = require("./pickersToolbarTextClasses.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "classes",
    "selected",
    "value"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersToolbarTextClassesJs.getPickersToolbarTextUtilityClass), classes);
};
const PickersToolbarTextRoot = (0, _styles.styled)((0, _typographyDefault.default), {
    name: 'MuiPickersToolbarText',
    slot: 'Root'
})(({ theme })=>({
        transition: theme.transitions.create('color'),
        color: (theme.vars || theme).palette.text.secondary,
        [`&[data-selected]`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const PickersToolbarText = /*#__PURE__*/ _react.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbarText'
    });
    const { className, classes: classesProp, selected, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersToolbarTextRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        component: "span",
        ownerState: props
    }, selected && {
        'data-selected': true
    }, other, {
        children: value
    }));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","@mui/material/Typography":"2wCD5","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","./pickersToolbarTextClasses.js":"10Juy","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"10Juy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersToolbarTextUtilityClass", ()=>getPickersToolbarTextUtilityClass);
parcelHelpers.export(exports, "pickersToolbarTextClasses", ()=>pickersToolbarTextClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getPickersToolbarTextUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPickersToolbarText', slot);
}
const pickersToolbarTextClasses = (0, _generateUtilityClassesDefault.default)('MuiPickersToolbarText', [
    'root'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hiLjt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersToolbarButton", ()=>PickersToolbarButton);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _styles = require("@mui/material/styles");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _pickersToolbarTextJs = require("./PickersToolbarText.js");
var _pickersToolbarClassesJs = require("./pickersToolbarClasses.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "align",
    "className",
    "classes",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _pickersToolbarClassesJs.getPickersToolbarUtilityClass), classes);
};
const PickersToolbarButtonRoot = (0, _styles.styled)((0, _buttonDefault.default), {
    name: 'MuiPickersToolbarButton',
    slot: 'Root'
})({
    padding: 0,
    minWidth: 16,
    textTransform: 'none'
});
const PickersToolbarButton = /*#__PURE__*/ _react.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbarButton'
    });
    const { align, className, classes: classesProp, selected, typographyClassName, value, variant, width } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersToolbarButtonRoot, (0, _extendsDefault.default)({
        variant: "text",
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: props
    }, width ? {
        sx: {
            width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersToolbarTextJs.PickersToolbarText), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"d2NWs","@mui/material/Button":"c6Y0y","@mui/material/styles":"c9RfU","@mui/utils/composeClasses":"59Equ","./PickersToolbarText.js":"baw8g","./pickersToolbarClasses.js":"cfogx","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1N3eB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDateTimePickerToolbarUtilityClass", ()=>getDateTimePickerToolbarUtilityClass);
parcelHelpers.export(exports, "dateTimePickerToolbarClasses", ()=>dateTimePickerToolbarClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
function getDateTimePickerToolbarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDateTimePickerToolbar', slot);
}
const dateTimePickerToolbarClasses = (0, _generateUtilityClassesDefault.default)('MuiDateTimePickerToolbar', [
    'root',
    'dateContainer',
    'timeContainer',
    'timeDigitsContainer',
    'separator',
    'timeLabelReverse',
    'ampmSelection',
    'ampmLandscape',
    'ampmLabel'
]);

},{"@mui/utils/generateUtilityClass":"jBs9M","@mui/utils/generateUtilityClasses":"7pSUk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2q1gF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveDateTimeFormat", ()=>resolveDateTimeFormat);
parcelHelpers.export(exports, "resolveTimeViewsResponse", ()=>resolveTimeViewsResponse);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _timeUtilsJs = require("./time-utils.js");
var _dateUtilsJs = require("./date-utils.js");
const _excluded = [
    "views",
    "format"
];
const resolveDateTimeFormat = (utils, _ref, ignoreDateResolving)=>{
    let { views, format } = _ref, other = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, _timeUtilsJs.isTimeView)(view)) timeViews.push(view);
        else if ((0, _dateUtilsJs.isDatePickerView)(view)) dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, _dateUtilsJs.resolveDateFormat)(utils, (0, _extendsDefault.default)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, _timeUtilsJs.resolveTimeFormat)(utils, (0, _extendsDefault.default)({
        views: timeViews
    }, other));
    const timeFormat = (0, _timeUtilsJs.resolveTimeFormat)(utils, (0, _extendsDefault.default)({
        views: timeViews
    }, other));
    const dateFormat = ignoreDateResolving ? utils.formats.keyboardDate : (0, _dateUtilsJs.resolveDateFormat)(utils, (0, _extendsDefault.default)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
const resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!(0, _timeUtilsJs.isInternalTimeView)(view) || view === 'hours');
    return ampm ? [
        ...views,
        'meridiem'
    ] : views;
};
const resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>1440 / ((timeSteps.hours ?? 1) * (timeSteps.minutes ?? 5)) <= threshold;
function resolveTimeViewsResponse({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm, timeSteps: inTimeSteps, views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold ?? 24;
    const timeSteps = (0, _extendsDefault.default)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn,
        timeSteps,
        shouldRenderTimeInASingleColumn,
        views: resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","./time-utils.js":"7FMia","./date-utils.js":"jrk9G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lWq1R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderTimeViewClock", ()=>(0, _timeViewRenderersJs.renderTimeViewClock));
parcelHelpers.export(exports, "renderDigitalClockTimeView", ()=>(0, _timeViewRenderersJs.renderDigitalClockTimeView));
parcelHelpers.export(exports, "renderMultiSectionDigitalClockTimeView", ()=>(0, _timeViewRenderersJs.renderMultiSectionDigitalClockTimeView));
var _timeViewRenderersJs = require("./timeViewRenderers.js");

},{"./timeViewRenderers.js":"bXaHd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bXaHd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderTimeViewClock", ()=>renderTimeViewClock);
parcelHelpers.export(exports, "renderDigitalClockTimeView", ()=>renderDigitalClockTimeView);
parcelHelpers.export(exports, "renderMultiSectionDigitalClockTimeView", ()=>renderMultiSectionDigitalClockTimeView);
var _react = require("react");
var _indexJs = require("../TimeClock/index.js");
var _indexJs1 = require("../DigitalClock/index.js");
var _indexJs2 = require("../MultiSectionDigitalClock/index.js");
var _timeUtilsJs = require("../internals/utils/time-utils.js");
var _jsxRuntime = require("react/jsx-runtime");
const renderTimeViewClock = ({ view, onViewChange, focusedView, onFocusedViewChange, views, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minTime, maxTime, shouldDisableTime, minutesStep, ampm, ampmInClock, slots, slotProps, readOnly, disabled, sx, autoFocus, showViewSwitcher, disableIgnoringDatePartForTimeValidation, timezone })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.TimeClock), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, _timeUtilsJs.isTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, _timeUtilsJs.isTimeView)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const renderDigitalClockTimeView = ({ view, onViewChange, focusedView, onFocusedViewChange, views, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minTime, maxTime, shouldDisableTime, minutesStep, ampm, slots, slotProps, readOnly, disabled, sx, autoFocus, disableIgnoringDatePartForTimeValidation, timeSteps, skipDisabled, timezone })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs1.DigitalClock), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, _timeUtilsJs.isTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, _timeUtilsJs.isTimeView)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps?.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const renderMultiSectionDigitalClockTimeView = ({ view, onViewChange, focusedView, onFocusedViewChange, views, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minTime, maxTime, shouldDisableTime, minutesStep, ampm, slots, slotProps, readOnly, disabled, sx, autoFocus, disableIgnoringDatePartForTimeValidation, timeSteps, skipDisabled, timezone })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs2.MultiSectionDigitalClock), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, _timeUtilsJs.isInternalTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, _timeUtilsJs.isTimeView)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });

},{"react":"9njXz","../TimeClock/index.js":"ljZfh","../DigitalClock/index.js":"aDNgV","../MultiSectionDigitalClock/index.js":"6BKf0","../internals/utils/time-utils.js":"7FMia","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"esKHK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesktopDateTimePickerLayout", ()=>DesktopDateTimePickerLayout);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _indexJs = require("../PickersLayout/index.js");
var _usePickerContextJs = require("../hooks/usePickerContext.js");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * @ignore - internal component.
 */ const DesktopDateTimePickerLayout = /*#__PURE__*/ _react.forwardRef(function DesktopDateTimePickerLayout(props, ref) {
    const { toolbar, tabs, content, actionBar, shortcuts, ownerState } = (0, _indexJs.usePickerLayout)(props);
    const { orientation } = (0, _usePickerContextJs.usePickerContext)();
    const { sx, className, classes } = props;
    const isActionBarVisible = actionBar && (actionBar.props.actions?.length ?? 0) > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _indexJs.PickersLayoutRoot), {
        ref: ref,
        className: (0, _clsxDefault.default)((0, _indexJs.pickersLayoutClasses).root, classes?.root, className),
        sx: [
            {
                [`& .${(0, _indexJs.pickersLayoutClasses).tabs}`]: {
                    gridRow: 4,
                    gridColumn: '1 / 4'
                },
                [`& .${(0, _indexJs.pickersLayoutClasses).actionBar}`]: {
                    gridRow: 5
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        ownerState: ownerState,
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _indexJs.PickersLayoutContentWrapper), {
                className: (0, _clsxDefault.default)((0, _indexJs.pickersLayoutClasses).contentWrapper, classes?.contentWrapper),
                ownerState: ownerState,
                sx: {
                    display: 'grid'
                },
                children: [
                    content,
                    tabs,
                    isActionBarVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                        sx: {
                            gridRow: 3,
                            gridColumn: '1 / 4'
                        }
                    })
                ]
            }),
            actionBar
        ]
    });
});

},{"react":"9njXz","prop-types":"bnNSm","clsx":"d2NWs","@mui/material/Divider":"5Ykub","../PickersLayout/index.js":"9qQLb","../hooks/usePickerContext.js":"hyseP","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kUDlR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileDateTimePicker", ()=>(0, _mobileDateTimePickerJs.MobileDateTimePicker));
var _mobileDateTimePickerJs = require("./MobileDateTimePicker.js");

},{"./MobileDateTimePicker.js":"glXY7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"glXY7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileDateTimePicker", ()=>MobileDateTimePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _resolveComponentProps = require("@mui/utils/resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _valueManagersJs = require("../internals/utils/valueManagers.js");
var _indexJs = require("../DateTimeField/index.js");
var _sharedJs = require("../DateTimePicker/shared.js");
var _useUtilsJs = require("../internals/hooks/useUtils.js");
var _indexJs1 = require("../validation/index.js");
var _indexJs2 = require("../internals/hooks/useMobilePicker/index.js");
var _indexJs3 = require("../dateViewRenderers/index.js");
var _indexJs4 = require("../timeViewRenderers/index.js");
var _dateTimeUtilsJs = require("../internals/utils/date-time-utils.js");
var _dimensionsJs = require("../internals/constants/dimensions.js");
var _indexJs5 = require("../MultiSectionDigitalClock/index.js");
var _utilsJs = require("../internals/utils/utils.js");
var _indexJs6 = require("../DigitalClock/index.js");
var _timeUtilsJs = require("../internals/utils/time-utils.js");
var _dateUtilsJs = require("../internals/utils/date-utils.js");
'use client';
const STEPS = [
    {
        views: (0, _dateUtilsJs.DATE_VIEWS)
    },
    {
        views: (0, _timeUtilsJs.EXPORTED_TIME_VIEWS)
    }
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDateTimePicker API](https://mui.com/x/api/date-pickers/mobile-date-time-picker/)
 */ const MobileDateTimePicker = /*#__PURE__*/ _react.forwardRef(function MobileDateTimePicker(inProps, ref) {
    const utils = (0, _useUtilsJs.useUtils)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, _sharedJs.useDateTimePickerDefaultizedProps)(inProps, 'MuiMobileDateTimePicker');
    const renderTimeView = defaultizedProps.shouldRenderTimeInASingleColumn ? (0, _indexJs4.renderDigitalClockTimeView) : (0, _indexJs4.renderMultiSectionDigitalClockTimeView);
    const viewRenderers = (0, _extendsDefault.default)({
        day: (0, _indexJs3.renderDateViewCalendar),
        month: (0, _indexJs3.renderDateViewCalendar),
        year: (0, _indexJs3.renderDateViewCalendar),
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === (0, _indexJs4.renderMultiSectionDigitalClockTimeView).name;
    const views = !shouldHoursRendererContainMeridiemView ? defaultizedProps.views.filter((view)=>view !== 'meridiem') : defaultizedProps.views;
    // Props with the default values specific to the mobile variant
    const props = (0, _extendsDefault.default)({}, defaultizedProps, {
        viewRenderers,
        format: (0, _dateTimeUtilsJs.resolveDateTimeFormat)(utils, defaultizedProps),
        views,
        ampmInClock,
        slots: (0, _extendsDefault.default)({
            field: (0, _indexJs.DateTimeField)
        }, defaultizedProps.slots),
        slotProps: (0, _extendsDefault.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, _extendsDefault.default)({}, (0, _resolveComponentPropsDefault.default)(defaultizedProps.slotProps?.field, ownerState), (0, _indexJs1.extractValidationProps)(defaultizedProps)),
            toolbar: (0, _extendsDefault.default)({
                hidden: false,
                ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, _extendsDefault.default)({
                hidden: false
            }, defaultizedProps.slotProps?.tabs),
            layout: (0, _extendsDefault.default)({}, defaultizedProps.slotProps?.layout, {
                sx: (0, _utilsJs.mergeSx)([
                    {
                        [`& .${(0, _indexJs5.multiSectionDigitalClockClasses).root}`]: {
                            width: (0, _dimensionsJs.DIALOG_WIDTH)
                        },
                        [`& .${(0, _indexJs5.multiSectionDigitalClockSectionClasses).root}`]: {
                            flex: 1,
                            // account for the border on `MultiSectionDigitalClock`
                            maxHeight: (0, _dimensionsJs.VIEW_HEIGHT) - 1,
                            [`.${(0, _indexJs5.multiSectionDigitalClockSectionClasses).item}`]: {
                                width: 'auto'
                            }
                        },
                        [`& .${(0, _indexJs6.digitalClockClasses).root}`]: {
                            width: (0, _dimensionsJs.DIALOG_WIDTH),
                            maxHeight: (0, _dimensionsJs.VIEW_HEIGHT),
                            flex: 1,
                            [`.${(0, _indexJs6.digitalClockClasses).item}`]: {
                                justifyContent: 'center'
                            }
                        }
                    }
                ], defaultizedProps.slotProps?.layout?.sx)
            })
        })
    });
    const { renderPicker } = (0, _indexJs2.useMobilePicker)({
        ref,
        props,
        valueManager: (0, _valueManagersJs.singleItemValueManager),
        valueType: 'date-time',
        validator: (0, _indexJs1.validateDateTime),
        steps: STEPS
    });
    return renderPicker();
});
MobileDateTimePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, _propTypesDefault.default).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: (0, _propTypesDefault.default).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, _propTypesDefault.default).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, _propTypesDefault.default).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, _propTypesDefault.default).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, _propTypesDefault.default).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, _propTypesDefault.default).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, _propTypesDefault.default).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, _propTypesDefault.default).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, _propTypesDefault.default).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, _refTypeDefault.default),
    /**
   * The label content.
   */ label: (0, _propTypesDefault.default).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, _propTypesDefault.default).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, _propTypesDefault.default).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, _propTypesDefault.default).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, _propTypesDefault.default).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, _propTypesDefault.default).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, _propTypesDefault.default).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, _propTypesDefault.default).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, _propTypesDefault.default).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, _propTypesDefault.default).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, _propTypesDefault.default).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, _propTypesDefault.default).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, _propTypesDefault.default).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, _propTypesDefault.default).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, _propTypesDefault.default).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, _propTypesDefault.default).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, _propTypesDefault.default).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, _propTypesDefault.default).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, _propTypesDefault.default).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, _propTypesDefault.default).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, _propTypesDefault.default).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, _propTypesDefault.default).func,
    /**
   * Disable specific time.
   * @param {PickerValidDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, _propTypesDefault.default).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, _propTypesDefault.default).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, _propTypesDefault.default).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, _propTypesDefault.default).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, _propTypesDefault.default).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).bool
        ])),
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, _propTypesDefault.default).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, _propTypesDefault.default).shape({
        hours: (0, _propTypesDefault.default).number,
        minutes: (0, _propTypesDefault.default).number,
        seconds: (0, _propTypesDefault.default).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, _propTypesDefault.default).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, _propTypesDefault.default).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, _propTypesDefault.default).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, _propTypesDefault.default).shape({
        day: (0, _propTypesDefault.default).func,
        hours: (0, _propTypesDefault.default).func,
        meridiem: (0, _propTypesDefault.default).func,
        minutes: (0, _propTypesDefault.default).func,
        month: (0, _propTypesDefault.default).func,
        seconds: (0, _propTypesDefault.default).func,
        year: (0, _propTypesDefault.default).func
    }),
    /**
   * Available views.
   */ views: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, _propTypesDefault.default).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, _propTypesDefault.default).oneOf([
        3,
        4
    ])
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/utils/resolveComponentProps":"gGfhx","@mui/utils/refType":"3TBXN","../internals/utils/valueManagers.js":"bimTj","../DateTimeField/index.js":"jI1xE","../DateTimePicker/shared.js":"cte17","../internals/hooks/useUtils.js":"dJQ8a","../validation/index.js":"973pf","../internals/hooks/useMobilePicker/index.js":"5OIPf","../dateViewRenderers/index.js":"4liGN","../timeViewRenderers/index.js":"lWq1R","../internals/utils/date-time-utils.js":"2q1gF","../internals/constants/dimensions.js":"i0BgX","../MultiSectionDigitalClock/index.js":"6BKf0","../internals/utils/utils.js":"k4iiH","../DigitalClock/index.js":"aDNgV","../internals/utils/time-utils.js":"7FMia","../internals/utils/date-utils.js":"jrk9G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ivEEo":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("2fd6242b20ec4c67").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("338a968334381571"));
var _jsxRuntime = require("19ac748d8b34c381");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');

},{"2fd6242b20ec4c67":"kZ6eK","338a968334381571":"2vOnF","19ac748d8b34c381":"1dlk8"}],"jg2jw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultHighlightDefault.default));
parcelHelpers.export(exports, "LightAsync", ()=>(0, _lightAsyncDefault.default));
parcelHelpers.export(exports, "Light", ()=>(0, _lightDefault.default));
parcelHelpers.export(exports, "PrismAsyncLight", ()=>(0, _prismAsyncLightDefault.default));
parcelHelpers.export(exports, "PrismAsync", ()=>(0, _prismAsyncDefault.default));
parcelHelpers.export(exports, "PrismLight", ()=>(0, _prismLightDefault.default));
parcelHelpers.export(exports, "Prism", ()=>(0, _prismDefault.default));
parcelHelpers.export(exports, "createElement", ()=>(0, _createElementDefault.default));
var _defaultHighlight = require("./default-highlight");
var _defaultHighlightDefault = parcelHelpers.interopDefault(_defaultHighlight);
var _lightAsync = require("./light-async");
var _lightAsyncDefault = parcelHelpers.interopDefault(_lightAsync);
var _light = require("./light");
var _lightDefault = parcelHelpers.interopDefault(_light);
var _prismAsyncLight = require("./prism-async-light");
var _prismAsyncLightDefault = parcelHelpers.interopDefault(_prismAsyncLight);
var _prismAsync = require("./prism-async");
var _prismAsyncDefault = parcelHelpers.interopDefault(_prismAsync);
var _prismLight = require("./prism-light");
var _prismLightDefault = parcelHelpers.interopDefault(_prismLight);
var _prism = require("./prism");
var _prismDefault = parcelHelpers.interopDefault(_prism);
var _createElement = require("./create-element");
var _createElementDefault = parcelHelpers.interopDefault(_createElement);

},{"./default-highlight":false,"./light-async":false,"./light":false,"./prism-async-light":false,"./prism-async":false,"./prism-light":false,"./prism":"01TKv","./create-element":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01TKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _highlight = require("./highlight");
var _highlightDefault = parcelHelpers.interopDefault(_highlight);
var _prism = require("./styles/prism/prism");
var _prismDefault = parcelHelpers.interopDefault(_prism);
var _refractor = require("refractor");
var _refractorDefault = parcelHelpers.interopDefault(_refractor);
var _supportedLanguages = require("./languages/prism/supported-languages");
var _supportedLanguagesDefault = parcelHelpers.interopDefault(_supportedLanguages);
var highlighter = (0, _highlightDefault.default)((0, _refractorDefault.default), (0, _prismDefault.default));
highlighter.supportedLanguages = (0, _supportedLanguagesDefault.default);
exports.default = highlighter;

},{"./highlight":"7y7vd","./styles/prism/prism":"dkNym","refractor":"bqv8I","./languages/prism/supported-languages":"iW0ht","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7y7vd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(defaultAstGenerator, defaultStyle) {
        return function SyntaxHighlighter(_ref7) {
            var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
                className: language ? "language-".concat(language) : undefined,
                style: _objectSpread(_objectSpread({}, style['code[class*="language-"]']), style["code[class*=\"language-".concat(language, "\"]")])
            } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? 'pre' : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? 'code' : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || '' : _ref7$code, astGenerator = _ref7.astGenerator, rest = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded);
            astGenerator = astGenerator || defaultAstGenerator;
            var allLineNumbers = showLineNumbers ? /*#__PURE__*/ (0, _reactDefault.default).createElement(AllLineNumbers, {
                containerStyle: lineNumberContainerStyle,
                codeStyle: codeTagProps.style || {},
                numberStyle: lineNumberStyle,
                startingLineNumber: startingLineNumber,
                codeString: code
            }) : null;
            var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
                backgroundColor: '#fff'
            };
            var generatorClassName = isHighlightJs(astGenerator) ? 'hljs' : 'prismjs';
            var preProps = useInlineStyles ? Object.assign({}, rest, {
                style: Object.assign({}, defaultPreStyle, customStyle)
            }) : Object.assign({}, rest, {
                className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
                style: Object.assign({}, customStyle)
            });
            if (wrapLongLines) codeTagProps.style = _objectSpread(_objectSpread({}, codeTagProps.style), {}, {
                whiteSpace: 'pre-wrap'
            });
            else codeTagProps.style = _objectSpread(_objectSpread({}, codeTagProps.style), {}, {
                whiteSpace: 'pre'
            });
            if (!astGenerator) return /*#__PURE__*/ (0, _reactDefault.default).createElement(PreTag, preProps, allLineNumbers, /*#__PURE__*/ (0, _reactDefault.default).createElement(CodeTag, codeTagProps, code));
            /*
     * Some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined.
     */ if (wrapLines === undefined && renderer || wrapLongLines) wrapLines = true;
            renderer = renderer || defaultRenderer;
            var defaultCodeValue = [
                {
                    type: 'text',
                    value: code
                }
            ];
            var codeTree = getCodeTree({
                astGenerator: astGenerator,
                language: language,
                code: code,
                defaultCodeValue: defaultCodeValue
            });
            if (codeTree.language === null) codeTree.value = defaultCodeValue;
             // determine largest line number so that we can force minWidth on all linenumber elements
            var largestLineNumber = codeTree.value.length + startingLineNumber;
            var rows = processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(PreTag, preProps, /*#__PURE__*/ (0, _reactDefault.default).createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
                rows: rows,
                stylesheet: style,
                useInlineStyles: useInlineStyles
            })));
        };
    });
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _createElement = require("./create-element");
var _createElementDefault = parcelHelpers.interopDefault(_createElement);
var _checkForListedLanguage = require("./checkForListedLanguage");
var _checkForListedLanguageDefault = parcelHelpers.interopDefault(_checkForListedLanguage);
var _excluded = [
    "language",
    "children",
    "style",
    "customStyle",
    "codeTagProps",
    "useInlineStyles",
    "showLineNumbers",
    "showInlineLineNumbers",
    "startingLineNumber",
    "lineNumberContainerStyle",
    "lineNumberStyle",
    "wrapLines",
    "wrapLongLines",
    "lineProps",
    "renderer",
    "PreTag",
    "CodeTag",
    "code",
    "astGenerator"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var newLineRegex = /\n/g;
function getNewLines(str) {
    return str.match(newLineRegex);
}
function getAllLineNumbers(_ref) {
    var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
    return lines.map(function(_, i) {
        var number = i + startingLineNumber;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            key: "line-".concat(i),
            className: "react-syntax-highlighter-line-number",
            style: typeof style === 'function' ? style(number) : style
        }, "".concat(number, "\n"));
    });
}
function AllLineNumbers(_ref2) {
    var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
        "float": 'left',
        paddingRight: '10px'
    } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("code", {
        style: Object.assign({}, codeStyle, containerStyle)
    }, getAllLineNumbers({
        lines: codeString.replace(/\n$/, '').split('\n'),
        style: numberStyle,
        startingLineNumber: startingLineNumber
    }));
}
function getEmWidthOfNumber(num) {
    return "".concat(num.toString().length, ".25em");
}
function getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: "line-number--".concat(lineNumber),
            className: [
                'comment',
                'linenumber',
                'react-syntax-highlighter-line-number'
            ],
            style: inlineLineNumberStyle
        },
        children: [
            {
                type: 'text',
                value: lineNumber
            }
        ]
    };
}
function assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
    // minimally necessary styling for line numbers
    var defaultLineNumberStyle = {
        display: 'inline-block',
        minWidth: getEmWidthOfNumber(largestLineNumber),
        paddingRight: '1em',
        textAlign: 'right',
        userSelect: 'none'
    }; // prep custom styling
    var customLineNumberStyle = typeof lineNumberStyle === 'function' ? lineNumberStyle(lineNumber) : lineNumberStyle; // combine
    var assembledStyle = _objectSpread(_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
    return assembledStyle;
}
function createLineElement(_ref3) {
    var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines;
    var properties = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    properties['className'] = className;
    if (lineNumber && showInlineLineNumbers) {
        var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
        children.unshift(getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    if (wrapLongLines & showLineNumbers) properties.style = _objectSpread(_objectSpread({}, properties.style), {}, {
        display: 'flex'
    });
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: children
    };
}
function flattenCodeTree(tree) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    for(var i = 0; i < tree.length; i++){
        var node = tree[i];
        if (node.type === 'text') newTree.push(createLineElement({
            children: [
                node
            ],
            className: (0, _toConsumableArrayDefault.default)(new Set(className))
        }));
        else if (node.children) {
            var classNames = className.concat(node.properties.className);
            flattenCodeTree(node.children, classNames).forEach(function(i) {
                return newTree.push(i);
            });
        }
    }
    return newTree;
}
function processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
    var _ref4;
    var tree = flattenCodeTree(codeTree.value);
    var newTree = [];
    var lastLineBreakIndex = -1;
    var index = 0;
    function createWrappedLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return createLineElement({
            children: children,
            lineNumber: lineNumber,
            lineNumberStyle: lineNumberStyle,
            largestLineNumber: largestLineNumber,
            showInlineLineNumbers: showInlineLineNumbers,
            lineProps: lineProps,
            className: className,
            showLineNumbers: showLineNumbers,
            wrapLongLines: wrapLongLines
        });
    }
    function createUnwrappedLine(children, lineNumber) {
        if (showLineNumbers && lineNumber && showInlineLineNumbers) {
            var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
            children.unshift(getInlineLineNumber(lineNumber, inlineLineNumberStyle));
        }
        return children;
    }
    function createLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return wrapLines || className.length > 0 ? createWrappedLine(children, lineNumber, className) : createUnwrappedLine(children, lineNumber);
    }
    var _loop = function _loop() {
        var node = tree[index];
        var value = node.children[0].value;
        var newLines = getNewLines(value);
        if (newLines) {
            var splitValue = value.split('\n');
            splitValue.forEach(function(text, i) {
                var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
                var newChild = {
                    type: 'text',
                    value: "".concat(text, "\n")
                }; // if it's the first line
                if (i === 0) {
                    var _children = tree.slice(lastLineBreakIndex + 1, index).concat(createLineElement({
                        children: [
                            newChild
                        ],
                        className: node.properties.className
                    }));
                    var _line = createLine(_children, lineNumber);
                    newTree.push(_line); // if it's the last line
                } else if (i === splitValue.length - 1) {
                    var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
                    var lastLineInPreviousSpan = {
                        type: 'text',
                        value: "".concat(text)
                    };
                    if (stringChild) {
                        var newElem = createLineElement({
                            children: [
                                lastLineInPreviousSpan
                            ],
                            className: node.properties.className
                        });
                        tree.splice(index + 1, 0, newElem);
                    } else {
                        var _children2 = [
                            lastLineInPreviousSpan
                        ];
                        var _line2 = createLine(_children2, lineNumber, node.properties.className);
                        newTree.push(_line2);
                    } // if it's neither the first nor the last line
                } else {
                    var _children3 = [
                        newChild
                    ];
                    var _line3 = createLine(_children3, lineNumber, node.properties.className);
                    newTree.push(_line3);
                }
            });
            lastLineBreakIndex = index;
        }
        index++;
    };
    while(index < tree.length)_loop();
    if (lastLineBreakIndex !== tree.length - 1) {
        var children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
            var line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function defaultRenderer(_ref5) {
    var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
    return rows.map(function(node, i) {
        return (0, _createElementDefault.default)({
            node: node,
            stylesheet: stylesheet,
            useInlineStyles: useInlineStyles,
            key: "code-segement".concat(i)
        });
    });
} // only highlight.js has the highlightAuto method
function isHighlightJs(astGenerator) {
    return astGenerator && typeof astGenerator.highlightAuto !== 'undefined';
}
function getCodeTree(_ref6) {
    var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
    // figure out whether we're using lowlight/highlight or refractor/prism
    // then attempt highlighting accordingly
    // lowlight/highlight?
    if (isHighlightJs(astGenerator)) {
        var hasLanguage = (0, _checkForListedLanguageDefault.default)(astGenerator, language);
        if (language === 'text') return {
            value: defaultCodeValue,
            language: 'text'
        };
        else if (hasLanguage) return astGenerator.highlight(language, code);
        else return astGenerator.highlightAuto(code);
    } // must be refractor/prism, then
    try {
        return language && language !== 'text' ? {
            value: astGenerator.highlight(code, language)
        } : {
            value: defaultCodeValue
        };
    } catch (e) {
        return {
            value: defaultCodeValue
        };
    }
}

},{"@babel/runtime/helpers/objectWithoutProperties":"5xa1i","@babel/runtime/helpers/toConsumableArray":"c2UGM","@babel/runtime/helpers/defineProperty":"hjdoh","react":"9njXz","./create-element":"hSeBs","./checkForListedLanguage":"6V8vC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5xa1i":[function(require,module,exports,__globalThis) {
var objectWithoutPropertiesLoose = require("424c8dc91f0a14f9");
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"424c8dc91f0a14f9":"imPRm"}],"imPRm":[function(require,module,exports,__globalThis) {
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"c2UGM":[function(require,module,exports,__globalThis) {
var arrayWithoutHoles = require("80b438c8f11ca70e");
var iterableToArray = require("4f1268a27b81f1fd");
var unsupportedIterableToArray = require("bfa7725fe5f724b");
var nonIterableSpread = require("24ae2b6222a85da6");
function _toConsumableArray(r) {
    return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"80b438c8f11ca70e":"aOlvk","4f1268a27b81f1fd":"1KRMO","bfa7725fe5f724b":"4zHVJ","24ae2b6222a85da6":"jdiaX"}],"aOlvk":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("d3a23041cb0f1512");
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d3a23041cb0f1512":"1AicQ"}],"1AicQ":[function(require,module,exports,__globalThis) {
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"1KRMO":[function(require,module,exports,__globalThis) {
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4zHVJ":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
    }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"1AicQ"}],"jdiaX":[function(require,module,exports,__globalThis) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hjdoh":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"6uI3m"}],"6uI3m":[function(require,module,exports,__globalThis) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"979to","2713647ce51d8c75":"3Msou"}],"3Msou":[function(require,module,exports,__globalThis) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"979to"}],"hSeBs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStyleObject", ()=>createStyleObject);
parcelHelpers.export(exports, "createClassNameString", ()=>createClassNameString);
parcelHelpers.export(exports, "createChildren", ()=>createChildren);
parcelHelpers.export(exports, "default", ()=>createElement);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react"); // Get all possible permutations of all power sets
var _reactDefault = parcelHelpers.interopDefault(_react);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
//
// Super simple, non-algorithmic solution since the
// number of class names will not be greater than 4
function powerSetPermutations(arr) {
    var arrLength = arr.length;
    if (arrLength === 0 || arrLength === 1) return arr;
    if (arrLength === 2) // prettier-ignore
    return [
        arr[0],
        arr[1],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength === 3) return [
        arr[0],
        arr[1],
        arr[2],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength >= 4) // Currently does not support more than 4 extra
    // class names (after `.token` has been removed)
    return [
        arr[0],
        arr[1],
        arr[2],
        arr[3],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
}
var classNameCombinations = {};
function getClassNameCombinations(classNames) {
    if (classNames.length === 0 || classNames.length === 1) return classNames;
    var key = classNames.join('.');
    if (!classNameCombinations[key]) classNameCombinations[key] = powerSetPermutations(classNames);
    return classNameCombinations[key];
}
function createStyleObject(classNames) {
    var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
    var nonTokenClassNames = classNames.filter(function(className) {
        return className !== 'token';
    });
    var classNamesCombinations = getClassNameCombinations(nonTokenClassNames);
    return classNamesCombinations.reduce(function(styleObject, className) {
        return _objectSpread(_objectSpread({}, styleObject), stylesheet[className]);
    }, elementStyle);
}
function createClassNameString(classNames) {
    return classNames.join(' ');
}
function createChildren(stylesheet, useInlineStyles) {
    var childrenCount = 0;
    return function(children) {
        childrenCount += 1;
        return children.map(function(child, i) {
            return createElement({
                node: child,
                stylesheet: stylesheet,
                useInlineStyles: useInlineStyles,
                key: "code-segment-".concat(childrenCount, "-").concat(i)
            });
        });
    };
}
function createElement(_ref) {
    var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key;
    var properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
    if (type === 'text') return value;
    else if (TagName) {
        var childrenCreator = createChildren(stylesheet, useInlineStyles);
        var props;
        if (!useInlineStyles) props = _objectSpread(_objectSpread({}, properties), {}, {
            className: createClassNameString(properties.className)
        });
        else {
            var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
                selector.split('.').forEach(function(className) {
                    if (!classes.includes(className)) classes.push(className);
                });
                return classes;
            }, []); // For compatibility with older versions of react-syntax-highlighter
            var startingClassName = properties.className && properties.className.includes('token') ? [
                'token'
            ] : [];
            var className = properties.className && startingClassName.concat(properties.className.filter(function(className) {
                return !allStylesheetSelectors.includes(className);
            }));
            props = _objectSpread(_objectSpread({}, properties), {}, {
                className: createClassNameString(className) || undefined,
                style: createStyleObject(properties.className, Object.assign({}, properties.style, style), stylesheet)
            });
        }
        var children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(TagName, (0, _extendsDefault.default)({
            key: key
        }, props), children);
    }
}

},{"@babel/runtime/helpers/extends":"ktcBy","@babel/runtime/helpers/defineProperty":"hjdoh","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6V8vC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = function(astGenerator, language) {
    var langs = astGenerator.listLanguages();
    return langs.indexOf(language) !== -1;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dkNym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    "code[class*=\"language-\"]": {
        "color": "black",
        "background": "none",
        "textShadow": "0 1px white",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "fontSize": "1em",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none"
    },
    "pre[class*=\"language-\"]": {
        "color": "black",
        "background": "#f5f2f0",
        "textShadow": "0 1px white",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "fontSize": "1em",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "padding": "1em",
        "margin": ".5em 0",
        "overflow": "auto"
    },
    "pre[class*=\"language-\"]::-moz-selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "pre[class*=\"language-\"] ::-moz-selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "code[class*=\"language-\"]::-moz-selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "code[class*=\"language-\"] ::-moz-selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "pre[class*=\"language-\"]::selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "pre[class*=\"language-\"] ::selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "code[class*=\"language-\"]::selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "code[class*=\"language-\"] ::selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    ":not(pre) > code[class*=\"language-\"]": {
        "background": "#f5f2f0",
        "padding": ".1em",
        "borderRadius": ".3em",
        "whiteSpace": "normal"
    },
    "comment": {
        "color": "slategray"
    },
    "prolog": {
        "color": "slategray"
    },
    "doctype": {
        "color": "slategray"
    },
    "cdata": {
        "color": "slategray"
    },
    "punctuation": {
        "color": "#999"
    },
    "namespace": {
        "Opacity": ".7"
    },
    "property": {
        "color": "#905"
    },
    "tag": {
        "color": "#905"
    },
    "boolean": {
        "color": "#905"
    },
    "number": {
        "color": "#905"
    },
    "constant": {
        "color": "#905"
    },
    "symbol": {
        "color": "#905"
    },
    "deleted": {
        "color": "#905"
    },
    "selector": {
        "color": "#690"
    },
    "attr-name": {
        "color": "#690"
    },
    "string": {
        "color": "#690"
    },
    "char": {
        "color": "#690"
    },
    "builtin": {
        "color": "#690"
    },
    "inserted": {
        "color": "#690"
    },
    "operator": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    "entity": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)",
        "cursor": "help"
    },
    "url": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    ".language-css .token.string": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    ".style .token.string": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    "atrule": {
        "color": "#07a"
    },
    "attr-value": {
        "color": "#07a"
    },
    "keyword": {
        "color": "#07a"
    },
    "function": {
        "color": "#DD4A68"
    },
    "class-name": {
        "color": "#DD4A68"
    },
    "regex": {
        "color": "#e90"
    },
    "important": {
        "color": "#e90",
        "fontWeight": "bold"
    },
    "variable": {
        "color": "#e90"
    },
    "bold": {
        "fontWeight": "bold"
    },
    "italic": {
        "fontStyle": "italic"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bqv8I":[function(require,module,exports,__globalThis) {
'use strict';
var refractor = require("c2e132b5178fafed");
module.exports = refractor;
refractor.register(require("a05c8497a71fff5b"));
refractor.register(require("f21e237e726979db"));
refractor.register(require("1814775c0c7e4d8e"));
refractor.register(require("23f1108f09b39e51"));
refractor.register(require("7e11b1702fce837d"));
refractor.register(require("d860f5f9f5baf63"));
refractor.register(require("271e4d26da088a9b"));
refractor.register(require("a7c2d90f7d8bc9d5"));
refractor.register(require("7f7c7b4aac26f149"));
refractor.register(require("a4c01ecd9164fc98"));
refractor.register(require("5f83c4f403c32944"));
refractor.register(require("983656d543f7708d"));
refractor.register(require("446d47b357569bb4"));
refractor.register(require("fb5994b261e33a71"));
refractor.register(require("53a3f48d5e0f5471"));
refractor.register(require("2ab04a556c7c3ba2"));
refractor.register(require("1673da2fb5ea4e7d"));
refractor.register(require("e890c6bd82b99aad"));
refractor.register(require("3491f7c651f89946"));
refractor.register(require("c7297c73b1bfe464"));
refractor.register(require("4593ed0abb28654e"));
refractor.register(require("17c4aeb6938b6a99"));
refractor.register(require("af946b70da6fedf3"));
refractor.register(require("5b98b32f60c83394"));
refractor.register(require("e76a02efbc7e1a1d"));
refractor.register(require("e895dc2f4e9aa8df"));
refractor.register(require("4608e5e690762746"));
refractor.register(require("2dbf0cc505cad80f"));
refractor.register(require("cc5718ed03098920"));
refractor.register(require("5ea3e6ebc591ced"));
refractor.register(require("5cb5d26697eda5bc"));
refractor.register(require("7e0a4b8f979f67a3"));
refractor.register(require("447142d1321d7fda"));
refractor.register(require("c5fd0e32af345c0b"));
refractor.register(require("c994232eb457ff71"));
refractor.register(require("3a3935cfef2abd7d"));
refractor.register(require("e68e8e24d6644a5f"));
refractor.register(require("b84b1c83eee423c5"));
refractor.register(require("c0f36a365b138823"));
refractor.register(require("f995ece61f5616a8"));
refractor.register(require("6697fa47cae7f1b4"));
refractor.register(require("a8c4e8c90022678e"));
refractor.register(require("efbc6541ce862cd"));
refractor.register(require("2f25a5d846776099"));
refractor.register(require("86dc4193766c0064"));
refractor.register(require("42c011bdd29236d7"));
refractor.register(require("e4d895c94bd68ad"));
refractor.register(require("4c20c75e349a9a67"));
refractor.register(require("9576740534cf18ba"));
refractor.register(require("6bd18ace4bfdd506"));
refractor.register(require("ae126c81d92e3f7f"));
refractor.register(require("9512e1a127fd5c1b"));
refractor.register(require("ba5365f4485ad749"));
refractor.register(require("53dcef46b8302df0"));
refractor.register(require("bb98351b17a978ba"));
refractor.register(require("20771e022a2138c6"));
refractor.register(require("b5ed34d525ddb36a"));
refractor.register(require("6fd864faefcf57d8"));
refractor.register(require("d115ecc9880968be"));
refractor.register(require("a07d2cb00411fece"));
refractor.register(require("c16dc1d8234d27b"));
refractor.register(require("cf32e69fe74f9ce"));
refractor.register(require("af3687b0027ef949"));
refractor.register(require("5f2af2d36ef1729b"));
refractor.register(require("2c32c375b2bf2c87"));
refractor.register(require("427e1c44c40ca62e"));
refractor.register(require("4784ea6026541272"));
refractor.register(require("bca7e4baa2b59b7f"));
refractor.register(require("8160de3e3adb152b"));
refractor.register(require("af09ef626786070f"));
refractor.register(require("f293b37dfdf01587"));
refractor.register(require("edfe754fc14151cd"));
refractor.register(require("7a267244bfa99b84"));
refractor.register(require("436cefc61cf32d39"));
refractor.register(require("2829da4a869755a1"));
refractor.register(require("a066f103033abbbf"));
refractor.register(require("e8b4a09e0b99b05b"));
refractor.register(require("db600365761c1fef"));
refractor.register(require("96041a46808840a4"));
refractor.register(require("d9ca98f31fb7b121"));
refractor.register(require("a4c9a9b812756224"));
refractor.register(require("f65c394a02e7d426"));
refractor.register(require("b8d54b5bab652b69"));
refractor.register(require("27308b406fe8563f"));
refractor.register(require("c17f470081627849"));
refractor.register(require("f38a2b45bc5e3b3f"));
refractor.register(require("c7a0f60e098cc756"));
refractor.register(require("42ac3af8dfd1d8b4"));
refractor.register(require("de3cdd3d0fda3310"));
refractor.register(require("33dd7549cdfa6827"));
refractor.register(require("6d61bda3de62f201"));
refractor.register(require("1b137727ff63129f"));
refractor.register(require("8c6f640b473e46a5"));
refractor.register(require("f8e3b2881e71fddc"));
refractor.register(require("9b3ef5c83990c5be"));
refractor.register(require("cef1ad73aefee08"));
refractor.register(require("5efef7145cdbd43d"));
refractor.register(require("d8114a510da9b140"));
refractor.register(require("7d97fce62ebd4af9"));
refractor.register(require("9b929d9a520f7481"));
refractor.register(require("65d0fbbde251b47e"));
refractor.register(require("62f813079c155bcd"));
refractor.register(require("b072d20f3cd98030"));
refractor.register(require("5716b4f04723528c"));
refractor.register(require("b7b5b190531bb252"));
refractor.register(require("482571cb47ff81eb"));
refractor.register(require("faa2a93a5ffb1574"));
refractor.register(require("ee183a0736962112"));
refractor.register(require("7f2dc21d840a757c"));
refractor.register(require("229292d40c0d824"));
refractor.register(require("eea11ab9df21630e"));
refractor.register(require("6a5990c4424d3cc4"));
refractor.register(require("6989274838419859"));
refractor.register(require("2928fdf252962d54"));
refractor.register(require("cea1298c7ac1dd8a"));
refractor.register(require("bab820bb25807149"));
refractor.register(require("167dd0716fba8c7e"));
refractor.register(require("f939e7a7fa803562"));
refractor.register(require("7b374251c96b838e"));
refractor.register(require("1139984bded7e83"));
refractor.register(require("4fd207faa3627492"));
refractor.register(require("d39c830cb3f74838"));
refractor.register(require("3e5aa9fb117767d0"));
refractor.register(require("bf88ce25bb5d9345"));
refractor.register(require("fcb7a91cff219cb3"));
refractor.register(require("99bcd725e02fee2d"));
refractor.register(require("cd66666412a56e31"));
refractor.register(require("a5d0bca2104349c7"));
refractor.register(require("44fc4484d50195f0"));
refractor.register(require("5059ea5f9f018981"));
refractor.register(require("91932498bc1dbee8"));
refractor.register(require("4cc7d947d23ccdf5"));
refractor.register(require("fbcb2ba121e75227"));
refractor.register(require("a4a34eb5f1e00191"));
refractor.register(require("a6b5d217dd8bc2aa"));
refractor.register(require("9bc25d432e211df7"));
refractor.register(require("4d6292236469340f"));
refractor.register(require("6a65d636ae0c9058"));
refractor.register(require("ee3f435f3f7be5d6"));
refractor.register(require("cefc055220209551"));
refractor.register(require("2f6da92a7fec50e6"));
refractor.register(require("4d0ebbc163a77c78"));
refractor.register(require("7ca2e915540ad14f"));
refractor.register(require("7c768527f8942d08"));
refractor.register(require("20854281c8aa1295"));
refractor.register(require("a9895c61f4fd1869"));
refractor.register(require("2f298cc0b9f54a97"));
refractor.register(require("a57e8e10994dee14"));
refractor.register(require("3b1396d942b0a18e"));
refractor.register(require("ec61a65376175a1f"));
refractor.register(require("a048b6fdafe08d2"));
refractor.register(require("591683389bcd54d2"));
refractor.register(require("f42a5c533326fe9b"));
refractor.register(require("d9385320e3fcf261"));
refractor.register(require("30dcf616330c7f97"));
refractor.register(require("cfa8b286fc54b2b0"));
refractor.register(require("15b9b083da882474"));
refractor.register(require("e21be7cdfbdaa2dc"));
refractor.register(require("fd18ee8a4a5c0e9f"));
refractor.register(require("62c7b28edff443ed"));
refractor.register(require("269de3a138b4790c"));
refractor.register(require("e9ff471ae7908f99"));
refractor.register(require("ac040d2c27921192"));
refractor.register(require("573c9345ae5edbad"));
refractor.register(require("67436ae38f7e8f81"));
refractor.register(require("b9962e7c6e045ea3"));
refractor.register(require("5343a577b322024d"));
refractor.register(require("93ff8236989490eb"));
refractor.register(require("f219e5c9007571b4"));
refractor.register(require("11ed710b16806044"));
refractor.register(require("ed51f3270ec667b6"));
refractor.register(require("8ff86d3aeb93b798"));
refractor.register(require("d467195da963aa39"));
refractor.register(require("622f069574300c2e"));
refractor.register(require("98a5bd76b7c98142"));
refractor.register(require("33e1456f8c26c7d2"));
refractor.register(require("102b4555fa851a93"));
refractor.register(require("462ce73811666045"));
refractor.register(require("677ff6068aaca5fa"));
refractor.register(require("e9f07896a8f6bf96"));
refractor.register(require("4d5a2545436ae7af"));
refractor.register(require("b87853db33a1561b"));
refractor.register(require("12c52eef40ca3257"));
refractor.register(require("b3983f420e087b55"));
refractor.register(require("5e89250b0feedff6"));
refractor.register(require("3b135640b03bfe7b"));
refractor.register(require("ecd0b1ee7f052b33"));
refractor.register(require("9dc62af71b5f2768"));
refractor.register(require("f9df1460fd34c687"));
refractor.register(require("df32ac95c2fd37f5"));
refractor.register(require("103aebb6d3993562"));
refractor.register(require("7f47d89c57fe6eb3"));
refractor.register(require("e16691031bdf6e7d"));
refractor.register(require("66bae0b9cd53e423"));
refractor.register(require("1329ba64874b7159"));
refractor.register(require("8a4709bf6eb618f4"));
refractor.register(require("7bc75f2c36195f7e"));
refractor.register(require("33e6b48147464dd2"));
refractor.register(require("bc64eb859935dec3"));
refractor.register(require("2ca2042d2b20a896"));
refractor.register(require("697ea2300991f77a"));
refractor.register(require("5a83f34fd45f0f9a"));
refractor.register(require("3b92a9a35a9621d5"));
refractor.register(require("85aa36eff6e3faa5"));
refractor.register(require("f65203112c4fa548"));
refractor.register(require("fce17c075b53502b"));
refractor.register(require("3f192866e92474b7"));
refractor.register(require("676580d0187eb6aa"));
refractor.register(require("681b4ed0e77cb38f"));
refractor.register(require("f45ffba0f587359e"));
refractor.register(require("4bda94c54982f163"));
refractor.register(require("8761eee4cdbd631e"));
refractor.register(require("6205e8f1098fd0b7"));
refractor.register(require("3dc3c8aa333694b1"));
refractor.register(require("23eb63b28e8ba05a"));
refractor.register(require("1ec0248104708998"));
refractor.register(require("3930b0259033aca3"));
refractor.register(require("17c47a312262f2e9"));
refractor.register(require("50635fda7b2bf038"));
refractor.register(require("97537a5170be6fa6"));
refractor.register(require("9999ab9de0a237cb"));
refractor.register(require("53370f206f8a84"));
refractor.register(require("72b3bfe5354a4da9"));
refractor.register(require("a729ee1943ba63aa"));
refractor.register(require("6c3dae497b004727"));
refractor.register(require("bcb9a32761b4fd9e"));
refractor.register(require("9ffa8a958177dca0"));
refractor.register(require("c5488c1fd0249801"));
refractor.register(require("735f2cdbfe9db4c7"));
refractor.register(require("28a2446f2ee52cd"));
refractor.register(require("f8052458cd49460b"));
refractor.register(require("99f76614354ef5c1"));
refractor.register(require("fdd7e450dfdad2ed"));
refractor.register(require("a460445bcea1654f"));
refractor.register(require("8e677801704806c7"));
refractor.register(require("7298ae70a4df2bfd"));
refractor.register(require("b35cb5d9d8783b1d"));
refractor.register(require("405504fa0063303a"));
refractor.register(require("8e7c4fb392aff3ac"));
refractor.register(require("751a4e86c9d6518d"));
refractor.register(require("6f27e26e656d1a7a"));
refractor.register(require("513918a0aea1ac81"));
refractor.register(require("bf047efe6a09a6e5"));
refractor.register(require("f1e99b664cc51fad"));
refractor.register(require("97338c84f5c98c5a"));
refractor.register(require("70165c303108b841"));
refractor.register(require("3ee1de4bf32f810f"));
refractor.register(require("2938ec2a7635a337"));
refractor.register(require("fae1d672bf1c34f5"));
refractor.register(require("483c027f3e5f87ca"));
refractor.register(require("4643031768975586"));
refractor.register(require("a1d29bd0d282c6f6"));
refractor.register(require("f51ac75f5a81fb22"));
refractor.register(require("d2724d7345b742f0"));
refractor.register(require("69598b83452d6ee6"));
refractor.register(require("f698f5178f965c72"));
refractor.register(require("2f24191e0e5c8236"));
refractor.register(require("31097faddccb84f8"));
refractor.register(require("b103a64d33e603e9"));
refractor.register(require("74d9eace29aca253"));
refractor.register(require("f779048f9c524897"));
refractor.register(require("493c26e52cedbda9"));
refractor.register(require("80ec7b78e04a1401"));
refractor.register(require("5bd269794cf6e9da"));
refractor.register(require("8e657d086d1bf8e3"));
refractor.register(require("7c658586d7239a0f"));
refractor.register(require("99d401efa45cabd7"));
refractor.register(require("f25d36b1aedd329"));
refractor.register(require("c48d54470a44d4f7"));
refractor.register(require("377506a7667879f0"));
refractor.register(require("b971db47a32c563a"));
refractor.register(require("b9525d76d2c6bafe"));
refractor.register(require("c80231f2b183af87"));

},{"c2e132b5178fafed":"jWUv3","a05c8497a71fff5b":"7sybo","f21e237e726979db":"4Bwqj","1814775c0c7e4d8e":"hEeqf","23f1108f09b39e51":"4I9qM","7e11b1702fce837d":"5f5O3","d860f5f9f5baf63":"598Qu","271e4d26da088a9b":"dijLo","a7c2d90f7d8bc9d5":"hlWp7","7f7c7b4aac26f149":"2NCxF","a4c01ecd9164fc98":"hjI97","5f83c4f403c32944":"jcDwP","983656d543f7708d":"knZ7Z","446d47b357569bb4":"eeV1f","fb5994b261e33a71":"aLttD","53a3f48d5e0f5471":"5YH5I","2ab04a556c7c3ba2":"cCsrb","1673da2fb5ea4e7d":"cNjzr","e890c6bd82b99aad":"3Ojkm","3491f7c651f89946":"2Sjb3","c7297c73b1bfe464":"2IJa9","4593ed0abb28654e":"cHiAQ","17c4aeb6938b6a99":"29Vdm","af946b70da6fedf3":"SDZTd","5b98b32f60c83394":"bnU0U","e76a02efbc7e1a1d":"lewDj","e895dc2f4e9aa8df":"2Wrts","4608e5e690762746":"jOOJM","2dbf0cc505cad80f":"3JjWI","cc5718ed03098920":"81zR6","5ea3e6ebc591ced":"9nLYo","5cb5d26697eda5bc":"2mZJH","7e0a4b8f979f67a3":"gbx3q","447142d1321d7fda":"aGGao","c5fd0e32af345c0b":"2HCJ7","c994232eb457ff71":"eMUEZ","3a3935cfef2abd7d":"3ufDi","e68e8e24d6644a5f":"8VyrL","b84b1c83eee423c5":"5lN4e","c0f36a365b138823":"68Tks","f995ece61f5616a8":"lR8GY","6697fa47cae7f1b4":"a8cZT","a8c4e8c90022678e":"gg8A2","efbc6541ce862cd":"kP8aL","2f25a5d846776099":"4k5le","86dc4193766c0064":"brS7J","42c011bdd29236d7":"euQ5r","e4d895c94bd68ad":"buy6I","4c20c75e349a9a67":"uYw2X","9576740534cf18ba":"3jiKs","6bd18ace4bfdd506":"lOjJo","ae126c81d92e3f7f":"asz0Q","9512e1a127fd5c1b":"fVeHd","ba5365f4485ad749":"cnalt","53dcef46b8302df0":"brm1N","bb98351b17a978ba":"iqGzw","20771e022a2138c6":"eIZoO","b5ed34d525ddb36a":"l5P6g","6fd864faefcf57d8":"8spVh","d115ecc9880968be":"hNWhr","a07d2cb00411fece":"2Rpqw","c16dc1d8234d27b":"anBQ8","cf32e69fe74f9ce":"jOhU4","af3687b0027ef949":"1hwJe","5f2af2d36ef1729b":"itdTK","2c32c375b2bf2c87":"ho6rl","427e1c44c40ca62e":"6sdqE","4784ea6026541272":"2pSjD","bca7e4baa2b59b7f":"iDuno","8160de3e3adb152b":"l1GKe","af09ef626786070f":"6cvtv","f293b37dfdf01587":"5Qkug","edfe754fc14151cd":"3lBVI","7a267244bfa99b84":"1Pefu","436cefc61cf32d39":"e3Kdm","2829da4a869755a1":"VTTVi","a066f103033abbbf":"2aO2r","e8b4a09e0b99b05b":"3RV2p","db600365761c1fef":"1NUv7","96041a46808840a4":"kUEsB","d9ca98f31fb7b121":"2rIHJ","a4c9a9b812756224":"3Qlw8","f65c394a02e7d426":"3bE1C","b8d54b5bab652b69":"fpqPV","27308b406fe8563f":"fUI1s","c17f470081627849":"jbJJZ","f38a2b45bc5e3b3f":"csvDy","c7a0f60e098cc756":"brkic","42ac3af8dfd1d8b4":"fLZKP","de3cdd3d0fda3310":"3KLb4","33dd7549cdfa6827":"cQk5d","6d61bda3de62f201":"bOWQq","1b137727ff63129f":"jSwns","8c6f640b473e46a5":"1F2iY","f8e3b2881e71fddc":"W2nn1","9b3ef5c83990c5be":"kvyjG","cef1ad73aefee08":"6SpBm","5efef7145cdbd43d":"4bvFk","d8114a510da9b140":"cJtqB","7d97fce62ebd4af9":"ayoMM","9b929d9a520f7481":"g2NwP","65d0fbbde251b47e":"nnqal","62f813079c155bcd":"3W7FD","b072d20f3cd98030":"acFVn","5716b4f04723528c":"52web","b7b5b190531bb252":"8exEc","482571cb47ff81eb":"4i42F","faa2a93a5ffb1574":"2TbDH","ee183a0736962112":"3EMpt","7f2dc21d840a757c":"f1VFC","229292d40c0d824":"y4vWu","eea11ab9df21630e":"kWeeS","6a5990c4424d3cc4":"9DpWu","6989274838419859":"5biU1","2928fdf252962d54":"bMcbL","cea1298c7ac1dd8a":"kn1Ox","bab820bb25807149":"3QjWX","167dd0716fba8c7e":"cBwEb","f939e7a7fa803562":"kJ9Rg","7b374251c96b838e":"pxFW6","1139984bded7e83":"6bsAN","4fd207faa3627492":"bMEaJ","d39c830cb3f74838":"fRfAx","3e5aa9fb117767d0":"fmEU2","bf88ce25bb5d9345":"ljcfb","fcb7a91cff219cb3":"3KPM5","99bcd725e02fee2d":"6TcDD","cd66666412a56e31":"alaWJ","a5d0bca2104349c7":"aeL6z","44fc4484d50195f0":"eW1Ps","5059ea5f9f018981":"2SmHt","91932498bc1dbee8":"jtUFl","4cc7d947d23ccdf5":"cVfd1","fbcb2ba121e75227":"l1wWe","a4a34eb5f1e00191":"gMvpH","a6b5d217dd8bc2aa":"axvTP","9bc25d432e211df7":"5BMWY","4d6292236469340f":"jZJ6b","6a65d636ae0c9058":"gVmsF","ee3f435f3f7be5d6":"2JOPl","cefc055220209551":"3lAdC","2f6da92a7fec50e6":"69Sns","4d0ebbc163a77c78":"5dy2G","7ca2e915540ad14f":"eTHbK","7c768527f8942d08":"fMVsy","20854281c8aa1295":"915b8","a9895c61f4fd1869":"fycDJ","2f298cc0b9f54a97":"6wCR2","a57e8e10994dee14":"lhKhp","3b1396d942b0a18e":"6T9Jo","ec61a65376175a1f":"6x8fG","a048b6fdafe08d2":"eYNqD","591683389bcd54d2":"85zhP","f42a5c533326fe9b":"1TpRw","d9385320e3fcf261":"e7rrr","30dcf616330c7f97":"iUJZb","cfa8b286fc54b2b0":"3wIC8","15b9b083da882474":"jZE9i","e21be7cdfbdaa2dc":"kNawC","fd18ee8a4a5c0e9f":"3ZTNF","62c7b28edff443ed":"3O6ws","269de3a138b4790c":"a3VxR","e9ff471ae7908f99":"inhvP","ac040d2c27921192":"lOJ5E","573c9345ae5edbad":"cCw8C","67436ae38f7e8f81":"4KAxW","b9962e7c6e045ea3":"lXqle","5343a577b322024d":"l0YCE","93ff8236989490eb":"bGqgq","f219e5c9007571b4":"a7XNF","11ed710b16806044":"2aF5V","ed51f3270ec667b6":"9N34f","8ff86d3aeb93b798":"8j7iJ","d467195da963aa39":"1Dkyt","622f069574300c2e":"bhHtL","98a5bd76b7c98142":"7B6xt","33e1456f8c26c7d2":"4MMj9","102b4555fa851a93":"8QYR8","462ce73811666045":"ibccN","677ff6068aaca5fa":"4KqDc","e9f07896a8f6bf96":"95d0b","4d5a2545436ae7af":"f5DlF","b87853db33a1561b":"bNNMg","12c52eef40ca3257":"kMtT3","b3983f420e087b55":"590zq","5e89250b0feedff6":"1caAO","3b135640b03bfe7b":"fShuq","ecd0b1ee7f052b33":"cXiUl","9dc62af71b5f2768":"hU0GD","f9df1460fd34c687":"9z3k8","df32ac95c2fd37f5":"9Gvpa","103aebb6d3993562":"fTFGc","7f47d89c57fe6eb3":"eT6ik","e16691031bdf6e7d":"9n7LA","66bae0b9cd53e423":"gtGOi","1329ba64874b7159":"kQ7W4","8a4709bf6eb618f4":"2o27K","7bc75f2c36195f7e":"96Qpb","33e6b48147464dd2":"j41f2","bc64eb859935dec3":"gzXny","2ca2042d2b20a896":"i1WTF","697ea2300991f77a":"59uoz","5a83f34fd45f0f9a":"cvtkO","3b92a9a35a9621d5":"5Zble","85aa36eff6e3faa5":"901XI","f65203112c4fa548":"1NvuG","fce17c075b53502b":"ei8DV","3f192866e92474b7":"9NnYo","676580d0187eb6aa":"b6T5S","681b4ed0e77cb38f":"oMsx6","f45ffba0f587359e":"9kBz9","4bda94c54982f163":"82nVp","8761eee4cdbd631e":"7gegN","6205e8f1098fd0b7":"03Tu7","3dc3c8aa333694b1":"4XVN6","23eb63b28e8ba05a":"5zOXW","1ec0248104708998":"aJN06","3930b0259033aca3":"6Tsyk","17c47a312262f2e9":"iQcWX","50635fda7b2bf038":"iBhXF","97537a5170be6fa6":"QnLEV","9999ab9de0a237cb":"4XB3z","53370f206f8a84":"i39EJ","72b3bfe5354a4da9":"jrAlE","a729ee1943ba63aa":"g4fu0","6c3dae497b004727":"Uv44I","bcb9a32761b4fd9e":"kLxiF","9ffa8a958177dca0":"jHmS7","c5488c1fd0249801":"bEBe7","735f2cdbfe9db4c7":"8bFuG","28a2446f2ee52cd":"g6Eid","f8052458cd49460b":"l8WOe","99f76614354ef5c1":"8NaXO","fdd7e450dfdad2ed":"2G2jP","a460445bcea1654f":"lhKw6","8e677801704806c7":"jWttK","7298ae70a4df2bfd":"hWk2Z","b35cb5d9d8783b1d":"9gh8N","405504fa0063303a":"9zSTh","8e7c4fb392aff3ac":"cFnF4","751a4e86c9d6518d":"lbzf8","6f27e26e656d1a7a":"1yQZh","513918a0aea1ac81":"dwOYD","bf047efe6a09a6e5":"dR9PJ","f1e99b664cc51fad":"64KR2","97338c84f5c98c5a":"hJg00","70165c303108b841":"8lg3c","3ee1de4bf32f810f":"lptQj","2938ec2a7635a337":"78nM7","fae1d672bf1c34f5":"cUtLH","483c027f3e5f87ca":"cZE3w","4643031768975586":"4ePta","a1d29bd0d282c6f6":"anl6q","f51ac75f5a81fb22":"SrnU6","d2724d7345b742f0":"6zZnL","69598b83452d6ee6":"5lunV","f698f5178f965c72":"c4GSa","2f24191e0e5c8236":"a7zma","31097faddccb84f8":"96UoI","b103a64d33e603e9":"1kBKi","74d9eace29aca253":"8phG0","f779048f9c524897":"e1IQ2","493c26e52cedbda9":"c2Qkx","80ec7b78e04a1401":"6g72f","5bd269794cf6e9da":"dHrPm","8e657d086d1bf8e3":"5E7AF","7c658586d7239a0f":"1WTsd","99d401efa45cabd7":"4Gw4C","f25d36b1aedd329":"eFhWq","c48d54470a44d4f7":"ilCAK","377506a7667879f0":"22IQU","b971db47a32c563a":"jAdhw","b9525d76d2c6bafe":"b2VmG","c80231f2b183af87":"1Az8c"}],"jWUv3":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
/* global window, self */ // istanbul ignore next - Don't allow Prism to run on page load in browser or
// to start messaging from workers.
var ctx = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof global === 'object' ? global : {};
var restore = capture();
ctx.Prism = {
    manual: true,
    disableWorkerMessageHandler: true
};
// Load all stuff in `prism.js` itself, except for `prism-file-highlight.js`.
// The wrapped non-leaky grammars are loaded instead of Prism’s originals.
var h = require("d244c3dc728d1b");
var decode = require("a0ee1454f2ae25b3");
var Prism = require("219ce7c21e680276");
var markup = require("ab2096f048adcd35");
var css = require("a2c53b07ca8f5e7a");
var clike = require("1c437b8f2b45b7c3");
var js = require("45d991b8513d1158");
restore();
var own = {}.hasOwnProperty;
// Inherit.
function Refractor() {}
Refractor.prototype = Prism;
// Construct.
var refract = new Refractor();
// Expose.
module.exports = refract;
// Create.
refract.highlight = highlight;
refract.register = register;
refract.alias = alias;
refract.registered = registered;
refract.listLanguages = listLanguages;
// Register bundled grammars.
register(markup);
register(css);
register(clike);
register(js);
refract.util.encode = encode;
refract.Token.stringify = stringify;
function register(grammar) {
    if (typeof grammar !== 'function' || !grammar.displayName) throw new Error('Expected `function` for `grammar`, got `' + grammar + '`');
    // Do not duplicate registrations.
    if (refract.languages[grammar.displayName] === undefined) grammar(refract);
}
function alias(name, alias) {
    var languages = refract.languages;
    var map = name;
    var key;
    var list;
    var length;
    var index;
    if (alias) {
        map = {};
        map[name] = alias;
    }
    for(key in map){
        list = map[key];
        list = typeof list === 'string' ? [
            list
        ] : list;
        length = list.length;
        index = -1;
        while(++index < length)languages[list[index]] = languages[key];
    }
}
function highlight(value, name) {
    var sup = Prism.highlight;
    var grammar;
    if (typeof value !== 'string') throw new Error('Expected `string` for `value`, got `' + value + '`');
    // `name` is a grammar object.
    if (refract.util.type(name) === 'Object') {
        grammar = name;
        name = null;
    } else {
        if (typeof name !== 'string') throw new Error('Expected `string` for `name`, got `' + name + '`');
        if (own.call(refract.languages, name)) grammar = refract.languages[name];
        else throw new Error('Unknown language: `' + name + '` is not registered');
    }
    return sup.call(this, value, grammar, name);
}
function registered(language) {
    if (typeof language !== 'string') throw new Error('Expected `string` for `language`, got `' + language + '`');
    return own.call(refract.languages, language);
}
function listLanguages() {
    var languages = refract.languages;
    var list = [];
    var language;
    for(language in languages)if (own.call(languages, language) && typeof languages[language] === 'object') list.push(language);
    return list;
}
function stringify(value, language, parent) {
    var env;
    if (typeof value === 'string') return {
        type: 'text',
        value: value
    };
    if (refract.util.type(value) === 'Array') return stringifyAll(value, language);
    env = {
        type: value.type,
        content: refract.Token.stringify(value.content, language, parent),
        tag: 'span',
        classes: [
            'token',
            value.type
        ],
        attributes: {},
        language: language,
        parent: parent
    };
    if (value.alias) env.classes = env.classes.concat(value.alias);
    refract.hooks.run('wrap', env);
    return h(env.tag + '.' + env.classes.join('.'), attributes(env.attributes), env.content);
}
function stringifyAll(values, language) {
    var result = [];
    var length = values.length;
    var index = -1;
    var value;
    while(++index < length){
        value = values[index];
        if (value !== '' && value !== null && value !== undefined) result.push(value);
    }
    index = -1;
    length = result.length;
    while(++index < length){
        value = result[index];
        result[index] = refract.Token.stringify(value, language, result);
    }
    return result;
}
function encode(tokens) {
    return tokens;
}
function attributes(attrs) {
    var key;
    for(key in attrs)attrs[key] = decode(attrs[key]);
    return attrs;
}
function capture() {
    var defined = 'Prism' in ctx;
    /* istanbul ignore next */ var current = defined ? ctx.Prism : undefined;
    return restore;
    function restore() {
        /* istanbul ignore else - Clean leaks after Prism. */ if (defined) ctx.Prism = current;
        else delete ctx.Prism;
        defined = undefined;
        current = undefined;
    }
}

},{"d244c3dc728d1b":"3WfQd","a0ee1454f2ae25b3":"lxDMx","219ce7c21e680276":"kiDOD","ab2096f048adcd35":"hryt3","a2c53b07ca8f5e7a":"cNlCK","1c437b8f2b45b7c3":"lDjlE","45d991b8513d1158":"5w8do"}],"3WfQd":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e85c9e986adf1dd1");

},{"e85c9e986adf1dd1":"Ye6JB"}],"Ye6JB":[function(require,module,exports,__globalThis) {
'use strict';
var schema = require("90b9caea5fbbb1f8");
var factory = require("a5f88ed29e486505");
var html = factory(schema, 'div');
html.displayName = 'html';
module.exports = html;

},{"90b9caea5fbbb1f8":"fGUEl","a5f88ed29e486505":"jNTPi"}],"fGUEl":[function(require,module,exports,__globalThis) {
'use strict';
var merge = require("e222e8b03baba495");
var xlink = require("4ce9827de25058e8");
var xml = require("cfa3717f03cc34a0");
var xmlns = require("d21a1d16bcc3d1b3");
var aria = require("6ae99b57b1aa34fb");
var html = require("b596ad7f000a3cd2");
module.exports = merge([
    xml,
    xlink,
    xmlns,
    aria,
    html
]);

},{"e222e8b03baba495":"ihC0D","4ce9827de25058e8":"661NY","cfa3717f03cc34a0":"bbLLg","d21a1d16bcc3d1b3":"hqTLU","6ae99b57b1aa34fb":"1Rg5d","b596ad7f000a3cd2":"4AwKK"}],"ihC0D":[function(require,module,exports,__globalThis) {
'use strict';
var xtend = require("aff02db643bcb2a8");
var Schema = require("9b204132a4dd486a");
module.exports = merge;
function merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new Schema(xtend.apply(null, property), xtend.apply(null, normal), space);
}

},{"aff02db643bcb2a8":"8NIEK","9b204132a4dd486a":"f5XBF"}],"8NIEK":[function(require,module,exports,__globalThis) {
module.exports = extend;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

},{}],"f5XBF":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = Schema;
var proto = Schema.prototype;
proto.space = null;
proto.normal = {};
proto.property = {};
function Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}

},{}],"661NY":[function(require,module,exports,__globalThis) {
'use strict';
var create = require("a308ff2877287727");
module.exports = create({
    space: 'xlink',
    transform: xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function xlinkTransform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase();
}

},{"a308ff2877287727":"iWLdo"}],"iWLdo":[function(require,module,exports,__globalThis) {
'use strict';
var normalize = require("bfffb1d93d1cda64");
var Schema = require("f026e02181ed8f92");
var DefinedInfo = require("dfd8875579285993");
module.exports = create;
function create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new DefinedInfo(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[normalize(prop)] = prop;
        normal[normalize(info.attribute)] = prop;
    }
    return new Schema(property, normal, space);
}

},{"bfffb1d93d1cda64":"6Ai8S","f026e02181ed8f92":"f5XBF","dfd8875579285993":"fgrtt"}],"6Ai8S":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = normalize;
function normalize(value) {
    return value.toLowerCase();
}

},{}],"fgrtt":[function(require,module,exports,__globalThis) {
'use strict';
var Info = require("aa72c1656ec85657");
var types = require("8b11356c60e083e2");
module.exports = DefinedInfo;
DefinedInfo.prototype = new Info();
DefinedInfo.prototype.defined = true;
var checks = [
    'boolean',
    'booleanish',
    'overloadedBoolean',
    'number',
    'commaSeparated',
    'spaceSeparated',
    'commaOrSpaceSeparated'
];
var checksLength = checks.length;
function DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    mark(this, 'space', space);
    Info.call(this, property, attribute);
    while(++index < checksLength){
        check = checks[index];
        mark(this, check, (mask & types[check]) === types[check]);
    }
}
function mark(values, key, value) {
    if (value) values[key] = value;
}

},{"aa72c1656ec85657":"jN81N","8b11356c60e083e2":"e5nT8"}],"jN81N":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = Info;
var proto = Info.prototype;
proto.space = null;
proto.attribute = null;
proto.property = null;
proto.boolean = false;
proto.booleanish = false;
proto.overloadedBoolean = false;
proto.number = false;
proto.commaSeparated = false;
proto.spaceSeparated = false;
proto.commaOrSpaceSeparated = false;
proto.mustUseProperty = false;
proto.defined = false;
function Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}

},{}],"e5nT8":[function(require,module,exports,__globalThis) {
'use strict';
var powers = 0;
exports.boolean = increment();
exports.booleanish = increment();
exports.overloadedBoolean = increment();
exports.number = increment();
exports.spaceSeparated = increment();
exports.commaSeparated = increment();
exports.commaOrSpaceSeparated = increment();
function increment() {
    return Math.pow(2, ++powers);
}

},{}],"bbLLg":[function(require,module,exports,__globalThis) {
'use strict';
var create = require("8291787cc1196527");
module.exports = create({
    space: 'xml',
    transform: xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function xmlTransform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase();
}

},{"8291787cc1196527":"iWLdo"}],"hqTLU":[function(require,module,exports,__globalThis) {
'use strict';
var create = require("f7d8dd585c66aa17");
var caseInsensitiveTransform = require("ef24f3f88efc8122");
module.exports = create({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: caseInsensitiveTransform,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});

},{"f7d8dd585c66aa17":"iWLdo","ef24f3f88efc8122":"faqup"}],"faqup":[function(require,module,exports,__globalThis) {
'use strict';
var caseSensitiveTransform = require("bc5d245be42a24e5");
module.exports = caseInsensitiveTransform;
function caseInsensitiveTransform(attributes, property) {
    return caseSensitiveTransform(attributes, property.toLowerCase());
}

},{"bc5d245be42a24e5":"jWVCq"}],"jWVCq":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = caseSensitiveTransform;
function caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

},{}],"1Rg5d":[function(require,module,exports,__globalThis) {
'use strict';
var types = require("cc49de9f6bf70a3f");
var create = require("5bb8251263d6e2cd");
var booleanish = types.booleanish;
var number = types.number;
var spaceSeparated = types.spaceSeparated;
module.exports = create({
    transform: ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: booleanish,
        ariaAutoComplete: null,
        ariaBusy: booleanish,
        ariaChecked: booleanish,
        ariaColCount: number,
        ariaColIndex: number,
        ariaColSpan: number,
        ariaControls: spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: spaceSeparated,
        ariaDetails: null,
        ariaDisabled: booleanish,
        ariaDropEffect: spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: booleanish,
        ariaFlowTo: spaceSeparated,
        ariaGrabbed: booleanish,
        ariaHasPopup: null,
        ariaHidden: booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: spaceSeparated,
        ariaLevel: number,
        ariaLive: null,
        ariaModal: booleanish,
        ariaMultiLine: booleanish,
        ariaMultiSelectable: booleanish,
        ariaOrientation: null,
        ariaOwns: spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: number,
        ariaPressed: booleanish,
        ariaReadOnly: booleanish,
        ariaRelevant: null,
        ariaRequired: booleanish,
        ariaRoleDescription: spaceSeparated,
        ariaRowCount: number,
        ariaRowIndex: number,
        ariaRowSpan: number,
        ariaSelected: booleanish,
        ariaSetSize: number,
        ariaSort: null,
        ariaValueMax: number,
        ariaValueMin: number,
        ariaValueNow: number,
        ariaValueText: null,
        role: null
    }
});
function ariaTransform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
}

},{"cc49de9f6bf70a3f":"e5nT8","5bb8251263d6e2cd":"iWLdo"}],"4AwKK":[function(require,module,exports,__globalThis) {
'use strict';
var types = require("7622a582e65cde1e");
var create = require("58cbfc1b918fbf1a");
var caseInsensitiveTransform = require("a82c3091ed99eaae");
var boolean = types.boolean;
var overloadedBoolean = types.overloadedBoolean;
var booleanish = types.booleanish;
var number = types.number;
var spaceSeparated = types.spaceSeparated;
var commaSeparated = types.commaSeparated;
module.exports = create({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: caseInsensitiveTransform,
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: commaSeparated,
        acceptCharset: spaceSeparated,
        accessKey: spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: boolean,
        allowPaymentRequest: boolean,
        allowUserMedia: boolean,
        alt: null,
        as: null,
        async: boolean,
        autoCapitalize: null,
        autoComplete: spaceSeparated,
        autoFocus: boolean,
        autoPlay: boolean,
        capture: boolean,
        charSet: null,
        checked: boolean,
        cite: null,
        className: spaceSeparated,
        cols: number,
        colSpan: null,
        content: null,
        contentEditable: booleanish,
        controls: boolean,
        controlsList: spaceSeparated,
        coords: number | commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: boolean,
        defer: boolean,
        dir: null,
        dirName: null,
        disabled: boolean,
        download: overloadedBoolean,
        draggable: booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: boolean,
        formTarget: null,
        headers: spaceSeparated,
        height: number,
        hidden: boolean,
        high: number,
        href: null,
        hrefLang: null,
        htmlFor: spaceSeparated,
        httpEquiv: spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: boolean,
        itemId: null,
        itemProp: spaceSeparated,
        itemRef: spaceSeparated,
        itemScope: boolean,
        itemType: spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: boolean,
        low: number,
        manifest: null,
        max: null,
        maxLength: number,
        media: null,
        method: null,
        min: null,
        minLength: number,
        multiple: boolean,
        muted: boolean,
        name: null,
        nonce: null,
        noModule: boolean,
        noValidate: boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: boolean,
        optimum: number,
        pattern: null,
        ping: spaceSeparated,
        placeholder: null,
        playsInline: boolean,
        poster: null,
        preload: null,
        readOnly: boolean,
        referrerPolicy: null,
        rel: spaceSeparated,
        required: boolean,
        reversed: boolean,
        rows: number,
        rowSpan: number,
        sandbox: spaceSeparated,
        scope: null,
        scoped: boolean,
        seamless: boolean,
        selected: boolean,
        shape: null,
        size: number,
        sizes: null,
        slot: null,
        span: number,
        spellCheck: booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: commaSeparated,
        start: number,
        step: null,
        style: null,
        tabIndex: number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: boolean,
        useMap: null,
        value: booleanish,
        width: number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: number,
        borderColor: null,
        bottomMargin: number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: boolean,
        declare: boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: number,
        leftMargin: number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: number,
        marginWidth: number,
        noResize: boolean,
        noHref: boolean,
        noShade: boolean,
        noWrap: boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: number,
        rules: null,
        scheme: null,
        scrolling: booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: boolean,
        disableRemotePlayback: boolean,
        prefix: null,
        property: null,
        results: number,
        security: null,
        unselectable: null
    }
});

},{"7622a582e65cde1e":"e5nT8","58cbfc1b918fbf1a":"iWLdo","a82c3091ed99eaae":"faqup"}],"jNTPi":[function(require,module,exports,__globalThis) {
'use strict';
var find = require("cc2372fb3986db23");
var normalize = require("75a358b0c10c5ae");
var parseSelector = require("28aa40f911e1f79f");
var spaces = require("8640c013a833857a").parse;
var commas = require("67494b4621cdfa3").parse;
module.exports = factory;
var own = {}.hasOwnProperty;
function factory(schema, defaultTagName, caseSensitive) {
    var adjust = caseSensitive ? createAdjustMap(caseSensitive) : null;
    return h;
    // Hyperscript compatible DSL for creating virtual hast trees.
    function h(selector, properties) {
        var node = parseSelector(selector, defaultTagName);
        var children = Array.prototype.slice.call(arguments, 2);
        var name = node.tagName.toLowerCase();
        var property;
        node.tagName = adjust && own.call(adjust, name) ? adjust[name] : name;
        if (properties && isChildren(properties, node)) {
            children.unshift(properties);
            properties = null;
        }
        if (properties) for(property in properties)addProperty(node.properties, property, properties[property]);
        addChild(node.children, children);
        if (node.tagName === 'template') {
            node.content = {
                type: 'root',
                children: node.children
            };
            node.children = [];
        }
        return node;
    }
    function addProperty(properties, key, value) {
        var info;
        var property;
        var result;
        // Ignore nullish and NaN values.
        if (value === null || value === undefined || value !== value) return;
        info = find(schema, key);
        property = info.property;
        result = value;
        // Handle list values.
        if (typeof result === 'string') {
            if (info.spaceSeparated) result = spaces(result);
            else if (info.commaSeparated) result = commas(result);
            else if (info.commaOrSpaceSeparated) result = spaces(commas(result).join(' '));
        }
        // Accept `object` on style.
        if (property === 'style' && typeof value !== 'string') result = style(result);
        // Class-names (which can be added both on the `selector` and here).
        if (property === 'className' && properties.className) result = properties.className.concat(result);
        properties[property] = parsePrimitives(info, property, result);
    }
}
function isChildren(value, node) {
    return typeof value === 'string' || 'length' in value || isNode(node.tagName, value);
}
function isNode(tagName, value) {
    var type = value.type;
    if (tagName === 'input' || !type || typeof type !== 'string') return false;
    if (typeof value.children === 'object' && 'length' in value.children) return true;
    type = type.toLowerCase();
    if (tagName === 'button') return type !== 'menu' && type !== 'submit' && type !== 'reset' && type !== 'button';
    return 'value' in value;
}
function addChild(nodes, value) {
    var index;
    var length;
    if (typeof value === 'string' || typeof value === 'number') {
        nodes.push({
            type: 'text',
            value: String(value)
        });
        return;
    }
    if (typeof value === 'object' && 'length' in value) {
        index = -1;
        length = value.length;
        while(++index < length)addChild(nodes, value[index]);
        return;
    }
    if (typeof value !== 'object' || !('type' in value)) throw new Error('Expected node, nodes, or string, got `' + value + '`');
    nodes.push(value);
}
// Parse a (list of) primitives.
function parsePrimitives(info, name, value) {
    var index;
    var length;
    var result;
    if (typeof value !== 'object' || !('length' in value)) return parsePrimitive(info, name, value);
    length = value.length;
    index = -1;
    result = [];
    while(++index < length)result[index] = parsePrimitive(info, name, value[index]);
    return result;
}
// Parse a single primitives.
function parsePrimitive(info, name, value) {
    var result = value;
    if (info.number || info.positiveNumber) {
        if (!isNaN(result) && result !== '') result = Number(result);
    } else if (info.boolean || info.overloadedBoolean) // Accept `boolean` and `string`.
    {
        if (typeof result === 'string' && (result === '' || normalize(value) === normalize(name))) result = true;
    }
    return result;
}
function style(value) {
    var result = [];
    var key;
    for(key in value)result.push([
        key,
        value[key]
    ].join(': '));
    return result.join('; ');
}
function createAdjustMap(values) {
    var length = values.length;
    var index = -1;
    var result = {};
    var value;
    while(++index < length){
        value = values[index];
        result[value.toLowerCase()] = value;
    }
    return result;
}

},{"cc2372fb3986db23":"iMWLt","75a358b0c10c5ae":"6Ai8S","28aa40f911e1f79f":"hp9mX","8640c013a833857a":"1Ctsk","67494b4621cdfa3":"45B51"}],"iMWLt":[function(require,module,exports,__globalThis) {
'use strict';
var normalize = require("acac6918aed11923");
var DefinedInfo = require("60cbd75c54f0c606");
var Info = require("cd9d1902463e5c80");
var data = 'data';
module.exports = find;
var valid = /^data[-\w.:]+$/i;
var dash = /-[a-z]/g;
var cap = /[A-Z]/g;
function find(schema, value) {
    var normal = normalize(value);
    var prop = value;
    var Type = Info;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') prop = datasetToProperty(value);
        else value = datasetToAttribute(value);
        Type = DefinedInfo;
    }
    return new Type(prop, value);
}
function datasetToProperty(attribute) {
    var value = attribute.slice(5).replace(dash, camelcase);
    return data + value.charAt(0).toUpperCase() + value.slice(1);
}
function datasetToAttribute(property) {
    var value = property.slice(4);
    if (dash.test(value)) return property;
    value = value.replace(cap, kebab);
    if (value.charAt(0) !== '-') value = '-' + value;
    return data + value;
}
function kebab($0) {
    return '-' + $0.toLowerCase();
}
function camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

},{"acac6918aed11923":"6Ai8S","60cbd75c54f0c606":"fgrtt","cd9d1902463e5c80":"jN81N"}],"hp9mX":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = parse;
var search = /[#.]/g;
// Create a hast element from a simple CSS selector.
function parse(selector, defaultTagName) {
    var value = selector || '';
    var name = defaultTagName || 'div';
    var props = {};
    var start = 0;
    var subvalue;
    var previous;
    var match;
    while(start < value.length){
        search.lastIndex = start;
        match = search.exec(value);
        subvalue = value.slice(start, match ? match.index : value.length);
        if (subvalue) {
            if (!previous) name = subvalue;
            else if (previous === '#') props.id = subvalue;
            else if (props.className) props.className.push(subvalue);
            else props.className = [
                subvalue
            ];
            start += subvalue.length;
        }
        if (match) {
            previous = match[0];
            start++;
        }
    }
    return {
        type: 'element',
        tagName: name,
        properties: props,
        children: []
    };
}

},{}],"1Ctsk":[function(require,module,exports,__globalThis) {
'use strict';
exports.parse = parse;
exports.stringify = stringify;
var empty = '';
var space = ' ';
var whiteSpace = /[ \t\n\r\f]+/g;
function parse(value) {
    var input = String(value || empty).trim();
    return input === empty ? [] : input.split(whiteSpace);
}
function stringify(values) {
    return values.join(space).trim();
}

},{}],"45B51":[function(require,module,exports,__globalThis) {
'use strict';
exports.parse = parse;
exports.stringify = stringify;
var comma = ',';
var space = ' ';
var empty = '';
// Parse comma-separated tokens to an array.
function parse(value) {
    var values = [];
    var input = String(value || empty);
    var index = input.indexOf(comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf(comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? empty : space;
    var right = settings.padRight ? space : empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === empty) values = values.concat(empty);
    return values.join(right + comma + left).trim();
}

},{}],"lxDMx":[function(require,module,exports,__globalThis) {
'use strict';
var legacy = require("d167df7aadf55c55");
var invalid = require("1607d1218b697c57");
var decimal = require("a79eb8234d1c118a");
var hexadecimal = require("49130e28d9fb85c3");
var alphanumerical = require("d5d86fd6f6e87ed9");
var decodeEntity = require("5729f4b97642ca9d");
module.exports = parseEntities;
var own = {}.hasOwnProperty;
var fromCharCode = String.fromCharCode;
var noop = Function.prototype;
// Default settings.
var defaults = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: false,
    nonTerminated: true
};
// Characters.
var tab = 9 // '\t'
;
var lineFeed = 10 // '\n'
;
var formFeed = 12 // '\f'
;
var space = 32 // ' '
;
var ampersand = 38 // '&'
;
var semicolon = 59 // ';'
;
var lessThan = 60 // '<'
;
var equalsTo = 61 // '='
;
var numberSign = 35 // '#'
;
var uppercaseX = 88 // 'X'
;
var lowercaseX = 120 // 'x'
;
var replacementCharacter = 65533 // '�'
;
// Reference types.
var name = 'named';
var hexa = 'hexadecimal';
var deci = 'decimal';
// Map of bases.
var bases = {};
bases[hexa] = 16;
bases[deci] = 10;
// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var tests = {};
tests[name] = alphanumerical;
tests[deci] = decimal;
tests[hexa] = hexadecimal;
// Warning types.
var namedNotTerminated = 1;
var numericNotTerminated = 2;
var namedEmpty = 3;
var numericEmpty = 4;
var namedUnknown = 5;
var numericDisallowed = 6;
var numericProhibited = 7;
// Warning messages.
var messages = {};
messages[namedNotTerminated] = 'Named character references must be terminated by a semicolon';
messages[numericNotTerminated] = 'Numeric character references must be terminated by a semicolon';
messages[namedEmpty] = 'Named character references cannot be empty';
messages[numericEmpty] = 'Numeric character references cannot be empty';
messages[namedUnknown] = 'Named character references must be known';
messages[numericDisallowed] = 'Numeric character references cannot be disallowed';
messages[numericProhibited] = 'Numeric character references cannot be outside the permissible Unicode range';
// Wrap to ensure clean parameters are given to `parse`.
function parseEntities(value, options) {
    var settings = {};
    var option;
    var key;
    if (!options) options = {};
    for(key in defaults){
        option = options[key];
        settings[key] = option === null || option === undefined ? defaults[key] : option;
    }
    if (settings.position.indent || settings.position.start) {
        settings.indent = settings.position.indent || [];
        settings.position = settings.position.start;
    }
    return parse(value, settings);
}
// Parse entities.
// eslint-disable-next-line complexity
function parse(value, settings) {
    var additional = settings.additional;
    var nonTerminated = settings.nonTerminated;
    var handleText = settings.text;
    var handleReference = settings.reference;
    var handleWarning = settings.warning;
    var textContext = settings.textContext;
    var referenceContext = settings.referenceContext;
    var warningContext = settings.warningContext;
    var pos = settings.position;
    var indent = settings.indent || [];
    var length = value.length;
    var index = 0;
    var lines = -1;
    var column = pos.column || 1;
    var line = pos.line || 1;
    var queue = '';
    var result = [];
    var entityCharacters;
    var namedEntity;
    var terminated;
    var characters;
    var character;
    var reference;
    var following;
    var warning;
    var reason;
    var output;
    var entity;
    var begin;
    var start;
    var type;
    var test;
    var prev;
    var next;
    var diff;
    var end;
    if (typeof additional === 'string') additional = additional.charCodeAt(0);
    // Cache the current point.
    prev = now();
    // Wrap `handleWarning`.
    warning = handleWarning ? parseError : noop;
    // Ensure the algorithm walks over the first character and the end
    // (inclusive).
    index--;
    length++;
    while(++index < length){
        // If the previous character was a newline.
        if (character === lineFeed) column = indent[lines] || 1;
        character = value.charCodeAt(index);
        if (character === ampersand) {
            following = value.charCodeAt(index + 1);
            // The behaviour depends on the identity of the next character.
            if (following === tab || following === lineFeed || following === formFeed || following === space || following === ampersand || following === lessThan || following !== following || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += fromCharCode(character);
                column++;
                continue;
            }
            start = index + 1;
            begin = start;
            end = start;
            if (following === numberSign) {
                // Numerical entity.
                end = ++begin;
                // The behaviour further depends on the next character.
                following = value.charCodeAt(end);
                if (following === uppercaseX || following === lowercaseX) {
                    // ASCII hex digits.
                    type = hexa;
                    end = ++begin;
                } else // ASCII digits.
                type = deci;
            } else // Named entity.
            type = name;
            entityCharacters = '';
            entity = '';
            characters = '';
            test = tests[type];
            end--;
            while(++end < length){
                following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === name && own.call(legacy, characters)) {
                    entityCharacters = characters;
                    entity = legacy[characters];
                }
            }
            terminated = value.charCodeAt(end) === semicolon;
            if (terminated) {
                end++;
                namedEntity = type === name ? decodeEntity(characters) : false;
                if (namedEntity) {
                    entityCharacters = characters;
                    entity = namedEntity;
                }
            }
            diff = 1 + end - start;
            if (!terminated && !nonTerminated) ;
            else if (!characters) // An empty (possible) entity is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== name) warning(numericEmpty, diff);
            } else if (type === name) {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !entity) warning(namedUnknown, 1);
                else {
                    // If theres something after an entity name which is not known, cap
                    // the reference.
                    if (entityCharacters !== characters) {
                        end = begin + entityCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        reason = entityCharacters ? namedNotTerminated : namedEmpty;
                        if (settings.attribute) {
                            following = value.charCodeAt(end);
                            if (following === equalsTo) {
                                warning(reason, diff);
                                entity = null;
                            } else if (alphanumerical(following)) entity = null;
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = entity;
            } else {
                if (!terminated) // All non-terminated numeric entities are not rendered, and trigger a
                // warning.
                warning(numericNotTerminated, diff);
                // When terminated and number, parse as either hexadecimal or decimal.
                reference = parseInt(characters, bases[type]);
                // Trigger a warning when the parsed number is prohibited, and replace
                // with replacement character.
                if (prohibited(reference)) {
                    warning(numericProhibited, diff);
                    reference = fromCharCode(replacementCharacter);
                } else if (reference in invalid) {
                    // Trigger a warning when the parsed number is disallowed, and replace
                    // by an alternative.
                    warning(numericDisallowed, diff);
                    reference = invalid[reference];
                } else {
                    // Parse the number.
                    output = '';
                    // Trigger a warning when the parsed number should not be used.
                    if (disallowed(reference)) warning(numericDisallowed, diff);
                    // Stringify the number.
                    if (reference > 0xffff) {
                        reference -= 0x10000;
                        output += fromCharCode(reference >>> 10 | 0xd800);
                        reference = 0xdc00 | reference & 0x3ff;
                    }
                    reference = output + fromCharCode(reference);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat an entity.
            if (reference) {
                flush();
                prev = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                next = now();
                next.offset++;
                if (handleReference) handleReference.call(referenceContext, reference, {
                    start: prev,
                    end: next
                }, value.slice(start - 1, end));
                prev = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 // Line feed
            ) {
                line++;
                lines++;
                column = 0;
            }
            if (character === character) {
                queue += fromCharCode(character);
                column++;
            } else flush();
        }
    }
    // Return the reduced nodes.
    return result.join('');
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + (pos.offset || 0)
        };
    }
    // “Throw” a parse-error: a warning.
    function parseError(code, offset) {
        var position = now();
        position.column += offset;
        position.offset += offset;
        handleWarning.call(warningContext, messages[code], position, code);
    }
    // Flush `queue` (normal text).
    // Macro invoked before each entity and at the end of `value`.
    // Does nothing when `queue` is empty.
    function flush() {
        if (queue) {
            result.push(queue);
            if (handleText) handleText.call(textContext, queue, {
                start: prev,
                end: now()
            });
            queue = '';
        }
    }
}
// Check if `character` is outside the permissible unicode range.
function prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
// Check if `character` is disallowed.
function disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}

},{"d167df7aadf55c55":"h8m0q","1607d1218b697c57":"6yNQZ","a79eb8234d1c118a":"e7NFI","49130e28d9fb85c3":"cdyZ5","d5d86fd6f6e87ed9":"hGM1H","5729f4b97642ca9d":"2FmxB"}],"h8m0q":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"AElig":"\xc6","AMP":"&","Aacute":"\xc1","Acirc":"\xc2","Agrave":"\xc0","Aring":"\xc5","Atilde":"\xc3","Auml":"\xc4","COPY":"\xa9","Ccedil":"\xc7","ETH":"\xd0","Eacute":"\xc9","Ecirc":"\xca","Egrave":"\xc8","Euml":"\xcb","GT":">","Iacute":"\xcd","Icirc":"\xce","Igrave":"\xcc","Iuml":"\xcf","LT":"<","Ntilde":"\xd1","Oacute":"\xd3","Ocirc":"\xd4","Ograve":"\xd2","Oslash":"\xd8","Otilde":"\xd5","Ouml":"\xd6","QUOT":"\\"","REG":"\xae","THORN":"\xde","Uacute":"\xda","Ucirc":"\xdb","Ugrave":"\xd9","Uuml":"\xdc","Yacute":"\xdd","aacute":"\xe1","acirc":"\xe2","acute":"\xb4","aelig":"\xe6","agrave":"\xe0","amp":"&","aring":"\xe5","atilde":"\xe3","auml":"\xe4","brvbar":"\xa6","ccedil":"\xe7","cedil":"\xb8","cent":"\xa2","copy":"\xa9","curren":"\xa4","deg":"\xb0","divide":"\xf7","eacute":"\xe9","ecirc":"\xea","egrave":"\xe8","eth":"\xf0","euml":"\xeb","frac12":"\xbd","frac14":"\xbc","frac34":"\xbe","gt":">","iacute":"\xed","icirc":"\xee","iexcl":"\xa1","igrave":"\xec","iquest":"\xbf","iuml":"\xef","laquo":"\xab","lt":"<","macr":"\xaf","micro":"\xb5","middot":"\xb7","nbsp":"\xa0","not":"\xac","ntilde":"\xf1","oacute":"\xf3","ocirc":"\xf4","ograve":"\xf2","ordf":"\xaa","ordm":"\xba","oslash":"\xf8","otilde":"\xf5","ouml":"\xf6","para":"\xb6","plusmn":"\xb1","pound":"\xa3","quot":"\\"","raquo":"\xbb","reg":"\xae","sect":"\xa7","shy":"\xad","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","szlig":"\xdf","thorn":"\xfe","times":"\xd7","uacute":"\xfa","ucirc":"\xfb","ugrave":"\xf9","uml":"\xa8","uuml":"\xfc","yacute":"\xfd","yen":"\xa5","yuml":"\xff"}');

},{}],"6yNQZ":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"0":"\uFFFD","128":"\u20AC","130":"\u201A","131":"\u0192","132":"\u201E","133":"\u2026","134":"\u2020","135":"\u2021","136":"\u02C6","137":"\u2030","138":"\u0160","139":"\u2039","140":"\u0152","142":"\u017D","145":"\u2018","146":"\u2019","147":"\u201C","148":"\u201D","149":"\u2022","150":"\u2013","151":"\u2014","152":"\u02DC","153":"\u2122","154":"\u0161","155":"\u203A","156":"\u0153","158":"\u017E","159":"\u0178"}');

},{}],"e7NFI":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = decimal;
// Check if the given character code, or the character code at the first
// character, is decimal.
function decimal(character) {
    var code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}

},{}],"cdyZ5":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = hexadecimal;
// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function hexadecimal(character) {
    var code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}

},{}],"hGM1H":[function(require,module,exports,__globalThis) {
'use strict';
var alphabetical = require("f4a1a485073a6196");
var decimal = require("46639e8bcd15391a");
module.exports = alphanumerical;
// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function alphanumerical(character) {
    return alphabetical(character) || decimal(character);
}

},{"f4a1a485073a6196":"dfs7g","46639e8bcd15391a":"e7NFI"}],"dfs7g":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = alphabetical;
// Check if the given character code, or the character code at the first
// character, is alphabetical.
function alphabetical(character) {
    var code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}

},{}],"2FmxB":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-env browser */ var el;
var semicolon = 59 //  ';'
;
module.exports = decodeEntity;
function decodeEntity(characters) {
    var entity = '&' + characters + ';';
    var char;
    el = el || document.createElement('i');
    el.innerHTML = entity;
    char = el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

},{}],"kiDOD":[function(require,module,exports,__globalThis) {
/// <reference lib="WebWorker"/>
var global = arguments[3];
var _self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === 'undefined') return null;
                if ('currentScript' in document && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}(_self);
if (0, module.exports) module.exports = Prism;
// hack for components to work correctly in node.js
if (typeof global !== 'undefined') global.Prism = Prism;
 // some additional documentation/types
 /**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */  /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */  /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */  /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ 

},{}],"hryt3":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = markup;
markup.displayName = 'markup';
markup.aliases = [
    'html',
    'mathml',
    'svg',
    'xml',
    'ssml',
    'atom',
    'rss'
];
function markup(Prism) {
    Prism.languages.markup = {
        comment: {
            pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
            greedy: true
        },
        prolog: {
            pattern: /<\?[\s\S]+?\?>/,
            greedy: true
        },
        doctype: {
            // https://www.w3.org/TR/xml/#NT-doctypedecl
            pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
            greedy: true,
            inside: {
                'internal-subset': {
                    pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                string: {
                    pattern: /"[^"]*"|'[^']*'/,
                    greedy: true
                },
                punctuation: /^<!|>$|[[\]]/,
                'doctype-tag': /^DOCTYPE/i,
                name: /[^\s<>'"]+/
            }
        },
        cdata: {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            greedy: true
        },
        tag: {
            pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
            greedy: true,
            inside: {
                tag: {
                    pattern: /^<\/?[^\s>\/]+/,
                    inside: {
                        punctuation: /^<\/?/,
                        namespace: /^[^\s>\/:]+:/
                    }
                },
                'special-attr': [],
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                    inside: {
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                },
                punctuation: /\/?>/,
                'attr-name': {
                    pattern: /[^\s>\/]+/,
                    inside: {
                        namespace: /^[^\s>\/:]+:/
                    }
                }
            }
        },
        entity: [
            {
                pattern: /&[\da-z]{1,8};/i,
                alias: 'named-entity'
            },
            /&#x?[\da-f]{1,8};/i
        ]
    };
    Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
    Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup // Plugin to make entity title show the real entity, idea by Roman Komarov
    ;
    Prism.hooks.add('wrap', function(env) {
        if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
        /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */ value: function addInlined(tagName, lang) {
            var includedCdataInside = {};
            includedCdataInside['language-' + lang] = {
                pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
                lookbehind: true,
                inside: Prism.languages[lang]
            };
            includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
            var inside = {
                'included-cdata': {
                    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                    inside: includedCdataInside
                }
            };
            inside['language-' + lang] = {
                pattern: /[\s\S]+/,
                inside: Prism.languages[lang]
            };
            var def = {};
            def[tagName] = {
                pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                    return tagName;
                }), 'i'),
                lookbehind: true,
                greedy: true,
                inside: inside
            };
            Prism.languages.insertBefore('markup', 'cdata', def);
        }
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
        /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */ value: function(attrName, lang) {
            Prism.languages.markup.tag.inside['special-attr'].push({
                pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
                lookbehind: true,
                inside: {
                    'attr-name': /^[^\s=]+/,
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            value: {
                                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                                lookbehind: true,
                                alias: [
                                    lang,
                                    'language-' + lang
                                ],
                                inside: Prism.languages[lang]
                            },
                            punctuation: [
                                {
                                    pattern: /^=/,
                                    alias: 'attr-equals'
                                },
                                /"|'/
                            ]
                        }
                    }
                }
            });
        }
    });
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.mathml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
    Prism.languages.xml = Prism.languages.extend('markup', {});
    Prism.languages.ssml = Prism.languages.xml;
    Prism.languages.atom = Prism.languages.xml;
    Prism.languages.rss = Prism.languages.xml;
}

},{}],"cNlCK":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = css;
css.displayName = 'css';
css.aliases = [];
function css(Prism) {
    (function(Prism) {
        var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
        Prism.languages.css = {
            comment: /\/\*[\s\S]*?\*\//,
            atrule: {
                pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
                inside: {
                    rule: /^@[\w-]+/,
                    'selector-function-argument': {
                        pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                        lookbehind: true,
                        alias: 'selector'
                    },
                    keyword: {
                        pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                        lookbehind: true
                    } // See rest below
                }
            },
            url: {
                // https://drafts.csswg.org/css-values-3/#urls
                pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
                greedy: true,
                inside: {
                    function: /^url/i,
                    punctuation: /^\(|\)$/,
                    string: {
                        pattern: RegExp('^' + string.source + '$'),
                        alias: 'url'
                    }
                }
            },
            selector: {
                pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
                lookbehind: true
            },
            string: {
                pattern: string,
                greedy: true
            },
            property: {
                pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
                lookbehind: true
            },
            important: /!important\b/i,
            function: {
                pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
                lookbehind: true
            },
            punctuation: /[(){};:,]/
        };
        Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
        var markup = Prism.languages.markup;
        if (markup) {
            markup.tag.addInlined('style', 'css');
            markup.tag.addAttribute('style', 'css');
        }
    })(Prism);
}

},{}],"lDjlE":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = clike;
clike.displayName = 'clike';
clike.aliases = [];
function clike(Prism) {
    Prism.languages.clike = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
            lookbehind: true,
            inside: {
                punctuation: /[.\\]/
            }
        },
        keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b\w+(?=\()/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
        punctuation: /[{}[\];(),.:]/
    };
}

},{}],"5w8do":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = javascript;
javascript.displayName = 'javascript';
javascript.aliases = [
    'js'
];
function javascript(Prism) {
    Prism.languages.javascript = Prism.languages.extend('clike', {
        'class-name': [
            Prism.languages.clike['class-name'],
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /((?:^|\})\s*)catch\b/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
                lookbehind: true
            }
        ],
        // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
        function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
        number: {
            pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
            (/NaN|Infinity/.source + '|' + // binary integer
            /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
            /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
            /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
            /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
            /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
            lookbehind: true
        },
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    });
    Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
    Prism.languages.insertBefore('javascript', 'keyword', {
        regex: {
            // eslint-disable-next-line regexp/no-dupe-characters-character-class
            pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
            lookbehind: true,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\/|\/$/,
                'regex-flags': /^[a-z]+$/
            }
        },
        // This must be declared before keyword because we use "function" inside the look-forward
        'function-variable': {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        },
        parameter: [
            {
                pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        ],
        constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    });
    Prism.languages.insertBefore('javascript', 'string', {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
        },
        'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.javascript
                    }
                },
                string: /[\s\S]+/
            }
        },
        'string-property': {
            pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        }
    });
    Prism.languages.insertBefore('javascript', 'operator', {
        'literal-property': {
            pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
            lookbehind: true,
            alias: 'property'
        }
    });
    if (Prism.languages.markup) {
        Prism.languages.markup.tag.addInlined('script', 'javascript') // add attribute support for all DOM events.
        ;
        // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
        Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
    }
    Prism.languages.js = Prism.languages.javascript;
}

},{}],"7sybo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = abap;
abap.displayName = 'abap';
abap.aliases = [];
function abap(Prism) {
    Prism.languages.abap = {
        comment: /^\*.*/m,
        string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'string-template': {
            pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
            lookbehind: true,
            alias: 'string'
        },
        /* End Of Line comments should not interfere with strings when the
quote character occurs within them. We assume a string being highlighted
inside an EOL comment is more acceptable than the opposite.
*/ 'eol-comment': {
            pattern: /(^|\s)".*/m,
            lookbehind: true,
            alias: 'comment'
        },
        keyword: {
            pattern: /(\s|\.|^)(?:SCIENTIFIC_WITH_LEADING_ZERO|SCALE_PRESERVING_SCIENTIFIC|RMC_COMMUNICATION_FAILURE|END-ENHANCEMENT-SECTION|MULTIPLY-CORRESPONDING|SUBTRACT-CORRESPONDING|VERIFICATION-MESSAGE|DIVIDE-CORRESPONDING|ENHANCEMENT-SECTION|CURRENCY_CONVERSION|RMC_SYSTEM_FAILURE|START-OF-SELECTION|MOVE-CORRESPONDING|RMC_INVALID_STATUS|CUSTOMER-FUNCTION|END-OF-DEFINITION|ENHANCEMENT-POINT|SYSTEM-EXCEPTIONS|ADD-CORRESPONDING|SCALE_PRESERVING|SELECTION-SCREEN|CURSOR-SELECTION|END-OF-SELECTION|LOAD-OF-PROGRAM|SCROLL-BOUNDARY|SELECTION-TABLE|EXCEPTION-TABLE|IMPLEMENTATIONS|PARAMETER-TABLE|RIGHT-JUSTIFIED|UNIT_CONVERSION|AUTHORITY-CHECK|LIST-PROCESSING|SIGN_AS_POSTFIX|COL_BACKGROUND|IMPLEMENTATION|INTERFACE-POOL|TRANSFORMATION|IDENTIFICATION|ENDENHANCEMENT|LINE-SELECTION|INITIALIZATION|LEFT-JUSTIFIED|SELECT-OPTIONS|SELECTION-SETS|COMMUNICATION|CORRESPONDING|DECIMAL_SHIFT|PRINT-CONTROL|VALUE-REQUEST|CHAIN-REQUEST|FUNCTION-POOL|FIELD-SYMBOLS|FUNCTIONALITY|INVERTED-DATE|SELECTION-SET|CLASS-METHODS|OUTPUT-LENGTH|CLASS-CODING|COL_NEGATIVE|ERRORMESSAGE|FIELD-GROUPS|HELP-REQUEST|NO-EXTENSION|NO-TOPOFPAGE|REDEFINITION|DISPLAY-MODE|ENDINTERFACE|EXIT-COMMAND|FIELD-SYMBOL|NO-SCROLLING|SHORTDUMP-ID|ACCESSPOLICY|CLASS-EVENTS|COL_POSITIVE|DECLARATIONS|ENHANCEMENTS|FILTER-TABLE|SWITCHSTATES|SYNTAX-CHECK|TRANSPORTING|ASYNCHRONOUS|SYNTAX-TRACE|TOKENIZATION|USER-COMMAND|WITH-HEADING|ABAP-SOURCE|BREAK-POINT|CHAIN-INPUT|COMPRESSION|FIXED-POINT|NEW-SECTION|NON-UNICODE|OCCURRENCES|RESPONSIBLE|SYSTEM-CALL|TRACE-TABLE|ABBREVIATED|CHAR-TO-HEX|END-OF-FILE|ENDFUNCTION|ENVIRONMENT|ASSOCIATION|COL_HEADING|EDITOR-CALL|END-OF-PAGE|ENGINEERING|IMPLEMENTED|INTENSIFIED|RADIOBUTTON|SYSTEM-EXIT|TOP-OF-PAGE|TRANSACTION|APPLICATION|CONCATENATE|DESTINATION|ENHANCEMENT|IMMEDIATELY|NO-GROUPING|PRECOMPILED|REPLACEMENT|TITLE-LINES|ACTIVATION|BYTE-ORDER|CLASS-POOL|CONNECTION|CONVERSION|DEFINITION|DEPARTMENT|EXPIRATION|INHERITING|MESSAGE-ID|NO-HEADING|PERFORMING|QUEUE-ONLY|RIGHTSPACE|SCIENTIFIC|STATUSINFO|STRUCTURES|SYNCPOINTS|WITH-TITLE|ATTRIBUTES|BOUNDARIES|CLASS-DATA|COL_NORMAL|DD\/MM\/YYYY|DESCENDING|INTERFACES|LINE-COUNT|MM\/DD\/YYYY|NON-UNIQUE|PRESERVING|SELECTIONS|STATEMENTS|SUBROUTINE|TRUNCATION|TYPE-POOLS|ARITHMETIC|BACKGROUND|ENDPROVIDE|EXCEPTIONS|IDENTIFIER|INDEX-LINE|OBLIGATORY|PARAMETERS|PERCENTAGE|PUSHBUTTON|RESOLUTION|COMPONENTS|DEALLOCATE|DISCONNECT|DUPLICATES|FIRST-LINE|HEAD-LINES|NO-DISPLAY|OCCURRENCE|RESPECTING|RETURNCODE|SUBMATCHES|TRACE-FILE|ASCENDING|BYPASSING|ENDMODULE|EXCEPTION|EXCLUDING|EXPORTING|INCREMENT|MATCHCODE|PARAMETER|PARTIALLY|PREFERRED|REFERENCE|REPLACING|RETURNING|SELECTION|SEPARATED|SPECIFIED|STATEMENT|TIMESTAMP|TYPE-POOL|ACCEPTING|APPENDAGE|ASSIGNING|COL_GROUP|COMPARING|CONSTANTS|DANGEROUS|IMPORTING|INSTANCES|LEFTSPACE|LOG-POINT|QUICKINFO|READ-ONLY|SCROLLING|SQLSCRIPT|STEP-LOOP|TOP-LINES|TRANSLATE|APPENDING|AUTHORITY|CHARACTER|COMPONENT|CONDITION|DIRECTORY|DUPLICATE|MESSAGING|RECEIVING|SUBSCREEN|ACCORDING|COL_TOTAL|END-LINES|ENDMETHOD|ENDSELECT|EXPANDING|EXTENSION|INCLUDING|INFOTYPES|INTERFACE|INTERVALS|LINE-SIZE|PF-STATUS|PROCEDURE|PROTECTED|REQUESTED|RESUMABLE|RIGHTPLUS|SAP-SPOOL|SECONDARY|STRUCTURE|SUBSTRING|TABLEVIEW|NUMOFCHAR|ADJACENT|ANALYSIS|ASSIGNED|BACKWARD|CHANNELS|CHECKBOX|CONTINUE|CRITICAL|DATAINFO|DD\/MM\/YY|DURATION|ENCODING|ENDCLASS|FUNCTION|LEFTPLUS|LINEFEED|MM\/DD\/YY|OVERFLOW|RECEIVED|SKIPPING|SORTABLE|STANDARD|SUBTRACT|SUPPRESS|TABSTRIP|TITLEBAR|TRUNCATE|UNASSIGN|WHENEVER|ANALYZER|COALESCE|COMMENTS|CONDENSE|DECIMALS|DEFERRED|ENDWHILE|EXPLICIT|KEYWORDS|MESSAGES|POSITION|PRIORITY|RECEIVER|RENAMING|TIMEZONE|TRAILING|ALLOCATE|CENTERED|CIRCULAR|CONTROLS|CURRENCY|DELETING|DESCRIBE|DISTANCE|ENDCATCH|EXPONENT|EXTENDED|GENERATE|IGNORING|INCLUDES|INTERNAL|MAJOR-ID|MODIFIER|NEW-LINE|OPTIONAL|PROPERTY|ROLLBACK|STARTING|SUPPLIED|ABSTRACT|CHANGING|CONTEXTS|CREATING|CUSTOMER|DATABASE|DAYLIGHT|DEFINING|DISTINCT|DIVISION|ENABLING|ENDCHAIN|ESCAPING|HARMLESS|IMPLICIT|INACTIVE|LANGUAGE|MINOR-ID|MULTIPLY|NEW-PAGE|NO-TITLE|POS_HIGH|SEPARATE|TEXTPOOL|TRANSFER|SELECTOR|DBMAXLEN|ITERATOR|ARCHIVE|BIT-XOR|BYTE-CO|COLLECT|COMMENT|CURRENT|DEFAULT|DISPLAY|ENDFORM|EXTRACT|LEADING|LISTBOX|LOCATOR|MEMBERS|METHODS|NESTING|POS_LOW|PROCESS|PROVIDE|RAISING|RESERVE|SECONDS|SUMMARY|VISIBLE|BETWEEN|BIT-AND|BYTE-CS|CLEANUP|COMPUTE|CONTROL|CONVERT|DATASET|ENDCASE|FORWARD|HEADERS|HOTSPOT|INCLUDE|INVERSE|KEEPING|NO-ZERO|OBJECTS|OVERLAY|PADDING|PATTERN|PROGRAM|REFRESH|SECTION|SUMMING|TESTING|VERSION|WINDOWS|WITHOUT|BIT-NOT|BYTE-CA|BYTE-NA|CASTING|CONTEXT|COUNTRY|DYNAMIC|ENABLED|ENDLOOP|EXECUTE|FRIENDS|HANDLER|HEADING|INITIAL|\*-INPUT|LOGFILE|MAXIMUM|MINIMUM|NO-GAPS|NO-SIGN|PRAGMAS|PRIMARY|PRIVATE|REDUCED|REPLACE|REQUEST|RESULTS|UNICODE|WARNING|ALIASES|BYTE-CN|BYTE-NS|CALLING|COL_KEY|COLUMNS|CONNECT|ENDEXEC|ENTRIES|EXCLUDE|FILTERS|FURTHER|HELP-ID|LOGICAL|MAPPING|MESSAGE|NAMETAB|OPTIONS|PACKAGE|PERFORM|RECEIVE|STATICS|VARYING|BINDING|CHARLEN|GREATER|XSTRLEN|ACCEPT|APPEND|DETAIL|ELSEIF|ENDING|ENDTRY|FORMAT|FRAMES|GIVING|HASHED|HEADER|IMPORT|INSERT|MARGIN|MODULE|NATIVE|OBJECT|OFFSET|REMOTE|RESUME|SAVING|SIMPLE|SUBMIT|TABBED|TOKENS|UNIQUE|UNPACK|UPDATE|WINDOW|YELLOW|ACTUAL|ASPECT|CENTER|CURSOR|DELETE|DIALOG|DIVIDE|DURING|ERRORS|EVENTS|EXTEND|FILTER|HANDLE|HAVING|IGNORE|LITTLE|MEMORY|NO-GAP|OCCURS|OPTION|PERSON|PLACES|PUBLIC|REDUCE|REPORT|RESULT|SINGLE|SORTED|SWITCH|SYNTAX|TARGET|VALUES|WRITER|ASSERT|BLOCKS|BOUNDS|BUFFER|CHANGE|COLUMN|COMMIT|CONCAT|COPIES|CREATE|DDMMYY|DEFINE|ENDIAN|ESCAPE|EXPAND|KERNEL|LAYOUT|LEGACY|LEVELS|MMDDYY|NUMBER|OUTPUT|RANGES|READER|RETURN|SCREEN|SEARCH|SELECT|SHARED|SOURCE|STABLE|STATIC|SUBKEY|SUFFIX|TABLES|UNWIND|YYMMDD|ASSIGN|BACKUP|BEFORE|BINARY|BIT-OR|BLANKS|CLIENT|CODING|COMMON|DEMAND|DYNPRO|EXCEPT|EXISTS|EXPORT|FIELDS|GLOBAL|GROUPS|LENGTH|LOCALE|MEDIUM|METHOD|MODIFY|NESTED|OTHERS|REJECT|SCROLL|SUPPLY|SYMBOL|ENDFOR|STRLEN|ALIGN|BEGIN|BOUND|ENDAT|ENTRY|EVENT|FINAL|FLUSH|GRANT|INNER|SHORT|USING|WRITE|AFTER|BLACK|BLOCK|CLOCK|COLOR|COUNT|DUMMY|EMPTY|ENDDO|ENDON|GREEN|INDEX|INOUT|LEAVE|LEVEL|LINES|MODIF|ORDER|OUTER|RANGE|RESET|RETRY|RIGHT|SMART|SPLIT|STYLE|TABLE|THROW|UNDER|UNTIL|UPPER|UTF-8|WHERE|ALIAS|BLANK|CLEAR|CLOSE|EXACT|FETCH|FIRST|FOUND|GROUP|LLANG|LOCAL|OTHER|REGEX|SPOOL|TITLE|TYPES|VALID|WHILE|ALPHA|BOXED|CATCH|CHAIN|CHECK|CLASS|COVER|ENDIF|EQUIV|FIELD|FLOOR|FRAME|INPUT|LOWER|MATCH|NODES|PAGES|PRINT|RAISE|ROUND|SHIFT|SPACE|SPOTS|STAMP|STATE|TASKS|TIMES|TRMAC|ULINE|UNION|VALUE|WIDTH|EQUAL|LOG10|TRUNC|BLOB|CASE|CEIL|CLOB|COND|EXIT|FILE|GAPS|HOLD|INCL|INTO|KEEP|KEYS|LAST|LINE|LONG|LPAD|MAIL|MODE|OPEN|PINK|READ|ROWS|TEST|THEN|ZERO|AREA|BACK|BADI|BYTE|CAST|EDIT|EXEC|FAIL|FIND|FKEQ|FONT|FREE|GKEQ|HIDE|INIT|ITNO|LATE|LOOP|MAIN|MARK|MOVE|NEXT|NULL|RISK|ROLE|UNIT|WAIT|ZONE|BASE|CALL|CODE|DATA|DATE|FKGE|GKGE|HIGH|KIND|LEFT|LIST|MASK|MESH|NAME|NODE|PACK|PAGE|POOL|SEND|SIGN|SIZE|SOME|STOP|TASK|TEXT|TIME|USER|VARY|WITH|WORD|BLUE|CONV|COPY|DEEP|ELSE|FORM|FROM|HINT|ICON|JOIN|LIKE|LOAD|ONLY|PART|SCAN|SKIP|SORT|TYPE|UNIX|VIEW|WHEN|WORK|ACOS|ASIN|ATAN|COSH|EACH|FRAC|LESS|RTTI|SINH|SQRT|TANH|AVG|BIT|DIV|ISO|LET|OUT|PAD|SQL|ALL|CI_|CPI|END|LOB|LPI|MAX|MIN|NEW|OLE|RUN|SET|\?TO|YES|ABS|ADD|AND|BIG|FOR|HDB|JOB|LOW|NOT|SAP|TRY|VIA|XML|ANY|GET|IDS|KEY|MOD|OFF|PUT|RAW|RED|REF|SUM|TAB|XSD|CNT|COS|EXP|LOG|SIN|TAN|XOR|AT|CO|CP|DO|GT|ID|IF|NS|OR|BT|CA|CS|GE|NA|NB|EQ|IN|LT|NE|NO|OF|ON|PF|TO|AS|BY|CN|IS|LE|NP|UP|E|I|M|O|Z|C|X)\b/i,
            lookbehind: true
        },
        /* Numbers can be only integers. Decimal or Hex appear only as strings */ number: /\b\d+\b/,
        /* Operators must always be surrounded by whitespace, they cannot be put
adjacent to operands.
*/ operator: {
            pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
            lookbehind: true
        },
        'string-operator': {
            pattern: /(\s)&&?(?=\s)/,
            lookbehind: true,
            /* The official editor highlights */ alias: 'keyword'
        },
        'token-operator': [
            {
                /* Special operators used to access structure components, class methods/attributes, etc. */ pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            {
                /* Special tokens used do delimit string templates */ pattern: /[|{}]/,
                alias: 'punctuation'
            }
        ],
        punctuation: /[,.:()]/
    };
}

},{}],"4Bwqj":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = abnf;
abnf.displayName = 'abnf';
abnf.aliases = [];
function abnf(Prism) {
    (function(Prism) {
        var coreRules = '(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)';
        Prism.languages.abnf = {
            comment: /;.*/,
            string: {
                pattern: /(?:%[is])?"[^"\n\r]*"/,
                greedy: true,
                inside: {
                    punctuation: /^%[is]/
                }
            },
            range: {
                pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
                alias: 'number'
            },
            terminal: {
                pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
                alias: 'number'
            },
            repetition: {
                pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
                lookbehind: true,
                alias: 'operator'
            },
            definition: {
                pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
                lookbehind: true,
                alias: 'keyword',
                inside: {
                    punctuation: /<|>/
                }
            },
            'core-rule': {
                pattern: RegExp('(?:(^|[^<\\w-])' + coreRules + '|<' + coreRules + '>)(?![\\w-])', 'i'),
                lookbehind: true,
                alias: [
                    'rule',
                    'constant'
                ],
                inside: {
                    punctuation: /<|>/
                }
            },
            rule: {
                pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
                lookbehind: true,
                inside: {
                    punctuation: /<|>/
                }
            },
            operator: /=\/?|\//,
            punctuation: /[()\[\]]/
        };
    })(Prism);
}

},{}],"hEeqf":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = actionscript;
actionscript.displayName = 'actionscript';
actionscript.aliases = [];
function actionscript(Prism) {
    Prism.languages.actionscript = Prism.languages.extend('javascript', {
        keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
        operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
    });
    Prism.languages.actionscript['class-name'].alias = 'function' // doesn't work with AS because AS is too complex
    ;
    delete Prism.languages.actionscript['parameter'];
    delete Prism.languages.actionscript['literal-property'];
    if (Prism.languages.markup) Prism.languages.insertBefore('actionscript', 'string', {
        xml: {
            pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
            lookbehind: true,
            inside: Prism.languages.markup
        }
    });
}

},{}],"4I9qM":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = ada;
ada.displayName = 'ada';
ada.aliases = [];
function ada(Prism) {
    Prism.languages.ada = {
        comment: /--.*/,
        string: /"(?:""|[^"\r\f\n])*"/,
        number: [
            {
                pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
            },
            {
                pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
            }
        ],
        'attr-name': /\b'\w+/,
        keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
        boolean: /\b(?:false|true)\b/i,
        operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
        punctuation: /\.\.?|[,;():]/,
        char: /'.'/,
        variable: /\b[a-z](?:\w)*\b/i
    };
}

},{}],"5f5O3":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = agda;
agda.displayName = 'agda';
agda.aliases = [];
function agda(Prism) {
    (function(Prism) {
        Prism.languages.agda = {
            comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
            string: {
                pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
                greedy: true
            },
            punctuation: /[(){}⦃⦄.;@]/,
            'class-name': {
                pattern: /((?:data|record) +)\S+/,
                lookbehind: true
            },
            function: {
                pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
                lookbehind: true
            },
            operator: {
                pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
                lookbehind: true
            },
            keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
        };
    })(Prism);
}

},{}],"598Qu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = al;
al.displayName = 'al';
al.aliases = [];
function al(Prism) {
    // based on https://github.com/microsoft/AL/blob/master/grammar/alsyntax.tmlanguage
    Prism.languages.al = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        function: {
            pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
            lookbehind: true
        },
        keyword: [
            // keywords
            /\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i,
            /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i
        ],
        number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
        boolean: /\b(?:false|true)\b/i,
        variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
        'class-name': /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
        operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
        punctuation: /[()\[\]{}:.;,]/
    };
}

},{}],"dijLo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = antlr4;
antlr4.displayName = 'antlr4';
antlr4.aliases = [
    'g4'
];
function antlr4(Prism) {
    Prism.languages.antlr4 = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        string: {
            pattern: /'(?:\\.|[^\\'\r\n])*'/,
            greedy: true
        },
        'character-class': {
            pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
            greedy: true,
            alias: 'regex',
            inside: {
                range: {
                    pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
                    lookbehind: true,
                    alias: 'punctuation'
                },
                escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
                punctuation: /[\[\]]/
            }
        },
        action: {
            pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
            greedy: true,
            inside: {
                content: {
                    // this might be C, C++, Python, Java, C#, or any other language ANTLR4 compiles to
                    pattern: /(\{)[\s\S]+(?=\})/,
                    lookbehind: true
                },
                punctuation: /[{}]/
            }
        },
        command: {
            pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
            lookbehind: true,
            inside: {
                function: /\b\w+(?=\s*(?:[,(]|$))/,
                punctuation: /[,()]/
            }
        },
        annotation: {
            pattern: /@\w+(?:::\w+)*/,
            alias: 'keyword'
        },
        label: {
            pattern: /#[ \t]*\w+/,
            alias: 'punctuation'
        },
        keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
        definition: [
            {
                pattern: /\b[a-z]\w*(?=\s*:)/,
                alias: [
                    'rule',
                    'class-name'
                ]
            },
            {
                pattern: /\b[A-Z]\w*(?=\s*:)/,
                alias: [
                    'token',
                    'constant'
                ]
            }
        ],
        constant: /\b[A-Z][A-Z_]*\b/,
        operator: /\.\.|->|[|~]|[*+?]\??/,
        punctuation: /[;:()=]/
    };
    Prism.languages.g4 = Prism.languages.antlr4;
}

},{}],"hlWp7":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = apacheconf;
apacheconf.displayName = 'apacheconf';
apacheconf.aliases = [];
function apacheconf(Prism) {
    Prism.languages.apacheconf = {
        comment: /#.*/,
        'directive-inline': {
            pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
            lookbehind: true,
            alias: 'property'
        },
        'directive-block': {
            pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
            inside: {
                'directive-block': {
                    pattern: /^<\/?\w+/,
                    inside: {
                        punctuation: /^<\/?/
                    },
                    alias: 'tag'
                },
                'directive-block-parameter': {
                    pattern: /.*[^>]/,
                    inside: {
                        punctuation: /:/,
                        string: {
                            pattern: /("|').*\1/,
                            inside: {
                                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
                            }
                        }
                    },
                    alias: 'attr-value'
                },
                punctuation: />/
            },
            alias: 'tag'
        },
        'directive-flags': {
            pattern: /\[(?:[\w=],?)+\]/,
            alias: 'keyword'
        },
        string: {
            pattern: /("|').*\1/,
            inside: {
                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
            }
        },
        variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
        regex: /\^?.*\$|\^.*\$?/
    };
}

},{}],"2NCxF":[function(require,module,exports,__globalThis) {
'use strict';
var refractorSql = require("a1ca04332d53abb5");
module.exports = apex;
apex.displayName = 'apex';
apex.aliases = [];
function apex(Prism) {
    Prism.register(refractorSql);
    (function(Prism) {
        var keywords = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i;
        var className = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(/<keyword>/g, function() {
            return keywords.source;
        });
        /** @param {string} pattern */ function insertClassName(pattern) {
            return RegExp(pattern.replace(/<CLASS-NAME>/g, function() {
                return className;
            }), 'i');
        }
        var classNameInside = {
            keyword: keywords,
            punctuation: /[()\[\]{};,:.<>]/
        };
        Prism.languages.apex = {
            comment: Prism.languages.clike.comment,
            string: Prism.languages.clike.string,
            sql: {
                pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
                lookbehind: true,
                greedy: true,
                alias: 'language-sql',
                inside: Prism.languages.sql
            },
            annotation: {
                pattern: /@\w+\b/,
                alias: 'punctuation'
            },
            'class-name': [
                {
                    pattern: insertClassName(/(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // cast
                    pattern: insertClassName(/(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // variable/parameter declaration and return types
                    pattern: insertClassName(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
                    inside: classNameInside
                }
            ],
            trigger: {
                pattern: /(\btrigger\s+)\w+\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            keyword: keywords,
            function: /\b[a-z_]\w*(?=\s*\()/i,
            boolean: /\b(?:false|true)\b/i,
            number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
            operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
            punctuation: /[()\[\]{};,.]/
        };
    })(Prism);
}

},{"a1ca04332d53abb5":"g6Eid"}],"g6Eid":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = sql;
sql.displayName = 'sql';
sql.aliases = [];
function sql(Prism) {
    Prism.languages.sql = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
            lookbehind: true
        },
        variable: [
            {
                pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
                greedy: true
            },
            /@[\w.$]+/
        ],
        string: {
            pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
            greedy: true,
            lookbehind: true
        },
        identifier: {
            pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
            greedy: true,
            lookbehind: true,
            inside: {
                punctuation: /^`|`$/
            }
        },
        function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
        // Should we highlight user defined functions too?
        keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
        punctuation: /[;[\]()`,.]/
    };
}

},{}],"hjI97":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = apl;
apl.displayName = 'apl';
apl.aliases = [];
function apl(Prism) {
    Prism.languages.apl = {
        comment: /(?:⍝|#[! ]).*$/m,
        string: {
            pattern: /'(?:[^'\r\n]|'')*'/,
            greedy: true
        },
        number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
        statement: /:[A-Z][a-z][A-Za-z]*\b/,
        'system-function': {
            pattern: /⎕[A-Z]+/i,
            alias: 'function'
        },
        constant: /[⍬⌾#⎕⍞]/,
        function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
        'monadic-operator': {
            pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
            alias: 'operator'
        },
        'dyadic-operator': {
            pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
            alias: 'operator'
        },
        assignment: {
            pattern: /←/,
            alias: 'keyword'
        },
        punctuation: /[\[;\]()◇⋄]/,
        dfn: {
            pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
            alias: 'builtin'
        }
    };
}

},{}],"jcDwP":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = applescript;
applescript.displayName = 'applescript';
applescript.aliases = [];
function applescript(Prism) {
    Prism.languages.applescript = {
        comment: [
            // Allow one level of nesting
            /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
            /--.+/,
            /#.+/
        ],
        string: /"(?:\\.|[^"\\\r\n])*"/,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
        operator: [
            /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
            /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/
        ],
        keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
        'class-name': /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
        punctuation: /[{}():,¬«»《》]/
    };
}

},{}],"knZ7Z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = aql;
aql.displayName = 'aql';
aql.aliases = [];
function aql(Prism) {
    Prism.languages.aql = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        property: {
            pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        variable: /@@?\w+/,
        keyword: [
            {
                pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
                lookbehind: true
            },
            /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i,
            {
                pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
                lookbehind: true
            },
            {
                pattern: /\bOPTIONS(?=\s*\{)/i
            }
        ],
        function: /\b(?!\d)\w+(?=\s*\()/,
        boolean: /\b(?:false|true)\b/i,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        number: [
            /\b0b[01]+/i,
            /\b0x[0-9a-f]+/i,
            /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i
        ],
        operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
        punctuation: /::|[?.:,;()[\]{}]/
    };
}

},{}],"eeV1f":[function(require,module,exports,__globalThis) {
'use strict';
var refractorCpp = require("e1101ad043dc5aa5");
module.exports = arduino;
arduino.displayName = 'arduino';
arduino.aliases = [
    'ino'
];
function arduino(Prism) {
    Prism.register(refractorCpp);
    Prism.languages.arduino = Prism.languages.extend('cpp', {
        keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
        constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
        builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
    });
    Prism.languages.ino = Prism.languages.arduino;
}

},{"e1101ad043dc5aa5":"brS7J"}],"brS7J":[function(require,module,exports,__globalThis) {
'use strict';
var refractorC = require("c4e344d12f9875e3");
module.exports = cpp;
cpp.displayName = 'cpp';
cpp.aliases = [];
function cpp(Prism) {
    Prism.register(refractorC);
    (function(Prism) {
        var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
        var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
            return keyword.source;
        });
        Prism.languages.cpp = Prism.languages.extend('c', {
            'class-name': [
                {
                    pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                        return keyword.source;
                    })),
                    lookbehind: true
                },
                //   void foo::bar() const {}
                // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
                // it starts with an uppercase letter. This approximation should give decent results.
                /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
                //   Foo::~Foo() {}
                /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
                // parameters, so it can't be a namespace (until C++ adds generic namespaces).
                /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
            ],
            keyword: keyword,
            number: {
                pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
                greedy: true
            },
            operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
            boolean: /\b(?:false|true)\b/
        });
        Prism.languages.insertBefore('cpp', 'string', {
            module: {
                // https://en.cppreference.com/w/cpp/language/modules
                pattern: RegExp(/(\b(?:import|module)\s+)/.source + '(?:' + // header-name
                /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + '|' + // module name or partition or both
                /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                    return modName;
                }) + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    string: /^[<"][\s\S]+/,
                    operator: /:/,
                    punctuation: /\./
                }
            },
            'raw-string': {
                pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
                alias: 'string',
                greedy: true
            }
        });
        Prism.languages.insertBefore('cpp', 'keyword', {
            'generic-function': {
                pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        alias: 'class-name',
                        inside: Prism.languages.cpp
                    }
                }
            }
        });
        Prism.languages.insertBefore('cpp', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('cpp', 'class-name', {
            // the base clause is an optional list of parent classes
            // https://en.cppreference.com/w/cpp/language/class
            'base-clause': {
                pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: Prism.languages.extend('cpp', {})
            }
        });
        Prism.languages.insertBefore('inside', 'double-colon', {
            // All untokenized words that are not namespaces should be class names
            'class-name': /\b[a-z_]\w*\b(?!\s*::)/i
        }, Prism.languages.cpp['base-clause']);
    })(Prism);
}

},{"c4e344d12f9875e3":"eMUEZ"}],"eMUEZ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = c;
c.displayName = 'c';
c.aliases = [];
function c(Prism) {
    Prism.languages.c = Prism.languages.extend('clike', {
        comment: {
            pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        string: {
            // https://en.cppreference.com/w/c/language/string_literal
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
            lookbehind: true
        },
        keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
        operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
    });
    Prism.languages.insertBefore('c', 'string', {
        char: {
            // https://en.cppreference.com/w/c/language/character_constant
            pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('c', 'string', {
        macro: {
            // allow for multiline macro definitions
            // spaces after the # character compile fine with gcc
            pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                string: [
                    {
                        // highlight the path of the include statement as a string
                        pattern: /^(#\s*include\s*)<[^>]+>/,
                        lookbehind: true
                    },
                    Prism.languages.c['string']
                ],
                char: Prism.languages.c['char'],
                comment: Prism.languages.c['comment'],
                'macro-name': [
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                        lookbehind: true
                    },
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                        lookbehind: true,
                        alias: 'function'
                    }
                ],
                // highlight macro directives as keywords
                directive: {
                    pattern: /^(#\s*)[a-z]+/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                'directive-hash': /^#/,
                punctuation: /##|\\(?=[\r\n])/,
                expression: {
                    pattern: /\S[\s\S]*/,
                    inside: Prism.languages.c
                }
            }
        }
    });
    Prism.languages.insertBefore('c', 'function', {
        // highlight predefined macros as constants
        constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
    });
    delete Prism.languages.c['boolean'];
}

},{}],"aLttD":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = arff;
arff.displayName = 'arff';
arff.aliases = [];
function arff(Prism) {
    Prism.languages.arff = {
        comment: /%.*/,
        string: {
            pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /@(?:attribute|data|end|relation)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        punctuation: /[{},]/
    };
}

},{}],"5YH5I":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = asciidoc;
asciidoc.displayName = 'asciidoc';
asciidoc.aliases = [
    'adoc'
];
function asciidoc(Prism) {
    (function(Prism) {
        var attributes = {
            pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
            lookbehind: true,
            inside: {
                quoted: {
                    pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
                    inside: {
                        punctuation: /^[$`]|[$`]$/
                    }
                },
                interpreted: {
                    pattern: /'(?:[^'\\]|\\.)*'/,
                    inside: {
                        punctuation: /^'|'$/ // See rest below
                    }
                },
                string: /"(?:[^"\\]|\\.)*"/,
                variable: /\w+(?==)/,
                punctuation: /^\[|\]$|,/,
                operator: /=/,
                // The negative look-ahead prevents blank matches
                'attr-value': /(?!^\s+$).+/
            }
        };
        var asciidoc = Prism.languages.asciidoc = {
            'comment-block': {
                pattern: /^(\/{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1/m,
                alias: 'comment'
            },
            table: {
                pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
                inside: {
                    specifiers: {
                        pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
                        alias: 'attr-value'
                    },
                    punctuation: {
                        pattern: /(^|[^\\])[|!]=*/,
                        lookbehind: true
                    } // See rest below
                }
            },
            'passthrough-block': {
                pattern: /^(\+{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
                inside: {
                    punctuation: /^\++|\++$/ // See rest below
                }
            },
            // Literal blocks and listing blocks
            'literal-block': {
                pattern: /^(-{4,}|\.{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
                inside: {
                    punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/ // See rest below
                }
            },
            // Sidebar blocks, quote blocks, example blocks and open blocks
            'other-block': {
                pattern: /^(--|\*{4,}|_{4,}|={4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
                inside: {
                    punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/ // See rest below
                }
            },
            // list-punctuation and list-label must appear before indented-block
            'list-punctuation': {
                pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
                lookbehind: true,
                alias: 'punctuation'
            },
            'list-label': {
                pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
                lookbehind: true,
                alias: 'symbol'
            },
            'indented-block': {
                pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
                lookbehind: true
            },
            comment: /^\/\/.*/m,
            title: {
                pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
                alias: 'important',
                inside: {
                    punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/ // See rest below
                }
            },
            'attribute-entry': {
                pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
                alias: 'tag'
            },
            attributes: attributes,
            hr: {
                pattern: /^'{3,}$/m,
                alias: 'punctuation'
            },
            'page-break': {
                pattern: /^<{3,}$/m,
                alias: 'punctuation'
            },
            admonition: {
                pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
                alias: 'keyword'
            },
            callout: [
                {
                    pattern: /(^[ \t]*)<?\d*>/m,
                    lookbehind: true,
                    alias: 'symbol'
                },
                {
                    pattern: /<\d+>/,
                    alias: 'symbol'
                }
            ],
            macro: {
                pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                inside: {
                    function: /^[a-z\d-]+(?=:)/,
                    punctuation: /^::?/,
                    attributes: {
                        pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                        inside: attributes.inside
                    }
                }
            },
            inline: {
                /*
The initial look-behind prevents the highlighting of escaped quoted text.
Quoted text can be multi-line but cannot span an empty line.
All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
First, we handle the constrained quotes.
Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
Then we handle the unconstrained quotes.
Those do not have the restrictions of the constrained quotes.
They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
*/ pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
                lookbehind: true,
                inside: {
                    attributes: attributes,
                    url: {
                        pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
                        inside: {
                            punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
                        }
                    },
                    'attribute-ref': {
                        pattern: /^\{.+\}$/,
                        inside: {
                            variable: {
                                pattern: /(^\{)[a-z\d,+_-]+/,
                                lookbehind: true
                            },
                            operator: /^[=?!#%@$]|!(?=[:}])/,
                            punctuation: /^\{|\}$|::?/
                        }
                    },
                    italic: {
                        pattern: /^(['_])[\s\S]+\1$/,
                        inside: {
                            punctuation: /^(?:''?|__?)|(?:''?|__?)$/
                        }
                    },
                    bold: {
                        pattern: /^\*[\s\S]+\*$/,
                        inside: {
                            punctuation: /^\*\*?|\*\*?$/
                        }
                    },
                    punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
                }
            },
            replacement: {
                pattern: /\((?:C|R|TM)\)/,
                alias: 'builtin'
            },
            entity: /&#?[\da-z]{1,8};/i,
            'line-continuation': {
                pattern: /(^| )\+$/m,
                lookbehind: true,
                alias: 'punctuation'
            }
        } // Allow some nesting. There is no recursion though, so cloning should not be needed.
        ;
        function copyFromAsciiDoc(keys) {
            keys = keys.split(' ');
            var o = {};
            for(var i = 0, l = keys.length; i < l; i++)o[keys[i]] = asciidoc[keys[i]];
            return o;
        }
        attributes.inside['interpreted'].inside.rest = copyFromAsciiDoc('macro inline replacement entity');
        asciidoc['passthrough-block'].inside.rest = copyFromAsciiDoc('macro');
        asciidoc['literal-block'].inside.rest = copyFromAsciiDoc('callout');
        asciidoc['table'].inside.rest = copyFromAsciiDoc('comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation');
        asciidoc['other-block'].inside.rest = copyFromAsciiDoc('table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation');
        asciidoc['title'].inside.rest = copyFromAsciiDoc('macro inline replacement entity') // Plugin to make entity title show the real entity, idea by Roman Komarov
        ;
        Prism.hooks.add('wrap', function(env) {
            if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
        });
        Prism.languages.adoc = Prism.languages.asciidoc;
    })(Prism);
}

},{}],"cCsrb":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = asm6502;
asm6502.displayName = 'asm6502';
asm6502.aliases = [];
function asm6502(Prism) {
    Prism.languages.asm6502 = {
        comment: /;.*/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'op-code': {
            pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{1,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[xya]\b/i,
            alias: 'variable'
        },
        punctuation: /[(),:]/
    };
}

},{}],"cNjzr":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = asmatmel;
asmatmel.displayName = 'asmatmel';
asmatmel.aliases = [];
function asmatmel(Prism) {
    Prism.languages.asmatmel = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        'r-register': {
            pattern: /\br(?:\d|[12]\d|3[01])\b/,
            alias: 'variable'
        },
        'op-code': {
            pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{2,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[acznvshtixy]\b/i,
            alias: 'variable'
        },
        operator: />>=?|<<=?|&&?|\|\|?|[-+*/%&|^!=<>?]=?/,
        punctuation: /[(),:]/
    };
}

},{}],"3Ojkm":[function(require,module,exports,__globalThis) {
'use strict';
var refractorCsharp = require("42044b41f4dcda3a");
module.exports = aspnet;
aspnet.displayName = 'aspnet';
aspnet.aliases = [];
function aspnet(Prism) {
    Prism.register(refractorCsharp);
    Prism.languages.aspnet = Prism.languages.extend('markup', {
        'page-directive': {
            pattern: /<%\s*@.*%>/,
            alias: 'tag',
            inside: {
                'page-directive': {
                    pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
                    alias: 'tag'
                },
                rest: Prism.languages.markup.tag.inside
            }
        },
        directive: {
            pattern: /<%.*%>/,
            alias: 'tag',
            inside: {
                directive: {
                    pattern: /<%\s*?[$=%#:]{0,2}|%>/,
                    alias: 'tag'
                },
                rest: Prism.languages.csharp
            }
        }
    }) // Regexp copied from prism-markup, with a negative look-ahead added
    ;
    Prism.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/ // match directives of attribute value foo="<% Bar %>"
    ;
    Prism.languages.insertBefore('inside', 'punctuation', {
        directive: Prism.languages.aspnet['directive']
    }, Prism.languages.aspnet.tag.inside['attr-value']);
    Prism.languages.insertBefore('aspnet', 'comment', {
        'asp-comment': {
            pattern: /<%--[\s\S]*?--%>/,
            alias: [
                'asp',
                'comment'
            ]
        }
    }) // script runat="server" contains csharp, not javascript
    ;
    Prism.languages.insertBefore('aspnet', Prism.languages.javascript ? 'script' : 'tag', {
        'asp-script': {
            pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
            lookbehind: true,
            alias: [
                'asp',
                'script'
            ],
            inside: Prism.languages.csharp || {}
        }
    });
}

},{"42044b41f4dcda3a":"buy6I"}],"buy6I":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = csharp;
csharp.displayName = 'csharp';
csharp.aliases = [
    'dotnet',
    'cs'
];
function csharp(Prism) {
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        } // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/keywords/
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void',
            // keywords which are used to declare a type
            typeDeclaration: 'class enum interface record struct',
            // contextual keywords
            // ("var" and "dynamic" are missing because they are used like types)
            contextual: 'add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)',
            // all other keywords
            other: 'abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield'
        } // keywords
        ;
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var typeDeclarationKeywords = keywordsToPattern(keywordKinds.typeDeclaration);
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other));
        var nonTypeKeywords = keywordsToPattern(keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other);
        var nonContextualKeywords = keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.other) // types
        ;
        var generic = nested(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2) // the idea behind the other forbidden characters is to prevent false positives. Same for tupleElement.
        ;
        var nestedRound = nested(/\((?:[^()]|<<self>>)*\)/.source, 2);
        var name = /@?\b[A-Za-z_]\w*\b/.source;
        var genericName = replace(/<<0>>(?:\s*<<1>>)?/.source, [
            name,
            generic
        ]);
        var identifier = replace(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
            nonTypeKeywords,
            genericName
        ]);
        var array = /\[\s*(?:,\s*)*\]/.source;
        var typeExpressionWithoutTuple = replace(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [
            identifier,
            array
        ]);
        var tupleElement = replace(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [
            generic,
            nestedRound,
            array
        ]);
        var tuple = replace(/\(<<0>>+(?:,<<0>>+)+\)/.source, [
            tupleElement
        ]);
        var typeExpression = replace(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [
            tuple,
            identifier,
            array
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        } // strings & characters
        ;
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#character-literals
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#string-literals
        var character = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source // simplified pattern
        ;
        var regularString = /"(?:\\.|[^\\"\r\n])*"/.source;
        var verbatimString = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
        Prism.languages.csharp = Prism.languages.extend('clike', {
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        verbatimString
                    ]),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: re(/(^|[^@$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // Using static
                    // using static System.Math;
                    pattern: re(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (type)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
                        name,
                        typeExpression
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (alias)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+)<<0>>(?=\s*=)/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Type declarations
                    // class Foo<A, B>
                    // interface Foo<out A, B>
                    pattern: re(/(\b<<0>>\s+)<<1>>/.source, [
                        typeDeclarationKeywords,
                        genericName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Single catch exception declaration
                    // catch(Foo)
                    // (things like catch(Foo e) is covered by variable declaration)
                    pattern: re(/(\bcatch\s*\(\s*)<<0>>/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Name of the type parameter of generic constraints
                    // where Foo : class
                    pattern: re(/(\bwhere\s+)<<0>>/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Casts and checks via as and is.
                    // as Foo<A>, is Bar<B>
                    // (things like if(a is Foo b) is covered by variable declaration)
                    pattern: re(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
                        typeExpressionWithoutTuple
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Variable, field and parameter declaration
                    // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
                    pattern: re(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [
                        typeExpression,
                        nonContextualKeywords,
                        name
                    ]),
                    inside: typeInside
                }
            ],
            keyword: keywords,
            // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
            number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
            operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
            punctuation: /\?\.?|::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('csharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('csharp', 'punctuation', {
            'named-parameter': {
                pattern: re(/([(,]\s*)<<0>>(?=\s*:)/.source, [
                    name
                ]),
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('csharp', 'class-name', {
            namespace: {
                // namespace Foo.Bar {}
                // using Foo.Bar;
                pattern: re(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [
                    name
                ]),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            'type-expression': {
                // default(Foo), typeof(Foo<Bar>), sizeof(int)
                pattern: re(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [
                    nestedRound
                ]),
                lookbehind: true,
                alias: 'class-name',
                inside: typeInside
            },
            'return-type': {
                // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
                // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
                // int Foo => 0; int Foo { get; set } = 0;
                pattern: re(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [
                    typeExpression,
                    identifier
                ]),
                inside: typeInside,
                alias: 'class-name'
            },
            'constructor-invocation': {
                // new List<Foo<Bar[]>> { }
                pattern: re(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [
                    typeExpression
                ]),
                lookbehind: true,
                inside: typeInside,
                alias: 'class-name'
            },
            /*'explicit-implementation': {
// int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
inside: classNameInside,
alias: 'class-name'
},*/ 'generic-method': {
                // foo<Bar>()
                pattern: re(/<<0>>\s*<<1>>(?=\s*\()/.source, [
                    name,
                    generic
                ]),
                inside: {
                    function: re(/^<<0>>/.source, [
                        name
                    ]),
                    generic: {
                        pattern: RegExp(generic),
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            },
            'type-list': {
                // The list of types inherited or of generic constraints
                // class Foo<F> : Bar, IList<FooBar>
                // where F : Bar, IList<int>
                pattern: re(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [
                    typeDeclarationKeywords,
                    genericName,
                    name,
                    typeExpression,
                    keywords.source,
                    nestedRound,
                    /\bnew\s*\(\s*\)/.source
                ]),
                lookbehind: true,
                inside: {
                    'record-arguments': {
                        pattern: re(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                            genericName,
                            nestedRound
                        ]),
                        lookbehind: true,
                        greedy: true,
                        inside: Prism.languages.csharp
                    },
                    keyword: keywords,
                    'class-name': {
                        pattern: RegExp(typeExpression),
                        greedy: true,
                        inside: typeInside
                    },
                    punctuation: /[,()]/
                }
            },
            preprocessor: {
                pattern: /(^[\t ]*)#.*/m,
                lookbehind: true,
                alias: 'property',
                inside: {
                    // highlight preprocessor directives as keywords
                    directive: {
                        pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
                        lookbehind: true,
                        alias: 'keyword'
                    }
                }
            }
        }) // attributes
        ;
        var regularStringOrCharacter = regularString + '|' + character;
        var regularStringCharacterOrComment = replace(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [
            regularStringOrCharacter
        ]);
        var roundExpression = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2) // https://docs.microsoft.com/en-us/dotnet/csharp/programming-guide/concepts/attributes/#attribute-targets
        ;
        var attrTarget = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source;
        var attr = replace(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
            identifier,
            roundExpression
        ]);
        Prism.languages.insertBefore('csharp', 'class-name', {
            attribute: {
                // Attributes
                // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
                pattern: re(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [
                    attrTarget,
                    attr
                ]),
                lookbehind: true,
                greedy: true,
                inside: {
                    target: {
                        pattern: re(/^<<0>>(?=\s*:)/.source, [
                            attrTarget
                        ]),
                        alias: 'keyword'
                    },
                    'attribute-arguments': {
                        pattern: re(/\(<<0>>*\)/.source, [
                            roundExpression
                        ]),
                        inside: Prism.languages.csharp
                    },
                    'class-name': {
                        pattern: RegExp(identifier),
                        inside: {
                            punctuation: /\./
                        }
                    },
                    punctuation: /[:,]/
                }
            }
        }) // string interpolation
        ;
        var formatString = /:[^}\r\n]+/.source // multi line
        ;
        var mInterpolationRound = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2);
        var mInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            mInterpolationRound,
            formatString
        ]) // single line
        ;
        var sInterpolationRound = nested(replace(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [
            regularStringOrCharacter
        ]), 2);
        var sInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            sInterpolationRound,
            formatString
        ]);
        function createInterpolationInside(interpolation, interpolationRound) {
            return {
                interpolation: {
                    pattern: re(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [
                        interpolation
                    ]),
                    lookbehind: true,
                    inside: {
                        'format-string': {
                            pattern: re(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                                interpolationRound,
                                formatString
                            ]),
                            lookbehind: true,
                            inside: {
                                punctuation: /^:/
                            }
                        },
                        punctuation: /^\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            alias: 'language-csharp',
                            inside: Prism.languages.csharp
                        }
                    }
                },
                string: /[\s\S]+/
            };
        }
        Prism.languages.insertBefore('csharp', 'string', {
            'interpolation-string': [
                {
                    pattern: re(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [
                        mInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(mInterpolation, mInterpolationRound)
                },
                {
                    pattern: re(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
                        sInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(sInterpolation, sInterpolationRound)
                }
            ],
            char: {
                pattern: RegExp(character),
                greedy: true
            }
        });
        Prism.languages.dotnet = Prism.languages.cs = Prism.languages.csharp;
    })(Prism);
}

},{}],"2Sjb3":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = autohotkey;
autohotkey.displayName = 'autohotkey';
autohotkey.aliases = [];
function autohotkey(Prism) {
    // NOTES - follows first-first highlight method, block is locked after highlight, different from SyntaxHl
    Prism.languages.autohotkey = {
        comment: [
            {
                pattern: /(^|\s);.*/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
                lookbehind: true,
                greedy: true
            }
        ],
        tag: {
            // labels
            pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
            lookbehind: true
        },
        string: /"(?:[^"\n\r]|"")*"/,
        variable: /%\w+%/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
        boolean: /\b(?:false|true)\b/,
        selector: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
        constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
        builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
        symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
        important: /#\b(?:AllowSameLineComments|ClipboardTimeout|CommentFlag|DerefChar|ErrorStdOut|EscapeChar|HotkeyInterval|HotkeyModifierTimeout|Hotstring|If|IfTimeout|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Include|IncludeAgain|InputLevel|InstallKeybdHook|InstallMouseHook|KeyHistory|MaxHotkeysPerInterval|MaxMem|MaxThreads|MaxThreadsBuffer|MaxThreadsPerHotkey|MenuMaskKey|NoEnv|NoTrayIcon|Persistent|SingleInstance|UseHook|Warn|WinActivateForce)\b/i,
        keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
        function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
        punctuation: /[{}[\]():,]/
    };
}

},{}],"2IJa9":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = autoit;
autoit.displayName = 'autoit';
autoit.aliases = [];
function autoit(Prism) {
    Prism.languages.autoit = {
        comment: [
            /;.*/,
            {
                // The multi-line comments delimiters can actually be commented out with ";"
                pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
                lookbehind: true
            }
        ],
        url: {
            pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
            greedy: true,
            inside: {
                variable: /([%$@])\w+\1/
            }
        },
        directive: {
            pattern: /(^[\t ]*)#[\w-]+/m,
            lookbehind: true,
            alias: 'keyword'
        },
        function: /\b\w+(?=\()/,
        // Variables and macros
        variable: /[$@]\w+/,
        keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        boolean: /\b(?:False|True)\b/i,
        operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
        punctuation: /[\[\]().,:]/
    };
}

},{}],"cHiAQ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = avisynth;
avisynth.displayName = 'avisynth';
avisynth.aliases = [
    'avs'
];
function avisynth(Prism) {
    (function(Prism) {
        function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return replacements[+index];
            });
        }
        function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        var types = /bool|clip|float|int|string|val/.source;
        var internals = [
            // bools
            /is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source,
            /apply|assert|default|eval|import|nop|select|undefined/.source,
            /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source,
            /hex(?:value)?|value/.source,
            /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source,
            /a?sinh?|a?cosh?|a?tan[2h]?/.source,
            /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source,
            /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source,
            /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source,
            /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source,
            /isversionorgreater|version(?:number|string)/.source,
            /buildpixeltype|colorspacenametopixeltype/.source,
            /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source
        ].join('|');
        var properties = [
            // content
            /has(?:audio|video)/.source,
            /height|width/.source,
            /frame(?:count|rate)|framerate(?:denominator|numerator)/.source,
            /getparity|is(?:field|frame)based/.source,
            /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source,
            /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source
        ].join('|');
        var filters = [
            // source
            /avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source,
            /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source,
            /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source,
            /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source,
            /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source,
            /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source,
            /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source,
            /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source,
            /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source,
            /imagewriter/.source,
            /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source
        ].join('|');
        var allinternals = [
            internals,
            properties,
            filters
        ].join('|');
        Prism.languages.avisynth = {
            comment: [
                {
                    // Matches [* *] nestable block comments, but only supports 1 level of nested comments
                    // /\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|<self>)*\*\]/
                    pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches /* */ block comments
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches # comments
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // Handle before strings because optional arguments are surrounded by double quotes
            argument: {
                pattern: re(/\b(?:<<0>>)\s+("?)\w+\1/.source, [
                    types
                ], 'i'),
                inside: {
                    keyword: /^\w+/
                }
            },
            // Optional argument assignment
            'argument-label': {
                pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
                lookbehind: true,
                inside: {
                    'argument-name': {
                        pattern: /^\w+/,
                        alias: 'punctuation'
                    },
                    punctuation: /=$/
                }
            },
            string: [
                {
                    // triple double-quoted
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true
                },
                {
                    // single double-quoted
                    pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        constant: {
                            // These *are* case-sensitive!
                            pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
                        }
                    }
                }
            ],
            // The special "last" variable that takes the value of the last implicitly returned clip
            variable: /\b(?:last)\b/i,
            boolean: /\b(?:false|no|true|yes)\b/i,
            keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
            constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
            // AviSynth's internal functions, filters, and properties
            'builtin-function': {
                pattern: re(/\b(?:<<0>>)\b/.source, [
                    allinternals
                ], 'i'),
                alias: 'function'
            },
            'type-cast': {
                pattern: re(/\b(?:<<0>>)(?=\s*\()/.source, [
                    types
                ], 'i'),
                alias: 'keyword'
            },
            // External/user-defined filters
            function: {
                pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
                lookbehind: true
            },
            // Matches a \ as the first or last character on a line
            'line-continuation': {
                pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
            operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
            punctuation: /[{}\[\]();,.]/
        };
        Prism.languages.avs = Prism.languages.avisynth;
    })(Prism);
}

},{}],"29Vdm":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = avroIdl;
avroIdl.displayName = 'avroIdl';
avroIdl.aliases = [];
function avroIdl(Prism) {
    // GitHub: https://github.com/apache/avro
    // Docs: https://avro.apache.org/docs/current/idl.html
    Prism.languages['avro-idl'] = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        annotation: {
            pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
            greedy: true,
            alias: 'function'
        },
        'function-identifier': {
            pattern: /`[^\r\n`]+`(?=\s*\()/,
            greedy: true,
            alias: 'function'
        },
        identifier: {
            pattern: /`[^\r\n`]+`/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: [
            {
                pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
                lookbehind: true
            },
            /-?\b(?:Infinity|NaN)\b/
        ],
        operator: /=/,
        punctuation: /[()\[\]{}<>.:,;-]/
    };
    Prism.languages.avdl = Prism.languages['avro-idl'];
}

},{}],"SDZTd":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = bash;
bash.displayName = 'bash';
bash.aliases = [
    'shell'
];
function bash(Prism) {
    (function(Prism) {
        // $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
        // + LC_ALL, RANDOM, REPLY, SECONDS.
        // + make sure PS1..4 are here as they are not always set,
        // - some useless things.
        var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';
        var commandAfterHeredoc = {
            pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
            lookbehind: true,
            alias: 'punctuation',
            // this looks reasonably well in all themes
            inside: null // see below
        };
        var insideString = {
            bash: commandAfterHeredoc,
            environment: {
                pattern: RegExp('\\$' + envVars),
                alias: 'constant'
            },
            variable: [
                // [0]: Arithmetic Environment
                {
                    pattern: /\$?\(\([\s\S]+?\)\)/,
                    greedy: true,
                    inside: {
                        // If there is a $ sign at the beginning highlight $(( and )) as variable
                        variable: [
                            {
                                pattern: /(^\$\(\([\s\S]+)\)\)/,
                                lookbehind: true
                            },
                            /^\$\(\(/
                        ],
                        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
                        // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
                        operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
                        // If there is no $ sign at the beginning highlight (( and )) as punctuation
                        punctuation: /\(\(?|\)\)?|,|;/
                    }
                },
                {
                    pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
                    greedy: true,
                    inside: {
                        variable: /^\$\(|^`|\)$|`$/
                    }
                },
                {
                    pattern: /\$\{[^}]+\}/,
                    greedy: true,
                    inside: {
                        operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
                        punctuation: /[\[\]]/,
                        environment: {
                            pattern: RegExp('(\\{)' + envVars),
                            lookbehind: true,
                            alias: 'constant'
                        }
                    }
                },
                /\$(?:\w+|[#?*!@$])/
            ],
            // Escape sequences from echo and printf's manuals, and escaped quotes.
            entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
        };
        Prism.languages.bash = {
            shebang: {
                pattern: /^#!\s*\/.*/,
                alias: 'important'
            },
            comment: {
                pattern: /(^|[^"{\\$])#.*/,
                lookbehind: true
            },
            'function-name': [
                // a) function foo {
                // b) foo() {
                // c) function foo() {
                // but not “foo {”
                {
                    // a) and c)
                    pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
                    lookbehind: true,
                    alias: 'function'
                },
                {
                    // b)
                    pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
                    alias: 'function'
                }
            ],
            // Highlight variable names as variables in for and select beginnings.
            'for-or-select': {
                pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
                alias: 'variable',
                lookbehind: true
            },
            // Highlight variable names as variables in the left-hand part
            // of assignments (“=” and “+=”).
            'assign-left': {
                pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
                inside: {
                    environment: {
                        pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
                        lookbehind: true,
                        alias: 'constant'
                    }
                },
                alias: 'variable',
                lookbehind: true
            },
            string: [
                // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
                {
                    pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                // → No expansion (so no “inside”).
                {
                    pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        bash: commandAfterHeredoc
                    }
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
                    pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
                    pattern: /(^|[^$\\])'[^']*'/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
                    pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
                    greedy: true,
                    inside: {
                        entity: insideString.entity
                    }
                }
            ],
            environment: {
                pattern: RegExp('\\$?' + envVars),
                alias: 'constant'
            },
            variable: insideString.variable,
            function: {
                pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            keyword: {
                pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
            builtin: {
                pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
                lookbehind: true,
                // Alias added to make those easier to distinguish from strings.
                alias: 'class-name'
            },
            boolean: {
                pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            'file-descriptor': {
                pattern: /\B&\d\b/,
                alias: 'important'
            },
            operator: {
                // Lots of redirections here, but not just that.
                pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
                inside: {
                    'file-descriptor': {
                        pattern: /^\d/,
                        alias: 'important'
                    }
                }
            },
            punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
            number: {
                pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
                lookbehind: true
            }
        };
        commandAfterHeredoc.inside = Prism.languages.bash;
        /* Patterns in command substitution. */ var toBeCopied = [
            'comment',
            'function-name',
            'for-or-select',
            'assign-left',
            'string',
            'environment',
            'function',
            'keyword',
            'builtin',
            'boolean',
            'file-descriptor',
            'operator',
            'punctuation',
            'number'
        ];
        var inside = insideString.variable[1].inside;
        for(var i = 0; i < toBeCopied.length; i++)inside[toBeCopied[i]] = Prism.languages.bash[toBeCopied[i]];
        Prism.languages.shell = Prism.languages.bash;
    })(Prism);
}

},{}],"bnU0U":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = basic;
basic.displayName = 'basic';
basic.aliases = [];
function basic(Prism) {
    Prism.languages.basic = {
        comment: {
            pattern: /(?:!|REM\b).+/i,
            inside: {
                keyword: /^REM/i
            }
        },
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
        function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
        operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
        punctuation: /[,;:()]/
    };
}

},{}],"lewDj":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = batch;
batch.displayName = 'batch';
batch.aliases = [];
function batch(Prism) {
    (function(Prism) {
        var variable = /%%?[~:\w]+%?|!\S+!/;
        var parameter = {
            pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
            alias: 'attr-name',
            inside: {
                punctuation: /:/
            }
        };
        var string = /"(?:[\\"]"|[^"])*"(?!")/;
        var number = /(?:\b|-)\d+\b/;
        Prism.languages.batch = {
            comment: [
                /^::.*/m,
                {
                    pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true
                }
            ],
            label: {
                pattern: /^:.*/m,
                alias: 'property'
            },
            command: [
                {
                    // FOR command
                    pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:do|in)\b|^for\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        punctuation: /[()',]/
                    }
                },
                {
                    // IF command
                    pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
                    }
                },
                {
                    // ELSE command
                    pattern: /((?:^|[&()])[ \t]*)else\b/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^else\b/i
                    }
                },
                {
                    // SET command
                    pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^set\b/i,
                        string: string,
                        parameter: parameter,
                        variable: [
                            variable,
                            /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/
                        ],
                        number: number,
                        operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
                        punctuation: /[()',]/
                    }
                },
                {
                    // Other commands
                    pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^\w+\b/,
                        string: string,
                        parameter: parameter,
                        label: {
                            pattern: /(^\s*):\S+/m,
                            lookbehind: true,
                            alias: 'property'
                        },
                        variable: variable,
                        number: number,
                        operator: /\^/
                    }
                }
            ],
            operator: /[&@]/,
            punctuation: /[()']/
        };
    })(Prism);
}

},{}],"2Wrts":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = bbcode;
bbcode.displayName = 'bbcode';
bbcode.aliases = [
    'shortcode'
];
function bbcode(Prism) {
    Prism.languages.bbcode = {
        tag: {
            pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
            inside: {
                tag: {
                    pattern: /^\[\/?[^\s=\]]+/,
                    inside: {
                        punctuation: /^\[\/?/
                    }
                },
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
                    inside: {
                        punctuation: [
                            /^=/,
                            {
                                pattern: /^(\s*)["']|["']$/,
                                lookbehind: true
                            }
                        ]
                    }
                },
                punctuation: /\]/,
                'attr-name': /[^\s=\]]+/
            }
        }
    };
    Prism.languages.shortcode = Prism.languages.bbcode;
}

},{}],"jOOJM":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = bicep;
bicep.displayName = 'bicep';
bicep.aliases = [];
function bicep(Prism) {
    // based loosely upon: https://github.com/Azure/bicep/blob/main/src/textmate/bicep.tmlanguage
    Prism.languages.bicep = {
        comment: [
            {
                // multiline comments eg /* ASDF */
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                // singleline comments eg // ASDF
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        property: [
            {
                pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
                lookbehind: true
            },
            {
                pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: /'''[^'][\s\S]*?'''/,
                greedy: true
            },
            {
                pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
                lookbehind: true,
                greedy: true
            }
        ],
        'interpolated-string': {
            pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}\r\n]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true
                        },
                        punctuation: /^\$\{|\}$/
                    }
                },
                string: /[\s\S]+/
            }
        },
        datatype: {
            pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
            lookbehind: true,
            alias: 'class-name'
        },
        boolean: /\b(?:false|true)\b/,
        // https://github.com/Azure/bicep/blob/114a3251b4e6e30082a58729f19a8cc4e374ffa6/src/textmate/bicep.tmlanguage#L184
        keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
        decorator: /@\w+\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.bicep['interpolated-string'].inside['interpolation'].inside['expression'].inside = Prism.languages.bicep;
}

},{}],"3JjWI":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = birb;
birb.displayName = 'birb';
birb.aliases = [];
function birb(Prism) {
    Prism.languages.birb = Prism.languages.extend('clike', {
        string: {
            pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
            greedy: true
        },
        'class-name': [
            /\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/,
            /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/
        ],
        keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
        variable: /\b[a-z_]\w*\b/
    });
    Prism.languages.insertBefore('birb', 'function', {
        metadata: {
            pattern: /<\w+>/,
            greedy: true,
            alias: 'symbol'
        }
    });
}

},{}],"81zR6":[function(require,module,exports,__globalThis) {
'use strict';
var refractorC = require("90431b9ca17d51be");
module.exports = bison;
bison.displayName = 'bison';
bison.aliases = [];
function bison(Prism) {
    Prism.register(refractorC);
    Prism.languages.bison = Prism.languages.extend('c', {});
    Prism.languages.insertBefore('bison', 'comment', {
        bison: {
            // This should match all the beginning of the file
            // including the prologue(s), the bison declarations and
            // the grammar rules.
            pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
            inside: {
                c: {
                    // Allow for one level of nested braces
                    pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
                    inside: {
                        delimiter: {
                            pattern: /^%?\{|%?\}$/,
                            alias: 'punctuation'
                        },
                        'bison-variable': {
                            pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
                            alias: 'variable',
                            inside: {
                                punctuation: /<|>/
                            }
                        },
                        rest: Prism.languages.c
                    }
                },
                comment: Prism.languages.c.comment,
                string: Prism.languages.c.string,
                property: /\S+(?=:)/,
                keyword: /%\w+/,
                number: {
                    pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
                    lookbehind: true
                },
                punctuation: /%[%?]|[|:;\[\]<>]/
            }
        }
    });
}

},{"90431b9ca17d51be":"eMUEZ"}],"9nLYo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = bnf;
bnf.displayName = 'bnf';
bnf.aliases = [
    'rbnf'
];
function bnf(Prism) {
    Prism.languages.bnf = {
        string: {
            pattern: /"[^\r\n"]*"|'[^\r\n']*'/
        },
        definition: {
            pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
            alias: [
                'rule',
                'keyword'
            ],
            inside: {
                punctuation: /^<|>$/
            }
        },
        rule: {
            pattern: /<[^<>\r\n\t]+>/,
            inside: {
                punctuation: /^<|>$/
            }
        },
        operator: /::=|[|()[\]{}*+?]|\.{3}/
    };
    Prism.languages.rbnf = Prism.languages.bnf;
}

},{}],"2mZJH":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = brainfuck;
brainfuck.displayName = 'brainfuck';
brainfuck.aliases = [];
function brainfuck(Prism) {
    Prism.languages.brainfuck = {
        pointer: {
            pattern: /<|>/,
            alias: 'keyword'
        },
        increment: {
            pattern: /\+/,
            alias: 'inserted'
        },
        decrement: {
            pattern: /-/,
            alias: 'deleted'
        },
        branching: {
            pattern: /\[|\]/,
            alias: 'important'
        },
        operator: /[.,]/,
        comment: /\S+/
    };
}

},{}],"gbx3q":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = brightscript;
brightscript.displayName = 'brightscript';
brightscript.aliases = [];
function brightscript(Prism) {
    Prism.languages.brightscript = {
        comment: /(?:\brem|').*/i,
        'directive-statement': {
            pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
            lookbehind: true,
            alias: 'property',
            inside: {
                'error-message': {
                    pattern: /(^#error).+/,
                    lookbehind: true
                },
                directive: {
                    pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
                    alias: 'keyword'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        },
        property: {
            pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        'class-name': {
            pattern: /(\bAs[\t ]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?!\d)\w+(?=[\t ]*\()/,
        number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
        operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
        punctuation: /[.,;()[\]{}]/,
        constant: /\b(?:LINE_NUM)\b/i
    };
    Prism.languages.brightscript['directive-statement'].inside.expression.inside = Prism.languages.brightscript;
}

},{}],"aGGao":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = bro;
bro.displayName = 'bro';
bro.aliases = [];
function bro(Prism) {
    Prism.languages.bro = {
        comment: {
            pattern: /(^|[^\\$])#.*/,
            lookbehind: true,
            inside: {
                italic: /\b(?:FIXME|TODO|XXX)\b/
            }
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        boolean: /\b[TF]\b/,
        function: {
            pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
            lookbehind: true
        },
        builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
        constant: {
            pattern: /(\bconst[ \t]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
        operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        punctuation: /[{}[\];(),.:]/
    };
}

},{}],"2HCJ7":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = bsl;
bsl.displayName = 'bsl';
bsl.aliases = [];
function bsl(Prism) {
    /* eslint-disable no-misleading-character-class */ // 1C:Enterprise
    // https://github.com/Diversus23/
    //
    Prism.languages.bsl = {
        comment: /\/\/.*/,
        string: [
            // Строки
            // Strings
            {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            // Date & time
            {
                pattern: /'(?:[^'\r\n\\]|\\.)*'/
            }
        ],
        keyword: [
            {
                // RU
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            {
                // EN
                pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
            }
        ],
        number: {
            pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
            lookbehind: true
        },
        operator: [
            /[<>+\-*/]=?|[%=]/,
            {
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            {
                pattern: /\b(?:and|not|or)\b/i
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
        directive: [
            // Теги препроцессора вида &Клиент, &Сервер, ...
            // Preprocessor tags of the type &Client, &Server, ...
            {
                pattern: /^([ \t]*)&.*/m,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            },
            // #Если Сервер Тогда
            // ...
            // #КонецЕсли
            // Preprocessor instructions of the form:
            // #If Server Then
            // ...
            // #EndIf
            {
                pattern: /^([ \t]*)#.*/gm,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            }
        ]
    };
    Prism.languages.oscript = Prism.languages['bsl'];
}

},{}],"3ufDi":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = cfscript;
cfscript.displayName = 'cfscript';
cfscript.aliases = [];
function cfscript(Prism) {
    // https://cfdocs.org/script
    Prism.languages.cfscript = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                inside: {
                    annotation: {
                        pattern: /(?:^|[^.])@[\w\.]+/,
                        alias: 'punctuation'
                    }
                }
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
        operator: [
            /\+\+|--|&&|\|\||::|=>|[!=]==|<=?|>=?|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|[?:]/,
            /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/
        ],
        scope: {
            pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
            alias: 'global'
        },
        type: {
            pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
            alias: 'builtin'
        }
    });
    Prism.languages.insertBefore('cfscript', 'keyword', {
        // This must be declared before keyword because we use "function" inside the lookahead
        'function-variable': {
            pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        }
    });
    delete Prism.languages.cfscript['class-name'];
    Prism.languages.cfc = Prism.languages['cfscript'];
}

},{}],"8VyrL":[function(require,module,exports,__globalThis) {
'use strict';
var refractorCpp = require("34634e321f02dd3d");
module.exports = chaiscript;
chaiscript.displayName = 'chaiscript';
chaiscript.aliases = [];
function chaiscript(Prism) {
    Prism.register(refractorCpp);
    Prism.languages.chaiscript = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
            lookbehind: true,
            greedy: true
        },
        'class-name': [
            {
                // e.g. class Rectangle { ... }
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            {
                // e.g. attr Rectangle::height, def Rectangle::area() { ... }
                pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
                lookbehind: true
            }
        ],
        keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
        number: [
            Prism.languages.cpp.number,
            /\b(?:Infinity|NaN)\b/
        ],
        operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
    });
    Prism.languages.insertBefore('chaiscript', 'operator', {
        'parameter-type': {
            // e.g. def foo(int x, Vector y) {...}
            pattern: /([,(]\s*)\w+(?=\s+\w)/,
            lookbehind: true,
            alias: 'class-name'
        }
    });
    Prism.languages.insertBefore('chaiscript', 'string', {
        'string-interpolation': {
            pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-expression': {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            inside: Prism.languages.chaiscript
                        },
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
}

},{"34634e321f02dd3d":"brS7J"}],"5lN4e":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = cil;
cil.displayName = 'cil';
cil.aliases = [];
function cil(Prism) {
    Prism.languages.cil = {
        comment: /\/\/.*/,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        directive: {
            pattern: /(^|\W)\.[a-z]+(?=\s)/,
            lookbehind: true,
            alias: 'class-name'
        },
        // Actually an assembly reference
        variable: /\[[\w\.]+\]/,
        keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
        function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
        punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
    };
}

},{}],"68Tks":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = clojure;
clojure.displayName = 'clojure';
clojure.aliases = [];
function clojure(Prism) {
    // Copied from https://github.com/jeluard/prism-clojure
    Prism.languages.clojure = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\.)*"/,
            greedy: true
        },
        char: /\\\w+/,
        symbol: {
            pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
            lookbehind: true
        },
        keyword: {
            pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
            lookbehind: true
        },
        boolean: /\b(?:false|nil|true)\b/,
        number: {
            pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
            lookbehind: true
        },
        function: {
            pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
            lookbehind: true
        },
        operator: /[#@^`~]/,
        punctuation: /[{}\[\](),]/
    };
}

},{}],"lR8GY":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = cmake;
cmake.displayName = 'cmake';
cmake.aliases = [];
function cmake(Prism) {
    Prism.languages.cmake = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
                    inside: {
                        punctuation: /\$\{|\}/,
                        variable: /\w+/
                    }
                }
            }
        },
        variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_(?:BINARY_DIR|DESCRIPTION|HOMEPAGE_URL|NAME|SOURCE_DIR|VERSION|VERSION_(?:MAJOR|MINOR|PATCH|TWEAK))|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE|XCODE_VERSION))\b/,
        property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|GLOBAL_KEYWORD|GLOBAL_PROJECT_TYPES|GLOBAL_ROOTNAMESPACE|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
        keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
        boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
        namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
        operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
        inserted: {
            pattern: /\b\w+::\w+\b/,
            alias: 'class-name'
        },
        number: /\b\d+(?:\.\d+)*\b/,
        function: /\b[a-z_]\w*(?=\s*\()\b/i,
        punctuation: /[()>}]|\$[<{]/
    };
}

},{}],"a8cZT":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = cobol;
cobol.displayName = 'cobol';
cobol.aliases = [];
function cobol(Prism) {
    Prism.languages.cobol = {
        comment: {
            pattern: /\*>.*|(^[ \t]*)\*.*/m,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
            greedy: true
        },
        level: {
            pattern: /(^[ \t]*)\d+\b/m,
            lookbehind: true,
            greedy: true,
            alias: 'number'
        },
        'class-name': {
            // https://github.com/antlr/grammars-v4/blob/42edd5b687d183b5fa679e858a82297bd27141e7/cobol85/Cobol85.g4#L1015
            pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
            lookbehind: true,
            inside: {
                number: {
                    pattern: /(\()\d+/,
                    lookbehind: true
                },
                punctuation: /[()]/
            }
        },
        keyword: {
            pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
            lookbehind: true
        },
        operator: [
            /<>|[<>]=?|[=+*/&]/,
            {
                pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
                lookbehind: true
            }
        ],
        punctuation: /[.:,()]/
    };
}

},{}],"gg8A2":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = coffeescript;
coffeescript.displayName = 'coffeescript';
coffeescript.aliases = [
    'coffee'
];
function coffeescript(Prism) {
    (function(Prism) {
        // Ignore comments starting with { to privilege string interpolation highlighting
        var comment = /#(?!\{).+/;
        var interpolation = {
            pattern: /#\{[^}]+\}/,
            alias: 'variable'
        };
        Prism.languages.coffeescript = Prism.languages.extend('javascript', {
            comment: comment,
            string: [
                // Strings are multiline
                {
                    pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                    greedy: true
                },
                {
                    // Strings are multiline
                    pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation
                    }
                }
            ],
            keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
            'class-member': {
                pattern: /@(?!\d)\w+/,
                alias: 'variable'
            }
        });
        Prism.languages.insertBefore('coffeescript', 'comment', {
            'multiline-comment': {
                pattern: /###[\s\S]+?###/,
                alias: 'comment'
            },
            // Block regexp can contain comments and interpolation
            'block-regex': {
                pattern: /\/{3}[\s\S]*?\/{3}/,
                alias: 'regex',
                inside: {
                    comment: comment,
                    interpolation: interpolation
                }
            }
        });
        Prism.languages.insertBefore('coffeescript', 'string', {
            'inline-javascript': {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                inside: {
                    delimiter: {
                        pattern: /^`|`$/,
                        alias: 'punctuation'
                    },
                    script: {
                        pattern: /[\s\S]+/,
                        alias: 'language-javascript',
                        inside: Prism.languages.javascript
                    }
                }
            },
            // Block strings
            'multiline-string': [
                {
                    pattern: /'''[\s\S]*?'''/,
                    greedy: true,
                    alias: 'string'
                },
                {
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        interpolation: interpolation
                    }
                }
            ]
        });
        Prism.languages.insertBefore('coffeescript', 'keyword', {
            // Object property
            property: /(?!\d)\w+(?=\s*:(?!:))/
        });
        delete Prism.languages.coffeescript['template-string'];
        Prism.languages.coffee = Prism.languages.coffeescript;
    })(Prism);
}

},{}],"kP8aL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = concurnas;
concurnas.displayName = 'concurnas';
concurnas.aliases = [
    'conc'
];
function concurnas(Prism) {
    Prism.languages.concurnas = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        langext: {
            pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
            greedy: true,
            inside: {
                'class-name': /^\w+/,
                string: {
                    pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
                    lookbehind: true
                },
                punctuation: /\|\|/
            }
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
        punctuation: /[{}[\];(),.:]/,
        operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
        annotation: {
            pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
            alias: 'builtin'
        }
    };
    Prism.languages.insertBefore('concurnas', 'langext', {
        'regex-literal': {
            pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                regex: /[\s\S]+/
            }
        },
        'string-literal': {
            pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.conc = Prism.languages.concurnas;
}

},{}],"4k5le":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = coq;
coq.displayName = 'coq';
coq.aliases = [];
function coq(Prism) {
    (function(Prism) {
        // https://github.com/coq/coq
        var commentSource = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source;
        for(var i = 0; i < 2; i++)commentSource = commentSource.replace(/<self>/g, function() {
            return commentSource;
        });
        commentSource = commentSource.replace(/<self>/g, '[]');
        Prism.languages.coq = {
            comment: RegExp(commentSource),
            string: {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            attribute: [
                {
                    pattern: RegExp(/#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(/<comment>/g, function() {
                        return commentSource;
                    })),
                    greedy: true,
                    alias: 'attr-name',
                    inside: {
                        comment: RegExp(commentSource),
                        string: {
                            pattern: /"(?:[^"]|"")*"(?!")/,
                            greedy: true
                        },
                        operator: /=/,
                        punctuation: /^#\[|\]$|[,()]/
                    }
                },
                {
                    pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
                    alias: 'attr-name'
                }
            ],
            keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
            number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
            punct: {
                pattern: /@\{|\{\||\[=|:>/,
                alias: 'punctuation'
            },
            operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
            punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
        };
    })(Prism);
}

},{}],"euQ5r":[function(require,module,exports,__globalThis) {
'use strict';
var refractorRuby = require("5d74cb7944f95cdc");
module.exports = crystal;
crystal.displayName = 'crystal';
crystal.aliases = [];
function crystal(Prism) {
    Prism.register(refractorRuby);
    (function(Prism) {
        Prism.languages.crystal = Prism.languages.extend('ruby', {
            keyword: [
                /\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/,
                {
                    pattern: /(\.\s*)(?:is_a|responds_to)\?/,
                    lookbehind: true
                }
            ],
            number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
            operator: [
                /->/,
                Prism.languages.ruby.operator
            ],
            punctuation: /[(){}[\].,;\\]/
        });
        Prism.languages.insertBefore('crystal', 'string-literal', {
            attribute: {
                pattern: /@\[.*?\]/,
                inside: {
                    delimiter: {
                        pattern: /^@\[|\]$/,
                        alias: 'punctuation'
                    },
                    attribute: {
                        pattern: /^(\s*)\w+/,
                        lookbehind: true,
                        alias: 'class-name'
                    },
                    args: {
                        pattern: /\S(?:[\s\S]*\S)?/,
                        inside: Prism.languages.crystal
                    }
                }
            },
            expansion: {
                pattern: /\{(?:\{.*?\}|%.*?%)\}/,
                inside: {
                    content: {
                        pattern: /^(\{.)[\s\S]+(?=.\}$)/,
                        lookbehind: true,
                        inside: Prism.languages.crystal
                    },
                    delimiter: {
                        pattern: /^\{[\{%]|[\}%]\}$/,
                        alias: 'operator'
                    }
                }
            },
            char: {
                pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
                greedy: true
            }
        });
    })(Prism);
}

},{"5d74cb7944f95cdc":"7gegN"}],"7gegN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = ruby;
ruby.displayName = 'ruby';
ruby.aliases = [
    'rb'
];
function ruby(Prism) {
    (function(Prism) {
        Prism.languages.ruby = Prism.languages.extend('clike', {
            comment: {
                pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
                greedy: true
            },
            'class-name': {
                pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
                lookbehind: true,
                inside: {
                    punctuation: /[.\\]/
                }
            },
            keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
            operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
            punctuation: /[(){}[\].,;]/
        });
        Prism.languages.insertBefore('ruby', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        var interpolation = {
            pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
            lookbehind: true,
            inside: {
                content: {
                    pattern: /^(#\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                delimiter: {
                    pattern: /^#\{|\}$/,
                    alias: 'punctuation'
                }
            }
        };
        delete Prism.languages.ruby.function;
        var percentExpression = '(?:' + [
            /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
            /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
            /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
            /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
            /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
        ].join('|') + ')';
        var symbolName = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
        Prism.languages.insertBefore('ruby', 'keyword', {
            'regex-literal': [
                {
                    pattern: RegExp(/%r/.source + percentExpression + /[egimnosux]{0,6}/.source),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                },
                {
                    pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                }
            ],
            variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
            symbol: [
                {
                    pattern: RegExp(/(^|[^:]):/.source + symbolName),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: RegExp(/([\r\n{(,][ \t]*)/.source + symbolName + /(?=:(?!:))/.source),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'method-definition': {
                pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
                lookbehind: true,
                inside: {
                    function: /\b\w+$/,
                    keyword: /^self\b/,
                    'class-name': /^\w+/,
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('ruby', 'string', {
            'string-literal': [
                {
                    pattern: RegExp(/%[qQiIwWs]?/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?/
                            }
                        },
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?'|'$/
                            }
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            'command-literal': [
                {
                    pattern: RegExp(/%x/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                },
                {
                    pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                }
            ]
        });
        delete Prism.languages.ruby.string;
        Prism.languages.insertBefore('ruby', 'number', {
            builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
            constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
        });
        Prism.languages.rb = Prism.languages.ruby;
    })(Prism);
}

},{}],"uYw2X":[function(require,module,exports,__globalThis) {
'use strict';
var refractorCsharp = require("333c2961910a1a6e");
module.exports = cshtml;
cshtml.displayName = 'cshtml';
cshtml.aliases = [
    'razor'
];
function cshtml(Prism) {
    Prism.register(refractorCsharp);
    (function(Prism) {
        var commentLike = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source;
        var stringLike = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + '|' + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<self>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<self>/g, '[^\\s\\S]').replace(/<str>/g, '(?:' + stringLike + ')').replace(/<comment>/g, '(?:' + commentLike + ')');
        }
        var round = nested(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2);
        var square = nested(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 2);
        var curly = nested(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2);
        var angle = nested(/<(?:[^<>'"@/]|<str>|<comment>|<self>)*>/.source, 2) // Note about the above bracket patterns:
        ;
        // They all ignore HTML expressions that might be in the C# code. This is a problem because HTML (like strings and
        // comments) is parsed differently. This is a huge problem because HTML might contain brackets and quotes which
        // messes up the bracket and string counting implemented by the above patterns.
        //
        // This problem is not fixable because 1) HTML expression are highly context sensitive and very difficult to detect
        // and 2) they require one capturing group at every nested level. See the `tagRegion` pattern to admire the
        // complexity of an HTML expression.
        //
        // To somewhat alleviate the problem a bit, the patterns for characters (e.g. 'a') is very permissive, it also
        // allows invalid characters to support HTML expressions like this: <p>That's it!</p>.
        var tagAttrs = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?/.source;
        var tagContent = /(?!\d)[^\s>\/=$<%]+/.source + tagAttrs + /\s*\/?>/.source;
        var tagRegion = /\B@?/.source + '(?:' + /<([a-zA-Z][\w:]*)/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + // nested start tag
        nested(// eslint-disable-next-line regexp/strict
        /<\1/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + '<self>') + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source, 2)) + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source + '|' + /</.source + tagContent + ')' // Now for the actual language definition(s):
        ;
        //
        // Razor as a language has 2 parts:
        //  1) CSHTML: A markup-like language that has been extended with inline C# code expressions and blocks.
        //  2) C#+HTML: A variant of C# that can contain CSHTML tags as expressions.
        //
        // In the below code, both CSHTML and C#+HTML will be create as separate language definitions that reference each
        // other. However, only CSHTML will be exported via `Prism.languages`.
        Prism.languages.cshtml = Prism.languages.extend('markup', {});
        var csharpWithHtml = Prism.languages.insertBefore('csharp', 'string', {
            html: {
                pattern: RegExp(tagRegion),
                greedy: true,
                inside: Prism.languages.cshtml
            }
        }, {
            csharp: Prism.languages.extend('csharp', {})
        });
        var cs = {
            pattern: /\S[\s\S]*/,
            alias: 'language-csharp',
            inside: csharpWithHtml
        };
        Prism.languages.insertBefore('cshtml', 'prolog', {
            'razor-comment': {
                pattern: /@\*[\s\S]*?\*@/,
                greedy: true,
                alias: 'comment'
            },
            block: {
                pattern: RegExp(/(^|[^@])@/.source + '(?:' + [
                    // @{ ... }
                    curly,
                    /(?:code|functions)\s*/.source + curly,
                    /(?:for|foreach|lock|switch|using|while)\s*/.source + round + /\s*/.source + curly,
                    /do\s*/.source + curly + /\s*while\s*/.source + round + /(?:\s*;)?/.source,
                    /try\s*/.source + curly + /\s*catch\s*/.source + round + /\s*/.source + curly + /\s*finally\s*/.source + curly,
                    /if\s*/.source + round + /\s*/.source + curly + '(?:' + /\s*else/.source + '(?:' + /\s+if\s*/.source + round + ')?' + /\s*/.source + curly + ')*'
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w*/,
                    csharp: cs
                }
            },
            directive: {
                pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w+/,
                    csharp: cs
                }
            },
            value: {
                pattern: RegExp(/(^|[^@])@/.source + /(?:await\b\s*)?/.source + '(?:' + /\w+\b/.source + '|' + round + ')' + '(?:' + /[?!]?\.\w+\b/.source + '|' + round + '|' + square + '|' + angle + round + ')*'),
                lookbehind: true,
                greedy: true,
                alias: 'variable',
                inside: {
                    keyword: /^@/,
                    csharp: cs
                }
            },
            'delegate-operator': {
                pattern: /(^|[^@])@(?=<)/,
                lookbehind: true,
                alias: 'operator'
            }
        });
        Prism.languages.razor = Prism.languages.cshtml;
    })(Prism);
}

},{"333c2961910a1a6e":"buy6I"}],"3jiKs":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = csp;
csp.displayName = 'csp';
csp.aliases = [];
function csp(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @returns {RegExp}
     */ function value(source) {
            return RegExp(/([ \t])/.source + '(?:' + source + ')' + /(?=[\s;]|$)/.source, 'i');
        }
        Prism.languages.csp = {
            directive: {
                pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
                lookbehind: true,
                alias: 'property'
            },
            scheme: {
                pattern: value(/[a-z][a-z0-9.+-]*:/.source),
                lookbehind: true
            },
            none: {
                pattern: value(/'none'/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            nonce: {
                pattern: value(/'nonce-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            hash: {
                pattern: value(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            host: {
                pattern: value(/[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + '|' + /\*[^\s;,']*/.source + '|' + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source),
                lookbehind: true,
                alias: 'url',
                inside: {
                    important: /\*/
                }
            },
            keyword: [
                {
                    pattern: value(/'unsafe-[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'unsafe'
                },
                {
                    pattern: value(/'[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'safe'
                }
            ],
            punctuation: /;/
        };
    })(Prism);
}

},{}],"lOjJo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = cssExtras;
cssExtras.displayName = 'cssExtras';
cssExtras.aliases = [];
function cssExtras(Prism) {
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var selectorInside;
        Prism.languages.css.selector = {
            pattern: Prism.languages.css.selector.pattern,
            lookbehind: true,
            inside: selectorInside = {
                'pseudo-element': /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
                'pseudo-class': /:[-\w]+/,
                class: /\.[-\w]+/,
                id: /#[-\w]+/,
                attribute: {
                    pattern: RegExp('\\[(?:[^[\\]"\']|' + string.source + ')*\\]'),
                    greedy: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        'case-sensitivity': {
                            pattern: /(\s)[si]$/i,
                            lookbehind: true,
                            alias: 'keyword'
                        },
                        namespace: {
                            pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                            lookbehind: true,
                            inside: {
                                punctuation: /\|$/
                            }
                        },
                        'attr-name': {
                            pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                            lookbehind: true
                        },
                        'attr-value': [
                            string,
                            {
                                pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                                lookbehind: true
                            }
                        ],
                        operator: /[|~*^$]?=/
                    }
                },
                'n-th': [
                    {
                        pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                        lookbehind: true,
                        inside: {
                            number: /[\dn]+/,
                            operator: /[+-]/
                        }
                    },
                    {
                        pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                        lookbehind: true
                    }
                ],
                combinator: />|\+|~|\|\|/,
                // the `tag` token has been existed and removed.
                // because we can't find a perfect tokenize to match it.
                // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
                punctuation: /[(),]/
            }
        };
        Prism.languages.css['atrule'].inside['selector-function-argument'].inside = selectorInside;
        Prism.languages.insertBefore('css', 'property', {
            variable: {
                pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
                lookbehind: true
            }
        });
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
            lookbehind: true
        } // 123 -123 .123 -.123 12.3 -12.3
        ;
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        Prism.languages.insertBefore('css', 'function', {
            operator: {
                pattern: /(\s)[+\-*\/](?=\s)/,
                lookbehind: true
            },
            // CAREFUL!
            // Previewers and Inline color use hexcode and color.
            hexcode: {
                pattern: /\B#[\da-f]{3,8}\b/i,
                alias: 'color'
            },
            color: [
                {
                    pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            // it's important that there is no boundary assertion after the hex digits
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            number: number
        });
    })(Prism);
}

},{}],"asz0Q":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = csv;
csv.displayName = 'csv';
csv.aliases = [];
function csv(Prism) {
    // https://tools.ietf.org/html/rfc4180
    Prism.languages.csv = {
        value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
        punctuation: /,/
    };
}

},{}],"fVeHd":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = cypher;
cypher.displayName = 'cypher';
cypher.aliases = [];
function cypher(Prism) {
    Prism.languages.cypher = {
        // https://neo4j.com/docs/cypher-manual/current/syntax/comments/
        comment: /\/\/.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        'class-name': {
            pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
            lookbehind: true,
            greedy: true
        },
        relationship: {
            pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        identifier: {
            pattern: /`(?:[^`\\\r\n])*`/,
            greedy: true
        },
        variable: /\$\w+/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/reserved/
        keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
        function: /\b\w+\b(?=\s*\()/,
        boolean: /\b(?:false|null|true)\b/i,
        number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/operators/
        operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
        punctuation: /[()[\]{},;.]/
    };
}

},{}],"cnalt":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = d;
d.displayName = 'd';
d.aliases = [];
function d(Prism) {
    Prism.languages.d = Prism.languages.extend('clike', {
        comment: [
            {
                // Shebang
                pattern: /^\s*#!.+/,
                greedy: true
            },
            {
                pattern: RegExp(/(^|[^\\])/.source + '(?:' + [
                    // /+ comment +/
                    // Allow one level of nesting
                    /\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source,
                    /\/\/.*/.source,
                    /\/\*[\s\S]*?\*\//.source
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: RegExp([
                    // r"", x""
                    /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source,
                    /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source,
                    // ...
                    // IDENT"
                    /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source,
                    // eslint-disable-next-line regexp/strict
                    /\bq"(.)[\s\S]*?\2"/.source,
                    /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source
                ].join('|'), 'm'),
                greedy: true
            },
            {
                pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
                greedy: true,
                alias: 'token-string'
            }
        ],
        // In order: $, keywords and special tokens, globally defined symbols
        keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
        number: [
            // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
            // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
            /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i,
            {
                pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
                lookbehind: true
            }
        ],
        operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
    });
    Prism.languages.insertBefore('d', 'string', {
        // Characters
        // 'a', '\\', '\n', '\xFF', '\377', '\uFFFF', '\U0010FFFF', '\quot'
        char: /'(?:\\(?:\W|\w+)|[^\\])'/
    });
    Prism.languages.insertBefore('d', 'keyword', {
        property: /\B@\w*/
    });
    Prism.languages.insertBefore('d', 'function', {
        register: {
            // Iasm registers
            pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
            alias: 'variable'
        }
    });
}

},{}],"brm1N":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = dart;
dart.displayName = 'dart';
dart.aliases = [];
function dart(Prism) {
    (function(Prism) {
        var keywords = [
            /\b(?:async|sync|yield)\*/,
            /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/
        ] // Handles named imports, such as http.Client
        ;
        var packagePrefix = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source // based on the dart naming conventions
        ;
        var className = {
            pattern: RegExp(packagePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                }
            }
        };
        Prism.languages.dart = Prism.languages.extend('clike', {
            'class-name': [
                className,
                {
                    // variables and parameters
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(packagePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
        });
        Prism.languages.insertBefore('dart', 'string', {
            'string-literal': {
                pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                        lookbehind: true,
                        inside: {
                            punctuation: /^\$\{?|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                inside: Prism.languages.dart
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            },
            string: undefined
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            metadata: {
                pattern: /@\w+/,
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            generics: {
                pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            }
        });
    })(Prism);
}

},{}],"iqGzw":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = dataweave;
dataweave.displayName = 'dataweave';
dataweave.aliases = [];
function dataweave(Prism) {
    (function(Prism) {
        Prism.languages.dataweave = {
            url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
            property: {
                pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
                greedy: true
            },
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            'mime-type': /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
            date: {
                pattern: /\|[\w:+-]+\|/,
                greedy: true
            },
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            regex: {
                pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
                greedy: true
            },
            keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
            function: /\b[A-Z_]\w*(?=\s*\()/i,
            number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
            punctuation: /[{}[\];(),.:@]/,
            operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
            boolean: /\b(?:false|true)\b/
        };
    })(Prism);
}

},{}],"eIZoO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = dax;
dax.displayName = 'dax';
dax.aliases = [];
function dax(Prism) {
    Prism.languages.dax = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
            lookbehind: true
        },
        'data-field': {
            pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'symbol'
        },
        measure: {
            pattern: /\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'constant'
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
        keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
        boolean: {
            pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
            alias: 'constant'
        },
        number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
        operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
        punctuation: /[;\[\](){}`,.]/
    };
}

},{}],"l5P6g":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = dhall;
dhall.displayName = 'dhall';
dhall.aliases = [];
function dhall(Prism) {
    // ABNF grammar:
    // https://github.com/dhall-lang/dhall-lang/blob/master/standard/dhall.abnf
    Prism.languages.dhall = {
        // Multi-line comments can be nested. E.g. {- foo {- bar -} -}
        // The multi-line pattern is essentially this:
        //   \{-(?:[^-{]|-(?!\})|\{(?!-)|<SELF>)*-\}
        comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
        string: {
            pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            alias: 'language-dhall',
                            inside: null // see blow
                        },
                        punctuation: /\$\{|\}/
                    }
                }
            }
        },
        label: {
            pattern: /`[^`]*`/,
            greedy: true
        },
        url: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L596
            pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
            greedy: true
        },
        env: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L661
            pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
            greedy: true,
            inside: {
                function: /^env/,
                operator: /^:/,
                variable: /[\s\S]+/
            }
        },
        hash: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L725
            pattern: /\bsha256:[\da-fA-F]{64}\b/,
            inside: {
                function: /sha256/,
                operator: /:/,
                number: /[\da-fA-F]{64}/
            }
        },
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L359
        keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
        builtin: /\b(?:None|Some)\b/,
        boolean: /\b(?:False|True)\b/,
        number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
        operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
        punctuation: /\.\.|[{}\[\](),./]/,
        // we'll just assume that every capital word left is a type name
        'class-name': /\b[A-Z]\w*\b/
    };
    Prism.languages.dhall.string.inside.interpolation.inside.expression.inside = Prism.languages.dhall;
}

},{}],"8spVh":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = diff;
diff.displayName = 'diff';
diff.aliases = [];
function diff(Prism) {
    (function(Prism) {
        Prism.languages.diff = {
            coord: [
                // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
                /^(?:\*{3}|-{3}|\+{3}).*$/m,
                /^@@.*@@$/m,
                /^\d.*$/m
            ] // deleted, inserted, unchanged, diff
        };
        /**
     * A map from the name of a block to its line prefix.
     *
     * @type {Object<string, string>}
     */ var PREFIXES = {
            'deleted-sign': '-',
            'deleted-arrow': '<',
            'inserted-sign': '+',
            'inserted-arrow': '>',
            unchanged: ' ',
            diff: '!'
        } // add a token for each prefix
        ;
        Object.keys(PREFIXES).forEach(function(name) {
            var prefix = PREFIXES[name];
            var alias = [];
            if (!/^\w+$/.test(name)) // "deleted-sign" -> "deleted"
            alias.push(/\w+/.exec(name)[0]);
            if (name === 'diff') alias.push('bold');
            Prism.languages.diff[name] = {
                pattern: RegExp('^(?:[' + prefix + '].*(?:\r\n?|\n|(?![\\s\\S])))+', 'm'),
                alias: alias,
                inside: {
                    line: {
                        pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
                        lookbehind: true
                    },
                    prefix: {
                        pattern: /[\s\S]/,
                        alias: /\w+/.exec(name)[0]
                    }
                }
            };
        }) // make prefixes available to Diff plugin
        ;
        Object.defineProperty(Prism.languages.diff, 'PREFIXES', {
            value: PREFIXES
        });
    })(Prism);
}

},{}],"hNWhr":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("e07f36f97a35cccf");
module.exports = django;
django.displayName = 'django';
django.aliases = [
    'jinja2'
];
function django(Prism) {
    Prism.register(refractorMarkupTemplating);
    (function(Prism) {
        Prism.languages.django = {
            comment: /^\{#[\s\S]*?#\}$/,
            tag: {
                pattern: /(^\{%[+-]?\s*)\w+/,
                lookbehind: true,
                alias: 'keyword'
            },
            delimiter: {
                pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
                alias: 'punctuation'
            },
            string: {
                pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
                greedy: true
            },
            filter: {
                pattern: /(\|)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            test: {
                pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b[a-z_]\w+(?=\s*\()/i,
            keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
            operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
            number: /\b\d+(?:\.\d+)?\b/,
            boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
            variable: /\b\w+\b/,
            punctuation: /[{}[\](),.:;]/
        };
        var pattern = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g;
        var markupTemplating = Prism.languages['markup-templating'];
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'django', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'django');
        }) // Add an Jinja2 alias
        ;
        Prism.languages.jinja2 = Prism.languages.django;
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'jinja2', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'jinja2');
        });
    })(Prism);
}

},{"e07f36f97a35cccf":"lhKhp"}],"lhKhp":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = markupTemplating;
markupTemplating.displayName = 'markupTemplating';
markupTemplating.aliases = [];
function markupTemplating(Prism) {
    (function(Prism) {
        /**
     * Returns the placeholder for the given language id and index.
     *
     * @param {string} language
     * @param {string|number} index
     * @returns {string}
     */ function getPlaceholder(language, index) {
            return '___' + language.toUpperCase() + index + '___';
        }
        Object.defineProperties(Prism.languages['markup-templating'] = {}, {
            buildPlaceholders: {
                /**
         * Tokenize all inline templating expressions matching `placeholderPattern`.
         *
         * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
         * `true` will be replaced.
         *
         * @param {object} env The environment of the `before-tokenize` hook.
         * @param {string} language The language id.
         * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
         * @param {(match: string) => boolean} [replaceFilter]
         */ value: function(env, language, placeholderPattern, replaceFilter) {
                    if (env.language !== language) return;
                    var tokenStack = env.tokenStack = [];
                    env.code = env.code.replace(placeholderPattern, function(match) {
                        if (typeof replaceFilter === 'function' && !replaceFilter(match)) return match;
                        var i = tokenStack.length;
                        var placeholder // Check for existing strings
                        ;
                        while(env.code.indexOf(placeholder = getPlaceholder(language, i)) !== -1)++i;
                         // Create a sparse array
                        tokenStack[i] = match;
                        return placeholder;
                    }) // Switch the grammar to markup
                    ;
                    env.grammar = Prism.languages.markup;
                }
            },
            tokenizePlaceholders: {
                /**
         * Replace placeholders with proper tokens after tokenizing.
         *
         * @param {object} env The environment of the `after-tokenize` hook.
         * @param {string} language The language id.
         */ value: function(env, language) {
                    if (env.language !== language || !env.tokenStack) return;
                     // Switch the grammar back
                    env.grammar = Prism.languages[language];
                    var j = 0;
                    var keys = Object.keys(env.tokenStack);
                    function walkTokens(tokens) {
                        for(var i = 0; i < tokens.length; i++){
                            // all placeholders are replaced already
                            if (j >= keys.length) break;
                            var token = tokens[i];
                            if (typeof token === 'string' || token.content && typeof token.content === 'string') {
                                var k = keys[j];
                                var t = env.tokenStack[k];
                                var s = typeof token === 'string' ? token : token.content;
                                var placeholder = getPlaceholder(language, k);
                                var index = s.indexOf(placeholder);
                                if (index > -1) {
                                    ++j;
                                    var before = s.substring(0, index);
                                    var middle = new Prism.Token(language, Prism.tokenize(t, env.grammar), 'language-' + language, t);
                                    var after = s.substring(index + placeholder.length);
                                    var replacement = [];
                                    if (before) replacement.push.apply(replacement, walkTokens([
                                        before
                                    ]));
                                    replacement.push(middle);
                                    if (after) replacement.push.apply(replacement, walkTokens([
                                        after
                                    ]));
                                    if (typeof token === 'string') tokens.splice.apply(tokens, [
                                        i,
                                        1
                                    ].concat(replacement));
                                    else token.content = replacement;
                                }
                            } else if (token.content) walkTokens(token.content);
                        }
                        return tokens;
                    }
                    walkTokens(env.tokens);
                }
            }
        });
    })(Prism);
}

},{}],"2Rpqw":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = dnsZoneFile;
dnsZoneFile.displayName = 'dnsZoneFile';
dnsZoneFile.aliases = [];
function dnsZoneFile(Prism) {
    Prism.languages['dns-zone-file'] = {
        comment: /;.*/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(^\$ORIGIN[ \t]+)\S+/m,
                lookbehind: true
            },
            {
                pattern: /(^|\s)@(?=\s|$)/,
                lookbehind: true
            }
        ],
        keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
        class: {
            // https://tools.ietf.org/html/rfc1035#page-13
            pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            // https://en.wikipedia.org/wiki/List_of_DNS_record_types
            pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        punctuation: /[()]/
    };
    Prism.languages['dns-zone'] = Prism.languages['dns-zone-file'];
}

},{}],"anBQ8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = docker;
docker.displayName = 'docker';
docker.aliases = [
    'dockerfile'
];
function docker(Prism) {
    (function(Prism) {
        // Many of the following regexes will contain negated lookaheads like `[ \t]+(?![ \t])`. This is a trick to ensure
        // that quantifiers behave *atomically*. Atomic quantifiers are necessary to prevent exponential backtracking.
        var spaceAfterBackSlash = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source // At least one space, comment, or line break
        ;
        var space = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(/<SP_BS>/g, function() {
            return spaceAfterBackSlash;
        });
        var string = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source;
        var option = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(/<STR>/g, function() {
            return string;
        });
        var stringRule = {
            pattern: RegExp(string),
            greedy: true
        };
        var commentRule = {
            pattern: /(^[ \t]*)#.*/m,
            lookbehind: true,
            greedy: true
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function re(source, flags) {
            source = source.replace(/<OPT>/g, function() {
                return option;
            }).replace(/<SP>/g, function() {
                return space;
            });
            return RegExp(source, flags);
        }
        Prism.languages.docker = {
            instruction: {
                pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
                lookbehind: true,
                greedy: true,
                inside: {
                    options: {
                        pattern: re(/(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source, 'i'),
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            property: {
                                pattern: /(^|\s)--[\w-]+/,
                                lookbehind: true
                            },
                            string: [
                                stringRule,
                                {
                                    pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                                    lookbehind: true
                                }
                            ],
                            operator: /\\$/m,
                            punctuation: /=/
                        }
                    },
                    keyword: [
                        {
                            // https://docs.docker.com/engine/reference/builder/#healthcheck
                            pattern: re(/(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#from
                            pattern: re(/(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#onbuild
                            pattern: re(/(^ONBUILD<SP>)\w+/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            pattern: /^\w+/,
                            greedy: true
                        }
                    ],
                    comment: commentRule,
                    string: stringRule,
                    variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
                    operator: /\\$/m
                }
            },
            comment: commentRule
        };
        Prism.languages.dockerfile = Prism.languages.docker;
    })(Prism);
}

},{}],"jOhU4":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = dot;
dot.displayName = 'dot';
dot.aliases = [
    'gv'
];
function dot(Prism) {
    (function(Prism) {
        var ID = '(?:' + [
            // an identifier
            /[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source,
            /-?(?:\.\d+|\d+(?:\.\d*)?)/.source,
            /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source,
            /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source
        ].join('|') + ')';
        var IDInside = {
            markup: {
                pattern: /(^<)[\s\S]+(?=>$)/,
                lookbehind: true,
                alias: [
                    'language-markup',
                    'language-html',
                    'language-xml'
                ],
                inside: Prism.languages.markup
            }
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function withID(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return ID;
            }), flags);
        }
        Prism.languages.dot = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
                greedy: true
            },
            'graph-name': {
                pattern: withID(/(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source, 'i'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name',
                inside: IDInside
            },
            'attr-value': {
                pattern: withID(/(=[ \t\r\n]*)<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            'attr-name': {
                pattern: withID(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
            'compass-point': {
                pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
                lookbehind: true,
                alias: 'builtin'
            },
            node: {
                pattern: withID(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            operator: /[=:]|-[->]/,
            punctuation: /[\[\]{};,]/
        };
        Prism.languages.gv = Prism.languages.dot;
    })(Prism);
}

},{}],"1hwJe":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = ebnf;
ebnf.displayName = 'ebnf';
ebnf.aliases = [];
function ebnf(Prism) {
    Prism.languages.ebnf = {
        comment: /\(\*[\s\S]*?\*\)/,
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        special: {
            pattern: /\?[^?\r\n]*\?/,
            greedy: true,
            alias: 'class-name'
        },
        definition: {
            pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
            lookbehind: true,
            alias: [
                'rule',
                'keyword'
            ]
        },
        rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
        punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
        operator: /[-=|*/!]/
    };
}

},{}],"itdTK":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = editorconfig;
editorconfig.displayName = 'editorconfig';
editorconfig.aliases = [];
function editorconfig(Prism) {
    Prism.languages.editorconfig = {
        // https://editorconfig-specification.readthedocs.io
        comment: /[;#].*/,
        section: {
            pattern: /(^[ \t]*)\[.+\]/m,
            lookbehind: true,
            alias: 'selector',
            inside: {
                regex: /\\\\[\[\]{},!?.*]/,
                // Escape special characters with '\\'
                operator: /[!?]|\.\.|\*{1,2}/,
                punctuation: /[\[\]{},]/
            }
        },
        key: {
            pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /=.*/,
            alias: 'attr-value',
            inside: {
                punctuation: /^=/
            }
        }
    };
}

},{}],"ho6rl":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = eiffel;
eiffel.displayName = 'eiffel';
eiffel.aliases = [];
function eiffel(Prism) {
    Prism.languages.eiffel = {
        comment: /--.*/,
        string: [
            // Aligned-verbatim-strings
            {
                pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
                greedy: true
            },
            {
                pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
                greedy: true
            },
            {
                pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
                greedy: true
            }
        ],
        // normal char | special char | char code
        char: /'(?:%.|[^%'\r\n])+'/,
        keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
        boolean: /\b(?:False|True)\b/i,
        // Convention: class-names are always all upper-case characters
        'class-name': /\b[A-Z][\dA-Z_]*\b/,
        number: [
            // hexa | octal | bin
            /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
            /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i
        ],
        punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
        operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
    };
}

},{}],"6sdqE":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("6eeea06777608a3a");
module.exports = ejs;
ejs.displayName = 'ejs';
ejs.aliases = [
    'eta'
];
function ejs(Prism) {
    Prism.register(refractorMarkupTemplating);
    (function(Prism) {
        Prism.languages.ejs = {
            delimiter: {
                pattern: /^<%[-_=]?|[-_]?%>$/,
                alias: 'punctuation'
            },
            comment: /^#[\s\S]*/,
            'language-javascript': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.javascript
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var ejsPattern = /<%(?!%)[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ejs', ejsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ejs');
        });
        Prism.languages.eta = Prism.languages.ejs;
    })(Prism);
}

},{"6eeea06777608a3a":"lhKhp"}],"2pSjD":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = elixir;
elixir.displayName = 'elixir';
elixir.aliases = [];
function elixir(Prism) {
    Prism.languages.elixir = {
        doc: {
            pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
            inside: {
                attribute: /^@\w+/,
                string: /['"][\s\S]+/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
        regex: {
            pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
            greedy: true
        },
        string: [
            {
                // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
                pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
                greedy: true,
                inside: {
                }
            },
            {
                pattern: /("""|''')[\s\S]*?\1/,
                greedy: true,
                inside: {
                }
            },
            {
                // Multi-line strings are allowed
                pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                greedy: true,
                inside: {
                }
            }
        ],
        atom: {
            // Look-behind prevents bad highlighting of the :: operator
            pattern: /(^|[^:]):\w+/,
            lookbehind: true,
            alias: 'symbol'
        },
        module: {
            pattern: /\b[A-Z]\w*\b/,
            alias: 'class-name'
        },
        // Look-ahead prevents bad highlighting of the :: operator
        'attr-name': /\b\w+\??:(?!:)/,
        argument: {
            // Look-behind prevents bad highlighting of the && operator
            pattern: /(^|[^&])&\d+/,
            lookbehind: true,
            alias: 'variable'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'variable'
        },
        function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
        number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
        keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        operator: [
            /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
            {
                // We don't want to match <<
                pattern: /([^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /([^>])>(?!>)/,
                lookbehind: true
            }
        ],
        punctuation: /<<|>>|[.,%\[\]{}()]/
    };
    Prism.languages.elixir.string.forEach(function(o) {
        o.inside = {
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.elixir
                }
            }
        };
    });
}

},{}],"iDuno":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = elm;
elm.displayName = 'elm';
elm.aliases = [];
function elm(Prism) {
    Prism.languages.elm = {
        comment: /--.*|\{-[\s\S]*?-\}/,
        char: {
            pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
            greedy: true
        },
        string: [
            {
                // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
                pattern: /"""[\s\S]*?"""/,
                greedy: true
            },
            {
                pattern: /"(?:[^\\"\r\n]|\\.)*"/,
                greedy: true
            }
        ],
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|exposing|import)\b/
            }
        },
        keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
        // decimal integers and floating point numbers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
        // Most of this is needed because of the meaning of a single '.'.
        // If it stands alone freely, it is the function composition.
        // It may also be a separator between a module name and an identifier => no
        // operator. If it comes together with other special characters it is an
        // operator too.
        // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
        // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
        operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
        // In Elm, nearly everything is a variable, do not highlight these.
        hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
        constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
        punctuation: /[{}[\]|(),.:]/
    };
}

},{}],"l1GKe":[function(require,module,exports,__globalThis) {
'use strict';
var refractorRuby = require("75d22fcd403d51a5");
var refractorMarkupTemplating = require("980cde025f2a0cb6");
module.exports = erb;
erb.displayName = 'erb';
erb.aliases = [];
function erb(Prism) {
    Prism.register(refractorRuby);
    Prism.register(refractorMarkupTemplating);
    (function(Prism) {
        Prism.languages.erb = {
            delimiter: {
                pattern: /^(\s*)<%=?|%>(?=\s*$)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            ruby: {
                pattern: /\s*\S[\s\S]*/,
                alias: 'language-ruby',
                inside: Prism.languages.ruby
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var erbPattern = /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'erb', erbPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'erb');
        });
    })(Prism);
}

},{"75d22fcd403d51a5":"7gegN","980cde025f2a0cb6":"lhKhp"}],"6cvtv":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = erlang;
erlang.displayName = 'erlang';
erlang.aliases = [];
function erlang(Prism) {
    Prism.languages.erlang = {
        comment: /%.+/,
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        'quoted-function': {
            pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
            alias: 'function'
        },
        'quoted-atom': {
            pattern: /'(?:\\.|[^\\'\r\n])+'/,
            alias: 'atom'
        },
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:after|case|catch|end|fun|if|of|receive|try|when)\b/,
        number: [
            /\$\\?./,
            /\b\d+#[a-z0-9]+/i,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i
        ],
        function: /\b[a-z][\w@]*(?=\()/,
        variable: {
            // Look-behind is used to prevent wrong highlighting of atoms containing "@"
            pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
            lookbehind: true
        },
        operator: [
            /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/,
            {
                // We don't want to match <<
                pattern: /(^|[^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /(^|[^>])>(?!>)/,
                lookbehind: true
            }
        ],
        atom: /\b[a-z][\w@]*/,
        punctuation: /[()[\]{}:;,.#|]|<<|>>/
    };
}

},{}],"5Qkug":[function(require,module,exports,__globalThis) {
'use strict';
var refractorLua = require("2048b896fc9ecac1");
var refractorMarkupTemplating = require("24696b5a01555d79");
module.exports = etlua;
etlua.displayName = 'etlua';
etlua.aliases = [];
function etlua(Prism) {
    Prism.register(refractorLua);
    Prism.register(refractorMarkupTemplating);
    (function(Prism) {
        Prism.languages.etlua = {
            delimiter: {
                pattern: /^<%[-=]?|-?%>$/,
                alias: 'punctuation'
            },
            'language-lua': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.lua
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var pattern = /<%[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'etlua', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'etlua');
        });
    })(Prism);
}

},{"2048b896fc9ecac1":"fMVsy","24696b5a01555d79":"lhKhp"}],"fMVsy":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = lua;
lua.displayName = 'lua';
lua.aliases = [];
function lua(Prism) {
    Prism.languages.lua = {
        comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
        // \z may be used to skip the following space
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
            greedy: true
        },
        number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
        keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
        function: /(?!\d)\w+(?=\s*(?:[({]))/,
        operator: [
            /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
            {
                // Match ".." but don't break "..."
                pattern: /(^|[^.])\.\.(?!\.)/,
                lookbehind: true
            }
        ],
        punctuation: /[\[\](){},;]|\.+|:+/
    };
}

},{}],"3lBVI":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = excelFormula;
excelFormula.displayName = 'excelFormula';
excelFormula.aliases = [];
function excelFormula(Prism) {
    Prism.languages['excel-formula'] = {
        comment: {
            pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        reference: {
            // https://www.ablebits.com/office-addins-blog/2015/12/08/excel-reference-another-sheet-workbook/
            // Sales!B2
            // 'Winter sales'!B2
            // [Sales.xlsx]Jan!B2:B5
            // D:\Reports\[Sales.xlsx]Jan!B2:B5
            // '[Sales.xlsx]Jan sales'!B2:B5
            // 'D:\Reports\[Sales.xlsx]Jan sales'!B2:B5
            pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
            greedy: true,
            alias: 'string',
            inside: {
                operator: /!$/,
                punctuation: /'/,
                sheet: {
                    pattern: /[^[\]]+$/,
                    alias: 'function'
                },
                file: {
                    pattern: /\[[^[\]]+\]$/,
                    inside: {
                        punctuation: /[[\]]/
                    }
                },
                path: /[\s\S]+/
            }
        },
        'function-name': {
            pattern: /\b[A-Z]\w*(?=\()/i,
            alias: 'keyword'
        },
        range: {
            pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
            alias: 'property',
            inside: {
                operator: /:/,
                cell: /\$?[A-Z]+\$?\d+/i,
                column: /\$?[A-Z]+/i,
                row: /\$?\d+/
            }
        },
        cell: {
            // Excel is case insensitive, so the string "foo1" could be either a variable or a cell.
            // To combat this, we match cells case insensitive, if the contain at least one "$", and case sensitive otherwise.
            pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
            alias: 'property'
        },
        number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        operator: /[-+*/^%=&,]|<[=>]?|>=?/,
        punctuation: /[[\]();{}|]/
    };
    Prism.languages['xlsx'] = Prism.languages['xls'] = Prism.languages['excel-formula'];
}

},{}],"1Pefu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = factor;
factor.displayName = 'factor';
factor.aliases = [];
function factor(Prism) {
    (function(Prism) {
        var comment_inside = {
            function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
        };
        var string_inside = {
            number: /\\[^\s']|%\w/
        };
        var factor = {
            comment: [
                {
                    // ! single-line exclamation point comments with whitespace after/around the !
                    pattern: /(^|\s)(?:! .*|!$)/,
                    lookbehind: true,
                    inside: comment_inside
                },
                /* from basis/multiline: */ {
                    // /* comment */, /* comment*/
                    pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                },
                {
                    // ![[ comment ]] , ![===[ comment]===]
                    pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                }
            ],
            number: [
                {
                    // basic base 10 integers 9, -9
                    pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // base prefix integers 0b010 0o70 0xad 0d10 0XAD -0xa9
                    pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // fractional ratios 1/5 -1/5 and the literal float approximations 1/5. -1/5.
                    pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // positive mixed numbers 23+1/5 +23+1/5
                    pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // negative mixed numbers -23-1/5
                    pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // basic decimal floats -0.01 0. .0 .1 -.1 -1. -12.13 +12.13
                    // and scientific notation with base 10 exponents 3e4 3e-4 .3e-4
                    pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // NAN literal syntax NAN: 80000deadbeef, NAN: a
                    pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    /*
base prefix floats 0x1.0p3 (8.0) 0b1.010p2 (5.0) 0x1.p1 0b1.11111111p11111...
"The normalized hex form ±0x1.MMMMMMMMMMMMM[pP]±EEEE allows any floating-point number to be specified precisely.
The values of MMMMMMMMMMMMM and EEEE map directly to the mantissa and exponent fields of the binary IEEE 754 representation."
<https://docs.factorcode.org/content/article-syntax-floats.html>
*/ pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
                    lookbehind: true
                }
            ],
            // R/ regexp?\/\\/
            regexp: {
                pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
                lookbehind: true,
                alias: 'number',
                inside: {
                    variable: /\\\S/,
                    keyword: /[+?*\[\]^$(){}.|]/,
                    operator: {
                        pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
                        lookbehind: true
                    }
                }
            },
            boolean: {
                pattern: /(^|\s)[tf](?=\s|$)/,
                lookbehind: true
            },
            // SBUF" asd", URL" ://...", P" /etc/"
            'custom-string': {
                pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
                lookbehind: true,
                greedy: true,
                alias: 'string',
                inside: {
                    number: /\\\S|%\w|\//
                }
            },
            'multiline-string': [
                {
                    // STRING: name \n content \n ; -> CONSTANT: name "content" (symbol)
                    pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        number: string_inside.number,
                        // trailing semicolon on its own line
                        'semicolon-or-setlocal': {
                            pattern: /([\r\n][ \t]*);(?=\s|$)/,
                            lookbehind: true,
                            alias: 'function'
                        }
                    }
                },
                {
                    // HEREDOC: marker \n content \n marker ; -> "content" (immediate)
                    pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                },
                {
                    // [[ string ]], [==[ string]==]
                    pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                }
            ],
            'special-using': {
                pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
                lookbehind: true,
                alias: 'function',
                inside: {
                    // this is essentially a regex for vocab names, which i don't want to specify
                    // but the USING: gets picked up as a vocab name
                    string: {
                        pattern: /(\s)[^:\s]+/,
                        lookbehind: true
                    }
                }
            },
            /* this description of stack effect literal syntax is not complete and not as specific as theoretically possible
trying to do better is more work and regex-computation-time than it's worth though.
- we'd like to have the "delimiter" parts of the stack effect [ (, --, and ) ] be a different (less-important or comment-like) colour to the stack effect contents
- we'd like if nested stack effects were treated as such rather than just appearing flat (with `inside`)
- we'd like if the following variable name conventions were recognised specifically:
special row variables = ..a b..
type and stack effect annotations end with a colon = ( quot: ( a: ( -- ) -- b ) -- x ), ( x: number -- )
word throws unconditional error = *
any other word-like variable name = a ? q' etc
https://docs.factorcode.org/content/article-effects.html
these are pretty complicated to highlight properly without a real parser, and therefore out of scope
the old pattern, which may be later useful, was: (^|\s)(?:call|execute|eval)?\((?:\s+[^"\r\n\t ]\S*)*?\s+--(?:\s+[^"\n\t ]\S*)*?\s+\)(?=\s|$)
*/ // current solution is not great
            'stack-effect-delimiter': [
                {
                    // opening parenthesis
                    pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // middle --
                    pattern: /(\s)--(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing parenthesis
                    pattern: /(\s)\)(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            combinators: {
                pattern: null,
                lookbehind: true,
                alias: 'keyword'
            },
            'kernel-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'sequences-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'math-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'constructor-word': {
                // <array> but not <=>
                pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'other-builtin-syntax': {
                pattern: null,
                lookbehind: true,
                alias: 'operator'
            },
            /*
full list of supported word naming conventions: (the convention appears outside of the [brackets])
set-[x]
change-[x]
with-[x]
new-[x]
>[string]
[base]>
[string]>[number]
+[symbol]+
[boolean-word]?
?[of]
[slot-reader]>>
>>[slot-setter]
[slot-writer]<<
([implementation-detail])
[mutater]!
[variant]*
[prettyprint].
$[help-markup]
<constructors>, SYNTAX:, etc are supported by their own patterns.
`with` and `new` from `kernel` are their own builtins.
see <https://docs.factorcode.org/content/article-conventions.html>
*/ 'conventionally-named-word': {
                pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'colon-syntax': {
                pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'semicolon-or-setlocal': {
                pattern: /(\s)(?:;|:>)(?=\s|$)/,
                lookbehind: true,
                alias: 'function'
            },
            // do not highlight leading } or trailing X{ at the begin/end of the file as it's invalid syntax
            'curly-brace-literal-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)[a-z]*\{(?=\s)/i,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\}(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            // do not highlight leading ] or trailing [ at the begin/end of the file as it's invalid syntax
            'quotation-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)\[(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\](?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            'normal-word': {
                pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
                lookbehind: true
            },
            /*
basic first-class string "a"
with escaped double-quote "a\""
escaped backslash "\\"
and general escapes since Factor has so many "\N"
syntax that works in the reference implementation that isn't fully
supported because it's an implementation detail:
"string 1""string 2" -> 2 strings (works anyway)
"string"5 -> string, 5
"string"[ ] -> string, quotation
{ "a"} -> array<string>
the rest of those examples all properly recognise the string, but not
the other object (number, quotation, etc)
this is fine for a regex-only implementation.
*/ string: {
                pattern: /"(?:\\\S|[^"\\])*"/,
                greedy: true,
                inside: string_inside
            }
        };
        var escape = function(str) {
            return (str + '').replace(/([.?*+\^$\[\]\\(){}|\-])/g, '\\$1');
        };
        var arrToWordsRegExp = function(arr) {
            return new RegExp('(^|\\s)(?:' + arr.map(escape).join('|') + ')(?=\\s|$)');
        };
        var builtins = {
            'kernel-builtin': [
                'or',
                '2nipd',
                '4drop',
                'tuck',
                'wrapper',
                'nip',
                'wrapper?',
                'callstack>array',
                'die',
                'dupd',
                'callstack',
                'callstack?',
                '3dup',
                'hashcode',
                'pick',
                '4nip',
                'build',
                '>boolean',
                'nipd',
                'clone',
                '5nip',
                'eq?',
                '?',
                '=',
                'swapd',
                '2over',
                'clear',
                '2dup',
                'get-retainstack',
                'not',
                'tuple?',
                'dup',
                '3nipd',
                'call',
                '-rotd',
                'object',
                'drop',
                'assert=',
                'assert?',
                '-rot',
                'execute',
                'boa',
                'get-callstack',
                'curried?',
                '3drop',
                'pickd',
                'overd',
                'over',
                'roll',
                '3nip',
                'swap',
                'and',
                '2nip',
                'rotd',
                'throw',
                '(clone)',
                'hashcode*',
                'spin',
                'reach',
                '4dup',
                'equal?',
                'get-datastack',
                'assert',
                '2drop',
                '<wrapper>',
                'boolean?',
                'identity-hashcode',
                'identity-tuple?',
                'null',
                'composed?',
                'new',
                '5drop',
                'rot',
                '-roll',
                'xor',
                'identity-tuple',
                'boolean'
            ],
            'other-builtin-syntax': [
                // syntax
                '=======',
                'recursive',
                'flushable',
                '>>',
                '<<<<<<',
                'M\\',
                'B',
                'PRIVATE>',
                '\\',
                '======',
                'final',
                'inline',
                'delimiter',
                'deprecated',
                '<PRIVATE',
                '>>>>>>',
                '<<<<<<<',
                'parse-complex',
                'malformed-complex',
                'read-only',
                '>>>>>>>',
                'call-next-method',
                '<<',
                'foldable',
                '$',
                '$[',
                '${'
            ],
            'sequences-builtin': [
                'member-eq?',
                'mismatch',
                'append',
                'assert-sequence=',
                'longer',
                'repetition',
                'clone-like',
                '3sequence',
                'assert-sequence?',
                'last-index-from',
                'reversed',
                'index-from',
                'cut*',
                'pad-tail',
                'join-as',
                'remove-eq!',
                'concat-as',
                'but-last',
                'snip',
                'nths',
                'nth',
                'sequence',
                'longest',
                'slice?',
                '<slice>',
                'remove-nth',
                'tail-slice',
                'empty?',
                'tail*',
                'member?',
                'virtual-sequence?',
                'set-length',
                'drop-prefix',
                'iota',
                'unclip',
                'bounds-error?',
                'unclip-last-slice',
                'non-negative-integer-expected',
                'non-negative-integer-expected?',
                'midpoint@',
                'longer?',
                '?set-nth',
                '?first',
                'rest-slice',
                'prepend-as',
                'prepend',
                'fourth',
                'sift',
                'subseq-start',
                'new-sequence',
                '?last',
                'like',
                'first4',
                '1sequence',
                'reverse',
                'slice',
                'virtual@',
                'repetition?',
                'set-last',
                'index',
                '4sequence',
                'max-length',
                'set-second',
                'immutable-sequence',
                'first2',
                'first3',
                'supremum',
                'unclip-slice',
                'suffix!',
                'insert-nth',
                'tail',
                '3append',
                'short',
                'suffix',
                'concat',
                'flip',
                'immutable?',
                'reverse!',
                '2sequence',
                'sum',
                'delete-all',
                'indices',
                'snip-slice',
                '<iota>',
                'check-slice',
                'sequence?',
                'head',
                'append-as',
                'halves',
                'sequence=',
                'collapse-slice',
                '?second',
                'slice-error?',
                'product',
                'bounds-check?',
                'bounds-check',
                'immutable',
                'virtual-exemplar',
                'harvest',
                'remove',
                'pad-head',
                'last',
                'set-fourth',
                'cartesian-product',
                'remove-eq',
                'shorten',
                'shorter',
                'reversed?',
                'shorter?',
                'shortest',
                'head-slice',
                'pop*',
                'tail-slice*',
                'but-last-slice',
                'iota?',
                'append!',
                'cut-slice',
                'new-resizable',
                'head-slice*',
                'sequence-hashcode',
                'pop',
                'set-nth',
                '?nth',
                'second',
                'join',
                'immutable-sequence?',
                '<reversed>',
                '3append-as',
                'virtual-sequence',
                'subseq?',
                'remove-nth!',
                'length',
                'last-index',
                'lengthen',
                'assert-sequence',
                'copy',
                'move',
                'third',
                'first',
                'tail?',
                'set-first',
                'prefix',
                'bounds-error',
                '<repetition>',
                'exchange',
                'surround',
                'cut',
                'min-length',
                'set-third',
                'push-all',
                'head?',
                'subseq-start-from',
                'delete-slice',
                'rest',
                'sum-lengths',
                'head*',
                'infimum',
                'remove!',
                'glue',
                'slice-error',
                'subseq',
                'push',
                'replace-slice',
                'subseq-as',
                'unclip-last'
            ],
            'math-builtin': [
                'number=',
                'next-power-of-2',
                '?1+',
                'fp-special?',
                'imaginary-part',
                'float>bits',
                'number?',
                'fp-infinity?',
                'bignum?',
                'fp-snan?',
                'denominator',
                'gcd',
                '*',
                '+',
                'fp-bitwise=',
                '-',
                'u>=',
                '/',
                '>=',
                'bitand',
                'power-of-2?',
                'log2-expects-positive',
                'neg?',
                '<',
                'log2',
                '>',
                'integer?',
                'number',
                'bits>double',
                '2/',
                'zero?',
                'bits>float',
                'float?',
                'shift',
                'ratio?',
                'rect>',
                'even?',
                'ratio',
                'fp-sign',
                'bitnot',
                '>fixnum',
                'complex?',
                '/i',
                'integer>fixnum',
                '/f',
                'sgn',
                '>bignum',
                'next-float',
                'u<',
                'u>',
                'mod',
                'recip',
                'rational',
                '>float',
                '2^',
                'integer',
                'fixnum?',
                'neg',
                'fixnum',
                'sq',
                'bignum',
                '>rect',
                'bit?',
                'fp-qnan?',
                'simple-gcd',
                'complex',
                '<fp-nan>',
                'real',
                '>fraction',
                'double>bits',
                'bitor',
                'rem',
                'fp-nan-payload',
                'real-part',
                'log2-expects-positive?',
                'prev-float',
                'align',
                'unordered?',
                'float',
                'fp-nan?',
                'abs',
                'bitxor',
                'integer>fixnum-strict',
                'u<=',
                'odd?',
                '<=',
                '/mod',
                '>integer',
                'real?',
                'rational?',
                'numerator'
            ] // that's all for now
        };
        Object.keys(builtins).forEach(function(k) {
            factor[k].pattern = arrToWordsRegExp(builtins[k]);
        });
        var combinators = [
            // kernel
            '2bi',
            'while',
            '2tri',
            'bi*',
            '4dip',
            'both?',
            'same?',
            'tri@',
            'curry',
            'prepose',
            '3bi',
            '?if',
            'tri*',
            '2keep',
            '3keep',
            'curried',
            '2keepd',
            'when',
            '2bi*',
            '2tri*',
            '4keep',
            'bi@',
            'keepdd',
            'do',
            'unless*',
            'tri-curry',
            'if*',
            'loop',
            'bi-curry*',
            'when*',
            '2bi@',
            '2tri@',
            'with',
            '2with',
            'either?',
            'bi',
            'until',
            '3dip',
            '3curry',
            'tri-curry*',
            'tri-curry@',
            'bi-curry',
            'keepd',
            'compose',
            '2dip',
            'if',
            '3tri',
            'unless',
            'tuple',
            'keep',
            '2curry',
            'tri',
            'most',
            'while*',
            'dip',
            'composed',
            'bi-curry@',
            'find-last-from',
            'trim-head-slice',
            'map-as',
            'each-from',
            'none?',
            'trim-tail',
            'partition',
            'if-empty',
            'accumulate*',
            'reject!',
            'find-from',
            'accumulate-as',
            'collector-for-as',
            'reject',
            'map',
            'map-sum',
            'accumulate!',
            '2each-from',
            'follow',
            'supremum-by',
            'map!',
            'unless-empty',
            'collector',
            'padding',
            'reduce-index',
            'replicate-as',
            'infimum-by',
            'trim-tail-slice',
            'count',
            'find-index',
            'filter',
            'accumulate*!',
            'reject-as',
            'map-integers',
            'map-find',
            'reduce',
            'selector',
            'interleave',
            '2map',
            'filter-as',
            'binary-reduce',
            'map-index-as',
            'find',
            'produce',
            'filter!',
            'replicate',
            'cartesian-map',
            'cartesian-each',
            'find-index-from',
            'map-find-last',
            '3map-as',
            '3map',
            'find-last',
            'selector-as',
            '2map-as',
            '2map-reduce',
            'accumulate',
            'each',
            'each-index',
            'accumulate*-as',
            'when-empty',
            'all?',
            'collector-as',
            'push-either',
            'new-like',
            'collector-for',
            '2selector',
            'push-if',
            '2all?',
            'map-reduce',
            '3each',
            'any?',
            'trim-slice',
            '2reduce',
            'change-nth',
            'produce-as',
            '2each',
            'trim',
            'trim-head',
            'cartesian-find',
            'map-index',
            'if-zero',
            'each-integer',
            'unless-zero',
            '(find-integer)',
            'when-zero',
            'find-last-integer',
            '(all-integers?)',
            'times',
            '(each-integer)',
            'find-integer',
            'all-integers?',
            'unless-negative',
            'if-positive',
            'when-positive',
            'when-negative',
            'unless-positive',
            'if-negative',
            'case',
            '2cleave',
            'cond>quot',
            'case>quot',
            '3cleave',
            'wrong-values',
            'to-fixed-point',
            'alist>quot',
            'cond',
            'cleave',
            'call-effect',
            'recursive-hashcode',
            'spread',
            'deep-spread>quot',
            '2||',
            '0||',
            'n||',
            '0&&',
            '2&&',
            '3||',
            '1||',
            '1&&',
            'n&&',
            '3&&',
            'smart-unless*',
            'keep-inputs',
            'reduce-outputs',
            'smart-when*',
            'cleave>array',
            'smart-with',
            'smart-apply',
            'smart-if',
            'inputs/outputs',
            'output>sequence-n',
            'map-outputs',
            'map-reduce-outputs',
            'dropping',
            'output>array',
            'smart-map-reduce',
            'smart-2map-reduce',
            'output>array-n',
            'nullary',
            'input<sequence',
            'append-outputs',
            'drop-inputs',
            'inputs',
            'smart-2reduce',
            'drop-outputs',
            'smart-reduce',
            'preserving',
            'smart-when',
            'outputs',
            'append-outputs-as',
            'smart-unless',
            'smart-if*',
            'sum-outputs',
            'input<sequence-unsafe',
            'output>sequence' // tafn
        ];
        factor.combinators.pattern = arrToWordsRegExp(combinators);
        Prism.languages.factor = factor;
    })(Prism);
}

},{}],"e3Kdm":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = $false;
$false.displayName = '$false';
$false.aliases = [];
function $false(Prism) {
    (function(Prism) {
        /**
     * Based on the manual by Wouter van Oortmerssen.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2801#issue-829717504}
     */ Prism.languages['false'] = {
            comment: {
                pattern: /\{[^}]*\}/
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            'character-code': {
                pattern: /'(?:[^\r]|\r\n?)/,
                alias: 'number'
            },
            'assembler-code': {
                pattern: /\d+`/,
                alias: 'important'
            },
            number: /\d+/,
            operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
            punctuation: /\[|\]/,
            variable: /[a-z]/,
            'non-standard': {
                pattern: /[()<BDO®]/,
                alias: 'bold'
            }
        };
    })(Prism);
}

},{}],"VTTVi":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = firestoreSecurityRules;
firestoreSecurityRules.displayName = 'firestoreSecurityRules';
firestoreSecurityRules.aliases = [];
function firestoreSecurityRules(Prism) {
    Prism.languages['firestore-security-rules'] = Prism.languages.extend('clike', {
        comment: /\/\/.*/,
        keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
        operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
    });
    delete Prism.languages['firestore-security-rules']['class-name'];
    Prism.languages.insertBefore('firestore-security-rules', 'keyword', {
        path: {
            pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
                    inside: {
                        operator: /=/,
                        keyword: /\*\*/,
                        punctuation: /[.$(){}]/
                    }
                },
                punctuation: /\//
            }
        },
        method: {
            // to make the pattern shorter, the actual method names are omitted
            pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
            lookbehind: true,
            alias: 'builtin',
            inside: {
                punctuation: /,/
            }
        }
    });
}

},{}],"2aO2r":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = flow;
flow.displayName = 'flow';
flow.aliases = [];
function flow(Prism) {
    (function(Prism) {
        Prism.languages.flow = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('flow', 'keyword', {
            type: [
                {
                    pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|any|mixed|null|void)\b/,
                    alias: 'tag'
                }
            ]
        });
        Prism.languages.flow['function-variable'].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i;
        delete Prism.languages.flow['parameter'];
        Prism.languages.insertBefore('flow', 'operator', {
            'flow-punctuation': {
                pattern: /\{\||\|\}/,
                alias: 'punctuation'
            }
        });
        if (!Array.isArray(Prism.languages.flow.keyword)) Prism.languages.flow.keyword = [
            Prism.languages.flow.keyword
        ];
        Prism.languages.flow.keyword.unshift({
            pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
            lookbehind: true
        }, {
            pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
            lookbehind: true
        });
    })(Prism);
}

},{}],"3RV2p":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = fortran;
fortran.displayName = 'fortran';
fortran.aliases = [];
function fortran(Prism) {
    Prism.languages.fortran = {
        'quoted-number': {
            pattern: /[BOZ](['"])[A-F0-9]+\1/i,
            alias: 'number'
        },
        string: {
            pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
            inside: {
                comment: {
                    pattern: /(&(?:\r\n?|\n)\s*)!.*/,
                    lookbehind: true
                }
            }
        },
        comment: {
            pattern: /!.*/,
            greedy: true
        },
        boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
        keyword: [
            // Types
            /\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i,
            /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
            /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
            /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
        ],
        operator: [
            /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i,
            {
                // Use lookbehind to prevent confusion with (/ /)
                pattern: /(^|(?!\().)\/(?!\))/,
                lookbehind: true
            }
        ],
        punctuation: /\(\/|\/\)|[(),;:&]/
    };
}

},{}],"1NUv7":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = fsharp;
fsharp.displayName = 'fsharp';
fsharp.aliases = [];
function fsharp(Prism) {
    Prism.languages.fsharp = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
            lookbehind: true,
            inside: {
                operator: /->|\*/,
                punctuation: /\./
            }
        },
        keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
        number: [
            /\b0x[\da-fA-F]+(?:LF|lf|un)?\b/,
            /\b0b[01]+(?:uy|y)?\b/,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
            /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/
        ],
        operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
    });
    Prism.languages.insertBefore('fsharp', 'keyword', {
        preprocessor: {
            pattern: /(^[\t ]*)#.*/m,
            lookbehind: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
                    lookbehind: true,
                    alias: 'keyword'
                }
            }
        }
    });
    Prism.languages.insertBefore('fsharp', 'punctuation', {
        'computation-expression': {
            pattern: /\b[_a-z]\w*(?=\s*\{)/i,
            alias: 'keyword'
        }
    });
    Prism.languages.insertBefore('fsharp', 'string', {
        annotation: {
            pattern: /\[<.+?>\]/,
            greedy: true,
            inside: {
                punctuation: /^\[<|>\]$/,
                'class-name': {
                    pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
                    lookbehind: true
                },
                'annotation-content': {
                    pattern: /[\s\S]+/,
                    inside: Prism.languages.fsharp
                }
            }
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
            greedy: true
        }
    });
}

},{}],"kUEsB":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("68541f2f45e1d86f");
module.exports = ftl;
ftl.displayName = 'ftl';
ftl.aliases = [];
function ftl(Prism) {
    Prism.register(refractorMarkupTemplating);
    (function(Prism) {
        // https://freemarker.apache.org/docs/dgui_template_exp.html
        // FTL expression with 4 levels of nesting supported
        var FTL_EXPR = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source;
        for(var i = 0; i < 2; i++)FTL_EXPR = FTL_EXPR.replace(/<expr>/g, function() {
            return FTL_EXPR;
        });
        FTL_EXPR = FTL_EXPR.replace(/<expr>/g, /[^\s\S]/.source);
        var ftl = {
            comment: /<#--[\s\S]*?-->/,
            string: [
                {
                    // raw string
                    pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
                    greedy: true
                },
                {
                    pattern: RegExp(/("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(/<expr>/g, function() {
                        return FTL_EXPR;
                    })),
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: RegExp(/((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(/<expr>/g, function() {
                                return FTL_EXPR;
                            })),
                            lookbehind: true,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^\$\{|\}$/,
                                    alias: 'punctuation'
                                },
                                rest: null
                            }
                        }
                    }
                }
            ],
            keyword: /\b(?:as)\b/,
            boolean: /\b(?:false|true)\b/,
            'builtin-function': {
                pattern: /((?:^|[^?])\?\s*)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b\w+(?=\s*\()/,
            number: /\b\d+(?:\.\d+)?\b/,
            operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
            punctuation: /[,;.:()[\]{}]/
        };
        ftl.string[1].inside.interpolation.inside.rest = ftl;
        Prism.languages.ftl = {
            'ftl-comment': {
                // the pattern is shortened to be more efficient
                pattern: /^<#--[\s\S]*/,
                alias: 'comment'
            },
            'ftl-directive': {
                pattern: /^<[\s\S]+>$/,
                inside: {
                    directive: {
                        pattern: /(^<\/?)[#@][a-z]\w*/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    punctuation: /^<\/?|\/?>$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            },
            'ftl-interpolation': {
                pattern: /^\$\{[\s\S]*\}$/,
                inside: {
                    punctuation: /^\$\{|\}$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            // eslint-disable-next-line regexp/no-useless-lazy
            var pattern = RegExp(/<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(/<expr>/g, function() {
                return FTL_EXPR;
            }), 'gi');
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ftl', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ftl');
        });
    })(Prism);
}

},{"68541f2f45e1d86f":"lhKhp"}],"2rIHJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = gap;
gap.displayName = 'gap';
gap.aliases = [];
function gap(Prism) {
    // https://www.gap-system.org/Manuals/doc/ref/chap4.html
    // https://www.gap-system.org/Manuals/doc/ref/chap27.html
    Prism.languages.gap = {
        shell: {
            pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
            greedy: true,
            inside: {
                gap: {
                    pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
                    lookbehind: true,
                    inside: null // see below
                },
                punctuation: /^gap>/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
            lookbehind: true,
            greedy: true,
            inside: {
                continuation: {
                    pattern: /([\r\n])>/,
                    lookbehind: true,
                    alias: 'punctuation'
                }
            }
        },
        keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        continuation: {
            pattern: /([\r\n])>/,
            lookbehind: true,
            alias: 'punctuation'
        },
        operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
        punctuation: /[()[\]{},;.:]/
    };
    Prism.languages.gap.shell.inside.gap.inside = Prism.languages.gap;
}

},{}],"3Qlw8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = gcode;
gcode.displayName = 'gcode';
gcode.aliases = [];
function gcode(Prism) {
    Prism.languages.gcode = {
        comment: /;.*|\B\(.*?\)\B/,
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        keyword: /\b[GM]\d+(?:\.\d+)?\b/,
        property: /\b[A-Z]/,
        checksum: {
            pattern: /(\*)\d+/,
            lookbehind: true,
            alias: 'number'
        },
        // T0:0:0
        punctuation: /[:*]/
    };
}

},{}],"3bE1C":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = gdscript;
gdscript.displayName = 'gdscript';
gdscript.aliases = [];
function gdscript(Prism) {
    Prism.languages.gdscript = {
        comment: /#.*/,
        string: {
            pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
            greedy: true
        },
        'class-name': {
            // class_name Foo, extends Bar, class InnerClass
            // export(int) var baz, export(int, 0) var i
            // as Node
            // const FOO: int = 9, var bar: bool = true
            // func add(reference: Item, amount: int) -> Item:
            pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
            lookbehind: true
        },
        keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        variable: /\$\w+/,
        number: [
            /\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/,
            /\b(?:INF|NAN|PI|TAU)\b/
        ],
        constant: /\b[A-Z][A-Z_\d]*\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
        punctuation: /[.:,;()[\]{}]/
    };
}

},{}],"fpqPV":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = gedcom;
gedcom.displayName = 'gedcom';
gedcom.aliases = [];
function gedcom(Prism) {
    Prism.languages.gedcom = {
        'line-value': {
            // Preceded by level, optional pointer, and tag
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
            lookbehind: true,
            inside: {
                pointer: {
                    pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
                    alias: 'variable'
                }
            }
        },
        tag: {
            // Preceded by level and optional pointer
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
            lookbehind: true,
            alias: 'string'
        },
        level: {
            pattern: /(^[\t ]*)\d+/m,
            lookbehind: true,
            alias: 'number'
        },
        pointer: {
            pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
            alias: 'variable'
        }
    };
}

},{}],"fUI1s":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = gherkin;
gherkin.displayName = 'gherkin';
gherkin.aliases = [];
function gherkin(Prism) {
    (function(Prism) {
        var tableRow = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
        Prism.languages.gherkin = {
            pystring: {
                pattern: /("""|''')[\s\S]+?\1/,
                alias: 'string'
            },
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[ \t]*)@\S*/m,
                lookbehind: true
            },
            feature: {
                pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]+/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            scenario: {
                pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]*/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            'table-body': {
                // Look-behind is used to skip the table head, which has the same format as any table row
                pattern: RegExp('(' + tableRow + ')(?:' + tableRow + ')+'),
                lookbehind: true,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    },
                    td: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'string'
                    },
                    punctuation: /\|/
                }
            },
            'table-head': {
                pattern: RegExp(tableRow),
                inside: {
                    th: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'variable'
                    },
                    punctuation: /\|/
                }
            },
            atrule: {
                pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
                lookbehind: true
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    }
                }
            },
            outline: {
                pattern: /<[^>]+>/,
                alias: 'variable'
            }
        };
    })(Prism);
}

},{}],"jbJJZ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = git;
git.displayName = 'git';
git.aliases = [];
function git(Prism) {
    Prism.languages.git = {
        /*
     * A simple one line comment like in a git status command
     * For instance:
     * $ git status
     * # On branch infinite-scroll
     * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
     * # and have 1 and 2 different commits each, respectively.
     * nothing to commit (working directory clean)
     */ comment: /^#.*/m,
        /*
     * Regexp to match the changed lines in a git diff output. Check the example below.
     */ deleted: /^[-–].*/m,
        inserted: /^\+.*/m,
        /*
     * a string (double and simple quote)
     */ string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        /*
     * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
     * For instance:
     * $ git add file.txt
     */ command: {
            pattern: /^.*\$ git .*$/m,
            inside: {
                /*
         * A git command can contain a parameter starting by a single or a double dash followed by a string
         * For instance:
         * $ git diff --cached
         * $ git log -p
         */ parameter: /\s--?\w+/
            }
        },
        /*
     * Coordinates displayed in a git diff command
     * For instance:
     * $ git diff
     * diff --git file.txt file.txt
     * index 6214953..1d54a52 100644
     * --- file.txt
     * +++ file.txt
     * @@ -1 +1,2 @@
     * -Here's my tetx file
     * +Here's my text file
     * +And this is the second line
     */ coord: /^@@.*@@$/m,
        /*
     * Match a "commit [SHA1]" line in a git log output.
     * For instance:
     * $ git log
     * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
     * Author: lgiraudel
     * Date:   Mon Feb 17 11:18:34 2014 +0100
     *
     *     Add of a new line
     */ 'commit-sha1': /^commit \w{40}$/m
    };
}

},{}],"csvDy":[function(require,module,exports,__globalThis) {
'use strict';
var refractorC = require("a2797a38f096e29e");
module.exports = glsl;
glsl.displayName = 'glsl';
glsl.aliases = [];
function glsl(Prism) {
    Prism.register(refractorC);
    Prism.languages.glsl = Prism.languages.extend('c', {
        keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
    });
}

},{"a2797a38f096e29e":"eMUEZ"}],"brkic":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = gml;
gml.displayName = 'gml';
gml.aliases = [];
function gml(Prism) {
    Prism.languages.gamemakerlanguage = Prism.languages.gml = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
        number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
        operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
        constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
        variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
    });
}

},{}],"fLZKP":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = gn;
gn.displayName = 'gn';
gn.aliases = [
    'gni'
];
function gn(Prism) {
    // https://gn.googlesource.com/gn/+/refs/heads/main/docs/reference.md#grammar
    Prism.languages.gn = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'string-literal': {
            pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
                    lookbehind: true,
                    inside: {
                        number: /^\$0x[\s\S]{2}$/,
                        variable: /^\$\w+$/,
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: null // see below
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        keyword: /\b(?:else|if)\b/,
        boolean: /\b(?:false|true)\b/,
        'builtin-function': {
            // a few functions get special highlighting to improve readability
            pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
            alias: 'keyword'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
        number: /-?\b\d+\b/,
        operator: /[-+!=<>]=?|&&|\|\|/,
        punctuation: /[(){}[\],.]/
    };
    Prism.languages.gn['string-literal'].inside['interpolation'].inside['expression'].inside = Prism.languages.gn;
    Prism.languages.gni = Prism.languages.gn;
}

},{}],"3KLb4":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = goModule;
goModule.displayName = 'goModule';
goModule.aliases = [];
function goModule(Prism) {
    // https://go.dev/ref/mod#go-mod-file-module
    Prism.languages['go-mod'] = Prism.languages['go-module'] = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        version: {
            pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
            lookbehind: true,
            alias: 'number'
        },
        'go-version': {
            pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
            lookbehind: true,
            alias: 'number'
        },
        keyword: {
            pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
            lookbehind: true
        },
        operator: /=>/,
        punctuation: /[()[\],]/
    };
}

},{}],"cQk5d":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = go;
go.displayName = 'go';
go.aliases = [];
function go(Prism) {
    Prism.languages.go = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
        boolean: /\b(?:_|false|iota|nil|true)\b/,
        number: [
            // binary and octal integers
            /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
            /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
        ],
        operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
        builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
    });
    Prism.languages.insertBefore('go', 'string', {
        char: {
            pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
            greedy: true
        }
    });
    delete Prism.languages.go['class-name'];
}

},{}],"bOWQq":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = graphql;
graphql.displayName = 'graphql';
graphql.aliases = [];
function graphql(Prism) {
    Prism.languages.graphql = {
        comment: /#.*/,
        description: {
            pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
            greedy: true,
            alias: 'string',
            inside: {
                'language-markdown': {
                    pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: Prism.languages.markdown
                }
            }
        },
        string: {
            pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:false|true)\b/,
        variable: /\$[a-z_]\w*/i,
        directive: {
            pattern: /@[a-z_]\w*/i,
            alias: 'function'
        },
        'attr-name': {
            pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
            greedy: true
        },
        'atom-input': {
            pattern: /\b[A-Z]\w*Input\b/,
            alias: 'class-name'
        },
        scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
        constant: /\b[A-Z][A-Z_\d]*\b/,
        'class-name': {
            pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
            lookbehind: true
        },
        fragment: {
            pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-mutation': {
            pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-query': {
            pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
        operator: /[!=|&]|\.{3}/,
        'property-query': /\w+(?=\s*\()/,
        object: /\w+(?=\s*\{)/,
        punctuation: /[!(){}\[\]:=,]/,
        property: /\w+/
    };
    Prism.hooks.add('after-tokenize', function afterTokenizeGraphql(env) {
        if (env.language !== 'graphql') return;
        /**
     * get the graphql token stream that we want to customize
     *
     * @typedef {InstanceType<import("./prism-core")["Token"]>} Token
     * @type {Token[]}
     */ var validTokens = env.tokens.filter(function(token) {
            return typeof token !== 'string' && token.type !== 'comment' && token.type !== 'scalar';
        });
        var currentIndex = 0;
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {number} offset
     * @returns {Token | undefined}
     */ function getToken(offset) {
            return validTokens[currentIndex + offset];
        }
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {readonly string[]} types
     * @param {number} [offset=0]
     * @returns {boolean}
     */ function isTokenType(types, offset) {
            offset = offset || 0;
            for(var i = 0; i < types.length; i++){
                var token = getToken(i + offset);
                if (!token || token.type !== types[i]) return false;
            }
            return true;
        }
        /**
     * Returns the index of the closing bracket to an opening bracket.
     *
     * It is assumed that `token[currentIndex - 1]` is an opening bracket.
     *
     * If no closing bracket could be found, `-1` will be returned.
     *
     * @param {RegExp} open
     * @param {RegExp} close
     * @returns {number}
     */ function findClosingBracket(open, close) {
            var stackHeight = 1;
            for(var i = currentIndex; i < validTokens.length; i++){
                var token = validTokens[i];
                var content = token.content;
                if (token.type === 'punctuation' && typeof content === 'string') {
                    if (open.test(content)) stackHeight++;
                    else if (close.test(content)) {
                        stackHeight--;
                        if (stackHeight === 0) return i;
                    }
                }
            }
            return -1;
        }
        /**
     * Adds an alias to the given token.
     *
     * @param {Token} token
     * @param {string} alias
     * @returns {void}
     */ function addAlias(token, alias) {
            var aliases = token.alias;
            if (!aliases) token.alias = aliases = [];
            else if (!Array.isArray(aliases)) token.alias = aliases = [
                aliases
            ];
            aliases.push(alias);
        }
        for(; currentIndex < validTokens.length;){
            var startToken = validTokens[currentIndex++] // add special aliases for mutation tokens
            ;
            if (startToken.type === 'keyword' && startToken.content === 'mutation') {
                // any array of the names of all input variables (if any)
                var inputVariables = [];
                if (isTokenType([
                    'definition-mutation',
                    'punctuation'
                ]) && getToken(1).content === '(') {
                    // definition
                    currentIndex += 2 // skip 'definition-mutation' and 'punctuation'
                    ;
                    var definitionEnd = findClosingBracket(/^\($/, /^\)$/);
                    if (definitionEnd === -1) continue;
                     // find all input variables
                    for(; currentIndex < definitionEnd; currentIndex++){
                        var t = getToken(0);
                        if (t.type === 'variable') {
                            addAlias(t, 'variable-input');
                            inputVariables.push(t.content);
                        }
                    }
                    currentIndex = definitionEnd + 1;
                }
                if (isTokenType([
                    'punctuation',
                    'property-query'
                ]) && getToken(0).content === '{') {
                    currentIndex++ // skip opening bracket
                    ;
                    addAlias(getToken(0), 'property-mutation');
                    if (inputVariables.length > 0) {
                        var mutationEnd = findClosingBracket(/^\{$/, /^\}$/);
                        if (mutationEnd === -1) continue;
                         // give references to input variables a special alias
                        for(var i = currentIndex; i < mutationEnd; i++){
                            var varToken = validTokens[i];
                            if (varToken.type === 'variable' && inputVariables.indexOf(varToken.content) >= 0) addAlias(varToken, 'variable-input');
                        }
                    }
                }
            }
        }
    });
}

},{}],"jSwns":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = groovy;
groovy.displayName = 'groovy';
groovy.aliases = [];
function groovy(Prism) {
    Prism.languages.groovy = Prism.languages.extend('clike', {
        string: [
            {
                // https://groovy-lang.org/syntax.html#_dollar_slashy_string
                pattern: /("""|''')(?:[^\\]|\\[\s\S])*?\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
                greedy: true
            },
            {
                // TODO: Slash strings (e.g. /foo/) can contain line breaks but this will cause a lot of trouble with
                // simple division (see JS regex), so find a fix maybe?
                pattern: /(["'/])(?:\\.|(?!\1)[^\\\r\n])*\1/,
                greedy: true
            }
        ],
        keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
        number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
        operator: {
            pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
            lookbehind: true
        },
        punctuation: /\.+|[{}[\];(),:$]/
    });
    Prism.languages.insertBefore('groovy', 'string', {
        shebang: {
            pattern: /#!.+/,
            alias: 'comment'
        }
    });
    Prism.languages.insertBefore('groovy', 'punctuation', {
        'spock-block': /\b(?:and|cleanup|expect|given|setup|then|when|where):/
    });
    Prism.languages.insertBefore('groovy', 'function', {
        annotation: {
            pattern: /(^|[^.])@\w+/,
            lookbehind: true,
            alias: 'punctuation'
        }
    }) // Handle string interpolation
    ;
    Prism.hooks.add('wrap', function(env) {
        if (env.language === 'groovy' && env.type === 'string') {
            var delimiter = env.content.value[0];
            if (delimiter != "'") {
                var pattern = /([^\\])(?:\$(?:\{.*?\}|[\w.]+))/;
                if (delimiter === '$') pattern = /([^\$])(?:\$(?:\{.*?\}|[\w.]+))/;
                 // To prevent double HTML-encoding we have to decode env.content first
                env.content.value = env.content.value.replace(/&lt;/g, '<').replace(/&amp;/g, '&');
                env.content = Prism.highlight(env.content.value, {
                    expression: {
                        pattern: pattern,
                        lookbehind: true,
                        inside: Prism.languages.groovy
                    }
                });
                env.classes.push(delimiter === '/' ? 'regex' : 'gstring');
            }
        }
    });
}

},{}],"1F2iY":[function(require,module,exports,__globalThis) {
'use strict';
var refractorRuby = require("4f063c17420d1e5a");
module.exports = haml;
haml.displayName = 'haml';
haml.aliases = [];
function haml(Prism) {
    Prism.register(refractorRuby) /* TODO
Handle multiline code after tag
%foo= some |
multiline |
code |
*/ ;
    (function(Prism) {
        Prism.languages.haml = {
            // Multiline stuff should appear before the rest
            'multiline-comment': {
                pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
                lookbehind: true,
                alias: 'comment'
            },
            'multiline-code': [
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                }
            ],
            // See at the end of the file for known filters
            filter: {
                pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    }
                }
            },
            markup: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
                lookbehind: true
            },
            tag: {
                // Allows for one nested group of braces
                pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            // Lookbehind tries to prevent interpolations from breaking it all
                            // Allows for one nested group of braces
                            pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
                            lookbehind: true,
                            inside: Prism.languages.ruby
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                                    lookbehind: true
                                },
                                'attr-name': /[\w:-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[=(),]/
                            }
                        },
                        {
                            pattern: /\[[^\]]+\]/,
                            inside: Prism.languages.ruby
                        }
                    ],
                    punctuation: /[<>]/
                }
            },
            code: {
                pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
                lookbehind: true,
                inside: Prism.languages.ruby
            },
            // Interpolations in plain text
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    ruby: {
                        pattern: /[\s\S]+/,
                        inside: Prism.languages.ruby
                    }
                }
            },
            punctuation: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
                lookbehind: true
            }
        };
        var filter_pattern = '((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+' // Non exhaustive list of available filters and associated languages
        ;
        var filters = [
            'css',
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'erb',
            'javascript',
            'less',
            'markdown',
            'ruby',
            'scss',
            'textile'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('{{filter_name}}', function() {
                    return filter.filter;
                })),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    },
                    text: {
                        pattern: /[\s\S]+/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('haml', 'filter', all_filters);
    })(Prism);
}

},{"4f063c17420d1e5a":"7gegN"}],"W2nn1":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("b1a01a3d2f84f380");
module.exports = handlebars;
handlebars.displayName = 'handlebars';
handlebars.aliases = [
    'hbs'
];
function handlebars(Prism) {
    Prism.register(refractorMarkupTemplating);
    (function(Prism) {
        Prism.languages.handlebars = {
            comment: /\{\{![\s\S]*?\}\}/,
            delimiter: {
                pattern: /^\{\{\{?|\}\}\}?$/,
                alias: 'punctuation'
            },
            string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
            boolean: /\b(?:false|true)\b/,
            block: {
                pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
                lookbehind: true,
                alias: 'keyword'
            },
            brackets: {
                pattern: /\[[^\]]+\]/,
                inside: {
                    punctuation: /\[|\]/,
                    variable: /[\s\S]+/
                }
            },
            punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
            variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var handlebarsPattern = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'handlebars', handlebarsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'handlebars');
        });
        Prism.languages.hbs = Prism.languages.handlebars;
    })(Prism);
}

},{"b1a01a3d2f84f380":"lhKhp"}],"kvyjG":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = haskell;
haskell.displayName = 'haskell';
haskell.aliases = [
    'hs'
];
function haskell(Prism) {
    Prism.languages.haskell = {
        comment: {
            pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
            lookbehind: true
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
            alias: 'string'
        },
        string: {
            pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
            greedy: true
        },
        keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import|qualified)\b/,
                punctuation: /\./
            }
        },
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
        // decimal integers and floating point numbers | octal integers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
        operator: [
            {
                // infix operator
                pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
                greedy: true
            },
            {
                // function composition
                pattern: /(\s)\.(?=\s)/,
                lookbehind: true
            },
            // If it stands alone freely, it is the function composition.
            // It may also be a separator between a module name and an identifier => no
            // operator. If it comes together with other special characters it is an
            // operator too.
            //
            // This regex means: /[-!#$%*+=?&@|~.:<>^\\\/]+/ without /\./.
            /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/
        ],
        // In Haskell, nearly everything is a variable, do not highlight these.
        hvariable: {
            pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        constant: {
            pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.hs = Prism.languages.haskell;
}

},{}],"6SpBm":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = haxe;
haxe.displayName = 'haxe';
haxe.aliases = [];
function haxe(Prism) {
    Prism.languages.haxe = Prism.languages.extend('clike', {
        string: {
            // Strings can be multi-line
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        'class-name': [
            {
                pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
                lookbehind: true
            },
            /\b[A-Z]\w*/
        ],
        // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
        keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
        function: {
            pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
            greedy: true
        },
        operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
    });
    Prism.languages.insertBefore('haxe', 'string', {
        'string-interpolation': {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{?|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.haxe
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'class-name', {
        regex: {
            pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
            greedy: true,
            inside: {
                'regex-flags': /\b[a-z]+$/,
                'regex-source': {
                    pattern: /^(~\/)[\s\S]+(?=\/$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^~\/|\/$/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'keyword', {
        preprocessor: {
            pattern: /#(?:else|elseif|end|if)\b.*/,
            alias: 'property'
        },
        metadata: {
            pattern: /@:?[\w.]+/,
            alias: 'symbol'
        },
        reification: {
            pattern: /\$(?:\w+|(?=\{))/,
            alias: 'important'
        }
    });
}

},{}],"4bvFk":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = hcl;
hcl.displayName = 'hcl';
hcl.aliases = [];
function hcl(Prism) {
    Prism.languages.hcl = {
        comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
        heredoc: {
            pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
            greedy: true,
            alias: 'string'
        },
        keyword: [
            {
                pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
                inside: {
                    type: {
                        pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            {
                pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
                inside: {
                    type: {
                        pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            /[\w-]+(?=\s+\{)/
        ],
        property: [
            /[-\w\.]+(?=\s*=(?!=))/,
            /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/
        ],
        string: {
            pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
                    lookbehind: true,
                    inside: {
                        type: {
                            pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
                            lookbehind: true,
                            alias: 'variable'
                        },
                        keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
                        function: /\w+(?=\()/,
                        string: {
                            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                            greedy: true
                        },
                        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
                        punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
                    }
                }
            }
        },
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        boolean: /\b(?:false|true)\b/i,
        punctuation: /[=\[\]{}]/
    };
}

},{}],"cJtqB":[function(require,module,exports,__globalThis) {
'use strict';
var refractorC = require("f1457f042f5096bf");
module.exports = hlsl;
hlsl.displayName = 'hlsl';
hlsl.aliases = [];
function hlsl(Prism) {
    Prism.register(refractorC);
    Prism.languages.hlsl = Prism.languages.extend('c', {
        // Regarding keywords and class names:
        // The list of all keywords was split into 'keyword' and 'class-name' tokens based on whether they are capitalized.
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-keywords
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-reserved-words
        'class-name': [
            Prism.languages.c['class-name'],
            /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/
        ],
        keyword: [
            // HLSL keyword
            /\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/,
            /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/
        ],
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-grammar#floating-point-numbers
        number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
        boolean: /\b(?:false|true)\b/
    });
}

},{"f1457f042f5096bf":"eMUEZ"}],"ayoMM":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = hoon;
hoon.displayName = 'hoon';
hoon.aliases = [];
function hoon(Prism) {
    Prism.languages.hoon = {
        comment: {
            pattern: /::.*/,
            greedy: true
        },
        string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: true
        },
        constant: /%(?:\.[ny]|[\w-]+)/,
        'class-name': /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
        function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
        keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
    };
}

},{}],"g2NwP":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = hpkp;
hpkp.displayName = 'hpkp';
hpkp.aliases = [];
function hpkp(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hpkp-cheat-sheet/
   */ Prism.languages.hpkp = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}

},{}],"nnqal":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = hsts;
hsts.displayName = 'hsts';
hsts.aliases = [];
function hsts(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hsts-cheat-sheet/
   */ Prism.languages.hsts = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}

},{}],"3W7FD":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = http;
http.displayName = 'http';
http.aliases = [];
function http(Prism) {
    (function(Prism) {
        /**
     * @param {string} name
     * @returns {RegExp}
     */ function headerValueOf(name) {
            return RegExp('(^(?:' + name + '):[ \t]*(?![ \t]))[^]+', 'i');
        }
        Prism.languages.http = {
            'request-line': {
                pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
                inside: {
                    // HTTP Method
                    method: {
                        pattern: /^[A-Z]+\b/,
                        alias: 'property'
                    },
                    // Request Target e.g. http://example.com, /path/to/file
                    'request-target': {
                        pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
                        lookbehind: true,
                        alias: 'url',
                        inside: Prism.languages.uri
                    },
                    // HTTP Version
                    'http-version': {
                        pattern: /^(\s)HTTP\/[\d.]+/,
                        lookbehind: true,
                        alias: 'property'
                    }
                }
            },
            'response-status': {
                pattern: /^HTTP\/[\d.]+ \d+ .+/m,
                inside: {
                    // HTTP Version
                    'http-version': {
                        pattern: /^HTTP\/[\d.]+/,
                        alias: 'property'
                    },
                    // Status Code
                    'status-code': {
                        pattern: /^(\s)\d+(?=\s)/,
                        lookbehind: true,
                        alias: 'number'
                    },
                    // Reason Phrase
                    'reason-phrase': {
                        pattern: /^(\s).+/,
                        lookbehind: true,
                        alias: 'string'
                    }
                }
            },
            header: {
                pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
                inside: {
                    'header-value': [
                        {
                            pattern: headerValueOf(/Content-Security-Policy/.source),
                            lookbehind: true,
                            alias: [
                                'csp',
                                'languages-csp'
                            ],
                            inside: Prism.languages.csp
                        },
                        {
                            pattern: headerValueOf(/Public-Key-Pins(?:-Report-Only)?/.source),
                            lookbehind: true,
                            alias: [
                                'hpkp',
                                'languages-hpkp'
                            ],
                            inside: Prism.languages.hpkp
                        },
                        {
                            pattern: headerValueOf(/Strict-Transport-Security/.source),
                            lookbehind: true,
                            alias: [
                                'hsts',
                                'languages-hsts'
                            ],
                            inside: Prism.languages.hsts
                        },
                        {
                            pattern: headerValueOf(/[^:]+/.source),
                            lookbehind: true
                        }
                    ],
                    'header-name': {
                        pattern: /^[^:]+/,
                        alias: 'keyword'
                    },
                    punctuation: /^:/
                }
            }
        } // Create a mapping of Content-Type headers to language definitions
        ;
        var langs = Prism.languages;
        var httpLanguages = {
            'application/javascript': langs.javascript,
            'application/json': langs.json || langs.javascript,
            'application/xml': langs.xml,
            'text/xml': langs.xml,
            'text/html': langs.html,
            'text/css': langs.css,
            'text/plain': langs.plain
        } // Declare which types can also be suffixes
        ;
        var suffixTypes = {
            'application/json': true,
            'application/xml': true
        };
        /**
     * Returns a pattern for the given content type which matches it and any type which has it as a suffix.
     *
     * @param {string} contentType
     * @returns {string}
     */ function getSuffixPattern(contentType) {
            var suffix = contentType.replace(/^[a-z]+\//, '');
            var suffixPattern = '\\w+/(?:[\\w.-]+\\+)+' + suffix + '(?![+\\w.-])';
            return '(?:' + contentType + '|' + suffixPattern + ')';
        } // Insert each content type parser that has its associated language
        // currently loaded.
        var options;
        for(var contentType in httpLanguages)if (httpLanguages[contentType]) {
            options = options || {};
            var pattern = suffixTypes[contentType] ? getSuffixPattern(contentType) : contentType;
            options[contentType.replace(/\//g, '-')] = {
                pattern: RegExp('(' + /content-type:\s*/.source + pattern + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ')' + // This is a little interesting:
                // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
                // However, when writing code by hand (e.g. to display on a website) people can forget about this,
                // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
                // the body does not start with a [\w-] character (as headers do).
                /[^ \t\w-][\s\S]*/.source, 'i'),
                lookbehind: true,
                inside: httpLanguages[contentType]
            };
        }
        if (options) Prism.languages.insertBefore('http', 'header', options);
    })(Prism);
}

},{}],"acFVn":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = ichigojam;
ichigojam.displayName = 'ichigojam';
ichigojam.aliases = [];
function ichigojam(Prism) {
    // according to the offical reference (EN)
    // https://ichigojam.net/IchigoJam-en.html
    Prism.languages.ichigojam = {
        comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
        function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
        label: /(?:\B@\S+)/,
        operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
        punctuation: /[\[,;:()\]]/
    };
}

},{}],"52web":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = icon;
icon.displayName = 'icon';
icon.aliases = [];
function icon(Prism) {
    Prism.languages.icon = {
        comment: /#.*/,
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
            greedy: true
        },
        number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
        'builtin-keyword': {
            pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
            alias: 'variable'
        },
        directive: {
            pattern: /\$\w+/,
            alias: 'builtin'
        },
        keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
        function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
        operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
        punctuation: /[\[\](){},;]/
    };
}

},{}],"8exEc":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = icuMessageFormat;
icuMessageFormat.displayName = 'icuMessageFormat';
icuMessageFormat.aliases = [];
function icuMessageFormat(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @param {number} level
     * @returns {string}
     */ function nested(source, level) {
            if (level <= 0) return /[]/.source;
            else return source.replace(/<SELF>/g, function() {
                return nested(source, level - 1);
            });
        }
        var stringPattern = /'[{}:=,](?:[^']|'')*'(?!')/;
        var escape = {
            pattern: /''/,
            greedy: true,
            alias: 'operator'
        };
        var string = {
            pattern: stringPattern,
            greedy: true,
            inside: {
                escape: escape
            }
        };
        var argumentSource = nested(/\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(/<STR>/g, function() {
            return stringPattern.source;
        }), 8);
        var nestedMessage = {
            pattern: RegExp(argumentSource),
            inside: {
                message: {
                    pattern: /^(\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: null // see below
                },
                'message-delimiter': {
                    pattern: /./,
                    alias: 'punctuation'
                }
            }
        };
        Prism.languages['icu-message-format'] = {
            argument: {
                pattern: RegExp(argumentSource),
                greedy: true,
                inside: {
                    content: {
                        pattern: /^(\{)[\s\S]+(?=\}$)/,
                        lookbehind: true,
                        inside: {
                            'argument-name': {
                                pattern: /^(\s*)[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'choice-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4c/classicu_1_1ChoiceFormat.html#details
                                pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    punctuation: /\|/,
                                    range: {
                                        pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                                        lookbehind: true,
                                        inside: {
                                            operator: /[<#\u2264]/,
                                            number: /\S+/
                                        }
                                    },
                                    rest: null // see below
                                }
                            },
                            'plural-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/PluralFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    offset: /^offset:\s*\d+/,
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /=\d+|[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^(?:few|many|one|other|two|zero)$/
                                        }
                                    }
                                }
                            },
                            'select-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/SelectFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^other$/
                                        }
                                    }
                                }
                            },
                            keyword: /\b(?:choice|plural|select|selectordinal)\b/,
                            'arg-type': {
                                pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                                alias: 'keyword'
                            },
                            'arg-skeleton': {
                                pattern: /(,\s*)::[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'arg-style': {
                                pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                                lookbehind: true
                            },
                            'arg-style-text': {
                                pattern: RegExp(/(^\s*,\s*(?=\S))/.source + nested(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + '$'),
                                lookbehind: true,
                                alias: 'string'
                            },
                            punctuation: /,/
                        }
                    },
                    'argument-delimiter': {
                        pattern: /./,
                        alias: 'operator'
                    }
                }
            },
            escape: escape,
            string: string
        };
        nestedMessage.inside.message.inside = Prism.languages['icu-message-format'];
        Prism.languages['icu-message-format'].argument.inside.content.inside['choice-style'].inside.rest = Prism.languages['icu-message-format'];
    })(Prism);
}

},{}],"4i42F":[function(require,module,exports,__globalThis) {
'use strict';
var refractorHaskell = require("657e6c5e1922579a");
module.exports = idris;
idris.displayName = 'idris';
idris.aliases = [
    'idr'
];
function idris(Prism) {
    Prism.register(refractorHaskell);
    Prism.languages.idris = Prism.languages.extend('haskell', {
        comment: {
            pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
        },
        keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
        builtin: undefined
    });
    Prism.languages.insertBefore('idris', 'keyword', {
        'import-statement': {
            pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    });
    Prism.languages.idr = Prism.languages.idris;
}

},{"657e6c5e1922579a":"kvyjG"}],"2TbDH":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = iecst;
iecst.displayName = 'iecst';
iecst.aliases = [];
function iecst(Prism) {
    Prism.languages.iecst = {
        comment: [
            {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: [
            /\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i,
            /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/
        ],
        'class-name': /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
        address: {
            pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
            alias: 'symbol'
        },
        number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/,
        operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        punctuation: /[()[\].,;]/
    };
}

},{}],"3EMpt":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = ignore;
ignore.displayName = 'ignore';
ignore.aliases = [
    'gitignore',
    'hgignore',
    'npmignore'
];
function ignore(Prism) {
    (function(Prism) {
        Prism.languages.ignore = {
            // https://git-scm.com/docs/gitignore
            comment: /^#.*/m,
            entry: {
                pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
                alias: 'string',
                inside: {
                    operator: /^!|\*\*?|\?/,
                    regex: {
                        pattern: /(^|[^\\])\[[^\[\]]*\]/,
                        lookbehind: true
                    },
                    punctuation: /\//
                }
            }
        };
        Prism.languages.gitignore = Prism.languages.ignore;
        Prism.languages.hgignore = Prism.languages.ignore;
        Prism.languages.npmignore = Prism.languages.ignore;
    })(Prism);
}

},{}],"f1VFC":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = inform7;
inform7.displayName = 'inform7';
inform7.aliases = [];
function inform7(Prism) {
    Prism.languages.inform7 = {
        string: {
            pattern: /"[^"]*"/,
            inside: {
                substitution: {
                    pattern: /\[[^\[\]]+\]/,
                    inside: {
                        delimiter: {
                            pattern: /\[|\]/,
                            alias: 'punctuation'
                        } // See rest below
                    }
                }
            }
        },
        comment: {
            pattern: /\[[^\[\]]+\]/,
            greedy: true
        },
        title: {
            pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
            alias: 'important'
        },
        number: {
            pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
            lookbehind: true
        },
        verb: {
            pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
            lookbehind: true,
            alias: 'operator'
        },
        keyword: {
            pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
            lookbehind: true
        },
        property: {
            pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
            lookbehind: true,
            alias: 'symbol'
        },
        position: {
            pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
            lookbehind: true,
            alias: 'variable'
        },
        punctuation: /[.,:;(){}]/
    };
    Prism.languages.inform7['string'].inside['substitution'].inside.rest = Prism.languages.inform7 // We don't want the remaining text in the substitution to be highlighted as the string.
    ;
    Prism.languages.inform7['string'].inside['substitution'].inside.rest.text = {
        pattern: /\S(?:\s*\S)*/,
        alias: 'comment'
    };
}

},{}],"y4vWu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = ini;
ini.displayName = 'ini';
ini.aliases = [];
function ini(Prism) {
    Prism.languages.ini = {
        /**
     * The component mimics the behavior of the Win32 API parser.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2775#issuecomment-787477723}
     */ comment: {
            pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
            lookbehind: true
        },
        section: {
            pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
            lookbehind: true,
            inside: {
                'section-name': {
                    pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
                    lookbehind: true,
                    alias: 'selector'
                },
                punctuation: /\[|\]/
            }
        },
        key: {
            pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
            lookbehind: true,
            alias: 'attr-value',
            inside: {
                'inner-value': {
                    pattern: /^("|').+(?=\1$)/,
                    lookbehind: true
                }
            }
        },
        punctuation: /=/
    };
}

},{}],"kWeeS":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = io;
io.displayName = 'io';
io.aliases = [];
function io(Prism) {
    Prism.languages.io = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
            lookbehind: true,
            greedy: true
        },
        'triple-quoted-string': {
            pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /"(?:\\.|[^\\\r\n"])*"/,
            greedy: true
        },
        keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
        builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
        operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
        punctuation: /[{}[\];(),.:]/
    };
}

},{}],"9DpWu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = j;
j.displayName = 'j';
j.aliases = [];
function j(Prism) {
    Prism.languages.j = {
        comment: {
            pattern: /\bNB\..*/,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
        verb: {
            // Negative look-ahead prevents bad highlighting
            // of ^: ;. =. =: !. !:
            pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
            alias: 'keyword'
        },
        number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
        adverb: {
            pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
            alias: 'builtin'
        },
        operator: /[=a][.:]|_\./,
        conjunction: {
            pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
            alias: 'variable'
        },
        punctuation: /[()]/
    };
}

},{}],"5biU1":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = java;
java.displayName = 'java';
java.aliases = [];
function java(Prism) {
    (function(Prism) {
        var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/ // full package (optional) + parent classes (optional)
        ;
        var classNamePrefix = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source // based on the java naming conventions
        ;
        var className = {
            pattern: RegExp(classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /\./
            }
        };
        Prism.languages.java = Prism.languages.extend('clike', {
            string: {
                pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
                lookbehind: true,
                greedy: true
            },
            'class-name': [
                className,
                {
                    // variables and parameters
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            function: [
                Prism.languages.clike.function,
                {
                    pattern: /(::\s*)[a-z_]\w*/,
                    lookbehind: true
                }
            ],
            number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
            operator: {
                pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
                lookbehind: true
            }
        });
        Prism.languages.insertBefore('java', 'string', {
            'triple-quoted-string': {
                // http://openjdk.java.net/jeps/355#Description
                pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
                greedy: true,
                alias: 'string'
            },
            char: {
                pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
                greedy: true
            }
        });
        Prism.languages.insertBefore('java', 'class-name', {
            annotation: {
                pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
                lookbehind: true,
                alias: 'punctuation'
            },
            generics: {
                pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            },
            namespace: {
                pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
                    return keywords.source;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
    })(Prism);
}

},{}],"bMcbL":[function(require,module,exports,__globalThis) {
'use strict';
var refractorJava = require("f6c817150ec551e9");
var refractorJavadoclike = require("b5de13a9bf2bbe4");
module.exports = javadoc;
javadoc.displayName = 'javadoc';
javadoc.aliases = [];
function javadoc(Prism) {
    Prism.register(refractorJava);
    Prism.register(refractorJavadoclike);
    (function(Prism) {
        var codeLinePattern = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m;
        var memberReference = /#\s*\w+(?:\s*\([^()]*\))?/.source;
        var reference = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(/<mem>/g, function() {
            return memberReference;
        });
        Prism.languages.javadoc = Prism.languages.extend('javadoclike', {});
        Prism.languages.insertBefore('javadoc', 'keyword', {
            reference: {
                pattern: RegExp(/(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + '(?:' + reference + ')'),
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /(#\s*)\w+(?=\s*\()/,
                        lookbehind: true
                    },
                    field: {
                        pattern: /(#\s*)\w+/,
                        lookbehind: true
                    },
                    namespace: {
                        pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    'class-name': /\b[A-Z]\w*/,
                    keyword: Prism.languages.java.keyword,
                    punctuation: /[#()[\],.]/
                }
            },
            'class-name': {
                // @param <T> the first generic type parameter
                pattern: /(@param\s+)<[A-Z]\w*>/,
                lookbehind: true,
                inside: {
                    punctuation: /[.<>]/
                }
            },
            'code-section': [
                {
                    pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
                    lookbehind: true,
                    inside: {
                        code: {
                            // there can't be any HTML inside of {@code} tags
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: Prism.languages.java,
                            alias: 'language-java'
                        }
                    }
                },
                {
                    pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
                    lookbehind: true,
                    inside: {
                        line: {
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: {
                                // highlight HTML tags and entities
                                tag: Prism.languages.markup.tag,
                                entity: Prism.languages.markup.entity,
                                code: {
                                    // everything else is Java code
                                    pattern: /.+/,
                                    inside: Prism.languages.java,
                                    alias: 'language-java'
                                }
                            }
                        }
                    }
                }
            ],
            tag: Prism.languages.markup.tag,
            entity: Prism.languages.markup.entity
        });
        Prism.languages.javadoclike.addSupport('java', Prism.languages.javadoc);
    })(Prism);
}

},{"f6c817150ec551e9":"5biU1","b5de13a9bf2bbe4":"kn1Ox"}],"kn1Ox":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = javadoclike;
javadoclike.displayName = 'javadoclike';
javadoclike.aliases = [];
function javadoclike(Prism) {
    (function(Prism) {
        var javaDocLike = Prism.languages.javadoclike = {
            parameter: {
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
                lookbehind: true
            },
            keyword: {
                // keywords are the first word in a line preceded be an `@` or surrounded by curly braces.
                // @word, {@word}
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
                lookbehind: true
            },
            punctuation: /[{}]/
        };
        /**
     * Adds doc comment support to the given language and calls a given callback on each doc comment pattern.
     *
     * @param {string} lang the language add doc comment support to.
     * @param {(pattern: {inside: {rest: undefined}}) => void} callback the function called with each doc comment pattern as argument.
     */ function docCommentSupport(lang, callback) {
            var tokenName = 'doc-comment';
            var grammar = Prism.languages[lang];
            if (!grammar) return;
            var token = grammar[tokenName];
            if (!token) {
                // add doc comment: /** */
                var definition = {};
                definition[tokenName] = {
                    pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    alias: 'comment'
                };
                grammar = Prism.languages.insertBefore(lang, 'comment', definition);
                token = grammar[tokenName];
            }
            if (token instanceof RegExp) // convert regex to object
            token = grammar[tokenName] = {
                pattern: token
            };
            if (Array.isArray(token)) for(var i = 0, l = token.length; i < l; i++){
                if (token[i] instanceof RegExp) token[i] = {
                    pattern: token[i]
                };
                callback(token[i]);
            }
            else callback(token);
        }
        /**
     * Adds doc-comment support to the given languages for the given documentation language.
     *
     * @param {string[]|string} languages
     * @param {Object} docLanguage
     */ function addSupport(languages, docLanguage) {
            if (typeof languages === 'string') languages = [
                languages
            ];
            languages.forEach(function(lang) {
                docCommentSupport(lang, function(pattern) {
                    if (!pattern.inside) pattern.inside = {};
                    pattern.inside.rest = docLanguage;
                });
            });
        }
        Object.defineProperty(javaDocLike, 'addSupport', {
            value: addSupport
        });
        javaDocLike.addSupport([
            'java',
            'javascript',
            'php'
        ], javaDocLike);
    })(Prism);
}

},{}],"3QjWX":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = javastacktrace;
javastacktrace.displayName = 'javastacktrace';
javastacktrace.aliases = [];
function javastacktrace(Prism) {
    // Specification:
    // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/Throwable.html#printStackTrace()
    Prism.languages.javastacktrace = {
        // java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: com.example.myproject.MyProjectServletException
        // Caused by: MidLevelException: LowLevelException
        // Suppressed: Resource$CloseFailException: Resource ID = 0
        summary: {
            pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
                    lookbehind: true
                },
                // the current thread if the summary starts with 'Exception in thread'
                string: {
                    pattern: /^(\s*)"[^"]*"/,
                    lookbehind: true
                },
                exceptions: {
                    pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
                    lookbehind: true,
                    inside: {
                        'class-name': /[\w$]+$/,
                        namespace: /\b[a-z]\w*\b/,
                        punctuation: /\./
                    }
                },
                message: {
                    pattern: /(:\s*)\S.*/,
                    lookbehind: true,
                    alias: 'string'
                },
                punctuation: /:/
            }
        },
        // at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
        // at org.hsqldb.jdbc.Util.throwError(Unknown Source) here could be some notes
        // at java.base/java.lang.Class.forName0(Native Method)
        // at Util.<init>(Unknown Source)
        // at com.foo.loader/foo@9.0/com.foo.Main.run(Main.java:101)
        // at com.foo.loader//com.foo.bar.App.run(App.java:12)
        // at acme@2.1/org.acme.Lib.test(Lib.java:80)
        // at MyClass.mash(MyClass.java:9)
        //
        // More information:
        // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/StackTraceElement.html#toString()
        //
        // A valid Java module name is defined as:
        //   "A module name consists of one or more Java identifiers (§3.8) separated by "." tokens."
        // https://docs.oracle.com/javase/specs/jls/se9/html/jls-6.html#jls-ModuleName
        //
        // A Java module version is defined by this class:
        // https://docs.oracle.com/javase/9/docs/api/java/lang/module/ModuleDescriptor.Version.html
        // This is the implementation of the `parse` method in JDK13:
        // https://github.com/matcdac/jdk/blob/2305df71d1b7710266ae0956d73927a225132c0f/src/java.base/share/classes/java/lang/module/ModuleDescriptor.java#L1108
        // However, to keep this simple, a version will be matched by the pattern /@[\w$.+-]*/.
        'stack-frame': {
            pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^(\s*)at(?= )/,
                    lookbehind: true
                },
                source: [
                    // (Main.java:15)
                    // (Main.scala:15)
                    {
                        pattern: /(\()\w+\.\w+:\d+(?=\))/,
                        lookbehind: true,
                        inside: {
                            file: /^\w+\.\w+/,
                            punctuation: /:/,
                            'line-number': {
                                pattern: /\b\d+\b/,
                                alias: 'number'
                            }
                        }
                    },
                    // (Native Method)
                    // (...something...)
                    {
                        pattern: /(\()[^()]*(?=\))/,
                        lookbehind: true,
                        inside: {
                            keyword: /^(?:Native Method|Unknown Source)$/
                        }
                    }
                ],
                'class-name': /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
                function: /(?:<init>|[\w$]+)(?=\()/,
                'class-loader': {
                    pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /\./
                    }
                },
                module: {
                    pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
                    lookbehind: true,
                    inside: {
                        version: {
                            pattern: /(@)[\s\S]+/,
                            lookbehind: true,
                            alias: 'number'
                        },
                        punctuation: /[@.]/
                    }
                },
                namespace: {
                    pattern: /(?:\b[a-z]\w*\.)+/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()/.]/
            }
        },
        // ... 32 more
        // ... 32 common frames omitted
        more: {
            pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\.{3}/,
                number: /\d+/,
                keyword: /\b[a-z]+(?: [a-z]+)*\b/
            }
        }
    };
}

},{}],"cBwEb":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = jexl;
jexl.displayName = 'jexl';
jexl.aliases = [];
function jexl(Prism) {
    Prism.languages.jexl = {
        string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        transform: {
            pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
            alias: 'function',
            lookbehind: true
        },
        function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
        number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
        operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
        boolean: /\b(?:false|true)\b/,
        keyword: /\bin\b/,
        punctuation: /[{}[\](),.]/
    };
}

},{}],"kJ9Rg":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = jolie;
jolie.displayName = 'jolie';
jolie.aliases = [];
function jolie(Prism) {
    Prism.languages.jolie = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
        operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
        punctuation: /[()[\]{},;.:]/,
        builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
    });
    Prism.languages.insertBefore('jolie', 'keyword', {
        aggregates: {
            pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
            lookbehind: true,
            inside: {
                keyword: /\bwith\b/,
                'class-name': /\w+/,
                punctuation: /,/
            }
        },
        redirects: {
            pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
            lookbehind: true,
            inside: {
                punctuation: /,/,
                'class-name': /\w+/,
                operator: /=>/
            }
        },
        property: {
            pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
        }
    });
}

},{}],"pxFW6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = jq;
jq.displayName = 'jq';
jq.aliases = [];
function jq(Prism) {
    (function(Prism) {
        var interpolation = /\\\((?:[^()]|\([^()]*\))*\)/.source;
        var string = RegExp(/(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(/__/g, function() {
            return interpolation;
        }));
        var stringInterpolation = {
            interpolation: {
                pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + interpolation),
                lookbehind: true,
                inside: {
                    content: {
                        pattern: /^(\\\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    punctuation: /^\\\(|\)$/
                }
            }
        };
        var jq = Prism.languages.jq = {
            comment: /#.*/,
            property: {
                pattern: RegExp(string.source + /(?=\s*:(?!:))/.source),
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            string: {
                pattern: string,
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            function: {
                pattern: /(\bdef\s+)[a-z_]\w+/i,
                lookbehind: true
            },
            variable: /\B\$\w+/,
            'property-literal': {
                pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
                alias: 'property'
            },
            keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
            boolean: /\b(?:false|true)\b/,
            number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
            operator: [
                {
                    pattern: /\|=?/,
                    alias: 'pipe'
                },
                /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/
            ],
            'c-style-function': {
                pattern: /\b[a-z_]\w*(?=\s*\()/i,
                alias: 'function'
            },
            punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
            dot: {
                pattern: /\./,
                alias: 'important'
            }
        };
        stringInterpolation.interpolation.inside.content.inside = jq;
    })(Prism);
}

},{}],"6bsAN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = jsExtras;
jsExtras.displayName = 'jsExtras';
jsExtras.aliases = [];
function jsExtras(Prism) {
    (function(Prism) {
        Prism.languages.insertBefore('javascript', 'function-variable', {
            'method-variable': {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function-variable'].pattern.source),
                lookbehind: true,
                alias: [
                    'function-variable',
                    'method',
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'function', {
            method: {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function'].source),
                lookbehind: true,
                alias: [
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'constant', {
            'known-class-name': [
                {
                    // standard built-ins
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
                    pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                    alias: 'class-name'
                },
                {
                    // errors
                    pattern: /\b(?:[A-Z]\w*)Error\b/,
                    alias: 'class-name'
                }
            ]
        });
        /**
     * Replaces the `<ID>` placeholder in the given pattern with a pattern for general JS identifiers.
     *
     * @param {string} source
     * @param {string} [flags]
     * @returns {RegExp}
     */ function withId(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
            }), flags);
        }
        Prism.languages.insertBefore('javascript', 'keyword', {
            imports: {
                // https://tc39.es/ecma262/#sec-imports
                pattern: withId(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            exports: {
                // https://tc39.es/ecma262/#sec-exports
                pattern: withId(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        });
        Prism.languages.javascript['keyword'].unshift({
            pattern: /\b(?:as|default|export|from|import)\b/,
            alias: 'module'
        }, {
            pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
            alias: 'control-flow'
        }, {
            pattern: /\bnull\b/,
            alias: [
                'null',
                'nil'
            ]
        }, {
            pattern: /\bundefined\b/,
            alias: 'nil'
        });
        Prism.languages.insertBefore('javascript', 'operator', {
            spread: {
                pattern: /\.{3}/,
                alias: 'operator'
            },
            arrow: {
                pattern: /=>/,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('javascript', 'punctuation', {
            'property-access': {
                pattern: withId(/(\.\s*)#?<ID>/.source),
                lookbehind: true
            },
            'maybe-class-name': {
                pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
                lookbehind: true
            },
            dom: {
                // this contains only a few commonly used DOM variables
                pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
                alias: 'variable'
            },
            console: {
                pattern: /\bconsole(?=\s*\.)/,
                alias: 'class-name'
            }
        }) // add 'maybe-class-name' to tokens which might be a class name
        ;
        var maybeClassNameTokens = [
            'function',
            'function-variable',
            'method',
            'method-variable',
            'property-access'
        ];
        for(var i = 0; i < maybeClassNameTokens.length; i++){
            var token = maybeClassNameTokens[i];
            var value = Prism.languages.javascript[token] // convert regex to object
            ;
            if (Prism.util.type(value) === 'RegExp') value = Prism.languages.javascript[token] = {
                pattern: value
            };
             // keep in mind that we don't support arrays
            var inside = value.inside || {};
            value.inside = inside;
            inside['maybe-class-name'] = /^[A-Z][\s\S]*/;
        }
    })(Prism);
}

},{}],"bMEaJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = jsTemplates;
jsTemplates.displayName = 'jsTemplates';
jsTemplates.aliases = [];
function jsTemplates(Prism) {
    (function(Prism) {
        var templateString = Prism.languages.javascript['template-string'] // see the pattern in prism-javascript.js
        ;
        var templateLiteralPattern = templateString.pattern.source;
        var interpolationObject = templateString.inside['interpolation'];
        var interpolationPunctuationObject = interpolationObject.inside['interpolation-punctuation'];
        var interpolationPattern = interpolationObject.pattern.source;
        /**
     * Creates a new pattern to match a template string with a special tag.
     *
     * This will return `undefined` if there is no grammar with the given language id.
     *
     * @param {string} language The language id of the embedded language. E.g. `markdown`.
     * @param {string} tag The regex pattern to match the tag.
     * @returns {object | undefined}
     * @example
     * createTemplate('css', /\bcss/.source);
     */ function createTemplate(language, tag) {
            if (!Prism.languages[language]) return undefined;
            return {
                pattern: RegExp('((?:' + tag + ')\\s*)' + templateLiteralPattern),
                lookbehind: true,
                greedy: true,
                inside: {
                    'template-punctuation': {
                        pattern: /^`|`$/,
                        alias: 'string'
                    },
                    'embedded-code': {
                        pattern: /[\s\S]+/,
                        alias: language
                    }
                }
            };
        }
        Prism.languages.javascript['template-string'] = [
            // styled-jsx:
            //   css`a { color: #25F; }`
            // styled-components:
            //   styled.h1`color: red;`
            createTemplate('css', /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
            // div.innerHTML = `<p></p>`
            createTemplate('html', /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
            createTemplate('svg', /\bsvg/.source),
            createTemplate('markdown', /\b(?:markdown|md)/.source),
            createTemplate('graphql', /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
            createTemplate('sql', /\bsql/.source),
            templateString
        ].filter(Boolean);
        /**
     * Returns a specific placeholder literal for the given language.
     *
     * @param {number} counter
     * @param {string} language
     * @returns {string}
     */ function getPlaceholder(counter, language) {
            return '___' + language.toUpperCase() + '_' + counter + '___';
        }
        /**
     * Returns the tokens of `Prism.tokenize` but also runs the `before-tokenize` and `after-tokenize` hooks.
     *
     * @param {string} code
     * @param {any} grammar
     * @param {string} language
     * @returns {(string|Token)[]}
     */ function tokenizeWithHooks(code, grammar, language) {
            var env = {
                code: code,
                grammar: grammar,
                language: language
            };
            Prism.hooks.run('before-tokenize', env);
            env.tokens = Prism.tokenize(env.code, env.grammar);
            Prism.hooks.run('after-tokenize', env);
            return env.tokens;
        }
        /**
     * Returns the token of the given JavaScript interpolation expression.
     *
     * @param {string} expression The code of the expression. E.g. `"${42}"`
     * @returns {Token}
     */ function tokenizeInterpolationExpression(expression) {
            var tempGrammar = {};
            tempGrammar['interpolation-punctuation'] = interpolationPunctuationObject;
            /** @type {Array} */ var tokens = Prism.tokenize(expression, tempGrammar);
            if (tokens.length === 3) {
                /**
         * The token array will look like this
         * [
         *     ["interpolation-punctuation", "${"]
         *     "..." // JavaScript expression of the interpolation
         *     ["interpolation-punctuation", "}"]
         * ]
         */ var args = [
                    1,
                    1
                ];
                args.push.apply(args, tokenizeWithHooks(tokens[1], Prism.languages.javascript, 'javascript'));
                tokens.splice.apply(tokens, args);
            }
            return new Prism.Token('interpolation', tokens, interpolationObject.alias, expression);
        }
        /**
     * Tokenizes the given code with support for JavaScript interpolation expressions mixed in.
     *
     * This function has 3 phases:
     *
     * 1. Replace all JavaScript interpolation expression with a placeholder.
     *    The placeholder will have the syntax of a identify of the target language.
     * 2. Tokenize the code with placeholders.
     * 3. Tokenize the interpolation expressions and re-insert them into the tokenize code.
     *    The insertion only works if a placeholder hasn't been "ripped apart" meaning that the placeholder has been
     *    tokenized as two tokens by the grammar of the embedded language.
     *
     * @param {string} code
     * @param {object} grammar
     * @param {string} language
     * @returns {Token}
     */ function tokenizeEmbedded(code, grammar, language) {
            // 1. First filter out all interpolations
            // because they might be escaped, we need a lookbehind, so we use Prism
            /** @type {(Token|string)[]} */ var _tokens = Prism.tokenize(code, {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    lookbehind: true
                }
            }) // replace all interpolations with a placeholder which is not in the code already
            ;
            var placeholderCounter = 0;
            /** @type {Object<string, string>} */ var placeholderMap = {};
            var embeddedCode = _tokens.map(function(token) {
                if (typeof token === 'string') return token;
                else {
                    var interpolationExpression = token.content;
                    var placeholder;
                    while(code.indexOf(placeholder = getPlaceholder(placeholderCounter++, language)) !== -1);
                    placeholderMap[placeholder] = interpolationExpression;
                    return placeholder;
                }
            }).join('') // 2. Tokenize the embedded code
            ;
            var embeddedTokens = tokenizeWithHooks(embeddedCode, grammar, language) // 3. Re-insert the interpolation
            ;
            var placeholders = Object.keys(placeholderMap);
            placeholderCounter = 0;
            /**
       *
       * @param {(Token|string)[]} tokens
       * @returns {void}
       */ function walkTokens(tokens) {
                for(var i = 0; i < tokens.length; i++){
                    if (placeholderCounter >= placeholders.length) return;
                    var token = tokens[i];
                    if (typeof token === 'string' || typeof token.content === 'string') {
                        var placeholder = placeholders[placeholderCounter];
                        var s = typeof token === 'string' ? token : /** @type {string} */ token.content;
                        var index = s.indexOf(placeholder);
                        if (index !== -1) {
                            ++placeholderCounter;
                            var before = s.substring(0, index);
                            var middle = tokenizeInterpolationExpression(placeholderMap[placeholder]);
                            var after = s.substring(index + placeholder.length);
                            var replacement = [];
                            if (before) replacement.push(before);
                            replacement.push(middle);
                            if (after) {
                                var afterTokens = [
                                    after
                                ];
                                walkTokens(afterTokens);
                                replacement.push.apply(replacement, afterTokens);
                            }
                            if (typeof token === 'string') {
                                tokens.splice.apply(tokens, [
                                    i,
                                    1
                                ].concat(replacement));
                                i += replacement.length - 1;
                            } else token.content = replacement;
                        }
                    } else {
                        var content = token.content;
                        if (Array.isArray(content)) walkTokens(content);
                        else walkTokens([
                            content
                        ]);
                    }
                }
            }
            walkTokens(embeddedTokens);
            return new Prism.Token(language, embeddedTokens, 'language-' + language, code);
        }
        /**
     * The languages for which JS templating will handle tagged template literals.
     *
     * JS templating isn't active for only JavaScript but also related languages like TypeScript, JSX, and TSX.
     */ var supportedLanguages = {
            javascript: true,
            js: true,
            typescript: true,
            ts: true,
            jsx: true,
            tsx: true
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (!(env.language in supportedLanguages)) return;
            /**
       * Finds and tokenizes all template strings with an embedded languages.
       *
       * @param {(Token | string)[]} tokens
       * @returns {void}
       */ function findTemplateStrings(tokens) {
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (typeof token === 'string') continue;
                    var content = token.content;
                    if (!Array.isArray(content)) {
                        if (typeof content !== 'string') findTemplateStrings([
                            content
                        ]);
                        continue;
                    }
                    if (token.type === 'template-string') {
                        /**
             * A JavaScript template-string token will look like this:
             *
             * ["template-string", [
             *     ["template-punctuation", "`"],
             *     (
             *         An array of "string" and "interpolation" tokens. This is the simple string case.
             *         or
             *         ["embedded-code", "..."] This is the token containing the embedded code.
             *                                  It also has an alias which is the language of the embedded code.
             *     ),
             *     ["template-punctuation", "`"]
             * ]]
             */ var embedded = content[1];
                        if (content.length === 3 && typeof embedded !== 'string' && embedded.type === 'embedded-code') {
                            // get string content
                            var code = stringContent(embedded);
                            var alias = embedded.alias;
                            var language = Array.isArray(alias) ? alias[0] : alias;
                            var grammar = Prism.languages[language];
                            if (!grammar) continue;
                            content[1] = tokenizeEmbedded(code, grammar, language);
                        }
                    } else findTemplateStrings(content);
                }
            }
            findTemplateStrings(env.tokens);
        });
        /**
     * Returns the string content of a token or token stream.
     *
     * @param {string | Token | (string | Token)[]} value
     * @returns {string}
     */ function stringContent(value) {
            if (typeof value === 'string') return value;
            else if (Array.isArray(value)) return value.map(stringContent).join('');
            else return stringContent(value.content);
        }
    })(Prism);
}

},{}],"fRfAx":[function(require,module,exports,__globalThis) {
'use strict';
var refractorJavadoclike = require("30c601f3f25d3fc6");
var refractorTypescript = require("580f8770cba907ee");
module.exports = jsdoc;
jsdoc.displayName = 'jsdoc';
jsdoc.aliases = [];
function jsdoc(Prism) {
    Prism.register(refractorJavadoclike);
    Prism.register(refractorTypescript);
    (function(Prism) {
        var javascript = Prism.languages.javascript;
        var type = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source;
        var parameterPrefix = '(@(?:arg|argument|param|property)\\s+(?:' + type + '\\s+)?)';
        Prism.languages.jsdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                // @param {string} foo - foo bar
                pattern: RegExp(parameterPrefix + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('jsdoc', 'keyword', {
            'optional-parameter': {
                // @param {string} [baz.foo="bar"] foo bar
                pattern: RegExp(parameterPrefix + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    parameter: {
                        pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    code: {
                        pattern: /(=)[\s\S]*(?=\]$)/,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    },
                    punctuation: /[=[\]]/
                }
            },
            'class-name': [
                {
                    pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                {
                    pattern: RegExp('(@[a-z]+\\s+)' + type),
                    lookbehind: true,
                    inside: {
                        string: javascript.string,
                        number: javascript.number,
                        boolean: javascript.boolean,
                        keyword: Prism.languages.typescript.keyword,
                        operator: /=>|\.\.\.|[&|?:*]/,
                        punctuation: /[.,;=<>{}()[\]]/
                    }
                }
            ],
            example: {
                pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
                lookbehind: true,
                inside: {
                    code: {
                        pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    }
                }
            }
        });
        Prism.languages.javadoclike.addSupport('javascript', Prism.languages.jsdoc);
    })(Prism);
}

},{"30c601f3f25d3fc6":"kn1Ox","580f8770cba907ee":"78nM7"}],"78nM7":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = typescript;
typescript.displayName = 'typescript';
typescript.aliases = [
    'ts'
];
function typescript(Prism) {
    (function(Prism) {
        Prism.languages.typescript = Prism.languages.extend('javascript', {
            'class-name': {
                pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
        }) // The keywords TypeScript adds to JavaScript
        ;
        Prism.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/) // doesn't work with TS because TS is too complex
        ;
        delete Prism.languages.typescript['parameter'];
        delete Prism.languages.typescript['literal-property'] // a version of typescript specifically for highlighting types
        ;
        var typeInside = Prism.languages.extend('typescript', {});
        delete typeInside['class-name'];
        Prism.languages.typescript['class-name'].inside = typeInside;
        Prism.languages.insertBefore('typescript', 'function', {
            decorator: {
                pattern: /@[$\w\xA0-\uFFFF]+/,
                inside: {
                    at: {
                        pattern: /^@/,
                        alias: 'operator'
                    },
                    function: /^[\s\S]+/
                }
            },
            'generic-function': {
                // e.g. foo<T extends "bar" | "baz">( ...
                pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
                greedy: true,
                inside: {
                    function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        // everything after the first <
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            }
        });
        Prism.languages.ts = Prism.languages.typescript;
    })(Prism);
}

},{}],"fmEU2":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = json;
json.displayName = 'json';
json.aliases = [
    'webmanifest'
];
function json(Prism) {
    // https://www.json.org/json-en.html
    Prism.languages.json = {
        property: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\],]/,
        operator: /:/,
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        }
    };
    Prism.languages.webmanifest = Prism.languages.json;
}

},{}],"ljcfb":[function(require,module,exports,__globalThis) {
'use strict';
var refractorJson = require("26822cf876ad59bb");
module.exports = json5;
json5.displayName = 'json5';
json5.aliases = [];
function json5(Prism) {
    Prism.register(refractorJson);
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
        Prism.languages.json5 = Prism.languages.extend('json', {
            property: [
                {
                    pattern: RegExp(string.source + '(?=\\s*:)'),
                    greedy: true
                },
                {
                    pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
                    alias: 'unquoted'
                }
            ],
            string: {
                pattern: string,
                greedy: true
            },
            number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
        });
    })(Prism);
}

},{"26822cf876ad59bb":"fmEU2"}],"3KPM5":[function(require,module,exports,__globalThis) {
'use strict';
var refractorJson = require("971c46331e789de0");
module.exports = jsonp;
jsonp.displayName = 'jsonp';
jsonp.aliases = [];
function jsonp(Prism) {
    Prism.register(refractorJson);
    Prism.languages.jsonp = Prism.languages.extend('json', {
        punctuation: /[{}[\]();,.]/
    });
    Prism.languages.insertBefore('jsonp', 'punctuation', {
        function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
    });
}

},{"971c46331e789de0":"fmEU2"}],"6TcDD":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = jsstacktrace;
jsstacktrace.displayName = 'jsstacktrace';
jsstacktrace.aliases = [];
function jsstacktrace(Prism) {
    Prism.languages.jsstacktrace = {
        'error-message': {
            pattern: /^\S.*/m,
            alias: 'string'
        },
        'stack-frame': {
            pattern: /(^[ \t]+)at[ \t].*/m,
            lookbehind: true,
            inside: {
                'not-my-code': {
                    pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
                    alias: 'comment'
                },
                filename: {
                    pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
                    lookbehind: true,
                    alias: 'url'
                },
                function: {
                    pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()]/,
                keyword: /\b(?:at|new)\b/,
                alias: {
                    pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
                    alias: 'variable'
                },
                'line-number': {
                    pattern: /:\d+(?::\d+)?\b/,
                    alias: 'number',
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        }
    };
}

},{}],"alaWJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = jsx;
jsx.displayName = 'jsx';
jsx.aliases = [];
function jsx(Prism) {
    (function(Prism) {
        var javascript = Prism.util.clone(Prism.languages.javascript);
        var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
        var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
        var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function re(source, flags) {
            source = source.replace(/<S>/g, function() {
                return space;
            }).replace(/<BRACES>/g, function() {
                return braces;
            }).replace(/<SPREAD>/g, function() {
                return spread;
            });
            return RegExp(source, flags);
        }
        spread = re(spread).source;
        Prism.languages.jsx = Prism.languages.extend('markup', javascript);
        Prism.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
        Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
        Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
        Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
        Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];
        Prism.languages.insertBefore('inside', 'attr-name', {
            spread: {
                pattern: re(/<SPREAD>/.source),
                inside: Prism.languages.jsx
            }
        }, Prism.languages.jsx.tag);
        Prism.languages.insertBefore('inside', 'special-attr', {
            script: {
                // Allow for two levels of nesting
                pattern: re(/=<BRACES>/.source),
                alias: 'language-javascript',
                inside: {
                    'script-punctuation': {
                        pattern: /^=(?=\{)/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.jsx
                }
            }
        }, Prism.languages.jsx.tag) // The following will handle plain text inside tags
        ;
        var stringifyToken = function(token) {
            if (!token) return '';
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside a JSX context.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token) // And merge text with adjacent text
                        ;
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'jsx' && env.language !== 'tsx') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}

},{}],"aeL6z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = julia;
julia.displayName = 'julia';
julia.aliases = [];
function julia(Prism) {
    Prism.languages.julia = {
        comment: {
            // support one level of nested comments
            // https://github.com/JuliaLang/julia/pull/6128
            pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
            lookbehind: true
        },
        regex: {
            // https://docs.julialang.org/en/v1/manual/strings/#Regular-Expressions-1
            pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
            greedy: true
        },
        string: {
            // https://docs.julialang.org/en/v1/manual/strings/#String-Basics-1
            // https://docs.julialang.org/en/v1/manual/strings/#non-standard-string-literals-1
            // https://docs.julialang.org/en/v1/manual/running-external-programs/#Running-External-Programs-1
            pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
            greedy: true
        },
        char: {
            // https://docs.julialang.org/en/v1/manual/strings/#man-characters-1
            pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/#Operator-Precedence-and-Associativity-1
        operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
        punctuation: /::?|[{}[\]();,.?]/,
        // https://docs.julialang.org/en/v1/base/numbers/#Base.im
        constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
    };
}

},{}],"eW1Ps":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = keepalived;
keepalived.displayName = 'keepalived';
keepalived.aliases = [];
function keepalived(Prism) {
    Prism.languages.keepalived = {
        comment: {
            pattern: /[#!].*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
            lookbehind: true,
            greedy: true
        },
        // support IPv4, IPv6, subnet mask
        ip: {
            pattern: RegExp(/\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(/<ipv4>/g, function() {
                return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
            }), 'i'),
            alias: 'number'
        },
        // support *nix / Windows, directory / file
        path: {
            pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
            lookbehind: true,
            alias: 'string'
        },
        variable: /\$\{?\w+\}?/,
        email: {
            pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
            alias: 'string'
        },
        'conditional-configuration': {
            pattern: /@\^?[\w-]+/,
            alias: 'variable'
        },
        operator: /=/,
        property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
        constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
        number: {
            pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
            lookbehind: true
        },
        boolean: /\b(?:false|no|off|on|true|yes)\b/,
        punctuation: /[\{\}]/
    };
}

},{}],"2SmHt":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = keyman;
keyman.displayName = 'keyman';
keyman.aliases = [];
function keyman(Prism) {
    Prism.languages.keyman = {
        comment: {
            pattern: /\bc .*/i,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        'virtual-key': {
            pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
            greedy: true,
            alias: 'function' // alias for styles
        },
        // https://help.keyman.com/developer/language/guide/headers
        'header-keyword': {
            pattern: /&\w+/,
            alias: 'bold' // alias for styles
        },
        'header-statement': {
            pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
            alias: 'bold' // alias for styles
        },
        'rule-keyword': {
            pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
            alias: 'keyword'
        },
        'structural-keyword': {
            pattern: /\b(?:ansi|begin|group|match|nomatch|unicode|using keys)\b/i,
            alias: 'keyword'
        },
        'compile-target': {
            pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
            alias: 'property'
        },
        // U+####, x###, d### characters and numbers
        number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
        operator: /[+>\\$]|\.\./,
        punctuation: /[()=,]/
    };
}

},{}],"jtUFl":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = kotlin;
kotlin.displayName = 'kotlin';
kotlin.aliases = [
    'kt',
    'kts'
];
function kotlin(Prism) {
    (function(Prism) {
        Prism.languages.kotlin = Prism.languages.extend('clike', {
            keyword: {
                // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
                pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
                lookbehind: true
            },
            function: [
                {
                    pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                    greedy: true
                },
                {
                    pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
            operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
        });
        delete Prism.languages.kotlin['class-name'];
        var interpolationInside = {
            'interpolation-punctuation': {
                pattern: /^\$\{?|\}$/,
                alias: 'punctuation'
            },
            expression: {
                pattern: /[\s\S]+/,
                inside: Prism.languages.kotlin
            }
        };
        Prism.languages.insertBefore('kotlin', 'string', {
            // https://kotlinlang.org/spec/expressions.html#string-interpolation-expressions
            'string-literal': [
                {
                    pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                    alias: 'multiline',
                    inside: {
                        interpolation: {
                            pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                    alias: 'singleline',
                    inside: {
                        interpolation: {
                            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            lookbehind: true,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            char: {
                // https://kotlinlang.org/spec/expressions.html#character-literals
                pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
                greedy: true
            }
        });
        delete Prism.languages.kotlin['string'];
        Prism.languages.insertBefore('kotlin', 'keyword', {
            annotation: {
                pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
                alias: 'builtin'
            }
        });
        Prism.languages.insertBefore('kotlin', 'function', {
            label: {
                pattern: /\b\w+@|@\w+\b/,
                alias: 'symbol'
            }
        });
        Prism.languages.kt = Prism.languages.kotlin;
        Prism.languages.kts = Prism.languages.kotlin;
    })(Prism);
}

},{}],"cVfd1":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = kumir;
kumir.displayName = 'kumir';
kumir.aliases = [
    'kum'
];
function kumir(Prism) {
    (function(Prism) {
        /**
     * Regular expression for characters that are not allowed in identifiers.
     *
     * @type {string}
     */ var nonId = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;
        /**
     * Surround a regular expression for IDs with patterns for non-ID sequences.
     *
     * @param {string} pattern A regular expression for identifiers.
     * @param {string} [flags] The regular expression flags.
     * @returns {RegExp} A wrapped regular expression for identifiers.
     */ function wrapId(pattern, flags) {
            return RegExp(pattern.replace(/<nonId>/g, nonId), flags);
        }
        Prism.languages.kumir = {
            comment: {
                pattern: /\|.*/
            },
            prolog: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
                greedy: true
            },
            boolean: {
                pattern: wrapId(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            'operator-word': {
                pattern: wrapId(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            'system-variable': {
                pattern: wrapId(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            type: [
                {
                    pattern: wrapId(/(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'builtin'
                },
                {
                    pattern: wrapId(/(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'important'
                }
            ],
            /**
       * Should be performed after searching for type names because of "таб".
       * "таб" is a reserved word, but never used without a preceding type name.
       * "НАЗНАЧИТЬ", "Фввод", and "Фвывод" are not reserved words.
       */ keyword: {
                pattern: wrapId(/(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for reserved words. */ name: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: wrapId(/(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for names. */ number: {
                pattern: wrapId(/(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source, 'i'),
                lookbehind: true
            },
            /** Should be performed after searching for words. */ punctuation: /:=|[(),:;\[\]]/,
            /**
       * Should be performed after searching for
       * - numeric constants (because of "+" and "-");
       * - punctuation marks (because of ":=" and "=").
       */ 'operator-char': {
                pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
                alias: 'operator'
            }
        };
        Prism.languages.kum = Prism.languages.kumir;
    })(Prism);
}

},{}],"l1wWe":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = kusto;
kusto.displayName = 'kusto';
kusto.aliases = [];
function kusto(Prism) {
    Prism.languages.kusto = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
            greedy: true
        },
        verb: {
            pattern: /(\|\s*)[a-z][\w-]*/i,
            lookbehind: true,
            alias: 'keyword'
        },
        command: {
            pattern: /\.[a-z][a-z\d-]*\b/,
            alias: 'keyword'
        },
        'class-name': /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
        keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
        boolean: /\b(?:false|null|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/,
        datetime: [
            {
                // RFC 822 + RFC 850
                pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
                alias: 'number'
            },
            {
                // ISO 8601
                pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
                alias: 'number'
            }
        ],
        number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
        operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
        punctuation: /[()\[\]{},;.:]/
    };
}

},{}],"gMvpH":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = latex;
latex.displayName = 'latex';
latex.aliases = [
    'tex',
    'context'
];
function latex(Prism) {
    (function(Prism) {
        var funcPattern = /\\(?:[^a-z()[\]]|[a-z*]+)/i;
        var insideEqu = {
            'equation-command': {
                pattern: funcPattern,
                alias: 'regex'
            }
        };
        Prism.languages.latex = {
            comment: /%.*/,
            // the verbatim environment prints whitespace to the document
            cdata: {
                pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                lookbehind: true
            },
            /*
       * equations can be between $$ $$ or $ $ or \( \) or \[ \]
       * (all are multiline)
       */ equation: [
                {
                    pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
                    inside: insideEqu,
                    alias: 'string'
                },
                {
                    pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                    lookbehind: true,
                    inside: insideEqu,
                    alias: 'string'
                }
            ],
            /*
       * arguments which are keywords or references are highlighted
       * as keywords
       */ keyword: {
                pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true
            },
            url: {
                pattern: /(\\url\{)[^}]+(?=\})/,
                lookbehind: true
            },
            /*
       * section or chapter headlines are highlighted as bold so that
       * they stand out more
       */ headline: {
                pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true,
                alias: 'class-name'
            },
            function: {
                pattern: funcPattern,
                alias: 'selector'
            },
            punctuation: /[[\]{}&]/
        };
        Prism.languages.tex = Prism.languages.latex;
        Prism.languages.context = Prism.languages.latex;
    })(Prism);
}

},{}],"axvTP":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("477bc55335995b21");
var refractorPhp = require("4e502347096fc4de");
module.exports = latte;
latte.displayName = 'latte';
latte.aliases = [];
function latte(Prism) {
    Prism.register(refractorMarkupTemplating);
    Prism.register(refractorPhp);
    (function(Prism) {
        Prism.languages.latte = {
            comment: /^\{\*[\s\S]*/,
            'latte-tag': {
                // https://latte.nette.org/en/tags
                pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
                lookbehind: true,
                alias: 'important'
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                alias: 'punctuation'
            },
            php: {
                pattern: /\S(?:[\s\S]*\S)?/,
                alias: 'language-php',
                inside: Prism.languages.php
            }
        };
        var markupLatte = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('inside', 'attr-value', {
            'n-attr': {
                pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
                inside: {
                    'attr-name': {
                        pattern: /^[^\s=]+/,
                        alias: 'important'
                    },
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            punctuation: [
                                /^=/,
                                {
                                    pattern: /^(\s*)["']|["']$/,
                                    lookbehind: true
                                }
                            ],
                            php: {
                                pattern: /\S(?:[\s\S]*\S)?/,
                                inside: Prism.languages.php
                            }
                        }
                    }
                }
            }
        }, markupLatte.tag);
        Prism.hooks.add('before-tokenize', function(env) {
            if (env.language !== 'latte') return;
            var lattePattern = /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'latte', lattePattern);
            env.grammar = markupLatte;
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'latte');
        });
    })(Prism);
}

},{"477bc55335995b21":"lhKhp","4e502347096fc4de":"f5DlF"}],"f5DlF":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("e2591cb3f5472fa0");
module.exports = php;
php.displayName = 'php';
php.aliases = [];
function php(Prism) {
    Prism.register(refractorMarkupTemplating) /**
   * Original by Aaron Harun: http://aahacreative.com/2012/07/31/php-syntax-highlighting-prism/
   * Modified by Miles Johnson: http://milesj.me
   * Rewritten by Tom Pavelec
   *
   * Supports PHP 5.3 - 8.0
   */ ;
    (function(Prism) {
        var comment = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/;
        var constant = [
            {
                pattern: /\b(?:false|true)\b/i,
                alias: 'boolean'
            },
            {
                pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
                greedy: true,
                lookbehind: true
            },
            /\b(?:null)\b/i,
            /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
        ];
        var number = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i;
        var operator = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/;
        var punctuation = /[{}\[\](),:;]/;
        Prism.languages.php = {
            delimiter: {
                pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
                alias: 'important'
            },
            comment: comment,
            variable: /\$+(?:\w+\b|(?=\{))/,
            package: {
                pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            'class-name-definition': {
                pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            'function-definition': {
                pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
                lookbehind: true,
                alias: 'function'
            },
            keyword: [
                {
                    pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
                    alias: 'type-casting',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string|void)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
                    alias: 'type-declaration',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:parent|self|static)(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    // yield from
                    pattern: /(\byield\s+)from\b/i,
                    lookbehind: true
                },
                /\bclass\b/i,
                {
                    // https://www.php.net/manual/en/reserved.keywords.php
                    //
                    // keywords cannot be preceded by "->"
                    // the complex lookbehind means `(?<!(?:->|::)\s*)`
                    pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|new|or|parent|print|private|protected|public|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
                    lookbehind: true
                }
            ],
            'argument-name': {
                pattern: /([(,]\s+)\b[a-z_]\w*(?=\s*:(?!:))/i,
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-declaration'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'static-context'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-hint'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'return-type'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                }
            ],
            constant: constant,
            function: {
                pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            property: {
                pattern: /(->\s*)\w+/,
                lookbehind: true
            },
            number: number,
            operator: operator,
            punctuation: punctuation
        };
        var string_interpolation = {
            pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
            lookbehind: true,
            inside: Prism.languages.php
        };
        var string = [
            {
                pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
                alias: 'nowdoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<'?|[';]$/
                        }
                    }
                }
            },
            {
                pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
                alias: 'heredoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<"?|[";]$/
                        }
                    },
                    interpolation: string_interpolation
                }
            },
            {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                alias: 'backtick-quoted-string',
                greedy: true
            },
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                alias: 'single-quoted-string',
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                alias: 'double-quoted-string',
                greedy: true,
                inside: {
                    interpolation: string_interpolation
                }
            }
        ];
        Prism.languages.insertBefore('php', 'variable', {
            string: string,
            attribute: {
                pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
                greedy: true,
                inside: {
                    'attribute-content': {
                        pattern: /^(#\[)[\s\S]+(?=\]$)/,
                        lookbehind: true,
                        // inside can appear subset of php
                        inside: {
                            comment: comment,
                            string: string,
                            'attribute-class-name': [
                                {
                                    pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                                    alias: 'class-name',
                                    greedy: true,
                                    lookbehind: true
                                },
                                {
                                    pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                                    alias: [
                                        'class-name',
                                        'class-name-fully-qualified'
                                    ],
                                    greedy: true,
                                    lookbehind: true,
                                    inside: {
                                        punctuation: /\\/
                                    }
                                }
                            ],
                            constant: constant,
                            number: number,
                            operator: operator,
                            punctuation: punctuation
                        }
                    },
                    delimiter: {
                        pattern: /^#\[|\]$/,
                        alias: 'punctuation'
                    }
                }
            }
        });
        Prism.hooks.add('before-tokenize', function(env) {
            if (!/<\?/.test(env.code)) return;
            var phpPattern = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'php', phpPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'php');
        });
    })(Prism);
}

},{"e2591cb3f5472fa0":"lhKhp"}],"5BMWY":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = less;
less.displayName = 'less';
less.aliases = [];
function less(Prism) {
    /* FIXME :
:extend() is not handled specifically : its highlighting is buggy.
Mixin usage must be inside a ruleset to be highlighted.
At-rules (e.g. import) containing interpolations are buggy.
Detached rulesets are highlighted as at-rules.
A comment before a mixin usage prevents the latter to be properly highlighted.
*/ Prism.languages.less = Prism.languages.extend('css', {
        comment: [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^|[^\\])\/\/.*/,
                lookbehind: true
            }
        ],
        atrule: {
            pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                punctuation: /[:()]/
            }
        },
        // selectors and mixins are considered the same
        selector: {
            pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                // mixin parameters
                variable: /@+[\w-]+/
            }
        },
        property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
        operator: /[+\-*\/]/
    });
    Prism.languages.insertBefore('less', 'property', {
        variable: [
            // Variable declaration (the colon must be consumed!)
            {
                pattern: /@[\w-]+\s*:/,
                inside: {
                    punctuation: /:/
                }
            },
            /@@?[\w-]+/
        ],
        'mixin-usage': {
            pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
            lookbehind: true,
            alias: 'function'
        }
    });
}

},{}],"jZJ6b":[function(require,module,exports,__globalThis) {
'use strict';
var refractorScheme = require("fff59792f03fe69");
module.exports = lilypond;
lilypond.displayName = 'lilypond';
lilypond.aliases = [];
function lilypond(Prism) {
    Prism.register(refractorScheme);
    (function(Prism) {
        var schemeExpression = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source // allow for up to pow(2, recursivenessLog2) many levels of recursive brace expressions
        ;
        // For some reason, this can't be 4
        var recursivenessLog2 = 5;
        for(var i = 0; i < recursivenessLog2; i++)schemeExpression = schemeExpression.replace(/<expr>/g, function() {
            return schemeExpression;
        });
        schemeExpression = schemeExpression.replace(/<expr>/g, /[^\s\S]/.source);
        var lilypond = Prism.languages.lilypond = {
            comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
            'embedded-scheme': {
                pattern: RegExp(/(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(/<expr>/g, function() {
                    return schemeExpression;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                inside: {
                    scheme: {
                        pattern: /^(#)[\s\S]+$/,
                        lookbehind: true,
                        alias: 'language-scheme',
                        inside: {
                            'embedded-lilypond': {
                                pattern: /#\{[\s\S]*?#\}/,
                                greedy: true,
                                inside: {
                                    punctuation: /^#\{|#\}$/,
                                    lilypond: {
                                        pattern: /[\s\S]+/,
                                        alias: 'language-lilypond',
                                        inside: null // see below
                                    }
                                }
                            },
                            rest: Prism.languages.scheme
                        }
                    },
                    punctuation: /#/
                }
            },
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': {
                pattern: /(\\new\s+)[\w-]+/,
                lookbehind: true
            },
            keyword: {
                pattern: /\\[a-z][-\w]*/i,
                inside: {
                    punctuation: /^\\/
                }
            },
            operator: /[=|]|<<|>>/,
            punctuation: {
                pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
                lookbehind: true
            },
            number: /\b\d+(?:\/\d+)?\b/
        };
        lilypond['embedded-scheme'].inside['scheme'].inside['embedded-lilypond'].inside['lilypond'].inside = lilypond;
        Prism.languages.ly = lilypond;
    })(Prism);
}

},{"fff59792f03fe69":"6Tsyk"}],"6Tsyk":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = scheme;
scheme.displayName = 'scheme';
scheme.aliases = [];
function scheme(Prism) {
    (function(Prism) {
        Prism.languages.scheme = {
            // this supports "normal" single-line comments:
            //   ; comment
            // and (potentially nested) multiline comments:
            //   #| comment #| nested |# still comment |#
            // (only 1 level of nesting is supported)
            comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            symbol: {
                pattern: /'[^()\[\]#'\s]+/,
                greedy: true
            },
            char: {
                pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
                greedy: true
            },
            'lambda-parameter': [
                // https://www.cs.cmu.edu/Groups/AI/html/r4rs/r4rs_6.html#SEC30
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
                    lookbehind: true
                }
            ],
            keyword: {
                pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            builtin: {
                // all functions of the base library of R7RS plus some of built-ins of R5Rs
                pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            operator: {
                pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            number: {
                // The number pattern from [the R7RS spec](https://small.r7rs.org/attachment/r7rs.pdf).
                //
                // <number>      := <num 2>|<num 8>|<num 10>|<num 16>
                // <num R>       := <prefix R><complex R>
                // <complex R>   := <real R>(?:@<real R>|<imaginary R>)?|<imaginary R>
                // <imaginary R> := [+-](?:<ureal R>|(?:inf|nan)\.0)?i
                // <real R>      := [+-]?<ureal R>|[+-](?:inf|nan)\.0
                // <ureal R>     := <uint R>(?:\/<uint R>)?
                //                | <decimal R>
                //
                // <decimal 10>  := (?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?
                // <uint R>      := <digit R>+
                // <prefix R>    := <radix R>(?:#[ei])?|(?:#[ei])?<radix R>
                // <radix 2>     := #b
                // <radix 8>     := #o
                // <radix 10>    := (?:#d)?
                // <radix 16>    := #x
                // <digit 2>     := [01]
                // <digit 8>     := [0-7]
                // <digit 10>    := \d
                // <digit 16>    := [0-9a-f]
                //
                // The problem with this grammar is that the resulting regex is way to complex, so we simplify by grouping all
                // non-decimal bases together. This results in a decimal (dec) and combined binary, octal, and hexadecimal (box)
                // pattern:
                pattern: RegExp(SortedBNF({
                    '<ureal dec>': /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
                    '<real dec>': /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary dec>': /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
                    '<complex dec>': /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
                    '<num dec>': /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
                    '<ureal box>': /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
                    '<real box>': /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary box>': /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
                    '<complex box>': /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
                    '<num box>': /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
                    '<number>': /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
                }), 'i'),
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            function: {
                pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            identifier: {
                pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
                lookbehind: true,
                greedy: true
            },
            punctuation: /[()\[\]']/
        };
        /**
     * Given a topologically sorted BNF grammar, this will return the RegExp source of last rule of the grammar.
     *
     * @param {Record<string, string>} grammar
     * @returns {string}
     */ function SortedBNF(grammar) {
            for(var key in grammar)grammar[key] = grammar[key].replace(/<[\w\s]+>/g, function(key) {
                return '(?:' + grammar[key].trim() + ')';
            });
             // return the last item
            return grammar[key];
        }
    })(Prism);
}

},{}],"gVmsF":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("a129e27699e7251f");
module.exports = liquid;
liquid.displayName = 'liquid';
liquid.aliases = [];
function liquid(Prism) {
    Prism.register(refractorMarkupTemplating);
    Prism.languages.liquid = {
        comment: {
            pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
            lookbehind: true
        },
        delimiter: {
            pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: true
        },
        keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
        object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
        function: [
            {
                pattern: /(\|\s*)\w+/,
                lookbehind: true,
                alias: 'filter'
            },
            {
                // array functions
                pattern: /(\.\s*)(?:first|last|size)/,
                lookbehind: true
            }
        ],
        boolean: /\b(?:false|nil|true)\b/,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        // https://github.com/Shopify/liquid/blob/698f5e0d967423e013f6169d9111bd969bd78337/lib/liquid/lexer.rb#L21
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
        punctuation: /[.,\[\]()]/,
        empty: {
            pattern: /\bempty\b/,
            alias: 'keyword'
        }
    };
    Prism.hooks.add('before-tokenize', function(env) {
        var liquidPattern = /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g;
        var insideRaw = false;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'liquid', liquidPattern, function(match) {
            var tagMatch = /^\{%-?\s*(\w+)/.exec(match);
            if (tagMatch) {
                var tag = tagMatch[1];
                if (tag === 'raw' && !insideRaw) {
                    insideRaw = true;
                    return true;
                } else if (tag === 'endraw') {
                    insideRaw = false;
                    return true;
                }
            }
            return !insideRaw;
        });
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'liquid');
    });
}

},{"a129e27699e7251f":"lhKhp"}],"2JOPl":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = lisp;
lisp.displayName = 'lisp';
lisp.aliases = [];
function lisp(Prism) {
    (function(Prism) {
        /**
     * Functions to construct regular expressions
     * e.g. (interactive ... or (interactive)
     *
     * @param {string} name
     * @returns {RegExp}
     */ function simple_form(name) {
            return RegExp(/(\()/.source + '(?:' + name + ')' + /(?=[\s\)])/.source);
        }
        /**
     * booleans and numbers
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function primitive(pattern) {
            return RegExp(/([\s([])/.source + '(?:' + pattern + ')' + /(?=[\s)])/.source);
        } // Patterns in regular expressions
        // Symbol name. See https://www.gnu.org/software/emacs/manual/html_node/elisp/Symbol-Type.html
        // & and : are excluded as they are usually used for special purposes
        var symbol = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source // symbol starting with & used in function arguments
        ;
        var marker = '&' + symbol // Open parenthesis for look-behind
        ;
        var par = '(\\()';
        var endpar = '(?=\\))' // End the pattern with look-ahead space
        ;
        var space = '(?=\\s)';
        var nestedPar = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source;
        var language = {
            // Three or four semicolons are considered a heading.
            // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
            heading: {
                pattern: /;;;.*/,
                alias: [
                    'comment',
                    'title'
                ]
            },
            comment: /;.*/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true,
                inside: {
                    argument: /[-A-Z]+(?=[.,\s])/,
                    symbol: RegExp('`' + symbol + "'")
                }
            },
            'quoted-symbol': {
                pattern: RegExp("#?'" + symbol),
                alias: [
                    'variable',
                    'symbol'
                ]
            },
            'lisp-property': {
                pattern: RegExp(':' + symbol),
                alias: 'property'
            },
            splice: {
                pattern: RegExp(',@?' + symbol),
                alias: [
                    'symbol',
                    'variable'
                ]
            },
            keyword: [
                {
                    pattern: RegExp(par + '(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)' + space),
                    lookbehind: true
                },
                {
                    pattern: RegExp(par + '(?:append|by|collect|concat|do|finally|for|in|return)' + space),
                    lookbehind: true
                }
            ],
            declare: {
                pattern: simple_form(/declare/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            interactive: {
                pattern: simple_form(/interactive/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            boolean: {
                pattern: primitive(/nil|t/.source),
                lookbehind: true
            },
            number: {
                pattern: primitive(/[-+]?\d+(?:\.\d*)?/.source),
                lookbehind: true
            },
            defvar: {
                pattern: RegExp(par + 'def(?:const|custom|group|var)\\s+' + symbol),
                lookbehind: true,
                inside: {
                    keyword: /^def[a-z]+/,
                    variable: RegExp(symbol)
                }
            },
            defun: {
                pattern: RegExp(par + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + symbol + /\s+\(/.source + nestedPar + /\)/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^(?:cl-)?def\S+/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    function: {
                        pattern: RegExp('(^\\s)' + symbol),
                        lookbehind: true
                    },
                    punctuation: /[()]/
                }
            },
            lambda: {
                pattern: RegExp(par + 'lambda\\s+\\(\\s*(?:&?' + symbol + '(?:\\s+&?' + symbol + ')*\\s*)?\\)'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^lambda/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    punctuation: /[()]/
                }
            },
            car: {
                pattern: RegExp(par + symbol),
                lookbehind: true
            },
            punctuation: [
                // open paren, brackets, and close paren
                /(?:['`,]?\(|[)\[\]])/,
                {
                    pattern: /(\s)\.(?=\s)/,
                    lookbehind: true
                }
            ]
        };
        var arg = {
            'lisp-marker': RegExp(marker),
            varform: {
                pattern: RegExp(/\(/.source + symbol + /\s+(?=\S)/.source + nestedPar + /\)/.source),
                inside: language
            },
            argument: {
                pattern: RegExp(/(^|[\s(])/.source + symbol),
                lookbehind: true,
                alias: 'variable'
            },
            rest: language
        };
        var forms = '\\S+(?:\\s+\\S+)*';
        var arglist = {
            pattern: RegExp(par + nestedPar + endpar),
            lookbehind: true,
            inside: {
                'rest-vars': {
                    pattern: RegExp('&(?:body|rest)\\s+' + forms),
                    inside: arg
                },
                'other-marker-vars': {
                    pattern: RegExp('&(?:aux|optional)\\s+' + forms),
                    inside: arg
                },
                keys: {
                    pattern: RegExp('&key\\s+' + forms + '(?:\\s+&allow-other-keys)?'),
                    inside: arg
                },
                argument: {
                    pattern: RegExp(symbol),
                    alias: 'variable'
                },
                punctuation: /[()]/
            }
        };
        language['lambda'].inside.arguments = arglist;
        language['defun'].inside.arguments = Prism.util.clone(arglist);
        language['defun'].inside.arguments.inside.sublist = arglist;
        Prism.languages.lisp = language;
        Prism.languages.elisp = language;
        Prism.languages.emacs = language;
        Prism.languages['emacs-lisp'] = language;
    })(Prism);
}

},{}],"3lAdC":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = livescript;
livescript.displayName = 'livescript';
livescript.aliases = [];
function livescript(Prism) {
    Prism.languages.livescript = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true
            },
            {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true
            }
        ],
        'interpolated-string': {
            /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
       * forcing it to match """-quoted string when it would otherwise match "-quoted first. */ pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
                    lookbehind: true
                },
                interpolation: {
                    pattern: /(^|[^\\])#\{[^}]+\}/m,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^#\{|\}$/,
                            alias: 'variable'
                        } // See rest below
                    }
                },
                string: /[\s\S]+/
            }
        },
        string: [
            {
                pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            {
                pattern: /<\[[\s\S]*?\]>/,
                greedy: true
            },
            /\\[^\s,;\])}]+/
        ],
        regex: [
            {
                pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
                greedy: true,
                inside: {
                    comment: {
                        pattern: /(^|[^\\])#.*/,
                        lookbehind: true
                    }
                }
            },
            {
                pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
                greedy: true
            }
        ],
        keyword: {
            pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
            lookbehind: true
        },
        'keyword-operator': {
            pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
            lookbehind: true,
            alias: 'operator'
        },
        boolean: {
            pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
            lookbehind: true
        },
        argument: {
            // Don't match .&. nor &&
            pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
            lookbehind: true,
            alias: 'variable'
        },
        number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
        identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
        operator: [
            // Spaced .
            {
                pattern: /( )\.(?= )/,
                lookbehind: true
            },
            // .= .~ .. ...
            // .&. .^. .<<. .>>. .>>>.
            // := :: ::=
            // &&
            // || |>
            // < << <<< <<<<
            // <- <-- <-! <--!
            // <~ <~~ <~! <~~!
            // <| <= <?
            // > >> >= >?
            // - -- -> -->
            // + ++
            // @ @@
            // % %%
            // * **
            // ! != !~=
            // !~> !~~>
            // !-> !-->
            // ~ ~> ~~> ~=
            // = ==
            // ^ ^^
            // / ?
            /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
        ],
        punctuation: /[(){}\[\]|.,:;`]/
    };
    Prism.languages.livescript['interpolated-string'].inside['interpolation'].inside.rest = Prism.languages.livescript;
}

},{}],"69Sns":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = llvm;
llvm.displayName = 'llvm';
llvm.aliases = [];
function llvm(Prism) {
    (function(Prism) {
        Prism.languages.llvm = {
            comment: /;.*/,
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            boolean: /\b(?:false|true)\b/,
            variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
            label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
            type: {
                pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
                alias: 'class-name'
            },
            keyword: /\b[a-z_][a-z_0-9]*\b/,
            number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
            punctuation: /[{}[\];(),.!*=<>]/
        };
    })(Prism);
}

},{}],"5dy2G":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = log;
log.displayName = 'log';
log.aliases = [];
function log(Prism) {
    // This is a language definition for generic log files.
    // Since there is no one log format, this language definition has to support all formats to some degree.
    //
    // Based on https://github.com/MTDL9/vim-log-highlighting
    Prism.languages.log = {
        string: {
            // Single-quoted strings must not be confused with plain text. E.g. Can't isn't Susan's Chris' toy
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        exception: {
            pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
            lookbehind: true,
            greedy: true,
            alias: [
                'javastacktrace',
                'language-javastacktrace'
            ],
            inside: Prism.languages['javastacktrace'] || {
                keyword: /\bat\b/,
                function: /[a-z_][\w$]*(?=\()/,
                punctuation: /[.:()]/
            }
        },
        level: [
            {
                pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
                alias: [
                    'error',
                    'important'
                ]
            },
            {
                pattern: /\b(?:WARN|WARNING|WRN)\b/,
                alias: [
                    'warning',
                    'important'
                ]
            },
            {
                pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
                alias: [
                    'info',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:DBG|DEBUG|FINE)\b/,
                alias: [
                    'debug',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
                alias: [
                    'trace',
                    'comment'
                ]
            }
        ],
        property: {
            pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
            lookbehind: true
        },
        separator: {
            pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
            lookbehind: true,
            alias: 'comment'
        },
        url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
        email: {
            pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
            lookbehind: true,
            alias: 'url'
        },
        'ip-address': {
            pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
            alias: 'constant'
        },
        'mac-address': {
            pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
            alias: 'constant'
        },
        domain: {
            pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
            lookbehind: true,
            alias: 'constant'
        },
        uuid: {
            pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
            alias: 'constant'
        },
        hash: {
            pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
            alias: 'constant'
        },
        'file-path': {
            pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
            lookbehind: true,
            greedy: true,
            alias: 'string'
        },
        date: {
            pattern: RegExp(/\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + '|' + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + '|' + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source, 'i'),
            alias: 'number'
        },
        time: {
            pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
            alias: 'number'
        },
        boolean: /\b(?:false|null|true)\b/i,
        number: {
            pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
            lookbehind: true
        },
        operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
        punctuation: /[\[\].,]/
    };
}

},{}],"eTHbK":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = lolcode;
lolcode.displayName = 'lolcode';
lolcode.aliases = [];
function lolcode(Prism) {
    Prism.languages.lolcode = {
        comment: [
            /\bOBTW\s[\s\S]*?\sTLDR\b/,
            /\bBTW.+/
        ],
        string: {
            pattern: /"(?::.|[^":])*"/,
            inside: {
                variable: /:\{[^}]+\}/,
                symbol: [
                    /:\([a-f\d]+\)/i,
                    /:\[[^\]]+\]/,
                    /:[)>o":]/
                ]
            },
            greedy: true
        },
        number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
        symbol: {
            pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
            lookbehind: true,
            inside: {
                keyword: /A(?=\s)/
            }
        },
        label: {
            pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
            lookbehind: true,
            alias: 'string'
        },
        function: {
            pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
            lookbehind: true
        },
        keyword: [
            {
                pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
                lookbehind: true
            },
            /'Z(?=\s|,|$)/
        ],
        boolean: {
            pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
            lookbehind: true
        },
        variable: {
            pattern: /(^|\s)IT(?=\s|,|$)/,
            lookbehind: true
        },
        operator: {
            pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
            lookbehind: true
        },
        punctuation: /\.{3}|…|,|!/
    };
}

},{}],"915b8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = magma;
magma.displayName = 'magma';
magma.aliases = [];
function magma(Prism) {
    Prism.languages.magma = {
        output: {
            pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        // http://magma.maths.usyd.edu.au/magma/handbook/text/82
        keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
        boolean: /\b(?:false|true)\b/,
        generator: {
            pattern: /\b[a-z_]\w*(?=\s*<)/i,
            alias: 'class-name'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        operator: /->|[-+*/^~!|#=]|:=|\.\./,
        punctuation: /[()[\]{}<>,;.:]/
    };
}

},{}],"fycDJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = makefile;
makefile.displayName = 'makefile';
makefile.aliases = [];
function makefile(Prism) {
    Prism.languages.makefile = {
        comment: {
            pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'builtin-target': {
            pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
            alias: 'builtin'
        },
        target: {
            pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
            alias: 'symbol',
            inside: {
                variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
            }
        },
        variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
        // Directives
        keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
        function: {
            pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
            lookbehind: true
        },
        operator: /(?:::|[?:+!])?=|[|@]/,
        punctuation: /[:;(){}]/
    };
}

},{}],"6wCR2":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = markdown;
markdown.displayName = 'markdown';
markdown.aliases = [
    'md'
];
function markdown(Prism) {
    (function(Prism) {
        // Allow only one line break
        var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
        /**
     * This function is intended for the creation of the bold or italic pattern.
     *
     * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
     *
     * _Note:_ Keep in mind that this adds a capturing group.
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function createInline(pattern) {
            pattern = pattern.replace(/<inner>/g, function() {
                return inner;
            });
            return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
        }
        var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
        var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
            return tableCell;
        });
        var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
        Prism.languages.markdown = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('markdown', 'prolog', {
            'front-matter-block': {
                pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^---|---$/,
                    'front-matter': {
                        pattern: /\S+(?:\s+\S+)*/,
                        alias: [
                            'yaml',
                            'language-yaml'
                        ],
                        inside: Prism.languages.yaml
                    }
                }
            },
            blockquote: {
                // > ...
                pattern: /^>(?:[\t ]*>)*/m,
                alias: 'punctuation'
            },
            table: {
                pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
                inside: {
                    'table-data-rows': {
                        pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
                        lookbehind: true,
                        inside: {
                            'table-data': {
                                pattern: RegExp(tableCell),
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    },
                    'table-line': {
                        pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
                        lookbehind: true,
                        inside: {
                            punctuation: /\||:?-{3,}:?/
                        }
                    },
                    'table-header-row': {
                        pattern: RegExp('^' + tableRow + '$'),
                        inside: {
                            'table-header': {
                                pattern: RegExp(tableCell),
                                alias: 'important',
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    }
                }
            },
            code: [
                {
                    // Prefixed by 4 spaces or 1 tab and preceded by an empty line
                    pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                {
                    // ```optional language
                    // code block
                    // ```
                    pattern: /^```[\s\S]*?^```$/m,
                    greedy: true,
                    inside: {
                        'code-block': {
                            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                            lookbehind: true
                        },
                        'code-language': {
                            pattern: /^(```).+/,
                            lookbehind: true
                        },
                        punctuation: /```/
                    }
                }
            ],
            title: [
                {
                    // title 1
                    // =======
                    // title 2
                    // -------
                    pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                    alias: 'important',
                    inside: {
                        punctuation: /==+$|--+$/
                    }
                },
                {
                    // # title 1
                    // ###### title 6
                    pattern: /(^\s*)#.+/m,
                    lookbehind: true,
                    alias: 'important',
                    inside: {
                        punctuation: /^#+|#+$/
                    }
                }
            ],
            hr: {
                // ***
                // ---
                // * * *
                // -----------
                pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            list: {
                // * item
                // + item
                // - item
                // 1. item
                pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            'url-reference': {
                // [id]: http://example.com "Optional title"
                // [id]: http://example.com 'Optional title'
                // [id]: http://example.com (Optional title)
                // [id]: <http://example.com> "Optional title"
                pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
                inside: {
                    variable: {
                        pattern: /^(!?\[)[^\]]+/,
                        lookbehind: true
                    },
                    string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                    punctuation: /^[\[\]!:]|[<>]/
                },
                alias: 'url'
            },
            bold: {
                // **strong**
                // __strong__
                // allow one nested instance of italic text using the same delimiter
                pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^..)[\s\S]+(?=..$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /\*\*|__/
                }
            },
            italic: {
                // *em*
                // _em_
                // allow one nested instance of bold text using the same delimiter
                pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^.)[\s\S]+(?=.$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /[*_]/
                }
            },
            strike: {
                // ~~strike through~~
                // ~strike~
                // eslint-disable-next-line regexp/strict
                pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^~~?)[\s\S]+(?=\1$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /~~?/
                }
            },
            'code-snippet': {
                // `code`
                // ``code``
                pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
                lookbehind: true,
                greedy: true,
                alias: [
                    'code',
                    'keyword'
                ]
            },
            url: {
                // [example](http://example.com "Optional title")
                // [example][id]
                // [example] [id]
                pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    operator: /^!/,
                    content: {
                        pattern: /(^\[)[^\]]+(?=\])/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    variable: {
                        pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                        lookbehind: true
                    },
                    url: {
                        pattern: /(^\]\()[^\s)]+/,
                        lookbehind: true
                    },
                    string: {
                        pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                        lookbehind: true
                    }
                }
            }
        });
        [
            'url',
            'bold',
            'italic',
            'strike'
        ].forEach(function(token) {
            [
                'url',
                'bold',
                'italic',
                'strike',
                'code-snippet'
            ].forEach(function(inside) {
                if (token !== inside) Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
            });
        });
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'markdown' && env.language !== 'md') return;
            function walkTokens(tokens) {
                if (!tokens || typeof tokens === 'string') return;
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (token.type !== 'code') {
                        walkTokens(token.content);
                        continue;
                    }
                    /*
           * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
           * is optional. But the grammar is defined so that there is only one case we have to handle:
           *
           * token.content = [
           *     <span class="punctuation">```</span>,
           *     <span class="code-language">xxxx</span>,
           *     '\n', // exactly one new lines (\r or \n or \r\n)
           *     <span class="code-block">...</span>,
           *     '\n', // exactly one new lines again
           *     <span class="punctuation">```</span>
           * ];
           */ var codeLang = token.content[1];
                    var codeBlock = token.content[3];
                    if (codeLang && codeBlock && codeLang.type === 'code-language' && codeBlock.type === 'code-block' && typeof codeLang.content === 'string') {
                        // this might be a language that Prism does not support
                        // do some replacements to support C++, C#, and F#
                        var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp') // only use the first word
                        ;
                        lang = (/[a-z][\w-]*/i.exec(lang) || [
                            ''
                        ])[0].toLowerCase();
                        var alias = 'language-' + lang // add alias
                        ;
                        if (!codeBlock.alias) codeBlock.alias = [
                            alias
                        ];
                        else if (typeof codeBlock.alias === 'string') codeBlock.alias = [
                            codeBlock.alias,
                            alias
                        ];
                        else codeBlock.alias.push(alias);
                    }
                }
            }
            walkTokens(env.tokens);
        });
        Prism.hooks.add('wrap', function(env) {
            if (env.type !== 'code-block') return;
            var codeLang = '';
            for(var i = 0, l = env.classes.length; i < l; i++){
                var cls = env.classes[i];
                var match = /language-(.+)/.exec(cls);
                if (match) {
                    codeLang = match[1];
                    break;
                }
            }
            var grammar = Prism.languages[codeLang];
            if (!grammar) {
                if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
                    var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
                    env.attributes['id'] = id;
                    Prism.plugins.autoloader.loadLanguages(codeLang, function() {
                        var ele = document.getElementById(id);
                        if (ele) ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
                    });
                }
            } else env.content = Prism.highlight(textContent(env.content.value), grammar, codeLang);
        });
        var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');
        /**
     * A list of known entity names.
     *
     * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
     *
     * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
     */ var KNOWN_ENTITY_NAMES = {
            amp: '&',
            lt: '<',
            gt: '>',
            quot: '"'
        } // IE 11 doesn't support `String.fromCodePoint`
        ;
        var fromCodePoint = String.fromCodePoint || String.fromCharCode;
        /**
     * Returns the text content of a given HTML source code string.
     *
     * @param {string} html
     * @returns {string}
     */ function textContent(html) {
            // remove all tags
            var text = html.replace(tagPattern, '') // decode known entities
            ;
            text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, code) {
                code = code.toLowerCase();
                if (code[0] === '#') {
                    var value;
                    if (code[1] === 'x') value = parseInt(code.slice(2), 16);
                    else value = Number(code.slice(1));
                    return fromCodePoint(value);
                } else {
                    var known = KNOWN_ENTITY_NAMES[code];
                    if (known) return known;
                     // unable to decode
                    return m;
                }
            });
            return text;
        }
        Prism.languages.md = Prism.languages.markdown;
    })(Prism);
}

},{}],"6T9Jo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = matlab;
matlab.displayName = 'matlab';
matlab.aliases = [];
function matlab(Prism) {
    Prism.languages.matlab = {
        comment: [
            /%\{[\s\S]*?\}%/,
            /%.+/
        ],
        string: {
            pattern: /\B'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        // FIXME We could handle imaginary numbers as a whole
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
        keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
        function: /\b(?!\d)\w+(?=\s*\()/,
        operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
        punctuation: /\.{3}|[.,;\[\](){}!]/
    };
}

},{}],"6x8fG":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = maxscript;
maxscript.displayName = 'maxscript';
maxscript.aliases = [];
function maxscript(Prism) {
    (function(Prism) {
        var keywords = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
        Prism.languages.maxscript = {
            comment: {
                pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
                greedy: true
            },
            string: {
                pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
                lookbehind: true,
                greedy: true
            },
            path: {
                pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
                greedy: true,
                alias: 'string'
            },
            'function-call': {
                pattern: RegExp('((?:' + // start of line
                (/^/.source + '|' + // operators and other language constructs
                /[;=<>+\-*/^({\[]/.source + '|' + // keywords as part of statements
                /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source) + ')[ \t]*)' + '(?!' + keywords.source + ')' + /[a-z_]\w*\b/.source + '(?=[ \t]*(?:' + // variable
                ('(?!' + keywords.source + ')' + /[a-z_]/.source + '|' + // number
                /\d|-\.?\d/.source + '|' + // other expressions or literals
                /[({'"$@#?]/.source) + '))', 'im'),
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'function-definition': {
                pattern: /(\b(?:fn|function)\s+)\w+\b/i,
                lookbehind: true,
                alias: 'function'
            },
            argument: {
                pattern: /\b[a-z_]\w*(?=:)/i,
                alias: 'attr-name'
            },
            keyword: keywords,
            boolean: /\b(?:false|true)\b/,
            time: {
                pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
                lookbehind: true,
                alias: 'number'
            },
            number: [
                {
                    pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
                    lookbehind: true
                },
                /\b(?:e|pi)\b/
            ],
            constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
            color: {
                pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
                alias: 'constant'
            },
            operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
            punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
        };
    })(Prism);
}

},{}],"eYNqD":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = mel;
mel.displayName = 'mel';
mel.aliases = [];
function mel(Prism) {
    Prism.languages.mel = {
        comment: /\/\/.*/,
        code: {
            pattern: /`(?:\\.|[^\\`\r\n])*`/,
            greedy: true,
            alias: 'italic',
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: 'punctuation'
                } // See rest below
            }
        },
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        variable: /\$\w+/,
        number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
        flag: {
            pattern: /-[^\d\W]\w*/,
            alias: 'operator'
        },
        keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
        function: /\b\w+(?=\()|\b(?:CBG|HfAddAttractorToAS|HfAssignAS|HfBuildEqualMap|HfBuildFurFiles|HfBuildFurImages|HfCancelAFR|HfConnectASToHF|HfCreateAttractor|HfDeleteAS|HfEditAS|HfPerformCreateAS|HfRemoveAttractorFromAS|HfSelectAttached|HfSelectAttractors|HfUnAssignAS|Mayatomr|about|abs|addAttr|addAttributeEditorNodeHelp|addDynamic|addNewShelfTab|addPP|addPanelCategory|addPrefixToName|advanceToNextDrivenKey|affectedNet|affects|aimConstraint|air|alias|aliasAttr|align|alignCtx|alignCurve|alignSurface|allViewFit|ambientLight|angle|angleBetween|animCone|animCurveEditor|animDisplay|animView|annotate|appendStringArray|applicationName|applyAttrPreset|applyTake|arcLenDimContext|arcLengthDimension|arclen|arrayMapper|art3dPaintCtx|artAttrCtx|artAttrPaintVertexCtx|artAttrSkinPaintCtx|artAttrTool|artBuildPaintMenu|artFluidAttrCtx|artPuttyCtx|artSelectCtx|artSetPaintCtx|artUserPaintCtx|assignCommand|assignInputDevice|assignViewportFactories|attachCurve|attachDeviceAttr|attachSurface|attrColorSliderGrp|attrCompatibility|attrControlGrp|attrEnumOptionMenu|attrEnumOptionMenuGrp|attrFieldGrp|attrFieldSliderGrp|attrNavigationControlGrp|attrPresetEditWin|attributeExists|attributeInfo|attributeMenu|attributeQuery|autoKeyframe|autoPlace|bakeClip|bakeFluidShading|bakePartialHistory|bakeResults|bakeSimulation|basename|basenameEx|batchRender|bessel|bevel|bevelPlus|binMembership|bindSkin|blend2|blendShape|blendShapeEditor|blendShapePanel|blendTwoAttr|blindDataType|boneLattice|boundary|boxDollyCtx|boxZoomCtx|bufferCurve|buildBookmarkMenu|buildKeyframeMenu|button|buttonManip|cacheFile|cacheFileCombine|cacheFileMerge|cacheFileTrack|camera|cameraView|canCreateManip|canvas|capitalizeString|catch|catchQuiet|ceil|changeSubdivComponentDisplayLevel|changeSubdivRegion|channelBox|character|characterMap|characterOutlineEditor|characterize|chdir|checkBox|checkBoxGrp|checkDefaultRenderGlobals|choice|circle|circularFillet|clamp|clear|clearCache|clip|clipEditor|clipEditorCurrentTimeCtx|clipSchedule|clipSchedulerOutliner|clipTrimBefore|closeCurve|closeSurface|cluster|cmdFileOutput|cmdScrollFieldExecuter|cmdScrollFieldReporter|cmdShell|coarsenSubdivSelectionList|collision|color|colorAtPoint|colorEditor|colorIndex|colorIndexSliderGrp|colorSliderButtonGrp|colorSliderGrp|columnLayout|commandEcho|commandLine|commandPort|compactHairSystem|componentEditor|compositingInterop|computePolysetVolume|condition|cone|confirmDialog|connectAttr|connectControl|connectDynamic|connectJoint|connectionInfo|constrain|constrainValue|constructionHistory|container|containsMultibyte|contextInfo|control|convertFromOldLayers|convertIffToPsd|convertLightmap|convertSolidTx|convertTessellation|convertUnit|copyArray|copyFlexor|copyKey|copySkinWeights|cos|cpButton|cpCache|cpClothSet|cpCollision|cpConstraint|cpConvClothToMesh|cpForces|cpGetSolverAttr|cpPanel|cpProperty|cpRigidCollisionFilter|cpSeam|cpSetEdit|cpSetSolverAttr|cpSolver|cpSolverTypes|cpTool|cpUpdateClothUVs|createDisplayLayer|createDrawCtx|createEditor|createLayeredPsdFile|createMotionField|createNewShelf|createNode|createRenderLayer|createSubdivRegion|cross|crossProduct|ctxAbort|ctxCompletion|ctxEditMode|ctxTraverse|currentCtx|currentTime|currentTimeCtx|currentUnit|curve|curveAddPtCtx|curveCVCtx|curveEPCtx|curveEditorCtx|curveIntersect|curveMoveEPCtx|curveOnSurface|curveSketchCtx|cutKey|cycleCheck|cylinder|dagPose|date|defaultLightListCheckBox|defaultNavigation|defineDataServer|defineVirtualDevice|deformer|deg_to_rad|delete|deleteAttr|deleteShadingGroupsAndMaterials|deleteShelfTab|deleteUI|deleteUnusedBrushes|delrandstr|detachCurve|detachDeviceAttr|detachSurface|deviceEditor|devicePanel|dgInfo|dgdirty|dgeval|dgtimer|dimWhen|directKeyCtx|directionalLight|dirmap|dirname|disable|disconnectAttr|disconnectJoint|diskCache|displacementToPoly|displayAffected|displayColor|displayCull|displayLevelOfDetail|displayPref|displayRGBColor|displaySmoothness|displayStats|displayString|displaySurface|distanceDimContext|distanceDimension|doBlur|dolly|dollyCtx|dopeSheetEditor|dot|dotProduct|doubleProfileBirailSurface|drag|dragAttrContext|draggerContext|dropoffLocator|duplicate|duplicateCurve|duplicateSurface|dynCache|dynControl|dynExport|dynExpression|dynGlobals|dynPaintEditor|dynParticleCtx|dynPref|dynRelEdPanel|dynRelEditor|dynamicLoad|editAttrLimits|editDisplayLayerGlobals|editDisplayLayerMembers|editRenderLayerAdjustment|editRenderLayerGlobals|editRenderLayerMembers|editor|editorTemplate|effector|emit|emitter|enableDevice|encodeString|endString|endsWith|env|equivalent|equivalentTol|erf|error|eval|evalDeferred|evalEcho|event|exactWorldBoundingBox|exclusiveLightCheckBox|exec|executeForEachObject|exists|exp|expression|expressionEditorListen|extendCurve|extendSurface|extrude|fcheck|fclose|feof|fflush|fgetline|fgetword|file|fileBrowserDialog|fileDialog|fileExtension|fileInfo|filetest|filletCurve|filter|filterCurve|filterExpand|filterStudioImport|findAllIntersections|findAnimCurves|findKeyframe|findMenuItem|findRelatedSkinCluster|finder|firstParentOf|fitBspline|flexor|floatEq|floatField|floatFieldGrp|floatScrollBar|floatSlider|floatSlider2|floatSliderButtonGrp|floatSliderGrp|floor|flow|fluidCacheInfo|fluidEmitter|fluidVoxelInfo|flushUndo|fmod|fontDialog|fopen|formLayout|format|fprint|frameLayout|fread|freeFormFillet|frewind|fromNativePath|fwrite|gamma|gauss|geometryConstraint|getApplicationVersionAsFloat|getAttr|getClassification|getDefaultBrush|getFileList|getFluidAttr|getInputDeviceRange|getMayaPanelTypes|getModifiers|getPanel|getParticleAttr|getPluginResource|getenv|getpid|glRender|glRenderEditor|globalStitch|gmatch|goal|gotoBindPose|grabColor|gradientControl|gradientControlNoAttr|graphDollyCtx|graphSelectContext|graphTrackCtx|gravity|grid|gridLayout|group|groupObjectsByName|hardenPointCurve|hardware|hardwareRenderPanel|headsUpDisplay|headsUpMessage|help|helpLine|hermite|hide|hilite|hitTest|hotBox|hotkey|hotkeyCheck|hsv_to_rgb|hudButton|hudSlider|hudSliderButton|hwReflectionMap|hwRender|hwRenderLoad|hyperGraph|hyperPanel|hyperShade|hypot|iconTextButton|iconTextCheckBox|iconTextRadioButton|iconTextRadioCollection|iconTextScrollList|iconTextStaticLabel|ikHandle|ikHandleCtx|ikHandleDisplayScale|ikSolver|ikSplineHandleCtx|ikSystem|ikSystemInfo|ikfkDisplayMethod|illustratorCurves|image|imfPlugins|inheritTransform|insertJoint|insertJointCtx|insertKeyCtx|insertKnotCurve|insertKnotSurface|instance|instanceable|instancer|intField|intFieldGrp|intScrollBar|intSlider|intSliderGrp|interToUI|internalVar|intersect|iprEngine|isAnimCurve|isConnected|isDirty|isParentOf|isSameObject|isTrue|isValidObjectName|isValidString|isValidUiName|isolateSelect|itemFilter|itemFilterAttr|itemFilterRender|itemFilterType|joint|jointCluster|jointCtx|jointDisplayScale|jointLattice|keyTangent|keyframe|keyframeOutliner|keyframeRegionCurrentTimeCtx|keyframeRegionDirectKeyCtx|keyframeRegionDollyCtx|keyframeRegionInsertKeyCtx|keyframeRegionMoveKeyCtx|keyframeRegionScaleKeyCtx|keyframeRegionSelectKeyCtx|keyframeRegionSetKeyCtx|keyframeRegionTrackCtx|keyframeStats|lassoContext|lattice|latticeDeformKeyCtx|launch|launchImageEditor|layerButton|layeredShaderPort|layeredTexturePort|layout|layoutDialog|lightList|lightListEditor|lightListPanel|lightlink|lineIntersection|linearPrecision|linstep|listAnimatable|listAttr|listCameras|listConnections|listDeviceAttachments|listHistory|listInputDeviceAxes|listInputDeviceButtons|listInputDevices|listMenuAnnotation|listNodeTypes|listPanelCategories|listRelatives|listSets|listTransforms|listUnselected|listerEditor|loadFluid|loadNewShelf|loadPlugin|loadPluginLanguageResources|loadPrefObjects|localizedPanelLabel|lockNode|loft|log|longNameOf|lookThru|ls|lsThroughFilter|lsType|lsUI|mag|makeIdentity|makeLive|makePaintable|makeRoll|makeSingleSurface|makeTubeOn|makebot|manipMoveContext|manipMoveLimitsCtx|manipOptions|manipRotateContext|manipRotateLimitsCtx|manipScaleContext|manipScaleLimitsCtx|marker|match|max|memory|menu|menuBarLayout|menuEditor|menuItem|menuItemToShelf|menuSet|menuSetPref|messageLine|min|minimizeApp|mirrorJoint|modelCurrentTimeCtx|modelEditor|modelPanel|mouse|movIn|movOut|move|moveIKtoFK|moveKeyCtx|moveVertexAlongDirection|multiProfileBirailSurface|mute|nParticle|nameCommand|nameField|namespace|namespaceInfo|newPanelItems|newton|nodeCast|nodeIconButton|nodeOutliner|nodePreset|nodeType|noise|nonLinear|normalConstraint|normalize|nurbsBoolean|nurbsCopyUVSet|nurbsCube|nurbsEditUV|nurbsPlane|nurbsSelect|nurbsSquare|nurbsToPoly|nurbsToPolygonsPref|nurbsToSubdiv|nurbsToSubdivPref|nurbsUVSet|nurbsViewDirectionVector|objExists|objectCenter|objectLayer|objectType|objectTypeUI|obsoleteProc|oceanNurbsPreviewPlane|offsetCurve|offsetCurveOnSurface|offsetSurface|openGLExtension|openMayaPref|optionMenu|optionMenuGrp|optionVar|orbit|orbitCtx|orientConstraint|outlinerEditor|outlinerPanel|overrideModifier|paintEffectsDisplay|pairBlend|palettePort|paneLayout|panel|panelConfiguration|panelHistory|paramDimContext|paramDimension|paramLocator|parent|parentConstraint|particle|particleExists|particleInstancer|particleRenderInfo|partition|pasteKey|pathAnimation|pause|pclose|percent|performanceOptions|pfxstrokes|pickWalk|picture|pixelMove|planarSrf|plane|play|playbackOptions|playblast|plugAttr|plugNode|pluginInfo|pluginResourceUtil|pointConstraint|pointCurveConstraint|pointLight|pointMatrixMult|pointOnCurve|pointOnSurface|pointPosition|poleVectorConstraint|polyAppend|polyAppendFacetCtx|polyAppendVertex|polyAutoProjection|polyAverageNormal|polyAverageVertex|polyBevel|polyBlendColor|polyBlindData|polyBoolOp|polyBridgeEdge|polyCacheMonitor|polyCheck|polyChipOff|polyClipboard|polyCloseBorder|polyCollapseEdge|polyCollapseFacet|polyColorBlindData|polyColorDel|polyColorPerVertex|polyColorSet|polyCompare|polyCone|polyCopyUV|polyCrease|polyCreaseCtx|polyCreateFacet|polyCreateFacetCtx|polyCube|polyCut|polyCutCtx|polyCylinder|polyCylindricalProjection|polyDelEdge|polyDelFacet|polyDelVertex|polyDuplicateAndConnect|polyDuplicateEdge|polyEditUV|polyEditUVShell|polyEvaluate|polyExtrudeEdge|polyExtrudeFacet|polyExtrudeVertex|polyFlipEdge|polyFlipUV|polyForceUV|polyGeoSampler|polyHelix|polyInfo|polyInstallAction|polyLayoutUV|polyListComponentConversion|polyMapCut|polyMapDel|polyMapSew|polyMapSewMove|polyMergeEdge|polyMergeEdgeCtx|polyMergeFacet|polyMergeFacetCtx|polyMergeUV|polyMergeVertex|polyMirrorFace|polyMoveEdge|polyMoveFacet|polyMoveFacetUV|polyMoveUV|polyMoveVertex|polyNormal|polyNormalPerVertex|polyNormalizeUV|polyOptUvs|polyOptions|polyOutput|polyPipe|polyPlanarProjection|polyPlane|polyPlatonicSolid|polyPoke|polyPrimitive|polyPrism|polyProjection|polyPyramid|polyQuad|polyQueryBlindData|polyReduce|polySelect|polySelectConstraint|polySelectConstraintMonitor|polySelectCtx|polySelectEditCtx|polySeparate|polySetToFaceNormal|polySewEdge|polyShortestPathCtx|polySmooth|polySoftEdge|polySphere|polySphericalProjection|polySplit|polySplitCtx|polySplitEdge|polySplitRing|polySplitVertex|polyStraightenUVBorder|polySubdivideEdge|polySubdivideFacet|polyToSubdiv|polyTorus|polyTransfer|polyTriangulate|polyUVSet|polyUnite|polyWedgeFace|popen|popupMenu|pose|pow|preloadRefEd|print|progressBar|progressWindow|projFileViewer|projectCurve|projectTangent|projectionContext|projectionManip|promptDialog|propModCtx|propMove|psdChannelOutliner|psdEditTextureFile|psdExport|psdTextureFile|putenv|pwd|python|querySubdiv|quit|rad_to_deg|radial|radioButton|radioButtonGrp|radioCollection|radioMenuItemCollection|rampColorPort|rand|randomizeFollicles|randstate|rangeControl|readTake|rebuildCurve|rebuildSurface|recordAttr|recordDevice|redo|reference|referenceEdit|referenceQuery|refineSubdivSelectionList|refresh|refreshAE|registerPluginResource|rehash|reloadImage|removeJoint|removeMultiInstance|removePanelCategory|rename|renameAttr|renameSelectionList|renameUI|render|renderGlobalsNode|renderInfo|renderLayerButton|renderLayerParent|renderLayerPostProcess|renderLayerUnparent|renderManip|renderPartition|renderQualityNode|renderSettings|renderThumbnailUpdate|renderWindowEditor|renderWindowSelectContext|renderer|reorder|reorderDeformers|requires|reroot|resampleFluid|resetAE|resetPfxToPolyCamera|resetTool|resolutionNode|retarget|reverseCurve|reverseSurface|revolve|rgb_to_hsv|rigidBody|rigidSolver|roll|rollCtx|rootOf|rot|rotate|rotationInterpolation|roundConstantRadius|rowColumnLayout|rowLayout|runTimeCommand|runup|sampleImage|saveAllShelves|saveAttrPreset|saveFluid|saveImage|saveInitialState|saveMenu|savePrefObjects|savePrefs|saveShelf|saveToolSettings|scale|scaleBrushBrightness|scaleComponents|scaleConstraint|scaleKey|scaleKeyCtx|sceneEditor|sceneUIReplacement|scmh|scriptCtx|scriptEditorInfo|scriptJob|scriptNode|scriptTable|scriptToShelf|scriptedPanel|scriptedPanelType|scrollField|scrollLayout|sculpt|searchPathArray|seed|selLoadSettings|select|selectContext|selectCurveCV|selectKey|selectKeyCtx|selectKeyframeRegionCtx|selectMode|selectPref|selectPriority|selectType|selectedNodes|selectionConnection|separator|setAttr|setAttrEnumResource|setAttrMapping|setAttrNiceNameResource|setConstraintRestPosition|setDefaultShadingGroup|setDrivenKeyframe|setDynamic|setEditCtx|setEditor|setFluidAttr|setFocus|setInfinity|setInputDeviceMapping|setKeyCtx|setKeyPath|setKeyframe|setKeyframeBlendshapeTargetWts|setMenuMode|setNodeNiceNameResource|setNodeTypeFlag|setParent|setParticleAttr|setPfxToPolyCamera|setPluginResource|setProject|setStampDensity|setStartupMessage|setState|setToolTo|setUITemplate|setXformManip|sets|shadingConnection|shadingGeometryRelCtx|shadingLightRelCtx|shadingNetworkCompare|shadingNode|shapeCompare|shelfButton|shelfLayout|shelfTabLayout|shellField|shortNameOf|showHelp|showHidden|showManipCtx|showSelectionInTitle|showShadingGroupAttrEditor|showWindow|sign|simplify|sin|singleProfileBirailSurface|size|sizeBytes|skinCluster|skinPercent|smoothCurve|smoothTangentSurface|smoothstep|snap2to2|snapKey|snapMode|snapTogetherCtx|snapshot|soft|softMod|softModCtx|sort|sound|soundControl|source|spaceLocator|sphere|sphrand|spotLight|spotLightPreviewPort|spreadSheetEditor|spring|sqrt|squareSurface|srtContext|stackTrace|startString|startsWith|stitchAndExplodeShell|stitchSurface|stitchSurfacePoints|strcmp|stringArrayCatenate|stringArrayContains|stringArrayCount|stringArrayInsertAtIndex|stringArrayIntersector|stringArrayRemove|stringArrayRemoveAtIndex|stringArrayRemoveDuplicates|stringArrayRemoveExact|stringArrayToString|stringToStringArray|strip|stripPrefixFromName|stroke|subdAutoProjection|subdCleanTopology|subdCollapse|subdDuplicateAndConnect|subdEditUV|subdListComponentConversion|subdMapCut|subdMapSewMove|subdMatchTopology|subdMirror|subdToBlind|subdToPoly|subdTransferUVsToCache|subdiv|subdivCrease|subdivDisplaySmoothness|substitute|substituteAllString|substituteGeometry|substring|surface|surfaceSampler|surfaceShaderList|swatchDisplayPort|switchTable|symbolButton|symbolCheckBox|sysFile|system|tabLayout|tan|tangentConstraint|texLatticeDeformContext|texManipContext|texMoveContext|texMoveUVShellContext|texRotateContext|texScaleContext|texSelectContext|texSelectShortestPathCtx|texSmudgeUVContext|texWinToolCtx|text|textCurves|textField|textFieldButtonGrp|textFieldGrp|textManip|textScrollList|textToShelf|textureDisplacePlane|textureHairColor|texturePlacementContext|textureWindow|threadCount|threePointArcCtx|timeControl|timePort|timerX|toNativePath|toggle|toggleAxis|toggleWindowVisibility|tokenize|tokenizeList|tolerance|tolower|toolButton|toolCollection|toolDropped|toolHasOptions|toolPropertyWindow|torus|toupper|trace|track|trackCtx|transferAttributes|transformCompare|transformLimits|translator|trim|trunc|truncateFluidCache|truncateHairCache|tumble|tumbleCtx|turbulence|twoPointArcCtx|uiRes|uiTemplate|unassignInputDevice|undo|undoInfo|ungroup|uniform|unit|unloadPlugin|untangleUV|untitledFileName|untrim|upAxis|updateAE|userCtx|uvLink|uvSnapshot|validateShelfName|vectorize|view2dToolCtx|viewCamera|viewClipPlane|viewFit|viewHeadOn|viewLookAt|viewManip|viewPlace|viewSet|visor|volumeAxis|vortex|waitCursor|warning|webBrowser|webBrowserPrefs|whatIs|window|windowPref|wire|wireContext|workspace|wrinkle|wrinkleContext|writeTake|xbmLangPathList|xform)\b/,
        operator: [
            /\+[+=]?|-[-=]?|&&|\|\||[<>]=|[*\/!=]=?|[%^]/,
            {
                // We don't want to match <<
                pattern: /(^|[^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /(^|[^>])>(?!>)/,
                lookbehind: true
            }
        ],
        punctuation: /<<|>>|[.,:;?\[\](){}]/
    };
    Prism.languages.mel['code'].inside.rest = Prism.languages.mel;
}

},{}],"85zhP":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = mermaid;
mermaid.displayName = 'mermaid';
mermaid.aliases = [];
function mermaid(Prism) {
    Prism.languages.mermaid = {
        comment: {
            pattern: /%%.*/,
            greedy: true
        },
        style: {
            pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
            lookbehind: true,
            inside: {
                property: /\b\w[\w-]*(?=[ \t]*:)/,
                operator: /:/,
                punctuation: /,/
            }
        },
        'inter-arrow-label': {
            pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
            lookbehind: true,
            greedy: true,
            inside: {
                arrow: {
                    pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
                    alias: 'operator'
                },
                label: {
                    pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
                    lookbehind: true,
                    alias: 'property'
                },
                'arrow-head': {
                    pattern: /^\S+/,
                    alias: [
                        'arrow',
                        'operator'
                    ]
                }
            }
        },
        arrow: [
            // This might look complex but it really isn't.
            // There are many possible arrows (see tests) and it's impossible to fit all of them into one pattern. The
            // problem is that we only have one lookbehind per pattern. However, we cannot disallow too many arrow
            // characters in the one lookbehind because that would create too many false negatives. So we have to split the
            // arrows into different patterns.
            {
                // ER diagram
                pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // flow chart
                // (?:==+|--+|-\.*-)
                pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // sequence diagram
                pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // class diagram
                pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
                lookbehind: true,
                alias: 'operator'
            }
        ],
        label: {
            pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        text: {
            pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
            alias: 'string'
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        annotation: {
            pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
            alias: 'important'
        },
        keyword: [
            // This language has both case-sensitive and case-insensitive keywords
            {
                pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
                lookbehind: true,
                greedy: true
            }
        ],
        entity: /#[a-z0-9]+;/,
        operator: {
            pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
            lookbehind: true
        },
        punctuation: /[(){};]/
    };
}

},{}],"1TpRw":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = mizar;
mizar.displayName = 'mizar';
mizar.aliases = [];
function mizar(Prism) {
    Prism.languages.mizar = {
        comment: /::.+/,
        keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
        parameter: {
            pattern: /\$(?:10|\d)/,
            alias: 'variable'
        },
        variable: /\b\w+(?=:)/,
        number: /(?:\b|-)\d+\b/,
        operator: /\.\.\.|->|&|\.?=/,
        punctuation: /\(#|#\)|[,:;\[\](){}]/
    };
}

},{}],"e7rrr":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = mongodb;
mongodb.displayName = 'mongodb';
mongodb.aliases = [];
function mongodb(Prism) {
    (function(Prism) {
        var operators = [
            // query and projection
            '$eq',
            '$gt',
            '$gte',
            '$in',
            '$lt',
            '$lte',
            '$ne',
            '$nin',
            '$and',
            '$not',
            '$nor',
            '$or',
            '$exists',
            '$type',
            '$expr',
            '$jsonSchema',
            '$mod',
            '$regex',
            '$text',
            '$where',
            '$geoIntersects',
            '$geoWithin',
            '$near',
            '$nearSphere',
            '$all',
            '$elemMatch',
            '$size',
            '$bitsAllClear',
            '$bitsAllSet',
            '$bitsAnyClear',
            '$bitsAnySet',
            '$comment',
            '$elemMatch',
            '$meta',
            '$slice',
            '$currentDate',
            '$inc',
            '$min',
            '$max',
            '$mul',
            '$rename',
            '$set',
            '$setOnInsert',
            '$unset',
            '$addToSet',
            '$pop',
            '$pull',
            '$push',
            '$pullAll',
            '$each',
            '$position',
            '$slice',
            '$sort',
            '$bit',
            '$addFields',
            '$bucket',
            '$bucketAuto',
            '$collStats',
            '$count',
            '$currentOp',
            '$facet',
            '$geoNear',
            '$graphLookup',
            '$group',
            '$indexStats',
            '$limit',
            '$listLocalSessions',
            '$listSessions',
            '$lookup',
            '$match',
            '$merge',
            '$out',
            '$planCacheStats',
            '$project',
            '$redact',
            '$replaceRoot',
            '$replaceWith',
            '$sample',
            '$set',
            '$skip',
            '$sort',
            '$sortByCount',
            '$unionWith',
            '$unset',
            '$unwind',
            '$setWindowFields',
            '$abs',
            '$accumulator',
            '$acos',
            '$acosh',
            '$add',
            '$addToSet',
            '$allElementsTrue',
            '$and',
            '$anyElementTrue',
            '$arrayElemAt',
            '$arrayToObject',
            '$asin',
            '$asinh',
            '$atan',
            '$atan2',
            '$atanh',
            '$avg',
            '$binarySize',
            '$bsonSize',
            '$ceil',
            '$cmp',
            '$concat',
            '$concatArrays',
            '$cond',
            '$convert',
            '$cos',
            '$dateFromParts',
            '$dateToParts',
            '$dateFromString',
            '$dateToString',
            '$dayOfMonth',
            '$dayOfWeek',
            '$dayOfYear',
            '$degreesToRadians',
            '$divide',
            '$eq',
            '$exp',
            '$filter',
            '$first',
            '$floor',
            '$function',
            '$gt',
            '$gte',
            '$hour',
            '$ifNull',
            '$in',
            '$indexOfArray',
            '$indexOfBytes',
            '$indexOfCP',
            '$isArray',
            '$isNumber',
            '$isoDayOfWeek',
            '$isoWeek',
            '$isoWeekYear',
            '$last',
            '$last',
            '$let',
            '$literal',
            '$ln',
            '$log',
            '$log10',
            '$lt',
            '$lte',
            '$ltrim',
            '$map',
            '$max',
            '$mergeObjects',
            '$meta',
            '$min',
            '$millisecond',
            '$minute',
            '$mod',
            '$month',
            '$multiply',
            '$ne',
            '$not',
            '$objectToArray',
            '$or',
            '$pow',
            '$push',
            '$radiansToDegrees',
            '$range',
            '$reduce',
            '$regexFind',
            '$regexFindAll',
            '$regexMatch',
            '$replaceOne',
            '$replaceAll',
            '$reverseArray',
            '$round',
            '$rtrim',
            '$second',
            '$setDifference',
            '$setEquals',
            '$setIntersection',
            '$setIsSubset',
            '$setUnion',
            '$size',
            '$sin',
            '$slice',
            '$split',
            '$sqrt',
            '$stdDevPop',
            '$stdDevSamp',
            '$strcasecmp',
            '$strLenBytes',
            '$strLenCP',
            '$substr',
            '$substrBytes',
            '$substrCP',
            '$subtract',
            '$sum',
            '$switch',
            '$tan',
            '$toBool',
            '$toDate',
            '$toDecimal',
            '$toDouble',
            '$toInt',
            '$toLong',
            '$toObjectId',
            '$toString',
            '$toLower',
            '$toUpper',
            '$trim',
            '$trunc',
            '$type',
            '$week',
            '$year',
            '$zip',
            '$count',
            '$dateAdd',
            '$dateDiff',
            '$dateSubtract',
            '$dateTrunc',
            '$getField',
            '$rand',
            '$sampleRate',
            '$setField',
            '$unsetField',
            '$comment',
            '$explain',
            '$hint',
            '$max',
            '$maxTimeMS',
            '$min',
            '$orderby',
            '$query',
            '$returnKey',
            '$showDiskLoc',
            '$natural'
        ];
        var builtinFunctions = [
            'ObjectId',
            'Code',
            'BinData',
            'DBRef',
            'Timestamp',
            'NumberLong',
            'NumberDecimal',
            'MaxKey',
            'MinKey',
            'RegExp',
            'ISODate',
            'UUID'
        ];
        operators = operators.map(function(operator) {
            return operator.replace('$', '\\$');
        });
        var operatorsSource = '(?:' + operators.join('|') + ')\\b';
        Prism.languages.mongodb = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('mongodb', 'string', {
            property: {
                pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
                greedy: true,
                inside: {
                    keyword: RegExp('^([\'"])?' + operatorsSource + '(?:\\1)?$')
                }
            }
        });
        Prism.languages.mongodb.string.inside = {
            url: {
                // url pattern
                pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
                greedy: true
            },
            entity: {
                // ipv4
                pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
                greedy: true
            }
        };
        Prism.languages.insertBefore('mongodb', 'constant', {
            builtin: {
                pattern: RegExp('\\b(?:' + builtinFunctions.join('|') + ')\\b'),
                alias: 'keyword'
            }
        });
    })(Prism);
}

},{}],"iUJZb":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = monkey;
monkey.displayName = 'monkey';
monkey.aliases = [];
function monkey(Prism) {
    Prism.languages.monkey = {
        comment: {
            pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        preprocessor: {
            pattern: /(^[ \t]*)#.+/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        function: /\b\w+(?=\()/,
        'type-char': {
            pattern: /\b[?%#$]/,
            alias: 'class-name'
        },
        number: {
            pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
            lookbehind: true
        },
        keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
        operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
        punctuation: /[.,:;()\[\]]/
    };
}

},{}],"3wIC8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = moonscript;
moonscript.displayName = 'moonscript';
moonscript.aliases = [
    'moon'
];
function moonscript(Prism) {
    Prism.languages.moonscript = {
        comment: /--.*/,
        string: [
            {
                pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
                greedy: true
            },
            {
                pattern: /"[^"]*"/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /#\{[^{}]*\}/,
                        inside: {
                            moonscript: {
                                pattern: /(^#\{)[\s\S]+(?=\})/,
                                lookbehind: true,
                                inside: null // see beow
                            },
                            'interpolation-punctuation': {
                                pattern: /#\{|\}/,
                                alias: 'punctuation'
                            }
                        }
                    }
                }
            }
        ],
        'class-name': [
            {
                pattern: /(\b(?:class|extends)[ \t]+)\w+/,
                lookbehind: true
            },
            /\b[A-Z]\w*/
        ],
        keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
        variable: /@@?\w*/,
        property: {
            pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
            lookbehind: true
        },
        function: {
            pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
            inside: {
                punctuation: /\./
            }
        },
        boolean: /\b(?:false|true)\b/,
        number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
        operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
        punctuation: /[.,()[\]{}\\]/
    };
    Prism.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = Prism.languages.moonscript;
    Prism.languages.moon = Prism.languages.moonscript;
}

},{}],"jZE9i":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = n1ql;
n1ql.displayName = 'n1ql';
n1ql.aliases = [];
function n1ql(Prism) {
    // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/index.html
    Prism.languages.n1ql = {
        comment: {
            pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
            greedy: true
        },
        parameter: /\$[\w.]+/,
        // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html#n1ql-reserved-words
        keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
        punctuation: /[;[\](),.{}:]/
    };
}

},{}],"kNawC":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = n4js;
n4js.displayName = 'n4js';
n4js.aliases = [
    'n4jsd'
];
function n4js(Prism) {
    Prism.languages.n4js = Prism.languages.extend('javascript', {
        // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
        keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
    });
    Prism.languages.insertBefore('n4js', 'constant', {
        // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
        annotation: {
            pattern: /@+\w+/,
            alias: 'operator'
        }
    });
    Prism.languages.n4jsd = Prism.languages.n4js;
}

},{}],"3ZTNF":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = nand2tetrisHdl;
nand2tetrisHdl.displayName = 'nand2tetrisHdl';
nand2tetrisHdl.aliases = [];
function nand2tetrisHdl(Prism) {
    Prism.languages['nand2tetris-hdl'] = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
        number: /\b\d+\b/,
        operator: /=|\.\./,
        punctuation: /[{}[\];(),:]/
    };
}

},{}],"3O6ws":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = naniscript;
naniscript.displayName = 'naniscript';
naniscript.aliases = [];
function naniscript(Prism) {
    (function(Prism) {
        var expressionDef = /\{[^\r\n\[\]{}]*\}/;
        var params = {
            'quoted-string': {
                pattern: /"(?:[^"\\]|\\.)*"/,
                alias: 'operator'
            },
            'command-param-id': {
                pattern: /(\s)\w+:/,
                lookbehind: true,
                alias: 'property'
            },
            'command-param-value': [
                {
                    pattern: expressionDef,
                    alias: 'selector'
                },
                {
                    pattern: /([\t ])\S+/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'operator'
                },
                {
                    pattern: /\S(?:.*\S)?/,
                    alias: 'operator'
                }
            ]
        };
        Prism.languages.naniscript = {
            // ; ...
            comment: {
                pattern: /^([\t ]*);.*/m,
                lookbehind: true
            },
            // > ...
            // Define is a control line starting with '>' followed by a word, a space and a text.
            define: {
                pattern: /^>.+/m,
                alias: 'tag',
                inside: {
                    value: {
                        pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    key: {
                        pattern: /(^>)\w+/,
                        lookbehind: true
                    }
                }
            },
            // # ...
            label: {
                pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
                lookbehind: true,
                alias: 'regex'
            },
            command: {
                pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
                lookbehind: true,
                alias: 'function',
                inside: {
                    'command-name': /^@\w+/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'command-params': {
                        pattern: /\s*\S[\s\S]*/,
                        inside: params
                    }
                }
            },
            // Generic is any line that doesn't start with operators: ;>#@
            'generic-text': {
                pattern: /(^[ \t]*)[^#@>;\s].*/m,
                lookbehind: true,
                alias: 'punctuation',
                inside: {
                    // \{ ... \} ... \[ ... \] ... \"
                    'escaped-char': /\\[{}\[\]"]/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'inline-command': {
                        pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
                        greedy: true,
                        alias: 'function',
                        inside: {
                            'command-params': {
                                pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                                lookbehind: true,
                                inside: params
                            },
                            'command-param-name': {
                                pattern: /^(\[[\t ]*)\w+/,
                                lookbehind: true,
                                alias: 'name'
                            },
                            'start-stop-char': /[\[\]]/
                        }
                    }
                }
            }
        };
        Prism.languages.nani = Prism.languages['naniscript'];
        /** @typedef {InstanceType<import("./prism-core")["Token"]>} Token */ /**
     * This hook is used to validate generic-text tokens for balanced brackets.
     * Mark token as bad-line when contains not balanced brackets: {},[]
     */ Prism.hooks.add('after-tokenize', function(env) {
            /** @type {(Token | string)[]} */ var tokens = env.tokens;
            tokens.forEach(function(token) {
                if (typeof token !== 'string' && token.type === 'generic-text') {
                    var content = getTextContent(token);
                    if (!isBracketsBalanced(content)) {
                        token.type = 'bad-line';
                        token.content = content;
                    }
                }
            });
        });
        /**
     * @param {string} input
     * @returns {boolean}
     */ function isBracketsBalanced(input) {
            var brackets = '[]{}';
            var stack = [];
            for(var i = 0; i < input.length; i++){
                var bracket = input[i];
                var bracketsIndex = brackets.indexOf(bracket);
                if (bracketsIndex !== -1) {
                    if (bracketsIndex % 2 === 0) stack.push(bracketsIndex + 1);
                    else if (stack.pop() !== bracketsIndex) return false;
                }
            }
            return stack.length === 0;
        }
        /**
     * @param {string | Token | (string | Token)[]} token
     * @returns {string}
     */ function getTextContent(token) {
            if (typeof token === 'string') return token;
            else if (Array.isArray(token)) return token.map(getTextContent).join('');
            else return getTextContent(token.content);
        }
    })(Prism);
}

},{}],"a3VxR":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = nasm;
nasm.displayName = 'nasm';
nasm.aliases = [];
function nasm(Prism) {
    Prism.languages.nasm = {
        comment: /;.*$/m,
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        label: {
            pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
            lookbehind: true,
            alias: 'function'
        },
        keyword: [
            /\[?BITS (?:16|32|64)\]?/,
            {
                pattern: /(^\s*)section\s*[a-z.]+:?/im,
                lookbehind: true
            },
            /(?:extern|global)[^;\r\n]*/i,
            /(?:CPU|DEFAULT|FLOAT).*$/m
        ],
        register: {
            pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
            alias: 'variable'
        },
        number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
        operator: /[\[\]*+\-\/%<>=&|$!]/
    };
}

},{}],"inhvP":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = neon;
neon.displayName = 'neon';
neon.aliases = [];
function neon(Prism) {
    Prism.languages.neon = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        datetime: {
            pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
            lookbehind: true,
            alias: 'number'
        },
        key: {
            pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
            lookbehind: true,
            alias: 'atrule'
        },
        number: {
            pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
            lookbehind: true
        },
        null: {
            pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
            lookbehind: true,
            alias: 'keyword'
        },
        string: {
            pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
            lookbehind: true,
            greedy: true
        },
        literal: {
            pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
            lookbehind: true,
            alias: 'string'
        },
        punctuation: /[,:=[\]{}()-]/
    };
}

},{}],"lOJ5E":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = nevod;
nevod.displayName = 'nevod';
nevod.aliases = [];
function nevod(Prism) {
    Prism.languages.nevod = {
        comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
        string: {
            pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
            greedy: true,
            inside: {
                'string-attrs': /!$|!\*$|\*$/
            }
        },
        namespace: {
            pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
            lookbehind: true
        },
        pattern: {
            pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
            lookbehind: true,
            inside: {
                'pattern-name': {
                    pattern: /^#?[a-zA-Z0-9\-.]+/,
                    alias: 'class-name'
                },
                fields: {
                    pattern: /\(.*\)/,
                    inside: {
                        'field-name': {
                            pattern: /[a-zA-Z0-9\-.]+/,
                            alias: 'variable'
                        },
                        punctuation: /[,()]/,
                        operator: {
                            pattern: /~/,
                            alias: 'field-hidden-mark'
                        }
                    }
                }
            }
        },
        search: {
            pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
            alias: 'function',
            lookbehind: true
        },
        keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
        'standard-pattern': {
            pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
            inside: {
                'standard-pattern-name': {
                    pattern: /^[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                quantifier: {
                    pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
                    alias: 'number'
                },
                'standard-pattern-attr': {
                    pattern: /[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                punctuation: /[,()]/
            }
        },
        quantifier: {
            pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
            alias: 'number'
        },
        operator: [
            {
                pattern: /=/,
                alias: 'pattern-def'
            },
            {
                pattern: /&/,
                alias: 'conjunction'
            },
            {
                pattern: /~/,
                alias: 'exception'
            },
            {
                pattern: /\?/,
                alias: 'optionality'
            },
            {
                pattern: /[[\]]/,
                alias: 'repetition'
            },
            {
                pattern: /[{}]/,
                alias: 'variation'
            },
            {
                pattern: /[+_]/,
                alias: 'sequence'
            },
            {
                pattern: /\.{2,3}/,
                alias: 'span'
            }
        ],
        'field-capture': [
            {
                pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
                lookbehind: true,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            },
            {
                pattern: /[a-zA-Z0-9\-.]+\s*:/,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            }
        ],
        punctuation: /[:;,()]/,
        name: /[a-zA-Z0-9\-.]+/
    };
}

},{}],"cCw8C":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = nginx;
nginx.displayName = 'nginx';
nginx.aliases = [];
function nginx(Prism) {
    (function(Prism) {
        var variable = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
        Prism.languages.nginx = {
            comment: {
                pattern: /(^|[\s{};])#.*/,
                lookbehind: true,
                greedy: true
            },
            directive: {
                pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: {
                    string: {
                        pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            escape: {
                                pattern: /\\["'\\nrt]/,
                                alias: 'entity'
                            },
                            variable: variable
                        }
                    },
                    comment: {
                        pattern: /(\s)#.*/,
                        lookbehind: true,
                        greedy: true
                    },
                    keyword: {
                        pattern: /^\S+/,
                        greedy: true
                    },
                    // other patterns
                    boolean: {
                        pattern: /(\s)(?:off|on)(?!\S)/,
                        lookbehind: true
                    },
                    number: {
                        pattern: /(\s)\d+[a-z]*(?!\S)/i,
                        lookbehind: true
                    },
                    variable: variable
                }
            },
            punctuation: /[{};]/
        };
    })(Prism);
}

},{}],"4KAxW":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = nim;
nim.displayName = 'nim';
nim.aliases = [];
function nim(Prism) {
    Prism.languages.nim = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
            pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
            greedy: true
        },
        char: {
            // Character literals are handled specifically to prevent issues with numeric type suffixes
            pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
            greedy: true
        },
        function: {
            pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
            greedy: true,
            inside: {
                operator: /\*$/
            }
        },
        // We don't want to highlight operators (and anything really) inside backticks
        identifier: {
            pattern: /`[^`\r\n]+`/,
            greedy: true,
            inside: {
                punctuation: /`/
            }
        },
        // The negative look ahead prevents wrong highlighting of the .. operator
        number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
        keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
        operator: {
            // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
            // but allow the slice operator .. to take precedence over them
            // One can define his own operators in Nim so all combination of operators might be an operator.
            pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
            lookbehind: true
        },
        punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
    };
}

},{}],"lXqle":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = nix;
nix.displayName = 'nix';
nix.aliases = [];
function nix(Prism) {
    Prism.languages.nix = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
            greedy: true,
            inside: {
                interpolation: {
                    // The lookbehind ensures the ${} is not preceded by \ or ''
                    pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
                    lookbehind: true,
                    inside: null // see below
                }
            }
        },
        url: [
            /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
            {
                pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
                lookbehind: true
            }
        ],
        antiquotation: {
            pattern: /\$(?=\{)/,
            alias: 'important'
        },
        number: /\b\d+\b/,
        keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
        function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
        boolean: /\b(?:false|true)\b/,
        operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
        punctuation: /[{}()[\].,:;]/
    };
    Prism.languages.nix.string.inside.interpolation.inside = Prism.languages.nix;
}

},{}],"l0YCE":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = nsis;
nsis.displayName = 'nsis';
nsis.aliases = [];
function nsis(Prism) {
    /**
   * Original by Jan T. Sott (http://github.com/idleberg)
   *
   * Includes all commands and plug-ins shipped with NSIS 3.08
   */ Prism.languages.nsis = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: {
            pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|LabelAddress|TempFileName)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
            lookbehind: true
        },
        property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
        constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
        variable: /\$\w[\w\.]*/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
        punctuation: /[{}[\];(),.:]/,
        important: {
            pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
            lookbehind: true
        }
    };
}

},{}],"bGqgq":[function(require,module,exports,__globalThis) {
'use strict';
var refractorC = require("646c1747044dd5ba");
module.exports = objectivec;
objectivec.displayName = 'objectivec';
objectivec.aliases = [
    'objc'
];
function objectivec(Prism) {
    Prism.register(refractorC);
    Prism.languages.objectivec = Prism.languages.extend('c', {
        string: {
            pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
        operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
    });
    delete Prism.languages.objectivec['class-name'];
    Prism.languages.objc = Prism.languages.objectivec;
}

},{"646c1747044dd5ba":"eMUEZ"}],"a7XNF":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = ocaml;
ocaml.displayName = 'ocaml';
ocaml.aliases = [];
function ocaml(Prism) {
    // https://ocaml.org/manual/lex.html
    Prism.languages.ocaml = {
        comment: {
            pattern: /\(\*[\s\S]*?\*\)/,
            greedy: true
        },
        char: {
            pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
            greedy: true
        },
        string: [
            {
                pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
                greedy: true
            },
            {
                pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
                greedy: true
            }
        ],
        number: [
            // binary and octal
            /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
            /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
            /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
        ],
        directive: {
            pattern: /\B#\w+/,
            alias: 'property'
        },
        label: {
            pattern: /\B~\w+/,
            alias: 'property'
        },
        'type-variable': {
            pattern: /\B'\w+/,
            alias: 'function'
        },
        variant: {
            pattern: /`\w+/,
            alias: 'symbol'
        },
        // For the list of keywords and operators,
        // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
        keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        'operator-like-punctuation': {
            pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
            alias: 'punctuation'
        },
        // Custom operators are allowed
        operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
        punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
    };
}

},{}],"2aF5V":[function(require,module,exports,__globalThis) {
'use strict';
var refractorC = require("9c144f560e3d758d");
module.exports = opencl;
opencl.displayName = 'opencl';
opencl.aliases = [];
function opencl(Prism) {
    Prism.register(refractorC);
    (function(Prism) {
        /* OpenCL kernel language */ Prism.languages.opencl = Prism.languages.extend('c', {
            // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
            keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
            // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
            // Math Constants: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/mathConstants.html
            // Macros and Limits: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/macroLimits.html
            number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
            boolean: /\b(?:false|true)\b/,
            'constant-opencl-kernel': {
                pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
                alias: 'constant'
            }
        });
        Prism.languages.insertBefore('opencl', 'class-name', {
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/scalarDataTypes.html
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/otherDataTypes.html
            'builtin-type': {
                pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
                alias: 'keyword'
            }
        });
        var attributes = {
            // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
            'type-opencl-host': {
                pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
                alias: 'keyword'
            },
            'boolean-opencl-host': {
                pattern: /\bCL_(?:FALSE|TRUE)\b/,
                alias: 'boolean'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
            'constant-opencl-host': {
                pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
                alias: 'constant'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
            'function-opencl-host': {
                pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
                alias: 'function'
            }
        };
        /* OpenCL host API */ Prism.languages.insertBefore('c', 'keyword', attributes) // C++ includes everything from the OpenCL C host API plus the classes defined in cl2.h
        ;
        if (Prism.languages.cpp) {
            // Extracted from doxygen class list http://github.khronos.org/OpenCL-CLHPP/annotated.html
            attributes['type-opencl-host-cpp'] = {
                pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
                alias: 'keyword'
            };
            Prism.languages.insertBefore('cpp', 'keyword', attributes);
        }
    })(Prism);
}

},{"9c144f560e3d758d":"eMUEZ"}],"9N34f":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = openqasm;
openqasm.displayName = 'openqasm';
openqasm.aliases = [
    'qasm'
];
function openqasm(Prism) {
    // https://qiskit.github.io/openqasm/grammar/index.html
    Prism.languages.openqasm = {
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
            greedy: true
        },
        keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
        'class-name': /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
        function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
        constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
        number: {
            pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
            lookbehind: true
        },
        operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
        punctuation: /[(){}\[\];,:.]/
    };
    Prism.languages.qasm = Prism.languages.openqasm;
}

},{}],"8j7iJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = oz;
oz.displayName = 'oz';
oz.aliases = [];
function oz(Prism) {
    Prism.languages.oz = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        atom: {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            alias: 'builtin'
        },
        keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
        function: [
            /\b[a-z][A-Za-z\d]*(?=\()/,
            {
                pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
                lookbehind: true
            }
        ],
        number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
        variable: /`(?:[^`\\]|\\.)+`/,
        'attr-name': /\b\w+(?=[ \t]*:(?![:=]))/,
        operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
        punctuation: /[\[\](){}.:;?]/
    };
}

},{}],"1Dkyt":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = parigp;
parigp.displayName = 'parigp';
parigp.aliases = [];
function parigp(Prism) {
    Prism.languages.parigp = {
        comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"/,
            greedy: true
        },
        // PARI/GP does not care about white spaces at all
        // so let's process the keywords to build an appropriate regexp
        // (e.g. "b *r *e *a *k", etc.)
        keyword: function() {
            var keywords = [
                'breakpoint',
                'break',
                'dbg_down',
                'dbg_err',
                'dbg_up',
                'dbg_x',
                'forcomposite',
                'fordiv',
                'forell',
                'forpart',
                'forprime',
                'forstep',
                'forsubgroup',
                'forvec',
                'for',
                'iferr',
                'if',
                'local',
                'my',
                'next',
                'return',
                'until',
                'while'
            ];
            keywords = keywords.map(function(keyword) {
                return keyword.split('').join(' *');
            }).join('|');
            return RegExp('\\b(?:' + keywords + ')\\b');
        }(),
        function: /\b\w(?:[\w ]*\w)?(?= *\()/,
        number: {
            // The lookbehind and the negative lookahead prevent from breaking the .. operator
            pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
            lookbehind: true
        },
        operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
        punctuation: /[\[\]{}().,:;|]/
    };
}

},{}],"bhHtL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = parser;
parser.displayName = 'parser';
parser.aliases = [];
function parser(Prism) {
    (function(Prism) {
        var parser = Prism.languages.parser = Prism.languages.extend('markup', {
            keyword: {
                pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
                lookbehind: true
            },
            variable: {
                pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    punctuation: /\.|:+/
                }
            },
            function: {
                pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /(^@)(?:GET_|SET_)/,
                        lookbehind: true
                    },
                    punctuation: /\.|:+/
                }
            },
            escape: {
                pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
                alias: 'builtin'
            },
            punctuation: /[\[\](){};]/
        });
        parser = Prism.languages.insertBefore('parser', 'keyword', {
            'parser-comment': {
                pattern: /(\s)#.*/,
                lookbehind: true,
                alias: 'comment'
            },
            expression: {
                // Allow for 3 levels of depth
                pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
                greedy: true,
                lookbehind: true,
                inside: {
                    string: {
                        pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
                        lookbehind: true
                    },
                    keyword: parser.keyword,
                    variable: parser.variable,
                    function: parser.function,
                    boolean: /\b(?:false|true)\b/,
                    number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
                    escape: parser.escape,
                    operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
                    punctuation: parser.punctuation
                }
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            expression: parser.expression,
            keyword: parser.keyword,
            variable: parser.variable,
            function: parser.function,
            escape: parser.escape,
            'parser-punctuation': {
                pattern: parser.punctuation,
                alias: 'punctuation'
            }
        }, parser['tag'].inside['attr-value']);
    })(Prism);
}

},{}],"7B6xt":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = pascal;
pascal.displayName = 'pascal';
pascal.aliases = [
    'objectpascal'
];
function pascal(Prism) {
    // Based on Free Pascal
    /* TODO
Support inline asm ?
*/ Prism.languages.pascal = {
        directive: {
            pattern: /\{\$[\s\S]*?\}/,
            greedy: true,
            alias: [
                'marco',
                'property'
            ]
        },
        comment: {
            pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
            greedy: true
        },
        asm: {
            pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        keyword: [
            {
                // Turbo Pascal
                pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
                lookbehind: true
            },
            {
                // Free Pascal
                pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
                lookbehind: true
            },
            {
                // Object Pascal
                pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
                lookbehind: true
            },
            {
                // Modifiers
                pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
                lookbehind: true
            }
        ],
        number: [
            // Hexadecimal, octal and binary
            /(?:[&%]\d+|\$[a-f\d]+)/i,
            /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
        ],
        operator: [
            /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/,
            {
                pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
                lookbehind: true
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/
    };
    Prism.languages.pascal.asm.inside = Prism.languages.extend('pascal', {
        asm: undefined,
        keyword: undefined,
        operator: undefined
    });
    Prism.languages.objectpascal = Prism.languages.pascal;
}

},{}],"4MMj9":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = pascaligo;
pascaligo.displayName = 'pascaligo';
pascaligo.aliases = [];
function pascaligo(Prism) {
    (function(Prism) {
        // Pascaligo is a layer 2 smart contract language for the tezos blockchain
        var braces = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source;
        var type = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(/<braces>/g, function() {
            return braces;
        });
        var pascaligo = Prism.languages.pascaligo = {
            comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
                greedy: true
            },
            'class-name': [
                {
                    pattern: RegExp(/(\btype\s+\w+\s+is\s+)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    pattern: RegExp(/<type>(?=\s+is\b)/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    inside: null // see below
                },
                {
                    pattern: RegExp(/(:\s*)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            keyword: {
                pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[^&])\b(?:False|True)\b/i,
                lookbehind: true
            },
            builtin: {
                pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
                lookbehind: true
            },
            function: /\b\w+(?=\s*\()/,
            number: [
                // Hexadecimal, octal and binary
                /%[01]+|&[0-7]+|\$[a-f\d]+/i,
                /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i
            ],
            operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
            punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
        };
        var classNameInside = [
            'comment',
            'keyword',
            'builtin',
            'operator',
            'punctuation'
        ].reduce(function(accum, key) {
            accum[key] = pascaligo[key];
            return accum;
        }, {});
        pascaligo['class-name'].forEach(function(p) {
            p.inside = classNameInside;
        });
    })(Prism);
}

},{}],"8QYR8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = pcaxis;
pcaxis.displayName = 'pcaxis';
pcaxis.aliases = [
    'px'
];
function pcaxis(Prism) {
    Prism.languages.pcaxis = {
        string: /"[^"]*"/,
        keyword: {
            pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
            lookbehind: true,
            greedy: true,
            inside: {
                keyword: /^[-A-Z\d]+/,
                language: {
                    pattern: /^(\s*)\[[-\w]+\]/,
                    lookbehind: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        property: /[-\w]+/
                    }
                },
                'sub-key': {
                    pattern: /^(\s*)\S[\s\S]*/,
                    lookbehind: true,
                    inside: {
                        parameter: {
                            pattern: /"[^"]*"/,
                            alias: 'property'
                        },
                        punctuation: /^\(|\)$|,/
                    }
                }
            }
        },
        operator: /=/,
        tlist: {
            pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
            greedy: true,
            inside: {
                function: /^TLIST/,
                property: {
                    pattern: /^(\s*\(\s*)\w+/,
                    lookbehind: true
                },
                string: /"[^"]*"/,
                punctuation: /[(),]/,
                operator: /-/
            }
        },
        punctuation: /[;,]/,
        number: {
            pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
            lookbehind: true
        },
        boolean: /NO|YES/
    };
    Prism.languages.px = Prism.languages.pcaxis;
}

},{}],"ibccN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = peoplecode;
peoplecode.displayName = 'peoplecode';
peoplecode.aliases = [
    'pcode'
];
function peoplecode(Prism) {
    Prism.languages.peoplecode = {
        comment: RegExp([
            // C-style multiline comments
            /\/\*[\s\S]*?\*\//.source,
            /\bREM[^;]*;/.source,
            /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source,
            /\/\+[\s\S]*?\+\//.source
        ].join('|')),
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        variable: /%\w+/,
        'function-definition': {
            pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
            lookbehind: true,
            alias: 'function'
        },
        'class-name': {
            pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
            lookbehind: true,
            inside: {
                punctuation: /:/
            }
        },
        keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
        'operator-keyword': {
            pattern: /\b(?:and|not|or)\b/i,
            alias: 'operator'
        },
        function: /[_a-z]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
        punctuation: /[:.;,()[\]]/
    };
    Prism.languages.pcode = Prism.languages.peoplecode;
}

},{}],"4KqDc":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = perl;
perl.displayName = 'perl';
perl.aliases = [];
function perl(Prism) {
    (function(Prism) {
        var brackets = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
        Prism.languages.perl = {
            comment: [
                {
                    // POD
                    pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // TODO Could be nice to handle Heredoc too.
            string: [
                {
                    pattern: RegExp(/\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // q/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // q{...}
                        // q[...]
                        // q<...>
                        brackets
                    ].join('|') + ')'),
                    greedy: true
                },
                {
                    pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
                    greedy: true
                },
                // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
                {
                    pattern: /'(?:[^'\\\r\n]|\\.)*'/,
                    greedy: true
                }
            ],
            regex: [
                {
                    pattern: RegExp(/\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // m/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // m{...}
                        // m[...]
                        // m<...>
                        brackets
                    ].join('|') + ')' + /[msixpodualngc]*/.source),
                    greedy: true
                },
                {
                    pattern: RegExp(/(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // s/.../.../
                        // eslint-disable-next-line regexp/strict
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
                        // s{...}{...}
                        // s[...][...]
                        // s<...><...>
                        // s(...)[...]
                        brackets + /\s*/.source + brackets
                    ].join('|') + ')' + /[msixpodualngcer]*/.source),
                    lookbehind: true,
                    greedy: true
                },
                // The look-ahead tries to prevent two divisions on
                // the same line from being highlighted as regex.
                // This does not support multi-line regex.
                {
                    pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
                    greedy: true
                }
            ],
            // FIXME Not sure about the handling of ::, ', and #
            variable: [
                // ${^POSTMATCH}
                /[&*$@%]\{\^[A-Z]+\}/,
                /[&*$@%]\^[A-Z_]/,
                /[&*$@%]#?(?=\{)/,
                /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
                /[&*$@%]\d+/,
                // The negative lookahead prevents from breaking the %= operator
                /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
            ],
            filehandle: {
                // <>, <FOO>, _
                pattern: /<(?![<=])\S*?>|\b_\b/,
                alias: 'symbol'
            },
            'v-string': {
                // v1.2, 1.2.3
                pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
                alias: 'string'
            },
            function: {
                pattern: /(\bsub[ \t]+)\w+/,
                lookbehind: true
            },
            keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
            operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
            punctuation: /[{}[\];(),:]/
        };
    })(Prism);
}

},{}],"95d0b":[function(require,module,exports,__globalThis) {
'use strict';
var refractorPhp = require("660b1382283bac8a");
module.exports = phpExtras;
phpExtras.displayName = 'phpExtras';
phpExtras.aliases = [];
function phpExtras(Prism) {
    Prism.register(refractorPhp);
    Prism.languages.insertBefore('php', 'variable', {
        this: {
            pattern: /\$this\b/,
            alias: 'keyword'
        },
        global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
        scope: {
            pattern: /\b[\w\\]+::/,
            inside: {
                keyword: /\b(?:parent|self|static)\b/,
                punctuation: /::|\\/
            }
        }
    });
}

},{"660b1382283bac8a":"f5DlF"}],"bNNMg":[function(require,module,exports,__globalThis) {
'use strict';
var refractorPhp = require("df22f6baff60b7a1");
var refractorJavadoclike = require("a9f91c7f8aa6f7ea");
module.exports = phpdoc;
phpdoc.displayName = 'phpdoc';
phpdoc.aliases = [];
function phpdoc(Prism) {
    Prism.register(refractorPhp);
    Prism.register(refractorJavadoclike);
    (function(Prism) {
        var typeExpression = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
        Prism.languages.phpdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                pattern: RegExp('(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:' + typeExpression + '\\s+)?)\\$\\w+'),
                lookbehind: true
            }
        });
        Prism.languages.insertBefore('phpdoc', 'keyword', {
            'class-name': [
                {
                    pattern: RegExp('(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)' + typeExpression),
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
                        punctuation: /[|\\[\]()]/
                    }
                }
            ]
        });
        Prism.languages.javadoclike.addSupport('php', Prism.languages.phpdoc);
    })(Prism);
}

},{"df22f6baff60b7a1":"f5DlF","a9f91c7f8aa6f7ea":"kn1Ox"}],"kMtT3":[function(require,module,exports,__globalThis) {
'use strict';
var refractorSql = require("59463b1a24459a5d");
module.exports = plsql;
plsql.displayName = 'plsql';
plsql.aliases = [];
function plsql(Prism) {
    Prism.register(refractorSql);
    Prism.languages.plsql = Prism.languages.extend('sql', {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|--.*/,
            greedy: true
        },
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-reserved-words-keywords.html
        keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-language-fundamentals.html#GUID-96A42F7C-7A71-4B90-8255-CA9C8BD9722E
        operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
    });
    Prism.languages.insertBefore('plsql', 'operator', {
        label: {
            pattern: /<<\s*\w+\s*>>/,
            alias: 'symbol'
        }
    });
}

},{"59463b1a24459a5d":"g6Eid"}],"590zq":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = powerquery;
powerquery.displayName = 'powerquery';
powerquery.aliases = [];
function powerquery(Prism) {
    // https://docs.microsoft.com/en-us/powerquery-m/power-query-m-language-specification
    Prism.languages.powerquery = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        'quoted-identifier': {
            pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        string: {
            pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        constant: [
            /\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/,
            /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/,
            /\bOccurrence\.(?:All|First|Last)\b/,
            /\bOrder\.(?:Ascending|Descending)\b/,
            /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/,
            /\bMissingField\.(?:Error|Ignore|UseNull)\b/,
            /\bQuoteStyle\.(?:Csv|None)\b/,
            /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/,
            /\bGroupKind\.(?:Global|Local)\b/,
            /\bExtraValues\.(?:Error|Ignore|List)\b/,
            /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/,
            /\bJoinSide\.(?:Left|Right)\b/,
            /\bPrecision\.(?:Decimal|Double)\b/,
            /\bRelativePosition\.From(?:End|Start)\b/,
            /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/,
            /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/,
            /\bnull\b/
        ],
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
        function: {
            pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
            lookbehind: true
        },
        'data-type': {
            pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
            alias: 'class-name'
        },
        number: {
            pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
            lookbehind: true
        },
        operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
        punctuation: /[,;\[\](){}]/
    };
    Prism.languages.pq = Prism.languages['powerquery'];
    Prism.languages.mscript = Prism.languages['powerquery'];
}

},{}],"1caAO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = powershell;
powershell.displayName = 'powershell';
powershell.aliases = [];
function powershell(Prism) {
    (function(Prism) {
        var powershell = Prism.languages.powershell = {
            comment: [
                {
                    pattern: /(^|[^`])<#[\s\S]*?#>/,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^`])#.*/,
                    lookbehind: true
                }
            ],
            string: [
                {
                    pattern: /"(?:`[\s\S]|[^`"])*"/,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /'(?:[^']|'')*'/,
                    greedy: true
                }
            ],
            // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
            // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
            namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
            boolean: /\$(?:false|true)\b/i,
            variable: /\$\w+\b/,
            // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
            // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
            // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
            function: [
                /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
                /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
            ],
            // per http://technet.microsoft.com/en-us/library/hh847744.aspx
            keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
            operator: {
                pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
                lookbehind: true
            },
            punctuation: /[|{}[\];(),.]/
        } // Variable interpolation inside strings, and nested expressions
        ;
        powershell.string[0].inside = {
            function: {
                // Allow for one level of nesting
                pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
                lookbehind: true,
                inside: powershell
            },
            boolean: powershell.boolean,
            variable: powershell.variable
        };
    })(Prism);
}

},{}],"fShuq":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = processing;
processing.displayName = 'processing';
processing.aliases = [];
function processing(Prism) {
    Prism.languages.processing = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
        // Spaces are allowed between function name and parenthesis
        function: /\b\w+(?=\s*\()/,
        operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
    });
    Prism.languages.insertBefore('processing', 'number', {
        // Special case: XML is a type
        constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
        type: {
            pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
            alias: 'class-name'
        }
    });
}

},{}],"cXiUl":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = prolog;
prolog.displayName = 'prolog';
prolog.aliases = [];
function prolog(Prism) {
    Prism.languages.prolog = {
        // Syntax depends on the implementation
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        // Depending on the implementation, strings may allow escaped newlines and quote-escape
        string: {
            pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
            greedy: true
        },
        builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
        // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
        function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
        number: /\b\d+(?:\.\d*)?/,
        // Custom operators are allowed
        operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
        punctuation: /[(){}\[\],]/
    };
}

},{}],"hU0GD":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = promql;
promql.displayName = 'promql';
promql.aliases = [];
function promql(Prism) {
    (function(Prism) {
        // PromQL Aggregation Operators
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#aggregation-operators)
        var aggregations = [
            'sum',
            'min',
            'max',
            'avg',
            'group',
            'stddev',
            'stdvar',
            'count',
            'count_values',
            'bottomk',
            'topk',
            'quantile'
        ] // PromQL vector matching + the by and without clauses
        ;
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#vector-matching)
        var vectorMatching = [
            'on',
            'ignoring',
            'group_right',
            'group_left',
            'by',
            'without'
        ] // PromQL offset modifier
        ;
        // (https://prometheus.io/docs/prometheus/latest/querying/basics/#offset-modifier)
        var offsetModifier = [
            'offset'
        ];
        var keywords = aggregations.concat(vectorMatching, offsetModifier);
        Prism.languages.promql = {
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            'vector-match': {
                // Match the comma-separated label lists inside vector matching:
                pattern: new RegExp('((?:' + vectorMatching.join('|') + ')\\s*)\\([^)]*\\)'),
                lookbehind: true,
                inside: {
                    'label-key': {
                        pattern: /\b[^,]+\b/,
                        alias: 'attr-name'
                    },
                    punctuation: /[(),]/
                }
            },
            'context-labels': {
                pattern: /\{[^{}]*\}/,
                inside: {
                    'label-key': {
                        pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
                        alias: 'attr-name'
                    },
                    'label-value': {
                        pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                        greedy: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\{|\}|=~?|![=~]|,/
                }
            },
            'context-range': [
                {
                    pattern: /\[[\w\s:]+\]/,
                    // [1m]
                    inside: {
                        punctuation: /\[|\]|:/,
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                },
                {
                    pattern: /(\boffset\s+)\w+/,
                    // offset 1m
                    lookbehind: true,
                    inside: {
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                }
            ],
            keyword: new RegExp('\\b(?:' + keywords.join('|') + ')\\b', 'i'),
            function: /\b[a-z_]\w*(?=\s*\()/i,
            number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
            operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
            punctuation: /[{};()`,.[\]]/
        };
    })(Prism);
}

},{}],"9z3k8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = properties;
properties.displayName = 'properties';
properties.aliases = [];
function properties(Prism) {
    Prism.languages.properties = {
        comment: /^[ \t]*[#!].*$/m,
        'attr-value': {
            pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
            lookbehind: true
        },
        'attr-name': /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
        punctuation: /[=:]/
    };
}

},{}],"9Gvpa":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = protobuf;
protobuf.displayName = 'protobuf';
protobuf.aliases = [];
function protobuf(Prism) {
    (function(Prism) {
        var builtinTypes = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
        Prism.languages.protobuf = Prism.languages.extend('clike', {
            'class-name': [
                {
                    pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
                    lookbehind: true
                },
                {
                    pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
                    lookbehind: true
                }
            ],
            keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
            function: /\b[a-z_]\w*(?=\s*\()/i
        });
        Prism.languages.insertBefore('protobuf', 'operator', {
            map: {
                pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /[<>.,]/,
                    builtin: builtinTypes
                }
            },
            builtin: builtinTypes,
            'positional-class-name': {
                pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /\./
                }
            },
            annotation: {
                pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
                lookbehind: true
            }
        });
    })(Prism);
}

},{}],"fTFGc":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = psl;
psl.displayName = 'psl';
psl.aliases = [];
function psl(Prism) {
    Prism.languages.psl = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true,
            inside: {
                symbol: /\\[ntrbA-Z"\\]/
            }
        },
        'heredoc-string': {
            pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
            alias: 'string',
            greedy: true
        },
        keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
        constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
        boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
        variable: /\b(?:PslDebug|errno|exit_status)\b/,
        builtin: {
            pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
            alias: 'builtin-function'
        },
        'foreach-variable': {
            pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
            lookbehind: true,
            greedy: true
        },
        function: /\b[_a-z]\w*\b(?=\s*\()/i,
        number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
        punctuation: /[(){}\[\];,]/
    };
}

},{}],"eT6ik":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = pug;
pug.displayName = 'pug';
pug.aliases = [];
function pug(Prism) {
    (function(Prism) {
        // TODO:
        // - Add CSS highlighting inside <style> tags
        // - Add support for multi-line code blocks
        // - Add support for interpolation #{} and !{}
        // - Add support for tag interpolation #[]
        // - Add explicit support for plain text using |
        // - Add support for markup embedded in plain text
        Prism.languages.pug = {
            // Multiline stuff should appear before the rest
            // This handles both single-line and multi-line comments
            comment: {
                pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
                lookbehind: true
            },
            // All the tag-related part is in lookbehind
            // so that it can be highlighted by the "tag" pattern
            'multiline-script': {
                pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            // See at the end of the file for known filters
            filter: {
                pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: /\S[\s\S]*/
                }
            },
            'multiline-plain-text': {
                pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true
            },
            markup: {
                pattern: /(^[\t ]*)<.+/m,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
                lookbehind: true
            },
            // This handle all conditional and loop keywords
            'flow-control': {
                pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
                lookbehind: true,
                inside: {
                    each: {
                        pattern: /^each .+? in\b/,
                        inside: {
                            keyword: /\b(?:each|in)\b/,
                            punctuation: /,/
                        }
                    },
                    branch: {
                        pattern: /^(?:case|default|else|if|unless|when|while)\b/,
                        alias: 'keyword'
                    },
                    rest: Prism.languages.javascript
                }
            },
            keyword: {
                pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
                lookbehind: true
            },
            mixin: [
                // Declaration
                {
                    pattern: /(^[\t ]*)mixin .+/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^mixin/,
                        function: /\w+(?=\s*\(|\s*$)/,
                        punctuation: /[(),.]/
                    }
                },
                {
                    pattern: /(^[\t ]*)\+.+/m,
                    lookbehind: true,
                    inside: {
                        name: {
                            pattern: /^\+\w+/,
                            alias: 'function'
                        },
                        rest: Prism.languages.javascript
                    }
                }
            ],
            script: {
                pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            'plain-text': {
                pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            pattern: /&[^(]+\([^)]+\)/,
                            inside: Prism.languages.javascript
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                                    lookbehind: true,
                                    inside: Prism.languages.javascript
                                },
                                'attr-name': /[\w-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[!=(),]+/
                            }
                        }
                    ],
                    punctuation: /:/,
                    'attr-id': /#[\w\-]+/,
                    'attr-class': /\.[\w\-]+/
                }
            },
            code: [
                {
                    pattern: /(^[\t ]*(?:-|!?=)).+/m,
                    lookbehind: true,
                    inside: Prism.languages.javascript
                }
            ],
            punctuation: /[.\-!=|]+/
        };
        var filter_pattern = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source // Non exhaustive list of available filters and associated languages
        ;
        var filters = [
            {
                filter: 'atpl',
                language: 'twig'
            },
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'ejs',
            'handlebars',
            'less',
            'livescript',
            'markdown',
            {
                filter: 'sass',
                language: 'scss'
            },
            'stylus'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('<filter_name>', function() {
                    return filter.filter;
                }), 'm'),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: {
                        pattern: /\S[\s\S]*/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('pug', 'filter', all_filters);
    })(Prism);
}

},{}],"9n7LA":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = puppet;
puppet.displayName = 'puppet';
puppet.aliases = [];
function puppet(Prism) {
    (function(Prism) {
        Prism.languages.puppet = {
            heredoc: [
                // Matches the content of a quoted heredoc string (subject to interpolation)
                {
                    pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/ // See interpolation below
                    }
                },
                {
                    pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/
                    }
                },
                {
                    pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
                    alias: 'string',
                    inside: {
                        punctuation: {
                            pattern: /(\().+?(?=\))/,
                            lookbehind: true
                        }
                    }
                }
            ],
            'multiline-comment': {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true,
                greedy: true,
                alias: 'comment'
            },
            regex: {
                // Must be prefixed with the keyword "node" or a non-word char
                pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    // Extended regexes must have the x flag. They can contain single-line comments.
                    'extended-regex': {
                        pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
                        inside: {
                            comment: /#.*/
                        }
                    }
                }
            },
            comment: {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true,
                greedy: true
            },
            string: {
                // Allow for one nested level of double quotes inside interpolation
                pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
                greedy: true,
                inside: {
                    'double-quoted': {
                        pattern: /^"[\s\S]*"$/,
                        inside: {
                        }
                    }
                }
            },
            variable: {
                pattern: /\$(?:::)?\w+(?:::\w+)*/,
                inside: {
                    punctuation: /::/
                }
            },
            'attr-name': /(?:\b\w+|\*)(?=\s*=>)/,
            function: [
                {
                    pattern: /(\.)(?!\d)\w+/,
                    lookbehind: true
                },
                /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
            ],
            number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
            boolean: /\b(?:false|true)\b/,
            // Includes words reserved for future use
            keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
            datatype: {
                pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
                alias: 'symbol'
            },
            operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
            punctuation: /[\[\]{}().,;]|:+/
        };
        var interpolation = [
            {
                // Allow for one nested level of braces inside interpolation
                pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
                lookbehind: true,
                inside: {
                    'short-variable': {
                        // Negative look-ahead prevent wrong highlighting of functions
                        pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
                        lookbehind: true,
                        alias: 'variable',
                        inside: {
                            punctuation: /::/
                        }
                    },
                    delimiter: {
                        pattern: /^\$/,
                        alias: 'variable'
                    },
                    rest: Prism.languages.puppet
                }
            },
            {
                pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
                lookbehind: true,
                alias: 'variable',
                inside: {
                    punctuation: /::/
                }
            }
        ];
        Prism.languages.puppet['heredoc'][0].inside.interpolation = interpolation;
        Prism.languages.puppet['string'].inside['double-quoted'].inside.interpolation = interpolation;
    })(Prism);
}

},{}],"gtGOi":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = pure;
pure.displayName = 'pure';
pure.aliases = [];
function pure(Prism) {
    (function(Prism) {
        // https://agraef.github.io/pure-docs/pure.html#lexical-matters
        Prism.languages.pure = {
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true
                },
                /#!.+/
            ],
            'inline-lang': {
                pattern: /%<[\s\S]+?%>/,
                greedy: true,
                inside: {
                    lang: {
                        pattern: /(^%< *)-\*-.+?-\*-/,
                        lookbehind: true,
                        alias: 'comment'
                    },
                    delimiter: {
                        pattern: /^%<.*|%>$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"/,
                greedy: true
            },
            number: {
                // The look-behind prevents wrong highlighting of the .. operator
                pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
                lookbehind: true
            },
            keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
            function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
            special: {
                pattern: /\b__[a-z]+__\b/i,
                alias: 'builtin'
            },
            // Any combination of operator chars can be an operator
            // eslint-disable-next-line no-misleading-character-class
            operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
            // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
            punctuation: /[(){}\[\];,|]/
        };
        var inlineLanguages = [
            'c',
            {
                lang: 'c++',
                alias: 'cpp'
            },
            'fortran'
        ];
        var inlineLanguageRe = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
        inlineLanguages.forEach(function(lang) {
            var alias = lang;
            if (typeof lang !== 'string') {
                alias = lang.alias;
                lang = lang.lang;
            }
            if (Prism.languages[alias]) {
                var o = {};
                o['inline-lang-' + alias] = {
                    pattern: RegExp(inlineLanguageRe.replace('<lang>', lang.replace(/([.+*?\/\\(){}\[\]])/g, '\\$1')), 'i'),
                    inside: Prism.util.clone(Prism.languages.pure['inline-lang'].inside)
                };
                o['inline-lang-' + alias].inside.rest = Prism.util.clone(Prism.languages[alias]);
                Prism.languages.insertBefore('pure', 'inline-lang', o);
            }
        }) // C is the default inline language
        ;
        if (Prism.languages.c) Prism.languages.pure['inline-lang'].inside.rest = Prism.util.clone(Prism.languages.c);
    })(Prism);
}

},{}],"kQ7W4":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = purebasic;
purebasic.displayName = 'purebasic';
purebasic.aliases = [];
function purebasic(Prism) {
    /*
Original Code by Bas Groothedde
!!MANY THANKS!! I never would have made this, regex and me will never be best friends ;)
==> https://codepen.io/ImagineProgramming/details/JYydBy/
slightly changed to pass all tests
*/ // PureBasic support, steal stuff from ansi-c
    Prism.languages.purebasic = Prism.languages.extend('clike', {
        comment: /;.*/,
        keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
        function: /\b\w+(?:\.\w+)?\s*(?=\()/,
        number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
        operator: /(?:@\*?|\?|\*)\w+|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
    });
    Prism.languages.insertBefore('purebasic', 'keyword', {
        tag: /#\w+\$?/,
        asm: {
            pattern: /(^[\t ]*)!.*/m,
            lookbehind: true,
            alias: 'tag',
            inside: {
                comment: /;.*/,
                string: {
                    pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
                    greedy: true
                },
                // Anonymous label references, i.e.: jmp @b
                'label-reference-anonymous': {
                    pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                // Named label reference, i.e.: jne label1
                'label-reference-addressed': {
                    pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                keyword: [
                    /\b(?:extern|global)\b[^;\r\n]*/i,
                    /\b(?:CPU|DEFAULT|FLOAT)\b.*/
                ],
                function: {
                    pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
                    lookbehind: true
                },
                'function-inline': {
                    pattern: /(:\s*)[\da-z]+(?=\s)/i,
                    lookbehind: true,
                    alias: 'function'
                },
                label: {
                    pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
                number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
                operator: /[\[\]*+\-/%<>=&|$!,.:]/
            }
        }
    });
    delete Prism.languages.purebasic['class-name'];
    delete Prism.languages.purebasic['boolean'];
    Prism.languages.pbfasm = Prism.languages['purebasic'];
}

},{}],"2o27K":[function(require,module,exports,__globalThis) {
'use strict';
var refractorHaskell = require("61372bd8f6d25b0a");
module.exports = purescript;
purescript.displayName = 'purescript';
purescript.aliases = [
    'purs'
];
function purescript(Prism) {
    Prism.register(refractorHaskell);
    Prism.languages.purescript = Prism.languages.extend('haskell', {
        keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import)\b/,
                punctuation: /\./
            }
        },
        // These are builtin functions only. Constructors are highlighted later as a constant.
        builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
        operator: [
            // Infix operators
            Prism.languages.haskell.operator[0],
            Prism.languages.haskell.operator[2],
            // This regex is equivalent to /(?=[\x80-\uFFFF])[\p{gc=Math_Symbol}\p{gc=Currency_Symbol}\p{Modifier_Symbol}\p{Other_Symbol}]/u
            // See https://github.com/PrismJS/prism/issues/3006 for more details.
            /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/
        ]
    });
    Prism.languages.purs = Prism.languages.purescript;
}

},{"61372bd8f6d25b0a":"kvyjG"}],"96Qpb":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = python;
python.displayName = 'python';
python.aliases = [
    'py'
];
function python(Prism) {
    Prism.languages.python = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true,
            greedy: true
        },
        'string-interpolation': {
            pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
            greedy: true,
            inside: {
                interpolation: {
                    // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                    pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                    lookbehind: true,
                    inside: {
                        'format-spec': {
                            pattern: /(:)[^:(){}]+(?=\}$)/,
                            lookbehind: true
                        },
                        'conversion-option': {
                            pattern: /![sra](?=[:}]$)/,
                            alias: 'punctuation'
                        },
                        rest: null
                    }
                },
                string: /[\s\S]+/
            }
        },
        'triple-quoted-string': {
            pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
            greedy: true
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
            lookbehind: true
        },
        'class-name': {
            pattern: /(\bclass\s+)\w+/i,
            lookbehind: true
        },
        decorator: {
            pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
            lookbehind: true,
            alias: [
                'annotation',
                'punctuation'
            ],
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
        builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
        boolean: /\b(?:False|None|True)\b/,
        number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
        operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;
    Prism.languages.py = Prism.languages.python;
}

},{}],"j41f2":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = q;
q.displayName = 'q';
q.aliases = [];
function q(Prism) {
    Prism.languages.q = {
        string: /"(?:\\.|[^"\\\r\n])*"/,
        comment: [
            // From http://code.kx.com/wiki/Reference/Slash:
            // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
            {
                pattern: /([\t )\]}])\/.*/,
                lookbehind: true,
                greedy: true
            },
            // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
            // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
            // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
            // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
            {
                pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
                lookbehind: true,
                greedy: true
            },
            // A \ on a line by itself with no preceding matching / will comment to end of file.
            {
                pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
                greedy: true
            },
            {
                pattern: /^#!.+/m,
                greedy: true
            }
        ],
        symbol: /`(?::\S+|[\w.]*)/,
        datetime: {
            pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
            alias: 'number'
        },
        // The negative look-ahead prevents bad highlighting
        // of verbs 0: and 1:
        number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
        keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
        adverb: {
            pattern: /['\/\\]:?|\beach\b/,
            alias: 'function'
        },
        verb: {
            pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
            alias: 'operator'
        },
        punctuation: /[(){}\[\];.]/
    };
}

},{}],"gzXny":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = qml;
qml.displayName = 'qml';
qml.aliases = [];
function qml(Prism) {
    (function(Prism) {
        var jsString = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source;
        var jsComment = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source;
        var jsExpr = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function() {
            return jsString;
        }).replace(/<comment>/g, function() {
            return jsComment;
        }) // the pattern will blow up, so only a few iterations
        ;
        for(var i = 0; i < 2; i++)jsExpr = jsExpr.replace(/<expr>/g, function() {
            return jsExpr;
        });
        jsExpr = jsExpr.replace(/<expr>/g, '[^\\s\\S]');
        Prism.languages.qml = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            'javascript-function': {
                pattern: RegExp(/((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            'class-name': {
                pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
                lookbehind: true
            },
            property: [
                {
                    pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^property/,
                        property: /\w+(?:\.\w+)*/
                    }
                }
            ],
            'javascript-expression': {
                pattern: RegExp(/(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            string: {
                pattern: /"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            keyword: /\b(?:as|import|on)\b/,
            punctuation: /[{}[\]:;,]/
        };
    })(Prism);
}

},{}],"i1WTF":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = qore;
qore.displayName = 'qore';
qore.aliases = [];
function qore(Prism) {
    Prism.languages.qore = Prism.languages.extend('clike', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
            lookbehind: true
        },
        // Overridden to allow unescaped multi-line strings
        string: {
            pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
            greedy: true
        },
        keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
        boolean: /\b(?:false|true)\b/i,
        function: /\$?\b(?!\d)\w+(?=\()/,
        number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
        operator: {
            pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
            lookbehind: true
        },
        variable: /\$(?!\d)\w+\b/
    });
}

},{}],"59uoz":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = qsharp;
qsharp.displayName = 'qsharp';
qsharp.aliases = [
    'qs'
];
function qsharp(Prism) {
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        } // https://docs.microsoft.com/en-us/azure/quantum/user-guide/language/typesystem/
        // https://github.com/microsoft/qsharp-language/tree/main/Specifications/Language/5_Grammar
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero',
            // all other keywords
            other: 'Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within'
        } // keywords
        ;
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.other)) // types
        ;
        var identifier = /\b[A-Za-z_]\w*\b/.source;
        var qualifiedName = replace(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [
            identifier
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        } // strings
        ;
        var regularString = /"(?:\\.|[^\\"])*"/.source;
        Prism.languages.qsharp = Prism.languages.extend('clike', {
            comment: /\/\/.*/,
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // open Microsoft.Quantum.Canon;
                    // open Microsoft.Quantum.Canon as CN;
                    pattern: re(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // namespace Quantum.App1;
                    pattern: re(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                }
            ],
            keyword: keywords,
            number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
            operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
            punctuation: /::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('qsharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        }) // single line
        ;
        var interpolationExpr = nested(replace(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [
            regularString
        ]), 2);
        Prism.languages.insertBefore('qsharp', 'string', {
            'interpolation-string': {
                pattern: re(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [
                    interpolationExpr
                ]),
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: re(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [
                            interpolationExpr
                        ]),
                        lookbehind: true,
                        inside: {
                            punctuation: /^\{|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                alias: 'language-qsharp',
                                inside: Prism.languages.qsharp
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            }
        });
    })(Prism);
    Prism.languages.qs = Prism.languages.qsharp;
}

},{}],"cvtkO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = r;
r.displayName = 'r';
r.aliases = [];
function r(Prism) {
    Prism.languages.r = {
        comment: /#.*/,
        string: {
            pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'percent-operator': {
            // Includes user-defined operators
            // and %%, %*%, %/%, %in%, %o%, %x%
            pattern: /%[^%\s]*%/,
            alias: 'operator'
        },
        boolean: /\b(?:FALSE|TRUE)\b/,
        ellipsis: /\.\.(?:\.|\d+)/,
        number: [
            /\b(?:Inf|NaN)\b/,
            /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
        ],
        keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
        operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
        punctuation: /[(){}\[\],;]/
    };
}

},{}],"5Zble":[function(require,module,exports,__globalThis) {
'use strict';
var refractorScheme = require("19be83bc27d9d122");
module.exports = racket;
racket.displayName = 'racket';
racket.aliases = [
    'rkt'
];
function racket(Prism) {
    Prism.register(refractorScheme);
    Prism.languages.racket = Prism.languages.extend('scheme', {
        'lambda-parameter': {
            // the racket lambda syntax is a lot more complex, so we won't even attempt to capture it.
            // this will just prevent false positives of the `function` pattern
            pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
            lookbehind: true
        }
    });
    Prism.languages.insertBefore('racket', 'string', {
        lang: {
            pattern: /^#lang.+/m,
            greedy: true,
            alias: 'keyword'
        }
    });
    Prism.languages.rkt = Prism.languages.racket;
}

},{"19be83bc27d9d122":"6Tsyk"}],"901XI":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = reason;
reason.displayName = 'reason';
reason.aliases = [];
function reason(Prism) {
    Prism.languages.reason = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
            greedy: true
        },
        // 'class-name' must be matched *after* 'constructor' defined below
        'class-name': /\b[A-Z]\w*/,
        keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
        operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
    });
    Prism.languages.insertBefore('reason', 'class-name', {
        char: {
            pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
            greedy: true
        },
        // Negative look-ahead prevents from matching things like String.capitalize
        constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
        label: {
            pattern: /\b[a-z]\w*(?=::)/,
            alias: 'symbol'
        }
    }) // We can't match functions property, so let's not even try.
    ;
    delete Prism.languages.reason.function;
}

},{}],"1NvuG":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = regex;
regex.displayName = 'regex';
regex.aliases = [];
function regex(Prism) {
    (function(Prism) {
        var specialEscape = {
            pattern: /\\[\\(){}[\]^$+*?|.]/,
            alias: 'escape'
        };
        var escape = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/;
        var charSet = {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var charSetWithoutDot = {
            pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var rangeChar = '(?:[^\\\\-]|' + escape.source + ')';
        var range = RegExp(rangeChar + '-' + rangeChar) // the name of a capturing group
        ;
        var groupName = {
            pattern: /(<|')[^<>']+(?=[>']$)/,
            lookbehind: true,
            alias: 'variable'
        };
        Prism.languages.regex = {
            'char-class': {
                pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
                lookbehind: true,
                inside: {
                    'char-class-negation': {
                        pattern: /(^\[)\^/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    'char-class-punctuation': {
                        pattern: /^\[|\]$/,
                        alias: 'punctuation'
                    },
                    range: {
                        pattern: range,
                        inside: {
                            escape: escape,
                            'range-punctuation': {
                                pattern: /-/,
                                alias: 'operator'
                            }
                        }
                    },
                    'special-escape': specialEscape,
                    'char-set': charSetWithoutDot,
                    escape: escape
                }
            },
            'special-escape': specialEscape,
            'char-set': charSet,
            backreference: [
                {
                    // a backreference which is not an octal escape
                    pattern: /\\(?![123][0-7]{2})[1-9]/,
                    alias: 'keyword'
                },
                {
                    pattern: /\\k<[^<>']+>/,
                    alias: 'keyword',
                    inside: {
                        'group-name': groupName
                    }
                }
            ],
            anchor: {
                pattern: /[$^]|\\[ABbGZz]/,
                alias: 'function'
            },
            escape: escape,
            group: [
                {
                    // https://docs.oracle.com/javase/10/docs/api/java/util/regex/Pattern.html
                    // https://docs.microsoft.com/en-us/dotnet/standard/base-types/regular-expression-language-quick-reference?view=netframework-4.7.2#grouping-constructs
                    // (), (?<name>), (?'name'), (?>), (?:), (?=), (?!), (?<=), (?<!), (?is-m), (?i-m:)
                    pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                    alias: 'punctuation',
                    inside: {
                        'group-name': groupName
                    }
                },
                {
                    pattern: /\)/,
                    alias: 'punctuation'
                }
            ],
            quantifier: {
                pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
                alias: 'number'
            },
            alternation: {
                pattern: /\|/,
                alias: 'keyword'
            }
        };
    })(Prism);
}

},{}],"ei8DV":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = rego;
rego.displayName = 'rego';
rego.aliases = [];
function rego(Prism) {
    // https://www.openpolicyagent.org/docs/latest/policy-reference/
    Prism.languages.rego = {
        comment: /#.*/,
        property: {
            pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
        boolean: /\b(?:false|true)\b/,
        function: {
            pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
            inside: {
                namespace: /\b\w+\b(?=\s*\.)/,
                punctuation: /\./
            }
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
        punctuation: /[,;.\[\]{}()]/
    };
}

},{}],"9NnYo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = renpy;
renpy.displayName = 'renpy';
renpy.aliases = [
    'rpy'
];
function renpy(Prism) {
    Prism.languages.renpy = {
        comment: {
            pattern: /(^|[^\\])#.+/,
            lookbehind: true
        },
        string: {
            pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
            greedy: true
        },
        function: /\b[a-z_]\w*(?=\()/i,
        property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
        tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
        keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
        boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
        number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
        operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.rpy = Prism.languages.renpy;
}

},{}],"b6T5S":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = rest;
rest.displayName = 'rest';
rest.aliases = [];
function rest(Prism) {
    Prism.languages.rest = {
        table: [
            {
                pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
                lookbehind: true,
                inside: {
                    punctuation: /\||(?:\+[=-]+)+\+/
                }
            },
            {
                pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
                lookbehind: true,
                inside: {
                    punctuation: /[=-]+/
                }
            }
        ],
        // Directive-like patterns
        'substitution-def': {
            pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
            lookbehind: true,
            inside: {
                substitution: {
                    pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
                    alias: 'attr-value',
                    inside: {
                        punctuation: /^\||\|$/
                    }
                },
                directive: {
                    pattern: /( )(?! )[^:]+::/,
                    lookbehind: true,
                    alias: 'function',
                    inside: {
                        punctuation: /::$/
                    }
                }
            }
        },
        'link-target': [
            {
                pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]$/
                }
            },
            {
                pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^_|:$/
                }
            }
        ],
        directive: {
            pattern: /(^[\t ]*\.\. )[^:]+::/m,
            lookbehind: true,
            alias: 'function',
            inside: {
                punctuation: /::$/
            }
        },
        comment: {
            // The two alternatives try to prevent highlighting of blank comments
            pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
            lookbehind: true
        },
        title: [
            // Overlined and underlined
            {
                pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
                inside: {
                    punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            },
            {
                pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
                lookbehind: true,
                inside: {
                    punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            }
        ],
        hr: {
            pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
            lookbehind: true,
            alias: 'punctuation'
        },
        field: {
            pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        'command-line-option': {
            pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
            lookbehind: true,
            alias: 'symbol'
        },
        'literal-block': {
            pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^::/,
                    alias: 'punctuation'
                }
            }
        },
        'quoted-literal-block': {
            pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
                    alias: 'punctuation'
                }
            }
        },
        'list-bullet': {
            pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
            lookbehind: true,
            alias: 'punctuation'
        },
        'doctest-block': {
            pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /^>>>/
            }
        },
        inline: [
            {
                pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
                lookbehind: true,
                inside: {
                    bold: {
                        pattern: /(^\*\*).+(?=\*\*$)/,
                        lookbehind: true
                    },
                    italic: {
                        pattern: /(^\*).+(?=\*$)/,
                        lookbehind: true
                    },
                    'inline-literal': {
                        pattern: /(^``).+(?=``$)/,
                        lookbehind: true,
                        alias: 'symbol'
                    },
                    role: {
                        pattern: /^:[^:]+:|:[^:]+:$/,
                        alias: 'function',
                        inside: {
                            punctuation: /^:|:$/
                        }
                    },
                    'interpreted-text': {
                        pattern: /(^`).+(?=`$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    substitution: {
                        pattern: /(^\|).+(?=\|$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\*\*?|``?|\|/
                }
            }
        ],
        link: [
            {
                pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]_$/
                }
            },
            {
                pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
                alias: 'string',
                inside: {
                    punctuation: /^_?`|`$|`?_?_$/
                }
            }
        ],
        // Line block start,
        // quote attribution,
        // explicit markup start,
        // and anonymous hyperlink target shortcut (__)
        punctuation: {
            pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
            lookbehind: true
        }
    };
}

},{}],"oMsx6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = rip;
rip.displayName = 'rip';
rip.aliases = [];
function rip(Prism) {
    Prism.languages.rip = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        char: {
            pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        regex: {
            pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
        builtin: /@|\bSystem\b/,
        boolean: /\b(?:false|true)\b/,
        date: /\b\d{4}-\d{2}-\d{2}\b/,
        time: /\b\d{2}:\d{2}:\d{2}\b/,
        datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
        symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
        number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
        punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
        reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
    };
}

},{}],"9kBz9":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = roboconf;
roboconf.displayName = 'roboconf';
roboconf.aliases = [];
function roboconf(Prism) {
    Prism.languages.roboconf = {
        comment: /#.*/,
        keyword: {
            pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
            lookbehind: true
        },
        component: {
            pattern: /[\w-]+(?=[ \t]*\{)/,
            alias: 'variable'
        },
        property: /[\w.-]+(?=[ \t]*:)/,
        value: {
            pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
            lookbehind: true,
            alias: 'attr-value'
        },
        optional: {
            pattern: /\(optional\)/,
            alias: 'builtin'
        },
        wildcard: {
            pattern: /(\.)\*/,
            lookbehind: true,
            alias: 'operator'
        },
        punctuation: /[{},.;:=]/
    };
}

},{}],"82nVp":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = robotframework;
robotframework.displayName = 'robotframework';
robotframework.aliases = [];
function robotframework(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /(^[ \t]*| {2}|\t)#.*/m,
            lookbehind: true,
            greedy: true
        };
        var variable = {
            pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
            lookbehind: true,
            inside: {
                punctuation: /^[$@&%]\{|\}$/
            }
        };
        function createSection(name, inside) {
            var extendecInside = {};
            extendecInside['section-header'] = {
                pattern: /^ ?\*{3}.+?\*{3}/,
                alias: 'keyword'
            } // copy inside tokens
            ;
            for(var token in inside)extendecInside[token] = inside[token];
            extendecInside['tag'] = {
                pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
                lookbehind: true,
                inside: {
                    punctuation: /\[|\]/
                }
            };
            extendecInside['variable'] = variable;
            extendecInside['comment'] = comment;
            return {
                pattern: RegExp(/^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(/<name>/g, function() {
                    return name;
                }), 'im'),
                alias: 'section',
                inside: extendecInside
            };
        }
        var docTag = {
            pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
            lookbehind: true,
            alias: 'string'
        };
        var testNameLike = {
            pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            alias: 'function',
            inside: {
                variable: variable
            }
        };
        var testPropertyLike = {
            pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            inside: {
                variable: variable
            }
        };
        Prism.languages['robotframework'] = {
            settings: createSection('Settings', {
                documentation: {
                    pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
                    lookbehind: true,
                    alias: 'string'
                },
                property: {
                    pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
                    lookbehind: true
                }
            }),
            variables: createSection('Variables'),
            'test-cases': createSection('Test Cases', {
                'test-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            keywords: createSection('Keywords', {
                'keyword-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            tasks: createSection('Tasks', {
                'task-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            comment: comment
        };
        Prism.languages.robot = Prism.languages['robotframework'];
    })(Prism);
}

},{}],"03Tu7":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = rust;
rust.displayName = 'rust';
rust.aliases = [];
function rust(Prism) {
    (function(Prism) {
        var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
        for(var i = 0; i < 2; i++)// support 4 levels of nested comments
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return multilineComment;
        });
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return /[^\s\S]/.source;
        });
        Prism.languages.rust = {
            comment: [
                {
                    pattern: RegExp(/(^|[^\\])/.source + multilineComment),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            string: {
                pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
                greedy: true
            },
            char: {
                pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
                greedy: true
            },
            attribute: {
                pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
                greedy: true,
                alias: 'attr-name',
                inside: {
                    string: null // see below
                }
            },
            // Closure params should not be confused with bitwise OR |
            'closure-params': {
                pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
                lookbehind: true,
                greedy: true,
                inside: {
                    'closure-punctuation': {
                        pattern: /^\||\|$/,
                        alias: 'punctuation'
                    },
                    rest: null // see below
                }
            },
            'lifetime-annotation': {
                pattern: /'\w+/,
                alias: 'symbol'
            },
            'fragment-specifier': {
                pattern: /(\$\w+:)[a-z]+/,
                lookbehind: true,
                alias: 'punctuation'
            },
            variable: /\$\w+/,
            'function-definition': {
                pattern: /(\bfn\s+)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            'type-definition': {
                pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
                lookbehind: true,
                alias: 'class-name'
            },
            'module-declaration': [
                {
                    pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                    lookbehind: true,
                    alias: 'namespace'
                },
                {
                    pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /::/
                    }
                }
            ],
            keyword: [
                // https://github.com/rust-lang/reference/blob/master/src/keywords.md
                /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
                // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
                /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
            ],
            // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
            // and Rust's naming conventions recommend snake_case anyway.
            // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
            macro: {
                pattern: /\b\w+!/,
                alias: 'property'
            },
            constant: /\b[A-Z_][A-Z_\d]+\b/,
            'class-name': /\b[A-Z]\w*\b/,
            namespace: {
                pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
                inside: {
                    punctuation: /::/
                }
            },
            // Hex, oct, bin, dec numbers with visual separators and type suffix
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
            operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
        };
        Prism.languages.rust['closure-params'].inside.rest = Prism.languages.rust;
        Prism.languages.rust['attribute'].inside['string'] = Prism.languages.rust['string'];
    })(Prism);
}

},{}],"4XVN6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = sas;
sas.displayName = 'sas';
sas.aliases = [];
function sas(Prism) {
    (function(Prism) {
        var stringPattern = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source;
        var number = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i;
        var numericConstant = {
            pattern: RegExp(stringPattern + '[bx]'),
            alias: 'number'
        };
        var macroVariable = {
            pattern: /&[a-z_]\w*/i
        };
        var macroKeyword = {
            pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var step = {
            pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
            alias: 'keyword',
            lookbehind: true
        };
        var comment = [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
                lookbehind: true
            }
        ];
        var string = {
            pattern: RegExp(stringPattern),
            greedy: true
        };
        var punctuation = /[$%@.(){}\[\];,\\]/;
        var func = {
            pattern: /%?\b\w+(?=\()/,
            alias: 'keyword'
        };
        var args = {
            function: func,
            'arg-value': {
                pattern: /(=\s*)[A-Z\.]+/i,
                lookbehind: true
            },
            operator: /=/,
            'macro-variable': macroVariable,
            arg: {
                pattern: /[A-Z]+/i,
                alias: 'keyword'
            },
            number: number,
            'numeric-constant': numericConstant,
            punctuation: punctuation,
            string: string
        };
        var format = {
            pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
            inside: {
                keyword: /^(?:format|put)(?==)/i,
                equals: /=/,
                format: {
                    pattern: /(?:\w|\$\d)+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var altformat = {
            pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
            inside: {
                keyword: /^(?:format|put)/i,
                format: {
                    pattern: /[\w$]+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var globalStatements = {
            pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var submitStatement = {
            pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var actionSets = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source;
        var casActions = {
            pattern: RegExp(/(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(/<act>/g, function() {
                return actionSets;
            }), 'i'),
            lookbehind: true,
            inside: {
                keyword: RegExp(/(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function() {
                    return actionSets;
                }), 'i'),
                action: {
                    pattern: /(?:action)/i,
                    alias: 'keyword'
                },
                comment: comment,
                function: func,
                'arg-value': args['arg-value'],
                operator: args.operator,
                argument: args.arg,
                number: number,
                'numeric-constant': numericConstant,
                punctuation: punctuation,
                string: string
            }
        };
        var keywords = {
            pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
            lookbehind: true
        };
        Prism.languages.sas = {
            datalines: {
                pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
                lookbehind: true,
                alias: 'string',
                inside: {
                    keyword: {
                        pattern: /^(?:cards|(?:data)?lines)/i
                    },
                    punctuation: /;/
                }
            },
            'proc-sql': {
                pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    sql: {
                        pattern: RegExp(/^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        alias: 'language-sql',
                        inside: Prism.languages.sql
                    },
                    'global-statements': globalStatements,
                    'sql-statements': {
                        pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-groovy': {
                pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    groovy: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-groovy',
                        inside: Prism.languages.groovy
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-lua': {
                pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    lua: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-lua',
                        inside: Prism.languages.lua
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-cas': {
                pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    'statement-var': {
                        pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
                        lookbehind: true,
                        inside: {
                            statement: {
                                pattern: /^saveresult\s+\S+/i,
                                inside: {
                                    keyword: /^(?:saveresult)/i
                                }
                            },
                            rest: args
                        }
                    },
                    'cas-actions': casActions,
                    statement: {
                        pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
                        lookbehind: true,
                        inside: args
                    },
                    step: step,
                    keyword: keywords,
                    function: func,
                    format: format,
                    altformat: altformat,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-args': {
                pattern: RegExp(/(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(/<str>/g, function() {
                    return stringPattern;
                }), 'im'),
                lookbehind: true,
                inside: args
            },
            /*Special keywords within macros*/ 'macro-keyword': macroKeyword,
            'macro-variable': macroVariable,
            'macro-string-functions': {
                pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
                        alias: 'keyword'
                    },
                    'macro-keyword': macroKeyword,
                    'macro-variable': macroVariable,
                    'escaped-char': {
                        pattern: /%['"()<>=¬^~;,#]/
                    },
                    punctuation: punctuation
                }
            },
            'macro-declaration': {
                pattern: /^%macro[^;]+(?=;)/im,
                inside: {
                    keyword: /%macro/i
                }
            },
            'macro-end': {
                pattern: /^%mend[^;]+(?=;)/im,
                inside: {
                    keyword: /%mend/i
                }
            },
            /*%_zscore(headcir, _lhc, _mhc, _shc, headcz, headcpct, _Fheadcz); */ macro: {
                pattern: /%_\w+(?=\()/,
                alias: 'keyword'
            },
            input: {
                pattern: /\binput\s[-\w\s/*.$&]+;/i,
                inside: {
                    input: {
                        alias: 'keyword',
                        pattern: /^input/i
                    },
                    comment: comment,
                    number: number,
                    'numeric-constant': numericConstant
                }
            },
            'options-args': {
                pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
                lookbehind: true,
                inside: args
            },
            'cas-actions': casActions,
            comment: comment,
            function: func,
            format: format,
            altformat: altformat,
            'numeric-constant': numericConstant,
            datetime: {
                // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
                pattern: RegExp(stringPattern + '(?:dt?|t)'),
                alias: 'number'
            },
            string: string,
            step: step,
            keyword: keywords,
            // In SAS Studio syntax highlighting, these operators are styled like keywords
            'operator-keyword': {
                pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
                alias: 'operator'
            },
            // Decimal (1.2e23), hexadecimal (0c1x)
            number: number,
            operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
            punctuation: punctuation
        };
    })(Prism);
}

},{}],"5zOXW":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = sass;
sass.displayName = 'sass';
sass.aliases = [];
function sass(Prism) {
    (function(Prism) {
        Prism.languages.sass = Prism.languages.extend('css', {
            // Sass comments don't need to be closed, only indented
            comment: {
                pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
                lookbehind: true,
                greedy: true
            }
        });
        Prism.languages.insertBefore('sass', 'atrule', {
            // We want to consume the whole line
            'atrule-line': {
                // Includes support for = and + shortcuts
                pattern: /^(?:[ \t]*)[@+=].+/m,
                greedy: true,
                inside: {
                    atrule: /(?:@[\w-]+|[+=])/
                }
            }
        });
        delete Prism.languages.sass.atrule;
        var variable = /\$[-\w]+|#\{\$[-\w]+\}/;
        var operator = [
            /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
            {
                pattern: /(\s)-(?=\s)/,
                lookbehind: true
            }
        ];
        Prism.languages.insertBefore('sass', 'property', {
            // We want to consume the whole line
            'variable-line': {
                pattern: /^[ \t]*\$.+/m,
                greedy: true,
                inside: {
                    punctuation: /:/,
                    variable: variable,
                    operator: operator
                }
            },
            // We want to consume the whole line
            'property-line': {
                pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
                greedy: true,
                inside: {
                    property: [
                        /[^:\s]+(?=\s*:)/,
                        {
                            pattern: /(:)[^:\s]+/,
                            lookbehind: true
                        }
                    ],
                    punctuation: /:/,
                    variable: variable,
                    operator: operator,
                    important: Prism.languages.sass.important
                }
            }
        });
        delete Prism.languages.sass.property;
        delete Prism.languages.sass.important // Now that whole lines for other patterns are consumed,
        ;
        // what's left should be selectors
        Prism.languages.insertBefore('sass', 'punctuation', {
            selector: {
                pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
                lookbehind: true,
                greedy: true
            }
        });
    })(Prism);
}

},{}],"aJN06":[function(require,module,exports,__globalThis) {
'use strict';
var refractorJava = require("ab3a4d3eba3c937f");
module.exports = scala;
scala.displayName = 'scala';
scala.aliases = [];
function scala(Prism) {
    Prism.register(refractorJava);
    Prism.languages.scala = Prism.languages.extend('java', {
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /<-|=>|\b(?:abstract|case|catch|class|def|do|else|extends|final|finally|for|forSome|if|implicit|import|lazy|match|new|null|object|override|package|private|protected|return|sealed|self|super|this|throw|trait|try|type|val|var|while|with|yield)\b/,
        number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
        builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
        symbol: /'[^\d\s\\]\w*/
    });
    Prism.languages.insertBefore('scala', 'triple-quoted-string', {
        'string-interpolation': {
            pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
            greedy: true,
            inside: {
                id: {
                    pattern: /^\w+/,
                    greedy: true,
                    alias: 'function'
                },
                escape: {
                    pattern: /\\\$"|\$[$"]/,
                    greedy: true,
                    alias: 'symbol'
                },
                interpolation: {
                    pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                    greedy: true,
                    inside: {
                        punctuation: /^\$\{?|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.scala
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    delete Prism.languages.scala['class-name'];
    delete Prism.languages.scala['function'];
}

},{"ab3a4d3eba3c937f":"5biU1"}],"iQcWX":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = scss;
scss.displayName = 'scss';
scss.aliases = [];
function scss(Prism) {
    Prism.languages.scss = Prism.languages.extend('css', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true
        },
        atrule: {
            pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
            inside: {
                rule: /@[\w-]+/ // See rest below
            }
        },
        // url, compassified
        url: /(?:[-a-z]+-)?url(?=\()/i,
        // CSS selector regex is not appropriate for Sass
        // since there can be lot more things (var, @ directive, nesting..)
        // a selector must start at the end of a property or after a brace (end of other rules or nesting)
        // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
        // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
        // can "pass" as a selector- e.g: proper#{$erty})
        // this one was hard to do, so please be careful if you edit this one :)
        selector: {
            // Initial look-ahead is used to prevent matching of blank selectors
            pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
            inside: {
                parent: {
                    pattern: /&/,
                    alias: 'important'
                },
                placeholder: /%[-\w]+/,
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        },
        property: {
            pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
            inside: {
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        }
    });
    Prism.languages.insertBefore('scss', 'atrule', {
        keyword: [
            /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
            {
                pattern: /( )(?:from|through)(?= )/,
                lookbehind: true
            }
        ]
    });
    Prism.languages.insertBefore('scss', 'important', {
        // var and interpolated vars
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
    });
    Prism.languages.insertBefore('scss', 'function', {
        'module-modifier': {
            pattern: /\b(?:as|hide|show|with)\b/i,
            alias: 'keyword'
        },
        placeholder: {
            pattern: /%[-\w]+/,
            alias: 'selector'
        },
        statement: {
            pattern: /\B!(?:default|optional)\b/i,
            alias: 'keyword'
        },
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        operator: {
            pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
            lookbehind: true
        }
    });
    Prism.languages.scss['atrule'].inside.rest = Prism.languages.scss;
}

},{}],"iBhXF":[function(require,module,exports,__globalThis) {
'use strict';
var refractorBash = require("444c54b10c381536");
module.exports = shellSession;
shellSession.displayName = 'shellSession';
shellSession.aliases = [];
function shellSession(Prism) {
    Prism.register(refractorBash);
    (function(Prism) {
        // CAREFUL!
        // The following patterns are concatenated, so the group referenced by a back reference is non-obvious!
        var strings = [
            // normal string
            /"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source,
            /'[^']*'/.source,
            /\$'(?:[^'\\]|\\[\s\S])*'/.source,
            // 2 capturing groups
            /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source
        ].join('|');
        Prism.languages['shell-session'] = {
            command: {
                pattern: RegExp(// user info
                /^/.source + '(?:' + // <user> ":" ( <path> )?
                (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + '|' + // <path>
                // Since the path pattern is quite general, we will require it to start with a special character to
                // prevent false positives.
                /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ')?' + // shell symbol
                /[$#%](?=\s)/.source + // bash command
                /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(/<<str>>/g, function() {
                    return strings;
                }), 'm'),
                greedy: true,
                inside: {
                    info: {
                        // foo@bar:~/files$ exit
                        // foo@bar$ exit
                        // ~/files$ exit
                        pattern: /^[^#$%]+/,
                        alias: 'punctuation',
                        inside: {
                            user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
                            punctuation: /:/,
                            path: /[\s\S]+/
                        }
                    },
                    bash: {
                        pattern: /(^[$#%]\s*)\S[\s\S]*/,
                        lookbehind: true,
                        alias: 'language-bash',
                        inside: Prism.languages.bash
                    },
                    'shell-symbol': {
                        pattern: /^[$#%]/,
                        alias: 'important'
                    }
                }
            },
            output: /.(?:.*(?:[\r\n]|.$))*/
        };
        Prism.languages['sh-session'] = Prism.languages['shellsession'] = Prism.languages['shell-session'];
    })(Prism);
}

},{"444c54b10c381536":"SDZTd"}],"QnLEV":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = smali;
smali.displayName = 'smali';
smali.aliases = [];
function smali(Prism) {
    // Test files for the parser itself:
    // https://github.com/JesusFreke/smali/tree/master/smali/src/test/resources/LexerTest
    Prism.languages.smali = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
            greedy: true
        },
        'class-name': {
            pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
            lookbehind: true,
            inside: {
                'class-name': {
                    pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
                    lookbehind: true
                },
                namespace: {
                    pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\//
                    }
                },
                builtin: /^L/
            }
        },
        builtin: [
            {
                // Reference: https://github.com/JesusFreke/smali/wiki/TypesMethodsAndFields#types
                pattern: /([();\[])[BCDFIJSVZ]+/,
                lookbehind: true
            },
            {
                // e.g. .field mWifiOnUid:I
                pattern: /([\w$>]:)[BCDFIJSVZ]/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /(\.end\s+)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
            lookbehind: true
        },
        field: {
            pattern: /[\w$]+(?=:)/,
            alias: 'variable'
        },
        register: {
            pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
            lookbehind: true,
            alias: 'variable'
        },
        boolean: {
            pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
            lookbehind: true
        },
        label: {
            pattern: /(:)\w+/,
            lookbehind: true,
            alias: 'property'
        },
        operator: /->|\.\.|[\[=]/,
        punctuation: /[{}(),;:]/
    };
}

},{}],"4XB3z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = smalltalk;
smalltalk.displayName = 'smalltalk';
smalltalk.aliases = [];
function smalltalk(Prism) {
    Prism.languages.smalltalk = {
        comment: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        char: {
            pattern: /\$./,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'])*'/,
            greedy: true
        },
        symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
        'block-arguments': {
            pattern: /(\[\s*):[^\[|]*\|/,
            lookbehind: true,
            inside: {
                variable: /:[\da-z]+/i,
                punctuation: /\|/
            }
        },
        'temporary-variables': {
            pattern: /\|[^|]+\|/,
            inside: {
                variable: /[\da-z]+/i,
                punctuation: /\|/
            }
        },
        keyword: /\b(?:new|nil|self|super)\b/,
        boolean: /\b(?:false|true)\b/,
        number: [
            /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
            /\b\d+(?:\.\d+)?(?:e-?\d+)?/
        ],
        operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
        punctuation: /[.;:?\[\](){}]/
    };
}

},{}],"i39EJ":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("bee0184588ec4a82");
module.exports = smarty;
smarty.displayName = 'smarty';
smarty.aliases = [];
function smarty(Prism) {
    Prism.register(refractorMarkupTemplating);
    (function(Prism) {
        Prism.languages.smarty = {
            comment: {
                pattern: /^\{\*[\s\S]*?\*\}/,
                greedy: true
            },
            'embedded-php': {
                pattern: /^\{php\}[\s\S]*?\{\/php\}/,
                greedy: true,
                inside: {
                    smarty: {
                        pattern: /^\{php\}|\{\/php\}$/,
                        inside: null // see below
                    },
                    php: {
                        pattern: /[\s\S]+/,
                        alias: 'language-php',
                        inside: Prism.languages.php
                    }
                }
            },
            string: [
                {
                    pattern: /"(?:\\.|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: /\{[^{}]*\}|`[^`]*`/,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^[{`]|[`}]$/,
                                    alias: 'punctuation'
                                },
                                expression: {
                                    pattern: /[\s\S]+/,
                                    inside: null // see below
                                }
                            }
                        },
                        variable: /\$\w+/
                    }
                },
                {
                    pattern: /'(?:\\.|[^'\\\r\n])*'/,
                    greedy: true
                }
            ],
            keyword: {
                pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
                lookbehind: true,
                greedy: true
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                greedy: true,
                alias: 'punctuation'
            },
            number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
            variable: [
                /\$(?!\d)\w+/,
                /#(?!\d)\w+#/,
                {
                    pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
                    lookbehind: true
                },
                {
                    pattern: /(\[)(?!\d)\w+(?=\])/,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
                lookbehind: true
            },
            'attr-name': /\b[a-z_]\w*(?=\s*=)/i,
            boolean: /\b(?:false|no|off|on|true|yes)\b/,
            punctuation: /[\[\](){}.,:`]|->/,
            operator: [
                /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
                /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
                /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/
            ]
        };
        Prism.languages.smarty['embedded-php'].inside.smarty.inside = Prism.languages.smarty;
        Prism.languages.smarty.string[0].inside.interpolation.inside.expression.inside = Prism.languages.smarty;
        var string = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/;
        var smartyPattern = RegExp(// comments
        /\{\*[\s\S]*?\*\}/.source + '|' + // php tags
        /\{php\}[\s\S]*?\{\/php\}/.source + '|' + // smarty blocks
        /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(/<str>/g, function() {
            return string.source;
        }), 'g') // Tokenize all inline Smarty expressions
        ;
        Prism.hooks.add('before-tokenize', function(env) {
            var smartyLiteralStart = '{literal}';
            var smartyLiteralEnd = '{/literal}';
            var smartyLiteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'smarty', smartyPattern, function(match) {
                // Smarty tags inside {literal} block are ignored
                if (match === smartyLiteralEnd) smartyLiteralMode = false;
                if (!smartyLiteralMode) {
                    if (match === smartyLiteralStart) smartyLiteralMode = true;
                    return true;
                }
                return false;
            });
        }) // Re-insert the tokens after tokenizing
        ;
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'smarty');
        });
    })(Prism);
}

},{"bee0184588ec4a82":"lhKhp"}],"jrAlE":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = sml;
sml.displayName = 'sml';
sml.aliases = [
    'smlnj'
];
function sml(Prism) {
    (function(Prism) {
        var keywords = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
        Prism.languages.sml = {
            // allow one level of nesting
            comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
            string: {
                pattern: /#?"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': [
                {
                    // This is only an approximation since the real grammar is context-free
                    //
                    // Why the main loop so complex?
                    // The main loop is approximately the same as /(?:\s*(?:[*,]|->)\s*<TERMINAL>)*/ which is, obviously, a lot
                    // simpler. The difference is that if a comma is the last iteration of the loop, then the terminal must be
                    // followed by a long identifier.
                    pattern: RegExp(/((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function() {
                        return /\s*(?:[*,]|->)/.source;
                    }).replace(/<TERMINAL>/g, function() {
                        return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
                    }).replace(/<LONG-ID>/g, function() {
                        return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
                    }).replace(/<KEYWORD>/g, function() {
                        return keywords.source;
                    }), 'i'),
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
                lookbehind: true
            },
            keyword: keywords,
            variable: {
                pattern: /(^|[^\w'])'[\w']*/,
                lookbehind: true
            },
            number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
            word: {
                pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
                alias: 'constant'
            },
            boolean: /\b(?:false|true)\b/i,
            operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
            punctuation: /[(){}\[\].:,;]/
        };
        Prism.languages.sml['class-name'][0].inside = Prism.languages.sml;
        Prism.languages.smlnj = Prism.languages.sml;
    })(Prism);
}

},{}],"g4fu0":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = solidity;
solidity.displayName = 'solidity';
solidity.aliases = [
    'sol'
];
function solidity(Prism) {
    Prism.languages.solidity = Prism.languages.extend('clike', {
        'class-name': {
            pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
            lookbehind: true
        },
        keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
        operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
    });
    Prism.languages.insertBefore('solidity', 'keyword', {
        builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
    });
    Prism.languages.insertBefore('solidity', 'number', {
        version: {
            pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
            lookbehind: true,
            alias: 'number'
        }
    });
    Prism.languages.sol = Prism.languages.solidity;
}

},{}],"Uv44I":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = solutionFile;
solutionFile.displayName = 'solutionFile';
solutionFile.aliases = [];
function solutionFile(Prism) {
    (function(Prism) {
        var guid = {
            // https://en.wikipedia.org/wiki/Universally_unique_identifier#Format
            pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
            alias: 'constant',
            inside: {
                punctuation: /[{}]/
            }
        };
        Prism.languages['solution-file'] = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                greedy: true,
                inside: {
                    guid: guid
                }
            },
            object: {
                // Foo
                //   Bar("abs") = 9
                //   EndBar
                //   Prop = TRUE
                // EndFoo
                pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
                lookbehind: true,
                greedy: true,
                alias: 'keyword'
            },
            property: {
                pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
                lookbehind: true,
                inside: {
                    guid: guid
                }
            },
            guid: guid,
            number: /\b\d+(?:\.\d+)*\b/,
            boolean: /\b(?:FALSE|TRUE)\b/,
            operator: /=/,
            punctuation: /[(),]/
        };
        Prism.languages['sln'] = Prism.languages['solution-file'];
    })(Prism);
}

},{}],"kLxiF":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("4d554afad78ed6c1");
module.exports = soy;
soy.displayName = 'soy';
soy.aliases = [];
function soy(Prism) {
    Prism.register(refractorMarkupTemplating);
    (function(Prism) {
        var stringPattern = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var numberPattern = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
        Prism.languages.soy = {
            comment: [
                /\/\*[\s\S]*?\*\//,
                {
                    pattern: /(\s)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            'command-arg': {
                pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /\./
                }
            },
            parameter: {
                pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'variable'
            },
            keyword: [
                {
                    pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
                    lookbehind: true
                },
                /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/
            ],
            delimiter: {
                pattern: /^\{+\/?|\/?\}+$/,
                alias: 'punctuation'
            },
            property: /\w+(?==)/,
            variable: {
                pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
                inside: {
                    string: {
                        pattern: stringPattern,
                        greedy: true
                    },
                    number: numberPattern,
                    punctuation: /[\[\].?]/
                }
            },
            string: {
                pattern: stringPattern,
                greedy: true
            },
            function: [
                /\w+(?=\()/,
                {
                    pattern: /(\|[^\S\r\n]*)\w+/,
                    lookbehind: true
                }
            ],
            boolean: /\b(?:false|true)\b/,
            number: numberPattern,
            operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
            punctuation: /[{}()\[\]|.,:]/
        } // Tokenize all inline Soy expressions
        ;
        Prism.hooks.add('before-tokenize', function(env) {
            var soyPattern = /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g;
            var soyLitteralStart = '{literal}';
            var soyLitteralEnd = '{/literal}';
            var soyLitteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'soy', soyPattern, function(match) {
                // Soy tags inside {literal} block are ignored
                if (match === soyLitteralEnd) soyLitteralMode = false;
                if (!soyLitteralMode) {
                    if (match === soyLitteralStart) soyLitteralMode = true;
                    return true;
                }
                return false;
            });
        }) // Re-insert the tokens after tokenizing
        ;
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'soy');
        });
    })(Prism);
}

},{"4d554afad78ed6c1":"lhKhp"}],"jHmS7":[function(require,module,exports,__globalThis) {
'use strict';
var refractorTurtle = require("fa3d6046ead94bec");
module.exports = sparql;
sparql.displayName = 'sparql';
sparql.aliases = [
    'rq'
];
function sparql(Prism) {
    Prism.register(refractorTurtle);
    Prism.languages.sparql = Prism.languages.extend('turtle', {
        boolean: /\b(?:false|true)\b/i,
        variable: {
            pattern: /[?$]\w+/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('sparql', 'punctuation', {
        keyword: [
            /\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i,
            /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i,
            /\b(?:BASE|GRAPH|PREFIX)\b/i
        ]
    });
    Prism.languages.rq = Prism.languages.sparql;
}

},{"fa3d6046ead94bec":"8lg3c"}],"8lg3c":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = turtle;
turtle.displayName = 'turtle';
turtle.aliases = [];
function turtle(Prism) {
    Prism.languages.turtle = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'multiline-string': {
            pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
            greedy: true,
            alias: 'string',
            inside: {
                comment: /#.*/
            }
        },
        string: {
            pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
            greedy: true
        },
        url: {
            pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
            greedy: true,
            inside: {
                punctuation: /[<>]/
            }
        },
        function: {
            pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
            inside: {
                'local-name': {
                    pattern: /([^:]*:)[\s\S]+/,
                    lookbehind: true
                },
                prefix: {
                    pattern: /[\s\S]+/,
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        },
        number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        punctuation: /[{}.,;()[\]]|\^\^/,
        boolean: /\b(?:false|true)\b/,
        keyword: [
            /(?:\ba|@prefix|@base)\b|=/,
            /\b(?:base|graph|prefix)\b/i
        ],
        tag: {
            pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
            inside: {
                punctuation: /@/
            }
        }
    };
    Prism.languages.trig = Prism.languages['turtle'];
}

},{}],"bEBe7":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = splunkSpl;
splunkSpl.displayName = 'splunkSpl';
splunkSpl.aliases = [];
function splunkSpl(Prism) {
    Prism.languages['splunk-spl'] = {
        comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true
        },
        // https://docs.splunk.com/Documentation/Splunk/7.3.0/SearchReference/ListOfSearchCommands
        keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
        'operator-word': {
            pattern: /\b(?:and|as|by|not|or|xor)\b/i,
            alias: 'operator'
        },
        function: /\b\w+(?=\s*\()/,
        property: /\b\w+(?=\s*=(?!=))/,
        date: {
            // MM/DD/YYYY(:HH:MM:SS)?
            pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
            alias: 'number'
        },
        number: /\b\d+(?:\.\d+)?\b/,
        boolean: /\b(?:f|false|t|true)\b/i,
        operator: /[<>=]=?|[-+*/%|]/,
        punctuation: /[()[\],]/
    };
}

},{}],"8bFuG":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = sqf;
sqf.displayName = 'sqf';
sqf.aliases = [];
function sqf(Prism) {
    Prism.languages.sqf = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
            greedy: true
        },
        keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
        number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
        operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
        'magic-variable': {
            pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
            alias: 'keyword'
        },
        constant: /\bDIK(?:_[a-z\d]+)+\b/i
    });
    Prism.languages.insertBefore('sqf', 'string', {
        macro: {
            pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /#[a-z]+\b/i,
                    alias: 'keyword'
                },
                comment: Prism.languages.sqf.comment
            }
        }
    });
    delete Prism.languages.sqf['class-name'];
}

},{}],"l8WOe":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = squirrel;
squirrel.displayName = 'squirrel';
squirrel.aliases = [];
function squirrel(Prism) {
    Prism.languages.squirrel = Prism.languages.extend('clike', {
        comment: [
            Prism.languages.clike['comment'][0],
            {
                pattern: /(^|[^\\:])(?:\/\/|#).*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
        number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
        operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
        punctuation: /[(){}\[\],;.]/
    });
    Prism.languages.insertBefore('squirrel', 'string', {
        char: {
            pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
            lookbehind: true,
            greedy: true
        }
    });
    Prism.languages.insertBefore('squirrel', 'operator', {
        'attribute-punctuation': {
            pattern: /<\/|\/>/,
            alias: 'important'
        },
        lambda: {
            pattern: /@(?=\()/,
            alias: 'operator'
        }
    });
}

},{}],"8NaXO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = stan;
stan.displayName = 'stan';
stan.aliases = [];
function stan(Prism) {
    (function(Prism) {
        // https://mc-stan.org/docs/2_28/reference-manual/bnf-grammars.html
        var higherOrderFunctions = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
        Prism.languages.stan = {
            comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
            string: {
                // String literals can contain spaces and any printable ASCII characters except for " and \
                // https://mc-stan.org/docs/2_24/reference-manual/print-statements-section.html#string-literals
                pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
                greedy: true
            },
            directive: {
                pattern: /^([ \t]*)#include\b.*/m,
                lookbehind: true,
                alias: 'property'
            },
            'function-arg': {
                pattern: RegExp('(' + higherOrderFunctions.source + /\s*\(\s*/.source + ')' + /[a-zA-Z]\w*/.source),
                lookbehind: true,
                alias: 'function'
            },
            constraint: {
                pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    property: /\b[a-z]\w*(?=\s*=)/i,
                    operator: /=/,
                    punctuation: /^<|>$|,/
                }
            },
            keyword: [
                {
                    pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
                    alias: 'program-block'
                },
                /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/,
                higherOrderFunctions
            ],
            function: /\b[a-z]\w*(?=\s*\()/i,
            number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            boolean: /\b(?:false|true)\b/,
            operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
            punctuation: /[()\[\]{},;]/
        };
        Prism.languages.stan.constraint.inside.expression.inside = Prism.languages.stan;
    })(Prism);
}

},{}],"2G2jP":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = stylus;
stylus.displayName = 'stylus';
stylus.aliases = [];
function stylus(Prism) {
    (function(Prism) {
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+)/,
            lookbehind: true
        } // 123 -123 .123 -.123 12.3 -12.3
        ;
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        var inside = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true
            },
            url: {
                pattern: /\burl\((["']?).*?\1\)/i,
                greedy: true
            },
            string: {
                pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
                greedy: true
            },
            interpolation: null,
            // See below
            func: null,
            // See below
            important: /\B!(?:important|optional)\b/i,
            keyword: {
                pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
                lookbehind: true
            },
            hexcode: /#[\da-f]{3,6}/i,
            color: [
                /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            boolean: /\b(?:false|true)\b/,
            operator: [
                // We want non-word chars around "-" because it is
                // accepted in property names.
                /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
            ],
            number: number,
            punctuation: /[{}()\[\];:,]/
        };
        inside['interpolation'] = {
            pattern: /\{[^\r\n}:]+\}/,
            alias: 'variable',
            inside: {
                delimiter: {
                    pattern: /^\{|\}$/,
                    alias: 'punctuation'
                },
                rest: inside
            }
        };
        inside['func'] = {
            pattern: /[\w-]+\([^)]*\).*/,
            inside: {
                function: /^[^(]+/,
                rest: inside
            }
        };
        Prism.languages.stylus = {
            'atrule-declaration': {
                pattern: /(^[ \t]*)@.+/m,
                lookbehind: true,
                inside: {
                    atrule: /^@[\w-]+/,
                    rest: inside
                }
            },
            'variable-declaration': {
                pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
                lookbehind: true,
                inside: {
                    variable: /^\S+/,
                    rest: inside
                }
            },
            statement: {
                pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
                lookbehind: true,
                inside: {
                    keyword: /^\S+/,
                    rest: inside
                }
            },
            // A property/value pair cannot end with a comma or a brace
            // It cannot have indented content unless it ended with a semicolon
            'property-declaration': {
                pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
                lookbehind: true,
                inside: {
                    property: {
                        pattern: /^[^\s:]+/,
                        inside: {
                            interpolation: inside.interpolation
                        }
                    },
                    rest: inside
                }
            },
            // A selector can contain parentheses only as part of a pseudo-element
            // It can span multiple lines.
            // It must end with a comma or an accolade or have indented content.
            selector: {
                pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
                lookbehind: true,
                inside: {
                    interpolation: inside.interpolation,
                    comment: inside.comment,
                    punctuation: /[{},]/
                }
            },
            func: inside.func,
            string: inside.string,
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true,
                greedy: true
            },
            interpolation: inside.interpolation,
            punctuation: /[{}()\[\];:.]/
        };
    })(Prism);
}

},{}],"lhKw6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = swift;
swift.displayName = 'swift';
swift.aliases = [];
function swift(Prism) {
    Prism.languages.swift = {
        comment: {
            // Nested comments are supported up to 2 levels
            pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
            lookbehind: true,
            greedy: true
        },
        'string-literal': [
            // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
            {
                pattern: RegExp(/(^|[^"#])/.source + '(?:' + // single-line string
                /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + '|' + // multi-line string
                /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ')' + /(?!["#])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\\($/,
                        alias: 'punctuation'
                    },
                    punctuation: /\\(?=[\r\n])/,
                    string: /[\s\S]+/
                }
            },
            {
                pattern: RegExp(/(^|[^"#])(#+)/.source + '(?:' + // single-line string
                /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + '|' + // multi-line string
                /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ')' + '\\2'),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\#+\($/,
                        alias: 'punctuation'
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        directive: {
            // directives with conditions
            pattern: RegExp(/#/.source + '(?:' + (/(?:elseif|if)\b/.source + '(?:[ \t]*' + // This regex is a little complex. It's equivalent to this:
            //   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
            // where <round> is a general parentheses expression.
            /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ')+') + '|' + /(?:else|endif)\b/.source + ')'),
            alias: 'property',
            inside: {
                'directive-name': /^#\w+/,
                boolean: /\b(?:false|true)\b/,
                number: /\b\d+(?:\.\d+)*\b/,
                operator: /!|&&|\|\||[<>]=?/,
                punctuation: /[(),]/
            }
        },
        literal: {
            pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
            alias: 'constant'
        },
        'other-directive': {
            pattern: /#\w+\b/,
            alias: 'property'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'atrule'
        },
        'function-definition': {
            pattern: /(\bfunc\s+)\w+/,
            lookbehind: true,
            alias: 'function'
        },
        label: {
            // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
            pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
            lookbehind: true,
            alias: 'important'
        },
        keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
        boolean: /\b(?:false|true)\b/,
        nil: {
            pattern: /\bnil\b/,
            alias: 'constant'
        },
        'short-argument': /\$\d+\b/,
        omit: {
            pattern: /\b_\b/,
            alias: 'keyword'
        },
        number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
        // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
        'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
        // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
        // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
        // This regex only supports ASCII operators.
        operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
        punctuation: /[{}[\]();,.:\\]/
    };
    Prism.languages.swift['string-literal'].forEach(function(rule) {
        rule.inside['interpolation'].inside = Prism.languages.swift;
    });
}

},{}],"jWttK":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = systemd;
systemd.displayName = 'systemd';
systemd.aliases = [];
function systemd(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /^[;#].*/m,
            greedy: true
        };
        var quotesSource = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
        Prism.languages.systemd = {
            comment: comment,
            section: {
                pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    'section-name': {
                        pattern: /[\s\S]+/,
                        alias: 'selector'
                    }
                }
            },
            key: {
                pattern: /^[^\s=]+(?=[ \t]*=)/m,
                greedy: true,
                alias: 'attr-name'
            },
            value: {
                // This pattern is quite complex because of two properties:
                //  1) Quotes (strings) must be preceded by a space. Since we can't use lookbehinds, we have to "resolve"
                //     the lookbehind. You will see this in the main loop where spaces are handled separately.
                //  2) Line continuations.
                //     After line continuations, empty lines and comments are ignored so we have to consume them.
                pattern: RegExp(/(=[ \t]*(?!\s))/.source + // the value either starts with quotes or not
                '(?:' + quotesSource + '|(?=[^"\r\n]))' + // main loop
                '(?:' + (/[^\s\\]/.source + // handle spaces separately because of quotes
                '|' + '[ \t]+(?:(?![ \t"])|' + quotesSource + ')' + // line continuation
                '|' + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source) + ')*'),
                lookbehind: true,
                greedy: true,
                alias: 'attr-value',
                inside: {
                    comment: comment,
                    quoted: {
                        pattern: RegExp(/(^|\s)/.source + quotesSource),
                        lookbehind: true,
                        greedy: true
                    },
                    punctuation: /\\$/m,
                    boolean: {
                        pattern: /^(?:false|no|off|on|true|yes)$/,
                        greedy: true
                    }
                }
            },
            punctuation: /=/
        };
    })(Prism);
}

},{}],"hWk2Z":[function(require,module,exports,__globalThis) {
'use strict';
var refractorT4Templating = require("f47e412a91c72f0");
var refractorCsharp = require("39ab6c8fae22f151");
module.exports = t4Cs;
t4Cs.displayName = 't4Cs';
t4Cs.aliases = [];
function t4Cs(Prism) {
    Prism.register(refractorT4Templating);
    Prism.register(refractorCsharp);
    Prism.languages.t4 = Prism.languages['t4-cs'] = Prism.languages['t4-templating'].createT4('csharp');
}

},{"f47e412a91c72f0":"9gh8N","39ab6c8fae22f151":"buy6I"}],"9gh8N":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = t4Templating;
t4Templating.displayName = 't4Templating';
t4Templating.aliases = [];
function t4Templating(Prism) {
    (function(Prism) {
        function createBlock(prefix, inside, contentAlias) {
            return {
                pattern: RegExp('<#' + prefix + '[\\s\\S]*?#>'),
                alias: 'block',
                inside: {
                    delimiter: {
                        pattern: RegExp('^<#' + prefix + '|#>$'),
                        alias: 'important'
                    },
                    content: {
                        pattern: /[\s\S]+/,
                        inside: inside,
                        alias: contentAlias
                    }
                }
            };
        }
        function createT4(insideLang) {
            var grammar = Prism.languages[insideLang];
            var className = 'language-' + insideLang;
            return {
                block: {
                    pattern: /<#[\s\S]+?#>/,
                    inside: {
                        directive: createBlock('@', {
                            'attr-value': {
                                pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                                inside: {
                                    punctuation: /^=|^["']|["']$/
                                }
                            },
                            keyword: /\b\w+(?=\s)/,
                            'attr-name': /\b\w+/
                        }),
                        expression: createBlock('=', grammar, className),
                        'class-feature': createBlock('\\+', grammar, className),
                        standard: createBlock('', grammar, className)
                    }
                }
            };
        }
        Prism.languages['t4-templating'] = Object.defineProperty({}, 'createT4', {
            value: createT4
        });
    })(Prism);
}

},{}],"9zSTh":[function(require,module,exports,__globalThis) {
'use strict';
var refractorT4Templating = require("65481886a6e752a9");
var refractorVbnet = require("2479aeeebe6cdbb3");
module.exports = t4Vb;
t4Vb.displayName = 't4Vb';
t4Vb.aliases = [];
function t4Vb(Prism) {
    Prism.register(refractorT4Templating);
    Prism.register(refractorVbnet);
    Prism.languages['t4-vb'] = Prism.languages['t4-templating'].createT4('vbnet');
}

},{"65481886a6e752a9":"9gh8N","2479aeeebe6cdbb3":"5lunV"}],"5lunV":[function(require,module,exports,__globalThis) {
'use strict';
var refractorBasic = require("dc606a244be1c8d8");
module.exports = vbnet;
vbnet.displayName = 'vbnet';
vbnet.aliases = [];
function vbnet(Prism) {
    Prism.register(refractorBasic);
    Prism.languages.vbnet = Prism.languages.extend('basic', {
        comment: [
            {
                pattern: /(?:!|REM\b).+/i,
                inside: {
                    keyword: /^REM/i
                }
            },
            {
                pattern: /(^|[^\\:])'.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
        punctuation: /[,;:(){}]/
    });
}

},{"dc606a244be1c8d8":"bnU0U"}],"cFnF4":[function(require,module,exports,__globalThis) {
'use strict';
var refractorYaml = require("3d2b226f449bb898");
module.exports = tap;
tap.displayName = 'tap';
tap.aliases = [];
function tap(Prism) {
    Prism.register(refractorYaml);
    // https://en.wikipedia.org/wiki/Test_Anything_Protocol
    Prism.languages.tap = {
        fail: /not ok[^#{\n\r]*/,
        pass: /ok[^#{\n\r]*/,
        pragma: /pragma [+-][a-z]+/,
        bailout: /bail out!.*/i,
        version: /TAP version \d+/i,
        plan: /\b\d+\.\.\d+(?: +#.*)?/,
        subtest: {
            pattern: /# Subtest(?:: .*)?/,
            greedy: true
        },
        punctuation: /[{}]/,
        directive: /#.*/,
        yamlish: {
            pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
            lookbehind: true,
            inside: Prism.languages.yaml,
            alias: 'language-yaml'
        }
    };
}

},{"3d2b226f449bb898":"jAdhw"}],"jAdhw":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = yaml;
yaml.displayName = 'yaml';
yaml.aliases = [
    'yml'
];
function yaml(Prism) {
    (function(Prism) {
        // https://yaml.org/spec/1.2/spec.html#c-ns-anchor-property
        // https://yaml.org/spec/1.2/spec.html#c-ns-alias-node
        var anchorOrAlias = /[*&][^\s[\]{},]+/ // https://yaml.org/spec/1.2/spec.html#c-ns-tag-property
        ;
        var tag = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/ // https://yaml.org/spec/1.2/spec.html#c-ns-properties(n,c)
        ;
        var properties = '(?:' + tag.source + '(?:[ \t]+' + anchorOrAlias.source + ')?|' + anchorOrAlias.source + '(?:[ \t]+' + tag.source + ')?)' // https://yaml.org/spec/1.2/spec.html#ns-plain(n,c)
        ;
        // This is a simplified version that doesn't support "#" and multiline keys
        // All these long scarry character classes are simplified versions of YAML's characters
        var plainKey = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
            return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
        });
        var string = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
        /**
     *
     * @param {string} value
     * @param {string} [flags]
     * @returns {RegExp}
     */ function createValuePattern(value, flags) {
            flags = (flags || '').replace(/m/g, '') + 'm' // add m flag
            ;
            var pattern = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
                return properties;
            }).replace(/<<value>>/g, function() {
                return value;
            });
            return RegExp(pattern, flags);
        }
        Prism.languages.yaml = {
            scalar: {
                pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                })),
                lookbehind: true,
                alias: 'string'
            },
            comment: /#.*/,
            key: {
                pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                }).replace(/<<key>>/g, function() {
                    return '(?:' + plainKey + '|' + string + ')';
                })),
                lookbehind: true,
                greedy: true,
                alias: 'atrule'
            },
            directive: {
                pattern: /(^[ \t]*)%.+/m,
                lookbehind: true,
                alias: 'important'
            },
            datetime: {
                pattern: createValuePattern(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
                lookbehind: true,
                alias: 'number'
            },
            boolean: {
                pattern: createValuePattern(/false|true/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            null: {
                pattern: createValuePattern(/null|~/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            string: {
                pattern: createValuePattern(string),
                lookbehind: true,
                greedy: true
            },
            number: {
                pattern: createValuePattern(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, 'i'),
                lookbehind: true
            },
            tag: tag,
            important: anchorOrAlias,
            punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
        };
        Prism.languages.yml = Prism.languages.yaml;
    })(Prism);
}

},{}],"lbzf8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = tcl;
tcl.displayName = 'tcl';
tcl.aliases = [];
function tcl(Prism) {
    Prism.languages.tcl = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true
        },
        string: {
            pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
                lookbehind: true
            },
            {
                pattern: /(\$)\{[^}]+\}/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^[\t ]*proc[ \t]+)\S+/m,
            lookbehind: true
        },
        builtin: [
            {
                pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
                lookbehind: true
            },
            /\b(?:else|elseif)\b/
        ],
        scope: {
            pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
            lookbehind: true,
            alias: 'constant'
        },
        keyword: {
            pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
            lookbehind: true
        },
        operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
        punctuation: /[{}()\[\]]/
    };
}

},{}],"1yQZh":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = textile;
textile.displayName = 'textile';
textile.aliases = [];
function textile(Prism) {
    (function(Prism) {
        // We don't allow for pipes inside parentheses
        // to not break table pattern |(. foo |). bar |
        var modifierRegex = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source // Opening and closing parentheses which are not a modifier
        ;
        // This pattern is necessary to prevent exponential backtracking
        var parenthesesRegex = /\)|\((?![^|()\n]+\))/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function withModifier(source, flags) {
            return RegExp(source.replace(/<MOD>/g, function() {
                return '(?:' + modifierRegex + ')';
            }).replace(/<PAR>/g, function() {
                return '(?:' + parenthesesRegex + ')';
            }), flags || '');
        }
        var modifierTokens = {
            css: {
                pattern: /\{[^{}]+\}/,
                inside: {
                    rest: Prism.languages.css
                }
            },
            'class-id': {
                pattern: /(\()[^()]+(?=\))/,
                lookbehind: true,
                alias: 'attr-value'
            },
            lang: {
                pattern: /(\[)[^\[\]]+(?=\])/,
                lookbehind: true,
                alias: 'attr-value'
            },
            // Anything else is punctuation (the first pattern is for row/col spans inside tables)
            punctuation: /[\\\/]\d+|\S/
        };
        var textile = Prism.languages.textile = Prism.languages.extend('markup', {
            phrase: {
                pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
                lookbehind: true,
                inside: {
                    // h1. Header 1
                    'block-tag': {
                        pattern: withModifier(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            tag: /^[a-z]\w*/,
                            punctuation: /\.$/
                        }
                    },
                    // # List item
                    // * List item
                    list: {
                        pattern: withModifier(/^[*#]+<MOD>*\s+\S.*/.source, 'm'),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[*#]+)<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /^[*#]+/
                        }
                    },
                    // | cell | cell | cell |
                    table: {
                        // Modifiers can be applied to the row: {color:red}.|1|2|3|
                        // or the cell: |{color:red}.1|2|3|
                        pattern: withModifier(/^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source, 'm'),
                        inside: {
                            modifier: {
                                // Modifiers for rows after the first one are
                                // preceded by a pipe and a line feed
                                pattern: withModifier(/(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /\||^\./
                        }
                    },
                    inline: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source),
                        lookbehind: true,
                        inside: {
                            // Note: superscripts and subscripts are not handled specifically
                            // *bold*, **bold**
                            bold: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // _italic_, __italic__
                            italic: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(__?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // ??cite??
                            cite: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                                lookbehind: true,
                                alias: 'string'
                            },
                            // @code@
                            code: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^@<MOD>*).+?(?=@)/.source),
                                lookbehind: true,
                                alias: 'keyword'
                            },
                            // +inserted+
                            inserted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\+<MOD>*).+?(?=\+)/.source),
                                lookbehind: true
                            },
                            // -deleted-
                            deleted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^-<MOD>*).+?(?=-)/.source),
                                lookbehind: true
                            },
                            // %span%
                            span: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^%<MOD>*).+?(?=%)/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /[*_%?@+\-^~]+/
                        }
                    },
                    // [alias]http://example.com
                    'link-ref': {
                        pattern: /^\[[^\]]+\]\S+$/m,
                        inside: {
                            string: {
                                pattern: /(^\[)[^\]]+(?=\])/,
                                lookbehind: true
                            },
                            url: {
                                pattern: /(^\])\S+$/,
                                lookbehind: true
                            },
                            punctuation: /[\[\]]/
                        }
                    },
                    // "text":http://example.com
                    // "text":link-ref
                    link: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source),
                        inside: {
                            text: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^"<MOD>*)[^"]+(?=")/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^")<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[":]/
                        }
                    },
                    // !image.jpg!
                    // !image.jpg(Title)!:http://example.com
                    image: {
                        pattern: withModifier(/!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source),
                        inside: {
                            source: {
                                pattern: withModifier(/(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source),
                                lookbehind: true,
                                alias: 'url'
                            },
                            modifier: {
                                pattern: withModifier(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[!:]/
                        }
                    },
                    // Footnote[1]
                    footnote: {
                        pattern: /\b\[\d+\]/,
                        alias: 'comment',
                        inside: {
                            punctuation: /\[|\]/
                        }
                    },
                    // CSS(Cascading Style Sheet)
                    acronym: {
                        pattern: /\b[A-Z\d]+\([^)]+\)/,
                        inside: {
                            comment: {
                                pattern: /(\()[^()]+(?=\))/,
                                lookbehind: true
                            },
                            punctuation: /[()]/
                        }
                    },
                    // Prism(C)
                    mark: {
                        pattern: /\b\((?:C|R|TM)\)/,
                        alias: 'comment',
                        inside: {
                            punctuation: /[()]/
                        }
                    }
                }
            }
        });
        var phraseInside = textile['phrase'].inside;
        var nestedPatterns = {
            inline: phraseInside['inline'],
            link: phraseInside['link'],
            image: phraseInside['image'],
            footnote: phraseInside['footnote'],
            acronym: phraseInside['acronym'],
            mark: phraseInside['mark']
        } // Only allow alpha-numeric HTML tags, not XML tags
        ;
        textile.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i // Allow some nesting
        ;
        var phraseInlineInside = phraseInside['inline'].inside;
        phraseInlineInside['bold'].inside = nestedPatterns;
        phraseInlineInside['italic'].inside = nestedPatterns;
        phraseInlineInside['inserted'].inside = nestedPatterns;
        phraseInlineInside['deleted'].inside = nestedPatterns;
        phraseInlineInside['span'].inside = nestedPatterns // Allow some styles inside table cells
        ;
        var phraseTableInside = phraseInside['table'].inside;
        phraseTableInside['inline'] = nestedPatterns['inline'];
        phraseTableInside['link'] = nestedPatterns['link'];
        phraseTableInside['image'] = nestedPatterns['image'];
        phraseTableInside['footnote'] = nestedPatterns['footnote'];
        phraseTableInside['acronym'] = nestedPatterns['acronym'];
        phraseTableInside['mark'] = nestedPatterns['mark'];
    })(Prism);
}

},{}],"dwOYD":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = toml;
toml.displayName = 'toml';
toml.aliases = [];
function toml(Prism) {
    (function(Prism) {
        var key = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
        /**
     * @param {string} pattern
     */ function insertKey(pattern) {
            return pattern.replace(/__/g, function() {
                return key;
            });
        }
        Prism.languages.toml = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            table: {
                pattern: RegExp(insertKey(/(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name'
            },
            key: {
                pattern: RegExp(insertKey(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'property'
            },
            string: {
                pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            date: [
                {
                    // Offset Date-Time, Local Date-Time, Local Date
                    pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
                    alias: 'number'
                },
                {
                    // Local Time
                    pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
                    alias: 'number'
                }
            ],
            number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /[.,=[\]{}]/
        };
    })(Prism);
}

},{}],"dR9PJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = tremor;
tremor.displayName = 'tremor';
tremor.aliases = [];
function tremor(Prism) {
    (function(Prism) {
        Prism.languages.tremor = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
                lookbehind: true
            },
            'interpolated-string': null,
            // see below
            extractor: {
                pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
                greedy: true,
                inside: {
                    regex: {
                        pattern: /(^re)\|[\s\S]+/,
                        lookbehind: true
                    },
                    function: /^\w+/,
                    value: /\|[\s\S]+/
                }
            },
            identifier: {
                pattern: /`[^`]*`/,
                greedy: true
            },
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
            keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
            boolean: /\b(?:false|null|true)\b/i,
            number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
            'pattern-punctuation': {
                pattern: /%(?=[({[])/,
                alias: 'punctuation'
            },
            operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
            punctuation: /::|[;\[\]()\{\},.:]/
        };
        var interpolationPattern = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
        Prism.languages.tremor['interpolated-string'] = {
            pattern: RegExp(/(^|[^\\])/.source + '(?:' + '"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + '|' + interpolationPattern + ')*"""' + '|' + '"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + '|' + interpolationPattern + ')*"' + ')'),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    inside: {
                        punctuation: /^#\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.tremor
                        }
                    }
                },
                string: /[\s\S]+/
            }
        };
        Prism.languages.troy = Prism.languages['tremor'];
        Prism.languages.trickle = Prism.languages['tremor'];
    })(Prism);
}

},{}],"64KR2":[function(require,module,exports,__globalThis) {
'use strict';
var refractorJsx = require("68d2f9cdb4350cc");
var refractorTypescript = require("cb849a21bda1693");
module.exports = tsx;
tsx.displayName = 'tsx';
tsx.aliases = [];
function tsx(Prism) {
    Prism.register(refractorJsx);
    Prism.register(refractorTypescript);
    (function(Prism) {
        var typescript = Prism.util.clone(Prism.languages.typescript);
        Prism.languages.tsx = Prism.languages.extend('jsx', typescript) // doesn't work with TS because TS is too complex
        ;
        delete Prism.languages.tsx['parameter'];
        delete Prism.languages.tsx['literal-property'] // This will prevent collisions between TSX tags and TS generic types.
        ;
        // Idea by https://github.com/karlhorky
        // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
        var tag = Prism.languages.tsx.tag;
        tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
        tag.lookbehind = true;
    })(Prism);
}

},{"68d2f9cdb4350cc":"alaWJ","cb849a21bda1693":"78nM7"}],"hJg00":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("e1b781e39489570f");
module.exports = tt2;
tt2.displayName = 'tt2';
tt2.aliases = [];
function tt2(Prism) {
    Prism.register(refractorMarkupTemplating);
    (function(Prism) {
        Prism.languages.tt2 = Prism.languages.extend('clike', {
            comment: /#.*|\[%#[\s\S]*?%\]/,
            keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
            punctuation: /[[\]{},()]/
        });
        Prism.languages.insertBefore('tt2', 'number', {
            operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
            variable: {
                pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
            }
        });
        Prism.languages.insertBefore('tt2', 'keyword', {
            delimiter: {
                pattern: /^(?:\[%|%%)-?|-?%\]$/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('tt2', 'string', {
            'single-quoted-string': {
                pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
                greedy: true,
                alias: 'string'
            },
            'double-quoted-string': {
                pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
                greedy: true,
                alias: 'string',
                inside: {
                    variable: {
                        pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
                    }
                }
            }
        }) // The different types of TT2 strings "replace" the C-like standard string
        ;
        delete Prism.languages.tt2.string;
        Prism.hooks.add('before-tokenize', function(env) {
            var tt2Pattern = /\[%[\s\S]+?%\]/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'tt2', tt2Pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'tt2');
        });
    })(Prism);
}

},{"e1b781e39489570f":"lhKhp"}],"lptQj":[function(require,module,exports,__globalThis) {
'use strict';
var refractorMarkupTemplating = require("8ef7e319a74f6ffc");
module.exports = twig;
twig.displayName = 'twig';
twig.aliases = [];
function twig(Prism) {
    Prism.register(refractorMarkupTemplating);
    Prism.languages.twig = {
        comment: /^\{#[\s\S]*?#\}$/,
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            }
        },
        keyword: /\b(?:even|if|odd)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
    Prism.hooks.add('before-tokenize', function(env) {
        if (env.language !== 'twig') return;
        var pattern = /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'twig', pattern);
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'twig');
    });
}

},{"8ef7e319a74f6ffc":"lhKhp"}],"cUtLH":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = typoscript;
typoscript.displayName = 'typoscript';
typoscript.aliases = [
    'tsconfig'
];
function typoscript(Prism) {
    (function(Prism) {
        var keywords = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
        Prism.languages.typoscript = {
            comment: [
                {
                    // multiline comments /* */
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true
                },
                {
                    // double-slash comments - ignored when backslashes or colon is found in front
                    // also ignored whenever directly after an equal-sign, because it would probably be an url without protocol
                    pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // hash comments - ignored when leading quote is found for hex colors in strings
                    pattern: /(^|[^"'])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            function: [
                {
                    // old include style
                    pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
                    inside: {
                        string: {
                            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                            inside: {
                                keyword: keywords
                            }
                        },
                        keyword: {
                            pattern: /INCLUDE_TYPOSCRIPT/
                        }
                    }
                },
                {
                    // new include style
                    pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
                    inside: {
                        string: /"[^"\r\n]*"|'[^'\r\n]*'/
                    }
                }
            ],
            string: {
                pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
                lookbehind: true,
                inside: {
                    function: /\{\$.*\}/,
                    // constants include
                    keyword: keywords,
                    number: /^\d+$/,
                    punctuation: /[,|:]/
                }
            },
            keyword: keywords,
            number: {
                // special highlighting for indexes of arrays in tags
                pattern: /\b\d+\s*[.{=]/,
                inside: {
                    operator: /[.{=]/
                }
            },
            tag: {
                pattern: /\.?[-\w\\]+\.?/,
                inside: {
                    punctuation: /\./
                }
            },
            punctuation: /[{}[\];(),.:|]/,
            operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
        };
        Prism.languages.tsconfig = Prism.languages.typoscript;
    })(Prism);
}

},{}],"cZE3w":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = unrealscript;
unrealscript.displayName = 'unrealscript';
unrealscript.aliases = [
    'uc',
    'uscript'
];
function unrealscript(Prism) {
    Prism.languages.unrealscript = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        category: {
            pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        metadata: {
            pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
            lookbehind: true,
            greedy: true,
            inside: {
                property: /\b\w+(?=\s*=)/,
                operator: /=/,
                punctuation: /[<>|]/
            }
        },
        macro: {
            pattern: /`\w+/,
            alias: 'property'
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        // https://docs.unrealengine.com/udk/Three/UnrealScriptExpressions.html
        operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
        punctuation: /[()[\]{};,.]/
    };
    Prism.languages.uc = Prism.languages.uscript = Prism.languages.unrealscript;
}

},{}],"4ePta":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = uorazor;
uorazor.displayName = 'uorazor';
uorazor.aliases = [];
function uorazor(Prism) {
    Prism.languages.uorazor = {
        'comment-hash': {
            pattern: /#.*/,
            alias: 'comment',
            greedy: true
        },
        'comment-slash': {
            pattern: /\/\/.*/,
            alias: 'comment',
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            },
            greedy: true
        },
        'source-layers': {
            pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
            alias: 'function'
        },
        'source-commands': {
            pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
            alias: 'function'
        },
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
        keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
}

},{}],"anl6q":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = uri;
uri.displayName = 'uri';
uri.aliases = [
    'url'
];
function uri(Prism) {
    // https://tools.ietf.org/html/rfc3986#appendix-A
    Prism.languages.uri = {
        scheme: {
            pattern: /^[a-z][a-z0-9+.-]*:/im,
            greedy: true,
            inside: {
                'scheme-delimiter': /:$/
            }
        },
        fragment: {
            pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'fragment-delimiter': /^#/
            }
        },
        query: {
            pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'query-delimiter': {
                    pattern: /^\?/,
                    greedy: true
                },
                'pair-delimiter': /[&;]/,
                pair: {
                    pattern: /^[^=][\s\S]*/,
                    inside: {
                        key: /^[^=]+/,
                        value: {
                            pattern: /(^=)[\s\S]+/,
                            lookbehind: true
                        }
                    }
                }
            }
        },
        authority: {
            pattern: RegExp(/^\/\//.source + // [ userinfo "@" ]
            /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + // host
            ('(?:' + // IP-literal
            /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + '|' + // IPv4address or registered name
            /[\w\-.~!$&'()*+,;=%]*/.source + ')') + // [ ":" port ]
            /(?::\d*)?/.source, 'm'),
            inside: {
                'authority-delimiter': /^\/\//,
                'user-info-segment': {
                    pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
                    inside: {
                        'user-info-delimiter': /@$/,
                        'user-info': /^[\w\-.~!$&'()*+,;=%:]+/
                    }
                },
                'port-segment': {
                    pattern: /:\d*$/,
                    inside: {
                        'port-delimiter': /^:/,
                        port: /^\d+/
                    }
                },
                host: {
                    pattern: /[\s\S]+/,
                    inside: {
                        'ip-literal': {
                            pattern: /^\[[\s\S]+\]$/,
                            inside: {
                                'ip-literal-delimiter': /^\[|\]$/,
                                'ipv-future': /^v[\s\S]+/,
                                'ipv6-address': /^[\s\S]+/
                            }
                        },
                        'ipv4-address': /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
                    }
                }
            }
        },
        path: {
            pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
            inside: {
                'path-separator': /\//
            }
        }
    };
    Prism.languages.url = Prism.languages.uri;
}

},{}],"SrnU6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = v;
v.displayName = 'v';
v.aliases = [];
function v(Prism) {
    (function(Prism) {
        var interpolationExpr = {
            pattern: /[\s\S]+/,
            inside: null
        };
        Prism.languages.v = Prism.languages.extend('clike', {
            string: {
                pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                alias: 'quoted-string',
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
                        lookbehind: true,
                        inside: {
                            'interpolation-variable': {
                                pattern: /^\$\w[\s\S]*$/,
                                alias: 'variable'
                            },
                            'interpolation-punctuation': {
                                pattern: /^\$\{|\}$/,
                                alias: 'punctuation'
                            },
                            'interpolation-expression': interpolationExpr
                        }
                    }
                }
            },
            'class-name': {
                pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
                lookbehind: true
            },
            keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
            number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
            operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
            builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
        });
        interpolationExpr.inside = Prism.languages.v;
        Prism.languages.insertBefore('v', 'string', {
            char: {
                pattern: /`(?:\\`|\\?[^`]{1,2})`/,
                // using {1,2} instead of `u` flag for compatibility
                alias: 'rune'
            }
        });
        Prism.languages.insertBefore('v', 'operator', {
            attribute: {
                pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
                lookbehind: true,
                alias: 'annotation',
                inside: {
                    punctuation: /[\[\]]/,
                    keyword: /\w+/
                }
            },
            generic: {
                pattern: /<\w+>(?=\s*[\)\{])/,
                inside: {
                    punctuation: /[<>]/,
                    'class-name': /\w+/
                }
            }
        });
        Prism.languages.insertBefore('v', 'function', {
            'generic-function': {
                // e.g. foo<T>( ...
                pattern: /\b\w+\s*<\w+>(?=\()/,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<\w+>/,
                        inside: Prism.languages.v.generic.inside
                    }
                }
            }
        });
    })(Prism);
}

},{}],"6zZnL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = vala;
vala.displayName = 'vala';
vala.aliases = [];
function vala(Prism) {
    Prism.languages.vala = Prism.languages.extend('clike', {
        // Classes copied from prism-csharp
        'class-name': [
            {
                // (Foo bar, Bar baz)
                pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // [Foo]
                pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo : Bar
                pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo
                pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        ],
        keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
        function: /\b\w+(?=\s*\()/,
        number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
        punctuation: /[{}[\];(),.:]/,
        constant: /\b[A-Z0-9_]+\b/
    });
    Prism.languages.insertBefore('vala', 'string', {
        'raw-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        'template-string': {
            pattern: /@"[\s\S]*?"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
                    inside: {
                        delimiter: {
                            pattern: /^\$\(?|\)$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.vala
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('vala', 'keyword', {
        regex: {
            pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\//,
                'regex-flags': /^[a-z]+$/
            }
        }
    });
}

},{}],"c4GSa":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = velocity;
velocity.displayName = 'velocity';
velocity.aliases = [];
function velocity(Prism) {
    (function(Prism) {
        Prism.languages.velocity = Prism.languages.extend('markup', {});
        var velocity = {
            variable: {
                pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
                lookbehind: true,
                inside: {} // See below
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            number: /\b\d+\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
            punctuation: /[(){}[\]:,.]/
        };
        velocity.variable.inside = {
            string: velocity['string'],
            function: {
                pattern: /([^\w-])[a-z][\w-]*(?=\()/,
                lookbehind: true
            },
            number: velocity['number'],
            boolean: velocity['boolean'],
            punctuation: velocity['punctuation']
        };
        Prism.languages.insertBefore('velocity', 'comment', {
            unparsed: {
                pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^#\[\[|\]\]#$/
                }
            },
            'velocity-comment': [
                {
                    pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                },
                {
                    pattern: /(^|[^\\])##.*/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                }
            ],
            directive: {
                pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
                        inside: {
                            punctuation: /[{}]/
                        }
                    },
                    rest: velocity
                }
            },
            variable: velocity['variable']
        });
        Prism.languages.velocity['tag'].inside['attr-value'].inside.rest = Prism.languages.velocity;
    })(Prism);
}

},{}],"a7zma":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = verilog;
verilog.displayName = 'verilog';
verilog.aliases = [];
function verilog(Prism) {
    Prism.languages.verilog = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'kernel-function': {
            // support for any kernel function (ex: $display())
            pattern: /\B\$\w+\b/,
            alias: 'property'
        },
        // support for user defined constants (ex: `define)
        constant: /\B`\w+\b/,
        function: /\b\w+(?=\()/,
        // support for verilog and system verilog keywords
        keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
        // bold highlighting for all verilog and system verilog logic blocks
        important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
        // support for time ticks, vectors, and real numbers
        number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
        operator: /[-+{}^~%*\/?=!<>&|]+/,
        punctuation: /[[\];(),.:]/
    };
}

},{}],"96UoI":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = vhdl;
vhdl.displayName = 'vhdl';
vhdl.aliases = [];
function vhdl(Prism) {
    Prism.languages.vhdl = {
        comment: /--.+/,
        // support for all logic vectors
        'vhdl-vectors': {
            pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
            alias: 'number'
        },
        // support for operator overloading included
        'quoted-function': {
            pattern: /"\S+?"(?=\()/,
            alias: 'function'
        },
        string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
        constant: /\b(?:library|use)\b/i,
        // support for predefined attributes included
        keyword: /\b(?:'active|'ascending|'base|'delayed|'driving|'driving_value|'event|'high|'image|'instance_name|'last_active|'last_event|'last_value|'left|'leftof|'length|'low|'path_name|'pos|'pred|'quiet|'range|'reverse_range|'right|'rightof|'simple_name|'stable|'succ|'transaction|'val|'value|access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|wait|when|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\w+(?=\()/,
        // decimal, based, physical, and exponential numbers supported
        number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
        operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
        punctuation: /[{}[\];(),.:]/
    };
}

},{}],"1kBKi":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = vim;
vim.displayName = 'vim';
vim.aliases = [];
function vim(Prism) {
    Prism.languages.vim = {
        string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
        comment: /".*/,
        function: /\b\w+(?=\()/,
        keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
        builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
        punctuation: /[{}[\](),;:]/
    };
}

},{}],"8phG0":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visualBasic;
visualBasic.displayName = 'visualBasic';
visualBasic.aliases = [];
function visualBasic(Prism) {
    Prism.languages['visual-basic'] = {
        comment: {
            pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
            inside: {
                keyword: /^REM/i
            }
        },
        directive: {
            pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
            alias: 'property',
            greedy: true
        },
        string: {
            pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
            greedy: true
        },
        date: {
            pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
            alias: 'number'
        },
        number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
        boolean: /\b(?:False|Nothing|True)\b/i,
        keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
        operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
        punctuation: /[{}().,:?]/
    };
    Prism.languages.vb = Prism.languages['visual-basic'];
    Prism.languages.vba = Prism.languages['visual-basic'];
}

},{}],"e1IQ2":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = warpscript;
warpscript.displayName = 'warpscript';
warpscript.aliases = [];
function warpscript(Prism) {
    Prism.languages.warpscript = {
        comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
            greedy: true
        },
        variable: /\$\S+/,
        macro: {
            pattern: /@\S+/,
            alias: 'property'
        },
        // WarpScript doesn't have any keywords, these are all functions under the control category
        // https://www.warp10.io/tags/control
        keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
        number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
        boolean: /\b(?:F|T|false|true)\b/,
        punctuation: /<%|%>|[{}[\]()]/,
        // Some operators from the "operators" category
        // https://www.warp10.io/tags/operators
        operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
    };
}

},{}],"c2Qkx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = wasm;
wasm.displayName = 'wasm';
wasm.aliases = [];
function wasm(Prism) {
    Prism.languages.wasm = {
        comment: [
            /\(;[\s\S]*?;\)/,
            {
                pattern: /;;.*/,
                greedy: true
            }
        ],
        string: {
            pattern: /"(?:\\[\s\S]|[^"\\])*"/,
            greedy: true
        },
        keyword: [
            {
                pattern: /\b(?:align|offset)=/,
                inside: {
                    operator: /=/
                }
            },
            {
                pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
                inside: {
                    punctuation: /\./
                }
            },
            /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
        ],
        variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
        number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
        punctuation: /[()]/
    };
}

},{}],"6g72f":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = webIdl;
webIdl.displayName = 'webIdl';
webIdl.aliases = [];
function webIdl(Prism) {
    (function(Prism) {
        var id = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source;
        var type = '(?:' + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + '|' + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + '|' + /(?!(?:unrestricted|unsigned)\b)/.source + id + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ')' + /(?:\s*\?)?/.source;
        var typeInside = {};
        Prism.languages['web-idl'] = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            namespace: {
                pattern: RegExp(/(\bnamespace\s+)/.source + id),
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // callback return type
                    pattern: RegExp('(' + /\bcallback\s+/.source + id + /\s*=\s*/.source + ')' + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // typedef
                    pattern: RegExp(/(\btypedef\b\s*)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + id),
                    lookbehind: true
                },
                {
                    // inheritance
                    pattern: RegExp(/(:\s*)/.source + id),
                    lookbehind: true
                },
                RegExp(id + /(?=\s+(?:implements|includes)\b)/.source),
                {
                    pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + id),
                    lookbehind: true
                },
                {
                    // function return type, parameter types, and dictionary members
                    pattern: RegExp(type + '(?=' + /\s*(?:\.{3}\s*)?/.source + id + /\s*[(),;=]/.source + ')'),
                    inside: typeInside
                }
            ],
            builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
            keyword: [
                /\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/,
                /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/
            ],
            boolean: /\b(?:false|true)\b/,
            number: {
                pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
                lookbehind: true
            },
            operator: /\.{3}|[=:?<>-]/,
            punctuation: /[(){}[\].,;]/
        };
        for(var key in Prism.languages['web-idl'])if (key !== 'class-name') typeInside[key] = Prism.languages['web-idl'][key];
        Prism.languages['webidl'] = Prism.languages['web-idl'];
    })(Prism);
}

},{}],"dHrPm":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = wiki;
wiki.displayName = 'wiki';
wiki.aliases = [];
function wiki(Prism) {
    Prism.languages.wiki = Prism.languages.extend('markup', {
        'block-comment': {
            pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
            lookbehind: true,
            alias: 'comment'
        },
        heading: {
            pattern: /^(=+)[^=\r\n].*?\1/m,
            inside: {
                punctuation: /^=+|=+$/,
                important: /.+/
            }
        },
        emphasis: {
            // TODO Multi-line
            pattern: /('{2,5}).+?\1/,
            inside: {
                'bold-italic': {
                    pattern: /(''''').+?(?=\1)/,
                    lookbehind: true,
                    alias: [
                        'bold',
                        'italic'
                    ]
                },
                bold: {
                    pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                italic: {
                    pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                punctuation: /^''+|''+$/
            }
        },
        hr: {
            pattern: /^-{4,}/m,
            alias: 'punctuation'
        },
        url: [
            /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i,
            /\[\[.+?\]\]|\[.+?\]/
        ],
        variable: [
            /__[A-Z]+__/,
            // {{formatnum:{{#expr:{{{3}}}}}}}
            /\{{3}.+?\}{3}/,
            /\{\{.+?\}\}/
        ],
        symbol: [
            /^#redirect/im,
            /~{3,5}/
        ],
        // Handle table attrs:
        // {|
        // ! style="text-align:left;"| Item
        // |}
        'table-tag': {
            pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
            lookbehind: true,
            inside: {
                'table-bar': {
                    pattern: /\|$/,
                    alias: 'punctuation'
                },
                rest: Prism.languages.markup['tag'].inside
            }
        },
        punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
    });
    Prism.languages.insertBefore('wiki', 'tag', {
        // Prevent highlighting inside <nowiki>, <source> and <pre> tags
        nowiki: {
            pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
            inside: {
                tag: {
                    pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
                    inside: Prism.languages.markup['tag'].inside
                }
            }
        }
    });
}

},{}],"5E7AF":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = wolfram;
wolfram.displayName = 'wolfram';
wolfram.aliases = [
    'mathematica',
    'wl',
    'nb'
];
function wolfram(Prism) {
    Prism.languages.wolfram = {
        // Allow one level of nesting - note: regex taken from applescipt
        comment: /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
        context: {
            pattern: /\b\w+`+\w*/,
            alias: 'class-name'
        },
        blank: {
            pattern: /\b\w+_\b/,
            alias: 'regex'
        },
        'global-variable': {
            pattern: /\$\w+/,
            alias: 'variable'
        },
        boolean: /\b(?:False|True)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
        operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\^|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.mathematica = Prism.languages.wolfram;
    Prism.languages.wl = Prism.languages.wolfram;
    Prism.languages.nb = Prism.languages.wolfram;
}

},{}],"1WTsd":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = wren;
wren.displayName = 'wren';
wren.aliases = [];
function wren(Prism) {
    // https://wren.io/
    Prism.languages.wren = {
        // Multiline comments in Wren can have nested multiline comments
        // Comments: // and /* */
        comment: [
            {
                // support 3 levels of nesting
                // regex: \/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\/
                pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        // Triple quoted strings are multiline but cannot have interpolation (raw strings)
        // Based on prism-python.js
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        // see below
        'string-literal': null,
        // #!/usr/bin/env wren on the first line
        hashbang: {
            pattern: /^#!\/.+/,
            greedy: true,
            alias: 'comment'
        },
        // Attributes are special keywords to add meta data to classes
        attribute: {
            // #! attributes are stored in class properties
            // #!myvar = true
            // #attributes are not stored and dismissed at compilation
            pattern: /#!?[ \t\u3000]*\w+/,
            alias: 'keyword'
        },
        'class-name': [
            {
                // class definition
                // class Meta {}
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            // File.read
            /\b[A-Z][a-z\d_]*\b/
        ],
        // A constant can be a variable, class, property or method. Just named in all uppercase letters
        constant: /\b[A-Z][A-Z\d_]*\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        // Functions can be Class.method()
        function: /\b[a-z_]\w*(?=\s*[({])/i,
        operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
        punctuation: /[\[\](){}.,;]/
    };
    Prism.languages.wren['string-literal'] = {
        // A single quote string is multiline and can have interpolation (similar to JS backticks ``)
        pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
        lookbehind: true,
        greedy: true,
        inside: {
            interpolation: {
                // "%(interpolation)"
                pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /^(%\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: Prism.languages.wren
                    },
                    'interpolation-punctuation': {
                        pattern: /^%\(|\)$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: /[\s\S]+/
        }
    };
}

},{}],"4Gw4C":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = xeora;
xeora.displayName = 'xeora';
xeora.aliases = [
    'xeoracube'
];
function xeora(Prism) {
    (function(Prism) {
        Prism.languages.xeora = Prism.languages.extend('markup', {
            constant: {
                pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
                inside: {
                    punctuation: {
                        pattern: /\$/
                    }
                }
            },
            variable: {
                pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[$.]/
                    },
                    operator: {
                        pattern: /#+|[-+*~=^@]/
                    }
                }
            },
            'function-inline': {
                pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
                inside: {
                    variable: {
                        pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
                        inside: {
                            punctuation: {
                                pattern: /[,.|]/
                            },
                            operator: {
                                pattern: /#+|[-+*~=^@]/
                            }
                        }
                    },
                    punctuation: {
                        pattern: /\$\w:|[$:?.,|]/
                    }
                },
                alias: 'function'
            },
            'function-block': {
                pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
                inside: {
                    punctuation: {
                        pattern: /[$:{}?.,|]/
                    }
                },
                alias: 'function'
            },
            'directive-inline': {
                pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    }
                },
                alias: 'function'
            },
            'directive-block-open': {
                pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    },
                    attribute: {
                        pattern: /![A-Z]+$/,
                        inside: {
                            punctuation: {
                                pattern: /!/
                            }
                        },
                        alias: 'keyword'
                    }
                },
                alias: 'function'
            },
            'directive-block-separator': {
                pattern: /\}:[-\w.]+:\{/,
                inside: {
                    punctuation: {
                        pattern: /[:{}]/
                    }
                },
                alias: 'function'
            },
            'directive-block-close': {
                pattern: /\}:[-\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[:{}$]/
                    }
                },
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            variable: Prism.languages.xeora['function-inline'].inside['variable']
        }, Prism.languages.xeora['function-block']);
        Prism.languages.xeoracube = Prism.languages.xeora;
    })(Prism);
}

},{}],"eFhWq":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = xmlDoc;
xmlDoc.displayName = 'xmlDoc';
xmlDoc.aliases = [];
function xmlDoc(Prism) {
    (function(Prism) {
        /**
     * If the given language is present, it will insert the given doc comment grammar token into it.
     *
     * @param {string} lang
     * @param {any} docComment
     */ function insertDocComment(lang, docComment) {
            if (Prism.languages[lang]) Prism.languages.insertBefore(lang, 'comment', {
                'doc-comment': docComment
            });
        }
        var tag = Prism.languages.markup.tag;
        var slashDocComment = {
            pattern: /\/\/\/.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        var tickDocComment = {
            pattern: /'''.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        insertDocComment('csharp', slashDocComment);
        insertDocComment('fsharp', slashDocComment);
        insertDocComment('vbnet', tickDocComment);
    })(Prism);
}

},{}],"ilCAK":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = xojo;
xojo.displayName = 'xojo';
xojo.aliases = [];
function xojo(Prism) {
    Prism.languages.xojo = {
        comment: {
            pattern: /(?:'|\/\/|Rem\b).+/i,
            greedy: true
        },
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        number: [
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
            /&[bchou][a-z\d]+/i
        ],
        directive: {
            pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
            alias: 'property'
        },
        keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
        operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
        punctuation: /[.,;:()]/
    };
}

},{}],"22IQU":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = xquery;
xquery.displayName = 'xquery';
xquery.aliases = [];
function xquery(Prism) {
    (function(Prism) {
        Prism.languages.xquery = Prism.languages.extend('markup', {
            'xquery-comment': {
                pattern: /\(:[\s\S]*?:\)/,
                greedy: true,
                alias: 'comment'
            },
            string: {
                pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
                greedy: true
            },
            extension: {
                pattern: /\(#.+?#\)/,
                alias: 'symbol'
            },
            variable: /\$[-\w:]+/,
            axis: {
                pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
                lookbehind: true,
                alias: 'operator'
            },
            'keyword-operator': {
                pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
                lookbehind: true,
                alias: 'operator'
            },
            keyword: {
                pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
                lookbehind: true
            },
            function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
            'xquery-element': {
                pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'tag'
            },
            'xquery-attribute': {
                pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'attr-name'
            },
            builtin: {
                pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
                lookbehind: true
            },
            number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
            operator: [
                /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
                {
                    pattern: /(\s)-(?=\s)/,
                    lookbehind: true
                }
            ],
            punctuation: /[[\](){},;:/]/
        });
        Prism.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/;
        Prism.languages.xquery['tag'].inside['attr-value'].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['punctuation'] = /^="|"$/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['expression'] = {
            // Allow for two levels of nesting
            pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
            inside: Prism.languages.xquery,
            alias: 'language-xquery'
        } // The following will handle plain text inside tags
        ;
        var stringifyToken = function(token) {
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{' && // Ignore `{{`
                    (!tokens[i + 1] || tokens[i + 1].type !== 'punctuation' || tokens[i + 1].content !== '{') && (!tokens[i - 1] || tokens[i - 1].type !== 'plain-text' || tokens[i - 1].content !== '{')) // Here we might have entered an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else if (token.type !== 'comment') notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside an XQuery expression.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token) // And merge text with adjacent text
                        ;
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        if (/^\s+$/.test(plainText)) tokens[i] = plainText;
                        else tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'xquery') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}

},{}],"b2VmG":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = yang;
yang.displayName = 'yang';
yang.aliases = [];
function yang(Prism) {
    Prism.languages.yang = {
        // https://tools.ietf.org/html/rfc6020#page-34
        // http://www.yang-central.org/twiki/bin/view/Main/YangExamples
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
            greedy: true
        },
        keyword: {
            pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
            lookbehind: true
        },
        namespace: {
            pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
            lookbehind: true
        },
        boolean: /\b(?:false|true)\b/,
        operator: /\+/,
        punctuation: /[{};:]/
    };
}

},{}],"1Az8c":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = zig;
zig.displayName = 'zig';
zig.aliases = [];
function zig(Prism) {
    (function(Prism) {
        function literal(str) {
            return function() {
                return str;
            };
        }
        var keyword = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/;
        var IDENTIFIER = '\\b(?!' + keyword.source + ')(?!\\d)\\w+\\b';
        var ALIGN = /align\s*\((?:[^()]|\([^()]*\))*\)/.source;
        var PREFIX_TYPE_OP = /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(/<ALIGN>/g, literal(ALIGN));
        var SUFFIX_EXPR = /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(/<ID>/g, literal(IDENTIFIER));
        var TYPE = '(?!\\s)(?:!?\\s*(?:' + PREFIX_TYPE_OP + '\\s*)*' + SUFFIX_EXPR + ')+';
        /*
     * A simplified grammar for Zig compile time type literals:
     *
     * TypeExpr = ( "!"? PREFIX_TYPE_OP* SUFFIX_EXPR )+
     *
     * SUFFIX_EXPR = ( \b "promise" \b | ( \b "error" "." )? IDENTIFIER ( "." IDENTIFIER )* (?! \s+ IDENTIFIER ) )
     *
     * PREFIX_TYPE_OP = "?"
     *                | \b "promise" "->"
     *                | ( "[" [^\[\]]* "]" | "*" | "**" ) ( ALIGN | "const" \b | "volatile" \b | "allowzero" \b )*
     *
     * ALIGN = "align" "(" ( [^()] | "(" [^()]* ")" )* ")"
     *
     * IDENTIFIER = \b (?! KEYWORD ) [a-zA-Z_] \w* \b
     *
     */ Prism.languages.zig = {
            comment: [
                {
                    pattern: /\/\/[/!].*/,
                    alias: 'doc-comment'
                },
                /\/{2}.*/
            ],
            string: [
                {
                    // "string" and c"string"
                    pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // multiline strings and c-strings
                    pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            char: {
                // characters 'a', '\n', '\xFF', '\u{10FFFF}'
                pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
                lookbehind: true,
                greedy: true
            },
            builtin: /\B@(?!\d)\w+(?=\s*\()/,
            label: {
                pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
                lookbehind: true
            },
            'class-name': [
                // const Foo = struct {};
                /\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/,
                {
                    // const x: i32 = 9;
                    // var x: Bar;
                    // fn foo(x: bool, y: f32) void {}
                    pattern: RegExp(/(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    // extern fn foo(x: f64) f64; (optional alignment)
                    pattern: RegExp(/(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            'builtin-type': {
                pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
                alias: 'keyword'
            },
            keyword: keyword,
            function: /\b(?!\d)\w+(?=\s*\()/,
            number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
            punctuation: /[.:,;(){}[\]]/
        };
        Prism.languages.zig['class-name'].forEach(function(obj) {
            if (obj.inside === null) obj.inside = Prism.languages.zig;
        });
    })(Prism);
}

},{}],"iW0ht":[function(require,module,exports,__globalThis) {
//
// This file has been auto-generated by the `npm run build-languages-prism` task
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    'abap',
    'abnf',
    'actionscript',
    'ada',
    'agda',
    'al',
    'antlr4',
    'apacheconf',
    'apex',
    'apl',
    'applescript',
    'aql',
    'arduino',
    'arff',
    'asciidoc',
    'asm6502',
    'asmatmel',
    'aspnet',
    'autohotkey',
    'autoit',
    'avisynth',
    'avro-idl',
    'bash',
    'basic',
    'batch',
    'bbcode',
    'bicep',
    'birb',
    'bison',
    'bnf',
    'brainfuck',
    'brightscript',
    'bro',
    'bsl',
    'c',
    'cfscript',
    'chaiscript',
    'cil',
    'clike',
    'clojure',
    'cmake',
    'cobol',
    'coffeescript',
    'concurnas',
    'coq',
    'cpp',
    'crystal',
    'csharp',
    'cshtml',
    'csp',
    'css-extras',
    'css',
    'csv',
    'cypher',
    'd',
    'dart',
    'dataweave',
    'dax',
    'dhall',
    'diff',
    'django',
    'dns-zone-file',
    'docker',
    'dot',
    'ebnf',
    'editorconfig',
    'eiffel',
    'ejs',
    'elixir',
    'elm',
    'erb',
    'erlang',
    'etlua',
    'excel-formula',
    'factor',
    'false',
    'firestore-security-rules',
    'flow',
    'fortran',
    'fsharp',
    'ftl',
    'gap',
    'gcode',
    'gdscript',
    'gedcom',
    'gherkin',
    'git',
    'glsl',
    'gml',
    'gn',
    'go-module',
    'go',
    'graphql',
    'groovy',
    'haml',
    'handlebars',
    'haskell',
    'haxe',
    'hcl',
    'hlsl',
    'hoon',
    'hpkp',
    'hsts',
    'http',
    'ichigojam',
    'icon',
    'icu-message-format',
    'idris',
    'iecst',
    'ignore',
    'inform7',
    'ini',
    'io',
    'j',
    'java',
    'javadoc',
    'javadoclike',
    'javascript',
    'javastacktrace',
    'jexl',
    'jolie',
    'jq',
    'js-extras',
    'js-templates',
    'jsdoc',
    'json',
    'json5',
    'jsonp',
    'jsstacktrace',
    'jsx',
    'julia',
    'keepalived',
    'keyman',
    'kotlin',
    'kumir',
    'kusto',
    'latex',
    'latte',
    'less',
    'lilypond',
    'liquid',
    'lisp',
    'livescript',
    'llvm',
    'log',
    'lolcode',
    'lua',
    'magma',
    'makefile',
    'markdown',
    'markup-templating',
    'markup',
    'matlab',
    'maxscript',
    'mel',
    'mermaid',
    'mizar',
    'mongodb',
    'monkey',
    'moonscript',
    'n1ql',
    'n4js',
    'nand2tetris-hdl',
    'naniscript',
    'nasm',
    'neon',
    'nevod',
    'nginx',
    'nim',
    'nix',
    'nsis',
    'objectivec',
    'ocaml',
    'opencl',
    'openqasm',
    'oz',
    'parigp',
    'parser',
    'pascal',
    'pascaligo',
    'pcaxis',
    'peoplecode',
    'perl',
    'php-extras',
    'php',
    'phpdoc',
    'plsql',
    'powerquery',
    'powershell',
    'processing',
    'prolog',
    'promql',
    'properties',
    'protobuf',
    'psl',
    'pug',
    'puppet',
    'pure',
    'purebasic',
    'purescript',
    'python',
    'q',
    'qml',
    'qore',
    'qsharp',
    'r',
    'racket',
    'reason',
    'regex',
    'rego',
    'renpy',
    'rest',
    'rip',
    'roboconf',
    'robotframework',
    'ruby',
    'rust',
    'sas',
    'sass',
    'scala',
    'scheme',
    'scss',
    'shell-session',
    'smali',
    'smalltalk',
    'smarty',
    'sml',
    'solidity',
    'solution-file',
    'soy',
    'sparql',
    'splunk-spl',
    'sqf',
    'sql',
    'squirrel',
    'stan',
    'stylus',
    'swift',
    'systemd',
    't4-cs',
    't4-templating',
    't4-vb',
    'tap',
    'tcl',
    'textile',
    'toml',
    'tremor',
    'tsx',
    'tt2',
    'turtle',
    'twig',
    'typescript',
    'typoscript',
    'unrealscript',
    'uorazor',
    'uri',
    'v',
    'vala',
    'vbnet',
    'velocity',
    'verilog',
    'vhdl',
    'vim',
    'visual-basic',
    'warpscript',
    'wasm',
    'web-idl',
    'wiki',
    'wolfram',
    'wren',
    'xeora',
    'xml-doc',
    'xojo',
    'xquery',
    'yaml',
    'yang',
    'zig'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"goW8x":[function(require,module,exports,__globalThis) {
// The following is a One Dark theme that can be used with react-syntax-highlighter
//  Example usage:
//  import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
//  import codeTheme from './code'
//  <SyntaxHighlighter language="javascript" style={codeTheme}>
//    {`const foo = 'bar'`}
//  </SyntaxHighlighter>
//
// Source: https://github.com/react-syntax-highlighter/react-syntax-highlighter/blob/master/src/styles/prism/one-dark.js
// You can find more theemes here: https://github.com/react-syntax-highlighter/react-syntax-highlighter/blob/master/src/styles/prism/
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const codeTheme = {
    'code[class*="language-"]': {
        background: 'hsl(220, 13%, 18%)',
        color: 'hsl(220, 14%, 71%)',
        textShadow: '0 1px rgba(0, 0, 0, 0.3)',
        fontFamily: '"Roboto Mono"',
        direction: 'ltr',
        textAlign: 'left',
        whiteSpace: 'pre',
        wordSpacing: 'normal',
        wordBreak: 'normal',
        lineHeight: '1.5',
        MozTabSize: '2',
        OTabSize: '2',
        tabSize: '2',
        WebkitHyphens: 'none',
        MozHyphens: 'none',
        msHyphens: 'none',
        hyphens: 'none'
    },
    'pre[class*="language-"]': {
        background: 'hsl(220, 13%, 18%)',
        color: 'hsl(220, 14%, 71%)',
        textShadow: '0 1px rgba(0, 0, 0, 0.3)',
        fontFamily: '"Roboto Mono"',
        direction: 'ltr',
        textAlign: 'left',
        whiteSpace: 'pre',
        wordSpacing: 'normal',
        wordBreak: 'normal',
        lineHeight: '1.5',
        MozTabSize: '2',
        OTabSize: '2',
        tabSize: '2',
        WebkitHyphens: 'none',
        MozHyphens: 'none',
        msHyphens: 'none',
        hyphens: 'none',
        padding: '1em',
        margin: '0.5em 0',
        overflow: 'auto',
        borderRadius: '0.3em'
    },
    'code[class*="language-"]::-moz-selection': {
        background: 'hsl(220, 13%, 28%)',
        color: 'inherit',
        textShadow: 'none'
    },
    'code[class*="language-"] *::-moz-selection': {
        background: 'hsl(220, 13%, 28%)',
        color: 'inherit',
        textShadow: 'none'
    },
    'pre[class*="language-"] *::-moz-selection': {
        background: 'hsl(220, 13%, 28%)',
        color: 'inherit',
        textShadow: 'none'
    },
    'code[class*="language-"]::selection': {
        background: 'hsl(220, 13%, 28%)',
        color: 'inherit',
        textShadow: 'none'
    },
    'code[class*="language-"] *::selection': {
        background: 'hsl(220, 13%, 28%)',
        color: 'inherit',
        textShadow: 'none'
    },
    'pre[class*="language-"] *::selection': {
        background: 'hsl(220, 13%, 28%)',
        color: 'inherit',
        textShadow: 'none'
    },
    ':not(pre) > code[class*="language-"]': {
        padding: '0.2em 0.3em',
        borderRadius: '0.3em',
        whiteSpace: 'normal'
    },
    comment: {
        color: 'hsl(220, 10%, 40%)',
        fontStyle: 'italic'
    },
    prolog: {
        color: 'hsl(220, 10%, 40%)'
    },
    cdata: {
        color: 'hsl(220, 10%, 40%)'
    },
    doctype: {
        color: 'hsl(220, 14%, 71%)'
    },
    punctuation: {
        color: 'hsl(220, 14%, 71%)'
    },
    entity: {
        color: 'hsl(220, 14%, 71%)',
        cursor: 'help'
    },
    'attr-name': {
        color: 'hsl(29, 54%, 61%)'
    },
    'class-name': {
        color: 'hsl(29, 54%, 61%)'
    },
    boolean: {
        color: 'hsl(29, 54%, 61%)'
    },
    constant: {
        color: 'hsl(29, 54%, 61%)'
    },
    number: {
        color: 'hsl(29, 54%, 61%)'
    },
    atrule: {
        color: 'hsl(29, 54%, 61%)'
    },
    keyword: {
        color: 'hsl(286, 60%, 67%)'
    },
    property: {
        color: 'hsl(355, 65%, 65%)'
    },
    tag: {
        color: 'hsl(355, 65%, 65%)'
    },
    symbol: {
        color: 'hsl(355, 65%, 65%)'
    },
    deleted: {
        color: 'hsl(355, 65%, 65%)'
    },
    important: {
        color: 'hsl(355, 65%, 65%)'
    },
    selector: {
        color: 'hsl(95, 38%, 62%)'
    },
    string: {
        color: 'hsl(95, 38%, 62%)'
    },
    char: {
        color: 'hsl(95, 38%, 62%)'
    },
    builtin: {
        color: 'hsl(95, 38%, 62%)'
    },
    inserted: {
        color: 'hsl(95, 38%, 62%)'
    },
    regex: {
        color: 'hsl(95, 38%, 62%)'
    },
    'attr-value': {
        color: 'hsl(95, 38%, 62%)'
    },
    'attr-value > .token.punctuation': {
        color: 'hsl(95, 38%, 62%)'
    },
    variable: {
        color: 'hsl(207, 82%, 66%)'
    },
    operator: {
        color: 'hsl(207, 82%, 66%)'
    },
    function: {
        color: 'hsl(207, 82%, 66%)'
    },
    url: {
        color: 'hsl(187, 47%, 55%)'
    },
    'attr-value > .token.punctuation.attr-equals': {
        color: 'hsl(220, 14%, 71%)'
    },
    'special-attr > .token.attr-value > .token.value.css': {
        color: 'hsl(220, 14%, 71%)'
    },
    '.language-css .token.selector': {
        color: 'hsl(355, 65%, 65%)'
    },
    '.language-css .token.property': {
        color: 'hsl(220, 14%, 71%)'
    },
    '.language-css .token.function': {
        color: 'hsl(187, 47%, 55%)'
    },
    '.language-css .token.url > .token.function': {
        color: 'hsl(187, 47%, 55%)'
    },
    '.language-css .token.url > .token.string.url': {
        color: 'hsl(95, 38%, 62%)'
    },
    '.language-css .token.important': {
        color: 'hsl(286, 60%, 67%)'
    },
    '.language-css .token.atrule .token.rule': {
        color: 'hsl(286, 60%, 67%)'
    },
    '.language-javascript .token.operator': {
        color: 'hsl(286, 60%, 67%)'
    },
    '.language-javascript .token.template-string > .token.interpolation > .token.interpolation-punctuation.punctuation': {
        color: 'hsl(5, 48%, 51%)'
    },
    '.language-json .token.operator': {
        color: 'hsl(220, 14%, 71%)'
    },
    '.language-json .token.null.keyword': {
        color: 'hsl(29, 54%, 61%)'
    },
    '.language-markdown .token.url': {
        color: 'hsl(220, 14%, 71%)'
    },
    '.language-markdown .token.url > .token.operator': {
        color: 'hsl(220, 14%, 71%)'
    },
    '.language-markdown .token.url-reference.url > .token.string': {
        color: 'hsl(220, 14%, 71%)'
    },
    '.language-markdown .token.url > .token.content': {
        color: 'hsl(207, 82%, 66%)'
    },
    '.language-markdown .token.url > .token.url': {
        color: 'hsl(187, 47%, 55%)'
    },
    '.language-markdown .token.url-reference.url': {
        color: 'hsl(187, 47%, 55%)'
    },
    '.language-markdown .token.blockquote.punctuation': {
        color: 'hsl(220, 10%, 40%)',
        fontStyle: 'italic'
    },
    '.language-markdown .token.hr.punctuation': {
        color: 'hsl(220, 10%, 40%)',
        fontStyle: 'italic'
    },
    '.language-markdown .token.code-snippet': {
        color: 'hsl(95, 38%, 62%)'
    },
    '.language-markdown .token.bold .token.content': {
        color: 'hsl(29, 54%, 61%)'
    },
    '.language-markdown .token.italic .token.content': {
        color: 'hsl(286, 60%, 67%)'
    },
    '.language-markdown .token.strike .token.content': {
        color: 'hsl(355, 65%, 65%)'
    },
    '.language-markdown .token.strike .token.punctuation': {
        color: 'hsl(355, 65%, 65%)'
    },
    '.language-markdown .token.list.punctuation': {
        color: 'hsl(355, 65%, 65%)'
    },
    '.language-markdown .token.title.important > .token.punctuation': {
        color: 'hsl(355, 65%, 65%)'
    },
    bold: {
        fontWeight: 'bold'
    },
    italic: {
        fontStyle: 'italic'
    },
    namespace: {
        opacity: '0.8'
    },
    'token.tab:not(:empty):before': {
        color: 'hsla(220, 14%, 71%, 0.15)',
        textShadow: 'none'
    },
    'token.cr:before': {
        color: 'hsla(220, 14%, 71%, 0.15)',
        textShadow: 'none'
    },
    'token.lf:before': {
        color: 'hsla(220, 14%, 71%, 0.15)',
        textShadow: 'none'
    },
    'token.space:before': {
        color: 'hsla(220, 14%, 71%, 0.15)',
        textShadow: 'none'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item': {
        marginRight: '0.4em'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item > button': {
        background: 'hsl(220, 13%, 26%)',
        color: 'hsl(220, 9%, 55%)',
        padding: '0.1em 0.4em',
        borderRadius: '0.3em'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item > a': {
        background: 'hsl(220, 13%, 26%)',
        color: 'hsl(220, 9%, 55%)',
        padding: '0.1em 0.4em',
        borderRadius: '0.3em'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item > span': {
        background: 'hsl(220, 13%, 26%)',
        color: 'hsl(220, 9%, 55%)',
        padding: '0.1em 0.4em',
        borderRadius: '0.3em'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item > button:hover': {
        background: 'hsl(220, 13%, 28%)',
        color: 'hsl(220, 14%, 71%)'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item > button:focus': {
        background: 'hsl(220, 13%, 28%)',
        color: 'hsl(220, 14%, 71%)'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item > a:hover': {
        background: 'hsl(220, 13%, 28%)',
        color: 'hsl(220, 14%, 71%)'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item > a:focus': {
        background: 'hsl(220, 13%, 28%)',
        color: 'hsl(220, 14%, 71%)'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item > span:hover': {
        background: 'hsl(220, 13%, 28%)',
        color: 'hsl(220, 14%, 71%)'
    },
    'div.code-toolbar > .toolbar.toolbar > .toolbar-item > span:focus': {
        background: 'hsl(220, 13%, 28%)',
        color: 'hsl(220, 14%, 71%)'
    },
    '.line-highlight.line-highlight': {
        background: 'hsla(220, 100%, 80%, 0.04)'
    },
    '.line-highlight.line-highlight:before': {
        background: 'hsl(220, 13%, 26%)',
        color: 'hsl(220, 14%, 71%)',
        padding: '0.1em 0.6em',
        borderRadius: '0.3em',
        boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.2)'
    },
    '.line-highlight.line-highlight[data-end]:after': {
        background: 'hsl(220, 13%, 26%)',
        color: 'hsl(220, 14%, 71%)',
        padding: '0.1em 0.6em',
        borderRadius: '0.3em',
        boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.2)'
    },
    'pre[id].linkable-line-numbers.linkable-line-numbers span.line-numbers-rows > span:hover:before': {
        backgroundColor: 'hsla(220, 100%, 80%, 0.04)'
    },
    '.line-numbers.line-numbers .line-numbers-rows': {
        borderRightColor: 'hsla(220, 14%, 71%, 0.15)'
    },
    '.command-line .command-line-prompt': {
        borderRightColor: 'hsla(220, 14%, 71%, 0.15)'
    },
    '.line-numbers .line-numbers-rows > span:before': {
        color: 'hsl(220, 14%, 45%)'
    },
    '.command-line .command-line-prompt > span:before': {
        color: 'hsl(220, 14%, 45%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-1': {
        color: 'hsl(355, 65%, 65%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-5': {
        color: 'hsl(355, 65%, 65%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-9': {
        color: 'hsl(355, 65%, 65%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-2': {
        color: 'hsl(95, 38%, 62%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-6': {
        color: 'hsl(95, 38%, 62%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-10': {
        color: 'hsl(95, 38%, 62%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-3': {
        color: 'hsl(207, 82%, 66%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-7': {
        color: 'hsl(207, 82%, 66%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-11': {
        color: 'hsl(207, 82%, 66%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-4': {
        color: 'hsl(286, 60%, 67%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-8': {
        color: 'hsl(286, 60%, 67%)'
    },
    '.rainbow-braces .token.token.punctuation.brace-level-12': {
        color: 'hsl(286, 60%, 67%)'
    },
    'pre.diff-highlight > code .token.token.deleted:not(.prefix)': {
        backgroundColor: 'hsla(353, 100%, 66%, 0.15)'
    },
    'pre > code.diff-highlight .token.token.deleted:not(.prefix)': {
        backgroundColor: 'hsla(353, 100%, 66%, 0.15)'
    },
    'pre.diff-highlight > code .token.token.deleted:not(.prefix)::-moz-selection': {
        backgroundColor: 'hsla(353, 95%, 66%, 0.25)'
    },
    'pre.diff-highlight > code .token.token.deleted:not(.prefix) *::-moz-selection': {
        backgroundColor: 'hsla(353, 95%, 66%, 0.25)'
    },
    'pre > code.diff-highlight .token.token.deleted:not(.prefix)::-moz-selection': {
        backgroundColor: 'hsla(353, 95%, 66%, 0.25)'
    },
    'pre > code.diff-highlight .token.token.deleted:not(.prefix) *::-moz-selection': {
        backgroundColor: 'hsla(353, 95%, 66%, 0.25)'
    },
    'pre.diff-highlight > code .token.token.deleted:not(.prefix)::selection': {
        backgroundColor: 'hsla(353, 95%, 66%, 0.25)'
    },
    'pre.diff-highlight > code .token.token.deleted:not(.prefix) *::selection': {
        backgroundColor: 'hsla(353, 95%, 66%, 0.25)'
    },
    'pre > code.diff-highlight .token.token.deleted:not(.prefix)::selection': {
        backgroundColor: 'hsla(353, 95%, 66%, 0.25)'
    },
    'pre > code.diff-highlight .token.token.deleted:not(.prefix) *::selection': {
        backgroundColor: 'hsla(353, 95%, 66%, 0.25)'
    },
    'pre.diff-highlight > code .token.token.inserted:not(.prefix)': {
        backgroundColor: 'hsla(137, 100%, 55%, 0.15)'
    },
    'pre > code.diff-highlight .token.token.inserted:not(.prefix)': {
        backgroundColor: 'hsla(137, 100%, 55%, 0.15)'
    },
    'pre.diff-highlight > code .token.token.inserted:not(.prefix)::-moz-selection': {
        backgroundColor: 'hsla(135, 73%, 55%, 0.25)'
    },
    'pre.diff-highlight > code .token.token.inserted:not(.prefix) *::-moz-selection': {
        backgroundColor: 'hsla(135, 73%, 55%, 0.25)'
    },
    'pre > code.diff-highlight .token.token.inserted:not(.prefix)::-moz-selection': {
        backgroundColor: 'hsla(135, 73%, 55%, 0.25)'
    },
    'pre > code.diff-highlight .token.token.inserted:not(.prefix) *::-moz-selection': {
        backgroundColor: 'hsla(135, 73%, 55%, 0.25)'
    },
    'pre.diff-highlight > code .token.token.inserted:not(.prefix)::selection': {
        backgroundColor: 'hsla(135, 73%, 55%, 0.25)'
    },
    'pre.diff-highlight > code .token.token.inserted:not(.prefix) *::selection': {
        backgroundColor: 'hsla(135, 73%, 55%, 0.25)'
    },
    'pre > code.diff-highlight .token.token.inserted:not(.prefix)::selection': {
        backgroundColor: 'hsla(135, 73%, 55%, 0.25)'
    },
    'pre > code.diff-highlight .token.token.inserted:not(.prefix) *::selection': {
        backgroundColor: 'hsla(135, 73%, 55%, 0.25)'
    },
    '.prism-previewer.prism-previewer:before': {
        borderColor: 'hsl(224, 13%, 17%)'
    },
    '.prism-previewer-gradient.prism-previewer-gradient div': {
        borderColor: 'hsl(224, 13%, 17%)',
        borderRadius: '0.3em'
    },
    '.prism-previewer-color.prism-previewer-color:before': {
        borderRadius: '0.3em'
    },
    '.prism-previewer-easing.prism-previewer-easing:before': {
        borderRadius: '0.3em'
    },
    '.prism-previewer.prism-previewer:after': {
        borderTopColor: 'hsl(224, 13%, 17%)'
    },
    '.prism-previewer-flipped.prism-previewer-flipped.after': {
        borderBottomColor: 'hsl(224, 13%, 17%)'
    },
    '.prism-previewer-angle.prism-previewer-angle:before': {
        background: 'hsl(219, 13%, 22%)'
    },
    '.prism-previewer-time.prism-previewer-time:before': {
        background: 'hsl(219, 13%, 22%)'
    },
    '.prism-previewer-easing.prism-previewer-easing': {
        background: 'hsl(219, 13%, 22%)'
    },
    '.prism-previewer-angle.prism-previewer-angle circle': {
        stroke: 'hsl(220, 14%, 71%)',
        strokeOpacity: '1'
    },
    '.prism-previewer-time.prism-previewer-time circle': {
        stroke: 'hsl(220, 14%, 71%)',
        strokeOpacity: '1'
    },
    '.prism-previewer-easing.prism-previewer-easing circle': {
        stroke: 'hsl(220, 14%, 71%)',
        fill: 'transparent'
    },
    '.prism-previewer-easing.prism-previewer-easing path': {
        stroke: 'hsl(220, 14%, 71%)'
    },
    '.prism-previewer-easing.prism-previewer-easing line': {
        stroke: 'hsl(220, 14%, 71%)'
    }
};
exports.default = codeTheme;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"44DTp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _container = require("@mui/material/Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _form = require("./Form");
class ErrorBoundary extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            error: undefined
        };
        this.handleOK = this.handleOK.bind(this);
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            error: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    async handleOK() {
        this.props.navigate(-1);
        // This is a workaround to avoid a setState before the navigation is complete
        // Which would cause the error-component to be re-rendered and the error to be thrown a second time
        await new Promise((resolve)=>setTimeout(resolve, 500));
        this.setState({
            error: undefined
        });
    }
    render() {
        if (this.state.error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ErrorDetails, {
            error: this.state.error.error,
            errorInfo: this.state.error.errorInfo,
            onOKButtonClicked: this.handleOK
        });
        return this.props.children;
    }
}
const ErrorDetails = ({ error, errorInfo, onOKButtonClicked })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _containerDefault.default), {
        component: "main",
        maxWidth: "xs",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "h2",
                    variant: "h2",
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "h2",
                    variant: "body2",
                    children: error.toString()
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("details", {
                    open: false,
                    style: {
                        whiteSpace: 'pre-wrap'
                    },
                    children: errorInfo.componentStack
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: onOKButtonClicked,
                    variant: "contained",
                    color: "primary",
                    sx: (0, _form.styles).button,
                    children: "OK"
                })
            ]
        })
    });
};
const withNavigate = (Component)=>{
    return function WrappedComponent(props) {
        const navigate = (0, _reactRouter.useNavigate)();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ...props,
            navigate: navigate
        });
    };
};
exports.default = withNavigate(ErrorBoundary);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","@mui/material/Container":"376wa","@mui/material/Typography":"6NtGx","@mui/material/Button":"3qJY9","./Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Mui7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Autocomplete", ()=>(0, _autocompleteDefault.default));
parcelHelpers.export(exports, "ButtonsPane", ()=>(0, _buttonsPaneDefault.default));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkboxDefault.default));
parcelHelpers.export(exports, "GridItem", ()=>(0, _gridItemDefault.default));
parcelHelpers.export(exports, "Paper", ()=>(0, _paperDefault.default));
parcelHelpers.export(exports, "SafeRouting", ()=>(0, _safeRoutingDefault.default));
parcelHelpers.export(exports, "Select", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "TextInput", ()=>(0, _textInputDefault.default));
parcelHelpers.export(exports, "DatePicker", ()=>(0, _datePickerDefault.default));
parcelHelpers.export(exports, "ErrorFocus", ()=>(0, _errorFocusDefault.default));
parcelHelpers.export(exports, "RHF", ()=>(0, _rhfDefault.default));
parcelHelpers.export(exports, "Form", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "FormProps", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "styles", ()=>(0, _styles.styles));
var _autocomplete = require("./Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _buttonsPane = require("./ButtonsPane");
var _buttonsPaneDefault = parcelHelpers.interopDefault(_buttonsPane);
var _checkbox = require("./Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _gridItem = require("./GridItem");
var _gridItemDefault = parcelHelpers.interopDefault(_gridItem);
var _paper = require("./Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _safeRouting = require("./SafeRouting");
var _safeRoutingDefault = parcelHelpers.interopDefault(_safeRouting);
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _textInput = require("./TextInput");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _datePicker = require("./DatePicker");
var _datePickerDefault = parcelHelpers.interopDefault(_datePicker);
var _errorFocus = require("./ErrorFocus");
var _errorFocusDefault = parcelHelpers.interopDefault(_errorFocus);
var _rhf = require("./RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
var _form = require("./Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _styles = require("./styles");

},{"./Autocomplete":"hV3MZ","./ButtonsPane":"19HZv","./Checkbox":"74c5k","./GridItem":"hSZf2","./Paper":"J2E2j","./SafeRouting":"gP5uG","./Select":"42YaD","./TextInput":"1xLso","./DatePicker":"izm8y","./ErrorFocus":"gR4dx","./RHF":"7gFt3","./Form":"6xuCU","./styles":"dg9GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hV3MZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _autocomplete = require("@mui/material/Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _debounce = require("lodash/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _gridItem = require("../GridItem");
var _gridItemDefault = parcelHelpers.interopDefault(_gridItem);
var _utils = require("../../../../utils");
const Comp = /*#__PURE__*/ (0, _react.forwardRef)(({ field, ...props }, ref)=>{
    const muiProps = {
        ...props,
        ref
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteDefault.default), {
        ...muiProps
    });
});
const FormAutocomplete = (props)=>{
    const { required = false, xs, newLine, label, name, groupBy, autoSelect, disableClearable, defaultOption, api, onChange, onClear, getOptionValue, optionComparator, getOptionDisabled, tooltip, comment, commentProps, allowCustomOptions, validateFn, ...restProps } = props;
    const { setValue: setFieldValue, getFieldState, formState } = (0, _reactHookForm.useFormContext)();
    const type = 'type' in restProps && restProps.type || undefined;
    const multiple = 'multiple' in restProps && restProps.multiple;
    const filterSelectedOptions = 'filterSelectedOptions' in restProps && restProps.filterSelectedOptions;
    const extraValidators = 'validators' in restProps ? restProps.validators : undefined;
    const componentProps = (0, _omitDefault.default)(restProps, [
        'validators',
        'filterSelectedOptions',
        'type'
    ]);
    const validators = extraValidators ?? {};
    validators.presence = required;
    const initialized = (0, _react.useRef)(false);
    const isMounted = (0, _react.useRef)(false);
    const [value, setValue] = (0, _react.useState)(defaultOption || (multiple ? [] : null));
    const [inputValue, setInputValue] = (0, _react.useState)(defaultOption && !multiple ? props.getOptionLabel(defaultOption) : '');
    const [options, setOptions] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [apiSearchFilter, setApiSearchFilter] = (0, _react.useState)(undefined);
    const doClear = ()=>{
        setApiSearchFilter('');
        onClear?.();
    };
    const hasError = formState.errors[name] !== undefined || getFieldState(name)?.error !== undefined;
    const fetch = (0, _react.useCallback)(async (filter)=>{
        const { items } = await api({
            pageNumber: '0',
            rowsPerPage: '500',
            filter
        });
        if (isMounted.current) {
            setOptions(items);
            setIsLoading(false);
        }
        initialized.current = true;
    }, [
        api
    ]);
    const debouncedFetch = (0, _react.useCallback)((0, _debounceDefault.default)(fetch, 500), [
        fetch
    ]);
    (0, _react.useEffect)(()=>{
        isMounted.current = true;
        setOptions([]);
        setIsLoading(true);
        if (initialized.current) debouncedFetch(apiSearchFilter);
        else {
            const value = defaultOption ? getOptionValue(defaultOption) : null;
            if (value !== null) setFieldValue(name, value);
            fetch(apiSearchFilter);
        }
        return ()=>{
            isMounted.current = false;
        };
    }, [
        apiSearchFilter,
        fetch,
        debouncedFetch
    ]);
    const selectOption = (option)=>{
        const newValue = multiple ? option : option ? getOptionValue(option) : null;
        setFieldValue(name, newValue, {
            shouldTouch: true,
            shouldValidate: true
        });
        setValue(option);
        onChange?.(newValue);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridItemDefault.default), {
        xs: xs,
        newLine: newLine,
        tooltip: tooltip,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
            margin: "normal",
            fullWidth: true,
            id: `autocomplete-${name}`,
            "data-is-loading": isLoading,
            "data-num-options": options.length,
            "data-selected-value": value,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                    name: name,
                    rules: {
                        validate: validateFn || (0, _utils.validate)(validators)
                    },
                    render: ({ field: { ref } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
                            ref: ref,
                            groupBy: groupBy,
                            autoSelect: autoSelect,
                            filterSelectedOptions: filterSelectedOptions,
                            disableClearable: disableClearable,
                            value: value,
                            defaultValue: defaultOption,
                            inputValue: inputValue,
                            options: options,
                            freeSolo: allowCustomOptions,
                            loading: isLoading,
                            isOptionEqualToValue: optionComparator,
                            getOptionDisabled: getOptionDisabled,
                            onChange: (_, newOption)=>{
                                selectOption(newOption);
                            },
                            onInputChange: (_, newInputValue, reason)=>{
                                if (reason === 'clear') doClear();
                                setInputValue(newInputValue);
                            },
                            renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                    ...params,
                                    name: name,
                                    type: type,
                                    label: label || (0, _upperFirstDefault.default)(name),
                                    variant: "outlined",
                                    required: required,
                                    error: hasError,
                                    onWheel: type === 'number' ? (e)=>e.target instanceof HTMLElement && e.target.blur() : undefined,
                                    onChange: (e)=>{
                                        setApiSearchFilter(e.target.value);
                                    },
                                    onBlur: ()=>{
                                        if (!autoSelect && allowCustomOptions && !multiple && inputValue) selectOption(inputValue);
                                        else if (inputValue === '' || !value) doClear();
                                    },
                                    slotProps: {
                                        htmlInput: {
                                            ...params.inputProps,
                                            autoComplete: 'off'
                                        }
                                    }
                                }),
                            ...componentProps
                        })
                }),
                hasError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
                    error: true,
                    children: getFieldState(name)?.error?.message
                }),
                !hasError && comment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
                    sx: commentProps ?? {},
                    variant: "filled",
                    children: comment
                })
            ]
        })
    });
};
exports.default = FormAutocomplete;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-hook-form":"8z0aI","@mui/material/FormControl":"ioFZ4","@mui/material/Autocomplete":"avdFA","@mui/material/TextField":"l88b4","@mui/material/FormHelperText":"9uvlb","lodash/debounce":"1hVPi","lodash/omit":"fhxvC","lodash/upperFirst":"eSJZa","../GridItem":"hSZf2","../../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8z0aI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Controller", ()=>Controller);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "FormProvider", ()=>FormProvider);
parcelHelpers.export(exports, "appendErrors", ()=>appendErrors);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "useController", ()=>useController);
parcelHelpers.export(exports, "useFieldArray", ()=>useFieldArray);
parcelHelpers.export(exports, "useForm", ()=>useForm);
parcelHelpers.export(exports, "useFormContext", ()=>useFormContext);
parcelHelpers.export(exports, "useFormState", ()=>useFormState);
parcelHelpers.export(exports, "useWatch", ()=>useWatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var isCheckBoxInput = (element)=>element.type === 'checkbox';
var isDateObject = (value1)=>value1 instanceof Date;
var isNullOrUndefined = (value1)=>value1 == null;
const isObjectType = (value1)=>typeof value1 === 'object';
var isObject = (value1)=>!isNullOrUndefined(value1) && !Array.isArray(value1) && isObjectType(value1) && !isDateObject(value1);
var getEventValue = (event)=>isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var isNameInFieldArray = (names, name)=>names.has(getNodeParentName(name));
var isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!(isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var isUndefined = (val)=>val === undefined;
var get = (object, path, defaultValue)=>{
    if (!path || !isObject(object)) return defaultValue;
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key)=>isNullOrUndefined(result) ? result : result[key], object);
    return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var isBoolean = (value1)=>typeof value1 === 'boolean';
var isKey = (value1)=>/^\w*$/.test(value1);
var stringToPath = (input)=>compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var set = (object, path, value1)=>{
    let index = -1;
    const tempPath = isKey(path) ? [
        path
    ] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const HookFormContext = (0, _reactDefault.default).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const useFormContext = ()=>(0, _reactDefault.default).useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const FormProvider = (props)=>{
    const { children, ...data } = props;
    return (0, _reactDefault.default).createElement(HookFormContext.Provider, {
        value: data
    }, children);
};
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var isEmptyObject = (value1)=>isObject(value1) && !Object.keys(value1).length;
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function useSubscribe(props) {
    const _props = (0, _reactDefault.default).useRef(props);
    _props.current = props;
    (0, _reactDefault.default).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = (0, _reactDefault.default).useState(control._formState);
    const _mounted = (0, _reactDefault.default).useRef(true);
    const _localProxyFormState = (0, _reactDefault.default).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, _reactDefault.default).useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value1)=>_mounted.current && shouldSubscribeByName(_name.current, value1.name, exact) && shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, _reactDefault.default).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return (0, _reactDefault.default).useMemo(()=>getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var isString = (value1)=>typeof value1 === 'string';
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact } = props || {};
    const _name = (0, _reactDefault.default).useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if (shouldSubscribeByName(_name.current, formState.name, exact)) updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, _reactDefault.default).useState(control._getWatch(name, defaultValue));
    (0, _reactDefault.default).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function useController(props) {
    const methods = useFormContext();
    const { name, disabled, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value1 = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = useFormState({
        control,
        name,
        exact: true
    });
    const _registerProps = (0, _reactDefault.default).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    const fieldState = (0, _reactDefault.default).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!get(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!get(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!get(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!get(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>get(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const field = (0, _reactDefault.default).useMemo(()=>({
            name,
            value: value1,
            ...isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (event)=>_registerProps.current.onChange({
                    target: {
                        value: getEventValue(event),
                        name: name
                    },
                    type: EVENTS.CHANGE
                }),
            onBlur: ()=>_registerProps.current.onBlur({
                    target: {
                        value: get(control._formValues, name),
                        name: name
                    },
                    type: EVENTS.BLUR
                }),
            ref: (elm)=>{
                const field = get(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        }), [
        name,
        control._formValues,
        disabled,
        formState.disabled,
        value1,
        control._fields
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = get(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value1);
            if (isUndefined(get(control._formValues, name))) set(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        control._updateDisabledField({
            disabled,
            fields: control._fields,
            name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, _reactDefault.default).useMemo(()=>({
            field,
            formState,
            fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const Controller = (props)=>props.render(useController(props));
const flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if (isObjectType(obj[key]) && obj[key] !== null) {
        const nested = flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = (0, _reactDefault.default).useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data,
                event,
                method,
                formData,
                formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type
            });
        }
    };
    (0, _reactDefault.default).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, render({
        submit
    })) : (0, _reactDefault.default).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var appendErrors = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var generateId = ()=>{
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var getFocusFieldName = (name, index, options = {})=>options.shouldFocus || isUndefined(options.shouldFocus) ? options.focusName || `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
        isOnBlur: mode === VALIDATION_MODE.onBlur,
        isOnChange: mode === VALIDATION_MODE.onChange,
        isOnAll: mode === VALIDATION_MODE.all,
        isOnTouch: mode === VALIDATION_MODE.onTouched
    });
var isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if (iterateFieldsByAction(currentField, action)) break;
                }
            } else if (isObject(currentField)) {
                if (iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
var updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = convertToArrayPayload(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};
var isFileInput = (element)=>element.type === 'file';
var isFunction = (value1)=>typeof value1 === 'function';
var isHTMLElement = (value1)=>{
    if (!isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMessage = (value1)=>isString(value1);
var isRadioInput = (element)=>element.type === 'radio';
var isRegex = (value1)=>value1 instanceof RegExp;
const defaultResult = {
    value: false,
    isValid: false
};
const validResult = {
    value: true,
    isValid: true
};
var getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === '' ? validResult : {
            value: options[0].value,
            isValid: true
        } : validResult : defaultResult;
    }
    return defaultResult;
};
const defaultReturn = {
    isValid: false,
    value: null
};
var getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, defaultReturn) : defaultReturn;
function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) return {
        type,
        message: isMessage(result) ? result : '',
        ref
    };
}
var getValueAndMessage = (validationData)=>isObject(validationData) && !isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
        const { value: value1, message } = isMessage(required) ? {
            value: !!required,
            message: required
        } : getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if (isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if (isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var appendAt = (data, value1)=>[
        ...data,
        ...convertToArrayPayload(value1)
    ];
var fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if (isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var prependAt = (data, value1)=>[
        ...convertToArrayPayload(value1),
        ...convertToArrayPayload(data)
    ];
function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index)=>isUndefined(index) ? [] : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b)=>a - b));
var swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) return false;
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path) ? path : isKey(path) ? [
        path
    ] : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) unset(object, paths.slice(0, -1));
    return object;
}
var updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, rules } = props;
    const [fields, setFields] = (0, _reactDefault.default).useState(control._getFieldArray(name));
    const ids = (0, _reactDefault.default).useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = (0, _reactDefault.default).useRef(fields);
    const _name = (0, _reactDefault.default).useRef(name);
    const _actioned = (0, _reactDefault.default).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    rules && control.register(name, rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, _reactDefault.default).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = appendAt(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, appendAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prependAt(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prependAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray(get(control._fields, name)) && set(control._fields, name, undefined);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = cloneObject(value1);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value1));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, _reactDefault.default).useEffect(()=>{
        control._state.action = false;
        isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = get(result.errors, name);
                const existingError = get(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? set(control._formState.errors, name, error) : unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = get(control._fields, name);
                if (field && field._f && !(getValidationModes(control._options.reValidateMode).isOnSubmit && getValidationModes(control._options.mode).isOnSubmit)) validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!isEmptyObject(error) && control._subjects.state.next({
                        errors: updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        !get(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, _reactDefault.default).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, _reactDefault.default).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, _reactDefault.default).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, _reactDefault.default).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, _reactDefault.default).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, _reactDefault.default).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, _reactDefault.default).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, _reactDefault.default).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, _reactDefault.default).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe
    };
};
var isPrimitive = (value1)=>isNullOrUndefined(value1) || !isObjectType(value1);
function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) return object1 === object2;
    if (isDateObject(object1) && isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var isMultipleSelect = (element)=>element.type === `select-multiple`;
var isRadioOrCheckbox = (ref)=>isRadioInput(ref) || isCheckBoxInput(ref);
var live = (ref)=>isHTMLElement(ref) && ref.isConnected;
var objectHasFunction = (data)=>{
    for(const key in data){
        if (isFunction(data[key])) return true;
    }
    return false;
};
function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            markFieldsDirty(data[key], fields[key]);
        } else if (!isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
            if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : {
                ...markFieldsDirty(data[key])
            };
            else getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues)=>getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
var getFieldValueAs = (value1, { valueAsNumber, valueAsDate, setValueAs })=>isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function getFieldValue(_f) {
    const ref = _f.ref;
    if (isFileInput(ref)) return ref.files;
    if (isRadioInput(ref)) return getRadioValue(_f.refs).value;
    if (isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if (isCheckBoxInput(ref)) return getCheckboxValue(_f.refs).value;
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields,
        shouldUseNativeValidation
    };
};
var getRuleValue = (rule)=>isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
const ASYNC_FUNCTION = 'AsyncFunction';
var hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!(isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === ASYNC_FUNCTION || isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === ASYNC_FUNCTION));
var hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) return {
        error,
        name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name
    };
}
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var unsetEmptyArray = (ref, name)=>!compact(get(ref, name)).length && unset(ref, name);
const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject()
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? set(_formState.validatingFields, name, isValidating) : unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else set(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value1) ? get(_defaultValues, name) : value1);
            isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name
        };
        if (!_options.disabled) {
            const disabledField = !!(get(_fields, name) && get(_fields, name)._f && get(_fields, name)._f.disabled);
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
                isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
                isCurrentFieldPristine || disabledField ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = get(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    set(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && isBoolean(isValid) ? {
                    isValid
                } : {},
                errors: _formState.errors,
                name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = get(errors, name);
            error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
                }
                !isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = get(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!live(ref)) : !live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>compact(get(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = get(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value1, fieldReference));
                fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value1) ? '' : value1;
                if (isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if (isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) || isObject(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value1);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name,
                dirtyFields: getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? getFieldValue(field._f) : getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || deepEqual(fieldValue, get(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid) {
                    if (_options.mode === 'onBlur' && isBlurEvent) _updateValid();
                    else if (!isBlurEvent) _updateValid();
                }
                return shouldRender && _subjects.state.next({
                    name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>get(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name
            },
            ..._options.resolver || !name ? {
                isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map((name)=>get(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!get((formState || _formState).errors, name),
            isDirty: !!get((formState || _formState).dirtyFields, name),
            error: get((formState || _formState).errors, name),
            isValidating: !!get(_formState.validatingFields, name),
            isTouched: !!get((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && convertToArrayPayload(name).forEach((inputName)=>unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = (get(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = get(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message, type, ...restOfErrorTree } = currentError;
        set(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled, name, field, fields })=>{
        if (isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
            updateTouchAndDirty(name, getFieldValue(field ? field._f : get(fields, name)._f), false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled) || isBoolean(_options.disabled);
        set(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name
                    }
                },
                name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field,
            disabled: isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: getRuleValue(options.min),
                max: getRuleValue(options.max),
                minLength: getRuleValue(options.minLength),
                maxLength: getRuleValue(options.maxLength),
                pattern: getRuleValue(options.pattern)
            } : {},
            name,
            onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter(live),
                                    fieldRef,
                                    ...Array.isArray(get(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = get(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if (isBoolean(disabled)) {
            _subjects.state.next({
                disabled
            });
            iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = get(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = cloneObject(_formValues);
            if (_names.disabled.size) for (const name of _names.disabled)set(fieldValues, name, undefined);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            unset(_formState.errors, 'root');
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) setValue(name, cloneObject(get(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject(get(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const isEmptyResetValues = isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys(getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))get(_formState.dirtyFields, fieldName) ? set(values, fieldName, get(_formValues, fieldName)) : setValue(fieldName, get(values, fieldName));
            } else {
                if (isWeb && isUndefined(formValues)) for (const name of _names.mount){
                    const field = get(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if (isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _updateDisabledField,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _disableForm,
            _subjects,
            _proxyFormState,
            _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function useForm(props = {}) {
    const _formControl = (0, _reactDefault.default).useRef(undefined);
    const _values = (0, _reactDefault.default).useRef(undefined);
    const [formState, updateFormState] = (0, _reactDefault.default).useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...createFormControl(props),
        formState
    };
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if (shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, _reactDefault.default).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, _reactDefault.default).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avdFA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("176d405f922312cb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    createFilterOptions: true,
    autocompleteClasses: true
};
Object.defineProperty(exports, "autocompleteClasses", {
    enumerable: true,
    get: function() {
        return _autocompleteClasses.default;
    }
});
Object.defineProperty(exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
        return _Autocomplete.createFilterOptions;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Autocomplete.default;
    }
});
var _Autocomplete = _interopRequireWildcard(require("84d037bee1d4f363"));
var _autocompleteClasses = _interopRequireWildcard(require("62c722db4e56fc52"));
Object.keys(_autocompleteClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _autocompleteClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _autocompleteClasses[key];
        }
    });
});

},{"176d405f922312cb":"fiRIh","84d037bee1d4f363":"6dwgW","62c722db4e56fc52":"kBLtO"}],"6dwgW":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("6eee293760969598").default;
var _interopRequireDefault = require("1aeff36b5bcda90f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
        return _useAutocomplete.createFilterOptions;
    }
});
exports.default = void 0;
var React = _interopRequireWildcard(require("cc512c89003c6d50"));
var _propTypes = _interopRequireDefault(require("737dcd84b6e1555f"));
var _clsx = _interopRequireDefault(require("9f404e08e46b67e5"));
var _integerPropType = _interopRequireDefault(require("6a651ff1dcd891d0"));
var _chainPropTypes = _interopRequireDefault(require("80991082c1f5b016"));
var _composeClasses = _interopRequireDefault(require("34474db4f49eee21"));
var _colorManipulator = require("4a3d6e749533556d");
var _useAutocomplete = _interopRequireWildcard(require("b42ac8639bb111"));
var _Popper = _interopRequireDefault(require("2fc46286b95b1942"));
var _ListSubheader = _interopRequireDefault(require("fb44b4899e7e7f09"));
var _Paper = _interopRequireDefault(require("bcf8efe7b62a5126"));
var _IconButton = _interopRequireDefault(require("b0474548c08e4152"));
var _Chip = _interopRequireDefault(require("99ba022613bc878a"));
var _inputClasses = _interopRequireDefault(require("cf7b976b6ffd77db"));
var _inputBaseClasses = _interopRequireDefault(require("fad4c170a8736986"));
var _outlinedInputClasses = _interopRequireDefault(require("fc4265804c8c485a"));
var _filledInputClasses = _interopRequireDefault(require("adba81072dab467f"));
var _Close = _interopRequireDefault(require("c5e5ee1133b40e8c"));
var _ArrowDropDown = _interopRequireDefault(require("4b31f90d8d8b0bee"));
var _zeroStyled = require("dda0f6b6dcac026");
var _memoTheme = _interopRequireDefault(require("58a281153b3f88a"));
var _DefaultPropsProvider = require("6136ec28366a6fb5");
var _autocompleteClasses = _interopRequireWildcard(require("792b549b2fa4a53a"));
var _capitalize = _interopRequireDefault(require("2eb91c3a8126d4cd"));
var _useSlot = _interopRequireDefault(require("51b106f383c41c25"));
var _jsxRuntime = require("fba01fc9a2d5e50a");
var _ClearIcon, _ArrowDropDownIcon;
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePortal, expanded, focused, fullWidth, hasClearIcon, hasPopupIcon, inputFocused, popupOpen, size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, _capitalize.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, _composeClasses.default)(slots, _autocompleteClasses.getAutocompleteUtilityClass, classes);
};
const AutocompleteRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { fullWidth, hasClearIcon, hasPopupIcon, inputFocused, size } = ownerState;
        return [
            {
                [`& .${_autocompleteClasses.default.tag}`]: styles.tag
            },
            {
                [`& .${_autocompleteClasses.default.tag}`]: styles[`tagSize${(0, _capitalize.default)(size)}`]
            },
            {
                [`& .${_autocompleteClasses.default.inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${_autocompleteClasses.default.input}`]: styles.input
            },
            {
                [`& .${_autocompleteClasses.default.input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${_autocompleteClasses.default.focused} .${_autocompleteClasses.default.clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${_autocompleteClasses.default.clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${_autocompleteClasses.default.tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${_autocompleteClasses.default.inputRoot}`]: {
        [`.${_autocompleteClasses.default.hasPopupIcon}&, .${_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${_autocompleteClasses.default.hasPopupIcon}.${_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${_autocompleteClasses.default.input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${_inputClasses.default.root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${_inputClasses.default.root}.${_inputBaseClasses.default.sizeSmall}`]: {
        [`& .${_inputClasses.default.input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${_outlinedInputClasses.default.root}`]: {
        padding: 9,
        [`.${_autocompleteClasses.default.hasPopupIcon}&, .${_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${_autocompleteClasses.default.hasPopupIcon}.${_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${_autocompleteClasses.default.input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${_autocompleteClasses.default.endAdornment}`]: {
            right: 9
        }
    },
    [`& .${_outlinedInputClasses.default.root}.${_inputBaseClasses.default.sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${_autocompleteClasses.default.input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${_filledInputClasses.default.root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${_autocompleteClasses.default.hasPopupIcon}&, .${_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${_autocompleteClasses.default.hasPopupIcon}.${_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${_filledInputClasses.default.input}`]: {
            padding: '7px 4px'
        },
        [`& .${_autocompleteClasses.default.endAdornment}`]: {
            right: 9
        }
    },
    [`& .${_filledInputClasses.default.root}.${_inputBaseClasses.default.sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${_filledInputClasses.default.input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${_inputBaseClasses.default.hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${_filledInputClasses.default.root}.${_inputBaseClasses.default.hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${_autocompleteClasses.default.input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${_filledInputClasses.default.root}.${_inputBaseClasses.default.hiddenLabel}.${_inputBaseClasses.default.sizeSmall}`]: {
        [`& .${_autocompleteClasses.default.input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${_autocompleteClasses.default.input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${_autocompleteClasses.default.tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${_autocompleteClasses.default.input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${_autocompleteClasses.default.inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const AutocompleteEndAdornment = (0, _zeroStyled.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment'
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const AutocompleteClearIndicator = (0, _zeroStyled.styled)(_IconButton.default, {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator'
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const AutocompletePopupIndicator = (0, _zeroStyled.styled)(_IconButton.default, {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const AutocompletePopper = (0, _zeroStyled.styled)(_Popper.default, {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_autocompleteClasses.default.option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const AutocompletePaper = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiAutocomplete',
    slot: 'Paper'
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const AutocompleteLoading = (0, _zeroStyled.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading'
})((0, _memoTheme.default)(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const AutocompleteNoOptions = (0, _zeroStyled.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions'
})((0, _memoTheme.default)(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const AutocompleteListbox = (0, _zeroStyled.styled)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox'
})((0, _memoTheme.default)(({ theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${_autocompleteClasses.default.option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${_autocompleteClasses.default.focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${_autocompleteClasses.default.focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${_autocompleteClasses.default.focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${_autocompleteClasses.default.focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    })));
const AutocompleteGroupLabel = (0, _zeroStyled.styled)(_ListSubheader.default, {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel'
})((0, _memoTheme.default)(({ theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const AutocompleteGroupUl = (0, _zeroStyled.styled)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl'
})({
    padding: 0,
    [`& .${_autocompleteClasses.default.option}`]: {
        paddingLeft: 24
    }
});
const Autocomplete = /*#__PURE__*/ React.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete = false, autoHighlight = false, autoSelect = false, blurOnSelect = false, ChipProps: ChipPropsProp, className, clearIcon = _ClearIcon || (_ClearIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Close.default, {
        fontSize: "small"
    })), clearOnBlur = !props.freeSolo, clearOnEscape = false, clearText = 'Clear', closeText = 'Close', componentsProps, defaultValue = props.multiple ? [] : null, disableClearable = false, disableCloseOnSelect = false, disabled = false, disabledItemsFocusable = false, disableListWrap = false, disablePortal = false, filterOptions, filterSelectedOptions = false, forcePopupIcon = 'auto', freeSolo = false, fullWidth = false, getLimitTagsText = (more)=>`+${more}`, getOptionDisabled, getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue, groupBy, handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList = false, inputValue: inputValueProp, limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading = false, loadingText = "Loading\u2026", multiple = false, noOptionsText = 'No options', onChange, onClose, onHighlightChange, onInputChange, onOpen, open, openOnFocus = false, openText = 'Open', options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon = _ArrowDropDownIcon || (_ArrowDropDownIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ArrowDropDown.default, {})), readOnly = false, renderGroup: renderGroupProp, renderInput, renderOption: renderOptionProp, renderTags, renderValue, selectOnFocus = !props.freeSolo, size = 'medium', slots = {}, slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps, getInputProps, getInputLabelProps, getPopupIndicatorProps, getClearProps, getItemProps, getListboxProps, getOptionProps, value, dirty, expanded, id, popupOpen, focused, focusedItem, anchorEl, setAnchorEl, inputValue, groupedOptions } = (0, _useAutocomplete.default)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal,
        expanded,
        focused,
        fullWidth,
        getOptionLabel,
        hasClearIcon,
        hasPopupIcon,
        inputFocused: focusedItem === -1,
        popupOpen,
        size
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, _useSlot.default)('listbox', {
        elementType: AutocompleteListbox,
        externalForwardedProps,
        ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, _useSlot.default)('paper', {
        elementType: _Paper.default,
        externalForwardedProps,
        ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, _useSlot.default)('popper', {
        elementType: _Popper.default,
        externalForwardedProps,
        ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    const getCustomizedItemProps = (params)=>({
            className: classes.tag,
            disabled,
            ...getItemProps(params)
        });
    if (renderTags && multiple && value.length > 0) startAdornment = renderTags(value, getCustomizedItemProps, ownerState);
    else if (renderValue && value) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
    else if (multiple && value.length > 0) startAdornment = value.map((option, index)=>{
        const { key, ...customItemProps } = getCustomizedItemProps({
            index
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Chip.default, {
            label: getOptionLabel(option),
            size: size,
            ...customItemProps,
            ...externalForwardedProps.slotProps.chip
        }, key);
    });
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option,
            index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index,
            inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteRoot, {
                ref: ref,
                className: (0, _clsx.default)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id,
                    disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, _clsx.default)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, _clsx.default)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled,
                        readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListboxSlot, {
                            as: ListboxComponentProp,
                            ...listboxProps,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
var _default = exports.default = Autocomplete;

},{"6eee293760969598":"fiRIh","1aeff36b5bcda90f":"kZ6eK","cc512c89003c6d50":"9njXz","737dcd84b6e1555f":"bnNSm","9f404e08e46b67e5":"d2NWs","6a651ff1dcd891d0":"iZJbi","80991082c1f5b016":"4stnp","34474db4f49eee21":"59Equ","4a3d6e749533556d":"hTYBL","b42ac8639bb111":"e1pVw","2fc46286b95b1942":"2EMLo","fb44b4899e7e7f09":"ldVLf","bcf8efe7b62a5126":"aexCI","b0474548c08e4152":"488As","99ba022613bc878a":"5cK8z","cf7b976b6ffd77db":"2rE1a","fad4c170a8736986":"7XvSk","fc4265804c8c485a":"dgsBP","adba81072dab467f":"eyL27","c5e5ee1133b40e8c":"alYeF","4b31f90d8d8b0bee":"kLz8E","dda0f6b6dcac026":"hZXDo","58a281153b3f88a":"cJNjb","6136ec28366a6fb5":"9bD8g","792b549b2fa4a53a":"kBLtO","2eb91c3a8126d4cd":"eOYSA","51b106f383c41c25":"h76AU","fba01fc9a2d5e50a":"1dlk8"}],"e1pVw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c470741452ca3b80").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
        return _useAutocomplete.createFilterOptions;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useAutocomplete.default;
    }
});
var _useAutocomplete = _interopRequireWildcard(require("287f8bc0699f7ba7"));

},{"c470741452ca3b80":"fiRIh","287f8bc0699f7ba7":"5DLY8"}],"5DLY8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
/* eslint-disable no-constant-condition */ var _interopRequireDefault = require("3903f4ae0aee3bec").default;
var _interopRequireWildcard = require("e3c968db865968d6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createFilterOptions = createFilterOptions;
exports.default = void 0;
var React = _interopRequireWildcard(require("9ccea00e1aacdcc7"));
var _setRef = _interopRequireDefault(require("4502fc78d70a4eb0"));
var _useEventCallback = _interopRequireDefault(require("d54b13f0a9ceeb04"));
var _useControlled = _interopRequireDefault(require("3a39c7bab4e6b317"));
var _useId = _interopRequireDefault(require("21f39755928cf58d"));
var _usePreviousProps = _interopRequireDefault(require("587115bfb1eeb765"));
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function createFilterOptions(config = {}) {
    const { ignoreAccents = true, ignoreCase = true, limit, matchFrom = 'any', stringify, trim = false } = config;
    return (options, { inputValue, getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const defaultFilterOptions = createFilterOptions();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const pageSize = 5;
const defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const MULTIPLE_DEFAULT_VALUE = [];
function getInputValue(value, multiple, getOptionLabel, renderValue) {
    if (multiple || value == null || renderValue) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function useAutocomplete(props) {
    const { // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = defaultIsActiveElementInListbox, // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete = false, autoHighlight = false, autoSelect = false, blurOnSelect = false, clearOnBlur = !props.freeSolo, clearOnEscape = false, componentName = 'useAutocomplete', defaultValue = props.multiple ? MULTIPLE_DEFAULT_VALUE : null, disableClearable = false, disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable = false, disableListWrap = false, filterOptions = defaultFilterOptions, filterSelectedOptions = false, freeSolo = false, getOptionDisabled, getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy, handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue = (option, value)=>option === value, multiple = false, onChange, onClose, onHighlightChange, onInputChange, onOpen, open: openProp, openOnFocus = false, options, readOnly = false, renderValue, selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, _useId.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = React.useRef(false);
    const firstFocus = React.useRef(true);
    const inputRef = React.useRef(null);
    const listboxRef = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [focusedItem, setFocusedItem] = React.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = React.useRef(defaultHighlighted);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = React.useRef(getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, _useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, _useControlled.default)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = React.useState(false);
    const resetInputValue = React.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = getInputValue(newValue, multiple, getOptionLabel, renderValue);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value,
        renderValue
    ]);
    const [open, setOpenState] = (0, _useControlled.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = React.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel
    }) : [];
    const previousProps = (0, _usePreviousProps.default)({
        filteredOptions,
        value,
        inputValue
    });
    React.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusItem = (0, _useEventCallback.default)((itemToFocus)=>{
        if (itemToFocus === -1) inputRef.current.focus();
        else {
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is gone.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            anchorEl.querySelector(`[${indexType}="${itemToFocus}"]`).focus();
        }
    });
    // Ensure the focusedItem is never inconsistent
    React.useEffect(()=>{
        if (multiple && focusedItem > value.length - 1) {
            setFocusedItem(-1);
            focusItem(-1);
        }
    }, [
        value,
        multiple,
        focusedItem,
        focusItem
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, _useEventCallback.default)(({ event, index, reason })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, _useEventCallback.default)(({ event, diff, direction = 'next', reason })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason,
            event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = React.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, _useEventCallback.default)((node)=>{
        (0, _setRef.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    React.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = React.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validItemIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is removed.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            const option = anchorEl.querySelector(`[${indexType}="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusItem = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextItem = focusedItem;
        if (focusedItem === -1) {
            if (inputValue === '' && direction === 'previous') nextItem = value.length - 1;
        } else {
            nextItem += direction === 'next' ? 1 : -1;
            if (nextItem < 0) nextItem = 0;
            if (nextItem === value.length) nextItem = -1;
        }
        nextItem = validItemIndex(nextItem, direction);
        setFocusedItem(nextItem);
        focusItem(nextItem);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedItem !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedItem(-1);
                focusItem(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    if (!multiple && renderValue) focusItem(0);
                    else handleFocusItem(event, 'previous');
                    break;
                case 'ArrowRight':
                    if (!multiple && renderValue) focusItem(-1);
                    else handleFocusItem(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0 || renderValue)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedItem === -1 ? value.length - 1 : focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly) {
                        setValueState(null);
                        focusItem(-1);
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedItem !== -1) {
                        const index = focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly) {
                        setValueState(null);
                        focusItem(-1);
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event,
            index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleItemDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handleSingleItemDelete = (event)=>{
        handleValue(event, null, 'removeOption', {
            option: value
        });
    };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index,
                group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getItemProps: ({ index = 0 } = {})=>({
                ...multiple && {
                    key: index
                },
                ...renderValue ? {
                    'data-item-index': index
                } : {
                    'data-tag-index': index
                },
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: multiple ? handleItemDelete(index) : handleSingleItemDelete
                }
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        // deprecated
        getTagProps: ({ index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleItemDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index, option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id,
        inputValue,
        value,
        dirty,
        expanded: popupOpen && anchorEl,
        popupOpen,
        focused: focused || focusedItem !== -1,
        anchorEl,
        setAnchorEl,
        focusedItem,
        // deprecated
        focusedTag: focusedItem,
        groupedOptions
    };
}
var _default = exports.default = useAutocomplete;

},{"3903f4ae0aee3bec":"kZ6eK","e3c968db865968d6":"fiRIh","9ccea00e1aacdcc7":"9njXz","4502fc78d70a4eb0":"8uRhj","d54b13f0a9ceeb04":"feNJe","3a39c7bab4e6b317":"jwZrv","21f39755928cf58d":"50qgI","587115bfb1eeb765":"kyeaf"}],"kyeaf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a95c2da9f238a956").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _usePreviousProps.default;
    }
});
var _usePreviousProps = _interopRequireDefault(require("92132870d40a39a7"));

},{"a95c2da9f238a956":"kZ6eK","92132870d40a39a7":"d1n3G"}],"d1n3G":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("1b54fa049a6e2001").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d98d45ec6822f19e"));
const usePreviousProps = (value)=>{
    const ref = React.useRef({});
    React.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var _default = exports.default = usePreviousProps;

},{"1b54fa049a6e2001":"fiRIh","d98d45ec6822f19e":"9njXz"}],"alYeF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("8dfb87f505fdd2a").default;
var _interopRequireWildcard = require("95a3ab9760542dc9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("3bb5bad97afa5dda"));
var _createSvgIcon = _interopRequireDefault(require("b815793dea65a3b8"));
var _jsxRuntime = require("2b1ab8cae0e106a4");
/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

},{"8dfb87f505fdd2a":"kZ6eK","95a3ab9760542dc9":"fiRIh","3bb5bad97afa5dda":"9njXz","b815793dea65a3b8":"5sni0","2b1ab8cae0e106a4":"1dlk8"}],"kBLtO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5c375e2322cab4d1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getAutocompleteUtilityClass = getAutocompleteUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4dc575f33ae32088"));
var _generateUtilityClass = _interopRequireDefault(require("823d37250124742c"));
function getAutocompleteUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiAutocomplete', slot);
}
const autocompleteClasses = (0, _generateUtilityClasses.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var _default = exports.default = autocompleteClasses;

},{"5c375e2322cab4d1":"kZ6eK","4dc575f33ae32088":"7pSUk","823d37250124742c":"jBs9M"}],"1hVPi":[function(require,module,exports,__globalThis) {
var isObject = require("3b174a999d6a40ac"), now = require("575b2317167ce20d"), toNumber = require("a13332670c5c0f63");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;

},{"3b174a999d6a40ac":"6hgJK","575b2317167ce20d":"fizKQ","a13332670c5c0f63":"3MLIQ"}],"fizKQ":[function(require,module,exports,__globalThis) {
var root = require("6439589d9d88d885");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
module.exports = now;

},{"6439589d9d88d885":"gVq56"}],"eSJZa":[function(require,module,exports,__globalThis) {
var createCaseFirst = require("9f71ec962d19127");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst('toUpperCase');
module.exports = upperFirst;

},{"9f71ec962d19127":"7uzpn"}],"7uzpn":[function(require,module,exports,__globalThis) {
var castSlice = require("6cc0e53be1623a5f"), hasUnicode = require("e28707473345265"), stringToArray = require("32980b84821a53a0"), toString = require("e00796f8e204e98");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = createCaseFirst;

},{"6cc0e53be1623a5f":"dqkKJ","e28707473345265":"6LhZ8","32980b84821a53a0":"e34IY","e00796f8e204e98":"iEDGT"}],"dqkKJ":[function(require,module,exports,__globalThis) {
var baseSlice = require("19fbc2ab8fa927cd");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

},{"19fbc2ab8fa927cd":"7H7oa"}],"6LhZ8":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"e34IY":[function(require,module,exports,__globalThis) {
var asciiToArray = require("55ec07d60faf873c"), hasUnicode = require("d3e31b390208b2ca"), unicodeToArray = require("2a468ebcd49732b9");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"55ec07d60faf873c":"8IriL","d3e31b390208b2ca":"6LhZ8","2a468ebcd49732b9":"8eM3H"}],"8IriL":[function(require,module,exports,__globalThis) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split('');
}
module.exports = asciiToArray;

},{}],"8eM3H":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [
    rsNonAstral + rsCombo + '?',
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"hSZf2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitGridProps", ()=>omitGridProps);
var _jsxRuntime = require("react/jsx-runtime");
var _omit = require("lodash/fp/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _tooltip = require("../Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
const classes = {
    divider: {
        width: '100%',
        borderColor: 'transparent'
    },
    tooltip: {
        fontSize: (theme)=>theme.typography.body2.fontSize
    },
    icon: {
        marginLeft: 1,
        transform: 'translateY(3px)'
    }
};
const omitGridProps = (0, _omitDefault.default)([
    'xs',
    'lg',
    'xl',
    'newLine',
    'fullWidth',
    'tooltip'
]);
/**
 * Every field should be wrapped with this component. It provides with media query sizing, tooltip, and whether its field should always be on the new line
 * @param props
 */ const GridItem = (props)=>{
    const size = {
        xs: props.xs || 12,
        lg: props.lg || 6,
        xl: props.xl || 4
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            props.newLine && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                component: "div",
                light: true,
                sx: classes.divider
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                size: size,
                sx: props.sx,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        display: 'flex',
                        alignItems: 'center'
                    },
                    children: [
                        props.children,
                        !!props.tooltip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    whiteSpace: 'pre-line'
                                },
                                children: props.tooltip
                            }),
                            sx: {
                                tooltip: classes.tooltip
                            },
                            placement: "top",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                                sx: classes.icon
                            })
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = GridItem;

},{"react/jsx-runtime":"1dlk8","lodash/fp/omit":"lRr4P","@mui/material/Box":"c4QkF","@mui/material/Grid":"6iX4B","@mui/material/Divider":"9Ul8c","../Tooltip":"crjvg","@mui/icons-material/HelpOutline":"2sIqE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6iX4B":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ecc37ac6c85e3756").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    gridClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Grid.default;
    }
});
Object.defineProperty(exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return _gridClasses.default;
    }
});
var _Grid = _interopRequireWildcard(require("2aa31e8670e034a0"));
Object.keys(_Grid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _Grid[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Grid[key];
        }
    });
});
var _gridClasses = _interopRequireWildcard(require("905035b3d5582fb2"));
Object.keys(_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _gridClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _gridClasses[key];
        }
    });
});

},{"ecc37ac6c85e3756":"fiRIh","2aa31e8670e034a0":"iAJ5k","905035b3d5582fb2":"fndkX"}],"iAJ5k":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c02a84732d66f5d0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("2293f24980166054"));
var _Grid = require("131dadcf3dde7fca");
var _requirePropFactory = _interopRequireDefault(require("6eba10668975d82d"));
var _styles = require("d08eee30c4e64499");
var _DefaultPropsProvider = require("a5ea88c06bbb603d");
var _useTheme = _interopRequireDefault(require("66c4e150da0ca6b3"));
/**
 *
 * Demos:
 *
 * - [Grid](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/material-ui/api/grid/)
 */ const Grid = (0, _Grid.createGrid)({
    createStyledComponent: (0, _styles.styled)('div', {
        name: 'MuiGrid',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid',
    useThemeProps: (inProps)=>(0, _DefaultPropsProvider.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid'
        }),
    useTheme: _useTheme.default
});
var _default = exports.default = Grid;

},{"c02a84732d66f5d0":"kZ6eK","2293f24980166054":"bnNSm","131dadcf3dde7fca":"QCdeK","6eba10668975d82d":"9hSkv","d08eee30c4e64499":"2UrBk","a5ea88c06bbb603d":"9bD8g","66c4e150da0ca6b3":"7z5Ze"}],"QCdeK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("6777b5166885b68").default;
var _interopRequireDefault = require("dc5de09531151b42").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    createGrid: true,
    gridClasses: true,
    unstable_traverseBreakpoints: true,
    unstable_generateDirectionClasses: true,
    unstable_generateSizeClassNames: true,
    unstable_generateSpacingClassNames: true
};
Object.defineProperty(exports, "createGrid", {
    enumerable: true,
    get: function() {
        return _createGrid.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Grid.default;
    }
});
Object.defineProperty(exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return _gridClasses.default;
    }
});
Object.defineProperty(exports, "unstable_generateDirectionClasses", {
    enumerable: true,
    get: function() {
        return _gridGenerator.generateDirectionClasses;
    }
});
Object.defineProperty(exports, "unstable_generateSizeClassNames", {
    enumerable: true,
    get: function() {
        return _gridGenerator.generateSizeClassNames;
    }
});
Object.defineProperty(exports, "unstable_generateSpacingClassNames", {
    enumerable: true,
    get: function() {
        return _gridGenerator.generateSpacingClassNames;
    }
});
Object.defineProperty(exports, "unstable_traverseBreakpoints", {
    enumerable: true,
    get: function() {
        return _traverseBreakpoints.traverseBreakpoints;
    }
});
var _Grid = _interopRequireDefault(require("320cf288c543da5f"));
var _createGrid = _interopRequireDefault(require("413733bc76f4a166"));
var _GridProps = require("d3e7d1d8c00e22c6");
Object.keys(_GridProps).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _GridProps[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _GridProps[key];
        }
    });
});
var _gridClasses = _interopRequireWildcard(require("6b23f0b9dcef2b9e"));
Object.keys(_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _gridClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _gridClasses[key];
        }
    });
});
var _traverseBreakpoints = require("d27dd608fe81fc78");
var _gridGenerator = require("ac2be87bc31bb59a");

},{"6777b5166885b68":"fiRIh","dc5de09531151b42":"kZ6eK","320cf288c543da5f":"5IPqD","413733bc76f4a166":"h59v5","d3e7d1d8c00e22c6":"4O8ds","6b23f0b9dcef2b9e":"iyfkS","d27dd608fe81fc78":"hNkTG","ac2be87bc31bb59a":"jPfr0"}],"5IPqD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("287ce615845131d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("ebb64b749fbaa72d"));
var _createGrid = _interopRequireDefault(require("9224c13684dcebb2"));
/**
 *
 * Demos:
 *
 * - [Grid (Joy UI)](https://mui.com/joy-ui/react-grid/)
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */ const Grid = (0, _createGrid.default)();
var _default = exports.default = Grid;

},{"287ce615845131d":"kZ6eK","ebb64b749fbaa72d":"bnNSm","9224c13684dcebb2":"h59v5"}],"h59v5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5e8b8f8a87a74dab").default;
var _interopRequireWildcard = require("d6b880b32747cf81").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createGrid;
var React = _interopRequireWildcard(require("911dcb021b794dfa"));
var _propTypes = _interopRequireDefault(require("76a2d414e957c42e"));
var _clsx = _interopRequireDefault(require("d79d9d96f05b86b6"));
var _isMuiElement = _interopRequireDefault(require("2beabd27f8564e15"));
var _generateUtilityClass = _interopRequireDefault(require("187b65d9f76a314e"));
var _composeClasses = _interopRequireDefault(require("3558609d8048437"));
var _styled = _interopRequireDefault(require("a9dabebc4684becb"));
var _useThemeProps = _interopRequireDefault(require("a7d7a905551fc2c5"));
var _useTheme = _interopRequireDefault(require("c46f3c12df3a08cb"));
var _styleFunctionSx = require("9e79e0340596ec5d");
var _createTheme = _interopRequireDefault(require("39cacc3e60ead2ea"));
var _gridGenerator = require("c51cce52cd527a14");
var _deleteLegacyGridProps = _interopRequireDefault(require("e70ffbd3cc9d022b"));
var _jsxRuntime = require("6c45d05e26051074");
const defaultTheme = (0, _createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0, _styled.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function useThemePropsDefault(props) {
    return (0, _useThemeProps.default)({
        props,
        name: 'MuiGrid',
        defaultTheme
    });
}
function createGrid(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, useTheme = _useTheme.default, componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container, direction, spacing, wrap, size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, _gridGenerator.generateDirectionClasses)(direction),
                ...(0, _gridGenerator.generateSizeClassNames)(size),
                ...container ? (0, _gridGenerator.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, _composeClasses.default)(slots, (slot)=>(0, _generateUtilityClass.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent(_gridGenerator.generateGridColumnsStyles, _gridGenerator.generateGridColumnSpacingStyles, _gridGenerator.generateGridRowSpacingStyles, _gridGenerator.generateGridSizeStyles, _gridGenerator.generateGridDirectionStyles, _gridGenerator.generateGridStyles, _gridGenerator.generateGridOffsetStyles);
    const Grid = /*#__PURE__*/ React.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, _styleFunctionSx.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, _deleteLegacyGridProps.default)(props, theme.breakpoints);
        const { className, children, columns: columnsProp = 12, container = false, component = 'div', direction = 'row', wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level,
            columns,
            container,
            direction,
            wrap,
            spacing,
            rowSpacing,
            columnSpacing,
            size,
            offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            ...other,
            children: React.Children.map(children, (child)=>{
                if (/*#__PURE__*/ React.isValidElement(child) && (0, _isMuiElement.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ React.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

},{"5e8b8f8a87a74dab":"kZ6eK","d6b880b32747cf81":"fiRIh","911dcb021b794dfa":"9njXz","76a2d414e957c42e":"bnNSm","d79d9d96f05b86b6":"d2NWs","2beabd27f8564e15":"4sqhm","187b65d9f76a314e":"jBs9M","3558609d8048437":"59Equ","a9dabebc4684becb":"6Au1X","a7d7a905551fc2c5":"tiL16","c46f3c12df3a08cb":"jem9R","9e79e0340596ec5d":"e1roB","39cacc3e60ead2ea":"lBucb","c51cce52cd527a14":"jPfr0","e70ffbd3cc9d022b":"de0bd","6c45d05e26051074":"1dlk8"}],"6Au1X":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5b81c707cf9e80a1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _styled.default;
    }
});
var _styled = _interopRequireDefault(require("a6441e56f2b9b5c0"));

},{"5b81c707cf9e80a1":"kZ6eK","a6441e56f2b9b5c0":"8dPdU"}],"8dPdU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("88451216d1e72252").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createStyled = _interopRequireDefault(require("648c341cfc6b682"));
const styled = (0, _createStyled.default)();
var _default = exports.default = styled;

},{"88451216d1e72252":"kZ6eK","648c341cfc6b682":"6ySdS"}],"jPfr0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateSpacingClassNames = exports.generateSizeClassNames = exports.generateGridStyles = exports.generateGridSizeStyles = exports.generateGridRowSpacingStyles = exports.generateGridOffsetStyles = exports.generateGridDirectionStyles = exports.generateGridColumnsStyles = exports.generateGridColumnSpacingStyles = exports.generateDirectionClasses = void 0;
var _traverseBreakpoints = require("802c07388e1623e1");
function getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const selfColumnsVar = '--Grid-columns';
const parentColumnsVar = '--Grid-parent-columns';
const generateGridSizeStyles = ({ theme, ownerState })=>{
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${parentColumnsVar}) - (var(${parentColumnsVar}) - ${value}) * (var(${getParentSpacingVar('column')}) / var(${parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
exports.generateGridSizeStyles = generateGridSizeStyles;
const generateGridOffsetStyles = ({ theme, ownerState })=>{
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${parentColumnsVar}) + var(${getParentSpacingVar('column')}) * ${value} / var(${parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
exports.generateGridOffsetStyles = generateGridOffsetStyles;
const generateGridColumnsStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [selfColumnsVar]: 12
    };
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [selfColumnsVar]: columns,
            '> *': {
                [parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
exports.generateGridColumnsStyles = generateGridColumnsStyles;
const generateGridRowSpacingStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [getSelfSpacingVar('row')]: spacing,
            '> *': {
                [getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
exports.generateGridRowSpacingStyles = generateGridRowSpacingStyles;
const generateGridColumnSpacingStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [getSelfSpacingVar('column')]: spacing,
            '> *': {
                [getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
exports.generateGridColumnSpacingStyles = generateGridColumnSpacingStyles;
const generateGridDirectionStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
exports.generateGridDirectionStyles = generateGridDirectionStyles;
const generateGridStyles = ({ ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${getSelfSpacingVar('row')}) var(${getSelfSpacingVar('column')})`
        }
    };
};
exports.generateGridStyles = generateGridStyles;
const generateSizeClassNames = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
exports.generateSizeClassNames = generateSizeClassNames;
const generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
exports.generateSpacingClassNames = generateSpacingClassNames;
const generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};
exports.generateDirectionClasses = generateDirectionClasses;

},{"802c07388e1623e1":"hNkTG"}],"hNkTG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.traverseBreakpoints = exports.filterBreakpointKeys = void 0;
const filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
exports.filterBreakpointKeys = filterBreakpointKeys;
const traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};
exports.traverseBreakpoints = traverseBreakpoints;

},{}],"de0bd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deleteLegacyGridProps;
const getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const warnedAboutProps = [];
/**
 * Deletes the legacy Grid component props from the `props` object and warns once about them if found.
 *
 * @param {object} props The props object to remove the legacy Grid props from.
 * @param {Breakpoints} breakpoints The breakpoints object.
 */ function deleteLegacyGridProps(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}

},{}],"4O8ds":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"iyfkS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cae58f89633c7240").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getGridUtilityClass = getGridUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("d8ed53e71bb866cb"));
var _generateUtilityClass = _interopRequireDefault(require("567d2557a1d7e880"));
function getGridUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiGrid', slot);
}
const SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const GRID_SIZES = [
    'auto',
    'grow',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const gridClasses = (0, _generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    'item',
    // spacings
    ...SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var _default = exports.default = gridClasses;

},{"cae58f89633c7240":"kZ6eK","d8ed53e71bb866cb":"7pSUk","567d2557a1d7e880":"jBs9M"}],"fndkX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("eb253b38c9b97a8c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getGridUtilityClass = getGridUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("a479d1202e5e0ced"));
var _generateUtilityClass = _interopRequireDefault(require("8a7cc818c3149bc5"));
function getGridUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiGrid', slot);
}
const SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const gridClasses = (0, _generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    // spacings
    ...SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var _default = exports.default = gridClasses;

},{"eb253b38c9b97a8c":"kZ6eK","a479d1202e5e0ced":"7pSUk","8a7cc818c3149bc5":"jBs9M"}],"19HZv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _styles = require("./styles");
const getStyle = (primary)=>primary ? {
        color: 'primary',
        variant: 'contained'
    } : {
        color: 'secondary',
        variant: 'outlined'
    };
/**
 * Button for common paper's button pane
 * @param text - button text
 * @param onClick - function to call
 * @param savingState - if true shows spinner instead
 * @param primary - true for main button (mostly 'save')
 * @param id
 */ const ButtonComp = ({ text, onClick, savingState, primary, id, type, disabled, tooltip })=>{
    const getButton = ()=>{
        const button = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            loading: !!savingState,
            ...getStyle(primary),
            onClick: onClick,
            id: id || `button-${text.split(' ').join('-').toLowerCase()}`,
            type: type,
            disabled: disabled,
            children: text
        });
        // Add tooltip if provided
        // Button need to be wrapped in a Box for tooltip to work if button is disabled
        if (tooltip !== undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
            title: tooltip,
            placement: "top",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                children: button
            })
        });
        return button;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: (0, _styles.styles).button,
        children: getButton()
    });
};
/**
 * Common Buttons pane on the bottom of the form
 * @param main - set of main buttons on the right side
 * @param secondary - set of optional buttons on the left side
 */ const ButtonsPane = ({ main, secondary })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
        direction: "row",
        sx: {
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        children: [
            !!secondary && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                direction: "row",
                children: Object.entries(secondary).map(([text, button])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonComp, {
                        ...button,
                        text: text
                    }, text))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                direction: "row",
                sx: {
                    marginLeft: 'auto'
                },
                children: Object.entries(main).map(([text, button])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonComp, {
                        ...button,
                        text: text
                    }, text))
            })
        ]
    });
};
exports.default = ButtonsPane;

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Stack":"6thYv","@mui/material/Tooltip":"2soEB","./styles":"dg9GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dg9GC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styles", ()=>styles);
const styles = {
    button: {
        marginBottom: (theme)=>theme.spacing(1),
        marginLeft: (theme)=>theme.spacing(1)
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"74c5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactHookForm = require("react-hook-form");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _gridItem = require("./GridItem");
var _gridItemDefault = parcelHelpers.interopDefault(_gridItem);
const Comp = ({ field, ...props })=>{
    const muiProps = {
        ...field,
        ...props
    };
    muiProps.checked = muiProps.value || false;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
            ...muiProps
        }),
        label: props.label || props.name
    });
};
/**
 * Checkbox for forms using React Hook Form
 * @param props {
 *   name?: if we use it as RHF field - the name for the form
 *   label?: the label to show
 *   control?: if we don't want to have the value in RHF state we have to define our own control to display it
 * }
 * @constructor
 */ const Checkbox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridItemDefault.default), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlDefault.default), {
            margin: "normal",
            children: props.control ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                onClick: props.onClick,
                control: props.control,
                label: props.label || props.name
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                name: props.name,
                render: ({ field: { ref, ...field } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
                        inputRef: ref,
                        field: field,
                        ...(0, _gridItem.omitGridProps)(props)
                    })
            })
        })
    });
exports.default = Checkbox;

},{"react/jsx-runtime":"1dlk8","react-hook-form":"8z0aI","@mui/material/Checkbox":"ag1Z5","@mui/material/FormControl":"ioFZ4","@mui/material/FormControlLabel":"45VZW","./GridItem":"hSZf2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ag1Z5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("26f1db3c0de9d66f").default;
var _interopRequireDefault = require("dce934ff273582b4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    checkboxClasses: true
};
Object.defineProperty(exports, "checkboxClasses", {
    enumerable: true,
    get: function() {
        return _checkboxClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Checkbox.default;
    }
});
var _Checkbox = _interopRequireDefault(require("bdf04ad6f9423124"));
var _checkboxClasses = _interopRequireWildcard(require("13bcb1a01a3251d5"));
Object.keys(_checkboxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _checkboxClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _checkboxClasses[key];
        }
    });
});

},{"26f1db3c0de9d66f":"fiRIh","dce934ff273582b4":"kZ6eK","bdf04ad6f9423124":"htZdQ","13bcb1a01a3251d5":"b8FGH"}],"htZdQ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2d2b1451c23b73b0").default;
var _interopRequireWildcard = require("562370ba015dd028").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d507eddde9245665"));
var _propTypes = _interopRequireDefault(require("988c559fa4f98167"));
var _clsx = _interopRequireDefault(require("48bbf0d51a39d87f"));
var _composeClasses = _interopRequireDefault(require("ee26d1d3777ef257"));
var _colorManipulator = require("d49e06c6565c3e22");
var _SwitchBase = _interopRequireDefault(require("7223cc9a08eecaa4"));
var _CheckBoxOutlineBlank = _interopRequireDefault(require("177be0f2acfdbc10"));
var _CheckBox = _interopRequireDefault(require("a67f2e103a3c60cf"));
var _IndeterminateCheckBox = _interopRequireDefault(require("637ee0b3f76b586b"));
var _capitalize = _interopRequireDefault(require("390fab5327a0d046"));
var _rootShouldForwardProp = _interopRequireDefault(require("bacac81a51dede06"));
var _checkboxClasses = _interopRequireWildcard(require("26eaf72868587e85"));
var _zeroStyled = require("309791e5be4010de");
var _memoTheme = _interopRequireDefault(require("c658a09e1112cf2f"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("5d592981d8f93994"));
var _DefaultPropsProvider = require("c0c233bf02ff010f");
var _utils = require("2545908fb2057402");
var _useSlot = _interopRequireDefault(require("aceb7f9098813d3a"));
var _jsxRuntime = require("96690fdfe8be31e8");
const useUtilityClasses = (ownerState)=>{
    const { classes, indeterminate, color, size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, _capitalize.default)(color)}`,
            `size${(0, _capitalize.default)(size)}`
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _checkboxClasses.getCheckboxUtilityClass, classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const CheckboxRoot = (0, _zeroStyled.styled)(_SwitchBase.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, _capitalize.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, _capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&.${_checkboxClasses.default.checked}, &.${_checkboxClasses.default.indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${_checkboxClasses.default.disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const defaultCheckedIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CheckBox.default, {});
const defaultIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CheckBoxOutlineBlank.default, {});
const defaultIndeterminateIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_IndeterminateCheckBox.default, {});
const Checkbox = /*#__PURE__*/ React.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon = defaultCheckedIcon, color = 'primary', icon: iconProp = defaultIcon, indeterminate = false, indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon, inputProps, size = 'medium', disableRipple = false, className, slots = {}, slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple,
        color,
        indeterminate,
        size
    };
    const classes = useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        ref,
        elementType: CheckboxRoot,
        className: (0, _clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots,
            slotProps,
            ...other
        },
        ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ React.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ React.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple,
            slots,
            slotProps: {
                input: (0, _utils.mergeSlotProps)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var _default = exports.default = Checkbox;

},{"2d2b1451c23b73b0":"kZ6eK","562370ba015dd028":"fiRIh","d507eddde9245665":"9njXz","988c559fa4f98167":"bnNSm","48bbf0d51a39d87f":"d2NWs","ee26d1d3777ef257":"59Equ","d49e06c6565c3e22":"hTYBL","7223cc9a08eecaa4":"2T3Xg","177be0f2acfdbc10":"bvd8O","a67f2e103a3c60cf":"jduop","637ee0b3f76b586b":"1uLvv","390fab5327a0d046":"eOYSA","bacac81a51dede06":"bTxRc","26eaf72868587e85":"b8FGH","309791e5be4010de":"hZXDo","c658a09e1112cf2f":"cJNjb","5d592981d8f93994":"2r5WG","c0c233bf02ff010f":"9bD8g","2545908fb2057402":"dEMJk","aceb7f9098813d3a":"h76AU","96690fdfe8be31e8":"1dlk8"}],"2T3Xg":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e94f5477e2b470f4").default;
var _interopRequireWildcard = require("64c4d54783cf6d65").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("492917de6949c01"));
var _propTypes = _interopRequireDefault(require("979f4cf85dafa4cb"));
var _refType = _interopRequireDefault(require("cda87a00fc1940cf"));
var _composeClasses = _interopRequireDefault(require("8d0107686e39d732"));
var _capitalize = _interopRequireDefault(require("c5d724f672a483f0"));
var _rootShouldForwardProp = _interopRequireDefault(require("482b5b9b407529a1"));
var _zeroStyled = require("e574863a3bc375bc");
var _useControlled = _interopRequireDefault(require("4a484b96d02ab26c"));
var _useFormControl = _interopRequireDefault(require("d9529cde2206c335"));
var _ButtonBase = _interopRequireDefault(require("822a5faa5f6b9ddf"));
var _switchBaseClasses = require("bfee990373c1e2ee");
var _useSlot = _interopRequireDefault(require("95bd14bc803fadc8"));
var _jsxRuntime = require("82bb8ab160b030b1");
const useUtilityClasses = (ownerState)=>{
    const { classes, checked, disabled, edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, _capitalize.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, _composeClasses.default)(slots, _switchBaseClasses.getSwitchBaseUtilityClass, classes);
};
const SwitchBaseRoot = (0, _zeroStyled.styled)(_ButtonBase.default)({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge, ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge, ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const SwitchBaseInput = (0, _zeroStyled.styled)('input', {
    shouldForwardProp: _rootShouldForwardProp.default
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const SwitchBase = /*#__PURE__*/ React.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus, checked: checkedProp, checkedIcon, defaultChecked, disabled: disabledProp, disableFocusRipple = false, edge = false, icon, id, inputProps, inputRef, name, onBlur, onChange, onFocus, readOnly, required = false, tabIndex, type, value, slots = {}, slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, _useControlled.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, _useFormControl.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked,
        disabled,
        disableFocusRipple,
        edge
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        ref,
        elementType: SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, _useSlot.default)('input', {
        ref: inputRef,
        elementType: SwitchBaseInput,
        className: classes.input,
        externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState,
        additionalProps: {
            autoFocus,
            checked: checkedProp,
            defaultChecked,
            disabled,
            id: hasLabelFor ? id : undefined,
            name,
            readOnly,
            required,
            tabIndex,
            type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value
            }
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var _default = exports.default = SwitchBase;

},{"e94f5477e2b470f4":"kZ6eK","64c4d54783cf6d65":"fiRIh","492917de6949c01":"9njXz","979f4cf85dafa4cb":"bnNSm","cda87a00fc1940cf":"3TBXN","8d0107686e39d732":"59Equ","c5d724f672a483f0":"eOYSA","482b5b9b407529a1":"bTxRc","e574863a3bc375bc":"hZXDo","4a484b96d02ab26c":"2pWHX","d9529cde2206c335":"51J7f","822a5faa5f6b9ddf":"7X8rf","bfee990373c1e2ee":"i6PrS","95bd14bc803fadc8":"h76AU","82bb8ab160b030b1":"1dlk8"}],"i6PrS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6c9c0a14f0d1354c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getSwitchBaseUtilityClass = getSwitchBaseUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("306a0a0b221c024"));
var _generateUtilityClass = _interopRequireDefault(require("5567e616b5b44d6b"));
function getSwitchBaseUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('PrivateSwitchBase', slot);
}
const switchBaseClasses = (0, _generateUtilityClasses.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var _default = exports.default = switchBaseClasses;

},{"6c9c0a14f0d1354c":"kZ6eK","306a0a0b221c024":"7pSUk","5567e616b5b44d6b":"jBs9M"}],"bvd8O":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e9cf47e795249f35").default;
var _interopRequireWildcard = require("f046427174ca215b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("a6f8910c0a8c552b"));
var _createSvgIcon = _interopRequireDefault(require("1c70bd9b03206889"));
var _jsxRuntime = require("18e2cb6bc3b625bc");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

},{"e9cf47e795249f35":"kZ6eK","f046427174ca215b":"fiRIh","a6f8910c0a8c552b":"9njXz","1c70bd9b03206889":"5sni0","18e2cb6bc3b625bc":"1dlk8"}],"jduop":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2a8f280e417c6835").default;
var _interopRequireWildcard = require("144148b134b9330f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("3615d1fa8a4b7e06"));
var _createSvgIcon = _interopRequireDefault(require("6893b73de91a803f"));
var _jsxRuntime = require("9de4ddc67fe8b7e8");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

},{"2a8f280e417c6835":"kZ6eK","144148b134b9330f":"fiRIh","3615d1fa8a4b7e06":"9njXz","6893b73de91a803f":"5sni0","9de4ddc67fe8b7e8":"1dlk8"}],"1uLvv":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2aec05d0d8a980ba").default;
var _interopRequireWildcard = require("49afba2b0ea983ad").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e0423437d8941267"));
var _createSvgIcon = _interopRequireDefault(require("87dfc6bcee61800f"));
var _jsxRuntime = require("90d1529a51b4b5bd");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

},{"2aec05d0d8a980ba":"kZ6eK","49afba2b0ea983ad":"fiRIh","e0423437d8941267":"9njXz","87dfc6bcee61800f":"5sni0","90d1529a51b4b5bd":"1dlk8"}],"b8FGH":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("259f15217a8a3bef").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getCheckboxUtilityClass = getCheckboxUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("6e7abeaf6e763895"));
var _generateUtilityClass = _interopRequireDefault(require("e302e124e3064b2b"));
function getCheckboxUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiCheckbox', slot);
}
const checkboxClasses = (0, _generateUtilityClasses.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var _default = exports.default = checkboxClasses;

},{"259f15217a8a3bef":"kZ6eK","6e7abeaf6e763895":"7pSUk","e302e124e3064b2b":"jBs9M"}],"45VZW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("1c36b7fa7f67a86c").default;
var _interopRequireDefault = require("1530476e8ef673d2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    formControlLabelClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FormControlLabel.default;
    }
});
Object.defineProperty(exports, "formControlLabelClasses", {
    enumerable: true,
    get: function() {
        return _formControlLabelClasses.default;
    }
});
var _FormControlLabel = _interopRequireDefault(require("3271a86441a4f772"));
var _formControlLabelClasses = _interopRequireWildcard(require("57b904be740cece7"));
Object.keys(_formControlLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _formControlLabelClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _formControlLabelClasses[key];
        }
    });
});

},{"1c36b7fa7f67a86c":"fiRIh","1530476e8ef673d2":"kZ6eK","3271a86441a4f772":"5a1Ey","57b904be740cece7":"4iJ0x"}],"5a1Ey":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("68ee587d8b65b8bb").default;
var _interopRequireWildcard = require("2ee647ccf1f326bd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.FormControlLabelRoot = void 0;
var React = _interopRequireWildcard(require("dbea1ad89e481d9"));
var _propTypes = _interopRequireDefault(require("856f616c43f7c12d"));
var _clsx = _interopRequireDefault(require("69272f7bc101ca64"));
var _refType = _interopRequireDefault(require("b54d17f9c48f75a8"));
var _composeClasses = _interopRequireDefault(require("ad42d8d145fe57fa"));
var _FormControl = require("14abc056ff9a650c");
var _zeroStyled = require("ae9bcb72b0f2c563");
var _memoTheme = _interopRequireDefault(require("467b7edbd933b9d"));
var _DefaultPropsProvider = require("273ba14fa6bfe53");
var _Typography = _interopRequireDefault(require("b9268ae1b999b387"));
var _capitalize = _interopRequireDefault(require("2b1709db347b8496"));
var _formControlLabelClasses = _interopRequireWildcard(require("ac09ce6427efe6af"));
var _formControlState = _interopRequireDefault(require("4f4d970aaa6ee777"));
var _useSlot = _interopRequireDefault(require("cd44f0794566b841"));
var _jsxRuntime = require("b759ff0c394ee26f");
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, labelPlacement, error, required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, _capitalize.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, _composeClasses.default)(slots, _formControlLabelClasses.getFormControlLabelUtilityClasses, classes);
};
const FormControlLabelRoot = exports.FormControlLabelRoot = (0, _zeroStyled.styled)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_formControlLabelClasses.default.label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, _capitalize.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${_formControlLabelClasses.default.disabled}`]: {
            cursor: 'default'
        },
        [`& .${_formControlLabelClasses.default.label}`]: {
            [`&.${_formControlLabelClasses.default.disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const AsteriskComponent = (0, _zeroStyled.styled)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk'
})((0, _memoTheme.default)(({ theme })=>({
        [`&.${_formControlLabelClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const FormControlLabel = /*#__PURE__*/ React.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked, className, componentsProps = {}, control, disabled: disabledProp, disableTypography, inputRef, label: labelProp, labelPlacement = 'end', name, onChange, required: requiredProp, slots = {}, slotProps = {}, value, ...other } = props;
    const muiFormControl = (0, _FormControl.useFormControl)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled,
        required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled,
        labelPlacement,
        required,
        error: fcs.error
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, _useSlot.default)('typography', {
        elementType: _Typography.default,
        externalForwardedProps,
        ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== _Typography.default && !disableTypography) label = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, _clsx.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormControlLabelRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ React.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var _default = exports.default = FormControlLabel;

},{"68ee587d8b65b8bb":"kZ6eK","2ee647ccf1f326bd":"fiRIh","dbea1ad89e481d9":"9njXz","856f616c43f7c12d":"bnNSm","69272f7bc101ca64":"d2NWs","b54d17f9c48f75a8":"3TBXN","ad42d8d145fe57fa":"59Equ","14abc056ff9a650c":"ioFZ4","ae9bcb72b0f2c563":"hZXDo","467b7edbd933b9d":"cJNjb","273ba14fa6bfe53":"9bD8g","b9268ae1b999b387":"6NtGx","2b1709db347b8496":"eOYSA","ac09ce6427efe6af":"4iJ0x","4f4d970aaa6ee777":"9soGV","cd44f0794566b841":"h76AU","b759ff0c394ee26f":"1dlk8"}],"4iJ0x":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5147a039b020907d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFormControlLabelUtilityClasses = getFormControlLabelUtilityClasses;
var _generateUtilityClasses = _interopRequireDefault(require("8bbfb6d8bdbf918e"));
var _generateUtilityClass = _interopRequireDefault(require("109dacd4bd616c65"));
function getFormControlLabelUtilityClasses(slot) {
    return (0, _generateUtilityClass.default)('MuiFormControlLabel', slot);
}
const formControlLabelClasses = (0, _generateUtilityClasses.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var _default = exports.default = formControlLabelClasses;

},{"5147a039b020907d":"kZ6eK","8bbfb6d8bdbf918e":"7pSUk","109dacd4bd616c65":"jBs9M"}],"J2E2j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _collapse = require("@mui/material/Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _tooltip = require("../Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _expandLess = require("@mui/icons-material/ExpandLess");
var _expandLessDefault = parcelHelpers.interopDefault(_expandLess);
var _expandMore = require("@mui/icons-material/ExpandMore");
var _expandMoreDefault = parcelHelpers.interopDefault(_expandMore);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
const styles = {
    buttonContainer: {
        justifyContent: 'flex-end',
        marginRight: 1,
        '& > div + div': {
            marginLeft: 2
        }
    },
    tooltip: {
        fontSize: (theme)=>theme.typography.body2.fontSize
    },
    icon: {
        marginLeft: 1,
        transform: 'translateY(3px)'
    },
    paper: {
        paddingY: 1,
        paddingX: 2,
        marginY: 1,
        width: '100%',
        '&.outlined': {
            boxShadow: 'none',
            backgroundColor: 'transparent',
            border: (theme)=>`1px solid ${theme.palette.background.paper}`,
            '&.error': {
                borderColor: (theme)=>theme.palette.error.main
            }
        }
    }
};
/**
 * Some enhancements on the top of MaterialUI Paper
 * @param collapsible - should we show button which expands/collapses the paper
 * @param title - paper's title
 * @param children - content
 * @param collapsed - if it is collapsible we can make it collapsed by default
 * @param actionsPane - bottom line of buttons
 * @param titleTypography - Typography variant for title
 * @param id
 */ const Paper = ({ className = '', sx = {}, collapsible = false, title = '', children, collapsed: col = false, actionsPane = [], titleTypography, id: dataTestId, onCollapseChange, tooltip })=>{
    const [collapsed, setCollapsed] = (0, _react.useState)(col);
    (0, _react.useEffect)(()=>{
        setCollapsed(col);
    }, [
        col
    ]);
    const toggle = ()=>{
        if (collapsible) setCollapsed(!collapsed);
        if (onCollapseChange) onCollapseChange(!collapsed);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        sx: {
            ...styles.paper,
            ...sx
        },
        className: className,
        "data-testid": dataTestId,
        "data-test-id": dataTestId || `paper-${title}`,
        children: [
            (title || collapsible) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
                disableGutters: true,
                variant: "dense",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                        variant: titleTypography || 'h2',
                        sx: {
                            flexGrow: 1,
                            cursor: collapsible ? 'pointer' : 'default'
                        },
                        className: (0, _classnamesDefault.default)(collapsible),
                        onClick: toggle,
                        children: [
                            title,
                            tooltip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                title: tooltip,
                                sx: {
                                    tooltip: styles.tooltip
                                },
                                placement: "right",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                                    sx: styles.icon
                                })
                            })
                        ]
                    }),
                    collapsible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: collapsed ? 'Expand' : 'Collapse',
                        placement: "top",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            onClick: toggle,
                            children: collapsed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandMoreDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandLessDefault.default), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapseDefault.default), {
                in: !collapsed,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        container: true,
                        rowSpacing: 1,
                        columnSpacing: 2,
                        sx: {
                            width: '100%'
                        },
                        children: children
                    }),
                    Boolean(actionsPane.length) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                        disableGutters: true,
                        variant: "dense",
                        sx: styles.buttonContainer,
                        children: actionsPane.map((item, ind)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlDefault.default), {
                                margin: "normal",
                                children: /*#__PURE__*/ (0, _react.isValidElement)(item) ? item : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    id: item ? item.id : undefined,
                                    variant: "contained",
                                    color: "secondary",
                                    onClick: item.onClick,
                                    ...item.props,
                                    children: item.title
                                })
                            }, ind))
                    })
                ]
            })
        ]
    });
};
exports.default = Paper;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","classnames":"5Een2","@mui/material/Button":"3qJY9","@mui/material/Collapse":"c7nwP","@mui/material/FormControl":"ioFZ4","@mui/material/Grid":"6iX4B","@mui/material/IconButton":"488As","@mui/material/Paper":"aexCI","@mui/material/Toolbar":"5Kohb","../Tooltip":"crjvg","@mui/material/Typography":"6NtGx","@mui/icons-material/ExpandLess":"fOT90","@mui/icons-material/ExpandMore":"gUaK6","@mui/icons-material/HelpOutline":"2sIqE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Een2":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"gP5uG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactBeforeunload = require("react-beforeunload");
const CONFIRM_PROMPT = 'You have some unsaved data, do you really want to leave the page?';
function useConfirmExit(confirmExit, when = true) {
    const { navigator } = (0, _react.useContext)((0, _reactRouter.UNSAFE_NavigationContext));
    (0, _react.useEffect)(()=>{
        if (!when) return;
        const push = navigator.push;
        navigator.push = (...args)=>{
            const result = confirmExit();
            if (result !== false) push(...args);
        };
        return ()=>{
            navigator.push = push;
        };
    }, [
        navigator,
        confirmExit,
        when
    ]);
}
function usePromptRHF({ message, when = true }) {
    (0, _react.useEffect)(()=>{
        if (when) window.onbeforeunload = function() {
            return message;
        };
        return ()=>{
            window.onbeforeunload = null;
        };
    }, [
        message,
        when
    ]);
    const confirmExit = (0, _react.useCallback)(()=>{
        const confirm = window.confirm(message);
        return confirm;
    }, [
        message
    ]);
    useConfirmExit(confirmExit, when);
}
/**
 * Component to prompt confirmation before leaving form page
 * @param enabled - if true, prompt will be shown
 * @param formState - react-hook-form form state, checks if form is dirty and submit was not successful
 * @constructor
 */ const SafeRouting = ({ enabled, formState })=>{
    const anyDirtyFields = (formState)=>Object.keys(formState.dirtyFields).some((key)=>formState.dirtyFields[key]);
    usePromptRHF({
        message: CONFIRM_PROMPT,
        when: formState ? anyDirtyFields(formState) && !formState.isSubmitSuccessful : false
    });
    (0, _reactRouter.unstable_usePrompt)({
        when: enabled,
        message: CONFIRM_PROMPT
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBeforeunload.Beforeunload), {
        onBeforeunload: ()=>{
            if (enabled) return CONFIRM_PROMPT;
            return null;
        }
    });
};
exports.default = SafeRouting;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-beforeunload":"jlBC0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jlBC0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Beforeunload", ()=>Beforeunload);
parcelHelpers.export(exports, "useBeforeunload", ()=>useBeforeunload);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var useBeforeunload = function useBeforeunload(handler) {
    !(handler == null || typeof handler === 'function') && (0, _tinyInvariantDefault.default)(false);
    var eventListenerRef = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        eventListenerRef.current = function(event) {
            var returnValue = handler === null || handler === void 0 ? void 0 : handler(event); // Handle legacy `event.returnValue` property
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
            if (typeof returnValue === 'string') return event.returnValue = returnValue;
             // Chrome doesn't support `event.preventDefault()` on `BeforeUnloadEvent`,
            // instead it requires `event.returnValue` to be set
            // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload#browser_compatibility
            if (event.defaultPrevented) return event.returnValue = '';
        };
    }, [
        handler
    ]);
    (0, _react.useEffect)(function() {
        var eventListener = function eventListener(event) {
            return eventListenerRef.current(event);
        };
        window.addEventListener('beforeunload', eventListener);
        return function() {
            window.removeEventListener('beforeunload', eventListener);
        };
    }, []);
};
var Beforeunload = function Beforeunload(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, onBeforeunload = _ref.onBeforeunload;
    useBeforeunload(onBeforeunload);
    return children;
};
Beforeunload.propTypes = {};

},{"prop-types":"bnNSm","react":"9njXz","tiny-invariant":"cKzLp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cKzLp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"42YaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _gridItem = require("./GridItem");
var _gridItemDefault = parcelHelpers.interopDefault(_gridItem);
var _utils = require("../../../utils");
var _tooltip = require("../Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
const Comp = /*#__PURE__*/ (0, _react.forwardRef)(({ field, fieldState, ...props }, ref)=>{
    const showError = fieldState.invalid;
    const fieldError = fieldState.error ? fieldState.error.message : '';
    const muiProps = {
        error: showError,
        helperText: showError ? fieldError : props.helperText,
        ...props,
        ...field,
        ref
    };
    const hasEmpty = !!(props.options || []).find((option)=>typeof option === 'object' && option.value === '');
    const selectProps = {
        displayEmpty: hasEmpty
    };
    const labelProps = {
        shrink: hasEmpty || undefined
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
        ...muiProps,
        defaultValue: "",
        slotProps: {
            select: selectProps,
            inputLabel: labelProps
        }
    });
});
/**
 * Simple select component using React Hook Form
 * @param props {
 *   name?: field name
 *   label?: label to show
 *   validators?: validation rules for the field
 *   required?: adds validation
 *   options?: array of string, numbers or complex objects with name, value, disabled state and tooltip
 *   onChange?: callback function to handle selection changes
 * }
 */ const Select = (props)=>{
    const { validators = {}, variant = 'outlined', hiddenLabel = false } = props;
    if (props.required) validators.presence = 'This field is required';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridItemDefault.default), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
            name: props.name ?? '',
            rules: {
                validate: (0, _utils.validate)(validators)
            },
            render: ({ field: { ref, value, onChange, ...field }, fieldState })=>{
                // Propagate the onChange both to RHF and the parent component
                const handleChange = (event)=>{
                    const selectedValue = event.target.value;
                    onChange(selectedValue);
                    props.onChange?.(selectedValue);
                };
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
                    inputRef: ref,
                    field: {
                        ...field,
                        value,
                        onChange: handleChange
                    },
                    fieldState: fieldState,
                    select: true,
                    label: hiddenLabel ? undefined : props.label,
                    margin: "normal",
                    fullWidth: true,
                    variant: variant,
                    hiddenLabel: hiddenLabel,
                    "data-test-id": `select-${props.name ?? props.label}`,
                    ...(0, _gridItem.omitGridProps)((0, _omitDefault.default)(props, 'onChange')),
                    options: props.options?.map((o)=>typeof o === 'object' && 'name' in o ? o.name : o),
                    children: props.options !== undefined && props.options.map((option)=>{
                        const opt = typeof option !== 'object' ? {
                            name: option
                        } : option;
                        const tooltipStyle = opt.hoverTooltip ? 'hover' : opt.tooltip ? 'inline' : 'none';
                        const body = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                fontStyle: 'value' in opt && opt.value === undefined ? 'italic' : undefined,
                                marginRight: 5
                            },
                            children: opt.name
                        });
                        if (tooltipStyle === 'hover') body.props.style.width = '100%';
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuItemDefault.default), {
                            value: 'value' in opt ? opt.value : opt.name,
                            disabled: Boolean(opt.disabled),
                            children: [
                                tooltipStyle === 'hover' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                    title: opt.hoverTooltip,
                                    children: body
                                }),
                                tooltipStyle !== 'hover' && body,
                                tooltipStyle === 'inline' && typeof opt.tooltip === 'string' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                    variant: "body2",
                                    component: "span",
                                    children: [
                                        "\xa0(",
                                        opt.tooltip,
                                        ")"
                                    ]
                                }),
                                tooltipStyle === 'inline' && typeof opt.tooltip === 'object' && opt.tooltip
                            ]
                        }, opt.name);
                    })
                });
            }
        })
    });
};
exports.default = Select;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-hook-form":"8z0aI","@mui/material/MenuItem":"krMs8","@mui/material/TextField":"l88b4","@mui/material/Typography":"6NtGx","./GridItem":"hSZf2","../../../utils":"342UB","../Tooltip":"crjvg","lodash/omit":"fhxvC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1xLso":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _omit = require("lodash/fp/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _gridItem = require("./GridItem");
var _gridItemDefault = parcelHelpers.interopDefault(_gridItem);
var _passwordField = require("./PasswordField");
var _utils = require("../../../utils");
var _reactHookForm = require("react-hook-form");
const disallowNonNumericCharacters = (event)=>{
    // Disallow all non-numeric characters
    if (isNaN(parseFloat(event.key))) event.preventDefault();
};
const Comp = /*#__PURE__*/ (0, _react.forwardRef)((allProps, ref)=>{
    const { field, fieldState, ...props } = allProps;
    const showError = fieldState.invalid;
    const fieldError = fieldState.error ? fieldState.error.message : '';
    const muiProps = {
        error: showError,
        helperText: showError ? fieldError : props.helperText,
        ...field,
        ...props,
        ref
    };
    if (props.type === 'number') muiProps.onWheel = (e)=>e.target instanceof HTMLElement && e.target.blur();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.type === 'password' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordField.PasswordField), {
            ...muiProps
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
            ...muiProps
        })
    });
});
/**
 * Simple text input (string, number, email, password etc.)
 * @param props {
 *   name: react-hook-form's name
 *   label?: label to show
 *   multiline?: if it is string field and we need it to be multiline
 *   noNegative?: for number fields we can forbid setting negative values by keyboard arrows, and also it adds validation rule
 *   unsignedInt?: disallow 'e', '+', '-', '.' for number fields
 *   validators?: validation rules for react-hook-form
 *   required?: adds validation
 *   showPassword?: If true, the password is visible. It's valid only when type=password.
 * }
 * @constructor
 */ const TextInput = (props)=>{
    const { setValue } = (0, _reactHookForm.useFormContext)();
    const { validators = {}, name, variant = 'outlined', hiddenLabel = false, unsignedInt = true } = props;
    const onKeyPress = props.onKeyPress ?? (props.type === 'number' && unsignedInt) ? disallowNonNumericCharacters : undefined;
    const handleOnChange = (0, _react.useCallback)((event)=>{
        const value = props.type === 'number' ? event.currentTarget.valueAsNumber : event.currentTarget.value;
        if (typeof value === 'number' && isNaN(value)) setValue(name, '');
        else setValue(name, value);
    }, [
        name,
        setValue
    ]);
    if (props.noNegative) validators.number = {
        valueAsNumber: true,
        min: 0,
        message: 'Can not be negative',
        ...validators.number
    };
    if (props.required) validators.presence = true;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridItemDefault.default), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
            name: name,
            rules: {
                validate: (0, _utils.validate)(validators)
            },
            render: ({ field: { ref, ...field }, fieldState })=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
                    inputRef: ref,
                    field: field,
                    fieldState: fieldState,
                    label: hiddenLabel ? undefined : props.name,
                    fullWidth: true,
                    variant: variant,
                    hiddenLabel: hiddenLabel,
                    margin: "normal",
                    autoComplete: "off",
                    onKeyPress: onKeyPress,
                    onChange: (e)=>{
                        field.onChange(e);
                        handleOnChange(e);
                    },
                    ...props.noNegative ? {
                        inputProps: {
                            min: '0'
                        }
                    } : undefined,
                    ...(0, _gridItem.omitGridProps)((0, _omitDefault.default)([
                        'noNegative',
                        'validators'
                    ], props)),
                    "data-test-id": props.name ? `textinput-${props.name}` : undefined
                });
            }
        })
    });
};
exports.default = TextInput;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/TextField":"l88b4","lodash/fp/omit":"lRr4P","./GridItem":"hSZf2","./PasswordField":"92DZK","../../../utils":"342UB","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"92DZK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PasswordField", ()=>PasswordField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _visibility = require("@mui/icons-material/Visibility");
var _visibilityDefault = parcelHelpers.interopDefault(_visibility);
var _visibilityOff = require("@mui/icons-material/VisibilityOff");
var _visibilityOffDefault = parcelHelpers.interopDefault(_visibilityOff);
const styles = {
    container: {
        width: '100%',
        position: 'relative'
    },
    visibilityIcon: {
        position: 'absolute',
        top: '30px',
        right: '10px',
        cursor: 'pointer'
    }
};
const PasswordField = (props)=>{
    const [showPassword, setShowPassword] = (0, _react.useState)(false);
    const { showPassword: _, ...textProps } = props;
    (0, _react.useEffect)(()=>{
        setShowPassword(Boolean(props.showPassword?.show));
    }, [
        props.showPassword?.id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                ...textProps,
                type: showPassword ? 'text' : 'password'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                onClick: ()=>setShowPassword(!showPassword),
                sx: styles.visibilityIcon,
                children: showPassword ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visibilityOffDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visibilityDefault.default), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/TextField":"l88b4","@mui/icons-material/Visibility":"kayv0","@mui/icons-material/VisibilityOff":"8LmfP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kayv0":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("8d409ff30f2d460c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4d8a0b0d6b4c99b7"));
var _jsxRuntime = require("edb86e02ce2d85fe");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');

},{"8d409ff30f2d460c":"kZ6eK","4d8a0b0d6b4c99b7":"2vOnF","edb86e02ce2d85fe":"1dlk8"}],"8LmfP":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("817c78af46b06333").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("c4968e70f40fe907"));
var _jsxRuntime = require("47021b0e1eb7c54c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), 'VisibilityOff');

},{"817c78af46b06333":"kZ6eK","c4968e70f40fe907":"2vOnF","47021b0e1eb7c54c":"1dlk8"}],"izm8y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _xDatePickers = require("@mui/x-date-pickers");
var _omit = require("lodash/fp/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _gridItem = require("./GridItem");
var _gridItemDefault = parcelHelpers.interopDefault(_gridItem);
var _utils = require("../../../utils");
var _reactHookForm = require("react-hook-form");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
const Comp = /*#__PURE__*/ (0, _react.forwardRef)((allProps, ref)=>{
    const { field, fieldState, ...props } = allProps;
    const showError = fieldState.invalid;
    const fieldError = fieldState.error ? fieldState.error.message : '';
    const muiProps = {
        error: showError,
        helperText: showError ? fieldError : props.helperText,
        ...field,
        ...props,
        ref
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.LocalizationProvider), {
        dateAdapter: (0, _adapterDateFns.AdapterDateFns),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
            ...muiProps
        })
    });
});
/**
 * Date picker component sized like our other form components
 * @param props {
 *   name: react-hook-form's name
 *   label?: label to show
 *   validators?: validation rules for react-hook-form
 *   required?: adds validation
 * }
 * @constructor
 */ const DatePicker = (props)=>{
    const { setValue } = (0, _reactHookForm.useFormContext)();
    const { validators = {}, name } = props;
    const handleOnChange = (0, _react.useCallback)((event)=>{
        const value = event.currentTarget.value;
        if (typeof value === 'number' && isNaN(value)) setValue(name, '');
        else setValue(name, value);
    }, [
        name,
        setValue
    ]);
    if (props.required) validators.presence = true;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridItemDefault.default), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
            name: name,
            rules: {
                validate: (0, _utils.validate)(validators)
            },
            render: ({ field: { ref, ...field }, fieldState })=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
                    inputRef: ref,
                    field: field,
                    fieldState: fieldState,
                    fullWidth: true,
                    sx: {
                        width: '100%'
                    },
                    margin: "normal",
                    autoComplete: "off",
                    onChange: (e)=>{
                        field.onChange(e);
                        handleOnChange(e);
                    },
                    ...(0, _gridItem.omitGridProps)((0, _omitDefault.default)([
                        'validators'
                    ], props)),
                    "data-test-id": props.name ? `datepicker-${props.name}` : undefined
                });
            }
        })
    });
};
exports.default = DatePicker;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/x-date-pickers":"gSoHo","lodash/fp/omit":"lRr4P","./GridItem":"hSZf2","../../../utils":"342UB","react-hook-form":"8z0aI","@mui/x-date-pickers/AdapterDateFns":"bSwsg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bSwsg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AdapterDateFns", {
    enumerable: true,
    get: function() {
        return _AdapterDateFns.AdapterDateFns;
    }
});
var _AdapterDateFns = require("62fedf9468922c81");

},{"62fedf9468922c81":"84Foe"}],"84Foe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AdapterDateFns = void 0;
var _addDays = require("fe236e69ec7473c");
var _addSeconds = require("7da78351776bec62");
var _addMinutes = require("7d06c6b944c7bcdb");
var _addHours = require("754fa60899b87755");
var _addWeeks = require("fd77b02a9d896b4e");
var _addMonths = require("1063e9e3719cf242");
var _addYears = require("c0dfb4f5feb52459");
var _endOfDay = require("2654b2413e5b6dd5");
var _endOfWeek = require("a38753f3c48388f5");
var _endOfYear = require("485754a424aa0176");
var _format = require("c4b61a288b71f132");
var _getDate = require("3beda86c75bafb58");
var _getDaysInMonth = require("3b5552fcf0f5fbbd");
var _getHours = require("61084442e1a177f8");
var _getMinutes = require("2d13b5ab9d5b099b");
var _getMonth = require("bdb60cca19b9cacf");
var _getSeconds = require("1dd902fa5734d0fe");
var _getMilliseconds = require("bd328ee7405cf99f");
var _getWeek = require("749084fd88aedc9c");
var _getYear = require("ef125453af10db68");
var _isAfter = require("a3b9b0978d2939c8");
var _isBefore = require("a4d276f4dc72edf2");
var _isEqual = require("b9007efeb2c32cb3");
var _isSameDay = require("c2635c5bc19ec835");
var _isSameYear = require("45fbd331067459a3");
var _isSameMonth = require("5d1c9d5a51f5f924");
var _isSameHour = require("c68d1324904aa02d");
var _isValid = require("cf1cb5ca2ff0a8c5");
var _parse = require("95d4f330ba1c8b87");
var _setDate = require("61d9521e7d12a69");
var _setHours = require("17488c9a5d966525");
var _setMinutes = require("531edaee357afd24");
var _setMonth = require("fe7edba5668100e4");
var _setSeconds = require("9c8fa56f169712db");
var _setMilliseconds = require("25450aecba224d3d");
var _setYear = require("9fd433b381a5f709");
var _startOfDay = require("a75ce4d07b23c546");
var _startOfMonth = require("6cc08316a21da774");
var _endOfMonth = require("d7858dbbc473994b");
var _startOfWeek = require("6bf086f75478509d");
var _startOfYear = require("8152570f933bd355");
var _isWithinInterval = require("267c087e8abe52d0");
var _enUS = require("fb72b6c535c37b94");
var _AdapterDateFnsBase = require("152865c260538f81");
/* eslint-disable class-methods-use-this */ /**
 * Based on `@date-io/date-fns`
 *
 * MIT License
 *
 * Copyright (c) 2017 Dmitriy Kovalenko
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ class AdapterDateFns extends _AdapterDateFnsBase.AdapterDateFnsBase {
    constructor({ locale, formats } = {}){
        /* v8 ignore stop */ super({
            locale: locale ?? _enUS.enUS,
            formats,
            longFormatters: _format.longFormatters
        });
        // TODO: explicit return types can be removed once there is only one date-fns version supported
        this.parse = (value, format)=>{
            if (value === '') return null;
            return (0, _parse.parse)(value, format, new Date(), {
                locale: this.locale
            });
        };
        this.isValid = (value)=>{
            if (value == null) return false;
            return (0, _isValid.isValid)(value);
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return (0, _format.format)(value, formatString, {
                locale: this.locale
            });
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            if (value === null || comparing === null) return false;
            return (0, _isEqual.isEqual)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, _isSameYear.isSameYear)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, _isSameMonth.isSameMonth)(value, comparing);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, _isSameDay.isSameDay)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, _isSameHour.isSameHour)(value, comparing);
        };
        this.isAfter = (value, comparing)=>{
            return (0, _isAfter.isAfter)(value, comparing);
        };
        this.isAfterYear = (value, comparing)=>{
            return (0, _isAfter.isAfter)(value, (0, _endOfYear.endOfYear)(comparing));
        };
        this.isAfterDay = (value, comparing)=>{
            return (0, _isAfter.isAfter)(value, (0, _endOfDay.endOfDay)(comparing));
        };
        this.isBefore = (value, comparing)=>{
            return (0, _isBefore.isBefore)(value, comparing);
        };
        this.isBeforeYear = (value, comparing)=>{
            return (0, _isBefore.isBefore)(value, this.startOfYear(comparing));
        };
        this.isBeforeDay = (value, comparing)=>{
            return (0, _isBefore.isBefore)(value, this.startOfDay(comparing));
        };
        this.isWithinRange = (value, [start, end])=>{
            return (0, _isWithinInterval.isWithinInterval)(value, {
                start,
                end
            });
        };
        this.startOfYear = (value)=>{
            return (0, _startOfYear.startOfYear)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, _startOfMonth.startOfMonth)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, _startOfWeek.startOfWeek)(value, {
                locale: this.locale
            });
        };
        this.startOfDay = (value)=>{
            return (0, _startOfDay.startOfDay)(value);
        };
        this.endOfYear = (value)=>{
            return (0, _endOfYear.endOfYear)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, _endOfMonth.endOfMonth)(value);
        };
        this.endOfWeek = (value)=>{
            return (0, _endOfWeek.endOfWeek)(value, {
                locale: this.locale
            });
        };
        this.endOfDay = (value)=>{
            return (0, _endOfDay.endOfDay)(value);
        };
        this.addYears = (value, amount)=>{
            return (0, _addYears.addYears)(value, amount);
        };
        this.addMonths = (value, amount)=>{
            return (0, _addMonths.addMonths)(value, amount);
        };
        this.addWeeks = (value, amount)=>{
            return (0, _addWeeks.addWeeks)(value, amount);
        };
        this.addDays = (value, amount)=>{
            return (0, _addDays.addDays)(value, amount);
        };
        this.addHours = (value, amount)=>{
            return (0, _addHours.addHours)(value, amount);
        };
        this.addMinutes = (value, amount)=>{
            return (0, _addMinutes.addMinutes)(value, amount);
        };
        this.addSeconds = (value, amount)=>{
            return (0, _addSeconds.addSeconds)(value, amount);
        };
        this.getYear = (value)=>{
            return (0, _getYear.getYear)(value);
        };
        this.getMonth = (value)=>{
            return (0, _getMonth.getMonth)(value);
        };
        this.getDate = (value)=>{
            return (0, _getDate.getDate)(value);
        };
        this.getHours = (value)=>{
            return (0, _getHours.getHours)(value);
        };
        this.getMinutes = (value)=>{
            return (0, _getMinutes.getMinutes)(value);
        };
        this.getSeconds = (value)=>{
            return (0, _getSeconds.getSeconds)(value);
        };
        this.getMilliseconds = (value)=>{
            return (0, _getMilliseconds.getMilliseconds)(value);
        };
        this.setYear = (value, year)=>{
            return (0, _setYear.setYear)(value, year);
        };
        this.setMonth = (value, month)=>{
            return (0, _setMonth.setMonth)(value, month);
        };
        this.setDate = (value, date)=>{
            return (0, _setDate.setDate)(value, date);
        };
        this.setHours = (value, hours)=>{
            return (0, _setHours.setHours)(value, hours);
        };
        this.setMinutes = (value, minutes)=>{
            return (0, _setMinutes.setMinutes)(value, minutes);
        };
        this.setSeconds = (value, seconds)=>{
            return (0, _setSeconds.setSeconds)(value, seconds);
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return (0, _setMilliseconds.setMilliseconds)(value, milliseconds);
        };
        this.getDaysInMonth = (value)=>{
            return (0, _getDaysInMonth.getDaysInMonth)(value);
        };
        this.getWeekArray = (value)=>{
            const start = this.startOfWeek(this.startOfMonth(value));
            const end = this.endOfWeek(this.endOfMonth(value));
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(this.isBefore(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = this.addDays(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return (0, _getWeek.getWeek)(value, {
                locale: this.locale
            });
        };
        this.getYearRange = ([start, end])=>{
            const startDate = this.startOfYear(start);
            const endDate = this.endOfYear(end);
            const years = [];
            let current = startDate;
            while(this.isBefore(current, endDate)){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
    }
}
exports.AdapterDateFns = AdapterDateFns;

},{"fe236e69ec7473c":"9LtkB","7da78351776bec62":"914CV","7d06c6b944c7bcdb":"5bsQn","754fa60899b87755":"dxbmv","fd77b02a9d896b4e":"4ahXg","1063e9e3719cf242":"2KbJx","c0dfb4f5feb52459":"kcexB","2654b2413e5b6dd5":"exhGp","a38753f3c48388f5":"c6yPR","485754a424aa0176":"a7DrC","c4b61a288b71f132":"1jf5Y","3beda86c75bafb58":"aAeR0","3b5552fcf0f5fbbd":"1YApV","61084442e1a177f8":"7peUb","2d13b5ab9d5b099b":"4gQeo","bdb60cca19b9cacf":"56u9i","1dd902fa5734d0fe":"4wr50","bd328ee7405cf99f":"2dTA9","749084fd88aedc9c":"2K8BV","ef125453af10db68":"aqHTj","a3b9b0978d2939c8":"kscRZ","a4d276f4dc72edf2":"9tjRN","b9007efeb2c32cb3":"lzuuJ","c2635c5bc19ec835":"60o4o","45fbd331067459a3":"95IfH","5d1c9d5a51f5f924":"e8k2N","c68d1324904aa02d":"75yV5","cf1cb5ca2ff0a8c5":"haYJN","95d4f330ba1c8b87":"bBWwD","61d9521e7d12a69":"9eTPI","17488c9a5d966525":"9K5Ak","531edaee357afd24":"9Y44A","fe7edba5668100e4":"h01A3","9c8fa56f169712db":"lyz51","25450aecba224d3d":"6nhUY","9fd433b381a5f709":"4uGq7","a75ce4d07b23c546":"9ng1e","6cc08316a21da774":"cyC4Q","d7858dbbc473994b":"3NdNs","6bf086f75478509d":"9Sgmt","8152570f933bd355":"7uDcT","267c087e8abe52d0":"9y6f8","fb72b6c535c37b94":"aGF1A","152865c260538f81":"iV0Iu"}],"9LtkB":[function(require,module,exports,__globalThis) {
"use strict";
exports.addDays = addDays;
var _index = require("2cd967972a296ad9");
var _index2 = require("f0e78f9c0d91f156");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function addDays(date, amount) {
    const _date = (0, _index.toDate)(date);
    if (isNaN(amount)) return (0, _index2.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

},{"2cd967972a296ad9":"iNzvk","f0e78f9c0d91f156":"i5mc5"}],"iNzvk":[function(require,module,exports,__globalThis) {
"use strict";
exports.toDate = toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

},{}],"i5mc5":[function(require,module,exports,__globalThis) {
"use strict";
exports.constructFrom = constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

},{}],"914CV":[function(require,module,exports,__globalThis) {
"use strict";
exports.addSeconds = addSeconds;
var _index = require("7442afe167e053cc");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function addSeconds(date, amount) {
    return (0, _index.addMilliseconds)(date, amount * 1000);
}

},{"7442afe167e053cc":"1muiy"}],"1muiy":[function(require,module,exports,__globalThis) {
"use strict";
exports.addMilliseconds = addMilliseconds;
var _index = require("701ad4371d122310");
var _index2 = require("fd3355012d608a81");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function addMilliseconds(date, amount) {
    const timestamp = +(0, _index.toDate)(date);
    return (0, _index2.constructFrom)(date, timestamp + amount);
}

},{"701ad4371d122310":"iNzvk","fd3355012d608a81":"i5mc5"}],"5bsQn":[function(require,module,exports,__globalThis) {
"use strict";
exports.addMinutes = addMinutes;
var _index = require("66ff9833f2a7265d");
var _index2 = require("1657f0b8a8702e8e");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function addMinutes(date, amount) {
    return (0, _index.addMilliseconds)(date, amount * _index2.millisecondsInMinute);
}

},{"66ff9833f2a7265d":"1muiy","1657f0b8a8702e8e":"g8xxI"}],"g8xxI":[function(require,module,exports,__globalThis) {
"use strict";
exports.secondsInYear = exports.secondsInWeek = exports.secondsInQuarter = exports.secondsInMonth = exports.secondsInMinute = exports.secondsInHour = exports.secondsInDay = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInYear = exports.minutesInMonth = exports.minutesInHour = exports.minutesInDay = exports.minTime = exports.millisecondsInWeek = exports.millisecondsInSecond = exports.millisecondsInMinute = exports.millisecondsInHour = exports.millisecondsInDay = exports.maxTime = exports.daysInYear = exports.daysInWeek = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const daysInWeek = exports.daysInWeek = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const daysInYear = exports.daysInYear = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const maxTime = exports.maxTime = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const minTime = exports.minTime = -maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const millisecondsInWeek = exports.millisecondsInWeek = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const millisecondsInDay = exports.millisecondsInDay = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const millisecondsInMinute = exports.millisecondsInMinute = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const millisecondsInHour = exports.millisecondsInHour = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const millisecondsInSecond = exports.millisecondsInSecond = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const minutesInYear = exports.minutesInYear = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const minutesInMonth = exports.minutesInMonth = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const minutesInDay = exports.minutesInDay = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const minutesInHour = exports.minutesInHour = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const monthsInQuarter = exports.monthsInQuarter = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const monthsInYear = exports.monthsInYear = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const quartersInYear = exports.quartersInYear = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const secondsInHour = exports.secondsInHour = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const secondsInMinute = exports.secondsInMinute = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const secondsInDay = exports.secondsInDay = secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const secondsInWeek = exports.secondsInWeek = secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const secondsInYear = exports.secondsInYear = secondsInDay * daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const secondsInMonth = exports.secondsInMonth = secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const secondsInQuarter = exports.secondsInQuarter = secondsInMonth * 3;

},{}],"dxbmv":[function(require,module,exports,__globalThis) {
"use strict";
exports.addHours = addHours;
var _index = require("1def4ce2cbf2b5a4");
var _index2 = require("c47db39c292847b5");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function addHours(date, amount) {
    return (0, _index.addMilliseconds)(date, amount * _index2.millisecondsInHour);
}

},{"1def4ce2cbf2b5a4":"1muiy","c47db39c292847b5":"g8xxI"}],"4ahXg":[function(require,module,exports,__globalThis) {
"use strict";
exports.addWeeks = addWeeks;
var _index = require("bdd905550c7c5ab9");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function addWeeks(date, amount) {
    const days = amount * 7;
    return (0, _index.addDays)(date, days);
}

},{"bdd905550c7c5ab9":"9LtkB"}],"2KbJx":[function(require,module,exports,__globalThis) {
"use strict";
exports.addMonths = addMonths;
var _index = require("5742eeee77c6c4dd");
var _index2 = require("79294aad06ee37dd");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function addMonths(date, amount) {
    const _date = (0, _index.toDate)(date);
    if (isNaN(amount)) return (0, _index2.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, _index2.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

},{"5742eeee77c6c4dd":"iNzvk","79294aad06ee37dd":"i5mc5"}],"kcexB":[function(require,module,exports,__globalThis) {
"use strict";
exports.addYears = addYears;
var _index = require("23e70a355800add9");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function addYears(date, amount) {
    return (0, _index.addMonths)(date, amount * 12);
}

},{"23e70a355800add9":"2KbJx"}],"exhGp":[function(require,module,exports,__globalThis) {
"use strict";
exports.endOfDay = endOfDay;
var _index = require("9462caeddacab7ba");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function endOfDay(date) {
    const _date = (0, _index.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"9462caeddacab7ba":"iNzvk"}],"c6yPR":[function(require,module,exports,__globalThis) {
"use strict";
exports.endOfWeek = endOfWeek;
var _index = require("874b81e8096fd15b");
var _index2 = require("54c51a8f0276b53b");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function endOfWeek(date, options) {
    const defaultOptions = (0, _index2.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _index.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"874b81e8096fd15b":"iNzvk","54c51a8f0276b53b":"5a0HW"}],"5a0HW":[function(require,module,exports,__globalThis) {
"use strict";
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
let defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{}],"a7DrC":[function(require,module,exports,__globalThis) {
"use strict";
exports.endOfYear = endOfYear;
var _index = require("bae33049518de779");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function endOfYear(date) {
    const _date = (0, _index.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"bae33049518de779":"iNzvk"}],"1jf5Y":[function(require,module,exports,__globalThis) {
"use strict";
exports.format = exports.formatDate = format;
Object.defineProperty(exports, "formatters", {
    enumerable: true,
    get: function() {
        return _index3.formatters;
    }
});
Object.defineProperty(exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return _index4.longFormatters;
    }
});
var _index = require("7a797645e41ea2c2");
var _index2 = require("2ed033e42fc5189d");
var _index3 = require("e1935e40361258cf");
var _index4 = require("c46187c282bdd45");
var _index5 = require("7528fb990c5ee731");
var _index6 = require("8d66a13aebf60df9");
var _index7 = require("3b5edf3c2ddf1d76");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function format(date, formatStr, options) {
    const defaultOptions = (0, _index2.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? _index.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, _index7.toDate)(date);
    if (!(0, _index6.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match(longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = _index4.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: cleanEscapedString(substring)
        };
        if (_index3.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate,
        weekStartsOn,
        locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, _index5.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, _index5.isProtectedDayOfYearToken)(token)) (0, _index5.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = _index3.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function cleanEscapedString(input) {
    const matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"7a797645e41ea2c2":"7YCyx","2ed033e42fc5189d":"5a0HW","e1935e40361258cf":"01Q06","c46187c282bdd45":"wFG4J","7528fb990c5ee731":"3ROcr","8d66a13aebf60df9":"haYJN","3b5edf3c2ddf1d76":"iNzvk"}],"7YCyx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return _index.enUS;
    }
});
var _index = require("537dc8c80b85612c");

},{"537dc8c80b85612c":"aGF1A"}],"aGF1A":[function(require,module,exports,__globalThis) {
"use strict";
exports.enUS = void 0;
var _index = require("479d03a18c245c3e");
var _index2 = require("b9e3c763ad65c41a");
var _index3 = require("6451586d149703ed");
var _index4 = require("cbddf07e540dd382");
var _index5 = require("3002f8fbc231e7a1");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const enUS = exports.enUS = {
    code: "en-US",
    formatDistance: _index.formatDistance,
    formatLong: _index2.formatLong,
    formatRelative: _index3.formatRelative,
    localize: _index4.localize,
    match: _index5.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

},{"479d03a18c245c3e":"fC1uj","b9e3c763ad65c41a":"fElyY","6451586d149703ed":"1o2G6","cbddf07e540dd382":"2PvvB","3002f8fbc231e7a1":"ar6et"}],"fC1uj":[function(require,module,exports,__globalThis) {
"use strict";
exports.formatDistance = void 0;
const formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
exports.formatDistance = formatDistance;

},{}],"fElyY":[function(require,module,exports,__globalThis) {
"use strict";
exports.formatLong = void 0;
var _index = require("4800af73d892e7a");
const dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const formatLong = exports.formatLong = {
    date: (0, _index.buildFormatLongFn)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _index.buildFormatLongFn)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _index.buildFormatLongFn)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};

},{"4800af73d892e7a":"9snDt"}],"9snDt":[function(require,module,exports,__globalThis) {
"use strict";
exports.buildFormatLongFn = buildFormatLongFn;
function buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{}],"1o2G6":[function(require,module,exports,__globalThis) {
"use strict";
exports.formatRelative = void 0;
const formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const formatRelative = (token, _date, _baseDate, _options)=>formatRelativeLocale[token];
exports.formatRelative = formatRelative;

},{}],"2PvvB":[function(require,module,exports,__globalThis) {
"use strict";
exports.localize = void 0;
var _index = require("78e7236a2f110627");
const eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const localize = exports.localize = {
    ordinalNumber,
    era: (0, _index.buildLocalizeFn)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _index.buildLocalizeFn)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, _index.buildLocalizeFn)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _index.buildLocalizeFn)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _index.buildLocalizeFn)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

},{"78e7236a2f110627":"dIBXh"}],"dIBXh":[function(require,module,exports,__globalThis) {
"use strict";
exports.buildLocalizeFn = buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{}],"ar6et":[function(require,module,exports,__globalThis) {
"use strict";
exports.match = void 0;
var _index = require("befc9b9f4e6afb32");
var _index2 = require("be7528ef34a1226");
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const match = exports.match = {
    ordinalNumber: (0, _index2.buildMatchPatternFn)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, _index.buildMatchFn)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _index.buildMatchFn)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, _index.buildMatchFn)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _index.buildMatchFn)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _index.buildMatchFn)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

},{"befc9b9f4e6afb32":"ahNTR","be7528ef34a1226":"i3Bj2"}],"ahNTR":[function(require,module,exports,__globalThis) {
"use strict";
exports.buildMatchFn = buildMatchFn;
function buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}
function findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{}],"i3Bj2":[function(require,module,exports,__globalThis) {
"use strict";
exports.buildMatchPatternFn = buildMatchPatternFn;
function buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}

},{}],"01Q06":[function(require,module,exports,__globalThis) {
"use strict";
exports.formatters = void 0;
var _index = require("2b70b701cccd48ba");
var _index2 = require("ce71b00fa268a334");
var _index3 = require("be1f4bd5db98fc0b");
var _index4 = require("4d35ee8b95213cb2");
var _index5 = require("31a9b5233efbdb74");
var _index6 = require("c78164dd4be2dfdf");
var _index7 = require("c129443cf4e77b69");
const dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const formatters = exports.formatters = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return _index7.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, _index5.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, _index6.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _index6.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, _index3.getISOWeekYear)(date);
        // Padding
        return (0, _index6.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, _index6.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _index6.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _index6.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return _index7.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _index6.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, _index4.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _index6.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, _index2.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _index6.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return _index7.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, _index.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _index6.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _index6.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _index6.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _index6.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return _index7.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return _index7.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _index6.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _index6.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return _index7.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return _index7.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return _index7.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, _index6.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, _index6.addLeadingZeros)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, _index6.addLeadingZeros)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, _index6.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, _index6.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, _index6.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

},{"2b70b701cccd48ba":"40fnp","ce71b00fa268a334":"5Vq1Y","be1f4bd5db98fc0b":"iKJMr","4d35ee8b95213cb2":"2K8BV","31a9b5233efbdb74":"hFGxC","c78164dd4be2dfdf":"2Ji0z","c129443cf4e77b69":"cPJWL"}],"40fnp":[function(require,module,exports,__globalThis) {
"use strict";
exports.getDayOfYear = getDayOfYear;
var _index = require("e4c17eecd713ff7a");
var _index2 = require("984c12d93b064944");
var _index3 = require("92e9542334495a7a");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function getDayOfYear(date) {
    const _date = (0, _index3.toDate)(date);
    const diff = (0, _index.differenceInCalendarDays)(_date, (0, _index2.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

},{"e4c17eecd713ff7a":"bNYW8","984c12d93b064944":"7uDcT","92e9542334495a7a":"iNzvk"}],"bNYW8":[function(require,module,exports,__globalThis) {
"use strict";
exports.differenceInCalendarDays = differenceInCalendarDays;
var _index = require("1d847bb4e92f7cd2");
var _index2 = require("7c9c2b23ec3dd965");
var _index3 = require("b0f56dce4f1af165");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, _index2.startOfDay)(dateLeft);
    const startOfDayRight = (0, _index2.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, _index3.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, _index3.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / _index.millisecondsInDay);
}

},{"1d847bb4e92f7cd2":"g8xxI","7c9c2b23ec3dd965":"9ng1e","b0f56dce4f1af165":"ksNVf"}],"9ng1e":[function(require,module,exports,__globalThis) {
"use strict";
exports.startOfDay = startOfDay;
var _index = require("b2c84f6728c789fd");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function startOfDay(date) {
    const _date = (0, _index.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"b2c84f6728c789fd":"iNzvk"}],"ksNVf":[function(require,module,exports,__globalThis) {
"use strict";
exports.getTimezoneOffsetInMilliseconds = getTimezoneOffsetInMilliseconds;
var _index = require("dd2f8ad2d4e94e96");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, _index.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

},{"dd2f8ad2d4e94e96":"iNzvk"}],"7uDcT":[function(require,module,exports,__globalThis) {
"use strict";
exports.startOfYear = startOfYear;
var _index = require("29a7a92b30a86c8c");
var _index2 = require("151cc5db30a5792f");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function startOfYear(date) {
    const cleanDate = (0, _index.toDate)(date);
    const _date = (0, _index2.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"29a7a92b30a86c8c":"iNzvk","151cc5db30a5792f":"i5mc5"}],"5Vq1Y":[function(require,module,exports,__globalThis) {
"use strict";
exports.getISOWeek = getISOWeek;
var _index = require("dd6520a678bb82fc");
var _index2 = require("4086029c683d4450");
var _index3 = require("5ae2977ff2643258");
var _index4 = require("e810a780c889259");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function getISOWeek(date) {
    const _date = (0, _index4.toDate)(date);
    const diff = +(0, _index2.startOfISOWeek)(_date) - +(0, _index3.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / _index.millisecondsInWeek) + 1;
}

},{"dd6520a678bb82fc":"g8xxI","4086029c683d4450":"4qSPp","5ae2977ff2643258":"2FuW7","e810a780c889259":"iNzvk"}],"4qSPp":[function(require,module,exports,__globalThis) {
"use strict";
exports.startOfISOWeek = startOfISOWeek;
var _index = require("af053f1a0e32a5c7");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfISOWeek(date) {
    return (0, _index.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

},{"af053f1a0e32a5c7":"9Sgmt"}],"9Sgmt":[function(require,module,exports,__globalThis) {
"use strict";
exports.startOfWeek = startOfWeek;
var _index = require("55694623f1e86518");
var _index2 = require("95f2b89022ff2bba");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfWeek(date, options) {
    const defaultOptions = (0, _index2.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _index.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"55694623f1e86518":"iNzvk","95f2b89022ff2bba":"5a0HW"}],"2FuW7":[function(require,module,exports,__globalThis) {
"use strict";
exports.startOfISOWeekYear = startOfISOWeekYear;
var _index = require("a94c8ed604a9d595");
var _index2 = require("2ab3fd1ace85020d");
var _index3 = require("3de294871cd3bca4");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function startOfISOWeekYear(date) {
    const year = (0, _index.getISOWeekYear)(date);
    const fourthOfJanuary = (0, _index3.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, _index2.startOfISOWeek)(fourthOfJanuary);
}

},{"a94c8ed604a9d595":"iKJMr","2ab3fd1ace85020d":"4qSPp","3de294871cd3bca4":"i5mc5"}],"iKJMr":[function(require,module,exports,__globalThis) {
"use strict";
exports.getISOWeekYear = getISOWeekYear;
var _index = require("931ddb1ed96783e");
var _index2 = require("657e416c92daae6d");
var _index3 = require("df657aff16d6d4b4");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function getISOWeekYear(date) {
    const _date = (0, _index3.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, _index.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _index2.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, _index.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _index2.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"931ddb1ed96783e":"i5mc5","657e416c92daae6d":"4qSPp","df657aff16d6d4b4":"iNzvk"}],"2K8BV":[function(require,module,exports,__globalThis) {
"use strict";
exports.getWeek = getWeek;
var _index = require("800ec1a6edc498ae");
var _index2 = require("5469df090b94480b");
var _index3 = require("28ef936dfd692f02");
var _index4 = require("9206fd6ff40c35c");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function getWeek(date, options) {
    const _date = (0, _index4.toDate)(date);
    const diff = +(0, _index2.startOfWeek)(_date, options) - +(0, _index3.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / _index.millisecondsInWeek) + 1;
}

},{"800ec1a6edc498ae":"g8xxI","5469df090b94480b":"9Sgmt","28ef936dfd692f02":"7JMwq","9206fd6ff40c35c":"iNzvk"}],"7JMwq":[function(require,module,exports,__globalThis) {
"use strict";
exports.startOfWeekYear = startOfWeekYear;
var _index = require("14264660eed87479");
var _index2 = require("ed79bb16479293f4");
var _index3 = require("6d62705f140db78b");
var _index4 = require("81264b991a2a077c");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function startOfWeekYear(date, options) {
    const defaultOptions = (0, _index4.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, _index2.getWeekYear)(date, options);
    const firstWeek = (0, _index.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, _index3.startOfWeek)(firstWeek, options);
    return _date;
}

},{"14264660eed87479":"i5mc5","ed79bb16479293f4":"hFGxC","6d62705f140db78b":"9Sgmt","81264b991a2a077c":"5a0HW"}],"hFGxC":[function(require,module,exports,__globalThis) {
"use strict";
exports.getWeekYear = getWeekYear;
var _index = require("49bcd86a127941a3");
var _index2 = require("e4e186ff29cb44fa");
var _index3 = require("639f7e4c63562544");
var _index4 = require("cda7b6367e92badd");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function getWeekYear(date, options) {
    const _date = (0, _index3.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, _index4.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, _index.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _index2.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, _index.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _index2.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"49bcd86a127941a3":"i5mc5","e4e186ff29cb44fa":"9Sgmt","639f7e4c63562544":"iNzvk","cda7b6367e92badd":"5a0HW"}],"2Ji0z":[function(require,module,exports,__globalThis) {
"use strict";
exports.addLeadingZeros = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

},{}],"cPJWL":[function(require,module,exports,__globalThis) {
"use strict";
exports.lightFormatters = void 0;
var _index = require("90a72a8e36ccc405");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const lightFormatters = exports.lightFormatters = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _index.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, _index.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, _index.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, _index.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, _index.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, _index.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, _index.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _index.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

},{"90a72a8e36ccc405":"2Ji0z"}],"wFG4J":[function(require,module,exports,__globalThis) {
"use strict";
exports.longFormatters = void 0;
const dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
const longFormatters = exports.longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};

},{}],"3ROcr":[function(require,module,exports,__globalThis) {
"use strict";
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.warnOrThrowProtectedError = warnOrThrowProtectedError;
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
    return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
    const _message = message(token, format, input);
    console.warn(_message);
    if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

},{}],"haYJN":[function(require,module,exports,__globalThis) {
"use strict";
exports.isValid = isValid;
var _index = require("187bc6a11beb8cf7");
var _index2 = require("fd0d651c7906f3f7");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function isValid(date) {
    if (!(0, _index.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, _index2.toDate)(date);
    return !isNaN(Number(_date));
}

},{"187bc6a11beb8cf7":"ibXAX","fd0d651c7906f3f7":"iNzvk"}],"ibXAX":[function(require,module,exports,__globalThis) {
"use strict";
exports.isDate = isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

},{}],"aAeR0":[function(require,module,exports,__globalThis) {
"use strict";
exports.getDate = getDate;
var _index = require("99a30b597441916f");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function getDate(date) {
    const _date = (0, _index.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

},{"99a30b597441916f":"iNzvk"}],"1YApV":[function(require,module,exports,__globalThis) {
"use strict";
exports.getDaysInMonth = getDaysInMonth;
var _index = require("ce5d8149ab8c0adb");
var _index2 = require("160593c36b918fdc");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function getDaysInMonth(date) {
    const _date = (0, _index.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, _index2.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"ce5d8149ab8c0adb":"iNzvk","160593c36b918fdc":"i5mc5"}],"7peUb":[function(require,module,exports,__globalThis) {
"use strict";
exports.getHours = getHours;
var _index = require("dd6beddad3762c0e");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function getHours(date) {
    const _date = (0, _index.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

},{"dd6beddad3762c0e":"iNzvk"}],"4gQeo":[function(require,module,exports,__globalThis) {
"use strict";
exports.getMinutes = getMinutes;
var _index = require("942a2ec019737ce6");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function getMinutes(date) {
    const _date = (0, _index.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

},{"942a2ec019737ce6":"iNzvk"}],"56u9i":[function(require,module,exports,__globalThis) {
"use strict";
exports.getMonth = getMonth;
var _index = require("72421b25c2b051d4");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function getMonth(date) {
    const _date = (0, _index.toDate)(date);
    const month = _date.getMonth();
    return month;
}

},{"72421b25c2b051d4":"iNzvk"}],"4wr50":[function(require,module,exports,__globalThis) {
"use strict";
exports.getSeconds = getSeconds;
var _index = require("66e87215fb77615b");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function getSeconds(date) {
    const _date = (0, _index.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

},{"66e87215fb77615b":"iNzvk"}],"2dTA9":[function(require,module,exports,__globalThis) {
"use strict";
exports.getMilliseconds = getMilliseconds;
var _index = require("d90c57ddf052ab34");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function getMilliseconds(date) {
    const _date = (0, _index.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}

},{"d90c57ddf052ab34":"iNzvk"}],"aqHTj":[function(require,module,exports,__globalThis) {
"use strict";
exports.getYear = getYear;
var _index = require("3a87a8c7949402ce");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function getYear(date) {
    return (0, _index.toDate)(date).getFullYear();
}

},{"3a87a8c7949402ce":"iNzvk"}],"kscRZ":[function(require,module,exports,__globalThis) {
"use strict";
exports.isAfter = isAfter;
var _index = require("d53a6d6418b9cc58");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function isAfter(date, dateToCompare) {
    const _date = (0, _index.toDate)(date);
    const _dateToCompare = (0, _index.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

},{"d53a6d6418b9cc58":"iNzvk"}],"9tjRN":[function(require,module,exports,__globalThis) {
"use strict";
exports.isBefore = isBefore;
var _index = require("29711cec40df889c");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function isBefore(date, dateToCompare) {
    const _date = (0, _index.toDate)(date);
    const _dateToCompare = (0, _index.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

},{"29711cec40df889c":"iNzvk"}],"lzuuJ":[function(require,module,exports,__globalThis) {
"use strict";
exports.isEqual = isEqual;
var _index = require("b079eb760d97c297");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function isEqual(leftDate, rightDate) {
    const _dateLeft = (0, _index.toDate)(leftDate);
    const _dateRight = (0, _index.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

},{"b079eb760d97c297":"iNzvk"}],"60o4o":[function(require,module,exports,__globalThis) {
"use strict";
exports.isSameDay = isSameDay;
var _index = require("404d3af83c6a3510");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, _index.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, _index.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

},{"404d3af83c6a3510":"9ng1e"}],"95IfH":[function(require,module,exports,__globalThis) {
"use strict";
exports.isSameYear = isSameYear;
var _index = require("cf2635c669070340");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, _index.toDate)(dateLeft);
    const _dateRight = (0, _index.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

},{"cf2635c669070340":"iNzvk"}],"e8k2N":[function(require,module,exports,__globalThis) {
"use strict";
exports.isSameMonth = isSameMonth;
var _index = require("23bd545f1d63f8a8");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, _index.toDate)(dateLeft);
    const _dateRight = (0, _index.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

},{"23bd545f1d63f8a8":"iNzvk"}],"75yV5":[function(require,module,exports,__globalThis) {
"use strict";
exports.isSameHour = isSameHour;
var _index = require("92c6a40dfa7c3154");
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, _index.startOfHour)(dateLeft);
    const dateRightStartOfHour = (0, _index.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}

},{"92c6a40dfa7c3154":"RTojT"}],"RTojT":[function(require,module,exports,__globalThis) {
"use strict";
exports.startOfHour = startOfHour;
var _index = require("9638b175da3d3e66");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function startOfHour(date) {
    const _date = (0, _index.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}

},{"9638b175da3d3e66":"iNzvk"}],"bBWwD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return _index5.longFormatters;
    }
});
exports.parse = parse;
Object.defineProperty(exports, "parsers", {
    enumerable: true,
    get: function() {
        return _index7.parsers;
    }
});
var _index = require("c53acb33da1787e9");
var _index2 = require("137ba7b89008c236");
var _index3 = require("2c4f28d92a378acf");
var _index4 = require("6071c86d3eb95bcf");
var _index5 = require("adb831f4e34cf8d0");
var _index6 = require("26eed989fb024afe");
var _index7 = require("8e4cd03974d82cc0");
var _Setter = require("264f22812daf122f");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, _index2.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? _index3.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, _index4.toDate)(referenceDate);
        else return (0, _index.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate,
        weekStartsOn,
        locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new _Setter.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match(longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in _index5.longFormatters) {
            const longFormatter = _index5.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, _index6.isProtectedWeekYearToken)(token)) (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, _index6.isProtectedDayOfYearToken)(token)) (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = _index7.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, _index.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, _index.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) return (0, _index.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, _index4.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, _index.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, _index.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, _index.constructFrom)(referenceDate, date);
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"c53acb33da1787e9":"i5mc5","137ba7b89008c236":"67rzU","2c4f28d92a378acf":"7YCyx","6071c86d3eb95bcf":"iNzvk","adb831f4e34cf8d0":"wFG4J","26eed989fb024afe":"3ROcr","8e4cd03974d82cc0":"9vF5C","264f22812daf122f":"hvBY0"}],"67rzU":[function(require,module,exports,__globalThis) {
"use strict";
exports.getDefaultOptions = getDefaultOptions;
var _index = require("4c8d0c918921978e");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function getDefaultOptions() {
    return Object.assign({}, (0, _index.getDefaultOptions)());
}

},{"4c8d0c918921978e":"5a0HW"}],"9vF5C":[function(require,module,exports,__globalThis) {
"use strict";
exports.parsers = void 0;
var _EraParser = require("73877e75490bba35");
var _YearParser = require("534dbfd035c7afae");
var _LocalWeekYearParser = require("ab4450ec135364ae");
var _ISOWeekYearParser = require("85d23a44ac18532c");
var _ExtendedYearParser = require("179a88ef12f61a71");
var _QuarterParser = require("93232ed2f05ef2c3");
var _StandAloneQuarterParser = require("c7c6a63c21fda1ba");
var _MonthParser = require("9ccf03b202560527");
var _StandAloneMonthParser = require("250a7296cb9bd5d4");
var _LocalWeekParser = require("bcc281e24017fb49");
var _ISOWeekParser = require("b4a87b1ad452a0e8");
var _DateParser = require("ad6bc827b2f368e4");
var _DayOfYearParser = require("bb234ddd84c3b240");
var _DayParser = require("2d736796a40046e7");
var _LocalDayParser = require("f161fb5cee20fef5");
var _StandAloneLocalDayParser = require("3943fd5b7ea48b68");
var _ISODayParser = require("86ddbd54e3fa3dd2");
var _AMPMParser = require("b283318e653dbb40");
var _AMPMMidnightParser = require("d8c3b56df6ed7ec1");
var _DayPeriodParser = require("2c8f7cc10db4bdc2");
var _Hour1to12Parser = require("c7c3fbe3abdaa79c");
var _Hour0to23Parser = require("3a24c22368eeaf29");
var _Hour0To11Parser = require("7689b873a1aa23cf");
var _Hour1To24Parser = require("f2e24da70f1ce437");
var _MinuteParser = require("5b7be433eba9622a");
var _SecondParser = require("810daf17248738a9");
var _FractionOfSecondParser = require("7e5fdf1f35b534dd");
var _ISOTimezoneWithZParser = require("46cb8c323b79446f");
var _ISOTimezoneParser = require("1eeadf9bee6760d9");
var _TimestampSecondsParser = require("41f3d3eb54e297d3");
var _TimestampMillisecondsParser = require("85a0d4684faae6f7");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const parsers = exports.parsers = {
    G: new _EraParser.EraParser(),
    y: new _YearParser.YearParser(),
    Y: new _LocalWeekYearParser.LocalWeekYearParser(),
    R: new _ISOWeekYearParser.ISOWeekYearParser(),
    u: new _ExtendedYearParser.ExtendedYearParser(),
    Q: new _QuarterParser.QuarterParser(),
    q: new _StandAloneQuarterParser.StandAloneQuarterParser(),
    M: new _MonthParser.MonthParser(),
    L: new _StandAloneMonthParser.StandAloneMonthParser(),
    w: new _LocalWeekParser.LocalWeekParser(),
    I: new _ISOWeekParser.ISOWeekParser(),
    d: new _DateParser.DateParser(),
    D: new _DayOfYearParser.DayOfYearParser(),
    E: new _DayParser.DayParser(),
    e: new _LocalDayParser.LocalDayParser(),
    c: new _StandAloneLocalDayParser.StandAloneLocalDayParser(),
    i: new _ISODayParser.ISODayParser(),
    a: new _AMPMParser.AMPMParser(),
    b: new _AMPMMidnightParser.AMPMMidnightParser(),
    B: new _DayPeriodParser.DayPeriodParser(),
    h: new _Hour1to12Parser.Hour1to12Parser(),
    H: new _Hour0to23Parser.Hour0to23Parser(),
    K: new _Hour0To11Parser.Hour0To11Parser(),
    k: new _Hour1To24Parser.Hour1To24Parser(),
    m: new _MinuteParser.MinuteParser(),
    s: new _SecondParser.SecondParser(),
    S: new _FractionOfSecondParser.FractionOfSecondParser(),
    X: new _ISOTimezoneWithZParser.ISOTimezoneWithZParser(),
    x: new _ISOTimezoneParser.ISOTimezoneParser(),
    t: new _TimestampSecondsParser.TimestampSecondsParser(),
    T: new _TimestampMillisecondsParser.TimestampMillisecondsParser()
};

},{"73877e75490bba35":"9F82z","534dbfd035c7afae":"jJwTF","ab4450ec135364ae":"jwIX2","85d23a44ac18532c":"hgurd","179a88ef12f61a71":"e3WMT","93232ed2f05ef2c3":"cXtJR","c7c6a63c21fda1ba":"604eG","9ccf03b202560527":"d3GDo","250a7296cb9bd5d4":"6vdhZ","bcc281e24017fb49":"fCdfI","b4a87b1ad452a0e8":"b0Y83","ad6bc827b2f368e4":"3ZB1L","bb234ddd84c3b240":"iracY","2d736796a40046e7":"hPp2h","f161fb5cee20fef5":"gSkSD","3943fd5b7ea48b68":"k6LON","86ddbd54e3fa3dd2":"6TozN","b283318e653dbb40":"7NCtO","d8c3b56df6ed7ec1":"3cipL","2c8f7cc10db4bdc2":"2t9k6","c7c3fbe3abdaa79c":"dNiTt","3a24c22368eeaf29":"4wteR","7689b873a1aa23cf":"1T1SS","f2e24da70f1ce437":"9sIEF","5b7be433eba9622a":"7VtQX","810daf17248738a9":"gNT94","7e5fdf1f35b534dd":"9iohU","46cb8c323b79446f":"b6LlA","1eeadf9bee6760d9":"1mjKF","41f3d3eb54e297d3":"2hBda","85a0d4684faae6f7":"1KD6q"}],"9F82z":[function(require,module,exports,__globalThis) {
"use strict";
exports.EraParser = void 0;
var _Parser = require("3b6644e454c96bd5");
class EraParser extends _Parser.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
exports.EraParser = EraParser;

},{"3b6644e454c96bd5":"joEGc"}],"joEGc":[function(require,module,exports,__globalThis) {
"use strict";
exports.Parser = void 0;
var _Setter = require("f9ccbe426415522b");
class Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new _Setter.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
exports.Parser = Parser;

},{"f9ccbe426415522b":"hvBY0"}],"hvBY0":[function(require,module,exports,__globalThis) {
"use strict";
exports.ValueSetter = exports.Setter = exports.DateToSystemTimezoneSetter = void 0;
var _index = require("22daacd9886737df");
var _index2 = require("80c3b8dc52dd858");
const TIMEZONE_UNIT_PRIORITY = 10;
class Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
exports.Setter = Setter;
class ValueSetter extends Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
exports.ValueSetter = ValueSetter;
class DateToSystemTimezoneSetter extends Setter {
    priority = TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, _index2.constructFrom)(date, (0, _index.transpose)(date, Date));
    }
}
exports.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter;

},{"22daacd9886737df":"KJurs","80c3b8dc52dd858":"i5mc5"}],"KJurs":[function(require,module,exports,__globalThis) {
"use strict";
exports.transpose = transpose;
var _index = require("e4cedfb3eb078b8e");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, _index.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

},{"e4cedfb3eb078b8e":"i5mc5"}],"jJwTF":[function(require,module,exports,__globalThis) {
"use strict";
exports.YearParser = void 0;
var _Parser = require("410cdd8b24ffe202");
var _utils = require("feb431ad5324f1c2");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class YearParser extends _Parser.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
exports.YearParser = YearParser;

},{"410cdd8b24ffe202":"joEGc","feb431ad5324f1c2":"bkc73"}],"bkc73":[function(require,module,exports,__globalThis) {
"use strict";
exports.dayPeriodEnumToHours = dayPeriodEnumToHours;
exports.isLeapYearIndex = isLeapYearIndex;
exports.mapValue = mapValue;
exports.normalizeTwoDigitYear = normalizeTwoDigitYear;
exports.parseAnyDigitsSigned = parseAnyDigitsSigned;
exports.parseNDigits = parseNDigits;
exports.parseNDigitsSigned = parseNDigitsSigned;
exports.parseNumericPattern = parseNumericPattern;
exports.parseTimezonePattern = parseTimezonePattern;
var _index = require("730ab950da1e266b");
var _constants = require("be7ba8dce2178d09");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * _index.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern(_constants.numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern(_constants.numericPatterns.singleDigit, dateString);
        case 2:
            return parseNumericPattern(_constants.numericPatterns.twoDigits, dateString);
        case 3:
            return parseNumericPattern(_constants.numericPatterns.threeDigits, dateString);
        case 4:
            return parseNumericPattern(_constants.numericPatterns.fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern(_constants.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern(_constants.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern(_constants.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern(_constants.numericPatterns.fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"730ab950da1e266b":"g8xxI","be7ba8dce2178d09":"cLNjW"}],"cLNjW":[function(require,module,exports,__globalThis) {
"use strict";
exports.timezonePatterns = exports.numericPatterns = void 0;
const numericPatterns = exports.numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const timezonePatterns = exports.timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{}],"jwIX2":[function(require,module,exports,__globalThis) {
"use strict";
exports.LocalWeekYearParser = void 0;
var _index = require("c7a1c4cdd11de749");
var _index2 = require("36ab983d3ac96e94");
var _Parser = require("2580105d5efe4503");
var _utils = require("e7bc0ea0bf35d979");
// Local week-numbering year
class LocalWeekYearParser extends _Parser.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, _index.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, _index2.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, _index2.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
exports.LocalWeekYearParser = LocalWeekYearParser;

},{"c7a1c4cdd11de749":"hFGxC","36ab983d3ac96e94":"9Sgmt","2580105d5efe4503":"joEGc","e7bc0ea0bf35d979":"bkc73"}],"hgurd":[function(require,module,exports,__globalThis) {
"use strict";
exports.ISOWeekYearParser = void 0;
var _index = require("e78417787f8e8167");
var _index2 = require("ac68ccd301053769");
var _Parser = require("996e304581b01cde");
var _utils = require("338b9c7449577074");
// ISO week-numbering year
class ISOWeekYearParser extends _Parser.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, _utils.parseNDigitsSigned)(4, dateString);
        return (0, _utils.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, _index2.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, _index.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.ISOWeekYearParser = ISOWeekYearParser;

},{"e78417787f8e8167":"4qSPp","ac68ccd301053769":"i5mc5","996e304581b01cde":"joEGc","338b9c7449577074":"bkc73"}],"e3WMT":[function(require,module,exports,__globalThis) {
"use strict";
exports.ExtendedYearParser = void 0;
var _Parser = require("14062af0868fbb7b");
var _utils = require("1b6df6d2682df22c");
class ExtendedYearParser extends _Parser.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, _utils.parseNDigitsSigned)(4, dateString);
        return (0, _utils.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.ExtendedYearParser = ExtendedYearParser;

},{"14062af0868fbb7b":"joEGc","1b6df6d2682df22c":"bkc73"}],"cXtJR":[function(require,module,exports,__globalThis) {
"use strict";
exports.QuarterParser = void 0;
var _Parser = require("2c403512ee0b4449");
var _utils = require("16f449bb6db64ee7");
class QuarterParser extends _Parser.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, _utils.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.QuarterParser = QuarterParser;

},{"2c403512ee0b4449":"joEGc","16f449bb6db64ee7":"bkc73"}],"604eG":[function(require,module,exports,__globalThis) {
"use strict";
exports.StandAloneQuarterParser = void 0;
var _Parser = require("90bdba2189236368");
var _utils = require("ac5cbd54eec0970d");
class StandAloneQuarterParser extends _Parser.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, _utils.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.StandAloneQuarterParser = StandAloneQuarterParser;

},{"90bdba2189236368":"joEGc","ac5cbd54eec0970d":"bkc73"}],"d3GDo":[function(require,module,exports,__globalThis) {
"use strict";
exports.MonthParser = void 0;
var _constants = require("3ca19f0e27bab599");
var _Parser = require("3b0e5e45825bc96f");
var _utils = require("73c2131545335241");
class MonthParser extends _Parser.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
exports.MonthParser = MonthParser;

},{"3ca19f0e27bab599":"cLNjW","3b0e5e45825bc96f":"joEGc","73c2131545335241":"bkc73"}],"6vdhZ":[function(require,module,exports,__globalThis) {
"use strict";
exports.StandAloneMonthParser = void 0;
var _constants = require("98e1a06b2ff3c4de");
var _Parser = require("e11ccdcf59f2f7dd");
var _utils = require("e8b8449d7a3b60c1");
class StandAloneMonthParser extends _Parser.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.StandAloneMonthParser = StandAloneMonthParser;

},{"98e1a06b2ff3c4de":"cLNjW","e11ccdcf59f2f7dd":"joEGc","e8b8449d7a3b60c1":"bkc73"}],"fCdfI":[function(require,module,exports,__globalThis) {
"use strict";
exports.LocalWeekParser = void 0;
var _index = require("13c2e2bf3016fdd5");
var _index2 = require("bbf7e0dcf711535f");
var _constants = require("2601195a0e99a978");
var _Parser = require("d6e7369fa8c2f278");
var _utils = require("1193e0f5bcd19001");
// Local week of year
class LocalWeekParser extends _Parser.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, _index2.startOfWeek)((0, _index.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
exports.LocalWeekParser = LocalWeekParser;

},{"13c2e2bf3016fdd5":"ivs4I","bbf7e0dcf711535f":"9Sgmt","2601195a0e99a978":"cLNjW","d6e7369fa8c2f278":"joEGc","1193e0f5bcd19001":"bkc73"}],"ivs4I":[function(require,module,exports,__globalThis) {
"use strict";
exports.setWeek = setWeek;
var _index = require("d61926e41e1e9dfc");
var _index2 = require("d8306f2d82e3f3b8");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function setWeek(date, week, options) {
    const _date = (0, _index2.toDate)(date);
    const diff = (0, _index.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

},{"d61926e41e1e9dfc":"2K8BV","d8306f2d82e3f3b8":"iNzvk"}],"b0Y83":[function(require,module,exports,__globalThis) {
"use strict";
exports.ISOWeekParser = void 0;
var _index = require("d0e9d8806b690ddf");
var _index2 = require("5eec22592445f1f4");
var _constants = require("1dcdea171de1c1d9");
var _Parser = require("3569999127d8de4");
var _utils = require("3c620a00554fc0c1");
// ISO week of year
class ISOWeekParser extends _Parser.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, _index2.startOfISOWeek)((0, _index.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.ISOWeekParser = ISOWeekParser;

},{"d0e9d8806b690ddf":"bOsWX","5eec22592445f1f4":"4qSPp","1dcdea171de1c1d9":"cLNjW","3569999127d8de4":"joEGc","3c620a00554fc0c1":"bkc73"}],"bOsWX":[function(require,module,exports,__globalThis) {
"use strict";
exports.setISOWeek = setISOWeek;
var _index = require("8291d064c3f19d2b");
var _index2 = require("2a6c0f5e0da284fe");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function setISOWeek(date, week) {
    const _date = (0, _index2.toDate)(date);
    const diff = (0, _index.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

},{"8291d064c3f19d2b":"5Vq1Y","2a6c0f5e0da284fe":"iNzvk"}],"3ZB1L":[function(require,module,exports,__globalThis) {
"use strict";
exports.DateParser = void 0;
var _constants = require("e37bf0ec17405e58");
var _Parser = require("e06fd271e217a3f4");
var _utils = require("19b066b35011bfca");
const DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class DateParser extends _Parser.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, _utils.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.DateParser = DateParser;

},{"e37bf0ec17405e58":"cLNjW","e06fd271e217a3f4":"joEGc","19b066b35011bfca":"bkc73"}],"iracY":[function(require,module,exports,__globalThis) {
"use strict";
exports.DayOfYearParser = void 0;
var _constants = require("83fbe2027339aec5");
var _Parser = require("332eeceadb0ccc98");
var _utils = require("73a8ca34cfbb7597");
class DayOfYearParser extends _Parser.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, _utils.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.DayOfYearParser = DayOfYearParser;

},{"83fbe2027339aec5":"cLNjW","332eeceadb0ccc98":"joEGc","73a8ca34cfbb7597":"bkc73"}],"hPp2h":[function(require,module,exports,__globalThis) {
"use strict";
exports.DayParser = void 0;
var _index = require("b83dfcd67991d62c");
var _Parser = require("57319c0f2f714850");
// Day of week
class DayParser extends _Parser.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, _index.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.DayParser = DayParser;

},{"b83dfcd67991d62c":"5MbvY","57319c0f2f714850":"joEGc"}],"5MbvY":[function(require,module,exports,__globalThis) {
"use strict";
exports.setDay = setDay;
var _index = require("ea54a94a012b3b70");
var _index2 = require("e25634d79be71669");
var _index3 = require("10936b78e6318933");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function setDay(date, day, options) {
    const defaultOptions = (0, _index3.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _index2.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, _index.addDays)(_date, diff);
}

},{"ea54a94a012b3b70":"9LtkB","e25634d79be71669":"iNzvk","10936b78e6318933":"5a0HW"}],"gSkSD":[function(require,module,exports,__globalThis) {
"use strict";
exports.LocalDayParser = void 0;
var _index = require("bb1b3f00c539097f");
var _Parser = require("6571efdf5566e23");
var _utils = require("59a554a051b6be38");
// Local day of week
class LocalDayParser extends _Parser.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, _index.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
exports.LocalDayParser = LocalDayParser;

},{"bb1b3f00c539097f":"5MbvY","6571efdf5566e23":"joEGc","59a554a051b6be38":"bkc73"}],"k6LON":[function(require,module,exports,__globalThis) {
"use strict";
exports.StandAloneLocalDayParser = void 0;
var _index = require("d9dbe8f35d194adf");
var _Parser = require("270cd8e0745b64ff");
var _utils = require("2894fe8ea24065ec");
// Stand-alone local day of week
class StandAloneLocalDayParser extends _Parser.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, _index.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
exports.StandAloneLocalDayParser = StandAloneLocalDayParser;

},{"d9dbe8f35d194adf":"5MbvY","270cd8e0745b64ff":"joEGc","2894fe8ea24065ec":"bkc73"}],"6TozN":[function(require,module,exports,__globalThis) {
"use strict";
exports.ISODayParser = void 0;
var _index = require("8d5cfff7f7eb5ee5");
var _Parser = require("f0244744717726df");
var _utils = require("bf9b3cd7754e213e");
// ISO day of week
class ISODayParser extends _Parser.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, _utils.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, _utils.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, _utils.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, _utils.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, _utils.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, _index.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
exports.ISODayParser = ISODayParser;

},{"8d5cfff7f7eb5ee5":"91aai","f0244744717726df":"joEGc","bf9b3cd7754e213e":"bkc73"}],"91aai":[function(require,module,exports,__globalThis) {
"use strict";
exports.setISODay = setISODay;
var _index = require("44745967f27ca3e1");
var _index2 = require("533ead4b5083b736");
var _index3 = require("3ceb9bffa1043609");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function setISODay(date, day) {
    const _date = (0, _index3.toDate)(date);
    const currentDay = (0, _index2.getISODay)(_date);
    const diff = day - currentDay;
    return (0, _index.addDays)(_date, diff);
}

},{"44745967f27ca3e1":"9LtkB","533ead4b5083b736":"7M84g","3ceb9bffa1043609":"iNzvk"}],"7M84g":[function(require,module,exports,__globalThis) {
"use strict";
exports.getISODay = getISODay;
var _index = require("cc4dec4ab039fecc");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function getISODay(date) {
    const _date = (0, _index.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

},{"cc4dec4ab039fecc":"iNzvk"}],"7NCtO":[function(require,module,exports,__globalThis) {
"use strict";
exports.AMPMParser = void 0;
var _Parser = require("8a2e19df354a4acd");
var _utils = require("24e42863940456ae");
class AMPMParser extends _Parser.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
exports.AMPMParser = AMPMParser;

},{"8a2e19df354a4acd":"joEGc","24e42863940456ae":"bkc73"}],"3cipL":[function(require,module,exports,__globalThis) {
"use strict";
exports.AMPMMidnightParser = void 0;
var _Parser = require("4760f05ad38083c4");
var _utils = require("e542420b98b8b2fa");
class AMPMMidnightParser extends _Parser.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
exports.AMPMMidnightParser = AMPMMidnightParser;

},{"4760f05ad38083c4":"joEGc","e542420b98b8b2fa":"bkc73"}],"2t9k6":[function(require,module,exports,__globalThis) {
"use strict";
exports.DayPeriodParser = void 0;
var _Parser = require("d445f4eb1b43afa9");
var _utils = require("5bc662f5d6a57c6");
// in the morning, in the afternoon, in the evening, at night
class DayPeriodParser extends _Parser.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
exports.DayPeriodParser = DayPeriodParser;

},{"d445f4eb1b43afa9":"joEGc","5bc662f5d6a57c6":"bkc73"}],"dNiTt":[function(require,module,exports,__globalThis) {
"use strict";
exports.Hour1to12Parser = void 0;
var _constants = require("d7205af5d699aaaa");
var _Parser = require("72fa2cbc4fa1bbbf");
var _utils = require("554c03fdba31e004");
class Hour1to12Parser extends _Parser.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
exports.Hour1to12Parser = Hour1to12Parser;

},{"d7205af5d699aaaa":"cLNjW","72fa2cbc4fa1bbbf":"joEGc","554c03fdba31e004":"bkc73"}],"4wteR":[function(require,module,exports,__globalThis) {
"use strict";
exports.Hour0to23Parser = void 0;
var _constants = require("517fe295d5149361");
var _Parser = require("e9b40c7441c4ce4a");
var _utils = require("a8f3667076399d62");
class Hour0to23Parser extends _Parser.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
exports.Hour0to23Parser = Hour0to23Parser;

},{"517fe295d5149361":"cLNjW","e9b40c7441c4ce4a":"joEGc","a8f3667076399d62":"bkc73"}],"1T1SS":[function(require,module,exports,__globalThis) {
"use strict";
exports.Hour0To11Parser = void 0;
var _constants = require("dc236b3b65dd7165");
var _Parser = require("110fa5ad724dd337");
var _utils = require("b31387bf6c98a135");
class Hour0To11Parser extends _Parser.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
exports.Hour0To11Parser = Hour0To11Parser;

},{"dc236b3b65dd7165":"cLNjW","110fa5ad724dd337":"joEGc","b31387bf6c98a135":"bkc73"}],"9sIEF":[function(require,module,exports,__globalThis) {
"use strict";
exports.Hour1To24Parser = void 0;
var _constants = require("8a98c953b97bd9d2");
var _Parser = require("1a7c1d02f575f2ef");
var _utils = require("c21199ad414d918f");
class Hour1To24Parser extends _Parser.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
exports.Hour1To24Parser = Hour1To24Parser;

},{"8a98c953b97bd9d2":"cLNjW","1a7c1d02f575f2ef":"joEGc","c21199ad414d918f":"bkc73"}],"7VtQX":[function(require,module,exports,__globalThis) {
"use strict";
exports.MinuteParser = void 0;
var _constants = require("ebf9011e7838a79d");
var _Parser = require("4c8575a7116c3b84");
var _utils = require("e234fafa49de7d98");
class MinuteParser extends _Parser.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
exports.MinuteParser = MinuteParser;

},{"ebf9011e7838a79d":"cLNjW","4c8575a7116c3b84":"joEGc","e234fafa49de7d98":"bkc73"}],"gNT94":[function(require,module,exports,__globalThis) {
"use strict";
exports.SecondParser = void 0;
var _constants = require("7521dd0b4c1ed894");
var _Parser = require("6437b3e2aa607a12");
var _utils = require("c6865c0f9a49a776");
class SecondParser extends _Parser.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, _utils.parseNumericPattern)(_constants.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, _utils.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
exports.SecondParser = SecondParser;

},{"7521dd0b4c1ed894":"cLNjW","6437b3e2aa607a12":"joEGc","c6865c0f9a49a776":"bkc73"}],"9iohU":[function(require,module,exports,__globalThis) {
"use strict";
exports.FractionOfSecondParser = void 0;
var _Parser = require("67c65f5bafa413a");
var _utils = require("150a83840d362903");
class FractionOfSecondParser extends _Parser.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
exports.FractionOfSecondParser = FractionOfSecondParser;

},{"67c65f5bafa413a":"joEGc","150a83840d362903":"bkc73"}],"b6LlA":[function(require,module,exports,__globalThis) {
"use strict";
exports.ISOTimezoneWithZParser = void 0;
var _index = require("368f4220a25e7374");
var _index2 = require("558ce65157f0e599");
var _constants = require("6a63e07f10f267b2");
var _Parser = require("ee66541a7458714a");
var _utils = require("e5626238686f2ba");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class ISOTimezoneWithZParser extends _Parser.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, _index.constructFrom)(date, date.getTime() - (0, _index2.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
exports.ISOTimezoneWithZParser = ISOTimezoneWithZParser;

},{"368f4220a25e7374":"i5mc5","558ce65157f0e599":"ksNVf","6a63e07f10f267b2":"cLNjW","ee66541a7458714a":"joEGc","e5626238686f2ba":"bkc73"}],"1mjKF":[function(require,module,exports,__globalThis) {
"use strict";
exports.ISOTimezoneParser = void 0;
var _index = require("20489a2406ed1f6");
var _index2 = require("7b0f4c2b6899a6a5");
var _constants = require("1da5ad1881c8c8be");
var _Parser = require("f83d1ed0441d94a4");
var _utils = require("3d4e56ba10e06f4a");
// Timezone (ISO-8601)
class ISOTimezoneParser extends _Parser.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, _index.constructFrom)(date, date.getTime() - (0, _index2.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
exports.ISOTimezoneParser = ISOTimezoneParser;

},{"20489a2406ed1f6":"i5mc5","7b0f4c2b6899a6a5":"ksNVf","1da5ad1881c8c8be":"cLNjW","f83d1ed0441d94a4":"joEGc","3d4e56ba10e06f4a":"bkc73"}],"2hBda":[function(require,module,exports,__globalThis) {
"use strict";
exports.TimestampSecondsParser = void 0;
var _index = require("d45a9a59d4c4a1fc");
var _Parser = require("e6a228a9048e0b92");
var _utils = require("1a8a5d87134d1ddc");
class TimestampSecondsParser extends _Parser.Parser {
    priority = 40;
    parse(dateString) {
        return (0, _utils.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, _index.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
exports.TimestampSecondsParser = TimestampSecondsParser;

},{"d45a9a59d4c4a1fc":"i5mc5","e6a228a9048e0b92":"joEGc","1a8a5d87134d1ddc":"bkc73"}],"1KD6q":[function(require,module,exports,__globalThis) {
"use strict";
exports.TimestampMillisecondsParser = void 0;
var _index = require("de438b7eb6bce284");
var _Parser = require("ea4d3aab51a2471d");
var _utils = require("f77d6322d2335550");
class TimestampMillisecondsParser extends _Parser.Parser {
    priority = 20;
    parse(dateString) {
        return (0, _utils.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, _index.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
exports.TimestampMillisecondsParser = TimestampMillisecondsParser;

},{"de438b7eb6bce284":"i5mc5","ea4d3aab51a2471d":"joEGc","f77d6322d2335550":"bkc73"}],"9eTPI":[function(require,module,exports,__globalThis) {
"use strict";
exports.setDate = setDate;
var _index = require("7057dcd16ee8e373");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function setDate(date, dayOfMonth) {
    const _date = (0, _index.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}

},{"7057dcd16ee8e373":"iNzvk"}],"9K5Ak":[function(require,module,exports,__globalThis) {
"use strict";
exports.setHours = setHours;
var _index = require("1d11a257f15355a4");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function setHours(date, hours) {
    const _date = (0, _index.toDate)(date);
    _date.setHours(hours);
    return _date;
}

},{"1d11a257f15355a4":"iNzvk"}],"9Y44A":[function(require,module,exports,__globalThis) {
"use strict";
exports.setMinutes = setMinutes;
var _index = require("1f70a54677cb46ac");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function setMinutes(date, minutes) {
    const _date = (0, _index.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

},{"1f70a54677cb46ac":"iNzvk"}],"h01A3":[function(require,module,exports,__globalThis) {
"use strict";
exports.setMonth = setMonth;
var _index = require("389800ba113a4b05");
var _index2 = require("c6d3e16f0e9f2d5d");
var _index3 = require("3008df466d06f93a");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function setMonth(date, month) {
    const _date = (0, _index3.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, _index.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, _index2.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

},{"389800ba113a4b05":"i5mc5","c6d3e16f0e9f2d5d":"1YApV","3008df466d06f93a":"iNzvk"}],"lyz51":[function(require,module,exports,__globalThis) {
"use strict";
exports.setSeconds = setSeconds;
var _index = require("d2223da5fd81400f");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function setSeconds(date, seconds) {
    const _date = (0, _index.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

},{"d2223da5fd81400f":"iNzvk"}],"6nhUY":[function(require,module,exports,__globalThis) {
"use strict";
exports.setMilliseconds = setMilliseconds;
var _index = require("b10f979f8cdab20a");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function setMilliseconds(date, milliseconds) {
    const _date = (0, _index.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}

},{"b10f979f8cdab20a":"iNzvk"}],"4uGq7":[function(require,module,exports,__globalThis) {
"use strict";
exports.setYear = setYear;
var _index = require("7614d9b80a22fd43");
var _index2 = require("6c1bb22d849e1125");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function setYear(date, year) {
    const _date = (0, _index2.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, _index.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

},{"7614d9b80a22fd43":"i5mc5","6c1bb22d849e1125":"iNzvk"}],"cyC4Q":[function(require,module,exports,__globalThis) {
"use strict";
exports.startOfMonth = startOfMonth;
var _index = require("9b1ec7fb57278771");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfMonth(date) {
    const _date = (0, _index.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

},{"9b1ec7fb57278771":"iNzvk"}],"3NdNs":[function(require,module,exports,__globalThis) {
"use strict";
exports.endOfMonth = endOfMonth;
var _index = require("4700e89a3c2bdc3a");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function endOfMonth(date) {
    const _date = (0, _index.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

},{"4700e89a3c2bdc3a":"iNzvk"}],"9y6f8":[function(require,module,exports,__globalThis) {
"use strict";
exports.isWithinInterval = isWithinInterval;
var _index = require("3b15ed0c3afb2c68");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function isWithinInterval(date, interval) {
    const time = +(0, _index.toDate)(date);
    const [startTime, endTime] = [
        +(0, _index.toDate)(interval.start),
        +(0, _index.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

},{"3b15ed0c3afb2c68":"iNzvk"}],"iV0Iu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AdapterDateFnsBase", {
    enumerable: true,
    get: function() {
        return _AdapterDateFnsBase.AdapterDateFnsBase;
    }
});
var _AdapterDateFnsBase = require("e778dc22697303f4");

},{"e778dc22697303f4":"eW1OT"}],"eW1OT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7cd7f34f05ac3220").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AdapterDateFnsBase = void 0;
var _extends2 = _interopRequireDefault(require("88052c7562f036c6"));
/* eslint-disable class-methods-use-this */ const formatTokenMap = {
    // Year
    y: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yy: 'year',
    yyy: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yyyy: 'year',
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    L: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    LL: 'month',
    LLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    LLLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    d: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    dd: 'day',
    do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    E: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    i: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ii: 'weekDay',
    iii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    iiii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // eslint-disable-next-line id-denylist
    e: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ee: 'weekDay',
    eee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    c: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    cc: 'weekDay',
    ccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    a: 'meridiem',
    aa: 'meridiem',
    aaa: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const defaultFormats = {
    year: 'yyyy',
    month: 'LLLL',
    monthShort: 'MMM',
    dayOfMonth: 'd',
    dayOfMonthFull: 'do',
    weekday: 'EEEE',
    weekdayShort: 'EEEEEE',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'aa',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'PP',
    keyboardDate: 'P',
    shortDate: 'MMM d',
    normalDate: 'd MMMM',
    normalDateWithWeekday: 'EEE, MMM d',
    fullTime12h: 'hh:mm aa',
    fullTime24h: 'HH:mm',
    keyboardDateTime12h: 'P hh:mm aa',
    keyboardDateTime24h: 'P HH:mm'
};
/**
 * Based on `@date-io/date-fns`
 *
 * MIT License
 *
 * Copyright (c) 2017 Dmitriy Kovalenko
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ class AdapterDateFnsBase {
    constructor(props){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = false;
        this.lib = void 0;
        this.locale = void 0;
        this.formats = void 0;
        this.formatTokenMap = formatTokenMap;
        this.escapedCharacters = {
            start: "'",
            end: "'"
        };
        this.longFormatters = void 0;
        this.date = (value)=>{
            if (typeof value === 'undefined') return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.getInvalidDate = ()=>new Date('Invalid Date');
        this.getTimezone = ()=>{
            return 'default';
        };
        this.setTimezone = (value)=>{
            return value;
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.getCurrentLocaleCode = ()=>{
            // `code` is undefined only in `date-fns` types, but all locales have it
            return this.locale.code;
        };
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            return /a/.test(this.locale.formatLong.time({
                width: 'short'
            }));
        };
        this.expandFormat = (format)=>{
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            return format.match(longFormatRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === 'p' || firstCharacter === 'P') {
                    const longFormatter = this.longFormatters[firstCharacter];
                    return longFormatter(token, this.locale.formatLong);
                }
                return token;
            }).join('');
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDayOfWeek = (value)=>{
            return value.getDay() + 1;
        };
        const { locale, formats, longFormatters, lib } = props;
        this.locale = locale;
        this.formats = (0, _extends2.default)({}, defaultFormats, formats);
        this.longFormatters = longFormatters;
        this.lib = lib || 'date-fns';
    }
}
exports.AdapterDateFnsBase = AdapterDateFnsBase;

},{"7cd7f34f05ac3220":"kZ6eK","88052c7562f036c6":"ktcBy"}],"gR4dx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactHookForm = require("react-hook-form");
/**
 * Helper to focus fields that failed validation. It uses React Hook Form context.
 */ const FocusError = ()=>{
    const { formState: { errors, isSubmitting, isValidating } } = (0, _reactHookForm.useFormContext)();
    (0, _react.useEffect)(()=>{
        if (isSubmitting && !isValidating) {
            const keys = Object.keys(errors);
            if (keys.length > 0) {
                const selector = `[name="${keys[0]}"]`;
                const errorElement = document.querySelector(selector);
                if (errorElement) {
                    const parent = errorElement.closest('.MuiFormControl-root');
                    parent && parent.scrollIntoView();
                }
            }
        }
    }, [
        errors,
        isSubmitting,
        isValidating
    ]);
    return null;
};
exports.default = FocusError;

},{"react":"9njXz","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7gFt3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnSubmit", ()=>OnSubmit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
const OnSubmit = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
/**
 * A wrapper around react-hook-form that provides a submit function and a context for the submit function.
 * @param defaultValues The initial values of the form.
 * @param enableReinitialize If true, the form will be reinitialized with the new initialValues whenever the initialValues prop changes.
 * @param onSubmit The function to be called when the form is submitted.
 * @param component The component to be rendered.
 * @param children The children of the component.
 * @returns The form component.
 * */ const RHF = ({ defaultValues, enableReinitialize, onSubmit, component: Component, children })=>{
    const methods = (0, _reactHookForm.useForm)({
        mode: 'all',
        defaultValues: defaultValues
    });
    (0, _react.useEffect)(()=>{
        if (enableReinitialize) methods.reset(defaultValues);
    }, [
        defaultValues,
        enableReinitialize
    ]);
    const onError = (errors)=>{
        const firstErrorField = Object.keys(errors)[0];
        if (firstErrorField) try {
            methods.setFocus(firstErrorField, {
                shouldSelect: true
            });
        } catch (e) {
            methods.setFocus(firstErrorField, {
                shouldSelect: false
            });
        }
    };
    const submitContextProps = {
        onSubmit: (e)=>methods.handleSubmit(async (data)=>{
                await onSubmit(data, methods);
                // Reset isDirty (https://gitlab.com/netinsight/edge/edge-rist/-/merge_requests/5769)
                methods.reset(data, {
                    // EDGE-5547: Keep values to avoid unmounting and remounting of useFieldArray() components, e.g. ApplianceSection, which in turn leads to unwanted useEffects() to re-trigger and user input to disappear if backend returns non 200, etc
                    // https://stackoverflow.com/questions/63953501/react-hook-form-resetting-isdirty-without-clearing-form#comment132682784_64061098
                    keepValues: true,
                    keepErrors: true
                });
            }, onError)(e)
    };
    const props = {
        ...methods,
        defaultValues: defaultValues || {},
        submitForm: ()=>{
            methods.trigger().then((valid)=>{
                if (valid) submitContextProps.onSubmit();
            });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.FormProvider), {
        ...methods,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(OnSubmit.Provider, {
            value: submitContextProps,
            children: [
                Component && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                    ...props
                }),
                typeof children === 'function' ? children(props) : children
            ]
        })
    });
};
exports.default = RHF;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6xuCU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _rhf = require("./RHF");
const Form = ({ id, noValidate, children, disableSubmitOnEnterKey })=>{
    const ctx = (0, _react.useContext)((0, _rhf.OnSubmit));
    const handleKeyDown = (e)=>{
        if (!!disableSubmitOnEnterKey && e.key === 'Enter') // Prevent Enter key from submitting the form
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
        id: id,
        noValidate: noValidate,
        onSubmit: ctx?.onSubmit,
        onKeyDown: handleKeyDown,
        children: children
    });
};
exports.default = Form;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./RHF":"7gFt3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3FxKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventPage", ()=>EventPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _types = require("common/api/v1/types");
var _store = require("../../store");
var _inputsActions = require("../../redux/actions/inputsActions");
var _outputsActions = require("../../redux/actions/outputsActions");
var _inputsReducer = require("../../redux/reducers/inputsReducer");
var _outputsReducer = require("../../redux/reducers/outputsReducer");
var _tagsAction = require("../../redux/actions/tagsAction");
var _utils = require("../../utils");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _form = require("../common/Form");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _tableConfig = require("../inputs/List/tableConfig");
var _tableConfig1 = require("../outputs/List/tableConfig");
var _listInputFilter = require("../inputs/List/listInputFilter");
var _index = require("../serviceOverview/Overview/index");
const INTERVAL_MS = 10000;
const InputsTable = ({ tags, experimentalFeatures })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [searchParams] = (0, _reactRouter.useSearchParams)();
    const [pending, setPending] = (0, _react.useState)(true);
    const { inputs, total } = (0, _reactRedux.useSelector)((0, _inputsReducer.selectInputs), (0, _reactRedux.shallowEqual));
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const config = [
        (0, _tableConfig.inputColumns).status({
            autoUpdate: false,
            user,
            routes,
            experimentalFeatures
        }),
        (0, _tableConfig.inputColumns).preview(),
        (0, _tableConfig.inputColumns).name({
            availableFn: (input)=>user.role !== (0, _types.Role).basic && !(0, _index.isServiceOverviewDisabled)(input),
            toFn: ({ id })=>routes.service({
                    id
                })
        }, {
            props: {
                sx: {
                    width: '70%'
                }
            }
        })
    ];
    (0, _react.useEffect)(()=>{
        const params = {
            tags,
            asc: searchParams.get('asc') ?? undefined,
            desc: searchParams.get('desc') ?? undefined,
            pageNumber: searchParams.get('iPageNumber') ?? undefined,
            rowsPerPage: searchParams.get('iRowsPerPage') ?? undefined
        };
        setPending(true);
        dispatch((0, _inputsActions.getInputs)(params)).then(()=>setPending(false));
        const interval = setInterval(()=>void dispatch((0, _inputsActions.getInputs)(params)), INTERVAL_MS);
        return ()=>clearInterval(interval);
    }, [
        dispatch,
        searchParams,
        tags
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Inputs",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
            pending: pending,
            emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                message: "No inputs available"
            }),
            config: config,
            data: inputs,
            pagination: {
                total,
                useUrlSearchParams: {
                    rowsPerPageKey: 'iRowsPerPage',
                    pageNumberKey: 'iPageNumber'
                }
            }
        })
    });
};
const OutputsTable = ({ tags, experimentalFeatures })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [searchParams] = (0, _reactRouter.useSearchParams)();
    const [pending, setPending] = (0, _react.useState)(true);
    const { outputs, total } = (0, _reactRedux.useSelector)((0, _outputsReducer.selectOutputs), (0, _reactRedux.shallowEqual));
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const config = [
        (0, _tableConfig1.outputColumns).status({
            autoUpdate: false,
            experimentalFeatures
        }),
        (0, _tableConfig1.outputColumns).preview(),
        (0, _tableConfig1.outputColumns).name({
            user,
            toCallback: ({ id, input })=>routes.service({
                    id: input,
                    outputId: id
                })
        }, {
            props: {
                sx: {
                    width: '70%'
                }
            }
        })
    ];
    (0, _react.useEffect)(()=>{
        const params = {
            tags,
            asc: searchParams.get('asc') ?? undefined,
            desc: searchParams.get('desc') ?? undefined,
            pageNumber: searchParams.get('oPageNumber') ?? undefined,
            rowsPerPage: searchParams.get('oRowsPerPage') ?? undefined
        };
        setPending(true);
        dispatch((0, _outputsActions.getOutputs)(params)).then(()=>setPending(false));
        const interval = setInterval(()=>void dispatch((0, _outputsActions.getOutputs)(params)), INTERVAL_MS);
        return ()=>clearInterval(interval);
    }, [
        dispatch,
        searchParams,
        tags
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Outputs",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
            pending: pending,
            emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                message: "No outputs available"
            }),
            config: config,
            data: outputs,
            pagination: {
                total,
                useUrlSearchParams: {
                    rowsPerPageKey: 'oRowsPerPage',
                    pageNumberKey: 'oPageNumber'
                }
            }
        })
    });
};
// output's 'tag' should be the same
const filters = (0, _listInputFilter.makeListInputFilter)({
    api: (0, _store.Api),
    expFeatures: {}
}).filter((f)=>f.key === 'tag');
const EventPage = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [searchParams] = (0, _reactRouter.useSearchParams)();
    const { settings } = (0, _utils.useSettingsSelector)();
    const tags = searchParams.get('tags') ?? undefined;
    (0, _react.useEffect)(()=>{
        if (!tags) return;
        dispatch((0, _tagsAction.updateSearchHistory)(tags));
    }, [
        dispatch,
        tags
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: tags ? [
            'Events',
            tags
        ] : 'Events',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                urlParamCacheKey: undefined,
                mapUrlParamToFilterFn: (key, value)=>key === 'tags' ? {
                        key: 'tag',
                        operator: 'isOneOf',
                        values: value.split(',').map((tagName)=>({
                                value: tagName,
                                displayName: tagName
                            }))
                    } : undefined,
                mapFilterToUrlParamFn: (filter)=>'values' in filter ? {
                        tags: filter.values.map(({ value })=>value).join(',')
                    } : {},
                searchTokenFilters: filters,
                rawTextFilter: filters[0]
            }),
            tags ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    display: 'flex'
                },
                gap: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputsTable, {
                        tags: tags,
                        experimentalFeatures: settings?.expFeatures
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputsTable, {
                        tags: tags,
                        experimentalFeatures: settings?.expFeatures
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    padding: 3
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "Select event tags"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","@mui/material/Box":"c4QkF","common/api/v1/types":"3qemx","../../store":"5LXiG","../../redux/actions/inputsActions":"l0Ua8","../../redux/actions/outputsActions":"alMzI","../../redux/reducers/inputsReducer":"742I9","../../redux/reducers/outputsReducer":"74FGl","../../redux/actions/tagsAction":"6HCqL","../../utils":"342UB","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","../common/Form":"4Mui7","../common/Wrapper":"8oy7r","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../inputs/List/tableConfig":"lLIw3","../outputs/List/tableConfig":"5ac6L","../inputs/List/listInputFilter":"gmhES","../serviceOverview/Overview/index":"1D7NB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eEpmv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UrlParamFilteredSearchBar", ()=>UrlParamFilteredSearchBar);
parcelHelpers.export(exports, "FilteredSearchBar", ()=>FilteredSearchBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _autocomplete = require("@mui/material/Autocomplete");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _filterTemplate = require("./FilterTemplate");
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _popper = require("@mui/material/Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _useAutocomplete = require("@mui/material/useAutocomplete");
var _useAutocompleteDefault = parcelHelpers.interopDefault(_useAutocomplete);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _debounce = require("lodash/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _helpers = require("common/api/v1/helpers");
var _styles = require("@mui/material/styles");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _search = require("@mui/icons-material/Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _reactRedux = require("react-redux");
var _utils = require("../../../../utils");
var _applicationException = require("../../../../api/ApplicationException");
var _util = require("common/util");
var _urlParamActions = require("../../../../redux/actions/urlParamActions");
var _utils1 = require("common/utils");
var _mixpanel = require("../../../../mixpanel");
const selectTemplateState = ()=>{
    return {
        state: 'selectTemplate',
        autocomplete: {
            placeholder: autocompletePlaceholder({
                state: 'selectTemplate'
            }),
            searchText: '',
            allowCustomOptions: false,
            autoOpenOptionsPopup: false,
            autoFocusFirstOption: true
        }
    };
};
const selectOperatorState = (template)=>({
        state: 'selectOperator',
        template,
        autocomplete: {
            placeholder: autocompletePlaceholder({
                state: 'selectOperator'
            }),
            searchText: '',
            allowCustomOptions: false,
            autoOpenOptionsPopup: true,
            autoFocusFirstOption: true
        }
    });
const selectValueState = (template, operator)=>{
    return {
        state: 'selectValue',
        template,
        operator,
        autocomplete: {
            placeholder: autocompletePlaceholder({
                state: 'selectValue',
                template
            }),
            searchText: '',
            allowCustomOptions: filterRequiresCustomInput(template),
            autoOpenOptionsPopup: true,
            autoFocusFirstOption: true
        }
    };
};
function reducer(prevState, action) {
    switch(action.type){
        case 'wipFilterTemplateSelected':
            if (prevState.state !== 'selectTemplate') throw new Error(`Invalid state transition to selectOperator from ${prevState.state} (expected selectTemplate)`);
            return selectOperatorState(action.template);
        case 'wipFilterOperatorSelected':
            if (prevState.state !== 'selectOperator') throw new Error(`Invalid state transition to selectValue from ${prevState.state} (expected selectOperator)`);
            return selectValueState(prevState.template, action.operator);
        case 'wipFilterValueSelected':
            if (prevState.state !== 'selectValue') throw new Error(`Invalid state transition to selectTemplate from ${prevState.state} (expected selectValue)`);
            return selectTemplateState();
        case 'wipFilterRemoved':
            return selectTemplateState();
        case 'filtersApplied':
            {
                const isConstructingFilter = prevState.state !== 'selectTemplate';
                return {
                    ...prevState,
                    autocomplete: {
                        ...prevState.autocomplete,
                        searchText: '',
                        placeholder: autocompletePlaceholder({
                            state: prevState.state,
                            template: 'template' in prevState ? prevState.template : undefined
                        }),
                        // Keep options open if we're currently working on a filter
                        // e.g. user has selected template + operator and then clicks "X" on a previously applied filter
                        autoOpenOptionsPopup: isConstructingFilter
                    }
                };
            }
        case 'searchTextEntered':
            return {
                ...prevState,
                autocomplete: {
                    ...prevState.autocomplete,
                    searchText: action.text
                }
            };
    }
}
const UrlParamFilteredSearchBar = ({ searchTokenFilters, rawTextFilter, urlParamCacheKey, mapUrlParamToFilterFn, mapFilterToUrlParamFn })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [urlParams, setUrlParams] = (0, _utils.usePageParams)();
    const { urlParamCache } = (0, _reactRedux.useSelector)(({ urlParamReducer })=>({
            urlParamCache: urlParamReducer.cachedUrlParams
        }), (0, _util.equals));
    const currentlyAppliedFilters = (0, _react.useMemo)(()=>(0, _filterTemplate.urlParamsToFilters)(urlParams, mapUrlParamToFilterFn), [
        urlParams,
        mapUrlParamToFilterFn
    ]);
    const populateUrlWithSelectedFilters = (newFilters)=>{
        const newUrlParams = (0, _filterTemplate.filtersToUrlParams)(newFilters, currentlyAppliedFilters, mapFilterToUrlParamFn);
        setUrlParams({
            ...newUrlParams,
            pageNumber: '0'
        }) // Reset page to 0 when applying filters
        ;
    };
    (0, _react.useEffect)(()=>{
        if (!urlParamCacheKey) return;
        // Observe url params and cache them in redux on change
        const cachedUrlParams = urlParamCache[urlParamCacheKey];
        if (!(0, _util.areObjectsEqual)(urlParams, cachedUrlParams)) {
            const action = (0, _urlParamActions.saveUrlParams)(urlParamCacheKey, urlParams);
            dispatch(action);
            const searchKeys = Object.keys((0, _helpers.omit)(urlParams, 'pageNumber', 'rowsPerPage', 'asc', 'desc'));
            if (searchKeys.length > 0) (0, _mixpanel.mixpanel).trackSearchResource({
                component: urlParamCacheKey,
                search_keys: searchKeys
            });
        }
    }, [
        JSON.stringify(urlParams),
        urlParamCacheKey,
        dispatch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilteredSearchBar, {
        appliedFilters: currentlyAppliedFilters,
        rawTextFilter: rawTextFilter,
        searchTokenFilters: searchTokenFilters,
        onFiltersApplied: populateUrlWithSelectedFilters
    });
};
const FilteredSearchBar = ({ appliedFilters: currentFilters, searchTokenFilters, rawTextFilter, onFiltersApplied })=>{
    const appliedFilters = (0, _react.useMemo)(()=>currentFilters.map(toSavedFilter).flat(), [
        JSON.stringify(currentFilters)
    ]);
    const [state, dispatch] = (0, _react.useReducer)(reducer, selectTemplateState(), undefined);
    (0, _react.useEffect)(()=>{
        dispatch({
            type: 'filtersApplied',
            filters: appliedFilters
        });
    }, [
        JSON.stringify(appliedFilters)
    ]);
    const requestApplyFilters = (reason)=>{
        if (isOptionsPopupOpen) return;
        if (isPerformingRawTextSearch) // Allow typing a custom string and pressing enter to search immediately by value
        // i.e. not having to select template, operator and value
        doApplyFilters([
            // Remove existing rawTextFilter since it will be re-inserted
            ...appliedFilters.filter((f)=>f.key !== rawTextFilter.key && f.operator !== rawTextFilter.operator),
            {
                key: rawTextFilter.key,
                operator: rawTextFilter.operator,
                value: {
                    value: state.autocomplete.searchText,
                    displayName: state.autocomplete.searchText
                }
            }
        ], `${reason} (raw text search)`);
        else // Allow pressing enter to search when options popup is closed
        doApplyFilters(appliedFilters, reason);
    };
    const doApplyFilters = (filters, _reason)=>{
        const distinctKeepingLastOccurrence = (0, _utils1.distinct)(filters.toReversed(), (a, b)=>{
            const canFilterOccurMultipleTimes = a.operator === 'isOneOf';
            return a.key === b.key && a.operator === b.operator && (!canFilterOccurMultipleTimes || a.value?.value === b.value?.value);
        }).toReversed();
        // console.log(`applying filters: ${_reason}: ${JSON.stringify(distinctKeepingLastOccurrence)}`)
        onFiltersApplied(toFilterBy(distinctKeepingLastOccurrence));
    };
    const [fetchState, setFetchState] = (0, _react.useState)({
        result: [],
        isLoading: false,
        error: undefined
    });
    (0, _react.useEffect)(()=>{
        let isMounted = true;
        let debouncedFetch = undefined;
        const setAutocompleteOptions = async (searchText)=>{
            if (isPerformingRawTextSearch) // Don't provide any options when performing raw text search
            return [];
            switch(state.state){
                case 'selectTemplate':
                    {
                        const templateKeys = new Set();
                        const dedupedSearchTokenFilters = searchTokenFilters.filter((filter)=>{
                            if (templateKeys.has(filter.key)) return false;
                            templateKeys.add(filter.key);
                            return true;
                        });
                        setFetchState({
                            isLoading: false,
                            error: undefined,
                            result: dedupedSearchTokenFilters.map((e)=>({
                                    value: e.key,
                                    displayName: e.key
                                }))
                        });
                        break;
                    }
                case 'selectOperator':
                    setFetchState({
                        isLoading: false,
                        error: undefined,
                        result: searchTokenFilters.filter((f)=>f.key === state.template.key).map((f)=>({
                                value: f.operator,
                                displayName: formattedOperator(f.operator)
                            }))
                    });
                    break;
                case 'selectValue':
                    if (state.template.possibleValuesSync) setFetchState({
                        isLoading: false,
                        error: undefined,
                        result: removeAlreadySelectedValues(state.template.possibleValuesSync(searchText), state.template, appliedFilters)
                    });
                    else if (state.template.possibleValues) {
                        const template = state.template;
                        debouncedFetch = (0, _debounceDefault.default)(()=>template.possibleValues?.(searchText).then((items)=>{
                                if (isMounted) setFetchState({
                                    isLoading: false,
                                    error: undefined,
                                    result: removeAlreadySelectedValues(items, template, appliedFilters)
                                });
                            }).catch((error)=>{
                                if (isMounted) setFetchState({
                                    isLoading: false,
                                    result: [],
                                    error: error instanceof (0, _applicationException.ApplicationException) ? `${error.errorInfo.text} - ${error.errorInfo.details}` : JSON.stringify(error)
                                });
                            }), 500);
                        setFetchState({
                            isLoading: true,
                            error: undefined,
                            result: []
                        });
                        debouncedFetch?.();
                    } else // Filter requires custom input
                    setFetchState({
                        isLoading: false,
                        error: undefined,
                        result: []
                    });
            }
        };
        setAutocompleteOptions(state.autocomplete.searchText).catch((_)=>{
        /* nop*/ });
        return ()=>{
            isMounted = false;
            debouncedFetch?.cancel();
        };
    }, [
        state.state,
        JSON.stringify(searchTokenFilters),
        appliedFilters,
        state.autocomplete.searchText
    ]);
    const hasEnteredText = state.autocomplete.searchText.length > 0;
    const isPerformingRawTextSearch = state.state === 'selectTemplate' && hasEnteredText;
    const selectedFilterHasSelectableOptions = !state.autocomplete.allowCustomOptions;
    const canOptionsPopupOpen = !isPerformingRawTextSearch && selectedFilterHasSelectableOptions;
    const [wantsOptionPopupOpen, setWantsOptionPopupOpen] = (0, _react.useState)(false);
    const isOptionsPopupOpen = canOptionsPopupOpen && wantsOptionPopupOpen;
    (0, _react.useEffect)(()=>{
        // Update wantsOptionPopupOpen accordingly after a state change, i.e. let the new state decide if the popup should be opened by default or not.
        if (state.autocomplete.autoOpenOptionsPopup !== wantsOptionPopupOpen) setWantsOptionPopupOpen(state.autocomplete.autoOpenOptionsPopup);
    }, // don't trigger effect on changes to 'wantsOptionPopupOpen' since then we can't toggle it (i.e. only observe state.autcomplete)
    [
        state.autocomplete
    ]);
    const { getRootProps, getInputProps, getListboxProps, getOptionProps, focused: isAutocompleteFocused, groupedOptions: autocompleteOptions, setAnchorEl: setOptionsPopupAnchor, anchorEl: optionsPopupAnchor } = (0, _useAutocompleteDefault.default)({
        open: isOptionsPopupOpen,
        openOnFocus: false,
        onOpen: ()=>setWantsOptionPopupOpen(true),
        onClose: ()=>setWantsOptionPopupOpen(false),
        options: fetchState.result,
        getOptionLabel: (o)=>{
            const isCustomOption = typeof o === 'string';
            return isCustomOption ? o : o.displayName;
        },
        freeSolo: state.autocomplete.allowCustomOptions,
        autoSelect: state.autocomplete.allowCustomOptions,
        autoHighlight: state.autocomplete.autoFocusFirstOption,
        inputValue: state.autocomplete.searchText,
        value: null,
        isOptionEqualToValue: (option, value)=>option.value === value.value,
        onInputChange: (_event, enteredText, reason)=>{
            // Don't update `enteredText` when reason == 'reset' since it then contains
            // the **formatted** name of the selected value, not the actual selected value.
            // E.g. "xxx (appliance software is out of date)" instead of simply "xxx".
            if ([
                'input',
                'clear'
            ].includes(reason)) dispatch({
                type: 'searchTextEntered',
                text: enteredText
            });
        },
        onChange: (_event, selectedOption)=>{
            // A value/option was selected from the popup
            if (!selectedOption) return;
            if (state.state === 'selectTemplate') {
                if (typeof selectedOption === 'string') // Programmer error - should not happen (state.autocomplete.allowCustomOptions is false)
                throw new Error(`Selected option has unexpected type`);
                dispatch({
                    type: 'wipFilterTemplateSelected',
                    template: searchTokenFilters.find((e)=>e.key === selectedOption.value)
                });
            } else if (state.state === 'selectOperator') {
                if (typeof selectedOption === 'string') // Programmer error - should not happen (state.autocomplete.allowCustomOptions is false)
                throw new Error(`Selected option has unexpected type`);
                dispatch({
                    type: 'wipFilterOperatorSelected',
                    operator: selectedOption.value
                });
            } else if (state.state === 'selectValue') {
                const value = typeof selectedOption === 'string' ? {
                    value: selectedOption,
                    displayName: selectedOption
                } : selectedOption;
                dispatch({
                    type: 'wipFilterValueSelected'
                });
                doApplyFilters([
                    ...appliedFilters,
                    {
                        key: state.template.key,
                        operator: state.operator,
                        value
                    }
                ], 'wipFilterValueSelected');
            }
        }
    });
    const inputProps = getInputProps();
    const scrollInputIntoHorizontalView = ()=>{
        if (inputProps.ref && 'current' in inputProps.ref && inputProps.ref.current) {
            const element = inputProps.ref.current;
            const elementRect = element.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            const isVerticallyInView = elementRect.bottom > 0 && elementRect.top < windowHeight;
            if (!isVerticallyInView) return; // Don't scroll horizontally if input isn't visible vertically
            const parent = element.parentElement;
            if (parent) {
                const parentRect = parent.getBoundingClientRect();
                if (elementRect.right > parentRect.right) // Element is cut off on the right, scroll right
                parent.scrollLeft += elementRect.right - parentRect.right;
                else if (elementRect.left < parentRect.left) // Element is cut off on the left, scroll left
                parent.scrollLeft -= parentRect.left - elementRect.left;
            }
        }
    };
    (0, _react.useEffect)(()=>{
        // Scroll input into view once on initial render (when autocomplete is not necessarily focused)
        scrollInputIntoHorizontalView();
    }, []);
    (0, _react.useEffect)(()=>{
        if (!isAutocompleteFocused) return;
        if (appliedFilters.length === 0) return;
        // Keep input field in view when many filters are selected and horizontal scrollbar is showing
        scrollInputIntoHorizontalView();
    }, [
        isAutocompleteFocused,
        appliedFilters,
        inputProps
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        ...getRootProps(),
        "data-testid": "fliteredSearch-root",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                "data-testid": 'filteredSearch-wrapper1',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    "data-testid": 'filteredSearch-wrapper2',
                    sx: {
                        display: 'flex',
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            "data-testid": 'filteredSearch-inputWrapper',
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                overflowX: 'auto',
                                flexGrow: 1
                            },
                            children: [
                                appliedFilters.map((filter, index)=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterView, {
                                        onDelete: ()=>doApplyFilters(appliedFilters.toSpliced(index, 1), 'delete chip'),
                                        filter: filter,
                                        dataTestId: `filteredSearch-appliedFilter-${filter.key}`
                                    }, `${filter.key}${filter.operator}${filter.value.value}`);
                                }),
                                'template' in state && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterView, {
                                    filter: {
                                        key: state.template.key,
                                        operator: 'operator' in state ? state.operator : undefined
                                    },
                                    onDelete: ()=>dispatch({
                                            type: 'wipFilterRemoved'
                                        }),
                                    dataTestId: `filteredSearch-wipFilter-${state.template.key}`
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    "data-testid": "filteredSearch-optionsPopupAnchor",
                                    ref: setOptionsPopupAnchor,
                                    style: {
                                        width: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, {
                                    autoFocus: false,
                                    "data-testid": 'filteredSearch-input',
                                    ...(0, _helpers.omit)(inputProps, 'value'),
                                    value: state.autocomplete.searchText,
                                    placeholder: state.autocomplete.placeholder,
                                    onKeyDown: (event)=>{
                                        // Convenient keyboard shortcuts
                                        if (event.key === 'Enter') {
                                            if (state.state === 'selectTemplate') requestApplyFilters('enter key pressed');
                                            event.preventDefault();
                                        } else if (event.key === 'Backspace') {
                                            if (hasEnteredText) // Erase text only (i.e. don't perform any quick-actions).
                                            return;
                                            if (state.state === 'selectTemplate') {
                                                if (appliedFilters.length > 0) // Allow pressing backspace to remove last applied filter and search
                                                doApplyFilters(appliedFilters.toSpliced(appliedFilters.length - 1, 1), 'selectedTemplate::backspace');
                                            } else // Allow pressing backspace to remove current wip-filter
                                            dispatch({
                                                type: 'wipFilterRemoved'
                                            });
                                        }
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            disabled: isOptionsPopupOpen,
                            onClick: ()=>{
                                requestApplyFilters('search button clicked');
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            "data-testid": 'filteredSearch-clear',
                            disabled: appliedFilters.length === 0,
                            onClick: ()=>{
                                if (appliedFilters.length > 0) doApplyFilters([], 'clear button clicked');
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popperDefault.default), {
                open: isOptionsPopupOpen,
                sx: {
                    zIndex: 2
                },
                anchorEl: optionsPopupAnchor,
                placement: "bottom-start",
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [
                                0,
                                12
                            ]
                        }
                    }
                ],
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(OptionsContainer, {
                        ...getListboxProps(),
                        "data-testid": 'filteredSearchOptionsContainer-2',
                        children: [
                            fetchState.isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                                    color: "inherit",
                                    size: 25
                                })
                            }),
                            fetchState.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    component: "span",
                                    variant: "body2",
                                    color: "error",
                                    children: fetchState.error
                                })
                            }),
                            !fetchState.isLoading && !fetchState.error && autocompleteOptions.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    component: "span",
                                    variant: "body1",
                                    color: "textPrimary",
                                    children: "No available options"
                                })
                            }),
                            !fetchState.isLoading && !fetchState.error && autocompleteOptions.length > 0 && autocompleteOptions.map((option, index)=>{
                                const { key, ...optionProps } = getOptionProps({
                                    option,
                                    index
                                });
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                    ...optionProps,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        component: "span",
                                        variant: "body1",
                                        color: "textPrimary",
                                        children: option.displayName
                                    })
                                }, key);
                            })
                        ]
                    })
                })
            })
        ]
    });
};
function removeAlreadySelectedValues(options, currentTemplate, appliedFilters) {
    return options.filter((value)=>{
        const isValueAlreadySelected = appliedFilters.some((existingFilter)=>filterEquals(existingFilter, {
                key: currentTemplate.key,
                operator: currentTemplate.operator,
                value
            }));
        return !isValueAlreadySelected;
    });
}
function autocompletePlaceholder({ state, template }) {
    switch(state){
        case 'selectTemplate':
            return 'select search token or enter raw search text';
        case 'selectOperator':
            return 'select operator';
        case 'selectValue':
            return selectValuePlaceholder(template);
    }
}
function selectValuePlaceholder(template) {
    if (template) {
        if (filterRequiresCustomInput(template)) return `enter ${template.key}`;
        if (template.operator === 'after' || template.operator === 'before') return 'YYYY-MM-DD HH:MM:SS';
    }
    return 'select value';
}
function filterRequiresCustomInput(template) {
    // no predefined values to select from
    return !template.possibleValues && !template.possibleValuesSync;
}
function filterEquals(a, b) {
    return a.key === b.key && a.operator === b.operator && a.value?.value === b.value?.value;
}
function formattedOperator(op) {
    return op === 'isOneOf' ? 'is one of' : op;
}
function toSavedFilter(f) {
    if ('value' in f) return [
        {
            key: f.key,
            operator: f.operator,
            value: {
                value: f.value,
                displayName: f.displayName ?? f.value
            }
        }
    ];
    return f.values.map((childFilter)=>({
            key: f.key,
            operator: f.operator,
            value: {
                value: childFilter.value,
                displayName: childFilter.displayName
            }
        }));
}
function toFilterBy(filters) {
    const groupedByKeyOperator = {};
    for (const { key, operator, value } of filters){
        const groupKey = `${key}-${operator}`;
        const existingFilter = groupedByKeyOperator[groupKey];
        if (!existingFilter) groupedByKeyOperator[groupKey] = operator === 'isOneOf' ? {
            key,
            operator,
            values: [
                value
            ]
        } : {
            key,
            operator,
            value: value.value,
            displayName: value.displayName
        };
        else if (existingFilter.operator === 'isOneOf') existingFilter.values.push(value);
    }
    return Object.values(groupedByKeyOperator);
}
const FilterView = ({ filter: { key, operator, value }, onDelete, dataTestId })=>{
    const isWip = !value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(HorizontallyShrinkableChip, {
        label: `${key} ${operator ? formattedOperator(operator) : ''} ${value?.displayName || ''}`,
        "data-testid": dataTestId,
        onDelete: onDelete,
        size: "small",
        variant: isWip ? 'outlined' : 'filled'
    });
};
const Root = (0, _styles.styled)('div')(({ theme })=>({
        borderRadius: 800,
        backgroundColor: 'rgba(255, 255, 255, 0.12)',
        '&:hover': {
            backgroundColor: `${theme.palette.action.selected}`
        }
    }));
const HorizontallyShrinkableChip = (0, _styles.styled)((0, _chipDefault.default))(({ theme })=>({
        padding: theme.spacing(0.5),
        margin: theme.spacing(0.5),
        height: '100%',
        '& .MuiChip-label': {
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            textOverflow: 'clip'
        }
    }));
const Input = (0, _styles.styled)('input')(({ theme })=>({
        height: 40,
        marginLeft: 10,
        border: 0,
        outline: 0,
        flexGrow: 1,
        fieldSizing: 'content',
        backgroundColor: 'transparent',
        '::placeholder': {
            fontFamily: theme.typography.body1.fontFamily,
            fontSize: theme.typography.body1.fontSize,
            color: theme.palette.text.disabled
        }
    }));
const OptionsContainer = (0, _styles.styled)('ul')(({ theme })=>({
        minWidth: 200,
        listStyle: 'none',
        paddingLeft: 0,
        borderRadius: 4,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette.divider,
        '& li': {
            padding: 6
        },
        '& li[aria-selected="true"]': {
            backgroundColor: theme.palette.action.selected
        },
        [`& li.${(0, _autocomplete.autocompleteClasses).focused}`]: {
            backgroundColor: theme.palette.action.focus,
            cursor: 'pointer'
        }
    }));

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Autocomplete":"avdFA","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","./FilterTemplate":"hhlHk","@mui/material/CircularProgress":"kEtIR","@mui/material/Popper":"2EMLo","@mui/material/useAutocomplete":"e1pVw","@mui/material/Chip":"5cK8z","lodash/debounce":"1hVPi","common/api/v1/helpers":"6jovr","@mui/material/styles":"2UrBk","@mui/material/IconButton":"488As","@mui/icons-material/Close":"acjz6","@mui/icons-material/Search":"lRGNy","@mui/material/Paper":"aexCI","react-redux":"l1pMU","../../../../utils":"342UB","../../../../api/ApplicationException":"5oMBs","common/util":"jV4UZ","../../../../redux/actions/urlParamActions":"abdT4","common/utils":"2AqiH","../../../../mixpanel":"7xxdr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hhlHk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "urlParamsToFilters", ()=>urlParamsToFilters);
parcelHelpers.export(exports, "filtersToUrlParams", ()=>filtersToUrlParams);
function urlParamsToFilters(urlParams, mapUrlParamToFilterFn) {
    const filters = [];
    for (const key of Object.keys(urlParams)){
        if (!urlParams[key]) continue;
        const filter = mapUrlParamToFilterFn(key, urlParams[key]);
        if (filter) filters.push(filter);
    }
    return filters;
}
function filtersToUrlParams(filters, prevFilter, mapFilterToUrlParamFn) {
    function toUrlParams(filters) {
        return filters.reduce((urlParams, filter)=>{
            return {
                ...urlParams,
                ...mapFilterToUrlParamFn(filter)
            };
        }, {});
    }
    const removedFilters = prevFilter.filter((prev)=>!filters.some((current)=>current.key === prev.key && current.operator === prev.operator));
    const urlParams = toUrlParams(filters);
    const urlParamsToRemove = toUrlParams(removedFilters);
    for (const keyToRemove of Object.keys(urlParamsToRemove))if (!urlParams[keyToRemove]) urlParams[keyToRemove] = '';
    return urlParams;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRGNy":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("fba53bc247860689").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("896a02316301fc50"));
var _jsxRuntime = require("b874acb5710c0313");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');

},{"fba53bc247860689":"kZ6eK","896a02316301fc50":"2vOnF","b874acb5710c0313":"1dlk8"}],"dt9lf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _table = require("./Table");
var _moveToEntity = require("./MoveToEntity");
parcelHelpers.exportAll(_moveToEntity, exports);
parcelHelpers.exportAll(_table, exports);
var _pagination = require("./Pagination");
parcelHelpers.exportAll(_pagination, exports);
/**
 * Common container for List entities pages table
 * @param actions - buttons on top of the table (for example create entity)
 * @param rest - common table properties
 */ const TableContainer = ({ actions, ...rest })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
        direction: "column",
        sx: {
            width: '100%'
        },
        children: [
            actions ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    textAlign: 'right',
                    marginRight: 1
                },
                children: actions
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
                sx: {
                    padding: (theme)=>theme.spacing(3, 2, 1)
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                    ...rest
                })
            })
        ]
    });
};
exports.default = TableContainer;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Paper":"aexCI","@mui/material/Stack":"6thYv","./Table":"7ffTR","./MoveToEntity":"loen3","./Pagination":"HM37R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ffTR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _get = require("lodash/fp/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _omit = require("lodash/fp/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableFooter = require("@mui/material/TableFooter");
var _tableFooterDefault = parcelHelpers.interopDefault(_tableFooter);
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _pagination = require("./Pagination");
var _columnHeader = require("./ColumnHeader");
var _columnHeaderDefault = parcelHelpers.interopDefault(_columnHeader);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
const styles = {
    wrapper: {
        overflowX: 'auto',
        position: 'relative'
    },
    cell: {
        borderBottom: 'none'
    }
};
const Cell = ({ value, noTypography, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
        ...rest,
        children: noTypography ? value : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            component: "div",
            children: value
        })
    });
function filterFn(column) {
    return column !== null;
}
const Table = ({ config: initConfig, data, getCustomEntityId, props, id, hasBorders, emptyMessageComponent = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}), isSmall, rowProps, pagination, noHeader, pending, footer, sorting })=>{
    const config = initConfig.filter(filterFn);
    const getEntityId = (entity, index)=>getCustomEntityId?.(entity) || (0, _getDefault.default)('id', entity) || index;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                pending: !!pending,
                cover: !!data.length,
                id: id,
                children: data.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: styles.wrapper,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                        id: id,
                        size: isSmall ? 'small' : 'medium',
                        ...props,
                        children: [
                            !noHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                    children: config.map(({ title = '', props, headerProps, sorting: columnSorting }, ind, { length })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                            sx: isSmall && !hasBorders ? {
                                                root: styles.cell
                                            } : undefined,
                                            padding: isSmall && (!ind || ind === length - 1) ? 'none' : undefined,
                                            "data-table-column": title,
                                            ...headerProps ? headerProps : (0, _omitDefault.default)([
                                                'noTypography'
                                            ], props),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnHeaderDefault.default), {
                                                title: title,
                                                sorting: columnSorting,
                                                currentSortKey: sorting?.currentSortKey,
                                                onSortOrderChanged: sorting?.onSortOrderChanged
                                            })
                                        }, ind))
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                                children: data.map((entity, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                        hover: true,
                                        ...rowProps ? rowProps(entity) : null,
                                        children: config.map(({ getValue, props, title }, ind, { length })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                                                sx: isSmall && !hasBorders ? {
                                                    root: styles.cell
                                                } : undefined,
                                                value: getValue(entity, i),
                                                "data-cell-name": `${title}-cell`,
                                                padding: isSmall && (!ind || ind === length - 1) ? 'none' : undefined,
                                                ...props
                                            }, ind))
                                    }, getEntityId(entity, i)))
                            }),
                            footer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableFooterDefault.default), {
                                children: footer()
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: emptyMessageComponent
                })
            }),
            pagination && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'background.paper'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.Pagination), {
                        ...pagination,
                        id: id
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","lodash/fp/get":"iAWy2","lodash/fp/omit":"lRr4P","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","@mui/material/Table":"k4r1H","@mui/material/TableHead":"9yKSO","@mui/material/TableRow":"bLA0R","@mui/material/TableBody":"2jHBQ","@mui/material/TableCell":"6WlPV","@mui/material/TableFooter":"fQGJX","../../common/Pendable":"gDN67","./Pagination":"HM37R","./ColumnHeader":"5BE9S","@mui/material/Divider":"9Ul8c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iAWy2":[function(require,module,exports,__globalThis) {
var convert = require("c200fd606d56e640"), func = convert('get', require("7f4619194c047ab9"));
func.placeholder = require("e72da4e1722600a0");
module.exports = func;

},{"c200fd606d56e640":"8yrvu","7f4619194c047ab9":"dBTJh","e72da4e1722600a0":"6JeHm"}],"k4r1H":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7bd5bb6f8d804b82").default;
var _interopRequireDefault = require("6b23f3134f676c87").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tableClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Table.default;
    }
});
Object.defineProperty(exports, "tableClasses", {
    enumerable: true,
    get: function() {
        return _tableClasses.default;
    }
});
var _Table = _interopRequireDefault(require("def34959cb123251"));
var _tableClasses = _interopRequireWildcard(require("dd1d979c22346d62"));
Object.keys(_tableClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tableClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tableClasses[key];
        }
    });
});

},{"7bd5bb6f8d804b82":"fiRIh","6b23f3134f676c87":"kZ6eK","def34959cb123251":"3JNqg","dd1d979c22346d62":"9WHwF"}],"3JNqg":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("90e9f532e1c7ff48").default;
var _interopRequireWildcard = require("27d60e8920ff1ef1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("4d5f908f3d1258d9"));
var _propTypes = _interopRequireDefault(require("9147047fafb04c55"));
var _clsx = _interopRequireDefault(require("610286c9340b339"));
var _composeClasses = _interopRequireDefault(require("b172217c8bcd3aa0"));
var _TableContext = _interopRequireDefault(require("af022fb3d3a4f15c"));
var _zeroStyled = require("d4c0bb9518288418");
var _memoTheme = _interopRequireDefault(require("d9dbb7a224b7f28f"));
var _DefaultPropsProvider = require("3db1f8517da98726");
var _tableClasses = require("3fc062fbe266bb86");
var _jsxRuntime = require("2a3c52fcf0ec924");
const useUtilityClasses = (ownerState)=>{
    const { classes, stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, _composeClasses.default)(slots, _tableClasses.getTableUtilityClass, classes);
};
const TableRoot = (0, _zeroStyled.styled)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const defaultComponent = 'table';
const Table = /*#__PURE__*/ React.forwardRef(function Table(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className, component = defaultComponent, padding = 'normal', size = 'medium', stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component,
        padding,
        size,
        stickyHeader
    };
    const classes = useUtilityClasses(ownerState);
    const table = React.useMemo(()=>({
            padding,
            size,
            stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TableContext.default.Provider, {
        value: table,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableRoot, {
            as: component,
            role: component === defaultComponent ? null : 'table',
            ref: ref,
            className: (0, _clsx.default)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
var _default = exports.default = Table;

},{"90e9f532e1c7ff48":"kZ6eK","27d60e8920ff1ef1":"fiRIh","4d5f908f3d1258d9":"9njXz","9147047fafb04c55":"bnNSm","610286c9340b339":"d2NWs","b172217c8bcd3aa0":"59Equ","af022fb3d3a4f15c":"vp6PH","d4c0bb9518288418":"hZXDo","d9dbb7a224b7f28f":"cJNjb","3db1f8517da98726":"9bD8g","3fc062fbe266bb86":"9WHwF","2a3c52fcf0ec924":"1dlk8"}],"vp6PH":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("a1592515e6370396").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f306c12231439681"));
/**
 * @ignore - internal component.
 */ const TableContext = /*#__PURE__*/ React.createContext();
var _default = exports.default = TableContext;

},{"a1592515e6370396":"fiRIh","f306c12231439681":"9njXz"}],"9WHwF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("babbe573243a8070").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTableUtilityClass = getTableUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("5183b12466005d60"));
var _generateUtilityClass = _interopRequireDefault(require("e30d5bae46738eb6"));
function getTableUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTable', slot);
}
const tableClasses = (0, _generateUtilityClasses.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var _default = exports.default = tableClasses;

},{"babbe573243a8070":"kZ6eK","5183b12466005d60":"7pSUk","e30d5bae46738eb6":"jBs9M"}],"9yKSO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("3bb5f2a15ca1b80e").default;
var _interopRequireDefault = require("a33245542375ac9d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tableHeadClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TableHead.default;
    }
});
Object.defineProperty(exports, "tableHeadClasses", {
    enumerable: true,
    get: function() {
        return _tableHeadClasses.default;
    }
});
var _TableHead = _interopRequireDefault(require("6f4517b1941a3a7c"));
var _tableHeadClasses = _interopRequireWildcard(require("8296b80f04f8fe2e"));
Object.keys(_tableHeadClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tableHeadClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tableHeadClasses[key];
        }
    });
});

},{"3bb5f2a15ca1b80e":"fiRIh","a33245542375ac9d":"kZ6eK","6f4517b1941a3a7c":"eNZjD","8296b80f04f8fe2e":"lVtGr"}],"eNZjD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("d061964b2b6e2adf").default;
var _interopRequireWildcard = require("fdcdb661b49c4032").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("82da76f0fc7e250"));
var _propTypes = _interopRequireDefault(require("5c7f67a310a60d28"));
var _clsx = _interopRequireDefault(require("872be72bf604a846"));
var _composeClasses = _interopRequireDefault(require("8d5a254e19101c76"));
var _Tablelvl2Context = _interopRequireDefault(require("fa24c1229bad230c"));
var _zeroStyled = require("be206142fb1c1a88");
var _DefaultPropsProvider = require("cba26d45b7d61e54");
var _tableHeadClasses = require("968001a3edb208bf");
var _jsxRuntime = require("2ef0fd3c3c478437");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _tableHeadClasses.getTableHeadUtilityClass, classes);
};
const TableHeadRoot = (0, _zeroStyled.styled)('thead', {
    name: 'MuiTableHead',
    slot: 'Root'
})({
    display: 'table-header-group'
});
const tablelvl2 = {
    variant: 'head'
};
const defaultComponent = 'thead';
const TableHead = /*#__PURE__*/ React.forwardRef(function TableHead(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className, component = defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Tablelvl2Context.default.Provider, {
        value: tablelvl2,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableHeadRoot, {
            as: component,
            className: (0, _clsx.default)(classes.root, className),
            ref: ref,
            role: component === defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var _default = exports.default = TableHead;

},{"d061964b2b6e2adf":"kZ6eK","fdcdb661b49c4032":"fiRIh","82da76f0fc7e250":"9njXz","5c7f67a310a60d28":"bnNSm","872be72bf604a846":"d2NWs","8d5a254e19101c76":"59Equ","fa24c1229bad230c":"5CvYy","be206142fb1c1a88":"hZXDo","cba26d45b7d61e54":"9bD8g","968001a3edb208bf":"lVtGr","2ef0fd3c3c478437":"1dlk8"}],"5CvYy":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("702962bcaaf6566d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("c25c15131961c229"));
/**
 * @ignore - internal component.
 */ const Tablelvl2Context = /*#__PURE__*/ React.createContext();
var _default = exports.default = Tablelvl2Context;

},{"702962bcaaf6566d":"fiRIh","c25c15131961c229":"9njXz"}],"lVtGr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a5b235a7c9271fb8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTableHeadUtilityClass = getTableHeadUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("3860ef2ac37de772"));
var _generateUtilityClass = _interopRequireDefault(require("2c02e82461c1603c"));
function getTableHeadUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTableHead', slot);
}
const tableHeadClasses = (0, _generateUtilityClasses.default)('MuiTableHead', [
    'root'
]);
var _default = exports.default = tableHeadClasses;

},{"a5b235a7c9271fb8":"kZ6eK","3860ef2ac37de772":"7pSUk","2c02e82461c1603c":"jBs9M"}],"bLA0R":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("327ce199163d0e0c").default;
var _interopRequireDefault = require("80a91629840c0d7c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tableRowClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TableRow.default;
    }
});
Object.defineProperty(exports, "tableRowClasses", {
    enumerable: true,
    get: function() {
        return _tableRowClasses.default;
    }
});
var _TableRow = _interopRequireDefault(require("45a451b4448c2a18"));
var _tableRowClasses = _interopRequireWildcard(require("2ab00487029c89a3"));
Object.keys(_tableRowClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tableRowClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tableRowClasses[key];
        }
    });
});

},{"327ce199163d0e0c":"fiRIh","80a91629840c0d7c":"kZ6eK","45a451b4448c2a18":"foz9T","2ab00487029c89a3":"9UIlo"}],"foz9T":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("4d8a2a3facfc08e1").default;
var _interopRequireWildcard = require("96f4b18430c064dd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("6b91b530fd1a3238"));
var _propTypes = _interopRequireDefault(require("3a69a21d4aaf1da8"));
var _clsx = _interopRequireDefault(require("3593112d358ff658"));
var _composeClasses = _interopRequireDefault(require("4d8707870a5c2a80"));
var _colorManipulator = require("abe1dbdd06f4975");
var _Tablelvl2Context = _interopRequireDefault(require("535217df81672d8d"));
var _zeroStyled = require("c076fbdb6990e36d");
var _memoTheme = _interopRequireDefault(require("af7a4f9599eb494f"));
var _DefaultPropsProvider = require("efe92ea1a96018d6");
var _tableRowClasses = _interopRequireWildcard(require("736e0e1f66a3d2a9"));
var _jsxRuntime = require("4b3ff8a3fdba2432");
const useUtilityClasses = (ownerState)=>{
    const { classes, selected, hover, head, footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, _composeClasses.default)(slots, _tableRowClasses.getTableRowUtilityClass, classes);
};
const TableRowRoot = (0, _zeroStyled.styled)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${_tableRowClasses.default.hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${_tableRowClasses.default.selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    })));
const defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const TableRow = /*#__PURE__*/ React.forwardRef(function TableRow(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className, component = defaultComponent, hover = false, selected = false, ...other } = props;
    const tablelvl2 = React.useContext(_Tablelvl2Context.default);
    const ownerState = {
        ...props,
        component,
        hover,
        selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        role: component === defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
var _default = exports.default = TableRow;

},{"4d8a2a3facfc08e1":"kZ6eK","96f4b18430c064dd":"fiRIh","6b91b530fd1a3238":"9njXz","3a69a21d4aaf1da8":"bnNSm","3593112d358ff658":"d2NWs","4d8707870a5c2a80":"59Equ","abe1dbdd06f4975":"hTYBL","535217df81672d8d":"5CvYy","c076fbdb6990e36d":"hZXDo","af7a4f9599eb494f":"cJNjb","efe92ea1a96018d6":"9bD8g","736e0e1f66a3d2a9":"9UIlo","4b3ff8a3fdba2432":"1dlk8"}],"9UIlo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e242952a9e8592b9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTableRowUtilityClass = getTableRowUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("72ccc2242d0113e1"));
var _generateUtilityClass = _interopRequireDefault(require("92ce490bc308ce9b"));
function getTableRowUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTableRow', slot);
}
const tableRowClasses = (0, _generateUtilityClasses.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var _default = exports.default = tableRowClasses;

},{"e242952a9e8592b9":"kZ6eK","72ccc2242d0113e1":"7pSUk","92ce490bc308ce9b":"jBs9M"}],"2jHBQ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5be7a92ec09395d2").default;
var _interopRequireDefault = require("84f5c1829ac0dc02").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tableBodyClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TableBody.default;
    }
});
Object.defineProperty(exports, "tableBodyClasses", {
    enumerable: true,
    get: function() {
        return _tableBodyClasses.default;
    }
});
var _TableBody = _interopRequireDefault(require("28001fcdc6058525"));
var _tableBodyClasses = _interopRequireWildcard(require("3d8fe2ac53f43363"));
Object.keys(_tableBodyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tableBodyClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tableBodyClasses[key];
        }
    });
});

},{"5be7a92ec09395d2":"fiRIh","84f5c1829ac0dc02":"kZ6eK","28001fcdc6058525":"d2FTY","3d8fe2ac53f43363":"1xowp"}],"d2FTY":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7f14349e0a2a3a7e").default;
var _interopRequireWildcard = require("65f0e1d825c925b6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("78077ca7a0ad8315"));
var _propTypes = _interopRequireDefault(require("8cb449953503535c"));
var _clsx = _interopRequireDefault(require("4ce256cfc9f86b4c"));
var _composeClasses = _interopRequireDefault(require("d73a2c58485af4ed"));
var _Tablelvl2Context = _interopRequireDefault(require("134eefa1debd1003"));
var _zeroStyled = require("e6be5415b57e903a");
var _DefaultPropsProvider = require("fd15ff5545f56b8f");
var _tableBodyClasses = require("9cf28d6b3ee1f68b");
var _jsxRuntime = require("c55900557737e938");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _tableBodyClasses.getTableBodyUtilityClass, classes);
};
const TableBodyRoot = (0, _zeroStyled.styled)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root'
})({
    display: 'table-row-group'
});
const tablelvl2 = {
    variant: 'body'
};
const defaultComponent = 'tbody';
const TableBody = /*#__PURE__*/ React.forwardRef(function TableBody(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className, component = defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Tablelvl2Context.default.Provider, {
        value: tablelvl2,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableBodyRoot, {
            className: (0, _clsx.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var _default = exports.default = TableBody;

},{"7f14349e0a2a3a7e":"kZ6eK","65f0e1d825c925b6":"fiRIh","78077ca7a0ad8315":"9njXz","8cb449953503535c":"bnNSm","4ce256cfc9f86b4c":"d2NWs","d73a2c58485af4ed":"59Equ","134eefa1debd1003":"5CvYy","e6be5415b57e903a":"hZXDo","fd15ff5545f56b8f":"9bD8g","9cf28d6b3ee1f68b":"1xowp","c55900557737e938":"1dlk8"}],"1xowp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("43856c5e0c76959b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTableBodyUtilityClass = getTableBodyUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("d1c5b8a5b58d991c"));
var _generateUtilityClass = _interopRequireDefault(require("e38d0870723273c4"));
function getTableBodyUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTableBody', slot);
}
const tableBodyClasses = (0, _generateUtilityClasses.default)('MuiTableBody', [
    'root'
]);
var _default = exports.default = tableBodyClasses;

},{"43856c5e0c76959b":"kZ6eK","d1c5b8a5b58d991c":"7pSUk","e38d0870723273c4":"jBs9M"}],"6WlPV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("b915b1c5f9a8cc8a").default;
var _interopRequireDefault = require("1a3d166f860c2b03").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tableCellClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TableCell.default;
    }
});
Object.defineProperty(exports, "tableCellClasses", {
    enumerable: true,
    get: function() {
        return _tableCellClasses.default;
    }
});
var _TableCell = _interopRequireDefault(require("bcfb0ab1df0a5576"));
var _tableCellClasses = _interopRequireWildcard(require("f59c6be03288e7c8"));
Object.keys(_tableCellClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tableCellClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tableCellClasses[key];
        }
    });
});

},{"b915b1c5f9a8cc8a":"fiRIh","1a3d166f860c2b03":"kZ6eK","bcfb0ab1df0a5576":"liZct","f59c6be03288e7c8":"dDVQq"}],"liZct":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("451333a855159d6d").default;
var _interopRequireWildcard = require("b8db06a0647ac59e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("7ac5d7e310980e37"));
var _propTypes = _interopRequireDefault(require("3ccf6234fa816338"));
var _clsx = _interopRequireDefault(require("40a462ed2f266c7e"));
var _composeClasses = _interopRequireDefault(require("23c180fb1f3a130b"));
var _colorManipulator = require("3f121c8f01baffd6");
var _capitalize = _interopRequireDefault(require("6ccedfcbd059f84d"));
var _TableContext = _interopRequireDefault(require("d8d5855b1ffae0b5"));
var _Tablelvl2Context = _interopRequireDefault(require("425912913ff4eeaa"));
var _zeroStyled = require("95f2fb5550e447f");
var _memoTheme = _interopRequireDefault(require("a9ba682b941d2a7"));
var _DefaultPropsProvider = require("200819e2ef6b7ef8");
var _tableCellClasses = _interopRequireWildcard(require("f3d50b5de67d1e30"));
var _jsxRuntime = require("8dee508acdda798f");
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, align, padding, size, stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, _capitalize.default)(align)}`,
            padding !== 'normal' && `padding${(0, _capitalize.default)(padding)}`,
            `size${(0, _capitalize.default)(size)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _tableCellClasses.getTableCellUtilityClass, classes);
};
const TableCellRoot = (0, _zeroStyled.styled)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, _capitalize.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, _capitalize.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, _capitalize.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.alpha)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${_tableCellClasses.default.paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const TableCell = /*#__PURE__*/ React.forwardRef(function TableCell(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align = 'inherit', className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection, variant: variantProp, ...other } = props;
    const table = React.useContext(_TableContext.default);
    const tablelvl2 = React.useContext(_Tablelvl2Context.default);
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align,
        component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var _default = exports.default = TableCell;

},{"451333a855159d6d":"kZ6eK","b8db06a0647ac59e":"fiRIh","7ac5d7e310980e37":"9njXz","3ccf6234fa816338":"bnNSm","40a462ed2f266c7e":"d2NWs","23c180fb1f3a130b":"59Equ","3f121c8f01baffd6":"hTYBL","6ccedfcbd059f84d":"eOYSA","d8d5855b1ffae0b5":"vp6PH","425912913ff4eeaa":"5CvYy","95f2fb5550e447f":"hZXDo","a9ba682b941d2a7":"cJNjb","200819e2ef6b7ef8":"9bD8g","f3d50b5de67d1e30":"dDVQq","8dee508acdda798f":"1dlk8"}],"dDVQq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b02a4621f35025f4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTableCellUtilityClass = getTableCellUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("69499dbff6759e11"));
var _generateUtilityClass = _interopRequireDefault(require("2c929fd907bb2859"));
function getTableCellUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTableCell', slot);
}
const tableCellClasses = (0, _generateUtilityClasses.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var _default = exports.default = tableCellClasses;

},{"b02a4621f35025f4":"kZ6eK","69499dbff6759e11":"7pSUk","2c929fd907bb2859":"jBs9M"}],"fQGJX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("555c7ba1edff4bdd").default;
var _interopRequireDefault = require("c917c9d7d0a95878").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tableFooterClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TableFooter.default;
    }
});
Object.defineProperty(exports, "tableFooterClasses", {
    enumerable: true,
    get: function() {
        return _tableFooterClasses.default;
    }
});
var _TableFooter = _interopRequireDefault(require("97986077b1b86345"));
var _tableFooterClasses = _interopRequireWildcard(require("86a846e82ca1eac1"));
Object.keys(_tableFooterClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tableFooterClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tableFooterClasses[key];
        }
    });
});

},{"555c7ba1edff4bdd":"fiRIh","c917c9d7d0a95878":"kZ6eK","97986077b1b86345":"a3cHW","86a846e82ca1eac1":"2ageL"}],"a3cHW":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c2841d39c1bbb52e").default;
var _interopRequireWildcard = require("52b7570170144579").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("bfaa2b4bee5feaea"));
var _propTypes = _interopRequireDefault(require("26d517e0f5dc920e"));
var _clsx = _interopRequireDefault(require("7123610a03faccc7"));
var _composeClasses = _interopRequireDefault(require("f90df0e28c9faef8"));
var _Tablelvl2Context = _interopRequireDefault(require("a744922100327c25"));
var _zeroStyled = require("71e115f2772a4f6b");
var _DefaultPropsProvider = require("d34e7490f52a2e9a");
var _tableFooterClasses = require("7eac97329ebb69e");
var _jsxRuntime = require("27a258985a480b44");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _tableFooterClasses.getTableFooterUtilityClass, classes);
};
const TableFooterRoot = (0, _zeroStyled.styled)('tfoot', {
    name: 'MuiTableFooter',
    slot: 'Root'
})({
    display: 'table-footer-group'
});
const tablelvl2 = {
    variant: 'footer'
};
const defaultComponent = 'tfoot';
const TableFooter = /*#__PURE__*/ React.forwardRef(function TableFooter(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableFooter'
    });
    const { className, component = defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Tablelvl2Context.default.Provider, {
        value: tablelvl2,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableFooterRoot, {
            as: component,
            className: (0, _clsx.default)(classes.root, className),
            ref: ref,
            role: component === defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var _default = exports.default = TableFooter;

},{"c2841d39c1bbb52e":"kZ6eK","52b7570170144579":"fiRIh","bfaa2b4bee5feaea":"9njXz","26d517e0f5dc920e":"bnNSm","7123610a03faccc7":"d2NWs","f90df0e28c9faef8":"59Equ","a744922100327c25":"5CvYy","71e115f2772a4f6b":"hZXDo","d34e7490f52a2e9a":"9bD8g","7eac97329ebb69e":"2ageL","27a258985a480b44":"1dlk8"}],"2ageL":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7401233eb3946c58").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTableFooterUtilityClass = getTableFooterUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("676bbe6044f8d109"));
var _generateUtilityClass = _interopRequireDefault(require("54d2ef7538e98482"));
function getTableFooterUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTableFooter', slot);
}
const tableFooterClasses = (0, _generateUtilityClasses.default)('MuiTableFooter', [
    'root'
]);
var _default = exports.default = tableFooterClasses;

},{"7401233eb3946c58":"kZ6eK","676bbe6044f8d109":"7pSUk","54d2ef7538e98482":"jBs9M"}],"gDN67":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _styles = require("@mui/material/styles");
const styles = {
    container: {
        padding: (theme)=>theme.spacing(2)
    },
    coverContainer: {
        position: 'relative',
        width: '100%'
    },
    cover: {
        position: 'absolute',
        inset: 0,
        background: (theme)=>(0, _styles.alpha)(theme.palette.background.paper, 0.5),
        transition: 'all .2s'
    },
    progress: {
        position: 'sticky',
        top: '20px'
    }
};
/**
 * Component to display 'loading' state on component (we wrap component with it)
 * @param pending - when we should show the 'loading' state
 * @param children - component to wrap around
 * @param cover - whether we should show component covered with shadow and 'loading' spinner on it, otherwise spinner replaces component
 * @param id
 */ const Pendable = ({ pending, children, cover, coverContainerProps, id })=>{
    return !cover ? pending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        container: true,
        justifyContent: "center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
            sx: styles.container,
            "data-test-id": id ? `pendable-${id}` : undefined,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                "data-test-id": "progress"
            })
        })
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            ...styles.coverContainer,
            ...coverContainerProps ?? {}
        },
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                container: true,
                justifyContent: "center",
                sx: {
                    ...styles.cover,
                    visibility: pending ? 'visible' : 'hidden'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    sx: styles.container,
                    "data-test-id": id ? `pendable-${id}` : undefined,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                        sx: styles.progress,
                        "data-test-id": "progress"
                    })
                })
            })
        ]
    });
};
exports.default = Pendable;

},{"react/jsx-runtime":"1dlk8","@mui/material/CircularProgress":"kEtIR","@mui/material/Box":"c4QkF","@mui/material/Grid":"6iX4B","@mui/material/styles":"2UrBk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"HM37R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", ()=>Pagination);
var _jsxRuntime = require("react/jsx-runtime");
var _pagination = require("@mui/material/Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _utils = require("../../../utils");
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _styles = require("@mui/material/styles");
var _react = require("react");
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
const Pagination = ({ id, changePageCallback, changeRowsPerPageCallback, page, perPage, total, useUrlSearchParams, hidePerPageOption, hideJumpToPage })=>{
    const [params, setPageParams] = (0, _utils.usePageParams)();
    const [pageNumberKey, rowsPerPageKey] = typeof useUrlSearchParams === 'object' ? [
        useUrlSearchParams.pageNumberKey,
        useUrlSearchParams.rowsPerPageKey
    ] : [
        'pageNumber',
        'rowsPerPage'
    ];
    // Set current page according to order: 1) TablePagination 2) Url params 3) Defaults
    const pageNumber = page !== undefined ? page : params[pageNumberKey] ?? '0';
    const rowsPerPageStr = getValidRowsPerPage(perPage !== undefined ? perPage : params[rowsPerPageKey] ?? (0, _utils.DEFAULT_PAGINATION).rowsPerPage);
    function getValidRowsPerPage(rowsPerPageStr) {
        const lRowsPerPage = parseInt(rowsPerPageStr);
        const isValid = !isNaN(lRowsPerPage) && lRowsPerPage > 0;
        return isValid ? rowsPerPageStr : '10';
    }
    const handlePageChange = (page)=>{
        if (changePageCallback) return changePageCallback(String(page));
        if (useUrlSearchParams) setPageParams({
            [rowsPerPageKey]: rowsPerPageStr,
            [pageNumberKey]: String(page)
        });
    };
    const handleRowsPerPageChange = (rowsPerPage)=>{
        if (changeRowsPerPageCallback) return changeRowsPerPageCallback(String(rowsPerPage));
        if (useUrlSearchParams) {
            (0, _utils.DEFAULT_PAGINATION).rowsPerPage = getValidRowsPerPage(String(rowsPerPage));
            setPageParams({
                [rowsPerPageKey]: String(rowsPerPage),
                [pageNumberKey]: '0'
            });
        }
    };
    const rowsPerPageOptions = Array.from(new Set([
        10,
        30,
        50,
        parseInt(rowsPerPageStr)
    ])).sort((a, b)=>a - b);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationComponent, {
        "data-test-id": id ? `pagination-${id}` : undefined,
        total: total,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handleRowsPerPageChange,
        page: Number(pageNumber),
        rowsPerPageOptions: rowsPerPageOptions,
        rowsPerPage: Number(rowsPerPageStr),
        hideRowsPerPage: hidePerPageOption,
        hideJumpToPage: hideJumpToPage
    });
};
const PaginationComponent = ({ rowsPerPage: unsafeRowsPerPage, rowsPerPageOptions, onRowsPerPageChange, page, onPageChange, total, hideRowsPerPage, hideJumpToPage })=>{
    const theme = (0, _styles.useTheme)();
    const pagePlusOne = page + 1 // MuiPagination page prop starts at 1, but our api is zero-indexed
    ;
    const rowsPerPage = Math.max(1, unsafeRowsPerPage);
    const upperBound = pagePlusOne * rowsPerPage;
    const lowerBound = upperBound - rowsPerPage + 1;
    const cappedUpperBound = Math.min(upperBound, total);
    const cappedLowerBound = Math.min(lowerBound, total);
    const lastPage = Math.ceil(total / rowsPerPage);
    const [requestedPage, setRequestedPage] = (0, _react.useState)('');
    const goToRequestedPage = ()=>{
        const requestedPageNumber = parseInt(requestedPage) - 1;
        if (!isNaN(requestedPageNumber)) {
            const safePage = Math.max(0, Math.min(lastPage - 1, requestedPageNumber));
            if (safePage !== page) {
                setRequestedPage('');
                onPageChange(safePage);
            }
        }
    };
    const minimumRowsPerPages = Math.min(...rowsPerPageOptions);
    const hasMultiplePages = total > minimumRowsPerPages;
    const canPaginate = lastPage > 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            width: '100%',
            height: 50,
            padding: '4px 12px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        children: [
            !hideRowsPerPage && hasMultiplePages && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        style: {
                            fontSize: theme.typography.body2.fontSize
                        },
                        children: "Rows Per Page:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: '12px'
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        style: {
                            fontSize: theme.typography.body2.fontSize
                        },
                        variant: "standard",
                        value: rowsPerPage,
                        onChange: ({ target })=>onRowsPerPageChange(target.value),
                        children: rowsPerPageOptions.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: option,
                                children: option
                            }, `menu-item-${option}`))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    flexGrow: 1
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        style: {
                            fontSize: theme.typography.body2.fontSize
                        },
                        children: [
                            cappedLowerBound,
                            "-",
                            cappedUpperBound,
                            " of ",
                            total
                        ]
                    }),
                    !hideJumpToPage && canPaginate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                        type: 'text',
                        style: {
                            marginLeft: '4px',
                            maxWidth: '92px',
                            paddingLeft: 6,
                            paddingRight: 2
                        },
                        size: 'small',
                        variant: "outlined",
                        label: 'Go to page',
                        value: requestedPage,
                        onChange: ({ target })=>{
                            const isValidInteger = !isNaN(Number(target.value)) && // Number allows whitespaces, tabs, newlines (and who knows what else)
                            !isNaN(parseInt(target.value)) && // parseInt allows "1 2" (will be parsed to "1")
                            !target.value.includes(' ') && // e.g. '3   '
                            !target.value.includes('.') && // e.g. '3.5'
                            !(target.value.startsWith('0') && target.value.length > 1 // e.g. '0000'
                            );
                            if (target.value === '' || isValidInteger) setRequestedPage(target.value);
                        },
                        onKeyDown: (ev)=>{
                            if (ev.key === 'Enter') {
                                goToRequestedPage();
                                ev.preventDefault();
                            }
                        },
                        slotProps: {
                            inputLabel: {
                                style: {
                                    fontSize: theme.typography.body2.fontSize
                                }
                            }
                        }
                    }),
                    canPaginate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
                        size: "small",
                        shape: "rounded",
                        page: pagePlusOne,
                        count: lastPage,
                        onChange: (_, requestedPage)=>onPageChange(requestedPage - 1)
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Pagination":"c213b","../../../utils":"342UB","@mui/material/MenuItem":"krMs8","@mui/material/Select":"kyj0v","@mui/material/styles":"2UrBk","react":"9njXz","@mui/material/TextField":"l88b4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c213b":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a9fc462f2b0efc82").default;
var _interopRequireDefault = require("1081c4c4ae4ab1fd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    paginationClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Pagination.default;
    }
});
Object.defineProperty(exports, "paginationClasses", {
    enumerable: true,
    get: function() {
        return _paginationClasses.default;
    }
});
var _Pagination = _interopRequireDefault(require("8e645d474d55adee"));
var _paginationClasses = _interopRequireWildcard(require("64780ca0eba88aca"));
Object.keys(_paginationClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _paginationClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _paginationClasses[key];
        }
    });
});

},{"a9fc462f2b0efc82":"fiRIh","1081c4c4ae4ab1fd":"kZ6eK","8e645d474d55adee":"29sl8","64780ca0eba88aca":"cu7hX"}],"29sl8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("eef1d3e7b992b0c").default;
var _interopRequireWildcard = require("aab1b419709b0831").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("96ffdddec2b53013"));
var _propTypes = _interopRequireDefault(require("9e6ae03712a4faaf"));
var _clsx = _interopRequireDefault(require("e6ff402d401af6ba"));
var _composeClasses = _interopRequireDefault(require("4ca4c04b57e970bd"));
var _integerPropType = _interopRequireDefault(require("7a31fc29da1a006f"));
var _paginationClasses = require("aa7b893b159fb423");
var _usePagination = _interopRequireDefault(require("be99c034902a8480"));
var _PaginationItem = _interopRequireDefault(require("17b1a61e203e7b4a"));
var _zeroStyled = require("83462bfda4eaed4f");
var _DefaultPropsProvider = require("3a75e2295aa507ad");
var _jsxRuntime = require("673390374ebeacd2");
const useUtilityClasses = (ownerState)=>{
    const { classes, variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, _composeClasses.default)(slots, _paginationClasses.getPaginationUtilityClass, classes);
};
const PaginationRoot = (0, _zeroStyled.styled)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const PaginationUl = (0, _zeroStyled.styled)('ul', {
    name: 'MuiPagination',
    slot: 'Ul'
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const Pagination = /*#__PURE__*/ React.forwardRef(function Pagination(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount = 1, className, color = 'standard', count = 1, defaultPage = 1, disabled = false, getItemAriaLabel = defaultGetAriaLabel, hideNextButton = false, hidePrevButton = false, onChange, page, renderItem = (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_PaginationItem.default, {
            ...item
        }), shape = 'circular', showFirstButton = false, showLastButton = false, siblingCount = 1, size = 'medium', variant = 'text', ...other } = props;
    const { items } = (0, _usePagination.default)({
        ...props,
        componentName: 'Pagination'
    });
    const ownerState = {
        ...props,
        boundaryCount,
        color,
        count,
        defaultPage,
        disabled,
        getItemAriaLabel,
        hideNextButton,
        hidePrevButton,
        renderItem,
        shape,
        showFirstButton,
        showLastButton,
        siblingCount,
        size,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationRoot, {
        "aria-label": "pagination navigation",
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    children: renderItem({
                        ...item,
                        color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape,
                        size,
                        variant
                    })
                }, index))
        })
    });
});
var _default = exports.default = Pagination;

},{"eef1d3e7b992b0c":"kZ6eK","aab1b419709b0831":"fiRIh","96ffdddec2b53013":"9njXz","9e6ae03712a4faaf":"bnNSm","e6ff402d401af6ba":"d2NWs","4ca4c04b57e970bd":"59Equ","7a31fc29da1a006f":"iZJbi","aa7b893b159fb423":"cu7hX","be99c034902a8480":"dZpcs","17b1a61e203e7b4a":"bEa65","83462bfda4eaed4f":"hZXDo","3a75e2295aa507ad":"9bD8g","673390374ebeacd2":"1dlk8"}],"cu7hX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8619a77402721618").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPaginationUtilityClass = getPaginationUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("440057d9bcdc1209"));
var _generateUtilityClass = _interopRequireDefault(require("669f8509824ebe3e"));
function getPaginationUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPagination', slot);
}
const paginationClasses = (0, _generateUtilityClasses.default)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
var _default = exports.default = paginationClasses;

},{"8619a77402721618":"kZ6eK","440057d9bcdc1209":"7pSUk","669f8509824ebe3e":"jBs9M"}],"dZpcs":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4c74f264a10bf1bb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _usePagination.default;
    }
});
var _usePagination = _interopRequireDefault(require("c71abfe50b5484be"));

},{"4c74f264a10bf1bb":"kZ6eK","c71abfe50b5484be":"k6LbF"}],"k6LbF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("edc76007c4714042").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = usePagination;
var _useControlled = _interopRequireDefault(require("9e07216b26ded834"));
function usePagination(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount = 1, componentName = 'usePagination', count = 1, defaultPage = 1, disabled = false, hideNextButton = false, hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton = false, showLastButton = false, siblingCount = 1, ...other } = props;
    const [page, setPageState] = (0, _useControlled.default)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    count - boundaryCount - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled,
            'aria-current': item === page ? 'page' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || !item.includes('ellipsis') && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return {
        items,
        ...other
    };
}

},{"edc76007c4714042":"kZ6eK","9e07216b26ded834":"jwZrv"}],"bEa65":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a84ac37731431af4").default;
var _interopRequireDefault = require("8262d7de7fc83d39").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    paginationItemClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _PaginationItem.default;
    }
});
Object.defineProperty(exports, "paginationItemClasses", {
    enumerable: true,
    get: function() {
        return _paginationItemClasses.default;
    }
});
var _PaginationItem = _interopRequireDefault(require("d7cba9ef26566489"));
var _paginationItemClasses = _interopRequireWildcard(require("758e480a5422ca34"));
Object.keys(_paginationItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _paginationItemClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _paginationItemClasses[key];
        }
    });
});

},{"a84ac37731431af4":"fiRIh","8262d7de7fc83d39":"kZ6eK","d7cba9ef26566489":"kt4eM","758e480a5422ca34":"CcdyO"}],"kt4eM":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("4f6fa188c7a6e42d").default;
var _interopRequireWildcard = require("2e0e297c90af00e0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("12dcaa9bb1f34e4a"));
var _propTypes = _interopRequireDefault(require("d5c11c13c98f899f"));
var _clsx = _interopRequireDefault(require("f10df2ce65737fd2"));
var _composeClasses = _interopRequireDefault(require("26238ac00d3084cd"));
var _colorManipulator = require("b49432e69a482bd2");
var _RtlProvider = require("a4e33940aff695bf");
var _paginationItemClasses = _interopRequireWildcard(require("1eed1ee6c663f876"));
var _ButtonBase = _interopRequireDefault(require("38f3d079a318335c"));
var _capitalize = _interopRequireDefault(require("ca0728fee6de13aa"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("9cd3ebca63cbd005"));
var _FirstPage = _interopRequireDefault(require("c57c12fbb918e6ed"));
var _LastPage = _interopRequireDefault(require("fdc059a75b4361cb"));
var _NavigateBefore = _interopRequireDefault(require("6c0b00e5ae05ea78"));
var _NavigateNext = _interopRequireDefault(require("473b1043aa9d9570"));
var _useSlot = _interopRequireDefault(require("22a9beb23291852"));
var _zeroStyled = require("da1ca4c19322d170");
var _memoTheme = _interopRequireDefault(require("86b53d5bef261243"));
var _DefaultPropsProvider = require("70597b94f04b0bae");
var _jsxRuntime = require("416f61db58105899");
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, _capitalize.default)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, _capitalize.default)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, _capitalize.default)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, selected, size, shape, type, variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, _capitalize.default)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, _capitalize.default)(color)}`,
            color !== 'standard' && `${variant}${(0, _capitalize.default)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, _composeClasses.default)(slots, _paginationItemClasses.getPaginationItemUtilityClass, classes);
};
const PaginationItemEllipsis = (0, _zeroStyled.styled)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body2,
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${_paginationItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    minWidth: 26,
                    borderRadius: 13,
                    margin: '0 1px',
                    padding: '0 4px'
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    minWidth: 40,
                    borderRadius: 20,
                    padding: '0 10px',
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const PaginationItemPage = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body2,
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${_paginationItemClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${_paginationItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${_paginationItemClasses.default.selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${_paginationItemClasses.default.focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${_paginationItemClasses.default.disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    minWidth: 26,
                    height: 26,
                    borderRadius: 13,
                    margin: '0 1px',
                    padding: '0 4px'
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    minWidth: 40,
                    height: 40,
                    borderRadius: 20,
                    padding: '0 10px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    shape: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                    [`&.${_paginationItemClasses.default.selected}`]: {
                        [`&.${_paginationItemClasses.default.disabled}`]: {
                            borderColor: (theme.vars || theme).palette.action.disabledBackground,
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    [`&.${_paginationItemClasses.default.selected}`]: {
                        [`&.${_paginationItemClasses.default.disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'dark',
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        variant: 'text',
                        color
                    },
                    style: {
                        [`&.${_paginationItemClasses.default.selected}`]: {
                            color: (theme.vars || theme).palette[color].contrastText,
                            backgroundColor: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: (theme.vars || theme).palette[color].dark,
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: (theme.vars || theme).palette[color].main
                                }
                            },
                            [`&.${_paginationItemClasses.default.focusVisible}`]: {
                                backgroundColor: (theme.vars || theme).palette[color].dark
                            },
                            [`&.${_paginationItemClasses.default.disabled}`]: {
                                color: (theme.vars || theme).palette.action.disabled
                            }
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color
                    },
                    style: {
                        [`&.${_paginationItemClasses.default.selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.5)}`,
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.activatedOpacity),
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${_paginationItemClasses.default.focusVisible}`]: {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
                            }
                        }
                    }
                }))
        ]
    })));
const PaginationItemPageIcon = (0, _zeroStyled.styled)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon'
})((0, _memoTheme.default)(({ theme })=>({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px',
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(22)
                }
            }
        ]
    })));
const PaginationItem = /*#__PURE__*/ React.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className, color = 'standard', component, components = {}, disabled = false, page, selected = false, shape = 'circular', size = 'medium', slots = {}, slotProps = {}, type = 'page', variant = 'text', ...other } = props;
    const ownerState = {
        ...props,
        color,
        disabled,
        selected,
        shape,
        size,
        type,
        variant
    };
    const isRtl = (0, _RtlProvider.useRtl)();
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            previous: slots.previous ?? components.previous,
            next: slots.next ?? components.next,
            first: slots.first ?? components.first,
            last: slots.last ?? components.last
        },
        slotProps
    };
    const [PreviousSlot, previousSlotProps] = (0, _useSlot.default)('previous', {
        elementType: _NavigateBefore.default,
        externalForwardedProps,
        ownerState
    });
    const [NextSlot, nextSlotProps] = (0, _useSlot.default)('next', {
        elementType: _NavigateNext.default,
        externalForwardedProps,
        ownerState
    });
    const [FirstSlot, firstSlotProps] = (0, _useSlot.default)('first', {
        elementType: _FirstPage.default,
        externalForwardedProps,
        ownerState
    });
    const [LastSlot, lastSlotProps] = (0, _useSlot.default)('last', {
        elementType: _LastPage.default,
        externalForwardedProps,
        ownerState
    });
    const rtlAwareType = isRtl ? ({
        previous: 'next',
        next: 'previous',
        first: 'last',
        last: 'first'
    })[type] : type;
    const IconSlot = {
        previous: PreviousSlot,
        next: NextSlot,
        first: FirstSlot,
        last: LastSlot
    }[rtlAwareType];
    const iconSlotProps = {
        previous: previousSlotProps,
        next: nextSlotProps,
        first: firstSlotProps,
        last: lastSlotProps
    }[rtlAwareType];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PaginationItemPage, {
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, _clsx.default)(classes.root, className),
        ...other,
        children: [
            type === 'page' && page,
            IconSlot ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationItemPageIcon, {
                ...iconSlotProps,
                className: classes.icon,
                as: IconSlot
            }) : null
        ]
    });
});
var _default = exports.default = PaginationItem;

},{"4f6fa188c7a6e42d":"kZ6eK","2e0e297c90af00e0":"fiRIh","12dcaa9bb1f34e4a":"9njXz","d5c11c13c98f899f":"bnNSm","f10df2ce65737fd2":"d2NWs","26238ac00d3084cd":"59Equ","b49432e69a482bd2":"hTYBL","a4e33940aff695bf":"ck9Pb","1eed1ee6c663f876":"CcdyO","38f3d079a318335c":"7X8rf","ca0728fee6de13aa":"eOYSA","9cd3ebca63cbd005":"2r5WG","c57c12fbb918e6ed":"dJssb","fdc059a75b4361cb":"abyvd","6c0b00e5ae05ea78":"gTSby","473b1043aa9d9570":"8qoaZ","22a9beb23291852":"h76AU","da1ca4c19322d170":"hZXDo","86b53d5bef261243":"cJNjb","70597b94f04b0bae":"9bD8g","416f61db58105899":"1dlk8"}],"CcdyO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("41cf8382f098b9fa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPaginationItemUtilityClass = getPaginationItemUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("dd4ee097eacf9c36"));
var _generateUtilityClass = _interopRequireDefault(require("fd4545da5dddc661"));
function getPaginationItemUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPaginationItem', slot);
}
const paginationItemClasses = (0, _generateUtilityClasses.default)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
var _default = exports.default = paginationItemClasses;

},{"41cf8382f098b9fa":"kZ6eK","dd4ee097eacf9c36":"7pSUk","fd4545da5dddc661":"jBs9M"}],"dJssb":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("39e6f7dd7a2ce714").default;
var _interopRequireWildcard = require("39d39ec04dbb893").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("8c8bec7be90871ad"));
var _createSvgIcon = _interopRequireDefault(require("af056b41defd64e3"));
var _jsxRuntime = require("fcb890e391fcc8f9");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

},{"39e6f7dd7a2ce714":"kZ6eK","39d39ec04dbb893":"fiRIh","8c8bec7be90871ad":"9njXz","af056b41defd64e3":"5sni0","fcb890e391fcc8f9":"1dlk8"}],"abyvd":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("194c71ca00df19ee").default;
var _interopRequireWildcard = require("484cb8232071e5c9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("845e6cd390ee906e"));
var _createSvgIcon = _interopRequireDefault(require("88b4b7f5bfd73006"));
var _jsxRuntime = require("35aafae2528fcc76");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

},{"194c71ca00df19ee":"kZ6eK","484cb8232071e5c9":"fiRIh","845e6cd390ee906e":"9njXz","88b4b7f5bfd73006":"5sni0","35aafae2528fcc76":"1dlk8"}],"gTSby":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9c53a5651b6312d7").default;
var _interopRequireWildcard = require("108206753d259516").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("928da79ad2eb06be"));
var _createSvgIcon = _interopRequireDefault(require("6a08f1111a8615a2"));
var _jsxRuntime = require("a67396ffe6e90185");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

},{"9c53a5651b6312d7":"kZ6eK","108206753d259516":"fiRIh","928da79ad2eb06be":"9njXz","6a08f1111a8615a2":"5sni0","a67396ffe6e90185":"1dlk8"}],"8qoaZ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ac9588523f7b5580").default;
var _interopRequireWildcard = require("f55bff8bd85847ea").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("15ee09b891a0a208"));
var _createSvgIcon = _interopRequireDefault(require("8055200117098e16"));
var _jsxRuntime = require("e30cd5c25ebdac59");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

},{"ac9588523f7b5580":"kZ6eK","f55bff8bd85847ea":"fiRIh","15ee09b891a0a208":"9njXz","8055200117098e16":"5sni0","e30cd5c25ebdac59":"1dlk8"}],"5BE9S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortDirection", ()=>SortDirection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _tableSortLabel = require("@mui/material/TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
var _utils = require("../../../utils");
var SortDirection = /*#__PURE__*/ function(SortDirection) {
    SortDirection["asc"] = "asc";
    SortDirection["desc"] = "desc";
    return SortDirection;
}({});
const classes = {
    columnHeader: {
        fontWeight: 'bold',
        textTransform: 'capitalize'
    }
};
/**
 * Returns reverse direction or 'asc' as default
 * @param direction - current direction
 */ const getNewDirection = (direction)=>{
    if (!direction) return "asc";
    return direction === "asc" ? "desc" : "asc";
};
/**
 * Column header for sortable column (only for Redux parameters based tables)
 * @param byParameter - which sort parameter we should set by clicking on it
 * @param title - column title
 */ const UrlParamsSortableHeader = ({ title, sortKey })=>{
    const [pageParams, setPageParams] = (0, _utils.usePageParams)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableHeader, {
        title: title,
        sortKey: sortKey,
        currentSortKey: pageParams,
        onSortOrderChanged: setPageParams
    });
};
const SortableHeader = ({ title, sortKey, currentSortKey, onSortOrderChanged })=>{
    let sortProps = {};
    if (currentSortKey && 'asc' in currentSortKey && currentSortKey.asc === sortKey) sortProps = {
        active: true,
        direction: "asc"
    };
    else if (currentSortKey && 'desc' in currentSortKey && currentSortKey.desc === sortKey) sortProps = {
        active: true,
        direction: "desc"
    };
    const setSort = (parameter, direction)=>{
        const newSorting = {
            asc: direction === "asc" ? parameter : undefined,
            desc: direction === "desc" ? parameter : undefined
        };
        onSortOrderChanged(newSorting);
    };
    const onClick = ()=>setSort(sortKey, getNewDirection(sortProps.direction));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableSortLabelDefault.default), {
        ...sortProps,
        onClick: onClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            variant: "body2",
            sx: classes.columnHeader,
            children: title
        })
    });
};
/**
 * Common table column header
 * @param props - title and sorting properties
 */ const ColumnHeader = ({ title, sorting, currentSortKey, onSortOrderChanged })=>{
    return !sorting || sorting.hidden ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        variant: "body2",
        sx: classes.columnHeader,
        children: title
    }) : onSortOrderChanged ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableHeader, {
        title: title,
        sortKey: sorting.byParameter,
        currentSortKey: currentSortKey,
        onSortOrderChanged: onSortOrderChanged
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(UrlParamsSortableHeader, {
        title: title,
        sortKey: sorting.byParameter
    });
};
exports.default = ColumnHeader;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Typography":"6NtGx","@mui/material/TableSortLabel":"9TO3Z","../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9TO3Z":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("8dc067b48ff214d5").default;
var _interopRequireDefault = require("7e23c4a95cee1a6a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tableSortLabelClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TableSortLabel.default;
    }
});
Object.defineProperty(exports, "tableSortLabelClasses", {
    enumerable: true,
    get: function() {
        return _tableSortLabelClasses.default;
    }
});
var _TableSortLabel = _interopRequireDefault(require("b49cf87d72c9d080"));
var _tableSortLabelClasses = _interopRequireWildcard(require("29e7c568bdf2f8bf"));
Object.keys(_tableSortLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tableSortLabelClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tableSortLabelClasses[key];
        }
    });
});

},{"8dc067b48ff214d5":"fiRIh","7e23c4a95cee1a6a":"kZ6eK","b49cf87d72c9d080":"fwt60","29e7c568bdf2f8bf":"ezGpE"}],"fwt60":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("a699612ba5e6d1e1").default;
var _interopRequireDefault = require("504b026b3a9fa0d2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _composeClasses = _interopRequireDefault(require("79668dc32cc9cb65"));
var _clsx = _interopRequireDefault(require("9dd28fff663f0284"));
var _propTypes = _interopRequireDefault(require("158268993fe64529"));
var React = _interopRequireWildcard(require("3c3b60d9c2b2f68"));
var _ButtonBase = _interopRequireDefault(require("e29770fd2ad5de73"));
var _ArrowDownward = _interopRequireDefault(require("f75509950dfa24f9"));
var _zeroStyled = require("6d6f5038cb1a65f7");
var _memoTheme = _interopRequireDefault(require("551e52468b427f45"));
var _DefaultPropsProvider = require("ca5077eeba699d09");
var _capitalize = _interopRequireDefault(require("288985c302a3f21a"));
var _tableSortLabelClasses = _interopRequireWildcard(require("205edd6c0debdd1e"));
var _useSlot = _interopRequireDefault(require("e21853da7642914f"));
var _jsxRuntime = require("498fd51ffaa24819");
const useUtilityClasses = (ownerState)=>{
    const { classes, direction, active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            `direction${(0, _capitalize.default)(direction)}`
        ],
        icon: [
            'icon',
            `iconDirection${(0, _capitalize.default)(direction)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _tableSortLabelClasses.getTableSortLabelUtilityClass, classes);
};
const TableSortLabelRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${_tableSortLabelClasses.default.icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${_tableSortLabelClasses.default.active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${_tableSortLabelClasses.default.icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    })));
const TableSortLabelIcon = (0, _zeroStyled.styled)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, _capitalize.default)(ownerState.direction)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none',
        variants: [
            {
                props: {
                    direction: 'desc'
                },
                style: {
                    transform: 'rotate(0deg)'
                }
            },
            {
                props: {
                    direction: 'asc'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const TableSortLabel = /*#__PURE__*/ React.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active = false, children, className, direction = 'asc', hideSortIcon = false, IconComponent = _ArrowDownward.default, slots = {}, slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        active,
        direction,
        hideSortIcon,
        IconComponent
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots,
        slotProps
    };
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        elementType: TableSortLabelRoot,
        externalForwardedProps,
        ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref
    });
    const [IconSlot, iconProps] = (0, _useSlot.default)('icon', {
        elementType: TableSortLabelIcon,
        externalForwardedProps,
        ownerState,
        className: classes.icon
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        disableRipple: true,
        component: "span",
        ...rootProps,
        ...other,
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconSlot, {
                as: IconComponent,
                ...iconProps
            })
        ]
    });
});
var _default = exports.default = TableSortLabel;

},{"a699612ba5e6d1e1":"fiRIh","504b026b3a9fa0d2":"kZ6eK","79668dc32cc9cb65":"59Equ","9dd28fff663f0284":"d2NWs","158268993fe64529":"bnNSm","3c3b60d9c2b2f68":"9njXz","e29770fd2ad5de73":"7X8rf","f75509950dfa24f9":"cR1or","6d6f5038cb1a65f7":"hZXDo","551e52468b427f45":"cJNjb","ca5077eeba699d09":"9bD8g","288985c302a3f21a":"eOYSA","205edd6c0debdd1e":"ezGpE","e21853da7642914f":"h76AU","498fd51ffaa24819":"1dlk8"}],"cR1or":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("8ad34d75199e881b").default;
var _interopRequireWildcard = require("bfdb200a3b5e9185").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e4d6767319670c0c"));
var _createSvgIcon = _interopRequireDefault(require("18e9313ec23a00ee"));
var _jsxRuntime = require("bbc607d2b470e1fd");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

},{"8ad34d75199e881b":"kZ6eK","bfdb200a3b5e9185":"fiRIh","e4d6767319670c0c":"9njXz","18e9313ec23a00ee":"5sni0","bbc607d2b470e1fd":"1dlk8"}],"ezGpE":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ccce1fc1352fa50a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTableSortLabelUtilityClass = getTableSortLabelUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("c6f8922eab9637bc"));
var _generateUtilityClass = _interopRequireDefault(require("cc65af211f6f4b85"));
function getTableSortLabelUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTableSortLabel', slot);
}
const tableSortLabelClasses = (0, _generateUtilityClasses.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc',
    'directionDesc',
    'directionAsc'
]);
var _default = exports.default = tableSortLabelClasses;

},{"ccce1fc1352fa50a":"kZ6eK","c6f8922eab9637bc":"7pSUk","cc65af211f6f4b85":"jBs9M"}],"loen3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MoveToEntity", ()=>MoveToEntity);
var _jsxRuntime = require("react/jsx-runtime");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _tooltip = require("../Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _link = require("../Link");
const MoveToEntity = ({ disabled, url, entityName, dataTestId })=>disabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
        edge: "end",
        "aria-label": "Edit",
        disabled: true,
        "data-test-id": dataTestId,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {})
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: `Edit ${entityName}`,
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                to: url,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                    edge: "end",
                    "aria-label": "Edit",
                    "data-test-id": dataTestId,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {})
                })
            })
        })
    });

},{"react/jsx-runtime":"1dlk8","@mui/material/IconButton":"488As","../Tooltip":"crjvg","@mui/icons-material/Settings":"jkTfg","../Link":"l3o6V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jkTfg":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("83add5e7a9a15fcc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6a10f8af21bc9756"));
var _jsxRuntime = require("2eb7196f2f0dc3f3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), 'Settings');

},{"83add5e7a9a15fcc":"kZ6eK","6a10f8af21bc9756":"2vOnF","2eb7196f2f0dc3f3":"1dlk8"}],"1LBl6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MissingContent", ()=>MissingContent);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _link = require("./Link");
var _utils = require("../../utils");
var _helpers = require("common/api/v1/helpers");
const styles = {
    centered: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    message: {
        textTransform: 'uppercase'
    },
    buttonWrapper: {
        margin: (theme)=>theme.spacing(2)
    },
    button: {
        margin: (theme)=>theme.spacing(2)
    }
};
const MissingContent = (props)=>{
    const { message, buttonText } = props;
    const [pageParams, setPageParams] = (0, _utils.usePageParams)();
    const nonFilteringUrlParams = [
        'rowsPerPage',
        'asc',
        'desc',
        'deriveFrom'
    ];
    const numAppliedFilters = Object.keys((0, _helpers.omit)(pageParams, ...nonFilteringUrlParams)).length;
    const noAppliedFilters = numAppliedFilters === 0 || numAppliedFilters === 1 && pageParams['pageNumber'] === '0' // pageNumber > 0 counts as a filter since it is possible to manually set page number in URL
    ;
    if (!noAppliedFilters) {
        const { filter: genericFilterString } = pageParams;
        const msg = genericFilterString ? `Could not find "${genericFilterString}"` : 'No matching items found';
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            sx: styles.centered,
            style: {
                overflowX: 'auto'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    sx: styles.message,
                    variant: "h2",
                    children: msg
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    sx: styles.button,
                    variant: "outlined",
                    "data-test-id": "clear-search-button",
                    onClick: ()=>{
                        const newPageParams = Object.keys(pageParams).reduce((acc, k)=>{
                            const key = k;
                            if (!nonFilteringUrlParams.includes(key)) acc[key] = '' // key performs filtering - remove it
                            ;
                            return acc;
                        }, {});
                        setPageParams(newPageParams);
                    },
                    children: "Clear search"
                })
            ]
        });
    }
    const renderLink = ({ url })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.buttonWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                type: "button",
                to: url,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "outlined",
                    children: buttonText
                })
            })
        });
    const renderButton = ({ onClick })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.buttonWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "outlined",
                onClick: onClick,
                children: buttonText
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.centered,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: styles.message,
                variant: "h2",
                children: message
            }),
            'url' in props && buttonText && renderLink(props),
            'onClick' in props && buttonText && renderButton(props)
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Typography":"6NtGx","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","./Link":"l3o6V","../../utils":"342UB","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lLIw3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inputColumns", ()=>inputColumns);
var _jsxRuntime = require("react/jsx-runtime");
var _dateFns = require("date-fns");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _removeRedEye = require("@mui/icons-material/RemoveRedEye");
var _removeRedEyeDefault = parcelHelpers.interopDefault(_removeRedEye);
var _types = require("common/api/v1/types");
var _helpers = require("common/api/v1/helpers");
var _indicator = require("../../common/Indicator");
var _thumbnail = require("../../common/Thumbnail");
var _link = require("../../common/Link");
var _utils = require("../../../utils");
var _actionMenu = require("./ActionMenu");
var _cable = require("@mui/icons-material/Cable");
var _cableDefault = parcelHelpers.interopDefault(_cable);
var _autoAwesome = require("@mui/icons-material/AutoAwesome");
var _autoAwesomeDefault = parcelHelpers.interopDefault(_autoAwesome);
var _questionMark = require("@mui/icons-material/QuestionMark");
var _questionMarkDefault = parcelHelpers.interopDefault(_questionMark);
var _index = require("./index");
const canUseNM = (role)=>role !== (0, _types.Role).basic;
const status = ({ autoUpdate, user, routes, experimentalFeatures })=>({
        title: 'status',
        getValue: (input)=>{
            const indicator = autoUpdate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.NonSubscribingAutoUpdatingInputHealthIndicator), {
                initialInput: input
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.InputHealthIndicator), {
                status: input.health,
                disabled: input.adminStatus === (0, _types.InputAdminStatus).off
            });
            // Note that this column actually conveys both the status and the access level of the input
            // When you have pull access for the input, you can see the status, otherwise you see the access level
            return input.canSubscribe || user.role === (0, _types.Role).super ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center'
                },
                children: [
                    input.alarms && input.alarms.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                        available: canUseNM(user.role),
                        type: "button",
                        to: routes.alarms(),
                        children: indicator
                    }) : indicator,
                    input.unhealthyAlarm ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: 'Status alarms are enabled for this input',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeRedEyeDefault.default), {
                            style: {
                                marginLeft: '5px'
                            }
                        })
                    }) : null
                ]
            }) : 'preview';
        },
        sorting: experimentalFeatures?.ExtHealthAlarms ? {
            byParameter: (0, _types.ListInputSortableField).healthStatus
        } : undefined,
        props: {
            noTypography: true
        }
    });
const preview = ()=>({
        title: 'preview',
        getValue: (input)=>input.thumbnailMode === (0, _types.ThumbnailMode).edge ? input.channelIds.map((channelId, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnail.NonSubscribingThumbnail), {
                    input: input,
                    channelId: channelId,
                    shouldHaveTopMargin: index > 0
                }, channelId)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnail.NonSubscribingThumbnail), {
                input: input
            }),
        props: {
            sx: {
                padding: 1,
                width: '100px'
            },
            noTypography: true
        },
        headerProps: {}
    });
const name = ({ availableFn, toFn }, override)=>({
        title: 'name',
        getValue: (input)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                available: availableFn(input),
                to: toFn(input),
                underline: "hover",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    ...(0, _utils.inputOutputColor)({
                        adminStatus: input.adminStatus
                    }),
                    "data-test-id": "input-name",
                    children: input.name
                })
            }),
        sorting: {
            byParameter: (0, _types.ListInputSortableField).inputName
        },
        props: {
            ...override?.props
        }
    });
const inputColumns = {
    status,
    preview,
    name
};
const getConfig = ({ selected, inputs, experimentalFeatures, handleSelect, handleSelectAll, user, dispatch, routes })=>[
        {
            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                indeterminate: selected.length > 0 && selected.length < inputs.length,
                checked: selected.length === inputs.length,
                onChange: handleSelectAll,
                inputProps: {
                    'aria-label': 'select all inputs'
                },
                "data-test-id": 'select-all'
            }),
            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: selected.includes(id),
                    onChange: ()=>{
                        handleSelect(id);
                    },
                    onDoubleClick: (e)=>e.stopPropagation()
                }),
            props: {
                padding: 'checkbox',
                noTypography: true
            }
        },
        status({
            autoUpdate: true,
            user,
            routes,
            experimentalFeatures
        }),
        preview(),
        name({
            availableFn: ({ owner })=>(0, _index.canEditInput)(user, owner),
            toFn: ({ id })=>routes.inputsUpdate({
                    id
                })
        }),
        {
            title: 'appliance',
            getValue: ({ appliances, adminStatus })=>appliances?.length ? appliances?.map((a)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                        to: routes.appliancesUpdate({
                            id: a.id
                        }),
                        available: (0, _utils.hasAccessToAppliance)(a, user),
                        underline: "hover",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            ...(0, _utils.inputOutputColor)({
                                adminStatus
                            }),
                            variant: "body2",
                            children: a.name
                        })
                    }, a.id)) : '',
            sorting: {
                byParameter: (0, _types.ListInputSortableField).applianceName
            }
        },
        {
            title: 'type',
            getValue: (input)=>{
                const inputTypes = (0, _utils.inputType)(input);
                const chips = inputTypes.map((label)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                        style: input.ports && input.ports.length > 0 ? {
                            margin: '1pt'
                        } : {},
                        size: "small",
                        label: label,
                        icon: input.deriveFrom ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoAwesomeDefault.default), {}) : !input.ports || !input.ports.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionMarkDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cableDefault.default), {})
                    }, label));
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        " ",
                        chips,
                        " "
                    ]
                });
            },
            sorting: {
                byParameter: (0, _types.ListInputSortableField).protocol
            }
        },
        {
            title: 'format',
            getValue: (input)=>{
                const tsInfos = (input.appliances ?? []).map((a)=>input.tsInfo?.find((info)=>info.applianceId === a.id));
                const formattedContent = tsInfos.map((info)=>(0, _helpers.getFormattedTransportStreamContent)(info)).join('\n');
                const toolTip = formattedContent === 'MPTS' ? 'Input contains multiple video streams' : tsInfos.map((0, _helpers.tsInfoServiceName)).join(', ');
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: toolTip,
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        ...(0, _utils.inputOutputColor)({
                            adminStatus: input.adminStatus
                        }),
                        variant: "body2",
                        style: {
                            whiteSpace: 'pre-line'
                        },
                        children: formattedContent
                    })
                });
            }
        },
        {
            title: 'owner',
            getValue: ({ _owner })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.groupsUpdate({
                        id: _owner?.id
                    }),
                    available: !!_owner?.id && (0, _utils.isEditableGroup)(_owner?.id, user),
                    underline: "hover",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body2",
                        color: "textSecondary",
                        children: !!_owner && _owner.name
                    })
                }),
            sorting: {
                byParameter: (0, _types.ListInputSortableField).ownerGroupName
            }
        },
        {
            title: 'created',
            getValue: ({ createdAt, adminStatus })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_LONG)),
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        ...(0, _utils.inputOutputColor)({
                            adminStatus
                        }),
                        variant: "body2",
                        children: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_SHORT))
                    })
                }),
            sorting: {
                byParameter: (0, _types.ListInputSortableField).creationDate
            }
        },
        {
            title: '',
            getValue: (row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    input: row,
                    user: user,
                    dispatch: dispatch,
                    experimentalFeatures: experimentalFeatures
                }),
            props: {
                noTypography: true
            }
        }
    ];
exports.default = getConfig;

},{"react/jsx-runtime":"1dlk8","date-fns":"gelMX","@mui/material/Checkbox":"ag1Z5","@mui/material/Chip":"5cK8z","../../common/Tooltip":"crjvg","@mui/material/Typography":"6NtGx","@mui/icons-material/RemoveRedEye":"bR8zj","common/api/v1/types":"3qemx","common/api/v1/helpers":"6jovr","../../common/Indicator":"hqaQa","../../common/Thumbnail":"5Q8KF","../../common/Link":"l3o6V","../../../utils":"342UB","./ActionMenu":"eN2rR","@mui/icons-material/Cable":"dBrUu","@mui/icons-material/AutoAwesome":"fnSW1","@mui/icons-material/QuestionMark":"b3YyJ","./index":"jmuAJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gelMX":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addMjs = require("./add.mjs");
parcelHelpers.exportAll(_addMjs, exports);
var _addBusinessDaysMjs = require("./addBusinessDays.mjs");
parcelHelpers.exportAll(_addBusinessDaysMjs, exports);
var _addDaysMjs = require("./addDays.mjs");
parcelHelpers.exportAll(_addDaysMjs, exports);
var _addHoursMjs = require("./addHours.mjs");
parcelHelpers.exportAll(_addHoursMjs, exports);
var _addISOWeekYearsMjs = require("./addISOWeekYears.mjs");
parcelHelpers.exportAll(_addISOWeekYearsMjs, exports);
var _addMillisecondsMjs = require("./addMilliseconds.mjs");
parcelHelpers.exportAll(_addMillisecondsMjs, exports);
var _addMinutesMjs = require("./addMinutes.mjs");
parcelHelpers.exportAll(_addMinutesMjs, exports);
var _addMonthsMjs = require("./addMonths.mjs");
parcelHelpers.exportAll(_addMonthsMjs, exports);
var _addQuartersMjs = require("./addQuarters.mjs");
parcelHelpers.exportAll(_addQuartersMjs, exports);
var _addSecondsMjs = require("./addSeconds.mjs");
parcelHelpers.exportAll(_addSecondsMjs, exports);
var _addWeeksMjs = require("./addWeeks.mjs");
parcelHelpers.exportAll(_addWeeksMjs, exports);
var _addYearsMjs = require("./addYears.mjs");
parcelHelpers.exportAll(_addYearsMjs, exports);
var _areIntervalsOverlappingMjs = require("./areIntervalsOverlapping.mjs");
parcelHelpers.exportAll(_areIntervalsOverlappingMjs, exports);
var _clampMjs = require("./clamp.mjs");
parcelHelpers.exportAll(_clampMjs, exports);
var _closestIndexToMjs = require("./closestIndexTo.mjs");
parcelHelpers.exportAll(_closestIndexToMjs, exports);
var _closestToMjs = require("./closestTo.mjs");
parcelHelpers.exportAll(_closestToMjs, exports);
var _compareAscMjs = require("./compareAsc.mjs");
parcelHelpers.exportAll(_compareAscMjs, exports);
var _compareDescMjs = require("./compareDesc.mjs");
parcelHelpers.exportAll(_compareDescMjs, exports);
var _constructFromMjs = require("./constructFrom.mjs");
parcelHelpers.exportAll(_constructFromMjs, exports);
var _daysToWeeksMjs = require("./daysToWeeks.mjs");
parcelHelpers.exportAll(_daysToWeeksMjs, exports);
var _differenceInBusinessDaysMjs = require("./differenceInBusinessDays.mjs");
parcelHelpers.exportAll(_differenceInBusinessDaysMjs, exports);
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
parcelHelpers.exportAll(_differenceInCalendarDaysMjs, exports);
var _differenceInCalendarISOWeekYearsMjs = require("./differenceInCalendarISOWeekYears.mjs");
parcelHelpers.exportAll(_differenceInCalendarISOWeekYearsMjs, exports);
var _differenceInCalendarISOWeeksMjs = require("./differenceInCalendarISOWeeks.mjs");
parcelHelpers.exportAll(_differenceInCalendarISOWeeksMjs, exports);
var _differenceInCalendarMonthsMjs = require("./differenceInCalendarMonths.mjs");
parcelHelpers.exportAll(_differenceInCalendarMonthsMjs, exports);
var _differenceInCalendarQuartersMjs = require("./differenceInCalendarQuarters.mjs");
parcelHelpers.exportAll(_differenceInCalendarQuartersMjs, exports);
var _differenceInCalendarWeeksMjs = require("./differenceInCalendarWeeks.mjs");
parcelHelpers.exportAll(_differenceInCalendarWeeksMjs, exports);
var _differenceInCalendarYearsMjs = require("./differenceInCalendarYears.mjs");
parcelHelpers.exportAll(_differenceInCalendarYearsMjs, exports);
var _differenceInDaysMjs = require("./differenceInDays.mjs");
parcelHelpers.exportAll(_differenceInDaysMjs, exports);
var _differenceInHoursMjs = require("./differenceInHours.mjs");
parcelHelpers.exportAll(_differenceInHoursMjs, exports);
var _differenceInISOWeekYearsMjs = require("./differenceInISOWeekYears.mjs");
parcelHelpers.exportAll(_differenceInISOWeekYearsMjs, exports);
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
parcelHelpers.exportAll(_differenceInMillisecondsMjs, exports);
var _differenceInMinutesMjs = require("./differenceInMinutes.mjs");
parcelHelpers.exportAll(_differenceInMinutesMjs, exports);
var _differenceInMonthsMjs = require("./differenceInMonths.mjs");
parcelHelpers.exportAll(_differenceInMonthsMjs, exports);
var _differenceInQuartersMjs = require("./differenceInQuarters.mjs");
parcelHelpers.exportAll(_differenceInQuartersMjs, exports);
var _differenceInSecondsMjs = require("./differenceInSeconds.mjs");
parcelHelpers.exportAll(_differenceInSecondsMjs, exports);
var _differenceInWeeksMjs = require("./differenceInWeeks.mjs");
parcelHelpers.exportAll(_differenceInWeeksMjs, exports);
var _differenceInYearsMjs = require("./differenceInYears.mjs");
parcelHelpers.exportAll(_differenceInYearsMjs, exports);
var _eachDayOfIntervalMjs = require("./eachDayOfInterval.mjs");
parcelHelpers.exportAll(_eachDayOfIntervalMjs, exports);
var _eachHourOfIntervalMjs = require("./eachHourOfInterval.mjs");
parcelHelpers.exportAll(_eachHourOfIntervalMjs, exports);
var _eachMinuteOfIntervalMjs = require("./eachMinuteOfInterval.mjs");
parcelHelpers.exportAll(_eachMinuteOfIntervalMjs, exports);
var _eachMonthOfIntervalMjs = require("./eachMonthOfInterval.mjs");
parcelHelpers.exportAll(_eachMonthOfIntervalMjs, exports);
var _eachQuarterOfIntervalMjs = require("./eachQuarterOfInterval.mjs");
parcelHelpers.exportAll(_eachQuarterOfIntervalMjs, exports);
var _eachWeekOfIntervalMjs = require("./eachWeekOfInterval.mjs");
parcelHelpers.exportAll(_eachWeekOfIntervalMjs, exports);
var _eachWeekendOfIntervalMjs = require("./eachWeekendOfInterval.mjs");
parcelHelpers.exportAll(_eachWeekendOfIntervalMjs, exports);
var _eachWeekendOfMonthMjs = require("./eachWeekendOfMonth.mjs");
parcelHelpers.exportAll(_eachWeekendOfMonthMjs, exports);
var _eachWeekendOfYearMjs = require("./eachWeekendOfYear.mjs");
parcelHelpers.exportAll(_eachWeekendOfYearMjs, exports);
var _eachYearOfIntervalMjs = require("./eachYearOfInterval.mjs");
parcelHelpers.exportAll(_eachYearOfIntervalMjs, exports);
var _endOfDayMjs = require("./endOfDay.mjs");
parcelHelpers.exportAll(_endOfDayMjs, exports);
var _endOfDecadeMjs = require("./endOfDecade.mjs");
parcelHelpers.exportAll(_endOfDecadeMjs, exports);
var _endOfHourMjs = require("./endOfHour.mjs");
parcelHelpers.exportAll(_endOfHourMjs, exports);
var _endOfISOWeekMjs = require("./endOfISOWeek.mjs");
parcelHelpers.exportAll(_endOfISOWeekMjs, exports);
var _endOfISOWeekYearMjs = require("./endOfISOWeekYear.mjs");
parcelHelpers.exportAll(_endOfISOWeekYearMjs, exports);
var _endOfMinuteMjs = require("./endOfMinute.mjs");
parcelHelpers.exportAll(_endOfMinuteMjs, exports);
var _endOfMonthMjs = require("./endOfMonth.mjs");
parcelHelpers.exportAll(_endOfMonthMjs, exports);
var _endOfQuarterMjs = require("./endOfQuarter.mjs");
parcelHelpers.exportAll(_endOfQuarterMjs, exports);
var _endOfSecondMjs = require("./endOfSecond.mjs");
parcelHelpers.exportAll(_endOfSecondMjs, exports);
var _endOfTodayMjs = require("./endOfToday.mjs");
parcelHelpers.exportAll(_endOfTodayMjs, exports);
var _endOfTomorrowMjs = require("./endOfTomorrow.mjs");
parcelHelpers.exportAll(_endOfTomorrowMjs, exports);
var _endOfWeekMjs = require("./endOfWeek.mjs");
parcelHelpers.exportAll(_endOfWeekMjs, exports);
var _endOfYearMjs = require("./endOfYear.mjs");
parcelHelpers.exportAll(_endOfYearMjs, exports);
var _endOfYesterdayMjs = require("./endOfYesterday.mjs");
parcelHelpers.exportAll(_endOfYesterdayMjs, exports);
var _formatMjs = require("./format.mjs");
parcelHelpers.exportAll(_formatMjs, exports);
var _formatDistanceMjs = require("./formatDistance.mjs");
parcelHelpers.exportAll(_formatDistanceMjs, exports);
var _formatDistanceStrictMjs = require("./formatDistanceStrict.mjs");
parcelHelpers.exportAll(_formatDistanceStrictMjs, exports);
var _formatDistanceToNowMjs = require("./formatDistanceToNow.mjs");
parcelHelpers.exportAll(_formatDistanceToNowMjs, exports);
var _formatDistanceToNowStrictMjs = require("./formatDistanceToNowStrict.mjs");
parcelHelpers.exportAll(_formatDistanceToNowStrictMjs, exports);
var _formatDurationMjs = require("./formatDuration.mjs");
parcelHelpers.exportAll(_formatDurationMjs, exports);
var _formatISOMjs = require("./formatISO.mjs");
parcelHelpers.exportAll(_formatISOMjs, exports);
var _formatISO9075Mjs = require("./formatISO9075.mjs");
parcelHelpers.exportAll(_formatISO9075Mjs, exports);
var _formatISODurationMjs = require("./formatISODuration.mjs");
parcelHelpers.exportAll(_formatISODurationMjs, exports);
var _formatRFC3339Mjs = require("./formatRFC3339.mjs");
parcelHelpers.exportAll(_formatRFC3339Mjs, exports);
var _formatRFC7231Mjs = require("./formatRFC7231.mjs");
parcelHelpers.exportAll(_formatRFC7231Mjs, exports);
var _formatRelativeMjs = require("./formatRelative.mjs");
parcelHelpers.exportAll(_formatRelativeMjs, exports);
var _fromUnixTimeMjs = require("./fromUnixTime.mjs");
parcelHelpers.exportAll(_fromUnixTimeMjs, exports);
var _getDateMjs = require("./getDate.mjs");
parcelHelpers.exportAll(_getDateMjs, exports);
var _getDayMjs = require("./getDay.mjs");
parcelHelpers.exportAll(_getDayMjs, exports);
var _getDayOfYearMjs = require("./getDayOfYear.mjs");
parcelHelpers.exportAll(_getDayOfYearMjs, exports);
var _getDaysInMonthMjs = require("./getDaysInMonth.mjs");
parcelHelpers.exportAll(_getDaysInMonthMjs, exports);
var _getDaysInYearMjs = require("./getDaysInYear.mjs");
parcelHelpers.exportAll(_getDaysInYearMjs, exports);
var _getDecadeMjs = require("./getDecade.mjs");
parcelHelpers.exportAll(_getDecadeMjs, exports);
var _getDefaultOptionsMjs = require("./getDefaultOptions.mjs");
parcelHelpers.exportAll(_getDefaultOptionsMjs, exports);
var _getHoursMjs = require("./getHours.mjs");
parcelHelpers.exportAll(_getHoursMjs, exports);
var _getISODayMjs = require("./getISODay.mjs");
parcelHelpers.exportAll(_getISODayMjs, exports);
var _getISOWeekMjs = require("./getISOWeek.mjs");
parcelHelpers.exportAll(_getISOWeekMjs, exports);
var _getISOWeekYearMjs = require("./getISOWeekYear.mjs");
parcelHelpers.exportAll(_getISOWeekYearMjs, exports);
var _getISOWeeksInYearMjs = require("./getISOWeeksInYear.mjs");
parcelHelpers.exportAll(_getISOWeeksInYearMjs, exports);
var _getMillisecondsMjs = require("./getMilliseconds.mjs");
parcelHelpers.exportAll(_getMillisecondsMjs, exports);
var _getMinutesMjs = require("./getMinutes.mjs");
parcelHelpers.exportAll(_getMinutesMjs, exports);
var _getMonthMjs = require("./getMonth.mjs");
parcelHelpers.exportAll(_getMonthMjs, exports);
var _getOverlappingDaysInIntervalsMjs = require("./getOverlappingDaysInIntervals.mjs");
parcelHelpers.exportAll(_getOverlappingDaysInIntervalsMjs, exports);
var _getQuarterMjs = require("./getQuarter.mjs");
parcelHelpers.exportAll(_getQuarterMjs, exports);
var _getSecondsMjs = require("./getSeconds.mjs");
parcelHelpers.exportAll(_getSecondsMjs, exports);
var _getTimeMjs = require("./getTime.mjs");
parcelHelpers.exportAll(_getTimeMjs, exports);
var _getUnixTimeMjs = require("./getUnixTime.mjs");
parcelHelpers.exportAll(_getUnixTimeMjs, exports);
var _getWeekMjs = require("./getWeek.mjs");
parcelHelpers.exportAll(_getWeekMjs, exports);
var _getWeekOfMonthMjs = require("./getWeekOfMonth.mjs");
parcelHelpers.exportAll(_getWeekOfMonthMjs, exports);
var _getWeekYearMjs = require("./getWeekYear.mjs");
parcelHelpers.exportAll(_getWeekYearMjs, exports);
var _getWeeksInMonthMjs = require("./getWeeksInMonth.mjs");
parcelHelpers.exportAll(_getWeeksInMonthMjs, exports);
var _getYearMjs = require("./getYear.mjs");
parcelHelpers.exportAll(_getYearMjs, exports);
var _hoursToMillisecondsMjs = require("./hoursToMilliseconds.mjs");
parcelHelpers.exportAll(_hoursToMillisecondsMjs, exports);
var _hoursToMinutesMjs = require("./hoursToMinutes.mjs");
parcelHelpers.exportAll(_hoursToMinutesMjs, exports);
var _hoursToSecondsMjs = require("./hoursToSeconds.mjs");
parcelHelpers.exportAll(_hoursToSecondsMjs, exports);
var _intervalMjs = require("./interval.mjs");
parcelHelpers.exportAll(_intervalMjs, exports);
var _intervalToDurationMjs = require("./intervalToDuration.mjs");
parcelHelpers.exportAll(_intervalToDurationMjs, exports);
var _intlFormatMjs = require("./intlFormat.mjs");
parcelHelpers.exportAll(_intlFormatMjs, exports);
var _intlFormatDistanceMjs = require("./intlFormatDistance.mjs");
parcelHelpers.exportAll(_intlFormatDistanceMjs, exports);
var _isAfterMjs = require("./isAfter.mjs");
parcelHelpers.exportAll(_isAfterMjs, exports);
var _isBeforeMjs = require("./isBefore.mjs");
parcelHelpers.exportAll(_isBeforeMjs, exports);
var _isDateMjs = require("./isDate.mjs");
parcelHelpers.exportAll(_isDateMjs, exports);
var _isEqualMjs = require("./isEqual.mjs");
parcelHelpers.exportAll(_isEqualMjs, exports);
var _isExistsMjs = require("./isExists.mjs");
parcelHelpers.exportAll(_isExistsMjs, exports);
var _isFirstDayOfMonthMjs = require("./isFirstDayOfMonth.mjs");
parcelHelpers.exportAll(_isFirstDayOfMonthMjs, exports);
var _isFridayMjs = require("./isFriday.mjs");
parcelHelpers.exportAll(_isFridayMjs, exports);
var _isFutureMjs = require("./isFuture.mjs");
parcelHelpers.exportAll(_isFutureMjs, exports);
var _isLastDayOfMonthMjs = require("./isLastDayOfMonth.mjs");
parcelHelpers.exportAll(_isLastDayOfMonthMjs, exports);
var _isLeapYearMjs = require("./isLeapYear.mjs");
parcelHelpers.exportAll(_isLeapYearMjs, exports);
var _isMatchMjs = require("./isMatch.mjs");
parcelHelpers.exportAll(_isMatchMjs, exports);
var _isMondayMjs = require("./isMonday.mjs");
parcelHelpers.exportAll(_isMondayMjs, exports);
var _isPastMjs = require("./isPast.mjs");
parcelHelpers.exportAll(_isPastMjs, exports);
var _isSameDayMjs = require("./isSameDay.mjs");
parcelHelpers.exportAll(_isSameDayMjs, exports);
var _isSameHourMjs = require("./isSameHour.mjs");
parcelHelpers.exportAll(_isSameHourMjs, exports);
var _isSameISOWeekMjs = require("./isSameISOWeek.mjs");
parcelHelpers.exportAll(_isSameISOWeekMjs, exports);
var _isSameISOWeekYearMjs = require("./isSameISOWeekYear.mjs");
parcelHelpers.exportAll(_isSameISOWeekYearMjs, exports);
var _isSameMinuteMjs = require("./isSameMinute.mjs");
parcelHelpers.exportAll(_isSameMinuteMjs, exports);
var _isSameMonthMjs = require("./isSameMonth.mjs");
parcelHelpers.exportAll(_isSameMonthMjs, exports);
var _isSameQuarterMjs = require("./isSameQuarter.mjs");
parcelHelpers.exportAll(_isSameQuarterMjs, exports);
var _isSameSecondMjs = require("./isSameSecond.mjs");
parcelHelpers.exportAll(_isSameSecondMjs, exports);
var _isSameWeekMjs = require("./isSameWeek.mjs");
parcelHelpers.exportAll(_isSameWeekMjs, exports);
var _isSameYearMjs = require("./isSameYear.mjs");
parcelHelpers.exportAll(_isSameYearMjs, exports);
var _isSaturdayMjs = require("./isSaturday.mjs");
parcelHelpers.exportAll(_isSaturdayMjs, exports);
var _isSundayMjs = require("./isSunday.mjs");
parcelHelpers.exportAll(_isSundayMjs, exports);
var _isThisHourMjs = require("./isThisHour.mjs");
parcelHelpers.exportAll(_isThisHourMjs, exports);
var _isThisISOWeekMjs = require("./isThisISOWeek.mjs");
parcelHelpers.exportAll(_isThisISOWeekMjs, exports);
var _isThisMinuteMjs = require("./isThisMinute.mjs");
parcelHelpers.exportAll(_isThisMinuteMjs, exports);
var _isThisMonthMjs = require("./isThisMonth.mjs");
parcelHelpers.exportAll(_isThisMonthMjs, exports);
var _isThisQuarterMjs = require("./isThisQuarter.mjs");
parcelHelpers.exportAll(_isThisQuarterMjs, exports);
var _isThisSecondMjs = require("./isThisSecond.mjs");
parcelHelpers.exportAll(_isThisSecondMjs, exports);
var _isThisWeekMjs = require("./isThisWeek.mjs");
parcelHelpers.exportAll(_isThisWeekMjs, exports);
var _isThisYearMjs = require("./isThisYear.mjs");
parcelHelpers.exportAll(_isThisYearMjs, exports);
var _isThursdayMjs = require("./isThursday.mjs");
parcelHelpers.exportAll(_isThursdayMjs, exports);
var _isTodayMjs = require("./isToday.mjs");
parcelHelpers.exportAll(_isTodayMjs, exports);
var _isTomorrowMjs = require("./isTomorrow.mjs");
parcelHelpers.exportAll(_isTomorrowMjs, exports);
var _isTuesdayMjs = require("./isTuesday.mjs");
parcelHelpers.exportAll(_isTuesdayMjs, exports);
var _isValidMjs = require("./isValid.mjs");
parcelHelpers.exportAll(_isValidMjs, exports);
var _isWednesdayMjs = require("./isWednesday.mjs");
parcelHelpers.exportAll(_isWednesdayMjs, exports);
var _isWeekendMjs = require("./isWeekend.mjs");
parcelHelpers.exportAll(_isWeekendMjs, exports);
var _isWithinIntervalMjs = require("./isWithinInterval.mjs");
parcelHelpers.exportAll(_isWithinIntervalMjs, exports);
var _isYesterdayMjs = require("./isYesterday.mjs");
parcelHelpers.exportAll(_isYesterdayMjs, exports);
var _lastDayOfDecadeMjs = require("./lastDayOfDecade.mjs");
parcelHelpers.exportAll(_lastDayOfDecadeMjs, exports);
var _lastDayOfISOWeekMjs = require("./lastDayOfISOWeek.mjs");
parcelHelpers.exportAll(_lastDayOfISOWeekMjs, exports);
var _lastDayOfISOWeekYearMjs = require("./lastDayOfISOWeekYear.mjs");
parcelHelpers.exportAll(_lastDayOfISOWeekYearMjs, exports);
var _lastDayOfMonthMjs = require("./lastDayOfMonth.mjs");
parcelHelpers.exportAll(_lastDayOfMonthMjs, exports);
var _lastDayOfQuarterMjs = require("./lastDayOfQuarter.mjs");
parcelHelpers.exportAll(_lastDayOfQuarterMjs, exports);
var _lastDayOfWeekMjs = require("./lastDayOfWeek.mjs");
parcelHelpers.exportAll(_lastDayOfWeekMjs, exports);
var _lastDayOfYearMjs = require("./lastDayOfYear.mjs");
parcelHelpers.exportAll(_lastDayOfYearMjs, exports);
var _lightFormatMjs = require("./lightFormat.mjs");
parcelHelpers.exportAll(_lightFormatMjs, exports);
var _maxMjs = require("./max.mjs");
parcelHelpers.exportAll(_maxMjs, exports);
var _millisecondsMjs = require("./milliseconds.mjs");
parcelHelpers.exportAll(_millisecondsMjs, exports);
var _millisecondsToHoursMjs = require("./millisecondsToHours.mjs");
parcelHelpers.exportAll(_millisecondsToHoursMjs, exports);
var _millisecondsToMinutesMjs = require("./millisecondsToMinutes.mjs");
parcelHelpers.exportAll(_millisecondsToMinutesMjs, exports);
var _millisecondsToSecondsMjs = require("./millisecondsToSeconds.mjs");
parcelHelpers.exportAll(_millisecondsToSecondsMjs, exports);
var _minMjs = require("./min.mjs");
parcelHelpers.exportAll(_minMjs, exports);
var _minutesToHoursMjs = require("./minutesToHours.mjs");
parcelHelpers.exportAll(_minutesToHoursMjs, exports);
var _minutesToMillisecondsMjs = require("./minutesToMilliseconds.mjs");
parcelHelpers.exportAll(_minutesToMillisecondsMjs, exports);
var _minutesToSecondsMjs = require("./minutesToSeconds.mjs");
parcelHelpers.exportAll(_minutesToSecondsMjs, exports);
var _monthsToQuartersMjs = require("./monthsToQuarters.mjs");
parcelHelpers.exportAll(_monthsToQuartersMjs, exports);
var _monthsToYearsMjs = require("./monthsToYears.mjs");
parcelHelpers.exportAll(_monthsToYearsMjs, exports);
var _nextDayMjs = require("./nextDay.mjs");
parcelHelpers.exportAll(_nextDayMjs, exports);
var _nextFridayMjs = require("./nextFriday.mjs");
parcelHelpers.exportAll(_nextFridayMjs, exports);
var _nextMondayMjs = require("./nextMonday.mjs");
parcelHelpers.exportAll(_nextMondayMjs, exports);
var _nextSaturdayMjs = require("./nextSaturday.mjs");
parcelHelpers.exportAll(_nextSaturdayMjs, exports);
var _nextSundayMjs = require("./nextSunday.mjs");
parcelHelpers.exportAll(_nextSundayMjs, exports);
var _nextThursdayMjs = require("./nextThursday.mjs");
parcelHelpers.exportAll(_nextThursdayMjs, exports);
var _nextTuesdayMjs = require("./nextTuesday.mjs");
parcelHelpers.exportAll(_nextTuesdayMjs, exports);
var _nextWednesdayMjs = require("./nextWednesday.mjs");
parcelHelpers.exportAll(_nextWednesdayMjs, exports);
var _parseMjs = require("./parse.mjs");
parcelHelpers.exportAll(_parseMjs, exports);
var _parseISOMjs = require("./parseISO.mjs");
parcelHelpers.exportAll(_parseISOMjs, exports);
var _parseJSONMjs = require("./parseJSON.mjs");
parcelHelpers.exportAll(_parseJSONMjs, exports);
var _previousDayMjs = require("./previousDay.mjs");
parcelHelpers.exportAll(_previousDayMjs, exports);
var _previousFridayMjs = require("./previousFriday.mjs");
parcelHelpers.exportAll(_previousFridayMjs, exports);
var _previousMondayMjs = require("./previousMonday.mjs");
parcelHelpers.exportAll(_previousMondayMjs, exports);
var _previousSaturdayMjs = require("./previousSaturday.mjs");
parcelHelpers.exportAll(_previousSaturdayMjs, exports);
var _previousSundayMjs = require("./previousSunday.mjs");
parcelHelpers.exportAll(_previousSundayMjs, exports);
var _previousThursdayMjs = require("./previousThursday.mjs");
parcelHelpers.exportAll(_previousThursdayMjs, exports);
var _previousTuesdayMjs = require("./previousTuesday.mjs");
parcelHelpers.exportAll(_previousTuesdayMjs, exports);
var _previousWednesdayMjs = require("./previousWednesday.mjs");
parcelHelpers.exportAll(_previousWednesdayMjs, exports);
var _quartersToMonthsMjs = require("./quartersToMonths.mjs");
parcelHelpers.exportAll(_quartersToMonthsMjs, exports);
var _quartersToYearsMjs = require("./quartersToYears.mjs");
parcelHelpers.exportAll(_quartersToYearsMjs, exports);
var _roundToNearestMinutesMjs = require("./roundToNearestMinutes.mjs");
parcelHelpers.exportAll(_roundToNearestMinutesMjs, exports);
var _secondsToHoursMjs = require("./secondsToHours.mjs");
parcelHelpers.exportAll(_secondsToHoursMjs, exports);
var _secondsToMillisecondsMjs = require("./secondsToMilliseconds.mjs");
parcelHelpers.exportAll(_secondsToMillisecondsMjs, exports);
var _secondsToMinutesMjs = require("./secondsToMinutes.mjs");
parcelHelpers.exportAll(_secondsToMinutesMjs, exports);
var _setMjs = require("./set.mjs");
parcelHelpers.exportAll(_setMjs, exports);
var _setDateMjs = require("./setDate.mjs");
parcelHelpers.exportAll(_setDateMjs, exports);
var _setDayMjs = require("./setDay.mjs");
parcelHelpers.exportAll(_setDayMjs, exports);
var _setDayOfYearMjs = require("./setDayOfYear.mjs");
parcelHelpers.exportAll(_setDayOfYearMjs, exports);
var _setDefaultOptionsMjs = require("./setDefaultOptions.mjs");
parcelHelpers.exportAll(_setDefaultOptionsMjs, exports);
var _setHoursMjs = require("./setHours.mjs");
parcelHelpers.exportAll(_setHoursMjs, exports);
var _setISODayMjs = require("./setISODay.mjs");
parcelHelpers.exportAll(_setISODayMjs, exports);
var _setISOWeekMjs = require("./setISOWeek.mjs");
parcelHelpers.exportAll(_setISOWeekMjs, exports);
var _setISOWeekYearMjs = require("./setISOWeekYear.mjs");
parcelHelpers.exportAll(_setISOWeekYearMjs, exports);
var _setMillisecondsMjs = require("./setMilliseconds.mjs");
parcelHelpers.exportAll(_setMillisecondsMjs, exports);
var _setMinutesMjs = require("./setMinutes.mjs");
parcelHelpers.exportAll(_setMinutesMjs, exports);
var _setMonthMjs = require("./setMonth.mjs");
parcelHelpers.exportAll(_setMonthMjs, exports);
var _setQuarterMjs = require("./setQuarter.mjs");
parcelHelpers.exportAll(_setQuarterMjs, exports);
var _setSecondsMjs = require("./setSeconds.mjs");
parcelHelpers.exportAll(_setSecondsMjs, exports);
var _setWeekMjs = require("./setWeek.mjs");
parcelHelpers.exportAll(_setWeekMjs, exports);
var _setWeekYearMjs = require("./setWeekYear.mjs");
parcelHelpers.exportAll(_setWeekYearMjs, exports);
var _setYearMjs = require("./setYear.mjs");
parcelHelpers.exportAll(_setYearMjs, exports);
var _startOfDayMjs = require("./startOfDay.mjs");
parcelHelpers.exportAll(_startOfDayMjs, exports);
var _startOfDecadeMjs = require("./startOfDecade.mjs");
parcelHelpers.exportAll(_startOfDecadeMjs, exports);
var _startOfHourMjs = require("./startOfHour.mjs");
parcelHelpers.exportAll(_startOfHourMjs, exports);
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
parcelHelpers.exportAll(_startOfISOWeekMjs, exports);
var _startOfISOWeekYearMjs = require("./startOfISOWeekYear.mjs");
parcelHelpers.exportAll(_startOfISOWeekYearMjs, exports);
var _startOfMinuteMjs = require("./startOfMinute.mjs");
parcelHelpers.exportAll(_startOfMinuteMjs, exports);
var _startOfMonthMjs = require("./startOfMonth.mjs");
parcelHelpers.exportAll(_startOfMonthMjs, exports);
var _startOfQuarterMjs = require("./startOfQuarter.mjs");
parcelHelpers.exportAll(_startOfQuarterMjs, exports);
var _startOfSecondMjs = require("./startOfSecond.mjs");
parcelHelpers.exportAll(_startOfSecondMjs, exports);
var _startOfTodayMjs = require("./startOfToday.mjs");
parcelHelpers.exportAll(_startOfTodayMjs, exports);
var _startOfTomorrowMjs = require("./startOfTomorrow.mjs");
parcelHelpers.exportAll(_startOfTomorrowMjs, exports);
var _startOfWeekMjs = require("./startOfWeek.mjs");
parcelHelpers.exportAll(_startOfWeekMjs, exports);
var _startOfWeekYearMjs = require("./startOfWeekYear.mjs");
parcelHelpers.exportAll(_startOfWeekYearMjs, exports);
var _startOfYearMjs = require("./startOfYear.mjs");
parcelHelpers.exportAll(_startOfYearMjs, exports);
var _startOfYesterdayMjs = require("./startOfYesterday.mjs");
parcelHelpers.exportAll(_startOfYesterdayMjs, exports);
var _subMjs = require("./sub.mjs");
parcelHelpers.exportAll(_subMjs, exports);
var _subBusinessDaysMjs = require("./subBusinessDays.mjs");
parcelHelpers.exportAll(_subBusinessDaysMjs, exports);
var _subDaysMjs = require("./subDays.mjs");
parcelHelpers.exportAll(_subDaysMjs, exports);
var _subHoursMjs = require("./subHours.mjs");
parcelHelpers.exportAll(_subHoursMjs, exports);
var _subISOWeekYearsMjs = require("./subISOWeekYears.mjs");
parcelHelpers.exportAll(_subISOWeekYearsMjs, exports);
var _subMillisecondsMjs = require("./subMilliseconds.mjs");
parcelHelpers.exportAll(_subMillisecondsMjs, exports);
var _subMinutesMjs = require("./subMinutes.mjs");
parcelHelpers.exportAll(_subMinutesMjs, exports);
var _subMonthsMjs = require("./subMonths.mjs");
parcelHelpers.exportAll(_subMonthsMjs, exports);
var _subQuartersMjs = require("./subQuarters.mjs");
parcelHelpers.exportAll(_subQuartersMjs, exports);
var _subSecondsMjs = require("./subSeconds.mjs");
parcelHelpers.exportAll(_subSecondsMjs, exports);
var _subWeeksMjs = require("./subWeeks.mjs");
parcelHelpers.exportAll(_subWeeksMjs, exports);
var _subYearsMjs = require("./subYears.mjs");
parcelHelpers.exportAll(_subYearsMjs, exports);
var _toDateMjs = require("./toDate.mjs");
parcelHelpers.exportAll(_toDateMjs, exports);
var _transposeMjs = require("./transpose.mjs");
parcelHelpers.exportAll(_transposeMjs, exports);
var _weeksToDaysMjs = require("./weeksToDays.mjs");
parcelHelpers.exportAll(_weeksToDaysMjs, exports);
var _yearsToDaysMjs = require("./yearsToDays.mjs");
parcelHelpers.exportAll(_yearsToDaysMjs, exports);
var _yearsToMonthsMjs = require("./yearsToMonths.mjs");
parcelHelpers.exportAll(_yearsToMonthsMjs, exports);
var _yearsToQuartersMjs = require("./yearsToQuarters.mjs");
parcelHelpers.exportAll(_yearsToQuartersMjs, exports);

},{"./add.mjs":false,"./addBusinessDays.mjs":false,"./addDays.mjs":"f68cL","./addHours.mjs":"9ZJws","./addISOWeekYears.mjs":false,"./addMilliseconds.mjs":"7GeuR","./addMinutes.mjs":"1YRq0","./addMonths.mjs":"giobK","./addQuarters.mjs":false,"./addSeconds.mjs":"jJahE","./addWeeks.mjs":false,"./addYears.mjs":false,"./areIntervalsOverlapping.mjs":false,"./clamp.mjs":false,"./closestIndexTo.mjs":false,"./closestTo.mjs":false,"./compareAsc.mjs":"035Nt","./compareDesc.mjs":false,"./constructFrom.mjs":false,"./daysToWeeks.mjs":false,"./differenceInBusinessDays.mjs":false,"./differenceInCalendarDays.mjs":false,"./differenceInCalendarISOWeekYears.mjs":false,"./differenceInCalendarISOWeeks.mjs":false,"./differenceInCalendarMonths.mjs":false,"./differenceInCalendarQuarters.mjs":false,"./differenceInCalendarWeeks.mjs":false,"./differenceInCalendarYears.mjs":false,"./differenceInDays.mjs":false,"./differenceInHours.mjs":false,"./differenceInISOWeekYears.mjs":false,"./differenceInMilliseconds.mjs":false,"./differenceInMinutes.mjs":false,"./differenceInMonths.mjs":false,"./differenceInQuarters.mjs":false,"./differenceInSeconds.mjs":false,"./differenceInWeeks.mjs":false,"./differenceInYears.mjs":false,"./eachDayOfInterval.mjs":false,"./eachHourOfInterval.mjs":false,"./eachMinuteOfInterval.mjs":false,"./eachMonthOfInterval.mjs":false,"./eachQuarterOfInterval.mjs":false,"./eachWeekOfInterval.mjs":false,"./eachWeekendOfInterval.mjs":false,"./eachWeekendOfMonth.mjs":false,"./eachWeekendOfYear.mjs":false,"./eachYearOfInterval.mjs":false,"./endOfDay.mjs":false,"./endOfDecade.mjs":false,"./endOfHour.mjs":false,"./endOfISOWeek.mjs":false,"./endOfISOWeekYear.mjs":false,"./endOfMinute.mjs":false,"./endOfMonth.mjs":"eydb8","./endOfQuarter.mjs":false,"./endOfSecond.mjs":false,"./endOfToday.mjs":false,"./endOfTomorrow.mjs":false,"./endOfWeek.mjs":false,"./endOfYear.mjs":false,"./endOfYesterday.mjs":false,"./format.mjs":"99LTY","./formatDistance.mjs":false,"./formatDistanceStrict.mjs":false,"./formatDistanceToNow.mjs":"kapFf","./formatDistanceToNowStrict.mjs":false,"./formatDuration.mjs":"78IyP","./formatISO.mjs":false,"./formatISO9075.mjs":false,"./formatISODuration.mjs":false,"./formatRFC3339.mjs":false,"./formatRFC7231.mjs":false,"./formatRelative.mjs":false,"./fromUnixTime.mjs":false,"./getDate.mjs":false,"./getDay.mjs":false,"./getDayOfYear.mjs":false,"./getDaysInMonth.mjs":false,"./getDaysInYear.mjs":false,"./getDecade.mjs":false,"./getDefaultOptions.mjs":false,"./getHours.mjs":false,"./getISODay.mjs":false,"./getISOWeek.mjs":false,"./getISOWeekYear.mjs":false,"./getISOWeeksInYear.mjs":false,"./getMilliseconds.mjs":false,"./getMinutes.mjs":false,"./getMonth.mjs":false,"./getOverlappingDaysInIntervals.mjs":false,"./getQuarter.mjs":false,"./getSeconds.mjs":false,"./getTime.mjs":false,"./getUnixTime.mjs":false,"./getWeek.mjs":false,"./getWeekOfMonth.mjs":false,"./getWeekYear.mjs":false,"./getWeeksInMonth.mjs":false,"./getYear.mjs":false,"./hoursToMilliseconds.mjs":false,"./hoursToMinutes.mjs":false,"./hoursToSeconds.mjs":false,"./interval.mjs":false,"./intervalToDuration.mjs":"bFeNW","./intlFormat.mjs":false,"./intlFormatDistance.mjs":false,"./isAfter.mjs":false,"./isBefore.mjs":false,"./isDate.mjs":false,"./isEqual.mjs":false,"./isExists.mjs":false,"./isFirstDayOfMonth.mjs":false,"./isFriday.mjs":false,"./isFuture.mjs":false,"./isLastDayOfMonth.mjs":false,"./isLeapYear.mjs":false,"./isMatch.mjs":false,"./isMonday.mjs":false,"./isPast.mjs":false,"./isSameDay.mjs":false,"./isSameHour.mjs":false,"./isSameISOWeek.mjs":false,"./isSameISOWeekYear.mjs":false,"./isSameMinute.mjs":false,"./isSameMonth.mjs":false,"./isSameQuarter.mjs":false,"./isSameSecond.mjs":false,"./isSameWeek.mjs":false,"./isSameYear.mjs":false,"./isSaturday.mjs":false,"./isSunday.mjs":false,"./isThisHour.mjs":false,"./isThisISOWeek.mjs":false,"./isThisMinute.mjs":false,"./isThisMonth.mjs":false,"./isThisQuarter.mjs":false,"./isThisSecond.mjs":false,"./isThisWeek.mjs":false,"./isThisYear.mjs":false,"./isThursday.mjs":false,"./isToday.mjs":false,"./isTomorrow.mjs":false,"./isTuesday.mjs":false,"./isValid.mjs":false,"./isWednesday.mjs":false,"./isWeekend.mjs":false,"./isWithinInterval.mjs":false,"./isYesterday.mjs":false,"./lastDayOfDecade.mjs":false,"./lastDayOfISOWeek.mjs":false,"./lastDayOfISOWeekYear.mjs":false,"./lastDayOfMonth.mjs":false,"./lastDayOfQuarter.mjs":false,"./lastDayOfWeek.mjs":false,"./lastDayOfYear.mjs":false,"./lightFormat.mjs":false,"./max.mjs":false,"./milliseconds.mjs":false,"./millisecondsToHours.mjs":false,"./millisecondsToMinutes.mjs":false,"./millisecondsToSeconds.mjs":false,"./min.mjs":false,"./minutesToHours.mjs":false,"./minutesToMilliseconds.mjs":false,"./minutesToSeconds.mjs":false,"./monthsToQuarters.mjs":false,"./monthsToYears.mjs":false,"./nextDay.mjs":false,"./nextFriday.mjs":false,"./nextMonday.mjs":false,"./nextSaturday.mjs":false,"./nextSunday.mjs":false,"./nextThursday.mjs":false,"./nextTuesday.mjs":false,"./nextWednesday.mjs":false,"./parse.mjs":false,"./parseISO.mjs":"6A2u9","./parseJSON.mjs":false,"./previousDay.mjs":false,"./previousFriday.mjs":false,"./previousMonday.mjs":false,"./previousSaturday.mjs":false,"./previousSunday.mjs":false,"./previousThursday.mjs":false,"./previousTuesday.mjs":false,"./previousWednesday.mjs":false,"./quartersToMonths.mjs":false,"./quartersToYears.mjs":false,"./roundToNearestMinutes.mjs":false,"./secondsToHours.mjs":false,"./secondsToMilliseconds.mjs":false,"./secondsToMinutes.mjs":false,"./set.mjs":false,"./setDate.mjs":false,"./setDay.mjs":false,"./setDayOfYear.mjs":false,"./setDefaultOptions.mjs":false,"./setHours.mjs":false,"./setISODay.mjs":false,"./setISOWeek.mjs":false,"./setISOWeekYear.mjs":false,"./setMilliseconds.mjs":false,"./setMinutes.mjs":false,"./setMonth.mjs":false,"./setQuarter.mjs":false,"./setSeconds.mjs":false,"./setWeek.mjs":false,"./setWeekYear.mjs":false,"./setYear.mjs":false,"./startOfDay.mjs":false,"./startOfDecade.mjs":false,"./startOfHour.mjs":false,"./startOfISOWeek.mjs":false,"./startOfISOWeekYear.mjs":false,"./startOfMinute.mjs":false,"./startOfMonth.mjs":false,"./startOfQuarter.mjs":false,"./startOfSecond.mjs":false,"./startOfToday.mjs":false,"./startOfTomorrow.mjs":false,"./startOfWeek.mjs":false,"./startOfWeekYear.mjs":false,"./startOfYear.mjs":false,"./startOfYesterday.mjs":false,"./sub.mjs":false,"./subBusinessDays.mjs":false,"./subDays.mjs":"lw5Ig","./subHours.mjs":false,"./subISOWeekYears.mjs":false,"./subMilliseconds.mjs":false,"./subMinutes.mjs":false,"./subMonths.mjs":false,"./subQuarters.mjs":false,"./subSeconds.mjs":false,"./subWeeks.mjs":false,"./subYears.mjs":false,"./toDate.mjs":false,"./transpose.mjs":false,"./weeksToDays.mjs":false,"./yearsToDays.mjs":false,"./yearsToMonths.mjs":false,"./yearsToQuarters.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jwRkq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ parcelHelpers.export(exports, "add", ()=>add);
var _addDaysMjs = require("./addDays.mjs");
var _addMonthsMjs = require("./addMonths.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
var _toDateMjs = require("./toDate.mjs");
function add(date, duration) {
    const { years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0 } = duration;
    // Add years and months
    const _date = (0, _toDateMjs.toDate)(date);
    const dateWithMonths = months || years ? (0, _addMonthsMjs.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, _addDaysMjs.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, _constructFromMjs.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}
// Fallback for modularized imports:
exports.default = add;

},{"./addDays.mjs":"f68cL","./addMonths.mjs":"giobK","./constructFrom.mjs":"6OOrJ","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f68cL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ parcelHelpers.export(exports, "addDays", ()=>addDays);
var _toDateMjs = require("./toDate.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function addDays(date, amount) {
    const _date = (0, _toDateMjs.toDate)(date);
    if (isNaN(amount)) return (0, _constructFromMjs.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
// Fallback for modularized imports:
exports.default = addDays;

},{"./toDate.mjs":"hQJHR","./constructFrom.mjs":"6OOrJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQJHR":[function(require,module,exports,__globalThis) {
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toDate", ()=>toDate);
function toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
// Fallback for modularized imports:
exports.default = toDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6OOrJ":[function(require,module,exports,__globalThis) {
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructFrom", ()=>constructFrom);
function constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
// Fallback for modularized imports:
exports.default = constructFrom;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"giobK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ parcelHelpers.export(exports, "addMonths", ()=>addMonths);
var _toDateMjs = require("./toDate.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function addMonths(date, amount) {
    const _date = (0, _toDateMjs.toDate)(date);
    if (isNaN(amount)) return (0, _constructFromMjs.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, _constructFromMjs.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
// Fallback for modularized imports:
exports.default = addMonths;

},{"./toDate.mjs":"hQJHR","./constructFrom.mjs":"6OOrJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ZJws":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ parcelHelpers.export(exports, "addHours", ()=>addHours);
var _addMillisecondsMjs = require("./addMilliseconds.mjs");
var _constantsMjs = require("./constants.mjs");
function addHours(date, amount) {
    return (0, _addMillisecondsMjs.addMilliseconds)(date, amount * (0, _constantsMjs.millisecondsInHour));
}
// Fallback for modularized imports:
exports.default = addHours;

},{"./addMilliseconds.mjs":"7GeuR","./constants.mjs":"kKlgU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7GeuR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ parcelHelpers.export(exports, "addMilliseconds", ()=>addMilliseconds);
var _toDateMjs = require("./toDate.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function addMilliseconds(date, amount) {
    const timestamp = +(0, _toDateMjs.toDate)(date);
    return (0, _constructFromMjs.constructFrom)(date, timestamp + amount);
}
// Fallback for modularized imports:
exports.default = addMilliseconds;

},{"./toDate.mjs":"hQJHR","./constructFrom.mjs":"6OOrJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kKlgU":[function(require,module,exports,__globalThis) {
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "millisecondsInWeek", ()=>millisecondsInWeek);
parcelHelpers.export(exports, "millisecondsInDay", ()=>millisecondsInDay);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minutesInYear", ()=>minutesInYear);
parcelHelpers.export(exports, "minutesInMonth", ()=>minutesInMonth);
parcelHelpers.export(exports, "minutesInDay", ()=>minutesInDay);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
const daysInWeek = 7;
const daysInYear = 365.2425;
const maxTime = Math.pow(10, 8) * 86400000;
const minTime = -maxTime;
const millisecondsInWeek = 604800000;
const millisecondsInDay = 86400000;
const millisecondsInMinute = 60000;
const millisecondsInHour = 3600000;
const millisecondsInSecond = 1000;
const minutesInYear = 525600;
const minutesInMonth = 43200;
const minutesInDay = 1440;
const minutesInHour = 60;
const monthsInQuarter = 3;
const monthsInYear = 12;
const quartersInYear = 4;
const secondsInHour = 3600;
const secondsInMinute = 60;
const secondsInDay = secondsInHour * 24;
const secondsInWeek = secondsInDay * 7;
const secondsInYear = secondsInDay * daysInYear;
const secondsInMonth = secondsInYear / 12;
const secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1YRq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ parcelHelpers.export(exports, "addMinutes", ()=>addMinutes);
var _addMillisecondsMjs = require("./addMilliseconds.mjs");
var _constantsMjs = require("./constants.mjs");
function addMinutes(date, amount) {
    return (0, _addMillisecondsMjs.addMilliseconds)(date, amount * (0, _constantsMjs.millisecondsInMinute));
}
// Fallback for modularized imports:
exports.default = addMinutes;

},{"./addMilliseconds.mjs":"7GeuR","./constants.mjs":"kKlgU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJahE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ parcelHelpers.export(exports, "addSeconds", ()=>addSeconds);
var _addMillisecondsMjs = require("./addMilliseconds.mjs");
function addSeconds(date, amount) {
    return (0, _addMillisecondsMjs.addMilliseconds)(date, amount * 1000);
}
// Fallback for modularized imports:
exports.default = addSeconds;

},{"./addMilliseconds.mjs":"7GeuR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"035Nt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "compareAsc", ()=>compareAsc);
var _toDateMjs = require("./toDate.mjs");
function compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
// Fallback for modularized imports:
exports.default = compareAsc;

},{"./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ZZqS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInCalendarDays", ()=>differenceInCalendarDays);
var _constantsMjs = require("./constants.mjs");
var _startOfDayMjs = require("./startOfDay.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
function differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, _startOfDayMjs.startOfDay)(dateLeft);
    const startOfDayRight = (0, _startOfDayMjs.startOfDay)(dateRight);
    const timestampLeft = startOfDayLeft.getTime() - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = startOfDayRight.getTime() - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / (0, _constantsMjs.millisecondsInDay));
}
// Fallback for modularized imports:
exports.default = differenceInCalendarDays;

},{"./constants.mjs":"kKlgU","./startOfDay.mjs":"ckbm0","./_lib/getTimezoneOffsetInMilliseconds.mjs":"fv8cq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ckbm0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfDay", ()=>startOfDay);
var _toDateMjs = require("./toDate.mjs");
function startOfDay(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfDay;

},{"./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fv8cq":[function(require,module,exports,__globalThis) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTimezoneOffsetInMilliseconds", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fSOku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ parcelHelpers.export(exports, "differenceInCalendarMonths", ()=>differenceInCalendarMonths);
var _toDateMjs = require("./toDate.mjs");
function differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}
// Fallback for modularized imports:
exports.default = differenceInCalendarMonths;

},{"./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iugkz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ parcelHelpers.export(exports, "differenceInCalendarYears", ()=>differenceInCalendarYears);
var _toDateMjs = require("./toDate.mjs");
function differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}
// Fallback for modularized imports:
exports.default = differenceInCalendarYears;

},{"./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c94Hv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ parcelHelpers.export(exports, "differenceInDays", ()=>differenceInDays);
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    const sign = compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number(compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
// Fallback for modularized imports:
exports.default = differenceInDays;

},{"./differenceInCalendarDays.mjs":"7ZZqS","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2cdrB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ parcelHelpers.export(exports, "differenceInHours", ()=>differenceInHours);
var _constantsMjs = require("./constants.mjs");
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
var _roundingMethodsMjs = require("./_lib/roundingMethods.mjs");
function differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, _differenceInMillisecondsMjs.differenceInMilliseconds)(dateLeft, dateRight) / (0, _constantsMjs.millisecondsInHour);
    return (0, _roundingMethodsMjs.getRoundingMethod)(options?.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInHours;

},{"./constants.mjs":"kKlgU","./differenceInMilliseconds.mjs":"69Jcr","./_lib/roundingMethods.mjs":"iA1Q7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"69Jcr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ parcelHelpers.export(exports, "differenceInMilliseconds", ()=>differenceInMilliseconds);
var _toDateMjs = require("./toDate.mjs");
function differenceInMilliseconds(dateLeft, dateRight) {
    return (0, _toDateMjs.toDate)(dateLeft).getTime() - (0, _toDateMjs.toDate)(dateRight).getTime();
}
// Fallback for modularized imports:
exports.default = differenceInMilliseconds;

},{"./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iA1Q7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundingMethod", ()=>getRoundingMethod);
function getRoundingMethod(method) {
    return method ? Math[method] : Math.trunc;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ZuFL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ parcelHelpers.export(exports, "differenceInMinutes", ()=>differenceInMinutes);
var _constantsMjs = require("./constants.mjs");
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
var _roundingMethodsMjs = require("./_lib/roundingMethods.mjs");
function differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, _differenceInMillisecondsMjs.differenceInMilliseconds)(dateLeft, dateRight) / (0, _constantsMjs.millisecondsInMinute);
    return (0, _roundingMethodsMjs.getRoundingMethod)(options?.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInMinutes;

},{"./constants.mjs":"kKlgU","./differenceInMilliseconds.mjs":"69Jcr","./_lib/roundingMethods.mjs":"iA1Q7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5mi2M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ parcelHelpers.export(exports, "differenceInMonths", ()=>differenceInMonths);
var _compareAscMjs = require("./compareAsc.mjs");
var _differenceInCalendarMonthsMjs = require("./differenceInCalendarMonths.mjs");
var _isLastDayOfMonthMjs = require("./isLastDayOfMonth.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    const sign = (0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, _differenceInCalendarMonthsMjs.differenceInCalendarMonths)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, _isLastDayOfMonthMjs.isLastDayOfMonth)((0, _toDateMjs.toDate)(dateLeft)) && difference === 1 && (0, _compareAscMjs.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Fallback for modularized imports:
exports.default = differenceInMonths;

},{"./compareAsc.mjs":"035Nt","./differenceInCalendarMonths.mjs":"fSOku","./isLastDayOfMonth.mjs":"aBNTI","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aBNTI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ parcelHelpers.export(exports, "isLastDayOfMonth", ()=>isLastDayOfMonth);
var _endOfDayMjs = require("./endOfDay.mjs");
var _endOfMonthMjs = require("./endOfMonth.mjs");
var _toDateMjs = require("./toDate.mjs");
function isLastDayOfMonth(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    return +(0, _endOfDayMjs.endOfDay)(_date) === +(0, _endOfMonthMjs.endOfMonth)(_date);
}
// Fallback for modularized imports:
exports.default = isLastDayOfMonth;

},{"./endOfDay.mjs":"4ItQx","./endOfMonth.mjs":"eydb8","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ItQx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfDay", ()=>endOfDay);
var _toDateMjs = require("./toDate.mjs");
function endOfDay(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfDay;

},{"./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eydb8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfMonth", ()=>endOfMonth);
var _toDateMjs = require("./toDate.mjs");
function endOfMonth(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfMonth;

},{"./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Hp7d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ parcelHelpers.export(exports, "differenceInSeconds", ()=>differenceInSeconds);
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
var _roundingMethodsMjs = require("./_lib/roundingMethods.mjs");
function differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, _differenceInMillisecondsMjs.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, _roundingMethodsMjs.getRoundingMethod)(options?.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInSeconds;

},{"./differenceInMilliseconds.mjs":"69Jcr","./_lib/roundingMethods.mjs":"iA1Q7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9T2Ne":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInYears", ()=>differenceInYears);
var _compareAscMjs = require("./compareAsc.mjs");
var _differenceInCalendarYearsMjs = require("./differenceInCalendarYears.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    const sign = (0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, _differenceInCalendarYearsMjs.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, _compareAscMjs.compareAsc)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Fallback for modularized imports:
exports.default = differenceInYears;

},{"./compareAsc.mjs":"035Nt","./differenceInCalendarYears.mjs":"iugkz","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99LTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ parcelHelpers.export(exports, "format", ()=>format);
var _isValidMjs = require("./isValid.mjs");
var _toDateMjs = require("./toDate.mjs");
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
var _formattersMjs = require("./_lib/format/formatters.mjs");
var _longFormattersMjs = require("./_lib/format/longFormatters.mjs");
var _protectedTokensMjs = require("./_lib/protectedTokens.mjs");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
    const defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleMjs.defaultLocale);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, _toDateMjs.toDate)(date);
    if (!(0, _isValidMjs.isValid)(originalDate)) throw new RangeError("Invalid time value");
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    const result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, _longFormattersMjs.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        const formatter = (0, _formattersMjs.formatters)[firstCharacter];
        if (formatter) {
            if (!options?.useAdditionalWeekYearTokens && (0, _protectedTokensMjs.isProtectedWeekYearToken)(substring)) (0, _protectedTokensMjs.warnOrThrowProtectedError)(substring, formatStr, String(date));
            if (!options?.useAdditionalDayOfYearTokens && (0, _protectedTokensMjs.isProtectedDayOfYearToken)(substring)) (0, _protectedTokensMjs.warnOrThrowProtectedError)(substring, formatStr, String(date));
            return formatter(originalDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    const matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
// Fallback for modularized imports:
exports.default = format;

},{"./isValid.mjs":"duVTX","./toDate.mjs":"hQJHR","./_lib/defaultLocale.mjs":"ltl1h","./_lib/defaultOptions.mjs":"gOjsl","./_lib/format/formatters.mjs":"28oKB","./_lib/format/longFormatters.mjs":"8MV79","./_lib/protectedTokens.mjs":"glHeI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"duVTX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ parcelHelpers.export(exports, "isValid", ()=>isValid);
var _isDateMjs = require("./isDate.mjs");
var _toDateMjs = require("./toDate.mjs");
function isValid(date) {
    if (!(0, _isDateMjs.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, _toDateMjs.toDate)(date);
    return !isNaN(Number(_date));
}
// Fallback for modularized imports:
exports.default = isValid;

},{"./isDate.mjs":"d0a2Y","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d0a2Y":[function(require,module,exports,__globalThis) {
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", ()=>isDate);
function isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
// Fallback for modularized imports:
exports.default = isDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ltl1h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLocale", ()=>(0, _enUSMjs.enUS));
var _enUSMjs = require("../locale/en-US.mjs");

},{"../locale/en-US.mjs":"lN3M5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lN3M5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enUS", ()=>enUS);
var _formatDistanceMjs = require("./en-US/_lib/formatDistance.mjs");
var _formatLongMjs = require("./en-US/_lib/formatLong.mjs");
var _formatRelativeMjs = require("./en-US/_lib/formatRelative.mjs");
var _localizeMjs = require("./en-US/_lib/localize.mjs");
var _matchMjs = require("./en-US/_lib/match.mjs");
const enUS = {
    code: "en-US",
    formatDistance: (0, _formatDistanceMjs.formatDistance),
    formatLong: (0, _formatLongMjs.formatLong),
    formatRelative: (0, _formatRelativeMjs.formatRelative),
    localize: (0, _localizeMjs.localize),
    match: (0, _matchMjs.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
// Fallback for modularized imports:
exports.default = enUS;

},{"./en-US/_lib/formatDistance.mjs":"lvAGN","./en-US/_lib/formatLong.mjs":"huaKH","./en-US/_lib/formatRelative.mjs":"d4PML","./en-US/_lib/localize.mjs":"6itwQ","./en-US/_lib/match.mjs":"ewypP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvAGN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDistance", ()=>formatDistance);
const formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"huaKH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatLong", ()=>formatLong);
var _buildFormatLongFnMjs = require("../../_lib/buildFormatLongFn.mjs");
const dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const formatLong = {
    date: (0, _buildFormatLongFnMjs.buildFormatLongFn)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _buildFormatLongFnMjs.buildFormatLongFn)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _buildFormatLongFnMjs.buildFormatLongFn)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};

},{"../../_lib/buildFormatLongFn.mjs":"ejLHG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ejLHG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildFormatLongFn", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d4PML":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelative", ()=>formatRelative);
const formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const formatRelative = (token, _date, _baseDate, _options)=>formatRelativeLocale[token];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6itwQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localize", ()=>localize);
var _buildLocalizeFnMjs = require("../../_lib/buildLocalizeFn.mjs");
const eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const localize = {
    ordinalNumber,
    era: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

},{"../../_lib/buildLocalizeFn.mjs":"HvRpj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"HvRpj":[function(require,module,exports,__globalThis) {
/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildLocalizeFn", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewypP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", ()=>match);
var _buildMatchFnMjs = require("../../_lib/buildMatchFn.mjs");
var _buildMatchPatternFnMjs = require("../../_lib/buildMatchPatternFn.mjs");
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const match = {
    ordinalNumber: (0, _buildMatchPatternFnMjs.buildMatchPatternFn)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

},{"../../_lib/buildMatchFn.mjs":"1HRDT","../../_lib/buildMatchPatternFn.mjs":"xH23L","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1HRDT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchFn", ()=>buildMatchFn);
function buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}
function findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"xH23L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchPatternFn", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gOjsl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
let defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"28oKB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatters", ()=>formatters);
var _getDayOfYearMjs = require("../../getDayOfYear.mjs");
var _getISOWeekMjs = require("../../getISOWeek.mjs");
var _getISOWeekYearMjs = require("../../getISOWeekYear.mjs");
var _getWeekMjs = require("../../getWeek.mjs");
var _getWeekYearMjs = require("../../getWeekYear.mjs");
var _addLeadingZerosMjs = require("../addLeadingZeros.mjs");
var _lightFormattersMjs = require("./lightFormatters.mjs");
const dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const formatters = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _lightFormattersMjs.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, _getWeekYearMjs.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, _addLeadingZerosMjs.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _addLeadingZerosMjs.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, _getISOWeekYearMjs.getISOWeekYear)(date);
        // Padding
        return (0, _addLeadingZerosMjs.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, _addLeadingZerosMjs.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _lightFormattersMjs.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, _getWeekMjs.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, _getISOWeekMjs.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, _lightFormattersMjs.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, _getDayOfYearMjs.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _addLeadingZerosMjs.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _lightFormattersMjs.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, _lightFormattersMjs.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosMjs.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, _lightFormattersMjs.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, _lightFormattersMjs.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, _lightFormattersMjs.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _addLeadingZerosMjs.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timestamp = originalDate.getTime();
        return (0, _addLeadingZerosMjs.addLeadingZeros)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.floor(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, _addLeadingZerosMjs.addLeadingZeros)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, _addLeadingZerosMjs.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, _addLeadingZerosMjs.addLeadingZeros)(Math.floor(absOffset / 60), 2);
    const minutes = (0, _addLeadingZerosMjs.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

},{"../../getDayOfYear.mjs":"4GBqi","../../getISOWeek.mjs":"ifZc9","../../getISOWeekYear.mjs":"lnes3","../../getWeek.mjs":"a8QMh","../../getWeekYear.mjs":"jb2Yl","../addLeadingZeros.mjs":"7NIlW","./lightFormatters.mjs":"3bgls","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4GBqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ parcelHelpers.export(exports, "getDayOfYear", ()=>getDayOfYear);
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _startOfYearMjs = require("./startOfYear.mjs");
var _toDateMjs = require("./toDate.mjs");
function getDayOfYear(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    const diff = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(_date, (0, _startOfYearMjs.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
// Fallback for modularized imports:
exports.default = getDayOfYear;

},{"./differenceInCalendarDays.mjs":"7ZZqS","./startOfYear.mjs":"1zDYC","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1zDYC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfYear", ()=>startOfYear);
var _toDateMjs = require("./toDate.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function startOfYear(date) {
    const cleanDate = (0, _toDateMjs.toDate)(date);
    const _date = (0, _constructFromMjs.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfYear;

},{"./toDate.mjs":"hQJHR","./constructFrom.mjs":"6OOrJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ifZc9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ parcelHelpers.export(exports, "getISOWeek", ()=>getISOWeek);
var _constantsMjs = require("./constants.mjs");
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
var _startOfISOWeekYearMjs = require("./startOfISOWeekYear.mjs");
var _toDateMjs = require("./toDate.mjs");
function getISOWeek(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    const diff = (0, _startOfISOWeekMjs.startOfISOWeek)(_date).getTime() - (0, _startOfISOWeekYearMjs.startOfISOWeekYear)(_date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / (0, _constantsMjs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getISOWeek;

},{"./constants.mjs":"kKlgU","./startOfISOWeek.mjs":"9J7eH","./startOfISOWeekYear.mjs":"5rpTv","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9J7eH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeek", ()=>startOfISOWeek);
var _startOfWeekMjs = require("./startOfWeek.mjs");
function startOfISOWeek(date) {
    return (0, _startOfWeekMjs.startOfWeek)(date, {
        weekStartsOn: 1
    });
}
// Fallback for modularized imports:
exports.default = startOfISOWeek;

},{"./startOfWeek.mjs":"4JTsH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4JTsH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfWeek", ()=>startOfWeek);
var _toDateMjs = require("./toDate.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function startOfWeek(date, options) {
    const defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _toDateMjs.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeek;

},{"./toDate.mjs":"hQJHR","./_lib/defaultOptions.mjs":"gOjsl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5rpTv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeekYear", ()=>startOfISOWeekYear);
var _getISOWeekYearMjs = require("./getISOWeekYear.mjs");
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
var _constructFromMjs = require("./constructFrom.mjs");
function startOfISOWeekYear(date) {
    const year = (0, _getISOWeekYearMjs.getISOWeekYear)(date);
    const fourthOfJanuary = (0, _constructFromMjs.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, _startOfISOWeekMjs.startOfISOWeek)(fourthOfJanuary);
}
// Fallback for modularized imports:
exports.default = startOfISOWeekYear;

},{"./getISOWeekYear.mjs":"lnes3","./startOfISOWeek.mjs":"9J7eH","./constructFrom.mjs":"6OOrJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lnes3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ parcelHelpers.export(exports, "getISOWeekYear", ()=>getISOWeekYear);
var _constructFromMjs = require("./constructFrom.mjs");
var _startOfISOWeekMjs = require("./startOfISOWeek.mjs");
var _toDateMjs = require("./toDate.mjs");
function getISOWeekYear(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, _constructFromMjs.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfISOWeekMjs.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, _constructFromMjs.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfISOWeekMjs.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getISOWeekYear;

},{"./constructFrom.mjs":"6OOrJ","./startOfISOWeek.mjs":"9J7eH","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a8QMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ parcelHelpers.export(exports, "getWeek", ()=>getWeek);
var _constantsMjs = require("./constants.mjs");
var _startOfWeekMjs = require("./startOfWeek.mjs");
var _startOfWeekYearMjs = require("./startOfWeekYear.mjs");
var _toDateMjs = require("./toDate.mjs");
function getWeek(date, options) {
    const _date = (0, _toDateMjs.toDate)(date);
    const diff = (0, _startOfWeekMjs.startOfWeek)(_date, options).getTime() - (0, _startOfWeekYearMjs.startOfWeekYear)(_date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / (0, _constantsMjs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getWeek;

},{"./constants.mjs":"kKlgU","./startOfWeek.mjs":"4JTsH","./startOfWeekYear.mjs":"2wKdl","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wKdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfWeekYear", ()=>startOfWeekYear);
var _constructFromMjs = require("./constructFrom.mjs");
var _getWeekYearMjs = require("./getWeekYear.mjs");
var _startOfWeekMjs = require("./startOfWeek.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function startOfWeekYear(date, options) {
    const defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, _getWeekYearMjs.getWeekYear)(date, options);
    const firstWeek = (0, _constructFromMjs.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, _startOfWeekMjs.startOfWeek)(firstWeek, options);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeekYear;

},{"./constructFrom.mjs":"6OOrJ","./getWeekYear.mjs":"jb2Yl","./startOfWeek.mjs":"4JTsH","./_lib/defaultOptions.mjs":"gOjsl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jb2Yl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ parcelHelpers.export(exports, "getWeekYear", ()=>getWeekYear);
var _constructFromMjs = require("./constructFrom.mjs");
var _startOfWeekMjs = require("./startOfWeek.mjs");
var _toDateMjs = require("./toDate.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function getWeekYear(date, options) {
    const _date = (0, _toDateMjs.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, _constructFromMjs.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfWeekMjs.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, _constructFromMjs.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfWeekMjs.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getWeekYear;

},{"./constructFrom.mjs":"6OOrJ","./startOfWeek.mjs":"4JTsH","./toDate.mjs":"hQJHR","./_lib/defaultOptions.mjs":"gOjsl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7NIlW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLeadingZeros", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3bgls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lightFormatters", ()=>lightFormatters);
var _addLeadingZerosMjs = require("../addLeadingZeros.mjs");
const lightFormatters = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _addLeadingZerosMjs.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, _addLeadingZerosMjs.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, _addLeadingZerosMjs.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _addLeadingZerosMjs.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

},{"../addLeadingZeros.mjs":"7NIlW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MV79":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "longFormatters", ()=>longFormatters);
const dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
const longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"glHeI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "warnOrThrowProtectedError", ()=>warnOrThrowProtectedError);
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
    return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
    const _message = message(token, format, input);
    console.warn(_message);
    if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"koHmA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ parcelHelpers.export(exports, "formatDistance", ()=>formatDistance);
var _compareAscMjs = require("./compareAsc.mjs");
var _constantsMjs = require("./constants.mjs");
var _differenceInMonthsMjs = require("./differenceInMonths.mjs");
var _differenceInSecondsMjs = require("./differenceInSeconds.mjs");
var _toDateMjs = require("./toDate.mjs");
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
function formatDistance(date, baseDate, options) {
    const defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleMjs.defaultLocale);
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, _compareAscMjs.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, _toDateMjs.toDate)(baseDate);
        dateRight = (0, _toDateMjs.toDate)(date);
    } else {
        dateLeft = (0, _toDateMjs.toDate)(date);
        dateRight = (0, _toDateMjs.toDate)(baseDate);
    }
    const seconds = (0, _differenceInSecondsMjs.differenceInSeconds)(dateRight, dateLeft);
    const offsetInSeconds = ((0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(dateRight) - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < (0, _constantsMjs.minutesInDay)) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < (0, _constantsMjs.minutesInMonth)) {
        const days = Math.round(minutes / (0, _constantsMjs.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < (0, _constantsMjs.minutesInMonth) * 2) {
        months = Math.round(minutes / (0, _constantsMjs.minutesInMonth));
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, _differenceInMonthsMjs.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / (0, _constantsMjs.minutesInMonth));
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}
// Fallback for modularized imports:
exports.default = formatDistance;

},{"./compareAsc.mjs":"035Nt","./constants.mjs":"kKlgU","./differenceInMonths.mjs":"5mi2M","./differenceInSeconds.mjs":"9Hp7d","./toDate.mjs":"hQJHR","./_lib/defaultLocale.mjs":"ltl1h","./_lib/defaultOptions.mjs":"gOjsl","./_lib/getTimezoneOffsetInMilliseconds.mjs":"fv8cq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kapFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ parcelHelpers.export(exports, "formatDistanceToNow", ()=>formatDistanceToNow);
var _formatDistanceMjs = require("./formatDistance.mjs");
function formatDistanceToNow(date, options) {
    return (0, _formatDistanceMjs.formatDistance)(date, Date.now(), options);
}
// Fallback for modularized imports:
exports.default = formatDistanceToNow;

},{"./formatDistance.mjs":"koHmA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"78IyP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ parcelHelpers.export(exports, "formatDuration", ()=>formatDuration);
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
/**
 * The {@link formatDuration} function options.
 */ const defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
function formatDuration(duration, options) {
    const defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleMjs.defaultLocale);
    const format = options?.format ?? defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}
// Fallback for modularized imports:
exports.default = formatDuration;

},{"./_lib/defaultLocale.mjs":"ltl1h","./_lib/defaultOptions.mjs":"gOjsl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bFeNW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ parcelHelpers.export(exports, "intervalToDuration", ()=>intervalToDuration);
var _addMjs = require("./add.mjs");
var _differenceInDaysMjs = require("./differenceInDays.mjs");
var _differenceInHoursMjs = require("./differenceInHours.mjs");
var _differenceInMinutesMjs = require("./differenceInMinutes.mjs");
var _differenceInMonthsMjs = require("./differenceInMonths.mjs");
var _differenceInSecondsMjs = require("./differenceInSeconds.mjs");
var _differenceInYearsMjs = require("./differenceInYears.mjs");
var _toDateMjs = require("./toDate.mjs");
function intervalToDuration(interval) {
    const start = (0, _toDateMjs.toDate)(interval.start);
    const end = (0, _toDateMjs.toDate)(interval.end);
    const duration = {};
    const years = (0, _differenceInYearsMjs.differenceInYears)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, _addMjs.add)(start, {
        years: duration.years
    });
    const months = (0, _differenceInMonthsMjs.differenceInMonths)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, _addMjs.add)(remainingMonths, {
        months: duration.months
    });
    const days = (0, _differenceInDaysMjs.differenceInDays)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, _addMjs.add)(remainingDays, {
        days: duration.days
    });
    const hours = (0, _differenceInHoursMjs.differenceInHours)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, _addMjs.add)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, _differenceInMinutesMjs.differenceInMinutes)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, _addMjs.add)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, _differenceInSecondsMjs.differenceInSeconds)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}
// Fallback for modularized imports:
exports.default = intervalToDuration;

},{"./add.mjs":"jwRkq","./differenceInDays.mjs":"c94Hv","./differenceInHours.mjs":"2cdrB","./differenceInMinutes.mjs":"7ZuFL","./differenceInMonths.mjs":"5mi2M","./differenceInSeconds.mjs":"9Hp7d","./differenceInYears.mjs":"9T2Ne","./toDate.mjs":"hQJHR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6A2u9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ parcelHelpers.export(exports, "parseISO", ()=>parseISO);
var _constantsMjs = require("./constants.mjs");
function parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split(patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = parseDateUnit(captures[1]);
    const month = parseDateUnit(captures[2]) - 1;
    const day = parseDateUnit(captures[3]);
    const week = parseDateUnit(captures[4]);
    const dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    const captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = parseTimeUnit(captures[1]);
    const minutes = parseTimeUnit(captures[2]);
    const seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _constantsMjs.millisecondsInHour) + minutes * (0, _constantsMjs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _constantsMjs.millisecondsInHour) + minutes * (0, _constantsMjs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
// Fallback for modularized imports:
exports.default = parseISO;

},{"./constants.mjs":"kKlgU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lw5Ig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ parcelHelpers.export(exports, "subDays", ()=>subDays);
var _addDaysMjs = require("./addDays.mjs");
function subDays(date, amount) {
    return (0, _addDaysMjs.addDays)(date, -amount);
}
// Fallback for modularized imports:
exports.default = subDays;

},{"./addDays.mjs":"f68cL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bR8zj":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("405be6f46b5c7d7c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("386d09579e7f857f"));
var _jsxRuntime = require("c94cbd5e034dba28");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'RemoveRedEye');

},{"405be6f46b5c7d7c":"kZ6eK","386d09579e7f857f":"2vOnF","c94cbd5e034dba28":"1dlk8"}],"hqaQa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApplianceIndicatorIcon", ()=>ApplianceIndicatorIcon);
parcelHelpers.export(exports, "NetworkIndicator", ()=>NetworkIndicator);
parcelHelpers.export(exports, "AuditOperationIndicator", ()=>AuditOperationIndicator);
parcelHelpers.export(exports, "InputHealthIndicator", ()=>InputHealthIndicator);
parcelHelpers.export(exports, "OutputHealthIndicator", ()=>OutputHealthIndicator);
parcelHelpers.export(exports, "AutoUpdatingInputHealthIndicator", ()=>AutoUpdatingInputHealthIndicator);
parcelHelpers.export(exports, "NonSubscribingAutoUpdatingInputHealthIndicator", ()=>NonSubscribingAutoUpdatingInputHealthIndicator);
parcelHelpers.export(exports, "AutoUpdatingOutputHealthIndicator", ()=>AutoUpdatingOutputHealthIndicator);
parcelHelpers.export(exports, "NonSubscribingAutoUpdatingOutputHealthIndicator", ()=>NonSubscribingAutoUpdatingOutputHealthIndicator);
parcelHelpers.export(exports, "ServiceOverviewApplianceHealthIndicator", ()=>ServiceOverviewApplianceHealthIndicator);
parcelHelpers.export(exports, "AutoUpdatingApplianceHealthIndicator", ()=>AutoUpdatingApplianceHealthIndicator);
parcelHelpers.export(exports, "NonSubscribingAutoUpdatingApplianceHealthIndicator", ()=>NonSubscribingAutoUpdatingApplianceHealthIndicator);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _fiberManualRecord = require("@mui/icons-material/FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _fiberManualRecordOutlined = require("@mui/icons-material/FiberManualRecordOutlined");
var _fiberManualRecordOutlinedDefault = parcelHelpers.interopDefault(_fiberManualRecordOutlined);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _linkOff = require("@mui/icons-material/LinkOff");
var _linkOffDefault = parcelHelpers.interopDefault(_linkOff);
var _callMerge = require("@mui/icons-material/CallMerge");
var _callMergeDefault = parcelHelpers.interopDefault(_callMerge);
var _videocamOff = require("@mui/icons-material/VideocamOff");
var _videocamOffDefault = parcelHelpers.interopDefault(_videocamOff);
var _notInterested = require("@mui/icons-material/NotInterested");
var _notInterestedDefault = parcelHelpers.interopDefault(_notInterested);
var _types = require("common/api/v1/types");
var _outputsActions = require("../../redux/actions/outputsActions");
var _applianceActions = require("../../redux/actions/applianceActions");
var _inputsActions = require("../../redux/actions/inputsActions");
var _utils = require("../../utils");
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _utils1 = require("common/utils");
const styles = {
    inlineWrapper: {
        display: 'flex',
        alignItems: 'center',
        '& > span': {
            marginLeft: (theme)=>theme.spacing(1)
        }
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '34px',
        height: '34px',
        pointerEvents: 'all',
        '& svg': {
            display: 'block'
        }
    },
    warning: {
        color: (theme)=>theme.palette.warning.main
    },
    error: {
        color: (theme)=>theme.palette.error.main
    },
    success: {
        color: (theme)=>theme.palette.success.main
    }
};
function titleFromInputStatus(status) {
    switch(status){
        case (0, _types.InputOperStatus).notConfigured:
            return 'Input is not configured';
        case (0, _types.InputOperStatus).metricsMissing:
            return 'Metrics missing:';
        case (0, _types.InputOperStatus).allOk:
            return 'Everything is ok';
        case (0, _types.InputOperStatus).inputError:
            return 'Input error:';
        case (0, _types.InputOperStatus).tr101290Priority1Error:
            return 'TR 101 290 Prio 1 error:';
        case (0, _types.InputOperStatus).transportError:
            return 'Transport error:';
        case (0, _types.InputOperStatus).alarm:
            return 'Alarm:';
        case (0, _types.InputOperStatus).reducedRedundancy:
            return 'Reduced redundancy:';
    }
}
function titleFromOutputStatus(status) {
    switch(status){
        case (0, _types.OutputOperStatus).notConfigured:
            return 'Not configured:';
        case (0, _types.OutputOperStatus).metricsMissing:
            return 'Metrics missing:';
        case (0, _types.OutputOperStatus).tr101290Priority1Error:
            return 'TR 101 290 Prio 1 error:';
        case (0, _types.OutputOperStatus).reducedRedundancy:
            return 'Reduced redundancy:';
        case (0, _types.OutputOperStatus).allOk:
            return 'Everything is ok';
        case (0, _types.OutputOperStatus).notAcknowledged:
            return 'Not acknowledged:';
        case (0, _types.OutputOperStatus).inputError:
            return 'Input error:';
        case (0, _types.OutputOperStatus).outputError:
            return 'Output error:';
        case (0, _types.OutputOperStatus).alarm:
            return 'Alarm:';
    }
}
const InputIndicatorIcon = ({ status, disabled })=>{
    if (disabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notInterestedDefault.default), {
        color: "disabled"
    });
    switch(status){
        case (0, _types.InputOperStatus).allOk:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: styles.success
            });
        case (0, _types.InputOperStatus).inputError:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videocamOffDefault.default), {
                sx: styles.error
            });
        case (0, _types.InputOperStatus).notConfigured:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordOutlinedDefault.default), {
                sx: styles.success
            });
        case (0, _types.InputOperStatus).tr101290Priority1Error:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: styles.warning
            });
        case (0, _types.InputOperStatus).transportError:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkOffDefault.default), {
                sx: styles.error
            });
        case (0, _types.InputOperStatus).reducedRedundancy:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _callMergeDefault.default), {
                sx: styles.success
            });
        case (0, _types.InputOperStatus).metricsMissing:
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                sx: styles.warning
            });
    }
};
const OutputIndicatorIcon = ({ status, disabled })=>{
    if (disabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notInterestedDefault.default), {
        color: "disabled"
    });
    switch(status){
        case (0, _types.OutputOperStatus).allOk:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: styles.success
            });
        case (0, _types.OutputOperStatus).notAcknowledged:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                sx: styles.success
            });
        case (0, _types.OutputOperStatus).inputError:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videocamOffDefault.default), {
                sx: styles.error
            });
        case (0, _types.OutputOperStatus).notConfigured:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordOutlinedDefault.default), {
                sx: styles.success
            });
        case (0, _types.OutputOperStatus).outputError:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkOffDefault.default), {
                sx: styles.error
            });
        case (0, _types.OutputOperStatus).reducedRedundancy:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _callMergeDefault.default), {
                sx: styles.success
            });
        case (0, _types.OutputOperStatus).tr101290Priority1Error:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: styles.warning
            });
        case (0, _types.OutputOperStatus).alarm:
        case (0, _types.OutputOperStatus).metricsMissing:
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                sx: styles.warning
            });
    }
};
const ApplianceIndicatorIcon = ({ status, restarting, softwareMismatch })=>{
    if (restarting) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
        size: 25
    });
    switch(status.state){
        case (0, _types.ApplianceConnectionState).connected:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: softwareMismatch ? styles.warning : styles.success
            });
        case (0, _types.ApplianceConnectionState).neverConnected:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkOffDefault.default), {
                sx: styles.error,
                "data-testid": "neverconnected"
            });
        // return <NotInterested color="disabled" />
        case (0, _types.ApplianceConnectionState).missing:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: styles.error
            });
        default:
            return null;
    }
};
const NetworkIndicator = ({ enabled })=>{
    if (!enabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: 'Disabled',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notInterestedDefault.default), {
            color: "disabled"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: 'Enabled',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
            sx: styles.success
        })
    });
};
const AuditOperationIndicator = ({ error })=>{
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: `Operation failed with error: ${error}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
            sx: styles.error
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: 'Success',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
            sx: styles.success
        })
    });
};
const InputHealthIndicator = ({ status, inline, noText, disabled })=>{
    if (!status) status = {
        title: 'Unknown',
        state: (0, _types.InputOperStatus).metricsMissing
    };
    const titlePrefix = titleFromInputStatus(status.state);
    const title = `${titlePrefix}${status.title ? ` ${status.title}` : ''}`;
    return inline || noText ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.inlineWrapper,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputIndicatorIcon, {
                status: status.state,
                disabled: disabled
            }),
            !noText && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: disabled ? 'Disabled' : title
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: disabled ? 'Input is disabled' : title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.container,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputIndicatorIcon, {
                    status: status.state,
                    disabled: disabled
                })
            })
        })
    });
};
const OutputHealthIndicator = ({ status, inline, noText, disabled })=>{
    if (!status) status = {
        title: 'Unknown',
        state: (0, _types.OutputOperStatus).metricsMissing
    };
    const prefix = titleFromOutputStatus(status.state);
    const title = disabled ? 'Output is disabled' : `${prefix}${status.title ? ` ${status.title}` : ''}`;
    return inline || noText ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.inlineWrapper,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputIndicatorIcon, {
                status: status.state,
                disabled: disabled
            }),
            !noText && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: title
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.container,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputIndicatorIcon, {
                    status: status.state,
                    disabled: disabled
                })
            })
        })
    });
};
/**
 * Appliance health indicator
 * @param status - fetched status
 * @param inline - whether it should be inline component
 * @param noText - whether we should hide the text for inline component
 * @param restarting - whether the appliance is restarting
 * @param softwareMismatch - wheter the appliance software version differ fron buildInfo version
 */ const ApplianceHealthIndicator = ({ status, inline, noText, restarting, softwareMismatch })=>{
    const title = softwareMismatch ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            whiteSpace: 'pre-line',
            textAlign: 'center'
        },
        children: [
            status.title,
            '\n',
            "Software version is outdated, restart appliance to update"
        ]
    }) : status.title;
    return inline || noText ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.inlineWrapper,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ApplianceIndicatorIcon, {
                status: status,
                restarting: restarting,
                softwareMismatch: softwareMismatch
            }),
            !noText && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: status.title
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: restarting ? 'Restarting' : title,
        placement: 'top',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.container,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ApplianceIndicatorIcon, {
                    status: status,
                    restarting: restarting,
                    softwareMismatch: softwareMismatch
                })
            })
        })
    });
};
const AutoUpdatingInputHealthIndicator = ({ initialInput, inline, noText })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const inputId = initialInput.id;
    (0, _react.useEffect)(()=>{
        if (!inputId) return;
        dispatch((0, _inputsActions.registerInputObserver)({
            inputIds: [
                inputId
            ]
        }));
        return ()=>{
            dispatch((0, _inputsActions.unregisterInputObserver)({
                inputIds: [
                    inputId
                ]
            }));
        };
    }, [
        inputId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NonSubscribingAutoUpdatingInputHealthIndicator, {
        initialInput: initialInput,
        inline: inline,
        noText: noText
    });
};
const NonSubscribingAutoUpdatingInputHealthIndicator = ({ initialInput, inline, noText })=>{
    const input = (0, _reactRedux.useSelector)(({ inputsReducer })=>{
        const input = inputsReducer.observedInputs.find((i)=>i.id === initialInput.id);
        return input ? (0, _utils1.pick)(input, 'id', 'health', 'adminStatus') : undefined;
    }, (0, _isEqualDefault.default)) ?? initialInput;
    if (!input) return null;
    const health = input.health;
    if (!health) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputHealthIndicator, {
        status: health,
        inline: inline,
        noText: noText,
        disabled: input.adminStatus === (0, _types.InputAdminStatus).off
    });
};
const AutoUpdatingOutputHealthIndicator = ({ initialOutput, inline, noText })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const outputId = initialOutput.id;
    (0, _react.useEffect)(()=>{
        dispatch((0, _outputsActions.registerOutputObserver)({
            outputIds: [
                outputId
            ]
        }));
        return ()=>{
            dispatch((0, _outputsActions.unregisterOutputObserver)({
                outputIds: [
                    outputId
                ]
            }));
        };
    }, [
        outputId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NonSubscribingAutoUpdatingOutputHealthIndicator, {
        initialOutput: initialOutput,
        inline: inline,
        noText: noText
    });
};
const NonSubscribingAutoUpdatingOutputHealthIndicator = ({ initialOutput, inline, noText })=>{
    const output = (0, _reactRedux.useSelector)(({ outputsReducer })=>{
        const o = outputsReducer.observedOutputs.find((o)=>o.id === initialOutput.id);
        return o ? (0, _utils1.pick)(o, 'id', 'health', 'adminStatus') : undefined;
    }, (0, _isEqualDefault.default)) ?? initialOutput;
    const health = output.health;
    if (!health) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputHealthIndicator, {
        status: health,
        inline: inline,
        noText: noText,
        disabled: output.adminStatus === (0, _types.OutputAdminStatus).off
    });
};
const ServiceOverviewApplianceHealthIndicator = ({ applianceId, inline, noText })=>{
    const serviceOverviewAppliances = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>serviceOverviewReducer.appliances.map((a)=>({
                id: a.id,
                health: 'health' in a ? a.health : undefined
            })), (0, _isEqualDefault.default));
    if (!applianceId) return null;
    const appliance = serviceOverviewAppliances.find((a)=>a?.id == applianceId);
    return appliance && 'health' in appliance && appliance.health ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ApplianceHealthIndicator, {
        status: appliance.health,
        inline: inline,
        noText: noText
    }) : null;
};
const AutoUpdatingApplianceHealthIndicator = ({ applianceId, inline, noText })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _applianceActions.registerApplianceObserver)({
            applianceIds: [
                applianceId
            ]
        }));
        return ()=>{
            dispatch((0, _applianceActions.unregisterApplianceObserver)({
                applianceIds: [
                    applianceId
                ]
            }));
        };
    }, [
        applianceId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NonSubscribingAutoUpdatingApplianceHealthIndicator, {
        applianceId: applianceId,
        inline: inline,
        noText: noText
    });
};
const NonSubscribingAutoUpdatingApplianceHealthIndicator = ({ applianceId, inline, noText })=>{
    const buildInfo = (0, _reactRedux.useSelector)(({ buildInfoReducer })=>buildInfoReducer.buildInfo ? (0, _utils1.pick)(buildInfoReducer.buildInfo, 'release') : undefined, (0, _reactRedux.shallowEqual));
    const appliance = (0, _reactRedux.useSelector)(({ appliancesReducer })=>{
        const appliance = [
            ...appliancesReducer.appliances,
            appliancesReducer.appliance
        ].find((a)=>a?.id === applianceId);
        return appliance ? (0, _utils1.pick)(appliance, 'id', 'health', 'version', '_restarting') : undefined;
    }, (0, _isEqualDefault.default));
    if (!appliance || !appliance.health) return null;
    const controlSoftwareVersion = appliance.version?.controlSoftwareVersion;
    const dataSoftwareVersion = appliance.version?.dataSoftwareVersion;
    const softwareMismatch = (0, _utils.runningDifferentSoftwareVersion)(controlSoftwareVersion, buildInfo) || (0, _utils.runningDifferentSoftwareVersion)(dataSoftwareVersion, buildInfo);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ApplianceHealthIndicator, {
        status: appliance.health,
        inline: inline,
        noText: noText,
        restarting: appliance._restarting,
        softwareMismatch: softwareMismatch
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","./Tooltip":"crjvg","@mui/material/CircularProgress":"kEtIR","@mui/icons-material/FiberManualRecord":"bvXIN","@mui/icons-material/FiberManualRecordOutlined":"Vffg8","@mui/icons-material/HelpOutline":"2sIqE","@mui/icons-material/LinkOff":"lwjKU","@mui/icons-material/CallMerge":"5MdQE","@mui/icons-material/VideocamOff":"kdfbz","@mui/icons-material/NotInterested":"6eQKe","common/api/v1/types":"3qemx","../../redux/actions/outputsActions":"alMzI","../../redux/actions/applianceActions":"TaoIu","../../redux/actions/inputsActions":"l0Ua8","../../utils":"342UB","lodash/isEqual":"3mRdp","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bvXIN":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("423bc17fb2bb4461").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("bba858a0bde4ef9d"));
var _jsxRuntime = require("d3ea18e4f8815e7e");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "8"
}), 'FiberManualRecord');

},{"423bc17fb2bb4461":"kZ6eK","bba858a0bde4ef9d":"2vOnF","d3ea18e4f8815e7e":"1dlk8"}],"Vffg8":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("b0c4780e97abf16e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("3df12e76ade01f40"));
var _jsxRuntime = require("7969afc8552751f3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6m0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8"
}), 'FiberManualRecordOutlined');

},{"b0c4780e97abf16e":"kZ6eK","3df12e76ade01f40":"2vOnF","7969afc8552751f3":"1dlk8"}],"lwjKU":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("e7db3f0ec217ef46").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("618f2d7beb8ff2a2"));
var _jsxRuntime = require("f254aa140b1e83e3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5m-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3z"
}), 'LinkOff');

},{"e7db3f0ec217ef46":"kZ6eK","618f2d7beb8ff2a2":"2vOnF","f254aa140b1e83e3":"1dlk8"}],"5MdQE":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("c5d9eaad24bdc35a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("a779490eccafeefc"));
var _jsxRuntime = require("2399bf48c46cb5b0");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M17 20.41 18.41 19 15 15.59 13.59 17zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5z"
}), 'CallMerge');

},{"c5d9eaad24bdc35a":"kZ6eK","a779490eccafeefc":"2vOnF","2399bf48c46cb5b0":"1dlk8"}],"kdfbz":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("f429d0ba5db7240d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("26dba04043ec496"));
var _jsxRuntime = require("dc63da8d07ad7d6b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m21 6.5-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18zM3.27 2 2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73z"
}), 'VideocamOff');

},{"f429d0ba5db7240d":"kZ6eK","26dba04043ec496":"2vOnF","dc63da8d07ad7d6b":"1dlk8"}],"6eQKe":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("5f35d41357fc3d4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("5f8465ef319fbbb6"));
var _jsxRuntime = require("4e943ab09e24ae82");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20m6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9"
}), 'NotInterested');

},{"5f35d41357fc3d4":"kZ6eK","5f8465ef319fbbb6":"2vOnF","4e943ab09e24ae82":"1dlk8"}],"3mRdp":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"hrIE8"}],"5Q8KF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThumbnailTooltip", ()=>ThumbnailTooltip);
parcelHelpers.export(exports, "NonSubscribingThumbnail", ()=>NonSubscribingThumbnail);
parcelHelpers.export(exports, "AdCreativeThumbnail", ()=>AdCreativeThumbnail);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("@mui/material/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _notInterested = require("@mui/icons-material/NotInterested");
var _notInterestedDefault = parcelHelpers.interopDefault(_notInterested);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _types = require("common/api/v1/types");
var _thumbWaitingSvg = require("../../img/thumb-waiting.svg");
var _thumbWaitingSvgDefault = parcelHelpers.interopDefault(_thumbWaitingSvg);
var _outputsActions = require("../../redux/actions/outputsActions");
var _thumbnailFetcher = require("../../thumbnail/ThumbnailFetcher");
var _contentDialog = require("./ContentDialog");
var _preview = require("./Preview");
var _helpers = require("common/api/v1/helpers");
var _rist = require("common/rist");
var ThumbnailTooltip = /*#__PURE__*/ function(ThumbnailTooltip) {
    ThumbnailTooltip["PreviewNotEnabled"] = "Preview not enabled";
    ThumbnailTooltip["PreviewNotSupported"] = "Preview not supported";
    ThumbnailTooltip["OutputDisabled"] = "Output disabled";
    ThumbnailTooltip["InputDisabled"] = "Input disabled";
    ThumbnailTooltip["NoVideo"] = "No video";
    ThumbnailTooltip["OutputHealthNotOk"] = "Output health not OK";
    ThumbnailTooltip["NoInput"] = "No input";
    ThumbnailTooltip["ThumbnailsDisabled"] = "Thumbnails disabled";
    ThumbnailTooltip["ClickToPreview"] = "Click to preview";
    ThumbnailTooltip["NotAuthorizedToPreview"] = "Not authorized to preview";
    ThumbnailTooltip["CodecNotSupported"] = "Codec not supported";
    ThumbnailTooltip["Pending"] = "Pending";
    return ThumbnailTooltip;
}({});
const styles = {
    wrapper: {
        width: '100%',
        height: 0,
        position: 'relative',
        paddingTop: '56.25%'
    },
    container: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'absolute'
    },
    iconContainer: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    common: {
        maxWidth: '100%',
        maxHeight: '100%',
        width: '100%',
        height: '100%'
    },
    img: {
        position: 'absolute',
        top: 0,
        left: 0,
        transition: `opacity 1s`
    },
    videoModalButton: {
        width: '100%',
        height: '100%'
    }
};
const EdgeThumbnailingSupportedCodecs = [
    (0, _helpers.ElementaryStreamTypeName).h264,
    (0, _helpers.ElementaryStreamTypeName).h265,
    (0, _helpers.ElementaryStreamTypeName).h262,
    (0, _helpers.ElementaryStreamTypeName).jpegxs
];
const Thumbnail = ({ input, initialOutput, linkToPlaylist = true, channelId, shouldHaveTopMargin = false, ageOverlayThreshold })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const outputId = initialOutput?.id;
    (0, _react.useEffect)(()=>{
        if (outputId) dispatch((0, _outputsActions.registerOutputObserver)({
            outputIds: [
                outputId
            ]
        }));
        return ()=>{
            if (outputId) dispatch((0, _outputsActions.unregisterOutputObserver)({
                outputIds: [
                    outputId
                ]
            }));
        };
    }, [
        outputId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NonSubscribingThumbnail, {
        input: input,
        initialOutput: initialOutput,
        linkToPlaylist: linkToPlaylist,
        channelId: channelId,
        shouldHaveTopMargin: shouldHaveTopMargin,
        ageOverlayThreshold: ageOverlayThreshold
    });
};
const NonSubscribingThumbnail = ({ input, initialOutput, linkToPlaylist = true, channelId, shouldHaveTopMargin = false, ageOverlayThreshold })=>{
    const imgProps = {
        style: {
            ...styles.common,
            ...styles.img
        },
        alt: 'stream preview thumbnail',
        draggable: false,
        'data-anchor': 'thumbnail'
    };
    const output = (0, _reactRedux.useSelector)(({ outputsReducer })=>{
        const o = outputsReducer.observedOutputs.find((o)=>o.id === initialOutput?.id);
        return o ? {
            id: o.id,
            health: o.health,
            adminStatus: o.adminStatus,
            metrics: o.metrics
        } : undefined;
    }, (0, _isEqualDefault.default)) ?? initialOutput;
    // Get active channelId for Output if Output is set
    if (output !== undefined) channelId = output.metrics?.ristMetrics?.find((metric)=>metric.type === (0, _types.RistMetricType).channel && metric.state === (0, _rist.ChannelState).activated)?.channelId;
    // Otherwise get active channelId for the Input if no override is set
    if (channelId === undefined) channelId = input?.metrics?.ristMetrics?.find((metric)=>metric.type === (0, _types.RistMetricType).channel && metric.state === (0, _rist.ChannelState).activated)?.channelId;
    const isInputDisabled = input?.adminStatus === (0, _types.InputAdminStatus).off;
    const isOutputDisabled = output?.adminStatus == (0, _types.OutputAdminStatus).off;
    const isTr101290Enabled = input?.tr101290Enabled !== false // TR101290 is most likely disabled due to the transport protocol being something else than MPEG-TS (meaning that no (Av)TsInfo is available).
    ;
    const isThumbnailGenerationDisabled = input?.thumbnailMode === (0, _types.ThumbnailMode).none;
    const pids = (0, _helpers.getInputPidsOnInputAppliance)(input, channelId);
    const { hasMpegTsAudio, hasMpegTsVideo } = (0, _helpers.getTransportStreamContentInfo)(pids);
    const videoCodec = (0, _helpers.getVideoCodecFromPids)(pids);
    const isEdgeThumbnailingVideoCodecNotSupported = input?.thumbnailMode === (0, _types.ThumbnailMode).edge && videoCodec && !EdgeThumbnailingSupportedCodecs.includes(videoCodec);
    const getComponent = ()=>{
        const tooltipIfPreviewable = (text)=>linkToPlaylist ? text : undefined;
        if (isOutputDisabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DisabledView, {
            tooltipText: tooltipIfPreviewable("Output disabled")
        });
        if (isInputDisabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DisabledView, {
            tooltipText: tooltipIfPreviewable("Input disabled")
        });
        if (input === undefined || channelId === undefined) // If an enabled Output doesn't have any Input configured
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoInputImage, {});
        // Show no thumbnail if TS-info is enabled and there are no streams in the info
        if (!hasMpegTsVideo && !hasMpegTsAudio && isTr101290Enabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoThumbnailView, {
            tooltipText: tooltipIfPreviewable("No video"),
            imageProperties: imgProps
        });
        // If output is provided check that it's healthy otherwise show disabled
        if (output !== undefined) {
            const isOutputHealthy = output.health && [
                (0, _types.OutputOperStatus).allOk,
                (0, _types.OutputOperStatus).notAcknowledged,
                (0, _types.OutputOperStatus).reducedRedundancy,
                (0, _types.OutputOperStatus).tr101290Priority1Error
            ].includes(output.health.state);
            if (!isOutputHealthy) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DisabledView, {
                tooltipText: tooltipIfPreviewable("Output health not OK")
            });
        }
        const previewMode = input.previewSettings?.mode || (0, _types.VideoPreviewMode).ondemand;
        // Show audio only view if there are audio but no video. If both are false it may be that there are no TS-info, then fallback to video
        if (hasMpegTsAudio && !hasMpegTsVideo) {
            if (isThumbnailGenerationDisabled) // Thumbnails are not relevant for audio-only streams. Therefore, show audio only image with tooltip 'preview not enabled'
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AudioOnlyView, {
                tooltipText: tooltipIfPreviewable("Preview not enabled"),
                imageProperties: imgProps
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbnailAudioView, {
                input: input,
                linkToPlaylist: linkToPlaylist,
                previewMode: previewMode,
                imageProperties: imgProps
            });
        }
        if (isThumbnailGenerationDisabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoThumbnailView, {
            tooltipText: tooltipIfPreviewable("Thumbnails disabled"),
            imageProperties: imgProps
        });
        if (isEdgeThumbnailingVideoCodecNotSupported) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoThumbnailView, {
            tooltipText: "Codec not supported",
            imageProperties: imgProps
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbnailVideoView, {
            input: input,
            channelId: channelId,
            previewMode: previewMode,
            linkToPlaylist: linkToPlaylist,
            imageProperties: imgProps,
            ageOverlayThreshold: ageOverlayThreshold
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            ...styles.wrapper,
            marginTop: shouldHaveTopMargin ? '8px' : 0
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.container,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: styles.common,
                children: getComponent()
            })
        })
    });
};
const AdCreativeThumbnail = ({ adCreative })=>{
    const thumbnail = (adCreative)=>{
        if (!adCreative) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoInputImage, {});
        if (adCreative.status === (0, _types.AdCreativeStatus).active) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.iconContainer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: adCreative.thumbnailUrl,
                alt: "Thumbnail",
                style: {
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover'
                }
            })
        });
        if (adCreative.status === (0, _types.AdCreativeStatus).pending) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pending, {});
        if (adCreative.status === (0, _types.AdCreativeStatus).probeFailed || adCreative.status === (0, _types.AdCreativeStatus).thumbnailFailed || adCreative.status === (0, _types.AdCreativeStatus).uploadFailed) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoInputImage, {});
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoInputImage, {});
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            ...styles.wrapper
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.container,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: styles.common,
                children: thumbnail(adCreative)
            })
        })
    });
};
const ThumbnailAudioView = ({ input, previewMode, imageProperties, linkToPlaylist: linkToPlaylist = true })=>{
    const inputId = input.id;
    const tsInfo = input.tsInfo?.[0];
    const audioCodec = tsInfo ? (0, _helpers.getAudioCodec)(tsInfo) : null;
    const isMptsInput = (0, _helpers.isMpts)(input.tsInfo);
    const supportedCodecs = [
        (0, _helpers.ElementaryStreamTypeName).adtsAac,
        (0, _helpers.ElementaryStreamTypeName).mpeg1,
        (0, _helpers.ElementaryStreamTypeName).mpeg2
    ];
    const isPlayable = !isMptsInput && audioCodec !== null && supportedCodecs.includes(audioCodec);
    const isPreviewEnabled = previewMode === (0, _types.VideoPreviewMode).ondemand || previewMode === (0, _types.VideoPreviewMode).alwayson;
    const authorizedToPreview = input.canSubscribe;
    const { actions: { handleOpen } } = (0, _react.useContext)((0, _contentDialog.ContentDialogContext));
    const getImage = (tooltip)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AudioOnlyView, {
            tooltipText: tooltip,
            imageProperties: imageProperties
        });
    };
    if (!linkToPlaylist) // Not supposed to be previewable/clickable by the context the component is used in
    return getImage();
    if (!authorizedToPreview) // EDGE-3409. If input has been shared from another group with preview only access
    // Preview only access means the the user doesn't have access to the stream data and therefore HLS preview isn't allowed
    return getImage("Not authorized to preview");
    if (!isPreviewEnabled) return getImage("Preview not enabled");
    if (!isPlayable) return getImage("Preview not supported");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        sx: styles.videoModalButton,
        onClick: ()=>{
            handleOpen(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _preview.Preview), {
                inputId: inputId,
                isOnDemand: previewMode === (0, _types.VideoPreviewMode).ondemand,
                isAudioOnly: true
            }), `Input: ${input.name}`);
        },
        children: getImage("Click to preview")
    });
};
const ThumbnailVideoView = ({ input, channelId, previewMode, imageProperties, linkToPlaylist: linkToPlaylist = true, ageOverlayThreshold })=>{
    const inputId = input.id;
    const { thumbnailMode } = input;
    const path = thumbnailMode === (0, _types.ThumbnailMode).core ? `thumb/${input.id}` : `thumbnailer/${channelId.toString()}`;
    const thumbnails = (0, _reactRedux.useSelector)(({ thumbnailReducer })=>thumbnailReducer.thumbnails);
    const cachedThumbnail = thumbnails[path];
    const thumbnail = (0, _thumbnailFetcher.ThumbnailFetcher).isThumbnailStale(cachedThumbnail) ? undefined : cachedThumbnail;
    const FETCH_INTERVAL_MS = 3000;
    const thumbTsInfo = input.tsInfo?.filter((t)=>t.applianceType === (0, _types.ApplianceType).thumb)?.sort((a, b)=>(a.channelId ?? 0) - (b.channelId ?? 0))?.[0];
    const videoCodec = thumbTsInfo ? (0, _helpers.getVideoCodec)(thumbTsInfo) : null;
    const isMptsInput = (0, _helpers.isMpts)(input.tsInfo);
    const supportedCodecs = [
        (0, _helpers.ElementaryStreamTypeName).h264
    ];
    const isPlayable = !isMptsInput && videoCodec !== null && supportedCodecs.includes(videoCodec);
    const isPreviewEnabled = previewMode === (0, _types.VideoPreviewMode).ondemand || previewMode === (0, _types.VideoPreviewMode).alwayson;
    const authorizedToPreview = input.canSubscribe;
    const { actions: { handleOpen } } = (0, _react.useContext)((0, _contentDialog.ContentDialogContext));
    (0, _react.useEffect)(()=>{
        (0, _thumbnailFetcher.ThumbnailFetcher).fetchThumbnailWithPath(path) // Fetch once initially
        ;
        const intervalId = setInterval(()=>{
            (0, _thumbnailFetcher.ThumbnailFetcher).fetchThumbnailWithPath(path);
        }, FETCH_INTERVAL_MS);
        return ()=>clearInterval(intervalId);
    }, [
        input
    ]);
    const [thumbAge, setThumbAge] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            if (thumbnail) setThumbAge(new Date().getTime() - thumbnail.serverLastModified.getTime());
            else setThumbAge(0);
        }, 250);
        return ()=>clearInterval(intervalId);
    }, [
        thumbnail
    ]);
    const shouldRenderAgeOverlay = !!thumbAge && ageOverlayThreshold !== undefined && thumbAge > ageOverlayThreshold;
    const getImage = (tooltip)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitioningImage, {
                    src: thumbnail?.url,
                    errorSrc: (0, _thumbWaitingSvgDefault.default),
                    tooltipText: tooltip,
                    imageProperties: imageProperties
                }),
                shouldRenderAgeOverlay && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    position: "absolute",
                    bottom: "0",
                    right: "0",
                    bgcolor: "rgba(0, 0, 0, 0.5)" // Slightly grayed-out background
                    ,
                    color: "white" // Text color
                    ,
                    padding: "4px",
                    textAlign: "center",
                    children: [
                        Math.floor(thumbAge / 1000),
                        "s ago"
                    ]
                })
            ]
        });
    };
    if (!linkToPlaylist) // Not supposed to be previewable/clickable by the context the component is used in
    return getImage();
    if (!authorizedToPreview) // EDGE-3409. If input has been shared from another group with preview only access
    // Preview only access means the the user doesn't have access to the stream data and therefore HLS preview isn't allowed
    return getImage("Not authorized to preview");
    if (!isPreviewEnabled) return getImage("Preview not enabled");
    if (!isPlayable) return getImage("Preview not supported");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        sx: styles.videoModalButton,
        onClick: ()=>{
            handleOpen(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _preview.Preview), {
                inputId: inputId,
                thumbnailUrl: thumbnail?.url,
                isOnDemand: previewMode === (0, _types.VideoPreviewMode).ondemand,
                isAudioOnly: false
            }), `Input: ${input.name}`);
        },
        children: getImage("Click to preview")
    });
};
const TransitioningImage = ({ src, errorSrc, tooltipText, imageProperties })=>{
    const [rearSrc, setRearSrc] = (0, _react.useState)(src ?? errorSrc);
    const [frontSrc, setFrontSrc] = (0, _react.useState)(src ?? errorSrc);
    const [frontOpacity, setFrontOpacity] = (0, _react.useState)(0);
    const tooltipHidden = tooltipText === undefined;
    const tooltipTitle = tooltipText ?? '';
    (0, _react.useEffect)(()=>{
        const nextFrontOpacity = frontOpacity === 0 ? 1 : 0;
        const setSrcFn = nextFrontOpacity === 0 ? setRearSrc : setFrontSrc;
        if (src) setSrcFn(src);
        else {
            setRearSrc(errorSrc);
            setFrontSrc(errorSrc);
        }
        setFrontOpacity(nextFrontOpacity);
    }, [
        src
    ]) // Only re-run the effect if 'src' changes
    ;
    // Change front image opacity according to state
    const rearProps = {
        ...imageProperties
    };
    const frontProps = {
        ...imageProperties,
        style: {
            ...imageProperties.style,
            opacity: frontOpacity
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: tooltipTitle,
        hidden: tooltipHidden,
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            sx: styles.iconContainer,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    "data-testid": "transitioning-image-rear",
                    src: rearSrc,
                    onError: ()=>setRearSrc(errorSrc),
                    ...rearProps
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    "data-testid": "transitioning-image-front",
                    src: frontSrc,
                    onError: ()=>setFrontSrc(errorSrc),
                    ...frontProps
                })
            ]
        })
    });
};
const Pending = ()=>{
    const imgProps = {
        style: {
            ...styles.common,
            ...styles.img
        },
        alt: 'pending',
        draggable: false,
        'data-anchor': 'thumbnail'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: styles.wrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.container,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: styles.common,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PendingThumbnailView, {
                    imageProperties: imgProps
                })
            })
        })
    });
};
const NoInputImage = ()=>{
    const imgProps = {
        style: {
            ...styles.common,
            ...styles.img
        },
        alt: 'no input',
        draggable: false,
        'data-anchor': 'thumbnail'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: styles.wrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: styles.container,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: styles.common,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoThumbnailView, {
                    tooltipText: "No input",
                    imageProperties: imgProps
                })
            })
        })
    });
};
const DisabledView = ({ tooltipText })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: styles.iconContainer,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
            title: tooltipText,
            placement: "top",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notInterestedDefault.default), {
                    color: "disabled"
                })
            })
        })
    });
};
const PendingThumbnailView = ({ tooltipText, imageProperties })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbnailView, {
        text: "PENDING",
        tooltipText: tooltipText,
        imageProperties: imageProperties
    });
};
const NoThumbnailView = ({ tooltipText, imageProperties })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbnailView, {
        text: "NO THUMBNAIL",
        tooltipText: tooltipText,
        imageProperties: imageProperties
    });
};
const AudioOnlyView = ({ tooltipText, imageProperties })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbnailView, {
        text: "AUDIO ONLY",
        tooltipText: tooltipText,
        imageProperties: imageProperties
    });
};
const ThumbnailView = ({ text, tooltipText, imageProperties })=>{
    const tooltipHidden = tooltipText === undefined;
    const tooltipTitle = tooltipText ?? '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: styles.iconContainer,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
            title: tooltipTitle,
            placement: "top",
            hidden: tooltipHidden,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: "534",
                    height: "300",
                    viewBox: "0 0 534 300",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...imageProperties,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: "534",
                            height: "300",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: "534",
                            height: "300",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            x: "50%",
                            y: "50%",
                            textAnchor: "middle",
                            fill: "white",
                            fontFamily: "Roboto",
                            fontSize: "50",
                            fontWeight: "bold",
                            letterSpacing: "7",
                            children: text
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M91 181H442",
                            stroke: "white",
                            strokeWidth: "6",
                            strokeDasharray: "25 15"
                        })
                    ]
                })
            })
        })
    });
};
exports.default = Thumbnail;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Icon":"cqMA1","./Tooltip":"crjvg","@mui/icons-material/NotInterested":"6eQKe","lodash/isEqual":"3mRdp","common/api/v1/types":"3qemx","../../img/thumb-waiting.svg":"btZso","../../redux/actions/outputsActions":"alMzI","../../thumbnail/ThumbnailFetcher":"3OAtq","./ContentDialog":"5kpCR","./Preview":"58Cok","common/api/v1/helpers":"6jovr","common/rist":"eyUJa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cqMA1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("4e82eff62e9f7438").default;
var _interopRequireDefault = require("f31a2d534b4f87ab").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    iconClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Icon.default;
    }
});
Object.defineProperty(exports, "iconClasses", {
    enumerable: true,
    get: function() {
        return _iconClasses.default;
    }
});
var _Icon = _interopRequireDefault(require("b18017f5590ad53"));
var _iconClasses = _interopRequireWildcard(require("dd02719a553803b3"));
Object.keys(_iconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _iconClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _iconClasses[key];
        }
    });
});

},{"4e82eff62e9f7438":"fiRIh","f31a2d534b4f87ab":"kZ6eK","b18017f5590ad53":"iW2Nx","dd02719a553803b3":"7zDxe"}],"iW2Nx":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a654a3fa2da7112b").default;
var _interopRequireWildcard = require("8d2cdaef4b2bf0fb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("4b1d9c6b2e732bc2"));
var _propTypes = _interopRequireDefault(require("1cd085386d86ba4f"));
var _clsx = _interopRequireDefault(require("953aad68eddfbc88"));
var _composeClasses = _interopRequireDefault(require("a6caa0568c58072f"));
var _capitalize = _interopRequireDefault(require("bdeb65291d69a828"));
var _zeroStyled = require("f596e00d4d3d1a28");
var _memoTheme = _interopRequireDefault(require("95d207bfb0b14728"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("5485f7f7d3f9a850"));
var _DefaultPropsProvider = require("7fd391165c3a4a7a");
var _iconClasses = require("f70c4e5dcae3af31");
var _jsxRuntime = require("799d7e999303b974");
const useUtilityClasses = (ownerState)=>{
    const { color, fontSize, classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, _capitalize.default)(color)}`,
            `fontSize${(0, _capitalize.default)(fontSize)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _iconClasses.getIconUtilityClass, classes);
};
const IconRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, _capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        // Chrome fix for https://issues.chromium.org/issues/41375697
        // To remove at some point.
        overflow: 'hidden',
        display: 'inline-block',
        // allow overflow hidden to take action
        textAlign: 'center',
        // support non-square icon
        flexShrink: 0,
        variants: [
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(20)
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography.pxToRem(24)
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(36)
                }
            },
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars || theme).palette.action.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const Icon = /*#__PURE__*/ React.forwardRef(function Icon(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiIcon'
    });
    const { baseClassName = 'material-icons', className, color = 'inherit', component: Component = 'span', fontSize = 'medium', ...other } = props;
    const ownerState = {
        ...props,
        baseClassName,
        color,
        component: Component,
        fontSize
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconRoot, {
        as: Component,
        className: (0, _clsx.default)(baseClassName, // Prevent the translation of the text content.
        // The font relies on the exact text content to render the icon.
        'notranslate', classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref,
        ...other
    });
});
Icon.muiName = 'Icon';
var _default = exports.default = Icon;

},{"a654a3fa2da7112b":"kZ6eK","8d2cdaef4b2bf0fb":"fiRIh","4b1d9c6b2e732bc2":"9njXz","1cd085386d86ba4f":"bnNSm","953aad68eddfbc88":"d2NWs","a6caa0568c58072f":"59Equ","bdeb65291d69a828":"eOYSA","f596e00d4d3d1a28":"hZXDo","95d207bfb0b14728":"cJNjb","5485f7f7d3f9a850":"2r5WG","7fd391165c3a4a7a":"9bD8g","f70c4e5dcae3af31":"7zDxe","799d7e999303b974":"1dlk8"}],"7zDxe":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5f5679ac37367ffe").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getIconUtilityClass = getIconUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("2601df9433a96cd5"));
var _generateUtilityClass = _interopRequireDefault(require("836d7a3c883bd288"));
function getIconUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiIcon', slot);
}
const iconClasses = (0, _generateUtilityClasses.default)('MuiIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var _default = exports.default = iconClasses;

},{"5f5679ac37367ffe":"kZ6eK","2601df9433a96cd5":"7pSUk","836d7a3c883bd288":"jBs9M"}],"btZso":[function(require,module,exports,__globalThis) {
module.exports = require("987807864a2e8587").getBundleURL('7YEHs') + "thumb-waiting.6bede8ca.svg";

},{"987807864a2e8587":"a2ypy"}],"5kpCR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultContextValue", ()=>defaultContextValue);
parcelHelpers.export(exports, "ContentDialogContext", ()=>ContentDialogContext);
parcelHelpers.export(exports, "ContentDialogProvider", ()=>ContentDialogProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
const styles = {
    title: {
        margin: 0,
        padding: (theme)=>theme.spacing(2)
    },
    closeButton: {
        position: 'absolute',
        right: (theme)=>theme.spacing(1),
        top: (theme)=>theme.spacing(1),
        color: (theme)=>theme.palette.grey[500]
    },
    content: {
        padding: (theme)=>theme.spacing(0, 2, 2, 2)
    }
};
const defaultContextValue = {
    state: {
        isOpen: false,
        comp: undefined,
        title: ''
    },
    actions: {
        handleOpen: ()=>undefined,
        handleClose: ()=>undefined
    }
};
const ContentDialogContext = /*#__PURE__*/ (0, _react.createContext)(defaultContextValue);
const ContentDialogProvider = ({ children })=>{
    const defaultState = defaultContextValue.state;
    const [state, setState] = (0, _react.useState)(defaultState);
    const handleOpen = (comp, title)=>{
        setState((s)=>({
                ...s,
                isOpen: true,
                comp,
                title
            }));
    };
    const handleClose = ()=>{
        setState((s)=>({
                ...s,
                isOpen: false
            }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ContentDialogContext.Provider, {
        value: {
            state: state,
            actions: {
                handleOpen,
                handleClose
            }
        },
        children: [
            children,
            state.isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
                open: state.isOpen,
                disableRestoreFocus: true,
                onClose: (_event, reason)=>{
                    if (reason === 'escapeKeyDown') handleClose();
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTitleDefault.default), {
                        sx: styles.title,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h4",
                                component: "span",
                                children: state.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                "aria-label": "close",
                                sx: styles.closeButton,
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: styles.content,
                        children: state.comp
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Dialog":"aOxpM","@mui/material/DialogTitle":"5aNce","@mui/material/IconButton":"488As","@mui/material/Typography":"6NtGx","@mui/icons-material/Close":"acjz6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5aNce":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7129050f8644c29f").default;
var _interopRequireDefault = require("925305be2f1466b6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    dialogTitleClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DialogTitle.default;
    }
});
Object.defineProperty(exports, "dialogTitleClasses", {
    enumerable: true,
    get: function() {
        return _dialogTitleClasses.default;
    }
});
var _DialogTitle = _interopRequireDefault(require("1e41e1bbaf1c458e"));
var _dialogTitleClasses = _interopRequireWildcard(require("8124a56ee13926ea"));
Object.keys(_dialogTitleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _dialogTitleClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _dialogTitleClasses[key];
        }
    });
});

},{"7129050f8644c29f":"fiRIh","925305be2f1466b6":"kZ6eK","1e41e1bbaf1c458e":"ahV7y","8124a56ee13926ea":"7xkge"}],"ahV7y":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2d717e5119fca5df").default;
var _interopRequireWildcard = require("21dc64169f20a2d9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("8a453d434371e7e2"));
var _propTypes = _interopRequireDefault(require("f1758f90fdb0555c"));
var _clsx = _interopRequireDefault(require("e5a593a75c65968b"));
var _composeClasses = _interopRequireDefault(require("ea18aa21b1191236"));
var _Typography = _interopRequireDefault(require("6ecd32a46fb5e56a"));
var _zeroStyled = require("276c60616f234b18");
var _DefaultPropsProvider = require("45ad4c5c2f471751");
var _dialogTitleClasses = require("f1ae3ffec7fe7bf9");
var _DialogContext = _interopRequireDefault(require("4142a39ab48b5654"));
var _jsxRuntime = require("a55b393b7f3cf541");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _dialogTitleClasses.getDialogTitleUtilityClass, classes);
};
const DialogTitleRoot = (0, _zeroStyled.styled)(_Typography.default, {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const DialogTitle = /*#__PURE__*/ React.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const { titleId = idProp } = React.useContext(_DialogContext.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogTitleRoot, {
        component: "h2",
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var _default = exports.default = DialogTitle;

},{"2d717e5119fca5df":"kZ6eK","21dc64169f20a2d9":"fiRIh","8a453d434371e7e2":"9njXz","f1758f90fdb0555c":"bnNSm","e5a593a75c65968b":"d2NWs","ea18aa21b1191236":"59Equ","6ecd32a46fb5e56a":"6NtGx","276c60616f234b18":"hZXDo","45ad4c5c2f471751":"9bD8g","f1ae3ffec7fe7bf9":"7xkge","4142a39ab48b5654":"9TzT8","a55b393b7f3cf541":"1dlk8"}],"58Cok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Preview", ()=>Preview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _store = require("../../store");
var _video = require("./Video");
var _fetch = require("../../utils/fetch");
var _mixpanel = require("../../mixpanel");
const styles = {
    videoWrapper: {
        width: '500px',
        height: '290px'
    },
    previewWrapper: {
        textAlign: 'center'
    }
};
const PREVIEW_KEEPALIVE_INTERVAL = 3000;
const PREVIEW_PLAYLIST_READY_CHECK_INTERVAL = 500;
const PreviewLoading = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.previewWrapper,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Preparing preview..."
            })
        ]
    });
};
const Preview = ({ inputId, thumbnailUrl, isOnDemand, isAudioOnly, height, width })=>{
    const [playlistReady, setPlaylistReady] = (0, _react.useState)(false);
    const playlistUrl = `/hls/${inputId}/playlist.m3u8`;
    const initiallyMuted = !isAudioOnly;
    (0, _mixpanel.useComponentTracking)({
        component: 'Preview',
        isAudioOnly,
        isOnDemand
    });
    (0, _react.useEffect)(()=>{
        if (isOnDemand) {
            // enable generating preview and keep it alive
            const feedWatchdog = ()=>(0, _store.Api).inputApi.enableInputPreview(inputId);
            feedWatchdog();
            const interval = setInterval(()=>{
                feedWatchdog();
            }, PREVIEW_KEEPALIVE_INTERVAL);
            return ()=>clearInterval(interval);
        }
    }, [
        isOnDemand
    ]);
    (0, _react.useEffect)(()=>{
        const checkPlaylistReady = ()=>{
            return (0, _fetch.fetch)(playlistUrl, {
                method: 'HEAD'
            }).then(()=>{
                setPlaylistReady(true);
                return true;
            }).catch(()=>false);
        };
        checkPlaylistReady();
        const interval = setInterval(()=>{
            if (playlistReady) {
                clearInterval(interval);
                return;
            }
            checkPlaylistReady().then((res)=>{
                if (res) clearInterval(interval);
            });
        }, PREVIEW_PLAYLIST_READY_CHECK_INTERVAL);
        return ()=>clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: width && height ? {
            width,
            height
        } : styles.videoWrapper,
        children: playlistReady ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _video.Video), {
            url: playlistUrl,
            poster: thumbnailUrl,
            autoplay: true,
            initiallyMuted: initiallyMuted
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PreviewLoading, {})
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/CircularProgress":"kEtIR","../../store":"5LXiG","./Video":"5BXU9","../../utils/fetch":"bwcMB","../../mixpanel":"7xxdr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5BXU9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Video", ()=>Video);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hlsplayer = require("../../hlsplayer");
var _hlsplayerDefault = parcelHelpers.interopDefault(_hlsplayer);
var _logger = require("../../logger");
const log = (0, _logger.getLogger)('video');
const Video = ({ url, poster, autoplay, initiallyMuted })=>{
    const videoRef = (0, _react.useRef)(null);
    const [player, setPlayer] = (0, _react.useState)();
    (0, _react.useEffect)(()=>{
        const videoEl = videoRef.current;
        if (!videoEl) return;
        if ((0, _hlsplayerDefault.default).isSupported() && !player) setPlayer(new (0, _hlsplayerDefault.default)(videoEl));
        player?.load(url).then(()=>{
            log(`Video url ${url} loaded`);
            if (autoplay) videoEl.play();
        });
        return ()=>{
            player?.destroy();
        };
    }, [
        url,
        player,
        videoRef?.current
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
        style: {
            width: '100%',
            height: '100%'
        },
        ref: videoRef,
        poster: poster,
        controls: true,
        autoPlay: autoplay,
        muted: initiallyMuted
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../hlsplayer":"amtOh","../../logger":"7sPvG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"amtOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hlsJs = require("hls.js");
var _hlsJsDefault = parcelHelpers.interopDefault(_hlsJs);
var _localstorage = require("./localstorage");
var _logger = require("./logger");
const log = (0, _logger.getLogger)('hlsplayer');
const debugVal = (0, _localstorage.getItem)('hls_player_debug');
const debug = !!(debugVal && debugVal !== '0');
class HlsPlayer {
    constructor(videoEl){
        this.videoEl = videoEl;
        this.hls = null;
        this.isNative = HlsPlayer.nativeHls();
        if (this.isNative) return;
        this.hls = new (0, _hlsJsDefault.default)({
            // No need to show duration for live content in native controls
            liveDurationInfinity: true,
            debug
        });
        this.hls.on((0, _hlsJsDefault.default).Events.ERROR, (event, data)=>{
            log(event, data);
            if (data.fatal) switch(data.type){
                case (0, _hlsJsDefault.default).ErrorTypes.NETWORK_ERROR:
                    this.hls?.startLoad();
                    break;
                case (0, _hlsJsDefault.default).ErrorTypes.MEDIA_ERROR:
                    this.hls?.recoverMediaError();
                    break;
                default:
                    break;
            }
        });
        this.hls.on((0, _hlsJsDefault.default).Events.LEVEL_LOADED, (event, data)=>{
            log(event, data);
        });
        this.hls.on((0, _hlsJsDefault.default).Events.FRAG_LOADED, (event, data)=>{
            log(event, data);
        });
        this.hls.on((0, _hlsJsDefault.default).Events.MEDIA_ATTACHED, function(event, data) {
            log(event, data);
        });
        this.hls.on((0, _hlsJsDefault.default).Events.MANIFEST_PARSED, function(event, data) {
            log(event, data);
        });
        this.hls.on((0, _hlsJsDefault.default).Events.FRAG_PARSING_INIT_SEGMENT, function(event, data) {
            log(event, data);
        });
        this.hls.on((0, _hlsJsDefault.default).Events.BUFFER_CODECS, function(event, data) {
            log(event, data);
        });
    }
    static nativeHls() {
        const video = document.createElement('video');
        return video.canPlayType('application/vnd.apple.mpegURL') !== '';
    }
    static isSupported() {
        return HlsPlayer.nativeHls() || (0, _hlsJsDefault.default).isSupported();
    }
    async load(src) {
        const hls = this.hls;
        if (!hls) {
            this.videoEl.setAttribute('src', src);
            return;
        }
        return new Promise((resolve)=>{
            hls.loadSource(src);
            hls.attachMedia(this.videoEl);
            hls.on((0, _hlsJsDefault.default).Events.MANIFEST_PARSED, function parseListener() {
                hls.off((0, _hlsJsDefault.default).Events.MANIFEST_PARSED, parseListener);
                resolve(undefined);
            });
        });
    }
    play() {
        return this.videoEl.play();
    }
    destroy() {
        this.hls?.destroy();
    }
}
exports.default = HlsPlayer;

},{"hls.js":"8EfLg","./localstorage":"7NDOS","./logger":"7sPvG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8EfLg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbrController", ()=>AbrController);
parcelHelpers.export(exports, "AttrList", ()=>AttrList);
parcelHelpers.export(exports, "AudioStreamController", ()=>AudioStreamController);
parcelHelpers.export(exports, "AudioTrackController", ()=>AudioTrackController);
parcelHelpers.export(exports, "BasePlaylistController", ()=>BasePlaylistController);
parcelHelpers.export(exports, "BaseSegment", ()=>BaseSegment);
parcelHelpers.export(exports, "BaseStreamController", ()=>BaseStreamController);
parcelHelpers.export(exports, "BufferController", ()=>BufferController);
parcelHelpers.export(exports, "CMCDController", ()=>CMCDController);
parcelHelpers.export(exports, "CapLevelController", ()=>CapLevelController);
parcelHelpers.export(exports, "ChunkMetadata", ()=>ChunkMetadata);
parcelHelpers.export(exports, "ContentSteeringController", ()=>ContentSteeringController);
parcelHelpers.export(exports, "DateRange", ()=>DateRange);
parcelHelpers.export(exports, "EMEController", ()=>EMEController);
parcelHelpers.export(exports, "ErrorActionFlags", ()=>ErrorActionFlags);
parcelHelpers.export(exports, "ErrorController", ()=>ErrorController);
parcelHelpers.export(exports, "ErrorDetails", ()=>ErrorDetails);
parcelHelpers.export(exports, "ErrorTypes", ()=>ErrorTypes);
parcelHelpers.export(exports, "Events", ()=>Events);
parcelHelpers.export(exports, "FPSController", ()=>FPSController);
parcelHelpers.export(exports, "Fragment", ()=>Fragment);
parcelHelpers.export(exports, "Hls", ()=>Hls);
parcelHelpers.export(exports, "HlsSkip", ()=>HlsSkip);
parcelHelpers.export(exports, "HlsUrlParameters", ()=>HlsUrlParameters);
parcelHelpers.export(exports, "KeySystemFormats", ()=>KeySystemFormats);
parcelHelpers.export(exports, "KeySystems", ()=>KeySystems);
parcelHelpers.export(exports, "Level", ()=>Level);
parcelHelpers.export(exports, "LevelDetails", ()=>LevelDetails);
parcelHelpers.export(exports, "LevelKey", ()=>LevelKey);
parcelHelpers.export(exports, "LoadStats", ()=>LoadStats);
parcelHelpers.export(exports, "MetadataSchema", ()=>MetadataSchema);
parcelHelpers.export(exports, "NetworkErrorAction", ()=>NetworkErrorAction);
parcelHelpers.export(exports, "Part", ()=>Part);
parcelHelpers.export(exports, "PlaylistLevelType", ()=>PlaylistLevelType);
parcelHelpers.export(exports, "SubtitleStreamController", ()=>SubtitleStreamController);
parcelHelpers.export(exports, "SubtitleTrackController", ()=>SubtitleTrackController);
parcelHelpers.export(exports, "TimelineController", ()=>TimelineController);
parcelHelpers.export(exports, "default", ()=>Hls);
parcelHelpers.export(exports, "getMediaSource", ()=>getMediaSource);
parcelHelpers.export(exports, "isMSESupported", ()=>isMSESupported);
parcelHelpers.export(exports, "isSupported", ()=>isSupported);
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var urlToolkit = {
    exports: {}
};
(function(module, exports) {
    // see https://tools.ietf.org/html/rfc1808
    (function(root) {
        var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
        var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
        var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
        var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
        var URLToolkit = {
            // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
            // E.g
            // With opts.alwaysNormalize = false (default, spec compliant)
            // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
            // With opts.alwaysNormalize = true (not spec compliant)
            // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
            buildAbsoluteURL: function(baseURL, relativeURL, opts) {
                opts = opts || {};
                // remove any remaining space and CRLF
                baseURL = baseURL.trim();
                relativeURL = relativeURL.trim();
                if (!relativeURL) {
                    // 2a) If the embedded URL is entirely empty, it inherits the
                    // entire base URL (i.e., is set equal to the base URL)
                    // and we are done.
                    if (!opts.alwaysNormalize) return baseURL;
                    var basePartsForNormalise = URLToolkit.parseURL(baseURL);
                    if (!basePartsForNormalise) throw new Error('Error trying to parse base URL.');
                    basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
                    return URLToolkit.buildURLFromParts(basePartsForNormalise);
                }
                var relativeParts = URLToolkit.parseURL(relativeURL);
                if (!relativeParts) throw new Error('Error trying to parse relative URL.');
                if (relativeParts.scheme) {
                    // 2b) If the embedded URL starts with a scheme name, it is
                    // interpreted as an absolute URL and we are done.
                    if (!opts.alwaysNormalize) return relativeURL;
                    relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
                    return URLToolkit.buildURLFromParts(relativeParts);
                }
                var baseParts = URLToolkit.parseURL(baseURL);
                if (!baseParts) throw new Error('Error trying to parse base URL.');
                if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
                    // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
                    // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
                    var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
                    baseParts.netLoc = pathParts[1];
                    baseParts.path = pathParts[2];
                }
                if (baseParts.netLoc && !baseParts.path) baseParts.path = '/';
                var builtParts = {
                    // 2c) Otherwise, the embedded URL inherits the scheme of
                    // the base URL.
                    scheme: baseParts.scheme,
                    netLoc: relativeParts.netLoc,
                    path: null,
                    params: relativeParts.params,
                    query: relativeParts.query,
                    fragment: relativeParts.fragment
                };
                if (!relativeParts.netLoc) {
                    // 3) If the embedded URL's <net_loc> is non-empty, we skip to
                    // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
                    // (if any) of the base URL.
                    builtParts.netLoc = baseParts.netLoc;
                    // 4) If the embedded URL path is preceded by a slash "/", the
                    // path is not relative and we skip to Step 7.
                    if (relativeParts.path[0] !== '/') {
                        if (!relativeParts.path) {
                            // 5) If the embedded URL path is empty (and not preceded by a
                            // slash), then the embedded URL inherits the base URL path
                            builtParts.path = baseParts.path;
                            // 5a) if the embedded URL's <params> is non-empty, we skip to
                            // step 7; otherwise, it inherits the <params> of the base
                            // URL (if any) and
                            if (!relativeParts.params) {
                                builtParts.params = baseParts.params;
                                // 5b) if the embedded URL's <query> is non-empty, we skip to
                                // step 7; otherwise, it inherits the <query> of the base
                                // URL (if any) and we skip to step 7.
                                if (!relativeParts.query) builtParts.query = baseParts.query;
                            }
                        } else {
                            // 6) The last segment of the base URL's path (anything
                            // following the rightmost slash "/", or the entire path if no
                            // slash is present) is removed and the embedded URL's path is
                            // appended in its place.
                            var baseURLPath = baseParts.path;
                            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
                            builtParts.path = URLToolkit.normalizePath(newPath);
                        }
                    }
                }
                if (builtParts.path === null) builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
                return URLToolkit.buildURLFromParts(builtParts);
            },
            parseURL: function(url) {
                var parts = URL_REGEX.exec(url);
                if (!parts) return null;
                return {
                    scheme: parts[1] || '',
                    netLoc: parts[2] || '',
                    path: parts[3] || '',
                    params: parts[4] || '',
                    query: parts[5] || '',
                    fragment: parts[6] || ''
                };
            },
            normalizePath: function(path) {
                // The following operations are
                // then applied, in order, to the new path:
                // 6a) All occurrences of "./", where "." is a complete path
                // segment, are removed.
                // 6b) If the path ends with "." as a complete path segment,
                // that "." is removed.
                path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
                // 6c) All occurrences of "<segment>/../", where <segment> is a
                // complete path segment not equal to "..", are removed.
                // Removal of these path segments is performed iteratively,
                // removing the leftmost matching pattern on each iteration,
                // until no matching pattern remains.
                // 6d) If the path ends with "<segment>/..", where <segment> is a
                // complete path segment not equal to "..", that
                // "<segment>/.." is removed.
                while(path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length);
                return path.split('').reverse().join('');
            },
            buildURLFromParts: function(parts) {
                return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
            }
        };
        module.exports = URLToolkit;
    })();
})(urlToolkit);
var urlToolkitExports = urlToolkit.exports;
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// https://caniuse.com/mdn-javascript_builtins_number_isfinite
const isFiniteNumber = Number.isFinite || function(value) {
    return typeof value === 'number' && isFinite(value);
};
// https://caniuse.com/mdn-javascript_builtins_number_issafeinteger
const isSafeInteger = Number.isSafeInteger || function(value) {
    return typeof value === 'number' && Math.abs(value) <= MAX_SAFE_INTEGER;
};
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
let Events = /*#__PURE__*/ function(Events) {
    Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
    Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
    Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
    Events["MEDIA_DETACHED"] = "hlsMediaDetached";
    Events["BUFFER_RESET"] = "hlsBufferReset";
    Events["BUFFER_CODECS"] = "hlsBufferCodecs";
    Events["BUFFER_CREATED"] = "hlsBufferCreated";
    Events["BUFFER_APPENDING"] = "hlsBufferAppending";
    Events["BUFFER_APPENDED"] = "hlsBufferAppended";
    Events["BUFFER_EOS"] = "hlsBufferEos";
    Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
    Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
    Events["MANIFEST_LOADING"] = "hlsManifestLoading";
    Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
    Events["MANIFEST_PARSED"] = "hlsManifestParsed";
    Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
    Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
    Events["LEVEL_LOADING"] = "hlsLevelLoading";
    Events["LEVEL_LOADED"] = "hlsLevelLoaded";
    Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
    Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
    Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
    Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
    Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
    Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
    Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
    Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
    Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
    Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
    Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
    Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
    Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
    Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
    Events["CUES_PARSED"] = "hlsCuesParsed";
    Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
    Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
    Events["FRAG_LOADING"] = "hlsFragLoading";
    Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
    Events["FRAG_LOADED"] = "hlsFragLoaded";
    Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
    Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
    Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
    Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
    Events["FRAG_PARSED"] = "hlsFragParsed";
    Events["FRAG_BUFFERED"] = "hlsFragBuffered";
    Events["FRAG_CHANGED"] = "hlsFragChanged";
    Events["FPS_DROP"] = "hlsFpsDrop";
    Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
    Events["MAX_AUTO_LEVEL_UPDATED"] = "hlsMaxAutoLevelUpdated";
    Events["ERROR"] = "hlsError";
    Events["DESTROYING"] = "hlsDestroying";
    Events["KEY_LOADING"] = "hlsKeyLoading";
    Events["KEY_LOADED"] = "hlsKeyLoaded";
    Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
    Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
    Events["STEERING_MANIFEST_LOADED"] = "hlsSteeringManifestLoaded";
    return Events;
}({});
/**
 * Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
 */ let ErrorTypes = /*#__PURE__*/ function(ErrorTypes) {
    ErrorTypes["NETWORK_ERROR"] = "networkError";
    ErrorTypes["MEDIA_ERROR"] = "mediaError";
    ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
    ErrorTypes["MUX_ERROR"] = "muxError";
    ErrorTypes["OTHER_ERROR"] = "otherError";
    return ErrorTypes;
}({});
let ErrorDetails = /*#__PURE__*/ function(ErrorDetails) {
    ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
    ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
    ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
    ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"] = "keySystemNoConfiguredLicense";
    ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
    ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"] = "keySystemServerCertificateRequestFailed";
    ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"] = "keySystemServerCertificateUpdateFailed";
    ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"] = "keySystemSessionUpdateFailed";
    ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"] = "keySystemStatusOutputRestricted";
    ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"] = "keySystemStatusInternalError";
    ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
    ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
    ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
    ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
    ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
    ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
    ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
    ErrorDetails["LEVEL_PARSING_ERROR"] = "levelParsingError";
    ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
    ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
    ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
    ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
    ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
    ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
    ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
    ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
    ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
    ErrorDetails["FRAG_GAP"] = "fragGap";
    ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
    ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
    ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
    ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
    ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
    ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
    ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
    ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
    ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
    ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
    ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
    ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
    ErrorDetails["INTERNAL_ABORTED"] = "aborted";
    ErrorDetails["UNKNOWN"] = "unknown";
    return ErrorDetails;
}({});
const noop = function noop() {};
const fakeLogger = {
    trace: noop,
    debug: noop,
    log: noop,
    warn: noop,
    info: noop,
    error: noop
};
let exportedLogger = fakeLogger;
// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }
function consolePrintFn(type) {
    const func = self.console[type];
    if (func) return func.bind(self.console, `[${type}] >`);
    return noop;
}
function exportLoggerFunctions(debugConfig, ...functions) {
    functions.forEach(function(type) {
        exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
    });
}
function enableLogs(debugConfig, id) {
    // check that console is available
    if (typeof console === 'object' && debugConfig === true || typeof debugConfig === 'object') {
        exportLoggerFunctions(debugConfig, // Remove out from list here to hard-disable a log-level
        // 'trace',
        'debug', 'log', 'info', 'warn', 'error');
        // Some browsers don't allow to use bind on console object anyway
        // fallback to default if needed
        try {
            exportedLogger.log(`Debug logs enabled for "${id}" in hls.js version ${"1.5.8"}`);
        } catch (e) {
            exportedLogger = fakeLogger;
        }
    } else exportedLogger = fakeLogger;
}
const logger = exportedLogger;
const DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
const ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;
// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
class AttrList {
    constructor(attrs){
        if (typeof attrs === 'string') attrs = AttrList.parseAttrList(attrs);
        _extends(this, attrs);
    }
    get clientAttrs() {
        return Object.keys(this).filter((attr)=>attr.substring(0, 2) === 'X-');
    }
    decimalInteger(attrName) {
        const intValue = parseInt(this[attrName], 10);
        if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
        return intValue;
    }
    hexadecimalInteger(attrName) {
        if (this[attrName]) {
            let stringValue = (this[attrName] || '0x').slice(2);
            stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
            const value = new Uint8Array(stringValue.length / 2);
            for(let i = 0; i < stringValue.length / 2; i++)value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
            return value;
        } else return null;
    }
    hexadecimalIntegerAsNumber(attrName) {
        const intValue = parseInt(this[attrName], 16);
        if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
        return intValue;
    }
    decimalFloatingPoint(attrName) {
        return parseFloat(this[attrName]);
    }
    optionalFloat(attrName, defaultValue) {
        const value = this[attrName];
        return value ? parseFloat(value) : defaultValue;
    }
    enumeratedString(attrName) {
        return this[attrName];
    }
    bool(attrName) {
        return this[attrName] === 'YES';
    }
    decimalResolution(attrName) {
        const res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
        if (res === null) return undefined;
        return {
            width: parseInt(res[1], 10),
            height: parseInt(res[2], 10)
        };
    }
    static parseAttrList(input) {
        let match;
        const attrs = {};
        const quote = '"';
        ATTR_LIST_REGEX.lastIndex = 0;
        while((match = ATTR_LIST_REGEX.exec(input)) !== null){
            let value = match[2];
            if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) value = value.slice(1, -1);
            const name = match[1].trim();
            attrs[name] = value;
        }
        return attrs;
    }
}
// Avoid exporting const enum so that these values can be inlined
function isDateRangeCueAttribute(attrName) {
    return attrName !== "ID" && attrName !== "CLASS" && attrName !== "START-DATE" && attrName !== "DURATION" && attrName !== "END-DATE" && attrName !== "END-ON-NEXT";
}
function isSCTE35Attribute(attrName) {
    return attrName === "SCTE35-OUT" || attrName === "SCTE35-IN";
}
class DateRange {
    constructor(dateRangeAttr, dateRangeWithSameId){
        this.attr = void 0;
        this._startDate = void 0;
        this._endDate = void 0;
        this._badValueForSameId = void 0;
        if (dateRangeWithSameId) {
            const previousAttr = dateRangeWithSameId.attr;
            for(const key in previousAttr)if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
                logger.warn(`DATERANGE tag attribute: "${key}" does not match for tags with ID: "${dateRangeAttr.ID}"`);
                this._badValueForSameId = key;
                break;
            }
            // Merge DateRange tags with the same ID
            dateRangeAttr = _extends(new AttrList({}), previousAttr, dateRangeAttr);
        }
        this.attr = dateRangeAttr;
        this._startDate = new Date(dateRangeAttr["START-DATE"]);
        if ("END-DATE" in this.attr) {
            const endDate = new Date(this.attr["END-DATE"]);
            if (isFiniteNumber(endDate.getTime())) this._endDate = endDate;
        }
    }
    get id() {
        return this.attr.ID;
    }
    get class() {
        return this.attr.CLASS;
    }
    get startDate() {
        return this._startDate;
    }
    get endDate() {
        if (this._endDate) return this._endDate;
        const duration = this.duration;
        if (duration !== null) return new Date(this._startDate.getTime() + duration * 1000);
        return null;
    }
    get duration() {
        if ("DURATION" in this.attr) {
            const duration = this.attr.decimalFloatingPoint("DURATION");
            if (isFiniteNumber(duration)) return duration;
        } else if (this._endDate) return (this._endDate.getTime() - this._startDate.getTime()) / 1000;
        return null;
    }
    get plannedDuration() {
        if ("PLANNED-DURATION" in this.attr) return this.attr.decimalFloatingPoint("PLANNED-DURATION");
        return null;
    }
    get endOnNext() {
        return this.attr.bool("END-ON-NEXT");
    }
    get isValid() {
        return !!this.id && !this._badValueForSameId && isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
    }
}
class LoadStats {
    constructor(){
        this.aborted = false;
        this.loaded = 0;
        this.retry = 0;
        this.total = 0;
        this.chunkCount = 0;
        this.bwEstimate = 0;
        this.loading = {
            start: 0,
            first: 0,
            end: 0
        };
        this.parsing = {
            start: 0,
            end: 0
        };
        this.buffering = {
            start: 0,
            first: 0,
            end: 0
        };
    }
}
var ElementaryStreamTypes = {
    AUDIO: "audio",
    VIDEO: "video",
    AUDIOVIDEO: "audiovideo"
};
class BaseSegment {
    constructor(baseurl){
        this._byteRange = null;
        this._url = null;
        // baseurl is the URL to the playlist
        this.baseurl = void 0;
        // relurl is the portion of the URL that comes from inside the playlist.
        this.relurl = void 0;
        // Holds the types of data this fragment supports
        this.elementaryStreams = {
            [ElementaryStreamTypes.AUDIO]: null,
            [ElementaryStreamTypes.VIDEO]: null,
            [ElementaryStreamTypes.AUDIOVIDEO]: null
        };
        this.baseurl = baseurl;
    }
    // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
    setByteRange(value, previous) {
        const params = value.split('@', 2);
        let start;
        if (params.length === 1) start = (previous == null ? void 0 : previous.byteRangeEndOffset) || 0;
        else start = parseInt(params[1]);
        this._byteRange = [
            start,
            parseInt(params[0]) + start
        ];
    }
    get byteRange() {
        if (!this._byteRange) return [];
        return this._byteRange;
    }
    get byteRangeStartOffset() {
        return this.byteRange[0];
    }
    get byteRangeEndOffset() {
        return this.byteRange[1];
    }
    get url() {
        if (!this._url && this.baseurl && this.relurl) this._url = urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, {
            alwaysNormalize: true
        });
        return this._url || '';
    }
    set url(value) {
        this._url = value;
    }
}
/**
 * Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
 */ class Fragment extends BaseSegment {
    constructor(type, baseurl){
        super(baseurl);
        this._decryptdata = null;
        this.rawProgramDateTime = null;
        this.programDateTime = null;
        this.tagList = [];
        // EXTINF has to be present for a m3u8 to be considered valid
        this.duration = 0;
        // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
        this.sn = 0;
        // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
        // core difference from the private field _decryptdata is the lack of the initialized IV
        // _decryptdata will set the IV for this segment based on the segment number in the fragment
        this.levelkeys = void 0;
        // A string representing the fragment type
        this.type = void 0;
        // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
        this.loader = null;
        // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
        this.keyLoader = null;
        // The level/track index to which the fragment belongs
        this.level = -1;
        // The continuity counter of the fragment
        this.cc = 0;
        // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
        this.startPTS = void 0;
        // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
        this.endPTS = void 0;
        // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
        this.startDTS = void 0;
        // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
        this.endDTS = void 0;
        // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
        this.start = 0;
        // Set by `updateFragPTSDTS` in level-helper
        this.deltaPTS = void 0;
        // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
        this.maxStartPTS = void 0;
        // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
        this.minEndPTS = void 0;
        // Load/parse timing information
        this.stats = new LoadStats();
        // Init Segment bytes (unset for media segments)
        this.data = void 0;
        // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
        this.bitrateTest = false;
        // #EXTINF  segment title
        this.title = null;
        // The Media Initialization Section for this segment
        this.initSegment = null;
        // Fragment is the last fragment in the media playlist
        this.endList = void 0;
        // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
        this.gap = void 0;
        // Deprecated
        this.urlId = 0;
        this.type = type;
    }
    get decryptdata() {
        const { levelkeys } = this;
        if (!levelkeys && !this._decryptdata) return null;
        if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
            const key = this.levelkeys.identity;
            if (key) this._decryptdata = key.getDecryptData(this.sn);
            else {
                const keyFormats = Object.keys(this.levelkeys);
                if (keyFormats.length === 1) return this._decryptdata = this.levelkeys[keyFormats[0]].getDecryptData(this.sn);
            }
        }
        return this._decryptdata;
    }
    get end() {
        return this.start + this.duration;
    }
    get endProgramDateTime() {
        if (this.programDateTime === null) return null;
        if (!isFiniteNumber(this.programDateTime)) return null;
        const duration = !isFiniteNumber(this.duration) ? 0 : this.duration;
        return this.programDateTime + duration * 1000;
    }
    get encrypted() {
        var _this$_decryptdata;
        // At the m3u8-parser level we need to add support for manifest signalled keyformats
        // when we want the fragment to start reporting that it is encrypted.
        // Currently, keyFormat will only be set for identity keys
        if ((_this$_decryptdata = this._decryptdata) != null && _this$_decryptdata.encrypted) return true;
        else if (this.levelkeys) {
            const keyFormats = Object.keys(this.levelkeys);
            const len = keyFormats.length;
            if (len > 1 || len === 1 && this.levelkeys[keyFormats[0]].encrypted) return true;
        }
        return false;
    }
    setKeyFormat(keyFormat) {
        if (this.levelkeys) {
            const key = this.levelkeys[keyFormat];
            if (key && !this._decryptdata) this._decryptdata = key.getDecryptData(this.sn);
        }
    }
    abortRequests() {
        var _this$loader, _this$keyLoader;
        (_this$loader = this.loader) == null || _this$loader.abort();
        (_this$keyLoader = this.keyLoader) == null || _this$keyLoader.abort();
    }
    setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial = false) {
        const { elementaryStreams } = this;
        const info = elementaryStreams[type];
        if (!info) {
            elementaryStreams[type] = {
                startPTS,
                endPTS,
                startDTS,
                endDTS,
                partial
            };
            return;
        }
        info.startPTS = Math.min(info.startPTS, startPTS);
        info.endPTS = Math.max(info.endPTS, endPTS);
        info.startDTS = Math.min(info.startDTS, startDTS);
        info.endDTS = Math.max(info.endDTS, endDTS);
    }
    clearElementaryStreamInfo() {
        const { elementaryStreams } = this;
        elementaryStreams[ElementaryStreamTypes.AUDIO] = null;
        elementaryStreams[ElementaryStreamTypes.VIDEO] = null;
        elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO] = null;
    }
}
/**
 * Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
 */ class Part extends BaseSegment {
    constructor(partAttrs, frag, baseurl, index, previous){
        super(baseurl);
        this.fragOffset = 0;
        this.duration = 0;
        this.gap = false;
        this.independent = false;
        this.relurl = void 0;
        this.fragment = void 0;
        this.index = void 0;
        this.stats = new LoadStats();
        this.duration = partAttrs.decimalFloatingPoint('DURATION');
        this.gap = partAttrs.bool('GAP');
        this.independent = partAttrs.bool('INDEPENDENT');
        this.relurl = partAttrs.enumeratedString('URI');
        this.fragment = frag;
        this.index = index;
        const byteRange = partAttrs.enumeratedString('BYTERANGE');
        if (byteRange) this.setByteRange(byteRange, previous);
        if (previous) this.fragOffset = previous.fragOffset + previous.duration;
    }
    get start() {
        return this.fragment.start + this.fragOffset;
    }
    get end() {
        return this.start + this.duration;
    }
    get loaded() {
        const { elementaryStreams } = this;
        return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
    }
}
const DEFAULT_TARGET_DURATION = 10;
/**
 * Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
 */ class LevelDetails {
    constructor(baseUrl){
        this.PTSKnown = false;
        this.alignedSliding = false;
        this.averagetargetduration = void 0;
        this.endCC = 0;
        this.endSN = 0;
        this.fragments = void 0;
        this.fragmentHint = void 0;
        this.partList = null;
        this.dateRanges = void 0;
        this.live = true;
        this.ageHeader = 0;
        this.advancedDateTime = void 0;
        this.updated = true;
        this.advanced = true;
        this.availabilityDelay = void 0;
        // Manifest reload synchronization
        this.misses = 0;
        this.startCC = 0;
        this.startSN = 0;
        this.startTimeOffset = null;
        this.targetduration = 0;
        this.totalduration = 0;
        this.type = null;
        this.url = void 0;
        this.m3u8 = '';
        this.version = null;
        this.canBlockReload = false;
        this.canSkipUntil = 0;
        this.canSkipDateRanges = false;
        this.skippedSegments = 0;
        this.recentlyRemovedDateranges = void 0;
        this.partHoldBack = 0;
        this.holdBack = 0;
        this.partTarget = 0;
        this.preloadHint = void 0;
        this.renditionReports = void 0;
        this.tuneInGoal = 0;
        this.deltaUpdateFailed = void 0;
        this.driftStartTime = 0;
        this.driftEndTime = 0;
        this.driftStart = 0;
        this.driftEnd = 0;
        this.encryptedFragments = void 0;
        this.playlistParsingError = null;
        this.variableList = null;
        this.hasVariableRefs = false;
        this.fragments = [];
        this.encryptedFragments = [];
        this.dateRanges = {};
        this.url = baseUrl;
    }
    reloaded(previous) {
        if (!previous) {
            this.advanced = true;
            this.updated = true;
            return;
        }
        const partSnDiff = this.lastPartSn - previous.lastPartSn;
        const partIndexDiff = this.lastPartIndex - previous.lastPartIndex;
        this.updated = this.endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff || !this.live;
        this.advanced = this.endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
        if (this.updated || this.advanced) this.misses = Math.floor(previous.misses * 0.6);
        else this.misses = previous.misses + 1;
        this.availabilityDelay = previous.availabilityDelay;
    }
    get hasProgramDateTime() {
        if (this.fragments.length) return isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime);
        return false;
    }
    get levelTargetDuration() {
        return this.averagetargetduration || this.targetduration || DEFAULT_TARGET_DURATION;
    }
    get drift() {
        const runTime = this.driftEndTime - this.driftStartTime;
        if (runTime > 0) {
            const runDuration = this.driftEnd - this.driftStart;
            return runDuration * 1000 / runTime;
        }
        return 1;
    }
    get edge() {
        return this.partEnd || this.fragmentEnd;
    }
    get partEnd() {
        var _this$partList;
        if ((_this$partList = this.partList) != null && _this$partList.length) return this.partList[this.partList.length - 1].end;
        return this.fragmentEnd;
    }
    get fragmentEnd() {
        var _this$fragments;
        if ((_this$fragments = this.fragments) != null && _this$fragments.length) return this.fragments[this.fragments.length - 1].end;
        return 0;
    }
    get age() {
        if (this.advancedDateTime) return Math.max(Date.now() - this.advancedDateTime, 0) / 1000;
        return 0;
    }
    get lastPartIndex() {
        var _this$partList2;
        if ((_this$partList2 = this.partList) != null && _this$partList2.length) return this.partList[this.partList.length - 1].index;
        return -1;
    }
    get lastPartSn() {
        var _this$partList3;
        if ((_this$partList3 = this.partList) != null && _this$partList3.length) return this.partList[this.partList.length - 1].fragment.sn;
        return this.endSN;
    }
}
function base64Decode(base64encodedStr) {
    return Uint8Array.from(atob(base64encodedStr), (c)=>c.charCodeAt(0));
}
function getKeyIdBytes(str) {
    const keyIdbytes = strToUtf8array(str).subarray(0, 16);
    const paddedkeyIdbytes = new Uint8Array(16);
    paddedkeyIdbytes.set(keyIdbytes, 16 - keyIdbytes.length);
    return paddedkeyIdbytes;
}
function changeEndianness(keyId) {
    const swap = function swap(array, from, to) {
        const cur = array[from];
        array[from] = array[to];
        array[to] = cur;
    };
    swap(keyId, 0, 3);
    swap(keyId, 1, 2);
    swap(keyId, 4, 5);
    swap(keyId, 6, 7);
}
function convertDataUriToArrayBytes(uri) {
    // data:[<media type][;attribute=value][;base64],<data>
    const colonsplit = uri.split(':');
    let keydata = null;
    if (colonsplit[0] === 'data' && colonsplit.length === 2) {
        const semicolonsplit = colonsplit[1].split(';');
        const commasplit = semicolonsplit[semicolonsplit.length - 1].split(',');
        if (commasplit.length === 2) {
            const isbase64 = commasplit[0] === 'base64';
            const data = commasplit[1];
            if (isbase64) {
                semicolonsplit.splice(-1, 1); // remove from processing
                keydata = base64Decode(data);
            } else keydata = getKeyIdBytes(data);
        }
    }
    return keydata;
}
function strToUtf8array(str) {
    return Uint8Array.from(unescape(encodeURIComponent(str)), (c)=>c.charCodeAt(0));
}
/** returns `undefined` is `self` is missing, e.g. in node */ const optionalSelf = typeof self !== 'undefined' ? self : undefined;
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */ var KeySystems = {
    CLEARKEY: "org.w3.clearkey",
    FAIRPLAY: "com.apple.fps",
    PLAYREADY: "com.microsoft.playready",
    WIDEVINE: "com.widevine.alpha"
};
// Playlist #EXT-X-KEY KEYFORMAT values
var KeySystemFormats = {
    CLEARKEY: "org.w3.clearkey",
    FAIRPLAY: "com.apple.streamingkeydelivery",
    PLAYREADY: "com.microsoft.playready",
    WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function keySystemFormatToKeySystemDomain(format) {
    switch(format){
        case KeySystemFormats.FAIRPLAY:
            return KeySystems.FAIRPLAY;
        case KeySystemFormats.PLAYREADY:
            return KeySystems.PLAYREADY;
        case KeySystemFormats.WIDEVINE:
            return KeySystems.WIDEVINE;
        case KeySystemFormats.CLEARKEY:
            return KeySystems.CLEARKEY;
    }
}
// System IDs for which we can extract a key ID from "encrypted" event PSSH
var KeySystemIds = {
    WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function keySystemIdToKeySystemDomain(systemId) {
    if (systemId === KeySystemIds.WIDEVINE) return KeySystems.WIDEVINE;
}
function keySystemDomainToKeySystemFormat(keySystem) {
    switch(keySystem){
        case KeySystems.FAIRPLAY:
            return KeySystemFormats.FAIRPLAY;
        case KeySystems.PLAYREADY:
            return KeySystemFormats.PLAYREADY;
        case KeySystems.WIDEVINE:
            return KeySystemFormats.WIDEVINE;
        case KeySystems.CLEARKEY:
            return KeySystemFormats.CLEARKEY;
    }
}
function getKeySystemsForConfig(config) {
    const { drmSystems, widevineLicenseUrl } = config;
    const keySystemsToAttempt = drmSystems ? [
        KeySystems.FAIRPLAY,
        KeySystems.WIDEVINE,
        KeySystems.PLAYREADY,
        KeySystems.CLEARKEY
    ].filter((keySystem)=>!!drmSystems[keySystem]) : [];
    if (!keySystemsToAttempt[KeySystems.WIDEVINE] && widevineLicenseUrl) keySystemsToAttempt.push(KeySystems.WIDEVINE);
    return keySystemsToAttempt;
}
const requestMediaKeySystemAccess = function(_optionalSelf$navigat) {
    if (optionalSelf != null && (_optionalSelf$navigat = optionalSelf.navigator) != null && _optionalSelf$navigat.requestMediaKeySystemAccess) return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
    else return null;
}();
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 */ function getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
    let initDataTypes;
    switch(keySystem){
        case KeySystems.FAIRPLAY:
            initDataTypes = [
                'cenc',
                'sinf'
            ];
            break;
        case KeySystems.WIDEVINE:
        case KeySystems.PLAYREADY:
            initDataTypes = [
                'cenc'
            ];
            break;
        case KeySystems.CLEARKEY:
            initDataTypes = [
                'cenc',
                'keyids'
            ];
            break;
        default:
            throw new Error(`Unknown key-system: ${keySystem}`);
    }
    return createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions);
}
function createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions) {
    const baseConfig = {
        initDataTypes: initDataTypes,
        persistentState: drmSystemOptions.persistentState || 'optional',
        distinctiveIdentifier: drmSystemOptions.distinctiveIdentifier || 'optional',
        sessionTypes: drmSystemOptions.sessionTypes || [
            drmSystemOptions.sessionType || 'temporary'
        ],
        audioCapabilities: audioCodecs.map((codec)=>({
                contentType: `audio/mp4; codecs="${codec}"`,
                robustness: drmSystemOptions.audioRobustness || '',
                encryptionScheme: drmSystemOptions.audioEncryptionScheme || null
            })),
        videoCapabilities: videoCodecs.map((codec)=>({
                contentType: `video/mp4; codecs="${codec}"`,
                robustness: drmSystemOptions.videoRobustness || '',
                encryptionScheme: drmSystemOptions.videoEncryptionScheme || null
            }))
    };
    return [
        baseConfig
    ];
}
function sliceUint8(array, start, end) {
    // @ts-expect-error This polyfills IE11 usage of Uint8Array slice.
    // It always exists in the TypeScript definition so fails, but it fails at runtime on IE11.
    return Uint8Array.prototype.slice ? array.slice(start, end) : new Uint8Array(Array.prototype.slice.call(array, start, end));
}
// breaking up those two types in order to clarify what is happening in the decoding path.
/**
 * Returns true if an ID3 header can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */ const isHeader$2 = (data, offset)=>{
    /*
   * http://id3.org/id3v2.3.0
   * [0]     = 'I'
   * [1]     = 'D'
   * [2]     = '3'
   * [3,4]   = {Version}
   * [5]     = {Flags}
   * [6-9]   = {ID3 Size}
   *
   * An ID3v2 tag can be detected with the following pattern:
   *  $49 44 33 yy yy xx zz zz zz zz
   * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
   */ if (offset + 10 <= data.length) {
        // look for 'ID3' identifier
        if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) // check version is within range
        {
            if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
                // check size is within range
                if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
            }
        }
    }
    return false;
};
/**
 * Returns true if an ID3 footer can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */ const isFooter = (data, offset)=>{
    /*
   * The footer is a copy of the header, but with a different identifier
   */ if (offset + 10 <= data.length) {
        // look for '3DI' identifier
        if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) // check version is within range
        {
            if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
                // check size is within range
                if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
            }
        }
    }
    return false;
};
/**
 * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 * @returns the block of data containing any ID3 tags found
 * or *undefined* if no header is found at the starting offset
 */ const getID3Data = (data, offset)=>{
    const front = offset;
    let length = 0;
    while(isHeader$2(data, offset)){
        // ID3 header is 10 bytes
        length += 10;
        const size = readSize(data, offset + 6);
        length += size;
        if (isFooter(data, offset + 10)) // ID3 footer is 10 bytes
        length += 10;
        offset += length;
    }
    if (length > 0) return data.subarray(front, front + length);
    return undefined;
};
const readSize = (data, offset)=>{
    let size = 0;
    size = (data[offset] & 0x7f) << 21;
    size |= (data[offset + 1] & 0x7f) << 14;
    size |= (data[offset + 2] & 0x7f) << 7;
    size |= data[offset + 3] & 0x7f;
    return size;
};
const canParse$2 = (data, offset)=>{
    return isHeader$2(data, offset) && readSize(data, offset + 6) + 10 <= data.length - offset;
};
/**
 * Searches for the Elementary Stream timestamp found in the ID3 data chunk
 * @param data - Block of data containing one or more ID3 tags
 */ const getTimeStamp = (data)=>{
    const frames = getID3Frames(data);
    for(let i = 0; i < frames.length; i++){
        const frame = frames[i];
        if (isTimeStampFrame(frame)) return readTimeStamp(frame);
    }
    return undefined;
};
/**
 * Returns true if the ID3 frame is an Elementary Stream timestamp frame
 */ const isTimeStampFrame = (frame)=>{
    return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
};
const getFrameData = (data)=>{
    /*
  Frame ID       $xx xx xx xx (four characters)
  Size           $xx xx xx xx
  Flags          $xx xx
  */ const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
    const size = readSize(data, 4);
    // skip frame id, size, and flags
    const offset = 10;
    return {
        type,
        size,
        data: data.subarray(offset, offset + size)
    };
};
/**
 * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
 * @param id3Data - The ID3 data containing one or more ID3 tags
 */ const getID3Frames = (id3Data)=>{
    let offset = 0;
    const frames = [];
    while(isHeader$2(id3Data, offset)){
        const size = readSize(id3Data, offset + 6);
        // skip past ID3 header
        offset += 10;
        const end = offset + size;
        // loop through frames in the ID3 tag
        while(offset + 8 < end){
            const frameData = getFrameData(id3Data.subarray(offset));
            const frame = decodeFrame(frameData);
            if (frame) frames.push(frame);
            // skip frame header and frame data
            offset += frameData.size + 10;
        }
        if (isFooter(id3Data, offset)) offset += 10;
    }
    return frames;
};
const decodeFrame = (frame)=>{
    if (frame.type === 'PRIV') return decodePrivFrame(frame);
    else if (frame.type[0] === 'W') return decodeURLFrame(frame);
    return decodeTextFrame(frame);
};
const decodePrivFrame = (frame)=>{
    /*
  Format: <text string>\0<binary data>
  */ if (frame.size < 2) return undefined;
    const owner = utf8ArrayToStr(frame.data, true);
    const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
    return {
        key: frame.type,
        info: owner,
        data: privateData.buffer
    };
};
const decodeTextFrame = (frame)=>{
    if (frame.size < 2) return undefined;
    if (frame.type === 'TXXX') {
        /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{Value}
    */ let index = 1;
        const description = utf8ArrayToStr(frame.data.subarray(index), true);
        index += description.length + 1;
        const value = utf8ArrayToStr(frame.data.subarray(index));
        return {
            key: frame.type,
            info: description,
            data: value
        };
    }
    /*
  Format:
  [0]   = {Text Encoding}
  [1-?] = {Value}
  */ const text = utf8ArrayToStr(frame.data.subarray(1));
    return {
        key: frame.type,
        data: text
    };
};
const decodeURLFrame = (frame)=>{
    if (frame.type === 'WXXX') {
        /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{URL}
    */ if (frame.size < 2) return undefined;
        let index = 1;
        const description = utf8ArrayToStr(frame.data.subarray(index), true);
        index += description.length + 1;
        const value = utf8ArrayToStr(frame.data.subarray(index));
        return {
            key: frame.type,
            info: description,
            data: value
        };
    }
    /*
  Format:
  [0-?] = {URL}
  */ const url = utf8ArrayToStr(frame.data);
    return {
        key: frame.type,
        data: url
    };
};
const readTimeStamp = (timeStampFrame)=>{
    if (timeStampFrame.data.byteLength === 8) {
        const data = new Uint8Array(timeStampFrame.data);
        // timestamp is 33 bit expressed as a big-endian eight-octet number,
        // with the upper 31 bits set to zero.
        const pts33Bit = data[3] & 0x1;
        let timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
        timestamp /= 45;
        if (pts33Bit) timestamp += 47721858.84;
         // 2^32 / 90
        return Math.round(timestamp);
    }
    return undefined;
};
// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */ const utf8ArrayToStr = (array, exitOnNull = false)=>{
    const decoder = getTextDecoder();
    if (decoder) {
        const decoded = decoder.decode(array);
        if (exitOnNull) {
            // grab up to the first null
            const idx = decoded.indexOf('\0');
            return idx !== -1 ? decoded.substring(0, idx) : decoded;
        }
        // remove any null characters
        return decoded.replace(/\0/g, '');
    }
    const len = array.length;
    let c;
    let char2;
    let char3;
    let out = '';
    let i = 0;
    while(i < len){
        c = array[i++];
        if (c === 0x00 && exitOnNull) return out;
        else if (c === 0x00 || c === 0x03) continue;
        switch(c >> 4){
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                // 0xxxxxxx
                out += String.fromCharCode(c);
                break;
            case 12:
            case 13:
                // 110x xxxx   10xx xxxx
                char2 = array[i++];
                out += String.fromCharCode((c & 0x1f) << 6 | char2 & 0x3f);
                break;
            case 14:
                // 1110 xxxx  10xx xxxx  10xx xxxx
                char2 = array[i++];
                char3 = array[i++];
                out += String.fromCharCode((c & 0x0f) << 12 | (char2 & 0x3f) << 6 | (char3 & 0x3f) << 0);
                break;
        }
    }
    return out;
};
let decoder;
function getTextDecoder() {
    // On Play Station 4, TextDecoder is defined but partially implemented.
    // Manual decoding option is preferable
    if (navigator.userAgent.includes('PlayStation 4')) return;
    if (!decoder && typeof self.TextDecoder !== 'undefined') decoder = new self.TextDecoder('utf-8');
    return decoder;
}
/**
 *  hex dump helper class
 */ const Hex = {
    hexDump: function(array) {
        let str = '';
        for(let i = 0; i < array.length; i++){
            let h = array[i].toString(16);
            if (h.length < 2) h = '0' + h;
            str += h;
        }
        return str;
    }
};
const UINT32_MAX$1 = Math.pow(2, 32) - 1;
const push = [].push;
// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
const RemuxerTrackIdConfig = {
    video: 1,
    audio: 2,
    id3: 3,
    text: 4
};
function bin2str(data) {
    return String.fromCharCode.apply(null, data);
}
function readUint16(buffer, offset) {
    const val = buffer[offset] << 8 | buffer[offset + 1];
    return val < 0 ? 65536 + val : val;
}
function readUint32(buffer, offset) {
    const val = readSint32(buffer, offset);
    return val < 0 ? 4294967296 + val : val;
}
function readUint64(buffer, offset) {
    let result = readUint32(buffer, offset);
    result *= Math.pow(2, 32);
    result += readUint32(buffer, offset + 4);
    return result;
}
function readSint32(buffer, offset) {
    return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function writeUint32(buffer, offset, value) {
    buffer[offset] = value >> 24;
    buffer[offset + 1] = value >> 16 & 0xff;
    buffer[offset + 2] = value >> 8 & 0xff;
    buffer[offset + 3] = value & 0xff;
}
// Find "moof" box
function hasMoofData(data) {
    const end = data.byteLength;
    for(let i = 0; i < end;){
        const size = readUint32(data, i);
        if (size > 8 && data[i + 4] === 0x6d && data[i + 5] === 0x6f && data[i + 6] === 0x6f && data[i + 7] === 0x66) return true;
        i = size > 1 ? i + size : end;
    }
    return false;
}
// Find the data for a box specified by its path
function findBox(data, path) {
    const results = [];
    if (!path.length) // short-circuit the search for empty paths
    return results;
    const end = data.byteLength;
    for(let i = 0; i < end;){
        const size = readUint32(data, i);
        const type = bin2str(data.subarray(i + 4, i + 8));
        const endbox = size > 1 ? i + size : end;
        if (type === path[0]) {
            if (path.length === 1) // this is the end of the path and we've found the box we were
            // looking for
            results.push(data.subarray(i + 8, endbox));
            else {
                // recursively search for the next box along the path
                const subresults = findBox(data.subarray(i + 8, endbox), path.slice(1));
                if (subresults.length) push.apply(results, subresults);
            }
        }
        i = endbox;
    }
    // we've finished searching all of data
    return results;
}
function parseSegmentIndex(sidx) {
    const references = [];
    const version = sidx[0];
    // set initial offset, we skip the reference ID (not needed)
    let index = 8;
    const timescale = readUint32(sidx, index);
    index += 4;
    let earliestPresentationTime = 0;
    let firstOffset = 0;
    if (version === 0) {
        earliestPresentationTime = readUint32(sidx, index);
        firstOffset = readUint32(sidx, index + 4);
        index += 8;
    } else {
        earliestPresentationTime = readUint64(sidx, index);
        firstOffset = readUint64(sidx, index + 8);
        index += 16;
    }
    // skip reserved
    index += 2;
    let startByte = sidx.length + firstOffset;
    const referencesCount = readUint16(sidx, index);
    index += 2;
    for(let i = 0; i < referencesCount; i++){
        let referenceIndex = index;
        const referenceInfo = readUint32(sidx, referenceIndex);
        referenceIndex += 4;
        const referenceSize = referenceInfo & 0x7fffffff;
        const referenceType = (referenceInfo & 0x80000000) >>> 31;
        if (referenceType === 1) {
            logger.warn('SIDX has hierarchical references (not supported)');
            return null;
        }
        const subsegmentDuration = readUint32(sidx, referenceIndex);
        referenceIndex += 4;
        references.push({
            referenceSize,
            subsegmentDuration,
            // unscaled
            info: {
                duration: subsegmentDuration / timescale,
                start: startByte,
                end: startByte + referenceSize - 1
            }
        });
        startByte += referenceSize;
        // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
        // for |sapDelta|.
        referenceIndex += 4;
        // skip to next ref
        index = referenceIndex;
    }
    return {
        earliestPresentationTime,
        timescale,
        version,
        referencesCount,
        references
    };
}
/**
 * Parses an MP4 initialization segment and extracts stream type and
 * timescale values for any declared tracks. Timescale values indicate the
 * number of clock ticks per second to assume for time-based values
 * elsewhere in the MP4.
 *
 * To determine the start time of an MP4, you need two pieces of
 * information: the timescale unit and the earliest base media decode
 * time. Multiple timescales can be specified within an MP4 but the
 * base media decode time is always expressed in the timescale from
 * the media header box for the track:
 * ```
 * moov > trak > mdia > mdhd.timescale
 * moov > trak > mdia > hdlr
 * ```
 * @param initSegment the bytes of the init segment
 * @returns a hash of track type to timescale values or null if
 * the init segment is malformed.
 */ function parseInitSegment(initSegment) {
    const result = [];
    const traks = findBox(initSegment, [
        'moov',
        'trak'
    ]);
    for(let i = 0; i < traks.length; i++){
        const trak = traks[i];
        const tkhd = findBox(trak, [
            'tkhd'
        ])[0];
        if (tkhd) {
            let version = tkhd[0];
            const trackId = readUint32(tkhd, version === 0 ? 12 : 20);
            const mdhd = findBox(trak, [
                'mdia',
                'mdhd'
            ])[0];
            if (mdhd) {
                version = mdhd[0];
                const timescale = readUint32(mdhd, version === 0 ? 12 : 20);
                const hdlr = findBox(trak, [
                    'mdia',
                    'hdlr'
                ])[0];
                if (hdlr) {
                    const hdlrType = bin2str(hdlr.subarray(8, 12));
                    const type = {
                        soun: ElementaryStreamTypes.AUDIO,
                        vide: ElementaryStreamTypes.VIDEO
                    }[hdlrType];
                    if (type) {
                        // Parse codec details
                        const stsd = findBox(trak, [
                            'mdia',
                            'minf',
                            'stbl',
                            'stsd'
                        ])[0];
                        const stsdData = parseStsd(stsd);
                        result[trackId] = {
                            timescale,
                            type
                        };
                        result[type] = _objectSpread2({
                            timescale,
                            id: trackId
                        }, stsdData);
                    }
                }
            }
        }
    }
    const trex = findBox(initSegment, [
        'moov',
        'mvex',
        'trex'
    ]);
    trex.forEach((trex)=>{
        const trackId = readUint32(trex, 4);
        const track = result[trackId];
        if (track) track.default = {
            duration: readUint32(trex, 12),
            flags: readUint32(trex, 20)
        };
    });
    return result;
}
function parseStsd(stsd) {
    const sampleEntries = stsd.subarray(8);
    const sampleEntriesEnd = sampleEntries.subarray(86);
    const fourCC = bin2str(sampleEntries.subarray(4, 8));
    let codec = fourCC;
    const encrypted = fourCC === 'enca' || fourCC === 'encv';
    if (encrypted) {
        const encBox = findBox(sampleEntries, [
            fourCC
        ])[0];
        const encBoxChildren = encBox.subarray(fourCC === 'enca' ? 28 : 78);
        const sinfs = findBox(encBoxChildren, [
            'sinf'
        ]);
        sinfs.forEach((sinf)=>{
            const schm = findBox(sinf, [
                'schm'
            ])[0];
            if (schm) {
                const scheme = bin2str(schm.subarray(4, 8));
                if (scheme === 'cbcs' || scheme === 'cenc') {
                    const frma = findBox(sinf, [
                        'frma'
                    ])[0];
                    if (frma) // for encrypted content codec fourCC will be in frma
                    codec = bin2str(frma);
                }
            }
        });
    }
    switch(codec){
        case 'avc1':
        case 'avc2':
        case 'avc3':
        case 'avc4':
            {
                // extract profile + compatibility + level out of avcC box
                const avcCBox = findBox(sampleEntriesEnd, [
                    'avcC'
                ])[0];
                codec += '.' + toHex(avcCBox[1]) + toHex(avcCBox[2]) + toHex(avcCBox[3]);
                break;
            }
        case 'mp4a':
            {
                const codecBox = findBox(sampleEntries, [
                    fourCC
                ])[0];
                const esdsBox = findBox(codecBox.subarray(28), [
                    'esds'
                ])[0];
                if (esdsBox && esdsBox.length > 12) {
                    let i = 4;
                    // ES Descriptor tag
                    if (esdsBox[i++] !== 0x03) break;
                    i = skipBERInteger(esdsBox, i);
                    i += 2; // skip es_id;
                    const flags = esdsBox[i++];
                    if (flags & 0x80) i += 2; // skip dependency es_id
                    if (flags & 0x40) i += esdsBox[i++]; // skip URL
                    // Decoder config descriptor
                    if (esdsBox[i++] !== 0x04) break;
                    i = skipBERInteger(esdsBox, i);
                    const objectType = esdsBox[i++];
                    if (objectType === 0x40) codec += '.' + toHex(objectType);
                    else break;
                    i += 12;
                    // Decoder specific info
                    if (esdsBox[i++] !== 0x05) break;
                    i = skipBERInteger(esdsBox, i);
                    const firstByte = esdsBox[i++];
                    let audioObjectType = (firstByte & 0xf8) >> 3;
                    if (audioObjectType === 31) audioObjectType += 1 + ((firstByte & 0x7) << 3) + ((esdsBox[i] & 0xe0) >> 5);
                    codec += '.' + audioObjectType;
                }
                break;
            }
        case 'hvc1':
        case 'hev1':
            {
                const hvcCBox = findBox(sampleEntriesEnd, [
                    'hvcC'
                ])[0];
                const profileByte = hvcCBox[1];
                const profileSpace = [
                    '',
                    'A',
                    'B',
                    'C'
                ][profileByte >> 6];
                const generalProfileIdc = profileByte & 0x1f;
                const profileCompat = readUint32(hvcCBox, 2);
                const tierFlag = (profileByte & 0x20) >> 5 ? 'H' : 'L';
                const levelIDC = hvcCBox[12];
                const constraintIndicator = hvcCBox.subarray(6, 12);
                codec += '.' + profileSpace + generalProfileIdc;
                codec += '.' + profileCompat.toString(16).toUpperCase();
                codec += '.' + tierFlag + levelIDC;
                let constraintString = '';
                for(let i = constraintIndicator.length; i--;){
                    const byte = constraintIndicator[i];
                    if (byte || constraintString) {
                        const encodedByte = byte.toString(16).toUpperCase();
                        constraintString = '.' + encodedByte + constraintString;
                    }
                }
                codec += constraintString;
                break;
            }
        case 'dvh1':
        case 'dvhe':
            {
                const dvcCBox = findBox(sampleEntriesEnd, [
                    'dvcC'
                ])[0];
                const profile = dvcCBox[2] >> 1 & 0x7f;
                const level = dvcCBox[2] << 5 & 0x20 | dvcCBox[3] >> 3 & 0x1f;
                codec += '.' + addLeadingZero(profile) + '.' + addLeadingZero(level);
                break;
            }
        case 'vp09':
            {
                const vpcCBox = findBox(sampleEntriesEnd, [
                    'vpcC'
                ])[0];
                const profile = vpcCBox[4];
                const level = vpcCBox[5];
                const bitDepth = vpcCBox[6] >> 4 & 0x0f;
                codec += '.' + addLeadingZero(profile) + '.' + addLeadingZero(level) + '.' + addLeadingZero(bitDepth);
                break;
            }
        case 'av01':
            {
                const av1CBox = findBox(sampleEntriesEnd, [
                    'av1C'
                ])[0];
                const profile = av1CBox[1] >>> 5;
                const level = av1CBox[1] & 0x1f;
                const tierFlag = av1CBox[2] >>> 7 ? 'H' : 'M';
                const highBitDepth = (av1CBox[2] & 0x40) >> 6;
                const twelveBit = (av1CBox[2] & 0x20) >> 5;
                const bitDepth = profile === 2 && highBitDepth ? twelveBit ? 12 : 10 : highBitDepth ? 10 : 8;
                const monochrome = (av1CBox[2] & 0x10) >> 4;
                const chromaSubsamplingX = (av1CBox[2] & 0x08) >> 3;
                const chromaSubsamplingY = (av1CBox[2] & 0x04) >> 2;
                const chromaSamplePosition = av1CBox[2] & 0x03;
                // TODO: parse color_description_present_flag
                // default it to BT.709/limited range for now
                // more info https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
                const colorPrimaries = 1;
                const transferCharacteristics = 1;
                const matrixCoefficients = 1;
                const videoFullRangeFlag = 0;
                codec += '.' + profile + '.' + addLeadingZero(level) + tierFlag + '.' + addLeadingZero(bitDepth) + '.' + monochrome + '.' + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition + '.' + addLeadingZero(colorPrimaries) + '.' + addLeadingZero(transferCharacteristics) + '.' + addLeadingZero(matrixCoefficients) + '.' + videoFullRangeFlag;
                break;
            }
    }
    return {
        codec,
        encrypted
    };
}
function skipBERInteger(bytes, i) {
    const limit = i + 5;
    while(bytes[i++] & 0x80 && i < limit);
    return i;
}
function toHex(x) {
    return ('0' + x.toString(16).toUpperCase()).slice(-2);
}
function addLeadingZero(num) {
    return (num < 10 ? '0' : '') + num;
}
function patchEncyptionData(initSegment, decryptdata) {
    if (!initSegment || !decryptdata) return initSegment;
    const keyId = decryptdata.keyId;
    if (keyId && decryptdata.isCommonEncryption) {
        const traks = findBox(initSegment, [
            'moov',
            'trak'
        ]);
        traks.forEach((trak)=>{
            const stsd = findBox(trak, [
                'mdia',
                'minf',
                'stbl',
                'stsd'
            ])[0];
            // skip the sample entry count
            const sampleEntries = stsd.subarray(8);
            let encBoxes = findBox(sampleEntries, [
                'enca'
            ]);
            const isAudio = encBoxes.length > 0;
            if (!isAudio) encBoxes = findBox(sampleEntries, [
                'encv'
            ]);
            encBoxes.forEach((enc)=>{
                const encBoxChildren = isAudio ? enc.subarray(28) : enc.subarray(78);
                const sinfBoxes = findBox(encBoxChildren, [
                    'sinf'
                ]);
                sinfBoxes.forEach((sinf)=>{
                    const tenc = parseSinf(sinf);
                    if (tenc) {
                        // Look for default key id (keyID offset is always 8 within the tenc box):
                        const tencKeyId = tenc.subarray(8, 24);
                        if (!tencKeyId.some((b)=>b !== 0)) {
                            logger.log(`[eme] Patching keyId in 'enc${isAudio ? 'a' : 'v'}>sinf>>tenc' box: ${Hex.hexDump(tencKeyId)} -> ${Hex.hexDump(keyId)}`);
                            tenc.set(keyId, 8);
                        }
                    }
                });
            });
        });
    }
    return initSegment;
}
function parseSinf(sinf) {
    const schm = findBox(sinf, [
        'schm'
    ])[0];
    if (schm) {
        const scheme = bin2str(schm.subarray(4, 8));
        if (scheme === 'cbcs' || scheme === 'cenc') return findBox(sinf, [
            'schi',
            'tenc'
        ])[0];
    }
    logger.error(`[eme] missing 'schm' box`);
    return null;
}
/**
 * Determine the base media decode start time, in seconds, for an MP4
 * fragment. If multiple fragments are specified, the earliest time is
 * returned.
 *
 * The base media decode time can be parsed from track fragment
 * metadata:
 * ```
 * moof > traf > tfdt.baseMediaDecodeTime
 * ```
 * It requires the timescale value from the mdhd to interpret.
 *
 * @param initData - a hash of track type to timescale values
 * @param fmp4 - the bytes of the mp4 fragment
 * @returns the earliest base media decode start time for the
 * fragment, in seconds
 */ function getStartDTS(initData, fmp4) {
    // we need info from two children of each track fragment box
    return findBox(fmp4, [
        'moof',
        'traf'
    ]).reduce((result, traf)=>{
        const tfdt = findBox(traf, [
            'tfdt'
        ])[0];
        const version = tfdt[0];
        const start = findBox(traf, [
            'tfhd'
        ]).reduce((result, tfhd)=>{
            // get the track id from the tfhd
            const id = readUint32(tfhd, 4);
            const track = initData[id];
            if (track) {
                let baseTime = readUint32(tfdt, 4);
                if (version === 1) {
                    // If value is too large, assume signed 64-bit. Negative track fragment decode times are invalid, but they exist in the wild.
                    // This prevents large values from being used for initPTS, which can cause playlist sync issues.
                    // https://github.com/video-dev/hls.js/issues/5303
                    if (baseTime === UINT32_MAX$1) {
                        logger.warn(`[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time`);
                        return result;
                    }
                    baseTime *= UINT32_MAX$1 + 1;
                    baseTime += readUint32(tfdt, 8);
                }
                // assume a 90kHz clock if no timescale was specified
                const scale = track.timescale || 90e3;
                // convert base time to seconds
                const startTime = baseTime / scale;
                if (isFiniteNumber(startTime) && (result === null || startTime < result)) return startTime;
            }
            return result;
        }, null);
        if (start !== null && isFiniteNumber(start) && (result === null || start < result)) return start;
        return result;
    }, null);
}
/*
  For Reference:
  aligned(8) class TrackFragmentHeaderBox
           extends FullBox(‘tfhd’, 0, tf_flags){
     unsigned int(32)  track_ID;
     // all the following are optional fields
     unsigned int(64)  base_data_offset;
     unsigned int(32)  sample_description_index;
     unsigned int(32)  default_sample_duration;
     unsigned int(32)  default_sample_size;
     unsigned int(32)  default_sample_flags
  }
 */ function getDuration(data, initData) {
    let rawDuration = 0;
    let videoDuration = 0;
    let audioDuration = 0;
    const trafs = findBox(data, [
        'moof',
        'traf'
    ]);
    for(let i = 0; i < trafs.length; i++){
        const traf = trafs[i];
        // There is only one tfhd & trun per traf
        // This is true for CMAF style content, and we should perhaps check the ftyp
        // and only look for a single trun then, but for ISOBMFF we should check
        // for multiple track runs.
        const tfhd = findBox(traf, [
            'tfhd'
        ])[0];
        // get the track id from the tfhd
        const id = readUint32(tfhd, 4);
        const track = initData[id];
        if (!track) continue;
        const trackDefault = track.default;
        const tfhdFlags = readUint32(tfhd, 0) | (trackDefault == null ? void 0 : trackDefault.flags);
        let sampleDuration = trackDefault == null ? void 0 : trackDefault.duration;
        if (tfhdFlags & 0x000008) {
            // 0x000008 indicates the presence of the default_sample_duration field
            if (tfhdFlags & 0x000002) // 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
            // If present, the default_sample_duration exists at byte offset 12
            sampleDuration = readUint32(tfhd, 12);
            else // Otherwise, the duration is at byte offset 8
            sampleDuration = readUint32(tfhd, 8);
        }
        // assume a 90kHz clock if no timescale was specified
        const timescale = track.timescale || 90e3;
        const truns = findBox(traf, [
            'trun'
        ]);
        for(let j = 0; j < truns.length; j++){
            rawDuration = computeRawDurationFromSamples(truns[j]);
            if (!rawDuration && sampleDuration) {
                const sampleCount = readUint32(truns[j], 4);
                rawDuration = sampleDuration * sampleCount;
            }
            if (track.type === ElementaryStreamTypes.VIDEO) videoDuration += rawDuration / timescale;
            else if (track.type === ElementaryStreamTypes.AUDIO) audioDuration += rawDuration / timescale;
        }
    }
    if (videoDuration === 0 && audioDuration === 0) {
        // If duration samples are not available in the traf use sidx subsegment_duration
        let sidxMinStart = Infinity;
        let sidxMaxEnd = 0;
        let sidxDuration = 0;
        const sidxs = findBox(data, [
            'sidx'
        ]);
        for(let i = 0; i < sidxs.length; i++){
            const sidx = parseSegmentIndex(sidxs[i]);
            if (sidx != null && sidx.references) {
                sidxMinStart = Math.min(sidxMinStart, sidx.earliestPresentationTime / sidx.timescale);
                const subSegmentDuration = sidx.references.reduce((dur, ref)=>dur + ref.info.duration || 0, 0);
                sidxMaxEnd = Math.max(sidxMaxEnd, subSegmentDuration + sidx.earliestPresentationTime / sidx.timescale);
                sidxDuration = sidxMaxEnd - sidxMinStart;
            }
        }
        if (sidxDuration && isFiniteNumber(sidxDuration)) return sidxDuration;
    }
    if (videoDuration) return videoDuration;
    return audioDuration;
}
/*
  For Reference:
  aligned(8) class TrackRunBox
           extends FullBox(‘trun’, version, tr_flags) {
     unsigned int(32)  sample_count;
     // the following are optional fields
     signed int(32) data_offset;
     unsigned int(32)  first_sample_flags;
     // all fields in the following array are optional
     {
        unsigned int(32)  sample_duration;
        unsigned int(32)  sample_size;
        unsigned int(32)  sample_flags
        if (version == 0)
           { unsigned int(32)
        else
           { signed int(32)
     }[ sample_count ]
  }
 */ function computeRawDurationFromSamples(trun) {
    const flags = readUint32(trun, 0);
    // Flags are at offset 0, non-optional sample_count is at offset 4. Therefore we start 8 bytes in.
    // Each field is an int32, which is 4 bytes
    let offset = 8;
    // data-offset-present flag
    if (flags & 0x000001) offset += 4;
    // first-sample-flags-present flag
    if (flags & 0x000004) offset += 4;
    let duration = 0;
    const sampleCount = readUint32(trun, 4);
    for(let i = 0; i < sampleCount; i++){
        // sample-duration-present flag
        if (flags & 0x000100) {
            const sampleDuration = readUint32(trun, offset);
            duration += sampleDuration;
            offset += 4;
        }
        // sample-size-present flag
        if (flags & 0x000200) offset += 4;
        // sample-flags-present flag
        if (flags & 0x000400) offset += 4;
        // sample-composition-time-offsets-present flag
        if (flags & 0x000800) offset += 4;
    }
    return duration;
}
function offsetStartDTS(initData, fmp4, timeOffset) {
    findBox(fmp4, [
        'moof',
        'traf'
    ]).forEach((traf)=>{
        findBox(traf, [
            'tfhd'
        ]).forEach((tfhd)=>{
            // get the track id from the tfhd
            const id = readUint32(tfhd, 4);
            const track = initData[id];
            if (!track) return;
            // assume a 90kHz clock if no timescale was specified
            const timescale = track.timescale || 90e3;
            // get the base media decode time from the tfdt
            findBox(traf, [
                'tfdt'
            ]).forEach((tfdt)=>{
                const version = tfdt[0];
                const offset = timeOffset * timescale;
                if (offset) {
                    let baseMediaDecodeTime = readUint32(tfdt, 4);
                    if (version === 0) {
                        baseMediaDecodeTime -= offset;
                        baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                        writeUint32(tfdt, 4, baseMediaDecodeTime);
                    } else {
                        baseMediaDecodeTime *= Math.pow(2, 32);
                        baseMediaDecodeTime += readUint32(tfdt, 8);
                        baseMediaDecodeTime -= offset;
                        baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                        const upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX$1 + 1));
                        const lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX$1 + 1));
                        writeUint32(tfdt, 4, upper);
                        writeUint32(tfdt, 8, lower);
                    }
                }
            });
        });
    });
}
// TODO: Check if the last moof+mdat pair is part of the valid range
function segmentValidRange(data) {
    const segmentedRange = {
        valid: null,
        remainder: null
    };
    const moofs = findBox(data, [
        'moof'
    ]);
    if (moofs.length < 2) {
        segmentedRange.remainder = data;
        return segmentedRange;
    }
    const last = moofs[moofs.length - 1];
    // Offset by 8 bytes; findBox offsets the start by as much
    segmentedRange.valid = sliceUint8(data, 0, last.byteOffset - 8);
    segmentedRange.remainder = sliceUint8(data, last.byteOffset - 8);
    return segmentedRange;
}
function appendUint8Array(data1, data2) {
    const temp = new Uint8Array(data1.length + data2.length);
    temp.set(data1);
    temp.set(data2, data1.length);
    return temp;
}
function parseSamples(timeOffset, track) {
    const seiSamples = [];
    const videoData = track.samples;
    const timescale = track.timescale;
    const trackId = track.id;
    let isHEVCFlavor = false;
    const moofs = findBox(videoData, [
        'moof'
    ]);
    moofs.map((moof)=>{
        const moofOffset = moof.byteOffset - 8;
        const trafs = findBox(moof, [
            'traf'
        ]);
        trafs.map((traf)=>{
            // get the base media decode time from the tfdt
            const baseTime = findBox(traf, [
                'tfdt'
            ]).map((tfdt)=>{
                const version = tfdt[0];
                let result = readUint32(tfdt, 4);
                if (version === 1) {
                    result *= Math.pow(2, 32);
                    result += readUint32(tfdt, 8);
                }
                return result / timescale;
            })[0];
            if (baseTime !== undefined) timeOffset = baseTime;
            return findBox(traf, [
                'tfhd'
            ]).map((tfhd)=>{
                const id = readUint32(tfhd, 4);
                const tfhdFlags = readUint32(tfhd, 0) & 0xffffff;
                const baseDataOffsetPresent = (tfhdFlags & 0x000001) !== 0;
                const sampleDescriptionIndexPresent = (tfhdFlags & 0x000002) !== 0;
                const defaultSampleDurationPresent = (tfhdFlags & 0x000008) !== 0;
                let defaultSampleDuration = 0;
                const defaultSampleSizePresent = (tfhdFlags & 0x000010) !== 0;
                let defaultSampleSize = 0;
                const defaultSampleFlagsPresent = (tfhdFlags & 0x000020) !== 0;
                let tfhdOffset = 8;
                if (id === trackId) {
                    if (baseDataOffsetPresent) tfhdOffset += 8;
                    if (sampleDescriptionIndexPresent) tfhdOffset += 4;
                    if (defaultSampleDurationPresent) {
                        defaultSampleDuration = readUint32(tfhd, tfhdOffset);
                        tfhdOffset += 4;
                    }
                    if (defaultSampleSizePresent) {
                        defaultSampleSize = readUint32(tfhd, tfhdOffset);
                        tfhdOffset += 4;
                    }
                    if (defaultSampleFlagsPresent) tfhdOffset += 4;
                    if (track.type === 'video') isHEVCFlavor = isHEVC(track.codec);
                    findBox(traf, [
                        'trun'
                    ]).map((trun)=>{
                        const version = trun[0];
                        const flags = readUint32(trun, 0) & 0xffffff;
                        const dataOffsetPresent = (flags & 0x000001) !== 0;
                        let dataOffset = 0;
                        const firstSampleFlagsPresent = (flags & 0x000004) !== 0;
                        const sampleDurationPresent = (flags & 0x000100) !== 0;
                        let sampleDuration = 0;
                        const sampleSizePresent = (flags & 0x000200) !== 0;
                        let sampleSize = 0;
                        const sampleFlagsPresent = (flags & 0x000400) !== 0;
                        const sampleCompositionOffsetsPresent = (flags & 0x000800) !== 0;
                        let compositionOffset = 0;
                        const sampleCount = readUint32(trun, 4);
                        let trunOffset = 8; // past version, flags, and sample count
                        if (dataOffsetPresent) {
                            dataOffset = readUint32(trun, trunOffset);
                            trunOffset += 4;
                        }
                        if (firstSampleFlagsPresent) trunOffset += 4;
                        let sampleOffset = dataOffset + moofOffset;
                        for(let ix = 0; ix < sampleCount; ix++){
                            if (sampleDurationPresent) {
                                sampleDuration = readUint32(trun, trunOffset);
                                trunOffset += 4;
                            } else sampleDuration = defaultSampleDuration;
                            if (sampleSizePresent) {
                                sampleSize = readUint32(trun, trunOffset);
                                trunOffset += 4;
                            } else sampleSize = defaultSampleSize;
                            if (sampleFlagsPresent) trunOffset += 4;
                            if (sampleCompositionOffsetsPresent) {
                                if (version === 0) compositionOffset = readUint32(trun, trunOffset);
                                else compositionOffset = readSint32(trun, trunOffset);
                                trunOffset += 4;
                            }
                            if (track.type === ElementaryStreamTypes.VIDEO) {
                                let naluTotalSize = 0;
                                while(naluTotalSize < sampleSize){
                                    const naluSize = readUint32(videoData, sampleOffset);
                                    sampleOffset += 4;
                                    if (isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) {
                                        const data = videoData.subarray(sampleOffset, sampleOffset + naluSize);
                                        parseSEIMessageFromNALu(data, isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
                                    }
                                    sampleOffset += naluSize;
                                    naluTotalSize += naluSize + 4;
                                }
                            }
                            timeOffset += sampleDuration / timescale;
                        }
                    });
                }
            });
        });
    });
    return seiSamples;
}
function isHEVC(codec) {
    if (!codec) return false;
    const delimit = codec.indexOf('.');
    const baseCodec = delimit < 0 ? codec : codec.substring(0, delimit);
    return baseCodec === 'hvc1' || baseCodec === 'hev1' || // Dolby Vision
    baseCodec === 'dvh1' || baseCodec === 'dvhe';
}
function isSEIMessage(isHEVCFlavor, naluHeader) {
    if (isHEVCFlavor) {
        const naluType = naluHeader >> 1 & 0x3f;
        return naluType === 39 || naluType === 40;
    } else {
        const naluType = naluHeader & 0x1f;
        return naluType === 6;
    }
}
function parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
    const data = discardEPB(unescapedData);
    let seiPtr = 0;
    // skip nal header
    seiPtr += headerSize;
    let payloadType = 0;
    let payloadSize = 0;
    let b = 0;
    while(seiPtr < data.length){
        payloadType = 0;
        do {
            if (seiPtr >= data.length) break;
            b = data[seiPtr++];
            payloadType += b;
        }while (b === 0xff);
        // Parse payload size.
        payloadSize = 0;
        do {
            if (seiPtr >= data.length) break;
            b = data[seiPtr++];
            payloadSize += b;
        }while (b === 0xff);
        const leftOver = data.length - seiPtr;
        // Create a variable to process the payload
        let payPtr = seiPtr;
        // Increment the seiPtr to the end of the payload
        if (payloadSize < leftOver) seiPtr += payloadSize;
        else if (payloadSize > leftOver) {
            // Some type of corruption has happened?
            logger.error(`Malformed SEI payload. ${payloadSize} is too small, only ${leftOver} bytes left to parse.`);
            break;
        }
        if (payloadType === 4) {
            const countryCode = data[payPtr++];
            if (countryCode === 181) {
                const providerCode = readUint16(data, payPtr);
                payPtr += 2;
                if (providerCode === 49) {
                    const userStructure = readUint32(data, payPtr);
                    payPtr += 4;
                    if (userStructure === 0x47413934) {
                        const userDataType = data[payPtr++];
                        // Raw CEA-608 bytes wrapped in CEA-708 packet
                        if (userDataType === 3) {
                            const firstByte = data[payPtr++];
                            const totalCCs = 0x1f & firstByte;
                            const enabled = 0x40 & firstByte;
                            const totalBytes = enabled ? 2 + totalCCs * 3 : 0;
                            const byteArray = new Uint8Array(totalBytes);
                            if (enabled) {
                                byteArray[0] = firstByte;
                                for(let i = 1; i < totalBytes; i++)byteArray[i] = data[payPtr++];
                            }
                            samples.push({
                                type: userDataType,
                                payloadType,
                                pts,
                                bytes: byteArray
                            });
                        }
                    }
                }
            }
        } else if (payloadType === 5) {
            if (payloadSize > 16) {
                const uuidStrArray = [];
                for(let i = 0; i < 16; i++){
                    const _b = data[payPtr++].toString(16);
                    uuidStrArray.push(_b.length == 1 ? '0' + _b : _b);
                    if (i === 3 || i === 5 || i === 7 || i === 9) uuidStrArray.push('-');
                }
                const length = payloadSize - 16;
                const userDataBytes = new Uint8Array(length);
                for(let i = 0; i < length; i++)userDataBytes[i] = data[payPtr++];
                samples.push({
                    payloadType,
                    pts,
                    uuid: uuidStrArray.join(''),
                    userData: utf8ArrayToStr(userDataBytes),
                    userDataBytes
                });
            }
        }
    }
}
/**
 * remove Emulation Prevention bytes from a RBSP
 */ function discardEPB(data) {
    const length = data.byteLength;
    const EPBPositions = [];
    let i = 1;
    // Find all `Emulation Prevention Bytes`
    while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
        EPBPositions.push(i + 2);
        i += 2;
    } else i++;
    // If no Emulation Prevention Bytes were found just return the original
    // array
    if (EPBPositions.length === 0) return data;
    // Create a new array to hold the NAL unit data
    const newLength = length - EPBPositions.length;
    const newData = new Uint8Array(newLength);
    let sourceIndex = 0;
    for(i = 0; i < newLength; sourceIndex++, i++){
        if (sourceIndex === EPBPositions[0]) {
            // Skip this byte
            sourceIndex++;
            // Remove this position index
            EPBPositions.shift();
        }
        newData[i] = data[sourceIndex];
    }
    return newData;
}
function parseEmsg(data) {
    const version = data[0];
    let schemeIdUri = '';
    let value = '';
    let timeScale = 0;
    let presentationTimeDelta = 0;
    let presentationTime = 0;
    let eventDuration = 0;
    let id = 0;
    let offset = 0;
    if (version === 0) {
        while(bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            schemeIdUri += bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        schemeIdUri += bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        while(bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            value += bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        value += bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        timeScale = readUint32(data, 12);
        presentationTimeDelta = readUint32(data, 16);
        eventDuration = readUint32(data, 20);
        id = readUint32(data, 24);
        offset = 28;
    } else if (version === 1) {
        offset += 4;
        timeScale = readUint32(data, offset);
        offset += 4;
        const leftPresentationTime = readUint32(data, offset);
        offset += 4;
        const rightPresentationTime = readUint32(data, offset);
        offset += 4;
        presentationTime = 2 ** 32 * leftPresentationTime + rightPresentationTime;
        if (!isSafeInteger(presentationTime)) {
            presentationTime = Number.MAX_SAFE_INTEGER;
            logger.warn('Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box');
        }
        eventDuration = readUint32(data, offset);
        offset += 4;
        id = readUint32(data, offset);
        offset += 4;
        while(bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            schemeIdUri += bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        schemeIdUri += bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        while(bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            value += bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        value += bin2str(data.subarray(offset, offset + 1));
        offset += 1;
    }
    const payload = data.subarray(offset, data.byteLength);
    return {
        schemeIdUri,
        value,
        timeScale,
        presentationTime,
        presentationTimeDelta,
        eventDuration,
        id,
        payload
    };
}
function mp4Box(type, ...payload) {
    const len = payload.length;
    let size = 8;
    let i = len;
    while(i--)size += payload[i].byteLength;
    const result = new Uint8Array(size);
    result[0] = size >> 24 & 0xff;
    result[1] = size >> 16 & 0xff;
    result[2] = size >> 8 & 0xff;
    result[3] = size & 0xff;
    result.set(type, 4);
    for(i = 0, size = 8; i < len; i++){
        result.set(payload[i], size);
        size += payload[i].byteLength;
    }
    return result;
}
function mp4pssh(systemId, keyids, data) {
    if (systemId.byteLength !== 16) throw new RangeError('Invalid system id');
    let version;
    let kids;
    if (keyids) {
        version = 1;
        kids = new Uint8Array(keyids.length * 16);
        for(let ix = 0; ix < keyids.length; ix++){
            const k = keyids[ix]; // uint8array
            if (k.byteLength !== 16) throw new RangeError('Invalid key');
            kids.set(k, ix * 16);
        }
    } else {
        version = 0;
        kids = new Uint8Array();
    }
    let kidCount;
    if (version > 0) {
        kidCount = new Uint8Array(4);
        if (keyids.length > 0) new DataView(kidCount.buffer).setUint32(0, keyids.length, false);
    } else kidCount = new Uint8Array();
    const dataSize = new Uint8Array(4);
    if (data && data.byteLength > 0) new DataView(dataSize.buffer).setUint32(0, data.byteLength, false);
    return mp4Box([
        112,
        115,
        115,
        104
    ], new Uint8Array([
        version,
        0x00,
        0x00,
        0x00 // Flags
    ]), systemId, // 16 bytes
    kidCount, kids, dataSize, data || new Uint8Array());
}
function parsePssh(initData) {
    if (!(initData instanceof ArrayBuffer) || initData.byteLength < 32) return null;
    const result = {
        version: 0,
        systemId: '',
        kids: null,
        data: null
    };
    const view = new DataView(initData);
    const boxSize = view.getUint32(0);
    if (initData.byteLength !== boxSize && boxSize > 44) return null;
    const type = view.getUint32(4);
    if (type !== 0x70737368) return null;
    result.version = view.getUint32(8) >>> 24;
    if (result.version > 1) return null;
    result.systemId = Hex.hexDump(new Uint8Array(initData, 12, 16));
    const dataSizeOrKidCount = view.getUint32(28);
    if (result.version === 0) {
        if (boxSize - 32 < dataSizeOrKidCount) return null;
        result.data = new Uint8Array(initData, 32, dataSizeOrKidCount);
    } else if (result.version === 1) {
        result.kids = [];
        for(let i = 0; i < dataSizeOrKidCount; i++)result.kids.push(new Uint8Array(initData, 32 + i * 16, 16));
    }
    return result;
}
let keyUriToKeyIdMap = {};
class LevelKey {
    static clearKeyUriToKeyIdMap() {
        keyUriToKeyIdMap = {};
    }
    constructor(method, uri, format, formatversions = [
        1
    ], iv = null){
        this.uri = void 0;
        this.method = void 0;
        this.keyFormat = void 0;
        this.keyFormatVersions = void 0;
        this.encrypted = void 0;
        this.isCommonEncryption = void 0;
        this.iv = null;
        this.key = null;
        this.keyId = null;
        this.pssh = null;
        this.method = method;
        this.uri = uri;
        this.keyFormat = format;
        this.keyFormatVersions = formatversions;
        this.iv = iv;
        this.encrypted = method ? method !== 'NONE' : false;
        this.isCommonEncryption = this.encrypted && method !== 'AES-128';
    }
    isSupported() {
        // If it's Segment encryption or No encryption, just select that key system
        if (this.method) {
            if (this.method === 'AES-128' || this.method === 'NONE') return true;
            if (this.keyFormat === 'identity') // Maintain support for clear SAMPLE-AES with MPEG-3 TS
            return this.method === 'SAMPLE-AES';
            else switch(this.keyFormat){
                case KeySystemFormats.FAIRPLAY:
                case KeySystemFormats.WIDEVINE:
                case KeySystemFormats.PLAYREADY:
                case KeySystemFormats.CLEARKEY:
                    return [
                        'ISO-23001-7',
                        'SAMPLE-AES',
                        'SAMPLE-AES-CENC',
                        'SAMPLE-AES-CTR'
                    ].indexOf(this.method) !== -1;
            }
        }
        return false;
    }
    getDecryptData(sn) {
        if (!this.encrypted || !this.uri) return null;
        if (this.method === 'AES-128' && this.uri && !this.iv) {
            if (typeof sn !== 'number') {
                // We are fetching decryption data for a initialization segment
                // If the segment was encrypted with AES-128
                // It must have an IV defined. We cannot substitute the Segment Number in.
                if (this.method === 'AES-128' && !this.iv) logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`);
                // Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
                sn = 0;
            }
            const iv = createInitializationVector(sn);
            const decryptdata = new LevelKey(this.method, this.uri, 'identity', this.keyFormatVersions, iv);
            return decryptdata;
        }
        // Initialize keyId if possible
        const keyBytes = convertDataUriToArrayBytes(this.uri);
        if (keyBytes) switch(this.keyFormat){
            case KeySystemFormats.WIDEVINE:
                this.pssh = keyBytes;
                // In case of widevine keyID is embedded in PSSH box. Read Key ID.
                if (keyBytes.length >= 22) this.keyId = keyBytes.subarray(keyBytes.length - 22, keyBytes.length - 6);
                break;
            case KeySystemFormats.PLAYREADY:
                {
                    const PlayReadyKeySystemUUID = new Uint8Array([
                        0x9a,
                        0x04,
                        0xf0,
                        0x79,
                        0x98,
                        0x40,
                        0x42,
                        0x86,
                        0xab,
                        0x92,
                        0xe6,
                        0x5b,
                        0xe0,
                        0x88,
                        0x5f,
                        0x95
                    ]);
                    this.pssh = mp4pssh(PlayReadyKeySystemUUID, null, keyBytes);
                    const keyBytesUtf16 = new Uint16Array(keyBytes.buffer, keyBytes.byteOffset, keyBytes.byteLength / 2);
                    const keyByteStr = String.fromCharCode.apply(null, Array.from(keyBytesUtf16));
                    // Parse Playready WRMHeader XML
                    const xmlKeyBytes = keyByteStr.substring(keyByteStr.indexOf('<'), keyByteStr.length);
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(xmlKeyBytes, 'text/xml');
                    const keyData = xmlDoc.getElementsByTagName('KID')[0];
                    if (keyData) {
                        const keyId = keyData.childNodes[0] ? keyData.childNodes[0].nodeValue : keyData.getAttribute('VALUE');
                        if (keyId) {
                            const keyIdArray = base64Decode(keyId).subarray(0, 16);
                            // KID value in PRO is a base64-encoded little endian GUID interpretation of UUID
                            // KID value in ‘tenc’ is a big endian UUID GUID interpretation of UUID
                            changeEndianness(keyIdArray);
                            this.keyId = keyIdArray;
                        }
                    }
                    break;
                }
            default:
                {
                    let keydata = keyBytes.subarray(0, 16);
                    if (keydata.length !== 16) {
                        const padded = new Uint8Array(16);
                        padded.set(keydata, 16 - keydata.length);
                        keydata = padded;
                    }
                    this.keyId = keydata;
                    break;
                }
        }
        // Default behavior: assign a new keyId for each uri
        if (!this.keyId || this.keyId.byteLength !== 16) {
            let keyId = keyUriToKeyIdMap[this.uri];
            if (!keyId) {
                const val = Object.keys(keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
                keyId = new Uint8Array(16);
                const dv = new DataView(keyId.buffer, 12, 4); // Just set the last 4 bytes
                dv.setUint32(0, val);
                keyUriToKeyIdMap[this.uri] = keyId;
            }
            this.keyId = keyId;
        }
        return this;
    }
}
function createInitializationVector(segmentNumber) {
    const uint8View = new Uint8Array(16);
    for(let i = 12; i < 16; i++)uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
    return uint8View;
}
const VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function hasVariableReferences(str) {
    return VARIABLE_REPLACEMENT_REGEX.test(str);
}
function substituteVariablesInAttributes(parsed, attr, attributeNames) {
    if (parsed.variableList !== null || parsed.hasVariableRefs) for(let i = attributeNames.length; i--;){
        const name = attributeNames[i];
        const value = attr[name];
        if (value) attr[name] = substituteVariables(parsed, value);
    }
}
function substituteVariables(parsed, value) {
    if (parsed.variableList !== null || parsed.hasVariableRefs) {
        const variableList = parsed.variableList;
        return value.replace(VARIABLE_REPLACEMENT_REGEX, (variableReference)=>{
            const variableName = variableReference.substring(2, variableReference.length - 1);
            const variableValue = variableList == null ? void 0 : variableList[variableName];
            if (variableValue === undefined) {
                parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${variableName}"`));
                return variableReference;
            }
            return variableValue;
        });
    }
    return value;
}
function addVariableDefinition(parsed, attr, parentUrl) {
    let variableList = parsed.variableList;
    if (!variableList) parsed.variableList = variableList = {};
    let NAME;
    let VALUE;
    if ('QUERYPARAM' in attr) {
        NAME = attr.QUERYPARAM;
        try {
            const searchParams = new self.URL(parentUrl).searchParams;
            if (searchParams.has(NAME)) VALUE = searchParams.get(NAME);
            else throw new Error(`"${NAME}" does not match any query parameter in URI: "${parentUrl}"`);
        } catch (error) {
            parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${error.message}`));
        }
    } else {
        NAME = attr.NAME;
        VALUE = attr.VALUE;
    }
    if (NAME in variableList) parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${NAME}"`));
    else variableList[NAME] = VALUE || '';
}
function importVariableDefinition(parsed, attr, sourceVariableList) {
    const IMPORT = attr.IMPORT;
    if (sourceVariableList && IMPORT in sourceVariableList) {
        let variableList = parsed.variableList;
        if (!variableList) parsed.variableList = variableList = {};
        variableList[IMPORT] = sourceVariableList[IMPORT];
    } else parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${IMPORT}"`));
}
/**
 * MediaSource helper
 */ function getMediaSource(preferManagedMediaSource = true) {
    if (typeof self === 'undefined') return undefined;
    const mms = (preferManagedMediaSource || !self.MediaSource) && self.ManagedMediaSource;
    return mms || self.MediaSource || self.WebKitMediaSource;
}
function isManagedMediaSource(source) {
    return typeof self !== 'undefined' && source === self.ManagedMediaSource;
}
// from http://mp4ra.org/codecs.html
// values indicate codec selection preference (lower is higher priority)
const sampleEntryCodesISO = {
    audio: {
        a3ds: 1,
        'ac-3': 0.95,
        'ac-4': 1,
        alac: 0.9,
        alaw: 1,
        dra1: 1,
        'dts+': 1,
        'dts-': 1,
        dtsc: 1,
        dtse: 1,
        dtsh: 1,
        'ec-3': 0.9,
        enca: 1,
        fLaC: 0.9,
        // MP4-RA listed codec entry for FLAC
        flac: 0.9,
        // legacy browser codec name for FLAC
        FLAC: 0.9,
        // some manifests may list "FLAC" with Apple's tools
        g719: 1,
        g726: 1,
        m4ae: 1,
        mha1: 1,
        mha2: 1,
        mhm1: 1,
        mhm2: 1,
        mlpa: 1,
        mp4a: 1,
        'raw ': 1,
        Opus: 1,
        opus: 1,
        // browsers expect this to be lowercase despite MP4RA says 'Opus'
        samr: 1,
        sawb: 1,
        sawp: 1,
        sevc: 1,
        sqcp: 1,
        ssmv: 1,
        twos: 1,
        ulaw: 1
    },
    video: {
        avc1: 1,
        avc2: 1,
        avc3: 1,
        avc4: 1,
        avcp: 1,
        av01: 0.8,
        drac: 1,
        dva1: 1,
        dvav: 1,
        dvh1: 0.7,
        dvhe: 0.7,
        encv: 1,
        hev1: 0.75,
        hvc1: 0.75,
        mjp2: 1,
        mp4v: 1,
        mvc1: 1,
        mvc2: 1,
        mvc3: 1,
        mvc4: 1,
        resv: 1,
        rv60: 1,
        s263: 1,
        svc1: 1,
        svc2: 1,
        'vc-1': 1,
        vp08: 1,
        vp09: 0.9
    },
    text: {
        stpp: 1,
        wvtt: 1
    }
};
function isCodecType(codec, type) {
    const typeCodes = sampleEntryCodesISO[type];
    return !!typeCodes && !!typeCodes[codec.slice(0, 4)];
}
function areCodecsMediaSourceSupported(codecs, type, preferManagedMediaSource = true) {
    return !codecs.split(',').some((codec)=>!isCodecMediaSourceSupported(codec, type, preferManagedMediaSource));
}
function isCodecMediaSourceSupported(codec, type, preferManagedMediaSource = true) {
    var _MediaSource$isTypeSu;
    const MediaSource = getMediaSource(preferManagedMediaSource);
    return (_MediaSource$isTypeSu = MediaSource == null ? void 0 : MediaSource.isTypeSupported(mimeTypeForCodec(codec, type))) != null ? _MediaSource$isTypeSu : false;
}
function mimeTypeForCodec(codec, type) {
    return `${type}/mp4;codecs="${codec}"`;
}
function videoCodecPreferenceValue(videoCodec) {
    if (videoCodec) {
        const fourCC = videoCodec.substring(0, 4);
        return sampleEntryCodesISO.video[fourCC];
    }
    return 2;
}
function codecsSetSelectionPreferenceValue(codecSet) {
    return codecSet.split(',').reduce((num, fourCC)=>{
        const preferenceValue = sampleEntryCodesISO.video[fourCC];
        if (preferenceValue) return (preferenceValue * 2 + num) / (num ? 3 : 2);
        return (sampleEntryCodesISO.audio[fourCC] + num) / (num ? 2 : 1);
    }, 0);
}
const CODEC_COMPATIBLE_NAMES = {};
function getCodecCompatibleNameLower(lowerCaseCodec, preferManagedMediaSource = true) {
    if (CODEC_COMPATIBLE_NAMES[lowerCaseCodec]) return CODEC_COMPATIBLE_NAMES[lowerCaseCodec];
    // Idealy fLaC and Opus would be first (spec-compliant) but
    // some browsers will report that fLaC is supported then fail.
    // see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
    const codecsToCheck = {
        flac: [
            'flac',
            'fLaC',
            'FLAC'
        ],
        opus: [
            'opus',
            'Opus'
        ]
    }[lowerCaseCodec];
    for(let i = 0; i < codecsToCheck.length; i++)if (isCodecMediaSourceSupported(codecsToCheck[i], 'audio', preferManagedMediaSource)) {
        CODEC_COMPATIBLE_NAMES[lowerCaseCodec] = codecsToCheck[i];
        return codecsToCheck[i];
    }
    return lowerCaseCodec;
}
const AUDIO_CODEC_REGEXP = /flac|opus/i;
function getCodecCompatibleName(codec, preferManagedMediaSource = true) {
    return codec.replace(AUDIO_CODEC_REGEXP, (m)=>getCodecCompatibleNameLower(m.toLowerCase(), preferManagedMediaSource));
}
function pickMostCompleteCodecName(parsedCodec, levelCodec) {
    // Parsing of mp4a codecs strings in mp4-tools from media is incomplete as of d8c6c7a
    // so use level codec is parsed codec is unavailable or incomplete
    if (parsedCodec && parsedCodec !== 'mp4a') return parsedCodec;
    return levelCodec ? levelCodec.split(',')[0] : levelCodec;
}
function convertAVC1ToAVCOTI(codec) {
    // Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
    const avcdata = codec.split('.');
    if (avcdata.length > 2) {
        let result = avcdata.shift() + '.';
        result += parseInt(avcdata.shift()).toString(16);
        result += ('000' + parseInt(avcdata.shift()).toString(16)).slice(-4);
        return result;
    }
    return codec;
}
const MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;
const MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
const IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m; // Handle empty Media Playlist (first EXTINF not signaled, but TARGETDURATION present)
const LEVEL_PLAYLIST_REGEX_FAST = new RegExp([
    /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
    // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
    /(?!#) *(\S[\S ]*)/.source,
    // segment URI, group 3 => the URI (note newline is not eaten)
    /#EXT-X-BYTERANGE:*(.+)/.source,
    // next segment's byterange, group 4 => range spec (x@y)
    /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
    // next segment's program date/time group 5 => the datetime spec
    /#.*/.source // All other non-segment oriented tags will match with all groups empty
].join('|'), 'g');
const LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([
    /#(EXTM3U)/.source,
    /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source,
    /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source,
    /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source,
    /(#)([^:]*):(.*)/.source,
    /(#)(.*)(?:.*)\r?\n?/.source
].join('|'));
class M3U8Parser {
    static findGroup(groups, mediaGroupId) {
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            if (group.id === mediaGroupId) return group;
        }
    }
    static resolve(url, baseUrl) {
        return urlToolkitExports.buildAbsoluteURL(baseUrl, url, {
            alwaysNormalize: true
        });
    }
    static isMediaPlaylist(str) {
        return IS_MEDIA_PLAYLIST.test(str);
    }
    static parseMasterPlaylist(string, baseurl) {
        const hasVariableRefs = hasVariableReferences(string);
        const parsed = {
            contentSteering: null,
            levels: [],
            playlistParsingError: null,
            sessionData: null,
            sessionKeys: null,
            startTimeOffset: null,
            variableList: null,
            hasVariableRefs
        };
        const levelsWithKnownCodecs = [];
        MASTER_PLAYLIST_REGEX.lastIndex = 0;
        let result;
        while((result = MASTER_PLAYLIST_REGEX.exec(string)) != null){
            if (result[1]) {
                var _level$unknownCodecs;
                // '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
                const attrs = new AttrList(result[1]);
                substituteVariablesInAttributes(parsed, attrs, [
                    'CODECS',
                    'SUPPLEMENTAL-CODECS',
                    'ALLOWED-CPC',
                    'PATHWAY-ID',
                    'STABLE-VARIANT-ID',
                    'AUDIO',
                    'VIDEO',
                    'SUBTITLES',
                    'CLOSED-CAPTIONS',
                    'NAME'
                ]);
                const uri = substituteVariables(parsed, result[2]);
                const level = {
                    attrs,
                    bitrate: attrs.decimalInteger('BANDWIDTH') || attrs.decimalInteger('AVERAGE-BANDWIDTH'),
                    name: attrs.NAME,
                    url: M3U8Parser.resolve(uri, baseurl)
                };
                const resolution = attrs.decimalResolution('RESOLUTION');
                if (resolution) {
                    level.width = resolution.width;
                    level.height = resolution.height;
                }
                setCodecs(attrs.CODECS, level);
                if (!((_level$unknownCodecs = level.unknownCodecs) != null && _level$unknownCodecs.length)) levelsWithKnownCodecs.push(level);
                parsed.levels.push(level);
            } else if (result[3]) {
                const tag = result[3];
                const attributes = result[4];
                switch(tag){
                    case 'SESSION-DATA':
                        {
                            // #EXT-X-SESSION-DATA
                            const sessionAttrs = new AttrList(attributes);
                            substituteVariablesInAttributes(parsed, sessionAttrs, [
                                'DATA-ID',
                                'LANGUAGE',
                                'VALUE',
                                'URI'
                            ]);
                            const dataId = sessionAttrs['DATA-ID'];
                            if (dataId) {
                                if (parsed.sessionData === null) parsed.sessionData = {};
                                parsed.sessionData[dataId] = sessionAttrs;
                            }
                            break;
                        }
                    case 'SESSION-KEY':
                        {
                            // #EXT-X-SESSION-KEY
                            const sessionKey = parseKey(attributes, baseurl, parsed);
                            if (sessionKey.encrypted && sessionKey.isSupported()) {
                                if (parsed.sessionKeys === null) parsed.sessionKeys = [];
                                parsed.sessionKeys.push(sessionKey);
                            } else logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${attributes}"`);
                            break;
                        }
                    case 'DEFINE':
                        // #EXT-X-DEFINE
                        {
                            const variableAttributes = new AttrList(attributes);
                            substituteVariablesInAttributes(parsed, variableAttributes, [
                                'NAME',
                                'VALUE',
                                'QUERYPARAM'
                            ]);
                            addVariableDefinition(parsed, variableAttributes, baseurl);
                        }
                        break;
                    case 'CONTENT-STEERING':
                        {
                            // #EXT-X-CONTENT-STEERING
                            const contentSteeringAttributes = new AttrList(attributes);
                            substituteVariablesInAttributes(parsed, contentSteeringAttributes, [
                                'SERVER-URI',
                                'PATHWAY-ID'
                            ]);
                            parsed.contentSteering = {
                                uri: M3U8Parser.resolve(contentSteeringAttributes['SERVER-URI'], baseurl),
                                pathwayId: contentSteeringAttributes['PATHWAY-ID'] || '.'
                            };
                            break;
                        }
                    case 'START':
                        // #EXT-X-START
                        parsed.startTimeOffset = parseStartTimeOffset(attributes);
                        break;
                }
            }
        }
        // Filter out levels with unknown codecs if it does not remove all levels
        const stripUnknownCodecLevels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < parsed.levels.length;
        parsed.levels = stripUnknownCodecLevels ? levelsWithKnownCodecs : parsed.levels;
        if (parsed.levels.length === 0) parsed.playlistParsingError = new Error('no levels found in manifest');
        return parsed;
    }
    static parseMasterPlaylistMedia(string, baseurl, parsed) {
        let result;
        const results = {};
        const levels = parsed.levels;
        const groupsByType = {
            AUDIO: levels.map((level)=>({
                    id: level.attrs.AUDIO,
                    audioCodec: level.audioCodec
                })),
            SUBTITLES: levels.map((level)=>({
                    id: level.attrs.SUBTITLES,
                    textCodec: level.textCodec
                })),
            'CLOSED-CAPTIONS': []
        };
        let id = 0;
        MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
        while((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null){
            const attrs = new AttrList(result[1]);
            const type = attrs.TYPE;
            if (type) {
                const groups = groupsByType[type];
                const medias = results[type] || [];
                results[type] = medias;
                substituteVariablesInAttributes(parsed, attrs, [
                    'URI',
                    'GROUP-ID',
                    'LANGUAGE',
                    'ASSOC-LANGUAGE',
                    'STABLE-RENDITION-ID',
                    'NAME',
                    'INSTREAM-ID',
                    'CHARACTERISTICS',
                    'CHANNELS'
                ]);
                const lang = attrs.LANGUAGE;
                const assocLang = attrs['ASSOC-LANGUAGE'];
                const channels = attrs.CHANNELS;
                const characteristics = attrs.CHARACTERISTICS;
                const instreamId = attrs['INSTREAM-ID'];
                const media = {
                    attrs,
                    bitrate: 0,
                    id: id++,
                    groupId: attrs['GROUP-ID'] || '',
                    name: attrs.NAME || lang || '',
                    type,
                    default: attrs.bool('DEFAULT'),
                    autoselect: attrs.bool('AUTOSELECT'),
                    forced: attrs.bool('FORCED'),
                    lang,
                    url: attrs.URI ? M3U8Parser.resolve(attrs.URI, baseurl) : ''
                };
                if (assocLang) media.assocLang = assocLang;
                if (channels) media.channels = channels;
                if (characteristics) media.characteristics = characteristics;
                if (instreamId) media.instreamId = instreamId;
                if (groups != null && groups.length) {
                    // If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
                    // If we don't find the track signalled, lets use the first audio groups codec we have
                    // Acting as a best guess
                    const groupCodec = M3U8Parser.findGroup(groups, media.groupId) || groups[0];
                    assignCodec(media, groupCodec, 'audioCodec');
                    assignCodec(media, groupCodec, 'textCodec');
                }
                medias.push(media);
            }
        }
        return results;
    }
    static parseLevelPlaylist(string, baseurl, id, type, levelUrlId, multivariantVariableList) {
        const level = new LevelDetails(baseurl);
        const fragments = level.fragments;
        // The most recent init segment seen (applies to all subsequent segments)
        let currentInitSegment = null;
        let currentSN = 0;
        let currentPart = 0;
        let totalduration = 0;
        let discontinuityCounter = 0;
        let prevFrag = null;
        let frag = new Fragment(type, baseurl);
        let result;
        let i;
        let levelkeys;
        let firstPdtIndex = -1;
        let createNextFrag = false;
        let nextByteRange = null;
        LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
        level.m3u8 = string;
        level.hasVariableRefs = hasVariableReferences(string);
        while((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null){
            if (createNextFrag) {
                createNextFrag = false;
                frag = new Fragment(type, baseurl);
                // setup the next fragment for part loading
                frag.start = totalduration;
                frag.sn = currentSN;
                frag.cc = discontinuityCounter;
                frag.level = id;
                if (currentInitSegment) {
                    frag.initSegment = currentInitSegment;
                    frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                    currentInitSegment.rawProgramDateTime = null;
                    if (nextByteRange) {
                        frag.setByteRange(nextByteRange);
                        nextByteRange = null;
                    }
                }
            }
            const duration = result[1];
            if (duration) {
                // INF
                frag.duration = parseFloat(duration);
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                const title = (' ' + result[2]).slice(1);
                frag.title = title || null;
                frag.tagList.push(title ? [
                    'INF',
                    duration,
                    title
                ] : [
                    'INF',
                    duration
                ]);
            } else if (result[3]) // url
            {
                if (isFiniteNumber(frag.duration)) {
                    frag.start = totalduration;
                    if (levelkeys) setFragLevelKeys(frag, levelkeys, level);
                    frag.sn = currentSN;
                    frag.level = id;
                    frag.cc = discontinuityCounter;
                    fragments.push(frag);
                    // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                    const uri = (' ' + result[3]).slice(1);
                    frag.relurl = substituteVariables(level, uri);
                    assignProgramDateTime(frag, prevFrag);
                    prevFrag = frag;
                    totalduration += frag.duration;
                    currentSN++;
                    currentPart = 0;
                    createNextFrag = true;
                }
            } else if (result[4]) {
                // X-BYTERANGE
                const data = (' ' + result[4]).slice(1);
                if (prevFrag) frag.setByteRange(data, prevFrag);
                else frag.setByteRange(data);
            } else if (result[5]) {
                // PROGRAM-DATE-TIME
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                frag.rawProgramDateTime = (' ' + result[5]).slice(1);
                frag.tagList.push([
                    'PROGRAM-DATE-TIME',
                    frag.rawProgramDateTime
                ]);
                if (firstPdtIndex === -1) firstPdtIndex = fragments.length;
            } else {
                result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
                if (!result) {
                    logger.warn('No matches on slow regex match for level playlist!');
                    continue;
                }
                for(i = 1; i < result.length; i++){
                    if (typeof result[i] !== 'undefined') break;
                }
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                const tag = (' ' + result[i]).slice(1);
                const value1 = (' ' + result[i + 1]).slice(1);
                const value2 = result[i + 2] ? (' ' + result[i + 2]).slice(1) : '';
                switch(tag){
                    case 'PLAYLIST-TYPE':
                        level.type = value1.toUpperCase();
                        break;
                    case 'MEDIA-SEQUENCE':
                        currentSN = level.startSN = parseInt(value1);
                        break;
                    case 'SKIP':
                        {
                            const skipAttrs = new AttrList(value1);
                            substituteVariablesInAttributes(level, skipAttrs, [
                                'RECENTLY-REMOVED-DATERANGES'
                            ]);
                            const skippedSegments = skipAttrs.decimalInteger('SKIPPED-SEGMENTS');
                            if (isFiniteNumber(skippedSegments)) {
                                level.skippedSegments = skippedSegments;
                                // This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
                                for(let _i = skippedSegments; _i--;)fragments.unshift(null);
                                currentSN += skippedSegments;
                            }
                            const recentlyRemovedDateranges = skipAttrs.enumeratedString('RECENTLY-REMOVED-DATERANGES');
                            if (recentlyRemovedDateranges) level.recentlyRemovedDateranges = recentlyRemovedDateranges.split('\t');
                            break;
                        }
                    case 'TARGETDURATION':
                        level.targetduration = Math.max(parseInt(value1), 1);
                        break;
                    case 'VERSION':
                        level.version = parseInt(value1);
                        break;
                    case 'INDEPENDENT-SEGMENTS':
                    case 'EXTM3U':
                        break;
                    case 'ENDLIST':
                        level.live = false;
                        break;
                    case '#':
                        if (value1 || value2) frag.tagList.push(value2 ? [
                            value1,
                            value2
                        ] : [
                            value1
                        ]);
                        break;
                    case 'DISCONTINUITY':
                        discontinuityCounter++;
                        frag.tagList.push([
                            'DIS'
                        ]);
                        break;
                    case 'GAP':
                        frag.gap = true;
                        frag.tagList.push([
                            tag
                        ]);
                        break;
                    case 'BITRATE':
                        frag.tagList.push([
                            tag,
                            value1
                        ]);
                        break;
                    case 'DATERANGE':
                        {
                            const dateRangeAttr = new AttrList(value1);
                            substituteVariablesInAttributes(level, dateRangeAttr, [
                                'ID',
                                'CLASS',
                                'START-DATE',
                                'END-DATE',
                                'SCTE35-CMD',
                                'SCTE35-OUT',
                                'SCTE35-IN'
                            ]);
                            substituteVariablesInAttributes(level, dateRangeAttr, dateRangeAttr.clientAttrs);
                            const dateRange = new DateRange(dateRangeAttr, level.dateRanges[dateRangeAttr.ID]);
                            if (dateRange.isValid || level.skippedSegments) level.dateRanges[dateRange.id] = dateRange;
                            else logger.warn(`Ignoring invalid DATERANGE tag: "${value1}"`);
                            // Add to fragment tag list for backwards compatibility (< v1.2.0)
                            frag.tagList.push([
                                'EXT-X-DATERANGE',
                                value1
                            ]);
                            break;
                        }
                    case 'DEFINE':
                        {
                            const variableAttributes = new AttrList(value1);
                            substituteVariablesInAttributes(level, variableAttributes, [
                                'NAME',
                                'VALUE',
                                'IMPORT',
                                'QUERYPARAM'
                            ]);
                            if ('IMPORT' in variableAttributes) importVariableDefinition(level, variableAttributes, multivariantVariableList);
                            else addVariableDefinition(level, variableAttributes, baseurl);
                        }
                        break;
                    case 'DISCONTINUITY-SEQUENCE':
                        discontinuityCounter = parseInt(value1);
                        break;
                    case 'KEY':
                        {
                            const levelKey = parseKey(value1, baseurl, level);
                            if (levelKey.isSupported()) {
                                if (levelKey.method === 'NONE') {
                                    levelkeys = undefined;
                                    break;
                                }
                                if (!levelkeys) levelkeys = {};
                                if (levelkeys[levelKey.keyFormat]) levelkeys = _extends({}, levelkeys);
                                levelkeys[levelKey.keyFormat] = levelKey;
                            } else logger.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${value1}"`);
                            break;
                        }
                    case 'START':
                        level.startTimeOffset = parseStartTimeOffset(value1);
                        break;
                    case 'MAP':
                        {
                            const mapAttrs = new AttrList(value1);
                            substituteVariablesInAttributes(level, mapAttrs, [
                                'BYTERANGE',
                                'URI'
                            ]);
                            if (frag.duration) {
                                // Initial segment tag is after segment duration tag.
                                //   #EXTINF: 6.0
                                //   #EXT-X-MAP:URI="init.mp4
                                const init = new Fragment(type, baseurl);
                                setInitSegment(init, mapAttrs, id, levelkeys);
                                currentInitSegment = init;
                                frag.initSegment = currentInitSegment;
                                if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                            } else {
                                // Initial segment tag is before segment duration tag
                                // Handle case where EXT-X-MAP is declared after EXT-X-BYTERANGE
                                const end = frag.byteRangeEndOffset;
                                if (end) {
                                    const start = frag.byteRangeStartOffset;
                                    nextByteRange = `${end - start}@${start}`;
                                } else nextByteRange = null;
                                setInitSegment(frag, mapAttrs, id, levelkeys);
                                currentInitSegment = frag;
                                createNextFrag = true;
                            }
                            break;
                        }
                    case 'SERVER-CONTROL':
                        {
                            const serverControlAttrs = new AttrList(value1);
                            level.canBlockReload = serverControlAttrs.bool('CAN-BLOCK-RELOAD');
                            level.canSkipUntil = serverControlAttrs.optionalFloat('CAN-SKIP-UNTIL', 0);
                            level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool('CAN-SKIP-DATERANGES');
                            level.partHoldBack = serverControlAttrs.optionalFloat('PART-HOLD-BACK', 0);
                            level.holdBack = serverControlAttrs.optionalFloat('HOLD-BACK', 0);
                            break;
                        }
                    case 'PART-INF':
                        {
                            const partInfAttrs = new AttrList(value1);
                            level.partTarget = partInfAttrs.decimalFloatingPoint('PART-TARGET');
                            break;
                        }
                    case 'PART':
                        {
                            let partList = level.partList;
                            if (!partList) partList = level.partList = [];
                            const previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : undefined;
                            const index = currentPart++;
                            const partAttrs = new AttrList(value1);
                            substituteVariablesInAttributes(level, partAttrs, [
                                'BYTERANGE',
                                'URI'
                            ]);
                            const part = new Part(partAttrs, frag, baseurl, index, previousFragmentPart);
                            partList.push(part);
                            frag.duration += part.duration;
                            break;
                        }
                    case 'PRELOAD-HINT':
                        {
                            const preloadHintAttrs = new AttrList(value1);
                            substituteVariablesInAttributes(level, preloadHintAttrs, [
                                'URI'
                            ]);
                            level.preloadHint = preloadHintAttrs;
                            break;
                        }
                    case 'RENDITION-REPORT':
                        {
                            const renditionReportAttrs = new AttrList(value1);
                            substituteVariablesInAttributes(level, renditionReportAttrs, [
                                'URI'
                            ]);
                            level.renditionReports = level.renditionReports || [];
                            level.renditionReports.push(renditionReportAttrs);
                            break;
                        }
                    default:
                        logger.warn(`line parsed but not handled: ${result}`);
                        break;
                }
            }
        }
        if (prevFrag && !prevFrag.relurl) {
            fragments.pop();
            totalduration -= prevFrag.duration;
            if (level.partList) level.fragmentHint = prevFrag;
        } else if (level.partList) {
            assignProgramDateTime(frag, prevFrag);
            frag.cc = discontinuityCounter;
            level.fragmentHint = frag;
            if (levelkeys) setFragLevelKeys(frag, levelkeys, level);
        }
        const fragmentLength = fragments.length;
        const firstFragment = fragments[0];
        const lastFragment = fragments[fragmentLength - 1];
        totalduration += level.skippedSegments * level.targetduration;
        if (totalduration > 0 && fragmentLength && lastFragment) {
            level.averagetargetduration = totalduration / fragmentLength;
            const lastSn = lastFragment.sn;
            level.endSN = lastSn !== 'initSegment' ? lastSn : 0;
            if (!level.live) lastFragment.endList = true;
            if (firstFragment) level.startCC = firstFragment.cc;
        } else {
            level.endSN = 0;
            level.startCC = 0;
        }
        if (level.fragmentHint) totalduration += level.fragmentHint.duration;
        level.totalduration = totalduration;
        level.endCC = discontinuityCounter;
        /**
     * Backfill any missing PDT values
     * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
     * one or more Media Segment URIs, the client SHOULD extrapolate
     * backward from that tag (using EXTINF durations and/or media
     * timestamps) to associate dates with those segments."
     * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
     * computed.
     */ if (firstPdtIndex > 0) backfillProgramDateTimes(fragments, firstPdtIndex);
        return level;
    }
}
function parseKey(keyTagAttributes, baseurl, parsed) {
    var _keyAttrs$METHOD, _keyAttrs$KEYFORMAT;
    // https://tools.ietf.org/html/rfc8216#section-4.3.2.4
    const keyAttrs = new AttrList(keyTagAttributes);
    substituteVariablesInAttributes(parsed, keyAttrs, [
        'KEYFORMAT',
        'KEYFORMATVERSIONS',
        'URI',
        'IV',
        'URI'
    ]);
    const decryptmethod = (_keyAttrs$METHOD = keyAttrs.METHOD) != null ? _keyAttrs$METHOD : '';
    const decrypturi = keyAttrs.URI;
    const decryptiv = keyAttrs.hexadecimalInteger('IV');
    const decryptkeyformatversions = keyAttrs.KEYFORMATVERSIONS;
    // From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
    const decryptkeyformat = (_keyAttrs$KEYFORMAT = keyAttrs.KEYFORMAT) != null ? _keyAttrs$KEYFORMAT : 'identity';
    if (decrypturi && keyAttrs.IV && !decryptiv) logger.error(`Invalid IV: ${keyAttrs.IV}`);
    // If decrypturi is a URI with a scheme, then baseurl will be ignored
    // No uri is allowed when METHOD is NONE
    const resolvedUri = decrypturi ? M3U8Parser.resolve(decrypturi, baseurl) : '';
    const keyFormatVersions = (decryptkeyformatversions ? decryptkeyformatversions : '1').split('/').map(Number).filter(Number.isFinite);
    return new LevelKey(decryptmethod, resolvedUri, decryptkeyformat, keyFormatVersions, decryptiv);
}
function parseStartTimeOffset(startAttributes) {
    const startAttrs = new AttrList(startAttributes);
    const startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
    if (isFiniteNumber(startTimeOffset)) return startTimeOffset;
    return null;
}
function setCodecs(codecsAttributeValue, level) {
    let codecs = (codecsAttributeValue || '').split(/[ ,]+/).filter((c)=>c);
    [
        'video',
        'audio',
        'text'
    ].forEach((type)=>{
        const filtered = codecs.filter((codec)=>isCodecType(codec, type));
        if (filtered.length) {
            // Comma separated list of all codecs for type
            level[`${type}Codec`] = filtered.join(',');
            // Remove known codecs so that only unknownCodecs are left after iterating through each type
            codecs = codecs.filter((codec)=>filtered.indexOf(codec) === -1);
        }
    });
    level.unknownCodecs = codecs;
}
function assignCodec(media, groupItem, codecProperty) {
    const codecValue = groupItem[codecProperty];
    if (codecValue) media[codecProperty] = codecValue;
}
function backfillProgramDateTimes(fragments, firstPdtIndex) {
    let fragPrev = fragments[firstPdtIndex];
    for(let i = firstPdtIndex; i--;){
        const frag = fragments[i];
        // Exit on delta-playlist skipped segments
        if (!frag) return;
        frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
        fragPrev = frag;
    }
}
function assignProgramDateTime(frag, prevFrag) {
    if (frag.rawProgramDateTime) frag.programDateTime = Date.parse(frag.rawProgramDateTime);
    else if (prevFrag != null && prevFrag.programDateTime) frag.programDateTime = prevFrag.endProgramDateTime;
    if (!isFiniteNumber(frag.programDateTime)) {
        frag.programDateTime = null;
        frag.rawProgramDateTime = null;
    }
}
function setInitSegment(frag, mapAttrs, id, levelkeys) {
    frag.relurl = mapAttrs.URI;
    if (mapAttrs.BYTERANGE) frag.setByteRange(mapAttrs.BYTERANGE);
    frag.level = id;
    frag.sn = 'initSegment';
    if (levelkeys) frag.levelkeys = levelkeys;
    frag.initSegment = null;
}
function setFragLevelKeys(frag, levelkeys, level) {
    frag.levelkeys = levelkeys;
    const { encryptedFragments } = level;
    if ((!encryptedFragments.length || encryptedFragments[encryptedFragments.length - 1].levelkeys !== levelkeys) && Object.keys(levelkeys).some((format)=>levelkeys[format].isCommonEncryption)) encryptedFragments.push(frag);
}
var PlaylistContextType = {
    MANIFEST: "manifest",
    LEVEL: "level",
    AUDIO_TRACK: "audioTrack",
    SUBTITLE_TRACK: "subtitleTrack"
};
var PlaylistLevelType = {
    MAIN: "main",
    AUDIO: "audio",
    SUBTITLE: "subtitle"
};
function mapContextToLevelType(context) {
    const { type } = context;
    switch(type){
        case PlaylistContextType.AUDIO_TRACK:
            return PlaylistLevelType.AUDIO;
        case PlaylistContextType.SUBTITLE_TRACK:
            return PlaylistLevelType.SUBTITLE;
        default:
            return PlaylistLevelType.MAIN;
    }
}
function getResponseUrl(response, context) {
    let url = response.url;
    // responseURL not supported on some browsers (it is used to detect URL redirection)
    // data-uri mode also not supported (but no need to detect redirection)
    if (url === undefined || url.indexOf('data:') === 0) // fallback to initial URL
    url = context.url;
    return url;
}
class PlaylistLoader {
    constructor(hls){
        this.hls = void 0;
        this.loaders = Object.create(null);
        this.variableList = null;
        this.hls = hls;
        this.registerListeners();
    }
    startLoad(startPosition) {}
    stopLoad() {
        this.destroyInternalLoaders();
    }
    registerListeners() {
        const { hls } = this;
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
        hls.on(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
    }
    unregisterListeners() {
        const { hls } = this;
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
        hls.off(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
    }
    /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */ createInternalLoader(context) {
        const config = this.hls.config;
        const PLoader = config.pLoader;
        const Loader = config.loader;
        const InternalLoader = PLoader || Loader;
        const loader = new InternalLoader(config);
        this.loaders[context.type] = loader;
        return loader;
    }
    getInternalLoader(context) {
        return this.loaders[context.type];
    }
    resetInternalLoader(contextType) {
        if (this.loaders[contextType]) delete this.loaders[contextType];
    }
    /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */ destroyInternalLoaders() {
        for(const contextType in this.loaders){
            const loader = this.loaders[contextType];
            if (loader) loader.destroy();
            this.resetInternalLoader(contextType);
        }
    }
    destroy() {
        this.variableList = null;
        this.unregisterListeners();
        this.destroyInternalLoaders();
    }
    onManifestLoading(event, data) {
        const { url } = data;
        this.variableList = null;
        this.load({
            id: null,
            level: 0,
            responseType: 'text',
            type: PlaylistContextType.MANIFEST,
            url,
            deliveryDirectives: null
        });
    }
    onLevelLoading(event, data) {
        const { id, level, pathwayId, url, deliveryDirectives } = data;
        this.load({
            id,
            level,
            pathwayId,
            responseType: 'text',
            type: PlaylistContextType.LEVEL,
            url,
            deliveryDirectives
        });
    }
    onAudioTrackLoading(event, data) {
        const { id, groupId, url, deliveryDirectives } = data;
        this.load({
            id,
            groupId,
            level: null,
            responseType: 'text',
            type: PlaylistContextType.AUDIO_TRACK,
            url,
            deliveryDirectives
        });
    }
    onSubtitleTrackLoading(event, data) {
        const { id, groupId, url, deliveryDirectives } = data;
        this.load({
            id,
            groupId,
            level: null,
            responseType: 'text',
            type: PlaylistContextType.SUBTITLE_TRACK,
            url,
            deliveryDirectives
        });
    }
    load(context) {
        var _context$deliveryDire;
        const config = this.hls.config;
        // logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);
        // Check if a loader for this context already exists
        let loader = this.getInternalLoader(context);
        if (loader) {
            const loaderContext = loader.context;
            if (loaderContext && loaderContext.url === context.url && loaderContext.level === context.level) {
                // same URL can't overlap
                logger.trace('[playlist-loader]: playlist request ongoing');
                return;
            }
            logger.log(`[playlist-loader]: aborting previous loader for type: ${context.type}`);
            loader.abort();
        }
        // apply different configs for retries depending on
        // context (manifest, level, audio/subs playlist)
        let loadPolicy;
        if (context.type === PlaylistContextType.MANIFEST) loadPolicy = config.manifestLoadPolicy.default;
        else loadPolicy = _extends({}, config.playlistLoadPolicy.default, {
            timeoutRetry: null,
            errorRetry: null
        });
        loader = this.createInternalLoader(context);
        // Override level/track timeout for LL-HLS requests
        // (the default of 10000ms is counter productive to blocking playlist reload requests)
        if (isFiniteNumber((_context$deliveryDire = context.deliveryDirectives) == null ? void 0 : _context$deliveryDire.part)) {
            let levelDetails;
            if (context.type === PlaylistContextType.LEVEL && context.level !== null) levelDetails = this.hls.levels[context.level].details;
            else if (context.type === PlaylistContextType.AUDIO_TRACK && context.id !== null) levelDetails = this.hls.audioTracks[context.id].details;
            else if (context.type === PlaylistContextType.SUBTITLE_TRACK && context.id !== null) levelDetails = this.hls.subtitleTracks[context.id].details;
            if (levelDetails) {
                const partTarget = levelDetails.partTarget;
                const targetDuration = levelDetails.targetduration;
                if (partTarget && targetDuration) {
                    const maxLowLatencyPlaylistRefresh = Math.max(partTarget * 3, targetDuration * 0.8) * 1000;
                    loadPolicy = _extends({}, loadPolicy, {
                        maxTimeToFirstByteMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs),
                        maxLoadTimeMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs)
                    });
                }
            }
        }
        const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
        const loaderConfig = {
            loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
            retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
            maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
        };
        const loaderCallbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                const loader = this.getInternalLoader(context);
                this.resetInternalLoader(context.type);
                const string = response.data;
                // Validate if it is an M3U8 at all
                if (string.indexOf('#EXTM3U') !== 0) {
                    this.handleManifestParsingError(response, context, new Error('no EXTM3U delimiter'), networkDetails || null, stats);
                    return;
                }
                stats.parsing.start = performance.now();
                if (M3U8Parser.isMediaPlaylist(string)) this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails || null, loader);
                else this.handleMasterPlaylist(response, stats, context, networkDetails);
            },
            onError: (response, context, networkDetails, stats)=>{
                this.handleNetworkError(context, networkDetails, false, response, stats);
            },
            onTimeout: (stats, context, networkDetails)=>{
                this.handleNetworkError(context, networkDetails, true, undefined, stats);
            }
        };
        // logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);
        loader.load(context, loaderConfig, loaderCallbacks);
    }
    handleMasterPlaylist(response, stats, context, networkDetails) {
        const hls = this.hls;
        const string = response.data;
        const url = getResponseUrl(response, context);
        const parsedResult = M3U8Parser.parseMasterPlaylist(string, url);
        if (parsedResult.playlistParsingError) {
            this.handleManifestParsingError(response, context, parsedResult.playlistParsingError, networkDetails, stats);
            return;
        }
        const { contentSteering, levels, sessionData, sessionKeys, startTimeOffset, variableList } = parsedResult;
        this.variableList = variableList;
        const { AUDIO: audioTracks = [], SUBTITLES: subtitles, 'CLOSED-CAPTIONS': captions } = M3U8Parser.parseMasterPlaylistMedia(string, url, parsedResult);
        if (audioTracks.length) {
            // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
            const embeddedAudioFound = audioTracks.some((audioTrack)=>!audioTrack.url);
            // if no embedded audio track defined, but audio codec signaled in quality level,
            // we need to signal this main audio track this could happen with playlists with
            // alt audio rendition in which quality levels (main)
            // contains both audio+video. but with mixed audio track not signaled
            if (!embeddedAudioFound && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                logger.log('[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one');
                audioTracks.unshift({
                    type: 'main',
                    name: 'main',
                    groupId: 'main',
                    default: false,
                    autoselect: false,
                    forced: false,
                    id: -1,
                    attrs: new AttrList({}),
                    bitrate: 0,
                    url: ''
                });
            }
        }
        hls.trigger(Events.MANIFEST_LOADED, {
            levels,
            audioTracks,
            subtitles,
            captions,
            contentSteering,
            url,
            stats,
            networkDetails,
            sessionData,
            sessionKeys,
            startTimeOffset,
            variableList
        });
    }
    handleTrackOrLevelPlaylist(response, stats, context, networkDetails, loader) {
        const hls = this.hls;
        const { id, level, type } = context;
        const url = getResponseUrl(response, context);
        const levelUrlId = 0;
        const levelId = isFiniteNumber(level) ? level : isFiniteNumber(id) ? id : 0;
        const levelType = mapContextToLevelType(context);
        const levelDetails = M3U8Parser.parseLevelPlaylist(response.data, url, levelId, levelType, levelUrlId, this.variableList);
        // We have done our first request (Manifest-type) and receive
        // not a master playlist but a chunk-list (track/level)
        // We fire the manifest-loaded event anyway with the parsed level-details
        // by creating a single-level structure for it.
        if (type === PlaylistContextType.MANIFEST) {
            const singleLevel = {
                attrs: new AttrList({}),
                bitrate: 0,
                details: levelDetails,
                name: '',
                url
            };
            hls.trigger(Events.MANIFEST_LOADED, {
                levels: [
                    singleLevel
                ],
                audioTracks: [],
                url,
                stats,
                networkDetails,
                sessionData: null,
                sessionKeys: null,
                contentSteering: null,
                startTimeOffset: null,
                variableList: null
            });
        }
        // save parsing time
        stats.parsing.end = performance.now();
        // extend the context with the new levelDetails property
        context.levelDetails = levelDetails;
        this.handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader);
    }
    handleManifestParsingError(response, context, error, networkDetails, stats) {
        this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.MANIFEST_PARSING_ERROR,
            fatal: context.type === PlaylistContextType.MANIFEST,
            url: response.url,
            err: error,
            error,
            reason: error.message,
            response,
            context,
            networkDetails,
            stats
        });
    }
    handleNetworkError(context, networkDetails, timeout = false, response, stats) {
        let message = `A network ${timeout ? 'timeout' : 'error' + (response ? ' (status ' + response.code + ')' : '')} occurred while loading ${context.type}`;
        if (context.type === PlaylistContextType.LEVEL) message += `: ${context.level} id: ${context.id}`;
        else if (context.type === PlaylistContextType.AUDIO_TRACK || context.type === PlaylistContextType.SUBTITLE_TRACK) message += ` id: ${context.id} group-id: "${context.groupId}"`;
        const error = new Error(message);
        logger.warn(`[playlist-loader]: ${message}`);
        let details = ErrorDetails.UNKNOWN;
        let fatal = false;
        const loader = this.getInternalLoader(context);
        switch(context.type){
            case PlaylistContextType.MANIFEST:
                details = timeout ? ErrorDetails.MANIFEST_LOAD_TIMEOUT : ErrorDetails.MANIFEST_LOAD_ERROR;
                fatal = true;
                break;
            case PlaylistContextType.LEVEL:
                details = timeout ? ErrorDetails.LEVEL_LOAD_TIMEOUT : ErrorDetails.LEVEL_LOAD_ERROR;
                fatal = false;
                break;
            case PlaylistContextType.AUDIO_TRACK:
                details = timeout ? ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
                fatal = false;
                break;
            case PlaylistContextType.SUBTITLE_TRACK:
                details = timeout ? ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : ErrorDetails.SUBTITLE_LOAD_ERROR;
                fatal = false;
                break;
        }
        if (loader) this.resetInternalLoader(context.type);
        const errorData = {
            type: ErrorTypes.NETWORK_ERROR,
            details,
            fatal,
            url: context.url,
            loader,
            context,
            error,
            networkDetails,
            stats
        };
        if (response) {
            const url = (networkDetails == null ? void 0 : networkDetails.url) || context.url;
            errorData.response = _objectSpread2({
                url,
                data: undefined
            }, response);
        }
        this.hls.trigger(Events.ERROR, errorData);
    }
    handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader) {
        const hls = this.hls;
        const { type, level, id, groupId, deliveryDirectives } = context;
        const url = getResponseUrl(response, context);
        const parent = mapContextToLevelType(context);
        const levelIndex = typeof context.level === 'number' && parent === PlaylistLevelType.MAIN ? level : undefined;
        if (!levelDetails.fragments.length) {
            const _error = new Error('No Segments found in Playlist');
            hls.trigger(Events.ERROR, {
                type: ErrorTypes.NETWORK_ERROR,
                details: ErrorDetails.LEVEL_EMPTY_ERROR,
                fatal: false,
                url,
                error: _error,
                reason: _error.message,
                response,
                context,
                level: levelIndex,
                parent,
                networkDetails,
                stats
            });
            return;
        }
        if (!levelDetails.targetduration) levelDetails.playlistParsingError = new Error('Missing Target Duration');
        const error = levelDetails.playlistParsingError;
        if (error) {
            hls.trigger(Events.ERROR, {
                type: ErrorTypes.NETWORK_ERROR,
                details: ErrorDetails.LEVEL_PARSING_ERROR,
                fatal: false,
                url,
                error,
                reason: error.message,
                response,
                context,
                level: levelIndex,
                parent,
                networkDetails,
                stats
            });
            return;
        }
        if (levelDetails.live && loader) {
            if (loader.getCacheAge) levelDetails.ageHeader = loader.getCacheAge() || 0;
            if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) levelDetails.ageHeader = 0;
        }
        switch(type){
            case PlaylistContextType.MANIFEST:
            case PlaylistContextType.LEVEL:
                hls.trigger(Events.LEVEL_LOADED, {
                    details: levelDetails,
                    level: levelIndex || 0,
                    id: id || 0,
                    stats,
                    networkDetails,
                    deliveryDirectives
                });
                break;
            case PlaylistContextType.AUDIO_TRACK:
                hls.trigger(Events.AUDIO_TRACK_LOADED, {
                    details: levelDetails,
                    id: id || 0,
                    groupId: groupId || '',
                    stats,
                    networkDetails,
                    deliveryDirectives
                });
                break;
            case PlaylistContextType.SUBTITLE_TRACK:
                hls.trigger(Events.SUBTITLE_TRACK_LOADED, {
                    details: levelDetails,
                    id: id || 0,
                    groupId: groupId || '',
                    stats,
                    networkDetails,
                    deliveryDirectives
                });
                break;
        }
    }
}
function sendAddTrackEvent(track, videoEl) {
    let event;
    try {
        event = new Event('addtrack');
    } catch (err) {
        // for IE11
        event = document.createEvent('Event');
        event.initEvent('addtrack', false, false);
    }
    event.track = track;
    videoEl.dispatchEvent(event);
}
function addCueToTrack(track, cue) {
    // Sometimes there are cue overlaps on segmented vtts so the same
    // cue can appear more than once in different vtt files.
    // This avoid showing duplicated cues with same timecode and text.
    const mode = track.mode;
    if (mode === 'disabled') track.mode = 'hidden';
    if (track.cues && !track.cues.getCueById(cue.id)) try {
        track.addCue(cue);
        if (!track.cues.getCueById(cue.id)) throw new Error(`addCue is failed for: ${cue}`);
    } catch (err) {
        logger.debug(`[texttrack-utils]: ${err}`);
        try {
            const textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
            textTrackCue.id = cue.id;
            track.addCue(textTrackCue);
        } catch (err2) {
            logger.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${err2}`);
        }
    }
    if (mode === 'disabled') track.mode = mode;
}
function clearCurrentCues(track) {
    // When track.mode is disabled, track.cues will be null.
    // To guarantee the removal of cues, we need to temporarily
    // change the mode to hidden
    const mode = track.mode;
    if (mode === 'disabled') track.mode = 'hidden';
    if (track.cues) for(let i = track.cues.length; i--;)track.removeCue(track.cues[i]);
    if (mode === 'disabled') track.mode = mode;
}
function removeCuesInRange(track, start, end, predicate) {
    const mode = track.mode;
    if (mode === 'disabled') track.mode = 'hidden';
    if (track.cues && track.cues.length > 0) {
        const cues = getCuesInRange(track.cues, start, end);
        for(let i = 0; i < cues.length; i++)if (!predicate || predicate(cues[i])) track.removeCue(cues[i]);
    }
    if (mode === 'disabled') track.mode = mode;
}
// Find first cue starting after given time.
// Modified version of binary search O(log(n)).
function getFirstCueIndexAfterTime(cues, time) {
    // If first cue starts after time, start there
    if (time < cues[0].startTime) return 0;
    // If the last cue ends before time there is no overlap
    const len = cues.length - 1;
    if (time > cues[len].endTime) return -1;
    let left = 0;
    let right = len;
    while(left <= right){
        const mid = Math.floor((right + left) / 2);
        if (time < cues[mid].startTime) right = mid - 1;
        else if (time > cues[mid].startTime && left < len) left = mid + 1;
        else // If it's not lower or higher, it must be equal.
        return mid;
    }
    // At this point, left and right have swapped.
    // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
    return cues[left].startTime - time < time - cues[right].startTime ? left : right;
}
function getCuesInRange(cues, start, end) {
    const cuesFound = [];
    const firstCueInRange = getFirstCueIndexAfterTime(cues, start);
    if (firstCueInRange > -1) for(let i = firstCueInRange, len = cues.length; i < len; i++){
        const cue = cues[i];
        if (cue.startTime >= start && cue.endTime <= end) cuesFound.push(cue);
        else if (cue.startTime > end) return cuesFound;
    }
    return cuesFound;
}
function filterSubtitleTracks(textTrackList) {
    const tracks = [];
    for(let i = 0; i < textTrackList.length; i++){
        const track = textTrackList[i];
        // Edge adds a track without a label; we don't want to use it
        if ((track.kind === 'subtitles' || track.kind === 'captions') && track.label) tracks.push(textTrackList[i]);
    }
    return tracks;
}
var MetadataSchema = {
    audioId3: "org.id3",
    dateRange: "com.apple.quicktime.HLS",
    emsg: "https://aomedia.org/emsg/ID3"
};
const MIN_CUE_DURATION = 0.25;
function getCueClass() {
    if (typeof self === 'undefined') return undefined;
    return self.VTTCue || self.TextTrackCue;
}
function createCueWithDataFields(Cue, startTime, endTime, data, type) {
    let cue = new Cue(startTime, endTime, '');
    try {
        cue.value = data;
        if (type) cue.type = type;
    } catch (e) {
        cue = new Cue(startTime, endTime, JSON.stringify(type ? _objectSpread2({
            type
        }, data) : data));
    }
    return cue;
}
// VTTCue latest draft allows an infinite duration, fallback
// to MAX_VALUE if necessary
const MAX_CUE_ENDTIME = (()=>{
    const Cue = getCueClass();
    try {
        Cue && new Cue(0, Number.POSITIVE_INFINITY, '');
    } catch (e) {
        return Number.MAX_VALUE;
    }
    return Number.POSITIVE_INFINITY;
})();
function dateRangeDateToTimelineSeconds(date, offset) {
    return date.getTime() / 1000 - offset;
}
function hexToArrayBuffer(str) {
    return Uint8Array.from(str.replace(/^0x/, '').replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, '').split(' ')).buffer;
}
class ID3TrackController {
    constructor(hls){
        this.hls = void 0;
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
        this.hls = hls;
        this._registerListeners();
    }
    destroy() {
        this._unregisterListeners();
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
        // @ts-ignore
        this.hls = null;
    }
    _registerListeners() {
        const { hls } = this;
        hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
        hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    _unregisterListeners() {
        const { hls } = this;
        hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
        hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    // Add ID3 metatadata text track.
    onMediaAttached(event, data) {
        this.media = data.media;
    }
    onMediaDetaching() {
        if (!this.id3Track) return;
        clearCurrentCues(this.id3Track);
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
    }
    onManifestLoading() {
        this.dateRangeCuesAppended = {};
    }
    createTrack(media) {
        const track = this.getID3Track(media.textTracks);
        track.mode = 'hidden';
        return track;
    }
    getID3Track(textTracks) {
        if (!this.media) return;
        for(let i = 0; i < textTracks.length; i++){
            const textTrack = textTracks[i];
            if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
                // send 'addtrack' when reusing the textTrack for metadata,
                // same as what we do for captions
                sendAddTrackEvent(textTrack, this.media);
                return textTrack;
            }
        }
        return this.media.addTextTrack('metadata', 'id3');
    }
    onFragParsingMetadata(event, data) {
        if (!this.media) return;
        const { hls: { config: { enableEmsgMetadataCues, enableID3MetadataCues } } } = this;
        if (!enableEmsgMetadataCues && !enableID3MetadataCues) return;
        const { samples } = data;
        // create track dynamically
        if (!this.id3Track) this.id3Track = this.createTrack(this.media);
        const Cue = getCueClass();
        if (!Cue) return;
        for(let i = 0; i < samples.length; i++){
            const type = samples[i].type;
            if (type === MetadataSchema.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) continue;
            const frames = getID3Frames(samples[i].data);
            if (frames) {
                const startTime = samples[i].pts;
                let endTime = startTime + samples[i].duration;
                if (endTime > MAX_CUE_ENDTIME) endTime = MAX_CUE_ENDTIME;
                const timeDiff = endTime - startTime;
                if (timeDiff <= 0) endTime = startTime + MIN_CUE_DURATION;
                for(let j = 0; j < frames.length; j++){
                    const frame = frames[j];
                    // Safari doesn't put the timestamp frame in the TextTrack
                    if (!isTimeStampFrame(frame)) {
                        // add a bounds to any unbounded cues
                        this.updateId3CueEnds(startTime, type);
                        const cue = createCueWithDataFields(Cue, startTime, endTime, frame, type);
                        if (cue) this.id3Track.addCue(cue);
                    }
                }
            }
        }
    }
    updateId3CueEnds(startTime, type) {
        var _this$id3Track;
        const cues = (_this$id3Track = this.id3Track) == null ? void 0 : _this$id3Track.cues;
        if (cues) for(let i = cues.length; i--;){
            const cue = cues[i];
            if (cue.type === type && cue.startTime < startTime && cue.endTime === MAX_CUE_ENDTIME) cue.endTime = startTime;
        }
    }
    onBufferFlushing(event, { startOffset, endOffset, type }) {
        const { id3Track, hls } = this;
        if (!hls) return;
        const { config: { enableEmsgMetadataCues, enableID3MetadataCues } } = hls;
        if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
            let predicate;
            if (type === 'audio') predicate = (cue)=>cue.type === MetadataSchema.audioId3 && enableID3MetadataCues;
            else if (type === 'video') predicate = (cue)=>cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
            else predicate = (cue)=>cue.type === MetadataSchema.audioId3 && enableID3MetadataCues || cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
            removeCuesInRange(id3Track, startOffset, endOffset, predicate);
        }
    }
    onLevelUpdated(event, { details }) {
        if (!this.media || !details.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues) return;
        const { dateRangeCuesAppended, id3Track } = this;
        const { dateRanges } = details;
        const ids = Object.keys(dateRanges);
        // Remove cues from track not found in details.dateRanges
        if (id3Track) {
            const idsToRemove = Object.keys(dateRangeCuesAppended).filter((id)=>!ids.includes(id));
            for(let i = idsToRemove.length; i--;){
                const id = idsToRemove[i];
                Object.keys(dateRangeCuesAppended[id].cues).forEach((key)=>{
                    id3Track.removeCue(dateRangeCuesAppended[id].cues[key]);
                });
                delete dateRangeCuesAppended[id];
            }
        }
        // Exit if the playlist does not have Date Ranges or does not have Program Date Time
        const lastFragment = details.fragments[details.fragments.length - 1];
        if (ids.length === 0 || !isFiniteNumber(lastFragment == null ? void 0 : lastFragment.programDateTime)) return;
        if (!this.id3Track) this.id3Track = this.createTrack(this.media);
        const dateTimeOffset = lastFragment.programDateTime / 1000 - lastFragment.start;
        const Cue = getCueClass();
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            const dateRange = dateRanges[id];
            const startTime = dateRangeDateToTimelineSeconds(dateRange.startDate, dateTimeOffset);
            // Process DateRanges to determine end-time (known DURATION, END-DATE, or END-ON-NEXT)
            const appendedDateRangeCues = dateRangeCuesAppended[id];
            const cues = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.cues) || {};
            let durationKnown = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.durationKnown) || false;
            let endTime = MAX_CUE_ENDTIME;
            const endDate = dateRange.endDate;
            if (endDate) {
                endTime = dateRangeDateToTimelineSeconds(endDate, dateTimeOffset);
                durationKnown = true;
            } else if (dateRange.endOnNext && !durationKnown) {
                const nextDateRangeWithSameClass = ids.reduce((candidateDateRange, id)=>{
                    if (id !== dateRange.id) {
                        const otherDateRange = dateRanges[id];
                        if (otherDateRange.class === dateRange.class && otherDateRange.startDate > dateRange.startDate && (!candidateDateRange || dateRange.startDate < candidateDateRange.startDate)) return otherDateRange;
                    }
                    return candidateDateRange;
                }, null);
                if (nextDateRangeWithSameClass) {
                    endTime = dateRangeDateToTimelineSeconds(nextDateRangeWithSameClass.startDate, dateTimeOffset);
                    durationKnown = true;
                }
            }
            // Create TextTrack Cues for each MetadataGroup Item (select DateRange attribute)
            // This is to emulate Safari HLS playback handling of DateRange tags
            const attributes = Object.keys(dateRange.attr);
            for(let j = 0; j < attributes.length; j++){
                const key = attributes[j];
                if (!isDateRangeCueAttribute(key)) continue;
                const cue = cues[key];
                if (cue) {
                    if (durationKnown && !appendedDateRangeCues.durationKnown) cue.endTime = endTime;
                } else if (Cue) {
                    let data = dateRange.attr[key];
                    if (isSCTE35Attribute(key)) data = hexToArrayBuffer(data);
                    const _cue = createCueWithDataFields(Cue, startTime, endTime, {
                        key,
                        data
                    }, MetadataSchema.dateRange);
                    if (_cue) {
                        _cue.id = id;
                        this.id3Track.addCue(_cue);
                        cues[key] = _cue;
                    }
                }
            }
            // Keep track of processed DateRanges by ID for updating cues with new DateRange tag attributes
            dateRangeCuesAppended[id] = {
                cues,
                dateRange,
                durationKnown
            };
        }
    }
}
class LatencyController {
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = null;
        this.levelDetails = null;
        this.currentTime = 0;
        this.stallCount = 0;
        this._latency = null;
        this.timeupdateHandler = ()=>this.timeupdate();
        this.hls = hls;
        this.config = hls.config;
        this.registerListeners();
    }
    get latency() {
        return this._latency || 0;
    }
    get maxLatency() {
        const { config, levelDetails } = this;
        if (config.liveMaxLatencyDuration !== undefined) return config.liveMaxLatencyDuration;
        return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
    }
    get targetLatency() {
        const { levelDetails } = this;
        if (levelDetails === null) return null;
        const { holdBack, partHoldBack, targetduration } = levelDetails;
        const { liveSyncDuration, liveSyncDurationCount, lowLatencyMode } = this.config;
        const userConfig = this.hls.userConfig;
        let targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
        if (userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) targetLatency = liveSyncDuration !== undefined ? liveSyncDuration : liveSyncDurationCount * targetduration;
        const maxLiveSyncOnStallIncrease = targetduration;
        const liveSyncOnStallIncrease = 1.0;
        return targetLatency + Math.min(this.stallCount * liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
    }
    get liveSyncPosition() {
        const liveEdge = this.estimateLiveEdge();
        const targetLatency = this.targetLatency;
        const levelDetails = this.levelDetails;
        if (liveEdge === null || targetLatency === null || levelDetails === null) return null;
        const edge = levelDetails.edge;
        const syncPosition = liveEdge - targetLatency - this.edgeStalled;
        const min = edge - levelDetails.totalduration;
        const max = edge - (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
        return Math.min(Math.max(min, syncPosition), max);
    }
    get drift() {
        const { levelDetails } = this;
        if (levelDetails === null) return 1;
        return levelDetails.drift;
    }
    get edgeStalled() {
        const { levelDetails } = this;
        if (levelDetails === null) return 0;
        const maxLevelUpdateAge = (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
        return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
    }
    get forwardBufferLength() {
        const { media, levelDetails } = this;
        if (!media || !levelDetails) return 0;
        const bufferedRanges = media.buffered.length;
        return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - this.currentTime;
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetaching();
        this.levelDetails = null;
        // @ts-ignore
        this.hls = this.timeupdateHandler = null;
    }
    registerListeners() {
        this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
        this.hls.on(Events.ERROR, this.onError, this);
    }
    unregisterListeners() {
        this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
        this.hls.off(Events.ERROR, this.onError, this);
    }
    onMediaAttached(event, data) {
        this.media = data.media;
        this.media.addEventListener('timeupdate', this.timeupdateHandler);
    }
    onMediaDetaching() {
        if (this.media) {
            this.media.removeEventListener('timeupdate', this.timeupdateHandler);
            this.media = null;
        }
    }
    onManifestLoading() {
        this.levelDetails = null;
        this._latency = null;
        this.stallCount = 0;
    }
    onLevelUpdated(event, { details }) {
        this.levelDetails = details;
        if (details.advanced) this.timeupdate();
        if (!details.live && this.media) this.media.removeEventListener('timeupdate', this.timeupdateHandler);
    }
    onError(event, data) {
        var _this$levelDetails;
        if (data.details !== ErrorDetails.BUFFER_STALLED_ERROR) return;
        this.stallCount++;
        if ((_this$levelDetails = this.levelDetails) != null && _this$levelDetails.live) logger.warn('[playback-rate-controller]: Stall detected, adjusting target latency');
    }
    timeupdate() {
        const { media, levelDetails } = this;
        if (!media || !levelDetails) return;
        this.currentTime = media.currentTime;
        const latency = this.computeLatency();
        if (latency === null) return;
        this._latency = latency;
        // Adapt playbackRate to meet target latency in low-latency mode
        const { lowLatencyMode, maxLiveSyncPlaybackRate } = this.config;
        if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1 || !levelDetails.live) return;
        const targetLatency = this.targetLatency;
        if (targetLatency === null) return;
        const distanceFromTarget = latency - targetLatency;
        // Only adjust playbackRate when within one target duration of targetLatency
        // and more than one second from under-buffering.
        // Playback further than one target duration from target can be considered DVR playback.
        const liveMinLatencyDuration = Math.min(this.maxLatency, targetLatency + levelDetails.targetduration);
        const inLiveRange = distanceFromTarget < liveMinLatencyDuration;
        if (inLiveRange && distanceFromTarget > 0.05 && this.forwardBufferLength > 1) {
            const max = Math.min(2, Math.max(1.0, maxLiveSyncPlaybackRate));
            const rate = Math.round(2 / (1 + Math.exp(-0.75 * distanceFromTarget - this.edgeStalled)) * 20) / 20;
            media.playbackRate = Math.min(max, Math.max(1, rate));
        } else if (media.playbackRate !== 1 && media.playbackRate !== 0) media.playbackRate = 1;
    }
    estimateLiveEdge() {
        const { levelDetails } = this;
        if (levelDetails === null) return null;
        return levelDetails.edge + levelDetails.age;
    }
    computeLatency() {
        const liveEdge = this.estimateLiveEdge();
        if (liveEdge === null) return null;
        return liveEdge - this.currentTime;
    }
}
const HdcpLevels = [
    'NONE',
    'TYPE-0',
    'TYPE-1',
    null
];
function isHdcpLevel(value) {
    return HdcpLevels.indexOf(value) > -1;
}
const VideoRangeValues = [
    'SDR',
    'PQ',
    'HLG'
];
function isVideoRange(value) {
    return !!value && VideoRangeValues.indexOf(value) > -1;
}
var HlsSkip = {
    No: "",
    Yes: "YES",
    v2: "v2"
};
function getSkipValue(details) {
    const { canSkipUntil, canSkipDateRanges, age } = details;
    // A Client SHOULD NOT request a Playlist Delta Update unless it already
    // has a version of the Playlist that is no older than one-half of the Skip Boundary.
    // @see: https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis#section-6.3.7
    const playlistRecentEnough = age < canSkipUntil / 2;
    if (canSkipUntil && playlistRecentEnough) {
        if (canSkipDateRanges) return HlsSkip.v2;
        return HlsSkip.Yes;
    }
    return HlsSkip.No;
}
class HlsUrlParameters {
    constructor(msn, part, skip){
        this.msn = void 0;
        this.part = void 0;
        this.skip = void 0;
        this.msn = msn;
        this.part = part;
        this.skip = skip;
    }
    addDirectives(uri) {
        const url = new self.URL(uri);
        if (this.msn !== undefined) url.searchParams.set('_HLS_msn', this.msn.toString());
        if (this.part !== undefined) url.searchParams.set('_HLS_part', this.part.toString());
        if (this.skip) url.searchParams.set('_HLS_skip', this.skip);
        return url.href;
    }
}
class Level {
    constructor(data){
        this._attrs = void 0;
        this.audioCodec = void 0;
        this.bitrate = void 0;
        this.codecSet = void 0;
        this.url = void 0;
        this.frameRate = void 0;
        this.height = void 0;
        this.id = void 0;
        this.name = void 0;
        this.videoCodec = void 0;
        this.width = void 0;
        this.details = void 0;
        this.fragmentError = 0;
        this.loadError = 0;
        this.loaded = void 0;
        this.realBitrate = 0;
        this.supportedPromise = void 0;
        this.supportedResult = void 0;
        this._avgBitrate = 0;
        this._audioGroups = void 0;
        this._subtitleGroups = void 0;
        // Deprecated (retained for backwards compatibility)
        this._urlId = 0;
        this.url = [
            data.url
        ];
        this._attrs = [
            data.attrs
        ];
        this.bitrate = data.bitrate;
        if (data.details) this.details = data.details;
        this.id = data.id || 0;
        this.name = data.name;
        this.width = data.width || 0;
        this.height = data.height || 0;
        this.frameRate = data.attrs.optionalFloat('FRAME-RATE', 0);
        this._avgBitrate = data.attrs.decimalInteger('AVERAGE-BANDWIDTH');
        this.audioCodec = data.audioCodec;
        this.videoCodec = data.videoCodec;
        this.codecSet = [
            data.videoCodec,
            data.audioCodec
        ].filter((c)=>!!c).map((s)=>s.substring(0, 4)).join(',');
        this.addGroupId('audio', data.attrs.AUDIO);
        this.addGroupId('text', data.attrs.SUBTITLES);
    }
    get maxBitrate() {
        return Math.max(this.realBitrate, this.bitrate);
    }
    get averageBitrate() {
        return this._avgBitrate || this.realBitrate || this.bitrate;
    }
    get attrs() {
        return this._attrs[0];
    }
    get codecs() {
        return this.attrs.CODECS || '';
    }
    get pathwayId() {
        return this.attrs['PATHWAY-ID'] || '.';
    }
    get videoRange() {
        return this.attrs['VIDEO-RANGE'] || 'SDR';
    }
    get score() {
        return this.attrs.optionalFloat('SCORE', 0);
    }
    get uri() {
        return this.url[0] || '';
    }
    hasAudioGroup(groupId) {
        return hasGroup(this._audioGroups, groupId);
    }
    hasSubtitleGroup(groupId) {
        return hasGroup(this._subtitleGroups, groupId);
    }
    get audioGroups() {
        return this._audioGroups;
    }
    get subtitleGroups() {
        return this._subtitleGroups;
    }
    addGroupId(type, groupId) {
        if (!groupId) return;
        if (type === 'audio') {
            let audioGroups = this._audioGroups;
            if (!audioGroups) audioGroups = this._audioGroups = [];
            if (audioGroups.indexOf(groupId) === -1) audioGroups.push(groupId);
        } else if (type === 'text') {
            let subtitleGroups = this._subtitleGroups;
            if (!subtitleGroups) subtitleGroups = this._subtitleGroups = [];
            if (subtitleGroups.indexOf(groupId) === -1) subtitleGroups.push(groupId);
        }
    }
    // Deprecated methods (retained for backwards compatibility)
    get urlId() {
        return 0;
    }
    set urlId(value) {}
    get audioGroupIds() {
        return this.audioGroups ? [
            this.audioGroupId
        ] : undefined;
    }
    get textGroupIds() {
        return this.subtitleGroups ? [
            this.textGroupId
        ] : undefined;
    }
    get audioGroupId() {
        var _this$audioGroups;
        return (_this$audioGroups = this.audioGroups) == null ? void 0 : _this$audioGroups[0];
    }
    get textGroupId() {
        var _this$subtitleGroups;
        return (_this$subtitleGroups = this.subtitleGroups) == null ? void 0 : _this$subtitleGroups[0];
    }
    addFallback() {}
}
function hasGroup(groups, groupId) {
    if (!groupId || !groups) return false;
    return groups.indexOf(groupId) !== -1;
}
function updateFromToPTS(fragFrom, fragTo) {
    const fragToPTS = fragTo.startPTS;
    // if we know startPTS[toIdx]
    if (isFiniteNumber(fragToPTS)) {
        // update fragment duration.
        // it helps to fix drifts between playlist reported duration and fragment real duration
        let duration = 0;
        let frag;
        if (fragTo.sn > fragFrom.sn) {
            duration = fragToPTS - fragFrom.start;
            frag = fragFrom;
        } else {
            duration = fragFrom.start - fragToPTS;
            frag = fragTo;
        }
        if (frag.duration !== duration) frag.duration = duration;
    // we dont know startPTS[toIdx]
    } else if (fragTo.sn > fragFrom.sn) {
        const contiguous = fragFrom.cc === fragTo.cc;
        // TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
        if (contiguous && fragFrom.minEndPTS) fragTo.start = fragFrom.start + (fragFrom.minEndPTS - fragFrom.start);
        else fragTo.start = fragFrom.start + fragFrom.duration;
    } else fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
}
function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
    const parsedMediaDuration = endPTS - startPTS;
    if (parsedMediaDuration <= 0) {
        logger.warn('Fragment should have a positive duration', frag);
        endPTS = startPTS + frag.duration;
        endDTS = startDTS + frag.duration;
    }
    let maxStartPTS = startPTS;
    let minEndPTS = endPTS;
    const fragStartPts = frag.startPTS;
    const fragEndPts = frag.endPTS;
    if (isFiniteNumber(fragStartPts)) {
        // delta PTS between audio and video
        const deltaPTS = Math.abs(fragStartPts - startPTS);
        if (!isFiniteNumber(frag.deltaPTS)) frag.deltaPTS = deltaPTS;
        else frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
        maxStartPTS = Math.max(startPTS, fragStartPts);
        startPTS = Math.min(startPTS, fragStartPts);
        startDTS = Math.min(startDTS, frag.startDTS);
        minEndPTS = Math.min(endPTS, fragEndPts);
        endPTS = Math.max(endPTS, fragEndPts);
        endDTS = Math.max(endDTS, frag.endDTS);
    }
    const drift = startPTS - frag.start;
    if (frag.start !== 0) frag.start = startPTS;
    frag.duration = endPTS - frag.start;
    frag.startPTS = startPTS;
    frag.maxStartPTS = maxStartPTS;
    frag.startDTS = startDTS;
    frag.endPTS = endPTS;
    frag.minEndPTS = minEndPTS;
    frag.endDTS = endDTS;
    const sn = frag.sn; // 'initSegment'
    // exit if sn out of range
    if (!details || sn < details.startSN || sn > details.endSN) return 0;
    let i;
    const fragIdx = sn - details.startSN;
    const fragments = details.fragments;
    // update frag reference in fragments array
    // rationale is that fragments array might not contain this frag object.
    // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
    // if we don't update frag, we won't be able to propagate PTS info on the playlist
    // resulting in invalid sliding computation
    fragments[fragIdx] = frag;
    // adjust fragment PTS/duration from seqnum-1 to frag 0
    for(i = fragIdx; i > 0; i--)updateFromToPTS(fragments[i], fragments[i - 1]);
    // adjust fragment PTS/duration from seqnum to last frag
    for(i = fragIdx; i < fragments.length - 1; i++)updateFromToPTS(fragments[i], fragments[i + 1]);
    if (details.fragmentHint) updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
    details.PTSKnown = details.alignedSliding = true;
    return drift;
}
function mergeDetails(oldDetails, newDetails) {
    // Track the last initSegment processed. Initialize it to the last one on the timeline.
    let currentInitSegment = null;
    const oldFragments = oldDetails.fragments;
    for(let i = oldFragments.length - 1; i >= 0; i--){
        const oldInit = oldFragments[i].initSegment;
        if (oldInit) {
            currentInitSegment = oldInit;
            break;
        }
    }
    if (oldDetails.fragmentHint) // prevent PTS and duration from being adjusted on the next hint
    delete oldDetails.fragmentHint.endPTS;
    // check if old/new playlists have fragments in common
    // loop through overlapping SN and update startPTS , cc, and duration if any found
    let ccOffset = 0;
    let PTSFrag;
    mapFragmentIntersection(oldDetails, newDetails, (oldFrag, newFrag)=>{
        if (oldFrag.relurl) // Do not compare CC if the old fragment has no url. This is a level.fragmentHint used by LL-HLS parts.
        // It maybe be off by 1 if it was created before any parts or discontinuity tags were appended to the end
        // of the playlist.
        ccOffset = oldFrag.cc - newFrag.cc;
        if (isFiniteNumber(oldFrag.startPTS) && isFiniteNumber(oldFrag.endPTS)) {
            newFrag.start = newFrag.startPTS = oldFrag.startPTS;
            newFrag.startDTS = oldFrag.startDTS;
            newFrag.maxStartPTS = oldFrag.maxStartPTS;
            newFrag.endPTS = oldFrag.endPTS;
            newFrag.endDTS = oldFrag.endDTS;
            newFrag.minEndPTS = oldFrag.minEndPTS;
            newFrag.duration = oldFrag.endPTS - oldFrag.startPTS;
            if (newFrag.duration) PTSFrag = newFrag;
            // PTS is known when any segment has startPTS and endPTS
            newDetails.PTSKnown = newDetails.alignedSliding = true;
        }
        newFrag.elementaryStreams = oldFrag.elementaryStreams;
        newFrag.loader = oldFrag.loader;
        newFrag.stats = oldFrag.stats;
        if (oldFrag.initSegment) {
            newFrag.initSegment = oldFrag.initSegment;
            currentInitSegment = oldFrag.initSegment;
        }
    });
    if (currentInitSegment) {
        const fragmentsToCheck = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
        fragmentsToCheck.forEach((frag)=>{
            var _currentInitSegment;
            if (frag && (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) == null ? void 0 : _currentInitSegment.relurl))) frag.initSegment = currentInitSegment;
        });
    }
    if (newDetails.skippedSegments) {
        newDetails.deltaUpdateFailed = newDetails.fragments.some((frag)=>!frag);
        if (newDetails.deltaUpdateFailed) {
            logger.warn('[level-helper] Previous playlist missing segments skipped in delta playlist');
            for(let i = newDetails.skippedSegments; i--;)newDetails.fragments.shift();
            newDetails.startSN = newDetails.fragments[0].sn;
            newDetails.startCC = newDetails.fragments[0].cc;
        } else if (newDetails.canSkipDateRanges) newDetails.dateRanges = mergeDateRanges(oldDetails.dateRanges, newDetails.dateRanges, newDetails.recentlyRemovedDateranges);
    }
    const newFragments = newDetails.fragments;
    if (ccOffset) {
        logger.warn('discontinuity sliding from playlist, take drift into account');
        for(let i = 0; i < newFragments.length; i++)newFragments[i].cc += ccOffset;
    }
    if (newDetails.skippedSegments) newDetails.startCC = newDetails.fragments[0].cc;
    // Merge parts
    mapPartIntersection(oldDetails.partList, newDetails.partList, (oldPart, newPart)=>{
        newPart.elementaryStreams = oldPart.elementaryStreams;
        newPart.stats = oldPart.stats;
    });
    // if at least one fragment contains PTS info, recompute PTS information for all fragments
    if (PTSFrag) updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
    else // ensure that delta is within oldFragments range
    // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
    // in that case we also need to adjust start offset of all fragments
    adjustSliding(oldDetails, newDetails);
    if (newFragments.length) newDetails.totalduration = newDetails.edge - newFragments[0].start;
    newDetails.driftStartTime = oldDetails.driftStartTime;
    newDetails.driftStart = oldDetails.driftStart;
    const advancedDateTime = newDetails.advancedDateTime;
    if (newDetails.advanced && advancedDateTime) {
        const edge = newDetails.edge;
        if (!newDetails.driftStart) {
            newDetails.driftStartTime = advancedDateTime;
            newDetails.driftStart = edge;
        }
        newDetails.driftEndTime = advancedDateTime;
        newDetails.driftEnd = edge;
    } else {
        newDetails.driftEndTime = oldDetails.driftEndTime;
        newDetails.driftEnd = oldDetails.driftEnd;
        newDetails.advancedDateTime = oldDetails.advancedDateTime;
    }
}
function mergeDateRanges(oldDateRanges, deltaDateRanges, recentlyRemovedDateranges) {
    const dateRanges = _extends({}, oldDateRanges);
    if (recentlyRemovedDateranges) recentlyRemovedDateranges.forEach((id)=>{
        delete dateRanges[id];
    });
    Object.keys(deltaDateRanges).forEach((id)=>{
        const dateRange = new DateRange(deltaDateRanges[id].attr, dateRanges[id]);
        if (dateRange.isValid) dateRanges[id] = dateRange;
        else logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(deltaDateRanges[id].attr)}"`);
    });
    return dateRanges;
}
function mapPartIntersection(oldParts, newParts, intersectionFn) {
    if (oldParts && newParts) {
        let delta = 0;
        for(let i = 0, len = oldParts.length; i <= len; i++){
            const oldPart = oldParts[i];
            const newPart = newParts[i + delta];
            if (oldPart && newPart && oldPart.index === newPart.index && oldPart.fragment.sn === newPart.fragment.sn) intersectionFn(oldPart, newPart);
            else delta--;
        }
    }
}
function mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
    const skippedSegments = newDetails.skippedSegments;
    const start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
    const end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
    const delta = newDetails.startSN - oldDetails.startSN;
    const newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
    const oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
    for(let i = start; i <= end; i++){
        const oldFrag = oldFrags[delta + i];
        let newFrag = newFrags[i];
        if (skippedSegments && !newFrag && i < skippedSegments) // Fill in skipped segments in delta playlist
        newFrag = newDetails.fragments[i] = oldFrag;
        if (oldFrag && newFrag) intersectionFn(oldFrag, newFrag);
    }
}
function adjustSliding(oldDetails, newDetails) {
    const delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
    const oldFragments = oldDetails.fragments;
    if (delta < 0 || delta >= oldFragments.length) return;
    addSliding(newDetails, oldFragments[delta].start);
}
function addSliding(details, start) {
    if (start) {
        const fragments = details.fragments;
        for(let i = details.skippedSegments; i < fragments.length; i++)fragments[i].start += start;
        if (details.fragmentHint) details.fragmentHint.start += start;
    }
}
function computeReloadInterval(newDetails, distanceToLiveEdgeMs = Infinity) {
    let reloadInterval = 1000 * newDetails.targetduration;
    if (newDetails.updated) {
        // Use last segment duration when shorter than target duration and near live edge
        const fragments = newDetails.fragments;
        const liveEdgeMaxTargetDurations = 4;
        if (fragments.length && reloadInterval * liveEdgeMaxTargetDurations > distanceToLiveEdgeMs) {
            const lastSegmentDuration = fragments[fragments.length - 1].duration * 1000;
            if (lastSegmentDuration < reloadInterval) reloadInterval = lastSegmentDuration;
        }
    } else // estimate = 'miss half average';
    // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
    // changed then it MUST wait for a period of one-half the target
    // duration before retrying.
    reloadInterval /= 2;
    return Math.round(reloadInterval);
}
function getFragmentWithSN(level, sn, fragCurrent) {
    if (!(level != null && level.details)) return null;
    const levelDetails = level.details;
    let fragment = levelDetails.fragments[sn - levelDetails.startSN];
    if (fragment) return fragment;
    fragment = levelDetails.fragmentHint;
    if (fragment && fragment.sn === sn) return fragment;
    if (sn < levelDetails.startSN && fragCurrent && fragCurrent.sn === sn) return fragCurrent;
    return null;
}
function getPartWith(level, sn, partIndex) {
    var _level$details;
    if (!(level != null && level.details)) return null;
    return findPart((_level$details = level.details) == null ? void 0 : _level$details.partList, sn, partIndex);
}
function findPart(partList, sn, partIndex) {
    if (partList) for(let i = partList.length; i--;){
        const part = partList[i];
        if (part.index === partIndex && part.fragment.sn === sn) return part;
    }
    return null;
}
function reassignFragmentLevelIndexes(levels) {
    levels.forEach((level, index)=>{
        const { details } = level;
        if (details != null && details.fragments) details.fragments.forEach((fragment)=>{
            fragment.level = index;
        });
    });
}
function isTimeoutError(error) {
    switch(error.details){
        case ErrorDetails.FRAG_LOAD_TIMEOUT:
        case ErrorDetails.KEY_LOAD_TIMEOUT:
        case ErrorDetails.LEVEL_LOAD_TIMEOUT:
        case ErrorDetails.MANIFEST_LOAD_TIMEOUT:
            return true;
    }
    return false;
}
function getRetryConfig(loadPolicy, error) {
    const isTimeout = isTimeoutError(error);
    return loadPolicy.default[`${isTimeout ? 'timeout' : 'error'}Retry`];
}
function getRetryDelay(retryConfig, retryCount) {
    // exponential backoff capped to max retry delay
    const backoffFactor = retryConfig.backoff === 'linear' ? 1 : Math.pow(2, retryCount);
    return Math.min(backoffFactor * retryConfig.retryDelayMs, retryConfig.maxRetryDelayMs);
}
function getLoaderConfigWithoutReties(loderConfig) {
    return _objectSpread2(_objectSpread2({}, loderConfig), {
        errorRetry: null,
        timeoutRetry: null
    });
}
function shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse) {
    if (!retryConfig) return false;
    const httpStatus = loaderResponse == null ? void 0 : loaderResponse.code;
    const retry = retryCount < retryConfig.maxNumRetry && (retryForHttpStatus(httpStatus) || !!isTimeout);
    return retryConfig.shouldRetry ? retryConfig.shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse, retry) : retry;
}
function retryForHttpStatus(httpStatus) {
    // Do not retry on status 4xx, status 0 (CORS error), or undefined (decrypt/gap/parse error)
    return httpStatus === 0 && navigator.onLine === false || !!httpStatus && (httpStatus < 400 || httpStatus > 499);
}
const BinarySearch = {
    /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */ search: function(list, comparisonFn) {
        let minIndex = 0;
        let maxIndex = list.length - 1;
        let currentIndex = null;
        let currentElement = null;
        while(minIndex <= maxIndex){
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = list[currentIndex];
            const comparisonResult = comparisonFn(currentElement);
            if (comparisonResult > 0) minIndex = currentIndex + 1;
            else if (comparisonResult < 0) maxIndex = currentIndex - 1;
            else return currentElement;
        }
        return null;
    }
};
/**
 * Returns first fragment whose endPdt value exceeds the given PDT, or null.
 * @param fragments - The array of candidate fragments
 * @param PDTValue - The PDT value which must be exceeded
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 */ function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
    if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !isFiniteNumber(PDTValue)) return null;
    // if less than start
    const startPDT = fragments[0].programDateTime;
    if (PDTValue < (startPDT || 0)) return null;
    const endPDT = fragments[fragments.length - 1].endProgramDateTime;
    if (PDTValue >= (endPDT || 0)) return null;
    maxFragLookUpTolerance = maxFragLookUpTolerance || 0;
    for(let seg = 0; seg < fragments.length; ++seg){
        const frag = fragments[seg];
        if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) return frag;
    }
    return null;
}
/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param fragPrevious - The last frag successfully appended
 * @param fragments - The array of candidate fragments
 * @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns a matching fragment or null
 */ function findFragmentByPTS(fragPrevious, fragments, bufferEnd = 0, maxFragLookUpTolerance = 0) {
    let fragNext = null;
    if (fragPrevious) {
        fragNext = fragments[fragPrevious.sn - fragments[0].sn + 1] || null;
        // check for buffer-end rounding error
        const bufferEdgeError = fragPrevious.endDTS - bufferEnd;
        if (bufferEdgeError > 0 && bufferEdgeError < 0.0000015) bufferEnd += 0.0000015;
    } else if (bufferEnd === 0 && fragments[0].start === 0) fragNext = fragments[0];
    // Prefer the next fragment if it's within tolerance
    if (fragNext && (!fragPrevious || fragPrevious.level === fragNext.level) && fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0) return fragNext;
    // We might be seeking past the tolerance so find the best match
    const foundFragment = BinarySearch.search(fragments, fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
    if (foundFragment && (foundFragment !== fragPrevious || !fragNext)) return foundFragment;
    // If no match was found return the next fragment after fragPrevious, or null
    return fragNext;
}
/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param candidate - The fragment to test
 * @param bufferEnd - The end of the current buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns 0 if it matches, 1 if too low, -1 if too high
 */ function fragmentWithinToleranceTest(bufferEnd = 0, maxFragLookUpTolerance = 0, candidate) {
    // eagerly accept an accurate match (no tolerance)
    if (candidate.start <= bufferEnd && candidate.start + candidate.duration > bufferEnd) return 0;
    // offset should be within fragment boundary - config.maxFragLookUpTolerance
    // this is to cope with situations like
    // bufferEnd = 9.991
    // frag[Ø] : [0,10]
    // frag[1] : [10,20]
    // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
    //              frag start               frag start+duration
    //                  |-----------------------------|
    //              <--->                         <--->
    //  ...--------><-----------------------------><---------....
    // previous frag         matching fragment         next frag
    //  return -1             return 0                 return 1
    // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
    // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
    const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
    if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) return 1;
    else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
    return -1;
    return 0;
}
/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param candidate - The fragment to test
 * @param pdtBufferEnd - The Unix time representing the end of the current buffered range
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns true if contiguous, false otherwise
 */ function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
    const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;
    // endProgramDateTime can be null, default to zero
    const endProgramDateTime = candidate.endProgramDateTime || 0;
    return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
function findFragWithCC(fragments, cc) {
    return BinarySearch.search(fragments, (candidate)=>{
        if (candidate.cc < cc) return 1;
        else if (candidate.cc > cc) return -1;
        else return 0;
    });
}
var NetworkErrorAction = {
    DoNothing: 0,
    SendEndCallback: 1,
    SendAlternateToPenaltyBox: 2,
    RemoveAlternatePermanently: 3,
    InsertDiscontinuity: 4,
    RetryRequest: 5
};
var ErrorActionFlags = {
    None: 0,
    MoveAllAlternatesMatchingHost: 1,
    MoveAllAlternatesMatchingHDCP: 2,
    SwitchToSDR: 4
}; // Reserved for future use
class ErrorController {
    constructor(hls){
        this.hls = void 0;
        this.playlistError = 0;
        this.penalizedRenditions = {};
        this.log = void 0;
        this.warn = void 0;
        this.error = void 0;
        this.hls = hls;
        this.log = logger.log.bind(logger, `[info]:`);
        this.warn = logger.warn.bind(logger, `[warning]:`);
        this.error = logger.error.bind(logger, `[error]:`);
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        hls.on(Events.ERROR, this.onError, this);
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        if (!hls) return;
        hls.off(Events.ERROR, this.onError, this);
        hls.off(Events.ERROR, this.onErrorOut, this);
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    destroy() {
        this.unregisterListeners();
        // @ts-ignore
        this.hls = null;
        this.penalizedRenditions = {};
    }
    startLoad(startPosition) {}
    stopLoad() {
        this.playlistError = 0;
    }
    getVariantLevelIndex(frag) {
        return (frag == null ? void 0 : frag.type) === PlaylistLevelType.MAIN ? frag.level : this.hls.loadLevel;
    }
    onManifestLoading() {
        this.playlistError = 0;
        this.penalizedRenditions = {};
    }
    onLevelUpdated() {
        this.playlistError = 0;
    }
    onError(event, data) {
        var _data$frag, _data$level;
        if (data.fatal) return;
        const hls = this.hls;
        const context = data.context;
        switch(data.details){
            case ErrorDetails.FRAG_LOAD_ERROR:
            case ErrorDetails.FRAG_LOAD_TIMEOUT:
            case ErrorDetails.KEY_LOAD_ERROR:
            case ErrorDetails.KEY_LOAD_TIMEOUT:
                data.errorAction = this.getFragRetryOrSwitchAction(data);
                return;
            case ErrorDetails.FRAG_PARSING_ERROR:
                // ignore empty segment errors marked as gap
                if ((_data$frag = data.frag) != null && _data$frag.gap) {
                    data.errorAction = {
                        action: NetworkErrorAction.DoNothing,
                        flags: ErrorActionFlags.None
                    };
                    return;
                }
            // falls through
            case ErrorDetails.FRAG_GAP:
            case ErrorDetails.FRAG_DECRYPT_ERROR:
                // Switch level if possible, otherwise allow retry count to reach max error retries
                data.errorAction = this.getFragRetryOrSwitchAction(data);
                data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
                return;
            case ErrorDetails.LEVEL_EMPTY_ERROR:
            case ErrorDetails.LEVEL_PARSING_ERROR:
                {
                    var _data$context, _data$context$levelDe;
                    // Only retry when empty and live
                    const levelIndex = data.parent === PlaylistLevelType.MAIN ? data.level : hls.loadLevel;
                    if (data.details === ErrorDetails.LEVEL_EMPTY_ERROR && !!((_data$context = data.context) != null && (_data$context$levelDe = _data$context.levelDetails) != null && _data$context$levelDe.live)) data.errorAction = this.getPlaylistRetryOrSwitchAction(data, levelIndex);
                    else {
                        // Escalate to fatal if not retrying or switching
                        data.levelRetry = false;
                        data.errorAction = this.getLevelSwitchAction(data, levelIndex);
                    }
                }
                return;
            case ErrorDetails.LEVEL_LOAD_ERROR:
            case ErrorDetails.LEVEL_LOAD_TIMEOUT:
                if (typeof (context == null ? void 0 : context.level) === 'number') data.errorAction = this.getPlaylistRetryOrSwitchAction(data, context.level);
                return;
            case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
            case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
            case ErrorDetails.SUBTITLE_LOAD_ERROR:
            case ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:
                if (context) {
                    const level = hls.levels[hls.loadLevel];
                    if (level && (context.type === PlaylistContextType.AUDIO_TRACK && level.hasAudioGroup(context.groupId) || context.type === PlaylistContextType.SUBTITLE_TRACK && level.hasSubtitleGroup(context.groupId))) {
                        // Perform Pathway switch or Redundant failover if possible for fastest recovery
                        // otherwise allow playlist retry count to reach max error retries
                        data.errorAction = this.getPlaylistRetryOrSwitchAction(data, hls.loadLevel);
                        data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
                        data.errorAction.flags = ErrorActionFlags.MoveAllAlternatesMatchingHost;
                        return;
                    }
                }
                return;
            case ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
                {
                    const level = hls.levels[hls.loadLevel];
                    const restrictedHdcpLevel = level == null ? void 0 : level.attrs['HDCP-LEVEL'];
                    if (restrictedHdcpLevel) data.errorAction = {
                        action: NetworkErrorAction.SendAlternateToPenaltyBox,
                        flags: ErrorActionFlags.MoveAllAlternatesMatchingHDCP,
                        hdcpLevel: restrictedHdcpLevel
                    };
                    else this.keySystemError(data);
                }
                return;
            case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
            case ErrorDetails.REMUX_ALLOC_ERROR:
            case ErrorDetails.BUFFER_APPEND_ERROR:
                data.errorAction = this.getLevelSwitchAction(data, (_data$level = data.level) != null ? _data$level : hls.loadLevel);
                return;
            case ErrorDetails.INTERNAL_EXCEPTION:
            case ErrorDetails.BUFFER_APPENDING_ERROR:
            case ErrorDetails.BUFFER_FULL_ERROR:
            case ErrorDetails.LEVEL_SWITCH_ERROR:
            case ErrorDetails.BUFFER_STALLED_ERROR:
            case ErrorDetails.BUFFER_SEEK_OVER_HOLE:
            case ErrorDetails.BUFFER_NUDGE_ON_STALL:
                data.errorAction = {
                    action: NetworkErrorAction.DoNothing,
                    flags: ErrorActionFlags.None
                };
                return;
        }
        if (data.type === ErrorTypes.KEY_SYSTEM_ERROR) this.keySystemError(data);
    }
    keySystemError(data) {
        const levelIndex = this.getVariantLevelIndex(data.frag);
        // Do not retry level. Escalate to fatal if switching levels fails.
        data.levelRetry = false;
        data.errorAction = this.getLevelSwitchAction(data, levelIndex);
    }
    getPlaylistRetryOrSwitchAction(data, levelIndex) {
        const hls = this.hls;
        const retryConfig = getRetryConfig(hls.config.playlistLoadPolicy, data);
        const retryCount = this.playlistError++;
        const retry = shouldRetry(retryConfig, retryCount, isTimeoutError(data), data.response);
        if (retry) return {
            action: NetworkErrorAction.RetryRequest,
            flags: ErrorActionFlags.None,
            retryConfig,
            retryCount
        };
        const errorAction = this.getLevelSwitchAction(data, levelIndex);
        if (retryConfig) {
            errorAction.retryConfig = retryConfig;
            errorAction.retryCount = retryCount;
        }
        return errorAction;
    }
    getFragRetryOrSwitchAction(data) {
        const hls = this.hls;
        // Share fragment error count accross media options (main, audio, subs)
        // This allows for level based rendition switching when media option assets fail
        const variantLevelIndex = this.getVariantLevelIndex(data.frag);
        const level = hls.levels[variantLevelIndex];
        const { fragLoadPolicy, keyLoadPolicy } = hls.config;
        const retryConfig = getRetryConfig(data.details.startsWith('key') ? keyLoadPolicy : fragLoadPolicy, data);
        const fragmentErrors = hls.levels.reduce((acc, level)=>acc + level.fragmentError, 0);
        // Switch levels when out of retried or level index out of bounds
        if (level) {
            if (data.details !== ErrorDetails.FRAG_GAP) level.fragmentError++;
            const retry = shouldRetry(retryConfig, fragmentErrors, isTimeoutError(data), data.response);
            if (retry) return {
                action: NetworkErrorAction.RetryRequest,
                flags: ErrorActionFlags.None,
                retryConfig,
                retryCount: fragmentErrors
            };
        }
        // Reach max retry count, or Missing level reference
        // Switch to valid index
        const errorAction = this.getLevelSwitchAction(data, variantLevelIndex);
        // Add retry details to allow skipping of FRAG_PARSING_ERROR
        if (retryConfig) {
            errorAction.retryConfig = retryConfig;
            errorAction.retryCount = fragmentErrors;
        }
        return errorAction;
    }
    getLevelSwitchAction(data, levelIndex) {
        const hls = this.hls;
        if (levelIndex === null || levelIndex === undefined) levelIndex = hls.loadLevel;
        const level = this.hls.levels[levelIndex];
        if (level) {
            var _data$frag2, _data$context2;
            const errorDetails = data.details;
            level.loadError++;
            if (errorDetails === ErrorDetails.BUFFER_APPEND_ERROR) level.fragmentError++;
            // Search for next level to retry
            let nextLevel = -1;
            const { levels, loadLevel, minAutoLevel, maxAutoLevel } = hls;
            if (!hls.autoLevelEnabled) hls.loadLevel = -1;
            const fragErrorType = (_data$frag2 = data.frag) == null ? void 0 : _data$frag2.type;
            // Find alternate audio codec if available on audio codec error
            const isAudioCodecError = fragErrorType === PlaylistLevelType.AUDIO && errorDetails === ErrorDetails.FRAG_PARSING_ERROR || data.sourceBufferName === 'audio' && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR);
            const findAudioCodecAlternate = isAudioCodecError && levels.some(({ audioCodec })=>level.audioCodec !== audioCodec);
            // Find alternate video codec if available on video codec error
            const isVideoCodecError = data.sourceBufferName === 'video' && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR);
            const findVideoCodecAlternate = isVideoCodecError && levels.some(({ codecSet, audioCodec })=>level.codecSet !== codecSet && level.audioCodec === audioCodec);
            const { type: playlistErrorType, groupId: playlistErrorGroupId } = (_data$context2 = data.context) != null ? _data$context2 : {};
            for(let i = levels.length; i--;){
                const candidate = (i + loadLevel) % levels.length;
                if (candidate !== loadLevel && candidate >= minAutoLevel && candidate <= maxAutoLevel && levels[candidate].loadError === 0) {
                    var _level$audioGroups, _level$subtitleGroups;
                    const levelCandidate = levels[candidate];
                    // Skip level switch if GAP tag is found in next level at same position
                    if (errorDetails === ErrorDetails.FRAG_GAP && data.frag) {
                        const levelDetails = levels[candidate].details;
                        if (levelDetails) {
                            const fragCandidate = findFragmentByPTS(data.frag, levelDetails.fragments, data.frag.start);
                            if (fragCandidate != null && fragCandidate.gap) continue;
                        }
                    } else if (playlistErrorType === PlaylistContextType.AUDIO_TRACK && levelCandidate.hasAudioGroup(playlistErrorGroupId) || playlistErrorType === PlaylistContextType.SUBTITLE_TRACK && levelCandidate.hasSubtitleGroup(playlistErrorGroupId)) continue;
                    else if (fragErrorType === PlaylistLevelType.AUDIO && (_level$audioGroups = level.audioGroups) != null && _level$audioGroups.some((groupId)=>levelCandidate.hasAudioGroup(groupId)) || fragErrorType === PlaylistLevelType.SUBTITLE && (_level$subtitleGroups = level.subtitleGroups) != null && _level$subtitleGroups.some((groupId)=>levelCandidate.hasSubtitleGroup(groupId)) || findAudioCodecAlternate && level.audioCodec === levelCandidate.audioCodec || !findAudioCodecAlternate && level.audioCodec !== levelCandidate.audioCodec || findVideoCodecAlternate && level.codecSet === levelCandidate.codecSet) continue;
                    nextLevel = candidate;
                    break;
                }
            }
            if (nextLevel > -1 && hls.loadLevel !== nextLevel) {
                data.levelRetry = true;
                this.playlistError = 0;
                return {
                    action: NetworkErrorAction.SendAlternateToPenaltyBox,
                    flags: ErrorActionFlags.None,
                    nextAutoLevel: nextLevel
                };
            }
        }
        // No levels to switch / Manual level selection / Level not found
        // Resolve with Pathway switch, Redundant fail-over, or stay on lowest Level
        return {
            action: NetworkErrorAction.SendAlternateToPenaltyBox,
            flags: ErrorActionFlags.MoveAllAlternatesMatchingHost
        };
    }
    onErrorOut(event, data) {
        var _data$errorAction;
        switch((_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.action){
            case NetworkErrorAction.DoNothing:
                break;
            case NetworkErrorAction.SendAlternateToPenaltyBox:
                this.sendAlternateToPenaltyBox(data);
                if (!data.errorAction.resolved && data.details !== ErrorDetails.FRAG_GAP) data.fatal = true;
                else if (/MediaSource readyState: ended/.test(data.error.message)) {
                    this.warn(`MediaSource ended after "${data.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`);
                    this.hls.recoverMediaError();
                }
                break;
            case NetworkErrorAction.RetryRequest:
                break;
        }
        if (data.fatal) {
            this.hls.stopLoad();
            return;
        }
    }
    sendAlternateToPenaltyBox(data) {
        const hls = this.hls;
        const errorAction = data.errorAction;
        if (!errorAction) return;
        const { flags, hdcpLevel, nextAutoLevel } = errorAction;
        switch(flags){
            case ErrorActionFlags.None:
                this.switchLevel(data, nextAutoLevel);
                break;
            case ErrorActionFlags.MoveAllAlternatesMatchingHDCP:
                if (hdcpLevel) {
                    hls.maxHdcpLevel = HdcpLevels[HdcpLevels.indexOf(hdcpLevel) - 1];
                    errorAction.resolved = true;
                }
                this.warn(`Restricting playback to HDCP-LEVEL of "${hls.maxHdcpLevel}" or lower`);
                break;
        }
        // If not resolved by previous actions try to switch to next level
        if (!errorAction.resolved) this.switchLevel(data, nextAutoLevel);
    }
    switchLevel(data, levelIndex) {
        if (levelIndex !== undefined && data.errorAction) {
            this.warn(`switching to level ${levelIndex} after ${data.details}`);
            this.hls.nextAutoLevel = levelIndex;
            data.errorAction.resolved = true;
            // Stream controller is responsible for this but won't switch on false start
            this.hls.nextLoadLevel = this.hls.nextAutoLevel;
        }
    }
}
class BasePlaylistController {
    constructor(hls, logPrefix){
        this.hls = void 0;
        this.timer = -1;
        this.requestScheduled = -1;
        this.canLoad = false;
        this.log = void 0;
        this.warn = void 0;
        this.log = logger.log.bind(logger, `${logPrefix}:`);
        this.warn = logger.warn.bind(logger, `${logPrefix}:`);
        this.hls = hls;
    }
    destroy() {
        this.clearTimer();
        // @ts-ignore
        this.hls = this.log = this.warn = null;
    }
    clearTimer() {
        if (this.timer !== -1) {
            self.clearTimeout(this.timer);
            this.timer = -1;
        }
    }
    startLoad() {
        this.canLoad = true;
        this.requestScheduled = -1;
        this.loadPlaylist();
    }
    stopLoad() {
        this.canLoad = false;
        this.clearTimer();
    }
    switchParams(playlistUri, previous, current) {
        const renditionReports = previous == null ? void 0 : previous.renditionReports;
        if (renditionReports) {
            let foundIndex = -1;
            for(let i = 0; i < renditionReports.length; i++){
                const attr = renditionReports[i];
                let uri;
                try {
                    uri = new self.URL(attr.URI, previous.url).href;
                } catch (error) {
                    logger.warn(`Could not construct new URL for Rendition Report: ${error}`);
                    uri = attr.URI || '';
                }
                // Use exact match. Otherwise, the last partial match, if any, will be used
                // (Playlist URI includes a query string that the Rendition Report does not)
                if (uri === playlistUri) {
                    foundIndex = i;
                    break;
                } else if (uri === playlistUri.substring(0, uri.length)) foundIndex = i;
            }
            if (foundIndex !== -1) {
                const attr = renditionReports[foundIndex];
                const msn = parseInt(attr['LAST-MSN']) || (previous == null ? void 0 : previous.lastPartSn);
                let part = parseInt(attr['LAST-PART']) || (previous == null ? void 0 : previous.lastPartIndex);
                if (this.hls.config.lowLatencyMode) {
                    const currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
                    if (part >= 0 && currentGoal > previous.partTarget) part += 1;
                }
                const skip = current && getSkipValue(current);
                return new HlsUrlParameters(msn, part >= 0 ? part : undefined, skip);
            }
        }
    }
    loadPlaylist(hlsUrlParameters) {
        if (this.requestScheduled === -1) this.requestScheduled = self.performance.now();
    // Loading is handled by the subclasses
    }
    shouldLoadPlaylist(playlist) {
        return this.canLoad && !!playlist && !!playlist.url && (!playlist.details || playlist.details.live);
    }
    shouldReloadPlaylist(playlist) {
        return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(playlist);
    }
    playlistLoaded(index, data, previousDetails) {
        const { details, stats } = data;
        // Set last updated date-time
        const now = self.performance.now();
        const elapsed = stats.loading.first ? Math.max(0, now - stats.loading.first) : 0;
        details.advancedDateTime = Date.now() - elapsed;
        // if current playlist is a live playlist, arm a timer to reload it
        if (details.live || previousDetails != null && previousDetails.live) {
            details.reloaded(previousDetails);
            if (previousDetails) this.log(`live playlist ${index} ${details.advanced ? 'REFRESHED ' + details.lastPartSn + '-' + details.lastPartIndex : details.updated ? 'UPDATED' : 'MISSED'}`);
            // Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
            if (previousDetails && details.fragments.length > 0) mergeDetails(previousDetails, details);
            if (!this.canLoad || !details.live) return;
            let deliveryDirectives;
            let msn = undefined;
            let part = undefined;
            if (details.canBlockReload && details.endSN && details.advanced) {
                // Load level with LL-HLS delivery directives
                const lowLatencyMode = this.hls.config.lowLatencyMode;
                const lastPartSn = details.lastPartSn;
                const endSn = details.endSN;
                const lastPartIndex = details.lastPartIndex;
                const hasParts = lastPartIndex !== -1;
                const lastPart = lastPartSn === endSn;
                // When low latency mode is disabled, we'll skip part requests once the last part index is found
                const nextSnStartIndex = lowLatencyMode ? 0 : lastPartIndex;
                if (hasParts) {
                    msn = lastPart ? endSn + 1 : lastPartSn;
                    part = lastPart ? nextSnStartIndex : lastPartIndex + 1;
                } else msn = endSn + 1;
                // Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
                // Update directives to obtain the Playlist that has the estimated additional duration of media
                const lastAdvanced = details.age;
                const cdnAge = lastAdvanced + details.ageHeader;
                let currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
                if (currentGoal > 0) {
                    if (previousDetails && currentGoal > previousDetails.tuneInGoal) {
                        // If we attempted to get the next or latest playlist update, but currentGoal increased,
                        // then we either can't catchup, or the "age" header cannot be trusted.
                        this.warn(`CDN Tune-in goal increased from: ${previousDetails.tuneInGoal} to: ${currentGoal} with playlist age: ${details.age}`);
                        currentGoal = 0;
                    } else {
                        const segments = Math.floor(currentGoal / details.targetduration);
                        msn += segments;
                        if (part !== undefined) {
                            const parts = Math.round(currentGoal % details.targetduration / details.partTarget);
                            part += parts;
                        }
                        this.log(`CDN Tune-in age: ${details.ageHeader}s last advanced ${lastAdvanced.toFixed(2)}s goal: ${currentGoal} skip sn ${segments} to part ${part}`);
                    }
                    details.tuneInGoal = currentGoal;
                }
                deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
                if (lowLatencyMode || !lastPart) {
                    this.loadPlaylist(deliveryDirectives);
                    return;
                }
            } else if (details.canBlockReload || details.canSkipUntil) deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
            const bufferInfo = this.hls.mainForwardBufferInfo;
            const position = bufferInfo ? bufferInfo.end - bufferInfo.len : 0;
            const distanceToLiveEdgeMs = (details.edge - position) * 1000;
            const reloadInterval = computeReloadInterval(details, distanceToLiveEdgeMs);
            if (details.updated && now > this.requestScheduled + reloadInterval) this.requestScheduled = stats.loading.start;
            if (msn !== undefined && details.canBlockReload) this.requestScheduled = stats.loading.first + reloadInterval - (details.partTarget * 1000 || 1000);
            else if (this.requestScheduled === -1 || this.requestScheduled + reloadInterval < now) this.requestScheduled = now;
            else if (this.requestScheduled - now <= 0) this.requestScheduled += reloadInterval;
            let estimatedTimeUntilUpdate = this.requestScheduled - now;
            estimatedTimeUntilUpdate = Math.max(0, estimatedTimeUntilUpdate);
            this.log(`reload live playlist ${index} in ${Math.round(estimatedTimeUntilUpdate)} ms`);
            // this.log(
            //   `live reload ${details.updated ? 'REFRESHED' : 'MISSED'}
            // reload in ${estimatedTimeUntilUpdate / 1000}
            // round trip ${(stats.loading.end - stats.loading.start) / 1000}
            // diff ${
            //   (reloadInterval -
            //     (estimatedTimeUntilUpdate +
            //       stats.loading.end -
            //       stats.loading.start)) /
            //   1000
            // }
            // reload interval ${reloadInterval / 1000}
            // target duration ${details.targetduration}
            // distance to edge ${distanceToLiveEdgeMs / 1000}`
            // );
            this.timer = self.setTimeout(()=>this.loadPlaylist(deliveryDirectives), estimatedTimeUntilUpdate);
        } else this.clearTimer();
    }
    getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
        let skip = getSkipValue(details);
        if (previousDeliveryDirectives != null && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
            msn = previousDeliveryDirectives.msn;
            part = previousDeliveryDirectives.part;
            skip = HlsSkip.No;
        }
        return new HlsUrlParameters(msn, part, skip);
    }
    checkRetry(errorEvent) {
        const errorDetails = errorEvent.details;
        const isTimeout = isTimeoutError(errorEvent);
        const errorAction = errorEvent.errorAction;
        const { action, retryCount = 0, retryConfig } = errorAction || {};
        const retry = !!errorAction && !!retryConfig && (action === NetworkErrorAction.RetryRequest || !errorAction.resolved && action === NetworkErrorAction.SendAlternateToPenaltyBox);
        if (retry) {
            var _errorEvent$context;
            this.requestScheduled = -1;
            if (retryCount >= retryConfig.maxNumRetry) return false;
            if (isTimeout && (_errorEvent$context = errorEvent.context) != null && _errorEvent$context.deliveryDirectives) {
                // The LL-HLS request already timed out so retry immediately
                this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" without delivery-directives`);
                this.loadPlaylist();
            } else {
                const delay = getRetryDelay(retryConfig, retryCount);
                // Schedule level/track reload
                this.timer = self.setTimeout(()=>this.loadPlaylist(), delay);
                this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" in ${delay}ms`);
            }
            // `levelRetry = true` used to inform other controllers that a retry is happening
            errorEvent.levelRetry = true;
            errorAction.resolved = true;
        }
        return retry;
    }
}
/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */ class EWMA {
    //  About half of the estimated value will be from the last |halfLife| samples by weight.
    constructor(halfLife, estimate = 0, weight = 0){
        this.halfLife = void 0;
        this.alpha_ = void 0;
        this.estimate_ = void 0;
        this.totalWeight_ = void 0;
        this.halfLife = halfLife;
        // Larger values of alpha expire historical data more slowly.
        this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
        this.estimate_ = estimate;
        this.totalWeight_ = weight;
    }
    sample(weight, value) {
        const adjAlpha = Math.pow(this.alpha_, weight);
        this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
        this.totalWeight_ += weight;
    }
    getTotalWeight() {
        return this.totalWeight_;
    }
    getEstimate() {
        if (this.alpha_) {
            const zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
            if (zeroFactor) return this.estimate_ / zeroFactor;
        }
        return this.estimate_;
    }
}
/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */ class EwmaBandWidthEstimator {
    constructor(slow, fast, defaultEstimate, defaultTTFB = 100){
        this.defaultEstimate_ = void 0;
        this.minWeight_ = void 0;
        this.minDelayMs_ = void 0;
        this.slow_ = void 0;
        this.fast_ = void 0;
        this.defaultTTFB_ = void 0;
        this.ttfb_ = void 0;
        this.defaultEstimate_ = defaultEstimate;
        this.minWeight_ = 0.001;
        this.minDelayMs_ = 50;
        this.slow_ = new EWMA(slow);
        this.fast_ = new EWMA(fast);
        this.defaultTTFB_ = defaultTTFB;
        this.ttfb_ = new EWMA(slow);
    }
    update(slow, fast) {
        const { slow_, fast_, ttfb_ } = this;
        if (slow_.halfLife !== slow) this.slow_ = new EWMA(slow, slow_.getEstimate(), slow_.getTotalWeight());
        if (fast_.halfLife !== fast) this.fast_ = new EWMA(fast, fast_.getEstimate(), fast_.getTotalWeight());
        if (ttfb_.halfLife !== slow) this.ttfb_ = new EWMA(slow, ttfb_.getEstimate(), ttfb_.getTotalWeight());
    }
    sample(durationMs, numBytes) {
        durationMs = Math.max(durationMs, this.minDelayMs_);
        const numBits = 8 * numBytes;
        // weight is duration in seconds
        const durationS = durationMs / 1000;
        // value is bandwidth in bits/s
        const bandwidthInBps = numBits / durationS;
        this.fast_.sample(durationS, bandwidthInBps);
        this.slow_.sample(durationS, bandwidthInBps);
    }
    sampleTTFB(ttfb) {
        // weight is frequency curve applied to TTFB in seconds
        // (longer times have less weight with expected input under 1 second)
        const seconds = ttfb / 1000;
        const weight = Math.sqrt(2) * Math.exp(-Math.pow(seconds, 2) / 2);
        this.ttfb_.sample(weight, Math.max(ttfb, 5));
    }
    canEstimate() {
        return this.fast_.getTotalWeight() >= this.minWeight_;
    }
    getEstimate() {
        if (this.canEstimate()) // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
        // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
        // Take the minimum of these two estimates.  This should have the effect of
        // adapting down quickly, but up more slowly.
        return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
        else return this.defaultEstimate_;
    }
    getEstimateTTFB() {
        if (this.ttfb_.getTotalWeight() >= this.minWeight_) return this.ttfb_.getEstimate();
        else return this.defaultTTFB_;
    }
    destroy() {}
}
const SUPPORTED_INFO_DEFAULT = {
    supported: true,
    configurations: [],
    decodingInfoResults: [
        {
            supported: true,
            powerEfficient: true,
            smooth: true
        }
    ]
};
const SUPPORTED_INFO_CACHE = {};
function requiresMediaCapabilitiesDecodingInfo(level, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference) {
    // Only test support when configuration is exceeds minimum options
    const audioGroups = level.audioCodec ? level.audioGroups : null;
    const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
    const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
    const maxChannels = channelsPreference ? parseInt(channelsPreference) : audioCodecPreference ? Infinity : 2;
    let audioChannels = null;
    if (audioGroups != null && audioGroups.length) try {
        if (audioGroups.length === 1 && audioGroups[0]) audioChannels = audioTracksByGroup.groups[audioGroups[0]].channels;
        else audioChannels = audioGroups.reduce((acc, groupId)=>{
            if (groupId) {
                const audioTrackGroup = audioTracksByGroup.groups[groupId];
                if (!audioTrackGroup) throw new Error(`Audio track group ${groupId} not found`);
                // Sum all channel key values
                Object.keys(audioTrackGroup.channels).forEach((key)=>{
                    acc[key] = (acc[key] || 0) + audioTrackGroup.channels[key];
                });
            }
            return acc;
        }, {
            2: 0
        });
    } catch (error) {
        return true;
    }
    return level.videoCodec !== undefined && (level.width > 1920 && level.height > 1088 || level.height > 1920 && level.width > 1088 || level.frameRate > Math.max(currentFrameRate, 30) || level.videoRange !== 'SDR' && level.videoRange !== currentVideoRange || level.bitrate > Math.max(currentBw, 8e6)) || !!audioChannels && isFiniteNumber(maxChannels) && Object.keys(audioChannels).some((channels)=>parseInt(channels) > maxChannels);
}
function getMediaDecodingInfoPromise(level, audioTracksByGroup, mediaCapabilities) {
    const videoCodecs = level.videoCodec;
    const audioCodecs = level.audioCodec;
    if (!videoCodecs || !audioCodecs || !mediaCapabilities) return Promise.resolve(SUPPORTED_INFO_DEFAULT);
    const baseVideoConfiguration = {
        width: level.width,
        height: level.height,
        bitrate: Math.ceil(Math.max(level.bitrate * 0.9, level.averageBitrate)),
        // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
        framerate: level.frameRate || 30
    };
    const videoRange = level.videoRange;
    if (videoRange !== 'SDR') baseVideoConfiguration.transferFunction = videoRange.toLowerCase();
    const configurations = videoCodecs.split(',').map((videoCodec)=>({
            type: 'media-source',
            video: _objectSpread2(_objectSpread2({}, baseVideoConfiguration), {}, {
                contentType: mimeTypeForCodec(videoCodec, 'video')
            })
        }));
    if (audioCodecs && level.audioGroups) level.audioGroups.forEach((audioGroupId)=>{
        var _audioTracksByGroup$g;
        if (!audioGroupId) return;
        (_audioTracksByGroup$g = audioTracksByGroup.groups[audioGroupId]) == null || _audioTracksByGroup$g.tracks.forEach((audioTrack)=>{
            if (audioTrack.groupId === audioGroupId) {
                const channels = audioTrack.channels || '';
                const channelsNumber = parseFloat(channels);
                if (isFiniteNumber(channelsNumber) && channelsNumber > 2) configurations.push.apply(configurations, audioCodecs.split(',').map((audioCodec)=>({
                        type: 'media-source',
                        audio: {
                            contentType: mimeTypeForCodec(audioCodec, 'audio'),
                            channels: '' + channelsNumber
                        }
                    })));
            }
        });
    });
    return Promise.all(configurations.map((configuration)=>{
        // Cache MediaCapabilities promises
        const decodingInfoKey = getMediaDecodingInfoKey(configuration);
        return SUPPORTED_INFO_CACHE[decodingInfoKey] || (SUPPORTED_INFO_CACHE[decodingInfoKey] = mediaCapabilities.decodingInfo(configuration));
    })).then((decodingInfoResults)=>({
            supported: !decodingInfoResults.some((info)=>!info.supported),
            configurations,
            decodingInfoResults
        })).catch((error)=>({
            supported: false,
            configurations,
            decodingInfoResults: [],
            error
        }));
}
function getMediaDecodingInfoKey(config) {
    const { audio, video } = config;
    const mediaConfig = video || audio;
    if (mediaConfig) {
        const codec = mediaConfig.contentType.split('"')[1];
        if (video) return `r${video.height}x${video.width}f${Math.ceil(video.framerate)}${video.transferFunction || 'sd'}_${codec}_${Math.ceil(video.bitrate / 1e5)}`;
        if (audio) return `c${audio.channels}${audio.spatialRendering ? 's' : 'n'}_${codec}`;
    }
    return '';
}
/**
 * @returns Whether we can detect and validate HDR capability within the window context
 */ function isHdrSupported() {
    if (typeof matchMedia === 'function') {
        const mediaQueryList = matchMedia('(dynamic-range: high)');
        const badQuery = matchMedia('bad query');
        if (mediaQueryList.media !== badQuery.media) return mediaQueryList.matches === true;
    }
    return false;
}
/**
 * Sanitizes inputs to return the active video selection options for HDR/SDR.
 * When both inputs are null:
 *
 *    `{ preferHDR: false, allowedVideoRanges: [] }`
 *
 * When `currentVideoRange` non-null, maintain the active range:
 *
 *    `{ preferHDR: currentVideoRange !== 'SDR', allowedVideoRanges: [currentVideoRange] }`
 *
 * When VideoSelectionOption non-null:
 *
 *  - Allow all video ranges if `allowedVideoRanges` unspecified.
 *  - If `preferHDR` is non-null use the value to filter `allowedVideoRanges`.
 *  - Else check window for HDR support and set `preferHDR` to the result.
 *
 * @param currentVideoRange
 * @param videoPreference
 */ function getVideoSelectionOptions(currentVideoRange, videoPreference) {
    let preferHDR = false;
    let allowedVideoRanges = [];
    if (currentVideoRange) {
        preferHDR = currentVideoRange !== 'SDR';
        allowedVideoRanges = [
            currentVideoRange
        ];
    }
    if (videoPreference) {
        allowedVideoRanges = videoPreference.allowedVideoRanges || VideoRangeValues.slice(0);
        preferHDR = videoPreference.preferHDR !== undefined ? videoPreference.preferHDR : isHdrSupported();
        if (preferHDR) allowedVideoRanges = allowedVideoRanges.filter((range)=>range !== 'SDR');
        else allowedVideoRanges = [
            'SDR'
        ];
    }
    return {
        preferHDR,
        allowedVideoRanges
    };
}
function getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference) {
    const codecSets = Object.keys(codecTiers);
    const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
    const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
    const preferStereo = channelsPreference && parseInt(channelsPreference) === 2;
    // Use first level set to determine stereo, and minimum resolution and framerate
    let hasStereo = true;
    let hasCurrentVideoRange = false;
    let minHeight = Infinity;
    let minFramerate = Infinity;
    let minBitrate = Infinity;
    let selectedScore = 0;
    let videoRanges = [];
    const { preferHDR, allowedVideoRanges } = getVideoSelectionOptions(currentVideoRange, videoPreference);
    for(let i = codecSets.length; i--;){
        const tier = codecTiers[codecSets[i]];
        hasStereo = tier.channels[2] > 0;
        minHeight = Math.min(minHeight, tier.minHeight);
        minFramerate = Math.min(minFramerate, tier.minFramerate);
        minBitrate = Math.min(minBitrate, tier.minBitrate);
        const matchingVideoRanges = allowedVideoRanges.filter((range)=>tier.videoRanges[range] > 0);
        if (matchingVideoRanges.length > 0) {
            hasCurrentVideoRange = true;
            videoRanges = matchingVideoRanges;
        }
    }
    minHeight = isFiniteNumber(minHeight) ? minHeight : 0;
    minFramerate = isFiniteNumber(minFramerate) ? minFramerate : 0;
    const maxHeight = Math.max(1080, minHeight);
    const maxFramerate = Math.max(30, minFramerate);
    minBitrate = isFiniteNumber(minBitrate) ? minBitrate : currentBw;
    currentBw = Math.max(minBitrate, currentBw);
    // If there are no variants with matching preference, set currentVideoRange to undefined
    if (!hasCurrentVideoRange) {
        currentVideoRange = undefined;
        videoRanges = [];
    }
    const codecSet = codecSets.reduce((selected, candidate)=>{
        // Remove candiates which do not meet bitrate, default audio, stereo or channels preference, 1080p or lower, 30fps or lower, or SDR/HDR selection if present
        const candidateTier = codecTiers[candidate];
        if (candidate === selected) return selected;
        if (candidateTier.minBitrate > currentBw) {
            logStartCodecCandidateIgnored(candidate, `min bitrate of ${candidateTier.minBitrate} > current estimate of ${currentBw}`);
            return selected;
        }
        if (!candidateTier.hasDefaultAudio) {
            logStartCodecCandidateIgnored(candidate, `no renditions with default or auto-select sound found`);
            return selected;
        }
        if (audioCodecPreference && candidate.indexOf(audioCodecPreference.substring(0, 4)) % 5 !== 0) {
            logStartCodecCandidateIgnored(candidate, `audio codec preference "${audioCodecPreference}" not found`);
            return selected;
        }
        if (channelsPreference && !preferStereo) {
            if (!candidateTier.channels[channelsPreference]) {
                logStartCodecCandidateIgnored(candidate, `no renditions with ${channelsPreference} channel sound found (channels options: ${Object.keys(candidateTier.channels)})`);
                return selected;
            }
        } else if ((!audioCodecPreference || preferStereo) && hasStereo && candidateTier.channels['2'] === 0) {
            logStartCodecCandidateIgnored(candidate, `no renditions with stereo sound found`);
            return selected;
        }
        if (candidateTier.minHeight > maxHeight) {
            logStartCodecCandidateIgnored(candidate, `min resolution of ${candidateTier.minHeight} > maximum of ${maxHeight}`);
            return selected;
        }
        if (candidateTier.minFramerate > maxFramerate) {
            logStartCodecCandidateIgnored(candidate, `min framerate of ${candidateTier.minFramerate} > maximum of ${maxFramerate}`);
            return selected;
        }
        if (!videoRanges.some((range)=>candidateTier.videoRanges[range] > 0)) {
            logStartCodecCandidateIgnored(candidate, `no variants with VIDEO-RANGE of ${JSON.stringify(videoRanges)} found`);
            return selected;
        }
        if (candidateTier.maxScore < selectedScore) {
            logStartCodecCandidateIgnored(candidate, `max score of ${candidateTier.maxScore} < selected max of ${selectedScore}`);
            return selected;
        }
        // Remove candiates with less preferred codecs or more errors
        if (selected && (codecsSetSelectionPreferenceValue(candidate) >= codecsSetSelectionPreferenceValue(selected) || candidateTier.fragmentError > codecTiers[selected].fragmentError)) return selected;
        selectedScore = candidateTier.maxScore;
        return candidate;
    }, undefined);
    return {
        codecSet,
        videoRanges,
        preferHDR,
        minFramerate,
        minBitrate
    };
}
function logStartCodecCandidateIgnored(codeSet, reason) {
    logger.log(`[abr] start candidates with "${codeSet}" ignored because ${reason}`);
}
function getAudioTracksByGroup(allAudioTracks) {
    return allAudioTracks.reduce((audioTracksByGroup, track)=>{
        let trackGroup = audioTracksByGroup.groups[track.groupId];
        if (!trackGroup) trackGroup = audioTracksByGroup.groups[track.groupId] = {
            tracks: [],
            channels: {
                2: 0
            },
            hasDefault: false,
            hasAutoSelect: false
        };
        trackGroup.tracks.push(track);
        const channelsKey = track.channels || '2';
        trackGroup.channels[channelsKey] = (trackGroup.channels[channelsKey] || 0) + 1;
        trackGroup.hasDefault = trackGroup.hasDefault || track.default;
        trackGroup.hasAutoSelect = trackGroup.hasAutoSelect || track.autoselect;
        if (trackGroup.hasDefault) audioTracksByGroup.hasDefaultAudio = true;
        if (trackGroup.hasAutoSelect) audioTracksByGroup.hasAutoSelectAudio = true;
        return audioTracksByGroup;
    }, {
        hasDefaultAudio: false,
        hasAutoSelectAudio: false,
        groups: {}
    });
}
function getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel) {
    return levels.slice(minAutoLevel, maxAutoLevel + 1).reduce((tiers, level)=>{
        if (!level.codecSet) return tiers;
        const audioGroups = level.audioGroups;
        let tier = tiers[level.codecSet];
        if (!tier) tiers[level.codecSet] = tier = {
            minBitrate: Infinity,
            minHeight: Infinity,
            minFramerate: Infinity,
            maxScore: 0,
            videoRanges: {
                SDR: 0
            },
            channels: {
                '2': 0
            },
            hasDefaultAudio: !audioGroups,
            fragmentError: 0
        };
        tier.minBitrate = Math.min(tier.minBitrate, level.bitrate);
        const lesserWidthOrHeight = Math.min(level.height, level.width);
        tier.minHeight = Math.min(tier.minHeight, lesserWidthOrHeight);
        tier.minFramerate = Math.min(tier.minFramerate, level.frameRate);
        tier.maxScore = Math.max(tier.maxScore, level.score);
        tier.fragmentError += level.fragmentError;
        tier.videoRanges[level.videoRange] = (tier.videoRanges[level.videoRange] || 0) + 1;
        if (audioGroups) audioGroups.forEach((audioGroupId)=>{
            if (!audioGroupId) return;
            const audioGroup = audioTracksByGroup.groups[audioGroupId];
            if (!audioGroup) return;
            // Default audio is any group with DEFAULT=YES, or if missing then any group with AUTOSELECT=YES, or all variants
            tier.hasDefaultAudio = tier.hasDefaultAudio || audioTracksByGroup.hasDefaultAudio ? audioGroup.hasDefault : audioGroup.hasAutoSelect || !audioTracksByGroup.hasDefaultAudio && !audioTracksByGroup.hasAutoSelectAudio;
            Object.keys(audioGroup.channels).forEach((channels)=>{
                tier.channels[channels] = (tier.channels[channels] || 0) + audioGroup.channels[channels];
            });
        });
        return tiers;
    }, {});
}
function findMatchingOption(option, tracks, matchPredicate) {
    if ('attrs' in option) {
        const index = tracks.indexOf(option);
        if (index !== -1) return index;
    }
    for(let i = 0; i < tracks.length; i++){
        const track = tracks[i];
        if (matchesOption(option, track, matchPredicate)) return i;
    }
    return -1;
}
function matchesOption(option, track, matchPredicate) {
    const { groupId, name, lang, assocLang, characteristics, default: isDefault } = option;
    const forced = option.forced;
    return (groupId === undefined || track.groupId === groupId) && (name === undefined || track.name === name) && (lang === undefined || track.lang === lang) && (lang === undefined || track.assocLang === assocLang) && (isDefault === undefined || track.default === isDefault) && (forced === undefined || track.forced === forced) && (characteristics === undefined || characteristicsMatch(characteristics, track.characteristics)) && (matchPredicate === undefined || matchPredicate(option, track));
}
function characteristicsMatch(characteristicsA, characteristicsB = '') {
    const arrA = characteristicsA.split(',');
    const arrB = characteristicsB.split(',');
    // Expects each item to be unique:
    return arrA.length === arrB.length && !arrA.some((el)=>arrB.indexOf(el) === -1);
}
function audioMatchPredicate(option, track) {
    const { audioCodec, channels } = option;
    return (audioCodec === undefined || (track.audioCodec || '').substring(0, 4) === audioCodec.substring(0, 4)) && (channels === undefined || channels === (track.channels || '2'));
}
function findClosestLevelWithAudioGroup(option, levels, allAudioTracks, searchIndex, matchPredicate) {
    const currentLevel = levels[searchIndex];
    // Are there variants with same URI as current level?
    // If so, find a match that does not require any level URI change
    const variants = levels.reduce((variantMap, level, index)=>{
        const uri = level.uri;
        const renditions = variantMap[uri] || (variantMap[uri] = []);
        renditions.push(index);
        return variantMap;
    }, {});
    const renditions = variants[currentLevel.uri];
    if (renditions.length > 1) searchIndex = Math.max.apply(Math, renditions);
    // Find best match
    const currentVideoRange = currentLevel.videoRange;
    const currentFrameRate = currentLevel.frameRate;
    const currentVideoCodec = currentLevel.codecSet.substring(0, 4);
    const matchingVideo = searchDownAndUpList(levels, searchIndex, (level)=>{
        if (level.videoRange !== currentVideoRange || level.frameRate !== currentFrameRate || level.codecSet.substring(0, 4) !== currentVideoCodec) return false;
        const audioGroups = level.audioGroups;
        const tracks = allAudioTracks.filter((track)=>!audioGroups || audioGroups.indexOf(track.groupId) !== -1);
        return findMatchingOption(option, tracks, matchPredicate) > -1;
    });
    if (matchingVideo > -1) return matchingVideo;
    return searchDownAndUpList(levels, searchIndex, (level)=>{
        const audioGroups = level.audioGroups;
        const tracks = allAudioTracks.filter((track)=>!audioGroups || audioGroups.indexOf(track.groupId) !== -1);
        return findMatchingOption(option, tracks, matchPredicate) > -1;
    });
}
function searchDownAndUpList(arr, searchIndex, predicate) {
    for(let i = searchIndex; i; i--){
        if (predicate(arr[i])) return i;
    }
    for(let i = searchIndex + 1; i < arr.length; i++){
        if (predicate(arr[i])) return i;
    }
    return -1;
}
class AbrController {
    constructor(_hls){
        this.hls = void 0;
        this.lastLevelLoadSec = 0;
        this.lastLoadedFragLevel = -1;
        this.firstSelection = -1;
        this._nextAutoLevel = -1;
        this.nextAutoLevelKey = '';
        this.audioTracksByGroup = null;
        this.codecTiers = null;
        this.timer = -1;
        this.fragCurrent = null;
        this.partCurrent = null;
        this.bitrateTestDelay = 0;
        this.bwEstimator = void 0;
        /*
        This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
        quickly enough to prevent underbuffering
      */ this._abandonRulesCheck = ()=>{
            const { fragCurrent: frag, partCurrent: part, hls } = this;
            const { autoLevelEnabled, media } = hls;
            if (!frag || !media) return;
            const now = performance.now();
            const stats = part ? part.stats : frag.stats;
            const duration = part ? part.duration : frag.duration;
            const timeLoading = now - stats.loading.start;
            const minAutoLevel = hls.minAutoLevel;
            // If frag loading is aborted, complete, or from lowest level, stop timer and return
            if (stats.aborted || stats.loaded && stats.loaded === stats.total || frag.level <= minAutoLevel) {
                this.clearTimer();
                // reset forced auto level value so that next level will be selected
                this._nextAutoLevel = -1;
                return;
            }
            // This check only runs if we're in ABR mode and actually playing
            if (!autoLevelEnabled || media.paused || !media.playbackRate || !media.readyState) return;
            const bufferInfo = hls.mainForwardBufferInfo;
            if (bufferInfo === null) return;
            const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
            const playbackRate = Math.abs(media.playbackRate);
            // To maintain stable adaptive playback, only begin monitoring frag loading after half or more of its playback duration has passed
            if (timeLoading <= Math.max(ttfbEstimate, 1000 * (duration / (playbackRate * 2)))) return;
            // bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
            const bufferStarvationDelay = bufferInfo.len / playbackRate;
            const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
            const loadedFirstByte = stats.loaded && ttfb > -1;
            const bwEstimate = this.getBwEstimate();
            const levels = hls.levels;
            const level = levels[frag.level];
            const expectedLen = stats.total || Math.max(stats.loaded, Math.round(duration * level.averageBitrate / 8));
            let timeStreaming = loadedFirstByte ? timeLoading - ttfb : timeLoading;
            if (timeStreaming < 1 && loadedFirstByte) timeStreaming = Math.min(timeLoading, stats.loaded * 8 / bwEstimate);
            const loadRate = loadedFirstByte ? stats.loaded * 1000 / timeStreaming : 0;
            // fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
            const fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate + ttfbEstimate / 1000;
            // Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
            if (fragLoadedDelay <= bufferStarvationDelay) return;
            const bwe = loadRate ? loadRate * 8 : bwEstimate;
            let fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
            let nextLoadLevel;
            // Iterate through lower level and try to find the largest one that avoids rebuffering
            for(nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--){
                // compute time to load next fragment at lower level
                // 8 = bits per byte (bps/Bps)
                const levelNextBitrate = levels[nextLoadLevel].maxBitrate;
                fragLevelNextLoadedDelay = this.getTimeToLoadFrag(ttfbEstimate / 1000, bwe, duration * levelNextBitrate, !levels[nextLoadLevel].details);
                if (fragLevelNextLoadedDelay < bufferStarvationDelay) break;
            }
            // Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
            // to load the current one
            if (fragLevelNextLoadedDelay >= fragLoadedDelay) return;
            // if estimated load time of new segment is completely unreasonable, ignore and do not emergency switch down
            if (fragLevelNextLoadedDelay > duration * 10) return;
            hls.nextLoadLevel = hls.nextAutoLevel = nextLoadLevel;
            if (loadedFirstByte) // If there has been loading progress, sample bandwidth using loading time offset by minimum TTFB time
            this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
            else // If there has been no loading progress, sample TTFB
            this.bwEstimator.sampleTTFB(timeLoading);
            const nextLoadLevelBitrate = levels[nextLoadLevel].maxBitrate;
            if (this.getBwEstimate() * this.hls.config.abrBandWidthUpFactor > nextLoadLevelBitrate) this.resetEstimator(nextLoadLevelBitrate);
            this.clearTimer();
            logger.warn(`[abr] Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${frag.level} is loading too slowly;
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s
      Estimated load time for current fragment: ${fragLoadedDelay.toFixed(3)} s
      Estimated load time for down switch fragment: ${fragLevelNextLoadedDelay.toFixed(3)} s
      TTFB estimate: ${ttfb | 0} ms
      Current BW estimate: ${isFiniteNumber(bwEstimate) ? bwEstimate | 0 : 'Unknown'} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${nextLoadLevel} @ ${nextLoadLevelBitrate | 0} bps`);
            hls.trigger(Events.FRAG_LOAD_EMERGENCY_ABORTED, {
                frag,
                part,
                stats
            });
        };
        this.hls = _hls;
        this.bwEstimator = this.initEstimator();
        this.registerListeners();
    }
    resetEstimator(abrEwmaDefaultEstimate) {
        if (abrEwmaDefaultEstimate) {
            logger.log(`setting initial bwe to ${abrEwmaDefaultEstimate}`);
            this.hls.config.abrEwmaDefaultEstimate = abrEwmaDefaultEstimate;
        }
        this.firstSelection = -1;
        this.bwEstimator = this.initEstimator();
    }
    initEstimator() {
        const config = this.hls.config;
        return new EwmaBandWidthEstimator(config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
    }
    registerListeners() {
        const { hls } = this;
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
        hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
        hls.on(Events.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls } = this;
        if (!hls) return;
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
        hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
        hls.off(Events.ERROR, this.onError, this);
    }
    destroy() {
        this.unregisterListeners();
        this.clearTimer();
        // @ts-ignore
        this.hls = this._abandonRulesCheck = null;
        this.fragCurrent = this.partCurrent = null;
    }
    onManifestLoading(event, data) {
        this.lastLoadedFragLevel = -1;
        this.firstSelection = -1;
        this.lastLevelLoadSec = 0;
        this.fragCurrent = this.partCurrent = null;
        this.onLevelsUpdated();
        this.clearTimer();
    }
    onLevelsUpdated() {
        if (this.lastLoadedFragLevel > -1 && this.fragCurrent) this.lastLoadedFragLevel = this.fragCurrent.level;
        this._nextAutoLevel = -1;
        this.onMaxAutoLevelUpdated();
        this.codecTiers = null;
        this.audioTracksByGroup = null;
    }
    onMaxAutoLevelUpdated() {
        this.firstSelection = -1;
        this.nextAutoLevelKey = '';
    }
    onFragLoading(event, data) {
        const frag = data.frag;
        if (this.ignoreFragment(frag)) return;
        if (!frag.bitrateTest) {
            var _data$part;
            this.fragCurrent = frag;
            this.partCurrent = (_data$part = data.part) != null ? _data$part : null;
        }
        this.clearTimer();
        this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
    onLevelSwitching(event, data) {
        this.clearTimer();
    }
    onError(event, data) {
        if (data.fatal) return;
        switch(data.details){
            case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
            case ErrorDetails.BUFFER_APPEND_ERROR:
                // Reset last loaded level so that a new selection can be made after calling recoverMediaError
                this.lastLoadedFragLevel = -1;
                this.firstSelection = -1;
                break;
            case ErrorDetails.FRAG_LOAD_TIMEOUT:
                {
                    const frag = data.frag;
                    const { fragCurrent, partCurrent: part } = this;
                    if (frag && fragCurrent && frag.sn === fragCurrent.sn && frag.level === fragCurrent.level) {
                        const now = performance.now();
                        const stats = part ? part.stats : frag.stats;
                        const timeLoading = now - stats.loading.start;
                        const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
                        const loadedFirstByte = stats.loaded && ttfb > -1;
                        if (loadedFirstByte) {
                            const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
                            this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
                        } else this.bwEstimator.sampleTTFB(timeLoading);
                    }
                    break;
                }
        }
    }
    getTimeToLoadFrag(timeToFirstByteSec, bandwidth, fragSizeBits, isSwitch) {
        const fragLoadSec = timeToFirstByteSec + fragSizeBits / bandwidth;
        const playlistLoadSec = isSwitch ? this.lastLevelLoadSec : 0;
        return fragLoadSec + playlistLoadSec;
    }
    onLevelLoaded(event, data) {
        const config = this.hls.config;
        const { loading } = data.stats;
        const timeLoadingMs = loading.end - loading.start;
        if (isFiniteNumber(timeLoadingMs)) this.lastLevelLoadSec = timeLoadingMs / 1000;
        if (data.details.live) this.bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
        else this.bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
    }
    onFragLoaded(event, { frag, part }) {
        const stats = part ? part.stats : frag.stats;
        if (frag.type === PlaylistLevelType.MAIN) this.bwEstimator.sampleTTFB(stats.loading.first - stats.loading.start);
        if (this.ignoreFragment(frag)) return;
        // stop monitoring bw once frag loaded
        this.clearTimer();
        // reset forced auto level value so that next level will be selected
        if (frag.level === this._nextAutoLevel) this._nextAutoLevel = -1;
        this.firstSelection = -1;
        // compute level average bitrate
        if (this.hls.config.abrMaxWithRealBitrate) {
            const duration = part ? part.duration : frag.duration;
            const level = this.hls.levels[frag.level];
            const loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
            const loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
            level.loaded = {
                bytes: loadedBytes,
                duration: loadedDuration
            };
            level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
        }
        if (frag.bitrateTest) {
            const fragBufferedData = {
                stats,
                frag,
                part,
                id: frag.type
            };
            this.onFragBuffered(Events.FRAG_BUFFERED, fragBufferedData);
            frag.bitrateTest = false;
        } else // store level id after successful fragment load for playback
        this.lastLoadedFragLevel = frag.level;
    }
    onFragBuffered(event, data) {
        const { frag, part } = data;
        const stats = part != null && part.stats.loaded ? part.stats : frag.stats;
        if (stats.aborted) return;
        if (this.ignoreFragment(frag)) return;
        // Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
        // rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
        // is used. If we used buffering in that case, our BW estimate sample will be very large.
        const processingMs = stats.parsing.end - stats.loading.start - Math.min(stats.loading.first - stats.loading.start, this.bwEstimator.getEstimateTTFB());
        this.bwEstimator.sample(processingMs, stats.loaded);
        stats.bwEstimate = this.getBwEstimate();
        if (frag.bitrateTest) this.bitrateTestDelay = processingMs / 1000;
        else this.bitrateTestDelay = 0;
    }
    ignoreFragment(frag) {
        // Only count non-alt-audio frags which were actually buffered in our BW calculations
        return frag.type !== PlaylistLevelType.MAIN || frag.sn === 'initSegment';
    }
    clearTimer() {
        if (this.timer > -1) {
            self.clearInterval(this.timer);
            this.timer = -1;
        }
    }
    get firstAutoLevel() {
        const { maxAutoLevel, minAutoLevel } = this.hls;
        const bwEstimate = this.getBwEstimate();
        const maxStartDelay = this.hls.config.maxStarvationDelay;
        const abrAutoLevel = this.findBestLevel(bwEstimate, minAutoLevel, maxAutoLevel, 0, maxStartDelay, 1, 1);
        if (abrAutoLevel > -1) return abrAutoLevel;
        const firstLevel = this.hls.firstLevel;
        const clamped = Math.min(Math.max(firstLevel, minAutoLevel), maxAutoLevel);
        logger.warn(`[abr] Could not find best starting auto level. Defaulting to first in playlist ${firstLevel} clamped to ${clamped}`);
        return clamped;
    }
    get forcedAutoLevel() {
        if (this.nextAutoLevelKey) return -1;
        return this._nextAutoLevel;
    }
    // return next auto level
    get nextAutoLevel() {
        const forcedAutoLevel = this.forcedAutoLevel;
        const bwEstimator = this.bwEstimator;
        const useEstimate = bwEstimator.canEstimate();
        const loadedFirstFrag = this.lastLoadedFragLevel > -1;
        // in case next auto level has been forced, and bw not available or not reliable, return forced value
        if (forcedAutoLevel !== -1 && (!useEstimate || !loadedFirstFrag || this.nextAutoLevelKey === this.getAutoLevelKey())) return forcedAutoLevel;
        // compute next level using ABR logic
        const nextABRAutoLevel = useEstimate && loadedFirstFrag ? this.getNextABRAutoLevel() : this.firstAutoLevel;
        // use forced auto level while it hasn't errored more than ABR selection
        if (forcedAutoLevel !== -1) {
            const levels = this.hls.levels;
            if (levels.length > Math.max(forcedAutoLevel, nextABRAutoLevel) && levels[forcedAutoLevel].loadError <= levels[nextABRAutoLevel].loadError) return forcedAutoLevel;
        }
        // save result until state has changed
        this._nextAutoLevel = nextABRAutoLevel;
        this.nextAutoLevelKey = this.getAutoLevelKey();
        return nextABRAutoLevel;
    }
    getAutoLevelKey() {
        return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
    }
    getNextABRAutoLevel() {
        const { fragCurrent, partCurrent, hls } = this;
        const { maxAutoLevel, config, minAutoLevel } = hls;
        const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
        const avgbw = this.getBwEstimate();
        // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
        const bufferStarvationDelay = this.getStarvationDelay();
        let bwFactor = config.abrBandWidthFactor;
        let bwUpFactor = config.abrBandWidthUpFactor;
        // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
        if (bufferStarvationDelay) {
            const _bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, 0, bwFactor, bwUpFactor);
            if (_bestLevel >= 0) return _bestLevel;
        }
        // not possible to get rid of rebuffering... try to find level that will guarantee less than maxStarvationDelay of rebuffering
        let maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
        if (!bufferStarvationDelay) {
            // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
            const bitrateTestDelay = this.bitrateTestDelay;
            if (bitrateTestDelay) {
                // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
                // max video loading delay used in  automatic start level selection :
                // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
                // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
                // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
                const maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
                maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
                logger.info(`[abr] bitrate test took ${Math.round(1000 * bitrateTestDelay)}ms, set first fragment max fetchDuration to ${Math.round(1000 * maxStarvationDelay)} ms`);
                // don't use conservative factor on bitrate test
                bwFactor = bwUpFactor = 1;
            }
        }
        const bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor);
        logger.info(`[abr] ${bufferStarvationDelay ? 'rebuffering expected' : 'buffer is empty'}, optimal quality level ${bestLevel}`);
        if (bestLevel > -1) return bestLevel;
        // If no matching level found, see if min auto level would be a better option
        const minLevel = hls.levels[minAutoLevel];
        const autoLevel = hls.levels[hls.loadLevel];
        if ((minLevel == null ? void 0 : minLevel.bitrate) < (autoLevel == null ? void 0 : autoLevel.bitrate)) return minAutoLevel;
        // or if bitrate is not lower, continue to use loadLevel
        return hls.loadLevel;
    }
    getStarvationDelay() {
        const hls = this.hls;
        const media = hls.media;
        if (!media) return Infinity;
        // playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
        // if we're playing back at the normal rate.
        const playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1.0;
        const bufferInfo = hls.mainForwardBufferInfo;
        return (bufferInfo ? bufferInfo.len : 0) / playbackRate;
    }
    getBwEstimate() {
        return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
    }
    findBestLevel(currentBw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor) {
        var _level$details;
        const maxFetchDuration = bufferStarvationDelay + maxStarvationDelay;
        const lastLoadedFragLevel = this.lastLoadedFragLevel;
        const selectionBaseLevel = lastLoadedFragLevel === -1 ? this.hls.firstLevel : lastLoadedFragLevel;
        const { fragCurrent, partCurrent } = this;
        const { levels, allAudioTracks, loadLevel, config } = this.hls;
        if (levels.length === 1) return 0;
        const level = levels[selectionBaseLevel];
        const live = !!(level != null && (_level$details = level.details) != null && _level$details.live);
        const firstSelection = loadLevel === -1 || lastLoadedFragLevel === -1;
        let currentCodecSet;
        let currentVideoRange = 'SDR';
        let currentFrameRate = (level == null ? void 0 : level.frameRate) || 0;
        const { audioPreference, videoPreference } = config;
        const audioTracksByGroup = this.audioTracksByGroup || (this.audioTracksByGroup = getAudioTracksByGroup(allAudioTracks));
        if (firstSelection) {
            if (this.firstSelection !== -1) return this.firstSelection;
            const codecTiers = this.codecTiers || (this.codecTiers = getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel));
            const startTier = getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference);
            const { codecSet, videoRanges, minFramerate, minBitrate, preferHDR } = startTier;
            currentCodecSet = codecSet;
            currentVideoRange = preferHDR ? videoRanges[videoRanges.length - 1] : videoRanges[0];
            currentFrameRate = minFramerate;
            currentBw = Math.max(currentBw, minBitrate);
            logger.log(`[abr] picked start tier ${JSON.stringify(startTier)}`);
        } else {
            currentCodecSet = level == null ? void 0 : level.codecSet;
            currentVideoRange = level == null ? void 0 : level.videoRange;
        }
        const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
        const ttfbEstimateSec = this.bwEstimator.getEstimateTTFB() / 1000;
        const levelsSkipped = [];
        for(let i = maxAutoLevel; i >= minAutoLevel; i--){
            var _levelInfo$supportedR;
            const levelInfo = levels[i];
            const upSwitch = i > selectionBaseLevel;
            if (!levelInfo) continue;
            if (config.useMediaCapabilities && !levelInfo.supportedResult && !levelInfo.supportedPromise) {
                const mediaCapabilities = navigator.mediaCapabilities;
                if (typeof (mediaCapabilities == null ? void 0 : mediaCapabilities.decodingInfo) === 'function' && requiresMediaCapabilitiesDecodingInfo(levelInfo, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference)) {
                    levelInfo.supportedPromise = getMediaDecodingInfoPromise(levelInfo, audioTracksByGroup, mediaCapabilities);
                    levelInfo.supportedPromise.then((decodingInfo)=>{
                        if (!this.hls) return;
                        levelInfo.supportedResult = decodingInfo;
                        const levels = this.hls.levels;
                        const index = levels.indexOf(levelInfo);
                        if (decodingInfo.error) logger.warn(`[abr] MediaCapabilities decodingInfo error: "${decodingInfo.error}" for level ${index} ${JSON.stringify(decodingInfo)}`);
                        else if (!decodingInfo.supported) {
                            logger.warn(`[abr] Unsupported MediaCapabilities decodingInfo result for level ${index} ${JSON.stringify(decodingInfo)}`);
                            if (index > -1 && levels.length > 1) {
                                logger.log(`[abr] Removing unsupported level ${index}`);
                                this.hls.removeLevel(index);
                            }
                        }
                    });
                } else levelInfo.supportedResult = SUPPORTED_INFO_DEFAULT;
            }
            // skip candidates which change codec-family or video-range,
            // and which decrease or increase frame-rate for up and down-switch respectfully
            if (currentCodecSet && levelInfo.codecSet !== currentCodecSet || currentVideoRange && levelInfo.videoRange !== currentVideoRange || upSwitch && currentFrameRate > levelInfo.frameRate || !upSwitch && currentFrameRate > 0 && currentFrameRate < levelInfo.frameRate || levelInfo.supportedResult && !((_levelInfo$supportedR = levelInfo.supportedResult.decodingInfoResults) != null && _levelInfo$supportedR[0].smooth)) {
                levelsSkipped.push(i);
                continue;
            }
            const levelDetails = levelInfo.details;
            const avgDuration = (partCurrent ? levelDetails == null ? void 0 : levelDetails.partTarget : levelDetails == null ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
            let adjustedbw;
            // follow algorithm captured from stagefright :
            // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
            // Pick the highest bandwidth stream below or equal to estimated bandwidth.
            // consider only 80% of the available bandwidth, but if we are switching up,
            // be even more conservative (70%) to avoid overestimating and immediately
            // switching back.
            if (!upSwitch) adjustedbw = bwFactor * currentBw;
            else adjustedbw = bwUpFactor * currentBw;
            // Use average bitrate when starvation delay (buffer length) is gt or eq two segment durations and rebuffering is not expected (maxStarvationDelay > 0)
            const bitrate = currentFragDuration && bufferStarvationDelay >= currentFragDuration * 2 && maxStarvationDelay === 0 ? levels[i].averageBitrate : levels[i].maxBitrate;
            const fetchDuration = this.getTimeToLoadFrag(ttfbEstimateSec, adjustedbw, bitrate * avgDuration, levelDetails === undefined);
            const canSwitchWithinTolerance = // if adjusted bw is greater than level bitrate AND
            adjustedbw >= bitrate && // no level change, or new level has no error history
            (i === lastLoadedFragLevel || levelInfo.loadError === 0 && levelInfo.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
            // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
            // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
            (fetchDuration <= ttfbEstimateSec || !isFiniteNumber(fetchDuration) || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration);
            if (canSwitchWithinTolerance) {
                const forcedAutoLevel = this.forcedAutoLevel;
                if (i !== loadLevel && (forcedAutoLevel === -1 || forcedAutoLevel !== loadLevel)) {
                    if (levelsSkipped.length) logger.trace(`[abr] Skipped level(s) ${levelsSkipped.join(',')} of ${maxAutoLevel} max with CODECS and VIDEO-RANGE:"${levels[levelsSkipped[0]].codecs}" ${levels[levelsSkipped[0]].videoRange}; not compatible with "${level.codecs}" ${currentVideoRange}`);
                    logger.info(`[abr] switch candidate:${selectionBaseLevel}->${i} adjustedbw(${Math.round(adjustedbw)})-bitrate=${Math.round(adjustedbw - bitrate)} ttfb:${ttfbEstimateSec.toFixed(1)} avgDuration:${avgDuration.toFixed(1)} maxFetchDuration:${maxFetchDuration.toFixed(1)} fetchDuration:${fetchDuration.toFixed(1)} firstSelection:${firstSelection} codecSet:${currentCodecSet} videoRange:${currentVideoRange} hls.loadLevel:${loadLevel}`);
                }
                if (firstSelection) this.firstSelection = i;
                // as we are looping from highest to lowest, this will return the best achievable quality level
                return i;
            }
        }
        // not enough time budget even with quality level 0 ... rebuffering might happen
        return -1;
    }
    set nextAutoLevel(nextLevel) {
        const { maxAutoLevel, minAutoLevel } = this.hls;
        const value = Math.min(Math.max(nextLevel, minAutoLevel), maxAutoLevel);
        if (this._nextAutoLevel !== value) {
            this.nextAutoLevelKey = '';
            this._nextAutoLevel = value;
        }
    }
}
/**
 * @ignore
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */ class TaskLoop {
    constructor(){
        this._boundTick = void 0;
        this._tickTimer = null;
        this._tickInterval = null;
        this._tickCallCount = 0;
        this._boundTick = this.tick.bind(this);
    }
    destroy() {
        this.onHandlerDestroying();
        this.onHandlerDestroyed();
    }
    onHandlerDestroying() {
        // clear all timers before unregistering from event bus
        this.clearNextTick();
        this.clearInterval();
    }
    onHandlerDestroyed() {}
    hasInterval() {
        return !!this._tickInterval;
    }
    hasNextTick() {
        return !!this._tickTimer;
    }
    /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */ setInterval(millis) {
        if (!this._tickInterval) {
            this._tickCallCount = 0;
            this._tickInterval = self.setInterval(this._boundTick, millis);
            return true;
        }
        return false;
    }
    /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */ clearInterval() {
        if (this._tickInterval) {
            self.clearInterval(this._tickInterval);
            this._tickInterval = null;
            return true;
        }
        return false;
    }
    /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */ clearNextTick() {
        if (this._tickTimer) {
            self.clearTimeout(this._tickTimer);
            this._tickTimer = null;
            return true;
        }
        return false;
    }
    /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */ tick() {
        this._tickCallCount++;
        if (this._tickCallCount === 1) {
            this.doTick();
            // re-entrant call to tick from previous doTick call stack
            // -> schedule a call on the next main loop iteration to process this task processing request
            if (this._tickCallCount > 1) // make sure only one timer exists at any time at max
            this.tickImmediate();
            this._tickCallCount = 0;
        }
    }
    tickImmediate() {
        this.clearNextTick();
        this._tickTimer = self.setTimeout(this._boundTick, 0);
    }
    /**
   * For subclass to implement task logic
   * @abstract
   */ doTick() {}
}
var FragmentState = {
    NOT_LOADED: "NOT_LOADED",
    APPENDING: "APPENDING",
    PARTIAL: "PARTIAL",
    OK: "OK"
};
class FragmentTracker {
    constructor(hls){
        this.activePartLists = Object.create(null);
        this.endListFragments = Object.create(null);
        this.fragments = Object.create(null);
        this.timeRanges = Object.create(null);
        this.bufferPadding = 0.2;
        this.hls = void 0;
        this.hasGaps = false;
        this.hls = hls;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls } = this;
        hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
        hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    }
    _unregisterListeners() {
        const { hls } = this;
        hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
        hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    }
    destroy() {
        this._unregisterListeners();
        // @ts-ignore
        this.fragments = // @ts-ignore
        this.activePartLists = // @ts-ignore
        this.endListFragments = this.timeRanges = null;
    }
    /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */ getAppendedFrag(position, levelType) {
        const activeParts = this.activePartLists[levelType];
        if (activeParts) for(let i = activeParts.length; i--;){
            const activePart = activeParts[i];
            if (!activePart) break;
            const appendedPTS = activePart.end;
            if (activePart.start <= position && appendedPTS !== null && position <= appendedPTS) return activePart;
        }
        return this.getBufferedFrag(position, levelType);
    }
    /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */ getBufferedFrag(position, levelType) {
        const { fragments } = this;
        const keys = Object.keys(fragments);
        for(let i = keys.length; i--;){
            const fragmentEntity = fragments[keys[i]];
            if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === levelType && fragmentEntity.buffered) {
                const frag = fragmentEntity.body;
                if (frag.start <= position && position <= frag.end) return frag;
            }
        }
        return null;
    }
    /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */ detectEvictedFragments(elementaryStream, timeRange, playlistType, appendedPart) {
        if (this.timeRanges) this.timeRanges[elementaryStream] = timeRange;
        // Check if any flagged fragments have been unloaded
        // excluding anything newer than appendedPartSn
        const appendedPartSn = (appendedPart == null ? void 0 : appendedPart.fragment.sn) || -1;
        Object.keys(this.fragments).forEach((key)=>{
            const fragmentEntity = this.fragments[key];
            if (!fragmentEntity) return;
            if (appendedPartSn >= fragmentEntity.body.sn) return;
            if (!fragmentEntity.buffered && !fragmentEntity.loaded) {
                if (fragmentEntity.body.type === playlistType) this.removeFragment(fragmentEntity.body);
                return;
            }
            const esData = fragmentEntity.range[elementaryStream];
            if (!esData) return;
            esData.time.some((time)=>{
                const isNotBuffered = !this.isTimeBuffered(time.startPTS, time.endPTS, timeRange);
                if (isNotBuffered) // Unregister partial fragment as it needs to load again to be reused
                this.removeFragment(fragmentEntity.body);
                return isNotBuffered;
            });
        });
    }
    /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */ detectPartialFragments(data) {
        const timeRanges = this.timeRanges;
        const { frag, part } = data;
        if (!timeRanges || frag.sn === 'initSegment') return;
        const fragKey = getFragmentKey(frag);
        const fragmentEntity = this.fragments[fragKey];
        if (!fragmentEntity || fragmentEntity.buffered && frag.gap) return;
        const isFragHint = !frag.relurl;
        Object.keys(timeRanges).forEach((elementaryStream)=>{
            const streamInfo = frag.elementaryStreams[elementaryStream];
            if (!streamInfo) return;
            const timeRange = timeRanges[elementaryStream];
            const partial = isFragHint || streamInfo.partial === true;
            fragmentEntity.range[elementaryStream] = this.getBufferedTimes(frag, part, partial, timeRange);
        });
        fragmentEntity.loaded = null;
        if (Object.keys(fragmentEntity.range).length) {
            fragmentEntity.buffered = true;
            const endList = fragmentEntity.body.endList = frag.endList || fragmentEntity.body.endList;
            if (endList) this.endListFragments[fragmentEntity.body.type] = fragmentEntity;
            if (!isPartial(fragmentEntity)) // Remove older fragment parts from lookup after frag is tracked as buffered
            this.removeParts(frag.sn - 1, frag.type);
        } else // remove fragment if nothing was appended
        this.removeFragment(fragmentEntity.body);
    }
    removeParts(snToKeep, levelType) {
        const activeParts = this.activePartLists[levelType];
        if (!activeParts) return;
        this.activePartLists[levelType] = activeParts.filter((part)=>part.fragment.sn >= snToKeep);
    }
    fragBuffered(frag, force) {
        const fragKey = getFragmentKey(frag);
        let fragmentEntity = this.fragments[fragKey];
        if (!fragmentEntity && force) {
            fragmentEntity = this.fragments[fragKey] = {
                body: frag,
                appendedPTS: null,
                loaded: null,
                buffered: false,
                range: Object.create(null)
            };
            if (frag.gap) this.hasGaps = true;
        }
        if (fragmentEntity) {
            fragmentEntity.loaded = null;
            fragmentEntity.buffered = true;
        }
    }
    getBufferedTimes(fragment, part, partial, timeRange) {
        const buffered = {
            time: [],
            partial
        };
        const startPTS = fragment.start;
        const endPTS = fragment.end;
        const minEndPTS = fragment.minEndPTS || endPTS;
        const maxStartPTS = fragment.maxStartPTS || startPTS;
        for(let i = 0; i < timeRange.length; i++){
            const startTime = timeRange.start(i) - this.bufferPadding;
            const endTime = timeRange.end(i) + this.bufferPadding;
            if (maxStartPTS >= startTime && minEndPTS <= endTime) {
                // Fragment is entirely contained in buffer
                // No need to check the other timeRange times since it's completely playable
                buffered.time.push({
                    startPTS: Math.max(startPTS, timeRange.start(i)),
                    endPTS: Math.min(endPTS, timeRange.end(i))
                });
                break;
            } else if (startPTS < endTime && endPTS > startTime) {
                const start = Math.max(startPTS, timeRange.start(i));
                const end = Math.min(endPTS, timeRange.end(i));
                if (end > start) {
                    buffered.partial = true;
                    // Check for intersection with buffer
                    // Get playable sections of the fragment
                    buffered.time.push({
                        startPTS: start,
                        endPTS: end
                    });
                }
            } else if (endPTS <= startTime) break;
        }
        return buffered;
    }
    /**
   * Gets the partial fragment for a certain time
   */ getPartialFragment(time) {
        let bestFragment = null;
        let timePadding;
        let startTime;
        let endTime;
        let bestOverlap = 0;
        const { bufferPadding, fragments } = this;
        Object.keys(fragments).forEach((key)=>{
            const fragmentEntity = fragments[key];
            if (!fragmentEntity) return;
            if (isPartial(fragmentEntity)) {
                startTime = fragmentEntity.body.start - bufferPadding;
                endTime = fragmentEntity.body.end + bufferPadding;
                if (time >= startTime && time <= endTime) {
                    // Use the fragment that has the most padding from start and end time
                    timePadding = Math.min(time - startTime, endTime - time);
                    if (bestOverlap <= timePadding) {
                        bestFragment = fragmentEntity.body;
                        bestOverlap = timePadding;
                    }
                }
            }
        });
        return bestFragment;
    }
    isEndListAppended(type) {
        const lastFragmentEntity = this.endListFragments[type];
        return lastFragmentEntity !== undefined && (lastFragmentEntity.buffered || isPartial(lastFragmentEntity));
    }
    getState(fragment) {
        const fragKey = getFragmentKey(fragment);
        const fragmentEntity = this.fragments[fragKey];
        if (fragmentEntity) {
            if (!fragmentEntity.buffered) return FragmentState.APPENDING;
            else if (isPartial(fragmentEntity)) return FragmentState.PARTIAL;
            else return FragmentState.OK;
        }
        return FragmentState.NOT_LOADED;
    }
    isTimeBuffered(startPTS, endPTS, timeRange) {
        let startTime;
        let endTime;
        for(let i = 0; i < timeRange.length; i++){
            startTime = timeRange.start(i) - this.bufferPadding;
            endTime = timeRange.end(i) + this.bufferPadding;
            if (startPTS >= startTime && endPTS <= endTime) return true;
            if (endPTS <= startTime) // No need to check the rest of the timeRange as it is in order
            return false;
        }
        return false;
    }
    onFragLoaded(event, data) {
        const { frag, part } = data;
        // don't track initsegment (for which sn is not a number)
        // don't track frags used for bitrateTest, they're irrelevant.
        if (frag.sn === 'initSegment' || frag.bitrateTest) return;
        // Fragment entity `loaded` FragLoadedData is null when loading parts
        const loaded = part ? null : data;
        const fragKey = getFragmentKey(frag);
        this.fragments[fragKey] = {
            body: frag,
            appendedPTS: null,
            loaded,
            buffered: false,
            range: Object.create(null)
        };
    }
    onBufferAppended(event, data) {
        const { frag, part, timeRanges } = data;
        if (frag.sn === 'initSegment') return;
        const playlistType = frag.type;
        if (part) {
            let activeParts = this.activePartLists[playlistType];
            if (!activeParts) this.activePartLists[playlistType] = activeParts = [];
            activeParts.push(part);
        }
        // Store the latest timeRanges loaded in the buffer
        this.timeRanges = timeRanges;
        Object.keys(timeRanges).forEach((elementaryStream)=>{
            const timeRange = timeRanges[elementaryStream];
            this.detectEvictedFragments(elementaryStream, timeRange, playlistType, part);
        });
    }
    onFragBuffered(event, data) {
        this.detectPartialFragments(data);
    }
    hasFragment(fragment) {
        const fragKey = getFragmentKey(fragment);
        return !!this.fragments[fragKey];
    }
    hasParts(type) {
        var _this$activePartLists;
        return !!((_this$activePartLists = this.activePartLists[type]) != null && _this$activePartLists.length);
    }
    removeFragmentsInRange(start, end, playlistType, withGapOnly, unbufferedOnly) {
        if (withGapOnly && !this.hasGaps) return;
        Object.keys(this.fragments).forEach((key)=>{
            const fragmentEntity = this.fragments[key];
            if (!fragmentEntity) return;
            const frag = fragmentEntity.body;
            if (frag.type !== playlistType || withGapOnly && !frag.gap) return;
            if (frag.start < end && frag.end > start && (fragmentEntity.buffered || unbufferedOnly)) this.removeFragment(frag);
        });
    }
    removeFragment(fragment) {
        const fragKey = getFragmentKey(fragment);
        fragment.stats.loaded = 0;
        fragment.clearElementaryStreamInfo();
        const activeParts = this.activePartLists[fragment.type];
        if (activeParts) {
            const snToRemove = fragment.sn;
            this.activePartLists[fragment.type] = activeParts.filter((part)=>part.fragment.sn !== snToRemove);
        }
        delete this.fragments[fragKey];
        if (fragment.endList) delete this.endListFragments[fragment.type];
    }
    removeAllFragments() {
        this.fragments = Object.create(null);
        this.endListFragments = Object.create(null);
        this.activePartLists = Object.create(null);
        this.hasGaps = false;
    }
}
function isPartial(fragmentEntity) {
    var _fragmentEntity$range, _fragmentEntity$range2, _fragmentEntity$range3;
    return fragmentEntity.buffered && (fragmentEntity.body.gap || ((_fragmentEntity$range = fragmentEntity.range.video) == null ? void 0 : _fragmentEntity$range.partial) || ((_fragmentEntity$range2 = fragmentEntity.range.audio) == null ? void 0 : _fragmentEntity$range2.partial) || ((_fragmentEntity$range3 = fragmentEntity.range.audiovideo) == null ? void 0 : _fragmentEntity$range3.partial));
}
function getFragmentKey(fragment) {
    return `${fragment.type}_${fragment.level}_${fragment.sn}`;
}
/**
 * Provides methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
 */ const noopBuffered = {
    length: 0,
    start: ()=>0,
    end: ()=>0
};
class BufferHelper {
    /**
   * Return true if `media`'s buffered include `position`
   */ static isBuffered(media, position) {
        try {
            if (media) {
                const buffered = BufferHelper.getBuffered(media);
                for(let i = 0; i < buffered.length; i++){
                    if (position >= buffered.start(i) && position <= buffered.end(i)) return true;
                }
            }
        } catch (error) {
        // this is to catch
        // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
        // This SourceBuffer has been removed from the parent media source
        }
        return false;
    }
    static bufferInfo(media, pos, maxHoleDuration) {
        try {
            if (media) {
                const vbuffered = BufferHelper.getBuffered(media);
                const buffered = [];
                let i;
                for(i = 0; i < vbuffered.length; i++)buffered.push({
                    start: vbuffered.start(i),
                    end: vbuffered.end(i)
                });
                return this.bufferedInfo(buffered, pos, maxHoleDuration);
            }
        } catch (error) {
        // this is to catch
        // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
        // This SourceBuffer has been removed from the parent media source
        }
        return {
            len: 0,
            start: pos,
            end: pos,
            nextStart: undefined
        };
    }
    static bufferedInfo(buffered, pos, maxHoleDuration) {
        pos = Math.max(0, pos);
        // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
        buffered.sort(function(a, b) {
            const diff = a.start - b.start;
            if (diff) return diff;
            else return b.end - a.end;
        });
        let buffered2 = [];
        if (maxHoleDuration) // there might be some small holes between buffer time range
        // consider that holes smaller than maxHoleDuration are irrelevant and build another
        // buffer time range representations that discards those holes
        for(let i = 0; i < buffered.length; i++){
            const buf2len = buffered2.length;
            if (buf2len) {
                const buf2end = buffered2[buf2len - 1].end;
                // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
                if (buffered[i].start - buf2end < maxHoleDuration) // merge overlapping time ranges
                // update lastRange.end only if smaller than item.end
                // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
                // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
                {
                    if (buffered[i].end > buf2end) buffered2[buf2len - 1].end = buffered[i].end;
                } else // big hole
                buffered2.push(buffered[i]);
            } else // first value
            buffered2.push(buffered[i]);
        }
        else buffered2 = buffered;
        let bufferLen = 0;
        // bufferStartNext can possibly be undefined based on the conditional logic below
        let bufferStartNext;
        // bufferStart and bufferEnd are buffer boundaries around current video position
        let bufferStart = pos;
        let bufferEnd = pos;
        for(let i = 0; i < buffered2.length; i++){
            const start = buffered2[i].start;
            const end = buffered2[i].end;
            // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
            if (pos + maxHoleDuration >= start && pos < end) {
                // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
                bufferStart = start;
                bufferEnd = end;
                bufferLen = bufferEnd - pos;
            } else if (pos + maxHoleDuration < start) {
                bufferStartNext = start;
                break;
            }
        }
        return {
            len: bufferLen,
            start: bufferStart || 0,
            end: bufferEnd || 0,
            nextStart: bufferStartNext
        };
    }
    /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */ static getBuffered(media) {
        try {
            return media.buffered;
        } catch (e) {
            logger.log('failed to get media.buffered', e);
            return noopBuffered;
        }
    }
}
class ChunkMetadata {
    constructor(level, sn, id, size = 0, part = -1, partial = false){
        this.level = void 0;
        this.sn = void 0;
        this.part = void 0;
        this.id = void 0;
        this.size = void 0;
        this.partial = void 0;
        this.transmuxing = getNewPerformanceTiming();
        this.buffering = {
            audio: getNewPerformanceTiming(),
            video: getNewPerformanceTiming(),
            audiovideo: getNewPerformanceTiming()
        };
        this.level = level;
        this.sn = sn;
        this.id = id;
        this.size = size;
        this.part = part;
        this.partial = partial;
    }
}
function getNewPerformanceTiming() {
    return {
        start: 0,
        executeStart: 0,
        executeEnd: 0,
        end: 0
    };
}
function findFirstFragWithCC(fragments, cc) {
    for(let i = 0, len = fragments.length; i < len; i++){
        var _fragments$i;
        if (((_fragments$i = fragments[i]) == null ? void 0 : _fragments$i.cc) === cc) return fragments[i];
    }
    return null;
}
function shouldAlignOnDiscontinuities(lastFrag, switchDetails, details) {
    if (switchDetails) {
        if (details.endCC > details.startCC || lastFrag && lastFrag.cc < details.startCC) return true;
    }
    return false;
}
// Find the first frag in the previous level which matches the CC of the first frag of the new level
function findDiscontinuousReferenceFrag(prevDetails, curDetails) {
    const prevFrags = prevDetails.fragments;
    const curFrags = curDetails.fragments;
    if (!curFrags.length || !prevFrags.length) {
        logger.log('No fragments to align');
        return;
    }
    const prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);
    if (!prevStartFrag || prevStartFrag && !prevStartFrag.startPTS) {
        logger.log('No frag in previous level to align on');
        return;
    }
    return prevStartFrag;
}
function adjustFragmentStart(frag, sliding) {
    if (frag) {
        const start = frag.start + sliding;
        frag.start = frag.startPTS = start;
        frag.endPTS = start + frag.duration;
    }
}
function adjustSlidingStart(sliding, details) {
    // Update segments
    const fragments = details.fragments;
    for(let i = 0, len = fragments.length; i < len; i++)adjustFragmentStart(fragments[i], sliding);
    // Update LL-HLS parts at the end of the playlist
    if (details.fragmentHint) adjustFragmentStart(details.fragmentHint, sliding);
    details.alignedSliding = true;
}
/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastFrag
 * @param lastLevel
 * @param details
 */ function alignStream(lastFrag, switchDetails, details) {
    if (!switchDetails) return;
    alignDiscontinuities(lastFrag, details, switchDetails);
    if (!details.alignedSliding && switchDetails) // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
    // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
    // discontinuity sequence.
    alignMediaPlaylistByPDT(details, switchDetails);
    if (!details.alignedSliding && switchDetails && !details.skippedSegments) // Try to align on sn so that we pick a better start fragment.
    // Do not perform this on playlists with delta updates as this is only to align levels on switch
    // and adjustSliding only adjusts fragments after skippedSegments.
    adjustSliding(switchDetails, details);
}
/**
 * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
 * discontinuity sequence.
 * @param lastFrag - The last Fragment which shares the same discontinuity sequence
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */ function alignDiscontinuities(lastFrag, details, switchDetails) {
    if (shouldAlignOnDiscontinuities(lastFrag, switchDetails, details)) {
        const referenceFrag = findDiscontinuousReferenceFrag(switchDetails, details);
        if (referenceFrag && isFiniteNumber(referenceFrag.start)) {
            logger.log(`Adjusting PTS using last level due to CC increase within current level ${details.url}`);
            adjustSlidingStart(referenceFrag.start, details);
        }
    }
}
/**
 * Ensures appropriate time-alignment between renditions based on PDT.
 * This function assumes the timelines represented in `refDetails` are accurate, including the PDTs
 * for the last discontinuity sequence number shared by both playlists when present,
 * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
 * times/timelines of `details` accordingly.
 * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
 * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
 * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
 * be consistent across playlists, per the HLS spec.
 * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
 * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
 */ function alignMediaPlaylistByPDT(details, refDetails) {
    if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) return;
    const fragments = details.fragments;
    const refFragments = refDetails.fragments;
    if (!fragments.length || !refFragments.length) return;
    // Calculate a delta to apply to all fragments according to the delta in PDT times and start times
    // of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
    // If a fragment of the same discontinuity was not found use the middle fragment of both.
    let refFrag;
    let frag;
    const targetCC = Math.min(refDetails.endCC, details.endCC);
    if (refDetails.startCC < targetCC && details.startCC < targetCC) {
        refFrag = findFirstFragWithCC(refFragments, targetCC);
        frag = findFirstFragWithCC(fragments, targetCC);
    }
    if (!refFrag || !frag) {
        refFrag = refFragments[Math.floor(refFragments.length / 2)];
        frag = findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.floor(fragments.length / 2)];
    }
    const refPDT = refFrag.programDateTime;
    const targetPDT = frag.programDateTime;
    if (!refPDT || !targetPDT) return;
    const delta = (targetPDT - refPDT) / 1000 - (frag.start - refFrag.start);
    adjustSlidingStart(delta, details);
}
const MIN_CHUNK_SIZE = Math.pow(2, 17); // 128kb
class FragmentLoader {
    constructor(config){
        this.config = void 0;
        this.loader = null;
        this.partLoadTimeout = -1;
        this.config = config;
    }
    destroy() {
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
    }
    abort() {
        if (this.loader) // Abort the loader for current fragment. Only one may load at any given time
        this.loader.abort();
    }
    load(frag, onProgress) {
        const url = frag.url;
        if (!url) return Promise.reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag,
            error: new Error(`Fragment does not have a ${url ? 'part list' : 'url'}`),
            networkDetails: null
        }));
        this.abort();
        const config = this.config;
        const FragmentILoader = config.fLoader;
        const DefaultILoader = config.loader;
        return new Promise((resolve, reject)=>{
            if (this.loader) this.loader.destroy();
            if (frag.gap) {
                if (frag.tagList.some((tags)=>tags[0] === 'GAP')) {
                    reject(createGapLoadError(frag));
                    return;
                } else // Reset temporary treatment as GAP tag
                frag.gap = false;
            }
            const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
            const loaderContext = createLoaderContext(frag);
            const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
            const loaderConfig = {
                loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0,
                highWaterMark: frag.sn === 'initSegment' ? Infinity : MIN_CHUNK_SIZE
            };
            // Assign frag stats to the loader's stats reference
            frag.stats = loader.stats;
            loader.load(loaderContext, loaderConfig, {
                onSuccess: (response, stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    let payload = response.data;
                    if (context.resetIV && frag.decryptdata) {
                        frag.decryptdata.iv = new Uint8Array(payload.slice(0, 16));
                        payload = payload.slice(16);
                    }
                    resolve({
                        frag,
                        part: null,
                        payload,
                        networkDetails
                    });
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(frag, loader);
                    reject(new LoadError({
                        type: ErrorTypes.NETWORK_ERROR,
                        details: ErrorDetails.FRAG_LOAD_ERROR,
                        fatal: false,
                        frag,
                        response: _objectSpread2({
                            url,
                            data: undefined
                        }, response),
                        error: new Error(`HTTP Error ${response.code} ${response.text}`),
                        networkDetails,
                        stats
                    }));
                },
                onAbort: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new LoadError({
                        type: ErrorTypes.NETWORK_ERROR,
                        details: ErrorDetails.INTERNAL_ABORTED,
                        fatal: false,
                        frag,
                        error: new Error('Aborted'),
                        networkDetails,
                        stats
                    }));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new LoadError({
                        type: ErrorTypes.NETWORK_ERROR,
                        details: ErrorDetails.FRAG_LOAD_TIMEOUT,
                        fatal: false,
                        frag,
                        error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
                        networkDetails,
                        stats
                    }));
                },
                onProgress: (stats, context, data, networkDetails)=>{
                    if (onProgress) onProgress({
                        frag,
                        part: null,
                        payload: data,
                        networkDetails
                    });
                }
            });
        });
    }
    loadPart(frag, part, onProgress) {
        this.abort();
        const config = this.config;
        const FragmentILoader = config.fLoader;
        const DefaultILoader = config.loader;
        return new Promise((resolve, reject)=>{
            if (this.loader) this.loader.destroy();
            if (frag.gap || part.gap) {
                reject(createGapLoadError(frag, part));
                return;
            }
            const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
            const loaderContext = createLoaderContext(frag, part);
            // Should we define another load policy for parts?
            const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
            const loaderConfig = {
                loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0,
                highWaterMark: MIN_CHUNK_SIZE
            };
            // Assign part stats to the loader's stats reference
            part.stats = loader.stats;
            loader.load(loaderContext, loaderConfig, {
                onSuccess: (response, stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    this.updateStatsFromPart(frag, part);
                    const partLoadedData = {
                        frag,
                        part,
                        payload: response.data,
                        networkDetails
                    };
                    onProgress(partLoadedData);
                    resolve(partLoadedData);
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(frag, loader);
                    reject(new LoadError({
                        type: ErrorTypes.NETWORK_ERROR,
                        details: ErrorDetails.FRAG_LOAD_ERROR,
                        fatal: false,
                        frag,
                        part,
                        response: _objectSpread2({
                            url: loaderContext.url,
                            data: undefined
                        }, response),
                        error: new Error(`HTTP Error ${response.code} ${response.text}`),
                        networkDetails,
                        stats
                    }));
                },
                onAbort: (stats, context, networkDetails)=>{
                    frag.stats.aborted = part.stats.aborted;
                    this.resetLoader(frag, loader);
                    reject(new LoadError({
                        type: ErrorTypes.NETWORK_ERROR,
                        details: ErrorDetails.INTERNAL_ABORTED,
                        fatal: false,
                        frag,
                        part,
                        error: new Error('Aborted'),
                        networkDetails,
                        stats
                    }));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new LoadError({
                        type: ErrorTypes.NETWORK_ERROR,
                        details: ErrorDetails.FRAG_LOAD_TIMEOUT,
                        fatal: false,
                        frag,
                        part,
                        error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
                        networkDetails,
                        stats
                    }));
                }
            });
        });
    }
    updateStatsFromPart(frag, part) {
        const fragStats = frag.stats;
        const partStats = part.stats;
        const partTotal = partStats.total;
        fragStats.loaded += partStats.loaded;
        if (partTotal) {
            const estTotalParts = Math.round(frag.duration / part.duration);
            const estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
            const estRemainingParts = estTotalParts - estLoadedParts;
            const estRemainingBytes = estRemainingParts * Math.round(fragStats.loaded / estLoadedParts);
            fragStats.total = fragStats.loaded + estRemainingBytes;
        } else fragStats.total = Math.max(fragStats.loaded, fragStats.total);
        const fragLoading = fragStats.loading;
        const partLoading = partStats.loading;
        if (fragLoading.start) // add to fragment loader latency
        fragLoading.first += partLoading.first - partLoading.start;
        else {
            fragLoading.start = partLoading.start;
            fragLoading.first = partLoading.first;
        }
        fragLoading.end = partLoading.end;
    }
    resetLoader(frag, loader) {
        frag.loader = null;
        if (this.loader === loader) {
            self.clearTimeout(this.partLoadTimeout);
            this.loader = null;
        }
        loader.destroy();
    }
}
function createLoaderContext(frag, part = null) {
    const segment = part || frag;
    const loaderContext = {
        frag,
        part,
        responseType: 'arraybuffer',
        url: segment.url,
        headers: {},
        rangeStart: 0,
        rangeEnd: 0
    };
    const start = segment.byteRangeStartOffset;
    const end = segment.byteRangeEndOffset;
    if (isFiniteNumber(start) && isFiniteNumber(end)) {
        var _frag$decryptdata;
        let byteRangeStart = start;
        let byteRangeEnd = end;
        if (frag.sn === 'initSegment' && ((_frag$decryptdata = frag.decryptdata) == null ? void 0 : _frag$decryptdata.method) === 'AES-128') {
            // MAP segment encrypted with method 'AES-128', when served with HTTP Range,
            // has the unencrypted size specified in the range.
            // Ref: https://tools.ietf.org/html/draft-pantos-hls-rfc8216bis-08#section-6.3.6
            const fragmentLen = end - start;
            if (fragmentLen % 16) byteRangeEnd = end + (16 - fragmentLen % 16);
            if (start !== 0) {
                loaderContext.resetIV = true;
                byteRangeStart = start - 16;
            }
        }
        loaderContext.rangeStart = byteRangeStart;
        loaderContext.rangeEnd = byteRangeEnd;
    }
    return loaderContext;
}
function createGapLoadError(frag, part) {
    const error = new Error(`GAP ${frag.gap ? 'tag' : 'attribute'} found`);
    const errorData = {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.FRAG_GAP,
        fatal: false,
        frag,
        error,
        networkDetails: null
    };
    if (part) errorData.part = part;
    (part ? part : frag).stats.aborted = true;
    return new LoadError(errorData);
}
class LoadError extends Error {
    constructor(data){
        super(data.error.message);
        this.data = void 0;
        this.data = data;
    }
}
class AESCrypto {
    constructor(subtle, iv){
        this.subtle = void 0;
        this.aesIV = void 0;
        this.subtle = subtle;
        this.aesIV = iv;
    }
    decrypt(data, key) {
        return this.subtle.decrypt({
            name: 'AES-CBC',
            iv: this.aesIV
        }, key, data);
    }
}
class FastAESKey {
    constructor(subtle, key){
        this.subtle = void 0;
        this.key = void 0;
        this.subtle = subtle;
        this.key = key;
    }
    expandKey() {
        return this.subtle.importKey('raw', this.key, {
            name: 'AES-CBC'
        }, false, [
            'encrypt',
            'decrypt'
        ]);
    }
}
// PKCS7
function removePadding(array) {
    const outputBytes = array.byteLength;
    const paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
    if (paddingBytes) return sliceUint8(array, 0, outputBytes - paddingBytes);
    return array;
}
class AESDecryptor {
    constructor(){
        this.rcon = [
            0x0,
            0x1,
            0x2,
            0x4,
            0x8,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        this.subMix = [
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256)
        ];
        this.invSubMix = [
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256)
        ];
        this.sBox = new Uint32Array(256);
        this.invSBox = new Uint32Array(256);
        this.key = new Uint32Array(0);
        this.ksRows = 0;
        this.keySize = 0;
        this.keySchedule = void 0;
        this.invKeySchedule = void 0;
        this.initTable();
    }
    // Using view.getUint32() also swaps the byte order.
    uint8ArrayToUint32Array_(arrayBuffer) {
        const view = new DataView(arrayBuffer);
        const newArray = new Uint32Array(4);
        for(let i = 0; i < 4; i++)newArray[i] = view.getUint32(i * 4);
        return newArray;
    }
    initTable() {
        const sBox = this.sBox;
        const invSBox = this.invSBox;
        const subMix = this.subMix;
        const subMix0 = subMix[0];
        const subMix1 = subMix[1];
        const subMix2 = subMix[2];
        const subMix3 = subMix[3];
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        const d = new Uint32Array(256);
        let x = 0;
        let xi = 0;
        let i = 0;
        for(i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
        else d[i] = i << 1 ^ 0x11b;
        for(i = 0; i < 256; i++){
            let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
            sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
            sBox[x] = sx;
            invSBox[sx] = x;
            // Compute multiplication
            const x2 = d[x];
            const x4 = d[x2];
            const x8 = d[x4];
            // Compute sub/invSub bytes, mix columns tables
            let t = d[sx] * 0x101 ^ sx * 0x1010100;
            subMix0[x] = t << 24 | t >>> 8;
            subMix1[x] = t << 16 | t >>> 16;
            subMix2[x] = t << 8 | t >>> 24;
            subMix3[x] = t;
            // Compute inv sub bytes, inv mix columns tables
            t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            invSubMix0[sx] = t << 24 | t >>> 8;
            invSubMix1[sx] = t << 16 | t >>> 16;
            invSubMix2[sx] = t << 8 | t >>> 24;
            invSubMix3[sx] = t;
            // Compute next counter
            if (!x) x = xi = 1;
            else {
                x = x2 ^ d[d[d[x8 ^ x2]]];
                xi ^= d[d[xi]];
            }
        }
    }
    expandKey(keyBuffer) {
        // convert keyBuffer to Uint32Array
        const key = this.uint8ArrayToUint32Array_(keyBuffer);
        let sameKey = true;
        let offset = 0;
        while(offset < key.length && sameKey){
            sameKey = key[offset] === this.key[offset];
            offset++;
        }
        if (sameKey) return;
        this.key = key;
        const keySize = this.keySize = key.length;
        if (keySize !== 4 && keySize !== 6 && keySize !== 8) throw new Error('Invalid aes key size=' + keySize);
        const ksRows = this.ksRows = (keySize + 6 + 1) * 4;
        let ksRow;
        let invKsRow;
        const keySchedule = this.keySchedule = new Uint32Array(ksRows);
        const invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
        const sbox = this.sBox;
        const rcon = this.rcon;
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        let prev;
        let t;
        for(ksRow = 0; ksRow < ksRows; ksRow++){
            if (ksRow < keySize) {
                prev = keySchedule[ksRow] = key[ksRow];
                continue;
            }
            t = prev;
            if (ksRow % keySize === 0) {
                // Rot word
                t = t << 8 | t >>> 24;
                // Sub word
                t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
                // Mix Rcon
                t ^= rcon[ksRow / keySize | 0] << 24;
            } else if (keySize > 6 && ksRow % keySize === 4) // Sub word
            t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
            keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
        }
        for(invKsRow = 0; invKsRow < ksRows; invKsRow++){
            ksRow = ksRows - invKsRow;
            if (invKsRow & 3) t = keySchedule[ksRow];
            else t = keySchedule[ksRow - 4];
            if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
            else invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
            invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
        }
    }
    // Adding this as a method greatly improves performance.
    networkToHostOrderSwap(word) {
        return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    }
    decrypt(inputArrayBuffer, offset, aesIV) {
        const nRounds = this.keySize + 6;
        const invKeySchedule = this.invKeySchedule;
        const invSBOX = this.invSBox;
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        const initVector = this.uint8ArrayToUint32Array_(aesIV);
        let initVector0 = initVector[0];
        let initVector1 = initVector[1];
        let initVector2 = initVector[2];
        let initVector3 = initVector[3];
        const inputInt32 = new Int32Array(inputArrayBuffer);
        const outputInt32 = new Int32Array(inputInt32.length);
        let t0, t1, t2, t3;
        let s0, s1, s2, s3;
        let inputWords0, inputWords1, inputWords2, inputWords3;
        let ksRow, i;
        const swapWord = this.networkToHostOrderSwap;
        while(offset < inputInt32.length){
            inputWords0 = swapWord(inputInt32[offset]);
            inputWords1 = swapWord(inputInt32[offset + 1]);
            inputWords2 = swapWord(inputInt32[offset + 2]);
            inputWords3 = swapWord(inputInt32[offset + 3]);
            s0 = inputWords0 ^ invKeySchedule[0];
            s1 = inputWords3 ^ invKeySchedule[1];
            s2 = inputWords2 ^ invKeySchedule[2];
            s3 = inputWords1 ^ invKeySchedule[3];
            ksRow = 4;
            // Iterate through the rounds of decryption
            for(i = 1; i < nRounds; i++){
                t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
                t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
                t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
                t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
                // Update state
                s0 = t0;
                s1 = t1;
                s2 = t2;
                s3 = t3;
                ksRow = ksRow + 4;
            }
            // Shift rows, sub bytes, add round key
            t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
            t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
            t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
            t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
            // Write
            outputInt32[offset] = swapWord(t0 ^ initVector0);
            outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
            outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
            outputInt32[offset + 3] = swapWord(t1 ^ initVector3);
            // reset initVector to last 4 unsigned int
            initVector0 = inputWords0;
            initVector1 = inputWords1;
            initVector2 = inputWords2;
            initVector3 = inputWords3;
            offset = offset + 4;
        }
        return outputInt32.buffer;
    }
}
const CHUNK_SIZE = 16; // 16 bytes, 128 bits
class Decrypter {
    constructor(config, { removePKCS7Padding = true } = {}){
        this.logEnabled = true;
        this.removePKCS7Padding = void 0;
        this.subtle = null;
        this.softwareDecrypter = null;
        this.key = null;
        this.fastAesKey = null;
        this.remainderData = null;
        this.currentIV = null;
        this.currentResult = null;
        this.useSoftware = void 0;
        this.useSoftware = config.enableSoftwareAES;
        this.removePKCS7Padding = removePKCS7Padding;
        // built in decryptor expects PKCS7 padding
        if (removePKCS7Padding) try {
            const browserCrypto = self.crypto;
            if (browserCrypto) this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
        } catch (e) {
        /* no-op */ }
        if (this.subtle === null) this.useSoftware = true;
    }
    destroy() {
        this.subtle = null;
        this.softwareDecrypter = null;
        this.key = null;
        this.fastAesKey = null;
        this.remainderData = null;
        this.currentIV = null;
        this.currentResult = null;
    }
    isSync() {
        return this.useSoftware;
    }
    flush() {
        const { currentResult, remainderData } = this;
        if (!currentResult || remainderData) {
            this.reset();
            return null;
        }
        const data = new Uint8Array(currentResult);
        this.reset();
        if (this.removePKCS7Padding) return removePadding(data);
        return data;
    }
    reset() {
        this.currentResult = null;
        this.currentIV = null;
        this.remainderData = null;
        if (this.softwareDecrypter) this.softwareDecrypter = null;
    }
    decrypt(data, key, iv) {
        if (this.useSoftware) return new Promise((resolve, reject)=>{
            this.softwareDecrypt(new Uint8Array(data), key, iv);
            const decryptResult = this.flush();
            if (decryptResult) resolve(decryptResult.buffer);
            else reject(new Error('[softwareDecrypt] Failed to decrypt data'));
        });
        return this.webCryptoDecrypt(new Uint8Array(data), key, iv);
    }
    // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
    // data is handled in the flush() call
    softwareDecrypt(data, key, iv) {
        const { currentIV, currentResult, remainderData } = this;
        this.logOnce('JS AES decrypt');
        // The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
        // This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
        // the end on flush(), but by that time we have already received all bytes for the segment.
        // Progressive decryption does not work with WebCrypto
        if (remainderData) {
            data = appendUint8Array(remainderData, data);
            this.remainderData = null;
        }
        // Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
        const currentChunk = this.getValidChunk(data);
        if (!currentChunk.length) return null;
        if (currentIV) iv = currentIV;
        let softwareDecrypter = this.softwareDecrypter;
        if (!softwareDecrypter) softwareDecrypter = this.softwareDecrypter = new AESDecryptor();
        softwareDecrypter.expandKey(key);
        const result = currentResult;
        this.currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
        this.currentIV = sliceUint8(currentChunk, -16).buffer;
        if (!result) return null;
        return result;
    }
    webCryptoDecrypt(data, key, iv) {
        const subtle = this.subtle;
        if (this.key !== key || !this.fastAesKey) {
            this.key = key;
            this.fastAesKey = new FastAESKey(subtle, key);
        }
        return this.fastAesKey.expandKey().then((aesKey)=>{
            // decrypt using web crypto
            if (!subtle) return Promise.reject(new Error('web crypto not initialized'));
            this.logOnce('WebCrypto AES decrypt');
            const crypto1 = new AESCrypto(subtle, new Uint8Array(iv));
            return crypto1.decrypt(data.buffer, aesKey);
        }).catch((err)=>{
            logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${err.name}: ${err.message}`);
            return this.onWebCryptoError(data, key, iv);
        });
    }
    onWebCryptoError(data, key, iv) {
        this.useSoftware = true;
        this.logEnabled = true;
        this.softwareDecrypt(data, key, iv);
        const decryptResult = this.flush();
        if (decryptResult) return decryptResult.buffer;
        throw new Error('WebCrypto and softwareDecrypt: failed to decrypt data');
    }
    getValidChunk(data) {
        let currentChunk = data;
        const splitPoint = data.length - data.length % CHUNK_SIZE;
        if (splitPoint !== data.length) {
            currentChunk = sliceUint8(data, 0, splitPoint);
            this.remainderData = sliceUint8(data, splitPoint);
        }
        return currentChunk;
    }
    logOnce(msg) {
        if (!this.logEnabled) return;
        logger.log(`[decrypter]: ${msg}`);
        this.logEnabled = false;
    }
}
/**
 *  TimeRanges to string helper
 */ const TimeRanges = {
    toString: function(r) {
        let log = '';
        const len = r.length;
        for(let i = 0; i < len; i++)log += `[${r.start(i).toFixed(3)}-${r.end(i).toFixed(3)}]`;
        return log;
    }
};
const State = {
    STOPPED: 'STOPPED',
    IDLE: 'IDLE',
    KEY_LOADING: 'KEY_LOADING',
    FRAG_LOADING: 'FRAG_LOADING',
    FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
    WAITING_TRACK: 'WAITING_TRACK',
    PARSING: 'PARSING',
    PARSED: 'PARSED',
    ENDED: 'ENDED',
    ERROR: 'ERROR',
    WAITING_INIT_PTS: 'WAITING_INIT_PTS',
    WAITING_LEVEL: 'WAITING_LEVEL'
};
class BaseStreamController extends TaskLoop {
    constructor(hls, fragmentTracker, keyLoader, logPrefix, playlistType){
        super();
        this.hls = void 0;
        this.fragPrevious = null;
        this.fragCurrent = null;
        this.fragmentTracker = void 0;
        this.transmuxer = null;
        this._state = State.STOPPED;
        this.playlistType = void 0;
        this.media = null;
        this.mediaBuffer = null;
        this.config = void 0;
        this.bitrateTest = false;
        this.lastCurrentTime = 0;
        this.nextLoadPosition = 0;
        this.startPosition = 0;
        this.startTimeOffset = null;
        this.loadedmetadata = false;
        this.retryDate = 0;
        this.levels = null;
        this.fragmentLoader = void 0;
        this.keyLoader = void 0;
        this.levelLastLoaded = null;
        this.startFragRequested = false;
        this.decrypter = void 0;
        this.initPTS = [];
        this.onvseeking = null;
        this.onvended = null;
        this.logPrefix = '';
        this.log = void 0;
        this.warn = void 0;
        this.playlistType = playlistType;
        this.logPrefix = logPrefix;
        this.log = logger.log.bind(logger, `${logPrefix}:`);
        this.warn = logger.warn.bind(logger, `${logPrefix}:`);
        this.hls = hls;
        this.fragmentLoader = new FragmentLoader(hls.config);
        this.keyLoader = keyLoader;
        this.fragmentTracker = fragmentTracker;
        this.config = hls.config;
        this.decrypter = new Decrypter(hls.config);
        hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    }
    doTick() {
        this.onTickEnd();
    }
    onTickEnd() {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    startLoad(startPosition) {}
    stopLoad() {
        this.fragmentLoader.abort();
        this.keyLoader.abort(this.playlistType);
        const frag = this.fragCurrent;
        if (frag != null && frag.loader) {
            frag.abortRequests();
            this.fragmentTracker.removeFragment(frag);
        }
        this.resetTransmuxer();
        this.fragCurrent = null;
        this.fragPrevious = null;
        this.clearInterval();
        this.clearNextTick();
        this.state = State.STOPPED;
    }
    _streamEnded(bufferInfo, levelDetails) {
        // If playlist is live, there is another buffered range after the current range, nothing buffered, media is detached,
        // of nothing loading/loaded return false
        if (levelDetails.live || bufferInfo.nextStart || !bufferInfo.end || !this.media) return false;
        const partList = levelDetails.partList;
        // Since the last part isn't guaranteed to correspond to the last playlist segment for Low-Latency HLS,
        // check instead if the last part is buffered.
        if (partList != null && partList.length) {
            const lastPart = partList[partList.length - 1];
            // Checking the midpoint of the part for potential margin of error and related issues.
            // NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
            // and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
            // part mismatches for independent audio and video playlists/segments.
            const lastPartBuffered = BufferHelper.isBuffered(this.media, lastPart.start + lastPart.duration / 2);
            return lastPartBuffered;
        }
        const playlistType = levelDetails.fragments[levelDetails.fragments.length - 1].type;
        return this.fragmentTracker.isEndListAppended(playlistType);
    }
    getLevelDetails() {
        if (this.levels && this.levelLastLoaded !== null) {
            var _this$levelLastLoaded;
            return (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details;
        }
    }
    onMediaAttached(event, data) {
        const media = this.media = this.mediaBuffer = data.media;
        this.onvseeking = this.onMediaSeeking.bind(this);
        this.onvended = this.onMediaEnded.bind(this);
        media.addEventListener('seeking', this.onvseeking);
        media.addEventListener('ended', this.onvended);
        const config = this.config;
        if (this.levels && config.autoStartLoad && this.state === State.STOPPED) this.startLoad(config.startPosition);
    }
    onMediaDetaching() {
        const media = this.media;
        if (media != null && media.ended) {
            this.log('MSE detaching and video ended, reset startPosition');
            this.startPosition = this.lastCurrentTime = 0;
        }
        // remove video listeners
        if (media && this.onvseeking && this.onvended) {
            media.removeEventListener('seeking', this.onvseeking);
            media.removeEventListener('ended', this.onvended);
            this.onvseeking = this.onvended = null;
        }
        if (this.keyLoader) this.keyLoader.detach();
        this.media = this.mediaBuffer = null;
        this.loadedmetadata = false;
        this.fragmentTracker.removeAllFragments();
        this.stopLoad();
    }
    onMediaSeeking() {
        const { config, fragCurrent, media, mediaBuffer, state } = this;
        const currentTime = media ? media.currentTime : 0;
        const bufferInfo = BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
        this.log(`media seeking to ${isFiniteNumber(currentTime) ? currentTime.toFixed(3) : currentTime}, state: ${state}`);
        if (this.state === State.ENDED) this.resetLoadingState();
        else if (fragCurrent) {
            // Seeking while frag load is in progress
            const tolerance = config.maxFragLookUpTolerance;
            const fragStartOffset = fragCurrent.start - tolerance;
            const fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
            // if seeking out of buffered range or into new one
            if (!bufferInfo.len || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
                const pastFragment = currentTime > fragEndOffset;
                // if the seek position is outside the current fragment range
                if (currentTime < fragStartOffset || pastFragment) {
                    if (pastFragment && fragCurrent.loader) {
                        this.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
                        fragCurrent.abortRequests();
                        this.resetLoadingState();
                    }
                    this.fragPrevious = null;
                }
            }
        }
        if (media) {
            // Remove gap fragments
            this.fragmentTracker.removeFragmentsInRange(currentTime, Infinity, this.playlistType, true);
            this.lastCurrentTime = currentTime;
        }
        // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
        if (!this.loadedmetadata && !bufferInfo.len) this.nextLoadPosition = this.startPosition = currentTime;
        // Async tick to speed up processing
        this.tickImmediate();
    }
    onMediaEnded() {
        // reset startPosition and lastCurrentTime to restart playback @ stream beginning
        this.startPosition = this.lastCurrentTime = 0;
    }
    onManifestLoaded(event, data) {
        this.startTimeOffset = data.startTimeOffset;
        this.initPTS = [];
    }
    onHandlerDestroying() {
        this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        this.stopLoad();
        super.onHandlerDestroying();
        // @ts-ignore
        this.hls = null;
    }
    onHandlerDestroyed() {
        this.state = State.STOPPED;
        if (this.fragmentLoader) this.fragmentLoader.destroy();
        if (this.keyLoader) this.keyLoader.destroy();
        if (this.decrypter) this.decrypter.destroy();
        this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null;
        super.onHandlerDestroyed();
    }
    loadFragment(frag, level, targetBufferTime) {
        this._loadFragForPlayback(frag, level, targetBufferTime);
    }
    _loadFragForPlayback(frag, level, targetBufferTime) {
        const progressCallback = (data)=>{
            if (this.fragContextChanged(frag)) {
                this.warn(`Fragment ${frag.sn}${data.part ? ' p: ' + data.part.index : ''} of level ${frag.level} was dropped during download.`);
                this.fragmentTracker.removeFragment(frag);
                return;
            }
            frag.stats.chunkCount++;
            this._handleFragmentLoadProgress(data);
        };
        this._doFragLoad(frag, level, targetBufferTime, progressCallback).then((data)=>{
            if (!data) // if we're here we probably needed to backtrack or are waiting for more parts
            return;
            const state = this.state;
            if (this.fragContextChanged(frag)) {
                if (state === State.FRAG_LOADING || !this.fragCurrent && state === State.PARSING) {
                    this.fragmentTracker.removeFragment(frag);
                    this.state = State.IDLE;
                }
                return;
            }
            if ('payload' in data) {
                this.log(`Loaded fragment ${frag.sn} of level ${frag.level}`);
                this.hls.trigger(Events.FRAG_LOADED, data);
            }
            // Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
            this._handleFragmentLoadComplete(data);
        }).catch((reason)=>{
            if (this.state === State.STOPPED || this.state === State.ERROR) return;
            this.warn(reason);
            this.resetFragmentLoading(frag);
        });
    }
    clearTrackerIfNeeded(frag) {
        var _this$mediaBuffer;
        const { fragmentTracker } = this;
        const fragState = fragmentTracker.getState(frag);
        if (fragState === FragmentState.APPENDING) {
            // Lower the buffer size and try again
            const playlistType = frag.type;
            const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
            const minForwardBufferLength = Math.max(frag.duration, bufferedInfo ? bufferedInfo.len : this.config.maxBufferLength);
            if (this.reduceMaxBufferLength(minForwardBufferLength)) fragmentTracker.removeFragment(frag);
        } else if (((_this$mediaBuffer = this.mediaBuffer) == null ? void 0 : _this$mediaBuffer.buffered.length) === 0) // Stop gap for bad tracker / buffer flush behavior
        fragmentTracker.removeAllFragments();
        else if (fragmentTracker.hasParts(frag.type)) {
            // In low latency mode, remove fragments for which only some parts were buffered
            fragmentTracker.detectPartialFragments({
                frag,
                part: null,
                stats: frag.stats,
                id: frag.type
            });
            if (fragmentTracker.getState(frag) === FragmentState.PARTIAL) fragmentTracker.removeFragment(frag);
        }
    }
    checkLiveUpdate(details) {
        if (details.updated && !details.live) {
            // Live stream ended, update fragment tracker
            const lastFragment = details.fragments[details.fragments.length - 1];
            this.fragmentTracker.detectPartialFragments({
                frag: lastFragment,
                part: null,
                stats: lastFragment.stats,
                id: lastFragment.type
            });
        }
        if (!details.fragments[0]) details.deltaUpdateFailed = true;
    }
    flushMainBuffer(startOffset, endOffset, type = null) {
        if (!(startOffset - endOffset)) return;
        // When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
        // passing a null type flushes both buffers
        const flushScope = {
            startOffset,
            endOffset,
            type
        };
        this.hls.trigger(Events.BUFFER_FLUSHING, flushScope);
    }
    _loadInitSegment(frag, level) {
        this._doFragLoad(frag, level).then((data)=>{
            if (!data || this.fragContextChanged(frag) || !this.levels) throw new Error('init load aborted');
            return data;
        }).then((data)=>{
            const { hls } = this;
            const { payload } = data;
            const decryptData = frag.decryptdata;
            // check to see if the payload needs to be decrypted
            if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && decryptData.method === 'AES-128') {
                const startTime = self.performance.now();
                // decrypt init segment data
                return this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch((err)=>{
                    hls.trigger(Events.ERROR, {
                        type: ErrorTypes.MEDIA_ERROR,
                        details: ErrorDetails.FRAG_DECRYPT_ERROR,
                        fatal: false,
                        error: err,
                        reason: err.message,
                        frag
                    });
                    throw err;
                }).then((decryptedData)=>{
                    const endTime = self.performance.now();
                    hls.trigger(Events.FRAG_DECRYPTED, {
                        frag,
                        payload: decryptedData,
                        stats: {
                            tstart: startTime,
                            tdecrypt: endTime
                        }
                    });
                    data.payload = decryptedData;
                    return this.completeInitSegmentLoad(data);
                });
            }
            return this.completeInitSegmentLoad(data);
        }).catch((reason)=>{
            if (this.state === State.STOPPED || this.state === State.ERROR) return;
            this.warn(reason);
            this.resetFragmentLoading(frag);
        });
    }
    completeInitSegmentLoad(data) {
        const { levels } = this;
        if (!levels) throw new Error('init load aborted, missing levels');
        const stats = data.frag.stats;
        this.state = State.IDLE;
        data.frag.data = new Uint8Array(data.payload);
        stats.parsing.start = stats.buffering.start = self.performance.now();
        stats.parsing.end = stats.buffering.end = self.performance.now();
        this.tick();
    }
    fragContextChanged(frag) {
        const { fragCurrent } = this;
        return !frag || !fragCurrent || frag.sn !== fragCurrent.sn || frag.level !== fragCurrent.level;
    }
    fragBufferedComplete(frag, part) {
        var _frag$startPTS, _frag$endPTS, _this$fragCurrent, _this$fragPrevious;
        const media = this.mediaBuffer ? this.mediaBuffer : this.media;
        this.log(`Buffered ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.playlistType === PlaylistLevelType.MAIN ? 'level' : 'track'} ${frag.level} (frag:[${((_frag$startPTS = frag.startPTS) != null ? _frag$startPTS : NaN).toFixed(3)}-${((_frag$endPTS = frag.endPTS) != null ? _frag$endPTS : NaN).toFixed(3)}] > buffer:${media ? TimeRanges.toString(BufferHelper.getBuffered(media)) : '(detached)'})`);
        if (frag.sn !== 'initSegment') {
            var _this$levels;
            if (frag.type !== PlaylistLevelType.SUBTITLE) {
                const el = frag.elementaryStreams;
                if (!Object.keys(el).some((type)=>!!el[type])) {
                    // empty segment
                    this.state = State.IDLE;
                    return;
                }
            }
            const level = (_this$levels = this.levels) == null ? void 0 : _this$levels[frag.level];
            if (level != null && level.fragmentError) {
                this.log(`Resetting level fragment error count of ${level.fragmentError} on frag buffered`);
                level.fragmentError = 0;
            }
        }
        this.state = State.IDLE;
        if (!media) return;
        if (!this.loadedmetadata && frag.type == PlaylistLevelType.MAIN && media.buffered.length && ((_this$fragCurrent = this.fragCurrent) == null ? void 0 : _this$fragCurrent.sn) === ((_this$fragPrevious = this.fragPrevious) == null ? void 0 : _this$fragPrevious.sn)) {
            this.loadedmetadata = true;
            this.seekToStartPos();
        }
        this.tick();
    }
    seekToStartPos() {}
    _handleFragmentLoadComplete(fragLoadedEndData) {
        const { transmuxer } = this;
        if (!transmuxer) return;
        const { frag, part, partsLoaded } = fragLoadedEndData;
        // If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
        const complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some((fragLoaded)=>!fragLoaded);
        const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
        transmuxer.flush(chunkMeta);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _handleFragmentLoadProgress(frag) {}
    _doFragLoad(frag, level, targetBufferTime = null, progressCallback) {
        var _frag$decryptdata;
        const details = level == null ? void 0 : level.details;
        if (!this.levels || !details) throw new Error(`frag load aborted, missing level${details ? '' : ' detail'}s`);
        let keyLoadingPromise = null;
        if (frag.encrypted && !((_frag$decryptdata = frag.decryptdata) != null && _frag$decryptdata.key)) {
            this.log(`Loading key for ${frag.sn} of [${details.startSN}-${details.endSN}], ${this.logPrefix === '[stream-controller]' ? 'level' : 'track'} ${frag.level}`);
            this.state = State.KEY_LOADING;
            this.fragCurrent = frag;
            keyLoadingPromise = this.keyLoader.load(frag).then((keyLoadedData)=>{
                if (!this.fragContextChanged(keyLoadedData.frag)) {
                    this.hls.trigger(Events.KEY_LOADED, keyLoadedData);
                    if (this.state === State.KEY_LOADING) this.state = State.IDLE;
                    return keyLoadedData;
                }
            });
            this.hls.trigger(Events.KEY_LOADING, {
                frag
            });
            if (this.fragCurrent === null) keyLoadingPromise = Promise.reject(new Error(`frag load aborted, context changed in KEY_LOADING`));
        } else if (!frag.encrypted && details.encryptedFragments.length) this.keyLoader.loadClear(frag, details.encryptedFragments);
        targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
        if (this.config.lowLatencyMode && frag.sn !== 'initSegment') {
            const partList = details.partList;
            if (partList && progressCallback) {
                if (targetBufferTime > frag.end && details.fragmentHint) frag = details.fragmentHint;
                const partIndex = this.getNextPart(partList, frag, targetBufferTime);
                if (partIndex > -1) {
                    const part = partList[partIndex];
                    this.log(`Loading part sn: ${frag.sn} p: ${part.index} cc: ${frag.cc} of playlist [${details.startSN}-${details.endSN}] parts [0-${partIndex}-${partList.length - 1}] ${this.logPrefix === '[stream-controller]' ? 'level' : 'track'}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
                    this.nextLoadPosition = part.start + part.duration;
                    this.state = State.FRAG_LOADING;
                    let _result;
                    if (keyLoadingPromise) _result = keyLoadingPromise.then((keyLoadedData)=>{
                        if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) return null;
                        return this.doFragPartsLoad(frag, part, level, progressCallback);
                    }).catch((error)=>this.handleFragLoadError(error));
                    else _result = this.doFragPartsLoad(frag, part, level, progressCallback).catch((error)=>this.handleFragLoadError(error));
                    this.hls.trigger(Events.FRAG_LOADING, {
                        frag,
                        part,
                        targetBufferTime
                    });
                    if (this.fragCurrent === null) return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING parts`));
                    return _result;
                } else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) // Fragment hint has no parts
                return Promise.resolve(null);
            }
        }
        this.log(`Loading fragment ${frag.sn} cc: ${frag.cc} ${details ? 'of [' + details.startSN + '-' + details.endSN + '] ' : ''}${this.logPrefix === '[stream-controller]' ? 'level' : 'track'}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
        // Don't update nextLoadPosition for fragments which are not buffered
        if (isFiniteNumber(frag.sn) && !this.bitrateTest) this.nextLoadPosition = frag.start + frag.duration;
        this.state = State.FRAG_LOADING;
        // Load key before streaming fragment data
        const dataOnProgress = this.config.progressive;
        let result;
        if (dataOnProgress && keyLoadingPromise) result = keyLoadingPromise.then((keyLoadedData)=>{
            if (!keyLoadedData || this.fragContextChanged(keyLoadedData == null ? void 0 : keyLoadedData.frag)) return null;
            return this.fragmentLoader.load(frag, progressCallback);
        }).catch((error)=>this.handleFragLoadError(error));
        else // load unencrypted fragment data with progress event,
        // or handle fragment result after key and fragment are finished loading
        result = Promise.all([
            this.fragmentLoader.load(frag, dataOnProgress ? progressCallback : undefined),
            keyLoadingPromise
        ]).then(([fragLoadedData])=>{
            if (!dataOnProgress && fragLoadedData && progressCallback) progressCallback(fragLoadedData);
            return fragLoadedData;
        }).catch((error)=>this.handleFragLoadError(error));
        this.hls.trigger(Events.FRAG_LOADING, {
            frag,
            targetBufferTime
        });
        if (this.fragCurrent === null) return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING`));
        return result;
    }
    doFragPartsLoad(frag, fromPart, level, progressCallback) {
        return new Promise((resolve, reject)=>{
            var _level$details;
            const partsLoaded = [];
            const initialPartList = (_level$details = level.details) == null ? void 0 : _level$details.partList;
            const loadPart = (part)=>{
                this.fragmentLoader.loadPart(frag, part, progressCallback).then((partLoadedData)=>{
                    partsLoaded[part.index] = partLoadedData;
                    const loadedPart = partLoadedData.part;
                    this.hls.trigger(Events.FRAG_LOADED, partLoadedData);
                    const nextPart = getPartWith(level, frag.sn, part.index + 1) || findPart(initialPartList, frag.sn, part.index + 1);
                    if (nextPart) loadPart(nextPart);
                    else return resolve({
                        frag,
                        part: loadedPart,
                        partsLoaded
                    });
                }).catch(reject);
            };
            loadPart(fromPart);
        });
    }
    handleFragLoadError(error) {
        if ('data' in error) {
            const data = error.data;
            if (error.data && data.details === ErrorDetails.INTERNAL_ABORTED) this.handleFragLoadAborted(data.frag, data.part);
            else this.hls.trigger(Events.ERROR, data);
        } else this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.OTHER_ERROR,
            details: ErrorDetails.INTERNAL_EXCEPTION,
            err: error,
            error,
            fatal: true
        });
        return null;
    }
    _handleTransmuxerFlush(chunkMeta) {
        const context = this.getCurrentContext(chunkMeta);
        if (!context || this.state !== State.PARSING) {
            if (!this.fragCurrent && this.state !== State.STOPPED && this.state !== State.ERROR) this.state = State.IDLE;
            return;
        }
        const { frag, part, level } = context;
        const now = self.performance.now();
        frag.stats.parsing.end = now;
        if (part) part.stats.parsing.end = now;
        this.updateLevelTiming(frag, part, level, chunkMeta.partial);
    }
    getCurrentContext(chunkMeta) {
        const { levels, fragCurrent } = this;
        const { level: levelIndex, sn, part: partIndex } = chunkMeta;
        if (!(levels != null && levels[levelIndex])) {
            this.warn(`Levels object was unset while buffering fragment ${sn} of level ${levelIndex}. The current chunk will not be buffered.`);
            return null;
        }
        const level = levels[levelIndex];
        const part = partIndex > -1 ? getPartWith(level, sn, partIndex) : null;
        const frag = part ? part.fragment : getFragmentWithSN(level, sn, fragCurrent);
        if (!frag) return null;
        if (fragCurrent && fragCurrent !== frag) frag.stats = fragCurrent.stats;
        return {
            frag,
            part,
            level
        };
    }
    bufferFragmentData(data, frag, part, chunkMeta, noBacktracking) {
        var _buffer;
        if (!data || this.state !== State.PARSING) return;
        const { data1, data2 } = data;
        let buffer = data1;
        if (data1 && data2) // Combine the moof + mdat so that we buffer with a single append
        buffer = appendUint8Array(data1, data2);
        if (!((_buffer = buffer) != null && _buffer.length)) return;
        const segment = {
            type: data.type,
            frag,
            part,
            chunkMeta,
            parent: frag.type,
            data: buffer
        };
        this.hls.trigger(Events.BUFFER_APPENDING, segment);
        if (data.dropped && data.independent && !part) {
            if (noBacktracking) return;
            // Clear buffer so that we reload previous segments sequentially if required
            this.flushBufferGap(frag);
        }
    }
    flushBufferGap(frag) {
        const media = this.media;
        if (!media) return;
        // If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
        if (!BufferHelper.isBuffered(media, media.currentTime)) {
            this.flushMainBuffer(0, frag.start);
            return;
        }
        // Remove back-buffer without interrupting playback to allow back tracking
        const currentTime = media.currentTime;
        const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
        const fragDuration = frag.duration;
        const segmentFraction = Math.min(this.config.maxFragLookUpTolerance * 2, fragDuration * 0.25);
        const start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
        if (frag.start - start > segmentFraction) this.flushMainBuffer(start, frag.start);
    }
    getFwdBufferInfo(bufferable, type) {
        const pos = this.getLoadPosition();
        if (!isFiniteNumber(pos)) return null;
        return this.getFwdBufferInfoAtPos(bufferable, pos, type);
    }
    getFwdBufferInfoAtPos(bufferable, pos, type) {
        const { config: { maxBufferHole } } = this;
        const bufferInfo = BufferHelper.bufferInfo(bufferable, pos, maxBufferHole);
        // Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
        if (bufferInfo.len === 0 && bufferInfo.nextStart !== undefined) {
            const bufferedFragAtPos = this.fragmentTracker.getBufferedFrag(pos, type);
            if (bufferedFragAtPos && bufferInfo.nextStart < bufferedFragAtPos.end) return BufferHelper.bufferInfo(bufferable, pos, Math.max(bufferInfo.nextStart, maxBufferHole));
        }
        return bufferInfo;
    }
    getMaxBufferLength(levelBitrate) {
        const { config } = this;
        let maxBufLen;
        if (levelBitrate) maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
        else maxBufLen = config.maxBufferLength;
        return Math.min(maxBufLen, config.maxMaxBufferLength);
    }
    reduceMaxBufferLength(threshold) {
        const config = this.config;
        const minLength = threshold || config.maxBufferLength;
        if (config.maxMaxBufferLength >= minLength) {
            // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
            config.maxMaxBufferLength /= 2;
            this.warn(`Reduce max buffer length to ${config.maxMaxBufferLength}s`);
            return true;
        }
        return false;
    }
    getAppendedFrag(position, playlistType = PlaylistLevelType.MAIN) {
        const fragOrPart = this.fragmentTracker.getAppendedFrag(position, PlaylistLevelType.MAIN);
        if (fragOrPart && 'fragment' in fragOrPart) return fragOrPart.fragment;
        return fragOrPart;
    }
    getNextFragment(pos, levelDetails) {
        const fragments = levelDetails.fragments;
        const fragLen = fragments.length;
        if (!fragLen) return null;
        // find fragment index, contiguous with end of buffer position
        const { config } = this;
        const start = fragments[0].start;
        let frag;
        if (levelDetails.live) {
            const initialLiveManifestSize = config.initialLiveManifestSize;
            if (fragLen < initialLiveManifestSize) {
                this.warn(`Not enough fragments to start playback (have: ${fragLen}, need: ${initialLiveManifestSize})`);
                return null;
            }
            // The real fragment start times for a live stream are only known after the PTS range for that level is known.
            // In order to discover the range, we load the best matching fragment for that level and demux it.
            // Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
            // we get the fragment matching that start time
            if (!levelDetails.PTSKnown && !this.startFragRequested && this.startPosition === -1 || pos < start) {
                frag = this.getInitialLiveFragment(levelDetails, fragments);
                this.startPosition = this.nextLoadPosition = frag ? this.hls.liveSyncPosition || frag.start : pos;
            }
        } else if (pos <= start) // VoD playlist: if loadPosition before start of playlist, load first fragment
        frag = fragments[0];
        // If we haven't run into any special cases already, just load the fragment most closely matching the requested position
        if (!frag) {
            const end = config.lowLatencyMode ? levelDetails.partEnd : levelDetails.fragmentEnd;
            frag = this.getFragmentAtPosition(pos, end, levelDetails);
        }
        return this.mapToInitFragWhenRequired(frag);
    }
    isLoopLoading(frag, targetBufferTime) {
        const trackerState = this.fragmentTracker.getState(frag);
        return (trackerState === FragmentState.OK || trackerState === FragmentState.PARTIAL && !!frag.gap) && this.nextLoadPosition > targetBufferTime;
    }
    getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, playlistType, maxBufLen) {
        const gapStart = frag.gap;
        const nextFragment = this.getNextFragment(this.nextLoadPosition, levelDetails);
        if (nextFragment === null) return nextFragment;
        frag = nextFragment;
        if (gapStart && frag && !frag.gap && bufferInfo.nextStart) {
            // Media buffered after GAP tags should not make the next buffer timerange exceed forward buffer length
            const nextbufferInfo = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, bufferInfo.nextStart, playlistType);
            if (nextbufferInfo !== null && bufferInfo.len + nextbufferInfo.len >= maxBufLen) {
                // Returning here might result in not finding an audio and video candiate to skip to
                this.log(`buffer full after gaps in "${playlistType}" playlist starting at sn: ${frag.sn}`);
                return null;
            }
        }
        return frag;
    }
    mapToInitFragWhenRequired(frag) {
        // If an initSegment is present, it must be buffered first
        if (frag != null && frag.initSegment && !(frag != null && frag.initSegment.data) && !this.bitrateTest) return frag.initSegment;
        return frag;
    }
    getNextPart(partList, frag, targetBufferTime) {
        let nextPart = -1;
        let contiguous = false;
        let independentAttrOmitted = true;
        for(let i = 0, len = partList.length; i < len; i++){
            const part = partList[i];
            independentAttrOmitted = independentAttrOmitted && !part.independent;
            if (nextPart > -1 && targetBufferTime < part.start) break;
            const loaded = part.loaded;
            if (loaded) nextPart = -1;
            else if ((contiguous || part.independent || independentAttrOmitted) && part.fragment === frag) nextPart = i;
            contiguous = loaded;
        }
        return nextPart;
    }
    loadedEndOfParts(partList, targetBufferTime) {
        const lastPart = partList[partList.length - 1];
        return lastPart && targetBufferTime > lastPart.start && lastPart.loaded;
    }
    /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */ getInitialLiveFragment(levelDetails, fragments) {
        const fragPrevious = this.fragPrevious;
        let frag = null;
        if (fragPrevious) {
            if (levelDetails.hasProgramDateTime) {
                // Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
                this.log(`Live playlist, switching playlist, load frag with same PDT: ${fragPrevious.programDateTime}`);
                frag = findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, this.config.maxFragLookUpTolerance);
            }
            if (!frag) {
                // SN does not need to be accurate between renditions, but depending on the packaging it may be so.
                const targetSN = fragPrevious.sn + 1;
                if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
                    const fragNext = fragments[targetSN - levelDetails.startSN];
                    // Ensure that we're staying within the continuity range, since PTS resets upon a new range
                    if (fragPrevious.cc === fragNext.cc) {
                        frag = fragNext;
                        this.log(`Live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
                    }
                }
                // It's important to stay within the continuity range if available; otherwise the fragments in the playlist
                // will have the wrong start times
                if (!frag) {
                    frag = findFragWithCC(fragments, fragPrevious.cc);
                    if (frag) this.log(`Live playlist, switching playlist, load frag with same CC: ${frag.sn}`);
                }
            }
        } else {
            // Find a new start fragment when fragPrevious is null
            const liveStart = this.hls.liveSyncPosition;
            if (liveStart !== null) frag = this.getFragmentAtPosition(liveStart, this.bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
        }
        return frag;
    }
    /*
  This method finds the best matching fragment given the provided position.
   */ getFragmentAtPosition(bufferEnd, end, levelDetails) {
        const { config } = this;
        let { fragPrevious } = this;
        let { fragments, endSN } = levelDetails;
        const { fragmentHint } = levelDetails;
        const tolerance = config.maxFragLookUpTolerance;
        const partList = levelDetails.partList;
        const loadingParts = !!(config.lowLatencyMode && partList != null && partList.length && fragmentHint);
        if (loadingParts && fragmentHint && !this.bitrateTest) {
            // Include incomplete fragment with parts at end
            fragments = fragments.concat(fragmentHint);
            endSN = fragmentHint.sn;
        }
        let frag;
        if (bufferEnd < end) {
            const lookupTolerance = bufferEnd > end - tolerance ? 0 : tolerance;
            // Remove the tolerance if it would put the bufferEnd past the actual end of stream
            // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
            frag = findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
        } else // reach end of playlist
        frag = fragments[fragments.length - 1];
        if (frag) {
            const curSNIdx = frag.sn - levelDetails.startSN;
            // Move fragPrevious forward to support forcing the next fragment to load
            // when the buffer catches up to a previously buffered range.
            const fragState = this.fragmentTracker.getState(frag);
            if (fragState === FragmentState.OK || fragState === FragmentState.PARTIAL && frag.gap) fragPrevious = frag;
            if (fragPrevious && frag.sn === fragPrevious.sn && (!loadingParts || partList[0].fragment.sn > frag.sn)) {
                // Force the next fragment to load if the previous one was already selected. This can occasionally happen with
                // non-uniform fragment durations
                const sameLevel = fragPrevious && frag.level === fragPrevious.level;
                if (sameLevel) {
                    const nextFrag = fragments[curSNIdx + 1];
                    if (frag.sn < endSN && this.fragmentTracker.getState(nextFrag) !== FragmentState.OK) frag = nextFrag;
                    else frag = null;
                }
            }
        }
        return frag;
    }
    synchronizeToLiveEdge(levelDetails) {
        const { config, media } = this;
        if (!media) return;
        const liveSyncPosition = this.hls.liveSyncPosition;
        const currentTime = media.currentTime;
        const start = levelDetails.fragments[0].start;
        const end = levelDetails.edge;
        const withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
        // Continue if we can seek forward to sync position or if current time is outside of sliding window
        if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
            // Continue if buffer is starving or if current time is behind max latency
            const maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
            if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
                if (!this.loadedmetadata) this.nextLoadPosition = liveSyncPosition;
                // Only seek if ready and there is not a significant forward buffer available for playback
                if (media.readyState) {
                    this.warn(`Playback: ${currentTime.toFixed(3)} is located too far from the end of live sliding playlist: ${end}, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
                    media.currentTime = liveSyncPosition;
                }
            }
        }
    }
    alignPlaylists(details, previousDetails, switchDetails) {
        // FIXME: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
        //  this could all go in level-helper mergeDetails()
        const length = details.fragments.length;
        if (!length) {
            this.warn(`No fragments in live playlist`);
            return 0;
        }
        const slidingStart = details.fragments[0].start;
        const firstLevelLoad = !previousDetails;
        const aligned = details.alignedSliding && isFiniteNumber(slidingStart);
        if (firstLevelLoad || !aligned && !slidingStart) {
            const { fragPrevious } = this;
            alignStream(fragPrevious, switchDetails, details);
            const alignedSlidingStart = details.fragments[0].start;
            this.log(`Live playlist sliding: ${alignedSlidingStart.toFixed(2)} start-sn: ${previousDetails ? previousDetails.startSN : 'na'}->${details.startSN} prev-sn: ${fragPrevious ? fragPrevious.sn : 'na'} fragments: ${length}`);
            return alignedSlidingStart;
        }
        return slidingStart;
    }
    waitForCdnTuneIn(details) {
        // Wait for Low-Latency CDN Tune-in to get an updated playlist
        const advancePartLimit = 3;
        return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * advancePartLimit);
    }
    setStartPosition(details, sliding) {
        // compute start position if set to -1. use it straight away if value is defined
        let startPosition = this.startPosition;
        if (startPosition < sliding) startPosition = -1;
        if (startPosition === -1 || this.lastCurrentTime === -1) {
            // Use Playlist EXT-X-START:TIME-OFFSET when set
            // Prioritize Multivariant Playlist offset so that main, audio, and subtitle stream-controller start times match
            const offsetInMultivariantPlaylist = this.startTimeOffset !== null;
            const startTimeOffset = offsetInMultivariantPlaylist ? this.startTimeOffset : details.startTimeOffset;
            if (startTimeOffset !== null && isFiniteNumber(startTimeOffset)) {
                startPosition = sliding + startTimeOffset;
                if (startTimeOffset < 0) startPosition += details.totalduration;
                startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
                this.log(`Start time offset ${startTimeOffset} found in ${offsetInMultivariantPlaylist ? 'multivariant' : 'media'} playlist, adjust startPosition to ${startPosition}`);
                this.startPosition = startPosition;
            } else if (details.live) // Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
            // not been specified via the config or an as an argument to startLoad (#3736).
            startPosition = this.hls.liveSyncPosition || sliding;
            else this.startPosition = startPosition = 0;
            this.lastCurrentTime = startPosition;
        }
        this.nextLoadPosition = startPosition;
    }
    getLoadPosition() {
        const { media } = this;
        // if we have not yet loaded any fragment, start loading from start position
        let pos = 0;
        if (this.loadedmetadata && media) pos = media.currentTime;
        else if (this.nextLoadPosition) pos = this.nextLoadPosition;
        return pos;
    }
    handleFragLoadAborted(frag, part) {
        if (this.transmuxer && frag.sn !== 'initSegment' && frag.stats.aborted) {
            this.warn(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${frag.level} was aborted`);
            this.resetFragmentLoading(frag);
        }
    }
    resetFragmentLoading(frag) {
        if (!this.fragCurrent || !this.fragContextChanged(frag) && this.state !== State.FRAG_LOADING_WAITING_RETRY) this.state = State.IDLE;
    }
    onFragmentOrKeyLoadError(filterType, data) {
        if (data.chunkMeta && !data.frag) {
            const context = this.getCurrentContext(data.chunkMeta);
            if (context) data.frag = context.frag;
        }
        const frag = data.frag;
        // Handle frag error related to caller's filterType
        if (!frag || frag.type !== filterType || !this.levels) return;
        if (this.fragContextChanged(frag)) {
            var _this$fragCurrent2;
            this.warn(`Frag load error must match current frag to retry ${frag.url} > ${(_this$fragCurrent2 = this.fragCurrent) == null ? void 0 : _this$fragCurrent2.url}`);
            return;
        }
        const gapTagEncountered = data.details === ErrorDetails.FRAG_GAP;
        if (gapTagEncountered) this.fragmentTracker.fragBuffered(frag, true);
        // keep retrying until the limit will be reached
        const errorAction = data.errorAction;
        const { action, retryCount = 0, retryConfig } = errorAction || {};
        if (errorAction && action === NetworkErrorAction.RetryRequest && retryConfig) {
            this.resetStartWhenNotLoaded(this.levelLastLoaded);
            const delay = getRetryDelay(retryConfig, retryCount);
            this.warn(`Fragment ${frag.sn} of ${filterType} ${frag.level} errored with ${data.details}, retrying loading ${retryCount + 1}/${retryConfig.maxNumRetry} in ${delay}ms`);
            errorAction.resolved = true;
            this.retryDate = self.performance.now() + delay;
            this.state = State.FRAG_LOADING_WAITING_RETRY;
        } else if (retryConfig && errorAction) {
            this.resetFragmentErrors(filterType);
            if (retryCount < retryConfig.maxNumRetry) // Network retry is skipped when level switch is preferred
            {
                if (!gapTagEncountered && action !== NetworkErrorAction.RemoveAlternatePermanently) errorAction.resolved = true;
            } else {
                logger.warn(`${data.details} reached or exceeded max retry (${retryCount})`);
                return;
            }
        } else if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox) this.state = State.WAITING_LEVEL;
        else this.state = State.ERROR;
        // Perform next async tick sooner to speed up error action resolution
        this.tickImmediate();
    }
    reduceLengthAndFlushBuffer(data) {
        // if in appending state
        if (this.state === State.PARSING || this.state === State.PARSED) {
            const playlistType = data.parent;
            const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
            // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
            // reduce max buf len if current position is buffered
            const buffered = bufferedInfo && bufferedInfo.len > 0.5;
            if (buffered) this.reduceMaxBufferLength(bufferedInfo.len);
            const flushBuffer = !buffered;
            if (flushBuffer) // current position is not buffered, but browser is still complaining about buffer full error
            // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
            // in that case flush the whole audio buffer to recover
            this.warn(`Buffer full error while media.currentTime is not buffered, flush ${playlistType} buffer`);
            if (data.frag) {
                this.fragmentTracker.removeFragment(data.frag);
                this.nextLoadPosition = data.frag.start;
            }
            this.resetLoadingState();
            return flushBuffer;
        }
        return false;
    }
    resetFragmentErrors(filterType) {
        if (filterType === PlaylistLevelType.AUDIO) // Reset current fragment since audio track audio is essential and may not have a fail-over track
        this.fragCurrent = null;
        // Fragment errors that result in a level switch or redundant fail-over
        // should reset the stream controller state to idle
        if (!this.loadedmetadata) this.startFragRequested = false;
        if (this.state !== State.STOPPED) this.state = State.IDLE;
    }
    afterBufferFlushed(media, bufferType, playlistType) {
        if (!media) return;
        // After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
        // (so that we will check against video.buffered ranges in case of alt audio track)
        const bufferedTimeRanges = BufferHelper.getBuffered(media);
        this.fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
        if (this.state === State.ENDED) this.resetLoadingState();
    }
    resetLoadingState() {
        this.log('Reset loading state');
        this.fragCurrent = null;
        this.fragPrevious = null;
        this.state = State.IDLE;
    }
    resetStartWhenNotLoaded(level) {
        // if loadedmetadata is not set, it means that first frag request failed
        // in that case, reset startFragRequested flag
        if (!this.loadedmetadata) {
            this.startFragRequested = false;
            const details = level ? level.details : null;
            if (details != null && details.live) {
                // Update the start position and return to IDLE to recover live start
                this.startPosition = -1;
                this.setStartPosition(details, 0);
                this.resetLoadingState();
            } else this.nextLoadPosition = this.startPosition;
        }
    }
    resetWhenMissingContext(chunkMeta) {
        this.warn(`The loading context changed while buffering fragment ${chunkMeta.sn} of level ${chunkMeta.level}. This chunk will not be buffered.`);
        this.removeUnbufferedFrags();
        this.resetStartWhenNotLoaded(this.levelLastLoaded);
        this.resetLoadingState();
    }
    removeUnbufferedFrags(start = 0) {
        this.fragmentTracker.removeFragmentsInRange(start, Infinity, this.playlistType, false, true);
    }
    updateLevelTiming(frag, part, level, partial) {
        var _this$transmuxer;
        const details = level.details;
        if (!details) {
            this.warn('level.details undefined');
            return;
        }
        const parsed = Object.keys(frag.elementaryStreams).reduce((result, type)=>{
            const info = frag.elementaryStreams[type];
            if (info) {
                const parsedDuration = info.endPTS - info.startPTS;
                if (parsedDuration <= 0) {
                    // Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
                    // The new transmuxer will be configured with a time offset matching the next fragment start,
                    // preventing the timeline from shifting.
                    this.warn(`Could not parse fragment ${frag.sn} ${type} duration reliably (${parsedDuration})`);
                    return result || false;
                }
                const drift = partial ? 0 : updateFragPTSDTS(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS);
                this.hls.trigger(Events.LEVEL_PTS_UPDATED, {
                    details,
                    level,
                    drift,
                    type,
                    frag,
                    start: info.startPTS,
                    end: info.endPTS
                });
                return true;
            }
            return result;
        }, false);
        if (!parsed && ((_this$transmuxer = this.transmuxer) == null ? void 0 : _this$transmuxer.error) === null) {
            const error = new Error(`Found no media in fragment ${frag.sn} of level ${frag.level} resetting transmuxer to fallback to playlist timing`);
            if (level.fragmentError === 0) {
                // Mark and track the odd empty segment as a gap to avoid reloading
                level.fragmentError++;
                frag.gap = true;
                this.fragmentTracker.removeFragment(frag);
                this.fragmentTracker.fragBuffered(frag, true);
            }
            this.warn(error.message);
            this.hls.trigger(Events.ERROR, {
                type: ErrorTypes.MEDIA_ERROR,
                details: ErrorDetails.FRAG_PARSING_ERROR,
                fatal: false,
                error,
                frag,
                reason: `Found no media in msn ${frag.sn} of level "${level.url}"`
            });
            if (!this.hls) return;
            this.resetTransmuxer();
        // For this error fallthrough. Marking parsed will allow advancing to next fragment.
        }
        this.state = State.PARSED;
        this.hls.trigger(Events.FRAG_PARSED, {
            frag,
            part
        });
    }
    resetTransmuxer() {
        if (this.transmuxer) {
            this.transmuxer.destroy();
            this.transmuxer = null;
        }
    }
    recoverWorkerError(data) {
        if (data.event === 'demuxerWorker') {
            this.fragmentTracker.removeAllFragments();
            this.resetTransmuxer();
            this.resetStartWhenNotLoaded(this.levelLastLoaded);
            this.resetLoadingState();
        }
    }
    set state(nextState) {
        const previousState = this._state;
        if (previousState !== nextState) {
            this._state = nextState;
            this.log(`${previousState}->${nextState}`);
        }
    }
    get state() {
        return this._state;
    }
}
class ChunkCache {
    constructor(){
        this.chunks = [];
        this.dataLength = 0;
    }
    push(chunk) {
        this.chunks.push(chunk);
        this.dataLength += chunk.length;
    }
    flush() {
        const { chunks, dataLength } = this;
        let result;
        if (!chunks.length) return new Uint8Array(0);
        else if (chunks.length === 1) result = chunks[0];
        else result = concatUint8Arrays(chunks, dataLength);
        this.reset();
        return result;
    }
    reset() {
        this.chunks.length = 0;
        this.dataLength = 0;
    }
}
function concatUint8Arrays(chunks, dataLength) {
    const result = new Uint8Array(dataLength);
    let offset = 0;
    for(let i = 0; i < chunks.length; i++){
        const chunk = chunks[i];
        result.set(chunk, offset);
        offset += chunk.length;
    }
    return result;
}
// ensure the worker ends up in the bundle
// If the worker should not be included this gets aliased to empty.js
function hasUMDWorker() {
    return typeof __HLS_WORKER_BUNDLE__ === 'function';
}
function injectWorker() {
    const blob = new self.Blob([
        `var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`
    ], {
        type: 'text/javascript'
    });
    const objectURL = self.URL.createObjectURL(blob);
    const worker = new self.Worker(objectURL);
    return {
        worker,
        objectURL
    };
}
function loadWorker(path) {
    const scriptURL = new self.URL(path, self.location.href).href;
    const worker = new self.Worker(scriptURL);
    return {
        worker,
        scriptURL
    };
}
function dummyTrack(type = '', inputTimeScale = 90000) {
    return {
        type,
        id: -1,
        pid: -1,
        inputTimeScale,
        sequenceNumber: -1,
        samples: [],
        dropped: 0
    };
}
class BaseAudioDemuxer {
    constructor(){
        this._audioTrack = void 0;
        this._id3Track = void 0;
        this.frameIndex = 0;
        this.cachedData = null;
        this.basePTS = null;
        this.initPTS = null;
        this.lastPTS = null;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        this._id3Track = {
            type: 'id3',
            id: 3,
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            dropped: 0
        };
    }
    resetTimeStamp(deaultTimestamp) {
        this.initPTS = deaultTimestamp;
        this.resetContiguity();
    }
    resetContiguity() {
        this.basePTS = null;
        this.lastPTS = null;
        this.frameIndex = 0;
    }
    canParse(data, offset) {
        return false;
    }
    appendFrame(track, data, offset) {}
    // feed incoming data to the front of the parsing pipeline
    demux(data, timeOffset) {
        if (this.cachedData) {
            data = appendUint8Array(this.cachedData, data);
            this.cachedData = null;
        }
        let id3Data = getID3Data(data, 0);
        let offset = id3Data ? id3Data.length : 0;
        let lastDataIndex;
        const track = this._audioTrack;
        const id3Track = this._id3Track;
        const timestamp = id3Data ? getTimeStamp(id3Data) : undefined;
        const length = data.length;
        if (this.basePTS === null || this.frameIndex === 0 && isFiniteNumber(timestamp)) {
            this.basePTS = initPTSFn(timestamp, timeOffset, this.initPTS);
            this.lastPTS = this.basePTS;
        }
        if (this.lastPTS === null) this.lastPTS = this.basePTS;
        // more expressive than alternative: id3Data?.length
        if (id3Data && id3Data.length > 0) id3Track.samples.push({
            pts: this.lastPTS,
            dts: this.lastPTS,
            data: id3Data,
            type: MetadataSchema.audioId3,
            duration: Number.POSITIVE_INFINITY
        });
        while(offset < length){
            if (this.canParse(data, offset)) {
                const frame = this.appendFrame(track, data, offset);
                if (frame) {
                    this.frameIndex++;
                    this.lastPTS = frame.sample.pts;
                    offset += frame.length;
                    lastDataIndex = offset;
                } else offset = length;
            } else if (canParse$2(data, offset)) {
                // after a ID3.canParse, a call to ID3.getID3Data *should* always returns some data
                id3Data = getID3Data(data, offset);
                id3Track.samples.push({
                    pts: this.lastPTS,
                    dts: this.lastPTS,
                    data: id3Data,
                    type: MetadataSchema.audioId3,
                    duration: Number.POSITIVE_INFINITY
                });
                offset += id3Data.length;
                lastDataIndex = offset;
            } else offset++;
            if (offset === length && lastDataIndex !== length) {
                const partialData = sliceUint8(data, lastDataIndex);
                if (this.cachedData) this.cachedData = appendUint8Array(this.cachedData, partialData);
                else this.cachedData = partialData;
            }
        }
        return {
            audioTrack: track,
            videoTrack: dummyTrack(),
            id3Track,
            textTrack: dummyTrack()
        };
    }
    demuxSampleAes(data, keyData, timeOffset) {
        return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
    }
    flush(timeOffset) {
        // Parse cache in case of remaining frames.
        const cachedData = this.cachedData;
        if (cachedData) {
            this.cachedData = null;
            this.demux(cachedData, 0);
        }
        return {
            audioTrack: this._audioTrack,
            videoTrack: dummyTrack(),
            id3Track: this._id3Track,
            textTrack: dummyTrack()
        };
    }
    destroy() {}
}
/**
 * Initialize PTS
 * <p>
 *    use timestamp unless it is undefined, NaN or Infinity
 * </p>
 */ const initPTSFn = (timestamp, timeOffset, initPTS)=>{
    if (isFiniteNumber(timestamp)) return timestamp * 90;
    const init90kHz = initPTS ? initPTS.baseTime * 90000 / initPTS.timescale : 0;
    return timeOffset * 90000 + init90kHz;
};
/**
 * ADTS parser helper
 * @link https://wiki.multimedia.cx/index.php?title=ADTS
 */ function getAudioConfig(observer, data, offset, audioCodec) {
    let adtsObjectType;
    let adtsExtensionSamplingIndex;
    let adtsChannelConfig;
    let config;
    const userAgent = navigator.userAgent.toLowerCase();
    const manifestCodec = audioCodec;
    const adtsSamplingRates = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    // byte 2
    adtsObjectType = ((data[offset + 2] & 0xc0) >>> 6) + 1;
    const adtsSamplingIndex = (data[offset + 2] & 0x3c) >>> 2;
    if (adtsSamplingIndex > adtsSamplingRates.length - 1) {
        const error = new Error(`invalid ADTS sampling index:${adtsSamplingIndex}`);
        observer.emit(Events.ERROR, Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.FRAG_PARSING_ERROR,
            fatal: true,
            error,
            reason: error.message
        });
        return;
    }
    adtsChannelConfig = (data[offset + 2] & 0x01) << 2;
    // byte 3
    adtsChannelConfig |= (data[offset + 3] & 0xc0) >>> 6;
    logger.log(`manifest codec:${audioCodec}, ADTS type:${adtsObjectType}, samplingIndex:${adtsSamplingIndex}`);
    // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
    if (/firefox/i.test(userAgent)) {
        if (adtsSamplingIndex >= 6) {
            adtsObjectType = 5;
            config = new Array(4);
            // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
            // there is a factor 2 between frame sample rate and output sample rate
            // multiply frequency by 2 (see table below, equivalent to substract 3)
            adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
        } else {
            adtsObjectType = 2;
            config = new Array(2);
            adtsExtensionSamplingIndex = adtsSamplingIndex;
        }
    } else if (userAgent.indexOf('android') !== -1) {
        adtsObjectType = 2;
        config = new Array(2);
        adtsExtensionSamplingIndex = adtsSamplingIndex;
    } else {
        /*  for other browsers (Chrome/Vivaldi/Opera ...)
        always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
    */ adtsObjectType = 5;
        config = new Array(4);
        // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
        if (audioCodec && (audioCodec.indexOf('mp4a.40.29') !== -1 || audioCodec.indexOf('mp4a.40.5') !== -1) || !audioCodec && adtsSamplingIndex >= 6) // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
        // there is a factor 2 between frame sample rate and output sample rate
        // multiply frequency by 2 (see table below, equivalent to substract 3)
        adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
        else {
            // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
            // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
            if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && (adtsSamplingIndex >= 6 && adtsChannelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChannelConfig === 1) {
                adtsObjectType = 2;
                config = new Array(2);
            }
            adtsExtensionSamplingIndex = adtsSamplingIndex;
        }
    }
    /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */ // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    config[0] = adtsObjectType << 3;
    // samplingFrequencyIndex
    config[0] |= (adtsSamplingIndex & 0x0e) >> 1;
    config[1] |= (adtsSamplingIndex & 0x01) << 7;
    // channelConfiguration
    config[1] |= adtsChannelConfig << 3;
    if (adtsObjectType === 5) {
        // adtsExtensionSamplingIndex
        config[1] |= (adtsExtensionSamplingIndex & 0x0e) >> 1;
        config[2] = (adtsExtensionSamplingIndex & 0x01) << 7;
        // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
        //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
        config[2] |= 8;
        config[3] = 0;
    }
    return {
        config,
        samplerate: adtsSamplingRates[adtsSamplingIndex],
        channelCount: adtsChannelConfig,
        codec: 'mp4a.40.' + adtsObjectType,
        manifestCodec
    };
}
function isHeaderPattern$1(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
function getHeaderLength(data, offset) {
    return data[offset + 1] & 0x01 ? 7 : 9;
}
function getFullFrameLength(data, offset) {
    return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xe0) >>> 5;
}
function canGetFrameLength(data, offset) {
    return offset + 5 < data.length;
}
function isHeader$1(data, offset) {
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    return offset + 1 < data.length && isHeaderPattern$1(data, offset);
}
function canParse$1(data, offset) {
    return canGetFrameLength(data, offset) && isHeaderPattern$1(data, offset) && getFullFrameLength(data, offset) <= data.length - offset;
}
function probe$1(data, offset) {
    // same as isHeader but we also check that ADTS frame follows last ADTS frame
    // or end of data is reached
    if (isHeader$1(data, offset)) {
        // ADTS header Length
        const headerLength = getHeaderLength(data, offset);
        if (offset + headerLength >= data.length) return false;
        // ADTS frame Length
        const frameLength = getFullFrameLength(data, offset);
        if (frameLength <= headerLength) return false;
        const newOffset = offset + frameLength;
        return newOffset === data.length || isHeader$1(data, newOffset);
    }
    return false;
}
function initTrackConfig(track, observer, data, offset, audioCodec) {
    if (!track.samplerate) {
        const config = getAudioConfig(observer, data, offset, audioCodec);
        if (!config) return;
        track.config = config.config;
        track.samplerate = config.samplerate;
        track.channelCount = config.channelCount;
        track.codec = config.codec;
        track.manifestCodec = config.manifestCodec;
        logger.log(`parsed codec:${track.codec}, rate:${config.samplerate}, channels:${config.channelCount}`);
    }
}
function getFrameDuration(samplerate) {
    return 92160000 / samplerate;
}
function parseFrameHeader(data, offset) {
    // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
    const headerLength = getHeaderLength(data, offset);
    if (offset + headerLength <= data.length) {
        // retrieve frame size
        const frameLength = getFullFrameLength(data, offset) - headerLength;
        if (frameLength > 0) // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
        return {
            headerLength,
            frameLength
        };
    }
}
function appendFrame$2(track, data, offset, pts, frameIndex) {
    const frameDuration = getFrameDuration(track.samplerate);
    const stamp = pts + frameIndex * frameDuration;
    const header = parseFrameHeader(data, offset);
    let unit;
    if (header) {
        const { frameLength, headerLength } = header;
        const _length = headerLength + frameLength;
        const missing = Math.max(0, offset + _length - data.length);
        // logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
        if (missing) {
            unit = new Uint8Array(_length - headerLength);
            unit.set(data.subarray(offset + headerLength, data.length), 0);
        } else unit = data.subarray(offset + headerLength, offset + _length);
        const _sample = {
            unit,
            pts: stamp
        };
        if (!missing) track.samples.push(_sample);
        return {
            sample: _sample,
            length: _length,
            missing
        };
    }
    // overflow incomplete header
    const length = data.length - offset;
    unit = new Uint8Array(length);
    unit.set(data.subarray(offset, data.length), 0);
    const sample = {
        unit,
        pts: stamp
    };
    return {
        sample,
        length,
        missing: -1
    };
}
/**
 *  MPEG parser helper
 */ let chromeVersion$1 = null;
const BitratesMap = [
    32,
    64,
    96,
    128,
    160,
    192,
    224,
    256,
    288,
    320,
    352,
    384,
    416,
    448,
    32,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    256,
    320,
    384,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    256,
    320,
    32,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    144,
    160,
    176,
    192,
    224,
    256,
    8,
    16,
    24,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    144,
    160
];
const SamplingRateMap = [
    44100,
    48000,
    32000,
    22050,
    24000,
    16000,
    11025,
    12000,
    8000
];
const SamplesCoefficients = [
    // MPEG 2.5
    [
        0,
        // Reserved
        72,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ],
    // Reserved
    [
        0,
        // Reserved
        0,
        // Layer3
        0,
        // Layer2
        0 // Layer1
    ],
    // MPEG 2
    [
        0,
        // Reserved
        72,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ],
    // MPEG 1
    [
        0,
        // Reserved
        144,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ]
];
const BytesInSlot = [
    0,
    // Reserved
    1,
    // Layer3
    1,
    // Layer2
    4 // Layer1
];
function appendFrame$1(track, data, offset, pts, frameIndex) {
    // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
    if (offset + 24 > data.length) return;
    const header = parseHeader(data, offset);
    if (header && offset + header.frameLength <= data.length) {
        const frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
        const stamp = pts + frameIndex * frameDuration;
        const sample = {
            unit: data.subarray(offset, offset + header.frameLength),
            pts: stamp,
            dts: stamp
        };
        track.config = [];
        track.channelCount = header.channelCount;
        track.samplerate = header.sampleRate;
        track.samples.push(sample);
        return {
            sample,
            length: header.frameLength,
            missing: 0
        };
    }
}
function parseHeader(data, offset) {
    const mpegVersion = data[offset + 1] >> 3 & 3;
    const mpegLayer = data[offset + 1] >> 1 & 3;
    const bitRateIndex = data[offset + 2] >> 4 & 15;
    const sampleRateIndex = data[offset + 2] >> 2 & 3;
    if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
        const paddingBit = data[offset + 2] >> 1 & 1;
        const channelMode = data[offset + 3] >> 6;
        const columnInBitrates = mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4;
        const bitRate = BitratesMap[columnInBitrates * 14 + bitRateIndex - 1] * 1000;
        const columnInSampleRates = mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2;
        const sampleRate = SamplingRateMap[columnInSampleRates * 3 + sampleRateIndex];
        const channelCount = channelMode === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
        const sampleCoefficient = SamplesCoefficients[mpegVersion][mpegLayer];
        const bytesInSlot = BytesInSlot[mpegLayer];
        const samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
        const frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
        if (chromeVersion$1 === null) {
            const userAgent = navigator.userAgent || '';
            const result = userAgent.match(/Chrome\/(\d+)/i);
            chromeVersion$1 = result ? parseInt(result[1]) : 0;
        }
        const needChromeFix = !!chromeVersion$1 && chromeVersion$1 <= 87;
        if (needChromeFix && mpegLayer === 2 && bitRate >= 224000 && channelMode === 0) // Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
        data[offset + 3] = data[offset + 3] | 0x80;
        return {
            sampleRate,
            channelCount,
            frameLength,
            samplesPerFrame
        };
    }
}
function isHeaderPattern(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
}
function isHeader(data, offset) {
    // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
    // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
    // More info http://www.mp3-tech.org/programmer/frame_header.html
    return offset + 1 < data.length && isHeaderPattern(data, offset);
}
function canParse(data, offset) {
    const headerSize = 4;
    return isHeaderPattern(data, offset) && headerSize <= data.length - offset;
}
function probe(data, offset) {
    // same as isHeader but we also check that MPEG frame follows last MPEG frame
    // or end of data is reached
    if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
        // MPEG header Length
        const headerLength = 4;
        // MPEG frame Length
        const header = parseHeader(data, offset);
        let frameLength = headerLength;
        if (header != null && header.frameLength) frameLength = header.frameLength;
        const newOffset = offset + frameLength;
        return newOffset === data.length || isHeader(data, newOffset);
    }
    return false;
}
/**
 * AAC demuxer
 */ class AACDemuxer extends BaseAudioDemuxer {
    constructor(observer, config){
        super();
        this.observer = void 0;
        this.config = void 0;
        this.observer = observer;
        this.config = config;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: 'audio/adts',
            type: 'audio',
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: 'aac',
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
    static probe(data) {
        if (!data) return false;
        // Check for the ADTS sync word
        // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
        // Layer bits (position 14 and 15) in header should be always 0 for ADTS
        // More info https://wiki.multimedia.cx/index.php?title=ADTS
        const id3Data = getID3Data(data, 0);
        let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
        if (probe(data, offset)) return false;
        for(let length = data.length; offset < length; offset++)if (probe$1(data, offset)) {
            logger.log('ADTS sync word found !');
            return true;
        }
        return false;
    }
    canParse(data, offset) {
        return canParse$1(data, offset);
    }
    appendFrame(track, data, offset) {
        initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
        const frame = appendFrame$2(track, data, offset, this.basePTS, this.frameIndex);
        if (frame && frame.missing === 0) return frame;
    }
}
const emsgSchemePattern = /\/emsg[-/]ID3/i;
class MP4Demuxer {
    constructor(observer, config){
        this.remainderData = null;
        this.timeOffset = 0;
        this.config = void 0;
        this.videoTrack = void 0;
        this.audioTrack = void 0;
        this.id3Track = void 0;
        this.txtTrack = void 0;
        this.config = config;
    }
    resetTimeStamp() {}
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        const videoTrack = this.videoTrack = dummyTrack('video', 1);
        const audioTrack = this.audioTrack = dummyTrack('audio', 1);
        const captionTrack = this.txtTrack = dummyTrack('text', 1);
        this.id3Track = dummyTrack('id3', 1);
        this.timeOffset = 0;
        if (!(initSegment != null && initSegment.byteLength)) return;
        const initData = parseInitSegment(initSegment);
        if (initData.video) {
            const { id, timescale, codec } = initData.video;
            videoTrack.id = id;
            videoTrack.timescale = captionTrack.timescale = timescale;
            videoTrack.codec = codec;
        }
        if (initData.audio) {
            const { id, timescale, codec } = initData.audio;
            audioTrack.id = id;
            audioTrack.timescale = timescale;
            audioTrack.codec = codec;
        }
        captionTrack.id = RemuxerTrackIdConfig.text;
        videoTrack.sampleDuration = 0;
        videoTrack.duration = audioTrack.duration = trackDuration;
    }
    resetContiguity() {
        this.remainderData = null;
    }
    static probe(data) {
        return hasMoofData(data);
    }
    demux(data, timeOffset) {
        this.timeOffset = timeOffset;
        // Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
        let videoSamples = data;
        const videoTrack = this.videoTrack;
        const textTrack = this.txtTrack;
        if (this.config.progressive) {
            // Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
            // This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
            // that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
            if (this.remainderData) videoSamples = appendUint8Array(this.remainderData, data);
            const segmentedData = segmentValidRange(videoSamples);
            this.remainderData = segmentedData.remainder;
            videoTrack.samples = segmentedData.valid || new Uint8Array();
        } else videoTrack.samples = videoSamples;
        const id3Track = this.extractID3Track(videoTrack, timeOffset);
        textTrack.samples = parseSamples(timeOffset, videoTrack);
        return {
            videoTrack,
            audioTrack: this.audioTrack,
            id3Track,
            textTrack: this.txtTrack
        };
    }
    flush() {
        const timeOffset = this.timeOffset;
        const videoTrack = this.videoTrack;
        const textTrack = this.txtTrack;
        videoTrack.samples = this.remainderData || new Uint8Array();
        this.remainderData = null;
        const id3Track = this.extractID3Track(videoTrack, this.timeOffset);
        textTrack.samples = parseSamples(timeOffset, videoTrack);
        return {
            videoTrack,
            audioTrack: dummyTrack(),
            id3Track,
            textTrack: dummyTrack()
        };
    }
    extractID3Track(videoTrack, timeOffset) {
        const id3Track = this.id3Track;
        if (videoTrack.samples.length) {
            const emsgs = findBox(videoTrack.samples, [
                'emsg'
            ]);
            if (emsgs) emsgs.forEach((data)=>{
                const emsgInfo = parseEmsg(data);
                if (emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
                    const pts = isFiniteNumber(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
                    let duration = emsgInfo.eventDuration === 0xffffffff ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
                    // Safari takes anything <= 0.001 seconds and maps it to Infinity
                    if (duration <= 0.001) duration = Number.POSITIVE_INFINITY;
                    const payload = emsgInfo.payload;
                    id3Track.samples.push({
                        data: payload,
                        len: payload.byteLength,
                        dts: pts,
                        pts: pts,
                        type: MetadataSchema.emsg,
                        duration: duration
                    });
                }
            });
        }
        return id3Track;
    }
    demuxSampleAes(data, keyData, timeOffset) {
        return Promise.reject(new Error('The MP4 demuxer does not support SAMPLE-AES decryption'));
    }
    destroy() {}
}
const getAudioBSID = (data, offset)=>{
    // check the bsid to confirm ac-3 | ec-3
    let bsid = 0;
    let numBits = 5;
    offset += numBits;
    const temp = new Uint32Array(1); // unsigned 32 bit for temporary storage
    const mask = new Uint32Array(1); // unsigned 32 bit mask value
    const byte = new Uint8Array(1); // unsigned 8 bit for temporary storage
    while(numBits > 0){
        byte[0] = data[offset];
        // read remaining bits, upto 8 bits at a time
        const bits = Math.min(numBits, 8);
        const shift = 8 - bits;
        mask[0] = 0xff000000 >>> 24 + shift << shift;
        temp[0] = (byte[0] & mask[0]) >> shift;
        bsid = !bsid ? temp[0] : bsid << bits | temp[0];
        offset += 1;
        numBits -= bits;
    }
    return bsid;
};
class AC3Demuxer extends BaseAudioDemuxer {
    constructor(observer){
        super();
        this.observer = void 0;
        this.observer = observer;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: 'audio/ac-3',
            type: 'audio',
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: 'ac3',
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    canParse(data, offset) {
        return offset + 64 < data.length;
    }
    appendFrame(track, data, offset) {
        const frameLength = appendFrame(track, data, offset, this.basePTS, this.frameIndex);
        if (frameLength !== -1) {
            const sample = track.samples[track.samples.length - 1];
            return {
                sample,
                length: frameLength,
                missing: 0
            };
        }
    }
    static probe(data) {
        if (!data) return false;
        const id3Data = getID3Data(data, 0);
        if (!id3Data) return false;
        // look for the ac-3 sync bytes
        const offset = id3Data.length;
        if (data[offset] === 0x0b && data[offset + 1] === 0x77 && getTimeStamp(id3Data) !== undefined && // check the bsid to confirm ac-3
        getAudioBSID(data, offset) < 16) return true;
        return false;
    }
}
function appendFrame(track, data, start, pts, frameIndex) {
    if (start + 8 > data.length) return -1; // not enough bytes left
    if (data[start] !== 0x0b || data[start + 1] !== 0x77) return -1; // invalid magic
    // get sample rate
    const samplingRateCode = data[start + 4] >> 6;
    if (samplingRateCode >= 3) return -1; // invalid sampling rate
    const samplingRateMap = [
        48000,
        44100,
        32000
    ];
    const sampleRate = samplingRateMap[samplingRateCode];
    // get frame size
    const frameSizeCode = data[start + 4] & 0x3f;
    const frameSizeMap = [
        64,
        69,
        96,
        64,
        70,
        96,
        80,
        87,
        120,
        80,
        88,
        120,
        96,
        104,
        144,
        96,
        105,
        144,
        112,
        121,
        168,
        112,
        122,
        168,
        128,
        139,
        192,
        128,
        140,
        192,
        160,
        174,
        240,
        160,
        175,
        240,
        192,
        208,
        288,
        192,
        209,
        288,
        224,
        243,
        336,
        224,
        244,
        336,
        256,
        278,
        384,
        256,
        279,
        384,
        320,
        348,
        480,
        320,
        349,
        480,
        384,
        417,
        576,
        384,
        418,
        576,
        448,
        487,
        672,
        448,
        488,
        672,
        512,
        557,
        768,
        512,
        558,
        768,
        640,
        696,
        960,
        640,
        697,
        960,
        768,
        835,
        1152,
        768,
        836,
        1152,
        896,
        975,
        1344,
        896,
        976,
        1344,
        1024,
        1114,
        1536,
        1024,
        1115,
        1536,
        1152,
        1253,
        1728,
        1152,
        1254,
        1728,
        1280,
        1393,
        1920,
        1280,
        1394,
        1920
    ];
    const frameLength = frameSizeMap[frameSizeCode * 3 + samplingRateCode] * 2;
    if (start + frameLength > data.length) return -1;
    // get channel count
    const channelMode = data[start + 6] >> 5;
    let skipCount = 0;
    if (channelMode === 2) skipCount += 2;
    else {
        if (channelMode & 1 && channelMode !== 1) skipCount += 2;
        if (channelMode & 4) skipCount += 2;
    }
    const lfeon = (data[start + 6] << 8 | data[start + 7]) >> 12 - skipCount & 1;
    const channelsMap = [
        2,
        1,
        2,
        3,
        3,
        4,
        4,
        5
    ];
    const channelCount = channelsMap[channelMode] + lfeon;
    // build dac3 box
    const bsid = data[start + 5] >> 3;
    const bsmod = data[start + 5] & 7;
    const config = new Uint8Array([
        samplingRateCode << 6 | bsid << 1 | bsmod >> 2,
        (bsmod & 3) << 6 | channelMode << 3 | lfeon << 2 | frameSizeCode >> 4,
        frameSizeCode << 4 & 0xe0
    ]);
    const frameDuration = 1536 / sampleRate * 90000;
    const stamp = pts + frameIndex * frameDuration;
    const unit = data.subarray(start, start + frameLength);
    track.config = config;
    track.channelCount = channelCount;
    track.samplerate = sampleRate;
    track.samples.push({
        unit,
        pts: stamp
    });
    return frameLength;
}
class BaseVideoParser {
    constructor(){
        this.VideoSample = null;
    }
    createVideoSample(key, pts, dts, debug) {
        return {
            key,
            frame: false,
            pts,
            dts,
            units: [],
            debug,
            length: 0
        };
    }
    getLastNalUnit(samples) {
        var _VideoSample;
        let VideoSample = this.VideoSample;
        let lastUnit;
        // try to fallback to previous sample if current one is empty
        if (!VideoSample || VideoSample.units.length === 0) VideoSample = samples[samples.length - 1];
        if ((_VideoSample = VideoSample) != null && _VideoSample.units) {
            const units = VideoSample.units;
            lastUnit = units[units.length - 1];
        }
        return lastUnit;
    }
    pushAccessUnit(VideoSample, videoTrack) {
        if (VideoSample.units.length && VideoSample.frame) {
            // if sample does not have PTS/DTS, patch with last sample PTS/DTS
            if (VideoSample.pts === undefined) {
                const samples = videoTrack.samples;
                const nbSamples = samples.length;
                if (nbSamples) {
                    const lastSample = samples[nbSamples - 1];
                    VideoSample.pts = lastSample.pts;
                    VideoSample.dts = lastSample.dts;
                } else {
                    // dropping samples, no timestamp found
                    videoTrack.dropped++;
                    return;
                }
            }
            videoTrack.samples.push(VideoSample);
        }
        if (VideoSample.debug.length) logger.log(VideoSample.pts + '/' + VideoSample.dts + ':' + VideoSample.debug);
    }
}
/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
 */ class ExpGolomb {
    constructor(data){
        this.data = void 0;
        this.bytesAvailable = void 0;
        this.word = void 0;
        this.bitsAvailable = void 0;
        this.data = data;
        // the number of bytes left to examine in this.data
        this.bytesAvailable = data.byteLength;
        // the current word being examined
        this.word = 0; // :uint
        // the number of bits left to examine in the current word
        this.bitsAvailable = 0; // :uint
    }
    // ():void
    loadWord() {
        const data = this.data;
        const bytesAvailable = this.bytesAvailable;
        const position = data.byteLength - bytesAvailable;
        const workingBytes = new Uint8Array(4);
        const availableBytes = Math.min(4, bytesAvailable);
        if (availableBytes === 0) throw new Error('no bytes available');
        workingBytes.set(data.subarray(position, position + availableBytes));
        this.word = new DataView(workingBytes.buffer).getUint32(0);
        // track the amount of this.data that has been processed
        this.bitsAvailable = availableBytes * 8;
        this.bytesAvailable -= availableBytes;
    }
    // (count:int):void
    skipBits(count) {
        let skipBytes; // :int
        count = Math.min(count, this.bytesAvailable * 8 + this.bitsAvailable);
        if (this.bitsAvailable > count) {
            this.word <<= count;
            this.bitsAvailable -= count;
        } else {
            count -= this.bitsAvailable;
            skipBytes = count >> 3;
            count -= skipBytes << 3;
            this.bytesAvailable -= skipBytes;
            this.loadWord();
            this.word <<= count;
            this.bitsAvailable -= count;
        }
    }
    // (size:int):uint
    readBits(size) {
        let bits = Math.min(this.bitsAvailable, size); // :uint
        const valu = this.word >>> 32 - bits; // :uint
        if (size > 32) logger.error('Cannot read more than 32 bits at a time');
        this.bitsAvailable -= bits;
        if (this.bitsAvailable > 0) this.word <<= bits;
        else if (this.bytesAvailable > 0) this.loadWord();
        else throw new Error('no bits available');
        bits = size - bits;
        if (bits > 0 && this.bitsAvailable) return valu << bits | this.readBits(bits);
        else return valu;
    }
    // ():uint
    skipLZ() {
        let leadingZeroCount; // :uint
        for(leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount)if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
            // the first bit of working word is 1
            this.word <<= leadingZeroCount;
            this.bitsAvailable -= leadingZeroCount;
            return leadingZeroCount;
        }
        // we exhausted word and still have not found a 1
        this.loadWord();
        return leadingZeroCount + this.skipLZ();
    }
    // ():void
    skipUEG() {
        this.skipBits(1 + this.skipLZ());
    }
    // ():void
    skipEG() {
        this.skipBits(1 + this.skipLZ());
    }
    // ():uint
    readUEG() {
        const clz = this.skipLZ(); // :uint
        return this.readBits(clz + 1) - 1;
    }
    // ():int
    readEG() {
        const valu = this.readUEG(); // :int
        if (0x01 & valu) // the number is odd if the low order bit is set
        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
        else return -1 * (valu >>> 1); // divide by two then make it negative
    }
    // Some convenience functions
    // :Boolean
    readBoolean() {
        return this.readBits(1) === 1;
    }
    // ():int
    readUByte() {
        return this.readBits(8);
    }
    // ():int
    readUShort() {
        return this.readBits(16);
    }
    // ():int
    readUInt() {
        return this.readBits(32);
    }
    /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */ skipScalingList(count) {
        let lastScale = 8;
        let nextScale = 8;
        let deltaScale;
        for(let j = 0; j < count; j++){
            if (nextScale !== 0) {
                deltaScale = this.readEG();
                nextScale = (lastScale + deltaScale + 256) % 256;
            }
            lastScale = nextScale === 0 ? lastScale : nextScale;
        }
    }
    /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */ readSPS() {
        let frameCropLeftOffset = 0;
        let frameCropRightOffset = 0;
        let frameCropTopOffset = 0;
        let frameCropBottomOffset = 0;
        let numRefFramesInPicOrderCntCycle;
        let scalingListCount;
        let i;
        const readUByte = this.readUByte.bind(this);
        const readBits = this.readBits.bind(this);
        const readUEG = this.readUEG.bind(this);
        const readBoolean = this.readBoolean.bind(this);
        const skipBits = this.skipBits.bind(this);
        const skipEG = this.skipEG.bind(this);
        const skipUEG = this.skipUEG.bind(this);
        const skipScalingList = this.skipScalingList.bind(this);
        readUByte();
        const profileIdc = readUByte(); // profile_idc
        readBits(5); // profileCompat constraint_set[0-4]_flag, u(5)
        skipBits(3); // reserved_zero_3bits u(3),
        readUByte(); // level_idc u(8)
        skipUEG(); // seq_parameter_set_id
        // some profiles have more optional data we don't need
        if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
            const chromaFormatIdc = readUEG();
            if (chromaFormatIdc === 3) skipBits(1);
             // separate_colour_plane_flag
            skipUEG(); // bit_depth_luma_minus8
            skipUEG(); // bit_depth_chroma_minus8
            skipBits(1); // qpprime_y_zero_transform_bypass_flag
            if (readBoolean()) {
                // seq_scaling_matrix_present_flag
                scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
                for(i = 0; i < scalingListCount; i++)if (readBoolean()) {
                    // seq_scaling_list_present_flag[ i ]
                    if (i < 6) skipScalingList(16);
                    else skipScalingList(64);
                }
            }
        }
        skipUEG(); // log2_max_frame_num_minus4
        const picOrderCntType = readUEG();
        if (picOrderCntType === 0) readUEG(); // log2_max_pic_order_cnt_lsb_minus4
        else if (picOrderCntType === 1) {
            skipBits(1); // delta_pic_order_always_zero_flag
            skipEG(); // offset_for_non_ref_pic
            skipEG(); // offset_for_top_to_bottom_field
            numRefFramesInPicOrderCntCycle = readUEG();
            for(i = 0; i < numRefFramesInPicOrderCntCycle; i++)skipEG();
             // offset_for_ref_frame[ i ]
        }
        skipUEG(); // max_num_ref_frames
        skipBits(1); // gaps_in_frame_num_value_allowed_flag
        const picWidthInMbsMinus1 = readUEG();
        const picHeightInMapUnitsMinus1 = readUEG();
        const frameMbsOnlyFlag = readBits(1);
        if (frameMbsOnlyFlag === 0) skipBits(1);
         // mb_adaptive_frame_field_flag
        skipBits(1); // direct_8x8_inference_flag
        if (readBoolean()) {
            // frame_cropping_flag
            frameCropLeftOffset = readUEG();
            frameCropRightOffset = readUEG();
            frameCropTopOffset = readUEG();
            frameCropBottomOffset = readUEG();
        }
        let pixelRatio = [
            1,
            1
        ];
        if (readBoolean()) // vui_parameters_present_flag
        {
            if (readBoolean()) {
                // aspect_ratio_info_present_flag
                const aspectRatioIdc = readUByte();
                switch(aspectRatioIdc){
                    case 1:
                        pixelRatio = [
                            1,
                            1
                        ];
                        break;
                    case 2:
                        pixelRatio = [
                            12,
                            11
                        ];
                        break;
                    case 3:
                        pixelRatio = [
                            10,
                            11
                        ];
                        break;
                    case 4:
                        pixelRatio = [
                            16,
                            11
                        ];
                        break;
                    case 5:
                        pixelRatio = [
                            40,
                            33
                        ];
                        break;
                    case 6:
                        pixelRatio = [
                            24,
                            11
                        ];
                        break;
                    case 7:
                        pixelRatio = [
                            20,
                            11
                        ];
                        break;
                    case 8:
                        pixelRatio = [
                            32,
                            11
                        ];
                        break;
                    case 9:
                        pixelRatio = [
                            80,
                            33
                        ];
                        break;
                    case 10:
                        pixelRatio = [
                            18,
                            11
                        ];
                        break;
                    case 11:
                        pixelRatio = [
                            15,
                            11
                        ];
                        break;
                    case 12:
                        pixelRatio = [
                            64,
                            33
                        ];
                        break;
                    case 13:
                        pixelRatio = [
                            160,
                            99
                        ];
                        break;
                    case 14:
                        pixelRatio = [
                            4,
                            3
                        ];
                        break;
                    case 15:
                        pixelRatio = [
                            3,
                            2
                        ];
                        break;
                    case 16:
                        pixelRatio = [
                            2,
                            1
                        ];
                        break;
                    case 255:
                        pixelRatio = [
                            readUByte() << 8 | readUByte(),
                            readUByte() << 8 | readUByte()
                        ];
                        break;
                }
            }
        }
        return {
            width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
            height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
            pixelRatio: pixelRatio
        };
    }
    readSliceType() {
        // skip NALu type
        this.readUByte();
        // discard first_mb_in_slice
        this.readUEG();
        // return slice_type
        return this.readUEG();
    }
}
class AvcVideoParser extends BaseVideoParser {
    parseAVCPES(track, textTrack, pes, last, duration) {
        const units = this.parseAVCNALu(track, pes.data);
        let VideoSample = this.VideoSample;
        let push;
        let spsfound = false;
        // free pes.data to save up some memory
        pes.data = null;
        // if new NAL units found and last sample still there, let's push ...
        // this helps parsing streams with missing AUD (only do this if AUD never found)
        if (VideoSample && units.length && !track.audFound) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts, '');
        }
        units.forEach((unit)=>{
            var _VideoSample2;
            switch(unit.type){
                // NDR
                case 1:
                    {
                        let iskey = false;
                        push = true;
                        const data = unit.data;
                        // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
                        if (spsfound && data.length > 4) {
                            // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
                            const sliceType = new ExpGolomb(data).readSliceType();
                            // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
                            // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
                            // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
                            // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
                            // if (sliceType === 2 || sliceType === 7) {
                            if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) iskey = true;
                        }
                        if (iskey) {
                            var _VideoSample;
                            // if we have non-keyframe data already, that cannot belong to the same frame as a keyframe, so force a push
                            if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
                                this.pushAccessUnit(VideoSample, track);
                                VideoSample = this.VideoSample = null;
                            }
                        }
                        if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts, '');
                        VideoSample.frame = true;
                        VideoSample.key = iskey;
                        break;
                    // IDR
                    }
                case 5:
                    push = true;
                    // handle PES not starting with AUD
                    // if we have frame data already, that cannot belong to the same frame, so force a push
                    if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
                        this.pushAccessUnit(VideoSample, track);
                        VideoSample = this.VideoSample = null;
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts, '');
                    VideoSample.key = true;
                    VideoSample.frame = true;
                    break;
                // SEI
                case 6:
                    push = true;
                    parseSEIMessageFromNALu(unit.data, 1, pes.pts, textTrack.samples);
                    break;
                case 7:
                    {
                        var _track$pixelRatio, _track$pixelRatio2;
                        push = true;
                        spsfound = true;
                        const sps = unit.data;
                        const expGolombDecoder = new ExpGolomb(sps);
                        const config = expGolombDecoder.readSPS();
                        if (!track.sps || track.width !== config.width || track.height !== config.height || ((_track$pixelRatio = track.pixelRatio) == null ? void 0 : _track$pixelRatio[0]) !== config.pixelRatio[0] || ((_track$pixelRatio2 = track.pixelRatio) == null ? void 0 : _track$pixelRatio2[1]) !== config.pixelRatio[1]) {
                            track.width = config.width;
                            track.height = config.height;
                            track.pixelRatio = config.pixelRatio;
                            track.sps = [
                                sps
                            ];
                            track.duration = duration;
                            const codecarray = sps.subarray(1, 4);
                            let codecstring = 'avc1.';
                            for(let i = 0; i < 3; i++){
                                let h = codecarray[i].toString(16);
                                if (h.length < 2) h = '0' + h;
                                codecstring += h;
                            }
                            track.codec = codecstring;
                        }
                        break;
                    }
                // PPS
                case 8:
                    push = true;
                    track.pps = [
                        unit.data
                    ];
                    break;
                // AUD
                case 9:
                    push = true;
                    track.audFound = true;
                    if (VideoSample) this.pushAccessUnit(VideoSample, track);
                    VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts, '');
                    break;
                // Filler Data
                case 12:
                    push = true;
                    break;
                default:
                    push = false;
                    if (VideoSample) VideoSample.debug += 'unknown NAL ' + unit.type + ' ';
                    break;
            }
            if (VideoSample && push) {
                const units = VideoSample.units;
                units.push(unit);
            }
        });
        // if last PES packet, push samples
        if (last && VideoSample) {
            this.pushAccessUnit(VideoSample, track);
            this.VideoSample = null;
        }
    }
    parseAVCNALu(track, array) {
        const len = array.byteLength;
        let state = track.naluState || 0;
        const lastState = state;
        const units = [];
        let i = 0;
        let value;
        let overflow;
        let unitType;
        let lastUnitStart = -1;
        let lastUnitType = 0;
        // logger.log('PES:' + Hex.hexDump(array));
        if (state === -1) {
            // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
            lastUnitStart = 0;
            // NALu type is value read from offset 0
            lastUnitType = array[0] & 0x1f;
            state = 0;
            i = 1;
        }
        while(i < len){
            value = array[i++];
            // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
            if (!state) {
                state = value ? 0 : 1;
                continue;
            }
            if (state === 1) {
                state = value ? 0 : 2;
                continue;
            }
            // here we have state either equal to 2 or 3
            if (!value) state = 3;
            else if (value === 1) {
                overflow = i - state - 1;
                if (lastUnitStart >= 0) {
                    const unit = {
                        data: array.subarray(lastUnitStart, overflow),
                        type: lastUnitType
                    };
                    // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
                    units.push(unit);
                } else {
                    // lastUnitStart is undefined => this is the first start code found in this PES packet
                    // first check if start code delimiter is overlapping between 2 PES packets,
                    // ie it started in last packet (lastState not zero)
                    // and ended at the beginning of this PES packet (i <= 4 - lastState)
                    const lastUnit = this.getLastNalUnit(track.samples);
                    if (lastUnit) {
                        if (lastState && i <= 4 - lastState) // start delimiter overlapping between PES packets
                        // strip start delimiter bytes from the end of last NAL unit
                        // check if lastUnit had a state different from zero
                        {
                            if (lastUnit.state) // strip last bytes
                            lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                        }
                        // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
                        if (overflow > 0) {
                            // logger.log('first NALU found with overflow:' + overflow);
                            lastUnit.data = appendUint8Array(lastUnit.data, array.subarray(0, overflow));
                            lastUnit.state = 0;
                        }
                    }
                }
                // check if we can read unit type
                if (i < len) {
                    unitType = array[i] & 0x1f;
                    // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
                    lastUnitStart = i;
                    lastUnitType = unitType;
                    state = 0;
                } else // not enough byte to read unit type. let's read it on next PES parsing
                state = -1;
            } else state = 0;
        }
        if (lastUnitStart >= 0 && state >= 0) {
            const unit = {
                data: array.subarray(lastUnitStart, len),
                type: lastUnitType,
                state: state
            };
            units.push(unit);
        // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
        }
        // no NALu found
        if (units.length === 0) {
            // append pes.data to previous NAL unit
            const lastUnit = this.getLastNalUnit(track.samples);
            if (lastUnit) lastUnit.data = appendUint8Array(lastUnit.data, array);
        }
        track.naluState = state;
        return units;
    }
}
/**
 * SAMPLE-AES decrypter
 */ class SampleAesDecrypter {
    constructor(observer, config, keyData){
        this.keyData = void 0;
        this.decrypter = void 0;
        this.keyData = keyData;
        this.decrypter = new Decrypter(config, {
            removePKCS7Padding: false
        });
    }
    decryptBuffer(encryptedData) {
        return this.decrypter.decrypt(encryptedData, this.keyData.key.buffer, this.keyData.iv.buffer);
    }
    // AAC - encrypt all full 16 bytes blocks starting from offset 16
    decryptAacSample(samples, sampleIndex, callback) {
        const curUnit = samples[sampleIndex].unit;
        if (curUnit.length <= 16) // No encrypted portion in this sample (first 16 bytes is not
        // encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
        return;
        const encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
        const encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
        this.decryptBuffer(encryptedBuffer).then((decryptedBuffer)=>{
            const decryptedData = new Uint8Array(decryptedBuffer);
            curUnit.set(decryptedData, 16);
            if (!this.decrypter.isSync()) this.decryptAacSamples(samples, sampleIndex + 1, callback);
        });
    }
    decryptAacSamples(samples, sampleIndex, callback) {
        for(;; sampleIndex++){
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            if (samples[sampleIndex].unit.length < 32) continue;
            this.decryptAacSample(samples, sampleIndex, callback);
            if (!this.decrypter.isSync()) return;
        }
    }
    // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
    getAvcEncryptedData(decodedData) {
        const encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
        const encryptedData = new Int8Array(encryptedDataLen);
        let outputPos = 0;
        for(let inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16)encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
        return encryptedData;
    }
    getAvcDecryptedUnit(decodedData, decryptedData) {
        const uint8DecryptedData = new Uint8Array(decryptedData);
        let inputPos = 0;
        for(let outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16)decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
        return decodedData;
    }
    decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit) {
        const decodedData = discardEPB(curUnit.data);
        const encryptedData = this.getAvcEncryptedData(decodedData);
        this.decryptBuffer(encryptedData.buffer).then((decryptedBuffer)=>{
            curUnit.data = this.getAvcDecryptedUnit(decodedData, decryptedBuffer);
            if (!this.decrypter.isSync()) this.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
        });
    }
    decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
        if (samples instanceof Uint8Array) throw new Error('Cannot decrypt samples of type Uint8Array');
        for(;; sampleIndex++, unitIndex = 0){
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            const curUnits = samples[sampleIndex].units;
            for(;; unitIndex++){
                if (unitIndex >= curUnits.length) break;
                const curUnit = curUnits[unitIndex];
                if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) continue;
                this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit);
                if (!this.decrypter.isSync()) return;
            }
        }
    }
}
const PACKET_LENGTH = 188;
class TSDemuxer {
    constructor(observer, config, typeSupported){
        this.observer = void 0;
        this.config = void 0;
        this.typeSupported = void 0;
        this.sampleAes = null;
        this.pmtParsed = false;
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this._duration = 0;
        this._pmtId = -1;
        this._videoTrack = void 0;
        this._audioTrack = void 0;
        this._id3Track = void 0;
        this._txtTrack = void 0;
        this.aacOverFlow = null;
        this.remainderData = null;
        this.videoParser = void 0;
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        this.videoParser = new AvcVideoParser();
    }
    static probe(data) {
        const syncOffset = TSDemuxer.syncOffset(data);
        if (syncOffset > 0) logger.warn(`MPEG2-TS detected but first sync word found @ offset ${syncOffset}`);
        return syncOffset !== -1;
    }
    static syncOffset(data) {
        const length = data.length;
        let scanwindow = Math.min(PACKET_LENGTH * 5, length - PACKET_LENGTH) + 1;
        let i = 0;
        while(i < scanwindow){
            // a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
            let foundPat = false;
            let packetStart = -1;
            let tsPackets = 0;
            for(let j = i; j < length; j += PACKET_LENGTH){
                if (data[j] === 0x47 && (length - j === PACKET_LENGTH || data[j + PACKET_LENGTH] === 0x47)) {
                    tsPackets++;
                    if (packetStart === -1) {
                        packetStart = j;
                        // First sync word found at offset, increase scan length (#5251)
                        if (packetStart !== 0) scanwindow = Math.min(packetStart + PACKET_LENGTH * 99, data.length - PACKET_LENGTH) + 1;
                    }
                    if (!foundPat) foundPat = parsePID(data, j) === 0;
                    // Sync word found at 0 with 3 packets, or found at offset least 2 packets up to scanwindow (#5501)
                    if (foundPat && tsPackets > 1 && (packetStart === 0 && tsPackets > 2 || j + PACKET_LENGTH > scanwindow)) return packetStart;
                } else if (tsPackets) // Exit if sync word found, but does not contain contiguous packets
                return -1;
                else break;
            }
            i++;
        }
        return -1;
    }
    /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */ static createTrack(type, duration) {
        return {
            container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
            type,
            id: RemuxerTrackIdConfig[type],
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            dropped: 0,
            duration: type === 'audio' ? duration : undefined
        };
    }
    /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */ resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        this.pmtParsed = false;
        this._pmtId = -1;
        this._videoTrack = TSDemuxer.createTrack('video');
        this._audioTrack = TSDemuxer.createTrack('audio', trackDuration);
        this._id3Track = TSDemuxer.createTrack('id3');
        this._txtTrack = TSDemuxer.createTrack('text');
        this._audioTrack.segmentCodec = 'aac';
        // flush any partial content
        this.aacOverFlow = null;
        this.remainderData = null;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this._duration = trackDuration;
    }
    resetTimeStamp() {}
    resetContiguity() {
        const { _audioTrack, _videoTrack, _id3Track } = this;
        if (_audioTrack) _audioTrack.pesData = null;
        if (_videoTrack) _videoTrack.pesData = null;
        if (_id3Track) _id3Track.pesData = null;
        this.aacOverFlow = null;
        this.remainderData = null;
    }
    demux(data, timeOffset, isSampleAes = false, flush = false) {
        if (!isSampleAes) this.sampleAes = null;
        let pes;
        const videoTrack = this._videoTrack;
        const audioTrack = this._audioTrack;
        const id3Track = this._id3Track;
        const textTrack = this._txtTrack;
        let videoPid = videoTrack.pid;
        let videoData = videoTrack.pesData;
        let audioPid = audioTrack.pid;
        let id3Pid = id3Track.pid;
        let audioData = audioTrack.pesData;
        let id3Data = id3Track.pesData;
        let unknownPID = null;
        let pmtParsed = this.pmtParsed;
        let pmtId = this._pmtId;
        let len = data.length;
        if (this.remainderData) {
            data = appendUint8Array(this.remainderData, data);
            len = data.length;
            this.remainderData = null;
        }
        if (len < PACKET_LENGTH && !flush) {
            this.remainderData = data;
            return {
                audioTrack,
                videoTrack,
                id3Track,
                textTrack
            };
        }
        const syncOffset = Math.max(0, TSDemuxer.syncOffset(data));
        len -= (len - syncOffset) % PACKET_LENGTH;
        if (len < data.byteLength && !flush) this.remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
        // loop through TS packets
        let tsPacketErrors = 0;
        for(let start = syncOffset; start < len; start += PACKET_LENGTH)if (data[start] === 0x47) {
            const stt = !!(data[start + 1] & 0x40);
            const pid = parsePID(data, start);
            const atf = (data[start + 3] & 0x30) >> 4;
            // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
            let offset;
            if (atf > 1) {
                offset = start + 5 + data[start + 4];
                // continue if there is only adaptation field
                if (offset === start + PACKET_LENGTH) continue;
            } else offset = start + 4;
            switch(pid){
                case videoPid:
                    if (stt) {
                        if (videoData && (pes = parsePES(videoData))) this.videoParser.parseAVCPES(videoTrack, textTrack, pes, false, this._duration);
                        videoData = {
                            data: [],
                            size: 0
                        };
                    }
                    if (videoData) {
                        videoData.data.push(data.subarray(offset, start + PACKET_LENGTH));
                        videoData.size += start + PACKET_LENGTH - offset;
                    }
                    break;
                case audioPid:
                    if (stt) {
                        if (audioData && (pes = parsePES(audioData))) switch(audioTrack.segmentCodec){
                            case 'aac':
                                this.parseAACPES(audioTrack, pes);
                                break;
                            case 'mp3':
                                this.parseMPEGPES(audioTrack, pes);
                                break;
                            case 'ac3':
                                this.parseAC3PES(audioTrack, pes);
                                break;
                        }
                        audioData = {
                            data: [],
                            size: 0
                        };
                    }
                    if (audioData) {
                        audioData.data.push(data.subarray(offset, start + PACKET_LENGTH));
                        audioData.size += start + PACKET_LENGTH - offset;
                    }
                    break;
                case id3Pid:
                    if (stt) {
                        if (id3Data && (pes = parsePES(id3Data))) this.parseID3PES(id3Track, pes);
                        id3Data = {
                            data: [],
                            size: 0
                        };
                    }
                    if (id3Data) {
                        id3Data.data.push(data.subarray(offset, start + PACKET_LENGTH));
                        id3Data.size += start + PACKET_LENGTH - offset;
                    }
                    break;
                case 0:
                    if (stt) offset += data[offset] + 1;
                    pmtId = this._pmtId = parsePAT(data, offset);
                    break;
                case pmtId:
                    {
                        if (stt) offset += data[offset] + 1;
                        const parsedPIDs = parsePMT(data, offset, this.typeSupported, isSampleAes);
                        // only update track id if track PID found while parsing PMT
                        // this is to avoid resetting the PID to -1 in case
                        // track PID transiently disappears from the stream
                        // this could happen in case of transient missing audio samples for example
                        // NOTE this is only the PID of the track as found in TS,
                        // but we are not using this for MP4 track IDs.
                        videoPid = parsedPIDs.videoPid;
                        if (videoPid > 0) {
                            videoTrack.pid = videoPid;
                            videoTrack.segmentCodec = parsedPIDs.segmentVideoCodec;
                        }
                        audioPid = parsedPIDs.audioPid;
                        if (audioPid > 0) {
                            audioTrack.pid = audioPid;
                            audioTrack.segmentCodec = parsedPIDs.segmentAudioCodec;
                        }
                        id3Pid = parsedPIDs.id3Pid;
                        if (id3Pid > 0) id3Track.pid = id3Pid;
                        if (unknownPID !== null && !pmtParsed) {
                            logger.warn(`MPEG-TS PMT found at ${start} after unknown PID '${unknownPID}'. Backtracking to sync byte @${syncOffset} to parse all TS packets.`);
                            unknownPID = null;
                            // we set it to -188, the += 188 in the for loop will reset start to 0
                            start = syncOffset - 188;
                        }
                        pmtParsed = this.pmtParsed = true;
                        break;
                    }
                case 0x11:
                case 0x1fff:
                    break;
                default:
                    unknownPID = pid;
                    break;
            }
        } else tsPacketErrors++;
        if (tsPacketErrors > 0) {
            const error = new Error(`Found ${tsPacketErrors} TS packet/s that do not start with 0x47`);
            this.observer.emit(Events.ERROR, Events.ERROR, {
                type: ErrorTypes.MEDIA_ERROR,
                details: ErrorDetails.FRAG_PARSING_ERROR,
                fatal: false,
                error,
                reason: error.message
            });
        }
        videoTrack.pesData = videoData;
        audioTrack.pesData = audioData;
        id3Track.pesData = id3Data;
        const demuxResult = {
            audioTrack,
            videoTrack,
            id3Track,
            textTrack
        };
        if (flush) this.extractRemainingSamples(demuxResult);
        return demuxResult;
    }
    flush() {
        const { remainderData } = this;
        this.remainderData = null;
        let result;
        if (remainderData) result = this.demux(remainderData, -1, false, true);
        else result = {
            videoTrack: this._videoTrack,
            audioTrack: this._audioTrack,
            id3Track: this._id3Track,
            textTrack: this._txtTrack
        };
        this.extractRemainingSamples(result);
        if (this.sampleAes) return this.decrypt(result, this.sampleAes);
        return result;
    }
    extractRemainingSamples(demuxResult) {
        const { audioTrack, videoTrack, id3Track, textTrack } = demuxResult;
        const videoData = videoTrack.pesData;
        const audioData = audioTrack.pesData;
        const id3Data = id3Track.pesData;
        // try to parse last PES packets
        let pes;
        if (videoData && (pes = parsePES(videoData))) {
            this.videoParser.parseAVCPES(videoTrack, textTrack, pes, true, this._duration);
            videoTrack.pesData = null;
        } else // either avcData null or PES truncated, keep it for next frag parsing
        videoTrack.pesData = videoData;
        if (audioData && (pes = parsePES(audioData))) {
            switch(audioTrack.segmentCodec){
                case 'aac':
                    this.parseAACPES(audioTrack, pes);
                    break;
                case 'mp3':
                    this.parseMPEGPES(audioTrack, pes);
                    break;
                case 'ac3':
                    this.parseAC3PES(audioTrack, pes);
                    break;
            }
            audioTrack.pesData = null;
        } else {
            if (audioData != null && audioData.size) logger.log('last AAC PES packet truncated,might overlap between fragments');
            // either audioData null or PES truncated, keep it for next frag parsing
            audioTrack.pesData = audioData;
        }
        if (id3Data && (pes = parsePES(id3Data))) {
            this.parseID3PES(id3Track, pes);
            id3Track.pesData = null;
        } else // either id3Data null or PES truncated, keep it for next frag parsing
        id3Track.pesData = id3Data;
    }
    demuxSampleAes(data, keyData, timeOffset) {
        const demuxResult = this.demux(data, timeOffset, true, !this.config.progressive);
        const sampleAes = this.sampleAes = new SampleAesDecrypter(this.observer, this.config, keyData);
        return this.decrypt(demuxResult, sampleAes);
    }
    decrypt(demuxResult, sampleAes) {
        return new Promise((resolve)=>{
            const { audioTrack, videoTrack } = demuxResult;
            if (audioTrack.samples && audioTrack.segmentCodec === 'aac') sampleAes.decryptAacSamples(audioTrack.samples, 0, ()=>{
                if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, ()=>{
                    resolve(demuxResult);
                });
                else resolve(demuxResult);
            });
            else if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, ()=>{
                resolve(demuxResult);
            });
        });
    }
    destroy() {
        this._duration = 0;
    }
    parseAACPES(track, pes) {
        let startOffset = 0;
        const aacOverFlow = this.aacOverFlow;
        let data = pes.data;
        if (aacOverFlow) {
            this.aacOverFlow = null;
            const frameMissingBytes = aacOverFlow.missing;
            const sampleLength = aacOverFlow.sample.unit.byteLength;
            // logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
            if (frameMissingBytes === -1) data = appendUint8Array(aacOverFlow.sample.unit, data);
            else {
                const frameOverflowBytes = sampleLength - frameMissingBytes;
                aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
                track.samples.push(aacOverFlow.sample);
                startOffset = aacOverFlow.missing;
            }
        }
        // look for ADTS header (0xFFFx)
        let offset;
        let len;
        for(offset = startOffset, len = data.length; offset < len - 1; offset++){
            if (isHeader$1(data, offset)) break;
        }
        // if ADTS header does not start straight from the beginning of the PES payload, raise an error
        if (offset !== startOffset) {
            let reason;
            const recoverable = offset < len - 1;
            if (recoverable) reason = `AAC PES did not start with ADTS header,offset:${offset}`;
            else reason = 'No ADTS header found in AAC PES';
            const error = new Error(reason);
            logger.warn(`parsing error: ${reason}`);
            this.observer.emit(Events.ERROR, Events.ERROR, {
                type: ErrorTypes.MEDIA_ERROR,
                details: ErrorDetails.FRAG_PARSING_ERROR,
                fatal: false,
                levelRetry: recoverable,
                error,
                reason
            });
            if (!recoverable) return;
        }
        initTrackConfig(track, this.observer, data, offset, this.audioCodec);
        let pts;
        if (pes.pts !== undefined) pts = pes.pts;
        else if (aacOverFlow) {
            // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
            // first sample PTS should be equal to last sample PTS + frameDuration
            const frameDuration = getFrameDuration(track.samplerate);
            pts = aacOverFlow.sample.pts + frameDuration;
        } else {
            logger.warn('[tsdemuxer]: AAC PES unknown PTS');
            return;
        }
        // scan for aac samples
        let frameIndex = 0;
        let frame;
        while(offset < len){
            frame = appendFrame$2(track, data, offset, pts, frameIndex);
            offset += frame.length;
            if (!frame.missing) {
                frameIndex++;
                for(; offset < len - 1; offset++){
                    if (isHeader$1(data, offset)) break;
                }
            } else {
                this.aacOverFlow = frame;
                break;
            }
        }
    }
    parseMPEGPES(track, pes) {
        const data = pes.data;
        const length = data.length;
        let frameIndex = 0;
        let offset = 0;
        const pts = pes.pts;
        if (pts === undefined) {
            logger.warn('[tsdemuxer]: MPEG PES unknown PTS');
            return;
        }
        while(offset < length)if (isHeader(data, offset)) {
            const frame = appendFrame$1(track, data, offset, pts, frameIndex);
            if (frame) {
                offset += frame.length;
                frameIndex++;
            } else break;
        } else // nothing found, keep looking
        offset++;
    }
    parseAC3PES(track, pes) {
        {
            const data = pes.data;
            const pts = pes.pts;
            if (pts === undefined) {
                logger.warn('[tsdemuxer]: AC3 PES unknown PTS');
                return;
            }
            const length = data.length;
            let frameIndex = 0;
            let offset = 0;
            let parsed;
            while(offset < length && (parsed = appendFrame(track, data, offset, pts, frameIndex++)) > 0)offset += parsed;
        }
    }
    parseID3PES(id3Track, pes) {
        if (pes.pts === undefined) {
            logger.warn('[tsdemuxer]: ID3 PES unknown PTS');
            return;
        }
        const id3Sample = _extends({}, pes, {
            type: this._videoTrack ? MetadataSchema.emsg : MetadataSchema.audioId3,
            duration: Number.POSITIVE_INFINITY
        });
        id3Track.samples.push(id3Sample);
    }
}
function parsePID(data, offset) {
    // pid is a 13-bit field starting at the last bit of TS[1]
    return ((data[offset + 1] & 0x1f) << 8) + data[offset + 2];
}
function parsePAT(data, offset) {
    // skip the PSI header and parse the first PMT entry
    return (data[offset + 10] & 0x1f) << 8 | data[offset + 11];
}
function parsePMT(data, offset, typeSupported, isSampleAes) {
    const result = {
        audioPid: -1,
        videoPid: -1,
        id3Pid: -1,
        segmentVideoCodec: 'avc',
        segmentAudioCodec: 'aac'
    };
    const sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
    const tableEnd = offset + 3 + sectionLength - 4;
    // to determine where the table is, we have to figure out how
    // long the program info descriptors are
    const programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
    // advance the offset to the first entry in the mapping table
    offset += 12 + programInfoLength;
    while(offset < tableEnd){
        const pid = parsePID(data, offset);
        const esInfoLength = (data[offset + 3] & 0x0f) << 8 | data[offset + 4];
        switch(data[offset]){
            case 0xcf:
                // SAMPLE-AES AAC
                if (!isSampleAes) {
                    logEncryptedSamplesFoundInUnencryptedStream('ADTS AAC');
                    break;
                }
            /* falls through */ case 0x0f:
                // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
                // logger.log('AAC PID:'  + pid);
                if (result.audioPid === -1) result.audioPid = pid;
                break;
            // Packetized metadata (ID3)
            case 0x15:
                // logger.log('ID3 PID:'  + pid);
                if (result.id3Pid === -1) result.id3Pid = pid;
                break;
            case 0xdb:
                // SAMPLE-AES AVC
                if (!isSampleAes) {
                    logEncryptedSamplesFoundInUnencryptedStream('H.264');
                    break;
                }
            /* falls through */ case 0x1b:
                // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
                // logger.log('AVC PID:'  + pid);
                if (result.videoPid === -1) {
                    result.videoPid = pid;
                    result.segmentVideoCodec = 'avc';
                }
                break;
            // ISO/IEC 11172-3 (MPEG-1 audio)
            // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
            case 0x03:
            case 0x04:
                // logger.log('MPEG PID:'  + pid);
                if (!typeSupported.mpeg && !typeSupported.mp3) logger.log('MPEG audio found, not supported in this browser');
                else if (result.audioPid === -1) {
                    result.audioPid = pid;
                    result.segmentAudioCodec = 'mp3';
                }
                break;
            case 0xc1:
                // SAMPLE-AES AC3
                if (!isSampleAes) {
                    logEncryptedSamplesFoundInUnencryptedStream('AC-3');
                    break;
                }
            /* falls through */ case 0x81:
                if (!typeSupported.ac3) logger.log('AC-3 audio found, not supported in this browser');
                else if (result.audioPid === -1) {
                    result.audioPid = pid;
                    result.segmentAudioCodec = 'ac3';
                }
                break;
            case 0x06:
                // stream_type 6 can mean a lot of different things in case of DVB.
                // We need to look at the descriptors. Right now, we're only interested
                // in AC-3 audio, so we do the descriptor parsing only when we don't have
                // an audio PID yet.
                if (result.audioPid === -1 && esInfoLength > 0) {
                    let parsePos = offset + 5;
                    let remaining = esInfoLength;
                    while(remaining > 2){
                        const descriptorId = data[parsePos];
                        switch(descriptorId){
                            case 0x6a:
                                if (typeSupported.ac3 !== true) logger.log('AC-3 audio found, not supported in this browser for now');
                                else {
                                    result.audioPid = pid;
                                    result.segmentAudioCodec = 'ac3';
                                }
                                break;
                        }
                        const descriptorLen = data[parsePos + 1] + 2;
                        parsePos += descriptorLen;
                        remaining -= descriptorLen;
                    }
                }
                break;
            case 0xc2:
            /* falls through */ case 0x87:
                logger.warn('Unsupported EC-3 in M2TS found');
                break;
            case 0x24:
                logger.warn('Unsupported HEVC in M2TS found');
                break;
        }
        // move to the next table entry
        // skip past the elementary stream descriptors, if present
        offset += esInfoLength + 5;
    }
    return result;
}
function logEncryptedSamplesFoundInUnencryptedStream(type) {
    logger.log(`${type} with AES-128-CBC encryption found in unencrypted stream`);
}
function parsePES(stream) {
    let i = 0;
    let frag;
    let pesLen;
    let pesHdrLen;
    let pesPts;
    let pesDts;
    const data = stream.data;
    // safety check
    if (!stream || stream.size === 0) return null;
    // we might need up to 19 bytes to read PES header
    // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
    // usually only one merge is needed (and this is rare ...)
    while(data[0].length < 19 && data.length > 1){
        data[0] = appendUint8Array(data[0], data[1]);
        data.splice(1, 1);
    }
    // retrieve PTS/DTS from first fragment
    frag = data[0];
    const pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
    if (pesPrefix === 1) {
        pesLen = (frag[4] << 8) + frag[5];
        // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
        // minus 6 : PES header size
        if (pesLen && pesLen > stream.size - 6) return null;
        const pesFlags = frag[7];
        if (pesFlags & 0xc0) {
            /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
          as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
          as Bitwise operators treat their operands as a sequence of 32 bits */ pesPts = (frag[9] & 0x0e) * 536870912 + // 1 << 29
            (frag[10] & 0xff) * 4194304 + // 1 << 22
            (frag[11] & 0xfe) * 16384 + // 1 << 14
            (frag[12] & 0xff) * 128 + // 1 << 7
            (frag[13] & 0xfe) / 2;
            if (pesFlags & 0x40) {
                pesDts = (frag[14] & 0x0e) * 536870912 + // 1 << 29
                (frag[15] & 0xff) * 4194304 + // 1 << 22
                (frag[16] & 0xfe) * 16384 + // 1 << 14
                (frag[17] & 0xff) * 128 + // 1 << 7
                (frag[18] & 0xfe) / 2;
                if (pesPts - pesDts > 5400000) {
                    logger.warn(`${Math.round((pesPts - pesDts) / 90000)}s delta between PTS and DTS, align them`);
                    pesPts = pesDts;
                }
            } else pesDts = pesPts;
        }
        pesHdrLen = frag[8];
        // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
        let payloadStartOffset = pesHdrLen + 9;
        if (stream.size <= payloadStartOffset) return null;
        stream.size -= payloadStartOffset;
        // reassemble PES packet
        const pesData = new Uint8Array(stream.size);
        for(let j = 0, dataLen = data.length; j < dataLen; j++){
            frag = data[j];
            let len = frag.byteLength;
            if (payloadStartOffset) {
                if (payloadStartOffset > len) {
                    // trim full frag if PES header bigger than frag
                    payloadStartOffset -= len;
                    continue;
                } else {
                    // trim partial frag if PES header smaller than frag
                    frag = frag.subarray(payloadStartOffset);
                    len -= payloadStartOffset;
                    payloadStartOffset = 0;
                }
            }
            pesData.set(frag, i);
            i += len;
        }
        if (pesLen) // payload size : remove PES header + PES extension
        pesLen -= pesHdrLen + 3;
        return {
            data: pesData,
            pts: pesPts,
            dts: pesDts,
            len: pesLen
        };
    }
    return null;
}
/**
 * MP3 demuxer
 */ class MP3Demuxer extends BaseAudioDemuxer {
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: 'audio/mpeg',
            type: 'audio',
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: 'mp3',
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    static probe(data) {
        if (!data) return false;
        // check if data contains ID3 timestamp and MPEG sync word
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        const id3Data = getID3Data(data, 0);
        let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
        // Check for ac-3|ec-3 sync bytes and return false if present
        if (id3Data && data[offset] === 0x0b && data[offset + 1] === 0x77 && getTimeStamp(id3Data) !== undefined && // check the bsid to confirm ac-3 or ec-3 (not mp3)
        getAudioBSID(data, offset) <= 16) return false;
        for(let length = data.length; offset < length; offset++)if (probe(data, offset)) {
            logger.log('MPEG Audio sync word found !');
            return true;
        }
        return false;
    }
    canParse(data, offset) {
        return canParse(data, offset);
    }
    appendFrame(track, data, offset) {
        if (this.basePTS === null) return;
        return appendFrame$1(track, data, offset, this.basePTS, this.frameIndex);
    }
}
/**
 *  AAC helper
 */ class AAC {
    static getSilentFrame(codec, channelCount) {
        switch(codec){
            case 'mp4a.40.2':
                if (channelCount === 1) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x23,
                    0x80
                ]);
                else if (channelCount === 2) return new Uint8Array([
                    0x21,
                    0x00,
                    0x49,
                    0x90,
                    0x02,
                    0x19,
                    0x00,
                    0x23,
                    0x80
                ]);
                else if (channelCount === 3) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x8e
                ]);
                else if (channelCount === 4) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x80,
                    0x2c,
                    0x80,
                    0x08,
                    0x02,
                    0x38
                ]);
                else if (channelCount === 5) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x82,
                    0x30,
                    0x04,
                    0x99,
                    0x00,
                    0x21,
                    0x90,
                    0x02,
                    0x38
                ]);
                else if (channelCount === 6) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x82,
                    0x30,
                    0x04,
                    0x99,
                    0x00,
                    0x21,
                    0x90,
                    0x02,
                    0x00,
                    0xb2,
                    0x00,
                    0x20,
                    0x08,
                    0xe0
                ]);
                break;
            // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
            default:
                if (channelCount === 1) // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x4e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x1c,
                    0x6,
                    0xf1,
                    0xc1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                else if (channelCount === 2) // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x5e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x0,
                    0x95,
                    0x0,
                    0x6,
                    0xf1,
                    0xa1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                else if (channelCount === 3) // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x5e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x0,
                    0x95,
                    0x0,
                    0x6,
                    0xf1,
                    0xa1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                break;
        }
        return undefined;
    }
}
/**
 * Generate MP4 Box
 */ const UINT32_MAX = Math.pow(2, 32) - 1;
class MP4 {
    static init() {
        MP4.types = {
            avc1: [],
            // codingname
            avcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            '.mp3': [],
            dac3: [],
            'ac-3': [],
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: [],
            smhd: []
        };
        let i;
        for(i in MP4.types)if (MP4.types.hasOwnProperty(i)) MP4.types[i] = [
            i.charCodeAt(0),
            i.charCodeAt(1),
            i.charCodeAt(2),
            i.charCodeAt(3)
        ];
        const videoHdlr = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x76,
            0x69,
            0x64,
            0x65,
            // handler_type: 'vide'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x56,
            0x69,
            0x64,
            0x65,
            0x6f,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'VideoHandler'
        ]);
        const audioHdlr = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x73,
            0x6f,
            0x75,
            0x6e,
            // handler_type: 'soun'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x53,
            0x6f,
            0x75,
            0x6e,
            0x64,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'SoundHandler'
        ]);
        MP4.HDLR_TYPES = {
            video: videoHdlr,
            audio: audioHdlr
        };
        const dref = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // entry_count
            0x00,
            0x00,
            0x00,
            0x0c,
            // entry_size
            0x75,
            0x72,
            0x6c,
            0x20,
            // 'url' type
            0x00,
            // version 0
            0x00,
            0x00,
            0x01 // entry_flags
        ]);
        const stco = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00 // entry_count
        ]);
        MP4.STTS = MP4.STSC = MP4.STCO = stco;
        MP4.STSZ = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // sample_size
            0x00,
            0x00,
            0x00,
            0x00 // sample_count
        ]);
        MP4.VMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x01,
            // flags
            0x00,
            0x00,
            // graphicsmode
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00 // opcolor
        ]);
        MP4.SMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            // balance
            0x00,
            0x00 // reserved
        ]);
        MP4.STSD = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01
        ]); // entry_count
        const majorBrand = new Uint8Array([
            105,
            115,
            111,
            109
        ]); // isom
        const avc1Brand = new Uint8Array([
            97,
            118,
            99,
            49
        ]); // avc1
        const minorVersion = new Uint8Array([
            0,
            0,
            0,
            1
        ]);
        MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
        MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
    }
    static box(type, ...payload) {
        let size = 8;
        let i = payload.length;
        const len = i;
        // calculate the total size we need to allocate
        while(i--)size += payload[i].byteLength;
        const result = new Uint8Array(size);
        result[0] = size >> 24 & 0xff;
        result[1] = size >> 16 & 0xff;
        result[2] = size >> 8 & 0xff;
        result[3] = size & 0xff;
        result.set(type, 4);
        // copy the payload into the result
        for(i = 0, size = 8; i < len; i++){
            // copy payload[i] array @ offset size
            result.set(payload[i], size);
            size += payload[i].byteLength;
        }
        return result;
    }
    static hdlr(type) {
        return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
    }
    static mdat(data) {
        return MP4.box(MP4.types.mdat, data);
    }
    static mdhd(timescale, duration) {
        duration *= timescale;
        const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
        return MP4.box(MP4.types.mdhd, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            timescale >> 24 & 0xff,
            timescale >> 16 & 0xff,
            timescale >> 8 & 0xff,
            timescale & 0xff,
            // timescale
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x55,
            0xc4,
            // 'und' language (undetermined)
            0x00,
            0x00
        ]));
    }
    static mdia(track) {
        return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
    }
    static mfhd(sequenceNumber) {
        return MP4.box(MP4.types.mfhd, new Uint8Array([
            0x00,
            0x00,
            0x00,
            0x00,
            // flags
            sequenceNumber >> 24,
            sequenceNumber >> 16 & 0xff,
            sequenceNumber >> 8 & 0xff,
            sequenceNumber & 0xff // sequence_number
        ]));
    }
    static minf(track) {
        if (track.type === 'audio') return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
        else return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
    }
    static moof(sn, baseMediaDecodeTime, track) {
        return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
    }
    static moov(tracks) {
        let i = tracks.length;
        const boxes = [];
        while(i--)boxes[i] = MP4.trak(tracks[i]);
        return MP4.box.apply(null, [
            MP4.types.moov,
            MP4.mvhd(tracks[0].timescale, tracks[0].duration)
        ].concat(boxes).concat(MP4.mvex(tracks)));
    }
    static mvex(tracks) {
        let i = tracks.length;
        const boxes = [];
        while(i--)boxes[i] = MP4.trex(tracks[i]);
        return MP4.box.apply(null, [
            MP4.types.mvex,
            ...boxes
        ]);
    }
    static mvhd(timescale, duration) {
        duration *= timescale;
        const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
        const bytes = new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            timescale >> 24 & 0xff,
            timescale >> 16 & 0xff,
            timescale >> 8 & 0xff,
            timescale & 0xff,
            // timescale
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x00,
            0x01,
            0x00,
            0x00,
            // 1.0 rate
            0x01,
            0x00,
            // 1.0 volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0xff,
            0xff,
            0xff,
            0xff // next_track_ID
        ]);
        return MP4.box(MP4.types.mvhd, bytes);
    }
    static sdtp(track) {
        const samples = track.samples || [];
        const bytes = new Uint8Array(4 + samples.length);
        let i;
        let flags;
        // leave the full box header (4 bytes) all zero
        // write the sample table
        for(i = 0; i < samples.length; i++){
            flags = samples[i].flags;
            bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
        }
        return MP4.box(MP4.types.sdtp, bytes);
    }
    static stbl(track) {
        return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
    }
    static avc1(track) {
        let sps = [];
        let pps = [];
        let i;
        let data;
        let len;
        // assemble the SPSs
        for(i = 0; i < track.sps.length; i++){
            data = track.sps[i];
            len = data.byteLength;
            sps.push(len >>> 8 & 0xff);
            sps.push(len & 0xff);
            // SPS
            sps = sps.concat(Array.prototype.slice.call(data));
        }
        // assemble the PPSs
        for(i = 0; i < track.pps.length; i++){
            data = track.pps[i];
            len = data.byteLength;
            pps.push(len >>> 8 & 0xff);
            pps.push(len & 0xff);
            pps = pps.concat(Array.prototype.slice.call(data));
        }
        const avcc = MP4.box(MP4.types.avcC, new Uint8Array([
            0x01,
            // version
            sps[3],
            // profile
            sps[4],
            // profile compat
            sps[5],
            // level
            255,
            // lengthSizeMinusOne, hard-coded to 4 bytes
            0xe0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
        ].concat(sps).concat([
            track.pps.length // numOfPictureParameterSets
        ]).concat(pps))); // "PPS"
        const width = track.width;
        const height = track.height;
        const hSpacing = track.pixelRatio[0];
        const vSpacing = track.pixelRatio[1];
        return MP4.box(MP4.types.avc1, new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            // pre_defined
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            width >> 8 & 0xff,
            width & 0xff,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            // height
            0x00,
            0x48,
            0x00,
            0x00,
            // horizresolution
            0x00,
            0x48,
            0x00,
            0x00,
            // vertresolution
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // frame_count
            0x12,
            0x64,
            0x61,
            0x69,
            0x6c,
            // dailymotion/hls.js
            0x79,
            0x6d,
            0x6f,
            0x74,
            0x69,
            0x6f,
            0x6e,
            0x2f,
            0x68,
            0x6c,
            0x73,
            0x2e,
            0x6a,
            0x73,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // compressorname
            0x00,
            0x18,
            // depth = 24
            0x11,
            0x11
        ]), // pre_defined = -1
        avcc, MP4.box(MP4.types.btrt, new Uint8Array([
            0x00,
            0x1c,
            0x9c,
            0x80,
            // bufferSizeDB
            0x00,
            0x2d,
            0xc6,
            0xc0,
            // maxBitrate
            0x00,
            0x2d,
            0xc6,
            0xc0
        ])), // avgBitrate
        MP4.box(MP4.types.pasp, new Uint8Array([
            hSpacing >> 24,
            // hSpacing
            hSpacing >> 16 & 0xff,
            hSpacing >> 8 & 0xff,
            hSpacing & 0xff,
            vSpacing >> 24,
            // vSpacing
            vSpacing >> 16 & 0xff,
            vSpacing >> 8 & 0xff,
            vSpacing & 0xff
        ])));
    }
    static esds(track) {
        const configlen = track.config.length;
        return new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x03,
            // descriptor_type
            0x17 + configlen,
            // length
            0x00,
            0x01,
            // es_id
            0x00,
            // stream_priority
            0x04,
            // descriptor_type
            0x0f + configlen,
            // length
            0x40,
            // codec : mpeg4_audio
            0x15,
            // stream_type
            0x00,
            0x00,
            0x00,
            // buffer_size
            0x00,
            0x00,
            0x00,
            0x00,
            // maxBitrate
            0x00,
            0x00,
            0x00,
            0x00,
            // avgBitrate
            0x05 // descriptor_type
        ].concat([
            configlen
        ]).concat(track.config).concat([
            0x06,
            0x01,
            0x02
        ])); // GASpecificConfig)); // length + audio config descriptor
    }
    static audioStsd(track) {
        const samplerate = track.samplerate;
        return new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            track.channelCount,
            // channelcount
            0x00,
            0x10,
            // sampleSize:16bits
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved2
            samplerate >> 8 & 0xff,
            samplerate & 0xff,
            //
            0x00,
            0x00
        ]);
    }
    static mp4a(track) {
        return MP4.box(MP4.types.mp4a, MP4.audioStsd(track), MP4.box(MP4.types.esds, MP4.esds(track)));
    }
    static mp3(track) {
        return MP4.box(MP4.types['.mp3'], MP4.audioStsd(track));
    }
    static ac3(track) {
        return MP4.box(MP4.types['ac-3'], MP4.audioStsd(track), MP4.box(MP4.types.dac3, track.config));
    }
    static stsd(track) {
        if (track.type === 'audio') {
            if (track.segmentCodec === 'mp3' && track.codec === 'mp3') return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
            if (track.segmentCodec === 'ac3') return MP4.box(MP4.types.stsd, MP4.STSD, MP4.ac3(track));
            return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
        } else return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
    }
    static tkhd(track) {
        const id = track.id;
        const duration = track.duration * track.timescale;
        const width = track.width;
        const height = track.height;
        const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
        return MP4.box(MP4.types.tkhd, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x07,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            id >> 24 & 0xff,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            // layer
            0x00,
            0x00,
            // alternate_group
            0x00,
            0x00,
            // non-audio track volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            width >> 8 & 0xff,
            width & 0xff,
            0x00,
            0x00,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            0x00,
            0x00 // height
        ]));
    }
    static traf(track, baseMediaDecodeTime) {
        const sampleDependencyTable = MP4.sdtp(track);
        const id = track.id;
        const upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
        const lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
        return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            id >> 24,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff // track_ID
        ])), MP4.box(MP4.types.tfdt, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            upperWordBaseMediaDecodeTime >> 24,
            upperWordBaseMediaDecodeTime >> 16 & 0xff,
            upperWordBaseMediaDecodeTime >> 8 & 0xff,
            upperWordBaseMediaDecodeTime & 0xff,
            lowerWordBaseMediaDecodeTime >> 24,
            lowerWordBaseMediaDecodeTime >> 16 & 0xff,
            lowerWordBaseMediaDecodeTime >> 8 & 0xff,
            lowerWordBaseMediaDecodeTime & 0xff
        ])), MP4.trun(track, sampleDependencyTable.length + 16 + // tfhd
        20 + // tfdt
        8 + // traf header
        16 + // mfhd
        8 + // moof header
        8), // mdat header
        sampleDependencyTable);
    }
    /**
   * Generate a track box.
   * @param track a track definition
   */ static trak(track) {
        track.duration = track.duration || 0xffffffff;
        return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
    }
    static trex(track) {
        const id = track.id;
        return MP4.box(MP4.types.trex, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            id >> 24,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // default_sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x01,
            0x00,
            0x01 // default_sample_flags
        ]));
    }
    static trun(track, offset) {
        const samples = track.samples || [];
        const len = samples.length;
        const arraylen = 12 + 16 * len;
        const array = new Uint8Array(arraylen);
        let i;
        let sample;
        let duration;
        let size;
        let flags;
        let cts;
        offset += 8 + arraylen;
        array.set([
            track.type === 'video' ? 0x01 : 0x00,
            // version 1 for video with signed-int sample_composition_time_offset
            0x00,
            0x0f,
            0x01,
            // flags
            len >>> 24 & 0xff,
            len >>> 16 & 0xff,
            len >>> 8 & 0xff,
            len & 0xff,
            // sample_count
            offset >>> 24 & 0xff,
            offset >>> 16 & 0xff,
            offset >>> 8 & 0xff,
            offset & 0xff // data_offset
        ], 0);
        for(i = 0; i < len; i++){
            sample = samples[i];
            duration = sample.duration;
            size = sample.size;
            flags = sample.flags;
            cts = sample.cts;
            array.set([
                duration >>> 24 & 0xff,
                duration >>> 16 & 0xff,
                duration >>> 8 & 0xff,
                duration & 0xff,
                // sample_duration
                size >>> 24 & 0xff,
                size >>> 16 & 0xff,
                size >>> 8 & 0xff,
                size & 0xff,
                // sample_size
                flags.isLeading << 2 | flags.dependsOn,
                flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync,
                flags.degradPrio & 61440,
                flags.degradPrio & 0x0f,
                // sample_flags
                cts >>> 24 & 0xff,
                cts >>> 16 & 0xff,
                cts >>> 8 & 0xff,
                cts & 0xff // sample_composition_time_offset
            ], 12 + 16 * i);
        }
        return MP4.box(MP4.types.trun, array);
    }
    static initSegment(tracks) {
        if (!MP4.types) MP4.init();
        const movie = MP4.moov(tracks);
        const result = appendUint8Array(MP4.FTYP, movie);
        return result;
    }
}
MP4.types = void 0;
MP4.HDLR_TYPES = void 0;
MP4.STTS = void 0;
MP4.STSC = void 0;
MP4.STCO = void 0;
MP4.STSZ = void 0;
MP4.VMHD = void 0;
MP4.SMHD = void 0;
MP4.STSD = void 0;
MP4.FTYP = void 0;
MP4.DINF = void 0;
const MPEG_TS_CLOCK_FREQ_HZ = 90000;
function toTimescaleFromBase(baseTime, destScale, srcBase = 1, round = false) {
    const result = baseTime * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
    return round ? Math.round(result) : result;
}
function toTimescaleFromScale(baseTime, destScale, srcScale = 1, round = false) {
    return toTimescaleFromBase(baseTime, destScale, 1 / srcScale, round);
}
function toMsFromMpegTsClock(baseTime, round = false) {
    return toTimescaleFromBase(baseTime, 1000, 1 / MPEG_TS_CLOCK_FREQ_HZ, round);
}
function toMpegTsClockFromTimescale(baseTime, srcScale = 1) {
    return toTimescaleFromBase(baseTime, MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
}
const MAX_SILENT_FRAME_DURATION = 10000; // 10 seconds
const AAC_SAMPLES_PER_FRAME = 1024;
const MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
const AC3_SAMPLES_PER_FRAME = 1536;
let chromeVersion = null;
let safariWebkitVersion = null;
class MP4Remuxer {
    constructor(observer, config, typeSupported, vendor = ''){
        this.observer = void 0;
        this.config = void 0;
        this.typeSupported = void 0;
        this.ISGenerated = false;
        this._initPTS = null;
        this._initDTS = null;
        this.nextAvcDts = null;
        this.nextAudioPts = null;
        this.videoSampleDuration = null;
        this.isAudioContiguous = false;
        this.isVideoContiguous = false;
        this.videoTrackConfig = void 0;
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        this.ISGenerated = false;
        if (chromeVersion === null) {
            const userAgent = navigator.userAgent || '';
            const result = userAgent.match(/Chrome\/(\d+)/i);
            chromeVersion = result ? parseInt(result[1]) : 0;
        }
        if (safariWebkitVersion === null) {
            const result = navigator.userAgent.match(/Safari\/(\d+)/i);
            safariWebkitVersion = result ? parseInt(result[1]) : 0;
        }
    }
    destroy() {
        // @ts-ignore
        this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
    }
    resetTimeStamp(defaultTimeStamp) {
        logger.log('[mp4-remuxer]: initPTS & initDTS reset');
        this._initPTS = this._initDTS = defaultTimeStamp;
    }
    resetNextTimestamp() {
        logger.log('[mp4-remuxer]: reset next timestamp');
        this.isVideoContiguous = false;
        this.isAudioContiguous = false;
    }
    resetInitSegment() {
        logger.log('[mp4-remuxer]: ISGenerated flag reset');
        this.ISGenerated = false;
        this.videoTrackConfig = undefined;
    }
    getVideoStartPts(videoSamples) {
        let rolloverDetected = false;
        const startPTS = videoSamples.reduce((minPTS, sample)=>{
            const delta = sample.pts - minPTS;
            if (delta < -4294967296) {
                // 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
                rolloverDetected = true;
                return normalizePts(minPTS, sample.pts);
            } else if (delta > 0) return minPTS;
            else return sample.pts;
        }, videoSamples[0].pts);
        if (rolloverDetected) logger.debug('PTS rollover detected');
        return startPTS;
    }
    remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
        let video;
        let audio;
        let initSegment;
        let text;
        let id3;
        let independent;
        let audioTimeOffset = timeOffset;
        let videoTimeOffset = timeOffset;
        // If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
        // This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
        // parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
        // However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
        // then we can remux one track without waiting for the other.
        const hasAudio = audioTrack.pid > -1;
        const hasVideo = videoTrack.pid > -1;
        const length = videoTrack.samples.length;
        const enoughAudioSamples = audioTrack.samples.length > 0;
        const enoughVideoSamples = flush && length > 0 || length > 1;
        const canRemuxAvc = (!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || this.ISGenerated || flush;
        if (canRemuxAvc) {
            if (this.ISGenerated) {
                var _videoTrack$pixelRati, _config$pixelRatio, _videoTrack$pixelRati2, _config$pixelRatio2;
                const config = this.videoTrackConfig;
                if (config && (videoTrack.width !== config.width || videoTrack.height !== config.height || ((_videoTrack$pixelRati = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati[0]) !== ((_config$pixelRatio = config.pixelRatio) == null ? void 0 : _config$pixelRatio[0]) || ((_videoTrack$pixelRati2 = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati2[1]) !== ((_config$pixelRatio2 = config.pixelRatio) == null ? void 0 : _config$pixelRatio2[1]))) this.resetInitSegment();
            } else initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
            const isVideoContiguous = this.isVideoContiguous;
            let firstKeyFrameIndex = -1;
            let firstKeyFramePTS;
            if (enoughVideoSamples) {
                firstKeyFrameIndex = findKeyframeIndex(videoTrack.samples);
                if (!isVideoContiguous && this.config.forceKeyFrameOnDiscontinuity) {
                    independent = true;
                    if (firstKeyFrameIndex > 0) {
                        logger.warn(`[mp4-remuxer]: Dropped ${firstKeyFrameIndex} out of ${length} video samples due to a missing keyframe`);
                        const startPTS = this.getVideoStartPts(videoTrack.samples);
                        videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
                        videoTrack.dropped += firstKeyFrameIndex;
                        videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
                        firstKeyFramePTS = videoTimeOffset;
                    } else if (firstKeyFrameIndex === -1) {
                        logger.warn(`[mp4-remuxer]: No keyframe found out of ${length} video samples`);
                        independent = false;
                    }
                }
            }
            if (this.ISGenerated) {
                if (enoughAudioSamples && enoughVideoSamples) {
                    // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
                    // if first audio DTS is not aligned with first video DTS then we need to take that into account
                    // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
                    // drift between audio and video streams
                    const startPTS = this.getVideoStartPts(videoTrack.samples);
                    const tsDelta = normalizePts(audioTrack.samples[0].pts, startPTS) - startPTS;
                    const audiovideoTimestampDelta = tsDelta / videoTrack.inputTimeScale;
                    audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
                    videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
                }
                // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
                if (enoughAudioSamples) {
                    // if initSegment was generated without audio samples, regenerate it again
                    if (!audioTrack.samplerate) {
                        logger.warn('[mp4-remuxer]: regenerate InitSegment as audio detected');
                        initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
                    }
                    audio = this.remuxAudio(audioTrack, audioTimeOffset, this.isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === PlaylistLevelType.AUDIO ? videoTimeOffset : undefined);
                    if (enoughVideoSamples) {
                        const audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
                        // if initSegment was generated without video samples, regenerate it again
                        if (!videoTrack.inputTimeScale) {
                            logger.warn('[mp4-remuxer]: regenerate InitSegment as video detected');
                            initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
                        }
                        video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
                    }
                } else if (enoughVideoSamples) video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
                if (video) {
                    video.firstKeyFrame = firstKeyFrameIndex;
                    video.independent = firstKeyFrameIndex !== -1;
                    video.firstKeyFramePTS = firstKeyFramePTS;
                }
            }
        }
        // Allow ID3 and text to remux, even if more audio/video samples are required
        if (this.ISGenerated && this._initPTS && this._initDTS) {
            if (id3Track.samples.length) id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, this._initPTS, this._initDTS);
            if (textTrack.samples.length) text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, this._initPTS);
        }
        return {
            audio,
            video,
            initSegment,
            independent,
            text,
            id3
        };
    }
    generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset) {
        const audioSamples = audioTrack.samples;
        const videoSamples = videoTrack.samples;
        const typeSupported = this.typeSupported;
        const tracks = {};
        const _initPTS = this._initPTS;
        let computePTSDTS = !_initPTS || accurateTimeOffset;
        let container = 'audio/mp4';
        let initPTS;
        let initDTS;
        let timescale;
        if (computePTSDTS) initPTS = initDTS = Infinity;
        if (audioTrack.config && audioSamples.length) {
            // let's use audio sampling rate as MP4 time scale.
            // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
            // using audio sampling rate here helps having an integer MP4 frame duration
            // this avoids potential rounding issue and AV sync issue
            audioTrack.timescale = audioTrack.samplerate;
            switch(audioTrack.segmentCodec){
                case 'mp3':
                    if (typeSupported.mpeg) {
                        // Chrome and Safari
                        container = 'audio/mpeg';
                        audioTrack.codec = '';
                    } else if (typeSupported.mp3) // Firefox
                    audioTrack.codec = 'mp3';
                    break;
                case 'ac3':
                    audioTrack.codec = 'ac-3';
                    break;
            }
            tracks.audio = {
                id: 'audio',
                container: container,
                codec: audioTrack.codec,
                initSegment: audioTrack.segmentCodec === 'mp3' && typeSupported.mpeg ? new Uint8Array(0) : MP4.initSegment([
                    audioTrack
                ]),
                metadata: {
                    channelCount: audioTrack.channelCount
                }
            };
            if (computePTSDTS) {
                timescale = audioTrack.inputTimeScale;
                if (!_initPTS || timescale !== _initPTS.timescale) // remember first PTS of this demuxing context. for audio, PTS = DTS
                initPTS = initDTS = audioSamples[0].pts - Math.round(timescale * timeOffset);
                else computePTSDTS = false;
            }
        }
        if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
            // let's use input time scale as MP4 video timescale
            // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
            videoTrack.timescale = videoTrack.inputTimeScale;
            tracks.video = {
                id: 'main',
                container: 'video/mp4',
                codec: videoTrack.codec,
                initSegment: MP4.initSegment([
                    videoTrack
                ]),
                metadata: {
                    width: videoTrack.width,
                    height: videoTrack.height
                }
            };
            if (computePTSDTS) {
                timescale = videoTrack.inputTimeScale;
                if (!_initPTS || timescale !== _initPTS.timescale) {
                    const startPTS = this.getVideoStartPts(videoSamples);
                    const startOffset = Math.round(timescale * timeOffset);
                    initDTS = Math.min(initDTS, normalizePts(videoSamples[0].dts, startPTS) - startOffset);
                    initPTS = Math.min(initPTS, startPTS - startOffset);
                } else computePTSDTS = false;
            }
            this.videoTrackConfig = {
                width: videoTrack.width,
                height: videoTrack.height,
                pixelRatio: videoTrack.pixelRatio
            };
        }
        if (Object.keys(tracks).length) {
            this.ISGenerated = true;
            if (computePTSDTS) {
                this._initPTS = {
                    baseTime: initPTS,
                    timescale: timescale
                };
                this._initDTS = {
                    baseTime: initDTS,
                    timescale: timescale
                };
            } else initPTS = timescale = undefined;
            return {
                tracks,
                initPTS,
                timescale
            };
        }
    }
    remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
        const timeScale = track.inputTimeScale;
        const inputSamples = track.samples;
        const outputSamples = [];
        const nbSamples = inputSamples.length;
        const initPTS = this._initPTS;
        let nextAvcDts = this.nextAvcDts;
        let offset = 8;
        let mp4SampleDuration = this.videoSampleDuration;
        let firstDTS;
        let lastDTS;
        let minPTS = Number.POSITIVE_INFINITY;
        let maxPTS = Number.NEGATIVE_INFINITY;
        let sortSamples = false;
        // if parsed fragment is contiguous with last one, let's use last DTS value as reference
        if (!contiguous || nextAvcDts === null) {
            const pts = timeOffset * timeScale;
            const cts = inputSamples[0].pts - normalizePts(inputSamples[0].dts, inputSamples[0].pts);
            if (chromeVersion && nextAvcDts !== null && Math.abs(pts - cts - nextAvcDts) < 15000) // treat as contigous to adjust samples that would otherwise produce video buffer gaps in Chrome
            contiguous = true;
            else // if not contiguous, let's use target timeOffset
            nextAvcDts = pts - cts;
        }
        // PTS is coded on 33bits, and can loop from -2^32 to 2^32
        // PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
        const initTime = initPTS.baseTime * timeScale / initPTS.timescale;
        for(let i = 0; i < nbSamples; i++){
            const sample = inputSamples[i];
            sample.pts = normalizePts(sample.pts - initTime, nextAvcDts);
            sample.dts = normalizePts(sample.dts - initTime, nextAvcDts);
            if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) sortSamples = true;
        }
        // sort video samples by DTS then PTS then demux id order
        if (sortSamples) inputSamples.sort(function(a, b) {
            const deltadts = a.dts - b.dts;
            const deltapts = a.pts - b.pts;
            return deltadts || deltapts;
        });
        // Get first/last DTS
        firstDTS = inputSamples[0].dts;
        lastDTS = inputSamples[inputSamples.length - 1].dts;
        // Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
        // set this constant duration as being the avg delta between consecutive DTS.
        const inputDuration = lastDTS - firstDTS;
        const averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;
        // if fragment are contiguous, detect hole/overlapping between fragments
        if (contiguous) {
            // check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
            const delta = firstDTS - nextAvcDts;
            const foundHole = delta > averageSampleDuration;
            const foundOverlap = delta < -1;
            if (foundHole || foundOverlap) {
                if (foundHole) logger.warn(`AVC: ${toMsFromMpegTsClock(delta, true)} ms (${delta}dts) hole between fragments detected at ${timeOffset.toFixed(3)}`);
                else logger.warn(`AVC: ${toMsFromMpegTsClock(-delta, true)} ms (${delta}dts) overlapping between fragments detected at ${timeOffset.toFixed(3)}`);
                if (!foundOverlap || nextAvcDts >= inputSamples[0].pts || chromeVersion) {
                    firstDTS = nextAvcDts;
                    const firstPTS = inputSamples[0].pts - delta;
                    if (foundHole) {
                        inputSamples[0].dts = firstDTS;
                        inputSamples[0].pts = firstPTS;
                    } else for(let i = 0; i < inputSamples.length; i++){
                        if (inputSamples[i].dts > firstPTS) break;
                        inputSamples[i].dts -= delta;
                        inputSamples[i].pts -= delta;
                    }
                    logger.log(`Video: Initial PTS/DTS adjusted: ${toMsFromMpegTsClock(firstPTS, true)}/${toMsFromMpegTsClock(firstDTS, true)}, delta: ${toMsFromMpegTsClock(delta, true)} ms`);
                }
            }
        }
        firstDTS = Math.max(0, firstDTS);
        let nbNalu = 0;
        let naluLen = 0;
        let dtsStep = firstDTS;
        for(let i = 0; i < nbSamples; i++){
            // compute total/avc sample length and nb of NAL units
            const sample = inputSamples[i];
            const units = sample.units;
            const nbUnits = units.length;
            let sampleLen = 0;
            for(let j = 0; j < nbUnits; j++)sampleLen += units[j].data.length;
            naluLen += sampleLen;
            nbNalu += nbUnits;
            sample.length = sampleLen;
            // ensure sample monotonic DTS
            if (sample.dts < dtsStep) {
                sample.dts = dtsStep;
                dtsStep += averageSampleDuration / 4 | 0 || 1;
            } else dtsStep = sample.dts;
            minPTS = Math.min(sample.pts, minPTS);
            maxPTS = Math.max(sample.pts, maxPTS);
        }
        lastDTS = inputSamples[nbSamples - 1].dts;
        /* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */ const mdatSize = naluLen + 4 * nbNalu + 8;
        let mdat;
        try {
            mdat = new Uint8Array(mdatSize);
        } catch (err) {
            this.observer.emit(Events.ERROR, Events.ERROR, {
                type: ErrorTypes.MUX_ERROR,
                details: ErrorDetails.REMUX_ALLOC_ERROR,
                fatal: false,
                error: err,
                bytes: mdatSize,
                reason: `fail allocating video mdat ${mdatSize}`
            });
            return;
        }
        const view = new DataView(mdat.buffer);
        view.setUint32(0, mdatSize);
        mdat.set(MP4.types.mdat, 4);
        let stretchedLastFrame = false;
        let minDtsDelta = Number.POSITIVE_INFINITY;
        let minPtsDelta = Number.POSITIVE_INFINITY;
        let maxDtsDelta = Number.NEGATIVE_INFINITY;
        let maxPtsDelta = Number.NEGATIVE_INFINITY;
        for(let i = 0; i < nbSamples; i++){
            const VideoSample = inputSamples[i];
            const VideoSampleUnits = VideoSample.units;
            let mp4SampleLength = 0;
            // convert NALU bitstream to MP4 format (prepend NALU with size field)
            for(let j = 0, nbUnits = VideoSampleUnits.length; j < nbUnits; j++){
                const unit = VideoSampleUnits[j];
                const unitData = unit.data;
                const unitDataLen = unit.data.byteLength;
                view.setUint32(offset, unitDataLen);
                offset += 4;
                mdat.set(unitData, offset);
                offset += unitDataLen;
                mp4SampleLength += 4 + unitDataLen;
            }
            // expected sample duration is the Decoding Timestamp diff of consecutive samples
            let ptsDelta;
            if (i < nbSamples - 1) {
                mp4SampleDuration = inputSamples[i + 1].dts - VideoSample.dts;
                ptsDelta = inputSamples[i + 1].pts - VideoSample.pts;
            } else {
                const config = this.config;
                const lastFrameDuration = i > 0 ? VideoSample.dts - inputSamples[i - 1].dts : averageSampleDuration;
                ptsDelta = i > 0 ? VideoSample.pts - inputSamples[i - 1].pts : averageSampleDuration;
                if (config.stretchShortVideoTrack && this.nextAudioPts !== null) {
                    // In some cases, a segment's audio track duration may exceed the video track duration.
                    // Since we've already remuxed audio, and we know how long the audio track is, we look to
                    // see if the delta to the next segment is longer than maxBufferHole.
                    // If so, playback would potentially get stuck, so we artificially inflate
                    // the duration of the last frame to minimize any potential gap between segments.
                    const gapTolerance = Math.floor(config.maxBufferHole * timeScale);
                    const deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : this.nextAudioPts) - VideoSample.pts;
                    if (deltaToFrameEnd > gapTolerance) {
                        // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                        // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
                        mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                        if (mp4SampleDuration < 0) mp4SampleDuration = lastFrameDuration;
                        else stretchedLastFrame = true;
                        logger.log(`[mp4-remuxer]: It is approximately ${deltaToFrameEnd / 90} ms to the next segment; using duration ${mp4SampleDuration / 90} ms for the last video frame.`);
                    } else mp4SampleDuration = lastFrameDuration;
                } else mp4SampleDuration = lastFrameDuration;
            }
            const compositionTimeOffset = Math.round(VideoSample.pts - VideoSample.dts);
            minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
            maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
            minPtsDelta = Math.min(minPtsDelta, ptsDelta);
            maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
            outputSamples.push(new Mp4Sample(VideoSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
        }
        if (outputSamples.length) {
            if (chromeVersion) {
                if (chromeVersion < 70) {
                    // Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
                    // https://code.google.com/p/chromium/issues/detail?id=229412
                    const flags = outputSamples[0].flags;
                    flags.dependsOn = 2;
                    flags.isNonSync = 0;
                }
            } else if (safariWebkitVersion) // Fix for "CNN special report, with CC" in test-streams (Safari browser only)
            // Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
            {
                if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < 0.025 && outputSamples[0].cts === 0) {
                    logger.warn('Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.');
                    let dts = firstDTS;
                    for(let i = 0, len = outputSamples.length; i < len; i++){
                        const nextDts = dts + outputSamples[i].duration;
                        const pts = dts + outputSamples[i].cts;
                        if (i < len - 1) {
                            const nextPts = nextDts + outputSamples[i + 1].cts;
                            outputSamples[i].duration = nextPts - pts;
                        } else outputSamples[i].duration = i ? outputSamples[i - 1].duration : averageSampleDuration;
                        outputSamples[i].cts = 0;
                        dts = nextDts;
                    }
                }
            }
        }
        // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
        mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
        this.nextAvcDts = nextAvcDts = lastDTS + mp4SampleDuration;
        this.videoSampleDuration = mp4SampleDuration;
        this.isVideoContiguous = true;
        const moof = MP4.moof(track.sequenceNumber++, firstDTS, _extends({}, track, {
            samples: outputSamples
        }));
        const type = 'video';
        const data = {
            data1: moof,
            data2: mdat,
            startPTS: minPTS / timeScale,
            endPTS: (maxPTS + mp4SampleDuration) / timeScale,
            startDTS: firstDTS / timeScale,
            endDTS: nextAvcDts / timeScale,
            type,
            hasAudio: false,
            hasVideo: true,
            nb: outputSamples.length,
            dropped: track.dropped
        };
        track.samples = [];
        track.dropped = 0;
        return data;
    }
    getSamplesPerFrame(track) {
        switch(track.segmentCodec){
            case 'mp3':
                return MPEG_AUDIO_SAMPLE_PER_FRAME;
            case 'ac3':
                return AC3_SAMPLES_PER_FRAME;
            default:
                return AAC_SAMPLES_PER_FRAME;
        }
    }
    remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
        const inputTimeScale = track.inputTimeScale;
        const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
        const scaleFactor = inputTimeScale / mp4timeScale;
        const mp4SampleDuration = this.getSamplesPerFrame(track);
        const inputSampleDuration = mp4SampleDuration * scaleFactor;
        const initPTS = this._initPTS;
        const rawMPEG = track.segmentCodec === 'mp3' && this.typeSupported.mpeg;
        const outputSamples = [];
        const alignedWithVideo = videoTimeOffset !== undefined;
        let inputSamples = track.samples;
        let offset = rawMPEG ? 0 : 8;
        let nextAudioPts = this.nextAudioPts || -1;
        // window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);
        // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
        // for sake of clarity:
        // consecutive fragments are frags with
        //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
        //  - less than 20 audio frames distance
        // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
        // this helps ensuring audio continuity
        // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
        const timeOffsetMpegTS = timeOffset * inputTimeScale;
        const initTime = initPTS.baseTime * inputTimeScale / initPTS.timescale;
        this.isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioPts > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - nextAudioPts) < 9000 || Math.abs(normalizePts(inputSamples[0].pts - initTime, timeOffsetMpegTS) - nextAudioPts) < 20 * inputSampleDuration);
        // compute normalized PTS
        inputSamples.forEach(function(sample) {
            sample.pts = normalizePts(sample.pts - initTime, timeOffsetMpegTS);
        });
        if (!contiguous || nextAudioPts < 0) {
            // filter out sample with negative PTS that are not playable anyway
            // if we don't remove these negative samples, they will shift all audio samples forward.
            // leading to audio overlap between current / next fragment
            inputSamples = inputSamples.filter((sample)=>sample.pts >= 0);
            // in case all samples have negative PTS, and have been filtered out, return now
            if (!inputSamples.length) return;
            if (videoTimeOffset === 0) // Set the start to 0 to match video so that start gaps larger than inputSampleDuration are filled with silence
            nextAudioPts = 0;
            else if (accurateTimeOffset && !alignedWithVideo) // When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
            nextAudioPts = Math.max(0, timeOffsetMpegTS);
            else // if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
            nextAudioPts = inputSamples[0].pts;
        }
        // If the audio track is missing samples, the frames seem to get "left-shifted" within the
        // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
        // In an effort to prevent this from happening, we inject frames here where there are gaps.
        // When possible, we inject a silent frame; when that's not possible, we duplicate the last
        // frame.
        if (track.segmentCodec === 'aac') {
            const maxAudioFramesDrift = this.config.maxAudioFramesDrift;
            for(let i = 0, nextPts = nextAudioPts; i < inputSamples.length; i++){
                // First, let's see how far off this frame is from where we expect it to be
                const sample = inputSamples[i];
                const pts = sample.pts;
                const delta = pts - nextPts;
                const duration = Math.abs(1000 * delta / inputTimeScale);
                // When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
                if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
                    if (i === 0) {
                        logger.warn(`Audio frame @ ${(pts / inputTimeScale).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1000 * delta / inputTimeScale)} ms.`);
                        this.nextAudioPts = nextAudioPts = nextPts = pts;
                    }
                } else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
                    let missing = Math.round(delta / inputSampleDuration);
                    // Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
                    // later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
                    nextPts = pts - missing * inputSampleDuration;
                    if (nextPts < 0) {
                        missing--;
                        nextPts += inputSampleDuration;
                    }
                    if (i === 0) this.nextAudioPts = nextAudioPts = nextPts;
                    logger.warn(`[mp4-remuxer]: Injecting ${missing} audio frame @ ${(nextPts / inputTimeScale).toFixed(3)}s due to ${Math.round(1000 * delta / inputTimeScale)} ms gap.`);
                    for(let j = 0; j < missing; j++){
                        const newStamp = Math.max(nextPts, 0);
                        let fillFrame = AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                        if (!fillFrame) {
                            logger.log('[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.');
                            fillFrame = sample.unit.subarray();
                        }
                        inputSamples.splice(i, 0, {
                            unit: fillFrame,
                            pts: newStamp
                        });
                        nextPts += inputSampleDuration;
                        i++;
                    }
                }
                sample.pts = nextPts;
                nextPts += inputSampleDuration;
            }
        }
        let firstPTS = null;
        let lastPTS = null;
        let mdat;
        let mdatSize = 0;
        let sampleLength = inputSamples.length;
        while(sampleLength--)mdatSize += inputSamples[sampleLength].unit.byteLength;
        for(let j = 0, _nbSamples = inputSamples.length; j < _nbSamples; j++){
            const audioSample = inputSamples[j];
            const unit = audioSample.unit;
            let pts = audioSample.pts;
            if (lastPTS !== null) {
                // If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
                // the previous sample
                const prevSample = outputSamples[j - 1];
                prevSample.duration = Math.round((pts - lastPTS) / scaleFactor);
            } else {
                if (contiguous && track.segmentCodec === 'aac') // set PTS/DTS to expected PTS/DTS
                pts = nextAudioPts;
                // remember first PTS of our audioSamples
                firstPTS = pts;
                if (mdatSize > 0) {
                    /* concatenate the audio data and construct the mdat in place
            (need 8 more bytes to fill length and mdat type) */ mdatSize += offset;
                    try {
                        mdat = new Uint8Array(mdatSize);
                    } catch (err) {
                        this.observer.emit(Events.ERROR, Events.ERROR, {
                            type: ErrorTypes.MUX_ERROR,
                            details: ErrorDetails.REMUX_ALLOC_ERROR,
                            fatal: false,
                            error: err,
                            bytes: mdatSize,
                            reason: `fail allocating audio mdat ${mdatSize}`
                        });
                        return;
                    }
                    if (!rawMPEG) {
                        const view = new DataView(mdat.buffer);
                        view.setUint32(0, mdatSize);
                        mdat.set(MP4.types.mdat, 4);
                    }
                } else // no audio samples
                return;
            }
            mdat.set(unit, offset);
            const unitLen = unit.byteLength;
            offset += unitLen;
            // Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
            // In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
            // becomes the PTS diff with the previous sample
            outputSamples.push(new Mp4Sample(true, mp4SampleDuration, unitLen, 0));
            lastPTS = pts;
        }
        // We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
        const nbSamples = outputSamples.length;
        if (!nbSamples) return;
        // The next audio sample PTS should be equal to last sample PTS + duration
        const lastSample = outputSamples[outputSamples.length - 1];
        this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSample.duration;
        // Set the track samples from inputSamples to outputSamples before remuxing
        const moof = rawMPEG ? new Uint8Array(0) : MP4.moof(track.sequenceNumber++, firstPTS / scaleFactor, _extends({}, track, {
            samples: outputSamples
        }));
        // Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
        track.samples = [];
        const start = firstPTS / inputTimeScale;
        const end = nextAudioPts / inputTimeScale;
        const type = 'audio';
        const audioData = {
            data1: moof,
            data2: mdat,
            startPTS: start,
            endPTS: end,
            startDTS: start,
            endDTS: end,
            type,
            hasAudio: true,
            hasVideo: false,
            nb: nbSamples
        };
        this.isAudioContiguous = true;
        return audioData;
    }
    remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
        const inputTimeScale = track.inputTimeScale;
        const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
        const scaleFactor = inputTimeScale / mp4timeScale;
        const nextAudioPts = this.nextAudioPts;
        // sync with video's timestamp
        const initDTS = this._initDTS;
        const init90kHz = initDTS.baseTime * 90000 / initDTS.timescale;
        const startDTS = (nextAudioPts !== null ? nextAudioPts : videoData.startDTS * inputTimeScale) + init90kHz;
        const endDTS = videoData.endDTS * inputTimeScale + init90kHz;
        // one sample's duration value
        const frameDuration = scaleFactor * AAC_SAMPLES_PER_FRAME;
        // samples count of this segment's duration
        const nbSamples = Math.ceil((endDTS - startDTS) / frameDuration);
        // silent frame
        const silentFrame = AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
        logger.warn('[mp4-remuxer]: remux empty Audio');
        // Can't remux if we can't generate a silent frame...
        if (!silentFrame) {
            logger.trace('[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec');
            return;
        }
        const samples = [];
        for(let i = 0; i < nbSamples; i++){
            const stamp = startDTS + i * frameDuration;
            samples.push({
                unit: silentFrame,
                pts: stamp,
                dts: stamp
            });
        }
        track.samples = samples;
        return this.remuxAudio(track, timeOffset, contiguous, false);
    }
}
function normalizePts(value, reference) {
    let offset;
    if (reference === null) return value;
    if (reference < value) // - 2^33
    offset = -8589934592;
    else // + 2^33
    offset = 8589934592;
    /* PTS is 33bit (from 0 to 2^33 -1)
    if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
    PTS looping occured. fill the gap */ while(Math.abs(value - reference) > 4294967296)value += offset;
    return value;
}
function findKeyframeIndex(samples) {
    for(let i = 0; i < samples.length; i++){
        if (samples[i].key) return i;
    }
    return -1;
}
function flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
    const length = track.samples.length;
    if (!length) return;
    const inputTimeScale = track.inputTimeScale;
    for(let index = 0; index < length; index++){
        const sample = track.samples[index];
        // setting id3 pts, dts to relative time
        // using this._initPTS and this._initDTS to calculate relative time
        sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
        sample.dts = normalizePts(sample.dts - initDTS.baseTime * inputTimeScale / initDTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    }
    const samples = track.samples;
    track.samples = [];
    return {
        samples
    };
}
function flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
    const length = track.samples.length;
    if (!length) return;
    const inputTimeScale = track.inputTimeScale;
    for(let index = 0; index < length; index++){
        const sample = track.samples[index];
        // setting text pts, dts to relative time
        // using this._initPTS and this._initDTS to calculate relative time
        sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    }
    track.samples.sort((a, b)=>a.pts - b.pts);
    const samples = track.samples;
    track.samples = [];
    return {
        samples
    };
}
class Mp4Sample {
    constructor(isKeyframe, duration, size, cts){
        this.size = void 0;
        this.duration = void 0;
        this.cts = void 0;
        this.flags = void 0;
        this.duration = duration;
        this.size = size;
        this.cts = cts;
        this.flags = {
            isLeading: 0,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradPrio: 0,
            dependsOn: isKeyframe ? 2 : 1,
            isNonSync: isKeyframe ? 0 : 1
        };
    }
}
class PassThroughRemuxer {
    constructor(){
        this.emitInitSegment = false;
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this.initData = void 0;
        this.initPTS = null;
        this.initTracks = void 0;
        this.lastEndTime = null;
    }
    destroy() {}
    resetTimeStamp(defaultInitPTS) {
        this.initPTS = defaultInitPTS;
        this.lastEndTime = null;
    }
    resetNextTimestamp() {
        this.lastEndTime = null;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, decryptdata) {
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this.generateInitSegment(patchEncyptionData(initSegment, decryptdata));
        this.emitInitSegment = true;
    }
    generateInitSegment(initSegment) {
        let { audioCodec, videoCodec } = this;
        if (!(initSegment != null && initSegment.byteLength)) {
            this.initTracks = undefined;
            this.initData = undefined;
            return;
        }
        const initData = this.initData = parseInitSegment(initSegment);
        // Get codec from initSegment or fallback to default
        if (initData.audio) audioCodec = getParsedTrackCodec(initData.audio, ElementaryStreamTypes.AUDIO);
        if (initData.video) videoCodec = getParsedTrackCodec(initData.video, ElementaryStreamTypes.VIDEO);
        const tracks = {};
        if (initData.audio && initData.video) tracks.audiovideo = {
            container: 'video/mp4',
            codec: audioCodec + ',' + videoCodec,
            initSegment,
            id: 'main'
        };
        else if (initData.audio) tracks.audio = {
            container: 'audio/mp4',
            codec: audioCodec,
            initSegment,
            id: 'audio'
        };
        else if (initData.video) tracks.video = {
            container: 'video/mp4',
            codec: videoCodec,
            initSegment,
            id: 'main'
        };
        else logger.warn('[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.');
        this.initTracks = tracks;
    }
    remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset) {
        var _initData, _initData2;
        let { initPTS, lastEndTime } = this;
        const result = {
            audio: undefined,
            video: undefined,
            text: textTrack,
            id3: id3Track,
            initSegment: undefined
        };
        // If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
        // lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
        // the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
        if (!isFiniteNumber(lastEndTime)) lastEndTime = this.lastEndTime = timeOffset || 0;
        // The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
        // audio or video (or both); adding it to video was an arbitrary choice.
        const data = videoTrack.samples;
        if (!(data != null && data.length)) return result;
        const initSegment = {
            initPTS: undefined,
            timescale: 1
        };
        let initData = this.initData;
        if (!((_initData = initData) != null && _initData.length)) {
            this.generateInitSegment(data);
            initData = this.initData;
        }
        if (!((_initData2 = initData) != null && _initData2.length)) {
            // We can't remux if the initSegment could not be generated
            logger.warn('[passthrough-remuxer.ts]: Failed to generate initSegment.');
            return result;
        }
        if (this.emitInitSegment) {
            initSegment.tracks = this.initTracks;
            this.emitInitSegment = false;
        }
        const duration = getDuration(data, initData);
        const startDTS = getStartDTS(initData, data);
        const decodeTime = startDTS === null ? timeOffset : startDTS;
        if (isInvalidInitPts(initPTS, decodeTime, timeOffset, duration) || initSegment.timescale !== initPTS.timescale && accurateTimeOffset) {
            initSegment.initPTS = decodeTime - timeOffset;
            if (initPTS && initPTS.timescale === 1) logger.warn(`Adjusting initPTS by ${initSegment.initPTS - initPTS.baseTime}`);
            this.initPTS = initPTS = {
                baseTime: initSegment.initPTS,
                timescale: 1
            };
        }
        const startTime = audioTrack ? decodeTime - initPTS.baseTime / initPTS.timescale : lastEndTime;
        const endTime = startTime + duration;
        offsetStartDTS(initData, data, initPTS.baseTime / initPTS.timescale);
        if (duration > 0) this.lastEndTime = endTime;
        else {
            logger.warn('Duration parsed from mp4 should be greater than zero');
            this.resetNextTimestamp();
        }
        const hasAudio = !!initData.audio;
        const hasVideo = !!initData.video;
        let type = '';
        if (hasAudio) type += 'audio';
        if (hasVideo) type += 'video';
        const track = {
            data1: data,
            startPTS: startTime,
            startDTS: startTime,
            endPTS: endTime,
            endDTS: endTime,
            type,
            hasAudio,
            hasVideo,
            nb: 1,
            dropped: 0
        };
        result.audio = track.type === 'audio' ? track : undefined;
        result.video = track.type !== 'audio' ? track : undefined;
        result.initSegment = initSegment;
        result.id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, initPTS, initPTS);
        if (textTrack.samples.length) result.text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, initPTS);
        return result;
    }
}
function isInvalidInitPts(initPTS, startDTS, timeOffset, duration) {
    if (initPTS === null) return true;
    // InitPTS is invalid when distance from program would be more than segment duration or a minimum of one second
    const minDuration = Math.max(duration, 1);
    const startTime = startDTS - initPTS.baseTime / initPTS.timescale;
    return Math.abs(startTime - timeOffset) > minDuration;
}
function getParsedTrackCodec(track, type) {
    const parsedCodec = track == null ? void 0 : track.codec;
    if (parsedCodec && parsedCodec.length > 4) return parsedCodec;
    if (type === ElementaryStreamTypes.AUDIO) {
        if (parsedCodec === 'ec-3' || parsedCodec === 'ac-3' || parsedCodec === 'alac') return parsedCodec;
        if (parsedCodec === 'fLaC' || parsedCodec === 'Opus') {
            // Opting not to get `preferManagedMediaSource` from player config for isSupported() check for simplicity
            const preferManagedMediaSource = false;
            return getCodecCompatibleName(parsedCodec, preferManagedMediaSource);
        }
        const result = 'mp4a.40.5';
        logger.info(`Parsed audio codec "${parsedCodec}" or audio object type not handled. Using "${result}"`);
        return result;
    }
    // Provide defaults based on codec type
    // This allows for some playback of some fmp4 playlists without CODECS defined in manifest
    logger.warn(`Unhandled video codec "${parsedCodec}"`);
    if (parsedCodec === 'hvc1' || parsedCodec === 'hev1') return 'hvc1.1.6.L120.90';
    if (parsedCodec === 'av01') return 'av01.0.04M.08';
    return 'avc1.42e01e';
}
let now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
    now = self.performance.now.bind(self.performance);
} catch (err) {
    logger.debug('Unable to use Performance API on this environment');
    now = optionalSelf == null ? void 0 : optionalSelf.Date.now;
}
const muxConfig = [
    {
        demux: MP4Demuxer,
        remux: PassThroughRemuxer
    },
    {
        demux: TSDemuxer,
        remux: MP4Remuxer
    },
    {
        demux: AACDemuxer,
        remux: MP4Remuxer
    },
    {
        demux: MP3Demuxer,
        remux: MP4Remuxer
    }
];
muxConfig.splice(2, 0, {
    demux: AC3Demuxer,
    remux: MP4Remuxer
});
class Transmuxer {
    constructor(observer, typeSupported, config, vendor, id){
        this.async = false;
        this.observer = void 0;
        this.typeSupported = void 0;
        this.config = void 0;
        this.vendor = void 0;
        this.id = void 0;
        this.demuxer = void 0;
        this.remuxer = void 0;
        this.decrypter = void 0;
        this.probe = void 0;
        this.decryptionPromise = null;
        this.transmuxConfig = void 0;
        this.currentTransmuxState = void 0;
        this.observer = observer;
        this.typeSupported = typeSupported;
        this.config = config;
        this.vendor = vendor;
        this.id = id;
    }
    configure(transmuxConfig) {
        this.transmuxConfig = transmuxConfig;
        if (this.decrypter) this.decrypter.reset();
    }
    push(data, decryptdata, chunkMeta, state) {
        const stats = chunkMeta.transmuxing;
        stats.executeStart = now();
        let uintData = new Uint8Array(data);
        const { currentTransmuxState, transmuxConfig } = this;
        if (state) this.currentTransmuxState = state;
        const { contiguous, discontinuity, trackSwitch, accurateTimeOffset, timeOffset, initSegmentChange } = state || currentTransmuxState;
        const { audioCodec, videoCodec, defaultInitPts, duration, initSegmentData } = transmuxConfig;
        const keyData = getEncryptionType(uintData, decryptdata);
        if (keyData && keyData.method === 'AES-128') {
            const decrypter = this.getDecrypter();
            // Software decryption is synchronous; webCrypto is not
            if (decrypter.isSync()) {
                // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
                // data is handled in the flush() call
                let decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer);
                // For Low-Latency HLS Parts, decrypt in place, since part parsing is expected on push progress
                const loadingParts = chunkMeta.part > -1;
                if (loadingParts) decryptedData = decrypter.flush();
                if (!decryptedData) {
                    stats.executeEnd = now();
                    return emptyResult(chunkMeta);
                }
                uintData = new Uint8Array(decryptedData);
            } else {
                this.decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer).then((decryptedData)=>{
                    // Calling push here is important; if flush() is called while this is still resolving, this ensures that
                    // the decrypted data has been transmuxed
                    const result = this.push(decryptedData, null, chunkMeta);
                    this.decryptionPromise = null;
                    return result;
                });
                return this.decryptionPromise;
            }
        }
        const resetMuxers = this.needsProbing(discontinuity, trackSwitch);
        if (resetMuxers) {
            const error = this.configureTransmuxer(uintData);
            if (error) {
                logger.warn(`[transmuxer] ${error.message}`);
                this.observer.emit(Events.ERROR, Events.ERROR, {
                    type: ErrorTypes.MEDIA_ERROR,
                    details: ErrorDetails.FRAG_PARSING_ERROR,
                    fatal: false,
                    error,
                    reason: error.message
                });
                stats.executeEnd = now();
                return emptyResult(chunkMeta);
            }
        }
        if (discontinuity || trackSwitch || initSegmentChange || resetMuxers) this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration, decryptdata);
        if (discontinuity || initSegmentChange || resetMuxers) this.resetInitialTimestamp(defaultInitPts);
        if (!contiguous) this.resetContiguity();
        const result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
        const currentState = this.currentTransmuxState;
        currentState.contiguous = true;
        currentState.discontinuity = false;
        currentState.trackSwitch = false;
        stats.executeEnd = now();
        return result;
    }
    // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
    flush(chunkMeta) {
        const stats = chunkMeta.transmuxing;
        stats.executeStart = now();
        const { decrypter, currentTransmuxState, decryptionPromise } = this;
        if (decryptionPromise) // Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
        // only flushing is required for async decryption
        return decryptionPromise.then(()=>{
            return this.flush(chunkMeta);
        });
        const transmuxResults = [];
        const { timeOffset } = currentTransmuxState;
        if (decrypter) {
            // The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
            // This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
            // or for progressive downloads with small segments)
            const decryptedData = decrypter.flush();
            if (decryptedData) // Push always returns a TransmuxerResult if decryptdata is null
            transmuxResults.push(this.push(decryptedData, null, chunkMeta));
        }
        const { demuxer, remuxer } = this;
        if (!demuxer || !remuxer) {
            // If probing failed, then Hls.js has been given content its not able to handle
            stats.executeEnd = now();
            return [
                emptyResult(chunkMeta)
            ];
        }
        const demuxResultOrPromise = demuxer.flush(timeOffset);
        if (isPromise(demuxResultOrPromise)) // Decrypt final SAMPLE-AES samples
        return demuxResultOrPromise.then((demuxResult)=>{
            this.flushRemux(transmuxResults, demuxResult, chunkMeta);
            return transmuxResults;
        });
        this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
        return transmuxResults;
    }
    flushRemux(transmuxResults, demuxResult, chunkMeta) {
        const { audioTrack, videoTrack, id3Track, textTrack } = demuxResult;
        const { accurateTimeOffset, timeOffset } = this.currentTransmuxState;
        logger.log(`[transmuxer.ts]: Flushed fragment ${chunkMeta.sn}${chunkMeta.part > -1 ? ' p: ' + chunkMeta.part : ''} of level ${chunkMeta.level}`);
        const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, this.id);
        transmuxResults.push({
            remuxResult,
            chunkMeta
        });
        chunkMeta.transmuxing.executeEnd = now();
    }
    resetInitialTimestamp(defaultInitPts) {
        const { demuxer, remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetTimeStamp(defaultInitPts);
        remuxer.resetTimeStamp(defaultInitPts);
    }
    resetContiguity() {
        const { demuxer, remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetContiguity();
        remuxer.resetNextTimestamp();
    }
    resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration, decryptdata) {
        const { demuxer, remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
        remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, decryptdata);
    }
    destroy() {
        if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = undefined;
        }
        if (this.remuxer) {
            this.remuxer.destroy();
            this.remuxer = undefined;
        }
    }
    transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
        let result;
        if (keyData && keyData.method === 'SAMPLE-AES') result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
        else result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
        return result;
    }
    transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
        const { audioTrack, videoTrack, id3Track, textTrack } = this.demuxer.demux(data, timeOffset, false, !this.config.progressive);
        const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, this.id);
        return {
            remuxResult,
            chunkMeta
        };
    }
    transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
        return this.demuxer.demuxSampleAes(data, decryptData, timeOffset).then((demuxResult)=>{
            const remuxResult = this.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, this.id);
            return {
                remuxResult,
                chunkMeta
            };
        });
    }
    configureTransmuxer(data) {
        const { config, observer, typeSupported, vendor } = this;
        // probe for content type
        let mux;
        for(let i = 0, len = muxConfig.length; i < len; i++){
            var _muxConfig$i$demux;
            if ((_muxConfig$i$demux = muxConfig[i].demux) != null && _muxConfig$i$demux.probe(data)) {
                mux = muxConfig[i];
                break;
            }
        }
        if (!mux) return new Error('Failed to find demuxer by probing fragment data');
        // so let's check that current remuxer and demuxer are still valid
        const demuxer = this.demuxer;
        const remuxer = this.remuxer;
        const Remuxer = mux.remux;
        const Demuxer = mux.demux;
        if (!remuxer || !(remuxer instanceof Remuxer)) this.remuxer = new Remuxer(observer, config, typeSupported, vendor);
        if (!demuxer || !(demuxer instanceof Demuxer)) {
            this.demuxer = new Demuxer(observer, config, typeSupported);
            this.probe = Demuxer.probe;
        }
    }
    needsProbing(discontinuity, trackSwitch) {
        // in case of continuity change, or track switch
        // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
        return !this.demuxer || !this.remuxer || discontinuity || trackSwitch;
    }
    getDecrypter() {
        let decrypter = this.decrypter;
        if (!decrypter) decrypter = this.decrypter = new Decrypter(this.config);
        return decrypter;
    }
}
function getEncryptionType(data, decryptData) {
    let encryptionType = null;
    if (data.byteLength > 0 && (decryptData == null ? void 0 : decryptData.key) != null && decryptData.iv !== null && decryptData.method != null) encryptionType = decryptData;
    return encryptionType;
}
const emptyResult = (chunkMeta)=>({
        remuxResult: {},
        chunkMeta
    });
function isPromise(p) {
    return 'then' in p && p.then instanceof Function;
}
class TransmuxConfig {
    constructor(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts){
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this.initSegmentData = void 0;
        this.duration = void 0;
        this.defaultInitPts = void 0;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this.initSegmentData = initSegmentData;
        this.duration = duration;
        this.defaultInitPts = defaultInitPts || null;
    }
}
class TransmuxState {
    constructor(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange){
        this.discontinuity = void 0;
        this.contiguous = void 0;
        this.accurateTimeOffset = void 0;
        this.trackSwitch = void 0;
        this.timeOffset = void 0;
        this.initSegmentChange = void 0;
        this.discontinuity = discontinuity;
        this.contiguous = contiguous;
        this.accurateTimeOffset = accurateTimeOffset;
        this.trackSwitch = trackSwitch;
        this.timeOffset = timeOffset;
        this.initSegmentChange = initSegmentChange;
    }
}
var eventemitter3 = {
    exports: {}
};
(function(module) {
    var has = Object.prototype.hasOwnProperty, prefix = '~';
    /**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */ function Events() {}
    //
    // We try to not inherit from `Object.prototype`. In some engines creating an
    // instance in this way is faster than calling `Object.create(null)` directly.
    // If `Object.create(null)` is not supported we prefix the event names with a
    // character to make sure that the built-in object properties are not
    // overridden or used as an attack vector.
    //
    if (Object.create) {
        Events.prototype = Object.create(null);
        //
        // This hack is needed because the `__proto__` property is still inherited in
        // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
        //
        if (!new Events().__proto__) prefix = false;
    }
    /**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */ function EE(fn, context, once) {
        this.fn = fn;
        this.context = context;
        this.once = once || false;
    }
    /**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */ function addListener(emitter, event, fn, context, once) {
        if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
        var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
        if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
        else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
        else emitter._events[evt] = [
            emitter._events[evt],
            listener
        ];
        return emitter;
    }
    /**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */ function clearEvent(emitter, evt) {
        if (--emitter._eventsCount === 0) emitter._events = new Events();
        else delete emitter._events[evt];
    }
    /**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */ function EventEmitter() {
        this._events = new Events();
        this._eventsCount = 0;
    }
    /**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */ EventEmitter.prototype.eventNames = function eventNames() {
        var names = [], events, name;
        if (this._eventsCount === 0) return names;
        for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
        if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
        return names;
    };
    /**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */ EventEmitter.prototype.listeners = function listeners(event) {
        var evt = prefix ? prefix + event : event, handlers = this._events[evt];
        if (!handlers) return [];
        if (handlers.fn) return [
            handlers.fn
        ];
        for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
        return ee;
    };
    /**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
        var evt = prefix ? prefix + event : event, listeners = this._events[evt];
        if (!listeners) return 0;
        if (listeners.fn) return 1;
        return listeners.length;
    };
    /**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return false;
        var listeners = this._events[evt], len = arguments.length, args, i;
        if (listeners.fn) {
            if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
            switch(len){
                case 1:
                    return listeners.fn.call(listeners.context), true;
                case 2:
                    return listeners.fn.call(listeners.context, a1), true;
                case 3:
                    return listeners.fn.call(listeners.context, a1, a2), true;
                case 4:
                    return listeners.fn.call(listeners.context, a1, a2, a3), true;
                case 5:
                    return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                case 6:
                    return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
            }
            for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
            listeners.fn.apply(listeners.context, args);
        } else {
            var length = listeners.length, j;
            for(i = 0; i < length; i++){
                if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                switch(len){
                    case 1:
                        listeners[i].fn.call(listeners[i].context);
                        break;
                    case 2:
                        listeners[i].fn.call(listeners[i].context, a1);
                        break;
                    case 3:
                        listeners[i].fn.call(listeners[i].context, a1, a2);
                        break;
                    case 4:
                        listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                        break;
                    default:
                        if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                        listeners[i].fn.apply(listeners[i].context, args);
                }
            }
        }
        return true;
    };
    /**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */ EventEmitter.prototype.on = function on(event, fn, context) {
        return addListener(this, event, fn, context, false);
    };
    /**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */ EventEmitter.prototype.once = function once(event, fn, context) {
        return addListener(this, event, fn, context, true);
    };
    /**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return this;
        if (!fn) {
            clearEvent(this, evt);
            return this;
        }
        var listeners = this._events[evt];
        if (listeners.fn) {
            if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
        } else {
            for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
            //
            // Reset the array, or remove it completely if we have no more listeners.
            //
            if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
            else clearEvent(this, evt);
        }
        return this;
    };
    /**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
        var evt;
        if (event) {
            evt = prefix ? prefix + event : event;
            if (this._events[evt]) clearEvent(this, evt);
        } else {
            this._events = new Events();
            this._eventsCount = 0;
        }
        return this;
    };
    //
    // Alias methods names because people roll like that.
    //
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    //
    // Expose the prefix.
    //
    EventEmitter.prefixed = prefix;
    //
    // Allow `EventEmitter` to be imported as module namespace.
    //
    EventEmitter.EventEmitter = EventEmitter;
    module.exports = EventEmitter;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
var EventEmitter = /*@__PURE__*/ getDefaultExportFromCjs(eventemitter3Exports);
class TransmuxerInterface {
    constructor(hls, id, onTransmuxComplete, onFlush){
        this.error = null;
        this.hls = void 0;
        this.id = void 0;
        this.observer = void 0;
        this.frag = null;
        this.part = null;
        this.useWorker = void 0;
        this.workerContext = null;
        this.onwmsg = void 0;
        this.transmuxer = null;
        this.onTransmuxComplete = void 0;
        this.onFlush = void 0;
        const config = hls.config;
        this.hls = hls;
        this.id = id;
        this.useWorker = !!config.enableWorker;
        this.onTransmuxComplete = onTransmuxComplete;
        this.onFlush = onFlush;
        const forwardMessage = (ev, data)=>{
            data = data || {};
            data.frag = this.frag;
            data.id = this.id;
            if (ev === Events.ERROR) this.error = data.error;
            this.hls.trigger(ev, data);
        };
        // forward events to main thread
        this.observer = new EventEmitter();
        this.observer.on(Events.FRAG_DECRYPTED, forwardMessage);
        this.observer.on(Events.ERROR, forwardMessage);
        const MediaSource = getMediaSource(config.preferManagedMediaSource) || {
            isTypeSupported: ()=>false
        };
        const m2tsTypeSupported = {
            mpeg: MediaSource.isTypeSupported('audio/mpeg'),
            mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
            ac3: MediaSource.isTypeSupported('audio/mp4; codecs="ac-3"')
        };
        // navigator.vendor is not always available in Web Worker
        // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
        const vendor = navigator.vendor;
        if (this.useWorker && typeof Worker !== 'undefined') {
            const canCreateWorker = config.workerPath || hasUMDWorker();
            if (canCreateWorker) {
                try {
                    if (config.workerPath) {
                        logger.log(`loading Web Worker ${config.workerPath} for "${id}"`);
                        this.workerContext = loadWorker(config.workerPath);
                    } else {
                        logger.log(`injecting Web Worker for "${id}"`);
                        this.workerContext = injectWorker();
                    }
                    this.onwmsg = (ev)=>this.onWorkerMessage(ev);
                    const { worker } = this.workerContext;
                    worker.addEventListener('message', this.onwmsg);
                    worker.onerror = (event)=>{
                        const error = new Error(`${event.message}  (${event.filename}:${event.lineno})`);
                        config.enableWorker = false;
                        logger.warn(`Error in "${id}" Web Worker, fallback to inline`);
                        this.hls.trigger(Events.ERROR, {
                            type: ErrorTypes.OTHER_ERROR,
                            details: ErrorDetails.INTERNAL_EXCEPTION,
                            fatal: false,
                            event: 'demuxerWorker',
                            error
                        });
                    };
                    worker.postMessage({
                        cmd: 'init',
                        typeSupported: m2tsTypeSupported,
                        vendor: vendor,
                        id: id,
                        config: JSON.stringify(config)
                    });
                } catch (err) {
                    logger.warn(`Error setting up "${id}" Web Worker, fallback to inline`, err);
                    this.resetWorker();
                    this.error = null;
                    this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, vendor, id);
                }
                return;
            }
        }
        this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, vendor, id);
    }
    resetWorker() {
        if (this.workerContext) {
            const { worker, objectURL } = this.workerContext;
            if (objectURL) // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
            self.URL.revokeObjectURL(objectURL);
            worker.removeEventListener('message', this.onwmsg);
            worker.onerror = null;
            worker.terminate();
            this.workerContext = null;
        }
    }
    destroy() {
        if (this.workerContext) {
            this.resetWorker();
            this.onwmsg = undefined;
        } else {
            const transmuxer = this.transmuxer;
            if (transmuxer) {
                transmuxer.destroy();
                this.transmuxer = null;
            }
        }
        const observer = this.observer;
        if (observer) observer.removeAllListeners();
        this.frag = null;
        // @ts-ignore
        this.observer = null;
        // @ts-ignore
        this.hls = null;
    }
    push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
        var _frag$initSegment, _lastFrag$initSegment;
        chunkMeta.transmuxing.start = self.performance.now();
        const { transmuxer } = this;
        const timeOffset = part ? part.start : frag.start;
        // TODO: push "clear-lead" decrypt data for unencrypted fragments in streams with encrypted ones
        const decryptdata = frag.decryptdata;
        const lastFrag = this.frag;
        const discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
        const trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
        const snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
        const partDiff = this.part ? chunkMeta.part - this.part.index : -1;
        const progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag == null ? void 0 : lastFrag.stats.chunkCount);
        const contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
        const now = self.performance.now();
        if (trackSwitch || snDiff || frag.stats.parsing.start === 0) frag.stats.parsing.start = now;
        if (part && (partDiff || !contiguous)) part.stats.parsing.start = now;
        const initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) == null ? void 0 : _lastFrag$initSegment.url));
        const state = new TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
        if (!contiguous || discontinuity || initSegmentChange) {
            logger.log(`[transmuxer-interface, ${frag.type}]: Starting new transmux session for sn: ${chunkMeta.sn} p: ${chunkMeta.part} level: ${chunkMeta.level} id: ${chunkMeta.id}
        discontinuity: ${discontinuity}
        trackSwitch: ${trackSwitch}
        contiguous: ${contiguous}
        accurateTimeOffset: ${accurateTimeOffset}
        timeOffset: ${timeOffset}
        initSegmentChange: ${initSegmentChange}`);
            const config = new TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
            this.configureTransmuxer(config);
        }
        this.frag = frag;
        this.part = part;
        // Frags with sn of 'initSegment' are not transmuxed
        if (this.workerContext) // post fragment payload as transferable objects for ArrayBuffer (no copy)
        this.workerContext.worker.postMessage({
            cmd: 'demux',
            data,
            decryptdata,
            chunkMeta,
            state
        }, data instanceof ArrayBuffer ? [
            data
        ] : []);
        else if (transmuxer) {
            const transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
            if (isPromise(transmuxResult)) {
                transmuxer.async = true;
                transmuxResult.then((data)=>{
                    this.handleTransmuxComplete(data);
                }).catch((error)=>{
                    this.transmuxerError(error, chunkMeta, 'transmuxer-interface push error');
                });
            } else {
                transmuxer.async = false;
                this.handleTransmuxComplete(transmuxResult);
            }
        }
    }
    flush(chunkMeta) {
        chunkMeta.transmuxing.start = self.performance.now();
        const { transmuxer } = this;
        if (this.workerContext) this.workerContext.worker.postMessage({
            cmd: 'flush',
            chunkMeta
        });
        else if (transmuxer) {
            let transmuxResult = transmuxer.flush(chunkMeta);
            const asyncFlush = isPromise(transmuxResult);
            if (asyncFlush || transmuxer.async) {
                if (!isPromise(transmuxResult)) transmuxResult = Promise.resolve(transmuxResult);
                transmuxResult.then((data)=>{
                    this.handleFlushResult(data, chunkMeta);
                }).catch((error)=>{
                    this.transmuxerError(error, chunkMeta, 'transmuxer-interface flush error');
                });
            } else this.handleFlushResult(transmuxResult, chunkMeta);
        }
    }
    transmuxerError(error, chunkMeta, reason) {
        if (!this.hls) return;
        this.error = error;
        this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.FRAG_PARSING_ERROR,
            chunkMeta,
            fatal: false,
            error,
            err: error,
            reason
        });
    }
    handleFlushResult(results, chunkMeta) {
        results.forEach((result)=>{
            this.handleTransmuxComplete(result);
        });
        this.onFlush(chunkMeta);
    }
    onWorkerMessage(ev) {
        const data = ev.data;
        const hls = this.hls;
        switch(data.event){
            case 'init':
                {
                    var _this$workerContext;
                    const objectURL = (_this$workerContext = this.workerContext) == null ? void 0 : _this$workerContext.objectURL;
                    if (objectURL) // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
                    self.URL.revokeObjectURL(objectURL);
                    break;
                }
            case 'transmuxComplete':
                this.handleTransmuxComplete(data.data);
                break;
            case 'flush':
                this.onFlush(data.data);
                break;
            // pass logs from the worker thread to the main logger
            case 'workerLog':
                if (logger[data.data.logType]) logger[data.data.logType](data.data.message);
                break;
            default:
                data.data = data.data || {};
                data.data.frag = this.frag;
                data.data.id = this.id;
                hls.trigger(data.event, data.data);
                break;
        }
    }
    configureTransmuxer(config) {
        const { transmuxer } = this;
        if (this.workerContext) this.workerContext.worker.postMessage({
            cmd: 'configure',
            config
        });
        else if (transmuxer) transmuxer.configure(config);
    }
    handleTransmuxComplete(result) {
        result.chunkMeta.transmuxing.end = self.performance.now();
        this.onTransmuxComplete(result);
    }
}
function subtitleOptionsIdentical(trackList1, trackList2) {
    if (trackList1.length !== trackList2.length) return false;
    for(let i = 0; i < trackList1.length; i++){
        if (!mediaAttributesIdentical(trackList1[i].attrs, trackList2[i].attrs)) return false;
    }
    return true;
}
function mediaAttributesIdentical(attrs1, attrs2, customAttributes) {
    // Media options with the same rendition ID must be bit identical
    const stableRenditionId = attrs1['STABLE-RENDITION-ID'];
    if (stableRenditionId && !customAttributes) return stableRenditionId === attrs2['STABLE-RENDITION-ID'];
    // When rendition ID is not present, compare attributes
    return !(customAttributes || [
        'LANGUAGE',
        'NAME',
        'CHARACTERISTICS',
        'AUTOSELECT',
        'DEFAULT',
        'FORCED',
        'ASSOC-LANGUAGE'
    ]).some((subtitleAttribute)=>attrs1[subtitleAttribute] !== attrs2[subtitleAttribute]);
}
function subtitleTrackMatchesTextTrack(subtitleTrack, textTrack) {
    return textTrack.label.toLowerCase() === subtitleTrack.name.toLowerCase() && (!textTrack.language || textTrack.language.toLowerCase() === (subtitleTrack.lang || '').toLowerCase());
}
const TICK_INTERVAL$2 = 100; // how often to tick in ms
class AudioStreamController extends BaseStreamController {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, '[audio-stream-controller]', PlaylistLevelType.AUDIO);
        this.videoBuffer = null;
        this.videoTrackCC = -1;
        this.waitingVideoCC = -1;
        this.bufferedTrack = null;
        this.switchingTrack = null;
        this.trackId = -1;
        this.waitingData = null;
        this.mainDetails = null;
        this.flushing = false;
        this.bufferFlushed = false;
        this.cachedTrackLoadedData = null;
        this._registerListeners();
    }
    onHandlerDestroying() {
        this._unregisterListeners();
        super.onHandlerDestroying();
        this.mainDetails = null;
        this.bufferedTrack = null;
        this.switchingTrack = null;
    }
    _registerListeners() {
        const { hls } = this;
        hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
        hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.on(Events.ERROR, this.onError, this);
        hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
        hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
        hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    _unregisterListeners() {
        const { hls } = this;
        hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
        hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.off(Events.ERROR, this.onError, this);
        hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
        hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
        hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
    onInitPtsFound(event, { frag, id, initPTS, timescale }) {
        // Always update the new INIT PTS
        // Can change due level switch
        if (id === 'main') {
            const cc = frag.cc;
            this.initPTS[frag.cc] = {
                baseTime: initPTS,
                timescale
            };
            this.log(`InitPTS for cc: ${cc} found from main: ${initPTS}`);
            this.videoTrackCC = cc;
            // If we are waiting, tick immediately to unblock audio fragment transmuxing
            if (this.state === State.WAITING_INIT_PTS) this.tick();
        }
    }
    startLoad(startPosition) {
        if (!this.levels) {
            this.startPosition = startPosition;
            this.state = State.STOPPED;
            return;
        }
        const lastCurrentTime = this.lastCurrentTime;
        this.stopLoad();
        this.setInterval(TICK_INTERVAL$2);
        if (lastCurrentTime > 0 && startPosition === -1) {
            this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
            startPosition = lastCurrentTime;
            this.state = State.IDLE;
        } else {
            this.loadedmetadata = false;
            this.state = State.WAITING_TRACK;
        }
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
        this.tick();
    }
    doTick() {
        switch(this.state){
            case State.IDLE:
                this.doTickIdle();
                break;
            case State.WAITING_TRACK:
                {
                    var _levels$trackId;
                    const { levels, trackId } = this;
                    const details = levels == null ? void 0 : (_levels$trackId = levels[trackId]) == null ? void 0 : _levels$trackId.details;
                    if (details) {
                        if (this.waitForCdnTuneIn(details)) break;
                        this.state = State.WAITING_INIT_PTS;
                    }
                    break;
                }
            case State.FRAG_LOADING_WAITING_RETRY:
                {
                    var _this$media;
                    const now = performance.now();
                    const retryDate = this.retryDate;
                    // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                    if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
                        const { levels, trackId } = this;
                        this.log('RetryDate reached, switch back to IDLE state');
                        this.resetStartWhenNotLoaded((levels == null ? void 0 : levels[trackId]) || null);
                        this.state = State.IDLE;
                    }
                    break;
                }
            case State.WAITING_INIT_PTS:
                {
                    // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
                    const waitingData = this.waitingData;
                    if (waitingData) {
                        const { frag, part, cache, complete } = waitingData;
                        if (this.initPTS[frag.cc] !== undefined) {
                            this.waitingData = null;
                            this.waitingVideoCC = -1;
                            this.state = State.FRAG_LOADING;
                            const payload = cache.flush();
                            const data = {
                                frag,
                                part,
                                payload,
                                networkDetails: null
                            };
                            this._handleFragmentLoadProgress(data);
                            if (complete) super._handleFragmentLoadComplete(data);
                        } else if (this.videoTrackCC !== this.waitingVideoCC) {
                            // Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
                            this.log(`Waiting fragment cc (${frag.cc}) cancelled because video is at cc ${this.videoTrackCC}`);
                            this.clearWaitingFragment();
                        } else {
                            // Drop waiting fragment if an earlier fragment is needed
                            const pos = this.getLoadPosition();
                            const bufferInfo = BufferHelper.bufferInfo(this.mediaBuffer, pos, this.config.maxBufferHole);
                            const waitingFragmentAtPosition = fragmentWithinToleranceTest(bufferInfo.end, this.config.maxFragLookUpTolerance, frag);
                            if (waitingFragmentAtPosition < 0) {
                                this.log(`Waiting fragment cc (${frag.cc}) @ ${frag.start} cancelled because another fragment at ${bufferInfo.end} is needed`);
                                this.clearWaitingFragment();
                            }
                        }
                    } else this.state = State.IDLE;
                }
        }
        this.onTickEnd();
    }
    clearWaitingFragment() {
        const waitingData = this.waitingData;
        if (waitingData) {
            this.fragmentTracker.removeFragment(waitingData.frag);
            this.waitingData = null;
            this.waitingVideoCC = -1;
            this.state = State.IDLE;
        }
    }
    resetLoadingState() {
        this.clearWaitingFragment();
        super.resetLoadingState();
    }
    onTickEnd() {
        const { media } = this;
        if (!(media != null && media.readyState)) // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
        return;
        this.lastCurrentTime = media.currentTime;
    }
    doTickIdle() {
        const { hls, levels, media, trackId } = this;
        const config = hls.config;
        // 1. if video not attached AND
        //    start fragment already requested OR start frag prefetch not enabled
        // 2. if tracks or track not loaded and selected
        // then exit loop
        // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
        if (!media && (this.startFragRequested || !config.startFragPrefetch) || !(levels != null && levels[trackId])) return;
        const levelInfo = levels[trackId];
        const trackDetails = levelInfo.details;
        if (!trackDetails || trackDetails.live && this.levelLastLoaded !== levelInfo || this.waitForCdnTuneIn(trackDetails)) {
            this.state = State.WAITING_TRACK;
            return;
        }
        const bufferable = this.mediaBuffer ? this.mediaBuffer : this.media;
        if (this.bufferFlushed && bufferable) {
            this.bufferFlushed = false;
            this.afterBufferFlushed(bufferable, ElementaryStreamTypes.AUDIO, PlaylistLevelType.AUDIO);
        }
        const bufferInfo = this.getFwdBufferInfo(bufferable, PlaylistLevelType.AUDIO);
        if (bufferInfo === null) return;
        const { bufferedTrack, switchingTrack } = this;
        if (!switchingTrack && this._streamEnded(bufferInfo, trackDetails)) {
            hls.trigger(Events.BUFFER_EOS, {
                type: 'audio'
            });
            this.state = State.ENDED;
            return;
        }
        const mainBufferInfo = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, PlaylistLevelType.MAIN);
        const bufferLen = bufferInfo.len;
        const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len);
        const fragments = trackDetails.fragments;
        const start = fragments[0].start;
        let targetBufferTime = this.flushing ? this.getLoadPosition() : bufferInfo.end;
        if (switchingTrack && media) {
            const pos = this.getLoadPosition();
            // STABLE
            if (bufferedTrack && !mediaAttributesIdentical(switchingTrack.attrs, bufferedTrack.attrs)) targetBufferTime = pos;
            // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
            if (trackDetails.PTSKnown && pos < start) // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
            {
                if (bufferInfo.end > start || bufferInfo.nextStart) {
                    this.log('Alt audio track ahead of main track, seek to start of alt audio track');
                    media.currentTime = start + 0.05;
                }
            }
        }
        // if buffer length is less than maxBufLen, or near the end, find a fragment to load
        if (bufferLen >= maxBufLen && !switchingTrack && targetBufferTime < fragments[fragments.length - 1].start) return;
        let frag = this.getNextFragment(targetBufferTime, trackDetails);
        let atGap = false;
        // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
        if (frag && this.isLoopLoading(frag, targetBufferTime)) {
            atGap = !!frag.gap;
            frag = this.getNextFragmentLoopLoading(frag, trackDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
        }
        if (!frag) {
            this.bufferFlushed = true;
            return;
        }
        // Buffer audio up to one target duration ahead of main buffer
        const atBufferSyncLimit = mainBufferInfo && frag.start > mainBufferInfo.end + trackDetails.targetduration;
        if (atBufferSyncLimit || // Or wait for main buffer after buffing some audio
        !(mainBufferInfo != null && mainBufferInfo.len) && bufferInfo.len) {
            // Check fragment-tracker for main fragments since GAP segments do not show up in bufferInfo
            const mainFrag = this.getAppendedFrag(frag.start, PlaylistLevelType.MAIN);
            if (mainFrag === null) return;
            // Bridge gaps in main buffer
            atGap || (atGap = !!mainFrag.gap || !!atBufferSyncLimit && mainBufferInfo.len === 0);
            if (atBufferSyncLimit && !atGap || atGap && bufferInfo.nextStart && bufferInfo.nextStart < mainFrag.end) return;
        }
        this.loadFragment(frag, levelInfo, targetBufferTime);
    }
    getMaxBufferLength(mainBufferLength) {
        const maxConfigBuffer = super.getMaxBufferLength();
        if (!mainBufferLength) return maxConfigBuffer;
        return Math.min(Math.max(maxConfigBuffer, mainBufferLength), this.config.maxMaxBufferLength);
    }
    onMediaDetaching() {
        this.videoBuffer = null;
        this.bufferFlushed = this.flushing = false;
        super.onMediaDetaching();
    }
    onAudioTracksUpdated(event, { audioTracks }) {
        // Reset tranxmuxer is essential for large context switches (Content Steering)
        this.resetTransmuxer();
        this.levels = audioTracks.map((mediaPlaylist)=>new Level(mediaPlaylist));
    }
    onAudioTrackSwitching(event, data) {
        // if any URL found on new audio track, it is an alternate audio track
        const altAudio = !!data.url;
        this.trackId = data.id;
        const { fragCurrent } = this;
        if (fragCurrent) {
            fragCurrent.abortRequests();
            this.removeUnbufferedFrags(fragCurrent.start);
        }
        this.resetLoadingState();
        // destroy useless transmuxer when switching audio to main
        if (!altAudio) this.resetTransmuxer();
        else // switching to audio track, start timer if not already started
        this.setInterval(TICK_INTERVAL$2);
        // should we switch tracks ?
        if (altAudio) {
            this.switchingTrack = data;
            // main audio track are handled by stream-controller, just do something if switching to alt audio track
            this.state = State.IDLE;
            this.flushAudioIfNeeded(data);
        } else {
            this.switchingTrack = null;
            this.bufferedTrack = data;
            this.state = State.STOPPED;
        }
        this.tick();
    }
    onManifestLoading() {
        this.fragmentTracker.removeAllFragments();
        this.startPosition = this.lastCurrentTime = 0;
        this.bufferFlushed = this.flushing = false;
        this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null;
        this.startFragRequested = false;
        this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
    }
    onLevelLoaded(event, data) {
        this.mainDetails = data.details;
        if (this.cachedTrackLoadedData !== null) {
            this.hls.trigger(Events.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData);
            this.cachedTrackLoadedData = null;
        }
    }
    onAudioTrackLoaded(event, data) {
        var _track$details;
        if (this.mainDetails == null) {
            this.cachedTrackLoadedData = data;
            return;
        }
        const { levels } = this;
        const { details: newDetails, id: trackId } = data;
        if (!levels) {
            this.warn(`Audio tracks were reset while loading level ${trackId}`);
            return;
        }
        this.log(`Audio track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
        const track = levels[trackId];
        let sliding = 0;
        if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
            this.checkLiveUpdate(newDetails);
            const mainDetails = this.mainDetails;
            if (newDetails.deltaUpdateFailed || !mainDetails) return;
            if (!track.details && newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
                // Make sure our audio rendition is aligned with the "main" rendition, using
                // pdt as our reference times.
                alignMediaPlaylistByPDT(newDetails, mainDetails);
                sliding = newDetails.fragments[0].start;
            } else {
                var _this$levelLastLoaded;
                sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
            }
        }
        track.details = newDetails;
        this.levelLastLoaded = track;
        // compute start position if we are aligned with the main playlist
        if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) this.setStartPosition(this.mainDetails || newDetails, sliding);
        // only switch back to IDLE state if we were waiting for track to start downloading a new fragment
        if (this.state === State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) this.state = State.IDLE;
        // trigger handler right now
        this.tick();
    }
    _handleFragmentLoadProgress(data) {
        var _frag$initSegment;
        const { frag, part, payload } = data;
        const { config, trackId, levels } = this;
        if (!levels) {
            this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
            return;
        }
        const track = levels[trackId];
        if (!track) {
            this.warn('Audio track is undefined on fragment load progress');
            return;
        }
        const details = track.details;
        if (!details) {
            this.warn('Audio track details undefined on fragment load progress');
            this.removeUnbufferedFrags(frag.start);
            return;
        }
        const audioCodec = config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2';
        let transmuxer = this.transmuxer;
        if (!transmuxer) transmuxer = this.transmuxer = new TransmuxerInterface(this.hls, PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
        // Check if we have video initPTS
        // If not we need to wait for it
        const initPTS = this.initPTS[frag.cc];
        const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
        if (initPTS !== undefined) {
            // this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
            // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
            const accurateTimeOffset = false; // details.PTSKnown || !details.live;
            const partIndex = part ? part.index : -1;
            const partial = partIndex !== -1;
            const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
            transmuxer.push(payload, initSegmentData, audioCodec, '', frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
        } else {
            this.log(`Unknown video PTS for cc ${frag.cc}, waiting for video PTS before demuxing audio frag ${frag.sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
            const { cache } = this.waitingData = this.waitingData || {
                frag,
                part,
                cache: new ChunkCache(),
                complete: false
            };
            cache.push(new Uint8Array(payload));
            this.waitingVideoCC = this.videoTrackCC;
            this.state = State.WAITING_INIT_PTS;
        }
    }
    _handleFragmentLoadComplete(fragLoadedData) {
        if (this.waitingData) {
            this.waitingData.complete = true;
            return;
        }
        super._handleFragmentLoadComplete(fragLoadedData);
    }
    onBufferReset() {
        // reset reference to sourcebuffers
        this.mediaBuffer = this.videoBuffer = null;
        this.loadedmetadata = false;
    }
    onBufferCreated(event, data) {
        const audioTrack = data.tracks.audio;
        if (audioTrack) this.mediaBuffer = audioTrack.buffer || null;
        if (data.tracks.video) this.videoBuffer = data.tracks.video.buffer || null;
    }
    onFragBuffered(event, data) {
        const { frag, part } = data;
        if (frag.type !== PlaylistLevelType.AUDIO) {
            if (!this.loadedmetadata && frag.type === PlaylistLevelType.MAIN) {
                const bufferable = this.videoBuffer || this.media;
                if (bufferable) {
                    const bufferedTimeRanges = BufferHelper.getBuffered(bufferable);
                    if (bufferedTimeRanges.length) this.loadedmetadata = true;
                }
            }
            return;
        }
        if (this.fragContextChanged(frag)) {
            // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
            // Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
            this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : 'false'}`);
            return;
        }
        if (frag.sn !== 'initSegment') {
            this.fragPrevious = frag;
            const track = this.switchingTrack;
            if (track) {
                this.bufferedTrack = track;
                this.switchingTrack = null;
                this.hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, track));
            }
        }
        this.fragBufferedComplete(frag, part);
    }
    onError(event, data) {
        var _data$context;
        if (data.fatal) {
            this.state = State.ERROR;
            return;
        }
        switch(data.details){
            case ErrorDetails.FRAG_GAP:
            case ErrorDetails.FRAG_PARSING_ERROR:
            case ErrorDetails.FRAG_DECRYPT_ERROR:
            case ErrorDetails.FRAG_LOAD_ERROR:
            case ErrorDetails.FRAG_LOAD_TIMEOUT:
            case ErrorDetails.KEY_LOAD_ERROR:
            case ErrorDetails.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError(PlaylistLevelType.AUDIO, data);
                break;
            case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
            case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
            case ErrorDetails.LEVEL_PARSING_ERROR:
                // in case of non fatal error while loading track, if not retrying to load track, switch back to IDLE
                if (!data.levelRetry && this.state === State.WAITING_TRACK && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.AUDIO_TRACK) this.state = State.IDLE;
                break;
            case ErrorDetails.BUFFER_APPEND_ERROR:
            case ErrorDetails.BUFFER_FULL_ERROR:
                if (!data.parent || data.parent !== 'audio') return;
                if (data.details === ErrorDetails.BUFFER_APPEND_ERROR) {
                    this.resetLoadingState();
                    return;
                }
                if (this.reduceLengthAndFlushBuffer(data)) {
                    this.bufferedTrack = null;
                    super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
                }
                break;
            case ErrorDetails.INTERNAL_EXCEPTION:
                this.recoverWorkerError(data);
                break;
        }
    }
    onBufferFlushing(event, { type }) {
        if (type !== ElementaryStreamTypes.VIDEO) this.flushing = true;
    }
    onBufferFlushed(event, { type }) {
        if (type !== ElementaryStreamTypes.VIDEO) {
            this.flushing = false;
            this.bufferFlushed = true;
            if (this.state === State.ENDED) this.state = State.IDLE;
            const mediaBuffer = this.mediaBuffer || this.media;
            if (mediaBuffer) {
                this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.AUDIO);
                this.tick();
            }
        }
    }
    _handleTransmuxComplete(transmuxResult) {
        var _id3$samples;
        const id = 'audio';
        const { hls } = this;
        const { remuxResult, chunkMeta } = transmuxResult;
        const context = this.getCurrentContext(chunkMeta);
        if (!context) {
            this.resetWhenMissingContext(chunkMeta);
            return;
        }
        const { frag, part, level } = context;
        const { details } = level;
        const { audio, text, id3, initSegment } = remuxResult;
        // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
        // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
        if (this.fragContextChanged(frag) || !details) {
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        this.state = State.PARSING;
        if (this.switchingTrack && audio) this.completeAudioSwitch(this.switchingTrack);
        if (initSegment != null && initSegment.tracks) {
            const mapFragment = frag.initSegment || frag;
            this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
            hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
                frag: mapFragment,
                id,
                tracks: initSegment.tracks
            });
        // Only flush audio from old audio tracks when PTS is known on new audio track
        }
        if (audio) {
            const { startPTS, endPTS, startDTS, endDTS } = audio;
            if (part) part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
                startPTS,
                endPTS,
                startDTS,
                endDTS
            };
            frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
            this.bufferFragmentData(audio, frag, part, chunkMeta);
        }
        if (id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
            const emittedID3 = _extends({
                id,
                frag,
                details
            }, id3);
            hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
        }
        if (text) {
            const emittedText = _extends({
                id,
                frag,
                details
            }, text);
            hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
        }
    }
    _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
        if (this.state !== State.PARSING) return;
        // delete any video track found on audio transmuxer
        if (tracks.video) delete tracks.video;
        // include levelCodec in audio and video tracks
        const track = tracks.audio;
        if (!track) return;
        track.id = 'audio';
        const variantAudioCodecs = currentLevel.audioCodec;
        this.log(`Init audio buffer, container:${track.container}, codecs[level/parsed]=[${variantAudioCodecs}/${track.codec}]`);
        // SourceBuffer will use track.levelCodec if defined
        if (variantAudioCodecs && variantAudioCodecs.split(',').length === 1) track.levelCodec = variantAudioCodecs;
        this.hls.trigger(Events.BUFFER_CODECS, tracks);
        const initSegment = track.initSegment;
        if (initSegment != null && initSegment.byteLength) {
            const segment = {
                type: 'audio',
                frag,
                part: null,
                chunkMeta,
                parent: frag.type,
                data: initSegment
            };
            this.hls.trigger(Events.BUFFER_APPENDING, segment);
        }
        // trigger handler right now
        this.tickImmediate();
    }
    loadFragment(frag, track, targetBufferTime) {
        // only load if fragment is not loaded or if in audio switch
        const fragState = this.fragmentTracker.getState(frag);
        this.fragCurrent = frag;
        // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
        if (this.switchingTrack || fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
            var _track$details2;
            if (frag.sn === 'initSegment') this._loadInitSegment(frag, track);
            else if ((_track$details2 = track.details) != null && _track$details2.live && !this.initPTS[frag.cc]) {
                this.log(`Waiting for video PTS in continuity counter ${frag.cc} of live stream before loading audio fragment ${frag.sn} of level ${this.trackId}`);
                this.state = State.WAITING_INIT_PTS;
                const mainDetails = this.mainDetails;
                if (mainDetails && mainDetails.fragments[0].start !== track.details.fragments[0].start) alignMediaPlaylistByPDT(track.details, mainDetails);
            } else {
                this.startFragRequested = true;
                super.loadFragment(frag, track, targetBufferTime);
            }
        } else this.clearTrackerIfNeeded(frag);
    }
    flushAudioIfNeeded(switchingTrack) {
        const { media, bufferedTrack } = this;
        const bufferedAttributes = bufferedTrack == null ? void 0 : bufferedTrack.attrs;
        const switchAttributes = switchingTrack.attrs;
        if (media && bufferedAttributes && (bufferedAttributes.CHANNELS !== switchAttributes.CHANNELS || bufferedTrack.name !== switchingTrack.name || bufferedTrack.lang !== switchingTrack.lang)) {
            this.log('Switching audio track : flushing all audio');
            super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
            this.bufferedTrack = null;
        }
    }
    completeAudioSwitch(switchingTrack) {
        const { hls } = this;
        this.flushAudioIfNeeded(switchingTrack);
        this.bufferedTrack = switchingTrack;
        this.switchingTrack = null;
        hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, switchingTrack));
    }
}
class AudioTrackController extends BasePlaylistController {
    constructor(hls){
        super(hls, '[audio-track-controller]');
        this.tracks = [];
        this.groupIds = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
        this.registerListeners();
    }
    registerListeners() {
        const { hls } = this;
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.on(Events.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls } = this;
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.off(Events.ERROR, this.onError, this);
    }
    destroy() {
        this.unregisterListeners();
        this.tracks.length = 0;
        this.tracksInGroup.length = 0;
        this.currentTrack = null;
        super.destroy();
    }
    onManifestLoading() {
        this.tracks = [];
        this.tracksInGroup = [];
        this.groupIds = null;
        this.currentTrack = null;
        this.trackId = -1;
        this.selectDefaultTrack = true;
    }
    onManifestParsed(event, data) {
        this.tracks = data.audioTracks || [];
    }
    onAudioTrackLoaded(event, data) {
        const { id, groupId, details } = data;
        const trackInActiveGroup = this.tracksInGroup[id];
        if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
            this.warn(`Audio track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
            return;
        }
        const curDetails = trackInActiveGroup.details;
        trackInActiveGroup.details = data.details;
        this.log(`Audio track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
        if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
    }
    onLevelLoading(event, data) {
        this.switchLevel(data.level);
    }
    onLevelSwitching(event, data) {
        this.switchLevel(data.level);
    }
    switchLevel(levelIndex) {
        const levelInfo = this.hls.levels[levelIndex];
        if (!levelInfo) return;
        const audioGroups = levelInfo.audioGroups || null;
        const currentGroups = this.groupIds;
        let currentTrack = this.currentTrack;
        if (!audioGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (audioGroups == null ? void 0 : audioGroups.length) || audioGroups != null && audioGroups.some((groupId)=>(currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
            this.groupIds = audioGroups;
            this.trackId = -1;
            this.currentTrack = null;
            const audioTracks = this.tracks.filter((track)=>!audioGroups || audioGroups.indexOf(track.groupId) !== -1);
            if (audioTracks.length) {
                // Disable selectDefaultTrack if there are no default tracks
                if (this.selectDefaultTrack && !audioTracks.some((track)=>track.default)) this.selectDefaultTrack = false;
                // track.id should match hls.audioTracks index
                audioTracks.forEach((track, i)=>{
                    track.id = i;
                });
            } else if (!currentTrack && !this.tracksInGroup.length) // Do not dispatch AUDIO_TRACKS_UPDATED when there were and are no tracks
            return;
            this.tracksInGroup = audioTracks;
            // Find preferred track
            const audioPreference = this.hls.config.audioPreference;
            if (!currentTrack && audioPreference) {
                const groupIndex = findMatchingOption(audioPreference, audioTracks, audioMatchPredicate);
                if (groupIndex > -1) currentTrack = audioTracks[groupIndex];
                else {
                    const allIndex = findMatchingOption(audioPreference, this.tracks);
                    currentTrack = this.tracks[allIndex];
                }
            }
            // Select initial track
            let trackId = this.findTrackId(currentTrack);
            if (trackId === -1 && currentTrack) trackId = this.findTrackId(null);
            // Dispatch events and load track if needed
            const audioTracksUpdated = {
                audioTracks
            };
            this.log(`Updating audio tracks, ${audioTracks.length} track(s) found in group(s): ${audioGroups == null ? void 0 : audioGroups.join(',')}`);
            this.hls.trigger(Events.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
            const selectedTrackId = this.trackId;
            if (trackId !== -1 && selectedTrackId === -1) this.setAudioTrack(trackId);
            else if (audioTracks.length && selectedTrackId === -1) {
                var _this$groupIds;
                const error = new Error(`No audio track selected for current audio group-ID(s): ${(_this$groupIds = this.groupIds) == null ? void 0 : _this$groupIds.join(',')} track count: ${audioTracks.length}`);
                this.warn(error.message);
                this.hls.trigger(Events.ERROR, {
                    type: ErrorTypes.MEDIA_ERROR,
                    details: ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                    fatal: true,
                    error
                });
            }
        } else if (this.shouldReloadPlaylist(currentTrack)) // Retry playlist loading if no playlist is or has been loaded yet
        this.setAudioTrack(this.trackId);
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === PlaylistContextType.AUDIO_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) {
            this.requestScheduled = -1;
            this.checkRetry(data);
        }
    }
    get allAudioTracks() {
        return this.tracks;
    }
    get audioTracks() {
        return this.tracksInGroup;
    }
    get audioTrack() {
        return this.trackId;
    }
    set audioTrack(newId) {
        // If audio track is selected from API then don't choose from the manifest default track
        this.selectDefaultTrack = false;
        this.setAudioTrack(newId);
    }
    setAudioOption(audioOption) {
        const hls = this.hls;
        hls.config.audioPreference = audioOption;
        if (audioOption) {
            const allAudioTracks = this.allAudioTracks;
            this.selectDefaultTrack = false;
            if (allAudioTracks.length) {
                // First see if current option matches (no switch op)
                const currentTrack = this.currentTrack;
                if (currentTrack && matchesOption(audioOption, currentTrack, audioMatchPredicate)) return currentTrack;
                // Find option in available tracks (tracksInGroup)
                const groupIndex = findMatchingOption(audioOption, this.tracksInGroup, audioMatchPredicate);
                if (groupIndex > -1) {
                    const track = this.tracksInGroup[groupIndex];
                    this.setAudioTrack(groupIndex);
                    return track;
                } else if (currentTrack) {
                    // Find option in nearest level audio group
                    let searchIndex = hls.loadLevel;
                    if (searchIndex === -1) searchIndex = hls.firstAutoLevel;
                    const switchIndex = findClosestLevelWithAudioGroup(audioOption, hls.levels, allAudioTracks, searchIndex, audioMatchPredicate);
                    if (switchIndex === -1) // could not find matching variant
                    return null;
                    // and switch level to acheive the audio group switch
                    hls.nextLoadLevel = switchIndex;
                }
                if (audioOption.channels || audioOption.audioCodec) {
                    // Could not find a match with codec / channels predicate
                    // Find a match without channels or codec
                    const withoutCodecAndChannelsMatch = findMatchingOption(audioOption, allAudioTracks);
                    if (withoutCodecAndChannelsMatch > -1) return allAudioTracks[withoutCodecAndChannelsMatch];
                }
            }
        }
        return null;
    }
    setAudioTrack(newId) {
        const tracks = this.tracksInGroup;
        // check if level idx is valid
        if (newId < 0 || newId >= tracks.length) {
            this.warn(`Invalid audio track id: ${newId}`);
            return;
        }
        // stopping live reloading timer if any
        this.clearTimer();
        this.selectDefaultTrack = false;
        const lastTrack = this.currentTrack;
        const track = tracks[newId];
        const trackLoaded = track.details && !track.details.live;
        if (newId === this.trackId && track === lastTrack && trackLoaded) return;
        this.log(`Switching to audio-track ${newId} "${track.name}" lang:${track.lang} group:${track.groupId} channels:${track.channels}`);
        this.trackId = newId;
        this.currentTrack = track;
        this.hls.trigger(Events.AUDIO_TRACK_SWITCHING, _objectSpread2({}, track));
        // Do not reload track unless live
        if (trackLoaded) return;
        const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
        this.loadPlaylist(hlsUrlParameters);
    }
    findTrackId(currentTrack) {
        const audioTracks = this.tracksInGroup;
        for(let i = 0; i < audioTracks.length; i++){
            const track = audioTracks[i];
            if (this.selectDefaultTrack && !track.default) continue;
            if (!currentTrack || matchesOption(currentTrack, track, audioMatchPredicate)) return i;
        }
        if (currentTrack) {
            const { name, lang, assocLang, characteristics, audioCodec, channels } = currentTrack;
            for(let i = 0; i < audioTracks.length; i++){
                const track = audioTracks[i];
                if (matchesOption({
                    name,
                    lang,
                    assocLang,
                    characteristics,
                    audioCodec,
                    channels
                }, track, audioMatchPredicate)) return i;
            }
            for(let i = 0; i < audioTracks.length; i++){
                const track = audioTracks[i];
                if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE',
                    'ASSOC-LANGUAGE',
                    'CHARACTERISTICS'
                ])) return i;
            }
            for(let i = 0; i < audioTracks.length; i++){
                const track = audioTracks[i];
                if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE'
                ])) return i;
            }
        }
        return -1;
    }
    loadPlaylist(hlsUrlParameters) {
        const audioTrack = this.currentTrack;
        if (this.shouldLoadPlaylist(audioTrack) && audioTrack) {
            super.loadPlaylist();
            const id = audioTrack.id;
            const groupId = audioTrack.groupId;
            let url = audioTrack.url;
            if (hlsUrlParameters) try {
                url = hlsUrlParameters.addDirectives(url);
            } catch (error) {
                this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
            }
            // track not retrieved yet, or live playlist we need to (re)load it
            this.log(`loading audio-track playlist ${id} "${audioTrack.name}" lang:${audioTrack.lang} group:${groupId}`);
            this.clearTimer();
            this.hls.trigger(Events.AUDIO_TRACK_LOADING, {
                url,
                id,
                groupId,
                deliveryDirectives: hlsUrlParameters || null
            });
        }
    }
}
const TICK_INTERVAL$1 = 500; // how often to tick in ms
class SubtitleStreamController extends BaseStreamController {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, '[subtitle-stream-controller]', PlaylistLevelType.SUBTITLE);
        this.currentTrackId = -1;
        this.tracksBuffered = [];
        this.mainDetails = null;
        this._registerListeners();
    }
    onHandlerDestroying() {
        this._unregisterListeners();
        super.onHandlerDestroying();
        this.mainDetails = null;
    }
    _registerListeners() {
        const { hls } = this;
        hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on(Events.ERROR, this.onError, this);
        hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.on(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.on(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
        hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    _unregisterListeners() {
        const { hls } = this;
        hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off(Events.ERROR, this.onError, this);
        hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.off(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.off(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
        hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    startLoad(startPosition) {
        this.stopLoad();
        this.state = State.IDLE;
        this.setInterval(TICK_INTERVAL$1);
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
        this.tick();
    }
    onManifestLoading() {
        this.mainDetails = null;
        this.fragmentTracker.removeAllFragments();
    }
    onMediaDetaching() {
        this.tracksBuffered = [];
        super.onMediaDetaching();
    }
    onLevelLoaded(event, data) {
        this.mainDetails = data.details;
    }
    onSubtitleFragProcessed(event, data) {
        const { frag, success } = data;
        this.fragPrevious = frag;
        this.state = State.IDLE;
        if (!success) return;
        const buffered = this.tracksBuffered[this.currentTrackId];
        if (!buffered) return;
        // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
        // so we can re-use the logic used to detect how much has been buffered
        let timeRange;
        const fragStart = frag.start;
        for(let i = 0; i < buffered.length; i++)if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
            timeRange = buffered[i];
            break;
        }
        const fragEnd = frag.start + frag.duration;
        if (timeRange) timeRange.end = fragEnd;
        else {
            timeRange = {
                start: fragStart,
                end: fragEnd
            };
            buffered.push(timeRange);
        }
        this.fragmentTracker.fragBuffered(frag);
        this.fragBufferedComplete(frag, null);
    }
    onBufferFlushing(event, data) {
        const { startOffset, endOffset } = data;
        if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
            const endOffsetSubtitles = endOffset - 1;
            if (endOffsetSubtitles <= 0) return;
            data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
            this.tracksBuffered.forEach((buffered)=>{
                for(let i = 0; i < buffered.length;){
                    if (buffered[i].end <= endOffsetSubtitles) {
                        buffered.shift();
                        continue;
                    } else if (buffered[i].start < endOffsetSubtitles) buffered[i].start = endOffsetSubtitles;
                    else break;
                    i++;
                }
            });
            this.fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, PlaylistLevelType.SUBTITLE);
        }
    }
    onFragBuffered(event, data) {
        if (!this.loadedmetadata && data.frag.type === PlaylistLevelType.MAIN) {
            var _this$media;
            if ((_this$media = this.media) != null && _this$media.buffered.length) this.loadedmetadata = true;
        }
    }
    // If something goes wrong, proceed to next frag, if we were processing one.
    onError(event, data) {
        const frag = data.frag;
        if ((frag == null ? void 0 : frag.type) === PlaylistLevelType.SUBTITLE) {
            if (this.fragCurrent) this.fragCurrent.abortRequests();
            if (this.state !== State.STOPPED) this.state = State.IDLE;
        }
    }
    // Got all new subtitle levels.
    onSubtitleTracksUpdated(event, { subtitleTracks }) {
        if (this.levels && subtitleOptionsIdentical(this.levels, subtitleTracks)) {
            this.levels = subtitleTracks.map((mediaPlaylist)=>new Level(mediaPlaylist));
            return;
        }
        this.tracksBuffered = [];
        this.levels = subtitleTracks.map((mediaPlaylist)=>{
            const level = new Level(mediaPlaylist);
            this.tracksBuffered[level.id] = [];
            return level;
        });
        this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, PlaylistLevelType.SUBTITLE);
        this.fragPrevious = null;
        this.mediaBuffer = null;
    }
    onSubtitleTrackSwitch(event, data) {
        var _this$levels;
        this.currentTrackId = data.id;
        if (!((_this$levels = this.levels) != null && _this$levels.length) || this.currentTrackId === -1) {
            this.clearInterval();
            return;
        }
        // Check if track has the necessary details to load fragments
        const currentTrack = this.levels[this.currentTrackId];
        if (currentTrack != null && currentTrack.details) this.mediaBuffer = this.mediaBufferTimeRanges;
        else this.mediaBuffer = null;
        if (currentTrack) this.setInterval(TICK_INTERVAL$1);
    }
    // Got a new set of subtitle fragments.
    onSubtitleTrackLoaded(event, data) {
        var _track$details;
        const { currentTrackId, levels } = this;
        const { details: newDetails, id: trackId } = data;
        if (!levels) {
            this.warn(`Subtitle tracks were reset while loading level ${trackId}`);
            return;
        }
        const track = levels[currentTrackId];
        if (trackId >= levels.length || trackId !== currentTrackId || !track) return;
        this.log(`Subtitle track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
        this.mediaBuffer = this.mediaBufferTimeRanges;
        let sliding = 0;
        if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
            const mainDetails = this.mainDetails;
            if (newDetails.deltaUpdateFailed || !mainDetails) return;
            const mainSlidingStartFragment = mainDetails.fragments[0];
            if (!track.details) {
                if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
                    alignMediaPlaylistByPDT(newDetails, mainDetails);
                    sliding = newDetails.fragments[0].start;
                } else if (mainSlidingStartFragment) {
                    // line up live playlist with main so that fragments in range are loaded
                    sliding = mainSlidingStartFragment.start;
                    addSliding(newDetails, sliding);
                }
            } else {
                var _this$levelLastLoaded;
                sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
                if (sliding === 0 && mainSlidingStartFragment) {
                    // realign with main when there is no overlap with last refresh
                    sliding = mainSlidingStartFragment.start;
                    addSliding(newDetails, sliding);
                }
            }
        }
        track.details = newDetails;
        this.levelLastLoaded = track;
        if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) this.setStartPosition(this.mainDetails || newDetails, sliding);
        // trigger handler right now
        this.tick();
        // If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
        if (newDetails.live && !this.fragCurrent && this.media && this.state === State.IDLE) {
            const foundFrag = findFragmentByPTS(null, newDetails.fragments, this.media.currentTime, 0);
            if (!foundFrag) {
                this.warn('Subtitle playlist not aligned with playback');
                track.details = undefined;
            }
        }
    }
    _handleFragmentLoadComplete(fragLoadedData) {
        const { frag, payload } = fragLoadedData;
        const decryptData = frag.decryptdata;
        const hls = this.hls;
        if (this.fragContextChanged(frag)) return;
        // check to see if the payload needs to be decrypted
        if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && decryptData.method === 'AES-128') {
            const startTime = performance.now();
            // decrypt the subtitles
            this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch((err)=>{
                hls.trigger(Events.ERROR, {
                    type: ErrorTypes.MEDIA_ERROR,
                    details: ErrorDetails.FRAG_DECRYPT_ERROR,
                    fatal: false,
                    error: err,
                    reason: err.message,
                    frag
                });
                throw err;
            }).then((decryptedData)=>{
                const endTime = performance.now();
                hls.trigger(Events.FRAG_DECRYPTED, {
                    frag,
                    payload: decryptedData,
                    stats: {
                        tstart: startTime,
                        tdecrypt: endTime
                    }
                });
            }).catch((err)=>{
                this.warn(`${err.name}: ${err.message}`);
                this.state = State.IDLE;
            });
        }
    }
    doTick() {
        if (!this.media) {
            this.state = State.IDLE;
            return;
        }
        if (this.state === State.IDLE) {
            const { currentTrackId, levels } = this;
            const track = levels == null ? void 0 : levels[currentTrackId];
            if (!track || !levels.length || !track.details) return;
            const { config } = this;
            const currentTime = this.getLoadPosition();
            const bufferedInfo = BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], currentTime, config.maxBufferHole);
            const { end: targetBufferTime, len: bufferLen } = bufferedInfo;
            const mainBufferInfo = this.getFwdBufferInfo(this.media, PlaylistLevelType.MAIN);
            const trackDetails = track.details;
            const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len) + trackDetails.levelTargetDuration;
            if (bufferLen > maxBufLen) return;
            const fragments = trackDetails.fragments;
            const fragLen = fragments.length;
            const end = trackDetails.edge;
            let foundFrag = null;
            const fragPrevious = this.fragPrevious;
            if (targetBufferTime < end) {
                const tolerance = config.maxFragLookUpTolerance;
                const lookupTolerance = targetBufferTime > end - tolerance ? 0 : tolerance;
                foundFrag = findFragmentByPTS(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), lookupTolerance);
                if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) foundFrag = fragments[0];
            } else foundFrag = fragments[fragLen - 1];
            if (!foundFrag) return;
            foundFrag = this.mapToInitFragWhenRequired(foundFrag);
            if (foundFrag.sn !== 'initSegment') {
                // Load earlier fragment in same discontinuity to make up for misaligned playlists and cues that extend beyond end of segment
                const curSNIdx = foundFrag.sn - trackDetails.startSN;
                const prevFrag = fragments[curSNIdx - 1];
                if (prevFrag && prevFrag.cc === foundFrag.cc && this.fragmentTracker.getState(prevFrag) === FragmentState.NOT_LOADED) foundFrag = prevFrag;
            }
            if (this.fragmentTracker.getState(foundFrag) === FragmentState.NOT_LOADED) // only load if fragment is not loaded
            this.loadFragment(foundFrag, track, targetBufferTime);
        }
    }
    getMaxBufferLength(mainBufferLength) {
        const maxConfigBuffer = super.getMaxBufferLength();
        if (!mainBufferLength) return maxConfigBuffer;
        return Math.max(maxConfigBuffer, mainBufferLength);
    }
    loadFragment(frag, level, targetBufferTime) {
        this.fragCurrent = frag;
        if (frag.sn === 'initSegment') this._loadInitSegment(frag, level);
        else {
            this.startFragRequested = true;
            super.loadFragment(frag, level, targetBufferTime);
        }
    }
    get mediaBufferTimeRanges() {
        return new BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
    }
}
class BufferableInstance {
    constructor(timeranges){
        this.buffered = void 0;
        const getRange = (name, index, length)=>{
            index = index >>> 0;
            if (index > length - 1) throw new DOMException(`Failed to execute '${name}' on 'TimeRanges': The index provided (${index}) is greater than the maximum bound (${length})`);
            return timeranges[index][name];
        };
        this.buffered = {
            get length () {
                return timeranges.length;
            },
            end (index) {
                return getRange('end', index, timeranges.length);
            },
            start (index) {
                return getRange('start', index, timeranges.length);
            }
        };
    }
}
class SubtitleTrackController extends BasePlaylistController {
    constructor(hls){
        super(hls, '[subtitle-track-controller]');
        this.media = null;
        this.tracks = [];
        this.groupIds = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
        this.queuedDefaultTrack = -1;
        this.asyncPollTrackChange = ()=>this.pollTrackChange(0);
        this.useTextTrackPolling = false;
        this.subtitlePollingInterval = -1;
        this._subtitleDisplay = true;
        this.onTextTracksChanged = ()=>{
            if (!this.useTextTrackPolling) self.clearInterval(this.subtitlePollingInterval);
            // Media is undefined when switching streams via loadSource()
            if (!this.media || !this.hls.config.renderTextTracksNatively) return;
            let textTrack = null;
            const tracks = filterSubtitleTracks(this.media.textTracks);
            for(let i = 0; i < tracks.length; i++){
                if (tracks[i].mode === 'hidden') // Do not break in case there is a following track with showing.
                textTrack = tracks[i];
                else if (tracks[i].mode === 'showing') {
                    textTrack = tracks[i];
                    break;
                }
            }
            // Find internal track index for TextTrack
            const trackId = this.findTrackForTextTrack(textTrack);
            if (this.subtitleTrack !== trackId) this.setSubtitleTrack(trackId);
        };
        this.registerListeners();
    }
    destroy() {
        this.unregisterListeners();
        this.tracks.length = 0;
        this.tracksInGroup.length = 0;
        this.currentTrack = null;
        this.onTextTracksChanged = this.asyncPollTrackChange = null;
        super.destroy();
    }
    get subtitleDisplay() {
        return this._subtitleDisplay;
    }
    set subtitleDisplay(value) {
        this._subtitleDisplay = value;
        if (this.trackId > -1) this.toggleTrackModes();
    }
    registerListeners() {
        const { hls } = this;
        hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.on(Events.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls } = this;
        hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.off(Events.ERROR, this.onError, this);
    }
    // Listen for subtitle track change, then extract the current track ID.
    onMediaAttached(event, data) {
        this.media = data.media;
        if (!this.media) return;
        if (this.queuedDefaultTrack > -1) {
            this.subtitleTrack = this.queuedDefaultTrack;
            this.queuedDefaultTrack = -1;
        }
        this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
        if (this.useTextTrackPolling) this.pollTrackChange(500);
        else this.media.textTracks.addEventListener('change', this.asyncPollTrackChange);
    }
    pollTrackChange(timeout) {
        self.clearInterval(this.subtitlePollingInterval);
        this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, timeout);
    }
    onMediaDetaching() {
        if (!this.media) return;
        self.clearInterval(this.subtitlePollingInterval);
        if (!this.useTextTrackPolling) this.media.textTracks.removeEventListener('change', this.asyncPollTrackChange);
        if (this.trackId > -1) this.queuedDefaultTrack = this.trackId;
        const textTracks = filterSubtitleTracks(this.media.textTracks);
        // Clear loaded cues on media detachment from tracks
        textTracks.forEach((track)=>{
            clearCurrentCues(track);
        });
        // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
        this.subtitleTrack = -1;
        this.media = null;
    }
    onManifestLoading() {
        this.tracks = [];
        this.groupIds = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
    }
    // Fired whenever a new manifest is loaded.
    onManifestParsed(event, data) {
        this.tracks = data.subtitleTracks;
    }
    onSubtitleTrackLoaded(event, data) {
        const { id, groupId, details } = data;
        const trackInActiveGroup = this.tracksInGroup[id];
        if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
            this.warn(`Subtitle track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
            return;
        }
        const curDetails = trackInActiveGroup.details;
        trackInActiveGroup.details = data.details;
        this.log(`Subtitle track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
        if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
    }
    onLevelLoading(event, data) {
        this.switchLevel(data.level);
    }
    onLevelSwitching(event, data) {
        this.switchLevel(data.level);
    }
    switchLevel(levelIndex) {
        const levelInfo = this.hls.levels[levelIndex];
        if (!levelInfo) return;
        const subtitleGroups = levelInfo.subtitleGroups || null;
        const currentGroups = this.groupIds;
        let currentTrack = this.currentTrack;
        if (!subtitleGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (subtitleGroups == null ? void 0 : subtitleGroups.length) || subtitleGroups != null && subtitleGroups.some((groupId)=>(currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
            this.groupIds = subtitleGroups;
            this.trackId = -1;
            this.currentTrack = null;
            const subtitleTracks = this.tracks.filter((track)=>!subtitleGroups || subtitleGroups.indexOf(track.groupId) !== -1);
            if (subtitleTracks.length) {
                // Disable selectDefaultTrack if there are no default tracks
                if (this.selectDefaultTrack && !subtitleTracks.some((track)=>track.default)) this.selectDefaultTrack = false;
                // track.id should match hls.audioTracks index
                subtitleTracks.forEach((track, i)=>{
                    track.id = i;
                });
            } else if (!currentTrack && !this.tracksInGroup.length) // Do not dispatch SUBTITLE_TRACKS_UPDATED when there were and are no tracks
            return;
            this.tracksInGroup = subtitleTracks;
            // Find preferred track
            const subtitlePreference = this.hls.config.subtitlePreference;
            if (!currentTrack && subtitlePreference) {
                this.selectDefaultTrack = false;
                const groupIndex = findMatchingOption(subtitlePreference, subtitleTracks);
                if (groupIndex > -1) currentTrack = subtitleTracks[groupIndex];
                else {
                    const allIndex = findMatchingOption(subtitlePreference, this.tracks);
                    currentTrack = this.tracks[allIndex];
                }
            }
            // Select initial track
            let trackId = this.findTrackId(currentTrack);
            if (trackId === -1 && currentTrack) trackId = this.findTrackId(null);
            // Dispatch events and load track if needed
            const subtitleTracksUpdated = {
                subtitleTracks
            };
            this.log(`Updating subtitle tracks, ${subtitleTracks.length} track(s) found in "${subtitleGroups == null ? void 0 : subtitleGroups.join(',')}" group-id`);
            this.hls.trigger(Events.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
            if (trackId !== -1 && this.trackId === -1) this.setSubtitleTrack(trackId);
        } else if (this.shouldReloadPlaylist(currentTrack)) // Retry playlist loading if no playlist is or has been loaded yet
        this.setSubtitleTrack(this.trackId);
    }
    findTrackId(currentTrack) {
        const tracks = this.tracksInGroup;
        const selectDefault = this.selectDefaultTrack;
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            if (selectDefault && !track.default || !selectDefault && !currentTrack) continue;
            if (!currentTrack || matchesOption(track, currentTrack)) return i;
        }
        if (currentTrack) {
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE',
                    'ASSOC-LANGUAGE',
                    'CHARACTERISTICS'
                ])) return i;
            }
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE'
                ])) return i;
            }
        }
        return -1;
    }
    findTrackForTextTrack(textTrack) {
        if (textTrack) {
            const tracks = this.tracksInGroup;
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                if (subtitleTrackMatchesTextTrack(track, textTrack)) return i;
            }
        }
        return -1;
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === PlaylistContextType.SUBTITLE_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) this.checkRetry(data);
    }
    get allSubtitleTracks() {
        return this.tracks;
    }
    /** get alternate subtitle tracks list from playlist **/ get subtitleTracks() {
        return this.tracksInGroup;
    }
    /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/ get subtitleTrack() {
        return this.trackId;
    }
    set subtitleTrack(newId) {
        this.selectDefaultTrack = false;
        this.setSubtitleTrack(newId);
    }
    setSubtitleOption(subtitleOption) {
        this.hls.config.subtitlePreference = subtitleOption;
        if (subtitleOption) {
            const allSubtitleTracks = this.allSubtitleTracks;
            this.selectDefaultTrack = false;
            if (allSubtitleTracks.length) {
                // First see if current option matches (no switch op)
                const currentTrack = this.currentTrack;
                if (currentTrack && matchesOption(subtitleOption, currentTrack)) return currentTrack;
                // Find option in current group
                const groupIndex = findMatchingOption(subtitleOption, this.tracksInGroup);
                if (groupIndex > -1) {
                    const track = this.tracksInGroup[groupIndex];
                    this.setSubtitleTrack(groupIndex);
                    return track;
                } else if (currentTrack) // If this is not the initial selection return null
                // option should have matched one in active group
                return null;
                else {
                    // Find the option in all tracks for initial selection
                    const allIndex = findMatchingOption(subtitleOption, allSubtitleTracks);
                    if (allIndex > -1) return allSubtitleTracks[allIndex];
                }
            }
        }
        return null;
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        const currentTrack = this.currentTrack;
        if (this.shouldLoadPlaylist(currentTrack) && currentTrack) {
            const id = currentTrack.id;
            const groupId = currentTrack.groupId;
            let url = currentTrack.url;
            if (hlsUrlParameters) try {
                url = hlsUrlParameters.addDirectives(url);
            } catch (error) {
                this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
            }
            this.log(`Loading subtitle playlist for id ${id}`);
            this.hls.trigger(Events.SUBTITLE_TRACK_LOADING, {
                url,
                id,
                groupId,
                deliveryDirectives: hlsUrlParameters || null
            });
        }
    }
    /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */ toggleTrackModes() {
        const { media } = this;
        if (!media) return;
        const textTracks = filterSubtitleTracks(media.textTracks);
        const currentTrack = this.currentTrack;
        let nextTrack;
        if (currentTrack) {
            nextTrack = textTracks.filter((textTrack)=>subtitleTrackMatchesTextTrack(currentTrack, textTrack))[0];
            if (!nextTrack) this.warn(`Unable to find subtitle TextTrack with name "${currentTrack.name}" and language "${currentTrack.lang}"`);
        }
        [].slice.call(textTracks).forEach((track)=>{
            if (track.mode !== 'disabled' && track !== nextTrack) track.mode = 'disabled';
        });
        if (nextTrack) {
            const mode = this.subtitleDisplay ? 'showing' : 'hidden';
            if (nextTrack.mode !== mode) nextTrack.mode = mode;
        }
    }
    /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */ setSubtitleTrack(newId) {
        const tracks = this.tracksInGroup;
        // setting this.subtitleTrack will trigger internal logic
        // if media has not been attached yet, it will fail
        // we keep a reference to the default track id
        // and we'll set subtitleTrack when onMediaAttached is triggered
        if (!this.media) {
            this.queuedDefaultTrack = newId;
            return;
        }
        // exit if track id as already set or invalid
        if (newId < -1 || newId >= tracks.length || !isFiniteNumber(newId)) {
            this.warn(`Invalid subtitle track id: ${newId}`);
            return;
        }
        // stopping live reloading timer if any
        this.clearTimer();
        this.selectDefaultTrack = false;
        const lastTrack = this.currentTrack;
        const track = tracks[newId] || null;
        this.trackId = newId;
        this.currentTrack = track;
        this.toggleTrackModes();
        if (!track) {
            // switch to -1
            this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
                id: newId
            });
            return;
        }
        const trackLoaded = !!track.details && !track.details.live;
        if (newId === this.trackId && track === lastTrack && trackLoaded) return;
        this.log(`Switching to subtitle-track ${newId}` + (track ? ` "${track.name}" lang:${track.lang} group:${track.groupId}` : ''));
        const { id, groupId = '', name, type, url } = track;
        this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
            id,
            groupId,
            name,
            type,
            url
        });
        const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
        this.loadPlaylist(hlsUrlParameters);
    }
}
class BufferOperationQueue {
    constructor(sourceBufferReference){
        this.buffers = void 0;
        this.queues = {
            video: [],
            audio: [],
            audiovideo: []
        };
        this.buffers = sourceBufferReference;
    }
    append(operation, type, pending) {
        const queue = this.queues[type];
        queue.push(operation);
        if (queue.length === 1 && !pending) this.executeNext(type);
    }
    insertAbort(operation, type) {
        const queue = this.queues[type];
        queue.unshift(operation);
        this.executeNext(type);
    }
    appendBlocker(type) {
        let execute;
        const promise = new Promise((resolve)=>{
            execute = resolve;
        });
        const operation = {
            execute,
            onStart: ()=>{},
            onComplete: ()=>{},
            onError: ()=>{}
        };
        this.append(operation, type);
        return promise;
    }
    executeNext(type) {
        const queue = this.queues[type];
        if (queue.length) {
            const operation = queue[0];
            try {
                // Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
                // which do not end with this event must call _onSBUpdateEnd manually
                operation.execute();
            } catch (error) {
                logger.warn(`[buffer-operation-queue]: Exception executing "${type}" SourceBuffer operation: ${error}`);
                operation.onError(error);
                // Only shift the current operation off, otherwise the updateend handler will do this for us
                const sb = this.buffers[type];
                if (!(sb != null && sb.updating)) this.shiftAndExecuteNext(type);
            }
        }
    }
    shiftAndExecuteNext(type) {
        this.queues[type].shift();
        this.executeNext(type);
    }
    current(type) {
        return this.queues[type][0];
    }
}
const VIDEO_CODEC_PROFILE_REPLACE = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
class BufferController {
    constructor(hls){
        // The level details used to determine duration, target-duration and live
        this.details = null;
        // cache the self generated object url to detect hijack of video tag
        this._objectUrl = null;
        // A queue of buffer operations which require the SourceBuffer to not be updating upon execution
        this.operationQueue = void 0;
        // References to event listeners for each SourceBuffer, so that they can be referenced for event removal
        this.listeners = void 0;
        this.hls = void 0;
        // The number of BUFFER_CODEC events received before any sourceBuffers are created
        this.bufferCodecEventsExpected = 0;
        // The total number of BUFFER_CODEC events received
        this._bufferCodecEventsTotal = 0;
        // A reference to the attached media element
        this.media = null;
        // A reference to the active media source
        this.mediaSource = null;
        // Last MP3 audio chunk appended
        this.lastMpegAudioChunk = null;
        this.appendSource = void 0;
        // counters
        this.appendErrors = {
            audio: 0,
            video: 0,
            audiovideo: 0
        };
        this.tracks = {};
        this.pendingTracks = {};
        this.sourceBuffer = void 0;
        this.log = void 0;
        this.warn = void 0;
        this.error = void 0;
        this._onEndStreaming = (event)=>{
            if (!this.hls) return;
            this.hls.pauseBuffering();
        };
        this._onStartStreaming = (event)=>{
            if (!this.hls) return;
            this.hls.resumeBuffering();
        };
        // Keep as arrow functions so that we can directly reference these functions directly as event listeners
        this._onMediaSourceOpen = ()=>{
            const { media, mediaSource } = this;
            this.log('Media source opened');
            if (media) {
                media.removeEventListener('emptied', this._onMediaEmptied);
                this.updateMediaElementDuration();
                this.hls.trigger(Events.MEDIA_ATTACHED, {
                    media,
                    mediaSource: mediaSource
                });
            }
            if (mediaSource) // once received, don't listen anymore to sourceopen event
            mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
            this.checkPendingTracks();
        };
        this._onMediaSourceClose = ()=>{
            this.log('Media source closed');
        };
        this._onMediaSourceEnded = ()=>{
            this.log('Media source ended');
        };
        this._onMediaEmptied = ()=>{
            const { mediaSrc, _objectUrl } = this;
            if (mediaSrc !== _objectUrl) logger.error(`Media element src was set while attaching MediaSource (${_objectUrl} > ${mediaSrc})`);
        };
        this.hls = hls;
        const logPrefix = '[buffer-controller]';
        this.appendSource = isManagedMediaSource(getMediaSource(hls.config.preferManagedMediaSource));
        this.log = logger.log.bind(logger, logPrefix);
        this.warn = logger.warn.bind(logger, logPrefix);
        this.error = logger.error.bind(logger, logPrefix);
        this._initSourceBuffer();
        this.registerListeners();
    }
    hasSourceTypes() {
        return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
    }
    destroy() {
        this.unregisterListeners();
        this.details = null;
        this.lastMpegAudioChunk = null;
        // @ts-ignore
        this.hls = null;
    }
    registerListeners() {
        const { hls } = this;
        hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
        hls.on(Events.BUFFER_APPENDING, this.onBufferAppending, this);
        hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.on(Events.BUFFER_EOS, this.onBufferEos, this);
        hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.on(Events.FRAG_PARSED, this.onFragParsed, this);
        hls.on(Events.FRAG_CHANGED, this.onFragChanged, this);
    }
    unregisterListeners() {
        const { hls } = this;
        hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
        hls.off(Events.BUFFER_APPENDING, this.onBufferAppending, this);
        hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.off(Events.BUFFER_EOS, this.onBufferEos, this);
        hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.off(Events.FRAG_PARSED, this.onFragParsed, this);
        hls.off(Events.FRAG_CHANGED, this.onFragChanged, this);
    }
    _initSourceBuffer() {
        this.sourceBuffer = {};
        this.operationQueue = new BufferOperationQueue(this.sourceBuffer);
        this.listeners = {
            audio: [],
            video: [],
            audiovideo: []
        };
        this.appendErrors = {
            audio: 0,
            video: 0,
            audiovideo: 0
        };
        this.lastMpegAudioChunk = null;
    }
    onManifestLoading() {
        this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0;
        this.details = null;
    }
    onManifestParsed(event, data) {
        // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
        // sourcebuffers will be created all at once when the expected nb of tracks will be reached
        // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
        // it will contain the expected nb of source buffers, no need to compute it
        let codecEvents = 2;
        if (data.audio && !data.video || !data.altAudio || false) codecEvents = 1;
        this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = codecEvents;
        this.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
    }
    onMediaAttaching(event, data) {
        const media = this.media = data.media;
        const MediaSource = getMediaSource(this.appendSource);
        if (media && MediaSource) {
            var _ms$constructor;
            const ms = this.mediaSource = new MediaSource();
            this.log(`created media source: ${(_ms$constructor = ms.constructor) == null ? void 0 : _ms$constructor.name}`);
            // MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
            ms.addEventListener('sourceopen', this._onMediaSourceOpen);
            ms.addEventListener('sourceended', this._onMediaSourceEnded);
            ms.addEventListener('sourceclose', this._onMediaSourceClose);
            if (this.appendSource) {
                ms.addEventListener('startstreaming', this._onStartStreaming);
                ms.addEventListener('endstreaming', this._onEndStreaming);
            }
            // cache the locally generated object url
            const objectUrl = this._objectUrl = self.URL.createObjectURL(ms);
            // link video and media Source
            if (this.appendSource) try {
                media.removeAttribute('src');
                // ManagedMediaSource will not open without disableRemotePlayback set to false or source alternatives
                const MMS = self.ManagedMediaSource;
                media.disableRemotePlayback = media.disableRemotePlayback || MMS && ms instanceof MMS;
                removeSourceChildren(media);
                addSource(media, objectUrl);
                media.load();
            } catch (error) {
                media.src = objectUrl;
            }
            else media.src = objectUrl;
            media.addEventListener('emptied', this._onMediaEmptied);
        }
    }
    onMediaDetaching() {
        const { media, mediaSource, _objectUrl } = this;
        if (mediaSource) {
            this.log('media source detaching');
            if (mediaSource.readyState === 'open') try {
                // endOfStream could trigger exception if any sourcebuffer is in updating state
                // we don't really care about checking sourcebuffer state here,
                // as we are anyway detaching the MediaSource
                // let's just avoid this exception to propagate
                mediaSource.endOfStream();
            } catch (err) {
                this.warn(`onMediaDetaching: ${err.message} while calling endOfStream`);
            }
            // Clean up the SourceBuffers by invoking onBufferReset
            this.onBufferReset();
            mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
            mediaSource.removeEventListener('sourceended', this._onMediaSourceEnded);
            mediaSource.removeEventListener('sourceclose', this._onMediaSourceClose);
            if (this.appendSource) {
                mediaSource.removeEventListener('startstreaming', this._onStartStreaming);
                mediaSource.removeEventListener('endstreaming', this._onEndStreaming);
            }
            // Detach properly the MediaSource from the HTMLMediaElement as
            // suggested in https://github.com/w3c/media-source/issues/53.
            if (media) {
                media.removeEventListener('emptied', this._onMediaEmptied);
                if (_objectUrl) self.URL.revokeObjectURL(_objectUrl);
                // clean up video tag src only if it's our own url. some external libraries might
                // hijack the video tag and change its 'src' without destroying the Hls instance first
                if (this.mediaSrc === _objectUrl) {
                    media.removeAttribute('src');
                    if (this.appendSource) removeSourceChildren(media);
                    media.load();
                } else this.warn('media|source.src was changed by a third party - skip cleanup');
            }
            this.mediaSource = null;
            this.media = null;
            this._objectUrl = null;
            this.bufferCodecEventsExpected = this._bufferCodecEventsTotal;
            this.pendingTracks = {};
            this.tracks = {};
        }
        this.hls.trigger(Events.MEDIA_DETACHED, undefined);
    }
    onBufferReset() {
        this.getSourceBufferTypes().forEach((type)=>{
            this.resetBuffer(type);
        });
        this._initSourceBuffer();
    }
    resetBuffer(type) {
        const sb = this.sourceBuffer[type];
        try {
            if (sb) {
                var _this$mediaSource;
                this.removeBufferListeners(type);
                // Synchronously remove the SB from the map before the next call in order to prevent an async function from
                // accessing it
                this.sourceBuffer[type] = undefined;
                if ((_this$mediaSource = this.mediaSource) != null && _this$mediaSource.sourceBuffers.length) this.mediaSource.removeSourceBuffer(sb);
            }
        } catch (err) {
            this.warn(`onBufferReset ${type}`, err);
        }
    }
    onBufferCodecs(event, data) {
        const sourceBufferCount = this.getSourceBufferTypes().length;
        const trackNames = Object.keys(data);
        trackNames.forEach((trackName)=>{
            if (sourceBufferCount) {
                // check if SourceBuffer codec needs to change
                const track = this.tracks[trackName];
                if (track && typeof track.buffer.changeType === 'function') {
                    var _trackCodec;
                    const { id, codec, levelCodec, container, metadata } = data[trackName];
                    const currentCodecFull = pickMostCompleteCodecName(track.codec, track.levelCodec);
                    const currentCodec = currentCodecFull == null ? void 0 : currentCodecFull.replace(VIDEO_CODEC_PROFILE_REPLACE, '$1');
                    let trackCodec = pickMostCompleteCodecName(codec, levelCodec);
                    const nextCodec = (_trackCodec = trackCodec) == null ? void 0 : _trackCodec.replace(VIDEO_CODEC_PROFILE_REPLACE, '$1');
                    if (trackCodec && currentCodec !== nextCodec) {
                        if (trackName.slice(0, 5) === 'audio') trackCodec = getCodecCompatibleName(trackCodec, this.appendSource);
                        const mimeType = `${container};codecs=${trackCodec}`;
                        this.appendChangeType(trackName, mimeType);
                        this.log(`switching codec ${currentCodecFull} to ${trackCodec}`);
                        this.tracks[trackName] = {
                            buffer: track.buffer,
                            codec,
                            container,
                            levelCodec,
                            metadata,
                            id
                        };
                    }
                }
            } else // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
            this.pendingTracks[trackName] = data[trackName];
        });
        // if sourcebuffers already created, do nothing ...
        if (sourceBufferCount) return;
        const bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0);
        if (this.bufferCodecEventsExpected !== bufferCodecEventsExpected) {
            this.log(`${bufferCodecEventsExpected} bufferCodec event(s) expected ${trackNames.join(',')}`);
            this.bufferCodecEventsExpected = bufferCodecEventsExpected;
        }
        if (this.mediaSource && this.mediaSource.readyState === 'open') this.checkPendingTracks();
    }
    appendChangeType(type, mimeType) {
        const { operationQueue } = this;
        const operation = {
            execute: ()=>{
                const sb = this.sourceBuffer[type];
                if (sb) {
                    this.log(`changing ${type} sourceBuffer type to ${mimeType}`);
                    sb.changeType(mimeType);
                }
                operationQueue.shiftAndExecuteNext(type);
            },
            onStart: ()=>{},
            onComplete: ()=>{},
            onError: (error)=>{
                this.warn(`Failed to change ${type} SourceBuffer type`, error);
            }
        };
        operationQueue.append(operation, type, !!this.pendingTracks[type]);
    }
    onBufferAppending(event, eventData) {
        const { hls, operationQueue, tracks } = this;
        const { data, type, frag, part, chunkMeta } = eventData;
        const chunkStats = chunkMeta.buffering[type];
        const bufferAppendingStart = self.performance.now();
        chunkStats.start = bufferAppendingStart;
        const fragBuffering = frag.stats.buffering;
        const partBuffering = part ? part.stats.buffering : null;
        if (fragBuffering.start === 0) fragBuffering.start = bufferAppendingStart;
        if (partBuffering && partBuffering.start === 0) partBuffering.start = bufferAppendingStart;
        // TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
        // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
        // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
        // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
        // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
        const audioTrack = tracks.audio;
        let checkTimestampOffset = false;
        if (type === 'audio' && (audioTrack == null ? void 0 : audioTrack.container) === 'audio/mpeg') {
            checkTimestampOffset = !this.lastMpegAudioChunk || chunkMeta.id === 1 || this.lastMpegAudioChunk.sn !== chunkMeta.sn;
            this.lastMpegAudioChunk = chunkMeta;
        }
        const fragStart = frag.start;
        const operation = {
            execute: ()=>{
                chunkStats.executeStart = self.performance.now();
                if (checkTimestampOffset) {
                    const sb = this.sourceBuffer[type];
                    if (sb) {
                        const delta = fragStart - sb.timestampOffset;
                        if (Math.abs(delta) >= 0.1) {
                            this.log(`Updating audio SourceBuffer timestampOffset to ${fragStart} (delta: ${delta}) sn: ${frag.sn})`);
                            sb.timestampOffset = fragStart;
                        }
                    }
                }
                this.appendExecutor(data, type);
            },
            onStart: ()=>{
            // logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
            },
            onComplete: ()=>{
                // logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
                const end = self.performance.now();
                chunkStats.executeEnd = chunkStats.end = end;
                if (fragBuffering.first === 0) fragBuffering.first = end;
                if (partBuffering && partBuffering.first === 0) partBuffering.first = end;
                const { sourceBuffer } = this;
                const timeRanges = {};
                for(const type in sourceBuffer)timeRanges[type] = BufferHelper.getBuffered(sourceBuffer[type]);
                this.appendErrors[type] = 0;
                if (type === 'audio' || type === 'video') this.appendErrors.audiovideo = 0;
                else {
                    this.appendErrors.audio = 0;
                    this.appendErrors.video = 0;
                }
                this.hls.trigger(Events.BUFFER_APPENDED, {
                    type,
                    frag,
                    part,
                    chunkMeta,
                    parent: frag.type,
                    timeRanges
                });
            },
            onError: (error)=>{
                // in case any error occured while appending, put back segment in segments table
                const event = {
                    type: ErrorTypes.MEDIA_ERROR,
                    parent: frag.type,
                    details: ErrorDetails.BUFFER_APPEND_ERROR,
                    sourceBufferName: type,
                    frag,
                    part,
                    chunkMeta,
                    error,
                    err: error,
                    fatal: false
                };
                if (error.code === DOMException.QUOTA_EXCEEDED_ERR) // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
                // let's stop appending any segments, and report BUFFER_FULL_ERROR error
                event.details = ErrorDetails.BUFFER_FULL_ERROR;
                else {
                    const appendErrorCount = ++this.appendErrors[type];
                    event.details = ErrorDetails.BUFFER_APPEND_ERROR;
                    /* with UHD content, we could get loop of quota exceeded error until
            browser is able to evict some data from sourcebuffer. Retrying can help recover.
          */ this.warn(`Failed ${appendErrorCount}/${hls.config.appendErrorMaxRetry} times to append segment in "${type}" sourceBuffer`);
                    if (appendErrorCount >= hls.config.appendErrorMaxRetry) event.fatal = true;
                }
                hls.trigger(Events.ERROR, event);
            }
        };
        operationQueue.append(operation, type, !!this.pendingTracks[type]);
    }
    onBufferFlushing(event, data) {
        const { operationQueue } = this;
        const flushOperation = (type)=>({
                execute: this.removeExecutor.bind(this, type, data.startOffset, data.endOffset),
                onStart: ()=>{
                // logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
                },
                onComplete: ()=>{
                    // logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
                    this.hls.trigger(Events.BUFFER_FLUSHED, {
                        type
                    });
                },
                onError: (error)=>{
                    this.warn(`Failed to remove from ${type} SourceBuffer`, error);
                }
            });
        if (data.type) operationQueue.append(flushOperation(data.type), data.type);
        else this.getSourceBufferTypes().forEach((type)=>{
            operationQueue.append(flushOperation(type), type);
        });
    }
    onFragParsed(event, data) {
        const { frag, part } = data;
        const buffersAppendedTo = [];
        const elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
        if (elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO]) buffersAppendedTo.push('audiovideo');
        else {
            if (elementaryStreams[ElementaryStreamTypes.AUDIO]) buffersAppendedTo.push('audio');
            if (elementaryStreams[ElementaryStreamTypes.VIDEO]) buffersAppendedTo.push('video');
        }
        const onUnblocked = ()=>{
            const now = self.performance.now();
            frag.stats.buffering.end = now;
            if (part) part.stats.buffering.end = now;
            const stats = part ? part.stats : frag.stats;
            this.hls.trigger(Events.FRAG_BUFFERED, {
                frag,
                part,
                stats,
                id: frag.type
            });
        };
        if (buffersAppendedTo.length === 0) this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${frag.type} level: ${frag.level} sn: ${frag.sn}`);
        this.blockBuffers(onUnblocked, buffersAppendedTo);
    }
    onFragChanged(event, data) {
        this.trimBuffers();
    }
    // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
    // an undefined data.type will mark all buffers as EOS.
    onBufferEos(event, data) {
        const ended = this.getSourceBufferTypes().reduce((acc, type)=>{
            const sb = this.sourceBuffer[type];
            if (sb && (!data.type || data.type === type)) {
                sb.ending = true;
                if (!sb.ended) {
                    sb.ended = true;
                    this.log(`${type} sourceBuffer now EOS`);
                }
            }
            return acc && !!(!sb || sb.ended);
        }, true);
        if (ended) {
            this.log(`Queueing mediaSource.endOfStream()`);
            this.blockBuffers(()=>{
                this.getSourceBufferTypes().forEach((type)=>{
                    const sb = this.sourceBuffer[type];
                    if (sb) sb.ending = false;
                });
                const { mediaSource } = this;
                if (!mediaSource || mediaSource.readyState !== 'open') {
                    if (mediaSource) this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${mediaSource.readyState}`);
                    return;
                }
                this.log(`Calling mediaSource.endOfStream()`);
                // Allow this to throw and be caught by the enqueueing function
                mediaSource.endOfStream();
            });
        }
    }
    onLevelUpdated(event, { details }) {
        if (!details.fragments.length) return;
        this.details = details;
        if (this.getSourceBufferTypes().length) this.blockBuffers(this.updateMediaElementDuration.bind(this));
        else this.updateMediaElementDuration();
    }
    trimBuffers() {
        const { hls, details, media } = this;
        if (!media || details === null) return;
        const sourceBufferTypes = this.getSourceBufferTypes();
        if (!sourceBufferTypes.length) return;
        const config = hls.config;
        const currentTime = media.currentTime;
        const targetDuration = details.levelTargetDuration;
        // Support for deprecated liveBackBufferLength
        const backBufferLength = details.live && config.liveBackBufferLength !== null ? config.liveBackBufferLength : config.backBufferLength;
        if (isFiniteNumber(backBufferLength) && backBufferLength > 0) {
            const maxBackBufferLength = Math.max(backBufferLength, targetDuration);
            const targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
            this.flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition);
        }
        if (isFiniteNumber(config.frontBufferFlushThreshold) && config.frontBufferFlushThreshold > 0) {
            const frontBufferLength = Math.max(config.maxBufferLength, config.frontBufferFlushThreshold);
            const maxFrontBufferLength = Math.max(frontBufferLength, targetDuration);
            const targetFrontBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration + maxFrontBufferLength;
            this.flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition);
        }
    }
    flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition) {
        const { details, sourceBuffer } = this;
        const sourceBufferTypes = this.getSourceBufferTypes();
        sourceBufferTypes.forEach((type)=>{
            const sb = sourceBuffer[type];
            if (sb) {
                const buffered = BufferHelper.getBuffered(sb);
                // when target buffer start exceeds actual buffer start
                if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
                    this.hls.trigger(Events.BACK_BUFFER_REACHED, {
                        bufferEnd: targetBackBufferPosition
                    });
                    // Support for deprecated event:
                    if (details != null && details.live) this.hls.trigger(Events.LIVE_BACK_BUFFER_REACHED, {
                        bufferEnd: targetBackBufferPosition
                    });
                    else if (sb.ended && buffered.end(buffered.length - 1) - currentTime < targetDuration * 2) {
                        this.log(`Cannot flush ${type} back buffer while SourceBuffer is in ended state`);
                        return;
                    }
                    this.hls.trigger(Events.BUFFER_FLUSHING, {
                        startOffset: 0,
                        endOffset: targetBackBufferPosition,
                        type
                    });
                }
            }
        });
    }
    flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition) {
        const { sourceBuffer } = this;
        const sourceBufferTypes = this.getSourceBufferTypes();
        sourceBufferTypes.forEach((type)=>{
            const sb = sourceBuffer[type];
            if (sb) {
                const buffered = BufferHelper.getBuffered(sb);
                const numBufferedRanges = buffered.length;
                // The buffer is either empty or contiguous
                if (numBufferedRanges < 2) return;
                const bufferStart = buffered.start(numBufferedRanges - 1);
                const bufferEnd = buffered.end(numBufferedRanges - 1);
                // No flush if we can tolerate the current buffer length or the current buffer range we would flush is contiguous with current position
                if (targetFrontBufferPosition > bufferStart || currentTime >= bufferStart && currentTime <= bufferEnd) return;
                else if (sb.ended && currentTime - bufferEnd < 2 * targetDuration) {
                    this.log(`Cannot flush ${type} front buffer while SourceBuffer is in ended state`);
                    return;
                }
                this.hls.trigger(Events.BUFFER_FLUSHING, {
                    startOffset: bufferStart,
                    endOffset: Infinity,
                    type
                });
            }
        });
    }
    /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */ updateMediaElementDuration() {
        if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== 'open') return;
        const { details, hls, media, mediaSource } = this;
        const levelDuration = details.fragments[0].start + details.totalduration;
        const mediaDuration = media.duration;
        const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : 0;
        if (details.live && hls.config.liveDurationInfinity) {
            // Override duration to Infinity
            mediaSource.duration = Infinity;
            this.updateSeekableRange(details);
        } else if (levelDuration > msDuration && levelDuration > mediaDuration || !isFiniteNumber(mediaDuration)) {
            // levelDuration was the last value we set.
            // not using mediaSource.duration as the browser may tweak this value
            // only update Media Source duration if its value increase, this is to avoid
            // flushing already buffered portion when switching between quality level
            this.log(`Updating Media Source duration to ${levelDuration.toFixed(3)}`);
            mediaSource.duration = levelDuration;
        }
    }
    updateSeekableRange(levelDetails) {
        const mediaSource = this.mediaSource;
        const fragments = levelDetails.fragments;
        const len = fragments.length;
        if (len && levelDetails.live && mediaSource != null && mediaSource.setLiveSeekableRange) {
            const start = Math.max(0, fragments[0].start);
            const end = Math.max(start, start + levelDetails.totalduration);
            this.log(`Media Source duration is set to ${mediaSource.duration}. Setting seekable range to ${start}-${end}.`);
            mediaSource.setLiveSeekableRange(start, end);
        }
    }
    checkPendingTracks() {
        const { bufferCodecEventsExpected, operationQueue, pendingTracks } = this;
        // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
        // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
        // data has been appended to existing ones.
        // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
        const pendingTracksCount = Object.keys(pendingTracks).length;
        if (pendingTracksCount && (!bufferCodecEventsExpected || pendingTracksCount === 2 || 'audiovideo' in pendingTracks)) {
            // ok, let's create them now !
            this.createSourceBuffers(pendingTracks);
            this.pendingTracks = {};
            // append any pending segments now !
            const buffers = this.getSourceBufferTypes();
            if (buffers.length) {
                this.hls.trigger(Events.BUFFER_CREATED, {
                    tracks: this.tracks
                });
                buffers.forEach((type)=>{
                    operationQueue.executeNext(type);
                });
            } else {
                const error = new Error('could not create source buffer for media codec(s)');
                this.hls.trigger(Events.ERROR, {
                    type: ErrorTypes.MEDIA_ERROR,
                    details: ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                    fatal: true,
                    error,
                    reason: error.message
                });
            }
        }
    }
    createSourceBuffers(tracks) {
        const { sourceBuffer, mediaSource } = this;
        if (!mediaSource) throw Error('createSourceBuffers called when mediaSource was null');
        for(const trackName in tracks)if (!sourceBuffer[trackName]) {
            var _track$levelCodec;
            const track = tracks[trackName];
            if (!track) throw Error(`source buffer exists for track ${trackName}, however track does not`);
            // use levelCodec as first priority unless it contains multiple comma-separated codec values
            let codec = ((_track$levelCodec = track.levelCodec) == null ? void 0 : _track$levelCodec.indexOf(',')) === -1 ? track.levelCodec : track.codec;
            if (codec) {
                if (trackName.slice(0, 5) === 'audio') codec = getCodecCompatibleName(codec, this.appendSource);
            }
            const mimeType = `${track.container};codecs=${codec}`;
            this.log(`creating sourceBuffer(${mimeType})`);
            try {
                const sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
                const sbName = trackName;
                this.addBufferListener(sbName, 'updatestart', this._onSBUpdateStart);
                this.addBufferListener(sbName, 'updateend', this._onSBUpdateEnd);
                this.addBufferListener(sbName, 'error', this._onSBUpdateError);
                // ManagedSourceBuffer bufferedchange event
                if (this.appendSource) this.addBufferListener(sbName, 'bufferedchange', (type, event)=>{
                    // If media was ejected check for a change. Added ranges are redundant with changes on 'updateend' event.
                    const removedRanges = event.removedRanges;
                    if (removedRanges != null && removedRanges.length) this.hls.trigger(Events.BUFFER_FLUSHED, {
                        type: trackName
                    });
                });
                this.tracks[trackName] = {
                    buffer: sb,
                    codec: codec,
                    container: track.container,
                    levelCodec: track.levelCodec,
                    metadata: track.metadata,
                    id: track.id
                };
            } catch (err) {
                this.error(`error while trying to add sourceBuffer: ${err.message}`);
                this.hls.trigger(Events.ERROR, {
                    type: ErrorTypes.MEDIA_ERROR,
                    details: ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                    fatal: false,
                    error: err,
                    sourceBufferName: trackName,
                    mimeType: mimeType
                });
            }
        }
    }
    get mediaSrc() {
        var _this$media;
        const media = ((_this$media = this.media) == null ? void 0 : _this$media.firstChild) || this.media;
        return media == null ? void 0 : media.src;
    }
    _onSBUpdateStart(type) {
        const { operationQueue } = this;
        const operation = operationQueue.current(type);
        operation.onStart();
    }
    _onSBUpdateEnd(type) {
        var _this$mediaSource2;
        if (((_this$mediaSource2 = this.mediaSource) == null ? void 0 : _this$mediaSource2.readyState) === 'closed') {
            this.resetBuffer(type);
            return;
        }
        const { operationQueue } = this;
        const operation = operationQueue.current(type);
        operation.onComplete();
        operationQueue.shiftAndExecuteNext(type);
    }
    _onSBUpdateError(type, event) {
        var _this$mediaSource3;
        const error = new Error(`${type} SourceBuffer error. MediaSource readyState: ${(_this$mediaSource3 = this.mediaSource) == null ? void 0 : _this$mediaSource3.readyState}`);
        this.error(`${error}`, event);
        // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
        // SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
        this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_APPENDING_ERROR,
            sourceBufferName: type,
            error,
            fatal: false
        });
        // updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
        const operation = this.operationQueue.current(type);
        if (operation) operation.onError(error);
    }
    // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
    removeExecutor(type, startOffset, endOffset) {
        const { media, mediaSource, operationQueue, sourceBuffer } = this;
        const sb = sourceBuffer[type];
        if (!media || !mediaSource || !sb) {
            this.warn(`Attempting to remove from the ${type} SourceBuffer, but it does not exist`);
            operationQueue.shiftAndExecuteNext(type);
            return;
        }
        const mediaDuration = isFiniteNumber(media.duration) ? media.duration : Infinity;
        const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : Infinity;
        const removeStart = Math.max(0, startOffset);
        const removeEnd = Math.min(endOffset, mediaDuration, msDuration);
        if (removeEnd > removeStart && (!sb.ending || sb.ended)) {
            sb.ended = false;
            this.log(`Removing [${removeStart},${removeEnd}] from the ${type} SourceBuffer`);
            sb.remove(removeStart, removeEnd);
        } else // Cycle the queue
        operationQueue.shiftAndExecuteNext(type);
    }
    // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
    appendExecutor(data, type) {
        const sb = this.sourceBuffer[type];
        if (!sb) {
            if (!this.pendingTracks[type]) throw new Error(`Attempting to append to the ${type} SourceBuffer, but it does not exist`);
            return;
        }
        sb.ended = false;
        sb.appendBuffer(data);
    }
    // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
    // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
    // upon completion, since we already do it here
    blockBuffers(onUnblocked, buffers = this.getSourceBufferTypes()) {
        if (!buffers.length) {
            this.log('Blocking operation requested, but no SourceBuffers exist');
            Promise.resolve().then(onUnblocked);
            return;
        }
        const { operationQueue } = this;
        // logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
        const blockingOperations = buffers.map((type)=>operationQueue.appendBlocker(type));
        Promise.all(blockingOperations).then(()=>{
            // logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
            onUnblocked();
            buffers.forEach((type)=>{
                const sb = this.sourceBuffer[type];
                // Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
                // true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
                // While this is a workaround, it's probably useful to have around
                if (!(sb != null && sb.updating)) operationQueue.shiftAndExecuteNext(type);
            });
        });
    }
    getSourceBufferTypes() {
        return Object.keys(this.sourceBuffer);
    }
    addBufferListener(type, event, fn) {
        const buffer = this.sourceBuffer[type];
        if (!buffer) return;
        const listener = fn.bind(this, type);
        this.listeners[type].push({
            event,
            listener
        });
        buffer.addEventListener(event, listener);
    }
    removeBufferListeners(type) {
        const buffer = this.sourceBuffer[type];
        if (!buffer) return;
        this.listeners[type].forEach((l)=>{
            buffer.removeEventListener(l.event, l.listener);
        });
    }
}
function removeSourceChildren(node) {
    const sourceChildren = node.querySelectorAll('source');
    [].slice.call(sourceChildren).forEach((source)=>{
        node.removeChild(source);
    });
}
function addSource(media, url) {
    const source = self.document.createElement('source');
    source.type = 'video/mp4';
    source.src = url;
    media.appendChild(source);
}
/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */ /**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */ const specialCea608CharsCodes = {
    0x2a: 0xe1,
    // lowercase a, acute accent
    0x5c: 0xe9,
    // lowercase e, acute accent
    0x5e: 0xed,
    // lowercase i, acute accent
    0x5f: 0xf3,
    // lowercase o, acute accent
    0x60: 0xfa,
    // lowercase u, acute accent
    0x7b: 0xe7,
    // lowercase c with cedilla
    0x7c: 0xf7,
    // division symbol
    0x7d: 0xd1,
    // uppercase N tilde
    0x7e: 0xf1,
    // lowercase n tilde
    0x7f: 0x2588,
    // Full block
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae,
    // Registered symbol (R)
    0x81: 0xb0,
    // degree sign
    0x82: 0xbd,
    // 1/2 symbol
    0x83: 0xbf,
    // Inverted (open) question mark
    0x84: 0x2122,
    // Trademark symbol (TM)
    0x85: 0xa2,
    // Cents symbol
    0x86: 0xa3,
    // Pounds sterling
    0x87: 0x266a,
    // Music 8'th note
    0x88: 0xe0,
    // lowercase a, grave accent
    0x89: 0x20,
    // transparent space (regular)
    0x8a: 0xe8,
    // lowercase e, grave accent
    0x8b: 0xe2,
    // lowercase a, circumflex accent
    0x8c: 0xea,
    // lowercase e, circumflex accent
    0x8d: 0xee,
    // lowercase i, circumflex accent
    0x8e: 0xf4,
    // lowercase o, circumflex accent
    0x8f: 0xfb,
    // lowercase u, circumflex accent
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1,
    // capital letter A with acute
    0x91: 0xc9,
    // capital letter E with acute
    0x92: 0xd3,
    // capital letter O with acute
    0x93: 0xda,
    // capital letter U with acute
    0x94: 0xdc,
    // capital letter U with diaresis
    0x95: 0xfc,
    // lowercase letter U with diaeresis
    0x96: 0x2018,
    // opening single quote
    0x97: 0xa1,
    // inverted exclamation mark
    0x98: 0x2a,
    // asterisk
    0x99: 0x2019,
    // closing single quote
    0x9a: 0x2501,
    // box drawings heavy horizontal
    0x9b: 0xa9,
    // copyright sign
    0x9c: 0x2120,
    // Service mark
    0x9d: 0x2022,
    // (round) bullet
    0x9e: 0x201c,
    // Left double quotation mark
    0x9f: 0x201d,
    // Right double quotation mark
    0xa0: 0xc0,
    // uppercase A, grave accent
    0xa1: 0xc2,
    // uppercase A, circumflex
    0xa2: 0xc7,
    // uppercase C with cedilla
    0xa3: 0xc8,
    // uppercase E, grave accent
    0xa4: 0xca,
    // uppercase E, circumflex
    0xa5: 0xcb,
    // capital letter E with diaresis
    0xa6: 0xeb,
    // lowercase letter e with diaresis
    0xa7: 0xce,
    // uppercase I, circumflex
    0xa8: 0xcf,
    // uppercase I, with diaresis
    0xa9: 0xef,
    // lowercase i, with diaresis
    0xaa: 0xd4,
    // uppercase O, circumflex
    0xab: 0xd9,
    // uppercase U, grave accent
    0xac: 0xf9,
    // lowercase u, grave accent
    0xad: 0xdb,
    // uppercase U, circumflex
    0xae: 0xab,
    // left-pointing double angle quotation mark
    0xaf: 0xbb,
    // right-pointing double angle quotation mark
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3,
    // Uppercase A, tilde
    0xb1: 0xe3,
    // Lowercase a, tilde
    0xb2: 0xcd,
    // Uppercase I, acute accent
    0xb3: 0xcc,
    // Uppercase I, grave accent
    0xb4: 0xec,
    // Lowercase i, grave accent
    0xb5: 0xd2,
    // Uppercase O, grave accent
    0xb6: 0xf2,
    // Lowercase o, grave accent
    0xb7: 0xd5,
    // Uppercase O, tilde
    0xb8: 0xf5,
    // Lowercase o, tilde
    0xb9: 0x7b,
    // Open curly brace
    0xba: 0x7d,
    // Closing curly brace
    0xbb: 0x5c,
    // Backslash
    0xbc: 0x5e,
    // Caret
    0xbd: 0x5f,
    // Underscore
    0xbe: 0x7c,
    // Pipe (vertical line)
    0xbf: 0x223c,
    // Tilde operator
    0xc0: 0xc4,
    // Uppercase A, umlaut
    0xc1: 0xe4,
    // Lowercase A, umlaut
    0xc2: 0xd6,
    // Uppercase O, umlaut
    0xc3: 0xf6,
    // Lowercase o, umlaut
    0xc4: 0xdf,
    // Esszett (sharp S)
    0xc5: 0xa5,
    // Yen symbol
    0xc6: 0xa4,
    // Generic currency sign
    0xc7: 0x2503,
    // Box drawings heavy vertical
    0xc8: 0xc5,
    // Uppercase A, ring
    0xc9: 0xe5,
    // Lowercase A, ring
    0xca: 0xd8,
    // Uppercase O, stroke
    0xcb: 0xf8,
    // Lowercase o, strok
    0xcc: 0x250f,
    // Box drawings heavy down and right
    0xcd: 0x2513,
    // Box drawings heavy down and left
    0xce: 0x2517,
    // Box drawings heavy up and right
    0xcf: 0x251b // Box drawings heavy up and left
};
/**
 * Utils
 */ const getCharForByte = function getCharForByte(byte) {
    let charCode = byte;
    if (specialCea608CharsCodes.hasOwnProperty(byte)) charCode = specialCea608CharsCodes[byte];
    return String.fromCharCode(charCode);
};
const NR_ROWS = 15;
const NR_COLS = 100;
// Tables to look up row from PAC data
const rowsLowCh1 = {
    0x11: 1,
    0x12: 3,
    0x15: 5,
    0x16: 7,
    0x17: 9,
    0x10: 11,
    0x13: 12,
    0x14: 14
};
const rowsHighCh1 = {
    0x11: 2,
    0x12: 4,
    0x15: 6,
    0x16: 8,
    0x17: 10,
    0x13: 13,
    0x14: 15
};
const rowsLowCh2 = {
    0x19: 1,
    0x1a: 3,
    0x1d: 5,
    0x1e: 7,
    0x1f: 9,
    0x18: 11,
    0x1b: 12,
    0x1c: 14
};
const rowsHighCh2 = {
    0x19: 2,
    0x1a: 4,
    0x1d: 6,
    0x1e: 8,
    0x1f: 10,
    0x1b: 13,
    0x1c: 15
};
const backgroundColors = [
    'white',
    'green',
    'blue',
    'cyan',
    'red',
    'yellow',
    'magenta',
    'black',
    'transparent'
];
class CaptionsLogger {
    constructor(){
        this.time = null;
        this.verboseLevel = 0;
    }
    log(severity, msg) {
        if (this.verboseLevel >= severity) {
            const m = typeof msg === 'function' ? msg() : msg;
            logger.log(`${this.time} [${severity}] ${m}`);
        }
    }
}
const numArrayToHexArray = function numArrayToHexArray(numArray) {
    const hexArray = [];
    for(let j = 0; j < numArray.length; j++)hexArray.push(numArray[j].toString(16));
    return hexArray;
};
class PenState {
    constructor(){
        this.foreground = 'white';
        this.underline = false;
        this.italics = false;
        this.background = 'black';
        this.flash = false;
    }
    reset() {
        this.foreground = 'white';
        this.underline = false;
        this.italics = false;
        this.background = 'black';
        this.flash = false;
    }
    setStyles(styles) {
        const attribs = [
            'foreground',
            'underline',
            'italics',
            'background',
            'flash'
        ];
        for(let i = 0; i < attribs.length; i++){
            const style = attribs[i];
            if (styles.hasOwnProperty(style)) this[style] = styles[style];
        }
    }
    isDefault() {
        return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
    }
    equals(other) {
        return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
    }
    copy(newPenState) {
        this.foreground = newPenState.foreground;
        this.underline = newPenState.underline;
        this.italics = newPenState.italics;
        this.background = newPenState.background;
        this.flash = newPenState.flash;
    }
    toString() {
        return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
    }
}
/**
 * Unicode character with styling and background.
 * @constructor
 */ class StyledUnicodeChar {
    constructor(){
        this.uchar = ' ';
        this.penState = new PenState();
    }
    reset() {
        this.uchar = ' ';
        this.penState.reset();
    }
    setChar(uchar, newPenState) {
        this.uchar = uchar;
        this.penState.copy(newPenState);
    }
    setPenState(newPenState) {
        this.penState.copy(newPenState);
    }
    equals(other) {
        return this.uchar === other.uchar && this.penState.equals(other.penState);
    }
    copy(newChar) {
        this.uchar = newChar.uchar;
        this.penState.copy(newChar.penState);
    }
    isEmpty() {
        return this.uchar === ' ' && this.penState.isDefault();
    }
}
/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */ class Row {
    constructor(logger){
        this.chars = [];
        this.pos = 0;
        this.currPenState = new PenState();
        this.cueStartTime = null;
        this.logger = void 0;
        for(let i = 0; i < NR_COLS; i++)this.chars.push(new StyledUnicodeChar());
        this.logger = logger;
    }
    equals(other) {
        for(let i = 0; i < NR_COLS; i++){
            if (!this.chars[i].equals(other.chars[i])) return false;
        }
        return true;
    }
    copy(other) {
        for(let i = 0; i < NR_COLS; i++)this.chars[i].copy(other.chars[i]);
    }
    isEmpty() {
        let empty = true;
        for(let i = 0; i < NR_COLS; i++)if (!this.chars[i].isEmpty()) {
            empty = false;
            break;
        }
        return empty;
    }
    /**
   *  Set the cursor to a valid column.
   */ setCursor(absPos) {
        if (this.pos !== absPos) this.pos = absPos;
        if (this.pos < 0) {
            this.logger.log(3, 'Negative cursor position ' + this.pos);
            this.pos = 0;
        } else if (this.pos > NR_COLS) {
            this.logger.log(3, 'Too large cursor position ' + this.pos);
            this.pos = NR_COLS;
        }
    }
    /**
   * Move the cursor relative to current position.
   */ moveCursor(relPos) {
        const newPos = this.pos + relPos;
        if (relPos > 1) for(let i = this.pos + 1; i < newPos + 1; i++)this.chars[i].setPenState(this.currPenState);
        this.setCursor(newPos);
    }
    /**
   * Backspace, move one step back and clear character.
   */ backSpace() {
        this.moveCursor(-1);
        this.chars[this.pos].setChar(' ', this.currPenState);
    }
    insertChar(byte) {
        if (byte >= 0x90) // Extended char
        this.backSpace();
        const char = getCharForByte(byte);
        if (this.pos >= NR_COLS) {
            this.logger.log(0, ()=>'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
            return;
        }
        this.chars[this.pos].setChar(char, this.currPenState);
        this.moveCursor(1);
    }
    clearFromPos(startPos) {
        let i;
        for(i = startPos; i < NR_COLS; i++)this.chars[i].reset();
    }
    clear() {
        this.clearFromPos(0);
        this.pos = 0;
        this.currPenState.reset();
    }
    clearToEndOfRow() {
        this.clearFromPos(this.pos);
    }
    getTextString() {
        const chars = [];
        let empty = true;
        for(let i = 0; i < NR_COLS; i++){
            const char = this.chars[i].uchar;
            if (char !== ' ') empty = false;
            chars.push(char);
        }
        if (empty) return '';
        else return chars.join('');
    }
    setPenStyles(styles) {
        this.currPenState.setStyles(styles);
        const currChar = this.chars[this.pos];
        currChar.setPenState(this.currPenState);
    }
}
/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
 */ class CaptionScreen {
    constructor(logger){
        this.rows = [];
        this.currRow = NR_ROWS - 1;
        this.nrRollUpRows = null;
        this.lastOutputScreen = null;
        this.logger = void 0;
        for(let i = 0; i < NR_ROWS; i++)this.rows.push(new Row(logger));
        this.logger = logger;
    }
    reset() {
        for(let i = 0; i < NR_ROWS; i++)this.rows[i].clear();
        this.currRow = NR_ROWS - 1;
    }
    equals(other) {
        let equal = true;
        for(let i = 0; i < NR_ROWS; i++)if (!this.rows[i].equals(other.rows[i])) {
            equal = false;
            break;
        }
        return equal;
    }
    copy(other) {
        for(let i = 0; i < NR_ROWS; i++)this.rows[i].copy(other.rows[i]);
    }
    isEmpty() {
        let empty = true;
        for(let i = 0; i < NR_ROWS; i++)if (!this.rows[i].isEmpty()) {
            empty = false;
            break;
        }
        return empty;
    }
    backSpace() {
        const row = this.rows[this.currRow];
        row.backSpace();
    }
    clearToEndOfRow() {
        const row = this.rows[this.currRow];
        row.clearToEndOfRow();
    }
    /**
   * Insert a character (without styling) in the current row.
   */ insertChar(char) {
        const row = this.rows[this.currRow];
        row.insertChar(char);
    }
    setPen(styles) {
        const row = this.rows[this.currRow];
        row.setPenStyles(styles);
    }
    moveCursor(relPos) {
        const row = this.rows[this.currRow];
        row.moveCursor(relPos);
    }
    setCursor(absPos) {
        this.logger.log(2, 'setCursor: ' + absPos);
        const row = this.rows[this.currRow];
        row.setCursor(absPos);
    }
    setPAC(pacData) {
        this.logger.log(2, ()=>'pacData = ' + JSON.stringify(pacData));
        let newRow = pacData.row - 1;
        if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) newRow = this.nrRollUpRows - 1;
        // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
        if (this.nrRollUpRows && this.currRow !== newRow) {
            // clear all rows first
            for(let i = 0; i < NR_ROWS; i++)this.rows[i].clear();
            // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
            // topRowIndex - the start of rows to copy (inclusive index)
            const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
            // We only copy if the last position was already shown.
            // We use the cueStartTime value to check this.
            const lastOutputScreen = this.lastOutputScreen;
            if (lastOutputScreen) {
                const prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                const time = this.logger.time;
                if (prevLineTime !== null && time !== null && prevLineTime < time) for(let i = 0; i < this.nrRollUpRows; i++)this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
            }
        }
        this.currRow = newRow;
        const row = this.rows[this.currRow];
        if (pacData.indent !== null) {
            const indent = pacData.indent;
            const prevPos = Math.max(indent - 1, 0);
            row.setCursor(pacData.indent);
            pacData.color = row.chars[prevPos].penState.foreground;
        }
        const styles = {
            foreground: pacData.color,
            underline: pacData.underline,
            italics: pacData.italics,
            background: 'black',
            flash: false
        };
        this.setPen(styles);
    }
    /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */ setBkgData(bkgData) {
        this.logger.log(2, ()=>'bkgData = ' + JSON.stringify(bkgData));
        this.backSpace();
        this.setPen(bkgData);
        this.insertChar(0x20); // Space
    }
    setRollUpRows(nrRows) {
        this.nrRollUpRows = nrRows;
    }
    rollUp() {
        if (this.nrRollUpRows === null) {
            this.logger.log(3, 'roll_up but nrRollUpRows not set yet');
            return; // Not properly setup
        }
        this.logger.log(1, ()=>this.getDisplayText());
        const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
        const topRow = this.rows.splice(topRowIndex, 1)[0];
        topRow.clear();
        this.rows.splice(this.currRow, 0, topRow);
        this.logger.log(2, 'Rolling up');
    // this.logger.log(VerboseLevel.TEXT, this.get_display_text())
    }
    /**
   * Get all non-empty rows with as unicode text.
   */ getDisplayText(asOneRow) {
        asOneRow = asOneRow || false;
        const displayText = [];
        let text = '';
        let rowNr = -1;
        for(let i = 0; i < NR_ROWS; i++){
            const rowText = this.rows[i].getTextString();
            if (rowText) {
                rowNr = i + 1;
                if (asOneRow) displayText.push('Row ' + rowNr + ": '" + rowText + "'");
                else displayText.push(rowText.trim());
            }
        }
        if (displayText.length > 0) {
            if (asOneRow) text = '[' + displayText.join(' | ') + ']';
            else text = displayText.join('\n');
        }
        return text;
    }
    getTextAndFormat() {
        return this.rows;
    }
}
// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
class Cea608Channel {
    constructor(channelNumber, outputFilter, logger){
        this.chNr = void 0;
        this.outputFilter = void 0;
        this.mode = void 0;
        this.verbose = void 0;
        this.displayedMemory = void 0;
        this.nonDisplayedMemory = void 0;
        this.lastOutputScreen = void 0;
        this.currRollUpRow = void 0;
        this.writeScreen = void 0;
        this.cueStartTime = void 0;
        this.logger = void 0;
        this.chNr = channelNumber;
        this.outputFilter = outputFilter;
        this.mode = null;
        this.verbose = 0;
        this.displayedMemory = new CaptionScreen(logger);
        this.nonDisplayedMemory = new CaptionScreen(logger);
        this.lastOutputScreen = new CaptionScreen(logger);
        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null; // Keeps track of where a cue started.
        this.logger = logger;
    }
    reset() {
        this.mode = null;
        this.displayedMemory.reset();
        this.nonDisplayedMemory.reset();
        this.lastOutputScreen.reset();
        this.outputFilter.reset();
        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null;
    }
    getHandler() {
        return this.outputFilter;
    }
    setHandler(newHandler) {
        this.outputFilter = newHandler;
    }
    setPAC(pacData) {
        this.writeScreen.setPAC(pacData);
    }
    setBkgData(bkgData) {
        this.writeScreen.setBkgData(bkgData);
    }
    setMode(newMode) {
        if (newMode === this.mode) return;
        this.mode = newMode;
        this.logger.log(2, ()=>'MODE=' + newMode);
        if (this.mode === 'MODE_POP-ON') this.writeScreen = this.nonDisplayedMemory;
        else {
            this.writeScreen = this.displayedMemory;
            this.writeScreen.reset();
        }
        if (this.mode !== 'MODE_ROLL-UP') {
            this.displayedMemory.nrRollUpRows = null;
            this.nonDisplayedMemory.nrRollUpRows = null;
        }
        this.mode = newMode;
    }
    insertChars(chars) {
        for(let i = 0; i < chars.length; i++)this.writeScreen.insertChar(chars[i]);
        const screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
        this.logger.log(2, ()=>screen + ': ' + this.writeScreen.getDisplayText(true));
        if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
            this.logger.log(1, ()=>'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
            this.outputDataUpdate();
        }
    }
    ccRCL() {
        // Resume Caption Loading (switch mode to Pop On)
        this.logger.log(2, 'RCL - Resume Caption Loading');
        this.setMode('MODE_POP-ON');
    }
    ccBS() {
        // BackSpace
        this.logger.log(2, 'BS - BackSpace');
        if (this.mode === 'MODE_TEXT') return;
        this.writeScreen.backSpace();
        if (this.writeScreen === this.displayedMemory) this.outputDataUpdate();
    }
    ccAOF() {
    // Reserved (formerly Alarm Off)
    }
    ccAON() {
    // Reserved (formerly Alarm On)
    }
    ccDER() {
        // Delete to End of Row
        this.logger.log(2, 'DER- Delete to End of Row');
        this.writeScreen.clearToEndOfRow();
        this.outputDataUpdate();
    }
    ccRU(nrRows) {
        // Roll-Up Captions-2,3,or 4 Rows
        this.logger.log(2, 'RU(' + nrRows + ') - Roll Up');
        this.writeScreen = this.displayedMemory;
        this.setMode('MODE_ROLL-UP');
        this.writeScreen.setRollUpRows(nrRows);
    }
    ccFON() {
        // Flash On
        this.logger.log(2, 'FON - Flash On');
        this.writeScreen.setPen({
            flash: true
        });
    }
    ccRDC() {
        // Resume Direct Captioning (switch mode to PaintOn)
        this.logger.log(2, 'RDC - Resume Direct Captioning');
        this.setMode('MODE_PAINT-ON');
    }
    ccTR() {
        // Text Restart in text mode (not supported, however)
        this.logger.log(2, 'TR');
        this.setMode('MODE_TEXT');
    }
    ccRTD() {
        // Resume Text Display in Text mode (not supported, however)
        this.logger.log(2, 'RTD');
        this.setMode('MODE_TEXT');
    }
    ccEDM() {
        // Erase Displayed Memory
        this.logger.log(2, 'EDM - Erase Displayed Memory');
        this.displayedMemory.reset();
        this.outputDataUpdate(true);
    }
    ccCR() {
        // Carriage Return
        this.logger.log(2, 'CR - Carriage Return');
        this.writeScreen.rollUp();
        this.outputDataUpdate(true);
    }
    ccENM() {
        // Erase Non-Displayed Memory
        this.logger.log(2, 'ENM - Erase Non-displayed Memory');
        this.nonDisplayedMemory.reset();
    }
    ccEOC() {
        // End of Caption (Flip Memories)
        this.logger.log(2, 'EOC - End Of Caption');
        if (this.mode === 'MODE_POP-ON') {
            const tmp = this.displayedMemory;
            this.displayedMemory = this.nonDisplayedMemory;
            this.nonDisplayedMemory = tmp;
            this.writeScreen = this.nonDisplayedMemory;
            this.logger.log(1, ()=>'DISP: ' + this.displayedMemory.getDisplayText());
        }
        this.outputDataUpdate(true);
    }
    ccTO(nrCols) {
        // Tab Offset 1,2, or 3 columns
        this.logger.log(2, 'TO(' + nrCols + ') - Tab Offset');
        this.writeScreen.moveCursor(nrCols);
    }
    ccMIDROW(secondByte) {
        // Parse MIDROW command
        const styles = {
            flash: false
        };
        styles.underline = secondByte % 2 === 1;
        styles.italics = secondByte >= 0x2e;
        if (!styles.italics) {
            const colorIndex = Math.floor(secondByte / 2) - 0x10;
            const colors = [
                'white',
                'green',
                'blue',
                'cyan',
                'red',
                'yellow',
                'magenta'
            ];
            styles.foreground = colors[colorIndex];
        } else styles.foreground = 'white';
        this.logger.log(2, 'MIDROW: ' + JSON.stringify(styles));
        this.writeScreen.setPen(styles);
    }
    outputDataUpdate(dispatch = false) {
        const time = this.logger.time;
        if (time === null) return;
        if (this.outputFilter) {
            if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) // Start of a new cue
            this.cueStartTime = time;
            else if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                this.outputFilter.newCue(this.cueStartTime, time, this.lastOutputScreen);
                if (dispatch && this.outputFilter.dispatchCue) this.outputFilter.dispatchCue();
                this.cueStartTime = this.displayedMemory.isEmpty() ? null : time;
            }
            this.lastOutputScreen.copy(this.displayedMemory);
        }
    }
    cueSplitAtTime(t) {
        if (this.outputFilter) {
            if (!this.displayedMemory.isEmpty()) {
                if (this.outputFilter.newCue) this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                this.cueStartTime = t;
            }
        }
    }
}
// Will be 1 or 2 when parsing captions
class Cea608Parser {
    constructor(field, out1, out2){
        this.channels = void 0;
        this.currentChannel = 0;
        this.cmdHistory = createCmdHistory();
        this.logger = void 0;
        const logger = this.logger = new CaptionsLogger();
        this.channels = [
            null,
            new Cea608Channel(field, out1, logger),
            new Cea608Channel(field + 1, out2, logger)
        ];
    }
    getHandler(channel) {
        return this.channels[channel].getHandler();
    }
    setHandler(channel, newHandler) {
        this.channels[channel].setHandler(newHandler);
    }
    /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */ addData(time, byteList) {
        let cmdFound;
        let a;
        let b;
        let charsFound = false;
        this.logger.time = time;
        for(let i = 0; i < byteList.length; i += 2){
            a = byteList[i] & 0x7f;
            b = byteList[i + 1] & 0x7f;
            if (a === 0 && b === 0) continue;
            else this.logger.log(3, '[' + numArrayToHexArray([
                byteList[i],
                byteList[i + 1]
            ]) + '] -> (' + numArrayToHexArray([
                a,
                b
            ]) + ')');
            cmdFound = this.parseCmd(a, b);
            if (!cmdFound) cmdFound = this.parseMidrow(a, b);
            if (!cmdFound) cmdFound = this.parsePAC(a, b);
            if (!cmdFound) cmdFound = this.parseBackgroundAttributes(a, b);
            if (!cmdFound) {
                charsFound = this.parseChars(a, b);
                if (charsFound) {
                    const currChNr = this.currentChannel;
                    if (currChNr && currChNr > 0) {
                        const channel = this.channels[currChNr];
                        channel.insertChars(charsFound);
                    } else this.logger.log(2, 'No channel found yet. TEXT-MODE?');
                }
            }
            if (!cmdFound && !charsFound) this.logger.log(2, "Couldn't parse cleaned data " + numArrayToHexArray([
                a,
                b
            ]) + ' orig: ' + numArrayToHexArray([
                byteList[i],
                byteList[i + 1]
            ]));
        }
    }
    /**
   * Parse Command.
   * @returns True if a command was found
   */ parseCmd(a, b) {
        const { cmdHistory } = this;
        const cond1 = (a === 0x14 || a === 0x1c || a === 0x15 || a === 0x1d) && b >= 0x20 && b <= 0x2f;
        const cond2 = (a === 0x17 || a === 0x1f) && b >= 0x21 && b <= 0x23;
        if (!(cond1 || cond2)) return false;
        if (hasCmdRepeated(a, b, cmdHistory)) {
            setLastCmd(null, null, cmdHistory);
            this.logger.log(3, 'Repeated command (' + numArrayToHexArray([
                a,
                b
            ]) + ') is dropped');
            return true;
        }
        const chNr = a === 0x14 || a === 0x15 || a === 0x17 ? 1 : 2;
        const channel = this.channels[chNr];
        if (a === 0x14 || a === 0x15 || a === 0x1c || a === 0x1d) {
            if (b === 0x20) channel.ccRCL();
            else if (b === 0x21) channel.ccBS();
            else if (b === 0x22) channel.ccAOF();
            else if (b === 0x23) channel.ccAON();
            else if (b === 0x24) channel.ccDER();
            else if (b === 0x25) channel.ccRU(2);
            else if (b === 0x26) channel.ccRU(3);
            else if (b === 0x27) channel.ccRU(4);
            else if (b === 0x28) channel.ccFON();
            else if (b === 0x29) channel.ccRDC();
            else if (b === 0x2a) channel.ccTR();
            else if (b === 0x2b) channel.ccRTD();
            else if (b === 0x2c) channel.ccEDM();
            else if (b === 0x2d) channel.ccCR();
            else if (b === 0x2e) channel.ccENM();
            else if (b === 0x2f) channel.ccEOC();
        } else // a == 0x17 || a == 0x1F
        channel.ccTO(b - 0x20);
        setLastCmd(a, b, cmdHistory);
        this.currentChannel = chNr;
        return true;
    }
    /**
   * Parse midrow styling command
   */ parseMidrow(a, b) {
        let chNr = 0;
        if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
            if (a === 0x11) chNr = 1;
            else chNr = 2;
            if (chNr !== this.currentChannel) {
                this.logger.log(0, 'Mismatch channel in midrow parsing');
                return false;
            }
            const channel = this.channels[chNr];
            if (!channel) return false;
            channel.ccMIDROW(b);
            this.logger.log(3, 'MIDROW (' + numArrayToHexArray([
                a,
                b
            ]) + ')');
            return true;
        }
        return false;
    }
    /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */ parsePAC(a, b) {
        let row;
        const cmdHistory = this.cmdHistory;
        const case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1f) && b >= 0x40 && b <= 0x7f;
        const case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5f;
        if (!(case1 || case2)) return false;
        if (hasCmdRepeated(a, b, cmdHistory)) {
            setLastCmd(null, null, cmdHistory);
            return true; // Repeated commands are dropped (once)
        }
        const chNr = a <= 0x17 ? 1 : 2;
        if (b >= 0x40 && b <= 0x5f) row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
        else // 0x60 <= b <= 0x7F
        row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
        const channel = this.channels[chNr];
        if (!channel) return false;
        channel.setPAC(this.interpretPAC(row, b));
        setLastCmd(a, b, cmdHistory);
        this.currentChannel = chNr;
        return true;
    }
    /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */ interpretPAC(row, byte) {
        let pacIndex;
        const pacData = {
            color: null,
            italics: false,
            indent: null,
            underline: false,
            row: row
        };
        if (byte > 0x5f) pacIndex = byte - 0x60;
        else pacIndex = byte - 0x40;
        pacData.underline = (pacIndex & 1) === 1;
        if (pacIndex <= 0xd) pacData.color = [
            'white',
            'green',
            'blue',
            'cyan',
            'red',
            'yellow',
            'magenta',
            'white'
        ][Math.floor(pacIndex / 2)];
        else if (pacIndex <= 0xf) {
            pacData.italics = true;
            pacData.color = 'white';
        } else pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
        return pacData; // Note that row has zero offset. The spec uses 1.
    }
    /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */ parseChars(a, b) {
        let channelNr;
        let charCodes = null;
        let charCode1 = null;
        if (a >= 0x19) {
            channelNr = 2;
            charCode1 = a - 8;
        } else {
            channelNr = 1;
            charCode1 = a;
        }
        if (charCode1 >= 0x11 && charCode1 <= 0x13) {
            // Special character
            let oneCode;
            if (charCode1 === 0x11) oneCode = b + 0x50;
            else if (charCode1 === 0x12) oneCode = b + 0x70;
            else oneCode = b + 0x90;
            this.logger.log(2, "Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);
            charCodes = [
                oneCode
            ];
        } else if (a >= 0x20 && a <= 0x7f) charCodes = b === 0 ? [
            a
        ] : [
            a,
            b
        ];
        if (charCodes) {
            const hexCodes = numArrayToHexArray(charCodes);
            this.logger.log(3, 'Char codes =  ' + hexCodes.join(','));
            setLastCmd(a, b, this.cmdHistory);
        }
        return charCodes;
    }
    /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */ parseBackgroundAttributes(a, b) {
        const case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
        const case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
        if (!(case1 || case2)) return false;
        let index;
        const bkgData = {};
        if (a === 0x10 || a === 0x18) {
            index = Math.floor((b - 0x20) / 2);
            bkgData.background = backgroundColors[index];
            if (b % 2 === 1) bkgData.background = bkgData.background + '_semi';
        } else if (b === 0x2d) bkgData.background = 'transparent';
        else {
            bkgData.foreground = 'black';
            if (b === 0x2f) bkgData.underline = true;
        }
        const chNr = a <= 0x17 ? 1 : 2;
        const channel = this.channels[chNr];
        channel.setBkgData(bkgData);
        setLastCmd(a, b, this.cmdHistory);
        return true;
    }
    /**
   * Reset state of parser and its channels.
   */ reset() {
        for(let i = 0; i < Object.keys(this.channels).length; i++){
            const channel = this.channels[i];
            if (channel) channel.reset();
        }
        this.cmdHistory = createCmdHistory();
    }
    /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */ cueSplitAtTime(t) {
        for(let i = 0; i < this.channels.length; i++){
            const channel = this.channels[i];
            if (channel) channel.cueSplitAtTime(t);
        }
    }
}
function setLastCmd(a, b, cmdHistory) {
    cmdHistory.a = a;
    cmdHistory.b = b;
}
function hasCmdRepeated(a, b, cmdHistory) {
    return cmdHistory.a === a && cmdHistory.b === b;
}
function createCmdHistory() {
    return {
        a: null,
        b: null
    };
}
class OutputFilter {
    constructor(timelineController, trackName){
        this.timelineController = void 0;
        this.cueRanges = [];
        this.trackName = void 0;
        this.startTime = null;
        this.endTime = null;
        this.screen = null;
        this.timelineController = timelineController;
        this.trackName = trackName;
    }
    dispatchCue() {
        if (this.startTime === null) return;
        this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges);
        this.startTime = null;
    }
    newCue(startTime, endTime, screen) {
        if (this.startTime === null || this.startTime > startTime) this.startTime = startTime;
        this.endTime = endTime;
        this.screen = screen;
        this.timelineController.createCaptionsTrack(this.trackName);
    }
    reset() {
        this.cueRanges = [];
        this.startTime = null;
    }
}
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var VTTCue = function() {
    if (optionalSelf != null && optionalSelf.VTTCue) return self.VTTCue;
    const AllowedDirections = [
        '',
        'lr',
        'rl'
    ];
    const AllowedAlignments = [
        'start',
        'middle',
        'end',
        'left',
        'right'
    ];
    function isAllowedValue(allowed, value) {
        if (typeof value !== 'string') return false;
        // necessary for assuring the generic conforms to the Array interface
        if (!Array.isArray(allowed)) return false;
        // reset the type so that the next narrowing works well
        const lcValue = value.toLowerCase();
        // use the allow list to narrow the type to a specific subset of strings
        if (~allowed.indexOf(lcValue)) return lcValue;
        return false;
    }
    function findDirectionSetting(value) {
        return isAllowedValue(AllowedDirections, value);
    }
    function findAlignSetting(value) {
        return isAllowedValue(AllowedAlignments, value);
    }
    function extend(obj, ...rest) {
        let i = 1;
        for(; i < arguments.length; i++){
            const cobj = arguments[i];
            for(const p in cobj)obj[p] = cobj[p];
        }
        return obj;
    }
    function VTTCue(startTime, endTime, text) {
        const cue = this;
        const baseObj = {
            enumerable: true
        };
        /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */ // Lets us know when the VTTCue's data has changed in such a way that we need
        // to recompute its display state. This lets us compute its display state
        // lazily.
        cue.hasBeenReset = false;
        /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */ let _id = '';
        let _pauseOnExit = false;
        let _startTime = startTime;
        let _endTime = endTime;
        let _text = text;
        let _region = null;
        let _vertical = '';
        let _snapToLines = true;
        let _line = 'auto';
        let _lineAlign = 'start';
        let _position = 50;
        let _positionAlign = 'middle';
        let _size = 50;
        let _align = 'middle';
        Object.defineProperty(cue, 'id', extend({}, baseObj, {
            get: function() {
                return _id;
            },
            set: function(value) {
                _id = '' + value;
            }
        }));
        Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
            get: function() {
                return _pauseOnExit;
            },
            set: function(value) {
                _pauseOnExit = !!value;
            }
        }));
        Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
            get: function() {
                return _startTime;
            },
            set: function(value) {
                if (typeof value !== 'number') throw new TypeError('Start time must be set to a number.');
                _startTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
            get: function() {
                return _endTime;
            },
            set: function(value) {
                if (typeof value !== 'number') throw new TypeError('End time must be set to a number.');
                _endTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'text', extend({}, baseObj, {
            get: function() {
                return _text;
            },
            set: function(value) {
                _text = '' + value;
                this.hasBeenReset = true;
            }
        }));
        // todo: implement VTTRegion polyfill?
        Object.defineProperty(cue, 'region', extend({}, baseObj, {
            get: function() {
                return _region;
            },
            set: function(value) {
                _region = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
            get: function() {
                return _vertical;
            },
            set: function(value) {
                const setting = findDirectionSetting(value);
                // Have to check for false because the setting an be an empty string.
                if (setting === false) throw new SyntaxError('An invalid or illegal string was specified.');
                _vertical = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
            get: function() {
                return _snapToLines;
            },
            set: function(value) {
                _snapToLines = !!value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'line', extend({}, baseObj, {
            get: function() {
                return _line;
            },
            set: function(value) {
                if (typeof value !== 'number' && value !== 'auto') throw new SyntaxError('An invalid number or illegal string was specified.');
                _line = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
            get: function() {
                return _lineAlign;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                _lineAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'position', extend({}, baseObj, {
            get: function() {
                return _position;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error('Position must be between 0 and 100.');
                _position = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
            get: function() {
                return _positionAlign;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                _positionAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'size', extend({}, baseObj, {
            get: function() {
                return _size;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error('Size must be between 0 and 100.');
                _size = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'align', extend({}, baseObj, {
            get: function() {
                return _align;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                _align = setting;
                this.hasBeenReset = true;
            }
        }));
        /**
     * Other <track> spec defined properties
     */ // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
        cue.displayState = undefined;
    }
    /**
   * VTTCue methods
   */ VTTCue.prototype.getCueAsHTML = function() {
        // Assume WebVTT.convertCueToDOMTree is on the global.
        const WebVTT = self.WebVTT;
        return WebVTT.convertCueToDOMTree(self, this.text);
    };
    // this is a polyfill hack
    return VTTCue;
}();
/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
 */ class StringDecoder {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    decode(data, options) {
        if (!data) return '';
        if (typeof data !== 'string') throw new Error('Error - expected string data.');
        return decodeURIComponent(encodeURIComponent(data));
    }
}
// Try to parse input as a time stamp.
function parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
    }
    const m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
    if (!m) return null;
    if (parseFloat(m[2]) > 59) // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[2], m[3], 0, m[4]);
    // Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3], m[4]);
}
// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
class Settings {
    constructor(){
        this.values = Object.create(null);
    }
    // Only accept the first assignment to any key.
    set(k, v) {
        if (!this.get(k) && v !== '') this.values[k] = v;
    }
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get(k, dflt, defaultKey) {
        if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
        return this.has(k) ? this.values[k] : dflt;
    }
    // Check whether we have a value for a key.
    has(k) {
        return k in this.values;
    }
    // Accept a setting if its one of the given alternatives.
    alt(k, v, a) {
        for(let n = 0; n < a.length; ++n)if (v === a[n]) {
            this.set(k, v);
            break;
        }
    }
    // Accept a setting if its a valid (signed) integer.
    integer(k, v) {
        if (/^-?\d+$/.test(v)) // integer
        this.set(k, parseInt(v, 10));
    }
    // Accept a setting if its a valid percentage.
    percent(k, v) {
        if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
            const percent = parseFloat(v);
            if (percent >= 0 && percent <= 100) {
                this.set(k, percent);
                return true;
            }
        }
        return false;
    }
}
// Helper function to parse input into groups separated by 'groupDelim', and
// interpret each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
    const groups = groupDelim ? input.split(groupDelim) : [
        input
    ];
    for(const i in groups){
        if (typeof groups[i] !== 'string') continue;
        const kv = groups[i].split(keyValueDelim);
        if (kv.length !== 2) continue;
        const k = kv[0];
        const v = kv[1];
        callback(k, v);
    }
}
const defaults = new VTTCue(0, 0, '');
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
const center = defaults.align === 'middle' ? 'middle' : 'center';
function parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    const oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
        const ts = parseTimeStamp(input);
        if (ts === null) throw new Error('Malformed timestamp: ' + oInput);
        // Remove time stamp from input.
        input = input.replace(/^[^\sa-zA-Z-]+/, '');
        return ts;
    }
    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
        const settings = new Settings();
        parseOptions(input, function(k, v) {
            let vals;
            switch(k){
                case 'region':
                    // Find the last region we parsed with the same region id.
                    for(let i = regionList.length - 1; i >= 0; i--)if (regionList[i].id === v) {
                        settings.set(k, regionList[i].region);
                        break;
                    }
                    break;
                case 'vertical':
                    settings.alt(k, v, [
                        'rl',
                        'lr'
                    ]);
                    break;
                case 'line':
                    vals = v.split(',');
                    settings.integer(k, vals[0]);
                    if (settings.percent(k, vals[0])) settings.set('snapToLines', false);
                    settings.alt(k, vals[0], [
                        'auto'
                    ]);
                    if (vals.length === 2) settings.alt('lineAlign', vals[1], [
                        'start',
                        center,
                        'end'
                    ]);
                    break;
                case 'position':
                    vals = v.split(',');
                    settings.percent(k, vals[0]);
                    if (vals.length === 2) settings.alt('positionAlign', vals[1], [
                        'start',
                        center,
                        'end',
                        'line-left',
                        'line-right',
                        'auto'
                    ]);
                    break;
                case 'size':
                    settings.percent(k, v);
                    break;
                case 'align':
                    settings.alt(k, v, [
                        'start',
                        center,
                        'end',
                        'left',
                        'right'
                    ]);
                    break;
            }
        }, /:/, /\s/);
        // Apply default values for any missing fields.
        cue.region = settings.get('region', null);
        cue.vertical = settings.get('vertical', '');
        let line = settings.get('line', 'auto');
        if (line === 'auto' && defaults.line === -1) // set numeric line number for Safari
        line = -1;
        cue.line = line;
        cue.lineAlign = settings.get('lineAlign', 'start');
        cue.snapToLines = settings.get('snapToLines', true);
        cue.size = settings.get('size', 100);
        cue.align = settings.get('align', center);
        let position = settings.get('position', 'auto');
        if (position === 'auto' && defaults.position === 50) // set numeric position for Safari
        position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
        cue.position = position;
    }
    function skipWhitespace() {
        input = input.replace(/^\s+/, '');
    }
    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.slice(0, 3) !== '-->') // (3) next characters must match '-->'
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
    input = input.slice(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time
    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
}
function fixLineBreaks(input) {
    return input.replace(/<br(?: \/)?>/gi, '\n');
}
class VTTParser {
    constructor(){
        this.state = 'INITIAL';
        this.buffer = '';
        this.decoder = new StringDecoder();
        this.regionList = [];
        this.cue = null;
        this.oncue = void 0;
        this.onparsingerror = void 0;
        this.onflush = void 0;
    }
    parse(data) {
        const _this = this;
        // If there is no data then we won't decode it, but will just try to parse
        // whatever is in buffer already. This may occur in circumstances, for
        // example when flush() is called.
        if (data) // Try to decode the data that we received.
        _this.buffer += _this.decoder.decode(data, {
            stream: true
        });
        function collectNextLine() {
            let buffer = _this.buffer;
            let pos = 0;
            buffer = fixLineBreaks(buffer);
            while(pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n')++pos;
            const line = buffer.slice(0, pos);
            // Advance the buffer early in case we fail below.
            if (buffer[pos] === '\r') ++pos;
            if (buffer[pos] === '\n') ++pos;
            _this.buffer = buffer.slice(pos);
            return line;
        }
        // 3.2 WebVTT metadata header syntax
        function parseHeader(input) {
            parseOptions(input, function(k, v) {
            // switch (k) {
            // case 'region':
            // 3.3 WebVTT region metadata header syntax
            // console.log('parse region', v);
            // parseRegion(v);
            // break;
            // }
            }, /:/);
        }
        // 5.1 WebVTT file parsing.
        try {
            let line = '';
            if (_this.state === 'INITIAL') {
                // We can't start parsing until we have the first line.
                if (!/\r\n|\n/.test(_this.buffer)) return this;
                line = collectNextLine();
                // strip of UTF-8 BOM if any
                // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
                const m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                if (!(m != null && m[0])) throw new Error('Malformed WebVTT signature.');
                _this.state = 'HEADER';
            }
            let alreadyCollectedLine = false;
            while(_this.buffer){
                // We can't parse a line until we have the full line.
                if (!/\r\n|\n/.test(_this.buffer)) return this;
                if (!alreadyCollectedLine) line = collectNextLine();
                else alreadyCollectedLine = false;
                switch(_this.state){
                    case 'HEADER':
                        // 13-18 - Allow a header (metadata) under the WEBVTT line.
                        if (/:/.test(line)) parseHeader(line);
                        else if (!line) // An empty line terminates the header and starts the body (cues).
                        _this.state = 'ID';
                        continue;
                    case 'NOTE':
                        // Ignore NOTE blocks.
                        if (!line) _this.state = 'ID';
                        continue;
                    case 'ID':
                        // Check for the start of NOTE blocks.
                        if (/^NOTE($|[ \t])/.test(line)) {
                            _this.state = 'NOTE';
                            break;
                        }
                        // 19-29 - Allow any number of line terminators, then initialize new cue values.
                        if (!line) continue;
                        _this.cue = new VTTCue(0, 0, '');
                        _this.state = 'CUE';
                        // 30-39 - Check if self line contains an optional identifier or timing data.
                        if (line.indexOf('-->') === -1) {
                            _this.cue.id = line;
                            continue;
                        }
                    // Process line as start of a cue.
                    /* falls through */ case 'CUE':
                        // 40 - Collect cue timings and settings.
                        if (!_this.cue) {
                            _this.state = 'BADCUE';
                            continue;
                        }
                        try {
                            parseCue(line, _this.cue, _this.regionList);
                        } catch (e) {
                            // In case of an error ignore rest of the cue.
                            _this.cue = null;
                            _this.state = 'BADCUE';
                            continue;
                        }
                        _this.state = 'CUETEXT';
                        continue;
                    case 'CUETEXT':
                        {
                            const hasSubstring = line.indexOf('-->') !== -1;
                            // 34 - If we have an empty line then report the cue.
                            // 35 - If we have the special substring '-->' then report the cue,
                            // but do not collect the line as we need to process the current
                            // one as a new cue.
                            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                                // We are done parsing self cue.
                                if (_this.oncue && _this.cue) _this.oncue(_this.cue);
                                _this.cue = null;
                                _this.state = 'ID';
                                continue;
                            }
                            if (_this.cue === null) continue;
                            if (_this.cue.text) _this.cue.text += '\n';
                            _this.cue.text += line;
                        }
                        continue;
                    case 'BADCUE':
                        // 54-62 - Collect and discard the remaining cue.
                        if (!line) _this.state = 'ID';
                }
            }
        } catch (e) {
            // If we are currently parsing a cue, report what we have.
            if (_this.state === 'CUETEXT' && _this.cue && _this.oncue) _this.oncue(_this.cue);
            _this.cue = null;
            // Enter BADWEBVTT state if header was not parsed correctly otherwise
            // another exception occurred so enter BADCUE state.
            _this.state = _this.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
        }
        return this;
    }
    flush() {
        const _this = this;
        try {
            // Finish decoding the stream.
            // _this.buffer += _this.decoder.decode();
            // Synthesize the end of the current cue or region.
            if (_this.cue || _this.state === 'HEADER') {
                _this.buffer += '\n\n';
                _this.parse();
            }
            // If we've flushed, parsed, and we're still on the INITIAL state then
            // that means we don't have enough of the stream to parse the first
            // line.
            if (_this.state === 'INITIAL' || _this.state === 'BADWEBVTT') throw new Error('Malformed WebVTT signature.');
        } catch (e) {
            if (_this.onparsingerror) _this.onparsingerror(e);
        }
        if (_this.onflush) _this.onflush();
        return this;
    }
}
const LINEBREAKS = /\r\n|\n\r|\n|\r/g;
// String.prototype.startsWith is not supported in IE11
const startsWith = function startsWith(inputString, searchString, position = 0) {
    return inputString.slice(position, position + searchString.length) === searchString;
};
const cueString2millis = function cueString2millis(timeString) {
    let ts = parseInt(timeString.slice(-3));
    const secs = parseInt(timeString.slice(-6, -4));
    const mins = parseInt(timeString.slice(-9, -7));
    const hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(':'))) : 0;
    if (!isFiniteNumber(ts) || !isFiniteNumber(secs) || !isFiniteNumber(mins) || !isFiniteNumber(hours)) throw Error(`Malformed X-TIMESTAMP-MAP: Local:${timeString}`);
    ts += 1000 * secs;
    ts += 60000 * mins;
    ts += 3600000 * hours;
    return ts;
};
// From https://github.com/darkskyapp/string-hash
const hash = function hash(text) {
    let _hash = 5381;
    let i = text.length;
    while(i)_hash = _hash * 33 ^ text.charCodeAt(--i);
    return (_hash >>> 0).toString();
};
// Create a unique hash id for a cue based on start/end times and text.
// This helps timeline-controller to avoid showing repeated captions.
function generateCueId(startTime, endTime, text) {
    return hash(startTime.toString()) + hash(endTime.toString()) + hash(text);
}
const calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
    let currCC = vttCCs[cc];
    let prevCC = vttCCs[currCC.prevCC];
    // This is the first discontinuity or cues have been processed since the last discontinuity
    // Offset = current discontinuity time
    if (!prevCC || !prevCC.new && currCC.new) {
        vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
        currCC.new = false;
        return;
    }
    // There have been discontinuities since cues were last parsed.
    // Offset = time elapsed
    while((_prevCC = prevCC) != null && _prevCC.new){
        var _prevCC;
        vttCCs.ccOffset += currCC.start - prevCC.start;
        currCC.new = false;
        currCC = prevCC;
        prevCC = vttCCs[currCC.prevCC];
    }
    vttCCs.presentationOffset = presentationTime;
};
function parseWebVTT(vttByteArray, initPTS, vttCCs, cc, timeOffset, callBack, errorCallBack) {
    const parser = new VTTParser();
    // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
    // Uint8Array.prototype.reduce is not implemented in IE11
    const vttLines = utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace(LINEBREAKS, '\n').split('\n');
    const cues = [];
    const init90kHz = initPTS ? toMpegTsClockFromTimescale(initPTS.baseTime, initPTS.timescale) : 0;
    let cueTime = '00:00.000';
    let timestampMapMPEGTS = 0;
    let timestampMapLOCAL = 0;
    let parsingError;
    let inHeader = true;
    parser.oncue = function(cue) {
        // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
        const currCC = vttCCs[cc];
        let cueOffset = vttCCs.ccOffset;
        // Calculate subtitle PTS offset
        const webVttMpegTsMapOffset = (timestampMapMPEGTS - init90kHz) / 90000;
        // Update offsets for new discontinuities
        if (currCC != null && currCC.new) {
            if (timestampMapLOCAL !== undefined) // When local time is provided, offset = discontinuity start time - local time
            cueOffset = vttCCs.ccOffset = currCC.start;
            else calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
        }
        if (webVttMpegTsMapOffset) {
            if (!initPTS) {
                parsingError = new Error('Missing initPTS for VTT MPEGTS');
                return;
            }
            // If we have MPEGTS, offset = presentation time + discontinuity offset
            cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
        }
        const duration = cue.endTime - cue.startTime;
        const startTime = normalizePts((cue.startTime + cueOffset - timestampMapLOCAL) * 90000, timeOffset * 90000) / 90000;
        cue.startTime = Math.max(startTime, 0);
        cue.endTime = Math.max(startTime + duration, 0);
        //trim trailing webvtt block whitespaces
        const text = cue.text.trim();
        // Fix encoding of special characters
        cue.text = decodeURIComponent(encodeURIComponent(text));
        // If the cue was not assigned an id from the VTT file (line above the content), create one.
        if (!cue.id) cue.id = generateCueId(cue.startTime, cue.endTime, text);
        if (cue.endTime > 0) cues.push(cue);
    };
    parser.onparsingerror = function(error) {
        parsingError = error;
    };
    parser.onflush = function() {
        if (parsingError) {
            errorCallBack(parsingError);
            return;
        }
        callBack(cues);
    };
    // Go through contents line by line.
    vttLines.forEach((line)=>{
        if (inHeader) {
            // Look for X-TIMESTAMP-MAP in header.
            if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
                // Once found, no more are allowed anyway, so stop searching.
                inHeader = false;
                // Extract LOCAL and MPEGTS.
                line.slice(16).split(',').forEach((timestamp)=>{
                    if (startsWith(timestamp, 'LOCAL:')) cueTime = timestamp.slice(6);
                    else if (startsWith(timestamp, 'MPEGTS:')) timestampMapMPEGTS = parseInt(timestamp.slice(7));
                });
                try {
                    // Convert cue time to seconds
                    timestampMapLOCAL = cueString2millis(cueTime) / 1000;
                } catch (error) {
                    parsingError = error;
                }
                // Return without parsing X-TIMESTAMP-MAP line.
                return;
            } else if (line === '') inHeader = false;
        }
        // Parse line by default.
        parser.parse(line + '\n');
    });
    parser.flush();
}
const IMSC1_CODEC = 'stpp.ttml.im1t';
// Time format: h:m:s:frames(.subframes)
const HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;
// Time format: hours, minutes, seconds, milliseconds, frames, ticks
const TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
const textAlignToLineAlign = {
    left: 'start',
    center: 'center',
    right: 'end',
    start: 'start',
    end: 'end'
};
function parseIMSC1(payload, initPTS, callBack, errorCallBack) {
    const results = findBox(new Uint8Array(payload), [
        'mdat'
    ]);
    if (results.length === 0) {
        errorCallBack(new Error('Could not parse IMSC1 mdat'));
        return;
    }
    const ttmlList = results.map((mdat)=>utf8ArrayToStr(mdat));
    const syncTime = toTimescaleFromScale(initPTS.baseTime, 1, initPTS.timescale);
    try {
        ttmlList.forEach((ttml)=>callBack(parseTTML(ttml, syncTime)));
    } catch (error) {
        errorCallBack(error);
    }
}
function parseTTML(ttml, syncTime) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(ttml, 'text/xml');
    const tt = xmlDoc.getElementsByTagName('tt')[0];
    if (!tt) throw new Error('Invalid ttml');
    const defaultRateInfo = {
        frameRate: 30,
        subFrameRate: 1,
        frameRateMultiplier: 0,
        tickRate: 0
    };
    const rateInfo = Object.keys(defaultRateInfo).reduce((result, key)=>{
        result[key] = tt.getAttribute(`ttp:${key}`) || defaultRateInfo[key];
        return result;
    }, {});
    const trim = tt.getAttribute('xml:space') !== 'preserve';
    const styleElements = collectionToDictionary(getElementCollection(tt, 'styling', 'style'));
    const regionElements = collectionToDictionary(getElementCollection(tt, 'layout', 'region'));
    const cueElements = getElementCollection(tt, 'body', '[begin]');
    return [].map.call(cueElements, (cueElement)=>{
        const cueText = getTextContent(cueElement, trim);
        if (!cueText || !cueElement.hasAttribute('begin')) return null;
        const startTime = parseTtmlTime(cueElement.getAttribute('begin'), rateInfo);
        const duration = parseTtmlTime(cueElement.getAttribute('dur'), rateInfo);
        let endTime = parseTtmlTime(cueElement.getAttribute('end'), rateInfo);
        if (startTime === null) throw timestampParsingError(cueElement);
        if (endTime === null) {
            if (duration === null) throw timestampParsingError(cueElement);
            endTime = startTime + duration;
        }
        const cue = new VTTCue(startTime - syncTime, endTime - syncTime, cueText);
        cue.id = generateCueId(cue.startTime, cue.endTime, cue.text);
        const region = regionElements[cueElement.getAttribute('region')];
        const style = styleElements[cueElement.getAttribute('style')];
        // Apply styles to cue
        const styles = getTtmlStyles(region, style, styleElements);
        const { textAlign } = styles;
        if (textAlign) {
            // cue.positionAlign not settable in FF~2016
            const lineAlign = textAlignToLineAlign[textAlign];
            if (lineAlign) cue.lineAlign = lineAlign;
            cue.align = textAlign;
        }
        _extends(cue, styles);
        return cue;
    }).filter((cue)=>cue !== null);
}
function getElementCollection(fromElement, parentName, childName) {
    const parent = fromElement.getElementsByTagName(parentName)[0];
    if (parent) return [].slice.call(parent.querySelectorAll(childName));
    return [];
}
function collectionToDictionary(elementsWithId) {
    return elementsWithId.reduce((dict, element)=>{
        const id = element.getAttribute('xml:id');
        if (id) dict[id] = element;
        return dict;
    }, {});
}
function getTextContent(element, trim) {
    return [].slice.call(element.childNodes).reduce((str, node, i)=>{
        var _node$childNodes;
        if (node.nodeName === 'br' && i) return str + '\n';
        if ((_node$childNodes = node.childNodes) != null && _node$childNodes.length) return getTextContent(node, trim);
        else if (trim) return str + node.textContent.trim().replace(/\s+/g, ' ');
        return str + node.textContent;
    }, '');
}
function getTtmlStyles(region, style, styleElements) {
    const ttsNs = 'http://www.w3.org/ns/ttml#styling';
    let regionStyle = null;
    const styleAttributes = [
        'displayAlign',
        'textAlign',
        'color',
        'backgroundColor',
        'fontSize',
        'fontFamily'
    ];
    const regionStyleName = region != null && region.hasAttribute('style') ? region.getAttribute('style') : null;
    if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) regionStyle = styleElements[regionStyleName];
    return styleAttributes.reduce((styles, name)=>{
        const value = getAttributeNS(style, ttsNs, name) || getAttributeNS(region, ttsNs, name) || getAttributeNS(regionStyle, ttsNs, name);
        if (value) styles[name] = value;
        return styles;
    }, {});
}
function getAttributeNS(element, ns, name) {
    if (!element) return null;
    return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
}
function timestampParsingError(node) {
    return new Error(`Could not parse ttml timestamp ${node}`);
}
function parseTtmlTime(timeAttributeValue, rateInfo) {
    if (!timeAttributeValue) return null;
    let seconds = parseTimeStamp(timeAttributeValue);
    if (seconds === null) {
        if (HMSF_REGEX.test(timeAttributeValue)) seconds = parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
        else if (TIME_UNIT_REGEX.test(timeAttributeValue)) seconds = parseTimeUnits(timeAttributeValue, rateInfo);
    }
    return seconds;
}
function parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
    const m = HMSF_REGEX.exec(timeAttributeValue);
    const frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
    return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
}
function parseTimeUnits(timeAttributeValue, rateInfo) {
    const m = TIME_UNIT_REGEX.exec(timeAttributeValue);
    const value = Number(m[1]);
    const unit = m[2];
    switch(unit){
        case 'h':
            return value * 3600;
        case 'm':
            return value * 60;
        case 'ms':
            return value * 1000;
        case 'f':
            return value / rateInfo.frameRate;
        case 't':
            return value / rateInfo.tickRate;
    }
    return value;
}
class TimelineController {
    constructor(hls){
        this.hls = void 0;
        this.media = null;
        this.config = void 0;
        this.enabled = true;
        this.Cues = void 0;
        this.textTracks = [];
        this.tracks = [];
        this.initPTS = [];
        this.unparsedVttFrags = [];
        this.captionsTracks = {};
        this.nonNativeCaptionsTracks = {};
        this.cea608Parser1 = void 0;
        this.cea608Parser2 = void 0;
        this.lastCc = -1;
        // Last video (CEA-608) fragment CC
        this.lastSn = -1;
        // Last video (CEA-608) fragment MSN
        this.lastPartIndex = -1;
        // Last video (CEA-608) fragment Part Index
        this.prevCC = -1;
        // Last subtitle fragment CC
        this.vttCCs = newVTTCCs();
        this.captionsProperties = void 0;
        this.hls = hls;
        this.config = hls.config;
        this.Cues = hls.config.cueHandler;
        this.captionsProperties = {
            textTrack1: {
                label: this.config.captionsTextTrack1Label,
                languageCode: this.config.captionsTextTrack1LanguageCode
            },
            textTrack2: {
                label: this.config.captionsTextTrack2Label,
                languageCode: this.config.captionsTextTrack2LanguageCode
            },
            textTrack3: {
                label: this.config.captionsTextTrack3Label,
                languageCode: this.config.captionsTextTrack3LanguageCode
            },
            textTrack4: {
                label: this.config.captionsTextTrack4Label,
                languageCode: this.config.captionsTextTrack4LanguageCode
            }
        };
        hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
        hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.on(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
        hls.on(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
        hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.on(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
        hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    }
    destroy() {
        const { hls } = this;
        hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
        hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.off(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
        hls.off(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
        hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.off(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
        hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        // @ts-ignore
        this.hls = this.config = null;
        this.cea608Parser1 = this.cea608Parser2 = undefined;
    }
    initCea608Parsers() {
        if (this.config.enableCEA708Captions && (!this.cea608Parser1 || !this.cea608Parser2)) {
            const channel1 = new OutputFilter(this, 'textTrack1');
            const channel2 = new OutputFilter(this, 'textTrack2');
            const channel3 = new OutputFilter(this, 'textTrack3');
            const channel4 = new OutputFilter(this, 'textTrack4');
            this.cea608Parser1 = new Cea608Parser(1, channel1, channel2);
            this.cea608Parser2 = new Cea608Parser(3, channel3, channel4);
        }
    }
    addCues(trackName, startTime, endTime, screen, cueRanges) {
        // skip cues which overlap more than 50% with previously parsed time ranges
        let merged = false;
        for(let i = cueRanges.length; i--;){
            const cueRange = cueRanges[i];
            const overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
            if (overlap >= 0) {
                cueRange[0] = Math.min(cueRange[0], startTime);
                cueRange[1] = Math.max(cueRange[1], endTime);
                merged = true;
                if (overlap / (endTime - startTime) > 0.5) return;
            }
        }
        if (!merged) cueRanges.push([
            startTime,
            endTime
        ]);
        if (this.config.renderTextTracksNatively) {
            const track = this.captionsTracks[trackName];
            this.Cues.newCue(track, startTime, endTime, screen);
        } else {
            const cues = this.Cues.newCue(null, startTime, endTime, screen);
            this.hls.trigger(Events.CUES_PARSED, {
                type: 'captions',
                cues,
                track: trackName
            });
        }
    }
    // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
    onInitPtsFound(event, { frag, id, initPTS, timescale }) {
        const { unparsedVttFrags } = this;
        if (id === 'main') this.initPTS[frag.cc] = {
            baseTime: initPTS,
            timescale
        };
        // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
        // Parse any unparsed fragments upon receiving the initial PTS.
        if (unparsedVttFrags.length) {
            this.unparsedVttFrags = [];
            unparsedVttFrags.forEach((frag)=>{
                this.onFragLoaded(Events.FRAG_LOADED, frag);
            });
        }
    }
    getExistingTrack(label, language) {
        const { media } = this;
        if (media) for(let i = 0; i < media.textTracks.length; i++){
            const textTrack = media.textTracks[i];
            if (canReuseVttTextTrack(textTrack, {
                name: label,
                lang: language,
                attrs: {}
            })) return textTrack;
        }
        return null;
    }
    createCaptionsTrack(trackName) {
        if (this.config.renderTextTracksNatively) this.createNativeTrack(trackName);
        else this.createNonNativeTrack(trackName);
    }
    createNativeTrack(trackName) {
        if (this.captionsTracks[trackName]) return;
        const { captionsProperties, captionsTracks, media } = this;
        const { label, languageCode } = captionsProperties[trackName];
        // Enable reuse of existing text track.
        const existingTrack = this.getExistingTrack(label, languageCode);
        if (!existingTrack) {
            const textTrack = this.createTextTrack('captions', label, languageCode);
            if (textTrack) {
                // Set a special property on the track so we know it's managed by Hls.js
                textTrack[trackName] = true;
                captionsTracks[trackName] = textTrack;
            }
        } else {
            captionsTracks[trackName] = existingTrack;
            clearCurrentCues(captionsTracks[trackName]);
            sendAddTrackEvent(captionsTracks[trackName], media);
        }
    }
    createNonNativeTrack(trackName) {
        if (this.nonNativeCaptionsTracks[trackName]) return;
        // Create a list of a single track for the provider to consume
        const trackProperties = this.captionsProperties[trackName];
        if (!trackProperties) return;
        const label = trackProperties.label;
        const track = {
            _id: trackName,
            label,
            kind: 'captions',
            default: trackProperties.media ? !!trackProperties.media.default : false,
            closedCaptions: trackProperties.media
        };
        this.nonNativeCaptionsTracks[trackName] = track;
        this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
            tracks: [
                track
            ]
        });
    }
    createTextTrack(kind, label, lang) {
        const media = this.media;
        if (!media) return;
        return media.addTextTrack(kind, label, lang);
    }
    onMediaAttaching(event, data) {
        this.media = data.media;
        this._cleanTracks();
    }
    onMediaDetaching() {
        const { captionsTracks } = this;
        Object.keys(captionsTracks).forEach((trackName)=>{
            clearCurrentCues(captionsTracks[trackName]);
            delete captionsTracks[trackName];
        });
        this.nonNativeCaptionsTracks = {};
    }
    onManifestLoading() {
        // Detect discontinuity in video fragment (CEA-608) parsing
        this.lastCc = -1;
        this.lastSn = -1;
        this.lastPartIndex = -1;
        // Detect discontinuity in subtitle manifests
        this.prevCC = -1;
        this.vttCCs = newVTTCCs();
        // Reset tracks
        this._cleanTracks();
        this.tracks = [];
        this.captionsTracks = {};
        this.nonNativeCaptionsTracks = {};
        this.textTracks = [];
        this.unparsedVttFrags = [];
        this.initPTS = [];
        if (this.cea608Parser1 && this.cea608Parser2) {
            this.cea608Parser1.reset();
            this.cea608Parser2.reset();
        }
    }
    _cleanTracks() {
        // clear outdated subtitles
        const { media } = this;
        if (!media) return;
        const textTracks = media.textTracks;
        if (textTracks) for(let i = 0; i < textTracks.length; i++)clearCurrentCues(textTracks[i]);
    }
    onSubtitleTracksUpdated(event, data) {
        const tracks = data.subtitleTracks || [];
        const hasIMSC1 = tracks.some((track)=>track.textCodec === IMSC1_CODEC);
        if (this.config.enableWebVTT || hasIMSC1 && this.config.enableIMSC1) {
            const listIsIdentical = subtitleOptionsIdentical(this.tracks, tracks);
            if (listIsIdentical) {
                this.tracks = tracks;
                return;
            }
            this.textTracks = [];
            this.tracks = tracks;
            if (this.config.renderTextTracksNatively) {
                const media = this.media;
                const inUseTracks = media ? filterSubtitleTracks(media.textTracks) : null;
                this.tracks.forEach((track, index)=>{
                    // Reuse tracks with the same label and lang, but do not reuse 608/708 tracks
                    let textTrack;
                    if (inUseTracks) {
                        let inUseTrack = null;
                        for(let i = 0; i < inUseTracks.length; i++)if (inUseTracks[i] && canReuseVttTextTrack(inUseTracks[i], track)) {
                            inUseTrack = inUseTracks[i];
                            inUseTracks[i] = null;
                            break;
                        }
                        if (inUseTrack) textTrack = inUseTrack;
                    }
                    if (textTrack) clearCurrentCues(textTrack);
                    else {
                        const textTrackKind = captionsOrSubtitlesFromCharacteristics(track);
                        textTrack = this.createTextTrack(textTrackKind, track.name, track.lang);
                        if (textTrack) textTrack.mode = 'disabled';
                    }
                    if (textTrack) this.textTracks.push(textTrack);
                });
                // Warn when video element has captions or subtitle TextTracks carried over from another source
                if (inUseTracks != null && inUseTracks.length) {
                    const unusedTextTracks = inUseTracks.filter((t)=>t !== null).map((t)=>t.label);
                    if (unusedTextTracks.length) logger.warn(`Media element contains unused subtitle tracks: ${unusedTextTracks.join(', ')}. Replace media element for each source to clear TextTracks and captions menu.`);
                }
            } else if (this.tracks.length) {
                // Create a list of tracks for the provider to consume
                const tracksList = this.tracks.map((track)=>{
                    return {
                        label: track.name,
                        kind: track.type.toLowerCase(),
                        default: track.default,
                        subtitleTrack: track
                    };
                });
                this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                    tracks: tracksList
                });
            }
        }
    }
    onManifestLoaded(event, data) {
        if (this.config.enableCEA708Captions && data.captions) data.captions.forEach((captionsTrack)=>{
            const instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
            if (!instreamIdMatch) return;
            const trackName = `textTrack${instreamIdMatch[1]}`;
            const trackProperties = this.captionsProperties[trackName];
            if (!trackProperties) return;
            trackProperties.label = captionsTrack.name;
            if (captionsTrack.lang) // optional attribute
            trackProperties.languageCode = captionsTrack.lang;
            trackProperties.media = captionsTrack;
        });
    }
    closedCaptionsForLevel(frag) {
        const level = this.hls.levels[frag.level];
        return level == null ? void 0 : level.attrs['CLOSED-CAPTIONS'];
    }
    onFragLoading(event, data) {
        this.initCea608Parsers();
        const { cea608Parser1, cea608Parser2, lastCc, lastSn, lastPartIndex } = this;
        if (!this.enabled || !cea608Parser1 || !cea608Parser2) return;
        // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
        if (data.frag.type === PlaylistLevelType.MAIN) {
            var _data$part$index, _data$part;
            const { cc, sn } = data.frag;
            const partIndex = (_data$part$index = data == null ? void 0 : (_data$part = data.part) == null ? void 0 : _data$part.index) != null ? _data$part$index : -1;
            if (!(sn === lastSn + 1 || sn === lastSn && partIndex === lastPartIndex + 1 || cc === lastCc)) {
                cea608Parser1.reset();
                cea608Parser2.reset();
            }
            this.lastCc = cc;
            this.lastSn = sn;
            this.lastPartIndex = partIndex;
        }
    }
    onFragLoaded(event, data) {
        const { frag, payload } = data;
        if (frag.type === PlaylistLevelType.SUBTITLE) {
            // If fragment is subtitle type, parse as WebVTT.
            if (payload.byteLength) {
                const decryptData = frag.decryptdata;
                // fragment after decryption has a stats object
                const decrypted = 'stats' in data;
                // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
                if (decryptData == null || !decryptData.encrypted || decrypted) {
                    const trackPlaylistMedia = this.tracks[frag.level];
                    const vttCCs = this.vttCCs;
                    if (!vttCCs[frag.cc]) {
                        vttCCs[frag.cc] = {
                            start: frag.start,
                            prevCC: this.prevCC,
                            new: true
                        };
                        this.prevCC = frag.cc;
                    }
                    if (trackPlaylistMedia && trackPlaylistMedia.textCodec === IMSC1_CODEC) this._parseIMSC1(frag, payload);
                    else this._parseVTTs(data);
                }
            } else // In case there is no payload, finish unsuccessfully.
            this.hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag,
                error: new Error('Empty subtitle payload')
            });
        }
    }
    _parseIMSC1(frag, payload) {
        const hls = this.hls;
        parseIMSC1(payload, this.initPTS[frag.cc], (cues)=>{
            this._appendCues(cues, frag.level);
            hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
                success: true,
                frag: frag
            });
        }, (error)=>{
            logger.log(`Failed to parse IMSC1: ${error}`);
            hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error
            });
        });
    }
    _parseVTTs(data) {
        var _frag$initSegment;
        const { frag, payload } = data;
        // We need an initial synchronisation PTS. Store fragments as long as none has arrived
        const { initPTS, unparsedVttFrags } = this;
        const maxAvCC = initPTS.length - 1;
        if (!initPTS[frag.cc] && maxAvCC === -1) {
            unparsedVttFrags.push(data);
            return;
        }
        const hls = this.hls;
        // Parse the WebVTT file contents.
        const payloadWebVTT = (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data ? appendUint8Array(frag.initSegment.data, new Uint8Array(payload)) : payload;
        parseWebVTT(payloadWebVTT, this.initPTS[frag.cc], this.vttCCs, frag.cc, frag.start, (cues)=>{
            this._appendCues(cues, frag.level);
            hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
                success: true,
                frag: frag
            });
        }, (error)=>{
            const missingInitPTS = error.message === 'Missing initPTS for VTT MPEGTS';
            if (missingInitPTS) unparsedVttFrags.push(data);
            else this._fallbackToIMSC1(frag, payload);
            // Something went wrong while parsing. Trigger event with success false.
            logger.log(`Failed to parse VTT cue: ${error}`);
            if (missingInitPTS && maxAvCC > frag.cc) return;
            hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error
            });
        });
    }
    _fallbackToIMSC1(frag, payload) {
        // If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
        const trackPlaylistMedia = this.tracks[frag.level];
        if (!trackPlaylistMedia.textCodec) parseIMSC1(payload, this.initPTS[frag.cc], ()=>{
            trackPlaylistMedia.textCodec = IMSC1_CODEC;
            this._parseIMSC1(frag, payload);
        }, ()=>{
            trackPlaylistMedia.textCodec = 'wvtt';
        });
    }
    _appendCues(cues, fragLevel) {
        const hls = this.hls;
        if (this.config.renderTextTracksNatively) {
            const textTrack = this.textTracks[fragLevel];
            // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
            // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
            // and trying to access getCueById method of cues will throw an exception
            // Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
            if (!textTrack || textTrack.mode === 'disabled') return;
            cues.forEach((cue)=>addCueToTrack(textTrack, cue));
        } else {
            const currentTrack = this.tracks[fragLevel];
            if (!currentTrack) return;
            const track = currentTrack.default ? 'default' : 'subtitles' + fragLevel;
            hls.trigger(Events.CUES_PARSED, {
                type: 'subtitles',
                cues,
                track
            });
        }
    }
    onFragDecrypted(event, data) {
        const { frag } = data;
        if (frag.type === PlaylistLevelType.SUBTITLE) this.onFragLoaded(Events.FRAG_LOADED, data);
    }
    onSubtitleTracksCleared() {
        this.tracks = [];
        this.captionsTracks = {};
    }
    onFragParsingUserdata(event, data) {
        this.initCea608Parsers();
        const { cea608Parser1, cea608Parser2 } = this;
        if (!this.enabled || !cea608Parser1 || !cea608Parser2) return;
        const { frag, samples } = data;
        if (frag.type === PlaylistLevelType.MAIN && this.closedCaptionsForLevel(frag) === 'NONE') return;
        // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
        // It will create the proper timestamps based on the PTS value
        for(let i = 0; i < samples.length; i++){
            const ccBytes = samples[i].bytes;
            if (ccBytes) {
                const ccdatas = this.extractCea608Data(ccBytes);
                cea608Parser1.addData(samples[i].pts, ccdatas[0]);
                cea608Parser2.addData(samples[i].pts, ccdatas[1]);
            }
        }
    }
    onBufferFlushing(event, { startOffset, endOffset, endOffsetSubtitles, type }) {
        const { media } = this;
        if (!media || media.currentTime < endOffset) return;
        // Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
        // Forward cues are never removed because we can loose streamed 608 content from recent fragments
        if (!type || type === 'video') {
            const { captionsTracks } = this;
            Object.keys(captionsTracks).forEach((trackName)=>removeCuesInRange(captionsTracks[trackName], startOffset, endOffset));
        }
        if (this.config.renderTextTracksNatively) // Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
        {
            if (startOffset === 0 && endOffsetSubtitles !== undefined) {
                const { textTracks } = this;
                Object.keys(textTracks).forEach((trackName)=>removeCuesInRange(textTracks[trackName], startOffset, endOffsetSubtitles));
            }
        }
    }
    extractCea608Data(byteArray) {
        const actualCCBytes = [
            [],
            []
        ];
        const count = byteArray[0] & 0x1f;
        let position = 2;
        for(let j = 0; j < count; j++){
            const tmpByte = byteArray[position++];
            const ccbyte1 = 0x7f & byteArray[position++];
            const ccbyte2 = 0x7f & byteArray[position++];
            if (ccbyte1 === 0 && ccbyte2 === 0) continue;
            const ccValid = (0x04 & tmpByte) !== 0; // Support all four channels
            if (ccValid) {
                const ccType = 0x03 & tmpByte;
                if (0x00 /* CEA608 field1*/  === ccType || 0x01 /* CEA608 field2*/  === ccType) {
                    // Exclude CEA708 CC data.
                    actualCCBytes[ccType].push(ccbyte1);
                    actualCCBytes[ccType].push(ccbyte2);
                }
            }
        }
        return actualCCBytes;
    }
}
function captionsOrSubtitlesFromCharacteristics(track) {
    if (track.characteristics) {
        if (/transcribes-spoken-dialog/gi.test(track.characteristics) && /describes-music-and-sound/gi.test(track.characteristics)) return 'captions';
    }
    return 'subtitles';
}
function canReuseVttTextTrack(inUseTrack, manifestTrack) {
    return !!inUseTrack && inUseTrack.kind === captionsOrSubtitlesFromCharacteristics(manifestTrack) && subtitleTrackMatchesTextTrack(manifestTrack, inUseTrack);
}
function intersection(x1, x2, y1, y2) {
    return Math.min(x2, y2) - Math.max(x1, y1);
}
function newVTTCCs() {
    return {
        ccOffset: 0,
        presentationOffset: 0,
        0: {
            start: 0,
            prevCC: -1,
            new: true
        }
    };
}
class CapLevelController {
    constructor(hls){
        this.hls = void 0;
        this.autoLevelCapping = void 0;
        this.firstLevel = void 0;
        this.media = void 0;
        this.restrictedLevels = void 0;
        this.timer = void 0;
        this.clientRect = void 0;
        this.streamController = void 0;
        this.hls = hls;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.firstLevel = -1;
        this.media = null;
        this.restrictedLevels = [];
        this.timer = undefined;
        this.clientRect = null;
        this.registerListeners();
    }
    setStreamController(streamController) {
        this.streamController = streamController;
    }
    destroy() {
        if (this.hls) this.unregisterListener();
        if (this.timer) this.stopCapping();
        this.media = null;
        this.clientRect = null;
        // @ts-ignore
        this.hls = this.streamController = null;
    }
    registerListeners() {
        const { hls } = this;
        hls.on(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
        hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    unregisterListener() {
        const { hls } = this;
        hls.off(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
        hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    onFpsDropLevelCapping(event, data) {
        // Don't add a restricted level more than once
        const level = this.hls.levels[data.droppedLevel];
        if (this.isLevelAllowed(level)) this.restrictedLevels.push({
            bitrate: level.bitrate,
            height: level.height,
            width: level.width
        });
    }
    onMediaAttaching(event, data) {
        this.media = data.media instanceof HTMLVideoElement ? data.media : null;
        this.clientRect = null;
        if (this.timer && this.hls.levels.length) this.detectPlayerSize();
    }
    onManifestParsed(event, data) {
        const hls = this.hls;
        this.restrictedLevels = [];
        this.firstLevel = data.firstLevel;
        if (hls.config.capLevelToPlayerSize && data.video) // Start capping immediately if the manifest has signaled video codecs
        this.startCapping();
    }
    onLevelsUpdated(event, data) {
        if (this.timer && isFiniteNumber(this.autoLevelCapping)) this.detectPlayerSize();
    }
    // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
    // to the first level
    onBufferCodecs(event, data) {
        const hls = this.hls;
        if (hls.config.capLevelToPlayerSize && data.video) // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
        this.startCapping();
    }
    onMediaDetaching() {
        this.stopCapping();
    }
    detectPlayerSize() {
        if (this.media) {
            if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
                this.clientRect = null;
                return;
            }
            const levels = this.hls.levels;
            if (levels.length) {
                const hls = this.hls;
                const maxLevel = this.getMaxLevel(levels.length - 1);
                if (maxLevel !== this.autoLevelCapping) logger.log(`Setting autoLevelCapping to ${maxLevel}: ${levels[maxLevel].height}p@${levels[maxLevel].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`);
                hls.autoLevelCapping = maxLevel;
                if (hls.autoLevelCapping > this.autoLevelCapping && this.streamController) // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
                // usually happen when the user go to the fullscreen mode.
                this.streamController.nextLevelSwitch();
                this.autoLevelCapping = hls.autoLevelCapping;
            }
        }
    }
    /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */ getMaxLevel(capLevelIndex) {
        const levels = this.hls.levels;
        if (!levels.length) return -1;
        const validLevels = levels.filter((level, index)=>this.isLevelAllowed(level) && index <= capLevelIndex);
        this.clientRect = null;
        return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
    }
    startCapping() {
        if (this.timer) // Don't reset capping if started twice; this can happen if the manifest signals a video codec
        return;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        self.clearInterval(this.timer);
        this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1000);
        this.detectPlayerSize();
    }
    stopCapping() {
        this.restrictedLevels = [];
        this.firstLevel = -1;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        if (this.timer) {
            self.clearInterval(this.timer);
            this.timer = undefined;
        }
    }
    getDimensions() {
        if (this.clientRect) return this.clientRect;
        const media = this.media;
        const boundsRect = {
            width: 0,
            height: 0
        };
        if (media) {
            const clientRect = media.getBoundingClientRect();
            boundsRect.width = clientRect.width;
            boundsRect.height = clientRect.height;
            if (!boundsRect.width && !boundsRect.height) {
                // When the media element has no width or height (equivalent to not being in the DOM),
                // then use its width and height attributes (media.width, media.height)
                boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
                boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
            }
        }
        this.clientRect = boundsRect;
        return boundsRect;
    }
    get mediaWidth() {
        return this.getDimensions().width * this.contentScaleFactor;
    }
    get mediaHeight() {
        return this.getDimensions().height * this.contentScaleFactor;
    }
    get contentScaleFactor() {
        let pixelRatio = 1;
        if (!this.hls.config.ignoreDevicePixelRatio) try {
            pixelRatio = self.devicePixelRatio;
        } catch (e) {
        /* no-op */ }
        return pixelRatio;
    }
    isLevelAllowed(level) {
        const restrictedLevels = this.restrictedLevels;
        return !restrictedLevels.some((restrictedLevel)=>{
            return level.bitrate === restrictedLevel.bitrate && level.width === restrictedLevel.width && level.height === restrictedLevel.height;
        });
    }
    static getMaxLevelByMediaSize(levels, width, height) {
        if (!(levels != null && levels.length)) return -1;
        // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
        // to determine whether we've chosen the greatest bandwidth for the media's dimensions
        const atGreatestBandwidth = (curLevel, nextLevel)=>{
            if (!nextLevel) return true;
            return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
        };
        // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
        // the max level
        let maxLevelIndex = levels.length - 1;
        // Prevent changes in aspect-ratio from causing capping to toggle back and forth
        const squareSize = Math.max(width, height);
        for(let i = 0; i < levels.length; i += 1){
            const level = levels[i];
            if ((level.width >= squareSize || level.height >= squareSize) && atGreatestBandwidth(level, levels[i + 1])) {
                maxLevelIndex = i;
                break;
            }
        }
        return maxLevelIndex;
    }
}
class FPSController {
    constructor(hls){
        this.hls = void 0;
        this.isVideoPlaybackQualityAvailable = false;
        this.timer = void 0;
        this.media = null;
        this.lastTime = void 0;
        this.lastDroppedFrames = 0;
        this.lastDecodedFrames = 0;
        // stream controller must be provided as a dependency!
        this.streamController = void 0;
        this.hls = hls;
        this.registerListeners();
    }
    setStreamController(streamController) {
        this.streamController = streamController;
    }
    registerListeners() {
        this.hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    }
    unregisterListeners() {
        this.hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    }
    destroy() {
        if (this.timer) clearInterval(this.timer);
        this.unregisterListeners();
        this.isVideoPlaybackQualityAvailable = false;
        this.media = null;
    }
    onMediaAttaching(event, data) {
        const config = this.hls.config;
        if (config.capLevelOnFPSDrop) {
            const media = data.media instanceof self.HTMLVideoElement ? data.media : null;
            this.media = media;
            if (media && typeof media.getVideoPlaybackQuality === 'function') this.isVideoPlaybackQualityAvailable = true;
            self.clearInterval(this.timer);
            this.timer = self.setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
        }
    }
    checkFPS(video, decodedFrames, droppedFrames) {
        const currentTime = performance.now();
        if (decodedFrames) {
            if (this.lastTime) {
                const currentPeriod = currentTime - this.lastTime;
                const currentDropped = droppedFrames - this.lastDroppedFrames;
                const currentDecoded = decodedFrames - this.lastDecodedFrames;
                const droppedFPS = 1000 * currentDropped / currentPeriod;
                const hls = this.hls;
                hls.trigger(Events.FPS_DROP, {
                    currentDropped: currentDropped,
                    currentDecoded: currentDecoded,
                    totalDroppedFrames: droppedFrames
                });
                if (droppedFPS > 0) // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
                {
                    if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
                        let currentLevel = hls.currentLevel;
                        logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
                        if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
                            currentLevel = currentLevel - 1;
                            hls.trigger(Events.FPS_DROP_LEVEL_CAPPING, {
                                level: currentLevel,
                                droppedLevel: hls.currentLevel
                            });
                            hls.autoLevelCapping = currentLevel;
                            this.streamController.nextLevelSwitch();
                        }
                    }
                }
            }
            this.lastTime = currentTime;
            this.lastDroppedFrames = droppedFrames;
            this.lastDecodedFrames = decodedFrames;
        }
    }
    checkFPSInterval() {
        const video = this.media;
        if (video) {
            if (this.isVideoPlaybackQualityAvailable) {
                const videoPlaybackQuality = video.getVideoPlaybackQuality();
                this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
            } else // HTMLVideoElement doesn't include the webkit types
            this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
        }
    }
}
const LOGGER_PREFIX = '[eme]';
/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */ class EMEController {
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = null;
        this.keyFormatPromise = null;
        this.keySystemAccessPromises = {};
        this._requestLicenseFailureCount = 0;
        this.mediaKeySessions = [];
        this.keyIdToKeySessionPromise = {};
        this.setMediaKeysQueue = EMEController.CDMCleanupPromise ? [
            EMEController.CDMCleanupPromise
        ] : [];
        this.onMediaEncrypted = this._onMediaEncrypted.bind(this);
        this.onWaitingForKey = this._onWaitingForKey.bind(this);
        this.debug = logger.debug.bind(logger, LOGGER_PREFIX);
        this.log = logger.log.bind(logger, LOGGER_PREFIX);
        this.warn = logger.warn.bind(logger, LOGGER_PREFIX);
        this.error = logger.error.bind(logger, LOGGER_PREFIX);
        this.hls = hls;
        this.config = hls.config;
        this.registerListeners();
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetached();
        // Remove any references that could be held in config options or callbacks
        const config = this.config;
        config.requestMediaKeySystemAccessFunc = null;
        config.licenseXhrSetup = config.licenseResponseCallback = undefined;
        config.drmSystems = config.drmSystemOptions = {};
        // @ts-ignore
        this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null;
        // @ts-ignore
        this.config = null;
    }
    registerListeners() {
        this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
        this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    }
    unregisterListeners() {
        this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
        this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    }
    getLicenseServerUrl(keySystem) {
        const { drmSystems, widevineLicenseUrl } = this.config;
        const keySystemConfiguration = drmSystems[keySystem];
        if (keySystemConfiguration) return keySystemConfiguration.licenseUrl;
        // For backward compatibility
        if (keySystem === KeySystems.WIDEVINE && widevineLicenseUrl) return widevineLicenseUrl;
        throw new Error(`no license server URL configured for key-system "${keySystem}"`);
    }
    getServerCertificateUrl(keySystem) {
        const { drmSystems } = this.config;
        const keySystemConfiguration = drmSystems[keySystem];
        if (keySystemConfiguration) return keySystemConfiguration.serverCertificateUrl;
        else this.log(`No Server Certificate in config.drmSystems["${keySystem}"]`);
    }
    attemptKeySystemAccess(keySystemsToAttempt) {
        const levels = this.hls.levels;
        const uniqueCodec = (value, i, a)=>!!value && a.indexOf(value) === i;
        const audioCodecs = levels.map((level)=>level.audioCodec).filter(uniqueCodec);
        const videoCodecs = levels.map((level)=>level.videoCodec).filter(uniqueCodec);
        if (audioCodecs.length + videoCodecs.length === 0) videoCodecs.push('avc1.42e01e');
        return new Promise((resolve, reject)=>{
            const attempt = (keySystems)=>{
                const keySystem = keySystems.shift();
                this.getMediaKeysPromise(keySystem, audioCodecs, videoCodecs).then((mediaKeys)=>resolve({
                        keySystem,
                        mediaKeys
                    })).catch((error)=>{
                    if (keySystems.length) attempt(keySystems);
                    else if (error instanceof EMEKeyError) reject(error);
                    else reject(new EMEKeyError({
                        type: ErrorTypes.KEY_SYSTEM_ERROR,
                        details: ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                        error,
                        fatal: true
                    }, error.message));
                });
            };
            attempt(keySystemsToAttempt);
        });
    }
    requestMediaKeySystemAccess(keySystem, supportedConfigurations) {
        const { requestMediaKeySystemAccessFunc } = this.config;
        if (!(typeof requestMediaKeySystemAccessFunc === 'function')) {
            let errMessage = `Configured requestMediaKeySystemAccess is not a function ${requestMediaKeySystemAccessFunc}`;
            if (requestMediaKeySystemAccess === null && self.location.protocol === 'http:') errMessage = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`;
            return Promise.reject(new Error(errMessage));
        }
        return requestMediaKeySystemAccessFunc(keySystem, supportedConfigurations);
    }
    getMediaKeysPromise(keySystem, audioCodecs, videoCodecs) {
        // This can throw, but is caught in event handler callpath
        const mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, this.config.drmSystemOptions);
        const keySystemAccessPromises = this.keySystemAccessPromises[keySystem];
        let keySystemAccess = keySystemAccessPromises == null ? void 0 : keySystemAccessPromises.keySystemAccess;
        if (!keySystemAccess) {
            this.log(`Requesting encrypted media "${keySystem}" key-system access with config: ${JSON.stringify(mediaKeySystemConfigs)}`);
            keySystemAccess = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
            const _keySystemAccessPromises = this.keySystemAccessPromises[keySystem] = {
                keySystemAccess
            };
            keySystemAccess.catch((error)=>{
                this.log(`Failed to obtain access to key-system "${keySystem}": ${error}`);
            });
            return keySystemAccess.then((mediaKeySystemAccess)=>{
                this.log(`Access for key-system "${mediaKeySystemAccess.keySystem}" obtained`);
                const certificateRequest = this.fetchServerCertificate(keySystem);
                this.log(`Create media-keys for "${keySystem}"`);
                _keySystemAccessPromises.mediaKeys = mediaKeySystemAccess.createMediaKeys().then((mediaKeys)=>{
                    this.log(`Media-keys created for "${keySystem}"`);
                    return certificateRequest.then((certificate)=>{
                        if (certificate) return this.setMediaKeysServerCertificate(mediaKeys, keySystem, certificate);
                        return mediaKeys;
                    });
                });
                _keySystemAccessPromises.mediaKeys.catch((error)=>{
                    this.error(`Failed to create media-keys for "${keySystem}"}: ${error}`);
                });
                return _keySystemAccessPromises.mediaKeys;
            });
        }
        return keySystemAccess.then(()=>keySystemAccessPromises.mediaKeys);
    }
    createMediaKeySessionContext({ decryptdata, keySystem, mediaKeys }) {
        this.log(`Creating key-system session "${keySystem}" keyId: ${Hex.hexDump(decryptdata.keyId || [])}`);
        const mediaKeysSession = mediaKeys.createSession();
        const mediaKeySessionContext = {
            decryptdata,
            keySystem,
            mediaKeys,
            mediaKeysSession,
            keyStatus: 'status-pending'
        };
        this.mediaKeySessions.push(mediaKeySessionContext);
        return mediaKeySessionContext;
    }
    renewKeySession(mediaKeySessionContext) {
        const decryptdata = mediaKeySessionContext.decryptdata;
        if (decryptdata.pssh) {
            const keySessionContext = this.createMediaKeySessionContext(mediaKeySessionContext);
            const keyId = this.getKeyIdString(decryptdata);
            const scheme = 'cenc';
            this.keyIdToKeySessionPromise[keyId] = this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, 'expired');
        } else this.warn(`Could not renew expired session. Missing pssh initData.`);
        this.removeSession(mediaKeySessionContext);
    }
    getKeyIdString(decryptdata) {
        if (!decryptdata) throw new Error('Could not read keyId of undefined decryptdata');
        if (decryptdata.keyId === null) throw new Error('keyId is null');
        return Hex.hexDump(decryptdata.keyId);
    }
    updateKeySession(mediaKeySessionContext, data) {
        var _mediaKeySessionConte;
        const keySession = mediaKeySessionContext.mediaKeysSession;
        this.log(`Updating key-session "${keySession.sessionId}" for keyID ${Hex.hexDump(((_mediaKeySessionConte = mediaKeySessionContext.decryptdata) == null ? void 0 : _mediaKeySessionConte.keyId) || [])}
      } (data length: ${data ? data.byteLength : data})`);
        return keySession.update(data);
    }
    selectKeySystemFormat(frag) {
        const keyFormats = Object.keys(frag.levelkeys || {});
        if (!this.keyFormatPromise) {
            this.log(`Selecting key-system from fragment (sn: ${frag.sn} ${frag.type}: ${frag.level}) key formats ${keyFormats.join(', ')}`);
            this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
        }
        return this.keyFormatPromise;
    }
    getKeyFormatPromise(keyFormats) {
        return new Promise((resolve, reject)=>{
            const keySystemsInConfig = getKeySystemsForConfig(this.config);
            const keySystemsToAttempt = keyFormats.map(keySystemFormatToKeySystemDomain).filter((value)=>!!value && keySystemsInConfig.indexOf(value) !== -1);
            return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({ keySystem })=>{
                const keySystemFormat = keySystemDomainToKeySystemFormat(keySystem);
                if (keySystemFormat) resolve(keySystemFormat);
                else reject(new Error(`Unable to find format for key-system "${keySystem}"`));
            }).catch(reject);
        });
    }
    loadKey(data) {
        const decryptdata = data.keyInfo.decryptdata;
        const keyId = this.getKeyIdString(decryptdata);
        const keyDetails = `(keyId: ${keyId} format: "${decryptdata.keyFormat}" method: ${decryptdata.method} uri: ${decryptdata.uri})`;
        this.log(`Starting session for key ${keyDetails}`);
        let keySessionContextPromise = this.keyIdToKeySessionPromise[keyId];
        if (!keySessionContextPromise) {
            keySessionContextPromise = this.keyIdToKeySessionPromise[keyId] = this.getKeySystemForKeyPromise(decryptdata).then(({ keySystem, mediaKeys })=>{
                this.throwIfDestroyed();
                this.log(`Handle encrypted media sn: ${data.frag.sn} ${data.frag.type}: ${data.frag.level} using key ${keyDetails}`);
                return this.attemptSetMediaKeys(keySystem, mediaKeys).then(()=>{
                    this.throwIfDestroyed();
                    const keySessionContext = this.createMediaKeySessionContext({
                        keySystem,
                        mediaKeys,
                        decryptdata
                    });
                    const scheme = 'cenc';
                    return this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, 'playlist-key');
                });
            });
            keySessionContextPromise.catch((error)=>this.handleError(error));
        }
        return keySessionContextPromise;
    }
    throwIfDestroyed(message = 'Invalid state') {
        if (!this.hls) throw new Error('invalid state');
    }
    handleError(error) {
        if (!this.hls) return;
        this.error(error.message);
        if (error instanceof EMEKeyError) this.hls.trigger(Events.ERROR, error.data);
        else this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_NO_KEYS,
            error,
            fatal: true
        });
    }
    getKeySystemForKeyPromise(decryptdata) {
        const keyId = this.getKeyIdString(decryptdata);
        const mediaKeySessionContext = this.keyIdToKeySessionPromise[keyId];
        if (!mediaKeySessionContext) {
            const keySystem = keySystemFormatToKeySystemDomain(decryptdata.keyFormat);
            const keySystemsToAttempt = keySystem ? [
                keySystem
            ] : getKeySystemsForConfig(this.config);
            return this.attemptKeySystemAccess(keySystemsToAttempt);
        }
        return mediaKeySessionContext;
    }
    getKeySystemSelectionPromise(keySystemsToAttempt) {
        if (!keySystemsToAttempt.length) keySystemsToAttempt = getKeySystemsForConfig(this.config);
        if (keySystemsToAttempt.length === 0) throw new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
            fatal: true
        }, `Missing key-system license configuration options ${JSON.stringify({
            drmSystems: this.config.drmSystems
        })}`);
        return this.attemptKeySystemAccess(keySystemsToAttempt);
    }
    _onMediaEncrypted(event) {
        const { initDataType, initData } = event;
        this.debug(`"${event.type}" event: init data type: "${initDataType}"`);
        // Ignore event when initData is null
        if (initData === null) return;
        let keyId;
        let keySystemDomain;
        if (initDataType === 'sinf' && this.config.drmSystems[KeySystems.FAIRPLAY]) {
            // Match sinf keyId to playlist skd://keyId=
            const json = bin2str(new Uint8Array(initData));
            try {
                const sinf = base64Decode(JSON.parse(json).sinf);
                const tenc = parseSinf(new Uint8Array(sinf));
                if (!tenc) return;
                keyId = tenc.subarray(8, 24);
                keySystemDomain = KeySystems.FAIRPLAY;
            } catch (error) {
                this.warn('Failed to parse sinf "encrypted" event message initData');
                return;
            }
        } else {
            // Support clear-lead key-session creation (otherwise depend on playlist keys)
            const psshInfo = parsePssh(initData);
            if (psshInfo === null) return;
            if (psshInfo.version === 0 && psshInfo.systemId === KeySystemIds.WIDEVINE && psshInfo.data) keyId = psshInfo.data.subarray(8, 24);
            keySystemDomain = keySystemIdToKeySystemDomain(psshInfo.systemId);
        }
        if (!keySystemDomain || !keyId) return;
        const keyIdHex = Hex.hexDump(keyId);
        const { keyIdToKeySessionPromise, mediaKeySessions } = this;
        let keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex];
        for(let i = 0; i < mediaKeySessions.length; i++){
            // Match playlist key
            const keyContext = mediaKeySessions[i];
            const decryptdata = keyContext.decryptdata;
            if (decryptdata.pssh || !decryptdata.keyId) continue;
            const oldKeyIdHex = Hex.hexDump(decryptdata.keyId);
            if (keyIdHex === oldKeyIdHex || decryptdata.uri.replace(/-/g, '').indexOf(keyIdHex) !== -1) {
                keySessionContextPromise = keyIdToKeySessionPromise[oldKeyIdHex];
                delete keyIdToKeySessionPromise[oldKeyIdHex];
                decryptdata.pssh = new Uint8Array(initData);
                decryptdata.keyId = keyId;
                keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = keySessionContextPromise.then(()=>{
                    return this.generateRequestWithPreferredKeySession(keyContext, initDataType, initData, 'encrypted-event-key-match');
                });
                break;
            }
        }
        if (!keySessionContextPromise) // Clear-lead key (not encountered in playlist)
        keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = this.getKeySystemSelectionPromise([
            keySystemDomain
        ]).then(({ keySystem, mediaKeys })=>{
            var _keySystemToKeySystem;
            this.throwIfDestroyed();
            const decryptdata = new LevelKey('ISO-23001-7', keyIdHex, (_keySystemToKeySystem = keySystemDomainToKeySystemFormat(keySystem)) != null ? _keySystemToKeySystem : '');
            decryptdata.pssh = new Uint8Array(initData);
            decryptdata.keyId = keyId;
            return this.attemptSetMediaKeys(keySystem, mediaKeys).then(()=>{
                this.throwIfDestroyed();
                const keySessionContext = this.createMediaKeySessionContext({
                    decryptdata,
                    keySystem,
                    mediaKeys
                });
                return this.generateRequestWithPreferredKeySession(keySessionContext, initDataType, initData, 'encrypted-event-no-match');
            });
        });
        keySessionContextPromise.catch((error)=>this.handleError(error));
    }
    _onWaitingForKey(event) {
        this.log(`"${event.type}" event`);
    }
    attemptSetMediaKeys(keySystem, mediaKeys) {
        const queue = this.setMediaKeysQueue.slice();
        this.log(`Setting media-keys for "${keySystem}"`);
        // Only one setMediaKeys() can run at one time, and multiple setMediaKeys() operations
        // can be queued for execution for multiple key sessions.
        const setMediaKeysPromise = Promise.all(queue).then(()=>{
            if (!this.media) throw new Error('Attempted to set mediaKeys without media element attached');
            return this.media.setMediaKeys(mediaKeys);
        });
        this.setMediaKeysQueue.push(setMediaKeysPromise);
        return setMediaKeysPromise.then(()=>{
            this.log(`Media-keys set for "${keySystem}"`);
            queue.push(setMediaKeysPromise);
            this.setMediaKeysQueue = this.setMediaKeysQueue.filter((p)=>queue.indexOf(p) === -1);
        });
    }
    generateRequestWithPreferredKeySession(context, initDataType, initData, reason) {
        var _this$config$drmSyste, _this$config$drmSyste2;
        const generateRequestFilter = (_this$config$drmSyste = this.config.drmSystems) == null ? void 0 : (_this$config$drmSyste2 = _this$config$drmSyste[context.keySystem]) == null ? void 0 : _this$config$drmSyste2.generateRequest;
        if (generateRequestFilter) try {
            const mappedInitData = generateRequestFilter.call(this.hls, initDataType, initData, context);
            if (!mappedInitData) throw new Error('Invalid response from configured generateRequest filter');
            initDataType = mappedInitData.initDataType;
            initData = context.decryptdata.pssh = mappedInitData.initData ? new Uint8Array(mappedInitData.initData) : null;
        } catch (error) {
            var _this$hls;
            this.warn(error.message);
            if ((_this$hls = this.hls) != null && _this$hls.config.debug) throw error;
        }
        if (initData === null) {
            this.log(`Skipping key-session request for "${reason}" (no initData)`);
            return Promise.resolve(context);
        }
        const keyId = this.getKeyIdString(context.decryptdata);
        this.log(`Generating key-session request for "${reason}": ${keyId} (init data type: ${initDataType} length: ${initData ? initData.byteLength : null})`);
        const licenseStatus = new EventEmitter();
        const onmessage = context._onmessage = (event)=>{
            const keySession = context.mediaKeysSession;
            if (!keySession) {
                licenseStatus.emit('error', new Error('invalid state'));
                return;
            }
            const { messageType, message } = event;
            this.log(`"${messageType}" message event for session "${keySession.sessionId}" message size: ${message.byteLength}`);
            if (messageType === 'license-request' || messageType === 'license-renewal') this.renewLicense(context, message).catch((error)=>{
                this.handleError(error);
                licenseStatus.emit('error', error);
            });
            else if (messageType === 'license-release') {
                if (context.keySystem === KeySystems.FAIRPLAY) {
                    this.updateKeySession(context, strToUtf8array('acknowledged'));
                    this.removeSession(context);
                }
            } else this.warn(`unhandled media key message type "${messageType}"`);
        };
        const onkeystatuseschange = context._onkeystatuseschange = (event)=>{
            const keySession = context.mediaKeysSession;
            if (!keySession) {
                licenseStatus.emit('error', new Error('invalid state'));
                return;
            }
            this.onKeyStatusChange(context);
            const keyStatus = context.keyStatus;
            licenseStatus.emit('keyStatus', keyStatus);
            if (keyStatus === 'expired') {
                this.warn(`${context.keySystem} expired for key ${keyId}`);
                this.renewKeySession(context);
            }
        };
        context.mediaKeysSession.addEventListener('message', onmessage);
        context.mediaKeysSession.addEventListener('keystatuseschange', onkeystatuseschange);
        const keyUsablePromise = new Promise((resolve, reject)=>{
            licenseStatus.on('error', reject);
            licenseStatus.on('keyStatus', (keyStatus)=>{
                if (keyStatus.startsWith('usable')) resolve();
                else if (keyStatus === 'output-restricted') reject(new EMEKeyError({
                    type: ErrorTypes.KEY_SYSTEM_ERROR,
                    details: ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
                    fatal: false
                }, 'HDCP level output restricted'));
                else if (keyStatus === 'internal-error') reject(new EMEKeyError({
                    type: ErrorTypes.KEY_SYSTEM_ERROR,
                    details: ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
                    fatal: true
                }, `key status changed to "${keyStatus}"`));
                else if (keyStatus === 'expired') reject(new Error('key expired while generating request'));
                else this.warn(`unhandled key status change "${keyStatus}"`);
            });
        });
        return context.mediaKeysSession.generateRequest(initDataType, initData).then(()=>{
            var _context$mediaKeysSes;
            this.log(`Request generated for key-session "${(_context$mediaKeysSes = context.mediaKeysSession) == null ? void 0 : _context$mediaKeysSes.sessionId}" keyId: ${keyId}`);
        }).catch((error)=>{
            throw new EMEKeyError({
                type: ErrorTypes.KEY_SYSTEM_ERROR,
                details: ErrorDetails.KEY_SYSTEM_NO_SESSION,
                error,
                fatal: false
            }, `Error generating key-session request: ${error}`);
        }).then(()=>keyUsablePromise).catch((error)=>{
            licenseStatus.removeAllListeners();
            this.removeSession(context);
            throw error;
        }).then(()=>{
            licenseStatus.removeAllListeners();
            return context;
        });
    }
    onKeyStatusChange(mediaKeySessionContext) {
        mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach((status1, keyId)=>{
            this.log(`key status change "${status1}" for keyStatuses keyId: ${Hex.hexDump('buffer' in keyId ? new Uint8Array(keyId.buffer, keyId.byteOffset, keyId.byteLength) : new Uint8Array(keyId))} session keyId: ${Hex.hexDump(new Uint8Array(mediaKeySessionContext.decryptdata.keyId || []))} uri: ${mediaKeySessionContext.decryptdata.uri}`);
            mediaKeySessionContext.keyStatus = status1;
        });
    }
    fetchServerCertificate(keySystem) {
        const config = this.config;
        const Loader = config.loader;
        const certLoader = new Loader(config);
        const url = this.getServerCertificateUrl(keySystem);
        if (!url) return Promise.resolve();
        this.log(`Fetching server certificate for "${keySystem}"`);
        return new Promise((resolve, reject)=>{
            const loaderContext = {
                responseType: 'arraybuffer',
                url
            };
            const loadPolicy = config.certLoadPolicy.default;
            const loaderConfig = {
                loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0
            };
            const loaderCallbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    resolve(response.data);
                },
                onError: (response, contex, networkDetails, stats)=>{
                    reject(new EMEKeyError({
                        type: ErrorTypes.KEY_SYSTEM_ERROR,
                        details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
                        fatal: true,
                        networkDetails,
                        response: _objectSpread2({
                            url: loaderContext.url,
                            data: undefined
                        }, response)
                    }, `"${keySystem}" certificate request failed (${url}). Status: ${response.code} (${response.text})`));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    reject(new EMEKeyError({
                        type: ErrorTypes.KEY_SYSTEM_ERROR,
                        details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
                        fatal: true,
                        networkDetails,
                        response: {
                            url: loaderContext.url,
                            data: undefined
                        }
                    }, `"${keySystem}" certificate request timed out (${url})`));
                },
                onAbort: (stats, context, networkDetails)=>{
                    reject(new Error('aborted'));
                }
            };
            certLoader.load(loaderContext, loaderConfig, loaderCallbacks);
        });
    }
    setMediaKeysServerCertificate(mediaKeys, keySystem, cert) {
        return new Promise((resolve, reject)=>{
            mediaKeys.setServerCertificate(cert).then((success)=>{
                this.log(`setServerCertificate ${success ? 'success' : 'not supported by CDM'} (${cert == null ? void 0 : cert.byteLength}) on "${keySystem}"`);
                resolve(mediaKeys);
            }).catch((error)=>{
                reject(new EMEKeyError({
                    type: ErrorTypes.KEY_SYSTEM_ERROR,
                    details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
                    error,
                    fatal: true
                }, error.message));
            });
        });
    }
    renewLicense(context, keyMessage) {
        return this.requestLicense(context, new Uint8Array(keyMessage)).then((data)=>{
            return this.updateKeySession(context, new Uint8Array(data)).catch((error)=>{
                throw new EMEKeyError({
                    type: ErrorTypes.KEY_SYSTEM_ERROR,
                    details: ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,
                    error,
                    fatal: true
                }, error.message);
            });
        });
    }
    unpackPlayReadyKeyMessage(xhr, licenseChallenge) {
        // On Edge, the raw license message is UTF-16-encoded XML.  We need
        // to unpack the Challenge element (base64-encoded string containing the
        // actual license request) and any HttpHeader elements (sent as request
        // headers).
        // For PlayReady CDMs, we need to dig the Challenge out of the XML.
        const xmlString = String.fromCharCode.apply(null, new Uint16Array(licenseChallenge.buffer));
        if (!xmlString.includes('PlayReadyKeyMessage')) {
            // This does not appear to be a wrapped message as on Edge.  Some
            // clients do not need this unwrapping, so we will assume this is one of
            // them.  Note that "xml" at this point probably looks like random
            // garbage, since we interpreted UTF-8 as UTF-16.
            xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
            return licenseChallenge;
        }
        const keyMessageXml = new DOMParser().parseFromString(xmlString, 'application/xml');
        // Set request headers.
        const headers = keyMessageXml.querySelectorAll('HttpHeader');
        if (headers.length > 0) {
            let header;
            for(let i = 0, len = headers.length; i < len; i++){
                var _header$querySelector, _header$querySelector2;
                header = headers[i];
                const name = (_header$querySelector = header.querySelector('name')) == null ? void 0 : _header$querySelector.textContent;
                const value = (_header$querySelector2 = header.querySelector('value')) == null ? void 0 : _header$querySelector2.textContent;
                if (name && value) xhr.setRequestHeader(name, value);
            }
        }
        const challengeElement = keyMessageXml.querySelector('Challenge');
        const challengeText = challengeElement == null ? void 0 : challengeElement.textContent;
        if (!challengeText) throw new Error(`Cannot find <Challenge> in key message`);
        return strToUtf8array(atob(challengeText));
    }
    setupLicenseXHR(xhr, url, keysListItem, licenseChallenge) {
        const licenseXhrSetup = this.config.licenseXhrSetup;
        if (!licenseXhrSetup) {
            xhr.open('POST', url, true);
            return Promise.resolve({
                xhr,
                licenseChallenge
            });
        }
        return Promise.resolve().then(()=>{
            if (!keysListItem.decryptdata) throw new Error('Key removed');
            return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
        }).catch((error)=>{
            if (!keysListItem.decryptdata) // Key session removed. Cancel license request.
            throw error;
            // let's try to open before running setup
            xhr.open('POST', url, true);
            return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
        }).then((licenseXhrSetupResult)=>{
            // if licenseXhrSetup did not yet call open, let's do it now
            if (!xhr.readyState) xhr.open('POST', url, true);
            const finalLicenseChallenge = licenseXhrSetupResult ? licenseXhrSetupResult : licenseChallenge;
            return {
                xhr,
                licenseChallenge: finalLicenseChallenge
            };
        });
    }
    requestLicense(keySessionContext, licenseChallenge) {
        const keyLoadPolicy = this.config.keyLoadPolicy.default;
        return new Promise((resolve, reject)=>{
            const url = this.getLicenseServerUrl(keySessionContext.keySystem);
            this.log(`Sending license request to URL: ${url}`);
            const xhr = new XMLHttpRequest();
            xhr.responseType = 'arraybuffer';
            xhr.onreadystatechange = ()=>{
                if (!this.hls || !keySessionContext.mediaKeysSession) return reject(new Error('invalid state'));
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        this._requestLicenseFailureCount = 0;
                        let data = xhr.response;
                        this.log(`License received ${data instanceof ArrayBuffer ? data.byteLength : data}`);
                        const licenseResponseCallback = this.config.licenseResponseCallback;
                        if (licenseResponseCallback) try {
                            data = licenseResponseCallback.call(this.hls, xhr, url, keySessionContext);
                        } catch (error) {
                            this.error(error);
                        }
                        resolve(data);
                    } else {
                        const retryConfig = keyLoadPolicy.errorRetry;
                        const maxNumRetry = retryConfig ? retryConfig.maxNumRetry : 0;
                        this._requestLicenseFailureCount++;
                        if (this._requestLicenseFailureCount > maxNumRetry || xhr.status >= 400 && xhr.status < 500) reject(new EMEKeyError({
                            type: ErrorTypes.KEY_SYSTEM_ERROR,
                            details: ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                            fatal: true,
                            networkDetails: xhr,
                            response: {
                                url,
                                data: undefined,
                                code: xhr.status,
                                text: xhr.statusText
                            }
                        }, `License Request XHR failed (${url}). Status: ${xhr.status} (${xhr.statusText})`));
                        else {
                            const attemptsLeft = maxNumRetry - this._requestLicenseFailureCount + 1;
                            this.warn(`Retrying license request, ${attemptsLeft} attempts left`);
                            this.requestLicense(keySessionContext, licenseChallenge).then(resolve, reject);
                        }
                    }
                }
            };
            if (keySessionContext.licenseXhr && keySessionContext.licenseXhr.readyState !== XMLHttpRequest.DONE) keySessionContext.licenseXhr.abort();
            keySessionContext.licenseXhr = xhr;
            this.setupLicenseXHR(xhr, url, keySessionContext, licenseChallenge).then(({ xhr, licenseChallenge })=>{
                if (keySessionContext.keySystem == KeySystems.PLAYREADY) licenseChallenge = this.unpackPlayReadyKeyMessage(xhr, licenseChallenge);
                xhr.send(licenseChallenge);
            });
        });
    }
    onMediaAttached(event, data) {
        if (!this.config.emeEnabled) return;
        const media = data.media;
        // keep reference of media
        this.media = media;
        media.addEventListener('encrypted', this.onMediaEncrypted);
        media.addEventListener('waitingforkey', this.onWaitingForKey);
    }
    onMediaDetached() {
        const media = this.media;
        const mediaKeysList = this.mediaKeySessions;
        if (media) {
            media.removeEventListener('encrypted', this.onMediaEncrypted);
            media.removeEventListener('waitingforkey', this.onWaitingForKey);
            this.media = null;
        }
        this._requestLicenseFailureCount = 0;
        this.setMediaKeysQueue = [];
        this.mediaKeySessions = [];
        this.keyIdToKeySessionPromise = {};
        LevelKey.clearKeyUriToKeyIdMap();
        // Close all sessions and remove media keys from the video element.
        const keySessionCount = mediaKeysList.length;
        EMEController.CDMCleanupPromise = Promise.all(mediaKeysList.map((mediaKeySessionContext)=>this.removeSession(mediaKeySessionContext)).concat(media == null ? void 0 : media.setMediaKeys(null).catch((error)=>{
            this.log(`Could not clear media keys: ${error}`);
        }))).then(()=>{
            if (keySessionCount) {
                this.log('finished closing key sessions and clearing media keys');
                mediaKeysList.length = 0;
            }
        }).catch((error)=>{
            this.log(`Could not close sessions and clear media keys: ${error}`);
        });
    }
    onManifestLoading() {
        this.keyFormatPromise = null;
    }
    onManifestLoaded(event, { sessionKeys }) {
        if (!sessionKeys || !this.config.emeEnabled) return;
        if (!this.keyFormatPromise) {
            const keyFormats = sessionKeys.reduce((formats, sessionKey)=>{
                if (formats.indexOf(sessionKey.keyFormat) === -1) formats.push(sessionKey.keyFormat);
                return formats;
            }, []);
            this.log(`Selecting key-system from session-keys ${keyFormats.join(', ')}`);
            this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
        }
    }
    removeSession(mediaKeySessionContext) {
        const { mediaKeysSession, licenseXhr } = mediaKeySessionContext;
        if (mediaKeysSession) {
            this.log(`Remove licenses and keys and close session ${mediaKeysSession.sessionId}`);
            if (mediaKeySessionContext._onmessage) {
                mediaKeysSession.removeEventListener('message', mediaKeySessionContext._onmessage);
                mediaKeySessionContext._onmessage = undefined;
            }
            if (mediaKeySessionContext._onkeystatuseschange) {
                mediaKeysSession.removeEventListener('keystatuseschange', mediaKeySessionContext._onkeystatuseschange);
                mediaKeySessionContext._onkeystatuseschange = undefined;
            }
            if (licenseXhr && licenseXhr.readyState !== XMLHttpRequest.DONE) licenseXhr.abort();
            mediaKeySessionContext.mediaKeysSession = mediaKeySessionContext.decryptdata = mediaKeySessionContext.licenseXhr = undefined;
            const index = this.mediaKeySessions.indexOf(mediaKeySessionContext);
            if (index > -1) this.mediaKeySessions.splice(index, 1);
            return mediaKeysSession.remove().catch((error)=>{
                this.log(`Could not remove session: ${error}`);
            }).then(()=>{
                return mediaKeysSession.close();
            }).catch((error)=>{
                this.log(`Could not close session: ${error}`);
            });
        }
    }
}
EMEController.CDMCleanupPromise = void 0;
class EMEKeyError extends Error {
    constructor(data, message){
        super(message);
        this.data = void 0;
        data.error || (data.error = new Error(message));
        this.data = data;
        data.err = data.error;
    }
}
/**
 * Common Media Object Type
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */ var CmObjectType;
(function(CmObjectType) {
    /**
   * text file, such as a manifest or playlist
   */ CmObjectType["MANIFEST"] = "m";
    /**
   * audio only
   */ CmObjectType["AUDIO"] = "a";
    /**
   * video only
   */ CmObjectType["VIDEO"] = "v";
    /**
   * muxed audio and video
   */ CmObjectType["MUXED"] = "av";
    /**
   * init segment
   */ CmObjectType["INIT"] = "i";
    /**
   * caption or subtitle
   */ CmObjectType["CAPTION"] = "c";
    /**
   * ISOBMFF timed text track
   */ CmObjectType["TIMED_TEXT"] = "tt";
    /**
   * cryptographic key, license or certificate.
   */ CmObjectType["KEY"] = "k";
    /**
   * other
   */ CmObjectType["OTHER"] = "o";
})(CmObjectType || (CmObjectType = {}));
/**
 * Common Media Streaming Format
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */ var CmStreamingFormat;
(function(CmStreamingFormat) {
    /**
   * MPEG DASH
   */ CmStreamingFormat["DASH"] = "d";
    /**
   * HTTP Live Streaming (HLS)
   */ CmStreamingFormat["HLS"] = "h";
    /**
   * Smooth Streaming
   */ CmStreamingFormat["SMOOTH"] = "s";
    /**
   * Other
   */ CmStreamingFormat["OTHER"] = "o";
})(CmStreamingFormat || (CmStreamingFormat = {}));
/**
 * CMCD header fields.
 *
 * @group CMCD
 *
 * @beta
 */ var CmcdHeaderField;
(function(CmcdHeaderField) {
    /**
   * keys whose values vary with the object being requested.
   */ CmcdHeaderField["OBJECT"] = "CMCD-Object";
    /**
   * keys whose values vary with each request.
   */ CmcdHeaderField["REQUEST"] = "CMCD-Request";
    /**
   * keys whose values are expected to be invariant over the life of the session.
   */ CmcdHeaderField["SESSION"] = "CMCD-Session";
    /**
   * keys whose values do not vary with every request or object.
   */ CmcdHeaderField["STATUS"] = "CMCD-Status";
})(CmcdHeaderField || (CmcdHeaderField = {}));
/**
 * The map of CMCD header fields to official CMCD keys.
 *
 * @internal
 *
 * @group CMCD
 */ const CmcdHeaderMap = {
    [CmcdHeaderField.OBJECT]: [
        'br',
        'd',
        'ot',
        'tb'
    ],
    [CmcdHeaderField.REQUEST]: [
        'bl',
        'dl',
        'mtp',
        'nor',
        'nrr',
        'su'
    ],
    [CmcdHeaderField.SESSION]: [
        'cid',
        'pr',
        'sf',
        'sid',
        'st',
        'v'
    ],
    [CmcdHeaderField.STATUS]: [
        'bs',
        'rtp'
    ]
};
/**
 * Structured Field Item
 *
 * @group Structured Field
 *
 * @beta
 */ class SfItem {
    constructor(value, params){
        this.value = void 0;
        this.params = void 0;
        if (Array.isArray(value)) value = value.map((v)=>v instanceof SfItem ? v : new SfItem(v));
        this.value = value;
        this.params = params;
    }
}
/**
 * A class to represent structured field tokens when `Symbol` is not available.
 *
 * @group Structured Field
 *
 * @beta
 */ class SfToken {
    constructor(description){
        this.description = void 0;
        this.description = description;
    }
}
const DICT = 'Dict';
function format(value) {
    if (Array.isArray(value)) return JSON.stringify(value);
    if (value instanceof Map) return 'Map{}';
    if (value instanceof Set) return 'Set{}';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
}
function throwError(action, src, type, cause) {
    return new Error(`failed to ${action} "${format(src)}" as ${type}`, {
        cause
    });
}
const BARE_ITEM = 'Bare Item';
const BOOLEAN = 'Boolean';
const BYTES = 'Byte Sequence';
const DECIMAL = 'Decimal';
const INTEGER = 'Integer';
function isInvalidInt(value) {
    return value < -999999999999999 || 999999999999999 < value;
}
const STRING_REGEX = /[\x00-\x1f\x7f]+/; // eslint-disable-line no-control-regex
const TOKEN = 'Token';
const KEY = 'Key';
function serializeError(src, type, cause) {
    return throwError('serialize', src, type, cause);
}
// 4.1.9.  Serializing a Boolean
//
// Given a Boolean as input_boolean, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  If input_boolean is not a boolean, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append "?" to output.
//
// 4.  If input_boolean is true, append "1" to output.
//
// 5.  If input_boolean is false, append "0" to output.
//
// 6.  Return output.
function serializeBoolean(value) {
    if (typeof value !== 'boolean') throw serializeError(value, BOOLEAN);
    return value ? '?1' : '?0';
}
/**
 * Encodes binary data to base64
 *
 * @param binary - The binary data to encode
 * @returns The base64 encoded string
 *
 * @group Utils
 *
 * @beta
 */ function base64encode(binary) {
    return btoa(String.fromCharCode(...binary));
}
// 4.1.8.  Serializing a Byte Sequence
//
// Given a Byte Sequence as input_bytes, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_bytes is not a sequence of bytes, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append ":" to output.
//
// 4.  Append the result of base64-encoding input_bytes as per
//     [RFC4648], Section 4, taking account of the requirements below.
//
// 5.  Append ":" to output.
//
// 6.  Return output.
//
// The encoded data is required to be padded with "=", as per [RFC4648],
// Section 3.2.
//
// Likewise, encoded data SHOULD have pad bits set to zero, as per
// [RFC4648], Section 3.5, unless it is not possible to do so due to
// implementation constraints.
function serializeByteSequence(value) {
    if (ArrayBuffer.isView(value) === false) throw serializeError(value, BYTES);
    return `:${base64encode(value)}:`;
}
// 4.1.4.  Serializing an Integer
//
// Given an Integer as input_integer, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_integer is not an integer in the range of
//     -999,999,999,999,999 to 999,999,999,999,999 inclusive, fail
//     serialization.
//
// 2.  Let output be an empty string.
//
// 3.  If input_integer is less than (but not equal to) 0, append "-" to
//     output.
//
// 4.  Append input_integer's numeric value represented in base 10 using
//     only decimal digits to output.
//
// 5.  Return output.
function serializeInteger(value) {
    if (isInvalidInt(value)) throw serializeError(value, INTEGER);
    return value.toString();
}
// 4.1.10.  Serializing a Date
//
// Given a Date as input_integer, return an ASCII string suitable for
// use in an HTTP field value.
// 1.  Let output be "@".
// 2.  Append to output the result of running Serializing an Integer
//     with input_date (Section 4.1.4).
// 3.  Return output.
function serializeDate(value) {
    return `@${serializeInteger(value.getTime() / 1000)}`;
}
/**
 * This implements the rounding procedure described in step 2 of the "Serializing a Decimal" specification.
 * This rounding style is known as "even rounding", "banker's rounding", or "commercial rounding".
 *
 * @param value - The value to round
 * @param precision - The number of decimal places to round to
 * @returns The rounded value
 *
 * @group Utils
 *
 * @beta
 */ function roundToEven(value, precision) {
    if (value < 0) return -roundToEven(-value, precision);
    const decimalShift = Math.pow(10, precision);
    const isEquidistant = Math.abs(value * decimalShift % 1 - 0.5) < Number.EPSILON;
    if (isEquidistant) {
        // If the tail of the decimal place is 'equidistant' we round to the nearest even value
        const flooredValue = Math.floor(value * decimalShift);
        return (flooredValue % 2 === 0 ? flooredValue : flooredValue + 1) / decimalShift;
    } else // Otherwise, proceed as normal
    return Math.round(value * decimalShift) / decimalShift;
}
// 4.1.5.  Serializing a Decimal
//
// Given a decimal number as input_decimal, return an ASCII string
// suitable for use in a HTTP field value.
//
// 1.   If input_decimal is not a decimal number, fail serialization.
//
// 2.   If input_decimal has more than three significant digits to the
//      right of the decimal point, round it to three decimal places,
//      rounding the final digit to the nearest value, or to the even
//      value if it is equidistant.
//
// 3.   If input_decimal has more than 12 significant digits to the left
//      of the decimal point after rounding, fail serialization.
//
// 4.   Let output be an empty string.
//
// 5.   If input_decimal is less than (but not equal to) 0, append "-"
//      to output.
//
// 6.   Append input_decimal's integer component represented in base 10
//      (using only decimal digits) to output; if it is zero, append
//      "0".
//
// 7.   Append "." to output.
//
// 8.   If input_decimal's fractional component is zero, append "0" to
//      output.
//
// 9.   Otherwise, append the significant digits of input_decimal's
//      fractional component represented in base 10 (using only decimal
//      digits) to output.
//
// 10.  Return output.
function serializeDecimal(value) {
    const roundedValue = roundToEven(value, 3); // round to 3 decimal places
    if (Math.floor(Math.abs(roundedValue)).toString().length > 12) throw serializeError(value, DECIMAL);
    const stringValue = roundedValue.toString();
    return stringValue.includes('.') ? stringValue : `${stringValue}.0`;
}
const STRING = 'String';
// 4.1.6.  Serializing a String
//
// Given a String as input_string, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Convert input_string into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_string contains characters in the range %x00-1f or %x7f
//     (i.e., not in VCHAR or SP), fail serialization.
//
// 3.  Let output be the string DQUOTE.
//
// 4.  For each character char in input_string:
//
//     1.  If char is "\" or DQUOTE:
//
//         1.  Append "\" to output.
//
//     2.  Append char to output.
//
// 5.  Append DQUOTE to output.
//
// 6.  Return output.
function serializeString(value) {
    if (STRING_REGEX.test(value)) throw serializeError(value, STRING);
    return `"${value.replace(/\\/g, `\\\\`).replace(/"/g, `\\"`)}"`;
}
function symbolToStr(symbol) {
    return symbol.description || symbol.toString().slice(7, -1);
}
function serializeToken(token) {
    const value = symbolToStr(token);
    if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(value) === false) throw serializeError(value, TOKEN);
    return value;
}
// 4.1.3.1.  Serializing a Bare Item
//
// Given an Item as input_item, return an ASCII string suitable for use
// in a HTTP field value.
//
// 1.  If input_item is an Integer, return the result of running
//     Serializing an Integer (Section 4.1.4) with input_item.
//
// 2.  If input_item is a Decimal, return the result of running
//     Serializing a Decimal (Section 4.1.5) with input_item.
//
// 3.  If input_item is a String, return the result of running
//     Serializing a String (Section 4.1.6) with input_item.
//
// 4.  If input_item is a Token, return the result of running
//     Serializing a Token (Section 4.1.7) with input_item.
//
// 5.  If input_item is a Boolean, return the result of running
//     Serializing a Boolean (Section 4.1.9) with input_item.
//
// 6.  If input_item is a Byte Sequence, return the result of running
//     Serializing a Byte Sequence (Section 4.1.8) with input_item.
//
// 7.  If input_item is a Date, return the result of running Serializing
//     a Date (Section 4.1.10) with input_item.
//
// 8.  Otherwise, fail serialization.
function serializeBareItem(value) {
    switch(typeof value){
        case 'number':
            if (!isFiniteNumber(value)) throw serializeError(value, BARE_ITEM);
            if (Number.isInteger(value)) return serializeInteger(value);
            return serializeDecimal(value);
        case 'string':
            return serializeString(value);
        case 'symbol':
            return serializeToken(value);
        case 'boolean':
            return serializeBoolean(value);
        case 'object':
            if (value instanceof Date) return serializeDate(value);
            if (value instanceof Uint8Array) return serializeByteSequence(value);
            if (value instanceof SfToken) return serializeToken(value);
        default:
            // fail
            throw serializeError(value, BARE_ITEM);
    }
}
// 4.1.1.3.  Serializing a Key
//
// Given a key as input_key, return an ASCII string suitable for use in
// a HTTP field value.
//
// 1.  Convert input_key into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_key contains characters not in lcalpha, DIGIT, "_", "-",
//     ".", or "*" fail serialization.
//
// 3.  If the first character of input_key is not lcalpha or "*", fail
//     serialization.
//
// 4.  Let output be an empty string.
//
// 5.  Append input_key to output.
//
// 6.  Return output.
function serializeKey(value) {
    if (/^[a-z*][a-z0-9\-_.*]*$/.test(value) === false) throw serializeError(value, KEY);
    return value;
}
// 4.1.1.2.  Serializing Parameters
//
// Given an ordered Dictionary as input_parameters (each member having a
// param_name and a param_value), return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each param_name with a value of param_value in
//     input_parameters:
//
//     1.  Append ";" to output.
//
//     2.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with param_name to output.
//
//     3.  If param_value is not Boolean true:
//
//         1.  Append "=" to output.
//
//         2.  Append the result of running Serializing a bare Item
//             (Section 4.1.3.1) with param_value to output.
//
// 3.  Return output.
function serializeParams(params) {
    if (params == null) return '';
    return Object.entries(params).map(([key, value])=>{
        if (value === true) return `;${serializeKey(key)}`; // omit true
        return `;${serializeKey(key)}=${serializeBareItem(value)}`;
    }).join('');
}
// 4.1.3.  Serializing an Item
//
// Given an Item as bare_item and Parameters as item_parameters, return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  Append the result of running Serializing a Bare Item
//     Section 4.1.3.1 with bare_item to output.
//
// 3.  Append the result of running Serializing Parameters
//     Section 4.1.1.2 with item_parameters to output.
//
// 4.  Return output.
function serializeItem(value) {
    if (value instanceof SfItem) return `${serializeBareItem(value.value)}${serializeParams(value.params)}`;
    else return serializeBareItem(value);
}
// 4.1.1.1.  Serializing an Inner List
//
// Given an array of (member_value, parameters) tuples as inner_list,
// and parameters as list_parameters, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  Let output be the string "(".
//
// 2.  For each (member_value, parameters) of inner_list:
//
//     1.  Append the result of running Serializing an Item
//         (Section 4.1.3) with (member_value, parameters) to output.
//
//     2.  If more values remain in inner_list, append a single SP to
//         output.
//
// 3.  Append ")" to output.
//
// 4.  Append the result of running Serializing Parameters
//     (Section 4.1.1.2) with list_parameters to output.
//
// 5.  Return output.
function serializeInnerList(value) {
    return `(${value.value.map(serializeItem).join(' ')})${serializeParams(value.params)}`;
}
// 4.1.2.  Serializing a Dictionary
//
// Given an ordered Dictionary as input_dictionary (each member having a
// member_name and a tuple value of (member_value, parameters)), return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each member_name with a value of (member_value, parameters)
//     in input_dictionary:
//
//     1.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with member's member_name to output.
//
//     2.  If member_value is Boolean true:
//
//         1.  Append the result of running Serializing Parameters
//             (Section 4.1.1.2) with parameters to output.
//
//     3.  Otherwise:
//
//         1.  Append "=" to output.
//
//         2.  If member_value is an array, append the result of running
//             Serializing an Inner List (Section 4.1.1.1) with
//             (member_value, parameters) to output.
//
//         3.  Otherwise, append the result of running Serializing an
//             Item (Section 4.1.3) with (member_value, parameters) to
//             output.
//
//     4.  If more members remain in input_dictionary:
//
//         1.  Append "," to output.
//
//         2.  Append a single SP to output.
//
// 3.  Return output.
function serializeDict(dict, options = {
    whitespace: true
}) {
    if (typeof dict !== 'object') throw serializeError(dict, DICT);
    const entries = dict instanceof Map ? dict.entries() : Object.entries(dict);
    const optionalWhiteSpace = options != null && options.whitespace ? ' ' : '';
    return Array.from(entries).map(([key, item])=>{
        if (item instanceof SfItem === false) item = new SfItem(item);
        let output = serializeKey(key);
        if (item.value === true) output += serializeParams(item.params);
        else {
            output += '=';
            if (Array.isArray(item.value)) output += serializeInnerList(item);
            else output += serializeItem(item);
        }
        return output;
    }).join(`,${optionalWhiteSpace}`);
}
/**
 * Encode an object into a structured field dictionary
 *
 * @param input - The structured field dictionary to encode
 * @returns The structured field string
 *
 * @group Structured Field
 *
 * @beta
 */ function encodeSfDict(value, options) {
    return serializeDict(value, options);
}
/**
 * Checks if the given key is a token field.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a token field.
 *
 * @internal
 *
 * @group CMCD
 */ const isTokenField = (key)=>key === 'ot' || key === 'sf' || key === 'st';
const isValid = (value)=>{
    if (typeof value === 'number') return isFiniteNumber(value);
    return value != null && value !== '' && value !== false;
};
/**
 * Constructs a relative path from a URL.
 *
 * @param url - The destination URL
 * @param base - The base URL
 * @returns The relative path
 *
 * @group Utils
 *
 * @beta
 */ function urlToRelativePath(url, base) {
    const to = new URL(url);
    const from = new URL(base);
    if (to.origin !== from.origin) return url;
    const toPath = to.pathname.split('/').slice(1);
    const fromPath = from.pathname.split('/').slice(1, -1);
    // remove common parents
    while(toPath[0] === fromPath[0]){
        toPath.shift();
        fromPath.shift();
    }
    // add back paths
    while(fromPath.length){
        fromPath.shift();
        toPath.unshift('..');
    }
    return toPath.join('/');
}
/**
 * Generate a random v4 UUID
 *
 * @returns A random v4 UUID
 *
 * @group Utils
 *
 * @beta
 */ function uuid() {
    try {
        return crypto.randomUUID();
    } catch (error) {
        try {
            const url = URL.createObjectURL(new Blob());
            const uuid = url.toString();
            URL.revokeObjectURL(url);
            return uuid.slice(uuid.lastIndexOf('/') + 1);
        } catch (error) {
            let dt = new Date().getTime();
            const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
                const r = (dt + Math.random() * 16) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
            });
            return uuid;
        }
    }
}
const toRounded = (value)=>Math.round(value);
const toUrlSafe = (value, options)=>{
    if (options != null && options.baseUrl) value = urlToRelativePath(value, options.baseUrl);
    return encodeURIComponent(value);
};
const toHundred = (value)=>toRounded(value / 100) * 100;
/**
 * The default formatters for CMCD values.
 *
 * @group CMCD
 *
 * @beta
 */ const CmcdFormatters = {
    /**
   * Bitrate (kbps) rounded integer
   */ br: toRounded,
    /**
   * Duration (milliseconds) rounded integer
   */ d: toRounded,
    /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */ bl: toHundred,
    /**
   * Deadline (milliseconds) rounded nearest 100ms
   */ dl: toHundred,
    /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */ mtp: toHundred,
    /**
   * Next Object Request URL encoded
   */ nor: toUrlSafe,
    /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */ rtp: toHundred,
    /**
   * Top Bitrate (kbps) rounded integer
   */ tb: toRounded
};
/**
 * Internal CMCD processing function.
 *
 * @param obj - The CMCD object to process.
 * @param map - The mapping function to use.
 * @param options - Options for encoding.
 *
 * @internal
 *
 * @group CMCD
 */ function processCmcd(obj, options) {
    const results = {};
    if (obj == null || typeof obj !== 'object') return results;
    const keys = Object.keys(obj).sort();
    const formatters = _extends({}, CmcdFormatters, options == null ? void 0 : options.formatters);
    const filter = options == null ? void 0 : options.filter;
    keys.forEach((key)=>{
        if (filter != null && filter(key)) return;
        let value = obj[key];
        const formatter = formatters[key];
        if (formatter) value = formatter(value, options);
        // Version should only be reported if not equal to 1.
        if (key === 'v' && value === 1) return;
        // Playback rate should only be sent if not equal to 1.
        if (key == 'pr' && value === 1) return;
        // ignore invalid values
        if (!isValid(value)) return;
        if (isTokenField(key) && typeof value === 'string') value = new SfToken(value);
        results[key] = value;
    });
    return results;
}
/**
 * Encode a CMCD object to a string.
 *
 * @param cmcd - The CMCD object to encode.
 * @param options - Options for encoding.
 *
 * @returns The encoded CMCD string.
 *
 * @group CMCD
 *
 * @beta
 */ function encodeCmcd(cmcd, options = {}) {
    if (!cmcd) return '';
    return encodeSfDict(processCmcd(cmcd, options), _extends({
        whitespace: false
    }, options));
}
/**
 * Convert a CMCD data object to request headers
 *
 * @param cmcd - The CMCD data object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD header shards.
 *
 * @group CMCD
 *
 * @beta
 */ function toCmcdHeaders(cmcd, options = {}) {
    if (!cmcd) return {};
    const entries = Object.entries(cmcd);
    const headerMap = Object.entries(CmcdHeaderMap).concat(Object.entries((options == null ? void 0 : options.customHeaderMap) || {}));
    const shards = entries.reduce((acc, entry)=>{
        var _headerMap$find, _acc$field;
        const [key, value] = entry;
        const field = ((_headerMap$find = headerMap.find((entry)=>entry[1].includes(key))) == null ? void 0 : _headerMap$find[0]) || CmcdHeaderField.REQUEST;
        (_acc$field = acc[field]) != null ? _acc$field : acc[field] = {};
        acc[field][key] = value;
        return acc;
    }, {});
    return Object.entries(shards).reduce((acc, [field, value])=>{
        acc[field] = encodeCmcd(value, options);
        return acc;
    }, {});
}
/**
 * Append CMCD query args to a header object.
 *
 * @param headers - The headers to append to.
 * @param cmcd - The CMCD object to append.
 * @param customHeaderMap - A map of custom CMCD keys to header fields.
 *
 * @returns The headers with the CMCD header shards appended.
 *
 * @group CMCD
 *
 * @beta
 */ function appendCmcdHeaders(headers, cmcd, options) {
    return _extends(headers, toCmcdHeaders(cmcd, options));
}
/**
 * CMCD parameter name.
 *
 * @group CMCD
 *
 * @beta
 */ const CMCD_PARAM = 'CMCD';
/**
 * Convert a CMCD data object to a query arg.
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD query arg.
 *
 * @group CMCD
 *
 * @beta
 */ function toCmcdQuery(cmcd, options = {}) {
    if (!cmcd) return '';
    const params = encodeCmcd(cmcd, options);
    return `${CMCD_PARAM}=${encodeURIComponent(params)}`;
}
const REGEX = /CMCD=[^&#]+/;
/**
 * Append CMCD query args to a URL.
 *
 * @param url - The URL to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The URL with the CMCD query args appended.
 *
 * @group CMCD
 *
 * @beta
 */ function appendCmcdQuery(url, cmcd, options) {
    // TODO: Replace with URLSearchParams once we drop Safari < 10.1 & Chrome < 49 support.
    // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
    const query = toCmcdQuery(cmcd, options);
    if (!query) return url;
    if (REGEX.test(url)) return url.replace(REGEX, query);
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${query}`;
}
/**
 * Controller to deal with Common Media Client Data (CMCD)
 * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
 */ class CMCDController {
    // eslint-disable-line no-restricted-globals
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = void 0;
        this.sid = void 0;
        this.cid = void 0;
        this.useHeaders = false;
        this.includeKeys = void 0;
        this.initialized = false;
        this.starved = false;
        this.buffering = true;
        this.audioBuffer = void 0;
        // eslint-disable-line no-restricted-globals
        this.videoBuffer = void 0;
        this.onWaiting = ()=>{
            if (this.initialized) this.starved = true;
            this.buffering = true;
        };
        this.onPlaying = ()=>{
            if (!this.initialized) this.initialized = true;
            this.buffering = false;
        };
        /**
     * Apply CMCD data to a manifest request.
     */ this.applyPlaylistData = (context)=>{
            try {
                this.apply(context, {
                    ot: CmObjectType.MANIFEST,
                    su: !this.initialized
                });
            } catch (error) {
                logger.warn('Could not generate manifest CMCD data.', error);
            }
        };
        /**
     * Apply CMCD data to a segment request
     */ this.applyFragmentData = (context)=>{
            try {
                const fragment = context.frag;
                const level = this.hls.levels[fragment.level];
                const ot = this.getObjectType(fragment);
                const data = {
                    d: fragment.duration * 1000,
                    ot
                };
                if (ot === CmObjectType.VIDEO || ot === CmObjectType.AUDIO || ot == CmObjectType.MUXED) {
                    data.br = level.bitrate / 1000;
                    data.tb = this.getTopBandwidth(ot) / 1000;
                    data.bl = this.getBufferLength(ot);
                }
                this.apply(context, data);
            } catch (error) {
                logger.warn('Could not generate segment CMCD data.', error);
            }
        };
        this.hls = hls;
        const config = this.config = hls.config;
        const { cmcd } = config;
        if (cmcd != null) {
            config.pLoader = this.createPlaylistLoader();
            config.fLoader = this.createFragmentLoader();
            this.sid = cmcd.sessionId || uuid();
            this.cid = cmcd.contentId;
            this.useHeaders = cmcd.useHeaders === true;
            this.includeKeys = cmcd.includeKeys;
            this.registerListeners();
        }
    }
    registerListeners() {
        const hls = this.hls;
        hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
        hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
        hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetached();
        // @ts-ignore
        this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
        // @ts-ignore
        this.onWaiting = this.onPlaying = null;
    }
    onMediaAttached(event, data) {
        this.media = data.media;
        this.media.addEventListener('waiting', this.onWaiting);
        this.media.addEventListener('playing', this.onPlaying);
    }
    onMediaDetached() {
        if (!this.media) return;
        this.media.removeEventListener('waiting', this.onWaiting);
        this.media.removeEventListener('playing', this.onPlaying);
        // @ts-ignore
        this.media = null;
    }
    onBufferCreated(event, data) {
        var _data$tracks$audio, _data$tracks$video;
        this.audioBuffer = (_data$tracks$audio = data.tracks.audio) == null ? void 0 : _data$tracks$audio.buffer;
        this.videoBuffer = (_data$tracks$video = data.tracks.video) == null ? void 0 : _data$tracks$video.buffer;
    }
    /**
   * Create baseline CMCD data
   */ createData() {
        var _this$media;
        return {
            v: 1,
            sf: CmStreamingFormat.HLS,
            sid: this.sid,
            cid: this.cid,
            pr: (_this$media = this.media) == null ? void 0 : _this$media.playbackRate,
            mtp: this.hls.bandwidthEstimate / 1000
        };
    }
    /**
   * Apply CMCD data to a request.
   */ apply(context, data = {}) {
        // apply baseline data
        _extends(data, this.createData());
        const isVideo = data.ot === CmObjectType.INIT || data.ot === CmObjectType.VIDEO || data.ot === CmObjectType.MUXED;
        if (this.starved && isVideo) {
            data.bs = true;
            data.su = true;
            this.starved = false;
        }
        if (data.su == null) data.su = this.buffering;
        // TODO: Implement rtp, nrr, nor, dl
        const { includeKeys } = this;
        if (includeKeys) data = Object.keys(data).reduce((acc, key)=>{
            includeKeys.includes(key) && (acc[key] = data[key]);
            return acc;
        }, {});
        if (this.useHeaders) {
            if (!context.headers) context.headers = {};
            appendCmcdHeaders(context.headers, data);
        } else context.url = appendCmcdQuery(context.url, data);
    }
    /**
   * The CMCD object type.
   */ getObjectType(fragment) {
        const { type } = fragment;
        if (type === 'subtitle') return CmObjectType.TIMED_TEXT;
        if (fragment.sn === 'initSegment') return CmObjectType.INIT;
        if (type === 'audio') return CmObjectType.AUDIO;
        if (type === 'main') {
            if (!this.hls.audioTracks.length) return CmObjectType.MUXED;
            return CmObjectType.VIDEO;
        }
        return undefined;
    }
    /**
   * Get the highest bitrate.
   */ getTopBandwidth(type) {
        let bitrate = 0;
        let levels;
        const hls = this.hls;
        if (type === CmObjectType.AUDIO) levels = hls.audioTracks;
        else {
            const max = hls.maxAutoLevel;
            const len = max > -1 ? max + 1 : hls.levels.length;
            levels = hls.levels.slice(0, len);
        }
        for (const level of levels)if (level.bitrate > bitrate) bitrate = level.bitrate;
        return bitrate > 0 ? bitrate : NaN;
    }
    /**
   * Get the buffer length for a media type in milliseconds
   */ getBufferLength(type) {
        const media = this.hls.media;
        const buffer = type === CmObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
        if (!buffer || !media) return NaN;
        const info = BufferHelper.bufferInfo(buffer, media.currentTime, this.config.maxBufferHole);
        return info.len * 1000;
    }
    /**
   * Create a playlist loader
   */ createPlaylistLoader() {
        const { pLoader } = this.config;
        const apply = this.applyPlaylistData;
        const Ctor = pLoader || this.config.loader;
        return class CmcdPlaylistLoader {
            constructor(config){
                this.loader = void 0;
                this.loader = new Ctor(config);
            }
            get stats() {
                return this.loader.stats;
            }
            get context() {
                return this.loader.context;
            }
            destroy() {
                this.loader.destroy();
            }
            abort() {
                this.loader.abort();
            }
            load(context, config, callbacks) {
                apply(context);
                this.loader.load(context, config, callbacks);
            }
        };
    }
    /**
   * Create a playlist loader
   */ createFragmentLoader() {
        const { fLoader } = this.config;
        const apply = this.applyFragmentData;
        const Ctor = fLoader || this.config.loader;
        return class CmcdFragmentLoader {
            constructor(config){
                this.loader = void 0;
                this.loader = new Ctor(config);
            }
            get stats() {
                return this.loader.stats;
            }
            get context() {
                return this.loader.context;
            }
            destroy() {
                this.loader.destroy();
            }
            abort() {
                this.loader.abort();
            }
            load(context, config, callbacks) {
                apply(context);
                this.loader.load(context, config, callbacks);
            }
        };
    }
}
const PATHWAY_PENALTY_DURATION_MS = 300000;
class ContentSteeringController {
    constructor(hls){
        this.hls = void 0;
        this.log = void 0;
        this.loader = null;
        this.uri = null;
        this.pathwayId = '.';
        this.pathwayPriority = null;
        this.timeToLoad = 300;
        this.reloadTimer = -1;
        this.updated = 0;
        this.started = false;
        this.enabled = true;
        this.levels = null;
        this.audioTracks = null;
        this.subtitleTracks = null;
        this.penalizedPathways = {};
        this.hls = hls;
        this.log = logger.log.bind(logger, `[content-steering]:`);
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on(Events.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        if (!hls) return;
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off(Events.ERROR, this.onError, this);
    }
    startLoad() {
        this.started = true;
        this.clearTimeout();
        if (this.enabled && this.uri) {
            if (this.updated) {
                const ttl = this.timeToLoad * 1000 - (performance.now() - this.updated);
                if (ttl > 0) {
                    this.scheduleRefresh(this.uri, ttl);
                    return;
                }
            }
            this.loadSteeringManifest(this.uri);
        }
    }
    stopLoad() {
        this.started = false;
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
        this.clearTimeout();
    }
    clearTimeout() {
        if (this.reloadTimer !== -1) {
            self.clearTimeout(this.reloadTimer);
            this.reloadTimer = -1;
        }
    }
    destroy() {
        this.unregisterListeners();
        this.stopLoad();
        // @ts-ignore
        this.hls = null;
        this.levels = this.audioTracks = this.subtitleTracks = null;
    }
    removeLevel(levelToRemove) {
        const levels = this.levels;
        if (levels) this.levels = levels.filter((level)=>level !== levelToRemove);
    }
    onManifestLoading() {
        this.stopLoad();
        this.enabled = true;
        this.timeToLoad = 300;
        this.updated = 0;
        this.uri = null;
        this.pathwayId = '.';
        this.levels = this.audioTracks = this.subtitleTracks = null;
    }
    onManifestLoaded(event, data) {
        const { contentSteering } = data;
        if (contentSteering === null) return;
        this.pathwayId = contentSteering.pathwayId;
        this.uri = contentSteering.uri;
        if (this.started) this.startLoad();
    }
    onManifestParsed(event, data) {
        this.audioTracks = data.audioTracks;
        this.subtitleTracks = data.subtitleTracks;
    }
    onError(event, data) {
        const { errorAction } = data;
        if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox && errorAction.flags === ErrorActionFlags.MoveAllAlternatesMatchingHost) {
            const levels = this.levels;
            let pathwayPriority = this.pathwayPriority;
            let errorPathway = this.pathwayId;
            if (data.context) {
                const { groupId, pathwayId, type } = data.context;
                if (groupId && levels) errorPathway = this.getPathwayForGroupId(groupId, type, errorPathway);
                else if (pathwayId) errorPathway = pathwayId;
            }
            if (!(errorPathway in this.penalizedPathways)) this.penalizedPathways[errorPathway] = performance.now();
            if (!pathwayPriority && levels) // If PATHWAY-PRIORITY was not provided, list pathways for error handling
            pathwayPriority = levels.reduce((pathways, level)=>{
                if (pathways.indexOf(level.pathwayId) === -1) pathways.push(level.pathwayId);
                return pathways;
            }, []);
            if (pathwayPriority && pathwayPriority.length > 1) {
                this.updatePathwayPriority(pathwayPriority);
                errorAction.resolved = this.pathwayId !== errorPathway;
            }
            if (!errorAction.resolved) logger.warn(`Could not resolve ${data.details} ("${data.error.message}") with content-steering for Pathway: ${errorPathway} levels: ${levels ? levels.length : levels} priorities: ${JSON.stringify(pathwayPriority)} penalized: ${JSON.stringify(this.penalizedPathways)}`);
        }
    }
    filterParsedLevels(levels) {
        // Filter levels to only include those that are in the initial pathway
        this.levels = levels;
        let pathwayLevels = this.getLevelsForPathway(this.pathwayId);
        if (pathwayLevels.length === 0) {
            const pathwayId = levels[0].pathwayId;
            this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${pathwayId}"`);
            pathwayLevels = this.getLevelsForPathway(pathwayId);
            this.pathwayId = pathwayId;
        }
        if (pathwayLevels.length !== levels.length) {
            this.log(`Found ${pathwayLevels.length}/${levels.length} levels in Pathway "${this.pathwayId}"`);
            return pathwayLevels;
        }
        return levels;
    }
    getLevelsForPathway(pathwayId) {
        if (this.levels === null) return [];
        return this.levels.filter((level)=>pathwayId === level.pathwayId);
    }
    updatePathwayPriority(pathwayPriority) {
        this.pathwayPriority = pathwayPriority;
        let levels;
        // Evaluate if we should remove the pathway from the penalized list
        const penalizedPathways = this.penalizedPathways;
        const now = performance.now();
        Object.keys(penalizedPathways).forEach((pathwayId)=>{
            if (now - penalizedPathways[pathwayId] > PATHWAY_PENALTY_DURATION_MS) delete penalizedPathways[pathwayId];
        });
        for(let i = 0; i < pathwayPriority.length; i++){
            const pathwayId = pathwayPriority[i];
            if (pathwayId in penalizedPathways) continue;
            if (pathwayId === this.pathwayId) return;
            const selectedIndex = this.hls.nextLoadLevel;
            const selectedLevel = this.hls.levels[selectedIndex];
            levels = this.getLevelsForPathway(pathwayId);
            if (levels.length > 0) {
                this.log(`Setting Pathway to "${pathwayId}"`);
                this.pathwayId = pathwayId;
                reassignFragmentLevelIndexes(levels);
                this.hls.trigger(Events.LEVELS_UPDATED, {
                    levels
                });
                // Set LevelController's level to trigger LEVEL_SWITCHING which loads playlist if needed
                const levelAfterChange = this.hls.levels[selectedIndex];
                if (selectedLevel && levelAfterChange && this.levels) {
                    if (levelAfterChange.attrs['STABLE-VARIANT-ID'] !== selectedLevel.attrs['STABLE-VARIANT-ID'] && levelAfterChange.bitrate !== selectedLevel.bitrate) this.log(`Unstable Pathways change from bitrate ${selectedLevel.bitrate} to ${levelAfterChange.bitrate}`);
                    this.hls.nextLoadLevel = selectedIndex;
                }
                break;
            }
        }
    }
    getPathwayForGroupId(groupId, type, defaultPathway) {
        const levels = this.getLevelsForPathway(defaultPathway).concat(this.levels || []);
        for(let i = 0; i < levels.length; i++){
            if (type === PlaylistContextType.AUDIO_TRACK && levels[i].hasAudioGroup(groupId) || type === PlaylistContextType.SUBTITLE_TRACK && levels[i].hasSubtitleGroup(groupId)) return levels[i].pathwayId;
        }
        return defaultPathway;
    }
    clonePathways(pathwayClones) {
        const levels = this.levels;
        if (!levels) return;
        const audioGroupCloneMap = {};
        const subtitleGroupCloneMap = {};
        pathwayClones.forEach((pathwayClone)=>{
            const { ID: cloneId, 'BASE-ID': baseId, 'URI-REPLACEMENT': uriReplacement } = pathwayClone;
            if (levels.some((level)=>level.pathwayId === cloneId)) return;
            const clonedVariants = this.getLevelsForPathway(baseId).map((baseLevel)=>{
                const attributes = new AttrList(baseLevel.attrs);
                attributes['PATHWAY-ID'] = cloneId;
                const clonedAudioGroupId = attributes.AUDIO && `${attributes.AUDIO}_clone_${cloneId}`;
                const clonedSubtitleGroupId = attributes.SUBTITLES && `${attributes.SUBTITLES}_clone_${cloneId}`;
                if (clonedAudioGroupId) {
                    audioGroupCloneMap[attributes.AUDIO] = clonedAudioGroupId;
                    attributes.AUDIO = clonedAudioGroupId;
                }
                if (clonedSubtitleGroupId) {
                    subtitleGroupCloneMap[attributes.SUBTITLES] = clonedSubtitleGroupId;
                    attributes.SUBTITLES = clonedSubtitleGroupId;
                }
                const url = performUriReplacement(baseLevel.uri, attributes['STABLE-VARIANT-ID'], 'PER-VARIANT-URIS', uriReplacement);
                const clonedLevel = new Level({
                    attrs: attributes,
                    audioCodec: baseLevel.audioCodec,
                    bitrate: baseLevel.bitrate,
                    height: baseLevel.height,
                    name: baseLevel.name,
                    url,
                    videoCodec: baseLevel.videoCodec,
                    width: baseLevel.width
                });
                if (baseLevel.audioGroups) for(let i = 1; i < baseLevel.audioGroups.length; i++)clonedLevel.addGroupId('audio', `${baseLevel.audioGroups[i]}_clone_${cloneId}`);
                if (baseLevel.subtitleGroups) for(let i = 1; i < baseLevel.subtitleGroups.length; i++)clonedLevel.addGroupId('text', `${baseLevel.subtitleGroups[i]}_clone_${cloneId}`);
                return clonedLevel;
            });
            levels.push(...clonedVariants);
            cloneRenditionGroups(this.audioTracks, audioGroupCloneMap, uriReplacement, cloneId);
            cloneRenditionGroups(this.subtitleTracks, subtitleGroupCloneMap, uriReplacement, cloneId);
        });
    }
    loadSteeringManifest(uri) {
        const config = this.hls.config;
        const Loader = config.loader;
        if (this.loader) this.loader.destroy();
        this.loader = new Loader(config);
        let url;
        try {
            url = new self.URL(uri);
        } catch (error) {
            this.enabled = false;
            this.log(`Failed to parse Steering Manifest URI: ${uri}`);
            return;
        }
        if (url.protocol !== 'data:') {
            const throughput = (this.hls.bandwidthEstimate || config.abrEwmaDefaultEstimate) | 0;
            url.searchParams.set('_HLS_pathway', this.pathwayId);
            url.searchParams.set('_HLS_throughput', '' + throughput);
        }
        const context = {
            responseType: 'json',
            url: url.href
        };
        const loadPolicy = config.steeringManifestLoadPolicy.default;
        const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
        const loaderConfig = {
            loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
            retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
            maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
        };
        const callbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                this.log(`Loaded steering manifest: "${url}"`);
                const steeringData = response.data;
                if (steeringData.VERSION !== 1) {
                    this.log(`Steering VERSION ${steeringData.VERSION} not supported!`);
                    return;
                }
                this.updated = performance.now();
                this.timeToLoad = steeringData.TTL;
                const { 'RELOAD-URI': reloadUri, 'PATHWAY-CLONES': pathwayClones, 'PATHWAY-PRIORITY': pathwayPriority } = steeringData;
                if (reloadUri) try {
                    this.uri = new self.URL(reloadUri, url).href;
                } catch (error) {
                    this.enabled = false;
                    this.log(`Failed to parse Steering Manifest RELOAD-URI: ${reloadUri}`);
                    return;
                }
                this.scheduleRefresh(this.uri || context.url);
                if (pathwayClones) this.clonePathways(pathwayClones);
                const loadedSteeringData = {
                    steeringManifest: steeringData,
                    url: url.toString()
                };
                this.hls.trigger(Events.STEERING_MANIFEST_LOADED, loadedSteeringData);
                if (pathwayPriority) this.updatePathwayPriority(pathwayPriority);
            },
            onError: (error, context, networkDetails, stats)=>{
                this.log(`Error loading steering manifest: ${error.code} ${error.text} (${context.url})`);
                this.stopLoad();
                if (error.code === 410) {
                    this.enabled = false;
                    this.log(`Steering manifest ${context.url} no longer available`);
                    return;
                }
                let ttl = this.timeToLoad * 1000;
                if (error.code === 429) {
                    const loader = this.loader;
                    if (typeof (loader == null ? void 0 : loader.getResponseHeader) === 'function') {
                        const retryAfter = loader.getResponseHeader('Retry-After');
                        if (retryAfter) ttl = parseFloat(retryAfter) * 1000;
                    }
                    this.log(`Steering manifest ${context.url} rate limited`);
                    return;
                }
                this.scheduleRefresh(this.uri || context.url, ttl);
            },
            onTimeout: (stats, context, networkDetails)=>{
                this.log(`Timeout loading steering manifest (${context.url})`);
                this.scheduleRefresh(this.uri || context.url);
            }
        };
        this.log(`Requesting steering manifest: ${url}`);
        this.loader.load(context, loaderConfig, callbacks);
    }
    scheduleRefresh(uri, ttlMs = this.timeToLoad * 1000) {
        this.clearTimeout();
        this.reloadTimer = self.setTimeout(()=>{
            var _this$hls;
            const media = (_this$hls = this.hls) == null ? void 0 : _this$hls.media;
            if (media && !media.ended) {
                this.loadSteeringManifest(uri);
                return;
            }
            this.scheduleRefresh(uri, this.timeToLoad * 1000);
        }, ttlMs);
    }
}
function cloneRenditionGroups(tracks, groupCloneMap, uriReplacement, cloneId) {
    if (!tracks) return;
    Object.keys(groupCloneMap).forEach((audioGroupId)=>{
        const clonedTracks = tracks.filter((track)=>track.groupId === audioGroupId).map((track)=>{
            const clonedTrack = _extends({}, track);
            clonedTrack.details = undefined;
            clonedTrack.attrs = new AttrList(clonedTrack.attrs);
            clonedTrack.url = clonedTrack.attrs.URI = performUriReplacement(track.url, track.attrs['STABLE-RENDITION-ID'], 'PER-RENDITION-URIS', uriReplacement);
            clonedTrack.groupId = clonedTrack.attrs['GROUP-ID'] = groupCloneMap[audioGroupId];
            clonedTrack.attrs['PATHWAY-ID'] = cloneId;
            return clonedTrack;
        });
        tracks.push(...clonedTracks);
    });
}
function performUriReplacement(uri, stableId, perOptionKey, uriReplacement) {
    const { HOST: host, PARAMS: params, [perOptionKey]: perOptionUris } = uriReplacement;
    let perVariantUri;
    if (stableId) {
        perVariantUri = perOptionUris == null ? void 0 : perOptionUris[stableId];
        if (perVariantUri) uri = perVariantUri;
    }
    const url = new self.URL(uri);
    if (host && !perVariantUri) url.host = host;
    if (params) Object.keys(params).sort().forEach((key)=>{
        if (key) url.searchParams.set(key, params[key]);
    });
    return url.href;
}
const AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
class XhrLoader {
    constructor(config){
        this.xhrSetup = void 0;
        this.requestTimeout = void 0;
        this.retryTimeout = void 0;
        this.retryDelay = void 0;
        this.config = null;
        this.callbacks = null;
        this.context = null;
        this.loader = null;
        this.stats = void 0;
        this.xhrSetup = config ? config.xhrSetup || null : null;
        this.stats = new LoadStats();
        this.retryDelay = 0;
    }
    destroy() {
        this.callbacks = null;
        this.abortInternal();
        this.loader = null;
        this.config = null;
        this.context = null;
        this.xhrSetup = null;
        // @ts-ignore
        this.stats = null;
    }
    abortInternal() {
        const loader = this.loader;
        self.clearTimeout(this.requestTimeout);
        self.clearTimeout(this.retryTimeout);
        if (loader) {
            loader.onreadystatechange = null;
            loader.onprogress = null;
            if (loader.readyState !== 4) {
                this.stats.aborted = true;
                loader.abort();
            }
        }
    }
    abort() {
        var _this$callbacks;
        this.abortInternal();
        if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.loader);
    }
    load(context, config, callbacks) {
        if (this.stats.loading.start) throw new Error('Loader can only be used once.');
        this.stats.loading.start = self.performance.now();
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.loadInternal();
    }
    loadInternal() {
        const { config, context } = this;
        if (!config || !context) return;
        const xhr = this.loader = new self.XMLHttpRequest();
        const stats = this.stats;
        stats.loading.first = 0;
        stats.loaded = 0;
        stats.aborted = false;
        const xhrSetup = this.xhrSetup;
        if (xhrSetup) Promise.resolve().then(()=>{
            if (this.stats.aborted) return;
            return xhrSetup(xhr, context.url);
        }).catch((error)=>{
            xhr.open('GET', context.url, true);
            return xhrSetup(xhr, context.url);
        }).then(()=>{
            if (this.stats.aborted) return;
            this.openAndSendXhr(xhr, context, config);
        }).catch((error)=>{
            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
            this.callbacks.onError({
                code: xhr.status,
                text: error.message
            }, context, xhr, stats);
            return;
        });
        else this.openAndSendXhr(xhr, context, config);
    }
    openAndSendXhr(xhr, context, config) {
        if (!xhr.readyState) xhr.open('GET', context.url, true);
        const headers = context.headers;
        const { maxTimeToFirstByteMs, maxLoadTimeMs } = config.loadPolicy;
        if (headers) for(const header in headers)xhr.setRequestHeader(header, headers[header]);
        if (context.rangeEnd) xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
        xhr.onreadystatechange = this.readystatechange.bind(this);
        xhr.onprogress = this.loadprogress.bind(this);
        xhr.responseType = context.responseType;
        // setup timeout before we perform request
        self.clearTimeout(this.requestTimeout);
        config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
        this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.timeout);
        xhr.send();
    }
    readystatechange() {
        const { context, loader: xhr, stats } = this;
        if (!context || !xhr) return;
        const readyState = xhr.readyState;
        const config = this.config;
        // don't proceed if xhr has been aborted
        if (stats.aborted) return;
        // >= HEADERS_RECEIVED
        if (readyState >= 2) {
            if (stats.loading.first === 0) {
                stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
                // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
                if (config.timeout !== config.loadPolicy.maxLoadTimeMs) {
                    self.clearTimeout(this.requestTimeout);
                    config.timeout = config.loadPolicy.maxLoadTimeMs;
                    this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.loadPolicy.maxLoadTimeMs - (stats.loading.first - stats.loading.start));
                }
            }
            if (readyState === 4) {
                self.clearTimeout(this.requestTimeout);
                xhr.onreadystatechange = null;
                xhr.onprogress = null;
                const status1 = xhr.status;
                // http status between 200 to 299 are all successful
                const useResponse = xhr.responseType !== 'text';
                if (status1 >= 200 && status1 < 300 && (useResponse && xhr.response || xhr.responseText !== null)) {
                    stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
                    const data = useResponse ? xhr.response : xhr.responseText;
                    const len = xhr.responseType === 'arraybuffer' ? data.byteLength : data.length;
                    stats.loaded = stats.total = len;
                    stats.bwEstimate = stats.total * 8000 / (stats.loading.end - stats.loading.first);
                    if (!this.callbacks) return;
                    const onProgress = this.callbacks.onProgress;
                    if (onProgress) onProgress(stats, context, data, xhr);
                    if (!this.callbacks) return;
                    const response = {
                        url: xhr.responseURL,
                        data: data,
                        code: status1
                    };
                    this.callbacks.onSuccess(response, stats, context, xhr);
                } else {
                    const retryConfig = config.loadPolicy.errorRetry;
                    const retryCount = stats.retry;
                    // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
                    const response = {
                        url: context.url,
                        data: undefined,
                        code: status1
                    };
                    if (shouldRetry(retryConfig, retryCount, false, response)) this.retry(retryConfig);
                    else {
                        logger.error(`${status1} while loading ${context.url}`);
                        this.callbacks.onError({
                            code: status1,
                            text: xhr.statusText
                        }, context, xhr, stats);
                    }
                }
            }
        }
    }
    loadtimeout() {
        var _this$config;
        const retryConfig = (_this$config = this.config) == null ? void 0 : _this$config.loadPolicy.timeoutRetry;
        const retryCount = this.stats.retry;
        if (shouldRetry(retryConfig, retryCount, true)) this.retry(retryConfig);
        else {
            var _this$context;
            logger.warn(`timeout while loading ${(_this$context = this.context) == null ? void 0 : _this$context.url}`);
            const callbacks = this.callbacks;
            if (callbacks) {
                this.abortInternal();
                callbacks.onTimeout(this.stats, this.context, this.loader);
            }
        }
    }
    retry(retryConfig) {
        const { context, stats } = this;
        this.retryDelay = getRetryDelay(retryConfig, stats.retry);
        stats.retry++;
        logger.warn(`${status ? 'HTTP Status ' + status : 'Timeout'} while loading ${context == null ? void 0 : context.url}, retrying ${stats.retry}/${retryConfig.maxNumRetry} in ${this.retryDelay}ms`);
        // abort and reset internal state
        this.abortInternal();
        this.loader = null;
        // schedule retry
        self.clearTimeout(this.retryTimeout);
        this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
    }
    loadprogress(event) {
        const stats = this.stats;
        stats.loaded = event.loaded;
        if (event.lengthComputable) stats.total = event.total;
    }
    getCacheAge() {
        let result = null;
        if (this.loader && AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
            const ageHeader = this.loader.getResponseHeader('age');
            result = ageHeader ? parseFloat(ageHeader) : null;
        }
        return result;
    }
    getResponseHeader(name) {
        if (this.loader && new RegExp(`^${name}:\\s*[\\d.]+\\s*$`, 'im').test(this.loader.getAllResponseHeaders())) return this.loader.getResponseHeader(name);
        return null;
    }
}
function fetchSupported() {
    if (// @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request) try {
        new self.ReadableStream({}); // eslint-disable-line no-new
        return true;
    } catch (e) {
    /* noop */ }
    return false;
}
const BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
class FetchLoader {
    constructor(config /* HlsConfig */ ){
        this.fetchSetup = void 0;
        this.requestTimeout = void 0;
        this.request = null;
        this.response = null;
        this.controller = void 0;
        this.context = null;
        this.config = null;
        this.callbacks = null;
        this.stats = void 0;
        this.loader = null;
        this.fetchSetup = config.fetchSetup || getRequest;
        this.controller = new self.AbortController();
        this.stats = new LoadStats();
    }
    destroy() {
        this.loader = this.callbacks = this.context = this.config = this.request = null;
        this.abortInternal();
        this.response = null;
        // @ts-ignore
        this.fetchSetup = this.controller = this.stats = null;
    }
    abortInternal() {
        if (this.controller && !this.stats.loading.end) {
            this.stats.aborted = true;
            this.controller.abort();
        }
    }
    abort() {
        var _this$callbacks;
        this.abortInternal();
        if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.response);
    }
    load(context, config, callbacks) {
        const stats = this.stats;
        if (stats.loading.start) throw new Error('Loader can only be used once.');
        stats.loading.start = self.performance.now();
        const initParams = getRequestParameters(context, this.controller.signal);
        const onProgress = callbacks.onProgress;
        const isArrayBuffer = context.responseType === 'arraybuffer';
        const LENGTH = isArrayBuffer ? 'byteLength' : 'length';
        const { maxTimeToFirstByteMs, maxLoadTimeMs } = config.loadPolicy;
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.request = this.fetchSetup(context, initParams);
        self.clearTimeout(this.requestTimeout);
        config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
        this.requestTimeout = self.setTimeout(()=>{
            this.abortInternal();
            callbacks.onTimeout(stats, context, this.response);
        }, config.timeout);
        self.fetch(this.request).then((response)=>{
            this.response = this.loader = response;
            const first = Math.max(self.performance.now(), stats.loading.start);
            self.clearTimeout(this.requestTimeout);
            config.timeout = maxLoadTimeMs;
            this.requestTimeout = self.setTimeout(()=>{
                this.abortInternal();
                callbacks.onTimeout(stats, context, this.response);
            }, maxLoadTimeMs - (first - stats.loading.start));
            if (!response.ok) {
                const { status: status1, statusText } = response;
                throw new FetchError(statusText || 'fetch, bad network response', status1, response);
            }
            stats.loading.first = first;
            stats.total = getContentLength(response.headers) || stats.total;
            if (onProgress && isFiniteNumber(config.highWaterMark)) return this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
            if (isArrayBuffer) return response.arrayBuffer();
            if (context.responseType === 'json') return response.json();
            return response.text();
        }).then((responseData)=>{
            const response = this.response;
            if (!response) throw new Error('loader destroyed');
            self.clearTimeout(this.requestTimeout);
            stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
            const total = responseData[LENGTH];
            if (total) stats.loaded = stats.total = total;
            const loaderResponse = {
                url: response.url,
                data: responseData,
                code: response.status
            };
            if (onProgress && !isFiniteNumber(config.highWaterMark)) onProgress(stats, context, responseData, response);
            callbacks.onSuccess(loaderResponse, stats, context, response);
        }).catch((error)=>{
            self.clearTimeout(this.requestTimeout);
            if (stats.aborted) return;
            // CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
            // when destroying, 'error' itself can be undefined
            const code = !error ? 0 : error.code || 0;
            const text = !error ? null : error.message;
            callbacks.onError({
                code,
                text
            }, context, error ? error.details : null, stats);
        });
    }
    getCacheAge() {
        let result = null;
        if (this.response) {
            const ageHeader = this.response.headers.get('age');
            result = ageHeader ? parseFloat(ageHeader) : null;
        }
        return result;
    }
    getResponseHeader(name) {
        return this.response ? this.response.headers.get(name) : null;
    }
    loadProgressively(response, stats, context, highWaterMark = 0, onProgress) {
        const chunkCache = new ChunkCache();
        const reader = response.body.getReader();
        const pump = ()=>{
            return reader.read().then((data)=>{
                if (data.done) {
                    if (chunkCache.dataLength) onProgress(stats, context, chunkCache.flush(), response);
                    return Promise.resolve(new ArrayBuffer(0));
                }
                const chunk = data.value;
                const len = chunk.length;
                stats.loaded += len;
                if (len < highWaterMark || chunkCache.dataLength) {
                    // The current chunk is too small to to be emitted or the cache already has data
                    // Push it to the cache
                    chunkCache.push(chunk);
                    if (chunkCache.dataLength >= highWaterMark) // flush in order to join the typed arrays
                    onProgress(stats, context, chunkCache.flush(), response);
                } else // If there's nothing cached already, and the chache is large enough
                // just emit the progress event
                onProgress(stats, context, chunk, response);
                return pump();
            }).catch(()=>{
                /* aborted */ return Promise.reject();
            });
        };
        return pump();
    }
}
function getRequestParameters(context, signal) {
    const initParams = {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin',
        signal,
        headers: new self.Headers(_extends({}, context.headers))
    };
    if (context.rangeEnd) initParams.headers.set('Range', 'bytes=' + context.rangeStart + '-' + String(context.rangeEnd - 1));
    return initParams;
}
function getByteRangeLength(byteRangeHeader) {
    const result = BYTERANGE.exec(byteRangeHeader);
    if (result) return parseInt(result[2]) - parseInt(result[1]) + 1;
}
function getContentLength(headers) {
    const contentRange = headers.get('Content-Range');
    if (contentRange) {
        const byteRangeLength = getByteRangeLength(contentRange);
        if (isFiniteNumber(byteRangeLength)) return byteRangeLength;
    }
    const contentLength = headers.get('Content-Length');
    if (contentLength) return parseInt(contentLength);
}
function getRequest(context, initParams) {
    return new self.Request(context.url, initParams);
}
class FetchError extends Error {
    constructor(message, code, details){
        super(message);
        this.code = void 0;
        this.details = void 0;
        this.code = code;
        this.details = details;
    }
}
const WHITESPACE_CHAR = /\s/;
const Cues = {
    newCue (track, startTime, endTime, captionScreen) {
        const result = [];
        let row;
        // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
        let cue;
        let indenting;
        let indent;
        let text;
        const Cue = self.VTTCue || self.TextTrackCue;
        for(let r = 0; r < captionScreen.rows.length; r++){
            row = captionScreen.rows[r];
            indenting = true;
            indent = 0;
            text = '';
            if (!row.isEmpty()) {
                var _track$cues;
                for(let c = 0; c < row.chars.length; c++)if (WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) indent++;
                else {
                    text += row.chars[c].uchar;
                    indenting = false;
                }
                // To be used for cleaning-up orphaned roll-up captions
                row.cueStartTime = startTime;
                // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
                if (startTime === endTime) endTime += 0.0001;
                if (indent >= 16) indent--;
                else indent++;
                const cueText = fixLineBreaks(text.trim());
                const id = generateCueId(startTime, endTime, cueText);
                // If this cue already exists in the track do not push it
                if (!(track != null && (_track$cues = track.cues) != null && _track$cues.getCueById(id))) {
                    cue = new Cue(startTime, endTime, cueText);
                    cue.id = id;
                    cue.line = r + 1;
                    cue.align = 'left';
                    // Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
                    // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
                    // Firefox throws an exception and captions break with out of bounds 0-100 values
                    cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
                    result.push(cue);
                }
            }
        }
        if (track && result.length) {
            // Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
            result.sort((cueA, cueB)=>{
                if (cueA.line === 'auto' || cueB.line === 'auto') return 0;
                if (cueA.line > 8 && cueB.line > 8) return cueB.line - cueA.line;
                return cueA.line - cueB.line;
            });
            result.forEach((cue)=>addCueToTrack(track, cue));
        }
        return result;
    }
};
/**
 * @deprecated use fragLoadPolicy.default
 */ /**
 * @deprecated use manifestLoadPolicy.default and playlistLoadPolicy.default
 */ const defaultLoadPolicy = {
    maxTimeToFirstByteMs: 8000,
    maxLoadTimeMs: 20000,
    timeoutRetry: null,
    errorRetry: null
};
/**
 * @ignore
 * If possible, keep hlsDefaultConfig shallow
 * It is cloned whenever a new Hls instance is created, by keeping the config
 * shallow the properties are cloned, and we don't end up manipulating the default
 */ const hlsDefaultConfig = _objectSpread2(_objectSpread2({
    autoStartLoad: true,
    // used by stream-controller
    startPosition: -1,
    // used by stream-controller
    defaultAudioCodec: undefined,
    // used by stream-controller
    debug: false,
    // used by logger
    capLevelOnFPSDrop: false,
    // used by fps-controller
    capLevelToPlayerSize: false,
    // used by cap-level-controller
    ignoreDevicePixelRatio: false,
    // used by cap-level-controller
    preferManagedMediaSource: true,
    initialLiveManifestSize: 1,
    // used by stream-controller
    maxBufferLength: 30,
    // used by stream-controller
    backBufferLength: Infinity,
    // used by buffer-controller
    frontBufferFlushThreshold: Infinity,
    maxBufferSize: 60000000,
    // used by stream-controller
    maxBufferHole: 0.1,
    // used by stream-controller
    highBufferWatchdogPeriod: 2,
    // used by stream-controller
    nudgeOffset: 0.1,
    // used by stream-controller
    nudgeMaxRetry: 3,
    // used by stream-controller
    maxFragLookUpTolerance: 0.25,
    // used by stream-controller
    liveSyncDurationCount: 3,
    // used by latency-controller
    liveMaxLatencyDurationCount: Infinity,
    // used by latency-controller
    liveSyncDuration: undefined,
    // used by latency-controller
    liveMaxLatencyDuration: undefined,
    // used by latency-controller
    maxLiveSyncPlaybackRate: 1,
    // used by latency-controller
    liveDurationInfinity: false,
    // used by buffer-controller
    /**
   * @deprecated use backBufferLength
   */ liveBackBufferLength: null,
    // used by buffer-controller
    maxMaxBufferLength: 600,
    // used by stream-controller
    enableWorker: true,
    // used by transmuxer
    workerPath: null,
    // used by transmuxer
    enableSoftwareAES: true,
    // used by decrypter
    startLevel: undefined,
    // used by level-controller
    startFragPrefetch: false,
    // used by stream-controller
    fpsDroppedMonitoringPeriod: 5000,
    // used by fps-controller
    fpsDroppedMonitoringThreshold: 0.2,
    // used by fps-controller
    appendErrorMaxRetry: 3,
    // used by buffer-controller
    loader: XhrLoader,
    // loader: FetchLoader,
    fLoader: undefined,
    // used by fragment-loader
    pLoader: undefined,
    // used by playlist-loader
    xhrSetup: undefined,
    // used by xhr-loader
    licenseXhrSetup: undefined,
    // used by eme-controller
    licenseResponseCallback: undefined,
    // used by eme-controller
    abrController: AbrController,
    bufferController: BufferController,
    capLevelController: CapLevelController,
    errorController: ErrorController,
    fpsController: FPSController,
    stretchShortVideoTrack: false,
    // used by mp4-remuxer
    maxAudioFramesDrift: 1,
    // used by mp4-remuxer
    forceKeyFrameOnDiscontinuity: true,
    // used by ts-demuxer
    abrEwmaFastLive: 3,
    // used by abr-controller
    abrEwmaSlowLive: 9,
    // used by abr-controller
    abrEwmaFastVoD: 3,
    // used by abr-controller
    abrEwmaSlowVoD: 9,
    // used by abr-controller
    abrEwmaDefaultEstimate: 5e5,
    // 500 kbps  // used by abr-controller
    abrEwmaDefaultEstimateMax: 5e6,
    // 5 mbps
    abrBandWidthFactor: 0.95,
    // used by abr-controller
    abrBandWidthUpFactor: 0.7,
    // used by abr-controller
    abrMaxWithRealBitrate: false,
    // used by abr-controller
    maxStarvationDelay: 4,
    // used by abr-controller
    maxLoadingDelay: 4,
    // used by abr-controller
    minAutoBitrate: 0,
    // used by hls
    emeEnabled: false,
    // used by eme-controller
    widevineLicenseUrl: undefined,
    // used by eme-controller
    drmSystems: {},
    // used by eme-controller
    drmSystemOptions: {},
    // used by eme-controller
    requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess,
    // used by eme-controller
    testBandwidth: true,
    progressive: false,
    lowLatencyMode: true,
    cmcd: undefined,
    enableDateRangeMetadataCues: true,
    enableEmsgMetadataCues: true,
    enableID3MetadataCues: true,
    useMediaCapabilities: true,
    certLoadPolicy: {
        default: defaultLoadPolicy
    },
    keyLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 8000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 20000,
                backoff: 'linear'
            },
            errorRetry: {
                maxNumRetry: 8,
                retryDelayMs: 1000,
                maxRetryDelayMs: 20000,
                backoff: 'linear'
            }
        }
    },
    manifestLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: Infinity,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    playlistLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 2,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    fragLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 120000,
            timeoutRetry: {
                maxNumRetry: 4,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 6,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    steeringManifestLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    // These default settings are deprecated in favor of the above policies
    // and are maintained for backwards compatibility
    manifestLoadingTimeOut: 10000,
    manifestLoadingMaxRetry: 1,
    manifestLoadingRetryDelay: 1000,
    manifestLoadingMaxRetryTimeout: 64000,
    levelLoadingTimeOut: 10000,
    levelLoadingMaxRetry: 4,
    levelLoadingRetryDelay: 1000,
    levelLoadingMaxRetryTimeout: 64000,
    fragLoadingTimeOut: 20000,
    fragLoadingMaxRetry: 6,
    fragLoadingRetryDelay: 1000,
    fragLoadingMaxRetryTimeout: 64000
}, timelineConfig()), {}, {
    subtitleStreamController: SubtitleStreamController,
    subtitleTrackController: SubtitleTrackController,
    timelineController: TimelineController,
    audioStreamController: AudioStreamController,
    audioTrackController: AudioTrackController,
    emeController: EMEController,
    cmcdController: CMCDController,
    contentSteeringController: ContentSteeringController
});
function timelineConfig() {
    return {
        cueHandler: Cues,
        // used by timeline-controller
        enableWebVTT: true,
        // used by timeline-controller
        enableIMSC1: true,
        // used by timeline-controller
        enableCEA708Captions: true,
        // used by timeline-controller
        captionsTextTrack1Label: 'English',
        // used by timeline-controller
        captionsTextTrack1LanguageCode: 'en',
        // used by timeline-controller
        captionsTextTrack2Label: 'Spanish',
        // used by timeline-controller
        captionsTextTrack2LanguageCode: 'es',
        // used by timeline-controller
        captionsTextTrack3Label: 'Unknown CC',
        // used by timeline-controller
        captionsTextTrack3LanguageCode: '',
        // used by timeline-controller
        captionsTextTrack4Label: 'Unknown CC',
        // used by timeline-controller
        captionsTextTrack4LanguageCode: '',
        // used by timeline-controller
        renderTextTracksNatively: true
    };
}
/**
 * @ignore
 */ function mergeConfig(defaultConfig, userConfig) {
    if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
    if (userConfig.liveMaxLatencyDurationCount !== undefined && (userConfig.liveSyncDurationCount === undefined || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
    if (userConfig.liveMaxLatencyDuration !== undefined && (userConfig.liveSyncDuration === undefined || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
    const defaultsCopy = deepCpy(defaultConfig);
    // Backwards compatibility with deprecated config values
    const deprecatedSettingTypes = [
        'manifest',
        'level',
        'frag'
    ];
    const deprecatedSettings = [
        'TimeOut',
        'MaxRetry',
        'RetryDelay',
        'MaxRetryTimeout'
    ];
    deprecatedSettingTypes.forEach((type)=>{
        const policyName = `${type === 'level' ? 'playlist' : type}LoadPolicy`;
        const policyNotSet = userConfig[policyName] === undefined;
        const report = [];
        deprecatedSettings.forEach((setting)=>{
            const deprecatedSetting = `${type}Loading${setting}`;
            const value = userConfig[deprecatedSetting];
            if (value !== undefined && policyNotSet) {
                report.push(deprecatedSetting);
                const settings = defaultsCopy[policyName].default;
                userConfig[policyName] = {
                    default: settings
                };
                switch(setting){
                    case 'TimeOut':
                        settings.maxLoadTimeMs = value;
                        settings.maxTimeToFirstByteMs = value;
                        break;
                    case 'MaxRetry':
                        settings.errorRetry.maxNumRetry = value;
                        settings.timeoutRetry.maxNumRetry = value;
                        break;
                    case 'RetryDelay':
                        settings.errorRetry.retryDelayMs = value;
                        settings.timeoutRetry.retryDelayMs = value;
                        break;
                    case 'MaxRetryTimeout':
                        settings.errorRetry.maxRetryDelayMs = value;
                        settings.timeoutRetry.maxRetryDelayMs = value;
                        break;
                }
            }
        });
        if (report.length) logger.warn(`hls.js config: "${report.join('", "')}" setting(s) are deprecated, use "${policyName}": ${JSON.stringify(userConfig[policyName])}`);
    });
    return _objectSpread2(_objectSpread2({}, defaultsCopy), userConfig);
}
function deepCpy(obj) {
    if (obj && typeof obj === 'object') {
        if (Array.isArray(obj)) return obj.map(deepCpy);
        return Object.keys(obj).reduce((result, key)=>{
            result[key] = deepCpy(obj[key]);
            return result;
        }, {});
    }
    return obj;
}
/**
 * @ignore
 */ function enableStreamingMode(config) {
    const currentLoader = config.loader;
    if (currentLoader !== FetchLoader && currentLoader !== XhrLoader) {
        // If a developer has configured their own loader, respect that choice
        logger.log('[config]: Custom loader detected, cannot enable progressive streaming');
        config.progressive = false;
    } else {
        const canStreamProgressively = fetchSupported();
        if (canStreamProgressively) {
            config.loader = FetchLoader;
            config.progressive = true;
            config.enableSoftwareAES = true;
            logger.log('[config]: Progressive streaming enabled, using FetchLoader');
        }
    }
}
let chromeOrFirefox;
class LevelController extends BasePlaylistController {
    constructor(hls, contentSteeringController){
        super(hls, '[level-controller]');
        this._levels = [];
        this._firstLevel = -1;
        this._maxAutoLevel = -1;
        this._startLevel = void 0;
        this.currentLevel = null;
        this.currentLevelIndex = -1;
        this.manualLevelIndex = -1;
        this.steering = void 0;
        this.onParsedComplete = void 0;
        this.steering = contentSteeringController;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls } = this;
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on(Events.ERROR, this.onError, this);
    }
    _unregisterListeners() {
        const { hls } = this;
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off(Events.ERROR, this.onError, this);
    }
    destroy() {
        this._unregisterListeners();
        this.steering = null;
        this.resetLevels();
        super.destroy();
    }
    stopLoad() {
        const levels = this._levels;
        // clean up live level details to force reload them, and reset load errors
        levels.forEach((level)=>{
            level.loadError = 0;
            level.fragmentError = 0;
        });
        super.stopLoad();
    }
    resetLevels() {
        this._startLevel = undefined;
        this.manualLevelIndex = -1;
        this.currentLevelIndex = -1;
        this.currentLevel = null;
        this._levels = [];
        this._maxAutoLevel = -1;
    }
    onManifestLoading(event, data) {
        this.resetLevels();
    }
    onManifestLoaded(event, data) {
        const preferManagedMediaSource = this.hls.config.preferManagedMediaSource;
        const levels = [];
        const redundantSet = {};
        const generatePathwaySet = {};
        let resolutionFound = false;
        let videoCodecFound = false;
        let audioCodecFound = false;
        data.levels.forEach((levelParsed)=>{
            var _audioCodec, _videoCodec;
            const attributes = levelParsed.attrs;
            // erase audio codec info if browser does not support mp4a.40.34.
            // demuxer will autodetect codec and fallback to mpeg/audio
            let { audioCodec, videoCodec } = levelParsed;
            if (((_audioCodec = audioCodec) == null ? void 0 : _audioCodec.indexOf('mp4a.40.34')) !== -1) {
                chromeOrFirefox || (chromeOrFirefox = /chrome|firefox/i.test(navigator.userAgent));
                if (chromeOrFirefox) levelParsed.audioCodec = audioCodec = undefined;
            }
            if (audioCodec) levelParsed.audioCodec = audioCodec = getCodecCompatibleName(audioCodec, preferManagedMediaSource);
            if (((_videoCodec = videoCodec) == null ? void 0 : _videoCodec.indexOf('avc1')) === 0) videoCodec = levelParsed.videoCodec = convertAVC1ToAVCOTI(videoCodec);
            // only keep levels with supported audio/video codecs
            const { width, height, unknownCodecs } = levelParsed;
            resolutionFound || (resolutionFound = !!(width && height));
            videoCodecFound || (videoCodecFound = !!videoCodec);
            audioCodecFound || (audioCodecFound = !!audioCodec);
            if (unknownCodecs != null && unknownCodecs.length || audioCodec && !areCodecsMediaSourceSupported(audioCodec, 'audio', preferManagedMediaSource) || videoCodec && !areCodecsMediaSourceSupported(videoCodec, 'video', preferManagedMediaSource)) return;
            const { CODECS, 'FRAME-RATE': FRAMERATE, 'HDCP-LEVEL': HDCP, 'PATHWAY-ID': PATHWAY, RESOLUTION, 'VIDEO-RANGE': VIDEO_RANGE } = attributes;
            const contentSteeringPrefix = `${PATHWAY || '.'}-`;
            const levelKey = `${contentSteeringPrefix}${levelParsed.bitrate}-${RESOLUTION}-${FRAMERATE}-${CODECS}-${VIDEO_RANGE}-${HDCP}`;
            if (!redundantSet[levelKey]) {
                const level = new Level(levelParsed);
                redundantSet[levelKey] = level;
                generatePathwaySet[levelKey] = 1;
                levels.push(level);
            } else if (redundantSet[levelKey].uri !== levelParsed.url && !levelParsed.attrs['PATHWAY-ID']) {
                // Assign Pathway IDs to Redundant Streams (default Pathways is ".". Redundant Streams "..", "...", and so on.)
                // Content Steering controller to handles Pathway fallback on error
                const pathwayCount = generatePathwaySet[levelKey] += 1;
                levelParsed.attrs['PATHWAY-ID'] = new Array(pathwayCount + 1).join('.');
                const level = new Level(levelParsed);
                redundantSet[levelKey] = level;
                levels.push(level);
            } else {
                redundantSet[levelKey].addGroupId('audio', attributes.AUDIO);
                redundantSet[levelKey].addGroupId('text', attributes.SUBTITLES);
            }
        });
        this.filterAndSortMediaOptions(levels, data, resolutionFound, videoCodecFound, audioCodecFound);
    }
    filterAndSortMediaOptions(filteredLevels, data, resolutionFound, videoCodecFound, audioCodecFound) {
        let audioTracks = [];
        let subtitleTracks = [];
        let levels = filteredLevels;
        // remove audio-only and invalid video-range levels if we also have levels with video codecs or RESOLUTION signalled
        if ((resolutionFound || videoCodecFound) && audioCodecFound) levels = levels.filter(({ videoCodec, videoRange, width, height })=>(!!videoCodec || !!(width && height)) && isVideoRange(videoRange));
        if (levels.length === 0) {
            // Dispatch error after MANIFEST_LOADED is done propagating
            Promise.resolve().then(()=>{
                if (this.hls) {
                    if (data.levels.length) this.warn(`One or more CODECS in variant not supported: ${JSON.stringify(data.levels[0].attrs)}`);
                    const error = new Error('no level with compatible codecs found in manifest');
                    this.hls.trigger(Events.ERROR, {
                        type: ErrorTypes.MEDIA_ERROR,
                        details: ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                        fatal: true,
                        url: data.url,
                        error,
                        reason: error.message
                    });
                }
            });
            return;
        }
        if (data.audioTracks) {
            const { preferManagedMediaSource } = this.hls.config;
            audioTracks = data.audioTracks.filter((track)=>!track.audioCodec || areCodecsMediaSourceSupported(track.audioCodec, 'audio', preferManagedMediaSource));
            // Assign ids after filtering as array indices by group-id
            assignTrackIdsByGroup(audioTracks);
        }
        if (data.subtitles) {
            subtitleTracks = data.subtitles;
            assignTrackIdsByGroup(subtitleTracks);
        }
        // start bitrate is the first bitrate of the manifest
        const unsortedLevels = levels.slice(0);
        // sort levels from lowest to highest
        levels.sort((a, b)=>{
            if (a.attrs['HDCP-LEVEL'] !== b.attrs['HDCP-LEVEL']) return (a.attrs['HDCP-LEVEL'] || '') > (b.attrs['HDCP-LEVEL'] || '') ? 1 : -1;
            // sort on height before bitrate for cap-level-controller
            if (resolutionFound && a.height !== b.height) return a.height - b.height;
            if (a.frameRate !== b.frameRate) return a.frameRate - b.frameRate;
            if (a.videoRange !== b.videoRange) return VideoRangeValues.indexOf(a.videoRange) - VideoRangeValues.indexOf(b.videoRange);
            if (a.videoCodec !== b.videoCodec) {
                const valueA = videoCodecPreferenceValue(a.videoCodec);
                const valueB = videoCodecPreferenceValue(b.videoCodec);
                if (valueA !== valueB) return valueB - valueA;
            }
            if (a.uri === b.uri && a.codecSet !== b.codecSet) {
                const valueA = codecsSetSelectionPreferenceValue(a.codecSet);
                const valueB = codecsSetSelectionPreferenceValue(b.codecSet);
                if (valueA !== valueB) return valueB - valueA;
            }
            if (a.averageBitrate !== b.averageBitrate) return a.averageBitrate - b.averageBitrate;
            return 0;
        });
        let firstLevelInPlaylist = unsortedLevels[0];
        if (this.steering) {
            levels = this.steering.filterParsedLevels(levels);
            if (levels.length !== unsortedLevels.length) {
                for(let i = 0; i < unsortedLevels.length; i++)if (unsortedLevels[i].pathwayId === levels[0].pathwayId) {
                    firstLevelInPlaylist = unsortedLevels[i];
                    break;
                }
            }
        }
        this._levels = levels;
        // find index of first level in sorted levels
        for(let i = 0; i < levels.length; i++)if (levels[i] === firstLevelInPlaylist) {
            var _this$hls$userConfig;
            this._firstLevel = i;
            const firstLevelBitrate = firstLevelInPlaylist.bitrate;
            const bandwidthEstimate = this.hls.bandwidthEstimate;
            this.log(`manifest loaded, ${levels.length} level(s) found, first bitrate: ${firstLevelBitrate}`);
            // Update default bwe to first variant bitrate as long it has not been configured or set
            if (((_this$hls$userConfig = this.hls.userConfig) == null ? void 0 : _this$hls$userConfig.abrEwmaDefaultEstimate) === undefined) {
                const startingBwEstimate = Math.min(firstLevelBitrate, this.hls.config.abrEwmaDefaultEstimateMax);
                if (startingBwEstimate > bandwidthEstimate && bandwidthEstimate === hlsDefaultConfig.abrEwmaDefaultEstimate) this.hls.bandwidthEstimate = startingBwEstimate;
            }
            break;
        }
        // Audio is only alternate if manifest include a URI along with the audio group tag,
        // and this is not an audio-only stream where levels contain audio-only
        const audioOnly = audioCodecFound && !videoCodecFound;
        const edata = {
            levels,
            audioTracks,
            subtitleTracks,
            sessionData: data.sessionData,
            sessionKeys: data.sessionKeys,
            firstLevel: this._firstLevel,
            stats: data.stats,
            audio: audioCodecFound,
            video: videoCodecFound,
            altAudio: !audioOnly && audioTracks.some((t)=>!!t.url)
        };
        this.hls.trigger(Events.MANIFEST_PARSED, edata);
        // Initiate loading after all controllers have received MANIFEST_PARSED
        if (this.hls.config.autoStartLoad || this.hls.forceStartLoad) this.hls.startLoad(this.hls.config.startPosition);
    }
    get levels() {
        if (this._levels.length === 0) return null;
        return this._levels;
    }
    get level() {
        return this.currentLevelIndex;
    }
    set level(newLevel) {
        const levels = this._levels;
        if (levels.length === 0) return;
        // check if level idx is valid
        if (newLevel < 0 || newLevel >= levels.length) {
            // invalid level id given, trigger error
            const error = new Error('invalid level idx');
            const fatal = newLevel < 0;
            this.hls.trigger(Events.ERROR, {
                type: ErrorTypes.OTHER_ERROR,
                details: ErrorDetails.LEVEL_SWITCH_ERROR,
                level: newLevel,
                fatal,
                error,
                reason: error.message
            });
            if (fatal) return;
            newLevel = Math.min(newLevel, levels.length - 1);
        }
        const lastLevelIndex = this.currentLevelIndex;
        const lastLevel = this.currentLevel;
        const lastPathwayId = lastLevel ? lastLevel.attrs['PATHWAY-ID'] : undefined;
        const level = levels[newLevel];
        const pathwayId = level.attrs['PATHWAY-ID'];
        this.currentLevelIndex = newLevel;
        this.currentLevel = level;
        if (lastLevelIndex === newLevel && level.details && lastLevel && lastPathwayId === pathwayId) return;
        this.log(`Switching to level ${newLevel} (${level.height ? level.height + 'p ' : ''}${level.videoRange ? level.videoRange + ' ' : ''}${level.codecSet ? level.codecSet + ' ' : ''}@${level.bitrate})${pathwayId ? ' with Pathway ' + pathwayId : ''} from level ${lastLevelIndex}${lastPathwayId ? ' with Pathway ' + lastPathwayId : ''}`);
        const levelSwitchingData = {
            level: newLevel,
            attrs: level.attrs,
            details: level.details,
            bitrate: level.bitrate,
            averageBitrate: level.averageBitrate,
            maxBitrate: level.maxBitrate,
            realBitrate: level.realBitrate,
            width: level.width,
            height: level.height,
            codecSet: level.codecSet,
            audioCodec: level.audioCodec,
            videoCodec: level.videoCodec,
            audioGroups: level.audioGroups,
            subtitleGroups: level.subtitleGroups,
            loaded: level.loaded,
            loadError: level.loadError,
            fragmentError: level.fragmentError,
            name: level.name,
            id: level.id,
            uri: level.uri,
            url: level.url,
            urlId: 0,
            audioGroupIds: level.audioGroupIds,
            textGroupIds: level.textGroupIds
        };
        this.hls.trigger(Events.LEVEL_SWITCHING, levelSwitchingData);
        // check if we need to load playlist for this level
        const levelDetails = level.details;
        if (!levelDetails || levelDetails.live) {
            // level not retrieved yet, or live playlist we need to (re)load it
            const hlsUrlParameters = this.switchParams(level.uri, lastLevel == null ? void 0 : lastLevel.details, levelDetails);
            this.loadPlaylist(hlsUrlParameters);
        }
    }
    get manualLevel() {
        return this.manualLevelIndex;
    }
    set manualLevel(newLevel) {
        this.manualLevelIndex = newLevel;
        if (this._startLevel === undefined) this._startLevel = newLevel;
        if (newLevel !== -1) this.level = newLevel;
    }
    get firstLevel() {
        return this._firstLevel;
    }
    set firstLevel(newLevel) {
        this._firstLevel = newLevel;
    }
    get startLevel() {
        // Setting hls.startLevel (this._startLevel) overrides config.startLevel
        if (this._startLevel === undefined) {
            const configStartLevel = this.hls.config.startLevel;
            if (configStartLevel !== undefined) return configStartLevel;
            return this.hls.firstAutoLevel;
        }
        return this._startLevel;
    }
    set startLevel(newLevel) {
        this._startLevel = newLevel;
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === PlaylistContextType.LEVEL && data.context.level === this.level) this.checkRetry(data);
    }
    // reset errors on the successful load of a fragment
    onFragBuffered(event, { frag }) {
        if (frag !== undefined && frag.type === PlaylistLevelType.MAIN) {
            const el = frag.elementaryStreams;
            if (!Object.keys(el).some((type)=>!!el[type])) return;
            const level = this._levels[frag.level];
            if (level != null && level.loadError) {
                this.log(`Resetting level error count of ${level.loadError} on frag buffered`);
                level.loadError = 0;
            }
        }
    }
    onLevelLoaded(event, data) {
        var _data$deliveryDirecti2;
        const { level, details } = data;
        const curLevel = this._levels[level];
        if (!curLevel) {
            var _data$deliveryDirecti;
            this.warn(`Invalid level index ${level}`);
            if ((_data$deliveryDirecti = data.deliveryDirectives) != null && _data$deliveryDirecti.skip) details.deltaUpdateFailed = true;
            return;
        }
        // only process level loaded events matching with expected level
        if (level === this.currentLevelIndex) {
            // reset level load error counter on successful level loaded only if there is no issues with fragments
            if (curLevel.fragmentError === 0) curLevel.loadError = 0;
            this.playlistLoaded(level, data, curLevel.details);
        } else if ((_data$deliveryDirecti2 = data.deliveryDirectives) != null && _data$deliveryDirecti2.skip) // received a delta playlist update that cannot be merged
        details.deltaUpdateFailed = true;
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        const currentLevelIndex = this.currentLevelIndex;
        const currentLevel = this.currentLevel;
        if (currentLevel && this.shouldLoadPlaylist(currentLevel)) {
            let url = currentLevel.uri;
            if (hlsUrlParameters) try {
                url = hlsUrlParameters.addDirectives(url);
            } catch (error) {
                this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
            }
            const pathwayId = currentLevel.attrs['PATHWAY-ID'];
            this.log(`Loading level index ${currentLevelIndex}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''} with${pathwayId ? ' Pathway ' + pathwayId : ''} ${url}`);
            // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
            // console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
            this.clearTimer();
            this.hls.trigger(Events.LEVEL_LOADING, {
                url,
                level: currentLevelIndex,
                pathwayId: currentLevel.attrs['PATHWAY-ID'],
                id: 0,
                // Deprecated Level urlId
                deliveryDirectives: hlsUrlParameters || null
            });
        }
    }
    get nextLoadLevel() {
        if (this.manualLevelIndex !== -1) return this.manualLevelIndex;
        else return this.hls.nextAutoLevel;
    }
    set nextLoadLevel(nextLevel) {
        this.level = nextLevel;
        if (this.manualLevelIndex === -1) this.hls.nextAutoLevel = nextLevel;
    }
    removeLevel(levelIndex) {
        var _this$currentLevel;
        const levels = this._levels.filter((level, index)=>{
            if (index !== levelIndex) return true;
            if (this.steering) this.steering.removeLevel(level);
            if (level === this.currentLevel) {
                this.currentLevel = null;
                this.currentLevelIndex = -1;
                if (level.details) level.details.fragments.forEach((f)=>f.level = -1);
            }
            return false;
        });
        reassignFragmentLevelIndexes(levels);
        this._levels = levels;
        if (this.currentLevelIndex > -1 && (_this$currentLevel = this.currentLevel) != null && _this$currentLevel.details) this.currentLevelIndex = this.currentLevel.details.fragments[0].level;
        this.hls.trigger(Events.LEVELS_UPDATED, {
            levels
        });
    }
    onLevelsUpdated(event, { levels }) {
        this._levels = levels;
    }
    checkMaxAutoUpdated() {
        const { autoLevelCapping, maxAutoLevel, maxHdcpLevel } = this.hls;
        if (this._maxAutoLevel !== maxAutoLevel) {
            this._maxAutoLevel = maxAutoLevel;
            this.hls.trigger(Events.MAX_AUTO_LEVEL_UPDATED, {
                autoLevelCapping,
                levels: this.levels,
                maxAutoLevel,
                minAutoLevel: this.hls.minAutoLevel,
                maxHdcpLevel
            });
        }
    }
}
function assignTrackIdsByGroup(tracks) {
    const groups = {};
    tracks.forEach((track)=>{
        const groupId = track.groupId || '';
        track.id = groups[groupId] = groups[groupId] || 0;
        groups[groupId]++;
    });
}
class KeyLoader {
    constructor(config){
        this.config = void 0;
        this.keyUriToKeyInfo = {};
        this.emeController = null;
        this.config = config;
    }
    abort(type) {
        for(const uri in this.keyUriToKeyInfo){
            const loader = this.keyUriToKeyInfo[uri].loader;
            if (loader) {
                var _loader$context;
                if (type && type !== ((_loader$context = loader.context) == null ? void 0 : _loader$context.frag.type)) return;
                loader.abort();
            }
        }
    }
    detach() {
        for(const uri in this.keyUriToKeyInfo){
            const keyInfo = this.keyUriToKeyInfo[uri];
            // Remove cached EME keys on detach
            if (keyInfo.mediaKeySessionContext || keyInfo.decryptdata.isCommonEncryption) delete this.keyUriToKeyInfo[uri];
        }
    }
    destroy() {
        this.detach();
        for(const uri in this.keyUriToKeyInfo){
            const loader = this.keyUriToKeyInfo[uri].loader;
            if (loader) loader.destroy();
        }
        this.keyUriToKeyInfo = {};
    }
    createKeyLoadError(frag, details = ErrorDetails.KEY_LOAD_ERROR, error, networkDetails, response) {
        return new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details,
            fatal: false,
            frag,
            response,
            error,
            networkDetails
        });
    }
    loadClear(loadingFrag, encryptedFragments) {
        if (this.emeController && this.config.emeEnabled) {
            // access key-system with nearest key on start (loaidng frag is unencrypted)
            const { sn, cc } = loadingFrag;
            for(let i = 0; i < encryptedFragments.length; i++){
                const frag = encryptedFragments[i];
                if (cc <= frag.cc && (sn === 'initSegment' || frag.sn === 'initSegment' || sn < frag.sn)) {
                    this.emeController.selectKeySystemFormat(frag).then((keySystemFormat)=>{
                        frag.setKeyFormat(keySystemFormat);
                    });
                    break;
                }
            }
        }
    }
    load(frag) {
        if (!frag.decryptdata && frag.encrypted && this.emeController) // Multiple keys, but none selected, resolve in eme-controller
        return this.emeController.selectKeySystemFormat(frag).then((keySystemFormat)=>{
            return this.loadInternal(frag, keySystemFormat);
        });
        return this.loadInternal(frag);
    }
    loadInternal(frag, keySystemFormat) {
        var _keyInfo, _keyInfo2;
        if (keySystemFormat) frag.setKeyFormat(keySystemFormat);
        const decryptdata = frag.decryptdata;
        if (!decryptdata) {
            const error = new Error(keySystemFormat ? `Expected frag.decryptdata to be defined after setting format ${keySystemFormat}` : 'Missing decryption data on fragment in onKeyLoading');
            return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, error));
        }
        const uri = decryptdata.uri;
        if (!uri) return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${uri}"`)));
        let keyInfo = this.keyUriToKeyInfo[uri];
        if ((_keyInfo = keyInfo) != null && _keyInfo.decryptdata.key) {
            decryptdata.key = keyInfo.decryptdata.key;
            return Promise.resolve({
                frag,
                keyInfo
            });
        }
        // Return key load promise as long as it does not have a mediakey session with an unusable key status
        if ((_keyInfo2 = keyInfo) != null && _keyInfo2.keyLoadPromise) {
            var _keyInfo$mediaKeySess;
            switch((_keyInfo$mediaKeySess = keyInfo.mediaKeySessionContext) == null ? void 0 : _keyInfo$mediaKeySess.keyStatus){
                case undefined:
                case 'status-pending':
                case 'usable':
                case 'usable-in-future':
                    return keyInfo.keyLoadPromise.then((keyLoadedData)=>{
                        // Return the correct fragment with updated decryptdata key and loaded keyInfo
                        decryptdata.key = keyLoadedData.keyInfo.decryptdata.key;
                        return {
                            frag,
                            keyInfo
                        };
                    });
            }
        // If we have a key session and status and it is not pending or usable, continue
        // This will go back to the eme-controller for expired keys to get a new keyLoadPromise
        }
        // Load the key or return the loading promise
        keyInfo = this.keyUriToKeyInfo[uri] = {
            decryptdata,
            keyLoadPromise: null,
            loader: null,
            mediaKeySessionContext: null
        };
        switch(decryptdata.method){
            case 'ISO-23001-7':
            case 'SAMPLE-AES':
            case 'SAMPLE-AES-CENC':
            case 'SAMPLE-AES-CTR':
                if (decryptdata.keyFormat === 'identity') // loadKeyHTTP handles http(s) and data URLs
                return this.loadKeyHTTP(keyInfo, frag);
                return this.loadKeyEME(keyInfo, frag);
            case 'AES-128':
                return this.loadKeyHTTP(keyInfo, frag);
            default:
                return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${decryptdata.method}"`)));
        }
    }
    loadKeyEME(keyInfo, frag) {
        const keyLoadedData = {
            frag,
            keyInfo
        };
        if (this.emeController && this.config.emeEnabled) {
            const keySessionContextPromise = this.emeController.loadKey(keyLoadedData);
            if (keySessionContextPromise) return (keyInfo.keyLoadPromise = keySessionContextPromise.then((keySessionContext)=>{
                keyInfo.mediaKeySessionContext = keySessionContext;
                return keyLoadedData;
            })).catch((error)=>{
                // Remove promise for license renewal or retry
                keyInfo.keyLoadPromise = null;
                throw error;
            });
        }
        return Promise.resolve(keyLoadedData);
    }
    loadKeyHTTP(keyInfo, frag) {
        const config = this.config;
        const Loader = config.loader;
        const keyLoader = new Loader(config);
        frag.keyLoader = keyInfo.loader = keyLoader;
        return keyInfo.keyLoadPromise = new Promise((resolve, reject)=>{
            const loaderContext = {
                keyInfo,
                frag,
                responseType: 'arraybuffer',
                url: keyInfo.decryptdata.uri
            };
            // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
            // key-loader will trigger an error and rely on stream-controller to handle retry logic.
            // this will also align retry logic with fragment-loader
            const loadPolicy = config.keyLoadPolicy.default;
            const loaderConfig = {
                loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0
            };
            const loaderCallbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    const { frag, keyInfo, url: uri } = context;
                    if (!frag.decryptdata || keyInfo !== this.keyUriToKeyInfo[uri]) return reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error('after key load, decryptdata unset or changed'), networkDetails));
                    keyInfo.decryptdata.key = frag.decryptdata.key = new Uint8Array(response.data);
                    // detach fragment key loader on load success
                    frag.keyLoader = null;
                    keyInfo.loader = null;
                    resolve({
                        frag,
                        keyInfo
                    });
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`HTTP Error ${response.code} loading key ${response.text}`), networkDetails, _objectSpread2({
                        url: loaderContext.url,
                        data: undefined
                    }, response)));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_TIMEOUT, new Error('key loading timed out'), networkDetails));
                },
                onAbort: (stats, context, networkDetails)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, ErrorDetails.INTERNAL_ABORTED, new Error('key loading aborted'), networkDetails));
                }
            };
            keyLoader.load(loaderContext, loaderConfig, loaderCallbacks);
        });
    }
    resetLoader(context) {
        const { frag, keyInfo, url: uri } = context;
        const loader = keyInfo.loader;
        if (frag.keyLoader === loader) {
            frag.keyLoader = null;
            keyInfo.loader = null;
        }
        delete this.keyUriToKeyInfo[uri];
        if (loader) loader.destroy();
    }
}
function getSourceBuffer() {
    return self.SourceBuffer || self.WebKitSourceBuffer;
}
function isMSESupported() {
    const mediaSource = getMediaSource();
    if (!mediaSource) return false;
    // if SourceBuffer is exposed ensure its API is valid
    // Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
    const sourceBuffer = getSourceBuffer();
    return !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
}
function isSupported() {
    if (!isMSESupported()) return false;
    const mediaSource = getMediaSource();
    return typeof (mediaSource == null ? void 0 : mediaSource.isTypeSupported) === 'function' && ([
        'avc1.42E01E,mp4a.40.2',
        'av01.0.01M.08',
        'vp09.00.50.08'
    ].some((codecsForVideoContainer)=>mediaSource.isTypeSupported(mimeTypeForCodec(codecsForVideoContainer, 'video'))) || [
        'mp4a.40.2',
        'fLaC'
    ].some((codecForAudioContainer)=>mediaSource.isTypeSupported(mimeTypeForCodec(codecForAudioContainer, 'audio'))));
}
function changeTypeSupported() {
    var _sourceBuffer$prototy;
    const sourceBuffer = getSourceBuffer();
    return typeof (sourceBuffer == null ? void 0 : (_sourceBuffer$prototy = sourceBuffer.prototype) == null ? void 0 : _sourceBuffer$prototy.changeType) === 'function';
}
const STALL_MINIMUM_DURATION_MS = 250;
const MAX_START_GAP_JUMP = 2.0;
const SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
const SKIP_BUFFER_RANGE_START = 0.05;
class GapController {
    constructor(config, media, fragmentTracker, hls){
        this.config = void 0;
        this.media = null;
        this.fragmentTracker = void 0;
        this.hls = void 0;
        this.nudgeRetry = 0;
        this.stallReported = false;
        this.stalled = null;
        this.moved = false;
        this.seeking = false;
        this.config = config;
        this.media = media;
        this.fragmentTracker = fragmentTracker;
        this.hls = hls;
    }
    destroy() {
        this.media = null;
        // @ts-ignore
        this.hls = this.fragmentTracker = null;
    }
    /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */ poll(lastCurrentTime, activeFrag) {
        const { config, media, stalled } = this;
        if (media === null) return;
        const { currentTime, seeking } = media;
        const seeked = this.seeking && !seeking;
        const beginSeek = !this.seeking && seeking;
        this.seeking = seeking;
        // The playhead is moving, no-op
        if (currentTime !== lastCurrentTime) {
            this.moved = true;
            if (!seeking) this.nudgeRetry = 0;
            if (stalled !== null) {
                // The playhead is now moving, but was previously stalled
                if (this.stallReported) {
                    const _stalledDuration = self.performance.now() - stalled;
                    logger.warn(`playback not stuck anymore @${currentTime}, after ${Math.round(_stalledDuration)}ms`);
                    this.stallReported = false;
                }
                this.stalled = null;
            }
            return;
        }
        // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
        if (beginSeek || seeked) {
            this.stalled = null;
            return;
        }
        // The playhead should not be moving
        if (media.paused && !seeking || media.ended || media.playbackRate === 0 || !BufferHelper.getBuffered(media).length) {
            this.nudgeRetry = 0;
            return;
        }
        const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
        const nextStart = bufferInfo.nextStart || 0;
        if (seeking) {
            // Waiting for seeking in a buffered range to complete
            const hasEnoughBuffer = bufferInfo.len > MAX_START_GAP_JUMP;
            // Next buffered range is too far ahead to jump to while still seeking
            const noBufferGap = !nextStart || activeFrag && activeFrag.start <= currentTime || nextStart - currentTime > MAX_START_GAP_JUMP && !this.fragmentTracker.getPartialFragment(currentTime);
            if (hasEnoughBuffer || noBufferGap) return;
            // Reset moved state when seeking to a point in or before a gap
            this.moved = false;
        }
        // Skip start gaps if we haven't played, but the last poll detected the start of a stall
        // The addition poll gives the browser a chance to jump the gap for us
        if (!this.moved && this.stalled !== null) {
            var _level$details;
            // There is no playable buffer (seeked, waiting for buffer)
            const isBuffered = bufferInfo.len > 0;
            if (!isBuffered && !nextStart) return;
            // Jump start gaps within jump threshold
            const startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;
            // When joining a live stream with audio tracks, account for live playlist window sliding by allowing
            // a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
            // that begins over 1 target duration after the video start position.
            const level = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null;
            const isLive = level == null ? void 0 : (_level$details = level.details) == null ? void 0 : _level$details.live;
            const maxStartGapJump = isLive ? level.details.targetduration * 2 : MAX_START_GAP_JUMP;
            const partialOrGap = this.fragmentTracker.getPartialFragment(currentTime);
            if (startJump > 0 && (startJump <= maxStartGapJump || partialOrGap)) {
                if (!media.paused) this._trySkipBufferHole(partialOrGap);
                return;
            }
        }
        // Start tracking stall time
        const tnow = self.performance.now();
        if (stalled === null) {
            this.stalled = tnow;
            return;
        }
        const stalledDuration = tnow - stalled;
        if (!seeking && stalledDuration >= STALL_MINIMUM_DURATION_MS) {
            // Report stalling after trying to fix
            this._reportStall(bufferInfo);
            if (!this.media) return;
        }
        const bufferedWithHoles = BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
        this._tryFixBufferStall(bufferedWithHoles, stalledDuration);
    }
    /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */ _tryFixBufferStall(bufferInfo, stalledDurationMs) {
        const { config, fragmentTracker, media } = this;
        if (media === null) return;
        const currentTime = media.currentTime;
        const partial = fragmentTracker.getPartialFragment(currentTime);
        if (partial) {
            // Try to skip over the buffer hole caused by a partial fragment
            // This method isn't limited by the size of the gap between buffered ranges
            const targetTime = this._trySkipBufferHole(partial);
            // we return here in this case, meaning
            // the branch below only executes when we haven't seeked to a new position
            if (targetTime || !this.media) return;
        }
        // if we haven't had to skip over a buffer hole of a partial fragment
        // we may just have to "nudge" the playlist as the browser decoding/rendering engine
        // needs to cross some sort of threshold covering all source-buffers content
        // to start playing properly.
        if ((bufferInfo.len > config.maxBufferHole || bufferInfo.nextStart && bufferInfo.nextStart - currentTime < config.maxBufferHole) && stalledDurationMs > config.highBufferWatchdogPeriod * 1000) {
            logger.warn('Trying to nudge playhead over buffer-hole');
            // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
            // We only try to jump the hole if it's under the configured size
            // Reset stalled so to rearm watchdog timer
            this.stalled = null;
            this._tryNudgeBuffer();
        }
    }
    /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */ _reportStall(bufferInfo) {
        const { hls, media, stallReported } = this;
        if (!stallReported && media) {
            // Report stalled error once
            this.stallReported = true;
            const error = new Error(`Playback stalling at @${media.currentTime} due to low buffer (${JSON.stringify(bufferInfo)})`);
            logger.warn(error.message);
            hls.trigger(Events.ERROR, {
                type: ErrorTypes.MEDIA_ERROR,
                details: ErrorDetails.BUFFER_STALLED_ERROR,
                fatal: false,
                error,
                buffer: bufferInfo.len
            });
        }
    }
    /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */ _trySkipBufferHole(partial) {
        const { config, hls, media } = this;
        if (media === null) return 0;
        // Check if currentTime is between unbuffered regions of partial fragments
        const currentTime = media.currentTime;
        const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
        const startTime = currentTime < bufferInfo.start ? bufferInfo.start : bufferInfo.nextStart;
        if (startTime) {
            const bufferStarved = bufferInfo.len <= config.maxBufferHole;
            const waiting = bufferInfo.len > 0 && bufferInfo.len < 1 && media.readyState < 3;
            const gapLength = startTime - currentTime;
            if (gapLength > 0 && (bufferStarved || waiting)) {
                // Only allow large gaps to be skipped if it is a start gap, or all fragments in skip range are partial
                if (gapLength > config.maxBufferHole) {
                    const { fragmentTracker } = this;
                    let startGap = false;
                    if (currentTime === 0) {
                        const startFrag = fragmentTracker.getAppendedFrag(0, PlaylistLevelType.MAIN);
                        if (startFrag && startTime < startFrag.end) startGap = true;
                    }
                    if (!startGap) {
                        const startProvisioned = partial || fragmentTracker.getAppendedFrag(currentTime, PlaylistLevelType.MAIN);
                        if (startProvisioned) {
                            let moreToLoad = false;
                            let pos = startProvisioned.end;
                            while(pos < startTime){
                                const provisioned = fragmentTracker.getPartialFragment(pos);
                                if (provisioned) pos += provisioned.duration;
                                else {
                                    moreToLoad = true;
                                    break;
                                }
                            }
                            if (moreToLoad) return 0;
                        }
                    }
                }
                const targetTime = Math.max(startTime + SKIP_BUFFER_RANGE_START, currentTime + SKIP_BUFFER_HOLE_STEP_SECONDS);
                logger.warn(`skipping hole, adjusting currentTime from ${currentTime} to ${targetTime}`);
                this.moved = true;
                this.stalled = null;
                media.currentTime = targetTime;
                if (partial && !partial.gap) {
                    const error = new Error(`fragment loaded with buffer holes, seeking from ${currentTime} to ${targetTime}`);
                    hls.trigger(Events.ERROR, {
                        type: ErrorTypes.MEDIA_ERROR,
                        details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                        fatal: false,
                        error,
                        reason: error.message,
                        frag: partial
                    });
                }
                return targetTime;
            }
        }
        return 0;
    }
    /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */ _tryNudgeBuffer() {
        const { config, hls, media, nudgeRetry } = this;
        if (media === null) return;
        const currentTime = media.currentTime;
        this.nudgeRetry++;
        if (nudgeRetry < config.nudgeMaxRetry) {
            const targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
            // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
            const error = new Error(`Nudging 'currentTime' from ${currentTime} to ${targetTime}`);
            logger.warn(error.message);
            media.currentTime = targetTime;
            hls.trigger(Events.ERROR, {
                type: ErrorTypes.MEDIA_ERROR,
                details: ErrorDetails.BUFFER_NUDGE_ON_STALL,
                error,
                fatal: false
            });
        } else {
            const error = new Error(`Playhead still not moving while enough data buffered @${currentTime} after ${config.nudgeMaxRetry} nudges`);
            logger.error(error.message);
            hls.trigger(Events.ERROR, {
                type: ErrorTypes.MEDIA_ERROR,
                details: ErrorDetails.BUFFER_STALLED_ERROR,
                error,
                fatal: true
            });
        }
    }
}
const TICK_INTERVAL = 100; // how often to tick in ms
class StreamController extends BaseStreamController {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, '[stream-controller]', PlaylistLevelType.MAIN);
        this.audioCodecSwap = false;
        this.gapController = null;
        this.level = -1;
        this._forceStartLoad = false;
        this.altAudio = false;
        this.audioOnly = false;
        this.fragPlaying = null;
        this.onvplaying = null;
        this.onvseeked = null;
        this.fragLastKbps = 0;
        this.couldBacktrack = false;
        this.backtrackFragment = null;
        this.audioCodecSwitch = false;
        this.videoBuffer = null;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls } = this;
        hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
        hls.on(Events.ERROR, this.onError, this);
        hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.on(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
        hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    _unregisterListeners() {
        const { hls } = this;
        hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
        hls.off(Events.ERROR, this.onError, this);
        hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.off(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
        hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    onHandlerDestroying() {
        this._unregisterListeners();
        super.onHandlerDestroying();
    }
    startLoad(startPosition) {
        if (this.levels) {
            const { lastCurrentTime, hls } = this;
            this.stopLoad();
            this.setInterval(TICK_INTERVAL);
            this.level = -1;
            if (!this.startFragRequested) {
                // determine load level
                let startLevel = hls.startLevel;
                if (startLevel === -1) {
                    if (hls.config.testBandwidth && this.levels.length > 1) {
                        // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
                        startLevel = 0;
                        this.bitrateTest = true;
                    } else startLevel = hls.firstAutoLevel;
                }
                // set new level to playlist loader : this will trigger start level load
                // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
                hls.nextLoadLevel = startLevel;
                this.level = hls.loadLevel;
                this.loadedmetadata = false;
            }
            // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
            if (lastCurrentTime > 0 && startPosition === -1) {
                this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
                startPosition = lastCurrentTime;
            }
            this.state = State.IDLE;
            this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
            this.tick();
        } else {
            this._forceStartLoad = true;
            this.state = State.STOPPED;
        }
    }
    stopLoad() {
        this._forceStartLoad = false;
        super.stopLoad();
    }
    doTick() {
        switch(this.state){
            case State.WAITING_LEVEL:
                {
                    const { levels, level } = this;
                    const currentLevel = levels == null ? void 0 : levels[level];
                    const details = currentLevel == null ? void 0 : currentLevel.details;
                    if (details && (!details.live || this.levelLastLoaded === currentLevel)) {
                        if (this.waitForCdnTuneIn(details)) break;
                        this.state = State.IDLE;
                        break;
                    } else if (this.hls.nextLoadLevel !== this.level) {
                        this.state = State.IDLE;
                        break;
                    }
                    break;
                }
            case State.FRAG_LOADING_WAITING_RETRY:
                {
                    var _this$media;
                    const now = self.performance.now();
                    const retryDate = this.retryDate;
                    // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                    if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
                        const { levels, level } = this;
                        const currentLevel = levels == null ? void 0 : levels[level];
                        this.resetStartWhenNotLoaded(currentLevel || null);
                        this.state = State.IDLE;
                    }
                }
                break;
        }
        if (this.state === State.IDLE) this.doTickIdle();
        this.onTickEnd();
    }
    onTickEnd() {
        super.onTickEnd();
        this.checkBuffer();
        this.checkFragmentChanged();
    }
    doTickIdle() {
        const { hls, levelLastLoaded, levels, media } = this;
        // if start level not parsed yet OR
        // if video not attached AND start fragment already requested OR start frag prefetch not enabled
        // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
        if (levelLastLoaded === null || !media && (this.startFragRequested || !hls.config.startFragPrefetch)) return;
        // If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
        if (this.altAudio && this.audioOnly) return;
        const level = hls.nextLoadLevel;
        if (!(levels != null && levels[level])) return;
        const levelInfo = levels[level];
        // if buffer length is less than maxBufLen try to load a new fragment
        const bufferInfo = this.getMainFwdBufferInfo();
        if (bufferInfo === null) return;
        const lastDetails = this.getLevelDetails();
        if (lastDetails && this._streamEnded(bufferInfo, lastDetails)) {
            const data = {};
            if (this.altAudio) data.type = 'video';
            this.hls.trigger(Events.BUFFER_EOS, data);
            this.state = State.ENDED;
            return;
        }
        // set next load level : this will trigger a playlist load if needed
        if (hls.loadLevel !== level && hls.manualLevel === -1) this.log(`Adapting to level ${level} from level ${this.level}`);
        this.level = hls.nextLoadLevel = level;
        const levelDetails = levelInfo.details;
        // if level info not retrieved yet, switch state and wait for level retrieval
        // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
        // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
        if (!levelDetails || this.state === State.WAITING_LEVEL || levelDetails.live && this.levelLastLoaded !== levelInfo) {
            this.level = level;
            this.state = State.WAITING_LEVEL;
            return;
        }
        const bufferLen = bufferInfo.len;
        // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
        const maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);
        // Stay idle if we are still with buffer margins
        if (bufferLen >= maxBufLen) return;
        if (this.backtrackFragment && this.backtrackFragment.start > bufferInfo.end) this.backtrackFragment = null;
        const targetBufferTime = this.backtrackFragment ? this.backtrackFragment.start : bufferInfo.end;
        let frag = this.getNextFragment(targetBufferTime, levelDetails);
        // Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
        if (this.couldBacktrack && !this.fragPrevious && frag && frag.sn !== 'initSegment' && this.fragmentTracker.getState(frag) !== FragmentState.OK) {
            var _this$backtrackFragme;
            const backtrackSn = ((_this$backtrackFragme = this.backtrackFragment) != null ? _this$backtrackFragme : frag).sn;
            const fragIdx = backtrackSn - levelDetails.startSN;
            const backtrackFrag = levelDetails.fragments[fragIdx - 1];
            if (backtrackFrag && frag.cc === backtrackFrag.cc) {
                frag = backtrackFrag;
                this.fragmentTracker.removeFragment(backtrackFrag);
            }
        } else if (this.backtrackFragment && bufferInfo.len) this.backtrackFragment = null;
        // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
        if (frag && this.isLoopLoading(frag, targetBufferTime)) {
            const gapStart = frag.gap;
            if (!gapStart) {
                // Cleanup the fragment tracker before trying to find the next unbuffered fragment
                const type = this.audioOnly && !this.altAudio ? ElementaryStreamTypes.AUDIO : ElementaryStreamTypes.VIDEO;
                const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
                if (mediaBuffer) this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
            }
            frag = this.getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
        }
        if (!frag) return;
        if (frag.initSegment && !frag.initSegment.data && !this.bitrateTest) frag = frag.initSegment;
        this.loadFragment(frag, levelInfo, targetBufferTime);
    }
    loadFragment(frag, level, targetBufferTime) {
        // Check if fragment is not loaded
        const fragState = this.fragmentTracker.getState(frag);
        this.fragCurrent = frag;
        if (fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
            if (frag.sn === 'initSegment') this._loadInitSegment(frag, level);
            else if (this.bitrateTest) {
                this.log(`Fragment ${frag.sn} of level ${frag.level} is being downloaded to test bitrate and will not be buffered`);
                this._loadBitrateTestFrag(frag, level);
            } else {
                this.startFragRequested = true;
                super.loadFragment(frag, level, targetBufferTime);
            }
        } else this.clearTrackerIfNeeded(frag);
    }
    getBufferedFrag(position) {
        return this.fragmentTracker.getBufferedFrag(position, PlaylistLevelType.MAIN);
    }
    followingBufferedFrag(frag) {
        if (frag) // try to get range of next fragment (500ms after this range)
        return this.getBufferedFrag(frag.end + 0.5);
        return null;
    }
    /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */ immediateLevelSwitch() {
        this.abortCurrentFrag();
        this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
    }
    /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */ nextLevelSwitch() {
        const { levels, media } = this;
        // ensure that media is defined and that metadata are available (to retrieve currentTime)
        if (media != null && media.readyState) {
            let fetchdelay;
            const fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
            if (fragPlayingCurrent && fragPlayingCurrent.start > 1) // flush buffer preceding current fragment (flush until current fragment start offset)
            // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
            this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
            const levelDetails = this.getLevelDetails();
            if (levelDetails != null && levelDetails.live) {
                const bufferInfo = this.getMainFwdBufferInfo();
                // Do not flush in live stream with low buffer
                if (!bufferInfo || bufferInfo.len < levelDetails.targetduration * 2) return;
            }
            if (!media.paused && levels) {
                // add a safety delay of 1s
                const nextLevelId = this.hls.nextLoadLevel;
                const nextLevel = levels[nextLevelId];
                const fragLastKbps = this.fragLastKbps;
                if (fragLastKbps && this.fragCurrent) fetchdelay = this.fragCurrent.duration * nextLevel.maxBitrate / (1000 * fragLastKbps) + 1;
                else fetchdelay = 0;
            } else fetchdelay = 0;
            // this.log('fetchdelay:'+fetchdelay);
            // find buffer range that will be reached once new fragment will be fetched
            const bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
            if (bufferedFrag) {
                // we can flush buffer range following this one without stalling playback
                const nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
                if (nextBufferedFrag) {
                    // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
                    this.abortCurrentFrag();
                    // start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
                    const maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
                    const fragDuration = nextBufferedFrag.duration;
                    const startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - this.config.maxFragLookUpTolerance, fragDuration * (this.couldBacktrack ? 0.5 : 0.125)), fragDuration * (this.couldBacktrack ? 0.75 : 0.25)));
                    this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
                }
            }
        }
    }
    abortCurrentFrag() {
        const fragCurrent = this.fragCurrent;
        this.fragCurrent = null;
        this.backtrackFragment = null;
        if (fragCurrent) {
            fragCurrent.abortRequests();
            this.fragmentTracker.removeFragment(fragCurrent);
        }
        switch(this.state){
            case State.KEY_LOADING:
            case State.FRAG_LOADING:
            case State.FRAG_LOADING_WAITING_RETRY:
            case State.PARSING:
            case State.PARSED:
                this.state = State.IDLE;
                break;
        }
        this.nextLoadPosition = this.getLoadPosition();
    }
    flushMainBuffer(startOffset, endOffset) {
        super.flushMainBuffer(startOffset, endOffset, this.altAudio ? 'video' : null);
    }
    onMediaAttached(event, data) {
        super.onMediaAttached(event, data);
        const media = data.media;
        this.onvplaying = this.onMediaPlaying.bind(this);
        this.onvseeked = this.onMediaSeeked.bind(this);
        media.addEventListener('playing', this.onvplaying);
        media.addEventListener('seeked', this.onvseeked);
        this.gapController = new GapController(this.config, media, this.fragmentTracker, this.hls);
    }
    onMediaDetaching() {
        const { media } = this;
        if (media && this.onvplaying && this.onvseeked) {
            media.removeEventListener('playing', this.onvplaying);
            media.removeEventListener('seeked', this.onvseeked);
            this.onvplaying = this.onvseeked = null;
            this.videoBuffer = null;
        }
        this.fragPlaying = null;
        if (this.gapController) {
            this.gapController.destroy();
            this.gapController = null;
        }
        super.onMediaDetaching();
    }
    onMediaPlaying() {
        // tick to speed up FRAG_CHANGED triggering
        this.tick();
    }
    onMediaSeeked() {
        const media = this.media;
        const currentTime = media ? media.currentTime : null;
        if (isFiniteNumber(currentTime)) this.log(`Media seeked to ${currentTime.toFixed(3)}`);
        // If seeked was issued before buffer was appended do not tick immediately
        const bufferInfo = this.getMainFwdBufferInfo();
        if (bufferInfo === null || bufferInfo.len === 0) {
            this.warn(`Main forward buffer length on "seeked" event ${bufferInfo ? bufferInfo.len : 'empty'})`);
            return;
        }
        // tick to speed up FRAG_CHANGED triggering
        this.tick();
    }
    onManifestLoading() {
        // reset buffer on manifest loading
        this.log('Trigger BUFFER_RESET');
        this.hls.trigger(Events.BUFFER_RESET, undefined);
        this.fragmentTracker.removeAllFragments();
        this.couldBacktrack = false;
        this.startPosition = this.lastCurrentTime = this.fragLastKbps = 0;
        this.levels = this.fragPlaying = this.backtrackFragment = this.levelLastLoaded = null;
        this.altAudio = this.audioOnly = this.startFragRequested = false;
    }
    onManifestParsed(event, data) {
        // detect if we have different kind of audio codecs used amongst playlists
        let aac = false;
        let heaac = false;
        data.levels.forEach((level)=>{
            const codec = level.audioCodec;
            if (codec) {
                aac = aac || codec.indexOf('mp4a.40.2') !== -1;
                heaac = heaac || codec.indexOf('mp4a.40.5') !== -1;
            }
        });
        this.audioCodecSwitch = aac && heaac && !changeTypeSupported();
        if (this.audioCodecSwitch) this.log('Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
        this.levels = data.levels;
        this.startFragRequested = false;
    }
    onLevelLoading(event, data) {
        const { levels } = this;
        if (!levels || this.state !== State.IDLE) return;
        const level = levels[data.level];
        if (!level.details || level.details.live && this.levelLastLoaded !== level || this.waitForCdnTuneIn(level.details)) this.state = State.WAITING_LEVEL;
    }
    onLevelLoaded(event, data) {
        var _curLevel$details;
        const { levels } = this;
        const newLevelId = data.level;
        const newDetails = data.details;
        const duration = newDetails.totalduration;
        if (!levels) {
            this.warn(`Levels were reset while loading level ${newLevelId}`);
            return;
        }
        this.log(`Level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''}, cc [${newDetails.startCC}, ${newDetails.endCC}] duration:${duration}`);
        const curLevel = levels[newLevelId];
        const fragCurrent = this.fragCurrent;
        if (fragCurrent && (this.state === State.FRAG_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY)) {
            if (fragCurrent.level !== data.level && fragCurrent.loader) this.abortCurrentFrag();
        }
        let sliding = 0;
        if (newDetails.live || (_curLevel$details = curLevel.details) != null && _curLevel$details.live) {
            var _this$levelLastLoaded;
            this.checkLiveUpdate(newDetails);
            if (newDetails.deltaUpdateFailed) return;
            sliding = this.alignPlaylists(newDetails, curLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
        }
        // override level info
        curLevel.details = newDetails;
        this.levelLastLoaded = curLevel;
        this.hls.trigger(Events.LEVEL_UPDATED, {
            details: newDetails,
            level: newLevelId
        });
        // only switch back to IDLE state if we were waiting for level to start downloading a new fragment
        if (this.state === State.WAITING_LEVEL) {
            if (this.waitForCdnTuneIn(newDetails)) // Wait for Low-Latency CDN Tune-in
            return;
            this.state = State.IDLE;
        }
        if (!this.startFragRequested) this.setStartPosition(newDetails, sliding);
        else if (newDetails.live) this.synchronizeToLiveEdge(newDetails);
        // trigger handler right now
        this.tick();
    }
    _handleFragmentLoadProgress(data) {
        var _frag$initSegment;
        const { frag, part, payload } = data;
        const { levels } = this;
        if (!levels) {
            this.warn(`Levels were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
            return;
        }
        const currentLevel = levels[frag.level];
        const details = currentLevel.details;
        if (!details) {
            this.warn(`Dropping fragment ${frag.sn} of level ${frag.level} after level details were reset`);
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        const videoCodec = currentLevel.videoCodec;
        // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
        const accurateTimeOffset = details.PTSKnown || !details.live;
        const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
        const audioCodec = this._getAudioCodec(currentLevel);
        // transmux the MPEG-TS data to ISO-BMFF segments
        // this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
        const transmuxer = this.transmuxer = this.transmuxer || new TransmuxerInterface(this.hls, PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
        const partIndex = part ? part.index : -1;
        const partial = partIndex !== -1;
        const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
        const initPTS = this.initPTS[frag.cc];
        transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
    }
    onAudioTrackSwitching(event, data) {
        // if any URL found on new audio track, it is an alternate audio track
        const fromAltAudio = this.altAudio;
        const altAudio = !!data.url;
        // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
        // don't do anything if we switch to alt audio: audio stream controller is handling it.
        // we will just have to change buffer scheduling on audioTrackSwitched
        if (!altAudio) {
            if (this.mediaBuffer !== this.media) {
                this.log('Switching on main audio, use media.buffered to schedule main fragment loading');
                this.mediaBuffer = this.media;
                const fragCurrent = this.fragCurrent;
                // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
                if (fragCurrent) {
                    this.log('Switching to main audio track, cancel main fragment load');
                    fragCurrent.abortRequests();
                    this.fragmentTracker.removeFragment(fragCurrent);
                }
                // destroy transmuxer to force init segment generation (following audio switch)
                this.resetTransmuxer();
                // switch to IDLE state to load new fragment
                this.resetLoadingState();
            } else if (this.audioOnly) // Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
            this.resetTransmuxer();
            const hls = this.hls;
            // If switching from alt to main audio, flush all audio and trigger track switched
            if (fromAltAudio) {
                hls.trigger(Events.BUFFER_FLUSHING, {
                    startOffset: 0,
                    endOffset: Number.POSITIVE_INFINITY,
                    type: null
                });
                this.fragmentTracker.removeAllFragments();
            }
            hls.trigger(Events.AUDIO_TRACK_SWITCHED, data);
        }
    }
    onAudioTrackSwitched(event, data) {
        const trackId = data.id;
        const altAudio = !!this.hls.audioTracks[trackId].url;
        if (altAudio) {
            const videoBuffer = this.videoBuffer;
            // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
            if (videoBuffer && this.mediaBuffer !== videoBuffer) {
                this.log('Switching on alternate audio, use video.buffered to schedule main fragment loading');
                this.mediaBuffer = videoBuffer;
            }
        }
        this.altAudio = altAudio;
        this.tick();
    }
    onBufferCreated(event, data) {
        const tracks = data.tracks;
        let mediaTrack;
        let name;
        let alternate = false;
        for(const type in tracks){
            const track = tracks[type];
            if (track.id === 'main') {
                name = type;
                mediaTrack = track;
                // keep video source buffer reference
                if (type === 'video') {
                    const videoTrack = tracks[type];
                    if (videoTrack) this.videoBuffer = videoTrack.buffer;
                }
            } else alternate = true;
        }
        if (alternate && mediaTrack) {
            this.log(`Alternate track found, use ${name}.buffered to schedule main fragment loading`);
            this.mediaBuffer = mediaTrack.buffer;
        } else this.mediaBuffer = this.media;
    }
    onFragBuffered(event, data) {
        const { frag, part } = data;
        if (frag && frag.type !== PlaylistLevelType.MAIN) return;
        if (this.fragContextChanged(frag)) {
            // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
            // Avoid setting state back to IDLE, since that will interfere with a level switch
            this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}`);
            if (this.state === State.PARSED) this.state = State.IDLE;
            return;
        }
        const stats = part ? part.stats : frag.stats;
        this.fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
        if (frag.sn !== 'initSegment') this.fragPrevious = frag;
        this.fragBufferedComplete(frag, part);
    }
    onError(event, data) {
        var _data$context;
        if (data.fatal) {
            this.state = State.ERROR;
            return;
        }
        switch(data.details){
            case ErrorDetails.FRAG_GAP:
            case ErrorDetails.FRAG_PARSING_ERROR:
            case ErrorDetails.FRAG_DECRYPT_ERROR:
            case ErrorDetails.FRAG_LOAD_ERROR:
            case ErrorDetails.FRAG_LOAD_TIMEOUT:
            case ErrorDetails.KEY_LOAD_ERROR:
            case ErrorDetails.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError(PlaylistLevelType.MAIN, data);
                break;
            case ErrorDetails.LEVEL_LOAD_ERROR:
            case ErrorDetails.LEVEL_LOAD_TIMEOUT:
            case ErrorDetails.LEVEL_PARSING_ERROR:
                // in case of non fatal error while loading level, if level controller is not retrying to load level, switch back to IDLE
                if (!data.levelRetry && this.state === State.WAITING_LEVEL && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.LEVEL) this.state = State.IDLE;
                break;
            case ErrorDetails.BUFFER_APPEND_ERROR:
            case ErrorDetails.BUFFER_FULL_ERROR:
                if (!data.parent || data.parent !== 'main') return;
                if (data.details === ErrorDetails.BUFFER_APPEND_ERROR) {
                    this.resetLoadingState();
                    return;
                }
                if (this.reduceLengthAndFlushBuffer(data)) this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                break;
            case ErrorDetails.INTERNAL_EXCEPTION:
                this.recoverWorkerError(data);
                break;
        }
    }
    // Checks the health of the buffer and attempts to resolve playback stalls.
    checkBuffer() {
        const { media, gapController } = this;
        if (!media || !gapController || !media.readyState) // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
        return;
        if (this.loadedmetadata || !BufferHelper.getBuffered(media).length) {
            // Resolve gaps using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
            const activeFrag = this.state !== State.IDLE ? this.fragCurrent : null;
            gapController.poll(this.lastCurrentTime, activeFrag);
        }
        this.lastCurrentTime = media.currentTime;
    }
    onFragLoadEmergencyAborted() {
        this.state = State.IDLE;
        // if loadedmetadata is not set, it means that we are emergency switch down on first frag
        // in that case, reset startFragRequested flag
        if (!this.loadedmetadata) {
            this.startFragRequested = false;
            this.nextLoadPosition = this.startPosition;
        }
        this.tickImmediate();
    }
    onBufferFlushed(event, { type }) {
        if (type !== ElementaryStreamTypes.AUDIO || this.audioOnly && !this.altAudio) {
            const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
            this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
            this.tick();
        }
    }
    onLevelsUpdated(event, data) {
        if (this.level > -1 && this.fragCurrent) this.level = this.fragCurrent.level;
        this.levels = data.levels;
    }
    swapAudioCodec() {
        this.audioCodecSwap = !this.audioCodecSwap;
    }
    /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */ seekToStartPos() {
        const { media } = this;
        if (!media) return;
        const currentTime = media.currentTime;
        let startPosition = this.startPosition;
        // only adjust currentTime if different from startPosition or if startPosition not buffered
        // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
        if (startPosition >= 0 && currentTime < startPosition) {
            if (media.seeking) {
                this.log(`could not seek to ${startPosition}, already seeking at ${currentTime}`);
                return;
            }
            const buffered = BufferHelper.getBuffered(media);
            const bufferStart = buffered.length ? buffered.start(0) : 0;
            const delta = bufferStart - startPosition;
            if (delta > 0 && (delta < this.config.maxBufferHole || delta < this.config.maxFragLookUpTolerance)) {
                this.log(`adjusting start position by ${delta} to match buffer start`);
                startPosition += delta;
                this.startPosition = startPosition;
            }
            this.log(`seek to target start position ${startPosition} from current time ${currentTime}`);
            media.currentTime = startPosition;
        }
    }
    _getAudioCodec(currentLevel) {
        let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
        if (this.audioCodecSwap && audioCodec) {
            this.log('Swapping audio codec');
            if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';
            else audioCodec = 'mp4a.40.5';
        }
        return audioCodec;
    }
    _loadBitrateTestFrag(frag, level) {
        frag.bitrateTest = true;
        this._doFragLoad(frag, level).then((data)=>{
            const { hls } = this;
            if (!data || this.fragContextChanged(frag)) return;
            level.fragmentError = 0;
            this.state = State.IDLE;
            this.startFragRequested = false;
            this.bitrateTest = false;
            const stats = frag.stats;
            // Bitrate tests fragments are neither parsed nor buffered
            stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
            hls.trigger(Events.FRAG_LOADED, data);
            frag.bitrateTest = false;
        });
    }
    _handleTransmuxComplete(transmuxResult) {
        var _id3$samples;
        const id = 'main';
        const { hls } = this;
        const { remuxResult, chunkMeta } = transmuxResult;
        const context = this.getCurrentContext(chunkMeta);
        if (!context) {
            this.resetWhenMissingContext(chunkMeta);
            return;
        }
        const { frag, part, level } = context;
        const { video, text, id3, initSegment } = remuxResult;
        const { details } = level;
        // The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
        const audio = this.altAudio ? undefined : remuxResult.audio;
        // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
        // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
        if (this.fragContextChanged(frag)) {
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        this.state = State.PARSING;
        if (initSegment) {
            if (initSegment != null && initSegment.tracks) {
                const mapFragment = frag.initSegment || frag;
                this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
                hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
                    frag: mapFragment,
                    id,
                    tracks: initSegment.tracks
                });
            }
            // This would be nice if Number.isFinite acted as a typeguard, but it doesn't. See: https://github.com/Microsoft/TypeScript/issues/10038
            const initPTS = initSegment.initPTS;
            const timescale = initSegment.timescale;
            if (isFiniteNumber(initPTS)) {
                this.initPTS[frag.cc] = {
                    baseTime: initPTS,
                    timescale
                };
                hls.trigger(Events.INIT_PTS_FOUND, {
                    frag,
                    id,
                    initPTS,
                    timescale
                });
            }
        }
        // Avoid buffering if backtracking this fragment
        if (video && details && frag.sn !== 'initSegment') {
            const prevFrag = details.fragments[frag.sn - 1 - details.startSN];
            const isFirstFragment = frag.sn === details.startSN;
            const isFirstInDiscontinuity = !prevFrag || frag.cc > prevFrag.cc;
            if (remuxResult.independent !== false) {
                const { startPTS, endPTS, startDTS, endDTS } = video;
                if (part) part.elementaryStreams[video.type] = {
                    startPTS,
                    endPTS,
                    startDTS,
                    endDTS
                };
                else {
                    if (video.firstKeyFrame && video.independent && chunkMeta.id === 1 && !isFirstInDiscontinuity) this.couldBacktrack = true;
                    if (video.dropped && video.independent) {
                        // Backtrack if dropped frames create a gap after currentTime
                        const bufferInfo = this.getMainFwdBufferInfo();
                        const targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + this.config.maxBufferHole;
                        const startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
                        if (!isFirstFragment && targetBufferTime < startTime - this.config.maxBufferHole && !isFirstInDiscontinuity) {
                            this.backtrack(frag);
                            return;
                        } else if (isFirstInDiscontinuity) // Mark segment with a gap to avoid loop loading
                        frag.gap = true;
                        // Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
                        frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
                    } else if (isFirstFragment && startPTS > MAX_START_GAP_JUMP) // Mark segment with a gap to skip large start gap
                    frag.gap = true;
                }
                frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
                if (this.backtrackFragment) this.backtrackFragment = frag;
                this.bufferFragmentData(video, frag, part, chunkMeta, isFirstFragment || isFirstInDiscontinuity);
            } else if (isFirstFragment || isFirstInDiscontinuity) // Mark segment with a gap to avoid loop loading
            frag.gap = true;
            else {
                this.backtrack(frag);
                return;
            }
        }
        if (audio) {
            const { startPTS, endPTS, startDTS, endDTS } = audio;
            if (part) part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
                startPTS,
                endPTS,
                startDTS,
                endDTS
            };
            frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
            this.bufferFragmentData(audio, frag, part, chunkMeta);
        }
        if (details && id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
            const emittedID3 = {
                id,
                frag,
                details,
                samples: id3.samples
            };
            hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
        }
        if (details && text) {
            const emittedText = {
                id,
                frag,
                details,
                samples: text.samples
            };
            hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
        }
    }
    _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
        if (this.state !== State.PARSING) return;
        this.audioOnly = !!tracks.audio && !tracks.video;
        // if audio track is expected to come from audio stream controller, discard any coming from main
        if (this.altAudio && !this.audioOnly) delete tracks.audio;
        // include levelCodec in audio and video tracks
        const { audio, video, audiovideo } = tracks;
        if (audio) {
            let audioCodec = currentLevel.audioCodec;
            const ua = navigator.userAgent.toLowerCase();
            if (this.audioCodecSwitch) {
                if (audioCodec) {
                    if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';
                    else audioCodec = 'mp4a.40.5';
                }
                // In the case that AAC and HE-AAC audio codecs are signalled in manifest,
                // force HE-AAC, as it seems that most browsers prefers it.
                // don't force HE-AAC if mono stream, or in Firefox
                if (audio.metadata.channelCount !== 1 && ua.indexOf('firefox') === -1) audioCodec = 'mp4a.40.5';
            }
            // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
            if (audioCodec && audioCodec.indexOf('mp4a.40.5') !== -1 && ua.indexOf('android') !== -1 && audio.container !== 'audio/mpeg') {
                // Exclude mpeg audio
                audioCodec = 'mp4a.40.2';
                this.log(`Android: force audio codec to ${audioCodec}`);
            }
            if (currentLevel.audioCodec && currentLevel.audioCodec !== audioCodec) this.log(`Swapping manifest audio codec "${currentLevel.audioCodec}" for "${audioCodec}"`);
            audio.levelCodec = audioCodec;
            audio.id = 'main';
            this.log(`Init audio buffer, container:${audio.container}, codecs[selected/level/parsed]=[${audioCodec || ''}/${currentLevel.audioCodec || ''}/${audio.codec}]`);
        }
        if (video) {
            video.levelCodec = currentLevel.videoCodec;
            video.id = 'main';
            this.log(`Init video buffer, container:${video.container}, codecs[level/parsed]=[${currentLevel.videoCodec || ''}/${video.codec}]`);
        }
        if (audiovideo) this.log(`Init audiovideo buffer, container:${audiovideo.container}, codecs[level/parsed]=[${currentLevel.codecs}/${audiovideo.codec}]`);
        this.hls.trigger(Events.BUFFER_CODECS, tracks);
        // loop through tracks that are going to be provided to bufferController
        Object.keys(tracks).forEach((trackName)=>{
            const track = tracks[trackName];
            const initSegment = track.initSegment;
            if (initSegment != null && initSegment.byteLength) this.hls.trigger(Events.BUFFER_APPENDING, {
                type: trackName,
                data: initSegment,
                frag,
                part: null,
                chunkMeta,
                parent: frag.type
            });
        });
        // trigger handler right now
        this.tickImmediate();
    }
    getMainFwdBufferInfo() {
        return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, PlaylistLevelType.MAIN);
    }
    backtrack(frag) {
        this.couldBacktrack = true;
        // Causes findFragments to backtrack through fragments to find the keyframe
        this.backtrackFragment = frag;
        this.resetTransmuxer();
        this.flushBufferGap(frag);
        this.fragmentTracker.removeFragment(frag);
        this.fragPrevious = null;
        this.nextLoadPosition = frag.start;
        this.state = State.IDLE;
    }
    checkFragmentChanged() {
        const video = this.media;
        let fragPlayingCurrent = null;
        if (video && video.readyState > 1 && video.seeking === false) {
            const currentTime = video.currentTime;
            /* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */ if (BufferHelper.isBuffered(video, currentTime)) fragPlayingCurrent = this.getAppendedFrag(currentTime);
            else if (BufferHelper.isBuffered(video, currentTime + 0.1)) /* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */ fragPlayingCurrent = this.getAppendedFrag(currentTime + 0.1);
            if (fragPlayingCurrent) {
                this.backtrackFragment = null;
                const fragPlaying = this.fragPlaying;
                const fragCurrentLevel = fragPlayingCurrent.level;
                if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel) {
                    this.fragPlaying = fragPlayingCurrent;
                    this.hls.trigger(Events.FRAG_CHANGED, {
                        frag: fragPlayingCurrent
                    });
                    if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) this.hls.trigger(Events.LEVEL_SWITCHED, {
                        level: fragCurrentLevel
                    });
                }
            }
        }
    }
    get nextLevel() {
        const frag = this.nextBufferedFrag;
        if (frag) return frag.level;
        return -1;
    }
    get currentFrag() {
        const media = this.media;
        if (media) return this.fragPlaying || this.getAppendedFrag(media.currentTime);
        return null;
    }
    get currentProgramDateTime() {
        const media = this.media;
        if (media) {
            const currentTime = media.currentTime;
            const frag = this.currentFrag;
            if (frag && isFiniteNumber(currentTime) && isFiniteNumber(frag.programDateTime)) {
                const epocMs = frag.programDateTime + (currentTime - frag.start) * 1000;
                return new Date(epocMs);
            }
        }
        return null;
    }
    get currentLevel() {
        const frag = this.currentFrag;
        if (frag) return frag.level;
        return -1;
    }
    get nextBufferedFrag() {
        const frag = this.currentFrag;
        if (frag) return this.followingBufferedFrag(frag);
        return null;
    }
    get forceStartLoad() {
        return this._forceStartLoad;
    }
}
/**
 * The `Hls` class is the core of the HLS.js library used to instantiate player instances.
 * @public
 */ class Hls {
    /**
   * Get the video-dev/hls.js package version.
   */ static get version() {
        return "1.5.8";
    }
    /**
   * Check if the required MediaSource Extensions are available.
   */ static isMSESupported() {
        return isMSESupported();
    }
    /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */ static isSupported() {
        return isSupported();
    }
    /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */ static getMediaSource() {
        return getMediaSource();
    }
    static get Events() {
        return Events;
    }
    static get ErrorTypes() {
        return ErrorTypes;
    }
    static get ErrorDetails() {
        return ErrorDetails;
    }
    /**
   * Get the default configuration applied to new instances.
   */ static get DefaultConfig() {
        if (!Hls.defaultConfig) return hlsDefaultConfig;
        return Hls.defaultConfig;
    }
    /**
   * Replace the default configuration applied to new instances.
   */ static set DefaultConfig(defaultConfig) {
        Hls.defaultConfig = defaultConfig;
    }
    /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */ constructor(userConfig = {}){
        /**
     * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
     */ this.config = void 0;
        /**
     * The configuration object provided on player instantiation.
     */ this.userConfig = void 0;
        this.coreComponents = void 0;
        this.networkControllers = void 0;
        this.started = false;
        this._emitter = new EventEmitter();
        this._autoLevelCapping = -1;
        this._maxHdcpLevel = null;
        this.abrController = void 0;
        this.bufferController = void 0;
        this.capLevelController = void 0;
        this.latencyController = void 0;
        this.levelController = void 0;
        this.streamController = void 0;
        this.audioTrackController = void 0;
        this.subtitleTrackController = void 0;
        this.emeController = void 0;
        this.cmcdController = void 0;
        this._media = null;
        this.url = null;
        this.triggeringException = void 0;
        enableLogs(userConfig.debug || false, 'Hls instance');
        const config = this.config = mergeConfig(Hls.DefaultConfig, userConfig);
        this.userConfig = userConfig;
        if (config.progressive) enableStreamingMode(config);
        // core controllers and network loaders
        const { abrController: ConfigAbrController, bufferController: ConfigBufferController, capLevelController: ConfigCapLevelController, errorController: ConfigErrorController, fpsController: ConfigFpsController } = config;
        const errorController = new ConfigErrorController(this);
        const abrController = this.abrController = new ConfigAbrController(this);
        const bufferController = this.bufferController = new ConfigBufferController(this);
        const capLevelController = this.capLevelController = new ConfigCapLevelController(this);
        const fpsController = new ConfigFpsController(this);
        const playListLoader = new PlaylistLoader(this);
        const id3TrackController = new ID3TrackController(this);
        const ConfigContentSteeringController = config.contentSteeringController;
        // ConentSteeringController is defined before LevelController to receive Multivariant Playlist events first
        const contentSteering = ConfigContentSteeringController ? new ConfigContentSteeringController(this) : null;
        const levelController = this.levelController = new LevelController(this, contentSteering);
        // FragmentTracker must be defined before StreamController because the order of event handling is important
        const fragmentTracker = new FragmentTracker(this);
        const keyLoader = new KeyLoader(this.config);
        const streamController = this.streamController = new StreamController(this, fragmentTracker, keyLoader);
        // Cap level controller uses streamController to flush the buffer
        capLevelController.setStreamController(streamController);
        // fpsController uses streamController to switch when frames are being dropped
        fpsController.setStreamController(streamController);
        const networkControllers = [
            playListLoader,
            levelController,
            streamController
        ];
        if (contentSteering) networkControllers.splice(1, 0, contentSteering);
        this.networkControllers = networkControllers;
        const coreComponents = [
            abrController,
            bufferController,
            capLevelController,
            fpsController,
            id3TrackController,
            fragmentTracker
        ];
        this.audioTrackController = this.createController(config.audioTrackController, networkControllers);
        const AudioStreamControllerClass = config.audioStreamController;
        if (AudioStreamControllerClass) networkControllers.push(new AudioStreamControllerClass(this, fragmentTracker, keyLoader));
        // subtitleTrackController must be defined before subtitleStreamController because the order of event handling is important
        this.subtitleTrackController = this.createController(config.subtitleTrackController, networkControllers);
        const SubtitleStreamControllerClass = config.subtitleStreamController;
        if (SubtitleStreamControllerClass) networkControllers.push(new SubtitleStreamControllerClass(this, fragmentTracker, keyLoader));
        this.createController(config.timelineController, coreComponents);
        keyLoader.emeController = this.emeController = this.createController(config.emeController, coreComponents);
        this.cmcdController = this.createController(config.cmcdController, coreComponents);
        this.latencyController = this.createController(LatencyController, coreComponents);
        this.coreComponents = coreComponents;
        // Error controller handles errors before and after all other controllers
        // This listener will be invoked after all other controllers error listeners
        networkControllers.push(errorController);
        const onErrorOut = errorController.onErrorOut;
        if (typeof onErrorOut === 'function') this.on(Events.ERROR, onErrorOut, errorController);
    }
    createController(ControllerClass, components) {
        if (ControllerClass) {
            const controllerInstance = new ControllerClass(this);
            if (components) components.push(controllerInstance);
            return controllerInstance;
        }
        return null;
    }
    // Delegate the EventEmitter through the public API of Hls.js
    on(event, listener, context = this) {
        this._emitter.on(event, listener, context);
    }
    once(event, listener, context = this) {
        this._emitter.once(event, listener, context);
    }
    removeAllListeners(event) {
        this._emitter.removeAllListeners(event);
    }
    off(event, listener, context = this, once) {
        this._emitter.off(event, listener, context, once);
    }
    listeners(event) {
        return this._emitter.listeners(event);
    }
    emit(event, name, eventObject) {
        return this._emitter.emit(event, name, eventObject);
    }
    trigger(event, eventObject) {
        if (this.config.debug) return this.emit(event, event, eventObject);
        else try {
            return this.emit(event, event, eventObject);
        } catch (error) {
            logger.error('An internal error happened while handling event ' + event + '. Error message: "' + error.message + '". Here is a stacktrace:', error);
            // Prevent recursion in error event handlers that throw #5497
            if (!this.triggeringException) {
                this.triggeringException = true;
                const fatal = event === Events.ERROR;
                this.trigger(Events.ERROR, {
                    type: ErrorTypes.OTHER_ERROR,
                    details: ErrorDetails.INTERNAL_EXCEPTION,
                    fatal,
                    event,
                    error
                });
                this.triggeringException = false;
            }
        }
        return false;
    }
    listenerCount(event) {
        return this._emitter.listenerCount(event);
    }
    /**
   * Dispose of the instance
   */ destroy() {
        logger.log('destroy');
        this.trigger(Events.DESTROYING, undefined);
        this.detachMedia();
        this.removeAllListeners();
        this._autoLevelCapping = -1;
        this.url = null;
        this.networkControllers.forEach((component)=>component.destroy());
        this.networkControllers.length = 0;
        this.coreComponents.forEach((component)=>component.destroy());
        this.coreComponents.length = 0;
        // Remove any references that could be held in config options or callbacks
        const config = this.config;
        config.xhrSetup = config.fetchSetup = undefined;
        // @ts-ignore
        this.userConfig = null;
    }
    /**
   * Attaches Hls.js to a media element
   */ attachMedia(media) {
        logger.log('attachMedia');
        this._media = media;
        this.trigger(Events.MEDIA_ATTACHING, {
            media: media
        });
    }
    /**
   * Detach Hls.js from the media
   */ detachMedia() {
        logger.log('detachMedia');
        this.trigger(Events.MEDIA_DETACHING, undefined);
        this._media = null;
    }
    /**
   * Set the source URL. Can be relative or absolute.
   */ loadSource(url) {
        this.stopLoad();
        const media = this.media;
        const loadedSource = this.url;
        const loadingSource = this.url = urlToolkitExports.buildAbsoluteURL(self.location.href, url, {
            alwaysNormalize: true
        });
        this._autoLevelCapping = -1;
        this._maxHdcpLevel = null;
        logger.log(`loadSource:${loadingSource}`);
        if (media && loadedSource && (loadedSource !== loadingSource || this.bufferController.hasSourceTypes())) {
            this.detachMedia();
            this.attachMedia(media);
        }
        // when attaching to a source URL, trigger a playlist load
        this.trigger(Events.MANIFEST_LOADING, {
            url: url
        });
    }
    /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */ startLoad(startPosition = -1) {
        logger.log(`startLoad(${startPosition})`);
        this.started = true;
        this.networkControllers.forEach((controller)=>{
            controller.startLoad(startPosition);
        });
    }
    /**
   * Stop loading of any stream data.
   */ stopLoad() {
        logger.log('stopLoad');
        this.started = false;
        this.networkControllers.forEach((controller)=>{
            controller.stopLoad();
        });
    }
    /**
   * Resumes stream controller segment loading if previously started.
   */ resumeBuffering() {
        if (this.started) this.networkControllers.forEach((controller)=>{
            if ('fragmentLoader' in controller) controller.startLoad(-1);
        });
    }
    /**
   * Stops stream controller segment loading without changing 'started' state like stopLoad().
   * This allows for media buffering to be paused without interupting playlist loading.
   */ pauseBuffering() {
        this.networkControllers.forEach((controller)=>{
            if ('fragmentLoader' in controller) controller.stopLoad();
        });
    }
    /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */ swapAudioCodec() {
        logger.log('swapAudioCodec');
        this.streamController.swapAudioCodec();
    }
    /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */ recoverMediaError() {
        logger.log('recoverMediaError');
        const media = this._media;
        this.detachMedia();
        if (media) this.attachMedia(media);
    }
    removeLevel(levelIndex) {
        this.levelController.removeLevel(levelIndex);
    }
    /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */ get levels() {
        const levels = this.levelController.levels;
        return levels ? levels : [];
    }
    /**
   * Index of quality level (variant) currently played
   */ get currentLevel() {
        return this.streamController.currentLevel;
    }
    /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */ set currentLevel(newLevel) {
        logger.log(`set currentLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
        this.streamController.immediateLevelSwitch();
    }
    /**
   * Index of next quality level loaded as scheduled by stream controller.
   */ get nextLevel() {
        return this.streamController.nextLevel;
    }
    /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */ set nextLevel(newLevel) {
        logger.log(`set nextLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
        this.streamController.nextLevelSwitch();
    }
    /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */ get loadLevel() {
        return this.levelController.level;
    }
    /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */ set loadLevel(newLevel) {
        logger.log(`set loadLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
    }
    /**
   * get next quality level loaded
   */ get nextLoadLevel() {
        return this.levelController.nextLoadLevel;
    }
    /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */ set nextLoadLevel(level) {
        this.levelController.nextLoadLevel = level;
    }
    /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */ get firstLevel() {
        return Math.max(this.levelController.firstLevel, this.minAutoLevel);
    }
    /**
   * Sets "first-level", see getter.
   */ set firstLevel(newLevel) {
        logger.log(`set firstLevel:${newLevel}`);
        this.levelController.firstLevel = newLevel;
    }
    /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */ get startLevel() {
        const startLevel = this.levelController.startLevel;
        if (startLevel === -1 && this.abrController.forcedAutoLevel > -1) return this.abrController.forcedAutoLevel;
        return startLevel;
    }
    /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */ set startLevel(newLevel) {
        logger.log(`set startLevel:${newLevel}`);
        // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
        if (newLevel !== -1) newLevel = Math.max(newLevel, this.minAutoLevel);
        this.levelController.startLevel = newLevel;
    }
    /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */ get capLevelToPlayerSize() {
        return this.config.capLevelToPlayerSize;
    }
    /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */ set capLevelToPlayerSize(shouldStartCapping) {
        const newCapLevelToPlayerSize = !!shouldStartCapping;
        if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
            if (newCapLevelToPlayerSize) this.capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
            else {
                this.capLevelController.stopCapping();
                this.autoLevelCapping = -1;
                this.streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
            }
            this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
        }
    }
    /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */ get autoLevelCapping() {
        return this._autoLevelCapping;
    }
    /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */ get bandwidthEstimate() {
        const { bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.getEstimate();
    }
    set bandwidthEstimate(abrEwmaDefaultEstimate) {
        this.abrController.resetEstimator(abrEwmaDefaultEstimate);
    }
    /**
   * get time to first byte estimate
   * @type {number}
   */ get ttfbEstimate() {
        const { bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.getEstimateTTFB();
    }
    /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */ set autoLevelCapping(newLevel) {
        if (this._autoLevelCapping !== newLevel) {
            logger.log(`set autoLevelCapping:${newLevel}`);
            this._autoLevelCapping = newLevel;
            this.levelController.checkMaxAutoUpdated();
        }
    }
    get maxHdcpLevel() {
        return this._maxHdcpLevel;
    }
    set maxHdcpLevel(value) {
        if (isHdcpLevel(value) && this._maxHdcpLevel !== value) {
            this._maxHdcpLevel = value;
            this.levelController.checkMaxAutoUpdated();
        }
    }
    /**
   * True when automatic level selection enabled
   */ get autoLevelEnabled() {
        return this.levelController.manualLevel === -1;
    }
    /**
   * Level set manually (if any)
   */ get manualLevel() {
        return this.levelController.manualLevel;
    }
    /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */ get minAutoLevel() {
        const { levels, config: { minAutoBitrate } } = this;
        if (!levels) return 0;
        const len = levels.length;
        for(let i = 0; i < len; i++){
            if (levels[i].maxBitrate >= minAutoBitrate) return i;
        }
        return 0;
    }
    /**
   * max level selectable in auto mode according to autoLevelCapping
   */ get maxAutoLevel() {
        const { levels, autoLevelCapping, maxHdcpLevel } = this;
        let maxAutoLevel;
        if (autoLevelCapping === -1 && levels != null && levels.length) maxAutoLevel = levels.length - 1;
        else maxAutoLevel = autoLevelCapping;
        if (maxHdcpLevel) for(let i = maxAutoLevel; i--;){
            const hdcpLevel = levels[i].attrs['HDCP-LEVEL'];
            if (hdcpLevel && hdcpLevel <= maxHdcpLevel) return i;
        }
        return maxAutoLevel;
    }
    get firstAutoLevel() {
        return this.abrController.firstAutoLevel;
    }
    /**
   * next automatically selected quality level
   */ get nextAutoLevel() {
        return this.abrController.nextAutoLevel;
    }
    /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */ set nextAutoLevel(nextLevel) {
        this.abrController.nextAutoLevel = nextLevel;
    }
    /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */ get playingDate() {
        return this.streamController.currentProgramDateTime;
    }
    get mainForwardBufferInfo() {
        return this.streamController.getMainFwdBufferInfo();
    }
    /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */ setAudioOption(audioOption) {
        var _this$audioTrackContr;
        return (_this$audioTrackContr = this.audioTrackController) == null ? void 0 : _this$audioTrackContr.setAudioOption(audioOption);
    }
    /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */ setSubtitleOption(subtitleOption) {
        var _this$subtitleTrackCo;
        (_this$subtitleTrackCo = this.subtitleTrackController) == null || _this$subtitleTrackCo.setSubtitleOption(subtitleOption);
        return null;
    }
    /**
   * Get the complete list of audio tracks across all media groups
   */ get allAudioTracks() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.allAudioTracks : [];
    }
    /**
   * Get the list of selectable audio tracks
   */ get audioTracks() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTracks : [];
    }
    /**
   * index of the selected audio track (index in audio track lists)
   */ get audioTrack() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTrack : -1;
    }
    /**
   * selects an audio track, based on its index in audio track lists
   */ set audioTrack(audioTrackId) {
        const audioTrackController = this.audioTrackController;
        if (audioTrackController) audioTrackController.audioTrack = audioTrackId;
    }
    /**
   * get the complete list of subtitle tracks across all media groups
   */ get allSubtitleTracks() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.allSubtitleTracks : [];
    }
    /**
   * get alternate subtitle tracks list from playlist
   */ get subtitleTracks() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
    }
    /**
   * index of the selected subtitle track (index in subtitle track lists)
   */ get subtitleTrack() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
    }
    get media() {
        return this._media;
    }
    /**
   * select an subtitle track, based on its index in subtitle track lists
   */ set subtitleTrack(subtitleTrackId) {
        const subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleTrack = subtitleTrackId;
    }
    /**
   * Whether subtitle display is enabled or not
   */ get subtitleDisplay() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
    }
    /**
   * Enable/disable subtitle display rendering
   */ set subtitleDisplay(value) {
        const subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleDisplay = value;
    }
    /**
   * get mode for Low-Latency HLS loading
   */ get lowLatencyMode() {
        return this.config.lowLatencyMode;
    }
    /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */ set lowLatencyMode(mode) {
        this.config.lowLatencyMode = mode;
    }
    /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */ get liveSyncPosition() {
        return this.latencyController.liveSyncPosition;
    }
    /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */ get latency() {
        return this.latencyController.latency;
    }
    /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */ get maxLatency() {
        return this.latencyController.maxLatency;
    }
    /**
   * target distance from the edge as calculated by the latency controller
   */ get targetLatency() {
        return this.latencyController.targetLatency;
    }
    /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */ get drift() {
        return this.latencyController.drift;
    }
    /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */ get forceStartLoad() {
        return this.streamController.forceStartLoad;
    }
}
Hls.defaultConfig = void 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7sPvG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLogger", ()=>getLogger);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
function getLogger(name) {
    return (0, _debugDefault.default)(`nm:${name}`);
}

},{"debug":"3sF0w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3sF0w":[function(require,module,exports,__globalThis) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ var process = require("12edbb1af7d8bd3b");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    let m;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    // eslint-disable-next-line no-return-assign
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === '%%') return;
        index++;
        if (match === '%c') // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem('debug', namespaces);
        else exports.storage.removeItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem('debug') || exports.storage.getItem('DEBUG');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof process !== 'undefined' && 'env' in process) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
module.exports = require("d9172905aa5ed6c")(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
    }
};

},{"12edbb1af7d8bd3b":"5jT8D","d9172905aa5ed6c":"9zaHU"}],"9zaHU":[function(require,module,exports,__globalThis) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ function setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = require("5c5c8c8b1996f88f");
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== 'string') // Anything else let's inspect with %O
            args.unshift('%O');
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') return '%';
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === 'function') {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, 'enabled', {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === 'function') createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        const split = (typeof namespaces === 'string' ? namespaces : '').trim().replace(/\s+/g, ',').split(',').filter(Boolean);
        for (const ns of split)if (ns[0] === '-') createDebug.skips.push(ns.slice(1));
        else createDebug.names.push(ns);
    }
    /**
	 * Checks if the given string matches a namespace template, honoring
	 * asterisks as wildcards.
	 *
	 * @param {String} search
	 * @param {String} template
	 * @return {Boolean}
	 */ function matchesTemplate(search, template) {
        let searchIndex = 0;
        let templateIndex = 0;
        let starIndex = -1;
        let matchIndex = 0;
        while(searchIndex < search.length){
            if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === '*')) {
                // Match character or proceed with wildcard
                if (template[templateIndex] === '*') {
                    starIndex = templateIndex;
                    matchIndex = searchIndex;
                    templateIndex++; // Skip the '*'
                } else {
                    searchIndex++;
                    templateIndex++;
                }
            } else if (starIndex !== -1) {
                // Backtrack to the last '*' and try to match more characters
                templateIndex = starIndex + 1;
                matchIndex++;
                searchIndex = matchIndex;
            } else return false; // No match
        }
        // Handle trailing '*' in template
        while(templateIndex < template.length && template[templateIndex] === '*')templateIndex++;
        return templateIndex === template.length;
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names,
            ...createDebug.skips.map((namespace)=>'-' + namespace)
        ].join(',');
        createDebug.enable('');
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        for (const skip of createDebug.skips){
            if (matchesTemplate(name, skip)) return false;
        }
        for (const ns of createDebug.names){
            if (matchesTemplate(name, ns)) return true;
        }
        return false;
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = setup;

},{"5c5c8c8b1996f88f":"abbqK"}],"abbqK":[function(require,module,exports,__globalThis) {
/**
 * Helpers.
 */ var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? fmtLong(val) : fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * w;
        case 'days':
        case 'day':
        case 'd':
            return n * d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) return Math.round(ms / d) + 'd';
    if (msAbs >= h) return Math.round(ms / h) + 'h';
    if (msAbs >= m) return Math.round(ms / m) + 'm';
    if (msAbs >= s) return Math.round(ms / s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) return plural(ms, msAbs, d, 'day');
    if (msAbs >= h) return plural(ms, msAbs, h, 'hour');
    if (msAbs >= m) return plural(ms, msAbs, m, 'minute');
    if (msAbs >= s) return plural(ms, msAbs, s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

},{}],"eN2rR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _groupAdd = require("@mui/icons-material/GroupAdd");
var _groupAddDefault = parcelHelpers.interopDefault(_groupAdd);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _input = require("@mui/icons-material/Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _callSplit = require("@mui/icons-material/CallSplit");
var _callSplitDefault = parcelHelpers.interopDefault(_callSplit);
var _stop = require("@mui/icons-material/Stop");
var _stopDefault = parcelHelpers.interopDefault(_stop);
var _playArrow = require("@mui/icons-material/PlayArrow");
var _playArrowDefault = parcelHelpers.interopDefault(_playArrow);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _store = require("../../../store");
var _types = require("common/api/v1/types");
var _inputsActions = require("../../../redux/actions/inputsActions");
var _index = require("./index");
var _contentCopy = require("@mui/icons-material/ContentCopy");
var _contentCopyDefault = parcelHelpers.interopDefault(_contentCopy);
var _actionMenu = require("../../common/Table/ActionMenu");
var _index1 = require("../../serviceOverview/Overview/index");
const ActionMenu = (props)=>{
    const { input, dispatch, user, experimentalFeatures } = props;
    const isOwner = (0, _index.canEditInput)(user, input.owner);
    const routes = (0, _store.useRoutes)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: 'flex'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.ServiceOverviewButton), {
                input: input
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                "data-test-id": "input-action-menu",
                options: [
                    ...isOwner ? [
                        {
                            label: 'Edit',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                            href: routes.inputsUpdate({
                                id: input.id
                            }),
                            'data-test-id': 'edit-input'
                        },
                        {
                            label: 'Share',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupAddDefault.default), {}),
                            onClick: ()=>{
                                dispatch((0, _inputsActions.draftInputs)({
                                    inputs: [
                                        input
                                    ],
                                    action: (0, _inputsActions.DraftActions).share,
                                    source: (0, _inputsActions.DraftSources).actionMenu
                                }));
                            },
                            'data-test-id': 'share-input'
                        },
                        {
                            label: input.adminStatus === (0, _types.InputAdminStatus).on ? 'Disable' : 'Enable',
                            icon: input.adminStatus === (0, _types.InputAdminStatus).on ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stopDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playArrowDefault.default), {}),
                            onClick: ()=>{
                                if (input.adminStatus === (0, _types.InputAdminStatus).on) dispatch((0, _inputsActions.draftInputs)({
                                    action: (0, _inputsActions.DraftActions).disable,
                                    inputs: [
                                        input
                                    ],
                                    source: (0, _inputsActions.DraftSources).actionMenu
                                }));
                                else {
                                    dispatch((0, _inputsActions.enableInputs)([
                                        input.id
                                    ]));
                                    dispatch((0, _inputsActions.draftInputs)({
                                        inputs: []
                                    }));
                                }
                            },
                            'data-test-id': 'toggle-admin-status-input'
                        }
                    ] : [],
                    {
                        label: 'Send to output',
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputDefault.default), {}),
                        onClick: ()=>{
                            dispatch((0, _inputsActions.draftInputs)({
                                inputs: [
                                    input
                                ],
                                action: (0, _inputsActions.DraftActions).send,
                                source: (0, _inputsActions.DraftSources).actionMenu
                            }));
                        },
                        'data-test-id': 'send-to-output'
                    },
                    ...experimentalFeatures && experimentalFeatures.ExtDerivedInput && !input.deriveFrom && isOwner ? [
                        {
                            label: 'Transform',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _callSplitDefault.default), {}),
                            href: routes.inputsDerive({
                                id: input.id
                            }),
                            'data-test-id': 'derive-from'
                        }
                    ] : [],
                    ...isOwner ? [
                        {
                            label: 'Duplicate',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentCopyDefault.default), {}),
                            href: routes.inputsCopy({
                                id: input.id
                            }),
                            'data-test-id': 'use-input-as-template'
                        },
                        {
                            label: 'Delete',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                            isDestructive: true,
                            onClick: ()=>{
                                dispatch((0, _inputsActions.draftInputs)({
                                    inputs: [
                                        input
                                    ],
                                    action: (0, _inputsActions.DraftActions).delete,
                                    source: (0, _inputsActions.DraftSources).actionMenu
                                }));
                            },
                            'data-test-id': 'delete-input'
                        }
                    ] : []
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/icons-material/GroupAdd":"eIJfP","@mui/icons-material/Settings":"jkTfg","@mui/icons-material/Input":"dzq6z","@mui/icons-material/Delete":"69aC7","@mui/icons-material/CallSplit":"euZFI","@mui/icons-material/Stop":"1bxT4","@mui/icons-material/PlayArrow":"4aev3","@mui/material/Box":"c4QkF","../../../store":"5LXiG","common/api/v1/types":"3qemx","../../../redux/actions/inputsActions":"l0Ua8","./index":"jmuAJ","@mui/icons-material/ContentCopy":"ivEEo","../../common/Table/ActionMenu":"jf6As","../../serviceOverview/Overview/index":"1D7NB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eIJfP":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("25a95bb34572d7f4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("5fe2697c8a3516e5"));
var _jsxRuntime = require("b1642959b560768c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M22 9V7h-2v2h-2v2h2v2h2v-2h2V9zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 1c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4m4.51-8.95C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95m4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17"
}), 'GroupAdd');

},{"25a95bb34572d7f4":"kZ6eK","5fe2697c8a3516e5":"2vOnF","b1642959b560768c":"1dlk8"}],"dzq6z":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("b0e2078fd2c758f7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("7990cf1f58d44d27"));
var _jsxRuntime = require("2dd5db2d856434dd");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2M11 16l4-4-4-4v3H1v2h10z"
}), 'Input');

},{"b0e2078fd2c758f7":"kZ6eK","7990cf1f58d44d27":"2vOnF","2dd5db2d856434dd":"1dlk8"}],"69aC7":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("ca183691b8d1339b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b5d3fdbc8fc03ede"));
var _jsxRuntime = require("bb5be2c295192cf");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');

},{"ca183691b8d1339b":"kZ6eK","b5d3fdbc8fc03ede":"2vOnF","bb5be2c295192cf":"1dlk8"}],"euZFI":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("810dd3e6c3033151").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("46ffe69a31bdbf98"));
var _jsxRuntime = require("c85c857e1acf751e");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m14 4 2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"
}), 'CallSplit');

},{"810dd3e6c3033151":"kZ6eK","46ffe69a31bdbf98":"2vOnF","c85c857e1acf751e":"1dlk8"}],"1bxT4":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("bca0a6bad0f91a6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("3f1d2ebbcefc750c"));
var _jsxRuntime = require("5659add136cbec3b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M6 6h12v12H6z"
}), 'Stop');

},{"bca0a6bad0f91a6":"kZ6eK","3f1d2ebbcefc750c":"2vOnF","5659add136cbec3b":"1dlk8"}],"4aev3":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("41cd38a6a497dfb6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("744063c7ae3d7f21"));
var _jsxRuntime = require("3f490556515bcf2");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8 5v14l11-7z"
}), 'PlayArrow');

},{"41cd38a6a497dfb6":"kZ6eK","744063c7ae3d7f21":"2vOnF","3f490556515bcf2":"1dlk8"}],"jmuAJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canEditInput", ()=>canEditInput);
parcelHelpers.export(exports, "List", ()=>List);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _utils = require("../../../utils");
var _types = require("common/api/v1/types");
var _missingContent = require("../../common/MissingContent");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _table = require("../../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _sendToOutput = require("./SendToOutput");
var _sendToOutputDefault = parcelHelpers.interopDefault(_sendToOutput);
var _commonActions = require("./CommonActions");
var _commonActionsDefault = parcelHelpers.interopDefault(_commonActions);
var _deleteDialog = require("./DeleteDialog");
var _deleteDialogDefault = parcelHelpers.interopDefault(_deleteDialog);
var _sharingDialog = require("./SharingDialog");
var _sharingDialogDefault = parcelHelpers.interopDefault(_sharingDialog);
var _tableConfig = require("./tableConfig");
var _tableConfigDefault = parcelHelpers.interopDefault(_tableConfig);
var _store = require("../../../store");
var _link = require("../../common/Link");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _inputsActions = require("../../../redux/actions/inputsActions");
const canEditInput = (user, owner)=>{
    return user.role === (0, _types.Role).admin && user.group === owner || user.role === (0, _types.Role).super;
};
const List = ()=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const { inputs, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useInputsSelector));
    const inputIds = inputs.map((i)=>i.id);
    (0, _react.useEffect)(()=>{
        dispatch((0, _inputsActions.registerInputObserver)({
            inputIds
        }));
        return ()=>{
            dispatch((0, _inputsActions.unregisterInputObserver)({
                inputIds
            }));
        };
    }, [
        JSON.stringify(inputIds)
    ]);
    const user = (0, _utils.useUser)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const routes = (0, _store.useRoutes)();
    const { settings } = (0, _utils.useSettingsSelector)();
    const expFeatures = settings?.expFeatures;
    const [selected, setSelected] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        setSelected([]);
    }, [
        inputs.map((i)=>i.id).join(',')
    ]);
    const handleSelect = (id)=>{
        if (selected.includes(id)) setSelected([
            ...selected.filter((item)=>item !== id)
        ]);
        else setSelected([
            ...selected,
            id
        ]);
    };
    const handleSelectAll = ()=>{
        if (selected.length === inputs.length) setSelected([]);
        else setSelected(inputs.reduce((acc, { id })=>acc.concat(id), []));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Inputs",
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            to: routes.inputsNew(),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "contained",
                color: "primary",
                children: "Create input"
            })
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commonActionsDefault.default), {
                inputs: inputs,
                selected: selected,
                setSelected: setSelected,
                user: user
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                id: "inputs",
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No inputs available",
                    buttonText: "Create input",
                    url: routes.inputsNew()
                }),
                config: (0, _tableConfigDefault.default)({
                    dispatch,
                    routes,
                    handleSelect,
                    handleSelectAll,
                    inputs,
                    selected,
                    user,
                    experimentalFeatures: expFeatures
                }),
                rowProps: ({ id, owner })=>{
                    const isItemSelected = Boolean(id && selected.includes(id));
                    return {
                        onDoubleClick: ()=>canEditInput(user, owner) ? void navigate(routes.inputsUpdate({
                                id
                            })) : null,
                        'aria-checked': isItemSelected,
                        tabIndex: -1,
                        selected: isItemSelected
                    };
                },
                data: inputs,
                pagination: {
                    useUrlSearchParams: true,
                    total
                },
                pending: loading
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDialogDefault.default), {
                setSelected: setSelected
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharingDialogDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendToOutputDefault.default), {})
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","../../../utils":"342UB","common/api/v1/types":"3qemx","../../common/MissingContent":"1LBl6","../../common/Wrapper":"8oy7r","../../common/Table":"dt9lf","./SendToOutput":"3lLA6","./CommonActions":"dh8aC","./DeleteDialog":"5GvDZ","./SharingDialog":"fV5xG","./tableConfig":"lLIw3","../../../store":"5LXiG","../../common/Link":"l3o6V","@mui/material/Button":"3qJY9","../../../redux/actions/inputsActions":"l0Ua8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3lLA6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _types = require("common/api/v1/types");
var _inputsActions = require("../../../../redux/actions/inputsActions");
var _utils = require("../../../../utils");
var _title = require("../../../common/Dialog/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _recipients = require("./Recipients");
var _recipientsDefault = parcelHelpers.interopDefault(_recipients);
var _availableOutputs = require("./AvailableOutputs");
var _availableOutputsDefault = parcelHelpers.interopDefault(_availableOutputs);
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _utils1 = require("common/utils");
const SendingDialog = ()=>{
    const { draft: { inputs, action }, dialogSaving } = (0, _reactRedux.useSelector)(({ inputsReducer })=>({
            draft: inputsReducer.draft,
            dialogSaving: inputsReducer.dialogSaving
        }), (0, _reactRedux.shallowEqual));
    const dispatch = (0, _reactRedux.useDispatch)();
    const editedInput = inputs[0];
    const [receiversChanges, setReceiversChanges] = (0, _react.useState)([]);
    const [availableChanges, setAvailableChanges] = (0, _react.useState)({});
    const [listChanges, setListChanges] = (0, _react.useState)([]);
    const [initialOpen, setInitialOpen] = (0, _react.useState)(true);
    const setConfirmation = (0, _utils.useConfirmationDialog)();
    const onClose = ()=>{
        setReceiversChanges([]);
        setAvailableChanges({});
        setListChanges([]);
        dispatch((0, _inputsActions.draftInputs)({
            inputs: []
        }));
    };
    const onSave = ()=>{
        const action = ()=>{
            dispatch((0, _inputsActions.updateInputRecipients)({
                id: editedInput.id,
                outputsAdded: Object.keys(availableChanges),
                listsAdded: listChanges,
                outputsRemoved: receiversChanges
            }));
        };
        const isOutputStreamingOtherInput = Object.values(availableChanges).map((output)=>!!output.input).some((val)=>val);
        const isRedundantInput = (0, _utils1.inputRedundancy)(editedInput);
        const isOutputRedundancyBeingRemoved = Object.values(availableChanges).some((output)=>{
            const isRedundantOutput = output.redundancyMode != (0, _types.OutputRedundancyMode).none;
            return isRedundantOutput && !isRedundantInput;
        });
        if (isOutputStreamingOtherInput || isOutputRedundancyBeingRemoved) return setConfirmation(action, /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                isOutputStreamingOtherInput && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: "- Some outputs are streaming other inputs "
                }),
                isOutputRedundancyBeingRemoved && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: "- You have selected a non-redundant input - output redundancy will be disabled "
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: " Proceed? "
                })
            ]
        }));
        return action();
    };
    (0, _react.useEffect)(()=>{
        if (initialOpen) setInitialOpen(false);
        else if (!dialogSaving) onClose();
    }, [
        dialogSaving
    ]);
    if (!editedInput) return null;
    const onRemove = (output)=>setReceiversChanges([
            ...receiversChanges,
            output.id
        ]);
    const onCancelRecipient = (outputId)=>setReceiversChanges(receiversChanges.filter((id)=>id !== outputId));
    const onAdd = (item)=>(0, _utils.isOutput)(item) ? setAvailableChanges({
            ...availableChanges,
            [item.id]: item
        }) : setListChanges(listChanges.concat(item.id));
    const onCancelAvailable = (itemId, isList = false)=>isList ? setListChanges(listChanges.filter((id)=>id !== itemId)) : setAvailableChanges((0, _omitDefault.default)(availableChanges, itemId));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: !!editedInput && action === (0, _inputsActions.DraftActions).send,
        disableRestoreFocus: true,
        onClose: onClose,
        maxWidth: "md",
        fullWidth: true,
        id: "send-input-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                title: `Send "${editedInput.name}" to:`,
                onClose: onClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentDefault.default), {
                sx: {
                    paddingBottom: 0 /* Remove bot padding for sticky pagination to look good */ 
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recipientsDefault.default), {
                        input: editedInput,
                        onCancel: onCancelRecipient,
                        onRemove: onRemove,
                        changes: receiversChanges
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _availableOutputsDefault.default), {
                        input: editedInput,
                        changes: availableChanges,
                        onSend: onAdd,
                        onCancel: onCancelAvailable,
                        listChanges: listChanges
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogActionsDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
                    pending: !!dialogSaving,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "outlined",
                            color: "secondary",
                            onClick: onClose,
                            "data-test-id": "cancel-btn",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "contained",
                            color: "primary",
                            onClick: onSave,
                            "data-test-id": "save-btn",
                            children: "Save"
                        })
                    ]
                })
            })
        ]
    }, "send-dialog");
};
exports.default = SendingDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Typography":"6NtGx","@mui/material/Button":"3qJY9","@mui/material/Dialog":"aOxpM","@mui/material/DialogActions":"h1RVn","@mui/material/DialogContent":"l4i9c","lodash/omit":"fhxvC","common/api/v1/types":"3qemx","../../../../redux/actions/inputsActions":"l0Ua8","../../../../utils":"342UB","../../../common/Dialog/Title":"hFLmw","./Recipients":"eMtY5","./AvailableOutputs":"1jkWS","../../../common/Pendable":"gDN67","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hFLmw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
const classes = {
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
};
/**
 * Simple title for modal dialogs
 * @param title - title itself
 * @param onClose - callback to call if the 'close' button clicked (hidden if no callback provided)
 */ const DialogTitle = ({ title, onClose })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTitleDefault.default), {
        sx: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                component: "span",
                children: title || null
            }),
            !!onClose && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "close",
                onClick: onClose,
                edge: "end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
            })
        ]
    });
};
exports.default = DialogTitle;

},{"react/jsx-runtime":"1dlk8","@mui/material/Typography":"6NtGx","@mui/material/DialogTitle":"5aNce","@mui/material/IconButton":"488As","@mui/icons-material/Close":"acjz6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eMtY5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _tooltip = require("../../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _highlightOff = require("@mui/icons-material/HighlightOff");
var _highlightOffDefault = parcelHelpers.interopDefault(_highlightOff);
var _store = require("../../../../store");
var _form = require("../../../common/Form");
var _selfStatePaginatedList = require("../../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _table = require("../../../common/Table");
var _indicator = require("../../../common/Indicator");
var _utils = require("../../../../utils");
const styles = {
    paper: {
        padding: (theme)=>theme.spacing(1),
        margin: (theme)=>theme.spacing(0, 0, 2),
        boxShadow: 'none',
        border: (theme)=>`1px solid ${theme.palette.grey['800']}`
    },
    button: {
        color: (theme)=>theme.palette.error.main,
        borderColor: (theme)=>theme.palette.error.main
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        minHeight: '48px',
        minWidth: '140px'
    },
    name: {
        fontWeight: 'bold'
    }
};
const outputApi = (0, _store.Api).outputApi;
const Recipients = ({ input, onCancel, onRemove, changes })=>{
    const [hideFilter, setHideFilter] = (0, _react.useState)(true);
    const [total, setTotal] = (0, _react.useState)(0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        collapsible: true,
        title: `Current recipients${total ? ` (${total})` : ''}`,
        sx: styles.paper,
        collapsed: true,
        titleTypography: "h3",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
            size: {
                xs: 12
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
                api: outputApi.getOutputs.bind(outputApi),
                emptyMessage: "no recipients",
                hideSearch: hideFilter,
                notFoundMessage: "no matching outputs",
                onListChange: ({ filter, total = 0 })=>{
                    setHideFilter(!filter && total < 10);
                    setTotal(total);
                },
                otherParams: {
                    input: input.id
                },
                searchPlaceholder: "Find specific output\u2026",
                List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                        data: list,
                        isSmall: true,
                        hasBorders: true,
                        noHeader: true,
                        config: [
                            {
                                getValue: ({ name, adminStatus })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        component: "div",
                                        sx: styles.name,
                                        "data-test-id": "output-name",
                                        ...(0, _utils.inputOutputColor)({
                                            adminStatus
                                        }),
                                        children: name
                                    })
                            },
                            {
                                getValue: (output)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AutoUpdatingOutputHealthIndicator), {
                                        initialOutput: output,
                                        noText: true
                                    })
                            },
                            {
                                getValue: ({ _group })=>!!_group && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        color: "textSecondary",
                                        variant: "body2",
                                        children: _group.name
                                    })
                            },
                            {
                                getValue: (output)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        sx: styles.actions,
                                        children: changes.includes(output.id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                            sx: styles.button,
                                            onClick: ()=>onCancel(output.id),
                                            variant: "outlined",
                                            size: "small",
                                            children: "Cancel remove"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: "Remove from recipients",
                                            placement: "top",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                                edge: "start",
                                                "aria-label": "remove",
                                                onClick: ()=>onRemove(output),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightOffDefault.default), {})
                                            })
                                        })
                                    }),
                                props: {
                                    align: 'right'
                                }
                            }
                        ]
                    })
            })
        })
    });
};
exports.default = Recipients;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Grid":"6iX4B","@mui/material/IconButton":"488As","../../../common/Tooltip":"crjvg","@mui/material/Typography":"6NtGx","@mui/icons-material/HighlightOff":"afUuo","../../../../store":"5LXiG","../../../common/Form":"4Mui7","../../../common/SelfStatePaginatedList":"dLSax","../../../common/Table":"dt9lf","../../../common/Indicator":"hqaQa","../../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"afUuo":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("dcf8064735de4cc9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("15ba16bbd3f4e545"));
var _jsxRuntime = require("e6bda49c3e2c6fd");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'HighlightOff');

},{"dcf8064735de4cc9":"kZ6eK","15ba16bbd3f4e545":"2vOnF","e6bda49c3e2c6fd":"1dlk8"}],"dLSax":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _pendable = require("../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _table = require("./Table");
var _searchInput = require("../common/SearchInput");
var _searchInputDefault = parcelHelpers.interopDefault(_searchInput);
var _utils = require("../../utils");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
const styles = {
    empty: {
        margin: (theme)=>theme.spacing(2, 0)
    }
};
/**
 * We use it to show paginated list of entities if we don't put it in the Redux store but rather have component's own state
 * For example we use it in modals
 * @param api - the api to get the list of entities
 * @param emptyMessage - if the list is empty
 * @param hideSearch - if we don't want to have filter search input on top of the list
 * @param notFoundMessage - if search with filter returned no matching entities
 * @param onListChange - callback to call if the list is changed (mostly we filtered)
 * @param otherParams - other params to call the api with (not pagination parameters)
 * @param searchPlaceholder - the placeholder to show inside empty search string
 * @param updateOn - forces to refetch on its change
 * @param Header - a component to display as a table header
 * @param List - the list component to show the entities (with single parameter 'list': Array<TEntity>)
 * @param paginationProps - configures the Pagination component
 * @constructor
 */ const PaginatedList = ({ api, emptyMessage, hideSearch, notFoundMessage, onListChange, otherParams, searchPlaceholder, updateOn, Header, List, paginationProps })=>{
    const [params, setParams] = (0, _react.useState)({
        pageNumber: (0, _utils.DEFAULT_PAGINATION).pageNumber,
        rowsPerPage: (0, _utils.DEFAULT_PAGINATION).rowsPerPage,
        filter: '',
        ...otherParams
    });
    const { loading, items, total } = (0, _utils.useSelfStatePagination)({
        params,
        api,
        updateOn
    });
    (0, _react.useEffect)(()=>{
        if (onListChange) onListChange({
            loading,
            items,
            total,
            ...params
        });
    }, [
        loading,
        total
    ]);
    if (!loading && !total && !params.filter) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        align: "center",
        variant: "body1",
        sx: styles.empty,
        color: "textSecondary",
        children: emptyMessage
    });
    const hasHeaderContent = Header || !hideSearch;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
        pending: loading,
        cover: true,
        id: "self-state-pending",
        children: [
            hasHeaderContent && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    top: 0,
                    zIndex: 1,
                    paddingTop: 2,
                    position: 'sticky',
                    backgroundColor: 'background.paper'
                },
                "data-testid": "paginated-list-header",
                children: [
                    Header,
                    !hideSearch && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchInputDefault.default), {
                        initialValue: params.filter,
                        placeholder: searchPlaceholder || "Search\u2026",
                        onChange: (input)=>setParams({
                                ...params,
                                filter: input,
                                pageNumber: '0'
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                        sx: {
                            marginTop: 2
                        }
                    })
                ]
            }),
            total || loading ? List({
                list: items
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                align: "center",
                variant: "body1",
                sx: styles.empty,
                color: "textSecondary",
                children: notFoundMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    position: 'sticky',
                    bottom: -1,
                    backgroundColor: 'background.paper'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Pagination), {
                        total: total,
                        page: params.pageNumber,
                        perPage: params.rowsPerPage,
                        changePageCallback: (pageNumber)=>setParams({
                                ...params,
                                pageNumber
                            }),
                        changeRowsPerPageCallback: (rowsPerPage)=>setParams({
                                ...params,
                                rowsPerPage,
                                pageNumber: '0'
                            }),
                        hideJumpToPage: paginationProps?.hideJumpToPage,
                        hidePerPageOption: paginationProps?.hidePerPageOption
                    })
                ]
            })
        ]
    });
};
exports.default = PaginatedList;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","../common/Pendable":"gDN67","./Table":"dt9lf","../common/SearchInput":"liEuw","../../utils":"342UB","@mui/material/Divider":"9Ul8c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"liEuw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _inputBase = require("@mui/material/InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _search = require("@mui/icons-material/Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _styles = require("@mui/material/styles");
const styles = {
    searchWrapper: {
        width: '100%',
        height: '100%',
        borderRadius: (theme)=>theme.shape.borderRadius * 50,
        backgroundColor: (theme)=>(0, _styles.alpha)(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.1 : 1),
        '&:hover': {
            backgroundColor: (theme)=>(0, _styles.alpha)(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.2 : 0.6)
        },
        '&.stretchable': {
            width: 'auto'
        }
    },
    searchIcon: {
        margin: '0 16px 0 16px',
        opacity: (theme)=>theme.palette.mode === 'dark' ? 1 : 0.54
    },
    stretchable: {
        '& .MuiInputBase-input': (theme)=>({
                [theme.breakpoints.up('sm')]: {
                    transition: (theme)=>theme.transitions.create('width'),
                    width: 130,
                    '&:focus': {
                        width: 200
                    }
                }
            })
    }
};
/**
 * Component with no logic to show special 'search' input
 * @param initialValue - the initial value for the input
 * @param onChange - callback to call on value _change_
 * @param placeholder - the text inside the empty input
 * @param stretchable - whether we stretch it on focus
 */ const SearchInput = ({ initialValue, onChange, placeholder = "Search\u2026", stretchable })=>{
    const onInputChangeHandler = (event)=>{
        onChange(event.target.value);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _classnamesDefault.default)(stretchable && 'stretchable'),
        sx: styles.searchWrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), {
            value: initialValue,
            onChange: onInputChangeHandler,
            placeholder: placeholder,
            sx: {
                width: '100%',
                ...stretchable ? styles.stretchable : {}
            },
            startAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {
                sx: styles.searchIcon
            })
        })
    });
};
exports.default = SearchInput;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","classnames":"5Een2","@mui/material/Box":"c4QkF","@mui/material/InputBase":"dfAmq","@mui/icons-material/Search":"lRGNy","@mui/material/styles":"2UrBk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1jkWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("@mui/material/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _videoLibrary = require("@mui/icons-material/VideoLibrary");
var _videoLibraryDefault = parcelHelpers.interopDefault(_videoLibrary);
var _utils = require("../../../../utils");
var _selfStatePaginatedList = require("../../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _thumbnail = require("../../../common/Thumbnail");
var _thumbnailDefault = parcelHelpers.interopDefault(_thumbnail);
var _store = require("../../../../store");
var _table = require("../../../common/Table");
var _indicator = require("../../../common/Indicator");
const styles = {
    row: {
        cursor: 'pointer'
    },
    thumbnail: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: (theme)=>theme.spacing(1),
        minWidth: '80px',
        maxWidth: '120px',
        minHeight: '50px'
    },
    button: {
        color: (theme)=>theme.palette.error.main,
        borderColor: (theme)=>theme.palette.error.main
    },
    owner: {
        display: 'inline-block',
        width: '140px'
    },
    name: {
        fontWeight: 'bold'
    }
};
const outputApi = (0, _store.Api).outputApi;
const AvailableOutputs = ({ input, onSend, onCancel, changes, listChanges })=>{
    const [hideFilter, setHideFilter] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        "data-test-id": "outputs-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                children: "Add recipients"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
                api: outputApi.getOutputsWithLists.bind(outputApi),
                emptyMessage: "no available outputs",
                hideSearch: hideFilter,
                notFoundMessage: "no matching outputs",
                onListChange: ({ filter, total = 0 })=>setHideFilter(!filter && total < 10),
                otherParams: {
                    notInput: input.id
                },
                searchPlaceholder: "Find specific output\u2026",
                List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                        data: list,
                        isSmall: true,
                        hasBorders: true,
                        noHeader: true,
                        rowProps: (item)=>({
                                onClick: ()=>((0, _utils.isOutput)(item) ? !(item.id in changes) : !listChanges.includes(item.id)) && onSend(item),
                                sx: styles.row
                            }),
                        config: [
                            {
                                getValue: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        sx: styles.thumbnail,
                                        children: (0, _utils.isOutput)(item) ? !!item._input && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnailDefault.default), {
                                            input: item._input,
                                            initialOutput: item,
                                            linkToPlaylist: false
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoLibraryDefault.default), {})
                                        })
                                    })
                            },
                            {
                                getValue: (item)=>(0, _utils.isOutput)(item) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                component: "div",
                                                sx: styles.name,
                                                "data-test-id": "output-name",
                                                ...(0, _utils.inputOutputColor)(item),
                                                children: item.name
                                            }),
                                            !!item._input && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                color: "textSecondary",
                                                variant: "body2",
                                                component: "div",
                                                children: item._input.name
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        "data-test-id": "output-name",
                                        children: item.name
                                    })
                            },
                            {
                                getValue: (item)=>(0, _utils.isOutput)(item) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AutoUpdatingOutputHealthIndicator), {
                                        initialOutput: item,
                                        noText: true
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        variant: "body2",
                                        color: "textSecondary",
                                        children: "output list"
                                    })
                            },
                            {
                                getValue: (item)=>(0, _utils.isOutput)(item) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        sx: styles.owner,
                                        children: item.id in changes ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                            sx: styles.button,
                                            onClick: ()=>onCancel(item.id),
                                            variant: "outlined",
                                            size: "small",
                                            children: "Cancel sending"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            color: "textSecondary",
                                            variant: "body2",
                                            children: item._group?.name
                                        })
                                    }) : listChanges.includes(item.id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        sx: styles.button,
                                        onClick: ()=>onCancel(item.id, true),
                                        variant: "outlined",
                                        size: "small",
                                        children: "Cancel sending"
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        color: "textSecondary",
                                        variant: "body2",
                                        children: item._group?.name
                                    }),
                                props: {
                                    align: 'right',
                                    noTypography: true
                                }
                            }
                        ]
                    })
            })
        ]
    });
};
exports.default = AvailableOutputs;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","@mui/material/Button":"3qJY9","@mui/material/Icon":"cqMA1","@mui/icons-material/VideoLibrary":"buoJz","../../../../utils":"342UB","../../../common/SelfStatePaginatedList":"dLSax","../../../common/Thumbnail":"5Q8KF","../../../../store":"5LXiG","../../../common/Table":"dt9lf","../../../common/Indicator":"hqaQa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"buoJz":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("6d6d8388f81f252b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("23e87075af16c65c"));
var _jsxRuntime = require("a973b847a845c460");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8 12.5v-9l6 4.5z"
}), 'VideoLibrary');

},{"6d6d8388f81f252b":"kZ6eK","23e87075af16c65c":"2vOnF","a973b847a845c460":"1dlk8"}],"dh8aC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _playArrow = require("@mui/icons-material/PlayArrow");
var _playArrowDefault = parcelHelpers.interopDefault(_playArrow);
var _stop = require("@mui/icons-material/Stop");
var _stopDefault = parcelHelpers.interopDefault(_stop);
var _types = require("common/api/v1/types");
var _utils = require("../../../utils");
var _store = require("../../../store");
var _inputsActions = require("../../../redux/actions/inputsActions");
var _listInputFilter = require("./listInputFilter");
var _filteredSearchBar = require("../../common/Filters/FilterView/FilteredSearchBar");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const BatchEnableButton = ({ selected, setSelected })=>{
    const inputs = (0, _reactRedux.useSelector)((state)=>state.inputsReducer.inputs, (0, _reactRedux.shallowEqual));
    const dispatch = (0, _reactRedux.useDispatch)();
    const selectedInputs = inputs.filter(({ id })=>selected.includes(id));
    const enable = selected.length > 0 && selectedInputs.some(({ adminStatus })=>adminStatus === (0, _types.InputAdminStatus).off);
    const onEnableClick = ()=>{
        dispatch((0, _inputsActions.enableInputs)(selected));
        dispatch((0, _inputsActions.draftInputs)({
            inputs: []
        }));
        setSelected([]);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: 'Enable selected inputs',
        disablePortal: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "Enable",
                disabled: !enable,
                onClick: onEnableClick,
                "data-test-id": "batch-enable",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playArrowDefault.default), {})
            })
        })
    });
};
const BatchDisableButton = ({ selected })=>{
    const inputs = (0, _reactRedux.useSelector)((state)=>state.inputsReducer.inputs, (0, _reactRedux.shallowEqual));
    const dispatch = (0, _reactRedux.useDispatch)();
    const selectedInputs = inputs.filter(({ id })=>selected.includes(id));
    const enable = selected.length > 0;
    const onDisableClick = ()=>{
        dispatch((0, _inputsActions.draftInputs)({
            action: (0, _inputsActions.DraftActions).disable,
            inputs: selectedInputs,
            source: (0, _inputsActions.DraftSources).batch
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: 'Disable selected inputs',
        disablePortal: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "Disable",
                disabled: !enable,
                onClick: onDisableClick,
                "data-test-id": "batch-disable",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stopDefault.default), {})
            })
        })
    });
};
const CommonActions = ({ inputs, selected, setSelected, user })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { group } = (0, _utils.useUser)();
    const inputsMap = inputs.reduce((acc, item)=>({
            ...acc,
            [item.id]: item
        }), {});
    const showButtons = user.role === (0, _types.Role).super || selected.every((id)=>inputsMap[id]?.owner === group);
    const onDeleteClick = ()=>dispatch((0, _inputsActions.draftInputs)({
            action: (0, _inputsActions.DraftActions).delete,
            inputs: selected.map((id)=>inputsMap[id]),
            source: (0, _inputsActions.DraftSources).batch
        }));
    const { settings } = (0, _utils.useSettingsSelector)();
    const expFeatures = settings?.expFeatures;
    const filters = (0, _listInputFilter.makeListInputFilter)({
        api: (0, _store.Api),
        expFeatures
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
        disableGutters: true,
        style: {
            overflowX: 'clip'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>theme.transitions.create('flex-shrink', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.shortest
                        })
                },
                style: {
                    flexShrink: selected.length > 0 ? 1 : 0,
                    flexGrow: 1,
                    flexBasis: '100%'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                    urlParamCacheKey: 'inputs',
                    mapUrlParamToFilterFn: (0, _listInputFilter.mapUrlParamToInputFilter),
                    mapFilterToUrlParamFn: (0, _listInputFilter.mapInputFilterToUrlParam),
                    searchTokenFilters: filters,
                    rawTextFilter: filters.find((f)=>f.key === (0, _listInputFilter.ListInputFilterKey).name)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>// Fade out, i.e. keep visible until contents has left the screen
                        theme.transitions.create('visibility', {
                            delay: selected.length === 0 ? theme.transitions.duration.shortest : 0
                        })
                },
                style: {
                    marginLeft: 16,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    visibility: selected.length > 0 ? 'visible' : 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: 140,
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            variant: "subtitle1",
                            children: [
                                (0, _utils.pluralize)(selected.length, 'input'),
                                " selected"
                            ]
                        })
                    }),
                    showButtons && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                title: 'Delete selected inputs',
                                disablePortal: false,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                        "aria-label": "batch delete",
                                        "data-test-id": "batch-delete",
                                        onClick: onDeleteClick,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BatchDisableButton, {
                                selected: selected
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BatchEnableButton, {
                                selected: selected,
                                setSelected: setSelected
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = CommonActions;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/IconButton":"488As","@mui/material/Typography":"6NtGx","@mui/material/Toolbar":"5Kohb","../../common/Tooltip":"crjvg","@mui/icons-material/Delete":"69aC7","@mui/icons-material/PlayArrow":"4aev3","@mui/icons-material/Stop":"1bxT4","common/api/v1/types":"3qemx","../../../utils":"342UB","../../../store":"5LXiG","../../../redux/actions/inputsActions":"l0Ua8","./listInputFilter":"gmhES","../../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@mui/material/Box":"c4QkF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gmhES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListInputFilterKey", ()=>ListInputFilterKey);
// Constructs a list-input-filter populated with possible values/suggestions
parcelHelpers.export(exports, "makeListInputFilter", ()=>makeListInputFilter);
parcelHelpers.export(exports, "mapInputFilterToUrlParam", ()=>mapInputFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToInputFilter", ()=>mapUrlParamToInputFilter);
var _nmTypes = require("../../../api/nm-types");
var _types = require("common/api/v1/types");
var _utils = require("common/utils");
var ListInputFilterKey = /*#__PURE__*/ function(ListInputFilterKey) {
    ListInputFilterKey["name"] = "name";
    ListInputFilterKey["healthStatus"] = "health status";
    ListInputFilterKey["appliance"] = "appliance";
    ListInputFilterKey["adminStatus"] = "admin status";
    ListInputFilterKey["applianceRegion"] = "appliance region";
    ListInputFilterKey["owner"] = "owner";
    ListInputFilterKey["tag"] = "tag";
    return ListInputFilterKey;
}({});
function makeListInputFilter({ api, expFeatures }) {
    const requestPaging = {
        pageNumber: '0',
        rowsPerPage: '20'
    };
    const supportsHealthFilter = expFeatures && expFeatures.ExtHealthAlarms;
    const filterTemplates = [
        ...supportsHealthFilter ? [
            {
                key: "health status",
                operator: 'is',
                possibleValuesSync: (searchText)=>{
                    return [
                        {
                            value: (0, _nmTypes.InputFilterHealthStatus).healthy,
                            displayName: 'healthy'
                        },
                        {
                            value: (0, _nmTypes.InputFilterHealthStatus).unhealthy,
                            displayName: 'unhealthy'
                        }
                    ].filter((v)=>!searchText || v.displayName.includes(searchText));
                }
            }
        ] : [],
        {
            key: "admin status",
            operator: 'is',
            possibleValuesSync: (searchText)=>{
                return [
                    {
                        value: (0, _types.InputAdminStatus).on.toString(),
                        displayName: 'enabled'
                    },
                    {
                        value: (0, _types.InputAdminStatus).off.toString(),
                        displayName: 'disabled'
                    }
                ].filter((v)=>!searchText || v.displayName.includes(searchText));
            }
        },
        {
            key: "name",
            operator: 'matches'
        },
        {
            key: "owner",
            operator: 'is',
            possibleValues: async (searchText)=>{
                const result = await api.groupsApi.getPureGroups({
                    ...requestPaging,
                    filter: searchText
                });
                return result.items.map((a)=>({
                        value: a.name,
                        displayName: a.name
                    }));
            }
        },
        {
            key: "appliance",
            operator: 'isOneOf',
            possibleValues: async (searchText)=>{
                const result = await api.appliancesApi.getBareAppliances({
                    ...requestPaging,
                    filter: searchText
                });
                return result.items.filter((a)=>a.type !== (0, _types.ApplianceType).thumb).map((a)=>({
                        value: a.name,
                        displayName: a.name
                    }));
            }
        },
        {
            key: "appliance region",
            operator: 'isOneOf',
            possibleValues: async (searchText)=>{
                const result = await api.regionApi.getRegions({
                    ...requestPaging,
                    filter: searchText
                });
                return result.items.map((r)=>({
                        value: r.name,
                        displayName: r.name
                    }));
            }
        },
        {
            key: "tag",
            operator: 'isOneOf',
            possibleValues: async (searchText)=>{
                const { items: tags } = await api.tagApi.listTags({
                    filter: {
                        searchName: searchText
                    }
                });
                // Super user receives tags from all groups - no need to display duplicates
                const uniqueTags = (0, _utils.distinct)(tags, (a, b)=>a.name === b.name);
                return uniqueTags.map(({ name })=>({
                        value: name,
                        displayName: name
                    }));
            }
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}
function mapInputFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "health status":
            return {
                health: filter.value
            };
        case "name":
            return {
                filter: filter.value
            };
        case "owner":
            return {
                owner: filter.value
            };
        case "admin status":
            return {
                adminStatus: filter.value
            };
    }
    else if ('values' in filter) switch(filter.key){
        case "appliance":
            return {
                appliances: filter.values.map(({ value })=>value).join(',')
            };
        case "appliance region":
            return {
                regions: filter.values.map(({ value })=>value).join(',')
            };
        case "tag":
            return {
                tags: filter.values.map(({ value })=>value).join(',')
            };
    }
    return {};
}
function mapUrlParamToInputFilter(key, value) {
    switch(key){
        case 'appliances':
            return {
                key: "appliance",
                operator: 'isOneOf',
                values: value.split(',').map((applianceName)=>({
                        value: applianceName,
                        displayName: applianceName
                    }))
            };
        case 'regions':
            return {
                key: "appliance region",
                operator: 'isOneOf',
                values: value.split(',').map((regionName)=>({
                        value: regionName,
                        displayName: regionName
                    }))
            };
        case 'owner':
            return {
                key: "owner",
                operator: 'is',
                value
            };
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
        case 'adminStatus':
            if (![
                (0, _types.InputAdminStatus).on.toString(),
                (0, _types.InputAdminStatus).off.toString()
            ].includes(value)) return undefined;
            return {
                key: "admin status",
                operator: 'is',
                value,
                displayName: value === (0, _types.InputAdminStatus).on.toString() ? 'enabled' : 'disabled'
            };
        case 'health':
            if (![
                (0, _nmTypes.InputFilterHealthStatus).healthy.toString(),
                (0, _nmTypes.InputFilterHealthStatus).unhealthy.toString()
            ].includes(value)) return undefined;
            return {
                key: "health status",
                operator: 'is',
                value,
                displayName: value === (0, _nmTypes.InputFilterHealthStatus).healthy.toString() ? 'healthy' : 'unhealthy'
            };
        case 'tags':
            return {
                key: "tag",
                operator: 'isOneOf',
                values: value.split(',').map((tagName)=>({
                        value: tagName,
                        displayName: tagName
                    }))
            };
    }
    return undefined;
}

},{"../../../api/nm-types":"bcYl5","common/api/v1/types":"3qemx","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5GvDZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _inputsActions = require("../../../redux/actions/inputsActions");
var _utils = require("../../../utils");
const DeleteDialog = ({ setSelected })=>{
    const [confirmTextValue, setConfirmTextValue] = (0, _react.useState)('');
    const { draft: { inputs, action, source } } = (0, _reactRedux.useSelector)(({ inputsReducer })=>({
            draft: inputsReducer.draft
        }), (0, _reactRedux.shallowEqual));
    const dispatch = (0, _reactRedux.useDispatch)();
    if (!inputs.length) return null;
    const onCancelClick = ()=>{
        setConfirmTextValue('');
        dispatch((0, _inputsActions.draftInputs)({
            inputs: []
        }));
    };
    const handleOk = ()=>{
        setConfirmTextValue('');
        dispatch((0, _inputsActions.draftInputs)({
            inputs: []
        }));
        if (action === (0, _inputsActions.DraftActions).delete) dispatch((0, _inputsActions.removeInputs)(inputs.map(({ id })=>id)));
        if (action === (0, _inputsActions.DraftActions).disable) {
            dispatch((0, _inputsActions.disableInputs)(inputs.map(({ id })=>id)));
            setSelected([]);
        }
    };
    const isInputInUse = inputs.some((input)=>!!input.numOutputs);
    const confirmText = (inputs.length === 1 ? inputs[0].name : `${action} inputs`).toLowerCase();
    const isConfirmRequired = source === (0, _inputsActions.DraftSources).batch && action === (0, _inputsActions.DraftActions).delete;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: inputs.length > 0 && (action === (0, _inputsActions.DraftActions).delete || action === (0, _inputsActions.DraftActions).disable),
        disableRestoreFocus: true,
        onClose: (_event, reason)=>{
            if (reason === 'escapeKeyDown') onCancelClick();
        },
        "data-test-id": "confirm-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentTextDefault.default), {
                        gutterBottom: true,
                        component: "div",
                        children: [
                            !isInputInUse && `Are you sure you want to ${action} ${inputs.length > 1 ? (0, _utils.pluralize)(inputs.length, 'input') : inputs[0].name}?`,
                            isInputInUse && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    inputs.length > 1 ? `Some inputs are in use - are you sure you want to ${action} them?` : `${inputs[0].name} is in use - are you sure you want to ${action} it?`,
                                    inputs.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                        children: inputs.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                                children: [
                                                    item.name,
                                                    !!item.numOutputs && ` (in use by ${(0, _utils.pluralize)(item.numOutputs, 'output')})`
                                                ]
                                            }, item.id))
                                    })
                                ]
                            })
                        ]
                    }),
                    isConfirmRequired && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentTextDefault.default), {
                                gutterBottom: true,
                                children: [
                                    "To confirm, type",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            fontStyle: 'italic',
                                            fontWeight: 'bold'
                                        },
                                        "data-test-id": "confirm-text-value",
                                        children: confirmText
                                    }),
                                    ' ',
                                    "below"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                "data-test-id": "confirm-text-field",
                                autoFocus: true,
                                fullWidth: true,
                                placeholder: confirmText,
                                value: confirmTextValue,
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter' && confirmTextValue.toLowerCase() === confirmText) handleOk();
                                },
                                onChange: (e)=>setConfirmTextValue(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogActionsDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "outlined",
                        color: "secondary",
                        onClick: onCancelClick,
                        "data-test-id": "cancel-btn",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "contained",
                        color: action === (0, _inputsActions.DraftActions).delete ? 'error' : 'primary',
                        onClick: handleOk,
                        "data-test-id": "ok-btn",
                        disabled: isConfirmRequired ? confirmTextValue.toLowerCase() !== confirmText : false,
                        children: action
                    })
                ]
            })
        ]
    });
};
exports.default = DeleteDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Dialog":"aOxpM","@mui/material/DialogActions":"h1RVn","@mui/material/DialogContent":"l4i9c","@mui/material/DialogContentText":"7bReD","@mui/material/Button":"3qJY9","@mui/material/TextField":"l88b4","../../../redux/actions/inputsActions":"l0Ua8","../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fV5xG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _api = require("../../../../api/inputs/api");
var _inputsActions = require("../../../../redux/actions/inputsActions");
var _types = require("common/api/v1/types");
var _title = require("../../../common/Dialog/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _utils = require("../../../../utils");
var _recipients = require("./Recipients");
var _recipientsDefault = parcelHelpers.interopDefault(_recipients);
var _availableGroups = require("./AvailableGroups");
var _availableGroupsDefault = parcelHelpers.interopDefault(_availableGroups);
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
const SharingDialog = ()=>{
    const { draft: { inputs, action }, dialogSaving } = (0, _reactRedux.useSelector)(({ inputsReducer })=>({
            draft: inputsReducer.draft,
            dialogSaving: inputsReducer.dialogSaving
        }), (0, _reactRedux.shallowEqual));
    const dispatch = (0, _reactRedux.useDispatch)();
    const editedInput = inputs[0];
    const [receiversChanges, setReceiversChanges] = (0, _react.useState)({});
    const [availableChanges, setAvailableChanges] = (0, _react.useState)({});
    const [listChanges, setListChanges] = (0, _react.useState)({});
    const [initialOpen, setInitialOpen] = (0, _react.useState)(true);
    const onClose = ()=>{
        setAvailableChanges({});
        setReceiversChanges({});
        setListChanges({});
        dispatch((0, _inputsActions.draftInputs)({
            inputs: []
        }));
    };
    const onSave = ()=>{
        dispatch((0, _inputsActions.updateInputDistribution)({
            id: editedInput.id,
            permissions: [
                ...Object.entries(receiversChanges).map(([groupId, action])=>({
                        permission: {
                            groupId,
                            accessType: (0, _types.InputAccessType).view
                        },
                        action
                    })),
                ...Object.entries(availableChanges).map(([groupId, accessType])=>({
                        permission: {
                            groupId,
                            accessType
                        },
                        action: (0, _api.PermissionAction).add
                    }))
            ],
            listPermissions: listChanges
        }));
    };
    (0, _react.useEffect)(()=>{
        if (initialOpen) setInitialOpen(false);
        else if (!dialogSaving) onClose();
    }, [
        dialogSaving
    ]);
    if (!editedInput) return null;
    const onRemoveNew = (group)=>setReceiversChanges({
            ...receiversChanges,
            [group.id]: (0, _api.PermissionAction).remove
        });
    const onSwitchNew = (group)=>setReceiversChanges({
            ...receiversChanges,
            [group.id]: (0, _api.PermissionAction).change
        });
    const onCancelRecipient = (group)=>setReceiversChanges((0, _omitDefault.default)(receiversChanges, group.id));
    const onShare = (group, permission)=>(0, _utils.isGroup)(group) ? setAvailableChanges({
            ...availableChanges,
            [group.id]: permission
        }) : setListChanges({
            ...listChanges,
            [group.id]: permission
        });
    const onCancelAvailable = (group)=>(0, _utils.isGroup)(group) ? setAvailableChanges((0, _omitDefault.default)(availableChanges, group.id)) : setListChanges((0, _omitDefault.default)(listChanges, group.id));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: !!editedInput && action === (0, _inputsActions.DraftActions).share,
        disableRestoreFocus: true,
        onClose: onClose,
        maxWidth: "md",
        fullWidth: true,
        id: "share-input-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                title: `Share "${editedInput.name}" to:`,
                onClose: onClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentDefault.default), {
                sx: {
                    paddingBottom: 0 /* Remove bot padding for sticky pagination to look good */ 
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recipientsDefault.default), {
                        input: editedInput,
                        onCancel: onCancelRecipient,
                        onRemove: onRemoveNew,
                        onSwitch: onSwitchNew,
                        changes: receiversChanges
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _availableGroupsDefault.default), {
                        input: editedInput,
                        changes: availableChanges,
                        listChanges: listChanges,
                        onShare: onShare,
                        onCancel: onCancelAvailable
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogActionsDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
                    pending: !!dialogSaving,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "outlined",
                            color: "secondary",
                            onClick: onClose,
                            "data-test-id": "cancel-btn",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "contained",
                            color: "primary",
                            onClick: onSave,
                            "data-test-id": "save-btn",
                            children: "Save"
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = SharingDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","lodash/omit":"fhxvC","@mui/material/Button":"3qJY9","@mui/material/Dialog":"aOxpM","@mui/material/DialogActions":"h1RVn","@mui/material/DialogContent":"l4i9c","../../../../api/inputs/api":"fNMtN","../../../../redux/actions/inputsActions":"l0Ua8","common/api/v1/types":"3qemx","../../../common/Dialog/Title":"hFLmw","../../../../utils":"342UB","./Recipients":"7pkCY","./AvailableGroups":"fx14c","../../../common/Pendable":"gDN67","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7pkCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _switch = require("@mui/material/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _types = require("common/api/v1/types");
var _store = require("../../../../store");
var _form = require("../../../common/Form");
var _selfStatePaginatedList = require("../../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _api = require("../../../../api/inputs/api");
const styles = {
    paper: {
        padding: (theme)=>theme.spacing(1),
        margin: (theme)=>theme.spacing(0, 0, 2),
        boxShadow: 'none',
        border: (theme)=>`1px solid ${theme.palette.grey['800']}`
    },
    button: {
        marginLeft: (theme)=>theme.spacing(1),
        '&.cancel': {
            color: (theme)=>theme.palette.error.main,
            borderColor: (theme)=>theme.palette.error.main
        }
    }
};
const groupApi = (0, _store.Api).groupsApi;
const Recipients = ({ input, onCancel, onRemove, onSwitch, changes })=>{
    const [hideFilter, setHideFilter] = (0, _react.useState)(true);
    const [total, setTotal] = (0, _react.useState)(0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        collapsible: true,
        title: `Current recipients${total ? ` (${total})` : ''}`,
        sx: styles.paper,
        collapsed: true,
        titleTypography: "h3",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
            api: groupApi.getGroupPermissions.bind(groupApi),
            emptyMessage: "no recipients",
            hideSearch: hideFilter,
            notFoundMessage: "no matching groups",
            onListChange: ({ filter, total = 0 })=>{
                setHideFilter(!filter && total < 10);
                setTotal(total);
            },
            otherParams: {
                inputShared: input.id,
                userGroup: input.owner
            },
            searchPlaceholder: "Find specific group\u2026",
            List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                    disablePadding: true,
                    "data-test-id": "shared-to",
                    children: list.map((item)=>{
                        const group = item;
                        let checked = group._permission?.accessType === (0, _types.InputAccessType).pull;
                        const change = changes[group.id];
                        if (change === (0, _api.PermissionAction).change) checked = !checked;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
                            disableGutters: true,
                            divider: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                    primaryTypographyProps: {
                                        color: change ? 'textSecondary' : 'textPrimary'
                                    },
                                    "data-test-id": "group-name",
                                    children: group.name
                                }),
                                !change || change === (0, _api.PermissionAction).change ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "body2",
                                            color: checked ? 'textSecondary' : 'textPrimary',
                                            children: "Preview"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchDefault.default), {
                                            checked: checked,
                                            onChange: ()=>change ? onCancel(group) : onSwitch(group),
                                            color: "primary"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "body2",
                                            color: checked ? 'textPrimary' : 'textSecondary',
                                            style: {
                                                whiteSpace: 'nowrap'
                                            },
                                            children: "Full Access"
                                        })
                                    ]
                                }) : null,
                                change ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    size: "small",
                                    variant: "outlined",
                                    onClick: ()=>onCancel(group),
                                    sx: styles.button,
                                    className: "cancel",
                                    children: `Cancel ${change === (0, _api.PermissionAction).change ? 'switch' : 'remove'}`
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    "data-test-id": "remove-btn",
                                    size: "small",
                                    variant: "outlined",
                                    onClick: ()=>onRemove(group),
                                    sx: styles.button,
                                    children: "Remove"
                                })
                            ]
                        }, item.id);
                    })
                })
        })
    });
};
exports.default = Recipients;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/List":"a52pA","@mui/material/Typography":"6NtGx","@mui/material/Button":"3qJY9","@mui/material/ListItem":"fosVg","@mui/material/ListItemText":"1ZvGq","@mui/material/Switch":"d69la","common/api/v1/types":"3qemx","../../../../store":"5LXiG","../../../common/Form":"4Mui7","../../../common/SelfStatePaginatedList":"dLSax","../../../../api/inputs/api":"fNMtN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d69la":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("3b4c05c35c7ec58f").default;
var _interopRequireDefault = require("9f58474c9778c9d5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    switchClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Switch.default;
    }
});
Object.defineProperty(exports, "switchClasses", {
    enumerable: true,
    get: function() {
        return _switchClasses.default;
    }
});
var _Switch = _interopRequireDefault(require("5240fee82c644b2e"));
var _switchClasses = _interopRequireWildcard(require("7003b9b6540094ac"));
Object.keys(_switchClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _switchClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _switchClasses[key];
        }
    });
});

},{"3b4c05c35c7ec58f":"fiRIh","9f58474c9778c9d5":"kZ6eK","5240fee82c644b2e":"4Eofc","7003b9b6540094ac":"hOMTu"}],"4Eofc":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
// @inheritedComponent IconButton
var _interopRequireDefault = require("48997e00b5afdd35").default;
var _interopRequireWildcard = require("46b817272b3fe0d4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d415a48728d9fffb"));
var _propTypes = _interopRequireDefault(require("1244a9966eff0cb9"));
var _clsx = _interopRequireDefault(require("da7f0275acfd856e"));
var _refType = _interopRequireDefault(require("1c5a2269b0f6d74c"));
var _composeClasses = _interopRequireDefault(require("5c693dc830c0bf50"));
var _colorManipulator = require("c8e62f3f21e54d18");
var _capitalize = _interopRequireDefault(require("8cbe585b18b965a7"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("8160ec0e80bd4b66"));
var _SwitchBase = _interopRequireDefault(require("1f2b0d251974b7f5"));
var _zeroStyled = require("cb2e27cededcaa58");
var _memoTheme = _interopRequireDefault(require("348959f5dd4a733f"));
var _DefaultPropsProvider = require("d3a10a26676f336d");
var _switchClasses = _interopRequireWildcard(require("66a59192fcfc50bb"));
var _useSlot = _interopRequireDefault(require("90cd552109dc1918"));
var _jsxRuntime = require("f25c1e504fd97e61");
const useUtilityClasses = (ownerState)=>{
    const { classes, edge, size, color, checked, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, _capitalize.default)(edge)}`,
            `size${(0, _capitalize.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, _capitalize.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _switchClasses.getSwitchUtilityClass, classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const SwitchRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, _capitalize.default)(ownerState.edge)}`],
            styles[`size${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${_switchClasses.default.thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${_switchClasses.default.switchBase}`]: {
                    padding: 4,
                    [`&.${_switchClasses.default.checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const SwitchSwitchBase = (0, _zeroStyled.styled)(_SwitchBase.default, {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${_switchClasses.default.input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, _capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${_switchClasses.default.checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${_switchClasses.default.disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${_switchClasses.default.checked} + .${_switchClasses.default.track}`]: {
            opacity: 0.5
        },
        [`&.${_switchClasses.default.disabled} + .${_switchClasses.default.track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${_switchClasses.default.input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, _memoTheme.default)(({ theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&.${_switchClasses.default.checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${_switchClasses.default.disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62) : (0, _colorManipulator.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${_switchClasses.default.checked} + .${_switchClasses.default.track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const SwitchTrack = (0, _zeroStyled.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Track'
})((0, _memoTheme.default)(({ theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const SwitchThumb = (0, _zeroStyled.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb'
})((0, _memoTheme.default)(({ theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const Switch = /*#__PURE__*/ React.forwardRef(function Switch(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className, color = 'primary', edge = false, size = 'medium', sx, slots = {}, slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color,
        edge,
        size
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots,
        slotProps
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        className: (0, _clsx.default)(classes.root, className),
        elementType: SwitchRoot,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, _useSlot.default)('thumb', {
        className: classes.thumb,
        elementType: SwitchThumb,
        externalForwardedProps,
        ownerState
    });
    const icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, _useSlot.default)('track', {
        className: classes.track,
        elementType: SwitchTrack,
        externalForwardedProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    ...slotProps.input && {
                        input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
var _default = exports.default = Switch;

},{"48997e00b5afdd35":"kZ6eK","46b817272b3fe0d4":"fiRIh","d415a48728d9fffb":"9njXz","1244a9966eff0cb9":"bnNSm","da7f0275acfd856e":"d2NWs","1c5a2269b0f6d74c":"3TBXN","5c693dc830c0bf50":"59Equ","c8e62f3f21e54d18":"hTYBL","8cbe585b18b965a7":"eOYSA","8160ec0e80bd4b66":"2r5WG","1f2b0d251974b7f5":"2T3Xg","cb2e27cededcaa58":"hZXDo","348959f5dd4a733f":"cJNjb","d3a10a26676f336d":"9bD8g","66a59192fcfc50bb":"hOMTu","90cd552109dc1918":"h76AU","f25c1e504fd97e61":"1dlk8"}],"hOMTu":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6820755f403e2a28").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getSwitchUtilityClass = getSwitchUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("b21762230144d891"));
var _generateUtilityClass = _interopRequireDefault(require("7a7a05fc0d0b9b53"));
function getSwitchUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiSwitch', slot);
}
const switchClasses = (0, _generateUtilityClasses.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var _default = exports.default = switchClasses;

},{"6820755f403e2a28":"kZ6eK","b21762230144d891":"7pSUk","7a7a05fc0d0b9b53":"jBs9M"}],"fx14c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _types = require("common/api/v1/types");
var _store = require("../../../../store");
var _selfStatePaginatedList = require("../../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _utils = require("../../../../utils");
const styles = {
    button: {
        whiteSpace: 'nowrap',
        marginLeft: (theme)=>theme.spacing(1),
        '&.cancel': {
            color: (theme)=>theme.palette.error.main,
            borderColor: (theme)=>theme.palette.error.main
        }
    }
};
const groupApi = (0, _store.Api).groupsApi;
const AvailableGroups = ({ input, onShare, onCancel, changes, listChanges })=>{
    const [hideFilter, setHideFilter] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        "data-test-id": "groups-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                children: "Add recipients"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
                api: groupApi.getGroupsWithLists.bind(groupApi),
                emptyMessage: "no available groups",
                hideSearch: hideFilter,
                notFoundMessage: "no matching groups",
                onListChange: ({ filter, total = 0 })=>setHideFilter(!filter && total < 10),
                otherParams: {
                    inputNotShared: input.id,
                    userGroup: input.owner
                },
                searchPlaceholder: "Find specific group\u2026",
                List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                        disablePadding: true,
                        "data-test-id": "groups",
                        children: list.map((group)=>{
                            const accessType = (0, _utils.isGroup)(group) ? changes[group.id] : listChanges[group.id];
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
                                disableGutters: true,
                                divider: true,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemTextDefault.default), {
                                        primaryTypographyProps: {
                                            color: changes[group.id] ? 'textSecondary' : 'textPrimary'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                component: "span",
                                                "data-test-id": "group-name",
                                                children: [
                                                    group.name,
                                                    ' '
                                                ]
                                            }),
                                            !(0, _utils.isGroup)(group) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                variant: "body2",
                                                color: "textSecondary",
                                                component: "span",
                                                children: "(Group list)"
                                            })
                                        ]
                                    }),
                                    accessType ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        size: "small",
                                        variant: "outlined",
                                        onClick: ()=>onCancel(group),
                                        sx: styles.button,
                                        className: "cancel",
                                        children: `Cancel ${accessType === (0, _types.InputAccessType).pull ? 'full access' : 'preview'}`
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                size: "small",
                                                variant: "outlined",
                                                onClick: ()=>onShare(group, (0, _types.InputAccessType).view),
                                                "data-test-id": "preview-btn",
                                                children: "Preview"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                size: "small",
                                                variant: "outlined",
                                                onClick: ()=>onShare(group, (0, _types.InputAccessType).pull),
                                                sx: styles.button,
                                                children: "Full Access"
                                            })
                                        ]
                                    })
                                ]
                            }, group.id);
                        })
                    })
            })
        ]
    });
};
exports.default = AvailableGroups;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/List":"a52pA","@mui/material/Typography":"6NtGx","@mui/material/Button":"3qJY9","@mui/material/ListItem":"fosVg","@mui/material/ListItemText":"1ZvGq","common/api/v1/types":"3qemx","../../../../store":"5LXiG","../../../common/SelfStatePaginatedList":"dLSax","../../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jf6As":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _react = require("react");
var _reactRouter = require("react-router");
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _common = require("../../../Common");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
const deleteStyle = (theme)=>({
        ...(0, _common.styles).error(theme),
        '&:hover': (0, _common.styles).error
    });
const ActionMenu = (props)=>{
    const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event)=>{
        event.stopPropagation();
        setAnchorEl(null);
    };
    const renderOptionContent = (option)=>{
        const { icon, label } = option;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                    children: icon
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                    primary: label
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "open action menu",
                "data-test-id": props['data-test-id'] ? `open-${props['data-test-id']}` : 'open-action-menu',
                "aria-haspopup": "true",
                onClick: handleClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
                "data-test-id": props['data-test-id'] || 'action-menu',
                "data-testid": props['data-test-id'] || 'action-menu',
                "data-is-open": open ? 'true' : 'false',
                keepMounted: true,
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: props.options.map((option, index)=>{
                    // Tries to use the most "native" way to open a link
                    if ('onClick' in option) {
                        const { onClick } = option;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                            sx: option.isDestructive ? deleteStyle : undefined,
                            "data-test-id": option['data-test-id'],
                            "data-testid": option['data-test-id'],
                            onClick: (e)=>{
                                onClick && onClick();
                                handleClose(e);
                            },
                            children: renderOptionContent(option)
                        }, index);
                    }
                    if (!('href' in option)) return null;
                    const { href, openInNewTab } = option;
                    if (!href) return null;
                    if (!openInNewTab) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        sx: option.isDestructive ? deleteStyle : undefined,
                        "data-test-id": option['data-test-id'],
                        "data-testid": option['data-test-id'],
                        component: (0, _reactRouter.Link),
                        to: href,
                        children: renderOptionContent(option)
                    }, index);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        sx: option.isDestructive ? deleteStyle : undefined,
                        "data-test-id": option['data-test-id'],
                        "data-testid": option['data-test-id'],
                        component: (0, _linkDefault.default),
                        href: href,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: renderOptionContent(option)
                    }, index);
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/icons-material/MoreVert":"22WtH","@mui/material/Menu":"1ut4X","@mui/material/IconButton":"488As","react":"9njXz","react-router":"iaz4C","@mui/material/MenuItem":"krMs8","@mui/material/ListItemIcon":"2WZ7w","@mui/material/ListItemText":"1ZvGq","../../../Common":"7DOrW","@mui/material/Link":"chNUC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"22WtH":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("232ab8a207fe2464").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("8f6184f10c32f401"));
var _jsxRuntime = require("6b76b0748d35cf91");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreVert');

},{"232ab8a207fe2464":"kZ6eK","8f6184f10c32f401":"2vOnF","6b76b0748d35cf91":"1dlk8"}],"1D7NB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServiceOverviewDisabled", ()=>isServiceOverviewDisabled);
parcelHelpers.export(exports, "ServiceOverviewButton", ()=>ServiceOverviewButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _dateFns = require("date-fns");
var _formGroup = require("@mui/material/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _cached = require("@mui/icons-material/Cached");
var _cachedDefault = parcelHelpers.interopDefault(_cached);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _serviceOverviewActions = require("../../../redux/actions/serviceOverviewActions");
var _utils = require("../../../utils");
var _form = require("../../common/Form");
var _link = require("../../common/Link");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _table = require("../../common/Table");
var _info1 = require("./Info");
var _infoDefault1 = parcelHelpers.interopDefault(_info1);
var _serviceOverviewGraph = require("../Graph/ServiceOverviewGraph");
var _common = require("../../../Common");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _windowSize = require("./WindowSize");
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _filteredSearchBar = require("../../common/Filters/FilterView/FilteredSearchBar");
var _listServiceOverviewFilter = require("../listServiceOverviewFilter");
var _mixpanel = require("../../../mixpanel");
const isServiceOverviewDisabled = (input)=>!input.ports?.length && !input.deriveFrom?.parentInput;
const ServiceOverviewButton = ({ input, outputId })=>{
    const routes = (0, _store.useRoutes)();
    const disabled = input ? isServiceOverviewDisabled(input) : true;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        available: !disabled,
        to: routes.service({
            id: input?.id,
            outputId
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
            "aria-label": "Open Service Overview",
            disabled: disabled,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: 'Service Overview',
                placement: "top",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {})
            })
        })
    });
};
const Overview = ()=>{
    const { id: inputId } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const [parameters] = (0, _utils.usePageParams)();
    const outputId = parameters.outputId;
    const params = (0, _utils.withDefaultPagination)(parameters);
    const { input, parent, outputs, derivedInputs, loading, graph, appliances, tr101290Window, isAnimationEnabled } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input,
            parent: serviceOverviewReducer.parent,
            outputs: serviceOverviewReducer.outputs,
            derivedInputs: serviceOverviewReducer.derivedInputs,
            loading: serviceOverviewReducer.loading,
            graph: serviceOverviewReducer.graph,
            appliances: serviceOverviewReducer.appliances,
            tr101290Window: serviceOverviewReducer.tr101290Window,
            isAnimationEnabled: serviceOverviewReducer.isAnimationEnabled
        }), (0, _reactRedux.shallowEqual));
    const [date, setDate] = (0, _react.useState)(new Date());
    const [selected, setSelected] = (0, _react.useState)(outputId ? {
        id: outputId,
        type: (0, _types.GraphNodeType).output
    } : undefined);
    (0, _react.useEffect)(()=>{
        if (!loading) setDate(new Date());
    }, [
        loading
    ]);
    (0, _react.useEffect)(()=>{
        if (!inputId) return;
        setSelected(undefined);
        dispatch((0, _serviceOverviewActions.getService)({
            params: parameters,
            inputId,
            outputId
        }));
    }, [
        inputId,
        outputId,
        dispatch,
        Object.values(params).join(',')
    ]);
    (0, _react.useEffect)(()=>{
        // Trigger auto-select when input (and hence new graph) has been re-fetched
        // by above effect.
        handleOnSelect(undefined);
    }, [
        input?.id
    ]);
    (0, _react.useEffect)(()=>{
        function doRefresh() {
            dispatch((0, _serviceOverviewActions.refresh)());
        }
        const timerId = setInterval(doRefresh, 20000);
        return function stopRefresh() {
            clearInterval(timerId);
        };
    }, [
        dispatch
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            dispatch((0, _serviceOverviewActions.clearService)());
        };
    }, [
        dispatch,
        parameters.outputId
    ]);
    const handleOnSelect = (selected)=>{
        if (selected) {
            setSelected(selected);
            (0, _mixpanel.mixpanel).trackClickComponent({
                component: 'service-overview',
                so_type: selected.type,
                so_from_type: selected.data?.fromType,
                so_to_type: selected.data?.toType
            });
        } else if (outputId) setSelected({
            id: outputId,
            type: (0, _types.GraphNodeType).output
        });
        else if (graph) {
            const inputLogicalPortNode = Object.values(graph.nodes).find((n)=>n.data.type === (0, _types.GraphNodeType).inputLogicalPort);
            if (inputLogicalPortNode) setSelected({
                id: inputLogicalPortNode.data.id,
                type: inputLogicalPortNode.data.type,
                data: inputLogicalPortNode.data
            });
        }
    };
    const showSearchbar = !parameters.outputId;
    const filters = (0, _listServiceOverviewFilter.makeServiceOverviewFilter)();
    const isInputConfigured = !!input && ((input.ports?.length ?? 0) > 0 || input.deriveFrom !== undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Service overview',
            input?.name
        ],
        actions: showSearchbar && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                flexShrink: 1,
                flexGrow: 1
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                urlParamCacheKey: undefined,
                mapUrlParamToFilterFn: (0, _listServiceOverviewFilter.mapUrlParamToServiceOverviewFilter),
                mapFilterToUrlParamFn: (0, _listServiceOverviewFilter.mapServiceOverviewFilterToUrlParam),
                searchTokenFilters: filters,
                rawTextFilter: filters.find((f)=>f.key === (0, _listServiceOverviewFilter.ListServiceOverviewFilterKey).outputName)
            })
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
            container: true,
            spacing: 3,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                size: {
                    xs: 12
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        id: "paper-service-overview",
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'space-between'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                            color: "textSecondary",
                                            variant: "body2",
                                            component: "span",
                                            style: {
                                                marginRight: 8,
                                                cursor: 'auto'
                                            },
                                            children: [
                                                "Loaded at ",
                                                (0, _dateFns.format)(date, 'HH:mm:ss')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: 'Refresh',
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                                onClick: ()=>void dispatch((0, _serviceOverviewActions.refresh)()),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cachedDefault.default), {
                                                    sx: loading ? (0, _common.styles).rotating : {}
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), {
                                            style: {
                                                marginRight: 12
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                                label: "Animate direction",
                                                labelPlacement: 'end',
                                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                                    size: 'small',
                                                    checked: isAnimationEnabled,
                                                    onChange: (_event, checked)=>dispatch((0, _serviceOverviewActions.setEnableAnimations)(checked))
                                                }),
                                                slotProps: {
                                                    typography: {
                                                        color: 'textSecondary',
                                                        variant: 'body2'
                                                    }
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _windowSize.WindowSizeSelect), {
                                            currentWindow: tr101290Window
                                        })
                                    ]
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            size: {
                                xs: 12
                            },
                            children: isInputConfigured && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serviceOverviewGraph.ServiceOverviewGraph), {
                                        selectedItem: selected,
                                        onSelect: handleOnSelect,
                                        graph: JSON.parse(JSON.stringify(graph)),
                                        input: input,
                                        parent: parent,
                                        outputs: outputs.items,
                                        derivedInputs: derivedInputs,
                                        appliances: appliances,
                                        outputId: parameters.outputId,
                                        isAnimationEnabled: isAnimationEnabled
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Pagination), {
                                        total: outputs.total,
                                        useUrlSearchParams: true
                                    })
                                ]
                            })
                        })
                    }),
                    !!selected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault1.default), {
                        selected: selected
                    })
                ]
            })
        })
    });
};
exports.default = Overview;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","date-fns":"gelMX","@mui/material/FormGroup":"4P3FX","@mui/material/Grid":"6iX4B","@mui/material/Typography":"6NtGx","@mui/material/IconButton":"488As","@mui/icons-material/Cached":"k4ZaR","@mui/icons-material/Info":"juq3i","common/api/v1/types":"3qemx","../../../store":"5LXiG","../../../redux/actions/serviceOverviewActions":"ak7dX","../../../utils":"342UB","../../common/Form":"4Mui7","../../common/Link":"l3o6V","../../common/Wrapper":"8oy7r","../../common/Table":"dt9lf","./Info":"iFdZy","../Graph/ServiceOverviewGraph":"i85VV","../../../Common":"7DOrW","@mui/material/Checkbox":"ag1Z5","@mui/material/FormControlLabel":"45VZW","./WindowSize":"1JLzg","../../common/Tooltip":"crjvg","../../common/Filters/FilterView/FilteredSearchBar":"eEpmv","../listServiceOverviewFilter":"exIG7","../../../mixpanel":"7xxdr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4P3FX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("b8af8b3a79926630").default;
var _interopRequireDefault = require("44e2f5d6f86ca0de").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    formGroupClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _FormGroup.default;
    }
});
Object.defineProperty(exports, "formGroupClasses", {
    enumerable: true,
    get: function() {
        return _formGroupClasses.default;
    }
});
var _FormGroup = _interopRequireDefault(require("452d99bd745ff2a2"));
var _formGroupClasses = _interopRequireWildcard(require("99b5b05d8814cf9f"));
Object.keys(_formGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _formGroupClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _formGroupClasses[key];
        }
    });
});

},{"b8af8b3a79926630":"fiRIh","44e2f5d6f86ca0de":"kZ6eK","452d99bd745ff2a2":"hBGqs","99b5b05d8814cf9f":"1wgWT"}],"hBGqs":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2305f789564c701b").default;
var _interopRequireWildcard = require("40dd9527f43d84c6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("64efb46ee235212b"));
var _propTypes = _interopRequireDefault(require("fd6a16af51a1992c"));
var _clsx = _interopRequireDefault(require("2e51a509869f8145"));
var _composeClasses = _interopRequireDefault(require("e8a69337f41ae9d8"));
var _zeroStyled = require("2915b1e9bb66c90e");
var _DefaultPropsProvider = require("2416c2e27ca6327d");
var _formGroupClasses = require("ce38ece3e0fd9729");
var _useFormControl = _interopRequireDefault(require("ed5d48fa80dc7b92"));
var _formControlState = _interopRequireDefault(require("ca36a8c7d9dd9e97"));
var _jsxRuntime = require("474e3b1afe537339");
const useUtilityClasses = (ownerState)=>{
    const { classes, row, error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, _composeClasses.default)(slots, _formGroupClasses.getFormGroupUtilityClass, classes);
};
const FormGroupRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const FormGroup = /*#__PURE__*/ React.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className, row = false, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row,
        error: fcs.error
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormGroupRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var _default = exports.default = FormGroup;

},{"2305f789564c701b":"kZ6eK","40dd9527f43d84c6":"fiRIh","64efb46ee235212b":"9njXz","fd6a16af51a1992c":"bnNSm","2e51a509869f8145":"d2NWs","e8a69337f41ae9d8":"59Equ","2915b1e9bb66c90e":"hZXDo","2416c2e27ca6327d":"9bD8g","ce38ece3e0fd9729":"1wgWT","ed5d48fa80dc7b92":"51J7f","ca36a8c7d9dd9e97":"9soGV","474e3b1afe537339":"1dlk8"}],"1wgWT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1681a96749b223ab").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getFormGroupUtilityClass = getFormGroupUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("70682ef8d00ec117"));
var _generateUtilityClass = _interopRequireDefault(require("76a0315cd962f10"));
function getFormGroupUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiFormGroup', slot);
}
const formGroupClasses = (0, _generateUtilityClasses.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var _default = exports.default = formGroupClasses;

},{"1681a96749b223ab":"kZ6eK","70682ef8d00ec117":"7pSUk","76a0315cd962f10":"jBs9M"}],"k4ZaR":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("a7e91ec66975c868").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("89de8f10713e172b"));
var _jsxRuntime = require("1bbf558213720e63");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m19 8-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4z"
}), 'Cached');

},{"a7e91ec66975c868":"kZ6eK","89de8f10713e172b":"2vOnF","1bbf558213720e63":"1dlk8"}],"iFdZy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getConnectionMetrics", ()=>getConnectionMetrics);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _min = require("lodash/min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _statistics = require("./Statistics");
var _vaStatistics = require("./VaStatistics");
var _infoSection = require("./InfoSection");
var _indicator = require("../../common/Indicator");
var _link = require("../../common/Link");
var _utils = require("../../../utils");
var _utils1 = require("./utils");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _helpers = require("common/api/v1/helpers");
var _internal = require("common/api/v1/internal");
var _tr101290 = require("./TR101290");
var _tr101290Default = parcelHelpers.interopDefault(_tr101290);
var _util = require("common/util");
var _utils2 = require("common/utils");
var _applianceProxyButton = require("../../common/ApplianceProxyButton");
var _srt = require("common/srt");
var _serviceOverviewGraph = require("../Graph/ServiceOverviewGraph");
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _reactRouter = require("react-router");
function isUdpInputPortWithRtpFormat(logicalPort) {
    // having mode rtp and failoverPriority means it will be added to the ristserver as a udp-input with format="rtp" used for source failover
    return logicalPort.mode === (0, _types.IpPortMode).rtp && logicalPort.failoverPriority !== undefined;
}
function isUdpOutputPortWithRtpFormat(logicalPort) {
    return (0, _srt.isRtpOverSrt)(logicalPort);
}
function isRtpInputPort(inputPort) {
    return inputPort.mode === (0, _types.IpPortMode).rtp;
}
const portModesWithUdpMetrics = [
    (0, _types.IpPortMode).udp,
    (0, _types.MatroxPortMode).matroxSdi,
    (0, _types.VideonPortMode).videonAuto,
    (0, _types.VideonPortMode).videonHdmi,
    (0, _types.VideonPortMode).videonSdi
];
const inputPortHasRtpMetrics = (lp)=>{
    if ((0, _srt.isRtpOverSrt)(lp)) return true;
    if (lp.mode === (0, _types.IpPortMode).rtp) return true;
    if (lp.mode === (0, _types.CoaxPortMode).sdi) return true;
    if (lp.mode === (0, _types.IpPortMode).zixi) return true;
    if (lp.mode === (0, _types.MatroxPortMode).matroxSdi) return true;
    if (lp.mode === (0, _types.ComprimatoPortMode).comprimatoNdi) return true;
    if (lp.mode === (0, _types.ComprimatoPortMode).comprimatoSdi) return true;
    return false;
};
const outputPortHasRtpMetrics = (lp)=>{
    if (isUdpOutputPortWithRtpFormat(lp)) return true;
    if (lp.mode === (0, _types.IpPortMode).rtp) return true;
    if (lp.mode === (0, _types.IpPortMode).zixi) return true;
    if (lp.mode === (0, _types.ComprimatoPortMode).comprimatoNdi) return true;
    if (lp.mode === (0, _types.ComprimatoPortMode).comprimatoSdi) return true;
    return false;
};
function findActiveOutputInGroupByStreamId(egressMetrics, streamId) {
    let metrics = egressMetrics.find((m)=>m.streamId === streamId);
    if (metrics && egressMetrics) {
        const channelGroupMirrors = egressMetrics.filter((m)=>m.applianceId === metrics?.applianceId && m.inputId === metrics.inputId && m.type === metrics.type);
        for (const m of channelGroupMirrors)if (m.sendPacketrate > metrics?.sendBitrate) metrics = m;
    }
    return metrics;
}
function findUdpOutputMetrics({ logicalPort, portAppliance, ristMetrics, streamId }, output) {
    const isVaOutput = portAppliance && (0, _applianceTypeUtil.isVaApplianceType)(portAppliance.type);
    if (isVaOutput) // VAs have their own UDP outputs (udpSrc) - the handover to them is made over RTP (an UDP output with packetFormat=RTP is added to the ristserver)
    // - so a "rtpOutputInfo handover" section should be displayed instead
    return null;
    const isSrtBondedOutput = logicalPort?.mode === (0, _types.IpPortMode).srt && logicalPort?.srtMode !== (0, _types.SrtMode).rendezvous && typeof logicalPort?.failoverPriority === 'number';
    const ristServerOutputStreamId = isSrtBondedOutput ? (0, _minDefault.default)(output.ports.map((p)=>p.internalStreamId)) : streamId;
    const egressMetrics = ristMetrics.filter((0, _helpers.isUdpOutputMetrics)).filter((m)=>m.isEgress);
    if (egressMetrics.length === 0) return null;
    const metrics = findActiveOutputInGroupByStreamId(egressMetrics, ristServerOutputStreamId);
    if (!metrics && !portModesWithUdpMetrics.includes(logicalPort.mode)) // This is likely to be an upgraded appliance that should not have udp info
    // It will however potentially miss issues where unupdated appliances are missing udp metrics for some reason
    return null;
    return metrics;
}
function udpOutputInfo({ logicalPort, portAppliance, ristMetrics, connectionDetails, streamId }, output) {
    const metrics = findUdpOutputMetrics({
        logicalPort,
        portAppliance,
        ristMetrics,
        connectionDetails,
        streamId
    }, output);
    if (!metrics) return null;
    return udpOutputInfoTable(metrics, logicalPort?.mode === (0, _types.IpPortMode).udp ? connectionDetails : undefined);
}
function udpOutputInfoTable(metrics, connectionDetails) {
    const metric = (0, _utils1.makeFormatter)(metrics);
    return {
        'Send bitrate': metric((s)=>(0, _helpers.formatBitrate)(s.sendBitrate)),
        'Packet rate': metric((s)=>Math.round(s.sendPacketrate)),
        'Packets lost': metric((s)=>s.packetsLost),
        'Packets dropped': metric((s)=>s.packetsDropped),
        'Playout margin': metric((s)=>(0, _utils1.applyUnit)(s.playoutMarginMs, 'ms')),
        'Internal Stream ID': metric((s)=>s.streamId),
        'Internal Channel ID': metric((s)=>s.channelId),
        ...connectionDetails ?? {}
    };
}
function unixOutputInfo({ logicalPort, ristMetrics, connectionDetails, streamId, portAppliance }) {
    const portApplianceType = portAppliance?.type;
    const portModesWithUnixOutput = [
        (0, _types.IpcPortMode).unix
    ];
    const applianceUsesUnixHandover = portApplianceType && !(0, _applianceTypeUtil.isVaApplianceType)(portApplianceType) && !(0, _applianceTypeUtil.isMatroxApplianceType)(portApplianceType);
    if (!applianceUsesUnixHandover || !portModesWithUnixOutput.includes(logicalPort.mode)) return null;
    const matchingEgressMetrics = ristMetrics.filter((m)=>m.isEgress).filter((m)=>m.streamId === streamId);
    // TODO: remove this when all appliances are upgraded with unix socket support
    // (it ensures that we will not show double handover information for unupgraded appliances)
    const metrics = matchingEgressMetrics?.find((0, _helpers.isUnixOutputMetrics));
    if (matchingEgressMetrics?.[0] && !metrics) return null;
    const metric = (0, _utils1.makeFormatter)(metrics);
    return {
        'Send bitrate': metric((s)=>(0, _helpers.formatBitrate)(s.sendBitrate)),
        'Packet rate': metric((s)=>Math.round(s.sendPacketrate)),
        'Playout margin': metric((s)=>(0, _utils1.applyUnit)(s.playoutMarginMs, 'ms')),
        'Internal Stream ID': metric((s)=>s.streamId),
        'Internal Channel ID': metric((s)=>s.channelId),
        ...logicalPort.mode === (0, _types.IpcPortMode).unix ? connectionDetails : {}
    };
}
function rtmpInputInfo({ logicalPort, streamId, ristMetrics, connectionDetails }) {
    if (logicalPort && logicalPort.mode !== (0, _types.IpPortMode).rtmp) return null;
    const metrics = ristMetrics.filter((0, _helpers.isRtmpInputMetric)).find((metric)=>metric.streamId === streamId);
    return {
        'Receive bitrate': (0, _helpers.formatBitrate)(metrics ? metrics.receiveBitrateKbps * 1000 : null),
        ...connectionDetails
    };
}
function rtmpOutputInfo({ logicalPort, streamId, ristMetrics, connectionDetails }) {
    if (logicalPort.mode !== (0, _types.IpPortMode).rtmp) return null;
    const metrics = ristMetrics.filter((0, _helpers.isRtmpOutputMetric)).find((metric)=>metric.streamId === streamId);
    const metric = (0, _utils1.makeFormatter)(metrics);
    return {
        Restarts: metric((s)=>s.restartCount),
        'Send bitrate': metric((s)=>(0, _helpers.formatBitrate)(s.sendBitrateKbps * 1000)),
        ...connectionDetails
    };
}
function unixInputInfo({ logicalPort, streamId, ristMetrics, connectionDetails, portAppliance }) {
    const portModesWithUnixInput = [
        (0, _types.IpcPortMode).unix
    ];
    const isVa = portAppliance && (0, _applianceTypeUtil.isVaApplianceType)(portAppliance.type);
    if (logicalPort && !portModesWithUnixInput.includes(logicalPort.mode) || isVa) return null;
    const unixReceiveMetrics = ristMetrics.filter((0, _helpers.isUnixInputMetrics)).find((metric)=>metric.streamId === streamId);
    if (!unixReceiveMetrics) return null;
    // TODO: remove this when all appliances support unix sockets
    const udpReceiveMetrics = ristMetrics.filter((0, _helpers.isUdpInputMetrics)).find((metric)=>metric.streamId === streamId);
    if (udpReceiveMetrics) return null;
    const receiveMetric = (0, _utils1.makeFormatter)(unixReceiveMetrics);
    return {
        'Receive bitrate': receiveMetric((s)=>(0, _helpers.formatBitrate)(s.receiveBitrate)),
        'Packet rate': receiveMetric((s)=>Math.round(s.receivePacketrate)),
        'Packets discarded during standby': receiveMetric((s)=>s.packetsWhileInactive),
        'Internal Stream ID': receiveMetric((s)=>s?.streamId),
        'Internal Channel ID': receiveMetric((s)=>s.channelId),
        Status: receiveMetric((s)=>s?.status),
        ...connectionDetails
    };
}
function udpInputInfo({ logicalPort, streamId, ristMetrics, connectionDetails }) {
    const isSrtBondedInput = logicalPort?.mode === (0, _types.IpPortMode).srt && logicalPort?.srtMode !== (0, _types.SrtMode).rendezvous && typeof logicalPort?.failoverPriority === 'number';
    const isUdpInputWithRtpFormat = logicalPort && isUdpInputPortWithRtpFormat(logicalPort);
    const receiveMetrics = isUdpInputWithRtpFormat ? undefined : ristMetrics.filter((0, _helpers.isUdpInputMetrics)).find((metric)=>metric.streamId === streamId || isSrtBondedInput);
    if (logicalPort?.mode === (0, _types.MatroxPortMode).matroxSdi) // Matrox input handover uses RTP
    return null;
    if (logicalPort && !portModesWithUdpMetrics.includes(logicalPort.mode) && !receiveMetrics) return null;
    const receiveMetric = (0, _utils1.makeFormatter)(receiveMetrics);
    return {
        'Receive bitrate': receiveMetric((s)=>(0, _helpers.formatBitrate)(s.receiveBitrate)),
        'Packet rate': receiveMetric((s)=>Math.round(s.receivePacketrate)),
        'Malformed packets discarded': receiveMetric((s)=>s.packetsDiscarded),
        'Packets discarded during standby': receiveMetric((s)=>s.packetsWhileInactive),
        'Internal Stream ID': receiveMetric((s)=>s?.streamId),
        'Internal Channel ID': receiveMetric((s)=>s.channelId),
        Status: receiveMetric((s)=>s?.status),
        ...logicalPort && logicalPort.mode === (0, _types.IpPortMode).udp ? connectionDetails : {}
    };
}
function rtpInputInfo({ logicalPort, streamId, ristMetrics, connectionDetails, portAppliance }) {
    const isVaApplianceInput = !!portAppliance && (0, _applianceTypeUtil.isVaApplianceType)(portAppliance.type);
    if (!isVaApplianceInput && logicalPort && !inputPortHasRtpMetrics(logicalPort)) return null;
    const isRtpInputMetricsOrUdpInputMetrics = (m)=>(0, _helpers.isRtpInputMetrics)(m) || isUdpInputWithFormatRtp && (0, _helpers.isUdpInputMetrics)(m);
    const isUdpInputWithFormatRtp = !!logicalPort && isUdpInputPortWithRtpFormat(logicalPort);
    const receiveMetrics = ristMetrics.filter(isRtpInputMetricsOrUdpInputMetrics).find((metric)=>metric.streamId === streamId);
    if (isVaApplianceInput && !receiveMetrics) // TODO: Remove this when all VA inputs have likely moved
    // over to RTP for handover
    return null;
    const useFec = logicalPort && isRtpInputPort(logicalPort) && logicalPort.fec;
    const receiveMetric = (0, _utils1.makeFormatter)(receiveMetrics);
    return {
        'Receive bitrate': receiveMetric((s)=>(0, _helpers.formatBitrate)(s.receiveBitrate)),
        'Packet rate': receiveMetric((s)=>Math.round(s.receivePacketrate)),
        'Packets discarded': receiveMetric((s)=>s.packetsDiscarded),
        ...receiveMetrics && (0, _helpers.isRtpInputMetrics)(receiveMetrics) ? {
            SSRC: typeof receiveMetrics.ssrc === 'number' ? receiveMetrics.ssrc.toString() : 'N/A',
            ...useFec ? {
                'FEC packet rate': receiveMetrics.fecReceivePacketrate ? Math.round(receiveMetrics.fecReceivePacketrate).toString() : 'N/A',
                'Packets recovered last 10s': typeof receiveMetrics.packetsRecovered === 'number' ? receiveMetrics.packetsRecovered.toString() : 'N/A',
                'Unrecovered packet rate': typeof receiveMetrics.unrecoveredPacketrate === 'number' ? receiveMetrics.unrecoveredPacketrate.toFixed(1).toString() : 'N/A'
            } : {},
            'Packet loss': receiveMetrics.receivePacketrate > 0 && typeof receiveMetrics.lostPacketrate === 'number' ? (100 * receiveMetrics.lostPacketrate / (receiveMetrics.lostPacketrate + receiveMetrics.receivePacketrate)).toFixed(1) + '%' : 'N/A'
        } : {},
        'Internal Stream ID': receiveMetric((s)=>s.streamId),
        'Internal Channel ID': receiveMetric((s)=>s.channelId),
        ...isVaApplianceInput ? {} : connectionDetails
    };
}
function derivedInputInfo({ streamId, ristMetrics }, deriveFrom) {
    if (!deriveFrom || !deriveFrom.ingestTransform || deriveFrom.ingestTransform.type !== 'mpts-demux') return null;
    const receiveMetrics = ristMetrics.filter((0, _helpers.isMptsMetrics)).find((metric)=>metric.streamId === streamId);
    const receiveMetric = (0, _utils1.makeFormatter)(receiveMetrics);
    return {
        'Udp packets': receiveMetric((s)=>s.udpPackets),
        'Udp packet rate': receiveMetric((s)=>Math.round(s.udpPacketsRate)),
        'Ts packets': receiveMetric((s)=>s.tsPackets),
        'Ts packet rate': receiveMetric((s)=>Math.round(s.tsPacketsRate))
    };
}
function rtpOutputInfo({ logicalPort, ristMetrics, connectionDetails, streamId, portAppliance }) {
    const portApplianceType = portAppliance?.type;
    const isVaApplianceOutput = !!portApplianceType && (0, _applianceTypeUtil.isVaApplianceType)(portApplianceType);
    if (!isVaApplianceOutput && !outputPortHasRtpMetrics(logicalPort)) return null;
    const isUdpOrRtpMetrics = (m)=>{
        return (0, _helpers.isRtpOutputMetrics)(m) || (0, _helpers.isUdpOutputMetrics)(m);
    };
    const egressMetrics = ristMetrics.filter(isUdpOrRtpMetrics).filter((m)=>m.isEgress);
    const sendMetrics = egressMetrics ? findActiveOutputInGroupByStreamId(egressMetrics, streamId) : undefined;
    if (isVaApplianceOutput && !sendMetrics) // TODO: remove this when all VA outputs
    // have moved to RTP for handover
    return null;
    const sendMetric = (0, _utils1.makeFormatter)(sendMetrics);
    const bufferedOutputMetrics = (0, _utils1.makeFormatter)(sendMetrics);
    const bufferedRtpOutputDetails = sendMetrics && (0, _helpers.isUdpOutputMetrics)(sendMetrics) ? {
        'Packets dropped': bufferedOutputMetrics((s)=>s.packetsDropped),
        'Playout margin': bufferedOutputMetrics((s)=>(0, _utils1.applyUnit)(s.playoutMarginMs, 'ms'))
    } : {};
    return {
        'Send bitrate': sendMetric((s)=>(0, _helpers.formatBitrate)(s.sendBitrate)),
        'Packet rate': sendMetric((s)=>Math.round(s.sendPacketrate)),
        'Packets lost': sendMetric((s)=>s.packetsLost),
        ...bufferedRtpOutputDetails,
        'Internal Stream ID': sendMetric((s)=>s.streamId),
        'Internal Channel ID': sendMetric((s)=>s.channelId),
        ...connectionDetails
    };
}
function ristInputInfo({ logicalPort, streamId, ristMetrics, connectionDetails }) {
    if (logicalPort && logicalPort.mode !== (0, _types.IpPortMode).rist) return null;
    const receiveMetrics = ristMetrics.filter((0, _helpers.isRistSimpleProfileInputMetrics)).find((metric)=>metric.streamId === streamId);
    const receiveMetric = (0, _utils1.makeFormatter)(receiveMetrics);
    return {
        'Receive bitrate': receiveMetric((s)=>(0, _helpers.formatBitrate)(s.receiveBitrate)),
        'Packet rate': receiveMetric((s)=>Math.round(s.receivePacketrate)),
        'Packet send errors': receiveMetric((s)=>s.packetSendErrors),
        'Packets discarded': receiveMetric((s)=>s.packetsDiscarded),
        'Retransmission bitrate': receiveMetric((s)=>(0, _helpers.formatBitrate)(s.retransmitReceiveBitrate)),
        'Retransmission packet rate': receiveMetric((s)=>Math.round(s.retransmitReceivePacketrate)),
        Roundtrip: receiveMetric((s)=>(0, _utils1.applyUnit)(s.roundtripMs, 'ms')),
        'Propagation delay': receiveMetric((s)=>(0, _utils1.applyUnit)(s.propagationDelayMs, 'ms')),
        'Packets lost': receiveMetric((s)=>s.packetsLost),
        'Longest burst loss': receiveMetric((s)=>s.longestBurstLoss),
        'RTP packets received': receiveMetric((s)=>s.rtpPacketsReceived),
        'Malformed RTCP Packets Received': receiveMetric((s)=>s.malformedRtcpPacketsReceived),
        'Unsupported RTCP Packets Received': receiveMetric((s)=>s.unsupportedRtcpPacketsReceived),
        'Internal Stream ID': receiveMetric((s)=>s.streamId),
        'Internal Channel ID': receiveMetric((s)=>s.channelId),
        ...connectionDetails
    };
}
function ristOutputInfo({ logicalPort, streamId, ristMetrics, connectionDetails }) {
    if (logicalPort.mode !== (0, _types.IpPortMode).rist) return null;
    const receiveMetrics = ristMetrics.filter((0, _helpers.isRistSimpleProfileOutputMetrics)).find((metric)=>metric.streamId === streamId);
    const sendMetric = (0, _utils1.makeFormatter)(receiveMetrics);
    return {
        'Send bitrate': sendMetric((s)=>(0, _helpers.formatBitrate)(s.sendBitrate)),
        'Packet rate': sendMetric((s)=>Math.round(s.sendPacketrate)),
        'Packet send errors': sendMetric((s)=>s.packetSendErrors),
        'Retransmission bitrate': (0, _helpers.formatBitrate)(sendMetric((s)=>s.retransmitSendBitrate)),
        'Retransmission packet rate': sendMetric((s)=>Math.round(s.retransmitSendPacketrate)),
        'RTP packets sent': sendMetric((s)=>s.rtpPacketsSent),
        'Reported packet loss': sendMetric((s)=>(0, _utils1.applyUnit)(s.reportedPacketLossPercent, '%')),
        Roundtrip: sendMetric((s)=>(0, _utils1.applyUnit)(s.roundtripMs, 'ms')),
        'RTCP receive packet rate': sendMetric((s)=>Math.round(s.rtcpReceivePacketrate)),
        'Malformed RTCP Packets Received': sendMetric((s)=>s.malformedRtcpPacketsReceived),
        'Unsupported RTCP Packets Received': sendMetric((s)=>s.unsupportedRtcpPacketsReceived),
        'Internal Stream ID': sendMetric((s)=>s.streamId),
        'Internal Channel ID': sendMetric((s)=>s.channelId),
        ...connectionDetails
    };
}
function zixiInputInfo({ logicalPort, streamId, ristMetrics, connectionDetails }) {
    if (logicalPort && logicalPort.mode !== (0, _types.IpPortMode).zixi) return null;
    const zixiInputMetrics = ristMetrics.filter((0, _helpers.isZixiInputMetrics)).find((metric)=>metric.streamId === streamId);
    const receiveMetric = (0, _utils1.makeFormatter)(zixiInputMetrics);
    return {
        'Zixi bitrate': receiveMetric((m)=>(0, _helpers.formatBitrate)(m.bitrate)),
        'Zixi connection': receiveMetric((m)=>m.connectionStatus),
        ...connectionDetails
    };
}
function zixiOutputInfo({ logicalPort, ristMetrics, streamId, connectionDetails }) {
    if (logicalPort.mode !== (0, _types.IpPortMode).zixi) return null;
    const receiveMetrics = ristMetrics.filter((0, _helpers.isZixiOutputMetric)).find((metric)=>metric.streamId === streamId);
    const receiveMetric = (0, _utils1.makeFormatter)(receiveMetrics);
    const formatMs = (t)=>t !== undefined ? t + ' ms' : undefined;
    if (receiveMetrics?.sinkStats) // Zixi Receiver/Feeder. Delete once we have migrated to zixi_boradcaster (R3.24)
    return {
        'Zixi bitrate': receiveMetric((m)=>m.sinkStats?.outBitrate),
        'Zixi connection': receiveMetric((m)=>m.connectionStatus),
        'Zixi rtt': receiveMetric((m)=>m.sinkStats?.rtt),
        'Zixi jitter': receiveMetric((m)=>m.sinkStats?.jitter),
        'Zixi packets': receiveMetric((m)=>m.sinkStats?.totalPackets),
        'Zixi packet rate': receiveMetric((m)=>m.sinkStats?.packetRate),
        'Zixi dropped': receiveMetric((m)=>m.sinkStats?.droppedPackets),
        'Zixi recovered': receiveMetric((m)=>m.sinkStats?.recoveredPackets),
        'Zixi not recovered': receiveMetric((m)=>m.sinkStats?.notRecoveredPackets),
        'Zixi failed sends': receiveMetric((m)=>m.sinkStats?.failedSends),
        'Zixi FEC packets': receiveMetric((m)=>m.sinkStats?.fecPackets),
        'Zixi ARQ requests': receiveMetric((m)=>m.sinkStats?.arqRequests),
        'Zixi ARQ recovered': receiveMetric((m)=>m.sinkStats?.arqRecovered),
        'Zixi ARQ duplicates': receiveMetric((m)=>m.sinkStats?.arqDuplicates),
        'Zixi overflows': receiveMetric((m)=>m.sinkStats?.overflows),
        ...connectionDetails
    };
    else // Zixi broadcaster
    return {
        'Zixi connection': receiveMetric((m)=>m.connectionStatus),
        'Zixi bitrate': receiveMetric((m)=>(0, _helpers.formatBitrate)(m.zixiBitrate)),
        'Zixi rtt': receiveMetric((m)=>formatMs(m.rtt)),
        'Zixi jitter': receiveMetric((m)=>formatMs(m.jitter)),
        'Zixi packets': receiveMetric((m)=>m.packets),
        'Zixi packet rate': receiveMetric((m)=>m.packetRate),
        'Zixi dropped packets': receiveMetric((m)=>m.droppedPackets),
        'Zixi duplicate packets': receiveMetric((m)=>m.duplicatePackets),
        'Zixi send packet rate': receiveMetric((m)=>m.sendPacketRate),
        'Zixi ARQ recovered packets': receiveMetric((m)=>m.arqRecoveredPackets),
        'Zixi ARQ lost packets': receiveMetric((m)=>m.arqLostPackets),
        'Zixi ARQ duplicate packets': receiveMetric((m)=>m.arqDuplicatePackets),
        'Zixi ARQ overflowed packets': receiveMetric((m)=>m.arqOverflowedPackets),
        'Zixi FEC sent packets': receiveMetric((m)=>m.fecSentPackets),
        'Zixi FEC received packets': receiveMetric((m)=>m.fecReceivedPackets),
        'Zixi FEC recovered packets': receiveMetric((m)=>m.fecRecoveredPackets),
        ...connectionDetails
    };
}
function srtInputInfo({ logicalPort, streamId, ristMetrics, connectionDetails }) {
    if (logicalPort && logicalPort.mode !== (0, _types.IpPortMode).srt) return null;
    const srtInputMetrics = ristMetrics.filter((0, _helpers.isSrtInputMetric)).find((metric)=>metric.streamId === streamId);
    const receiveMetric = (0, _utils1.makeFormatter)(srtInputMetrics);
    return {
        'SRT connection status': receiveMetric((m)=>m.connectionStatus),
        'SRT bitrate': receiveMetric((m)=>(0, _helpers.formatBitrate)(m.bitrate)),
        'SRT rtt': receiveMetric((m)=>(0, _utils1.applyUnit)(m.rtt, 'ms')),
        'SRT packets lost': receiveMetric((m)=>m.packetsLost),
        'SRT packets dropped': receiveMetric((m)=>m.packetsDropped),
        'SRT packets retransmitted': receiveMetric((m)=>m.packetsRetransmitted),
        // TODO: re-add this stat when it is available
        // 'SRT receive buffer, acknowledged': receiveMetric((m) => applyUnit(m.msRecvBuffer, 'ms')),
        'Internal Stream ID': receiveMetric((s)=>s.streamId),
        'Remote address': receiveMetric((m)=>m.remoteAddress),
        ...connectionDetails
    };
}
function srtOutputInfo({ logicalPort, streamId, ristMetrics, connectionDetails }) {
    if (logicalPort.mode !== (0, _types.IpPortMode).srt) return null;
    const srtOutputMetrics = ristMetrics.filter((0, _helpers.isSrtOutputMetric)).find((metric)=>metric.streamId === streamId);
    const receiveMetric = (0, _utils1.makeFormatter)(srtOutputMetrics);
    const srtInfo = {
        'SRT connection status': receiveMetric((m)=>m.connectionStatus),
        'SRT bitrate': receiveMetric((m)=>(0, _helpers.formatBitrate)(m.bitrate)),
        'SRT rtt': receiveMetric((m)=>(0, _utils1.applyUnit)(m.rtt, 'ms')),
        'SRT packets dropped': receiveMetric((m)=>m.packetsDropped),
        'SRT packets retransmitted': receiveMetric((m)=>m.packetsRetransmitted),
        'SRT send buffer, unacknowledged': receiveMetric((m)=>(0, _utils1.applyUnit)(m.msSendBuffer, 'ms')),
        'Internal Stream ID': receiveMetric((s)=>s.streamId),
        ...connectionDetails
    };
    if (srtOutputMetrics?.remoteAddress) srtInfo['Remote address'] = receiveMetric((m)=>m.remoteAddress);
    return srtInfo;
}
function getInputConnectionDetails(input, logicalPortId) {
    const inputPorts = input.ports;
    if (!inputPorts?.length) return undefined;
    const port = logicalPortId ? inputPorts.find((port)=>port.id === logicalPortId) || inputPorts[0] : inputPorts[0];
    const ports = logicalPortId ? [
        port
    ] : inputPorts;
    switch(port.mode){
        case (0, _types.IpPortMode).rtmp:
        case (0, _types.IpPortMode).rist:
        case (0, _types.IpPortMode).generator:
            return makeServerConnectionDetails(ports.map((port)=>({
                    listenAddress: port.address,
                    listenPort: port.port
                })));
        case (0, _types.IpPortMode).udp:
            return makeServerConnectionDetails(ports.map((port)=>({
                    listenAddress: port.address,
                    listenPort: port.port,
                    multicastGroupAddress: port.multicastAddress,
                    multicastSource: port.multicastSource
                })));
        case (0, _types.IpPortMode).rtp:
            return makeServerConnectionDetails(ports.map((port)=>({
                    listenAddress: port.address,
                    listenPort: port.port,
                    multicastGroupAddress: port.multicastAddress,
                    multicastSource: port.multicastSource
                })));
        case (0, _types.IpPortMode).srt:
            switch(port.srtMode){
                case (0, _types.SrtMode).caller:
                    return makeClientConnectionDetails(ports.map((port)=>({
                            fromPort: port.localPort,
                            toAddress: port.remoteIp,
                            toPort: port.remotePort
                        })));
                case (0, _types.SrtMode).listener:
                    return makeServerConnectionDetails(ports.map((port)=>({
                            listenAddress: port.localIp,
                            listenPort: port.localPort
                        })));
                case (0, _types.SrtMode).rendezvous:
                    return {
                        ...makeClientConnectionDetails(ports.map((port)=>({
                                fromAddress: port.localIp,
                                fromPort: port.remotePort,
                                toAddress: port.remoteIp,
                                toPort: port.remotePort
                            }))),
                        ...makeServerConnectionDetails(ports.map((port)=>({
                                listenAddress: port.localIp,
                                listenPort: port.remotePort
                            }))),
                        'Connection type': 'Client and server'
                    };
            }
        case (0, _types.IpPortMode).zixi:
            switch(port.zixiMode){
                case (0, _types.ZixiMode).pull:
                    return makeClientConnectionDetails(ports.flatMap((port)=>[
                            port.remotePrimaryIp,
                            port.remoteSecondaryIp
                        ].filter(Boolean).map((toAddress)=>({
                                fromAddress: port.localIp,
                                toAddress,
                                toPort: port.pullPort
                            }))));
                case (0, _types.ZixiMode).push:
                    // Note: zixi push inputs can only be set up on VA:s. It is not possible
                    // to specify 'listenAddress' or 'listenPort' per input - this information
                    // is configured on the associated VA and must be retrieved via the OAM api.
                    return makeServerConnectionDetails([]);
            }
        case (0, _types.CoaxPortMode).asi:
        case (0, _types.CoaxPortMode).sdi:
            return undefined;
    }
}
function getOutputConnectionDetails(output, logicalPortId) {
    const outputPorts = output.ports;
    if (!outputPorts?.length) return undefined;
    const port = logicalPortId ? outputPorts.find((port)=>port.id === logicalPortId) : outputPorts[0];
    const ports = logicalPortId ? [
        port
    ] : outputPorts;
    if (!port) return undefined;
    switch(port.mode){
        case (0, _types.IpPortMode).udp:
            return makeClientConnectionDetails(ports.map((port)=>({
                    fromAddress: port.sourceAddress,
                    fromPort: port.localPort,
                    toAddress: port.address,
                    toPort: port.port
                })));
        case (0, _types.IpPortMode).rist:
            return makeClientConnectionDetails(ports.map((port)=>({
                    fromAddress: port.sourceAddress,
                    fromPort: port.localPort,
                    toAddress: port.address,
                    toPort: port.port
                })));
        case (0, _types.IpPortMode).rtp:
            return makeClientConnectionDetails(ports.map((port)=>({
                    fromAddress: port.sourceAddress,
                    fromPort: port.localPort,
                    toAddress: port.address,
                    toPort: port.port
                })));
        case (0, _types.IpPortMode).rtmp:
            return makeClientConnectionDetails(ports.map((port)=>({
                    toAddress: port.rtmpDestinationAddress
                })));
        case (0, _types.IpPortMode).srt:
            switch(port.srtMode){
                case (0, _types.SrtMode).caller:
                    return makeClientConnectionDetails(ports.map((port)=>({
                            fromPort: port.localPort,
                            toAddress: port.remoteIp,
                            toPort: port.remotePort
                        })));
                case (0, _types.SrtMode).listener:
                    return makeServerConnectionDetails(ports.map((port)=>({
                            listenAddress: port.localIp,
                            listenPort: port.localPort
                        })));
                case (0, _types.SrtMode).rendezvous:
                    return {
                        ...makeClientConnectionDetails(ports.map((port)=>({
                                fromAddress: port.localIp,
                                fromPort: port.remotePort,
                                toAddress: port.remoteIp,
                                toPort: port.remotePort
                            }))),
                        ...makeServerConnectionDetails(ports.map((port)=>({
                                listenAddress: port.localIp,
                                listenPort: port.remotePort
                            }))),
                        'Connection type': 'Client and server'
                    };
            }
        case (0, _types.IpPortMode).zixi:
            switch(port.zixiMode){
                case (0, _types.ZixiMode).pull:
                    // Note: zixi pull outputs can only be set up on VA:s. It is not possible
                    // to specify 'listenAddress' or 'listenPort' per input - this information
                    // is configured on the associated VA and must be retrieved via the OAM api.
                    return makeServerConnectionDetails([]);
                case (0, _types.ZixiMode).push:
                    return makeClientConnectionDetails(ports.flatMap((port)=>[
                            port.linkSet1,
                            port.linkSet2
                        ].flat().filter(Boolean).map((zixiLink)=>({
                                fromAddress: zixiLink.localIp,
                                toAddress: zixiLink.remoteIp,
                                toPort: zixiLink.remotePort
                            }))));
            }
        case (0, _types.CoaxPortMode).asi:
        case (0, _types.CoaxPortMode).sdi:
            return undefined;
    }
}
function makeClientConnectionDetails(entries) {
    const fromEntries = Array.from(new Set(entries.map(({ fromAddress, fromPort })=>{
        if (fromAddress && fromPort) return `${fromAddress}:${fromPort}`;
        else if (fromAddress) return fromAddress;
        else if (fromPort) return `port ${fromPort}`;
        return undefined;
    }).filter(Boolean)));
    const toEntries = Array.from(new Set(entries.map(({ toAddress, toPort })=>{
        if (toAddress && toPort) return `${toAddress}:${toPort}`;
        else if (toAddress) return toAddress;
        else if (toPort) return `port ${toPort}`;
        return undefined;
    }).filter(Boolean)));
    return {
        'Connection type': 'Client',
        ...fromEntries.length ? {
            'Connecting from': fromEntries.join(', ')
        } : undefined,
        ...toEntries.length ? {
            'Connecting to': toEntries.join(', ')
        } : undefined
    };
}
function makeServerConnectionDetails(entries) {
    const listenEntries = Array.from(new Set(entries.map(({ listenAddress, listenPort })=>{
        if (listenAddress && listenPort) return `${listenAddress}:${listenPort}`;
        else if (listenAddress) return listenAddress;
        else if (listenPort) return `port ${listenPort}`;
        return undefined;
    }).filter(Boolean)));
    const multicastEntries = Array.from(new Set(entries.map(({ multicastGroupAddress, multicastSource })=>{
        if (multicastGroupAddress && multicastSource) return `${multicastGroupAddress} (source: ${multicastSource})`;
        else if (multicastGroupAddress) return multicastGroupAddress;
        return undefined;
    }).filter(Boolean)));
    return {
        'Connection type': 'Server',
        ...listenEntries.length ? {
            'Listening on': listenEntries.join(', ')
        } : undefined,
        ...multicastEntries.length ? {
            [(0, _utils.pluralizeWord)(multicastEntries.length, 'Multicast group')]: multicastEntries.join(', ')
        } : undefined
    };
}
function makeApplianceHealthInfo(appliance) {
    return 'health' in appliance ? {
        Status: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.ServiceOverviewApplianceHealthIndicator), {
            applianceId: appliance.id,
            inline: true
        })
    } : undefined;
}
function makeApplianceAlarmsInfo(appliance, user, routes) {
    return 'alarms' in appliance && (0, _utils.hasAccessToAppliance)(appliance, user) ? {
        Alarms: appliance.alarms.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            to: routes.alarms({
                applianceId: appliance.id,
                applianceName: appliance.name
            }),
            underline: "hover",
            children: (0, _utils.pluralize)(appliance.alarms.length, 'alarm')
        }) : 'No alarms present'
    } : undefined;
}
function applianceOverviewLink(applianceName) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ExternalLink), {
        href: `/grafana/d/appliance-overview/appliance-overview?orgId=1&from=now-1h&to=now&refresh=10s&var-appliance=${applianceName}`,
        underline: "always",
        style: {
            marginRight: '12px'
        },
        children: "Appliance Overview"
    });
}
const InputPortInfo = ({ selected })=>{
    const { input, parent } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input,
            parent: serviceOverviewReducer.parent
        }), (0, _reactRedux.shallowEqual));
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const navigate = (0, _reactRouter.useNavigate)();
    const selectedInput = selected?.type === (0, _types.GraphNodeType).inputLogicalPort ? input : selected?.type === (0, _types.GraphNodeType).parentInputLogicalPort ? parent : undefined;
    if (!selectedInput) return null;
    const isDerivedInput = !!selectedInput.deriveFrom;
    const logicalPort = isDerivedInput ? undefined : selectedInput.ports?.find((port)=>port.id === selected.id);
    if (!isDerivedInput && !logicalPort) return null;
    const applianceId = selected.data?.meta?.applianceId;
    if (!applianceId) return null;
    const portAppliance = selectedInput.appliances?.find((a)=>a.id === applianceId);
    if (!portAppliance) return null;
    const channelId = selected.data?.meta?.channelId;
    if (channelId === undefined) return null;
    const isSuperUser = user.role === (0, _types.Role).super;
    const metricsLinks = isSuperUser ? [
        {
            text: 'RIST Overview',
            url: `/grafana/d/rist-overview/rist-overview?orgId=1&refresh=10s&from=now-15m&to=now&var-input=${selectedInput.id}&var-type=All&var-applianceName=All`
        },
        {
            text: 'TR 101 290',
            url: `/grafana/d/tr-101-290/tr-101-290?orgId=1&refresh=10s&from=now-15m&to=now&var-input=${selectedInput.id}&var-applianceName=All`
        }
    ] : [];
    const isVaApplianceInput = (0, _applianceTypeUtil.isVaApplianceType)(portAppliance.type);
    if (isSuperUser && !isVaApplianceInput && logicalPort?.mode === (0, _types.IpPortMode).srt) metricsLinks.push({
        text: 'SRT Overview',
        url: `/grafana/d/srt-overview/srt-overview?orgId=1&refresh=10s&from=now-15m&to=now&var-input=${selectedInput.id}&var-type=All&var-applianceName=All`
    });
    if (isSuperUser && !isVaApplianceInput && logicalPort?.mode === (0, _types.IpPortMode).rtmp) metricsLinks.push({
        text: 'RTMP Overview',
        url: `/grafana/d/rtmp-overview/rtmp-overview?orgId=1&refresh=10s&from=now-15m&to=now&var-input=${selectedInput.id}&var-type=All&var-applianceName=All`
    });
    if (isSuperUser && !isVaApplianceInput && selectedInput.deriveFrom?.ingestTransform?.type === 'transcode') metricsLinks.push({
        text: 'Transcoding Overview',
        url: `/grafana/d/transcode-overview/transcode-overview?orgId=1&refresh=10s&from=now-15m&to=now&var-input=${selectedInput.id}&var-type=All&var-appliance=${portAppliance.id}`
    });
    const metricsLink = metricsLinks.length > 0 ? {
        Metrics: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: metricsLinks.map(({ url, text })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ExternalLink), {
                    href: url,
                    underline: "always",
                    style: {
                        marginRight: '12px'
                    },
                    children: text
                }, url))
        })
    } : {};
    const isInputOwner = user.group === selectedInput.owner || user.role === (0, _types.Role).super;
    const tsInfos = selectedInput.tsInfo?.filter((ts)=>portAppliance.id === ts.applianceId && ts.channelId === channelId);
    const formatString = tsInfos?.map((tsInfo)=>(0, _helpers.getFormattedTransportStreamContent)(tsInfo)).join(', ') || 'N/A';
    const title = isDerivedInput ? 'Transformation' : `${(0, _utils.inputTypeFromPort)(logicalPort)} input`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        id: "paper-Information",
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
            container: true,
            size: {
                xs: 12
            },
            gap: 5,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                size: {
                    xs: 'auto'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: {
                        Input: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                    underline: "hover",
                                    available: isInputOwner,
                                    to: routes.inputsUpdate({
                                        id: selectedInput.id
                                    }),
                                    children: selectedInput.name
                                }),
                                selectedInput.id !== input?.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                    "aria-label": "service overview button",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        navigate(routes.service({
                                            id: selectedInput.id
                                        }));
                                    },
                                    sx: {
                                        marginTop: '-4px'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                        title: 'Service Overview',
                                        placement: "top",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {})
                                    })
                                })
                            ]
                        }),
                        'Input Status': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.InputHealthIndicator), {
                            status: selectedInput.health,
                            inline: true,
                            disabled: selectedInput.adminStatus === (0, _types.InputAdminStatus).off
                        }),
                        'Channel ID': channelId,
                        Format: formatString,
                        ...getInputConnectionDetails(selectedInput, logicalPort?.id),
                        ...metricsLink
                    }
                })
            })
        })
    });
};
const DerivedInputInfo = ({ selected })=>{
    const { input: _input, derivedInputs } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input,
            derivedInputs: serviceOverviewReducer.derivedInputs
        }), (0, _reactRedux.shallowEqual));
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const navigate = (0, _reactRouter.useNavigate)();
    if (!_input) return null;
    const input = derivedInputs.find((d)=>d.id === selected.id);
    const isInputOwner = user.group === _input.owner || user.role === (0, _types.Role).super;
    const isSuperUser = user.role === (0, _types.Role).super;
    const metricsLinks = isSuperUser ? [
        {
            text: 'RIST Overview',
            url: `/grafana/d/rist-overview/rist-overview?orgId=1&refresh=10s&from=now-15m&to=now&var-input=${input.id}&var-type=All&var-applianceName=All`
        },
        {
            text: 'TR 101 290',
            url: `/grafana/d/tr-101-290/tr-101-290?orgId=1&refresh=10s&from=now-15m&to=now&var-input=${input.id}&var-applianceName=All`
        }
    ] : [];
    const metricsLink = metricsLinks.length > 0 ? {
        Metrics: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: metricsLinks.map(({ url, text })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ExternalLink), {
                    href: url,
                    underline: "always",
                    style: {
                        marginRight: '12px'
                    },
                    children: text
                }, url))
        })
    } : {};
    const inputApplianceIds = input.appliances?.map((appliance)=>appliance.id) || [];
    const tsInfosForApplianceByPrio = (tsInfo)=>tsInfo.filter((info)=>inputApplianceIds.includes(info.applianceId)).sort((a, b)=>input.channelIds.indexOf(a.channelId) - input.channelIds.indexOf(b.channelId));
    const formatTsInfo = (tsInfos)=>tsInfos.map((tsInfo)=>(0, _helpers.getFormattedTransportStreamContent)(tsInfo)).join(', ') || 'N/A';
    const formatString = formatTsInfo(tsInfosForApplianceByPrio(_input?.tsInfo || [])) + " \u2192 " + formatTsInfo(tsInfosForApplianceByPrio(input?.tsInfo || []));
    const title = 'Transformation';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        id: "paper-Information",
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
            container: true,
            size: {
                xs: 12
            },
            gap: 5,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                size: {
                    xs: 'auto'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: {
                        Name: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                    underline: "hover",
                                    available: isInputOwner,
                                    to: routes.inputsUpdate({
                                        id: input.id
                                    }),
                                    children: input.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                    "aria-label": "service overview button",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        navigate(routes.service({
                                            id: input.id
                                        }));
                                    },
                                    sx: {
                                        marginTop: '-4px'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                        title: 'Service Overview',
                                        placement: "top",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {})
                                    })
                                })
                            ]
                        }),
                        Type: 'derived',
                        Status: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.InputHealthIndicator), {
                            status: input.health,
                            inline: true,
                            disabled: input.adminStatus === (0, _types.InputAdminStatus).off
                        }),
                        'Channel IDs': input.channelIds.join(', '),
                        Format: formatString,
                        ...getInputConnectionDetails(input),
                        ...metricsLink
                    }
                })
            })
        })
    });
};
function capitalizePortMode(portMode) {
    if (portMode === undefined) return;
    return portMode === (0, _types.IpPortMode).zixi ? (0, _capitalizeDefault.default)(portMode) : portMode.toUpperCase();
}
function getVaInputPipe(logicalPortId, vaObjects) {
    if (!logicalPortId || !vaObjects) return undefined;
    const objectsForPort = vaObjects.filter((v)=>v.logicalPort === logicalPortId);
    const edgeSource = objectsForPort.find((v)=>v.type === (0, _types.VaObjectInputType).edgeSource);
    if (!edgeSource) return undefined;
    const vaInputPipe = [
        edgeSource
    ];
    let last = edgeSource;
    while(last.inputFrom){
        const prev = objectsForPort.find((o)=>o.name === last.inputFrom);
        if (!prev) return undefined;
        vaInputPipe.unshift(prev);
        last = prev;
    }
    return vaInputPipe;
}
const InputPortStreamInfo = ({ selected })=>{
    const { input } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input
        }), (0, _reactRedux.shallowEqual));
    if (!input) return null;
    function isInputPortData(data) {
        return data?.type === (0, _serviceOverviewGraph.NMGraphLineType).inputPortStream;
    }
    const data = isInputPortData(selected.data) ? selected.data : undefined;
    if (!data) return null;
    const logicalPort = input.ports?.find((port)=>port.id === data.logicalPortId);
    const portAppliance = input.appliances?.find((a)=>a.id === selected.data.toId);
    const portMetadata = {
        logicalPort,
        portAppliance,
        streamId: data.streamId,
        ristMetrics: input.metrics?.ristMetrics ?? [],
        connectionDetails: getInputConnectionDetails(input, data.logicalPortId) ?? {},
        isDerivedInput: !!input.deriveFrom
    };
    const unixInfo = unixInputInfo(portMetadata);
    const udpInfo = udpInputInfo(portMetadata);
    const isVa = !!(portAppliance && (0, _applianceTypeUtil.isVaApplianceType)(portAppliance.type));
    if (portMetadata.isDerivedInput) {
        if (isVa) return null;
        const mptsInfo = derivedInputInfo(portMetadata, input.deriveFrom);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                mptsInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                    title: "MPTS demuxing information",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: mptsInfo
                        })
                    })
                }),
                udpInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                    title: `UDP stream`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: udpInfo
                        })
                    })
                }),
                unixInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                    title: `Unix socket stream`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: unixInfo
                        })
                    })
                })
            ]
        });
    }
    const srtInfo = srtInputInfo(portMetadata);
    const zixiInfo = zixiInputInfo(portMetadata);
    const rtmpInfo = rtmpInputInfo(portMetadata);
    const ristInfo = ristInputInfo(portMetadata);
    const rtpInfo = rtpInputInfo(portMetadata);
    const vaInputPipe = isVa ? getVaInputPipe(data.logicalPortId, input.metrics?.vaObjects) : undefined;
    const showHandoverTooltip = logicalPort && !(0, _helpers.isRistServerPortMode)(logicalPort.mode);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            rtpInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "RTP stream",
                tooltip: showHandoverTooltip ? `The handover from the protocol adapter for ${capitalizePortMode(logicalPort.mode)} uses RTP.` : undefined,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: rtpInfo
                    })
                })
            }),
            !isVa && zixiInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "Zixi stream",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: zixiInfo
                    })
                })
            }),
            !isVa && srtInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "SRT stream",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: srtInfo
                    })
                })
            }),
            !isVa && rtmpInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "RTMP stream",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: rtmpInfo
                    })
                })
            }),
            !isVa && ristInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "RIST stream",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: ristInfo
                    })
                })
            }),
            udpInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: `UDP stream`,
                tooltip: showHandoverTooltip ? `The handover from the protocol adapter for ${capitalizePortMode(logicalPort.mode)} uses UDP.` : undefined,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: udpInfo
                    })
                })
            }),
            unixInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: `Unix socket stream`,
                tooltip: showHandoverTooltip ? `The handover from the protocol adapter for ${capitalizePortMode(logicalPort.mode)} uses Unix domain sockets.` : undefined,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: unixInfo
                    })
                })
            }),
            vaInputPipe && logicalPort && !(0, _helpers.isIpcPortMode)(logicalPort.mode) && !(0, _helpers.isVideonPortMode)(logicalPort.mode) && !(0, _helpers.isMatroxPortMode)(logicalPort.mode) && !(0, _helpers.isComprimatoPortMode)(logicalPort.mode) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: `VA ${logicalPort.mode.toUpperCase()} statistics`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: (0, _vaStatistics.vaInputStatistics)(logicalPort.mode, vaInputPipe)
                })
            })
        ]
    });
};
const DeriveFromInfo = ({ selected })=>{
    const { input: _input, parent } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input,
            parent: serviceOverviewReducer.parent
        }), (0, _reactRedux.shallowEqual));
    if (!_input) return null;
    if (!parent) return null;
    function isInputPortData(data) {
        return data?.type === (0, _serviceOverviewGraph.NMGraphLineType).deriveFrom;
    }
    const data = isInputPortData(selected.data) ? selected.data : undefined;
    if (!data) return null;
    const parentRistMetrics = parent.metrics?.ristMetrics;
    if (!parentRistMetrics) return null;
    const udpOutputMetrics = parentRistMetrics.filter((m)=>m.type === (0, _types.RistMetricType).udpOutput && m.window === (0, _types.MetricWindow).s10).find((m)=>m.streamId === data.streamId);
    if (!udpOutputMetrics) return null;
    const udpInfo = udpOutputInfoTable(udpOutputMetrics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: udpInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
            title: `UDP stream`,
            tooltip: undefined,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: udpInfo
                })
            })
        })
    });
};
const DeriveFromParentInfo = ({ selected })=>{
    const { parentInput } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            parentInput: serviceOverviewReducer.input
        }), (0, _reactRedux.shallowEqual));
    if (!parentInput) return null;
    const data = selected.data;
    // const input = derivedInputs.find(d=>d.id === data.toId)!
    const ristMetrics = parentInput.metrics?.ristMetrics;
    if (!ristMetrics) return null;
    const udpOutputMetrics = ristMetrics.filter((m)=>m.type === (0, _types.RistMetricType).udpOutput && m.window === (0, _types.MetricWindow).s10).find((m)=>m.streamId === data.streamId);
    if (!udpOutputMetrics) return null;
    const udpInfo = udpOutputInfoTable(udpOutputMetrics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: udpInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
            title: `UDP stream`,
            tooltip: undefined,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: udpInfo
                })
            })
        })
    });
};
const InputApplianceInfo = ({ selected })=>{
    const { input, appliances } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input,
            appliances: serviceOverviewReducer.appliances
        }), (0, _reactRedux.shallowEqual));
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const appliance = appliances.find((a)=>a.id === selected.id);
    if (!appliance) return null;
    if (!input) throw new Error('No selected input');
    const inputAppliance = input.appliances[0];
    if (!inputAppliance) throw new Error('No input appliance');
    const metricsLinks = user.role === (0, _types.Role).super ? {
        Metrics: applianceOverviewLink(appliance.name)
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        id: "paper-Information",
        title: "Input appliance",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
            values: {
                Name: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        (0, _utils.hasAccessToAppliance)(appliance, user) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            underline: "hover",
                            to: routes.appliancesUpdate({
                                id: selected.id
                            }),
                            children: appliance.name
                        }) || appliance.name,
                        'features' in appliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _applianceProxyButton.ApplianceProxyButton), {
                            user: user,
                            appliance: appliance,
                            iconButtonProps: {
                                height: 24
                            }
                        })
                    ]
                }),
                Type: appliance.type,
                ...makeApplianceHealthInfo(appliance),
                ...makeApplianceAlarmsInfo(appliance, user, routes),
                ...metricsLinks
            }
        })
    });
};
const CoreNodeInfo = ({ selected })=>{
    const { input, appliances } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input,
            appliances: serviceOverviewReducer.appliances
        }), (0, _reactRedux.shallowEqual));
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    if (!input) return null;
    const appliance = appliances.find((a)=>a.id === selected.id);
    if (!appliance) return null;
    const metricsLinks = user.role === (0, _types.Role).super ? {
        Metrics: applianceOverviewLink(appliance.name)
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        id: "paper-Information",
        title: "Core node",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
            values: {
                Name: (0, _utils.hasAccessToAppliance)(appliance, user) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    underline: "hover",
                    to: routes.appliancesUpdate({
                        id: selected.id
                    }),
                    children: appliance.name
                }) || appliance.name,
                ...makeApplianceHealthInfo(appliance),
                ...makeApplianceAlarmsInfo(appliance, user, routes),
                ...metricsLinks
            }
        })
    });
};
const ThumbNodeInfo = ({ selected })=>{
    const { input, appliances } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input,
            appliances: serviceOverviewReducer.appliances
        }), (0, _reactRedux.shallowEqual));
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    if (!input) return null;
    const appliance = appliances.find((a)=>a.id === selected.id);
    if (!appliance) return null;
    const metricsLinks = user.role === (0, _types.Role).super ? {
        Metrics: applianceOverviewLink(appliance.name)
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        id: "paper-Information",
        title: "Thumb node",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
            values: {
                Name: (0, _utils.hasAccessToAppliance)(appliance, user) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    underline: "hover",
                    to: routes.appliancesUpdate({
                        id: selected.id
                    }),
                    children: appliance.name
                }) || appliance.name,
                ...makeApplianceHealthInfo(appliance),
                ...metricsLinks
            }
        })
    });
};
const OutputApplianceInfo = ({ selected })=>{
    const { appliances } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            appliances: serviceOverviewReducer.appliances
        }), (0, _reactRedux.shallowEqual));
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const appliance = appliances.find(({ id })=>id === selected.id);
    if (!appliance) return null;
    const metricsLinks = user.role === (0, _types.Role).super ? {
        Metrics: applianceOverviewLink(appliance.name)
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        id: "paper-Information",
        title: "Output appliance",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
            values: {
                Name: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        (0, _utils.hasAccessToAppliance)(appliance, user) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            underline: "hover",
                            to: routes.appliancesUpdate({
                                id: selected.id
                            }),
                            children: appliance.name
                        }) || appliance.name,
                        'features' in appliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _applianceProxyButton.ApplianceProxyButton), {
                            user: user,
                            appliance: appliance,
                            iconButtonProps: {
                                height: 24
                            }
                        })
                    ]
                }),
                Type: appliance.type,
                ...makeApplianceHealthInfo(appliance),
                ...makeApplianceAlarmsInfo(appliance, user, routes),
                ...metricsLinks
            }
        })
    });
};
function getApplianceRistMetrics(input, outputs) {
    const ristMetrics = [
        input.metrics?.ristMetrics || [],
        ...outputs.map((o)=>o.metrics?.ristMetrics || [])
    ].flat();
    return ristMetrics;
}
function getConnectionMetrics(input, outputs, from, to) {
    const ristMetrics = getApplianceRistMetrics(input, outputs);
    if (ristMetrics.length === 0) return {
        sendMetrics: undefined,
        receiveMetrics: undefined
    };
    const belongsToConnection = (m)=>{
        return m.clientApplianceId === from && m.serverApplianceId === to || m.serverApplianceId === from && m.clientApplianceId === to;
    };
    const candidateSendMetrics = ristMetrics.filter((m)=>belongsToConnection(m) && (0, _helpers.isRistOutputMetrics)(m) && m.applianceId === from && m.window === (0, _types.MetricWindow).s10);
    const activeChannelId = (0, _utils1.getActiveChannelId)(from, input, outputs);
    // There should be 1 ristOutput per channel.
    // Prefer the one belonging to the active channel, but fallback to the one with the highest sendBitrate if there is no ristOutput of the active channel
    // (e.g. in a multi-appliance setup, if the secondary ingress appliance has a ristInput receiving the primary channel
    // (i.e an output assigned this input is located on the secondary ingress appliance), the "getActiveChannelId()" above
    // will return the primary channel id.
    const sendMetrics = candidateSendMetrics.find((m)=>m.channelId === activeChannelId) ?? candidateSendMetrics.reduce((prev, curr)=>{
        return prev && prev.sendBitrate > curr.sendBitrate ? prev : curr;
    }, undefined);
    // There should be 1 ristInput per channel.
    // Select the one receiving from the ristOutput (i.e. same channel).
    const receiveMetrics = ristMetrics.find((m)=>belongsToConnection(m) && (0, _helpers.isRistInputMetrics)(m) && m.applianceId === to && m.window === (0, _types.MetricWindow).s10 && m.channelId === sendMetrics?.channelId);
    return {
        sendMetrics,
        receiveMetrics
    };
}
const ConnectionInfo = ({ selected })=>{
    const { input, tunnels, appliances } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input,
            tunnels: serviceOverviewReducer.tunnels,
            appliances: serviceOverviewReducer.appliances
        }), (0, _reactRedux.shallowEqual));
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const outputs = (0, _reactRedux.useSelector)(({ outputsReducer })=>outputsReducer.outputs, (0, _reactRedux.shallowEqual));
    if (!input) return null;
    const [from, to] = selected.id.split('>');
    const fromAppliance = appliances.find((a)=>a.id === from);
    const toAppliance = appliances.find((a)=>a.id === to);
    if (!fromAppliance || !toAppliance) return null;
    const { sendMetrics, receiveMetrics } = getConnectionMetrics(input, outputs, from, to);
    const sendMetric = (getter)=>{
        if (!sendMetrics) return 'N/A';
        const val = getter(sendMetrics);
        if (typeof val === 'undefined' || Number.isNaN(val)) return 'N/A';
        return val;
    };
    const receiveMetric = (getter)=>{
        if (!receiveMetrics) return 'N/A';
        const val = getter(receiveMetrics);
        if (typeof val === 'undefined' || Number.isNaN(val)) return 'N/A';
        return val;
    };
    let senderTunnelInfo = {};
    let receiverTunnelInfo = {};
    const networkInfo = {};
    const tunnel = tunnels.find((t)=>t.client === fromAppliance.id && t.server === toAppliance.id || t.client === toAppliance.id && t.server === fromAppliance.id);
    if (tunnel) {
        const tunnelClientInfo = makeClientConnectionDetails([
            {
                fromAddress: tunnel.clientLocalIp,
                fromPort: tunnel.clientLocalPort,
                toAddress: tunnel.clientRemoteIp,
                toPort: tunnel.clientRemotePort
            }
        ]);
        const isSuperUser = user.role === (0, _types.Role).super;
        const tunnelLinkComponent = isSuperUser ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            to: routes.tunnel({
                tunnelId: tunnel.id
            }),
            underline: "hover",
            children: tunnel.id
        }) : tunnel.id;
        const tunnelServerInfo = makeServerConnectionDetails([
            {
                listenAddress: tunnel.serverLocalIp,
                listenPort: tunnel.serverLocalPort
            }
        ]);
        tunnelClientInfo['Tunnel id'] = tunnelLinkComponent;
        tunnelServerInfo['Tunnel id'] = tunnelLinkComponent;
        // Input: Sender (tunnel client on external appliance) pushes to receiver (tunnel server on core appliance)
        // Output: Receiver (tunnel client on external appliance) pulls from sender (tunnel server on core appliance)
        senderTunnelInfo = fromAppliance.id === tunnel.client ? tunnelClientInfo : tunnelServerInfo;
        receiverTunnelInfo = toAppliance.id === tunnel.client ? tunnelClientInfo : tunnelServerInfo;
        if (tunnel.network) networkInfo['Network'] = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            to: routes.networkUpdate({
                id: tunnel.network.id
            }),
            underline: "hover",
            children: tunnel.network.name
        });
        else networkInfo['Network'] = (0, _internal.TunnelLabels)[tunnel.type];
    }
    const inputMultipathState = receiveMetrics && receiveMetrics.multipathState;
    const inputMultiPathStateData = inputMultipathState ? {
        'Multipath state': inputMultipathState
    } : {};
    const outputMultipathState = sendMetrics && sendMetrics.multipathState;
    const outputMultiPathStateData = outputMultipathState ? {
        'Multipath state': outputMultipathState
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        id: "paper-Information",
        title: 'RIST stream',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                display: 'flex'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        flex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                            children: [
                                "Sent from ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: {
                                        fontWeight: 'normal'
                                    },
                                    children: fromAppliance.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: {
                                ...senderTunnelInfo,
                                ...networkInfo,
                                ...outputMultiPathStateData,
                                Bitrate: sendMetric((s)=>(0, _helpers.formatBitrate)(s.sendBitrate)),
                                'Packet rate': sendMetric((s)=>Math.round(s.sendPacketrate)),
                                'Packet send errors': sendMetric((s)=>s.packetSendErrors),
                                'Retransmission bitrate': (0, _helpers.formatBitrate)(sendMetric((s)=>s.retransmitSendBitrate)),
                                'Retransmission packet rate': sendMetric((s)=>Math.round(s.retransmitSendPacketrate)),
                                'RTP packets sent': sendMetric((s)=>s.rtpPacketsSent),
                                Roundtrip: sendMetric((s)=>(0, _utils1.applyUnit)(s.roundtripMs, 'ms')),
                                'Internal Stream ID': sendMetric((s)=>s.streamId),
                                'Internal Channel ID': sendMetric((s)=>s.channelId)
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        flex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                            children: [
                                "Received by ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: {
                                        fontWeight: 'normal'
                                    },
                                    children: toAppliance.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: {
                                ...receiverTunnelInfo,
                                ...networkInfo,
                                ...inputMultiPathStateData,
                                Bitrate: receiveMetric((s)=>(0, _helpers.formatBitrate)(s.receiveBitrate)),
                                'Packet rate': receiveMetric((s)=>Math.round(s.receivePacketrate)),
                                'Packet send errors': receiveMetric((s)=>s.packetSendErrors),
                                'Packets discarded': receiveMetric((s)=>s.packetsDiscarded),
                                'Retransmission bitrate': receiveMetric((s)=>(0, _helpers.formatBitrate)(s.retransmitReceiveBitrate)),
                                'Retransmission packet rate': receiveMetric((s)=>Math.round(s.retransmitReceivePacketrate)),
                                'Interarrival jitter': receiveMetric((s)=>(0, _utils1.applyUnit)(s.interarrivalJitter, "\xb5s")),
                                'RTP packets received': receiveMetric((s)=>s.rtpPacketsReceived),
                                Roundtrip: receiveMetric((s)=>(0, _utils1.applyUnit)(s.roundtripMs, 'ms')),
                                'Propagation delay': receiveMetric((s)=>(0, _utils1.applyUnit)(s.propagationDelayMs, 'ms')),
                                'Packet loss': receiveMetric((s)=>s.packetsReceived > 0 ? (100 * s.packetsLost / (s.packetsReceived + s.packetsLost)).toFixed(1) + '%' : undefined),
                                'Longest burst loss': receiveMetric((s)=>s.longestBurstLoss),
                                'Internal Stream ID': receiveMetric((s)=>s.streamId),
                                'Internal Channel ID': receiveMetric((s)=>s.channelId)
                            }
                        })
                    ]
                })
            ]
        })
    });
};
const OutputInfo = ({ selected })=>{
    const routes = (0, _store.useRoutes)();
    const outputId = selected.id;
    const outputs = (0, _reactRedux.useSelector)(({ outputsReducer })=>outputsReducer.outputs, (0, _reactRedux.shallowEqual));
    const output = outputs.find(({ id })=>id === outputId);
    if (!output) return null;
    const ristServerEgressMetricsPacketsLost2min = output.metrics?.ristMetrics.filter((m)=>m.outputId === output.id && m.isEgress === true && m.window === (0, _types.MetricWindow).m1 && m.sampledAt && (0, _util.ageSeconds)(m.sampledAt) <= 120).filter((0, _helpers.isOutputMetricsWithPacketsLost)).map((m)=>m.packetsLost);
    const egressPacketsLost2min = ristServerEgressMetricsPacketsLost2min?.length ? ristServerEgressMetricsPacketsLost2min.reduce((sum, packetsLost)=>sum + packetsLost, 0) : null;
    const packetsLost = typeof egressPacketsLost2min === 'number' ? {
        'Packets Lost (last 2 minutes)': (0, _statistics.packets)(egressPacketsLost2min)
    } : {};
    const ports = output.ports;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
            id: "paper-Information",
            title: "Output",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: {
                        Name: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            underline: "hover",
                            to: routes.outputsUpdate({
                                id: outputId
                            }),
                            children: output.name
                        }),
                        Type: (0, _utils2.distinct)(ports.map((port)=>(0, _utils.outputType)(port))).join(', '),
                        Status: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.OutputHealthIndicator), {
                            status: output.health,
                            inline: true,
                            disabled: output.adminStatus === (0, _types.OutputAdminStatus).off
                        }),
                        ...packetsLost,
                        ...getOutputConnectionDetails(output)
                    }
                })
            })
        })
    });
};
function getVaOutputPipe(logicalPortId, vaObjects) {
    if (!logicalPortId || !vaObjects) return undefined;
    const objectsForPort = vaObjects.filter((v)=>v.logicalPort === logicalPortId);
    const finalDestination = objectsForPort.find((o)=>o.type !== 'edge-sink' && o.type !== 'decoder');
    if (!finalDestination) return undefined;
    const outputChain = [
        finalDestination
    ];
    let inputFrom = finalDestination.inputFrom;
    while(inputFrom){
        const nextVaObject = objectsForPort.find((o)=>o.name == inputFrom);
        if (nextVaObject) {
            outputChain.unshift(nextVaObject);
            inputFrom = nextVaObject.inputFrom;
        } else break;
    }
    return outputChain;
}
const OutputPortStreamInfo = ({ selected })=>{
    const outputId = selected?.data?.toId;
    const outputs = (0, _reactRedux.useSelector)(({ outputsReducer })=>outputsReducer.outputs, (0, _reactRedux.shallowEqual));
    const output = outputs.find(({ id })=>id === outputId);
    if (!output) return null;
    function isOutputPortData(data) {
        return data?.type === (0, _serviceOverviewGraph.NMGraphLineType).outputPortStream;
    }
    const data = isOutputPortData(selected.data) ? selected.data : undefined;
    if (!data) return null;
    const logicalPort = output.ports?.find((port)=>port.id === selected?.data?.logicalPortId);
    if (!logicalPort) return null;
    const portAppliance = output.appliances?.find((a)=>a.id === selected.data.fromId);
    const portMetadata = {
        logicalPort,
        portAppliance,
        streamId: data.streamId,
        ristMetrics: output.metrics?.ristMetrics ?? [],
        connectionDetails: getOutputConnectionDetails(output, data.logicalPortId) ?? {}
    };
    const srtInfo = srtOutputInfo(portMetadata);
    const zixiInfo = zixiOutputInfo(portMetadata);
    const rtmpInfo = rtmpOutputInfo(portMetadata);
    const ristInfo = ristOutputInfo(portMetadata);
    const udpInfo = udpOutputInfo(portMetadata, output);
    const unixInfo = unixOutputInfo(portMetadata);
    const rtpInfo = rtpOutputInfo(portMetadata);
    const isVa = !!(portAppliance && (0, _applianceTypeUtil.isVaApplianceType)(portAppliance.type));
    const vaOutputPipe = isVa ? getVaOutputPipe(data.logicalPortId, output.metrics?.vaObjects) : undefined;
    const showHandoverTooltip = !(0, _helpers.isRistServerPortMode)(logicalPort.mode) || isVa;
    const isActuallyRtpOutput = logicalPort.mode === (0, _types.IpPortMode).rtp || isUdpOutputPortWithRtpFormat(logicalPort);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            udpInfo && !isActuallyRtpOutput && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "UDP stream",
                tooltip: showHandoverTooltip ? `The handover to the protocol adapter for ${capitalizePortMode(logicalPort.mode)} uses UDP.` : undefined,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: udpInfo
                    })
                })
            }),
            unixInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "Unix socket stream",
                tooltip: showHandoverTooltip ? `The handover to the protocol adapter for ${capitalizePortMode(logicalPort.mode)} uses Unix domain sockets.` : undefined,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: unixInfo
                    })
                })
            }),
            rtpInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "RTP stream",
                tooltip: showHandoverTooltip ? `The handover to the protocol adapter for ${capitalizePortMode(logicalPort.mode)} uses RTP.` : undefined,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: rtpInfo
                    })
                })
            }),
            !isVa && zixiInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "Zixi stream",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: zixiInfo
                    })
                })
            }),
            !isVa && srtInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "SRT stream",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: srtInfo
                    })
                })
            }),
            !isVa && rtmpInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "RTMP stream",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: rtmpInfo
                    })
                })
            }),
            !isVa && ristInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: "RIST stream",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: ristInfo
                    })
                })
            }),
            vaOutputPipe && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
                title: `VA ${output.ports[0].mode.toUpperCase()} statistics`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vaStatistics.VaOutputStatistics), {
                        port: portMetadata.logicalPort,
                        vaOutputPipe: vaOutputPipe
                    })
                })
            })
        ]
    });
};
const Info = ({ selected })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            selected.type === (0, _types.GraphNodeType).parentInputLogicalPort && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputPortInfo, {
                selected: selected
            }),
            selected.type === (0, _types.GraphNodeType).inputLogicalPort && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputPortInfo, {
                selected: selected
            }),
            selected.type === (0, _types.GraphNodeType).derivedInput && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DerivedInputInfo, {
                selected: selected
            }),
            selected.type === (0, _types.GraphNodeType).inputEdgeAppliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputApplianceInfo, {
                selected: selected
            }),
            selected.type === (0, _types.GraphNodeType).thumbAppliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbNodeInfo, {
                selected: selected
            }),
            selected.type === (0, _types.GraphNodeType).inputRegionCore && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CoreNodeInfo, {
                selected: selected
            }),
            selected.type === (0, _types.GraphNodeType).outputRegionCore && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CoreNodeInfo, {
                selected: selected
            }),
            selected.type === (0, _types.GraphNodeType).inputRegionOutputEdgeAppliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputApplianceInfo, {
                selected: selected
            }),
            selected.type === (0, _types.GraphNodeType).outputRegionOutputEdgeAppliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputApplianceInfo, {
                selected: selected
            }),
            selected.type === (0, _types.GraphNodeType).output && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputInfo, {
                selected: selected
            }),
            selected.type === (0, _serviceOverviewGraph.NMGraphLineType).connection && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConnectionInfo, {
                selected: selected
            }),
            selected.type === (0, _serviceOverviewGraph.NMGraphLineType).deriveFrom && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeriveFromInfo, {
                selected: selected
            }),
            selected.type === (0, _serviceOverviewGraph.NMGraphLineType).deriveFromParent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeriveFromParentInfo, {
                selected: selected
            }),
            selected.type === (0, _serviceOverviewGraph.NMGraphLineType).inputPortStream && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputPortStreamInfo, {
                selected: selected
            }),
            selected.type === (0, _serviceOverviewGraph.NMGraphLineType).outputPortStream && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputPortStreamInfo, {
                selected: selected
            }),
            isGraphNodeApplianceType(selected.type) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tr101290Default.default), {
                selected: selected
            }),
            isGraphNodeApplianceType(selected.type) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statistics.TsInfo), {
                selected: selected
            }),
            isGraphNodeApplianceType(selected.type) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statistics.AdInsertionInfo), {
                selected: selected
            })
        ]
    });
};
function isGraphNodeApplianceType(type) {
    const nodeTypes = [
        (0, _types.GraphNodeType).inputEdgeAppliance,
        (0, _types.GraphNodeType).inputRegionCore,
        (0, _types.GraphNodeType).outputRegionCore,
        (0, _types.GraphNodeType).inputRegionOutputEdgeAppliance,
        (0, _types.GraphNodeType).outputRegionOutputEdgeAppliance
    ];
    return nodeTypes.includes(type);
}
exports.default = Info;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Grid":"6iX4B","@mui/utils/capitalize":"5sWY4","lodash/min":"dpb6A","@mui/icons-material/Info":"juq3i","common/api/v1/types":"3qemx","../../../store":"5LXiG","../../common/DataSet":"dmQXG","./Statistics":"y5hil","./VaStatistics":"9WTwZ","./InfoSection":"j29oh","../../common/Indicator":"hqaQa","../../common/Link":"l3o6V","../../../utils":"342UB","./utils":"foCTx","common/applianceTypeUtil":"3z9on","common/api/v1/helpers":"6jovr","common/api/v1/internal":"aS8rO","./TR101290":"eVcvx","common/util":"jV4UZ","common/utils":"2AqiH","../../common/ApplianceProxyButton":"59aZo","common/srt":"9Ptuu","../Graph/ServiceOverviewGraph":"i85VV","../../common/Tooltip":"crjvg","@mui/material/IconButton":"488As","react-router":"iaz4C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dpb6A":[function(require,module,exports,__globalThis) {
var baseExtremum = require("122393f3e0d791dc"), baseLt = require("8122a719ac68b5c4"), identity = require("3161b76b624de11a");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function min(array) {
    return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
}
module.exports = min;

},{"122393f3e0d791dc":"3QycA","8122a719ac68b5c4":"1yqJx","3161b76b624de11a":"2HXBf"}],"3QycA":[function(require,module,exports,__globalThis) {
var isSymbol = require("6a2d056d200c4854");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = baseExtremum;

},{"6a2d056d200c4854":"fMaHV"}],"1yqJx":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function baseLt(value, other) {
    return value < other;
}
module.exports = baseLt;

},{}],"dmQXG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
const Container = (0, _styles.styled)('dl')(({ theme })=>({
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        gridTemplateRows: 'repeat(auto-fill, auto)',
        gridRowGap: theme.spacing(1),
        gridColumnGap: theme.spacing(3)
    }));
/**
 * Common data set display
 * @param values - map of key=title, value=value to show
 */ const DataSet = ({ values })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        children: Object.entries(values).map(([key, value])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            sx: {
                                fontWeight: 'bold'
                            },
                            children: key
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        "data-value-for": key,
                        children: /*#__PURE__*/ (0, _react.isValidElement)(value) ? value : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            component: "span",
                            children: value
                        })
                    })
                ]
            }, key))
    });
};
exports.default = DataSet;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Typography":"6NtGx","@mui/material/styles":"2UrBk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"y5hil":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "integer", ()=>integer);
parcelHelpers.export(exports, "packets", ()=>packets);
parcelHelpers.export(exports, "formatSampleRate", ()=>formatSampleRate);
parcelHelpers.export(exports, "TsInfo", ()=>TsInfo);
parcelHelpers.export(exports, "AdInsertionInfo", ()=>AdInsertionInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _utils = require("../../../utils");
var _helpers = require("common/api/v1/helpers");
var _infoSection = require("./InfoSection");
var _reactRedux = require("react-redux");
var _utils1 = require("./utils");
var _adInsertionCompatibility = require("../../common/AdInsertionCompatibility");
const integer = (val)=>val == null ? null : String(Math.round(val));
const packets = (value)=>value === undefined || value === null ? '-' : (0, _utils.pluralize)(value, 'packet');
const VideoStreams = ({ pids })=>{
    const tsInfos = pids;
    if (tsInfos.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h3",
                children: "Video streams"
            }),
            tsInfos.map((pid, i)=>{
                const framerate = pid?.streamInfo?.video?.frameRate;
                const values = {
                    Pid: pid?.id,
                    Type: pid?.description,
                    'Avg bitrate': (0, _helpers.formatBitrate)(pid?.bitrate?.average),
                    Width: pid?.streamInfo?.video?.videoSize?.horizontal,
                    Height: pid?.streamInfo?.video?.videoSize?.vertical,
                    ['Frame rate']: framerate?.toFixed(2)
                };
                const isInterlaced = pid?.streamInfo?.video?.interlaced === 'yes';
                if (isInterlaced) {
                    const fieldRate = framerate ? framerate * 2 : undefined;
                    values['Field rate'] = fieldRate?.toFixed(2);
                }
                values['Interlaced'] = pid?.streamInfo?.video?.interlaced;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: values
                        }),
                        i !== tsInfos.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {})
                    ]
                }, `${pid.id}-video`);
            })
        ]
    });
};
const AudioStreams = ({ pids })=>{
    const tsInfos = pids;
    if (tsInfos.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h3",
                children: "Audio streams"
            }),
            tsInfos.map((pid, i)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: {
                                Pid: pid?.id,
                                Type: pid?.description,
                                'Avg bitrate': (0, _helpers.formatBitrate)(pid?.bitrate?.average),
                                'Sample rate': formatSampleRate(pid?.streamInfo?.audio?.sampleRate)
                            }
                        }),
                        i !== tsInfos.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {})
                    ]
                }, `${pid.id}-audio`);
            })
        ]
    });
};
const OtherStreams = ({ pids })=>{
    const tsInfos = pids;
    if (tsInfos.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h3",
                children: "Other streams"
            }),
            tsInfos.map((pid, i)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: {
                                Pid: pid?.id,
                                Type: pid?.description,
                                'Avg bitrate': (0, _helpers.formatBitrate)(pid?.bitrate?.average)
                            }
                        }),
                        i !== tsInfos.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {})
                    ]
                }, `${pid.id}-other`);
            })
        ]
    });
};
const GlobalPids = ({ pids })=>{
    const tsInfos = pids;
    if (tsInfos.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
        style: {
            marginBottom: '16px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "h3",
                    component: "span",
                    children: "Global Pids"
                })
            }),
            tsInfos.map((pid, i)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: {
                                Pid: pid?.id,
                                Type: pid?.description,
                                'Avg bitrate': (0, _helpers.formatBitrate)(pid?.bitrate?.average)
                            }
                        }),
                        i !== tsInfos.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {})
                    ]
                }, `${pid?.id}-global`);
            })
        ]
    });
};
const Services = ({ tsInfo })=>{
    const services = tsInfo?.services;
    if (!tsInfo || !services || services.length === 0) return null;
    const pids = tsInfo.pids?.filter((p)=>typeof p !== 'undefined').map((p)=>p) ?? [];
    const globalPids = [];
    const servicePidMapping = new Map();
    const orderedServices = services.filter((s)=>s.pids !== undefined) // pids and id should never be undefined
    ;
    orderedServices.sort((a, b)=>a.id - b.id) // Sort for consistent ordering
    ;
    for (const pid of pids.filter((p)=>p.id !== undefined)){
        const servicesUsingPid = orderedServices.filter((s)=>s.pids.includes(pid.id));
        if (servicesUsingPid.length === 0) {
            // No service include the PID -> it's a global PID
            globalPids.push(pid);
            continue;
        }
        for (const service of servicesUsingPid){
            const servicePids = servicePidMapping.get(service.id) ?? [];
            servicePids.push(pid);
            servicePidMapping.set(service.id, servicePids);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(GlobalPids, {
                pids: globalPids
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h3",
                children: "Programs"
            }),
            orderedServices.map((service, index)=>{
                const pidsInService = servicePidMapping.get(service.id);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: {
                                Id: service.id,
                                Name: service.name ?? '-',
                                Type: service.type?.description ?? '-',
                                'Avg bitrate': (0, _helpers.formatBitrate)(service?.averageBitrate)
                            }
                        }),
                        pidsInService?.length ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
                            style: {
                                marginBottom: '16px'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        component: "span",
                                        style: {
                                            fontWeight: 'bold'
                                        },
                                        children: "Contents"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        paddingTop: '16px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                marginRight: '40px'
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(VideoStreams, {
                                                pids: pidsInService?.filter(isVideoPid) ?? []
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                marginRight: '40px'
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AudioStreams, {
                                                pids: pidsInService?.filter(isAudioPid) ?? []
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                marginRight: '40px'
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OtherStreams, {
                                                pids: pidsInService?.filter((p)=>!isAudioPid(p) && !isVideoPid(p)) ?? []
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : null,
                        index !== services.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {})
                    ]
                }, `${service.id}-service`);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    marginTop: '12px'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                    variant: "body2",
                    children: [
                        "Showing TS info for internal channel ID: ",
                        tsInfo.channelId
                    ]
                })
            })
        ]
    });
};
function isVideoPid(pid) {
    return !!pid.streamInfo?.video;
}
function isAudioPid(pid) {
    return !!pid.streamInfo?.audio;
}
function formatSampleRate(sampleRate) {
    if (typeof sampleRate !== 'number') return 'N/A';
    return sampleRate.toString();
}
const TsInfo = ({ selected })=>{
    const input = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>serviceOverviewReducer.input, (0, _reactRedux.shallowEqual));
    const outputs = (0, _reactRedux.useSelector)(({ outputsReducer })=>outputsReducer.outputs, (0, _reactRedux.shallowEqual));
    if (!input) return null;
    if (!input.tr101290Enabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        title: "TS info disabled"
    });
    const applianceId = selected.id;
    if ((0, _utils1.isApplianceStandby)(applianceId, input, outputs)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        title: "TS info not available in standby"
    });
    const tsInfoMatchesAppliance = (tsInfo)=>tsInfo.applianceId === applianceId;
    let tsInfo = (input.tsInfo || []).find(tsInfoMatchesAppliance);
    if (!tsInfo) for (const output of outputs){
        const outputTsInfo = output.tsInfo?.find(tsInfoMatchesAppliance);
        if (outputTsInfo) {
            tsInfo = outputTsInfo;
            break;
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        title: 'TS info',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                display: 'flex',
                paddingTop: '16px'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Services, {
                    tsInfo: tsInfo
                })
            })
        })
    });
};
const AdInsertionInfo = ({ selected })=>{
    const input = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>serviceOverviewReducer.input, (0, _reactRedux.shallowEqual));
    const outputs = (0, _reactRedux.useSelector)(({ outputsReducer })=>outputsReducer.outputs, (0, _reactRedux.shallowEqual));
    const { settings } = (0, _utils.useSettingsSelector)();
    if (!settings?.expFeatures?.AdInsertion) return null;
    if (!input) return null;
    if (!input.tr101290Enabled) return null;
    const applianceId = selected.id;
    if ((0, _utils1.isApplianceStandby)(applianceId, input, outputs)) return null;
    const tsInfoMatchesAppliance = (tsInfo)=>tsInfo.applianceId === applianceId;
    let tsInfo = (input.tsInfo || []).find(tsInfoMatchesAppliance);
    if (!tsInfo) for (const output of outputs){
        const outputTsInfo = output.tsInfo?.find(tsInfoMatchesAppliance);
        if (outputTsInfo) {
            tsInfo = outputTsInfo;
            break;
        }
    }
    if (!tsInfo) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSection.InfoSection), {
        title: 'Ad insertion',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adInsertionCompatibility.AdInsertionCompatibility), {
            latestTsInfo: tsInfo
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Divider":"9Ul8c","@mui/material/Typography":"6NtGx","../../common/DataSet":"dmQXG","../../../utils":"342UB","common/api/v1/helpers":"6jovr","./InfoSection":"j29oh","react-redux":"l1pMU","./utils":"foCTx","../../common/AdInsertionCompatibility":"7lx8B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j29oh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfoSection", ()=>InfoSection);
var _jsxRuntime = require("react/jsx-runtime");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _form = require("../../common/Form");
const InfoSection = ({ children, title, id, tooltip })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        id: id,
        title: title || 'Information',
        tooltip: tooltip,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
            size: {
                xs: 12
            },
            children: children
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Grid":"6iX4B","../../common/Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"foCTx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeFormatter", ()=>makeFormatter);
parcelHelpers.export(exports, "applyUnit", ()=>applyUnit);
parcelHelpers.export(exports, "isApplianceStandby", ()=>isApplianceStandby);
parcelHelpers.export(exports, "getActiveChannelId", ()=>getActiveChannelId);
parcelHelpers.export(exports, "extractTr101290Metrics", ()=>extractTr101290Metrics);
var _types = require("common/api/v1/types");
var _helpers = require("common/api/v1/helpers");
function makeFormatter(t) {
    return (getter)=>{
        if (!t) return 'N/A';
        try {
            const val = getter(t);
            return val == null || Number.isNaN(val) ? 'N/A' : val;
        } catch  {
            // eslint-disable-next-line no-console
            console.warn(`Unexpected missing value on object`, t);
            return 'N/A';
        }
    };
}
function applyUnit(val, unit) {
    if (val == null || Number.isNaN(val)) return undefined;
    return `${val} ${unit}`;
}
const isRistInputOnAppliance = (applianceId)=>(m)=>m.type === (0, _types.RistMetricType).ristInput && m.window === (0, _types.MetricWindow).s10 && m.applianceId === applianceId;
const isApplianceStandby = (applianceId, input, outputs)=>{
    const activeChannelId = input ? getActiveChannelId(applianceId, input, outputs) : undefined;
    const ristMetricsInInput = input?.metrics?.ristMetrics ?? [];
    const ristMetricsOnOutputs = outputs.map((o)=>o.metrics?.ristMetrics ?? []);
    // We only care about ristInputs of the active channel (there may be 'active' ristInputs belonging to deactivated channels)
    const ristInputsOfActiveChannel = [
        ristMetricsInInput,
        ...ristMetricsOnOutputs
    ].flat().filter((m)=>m.channelId === activeChannelId && isRistInputOnAppliance(applianceId)(m));
    return ristInputsOfActiveChannel.length > 0 && ristInputsOfActiveChannel.every((m)=>m.multipathState === (0, _types.RistInputMultipathState).standby);
};
const getActiveChannelId = (applianceId, input, outputs)=>{
    const ristMetrics = [
        input.metrics?.ristMetrics ?? [],
        ...outputs.map((o)=>o.metrics?.ristMetrics ?? [])
    ].flat().filter((m)=>m.inputId === input.id && input.channelIds.includes(m.channelId));
    return (0, _helpers.getActiveChannelOnAppliance)(applianceId, ristMetrics);
};
const extractTr101290Metrics = (input, outputs)=>{
    const metricsMap = new Map();
    const inputMetrics = input?.metrics?.tr101290Metrics ?? [];
    // Add input metrics to map
    inputMetrics.forEach((m)=>{
        metricsMap.set(m.applianceId, m);
    });
    // Add output metrics to map
    outputs.flatMap((m)=>m.metrics?.tr101290Metrics ?? []).forEach((m)=>{
        metricsMap.set(m.applianceId, m);
    });
    // Convert map values to array
    return [
        ...metricsMap.values()
    ];
};

},{"common/api/v1/types":"3qemx","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7lx8B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdInsertionCompatibility", ()=>AdInsertionCompatibility);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("./Form");
var _dataSet = require("./DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _check = require("@mui/icons-material/Check");
var _checkDefault = parcelHelpers.interopDefault(_check);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
const AdInsertionCompatibility = ({ latestTsInfo })=>{
    const supportedVideoCodecs = [
        'H.264',
        'H.265'
    ];
    const supportedAudioCodecs = [
        'AAC'
    ];
    const pid256 = latestTsInfo.pids?.find((pid)=>pid?.id === 256);
    const pid257 = latestTsInfo.pids?.find((pid)=>pid?.id === 257);
    const gotVideo = !!pid256?.streamInfo?.video;
    const gotAudio = !!pid257?.streamInfo?.audio;
    const validVideoCodec = supportedVideoCodecs.find((c)=>pid256?.streamInfo?.type?.description?.includes(c));
    const validAudioCodec = supportedAudioCodecs.find((c)=>pid257?.streamInfo?.type?.description?.includes(c));
    const scte35Pid = latestTsInfo.pids?.find((pid)=>pid?.description?.includes('SCTE-35'));
    const videoScan = pid256?.streamInfo?.video?.interlaced === 'no';
    const videoSize = pid256?.streamInfo?.video?.videoSize;
    const videoSizeIsBelow4k = videoSize?.horizontal && videoSize?.vertical && videoSize.horizontal <= 3840 && videoSize.vertical <= 2160;
    const videoFramerate = pid256?.streamInfo?.video?.frameRate;
    const videoBitrate = pid256?.bitrate?.average;
    const audioBitrate = pid257?.bitrate?.average;
    const tests = [
        {
            label: 'PID 256 contains video',
            test: gotVideo
        },
        {
            label: 'PID 257 contains audio',
            test: gotAudio
        },
        {
            label: 'Video codec found',
            test: validVideoCodec
        },
        {
            label: 'Audio codec found',
            test: validAudioCodec
        },
        {
            label: 'SCTE35 PID found',
            test: scte35Pid
        },
        {
            label: 'Video scan is progressive',
            test: videoScan
        },
        {
            label: 'Video resolution found',
            test: videoSizeIsBelow4k
        },
        {
            label: 'Framerate found',
            test: videoFramerate
        },
        {
            label: 'Video bitrate found',
            test: videoBitrate
        },
        {
            label: 'Audio bitrate found',
            test: audioBitrate
        }
    ];
    const allTrue = tests.every((t)=>t.test);
    const failed = tests.filter((t)=>!t.test);
    const passed = tests.filter((t)=>t.test);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        collapsible: true,
        collapsed: true,
        title: allTrue ? 'Stream is compatible' : `Check compatibility (${failed.length} incompatible)`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                xs: 6,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: {
                        Incompatible: '',
                        ...failed.reduce((acc, t)=>({
                                ...acc,
                                [t.label]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                            }), {})
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                xs: 6,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: {
                        Compatible: '',
                        ...passed.reduce((acc, t)=>({
                                ...acc,
                                [t.label]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkDefault.default), {})
                            }), {})
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","./Form":"4Mui7","./DataSet":"dmQXG","@mui/icons-material/Check":"hwZzP","@mui/icons-material/Close":"acjz6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwZzP":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("e4b66f5260c416f2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("f9c4817c4d27655f"));
var _jsxRuntime = require("81bc061326b489b4");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

},{"e4b66f5260c416f2":"kZ6eK","f9c4817c4d27655f":"2vOnF","81bc061326b489b4":"1dlk8"}],"9WTwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vaInputStatistics", ()=>vaInputStatistics);
parcelHelpers.export(exports, "VaOutputStatistics", ()=>VaOutputStatistics);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _statistics = require("./Statistics");
var _utils = require("./utils");
var _helpers = require("common/api/v1/helpers");
const VaUdpInputStatistics = ({ vaInputPipe })=>{
    if (!vaInputPipe || !vaInputPipe.length || !vaInputPipe[0]) return null;
    const { statistics } = vaInputPipe[0];
    const stat = (0, _utils.makeFormatter)(statistics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            Bitrate: stat((s)=>(0, _helpers.formatBitrate)(s?.udpStats?.bitrate)),
            'FEC bitrate': stat((s)=>(0, _helpers.formatBitrate)(s?.fecRecv?.fecBitrate)),
            'FEC packet rate': stat((s)=>(0, _statistics.packets)(s?.fecRecv?.fecRate)),
            'FEC packets received': stat((s)=>(0, _statistics.integer)(s?.fecRecv?.fecPackets)),
            'Packets recovered by FEC': stat((s)=>(0, _statistics.integer)(s?.fecRecv?.recovered))
        }
    });
};
const VaSrtInputStatistics = ({ vaInputPipe })=>{
    if (!vaInputPipe || !vaInputPipe.length || !vaInputPipe[0]) return null;
    const { srtRecv } = vaInputPipe[0].statistics;
    const stat = (0, _utils.makeFormatter)(srtRecv);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            'Packets received': stat((s)=>(0, _statistics.packets)(s.received)),
            'Packets lost': stat((s)=>(0, _statistics.packets)(s.lost)),
            'Packets dropped': stat((s)=>(0, _statistics.packets)(s.dropped)),
            'Packets belated': stat((s)=>(0, _statistics.packets)(s.belated)),
            'Packets retransmitted': stat((s)=>(0, _statistics.packets)(s.retransmitted)),
            'Round trip time': stat((s)=>(0, _utils.applyUnit)(s.rtt, "\u03BCs")),
            Bitrate: stat((s)=>(0, _helpers.formatBitrate)(s.bitRate)),
            'Bytes received': stat((s)=>(0, _statistics.integer)(s.bytes)),
            'Bytes lost': stat((s)=>(0, _statistics.integer)(s.bytesLost)),
            'Bytes dropped': stat((s)=>(0, _statistics.integer)(s.bytesDropped))
        }
    });
};
const VaZixiInputStatistics = ({ vaInputPipe: [zixiSink] })=>{
    const stat = (0, _utils.makeFormatter)(zixiSink?.statistics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            Reconnections: stat((s)=>(0, _statistics.integer)(s.general.numConnects)),
            'Packets received': stat((s)=>(0, _statistics.packets)(s.netRecv.numPackets)),
            'FEC packets received': stat((s)=>(0, _statistics.packets)(s.fecRecv.fecPackets)),
            'Receive bitrate': stat((s)=>(0, _helpers.formatBitrate)(s.netRecv.inputBitrate)),
            'Remote end Send bitrate': stat((s)=>(0, _helpers.formatBitrate)(s.netSend.sendBitrate)),
            'Round trip time': stat((s)=>`${(0, _statistics.integer)(s.netSend.rtt)} \u{3BC}s`),
            'Packet jitter': stat((s)=>`${(0, _statistics.integer)(s.netRecv.jitter)} ms`),
            'Missing packets (%)': stat((s)=>(0, _statistics.integer)(s.netRecv.packetLoss / 1000)),
            'Missing packets': stat((s)=>(0, _statistics.packets)(s.netRecv.dropped)),
            'Packets recovered by FEC': stat((s)=>(0, _statistics.packets)(s.fecRecv.recovered)),
            'Packets recovered by ARQ': stat((s)=>(0, _statistics.packets)(s.arqRecv.recovered)),
            'Unrecovered packets': stat((s)=>(0, _statistics.packets)(s.arqRecv.dropped))
        }
    });
};
const VaSdiInputStatistics = ({ vaInputPipe: [sdiInput] })=>{
    const stat = (0, _utils.makeFormatter)(sdiInput?.statistics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            'Frames received': stat((s)=>(0, _statistics.integer)(s.netRecv.numPackets))
        }
    });
};
const VaAsiInputStatistics = ({ vaInputPipe: [asiInput] })=>{
    const stat = (0, _utils.makeFormatter)(asiInput?.statistics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            Reconnections: stat((s)=>(0, _statistics.integer)(s.general.numConnects)),
            Bitrate: stat((s)=>(0, _helpers.formatBitrate)(s.netRecv.inputBitrate))
        }
    });
};
const vaInputStatistics = (mode, vaInputPipe)=>{
    switch(mode){
        case (0, _types.CoaxPortMode).asi:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaAsiInputStatistics, {
                vaInputPipe: vaInputPipe
            });
        case (0, _types.CoaxPortMode).sdi:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaSdiInputStatistics, {
                vaInputPipe: vaInputPipe
            });
        case (0, _types.IpPortMode).udp:
        // falls through
        case (0, _types.IpPortMode).rtp:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaUdpInputStatistics, {
                vaInputPipe: vaInputPipe
            });
        case (0, _types.IpPortMode).srt:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaSrtInputStatistics, {
                vaInputPipe: vaInputPipe
            });
        case (0, _types.IpPortMode).zixi:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaZixiInputStatistics, {
                vaInputPipe: vaInputPipe
            });
        default:
            return null;
    }
};
const VaUdpOutputStatistics = ({ vaOutputPipe: [, udpSource] })=>{
    const stat = (0, _utils.makeFormatter)(udpSource?.statistics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            Bitrate: stat((s)=>(0, _helpers.formatBitrate)(s.udpStats.bitrate)),
            'FEC send bitrate': stat((s)=>(0, _helpers.formatBitrate)(s.fecSend.fecBitrate)),
            'FEC packet rate': stat((s)=>(0, _statistics.packets)(s.fecSend.fecRate)),
            'FEC packets sent': stat((s)=>(0, _statistics.packets)(s.fecSend.fecPackets))
        }
    });
};
const VaSrtOutputStatistics = ({ vaOutputPipe: [, srtSource] })=>{
    const stat = (0, _utils.makeFormatter)(srtSource?.statistics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            'Packets sent': stat((s)=>(0, _statistics.packets)(s.srtSend.sent)),
            'Packets lost': stat((s)=>(0, _statistics.packets)(s.srtSend.lost)),
            'Packets dropped': stat((s)=>(0, _statistics.packets)(s.srtSend.dropped)),
            'Packets retransmitted': stat((s)=>(0, _statistics.packets)(s.srtSend.retransmitted)),
            'Round trip time': stat((s)=>(0, _utils.applyUnit)(s.srtSend.rtt, "\u03BCs")),
            Bitrate: stat((s)=>(0, _helpers.formatBitrate)(s.srtSend.bitRate)),
            'Bytes sent': stat((s)=>(0, _statistics.integer)(s.srtSend.bytes)),
            'Bytes dropped': stat((s)=>(0, _statistics.integer)(s.srtSend.bytesDropped))
        }
    });
};
const VaZixiOutputStatistics = ({ vaOutputPipe: [, pullSource] })=>{
    const stat = (0, _utils.makeFormatter)(pullSource?.statistics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            Reconnections: stat((s)=>(0, _statistics.integer)(s.general.numConnects)),
            'Packets sent': stat((s)=>(0, _statistics.packets)(s.netSend.sentPackets)),
            'FEC packets sent': stat((s)=>(0, _statistics.packets)(s.fecSend.fecPackets)),
            'Send bitrate': stat((s)=>(0, _helpers.formatBitrate)(s.netSend.sendBitrate)),
            'Remote end Receive bitrate': stat((s)=>(0, _helpers.formatBitrate)(s.netRecv.inputBitrate)),
            'Round trip time': stat((s)=>`${(0, _statistics.integer)(s.netSend.rtt)} \u{3BC}s`),
            'Packet jitter': stat((s)=>`${(0, _statistics.integer)(s.netRecv.jitter)} ms`),
            'Missing packets (%)': stat((s)=>(0, _statistics.integer)(s.netRecv.packetLoss / 1000)),
            'Missing packets': stat((s)=>(0, _statistics.packets)(s.netRecv.dropped)),
            'Packets recovered by FEC': stat((s)=>(0, _statistics.packets)(s.fecRecv.recovered)),
            'Packets recovered by ARQ': stat((s)=>(0, _statistics.packets)(s.arqRecv.recovered)),
            'Unrecovered packets': stat((s)=>(0, _statistics.packets)(s.arqRecv.dropped))
        }
    });
};
const VaAsiOutputStatistics = ({ vaOutputPipe: [, asiSource] })=>{
    const stat = (0, _utils.makeFormatter)(asiSource?.statistics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            Reconnections: stat((s)=>(0, _statistics.integer)(s.general.numConnects)),
            'Packets sent': stat((s)=>(0, _statistics.packets)(s.netSend.sentPackets)),
            Bitrate: stat((s)=>(0, _helpers.formatBitrate)(s.netSend.sendBitrate))
        }
    });
};
const VaSdiOutputStatistics = ({ vaOutputPipe: [, decoder] })=>{
    const stat = (0, _utils.makeFormatter)(decoder?.statistics);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: {
            'Decoded frames': stat((s)=>(0, _statistics.integer)(s.decFrames)),
            'Dropped frames': stat((s)=>(0, _statistics.integer)(s.droppedFrames)),
            'Repeated frames': stat((s)=>(0, _statistics.integer)(s.repeatedFrames))
        }
    });
};
const VaOutputStatistics = ({ port, vaOutputPipe })=>{
    if (!vaOutputPipe || !port) return null;
    const makeComponent = ()=>{
        switch(port.mode){
            case (0, _types.CoaxPortMode).asi:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaAsiOutputStatistics, {
                    vaOutputPipe: vaOutputPipe
                });
            case (0, _types.CoaxPortMode).sdi:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaSdiOutputStatistics, {
                    vaOutputPipe: vaOutputPipe
                });
            case (0, _types.IpPortMode).udp:
            // falls through
            case (0, _types.IpPortMode).rtp:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaUdpOutputStatistics, {
                    vaOutputPipe: vaOutputPipe
                });
            case (0, _types.IpPortMode).srt:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaSrtOutputStatistics, {
                    vaOutputPipe: vaOutputPipe
                });
            case (0, _types.IpPortMode).zixi:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VaZixiOutputStatistics, {
                    vaOutputPipe: vaOutputPipe
                });
            default:
                return null;
        }
    };
    const component = makeComponent();
    return component;
};

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../common/DataSet":"dmQXG","./Statistics":"y5hil","./utils":"foCTx","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aS8rO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TunnelLabels = void 0;
const types_1 = require("79ae57fc09bee207");
exports.TunnelLabels = {
    [types_1.TunnelType.internal]: 'Internal',
    [types_1.TunnelType.external]: 'Public',
    [types_1.TunnelType.interRegion]: 'Inter Regional'
};

},{"79ae57fc09bee207":"3qemx"}],"eVcvx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _form = require("../../common/Form");
var _utils = require("./utils");
const METRICS_MISSING = -1;
const Tr101290Page = ({ selected })=>{
    const { input, outputs } = (0, _reactRedux.useSelector)(({ serviceOverviewReducer })=>({
            input: serviceOverviewReducer.input,
            outputs: serviceOverviewReducer.outputs
        }), (0, _reactRedux.shallowEqual));
    const outputs1m = (0, _reactRedux.useSelector)(({ outputsReducer })=>outputsReducer.outputs, (0, _reactRedux.shallowEqual));
    if (input?.tr101290Enabled === false) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                display: 'flex',
                justifyContent: 'space-between'
            },
            children: "TR 101 290 disabled"
        })
    });
    const allMetrics = (0, _utils.extractTr101290Metrics)(input, outputs.items);
    const stats = getTr101290StatsForType(allMetrics, selected);
    if ((0, _utils.isApplianceStandby)(selected.id, input, outputs1m)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                display: 'flex',
                justifyContent: 'space-between'
            },
            children: "TR 101 290 not available in standby"
        })
    });
    const titleRow = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        children: "TR 101 290"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: titleRow,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tr101202Stats, {
            ...stats || makeEmptyTr101290Stats()
        })
    });
};
/**
 * @return tr101290: present metrics for the selected type
 * @return null: if info that should be there is missing
 * @return undefined: if info is not expected
 */ const getTr101290StatsForType = (allMetrics, selected)=>{
    switch(selected.type){
        case (0, _types.GraphNodeType).inputEdgeAppliance:
        case (0, _types.GraphNodeType).inputRegionOutputEdgeAppliance:
        case (0, _types.GraphNodeType).outputRegionOutputEdgeAppliance:
        case (0, _types.GraphNodeType).inputRegionCore:
        case (0, _types.GraphNodeType).outputRegionCore:
            return allMetrics.find((m)=>m.applianceId === selected.id) || null;
        default:
            return null;
    }
};
const Tr101202Stats = (tr101290)=>{
    const formatStats = (obj)=>{
        return Object.entries(obj).reduce((acc, [key, value])=>({
                ...acc,
                [key.split('_').join(' ')]: value === METRICS_MISSING ? 'N/A' : value
            }), {});
    };
    function getPrio1SortWeight(key) {
        if (key === 'TS_sync_loss') return 1;
        if (key === 'Sync_byte_error') return 2;
        if (key === 'PAT_error') return 3;
        if (key === 'Continuity_count_error') return 4;
        if (key === 'PMT_error') return 5;
        if (key === 'PID_error') return 6;
        return 7;
    }
    function getPrio2SortWeight(key) {
        if (key === 'Transport_error') return 1;
        if (key === 'CRC_error') return 2;
        if (key === 'PCR_error') return 3;
        if (key === 'PCR_accuracy_error') return 4;
        if (key === 'PTS_error') return 5;
        if (key === 'CAT_error') return 6;
        return 7;
    }
    const { prio1, prio2 } = tr101290;
    const sortedPrio1 = Object.keys(prio1).sort((a, b)=>getPrio1SortWeight(a) - getPrio1SortWeight(b)).reduce((sorted, key)=>{
        return {
            ...sorted,
            [key]: prio1[key]
        };
    }, {});
    const sortedPrio2 = Object.keys(prio2).sort((a, b)=>getPrio2SortWeight(a) - getPrio2SortWeight(b)).reduce((sorted, key)=>{
        return {
            ...sorted,
            [key]: prio2[key]
        };
    }, {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
        size: {
            xs: 12
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                container: true,
                spacing: 4,
                children: [
                    prio1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                        size: {
                            xs: 4
                        },
                        sx: {
                            paddingTop: '12px'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h3",
                                children: "Prio 1"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                                values: formatStats(sortedPrio1)
                            })
                        ]
                    }),
                    prio2 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                        size: {
                            xs: 4
                        },
                        sx: {
                            paddingTop: '12px'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h3",
                                children: "Prio 2"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                                values: formatStats(sortedPrio2)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    marginTop: '12px'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                        variant: "body2",
                        children: [
                            "Window size: ",
                            tr101290.window || 'N/A'
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                        variant: "body2",
                        children: [
                            "Showing stats since: ",
                            tr101290.time?.toLocaleString() || 'N/A'
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                        variant: "body2",
                        children: [
                            "Showing stats for internal channel ID: ",
                            tr101290.channelId || 'N/A'
                        ]
                    })
                ]
            })
        ]
    });
};
const makeEmptyTr101290Stats = ()=>({
        time: undefined,
        window: undefined,
        channelId: 'N/A',
        prio1: {
            TS_sync_loss: METRICS_MISSING,
            Sync_byte_error: METRICS_MISSING,
            PAT_error: METRICS_MISSING,
            Continuity_count_error: METRICS_MISSING,
            PMT_error: METRICS_MISSING,
            PID_error: METRICS_MISSING
        },
        prio2: {
            Transport_error: METRICS_MISSING,
            CRC_error: METRICS_MISSING,
            PCR_error: METRICS_MISSING,
            PCR_accuracy_error: METRICS_MISSING,
            PTS_error: METRICS_MISSING,
            CAT_error: METRICS_MISSING
        }
    });
exports.default = Tr101290Page;

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","@mui/material/Grid":"6iX4B","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../common/DataSet":"dmQXG","../../common/Form":"4Mui7","./utils":"foCTx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59aZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApplianceProxyButton", ()=>ApplianceProxyButton);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("../../utils");
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _routes = require("../../utils/routes");
var _constants = require("common/constants");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _openInNew = require("@mui/icons-material/OpenInNew");
var _openInNewDefault = parcelHelpers.interopDefault(_openInNew);
const ApplianceProxyButton = ({ user, appliance, iconButtonProps })=>{
    const isEditable = (0, _utils.isEditableAppliance)(user, (0, _utils.getApplianceOwnerId)(appliance));
    const proxyEnabledOverride = appliance.settings.proxy?.enabled;
    const applianceHasProxy = !!appliance.features.proxy?.enabled && proxyEnabledOverride === undefined || !!proxyEnabledOverride;
    if (!isEditable) return null;
    if (!applianceHasProxy) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: "Manage appliance",
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                href: (0, _routes.api).appliance({
                    id: appliance.id
                }),
                onClick: ()=>{
                    document.cookie = `${0, _constants.COOKIE_APPLIANCE_PROXY}=${appliance.id};path=/api/appliance/${appliance.id}/proxy`;
                },
                target: "_blank",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                    edge: "end",
                    "aria-label": "Manage appliance",
                    sx: iconButtonProps ? iconButtonProps : undefined,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInNewDefault.default), {})
                })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","../../utils":"342UB","./Tooltip":"crjvg","@mui/material/Link":"chNUC","../../utils/routes":"cqMGU","common/constants":"bdiC1","@mui/material/IconButton":"488As","@mui/icons-material/OpenInNew":"3wl83","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3wl83":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("e2fa2d905ac58114").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("ae1c288d5833efff"));
var _jsxRuntime = require("fbc157c28865ae1d");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'OpenInNew');

},{"e2fa2d905ac58114":"kZ6eK","ae1c288d5833efff":"2vOnF","fbc157c28865ae1d":"1dlk8"}],"9Ptuu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SrtConnectionStatus = void 0;
exports.isRtpOverSrt = isRtpOverSrt;
exports.isBondedSrtInputPort = isBondedSrtInputPort;
const types_1 = require("73bb9c1e13abeb63");
var SrtConnectionStatus;
(function(SrtConnectionStatus) {
    SrtConnectionStatus["connected"] = "connected";
    SrtConnectionStatus["disconnected"] = "disconnected";
})(SrtConnectionStatus || (exports.SrtConnectionStatus = SrtConnectionStatus = {}));
function isRtpOverSrt(p) {
    return p.mode === types_1.IpPortMode.srt && !!p.rtp;
}
function isBondedSrtInputPort(p) {
    return p.mode === types_1.IpPortMode.srt && 'failoverPriority' in p && typeof p.failoverPriority === 'number';
}

},{"73bb9c1e13abeb63":"3qemx"}],"i85VV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoSizingSvg", ()=>AutoSizingSvg);
parcelHelpers.export(exports, "ServiceOverviewGraph", ()=>ServiceOverviewGraph);
parcelHelpers.export(exports, "NMGraphLineType", ()=>NMGraphLineType);
parcelHelpers.export(exports, "CurveBendSize", ()=>CurveBendSize);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _styles = require("@mui/material/styles");
var _graph = require("./graph");
var _thumbnail = require("../../common/Thumbnail");
var _thumbnailDefault = parcelHelpers.interopDefault(_thumbnail);
var _types = require("common/api/v1/types");
var _helpers = require("common/api/v1/helpers");
var _icons = require("./icons");
var _info = require("../Overview/Info");
var _rist = require("common/rist");
var _utils = require("../Overview/utils");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _srt = require("common/srt");
const CIRCLE_RADIUS = 1.8;
const CHANNEL_COLORS = [
    {
        default: 'rgb(51, 102, 204)',
        highlight: 'rgb(103, 226, 191)'
    },
    {
        default: 'rgb(166,8,195)',
        highlight: 'rgb(211,113,227)'
    },
    {
        default: 'rgb(84, 116, 9)',
        highlight: 'rgb(167,230,17)'
    },
    {
        default: 'rgb(187, 109, 0)',
        highlight: 'rgb(255,151,2)'
    },
    {
        default: 'rgb(0, 155, 255)',
        highlight: 'rgb(97,187,243)'
    }
];
const defaultStyle = {
    baseColor: '#3366CC',
    highlightColor: 'rgb(103, 226, 191)',
    fillBaseColor: '#202631',
    fillHighlightColor: '#3D4451',
    textColor: '#ccc',
    errorColor: 'hsl(353, 57%, 61%)',
    errorHighlightColor: 'hsl(353, 57%, 75%)',
    warningColor: 'hsl(48, 75.3%, 63.5%)',
    warningHighlightColor: 'hsl(48, 75.3%, 83.5%)',
    disabledColor: 'rgba(255, 255, 255, 0.3)',
    disabledHighlightColor: 'rgba(255, 255, 255, 0.5)'
};
const AutoSizingSvg = ({ width, children, minContentWidth = 0 })=>{
    const svgRef = (0, _react.useRef)(null);
    const [bounds, setBounds] = (0, _react.useState)();
    (0, _react.useLayoutEffect)(()=>{
        if (!svgRef.current) return;
        const bb = svgRef.current.getBBox();
        setBounds({
            x: bb.x,
            y: bb.y,
            w: bb.width,
            h: bb.height
        });
    }, [
        children
    ]);
    // initial invisible pass for measurement
    if (!bounds) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        ref: svgRef,
        style: {
            overflow: 'visible',
            width,
            height: 'auto',
            display: 'block'
        },
        preserveAspectRatio: "xMidYMid meet",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            opacity: 0,
            children: children
        })
    });
    // compute viewBox dimensions
    const vbWidth = Math.max(bounds.w, minContentWidth);
    const vbHeight = bounds.h;
    const aspect = vbHeight / vbWidth;
    const height = width * aspect;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        ref: svgRef,
        viewBox: `${bounds.x} ${bounds.y} ${vbWidth} ${vbHeight}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMidYMid meet",
        style: {
            overflow: 'visible',
            display: 'block'
        },
        children: children
    });
};
function makeParentStyle(property, hoverColor = defaultStyle.highlightColor) {
    return {
        '&:hover .svgElement, & .highlight': {
            [property]: hoverColor,
            '&.error': {
                [property]: defaultStyle.errorHighlightColor
            },
            '&.errorStandby': {
                [property]: defaultStyle.errorHighlightColor
            },
            '&.disabled': {
                [property]: defaultStyle.disabledHighlightColor
            },
            '&.warning': {
                [property]: defaultStyle.warningHighlightColor
            }
        }
    };
}
function makeColorStyle(property) {
    return {
        [property]: defaultStyle.baseColor,
        '&.error': {
            [property]: defaultStyle.errorColor
        },
        '&.warning': {
            [property]: defaultStyle.warningColor
        },
        '&.disabled': {
            [property]: defaultStyle.disabledColor
        }
    };
}
const HoverableSvgParent = (0, _styles.styled)('g')(({ fillType, hoverColor })=>makeParentStyle(fillType, hoverColor));
const Circle = (0, _styles.styled)('circle')({
    fill: defaultStyle.fillBaseColor,
    stroke: defaultStyle.baseColor,
    '&.highlight': {
        fill: defaultStyle.fillHighlightColor,
        stroke: defaultStyle.highlightColor,
        '&.error': {
            stroke: defaultStyle.errorHighlightColor
        },
        '&.warning': {
            stroke: defaultStyle.warningHighlightColor
        }
    },
    '&.error': {
        stroke: defaultStyle.errorColor
    },
    '&.warning': {
        stroke: defaultStyle.warningColor
    },
    '&.disabled': {
        stroke: defaultStyle.disabledColor
    }
});
const Icon = (0, _styles.styled)('path')({
    ...makeColorStyle('fill')
});
function makeLine({ animationsEnabled, strokeColor, highlightColor }) {
    function lineCommon({ isAnimated, isStandby }) {
        const common = {
            strokeWidth: isStandby ? '0.6' : '0.35',
            strokeLinecap: 'round',
            '@keyframes so-streaming-data': {
                '0%': {
                    strokeDashoffset: '100%'
                },
                '100%': {
                    strokeDashoffset: '0%'
                }
            }
        };
        const specifics = animationsEnabled && isAnimated ? {
            animation: `so-streaming-data ${isStandby ? 180 : 90}s linear infinite`,
            strokeDasharray: isStandby ? '0.1 1.6' : '5 0.5'
        } : {
            animation: 'none',
            strokeDasharray: isStandby ? '0.1 1.6' : '0'
        };
        return {
            ...common,
            ...specifics
        };
    }
    return {
        ...lineCommon({
            isAnimated: true
        }),
        stroke: strokeColor,
        '&.highlight': {
            stroke: highlightColor
        },
        '&.error': {
            ...lineCommon({
                isAnimated: false
            }),
            stroke: defaultStyle.errorColor,
            '&.highlight': {
                stroke: defaultStyle.errorHighlightColor
            }
        },
        '&.warning': {
            stroke: defaultStyle.warningColor,
            '&.highlight': {
                stroke: defaultStyle.warningHighlightColor
            }
        },
        '&.standby': {
            ...lineCommon({
                isAnimated: true,
                isStandby: true
            })
        },
        '&.errorStandby': {
            ...lineCommon({
                isAnimated: false,
                isStandby: true
            }),
            stroke: defaultStyle.errorColor,
            '&.highlight': {
                stroke: defaultStyle.errorHighlightColor
            }
        },
        '&.disabled': {
            ...lineCommon({
                isAnimated: false
            }),
            stroke: defaultStyle.disabledColor,
            '&.highlight': {
                stroke: defaultStyle.disabledHighlightColor
            }
        }
    };
}
const Line = (0, _styles.styled)('path')(({ animationsEnabled = true, strokeColor = defaultStyle.baseColor, highlightColor = defaultStyle.highlightColor })=>makeLine({
        animationsEnabled,
        strokeColor,
        highlightColor
    }));
function coordsFromPosition(p) {
    if (!p) return [
        0,
        0
    ];
    return [
        p.x,
        p.y
    ];
}
function getRenderObjects(graph, input, parent, outputs, derivedInputs, appliances) {
    const lines = graph.edges.map((edge)=>{
        const { source, target } = edge;
        const sourceNode = (0, _graph.getNode)(graph, source);
        const targetNode = (0, _graph.getNode)(graph, target);
        const sourcePosition = coordsFromPosition(sourceNode.position);
        const targetPosition = coordsFromPosition(targetNode.position);
        const fromType = sourceNode.data.type;
        const toType = targetNode.data.type;
        const lineType = toType === (0, _types.GraphNodeType).derivedInput ? "deriveFromParent" : fromType === (0, _types.GraphNodeType).parentInputLogicalPort ? "deriveFrom" : fromType === (0, _types.GraphNodeType).inputLogicalPort ? "inputPortStream" : toType === (0, _types.GraphNodeType).output ? "outputPortStream" : "connection";
        const output = lineType === "outputPortStream" ? outputs.find((o)=>o.id === targetNode.data.id) : undefined;
        const { lineClass } = lineType === "deriveFromParent" ? getDerivedInputHandoverStatus(input, edge.streamId) : lineType === "deriveFrom" ? getDerivedInputHandoverStatus(parent, edge.streamId) : lineType === "inputPortStream" ? getInputPortStatus(input, edge.streamId) : lineType === "outputPortStream" ? getOutputPortStatus(output, edge.streamId, edge.logicalPortId, output?.appliances?.find((a)=>a.id === sourceNode.data.id), input.adminStatus === (0, _types.InputAdminStatus).off) : getConnectionStatus(lineType, input, outputs, sourceNode.data.id, targetNode.data.id);
        let activeChannelId = undefined;
        if (sourceNode.data.type === (0, _types.GraphNodeType).inputLogicalPort || sourceNode.data.type === (0, _types.GraphNodeType).parentInputLogicalPort) activeChannelId = sourceNode.data.meta.channelId;
        else {
            const isApplianceNode = (node)=>node.startsWith('appliance');
            const applianceNode = isApplianceNode(source) ? sourceNode : isApplianceNode(target) ? targetNode : undefined;
            if (applianceNode) {
                const { sendMetrics } = (0, _info.getConnectionMetrics)(input, output ? [
                    output
                ] : [], sourceNode.data.id, targetNode.data.id);
                activeChannelId = sendMetrics?.channelId ?? (0, _utils.getActiveChannelId)(applianceNode.data.id, input, output ? [
                    output
                ] : []);
            }
        }
        return {
            from: sourcePosition,
            to: targetPosition,
            curveType: "straight",
            curveBendSize: undefined,
            id: lineType === "connection" ? `${sourceNode.data.id}>${targetNode.data.id}` : lineType === "inputPortStream" ? `${sourceNode.data.id}-${edge.logicalPortId}` : `${targetNode.data.id}-${edge.logicalPortId}`,
            data: {
                type: lineType,
                fromType,
                toType,
                fromId: sourceNode.data.id,
                toId: targetNode.data.id,
                logicalPortId: edge.logicalPortId,
                streamId: edge.streamId,
                channelId: activeChannelId
            },
            lineClass
        };
    });
    const nodeNames = (0, _graph.graphNodeNames)(graph);
    const { circles, icons } = nodeNames.reduce(({ circles, icons }, n)=>{
        const node = (0, _graph.getNode)(graph, n);
        const coords = coordsFromPosition(node.position);
        switch(node.data.type){
            case (0, _types.GraphNodeType).inputLogicalPort:
                {
                    const { svg, style } = getInputIconStatus(input?.health, input?.adminStatus === (0, _types.InputAdminStatus).off, parent);
                    icons.push({
                        svg,
                        textPositioning: "top",
                        rect: {
                            width: 5.2,
                            height: 4.6,
                            xOffset: parent ? -2.6 : -3.1,
                            yOffset: -2.3
                        },
                        xOffset: -12,
                        yOffset: -12,
                        coords: coords,
                        scale: 0.24,
                        title: node.name,
                        type: node.data.type,
                        data: node.data,
                        id: node.data.id,
                        style
                    });
                }
                break;
            case (0, _types.GraphNodeType).parentInputLogicalPort:
                {
                    const { svg, style } = getInputIconStatus(parent?.health, parent?.adminStatus === (0, _types.InputAdminStatus).off, undefined);
                    icons.push({
                        svg,
                        textPositioning: "top",
                        rect: {
                            width: 5.2,
                            height: 4.6,
                            xOffset: -3.1,
                            yOffset: -2.3
                        },
                        xOffset: -12,
                        yOffset: -12,
                        coords: coords,
                        scale: 0.24,
                        title: node.name,
                        type: node.data.type,
                        data: node.data,
                        id: node.data.id,
                        style
                    });
                }
                break;
            case (0, _types.GraphNodeType).output:
                {
                    const output = outputs.find((o)=>o.id === node.data.id);
                    const { svg, style } = getOutputIconStatus(output?.health, output?.adminStatus === (0, _types.OutputAdminStatus).off || input?.adminStatus === (0, _types.InputAdminStatus).off);
                    icons.push({
                        svg,
                        textPositioning: "top",
                        rect: {
                            width: 5.4,
                            height: 4.8,
                            xOffset: -2.1,
                            yOffset: -2.5
                        },
                        xOffset: -11,
                        yOffset: -11,
                        coords: coords,
                        scale: 0.24,
                        title: node.name,
                        type: node.data.type,
                        id: node.data.id,
                        style
                    });
                }
                break;
            case (0, _types.GraphNodeType).derivedInput:
                {
                    const derivedInput = derivedInputs.find((d)=>d.id === node.data.id);
                    const { svg, style } = getDerivedInputIconStatus(derivedInput?.health, derivedInput?.adminStatus === (0, _types.InputAdminStatus).off);
                    icons.push({
                        svg,
                        textPositioning: "top",
                        rect: {
                            width: 5.2,
                            height: 4.6,
                            xOffset: -2.6,
                            yOffset: -2.3
                        },
                        xOffset: -12,
                        yOffset: -12,
                        coords: coords,
                        scale: 0.24,
                        title: node.name,
                        type: node.data.type,
                        id: node.data.id,
                        style
                    });
                }
                break;
            default:
                {
                    const allMetrics = (0, _utils.extractTr101290Metrics)(input, outputs);
                    const { style } = getApplianceIconStatus(input?.tr101290Enabled ?? true, (0, _utils.isApplianceStandby)(node.data.id, input, outputs), appliances.find((a)=>a.id === node.data.id), allMetrics.find((v)=>v.applianceId === node.data.id), input.adminStatus === (0, _types.InputAdminStatus).off);
                    if (node.data.type === (0, _types.GraphNodeType).thumbAppliance) icons.push({
                        svg: (0, _icons.ThumbIconSvg),
                        textPositioning: "top",
                        rect: {
                            width: 5.4,
                            height: 4.8,
                            xOffset: -2.1,
                            yOffset: -2.5
                        },
                        xOffset: -11,
                        yOffset: -11,
                        coords: coords,
                        scale: 0.22,
                        title: node.name,
                        type: node.data.type,
                        id: node.data.id,
                        style
                    });
                    else circles.push({
                        center: coords,
                        radius: CIRCLE_RADIUS,
                        title: node.name,
                        type: node.data.type,
                        id: node.data.id,
                        style
                    });
                }
        }
        return {
            circles,
            icons
        };
    }, {
        circles: [],
        icons: []
    });
    return {
        lines,
        circles,
        icons
    };
}
function ServiceOverviewGraph({ graph, selectedItem, onSelect, outputId, input, parent, outputs, derivedInputs, appliances, isAnimationEnabled }) {
    const { textColor, fillBaseColor } = defaultStyle;
    const containerRef = (0, _react.useRef)(null);
    const [svgWidth, setSvgWidth] = (0, _react.useState)(800);
    (0, _react.useLayoutEffect)(()=>{
        const calculateResponsiveSvgWidth = ()=>{
            if (!containerRef.current) return;
            const containerWidth = containerRef.current.offsetWidth;
            const extraPadding = 80 // Add some more padding/margins to prevent overflow
            ;
            const availableWidth = containerWidth - extraPadding;
            const minWidth = containerWidth * 0.8;
            const maxWidth = 1800;
            const boundedWidth = Math.min(maxWidth, Math.max(minWidth, availableWidth));
            setSvgWidth(boundedWidth);
        };
        calculateResponsiveSvgWidth();
        const handleResize = calculateResponsiveSvgWidth;
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    const { graph: graphToRender, maxNumberOfXCols } = (0, _graph.layout)(graph);
    const { lines, circles, icons } = getRenderObjects(graphToRender, input, parent, outputs, derivedInputs, appliances);
    avoidOverlappingLines(lines.filter((line)=>line.curveType === "straight"));
    const getScaledXColSize = (width)=>{
        // The xColSize is a scaling factor that converts logical coordinates to SVG coordinate units.
        // When you make xColSize smaller, you're making the viewBox smaller, which causes the browser to zoom in on the content.
        // 45 was chosen through trial and error by testing what "looked good" at different screen sizes and
        // means "for every 45 pixels wider/narrower, add/remove spacing (making elements appear smaller/larger)"
        const scaleFactor = 45;
        const minXColSize = 1 // Don't allow 0
        ;
        return Math.max(minXColSize, Math.round(width / scaleFactor));
    };
    const getScaledNodeTextFontSize = (width)=>{
        if (width >= 880) return 2.6;
        if (width >= 750) return 2.2;
        if (width >= 600) return 1.8;
        // Testing shows that scaling is only necessary when on smaller screens
        const minFontSize = 1.2;
        const maxFontSize = 2.6;
        const baseSize = 2.2;
        const scaleFactor = Math.sqrt(width / 1200);
        const scaledSize = baseSize * scaleFactor;
        return Math.max(minFontSize, Math.min(maxFontSize, scaledSize));
    };
    const xColSize = getScaledXColSize(svgWidth);
    const nodeTextFontSize = getScaledNodeTextFontSize(svgWidth);
    const yColSize = 12;
    const radius = 1;
    let nextColorIdx = 0;
    const channelColorMap = lines.reduce((map, line)=>{
        let channelColorIndex = nextColorIdx;
        const channelId = line.data?.channelId;
        if (channelId !== undefined) {
            channelColorIndex = map[channelId] ?? nextColorIdx++ % CHANNEL_COLORS.length;
            map[channelId] = channelColorIndex;
        }
        return map;
    }, {});
    const numChannels = Object.keys(channelColorMap).length;
    let channelColorMappingSvg = null;
    if (numChannels > 1) {
        const rowHeight = yColSize * 2;
        const totalHeight = rowHeight * numChannels;
        const children = Object.entries(channelColorMap).map(([channelId, colorIndex], lineIndex)=>{
            const baseYOffset = rowHeight;
            const y = baseYOffset + lineIndex * rowHeight;
            const lineYMargin = -5;
            const channelColors = CHANNEL_COLORS[colorIndex];
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                height: rowHeight,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        height: rowHeight,
                        dx: 0,
                        y: y,
                        style: {
                            fontSize: '13px'
                        },
                        fill: textColor,
                        children: `Channel ID: ${channelId}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Line, {
                        height: rowHeight,
                        d: `M${150},${y + lineYMargin} h${130}`,
                        strokeColor: channelColors.default,
                        highlightColor: channelColors.highlight,
                        animationsEnabled: isAnimationEnabled,
                        fill: 'transparent',
                        style: {
                            pointerEvents: 'none',
                            strokeWidth: 4
                        },
                        className: "svgElement"
                    })
                ]
            }, channelId);
        });
        channelColorMappingSvg = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            width: "320px",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                style: {
                    marginTop: 50
                },
                width: '100%',
                height: totalHeight,
                children: children
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: containerRef,
        style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            overflowX: 'auto',
            overflowY: 'visible',
            width: '100%',
            maxWidth: '100%'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "data-test-id": "overview-graph",
                style: {
                    marginTop: 20
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AutoSizingSvg, {
                    width: svgWidth,
                    minContentWidth: maxNumberOfXCols * xColSize,
                    children: [
                        lines.map((line)=>{
                            const { from, to, id, data, lineClass, curveType, curveBendSize: curveSize } = line;
                            const type = data && data.type || "connection";
                            const scale = scalePoint(xColSize, yColSize);
                            const [x1, y1] = scale(from);
                            const [x2, y2] = scale(to);
                            const highlighted = selectedItem?.type == type && selectedItem?.id == id;
                            const pathPos = `M${x1},${y1}`;
                            const pathString = curveType === "straight" ? `${pathPos} L${x2},${y2}` : `${pathPos} Q${controlPoint([
                                x1,
                                y1
                            ], [
                                x2,
                                y2
                            ], curveType, curveSize).join(',')} ${x2},${y2}`;
                            const channelId = line.data?.channelId;
                            const channelColorIndex = channelId !== undefined ? channelColorMap[channelId] : 0;
                            const channelColors = CHANNEL_COLORS[channelColorIndex];
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(HoverableSvgParent, {
                                fillType: 'stroke',
                                hoverColor: channelColors.highlight,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Line, {
                                        d: pathString,
                                        strokeColor: channelColors.default,
                                        highlightColor: channelColors.highlight,
                                        fill: 'transparent',
                                        style: {
                                            pointerEvents: 'none'
                                        },
                                        animationsEnabled: isAnimationEnabled,
                                        className: (0, _classnamesDefault.default)('svgElement', lineClass, highlighted ? 'highlight' : '')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: pathString,
                                        fill: 'transparent',
                                        stroke: 'transparent',
                                        strokeWidth: 3,
                                        pointerEvents: "visibleStroke",
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        onClick: ()=>onSelect({
                                                type,
                                                id,
                                                data
                                            })
                                    })
                                ]
                            }, id);
                        }).reverse(),
                        circles.map((circle)=>{
                            const { center: [cx, cy], id, title, radius: r, style } = circle;
                            let highlighted = false;
                            if (selectedItem) {
                                const { id: selectedId, type: selectedType } = selectedItem;
                                highlighted = highlighted || selectedType == circle.type && selectedId == id;
                            }
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(HoverableSvgParent, {
                                fillType: "stroke",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Circle, {
                                        cx: cx * xColSize,
                                        cy: cy * yColSize,
                                        r: r,
                                        strokeWidth: 0.4,
                                        onClick: ()=>onSelect({
                                                type: circle.type,
                                                id
                                            }),
                                        className: (0, _classnamesDefault.default)('svgElement', style, highlighted ? ' highlight' : ''),
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                        style: {
                                            fontSize: nodeTextFontSize,
                                            cursor: 'pointer'
                                        },
                                        fill: textColor,
                                        textAnchor: "middle",
                                        x: cx * xColSize,
                                        y: cy * yColSize - radius * 2.8,
                                        onClick: ()=>{
                                            onSelect({
                                                type: circle.type,
                                                id
                                            });
                                        },
                                        children: maxLength(title, 22)
                                    })
                                ]
                            }, id);
                        }),
                        icons.map((icon)=>{
                            const { coords: [x, y], id, textPositioning, title, data, scale, rect, xOffset, yOffset, svg, style } = icon;
                            const name = id;
                            let highlighted = false;
                            if (selectedItem) {
                                const { id: selectedId, type: selectedType } = selectedItem;
                                highlighted = highlighted || selectedType == icon.type && selectedId == id;
                            }
                            const { x: textPosX, y: textPosY, textAnchor } = getIconTextPos({
                                pos: {
                                    x,
                                    y
                                },
                                scale: {
                                    x: xColSize,
                                    y: yColSize
                                },
                                textPositioning
                            });
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(HoverableSvgParent, {
                                fillType: svg.fillType,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: rect.width,
                                        height: rect.height,
                                        fill: fillBaseColor,
                                        x: x * xColSize + rect.xOffset,
                                        y: y * yColSize + rect.yOffset,
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        onClick: ()=>onSelect({
                                                type: icon.type,
                                                id,
                                                data
                                            })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                                        transform: `translate(${x * xColSize} ${y * yColSize}) scale(${scale}) translate(${xOffset} ${yOffset})`,
                                        d: svg.path,
                                        onClick: ()=>onSelect({
                                                type: icon.type,
                                                id,
                                                data
                                            }),
                                        className: (0, _classnamesDefault.default)('svgElement', style, highlighted ? ' highlight' : ''),
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                        style: {
                                            fontSize: nodeTextFontSize,
                                            cursor: 'pointer'
                                        },
                                        fill: textColor,
                                        textAnchor: textAnchor,
                                        x: textPosX,
                                        y: textPosY,
                                        onClick: ()=>{
                                            onSelect({
                                                type: icon.type,
                                                id,
                                                data
                                            });
                                        },
                                        children: maxLength(title, 18)
                                    })
                                ]
                            }, name);
                        })
                    ]
                })
            }),
            channelColorMappingSvg,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbnailSection, {
                additionalTopMargin: outputs.length + (derivedInputs?.length ?? 0) <= 1,
                input: input,
                parent: parent
            })
        ]
    });
}
function ThumbnailSection({ input, parent, additionalTopMargin }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
        id: "thumbnails-section",
        style: {
            display: 'flex',
            justifyContent: 'flex-start',
            ...additionalTopMargin ? {
                marginTop: '40px'
            } : {}
        },
        children: [
            parent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputThumbnails, {
                input: parent
            }, parent.id) || null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputThumbnails, {
                input: input
            }, input.id)
        ]
    });
}
function InputThumbnails({ input }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        container: true,
        style: {
            flexGrow: 0
        },
        children: input.adminStatus === (0, _types.InputAdminStatus).on && input.thumbnailMode === (0, _types.ThumbnailMode).core ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            width: "320px",
            marginLeft: "8px",
            position: "relative",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnailDefault.default), {
                    input: input
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbnailLabel, {
                    children: input.name
                })
            ]
        }, input.id) : input.channelIds?.map((channelId)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                width: "320px",
                marginLeft: "8px",
                marginTop: "8px",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnailDefault.default), {
                        input: input,
                        channelId: channelId,
                        ageOverlayThreshold: 15000
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ThumbnailLabel, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: input.name
                            }),
                            input.channelIds?.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Channel ID: ",
                                    channelId
                                ]
                            })
                        ]
                    })
                ]
            }, channelId.toString()))
    });
}
function ThumbnailLabel(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bgcolor: "rgba(0, 0, 0, 0.5)" // Slightly grayed-out background
        ,
        color: "white" // Text color
        ,
        padding: "4px",
        textAlign: "center",
        children: props.children
    });
}
function getIconTextPos({ pos, scale, textPositioning }) {
    const xColSize = scale.x;
    const yColSize = scale.y;
    switch(textPositioning){
        case "top":
            {
                const x = pos.x * xColSize;
                const y = pos.y * yColSize - 2.8;
                const textAnchor = 'middle';
                return {
                    x,
                    y,
                    textAnchor
                };
            }
        case "right":
            {
                const x = pos.x * xColSize + 2.8;
                const y = pos.y * yColSize + 0.75;
                const textAnchor = 'start';
                return {
                    x,
                    y,
                    textAnchor
                };
            }
    }
}
var NMGraphLineType = /*#__PURE__*/ function(NMGraphLineType) {
    // Line connecting input port and input appliance
    NMGraphLineType["inputPortStream"] = "inputPortStream";
    // Line connecting output appliance and output
    NMGraphLineType["outputPortStream"] = "outputPortStream";
    // Line connecting parent input port and input port
    NMGraphLineType["deriveFrom"] = "deriveFrom";
    // Line connecting appliance and output of type "derived input"
    NMGraphLineType["deriveFromParent"] = "deriveFromParent";
    // Line connecting two appliances
    NMGraphLineType["connection"] = "connection";
    return NMGraphLineType;
}({});
var LineCurve = /*#__PURE__*/ function(LineCurve) {
    LineCurve["straight"] = "straight";
    LineCurve["curveClockwise"] = "curveClockwise";
    LineCurve["curveAntiClockwise"] = "curveAntiClockwise";
    return LineCurve;
}(LineCurve || {});
var CurveBendSize = /*#__PURE__*/ function(CurveBendSize) {
    CurveBendSize["small"] = "small";
    CurveBendSize["big"] = "big";
    return CurveBendSize;
}({});
var IconTextPositioning = /*#__PURE__*/ function(IconTextPositioning) {
    IconTextPositioning["top"] = "top";
    IconTextPositioning["right"] = "right";
    return IconTextPositioning;
}(IconTextPositioning || {});
function maxLength(v, length) {
    if (v.length <= length) return v;
    return v.substring(0, length) + '...';
}
const getConnectionStatus = (type, input, outputs, from, to)=>{
    if (type !== "connection") return {
        lineClass: 'base'
    };
    if (input.adminStatus === (0, _types.InputAdminStatus).off) return {
        lineClass: 'disabled'
    };
    const { sendMetrics, receiveMetrics } = (0, _info.getConnectionMetrics)(input, outputs, from, to);
    const minimumAcceptableBitrate = (0, _helpers.getMinimumAcceptableInputBitrateBps)((input.tsInfo || [])[0]);
    const metricsMissing = !sendMetrics || !receiveMetrics;
    if (metricsMissing) return {
        lineClass: 'error'
    };
    const standby = receiveMetrics?.multipathState === (0, _types.RistInputMultipathState).standby;
    if (standby) // Low bitrate is expected if it's in standby
    return {
        lineClass: 'standby'
    };
    const bitrateTooLow = sendMetrics.sendBitrate < minimumAcceptableBitrate || receiveMetrics.receiveBitrate < minimumAcceptableBitrate;
    if (bitrateTooLow) return {
        lineClass: 'error'
    };
    return {
        lineClass: 'base'
    };
};
const getDerivedInputHandoverStatus = (parentInput, derivedInputSinkStreamId)=>{
    if (!parentInput) // This should never happen (this function should only be called when there is a parent input)
    return {
        lineClass: 'error'
    };
    if (!derivedInputSinkStreamId) return {
        lineClass: 'error'
    };
    const handoverMetric = parentInput.metrics?.ristMetrics.find((m)=>m.streamId === derivedInputSinkStreamId && m.window === (0, _types.MetricWindow).s10 && m.type === (0, _types.RistMetricType).udpOutput);
    const minimumAcceptableBitrate = (0, _helpers.getMinimumAcceptableInputBitrateBps)((parentInput.tsInfo || [])[0]);
    if (!handoverMetric || handoverMetric.sendBitrate < minimumAcceptableBitrate) return {
        lineClass: 'error'
    };
    return {
        lineClass: 'base'
    };
};
const getInputPortStatus = (input, streamId)=>{
    if (input.adminStatus === (0, _types.InputAdminStatus).off) return {
        lineClass: 'disabled'
    };
    const inputPort = input.ports?.find((port)=>port.internalStreamId === streamId);
    const streamMetrics = input.metrics?.ristMetrics.find((m)=>m.streamId === streamId);
    const applianceId = streamMetrics?.applianceId;
    const portsOnThisAppliance = input.ports?.filter((p)=>p.appliance === applianceId) || [];
    const isBondedSrt = portsOnThisAppliance.length > 1 && portsOnThisAppliance.every((p)=>p.mode === (0, _types.IpPortMode).srt) && new Set(portsOnThisAppliance.map((p)=>p.priority)).size === 1;
    const receiveMetrics = input.metrics?.ristMetrics.find((metric)=>(metric.streamId === streamId || isBondedSrt) && (0, _helpers.isAnyRistServerInputMetrics)(metric));
    const minimumAcceptableBitrate = (0, _helpers.getMinimumAcceptableInputBitrateBps)((input.tsInfo || [])[0]);
    let notOk = !receiveMetrics || receiveMetrics?.type !== (0, _types.RistMetricType).udpInput && receiveMetrics?.receiveBitrate < minimumAcceptableBitrate || // Source failover RTP inputs are actually UDP inputs with packetFormat: RTP which thus gets handled below here
    receiveMetrics?.type === (0, _types.RistMetricType).udpInput && receiveMetrics?.receiveBitrate === 0 && (receiveMetrics?.packetsWhileInactive === 0 || receiveMetrics?.status === (0, _rist.UdpInputStatusCode).active && receiveMetrics?.packetsWhileInactive > 0);
    if (!notOk && isBondedSrt) {
        const srtInputMetrics = input.metrics?.ristMetrics.find((m)=>m.type === (0, _types.SrtMetricType).srtInput && m.streamId === streamId);
        notOk = srtInputMetrics?.connectionStatus !== (0, _srt.SrtConnectionStatus).connected;
    }
    const standbyChecks = {
        [(0, _types.IpPortMode).srt]: ()=>{
            if (!isBondedSrt) return false;
            const srtInputMetrics = input.metrics?.ristMetrics.find((m)=>m.type === (0, _types.SrtMetricType).srtInput && m.streamId === streamId);
            return srtInputMetrics && srtInputMetrics.connectionStatus === (0, _srt.SrtConnectionStatus).connected && srtInputMetrics.bitrate === 0;
        }
    };
    const defaultStandbyCheck = ()=>receiveMetrics?.type === (0, _types.RistMetricType).udpInput && receiveMetrics?.status === (0, _rist.UdpInputStatusCode).standby;
    const standbyCheck = inputPort?.mode && standbyChecks[inputPort?.mode] || defaultStandbyCheck;
    if (notOk) {
        if (standbyCheck()) return {
            lineClass: 'errorStandby'
        };
        else return {
            lineClass: 'error'
        };
    } else {
        if (standbyCheck()) return {
            lineClass: 'standby'
        };
        else return {
            lineClass: 'base'
        };
    }
};
const getOutputPortStatus = (output, streamId, logicalPortId, portAppliance, inputDisabled)=>{
    if (!output) return {
        lineClass: 'error'
    };
    if (inputDisabled) return {
        lineClass: 'disabled'
    };
    const outputPort = output.ports.find((port)=>port.id === logicalPortId);
    const isBondedSrtOutput = output.ports.every((port)=>port.mode === (0, _types.IpPortMode).srt);
    const firstPort = output.ports[0];
    const isBondedSrtCallerOutput = isBondedSrtOutput && firstPort.mode === (0, _types.IpPortMode).srt && firstPort.srtMode === (0, _types.SrtMode).caller;
    const isMainBackupSrtBondedOutput = isBondedSrtCallerOutput && new Set(output.ports.map((p)=>p.failoverPriority)).size > 1;
    const isBondedSrtListener = isBondedSrtOutput && !isBondedSrtCallerOutput;
    // If an input with a channel group (i.e. multi-appliance input) is assigned to an output
    // then, in order for the ristserver to be able to perform failover between the different channels,
    // one ristserver-output is created for each channel in the channel group (in the appliance config, not in the db) .
    // These outputs all have the same stream id, but only one of them is active at any given time (i.e. the one with a sendBitrate).
    const activeRistserverSendMetric = (output.metrics?.ristMetrics ?? [])// For bonded srt outputs, there will be a single ristserver output for all the bonded srt ports
    .filter((m)=>(m.streamId === streamId || isBondedSrtOutput) && (0, _helpers.isRistServerEgressMetrics)(m)).reduce((prev, current)=>(prev?.sendBitrate ?? 0) > (current?.sendBitrate ?? 0) ? prev : current, undefined);
    // Use minimum acceptable input bitrate as the required output bitrate
    const minimumAcceptableBitrate = (0, _helpers.getMinimumAcceptableInputBitrateBps)((output.tsInfo || [])[0]);
    // Check the ristserver send metrics (i.e. the outgoing udp/rtp/rist bitrates)
    if (!activeRistserverSendMetric || activeRistserverSendMetric?.sendBitrate < minimumAcceptableBitrate) return {
        lineClass: 'error'
    };
    const outputApplianceType = portAppliance?.type;
    const isVa = outputApplianceType && (0, _applianceTypeUtil.isVaApplianceType)(outputApplianceType);
    const ristserverOutputPortMode = (0, _helpers.isRistServerPortMode)(outputPort?.mode);
    const isMatroxOutput = outputPort && (0, _helpers.isMatroxPortMode)(outputPort.mode);
    const isComprimatoOutput = outputPort && (0, _helpers.isComprimatoPortMode)(outputPort.mode);
    if (ristserverOutputPortMode || isVa || isMatroxOutput || isComprimatoOutput || outputPort?.mode === (0, _types.CoaxPortMode).sdi) return {
        lineClass: 'base'
    };
    // Check the corresponding non-native output metrics (i.e. RTMP/Zixi/SRT etc)
    const nonRistserverSendMetric = output.metrics?.ristMetrics.find((metric)=>outputPort && outputApplianceType && metric.type === (0, _helpers.getMetricTypeForOutput)(outputPort.mode, outputApplianceType) && metric.streamId === streamId);
    let nonRistserverOutputBitrate;
    if (nonRistserverSendMetric) switch(nonRistserverSendMetric.type){
        case (0, _types.RtmpMetricType).rtmpOutput:
            nonRistserverOutputBitrate = nonRistserverSendMetric.sendBitrateKbps * 1000;
            break;
        case (0, _types.ZixiMetricType).zixiOutput:
        case (0, _types.SrtMetricType).srtOutput:
            nonRistserverOutputBitrate = nonRistserverSendMetric.bitrate;
            if ((isMainBackupSrtBondedOutput || isBondedSrtListener) && nonRistserverOutputBitrate === 0) {
                const otherSrtOutputMetric = output.metrics?.ristMetrics.find((m)=>m.type === (0, _types.SrtMetricType).srtOutput && m.streamId !== streamId);
                if (otherSrtOutputMetric && otherSrtOutputMetric.bitrate > 0 && nonRistserverSendMetric.connectionStatus === (0, _srt.SrtConnectionStatus).connected) return {
                    lineClass: 'standby'
                };
                 // else this will be handled as an error per below
            }
            break;
    }
    if (!nonRistserverOutputBitrate || nonRistserverOutputBitrate < minimumAcceptableBitrate) return {
        lineClass: 'error'
    };
    return {
        lineClass: 'base'
    };
};
const getApplianceIconStatus = (isTr101290Enabled, isApplianceStandby, appliance, tr101290Metrics, disabled)=>{
    const isMissingTr101290Metrics = isTr101290Enabled && !isApplianceStandby && (!tr101290Metrics || !tr101290Metrics.prio1 || !tr101290Metrics.prio2);
    const hasTr101290Errors = isTr101290Enabled && Object.values({
        ...tr101290Metrics?.prio1
    }).some((value)=>value > 0);
    if (disabled) return {
        style: 'disabled'
    };
    switch(appliance?.health?.state){
        case (0, _types.ApplianceConnectionState).missing:
        case (0, _types.ApplianceConnectionState).neverConnected:
            return {
                style: 'error'
            };
        case (0, _types.ApplianceConnectionState).connected:
        // Default case handles where user can't see Appliance stats but can see tr101290
        default:
            if (isMissingTr101290Metrics || hasTr101290Errors) return {
                style: 'warning'
            };
            else return {
                style: 'base'
            };
    }
};
const getInputIconStatus = (status, disabled, parentInput)=>{
    if (disabled) return {
        svg: (0, _icons.NotInterestedSvg),
        style: 'disabled'
    };
    const isDerivedInput = !!parentInput;
    const inputIcon = isDerivedInput ? (0, _icons.TranscodeSvg) : (0, _icons.InputSvg);
    switch(status?.state){
        case (0, _types.InputOperStatus).allOk:
            return {
                svg: inputIcon,
                style: 'base'
            };
        case (0, _types.InputOperStatus).inputError:
            return {
                svg: inputIcon,
                style: 'error'
            };
        case (0, _types.InputOperStatus).notConfigured:
            return {
                svg: inputIcon,
                style: 'base'
            };
        case (0, _types.InputOperStatus).tr101290Priority1Error:
            return {
                svg: inputIcon,
                style: 'warning'
            };
        case (0, _types.InputOperStatus).transportError:
            return {
                svg: inputIcon,
                style: 'error'
            };
        case (0, _types.InputOperStatus).reducedRedundancy:
            return {
                svg: inputIcon,
                style: 'base'
            };
        case (0, _types.InputOperStatus).metricsMissing:
        default:
            return {
                svg: inputIcon,
                style: 'warning'
            };
    }
};
const getDerivedInputIconStatus = (status, disabled)=>{
    if (disabled) return {
        svg: (0, _icons.NotInterestedSvg),
        style: 'disabled'
    };
    const derivedInputIcon = (0, _icons.TranscodeSvg);
    switch(status?.state){
        case (0, _types.InputOperStatus).allOk:
            return {
                svg: derivedInputIcon,
                style: 'base'
            };
        case (0, _types.InputOperStatus).inputError:
            return {
                svg: derivedInputIcon,
                style: 'error'
            };
        case (0, _types.InputOperStatus).notConfigured:
            return {
                svg: derivedInputIcon,
                style: 'base'
            };
        case (0, _types.InputOperStatus).tr101290Priority1Error:
            return {
                svg: derivedInputIcon,
                style: 'warning'
            };
        case (0, _types.InputOperStatus).transportError:
            return {
                svg: derivedInputIcon,
                style: 'error'
            };
        case (0, _types.InputOperStatus).reducedRedundancy:
            return {
                svg: derivedInputIcon,
                style: 'base'
            };
        case (0, _types.InputOperStatus).metricsMissing:
        default:
            return {
                svg: derivedInputIcon,
                style: 'warning'
            };
    }
};
const getOutputIconStatus = (status, disabled)=>{
    const outputIcon = (0, _icons.OndemandVideoOutlinedSvg);
    if (disabled) return {
        svg: (0, _icons.NotInterestedSvg),
        style: 'disabled'
    };
    switch(status?.state){
        case (0, _types.OutputOperStatus).allOk:
            return {
                svg: outputIcon,
                style: 'base'
            };
        case (0, _types.OutputOperStatus).notAcknowledged:
            return {
                svg: outputIcon,
                style: 'base'
            };
        case (0, _types.OutputOperStatus).inputError:
            return {
                svg: outputIcon,
                style: 'error'
            };
        case (0, _types.OutputOperStatus).notConfigured:
            return {
                svg: outputIcon,
                style: 'base'
            };
        case (0, _types.OutputOperStatus).outputError:
            return {
                svg: outputIcon,
                style: 'error'
            };
        case (0, _types.OutputOperStatus).reducedRedundancy:
            return {
                svg: outputIcon,
                style: 'base'
            };
        case (0, _types.OutputOperStatus).tr101290Priority1Error:
            return {
                svg: outputIcon,
                style: 'warning'
            };
        case (0, _types.OutputOperStatus).metricsMissing:
        case (0, _types.OutputOperStatus).alarm:
        default:
            return {
                svg: outputIcon,
                style: 'warning'
            };
    }
};
function avoidOverlappingLines(lines) {
    const linesAndSlope = lines.map((l)=>{
        const lineWithSlope = {
            line: l,
            slope: slope(l)
        };
        return lineWithSlope;
    });
    linesAndSlope.sort((l1, l2)=>{
        if (l1.slope < l2.slope) return -1;
        if (l1.slope > l2.slope) return 1;
        if (l1.line.from[0] < l2.line.from[0]) return -1;
        if (l1.line.from[0] > l2.line.from[0]) return 1;
        if (l1.line.to[0] > l2.line.to[0]) return -1;
        if (l1.line.to[0] < l2.line.to[0]) return 1;
        return 0;
    });
    let lastItem;
    let overlapReference;
    for (const item of linesAndSlope){
        if (lastItem && overlaps(overlapReference || lastItem, item)) {
            if (!overlapReference) overlapReference = lastItem;
            overlapReference.line.curveType = "curveAntiClockwise";
        } else overlapReference = undefined;
        lastItem = item;
    }
    const ylength = ({ from, to })=>Math.abs(to[1] - from[1]);
    const infinitySlope = linesAndSlope.filter((l)=>(l.slope === -Infinity || l.slope === Infinity) && ylength(l.line) > 1);
    for (const { line } of infinitySlope)if (line.curveType === "straight") line.curveType = "curveAntiClockwise";
}
function overlaps({ line: line1, slope: slope1 }, { line: line2, slope: slope2 }) {
    if (slope1 != slope2) return false;
    const m1 = line1.from[1] - slope1 * line1.from[0];
    const m2 = line2.from[1] - slope1 * line2.from[0];
    const doesOverlap = line1.to[0] > line2.from[0] && m1 == m2;
    return doesOverlap;
}
function slope(line) {
    const { from, to } = line;
    const dx = to[0] - from[0];
    const dy = to[1] - from[1];
    return dy / dx;
}
function controlPoint(from, to, curveType, curveSize) {
    const offset = (curveSize === "big" ? 6 : 3) * CIRCLE_RADIUS;
    const [x1, y1] = from;
    const [x2, y2] = to;
    const dx = x2 - x1;
    const dy = y2 - y1;
    const tanAlpha = dy / dx;
    const alpha = Math.atan(tanAlpha);
    const midx = (x2 + x1) / 2;
    const midy = (y1 + y2) / 2;
    const sinAlpha = Math.sin(alpha);
    const cosAlpha = Math.cos(alpha);
    const tmpOffsetX = -sinAlpha * offset;
    const tmpOffsetY = cosAlpha * offset;
    const offsetX = curveType === "curveAntiClockwise" ? tmpOffsetX : -tmpOffsetX;
    const offsetY = curveType === "curveAntiClockwise" ? tmpOffsetY : -tmpOffsetY;
    const x3 = midx + offsetX;
    const y3 = midy + offsetY;
    // console.log(`Control point from`, { from, to, x3, y3, offsetX, offsetY })
    return [
        x3,
        y3
    ];
}
function scalePoint(xscale, yscale) {
    return function(c) {
        return [
            c[0] * xscale,
            c[1] * yscale
        ];
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","classnames":"5Een2","@mui/material/Box":"c4QkF","@mui/material/Grid":"6iX4B","@mui/material/styles":"2UrBk","./graph":"ki8Sm","../../common/Thumbnail":"5Q8KF","common/api/v1/types":"3qemx","common/api/v1/helpers":"6jovr","./icons":"fL0os","../Overview/Info":"iFdZy","common/rist":"eyUJa","../Overview/utils":"foCTx","common/applianceTypeUtil":"3z9on","common/srt":"9Ptuu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ki8Sm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "graphNodeNames", ()=>graphNodeNames);
parcelHelpers.export(exports, "layout", ()=>layout);
parcelHelpers.export(exports, "getNode", ()=>getNode);
var _types = require("common/api/v1/types");
var _util = require("common/util");
function graphNodeNames(graph) {
    return Object.keys(graph.nodes);
}
function findNodes(graph, predicate) {
    const nodeNames = graphNodeNames(graph);
    return nodeNames.filter((n)=>{
        return predicate(n, graph.nodes[n]);
    });
}
function getRootNodes(graph) {
    return findNodes(graph, (nodeName)=>!graph.edges.find((e)=>e.target == nodeName));
}
function layout(graph) {
    const roots = getRootNodes(graph);
    const annotatedGraph = annotateNodes(graph, roots);
    const allNodes = Object.values(annotatedGraph.nodes);
    // Increases the logical coordinate space of the x axis (to get a wider graph)
    const xColumnStep = 1.5;
    const parentLogicalPorts = allNodes.filter((n)=>n.data.type === (0, _types.GraphNodeType).parentInputLogicalPort).sort((a, b)=>{
        return (a.data.meta?.index ?? 0) - (b.data.meta?.index ?? 0);
    });
    const inputLogicalPorts = allNodes.filter((n)=>n.data.type === (0, _types.GraphNodeType).inputLogicalPort).sort((a, b)=>{
        return (a.data.meta?.index ?? 0) - (b.data.meta?.index ?? 0);
    });
    const inputRegions = inputLogicalPorts.map((n)=>n.data.region);
    const inputSecondaryRegion = inputLogicalPorts[0]?.data.secondaryRegion;
    const startX = parentLogicalPorts.length > 0 ? 1 : 0;
    const outputs = allNodes.filter((n)=>n.data.type === (0, _types.GraphNodeType).output || n.data.type === (0, _types.GraphNodeType).thumbAppliance || n.data.type === (0, _types.GraphNodeType).derivedInput).sort((n1, n2)=>{
        return compare(n1, n2, (n)=>inputRegions.includes(n.data.region) ? '' : n.data.region, (n)=>Math.min(...n.data.parents.map((p)=>[
                    undefined,
                    (0, _types.GraphNodeType).inputEdgeAppliance,
                    (0, _types.GraphNodeType).inputRegionCore,
                    (0, _types.GraphNodeType).inputRegionOutputEdgeAppliance,
                    (0, _types.GraphNodeType).outputRegionCore,
                    (0, _types.GraphNodeType).outputRegionOutputEdgeAppliance
                ].indexOf(p.data.type))), (n)=>n.data.parents[0].name, (n)=>n.name, (n)=>n.data.name);
    });
    const numInputApplianceOutputs = outputs.filter((o)=>o.data.parents[0]?.data.type === (0, _types.GraphNodeType).inputEdgeAppliance).length;
    const singleRegionOffset = outputs.every((o)=>o.data.region === inputRegions[0] && (!o.data.secondaryRegion || o.data.secondaryRegion === inputRegions[0] || o.data.secondaryRegion === inputSecondaryRegion)) ? -1 : 0;
    const regions = [];
    outputs.forEach((o, i)=>{
        for (const p of o.data.parents){
            if (p.data.type === (0, _types.GraphNodeType).outputRegionCore) {
                if (!regions.includes(p.data.region)) regions.push(p.data.region);
            } else {
                p.data.parents.sort((p1, p2)=>p.data.region === p1.data.region ? -1 : p.data.region === p2.data.region ? 1 : p1.data.name.localeCompare(p2.data.name));
                for (const coreParent of p.data.parents)if (!regions.includes(coreParent.data.region)) regions.push(coreParent.data.region);
            }
        }
        o.position = {
            x: (startX + 5 + singleRegionOffset) * xColumnStep,
            y: i
        };
    });
    const regionOutputStats = {};
    for (const o of outputs){
        const r = o.data.region;
        const y = o.position.y;
        let regionStats = regionOutputStats[r];
        if (!regionStats) regionStats = regionOutputStats[r] = {
            maxNonOutputApplianceOutputY: -1,
            numCoreOutputs: 0,
            maxCoreOutputY: -1,
            minY: Number.MAX_SAFE_INTEGER
        };
        if (y < regionStats.minY) regionStats.minY = y;
        if ([
            (0, _types.GraphNodeType).inputEdgeAppliance,
            (0, _types.GraphNodeType).inputRegionCore,
            (0, _types.GraphNodeType).outputRegionCore
        ].includes(o.data.parents[0]?.data.type)) {
            regionStats.numCoreOutputs += 1;
            if (y > regionStats.maxNonOutputApplianceOutputY) regionStats.maxNonOutputApplianceOutputY = y;
            if ([
                (0, _types.GraphNodeType).inputRegionCore,
                (0, _types.GraphNodeType).outputRegionCore
            ].includes(o.data.parents[0].data.type)) {
                if (y > regionStats.maxCoreOutputY) regionStats.maxCoreOutputY = y;
            }
        }
    }
    const outputAppliances = allNodes.filter((n)=>[
            (0, _types.GraphNodeType).inputRegionOutputEdgeAppliance,
            (0, _types.GraphNodeType).outputRegionOutputEdgeAppliance
        ].includes(n.data.type));
    outputAppliances.sort((n1, n2)=>{
        return compare(n1, n2, (n)=>outputs.findIndex((o)=>o.data.parents[0].data.name == n.data.name && o.data.parents[0].data.type == n.data.type));
    });
    let maxOutputApplianceY = -1;
    outputAppliances.forEach((o)=>{
        const regionStats = regionOutputStats[o.data.region];
        let outputMinY = 0;
        for (const output of outputs.filter((outp)=>outp.data.parents[0].data.name == o.data.name))if (output.position.y < outputMinY) outputMinY = output.position.y;
        const minFromNonOutputAppliance = regionStats.maxNonOutputApplianceOutputY == -1 ? 0 : regionStats.maxNonOutputApplianceOutputY + 1;
        const y = outputMinY;
        const minLimits = [
            y,
            minFromNonOutputAppliance,
            regionStats.minY,
            maxOutputApplianceY + 1
        ];
        const actualY = Math.max(...minLimits);
        o.position = {
            x: (startX + 4 + singleRegionOffset) * xColumnStep,
            y: actualY
        };
        maxOutputApplianceY = actualY;
    });
    const outputRegionCoresInitial = allNodes.filter((n)=>n.data.type === (0, _types.GraphNodeType).outputRegionCore);
    const outputRegionCores = [];
    for (const region of regions){
        const singleOutputRegionCores = outputRegionCoresInitial.filter((c)=>c.data.region === region);
        singleOutputRegionCores.sort((n1, n2)=>{
            return compare(n1, n2, (n)=>{
                const outputIndex = outputs.findIndex((o)=>o.data.parents[0].data.name == n.data.name && o.data.parents[0].data.type == n.data.type);
                if (outputIndex !== -1) return outputIndex;
                const outputApplianceIndex = outputAppliances.findIndex((outputAppliance)=>outputAppliance.data.parents[0].data.region === n.data.region);
                if (outputApplianceIndex !== -1) return outputs.length + outputApplianceIndex;
                return 1000000;
            }, (n)=>n.name);
        });
        outputRegionCores.push(...singleOutputRegionCores);
    }
    const inputRegionCores = allNodes.filter((n)=>n.data.type === (0, _types.GraphNodeType).inputRegionCore);
    inputRegionCores.sort((n1, n2)=>{
        return compare(n1, n2, (n)=>{
            const outputIndex = outputs.findIndex((o)=>o.data.parents[0].data.name == n.data.name && o.data.parents[0].data.type == n.data.type);
            if (outputIndex !== -1) return outputIndex;
            const outputApplianceIndex = outputAppliances.findIndex((outputAppliance)=>outputAppliance.data.parents[0].data.name == n.data.name);
            if (outputApplianceIndex !== -1) return outputs.length + 1 + outputApplianceIndex;
            const outputRegionIndex = outputRegionCores.findIndex((c)=>c.data.parents[0].data.name == n.data.name);
            if (outputRegionIndex !== -1) return outputs.length + 1 + outputAppliances.length + 1 + outputRegionIndex;
            return 1000000;
        }, (n)=>n.name);
    });
    for (const inputRegionCore of inputRegionCores)if (!inputRegions.includes(inputRegionCore.data.region)) inputRegions.push(inputRegionCore.data.region);
    inputRegionCores.sort((c1, c2)=>{
        const index1 = inputRegions.indexOf(c1.data.region);
        const index2 = inputRegions.indexOf(c2.data.region);
        if (index1 < index2) return -1;
        if (index1 > index2) return 1;
        return c1.name.localeCompare(c2.name) // appliance name
        ;
    });
    inputRegionCores.forEach((o, i)=>{
        o.position = {
            x: (startX + 2) * xColumnStep,
            y: i + numInputApplianceOutputs
        };
    });
    const inputApplianceNodes = allNodes.filter((n)=>n.data.type === (0, _types.GraphNodeType).inputEdgeAppliance).sort((0, _util.sort)((n)=>n.data.meta?.priority));
    inputApplianceNodes.forEach((o, i)=>{
        o.position = {
            x: (startX + 1) * xColumnStep,
            y: i
        };
    });
    const numOutputsInInputRegion = outputs.filter((o)=>inputRegions.includes(o.data.region)).length;
    outputRegionCores.forEach((o, i)=>{
        o.position = {
            x: (startX + 3) * xColumnStep,
            y: i + numOutputsInInputRegion
        };
    });
    for(let portIndex = 0; portIndex < parentLogicalPorts.length; portIndex++){
        const node = parentLogicalPorts[portIndex];
        node.position = {
            x: 0,
            y: portIndex
        };
    }
    for(let portIndex = 0; portIndex < inputLogicalPorts.length; portIndex++){
        const node = inputLogicalPorts[portIndex];
        node.position = {
            x: startX,
            y: portIndex
        };
    }
    // 1) parent input port, 2) input port 3) input appliance, 4) region 1, 5) region 2, 6) output appliance, 7) output
    const maxNumberOfLogicalXCols = 7;
    return {
        graph,
        maxNumberOfXCols: maxNumberOfLogicalXCols
    };
}
function getAdjacent(graph, nodeRef) {
    const adjacent = graph.edges.filter((edge)=>edge.source == nodeRef).map((edge)=>edge.target);
    return adjacent;
}
// Annotate nodes with depth and parent metadata
function annotateNodes(graph, nodeNames, rootDepth = 0, parent, ancestors = []) {
    const annotatedGraph = graph;
    for (const nodeName of nodeNames){
        const node = getNode(annotatedGraph, nodeName);
        node.depth = rootDepth;
        if (!node.data.parents) node.data.parents = [];
        if (parent) {
            if (!node.data.parents.includes(parent)) node.data.parents.push(parent);
        }
        node.data.name = nodeName;
        const adjacentDepth = rootDepth + 1;
        const adjacentNodes = getAdjacent(annotatedGraph, nodeName);
        if (adjacentNodes.length === 0) {
            node.leaf = true;
            node.maxHeight = 0;
            node.minHeight = 0;
            let height = 0;
            while(ancestors.length > 0){
                height++;
                const ancestor = ancestors.pop();
                if (!ancestor) throw new Error();
                const ancestorNode = getNode(annotatedGraph, ancestor);
                if (typeof ancestorNode.maxHeight === 'undefined' || height > ancestorNode.maxHeight) ancestorNode.maxHeight = height;
                if (typeof ancestorNode.minHeight === 'undefined' || ancestorNode.minHeight > height) ancestorNode.minHeight = height;
            }
        }
        for (const nodeRef of adjacentNodes)if (!ancestors.includes(nodeRef)) annotateNodes(graph, [
            nodeRef
        ], adjacentDepth, node, [
            ...ancestors,
            nodeName
        ]);
    }
    return annotatedGraph;
}
function getNode(graph, name) {
    const n = graph.nodes[name];
    if (!n) throw new Error(`Could not get node ${name}`);
    return n;
}
function compare(v1, v2, ...selectors) {
    for (const s of selectors){
        const v1Val = s(v1);
        const v2Val = s(v2);
        if (typeof v1Val === 'undefined') return -1;
        if (typeof v2Val === 'undefined') return 1;
        if (v1Val < v2Val) return -1;
        if (v1Val > v2Val) return 1;
    }
    return 0;
}

},{"common/api/v1/types":"3qemx","common/util":"jV4UZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fL0os":[function(require,module,exports,__globalThis) {
// SVGs copied from network-manager/node_modules/@material-ui/icons/*.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconFillType", ()=>IconFillType);
parcelHelpers.export(exports, "InputSvg", ()=>InputSvg);
parcelHelpers.export(exports, "VideocamOutlinedSvg", ()=>VideocamOutlinedSvg);
parcelHelpers.export(exports, "OndemandVideoOutlinedSvg", ()=>OndemandVideoOutlinedSvg);
parcelHelpers.export(exports, "NotInterestedSvg", ()=>NotInterestedSvg);
parcelHelpers.export(exports, "LinkOffSvg", ()=>LinkOffSvg);
parcelHelpers.export(exports, "ReducedRedundancySvg", ()=>ReducedRedundancySvg);
parcelHelpers.export(exports, "VideocamOffSvg", ()=>VideocamOffSvg);
parcelHelpers.export(exports, "RoundSvg", ()=>RoundSvg);
parcelHelpers.export(exports, "HelpOutlineSvg", ()=>HelpOutlineSvg);
parcelHelpers.export(exports, "ThumbIconSvg", ()=>ThumbIconSvg);
parcelHelpers.export(exports, "TranscodeSvg", ()=>TranscodeSvg);
var IconFillType = /*#__PURE__*/ function(IconFillType) {
    IconFillType["stroke"] = "stroke";
    IconFillType["fill"] = "fill";
    return IconFillType;
}({});
const InputSvg = {
    path: 'm20.43182,4.01l-17.48864,0c-1.06875,0 -1.94318,0.84682 -1.94318,1.88181l0,3.75422l1.94318,0l0,-3.77304l17.48864,0l0,13.20092l-17.48864,0l0,-3.78244l-1.94318,0l0,3.77304c0,1.035 0.87443,1.86299 1.94318,1.86299l17.48864,0c1.06875,0 1.94318,-0.828 1.94318,-1.86299l0,-13.17269c0,-1.04441 -0.87443,-1.88181 -1.94318,-1.88181zm-9.71591,12.22238l3.88636,-3.76363l-3.88636,-3.76363l0,2.82272l-9.71591,0l0,1.88181l9.71591,0l0,2.82272z',
    fillType: "fill"
};
const VideocamOutlinedSvg = {
    path: 'M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1z',
    fillType: "fill"
};
const OndemandVideoOutlinedSvg = {
    path: 'M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z',
    fillType: "fill"
};
const NotInterestedSvg = {
    path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z',
    fillType: "fill"
};
const LinkOffSvg = {
    path: 'M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z',
    fillType: "fill"
};
const ReducedRedundancySvg = {
    path: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z',
    fillType: "fill"
};
const VideocamOffSvg = {
    path: 'M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z',
    fillType: "fill"
};
const RoundSvg = {
    path: 'M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6m0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z',
    fillType: "fill"
};
const HelpOutlineSvg = {
    path: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z',
    fillType: "fill"
};
const ThumbIconSvg = {
    path: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4 2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z',
    fillType: "fill"
};
const TranscodeSvg = {
    path: 'm18 4 2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z',
    fillType: "fill"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1JLzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WindowSizeSelect", ()=>WindowSizeSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _types = require("common/api/v1/types");
var _serviceOverviewActions = require("../../../redux/actions/serviceOverviewActions");
const WindowSizeSelect = (props)=>{
    const prettyFormatWindow = (window)=>{
        switch(window){
            case (0, _types.MetricWindow).s10:
                return 'Last 10 seconds';
            case (0, _types.MetricWindow).m1:
                return 'Last minute';
            case (0, _types.MetricWindow).m15:
                return 'Last 15 minutes';
            case (0, _types.MetricWindow).h1:
                return 'Last hour';
            case (0, _types.MetricWindow).h24:
                return 'Last 24 hours';
        }
    };
    const dispatch = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
        variant: "outlined",
        style: {
            minWidth: '150px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                children: "TR 101 290 analysis"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                autoWidth: true,
                value: props.currentWindow,
                label: 'TR 101 290 analysis',
                onChange: ({ target })=>{
                    dispatch((0, _serviceOverviewActions.selectTr101290Window)(target.value));
                },
                children: [
                    (0, _types.MetricWindow).s10,
                    (0, _types.MetricWindow).m1,
                    (0, _types.MetricWindow).m15,
                    (0, _types.MetricWindow).h1,
                    (0, _types.MetricWindow).h24
                ].map((window)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        value: window,
                        children: prettyFormatWindow(window)
                    }, `menu-item-${window}`))
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","@mui/material/FormControl":"ioFZ4","@mui/material/InputLabel":"5EJtb","@mui/material/Select":"kyj0v","@mui/material/MenuItem":"krMs8","common/api/v1/types":"3qemx","../../../redux/actions/serviceOverviewActions":"ak7dX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"exIG7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListServiceOverviewFilterKey", ()=>ListServiceOverviewFilterKey);
parcelHelpers.export(exports, "mapServiceOverviewFilterToUrlParam", ()=>mapServiceOverviewFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToServiceOverviewFilter", ()=>mapUrlParamToServiceOverviewFilter);
parcelHelpers.export(exports, "makeServiceOverviewFilter", ()=>makeServiceOverviewFilter);
var ListServiceOverviewFilterKey = /*#__PURE__*/ function(ListServiceOverviewFilterKey) {
    ListServiceOverviewFilterKey["outputName"] = "output name";
    return ListServiceOverviewFilterKey;
}({});
function mapServiceOverviewFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "output name":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToServiceOverviewFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "output name",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeServiceOverviewFilter() {
    const filterTemplates = [
        {
            key: "output name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dBrUu":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("4af05d7664edc58f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("17b64a34b5e8cfde"));
var _jsxRuntime = require("e23af90f33ecf69a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 5V4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1h-1v4c0 .55.45 1 1 1h1v7c0 1.1-.9 2-2 2s-2-.9-2-2V7c0-2.21-1.79-4-4-4S5 4.79 5 7v7H4c-.55 0-1 .45-1 1v4h1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h1v-4c0-.55-.45-1-1-1H7V7c0-1.1.9-2 2-2s2 .9 2 2v10c0 2.21 1.79 4 4 4s4-1.79 4-4v-7h1c.55 0 1-.45 1-1V5z"
}), 'Cable');

},{"4af05d7664edc58f":"kZ6eK","17b64a34b5e8cfde":"2vOnF","e23af90f33ecf69a":"1dlk8"}],"fnSW1":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("75b0d8270aa7058").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6b55494e6aab73b5"));
var _jsxRuntime = require("5a48978c6e2abd9b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25z"
}), 'AutoAwesome');

},{"75b0d8270aa7058":"kZ6eK","6b55494e6aab73b5":"2vOnF","5a48978c6e2abd9b":"1dlk8"}],"b3YyJ":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("c83a01475e7e5447").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("bda2686ed43fb553"));
var _jsxRuntime = require("5a34cf37bcb0c76e");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15M14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2"
}), 'QuestionMark');

},{"c83a01475e7e5447":"kZ6eK","bda2686ed43fb553":"2vOnF","5a34cf37bcb0c76e":"1dlk8"}],"5ac6L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "outputColumns", ()=>outputColumns);
var _jsxRuntime = require("react/jsx-runtime");
var _dateFns = require("date-fns");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _removeRedEye = require("@mui/icons-material/RemoveRedEye");
var _removeRedEyeDefault = parcelHelpers.interopDefault(_removeRedEye);
var _types = require("common/api/v1/types");
var _utils = require("../../../utils");
var _helpers = require("common/api/v1/helpers");
var _link = require("../../common/Link");
var _indicator = require("../../common/Indicator");
var _thumbnail = require("../../common/Thumbnail");
var _actionMenu = require("./ActionMenu");
var _cable = require("@mui/icons-material/Cable");
var _cableDefault = parcelHelpers.interopDefault(_cable);
var _questionMark = require("@mui/icons-material/QuestionMark");
var _questionMarkDefault = parcelHelpers.interopDefault(_questionMark);
var _monetizationOn = require("@mui/icons-material/MonetizationOn");
var _monetizationOnDefault = parcelHelpers.interopDefault(_monetizationOn);
const canUseNM = (role)=>role !== (0, _types.Role).basic;
const status = ({ autoUpdate, experimentalFeatures })=>({
        title: 'status',
        getValue: (output)=>{
            const indicator = autoUpdate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.NonSubscribingAutoUpdatingOutputHealthIndicator), {
                initialOutput: output
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.OutputHealthIndicator), {
                status: output.health,
                disabled: output.adminStatus === (0, _types.OutputAdminStatus).off
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center'
                },
                children: [
                    indicator,
                    output.adInsertionEnabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: 'Ad insertion is enabled for this output',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _monetizationOnDefault.default), {
                            style: {
                                marginLeft: '5px'
                            }
                        })
                    }),
                    output.unhealthyAlarm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: 'Status alarms are enabled for this output',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeRedEyeDefault.default), {
                            style: {
                                marginLeft: '5px'
                            }
                        })
                    })
                ]
            });
        },
        sorting: experimentalFeatures && experimentalFeatures.ExtHealthAlarms ? {
            byParameter: (0, _types.ListOutputSortableField).healthStatus
        } : undefined,
        props: {
            noTypography: true
        }
    });
const preview = ()=>({
        title: 'preview',
        getValue: (output)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "data-test-id": "thumbnail",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnail.NonSubscribingThumbnail), {
                    input: output._input,
                    initialOutput: output
                })
            }),
        props: {
            sx: {
                padding: 1,
                width: '100px'
            },
            noTypography: true
        },
        headerProps: {}
    });
const name = ({ user, toCallback }, override)=>({
        title: 'name',
        getValue: (output)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                available: canUseNM(user.role),
                to: toCallback(output),
                underline: "hover",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    ...(0, _utils.inputOutputColor)({
                        adminStatus: output.adminStatus
                    }),
                    children: output.name
                })
            }),
        sorting: {
            byParameter: (0, _types.ListOutputSortableField).outputName
        },
        props: {
            ...override?.props
        }
    });
const outputColumns = {
    status,
    preview,
    name
};
const getConfig = ({ selected, outputs, experimentalFeatures, handleSelect, handleSelectAll, showDialog, dispatch, routes, user })=>[
        {
            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                indeterminate: selected.length > 0 && selected.length < outputs.length,
                checked: selected.length === outputs.length,
                onChange: handleSelectAll,
                inputProps: {
                    'aria-label': 'select all outputs'
                },
                "data-test-id": 'select-all'
            }),
            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: selected.includes(id),
                    "data-test-id": "select-output",
                    onChange: ()=>{
                        handleSelect(id);
                    },
                    onDoubleClick: (e)=>e.stopPropagation()
                }),
            props: {
                padding: 'checkbox',
                noTypography: true
            }
        },
        status({
            autoUpdate: true,
            experimentalFeatures
        }),
        preview(),
        name({
            user,
            toCallback: ({ id })=>routes.outputsUpdate({
                    id
                })
        }),
        {
            title: 'input',
            getValue: (output)=>{
                const isInputOwner = user.group === output._input?.owner || user.role === (0, _types.Role).super;
                return output._input?.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.inputsUpdate({
                        id: output._input.id
                    }),
                    available: isInputOwner,
                    underline: "hover",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "subtitle1",
                        ...(0, _utils.inputOutputColor)(output),
                        children: output._input?.name
                    })
                });
            },
            sorting: {
                byParameter: (0, _types.ListOutputSortableField).inputName
            }
        },
        {
            title: 'appliance',
            getValue: ({ appliances, adminStatus })=>appliances.map((a)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                        to: routes.appliancesUpdate({
                            id: a.id
                        }),
                        available: (0, _utils.hasAccessToAppliance)(a, user),
                        underline: "hover",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            ...(0, _utils.inputOutputColor)({
                                adminStatus
                            }),
                            variant: "body2",
                            children: a.name
                        })
                    }, a.id)),
            sorting: {
                byParameter: (0, _types.ListOutputSortableField).applianceName
            }
        },
        {
            title: 'type',
            getValue: ({ ports })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                    size: "small",
                    icon: ports[0] ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cableDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionMarkDefault.default), {}),
                    label: (0, _utils.outputType)(ports[0])
                }),
            sorting: {
                byParameter: (0, _types.ListOutputSortableField).protocol
            }
        },
        {
            title: 'format',
            getValue: ({ _input, adminStatus, ports })=>{
                if (!_input) return 'N/A';
                const { tsInfo } = _input;
                const formattedOutputStreamContents = (0, _helpers.formatOutputStreamContents)({
                    ports,
                    tsInfo
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: JSON.stringify((tsInfo || [])[0]?.services?.[0]?.type?.description) || 'no info',
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        ...(0, _utils.inputOutputColor)({
                            adminStatus
                        }),
                        variant: "body2",
                        children: formattedOutputStreamContents
                    })
                });
            }
        },
        ...user.role === (0, _types.Role).super ? [
            {
                title: 'owner',
                sorting: {
                    byParameter: (0, _types.ListOutputSortableField).ownerGroupName
                },
                getValue: ({ _group })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                        to: routes.groupsUpdate({
                            id: _group?.id
                        }),
                        available: !!_group?.id && (0, _utils.isEditableGroup)(_group?.id, user),
                        underline: "hover",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "body2",
                            color: "textSecondary",
                            children: !!_group && _group.name
                        })
                    })
            }
        ] : [],
        {
            title: 'created',
            getValue: ({ createdAt, adminStatus })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_LONG)),
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        ...(0, _utils.inputOutputColor)({
                            adminStatus
                        }),
                        variant: "body2",
                        children: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_SHORT))
                    })
                }),
            sorting: {
                byParameter: (0, _types.ListOutputSortableField).creationDate
            }
        },
        {
            title: '',
            getValue: (row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    output: row,
                    dispatch: dispatch,
                    showDialog: showDialog
                }),
            props: {
                noTypography: true
            }
        }
    ];
exports.default = getConfig;

},{"react/jsx-runtime":"1dlk8","date-fns":"gelMX","@mui/material/Checkbox":"ag1Z5","@mui/material/Chip":"5cK8z","@mui/material/Typography":"6NtGx","../../common/Tooltip":"crjvg","@mui/icons-material/RemoveRedEye":"bR8zj","common/api/v1/types":"3qemx","../../../utils":"342UB","common/api/v1/helpers":"6jovr","../../common/Link":"l3o6V","../../common/Indicator":"hqaQa","../../common/Thumbnail":"5Q8KF","./ActionMenu":"jGxcW","@mui/icons-material/Cable":"dBrUu","@mui/icons-material/QuestionMark":"b3YyJ","@mui/icons-material/MonetizationOn":"6PlbH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGxcW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _videocamOutlined = require("@mui/icons-material/VideocamOutlined");
var _videocamOutlinedDefault = parcelHelpers.interopDefault(_videocamOutlined);
var _videoLibrary = require("@mui/icons-material/VideoLibrary");
var _videoLibraryDefault = parcelHelpers.interopDefault(_videoLibrary);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _stop = require("@mui/icons-material/Stop");
var _stopDefault = parcelHelpers.interopDefault(_stop);
var _playArrow = require("@mui/icons-material/PlayArrow");
var _playArrowDefault = parcelHelpers.interopDefault(_playArrow);
var _store = require("../../../store");
var _types = require("../../../../../common/src/api/v1/types");
var _outputsActions = require("../../../redux/actions/outputsActions");
var _ = require(".");
var _contentCopy = require("@mui/icons-material/ContentCopy");
var _contentCopyDefault = parcelHelpers.interopDefault(_contentCopy);
var _index = require("../../serviceOverview/Overview/index");
var _actionMenu = require("../../common/Table/ActionMenu");
const ActionMenu = (props)=>{
    const { output, dispatch, showDialog } = props;
    const routes = (0, _store.useRoutes)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: 'flex'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.ServiceOverviewButton), {
                input: output._input,
                outputId: output.id
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                "data-test-id": "output-action-menu",
                options: [
                    {
                        label: 'Edit',
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                        href: routes.outputsUpdate({
                            id: output.id
                        }),
                        'data-test-id': 'edit-output'
                    },
                    {
                        label: 'Switch input',
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videocamOutlinedDefault.default), {}),
                        onClick: ()=>{
                            showDialog(output, (0, _.OutputListDialog).selectInput);
                        },
                        'data-test-id': 'switch-input'
                    },
                    ...output.adminStatus === (0, _types.OutputAdminStatus).on ? [
                        {
                            label: 'Disable',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stopDefault.default), {}),
                            onClick: ()=>{
                                dispatch((0, _outputsActions.draftOutputs)({
                                    action: (0, _outputsActions.DraftActions).disable,
                                    outputs: [
                                        output
                                    ],
                                    source: (0, _outputsActions.DraftSources).actionMenu
                                }));
                            },
                            'data-test-id': 'toggle-admin-status-output'
                        }
                    ] : [
                        {
                            label: 'Enable',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playArrowDefault.default), {}),
                            onClick: ()=>{
                                dispatch((0, _outputsActions.enableOutputs)([
                                    output.id
                                ]));
                                dispatch((0, _outputsActions.draftOutputs)({
                                    outputs: []
                                }));
                            },
                            'data-test-id': 'toggle-admin-status-output'
                        }
                    ],
                    {
                        label: 'Add to list',
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoLibraryDefault.default), {}),
                        onClick: ()=>{
                            showDialog(output, (0, _.OutputListDialog).addToOutputList);
                        },
                        'data-test-id': 'add-to-list'
                    },
                    {
                        label: 'Duplicate',
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentCopyDefault.default), {}),
                        href: routes.outputsCopy({
                            id: output.id
                        }),
                        'data-test-id': 'use-output-as-template'
                    },
                    {
                        label: 'Delete',
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                        isDestructive: true,
                        onClick: ()=>{
                            dispatch((0, _outputsActions.draftOutputs)({
                                outputs: [
                                    output
                                ],
                                action: (0, _outputsActions.DraftActions).delete,
                                source: (0, _outputsActions.DraftSources).actionMenu
                            }));
                        },
                        'data-test-id': 'delete-output'
                    }
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","@mui/icons-material/Settings":"jkTfg","@mui/icons-material/VideocamOutlined":"3B1X9","@mui/icons-material/VideoLibrary":"buoJz","@mui/icons-material/Delete":"69aC7","@mui/icons-material/Stop":"1bxT4","@mui/icons-material/PlayArrow":"4aev3","../../../store":"5LXiG","../../../../../common/src/api/v1/types":"3zpKe","../../../redux/actions/outputsActions":"alMzI",".":"lBjcz","@mui/icons-material/ContentCopy":"ivEEo","../../serviceOverview/Overview/index":"1D7NB","../../common/Table/ActionMenu":"jf6As","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3B1X9":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("f5837dd69ca59775").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6e53581df5746c40"));
var _jsxRuntime = require("39572f497fdb5c2f");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15 8v8H5V8zm1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1"
}), 'VideocamOutlined');

},{"f5837dd69ca59775":"kZ6eK","6e53581df5746c40":"2vOnF","39572f497fdb5c2f":"1dlk8"}],"3zpKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelayMode", ()=>(0, _rist.DelayMode));
parcelHelpers.export(exports, "RistInputMultipathState", ()=>(0, _rist.RistInputMultipathState));
parcelHelpers.export(exports, "UdpOutputStatusCode", ()=>(0, _rist.UdpOutputStatusCode));
parcelHelpers.export(exports, "LogLevel", ()=>LogLevel);
parcelHelpers.export(exports, "EdgeProduct", ()=>EdgeProduct);
parcelHelpers.export(exports, "RistserverLogLevel", ()=>RistserverLogLevel);
parcelHelpers.export(exports, "RistProfile", ()=>RistProfile);
parcelHelpers.export(exports, "SrtMode", ()=>SrtMode);
parcelHelpers.export(exports, "ZixiMode", ()=>ZixiMode);
parcelHelpers.export(exports, "SrtKeylen", ()=>SrtKeylen);
parcelHelpers.export(exports, "SrtRateLimiting", ()=>SrtRateLimiting);
parcelHelpers.export(exports, "AuditLogOperationResult", ()=>AuditLogOperationResult);
parcelHelpers.export(exports, "AuditOperation", ()=>AuditOperation);
parcelHelpers.export(exports, "AlarmCause", ()=>AlarmCause);
parcelHelpers.export(exports, "AlarmSeverityLevels", ()=>AlarmSeverityLevels);
parcelHelpers.export(exports, "VaAlarmOwnSeverityLevels", ()=>VaAlarmOwnSeverityLevels);
parcelHelpers.export(exports, "AlarmType", ()=>AlarmType);
parcelHelpers.export(exports, "PrometheusAlerts", ()=>PrometheusAlerts);
parcelHelpers.export(exports, "MatroxEncoderAACQualityLevel", ()=>MatroxEncoderAACQualityLevel);
parcelHelpers.export(exports, "ApplianceType", ()=>ApplianceType);
parcelHelpers.export(exports, "MatroxEncoderIOConfig", ()=>MatroxEncoderIOConfig);
parcelHelpers.export(exports, "MatroxEncoderGenlockResolution", ()=>MatroxEncoderGenlockResolution);
parcelHelpers.export(exports, "MatroxDecoderGenlockSource", ()=>MatroxDecoderGenlockSource);
parcelHelpers.export(exports, "MatroxDecoderFramerateFamily", ()=>MatroxDecoderFramerateFamily);
parcelHelpers.export(exports, "ApplianceConnectionState", ()=>ApplianceConnectionState);
parcelHelpers.export(exports, "PortType", ()=>PortType);
parcelHelpers.export(exports, "PIDRuleAction", ()=>PIDRuleAction);
parcelHelpers.export(exports, "InputAdminStatus", ()=>InputAdminStatus);
parcelHelpers.export(exports, "ThumbnailMode", ()=>ThumbnailMode);
parcelHelpers.export(exports, "VideoPreviewMode", ()=>VideoPreviewMode);
parcelHelpers.export(exports, "HandoverMethod", ()=>HandoverMethod);
parcelHelpers.export(exports, "OutputRedundancyMode", ()=>OutputRedundancyMode);
parcelHelpers.export(exports, "OutputAdminStatus", ()=>OutputAdminStatus);
parcelHelpers.export(exports, "sdiAudioPairs", ()=>sdiAudioPairs);
parcelHelpers.export(exports, "AudioLayout", ()=>AudioLayout);
parcelHelpers.export(exports, "AudioCodec", ()=>AudioCodec);
parcelHelpers.export(exports, "AudioSystemStandard", ()=>AudioSystemStandard);
parcelHelpers.export(exports, "VideoCodec", ()=>VideoCodec);
parcelHelpers.export(exports, "RawVideo", ()=>RawVideo);
parcelHelpers.export(exports, "MatroxEncoderScalingOption", ()=>MatroxEncoderScalingOption);
parcelHelpers.export(exports, "MatroxEncoderPivotOption", ()=>MatroxEncoderPivotOption);
parcelHelpers.export(exports, "MatroxEncoderFlipOption", ()=>MatroxEncoderFlipOption);
parcelHelpers.export(exports, "MatroxEncoderPixelFormat", ()=>MatroxEncoderPixelFormat);
parcelHelpers.export(exports, "MatroxEncoderVideoProfile", ()=>MatroxEncoderVideoProfile);
parcelHelpers.export(exports, "MatroxEncoderProcessorFrameRate", ()=>MatroxEncoderProcessorFrameRate);
parcelHelpers.export(exports, "MatroxEncoderIncludeOption", ()=>MatroxEncoderIncludeOption);
parcelHelpers.export(exports, "MatroxEncoderEncodingMode", ()=>MatroxEncoderEncodingMode);
parcelHelpers.export(exports, "MatroxEncoderBitrateControlMode", ()=>MatroxEncoderBitrateControlMode);
parcelHelpers.export(exports, "MatroxEncoderAACEncoder", ()=>MatroxEncoderAACEncoder);
parcelHelpers.export(exports, "MatroxEncoderAACFormat", ()=>MatroxEncoderAACFormat);
parcelHelpers.export(exports, "Nimbra400VideoFlags", ()=>Nimbra400VideoFlags);
parcelHelpers.export(exports, "VideonVideoFlags", ()=>VideonVideoFlags);
parcelHelpers.export(exports, "MatroxVideoFlags", ()=>MatroxVideoFlags);
parcelHelpers.export(exports, "IpcPortMode", ()=>IpcPortMode);
parcelHelpers.export(exports, "IpPortMode", ()=>IpPortMode);
parcelHelpers.export(exports, "CoaxPortMode", ()=>CoaxPortMode);
parcelHelpers.export(exports, "MatroxPortMode", ()=>MatroxPortMode);
parcelHelpers.export(exports, "VideonPortMode", ()=>VideonPortMode);
parcelHelpers.export(exports, "ComprimatoPortMode", ()=>ComprimatoPortMode);
parcelHelpers.export(exports, "Output3gLevel", ()=>Output3gLevel);
parcelHelpers.export(exports, "OutputPortFec", ()=>OutputPortFec);
parcelHelpers.export(exports, "ZixiDecryptType", ()=>ZixiDecryptType);
parcelHelpers.export(exports, "ZixiLinkMode", ()=>ZixiLinkMode);
parcelHelpers.export(exports, "MatroxAudioChannelPair", ()=>MatroxAudioChannelPair);
parcelHelpers.export(exports, "MatroxDecoderOutputResolutionFamilyOne", ()=>MatroxDecoderOutputResolutionFamilyOne);
parcelHelpers.export(exports, "MatroxDecoderOutputResolutionFamilyTwo", ()=>MatroxDecoderOutputResolutionFamilyTwo);
parcelHelpers.export(exports, "MatroxDecoderOutputResolutionFamilyThree", ()=>MatroxDecoderOutputResolutionFamilyThree);
parcelHelpers.export(exports, "Role", ()=>Role);
parcelHelpers.export(exports, "SsoStrategy", ()=>SsoStrategy);
parcelHelpers.export(exports, "VaObjectInputType", ()=>VaObjectInputType);
parcelHelpers.export(exports, "VaObjectOutputType", ()=>VaObjectOutputType);
parcelHelpers.export(exports, "RistMetricType", ()=>RistMetricType);
parcelHelpers.export(exports, "ZixiMetricType", ()=>ZixiMetricType);
parcelHelpers.export(exports, "SrtMetricType", ()=>SrtMetricType);
parcelHelpers.export(exports, "RtmpMetricType", ()=>RtmpMetricType);
parcelHelpers.export(exports, "TrancodeStreamMetricType", ()=>TrancodeStreamMetricType);
parcelHelpers.export(exports, "MptsMetricType", ()=>MptsMetricType);
parcelHelpers.export(exports, "RistSimpleProfileMetricType", ()=>RistSimpleProfileMetricType);
parcelHelpers.export(exports, "VideonMetricType", ()=>VideonMetricType);
parcelHelpers.export(exports, "SdiMetricType", ()=>SdiMetricType);
parcelHelpers.export(exports, "AsiMetricType", ()=>AsiMetricType);
parcelHelpers.export(exports, "MatroxMetricType", ()=>MatroxMetricType);
parcelHelpers.export(exports, "ComprimatoMetricType", ()=>ComprimatoMetricType);
parcelHelpers.export(exports, "MetricWindow", ()=>MetricWindow);
parcelHelpers.export(exports, "InputAccessType", ()=>InputAccessType);
parcelHelpers.export(exports, "ExpFeatures", ()=>ExpFeatures);
parcelHelpers.export(exports, "OidcPrompt", ()=>OidcPrompt);
parcelHelpers.export(exports, "SsoConfigSource", ()=>SsoConfigSource);
parcelHelpers.export(exports, "KubernetesProvider", ()=>KubernetesProvider);
parcelHelpers.export(exports, "TranscodeAcceleratorType", ()=>TranscodeAcceleratorType);
parcelHelpers.export(exports, "BroadcastStandard", ()=>BroadcastStandard);
parcelHelpers.export(exports, "Nimbra400AlarmsFilter", ()=>Nimbra400AlarmsFilter);
parcelHelpers.export(exports, "InputOperStatus", ()=>InputOperStatus);
parcelHelpers.export(exports, "OutputOperStatus", ()=>OutputOperStatus);
parcelHelpers.export(exports, "TunnelType", ()=>TunnelType);
parcelHelpers.export(exports, "UsageDetailType", ()=>UsageDetailType);
parcelHelpers.export(exports, "ContainerTerminatedReason", ()=>ContainerTerminatedReason);
parcelHelpers.export(exports, "ListKubernetesNodeSortableField", ()=>ListKubernetesNodeSortableField);
parcelHelpers.export(exports, "ApplianceRealm", ()=>ApplianceRealm);
parcelHelpers.export(exports, "ExternalRegionMode", ()=>ExternalRegionMode);
parcelHelpers.export(exports, "EntityType", ()=>EntityType);
parcelHelpers.export(exports, "ImageName", ()=>ImageName);
parcelHelpers.export(exports, "ListPortSortableField", ()=>ListPortSortableField);
parcelHelpers.export(exports, "ListAlarmSortableField", ()=>ListAlarmSortableField);
parcelHelpers.export(exports, "ListUserSortableField", ()=>ListUserSortableField);
parcelHelpers.export(exports, "ListApiTokenSortableField", ()=>ListApiTokenSortableField);
parcelHelpers.export(exports, "ListInputSortableField", ()=>ListInputSortableField);
parcelHelpers.export(exports, "ListOutputSortableField", ()=>ListOutputSortableField);
parcelHelpers.export(exports, "ListGroupSortableField", ()=>ListGroupSortableField);
parcelHelpers.export(exports, "ApplianceSummarySortableField", ()=>ApplianceSummarySortableField);
parcelHelpers.export(exports, "ListApplianceSortableField", ()=>ListApplianceSortableField);
parcelHelpers.export(exports, "ListIpMappingSortableField", ()=>ListIpMappingSortableField);
parcelHelpers.export(exports, "GraphNodeType", ()=>GraphNodeType);
parcelHelpers.export(exports, "IpMappingType", ()=>IpMappingType);
parcelHelpers.export(exports, "NetworkSortableField", ()=>NetworkSortableField);
parcelHelpers.export(exports, "ListServiceSortableField", ()=>ListServiceSortableField);
parcelHelpers.export(exports, "ACCESS_SCOPES", ()=>ACCESS_SCOPES);
parcelHelpers.export(exports, "ACCESS_SCOPE_NAMES_LIST", ()=>ACCESS_SCOPE_NAMES_LIST);
parcelHelpers.export(exports, "ACCESS_SCOPE_FRIENDLY_NAMES", ()=>ACCESS_SCOPE_FRIENDLY_NAMES);
parcelHelpers.export(exports, "ACCESS_SCOPE_DESCRIPTIONS", ()=>ACCESS_SCOPE_DESCRIPTIONS);
parcelHelpers.export(exports, "ListAdPodSortableField", ()=>ListAdPodSortableField);
parcelHelpers.export(exports, "ListAdCreativeSortableField", ()=>ListAdCreativeSortableField);
parcelHelpers.export(exports, "ListAdBreakSortableField", ()=>ListAdBreakSortableField);
parcelHelpers.export(exports, "AdPodStatus", ()=>AdPodStatus);
parcelHelpers.export(exports, "AdCreativeEvent", ()=>AdCreativeEvent);
parcelHelpers.export(exports, "AdCreativeStatus", ()=>AdCreativeStatus);
parcelHelpers.export(exports, "AdBreakStatus", ()=>AdBreakStatus);
var _rist = require("../../rist");
var LogLevel = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["fatal"] = 0] = "fatal";
    LogLevel[LogLevel["error"] = 1] = "error";
    LogLevel[LogLevel["warn"] = 2] = "warn";
    LogLevel[LogLevel["info"] = 3] = "info";
    LogLevel[LogLevel["debug"] = 4] = "debug";
    LogLevel[LogLevel["trace"] = 5] = "trace";
    return LogLevel;
}({});
var EdgeProduct = /*#__PURE__*/ function(EdgeProduct) {
    EdgeProduct["edge"] = "edge";
    EdgeProduct["loci"] = "loci";
    return EdgeProduct;
}({});
var RistserverLogLevel = /*#__PURE__*/ function(RistserverLogLevel) {
    RistserverLogLevel["fatal"] = "critical";
    RistserverLogLevel["error"] = "error";
    RistserverLogLevel["warn"] = "warning";
    RistserverLogLevel["info"] = "info";
    RistserverLogLevel["debug"] = "debug";
    RistserverLogLevel["trace"] = "trace";
    return RistserverLogLevel;
}({});
var RistProfile = /*#__PURE__*/ function(RistProfile) {
    RistProfile["simple"] = "simple";
    RistProfile["main"] = "main";
    return RistProfile;
}({});
var SrtMode = /*#__PURE__*/ function(SrtMode) {
    SrtMode["listener"] = "listener";
    SrtMode["caller"] = "caller";
    SrtMode["rendezvous"] = "rendezvous";
    return SrtMode;
}({});
var ZixiMode = /*#__PURE__*/ function(ZixiMode) {
    ZixiMode["pull"] = "pull";
    ZixiMode["push"] = "push";
    return ZixiMode;
}({});
var SrtKeylen = /*#__PURE__*/ function(SrtKeylen) {
    SrtKeylen["aes128"] = "16";
    SrtKeylen["aes192"] = "24";
    SrtKeylen["aes256"] = "32";
    SrtKeylen["none"] = "-1";
    return SrtKeylen;
}({});
var SrtRateLimiting = /*#__PURE__*/ function(SrtRateLimiting) {
    SrtRateLimiting["notEnforced"] = "Not enforced";
    SrtRateLimiting["absolute"] = "Absolute";
    SrtRateLimiting["relativeToInput"] = "Relative to input";
    return SrtRateLimiting;
}({});
var AuditLogOperationResult = /*#__PURE__*/ function(AuditLogOperationResult) {
    AuditLogOperationResult["error"] = "error";
    AuditLogOperationResult["success"] = "success";
    return AuditLogOperationResult;
}({});
var AuditOperation = /*#__PURE__*/ function(AuditOperation) {
    AuditOperation["create"] = "create";
    AuditOperation["delete"] = "delete";
    AuditOperation["update"] = "update";
    AuditOperation["login"] = "login";
    AuditOperation["logout"] = "logout";
    AuditOperation["switchInput"] = "switchInput";
    AuditOperation["tcpdumpInput"] = "tcpdumpInput";
    AuditOperation["updateInputRecipients"] = "updateInputRecipients";
    AuditOperation["sendToOutputs"] = "sendToOutputs";
    AuditOperation["updateApplianceVersion"] = "updateApplianceVersion";
    AuditOperation["registerAppliance"] = "registerAppliance";
    AuditOperation["reregisterAppliance"] = "reregisterAppliance";
    AuditOperation["updateApplianceBasicInfo"] = "updateApplianceBasicInfo";
    AuditOperation["updateApplianceIpConfig"] = "updateApplianceIpConfig";
    AuditOperation["restartAppliance"] = "restartAppliance";
    AuditOperation["updateApplianceImage"] = "updateApplianceImage";
    AuditOperation["startCloudApplianceInstance"] = "startCloudApplianceInstance";
    AuditOperation["stopCloudApplianceInstance"] = "stopCloudApplianceInstance";
    AuditOperation["beginSystemUpgrade"] = "beginSystemUpgrade";
    AuditOperation["completeSystemUpgrade"] = "completeSystemUpgrade";
    AuditOperation["toggle"] = "toggle";
    return AuditOperation;
}({});
var AlarmCause = /*#__PURE__*/ function(AlarmCause) {
    AlarmCause["INTERFACE_REMOVED_BUT_IN_USE"] = "Interface removed but still in use";
    AlarmCause["CORE_APPLIANCE_PUBLIC_IP_MISSING"] = "Appliance needs public ip mapping";
    AlarmCause["CORE_INPUT_INVALID_ADDRESS"] = "Core input configured on an address that is not available";
    AlarmCause["CORE_OUTPUT_INVALID_ADDRESS"] = "Core output configured on an address that is not available";
    AlarmCause["FIREWALL_NFT_ERROR"] = "Failed to apply firewall settings using nftables";
    AlarmCause["MPTS_SUPPORT_ERROR"] = "Failed to run mpts demux binary";
    AlarmCause["MPTS_STARTUP_ERROR"] = "Unknown error when starting the mpts demux binary";
    AlarmCause["MPTS_UNEXPECTED_EXIT"] = "The mpts demux binary unexpectedly exited";
    AlarmCause["MPTS_CALL_TIMEOUT"] = "The mpts demux binary did not give a timely response to an api call";
    AlarmCause["BACKUP_JOB_FAILED"] = "Backup job failed";
    AlarmCause["RTMP_RECEIVER_EXITED"] = "RTMP receiver exited unexpectedly";
    AlarmCause["RTMP_SENDER_EXITED"] = "RTMP sender exited unexpectedly";
    AlarmCause["TRANSCODE_EXITED"] = "Transcode process exited unexpectedly";
    AlarmCause["TRANSCODE_MISSING_PID"] = "Audio reshuffling failed due to missing PID";
    AlarmCause["TRANSCODE_MISALIGNED_STREAMS"] = "Stream timestamps are misaligned";
    AlarmCause["INPUT_MAX_BITRATE_EXCEEDED"] = "Ingested stream traffic exceeds the maximum bitrate";
    AlarmCause["INPUT_UNHEALTHY"] = "Input is unhealthy";
    AlarmCause["OUTPUT_UNHEALTHY"] = "Output is unhealthy";
    AlarmCause["APPLIANCE_OFFLINE"] = "Appliance is offline";
    AlarmCause["APPLIANCE_HIGH_CPU_USAGE"] = "High CPU usage detected";
    AlarmCause["TRANSCODE_ACCELERATOR_HIGH_USAGE"] = "High transcode accelerator usage detected";
    // Nimbra 400 alarms
    AlarmCause["VA_LOSS_OF_SIGNAL"] = "Loss of signal";
    AlarmCause["VA_CALL_ESTABLISHMENT_ERROR"] = "Call establishment error";
    AlarmCause["VA_CONFIGURATION_OR_CUSTOMIZATION_ERROR"] = "Configuration or customization error";
    AlarmCause["VA_RESOURCE_CAPACITY"] = "Resource at or nearing capacity";
    AlarmCause["VA_SOFTWARE_PROGRAM_ERROR"] = "Software program error";
    // Edge-data alarms
    AlarmCause["RISTSERVER_ADD_CHANNEL"] = "Failed to add channel";
    AlarmCause["RISTSERVER_ADD_INPUT_STREAM_RIST"] = "Failed to add input stream rist";
    AlarmCause["RISTSERVER_ADD_INPUT_STREAM_RTP"] = "Failed to add input stream rtp";
    AlarmCause["RISTSERVER_ADD_INPUT_STREAM_UDP"] = "Failed to add input stream udp";
    AlarmCause["RISTSERVER_ADD_INPUT_STREAM_ADDRESS_ALREADY_IN_USE"] = "Address already in use";
    AlarmCause["RISTSERVER_ADD_OUTPUT_STREAM_RIST"] = "Failed to add output stream rist";
    AlarmCause["RISTSERVER_ADD_OUTPUT_STREAM_RTP"] = "Failed to add output stream rtp";
    AlarmCause["RISTSERVER_ADD_OUTPUT_STREAM_UDP"] = "Failed to add output stream udp";
    AlarmCause["RISTSERVER_ADD_TUNNEL_CLIENT"] = "Failed to add tunnel client";
    AlarmCause["RISTSERVER_ADD_TUNNEL_SERVER"] = "Failed to add tunnel server";
    AlarmCause["RISTSERVER_GET_DELTA_STATISTICS"] = "Failed to get delta statistics";
    AlarmCause["RISTSERVER_REMOVE_CHANNEL"] = "Failed to remove channel";
    AlarmCause["RISTSERVER_REMOVE_INPUT_STREAM"] = "Failed to remove input stream";
    AlarmCause["RISTSERVER_REMOVE_OUTPUT_STREAM"] = "Failed to remove output stream";
    AlarmCause["RISTSERVER_REMOVE_TUNNEL"] = "Failed to remove tunnel";
    AlarmCause["RISTSERVER_SET_INPUT_MULTIPATH_PARAMS"] = "Failed to set input multipath params";
    AlarmCause["RISTSERVER_SET_LOGGING_OPTIONS"] = "Failed to set logging options";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_MAXBITRATE"] = "Failed to set output stream max bitrate";
    AlarmCause["RISTSERVER_GET_STATISTICS"] = "Failed to get statistics";
    AlarmCause["RISTSERVER_GET_STATUS"] = "Failed to get status";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_NEW_AD_PLAYLIST"] = "Failed to set output stream new ad playlist";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_NOTIFY_SCTE"] = "Failed to set output stream notify scte";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_AD_INSERTION"] = "Failed to set output stream ad insertion";
    AlarmCause["RISTSERVER_SET_OUTPUT_STREAM_AD_SCTE_35_SOURCE"] = "Failed to set output stream ad insertion SCTE source filter";
    AlarmCause["RISTSERVER_SET_AD_FILE_AVAILABILITY"] = "Failed to set ad file availability";
    AlarmCause["HANDOVER_PROCESS_ADD_INPUT"] = "Failed to add input";
    AlarmCause["HANDOVER_PROCESS_ADD_OUTPUT"] = "Failed to add output";
    AlarmCause["MATROX_CONFIG_MISMATCH"] = "Configuration error - unable to set up appliance";
    AlarmCause["MATROX_FETCH_STATE"] = "Failed to fetch state";
    AlarmCause["MATROX_MISCONFIGURED_GENLOCK"] = "Misconfigured genlock";
    AlarmCause["MATROX_UPDATE_GENLOCK"] = "Failed to update genlock";
    AlarmCause["MATROX_MISCONFIGURED_IO_CONFIG"] = "Misconfigured I/O config";
    AlarmCause["MATROX_UPDATE_IO_CONFIG"] = "Failed to update I/O config";
    AlarmCause["MATROX_MISCONFIGURED_SDI_PORTS"] = "Misconfigured SDI ports";
    AlarmCause["MATROX_UPDATE_SDI_PORT"] = "Failed to update SDI port";
    AlarmCause["MATROX_MISCONFIGURED_PIPELINE"] = "Misconfigured pipeline";
    AlarmCause["MATROX_ADD_MISSING_PIPELINE"] = "Failed to add missing pipeline";
    AlarmCause["MATROX_DELETE_OBSOLETE_MPEG2TS_INPUT"] = "Failed to delete obsolete MPEG2TS input";
    AlarmCause["MATROX_DELETE_OBSOLETE_PROCESSOR"] = "Failed to delete obsolete processor";
    AlarmCause["MATROX_DELETE_OBSOLETE_ENCODER"] = "Failed to delete obsolete encoder";
    AlarmCause["MATROX_DELETE_OBSOLETE_MPEG2TS_OUTPUT"] = "Failed to delete obsolete MPEG2TS output";
    AlarmCause["COMPRIMATO_UNHEALTHY_PIPELINE"] = "Unhealthy Comprimato pipeline";
    AlarmCause["STORAGE_THRESHOLD_ALERT"] = "Storage threshold alert";
    AlarmCause["UNHEALTHY_INSTANCES_ALERT"] = "Unhealthy instances alert";
    AlarmCause["KAFKA_UNAVAILABLE"] = "Redpanda unavailable";
    AlarmCause["K8S_SYSTEM_ALERT"] = "Kubernetes system alert";
    AlarmCause["DOWNLOAD_AD_FILE"] = "Failed to download ad file";
    AlarmCause["PARSE_VAST_RESPONSE"] = "Failed to parse VAST response";
    return AlarmCause;
}({});
var AlarmSeverityLevels = /*#__PURE__*/ function(AlarmSeverityLevels) {
    AlarmSeverityLevels["critical"] = "critical";
    AlarmSeverityLevels["major"] = "major";
    AlarmSeverityLevels["minor"] = "minor";
    AlarmSeverityLevels["warning"] = "warning";
    return AlarmSeverityLevels;
}({});
var VaAlarmOwnSeverityLevels = /*#__PURE__*/ function(VaAlarmOwnSeverityLevels) {
    VaAlarmOwnSeverityLevels["cleared"] = "cleared";
    return VaAlarmOwnSeverityLevels;
}({});
var AlarmType = /*#__PURE__*/ function(AlarmType) {
    AlarmType["va"] = "va";
    AlarmType["edge"] = "edge";
    AlarmType["backend"] = "backend";
    AlarmType["backupMonitor"] = "backup-monitor";
    AlarmType["prometheus"] = "prometheus";
    return AlarmType;
}({});
var PrometheusAlerts = /*#__PURE__*/ function(PrometheusAlerts) {
    // These values MUST match the rule names in the prometheus.values file
    PrometheusAlerts["LowRedpandaDiskSpace"] = "LowRedpandaDiskSpace";
    PrometheusAlerts["HighNodeDiskUsage"] = "HighNodeDiskUsage";
    PrometheusAlerts["ReducedCloudNativePGAvailability"] = "ReducedCloudNativePGAvailability";
    PrometheusAlerts["CloudNativePGReplicationLag"] = "CloudNativePGReplicationLag";
    PrometheusAlerts["CloudNativePGReplicationFailure"] = "CloudNativePGReplicationFailure";
    PrometheusAlerts["ReducedCloudNativePGReplication"] = "ReducedCloudNativePGReplication";
    PrometheusAlerts["ReducedRedisAvailability"] = "ReducedRedisAvailability";
    PrometheusAlerts["KafkaSendErrors"] = "KafkaSendErrors";
    PrometheusAlerts["ReducedRedpandaAvailability"] = "ReducedRedpandaAvailability";
    PrometheusAlerts["RedpandaConsumerGroupLag"] = "RedpandaConsumerGroupLag";
    PrometheusAlerts["ReducedRedpandaToClickHouseAvailability"] = "ReducedRedpandaToClickHouseAvailability";
    PrometheusAlerts["ReducedClickHouseAvailability"] = "ReducedClickHouseAvailability";
    PrometheusAlerts["ClickHouseHighLatency"] = "ClickHouseHighLatency";
    PrometheusAlerts["KubeClientCertificateExpiration"] = "KubeClientCertificateExpiration";
    return PrometheusAlerts;
}({});
var MatroxEncoderAACQualityLevel = /*#__PURE__*/ function(MatroxEncoderAACQualityLevel) {
    MatroxEncoderAACQualityLevel["low"] = "Level0";
    MatroxEncoderAACQualityLevel["medium"] = "Level1";
    MatroxEncoderAACQualityLevel["high"] = "Level2";
    MatroxEncoderAACQualityLevel["unknown"] = "LevelUnknown";
    return MatroxEncoderAACQualityLevel;
}({});
var ApplianceType = /*#__PURE__*/ function(ApplianceType) {
    ApplianceType["nimbraVAdocker"] = "nimbraVAdocker";
    ApplianceType["nimbra410"] = "nimbra410";
    ApplianceType["nimbra412"] = "nimbra412";
    ApplianceType["nimbra414"] = "nimbra414";
    ApplianceType["nimbra414b"] = "nimbra414b";
    ApplianceType["nimbraVA225"] = "nimbraVA225";
    ApplianceType["nimbraVA220"] = "nimbraVA220";
    ApplianceType["edgeConnect"] = "edgeConnect";
    ApplianceType["core"] = "core";
    ApplianceType["thumb"] = "thumb";
    ApplianceType["videon"] = "videon";
    ApplianceType["matroxMonarchEdgeE4_8Bit"] = "matroxMonarchEdgeE4_8Bit";
    ApplianceType["matroxMonarchEdgeE4_10Bit"] = "matroxMonarchEdgeE4_10Bit";
    ApplianceType["matroxMonarchEdgeD4"] = "matroxMonarchEdgeD4";
    ApplianceType["matroxMonarchEdgeS1"] = "matroxMonarchEdgeS1";
    ApplianceType["comprimato"] = "comprimato";
    ApplianceType["mediakindRx1"] = "mediakindRx1";
    ApplianceType["mediakindCe1"] = "mediakindCe1";
    ApplianceType["riversilica"] = "riversilica";
    ApplianceType["nimbra204"] = "nimbra204";
    return ApplianceType;
}({});
var MatroxEncoderIOConfig = /*#__PURE__*/ function(MatroxEncoderIOConfig) {
    MatroxEncoderIOConfig["fourZero"] = "4:0";
    MatroxEncoderIOConfig["threeOne"] = "3:1";
    MatroxEncoderIOConfig["twoTwo"] = "2:2";
    return MatroxEncoderIOConfig;
}({});
var MatroxEncoderGenlockResolution = /*#__PURE__*/ function(MatroxEncoderGenlockResolution) {
    MatroxEncoderGenlockResolution["ntsc"] = "NTSC";
    MatroxEncoderGenlockResolution["pal"] = "PAL";
    return MatroxEncoderGenlockResolution;
}({});
var MatroxDecoderGenlockSource = /*#__PURE__*/ function(MatroxDecoderGenlockSource) {
    MatroxDecoderGenlockSource["internal"] = "internal";
    MatroxDecoderGenlockSource["external"] = "external";
    return MatroxDecoderGenlockSource;
}({});
var MatroxDecoderFramerateFamily = /*#__PURE__*/ function(MatroxDecoderFramerateFamily) {
    MatroxDecoderFramerateFamily["familyOne"] = "25/50";
    MatroxDecoderFramerateFamily["familyTwo"] = "29.97/59.94";
    MatroxDecoderFramerateFamily["familyThree"] = "30/60";
    return MatroxDecoderFramerateFamily;
}({});
var ApplianceConnectionState = /*#__PURE__*/ function(ApplianceConnectionState) {
    ApplianceConnectionState["connected"] = "connected";
    ApplianceConnectionState["missing"] = "missing";
    ApplianceConnectionState["neverConnected"] = "neverConnected";
    return ApplianceConnectionState;
}({});
var PortType = /*#__PURE__*/ function(PortType) {
    PortType["ip"] = "ip";
    PortType["coax"] = "coax";
    PortType["videon"] = "videon";
    PortType["ndi"] = "ndi";
    return PortType;
}({});
var PIDRuleAction = /*#__PURE__*/ function(PIDRuleAction) {
    PIDRuleAction["Map"] = "map";
    PIDRuleAction["Delete"] = "delete";
    PIDRuleAction["SetNull"] = "setNull";
    return PIDRuleAction;
}({});
var InputAdminStatus = /*#__PURE__*/ function(InputAdminStatus) {
    InputAdminStatus[InputAdminStatus["off"] = 0] = "off";
    InputAdminStatus[InputAdminStatus["on"] = 1] = "on";
    return InputAdminStatus;
}({});
var ThumbnailMode = /*#__PURE__*/ function(ThumbnailMode) {
    ThumbnailMode[ThumbnailMode["none"] = 0] = "none";
    ThumbnailMode[ThumbnailMode["edge"] = 1] = "edge";
    ThumbnailMode[ThumbnailMode["core"] = 2] = "core";
    return ThumbnailMode;
}({});
var VideoPreviewMode = /*#__PURE__*/ function(VideoPreviewMode) {
    VideoPreviewMode["off"] = "off";
    VideoPreviewMode["ondemand"] = "on demand";
    VideoPreviewMode["alwayson"] = "always on";
    return VideoPreviewMode;
}({});
var HandoverMethod = /*#__PURE__*/ function(HandoverMethod) {
    HandoverMethod["udp"] = "udp";
    HandoverMethod["unix"] = "unix";
    return HandoverMethod;
}({});
var OutputRedundancyMode = /*#__PURE__*/ function(OutputRedundancyMode) {
    OutputRedundancyMode[OutputRedundancyMode["none"] = 0] = "none";
    OutputRedundancyMode[OutputRedundancyMode["failover"] = 1] = "failover";
    OutputRedundancyMode[OutputRedundancyMode["active"] = 2] = "active";
    return OutputRedundancyMode;
}({});
var OutputAdminStatus = /*#__PURE__*/ function(OutputAdminStatus) {
    OutputAdminStatus[OutputAdminStatus["off"] = 0] = "off";
    OutputAdminStatus[OutputAdminStatus["on"] = 1] = "on";
    return OutputAdminStatus;
}({});
const SDI_AUDIO_PAIRS = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8
];
const sdiAudioPairs = [
    ...SDI_AUDIO_PAIRS
] // get the not ReadOnly array
;
var AudioLayout = /*#__PURE__*/ function(AudioLayout) {
    AudioLayout["mono"] = "mono";
    AudioLayout["stereo"] = "stereo";
    return AudioLayout;
}({});
var AudioCodec = /*#__PURE__*/ function(AudioCodec) {
    AudioCodec["mpeg2"] = "mpeg-2";
    AudioCodec["aacLc"] = "aac-lc";
    AudioCodec["heAac"] = "he-aac";
    AudioCodec["heAacV2"] = "he-aac v2";
    AudioCodec["aes3"] = "aes3";
    AudioCodec["ac3pt"] = "ac3pt";
    AudioCodec["ac3"] = "ac3";
    AudioCodec["aacLatm"] = "aac latm";
    AudioCodec["aacAdts"] = "aac adts";
    AudioCodec["raw"] = "raw";
    return AudioCodec;
}({});
var AudioSystemStandard = /*#__PURE__*/ function(AudioSystemStandard) {
    AudioSystemStandard["systemA"] = "System A";
    AudioSystemStandard["systemB"] = "System B";
    return AudioSystemStandard;
}({});
var VideoCodec = /*#__PURE__*/ function(VideoCodec) {
    VideoCodec["h264"] = "h.264";
    VideoCodec["h265"] = "h.265";
    return VideoCodec;
}({});
const RawVideo = 'RAW';
var MatroxEncoderScalingOption = /*#__PURE__*/ function(MatroxEncoderScalingOption) {
    // Unscaled from top left
    MatroxEncoderScalingOption["noScalingAtTopLeft"] = "noScalingAtTopLeft";
    // Unscaled centered
    MatroxEncoderScalingOption["noScalingAtCenter"] = "noScalingAtCenter";
    // Stretched to all edges
    MatroxEncoderScalingOption["scaleToFitDestination"] = "scaleToFitDestination";
    // Scaled to all edges
    MatroxEncoderScalingOption["scaleToFillButKeepContentAspectRatio"] = "scaleToFillButKeepContentAspectRatio";
    // Scaling to the nearest edge
    MatroxEncoderScalingOption["scaleToFitAllContent"] = "scaleToFitAllContent";
    return MatroxEncoderScalingOption;
}({});
var MatroxEncoderPivotOption = /*#__PURE__*/ function(MatroxEncoderPivotOption) {
    MatroxEncoderPivotOption["none"] = "none";
    MatroxEncoderPivotOption["by90Degrees"] = "by90Degrees";
    MatroxEncoderPivotOption["by180Degrees"] = "by180Degrees";
    MatroxEncoderPivotOption["by270Degrees"] = "by270Degrees";
    return MatroxEncoderPivotOption;
}({});
var MatroxEncoderFlipOption = /*#__PURE__*/ function(MatroxEncoderFlipOption) {
    MatroxEncoderFlipOption["none"] = "none";
    MatroxEncoderFlipOption["horizontally"] = "horizontally";
    MatroxEncoderFlipOption["vertically"] = "vertically";
    MatroxEncoderFlipOption["bothAxis"] = "bothAxis";
    return MatroxEncoderFlipOption;
}({});
var MatroxEncoderPixelFormat = /*#__PURE__*/ function(MatroxEncoderPixelFormat) {
    MatroxEncoderPixelFormat["YUV420_8bits"] = "YUV420_8bits";
    MatroxEncoderPixelFormat["YUV422_8bits"] = "YUV422_8bits";
    MatroxEncoderPixelFormat["YUV422_10bits"] = "YUV422_10bits";
    MatroxEncoderPixelFormat["YUV420_10bits"] = "YUV420_10bits";
    return MatroxEncoderPixelFormat;
}({});
var MatroxEncoderVideoProfile = /*#__PURE__*/ function(MatroxEncoderVideoProfile) {
    MatroxEncoderVideoProfile["Baseline"] = "Baseline";
    MatroxEncoderVideoProfile["Main"] = "Main";
    MatroxEncoderVideoProfile["High"] = "High";
    MatroxEncoderVideoProfile["High10Bit"] = "High 10-bit";
    MatroxEncoderVideoProfile["High422"] = "High YUV 4:2:2";
    return MatroxEncoderVideoProfile;
}({});
var MatroxEncoderProcessorFrameRate = /*#__PURE__*/ function(MatroxEncoderProcessorFrameRate) {
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["twentyFive"] = 25] = "twentyFive";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["twentyNineNinetySeven"] = 29.97] = "twentyNineNinetySeven";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["thirty"] = 30] = "thirty";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["fifty"] = 50] = "fifty";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["fiftyNineNinetyFour"] = 59.94] = "fiftyNineNinetyFour";
    MatroxEncoderProcessorFrameRate[MatroxEncoderProcessorFrameRate["sixty"] = 60] = "sixty";
    return MatroxEncoderProcessorFrameRate;
}({});
var MatroxEncoderIncludeOption = /*#__PURE__*/ function(MatroxEncoderIncludeOption) {
    MatroxEncoderIncludeOption["none"] = "none";
    MatroxEncoderIncludeOption["audioOnly"] = "audioOnly";
    MatroxEncoderIncludeOption["videoOnly"] = "videoOnly";
    MatroxEncoderIncludeOption["audioAndVideo"] = "audioAndVideo";
    return MatroxEncoderIncludeOption;
}({});
var MatroxEncoderEncodingMode = /*#__PURE__*/ function(MatroxEncoderEncodingMode) {
    MatroxEncoderEncodingMode["lowLatency"] = "lowLatency";
    MatroxEncoderEncodingMode["highQuality"] = "highQuality";
    return MatroxEncoderEncodingMode;
}({});
var MatroxEncoderBitrateControlMode = /*#__PURE__*/ function(MatroxEncoderBitrateControlMode) {
    MatroxEncoderBitrateControlMode["constant"] = "constant";
    MatroxEncoderBitrateControlMode["variable"] = "variable";
    return MatroxEncoderBitrateControlMode;
}({});
var MatroxEncoderAACEncoder = /*#__PURE__*/ function(MatroxEncoderAACEncoder) {
    MatroxEncoderAACEncoder["lc"] = "lc";
    MatroxEncoderAACEncoder["hev1"] = "hev1";
    MatroxEncoderAACEncoder["hev2"] = "hev2";
    return MatroxEncoderAACEncoder;
}({});
var MatroxEncoderAACFormat = /*#__PURE__*/ function(MatroxEncoderAACFormat) {
    MatroxEncoderAACFormat["noContainer"] = "noContainer";
    MatroxEncoderAACFormat["adts"] = "adts";
    MatroxEncoderAACFormat["adif"] = "adif";
    MatroxEncoderAACFormat["unknown"] = "unknown";
    return MatroxEncoderAACFormat;
}({});
var Nimbra400VideoFlags = /*#__PURE__*/ function(Nimbra400VideoFlags) {
    Nimbra400VideoFlags["smpte12mTimecode"] = "smpte12mTimecode";
    return Nimbra400VideoFlags;
}({});
var VideonVideoFlags = /*#__PURE__*/ function(VideonVideoFlags) {
    VideonVideoFlags["limitTo30Fps"] = "limitTo30Fps";
    VideonVideoFlags["klvTimeCodeInsertion"] = "klvTimeCodeInsertion";
    VideonVideoFlags["scte35Insertion"] = "scte35Insertion";
    VideonVideoFlags["cea708_608Captions"] = "cea708_608Captions";
    VideonVideoFlags["smpte2038Insertion"] = "smpte2038Insertion";
    return VideonVideoFlags;
}({});
var MatroxVideoFlags = /*#__PURE__*/ function(MatroxVideoFlags) {
    MatroxVideoFlags["ForceCAVLCEntropyEncoding"] = "ForceCAVLCEntropyEncoding";
    return MatroxVideoFlags;
}({});
var IpcPortMode = /*#__PURE__*/ function(IpcPortMode) {
    IpcPortMode["unix"] = "unix";
    return IpcPortMode;
}({});
var IpPortMode = /*#__PURE__*/ function(IpPortMode) {
    IpPortMode["rist"] = "rist";
    IpPortMode["udp"] = "udp";
    IpPortMode["rtp"] = "rtp";
    IpPortMode["srt"] = "srt";
    IpPortMode["zixi"] = "zixi";
    IpPortMode["rtmp"] = "rtmp";
    IpPortMode["generator"] = "generator";
    return IpPortMode;
}({});
var CoaxPortMode = /*#__PURE__*/ function(CoaxPortMode) {
    // 'hdmi' = 'hdmi',
    CoaxPortMode["sdi"] = "sdi";
    CoaxPortMode["asi"] = "asi";
    return CoaxPortMode;
}({});
var MatroxPortMode = /*#__PURE__*/ function(MatroxPortMode) {
    MatroxPortMode["matroxSdi"] = "matroxSdi";
    return MatroxPortMode;
}({});
var VideonPortMode = /*#__PURE__*/ function(VideonPortMode) {
    VideonPortMode["videonSdi"] = "videonSdi";
    VideonPortMode["videonHdmi"] = "videonHdmi";
    VideonPortMode["videonAuto"] = "videonAuto";
    return VideonPortMode;
}({});
var ComprimatoPortMode = /*#__PURE__*/ function(ComprimatoPortMode) {
    ComprimatoPortMode["comprimatoSdi"] = "comprimatoSdi";
    ComprimatoPortMode["comprimatoNdi"] = "comprimatoNdi";
    return ComprimatoPortMode;
}({});
var Output3gLevel = /*#__PURE__*/ function(Output3gLevel) {
    Output3gLevel["A"] = "A";
    Output3gLevel["B"] = "B";
    return Output3gLevel;
}({});
var OutputPortFec = /*#__PURE__*/ function(OutputPortFec) {
    OutputPortFec["1D"] = "1D";
    OutputPortFec["2D"] = "2D";
    return OutputPortFec;
}({});
var ZixiDecryptType = /*#__PURE__*/ function(ZixiDecryptType) {
    ZixiDecryptType["none"] = "none";
    ZixiDecryptType["aes128"] = "aes128";
    ZixiDecryptType["aes192"] = "aes192";
    ZixiDecryptType["aes256"] = "aes256";
    return ZixiDecryptType;
}({});
var ZixiLinkMode = /*#__PURE__*/ function(ZixiLinkMode) {
    ZixiLinkMode["single"] = "single";
    ZixiLinkMode["standby"] = "standby";
    ZixiLinkMode["bonded"] = "bonded";
    return ZixiLinkMode;
}({});
var MatroxAudioChannelPair = /*#__PURE__*/ function(MatroxAudioChannelPair) {
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel1And2"] = 3] = "channel1And2";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel3And4"] = 12] = "channel3And4";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel5And6"] = 48] = "channel5And6";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel7And8"] = 192] = "channel7And8";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel9And10"] = 768] = "channel9And10";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel11And12"] = 3072] = "channel11And12";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel13And14"] = 12288] = "channel13And14";
    MatroxAudioChannelPair[MatroxAudioChannelPair["channel15And16"] = 49152] = "channel15And16";
    return MatroxAudioChannelPair;
}({});
var MatroxDecoderOutputResolutionFamilyOne = /*#__PURE__*/ function(MatroxDecoderOutputResolutionFamilyOne) {
    MatroxDecoderOutputResolutionFamilyOne["720p50"] = "720p50";
    MatroxDecoderOutputResolutionFamilyOne["1080p25"] = "1080p25";
    MatroxDecoderOutputResolutionFamilyOne["1080p50"] = "1080p50";
    MatroxDecoderOutputResolutionFamilyOne["1080i25"] = "1080i25";
    MatroxDecoderOutputResolutionFamilyOne["2160p50"] = "2160p50";
    return MatroxDecoderOutputResolutionFamilyOne;
}({});
var MatroxDecoderOutputResolutionFamilyTwo = /*#__PURE__*/ function(MatroxDecoderOutputResolutionFamilyTwo) {
    MatroxDecoderOutputResolutionFamilyTwo["720p59.94"] = "720p59.94";
    MatroxDecoderOutputResolutionFamilyTwo["1080p23.98"] = "1080p23.98";
    MatroxDecoderOutputResolutionFamilyTwo["1080p29.97"] = "1080p29.97";
    MatroxDecoderOutputResolutionFamilyTwo["1080p59.94"] = "1080p59.94";
    MatroxDecoderOutputResolutionFamilyTwo["1080i29.97"] = "1080i29.97";
    MatroxDecoderOutputResolutionFamilyTwo["2160p59.94"] = "2160p59.94";
    return MatroxDecoderOutputResolutionFamilyTwo;
}({});
var MatroxDecoderOutputResolutionFamilyThree = /*#__PURE__*/ function(MatroxDecoderOutputResolutionFamilyThree) {
    MatroxDecoderOutputResolutionFamilyThree["720p60"] = "720p60";
    MatroxDecoderOutputResolutionFamilyThree["1080p24"] = "1080p24";
    MatroxDecoderOutputResolutionFamilyThree["1080p30"] = "1080p30";
    MatroxDecoderOutputResolutionFamilyThree["1080p60"] = "1080p60";
    MatroxDecoderOutputResolutionFamilyThree["1080i30"] = "1080i30";
    MatroxDecoderOutputResolutionFamilyThree["2160p60"] = "2160p60";
    return MatroxDecoderOutputResolutionFamilyThree;
}({});
var Role = /*#__PURE__*/ function(Role) {
    Role["basic"] = "basic";
    Role["admin"] = "admin";
    Role["super"] = "super";
    return Role;
}({});
var SsoStrategy = /*#__PURE__*/ function(SsoStrategy) {
    SsoStrategy["saml"] = "saml";
    SsoStrategy["oidc"] = "oidc";
    return SsoStrategy;
}({});
var VaObjectInputType = /*#__PURE__*/ function(VaObjectInputType) {
    VaObjectInputType["sdiInput"] = "sdi-input";
    VaObjectInputType["encoder"] = "encoder";
    VaObjectInputType["udpSink"] = "udp-sink";
    VaObjectInputType["ristSink"] = "rist-sink";
    VaObjectInputType["srtSink"] = "srt-sink";
    VaObjectInputType["edgeSource"] = "edge-source";
    VaObjectInputType["asiInput"] = "asi-input";
    VaObjectInputType["pullSink"] = "pull-sink";
    VaObjectInputType["pushSink"] = "push-sink";
    return VaObjectInputType;
}({});
var VaObjectOutputType = /*#__PURE__*/ function(VaObjectOutputType) {
    VaObjectOutputType["sdiOutput"] = "sdi-output";
    VaObjectOutputType["decoder"] = "decoder";
    VaObjectOutputType["udpSource"] = "udp-source";
    VaObjectOutputType["ristSource"] = "rist-source";
    VaObjectOutputType["srtSource"] = "srt-source";
    VaObjectOutputType["edgeSink"] = "edge-sink";
    VaObjectOutputType["asiOutput"] = "asi-output";
    VaObjectOutputType["pullSource"] = "pull-source";
    VaObjectOutputType["pushSource"] = "push-source";
    return VaObjectOutputType;
}({});
var RistMetricType = /*#__PURE__*/ function(RistMetricType) {
    RistMetricType["ristInput"] = "ristInput";
    RistMetricType["ristOutput"] = "ristOutput";
    RistMetricType["udpInput"] = "udpInput";
    RistMetricType["udpOutput"] = "udpOutput";
    RistMetricType["unixInput"] = "unixInput";
    RistMetricType["unixOutput"] = "unixOutput";
    RistMetricType["rtpInput"] = "rtpInput";
    RistMetricType["rtpOutput"] = "rtpOutput";
    RistMetricType["channel"] = "channel";
    return RistMetricType;
}({});
var ZixiMetricType = /*#__PURE__*/ function(ZixiMetricType) {
    ZixiMetricType["zixiOutput"] = "zixiOutput";
    ZixiMetricType["zixiInput"] = "zixiInput";
    return ZixiMetricType;
}({});
var SrtMetricType = /*#__PURE__*/ function(SrtMetricType) {
    SrtMetricType["srtOutput"] = "srtOutput";
    SrtMetricType["srtInput"] = "srtInput";
    return SrtMetricType;
}({});
var RtmpMetricType = /*#__PURE__*/ function(RtmpMetricType) {
    RtmpMetricType["rtmpInput"] = "rtmpInput";
    RtmpMetricType["rtmpOutput"] = "rtmpOutput";
    return RtmpMetricType;
}({});
var TrancodeStreamMetricType = /*#__PURE__*/ function(TrancodeStreamMetricType) {
    TrancodeStreamMetricType["transcodeStream"] = "transcodeStream";
    return TrancodeStreamMetricType;
}({});
var MptsMetricType = /*#__PURE__*/ function(MptsMetricType) {
    MptsMetricType["mptsDemux"] = "mptsDemux";
    return MptsMetricType;
}({});
var RistSimpleProfileMetricType = /*#__PURE__*/ function(RistSimpleProfileMetricType) {
    RistSimpleProfileMetricType["ristSimpleInput"] = "ristSimpleInput";
    RistSimpleProfileMetricType["ristSimpleOutput"] = "ristSimpleOutput";
    return RistSimpleProfileMetricType;
}({});
var VideonMetricType = /*#__PURE__*/ function(VideonMetricType) {
    VideonMetricType["videonAutoInput"] = "videonAutoInput";
    VideonMetricType["videonHdmiInput"] = "videonHdmiInput";
    VideonMetricType["videonSdiInput"] = "videonSdiInput";
    return VideonMetricType;
}({});
var SdiMetricType = /*#__PURE__*/ function(SdiMetricType) {
    SdiMetricType["sdiInput"] = "sdiInput";
    SdiMetricType["sdiOutput"] = "sdiOutput";
    return SdiMetricType;
}({});
var AsiMetricType = /*#__PURE__*/ function(AsiMetricType) {
    AsiMetricType["asiInput"] = "asiInput";
    AsiMetricType["asiOutput"] = "asiOutput";
    return AsiMetricType;
}({});
var MatroxMetricType = /*#__PURE__*/ function(MatroxMetricType) {
    MatroxMetricType["matroxSdiInput"] = "matroxSdiInput";
    MatroxMetricType["matroxSdiOutput"] = "matroxSdiOutput";
    return MatroxMetricType;
}({});
var ComprimatoMetricType = /*#__PURE__*/ function(ComprimatoMetricType) {
    ComprimatoMetricType["comprimatoSdiInput"] = "comprimatoSdiInput";
    ComprimatoMetricType["comprimatoNdiInput"] = "comprimatoNdiInput";
    ComprimatoMetricType["comprimatoNdiOutput"] = "comprimatoNdiOutput";
    ComprimatoMetricType["comprimatoSdiOutput"] = "comprimatoSdiOutput";
    return ComprimatoMetricType;
}({});
var MetricWindow = /*#__PURE__*/ function(MetricWindow) {
    MetricWindow["s10"] = "10 seconds";
    MetricWindow["m1"] = "1 minute";
    MetricWindow["m15"] = "15 minutes";
    MetricWindow["h1"] = "1 hour";
    MetricWindow["h24"] = "24 hours";
    return MetricWindow;
}({});
var InputAccessType = /*#__PURE__*/ function(InputAccessType) {
    InputAccessType[InputAccessType["view"] = 1] = "view";
    InputAccessType[InputAccessType["pull"] = 2] = "pull";
    return InputAccessType;
}({});
var ExpFeatures = /*#__PURE__*/ function(ExpFeatures) {
    // These currently need to be  abc = 'abc' and not abc = 'friendly name for abc'
    ExpFeatures["OASResponseValidation"] = "OASResponseValidation";
    ExpFeatures["ExtDerivedInput"] = "ExtDerivedInput";
    ExpFeatures["ExtSelectableDelayMode"] = "ExtSelectableDelayMode";
    ExpFeatures["ExtHealthAlarms"] = "ExtHealthAlarms";
    ExpFeatures["AdInsertion"] = "AdInsertion";
    // TODO: remove this when all customers have upgraded to >=R3.14.0
    ExpFeatures["AllowLegacyExternalRegions"] = "AllowLegacyExternalRegions";
    return ExpFeatures;
}({});
var OidcPrompt = /*#__PURE__*/ function(OidcPrompt) {
    OidcPrompt["none"] = "none";
    OidcPrompt["login"] = "login";
    OidcPrompt["select_account"] = "select_account";
    return OidcPrompt;
}({});
var SsoConfigSource = /*#__PURE__*/ function(SsoConfigSource) {
    SsoConfigSource["metadata"] = "metadata";
    SsoConfigSource["manual"] = "manual";
    return SsoConfigSource;
}({});
var KubernetesProvider = /*#__PURE__*/ function(KubernetesProvider) {
    KubernetesProvider["metal"] = "metal";
    KubernetesProvider["alibaba"] = "alibaba";
    KubernetesProvider["aws"] = "aws";
    KubernetesProvider["google"] = "google";
    KubernetesProvider["azure"] = "azure";
    KubernetesProvider["oracle"] = "oracle";
    return KubernetesProvider;
}({});
var TranscodeAcceleratorType = /*#__PURE__*/ function(TranscodeAcceleratorType) {
    TranscodeAcceleratorType["nvidia"] = "nvidia";
    TranscodeAcceleratorType["netint"] = "netint";
    TranscodeAcceleratorType["xilinx_u30"] = "xilinx_u30";
    TranscodeAcceleratorType["videotoolbox"] = "videotoolbox";
    TranscodeAcceleratorType["cpu"] = "cpu";
    return TranscodeAcceleratorType;
}({});
var BroadcastStandard = /*#__PURE__*/ function(BroadcastStandard) {
    BroadcastStandard["dvb"] = "dvb";
    BroadcastStandard["atsc"] = "atsc";
    return BroadcastStandard;
}({});
var Nimbra400AlarmsFilter = /*#__PURE__*/ function(Nimbra400AlarmsFilter) {
    Nimbra400AlarmsFilter["edgeManagedServices"] = "edgeManagedServices";
    Nimbra400AlarmsFilter["all"] = "all";
    Nimbra400AlarmsFilter["none"] = "none";
    return Nimbra400AlarmsFilter;
}({});
var InputOperStatus = /*#__PURE__*/ function(InputOperStatus) {
    InputOperStatus["notConfigured"] = "notConfigured";
    InputOperStatus["metricsMissing"] = "metricsMissing";
    InputOperStatus["allOk"] = "allOk";
    InputOperStatus["inputError"] = "inputError";
    InputOperStatus["tr101290Priority1Error"] = "tr101290Priority1Error";
    InputOperStatus["transportError"] = "transportError";
    InputOperStatus["alarm"] = "alarm";
    InputOperStatus["reducedRedundancy"] = "reducedRedundancy";
    return InputOperStatus;
}({});
var OutputOperStatus = /*#__PURE__*/ function(OutputOperStatus) {
    OutputOperStatus["notConfigured"] = "notConfigured";
    OutputOperStatus["metricsMissing"] = "metricsMissing";
    OutputOperStatus["tr101290Priority1Error"] = "tr101290Priority1Error";
    OutputOperStatus["reducedRedundancy"] = "reducedRedundancy";
    OutputOperStatus["allOk"] = "allOk";
    // The output is successfully sending data to the configured destination but has not (yet) received an ACK from the receiver
    // Applicable for Rist Simple Profile, but not for e.g. SRT or RTMP since they won't actually send any data until a connection has been established.
    OutputOperStatus["notAcknowledged"] = "notAcknowledged";
    OutputOperStatus["inputError"] = "inputError";
    OutputOperStatus["outputError"] = "outputError";
    OutputOperStatus["alarm"] = "alarm";
    return OutputOperStatus;
}({});
var TunnelType = /*#__PURE__*/ function(TunnelType) {
    // Used by external appliances (edgeConnect, VA, etc) connecting to core nodes.
    // Uses "public" ip mapping.
    TunnelType[TunnelType["external"] = 1] = "external";
    // Used for communication between core appliances (video and thumb) within the same region.
    // Uses "internal" ip mapping.
    TunnelType[TunnelType["internal"] = 2] = "internal";
    // Used for communication between different regions.
    // Uses "inter region" ip mapping.
    TunnelType[TunnelType["interRegion"] = 3] = "interRegion";
    return TunnelType;
}({});
var UsageDetailType = /*#__PURE__*/ function(UsageDetailType) {
    UsageDetailType["input"] = "input";
    UsageDetailType["output"] = "output";
    return UsageDetailType;
}({});
var ContainerTerminatedReason = /*#__PURE__*/ function(ContainerTerminatedReason) {
    ContainerTerminatedReason["completed"] = "Completed";
    return ContainerTerminatedReason;
}({});
var ListKubernetesNodeSortableField = /*#__PURE__*/ function(ListKubernetesNodeSortableField) {
    ListKubernetesNodeSortableField["name"] = "name";
    ListKubernetesNodeSortableField["region"] = "region";
    ListKubernetesNodeSortableField["status"] = "status";
    return ListKubernetesNodeSortableField;
}({});
var ApplianceRealm = /*#__PURE__*/ function(ApplianceRealm) {
    ApplianceRealm["core"] = "core";
    ApplianceRealm["edge"] = "edge";
    return ApplianceRealm;
}({});
var ExternalRegionMode = /*#__PURE__*/ function(ExternalRegionMode) {
    ExternalRegionMode[ExternalRegionMode["core"] = 0] = "core";
    ExternalRegionMode[ExternalRegionMode["externalK8s"] = 1] = "externalK8s";
    ExternalRegionMode[ExternalRegionMode["external"] = 2] = "external";
    return ExternalRegionMode;
}({});
var EntityType = /*#__PURE__*/ function(EntityType) {
    EntityType["alarm"] = "alarm";
    EntityType["appliance"] = "appliance";
    EntityType["alarmLog"] = "alarm-log";
    EntityType["auditLog"] = "audit-log";
    EntityType["distribution"] = "distribution";
    EntityType["input"] = "input";
    EntityType["group"] = "group";
    EntityType["groupAndRecipientList"] = "groupAndRecipientList";
    EntityType["groupRecipientList"] = "groupRecipientList";
    EntityType["output"] = "output";
    EntityType["outputAndRecipientList"] = "outputAndRecipientList";
    EntityType["outputRecipientList"] = "outputRecipientList";
    EntityType["port"] = "port";
    EntityType["region"] = "region";
    EntityType["user"] = "user";
    EntityType["ipMapping"] = "ip-mapping";
    EntityType["system"] = "system";
    return EntityType;
}({});
var ImageName = /*#__PURE__*/ function(ImageName) {
    ImageName["product"] = "product";
    ImageName["serviceProvider"] = "serviceProvider";
    ImageName["favicon"] = "favicon";
    return ImageName;
}({});
var ListPortSortableField = /*#__PURE__*/ function(ListPortSortableField) {
    ListPortSortableField["portName"] = "portName";
    ListPortSortableField["address"] = "address";
    ListPortSortableField["publicAddress"] = "publicAddress";
    ListPortSortableField["applianceName"] = "applianceName";
    ListPortSortableField["ownerGroupName"] = "ownerGroupName";
    return ListPortSortableField;
}({});
var ListAlarmSortableField = /*#__PURE__*/ function(ListAlarmSortableField) {
    ListAlarmSortableField["time"] = "time";
    ListAlarmSortableField["applianceName"] = "applianceName";
    ListAlarmSortableField["alarmCause"] = "alarmCause";
    ListAlarmSortableField["text"] = "text";
    return ListAlarmSortableField;
}({});
var ListUserSortableField = /*#__PURE__*/ function(ListUserSortableField) {
    ListUserSortableField["userName"] = "userName";
    ListUserSortableField["groupName"] = "groupName";
    ListUserSortableField["role"] = "role";
    return ListUserSortableField;
}({});
var ListApiTokenSortableField = /*#__PURE__*/ function(ListApiTokenSortableField) {
    ListApiTokenSortableField["name"] = "name";
    ListApiTokenSortableField["userName"] = "userName";
    ListApiTokenSortableField["groupName"] = "groupName";
    ListApiTokenSortableField["role"] = "role";
    ListApiTokenSortableField["expiresAt"] = "expiresAt";
    return ListApiTokenSortableField;
}({});
var ListInputSortableField = /*#__PURE__*/ function(ListInputSortableField) {
    ListInputSortableField["inputName"] = "inputName";
    ListInputSortableField["applianceName"] = "applianceName";
    ListInputSortableField["protocol"] = "protocol";
    ListInputSortableField["creationDate"] = "creationDate";
    ListInputSortableField["lastModified"] = "lastModified";
    ListInputSortableField["accessType"] = "accessType";
    ListInputSortableField["ownerGroupName"] = "ownerGroupName";
    ListInputSortableField["healthStatus"] = "healthStatus";
    return ListInputSortableField;
}({});
var ListOutputSortableField = /*#__PURE__*/ function(ListOutputSortableField) {
    ListOutputSortableField["id"] = "id";
    ListOutputSortableField["outputName"] = "outputName";
    ListOutputSortableField["applianceName"] = "applianceName";
    ListOutputSortableField["protocol"] = "protocol";
    ListOutputSortableField["creationDate"] = "creationDate";
    ListOutputSortableField["lastModified"] = "lastModified";
    ListOutputSortableField["inputName"] = "inputName";
    ListOutputSortableField["ownerGroupName"] = "ownerGroupName";
    ListOutputSortableField["healthStatus"] = "healthStatus";
    return ListOutputSortableField;
}({});
var ListGroupSortableField = /*#__PURE__*/ function(ListGroupSortableField) {
    ListGroupSortableField["groupName"] = "groupName";
    ListGroupSortableField["numberOfUsers"] = "numberOfUsers";
    ListGroupSortableField["numberOfAppliances"] = "numberOfAppliances";
    ListGroupSortableField["numberOfPorts"] = "numberOfPorts";
    return ListGroupSortableField;
}({});
var ApplianceSummarySortableField = /*#__PURE__*/ function(ApplianceSummarySortableField) {
    ApplianceSummarySortableField["applianceName"] = "applianceName";
    ApplianceSummarySortableField["regionName"] = "regionName";
    ApplianceSummarySortableField["ownerGroupName"] = "ownerGroupName";
    return ApplianceSummarySortableField;
}({});
var ListApplianceSortableField = /*#__PURE__*/ function(ListApplianceSortableField) {
    ListApplianceSortableField["applianceName"] = "applianceName";
    ListApplianceSortableField["applianceType"] = "applianceType";
    ListApplianceSortableField["regionName"] = "regionName";
    ListApplianceSortableField["secondaryRegionName"] = "secondaryRegionName";
    ListApplianceSortableField["ownerGroupName"] = "ownerGroupName";
    ListApplianceSortableField["lastSeen"] = "lastSeen";
    ListApplianceSortableField["numActiveAlarms"] = "numActiveAlarms";
    return ListApplianceSortableField;
}({});
var ListIpMappingSortableField = /*#__PURE__*/ function(ListIpMappingSortableField) {
    ListIpMappingSortableField["regionName"] = "regionName";
    ListIpMappingSortableField["applianceName"] = "applianceName";
    ListIpMappingSortableField["interfaceName"] = "interfaceName";
    ListIpMappingSortableField["privateAddress"] = "privateAddress";
    ListIpMappingSortableField["publicAddress"] = "publicAddress";
    ListIpMappingSortableField["internalAddress"] = "internalAddress";
    ListIpMappingSortableField["interRegionAddress"] = "interRegionAddress";
    return ListIpMappingSortableField;
}({});
var GraphNodeType = /*#__PURE__*/ function(GraphNodeType) {
    // A logical port of the input we are currently looking at.
    // If it is a parent input, it will have derivedInput(s) in the graph.
    // If it is a derived input, it will have parentInputLogicalPort(s) in the graph.
    GraphNodeType["inputLogicalPort"] = "inputLogicalPort";
    GraphNodeType["parentInputLogicalPort"] = "parentInputLogicalPort";
    // Derived/child input of the (parent) input being inspected.
    GraphNodeType["derivedInput"] = "derivedInput";
    // The edge-appliance where the input resides
    GraphNodeType["inputEdgeAppliance"] = "inputEdgeAppliance";
    // The core-appliance where the input resides
    GraphNodeType["inputRegionCore"] = "inputRegionCore";
    GraphNodeType["thumbAppliance"] = "thumbAppliance";
    // An output
    GraphNodeType["output"] = "output";
    // The core-appliance where the output resides
    GraphNodeType["outputRegionCore"] = "outputRegionCore";
    // The edge-appliance, in the same region as the input, where the output resides
    GraphNodeType["inputRegionOutputEdgeAppliance"] = "inputRegionOutputEdgeAppliance";
    // The edge-appliance, in a different region than the input, where the output resides
    GraphNodeType["outputRegionOutputEdgeAppliance"] = "outputRegionOutputEdgeAppliance";
    return GraphNodeType;
}({});
var IpMappingType = /*#__PURE__*/ function(IpMappingType) {
    // A user configured IP mapping
    IpMappingType["mapped"] = "mapped";
    // A suggested (incomplete) IP mapping suggested by the system
    IpMappingType["suggested"] = "suggested";
    return IpMappingType;
}({});
var NetworkSortableField = /*#__PURE__*/ function(NetworkSortableField) {
    NetworkSortableField["id"] = "id";
    NetworkSortableField["name"] = "name";
    return NetworkSortableField;
}({});
var ListServiceSortableField = /*#__PURE__*/ function(ListServiceSortableField) {
    ListServiceSortableField["purpose"] = "purpose";
    ListServiceSortableField["product"] = "product";
    return ListServiceSortableField;
}({});
var ACCESS_SCOPES = /*#__PURE__*/ function(ACCESS_SCOPES) {
    ACCESS_SCOPES[ACCESS_SCOPES["api"] = 1] = "api";
    ACCESS_SCOPES[ACCESS_SCOPES["read_appliance_summary"] = 2] = "read_appliance_summary";
    ACCESS_SCOPES[ACCESS_SCOPES["post_cloud_appliance_audit_log"] = 3] = "post_cloud_appliance_audit_log";
    return ACCESS_SCOPES;
}({});
const ACCESS_SCOPE_NAMES_LIST = Object.keys(ACCESS_SCOPES).filter((key)=>isNaN(Number(key)));
const ACCESS_SCOPE_FRIENDLY_NAMES = {
    api: 'Full read/write access',
    read_appliance_summary: 'Read appliance summary',
    post_cloud_appliance_audit_log: 'Post cloud appliance audit log'
};
const ACCESS_SCOPE_DESCRIPTIONS = {
    api: 'Access to everything user has access to',
    read_appliance_summary: 'Read appliance summary (id, name, hostname, type, tags, isActive)',
    post_cloud_appliance_audit_log: 'Allow external appliance automation tools to record events in the audit log'
};
var ListAdPodSortableField = /*#__PURE__*/ function(ListAdPodSortableField) {
    ListAdPodSortableField["name"] = "name";
    ListAdPodSortableField["createdAt"] = "createdAt";
    return ListAdPodSortableField;
}({});
var ListAdCreativeSortableField = /*#__PURE__*/ function(ListAdCreativeSortableField) {
    ListAdCreativeSortableField["name"] = "name";
    ListAdCreativeSortableField["fileSize"] = "fileSize";
    ListAdCreativeSortableField["duration"] = "duration";
    ListAdCreativeSortableField["createdAt"] = "createdAt";
    return ListAdCreativeSortableField;
}({});
var ListAdBreakSortableField = /*#__PURE__*/ function(ListAdBreakSortableField) {
    ListAdBreakSortableField["startsAt"] = "startsAt";
    ListAdBreakSortableField["createdAt"] = "createdAt";
    return ListAdBreakSortableField;
}({});
var AdPodStatus = /*#__PURE__*/ function(AdPodStatus) {
    AdPodStatus["pending"] = "pending";
    AdPodStatus["healthy"] = "healthy";
    AdPodStatus["unhealthy"] = "unhealthy";
    AdPodStatus["inactive"] = "inactive";
    return AdPodStatus;
}({});
var AdCreativeEvent = /*#__PURE__*/ function(AdCreativeEvent) {
    AdCreativeEvent["probeOk"] = "probeOk";
    AdCreativeEvent["probeFailed"] = "probeFailed";
    AdCreativeEvent["thumbnailOk"] = "thumbnailOk";
    AdCreativeEvent["thumbnailFailed"] = "thumbnailFailed";
    AdCreativeEvent["uploadOk"] = "uploadOk";
    AdCreativeEvent["uploadFailed"] = "uploadFailed";
    return AdCreativeEvent;
}({});
var AdCreativeStatus = /*#__PURE__*/ function(AdCreativeStatus) {
    AdCreativeStatus["pending"] = "pending";
    AdCreativeStatus["active"] = "active";
    AdCreativeStatus["thumbnailFailed"] = "thumbnailFailed";
    AdCreativeStatus["uploadFailed"] = "uploadFailed";
    AdCreativeStatus["probeFailed"] = "probeFailed";
    return AdCreativeStatus;
}({});
var AdBreakStatus = /*#__PURE__*/ function(AdBreakStatus) {
    AdBreakStatus["pending"] = "pending";
    AdBreakStatus["playing"] = "playing";
    AdBreakStatus["playOk"] = "playOk";
    AdBreakStatus["playFailed"] = "playFailed";
    AdBreakStatus["collectingStats"] = "collectingStats";
    return AdBreakStatus;
}({});

},{"../../rist":"csnXY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"csnXY":[function(require,module,exports,__globalThis) {
// for the rist-server
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RistServerFecMode", ()=>RistServerFecMode);
parcelHelpers.export(exports, "Importance", ()=>Importance);
parcelHelpers.export(exports, "DelayMode", ()=>DelayMode);
parcelHelpers.export(exports, "RistMultipathPolicy", ()=>RistMultipathPolicy);
parcelHelpers.export(exports, "RistInputMultipathState", ()=>RistInputMultipathState);
parcelHelpers.export(exports, "RistOutputMultipathState", ()=>RistOutputMultipathState);
parcelHelpers.export(exports, "ChannelState", ()=>ChannelState);
parcelHelpers.export(exports, "RtpInputStatusCode", ()=>RtpInputStatusCode);
parcelHelpers.export(exports, "UdpInputStatusCode", ()=>UdpInputStatusCode);
parcelHelpers.export(exports, "UdpOutputStatusCode", ()=>UdpOutputStatusCode);
var RistServerFecMode = /*#__PURE__*/ function(RistServerFecMode) {
    RistServerFecMode[RistServerFecMode["none"] = 0] = "none";
    RistServerFecMode[RistServerFecMode["1D"] = 1] = "1D";
    RistServerFecMode[RistServerFecMode["2D"] = 2] = "2D";
    return RistServerFecMode;
}({});
var Importance = /*#__PURE__*/ function(Importance) {
    Importance["vital"] = "vital";
    Importance["nonvital"] = "nonvital";
    return Importance;
}({});
var DelayMode = /*#__PURE__*/ function(DelayMode) {
    // basedOnRtpAndArrivalTime = 0,
    DelayMode[DelayMode["basedOnArrivalTime"] = 1] = "basedOnArrivalTime";
    DelayMode[DelayMode["basedOnOriginTime"] = 2] = "basedOnOriginTime";
    return DelayMode;
}({});
var RistMultipathPolicy = /*#__PURE__*/ function(RistMultipathPolicy) {
    // Of all healthy paths, the one with the highest priority is chosen.
    // The others are sent inhibit messages to prevent them from sending RTP.
    RistMultipathPolicy["failover"] = "failover";
    // No inhibit messages are sent on any input paths.
    RistMultipathPolicy["redundancy"] = "redundancy";
    // Propagate is failover with propagation of inhibit on all rist inputs
    // when all rist outputs are inhibited and no udp output is vital.
    // As soon as one rist output is resumed, propagation of inhibit stops.
    RistMultipathPolicy["propagate"] = "propagate";
    return RistMultipathPolicy;
}({});
var RistInputMultipathState = /*#__PURE__*/ function(RistInputMultipathState) {
    RistInputMultipathState["active"] = "active";
    RistInputMultipathState["standby"] = "standby";
    return RistInputMultipathState;
}({});
var RistOutputMultipathState = /*#__PURE__*/ function(RistOutputMultipathState) {
    RistOutputMultipathState["active"] = "active";
    RistOutputMultipathState["inhibited"] = "inhibited";
    return RistOutputMultipathState;
}({});
var ChannelState = /*#__PURE__*/ function(ChannelState) {
    ChannelState["activated"] = "activated";
    ChannelState["deactivated"] = "deactivated";
    return ChannelState;
}({});
var RtpInputStatusCode = /*#__PURE__*/ function(RtpInputStatusCode) {
    RtpInputStatusCode["ok"] = "ok";
    RtpInputStatusCode["oddSsrc"] = "odd_ssrc";
    RtpInputStatusCode["unknown"] = "unknown";
    return RtpInputStatusCode;
}({});
var UdpInputStatusCode = /*#__PURE__*/ function(UdpInputStatusCode) {
    UdpInputStatusCode["active"] = "active";
    UdpInputStatusCode["standby"] = "standby";
    return UdpInputStatusCode;
}({});
var UdpOutputStatusCode = /*#__PURE__*/ function(UdpOutputStatusCode) {
    UdpOutputStatusCode["playing"] = "playing";
    UdpOutputStatusCode["noData"] = "no_data";
    UdpOutputStatusCode["noOriginTime"] = "no_origin_time";
    UdpOutputStatusCode["noCommonTimeBase"] = "no_common_time_base";
    UdpOutputStatusCode["lagging"] = "lagging";
    return UdpOutputStatusCode;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lBjcz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OutputListDialog", ()=>OutputListDialog);
parcelHelpers.export(exports, "List", ()=>List);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _utils = require("../../../utils");
var _missingContent = require("../../common/MissingContent");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../../common/Link");
var _table = require("../../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableConfig = require("./tableConfig");
var _tableConfigDefault = parcelHelpers.interopDefault(_tableConfig);
var _selectOutputListDialog = require("./SelectOutputListDialog");
var _outputListsActions = require("../../../redux/actions/outputListsActions");
var _selectInputDialog = require("../SelectInputDialog");
var _outputsActions = require("../../../redux/actions/outputsActions");
var _deleteDialog = require("./DeleteDialog");
var _deleteDialogDefault = parcelHelpers.interopDefault(_deleteDialog);
var _commonActions = require("./CommonActions");
var _commonActionsDefault = parcelHelpers.interopDefault(_commonActions);
var _store = require("../../../store");
var OutputListDialog = /*#__PURE__*/ function(OutputListDialog) {
    OutputListDialog[OutputListDialog["selectInput"] = 0] = "selectInput";
    OutputListDialog[OutputListDialog["addToOutputList"] = 1] = "addToOutputList";
    return OutputListDialog;
}({});
function dialogReducer(state, action) {
    if (action.type === 'close') return {
        ...state,
        isOpen: false
    };
    return {
        isOpen: true,
        output: action.output,
        type: action.type
    };
}
const List = ()=>{
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { outputs, loading, total } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useOutputsSelector));
    const outputIds = outputs.map((o)=>o.id);
    (0, _react.useEffect)(()=>{
        dispatch((0, _outputsActions.registerOutputObserver)({
            outputIds
        }));
        return ()=>{
            dispatch((0, _outputsActions.unregisterOutputObserver)({
                outputIds
            }));
        };
    }, [
        JSON.stringify(outputIds)
    ]);
    const user = (0, _utils.useUser)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const [selected, setSelected] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        setSelected([]);
    }, [
        outputs.map((i)=>i.id).join(',')
    ]);
    const [dialog, dispatchDialogAction] = (0, _react.useReducer)(dialogReducer, {
        isOpen: false
    });
    const { settings } = (0, _utils.useSettingsSelector)();
    const experimentalFeatures = settings?.expFeatures;
    const closeDialog = ()=>dispatchDialogAction({
            type: 'close'
        });
    const showDialog = (output, type)=>dispatchDialogAction({
            type,
            output
        });
    const handleSelect = (id)=>{
        if (selected.includes(id)) setSelected([
            ...selected.filter((item)=>item !== id)
        ]);
        else setSelected([
            ...selected,
            id
        ]);
    };
    const handleSelectAll = ()=>{
        if (selected.length === outputs.length) setSelected([]);
        else setSelected(outputs.reduce((acc, { id })=>acc.concat(id), []));
    };
    const onOutputListSelect = (output, outputList)=>{
        dispatch((0, _outputListsActions.updateOutputList)({
            outputList: {
                ...outputList,
                addOutputs: [
                    output.id
                ],
                removeOutputs: []
            },
            withRedirection: false
        }));
    };
    const onInputSelected = (output, input)=>{
        // EDGE-2774: Use 'setInputOfOutput' instead of 'updateOutput' since it generates a more detailed audit-log message
        dispatch((0, _outputsActions.setInputOfOutput)({
            output,
            inputId: input.id
        }));
    };
    const onClearInput = (output)=>dispatch((0, _outputsActions.setInputOfOutput)({
            output,
            inputId: undefined
        }));
    const isDialogOpen = (type)=>dialog.isOpen && dialog.type === type;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Outputs",
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    type: "button",
                    to: routes.outputLists(),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "outlined",
                        color: "primary",
                        children: "Manage output lists"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    type: "button",
                    to: routes.outputsNew(),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        style: {
                            marginLeft: 8
                        },
                        id: "outputs-table-create-button",
                        variant: "contained",
                        color: "primary",
                        children: "Create output"
                    })
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commonActionsDefault.default), {
                outputs: outputs,
                selected: selected,
                setSelected: setSelected
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                id: "outputs-table",
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No outputs available",
                    buttonText: "Create output",
                    url: routes.outputsNew()
                }),
                config: (0, _tableConfigDefault.default)({
                    dispatch,
                    routes,
                    outputs,
                    experimentalFeatures,
                    selected,
                    handleSelect,
                    handleSelectAll,
                    showDialog,
                    user
                }),
                rowProps: ({ id, name })=>{
                    const isItemSelected = Boolean(id && selected.includes(id));
                    return {
                        onDoubleClick: ()=>navigate(routes.outputsUpdate({
                                id
                            })),
                        'aria-checked': isItemSelected,
                        tabIndex: -1,
                        selected: isItemSelected,
                        'data-output-name': name
                    };
                },
                data: outputs,
                pagination: {
                    useUrlSearchParams: true,
                    total
                },
                pending: loading
            }),
            dialog.output && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectInputDialog.SelectInputWithConfirmationDialog), {
                show: isDialogOpen(0),
                output: dialog.output,
                closeDialog: closeDialog,
                onInputSelect: onInputSelected,
                onClearInput: onClearInput
            }),
            dialog.output && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectOutputListDialog.SelectOutputListDialog), {
                output: dialog.output,
                show: isDialogOpen(1),
                onListSelect: onOutputListSelect,
                closeDialog: closeDialog
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDialogDefault.default), {
                setSelected: setSelected
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","@mui/material/Button":"3qJY9","../../../utils":"342UB","../../common/MissingContent":"1LBl6","../../common/Wrapper":"8oy7r","../../common/Link":"l3o6V","../../common/Table":"dt9lf","./tableConfig":"5ac6L","./SelectOutputListDialog":"CeCvU","../../../redux/actions/outputListsActions":"ce4Vm","../SelectInputDialog":"eqSKz","../../../redux/actions/outputsActions":"alMzI","./DeleteDialog":"l71Vt","./CommonActions":"2b0Uk","../../../store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"CeCvU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectOutputListDialog", ()=>SelectOutputListDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _store = require("../../../store");
var _title = require("../../common/Dialog/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _table = require("../../common/Table");
var _selfStatePaginatedList = require("../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
const { outputListsApi } = (0, _store.Api);
const styles = {
    name: {
        fontWeight: 'bold',
        fontSize: (theme)=>theme.typography.h4.fontSize
    },
    row: {
        cursor: 'pointer'
    }
};
const InputsTable = ({ output, closeDialog, onListSelect })=>{
    const onAddToListClick = (output, list)=>()=>{
            closeDialog();
            return onListSelect(output, list);
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
        api: (params)=>outputListsApi.getOutputLists({
                ...params,
                group: output.group
            }),
        searchPlaceholder: "Find output list\u2026",
        emptyMessage: "no output lists are available",
        notFoundMessage: "no matching output lists",
        List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                id: 'output-lists-table',
                data: list,
                emptyMessageComponent: "no output lists are available",
                props: {
                    size: 'small'
                },
                noHeader: true,
                rowProps: (outputList)=>({
                        onClick: onAddToListClick(output, outputList),
                        sx: styles.row
                    }),
                config: [
                    {
                        getValue: ({ name })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                sx: styles.name,
                                children: name
                            })
                    },
                    {
                        getValue: ({ description })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "body2",
                                color: "textSecondary",
                                children: description
                            })
                    }
                ]
            })
    });
};
const SelectOutputListDialog = ({ output, show, closeDialog, onListSelect })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: show && !!output,
        onClose: closeDialog,
        maxWidth: "md",
        fullWidth: true,
        disableRestoreFocus: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                title: `Add "${output?.name}" to output list`,
                onClose: closeDialog
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                sx: {
                    paddingBottom: 0 /* Remove bot padding for sticky pagination to look good */ 
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentTextDefault.default), {
                    component: "div",
                    children: show && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputsTable, {
                        output: output,
                        closeDialog: closeDialog,
                        onListSelect: onListSelect
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Dialog":"aOxpM","@mui/material/DialogContent":"l4i9c","@mui/material/DialogContentText":"7bReD","@mui/material/Typography":"6NtGx","../../../store":"5LXiG","../../common/Dialog/Title":"hFLmw","../../common/Table":"dt9lf","../../common/SelfStatePaginatedList":"dLSax","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eqSKz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectInputDialog", ()=>SelectInputDialog);
parcelHelpers.export(exports, "SelectInputWithConfirmationDialog", ()=>SelectInputWithConfirmationDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _store = require("../../store");
var _indicator = require("../common/Indicator");
var _title = require("../common/Dialog/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _table = require("../common/Table");
var _selfStatePaginatedList = require("../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _thumbnail = require("../common/Thumbnail");
var _thumbnailDefault = parcelHelpers.interopDefault(_thumbnail);
var _utils = require("../../utils");
var _helpers = require("common/api/v1/helpers");
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _react = require("react");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _utils1 = require("common/utils");
const { inputApi } = (0, _store.Api);
const styles = {
    thumbnail: {
        padding: (theme)=>theme.spacing(1),
        minWidth: '80px',
        maxWidth: '120px',
        minHeight: '50px'
    },
    name: {
        fontWeight: 'bold',
        fontSize: (theme)=>theme.typography.h4.fontSize
    },
    row: {
        cursor: 'pointer'
    }
};
const SelectInputDialog = ({ show, output, closeDialog, onInputSelect, onClearInput })=>{
    const onRowClicked = (selectedInput)=>{
        closeDialog();
        if (selectedInput) onInputSelect(output, {
            ...selectedInput
        });
    };
    const onClearInputClicked = ()=>{
        closeDialog();
        onClearInput(output);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: Boolean(show && output),
        disableRestoreFocus: true,
        onClose: closeDialog,
        maxWidth: "md",
        fullWidth: true,
        id: "switch-input-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                title: `Switch input of ${output.name}`,
                onClose: closeDialog
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                sx: {
                    paddingBottom: 0 /* Remove bot padding for sticky pagination to look good */ 
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentTextDefault.default), {
                    component: "div",
                    children: show && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginatedInputList, {
                        output: output,
                        onRowClicked: onRowClicked
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogActionsDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "outlined",
                        color: "secondary",
                        onClick: closeDialog,
                        "data-test-id": "cancel-btn",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: !output.input,
                        variant: "outlined",
                        onClick: onClearInputClicked,
                        "data-test-id": "clear-input-btn",
                        children: "Clear"
                    })
                ]
            })
        ]
    });
};
const SelectInputWithConfirmationDialog = ({ show, output, closeDialog, onInputSelect, onClearInput })=>{
    const showConfirmationDialog = (0, _utils.useConfirmationDialog)();
    const [selectedInput, setSelectedInput] = (0, _react.useState)(output._input);
    (0, _react.useEffect)(()=>{
        if (!show) setSelectedInput(undefined);
        else setSelectedInput(output._input);
    }, [
        show,
        output
    ]);
    const resetStateAndClose = ()=>{
        // The same dialog component is re-used between presentations,
        // i.e. dialog state is persisted...
        setSelectedInput(undefined);
        closeDialog();
    };
    const onSaveButtonClicked = (selectedInput)=>{
        const isRedundantOutput = output.redundancyMode != (0, _types.OutputRedundancyMode).none;
        const isRedundantInput = !!selectedInput && (0, _utils1.inputRedundancy)(selectedInput);
        const outputRedundancyWillBeRemoved = isRedundantOutput && !isRedundantInput;
        const title = selectedInput ? outputRedundancyWillBeRemoved ? `Assigning non-redundant input "${selectedInput.name}" to output "${output.name}" will disable output redundancy. Proceed?` : `Assign input "${selectedInput.name}" to output "${output.name}"?` : `Clear the input of output "${output.name}"?`;
        const action = selectedInput ? ()=>{
            onInputSelect(output, {
                ...selectedInput
            });
            resetStateAndClose();
        } : ()=>{
            onClearInput(output);
            resetStateAndClose();
        };
        showConfirmationDialog(action, title);
    };
    const hasSelectedSameInput = selectedInput?.id === output.input;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: Boolean(show && output),
        disableRestoreFocus: true,
        onClose: resetStateAndClose,
        maxWidth: "md",
        fullWidth: true,
        id: "switch-input-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                title: `Switch input of ${output.name}`,
                onClose: resetStateAndClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                sx: {
                    paddingBottom: 0 /* Remove bot padding for sticky pagination to look good */ 
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentTextDefault.default), {
                    component: "div",
                    children: show && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginatedInputList, {
                        output: output,
                        onRowClicked: (input)=>{
                            const isAlreadySelected = input?.id === selectedInput?.id;
                            setSelectedInput(isAlreadySelected ? undefined : input);
                        },
                        selectedInputColumn: {
                            selectedInput
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogActionsDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "outlined",
                        color: "secondary",
                        onClick: resetStateAndClose,
                        "data-test-id": "cancel-btn",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: !output.input,
                        variant: "outlined",
                        onClick: ()=>onSaveButtonClicked(undefined),
                        "data-test-id": "clear-input-btn",
                        children: "Clear"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "contained",
                        color: "primary",
                        disabled: hasSelectedSameInput,
                        onClick: ()=>onSaveButtonClicked(selectedInput),
                        "data-test-id": "save-btn",
                        children: "Save"
                    })
                ]
            })
        ]
    });
};
const PaginatedInputList = ({ output, onRowClicked, selectedInputColumn })=>{
    const config = [
        {
            getValue: (input)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: styles.thumbnail,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnailDefault.default), {
                        input: input,
                        linkToPlaylist: false
                    })
                })
        },
        {
            getValue: ({ name, _owner, adminStatus })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            "data-test-id": "input-name",
                            sx: styles.name,
                            ...(0, _utils.inputOutputColor)({
                                adminStatus
                            }),
                            children: name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            color: "textSecondary",
                            variant: "body2",
                            children: _owner ? _owner.name : ''
                        })
                    ]
                })
        },
        {
            getValue: ({ tsInfo })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    color: "textSecondary",
                    variant: "body2",
                    children: (0, _helpers.getFormattedTransportStreamContent)((tsInfo || [])[0])
                })
        },
        {
            getValue: (input)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AutoUpdatingInputHealthIndicator), {
                    initialInput: input
                })
        }
    ];
    const showSelectionColumn = !!selectedInputColumn;
    if (showSelectionColumn) config.push({
        getValue: (input)=>{
            const isSelected = selectedInputColumn?.selectedInput?.id === input.id;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                sx: {
                    visibility: isSelected ? 'visible' : 'hidden'
                },
                variant: "outlined",
                size: "small",
                children: "Selected"
            });
        },
        props: {
            align: 'center',
            noTypography: true
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
        api: inputApi.getInputs.bind(inputApi),
        otherParams: {
            canSubscribe: true
        },
        searchPlaceholder: "Find input\u2026",
        emptyMessage: "no inputs are available",
        notFoundMessage: "no matching inputs",
        Header: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            color: "textSecondary",
                            variant: "body1",
                            children: [
                                "Current input: ",
                                output._input ? output._input.name : 'none'
                            ]
                        }),
                        showSelectionColumn && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            color: "textSecondary",
                            variant: "body1",
                            children: [
                                "New input: ",
                                selectedInputColumn?.selectedInput?.name ?? 'none'
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                    sx: {
                        marginTop: 2,
                        marginBottom: 2
                    }
                })
            ]
        }),
        List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                id: "input-switch",
                data: list,
                props: {
                    size: 'small'
                },
                noHeader: true,
                rowProps: (input)=>({
                        onClick: ()=>onRowClicked(input),
                        selected: output.input === input.id,
                        sx: styles.row
                    }),
                config: config
            })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Dialog":"aOxpM","@mui/material/DialogContent":"l4i9c","@mui/material/DialogContentText":"7bReD","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../store":"5LXiG","../common/Indicator":"hqaQa","../common/Dialog/Title":"hFLmw","../common/Table":"dt9lf","../common/SelfStatePaginatedList":"dLSax","../common/Thumbnail":"5Q8KF","../../utils":"342UB","common/api/v1/helpers":"6jovr","@mui/material/DialogActions":"h1RVn","react":"9njXz","@mui/material/Divider":"9Ul8c","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l71Vt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _outputsActions = require("../../../redux/actions/outputsActions");
var _utils = require("../../../utils");
const DeleteDialog = ({ setSelected })=>{
    const [confirmTextValue, setConfirmTextValue] = (0, _react.useState)('');
    const { draft: { outputs, action, source } } = (0, _reactRedux.useSelector)(({ outputsReducer })=>({
            draft: outputsReducer.draft
        }), (0, _reactRedux.shallowEqual));
    const dispatch = (0, _reactRedux.useDispatch)();
    if (!outputs.length) return null;
    const onCancelClick = ()=>{
        setConfirmTextValue('');
        dispatch((0, _outputsActions.draftOutputs)({
            outputs: []
        }));
    };
    const handleOk = ()=>{
        setConfirmTextValue('');
        dispatch((0, _outputsActions.draftOutputs)({
            outputs: []
        }));
        if (action === (0, _outputsActions.DraftActions).delete) dispatch((0, _outputsActions.removeOutputs)(outputs.map(({ id })=>id)));
        if (action === (0, _outputsActions.DraftActions).disable) {
            dispatch((0, _outputsActions.disableOutputs)(outputs.map(({ id })=>id)));
            setSelected([]);
        }
    };
    const confirmText = (outputs.length === 1 ? outputs[0].name : `${action} outputs`).toLowerCase();
    const isConfirmRequired = source === (0, _outputsActions.DraftSources).batch && action === (0, _outputsActions.DraftActions).delete;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: outputs.length > 0 && (action === (0, _outputsActions.DraftActions).delete || action === (0, _outputsActions.DraftActions).disable),
        disableRestoreFocus: true,
        onClose: (_event, reason)=>{
            if (reason === 'escapeKeyDown') onCancelClick();
        },
        "data-test-id": "confirm-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentTextDefault.default), {
                        gutterBottom: true,
                        component: "div",
                        children: [
                            `Are you sure you want to ${action} ${outputs.length > 1 ? (0, _utils.pluralize)(outputs.length, 'output') : outputs[0].name}?`,
                            outputs.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                children: outputs.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        children: item.name
                                    }, item.id))
                            })
                        ]
                    }),
                    isConfirmRequired && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentTextDefault.default), {
                                gutterBottom: true,
                                children: [
                                    "To confirm, type",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            fontStyle: 'italic',
                                            fontWeight: 'bold'
                                        },
                                        "data-test-id": "confirm-text-value",
                                        children: confirmText
                                    }),
                                    ' ',
                                    "below"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                "data-test-id": "confirm-text-field",
                                autoFocus: true,
                                fullWidth: true,
                                placeholder: confirmText,
                                value: confirmTextValue,
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter' && confirmTextValue.toLowerCase() === confirmText) handleOk();
                                },
                                onChange: (e)=>setConfirmTextValue(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogActionsDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "outlined",
                        color: "secondary",
                        onClick: onCancelClick,
                        "data-test-id": "cancel-btn",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "contained",
                        color: action === (0, _outputsActions.DraftActions).delete ? 'error' : 'primary',
                        onClick: handleOk,
                        "data-test-id": "ok-btn",
                        disabled: isConfirmRequired ? confirmTextValue.toLowerCase() !== confirmText : false,
                        children: action
                    })
                ]
            })
        ]
    });
};
exports.default = DeleteDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Dialog":"aOxpM","@mui/material/DialogActions":"h1RVn","@mui/material/DialogContent":"l4i9c","@mui/material/DialogContentText":"7bReD","@mui/material/Button":"3qJY9","@mui/material/TextField":"l88b4","../../../redux/actions/outputsActions":"alMzI","../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2b0Uk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _playArrow = require("@mui/icons-material/PlayArrow");
var _playArrowDefault = parcelHelpers.interopDefault(_playArrow);
var _stop = require("@mui/icons-material/Stop");
var _stopDefault = parcelHelpers.interopDefault(_stop);
var _types = require("common/api/v1/types");
var _utils = require("../../../utils");
var _store = require("../../../store");
var _outputsActions = require("../../../redux/actions/outputsActions");
var _listOutputFilter = require("./listOutputFilter");
var _filteredSearchBar = require("../../common/Filters/FilterView/FilteredSearchBar");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const BatchEnableButton = ({ selected, setSelected })=>{
    const outputs = (0, _reactRedux.useSelector)((state)=>state.outputsReducer.outputs, (0, _reactRedux.shallowEqual));
    const dispatch = (0, _reactRedux.useDispatch)();
    const selectedOutputs = outputs.filter(({ id })=>selected.includes(id));
    const enable = selected.length > 0 && selectedOutputs.some(({ adminStatus })=>adminStatus === (0, _types.OutputAdminStatus).off);
    const onEnableClick = ()=>{
        dispatch((0, _outputsActions.enableOutputs)(selected));
        dispatch((0, _outputsActions.draftOutputs)({
            outputs: []
        }));
        setSelected([]);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: 'Enable selected outputs',
        disablePortal: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "Enable",
                disabled: !enable,
                onClick: onEnableClick,
                "data-test-id": "batch-enable",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playArrowDefault.default), {})
            })
        })
    });
};
const BatchDisableButton = ({ selected })=>{
    const outputs = (0, _reactRedux.useSelector)((state)=>state.outputsReducer.outputs, (0, _reactRedux.shallowEqual));
    const dispatch = (0, _reactRedux.useDispatch)();
    const selectedOutputs = outputs.filter(({ id })=>selected.includes(id));
    const enable = selected.length > 0 && selectedOutputs.some(({ adminStatus })=>adminStatus === (0, _types.OutputAdminStatus).on);
    const onDisableClick = ()=>{
        dispatch((0, _outputsActions.draftOutputs)({
            action: (0, _outputsActions.DraftActions).disable,
            outputs: selectedOutputs,
            source: (0, _outputsActions.DraftSources).batch
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: 'Disable selected outputs',
        disablePortal: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "Disable",
                disabled: !enable,
                onClick: onDisableClick,
                "data-test-id": "batch-disable",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stopDefault.default), {})
            })
        })
    });
};
const CommonActions = ({ outputs, selected, setSelected })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { settings } = (0, _utils.useSettingsSelector)();
    const expFeatures = settings?.expFeatures;
    const outputsMap = outputs.reduce((acc, item)=>({
            ...acc,
            [item.id]: item
        }), {});
    const { showButtons } = selected.reduce(({ showButtons }, id)=>{
        const output = outputsMap[id];
        return {
            showButtons: Boolean(showButtons && output)
        };
    }, {
        showButtons: true
    });
    const onDeleteClick = ()=>dispatch((0, _outputsActions.draftOutputs)({
            action: (0, _outputsActions.DraftActions).delete,
            outputs: selected.map((id)=>outputsMap[id]),
            source: (0, _outputsActions.DraftSources).batch
        }));
    const filters = (0, _listOutputFilter.makeListOutputFilter)({
        api: (0, _store.Api),
        expFeatures
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
        disableGutters: true,
        style: {
            overflowX: 'clip'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>theme.transitions.create('flex-shrink', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.shortest
                        })
                },
                style: {
                    flexShrink: selected.length > 0 ? 1 : 0,
                    flexGrow: 1,
                    flexBasis: '100%'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                    urlParamCacheKey: 'outputs',
                    mapUrlParamToFilterFn: (0, _listOutputFilter.mapUrlParamToOutputFilter),
                    mapFilterToUrlParamFn: (0, _listOutputFilter.mapOutputFilterToUrlParam),
                    searchTokenFilters: filters,
                    rawTextFilter: filters.find((f)=>f.key === (0, _listOutputFilter.ListOutputFilterKey).name)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>// Fade out, i.e. keep visible until contents has left the screen
                        theme.transitions.create('visibility', {
                            delay: selected.length === 0 ? theme.transitions.duration.shortest : 0
                        })
                },
                style: {
                    marginLeft: 16,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    visibility: selected.length > 0 ? 'visible' : 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: 150,
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            variant: "subtitle1",
                            children: [
                                (0, _utils.pluralize)(selected.length, 'output'),
                                " selected"
                            ]
                        })
                    }),
                    showButtons && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                title: 'Delete selected outputs',
                                disablePortal: false,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                        "aria-label": "Delete",
                                        onClick: onDeleteClick,
                                        "data-test-id": "delete-selected",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BatchDisableButton, {
                                selected: selected
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BatchEnableButton, {
                                selected: selected,
                                setSelected: setSelected
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = CommonActions;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/IconButton":"488As","@mui/material/Typography":"6NtGx","@mui/material/Toolbar":"5Kohb","../../common/Tooltip":"crjvg","@mui/icons-material/Delete":"69aC7","@mui/icons-material/PlayArrow":"4aev3","@mui/icons-material/Stop":"1bxT4","common/api/v1/types":"3qemx","../../../utils":"342UB","../../../store":"5LXiG","../../../redux/actions/outputsActions":"alMzI","./listOutputFilter":"CuHBL","../../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@mui/material/Box":"c4QkF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"CuHBL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListOutputFilterKey", ()=>ListOutputFilterKey);
// Constructs a list-Output-filter populated with possible values/suggestions
parcelHelpers.export(exports, "makeListOutputFilter", ()=>makeListOutputFilter);
parcelHelpers.export(exports, "mapOutputFilterToUrlParam", ()=>mapOutputFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToOutputFilter", ()=>mapUrlParamToOutputFilter);
var _nmTypes = require("../../../api/nm-types");
var _types = require("common/api/v1/types");
var _utils = require("common/utils");
var ListOutputFilterKey = /*#__PURE__*/ function(ListOutputFilterKey) {
    ListOutputFilterKey["appliance"] = "appliance";
    ListOutputFilterKey["name"] = "name";
    ListOutputFilterKey["healthStatus"] = "health status";
    ListOutputFilterKey["adminStatus"] = "admin status";
    ListOutputFilterKey["input"] = "input";
    ListOutputFilterKey["applianceRegion"] = "appliance region";
    ListOutputFilterKey["group"] = "group";
    ListOutputFilterKey["tag"] = "tag";
    return ListOutputFilterKey;
}({});
function makeListOutputFilter({ api, expFeatures }) {
    const requestPaging = {
        pageNumber: '0',
        rowsPerPage: '20'
    };
    const supportsStatusFilter = expFeatures && expFeatures.ExtHealthAlarms;
    const filterTemplates = [
        ...supportsStatusFilter ? [
            {
                key: "health status",
                operator: 'is',
                possibleValuesSync: (searchText)=>{
                    return [
                        {
                            value: (0, _nmTypes.OutputFilterHealthStatus).healthy,
                            displayName: 'healthy'
                        },
                        {
                            value: (0, _nmTypes.OutputFilterHealthStatus).unhealthy,
                            displayName: 'unhealthy'
                        }
                    ].filter((v)=>!searchText || v.displayName.includes(searchText));
                }
            }
        ] : [],
        {
            key: "admin status",
            operator: 'is',
            possibleValuesSync: (searchText)=>{
                return [
                    {
                        value: (0, _types.OutputAdminStatus).on.toString(),
                        displayName: 'enabled'
                    },
                    {
                        value: (0, _types.OutputAdminStatus).off.toString(),
                        displayName: 'disabled'
                    }
                ].filter((v)=>!searchText || v.displayName.includes(searchText));
            }
        },
        {
            key: "name",
            operator: 'matches'
        },
        {
            key: "input",
            operator: 'is',
            possibleValues: async (searchText)=>{
                const result = await api.inputApi.getBareInputs({
                    ...requestPaging,
                    filter: searchText
                });
                return result.items.map((a)=>({
                        value: a.name,
                        displayName: a.name
                    }));
            }
        },
        {
            key: "appliance region",
            operator: 'isOneOf',
            possibleValues: async (searchText)=>{
                const result = await api.regionApi.getRegions({
                    ...requestPaging,
                    filter: searchText
                });
                return result.items.map((a)=>({
                        value: a.name,
                        displayName: a.name
                    }));
            }
        },
        {
            key: "appliance",
            operator: 'isOneOf',
            possibleValues: async (searchText)=>{
                const result = await api.appliancesApi.getBareAppliances({
                    ...requestPaging,
                    filter: searchText
                });
                return result.items.filter((a)=>a.type !== (0, _types.ApplianceType).thumb).map((a)=>({
                        value: a.name,
                        displayName: a.name
                    }));
            }
        },
        {
            key: "group",
            operator: 'is',
            possibleValues: async (searchText)=>{
                const result = await api.groupsApi.getPureGroups({
                    ...requestPaging,
                    filter: searchText
                });
                return result.items.map((a)=>({
                        value: a.name,
                        displayName: a.name
                    }));
            }
        },
        {
            key: "tag",
            operator: 'isOneOf',
            possibleValues: async (searchText)=>{
                const { items: tags } = await api.tagApi.listTags({
                    filter: {
                        searchName: searchText
                    }
                });
                // Super user receives tags from all groups - no need to display duplicates
                const uniqueTags = (0, _utils.distinct)(tags, (a, b)=>a.name === b.name);
                return uniqueTags.map(({ name })=>({
                        value: name,
                        displayName: name
                    }));
            }
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}
function mapOutputFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
        case "health status":
            return {
                health: filter.value
            };
        case "group":
            return {
                group: filter.value
            };
        case "input":
            return {
                inputName: filter.value
            };
        case "admin status":
            return {
                adminStatus: filter.value
            };
    }
    else if ('values' in filter) switch(filter.key){
        case "appliance":
            return {
                appliances: filter.values.map(({ value })=>value).join(',')
            };
        case "appliance region":
            return {
                regions: filter.values.map(({ value })=>value).join(',')
            };
        case "tag":
            return {
                tags: filter.values.map(({ value })=>value).join(',')
            };
    }
    return {};
}
function mapUrlParamToOutputFilter(key, value) {
    switch(key){
        case 'appliances':
            return {
                key: "appliance",
                operator: 'isOneOf',
                values: value.split(',').map((applianceName)=>({
                        value: applianceName,
                        displayName: applianceName
                    }))
            };
        case 'regions':
            return {
                key: "appliance region",
                operator: 'isOneOf',
                values: value.split(',').map((regionName)=>({
                        value: regionName,
                        displayName: regionName
                    }))
            };
        case 'inputName':
            return {
                key: "input",
                operator: 'is',
                value
            };
        case 'group':
            return {
                key: "group",
                operator: 'is',
                value
            };
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
        case 'adminStatus':
            if (![
                (0, _types.OutputAdminStatus).on.toString(),
                (0, _types.OutputAdminStatus).off.toString()
            ].includes(value)) return undefined;
            return {
                key: "admin status",
                operator: 'is',
                value,
                displayName: value === (0, _types.OutputAdminStatus).on.toString() ? 'enabled' : 'disabled'
            };
        case 'health':
            if (![
                (0, _nmTypes.OutputFilterHealthStatus).healthy.toString(),
                (0, _nmTypes.OutputFilterHealthStatus).unhealthy.toString()
            ].includes(value)) return undefined;
            return {
                key: "health status",
                operator: 'is',
                value,
                displayName: value === (0, _nmTypes.OutputFilterHealthStatus).healthy.toString() ? 'healthy' : 'unhealthy'
            };
        case 'tags':
            return {
                key: "tag",
                operator: 'isOneOf',
                values: value.split(',').map((tagName)=>({
                        value: tagName,
                        displayName: tagName
                    }))
            };
    }
    return undefined;
}

},{"../../../api/nm-types":"bcYl5","common/api/v1/types":"3qemx","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6PlbH":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("347d242904538841").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("be7e0b09ca25e07"));
var _jsxRuntime = require("b3e9e96ba2b84a29");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16"
}), 'MonetizationOn');

},{"347d242904538841":"kZ6eK","be7e0b09ca25e07":"2vOnF","b3e9e96ba2b84a29":"1dlk8"}],"dfRs7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Profile", ()=>Profile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _reactQrCode = require("react-qr-code");
var _reactQrCodeDefault = parcelHelpers.interopDefault(_reactQrCode);
var _store = require("../../store");
var _userActions = require("../../redux/actions/userActions");
var _notificationActions = require("../../redux/actions/notificationActions");
var _uiActions = require("../../redux/actions/uiActions");
var _common = require("../../Common");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _form = require("../common/Form");
var _dataSet = require("../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _utils = require("../../utils");
var _types = require("common/api/v1/types");
var _util = require("common/util");
var _apitokens = require("./APITokens");
const MFADataValue = (isTOTPEnabled, onUpdateUri, disabled = false)=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
    const handleClose = (event)=>{
        event.stopPropagation();
        setAnchorEl(null);
    };
    const handleClickMFAMenu = (event)=>{
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleMFAShow = ()=>{
        (0, _store.Api).userApi.configureTOTP().then((res)=>onUpdateUri(res.uri)).catch((error)=>dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error,
                operation: 'configure MFA'
            })));
        setAnchorEl(null);
    };
    const handleMFADelete = ()=>{
        (0, _store.Api).userApi.deleteTOTP().then(()=>{
            dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Deleted MFA'));
            dispatch((0, _userActions.fetchCurrentUser)());
            setAnchorEl(null);
            onUpdateUri('');
        }).catch((error)=>dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error,
                operation: 'delete MFA'
            })));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: 'flex'
        },
        children: [
            disabled ? 'Disabled' : isTOTPEnabled ? 'Configured' : 'Not configured',
            !disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                onClick: handleClickMFAMenu,
                sx: {
                    marginTop: -1,
                    marginLeft: 3
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                open: Boolean(anchorEl),
                keepMounted: true,
                anchorEl: anchorEl,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleMFAShow,
                        children: "Show"
                    }),
                    isTOTPEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleMFADelete,
                        sx: (0, _common.styles).error,
                        children: "Delete"
                    }) : null
                ]
            })
        ]
    });
};
const MFAPane = ({ uri, onClose })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [token, setToken] = (0, _react.useState)('');
    const secret = (0, _react.useMemo)(()=>{
        try {
            return new URL(uri).searchParams.get('secret') ?? '';
        } catch (_e) {
            return '';
        }
    }, [
        uri
    ]);
    const handleSave = ()=>{
        (0, _store.Api).userApi.verifyTOTP(token).then(()=>{
            dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Configured MFA'));
            dispatch((0, _userActions.fetchCurrentUser)());
            onClose();
        }).catch((error)=>dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error,
                operation: 'verify MFA code'
            })));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Multi-factor Authentication",
        actionsPane: [],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                marginTop: 3,
                gap: 3
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: "1. Scan the QR code with your authenticator app"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: {
                        background: 'white',
                        padding: '16px',
                        maxWidth: 200
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQrCodeDefault.default), {
                        size: 200,
                        style: {
                            height: 'auto',
                            maxWidth: '100%',
                            width: '100%'
                        },
                        value: uri,
                        viewBox: '0 0 200 200'
                    })
                }),
                secret ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                    variant: "caption",
                    children: [
                        "Alternatively, you can enter a key manually: ",
                        secret
                    ]
                }) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: "2. Verify the MFA code from your authenticator app"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                    onChange: (e)=>setToken(e.target.value),
                    onKeyDown: (e)=>{
                        if (e.key === 'Enter') {
                            handleSave();
                            e.preventDefault();
                        }
                    },
                    id: "verify-mfacode",
                    label: "Verify the MFA code",
                    autoComplete: "one-time-code",
                    sx: {
                        maxWidth: 200
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                    main: {},
                    secondary: {
                        Cancel: {
                            onClick: onClose
                        },
                        Save: {
                            primary: true,
                            onClick: handleSave
                        }
                    }
                })
            ]
        })
    });
};
const UserSettingsView = ({ userId, initialSettings })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [settings, setSettings] = (0, _react.useState)((0, _util.clone)(initialSettings));
    const errorSnackbarPosition = (0, _reactRedux.useSelector)(({ uiReducer })=>uiReducer.errorSnackbarPosition);
    const [errorAt, setErrorAt] = (0, _react.useState)(errorSnackbarPosition);
    const onSave = ()=>{
        dispatch((0, _userActions.saveUserSettings)({
            userId,
            settings
        }));
        dispatch((0, _uiActions.changeErrorSnackbarPosition)(errorAt));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Preferences",
        actionsPane: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "contained",
                color: "primary",
                onClick: onSave,
                children: "Save"
            })
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                enabled: settings.alarm.notificationsEnabled !== initialSettings.alarm.notificationsEnabled
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                    label: "Show alarm notifications",
                    control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                        checked: settings.alarm.notificationsEnabled,
                        onChange: ()=>setSettings((prevState)=>({
                                    ...prevState,
                                    alarm: {
                                        ...prevState.alarm,
                                        notificationsEnabled: !prevState.alarm.notificationsEnabled
                                    }
                                }))
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.GridItem), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body1",
                        children: "Show error notification at:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectDefault.default), {
                        sx: {
                            m: 1,
                            minWidth: 150
                        },
                        value: errorAt,
                        onChange: (ev)=>setErrorAt(ev.target.value),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: "bottom-right",
                                children: "bottom-right"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: "top-right",
                                children: "top-right"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: "top-left",
                                children: "top-left"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: "bottom-left",
                                children: "bottom-left"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const Profile = ({ isStreamManager })=>{
    const user = (0, _utils.useUser)();
    const [uri, setUri] = (0, _react.useState)('');
    const onUpdateUri = (uri)=>{
        setUri(uri ?? '');
    };
    const meta = {
        Name: user.username,
        Role: user.role,
        Group: user._group.name,
        MFA: MFADataValue(user.mfa?.totp?.enabled, onUpdateUri, user.external)
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Profile",
        isStreamManager: isStreamManager,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: "User data",
                actionsPane: [],
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: meta
                })
            }),
            uri ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MFAPane, {
                uri: uri,
                onClose: ()=>setUri('')
            }) : null,
            user.role === (0, _types.Role).super && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _apitokens.APITokensTable), {}),
            user.settings && /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserSettingsView, {
                userId: user.id,
                initialSettings: user.settings
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Checkbox":"ag1Z5","@mui/material/FormControlLabel":"45VZW","@mui/material/IconButton":"488As","@mui/material/Menu":"1ut4X","@mui/material/MenuItem":"krMs8","@mui/material/Select":"kyj0v","@mui/material/TextField":"l88b4","@mui/material/Typography":"6NtGx","@mui/icons-material/MoreVert":"22WtH","react-qr-code":"l1155","../../store":"5LXiG","../../redux/actions/userActions":"2tWgd","../../redux/actions/notificationActions":"7LkQg","../../redux/actions/uiActions":"aO8kk","../../Common":"7DOrW","../common/Wrapper":"8oy7r","../common/Form":"4Mui7","../common/DataSet":"dmQXG","../../utils":"342UB","common/api/v1/types":"3qemx","common/util":"jV4UZ","./APITokens":"cCAiL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l1155":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QRCode = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _propTypes = require("a33cfa6b50a1f4c1");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ErrorCorrectLevel = require("1545c2a074cf6198");
var _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel);
var _QRCode = require("98c7d9f2ae1dde49");
var _QRCode2 = _interopRequireDefault(_QRCode);
var _react = require("91460e89cda6a6f5");
var _react2 = _interopRequireDefault(_react);
var _QRCodeSvg = require("559cdd5940230159");
var _QRCodeSvg2 = _interopRequireDefault(_QRCodeSvg);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
// A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.
var propTypes = {
    bgColor: _propTypes2.default.oneOfType([
        _propTypes2.default.object,
        _propTypes2.default.string
    ]),
    fgColor: _propTypes2.default.oneOfType([
        _propTypes2.default.object,
        _propTypes2.default.string
    ]),
    level: _propTypes2.default.string,
    size: _propTypes2.default.number,
    value: _propTypes2.default.string.isRequired
};
var QRCode = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === undefined ? "#FFFFFF" : _ref$bgColor, _ref$fgColor = _ref.fgColor, fgColor = _ref$fgColor === undefined ? "#000000" : _ref$fgColor, _ref$level = _ref.level, level = _ref$level === undefined ? "L" : _ref$level, _ref$size = _ref.size, size = _ref$size === undefined ? 256 : _ref$size, value = _ref.value, props = _objectWithoutProperties(_ref, [
        "bgColor",
        "fgColor",
        "level",
        "size",
        "value"
    ]);
    // Use type === -1 to automatically pick the best type.
    var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
    qrcode.addData(value);
    qrcode.make();
    var cells = qrcode.modules;
    return _react2.default.createElement(_QRCodeSvg2.default, _extends({}, props, {
        bgColor: bgColor,
        bgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        fgColor: fgColor,
        fgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        ref: ref,
        size: size,
        viewBoxSize: cells.length
    }));
});
exports.QRCode = QRCode;
QRCode.displayName = "QRCode";
QRCode.propTypes = propTypes;
exports.default = QRCode;

},{"a33cfa6b50a1f4c1":"bnNSm","1545c2a074cf6198":"lWMoU","98c7d9f2ae1dde49":"hLob3","91460e89cda6a6f5":"9njXz","559cdd5940230159":"dwmEb"}],"lWMoU":[function(require,module,exports,__globalThis) {
module.exports = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};

},{}],"hLob3":[function(require,module,exports,__globalThis) {
var BitByte = require("994ab1655494fbd0");
var RSBlock = require("919c509a6f269fad");
var BitBuffer = require("bd1ef7d1ea355bd6");
var util = require("6a5261ac3b21ef40");
var Polynomial = require("e88e1dcb8e0375b7");
function QRCode(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
// for client side minification
var proto = QRCode.prototype;
proto.addData = function(data) {
    var newData = new BitByte(data);
    this.dataList.push(newData);
    this.dataCache = null;
};
proto.isDark = function(row, col) {
    if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) throw new Error(row + "," + col);
    return this.modules[row][col];
};
proto.getModuleCount = function() {
    return this.moduleCount;
};
proto.make = function() {
    // Calculate automatically typeNumber if provided is < 1
    if (this.typeNumber < 1) {
        var typeNumber = 1;
        for(typeNumber = 1; typeNumber < 40; typeNumber++){
            var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
            var buffer = new BitBuffer();
            var totalDataCount = 0;
            for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
            for(var i = 0; i < this.dataList.length; i++){
                var data = this.dataList[i];
                buffer.put(data.mode, 4);
                buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
                data.write(buffer);
            }
            if (buffer.getLengthInBits() <= totalDataCount * 8) break;
        }
        this.typeNumber = typeNumber;
    }
    this.makeImpl(false, this.getBestMaskPattern());
};
proto.makeImpl = function(test, maskPattern) {
    this.moduleCount = this.typeNumber * 4 + 17;
    this.modules = new Array(this.moduleCount);
    for(var row = 0; row < this.moduleCount; row++){
        this.modules[row] = new Array(this.moduleCount);
        for(var col = 0; col < this.moduleCount; col++)this.modules[row][col] = null; //(col + row) % 3;
    }
    this.setupPositionProbePattern(0, 0);
    this.setupPositionProbePattern(this.moduleCount - 7, 0);
    this.setupPositionProbePattern(0, this.moduleCount - 7);
    this.setupPositionAdjustPattern();
    this.setupTimingPattern();
    this.setupTypeInfo(test, maskPattern);
    if (this.typeNumber >= 7) this.setupTypeNumber(test);
    if (this.dataCache == null) this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
    this.mapData(this.dataCache, maskPattern);
};
proto.setupPositionProbePattern = function(row, col) {
    for(var r = -1; r <= 7; r++){
        if (row + r <= -1 || this.moduleCount <= row + r) continue;
        for(var c = -1; c <= 7; c++){
            if (col + c <= -1 || this.moduleCount <= col + c) continue;
            if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
proto.getBestMaskPattern = function() {
    var minLostPoint = 0;
    var pattern = 0;
    for(var i = 0; i < 8; i++){
        this.makeImpl(true, i);
        var lostPoint = util.getLostPoint(this);
        if (i == 0 || minLostPoint > lostPoint) {
            minLostPoint = lostPoint;
            pattern = i;
        }
    }
    return pattern;
};
proto.createMovieClip = function(target_mc, instance_name, depth) {
    var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
    var cs = 1;
    this.make();
    for(var row = 0; row < this.modules.length; row++){
        var y = row * cs;
        for(var col = 0; col < this.modules[row].length; col++){
            var x = col * cs;
            var dark = this.modules[row][col];
            if (dark) {
                qr_mc.beginFill(0, 100);
                qr_mc.moveTo(x, y);
                qr_mc.lineTo(x + cs, y);
                qr_mc.lineTo(x + cs, y + cs);
                qr_mc.lineTo(x, y + cs);
                qr_mc.endFill();
            }
        }
    }
    return qr_mc;
};
proto.setupTimingPattern = function() {
    for(var r = 8; r < this.moduleCount - 8; r++){
        if (this.modules[r][6] != null) continue;
        this.modules[r][6] = r % 2 == 0;
    }
    for(var c = 8; c < this.moduleCount - 8; c++){
        if (this.modules[6][c] != null) continue;
        this.modules[6][c] = c % 2 == 0;
    }
};
proto.setupPositionAdjustPattern = function() {
    var pos = util.getPatternPosition(this.typeNumber);
    for(var i = 0; i < pos.length; i++)for(var j = 0; j < pos.length; j++){
        var row = pos[i];
        var col = pos[j];
        if (this.modules[row][col] != null) continue;
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
proto.setupTypeNumber = function(test) {
    var bits = util.getBCHTypeNumber(this.typeNumber);
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
    }
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
    }
};
proto.setupTypeInfo = function(test, maskPattern) {
    var data = this.errorCorrectLevel << 3 | maskPattern;
    var bits = util.getBCHTypeInfo(data);
    // vertical		
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 6) this.modules[i][8] = mod;
        else if (i < 8) this.modules[i + 1][8] = mod;
        else this.modules[this.moduleCount - 15 + i][8] = mod;
    }
    // horizontal
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 8) this.modules[8][this.moduleCount - i - 1] = mod;
        else if (i < 9) this.modules[8][15 - i - 1 + 1] = mod;
        else this.modules[8][15 - i - 1] = mod;
    }
    // fixed module
    this.modules[this.moduleCount - 8][8] = !test;
};
proto.mapData = function(data, maskPattern) {
    var inc = -1;
    var row = this.moduleCount - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = this.moduleCount - 1; col > 0; col -= 2){
        if (col == 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (this.modules[row][col - c] == null) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                var mask = util.getMask(maskPattern, row, col - c);
                if (mask) dark = !dark;
                this.modules[row][col - c] = dark;
                bitIndex--;
                if (bitIndex == -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || this.moduleCount <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
};
QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;
QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new BitBuffer();
    for(var i = 0; i < dataList.length; i++){
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    // calc num max data.
    var totalDataCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
    if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
    // end code
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
    // padding
    while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
    // padding
    while(true){
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put(QRCode.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put(QRCode.PAD1, 8);
    }
    return QRCode.createBytes(buffer, rsBlocks);
};
QRCode.createBytes = function(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for(var r = 0; r < rsBlocks.length; r++){
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for(var i = 0; i < dcdata[r].length; i++)dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        offset += dcCount;
        var rsPoly = util.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for(var i = 0; i < ecdata[r].length; i++){
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalCodeCount += rsBlocks[i].totalCount;
    var data = new Array(totalCodeCount);
    var index = 0;
    for(var i = 0; i < maxDcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < dcdata[r].length) data[index++] = dcdata[r][i];
    }
    for(var i = 0; i < maxEcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < ecdata[r].length) data[index++] = ecdata[r][i];
    }
    return data;
};
module.exports = QRCode;

},{"994ab1655494fbd0":"bux4k","919c509a6f269fad":"kTY35","bd1ef7d1ea355bd6":"9bWmI","6a5261ac3b21ef40":"a0o9W","e88e1dcb8e0375b7":"j3Qv0"}],"bux4k":[function(require,module,exports,__globalThis) {
var mode = require("13f3aa4728a9cc3a");
function QR8bitByte(data) {
    this.mode = mode.MODE_8BIT_BYTE;
    this.data = data;
}
QR8bitByte.prototype = {
    getLength: function(buffer) {
        return this.data.length;
    },
    write: function(buffer) {
        for(var i = 0; i < this.data.length; i++)// not JIS ...
        buffer.put(this.data.charCodeAt(i), 8);
    }
};
module.exports = QR8bitByte;

},{"13f3aa4728a9cc3a":"yCct3"}],"yCct3":[function(require,module,exports,__globalThis) {
module.exports = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};

},{}],"kTY35":[function(require,module,exports,__globalThis) {
// ErrorCorrectLevel
var ECL = require("8d37152652b4ffff");
function QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
QRRSBlock.RS_BLOCK_TABLE = [
    // L
    // M
    // Q
    // H
    // 1
    [
        1,
        26,
        19
    ],
    [
        1,
        26,
        16
    ],
    [
        1,
        26,
        13
    ],
    [
        1,
        26,
        9
    ],
    // 2
    [
        1,
        44,
        34
    ],
    [
        1,
        44,
        28
    ],
    [
        1,
        44,
        22
    ],
    [
        1,
        44,
        16
    ],
    // 3
    [
        1,
        70,
        55
    ],
    [
        1,
        70,
        44
    ],
    [
        2,
        35,
        17
    ],
    [
        2,
        35,
        13
    ],
    // 4		
    [
        1,
        100,
        80
    ],
    [
        2,
        50,
        32
    ],
    [
        2,
        50,
        24
    ],
    [
        4,
        25,
        9
    ],
    // 5
    [
        1,
        134,
        108
    ],
    [
        2,
        67,
        43
    ],
    [
        2,
        33,
        15,
        2,
        34,
        16
    ],
    [
        2,
        33,
        11,
        2,
        34,
        12
    ],
    // 6
    [
        2,
        86,
        68
    ],
    [
        4,
        43,
        27
    ],
    [
        4,
        43,
        19
    ],
    [
        4,
        43,
        15
    ],
    // 7		
    [
        2,
        98,
        78
    ],
    [
        4,
        49,
        31
    ],
    [
        2,
        32,
        14,
        4,
        33,
        15
    ],
    [
        4,
        39,
        13,
        1,
        40,
        14
    ],
    // 8
    [
        2,
        121,
        97
    ],
    [
        2,
        60,
        38,
        2,
        61,
        39
    ],
    [
        4,
        40,
        18,
        2,
        41,
        19
    ],
    [
        4,
        40,
        14,
        2,
        41,
        15
    ],
    // 9
    [
        2,
        146,
        116
    ],
    [
        3,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        36,
        16,
        4,
        37,
        17
    ],
    [
        4,
        36,
        12,
        4,
        37,
        13
    ],
    // 10		
    [
        2,
        86,
        68,
        2,
        87,
        69
    ],
    [
        4,
        69,
        43,
        1,
        70,
        44
    ],
    [
        6,
        43,
        19,
        2,
        44,
        20
    ],
    [
        6,
        43,
        15,
        2,
        44,
        16
    ],
    // 11
    [
        4,
        101,
        81
    ],
    [
        1,
        80,
        50,
        4,
        81,
        51
    ],
    [
        4,
        50,
        22,
        4,
        51,
        23
    ],
    [
        3,
        36,
        12,
        8,
        37,
        13
    ],
    // 12
    [
        2,
        116,
        92,
        2,
        117,
        93
    ],
    [
        6,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        46,
        20,
        6,
        47,
        21
    ],
    [
        7,
        42,
        14,
        4,
        43,
        15
    ],
    // 13
    [
        4,
        133,
        107
    ],
    [
        8,
        59,
        37,
        1,
        60,
        38
    ],
    [
        8,
        44,
        20,
        4,
        45,
        21
    ],
    [
        12,
        33,
        11,
        4,
        34,
        12
    ],
    // 14
    [
        3,
        145,
        115,
        1,
        146,
        116
    ],
    [
        4,
        64,
        40,
        5,
        65,
        41
    ],
    [
        11,
        36,
        16,
        5,
        37,
        17
    ],
    [
        11,
        36,
        12,
        5,
        37,
        13
    ],
    // 15
    [
        5,
        109,
        87,
        1,
        110,
        88
    ],
    [
        5,
        65,
        41,
        5,
        66,
        42
    ],
    [
        5,
        54,
        24,
        7,
        55,
        25
    ],
    [
        11,
        36,
        12
    ],
    // 16
    [
        5,
        122,
        98,
        1,
        123,
        99
    ],
    [
        7,
        73,
        45,
        3,
        74,
        46
    ],
    [
        15,
        43,
        19,
        2,
        44,
        20
    ],
    [
        3,
        45,
        15,
        13,
        46,
        16
    ],
    // 17
    [
        1,
        135,
        107,
        5,
        136,
        108
    ],
    [
        10,
        74,
        46,
        1,
        75,
        47
    ],
    [
        1,
        50,
        22,
        15,
        51,
        23
    ],
    [
        2,
        42,
        14,
        17,
        43,
        15
    ],
    // 18
    [
        5,
        150,
        120,
        1,
        151,
        121
    ],
    [
        9,
        69,
        43,
        4,
        70,
        44
    ],
    [
        17,
        50,
        22,
        1,
        51,
        23
    ],
    [
        2,
        42,
        14,
        19,
        43,
        15
    ],
    // 19
    [
        3,
        141,
        113,
        4,
        142,
        114
    ],
    [
        3,
        70,
        44,
        11,
        71,
        45
    ],
    [
        17,
        47,
        21,
        4,
        48,
        22
    ],
    [
        9,
        39,
        13,
        16,
        40,
        14
    ],
    // 20
    [
        3,
        135,
        107,
        5,
        136,
        108
    ],
    [
        3,
        67,
        41,
        13,
        68,
        42
    ],
    [
        15,
        54,
        24,
        5,
        55,
        25
    ],
    [
        15,
        43,
        15,
        10,
        44,
        16
    ],
    // 21
    [
        4,
        144,
        116,
        4,
        145,
        117
    ],
    [
        17,
        68,
        42
    ],
    [
        17,
        50,
        22,
        6,
        51,
        23
    ],
    [
        19,
        46,
        16,
        6,
        47,
        17
    ],
    // 22
    [
        2,
        139,
        111,
        7,
        140,
        112
    ],
    [
        17,
        74,
        46
    ],
    [
        7,
        54,
        24,
        16,
        55,
        25
    ],
    [
        34,
        37,
        13
    ],
    // 23
    [
        4,
        151,
        121,
        5,
        152,
        122
    ],
    [
        4,
        75,
        47,
        14,
        76,
        48
    ],
    [
        11,
        54,
        24,
        14,
        55,
        25
    ],
    [
        16,
        45,
        15,
        14,
        46,
        16
    ],
    // 24
    [
        6,
        147,
        117,
        4,
        148,
        118
    ],
    [
        6,
        73,
        45,
        14,
        74,
        46
    ],
    [
        11,
        54,
        24,
        16,
        55,
        25
    ],
    [
        30,
        46,
        16,
        2,
        47,
        17
    ],
    // 25
    [
        8,
        132,
        106,
        4,
        133,
        107
    ],
    [
        8,
        75,
        47,
        13,
        76,
        48
    ],
    [
        7,
        54,
        24,
        22,
        55,
        25
    ],
    [
        22,
        45,
        15,
        13,
        46,
        16
    ],
    // 26
    [
        10,
        142,
        114,
        2,
        143,
        115
    ],
    [
        19,
        74,
        46,
        4,
        75,
        47
    ],
    [
        28,
        50,
        22,
        6,
        51,
        23
    ],
    [
        33,
        46,
        16,
        4,
        47,
        17
    ],
    // 27
    [
        8,
        152,
        122,
        4,
        153,
        123
    ],
    [
        22,
        73,
        45,
        3,
        74,
        46
    ],
    [
        8,
        53,
        23,
        26,
        54,
        24
    ],
    [
        12,
        45,
        15,
        28,
        46,
        16
    ],
    // 28
    [
        3,
        147,
        117,
        10,
        148,
        118
    ],
    [
        3,
        73,
        45,
        23,
        74,
        46
    ],
    [
        4,
        54,
        24,
        31,
        55,
        25
    ],
    [
        11,
        45,
        15,
        31,
        46,
        16
    ],
    // 29
    [
        7,
        146,
        116,
        7,
        147,
        117
    ],
    [
        21,
        73,
        45,
        7,
        74,
        46
    ],
    [
        1,
        53,
        23,
        37,
        54,
        24
    ],
    [
        19,
        45,
        15,
        26,
        46,
        16
    ],
    // 30
    [
        5,
        145,
        115,
        10,
        146,
        116
    ],
    [
        19,
        75,
        47,
        10,
        76,
        48
    ],
    [
        15,
        54,
        24,
        25,
        55,
        25
    ],
    [
        23,
        45,
        15,
        25,
        46,
        16
    ],
    // 31
    [
        13,
        145,
        115,
        3,
        146,
        116
    ],
    [
        2,
        74,
        46,
        29,
        75,
        47
    ],
    [
        42,
        54,
        24,
        1,
        55,
        25
    ],
    [
        23,
        45,
        15,
        28,
        46,
        16
    ],
    // 32
    [
        17,
        145,
        115
    ],
    [
        10,
        74,
        46,
        23,
        75,
        47
    ],
    [
        10,
        54,
        24,
        35,
        55,
        25
    ],
    [
        19,
        45,
        15,
        35,
        46,
        16
    ],
    // 33
    [
        17,
        145,
        115,
        1,
        146,
        116
    ],
    [
        14,
        74,
        46,
        21,
        75,
        47
    ],
    [
        29,
        54,
        24,
        19,
        55,
        25
    ],
    [
        11,
        45,
        15,
        46,
        46,
        16
    ],
    // 34
    [
        13,
        145,
        115,
        6,
        146,
        116
    ],
    [
        14,
        74,
        46,
        23,
        75,
        47
    ],
    [
        44,
        54,
        24,
        7,
        55,
        25
    ],
    [
        59,
        46,
        16,
        1,
        47,
        17
    ],
    // 35
    [
        12,
        151,
        121,
        7,
        152,
        122
    ],
    [
        12,
        75,
        47,
        26,
        76,
        48
    ],
    [
        39,
        54,
        24,
        14,
        55,
        25
    ],
    [
        22,
        45,
        15,
        41,
        46,
        16
    ],
    // 36
    [
        6,
        151,
        121,
        14,
        152,
        122
    ],
    [
        6,
        75,
        47,
        34,
        76,
        48
    ],
    [
        46,
        54,
        24,
        10,
        55,
        25
    ],
    [
        2,
        45,
        15,
        64,
        46,
        16
    ],
    // 37
    [
        17,
        152,
        122,
        4,
        153,
        123
    ],
    [
        29,
        74,
        46,
        14,
        75,
        47
    ],
    [
        49,
        54,
        24,
        10,
        55,
        25
    ],
    [
        24,
        45,
        15,
        46,
        46,
        16
    ],
    // 38
    [
        4,
        152,
        122,
        18,
        153,
        123
    ],
    [
        13,
        74,
        46,
        32,
        75,
        47
    ],
    [
        48,
        54,
        24,
        14,
        55,
        25
    ],
    [
        42,
        45,
        15,
        32,
        46,
        16
    ],
    // 39
    [
        20,
        147,
        117,
        4,
        148,
        118
    ],
    [
        40,
        75,
        47,
        7,
        76,
        48
    ],
    [
        43,
        54,
        24,
        22,
        55,
        25
    ],
    [
        10,
        45,
        15,
        67,
        46,
        16
    ],
    // 40
    [
        19,
        148,
        118,
        6,
        149,
        119
    ],
    [
        18,
        75,
        47,
        31,
        76,
        48
    ],
    [
        34,
        54,
        24,
        34,
        55,
        25
    ],
    [
        20,
        45,
        15,
        61,
        46,
        16
    ]
];
QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
    var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    var length = rsBlock.length / 3;
    var list = new Array();
    for(var i = 0; i < length; i++){
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for(var j = 0; j < count; j++)list.push(new QRRSBlock(totalCount, dataCount));
    }
    return list;
};
QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
    switch(errorCorrectLevel){
        case ECL.L:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case ECL.M:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case ECL.Q:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case ECL.H:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
module.exports = QRRSBlock;

},{"8d37152652b4ffff":"lWMoU"}],"9bWmI":[function(require,module,exports,__globalThis) {
function QRBitBuffer() {
    this.buffer = new Array();
    this.length = 0;
}
QRBitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = QRBitBuffer;

},{}],"a0o9W":[function(require,module,exports,__globalThis) {
var Mode = require("7df1bf33d69adbf8");
var Polynomial = require("c3a1f001bec95f5c");
var math = require("7ba226ae2bcd3d6f");
var QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(data) {
        var d = data << 10;
        while(QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0)d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
        return (data << 10 | d) ^ QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function(data) {
        var d = data << 12;
        while(QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0)d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
        return data << 12 | d;
    },
    getBCHDigit: function(data) {
        var digit = 0;
        while(data != 0){
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function(typeNumber) {
        return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function(maskPattern, i, j) {
        switch(maskPattern){
            case QRMaskPattern.PATTERN000:
                return (i + j) % 2 == 0;
            case QRMaskPattern.PATTERN001:
                return i % 2 == 0;
            case QRMaskPattern.PATTERN010:
                return j % 3 == 0;
            case QRMaskPattern.PATTERN011:
                return (i + j) % 3 == 0;
            case QRMaskPattern.PATTERN100:
                return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case QRMaskPattern.PATTERN101:
                return i * j % 2 + i * j % 3 == 0;
            case QRMaskPattern.PATTERN110:
                return (i * j % 2 + i * j % 3) % 2 == 0;
            case QRMaskPattern.PATTERN111:
                return (i * j % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function(errorCorrectLength) {
        var a = new Polynomial([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i++)a = a.multiply(new Polynomial([
            1,
            math.gexp(i)
        ], 0));
        return a;
    },
    getLengthInBits: function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case Mode.MODE_NUMBER:
                return 10;
            case Mode.MODE_ALPHA_NUM:
                return 9;
            case Mode.MODE_8BIT_BYTE:
                return 8;
            case Mode.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case Mode.MODE_NUMBER:
                return 12;
            case Mode.MODE_ALPHA_NUM:
                return 11;
            case Mode.MODE_8BIT_BYTE:
                return 16;
            case Mode.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case Mode.MODE_NUMBER:
                return 14;
            case Mode.MODE_ALPHA_NUM:
                return 13;
            case Mode.MODE_8BIT_BYTE:
                return 16;
            case Mode.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    },
    getLostPoint: function(qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        // LEVEL1
        for(var row = 0; row < moduleCount; row++)for(var col = 0; col < moduleCount; col++){
            var sameCount = 0;
            var dark = qrCode.isDark(row, col);
            for(var r = -1; r <= 1; r++){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c++){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrCode.isDark(row + r, col + c)) sameCount++;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(var row = 0; row < moduleCount - 1; row++)for(var col = 0; col < moduleCount - 1; col++){
            var count = 0;
            if (qrCode.isDark(row, col)) count++;
            if (qrCode.isDark(row + 1, col)) count++;
            if (qrCode.isDark(row, col + 1)) count++;
            if (qrCode.isDark(row + 1, col + 1)) count++;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(var row = 0; row < moduleCount; row++){
            for(var col = 0; col < moduleCount - 6; col++)if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount - 6; row++)if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount; row++)if (qrCode.isDark(row, col)) darkCount++;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
module.exports = QRUtil;

},{"7df1bf33d69adbf8":"yCct3","c3a1f001bec95f5c":"j3Qv0","7ba226ae2bcd3d6f":"5NtY6"}],"j3Qv0":[function(require,module,exports,__globalThis) {
var math = require("4906f8662983df03");
function QRPolynomial(num, shift) {
    if (num.length == undefined) throw new Error(num.length + "/" + shift);
    var offset = 0;
    while(offset < num.length && num[offset] == 0)offset++;
    this.num = new Array(num.length - offset + shift);
    for(var i = 0; i < num.length - offset; i++)this.num[i] = num[i + offset];
}
QRPolynomial.prototype = {
    get: function(index) {
        return this.num[index];
    },
    getLength: function() {
        return this.num.length;
    },
    multiply: function(e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for(var i = 0; i < this.getLength(); i++)for(var j = 0; j < e.getLength(); j++)num[i + j] ^= math.gexp(math.glog(this.get(i)) + math.glog(e.get(j)));
        return new QRPolynomial(num, 0);
    },
    mod: function(e) {
        if (this.getLength() - e.getLength() < 0) return this;
        var ratio = math.glog(this.get(0)) - math.glog(e.get(0));
        var num = new Array(this.getLength());
        for(var i = 0; i < this.getLength(); i++)num[i] = this.get(i);
        for(var i = 0; i < e.getLength(); i++)num[i] ^= math.gexp(math.glog(e.get(i)) + ratio);
        // recursive call
        return new QRPolynomial(num, 0).mod(e);
    }
};
module.exports = QRPolynomial;

},{"4906f8662983df03":"5NtY6"}],"5NtY6":[function(require,module,exports,__globalThis) {
var QRMath = {
    glog: function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return QRMath.LOG_TABLE[n];
    },
    gexp: function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for(var i = 0; i < 8; i++)QRMath.EXP_TABLE[i] = 1 << i;
for(var i = 8; i < 256; i++)QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
for(var i = 0; i < 255; i++)QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
module.exports = QRMath;

},{}],"dwmEb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _propTypes = require("cdbf0b0644b0aeb5");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _react = require("2b5c78ce90120497");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var propTypes = {
    bgColor: _propTypes2.default.oneOfType([
        _propTypes2.default.object,
        _propTypes2.default.string
    ]).isRequired,
    bgD: _propTypes2.default.string.isRequired,
    fgColor: _propTypes2.default.oneOfType([
        _propTypes2.default.object,
        _propTypes2.default.string
    ]).isRequired,
    fgD: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.number.isRequired,
    title: _propTypes2.default.string,
    viewBoxSize: _propTypes2.default.number.isRequired,
    xmlns: _propTypes2.default.string
};
var QRCodeSvg = (0, _react.forwardRef)(function(_ref, ref) {
    var bgColor = _ref.bgColor, bgD = _ref.bgD, fgD = _ref.fgD, fgColor = _ref.fgColor, size = _ref.size, title = _ref.title, viewBoxSize = _ref.viewBoxSize, _ref$xmlns = _ref.xmlns, xmlns = _ref$xmlns === undefined ? "http://www.w3.org/2000/svg" : _ref$xmlns, props = _objectWithoutProperties(_ref, [
        "bgColor",
        "bgD",
        "fgD",
        "fgColor",
        "size",
        "title",
        "viewBoxSize",
        "xmlns"
    ]);
    return _react2.default.createElement("svg", _extends({}, props, {
        height: size,
        ref: ref,
        viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize,
        width: size,
        xmlns: xmlns
    }), title ? _react2.default.createElement("title", null, title) : null, _react2.default.createElement("path", {
        d: bgD,
        fill: bgColor
    }), _react2.default.createElement("path", {
        d: fgD,
        fill: fgColor
    }));
});
QRCodeSvg.displayName = "QRCodeSvg";
QRCodeSvg.propTypes = propTypes;
exports.default = QRCodeSvg;

},{"cdbf0b0644b0aeb5":"bnNSm","2b5c78ce90120497":"9njXz"}],"cCAiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "APITokenForm", ()=>APITokenForm);
parcelHelpers.export(exports, "APITokensTable", ()=>APITokensTable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _utils = require("../../utils");
var _missingContent = require("../common/MissingContent");
var _types = require("common/api/v1/types");
var _reactAsyncHook = require("react-async-hook");
var _store = require("../../store");
var _failedFetchingContent = require("../common/FailedFetchingContent");
var _reactRedux = require("react-redux");
var _notificationActions = require("../../redux/actions/notificationActions");
var _alert = require("@mui/material/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _alertTitle = require("@mui/material/AlertTitle");
var _alertTitleDefault = parcelHelpers.interopDefault(_alertTitle);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _form = require("../common/Form");
var _table = require("../common/Table");
var _reactHookForm = require("react-hook-form");
var _contentCopy = require("@mui/icons-material/ContentCopy");
var _contentCopyDefault = parcelHelpers.interopDefault(_contentCopy);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
const handleCopy = (value)=>void navigator.clipboard.writeText(value);
const convertScopesArrayToRecord = (scopes)=>Object.fromEntries(scopes.map((scope)=>[
            scope,
            false
        ]));
const convertScopesRecordToArray = (scopes)=>{
    return Object.entries(scopes).filter(([, value])=>!!value).map(([key])=>key);
};
const ScopesDefaultValuesObj = convertScopesArrayToRecord((0, _types.ACCESS_SCOPE_NAMES_LIST));
const fieldErrorToString = (error)=>{
    if (!error) return '';
    if (error.type === 'required') return 'This field is required';
    return error.message;
};
const APITokenConfigForm = (props)=>{
    const { control } = (0, _reactHookForm.useFormContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Form), {
        id: "access-token-form",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
            direction: 'column',
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                    name: "name",
                    label: "Token name",
                    required: true,
                    autoFocus: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                    name: 'expiresAt',
                    control: control,
                    rules: {
                        required: true
                    },
                    render: ({ field, fieldState: { error } })=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.DatePicker), {
                            name: "Expiry Date",
                            format: "dd/MM/yyyy",
                            label: "Expiry Date",
                            minDate: new Date(),
                            value: field.value,
                            onChange: (date)=>{
                                field.onChange(date?.toISOString());
                            },
                            slotProps: {
                                textField: {
                                    error: !!error,
                                    helperText: fieldErrorToString(error)
                                }
                            }
                        });
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                    marginTop: 2,
                    width: '100%',
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "h5",
                            children: "Scopes"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "body1",
                            color: "textSecondary",
                            children: "Pick at least one scope that this token will have access to"
                        }),
                        (0, _types.ACCESS_SCOPE_NAMES_LIST).map((scope)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                name: `scopes.${scope}`,
                                label: (0, _types.ACCESS_SCOPE_FRIENDLY_NAMES)[scope],
                                tooltip: (0, _types.ACCESS_SCOPE_DESCRIPTIONS)[scope]
                            }, scope))
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                    direction: "row",
                    spacing: 2,
                    marginTop: 2,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "outlined",
                            onClick: props.onCancel,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            color: "primary",
                            type: "submit",
                            variant: "contained",
                            sx: {
                                marginTop: 1
                            },
                            children: "Save"
                        })
                    ]
                })
            ]
        })
    });
};
const APITokenForm = (props)=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const user = (0, _utils.useUser)();
    const onSubmit = (values)=>{
        const apiToken = {
            ...values,
            role: user.role,
            scopes: convertScopesRecordToArray(values.scopes)
        };
        (0, _store.Api).apiTokensApi.createApiToken(apiToken).then((response)=>{
            dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Created API token ${apiToken.name}`));
            props.onSuccess(response.token);
        }).catch((error)=>{
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error,
                operation: 'create API token'
            }));
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
        onSubmit: onSubmit,
        defaultValues: {
            name: '',
            expiresAt: undefined,
            scopes: ScopesDefaultValuesObj
        },
        enableReinitialize: true,
        component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(APITokenConfigForm, {
                onCancel: props.onCancel
            })
    });
};
const APITokensTable = ()=>{
    const showConfirm = (0, _utils.useConfirmationDialog)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const [createTokenMode, setCreateTokenMode] = (0, _react.useState)(false);
    const [showToken, setShowToken] = (0, _react.useState)('');
    // state to force refresh of the table
    const [refreshId, setRefreshId] = (0, _react.useState)(0);
    const refresh = ()=>setRefreshId((id)=>id + 1);
    const removeApiToken = (token)=>{
        showConfirm(()=>{
            (0, _store.Api).apiTokensApi.removeApiToken(token.id).then(()=>{
                dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Removed Token'));
                refresh();
            }).catch((error)=>{
                dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                    error,
                    operation: 'delete API token'
                }));
            });
        }, `Are you sure you want to delete api token '${token.name}'?`, token.name);
    };
    const { result, loading, error } = (0, _reactAsyncHook.useAsync)(async ()=>(0, _store.Api).apiTokensApi.getApiTokens(), [
        refreshId
    ]);
    const apiTokens = result?.items || [];
    const tableConfig = [
        {
            title: 'Token name',
            getValue: ({ name })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        paddingLeft: '16px'
                    },
                    children: name
                })
        },
        {
            title: 'Scopes',
            getValue: ({ scopes })=>(scopes ?? []).join(', ')
        },
        {
            title: 'Last used',
            getValue: ({ lastUsedAt })=>lastUsedAt ? (0, _dateFns.format)(new Date(lastUsedAt), (0, _helpers.DATE_FORMAT_SHORT)) : 'Never'
        },
        {
            title: 'Expires',
            getValue: ({ expiresAt })=>expiresAt ? (0, _dateFns.format)(new Date(expiresAt), (0, _helpers.DATE_FORMAT_SHORT)) : 'Never'
        },
        {
            title: 'Actions',
            getValue: (token)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                    onClick: ()=>removeApiToken(token),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
                })
        }
    ];
    if (error) {
        const message = error.message ? `: ${error.message}` : '';
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _failedFetchingContent.FailedFetchingContent), {
            message: `Failed to fetch tokens${message}`
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "API Tokens",
        actionsPane: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                disabled: createTokenMode || !!showToken,
                variant: "contained",
                color: "primary",
                onClick: ()=>setCreateTokenMode(true),
                children: "Add new token"
            })
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            alignItems: "flex-start",
            marginTop: 2,
            width: '100%',
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                    emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                        message: "No access tokens available"
                    }),
                    config: tableConfig,
                    data: apiTokens,
                    id: "networks-table",
                    pending: loading,
                    isSmall: true
                }),
                createTokenMode && /*#__PURE__*/ (0, _jsxRuntime.jsx)(APITokenForm, {
                    onCancel: ()=>setCreateTokenMode(false),
                    onSuccess: (createdToken)=>{
                        setCreateTokenMode(false);
                        setShowToken(createdToken);
                        refresh();
                    }
                }),
                showToken && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alertDefault.default), {
                    color: "success",
                    severity: "success",
                    onClose: ()=>setShowToken(''),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertTitleDefault.default), {
                            color: "primary",
                            children: "Token created"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            variant: "body1",
                            children: [
                                "Token: ",
                                showToken
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "contained",
                            color: "primary",
                            startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentCopyDefault.default), {}),
                            onClick: ()=>handleCopy(showToken),
                            children: "Copy"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            variant: "body1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Important:"
                                }),
                                " Save this token now, it will not be shown again!"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","date-fns":"gelMX","common/api/v1/helpers":"6jovr","../../utils":"342UB","../common/MissingContent":"1LBl6","common/api/v1/types":"3qemx","react-async-hook":"3D6Y9","../../store":"5LXiG","../common/FailedFetchingContent":"dJi9P","react-redux":"l1pMU","../../redux/actions/notificationActions":"7LkQg","@mui/material/Alert":"8qQ0S","@mui/material/AlertTitle":"1HDvR","@mui/material/Grid":"6iX4B","@mui/material/Stack":"6thYv","@mui/material/Typography":"6NtGx","@mui/material/Button":"3qJY9","../common/Form":"4Mui7","../common/Table":"dt9lf","react-hook-form":"8z0aI","@mui/icons-material/ContentCopy":"ivEEo","@mui/icons-material/Delete":"69aC7","@mui/material/IconButton":"488As","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dJi9P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FailedFetchingContent", ()=>FailedFetchingContent);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _form = require("./Form");
const styles = {
    centered: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%'
    },
    message: {
        textTransform: 'uppercase'
    },
    buttonWrapper: {
        margin: (theme)=>theme.spacing(2)
    }
};
const FailedFetchingContent = ({ message, inline })=>{
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.centered,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: styles.message,
                variant: "h2",
                children: message
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: styles.buttonWrapper,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "outlined",
                    onClick: ()=>window.location.reload(),
                    children: "Reload"
                })
            })
        ]
    });
    return inline ? content : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        children: content
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Typography":"6NtGx","./Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8qQ0S":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c9e9fc7de390128e").default;
var _interopRequireDefault = require("74cc3a365d48cabf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    alertClasses: true
};
Object.defineProperty(exports, "alertClasses", {
    enumerable: true,
    get: function() {
        return _alertClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Alert.default;
    }
});
var _Alert = _interopRequireDefault(require("972caa19d984ded"));
var _alertClasses = _interopRequireWildcard(require("fa7cc6244ea230d2"));
Object.keys(_alertClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _alertClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _alertClasses[key];
        }
    });
});

},{"c9e9fc7de390128e":"fiRIh","74cc3a365d48cabf":"kZ6eK","972caa19d984ded":"3MFkp","fa7cc6244ea230d2":"5ONsL"}],"3MFkp":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("6af8e488764706cd").default;
var _interopRequireWildcard = require("fe2cca952eee98d2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("6da33a1c9c674d19"));
var _propTypes = _interopRequireDefault(require("b0bf00631184eb48"));
var _clsx = _interopRequireDefault(require("68a33182c094932c"));
var _composeClasses = _interopRequireDefault(require("963c9f83cb3c1b22"));
var _colorManipulator = require("73a76d28a3ce14c6");
var _zeroStyled = require("a55fab06bb644160");
var _memoTheme = _interopRequireDefault(require("fe3aa7e867abc8fc"));
var _DefaultPropsProvider = require("aa9bcf47ac8534a0");
var _useSlot = _interopRequireDefault(require("9960c1eb2fd6e21b"));
var _capitalize = _interopRequireDefault(require("14bcf5349037903c"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("f13c9a0629919b2a"));
var _Paper = _interopRequireDefault(require("bb8668d390d9f084"));
var _alertClasses = _interopRequireWildcard(require("8a13119520dd52a4"));
var _IconButton = _interopRequireDefault(require("5ac7657e0229131f"));
var _SuccessOutlined = _interopRequireDefault(require("442af25158b7cd37"));
var _ReportProblemOutlined = _interopRequireDefault(require("67669643d36fa2a8"));
var _ErrorOutline = _interopRequireDefault(require("77cd0d3eb0a364e3"));
var _InfoOutlined = _interopRequireDefault(require("2f33d5bd4856329f"));
var _Close = _interopRequireDefault(require("43f2557d77aaa190"));
var _jsxRuntime = require("6053944ca1d8518");
const useUtilityClasses = (ownerState)=>{
    const { variant, color, severity, classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalize.default)(color || severity)}`,
            `${variant}${(0, _capitalize.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, _composeClasses.default)(slots, _alertClasses.getAlertUtilityClass, classes);
};
const AlertRoot = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, _capitalize.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const getColor = theme.palette.mode === 'light' ? _colorManipulator.darken : _colorManipulator.lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? _colorManipulator.lighten : _colorManipulator.darken;
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${_alertClasses.default.icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${_alertClasses.default.icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const AlertIcon = (0, _zeroStyled.styled)('div', {
    name: 'MuiAlert',
    slot: 'Icon'
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const AlertMessage = (0, _zeroStyled.styled)('div', {
    name: 'MuiAlert',
    slot: 'Message'
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const AlertAction = (0, _zeroStyled.styled)('div', {
    name: 'MuiAlert',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const defaultIconMapping = {
    success: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SuccessOutlined.default, {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ReportProblemOutlined.default, {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorOutline.default, {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InfoOutlined.default, {
        fontSize: "inherit"
    })
};
const Alert = /*#__PURE__*/ React.forwardRef(function Alert(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action, children, className, closeText = 'Close', color, components = {}, componentsProps = {}, icon, iconMapping = defaultIconMapping, onClose, role = 'alert', severity = 'success', slotProps = {}, slots = {}, variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color,
        severity,
        variant,
        colorSeverity: color || severity
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        ref,
        shouldForwardComponentProp: true,
        className: (0, _clsx.default)(classes.root, className),
        elementType: AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState,
        additionalProps: {
            role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, _useSlot.default)('icon', {
        className: classes.icon,
        elementType: AlertIcon,
        externalForwardedProps,
        ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, _useSlot.default)('message', {
        className: classes.message,
        elementType: AlertMessage,
        externalForwardedProps,
        ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, _useSlot.default)('action', {
        className: classes.action,
        elementType: AlertAction,
        externalForwardedProps,
        ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, _useSlot.default)('closeButton', {
        elementType: _IconButton.default,
        externalForwardedProps,
        ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, _useSlot.default)('closeIcon', {
        elementType: _Close.default,
        externalForwardedProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var _default = exports.default = Alert;

},{"6af8e488764706cd":"kZ6eK","fe2cca952eee98d2":"fiRIh","6da33a1c9c674d19":"9njXz","b0bf00631184eb48":"bnNSm","68a33182c094932c":"d2NWs","963c9f83cb3c1b22":"59Equ","73a76d28a3ce14c6":"hTYBL","a55fab06bb644160":"hZXDo","fe3aa7e867abc8fc":"cJNjb","aa9bcf47ac8534a0":"9bD8g","9960c1eb2fd6e21b":"h76AU","14bcf5349037903c":"eOYSA","f13c9a0629919b2a":"2r5WG","bb8668d390d9f084":"aexCI","8a13119520dd52a4":"5ONsL","5ac7657e0229131f":"488As","442af25158b7cd37":"3H2ob","67669643d36fa2a8":"1kvJu","77cd0d3eb0a364e3":"iVVKj","2f33d5bd4856329f":"4ZBdB","43f2557d77aaa190":"alYeF","6053944ca1d8518":"1dlk8"}],"5ONsL":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("26ec1f1adb28dece").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getAlertUtilityClass = getAlertUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("ab882a49ae5ee7bf"));
var _generateUtilityClass = _interopRequireDefault(require("507b43403a312ed1"));
function getAlertUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiAlert', slot);
}
const alertClasses = (0, _generateUtilityClasses.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var _default = exports.default = alertClasses;

},{"26ec1f1adb28dece":"kZ6eK","ab882a49ae5ee7bf":"7pSUk","507b43403a312ed1":"jBs9M"}],"3H2ob":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("21e8b38c0cfaedc1").default;
var _interopRequireWildcard = require("9fe8a660a4a5ec06").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("612445980c0ad070"));
var _createSvgIcon = _interopRequireDefault(require("9b9de6af90b0374f"));
var _jsxRuntime = require("f9b7665de529793c");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

},{"21e8b38c0cfaedc1":"kZ6eK","9fe8a660a4a5ec06":"fiRIh","612445980c0ad070":"9njXz","9b9de6af90b0374f":"5sni0","f9b7665de529793c":"1dlk8"}],"1kvJu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("483de34f5b8e84ee").default;
var _interopRequireWildcard = require("616e68cb23f04b1c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("2ecdebd8587a5485"));
var _createSvgIcon = _interopRequireDefault(require("a4c6fefb468910e3"));
var _jsxRuntime = require("b231304f96d6bdd8");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

},{"483de34f5b8e84ee":"kZ6eK","616e68cb23f04b1c":"fiRIh","2ecdebd8587a5485":"9njXz","a4c6fefb468910e3":"5sni0","b231304f96d6bdd8":"1dlk8"}],"iVVKj":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("451e9728a5484a50").default;
var _interopRequireWildcard = require("ec809583089cee8d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("a8318962c3ee1cb3"));
var _createSvgIcon = _interopRequireDefault(require("131bc5363fa9a7c5"));
var _jsxRuntime = require("9ad74af3f870e952");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

},{"451e9728a5484a50":"kZ6eK","ec809583089cee8d":"fiRIh","a8318962c3ee1cb3":"9njXz","131bc5363fa9a7c5":"5sni0","9ad74af3f870e952":"1dlk8"}],"4ZBdB":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ad1af0da12d4a775").default;
var _interopRequireWildcard = require("84c074ebcd6eb32e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d4be98af4ce24ed4"));
var _createSvgIcon = _interopRequireDefault(require("cc2af8128f4b28dc"));
var _jsxRuntime = require("38e5a203c008630c");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

},{"ad1af0da12d4a775":"kZ6eK","84c074ebcd6eb32e":"fiRIh","d4be98af4ce24ed4":"9njXz","cc2af8128f4b28dc":"5sni0","38e5a203c008630c":"1dlk8"}],"1HDvR":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("874f5576769a26a5").default;
var _interopRequireDefault = require("23272b520487487a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    alertTitleClasses: true
};
Object.defineProperty(exports, "alertTitleClasses", {
    enumerable: true,
    get: function() {
        return _alertTitleClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _AlertTitle.default;
    }
});
var _AlertTitle = _interopRequireDefault(require("1bbd00d6e8307cac"));
var _alertTitleClasses = _interopRequireWildcard(require("b9b24d84cc779905"));
Object.keys(_alertTitleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _alertTitleClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _alertTitleClasses[key];
        }
    });
});

},{"874f5576769a26a5":"fiRIh","23272b520487487a":"kZ6eK","1bbd00d6e8307cac":"43Dvi","b9b24d84cc779905":"l94Oc"}],"43Dvi":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("1bf5706fe2b538c7").default;
var _interopRequireWildcard = require("92a56b63746785ab").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d51e09564f2c1607"));
var _propTypes = _interopRequireDefault(require("ac5069cdad853eac"));
var _clsx = _interopRequireDefault(require("c467a5e6136b114e"));
var _composeClasses = _interopRequireDefault(require("5742431f30ecdf0d"));
var _zeroStyled = require("171b25c167b01c32");
var _memoTheme = _interopRequireDefault(require("301b80a5daf15380"));
var _DefaultPropsProvider = require("8c1910ef096b0b2d");
var _Typography = _interopRequireDefault(require("65c32ce526fbb5c9"));
var _alertTitleClasses = require("be5007a55a9626b6");
var _jsxRuntime = require("946894f334c106cb");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _alertTitleClasses.getAlertTitleUtilityClass, classes);
};
const AlertTitleRoot = (0, _zeroStyled.styled)(_Typography.default, {
    name: 'MuiAlertTitle',
    slot: 'Root'
})((0, _memoTheme.default)(({ theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
}));
const AlertTitle = /*#__PURE__*/ React.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAlertTitle'
    });
    const { className, ...other } = props;
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertTitleRoot, {
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ...other
    });
});
var _default = exports.default = AlertTitle;

},{"1bf5706fe2b538c7":"kZ6eK","92a56b63746785ab":"fiRIh","d51e09564f2c1607":"9njXz","ac5069cdad853eac":"bnNSm","c467a5e6136b114e":"d2NWs","5742431f30ecdf0d":"59Equ","171b25c167b01c32":"hZXDo","301b80a5daf15380":"cJNjb","8c1910ef096b0b2d":"9bD8g","65c32ce526fbb5c9":"6NtGx","be5007a55a9626b6":"l94Oc","946894f334c106cb":"1dlk8"}],"l94Oc":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("21f84369f17040a0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getAlertTitleUtilityClass = getAlertTitleUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("5b945bcaf7f96cc"));
var _generateUtilityClass = _interopRequireDefault(require("680fb7432feb030f"));
function getAlertTitleUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiAlertTitle', slot);
}
const alertTitleClasses = (0, _generateUtilityClasses.default)('MuiAlertTitle', [
    'root'
]);
var _default = exports.default = alertTitleClasses;

},{"21f84369f17040a0":"kZ6eK","5b945bcaf7f96cc":"7pSUk","680fb7432feb030f":"jBs9M"}],"h0485":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StreamManagerContainer", ()=>StreamManagerContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _container = require("@mui/material/Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _notFound = require("../common/NotFound");
var _topBar = require("../streamManager/TopBar");
var _index = require("../streamManager/List/index");
var _index1 = require("../profile/index");
var _errorBoundary = require("../common/ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
const padding = {
    marginBottom: 2,
    paddingX: 3
};
const StreamManagerContainer = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            height: '100vh',
            width: '100vw',
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topBar.Header), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _containerDefault.default), {
                    component: "main",
                    maxWidth: false,
                    disableGutters: true,
                    sx: {
                        flexGrow: 1,
                        overflowX: 'auto'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                index: true,
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.List), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                path: "profile",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    sx: padding,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Profile), {
                                        isStreamManager: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                path: "*",
                                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    sx: padding,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","@mui/material/Box":"c4QkF","@mui/material/Container":"376wa","../common/NotFound":"1Msr5","../streamManager/TopBar":"96mEP","../streamManager/List/index":"btHiU","../profile/index":"dfRs7","../common/ErrorBoundary":"44DTp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96mEP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _appBar = require("@mui/material/AppBar");
var _appBarDefault = parcelHelpers.interopDefault(_appBar);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _powerSettingsNew = require("@mui/icons-material/PowerSettingsNew");
var _powerSettingsNewDefault = parcelHelpers.interopDefault(_powerSettingsNew);
var _person = require("@mui/icons-material/Person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _topLeftNav = require("../partials/TopLeftNav");
var _link = require("../common/Link");
var _userActions = require("../../redux/actions/userActions");
var _utils = require("../../utils");
var _store = require("../../store");
const styles = {
    logoutButton: {
        marginLeft: 3
    }
};
const Header = ()=>{
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const logoutUserAction = ()=>void dispatch((0, _userActions.logoutAndNavigateToMainPage)());
    const stopImpersonationAction = ()=>void dispatch((0, _userActions.stopImpersonation)({
            showSuccessSnackbar: true
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appBarDefault.default), {
        position: "sticky",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
            disableGutters: true,
            sx: {
                paddingRight: 2
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topLeftNav.TopLeftNav), {
                    title: "Stream Manager",
                    logoLink: routes.stream()
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        marginLeft: 'auto',
                        display: 'flex',
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: routes.streamProfile.route,
                            underline: "hover",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "body2",
                                "data-test-id": "current-user",
                                children: user.username
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "body2",
                            children: user.impersonatedBy && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                style: {
                                    opacity: 0.5,
                                    marginLeft: 4
                                },
                                children: [
                                    "(by ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        "data-test-id": "current-impersonator",
                                        children: user.impersonatedBy.username
                                    }),
                                    ")"
                                ]
                            })
                        }),
                        user.impersonatedBy ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            endIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personDefault.default), {}),
                            onClick: stopImpersonationAction,
                            sx: styles.logoutButton,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "body2",
                                color: "textSecondary",
                                id: "stop-impersonation",
                                children: "SWITCH TO ADMIN"
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            endIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _powerSettingsNewDefault.default), {}),
                            onClick: logoutUserAction,
                            sx: styles.logoutButton,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "body2",
                                color: "textSecondary",
                                children: "LOG OUT"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","@mui/material/AppBar":"6sika","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Toolbar":"5Kohb","@mui/material/Typography":"6NtGx","@mui/icons-material/PowerSettingsNew":"fkySZ","@mui/icons-material/Person":"6tc0D","../partials/TopLeftNav":"eWUlU","../common/Link":"l3o6V","../../redux/actions/userActions":"2tWgd","../../utils":"342UB","../../store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btHiU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "List", ()=>List);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _inputs = require("./Inputs");
var _inputsDefault = parcelHelpers.interopDefault(_inputs);
var _outputs = require("./Outputs");
var _outputsDefault = parcelHelpers.interopDefault(_outputs);
var _pageTitle = require("../../common/PageTitle");
const styles = {
    container: {
        height: '100%',
        display: 'flex'
    },
    inputs: (theme)=>({
            width: '70%',
            height: '100%',
            overflow: 'hidden',
            [theme.breakpoints.down('sm')]: {
                width: '50%'
            }
        }),
    outputs: (theme)=>({
            width: '30%',
            height: '100%',
            overflow: 'hidden',
            [theme.breakpoints.down('sm')]: {
                width: '50%'
            }
        })
};
const List = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageTitle.PageTitle), {
                title: "Stream Manager"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: styles.container,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: styles.inputs,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputsDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: styles.outputs,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outputsDefault.default), {})
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","./Inputs":"lPdbD","./Outputs":"bJDdY","../../common/PageTitle":"5VKx3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lPdbD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDnd = require("react-dnd");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _thumbnail = require("../../common/Thumbnail");
var _thumbnailDefault = parcelHelpers.interopDefault(_thumbnail);
var _searchInput = require("../../common/SearchInput");
var _searchInputDefault = parcelHelpers.interopDefault(_searchInput);
var _indicator = require("../../common/Indicator");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _utils = require("../../../utils");
var _helpers = require("common/api/v1/helpers");
var _pagination = require("../../common/Table/Pagination");
var _hooks = require("../../../utils/hooks");
var _hooksDefault = parcelHelpers.interopDefault(_hooks);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
const LOCALE_STORAGE_PER_PAGE_KEY = 'edge:sm:inputsPerPage';
const headerFooterHeight = 58;
const styles = {
    container: {
        height: '100%',
        overflow: 'hidden'
    },
    toolbar: (theme)=>({
            maxHeight: headerFooterHeight,
            justifyContent: 'space-between',
            [theme.breakpoints.down('xs')]: {
                flexWrap: 'wrap',
                padding: theme.spacing(1, 3)
            }
        }),
    inputList: {
        marginTop: 0,
        marginBottom: 0,
        padding: (theme)=>theme.spacing(0, 3, 3),
        height: `calc(100% - ${headerFooterHeight * 2}px)`,
        overflowY: 'auto',
        alignContent: 'flex-start'
    },
    pagination: {
        height: headerFooterHeight
    },
    item: {
        flexGrow: 1
    },
    card: {
        background: (theme)=>theme.palette.common.white,
        cursor: 'grab',
        '&.dragging': {
            opacity: 0.7,
            cursor: 'grabbing'
        }
    },
    health: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: (theme)=>theme.spacing(2, 2, 0, 2),
        top: 0,
        left: 0,
        right: 0,
        paddingBottom: (theme)=>theme.spacing(2),
        color: (theme)=>theme.palette.common.white,
        background: (theme)=>(0, _styles.alpha)(theme.palette.common.black, 0.5),
        fontSize: (theme)=>theme.typography.subtitle2.fontSize
    },
    sub: {
        color: (theme)=>theme.palette.text.secondary,
        fontSize: (theme)=>theme.typography.subtitle2.fontSize,
        padding: (theme)=>theme.spacing(0, 2, 2)
    }
};
const InputCard = ({ input })=>{
    const [{ isDragging }, drag] = (0, _reactDnd.useDrag)(()=>({
            type: 'input',
            item: input,
            options: {
                dropEffect: 'copy'
            },
            collect: (monitor)=>({
                    isDragging: monitor.isDragging(),
                    handlerId: monitor.getHandlerId()
                })
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        sx: styles.item,
        size: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 3,
            xl: 2
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: drag,
            style: {
                position: 'relative'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                sx: styles.card,
                className: (0, _classnamesDefault.default)(isDragging && 'dragging'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnailDefault.default), {
                                input: input
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                sx: styles.health,
                                style: {
                                    position: 'absolute',
                                    pointerEvents: 'none'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AutoUpdatingInputHealthIndicator), {
                                        initialInput: input
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: (0, _helpers.getFormattedTransportStreamContent)((input?.tsInfo || [])[0])
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            component: "div",
                            "data-test-id": "input-title",
                            ...(0, _utils.inputOutputColor)(input),
                            children: input.name
                        }),
                        titleTypographyProps: {
                            variant: 'subtitle1'
                        },
                        subheader: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            color: input.adminStatus ? 'primary' : 'secondary',
                            variant: "caption",
                            children: input.canSubscribe ? 'Full Access' : 'Preview'
                        })
                    }),
                    !!input._owner && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: styles.sub,
                        children: [
                            "Source: ",
                            input._owner.name
                        ]
                    })
                ]
            })
        })
    });
};
const Inputs = ()=>{
    const [filter, setFilter] = (0, _react.useState)('');
    const debouncedFilter = (0, _utils.useDebouncedFilter)(filter);
    const [pageNumber, setPageNumber] = (0, _react.useState)('0');
    const [rowsPerPage, setRowsPerPage] = (0, _react.useState)(localStorage.getItem(LOCALE_STORAGE_PER_PAGE_KEY) || '10');
    const { width } = (0, _hooksDefault.default)();
    const hidePerPagePaginationOption = width < 600;
    const { inputs, total, loading } = (0, _utils.useInputsSelector)({
        pageNumber,
        rowsPerPage,
        filter: debouncedFilter || undefined
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
        id: "inputs",
        pending: loading,
        cover: true,
        coverContainerProps: styles.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
                sx: styles.toolbar,
                id: "inputs-toolbar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h2",
                        children: "Inputs"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchInputDefault.default), {
                        stretchable: true,
                        onChange: (input)=>{
                            setPageNumber('0');
                            setFilter(input);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                container: true,
                spacing: 3,
                sx: styles.inputList,
                id: "inputs-list",
                children: inputs.map((input)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(InputCard, {
                        input: input
                    }, input.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: styles.pagination,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.Pagination), {
                        total: total,
                        page: pageNumber,
                        perPage: rowsPerPage,
                        changePageCallback: setPageNumber,
                        changeRowsPerPageCallback: (rows)=>{
                            setPageNumber('0');
                            localStorage.setItem(LOCALE_STORAGE_PER_PAGE_KEY, rows);
                            setRowsPerPage(rows);
                        },
                        id: 'input-pagination',
                        hidePerPageOption: hidePerPagePaginationOption,
                        hideJumpToPage: hidePerPagePaginationOption
                    })
                ]
            })
        ]
    });
};
exports.default = Inputs;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dnd":"aAvQg","classnames":"5Een2","@mui/material/Box":"c4QkF","@mui/material/Card":"4f45q","@mui/material/CardHeader":"dFaD2","@mui/material/Grid":"6iX4B","@mui/material/Toolbar":"5Kohb","@mui/material/Typography":"6NtGx","@mui/material/styles":"2UrBk","../../common/Thumbnail":"5Q8KF","../../common/SearchInput":"liEuw","../../common/Indicator":"hqaQa","../../common/Pendable":"gDN67","../../../utils":"342UB","common/api/v1/helpers":"6jovr","../../common/Table/Pagination":"HM37R","../../../utils/hooks":"5aY3q","@mui/material/Divider":"9Ul8c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAvQg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./core/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _indexJs1 = require("./hooks/index.js");
parcelHelpers.exportAll(_indexJs1, exports);
var _indexJs2 = require("./types/index.js");
parcelHelpers.exportAll(_indexJs2, exports);

},{"./core/index.js":"eIyV4","./hooks/index.js":"17bx5","./types/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eIyV4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dndContextJs = require("./DndContext.js");
parcelHelpers.exportAll(_dndContextJs, exports);
var _dndProviderJs = require("./DndProvider.js");
parcelHelpers.exportAll(_dndProviderJs, exports);
var _dragPreviewImageJs = require("./DragPreviewImage.js");
parcelHelpers.exportAll(_dragPreviewImageJs, exports);

},{"./DndContext.js":"aqtAC","./DndProvider.js":"g511d","./DragPreviewImage.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aqtAC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DndContext", ()=>DndContext);
var _react = require("react");
const DndContext = (0, _react.createContext)({
    dragDropManager: undefined
});

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g511d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A React component that provides the React-DnD context
 */ parcelHelpers.export(exports, "DndProvider", ()=>DndProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _dndCore = require("dnd-core");
var _react = require("react");
var _dndContextJs = require("./DndContext.js");
var global = arguments[3];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let refCount = 0;
const INSTANCE_SYM = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
var DndProvider = /*#__PURE__*/ (0, _react.memo)(function DndProvider(_param) {
    var { children } = _param, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, _react.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = getGlobalContext();
            ++refCount;
            return ()=>{
                if (--refCount === 0) context[INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dndContextJs.DndContext).Provider, {
        value: manager,
        children: children
    });
});
function getDndContextValue(props) {
    if ('manager' in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function createSingletonDndContext(backend, context = getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[INSTANCE_SYM]) ctx[INSTANCE_SYM] = {
        dragDropManager: (0, _dndCore.createDragDropManager)(backend, context, options, debugMode)
    };
    return ctx[INSTANCE_SYM];
}
function getGlobalContext() {
    return typeof global !== 'undefined' ? global : window;
}

},{"react/jsx-runtime":"1dlk8","dnd-core":"hAQQ1","react":"9njXz","./DndContext.js":"aqtAC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAQQ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createDragDropManagerJs = require("./createDragDropManager.js");
parcelHelpers.exportAll(_createDragDropManagerJs, exports);
var _interfacesJs = require("./interfaces.js");
parcelHelpers.exportAll(_interfacesJs, exports);

},{"./createDragDropManager.js":"1cV3r","./interfaces.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cV3r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDragDropManager", ()=>createDragDropManager);
var _redux = require("redux");
var _dragDropManagerImplJs = require("./classes/DragDropManagerImpl.js");
var _dragDropMonitorImplJs = require("./classes/DragDropMonitorImpl.js");
var _handlerRegistryImplJs = require("./classes/HandlerRegistryImpl.js");
var _indexJs = require("./reducers/index.js");
function createDragDropManager(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = makeStoreInstance(debugMode);
    const monitor = new (0, _dragDropMonitorImplJs.DragDropMonitorImpl)(store, new (0, _handlerRegistryImplJs.HandlerRegistryImpl)(store));
    const manager = new (0, _dragDropManagerImplJs.DragDropManagerImpl)(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, _redux.createStore)((0, _indexJs.reduce), debugMode && reduxDevTools && reduxDevTools({
        name: 'dnd-core',
        instanceId: 'dnd-core'
    }));
}

},{"redux":"ikKU1","./classes/DragDropManagerImpl.js":"9ApSe","./classes/DragDropMonitorImpl.js":"3DXTv","./classes/HandlerRegistryImpl.js":"6vDbA","./reducers/index.js":"5hbdr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ikKU1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if (isDate(val)) return 'date';
    if (isError(val)) return 'error';
    var constructorName = ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === 'undefined') throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59BsR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"5zOJa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5zOJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"61Sn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61Sn9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"la19k","./toPrimitive.js":"cVPci","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"la19k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVPci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"la19k","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ApSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropManagerImpl", ()=>DragDropManagerImpl);
var _indexJs = require("../actions/dragDrop/index.js");
class DragDropManagerImpl {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== 'undefined') dispatch(action);
            };
        }
        const actions = (0, _indexJs.createDragDropActions)(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}

},{"../actions/dragDrop/index.js":"ee6Ir","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ee6Ir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDragDropActions", ()=>createDragDropActions);
var _beginDragJs = require("./beginDrag.js");
var _dropJs = require("./drop.js");
var _endDragJs = require("./endDrag.js");
var _hoverJs = require("./hover.js");
var _publishDragSourceJs = require("./publishDragSource.js");
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
function createDragDropActions(manager) {
    return {
        beginDrag: (0, _beginDragJs.createBeginDrag)(manager),
        publishDragSource: (0, _publishDragSourceJs.createPublishDragSource)(manager),
        hover: (0, _hoverJs.createHover)(manager),
        drop: (0, _dropJs.createDrop)(manager),
        endDrag: (0, _endDragJs.createEndDrag)(manager)
    };
}

},{"./beginDrag.js":"4isGB","./drop.js":"5UuFx","./endDrag.js":"e9wlg","./hover.js":"jqgyZ","./publishDragSource.js":"2zPUj","./types.js":"8fHJ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4isGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBeginDrag", ()=>createBeginDrag);
var _invariant = require("@react-dnd/invariant");
var _jsUtilsJs = require("../../utils/js_utils.js");
var _setClientOffsetJs = require("./local/setClientOffset.js");
var _typesJs = require("./types.js");
const ResetCoordinatesAction = {
    type: (0, _typesJs.INIT_COORDS),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function createBeginDrag(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource = true, clientOffset, getSourceClientOffset } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch((0, _setClientOffsetJs.setClientOffset)(clientOffset));
        verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch(ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error('getSourceClientOffset must be defined');
            verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch((0, _setClientOffsetJs.setClientOffset)(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: (0, _typesJs.BEGIN_DRAG),
            payload: {
                itemType,
                item,
                sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function verifyInvariants(sourceIds, monitor, registry) {
    (0, _invariant.invariant)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    sourceIds.forEach(function(sourceId) {
        (0, _invariant.invariant)(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
    });
}
function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, _invariant.invariant)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}
function verifyItemIsObject(item) {
    (0, _invariant.invariant)((0, _jsUtilsJs.isObject)(item), 'Item must be an object.');
}
function getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}

},{"@react-dnd/invariant":"39q74","../../utils/js_utils.js":"bq2id","./local/setClientOffset.js":"dzXq2","./types.js":"8fHJ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"39q74":[function(require,module,exports,__globalThis) {
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
var process = require("5a3903f93be82c8e");
function invariant(condition, format, ...args) {
    if (isProduction()) {
        if (format === undefined) throw new Error('invariant requires an error message argument');
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function isProduction() {
    return typeof process !== 'undefined' && true;
}

},{"5a3903f93be82c8e":"5jT8D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bq2id":[function(require,module,exports,__globalThis) {
// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", ()=>get);
/**
 * drop-in replacement for _.without
 */ parcelHelpers.export(exports, "without", ()=>without);
/**
 * drop-in replacement for _.isString
 * @param input
 */ parcelHelpers.export(exports, "isString", ()=>isString);
/**
 * drop-in replacement for _.isString
 * @param input
 */ parcelHelpers.export(exports, "isObject", ()=>isObject);
/**
 * replacement for _.xor
 * @param itemsA
 * @param itemsB
 */ parcelHelpers.export(exports, "xor", ()=>xor);
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */ parcelHelpers.export(exports, "intersection", ()=>intersection);
function get(obj, path, defaultValue) {
    return path.split('.').reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
function without(items, item) {
    return items.filter((i)=>i !== item);
}
function isString(input) {
    return typeof input === 'string';
}
function isObject(input) {
    return typeof input === 'object';
}
function xor(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
function intersection(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzXq2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setClientOffset", ()=>setClientOffset);
var _typesJs = require("../types.js");
function setClientOffset(clientOffset, sourceClientOffset) {
    return {
        type: (0, _typesJs.INIT_COORDS),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}

},{"../types.js":"8fHJ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8fHJ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INIT_COORDS", ()=>INIT_COORDS);
parcelHelpers.export(exports, "BEGIN_DRAG", ()=>BEGIN_DRAG);
parcelHelpers.export(exports, "PUBLISH_DRAG_SOURCE", ()=>PUBLISH_DRAG_SOURCE);
parcelHelpers.export(exports, "HOVER", ()=>HOVER);
parcelHelpers.export(exports, "DROP", ()=>DROP);
parcelHelpers.export(exports, "END_DRAG", ()=>END_DRAG);
const INIT_COORDS = 'dnd-core/INIT_COORDS';
const BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
const PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
const HOVER = 'dnd-core/HOVER';
const DROP = 'dnd-core/DROP';
const END_DRAG = 'dnd-core/END_DRAG';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5UuFx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDrop", ()=>createDrop);
var _invariant = require("@react-dnd/invariant");
var _jsUtilsJs = require("../../utils/js_utils.js");
var _typesJs = require("./types.js");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function createDrop(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        verifyInvariants(monitor);
        const targetIds = getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: (0, _typesJs.DROP),
                payload: {
                    dropResult: _objectSpread({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function verifyInvariants(monitor) {
    (0, _invariant.invariant)(monitor.isDragging(), 'Cannot call drop while not dragging.');
    (0, _invariant.invariant)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}
function determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    verifyDropResultType(dropResult);
    if (typeof dropResult === 'undefined') dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function verifyDropResultType(dropResult) {
    (0, _invariant.invariant)(typeof dropResult === 'undefined' || (0, _jsUtilsJs.isObject)(dropResult), 'Drop result must either be an object or undefined.');
}
function getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}

},{"@react-dnd/invariant":"39q74","../../utils/js_utils.js":"bq2id","./types.js":"8fHJ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e9wlg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEndDrag", ()=>createEndDrag);
var _invariant = require("@react-dnd/invariant");
var _typesJs = require("./types.js");
function createEndDrag(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: (0, _typesJs.END_DRAG)
        };
    };
}
function verifyIsDragging(monitor) {
    (0, _invariant.invariant)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}

},{"@react-dnd/invariant":"39q74","./types.js":"8fHJ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jqgyZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHover", ()=>createHover);
var _invariant = require("@react-dnd/invariant");
var _matchesTypeJs = require("../../utils/matchesType.js");
var _typesJs = require("./types.js");
function createHover(manager) {
    return function hover(targetIdsArg, { clientOffset } = {}) {
        verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        checkInvariants(targetIds, monitor, registry);
        hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, _typesJs.HOVER),
            payload: {
                targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function verifyTargetIdsIsArray(targetIdsArg) {
    (0, _invariant.invariant)(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}
function checkInvariants(targetIds, monitor, registry) {
    (0, _invariant.invariant)(monitor.isDragging(), 'Cannot call hover while not dragging.');
    (0, _invariant.invariant)(!monitor.didDrop(), 'Cannot call hover after drop.');
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        (0, _invariant.invariant)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        const target = registry.getTarget(targetId);
        (0, _invariant.invariant)(target, 'Expected targetIds to be registered.');
    }
}
function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!(0, _matchesTypeJs.matchesType)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}

},{"@react-dnd/invariant":"39q74","../../utils/matchesType.js":"jVL3I","./types.js":"8fHJ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jVL3I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matchesType", ()=>matchesType);
function matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2zPUj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPublishDragSource", ()=>createPublishDragSource);
var _typesJs = require("./types.js");
function createPublishDragSource(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, _typesJs.PUBLISH_DRAG_SOURCE)
        };
        return;
    };
}

},{"./types.js":"8fHJ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3DXTv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropMonitorImpl", ()=>DragDropMonitorImpl);
var _invariant = require("@react-dnd/invariant");
var _coordsJs = require("../utils/coords.js");
var _dirtinessJs = require("../utils/dirtiness.js");
var _matchesTypeJs = require("../utils/matchesType.js");
class DragDropMonitorImpl {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds } = options;
        (0, _invariant.invariant)(typeof listener === 'function', 'listener must be a function.');
        (0, _invariant.invariant)(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtinessJs.areDirty)(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        (0, _invariant.invariant)(typeof listener === 'function', 'listener must be a function.');
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        (0, _invariant.invariant)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        (0, _invariant.invariant)(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return (0, _matchesTypeJs.matchesType)(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        (0, _invariant.invariant)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !(0, _matchesTypeJs.matchesType)(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return (0, _coordsJs.getSourceClientOffset)(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return (0, _coordsJs.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}

},{"@react-dnd/invariant":"39q74","../utils/coords.js":"1DpAG","../utils/dirtiness.js":"eTjRQ","../utils/matchesType.js":"jVL3I","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1DpAG":[function(require,module,exports,__globalThis) {
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>add);
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */ parcelHelpers.export(exports, "subtract", ()=>subtract);
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */ parcelHelpers.export(exports, "getSourceClientOffset", ()=>getSourceClientOffset);
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */ parcelHelpers.export(exports, "getDifferenceFromInitialOffset", ()=>getDifferenceFromInitialOffset);
function add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function getSourceClientOffset(state) {
    const { clientOffset, initialClientOffset, initialSourceClientOffset } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function getDifferenceFromInitialOffset(state) {
    const { clientOffset, initialClientOffset } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return subtract(clientOffset, initialClientOffset);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eTjRQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NONE", ()=>NONE);
parcelHelpers.export(exports, "ALL", ()=>ALL);
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */ parcelHelpers.export(exports, "areDirty", ()=>areDirty);
var _jsUtilsJs = require("./js_utils.js");
const NONE = [];
const ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
function areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === NONE) return false;
    if (dirtyIds === ALL || typeof handlerIds === 'undefined') return true;
    const commonIds = (0, _jsUtilsJs.intersection)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}

},{"./js_utils.js":"bq2id","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6vDbA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HandlerRegistryImpl", ()=>HandlerRegistryImpl);
var _asap = require("@react-dnd/asap");
var _invariant = require("@react-dnd/invariant");
var _registryJs = require("../actions/registry.js");
var _contractsJs = require("../contracts.js");
var _interfacesJs = require("../interfaces.js");
var _getNextUniqueIdJs = require("../utils/getNextUniqueId.js");
function getNextHandlerId(role) {
    const id = (0, _getNextUniqueIdJs.getNextUniqueId)().toString();
    switch(role){
        case (0, _interfacesJs.HandlerRole).SOURCE:
            return `S${id}`;
        case (0, _interfacesJs.HandlerRole).TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return (0, _interfacesJs.HandlerRole).SOURCE;
        case 'T':
            return (0, _interfacesJs.HandlerRole).TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done, value: [, value] } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class HandlerRegistryImpl {
    addSource(type, source) {
        (0, _contractsJs.validateType)(type);
        (0, _contractsJs.validateSourceContract)(source);
        const sourceId = this.addHandler((0, _interfacesJs.HandlerRole).SOURCE, type, source);
        this.store.dispatch((0, _registryJs.addSource)(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        (0, _contractsJs.validateType)(type, true);
        (0, _contractsJs.validateTargetContract)(target);
        const targetId = this.addHandler((0, _interfacesJs.HandlerRole).TARGET, type, target);
        this.store.dispatch((0, _registryJs.addTarget)(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        (0, _invariant.invariant)(this.isSourceId(sourceId), 'Expected a valid source ID.');
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        (0, _invariant.invariant)(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        (0, _invariant.invariant)(this.isSourceId(sourceId), 'Expected a valid source ID.');
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        (0, _invariant.invariant)(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = parseRoleFromHandlerId(handlerId);
        return role === (0, _interfacesJs.HandlerRole).SOURCE;
    }
    isTargetId(handlerId) {
        const role = parseRoleFromHandlerId(handlerId);
        return role === (0, _interfacesJs.HandlerRole).TARGET;
    }
    removeSource(sourceId) {
        (0, _invariant.invariant)(this.getSource(sourceId), 'Expected an existing source.');
        this.store.dispatch((0, _registryJs.removeSource)(sourceId));
        (0, _asap.asap)(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        (0, _invariant.invariant)(this.getTarget(targetId), 'Expected an existing target.');
        this.store.dispatch((0, _registryJs.removeTarget)(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        (0, _invariant.invariant)(source, 'Expected an existing source.');
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        (0, _invariant.invariant)(this.pinnedSource, 'No source is pinned at the time.');
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = getNextHandlerId(role);
        this.types.set(id, type);
        if (role === (0, _interfacesJs.HandlerRole).SOURCE) this.dragSources.set(id, handler);
        else if (role === (0, _interfacesJs.HandlerRole).TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}

},{"@react-dnd/asap":"dGxml","@react-dnd/invariant":"39q74","../actions/registry.js":"4d9aX","../contracts.js":"b0q1d","../interfaces.js":"lQqnZ","../utils/getNextUniqueId.js":"6YQHX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGxml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asapJs = require("./asap.js");
parcelHelpers.exportAll(_asapJs, exports);
var _asapQueueJs = require("./AsapQueue.js");
parcelHelpers.exportAll(_asapQueueJs, exports);
var _taskFactoryJs = require("./TaskFactory.js");
parcelHelpers.exportAll(_taskFactoryJs, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);

},{"./asap.js":"jrxSs","./AsapQueue.js":"l19b2","./TaskFactory.js":"8Kosd","./types.js":"3p2Ra","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jrxSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */ parcelHelpers.export(exports, "asap", ()=>asap);
var _asapQueueJs = require("./AsapQueue.js");
var _taskFactoryJs = require("./TaskFactory.js");
const asapQueue = new (0, _asapQueueJs.AsapQueue)();
const taskFactory = new (0, _taskFactoryJs.TaskFactory)(asapQueue.registerPendingError);
function asap(task) {
    asapQueue.enqueueTask(taskFactory.create(task));
}

},{"./AsapQueue.js":"l19b2","./TaskFactory.js":"8Kosd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l19b2":[function(require,module,exports,__globalThis) {
/* eslint-disable no-restricted-globals, @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-non-null-assertion */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapQueue", ()=>AsapQueue) // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
;
var _makeRequestCallJs = require("./makeRequestCall.js");
class AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = (0, _makeRequestCallJs.makeRequestCall)(this.flush);
        this.requestErrorThrow = (0, _makeRequestCallJs.makeRequestCallFromTimer)(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
}

},{"./makeRequestCall.js":"jNqzB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jNqzB":[function(require,module,exports,__globalThis) {
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeRequestCallFromTimer", ()=>makeRequestCallFromTimer);
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
parcelHelpers.export(exports, "makeRequestCallFromMutationObserver", ()=>makeRequestCallFromMutationObserver);
parcelHelpers.export(exports, "makeRequestCall", ()=>makeRequestCall);
var global = arguments[3];
const scope = typeof global !== 'undefined' ? global : self;
const BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new BrowserMutationObserver(callback);
    const node = document.createTextNode('');
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const makeRequestCall = typeof BrowserMutationObserver === 'function' ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
makeRequestCallFromMutationObserver : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
makeRequestCallFromTimer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Kosd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TaskFactory", ()=>TaskFactory);
var _rawTaskJs = require("./RawTask.js");
class TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new (0, _rawTaskJs.RawTask)(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}

},{"./RawTask.js":"1kZWT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1kZWT":[function(require,module,exports,__globalThis) {
// `call`, just like a function.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RawTask", ()=>RawTask);
class RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3p2Ra":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4d9aX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADD_SOURCE", ()=>ADD_SOURCE);
parcelHelpers.export(exports, "ADD_TARGET", ()=>ADD_TARGET);
parcelHelpers.export(exports, "REMOVE_SOURCE", ()=>REMOVE_SOURCE);
parcelHelpers.export(exports, "REMOVE_TARGET", ()=>REMOVE_TARGET);
parcelHelpers.export(exports, "addSource", ()=>addSource);
parcelHelpers.export(exports, "addTarget", ()=>addTarget);
parcelHelpers.export(exports, "removeSource", ()=>removeSource);
parcelHelpers.export(exports, "removeTarget", ()=>removeTarget);
const ADD_SOURCE = 'dnd-core/ADD_SOURCE';
const ADD_TARGET = 'dnd-core/ADD_TARGET';
const REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
const REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function addSource(sourceId) {
    return {
        type: ADD_SOURCE,
        payload: {
            sourceId
        }
    };
}
function addTarget(targetId) {
    return {
        type: ADD_TARGET,
        payload: {
            targetId
        }
    };
}
function removeSource(sourceId) {
    return {
        type: REMOVE_SOURCE,
        payload: {
            sourceId
        }
    };
}
function removeTarget(targetId) {
    return {
        type: REMOVE_TARGET,
        payload: {
            targetId
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b0q1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateSourceContract", ()=>validateSourceContract);
parcelHelpers.export(exports, "validateTargetContract", ()=>validateTargetContract);
parcelHelpers.export(exports, "validateType", ()=>validateType);
var _invariant = require("@react-dnd/invariant");
function validateSourceContract(source) {
    (0, _invariant.invariant)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    (0, _invariant.invariant)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    (0, _invariant.invariant)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
    (0, _invariant.invariant)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    (0, _invariant.invariant)(typeof target.hover === 'function', 'Expected hover to be a function.');
    (0, _invariant.invariant)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>validateType(t, false));
        return;
    }
    (0, _invariant.invariant)(typeof type === 'string' || typeof type === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

},{"@react-dnd/invariant":"39q74","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lQqnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HandlerRole", ()=>HandlerRole);
var HandlerRole;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6YQHX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNextUniqueId", ()=>getNextUniqueId);
let nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5hbdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _jsUtilsJs = require("../utils/js_utils.js");
var _dirtyHandlerIdsJs = require("./dirtyHandlerIds.js");
var _dragOffsetJs = require("./dragOffset.js");
var _dragOperationJs = require("./dragOperation.js");
var _refCountJs = require("./refCount.js");
var _stateIdJs = require("./stateId.js");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function reduce(state = {}, action) {
    return {
        dirtyHandlerIds: (0, _dirtyHandlerIdsJs.reduce)(state.dirtyHandlerIds, {
            type: action.type,
            payload: _objectSpread({}, action.payload, {
                prevTargetIds: (0, _jsUtilsJs.get)(state, 'dragOperation.targetIds', [])
            })
        }),
        dragOffset: (0, _dragOffsetJs.reduce)(state.dragOffset, action),
        refCount: (0, _refCountJs.reduce)(state.refCount, action),
        dragOperation: (0, _dragOperationJs.reduce)(state.dragOperation, action),
        stateId: (0, _stateIdJs.reduce)(state.stateId)
    };
}

},{"../utils/js_utils.js":"bq2id","./dirtyHandlerIds.js":"38URa","./dragOffset.js":"kdN4k","./dragOperation.js":"3oKpw","./refCount.js":"a7PCE","./stateId.js":"68TMs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38URa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _indexJs = require("../actions/dragDrop/index.js");
var _registryJs = require("../actions/registry.js");
var _dirtinessJs = require("../utils/dirtiness.js");
var _equalityJs = require("../utils/equality.js");
var _jsUtilsJs = require("../utils/js_utils.js");
function reduce(_state = (0, _dirtinessJs.NONE), action) {
    switch(action.type){
        case 0, _indexJs.HOVER:
            break;
        case 0, _registryJs.ADD_SOURCE:
        case 0, _registryJs.ADD_TARGET:
        case 0, _registryJs.REMOVE_TARGET:
        case 0, _registryJs.REMOVE_SOURCE:
            return 0, _dirtinessJs.NONE;
        case 0, _indexJs.BEGIN_DRAG:
        case 0, _indexJs.PUBLISH_DRAG_SOURCE:
        case 0, _indexJs.END_DRAG:
        case 0, _indexJs.DROP:
        default:
            return 0, _dirtinessJs.ALL;
    }
    const { targetIds = [], prevTargetIds = [] } = action.payload;
    const result = (0, _jsUtilsJs.xor)(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !(0, _equalityJs.areArraysEqual)(targetIds, prevTargetIds);
    if (!didChange) return 0, _dirtinessJs.NONE;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}

},{"../actions/dragDrop/index.js":"ee6Ir","../actions/registry.js":"4d9aX","../utils/dirtiness.js":"eTjRQ","../utils/equality.js":"2i5EP","../utils/js_utils.js":"bq2id","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2i5EP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "strictEquality", ()=>strictEquality);
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */ parcelHelpers.export(exports, "areCoordsEqual", ()=>areCoordsEqual);
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */ parcelHelpers.export(exports, "areArraysEqual", ()=>areArraysEqual);
const strictEquality = (a, b)=>a === b;
function areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function areArraysEqual(a, b, isEqual = strictEquality) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kdN4k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _indexJs = require("../actions/dragDrop/index.js");
var _equalityJs = require("../utils/equality.js");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function reduce(state = initialState, action) {
    const { payload } = action;
    switch(action.type){
        case 0, _indexJs.INIT_COORDS:
        case 0, _indexJs.BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, _indexJs.HOVER:
            if ((0, _equalityJs.areCoordsEqual)(state.clientOffset, payload.clientOffset)) return state;
            return _objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case 0, _indexJs.END_DRAG:
        case 0, _indexJs.DROP:
            return initialState;
        default:
            return state;
    }
}

},{"../actions/dragDrop/index.js":"ee6Ir","../utils/equality.js":"2i5EP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3oKpw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _indexJs = require("../actions/dragDrop/index.js");
var _registryJs = require("../actions/registry.js");
var _jsUtilsJs = require("../utils/js_utils.js");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function reduce(state = initialState, action) {
    const { payload } = action;
    switch(action.type){
        case 0, _indexJs.BEGIN_DRAG:
            return _objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, _indexJs.PUBLISH_DRAG_SOURCE:
            return _objectSpread({}, state, {
                isSourcePublic: true
            });
        case 0, _indexJs.HOVER:
            return _objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case 0, _registryJs.REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return _objectSpread({}, state, {
                targetIds: (0, _jsUtilsJs.without)(state.targetIds, payload.targetId)
            });
        case 0, _indexJs.DROP:
            return _objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, _indexJs.END_DRAG:
            return _objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}

},{"../actions/dragDrop/index.js":"ee6Ir","../actions/registry.js":"4d9aX","../utils/js_utils.js":"bq2id","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a7PCE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _registryJs = require("../actions/registry.js");
function reduce(state = 0, action) {
    switch(action.type){
        case 0, _registryJs.ADD_SOURCE:
        case 0, _registryJs.ADD_TARGET:
            return state + 1;
        case 0, _registryJs.REMOVE_SOURCE:
        case 0, _registryJs.REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}

},{"../actions/registry.js":"4d9aX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"68TMs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
function reduce(state = 0) {
    return state + 1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"17bx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _indexJs = require("./useDrag/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _useDragDropManagerJs = require("./useDragDropManager.js");
parcelHelpers.exportAll(_useDragDropManagerJs, exports);
var _useDragLayerJs = require("./useDragLayer.js");
parcelHelpers.exportAll(_useDragLayerJs, exports);
var _indexJs1 = require("./useDrop/index.js");
parcelHelpers.exportAll(_indexJs1, exports);

},{"./types.js":false,"./useDrag/index.js":"7nkYb","./useDragDropManager.js":false,"./useDragLayer.js":false,"./useDrop/index.js":"c55tz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7nkYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useDragJs = require("./useDrag.js");
parcelHelpers.exportAll(_useDragJs, exports);

},{"./useDrag.js":"6dauQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6dauQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ parcelHelpers.export(exports, "useDrag", ()=>useDrag);
var _invariant = require("@react-dnd/invariant");
var _useCollectedPropsJs = require("../useCollectedProps.js");
var _useOptionalFactoryJs = require("../useOptionalFactory.js");
var _connectorsJs = require("./connectors.js");
var _useDragSourceConnectorJs = require("./useDragSourceConnector.js");
var _useDragSourceMonitorJs = require("./useDragSourceMonitor.js");
var _useRegisteredDragSourceJs = require("./useRegisteredDragSource.js");
function useDrag(specArg, deps) {
    const spec = (0, _useOptionalFactoryJs.useOptionalFactory)(specArg, deps);
    (0, _invariant.invariant)(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = (0, _useDragSourceMonitorJs.useDragSourceMonitor)();
    const connector = (0, _useDragSourceConnectorJs.useDragSourceConnector)(spec.options, spec.previewOptions);
    (0, _useRegisteredDragSourceJs.useRegisteredDragSource)(spec, monitor, connector);
    return [
        (0, _useCollectedPropsJs.useCollectedProps)(spec.collect, monitor, connector),
        (0, _connectorsJs.useConnectDragSource)(connector),
        (0, _connectorsJs.useConnectDragPreview)(connector)
    ];
}

},{"@react-dnd/invariant":"39q74","../useCollectedProps.js":"lLwHF","../useOptionalFactory.js":"7H5SQ","./connectors.js":"1vfS4","./useDragSourceConnector.js":"i6rlE","./useDragSourceMonitor.js":"gfFTY","./useRegisteredDragSource.js":"4I31O","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lLwHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCollectedProps", ()=>useCollectedProps);
var _useMonitorOutputJs = require("./useMonitorOutput.js");
function useCollectedProps(collector, monitor, connector) {
    return (0, _useMonitorOutputJs.useMonitorOutput)(monitor, collector || (()=>({})), ()=>connector.reconnect());
}

},{"./useMonitorOutput.js":"cWzuv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWzuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMonitorOutput", ()=>useMonitorOutput);
var _useCollectorJs = require("./useCollector.js");
var _useIsomorphicLayoutEffectJs = require("./useIsomorphicLayoutEffect.js");
function useMonitorOutput(monitor, collect, onCollect) {
    const [collected, updateCollected] = (0, _useCollectorJs.useCollector)(monitor, collect, onCollect);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}

},{"./useCollector.js":"btceu","./useIsomorphicLayoutEffect.js":"gxphT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btceu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */ parcelHelpers.export(exports, "useCollector", ()=>useCollector);
var _fastDeepEqual = require("fast-deep-equal");
var _fastDeepEqualDefault = parcelHelpers.interopDefault(_fastDeepEqual);
var _react = require("react");
var _useIsomorphicLayoutEffectJs = require("./useIsomorphicLayoutEffect.js");
function useCollector(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, _react.useState)(()=>collect(monitor));
    const updateCollected = (0, _react.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, _fastDeepEqualDefault.default)(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(updateCollected);
    return [
        collected,
        updateCollected
    ];
}

},{"fast-deep-equal":"GnVk8","react":"9njXz","./useIsomorphicLayoutEffect.js":"gxphT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"GnVk8":[function(require,module,exports,__globalThis) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"gxphT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7H5SQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOptionalFactory", ()=>useOptionalFactory);
var _react = require("react");
function useOptionalFactory(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== 'function') memoDeps.push(arg);
    return (0, _react.useMemo)(()=>{
        return typeof arg === 'function' ? arg() : arg;
    }, memoDeps);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1vfS4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useConnectDragSource", ()=>useConnectDragSource);
parcelHelpers.export(exports, "useConnectDragPreview", ()=>useConnectDragPreview);
var _react = require("react");
function useConnectDragSource(connector) {
    return (0, _react.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function useConnectDragPreview(connector) {
    return (0, _react.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i6rlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDragSourceConnector", ()=>useDragSourceConnector);
var _react = require("react");
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");
function useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
    const manager = (0, _useDragDropManagerJs.useDragDropManager)();
    const connector = (0, _react.useMemo)(()=>new (0, _indexJs.SourceConnector)(manager.getBackend()), [
        manager
    ]);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}

},{"react":"9njXz","../../internals/index.js":"2ucuH","../useDragDropManager.js":"4DbuX","../useIsomorphicLayoutEffect.js":"gxphT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ucuH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dragSourceMonitorImplJs = require("./DragSourceMonitorImpl.js");
parcelHelpers.exportAll(_dragSourceMonitorImplJs, exports);
var _dropTargetMonitorImplJs = require("./DropTargetMonitorImpl.js");
parcelHelpers.exportAll(_dropTargetMonitorImplJs, exports);
var _registrationJs = require("./registration.js");
parcelHelpers.exportAll(_registrationJs, exports);
var _sourceConnectorJs = require("./SourceConnector.js");
parcelHelpers.exportAll(_sourceConnectorJs, exports);
var _targetConnectorJs = require("./TargetConnector.js");
parcelHelpers.exportAll(_targetConnectorJs, exports);

},{"./DragSourceMonitorImpl.js":"hh8jx","./DropTargetMonitorImpl.js":"kEQs4","./registration.js":"8IsFg","./SourceConnector.js":"5Tmd0","./TargetConnector.js":"78eP6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hh8jx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragSourceMonitorImpl", ()=>DragSourceMonitorImpl);
var _invariant = require("@react-dnd/invariant");
let isCallingCanDrag = false;
let isCallingIsDragging = false;
class DragSourceMonitorImpl {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        (0, _invariant.invariant)(!isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        (0, _invariant.invariant)(!isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}

},{"@react-dnd/invariant":"39q74","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kEQs4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropTargetMonitorImpl", ()=>DropTargetMonitorImpl);
var _invariant = require("@react-dnd/invariant");
let isCallingCanDrop = false;
class DropTargetMonitorImpl {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        (0, _invariant.invariant)(!isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}

},{"@react-dnd/invariant":"39q74","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8IsFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerTarget", ()=>registerTarget);
parcelHelpers.export(exports, "registerSource", ()=>registerSource);
function registerTarget(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function registerSource(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Tmd0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SourceConnector", ()=>SourceConnector);
var _shallowequal = require("@react-dnd/shallowequal");
var _isRefJs = require("./isRef.js");
var _wrapConnectorHooksJs = require("./wrapConnectorHooks.js");
class SourceConnector {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !(0, _shallowequal.shallowEqual)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !(0, _shallowequal.shallowEqual)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = (0, _wrapConnectorHooksJs.wrapConnectorHooks)({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ((0, _isRefJs.isRef)(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ((0, _isRefJs.isRef)(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}

},{"@react-dnd/shallowequal":"1Nvkn","./isRef.js":"apBZt","./wrapConnectorHooks.js":"5iC4h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Nvkn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
function shallowEqual(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"apBZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRef", ()=>isRef);
function isRef(obj) {
    return obj !== null && typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5iC4h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapConnectorHooks", ()=>wrapConnectorHooks);
var _invariant = require("@react-dnd/invariant");
var _react = require("react");
function throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') return;
    const displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + `You can either wrap ${displayName} into a <div>, or turn it into a ` + 'drag source or a drop target itself.');
}
function wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, _react.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return cloneWithRef(element, ref);
    };
}
function wrapConnectorHooks(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith('Ref')) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function setRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else ref.current = node;
}
function cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    (0, _invariant.invariant)(typeof previousRef !== 'string', "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, _react.cloneElement)(element, {
        ref: newRef
    });
    else return (0, _react.cloneElement)(element, {
        ref: (node)=>{
            setRef(previousRef, node);
            setRef(newRef, node);
        }
    });
}

},{"@react-dnd/invariant":"39q74","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"78eP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TargetConnector", ()=>TargetConnector);
var _shallowequal = require("@react-dnd/shallowequal");
var _isRefJs = require("./isRef.js");
var _wrapConnectorHooksJs = require("./wrapConnectorHooks.js");
class TargetConnector {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !(0, _shallowequal.shallowEqual)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = (0, _wrapConnectorHooksJs.wrapConnectorHooks)({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ((0, _isRefJs.isRef)(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}

},{"@react-dnd/shallowequal":"1Nvkn","./isRef.js":"apBZt","./wrapConnectorHooks.js":"5iC4h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4DbuX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook to retrieve the DragDropManager from Context
 */ parcelHelpers.export(exports, "useDragDropManager", ()=>useDragDropManager);
var _invariant = require("@react-dnd/invariant");
var _react = require("react");
var _indexJs = require("../core/index.js");
function useDragDropManager() {
    const { dragDropManager } = (0, _react.useContext)((0, _indexJs.DndContext));
    (0, _invariant.invariant)(dragDropManager != null, 'Expected drag drop context');
    return dragDropManager;
}

},{"@react-dnd/invariant":"39q74","react":"9njXz","../core/index.js":"eIyV4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gfFTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDragSourceMonitor", ()=>useDragSourceMonitor);
var _react = require("react");
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
function useDragSourceMonitor() {
    const manager = (0, _useDragDropManagerJs.useDragDropManager)();
    return (0, _react.useMemo)(()=>new (0, _indexJs.DragSourceMonitorImpl)(manager), [
        manager
    ]);
}

},{"react":"9njXz","../../internals/index.js":"2ucuH","../useDragDropManager.js":"4DbuX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4I31O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRegisteredDragSource", ()=>useRegisteredDragSource);
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");
var _useDragSourceJs = require("./useDragSource.js");
var _useDragTypeJs = require("./useDragType.js");
function useRegisteredDragSource(spec, monitor, connector) {
    const manager = (0, _useDragDropManagerJs.useDragDropManager)();
    const handler = (0, _useDragSourceJs.useDragSource)(spec, monitor, connector);
    const itemType = (0, _useDragTypeJs.useDragType)(spec);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = (0, _indexJs.registerSource)(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}

},{"../../internals/index.js":"2ucuH","../useDragDropManager.js":"4DbuX","../useIsomorphicLayoutEffect.js":"gxphT","./useDragSource.js":"5RfGB","./useDragType.js":"jhRLM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5RfGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDragSource", ()=>useDragSource);
var _react = require("react");
var _dragSourceImplJs = require("./DragSourceImpl.js");
function useDragSource(spec, monitor, connector) {
    const handler = (0, _react.useMemo)(()=>new (0, _dragSourceImplJs.DragSourceImpl)(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, _react.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}

},{"react":"9njXz","./DragSourceImpl.js":"bw8VG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bw8VG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragSourceImpl", ()=>DragSourceImpl);
class DragSourceImpl {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === 'object') result = spec.item;
        else if (typeof spec.item === 'function') result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === 'boolean') return spec.canDrag;
        else if (typeof spec.canDrag === 'function') return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jhRLM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDragType", ()=>useDragType);
var _invariant = require("@react-dnd/invariant");
var _react = require("react");
function useDragType(spec) {
    return (0, _react.useMemo)(()=>{
        const result = spec.type;
        (0, _invariant.invariant)(result != null, 'spec.type must be defined');
        return result;
    }, [
        spec
    ]);
}

},{"@react-dnd/invariant":"39q74","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c55tz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useDropJs = require("./useDrop.js");
parcelHelpers.exportAll(_useDropJs, exports);

},{"./useDrop.js":"3bC5L","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3bC5L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */ parcelHelpers.export(exports, "useDrop", ()=>useDrop);
var _useCollectedPropsJs = require("../useCollectedProps.js");
var _useOptionalFactoryJs = require("../useOptionalFactory.js");
var _connectorsJs = require("./connectors.js");
var _useDropTargetConnectorJs = require("./useDropTargetConnector.js");
var _useDropTargetMonitorJs = require("./useDropTargetMonitor.js");
var _useRegisteredDropTargetJs = require("./useRegisteredDropTarget.js");
function useDrop(specArg, deps) {
    const spec = (0, _useOptionalFactoryJs.useOptionalFactory)(specArg, deps);
    const monitor = (0, _useDropTargetMonitorJs.useDropTargetMonitor)();
    const connector = (0, _useDropTargetConnectorJs.useDropTargetConnector)(spec.options);
    (0, _useRegisteredDropTargetJs.useRegisteredDropTarget)(spec, monitor, connector);
    return [
        (0, _useCollectedPropsJs.useCollectedProps)(spec.collect, monitor, connector),
        (0, _connectorsJs.useConnectDropTarget)(connector)
    ];
}

},{"../useCollectedProps.js":"lLwHF","../useOptionalFactory.js":"7H5SQ","./connectors.js":"lFcUz","./useDropTargetConnector.js":"bQxEU","./useDropTargetMonitor.js":"l9RhN","./useRegisteredDropTarget.js":"2EuaD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lFcUz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useConnectDropTarget", ()=>useConnectDropTarget);
var _react = require("react");
function useConnectDropTarget(connector) {
    return (0, _react.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQxEU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDropTargetConnector", ()=>useDropTargetConnector);
var _react = require("react");
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");
function useDropTargetConnector(options) {
    const manager = (0, _useDragDropManagerJs.useDragDropManager)();
    const connector = (0, _react.useMemo)(()=>new (0, _indexJs.TargetConnector)(manager.getBackend()), [
        manager
    ]);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}

},{"react":"9njXz","../../internals/index.js":"2ucuH","../useDragDropManager.js":"4DbuX","../useIsomorphicLayoutEffect.js":"gxphT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l9RhN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDropTargetMonitor", ()=>useDropTargetMonitor);
var _react = require("react");
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
function useDropTargetMonitor() {
    const manager = (0, _useDragDropManagerJs.useDragDropManager)();
    return (0, _react.useMemo)(()=>new (0, _indexJs.DropTargetMonitorImpl)(manager), [
        manager
    ]);
}

},{"react":"9njXz","../../internals/index.js":"2ucuH","../useDragDropManager.js":"4DbuX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2EuaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRegisteredDropTarget", ()=>useRegisteredDropTarget);
var _indexJs = require("../../internals/index.js");
var _useDragDropManagerJs = require("../useDragDropManager.js");
var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");
var _useAcceptJs = require("./useAccept.js");
var _useDropTargetJs = require("./useDropTarget.js");
function useRegisteredDropTarget(spec, monitor, connector) {
    const manager = (0, _useDragDropManagerJs.useDragDropManager)();
    const dropTarget = (0, _useDropTargetJs.useDropTarget)(spec, monitor);
    const accept = (0, _useAcceptJs.useAccept)(spec);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(function registerDropTarget() {
        const [handlerId, unregister] = (0, _indexJs.registerTarget)(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join('|')
    ]);
}

},{"../../internals/index.js":"2ucuH","../useDragDropManager.js":"4DbuX","../useIsomorphicLayoutEffect.js":"gxphT","./useAccept.js":"4S8XN","./useDropTarget.js":"hJ3P5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4S8XN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */ parcelHelpers.export(exports, "useAccept", ()=>useAccept);
var _invariant = require("@react-dnd/invariant");
var _react = require("react");
function useAccept(spec) {
    const { accept } = spec;
    return (0, _react.useMemo)(()=>{
        (0, _invariant.invariant)(spec.accept != null, 'accept must be defined');
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}

},{"@react-dnd/invariant":"39q74","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hJ3P5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDropTarget", ()=>useDropTarget);
var _react = require("react");
var _dropTargetImplJs = require("./DropTargetImpl.js");
function useDropTarget(spec, monitor) {
    const dropTarget = (0, _react.useMemo)(()=>new (0, _dropTargetImplJs.DropTargetImpl)(spec, monitor), [
        monitor
    ]);
    (0, _react.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}

},{"react":"9njXz","./DropTargetImpl.js":"l8bPZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l8bPZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropTargetImpl", ()=>DropTargetImpl);
class DropTargetImpl {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4f45q":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("62e3cfc56d62d1e2").default;
var _interopRequireDefault = require("97afef054d459ede").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    cardClasses: true
};
Object.defineProperty(exports, "cardClasses", {
    enumerable: true,
    get: function() {
        return _cardClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Card.default;
    }
});
var _Card = _interopRequireDefault(require("1ac5e00873f6d4a0"));
var _cardClasses = _interopRequireWildcard(require("3c67eb07f7e1c146"));
Object.keys(_cardClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _cardClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _cardClasses[key];
        }
    });
});

},{"62e3cfc56d62d1e2":"fiRIh","97afef054d459ede":"kZ6eK","1ac5e00873f6d4a0":"iQH5n","3c67eb07f7e1c146":"bak6J"}],"iQH5n":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9e3d4edab860008c").default;
var _interopRequireWildcard = require("1384c0e5498721e3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("b6fcba72e978e5f2"));
var _propTypes = _interopRequireDefault(require("1e1dc646fbc8c144"));
var _clsx = _interopRequireDefault(require("fc9b0eff160332d8"));
var _chainPropTypes = _interopRequireDefault(require("8241f44c916c09c7"));
var _composeClasses = _interopRequireDefault(require("f945d7e421477871"));
var _zeroStyled = require("9f22904da2b33e99");
var _DefaultPropsProvider = require("77f26b889e1862a8");
var _Paper = _interopRequireDefault(require("2520f83f7f88cd53"));
var _cardClasses = require("a186b27b21593fd8");
var _jsxRuntime = require("1a178b3b34075e8c");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _cardClasses.getCardUtilityClass, classes);
};
const CardRoot = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiCard',
    slot: 'Root'
})({
    overflow: 'hidden'
});
const Card = /*#__PURE__*/ React.forwardRef(function Card(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className, raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardRoot, {
        className: (0, _clsx.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var _default = exports.default = Card;

},{"9e3d4edab860008c":"kZ6eK","1384c0e5498721e3":"fiRIh","b6fcba72e978e5f2":"9njXz","1e1dc646fbc8c144":"bnNSm","fc9b0eff160332d8":"d2NWs","8241f44c916c09c7":"4stnp","f945d7e421477871":"59Equ","9f22904da2b33e99":"hZXDo","77f26b889e1862a8":"9bD8g","2520f83f7f88cd53":"aexCI","a186b27b21593fd8":"bak6J","1a178b3b34075e8c":"1dlk8"}],"bak6J":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a5896799c49dbe58").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getCardUtilityClass = getCardUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("5633528c5c910eb"));
var _generateUtilityClass = _interopRequireDefault(require("28146991fbf9ab2e"));
function getCardUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiCard', slot);
}
const cardClasses = (0, _generateUtilityClasses.default)('MuiCard', [
    'root'
]);
var _default = exports.default = cardClasses;

},{"a5896799c49dbe58":"kZ6eK","5633528c5c910eb":"7pSUk","28146991fbf9ab2e":"jBs9M"}],"dFaD2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("67c64af4bc5634ed").default;
var _interopRequireDefault = require("7c27cf1bcb3bb4fe").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    cardHeaderClasses: true
};
Object.defineProperty(exports, "cardHeaderClasses", {
    enumerable: true,
    get: function() {
        return _cardHeaderClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _CardHeader.default;
    }
});
var _CardHeader = _interopRequireDefault(require("e75e30aadadda8d3"));
var _cardHeaderClasses = _interopRequireWildcard(require("9e44779882fa9790"));
Object.keys(_cardHeaderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _cardHeaderClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _cardHeaderClasses[key];
        }
    });
});

},{"67c64af4bc5634ed":"fiRIh","7c27cf1bcb3bb4fe":"kZ6eK","e75e30aadadda8d3":"8ypX5","9e44779882fa9790":"9ALi9"}],"8ypX5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("342e213e8c11aeea").default;
var _interopRequireWildcard = require("8753ae900e0f31c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("12b2937a5aca384d"));
var _propTypes = _interopRequireDefault(require("b9167c867b2ddb6e"));
var _composeClasses = _interopRequireDefault(require("2ae24810367df700"));
var _Typography = _interopRequireWildcard(require("74315aad9cbafe65"));
var _zeroStyled = require("e61390187934b295");
var _DefaultPropsProvider = require("2739cdf66074c849");
var _cardHeaderClasses = _interopRequireWildcard(require("dfa0bf9ec8d0e2dd"));
var _useSlot = _interopRequireDefault(require("55e3771f39a381d9"));
var _jsxRuntime = require("1393088ea93dcf13");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, _composeClasses.default)(slots, _cardHeaderClasses.getCardHeaderUtilityClass, classes);
};
const CardHeaderRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${_cardHeaderClasses.default.title}`]: styles.title
            },
            {
                [`& .${_cardHeaderClasses.default.subheader}`]: styles.subheader
            },
            styles.root
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const CardHeaderAvatar = (0, _zeroStyled.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar'
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const CardHeaderAction = (0, _zeroStyled.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Action'
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const CardHeaderContent = (0, _zeroStyled.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Content'
})({
    flex: '1 1 auto',
    [`.${_Typography.typographyClasses.root}:where(& .${_cardHeaderClasses.default.title})`]: {
        display: 'block'
    },
    [`.${_Typography.typographyClasses.root}:where(& .${_cardHeaderClasses.default.subheader})`]: {
        display: 'block'
    }
});
const CardHeader = /*#__PURE__*/ React.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action, avatar, component = 'div', disableTypography = false, subheader: subheaderProp, subheaderTypographyProps, title: titleProp, titleTypographyProps, slots = {}, slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        component,
        disableTypography
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots,
        slotProps: {
            title: titleTypographyProps,
            subheader: subheaderTypographyProps,
            ...slotProps
        }
    };
    let title = titleProp;
    const [TitleSlot, titleSlotProps] = (0, _useSlot.default)('title', {
        className: classes.title,
        elementType: _Typography.default,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'h5',
            component: 'span'
        }
    });
    if (title != null && title.type !== _Typography.default && !disableTypography) title = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleSlot, {
        ...titleSlotProps,
        children: title
    });
    let subheader = subheaderProp;
    const [SubheaderSlot, subheaderSlotProps] = (0, _useSlot.default)('subheader', {
        className: classes.subheader,
        elementType: _Typography.default,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'body1',
            color: 'textSecondary',
            component: 'span'
        }
    });
    if (subheader != null && subheader.type !== _Typography.default && !disableTypography) subheader = /*#__PURE__*/ (0, _jsxRuntime.jsx)(SubheaderSlot, {
        ...subheaderSlotProps,
        children: subheader
    });
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        ref,
        className: classes.root,
        elementType: CardHeaderRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component
        },
        ownerState
    });
    const [AvatarSlot, avatarSlotProps] = (0, _useSlot.default)('avatar', {
        className: classes.avatar,
        elementType: CardHeaderAvatar,
        externalForwardedProps,
        ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, _useSlot.default)('content', {
        className: classes.content,
        elementType: CardHeaderContent,
        externalForwardedProps,
        ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, _useSlot.default)('action', {
        className: classes.action,
        elementType: CardHeaderAction,
        externalForwardedProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            avatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)(AvatarSlot, {
                ...avatarSlotProps,
                children: avatar
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ContentSlot, {
                ...contentSlotProps,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            })
        ]
    });
});
var _default = exports.default = CardHeader;

},{"342e213e8c11aeea":"kZ6eK","8753ae900e0f31c":"fiRIh","12b2937a5aca384d":"9njXz","b9167c867b2ddb6e":"bnNSm","2ae24810367df700":"59Equ","74315aad9cbafe65":"6NtGx","e61390187934b295":"hZXDo","2739cdf66074c849":"9bD8g","dfa0bf9ec8d0e2dd":"9ALi9","55e3771f39a381d9":"h76AU","1393088ea93dcf13":"1dlk8"}],"9ALi9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d5715ea4ecf424d5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getCardHeaderUtilityClass = getCardHeaderUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("9fcff31ad4cb2243"));
var _generateUtilityClass = _interopRequireDefault(require("417824b1e33854c6"));
function getCardHeaderUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiCardHeader', slot);
}
const cardHeaderClasses = (0, _generateUtilityClasses.default)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
var _default = exports.default = cardHeaderClasses;

},{"d5715ea4ecf424d5":"kZ6eK","9fcff31ad4cb2243":"7pSUk","417824b1e33854c6":"jBs9M"}],"bJDdY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _searchInput = require("../../../common/SearchInput");
var _searchInputDefault = parcelHelpers.interopDefault(_searchInput);
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _outputsActions = require("../../../../redux/actions/outputsActions");
var _utils = require("../../../../utils");
var _item = require("./Item");
var _itemDefault = parcelHelpers.interopDefault(_item);
var _style = require("./Item/style");
var _pagination = require("../../../common/Table/Pagination");
var _hooks = require("../../../../utils/hooks");
var _hooksDefault = parcelHelpers.interopDefault(_hooks);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
const LOCALE_STORAGE_PER_PAGE_KEY = 'edge:sm:outputsPerPage';
const headerFooterHeight = 58;
const styles = {
    container: {
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        background: (theme)=>theme.palette.background.paper
    },
    toolbar: {
        maxHeight: headerFooterHeight,
        padding: (theme)=>theme.spacing(0, (0, _style.SIDE_PADDING))
    },
    outputList: {
        marginTop: 0,
        marginBottom: 0,
        padding: (theme)=>theme.spacing(0, 0, 3),
        height: `calc(100% - ${headerFooterHeight * 2}px)`,
        overflowY: 'auto',
        alignContent: 'flex-start'
    },
    pagination: {
        height: headerFooterHeight,
        backgroundColor: 'background.paper'
    }
};
const Outputs = ()=>{
    const [filter, setFilter] = (0, _react.useState)('');
    const [pageNumber, setPageNumber] = (0, _react.useState)('0');
    const [rowsPerPage, setRowsPerPage] = (0, _react.useState)(localStorage.getItem(LOCALE_STORAGE_PER_PAGE_KEY) || '10');
    const debouncedFilter = (0, _utils.useDebouncedFilter)(filter);
    const params = {
        pageNumber,
        rowsPerPage,
        filter: debouncedFilter || undefined
    };
    const { outputsWithLists, total, loading, saving } = (0, _utils.useOutputsWithListsSelector)(params);
    const { dialogSaving: listSending } = (0, _reactRedux.useSelector)(({ inputsReducer })=>({
            dialogSaving: inputsReducer.dialogSaving
        }), (0, _reactRedux.shallowEqual));
    const dispatch = (0, _reactRedux.useDispatch)();
    const { width } = (0, _hooksDefault.default)();
    const hidePerPagePaginationOption = width < 1330;
    (0, _react.useEffect)(()=>{
        if (saving || listSending) return;
        dispatch((0, _outputsActions.getOutputsWithLists)(params));
    }, [
        saving,
        listSending,
        pageNumber,
        rowsPerPage,
        debouncedFilter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
        id: "outputs",
        pending: loading || saving || listSending,
        cover: true,
        coverContainerProps: styles.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                sx: styles.toolbar,
                id: "outputs-toolbar",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchInputDefault.default), {
                    onChange: (input)=>{
                        setPageNumber('0');
                        setFilter(input);
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: styles.outputList,
                children: outputsWithLists.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemDefault.default), {
                        output: item
                    }, item.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: styles.pagination,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.Pagination), {
                        total: total,
                        page: pageNumber,
                        perPage: rowsPerPage,
                        changePageCallback: setPageNumber,
                        changeRowsPerPageCallback: (rows)=>{
                            setPageNumber('0');
                            localStorage.setItem(LOCALE_STORAGE_PER_PAGE_KEY, rows);
                            setRowsPerPage(rows);
                        },
                        id: 'output-pagination',
                        hidePerPageOption: true,
                        hideJumpToPage: hidePerPagePaginationOption
                    })
                ]
            })
        ]
    });
};
exports.default = Outputs;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/Toolbar":"5Kohb","../../../common/SearchInput":"liEuw","../../../common/Pendable":"gDN67","../../../../redux/actions/outputsActions":"alMzI","../../../../utils":"342UB","./Item":"ccyHF","./Item/style":"7y0YK","../../../common/Table/Pagination":"HM37R","../../../../utils/hooks":"5aY3q","@mui/material/Divider":"9Ul8c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ccyHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _reactDnd = require("react-dnd");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _outputsActions = require("../../../../../redux/actions/outputsActions");
var _inputsActions = require("../../../../../redux/actions/inputsActions");
var _utils = require("../../../../../utils");
var _outputList = require("./OutputList");
var _outputListDefault = parcelHelpers.interopDefault(_outputList);
var _output = require("./Output");
var _outputDefault = parcelHelpers.interopDefault(_output);
var _utils1 = require("common/utils");
const Item = ({ output })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const setConfirmation = (0, _utils.useConfirmationDialog)();
    const [{ canDrop, isOver }, drop] = (0, _reactDnd.useDrop)(()=>({
            accept: 'input',
            drop: (item)=>{
                onInputDrop({
                    output,
                    input: item
                });
            },
            collect: (monitor)=>({
                    isOver: monitor.isOver(),
                    canDrop: monitor.canDrop()
                })
        }), [
        output
    ]);
    const onInputDrop = ({ output, input })=>{
        if (!(0, _utils.isOutput)(output)) {
            const action = ()=>dispatch((0, _inputsActions.updateInputRecipients)({
                    id: input.id,
                    listsAdded: [
                        output.id
                    ],
                    outputsAdded: [],
                    outputsRemoved: []
                }));
            if (output._hasOutputsInUse) return setConfirmation(()=>void action(), 'At least one of the outputs in the list is already streaming an input, are you sure you want to proceed?', output.name);
            return action();
        }
        const action = ()=>dispatch((0, _outputsActions.setInputOfOutput)({
                output,
                inputId: input.id
            }));
        const isOutputStreamingOtherInput = output._input && output._input.id !== input.id;
        const isRedundantOutput = output.redundancyMode != (0, _types.OutputRedundancyMode).none;
        const isRedundantInput = (0, _utils1.inputRedundancy)(input);
        const isOutputRedundancyBeingRemoved = isRedundantOutput && !isRedundantInput;
        const showPrompt = isOutputStreamingOtherInput || isOutputRedundancyBeingRemoved;
        if (showPrompt) return setConfirmation(()=>void action(), /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                isOutputStreamingOtherInput && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                    children: [
                        "- Current output is already streaming the input ",
                        output._input.name,
                        " "
                    ]
                }),
                isOutputRedundancyBeingRemoved && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: "- You have selected a non-redundant input - output redundancy will be disabled "
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: " Proceed? "
                })
            ]
        }));
        return action();
    };
    const isHovered = canDrop && isOver;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: drop,
        children: (0, _utils.isOutput)(output) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outputDefault.default), {
            output: output,
            isHovered: isHovered
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outputListDefault.default), {
            output: output,
            isHovered: isHovered
        })
    });
};
exports.default = Item;

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","react-dnd":"aAvQg","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../../../../redux/actions/outputsActions":"alMzI","../../../../../redux/actions/inputsActions":"l0Ua8","../../../../../utils":"342UB","./OutputList":"ifpDh","./Output":"a8e18","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ifpDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _icon = require("@mui/material/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _videoLibrary = require("@mui/icons-material/VideoLibrary");
var _videoLibraryDefault = parcelHelpers.interopDefault(_videoLibrary);
var _style = require("./style");
const styles = {
    listContainer: {
        position: 'relative',
        margin: (theme)=>theme.spacing(1, 1, 3, 3)
    },
    listContent: {
        display: 'flex',
        padding: (theme)=>theme.spacing(2),
        color: (theme)=>theme.palette.text.secondary,
        alignItems: 'center',
        '& > *:first-child': {
            marginRight: (theme)=>theme.spacing(2)
        }
    },
    listItem: {
        position: 'relative'
    },
    listSign: {
        position: 'absolute',
        height: '100%',
        width: '100%'
    }
};
const OutputList = ({ output, isHovered })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.listContainer,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    ...styles.listSign,
                    ...(0, _style.styles).itemStyle,
                    top: '16px',
                    left: '-16px'
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    ...styles.listSign,
                    ...(0, _style.styles).itemStyle,
                    top: '8px',
                    left: '-8px'
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    ...styles.listItem,
                    ...(0, _style.styles).itemStyle,
                    ...isHovered ? (0, _style.styles).itemHovered : {}
                },
                "data-test-id": "output",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body1",
                        color: isHovered ? 'primary' : 'textPrimary',
                        "data-test-id": "output-title",
                        children: output.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: styles.listContent,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoLibraryDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                children: output.description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = OutputList;

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","@mui/material/Icon":"cqMA1","@mui/icons-material/VideoLibrary":"buoJz","./style":"7y0YK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7y0YK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIDE_PADDING", ()=>SIDE_PADDING);
parcelHelpers.export(exports, "styles", ()=>styles);
const SIDE_PADDING = 1;
const styles = {
    itemStyle: {
        background: (theme)=>theme.palette.background.default,
        padding: (theme)=>theme.spacing(1, SIDE_PADDING),
        border: (theme)=>`1px solid ${theme.palette.divider}`,
        borderRadius: (theme)=>theme.shape.borderRadius,
        transition: 'background .2s linear'
    },
    itemHovered: {
        background: (theme)=>theme.palette.grey[300]
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a8e18":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _thumbnail = require("../../../../common/Thumbnail");
var _thumbnailDefault = parcelHelpers.interopDefault(_thumbnail);
var _style = require("./style");
var _outputsActions = require("../../../../../redux/actions/outputsActions");
var _utils = require("../../../../../utils");
var _helpers = require("common/api/v1/helpers");
const styles = {
    item: {
        margin: (theme)=>theme.spacing(1)
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        minHeight: '50px'
    },
    card: (theme)=>({
            display: 'flex',
            transition: 'transform .1s, opacity 0.2s',
            margin: theme.spacing(1, 0),
            opacity: 1,
            '&.hovered': {
                opacity: 0.4
            },
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column'
            },
            '&:hover .inputRemove': (theme)=>({
                    transform: 'translateX(0)',
                    [theme.breakpoints.up('sm')]: {
                        boxShadow: `-15px 0px 22px 5px ${theme.palette.background.paper}`
                    }
                })
        }),
    inputRemove: {
        position: 'absolute',
        right: 0,
        top: 0,
        width: '50px',
        height: '100%',
        transform: 'translateX(100%)',
        transition: 'all .2s',
        background: 'inherit',
        boxShadow: (theme)=>`0 0 0 0 ${theme.palette.background.paper}`,
        '&.shown': {
            transform: 'translateX(0)'
        },
        display: 'flex',
        alignItems: 'center'
    },
    thumbnail: (theme)=>({
            display: 'flex',
            alignItems: 'center',
            minWidth: '90px',
            [theme.breakpoints.down('xs')]: {
                width: 'auto'
            }
        }),
    content: {
        padding: (theme)=>theme.spacing(1),
        display: 'flex',
        alignItems: 'center'
    },
    empty: {
        textTransform: 'uppercase',
        textAlign: 'center',
        padding: (theme)=>theme.spacing(2, 0)
    }
};
const Item = ({ output, isHovered })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const setConfirmation = (0, _utils.useConfirmationDialog)();
    const [showClear, setShowClear] = (0, _react.useState)(false);
    const onClearInput = ()=>{
        setShowClear(true);
        setConfirmation(()=>void dispatch((0, _outputsActions.setInputOfOutput)({
                output,
                inputId: undefined
            })), 'Do you want to clear the input of this output?', output.name, undefined, ()=>setShowClear(false));
    };
    const input = output._input;
    const format = (0, _helpers.getFormattedTransportStreamContent)((input?.tsInfo || [])[0]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            ...styles.item,
            ...(0, _style.styles).itemStyle,
            ...isHovered ? (0, _style.styles).itemHovered : {}
        },
        "data-test-id": "output",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "body1",
                color: isHovered ? 'primary' : output.adminStatus ? 'textPrimary' : 'textSecondary',
                "data-test-id": "output-title",
                children: output.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: input ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: styles.container,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                                sx: styles.card,
                                className: (0, _classnamesDefault.default)(isHovered && 'hovered'),
                                "data-test-id": "input-streaming",
                                style: {
                                    position: 'relative',
                                    transform: isHovered ? 'translateX(50%)' : 'translateX(0)'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        sx: styles.thumbnail,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnailDefault.default), {
                                            input: input,
                                            initialOutput: output
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                                        sx: styles.content,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "body2",
                                            "data-test-id": "input-title",
                                            ...(0, _utils.inputOutputColor)(input),
                                            children: input.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        sx: styles.inputRemove,
                                        className: (0, _classnamesDefault.default)('inputRemove', showClear && 'shown'),
                                        title: "Clear",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                            "aria-label": "clear",
                                            onClick: onClearInput,
                                            edge: "end",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "subtitle2",
                            color: "textSecondary",
                            children: format
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    sx: {
                        ...styles.content,
                        ...styles.empty
                    },
                    color: "textSecondary",
                    variant: "caption",
                    component: "div",
                    children: isHovered ? 'Drop to switch' : 'Waiting for input'
                })
            })
        ]
    });
};
exports.default = Item;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","classnames":"5Een2","@mui/material/Box":"c4QkF","@mui/material/Card":"4f45q","@mui/material/CardContent":"29GK9","@mui/material/Typography":"6NtGx","@mui/material/IconButton":"488As","@mui/icons-material/Close":"acjz6","../../../../common/Thumbnail":"5Q8KF","./style":"7y0YK","../../../../../redux/actions/outputsActions":"alMzI","../../../../../utils":"342UB","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"29GK9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("cd096df5fe41522").default;
var _interopRequireDefault = require("e63237ba158bfe23").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    cardContentClasses: true
};
Object.defineProperty(exports, "cardContentClasses", {
    enumerable: true,
    get: function() {
        return _cardContentClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _CardContent.default;
    }
});
var _CardContent = _interopRequireDefault(require("fed7119a254eaf59"));
var _cardContentClasses = _interopRequireWildcard(require("4fa4e7d770e83168"));
Object.keys(_cardContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _cardContentClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _cardContentClasses[key];
        }
    });
});

},{"cd096df5fe41522":"fiRIh","e63237ba158bfe23":"kZ6eK","fed7119a254eaf59":"7Ldoh","4fa4e7d770e83168":"hKqz5"}],"7Ldoh":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7582cf14130707ee").default;
var _interopRequireWildcard = require("58a94d82946dd129").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("e042cb335c21b40"));
var _propTypes = _interopRequireDefault(require("7bf6bf0ae2eda2a8"));
var _clsx = _interopRequireDefault(require("637fd63aa5edb015"));
var _composeClasses = _interopRequireDefault(require("375c2107724ba495"));
var _zeroStyled = require("5b2c9a62442dab67");
var _DefaultPropsProvider = require("ce4c986dd67f212a");
var _cardContentClasses = require("75ea4d823fc8d626");
var _jsxRuntime = require("4601d55e2b7c0e07");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _cardContentClasses.getCardContentUtilityClass, classes);
};
const CardContentRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiCardContent',
    slot: 'Root'
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const CardContent = /*#__PURE__*/ React.forwardRef(function CardContent(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className, component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardContentRoot, {
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var _default = exports.default = CardContent;

},{"7582cf14130707ee":"kZ6eK","58a94d82946dd129":"fiRIh","e042cb335c21b40":"9njXz","7bf6bf0ae2eda2a8":"bnNSm","637fd63aa5edb015":"d2NWs","375c2107724ba495":"59Equ","5b2c9a62442dab67":"hZXDo","ce4c986dd67f212a":"9bD8g","75ea4d823fc8d626":"hKqz5","4601d55e2b7c0e07":"1dlk8"}],"hKqz5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b3d76390ec78b0d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getCardContentUtilityClass = getCardContentUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("3bb4f43bf2968bb0"));
var _generateUtilityClass = _interopRequireDefault(require("853f3466dbcb2399"));
function getCardContentUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiCardContent', slot);
}
const cardContentClasses = (0, _generateUtilityClasses.default)('MuiCardContent', [
    'root'
]);
var _default = exports.default = cardContentClasses;

},{"b3d76390ec78b0d":"kZ6eK","3bb4f43bf2968bb0":"7pSUk","853f3466dbcb2399":"jBs9M"}],"g2VXu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkManagerContainer", ()=>NetworkManagerContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _container = require("@mui/material/Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _nmsidebar = require("../partials/NMSidebar");
var _routes = require("../../utils/routes");
var _alarmsActions = require("../../redux/actions/alarmsActions");
var _notFound = require("../common/NotFound");
var _serviceProvider = require("../dashboards/serviceProvider");
var _inputs = require("../inputs");
var _groups = require("../groups");
var _users = require("../users");
var _interfaces = require("../interfaces");
var _appliances = require("../appliances");
var _outputs = require("../outputs");
var _alarms = require("../alarms");
var _billing = require("../billing");
var _graph = require("../graph");
var _overview = require("../serviceOverview/Overview");
var _overviewDefault = parcelHelpers.interopDefault(_overview);
var _audit = require("../audit");
var _regions = require("../regions");
var _settings = require("../settings");
var _status = require("../status");
var _addressMappings = require("../addressMappings");
var _usage = require("../usage");
var _errorBoundary = require("../common/ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _kubernetesNodes = require("../kubernetesNodes");
var _networks = require("../networks");
var _services = require("../services");
var _alarmLogs = require("../alarmLogs");
var _index = require("../profile/index");
var _tunnels = require("../appliances/Edit/ApplianceForm/Tunnels");
var _production = require("../production");
var _adInsertion = require("../adInsertion");
const NetworkManagerContainer = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _alarmsActions.readAlarmsInBackground)({}));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            sx: {
                height: '100vh',
                width: '100vw',
                display: 'flex'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nmsidebar.NMSidebar), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _containerDefault.default), {
                        component: "main",
                        maxWidth: false,
                        sx: {
                            overflowX: 'auto'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Navigate), {
                                        to: (0, _routes.ROUTES).overview,
                                        replace: true
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: (0, _routes.ROUTES).overview,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serviceProvider.Dashboard), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).graph}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graphs), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).inputs}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputs.Inputs), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).outputs}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outputs.Outputs), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).alarms}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alarms.Alarms), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: (0, _routes.ROUTES).service,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewDefault.default), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: (0, _routes.ROUTES).setting,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Navigate), {
                                        to: "settings/appliances/"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).appliances}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appliances.Appliances), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).users}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _users.Users), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).interfaces}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _interfaces.Interfaces), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).networks}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networks.Networks), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).groups}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groups.Groups), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).billing}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _billing.BillingReport), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).usage}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usage.UsageReport), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).audit}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _audit.Audit), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).alarmLogs}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alarmLogs.AlarmLogs), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).addressMappings}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressMappings.AddressMappings), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).regions}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _regions.Regions), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).production}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _production.Production), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).adInsertion}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adInsertion.AdInsertion), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: (0, _routes.ROUTES).globalSettings,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settings.Settings), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).status}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _status.Status), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).nodes}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kubernetesNodes.Nodes), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).services}/*`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _services.Services), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: `${(0, _routes.ROUTES).tunnels}/:tunnelId`,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tunnels.TunnelDetails), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: (0, _routes.ROUTES).profile,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Profile), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","@mui/material/Box":"c4QkF","@mui/material/Container":"376wa","../partials/NMSidebar":"753kN","../../utils/routes":"cqMGU","../../redux/actions/alarmsActions":"2PZQF","../common/NotFound":"1Msr5","../dashboards/serviceProvider":"jMCXc","../inputs":"gCfwf","../groups":"5LplR","../users":"eY235","../interfaces":"KziXu","../appliances":"bCeik","../outputs":"kYs69","../alarms":"dJzk1","../billing":"d0cOl","../graph":"gE26Y","../serviceOverview/Overview":"1D7NB","../audit":"4pBqU","../regions":"8Qufr","../settings":"jpK9z","../status":"88QQ0","../addressMappings":"exGSe","../usage":"6sLRr","../common/ErrorBoundary":"44DTp","../kubernetesNodes":"18S2x","../networks":"c0HOG","../services":"l3ePJ","../alarmLogs":"bIyS9","../profile/index":"dfRs7","../appliances/Edit/ApplianceForm/Tunnels":"978yf","../production":"4OX6G","../adInsertion":"iyMC8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"753kN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NMSidebar", ()=>NMSidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _dashboard = require("@mui/icons-material/Dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _ondemandVideoOutlined = require("@mui/icons-material/OndemandVideoOutlined");
var _ondemandVideoOutlinedDefault = parcelHelpers.interopDefault(_ondemandVideoOutlined);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _videocamOutlined = require("@mui/icons-material/VideocamOutlined");
var _videocamOutlinedDefault = parcelHelpers.interopDefault(_videocamOutlined);
var _warning = require("@mui/icons-material/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _monetizationOn = require("@mui/icons-material/MonetizationOn");
var _monetizationOnDefault = parcelHelpers.interopDefault(_monetizationOn);
var _types = require("common/api/v1/types");
var _store = require("../../store");
var _env = require("../../env");
var _index = require("../common/SidebarMenu/index");
var _alarmItemNameWithActiveAlarms = require("../common/SidebarMenu/AlarmItemNameWithActiveAlarms");
var _alarmItemNameWithActiveAlarmsDefault = parcelHelpers.interopDefault(_alarmItemNameWithActiveAlarms);
var _utils = require("../../utils");
const NMSidebar = ()=>{
    const routes = (0, _store.useRoutes)();
    const { settings } = (0, _utils.useSettingsSelector)();
    const expFeatures = settings?.expFeatures;
    const menuItems = ({ userRole, alarms, onClick, devMode })=>[
            {
                name: 'Overview',
                url: routes.overview(),
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardDefault.default), {}),
                onClick
            },
            {
                name: 'Inputs',
                url: routes.inputs(),
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videocamOutlinedDefault.default), {}),
                onClick
            },
            {
                name: 'Outputs',
                url: routes.outputs(),
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ondemandVideoOutlinedDefault.default), {}),
                onClick
            },
            {
                name: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alarmItemNameWithActiveAlarmsDefault.default), {
                    alarms: alarms
                }),
                url: routes.alarms(),
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {}),
                onClick
            },
            ...userRole >= (0, _types.Role).admin && expFeatures?.AdInsertion ? [
                {
                    name: 'Ad Insertion',
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _monetizationOnDefault.default), {}),
                    children: [
                        {
                            name: 'Overview',
                            url: routes.adInsertion(),
                            onClick
                        },
                        {
                            name: 'Breaks',
                            url: routes.adBreaks(),
                            onClick
                        },
                        {
                            name: 'Pods',
                            url: routes.adPods(),
                            onClick
                        },
                        {
                            name: 'Creatives',
                            url: routes.adCreatives(),
                            onClick
                        },
                        {
                            name: 'Audit log',
                            url: routes.adAudit(),
                            onClick
                        },
                        {
                            name: 'External Ad Servers',
                            url: routes.adServers(),
                            onClick
                        }
                    ]
                }
            ] : [],
            {
                name: 'Settings',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                children: [
                    {
                        name: 'Regions',
                        url: routes.regions(),
                        onClick
                    },
                    {
                        name: 'Appliances',
                        url: routes.appliances(),
                        onClick
                    },
                    devMode ? {
                        name: /*#__PURE__*/ (0, _jsxRuntime.jsx)("s", {
                            children: "Interfaces"
                        }),
                        url: routes.interfaces(),
                        divider: true,
                        onClick
                    } : null,
                    userRole === (0, _types.Role).super ? {
                        name: 'Networks',
                        url: routes.networks(),
                        onClick
                    } : null,
                    userRole === (0, _types.Role).super ? {
                        name: 'Address mappings',
                        url: routes.addressMappings(),
                        onClick
                    } : null,
                    userRole === (0, _types.Role).super && !(0, _env.IS_CONNECT_IT) ? {
                        name: 'Kubernetes nodes',
                        url: routes.kubernetesNodes(),
                        onClick
                    } : null,
                    userRole === (0, _types.Role).super && !(0, _env.IS_CONNECT_IT) ? {
                        name: 'Kubernetes services',
                        url: routes.services(),
                        divider: true,
                        onClick
                    } : null,
                    {
                        name: 'Groups',
                        url: routes.groups(),
                        onClick
                    },
                    {
                        name: 'Users',
                        url: routes.users(),
                        divider: true,
                        onClick
                    },
                    {
                        name: 'Audit log',
                        url: routes.audit(),
                        onClick
                    },
                    userRole === (0, _types.Role).super ? {
                        name: 'Alarm history',
                        url: routes.alarmLogs(),
                        divider: true,
                        onClick
                    } : null,
                    userRole === (0, _types.Role).super && !(0, _env.IS_CONNECT_IT) ? {
                        name: 'Billing',
                        url: routes.billing(),
                        onClick
                    } : null,
                    userRole === (0, _types.Role).super || userRole === (0, _types.Role).admin ? {
                        name: 'Usage',
                        url: routes.usage(),
                        divider: true,
                        onClick
                    } : null,
                    userRole >= (0, _types.Role).admin && devMode && expFeatures?.ExtDerivedInput ? {
                        name: 'Production tools',
                        url: routes.production()
                    } : null,
                    userRole === (0, _types.Role).super ? {
                        name: 'Global settings',
                        url: routes.globalSettings(),
                        onClick
                    } : null
                ].filter(Boolean)
            }
        ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Sidebar), {
        logoLink: routes.overview(),
        title: "Network Manager",
        menuItems: menuItems,
        profileUrl: routes.profile.route
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/icons-material/Dashboard":"6dJXb","@mui/icons-material/OndemandVideoOutlined":"3EY4k","@mui/icons-material/Settings":"jkTfg","@mui/icons-material/VideocamOutlined":"3B1X9","@mui/icons-material/Warning":"eRDc8","@mui/icons-material/MonetizationOn":"6PlbH","common/api/v1/types":"3qemx","../../store":"5LXiG","../../env":"cPu8n","../common/SidebarMenu/index":"f2Iey","../common/SidebarMenu/AlarmItemNameWithActiveAlarms":"gxQEf","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6dJXb":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("73ee906234b24c10").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("c3968ba976bdfdfc"));
var _jsxRuntime = require("45103603424ce9b5");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M3 13h8V3H3zm0 8h8v-6H3zm10 0h8V11h-8zm0-18v6h8V3z"
}), 'Dashboard');

},{"73ee906234b24c10":"kZ6eK","c3968ba976bdfdfc":"2vOnF","45103603424ce9b5":"1dlk8"}],"3EY4k":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("2d1fd05afaaa3bbd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("fd8d377bdaa47678"));
var _jsxRuntime = require("6c746a1c1b8c9c4c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 14H3V5h18z"
}), 'OndemandVideoOutlined');

},{"2d1fd05afaaa3bbd":"kZ6eK","fd8d377bdaa47678":"2vOnF","6c746a1c1b8c9c4c":"1dlk8"}],"gxQEf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _badge = require("@mui/material/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("@mui/material/styles");
const styles = {
    container: {
        display: 'flex',
        justifyContent: 'space-between'
    }
};
const StyledBadge = (0, _styles.styled)((0, _badgeDefault.default))(({ theme })=>({
        '& .MuiBadge-badge': {
            transform: 'unset',
            color: theme.palette.grey[900]
        },
        '& .MuiBadge-colorPrimary': {
            background: theme.palette.warning.main
        },
        '& .MuiBadge-colorError': {
            background: theme.palette.error.main
        }
    }));
const AlarmItemNameWithActiveAlarms = ({ alarms: { hasCritical, total } })=>{
    const badgeColor = hasCritical ? 'error' : 'primary';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.container,
        children: [
            "Alarms",
            total > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBadge, {
                overlap: "rectangular",
                color: badgeColor,
                badgeContent: total,
                max: 1e9
            })
        ]
    });
};
exports.default = AlarmItemNameWithActiveAlarms;

},{"react/jsx-runtime":"1dlk8","@mui/material/Badge":"2fJ2h","@mui/material/Box":"c4QkF","@mui/material/styles":"2UrBk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2fJ2h":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("f517978c7f8183fc").default;
var _interopRequireDefault = require("a4c511e8805e4c72").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    badgeClasses: true
};
Object.defineProperty(exports, "badgeClasses", {
    enumerable: true,
    get: function() {
        return _badgeClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Badge.default;
    }
});
var _Badge = _interopRequireDefault(require("3d6bb1c2bec6b76e"));
var _badgeClasses = _interopRequireWildcard(require("6982cae2780d6677"));
Object.keys(_badgeClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _badgeClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _badgeClasses[key];
        }
    });
});

},{"f517978c7f8183fc":"fiRIh","a4c511e8805e4c72":"kZ6eK","3d6bb1c2bec6b76e":"cAKiT","6982cae2780d6677":"eos6k"}],"cAKiT":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("349d2ce093e5079d").default;
var _interopRequireWildcard = require("aa279aaf66e028d7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("c31edf92e7941fd8"));
var _propTypes = _interopRequireDefault(require("f4421823bbde177e"));
var _clsx = _interopRequireDefault(require("f5a00402d42646a8"));
var _usePreviousProps = _interopRequireDefault(require("aacdae798e1c5fa9"));
var _composeClasses = _interopRequireDefault(require("5da04b16b2759c4d"));
var _useBadge = _interopRequireDefault(require("17c39e4f4d6eb00f"));
var _zeroStyled = require("2d1983735959e3e");
var _memoTheme = _interopRequireDefault(require("2e02c07c9631e2a3"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("b4a8980d40ccd8f"));
var _DefaultPropsProvider = require("5042c946fd53acb8");
var _capitalize = _interopRequireDefault(require("1298596a24e72c26"));
var _badgeClasses = _interopRequireWildcard(require("8269326c25af4749"));
var _useSlot = _interopRequireDefault(require("8557f0f2a8ac7f11"));
var _jsxRuntime = require("d24293c04c5d1f6c");
const RADIUS_STANDARD = 10;
const RADIUS_DOT = 4;
const useUtilityClasses = (ownerState)=>{
    const { color, anchorOrigin, invisible, overlap, variant, classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, _capitalize.default)(anchorOrigin.vertical)}${(0, _capitalize.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, _capitalize.default)(anchorOrigin.vertical)}${(0, _capitalize.default)(anchorOrigin.horizontal)}${(0, _capitalize.default)(overlap)}`,
            `overlap${(0, _capitalize.default)(overlap)}`,
            color !== 'default' && `color${(0, _capitalize.default)(color)}`
        ]
    };
    return (0, _composeClasses.default)(slots, _badgeClasses.getBadgeUtilityClass, classes);
};
const BadgeRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiBadge',
    slot: 'Root'
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const BadgeBadge = (0, _zeroStyled.styled)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, _capitalize.default)(ownerState.anchorOrigin.vertical)}${(0, _capitalize.default)(ownerState.anchorOrigin.horizontal)}${(0, _capitalize.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: RADIUS_STANDARD * 2,
        borderRadius: RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: RADIUS_DOT,
                    height: RADIUS_DOT * 2,
                    minWidth: RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${_badgeClasses.default.invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${_badgeClasses.default.invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${_badgeClasses.default.invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${_badgeClasses.default.invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${_badgeClasses.default.invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${_badgeClasses.default.invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${_badgeClasses.default.invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${_badgeClasses.default.invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    })));
function getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const Badge = /*#__PURE__*/ React.forwardRef(function Badge(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className, classes: classesProp, component, components = {}, componentsProps = {}, children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots, slotProps, showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent, invisible: invisibleFromHook, max, displayValue: displayValueFromHook } = (0, _useBadge.default)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero
    });
    const prevProps = (0, _usePreviousProps.default)({
        anchorOrigin: getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color = colorProp, overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent,
        invisible,
        max,
        displayValue,
        showZero,
        anchorOrigin,
        color,
        overlap,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        elementType: BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, _useSlot.default)('badge', {
        elementType: BadgeBadge,
        externalForwardedProps,
        ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var _default = exports.default = Badge;

},{"349d2ce093e5079d":"kZ6eK","aa279aaf66e028d7":"fiRIh","c31edf92e7941fd8":"9njXz","f4421823bbde177e":"bnNSm","f5a00402d42646a8":"d2NWs","aacdae798e1c5fa9":"kyeaf","5da04b16b2759c4d":"59Equ","17c39e4f4d6eb00f":"7w1BQ","2d1983735959e3e":"hZXDo","2e02c07c9631e2a3":"cJNjb","b4a8980d40ccd8f":"2r5WG","5042c946fd53acb8":"9bD8g","1298596a24e72c26":"eOYSA","8269326c25af4749":"eos6k","8557f0f2a8ac7f11":"h76AU","d24293c04c5d1f6c":"1dlk8"}],"7w1BQ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b84bf0034ac2478d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _usePreviousProps = _interopRequireDefault(require("1eaf61199b5a3079"));
function useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero = false } = parameters;
    const prevProps = (0, _usePreviousProps.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent, max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent,
        invisible,
        max,
        displayValue
    };
}
var _default = exports.default = useBadge;

},{"b84bf0034ac2478d":"kZ6eK","1eaf61199b5a3079":"kyeaf"}],"eos6k":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("72625ee763d831d6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getBadgeUtilityClass = getBadgeUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("a560ac661b1bdd6"));
var _generateUtilityClass = _interopRequireDefault(require("fa9e482473d275a9"));
function getBadgeUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiBadge', slot);
}
const badgeClasses = (0, _generateUtilityClasses.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var _default = exports.default = badgeClasses;

},{"72625ee763d831d6":"kZ6eK","a560ac661b1bdd6":"7pSUk","fa9e482473d275a9":"jBs9M"}],"jMCXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dashboard", ()=>Dashboard);
var _jsxRuntime = require("react/jsx-runtime");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _form = require("../../common/Form");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _alarms = require("../../alarms/Table/Alarms");
var _alarmsDefault = parcelHelpers.interopDefault(_alarms);
var _map = require("../../geo/Map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _availability = require("./Availability");
var _availabilityDefault = parcelHelpers.interopDefault(_availability);
var _graph = require("./Graph");
var _graphDefault = parcelHelpers.interopDefault(_graph);
var _link = require("../../common/Link");
var _store = require("../../../store");
const classes = {
    paper: {
        margin: 0,
        overflow: 'hidden'
    },
    stretched: {
        height: '100%'
    }
};
const Dashboard = ()=>{
    const routes = (0, _store.useRoutes)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: "Overview",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            container: true,
            spacing: 3,
            alignItems: "stretch",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        xs: 12,
                        lg: 6
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mapDefault.default), {
                        dataType: (0, _map.MapDataType).appliances
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        xs: 12,
                        md: 6
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        sx: {
                            ...classes.paper,
                            ...classes.stretched
                        },
                        title: "Availability",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _availabilityDefault.default), {})
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        xs: 12,
                        md: 6
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        sx: classes.paper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graphDefault.default), {})
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        xs: 12,
                        lg: 6
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        sx: classes.paper,
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: routes.alarms(),
                            children: "Alarms"
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alarmsDefault.default), {
                            size: 'small'
                        })
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Grid":"6iX4B","../../common/Form":"4Mui7","../../common/Wrapper":"8oy7r","../../alarms/Table/Alarms":"6zAIJ","../../geo/Map":"ihRJn","./Availability":"50hhX","./Graph":"fsrcu","../../common/Link":"l3o6V","../../../store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6zAIJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _dateFns = require("date-fns");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _tab = require("@mui/material/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabs = require("@mui/material/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _actionMenu = require("../../common/Table/ActionMenu");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _table = require("../../common/Table");
var _link = require("../../common/Link");
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _utils = require("../../../utils");
var _alarmsActions = require("../../../redux/actions/alarmsActions");
var _helpers = require("common/api/v1/helpers");
const styles = {
    container: {
        width: '100%',
        borderBottom: (theme)=>`1px solid ${theme.palette.divider}`
    },
    noValue: {
        padding: (theme)=>theme.spacing(2)
    }
};
const BADGE_SIZE = 1.4;
const tabStyles = {
    tab: {
        minWidth: 'auto',
        padding: (theme)=>theme.spacing(1)
    },
    full: {
        opacity: 1
    },
    badge: {
        display: 'inline-block',
        padding: `0 ${BADGE_SIZE / 3}rem`,
        margin: (theme)=>theme.spacing(0, 1),
        minWidth: `${BADGE_SIZE}rem`,
        height: `${BADGE_SIZE}rem`,
        lineHeight: BADGE_SIZE * 1.2,
        borderRadius: `${BADGE_SIZE / 2}rem`,
        color: (theme)=>theme.palette.grey[900]
    }
};
const badgeColor = {
    [(0, _types.AlarmSeverityLevels).critical]: (theme)=>theme.palette.error.main,
    [(0, _types.AlarmSeverityLevels).major]: (theme)=>theme.palette.warning.main,
    [(0, _types.AlarmSeverityLevels).minor]: (theme)=>theme.palette.success.dark,
    [(0, _types.AlarmSeverityLevels).warning]: (theme)=>theme.palette.primary.light
};
const getTabProps = ({ alarms, type, isCriticalAmount })=>{
    const amount = alarms[type].length;
    return {
        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                (amount || isCriticalAmount) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: {
                        ...tabStyles.badge,
                        background: badgeColor[type]
                    },
                    children: isCriticalAmount ? '!!!' : amount
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: type
                })
            ]
        }),
        sx: amount ? {
            ...tabStyles.tab,
            ...tabStyles.full
        } : tabStyles.tab,
        value: type
    };
};
const getAlarmTime = (alarm)=>new Date(alarm.time);
const MOST_SEVERE_LEVEL = (0, _types.AlarmSeverityLevels).critical;
const Alarms = ({ showTexts, size = 'medium', showClearButton })=>{
    const routes = (0, _store.useRoutes)();
    const levels = Object.keys((0, _types.AlarmSeverityLevels));
    const { alarms, loading, mostSevereLevel } = (0, _utils.usePageParamsFilteredSelector)((params)=>{
        // Delete alarmTab since it isn't sent to the backend and causes unnecessary requests on each tab change otherwise
        const alarmsSelector = (0, _utils.useAlarmsSelector)({
            ...params,
            alarmTab: undefined
        }) // eslint-disable-line react-hooks/rules-of-hooks
        ;
        const alarms = alarmsSelector.alarms.reduce((acc, item)=>{
            const severity = item.alarmSeverity;
            if (severity === (0, _types.VaAlarmOwnSeverityLevels).cleared) return acc;
            return {
                ...acc,
                [severity]: [
                    ...acc[severity],
                    item
                ]
            };
        }, {
            [(0, _types.AlarmSeverityLevels).critical]: [],
            [(0, _types.AlarmSeverityLevels).major]: [],
            [(0, _types.AlarmSeverityLevels).minor]: [],
            [(0, _types.AlarmSeverityLevels).warning]: []
        });
        const mostSevereLevel = levels.find((level)=>alarms[level].length > 0) ?? MOST_SEVERE_LEVEL;
        return {
            alarms,
            loading: alarmsSelector.loading,
            mostSevereLevel
        };
    });
    const isCriticalAmount = (0, _reactRedux.useSelector)(({ alarmsReducer })=>alarmsReducer.isCriticalAmount, (0, _reactRedux.shallowEqual));
    const [tab, setTab] = (0, _react.useState)(undefined);
    const dispatch = (0, _reactRedux.useDispatch)();
    const [params, setPageParams] = (0, _utils.usePageParams)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _alarmsActions.readAlarmsInBackground)({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, _react.useEffect)(()=>{
        setPageParams({
            alarmTab: tab
        });
    }, [
        tab
    ]);
    (0, _react.useEffect)(()=>{
        setTab(mostSevereLevel);
    }, [
        mostSevereLevel
    ]);
    (0, _utils.useIntervalNoInitial)(async ()=>{
        dispatch((0, _alarmsActions.getAlarms)({
            ...params,
            silent: true
        }));
    }, 10000);
    const effectiveTab = tab ?? MOST_SEVERE_LEVEL;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsDefault.default), {
                value: effectiveTab,
                variant: "fullWidth",
                onChange: (_, val)=>{
                    setTab(val);
                },
                sx: styles.container,
                textColor: "inherit",
                children: levels.map((level)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                        "data-test-id": `tab-${level}`,
                        ...getTabProps({
                            alarms,
                            isCriticalAmount,
                            type: level
                        })
                    }, `tab-${level}`))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                pending: loading,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                    id: "alarms",
                    emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        container: true,
                        justifyContent: "space-around",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                sx: styles.noValue,
                                color: "textSecondary",
                                children: isCriticalAmount ? 'The amount of alarms is too large, only recent ones are fetched' : `No ${effectiveTab} alarms.`
                            })
                        })
                    }),
                    data: alarms[effectiveTab],
                    getCustomEntityId: (alarm)=>`${alarm.alarmId}-${alarm.applianceId}`,
                    isSmall: size === 'small',
                    config: [
                        {
                            title: 'Time ago',
                            getValue: (alarm)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                    "data-test-id": "time-raw",
                                    title: (0, _dateFns.format)(new Date(getAlarmTime(alarm)), (0, _helpers.DATE_FORMAT_LONG)),
                                    placement: "top",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        color: "textPrimary",
                                        variant: "body2",
                                        children: (0, _dateFns.formatDistanceToNow)(getAlarmTime(alarm))
                                    })
                                }),
                            headerProps: {
                                sx: {
                                    whiteSpace: 'nowrap'
                                }
                            },
                            sorting: {
                                byParameter: (0, _types.ListAlarmSortableField).time
                            }
                        },
                        {
                            title: 'Appliance',
                            getValue: ({ applianceId, applianceName })=>{
                                if (applianceId) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                    underline: "hover",
                                    to: routes.appliancesUpdate({
                                        id: applianceId
                                    }),
                                    children: applianceName
                                });
                            },
                            sorting: {
                                byParameter: (0, _types.ListAlarmSortableField).applianceName
                            }
                        },
                        {
                            title: 'Alarm',
                            getValue: ({ alarmCause })=>alarmCause,
                            sorting: {
                                byParameter: (0, _types.ListAlarmSortableField).alarmCause
                            }
                        },
                        showTexts ? {
                            title: 'Message',
                            getValue: ({ text, object, objectName, repeatCount })=>{
                                const isVALicenseAlarm = !!object?.startsWith('.license');
                                const textDetails = isVALicenseAlarm ? ` - ${objectName}` : '';
                                const repeatText = repeatCount > 0 ? ` (repeated ${repeatCount} times)` : '';
                                return `${text}${textDetails}${repeatText}`;
                            },
                            sorting: {
                                byParameter: (0, _types.ListAlarmSortableField).text
                            }
                        } : null,
                        {
                            title: 'Entity',
                            getValue: ({ _input, _output, applianceId, applianceName, alarmCause, objectName })=>{
                                if (_input) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                    underline: "hover",
                                    to: routes.service({
                                        id: _input.id
                                    }),
                                    children: `input "${_input.name}"`
                                });
                                if (_output) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                    underline: "hover",
                                    to: _output.input ? routes.service({
                                        id: _output.input,
                                        outputId: _output.id
                                    }) : routes.outputsUpdate({
                                        id: _output.id
                                    }),
                                    children: `output "${_output.name}"`
                                });
                                if (applianceId) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                    underline: "hover",
                                    to: routes.appliancesUpdate({
                                        id: applianceId
                                    }),
                                    children: `appliance "${applianceName}"`
                                });
                                if (alarmCause === (0, _types.AlarmCause).BACKUP_JOB_FAILED) return `job "${objectName}"`;
                                return '';
                            }
                        },
                        {
                            title: '',
                            getValue: (row)=>showClearButton ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                                    options: [
                                        {
                                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                                            label: 'Clear',
                                            isDestructive: true,
                                            onClick: ()=>{
                                                dispatch((0, _alarmsActions.clearAlarm)({
                                                    alarmId: row.alarmId
                                                }));
                                            }
                                        }
                                    ]
                                }) : null
                        }
                    ]
                })
            })
        ]
    });
};
exports.default = Alarms;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","date-fns":"gelMX","@mui/material/Box":"c4QkF","@mui/material/Grid":"6iX4B","@mui/material/Tab":"aDY3J","@mui/material/Tabs":"26Co6","../../common/Tooltip":"crjvg","@mui/material/Typography":"6NtGx","@mui/icons-material/Delete":"69aC7","../../common/Table/ActionMenu":"jf6As","../../common/Pendable":"gDN67","../../common/Table":"dt9lf","../../common/Link":"l3o6V","common/api/v1/types":"3qemx","../../../store":"5LXiG","../../../utils":"342UB","../../../redux/actions/alarmsActions":"2PZQF","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDY3J":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("8c2d1d184a02f331").default;
var _interopRequireDefault = require("fa825ba338a19b49").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tabClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Tab.default;
    }
});
Object.defineProperty(exports, "tabClasses", {
    enumerable: true,
    get: function() {
        return _tabClasses.default;
    }
});
var _Tab = _interopRequireDefault(require("cc4d92f602aed1a2"));
var _tabClasses = _interopRequireWildcard(require("251397d34051d62"));
Object.keys(_tabClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tabClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tabClasses[key];
        }
    });
});

},{"8c2d1d184a02f331":"fiRIh","fa825ba338a19b49":"kZ6eK","cc4d92f602aed1a2":"AbeB1","251397d34051d62":"iuGsn"}],"AbeB1":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("373f240c3ccf1fad").default;
var _interopRequireWildcard = require("d97f28fffbb8531d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("92e6fd03480561c9"));
var _propTypes = _interopRequireDefault(require("247bb76493b1f22"));
var _clsx = _interopRequireDefault(require("aabbd333313907e5"));
var _composeClasses = _interopRequireDefault(require("3be9bebcc122416e"));
var _ButtonBase = _interopRequireDefault(require("471a5d74a17dde4a"));
var _capitalize = _interopRequireDefault(require("846272c25e5c8c0e"));
var _zeroStyled = require("520503552d9224b1");
var _memoTheme = _interopRequireDefault(require("c5919239562caa90"));
var _DefaultPropsProvider = require("50f4161a6d64c");
var _unsupportedProp = _interopRequireDefault(require("be671635436a153f"));
var _tabClasses = _interopRequireWildcard(require("d9a0f886e2f3a751"));
var _jsxRuntime = require("9257197833960ac5");
const useUtilityClasses = (ownerState)=>{
    const { classes, textColor, fullWidth, wrapped, icon, label, selected, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, _capitalize.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, _composeClasses.default)(slots, _tabClasses.getTabUtilityClass, classes);
};
const TabRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, _capitalize.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${_tabClasses.default.iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${_tabClasses.default.icon}`]: styles.icon
            }
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState, iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${_tabClasses.default.icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState, iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${_tabClasses.default.icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState, iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${_tabClasses.default.icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState, iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${_tabClasses.default.icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${_tabClasses.default.selected}`]: {
                        opacity: 1
                    },
                    [`&.${_tabClasses.default.disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${_tabClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${_tabClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${_tabClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${_tabClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const Tab = /*#__PURE__*/ React.forwardRef(function Tab(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className, disabled = false, disableFocusRipple = false, // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition = 'top', // eslint-disable-next-line react/prop-types
    indicator, label, onChange, onClick, onFocus, // eslint-disable-next-line react/prop-types
    selected, // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value, wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled,
        disableFocusRipple,
        selected,
        icon: !!iconProp,
        iconPosition,
        label: !!label,
        fullWidth,
        textColor,
        wrapped
    };
    const classes = useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ React.isValidElement(iconProp) ? /*#__PURE__*/ React.cloneElement(iconProp, {
        className: (0, _clsx.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var _default = exports.default = Tab;

},{"373f240c3ccf1fad":"kZ6eK","d97f28fffbb8531d":"fiRIh","92e6fd03480561c9":"9njXz","247bb76493b1f22":"bnNSm","aabbd333313907e5":"d2NWs","3be9bebcc122416e":"59Equ","471a5d74a17dde4a":"7X8rf","846272c25e5c8c0e":"eOYSA","520503552d9224b1":"hZXDo","c5919239562caa90":"cJNjb","50f4161a6d64c":"9bD8g","be671635436a153f":"4ygWT","d9a0f886e2f3a751":"iuGsn","9257197833960ac5":"1dlk8"}],"iuGsn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2b33dfb766af788").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTabUtilityClass = getTabUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("84b1f900400f40ba"));
var _generateUtilityClass = _interopRequireDefault(require("1af93708371ba7e1"));
function getTabUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTab', slot);
}
const tabClasses = (0, _generateUtilityClasses.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var _default = exports.default = tabClasses;

},{"2b33dfb766af788":"kZ6eK","84b1f900400f40ba":"7pSUk","1af93708371ba7e1":"jBs9M"}],"26Co6":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("6b3fb79682a82934").default;
var _interopRequireDefault = require("175fa7681ddf3e1b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tabsClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Tabs.default;
    }
});
Object.defineProperty(exports, "tabsClasses", {
    enumerable: true,
    get: function() {
        return _tabsClasses.default;
    }
});
var _Tabs = _interopRequireDefault(require("9bb040f1fb22ea0f"));
var _tabsClasses = _interopRequireWildcard(require("c5a182cdf24ad731"));
Object.keys(_tabsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tabsClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tabsClasses[key];
        }
    });
});

},{"6b3fb79682a82934":"fiRIh","175fa7681ddf3e1b":"kZ6eK","9bb040f1fb22ea0f":"96VKV","c5a182cdf24ad731":"9OMSx"}],"96VKV":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("63e9b6f0c527f837").default;
var _interopRequireWildcard = require("61c8dacbe1581a5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("4924cecc6fc865c2"));
var _reactIs = require("62fb87101eb1135");
var _propTypes = _interopRequireDefault(require("bef6b3da6fad73f7"));
var _clsx = _interopRequireDefault(require("1d83f1c29114723b"));
var _refType = _interopRequireDefault(require("79eee4f7855beecb"));
var _composeClasses = _interopRequireDefault(require("b81e50cbc84068c2"));
var _RtlProvider = require("8e3a21b3fb070aa5");
var _useSlotProps = _interopRequireDefault(require("f7d5580011e3ecb0"));
var _zeroStyled = require("e1a3e25340521d21");
var _memoTheme = _interopRequireDefault(require("93d22bfcc36141b5"));
var _DefaultPropsProvider = require("b35c5c19632275fc");
var _debounce = _interopRequireDefault(require("7af558e48fea4b78"));
var _animate = _interopRequireDefault(require("71f24e7bafab09bb"));
var _ScrollbarSize = _interopRequireDefault(require("3378c6190a21bd79"));
var _TabScrollButton = _interopRequireDefault(require("4d07cde34678293e"));
var _useEventCallback = _interopRequireDefault(require("1d1860fcbf6120bf"));
var _tabsClasses = _interopRequireWildcard(require("24cdefa5d17446da"));
var _ownerDocument = _interopRequireDefault(require("6a2ea3031e0e1748"));
var _ownerWindow = _interopRequireDefault(require("a0650e9d6cba51aa"));
var _useSlot = _interopRequireDefault(require("16ff0a2eaa11442e"));
var _jsxRuntime = require("216c3365c1bc9028");
const nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const useUtilityClasses = (ownerState)=>{
    const { vertical, fixed, hideScrollbar, scrollableX, scrollableY, centered, scrollButtonsHideMobile, classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, _composeClasses.default)(slots, _tabsClasses.getTabsUtilityClass, classes);
};
const TabsRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_tabsClasses.default.scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${_tabsClasses.default.scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${_tabsClasses.default.scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const TabsScroller = (0, _zeroStyled.styled)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const List = (0, _zeroStyled.styled)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const TabsIndicator = (0, _zeroStyled.styled)('span', {
    name: 'MuiTabs',
    slot: 'Indicator'
})((0, _memoTheme.default)(({ theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const TabsScrollbarSize = (0, _zeroStyled.styled)(_ScrollbarSize.default)({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const defaultIndicatorStyle = {};
let warnedOnceTabPresent = false;
const Tabs = /*#__PURE__*/ React.forwardRef(function Tabs(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, _zeroStyled.useTheme)();
    const isRtl = (0, _RtlProvider.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action, centered = false, children: childrenProp, className, component = 'div', allowScrollButtonsMobile = false, indicatorColor = 'primary', onChange, orientation = 'horizontal', ScrollButtonComponent, // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus, slots = {}, slotProps = {}, TabIndicatorProps = {}, // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value, variant = 'standard', visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component,
        allowScrollButtonsMobile,
        indicatorColor,
        orientation,
        vertical,
        scrollButtons,
        textColor,
        variant,
        visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, _useSlotProps.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState
    });
    const endScrollButtonIconProps = (0, _useSlotProps.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState
    });
    const [mounted, setMounted] = React.useState(false);
    const [indicatorStyle, setIndicatorStyle] = React.useState(defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = React.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = React.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = React.useState(false);
    const [scrollerStyle, setScrollerStyle] = React.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = React.useRef(null);
    const tabListRef = React.useRef(null);
    const externalForwardedProps = {
        slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButton: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta,
            tabMeta
        };
    };
    const updateIndicatorState = (0, _useEventCallback.default)(()=>{
        const { tabsMeta, tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation = true } = {})=>{
        if (animation) (0, _animate.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, _useSlot.default)('scrollbar', {
        className: (0, _clsx.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps,
        ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = React.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, _useSlot.default)('scrollButtons', {
        className: (0, _clsx.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: _TabScrollButton.default,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, _useEventCallback.default)((animation)=>{
        const { tabsMeta, tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation
            });
        }
    });
    const updateScrollButtonState = (0, _useEventCallback.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    React.useEffect(()=>{
        const handleResize = (0, _debounce.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, _ownerWindow.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ React.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    React.useEffect(()=>{
        setMounted(true);
    }, []);
    React.useEffect(()=>{
        updateIndicatorState();
    });
    React.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView(defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    React.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, _useSlot.default)('indicator', {
        className: (0, _clsx.default)(classes.indicator, TabIndicatorProps.className),
        elementType: TabsIndicator,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, _jsxRuntime.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = React.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ React.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected,
            selectionFollowsFocus,
            onChange,
            textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, _ownerDocument.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                moveFocus(list, currentFocus, previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                moveFocus(list, currentFocus, nextItem);
                break;
            case 'Home':
                event.preventDefault();
                moveFocus(list, null, nextItem);
                break;
            case 'End':
                event.preventDefault();
                moveFocus(list, null, previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        ref,
        className: (0, _clsx.default)(classes.root, className),
        elementType: TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component
        },
        ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, _useSlot.default)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: TabsScroller,
        externalForwardedProps,
        ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, _useSlot.default)('list', {
        ref: tabListRef,
        className: (0, _clsx.default)(classes.list, classes.flexContainer),
        elementType: List,
        externalForwardedProps,
        ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var _default = exports.default = Tabs;

},{"63e9b6f0c527f837":"kZ6eK","61c8dacbe1581a5":"fiRIh","4924cecc6fc865c2":"9njXz","62fb87101eb1135":"bmrco","bef6b3da6fad73f7":"bnNSm","1d83f1c29114723b":"d2NWs","79eee4f7855beecb":"3TBXN","b81e50cbc84068c2":"59Equ","8e3a21b3fb070aa5":"ck9Pb","f7d5580011e3ecb0":"kr4RG","e1a3e25340521d21":"hZXDo","93d22bfcc36141b5":"cJNjb","b35c5c19632275fc":"9bD8g","7af558e48fea4b78":"bjUwl","71f24e7bafab09bb":"kyXs2","3378c6190a21bd79":"fDE4k","4d07cde34678293e":"5YxFA","1d1860fcbf6120bf":"9mQKD","24cdefa5d17446da":"9OMSx","6a2ea3031e0e1748":"1juJZ","a0650e9d6cba51aa":"lHNEW","16ff0a2eaa11442e":"h76AU","216c3365c1bc9028":"1dlk8"}],"kyXs2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = animate;
function easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function animate(property, element, to, options = {}, cb = ()=>{}) {
    const { ease = easeInOutSin, duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

},{}],"fDE4k":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5ea527d12d8eed7").default;
var _interopRequireWildcard = require("797dd22b8ac81160").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ScrollbarSize;
var React = _interopRequireWildcard(require("7b3668c96df5e39f"));
var _propTypes = _interopRequireDefault(require("53a05a8cad05bb71"));
var _debounce = _interopRequireDefault(require("97e1f05307564aa0"));
var _utils = require("62bad1120d85d844");
var _jsxRuntime = require("15ad3c195736ffc0");
const styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */ function ScrollbarSize(props) {
    const { onChange, ...other } = props;
    const scrollbarHeight = React.useRef();
    const nodeRef = React.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const handleResize = (0, _debounce.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, _utils.ownerWindow)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    React.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles,
        ...other,
        ref: nodeRef
    });
}

},{"5ea527d12d8eed7":"kZ6eK","797dd22b8ac81160":"fiRIh","7b3668c96df5e39f":"9njXz","53a05a8cad05bb71":"bnNSm","97e1f05307564aa0":"bjUwl","62bad1120d85d844":"dEMJk","15ad3c195736ffc0":"1dlk8"}],"5YxFA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("686b2ef1e0ff67d8").default;
var _interopRequireDefault = require("fa6c127ec7b14c61").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tabScrollButtonClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TabScrollButton.default;
    }
});
Object.defineProperty(exports, "tabScrollButtonClasses", {
    enumerable: true,
    get: function() {
        return _tabScrollButtonClasses.default;
    }
});
var _TabScrollButton = _interopRequireDefault(require("2c2fcf9ab1784ff8"));
var _tabScrollButtonClasses = _interopRequireWildcard(require("d0cbcf9699f84536"));
Object.keys(_tabScrollButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tabScrollButtonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tabScrollButtonClasses[key];
        }
    });
});

},{"686b2ef1e0ff67d8":"fiRIh","fa6c127ec7b14c61":"kZ6eK","2c2fcf9ab1784ff8":"iS5Y5","d0cbcf9699f84536":"gOH24"}],"iS5Y5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
/* eslint-disable jsx-a11y/aria-role */ var _interopRequireDefault = require("b769b62893414eb2").default;
var _interopRequireWildcard = require("86e689fbb233bf9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("4c5a531125256f72"));
var _propTypes = _interopRequireDefault(require("9a068da2c25f3824"));
var _clsx = _interopRequireDefault(require("44f7ce8243051e26"));
var _composeClasses = _interopRequireDefault(require("64e04b9eadebe1c6"));
var _RtlProvider = require("9bb45a6fa5337435");
var _useSlotProps = _interopRequireDefault(require("6c7755cfd4fff135"));
var _KeyboardArrowLeft = _interopRequireDefault(require("569e3da0c90aec4f"));
var _KeyboardArrowRight = _interopRequireDefault(require("aa54904493925e4b"));
var _ButtonBase = _interopRequireDefault(require("f788f450f7cd302d"));
var _zeroStyled = require("4474c4f9eb4a921d");
var _DefaultPropsProvider = require("85c1268bf556a7b");
var _tabScrollButtonClasses = _interopRequireWildcard(require("9634d2096775ee38"));
var _jsxRuntime = require("455c46f917084abf");
const useUtilityClasses = (ownerState)=>{
    const { classes, orientation, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, _composeClasses.default)(slots, _tabScrollButtonClasses.getTabScrollButtonUtilityClass, classes);
};
const TabScrollButtonRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${_tabScrollButtonClasses.default.disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const TabScrollButton = /*#__PURE__*/ React.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className, slots = {}, slotProps = {}, direction, orientation, disabled, ...other } = props;
    const isRtl = (0, _RtlProvider.useRtl)();
    const ownerState = {
        isRtl,
        ...props
    };
    const classes = useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? _KeyboardArrowLeft.default;
    const EndButtonIcon = slots.EndScrollButtonIcon ?? _KeyboardArrowRight.default;
    const startButtonIconProps = (0, _useSlotProps.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState
    });
    const endButtonIconProps = (0, _useSlotProps.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabScrollButtonRoot, {
        component: "div",
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var _default = exports.default = TabScrollButton;

},{"b769b62893414eb2":"kZ6eK","86e689fbb233bf9":"fiRIh","4c5a531125256f72":"9njXz","9a068da2c25f3824":"bnNSm","44f7ce8243051e26":"d2NWs","64e04b9eadebe1c6":"59Equ","9bb45a6fa5337435":"ck9Pb","6c7755cfd4fff135":"kr4RG","569e3da0c90aec4f":"8gWQf","aa54904493925e4b":"l1RBC","f788f450f7cd302d":"7X8rf","4474c4f9eb4a921d":"hZXDo","85c1268bf556a7b":"9bD8g","9634d2096775ee38":"gOH24","455c46f917084abf":"1dlk8"}],"8gWQf":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("fe7a4d56351101a9").default;
var _interopRequireWildcard = require("de75ae30bed1ddd0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("939689c6d4bd6c66"));
var _createSvgIcon = _interopRequireDefault(require("e795ba8a042eebaf"));
var _jsxRuntime = require("fd882e7710c5e3b0");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

},{"fe7a4d56351101a9":"kZ6eK","de75ae30bed1ddd0":"fiRIh","939689c6d4bd6c66":"9njXz","e795ba8a042eebaf":"5sni0","fd882e7710c5e3b0":"1dlk8"}],"l1RBC":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("83e18ba6880834fe").default;
var _interopRequireWildcard = require("f1359458ac8c1521").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("4d4a9779ca88f806"));
var _createSvgIcon = _interopRequireDefault(require("a3204c4f253bfdcd"));
var _jsxRuntime = require("498e2bce972a8138");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

},{"83e18ba6880834fe":"kZ6eK","f1359458ac8c1521":"fiRIh","4d4a9779ca88f806":"9njXz","a3204c4f253bfdcd":"5sni0","498e2bce972a8138":"1dlk8"}],"gOH24":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f9cb49d429276ce4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTabScrollButtonUtilityClass = getTabScrollButtonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("d0678a695bafbf2c"));
var _generateUtilityClass = _interopRequireDefault(require("6bad986d7d10381a"));
function getTabScrollButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTabScrollButton', slot);
}
const tabScrollButtonClasses = (0, _generateUtilityClasses.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var _default = exports.default = tabScrollButtonClasses;

},{"f9cb49d429276ce4":"kZ6eK","d0678a695bafbf2c":"7pSUk","6bad986d7d10381a":"jBs9M"}],"9OMSx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1212bf35ebbb143").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTabsUtilityClass = getTabsUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("6b895bb882dd367"));
var _generateUtilityClass = _interopRequireDefault(require("2892571379a3ec7f"));
function getTabsUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTabs', slot);
}
const tabsClasses = (0, _generateUtilityClasses.default)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var _default = exports.default = tabsClasses;

},{"1212bf35ebbb143":"kZ6eK","6b895bb882dd367":"7pSUk","2892571379a3ec7f":"jBs9M"}],"ihRJn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MapDataType", ()=>MapDataType);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactMapGl = require("react-map-gl");
var _reactMapGlDefault = parcelHelpers.interopDefault(_reactMapGl);
var _mapboxGlCss = require("mapbox-gl/dist/mapbox-gl.css");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("@mui/material/styles");
var _env = require("../../../env");
var _appliances = require("./Appliances/Appliances");
var _appliancesDefault = parcelHelpers.interopDefault(_appliances);
const styles = {
    container: {
        width: '100%',
        height: '50vh',
        maxHeight: '700px',
        '& a': {
            color: (theme)=>theme.palette.background.default,
            '&:hover': {
                color: (theme)=>theme.palette.background.paper
            }
        }
    }
};
const StyledPopup = (0, _styles.styled)((0, _reactMapGl.Popup))(({ theme })=>({
        '& .mapboxgl-popup-content': {
            background: theme.palette.grey[800],
            color: theme.palette.text.primary,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[2],
            maxHeight: '40vh',
            maxWidth: '50vh',
            overflow: 'auto',
            padding: (theme)=>theme.spacing(2)
        },
        '& .mapboxgl-popup-tip': {
            borderTopColor: theme.palette.grey[800]
        }
    }));
var MapDataType = /*#__PURE__*/ function(MapDataType) {
    MapDataType["services"] = "services";
    MapDataType["appliances"] = "appliances";
    return MapDataType;
}({});
/**
 * Mapbox container
 * @param sideMargin - needed to avoid having padding (left, right & bottom) on parent Paper
 * @param dataType - do we show appliances only or the whole services
 */ const Map = ({ dataType = "services" })=>{
    const featureEvents = (0, _react.useRef)({
        appliances: new EventTarget()
    });
    const [interactiveLayerIds, setInteractiveLayerIds] = (0, _react.useState)([]);
    const [popup, setPopup] = (0, _react.useState)(undefined);
    const [currentHoverFeature, setCurrentHoverFeature] = (0, _react.useState)(undefined);
    const initialViewState = {
        latitude: 59.359010042385975,
        longitude: 17.980828484893433,
        zoom: 2
    };
    const [cursor, setCursor] = (0, _react.useState)('grab');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: styles.container,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactMapGlDefault.default), {
            mapboxAccessToken: (0, _env.MAPBOX_TOKEN // nimbra-edge-dev token from .env unless MAPBOX_TOKEN is set (which in the pipeline is set to nimbra-edge-production
            ),
            initialViewState: initialViewState,
            cursor: cursor,
            minZoom: 0.5,
            maxZoom: 10,
            style: {
                width: '100%',
                height: '100%'
            },
            mapStyle: "mapbox://styles/netinsight/ck9sgm2mi0ryl1ipff3wfxmhl",
            interactiveLayerIds: interactiveLayerIds,
            onLoad: ()=>setInteractiveLayerIds([
                    'appliances'
                ]),
            onClick: (e)=>{
                const feature = e?.features?.[0];
                if (feature?.properties) featureEvents.current.appliances.dispatchEvent(new CustomEvent('onClick', {
                    detail: feature.properties.id
                }));
                else setPopup(undefined);
            },
            onMouseMove: (e)=>{
                const feature = e?.features?.[0];
                if (feature?.properties) {
                    featureEvents.current.appliances.dispatchEvent(new CustomEvent('onMouseEnter', {
                        detail: feature.properties.id
                    }));
                    setCurrentHoverFeature(feature.properties.id);
                    setCursor('pointer');
                } else if (currentHoverFeature !== undefined) {
                    featureEvents.current.appliances.dispatchEvent(new CustomEvent('onMouseLeave', {
                        detail: currentHoverFeature
                    }));
                    setCurrentHoverFeature(undefined);
                    setCursor('grab');
                }
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactMapGl.NavigationControl), {
                        position: "top-left",
                        showCompass: false
                    }),
                    dataType === "appliances" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appliancesDefault.default), {
                        layerId: "appliances",
                        setPopup: setPopup,
                        featureEvents: featureEvents.current
                    }),
                    !!popup && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPopup, {
                        onClose: ()=>setPopup(undefined),
                        latitude: popup.coordinates[0],
                        longitude: popup.coordinates[1],
                        anchor: "bottom",
                        children: popup.content
                    })
                ]
            })
        })
    });
};
exports.default = Map;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-map-gl":"7lAS3","mapbox-gl/dist/mapbox-gl.css":"2LGap","@mui/material/Box":"c4QkF","@mui/material/styles":"2UrBk","../../../env":"cPu8n","./Appliances/Appliances":"fxsJk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7lAS3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _mapDefault.default));
parcelHelpers.export(exports, "Map", ()=>(0, _mapDefault.default));
parcelHelpers.export(exports, "Marker", ()=>(0, _markerDefault.default));
parcelHelpers.export(exports, "Popup", ()=>(0, _popupDefault.default));
parcelHelpers.export(exports, "AttributionControl", ()=>(0, _attributionControlDefault.default));
parcelHelpers.export(exports, "FullscreenControl", ()=>(0, _fullscreenControlDefault.default));
parcelHelpers.export(exports, "GeolocateControl", ()=>(0, _geolocateControlDefault.default));
parcelHelpers.export(exports, "NavigationControl", ()=>(0, _navigationControlDefault.default));
parcelHelpers.export(exports, "ScaleControl", ()=>(0, _scaleControlDefault.default));
parcelHelpers.export(exports, "Source", ()=>(0, _sourceDefault.default));
parcelHelpers.export(exports, "Layer", ()=>(0, _layerDefault.default));
parcelHelpers.export(exports, "useControl", ()=>(0, _useControlDefault.default));
parcelHelpers.export(exports, "MapProvider", ()=>(0, _useMap.MapProvider));
parcelHelpers.export(exports, "useMap", ()=>(0, _useMap.useMap));
var _map = require("./components/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _marker = require("./components/marker");
var _markerDefault = parcelHelpers.interopDefault(_marker);
var _popup = require("./components/popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _attributionControl = require("./components/attribution-control");
var _attributionControlDefault = parcelHelpers.interopDefault(_attributionControl);
var _fullscreenControl = require("./components/fullscreen-control");
var _fullscreenControlDefault = parcelHelpers.interopDefault(_fullscreenControl);
var _geolocateControl = require("./components/geolocate-control");
var _geolocateControlDefault = parcelHelpers.interopDefault(_geolocateControl);
var _navigationControl = require("./components/navigation-control");
var _navigationControlDefault = parcelHelpers.interopDefault(_navigationControl);
var _scaleControl = require("./components/scale-control");
var _scaleControlDefault = parcelHelpers.interopDefault(_scaleControl);
var _source = require("./components/source");
var _sourceDefault = parcelHelpers.interopDefault(_source);
var _layer = require("./components/layer");
var _layerDefault = parcelHelpers.interopDefault(_layer);
var _useControl = require("./components/use-control");
var _useControlDefault = parcelHelpers.interopDefault(_useControl);
var _useMap = require("./components/use-map");
// Types
var _external = require("./types/external");
parcelHelpers.exportAll(_external, exports);

},{"./components/map":"2j6lb","./components/marker":"iTmCB","./components/popup":"2ZYPY","./components/attribution-control":"6QiHQ","./components/fullscreen-control":"eJOIz","./components/geolocate-control":"1fQDx","./components/navigation-control":"cEfVz","./components/scale-control":"cj2wl","./components/source":"kF3ds","./components/layer":"3G3Ij","./components/use-control":"7XL0s","./components/use-map":"lmqzZ","./types/external":"fFxhw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2j6lb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MapContext", ()=>MapContext);
var _react = require("react");
var _useMap = require("./use-map");
var _mapbox = require("../mapbox/mapbox");
var _mapboxDefault = parcelHelpers.interopDefault(_mapbox);
var _createRef = require("../mapbox/create-ref");
var _createRefDefault = parcelHelpers.interopDefault(_createRef);
var _useIsomorphicLayoutEffect = require("../utils/use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _setGlobals = require("../utils/set-globals");
var _setGlobalsDefault = parcelHelpers.interopDefault(_setGlobals);
const MapContext = _react.createContext(null);
const defaultProps = {
    // Constraints
    minZoom: 0,
    maxZoom: 22,
    minPitch: 0,
    maxPitch: 60,
    // Interaction handlers
    scrollZoom: true,
    boxZoom: true,
    dragRotate: true,
    dragPan: true,
    keyboard: true,
    doubleClickZoom: true,
    touchZoomRotate: true,
    touchPitch: true,
    // Style
    mapStyle: {
        version: 8,
        sources: {},
        layers: []
    },
    styleDiffing: true,
    projection: 'mercator',
    renderWorldCopies: true,
    // Callbacks
    onError: (e)=>console.error(e.error),
    // Globals
    RTLTextPlugin: 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js'
};
const Map = (0, _react.forwardRef)((props, ref)=>{
    const mountedMapsContext = (0, _react.useContext)((0, _useMap.MountedMapsContext));
    const [mapInstance, setMapInstance] = (0, _react.useState)(null);
    const containerRef = (0, _react.useRef)();
    const { current: contextValue } = (0, _react.useRef)({
        mapLib: null,
        map: null
    });
    (0, _react.useEffect)(()=>{
        const mapLib = props.mapLib;
        let isMounted = true;
        let mapbox;
        Promise.resolve(mapLib || require("509c4b9f8d3ba65e")).then((mapboxgl)=>{
            if (!isMounted) return;
            if (!mapboxgl.Map) // commonjs style
            mapboxgl = mapboxgl.default;
            if (!mapboxgl || !mapboxgl.Map) throw new Error('Invalid mapLib');
            if (mapboxgl.supported(props)) {
                (0, _setGlobalsDefault.default)(mapboxgl, props);
                if (props.reuseMaps) mapbox = (0, _mapboxDefault.default).reuse(props, containerRef.current);
                if (!mapbox) mapbox = new (0, _mapboxDefault.default)(mapboxgl.Map, props, containerRef.current);
                contextValue.map = (0, _createRefDefault.default)(mapbox, mapboxgl);
                contextValue.mapLib = mapboxgl;
                setMapInstance(mapbox);
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapMount(contextValue.map, props.id);
            } else throw new Error('Map is not supported by this browser');
        }).catch((error)=>{
            props.onError({
                type: 'error',
                target: null,
                originalEvent: null,
                error
            });
        });
        return ()=>{
            isMounted = false;
            if (mapbox) {
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapUnmount(props.id);
                if (props.reuseMaps) mapbox.recycle();
                else mapbox.destroy();
            }
        };
    }, []);
    (0, _useIsomorphicLayoutEffectDefault.default)(()=>{
        if (mapInstance) mapInstance.setProps(props);
    });
    (0, _react.useImperativeHandle)(ref, ()=>contextValue.map, [
        mapInstance
    ]);
    const style = (0, _react.useMemo)(()=>({
            position: 'relative',
            width: '100%',
            height: '100%',
            ...props.style
        }), [
        props.style
    ]);
    return _react.createElement("div", {
        id: props.id,
        ref: containerRef,
        style: style
    }, mapInstance && _react.createElement(MapContext.Provider, {
        value: contextValue
    }, _react.createElement("div", {
        "mapboxgl-children": ""
    }, props.children)));
});
Map.displayName = 'Map';
Map.defaultProps = defaultProps;
exports.default = Map;

},{"react":"9njXz","./use-map":"lmqzZ","../mapbox/mapbox":"84Qjj","../mapbox/create-ref":"5YY6n","../utils/use-isomorphic-layout-effect":"a7ESq","../utils/set-globals":"8XQ20","509c4b9f8d3ba65e":"hFFkp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lmqzZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MountedMapsContext", ()=>MountedMapsContext);
parcelHelpers.export(exports, "MapProvider", ()=>MapProvider);
parcelHelpers.export(exports, "useMap", ()=>useMap);
var _react = require("react");
var _map = require("./map");
const MountedMapsContext = _react.createContext(null);
const MapProvider = (props)=>{
    const [maps, setMaps] = (0, _react.useState)({});
    const onMapMount = (0, _react.useCallback)((map, id = 'default')=>{
        setMaps((currMaps)=>{
            if (id === 'current') throw new Error("'current' cannot be used as map id");
            if (currMaps[id]) throw new Error(`Multiple maps with the same id: ${id}`);
            return {
                ...currMaps,
                [id]: map
            };
        });
    }, []);
    const onMapUnmount = (0, _react.useCallback)((id = 'default')=>{
        setMaps((currMaps)=>{
            if (currMaps[id]) {
                const nextMaps = {
                    ...currMaps
                };
                delete nextMaps[id];
                return nextMaps;
            }
            return currMaps;
        });
    }, []);
    return _react.createElement(MountedMapsContext.Provider, {
        value: {
            maps,
            onMapMount,
            onMapUnmount
        }
    }, props.children);
};
function useMap() {
    var _a;
    const maps = (_a = (0, _react.useContext)(MountedMapsContext)) === null || _a === void 0 ? void 0 : _a.maps;
    const currentMap = (0, _react.useContext)((0, _map.MapContext));
    const mapsWithCurrent = (0, _react.useMemo)(()=>{
        return {
            ...maps,
            current: currentMap === null || currentMap === void 0 ? void 0 : currentMap.map
        };
    }, [
        maps,
        currentMap
    ]);
    return mapsWithCurrent;
}

},{"react":"9njXz","./map":"2j6lb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"84Qjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transform = require("../utils/transform");
var _styleUtils = require("../utils/style-utils");
var _deepEqual = require("../utils/deep-equal");
const pointerEvents = {
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    click: 'onClick',
    dblclick: 'onDblClick',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    mouseout: 'onMouseOut',
    contextmenu: 'onContextMenu',
    touchstart: 'onTouchStart',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchcancel: 'onTouchCancel'
};
const cameraEvents = {
    movestart: 'onMoveStart',
    move: 'onMove',
    moveend: 'onMoveEnd',
    dragstart: 'onDragStart',
    drag: 'onDrag',
    dragend: 'onDragEnd',
    zoomstart: 'onZoomStart',
    zoom: 'onZoom',
    zoomend: 'onZoomEnd',
    rotatestart: 'onRotateStart',
    rotate: 'onRotate',
    rotateend: 'onRotateEnd',
    pitchstart: 'onPitchStart',
    pitch: 'onPitch',
    pitchend: 'onPitchEnd'
};
const otherEvents = {
    wheel: 'onWheel',
    boxzoomstart: 'onBoxZoomStart',
    boxzoomend: 'onBoxZoomEnd',
    boxzoomcancel: 'onBoxZoomCancel',
    resize: 'onResize',
    load: 'onLoad',
    render: 'onRender',
    idle: 'onIdle',
    remove: 'onRemove',
    data: 'onData',
    styledata: 'onStyleData',
    sourcedata: 'onSourceData',
    error: 'onError'
};
const settingNames = [
    'minZoom',
    'maxZoom',
    'minPitch',
    'maxPitch',
    'maxBounds',
    'projection',
    'renderWorldCopies'
];
const handlerNames = [
    'scrollZoom',
    'boxZoom',
    'dragRotate',
    'dragPan',
    'keyboard',
    'doubleClickZoom',
    'touchZoomRotate',
    'touchPitch'
];
class Mapbox {
    constructor(MapClass, props, container){
        // mapboxgl.Map instance. Not using type here because we are accessing
        // private members and methods
        this._map = null;
        // Internal states
        this._internalUpdate = false;
        this._inRender = false;
        this._hoveredFeatures = null;
        this._deferredEvents = {
            move: false,
            zoom: false,
            pitch: false,
            rotate: false
        };
        this._onEvent = (e)=>{
            // @ts-ignore
            const cb = this.props[otherEvents[e.type]];
            if (cb) cb(e);
        };
        this._onPointerEvent = (e)=>{
            if (e.type === 'mousemove' || e.type === 'mouseout') this._updateHover(e);
            // @ts-ignore
            const cb = this.props[pointerEvents[e.type]];
            if (cb) {
                if (this.props.interactiveLayerIds && e.type !== 'mouseover' && e.type !== 'mouseout') {
                    const features = this._hoveredFeatures || this._map.queryRenderedFeatures(e.point, {
                        layers: this.props.interactiveLayerIds
                    });
                    e.features = features;
                }
                cb(e);
                delete e.features;
            }
        };
        this._onCameraEvent = (e)=>{
            if (!this._internalUpdate) {
                // @ts-ignore
                const cb = this.props[cameraEvents[e.type]];
                if (cb) cb(e);
            }
            if (e.type in this._deferredEvents) this._deferredEvents[e.type] = false;
        };
        this._MapClass = MapClass;
        this.props = props;
        this._initialize(container);
    }
    get map() {
        return this._map;
    }
    get transform() {
        return this._renderTransform;
    }
    setProps(props) {
        const oldProps = this.props;
        this.props = props;
        const settingsChanged = this._updateSettings(props, oldProps);
        if (settingsChanged) this._createShadowTransform(this._map);
        const sizeChanged = this._updateSize(props);
        const viewStateChanged = this._updateViewState(props, true);
        this._updateStyle(props, oldProps);
        this._updateStyleComponents(props, oldProps);
        this._updateHandlers(props, oldProps);
        // If 1) view state has changed to match props and
        //    2) the props change is not triggered by map events,
        // it's driven by an external state change. Redraw immediately
        if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) this.redraw();
    }
    static reuse(props, container) {
        const that = Mapbox.savedMaps.pop();
        if (!that) return null;
        const map = that.map;
        // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step1: reparenting child nodes from old container to new container
        const oldContainer = map.getContainer();
        container.className = oldContainer.className;
        while(oldContainer.childNodes.length > 0)container.appendChild(oldContainer.childNodes[0]);
        // Step2: replace the internal container with new container from the react component
        // @ts-ignore
        map._container = container;
        // Step 3: apply new props
        that.setProps({
            ...props,
            styleDiffing: false
        });
        map.resize();
        const { initialViewState } = props;
        if (initialViewState) {
            if (initialViewState.bounds) map.fitBounds(initialViewState.bounds, {
                ...initialViewState.fitBoundsOptions,
                duration: 0
            });
            else that._updateViewState(initialViewState, false);
        }
        // Simulate load event
        if (map.isStyleLoaded()) map.fire('load');
        else map.once('styledata', ()=>map.fire('load'));
        return that;
    }
    /* eslint-disable complexity,max-statements */ _initialize(container) {
        const { props } = this;
        const mapOptions = {
            ...props,
            ...props.initialViewState,
            accessToken: props.mapboxAccessToken || getAccessTokenFromEnv() || null,
            container,
            style: (0, _styleUtils.normalizeStyle)(props.mapStyle)
        };
        const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
        Object.assign(mapOptions, {
            center: [
                viewState.longitude || 0,
                viewState.latitude || 0
            ],
            zoom: viewState.zoom || 0,
            pitch: viewState.pitch || 0,
            bearing: viewState.bearing || 0
        });
        if (props.gl) {
            // eslint-disable-next-line
            const getContext = HTMLCanvasElement.prototype.getContext;
            // Hijack canvas.getContext to return our own WebGLContext
            // This will be called inside the mapboxgl.Map constructor
            // @ts-expect-error
            HTMLCanvasElement.prototype.getContext = ()=>{
                // Unhijack immediately
                HTMLCanvasElement.prototype.getContext = getContext;
                return props.gl;
            };
        }
        const map = new this._MapClass(mapOptions);
        // Props that are not part of constructor options
        if (viewState.padding) map.setPadding(viewState.padding);
        if (props.cursor) map.getCanvas().style.cursor = props.cursor;
        this._createShadowTransform(map);
        // Hack
        // Insert code into map's render cycle
        const renderMap = map._render;
        map._render = (arg)=>{
            this._inRender = true;
            renderMap.call(map, arg);
            this._inRender = false;
        };
        const runRenderTaskQueue = map._renderTaskQueue.run;
        map._renderTaskQueue.run = (arg)=>{
            runRenderTaskQueue.call(map._renderTaskQueue, arg);
            this._onBeforeRepaint();
        };
        map.on('render', ()=>this._onAfterRepaint());
        // Insert code into map's event pipeline
        const fireEvent = map.fire;
        map.fire = this._fireEvent.bind(this, fireEvent);
        // add listeners
        map.on('resize', ()=>{
            this._renderTransform.resize(map.transform.width, map.transform.height);
        });
        map.on('styledata', ()=>this._updateStyleComponents(this.props, {}));
        map.on('sourcedata', ()=>this._updateStyleComponents(this.props, {}));
        for(const eventName in pointerEvents)map.on(eventName, this._onPointerEvent);
        for(const eventName in cameraEvents)map.on(eventName, this._onCameraEvent);
        for(const eventName in otherEvents)map.on(eventName, this._onEvent);
        this._map = map;
    }
    /* eslint-enable complexity,max-statements */ recycle() {
        // Clean up unnecessary elements before storing for reuse.
        const container = this.map.getContainer();
        const children = container.querySelector('[mapboxgl-children]');
        children === null || children === void 0 || children.remove();
        Mapbox.savedMaps.push(this);
    }
    destroy() {
        this._map.remove();
    }
    // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
    // render cycle, which is managed by Mapbox's animation loop.
    // This removes the synchronization issue caused by requestAnimationFrame.
    redraw() {
        const map = this._map;
        // map._render will throw error if style does not exist
        // https://github.com/mapbox/mapbox-gl-js/blob/fb9fc316da14e99ff4368f3e4faa3888fb43c513
        //   /src/ui/map.js#L1834
        if (!this._inRender && map.style) {
            // cancel the scheduled update
            if (map._frame) {
                map._frame.cancel();
                map._frame = null;
            }
            // the order is important - render() may schedule another update
            map._render();
        }
    }
    _createShadowTransform(map) {
        const renderTransform = (0, _transform.cloneTransform)(map.transform);
        map.painter.transform = renderTransform;
        this._renderTransform = renderTransform;
    }
    /* Trigger map resize if size is controlled
       @param {object} nextProps
       @returns {bool} true if size has changed
     */ _updateSize(nextProps) {
        // Check if size is controlled
        const { viewState } = nextProps;
        if (viewState) {
            const map = this._map;
            if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
                map.resize();
                return true;
            }
        }
        return false;
    }
    // Adapted from map.jumpTo
    /* Update camera to match props
       @param {object} nextProps
       @param {bool} triggerEvents - should fire camera events
       @returns {bool} true if anything is changed
     */ _updateViewState(nextProps, triggerEvents) {
        if (this._internalUpdate) return false;
        const map = this._map;
        const tr = this._renderTransform;
        // Take a snapshot of the transform before mutation
        const { zoom, pitch, bearing } = tr;
        const isMoving = map.isMoving();
        if (isMoving) // All movement of the camera is done relative to the sea level
        tr.cameraElevationReference = 'sea';
        const changed = (0, _transform.applyViewStateToTransform)(tr, {
            ...(0, _transform.transformToViewState)(map.transform),
            ...nextProps
        });
        if (isMoving) // Reset camera reference
        tr.cameraElevationReference = 'ground';
        if (changed && triggerEvents) {
            const deferredEvents = this._deferredEvents;
            // Delay DOM control updates to the next render cycle
            deferredEvents.move = true;
            deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
            deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
            deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
        }
        // Avoid manipulating the real transform when interaction/animation is ongoing
        // as it would interfere with Mapbox's handlers
        if (!isMoving) (0, _transform.applyViewStateToTransform)(map.transform, nextProps);
        return changed;
    }
    /* Update camera constraints and projection settings to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateSettings(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of settingNames)if (propName in nextProps && !(0, _deepEqual.deepEqual)(nextProps[propName], currProps[propName])) {
            changed = true;
            map[`set${propName[0].toUpperCase()}${propName.slice(1)}`](nextProps[propName]);
        }
        return changed;
    }
    /* Update map style to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if style is changed
     */ _updateStyle(nextProps, currProps) {
        if (nextProps.cursor !== currProps.cursor) this._map.getCanvas().style.cursor = nextProps.cursor;
        if (nextProps.mapStyle !== currProps.mapStyle) {
            const options = {
                diff: nextProps.styleDiffing
            };
            if ('localIdeographFontFamily' in nextProps) options.localIdeographFontFamily = nextProps.localIdeographFontFamily;
            this._map.setStyle((0, _styleUtils.normalizeStyle)(nextProps.mapStyle), options);
            return true;
        }
        return false;
    }
    /* Update fog, light and terrain to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateStyleComponents(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        if (map.style.loaded()) {
            if ('light' in nextProps && !(0, _deepEqual.deepEqual)(nextProps.light, currProps.light)) {
                changed = true;
                map.setLight(nextProps.light);
            }
            if ('fog' in nextProps && !(0, _deepEqual.deepEqual)(nextProps.fog, currProps.fog)) {
                changed = true;
                map.setFog(nextProps.fog);
            }
            if ('terrain' in nextProps && !(0, _deepEqual.deepEqual)(nextProps.terrain, currProps.terrain)) {
                if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
                    changed = true;
                    map.setTerrain(nextProps.terrain);
                }
            }
        }
        return changed;
    }
    /* Update interaction handlers to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateHandlers(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of handlerNames){
            const newValue = nextProps[propName];
            if (!(0, _deepEqual.deepEqual)(newValue, currProps[propName])) {
                changed = true;
                if (newValue) map[propName].enable(newValue);
                else map[propName].disable();
            }
        }
        return changed;
    }
    _updateHover(e) {
        var _a;
        const { props } = this;
        const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
        if (shouldTrackHoveredFeatures) {
            const eventType = e.type;
            const wasHovering = ((_a = this._hoveredFeatures) === null || _a === void 0 ? void 0 : _a.length) > 0;
            let features;
            if (eventType === 'mousemove') try {
                features = this._map.queryRenderedFeatures(e.point, {
                    layers: props.interactiveLayerIds
                });
            } catch (_b) {
                features = [];
            }
            else features = [];
            const isHovering = features.length > 0;
            if (!isHovering && wasHovering) {
                e.type = 'mouseleave';
                this._onPointerEvent(e);
            }
            this._hoveredFeatures = features;
            if (isHovering && !wasHovering) {
                e.type = 'mouseenter';
                this._onPointerEvent(e);
            }
            e.type = eventType;
        } else this._hoveredFeatures = null;
    }
    _fireEvent(baseFire, event, properties) {
        const map = this._map;
        const tr = map.transform;
        const eventType = typeof event === 'string' ? event : event.type;
        if (eventType === 'move') this._updateViewState(this.props, false);
        if (eventType in cameraEvents) {
            if (typeof event === 'object') event.viewState = (0, _transform.transformToViewState)(tr);
            if (this._map.isMoving()) {
                // Replace map.transform with ours during the callbacks
                map.transform = this._renderTransform;
                baseFire.call(map, event, properties);
                map.transform = tr;
                return map;
            }
        }
        baseFire.call(map, event, properties);
        return map;
    }
    // All camera manipulations are complete, ready to repaint
    _onBeforeRepaint() {
        const map = this._map;
        // If there are camera changes driven by props, invoke camera events so that DOM controls are synced
        this._internalUpdate = true;
        for(const eventType in this._deferredEvents)if (this._deferredEvents[eventType]) map.fire(eventType);
        this._internalUpdate = false;
        const tr = this._map.transform;
        // Make sure camera matches the current props
        this._map.transform = this._renderTransform;
        this._onAfterRepaint = ()=>{
            // Restores camera state before render/load events are fired
            this._map.transform = tr;
        };
    }
}
exports.default = Mapbox;
Mapbox.savedMaps = [];
/**
 * Access token can be provided via one of:
 *   mapboxAccessToken prop
 *   access_token query parameter
 *   MapboxAccessToken environment variable
 *   REACT_APP_MAPBOX_ACCESS_TOKEN environment variable
 * @returns access token
 */ function getAccessTokenFromEnv() {
    let accessToken = null;
    /* global location, process */ if (typeof location !== 'undefined') {
        const match = /access_token=([^&\/]*)/.exec(location.search);
        accessToken = match && match[1];
    }
    // Note: This depends on bundler plugins (e.g. webpack) importing environment correctly
    try {
        accessToken = accessToken || undefined;
    } catch (_a) {
    // ignore
    }
    try {
        accessToken = accessToken || undefined;
    } catch (_b) {
    // ignore
    }
    return accessToken;
}

},{"../utils/transform":"9Yynb","../utils/style-utils":"1eLQj","../utils/deep-equal":"3ppfS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Yynb":[function(require,module,exports,__globalThis) {
/**
 * Make a copy of a transform
 * @param tr
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneTransform", ()=>cloneTransform);
/**
 * Capture a transform's current state
 * @param transform
 * @returns descriptor of the view state
 */ parcelHelpers.export(exports, "transformToViewState", ()=>transformToViewState);
/* eslint-disable complexity */ /**
 * Mutate a transform to match the given view state
 * @param transform
 * @param viewState
 * @returns true if the transform has changed
 */ parcelHelpers.export(exports, "applyViewStateToTransform", ()=>applyViewStateToTransform);
function cloneTransform(tr) {
    const newTransform = tr.clone();
    // Work around mapbox bug - this value is not assigned in clone(), only in resize()
    newTransform.pixelsToGLUnits = tr.pixelsToGLUnits;
    return newTransform;
}
function transformToViewState(tr) {
    return {
        longitude: tr.center.lng,
        latitude: tr.center.lat,
        zoom: tr.zoom,
        pitch: tr.pitch,
        bearing: tr.bearing,
        padding: tr.padding
    };
}
function applyViewStateToTransform(tr, props) {
    const v = props.viewState || props;
    let changed = false;
    if ('longitude' in v && 'latitude' in v) {
        const center = tr.center;
        // @ts-ignore
        tr.center = new center.constructor(v.longitude, v.latitude);
        changed = changed || center !== tr.center;
    }
    if ('zoom' in v) {
        const zoom = tr.zoom;
        tr.zoom = v.zoom;
        changed = changed || zoom !== tr.zoom;
    }
    if ('bearing' in v) {
        const bearing = tr.bearing;
        tr.bearing = v.bearing;
        changed = changed || bearing !== tr.bearing;
    }
    if ('pitch' in v) {
        const pitch = tr.pitch;
        tr.pitch = v.pitch;
        changed = changed || pitch !== tr.pitch;
    }
    if (v.padding && !tr.isPaddingEqual(v.padding)) {
        changed = true;
        tr.padding = v.padding;
    }
    return changed;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1eLQj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Prepare a map style object for diffing
// If immutable - convert to plain object
// Work around some issues in older styles that would fail Mapbox's diffing
parcelHelpers.export(exports, "normalizeStyle", ()=>normalizeStyle);
const refProps = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];
function normalizeStyle(style) {
    if (!style) return null;
    if (typeof style === 'string') return style;
    if ('toJS' in style) style = style.toJS();
    if (!style.layers) return style;
    const layerIndex = {};
    for (const layer of style.layers)layerIndex[layer.id] = layer;
    const layers = style.layers.map((layer)=>{
        // @ts-expect-error
        const layerRef = layerIndex[layer.ref];
        let normalizedLayer = null;
        if ('interactive' in layer) {
            normalizedLayer = {
                ...layer
            };
            // Breaks style diffing :(
            delete normalizedLayer.interactive;
        }
        // Style diffing doesn't work with refs so expand them out manually before diffing.
        if (layerRef) {
            normalizedLayer = normalizedLayer || {
                ...layer
            };
            delete normalizedLayer.ref;
            // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/deref.js
            for (const propName of refProps)if (propName in layerRef) normalizedLayer[propName] = layerRef[propName];
        }
        return normalizedLayer || layer;
    });
    // Do not mutate the style object provided by the user
    return {
        ...style,
        layers
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ppfS":[function(require,module,exports,__globalThis) {
/**
 * Compare two points
 * @param a
 * @param b
 * @returns true if the points are equal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arePointsEqual", ()=>arePointsEqual);
/* eslint-disable complexity */ /**
 * Compare any two objects
 * @param a
 * @param b
 * @returns true if the objects are deep equal
 */ parcelHelpers.export(exports, "deepEqual", ()=>deepEqual);
function arePointsEqual(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!deepEqual(a[i], b[i])) return false;
        }
        return true;
    } else if (Array.isArray(b)) return false;
    if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5YY6n":[function(require,module,exports,__globalThis) {
/** These methods may break the react binding if called directly */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createRef);
const skipMethods = [
    'setMaxBounds',
    'setMinZoom',
    'setMaxZoom',
    'setMinPitch',
    'setMaxPitch',
    'setRenderWorldCopies',
    'setProjection',
    'setStyle',
    'addSource',
    'removeSource',
    'addLayer',
    'removeLayer',
    'setLayerZoomRange',
    'setFilter',
    'setPaintProperty',
    'setLayoutProperty',
    'setLight',
    'setTerrain',
    'setFog',
    'remove'
];
function createRef(mapInstance, mapLib) {
    if (!mapInstance) return null;
    const map = mapInstance.map;
    const result = {
        getMap: ()=>map,
        // Overwrite getters to use our shadow transform
        getCenter: ()=>mapInstance.transform.center,
        getZoom: ()=>mapInstance.transform.zoom,
        getBearing: ()=>mapInstance.transform.bearing,
        getPitch: ()=>mapInstance.transform.pitch,
        getPadding: ()=>mapInstance.transform.padding,
        getBounds: ()=>mapInstance.transform.getBounds(),
        project: (lnglat)=>{
            return mapInstance.transform.locationPoint(mapLib.LngLat.convert(lnglat));
        },
        unproject: (point)=>{
            return mapInstance.transform.pointLocation(mapLib.Point.convert(point));
        },
        queryTerrainElevation: (lnglat, options)=>{
            // @ts-ignore transform not defined
            const tr = map.transform;
            // @ts-ignore transform not defined
            map.transform = mapInstance.transform;
            const result = map.queryTerrainElevation(lnglat, options);
            // @ts-ignore transform not defined
            map.transform = tr;
            return result;
        }
    };
    for (const key of getMethodNames(map))// @ts-expect-error
    if (!(key in result) && !skipMethods.includes(key)) result[key] = map[key].bind(map);
    return result;
}
function getMethodNames(obj) {
    const result = new Set();
    let proto = obj;
    while(proto){
        for (const key of Object.getOwnPropertyNames(proto))if (key[0] !== '_' && typeof obj[key] === 'function' && key !== 'fire' && key !== 'setEventedParent') result.add(key);
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(result);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a7ESq":[function(require,module,exports,__globalThis) {
// From https://github.com/streamich/react-use/blob/master/src/useIsomorphicLayoutEffect.ts
// useLayoutEffect but does not trigger warning in server-side rendering
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useIsomorphicLayoutEffect = typeof document !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
exports.default = useIsomorphicLayoutEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8XQ20":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setGlobals);
const globalSettings = [
    'baseApiUrl',
    'maxParallelImageRequests',
    'workerClass',
    'workerCount',
    'workerUrl'
];
function setGlobals(mapLib, props) {
    for (const key of globalSettings)if (key in props) mapLib[key] = props[key];
    if (props.RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === 'unavailable') mapLib.setRTLTextPlugin(props.RTLTextPlugin, (error)=>{
        if (error) // eslint-disable-next-line
        console.error(error);
    }, false);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hFFkp":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("8QZuN"));

},{}],"iTmCB":[function(require,module,exports,__globalThis) {
/* global document */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDom = require("react-dom");
var _applyReactStyle = require("../utils/apply-react-style");
var _map = require("./map");
var _deepEqual = require("../utils/deep-equal");
const defaultProps = {
    draggable: false,
    popup: null,
    rotation: 0,
    rotationAlignment: 'auto',
    pitchAlignment: 'auto'
};
/* eslint-disable complexity,max-statements */ function Marker(props) {
    const { map, mapLib } = (0, _react.useContext)((0, _map.MapContext));
    const thisRef = (0, _react.useRef)({
        props
    });
    thisRef.current.props = props;
    const marker = (0, _react.useMemo)(()=>{
        let hasChildren = false;
        _react.Children.forEach(props.children, (el)=>{
            if (el) hasChildren = true;
        });
        const options = {
            ...props,
            element: hasChildren ? document.createElement('div') : null
        };
        const mk = new mapLib.Marker(options).setLngLat([
            props.longitude,
            props.latitude
        ]);
        mk.getElement().addEventListener('click', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClick) === null || _b === void 0 || _b.call(_a, {
                type: 'click',
                target: mk,
                originalEvent: e
            });
        });
        mk.on('dragstart', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragStart) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on('drag', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDrag) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on('dragend', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragEnd) === null || _b === void 0 || _b.call(_a, evt);
        });
        return mk;
    }, []);
    (0, _react.useEffect)(()=>{
        marker.addTo(map.getMap());
        return ()=>{
            marker.remove();
        };
    }, []);
    (0, _react.useEffect)(()=>{
        (0, _applyReactStyle.applyReactStyle)(marker.getElement(), props.style);
    }, [
        props.style
    ]);
    if (marker.getLngLat().lng !== props.longitude || marker.getLngLat().lat !== props.latitude) marker.setLngLat([
        props.longitude,
        props.latitude
    ]);
    if (props.offset && !(0, _deepEqual.arePointsEqual)(marker.getOffset(), props.offset)) marker.setOffset(props.offset);
    if (marker.isDraggable() !== props.draggable) marker.setDraggable(props.draggable);
    if (marker.getRotation() !== props.rotation) marker.setRotation(props.rotation);
    if (marker.getRotationAlignment() !== props.rotationAlignment) marker.setRotationAlignment(props.rotationAlignment);
    if (marker.getPitchAlignment() !== props.pitchAlignment) marker.setPitchAlignment(props.pitchAlignment);
    if (marker.getPopup() !== props.popup) marker.setPopup(props.popup);
    return (0, _reactDom.createPortal)(props.children, marker.getElement());
}
Marker.defaultProps = defaultProps;
// @ts-ignore
exports.default = _react.memo(Marker);

},{"react":"9njXz","react-dom":"2ApDx","../utils/apply-react-style":"j9NKP","./map":"2j6lb","../utils/deep-equal":"3ppfS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9NKP":[function(require,module,exports,__globalThis) {
// This is a simplified version of
// https://github.com/facebook/react/blob/4131af3e4bf52f3a003537ec95a1655147c81270/src/renderers/dom/shared/CSSPropertyOperations.js#L62
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyReactStyle", ()=>applyReactStyle);
const unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function applyReactStyle(element, styles) {
    if (!element || !styles) return;
    const style = element.style;
    for(const key in styles){
        const value = styles[key];
        if (Number.isFinite(value) && !unitlessNumber.test(key)) style[key] = `${value}px`;
        else style[key] = value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZYPY":[function(require,module,exports,__globalThis) {
/* global document */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDom = require("react-dom");
var _applyReactStyle = require("../utils/apply-react-style");
var _map = require("./map");
var _deepEqual = require("../utils/deep-equal");
// Adapted from https://github.com/mapbox/mapbox-gl-js/blob/v1.13.0/src/ui/popup.js
function getClassList(className) {
    return new Set(className ? className.trim().split(/\s+/) : []);
}
/* eslint-disable complexity,max-statements */ function Popup(props) {
    const { map, mapLib } = (0, _react.useContext)((0, _map.MapContext));
    const container = (0, _react.useMemo)(()=>{
        return document.createElement('div');
    }, []);
    const thisRef = (0, _react.useRef)({
        props
    });
    thisRef.current.props = props;
    const popup = (0, _react.useMemo)(()=>{
        const options = {
            ...props
        };
        const pp = new mapLib.Popup(options).setLngLat([
            props.longitude,
            props.latitude
        ]);
        pp.once('open', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOpen) === null || _b === void 0 || _b.call(_a, e);
        });
        return pp;
    }, []);
    (0, _react.useEffect)(()=>{
        const onClose = (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClose) === null || _b === void 0 || _b.call(_a, e);
        };
        popup.on('close', onClose);
        popup.setDOMContent(container).addTo(map.getMap());
        return ()=>{
            // https://github.com/visgl/react-map-gl/issues/1825
            // onClose should not be fired if the popup is removed by unmounting
            // When using React strict mode, the component is mounted twice.
            // Firing the onClose callback here would be a false signal to remove the component.
            popup.off('close', onClose);
            if (popup.isOpen()) popup.remove();
        };
    }, []);
    (0, _react.useEffect)(()=>{
        (0, _applyReactStyle.applyReactStyle)(popup.getElement(), props.style);
    }, [
        props.style
    ]);
    if (popup.isOpen()) {
        if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) popup.setLngLat([
            props.longitude,
            props.latitude
        ]);
        // @ts-ignore
        if (props.offset && !(0, _deepEqual.deepEqual)(popup.options.offset, props.offset)) popup.setOffset(props.offset);
        // @ts-ignore
        if (popup.options.anchor !== props.anchor || popup.options.maxWidth !== props.maxWidth) {
            // @ts-ignore
            popup.options.anchor = props.anchor;
            popup.setMaxWidth(props.maxWidth);
        }
        // @ts-ignore
        if (popup.options.className !== props.className) {
            // @ts-ignore
            const prevClassList = getClassList(popup.options.className);
            const nextClassList = getClassList(props.className);
            for (const c of prevClassList)if (!nextClassList.has(c)) popup.removeClassName(c);
            for (const c of nextClassList)if (!prevClassList.has(c)) popup.addClassName(c);
            // @ts-ignore
            popup.options.className = props.className;
        }
    }
    return (0, _reactDom.createPortal)(props.children, container);
}
// @ts-ignore
exports.default = _react.memo(Popup);

},{"react":"9njXz","react-dom":"2ApDx","../utils/apply-react-style":"j9NKP","./map":"2j6lb","../utils/deep-equal":"3ppfS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6QiHQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _applyReactStyle = require("../utils/apply-react-style");
var _useControl = require("./use-control");
var _useControlDefault = parcelHelpers.interopDefault(_useControl);
function AttributionControl(props) {
    const ctrl = (0, _useControlDefault.default)(({ mapLib })=>new mapLib.AttributionControl(props), {
        position: props.position
    });
    (0, _react.useEffect)(()=>{
        // @ts-ignore
        (0, _applyReactStyle.applyReactStyle)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
exports.default = _react.memo(AttributionControl);

},{"react":"9njXz","../utils/apply-react-style":"j9NKP","./use-control":"7XL0s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7XL0s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _map = require("./map");
function useControl(onCreate, arg1, arg2, arg3) {
    const context = (0, _react.useContext)((0, _map.MapContext));
    const ctrl = (0, _react.useMemo)(()=>onCreate(context), []);
    (0, _react.useEffect)(()=>{
        const opts = arg3 || arg2 || arg1;
        const onAdd = typeof arg1 === 'function' && typeof arg2 === 'function' ? arg1 : null;
        const onRemove = typeof arg2 === 'function' ? arg2 : typeof arg1 === 'function' ? arg1 : null;
        const { map } = context;
        if (!map.hasControl(ctrl)) {
            map.addControl(ctrl, opts === null || opts === void 0 ? void 0 : opts.position);
            if (onAdd) onAdd(context);
        }
        return ()=>{
            if (onRemove) onRemove(context);
            // Map might have been removed (parent effects are destroyed before child ones)
            if (map.hasControl(ctrl)) map.removeControl(ctrl);
        };
    }, []);
    return ctrl;
}
exports.default = useControl;

},{"react":"9njXz","./map":"2j6lb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eJOIz":[function(require,module,exports,__globalThis) {
/* global document */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _applyReactStyle = require("../utils/apply-react-style");
var _useControl = require("./use-control");
var _useControlDefault = parcelHelpers.interopDefault(_useControl);
function FullscreenControl(props) {
    const ctrl = (0, _useControlDefault.default)(({ mapLib })=>new mapLib.FullscreenControl({
            container: props.containerId && document.getElementById(props.containerId)
        }), {
        position: props.position
    });
    (0, _react.useEffect)(()=>{
        // @ts-ignore
        (0, _applyReactStyle.applyReactStyle)(ctrl._controlContainer, props.style);
    }, [
        props.style
    ]);
    return null;
}
exports.default = _react.memo(FullscreenControl);

},{"react":"9njXz","../utils/apply-react-style":"j9NKP","./use-control":"7XL0s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1fQDx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _applyReactStyle = require("../utils/apply-react-style");
var _useControl = require("./use-control");
var _useControlDefault = parcelHelpers.interopDefault(_useControl);
const GeolocateControl = (0, _react.forwardRef)((props, ref)=>{
    const thisRef = (0, _react.useRef)({
        props
    });
    const ctrl = (0, _useControlDefault.default)(({ mapLib })=>{
        const gc = new mapLib.GeolocateControl(props);
        // Hack: fix GeolocateControl reuse
        // When using React strict mode, the component is mounted twice.
        // GeolocateControl's UI creation is asynchronous. Removing and adding it back causes the UI to be initialized twice.
        const setupUI = gc._setupUI;
        gc._setupUI = (args)=>{
            if (!gc._container.hasChildNodes()) setupUI(args);
        };
        gc.on('geolocate', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onGeolocate) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('error', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onError) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('outofmaxbounds', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOutOfMaxBounds) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('trackuserlocationstart', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationStart) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('trackuserlocationend', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationEnd) === null || _b === void 0 || _b.call(_a, e);
        });
        return gc;
    }, {
        position: props.position
    });
    thisRef.current.props = props;
    (0, _react.useImperativeHandle)(ref, ()=>({
            trigger: ()=>ctrl.trigger()
        }), []);
    (0, _react.useEffect)(()=>{
        // @ts-ignore
        (0, _applyReactStyle.applyReactStyle)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
});
GeolocateControl.displayName = 'GeolocateControl';
exports.default = _react.memo(GeolocateControl);

},{"react":"9njXz","../utils/apply-react-style":"j9NKP","./use-control":"7XL0s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cEfVz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _applyReactStyle = require("../utils/apply-react-style");
var _useControl = require("./use-control");
var _useControlDefault = parcelHelpers.interopDefault(_useControl);
function NavigationControl(props) {
    const ctrl = (0, _useControlDefault.default)(({ mapLib })=>new mapLib.NavigationControl(props), {
        position: props.position
    });
    (0, _react.useEffect)(()=>{
        // @ts-ignore
        (0, _applyReactStyle.applyReactStyle)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
exports.default = _react.memo(NavigationControl);

},{"react":"9njXz","../utils/apply-react-style":"j9NKP","./use-control":"7XL0s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cj2wl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _applyReactStyle = require("../utils/apply-react-style");
var _useControl = require("./use-control");
var _useControlDefault = parcelHelpers.interopDefault(_useControl);
const defaultProps = {
    unit: 'metric',
    maxWidth: 100
};
function ScaleControl(props) {
    const ctrl = (0, _useControlDefault.default)(({ mapLib })=>new mapLib.ScaleControl(props), {
        position: props.position
    });
    // @ts-ignore
    if (ctrl.options.unit !== props.unit || ctrl.options.maxWidth !== props.maxWidth) {
        // @ts-ignore
        ctrl.options.maxWidth = props.maxWidth;
        // This method will trigger an update
        ctrl.setUnit(props.unit);
    }
    (0, _react.useEffect)(()=>{
        // @ts-ignore
        (0, _applyReactStyle.applyReactStyle)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
ScaleControl.defaultProps = defaultProps;
exports.default = _react.memo(ScaleControl);

},{"react":"9njXz","../utils/apply-react-style":"j9NKP","./use-control":"7XL0s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kF3ds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _map = require("./map");
var _assert = require("../utils/assert");
var _assertDefault = parcelHelpers.interopDefault(_assert);
var _deepEqual = require("../utils/deep-equal");
let sourceCounter = 0;
function createSource(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded) {
        const options = {
            ...props
        };
        delete options.id;
        delete options.children;
        // @ts-ignore
        map.addSource(id, options);
        return map.getSource(id);
    }
    return null;
}
/* eslint-disable complexity */ function updateSource(source, props, prevProps) {
    (0, _assertDefault.default)(props.id === prevProps.id, 'source id changed');
    (0, _assertDefault.default)(props.type === prevProps.type, 'source type changed');
    let changedKey = '';
    let changedKeyCount = 0;
    for(const key in props)if (key !== 'children' && key !== 'id' && !(0, _deepEqual.deepEqual)(prevProps[key], props[key])) {
        changedKey = key;
        changedKeyCount++;
    }
    if (!changedKeyCount) return;
    const type = props.type;
    if (type === 'geojson') source.setData(props.data);
    else if (type === 'image') source.updateImage({
        url: props.url,
        coordinates: props.coordinates
    });
    else if ((type === 'canvas' || type === 'video') && changedKeyCount === 1 && changedKey === 'coordinates') source.setCoordinates(props.coordinates);
    else if (type === 'vector' && 'setUrl' in source) // Added in 1.12.0:
    // vectorTileSource.setTiles
    // vectorTileSource.setUrl
    switch(changedKey){
        case 'url':
            source.setUrl(props.url);
            break;
        case 'tiles':
            source.setTiles(props.tiles);
            break;
        default:
    }
    else // eslint-disable-next-line
    console.warn(`Unable to update <Source> prop: ${changedKey}`);
}
/* eslint-enable complexity */ function Source(props) {
    const map = (0, _react.useContext)((0, _map.MapContext)).map.getMap();
    const propsRef = (0, _react.useRef)(props);
    const [, setStyleLoaded] = (0, _react.useState)(0);
    const id = (0, _react.useMemo)(()=>props.id || `jsx-source-${sourceCounter++}`, []);
    (0, _react.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setTimeout(()=>setStyleLoaded((version)=>version + 1), 0);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                var _a;
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getSource(id)) {
                    // Parent effects are destroyed before child ones, see
                    // https://github.com/facebook/react/issues/16728
                    // Source can only be removed after all child layers are removed
                    const allLayers = (_a = map.getStyle()) === null || _a === void 0 ? void 0 : _a.layers;
                    if (allLayers) {
                        for (const layer of allLayers)// @ts-ignore (2339) source does not exist on all layer types
                        if (layer.source === id) map.removeLayer(layer.id);
                    }
                    map.removeSource(id);
                }
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    let source = map && map.style && map.getSource(id);
    if (source) updateSource(source, props, propsRef.current);
    else source = createSource(map, id, props);
    propsRef.current = props;
    return source && _react.Children.map(props.children, (child)=>child && (0, _react.cloneElement)(child, {
            source: id
        })) || null;
}
exports.default = Source;

},{"react":"9njXz","./map":"2j6lb","../utils/assert":"GYkaD","../utils/deep-equal":"3ppfS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"GYkaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assert);
function assert(condition, message) {
    if (!condition) throw new Error(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3G3Ij":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _map = require("./map");
var _assert = require("../utils/assert");
var _assertDefault = parcelHelpers.interopDefault(_assert);
var _deepEqual = require("../utils/deep-equal");
/* eslint-disable complexity, max-statements */ function updateLayer(map, id, props, prevProps) {
    (0, _assertDefault.default)(props.id === prevProps.id, 'layer id changed');
    (0, _assertDefault.default)(props.type === prevProps.type, 'layer type changed');
    if (props.type === 'custom' || prevProps.type === 'custom') return;
    const { layout = {}, paint = {}, filter, minzoom, maxzoom, beforeId } = props;
    if (beforeId !== prevProps.beforeId) map.moveLayer(id, beforeId);
    if (layout !== prevProps.layout) {
        const prevLayout = prevProps.layout || {};
        for(const key in layout)if (!(0, _deepEqual.deepEqual)(layout[key], prevLayout[key])) map.setLayoutProperty(id, key, layout[key]);
        for(const key in prevLayout)if (!layout.hasOwnProperty(key)) map.setLayoutProperty(id, key, undefined);
    }
    if (paint !== prevProps.paint) {
        const prevPaint = prevProps.paint || {};
        for(const key in paint)if (!(0, _deepEqual.deepEqual)(paint[key], prevPaint[key])) map.setPaintProperty(id, key, paint[key]);
        for(const key in prevPaint)if (!paint.hasOwnProperty(key)) map.setPaintProperty(id, key, undefined);
    }
    if (!(0, _deepEqual.deepEqual)(filter, prevProps.filter)) map.setFilter(id, filter);
    if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) map.setLayerZoomRange(id, minzoom, maxzoom);
}
function createLayer(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded && (!('source' in props) || map.getSource(props.source))) {
        const options = {
            ...props,
            id
        };
        delete options.beforeId;
        // @ts-ignore
        map.addLayer(options, props.beforeId);
    }
}
/* eslint-enable complexity, max-statements */ let layerCounter = 0;
function Layer(props) {
    const map = (0, _react.useContext)((0, _map.MapContext)).map.getMap();
    const propsRef = (0, _react.useRef)(props);
    const [, setStyleLoaded] = (0, _react.useState)(0);
    const id = (0, _react.useMemo)(()=>props.id || `jsx-layer-${layerCounter++}`, []);
    (0, _react.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setStyleLoaded((version)=>version + 1);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getLayer(id)) map.removeLayer(id);
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    const layer = map && map.style && map.getLayer(id);
    if (layer) try {
        updateLayer(map, id, props, propsRef.current);
    } catch (error) {
        console.warn(error); // eslint-disable-line
    }
    else createLayer(map, id, props);
    // Store last rendered props
    propsRef.current = props;
    return null;
}
exports.default = Layer;

},{"react":"9njXz","./map":"2j6lb","../utils/assert":"GYkaD","../utils/deep-equal":"3ppfS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fFxhw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2LGap":[function() {},{}],"fxsJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getColor", ()=>getColor);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _reactMapGl = require("react-map-gl");
var _styles = require("@mui/material/styles");
var _types = require("common/api/v1/types");
var _markers = require("../Markers");
var _applianceActions = require("../../../../redux/actions/applianceActions");
var _utils = require("../../../../utils");
var _helpers = require("common/api/v1/helpers");
var _utils1 = require("common/utils");
var _util = require("common/util");
const getLocationString = (point)=>`${point[0]}:${point[1]}`;
/**
 * Returns points to show on map and connections between core nodes from different regions
 * @param appliances - array of GeoAppliances
 * @return {
 *   coreNodes: {'ltd:lng': {coordinates, name, id of coreNode}}
 *   coreConnections: {'ltd:lng-ltd:lng': [outputCoreNodeCoordinates, inputCoreNodeCoordinates]}
 *   dots: {'ltd:lng': array of appliances with these coordinates}
 * }
 */ const getMapObjects = (appliances)=>{
    const coreNodes = {};
    const dots = appliances.reduce((acc, appliance)=>{
        if (!appliance.geoLocation?.coordinates) return acc;
        if (appliance.type === (0, _types.ApplianceType).core && appliance.region) coreNodes[appliance.region.id] = {
            id: appliance.id,
            name: appliance.name,
            coordinates: appliance.geoLocation.coordinates
        };
        const applianceLocation = getLocationString(appliance.geoLocation.coordinates);
        const appliancesAtLocation = [
            ...acc[applianceLocation] || [],
            appliance
        ];
        return {
            ...acc,
            [applianceLocation]: appliancesAtLocation
        };
    }, {});
    const coreNodeValues = Object.values(coreNodes);
    const coreConnections = coreNodeValues.reduce((acc, { id, coordinates }, ind)=>{
        for(let i = ind + 1; i < coreNodeValues.length; i++){
            // Connect the core nodes in each region with all core nodes in each other region
            const dstAppliance = coreNodeValues[i];
            acc.push({
                srcApplianceId: id,
                srcApplianceCoords: coordinates,
                dstApplianceId: dstAppliance.id,
                dstApplianceCoords: dstAppliance.coordinates
            });
        }
        return acc;
    }, []);
    return {
        coreNodes,
        coreConnections,
        dots
    };
};
const getColor = (theme, isCoreNode = false)=>{
    const colors = {
        appliance: theme.palette.primary.main,
        coreNode: theme.palette.success.light
    };
    return !isCoreNode ? colors.appliance : colors.coreNode;
};
/**
 * Overview page map
 * Two iterations over dots map, since we have to first draw lines and then markers in order for markers to be on top
 */ const Appliances = ({ layerId, setPopup, featureEvents })=>{
    const theme = (0, _styles.useTheme)();
    const { current: map } = (0, _reactMapGl.useMap)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _applianceActions.getGeoAppliances)({
            rowsPerPage: '100',
            pageNumber: '0'
        }));
    }, [
        dispatch
    ]);
    const { loading, geoAppliances } = (0, _reactRedux.useSelector)(({ appliancesReducer })=>({
            loading: appliancesReducer.loading,
            geoAppliances: appliancesReducer.geoAppliances.map((ga)=>({
                    ...(0, _utils1.pick)(ga, 'id', 'name', 'type', 'region', 'geoLocation'),
                    owner: 'owner' in ga ? ga.owner : undefined
                }))
        }), (0, _util.equals));
    const { dots, coreNodes, coreConnections } = getMapObjects(geoAppliances);
    (0, _react.useEffect)(()=>{
        const points = Object.values(dots).reduce((acc, appliances)=>[
                ...acc,
                ...appliances.map((a)=>a.geoLocation?.coordinates)
            ], []);
        if (map && points.length) // Animations enabled makes map.getCenter() and map.getZoom() return the pre-fitBounds() values which causes setViewport()
        // not work and the map to jump around when the user starts dragging
        map.fitBounds((0, _utils.getBounds)(points), {
            padding: 40,
            animate: false
        });
    }, [
        map,
        geoAppliances
    ]);
    if (loading) return null;
    const circles = Object.entries(dots).map(([_, appliances], index)=>{
        const { geoLocation } = appliances[0];
        if (!geoLocation) return null;
        return {
            id: index,
            coordinates: geoLocation.coordinates,
            appliances
        };
    }).filter((0, _helpers.notUndefinedOrNull));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            coreConnections.map(({ srcApplianceId, srcApplianceCoords, dstApplianceId, dstApplianceCoords })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markers.Polyline), {
                    color: getColor(theme, true),
                    width: 2,
                    position: [
                        srcApplianceCoords,
                        dstApplianceCoords
                    ]
                }, `${srcApplianceId}-${dstApplianceId}`)),
            Object.entries(dots).map(([k, appliances])=>{
                const { geoLocation } = appliances[0];
                if (!geoLocation) return null;
                const point = geoLocation.coordinates;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                    children: appliances.map(({ region, type, id })=>{
                        if (type === (0, _types.ApplianceType).core) return null;
                        const { coordinates: coreNodeLocation } = region?.id && coreNodes[region.id] ? coreNodes[region.id] : {
                            coordinates: null
                        };
                        if (!coreNodeLocation) return null;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markers.Polyline), {
                            color: getColor(theme),
                            width: 2,
                            position: [
                                point,
                                coreNodeLocation
                            ]
                        }, `appliance-connection-${id}`);
                    })
                }, k);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markers.CircleMarkers), {
                layerId: layerId,
                circles: circles,
                featureEvents: featureEvents,
                setPopup: setPopup
            })
        ]
    });
};
exports.default = Appliances;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-map-gl":"7lAS3","@mui/material/styles":"2UrBk","common/api/v1/types":"3qemx","../Markers":"3iGxo","../../../../redux/actions/applianceActions":"TaoIu","../../../../utils":"342UB","common/api/v1/helpers":"6jovr","common/utils":"2AqiH","common/util":"jV4UZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3iGxo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleMarkers", ()=>CircleMarkers);
parcelHelpers.export(exports, "Polyline", ()=>Polyline);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactMapGl = require("react-map-gl");
var _styles = require("@mui/material/styles");
var _types = require("common/api/v1/types");
var _utils = require("../../../utils");
var _popup = require("./Popup");
const CircleMarkers = ({ layerId, circles, featureEvents, setPopup })=>{
    const theme = (0, _styles.useTheme)();
    const user = (0, _utils.useUser)();
    const { current: map } = (0, _reactMapGl.useMap)();
    const features = {
        type: 'FeatureCollection',
        features: circles.map((circle)=>({
                type: 'Feature',
                id: circle.id,
                properties: {
                    id: circle.id,
                    isCoreNode: circle.appliances[0].type === (0, _types.ApplianceType).core
                },
                geometry: {
                    type: 'Point',
                    coordinates: (0, _utils.toMapboxCoords)(circle.coordinates)
                }
            }))
    };
    (0, _react.useEffect)(()=>{
        const handleClick = (event)=>{
            const id = event.detail;
            const circle = circles.find((circle)=>circle.id === id);
            if (circle) setPopup({
                coordinates: circle.coordinates,
                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popup.AppliancesPopup), {
                    appliances: circle.appliances,
                    user: user
                })
            });
        };
        const handleMouseEnter = (event)=>{
            const id = event.detail;
            map?.setFeatureState({
                id,
                source: 'appliances'
            }, {
                hover: true
            });
        };
        const handleMouseLeave = (event)=>{
            const id = event.detail;
            map?.setFeatureState({
                id,
                source: 'appliances'
            }, {
                hover: false
            });
        };
        featureEvents.appliances.addEventListener('onClick', handleClick);
        featureEvents.appliances.addEventListener('onMouseEnter', handleMouseEnter);
        featureEvents.appliances.addEventListener('onMouseLeave', handleMouseLeave);
        return ()=>{
            featureEvents.appliances.removeEventListener('onClick', handleClick);
            featureEvents.appliances.removeEventListener('onMouseEnter', handleMouseEnter);
            featureEvents.appliances.removeEventListener('onMouseLeave', handleMouseLeave);
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactMapGl.Source), {
        id: "appliances",
        type: "geojson",
        data: features,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactMapGl.Layer), {
            id: layerId,
            type: "circle",
            paint: {
                'circle-color': '#ffffff',
                'circle-stroke-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'isCoreNode'
                        ],
                        false
                    ],
                    theme.palette.success.light,
                    theme.palette.primary.main
                ],
                'circle-stroke-width': 2,
                'circle-radius': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'hover'
                        ],
                        false
                    ],
                    4,
                    2
                ]
            }
        })
    });
};
const Polyline = ({ color, position, width })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactMapGl.Source), {
        type: "geojson",
        data: {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'LineString',
                        coordinates: [
                            (0, _utils.toMapboxCoords)(position[0]),
                            (0, _utils.toMapboxCoords)(position[1])
                        ]
                    }
                }
            ]
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactMapGl.Layer), {
            type: "line",
            paint: {
                'line-color': color,
                'line-width': width
            }
        })
    });

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-map-gl":"7lAS3","@mui/material/styles":"2UrBk","common/api/v1/types":"3qemx","../../../utils":"342UB","./Popup":"bMbWT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bMbWT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppliancePopup", ()=>AppliancePopup);
parcelHelpers.export(exports, "AppliancesPopup", ()=>AppliancesPopup);
var _jsxRuntime = require("react/jsx-runtime");
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _utils = require("../../../utils");
var _link = require("../../common/Link");
var _store = require("../../../store");
const AppliancePopup = ({ name, id, linkAvailable })=>{
    const routes = (0, _store.useRoutes)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        to: routes.appliancesUpdate({
            id
        }),
        underline: "hover",
        available: linkAvailable,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            component: "div",
            variant: "body2",
            children: name
        })
    });
};
const isGeoCoreNode = (appliance)=>(0, _utils.isCoreNode)(appliance.type);
const AppliancesPopup = ({ appliances, user })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
        dense: true,
        disablePadding: true,
        children: appliances.map((appliance)=>{
            const { name, id } = appliance;
            let hasAccessToNode = false;
            if (isGeoCoreNode(appliance)) hasAccessToNode = user.role === (0, _types.Role).super;
            else {
                const applianceOwner = (0, _utils.getApplianceOwnerId)(appliance);
                hasAccessToNode = user.role === (0, _types.Role).super || user.group === applianceOwner;
            }
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppliancePopup, {
                        name: name,
                        id: id,
                        linkAvailable: hasAccessToNode
                    })
                })
            }, `appliance-popup-${id}`);
        })
    });

},{"react/jsx-runtime":"1dlk8","@mui/material/List":"a52pA","@mui/material/ListItem":"fosVg","@mui/material/ListItemText":"1ZvGq","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../../utils":"342UB","../../common/Link":"l3o6V","../../../store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"50hhX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactAsyncHook = require("react-async-hook");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _outputsActions = require("../../../redux/actions/outputsActions");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _link = require("../../common/Link");
var _numericalDataSet = require("../../common/NumericalDataSet");
var _numericalDataSetDefault = parcelHelpers.interopDefault(_numericalDataSet);
var _utils = require("../../../utils");
var _store = require("../../../store");
var _userActions = require("../../../redux/actions/userActions");
const { userApi } = (0, _store.Api);
const trackEvent = {
    component: 'Availability'
};
const Availability = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _outputsActions.getTotalOutputCount)());
    }, [
        dispatch
    ]);
    const { total: outputsTotal, loading: outputsLoading } = (0, _reactRedux.useSelector)(({ outputsReducer })=>({
            total: outputsReducer.total,
            loading: outputsReducer.loading
        }), (0, _reactRedux.shallowEqual));
    const { loading: inputsLoading, total: inputsTotal } = (0, _utils.useInputsSelector)((0, _utils.DEFAULT_PAGINATION));
    const { loading: appliancesLoading, total: appliancesTotal, totalRegions } = (0, _utils.useApplianceSelector)((0, _utils.DEFAULT_PAGINATION));
    const users = (0, _reactAsyncHook.useAsync)(()=>(0, _userActions.getUsers)((0, _utils.DEFAULT_PAGINATION), {
            dispatch,
            userApi
        }), []);
    const routes = (0, _store.useRoutes)();
    const isPending = users.loading || appliancesLoading || inputsLoading || outputsLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
        pending: isPending,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                width: '100%'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _numericalDataSetDefault.default), {
                values: [
                    {
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: routes.inputs(),
                            underline: "hover",
                            trackEvent: trackEvent,
                            children: "Inputs available"
                        }),
                        value: inputsTotal
                    },
                    {
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: routes.outputs(),
                            underline: "hover",
                            trackEvent: trackEvent,
                            children: "Outputs available"
                        }),
                        value: outputsTotal
                    },
                    {
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: routes.users(),
                            underline: "hover",
                            trackEvent: trackEvent,
                            children: "User accounts"
                        }),
                        value: users.result?.total
                    },
                    {
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: routes.appliances(),
                            underline: "hover",
                            trackEvent: trackEvent,
                            children: "Appliances"
                        }),
                        value: appliancesTotal
                    },
                    {
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: routes.regions(),
                            underline: "hover",
                            trackEvent: trackEvent,
                            children: "Regions"
                        }),
                        value: totalRegions
                    }
                ]
            })
        })
    });
};
exports.default = Availability;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-async-hook":"3D6Y9","@mui/material/Box":"c4QkF","../../../redux/actions/outputsActions":"alMzI","../../common/Pendable":"gDN67","../../common/Link":"l3o6V","../../common/NumericalDataSet":"4YSqy","../../../utils":"342UB","../../../store":"5LXiG","../../../redux/actions/userActions":"2tWgd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4YSqy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
const classes = {
    list: {
        width: '100%'
    },
    item: {
        padding: '0',
        alignItems: 'baseline'
    },
    title: {
        flexGrow: 1,
        fontSize: (theme)=>`${theme.typography.h3.fontSize}`
    },
    value: {
        fontSize: (theme)=>`${theme.typography.h1.fontSize}`,
        fontWeight: 'bold',
        marginLeft: (theme)=>theme.spacing(4),
        whiteSpace: 'nowrap'
    }
};
const Line = ({ title, value })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
        sx: classes.item,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "div",
                sx: classes.title,
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "div",
                sx: classes.value,
                children: value
            })
        ]
    });
};
/**
 * Simple dataset with short (mostly numbers) values
 * @param values - array of {title, value} objects
 */ const NumericalDataSet = ({ values })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
        sx: classes.list,
        children: values.map(({ title, value }, ind)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Line, {
                title: title,
                value: value
            }, ind))
    });
};
exports.default = NumericalDataSet;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/List":"a52pA","@mui/material/ListItem":"fosVg","@mui/material/Typography":"6NtGx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fsrcu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Merge both input and output bitrates to one series while also handling missing entries in any of the series
parcelHelpers.export(exports, "transformData", ()=>transformData);
parcelHelpers.export(exports, "addNullToGaps", ()=>addNullToGaps);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _dateFns = require("date-fns");
var _recharts = require("recharts");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _notificationActions = require("../../../redux/actions/notificationActions");
var _common = require("../../../themes/common");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _utils = require("../../../utils");
var _failedFetchingContent = require("../../common/FailedFetchingContent");
const HEIGHT = 280;
const styles = {
    empty: {
        margin: 'auto',
        padding: (theme)=>theme.spacing(8, 0, 6)
    },
    container: {
        position: 'relative',
        width: '100%',
        height: `${HEIGHT}px`
    }
};
function transformData({ inputMaxBitrates, outputMaxBitrates }) {
    const dataPoints = new Map();
    for (const inputBitrate of inputMaxBitrates){
        const date = Date.parse(inputBitrate[0]);
        if (!dataPoints.has(date)) dataPoints.set(date, {
            timestamp: date,
            ingress: null,
            egress: null
        });
        dataPoints.set(date, {
            ...dataPoints.get(date),
            ingress: transformBitsToMegabits(inputBitrate[1])
        });
    }
    for (const outputBitrate of outputMaxBitrates){
        const date = Date.parse(outputBitrate[0]);
        if (!dataPoints.has(date)) dataPoints.set(date, {
            timestamp: date,
            ingress: null,
            egress: null
        });
        dataPoints.set(date, {
            ...dataPoints.get(date),
            egress: transformBitsToMegabits(outputBitrate[1])
        });
    }
    return addNullToGaps(Array.from(dataPoints.values()).sort((a, b)=>a.timestamp - b.timestamp));
}
const addNullToGaps = (dataPoints)=>{
    if (!dataPoints.length) return [];
    let prevTS = dataPoints[0].timestamp;
    const dataPointsWithNullGaps = [];
    for (const dataPoint of dataPoints){
        const ts = dataPoint.timestamp;
        if (ts - prevTS > 660000) // if gap larger than 11 minutes
        dataPointsWithNullGaps.push({
            timestamp: prevTS + 600000,
            ingress: null,
            egress: null
        });
        dataPointsWithNullGaps.push(dataPoint);
        prevTS = ts;
    }
    return dataPointsWithNullGaps;
};
const transformBitsToMegabits = (bits)=>{
    return bits === null ? null : bits / 1024 / 1024;
};
const dateToShortForm = (date)=>`${(0, _dateFns.format)(new Date(date), 'HH:mm')}`;
const Graph = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const user = (0, _utils.useUser)();
    const titlePrefix = user.role === (0, _types.Role).super ? 'Total' : 'Group';
    const [data, setData] = (0, _react.useState)(false);
    const timer = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const res = await (0, _store.Api).bitratesApi.readBitrates();
                setData({
                    series: transformData(res),
                    error: false
                });
            } catch (error) {
                dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                    error,
                    operation: 'fetch bitrate'
                }));
                setData({
                    error: true
                });
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        timer.current = setInterval(fetchData, 60000);
        fetchData();
        return ()=>{
            if (timer.current) clearInterval(timer.current);
        };
    }, [
        user
    ]);
    const theme = (0, _styles.useTheme)();
    if (data && data.error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _failedFetchingContent.FailedFetchingContent), {
        message: 'Failed to fetch ingress and egress bitrates.'
    });
    return data && !data.error && !data.series.length ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: styles.empty,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                align: "center",
                children: "Bitrate overview"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "body1",
                align: "center",
                children: "There is currently no ingress or egress related to this group."
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                variant: "dense",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "h2",
                    children: data && data.series && !data.series.length ? 'Currently no ingress or egress' : `${titlePrefix} ingress and egress`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: styles.container,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                    pending: !data,
                    children: data && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.ResponsiveContainer), {
                        width: "100%",
                        height: "100%",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _recharts.AreaChart), {
                            data: data.series,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.XAxis), {
                                    dataKey: "timestamp",
                                    type: 'number',
                                    domain: [
                                        Date.now() - 86400000,
                                        Date.now()
                                    ],
                                    tickFormatter: (value)=>dateToShortForm(value),
                                    stroke: "white",
                                    axisLine: {
                                        stroke: 'white'
                                    },
                                    tick: {
                                        fill: 'white'
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.YAxis), {
                                    stroke: "white",
                                    axisLine: {
                                        stroke: 'white'
                                    },
                                    tick: {
                                        fill: 'white'
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Tooltip), {
                                    contentStyle: {
                                        backgroundColor: 'black',
                                        color: 'white'
                                    },
                                    formatter: (value)=>typeof value === 'number' ? value.toFixed(3) : value,
                                    labelFormatter: (label)=>dateToShortForm(label)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Legend), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Area), {
                                    type: "monotone",
                                    dataKey: "ingress",
                                    dot: false,
                                    activeDot: {
                                        r: 4
                                    },
                                    unit: ' Mbps',
                                    fill: (0, _common.NimbraBlue)[100],
                                    fillOpacity: 0.5,
                                    stroke: (0, _common.NimbraBlue)[100],
                                    strokeWidth: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Area), {
                                    type: "monotone",
                                    dataKey: "egress",
                                    dot: false,
                                    activeDot: {
                                        r: 4
                                    },
                                    unit: ' Mbps',
                                    fill: theme.palette.primary.main,
                                    fillOpacity: 0.5,
                                    stroke: theme.palette.primary.main,
                                    strokeWidth: 2
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
exports.default = Graph;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","date-fns":"gelMX","recharts":"jCsOk","@mui/material/Box":"c4QkF","@mui/material/Toolbar":"5Kohb","@mui/material/Typography":"6NtGx","@mui/material/styles":"2UrBk","common/api/v1/types":"3qemx","../../../store":"5LXiG","../../../redux/actions/notificationActions":"7LkQg","../../../themes/common":"e6yiH","../../common/Pendable":"gDN67","../../../utils":"342UB","../../common/FailedFetchingContent":"dJi9P","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCsOk":[function(require,module,exports,__globalThis) {
// "export type" declarations on separate lines are in use
// to workaround babel issue(s) 11465 12578
//
// see https://github.com/babel/babel/issues/11464#issuecomment-617606898
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Surface", ()=>(0, _surface.Surface));
parcelHelpers.export(exports, "Layer", ()=>(0, _layer.Layer));
parcelHelpers.export(exports, "Legend", ()=>(0, _legend.Legend));
parcelHelpers.export(exports, "DefaultLegendContent", ()=>(0, _defaultLegendContent.DefaultLegendContent));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltip.Tooltip));
parcelHelpers.export(exports, "DefaultTooltipContent", ()=>(0, _defaultTooltipContent.DefaultTooltipContent));
parcelHelpers.export(exports, "ResponsiveContainer", ()=>(0, _responsiveContainer.ResponsiveContainer));
parcelHelpers.export(exports, "Cell", ()=>(0, _cell.Cell));
parcelHelpers.export(exports, "Text", ()=>(0, _text.Text));
parcelHelpers.export(exports, "Label", ()=>(0, _label.Label));
parcelHelpers.export(exports, "LabelList", ()=>(0, _labelList.LabelList));
parcelHelpers.export(exports, "Customized", ()=>(0, _customized.Customized));
parcelHelpers.export(exports, "Sector", ()=>(0, _sector.Sector));
parcelHelpers.export(exports, "Curve", ()=>(0, _curve.Curve));
parcelHelpers.export(exports, "Rectangle", ()=>(0, _rectangle.Rectangle));
parcelHelpers.export(exports, "Polygon", ()=>(0, _polygon.Polygon));
parcelHelpers.export(exports, "Dot", ()=>(0, _dot.Dot));
parcelHelpers.export(exports, "Cross", ()=>(0, _cross.Cross));
parcelHelpers.export(exports, "Symbols", ()=>(0, _symbols.Symbols));
parcelHelpers.export(exports, "PolarGrid", ()=>(0, _polarGrid.PolarGrid));
parcelHelpers.export(exports, "PolarRadiusAxis", ()=>(0, _polarRadiusAxis.PolarRadiusAxis));
parcelHelpers.export(exports, "PolarAngleAxis", ()=>(0, _polarAngleAxis.PolarAngleAxis));
parcelHelpers.export(exports, "Pie", ()=>(0, _pie.Pie));
parcelHelpers.export(exports, "Radar", ()=>(0, _radar.Radar));
parcelHelpers.export(exports, "RadialBar", ()=>(0, _radialBar.RadialBar));
parcelHelpers.export(exports, "Brush", ()=>(0, _brush.Brush));
parcelHelpers.export(exports, "ReferenceLine", ()=>(0, _referenceLine.ReferenceLine));
parcelHelpers.export(exports, "ReferenceDot", ()=>(0, _referenceDot.ReferenceDot));
parcelHelpers.export(exports, "ReferenceArea", ()=>(0, _referenceArea.ReferenceArea));
parcelHelpers.export(exports, "CartesianAxis", ()=>(0, _cartesianAxis.CartesianAxis));
parcelHelpers.export(exports, "CartesianGrid", ()=>(0, _cartesianGrid.CartesianGrid));
parcelHelpers.export(exports, "Line", ()=>(0, _line.Line));
parcelHelpers.export(exports, "Area", ()=>(0, _area.Area));
parcelHelpers.export(exports, "Bar", ()=>(0, _bar.Bar));
parcelHelpers.export(exports, "Scatter", ()=>(0, _scatter.Scatter));
parcelHelpers.export(exports, "XAxis", ()=>(0, _xaxis.XAxis));
parcelHelpers.export(exports, "YAxis", ()=>(0, _yaxis.YAxis));
parcelHelpers.export(exports, "ZAxis", ()=>(0, _zaxis.ZAxis));
parcelHelpers.export(exports, "ErrorBar", ()=>(0, _errorBar.ErrorBar));
parcelHelpers.export(exports, "LineChart", ()=>(0, _lineChart.LineChart));
parcelHelpers.export(exports, "BarChart", ()=>(0, _barChart.BarChart));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChart.PieChart));
parcelHelpers.export(exports, "Treemap", ()=>(0, _treemap.Treemap));
parcelHelpers.export(exports, "Sankey", ()=>(0, _sankey.Sankey));
parcelHelpers.export(exports, "RadarChart", ()=>(0, _radarChart.RadarChart));
parcelHelpers.export(exports, "ScatterChart", ()=>(0, _scatterChart.ScatterChart));
parcelHelpers.export(exports, "AreaChart", ()=>(0, _areaChart.AreaChart));
parcelHelpers.export(exports, "RadialBarChart", ()=>(0, _radialBarChart.RadialBarChart));
parcelHelpers.export(exports, "ComposedChart", ()=>(0, _composedChart.ComposedChart));
parcelHelpers.export(exports, "Funnel", ()=>(0, _funnel.Funnel));
parcelHelpers.export(exports, "FunnelChart", ()=>(0, _funnelChart.FunnelChart));
parcelHelpers.export(exports, "Trapezoid", ()=>(0, _trapezoid.Trapezoid));
parcelHelpers.export(exports, "Global", ()=>(0, _global.Global));
var _surface = require("./container/Surface");
var _layer = require("./container/Layer");
var _legend = require("./component/Legend");
var _defaultLegendContent = require("./component/DefaultLegendContent");
var _tooltip = require("./component/Tooltip");
var _defaultTooltipContent = require("./component/DefaultTooltipContent");
var _responsiveContainer = require("./component/ResponsiveContainer");
var _cell = require("./component/Cell");
var _text = require("./component/Text");
var _label = require("./component/Label");
var _labelList = require("./component/LabelList");
var _customized = require("./component/Customized");
var _sector = require("./shape/Sector");
var _curve = require("./shape/Curve");
var _rectangle = require("./shape/Rectangle");
var _polygon = require("./shape/Polygon");
var _dot = require("./shape/Dot");
var _cross = require("./shape/Cross");
var _symbols = require("./shape/Symbols");
var _polarGrid = require("./polar/PolarGrid");
var _polarRadiusAxis = require("./polar/PolarRadiusAxis");
var _polarAngleAxis = require("./polar/PolarAngleAxis");
var _pie = require("./polar/Pie");
var _radar = require("./polar/Radar");
var _radialBar = require("./polar/RadialBar");
var _brush = require("./cartesian/Brush");
var _referenceLine = require("./cartesian/ReferenceLine");
var _referenceDot = require("./cartesian/ReferenceDot");
var _referenceArea = require("./cartesian/ReferenceArea");
var _cartesianAxis = require("./cartesian/CartesianAxis");
var _cartesianGrid = require("./cartesian/CartesianGrid");
var _line = require("./cartesian/Line");
var _area = require("./cartesian/Area");
var _bar = require("./cartesian/Bar");
var _scatter = require("./cartesian/Scatter");
var _xaxis = require("./cartesian/XAxis");
var _yaxis = require("./cartesian/YAxis");
var _zaxis = require("./cartesian/ZAxis");
var _errorBar = require("./cartesian/ErrorBar");
var _lineChart = require("./chart/LineChart");
var _barChart = require("./chart/BarChart");
var _pieChart = require("./chart/PieChart");
var _treemap = require("./chart/Treemap");
var _sankey = require("./chart/Sankey");
var _radarChart = require("./chart/RadarChart");
var _scatterChart = require("./chart/ScatterChart");
var _areaChart = require("./chart/AreaChart");
var _radialBarChart = require("./chart/RadialBarChart");
var _composedChart = require("./chart/ComposedChart");
var _funnel = require("./numberAxis/Funnel");
var _funnelChart = require("./chart/FunnelChart");
var _trapezoid = require("./shape/Trapezoid");
var _global = require("./util/Global");

},{"./container/Surface":false,"./container/Layer":false,"./component/Legend":"dkfOy","./component/DefaultLegendContent":false,"./component/Tooltip":"lILc1","./component/DefaultTooltipContent":false,"./component/ResponsiveContainer":"8f9vd","./component/Cell":false,"./component/Text":false,"./component/Label":false,"./component/LabelList":false,"./component/Customized":false,"./shape/Sector":false,"./shape/Curve":false,"./shape/Rectangle":false,"./shape/Polygon":false,"./shape/Dot":false,"./shape/Cross":false,"./shape/Symbols":false,"./polar/PolarGrid":false,"./polar/PolarRadiusAxis":false,"./polar/PolarAngleAxis":false,"./polar/Pie":false,"./polar/Radar":false,"./polar/RadialBar":false,"./cartesian/Brush":false,"./cartesian/ReferenceLine":false,"./cartesian/ReferenceDot":false,"./cartesian/ReferenceArea":false,"./cartesian/CartesianAxis":false,"./cartesian/CartesianGrid":false,"./cartesian/Line":false,"./cartesian/Area":"12YNc","./cartesian/Bar":false,"./cartesian/Scatter":false,"./cartesian/XAxis":"g9bnS","./cartesian/YAxis":"01IPN","./cartesian/ZAxis":false,"./cartesian/ErrorBar":false,"./chart/LineChart":false,"./chart/BarChart":false,"./chart/PieChart":false,"./chart/Treemap":false,"./chart/Sankey":false,"./chart/RadarChart":false,"./chart/ScatterChart":false,"./chart/AreaChart":"asgQa","./chart/RadialBarChart":false,"./chart/ComposedChart":false,"./numberAxis/Funnel":false,"./chart/FunnelChart":false,"./shape/Trapezoid":false,"./util/Global":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l5HV0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Surface", ()=>Surface);
/**
 * @fileOverview Surface
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Surface(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = _objectWithoutProperties(props, _excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, _clsxDefault.default)('recharts-surface', className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({}, (0, _reactUtils.filterProps)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("desc", null, desc), children);
}

},{"react":"9njXz","clsx":"d2NWs","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lj4u0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SCALE_TYPES", ()=>SCALE_TYPES);
parcelHelpers.export(exports, "LEGEND_TYPES", ()=>LEGEND_TYPES);
parcelHelpers.export(exports, "TOOLTIP_TYPES", ()=>TOOLTIP_TYPES);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
parcelHelpers.export(exports, "toArray", ()=>toArray);
/*
 * Find and return all matched children by type.
 * `type` must be a React.ComponentType
 */ parcelHelpers.export(exports, "findAllByType", ()=>findAllByType);
/*
 * Return the first matched child by type, return null otherwise.
 * `type` must be a React.ComponentType
 */ parcelHelpers.export(exports, "findChildByType", ()=>findChildByType);
parcelHelpers.export(exports, "withoutType", ()=>withoutType);
parcelHelpers.export(exports, "validateWidthHeight", ()=>validateWidthHeight);
parcelHelpers.export(exports, "isDotProps", ()=>isDotProps);
parcelHelpers.export(exports, "isValidSpreadableProp", ()=>isValidSpreadableProp);
parcelHelpers.export(exports, "filterSvgElements", ()=>filterSvgElements);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "isChildrenEqual", ()=>isChildrenEqual);
parcelHelpers.export(exports, "isSingleChildEqual", ()=>isSingleChildEqual);
parcelHelpers.export(exports, "renderByOrder", ()=>renderByOrder);
parcelHelpers.export(exports, "getReactEventByType", ()=>getReactEventByType);
parcelHelpers.export(exports, "parseChildIndex", ()=>parseChildIndex);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _react = require("react");
var _reactIs = require("react-is");
var _dataUtils = require("./DataUtils");
var _shallowEqual = require("./ShallowEqual");
var _types = require("./types");
var _excluded = [
    "children"
], _excluded2 = [
    "children"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart'
};
var SCALE_TYPES = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var LEGEND_TYPES = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var TOOLTIP_TYPES = [
    'none'
];
var getDisplayName = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var lastChildren = null;
var lastResult = null;
var toArray = function toArray(children) {
    if (children === lastChildren && Array.isArray(lastResult)) return lastResult;
    var result = [];
    (0, _react.Children).forEach(children, function(child) {
        if ((0, _isNilDefault.default)(child)) return;
        if ((0, _reactIs.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    lastResult = result;
    lastChildren = children;
    return result;
};
function findAllByType(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return getDisplayName(t);
    });
    else types = [
        getDisplayName(type)
    ];
    toArray(children).forEach(function(child) {
        var childType = (0, _getDefault.default)(child, 'type.displayName') || (0, _getDefault.default)(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function findChildByType(children, type) {
    var result = findAllByType(children, type);
    return result && result[0];
}
var withoutType = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return getDisplayName(t);
    });
    else types = [
        getDisplayName(type)
    ];
    toArray(children).forEach(function(child) {
        var displayName = (0, _getDefault.default)(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var validateWidthHeight = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, _dataUtils.isNumber)(width) || width <= 0 || !(0, _dataUtils.isNumber)(height) || height <= 0) return false;
    return true;
};
var SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, _isStringDefault.default)(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
var isDotProps = function isDotProps(dot) {
    return dot && _typeof(dot) === 'object' && 'cx' in dot && 'cy' in dot && 'r' in dot;
};
var isValidSpreadableProp = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, _types.FilteredElementKeyMap) === null || (0, _types.FilteredElementKeyMap) === void 0 ? void 0 : (0, _types.FilteredElementKeyMap)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, _isFunctionDefault.default)(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, _types.SVGElementPropKeys).includes(key)) || includeEvents && (0, _types.EventKeys).includes(key);
};
var filterSvgElements = function filterSvgElements(children) {
    var svgElements = [];
    toArray(children).forEach(function(entry) {
        if (isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var filterProps = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(props)) inputProps = props.props;
    if (!(0, _isObjectDefault.default)(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if (isValidSpreadableProp((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, _react.Children).count(nextChildren);
    if (count !== (0, _react.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return isSingleChildEqual(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!isSingleChildEqual(nextChild, prevChild)) return false;
    }
    return true;
};
var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, _isNilDefault.default)(nextChild) && (0, _isNilDefault.default)(prevChild)) return true;
    if (!(0, _isNilDefault.default)(nextChild) && !(0, _isNilDefault.default)(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = _objectWithoutProperties(_ref, _excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = _objectWithoutProperties(_ref2, _excluded2);
        if (nextChildren && prevChildren) return (0, _shallowEqual.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, _shallowEqual.shallowEqual)(nextProps, prevProps);
        return false;
    }
    return false;
};
var renderByOrder = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    toArray(children).forEach(function(child, index) {
        if (isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = getDisplayName(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var getReactEventByType = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && REACT_BROWSER_EVENT_MAP[type]) return REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var parseChildIndex = function parseChildIndex(child, children) {
    return toArray(children).indexOf(child);
};

},{"lodash/get":"dBTJh","lodash/isNil":"eS6AM","lodash/isString":"5nkFr","lodash/isFunction":"3A7xI","lodash/isObject":"6hgJK","react":"9njXz","react-is":"3ILnA","./DataUtils":"5VTG4","./ShallowEqual":"5DwJA","./types":"c9QyM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eS6AM":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"5nkFr":[function(require,module,exports,__globalThis) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"5ltt8","46fdd4d2c5d7b4ab":"1DVeR","36ebbb6a9d8b3fe4":"4gOki"}],"3ILnA":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("89e91c2f3d031081");

},{"89e91c2f3d031081":"h3jeS"}],"h3jeS":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"5VTG4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mathSign", ()=>mathSign);
parcelHelpers.export(exports, "isPercent", ()=>isPercent);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isNumOrStr", ()=>isNumOrStr);
parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
parcelHelpers.export(exports, "getPercentValue", ()=>getPercentValue);
parcelHelpers.export(exports, "getAnyElementOfObject", ()=>getAnyElementOfObject);
parcelHelpers.export(exports, "hasDuplicate", ()=>hasDuplicate);
parcelHelpers.export(exports, "interpolateNumber", ()=>interpolateNumber);
parcelHelpers.export(exports, "findEntryInArray", ()=>findEntryInArray);
parcelHelpers.export(exports, "getLinearRegression", ()=>getLinearRegression);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var mathSign = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var isPercent = function isPercent(value) {
    return (0, _isStringDefault.default)(value) && value.indexOf('%') === value.length - 1;
};
var isNumber = function isNumber(value) {
    return (0, _isNumberDefault.default)(value) && !(0, _isNaNDefault.default)(value);
};
var isNumOrStr = function isNumOrStr(value) {
    return isNumber(value) || (0, _isStringDefault.default)(value);
};
var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
    var id = ++idCounter;
    return "".concat(prefix || '').concat(id);
};
var getPercentValue = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!isNumber(percent) && !(0, _isStringDefault.default)(percent)) return defaultValue;
    var value;
    if (isPercent(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, _isNaNDefault.default)(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var getAnyElementOfObject = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var hasDuplicate = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var interpolateNumber = function interpolateNumber(numberA, numberB) {
    if (isNumber(numberA) && isNumber(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function findEntryInArray(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, _getDefault.default)(entry, specifiedKey)) === specifiedValue;
    });
}
var getLinearRegression = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};

},{"lodash/isString":"5nkFr","lodash/isNaN":"ih06S","lodash/get":"dBTJh","lodash/isNumber":"cJnL5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ih06S":[function(require,module,exports,__globalThis) {
var isNumber = require("3426dfbd8f8be7c7");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return isNumber(value) && value != +value;
}
module.exports = isNaN;

},{"3426dfbd8f8be7c7":"cJnL5"}],"cJnL5":[function(require,module,exports,__globalThis) {
var baseGetTag = require("d5df50bb79e32710"), isObjectLike = require("6ae0825ac2dae50f");
/** `Object#toString` result references. */ var numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
}
module.exports = isNumber;

},{"d5df50bb79e32710":"5ltt8","6ae0825ac2dae50f":"4gOki"}],"5DwJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
function shallowEqual(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c9QyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SVGElementPropKeys", ()=>SVGElementPropKeys);
parcelHelpers.export(exports, "FilteredElementKeyMap", ()=>FilteredElementKeyMap);
parcelHelpers.export(exports, "EventKeys", ()=>EventKeys);
parcelHelpers.export(exports, "adaptEventHandlers", ()=>adaptEventHandlers);
parcelHelpers.export(exports, "adaptEventsOfChild", ()=>adaptEventsOfChild);
var _react = require("react");
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var SVGElementPropKeys = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var PolyElementKeys = [
    'points',
    'pathLength'
];
var FilteredElementKeyMap = {
    svg: SVGContainerPropKeys,
    polygon: PolyElementKeys,
    polyline: PolyElementKeys
};
var EventKeys = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var adaptEventHandlers = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(props)) inputProps = props.props;
    if (!(0, _isObjectDefault.default)(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if (EventKeys.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var adaptEventsOfChild = function adaptEventsOfChild(props, data, index) {
    if (!(0, _isObjectDefault.default)(props) || _typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if (EventKeys.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};

},{"react":"9njXz","lodash/isObject":"6hgJK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Q0HG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", ()=>Layer);
/**
 * @fileOverview Layer
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "children",
    "className"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Layer = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = _objectWithoutProperties(props, _excluded);
    var layerClass = (0, _clsxDefault.default)('recharts-layer', className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", _extends({
        className: layerClass
    }, (0, _reactUtils.filterProps)(others, true), {
        ref: ref
    }), children);
});

},{"react":"9njXz","clsx":"d2NWs","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dkfOy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Legend", ()=>Legend);
/**
 * @fileOverview Legend
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _defaultLegendContent = require("./DefaultLegendContent");
var _dataUtils = require("../util/DataUtils");
var _getUniqPayload = require("../util/payload/getUniqPayload");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "ref"
];
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function defaultUniqBy(entry) {
    return entry.value;
}
function renderContent(content, props) {
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(content)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, _reactDefault.default).createElement(content, props);
    var ref = props.ref, otherProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultLegendContent.DefaultLegendContent), otherProps);
}
var EPS = 1;
var Legend = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Legend, _PureComponent);
    var _super = _createSuper(Legend);
    function Legend() {
        var _this;
        _classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    _createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box.width - this.lastBoundingBox.width) > EPS || Math.abs(_box.height - this.lastBoundingBox.height) > EPS) {
                        this.lastBoundingBox.width = _box.width;
                        this.lastBoundingBox.height = _box.height;
                        if (onBBoxUpdate) onBBoxUpdate(_box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return _objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var _box2 = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - _box2.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box3 = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box3.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return _objectSpread(_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = _objectSpread(_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, renderContent(content, _objectSpread(_objectSpread({}, this.props), {}, {
                    payload: (0, _getUniqPayload.getUniqPayload)(payload, payloadUniqBy, defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === 'vertical' && (0, _dataUtils.isNumber)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, _react.PureComponent));
_defineProperty(Legend, "displayName", 'Legend');
_defineProperty(Legend, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});

},{"react":"9njXz","./DefaultLegendContent":"8US9o","../util/DataUtils":"5VTG4","../util/payload/getUniqPayload":"cyyuN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8US9o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultLegendContent", ()=>DefaultLegendContent);
/**
 * @fileOverview Default Legend Content
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _logUtils = require("../util/LogUtils");
var _surface = require("../container/Surface");
var _symbols = require("../shape/Symbols");
var _types = require("../util/types");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var SIZE = 32;
var DefaultLegendContent = /*#__PURE__*/ function(_PureComponent) {
    _inherits(DefaultLegendContent, _PureComponent);
    var _super = _createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        _classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    _createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = SIZE / 2;
                var sixthSize = SIZE / 6;
                var thirdSize = SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(data.legendIcon)) {
                    var iconProps = _objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _symbols.Symbols), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: SIZE,
                    height: SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _clsx;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, _clsxDefault.default)((_clsx = {
                        'recharts-legend-item': true
                    }, _defineProperty(_clsx, "legend-item-".concat(i), true), _defineProperty(_clsx, "inactive", entry.inactive), _clsx));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, _isFunctionDefault.default)(entry.value) ? entry.value : null;
                    (0, _logUtils.warn)(!(0, _isFunctionDefault.default)(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", _extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, _react.PureComponent));
_defineProperty(DefaultLegendContent, "displayName", 'Legend');
_defineProperty(DefaultLegendContent, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});

},{"react":"9njXz","lodash/isFunction":"3A7xI","clsx":"d2NWs","../util/LogUtils":"2yNyz","../container/Surface":"l5HV0","../shape/Symbols":"gQKDd","../util/types":"c9QyM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2yNyz":[function(require,module,exports,__globalThis) {
/* eslint no-console: 0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", ()=>warn);
var isDev = false;
var warn = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if (isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gQKDd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Symbols", ()=>Symbols);
/**
 * @fileOverview Curve
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _d3Shape = require("victory-vendor/d3-shape");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "type",
    "size",
    "sizeType"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var symbolFactories = {
    symbolCircle: (0, _d3Shape.symbolCircle),
    symbolCross: (0, _d3Shape.symbolCross),
    symbolDiamond: (0, _d3Shape.symbolDiamond),
    symbolSquare: (0, _d3Shape.symbolSquare),
    symbolStar: (0, _d3Shape.symbolStar),
    symbolTriangle: (0, _d3Shape.symbolTriangle),
    symbolWye: (0, _d3Shape.symbolWye)
};
var RADIAN = Math.PI / 180;
var getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, _upperFirstDefault.default)(type));
    return symbolFactories[name] || (0, _d3Shape.symbolCircle);
};
var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var registerSymbol = function registerSymbol(key, factory) {
    symbolFactories["symbol".concat((0, _upperFirstDefault.default)(key))] = factory;
};
var Symbols = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread(_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = getSymbolFactory(type);
        var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, _reactUtils.filterProps)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, filteredProps, {
        className: (0, _clsxDefault.default)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
Symbols.registerSymbol = registerSymbol;

},{"react":"9njXz","lodash/upperFirst":"eSJZa","victory-vendor/d3-shape":"fFCVX","clsx":"d2NWs","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fFCVX":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("19271802296fa753");

},{"19271802296fa753":"id8VC"}],"id8VC":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`
module.exports = require("176bd3ee52fdecae");

},{"176bd3ee52fdecae":"41gzd"}],"41gzd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "arc", {
    enumerable: true,
    get: function() {
        return _arc.default;
    }
});
Object.defineProperty(exports, "area", {
    enumerable: true,
    get: function() {
        return _area.default;
    }
});
Object.defineProperty(exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return _basisOpen.default;
    }
});
Object.defineProperty(exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return _bump.bumpX;
    }
});
Object.defineProperty(exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return _bump.bumpY;
    }
});
Object.defineProperty(exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return _bundle.default;
    }
});
Object.defineProperty(exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return _cardinal.default;
    }
});
Object.defineProperty(exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return _cardinalClosed.default;
    }
});
Object.defineProperty(exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return _cardinalOpen.default;
    }
});
Object.defineProperty(exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return _catmullRom.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return _catmullRomClosed.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return _catmullRomOpen.default;
    }
});
Object.defineProperty(exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return _linearClosed.default;
    }
});
Object.defineProperty(exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return _monotone.monotoneX;
    }
});
Object.defineProperty(exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return _monotone.monotoneY;
    }
});
Object.defineProperty(exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return _natural.default;
    }
});
Object.defineProperty(exports, "curveStep", {
    enumerable: true,
    get: function() {
        return _step.default;
    }
});
Object.defineProperty(exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return _step.stepAfter;
    }
});
Object.defineProperty(exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return _step.stepBefore;
    }
});
Object.defineProperty(exports, "line", {
    enumerable: true,
    get: function() {
        return _line.default;
    }
});
Object.defineProperty(exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "link", {
    enumerable: true,
    get: function() {
        return _link.link;
    }
});
Object.defineProperty(exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return _link.linkHorizontal;
    }
});
Object.defineProperty(exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return _link.linkRadial;
    }
});
Object.defineProperty(exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return _link.linkVertical;
    }
});
Object.defineProperty(exports, "pie", {
    enumerable: true,
    get: function() {
        return _pie.default;
    }
});
Object.defineProperty(exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return _pointRadial.default;
    }
});
Object.defineProperty(exports, "radialArea", {
    enumerable: true,
    get: function() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "radialLine", {
    enumerable: true,
    get: function() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "stack", {
    enumerable: true,
    get: function() {
        return _stack.default;
    }
});
Object.defineProperty(exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return _expand.default;
    }
});
Object.defineProperty(exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return _none.default;
    }
});
Object.defineProperty(exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return _silhouette.default;
    }
});
Object.defineProperty(exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return _wiggle.default;
    }
});
Object.defineProperty(exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return _appearance.default;
    }
});
Object.defineProperty(exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return _insideOut.default;
    }
});
Object.defineProperty(exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return _none2.default;
    }
});
Object.defineProperty(exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "symbol", {
    enumerable: true,
    get: function() {
        return _symbol.default;
    }
});
Object.defineProperty(exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return _asterisk.default;
    }
});
Object.defineProperty(exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return _circle.default;
    }
});
Object.defineProperty(exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return _diamond.default;
    }
});
Object.defineProperty(exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return _diamond2.default;
    }
});
Object.defineProperty(exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return _plus.default;
    }
});
Object.defineProperty(exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return _square.default;
    }
});
Object.defineProperty(exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return _square2.default;
    }
});
Object.defineProperty(exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return _star.default;
    }
});
Object.defineProperty(exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return _triangle.default;
    }
});
Object.defineProperty(exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return _triangle2.default;
    }
});
Object.defineProperty(exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return _wye.default;
    }
});
Object.defineProperty(exports, "symbolX", {
    enumerable: true,
    get: function() {
        return _x.default;
    }
});
Object.defineProperty(exports, "symbols", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsStroke;
    }
});
var _arc = _interopRequireDefault(require("2d3f5974235d4d97"));
var _area = _interopRequireDefault(require("e7d6d9d0e4901d2e"));
var _line = _interopRequireDefault(require("bce35bc16739dbe5"));
var _pie = _interopRequireDefault(require("74b9b0848a30f56d"));
var _areaRadial = _interopRequireDefault(require("795a4987e33fc84"));
var _lineRadial = _interopRequireDefault(require("b1ce66d1195c070b"));
var _pointRadial = _interopRequireDefault(require("18b93f5355310e1c"));
var _link = require("661c14c96c31c97d");
var _symbol = _interopRequireWildcard(require("974cd54b219b5407"));
var _asterisk = _interopRequireDefault(require("3237a04f4f14fca5"));
var _circle = _interopRequireDefault(require("d06ad8106b0de21c"));
var _cross = _interopRequireDefault(require("871a2983fe1eb51f"));
var _diamond = _interopRequireDefault(require("d1ef85359a4dd212"));
var _diamond2 = _interopRequireDefault(require("3dea65984f117ec1"));
var _plus = _interopRequireDefault(require("1565ec3cf1a7613a"));
var _square = _interopRequireDefault(require("9285c34ad7b613e4"));
var _square2 = _interopRequireDefault(require("c6e9c9d35fa5b5cb"));
var _star = _interopRequireDefault(require("815abfb8fc8798e0"));
var _triangle = _interopRequireDefault(require("431e53334965b545"));
var _triangle2 = _interopRequireDefault(require("64d0ff16b783fd6c"));
var _wye = _interopRequireDefault(require("6bcb4260ac11e7b8"));
var _x = _interopRequireDefault(require("f8ed4fd677a8b4d9"));
var _basisClosed = _interopRequireDefault(require("91e47160fd76a75d"));
var _basisOpen = _interopRequireDefault(require("3cfac39a85530a37"));
var _basis = _interopRequireDefault(require("f697ba81082957cf"));
var _bump = require("2bea78dcacfdca47");
var _bundle = _interopRequireDefault(require("e82aff58f59c7695"));
var _cardinalClosed = _interopRequireDefault(require("c72e75e517eac392"));
var _cardinalOpen = _interopRequireDefault(require("9217e81617e05b4"));
var _cardinal = _interopRequireDefault(require("1dd79a3764c6f2bf"));
var _catmullRomClosed = _interopRequireDefault(require("aee7da70ecf7456b"));
var _catmullRomOpen = _interopRequireDefault(require("6d5f31fa960dcbe2"));
var _catmullRom = _interopRequireDefault(require("3a4d3052f18b3d40"));
var _linearClosed = _interopRequireDefault(require("46142d6a54d00966"));
var _linear = _interopRequireDefault(require("e55fce1282a99ed7"));
var _monotone = require("fad9762fa89b7933");
var _natural = _interopRequireDefault(require("188623ab79fe5f6b"));
var _step = _interopRequireWildcard(require("48bb2877ede27508"));
var _stack = _interopRequireDefault(require("39fd6af83767c8b0"));
var _expand = _interopRequireDefault(require("17e05ad95922030d"));
var _diverging = _interopRequireDefault(require("a216beddff4c3a08"));
var _none = _interopRequireDefault(require("b09a2130bd13b1e0"));
var _silhouette = _interopRequireDefault(require("70400e7acef40477"));
var _wiggle = _interopRequireDefault(require("b9b44fd8f75e0415"));
var _appearance = _interopRequireDefault(require("fd3023466e7ac9e7"));
var _ascending = _interopRequireDefault(require("46c02ef8fc93b026"));
var _descending = _interopRequireDefault(require("a5a0ae33dd14b3b0"));
var _insideOut = _interopRequireDefault(require("43469f5cea84b12e"));
var _none2 = _interopRequireDefault(require("68f36eef1efe200b"));
var _reverse = _interopRequireDefault(require("a5f086840207a549"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"2d3f5974235d4d97":"8qV0g","e7d6d9d0e4901d2e":"jjQ9H","bce35bc16739dbe5":"dbdXT","74b9b0848a30f56d":"h1CxD","795a4987e33fc84":"fLCVI","b1ce66d1195c070b":"8d9sy","18b93f5355310e1c":"lCE22","661c14c96c31c97d":"2XXDw","974cd54b219b5407":"gubrc","3237a04f4f14fca5":"lfDUF","d06ad8106b0de21c":"8ERZC","871a2983fe1eb51f":"77xCF","d1ef85359a4dd212":"bv2cQ","3dea65984f117ec1":"fCTOE","1565ec3cf1a7613a":"bFnZs","9285c34ad7b613e4":"gkmNn","c6e9c9d35fa5b5cb":"cQPuJ","815abfb8fc8798e0":"6PQyS","431e53334965b545":"4e1xB","64d0ff16b783fd6c":"2hwOo","6bcb4260ac11e7b8":"aagnu","f8ed4fd677a8b4d9":"4HZke","91e47160fd76a75d":"fkrKY","3cfac39a85530a37":"etkov","f697ba81082957cf":"83GJ4","2bea78dcacfdca47":"ks8jm","e82aff58f59c7695":"7skup","c72e75e517eac392":"lbqOC","9217e81617e05b4":"cDURi","1dd79a3764c6f2bf":"fXB4s","aee7da70ecf7456b":"95i35","6d5f31fa960dcbe2":"eJAdl","3a4d3052f18b3d40":"2TcOO","46142d6a54d00966":"aE37P","e55fce1282a99ed7":"g4V16","fad9762fa89b7933":"8gAzl","188623ab79fe5f6b":"eMH6q","48bb2877ede27508":"bJOXa","39fd6af83767c8b0":"1Ocq7","17e05ad95922030d":"6IDoF","a216beddff4c3a08":"eaApZ","b09a2130bd13b1e0":"jsWcZ","70400e7acef40477":"ies3f","b9b44fd8f75e0415":"bR7O5","fd3023466e7ac9e7":"7wEjH","46c02ef8fc93b026":"0401Z","a5a0ae33dd14b3b0":"j8E15","43469f5cea84b12e":"5xK7H","68f36eef1efe200b":"g2g16","a5f086840207a549":"jkzh6"}],"8qV0g":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("9b71135f97bb0843");
var _constant = _interopRequireDefault(require("b66d56b93af4da33"));
var _math = require("53b6f54f25927f26");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < _math.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _math.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _math.sqrt)((0, _math.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function _default() {
    var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constant.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - _math.halfPi, a1 = endAngle.apply(this, arguments) - _math.halfPi, da = (0, _math.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, _index.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > _math.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > _math.tau - _math.epsilon) {
            context.moveTo(r1 * (0, _math.cos)(a0), r1 * (0, _math.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > _math.epsilon) {
                context.moveTo(r0 * (0, _math.cos)(a1), r0 * (0, _math.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > _math.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, _math.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _math.min)((0, _math.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > _math.epsilon) {
                var p0 = (0, _math.asin)(rp / r0 * (0, _math.sin)(ap)), p1 = (0, _math.asin)(rp / r1 * (0, _math.sin)(ap));
                if ((da0 -= p0 * 2) > _math.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > _math.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, _math.cos)(a01), y01 = r1 * (0, _math.sin)(a01), x10 = r0 * (0, _math.cos)(a10), y10 = r0 * (0, _math.sin)(a10); // Apply rounded corners?
            if (rc > _math.epsilon) {
                var x11 = r1 * (0, _math.cos)(a11), y11 = r1 * (0, _math.sin)(a11), x00 = r0 * (0, _math.cos)(a00), y00 = r0 * (0, _math.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < _math.pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _math.sin)((0, _math.acos)((ax * bx + ay * by) / ((0, _math.sqrt)(ax * ax + ay * ay) * (0, _math.sqrt)(bx * bx + by * by))) / 2), lc = (0, _math.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, _math.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, _math.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > _math.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > _math.epsilon) {
                t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > _math.epsilon) || !(da0 > _math.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > _math.epsilon) {
                t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - _math.pi / 2;
        return [
            (0, _math.cos)(a) * r,
            (0, _math.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

},{"9b71135f97bb0843":"6rSRK","b66d56b93af4da33":"2NJag","53b6f54f25927f26":"7oqaJ"}],"6rSRK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "path", {
    enumerable: true,
    get: function() {
        return _path.default;
    }
});
var _path = _interopRequireDefault(require("3b0cf72f61f38e1e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"3b0cf72f61f38e1e":"dUcix"}],"dUcix":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path();
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var _default = path;
exports.default = _default;

},{}],"2NJag":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return function constant() {
        return x;
    };
}

},{}],"7oqaJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.abs = void 0;
exports.acos = acos;
exports.asin = asin;
exports.tau = exports.sqrt = exports.sin = exports.pi = exports.min = exports.max = exports.halfPi = exports.epsilon = exports.cos = exports.atan2 = void 0;
const abs = Math.abs;
exports.abs = abs;
const atan2 = Math.atan2;
exports.atan2 = atan2;
const cos = Math.cos;
exports.cos = cos;
const max = Math.max;
exports.max = max;
const min = Math.min;
exports.min = min;
const sin = Math.sin;
exports.sin = sin;
const sqrt = Math.sqrt;
exports.sqrt = sqrt;
const epsilon = 1e-12;
exports.epsilon = epsilon;
const pi = Math.PI;
exports.pi = pi;
const halfPi = pi / 2;
exports.halfPi = halfPi;
const tau = 2 * pi;
exports.tau = tau;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{}],"jjQ9H":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("500493761fddc3b8");
var _array = _interopRequireDefault(require("bbf8fdbd92f1ebcd"));
var _constant = _interopRequireDefault(require("a5b783eee5be8fa0"));
var _linear = _interopRequireDefault(require("f4129b2496ff7a8b"));
var _line = _interopRequireDefault(require("b3caf3b68a2e9f58"));
var _point = require("ea923553657b0095");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x0, y0, y1) {
    var x1 = null, defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? _point.x : (0, _constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constant.default)(0) : (0, _constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? _point.y : (0, _constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, _line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

},{"500493761fddc3b8":"6rSRK","bbf8fdbd92f1ebcd":"1QzK0","a5b783eee5be8fa0":"2NJag","f4129b2496ff7a8b":"g4V16","b3caf3b68a2e9f58":"dbdXT","ea923553657b0095":"buAQ8"}],"1QzK0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.slice = void 0;
var slice = Array.prototype.slice;
exports.slice = slice;
function _default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

},{}],"g4V16":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function _default(context) {
    return new Linear(context);
}

},{}],"dbdXT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("98710a8cd2690312");
var _array = _interopRequireDefault(require("71eeea1751dcd149"));
var _constant = _interopRequireDefault(require("9083cb1503140862"));
var _linear = _interopRequireDefault(require("c81bc5ab811126a3"));
var _point = require("552145ba71b64707");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x, y) {
    var defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? _point.x : (0, _constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? _point.y : (0, _constant.default)(y);
    function line(data) {
        var i, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

},{"98710a8cd2690312":"6rSRK","71eeea1751dcd149":"1QzK0","9083cb1503140862":"2NJag","c81bc5ab811126a3":"g4V16","552145ba71b64707":"buAQ8"}],"buAQ8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.x = x;
exports.y = y;
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{}],"h1CxD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("b67e0ae37b57d123"));
var _constant = _interopRequireDefault(require("37710d2df9ce0c7a"));
var _descending = _interopRequireDefault(require("a28172d9eab0febf"));
var _identity = _interopRequireDefault(require("e5c1f58030d4bf4f"));
var _math = require("496c2d9cd8d2f75c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default() {
    var value = _identity.default, sortValues = _descending.default, sort = null, startAngle = (0, _constant.default)(0), endAngle = (0, _constant.default)(_math.tau), padAngle = (0, _constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, _array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(_math.tau, Math.max(-_math.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

},{"b67e0ae37b57d123":"1QzK0","37710d2df9ce0c7a":"2NJag","a28172d9eab0febf":"8cCCu","e5c1f58030d4bf4f":"9DY5R","496c2d9cd8d2f75c":"7oqaJ"}],"8cCCu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"9DY5R":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(d) {
    return d;
}

},{}],"fLCVI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _radial = _interopRequireWildcard(require("d5f2199be7e4428"));
var _area = _interopRequireDefault(require("9fd6b69a882b62b9"));
var _lineRadial = require("4727a97bf0f56e5e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _default() {
    var a = (0, _area.default)().curve(_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, _lineRadial.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, _lineRadial.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, _lineRadial.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, _lineRadial.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return a;
}

},{"d5f2199be7e4428":"1lOJH","9fd6b69a882b62b9":"jjQ9H","4727a97bf0f56e5e":"8d9sy"}],"1lOJH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.curveRadialLinear = void 0;
exports.default = curveRadial;
var _linear = _interopRequireDefault(require("fcbc4ed98c33ce63"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var curveRadialLinear = curveRadial(_linear.default);
exports.curveRadialLinear = curveRadialLinear;
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"fcbc4ed98c33ce63":"g4V16"}],"8d9sy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.lineRadial = lineRadial;
var _radial = _interopRequireWildcard(require("467073d1fc4d6144"));
var _line = _interopRequireDefault(require("b165a0178810938"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return l;
}
function _default() {
    return lineRadial((0, _line.default)().curve(_radial.curveRadialLinear));
}

},{"467073d1fc4d6144":"1lOJH","b165a0178810938":"dbdXT"}],"lCE22":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

},{}],"2XXDw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.link = link;
exports.linkHorizontal = linkHorizontal;
exports.linkRadial = linkRadial;
exports.linkVertical = linkVertical;
var _index = require("ae6bae8009c48266");
var _array = require("3bac10be5f465a96");
var _constant = _interopRequireDefault(require("35364e9c346d01b7"));
var _bump = require("ce2d1a2cbddf3802");
var _point = require("be0eb0a3ebd67c05");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    let source = linkSource;
    let target = linkTarget;
    let x = _point.x;
    let y = _point.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = _array.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, _index.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function linkHorizontal() {
    return link(_bump.bumpX);
}
function linkVertical() {
    return link(_bump.bumpY);
}
function linkRadial() {
    const l = link(_bump.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"ae6bae8009c48266":"6rSRK","3bac10be5f465a96":"1QzK0","35364e9c346d01b7":"2NJag","ce2d1a2cbddf3802":"ks8jm","be0eb0a3ebd67c05":"buAQ8"}],"ks8jm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bumpRadial = bumpRadial;
exports.bumpX = bumpX;
exports.bumpY = bumpY;
var _pointRadial = _interopRequireDefault(require("b619d14f2ed97e73"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, _pointRadial.default)(this._x0, this._y0);
            const p1 = (0, _pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, _pointRadial.default)(x, this._y0);
            const p3 = (0, _pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function bumpX(context) {
    return new Bump(context, true);
}
function bumpY(context) {
    return new Bump(context, false);
}
function bumpRadial(context) {
    return new BumpRadial(context);
}

},{"b619d14f2ed97e73":"lCE22"}],"gubrc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Symbol;
exports.symbolsStroke = exports.symbolsFill = void 0;
var _index = require("ed221954c3cadd8c");
var _constant = _interopRequireDefault(require("a318f579ae289bb4"));
var _asterisk = _interopRequireDefault(require("4f836b828c4aee2"));
var _circle = _interopRequireDefault(require("a3d59dddf62412f7"));
var _cross = _interopRequireDefault(require("b51ad47cf070e0d4"));
var _diamond = _interopRequireDefault(require("a8375ed091b8d08a"));
var _diamond2 = _interopRequireDefault(require("7c0f9eaf6c7614f0"));
var _plus = _interopRequireDefault(require("459ff396a52f1e2d"));
var _square = _interopRequireDefault(require("174dac6271fe5f76"));
var _square2 = _interopRequireDefault(require("444710f2180a0669"));
var _star = _interopRequireDefault(require("1f31f8ec57f98fa6"));
var _triangle = _interopRequireDefault(require("f4d77aaf9ffb5dbd"));
var _triangle2 = _interopRequireDefault(require("80c17c4ac5160020"));
var _wye = _interopRequireDefault(require("2da15e99e0fdb804"));
var _x = _interopRequireDefault(require("67fc72d8d3ef7cbf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const symbolsFill = [
    _circle.default,
    _cross.default,
    _diamond.default,
    _square.default,
    _star.default,
    _triangle.default,
    _wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
exports.symbolsFill = symbolsFill;
const symbolsStroke = [
    _circle.default,
    _plus.default,
    _x.default,
    _triangle2.default,
    _asterisk.default,
    _square2.default,
    _diamond2.default
];
exports.symbolsStroke = symbolsStroke;
function Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, _constant.default)(type || _circle.default);
    size = typeof size === "function" ? size : (0, _constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, _index.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

},{"ed221954c3cadd8c":"6rSRK","a318f579ae289bb4":"2NJag","4f836b828c4aee2":"lfDUF","a3d59dddf62412f7":"8ERZC","b51ad47cf070e0d4":"77xCF","a8375ed091b8d08a":"bv2cQ","7c0f9eaf6c7614f0":"fCTOE","459ff396a52f1e2d":"bFnZs","174dac6271fe5f76":"gkmNn","444710f2180a0669":"cQPuJ","1f31f8ec57f98fa6":"6PQyS","f4d77aaf9ffb5dbd":"4e1xB","80c17c4ac5160020":"2hwOo","2da15e99e0fdb804":"aagnu","67fc72d8d3ef7cbf":"4HZke"}],"lfDUF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("48d3e9f7df1a172c");
const sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size + (0, _math.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
exports.default = _default;

},{"48d3e9f7df1a172c":"7oqaJ"}],"8ERZC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("8ed2e3009b93c9bf");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / _math.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, _math.tau);
    }
};
exports.default = _default;

},{"8ed2e3009b93c9bf":"7oqaJ"}],"77xCF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("69815bae4b0787ae");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
exports.default = _default;

},{"69815bae4b0787ae":"7oqaJ"}],"bv2cQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("856b74e87be6d6a0");
const tan30 = (0, _math.sqrt)(1 / 3);
const tan30_2 = tan30 * 2;
var _default = {
    draw (context, size) {
        const y = (0, _math.sqrt)(size / tan30_2);
        const x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
exports.default = _default;

},{"856b74e87be6d6a0":"7oqaJ"}],"fCTOE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("c8441956b7ca25b0");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
exports.default = _default;

},{"c8441956b7ca25b0":"7oqaJ"}],"bFnZs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("a4abcfa52e8b0f37");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size - (0, _math.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
exports.default = _default;

},{"a4abcfa52e8b0f37":"7oqaJ"}],"gkmNn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("e72da19a42674d7c");
var _default = {
    draw (context, size) {
        const w = (0, _math.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
exports.default = _default;

},{"e72da19a42674d7c":"7oqaJ"}],"cQPuJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("1c9d5bda227640bf");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
exports.default = _default;

},{"1c9d5bda227640bf":"7oqaJ"}],"6PQyS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("751667ddf3bfbdc1");
const ka = 0.89081309152928522810;
const kr = (0, _math.sin)(_math.pi / 10) / (0, _math.sin)(7 * _math.pi / 10);
const kx = (0, _math.sin)(_math.tau / 10) * kr;
const ky = -(0, _math.cos)(_math.tau / 10) * kr;
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size * ka);
        const x = kx * r;
        const y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = _math.tau * i / 5;
            const c = (0, _math.cos)(a);
            const s = (0, _math.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
exports.default = _default;

},{"751667ddf3bfbdc1":"7oqaJ"}],"4e1xB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("7bc957b4c8d38817");
const sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw (context, size) {
        const y = -(0, _math.sqrt)(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};
exports.default = _default;

},{"7bc957b4c8d38817":"7oqaJ"}],"2hwOo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("7e4bb208ad9cf3ec");
const sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw (context, size) {
        const s = (0, _math.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
exports.default = _default;

},{"7e4bb208ad9cf3ec":"7oqaJ"}],"aagnu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("812e1ff9b9a68f0d");
const c = -0.5;
const s = (0, _math.sqrt)(3) / 2;
const k = 1 / (0, _math.sqrt)(12);
const a = (k / 2 + 1) * 3;
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / a);
        const x0 = r / 2, y0 = r * k;
        const x1 = x0, y1 = r * k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};
exports.default = _default;

},{"812e1ff9b9a68f0d":"7oqaJ"}],"4HZke":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("6e8e98e197afefc3");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size - (0, _math.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
exports.default = _default;

},{"6e8e98e197afefc3":"7oqaJ"}],"fkrKY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("8620520ba80e006a"));
var _basis = require("87413069402f4f60");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisClosed(context);
}

},{"8620520ba80e006a":"gk2lR","87413069402f4f60":"83GJ4"}],"gk2lR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default() {}

},{}],"83GJ4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Basis = Basis;
exports.default = _default;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new Basis(context);
}

},{}],"etkov":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("580a0e4914be358e");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisOpen(context);
}

},{"580a0e4914be358e":"83GJ4"}],"7skup":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _basis = require("202e66c93596d8c0");
function Bundle(context, beta) {
    this._basis = new _basis.Basis(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var _default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new _basis.Basis(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
exports.default = _default;

},{"202e66c93596d8c0":"83GJ4"}],"lbqOC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalClosed = CardinalClosed;
exports.default = void 0;
var _noop = _interopRequireDefault(require("3ac7c5e1248dc9ae"));
var _cardinal = require("cfbcda1bc3207e7e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{"3ac7c5e1248dc9ae":"gk2lR","cfbcda1bc3207e7e":"fXB4s"}],"fXB4s":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cardinal = Cardinal;
exports.default = void 0;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{}],"cDURi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalOpen = CardinalOpen;
exports.default = void 0;
var _cardinal = require("cf4363a3b836d23a");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{"cf4363a3b836d23a":"fXB4s"}],"95i35":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalClosed = require("f5ae01d2345d4943");
var _noop = _interopRequireDefault(require("82484b434a1d31db"));
var _catmullRom = require("3bd3d5af820e50ff");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new _cardinalClosed.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"f5ae01d2345d4943":"lbqOC","82484b434a1d31db":"gk2lR","3bd3d5af820e50ff":"2TcOO"}],"2TcOO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;
var _math = require("d464c344292067de");
var _cardinal = require("2f2af409b067cecd");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > _math.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > _math.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new _cardinal.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"d464c344292067de":"7oqaJ","2f2af409b067cecd":"fXB4s"}],"eJAdl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalOpen = require("97b1c5692429330d");
var _catmullRom = require("9847de9b9e7ea36b");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new _cardinalOpen.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"97b1c5692429330d":"cDURi","9847de9b9e7ea36b":"2TcOO"}],"aE37P":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("bb3255f3276eba36"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function _default(context) {
    return new LinearClosed(context);
}

},{"bb3255f3276eba36":"gk2lR"}],"8gAzl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.monotoneX = monotoneX;
exports.monotoneY = monotoneY;
function sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{}],"eMH6q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function _default(context) {
    return new Natural(context);
}

},{}],"bJOXa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.stepAfter = stepAfter;
exports.stepBefore = stepBefore;
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function _default(context) {
    return new Step(context, 0.5);
}
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{}],"1Ocq7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("8b3b605fa9e4fac5"));
var _constant = _interopRequireDefault(require("e744701481d85f49"));
var _none = _interopRequireDefault(require("e54b6b0ae39944a2"));
var _none2 = _interopRequireDefault(require("e9814568a9c80598"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function stackValue(d, key) {
    return d[key];
}
function stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function _default() {
    var keys = (0, _constant.default)([]), order = _none2.default, offset = _none.default, value = stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, _array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? _none2.default : typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? _none.default : _, stack) : offset;
    };
    return stack;
}

},{"8b3b605fa9e4fac5":"1QzK0","e744701481d85f49":"2NJag","e54b6b0ae39944a2":"jsWcZ","e9814568a9c80598":"g2g16"}],"jsWcZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

},{}],"g2g16":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

},{}],"6IDoF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("d8cdcff221711407"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, _none.default)(series, order);
}

},{"d8cdcff221711407":"jsWcZ"}],"eaApZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

},{}],"ies3f":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("af9c5fa37c1b1d9e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, _none.default)(series, order);
}

},{"af9c5fa37c1b1d9e":"jsWcZ"}],"bR7O5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("56eb12e1b2174aaf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, _none.default)(series, order);
}

},{"56eb12e1b2174aaf":"jsWcZ"}],"7wEjH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("4494c675f3e20319"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var peaks = series.map(peak);
    return (0, _none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"4494c675f3e20319":"g2g16"}],"0401Z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.sum = sum;
var _none = _interopRequireDefault(require("4a7d728f9a184a25"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var sums = series.map(sum);
    return (0, _none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"4a7d728f9a184a25":"g2g16"}],"j8E15":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _ascending = _interopRequireDefault(require("d39a3ba1232418c4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _ascending.default)(series).reverse();
}

},{"d39a3ba1232418c4":"0401Z"}],"5xK7H":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _appearance = _interopRequireDefault(require("7e770dfcdf2ff59a"));
var _ascending = require("12f0fe8581e206");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var n = series.length, i, j, sums = series.map(_ascending.sum), order = (0, _appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

},{"7e770dfcdf2ff59a":"7wEjH","12f0fe8581e206":"0401Z"}],"jkzh6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("175f4f386d8ceefb"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _none.default)(series).reverse();
}

},{"175f4f386d8ceefb":"g2g16"}],"cyyuN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is configuration option that decides how to filter for unique values only:
 *
 * - `false` means "no filter"
 * - `true` means "use recharts default filter"
 * - function means "use return of this function as the default key"
 */ parcelHelpers.export(exports, "getUniqPayload", ()=>getUniqPayload);
var _uniqBy = require("lodash/uniqBy");
var _uniqByDefault = parcelHelpers.interopDefault(_uniqBy);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
function getUniqPayload(payload, option, defaultUniqBy) {
    if (option === true) return (0, _uniqByDefault.default)(payload, defaultUniqBy);
    if ((0, _isFunctionDefault.default)(option)) return (0, _uniqByDefault.default)(payload, option);
    return payload;
}

},{"lodash/uniqBy":"gAgCA","lodash/isFunction":"3A7xI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gAgCA":[function(require,module,exports,__globalThis) {
var baseIteratee = require("ce9604aad32f97ab"), baseUniq = require("9fbd8e46e11f49c4");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}
module.exports = uniqBy;

},{"ce9604aad32f97ab":"6jZAq","9fbd8e46e11f49c4":"lImIy"}],"lImIy":[function(require,module,exports,__globalThis) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"irm8l","a1d85be956e037a9":"3t5Fw","8cd18f86a4a2c118":"4yfFQ","3acf9f4a3a78c511":"c2cDw","19b77385b4f7775a":"gStkf","4568580f7416eb83":"lxNlE"}],"4yfFQ":[function(require,module,exports,__globalThis) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"gStkf":[function(require,module,exports,__globalThis) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"juoJE","a02c367b3608ccee":"enX86","cd8d0af6a14b2f7d":"lxNlE"}],"lILc1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
/**
 * @fileOverview Tooltip
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _defaultTooltipContent = require("./DefaultTooltipContent");
var _tooltipBoundingBox = require("./TooltipBoundingBox");
var _global = require("../util/Global");
var _getUniqPayload = require("../util/payload/getUniqPayload");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function defaultUniqBy(entry) {
    return entry.dataKey;
}
function renderContent(content, props) {
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(content)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, _reactDefault.default).createElement(content, props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultTooltipContent.DefaultTooltipContent), props);
}
var Tooltip = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Tooltip, _PureComponent);
    var _super = _createSuper(Tooltip);
    function Tooltip() {
        _classCallCheck(this, Tooltip);
        return _super.apply(this, arguments);
    }
    _createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, _getUniqPayload.getUniqPayload)(payload.filter(function(entry) {
                    return entry.value != null;
                }), payloadUniqBy, defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipBoundingBox.TooltipBoundingBox), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, renderContent(content, _objectSpread(_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, _react.PureComponent));
_defineProperty(Tooltip, "displayName", 'Tooltip');
_defineProperty(Tooltip, "defaultProps", {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, _global.Global).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});

},{"react":"9njXz","./DefaultTooltipContent":"4rOkG","./TooltipBoundingBox":"k5ynY","../util/Global":"c6qoI","../util/payload/getUniqPayload":"cyyuN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4rOkG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTooltipContent", ()=>DefaultTooltipContent);
/**
 * @fileOverview Default Tooltip Content
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function defaultFormatter(value) {
    return Array.isArray(value) && (0, _dataUtils.isNumOrStr)(value[0]) && (0, _dataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
}
var DefaultTooltipContent = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, _sortByDefault.default)(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = _objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = _slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, _reactDefault.default).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = _objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = _objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, _isNilDefault.default)(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, _clsxDefault.default)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, _clsxDefault.default)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: wrapperCN,
        style: finalStyle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, _reactDefault.default).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};

},{"react":"9njXz","lodash/sortBy":"4paFu","lodash/isNil":"eS6AM","clsx":"d2NWs","../util/DataUtils":"5VTG4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4paFu":[function(require,module,exports,__globalThis) {
var baseFlatten = require("7dd3b18d381f1f29"), baseOrderBy = require("2553e45e897c3cba"), baseRest = require("9df1e918b0eea173"), isIterateeCall = require("36218471fd8f4dda");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
module.exports = sortBy;

},{"7dd3b18d381f1f29":"iu9J0","2553e45e897c3cba":"f3iLf","9df1e918b0eea173":"5w1TW","36218471fd8f4dda":"gTLnH"}],"f3iLf":[function(require,module,exports,__globalThis) {
var arrayMap = require("8b3be8ab05c5c021"), baseGet = require("56eb179604ce4d19"), baseIteratee = require("41950d167c7e12b5"), baseMap = require("b09740a39499ec43"), baseSortBy = require("35a9013ca73ef017"), baseUnary = require("b387a5b76e29e664"), compareMultiple = require("2ab709818f44804c"), identity = require("5cb379329c706719"), isArray = require("8acdbb462385356c");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;

},{"8b3be8ab05c5c021":"chzeu","56eb179604ce4d19":"5Vkba","41950d167c7e12b5":"6jZAq","b09740a39499ec43":"8JEHD","35a9013ca73ef017":"1dFrx","b387a5b76e29e664":"jVyhK","2ab709818f44804c":"9XLey","5cb379329c706719":"2HXBf","8acdbb462385356c":"1DVeR"}],"8JEHD":[function(require,module,exports,__globalThis) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"hbtgh","2924e2db4bb5430d":"kzICo"}],"hbtgh":[function(require,module,exports,__globalThis) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"i7P4y","f1e3fc84161ef3ec":"bY6r9"}],"i7P4y":[function(require,module,exports,__globalThis) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"9oLrx","1fb77c53defe5720":"9qKxr"}],"9oLrx":[function(require,module,exports,__globalThis) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"d4N9s"}],"d4N9s":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"bY6r9":[function(require,module,exports,__globalThis) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"kzICo"}],"1dFrx":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = baseSortBy;

},{}],"9XLey":[function(require,module,exports,__globalThis) {
var compareAscending = require("dd5e23e02b1cd726");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = compareMultiple;

},{"dd5e23e02b1cd726":"e5XoH"}],"e5XoH":[function(require,module,exports,__globalThis) {
var isSymbol = require("a51b63ee8daeecee");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = compareAscending;

},{"a51b63ee8daeecee":"fMaHV"}],"5w1TW":[function(require,module,exports,__globalThis) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"2HXBf","ff7d23ff2a2ea6f8":"rlFXD","a11d545e809d14f7":"cmKNW"}],"gTLnH":[function(require,module,exports,__globalThis) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"evtiM","616bc732534dffe0":"kzICo","e781332a36d1bd7":"bxLaX","c8548bf6929b8a5d":"6hgJK"}],"k5ynY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipBoundingBox", ()=>TooltipBoundingBox);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _translate = require("../util/tooltip/translate");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var EPSILON = 1;
var TooltipBoundingBox = /*#__PURE__*/ function(_PureComponent) {
    _inherits(TooltipBoundingBox, _PureComponent);
    var _super = _createSuper(TooltipBoundingBox);
    function TooltipBoundingBox() {
        var _this;
        _classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        });
        _defineProperty(_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    _createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.lastBoundingBox.width) > EPSILON || Math.abs(box.height - this.lastBoundingBox.height) > EPSILON) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, _translate.getTooltipTranslate)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: {
                        height: this.lastBoundingBox.height,
                        width: this.lastBoundingBox.width
                    },
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = _objectSpread(_objectSpread(_objectSpread({}, isAnimationActive && active && (0, _reactSmooth.translateStyle)({
                    transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
                })), cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, _reactDefault.default).createElement("div", {
                    tabIndex: -1,
                    role: "dialog",
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
    return TooltipBoundingBox;
}((0, _react.PureComponent));

},{"react":"9njXz","react-smooth":"7kGqo","../util/tooltip/translate":"9SV0K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7kGqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configSpring", ()=>(0, _easing.configSpring));
parcelHelpers.export(exports, "configBezier", ()=>(0, _easing.configBezier));
parcelHelpers.export(exports, "AnimateGroup", ()=>(0, _animateGroupDefault.default));
parcelHelpers.export(exports, "translateStyle", ()=>(0, _util.translateStyle));
var _animate = require("./Animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var _easing = require("./easing");
var _util = require("./util");
var _animateGroup = require("./AnimateGroup");
var _animateGroupDefault = parcelHelpers.interopDefault(_animateGroup);
exports.default = (0, _animateDefault.default);

},{"./Animate":"cvc77","./easing":"ffxm6","./util":"jIzvl","./AnimateGroup":"3pMO3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cvc77":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _fastEquals = require("fast-equals");
var _animateManager = require("./AnimateManager");
var _animateManagerDefault = parcelHelpers.interopDefault(_animateManager);
var _easing = require("./easing");
var _configUpdate = require("./configUpdate");
var _configUpdateDefault = parcelHelpers.interopDefault(_configUpdate);
var _util = require("./util");
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var _excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var Animate = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Animate, _PureComponent);
    var _super = _createSuper(Animate);
    function Animate(props, context) {
        var _this;
        _classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return _possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return _possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? _defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    _createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? _defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, _fastEquals.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? _defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation(_objectSpread(_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, _configUpdateDefault.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat(_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, _util.getTransitionVal)(properties, duration, easing);
                    var newStyle = _objectSpread(_objectSpread(_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat(_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, _util.identity));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat(_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, _animateManagerDefault.default)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    _objectSpread(_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = _objectWithoutProperties(_this$props4, _excluded);
                var count = (0, _react.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = (0, _util.translateStyle)(this.state.style);
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, _react.cloneElement)(container, _objectSpread(_objectSpread({}, others), {}, {
                        style: _objectSpread(_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, _react.Children).only(children));
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, (0, _react.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, _react.PureComponent));
Animate.displayName = 'Animate';
Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
Animate.propTypes = {
    from: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    to: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    attributeName: (0, _propTypesDefault.default).string,
    // animation duration
    duration: (0, _propTypesDefault.default).number,
    begin: (0, _propTypesDefault.default).number,
    easing: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    steps: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        duration: (0, _propTypesDefault.default).number.isRequired,
        style: (0, _propTypesDefault.default).object.isRequired,
        easing: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, _propTypesDefault.default).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, _propTypesDefault.default).arrayOf('string'),
        onAnimationEnd: (0, _propTypesDefault.default).func
    })),
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]),
    isActive: (0, _propTypesDefault.default).bool,
    canBegin: (0, _propTypesDefault.default).bool,
    onAnimationEnd: (0, _propTypesDefault.default).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, _propTypesDefault.default).bool,
    onAnimationStart: (0, _propTypesDefault.default).func,
    onAnimationReStart: (0, _propTypesDefault.default).func
};
exports.default = Animate;

},{"react":"9njXz","prop-types":"bnNSm","fast-equals":"ktRd2","./AnimateManager":"bukhs","./easing":"ffxm6","./configUpdate":"7xLII","./util":"jIzvl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ktRd2":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});

},{}],"bukhs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createAnimateManager);
var _setRafTimeout = require("./setRafTimeout");
var _setRafTimeoutDefault = parcelHelpers.interopDefault(_setRafTimeout);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function createAnimateManager() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = _toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, _setRafTimeoutDefault.default)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, _setRafTimeoutDefault.default)(setStyle.bind(null, restStyles));
            return;
        }
        if (_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}

},{"./setRafTimeout":"lsoXC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lsoXC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setRafTimeout);
function safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function setRafTimeout(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffxm6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configBezier", ()=>configBezier);
parcelHelpers.export(exports, "configSpring", ()=>configSpring);
parcelHelpers.export(exports, "configEasing", ()=>configEasing);
var _util = require("./util");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var ACCURACY = 1e-4;
var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = cubicBezierFactor(c1, c2);
        return multyTime(params, t);
    };
};
var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = cubicBezierFactor(c1, c2);
        var newParams = [].concat(_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return multyTime(newParams, t);
    };
};
var configBezier = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, _util.warn)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, _util.warn)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = cubicBezier(x1, x2);
    var curveY = cubicBezier(y1, y2);
    var derCurveX = derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var configSpring = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var configEasing = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return configBezier(easing);
        case 'spring':
            return configSpring();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return configBezier(easing);
            (0, _util.warn)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, _util.warn)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};

},{"./util":"jIzvl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jIzvl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIntersectionKeys", ()=>getIntersectionKeys);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "getDashCase", ()=>getDashCase);
parcelHelpers.export(exports, "generatePrefixStyle", ()=>generatePrefixStyle);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "debug", ()=>debug);
parcelHelpers.export(exports, "debugf", ()=>debugf);
parcelHelpers.export(exports, "mapObject", ()=>mapObject);
parcelHelpers.export(exports, "translateStyle", ()=>translateStyle);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "getTransitionVal", ()=>getTransitionVal);
parcelHelpers.export(exports, "warn", ()=>warn);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint no-console: 0 */ var PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var IN_LINE_PREFIX_LIST = [
    '-webkit-',
    '-moz-',
    '-o-',
    '-ms-'
];
var IN_COMPATIBLE_PROPERTY = [
    'transform',
    'transformOrigin',
    'transition'
];
var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var identity = function identity(param) {
    return param;
};
var getDashCase = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var generatePrefixStyle = function generatePrefixStyle(name, value) {
    if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return _defineProperty({}, name, Number.isNaN(value) ? 0 : value);
    var isTransition = name === 'transition';
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat(IN_LINE_PREFIX_LIST[i], "$1"));
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, property + camelName, styleVal));
    }, {});
};
var log = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var debug = function debug(name) {
    return function(item) {
        log(name, item);
        return item;
    };
};
var debugf = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var mapObject = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var translateStyle = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), generatePrefixStyle(key, res[key]));
    }, style);
};
var compose = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return identity;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var getTransitionVal = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var isDev = false;
var warn = function warn(condition, format, a, b, c, d, e, f) {
    if (isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7xLII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("./util");
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, _util.mapObject)(function(key, val) {
        if (needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = _slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return _objectSpread(_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, _util.mapObject)(function(key, val) {
        if (needContinue(val)) return _objectSpread(_objectSpread({}, val), {}, {
            velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
// configure update function
exports.default = function(from, to, easing, duration, render) {
    var interKeys = (0, _util.getIntersectionKeys)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, _util.mapObject)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter(needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, _util.mapObject)(function(key, val) {
            return alpha.apply(void 0, _toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, _util.mapObject)(function(key, val) {
                return alpha.apply(void 0, _toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render(_objectSpread(_objectSpread(_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};

},{"./util":"jIzvl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3pMO3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _animateGroupChild = require("./AnimateGroupChild");
var _animateGroupChildDefault = parcelHelpers.interopDefault(_animateGroupChild);
function AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.TransitionGroup), {
        component: component
    }, (0, _react.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _animateGroupChildDefault.default), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
AnimateGroup.propTypes = {
    appear: (0, _propTypesDefault.default).object,
    enter: (0, _propTypesDefault.default).object,
    leave: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).element
    ]),
    component: (0, _propTypesDefault.default).any
};
AnimateGroup.defaultProps = {
    component: 'span'
};
exports.default = AnimateGroup;

},{"react":"9njXz","react-transition-group":"eTl0V","prop-types":"bnNSm","./AnimateGroupChild":"6E10C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eTl0V":[function(require,module,exports,__globalThis) {
"use strict";
var _CSSTransition = _interopRequireDefault(require("a7857a428ec252eb"));
var _ReplaceTransition = _interopRequireDefault(require("b8f463eafa906298"));
var _TransitionGroup = _interopRequireDefault(require("45e006645188c41"));
var _Transition = _interopRequireDefault(require("b6bd11460318e6fd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = {
    Transition: _Transition.default,
    TransitionGroup: _TransitionGroup.default,
    ReplaceTransition: _ReplaceTransition.default,
    CSSTransition: _CSSTransition.default
};

},{"a7857a428ec252eb":"ixkcP","b8f463eafa906298":"hshew","45e006645188c41":"f3lFU","b6bd11460318e6fd":"fEtKI"}],"ixkcP":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var PropTypes = _interopRequireWildcard(require("55694796d51c1e7a"));
var _addClass = _interopRequireDefault(require("7a4eeceb6d6ce52b"));
var _removeClass = _interopRequireDefault(require("42812cdca3d7c160"));
var _react = _interopRequireDefault(require("ecb5f58a9014b2b6"));
var _Transition = _interopRequireDefault(require("837b6a4ac0517221"));
var _PropTypes = require("a4a394802e85474d");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _addClass.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'), className = _this$getClassNames.className;
            _this.removeClasses(node, 'exit');
            addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames('appear').doneClassName;
            var enterClassName = _this.getClassNames('enter').doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? 'appear' : 'enter');
            addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames('exit'), className = _this$getClassNames3.className;
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames('exit'), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames('exit'), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, 'exit');
            addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + '-' : '';
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
            var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && removeClass(node, className);
        activeClassName && removeClass(node, activeClassName);
        doneClassName && removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = _extends({}, this.props);
        delete props.classNames;
        return _react.default.createElement(_Transition.default, _extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}(_react.default.Component);
CSSTransition.defaultProps = {
    classNames: ''
};
CSSTransition.propTypes = {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

},{"55694796d51c1e7a":"bnNSm","7a4eeceb6d6ce52b":"iwbxw","42812cdca3d7c160":"fB4eF","ecb5f58a9014b2b6":"9njXz","837b6a4ac0517221":"fEtKI","a4a394802e85474d":"3GTTr"}],"iwbxw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("29606a5742d8011d");
exports.__esModule = true;
exports.default = addClass;
var _hasClass = _interopRequireDefault(require("d10b9431e3766b13"));
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClass.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + ' ' + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
    }
}
module.exports = exports["default"];

},{"29606a5742d8011d":"kZ6eK","d10b9431e3766b13":"4DdgJ"}],"4DdgJ":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = hasClass;
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

},{}],"fB4eF":[function(require,module,exports,__globalThis) {
'use strict';
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

},{}],"fEtKI":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
var PropTypes = _interopRequireWildcard(require("253f2f18f4dec3df"));
var _react = _interopRequireDefault(require("1643089e8799fbcd"));
var _reactDom = _interopRequireDefault(require("96ad39782dfea8d8"));
var _reactLifecyclesCompat = require("d2e0428f5c44c877");
var _PropTypes = require("94d7b50818060aa1");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ exports.EXITING = EXITING;
var Transition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = _reactDom.default.findDOMNode(this);
            if (nextStatus === ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = _objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = _react.default.Children.only(children);
        return _react.default.cloneElement(child, childProps);
    };
    return Transition;
}(_react.default.Component);
Transition.contextTypes = {
    transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
Transition.propTypes = {};
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;
var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
exports.default = _default;

},{"253f2f18f4dec3df":"bnNSm","1643089e8799fbcd":"9njXz","96ad39782dfea8d8":"2ApDx","d2e0428f5c44c877":"9jQEY","94d7b50818060aa1":"3GTTr"}],"9jQEY":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3GTTr":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;
var _propTypes = _interopRequireDefault(require("176756ddd61eb2e6"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var timeoutsShape = null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape = null;
exports.classNamesShape = classNamesShape;

},{"176756ddd61eb2e6":"bnNSm"}],"hshew":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("f15ee0d81d0c25fa"));
var _react = _interopRequireDefault(require("80f29e369ce19641"));
var _reactDom = require("814d7f2976a5cde");
var _TransitionGroup = _interopRequireDefault(require("c0895d5f59ef6f35"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle('onEnter', 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle('onEntering', 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle('onEntered', 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle('onExit', 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle('onExiting', 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle('onExited', 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = _react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = _objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = _react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
            key: 'first',
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : _react.default.cloneElement(second, {
            key: 'second',
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}(_react.default.Component);
ReplaceTransition.propTypes = {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

},{"f15ee0d81d0c25fa":"bnNSm","80f29e369ce19641":"9njXz","814d7f2976a5cde":"2ApDx","c0895d5f59ef6f35":"f3lFU"}],"f3lFU":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("98118a7d02b41a87"));
var _react = _interopRequireDefault(require("1e1d706d434422f5"));
var _reactLifecyclesCompat = require("9a36af6c0ec8b65f");
var _ChildMapping = require("b9fc69c2fecfb8e5");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = _extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return _react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}(_react.default.Component);
TransitionGroup.childContextTypes = {
    transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
exports.default = _default;
module.exports = exports["default"];

},{"98118a7d02b41a87":"bnNSm","1e1d706d434422f5":"9njXz","9a36af6c0ec8b65f":"9jQEY","b9fc69c2fecfb8e5":"5YqvR"}],"5YqvR":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;
var _react = require("1e43e2e01eaa18e2");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) _react.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, 'appear', props),
            enter: getProp(child, 'enter', props),
            exit: getProp(child, 'exit', props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

},{"1e43e2e01eaa18e2":"9njXz"}],"6E10C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _animate = require("./Animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var _excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === 'number' && isFinite(value);
};
var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    _inherits(AnimateGroupChild, _Component);
    var _super = _createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        _classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        _defineProperty(_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        _defineProperty(_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    _createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState(_objectSpread(_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = _objectWithoutProperties(_this$props3, _excluded);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), _extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _animateDefault.default), _this2.state, (0, _react.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, _react.Component));
AnimateGroupChild.propTypes = {
    appearOptions: (0, _propTypesDefault.default).object,
    enterOptions: (0, _propTypesDefault.default).object,
    leaveOptions: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).element
};
exports.default = AnimateGroupChild;

},{"react":"9njXz","react-transition-group":"eTl0V","prop-types":"bnNSm","./Animate":"cvc77","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9SV0K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTooltipCSSClassName", ()=>getTooltipCSSClassName);
parcelHelpers.export(exports, "getTooltipTranslateXY", ()=>getTooltipTranslateXY);
parcelHelpers.export(exports, "getTransformStyle", ()=>getTransformStyle);
parcelHelpers.export(exports, "getTooltipTranslate", ()=>getTooltipTranslate);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _dataUtils = require("../DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function getTooltipCSSClassName(_ref) {
    var _clsx;
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, _clsxDefault.default)(CSS_CLASS_PREFIX, (_clsx = {}, _defineProperty(_clsx, "".concat(CSS_CLASS_PREFIX, "-right"), (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), _defineProperty(_clsx, "".concat(CSS_CLASS_PREFIX, "-left"), (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), _defineProperty(_clsx, "".concat(CSS_CLASS_PREFIX, "-bottom"), (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), _defineProperty(_clsx, "".concat(CSS_CLASS_PREFIX, "-top"), (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY < coordinate.y), _clsx));
}
function getTooltipTranslateXY(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, _dataUtils.isNumber)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function getTransformStyle(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return (0, _reactSmooth.translateStyle)({
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    });
}
function getTooltipTranslate(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = getTooltipTranslateXY({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = getTooltipTranslateXY({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = getTransformStyle({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: getTooltipCSSClassName({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}

},{"clsx":"d2NWs","react-smooth":"7kGqo","../DataUtils":"5VTG4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6qoI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Global", ()=>Global);
var parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var Global = {
    isSsr: parseIsSsrByDefault(),
    get: function get(key) {
        return Global[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') Global[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                Global[k] = key[k];
            });
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8f9vd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveContainer", ()=>ResponsiveContainer);
/**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */ var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _throttle = require("lodash/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _reactIs = require("react-is");
var _dataUtils = require("../util/DataUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var ResponsiveContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, _react.useRef)(null);
    var onResizeRef = (0, _react.useRef)();
    onResizeRef.current = onResize;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (0, _react.useImperativeHandle)(ref, function() {
        return containerRef;
    });
    var _useState = (0, _react.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = _slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, _react.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, _react.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, _throttleDefault.default)(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, _react.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, _logUtils.warn)((0, _dataUtils.isPercent)(width) || (0, _dataUtils.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, _logUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, _dataUtils.isPercent)(width) ? containerWidth : width;
        var calculatedHeight = (0, _dataUtils.isPercent)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, _logUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, _reactIs.isElement)(children) && (0, _reactUtils.getDisplayName)(children.type).endsWith('Chart');
        return (0, _reactDefault.default).Children.map(children, function(child) {
            if ((0, _reactIs.isElement)(child)) return /*#__PURE__*/ (0, _react.cloneElement)(child, _objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: _objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, _clsxDefault.default)('recharts-responsive-container', className),
        style: _objectSpread(_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});

},{"clsx":"d2NWs","react":"9njXz","lodash/throttle":"7IlSK","react-is":"3ILnA","../util/DataUtils":"5VTG4","../util/LogUtils":"2yNyz","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7IlSK":[function(require,module,exports,__globalThis) {
var debounce = require("5b383646e2c7b4c6"), isObject = require("a29ce0b3e78d037d");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = throttle;

},{"5b383646e2c7b4c6":"1hVPi","a29ce0b3e78d037d":"6hgJK"}],"cemk7":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Cross
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cell", ()=>Cell);
var Cell = function Cell(_props) {
    return null;
};
Cell.displayName = 'Cell';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AQ2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>Text);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
var _global = require("../util/Global");
var _reactUtils = require("../util/ReactUtils");
var _domutils = require("../util/DOMUtils");
var _reduceCSSCalc = require("../util/ReduceCSSCalc");
var _excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], _excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, _isNilDefault.default)(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split(BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, _domutils.getStringSize)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, _domutils.getStringSize)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, _dataUtils.isNumber)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = _slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = _slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, _isNilDefault.default)(children) ? children.toString().split(BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, _global.Global).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return getWordsWithoutCalculate(children);
        return calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return getWordsWithoutCalculate(children);
};
var DEFAULT_FILL = '#808080';
var Text = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? DEFAULT_FILL : _ref5$fill, props = _objectWithoutProperties(_ref5, _excluded);
    var wordsByLines = (0, _react.useMemo)(function() {
        return getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = _objectWithoutProperties(props, _excluded2);
    if (!(0, _dataUtils.isNumOrStr)(propsX) || !(0, _dataUtils.isNumOrStr)(propsY)) return null;
    var x = propsX + ((0, _dataUtils.isNumber)(dx) ? dx : 0);
    var y = propsY + ((0, _dataUtils.isNumber)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, _dataUtils.isNumber)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("text", _extends({}, (0, _reactUtils.filterProps)(textProps, true), {
        x: x,
        y: y,
        className: (0, _clsxDefault.default)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, _reactDefault.default).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: index
        }, line.words.join(breakAll ? '' : ' ')));
    }));
};

},{"react":"9njXz","lodash/isNil":"eS6AM","clsx":"d2NWs","../util/DataUtils":"5VTG4","../util/Global":"c6qoI","../util/ReactUtils":"lj4u0","../util/DOMUtils":"7SjCz","../util/ReduceCSSCalc":"d5NmK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7SjCz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleString", ()=>getStyleString);
parcelHelpers.export(exports, "getStringSize", ()=>getStringSize);
parcelHelpers.export(exports, "getOffset", ()=>getOffset);
var _global = require("./Global");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var stringCache = {
    widthCache: {},
    cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function autoCompleteStyle(name, value) {
    if (STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat(_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat(_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var getStyleString = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function removeInvalidKeys(obj) {
    var copyObj = _objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var getStringSize = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, _global.Global).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if (stringCache.widthCache[cacheKey]) return stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = _objectSpread(_objectSpread({}, SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        stringCache.widthCache[cacheKey] = result;
        if (++stringCache.cacheCount > MAX_CACHE_NUM) {
            stringCache.cacheCount = 0;
            stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var getOffset = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};

},{"./Global":"c6qoI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d5NmK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeEvaluateExpression", ()=>safeEvaluateExpression);
parcelHelpers.export(exports, "reduceCSSCalc", ()=>reduceCSSCalc);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var FIXED_CSS_LENGTH_UNITS = Object.keys(CONVERSION_RATES);
var STR_NAN = 'NaN';
function convertToPx(value, unit) {
    return value * CONVERSION_RATES[unit];
}
var DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        _classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if (FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    _createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = _slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
    return DecimalCSS;
}();
function calculateArithmetic(expr) {
    if (expr.includes(STR_NAN)) return STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = _slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = _slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = _slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace(PARENTHESES_REGEX, calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = calculateParentheses(newExpr);
    newExpr = calculateArithmetic(newExpr);
    return newExpr;
}
function safeEvaluateExpression(expression) {
    try {
        return evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return STR_NAN;
    }
}
function reduceCSSCalc(expression) {
    var result = safeEvaluateExpression(expression.slice(5, -1));
    if (result === STR_NAN) // notify the user
    return '';
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2uQzv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _text = require("./Text");
var _reactUtils = require("../util/ReactUtils");
var _dataUtils = require("../util/DataUtils");
var _polarUtils = require("../util/PolarUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "offset"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, _isNilDefault.default)(props.children) ? value : props.children;
    if ((0, _isFunctionDefault.default)(formatter)) return formatter(label);
    return label;
};
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, _isNilDefault.default)(labelProps.id) ? (0, _dataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("text", _extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, _clsxDefault.default)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, _polarUtils.polarToCartesian)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return _objectSpread(_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return _objectSpread(_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return _objectSpread(_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return _objectSpread(_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return _objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return _objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return _objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return _objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return _objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, _isObjectDefault.default)(position) && ((0, _dataUtils.isNumber)(position.x) || (0, _dataUtils.isPercent)(position.x)) && ((0, _dataUtils.isNumber)(position.y) || (0, _dataUtils.isPercent)(position.y))) return _objectSpread({
        x: x + (0, _dataUtils.getPercentValue)(position.x, width),
        y: y + (0, _dataUtils.getPercentValue)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return _objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, _dataUtils.isNumber)(viewBox.cx);
};
function Label(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = _objectWithoutProperties(_ref4, _excluded);
    var props = _objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, _isNilDefault.default)(value) && (0, _isNilDefault.default)(children) && !/*#__PURE__*/ (0, _react.isValidElement)(content) && !(0, _isFunctionDefault.default)(content)) return null;
    if (/*#__PURE__*/ (0, _react.isValidElement)(content)) return /*#__PURE__*/ (0, _react.cloneElement)(content, props);
    var label;
    if ((0, _isFunctionDefault.default)(content)) {
        label = /*#__PURE__*/ (0, _react.createElement)(content, props);
        if (/*#__PURE__*/ (0, _react.isValidElement)(label)) return label;
    } else label = getLabel(props);
    var isPolarLabel = isPolar(viewBox);
    var attrs = (0, _reactUtils.filterProps)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
        className: (0, _clsxDefault.default)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
Label.displayName = 'Label';
var parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, _dataUtils.isNumber)(width) && (0, _dataUtils.isNumber)(height)) {
        if ((0, _dataUtils.isNumber)(x) && (0, _dataUtils.isNumber)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, _dataUtils.isNumber)(top) && (0, _dataUtils.isNumber)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, _dataUtils.isNumber)(x) && (0, _dataUtils.isNumber)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, _dataUtils.isNumber)(cx) && (0, _dataUtils.isNumber)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, _dataUtils.isNumOrStr)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, _react.isValidElement)(label)) {
        if (label.type === Label) return /*#__PURE__*/ (0, _react.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, _isFunctionDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, _isObjectDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, _extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = parseViewBox(parentProps);
    var explicitChildren = (0, _reactUtils.findAllByType)(children, Label).map(function(child, index) {
        return /*#__PURE__*/ (0, _react.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat(_toConsumableArray(explicitChildren));
};
Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent;

},{"react":"9njXz","lodash/isNil":"eS6AM","lodash/isFunction":"3A7xI","lodash/isObject":"6hgJK","clsx":"d2NWs","./Text":"4AQ2W","../util/ReactUtils":"lj4u0","../util/DataUtils":"5VTG4","../util/PolarUtils":"eBFiJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eBFiJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIAN", ()=>RADIAN);
parcelHelpers.export(exports, "degreeToRadian", ()=>degreeToRadian);
parcelHelpers.export(exports, "radianToDegree", ()=>radianToDegree);
parcelHelpers.export(exports, "polarToCartesian", ()=>polarToCartesian);
parcelHelpers.export(exports, "getMaxRadius", ()=>getMaxRadius);
parcelHelpers.export(exports, "formatAxisMap", ()=>formatAxisMap);
parcelHelpers.export(exports, "distanceBetweenPoints", ()=>distanceBetweenPoints);
parcelHelpers.export(exports, "getAngleOfPoint", ()=>getAngleOfPoint);
parcelHelpers.export(exports, "formatAngleOfSector", ()=>formatAngleOfSector);
parcelHelpers.export(exports, "inRangeOfSector", ()=>inRangeOfSector);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _dataUtils = require("./DataUtils");
var _chartUtils = require("./ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var RADIAN = Math.PI / 180;
var degreeToRadian = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var radianToDegree = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-RADIAN * angle) * radius,
        y: cy + Math.sin(-RADIAN * angle) * radius
    };
};
var getMaxRadius = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, _dataUtils.getPercentValue)(props.cx, width, width / 2);
    var cy = (0, _dataUtils.getPercentValue)(props.cy, height, height / 2);
    var maxRadius = getMaxRadius(width, height, offset);
    var innerRadius = (0, _dataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, _dataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, _isNilDefault.default)(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = _slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, _chartUtils.parseScale)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, _chartUtils.checkDomainOfScale)(scale);
        var ticks = (0, _chartUtils.getTicksOfScale)(scale, _objectSpread(_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = _objectSpread(_objectSpread(_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, id, finalAxis));
    }, {});
};
var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = distanceBetweenPoints({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: radianToDegree(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var formatAngleOfSector = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = getAngleOfPoint({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = formatAngleOfSector(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return _objectSpread(_objectSpread({}, sector), {}, {
        radius: radius,
        angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};

},{"lodash/isNil":"eS6AM","./DataUtils":"5VTG4","./ChartUtils":"24GXn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"24GXn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Exported for backwards compatibility
parcelHelpers.export(exports, "getLegendProps", ()=>(0, _getLegendProps.getLegendProps));
parcelHelpers.export(exports, "getValueByDataKey", ()=>getValueByDataKey);
/**
 * Get domain of data by key.
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */ parcelHelpers.export(exports, "getDomainOfDataByKey", ()=>getDomainOfDataByKey);
parcelHelpers.export(exports, "calculateActiveTickIndex", ()=>calculateActiveTickIndex);
parcelHelpers.export(exports, "getMainColorOfGraphicItem", ()=>getMainColorOfGraphicItem);
parcelHelpers.export(exports, "getBarSizeList", ()=>getBarSizeList);
parcelHelpers.export(exports, "getBarPosition", ()=>getBarPosition);
parcelHelpers.export(exports, "appendOffsetOfLegend", ()=>appendOffsetOfLegend);
parcelHelpers.export(exports, "getDomainOfErrorBars", ()=>getDomainOfErrorBars);
parcelHelpers.export(exports, "parseErrorBarsOfAxis", ()=>parseErrorBarsOfAxis);
parcelHelpers.export(exports, "getDomainOfItemsWithSameAxis", ()=>getDomainOfItemsWithSameAxis);
parcelHelpers.export(exports, "isCategoricalAxis", ()=>isCategoricalAxis);
parcelHelpers.export(exports, "getCoordinatesOfGrid", ()=>getCoordinatesOfGrid);
parcelHelpers.export(exports, "getTicksOfAxis", ()=>getTicksOfAxis);
parcelHelpers.export(exports, "combineEventHandlers", ()=>combineEventHandlers);
parcelHelpers.export(exports, "parseScale", ()=>parseScale);
parcelHelpers.export(exports, "checkDomainOfScale", ()=>checkDomainOfScale);
parcelHelpers.export(exports, "findPositionOfBar", ()=>findPositionOfBar);
parcelHelpers.export(exports, "truncateByDomain", ()=>truncateByDomain);
parcelHelpers.export(exports, "offsetSign", ()=>offsetSign);
parcelHelpers.export(exports, "offsetPositive", ()=>offsetPositive);
parcelHelpers.export(exports, "getStackedData", ()=>getStackedData);
parcelHelpers.export(exports, "getStackGroupsByAxisId", ()=>getStackGroupsByAxisId);
parcelHelpers.export(exports, "getTicksOfScale", ()=>getTicksOfScale);
parcelHelpers.export(exports, "getCateCoordinateOfLine", ()=>getCateCoordinateOfLine);
parcelHelpers.export(exports, "getCateCoordinateOfBar", ()=>getCateCoordinateOfBar);
parcelHelpers.export(exports, "getBaseValueOfBar", ()=>getBaseValueOfBar);
parcelHelpers.export(exports, "getStackedDataOfItem", ()=>getStackedDataOfItem);
parcelHelpers.export(exports, "getDomainOfStackGroups", ()=>getDomainOfStackGroups);
parcelHelpers.export(exports, "MIN_VALUE_REG", ()=>MIN_VALUE_REG);
parcelHelpers.export(exports, "MAX_VALUE_REG", ()=>MAX_VALUE_REG);
parcelHelpers.export(exports, "parseSpecifiedDomain", ()=>parseSpecifiedDomain);
parcelHelpers.export(exports, "getBandSizeOfAxis", ()=>getBandSizeOfAxis);
parcelHelpers.export(exports, "parseDomainOfCategoryAxis", ()=>parseDomainOfCategoryAxis);
parcelHelpers.export(exports, "getTooltipItem", ()=>getTooltipItem);
var _d3Scale = require("victory-vendor/d3-scale");
var _d3Shape = require("victory-vendor/d3-shape");
var _max = require("lodash/max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _min = require("lodash/min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _flatMap = require("lodash/flatMap");
var _flatMapDefault = parcelHelpers.interopDefault(_flatMap);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _rechartsScale = require("recharts-scale");
var _errorBar = require("../cartesian/ErrorBar");
var _dataUtils = require("./DataUtils");
var _reactUtils = require("./ReactUtils");
// TODO: Cause of circular dependency. Needs refactor.
// import { RadiusAxisProps, AngleAxisProps } from '../polar/types';
var _getLegendProps = require("./getLegendProps");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function getValueByDataKey(obj, dataKey, defaultValue) {
    if ((0, _isNilDefault.default)(obj) || (0, _isNilDefault.default)(dataKey)) return defaultValue;
    if ((0, _dataUtils.isNumOrStr)(dataKey)) return (0, _getDefault.default)(obj, dataKey, defaultValue);
    if ((0, _isFunctionDefault.default)(dataKey)) return dataKey(obj);
    return defaultValue;
}
function getDomainOfDataByKey(data, key, type, filterNil) {
    var flattenData = (0, _flatMapDefault.default)(data, function(entry) {
        return getValueByDataKey(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, _dataUtils.isNumber)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, _minDefault.default)(domain),
            (0, _maxDefault.default)(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, _isNilDefault.default)(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, _dataUtils.isNumOrStr)(entry) || entry instanceof Date ? entry : '';
    });
}
var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, _dataUtils.mathSign)(cur - before) !== (0, _dataUtils.mathSign)(after - cur)) {
                var diffInterval = [];
                if ((0, _dataUtils.mathSign)(after - cur) === (0, _dataUtils.mathSign)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var getBarSizeList = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, _reactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, _isNilDefault.default)(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var getBarPosition = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, _dataUtils.getPercentValue)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat(_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, _dataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat(_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, _getLegendProps.getLegendProps)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, _dataUtils.isNumber)(offset[align])) return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, _dataUtils.isNumber)(offset[verticalAlign])) return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, _isNilDefault.default)(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar)).filter(function(errorBarChild) {
        return isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = getValueByDataKey(entry, dataKey, 0);
            var mainValue = Array.isArray(entryValue) ? [
                (0, _minDefault.default)(entryValue),
                (0, _maxDefault.default)(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = getValueByDataKey(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return getDomainOfErrorBars(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, _isNilDefault.default)(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return getDomainOfErrorBars(data, item, dataKey, layout) || getDomainOfDataByKey(data, dataKey, type, filterNil);
        return getDomainOfDataByKey(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var isCategoricalAxis = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, _dataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, _isNaNDefault.default)(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var handlerWeakMap = new WeakMap();
var combineEventHandlers = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!handlerWeakMap.has(defaultHandler)) handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var parseScale = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: _d3Scale.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: _d3Scale.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: _d3Scale.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: _d3Scale.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: _d3Scale.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, _isStringDefault.default)(scale)) {
        var name = "scale".concat((0, _upperFirstDefault.default)(scale));
        return {
            scale: (_d3Scale[name] || _d3Scale.scalePoint)(),
            realScaleType: _d3Scale[name] ? name : 'point'
        };
    }
    return (0, _isFunctionDefault.default)(scale) ? {
        scale: scale
    } : {
        scale: _d3Scale.scalePoint(),
        realScaleType: 'point'
    };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - EPS;
    var maxValue = Math.max(range[0], range[1]) + EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var findPositionOfBar = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var truncateByDomain = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, _dataUtils.isNumber)(domain[0]) || !(0, _dataUtils.isNumber)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, _dataUtils.isNumber)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, _dataUtils.isNumber)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var offsetSign = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, _isNaNDefault.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var offsetPositive = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, _isNaNDefault.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var STACK_OFFSET_MAP = {
    sign: offsetSign,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, _d3Shape.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, _d3Shape.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, _d3Shape.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, _d3Shape.stackOffsetWiggle),
    positive: offsetPositive
};
var getStackedData = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = STACK_OFFSET_MAP[offsetType];
    var stack = (0, _d3Shape.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +getValueByDataKey(d, key, 0);
    }).order((0, _d3Shape.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$props2 = item.props, stackId = _item$props2.stackId, hide = _item$props2.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, _dataUtils.isNumOrStr)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, _dataUtils.uniqueId)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: getStackedData(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var getTicksOfScale = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, _minDefault.default)(tickValues),
            (0, _maxDefault.default)(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNilDefault.default)(entry[axis.dataKey])) {
            var matchedTick = (0, _dataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = getValueByDataKey(entry, !(0, _isNilDefault.default)(dataKey) ? dataKey : axis.dataKey);
    return !(0, _isNilDefault.default)(value) ? axis.scale(value) : null;
};
var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
    return !(0, _isNilDefault.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var getBaseValueOfBar = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, _dataUtils.isNumOrStr)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, _minDefault.default)(entry.concat([
                result[0]
            ]).filter((0, _dataUtils.isNumber))),
            (0, _maxDefault.default)(entry.concat([
                result[1]
            ]).filter((0, _dataUtils.isNumber)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, _isFunctionDefault.default)(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, _dataUtils.isNumber)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
        var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, _isFunctionDefault.default)(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, _dataUtils.isNumber)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
        var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, _isFunctionDefault.default)(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, _sortByDefault.default)(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, _isEqualDefault.default)(specifiedDomain, (0, _getDefault.default)(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var getTooltipItem = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: getMainColorOfGraphicItem(graphicalItem),
        value: getValueByDataKey(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};

},{"victory-vendor/d3-scale":"22AVB","victory-vendor/d3-shape":"fFCVX","lodash/max":"5g5H3","lodash/min":"dpb6A","lodash/isNil":"eS6AM","lodash/isFunction":"3A7xI","lodash/isString":"5nkFr","lodash/get":"dBTJh","lodash/flatMap":"aJDkJ","lodash/isNaN":"ih06S","lodash/upperFirst":"eSJZa","lodash/isEqual":"3mRdp","lodash/sortBy":"4paFu","recharts-scale":"ldtNH","../cartesian/ErrorBar":"1ePUt","./DataUtils":"5VTG4","./ReactUtils":"lj4u0","./getLegendProps":"aRqnG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"22AVB":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("ea85efe7e401a98a");

},{"ea85efe7e401a98a":"3iUt8"}],"3iUt8":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`
module.exports = require("9f3e91243b64b1b0");

},{"9f3e91243b64b1b0":"8mvIK"}],"8mvIK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return _band.default;
    }
});
Object.defineProperty(exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return _diverging.divergingLog;
    }
});
Object.defineProperty(exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return _diverging.divergingPow;
    }
});
Object.defineProperty(exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return _diverging.divergingSqrt;
    }
});
Object.defineProperty(exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return _diverging.divergingSymlog;
    }
});
Object.defineProperty(exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return _identity.default;
    }
});
Object.defineProperty(exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return _ordinal.implicit;
    }
});
Object.defineProperty(exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return _log.default;
    }
});
Object.defineProperty(exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return _ordinal.default;
    }
});
Object.defineProperty(exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return _band.point;
    }
});
Object.defineProperty(exports, "scalePow", {
    enumerable: true,
    get: function() {
        return _pow.default;
    }
});
Object.defineProperty(exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return _quantize.default;
    }
});
Object.defineProperty(exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return _radial.default;
    }
});
Object.defineProperty(exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return _sequential.default;
    }
});
Object.defineProperty(exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialLog;
    }
});
Object.defineProperty(exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialPow;
    }
});
Object.defineProperty(exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return _sequentialQuantile.default;
    }
});
Object.defineProperty(exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialSqrt;
    }
});
Object.defineProperty(exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialSymlog;
    }
});
Object.defineProperty(exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return _pow.sqrt;
    }
});
Object.defineProperty(exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return _symlog.default;
    }
});
Object.defineProperty(exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return _threshold.default;
    }
});
Object.defineProperty(exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return _time.default;
    }
});
Object.defineProperty(exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return _utcTime.default;
    }
});
Object.defineProperty(exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return _tickFormat.default;
    }
});
var _band = _interopRequireWildcard(require("b63efb80eb4f3997"));
var _identity = _interopRequireDefault(require("599666f8569781e"));
var _linear = _interopRequireDefault(require("81a646a660f644b0"));
var _log = _interopRequireDefault(require("86d5f4344a349716"));
var _symlog = _interopRequireDefault(require("b710ccde4c0e48a2"));
var _ordinal = _interopRequireWildcard(require("64b86754e86644bb"));
var _pow = _interopRequireWildcard(require("b1b95f640cc918be"));
var _radial = _interopRequireDefault(require("a92c7cfb56bc5881"));
var _quantile = _interopRequireDefault(require("592c2efd5d96bbdb"));
var _quantize = _interopRequireDefault(require("e52ffbce45f03bde"));
var _threshold = _interopRequireDefault(require("d72c59b81e30fbb0"));
var _time = _interopRequireDefault(require("8a3bda0d92036416"));
var _utcTime = _interopRequireDefault(require("889651fd1a77d2be"));
var _sequential = _interopRequireWildcard(require("fd5b5906f4fcb1c8"));
var _sequentialQuantile = _interopRequireDefault(require("4430958b59fb539b"));
var _diverging = _interopRequireWildcard(require("f8014e5ceaa878fb"));
var _tickFormat = _interopRequireDefault(require("1391cb83b35daafe"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"b63efb80eb4f3997":"3XIcL","599666f8569781e":"grhhr","81a646a660f644b0":"dQTNh","86d5f4344a349716":"bxOFO","b710ccde4c0e48a2":"iqOUB","64b86754e86644bb":"8cyn5","b1b95f640cc918be":"c5QfX","a92c7cfb56bc5881":"bcmi0","592c2efd5d96bbdb":"9J4WR","e52ffbce45f03bde":"2eOP8","d72c59b81e30fbb0":"cGBCy","8a3bda0d92036416":"9WDTW","889651fd1a77d2be":"7usYt","fd5b5906f4fcb1c8":"aDiix","4430958b59fb539b":"1OSpW","f8014e5ceaa878fb":"ftvdw","1391cb83b35daafe":"9cH6I"}],"3XIcL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = band;
exports.point = point;
var _index = require("c83c4aaf4d4f3e6c");
var _init = require("691f3ba4feec551a");
var _ordinal = _interopRequireDefault(require("933dd1d51fe58981"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function band() {
    var scale = (0, _ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _index.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return _init.initRange.apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"c83c4aaf4d4f3e6c":"a3yRD","691f3ba4feec551a":"dqCPN","933dd1d51fe58981":"8cyn5"}],"a3yRD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Adder", {
    enumerable: true,
    get: function() {
        return _fsum.Adder;
    }
});
Object.defineProperty(exports, "InternMap", {
    enumerable: true,
    get: function() {
        return _index.InternMap;
    }
});
Object.defineProperty(exports, "InternSet", {
    enumerable: true,
    get: function() {
        return _index.InternSet;
    }
});
Object.defineProperty(exports, "ascending", {
    enumerable: true,
    get: function() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "bin", {
    enumerable: true,
    get: function() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "bisect", {
    enumerable: true,
    get: function() {
        return _bisect.default;
    }
});
Object.defineProperty(exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return _bisect.bisectCenter;
    }
});
Object.defineProperty(exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return _bisect.bisectLeft;
    }
});
Object.defineProperty(exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return _bisect.bisectRight;
    }
});
Object.defineProperty(exports, "bisector", {
    enumerable: true,
    get: function() {
        return _bisector.default;
    }
});
Object.defineProperty(exports, "count", {
    enumerable: true,
    get: function() {
        return _count.default;
    }
});
Object.defineProperty(exports, "cross", {
    enumerable: true,
    get: function() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "cumsum", {
    enumerable: true,
    get: function() {
        return _cumsum.default;
    }
});
Object.defineProperty(exports, "descending", {
    enumerable: true,
    get: function() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "deviation", {
    enumerable: true,
    get: function() {
        return _deviation.default;
    }
});
Object.defineProperty(exports, "difference", {
    enumerable: true,
    get: function() {
        return _difference.default;
    }
});
Object.defineProperty(exports, "disjoint", {
    enumerable: true,
    get: function() {
        return _disjoint.default;
    }
});
Object.defineProperty(exports, "every", {
    enumerable: true,
    get: function() {
        return _every.default;
    }
});
Object.defineProperty(exports, "extent", {
    enumerable: true,
    get: function() {
        return _extent.default;
    }
});
Object.defineProperty(exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return _fsum.fcumsum;
    }
});
Object.defineProperty(exports, "filter", {
    enumerable: true,
    get: function() {
        return _filter.default;
    }
});
Object.defineProperty(exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return _group.flatGroup;
    }
});
Object.defineProperty(exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return _group.flatRollup;
    }
});
Object.defineProperty(exports, "fsum", {
    enumerable: true,
    get: function() {
        return _fsum.fsum;
    }
});
Object.defineProperty(exports, "greatest", {
    enumerable: true,
    get: function() {
        return _greatest.default;
    }
});
Object.defineProperty(exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return _greatestIndex.default;
    }
});
Object.defineProperty(exports, "group", {
    enumerable: true,
    get: function() {
        return _group.default;
    }
});
Object.defineProperty(exports, "groupSort", {
    enumerable: true,
    get: function() {
        return _groupSort.default;
    }
});
Object.defineProperty(exports, "groups", {
    enumerable: true,
    get: function() {
        return _group.groups;
    }
});
Object.defineProperty(exports, "histogram", {
    enumerable: true,
    get: function() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "index", {
    enumerable: true,
    get: function() {
        return _group.index;
    }
});
Object.defineProperty(exports, "indexes", {
    enumerable: true,
    get: function() {
        return _group.indexes;
    }
});
Object.defineProperty(exports, "intersection", {
    enumerable: true,
    get: function() {
        return _intersection.default;
    }
});
Object.defineProperty(exports, "least", {
    enumerable: true,
    get: function() {
        return _least.default;
    }
});
Object.defineProperty(exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return _leastIndex.default;
    }
});
Object.defineProperty(exports, "map", {
    enumerable: true,
    get: function() {
        return _map.default;
    }
});
Object.defineProperty(exports, "max", {
    enumerable: true,
    get: function() {
        return _max.default;
    }
});
Object.defineProperty(exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return _maxIndex.default;
    }
});
Object.defineProperty(exports, "mean", {
    enumerable: true,
    get: function() {
        return _mean.default;
    }
});
Object.defineProperty(exports, "median", {
    enumerable: true,
    get: function() {
        return _median.default;
    }
});
Object.defineProperty(exports, "merge", {
    enumerable: true,
    get: function() {
        return _merge.default;
    }
});
Object.defineProperty(exports, "min", {
    enumerable: true,
    get: function() {
        return _min.default;
    }
});
Object.defineProperty(exports, "minIndex", {
    enumerable: true,
    get: function() {
        return _minIndex.default;
    }
});
Object.defineProperty(exports, "mode", {
    enumerable: true,
    get: function() {
        return _mode.default;
    }
});
Object.defineProperty(exports, "nice", {
    enumerable: true,
    get: function() {
        return _nice.default;
    }
});
Object.defineProperty(exports, "pairs", {
    enumerable: true,
    get: function() {
        return _pairs.default;
    }
});
Object.defineProperty(exports, "permute", {
    enumerable: true,
    get: function() {
        return _permute.default;
    }
});
Object.defineProperty(exports, "quantile", {
    enumerable: true,
    get: function() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return _quantile.quantileSorted;
    }
});
Object.defineProperty(exports, "quickselect", {
    enumerable: true,
    get: function() {
        return _quickselect.default;
    }
});
Object.defineProperty(exports, "range", {
    enumerable: true,
    get: function() {
        return _range.default;
    }
});
Object.defineProperty(exports, "rank", {
    enumerable: true,
    get: function() {
        return _rank.default;
    }
});
Object.defineProperty(exports, "reduce", {
    enumerable: true,
    get: function() {
        return _reduce.default;
    }
});
Object.defineProperty(exports, "reverse", {
    enumerable: true,
    get: function() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "rollup", {
    enumerable: true,
    get: function() {
        return _group.rollup;
    }
});
Object.defineProperty(exports, "rollups", {
    enumerable: true,
    get: function() {
        return _group.rollups;
    }
});
Object.defineProperty(exports, "scan", {
    enumerable: true,
    get: function() {
        return _scan.default;
    }
});
Object.defineProperty(exports, "shuffle", {
    enumerable: true,
    get: function() {
        return _shuffle.default;
    }
});
Object.defineProperty(exports, "shuffler", {
    enumerable: true,
    get: function() {
        return _shuffle.shuffler;
    }
});
Object.defineProperty(exports, "some", {
    enumerable: true,
    get: function() {
        return _some.default;
    }
});
Object.defineProperty(exports, "sort", {
    enumerable: true,
    get: function() {
        return _sort.default;
    }
});
Object.defineProperty(exports, "subset", {
    enumerable: true,
    get: function() {
        return _subset.default;
    }
});
Object.defineProperty(exports, "sum", {
    enumerable: true,
    get: function() {
        return _sum.default;
    }
});
Object.defineProperty(exports, "superset", {
    enumerable: true,
    get: function() {
        return _superset.default;
    }
});
Object.defineProperty(exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return _freedmanDiaconis.default;
    }
});
Object.defineProperty(exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return _scott.default;
    }
});
Object.defineProperty(exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return _sturges.default;
    }
});
Object.defineProperty(exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return _ticks.tickIncrement;
    }
});
Object.defineProperty(exports, "tickStep", {
    enumerable: true,
    get: function() {
        return _ticks.tickStep;
    }
});
Object.defineProperty(exports, "ticks", {
    enumerable: true,
    get: function() {
        return _ticks.default;
    }
});
Object.defineProperty(exports, "transpose", {
    enumerable: true,
    get: function() {
        return _transpose.default;
    }
});
Object.defineProperty(exports, "union", {
    enumerable: true,
    get: function() {
        return _union.default;
    }
});
Object.defineProperty(exports, "variance", {
    enumerable: true,
    get: function() {
        return _variance.default;
    }
});
Object.defineProperty(exports, "zip", {
    enumerable: true,
    get: function() {
        return _zip.default;
    }
});
var _bisect = _interopRequireWildcard(require("30e30fd80e01d017"));
var _ascending = _interopRequireDefault(require("ba6e167afdeaab0b"));
var _bisector = _interopRequireDefault(require("a8afbc207886cfe5"));
var _count = _interopRequireDefault(require("1ec4d87c2d530b17"));
var _cross = _interopRequireDefault(require("e60cb580083b63b4"));
var _cumsum = _interopRequireDefault(require("2ed7a3899076eb06"));
var _descending = _interopRequireDefault(require("b44226224b8ee28a"));
var _deviation = _interopRequireDefault(require("3bfdfde74e5e3893"));
var _extent = _interopRequireDefault(require("e0c64cb1665c42fc"));
var _fsum = require("8239d81e924c7f9b");
var _group = _interopRequireWildcard(require("e133ef73b59e280f"));
var _groupSort = _interopRequireDefault(require("3c1ee14e652a9a74"));
var _bin = _interopRequireDefault(require("1c3fea00392fd51a"));
var _freedmanDiaconis = _interopRequireDefault(require("39d93dd913508747"));
var _scott = _interopRequireDefault(require("876933b3acb155ad"));
var _sturges = _interopRequireDefault(require("d1e08dd0d72014d7"));
var _max = _interopRequireDefault(require("5653c1d333b623cc"));
var _maxIndex = _interopRequireDefault(require("e384106528492a4"));
var _mean = _interopRequireDefault(require("e8829bf9149c3ef0"));
var _median = _interopRequireDefault(require("d00dfb19fe2fa3dd"));
var _merge = _interopRequireDefault(require("f8db612b317ca902"));
var _min = _interopRequireDefault(require("23890540251f6e67"));
var _minIndex = _interopRequireDefault(require("b9d42ff8895c4de8"));
var _mode = _interopRequireDefault(require("85fe3d40f6f5138d"));
var _nice = _interopRequireDefault(require("e8d14d9a3dedafe6"));
var _pairs = _interopRequireDefault(require("177b2ef4b4963970"));
var _permute = _interopRequireDefault(require("365c2a51c1482713"));
var _quantile = _interopRequireWildcard(require("1d56df0071525856"));
var _quickselect = _interopRequireDefault(require("1d2b63add15610db"));
var _range = _interopRequireDefault(require("879f1890a7517024"));
var _rank = _interopRequireDefault(require("912567809e44cbf8"));
var _least = _interopRequireDefault(require("c6b4300bede89d14"));
var _leastIndex = _interopRequireDefault(require("38f5be9e3fad1ac0"));
var _greatest = _interopRequireDefault(require("7fdad0a7cfab2520"));
var _greatestIndex = _interopRequireDefault(require("acba90bb290c79e9"));
var _scan = _interopRequireDefault(require("4a0a3c353076d5f7"));
var _shuffle = _interopRequireWildcard(require("ca2fb5eb530363f6"));
var _sum = _interopRequireDefault(require("fcc170790ec9f19b"));
var _ticks = _interopRequireWildcard(require("cd372a8370da3735"));
var _transpose = _interopRequireDefault(require("fece81f7cb114699"));
var _variance = _interopRequireDefault(require("68a6cbe5f6ed9d0b"));
var _zip = _interopRequireDefault(require("a43b4c003dde8ae5"));
var _every = _interopRequireDefault(require("aa419cb489a22141"));
var _some = _interopRequireDefault(require("2d20a8f791fd5767"));
var _filter = _interopRequireDefault(require("32260c06b0e9256d"));
var _map = _interopRequireDefault(require("6071cde151b05eb9"));
var _reduce = _interopRequireDefault(require("12d8fb254953b9bd"));
var _reverse = _interopRequireDefault(require("a0b2aacd1379b178"));
var _sort = _interopRequireDefault(require("68390ceda5e75df5"));
var _difference = _interopRequireDefault(require("e3b896de066f5364"));
var _disjoint = _interopRequireDefault(require("a4315b63bcb13bca"));
var _intersection = _interopRequireDefault(require("9f70d47eae5d7300"));
var _subset = _interopRequireDefault(require("56df3047d82ddba3"));
var _superset = _interopRequireDefault(require("f70ec3fe7b14f6c5"));
var _union = _interopRequireDefault(require("7c20e02710d1b117"));
var _index = require("5307d8bb084e9ec1");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"30e30fd80e01d017":"72lnB","ba6e167afdeaab0b":"bnIt1","a8afbc207886cfe5":"9atlW","1ec4d87c2d530b17":"37UKm","e60cb580083b63b4":"5qUIK","2ed7a3899076eb06":"cDEqq","b44226224b8ee28a":"aRBct","3bfdfde74e5e3893":"km770","e0c64cb1665c42fc":"iYOqp","8239d81e924c7f9b":"2mBrX","e133ef73b59e280f":"4Tvjk","3c1ee14e652a9a74":"jpXYE","1c3fea00392fd51a":"iY4Z6","39d93dd913508747":"8YfGK","876933b3acb155ad":"NykzC","d1e08dd0d72014d7":"ffzqw","5653c1d333b623cc":"33JTx","e384106528492a4":"a9Scj","e8829bf9149c3ef0":"01KTG","d00dfb19fe2fa3dd":"dG1jB","f8db612b317ca902":"iTnLI","23890540251f6e67":"lD6ST","b9d42ff8895c4de8":"fzuUT","85fe3d40f6f5138d":"gORAx","e8d14d9a3dedafe6":"ftct3","177b2ef4b4963970":"1khNb","365c2a51c1482713":"cXxzX","1d56df0071525856":"5gGVP","1d2b63add15610db":"8ZY5o","879f1890a7517024":"7AOY5","912567809e44cbf8":"dNsCs","c6b4300bede89d14":"cCwxC","38f5be9e3fad1ac0":"6pNli","7fdad0a7cfab2520":"goRck","acba90bb290c79e9":"6F6eL","4a0a3c353076d5f7":"2jjAC","ca2fb5eb530363f6":"bTMc4","fcc170790ec9f19b":"2pSBj","cd372a8370da3735":"hEI4X","fece81f7cb114699":"cDQX3","68a6cbe5f6ed9d0b":"baS4I","a43b4c003dde8ae5":"gwlis","aa419cb489a22141":"bCqwX","2d20a8f791fd5767":"2vM6r","32260c06b0e9256d":"7y80c","6071cde151b05eb9":"6nwDp","12d8fb254953b9bd":"lLXjp","a0b2aacd1379b178":"134wO","68390ceda5e75df5":"jFd9o","e3b896de066f5364":"e7prt","a4315b63bcb13bca":"j2rdi","9f70d47eae5d7300":"dGQr3","56df3047d82ddba3":"bkwXG","f70ec3fe7b14f6c5":"gpTMT","7c20e02710d1b117":"3UUsW","5307d8bb084e9ec1":"iRXKz"}],"72lnB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.bisectRight = exports.bisectLeft = exports.bisectCenter = void 0;
var _ascending = _interopRequireDefault(require("c1f158b330aaa13c"));
var _bisector = _interopRequireDefault(require("ae9e5922ca82e11d"));
var _number = _interopRequireDefault(require("7b6cc53664acedc3"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ascendingBisect = (0, _bisector.default)(_ascending.default);
const bisectRight = ascendingBisect.right;
exports.bisectRight = bisectRight;
const bisectLeft = ascendingBisect.left;
exports.bisectLeft = bisectLeft;
const bisectCenter = (0, _bisector.default)(_number.default).center;
exports.bisectCenter = bisectCenter;
var _default = bisectRight;
exports.default = _default;

},{"c1f158b330aaa13c":"bnIt1","ae9e5922ca82e11d":"9atlW","7b6cc53664acedc3":"h0AIL"}],"bnIt1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ascending;
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{}],"9atlW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bisector;
var _ascending = _interopRequireDefault(require("7cbc9edd390ae8bb"));
var _descending = _interopRequireDefault(require("bbf176e93324968c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = _ascending.default;
        compare2 = (d, x)=>(0, _ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === _ascending.default || f === _descending.default ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"7cbc9edd390ae8bb":"bnIt1","bbf176e93324968c":"aRBct"}],"aRBct":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = descending;
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"h0AIL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
exports.numbers = numbers;
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{}],"37UKm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = count;
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{}],"5qUIK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cross;
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{}],"cDEqq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cumsum;
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{}],"km770":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deviation;
var _variance = _interopRequireDefault(require("51ae5f4f20d14175"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function deviation(values, valueof) {
    const v = (0, _variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"51ae5f4f20d14175":"baS4I"}],"baS4I":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = variance;
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{}],"iYOqp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = extent;
function extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

},{}],"2mBrX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Adder = void 0;
exports.fcumsum = fcumsum;
exports.fsum = fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
exports.Adder = Adder;
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{}],"4Tvjk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = group;
exports.flatGroup = flatGroup;
exports.flatRollup = flatRollup;
exports.groups = groups;
exports.index = index;
exports.indexes = indexes;
exports.rollup = rollup;
exports.rollups = rollups;
var _index = require("48004d0dfe52b7a6");
var _identity = _interopRequireDefault(require("3cf6030d781ef6b2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function group(values, ...keys) {
    return nest(values, _identity.default, _identity.default, keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, _identity.default, keys);
}
function flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function flatGroup(values, ...keys) {
    return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce, ...keys) {
    return flatten(rollups(values, reduce, ...keys), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, _identity.default, reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, _identity.default, unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new _index.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"48004d0dfe52b7a6":"iRXKz","3cf6030d781ef6b2":"7LZ4g"}],"iRXKz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InternSet = exports.InternMap = void 0;
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
exports.InternMap = InternMap;
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
exports.InternSet = InternSet;
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{}],"7LZ4g":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
function identity(x) {
    return x;
}

},{}],"jpXYE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = groupSort;
var _ascending = _interopRequireDefault(require("325640508c2e43b"));
var _group = _interopRequireWildcard(require("57a8d19e7d7a16cf"));
var _sort = _interopRequireDefault(require("a759bcb922f07eb1"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sort.default)((0, _group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascending.default)(av, bv) || (0, _ascending.default)(ak, bk)) : (0, _sort.default)((0, _group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascending.default)(ak, bk))).map(([key])=>key);
}

},{"325640508c2e43b":"bnIt1","57a8d19e7d7a16cf":"4Tvjk","a759bcb922f07eb1":"jFd9o"}],"jFd9o":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ascendingDefined = ascendingDefined;
exports.compareDefined = compareDefined;
exports.default = sort;
var _ascending = _interopRequireDefault(require("17dda5769044e4af"));
var _permute = _interopRequireDefault(require("45ed8435c3fc2fdf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>ascendingDefined(f[i], f[j]));
        }
        return (0, _permute.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined(compare = _ascending.default) {
    if (compare === _ascending.default) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"17dda5769044e4af":"bnIt1","45ed8435c3fc2fdf":"cXxzX"}],"cXxzX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = permute;
function permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

},{}],"iY4Z6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bin;
var _array = require("2e045be59e43c77");
var _bisect = _interopRequireDefault(require("319eb924a032034c"));
var _constant = _interopRequireDefault(require("2d6358dd303eb77c"));
var _extent = _interopRequireDefault(require("b715ed473e0ab15b"));
var _identity = _interopRequireDefault(require("f9340ffc2d80b8ca"));
var _nice = _interopRequireDefault(require("c13788fe41624795"));
var _ticks = _interopRequireWildcard(require("b122967555bb47b9"));
var _sturges = _interopRequireDefault(require("3587d7f4446a1fc2"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bin() {
    var value = _identity.default, domain = _extent.default, threshold = _sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === _extent.default) [x0, x1] = (0, _nice.default)(x0, x1, tn);
            tz = (0, _ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === _extent.default) {
                    const step = (0, _ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constant.default)(_array.slice.call(_)) : (0, _constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

},{"2e045be59e43c77":"9GlW3","319eb924a032034c":"72lnB","2d6358dd303eb77c":"fF8Od","b715ed473e0ab15b":"iYOqp","f9340ffc2d80b8ca":"7LZ4g","c13788fe41624795":"ftct3","b122967555bb47b9":"hEI4X","3587d7f4446a1fc2":"ffzqw"}],"9GlW3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.slice = exports.map = void 0;
var array = Array.prototype;
var slice = array.slice;
exports.slice = slice;
var map = array.map;
exports.map = map;

},{}],"fF8Od":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constant;
function constant(x) {
    return ()=>x;
}

},{}],"ftct3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
var _ticks = require("82883d5f91d2ba9");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticks.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"82883d5f91d2ba9":"hEI4X"}],"hEI4X":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ticks;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{}],"ffzqw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdSturges;
var _count = _interopRequireDefault(require("d856b0d375bb9b61"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdSturges(values) {
    return Math.ceil(Math.log((0, _count.default)(values)) / Math.LN2) + 1;
}

},{"d856b0d375bb9b61":"37UKm"}],"8YfGK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdFreedmanDiaconis;
var _count = _interopRequireDefault(require("84a2a08734413081"));
var _quantile = _interopRequireDefault(require("b453688def319e0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, _quantile.default)(values, 0.75) - (0, _quantile.default)(values, 0.25)) * Math.pow((0, _count.default)(values), -1 / 3)));
}

},{"84a2a08734413081":"37UKm","b453688def319e0":"5gGVP"}],"5gGVP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
exports.quantileSorted = quantileSorted;
var _max = _interopRequireDefault(require("6377896bac51b475"));
var _min = _interopRequireDefault(require("7403c617ea3dc723"));
var _quickselect = _interopRequireDefault(require("fa6451b912e13124"));
var _number = _interopRequireWildcard(require("de13410c4756be71"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, _min.default)(values);
    if (p >= 1) return (0, _max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _max.default)((0, _quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = _number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

},{"6377896bac51b475":"33JTx","7403c617ea3dc723":"lD6ST","fa6451b912e13124":"8ZY5o","de13410c4756be71":"h0AIL"}],"33JTx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = max;
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{}],"lD6ST":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = min;
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{}],"8ZY5o":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quickselect;
var _sort = require("c4d7054457278972");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? _sort.ascendingDefined : (0, _sort.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"c4d7054457278972":"jFd9o"}],"NykzC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdScott;
var _count = _interopRequireDefault(require("544301f03b7cfef6"));
var _deviation = _interopRequireDefault(require("9c084667c87040d5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, _count.default)(values)) / (3.49 * (0, _deviation.default)(values)));
}

},{"544301f03b7cfef6":"37UKm","9c084667c87040d5":"km770"}],"a9Scj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = maxIndex;
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{}],"01KTG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mean;
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{}],"dG1jB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = median;
var _quantile = _interopRequireDefault(require("73b253d4e179eac9"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function median(values, valueof) {
    return (0, _quantile.default)(values, 0.5, valueof);
}

},{"73b253d4e179eac9":"5gGVP"}],"iTnLI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = merge;
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{}],"fzuUT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = minIndex;
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{}],"gORAx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mode;
var _index = require("cc79d9604cb49161");
function mode(values, valueof) {
    const counts = new _index.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

},{"cc79d9604cb49161":"iRXKz"}],"1khNb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pairs;
exports.pair = pair;
function pairs(values, pairof = pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{}],"7AOY5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = range;
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{}],"dNsCs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rank;
var _ascending = _interopRequireDefault(require("3d6b2e0137da2f5f"));
var _sort = require("baf9f3a118e8a4c3");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function rank(values, valueof = _ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = _ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === _ascending.default ? (i, j)=>(0, _sort.ascendingDefined)(V[i], V[j]) : (0, _sort.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"3d6b2e0137da2f5f":"bnIt1","baf9f3a118e8a4c3":"jFd9o"}],"cCwxC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = least;
var _ascending = _interopRequireDefault(require("86cd41303b4be24c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function least(values, compare = _ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascending.default)(value, minValue) < 0 : (0, _ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"86cd41303b4be24c":"bnIt1"}],"6pNli":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = leastIndex;
var _ascending = _interopRequireDefault(require("3a70505afbae26e3"));
var _minIndex = _interopRequireDefault(require("7863dae356808098"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function leastIndex(values, compare = _ascending.default) {
    if (compare.length === 1) return (0, _minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"3a70505afbae26e3":"bnIt1","7863dae356808098":"fzuUT"}],"goRck":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatest;
var _ascending = _interopRequireDefault(require("7e4721a4d28ff20a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatest(values, compare = _ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascending.default)(value, maxValue) > 0 : (0, _ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"7e4721a4d28ff20a":"bnIt1"}],"6F6eL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatestIndex;
var _ascending = _interopRequireDefault(require("a08614b50d783d7f"));
var _maxIndex = _interopRequireDefault(require("c1f809321f205561"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatestIndex(values, compare = _ascending.default) {
    if (compare.length === 1) return (0, _maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"a08614b50d783d7f":"bnIt1","c1f809321f205561":"a9Scj"}],"2jjAC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = scan;
var _leastIndex = _interopRequireDefault(require("620579109956e518"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function scan(values, compare) {
    const index = (0, _leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"620579109956e518":"6pNli"}],"bTMc4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.shuffler = shuffler;
var _default = shuffler(Math.random);
exports.default = _default;
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{}],"2pSBj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sum;
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{}],"cDQX3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = transpose;
var _min = _interopRequireDefault(require("e91a8bba11a65cd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _min.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function length(d) {
    return d.length;
}

},{"e91a8bba11a65cd":"lD6ST"}],"gwlis":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = zip;
var _transpose = _interopRequireDefault(require("f5cee9197fcba405"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function zip() {
    return (0, _transpose.default)(arguments);
}

},{"f5cee9197fcba405":"cDQX3"}],"bCqwX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = every;
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{}],"2vM6r":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = some;
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{}],"7y80c":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filter;
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{}],"6nwDp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = map;
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{}],"lLXjp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reduce;
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{}],"134wO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reverse;
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{}],"e7prt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = difference;
var _index = require("53f785431e2265c8");
function difference(values, ...others) {
    values = new _index.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"53f785431e2265c8":"iRXKz"}],"j2rdi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = disjoint;
var _index = require("fd3ab907acc87368");
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new _index.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"fd3ab907acc87368":"iRXKz"}],"dGQr3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = intersection;
var _index = require("57400e6933e84289");
function intersection(values, ...others) {
    values = new _index.InternSet(values);
    others = others.map(set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function set(values) {
    return values instanceof _index.InternSet ? values : new _index.InternSet(values);
}

},{"57400e6933e84289":"iRXKz"}],"bkwXG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subset;
var _superset = _interopRequireDefault(require("642286ff2d84a077"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function subset(values, other) {
    return (0, _superset.default)(other, values);
}

},{"642286ff2d84a077":"gpTMT"}],"gpTMT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = superset;
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            const ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{}],"3UUsW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = union;
var _index = require("c01638dea2a1bd81");
function union(...others) {
    const set = new _index.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"c01638dea2a1bd81":"iRXKz"}],"dqCPN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initInterpolator = initInterpolator;
exports.initRange = initRange;
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{}],"8cyn5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ordinal;
exports.implicit = void 0;
var _index = require("fcba4401bac5bf73");
var _init = require("cc7553c4008fe238");
const implicit = Symbol("implicit");
exports.implicit = implicit;
function ordinal() {
    var index = new _index.InternMap(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new _index.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"fcba4401bac5bf73":"a3yRD","cc7553c4008fe238":"dqCPN"}],"grhhr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
var _linear = require("f84b1fa17c06395b");
var _number = _interopRequireDefault(require("b36082d6f802f397"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, _number.default) : [
        0,
        1
    ];
    return (0, _linear.linearish)(scale);
}

},{"f84b1fa17c06395b":"dQTNh","b36082d6f802f397":"6x3es"}],"dQTNh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = linear;
exports.linearish = linearish;
var _index = require("1483cc73fade9a0f");
var _continuous = _interopRequireWildcard(require("b89b32e6dad66d07"));
var _init = require("a628a2e1a79e7cdb");
var _tickFormat = _interopRequireDefault(require("a55604f9dbd11e62"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _index.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _index.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuous.default)();
    scale.copy = function() {
        return (0, _continuous.copy)(scale, linear());
    };
    _init.initRange.apply(scale, arguments);
    return linearish(scale);
}

},{"1483cc73fade9a0f":"a3yRD","b89b32e6dad66d07":"2mXaL","a628a2e1a79e7cdb":"dqCPN","a55604f9dbd11e62":"9cH6I"}],"2mXaL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = continuous;
exports.identity = identity;
exports.transformer = transformer;
var _index = require("b27e55bf39279c79");
var _index2 = require("ba6b5a0092937a29");
var _constant = _interopRequireDefault(require("e75211b791b964e7"));
var _number = _interopRequireDefault(require("d695e4a3f96a954d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constant.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _index.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = _index2.interpolate, transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), _index2.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = _index2.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"b27e55bf39279c79":"a3yRD","ba6b5a0092937a29":"jNtfI","e75211b791b964e7":"8TitP","d695e4a3f96a954d":"6x3es"}],"jNtfI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "interpolate", {
    enumerable: true,
    get: function() {
        return _value.default;
    }
});
Object.defineProperty(exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return _array.default;
    }
});
Object.defineProperty(exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return _cubehelix.cubehelixLong;
    }
});
Object.defineProperty(exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return _date.default;
    }
});
Object.defineProperty(exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return _discrete.default;
    }
});
Object.defineProperty(exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return _hcl.default;
    }
});
Object.defineProperty(exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return _hcl.hclLong;
    }
});
Object.defineProperty(exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return _hsl.default;
    }
});
Object.defineProperty(exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return _hsl.hslLong;
    }
});
Object.defineProperty(exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return _hue.default;
    }
});
Object.defineProperty(exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return _number.default;
    }
});
Object.defineProperty(exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return _numberArray.default;
    }
});
Object.defineProperty(exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return _object.default;
    }
});
Object.defineProperty(exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return _rgb.default;
    }
});
Object.defineProperty(exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return _rgb.rgbBasis;
    }
});
Object.defineProperty(exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return _rgb.rgbBasisClosed;
    }
});
Object.defineProperty(exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return _round.default;
    }
});
Object.defineProperty(exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return _string.default;
    }
});
Object.defineProperty(exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return _index.interpolateTransformCss;
    }
});
Object.defineProperty(exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return _index.interpolateTransformSvg;
    }
});
Object.defineProperty(exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return _zoom.default;
    }
});
Object.defineProperty(exports, "piecewise", {
    enumerable: true,
    get: function() {
        return _piecewise.default;
    }
});
Object.defineProperty(exports, "quantize", {
    enumerable: true,
    get: function() {
        return _quantize.default;
    }
});
var _value = _interopRequireDefault(require("18a1769b74308b38"));
var _array = _interopRequireDefault(require("f99323a27aa06a8c"));
var _basis = _interopRequireDefault(require("66bb1ae08d550d2f"));
var _basisClosed = _interopRequireDefault(require("e0f8689cd9a4ed85"));
var _date = _interopRequireDefault(require("938cc47dd24b27f"));
var _discrete = _interopRequireDefault(require("6ee3a660784662db"));
var _hue = _interopRequireDefault(require("c97b3402df3264f1"));
var _number = _interopRequireDefault(require("c4605d70387a9f89"));
var _numberArray = _interopRequireDefault(require("f5b9681bf316d3c8"));
var _object = _interopRequireDefault(require("2a8363d30def3d49"));
var _round = _interopRequireDefault(require("132735e62b44017c"));
var _string = _interopRequireDefault(require("5f79c0b417d7ffb1"));
var _index = require("9cd31cac42489c2d");
var _zoom = _interopRequireDefault(require("829022ddb9572f68"));
var _rgb = _interopRequireWildcard(require("a08467c6d9046172"));
var _hsl = _interopRequireWildcard(require("1b2f37b38b1c2632"));
var _lab = _interopRequireDefault(require("76284b3c5d04b53e"));
var _hcl = _interopRequireWildcard(require("361bffab7c7a6e6a"));
var _cubehelix = _interopRequireWildcard(require("c6d6249c783d060a"));
var _piecewise = _interopRequireDefault(require("cb02924b4c722e0d"));
var _quantize = _interopRequireDefault(require("d55fda9f4fcff7dd"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"18a1769b74308b38":"lgnZn","f99323a27aa06a8c":"4SR6v","66bb1ae08d550d2f":"7KUSz","e0f8689cd9a4ed85":"eB21e","938cc47dd24b27f":"dJlmL","6ee3a660784662db":"1wC5U","c97b3402df3264f1":"31NDU","c4605d70387a9f89":"ehlb7","f5b9681bf316d3c8":"du2z5","2a8363d30def3d49":"1ryMe","132735e62b44017c":"gpx73","5f79c0b417d7ffb1":"1tEzF","9cd31cac42489c2d":"2inlt","829022ddb9572f68":"5amrf","a08467c6d9046172":"gPSyd","1b2f37b38b1c2632":"hQEYy","76284b3c5d04b53e":"dIS2A","361bffab7c7a6e6a":"3uhmT","c6d6249c783d060a":"22BjP","cb02924b4c722e0d":"97Vrx","d55fda9f4fcff7dd":"dCWHk"}],"lgnZn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("6b00cb8a35cd7eca");
var _rgb = _interopRequireDefault(require("2f5b9308d0021b3f"));
var _array = require("858d92aa5fbe2d16");
var _date = _interopRequireDefault(require("3b5f3eaf3c70c4df"));
var _number = _interopRequireDefault(require("7aa3212a6360303f"));
var _object = _interopRequireDefault(require("4512622efcc3e244"));
var _string = _interopRequireDefault(require("4f6ec7c7e2d116a"));
var _constant = _interopRequireDefault(require("49fed36e04134ce7"));
var _numberArray = _interopRequireWildcard(require("7635b225e783f2fb"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, _constant.default)(b) : (t === "number" ? _number.default : t === "string" ? (c = (0, _index.color)(b)) ? (b = c, _rgb.default) : _string.default : b instanceof _index.color ? _rgb.default : b instanceof Date ? _date.default : (0, _numberArray.isNumberArray)(b) ? _numberArray.default : Array.isArray(b) ? _array.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? _object.default : _number.default)(a, b);
}

},{"6b00cb8a35cd7eca":"hvXGa","2f5b9308d0021b3f":"gPSyd","858d92aa5fbe2d16":"4SR6v","3b5f3eaf3c70c4df":"dJlmL","7aa3212a6360303f":"ehlb7","4512622efcc3e244":"1ryMe","4f6ec7c7e2d116a":"1tEzF","49fed36e04134ce7":"9xLTD","7635b225e783f2fb":"du2z5"}],"hvXGa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "color", {
    enumerable: true,
    get: function() {
        return _color.default;
    }
});
Object.defineProperty(exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "gray", {
    enumerable: true,
    get: function() {
        return _lab.gray;
    }
});
Object.defineProperty(exports, "hcl", {
    enumerable: true,
    get: function() {
        return _lab.hcl;
    }
});
Object.defineProperty(exports, "hsl", {
    enumerable: true,
    get: function() {
        return _color.hsl;
    }
});
Object.defineProperty(exports, "lab", {
    enumerable: true,
    get: function() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "lch", {
    enumerable: true,
    get: function() {
        return _lab.lch;
    }
});
Object.defineProperty(exports, "rgb", {
    enumerable: true,
    get: function() {
        return _color.rgb;
    }
});
var _color = _interopRequireWildcard(require("60878dcd6741cbf6"));
var _lab = _interopRequireWildcard(require("19fbdf90fb32e3fb"));
var _cubehelix = _interopRequireDefault(require("84a7e361b17f11ef"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"60878dcd6741cbf6":"tCliw","19fbdf90fb32e3fb":"1qnKA","84a7e361b17f11ef":"3Sz4C"}],"tCliw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;
var _define = _interopRequireWildcard(require("1d30727e3b2969dd"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"1d30727e3b2969dd":"cOwnz"}],"cOwnz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.extend = extend;
function _default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{}],"1qnKA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Hcl = Hcl;
exports.Lab = Lab;
exports.default = lab;
exports.gray = gray;
exports.hcl = hcl;
exports.lch = lch;
var _define = _interopRequireWildcard(require("9a3353011f08cad1"));
var _color = require("3650f0b1e5700098");
var _math = require("ef21497f13ac1079");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Lab, lab, (0, _define.extend)(_color.Color, {
    brighter (k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new _color.Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * _math.degrees;
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * _math.radians;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _define.default)(Hcl, hcl, (0, _define.extend)(_color.Color, {
    brighter (k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return hcl2lab(this).rgb();
    }
}));

},{"9a3353011f08cad1":"cOwnz","3650f0b1e5700098":"tCliw","ef21497f13ac1079":"bMO5X"}],"bMO5X":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.radians = exports.degrees = void 0;
const radians = Math.PI / 180;
exports.radians = radians;
const degrees = 180 / Math.PI;
exports.degrees = degrees;

},{}],"3Sz4C":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cubehelix = Cubehelix;
exports.default = cubehelix;
var _define = _interopRequireWildcard(require("4abcf1c064e6684a"));
var _color = require("88aa652eacec148e");
var _math = require("7e69901a6e423f00");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * _math.degrees - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Cubehelix, cubehelix, (0, _define.extend)(_color.Color, {
    brighter (k) {
        k = k == null ? _color.brighter : Math.pow(_color.brighter, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? _color.darker : Math.pow(_color.darker, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * _math.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new _color.Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"4abcf1c064e6684a":"cOwnz","88aa652eacec148e":"tCliw","7e69901a6e423f00":"bMO5X"}],"gPSyd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rgbBasisClosed = exports.rgbBasis = exports.default = void 0;
var _index = require("a71c13c6f95adbd4");
var _basis = _interopRequireDefault(require("6a332a97102860d7"));
var _basisClosed = _interopRequireDefault(require("9304424e5c9a17cf"));
var _color = _interopRequireWildcard(require("7dffa81f3b4437d6"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = function rgbGamma(y) {
    var color = (0, _color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _index.rgb)(start)).r, (end = (0, _index.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
exports.default = _default;
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _index.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline(_basis.default);
exports.rgbBasis = rgbBasis;
var rgbBasisClosed = rgbSpline(_basisClosed.default);
exports.rgbBasisClosed = rgbBasisClosed;

},{"a71c13c6f95adbd4":"hvXGa","6a332a97102860d7":"7KUSz","9304424e5c9a17cf":"eB21e","7dffa81f3b4437d6":"luaUv"}],"7KUSz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.basis = basis;
exports.default = _default;
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function _default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{}],"eB21e":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("fa54a771ab54df01");
function _default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, _basis.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{"fa54a771ab54df01":"7KUSz"}],"luaUv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nogamma;
exports.gamma = gamma;
exports.hue = hue;
var _constant = _interopRequireDefault(require("c45f0b08e65bfe9d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constant.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constant.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constant.default)(isNaN(a) ? b : a);
}

},{"c45f0b08e65bfe9d":"9xLTD"}],"9xLTD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = (x)=>()=>x;
exports.default = _default;

},{}],"4SR6v":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.genericArray = genericArray;
var _value = _interopRequireDefault(require("b86da8c7688bb1d9"));
var _numberArray = _interopRequireWildcard(require("505aa46a393cd613"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    return ((0, _numberArray.isNumberArray)(b) ? _numberArray.default : genericArray)(a, b);
}
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"b86da8c7688bb1d9":"lgnZn","505aa46a393cd613":"du2z5"}],"du2z5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.isNumberArray = isNumberArray;
function _default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{}],"dJlmL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

},{}],"ehlb7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

},{}],"1ryMe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _value = _interopRequireDefault(require("ff3c10c6ba896e53"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, _value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

},{"ff3c10c6ba896e53":"lgnZn"}],"1tEzF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _number = _interopRequireDefault(require("1ec1f242696e82fa"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function _default(a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = reA.exec(a)) && (bm = reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, _number.default)(am, bm)
            });
        }
        bi = reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

},{"1ec1f242696e82fa":"ehlb7"}],"1wC5U":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

},{}],"31NDU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _color = require("f9552f2567e33cad");
function _default(a, b) {
    var i = (0, _color.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

},{"f9552f2567e33cad":"luaUv"}],"gpx73":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

},{}],"2inlt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.interpolateTransformSvg = exports.interpolateTransformCss = void 0;
var _number = _interopRequireDefault(require("3e2d37e598810190"));
var _parse = require("4b3d6acbd4a3c21a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform(_parse.parseCss, "px, ", "px)", "deg)");
exports.interpolateTransformCss = interpolateTransformCss;
var interpolateTransformSvg = interpolateTransform(_parse.parseSvg, ", ", ")", ")");
exports.interpolateTransformSvg = interpolateTransformSvg;

},{"3e2d37e598810190":"ehlb7","4b3d6acbd4a3c21a":"dOaGw"}],"dOaGw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseCss = parseCss;
exports.parseSvg = parseSvg;
var _decompose = _interopRequireWildcard(require("6801e9b7b9a8c06f"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var svgNode;
/* eslint-disable no-undef */ function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? _decompose.identity : (0, _decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return _decompose.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return _decompose.identity;
    value = value.matrix;
    return (0, _decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"6801e9b7b9a8c06f":"8x26f"}],"8x26f":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.identity = void 0;
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
exports.identity = identity;
function _default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * degrees,
        skewX: Math.atan(skewX) * degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

},{}],"5amrf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var _default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
exports.default = _default;

},{}],"hQEYy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hslLong = exports.default = void 0;
var _index = require("8527dae26181d5cf");
var _color = _interopRequireWildcard(require("45faacac073e112a"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hsl)(start)).h, (end = (0, _index.hsl)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = hsl(_color.hue);
exports.default = _default;
var hslLong = hsl(_color.default);
exports.hslLong = hslLong;

},{"8527dae26181d5cf":"hvXGa","45faacac073e112a":"luaUv"}],"dIS2A":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = lab;
var _index = require("bb962b0e100409c3");
var _color = _interopRequireDefault(require("39c4c5a5fff46e6a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function lab(start, end) {
    var l = (0, _color.default)((start = (0, _index.lab)(start)).l, (end = (0, _index.lab)(end)).l), a = (0, _color.default)(start.a, end.a), b = (0, _color.default)(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"bb962b0e100409c3":"hvXGa","39c4c5a5fff46e6a":"luaUv"}],"3uhmT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hclLong = exports.default = void 0;
var _index = require("5dab9e1ee5c5ab5d");
var _color = _interopRequireWildcard(require("4a63660e3a72d4d2"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hcl)(start)).h, (end = (0, _index.hcl)(end)).h), c = (0, _color.default)(start.c, end.c), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = hcl(_color.hue);
exports.default = _default;
var hclLong = hcl(_color.default);
exports.hclLong = hclLong;

},{"5dab9e1ee5c5ab5d":"hvXGa","4a63660e3a72d4d2":"luaUv"}],"22BjP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.cubehelixLong = void 0;
var _index = require("981aef0afb354b0c");
var _color = _interopRequireWildcard(require("f9336ad633bd893d"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _index.cubehelix)(start)).h, (end = (0, _index.cubehelix)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var _default = cubehelix(_color.hue);
exports.default = _default;
var cubehelixLong = cubehelix(_color.default);
exports.cubehelixLong = cubehelixLong;

},{"981aef0afb354b0c":"hvXGa","f9336ad633bd893d":"luaUv"}],"97Vrx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = piecewise;
var _value = _interopRequireDefault(require("5c06b65a4f09269b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = _value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"5c06b65a4f09269b":"lgnZn"}],"dCWHk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

},{}],"8TitP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constants;
function constants(x) {
    return function() {
        return x;
    };
}

},{}],"6x3es":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
function number(x) {
    return +x;
}

},{}],"9cH6I":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = tickFormat;
var _index = require("a4043605242eb496");
var _index2 = require("8da1e3e06f47624b");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _index.tickStep)(start, stop, count), precision;
    specifier = (0, _index2.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _index2.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _index2.format)(specifier);
}

},{"a4043605242eb496":"a3yRD","8da1e3e06f47624b":"ZTcXI"}],"ZTcXI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return _formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(exports, "format", {
    enumerable: true,
    get: function() {
        return _defaultLocale.format;
    }
});
Object.defineProperty(exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return _defaultLocale.formatPrefix;
    }
});
Object.defineProperty(exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return _formatSpecifier.default;
    }
});
Object.defineProperty(exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return _precisionFixed.default;
    }
});
Object.defineProperty(exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return _precisionPrefix.default;
    }
});
Object.defineProperty(exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return _precisionRound.default;
    }
});
var _defaultLocale = _interopRequireWildcard(require("2ee0c7b1a22e44e6"));
var _locale = _interopRequireDefault(require("ff358412e51164cd"));
var _formatSpecifier = _interopRequireWildcard(require("60d6396182b4fde8"));
var _precisionFixed = _interopRequireDefault(require("792b165b9b0bcf2d"));
var _precisionPrefix = _interopRequireDefault(require("f2702d774fe2085c"));
var _precisionRound = _interopRequireDefault(require("492f493218059efd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"2ee0c7b1a22e44e6":"aYFkp","ff358412e51164cd":"fFeIQ","60d6396182b4fde8":"kZ2Zz","792b165b9b0bcf2d":"gSDa9","f2702d774fe2085c":"lCYfP","492f493218059efd":"583G9"}],"aYFkp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.formatPrefix = exports.format = void 0;
var _locale = _interopRequireDefault(require("317c67875ded3d99"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var format;
exports.format = format;
var formatPrefix;
exports.formatPrefix = formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.format = format = locale.format;
    exports.formatPrefix = formatPrefix = locale.formatPrefix;
    return locale;
}

},{"317c67875ded3d99":"fFeIQ"}],"fFeIQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("f55671e2db2b86ef"));
var _formatGroup = _interopRequireDefault(require("e366a511ee4b4f2f"));
var _formatNumerals = _interopRequireDefault(require("86155372ae3c6f7e"));
var _formatSpecifier = _interopRequireDefault(require("1b6c7d0076b09661"));
var _formatTrim = _interopRequireDefault(require("8fea1479564cd384"));
var _formatTypes = _interopRequireDefault(require("8cc741dcfb99dfd9"));
var _formatPrefixAuto = require("10cbdd8f7ac88548");
var _identity = _interopRequireDefault(require("efeab53251079183"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function _default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? _identity.default : (0, _formatGroup.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? _identity.default : (0, _formatNumerals.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, _formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = _formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, _formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? prefixes[8 + _formatPrefixAuto.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, _formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

},{"f55671e2db2b86ef":"hAYDO","e366a511ee4b4f2f":"eBv9e","86155372ae3c6f7e":"4osmw","1b6c7d0076b09661":"kZ2Zz","8fea1479564cd384":"9tjaa","8cc741dcfb99dfd9":"675xC","10cbdd8f7ac88548":"jt0hN","efeab53251079183":"z9tST"}],"hAYDO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("bc7d6f0e0b7ad989");
function _default(x) {
    return x = (0, _formatDecimal.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

},{"bc7d6f0e0b7ad989":"f9Epp"}],"f9Epp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.formatDecimalParts = formatDecimalParts;
function _default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{}],"eBv9e":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

},{}],"4osmw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

},{}],"kZ2Zz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormatSpecifier = FormatSpecifier;
exports.default = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{}],"9tjaa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function _default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

},{}],"675xC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _formatDecimal = _interopRequireDefault(require("feafbe2a554fb639"));
var _formatPrefixAuto = _interopRequireDefault(require("8d1082b790377352"));
var _formatRounded = _interopRequireDefault(require("35a9fc35835a2a14"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": _formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRounded.default)(x * 100, p),
    "r": _formatRounded.default,
    "s": _formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
exports.default = _default;

},{"feafbe2a554fb639":"f9Epp","8d1082b790377352":"jt0hN","35a9fc35835a2a14":"2cOlp"}],"jt0hN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.prefixExponent = void 0;
var _formatDecimal = require("c968343e236e1eff");
var prefixExponent;
exports.prefixExponent = prefixExponent;
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (exports.prefixExponent = prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimal.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

},{"c968343e236e1eff":"f9Epp"}],"2cOlp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("8a356ace3ecb0657");
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

},{"8a356ace3ecb0657":"f9Epp"}],"z9tST":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return x;
}

},{}],"gSDa9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("10ac7ec4cef9eac2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step) {
    return Math.max(0, -(0, _exponent.default)(Math.abs(step)));
}

},{"10ac7ec4cef9eac2":"hAYDO"}],"lCYfP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("a74b6430297cf90d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3 - (0, _exponent.default)(Math.abs(step)));
}

},{"a74b6430297cf90d":"hAYDO"}],"583G9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("152cf0fffe5db4dc"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, _exponent.default)(max) - (0, _exponent.default)(step)) + 1;
}

},{"152cf0fffe5db4dc":"hAYDO"}],"bxOFO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = log;
exports.loggish = loggish;
var _index = require("c2225ae6830156cb");
var _index2 = require("9fe16242a20f801");
var _nice = _interopRequireDefault(require("e1f7cd4bad5fecf5"));
var _continuous = require("cdd2320c22aee987");
var _init = require("54c81c620622cc22");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _index.ticks)(u, v, n);
        } else z = (0, _index.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _index2.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _index2.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuous.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuous.copy)(scale, log()).base(scale.base());
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"c2225ae6830156cb":"a3yRD","9fe16242a20f801":"ZTcXI","e1f7cd4bad5fecf5":"iMxY8","cdd2320c22aee987":"2mXaL","54c81c620622cc22":"dqCPN"}],"iMxY8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{}],"iqOUB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = symlog;
exports.symlogish = symlogish;
var _linear = require("6b7bc111d415c072");
var _continuous = require("f781e5664611d9c0");
var _init = require("499d293100f0413a");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linear.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, symlog()).constant(scale.constant());
    };
    return _init.initRange.apply(scale, arguments);
}

},{"6b7bc111d415c072":"dQTNh","f781e5664611d9c0":"2mXaL","499d293100f0413a":"dqCPN"}],"c5QfX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pow;
exports.powish = powish;
exports.sqrt = sqrt;
var _linear = require("94b90569504e034e");
var _continuous = require("6297cca891d63c37");
var _init = require("1b7874ad495edb4c");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform(_continuous.identity, _continuous.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform(_continuous.identity, _continuous.identity) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linear.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, pow()).exponent(scale.exponent());
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"94b90569504e034e":"dQTNh","6297cca891d63c37":"2mXaL","1b7874ad495edb4c":"dqCPN"}],"bcmi0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = radial;
var _continuous = _interopRequireDefault(require("9cc3a5098e156c85"));
var _init = require("116f55aac82ec8e9");
var _linear = require("b2719a0a78ca2805");
var _number = _interopRequireDefault(require("aa73717e632c4a05"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, _number.default)).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return (0, _linear.linearish)(scale);
}

},{"9cc3a5098e156c85":"2mXaL","116f55aac82ec8e9":"dqCPN","b2719a0a78ca2805":"dQTNh","aa73717e632c4a05":"6x3es"}],"9J4WR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
var _index = require("1587656407247c17");
var _init = require("e93efb9761f1f003");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _index.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _index.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort(_index.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"1587656407247c17":"a3yRD","e93efb9761f1f003":"dqCPN"}],"2eOP8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantize;
var _index = require("61f3ae9aeeace72a");
var _linear = require("19f450ffb9fe0ee8");
var _init = require("97a4ee1bb0f33f6b");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return _init.initRange.apply((0, _linear.linearish)(scale), arguments);
}

},{"61f3ae9aeeace72a":"a3yRD","19f450ffb9fe0ee8":"dQTNh","97a4ee1bb0f33f6b":"dqCPN"}],"cGBCy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = threshold;
var _index = require("4b6954aba910b52b");
var _init = require("5769040792c8fbdc");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"4b6954aba910b52b":"a3yRD","5769040792c8fbdc":"dqCPN"}],"9WDTW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calendar = calendar;
exports.default = time;
var _index = require("d6f26b6733e27d9f");
var _index2 = require("2c6c21fb5fc82ed8");
var _continuous = _interopRequireWildcard(require("33f8922a5dd4a530"));
var _init = require("2234a07f2ca64e26");
var _nice = _interopRequireDefault(require("c7d75e934f92c19f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return _init.initRange.apply(calendar(_index.timeTicks, _index.timeTickInterval, _index.timeYear, _index.timeMonth, _index.timeWeek, _index.timeDay, _index.timeHour, _index.timeMinute, _index.timeSecond, _index2.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d6f26b6733e27d9f":"cF2zn","2c6c21fb5fc82ed8":"d2Ivb","33f8922a5dd4a530":"2mXaL","2234a07f2ca64e26":"dqCPN","c7d75e934f92c19f":"iMxY8"}],"cF2zn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "timeDay", {
    enumerable: true,
    get: function() {
        return _day.default;
    }
});
Object.defineProperty(exports, "timeDays", {
    enumerable: true,
    get: function() {
        return _day.days;
    }
});
Object.defineProperty(exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return _week.friday;
    }
});
Object.defineProperty(exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return _week.fridays;
    }
});
Object.defineProperty(exports, "timeHour", {
    enumerable: true,
    get: function() {
        return _hour.default;
    }
});
Object.defineProperty(exports, "timeHours", {
    enumerable: true,
    get: function() {
        return _hour.hours;
    }
});
Object.defineProperty(exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return _interval.default;
    }
});
Object.defineProperty(exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return _minute.default;
    }
});
Object.defineProperty(exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return _minute.minutes;
    }
});
Object.defineProperty(exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return _week.monday;
    }
});
Object.defineProperty(exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return _week.mondays;
    }
});
Object.defineProperty(exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return _month.default;
    }
});
Object.defineProperty(exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return _month.months;
    }
});
Object.defineProperty(exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return _week.saturday;
    }
});
Object.defineProperty(exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return _week.saturdays;
    }
});
Object.defineProperty(exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return _second.default;
    }
});
Object.defineProperty(exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return _week.thursday;
    }
});
Object.defineProperty(exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return _week.thursdays;
    }
});
Object.defineProperty(exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return _ticks.timeTickInterval;
    }
});
Object.defineProperty(exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return _ticks.timeTicks;
    }
});
Object.defineProperty(exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return _week.tuesday;
    }
});
Object.defineProperty(exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return _week.tuesdays;
    }
});
Object.defineProperty(exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return _week.wednesday;
    }
});
Object.defineProperty(exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return _week.wednesdays;
    }
});
Object.defineProperty(exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeYear", {
    enumerable: true,
    get: function() {
        return _year.default;
    }
});
Object.defineProperty(exports, "timeYears", {
    enumerable: true,
    get: function() {
        return _year.years;
    }
});
Object.defineProperty(exports, "utcDay", {
    enumerable: true,
    get: function() {
        return _utcDay.default;
    }
});
Object.defineProperty(exports, "utcDays", {
    enumerable: true,
    get: function() {
        return _utcDay.utcDays;
    }
});
Object.defineProperty(exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcFriday;
    }
});
Object.defineProperty(exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcFridays;
    }
});
Object.defineProperty(exports, "utcHour", {
    enumerable: true,
    get: function() {
        return _utcHour.default;
    }
});
Object.defineProperty(exports, "utcHours", {
    enumerable: true,
    get: function() {
        return _utcHour.utcHours;
    }
});
Object.defineProperty(exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return _utcMinute.default;
    }
});
Object.defineProperty(exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return _utcMinute.utcMinutes;
    }
});
Object.defineProperty(exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcMonday;
    }
});
Object.defineProperty(exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcMondays;
    }
});
Object.defineProperty(exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return _utcMonth.default;
    }
});
Object.defineProperty(exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return _utcMonth.utcMonths;
    }
});
Object.defineProperty(exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSaturday;
    }
});
Object.defineProperty(exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSaturdays;
    }
});
Object.defineProperty(exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return _second.default;
    }
});
Object.defineProperty(exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcThursday;
    }
});
Object.defineProperty(exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcThursdays;
    }
});
Object.defineProperty(exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return _ticks.utcTickInterval;
    }
});
Object.defineProperty(exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return _ticks.utcTicks;
    }
});
Object.defineProperty(exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcTuesday;
    }
});
Object.defineProperty(exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcTuesdays;
    }
});
Object.defineProperty(exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcWednesday;
    }
});
Object.defineProperty(exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcWednesdays;
    }
});
Object.defineProperty(exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcYear", {
    enumerable: true,
    get: function() {
        return _utcYear.default;
    }
});
Object.defineProperty(exports, "utcYears", {
    enumerable: true,
    get: function() {
        return _utcYear.utcYears;
    }
});
var _interval = _interopRequireDefault(require("792c68a3f8a1926"));
var _millisecond = _interopRequireWildcard(require("2357def356bae18"));
var _second = _interopRequireWildcard(require("1c57489bc0aa2095"));
var _minute = _interopRequireWildcard(require("29ed17b274422d68"));
var _hour = _interopRequireWildcard(require("24ed79de6f4f26d"));
var _day = _interopRequireWildcard(require("82753f475a698669"));
var _week = require("a7e60f089113fd37");
var _month = _interopRequireWildcard(require("340ea3bf33812c65"));
var _year = _interopRequireWildcard(require("e014d3654a0b00fb"));
var _utcMinute = _interopRequireWildcard(require("5ff1ef18d2410f37"));
var _utcHour = _interopRequireWildcard(require("2822e085c5125d78"));
var _utcDay = _interopRequireWildcard(require("ff909be541c31c33"));
var _utcWeek = require("70b57967fcafbaa5");
var _utcMonth = _interopRequireWildcard(require("e41feff472794f13"));
var _utcYear = _interopRequireWildcard(require("9b0775a896f4b4dc"));
var _ticks = require("af413f597619bd05");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"792c68a3f8a1926":"aBZCg","2357def356bae18":"bwSyx","1c57489bc0aa2095":"73e1W","29ed17b274422d68":"cKlNh","24ed79de6f4f26d":"9vXRo","82753f475a698669":"7ybFa","a7e60f089113fd37":"kglIM","340ea3bf33812c65":"iZMTg","e014d3654a0b00fb":"23bKz","5ff1ef18d2410f37":"hfwGc","2822e085c5125d78":"2cxR9","ff909be541c31c33":"hQXt4","70b57967fcafbaa5":"fm7FV","e41feff472794f13":"1PCRT","9b0775a896f4b4dc":"lJwRL","af413f597619bd05":"5phBc"}],"aBZCg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = newInterval;
var t0 = new Date(), t1 = new Date();
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{}],"bwSyx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.milliseconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("47fef281020880de"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var millisecond = (0, _interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var _default = millisecond;
exports.default = _default;
var milliseconds = millisecond.range;
exports.milliseconds = milliseconds;

},{"47fef281020880de":"aBZCg"}],"73e1W":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.seconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("b059f221ba83fd2b"));
var _duration = require("4b017018381ce3ad");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var second = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * _duration.durationSecond);
}, function(start, end) {
    return (end - start) / _duration.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var _default = second;
exports.default = _default;
var seconds = second.range;
exports.seconds = seconds;

},{"b059f221ba83fd2b":"aBZCg","4b017018381ce3ad":"d023D"}],"d023D":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.durationYear = exports.durationWeek = exports.durationSecond = exports.durationMonth = exports.durationMinute = exports.durationHour = exports.durationDay = void 0;
const durationSecond = 1000;
exports.durationSecond = durationSecond;
const durationMinute = durationSecond * 60;
exports.durationMinute = durationMinute;
const durationHour = durationMinute * 60;
exports.durationHour = durationHour;
const durationDay = durationHour * 24;
exports.durationDay = durationDay;
const durationWeek = durationDay * 7;
exports.durationWeek = durationWeek;
const durationMonth = durationDay * 30;
exports.durationMonth = durationMonth;
const durationYear = durationDay * 365;
exports.durationYear = durationYear;

},{}],"cKlNh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.minutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("5b81b309635f37c2"));
var _duration = require("52c486da961f0d2c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var minute = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var _default = minute;
exports.default = _default;
var minutes = minute.range;
exports.minutes = minutes;

},{"5b81b309635f37c2":"aBZCg","52c486da961f0d2c":"d023D"}],"9vXRo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hours = exports.default = void 0;
var _interval = _interopRequireDefault(require("d36c991e94b8c5d6"));
var _duration = require("b17b3dbdbc5c799e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var hour = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond - date.getMinutes() * _duration.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getHours();
});
var _default = hour;
exports.default = _default;
var hours = hour.range;
exports.hours = hours;

},{"d36c991e94b8c5d6":"aBZCg","b17b3dbdbc5c799e":"d023D"}],"7ybFa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.days = void 0;
var _interval = _interopRequireDefault(require("c559f97c050225d3"));
var _duration = require("93d679bd1def1b3c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var day = (0, _interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationDay, (date)=>date.getDate() - 1);
var _default = day;
exports.default = _default;
var days = day.range;
exports.days = days;

},{"c559f97c050225d3":"aBZCg","93d679bd1def1b3c":"d023D"}],"kglIM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wednesdays = exports.wednesday = exports.tuesdays = exports.tuesday = exports.thursdays = exports.thursday = exports.sundays = exports.sunday = exports.saturdays = exports.saturday = exports.mondays = exports.monday = exports.fridays = exports.friday = void 0;
var _interval = _interopRequireDefault(require("fb608840fab065f0"));
var _duration = require("136ded3f760de188");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function weekday(i) {
    return (0, _interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationWeek;
    });
}
var sunday = weekday(0);
exports.sunday = sunday;
var monday = weekday(1);
exports.monday = monday;
var tuesday = weekday(2);
exports.tuesday = tuesday;
var wednesday = weekday(3);
exports.wednesday = wednesday;
var thursday = weekday(4);
exports.thursday = thursday;
var friday = weekday(5);
exports.friday = friday;
var saturday = weekday(6);
exports.saturday = saturday;
var sundays = sunday.range;
exports.sundays = sundays;
var mondays = monday.range;
exports.mondays = mondays;
var tuesdays = tuesday.range;
exports.tuesdays = tuesdays;
var wednesdays = wednesday.range;
exports.wednesdays = wednesdays;
var thursdays = thursday.range;
exports.thursdays = thursdays;
var fridays = friday.range;
exports.fridays = fridays;
var saturdays = saturday.range;
exports.saturdays = saturdays;

},{"fb608840fab065f0":"aBZCg","136ded3f760de188":"d023D"}],"iZMTg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.months = exports.default = void 0;
var _interval = _interopRequireDefault(require("7e198ba28f0e25de"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var month = (0, _interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var _default = month;
exports.default = _default;
var months = month.range;
exports.months = months;

},{"7e198ba28f0e25de":"aBZCg"}],"23bKz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.years = exports.default = void 0;
var _interval = _interopRequireDefault(require("699a5bdfd0c77e2e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var year = (0, _interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var _default = year;
exports.default = _default;
var years = year.range;
exports.years = years;

},{"699a5bdfd0c77e2e":"aBZCg"}],"hfwGc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMinutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("64b6a8f5c9bd1c96"));
var _duration = require("32c01369d4e699fb");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMinute = (0, _interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var _default = utcMinute;
exports.default = _default;
var utcMinutes = utcMinute.range;
exports.utcMinutes = utcMinutes;

},{"64b6a8f5c9bd1c96":"aBZCg","32c01369d4e699fb":"d023D"}],"2cxR9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcHours = exports.default = void 0;
var _interval = _interopRequireDefault(require("8c74396d670977a"));
var _duration = require("6c82203e6970a1bc");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcHour = (0, _interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var _default = utcHour;
exports.default = _default;
var utcHours = utcHour.range;
exports.utcHours = utcHours;

},{"8c74396d670977a":"aBZCg","6c82203e6970a1bc":"d023D"}],"hQXt4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcDays = exports.default = void 0;
var _interval = _interopRequireDefault(require("1f97a562b3e12493"));
var _duration = require("4c0ac820095fab8f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcDay = (0, _interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / _duration.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var _default = utcDay;
exports.default = _default;
var utcDays = utcDay.range;
exports.utcDays = utcDays;

},{"1f97a562b3e12493":"aBZCg","4c0ac820095fab8f":"d023D"}],"fm7FV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcWednesdays = exports.utcWednesday = exports.utcTuesdays = exports.utcTuesday = exports.utcThursdays = exports.utcThursday = exports.utcSundays = exports.utcSunday = exports.utcSaturdays = exports.utcSaturday = exports.utcMondays = exports.utcMonday = exports.utcFridays = exports.utcFriday = void 0;
var _interval = _interopRequireDefault(require("e95c6c72a9a72603"));
var _duration = require("b3779dea703b5e01");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function utcWeekday(i) {
    return (0, _interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / _duration.durationWeek;
    });
}
var utcSunday = utcWeekday(0);
exports.utcSunday = utcSunday;
var utcMonday = utcWeekday(1);
exports.utcMonday = utcMonday;
var utcTuesday = utcWeekday(2);
exports.utcTuesday = utcTuesday;
var utcWednesday = utcWeekday(3);
exports.utcWednesday = utcWednesday;
var utcThursday = utcWeekday(4);
exports.utcThursday = utcThursday;
var utcFriday = utcWeekday(5);
exports.utcFriday = utcFriday;
var utcSaturday = utcWeekday(6);
exports.utcSaturday = utcSaturday;
var utcSundays = utcSunday.range;
exports.utcSundays = utcSundays;
var utcMondays = utcMonday.range;
exports.utcMondays = utcMondays;
var utcTuesdays = utcTuesday.range;
exports.utcTuesdays = utcTuesdays;
var utcWednesdays = utcWednesday.range;
exports.utcWednesdays = utcWednesdays;
var utcThursdays = utcThursday.range;
exports.utcThursdays = utcThursdays;
var utcFridays = utcFriday.range;
exports.utcFridays = utcFridays;
var utcSaturdays = utcSaturday.range;
exports.utcSaturdays = utcSaturdays;

},{"e95c6c72a9a72603":"aBZCg","b3779dea703b5e01":"d023D"}],"1PCRT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMonths = exports.default = void 0;
var _interval = _interopRequireDefault(require("9fc54a6c7da64a87"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMonth = (0, _interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var _default = utcMonth;
exports.default = _default;
var utcMonths = utcMonth.range;
exports.utcMonths = utcMonths;

},{"9fc54a6c7da64a87":"aBZCg"}],"lJwRL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcYears = exports.default = void 0;
var _interval = _interopRequireDefault(require("8be30e72f54134d4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcYear = (0, _interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var _default = utcYear;
exports.default = _default;
var utcYears = utcYear.range;
exports.utcYears = utcYears;

},{"8be30e72f54134d4":"aBZCg"}],"5phBc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcTicks = exports.utcTickInterval = exports.timeTicks = exports.timeTickInterval = void 0;
var _index = require("d7f21fd662cddf99");
var _duration = require("aa18ef34c0be11bc");
var _millisecond = _interopRequireDefault(require("dac51414a1e8276b"));
var _second = _interopRequireDefault(require("d68afea8416c3f1a"));
var _minute = _interopRequireDefault(require("404a139d621a9db2"));
var _hour = _interopRequireDefault(require("9a0bf4314f401b0c"));
var _day = _interopRequireDefault(require("3f04924c68533af9"));
var _week = require("b2b29cfa1ce6c7da");
var _month = _interopRequireDefault(require("5ceb61e7c9c807ec"));
var _year = _interopRequireDefault(require("dd0ef245ed62fdbf"));
var _utcMinute = _interopRequireDefault(require("1e46f3d232f79e5e"));
var _utcHour = _interopRequireDefault(require("3d1ae5dfacd220b4"));
var _utcDay = _interopRequireDefault(require("5fb1b56afb7033e1"));
var _utcWeek = require("536323b8c7eb14e3");
var _utcMonth = _interopRequireDefault(require("856c2c54a9da13b6"));
var _utcYear = _interopRequireDefault(require("f5ebb8abb03b9dec"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            _second.default,
            1,
            _duration.durationSecond
        ],
        [
            _second.default,
            5,
            5 * _duration.durationSecond
        ],
        [
            _second.default,
            15,
            15 * _duration.durationSecond
        ],
        [
            _second.default,
            30,
            30 * _duration.durationSecond
        ],
        [
            minute,
            1,
            _duration.durationMinute
        ],
        [
            minute,
            5,
            5 * _duration.durationMinute
        ],
        [
            minute,
            15,
            15 * _duration.durationMinute
        ],
        [
            minute,
            30,
            30 * _duration.durationMinute
        ],
        [
            hour,
            1,
            _duration.durationHour
        ],
        [
            hour,
            3,
            3 * _duration.durationHour
        ],
        [
            hour,
            6,
            6 * _duration.durationHour
        ],
        [
            hour,
            12,
            12 * _duration.durationHour
        ],
        [
            day,
            1,
            _duration.durationDay
        ],
        [
            day,
            2,
            2 * _duration.durationDay
        ],
        [
            week,
            1,
            _duration.durationWeek
        ],
        [
            month,
            1,
            _duration.durationMonth
        ],
        [
            month,
            3,
            3 * _duration.durationMonth
        ],
        [
            year,
            1,
            _duration.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _index.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _index.tickStep)(start / _duration.durationYear, stop / _duration.durationYear, count));
        if (i === 0) return _millisecond.default.every(Math.max((0, _index.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker(_utcYear.default, _utcMonth.default, _utcWeek.utcSunday, _utcDay.default, _utcHour.default, _utcMinute.default);
exports.utcTickInterval = utcTickInterval;
exports.utcTicks = utcTicks;
const [timeTicks, timeTickInterval] = ticker(_year.default, _month.default, _week.sunday, _day.default, _hour.default, _minute.default);
exports.timeTickInterval = timeTickInterval;
exports.timeTicks = timeTicks;

},{"d7f21fd662cddf99":"a3yRD","aa18ef34c0be11bc":"d023D","dac51414a1e8276b":"bwSyx","d68afea8416c3f1a":"73e1W","404a139d621a9db2":"cKlNh","9a0bf4314f401b0c":"9vXRo","3f04924c68533af9":"7ybFa","b2b29cfa1ce6c7da":"kglIM","5ceb61e7c9c807ec":"iZMTg","dd0ef245ed62fdbf":"23bKz","1e46f3d232f79e5e":"hfwGc","3d1ae5dfacd220b4":"2cxR9","5fb1b56afb7033e1":"hQXt4","536323b8c7eb14e3":"fm7FV","856c2c54a9da13b6":"1PCRT","f5ebb8abb03b9dec":"lJwRL"}],"d2Ivb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return _isoFormat.default;
    }
});
Object.defineProperty(exports, "isoParse", {
    enumerable: true,
    get: function() {
        return _isoParse.default;
    }
});
Object.defineProperty(exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return _defaultLocale.timeFormat;
    }
});
Object.defineProperty(exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "timeParse", {
    enumerable: true,
    get: function() {
        return _defaultLocale.timeParse;
    }
});
Object.defineProperty(exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return _defaultLocale.utcFormat;
    }
});
Object.defineProperty(exports, "utcParse", {
    enumerable: true,
    get: function() {
        return _defaultLocale.utcParse;
    }
});
var _defaultLocale = _interopRequireWildcard(require("e254c805352cbe79"));
var _locale = _interopRequireDefault(require("a2049a4646cad099"));
var _isoFormat = _interopRequireDefault(require("8485f996f4dff29b"));
var _isoParse = _interopRequireDefault(require("e2c3ab8c9c293ff5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"e254c805352cbe79":"c1KOU","a2049a4646cad099":"7Rkaw","8485f996f4dff29b":"70GsT","e2c3ab8c9c293ff5":"2pX7D"}],"c1KOU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.utcParse = exports.utcFormat = exports.timeParse = exports.timeFormat = void 0;
var _locale = _interopRequireDefault(require("8c8d5f4601afc09e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var timeFormat;
exports.timeFormat = timeFormat;
var timeParse;
exports.timeParse = timeParse;
var utcFormat;
exports.utcFormat = utcFormat;
var utcParse;
exports.utcParse = utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.timeFormat = timeFormat = locale.format;
    exports.timeParse = timeParse = locale.parse;
    exports.utcFormat = utcFormat = locale.utcFormat;
    exports.utcParse = utcParse = locale.utcParse;
    return locale;
}

},{"8c8d5f4601afc09e":"7Rkaw"}],"7Rkaw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatLocale;
var _index = require("da76bc1e0eef4658");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? _index.utcMonday.ceil(week) : (0, _index.utcMonday)(week);
                    week = _index.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? _index.timeMonday.ceil(week) : (0, _index.timeMonday)(week);
                    week = _index.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            } // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, // note: ignores next directive
percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + _index.timeDay.count((0, _index.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad(_index.timeSunday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad(_index.timeThursday.count((0, _index.timeYear)(d), d) + ((0, _index.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad(_index.timeMonday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + _index.utcDay.count((0, _index.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad(_index.utcSunday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad(_index.utcThursday.count((0, _index.utcYear)(d), d) + ((0, _index.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad(_index.utcMonday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"da76bc1e0eef4658":"cF2zn"}],"70GsT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isoSpecifier = exports.default = void 0;
var _defaultLocale = require("2f8f6a7c55a265a7");
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
exports.isoSpecifier = isoSpecifier;
function formatIsoNative(date) {
    return date.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocale.utcFormat)(isoSpecifier);
var _default = formatIso;
exports.default = _default;

},{"2f8f6a7c55a265a7":"c1KOU"}],"2pX7D":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isoFormat = require("c9c0e033b3f4cd7a");
var _defaultLocale = require("717272dfdfdf9f58");
function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocale.utcParse)(_isoFormat.isoSpecifier);
var _default = parseIso;
exports.default = _default;

},{"c9c0e033b3f4cd7a":"70GsT","717272dfdfdf9f58":"c1KOU"}],"7usYt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = utcTime;
var _index = require("ea22621463423769");
var _index2 = require("df08fa54879bdddf");
var _time = require("3d474b4ac409608e");
var _init = require("f5277d460a04562a");
function utcTime() {
    return _init.initRange.apply((0, _time.calendar)(_index.utcTicks, _index.utcTickInterval, _index.utcYear, _index.utcMonth, _index.utcWeek, _index.utcDay, _index.utcHour, _index.utcMinute, _index.utcSecond, _index2.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"ea22621463423769":"cF2zn","df08fa54879bdddf":"d2Ivb","3d474b4ac409608e":"9WDTW","f5277d460a04562a":"dqCPN"}],"aDiix":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = sequential;
exports.sequentialLog = sequentialLog;
exports.sequentialPow = sequentialPow;
exports.sequentialSqrt = sequentialSqrt;
exports.sequentialSymlog = sequentialSymlog;
var _index = require("576a63ed61017ad0");
var _continuous = require("367c19cf7640115e");
var _init = require("4d9ecd8e312987f2");
var _linear = require("7aa8dc079711aa38");
var _log = require("9675a35c284dba6f");
var _symlog = require("e5e6e98809c25bc3");
var _pow = require("814ae7ed84550652");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = _continuous.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"576a63ed61017ad0":"jNtfI","367c19cf7640115e":"2mXaL","4d9ecd8e312987f2":"dqCPN","7aa8dc079711aa38":"dQTNh","9675a35c284dba6f":"bxOFO","e5e6e98809c25bc3":"iqOUB","814ae7ed84550652":"c5QfX"}],"1OSpW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sequentialQuantile;
var _index = require("eed0055976263d50");
var _continuous = require("21618a239c62366b");
var _init = require("92ad1cf8524c146");
function sequentialQuantile() {
    var domain = [], interpolator = _continuous.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _index.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort(_index.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, _index.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return _init.initInterpolator.apply(scale, arguments);
}

},{"eed0055976263d50":"a3yRD","21618a239c62366b":"2mXaL","92ad1cf8524c146":"dqCPN"}],"ftvdw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = diverging;
exports.divergingLog = divergingLog;
exports.divergingPow = divergingPow;
exports.divergingSqrt = divergingSqrt;
exports.divergingSymlog = divergingSymlog;
var _index = require("915e51d9b913a910");
var _continuous = require("bf6a55aee26f6305");
var _init = require("dafbeaec64c427e8");
var _linear = require("367c88af554f4c81");
var _log = require("f1b41897387bed31");
var _sequential = require("478631d13f9292c0");
var _symlog = require("f1514783e2b3953d");
var _pow = require("2cbbbabc7f04bb29");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = _continuous.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _index.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return (0, _sequential.copy)(scale, diverging());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"915e51d9b913a910":"jNtfI","bf6a55aee26f6305":"2mXaL","dafbeaec64c427e8":"dqCPN","367c88af554f4c81":"dQTNh","f1b41897387bed31":"bxOFO","478631d13f9292c0":"aDiix","f1514783e2b3953d":"iqOUB","2cbbbabc7f04bb29":"c5QfX"}],"5g5H3":[function(require,module,exports,__globalThis) {
var baseExtremum = require("c7d87741ab4129b0"), baseGt = require("dbeef59341d150f4"), identity = require("3c95c3c9fbe3850f");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function max(array) {
    return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
}
module.exports = max;

},{"c7d87741ab4129b0":"3QycA","dbeef59341d150f4":"2yQH4","3c95c3c9fbe3850f":"2HXBf"}],"2yQH4":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function baseGt(value, other) {
    return value > other;
}
module.exports = baseGt;

},{}],"aJDkJ":[function(require,module,exports,__globalThis) {
var baseFlatten = require("727a074274bef45"), map = require("19e2d816e1d885f8");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function flatMap(collection, iteratee) {
    return baseFlatten(map(collection, iteratee), 1);
}
module.exports = flatMap;

},{"727a074274bef45":"iu9J0","19e2d816e1d885f8":"lEbGY"}],"lEbGY":[function(require,module,exports,__globalThis) {
var arrayMap = require("61518c8bb036dd9b"), baseIteratee = require("8bad46685c8864d"), baseMap = require("51c76ab24fdb66f9"), isArray = require("7cb4cacc4dea406c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"61518c8bb036dd9b":"chzeu","8bad46685c8864d":"6jZAq","51c76ab24fdb66f9":"8JEHD","7cb4cacc4dea406c":"1DVeR"}],"ldtNH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTickValues", ()=>(0, _getNiceTickValues.getTickValues));
parcelHelpers.export(exports, "getNiceTickValues", ()=>(0, _getNiceTickValues.getNiceTickValues));
parcelHelpers.export(exports, "getTickValuesFixedDomain", ()=>(0, _getNiceTickValues.getTickValuesFixedDomain));
var _getNiceTickValues = require("./getNiceTickValues");

},{"./getNiceTickValues":"3Tomb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Tomb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNiceTickValues", ()=>getNiceTickValues);
parcelHelpers.export(exports, "getTickValues", ()=>getTickValues);
parcelHelpers.export(exports, "getTickValuesFixedDomain", ()=>getTickValuesFixedDomain);
/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */ var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
var _utils = require("./util/utils");
var _arithmetic = require("./util/arithmetic");
var _arithmeticDefault = parcelHelpers.interopDefault(_arithmetic);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function getValidInterval(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, _decimalJsLightDefault.default)(0);
    var digitCount = (0, _arithmeticDefault.default).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, _decimalJsLightDefault.default)(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, _decimalJsLightDefault.default)(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, _decimalJsLightDefault.default)(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, _decimalJsLightDefault.default)(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, _decimalJsLightDefault.default)(10).pow((0, _arithmeticDefault.default).getDigitCount(value) - 1);
            middle = new (0, _decimalJsLightDefault.default)(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    } else if (value === 0) middle = new (0, _decimalJsLightDefault.default)(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, _utils.compose)((0, _utils.map)(function(n) {
        return middle.add(new (0, _decimalJsLightDefault.default)(n - middleIndex).mul(step)).toNumber();
    }), (0, _utils.range));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, _decimalJsLightDefault.default)(0),
        tickMin: new (0, _decimalJsLightDefault.default)(0),
        tickMax: new (0, _decimalJsLightDefault.default)(0)
    };
     // The step which is easy to understand between two ticks
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, _decimalJsLightDefault.default)(0);
    else {
        // calculate the middle value
        middle = new (0, _decimalJsLightDefault.default)(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, _decimalJsLightDefault.default)(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, _decimalJsLightDefault.default)(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, _decimalJsLightDefault.default)(belowCount).mul(step)),
        tickMax: middle.add(new (0, _decimalJsLightDefault.default)(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getNiceTickValuesFn(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = getValidInterval([
        min,
        max
    ]), _getValidInterval2 = _slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, _utils.reverse)(_values) : _values;
    }
    if (cormin === cormax) return getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, _arithmeticDefault.default).rangeStep(tickMin, tickMax.add(new (0, _decimalJsLightDefault.default)(0.1).mul(step)), step);
    return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getTickValuesFn(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = getValidInterval([
        min,
        max
    ]), _getValidInterval4 = _slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, _utils.compose)((0, _utils.map)(function(n) {
        return new (0, _decimalJsLightDefault.default)(cormin).add(new (0, _decimalJsLightDefault.default)(n).mul(step)).toNumber();
    }), (0, _utils.range));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = _slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = getValidInterval([
        min,
        max
    ]), _getValidInterval6 = _slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat(_toConsumableArray((0, _arithmeticDefault.default).rangeStep(new (0, _decimalJsLightDefault.default)(cormin), new (0, _decimalJsLightDefault.default)(cormax).sub(new (0, _decimalJsLightDefault.default)(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, _utils.reverse)(values) : values;
}
var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
var getTickValues = (0, _utils.memoize)(getTickValuesFn);
var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

},{"decimal.js-light":"j0Zj0","./util/utils":"91uiX","./util/arithmetic":"l4mPl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j0Zj0":[function(require,module,exports,__globalThis) {
(function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, module.exports) module.exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})(this);

},{}],"91uiX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLACE_HOLDER", ()=>PLACE_HOLDER);
parcelHelpers.export(exports, "curry", ()=>curry);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "memoize", ()=>memoize);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var identity = function identity(i) {
    return i;
};
var PLACE_HOLDER = {
    '@@functional/placeholder': true
};
var isPlaceHolder = function isPlaceHolder(val) {
    return val === PLACE_HOLDER;
};
var curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== PLACE_HOLDER;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var curry = function curry(fn) {
    return curryN(fn.length, fn);
};
var range = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var map = curry(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var compose = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var reverse = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var memoize = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4mPl":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
var _utils = require("./utils");
/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, _decimalJsLightDefault.default)(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function rangeStep(start, end, step) {
    var num = new (0, _decimalJsLightDefault.default)(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var interpolateNumber = (0, _utils.curry)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var uninterpolateNumber = (0, _utils.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var uninterpolateTruncation = (0, _utils.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
exports.default = {
    rangeStep: rangeStep,
    getDigitCount: getDigitCount,
    interpolateNumber: interpolateNumber,
    uninterpolateNumber: uninterpolateNumber,
    uninterpolateTruncation: uninterpolateTruncation
};

},{"decimal.js-light":"j0Zj0","./utils":"91uiX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ePUt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBar", ()=>ErrorBar);
/**
 * @fileOverview Render a group of error bar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ErrorBar(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = _objectWithoutProperties(props, _excluded);
    var svgProps = (0, _reactUtils.filterProps)(others);
    var errorBars = data.map(function(entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = _slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === 'vertical') {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === 'horizontal') {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
            className: "recharts-errorBar",
            key: "bar-".concat(i)
        }, svgProps), lineCoordinates.map(function(coordinates, index) {
            return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
            (0, _reactDefault.default).createElement("line", _extends({}, coordinates, {
                key: "line-".concat(index)
            })));
        })));
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: "recharts-errorBars"
    }, errorBars);
}
ErrorBar.defaultProps = {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
};
ErrorBar.displayName = 'ErrorBar';

},{"react":"9njXz","../container/Layer":"4Q0HG","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRqnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLegendProps", ()=>getLegendProps);
var _legend = require("../component/Legend");
var _chartUtils = require("./ChartUtils");
var _reactUtils = require("./ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var getLegendProps = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, _reactUtils.findChildByType)(children, (0, _legend.Legend));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var _item$props = item.props, dataKey = _item$props.dataKey, name = _item$props.name, legendType = _item$props.legendType, hide = _item$props.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || 'square',
            color: (0, _chartUtils.getMainColorOfGraphicItem)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: item.props
        };
    });
    return _objectSpread(_objectSpread(_objectSpread({}, legendItem.props), (0, _legend.Legend).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};

},{"../component/Legend":"dkfOy","./ChartUtils":"24GXn","./ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bRsHp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LabelList", ()=>LabelList);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _label = require("./Label");
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _chartUtils = require("../util/ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "valueAccessor"
], _excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, _lastDefault.default)(entry.value) : entry.value;
};
function LabelList(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? defaultAccessor : _ref$valueAccessor, restProps = _objectWithoutProperties(_ref, _excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = _objectWithoutProperties(restProps, _excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, _isNilDefault.default)(dataKey) ? valueAccessor(entry, index) : (0, _chartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
        var idProps = (0, _isNilDefault.default)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), _extends({}, (0, _reactUtils.filterProps)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, _label.Label).parseViewBox((0, _isNilDefault.default)(clockWise) ? entry : _objectSpread(_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
LabelList.displayName = 'LabelList';
function parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(label) || (0, _isFunctionDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, _isObjectDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, _extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, _reactUtils.findAllByType)(children, LabelList).map(function(child, index) {
        return /*#__PURE__*/ (0, _react.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat(_toConsumableArray(explicitChildren));
}
LabelList.renderCallByParent = renderCallByParent;

},{"react":"9njXz","lodash/isNil":"eS6AM","lodash/isObject":"6hgJK","lodash/isFunction":"3A7xI","lodash/last":"glvbo","./Label":"2uQzv","../container/Layer":"4Q0HG","../util/ReactUtils":"lj4u0","../util/ChartUtils":"24GXn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bmvhw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sector", ()=>Sector);
/**
 * @fileOverview Sector
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _polarUtils = require("../util/PolarUtils");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, _polarUtils.RADIAN);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, _polarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * (0, _polarUtils.RADIAN)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var _getTangentCircle = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var Sector = function Sector(sectorProps) {
    var props = _objectSpread(_objectSpread({}, defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, _dataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};

},{"react":"9njXz","clsx":"d2NWs","../util/ReactUtils":"lj4u0","../util/PolarUtils":"eBFiJ","../util/DataUtils":"5VTG4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hqiOr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Curve", ()=>Curve);
/**
 * @fileOverview Curve
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _d3Shape = require("victory-vendor/d3-shape");
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var CURVE_FACTORIES = {
    curveBasisClosed: (0, _d3Shape.curveBasisClosed),
    curveBasisOpen: (0, _d3Shape.curveBasisOpen),
    curveBasis: (0, _d3Shape.curveBasis),
    curveBumpX: (0, _d3Shape.curveBumpX),
    curveBumpY: (0, _d3Shape.curveBumpY),
    curveLinearClosed: (0, _d3Shape.curveLinearClosed),
    curveLinear: (0, _d3Shape.curveLinear),
    curveMonotoneX: (0, _d3Shape.curveMonotoneX),
    curveMonotoneY: (0, _d3Shape.curveMonotoneY),
    curveNatural: (0, _d3Shape.curveNatural),
    curveStep: (0, _d3Shape.curveStep),
    curveStepAfter: (0, _d3Shape.curveStepAfter),
    curveStepBefore: (0, _d3Shape.curveStepBefore)
};
var defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var getX = function getX(p) {
    return p.x;
};
var getY = function getY(p) {
    return p.y;
};
var getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, _isFunctionDefault.default)(type)) return type;
    var name = "curve".concat((0, _upperFirstDefault.default)(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return CURVE_FACTORIES[name] || (0, _d3Shape.curveLinear);
};
/**
 * Calculate the path of curve
 * @return {String} path
 */ var getPath = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return _objectSpread(_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined(defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
    else if ((0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
    else lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
    lineFunction.defined(defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var Curve = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? getPath(props) : path;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props), (0, _types.adaptEventHandlers)(props), {
        className: (0, _clsxDefault.default)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};

},{"react":"9njXz","victory-vendor/d3-shape":"fFCVX","lodash/upperFirst":"eSJZa","lodash/isFunction":"3A7xI","clsx":"d2NWs","../util/types":"c9QyM","../util/ReactUtils":"lj4u0","../util/DataUtils":"5VTG4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"icCgC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInRectangle", ()=>isInRectangle);
parcelHelpers.export(exports, "Rectangle", ()=>Rectangle);
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var isInRectangle = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var Rectangle = function Rectangle(rectangleProps) {
    var props = _objectSpread(_objectSpread({}, defaultProps), rectangleProps);
    var pathRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)(-1), _useState2 = _slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, _react.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: layerClass,
        d: getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
            className: layerClass,
            d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};

},{"react":"9njXz","clsx":"d2NWs","react-smooth":"7kGqo","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"44jal":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dot", ()=>Dot);
/**
 * @fileOverview Dot
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var Dot = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, _clsxDefault.default)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", _extends({}, (0, _reactUtils.filterProps)(props), (0, _types.adaptEventHandlers)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};

},{"react":"9njXz","clsx":"d2NWs","../util/types":"c9QyM","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5qFSP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cross", ()=>Cross);
/**
 * @fileOverview Cross
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var Cross = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y) || !(0, _dataUtils.isNumber)(width) || !(0, _dataUtils.isNumber)(height) || !(0, _dataUtils.isNumber)(top) || !(0, _dataUtils.isNumber)(left)) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: (0, _clsxDefault.default)('recharts-cross', className),
        d: getPath(x, y, width, height, top, left)
    }));
};

},{"react":"9njXz","clsx":"d2NWs","../util/DataUtils":"5VTG4","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jFSUR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Brush", ()=>Brush);
/**
 * @fileOverview Brush
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _d3Scale = require("victory-vendor/d3-scale");
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _layer = require("../container/Layer");
var _text = require("../component/Text");
var _chartUtils = require("../util/ChartUtils");
var _dataUtils = require("../util/DataUtils");
var _cssPrefixUtils = require("../util/CssPrefixUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, _d3Scale.scalePoint)().domain((0, _rangeDefault.default)(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var Brush = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Brush, _PureComponent);
    var _super = _createSuper(Brush);
    function Brush(props) {
        var _this;
        _classCallCheck(this, Brush);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        _defineProperty(_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        _defineProperty(_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        _defineProperty(_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'startX'),
            endX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'endX')
        };
        _this.state = {};
        return _this;
    }
    _createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, _chartUtils.getValueByDataKey)(data[index], dataKey, index);
                return (0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, _defineProperty(_this$setState, movingTravellerId, prevValue + delta), _defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState(_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, _react.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    tabIndex: 0,
                    role: "slider",
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y) || !(0, _dataUtils.isNumber)(width) || !(0, _dataUtils.isNumber)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, _clsxDefault.default)('recharts-brush', className);
                var isPanoramic = (0, _reactDefault.default).Children.count(children) === 1;
                var style = (0, _cssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) rectangle = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return _objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, _react.PureComponent));
_defineProperty(Brush, "displayName", 'Brush');
_defineProperty(Brush, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});

},{"react":"9njXz","clsx":"d2NWs","victory-vendor/d3-scale":"22AVB","lodash/isFunction":"3A7xI","lodash/range":"3NTTt","../container/Layer":"4Q0HG","../component/Text":"4AQ2W","../util/ChartUtils":"24GXn","../util/DataUtils":"5VTG4","../util/CssPrefixUtils":"j4TUv","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3NTTt":[function(require,module,exports,__globalThis) {
var createRange = require("1232c42be39f64d6");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var range = createRange();
module.exports = range;

},{"1232c42be39f64d6":"2HsCF"}],"2HsCF":[function(require,module,exports,__globalThis) {
var baseRange = require("f5c6552fbc38341a"), isIterateeCall = require("ae36f017fbc9946"), toFinite = require("c59818521cb53c6a");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = toFinite(end);
        step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
    };
}
module.exports = createRange;

},{"f5c6552fbc38341a":"3QPng","ae36f017fbc9946":"gTLnH","c59818521cb53c6a":"b6tZP"}],"3QPng":[function(require,module,exports,__globalThis) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = baseRange;

},{}],"j4TUv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generatePrefixStyle", ()=>generatePrefixStyle);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var generatePrefixStyle = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = PREFIX_LIST.reduce(function(res, entry) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYVuF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferenceLine", ()=>ReferenceLine);
/**
 * @fileOverview Reference Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _some = require("lodash/some");
var _someDefault = parcelHelpers.interopDefault(_some);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _label = require("../component/Label");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _dataUtils = require("../util/DataUtils");
var _cartesianUtils = require("../util/CartesianUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) line = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) line = option(props);
    else line = /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
// TODO: ScaleHelper
var getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && (0, _someDefault.default)(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function ReferenceLine(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, _dataUtils.isNumOrStr)(fixedX);
    var isY = (0, _dataUtils.isNumOrStr)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = getEndPoints(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = _slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = _objectSpread(_objectSpread({
        clipPath: clipPath
    }, (0, _reactUtils.filterProps)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: (0, _clsxDefault.default)('recharts-reference-line', className)
    }, renderLine(shape, lineProps), (0, _label.Label).renderCallByParent(props, (0, _cartesianUtils.rectWithCoords)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
ReferenceLine.displayName = 'ReferenceLine';
ReferenceLine.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
};

},{"react":"9njXz","lodash/isFunction":"3A7xI","lodash/some":"8liwH","clsx":"d2NWs","../container/Layer":"4Q0HG","../component/Label":"2uQzv","../util/IfOverflowMatches":"4CJ5E","../util/DataUtils":"5VTG4","../util/CartesianUtils":"8rDib","../util/LogUtils":"2yNyz","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8liwH":[function(require,module,exports,__globalThis) {
var arraySome = require("499d9ae1b712c84d"), baseIteratee = require("6137baa4d335eb2f"), baseSome = require("dffda66140b0b703"), isArray = require("21c688a994e48617"), isIterateeCall = require("86e6a8e9c3fc8343");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function some(collection, predicate, guard) {
    var func = isArray(collection) ? arraySome : baseSome;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = some;

},{"499d9ae1b712c84d":"bjRBC","6137baa4d335eb2f":"6jZAq","dffda66140b0b703":"ca50T","21c688a994e48617":"1DVeR","86e6a8e9c3fc8343":"gTLnH"}],"ca50T":[function(require,module,exports,__globalThis) {
var baseEach = require("fbf6b3dce93949f8");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function baseSome(collection, predicate) {
    var result;
    baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = baseSome;

},{"fbf6b3dce93949f8":"hbtgh"}],"4CJ5E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ifOverflowMatches", ()=>ifOverflowMatches);
var ifOverflowMatches = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8rDib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatAxisMap", ()=>formatAxisMap);
parcelHelpers.export(exports, "rectWithPoints", ()=>rectWithPoints);
parcelHelpers.export(exports, "rectWithCoords", ()=>rectWithCoords);
parcelHelpers.export(exports, "ScaleHelper", ()=>ScaleHelper);
parcelHelpers.export(exports, "createLabeledScales", ()=>createLabeledScales);
/** Normalizes the angle so that 0 <= angle < 180.
 * @param {number} angle Angle in degrees.
 * @return {number} the normalized angle with a value of at least 0 and never greater or equal to 180. */ parcelHelpers.export(exports, "normalizeAngle", ()=>normalizeAngle);
parcelHelpers.export(exports, "getAngledRectangleWidth", ()=>getAngledRectangleWidth);
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _every = require("lodash/every");
var _everyDefault = parcelHelpers.interopDefault(_every);
var _chartUtils = require("./ChartUtils");
var _reactUtils = require("./ReactUtils");
var _dataUtils = require("./DataUtils");
var _bar = require("../cartesian/Bar");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, _reactUtils.findChildByType)(children, (0, _bar.Bar));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
            if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === 'no-gap') {
                var gap = (0, _dataUtils.getPercentValue)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, _chartUtils.parseScale)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, _chartUtils.checkDomainOfScale)(scale);
        var ticks = (0, _chartUtils.getTicksOfScale)(scale, _objectSpread(_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = _objectSpread(_objectSpread(_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, _chartUtils.getBandSizeOfAxis)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, id, finalAxis));
    }, {});
};
var rectWithPoints = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var rectWithCoords = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return rectWithPoints({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var ScaleHelper = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        _classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    _createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
_defineProperty(ScaleHelper, "EPS", 1e-4);
var createLabeledScales = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, ScaleHelper.create(options[key])));
    }, {});
    return _objectSpread(_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, _mapValuesDefault.default)(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, _everyDefault.default)(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function normalizeAngle(angle) {
    return (angle % 180 + 180) % 180;
}
var getAngledRectangleWidth = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = normalizeAngle(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};

},{"lodash/mapValues":"euNKf","lodash/every":"drZyD","./ChartUtils":"24GXn","./ReactUtils":"lj4u0","./DataUtils":"5VTG4","../cartesian/Bar":"ddhnq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"euNKf":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("a3dd03284854d1b5"), baseForOwn = require("3fe946fb5f45d4e9"), baseIteratee = require("8671a2b480ab95e2");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = mapValues;

},{"a3dd03284854d1b5":"ba13n","3fe946fb5f45d4e9":"i7P4y","8671a2b480ab95e2":"6jZAq"}],"drZyD":[function(require,module,exports,__globalThis) {
var arrayEvery = require("35998aa94ab060f1"), baseEvery = require("44e7ab95f8b26a55"), baseIteratee = require("1d5621a35ca53be0"), isArray = require("e0e4c2e424adb44f"), isIterateeCall = require("2f9b3b0ab0300132");
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function every(collection, predicate, guard) {
    var func = isArray(collection) ? arrayEvery : baseEvery;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = every;

},{"35998aa94ab060f1":"gsRpm","44e7ab95f8b26a55":"jdsxq","1d5621a35ca53be0":"6jZAq","e0e4c2e424adb44f":"1DVeR","2f9b3b0ab0300132":"gTLnH"}],"gsRpm":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
module.exports = arrayEvery;

},{}],"jdsxq":[function(require,module,exports,__globalThis) {
var baseEach = require("88b2ceed9e7ead7a");
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function baseEvery(collection, predicate) {
    var result = true;
    baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
module.exports = baseEvery;

},{"88b2ceed9e7ead7a":"hbtgh"}],"ddhnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", ()=>Bar);
/**
 * @fileOverview Render a group of bar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _layer = require("../container/Layer");
var _errorBar = require("./ErrorBar");
var _cell = require("../component/Cell");
var _labelList = require("../component/LabelList");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _chartUtils = require("../util/ChartUtils");
var _types = require("../util/types");
var _barUtils = require("../util/BarUtils");
var _excluded = [
    "value",
    "background"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var Bar = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Bar, _PureComponent);
    var _super = _createSuper(Bar);
    function Bar() {
        var _this;
        _classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        _defineProperty(_assertThisInitialized(_this), "id", (0, _dataUtils.uniqueId)('recharts-bar-'));
        _defineProperty(_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        _defineProperty(_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    _createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, _reactUtils.filterProps)(this.props);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = _objectSpread(_objectSpread(_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-bar-rectangle"
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
                        key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barUtils.BarRectangle), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                            var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                            var interpolatorWidth = (0, _dataUtils.interpolateNumber)(prev.width, entry.width);
                            var interpolatorHeight = (0, _dataUtils.interpolateNumber)(prev.height, entry.height);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, _dataUtils.interpolateNumber)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, _dataUtils.interpolateNumber)(0, entry.width);
                        var w = interpolator(t);
                        return _objectSpread(_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqualDefault.default)(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, _reactUtils.filterProps)(this.props.background);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = _objectWithoutProperties(entry, _excluded);
                    if (!background) return null;
                    var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, _types.adaptEventsOfChild)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        key: "background-bar-".concat(i),
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barUtils.BarRectangle), _extends({
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, _chartUtils.getValueByDataKey)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(item, {
                        key: "error-bar-".concat(i),
                        // eslint-disable-line react/no-array-index-key
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, _clsxDefault.default)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
    return Bar;
}((0, _react.PureComponent));
_defineProperty(Bar, "displayName", 'Bar');
_defineProperty(Bar, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: true,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ _defineProperty(Bar, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, _chartUtils.findPositionOfBar)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, _chartUtils.getBaseValueOfBar)({
        numericAxis: numericAxis
    });
    var cells = (0, _reactUtils.findAllByType)(children, (0, _cell.Cell));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, _chartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, _dataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, _dataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return _objectSpread(_objectSpread(_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, _chartUtils.getTooltipItem)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return _objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

},{"react":"9njXz","clsx":"d2NWs","react-smooth":"7kGqo","lodash/isEqual":"3mRdp","lodash/isNil":"eS6AM","../container/Layer":"4Q0HG","./ErrorBar":"1ePUt","../component/Cell":"cemk7","../component/LabelList":"bRsHp","../util/DataUtils":"5VTG4","../util/ReactUtils":"lj4u0","../util/Global":"c6qoI","../util/ChartUtils":"24GXn","../util/types":"c9QyM","../util/BarUtils":"68f5p","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"68f5p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BarRectangle", ()=>BarRectangle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _activeShapeUtils = require("./ActiveShapeUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "x",
    "y"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, numbe, number, number]
function typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = _objectWithoutProperties(_ref, _excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function BarRectangle(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _activeShapeUtils.Shape), _extends({
        shapeType: "rectangle",
        propTransformer: typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}

},{"react":"9njXz","./ActiveShapeUtils":"fo3nx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fo3nx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPropsFromShapeOption", ()=>getPropsFromShapeOption);
parcelHelpers.export(exports, "Shape", ()=>Shape);
/**
 * This is an abstraction to handle identifying the active index from a tooltip mouse interaction
 */ parcelHelpers.export(exports, "isFunnel", ()=>isFunnel);
parcelHelpers.export(exports, "isPie", ()=>isPie);
parcelHelpers.export(exports, "isScatter", ()=>isScatter);
parcelHelpers.export(exports, "compareFunnel", ()=>compareFunnel);
parcelHelpers.export(exports, "comparePie", ()=>comparePie);
parcelHelpers.export(exports, "compareScatter", ()=>compareScatter);
/**
 *
 * @param {GetActiveShapeIndexForTooltip} arg an object of incoming attributes from Tooltip
 * @returns {number}
 *
 * To handle possible duplicates in the data set,
 * match both the data value of the active item to a data value on a graph item,
 * and match the mouse coordinates of the active item to the coordinates of in a particular components shape data.
 * This assumes equal lengths of shape objects to data items.
 */ parcelHelpers.export(exports, "getActiveShapeIndexForTooltip", ()=>getActiveShapeIndexForTooltip);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _isBoolean = require("lodash/isBoolean");
var _isBooleanDefault = parcelHelpers.interopDefault(_isBoolean);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _rectangle = require("../shape/Rectangle");
var _trapezoid = require("../shape/Trapezoid");
var _sector = require("../shape/Sector");
var _layer = require("../container/Layer");
var _symbols = require("../shape/Symbols");
var _excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function defaultPropTransformer(option, props) {
    return _objectSpread(_objectSpread({}, props), option);
}
function isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _trapezoid.Trapezoid), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sector.Sector), elementProps);
        case 'symbols':
            if (isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _symbols.Symbols), elementProps);
            break;
        default:
            return null;
    }
}
function getPropsFromShapeOption(option) {
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) return option.props;
    return option;
}
function Shape(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = _objectWithoutProperties(_ref2, _excluded);
    var shape;
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) shape = /*#__PURE__*/ (0, _react.cloneElement)(option, _objectSpread(_objectSpread({}, props), getPropsFromShapeOption(option)));
    else if ((0, _isFunctionDefault.default)(option)) shape = option(props);
    else if ((0, _isPlainObjectDefault.default)(option) && !(0, _isBooleanDefault.default)(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, _reactDefault.default).createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, _reactDefault.default).createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: activeClassName
    }, shape);
    return shape;
}
function isFunnel(graphicalItem, _item) {
    return 'trapezoids' in graphicalItem.props;
}
function isPie(graphicalItem, _item) {
    return 'sectors' in graphicalItem.props;
}
function isScatter(graphicalItem, _item) {
    return 'points' in graphicalItem.props;
}
function compareFunnel(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function comparePie(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function compareScatter(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if (isFunnel(graphicalItem, activeItem)) comparison = compareFunnel;
    else if (isPie(graphicalItem, activeItem)) comparison = comparePie;
    else if (isScatter(graphicalItem, activeItem)) comparison = compareScatter;
    return comparison;
}
function getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if (isFunnel(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if (isPie(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if (isScatter(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if (isFunnel(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if (isPie(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if (isScatter(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function getActiveShapeIndexForTooltip(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, _isEqualDefault.default)(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}

},{"react":"9njXz","lodash/isFunction":"3A7xI","lodash/isPlainObject":"lCxAG","lodash/isBoolean":"7ksee","lodash/isEqual":"3mRdp","../shape/Rectangle":"icCgC","../shape/Trapezoid":"aasiL","../shape/Sector":"bmvhw","../container/Layer":"4Q0HG","../shape/Symbols":"gQKDd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ksee":[function(require,module,exports,__globalThis) {
var baseGetTag = require("763d54281423d9ac"), isObjectLike = require("37c1c7912587466b");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}
module.exports = isBoolean;

},{"763d54281423d9ac":"5ltt8","37c1c7912587466b":"4gOki"}],"aasiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trapezoid", ()=>Trapezoid);
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var Trapezoid = function Trapezoid(props) {
    var trapezoidProps = _objectSpread(_objectSpread({}, defaultProps), props);
    var pathRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)(-1), _useState2 = _slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, _react.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(trapezoidProps, true), {
        className: layerClass,
        d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(trapezoidProps, true), {
            className: layerClass,
            d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};

},{"react":"9njXz","clsx":"d2NWs","react-smooth":"7kGqo","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4nujU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferenceDot", ()=>ReferenceDot);
/**
 * @fileOverview Reference Dot
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _dot = require("../shape/Dot");
var _label = require("../component/Label");
var _dataUtils = require("../util/DataUtils");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _cartesianUtils = require("../util/CartesianUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
function ReferenceDot(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, _dataUtils.isNumOrStr)(x);
    var isY = (0, _dataUtils.isNumOrStr)(y);
    (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = _objectSpread(_objectSpread({
        clipPath: clipPath
    }, (0, _reactUtils.filterProps)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: (0, _clsxDefault.default)('recharts-reference-dot', className)
    }, ReferenceDot.renderDot(shape, dotProps), (0, _label.Label).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
ReferenceDot.displayName = 'ReferenceDot';
ReferenceDot.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
};
ReferenceDot.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dot = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};

},{"react":"9njXz","lodash/isFunction":"3A7xI","clsx":"d2NWs","../container/Layer":"4Q0HG","../shape/Dot":"44jal","../component/Label":"2uQzv","../util/DataUtils":"5VTG4","../util/IfOverflowMatches":"4CJ5E","../util/CartesianUtils":"8rDib","../util/LogUtils":"2yNyz","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"izrp6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferenceArea", ()=>ReferenceArea);
/**
 * @fileOverview Reference Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _label = require("../component/Label");
var _cartesianUtils = require("../util/CartesianUtils");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _dataUtils = require("../util/DataUtils");
var _logUtils = require("../util/LogUtils");
var _rectangle = require("../shape/Rectangle");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, _cartesianUtils.rectWithPoints)(p1, p2);
};
function ReferenceArea(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, _dataUtils.isNumOrStr)(x1);
    var hasX2 = (0, _dataUtils.isNumOrStr)(x2);
    var hasY1 = (0, _dataUtils.isNumOrStr)(y1);
    var hasY2 = (0, _dataUtils.isNumOrStr)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: (0, _clsxDefault.default)('recharts-reference-area', className)
    }, ReferenceArea.renderRect(shape, _objectSpread(_objectSpread({
        clipPath: clipPath
    }, (0, _reactUtils.filterProps)(props, true)), rect)), (0, _label.Label).renderCallByParent(props, rect));
}
ReferenceArea.displayName = 'ReferenceArea';
ReferenceArea.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
};
ReferenceArea.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) rect = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), _extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};

},{"react":"9njXz","lodash/isFunction":"3A7xI","clsx":"d2NWs","../container/Layer":"4Q0HG","../component/Label":"2uQzv","../util/CartesianUtils":"8rDib","../util/IfOverflowMatches":"4CJ5E","../util/DataUtils":"5VTG4","../util/LogUtils":"2yNyz","../shape/Rectangle":"icCgC","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iRtii":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianAxis", ()=>CartesianAxis);
/**
 * @fileOverview Cartesian Axis
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _shallowEqual = require("../util/ShallowEqual");
var _layer = require("../container/Layer");
var _text = require("../component/Text");
var _label = require("../component/Label");
var _dataUtils = require("../util/DataUtils");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _getTicks = require("./getTicks");
var _excluded = [
    "viewBox"
], _excluded2 = [
    "viewBox"
], _excluded3 = [
    "ticks"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var CartesianAxis = /*#__PURE__*/ function(_Component) {
    _inherits(CartesianAxis, _Component);
    var _super = _createSuper(CartesianAxis);
    function CartesianAxis(props) {
        var _this;
        _classCallCheck(this, CartesianAxis);
        _this = _super.call(this, props);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    _createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = _objectWithoutProperties(_ref, _excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = _objectWithoutProperties(_this$props, _excluded2);
                return !(0, _shallowEqual.shallowEqual)(viewBox, viewBoxOld) || !(0, _shallowEqual.shallowEqual)(restProps, restPropsOld) || !(0, _shallowEqual.shallowEqual)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, _dataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props)), (0, _reactUtils.filterProps)(axisLine)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = _objectSpread(_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = _objectSpread(_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, props, {
                    className: (0, _clsxDefault.default)('recharts-cartesian-axis-line', (0, _getDefault.default)(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, _getTicks.getTicks)(_objectSpread(_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, _reactUtils.filterProps)(this.props);
                var customTickProps = (0, _reactUtils.filterProps)(tick);
                var tickLineProps = _objectSpread(_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, _reactUtils.filterProps)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, tickLineProps, lineCoord, {
                        className: (0, _clsxDefault.default)('recharts-cartesian-axis-tick-line', (0, _getDefault.default)(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = _objectWithoutProperties(_this$props8, _excluded3);
                var finalTicks = ticks;
                if ((0, _isFunctionDefault.default)(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, _label.Label).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, _react.Component));
_defineProperty(CartesianAxis, "displayName", 'CartesianAxis');
_defineProperty(CartesianAxis, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});

},{"react":"9njXz","lodash/isFunction":"3A7xI","lodash/get":"dBTJh","clsx":"d2NWs","../util/ShallowEqual":"5DwJA","../container/Layer":"4Q0HG","../component/Text":"4AQ2W","../component/Label":"2uQzv","../util/DataUtils":"5VTG4","../util/types":"c9QyM","../util/ReactUtils":"lj4u0","./getTicks":"gZ70X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gZ70X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTicks", ()=>getTicks);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _dataUtils = require("../util/DataUtils");
var _domutils = require("../util/DOMUtils");
var _global = require("../util/Global");
var _tickUtils = require("../util/TickUtils");
var _getEquidistantTicks = require("./getEquidistantTicks");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _objectSpread(_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, _tickUtils.isVisible)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = _objectSpread(_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function getTicks(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, _dataUtils.isNumber)(interval) || (0, _global.Global).isSsr) return (0, _tickUtils.getNumberIntervalTicks)(ticks, typeof interval === 'number' && (0, _dataUtils.isNumber)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, _domutils.getStringSize)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, _tickUtils.getAngledTickWidth)((0, _domutils.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, _domutils.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, _dataUtils.mathSign)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, _tickUtils.getTickBoundaries)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, _getEquidistantTicks.getEquidistantTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}

},{"lodash/isFunction":"3A7xI","../util/DataUtils":"5VTG4","../util/DOMUtils":"7SjCz","../util/Global":"c6qoI","../util/TickUtils":"aspGR","./getEquidistantTicks":"8INCv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aspGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAngledTickWidth", ()=>getAngledTickWidth);
parcelHelpers.export(exports, "getTickBoundaries", ()=>getTickBoundaries);
parcelHelpers.export(exports, "isVisible", ()=>isVisible);
parcelHelpers.export(exports, "getNumberIntervalTicks", ()=>getNumberIntervalTicks);
var _cartesianUtils = require("./CartesianUtils");
var _getEveryNthWithCondition = require("./getEveryNthWithCondition");
function getAngledTickWidth(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, _cartesianUtils.getAngledRectangleWidth)(size, angle);
}
function getTickBoundaries(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function isVisible(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function getNumberIntervalTicks(ticks, interval) {
    return (0, _getEveryNthWithCondition.getEveryNthWithCondition)(ticks, interval + 1);
}

},{"./CartesianUtils":"8rDib","./getEveryNthWithCondition":"bVE8V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bVE8V":[function(require,module,exports,__globalThis) {
/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEveryNthWithCondition", ()=>getEveryNthWithCondition);
function getEveryNthWithCondition(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8INCv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEquidistantTicks", ()=>getEquidistantTicks);
var _tickUtils = require("../util/TickUtils");
var _getEveryNthWithCondition = require("../util/getEveryNthWithCondition");
function getEquidistantTicks(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, _getEveryNthWithCondition.getEveryNthWithCondition)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, _tickUtils.isVisible)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}

},{"../util/TickUtils":"aspGR","../util/getEveryNthWithCondition":"bVE8V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"12YNc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Area", ()=>Area);
/**
 * @fileOverview Area
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _max = require("lodash/max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _curve = require("../shape/Curve");
var _dot = require("../shape/Dot");
var _layer = require("../container/Layer");
var _labelList = require("../component/LabelList");
var _global = require("../util/Global");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
];
var _class;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var Area = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Area, _PureComponent);
    var _super = _createSuper(Area);
    function Area() {
        var _this;
        _classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
            isAnimationFinished: true
        });
        _defineProperty(_assertThisInitialized(_this), "id", (0, _dataUtils.uniqueId)('recharts-area-'));
        _defineProperty(_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    _createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, _reactUtils.filterProps)(this.props);
                var customDotProps = (0, _reactUtils.filterProps)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = _objectSpread(_objectSpread(_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        value: entry.value,
                        payload: entry.payload
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, _maxDefault.default)(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, _dataUtils.isNumber)(baseLine) && typeof baseLine === 'number') maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, _maxDefault.default)(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, _dataUtils.isNumber)(maxY)) return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, _maxDefault.default)(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, _dataUtils.isNumber)(baseLine) && typeof baseLine === 'number') maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, _maxDefault.default)(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, _dataUtils.isNumber)(maxX)) return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === 'vertical') return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = _objectWithoutProperties(_this$props4, _excluded);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, (0, _reactUtils.filterProps)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== 'none' && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, (0, _reactUtils.filterProps)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== 'none' && isRange && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, (0, _reactUtils.filterProps)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, _dataUtils.isNumber)(baseLine) && typeof baseLine === 'number') {
                            var interpolator = (0, _dataUtils.interpolateNumber)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, _isNilDefault.default)(baseLine) || (0, _isNaNDefault.default)(baseLine)) {
                            var _interpolator = (0, _dataUtils.interpolateNumber)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqualDefault.default)(prevPoints, points) || !(0, _isEqualDefault.default)(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, _clsxDefault.default)('recharts-area', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, _reactUtils.filterProps)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, _reactUtils.isDotProps)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
    return Area;
}((0, _react.PureComponent));
_class = Area;
_defineProperty(Area, "displayName", 'Area');
_defineProperty(Area, "defaultProps", {
    stroke: '#3182bd',
    fill: '#3182bd',
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'line',
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
_defineProperty(Area, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, _dataUtils.isNumber)(baseValue) && typeof baseValue === 'number') return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return domainMin;
        if (baseValue === 'dataMax') return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
});
_defineProperty(Area, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = _class.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === 'horizontal';
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, _chartUtils.getValueByDataKey)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return _objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
_defineProperty(Area, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dotItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) dotItem = option(props);
    else dotItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({}, props, {
        className: "recharts-area-dot"
    }));
    return dotItem;
});

},{"react":"9njXz","clsx":"d2NWs","react-smooth":"7kGqo","lodash/isFunction":"3A7xI","lodash/max":"5g5H3","lodash/isNil":"eS6AM","lodash/isNaN":"ih06S","lodash/isEqual":"3mRdp","../shape/Curve":"hqiOr","../shape/Dot":"44jal","../container/Layer":"4Q0HG","../component/LabelList":"bRsHp","../util/Global":"c6qoI","../util/DataUtils":"5VTG4","../util/ChartUtils":"24GXn","../util/ReactUtils":"lj4u0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g9bnS":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XAxis", ()=>XAxis);
var XAxis = function XAxis() {
    return null;
};
XAxis.displayName = 'XAxis';
XAxis.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01IPN":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Y Axis
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YAxis", ()=>YAxis);
var YAxis = function YAxis() {
    return null;
};
YAxis.displayName = 'YAxis';
YAxis.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"asgQa":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Area Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AreaChart", ()=>AreaChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _area = require("../cartesian/Area");
var _xaxis = require("../cartesian/XAxis");
var _yaxis = require("../cartesian/YAxis");
var _cartesianUtils = require("../util/CartesianUtils");
var AreaChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'AreaChart',
    GraphicalChild: (0, _area.Area),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, _xaxis.XAxis)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, _yaxis.YAxis)
        }
    ],
    formatAxisMap: (0, _cartesianUtils.formatAxisMap)
});

},{"./generateCategoricalChart":"dQGlB","../cartesian/Area":"12YNc","../cartesian/XAxis":"g9bnS","../cartesian/YAxis":"01IPN","../util/CartesianUtils":"8rDib","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dQGlB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAxisMapByAxes", ()=>getAxisMapByAxes);
parcelHelpers.export(exports, "generateCategoricalChart", ()=>generateCategoricalChart);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _throttle = require("lodash/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _find = require("lodash/find");
var _findDefault = parcelHelpers.interopDefault(_find);
var _every = require("lodash/every");
var _everyDefault = parcelHelpers.interopDefault(_every);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
// eslint-disable-next-line no-restricted-imports
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _getRadialCursorPoints = require("../util/cursor/getRadialCursorPoints");
var _getTicks = require("../cartesian/getTicks");
var _surface = require("../container/Surface");
var _layer = require("../container/Layer");
var _tooltip = require("../component/Tooltip");
var _legend = require("../component/Legend");
var _curve = require("../shape/Curve");
var _cross = require("../shape/Cross");
var _sector = require("../shape/Sector");
var _dot = require("../shape/Dot");
var _rectangle = require("../shape/Rectangle");
var _reactUtils = require("../util/ReactUtils");
var _cartesianAxis = require("../cartesian/CartesianAxis");
var _brush = require("../cartesian/Brush");
var _domutils = require("../util/DOMUtils");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _detectReferenceElementsDomain = require("../util/DetectReferenceElementsDomain");
var _polarUtils = require("../util/PolarUtils");
var _shallowEqual = require("../util/ShallowEqual");
var _events = require("../util/Events");
var _types = require("../util/types");
var _accessibilityManager = require("./AccessibilityManager");
var _isDomainSpecifiedByUser = require("../util/isDomainSpecifiedByUser");
var _activeShapeUtils = require("../util/ActiveShapeUtils");
var _getCursorPoints = require("../util/cursor/getCursorPoints");
var _getCursorRectangle = require("../util/cursor/getCursorRectangle");
var _excluded = [
    "item"
], _excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var originCoordinate = {
    x: 0,
    y: 0
};
var calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return originCoordinate;
};
var getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, _dataUtils.isNumber)(dataStartIndex) && (0, _dataUtils.isNumber)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        var hide = child.props.hide;
        if (hide) return result;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, _dataUtils.findEntryInArray)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat(_toConsumableArray(result), [
            (0, _chartUtils.getTooltipItem)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, _chartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var getAxisMapByAxes = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, _isDomainSpecifiedByUser.isDomainSpecifiedByUser)(child.props.domain, allowDataOverflow, type)) {
            domain = (0, _chartUtils.parseSpecifiedDomain)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, _dataUtils.hasDuplicate)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, _rangeDefault.default)(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, _chartUtils.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, _chartUtils.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNilDefault.default)(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, _isNilDefault.default)(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, _chartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, _rangeDefault.default)(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, _chartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, _chartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, _chartUtils.parseSpecifiedDomain)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, _rangeDefault.default)(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, _chartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            } else {
                domain = (0, _chartUtils.parseSpecifiedDomain)(originalDomain, (0, _chartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            }
            return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, _getDefault.default)(ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, _reactUtils.findAllByType)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = getAxisMapByAxes(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, _dataUtils.getAnyElementOfObject)(axisMap);
    var tooltipTicks = (0, _chartUtils.getTicksOfAxis)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, _sortByDefault.default)(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, _chartUtils.getBandSizeOfAxis)(axis, tooltipTicks)
    };
};
/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */ var createDefaultState = function createDefaultState(props) {
    var _brushItem$props, _brushItem$props2;
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = (brushItem === null || brushItem === void 0 || (_brushItem$props = brushItem.props) === null || _brushItem$props === void 0 ? void 0 : _brushItem$props.endIndex) !== undefined ? brushItem === null || brushItem === void 0 || (_brushItem$props2 = brushItem.props) === null || _brushItem$props2 === void 0 ? void 0 : _brushItem$props2.endIndex : props.data && props.data.length - 1 || 0;
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, _reactUtils.getDisplayName)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
    var legendItem = (0, _reactUtils.findChildByType)(children, (0, _legend.Legend));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, (0, _getDefault.default)(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = _objectSpread(_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, _brush.Brush).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, _chartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return _objectSpread(_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
var generateCategoricalChart = function generateCategoricalChart(_ref6) {
    var _class;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, _chartUtils.getBarSizeList)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type, _objectSpread6;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = item.props["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, _tinyInvariantDefault.default)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return _objectSpread(_objectSpread({}, result), {}, (_objectSpread6 = {}, _defineProperty(_objectSpread6, entry.axisType, axis), _defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, _chartUtils.getTicksOfAxis)(axis)), _objectSpread6));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _chartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, _reactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, _chartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, _isNilDefault.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, _chartUtils.getBandSizeOfAxis)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, _chartUtils.getBarPosition)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return _objectSpread(_objectSpread({}, pos), {}, {
                        position: _objectSpread(_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: _objectSpread(_objectSpread({}, composedFn(_objectSpread(_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, _defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), _defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), _defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, _reactUtils.parseChildIndex)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, _reactUtils.validateWidthHeight)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, _reactUtils.findAllByType)(children, GraphicalChild);
        var stackGroups = (0, _chartUtils.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, name, getAxisMap(props, _objectSpread(_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = calculateOffset(_objectSpread(_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, _objectSpread(_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return _objectSpread(_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _class = /*#__PURE__*/ function(_Component) {
        _inherits(CategoricalChartWrapper, _Component);
        var _super = _createSuper(CategoricalChartWrapper);
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            _classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            _defineProperty(_assertThisInitialized(_this), "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            _defineProperty(_assertThisInitialized(_this), "accessibilityManager", new (0, _accessibilityManager.AccessibilityManager)());
            _defineProperty(_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState(_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, _objectSpread(_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return _objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = _objectSpread(_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, _isFunctionDefault.default)(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? _objectSpread(_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, _isFunctionDefault.default)(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ _defineProperty(_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ _defineProperty(_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, _isFunctionDefault.default)(onMouseLeave)) onMouseLeave(nextState, e);
            });
            _defineProperty(_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, _reactUtils.getReactEventByType)(e);
                var event = (0, _getDefault.default)(_this.props, "".concat(eventName));
                if (eventName && (0, _isFunctionDefault.default)(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = _objectSpread(_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, _isFunctionDefault.default)(onClick)) onClick(_nextState2, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, _isFunctionDefault.default)(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, _isFunctionDefault.default)(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            _defineProperty(_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            _defineProperty(_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            _defineProperty(_assertThisInitialized(_this), "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, _events.eventCenter).emit((0, _events.SYNC_EVENT), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            _defineProperty(_assertThisInitialized(_this), "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState(_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = _objectSpread(_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : originCoordinate;
                    _this.setState(_objectSpread(_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            _defineProperty(_assertThisInitialized(_this), "verticalCoordinatesGenerator", function(_ref10, syncWithTicks) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.CartesianAxis).defaultProps), xAxis), {}, {
                    ticks: (0, _chartUtils.getTicksOfAxis)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width, syncWithTicks);
            });
            _defineProperty(_assertThisInitialized(_this), "horizontalCoordinatesGenerator", function(_ref11, syncWithTicks) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.CartesianAxis).defaultProps), yAxis), {}, {
                    ticks: (0, _chartUtils.getTicksOfAxis)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height, syncWithTicks);
            });
            _defineProperty(_assertThisInitialized(_this), "axesTicksGenerator", function(axis) {
                return (0, _chartUtils.getTicksOfAxis)(axis, true);
            });
            _defineProperty(_assertThisInitialized(_this), "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                if (!element || !element.props.cursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
                var layout = _this.props.layout;
                var restProps;
                var cursorComp = (0, _curve.Curve);
                if (chartName === 'ScatterChart') {
                    restProps = activeCoordinate;
                    cursorComp = (0, _cross.Cross);
                } else if (chartName === 'BarChart') {
                    restProps = (0, _getCursorRectangle.getCursorRectangle)(layout, activeCoordinate, offset, tooltipAxisBandSize);
                    cursorComp = (0, _rectangle.Rectangle);
                } else if (layout === 'radial') {
                    var _getRadialCursorPoint = (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
                    restProps = {
                        cx: cx,
                        cy: cy,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        innerRadius: radius,
                        outerRadius: radius
                    };
                    cursorComp = (0, _sector.Sector);
                } else {
                    restProps = {
                        points: (0, _getCursorPoints.getCursorPoints)(layout, activeCoordinate, offset)
                    };
                    cursorComp = (0, _curve.Curve);
                }
                var key = element.key || '_recharts-cursor';
                var cursorProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                    stroke: '#ccc',
                    pointerEvents: 'none'
                }, offset), restProps), (0, _reactUtils.filterProps)(element.props.cursor)), {}, {
                    payload: activePayload,
                    payloadIndex: activeTooltipIndex,
                    key: key,
                    className: 'recharts-tooltip-cursor'
                });
                return /*#__PURE__*/ (0, _react.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, _react.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, _react.createElement)(cursorComp, cursorProps);
            });
            _defineProperty(_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, _getDefault.default)(element, 'type.axisType');
                var axisMap = (0, _getDefault.default)(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, _chartUtils.getTicksOfAxis)(axisOption, true)
                }));
            });
            _defineProperty(_assertThisInitialized(_this), "renderXAxis", function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            _defineProperty(_assertThisInitialized(_this), "renderYAxis", function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */ _defineProperty(_assertThisInitialized(_this), "renderGrid", function(element) {
                var _this$state4 = _this.state, xAxisMap = _this$state4.xAxisMap, yAxisMap = _this$state4.yAxisMap, offset = _this$state4.offset;
                var _this$props2 = _this.props, width = _this$props2.width, height = _this$props2.height;
                var xAxis = (0, _dataUtils.getAnyElementOfObject)(xAxisMap);
                var yAxisWithFiniteDomain = (0, _findDefault.default)(yAxisMap, function(axis) {
                    return (0, _everyDefault.default)(axis.domain, Number.isFinite);
                });
                var yAxis = yAxisWithFiniteDomain || (0, _dataUtils.getAnyElementOfObject)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    key: element.key || 'grid',
                    x: (0, _dataUtils.isNumber)(props.x) ? props.x : offset.left,
                    y: (0, _dataUtils.isNumber)(props.y) ? props.y : offset.top,
                    width: (0, _dataUtils.isNumber)(props.width) ? props.width : offset.width,
                    height: (0, _dataUtils.isNumber)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            });
            _defineProperty(_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state5 = _this.state, radiusAxisMap = _this$state5.radiusAxisMap, angleAxisMap = _this$state5.angleAxisMap;
                var radiusAxis = (0, _dataUtils.getAnyElementOfObject)(radiusAxisMap);
                var angleAxis = (0, _dataUtils.getAnyElementOfObject)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, _chartUtils.getTicksOfAxis)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, _chartUtils.getTicksOfAxis)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ _defineProperty(_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props3 = _this.props, children = _this$props3.children, width = _this$props3.width, height = _this$props3.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, _chartUtils.getLegendProps)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = _objectWithoutProperties(props, _excluded);
                return /*#__PURE__*/ (0, _react.cloneElement)(item, _objectSpread(_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ _defineProperty(_assertThisInitialized(_this), "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var children = _this.props.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (!tooltipItem) return null;
                var _this$state6 = _this.state, isTooltipActive = _this$state6.isTooltipActive, activeCoordinate = _this$state6.activeCoordinate, activePayload = _this$state6.activePayload, activeLabel = _this$state6.activeLabel, offset = _this$state6.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, _react.cloneElement)(tooltipItem, {
                    viewBox: _objectSpread(_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            });
            _defineProperty(_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state7 = _this.state, offset = _this$state7.offset, dataStartIndex = _this$state7.dataStartIndex, dataEndIndex = _this$state7.dataEndIndex, updateId = _this$state7.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, _chartUtils.combineEventHandlers)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, _dataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
                    y: (0, _dataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, _dataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            _defineProperty(_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = _assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state8 = _this.state, xAxisMap = _this$state8.xAxisMap, yAxisMap = _this$state8.yAxisMap, offset = _this$state8.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            _defineProperty(_assertThisInitialized(_this), "renderActivePoints", function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = _objectSpread(_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, _chartUtils.getMainColorOfGraphicItem)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, _reactUtils.filterProps)(activeDot)), (0, _types.adaptEventHandlers)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, _objectSpread(_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            _defineProperty(_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state9 = _this.state, isTooltipActive = _this$state9.isTooltipActive, tooltipAxis = _this$state9.tooltipAxis, activeTooltipIndex = _this$state9.activeTooltipIndex, activeLabel = _this$state9.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide, activeBar = _item$item$props2.activeBar, activeShape = _item$item$props2.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, _dataUtils.findEntryInArray)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, _dataUtils.findEntryInArray)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, _isNilDefault.default)(activePoint)) return [
                            graphicalItem
                        ].concat(_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref13 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref13$graphicalItem = _ref13.graphicalItem, _ref13$graphicalItem$ = _ref13$graphicalItem.item, xyItem = _ref13$graphicalItem$ === void 0 ? element : _ref13$graphicalItem$, childIndex = _ref13$graphicalItem.childIndex;
                        var elementProps = _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, _react.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            _defineProperty(_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            _defineProperty(_assertThisInitialized(_this), "renderMap", {
                CartesianGrid: {
                    handler: _this.renderGrid,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: _this.renderReferenceElement
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: _this.renderXAxis
                },
                YAxis: {
                    handler: _this.renderYAxis
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, _dataUtils.uniqueId)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, _throttleDefault.default)(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        _createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: // eslint-disable-next-line @typescript-eslint/no-empty-function
                function componentDidUpdate() {}
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, _reactUtils.findChildByType)(this.props.children, (0, _tooltip.Tooltip));
                    if (tooltipItem && Boolean(tooltipItem.props.shared)) {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, _domutils.getOffset)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state10 = this.state, xAxisMap = _this$state10.xAxisMap, yAxisMap = _this$state10.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, _dataUtils.getAnyElementOfObject)(xAxisMap).scale;
                        var yScale = (0, _dataUtils.getAnyElementOfObject)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return _objectSpread(_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return _objectSpread(_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state11 = this.state, angleAxisMap = _this$state11.angleAxisMap, radiusAxisMap = _this$state11.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, _dataUtils.getAnyElementOfObject)(angleAxisMap);
                        return (0, _polarUtils.inRangeOfSector)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, _types.adaptEventHandlers)(this.props, this.handleOuterEvent);
                    return _objectSpread(_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, _events.eventCenter).on((0, _events.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, _events.eventCenter).removeListener((0, _events.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, _reactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cartesianAxis.CartesianAxis), _extends({}, axisOptions, {
                        className: (0, _clsxDefault.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref14) {
                        var _ref15 = _slicedToArray(_ref14, 2), axisId = _ref15[0], axisProps = _ref15[1];
                        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref16) {
                        var _ref17 = _slicedToArray(_ref16, 2), axisId = _ref17[0], axisProps = _ref17[1];
                        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state12 = this.state, formattedGraphicalItems = _this$state12.formattedGraphicalItems, activeItem = _this$state12.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, _reactUtils.getDisplayName)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, _rectangle.isInRectangle)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, _polarUtils.inRangeOfSector)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, _activeShapeUtils.isFunnel)(graphicalItem, activeItem) || (0, _activeShapeUtils.isPie)(graphicalItem, activeItem) || (0, _activeShapeUtils.isScatter)(graphicalItem, activeItem)) {
                            var activeIndex = (0, _activeShapeUtils.getActiveShapeIndexForTooltip)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: item.props.data
                            });
                            var childIndex = item.props.activeIndex === undefined ? activeIndex : item.props.activeIndex;
                            return {
                                graphicalItem: _objectSpread(_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, _activeShapeUtils.isScatter)(graphicalItem, activeItem) ? item.props.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, _reactUtils.validateWidthHeight)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = _objectWithoutProperties(_this$props6, _excluded2);
                    var attrs = (0, _reactUtils.filterProps)(others);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, _reactUtils.renderByOrder)(children, this.renderMap));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'img';
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
                        className: (0, _clsxDefault.default)('recharts-wrapper', className),
                        style: _objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        },
                        role: "region"
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, _reactUtils.renderByOrder)(children, this.renderMap)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, _react.Component)), _defineProperty(_class, "displayName", chartName), _defineProperty(_class, "defaultProps", _objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps)), _defineProperty(_class, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        if (prevState.updateId === undefined) {
            var defaultState = createDefaultState(nextProps);
            return _objectSpread(_objectSpread(_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, _shallowEqual.shallowEqual)(margin, prevState.prevMargin)) {
            var _defaultState = createDefaultState(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = _objectSpread(_objectSpread({}, getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = _objectSpread(_objectSpread(_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return _objectSpread(_objectSpread(_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, _reactUtils.isChildrenEqual)(children, prevState.prevChildren)) {
            // update configuration in children
            var hasGlobalData = !(0, _isNilDefault.default)(data);
            var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
            return _objectSpread(_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId
            }), prevState)), {}, {
                prevChildren: children
            });
        }
        return null;
    }), _defineProperty(_class, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, _react.isValidElement)(option)) dot = /*#__PURE__*/ (0, _react.cloneElement)(option, props);
        else if ((0, _isFunctionDefault.default)(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), props);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _class;
};

},{"react":"9njXz","lodash/isNil":"eS6AM","lodash/isFunction":"3A7xI","lodash/range":"3NTTt","lodash/get":"dBTJh","lodash/sortBy":"4paFu","lodash/throttle":"7IlSK","lodash/find":"doA9Z","lodash/every":"drZyD","clsx":"d2NWs","tiny-invariant":"cKzLp","../util/cursor/getRadialCursorPoints":"6Kf9D","../cartesian/getTicks":"gZ70X","../container/Surface":"l5HV0","../container/Layer":"4Q0HG","../component/Tooltip":"lILc1","../component/Legend":"dkfOy","../shape/Curve":"hqiOr","../shape/Cross":"5qFSP","../shape/Sector":"bmvhw","../shape/Dot":"44jal","../shape/Rectangle":"icCgC","../util/ReactUtils":"lj4u0","../cartesian/CartesianAxis":"iRtii","../cartesian/Brush":"jFSUR","../util/DOMUtils":"7SjCz","../util/DataUtils":"5VTG4","../util/ChartUtils":"24GXn","../util/DetectReferenceElementsDomain":"aJTiy","../util/PolarUtils":"eBFiJ","../util/ShallowEqual":"5DwJA","../util/Events":"fcjWX","../util/types":"c9QyM","./AccessibilityManager":"2q46K","../util/isDomainSpecifiedByUser":"SkHyI","../util/ActiveShapeUtils":"fo3nx","../util/cursor/getCursorPoints":"eZKpY","../util/cursor/getCursorRectangle":"gtHBd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"doA9Z":[function(require,module,exports,__globalThis) {
var createFind = require("f180f4459f295340"), findIndex = require("5af87c887948f3ca");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find = createFind(findIndex);
module.exports = find;

},{"f180f4459f295340":"32Tng","5af87c887948f3ca":"a58Ph"}],"32Tng":[function(require,module,exports,__globalThis) {
var baseIteratee = require("ad0cafc4de9b66e6"), isArrayLike = require("cfacddc571674e4b"), keys = require("847fe2f1205991cd");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = createFind;

},{"ad0cafc4de9b66e6":"6jZAq","cfacddc571674e4b":"kzICo","847fe2f1205991cd":"9qKxr"}],"a58Ph":[function(require,module,exports,__globalThis) {
var baseFindIndex = require("c4739d82cf87a9be"), baseIteratee = require("a250b62014668b1"), toInteger = require("8b47b48a148e503b");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) index = nativeMax(length + index, 0);
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;

},{"c4739d82cf87a9be":"9mWam","a250b62014668b1":"6jZAq","8b47b48a148e503b":"fCKw5"}],"6Kf9D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Only applicable for radial layouts
 * @param {Object} activeCoordinate ChartCoordinate
 * @returns {Object} RadialCursorPoints
 */ parcelHelpers.export(exports, "getRadialCursorPoints", ()=>getRadialCursorPoints);
var _polarUtils = require("../PolarUtils");
function getRadialCursorPoints(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, startAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}

},{"../PolarUtils":"eBFiJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJTiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectReferenceElementsDomain", ()=>detectReferenceElementsDomain);
var _referenceDot = require("../cartesian/ReferenceDot");
var _referenceLine = require("../cartesian/ReferenceLine");
var _referenceArea = require("../cartesian/ReferenceArea");
var _ifOverflowMatches = require("./IfOverflowMatches");
var _reactUtils = require("./ReactUtils");
var _dataUtils = require("./DataUtils");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, _reactUtils.findAllByType)(children, (0, _referenceLine.ReferenceLine));
    var dots = (0, _reactUtils.findAllByType)(children, (0, _referenceDot.ReferenceDot));
    var elements = [].concat(_toConsumableArray(lines), _toConsumableArray(dots));
    var areas = (0, _reactUtils.findAllByType)(children, (0, _referenceArea.ReferenceArea));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, _ifOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _dataUtils.isNumber)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, _ifOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _dataUtils.isNumber)(el.props[key1]) && (0, _dataUtils.isNumber)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, _dataUtils.isNumber)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};

},{"../cartesian/ReferenceDot":"4nujU","../cartesian/ReferenceLine":"hYVuF","../cartesian/ReferenceArea":"izrp6","./IfOverflowMatches":"4CJ5E","./ReactUtils":"lj4u0","./DataUtils":"5VTG4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fcjWX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventCenter", ()=>eventCenter);
parcelHelpers.export(exports, "SYNC_EVENT", ()=>SYNC_EVENT);
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
var eventCenter = new (0, _eventemitter3Default.default)();
var SYNC_EVENT = 'recharts.syncMouseEvents';

},{"eventemitter3":"8CDPR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8CDPR":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"2q46K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessibilityManager", ()=>AccessibilityManager);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var AccessibilityManager = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        _classCallCheck(this, AccessibilityManager);
        _defineProperty(this, "activeIndex", 0);
        _defineProperty(this, "coordinateList", []);
        _defineProperty(this, "layout", 'horizontal');
    }
    _createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? [] : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList;
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"SkHyI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */ parcelHelpers.export(exports, "isDomainSpecifiedByUser", ()=>isDomainSpecifiedByUser);
var _dataUtils = require("./DataUtils");
function isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, _dataUtils.isNumber)(domainStart) && (0, _dataUtils.isNumber)(domainEnd)) return true;
    }
    return false;
}

},{"./DataUtils":"5VTG4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eZKpY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorPoints", ()=>getCursorPoints);
var _polarUtils = require("../PolarUtils");
var _getRadialCursorPoints = require("./getRadialCursorPoints");
function getCursorPoints(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
            var outerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}

},{"../PolarUtils":"eBFiJ","./getRadialCursorPoints":"6Kf9D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtHBd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorRectangle", ()=>getCursorRectangle);
function getCursorRectangle(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gCfwf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Inputs", ()=>Inputs);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _list = require("./List");
var _edit = require("./Edit");
const Inputs = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).UPDATE,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).NEW,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).COPY,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.List), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","./List":"jmuAJ","./Edit":"7E6Sj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7E6Sj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEditType", ()=>useEditType);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _mergeWith = require("lodash/mergeWith");
var _mergeWithDefault = parcelHelpers.interopDefault(_mergeWith);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _omitBy = require("lodash/omitBy");
var _omitByDefault = parcelHelpers.interopDefault(_omitBy);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var _constants = require("common/constants");
var _types = require("common/api/v1/types");
var _inputsActions = require("../../../redux/actions/inputsActions");
var _store = require("../../../store");
var _utils = require("../../../utils");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _ipPortForm = require("./PortForm/IpPortForm");
var _inputForm = require("./InputForm");
var _inputFormDefault = parcelHelpers.interopDefault(_inputForm);
var _nmTypes = require("../../../api/nm-types");
var _base = require("../../common/Interface/Base");
var _helpers = require("common/api/v1/helpers");
var _notificationActions = require("../../../redux/actions/notificationActions");
var _utils1 = require("common/utils");
var _env = require("../../../env");
var _form = require("../../common/Form");
var _reactAsyncHook = require("react-async-hook");
const useEditType = ()=>{
    const routes = (0, _store.useRoutes)();
    const matchNew = (0, _reactRouter.useMatch)(routes.inputsNew.route);
    const matchUpdate = (0, _reactRouter.useMatch)(routes.inputsUpdate.route);
    const matchCopy = (0, _reactRouter.useMatch)(routes.inputsCopy.route);
    const type = matchNew ? 'new' : matchUpdate ? 'update' : matchCopy ? 'copy' : null;
    if (!type) throw new Error('Invalid route');
    return (0, _react.useMemo)(()=>({
            type,
            isNew: type === 'new',
            isUpdate: type === 'update',
            isCopy: type === 'copy'
        }), [
        type
    ]);
};
const getInitialState = (selectedInput, editType, pageParams, settings, parentInput)=>{
    const broadcastStandard = parentInput?.broadcastStandard || selectedInput?.broadcastStandard || settings?.defaultBroadcastStandard || 'dvb';
    const handoverMethod = parentInput?.handoverMethod || selectedInput?.handoverMethod || settings?.defaultHandoverMethod || 'udp';
    const receiver = {
        name: '',
        maxBitrateMbps: selectedInput?.maxBitrate && selectedInput?.maxBitrate / 10 ** 6 || '',
        tr101290Enabled: true,
        broadcastStandard: selectedInput?.tr101290Enabled === false ? 'none' : broadcastStandard,
        thumbnailMode: (0, _types.ThumbnailMode).edge,
        videoPreviewMode: selectedInput?.previewSettings?.mode || ((0, _env.REACT_APP_EDGE_PRODUCT) === (0, _constants.PRODUCTS).nimbraEdge.id ? (0, _types.VideoPreviewMode).ondemand : (0, _types.VideoPreviewMode).off),
        adminStatus: true,
        unhealthyAlarm: selectedInput?.unhealthyAlarm || '',
        ports: [],
        downstreamAppliances: [],
        handoverMethod,
        _redundant: !!(selectedInput?.ports?.[0]?.copies === 2),
        bufferSize: 6000,
        deriveFrom: {
            ingestTransform: selectedInput?.deriveFrom?.ingestTransform || {
                type: '',
                services: []
            },
            parentInput: pageParams.deriveFrom || selectedInput?.deriveFrom?.parentInput || ''
        },
        transcodeTotalBitrateMbps: selectedInput?.deriveFrom?.ingestTransform?.type === 'transcode' && selectedInput?.deriveFrom?.ingestTransform.ffmpegParams.bitrate ? selectedInput?.deriveFrom?.ingestTransform.ffmpegParams.bitrate / 1000000 : '',
        transcodeVideoBitrateMbps: selectedInput?.deriveFrom?.ingestTransform?.type === 'transcode' && selectedInput?.deriveFrom?.ingestTransform.ffmpegParams.videoBitrate ? selectedInput?.deriveFrom?.ingestTransform.ffmpegParams.videoBitrate / 1000000 : '',
        transcodeAudioBitrateKbps: selectedInput?.deriveFrom?.ingestTransform?.type === 'transcode' && selectedInput?.deriveFrom?.ingestTransform.ffmpegParams.audioBitrate ? selectedInput?.deriveFrom?.ingestTransform.ffmpegParams.audioBitrate / 1000 : '',
        parentInput: '',
        _derived: !!selectedInput?.deriveFrom?.parentInput || !!pageParams.deriveFrom
    };
    (0, _mergeWithDefault.default)(receiver, (0, _omitDefault.default)(selectedInput, [
        'metrics',
        'alarms',
        'broadcastStandard'
    ]), (_, existingValueForKey, key)=>{
        if (key === 'adminStatus') return existingValueForKey === (0, _types.InputAdminStatus).on;
        if (key === 'ports') {
            const failoverPriorities = existingValueForKey.map((p)=>p.failoverPriority).filter((p)=>typeof p === 'number');
            const numDistinctFailoverPriorities = new Set(failoverPriorities).size;
            return existingValueForKey.map((port)=>(0, _mergeWithDefault.default)((0, _inputForm.initialInputLogicalPort)({
                    physicalPortId: port.physicalPort,
                    port: port._port,
                    numDistinctFailoverPriorities
                }), port, (_, existingValueForKey2, key2)=>{
                    if ('totalBitrate' === key2 && existingValueForKey2) return existingValueForKey2 / 1000000 // bps --> Mbps
                    ;
                    if ('reducedBitrateThreshold' === key2 && existingValueForKey2) return existingValueForKey2 / 1000;
                    if ('whitelistCidrBlock' === key2 && existingValueForKey2) // EDGE-3975: Use array-representation rather than string representation to avoid
                    // dialog "You have some unsaved data, do you really want to leave the page?"
                    // due to initialValues !== values despite no changes being made.
                    return (0, _utils1.whitelistCidrBlockToArray)(existingValueForKey2);
                }));
        }
    });
    if (editType.isCopy) receiver.name += ' (copy)';
    if (receiver.ports) {
        for (const port of receiver.ports)if (port.encoderSettings && typeof port.encoderSettings.gopStructure === 'undefined') port.encoderSettings.gopStructure = '';
    }
    // 1. Divide ports into groups by their appliance or region, using key '_applianceSection-${id}'
    // 2. We will later create one <ApplianceSection> per group, passing the above key as namePrefix
    // 3. Each ApplianceSection and sub-component modifies their nameprefix-XXX entry
    // 4. When the user submits, we will merge each namePrefix-entry back into the 'ports' again
    const portsGroupedByApplianceOrRegion = (0, _base.groupPortsByApplianceOrRegion)(receiver.ports);
    return {
        ...receiver,
        [(0, _base.APPLIANCE_SECTION_FORM_PREFIX)]: portsGroupedByApplianceOrRegion
    };
};
const Edit = ()=>{
    const { id: inputId } = (0, _reactRouter.useParams)();
    const editType = useEditType();
    const [parameters] = (0, _utils.usePageParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const [parentInput, setParentInput] = (0, _react.useState)(null);
    const { result: selectedInput, error: fetchInputError, loading: isFetchingInput } = (0, _reactAsyncHook.useAsync)(()=>{
        return inputId ? (0, _store.Api).inputApi.getInput(inputId).catch((err)=>{
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: err,
                operation: 'fetch input'
            }));
            throw err;
        }) : Promise.resolve(undefined);
    }, [
        dispatch,
        inputId
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            dispatch((0, _inputsActions.clearInputFormErrors)());
        };
    }, [
        dispatch,
        inputId
    ]);
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    (0, _react.useEffect)(()=>{
        if (parameters.deriveFrom) (0, _store.Api).inputApi.getInput(parameters.deriveFrom).then((input)=>{
            setParentInput(input);
        }).catch((err)=>{
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: err,
                operation: 'fetch parent input'
            }));
        });
    }, [
        parameters.deriveFrom
    ]);
    const { settings } = (0, _utils.useSettingsSelector)();
    const initialState = getInitialState(selectedInput, editType, parameters, settings, parentInput);
    const onSubmit = (input)=>{
        const action = ()=>dispatch((0, _inputsActions.updateInput)(input));
        if (selectedInput && editType.isUpdate) {
            if (selectedInput.numOutputs) showConfirmation(()=>{
                action();
            }, 'Current input is in use! Are you sure you want to edit it?');
            else action();
        } else dispatch((0, _inputsActions.createInput)((0, _omitDefault.default)(input, [
            'id'
        ])));
    };
    const isLoading = isFetchingInput || Boolean(parameters.deriveFrom) && !parentInput;
    const transformPIDMapRules = (rules)=>{
        return rules.map((r)=>{
            switch(r.action){
                case (0, _types.PIDRuleAction).Map:
                    return {
                        action: r.action,
                        pid: r.pid,
                        destPid: r.destPid
                    };
                case (0, _types.PIDRuleAction).Delete:
                    return {
                        action: r.action,
                        pid: r.pid
                    };
                case (0, _types.PIDRuleAction).SetNull:
                    return {
                        action: r.action,
                        pid: r.pid
                    };
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Inputs',
            inputId ? selectedInput?.name : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: isLoading,
            children: fetchInputError ? 'Failed fetching input' : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                component: (0, _inputFormDefault.default),
                defaultValues: initialState,
                onSubmit: (values)=>{
                    values.ports = (0, _base.collectPortsFromApplianceSections)(values);
                    const hasEncoderSettings = values.ports.some((p)=>{
                        const applianceFeatures = p._port?._appliance?.features ?? p._port?.appliance?.features;
                        const modesWithEncoderSettings = applianceFeatures?.input?.modes.filter((m)=>!!m.encoder).map((m)=>m.mode) ?? [];
                        return modesWithEncoderSettings.includes(p.mode);
                    });
                    const transformed = (0, _utils.formTransform)(values, {
                        deriveFrom: {
                            _transform: (deriveFrom)=>{
                                if (!deriveFrom?.parentInput || !values._derived || !deriveFrom.ingestTransform) return undefined;
                                if (deriveFrom.ingestTransform.type === 'mpts-demux') {
                                    const services = (0, _utils1.distinct)(Object.assign(deriveFrom.ingestTransform?.services ?? [])// pid is a number when coming from backend and a string when coming from RHF
                                    .map((pid)=>parseInt(pid.toString())).filter((pidOrNaN)=>!isNaN(pidOrNaN)));
                                    const ingestTransform = {
                                        ...deriveFrom.ingestTransform,
                                        type: 'mpts-demux',
                                        services
                                    };
                                    // Map PID map rules to avoid sending destPid to API when not applicable
                                    // Fallback to empty rules array if pidMap is undefined
                                    const pidMap = ingestTransform.pidMap;
                                    ingestTransform.pidMap = pidMap !== undefined ? {
                                        ...pidMap,
                                        rules: transformPIDMapRules(pidMap.rules)
                                    } : {
                                        rules: []
                                    };
                                    return {
                                        ...deriveFrom,
                                        // Handover delay
                                        delay: 1000,
                                        ingestTransform: ingestTransform
                                    };
                                }
                                if (deriveFrom.ingestTransform.type === 'transcode' || deriveFrom.ingestTransform.type === 'audio-reshuffling') return {
                                    ...deriveFrom,
                                    // Handover delay
                                    delay: 1000
                                };
                                return undefined;
                            }
                        },
                        videoPreviewMode: {
                            _transform: (val)=>values.thumbnailMode ? val : (0, _types.VideoPreviewMode).off
                        },
                        adminStatus: {
                            _transform: (val)=>val ? (0, _types.InputAdminStatus).on : (0, _types.InputAdminStatus).off
                        },
                        ports: {
                            reducedBitrateThreshold: {
                                _transform: (bitrate)=>bitrate === '' ? undefined : bitrate * 1000
                            },
                            encoderSettings: {
                                _transform: (es)=>!hasEncoderSettings ? undefined : es,
                                totalBitrate: {
                                    _transform: (bitrate)=>bitrate === '' ? undefined : bitrate * 1000000
                                },
                                gopStructure: {
                                    _transform: (gopStructure)=>gopStructure === '' ? undefined : gopStructure
                                },
                                audioStreams: {
                                    // TODO: Codec AES3 does not support bitrate but it is a required property.
                                    _transform: (audioStream)=>({
                                            ...audioStream,
                                            bitrate: audioStream.bitrate || -1
                                        })
                                }
                            },
                            _transform: (port)=>{
                                if (!port?.physicalPort) return undefined;
                                const result = (0, _helpers.isIpPort)(port) ? (0, _pickDefault.default)(port, (0, _ipPortForm.getIpPortFormFields)(port)) : port.mode === (0, _types.ComprimatoPortMode).comprimatoNdi ? (0, _pickDefault.default)(port, [
                                    (0, _ipPortForm.CommonFields).physicalPort,
                                    (0, _ipPortForm.CommonFields).mode,
                                    (0, _ipPortForm.CommonFields).copies,
                                    'id',
                                    'name'
                                ]) : (0, _pickDefault.default)(port, [
                                    (0, _ipPortForm.CommonFields).physicalPort,
                                    (0, _ipPortForm.CommonFields).mode,
                                    (0, _ipPortForm.CommonFields).copies,
                                    'id',
                                    'encoderSettings'
                                ]);
                                result.copies = values._redundant ? 2 : 1;
                                const omittedFields = [
                                    'region.allocatedAppliance'
                                ];
                                if (port.mode === (0, _types.IpPortMode).generator && typeof port.port !== 'number') // TODO: Remove this when we expect all generators created before R3.14.0 have been updated.
                                omittedFields.push('address');
                                return {
                                    ...(0, _omitDefault.default)(result, omittedFields)
                                };
                            }
                        },
                        _transform: (input)=>(0, _omitByDefault.default)(input, (_value, key)=>key.startsWith('_'))
                    });
                    if (values._derived) transformed.ports = undefined;
                    // Enable rtp-over-srt for all srt ports if true for one port
                    const isRtpOverSrt = !!transformed.ports && transformed.ports.some((p)=>p.mode === (0, _types.IpPortMode).srt && !!p.rtp);
                    if (isRtpOverSrt) {
                        for (const p of transformed.ports)if (p.mode === (0, _types.IpPortMode).srt) p.rtp = true;
                    }
                    if (transformed.ports?.length > 1 && transformed.ports?.[0]?.mode === (0, _types.IpPortMode).srt) {
                        let failoverPriority = undefined;
                        const bondingMode = values.ports[0].bondingMode;
                        if (bondingMode !== (0, _nmTypes.SrtBondingMode).none) failoverPriority = 0;
                        for (const p of transformed.ports){
                            if (p.mode === (0, _types.IpPortMode).srt && p.srtMode !== (0, _types.SrtMode).rendezvous) p.failoverPriority = failoverPriority;
                            if (bondingMode === (0, _nmTypes.SrtBondingMode).activeBackup) failoverPriority += 1;
                        }
                    }
                    if ((values.broadcastStandard || 'none') === 'none') {
                        transformed.tr101290Enabled = false;
                        transformed.broadcastStandard = undefined;
                    } else transformed.tr101290Enabled = true;
                    if (!transformed.unhealthyAlarm) transformed.unhealthyAlarm = null;
                    delete transformed.maxBitrate;
                    transformed.maxBitrate = transformed.maxBitrateMbps ? transformed.maxBitrateMbps * 10 ** 6 : null;
                    if (transformed?.deriveFrom?.ingestTransform?.type === 'transcode') {
                        if (!transformed.deriveFrom.ingestTransform.ffmpegParams) transformed.deriveFrom.ingestTransform.ffmpegParams = {};
                        transformed.deriveFrom.ingestTransform.ffmpegParams.bitrate = transformed.transcodeTotalBitrateMbps ? transformed.transcodeTotalBitrateMbps * 1000000 : undefined;
                        transformed.deriveFrom.ingestTransform.ffmpegParams.videoBitrate = transformed.transcodeVideoBitrateMbps ? transformed.transcodeVideoBitrateMbps * 1000000 : undefined;
                        transformed.deriveFrom.ingestTransform.ffmpegParams.audioBitrate = transformed.transcodeAudioBitrateKbps ? transformed.transcodeAudioBitrateKbps * 1000 : undefined;
                    }
                    onSubmit(transformed);
                }
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","lodash/mergeWith":"40Q54","lodash/omit":"fhxvC","lodash/omitBy":"38wzK","lodash/pick":"5kPds","common/constants":"bdiC1","common/api/v1/types":"3qemx","../../../redux/actions/inputsActions":"l0Ua8","../../../store":"5LXiG","../../../utils":"342UB","../../common/Pendable":"gDN67","../../common/Wrapper":"8oy7r","./PortForm/IpPortForm":"mlnEQ","./InputForm":"49oSK","../../../api/nm-types":"bcYl5","../../common/Interface/Base":"gmIdH","common/api/v1/helpers":"6jovr","../../../redux/actions/notificationActions":"7LkQg","common/utils":"2AqiH","../../../env":"cPu8n","../../common/Form":"4Mui7","react-async-hook":"3D6Y9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"40Q54":[function(require,module,exports,__globalThis) {
var baseMerge = require("534a42b3db0d10f3"), createAssigner = require("1dd402ac842b0276");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
module.exports = mergeWith;

},{"534a42b3db0d10f3":"1n4LL","1dd402ac842b0276":"e0xvq"}],"1n4LL":[function(require,module,exports,__globalThis) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"cltFt","76e9fd6386317324":"e0LII","e7dca58bcfe9c669":"9oLrx","4ea46d88599071ec":"8JjIw","c52c932be04280cc":"6hgJK","27adf66142f57b4b":"6emcB","564385b2292facea":"34puL"}],"e0LII":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"ba13n","7d9c95e1ffdd4f16":"evtiM"}],"8JjIw":[function(require,module,exports,__globalThis) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"e0LII","ec8e1b90277c5e12":"aNaSh","4b1a2b5090faf247":"WFexx","d7675bdf0a02bffc":"lWbYv","1067a6f3f6bd5986":"fGkGx","2238139506f6727b":"bpegN","290c774b41e416bb":"1DVeR","f481819c40e5b527":"gamaN","6532fda6a198015f":"26W2O","7f306c94b573f977":"3A7xI","32c89e763261c579":"6hgJK","ff359d315efefc4f":"lCxAG","61ce92c01fd411fe":"hq5rz","abfa8f7e72201edb":"34puL","c54d414b219fa287":"i8tDZ"}],"gamaN":[function(require,module,exports,__globalThis) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"kzICo","639a4883b097af28":"4gOki"}],"34puL":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = safeGet;

},{}],"i8tDZ":[function(require,module,exports,__globalThis) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"vDc33","437a3e3814017158":"6emcB"}],"e0xvq":[function(require,module,exports,__globalThis) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"5w1TW","4f5832110eba92d3":"gTLnH"}],"38wzK":[function(require,module,exports,__globalThis) {
var baseIteratee = require("4f51b0fed4eb5815"), negate = require("2e30ffcdce37b156"), pickBy = require("8525cfbf72d27786");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function omitBy(object, predicate) {
    return pickBy(object, negate(baseIteratee(predicate)));
}
module.exports = omitBy;

},{"4f51b0fed4eb5815":"6jZAq","2e30ffcdce37b156":"jGMru","8525cfbf72d27786":"jfoze"}],"jGMru":[function(require,module,exports,__globalThis) {
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = negate;

},{}],"jfoze":[function(require,module,exports,__globalThis) {
var arrayMap = require("6fd113b3f5002de4"), baseIteratee = require("1e32e0d8feab18e"), basePickBy = require("85ba60b03da46517"), getAllKeysIn = require("86922ee5dcf85621");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function pickBy(object, predicate) {
    if (object == null) return {};
    var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = baseIteratee(predicate);
    return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = pickBy;

},{"6fd113b3f5002de4":"chzeu","1e32e0d8feab18e":"6jZAq","85ba60b03da46517":"369pd","86922ee5dcf85621":"iZ6gY"}],"369pd":[function(require,module,exports,__globalThis) {
var baseGet = require("d8aa974fba65e61e"), baseSet = require("b07dbab95dca4167"), castPath = require("64b51364f27b9088");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"d8aa974fba65e61e":"5Vkba","b07dbab95dca4167":"7efHu","64b51364f27b9088":"1tEcE"}],"7efHu":[function(require,module,exports,__globalThis) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"aKTSf","56e0b8a492d56399":"1tEcE","d1eb8acc5a65dc38":"bxLaX","dfb182b16ef275c0":"6hgJK","6a51dc787ca5b6e3":"b5swP"}],"5kPds":[function(require,module,exports,__globalThis) {
var basePick = require("e13834df88faab8"), flatRest = require("7f4b4cdb31764f87");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
});
module.exports = pick;

},{"e13834df88faab8":"kT10w","7f4b4cdb31764f87":"j0z0i"}],"kT10w":[function(require,module,exports,__globalThis) {
var basePickBy = require("4620eb0b3c4f1463"), hasIn = require("c697490fd5f67a25");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function basePick(object, paths) {
    return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
    });
}
module.exports = basePick;

},{"4620eb0b3c4f1463":"369pd","c697490fd5f67a25":"105Hu"}],"mlnEQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "udpDefaults", ()=>(0, _udpForm.udpDefaults));
parcelHelpers.export(exports, "rtpDefaults", ()=>(0, _rtpForm.rtpDefaults));
parcelHelpers.export(exports, "srtDefaults", ()=>(0, _srtForm.srtDefaults));
parcelHelpers.export(exports, "ristDefaults", ()=>(0, _ristForm.ristDefaults));
parcelHelpers.export(exports, "zixiDefaults", ()=>(0, _zixiForm.zixiDefaults));
parcelHelpers.export(exports, "generatorDefaults", ()=>(0, _generatorForm.generatorDefaults));
parcelHelpers.export(exports, "CommonFields", ()=>CommonFields);
parcelHelpers.export(exports, "styles", ()=>styles);
parcelHelpers.export(exports, "getIpPortFormFields", ()=>getIpPortFormFields);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _udpForm = require("./UdpForm");
var _udpFormDefault = parcelHelpers.interopDefault(_udpForm);
var _rtpForm = require("./RtpForm");
var _rtpFormDefault = parcelHelpers.interopDefault(_rtpForm);
var _srtForm = require("./SrtForm");
var _srtFormDefault = parcelHelpers.interopDefault(_srtForm);
var _zixiForm = require("./ZixiForm");
var _zixiFormDefault = parcelHelpers.interopDefault(_zixiForm);
var _ristForm = require("./RistForm");
var _ristFormDefault = parcelHelpers.interopDefault(_ristForm);
var _generatorForm = require("./GeneratorForm");
var _generatorFormDefault = parcelHelpers.interopDefault(_generatorForm);
var _rtmpForm = require("../../../../inputs/Edit/PortForm/IpPortForm/RtmpForm");
var _rtmpFormDefault = parcelHelpers.interopDefault(_rtmpForm);
var _ports = require("common/ports");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _reactHookForm = require("react-hook-form");
var CommonFields = /*#__PURE__*/ function(CommonFields) {
    CommonFields["mode"] = "mode";
    CommonFields["physicalPort"] = "physicalPort";
    CommonFields["copies"] = "copies";
    CommonFields["region"] = "region";
    CommonFields["applianceAllocationId"] = "applianceAllocationId";
    return CommonFields;
}({});
const styles = {
    warningText: {
        marginLeft: (theme)=>theme.spacing(1),
        color: (theme)=>theme.palette.warning.light
    }
};
const getIpPortFormFields = (port)=>{
    const common = [
        'id',
        "mode",
        "physicalPort",
        "copies",
        "region",
        "applianceAllocationId"
    ];
    if (port.mode === (0, _types.IpPortMode).udp) return [
        ...common,
        ...Object.keys((0, _udpForm.UdpFields))
    ];
    if (port.mode === (0, _types.IpPortMode).generator) return [
        ...common,
        ...Object.keys((0, _generatorForm.GeneratorFields))
    ];
    if (port.mode === (0, _types.IpPortMode).rtp) return [
        ...common,
        ...Object.keys((0, _rtpForm.RtpFields))
    ];
    if (port.mode === (0, _types.IpPortMode).rist) return [
        ...common,
        ...Object.keys((0, _ristForm.RistFields))
    ];
    if (port.mode === (0, _types.IpPortMode).zixi) return [
        ...common,
        ...(0, _zixiForm.getZixiFieldsToSave)(port)
    ];
    if (port.mode === (0, _types.IpPortMode).rtmp) return [
        ...common,
        ...Object.keys((0, _rtmpForm.RtmpFields))
    ];
    if (port.mode === (0, _types.IpPortMode).srt) {
        if (port.srtMode) return [
            ...common,
            ...(0, _srtForm.getSrtFieldsToSave)(port)
        ];
    }
    return [];
};
const IpPortForm = ({ addresses, applianceId, applianceType, applianceVersion, applianceFeatures, namePrefix, portIndex, occupiedPorts, isModeDisabled, onAddLogicalPortRequested })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const adminStatus = getValues('adminStatus') ? (0, _types.InputAdminStatus).on : (0, _types.InputAdminStatus).off;
    const handoverMethod = getValues('handoverMethod');
    const modeKey = `${namePrefix}.mode`;
    const currentIpPortMode = watch(modeKey);
    const modes = applianceFeatures.input?.modes.filter((m)=>m.mode in (0, _types.IpPortMode)).map((m)=>{
        const tooltipComponent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            sx: styles.warningText,
            variant: "body2",
            component: "span",
            children: "(CPU intensive - avoid on highly loaded video nodes)"
        });
        const tooltip = applianceType === (0, _types.ApplianceType).core && m.mode === (0, _types.IpPortMode).generator ? tooltipComponent : undefined;
        return {
            name: m.prettyName ?? m.mode,
            value: m.mode,
            tooltip
        };
    }) ?? [];
    const modeValues = modes.map((m)=>m.value);
    (0, _react.useEffect)(()=>{
        if (currentIpPortMode !== '') {
            const isValidMode = modes.some((m)=>m.value === currentIpPortMode);
            if (!isValidMode) setValue(modeKey, '');
        }
    }, [
        JSON.stringify(modeValues),
        currentIpPortMode,
        setValue,
        modeKey
    ]);
    const occupiedUdpPorts = occupiedPorts.filter((o)=>(0, _ports.isUdpBasedProtocol)(o.portMode));
    const occupiedTcpPorts = occupiedPorts.filter((o)=>(0, _ports.isTcpBasedProtocol)(o.portMode));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Mode",
                name: modeKey,
                newLine: true,
                required: true,
                disabled: isModeDisabled,
                options: modes,
                validators: {
                    oneOf: {
                        validValues: new Set(modeValues)
                    }
                }
            }),
            currentIpPortMode === (0, _types.IpPortMode).udp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _udpFormDefault.default), {
                namePrefix: namePrefix,
                addresses: addresses,
                applianceType: applianceType,
                occupiedPorts: occupiedUdpPorts,
                adminStatus: adminStatus
            }),
            currentIpPortMode === (0, _types.IpPortMode).rtp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtpFormDefault.default), {
                namePrefix: namePrefix,
                addresses: addresses,
                applianceType: applianceType,
                applianceVersion: applianceVersion,
                portIndex: portIndex,
                occupiedPorts: occupiedUdpPorts,
                adminStatus: adminStatus
            }),
            currentIpPortMode === (0, _types.IpPortMode).srt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _srtFormDefault.default), {
                namePrefix: namePrefix,
                applianceId: applianceId,
                applianceType: applianceType,
                applianceFeatures: applianceFeatures,
                portIndex: portIndex,
                addresses: addresses,
                occupiedPorts: occupiedUdpPorts,
                adminStatus: adminStatus,
                onAddLogicalPortRequested: onAddLogicalPortRequested
            }),
            currentIpPortMode === (0, _types.IpPortMode).rist && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ristFormDefault.default), {
                namePrefix: namePrefix,
                addresses: addresses,
                applianceType: applianceType,
                occupiedPorts: occupiedUdpPorts,
                adminStatus: adminStatus
            }),
            currentIpPortMode === (0, _types.IpPortMode).rtmp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtmpFormDefault.default), {
                namePrefix: namePrefix,
                addresses: addresses,
                applianceType: applianceType,
                occupiedPorts: occupiedTcpPorts,
                adminStatus: adminStatus
            }),
            currentIpPortMode === (0, _types.IpPortMode).zixi && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _zixiFormDefault.default), {
                applianceType: applianceType,
                applianceFeatures: applianceFeatures,
                applianceVersion: applianceVersion,
                namePrefix: namePrefix,
                addresses: addresses
            }),
            currentIpPortMode === (0, _types.IpPortMode).generator && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generatorFormDefault.default), {
                namePrefix: namePrefix,
                addresses: addresses,
                occupiedPorts: occupiedUdpPorts,
                adminStatus: adminStatus,
                handoverMethod: handoverMethod
            })
        ]
    });
};
exports.default = IpPortForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","./UdpForm":"5WU8I","./RtpForm":"1CwXR","./SrtForm":"kARbK","./ZixiForm":"2S94R","./RistForm":"aZU4b","./GeneratorForm":"bJIqn","../../../../inputs/Edit/PortForm/IpPortForm/RtmpForm":"bM9uI","common/ports":"5XehL","@mui/material/Typography":"6NtGx","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5WU8I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UdpFields", ()=>UdpFields);
parcelHelpers.export(exports, "udpDefaults", ()=>udpDefaults);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _whitelistCidrBlockAutoComplete = require("../../../../common/WhitelistCidrBlockAutoComplete");
var _suggestedPortTextField = require("../../../../common/SuggestedPortTextField");
var _reactHookForm = require("react-hook-form");
var UdpFields = /*#__PURE__*/ function(UdpFields) {
    UdpFields["address"] = "address";
    UdpFields["port"] = "port";
    UdpFields["multicastAddress"] = "multicastAddress";
    UdpFields["multicastSource"] = "multicastSource";
    UdpFields["whitelistCidrBlock"] = "whitelistCidrBlock";
    return UdpFields;
}({});
const udpDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(UdpFields), [], {
        ["whitelistCidrBlock"]: []
    });
const UdpForm = ({ addresses, namePrefix, applianceType, occupiedPorts, adminStatus })=>{
    const { getValues, setValue } = (0, _reactHookForm.useFormContext)();
    const getMulticast = ()=>({
            address: getValues(`${[
                namePrefix
            ]}.multicastAddress`),
            source: getValues(`${[
                namePrefix
            ]}.multicastSource`)
        });
    const { address, source } = getMulticast();
    const [isMulticast, setIsMulticast] = (0, _react.useState)(!!(address || source));
    const [multicast, setMulticast] = (0, _react.useState)(getMulticast());
    const addressSelector = `${namePrefix}.${"address"}`;
    const selectedSourceAddress = getValues(addressSelector);
    const portSelector = `${namePrefix}.${"port"}`;
    (0, _react.useEffect)(()=>{
        if (!isMulticast) {
            setMulticast(getMulticast());
            setValue(`${namePrefix}.${"multicastAddress"}`, '');
            setValue(`${namePrefix}.${"multicastSource"}`, '');
        } else {
            setValue(`${namePrefix}.${"multicastAddress"}`, multicast.address);
            setValue(`${namePrefix}.${"multicastSource"}`, multicast.source);
        }
    }, [
        isMulticast,
        setValue,
        namePrefix
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: addressSelector,
                label: "Address",
                required: true,
                options: (0, _utils.makeAddressOptions)(selectedSourceAddress, addresses),
                newLine: true,
                validators: {
                    addressIn: {
                        addresses
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _suggestedPortTextField.SuggestedLocalPortTextField), {
                name: portSelector,
                label: 'Port',
                namePrefix: namePrefix,
                required: true,
                portInfo: {
                    mode: (0, _types.IpPortMode).udp,
                    isInput: true,
                    isMulticast,
                    existingLogicalPortsOnSameNic: occupiedPorts,
                    isPortDisabled: adminStatus === (0, _types.InputAdminStatus).off
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: isMulticast,
                    onChange: (e)=>setIsMulticast(e.target.checked),
                    id: "multicast"
                }),
                label: "Is this port multicast?",
                newLine: true
            }),
            isMulticast && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"multicastAddress"}`,
                        label: "Multicast address",
                        validators: {
                            multicastAddress: {}
                        },
                        newLine: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"multicastSource"}`,
                        validators: {
                            ip: {}
                        },
                        label: "Source specific multicast address"
                    })
                ]
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _whitelistCidrBlockAutoComplete.WhitelistCidrBlockAutoComplete), {
                name: `${namePrefix}.${"whitelistCidrBlock"}`,
                required: (0, _utils.isCoreNode)(applianceType)
            })
        ]
    });
};
exports.default = UdpForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Checkbox":"ag1Z5","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","common/applianceTypeUtil":"3z9on","../../../../common/WhitelistCidrBlockAutoComplete":"91kUs","../../../../common/SuggestedPortTextField":"1iSAC","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"91kUs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WhitelistCidrBlockAutoComplete", ()=>WhitelistCidrBlockAutoComplete);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("./Form");
var _styles = require("@mui/material/styles");
var _texts = require("../../texts");
var _utils = require("common/utils");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
function getWarningText(cidrBlocks, isRequired) {
    if (cidrBlocks.length === 0 && !isRequired) return `Not selecting a value will allow all incoming traffic`;
    else if (cidrBlocks.includes((0, _texts.CIDR_BLOCK_ALLOW_ALL))) return `${0, _texts.CIDR_BLOCK_ALLOW_ALL} allows all incoming traffic`;
    return undefined;
}
const WhitelistCidrBlockAutoComplete = ({ name, required })=>{
    const theme = (0, _styles.useTheme)();
    const { getValues } = (0, _reactHookForm.useFormContext)();
    // Watch the value to dynamically get the updated cidrBlocks
    const cidrBlocks = (0, _utils.whitelistCidrBlockToArray)(getValues(name) || '');
    const warningText = getWarningText(cidrBlocks, required);
    const api = (0, _react.useCallback)(()=>{
        const options = Array.from(new Set([
            (0, _texts.CIDR_BLOCK_ALLOW_ALL),
            ...cidrBlocks
        ]));
        return Promise.resolve({
            items: options,
            total: options.length
        });
    }, [
        cidrBlocks
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
        name: name,
        label: `Whitelist CIDR blocks`,
        tooltip: (0, _texts.CIDRToolTip)(required, 'Input'),
        required: required,
        api: api,
        multiple: true,
        allowCustomOptions: true,
        validators: {
            ipv4CidrBlock: {}
        },
        filterSelectedOptions: true,
        comment: warningText,
        commentProps: {
            color: theme.palette.warning.light
        },
        defaultOption: cidrBlocks,
        getOptionValue: (option)=>option,
        getOptionLabel: (option)=>option,
        optionComparator: (o1, o2)=>o1 == o2,
        autoSelect: true,
        disableClearable: true
    });
};

},{"react/jsx-runtime":"1dlk8","./Form":"4Mui7","@mui/material/styles":"2UrBk","../../texts":"5m6xd","common/utils":"2AqiH","react":"9njXz","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5m6xd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CIDR_BLOCK_ALLOW_ALL", ()=>CIDR_BLOCK_ALLOW_ALL);
parcelHelpers.export(exports, "CIDRToolTip", ()=>CIDRToolTip);
const CIDR_BLOCK_ALLOW_ALL = '0.0.0.0/0';
const CIDRToolTip = (mandatory, entity)=>`Specifies which IP addresses are allowed to connect to this ${entity}. Example: 10.0.0.0/16. ${mandatory ? `To allow everything use ${CIDR_BLOCK_ALLOW_ALL}` : `To allow everything, leave blank or use ${CIDR_BLOCK_ALLOW_ALL}.`}`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1iSAC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "suggestAvailablePortNumbers", ()=>suggestAvailablePortNumbers);
parcelHelpers.export(exports, "SuggestedLocalPortTextField", ()=>SuggestedLocalPortTextField);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("./Form");
var _ports = require("common/ports");
var _types = require("common/api/v1/types");
var _arrays = require("common/arrays");
var _utils = require("../../utils");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
const reservedUdpPortNumbers = [
    ...(0, _arrays.generateNumericRange)((0, _ports.UDP_HANDOVER_PORT_RANGE_START), (0, _ports.UDP_HANDOVER_PORT_RANGE_END)),
    ...(0, _arrays.generateNumericRange)((0, _ports.UDP_TUNNEL_PORT_RANGE_START), (0, _ports.UDP_TUNNEL_PORT_RANGE_END))
];
const reservedTcpPortNumbers = [
    (0, _ports.TCP_EDGE_CONTROL_HTTP_PORT)
];
function suggestAvailablePortNumbers({ rangeStart, requestedMode, logicalPortsOnSameNic }) {
    const isUdp = (0, _ports.isUdpBasedProtocol)(requestedMode);
    const isTcp = (0, _ports.isTcpBasedProtocol)(requestedMode);
    const excludedPortNumbers = new Set(isUdp ? reservedUdpPortNumbers : isTcp ? reservedTcpPortNumbers : []);
    logicalPortsOnSameNic.forEach((lp)=>{
        const canConflict = isUdp && (0, _ports.isUdpBasedProtocol)(lp.portMode) || isTcp && (0, _ports.isTcpBasedProtocol)(lp.portMode);
        if (canConflict) lp.localPortNumbers.forEach((p)=>excludedPortNumbers.add(p));
    });
    const DEFAULT_START_RANGE = 10000;
    let suggestedStartRange = Math.abs(parseInt((rangeStart || DEFAULT_START_RANGE).toString()));
    if (!suggestedStartRange || isNaN(suggestedStartRange)) suggestedStartRange = DEFAULT_START_RANGE;
    while(suggestedStartRange < 1000)suggestedStartRange *= 10;
    const minAllowedPort = 1024;
    const maxAllowedPort = 65535;
    const startRange = Math.min(maxAllowedPort, Math.max(minAllowedPort, suggestedStartRange));
    const maxSuggestions = 5;
    const suggestedPortNumbers = new Set();
    for (const portNumber of (0, _arrays.generateNumericRange)(startRange, maxAllowedPort)){
        // Certain services such as FEC-enabled RTP inputs need multiple ports. An offset by 6 should be safe.
        const isDivisibleBySix = portNumber % 6 === 0;
        const isNearbyPortOccupied = (0, _arrays.generateNumericRange)(-5, 5).some((offset)=>excludedPortNumbers.has(portNumber + offset));
        if (isDivisibleBySix && !isNearbyPortOccupied) suggestedPortNumbers.add(portNumber);
        if (suggestedPortNumbers.size === maxSuggestions) break;
    }
    return Array.from(suggestedPortNumbers);
}
// Returns the logical ports in form.values for the Input/Output forms.
function useRequestedPortsOnSameNic(namePrefix, isInput) {
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    const portsNamePrefix = namePrefix.substr(0, namePrefix.length - 2) // _applianceSection.x.ports.0 --> _applianceSection.x.ports
    ;
    const port = getValues(namePrefix);
    const ports = getValues(portsNamePrefix) || [];
    const otherPortsOnSamePhysicalPort = ports.filter((p)=>p !== port && p.physicalPort === port.physicalPort);
    function fetchLogicalPortsFromForm() {
        return otherPortsOnSamePhysicalPort.map((p)=>({
                portMode: p.mode,
                logicalPortId: p.id ?? '',
                physicalPortId: p.physicalPort,
                inputId: isInput ? values.id : undefined,
                outputId: isInput ? undefined : values.id,
                isDisabled: false,
                localPortNumbers: isInput ? (0, _ports.getLocalPortNumbersUsedByInputPort)(p) : (0, _ports.getLocalPortNumbersUsedByOutputPort)(p)
            }));
    }
    const [requestedLogicalPorts, setRequestedLogicalPorts] = (0, _react.useState)(fetchLogicalPortsFromForm());
    (0, _react.useEffect)(()=>setRequestedLogicalPorts(fetchLogicalPortsFromForm()), [
        JSON.stringify(otherPortsOnSamePhysicalPort)
    ]);
    return requestedLogicalPorts;
}
const SuggestedLocalPortTextField = ({ name, label, namePrefix, portInfo, required })=>{
    const { field } = (0, _reactHookForm.useController)({
        name
    });
    const selectedBasePort = parseInt(field.value) || undefined;
    const localPortsUsed = selectedBasePort ? portInfo.isInput ? (0, _ports.getLocalPortNumbersUsedByInputProtocol)({
        ...portInfo,
        localBasePort: selectedBasePort,
        isFec: portInfo.isFec ?? false,
        isMulticast: portInfo.isMulticast ?? false,
        isRtcp: portInfo.isRtpRtcp ?? false
    }) : (0, _ports.getLocalPortNumbersUsedByOutputProtocol)({
        ...portInfo,
        localBasePort: selectedBasePort
    }) : [];
    const comment = localPortsUsed.length > 0 ? `The following local ports will be used: ${localPortsUsed.join(', ')}` : '';
    const requestedPortsOnSameNic = useRequestedPortsOnSameNic(namePrefix, portInfo.isInput);
    const logicalPortsOnSameNic = [
        ...requestedPortsOnSameNic,
        ...portInfo.existingLogicalPortsOnSameNic
    ];
    const api = (0, _react.useCallback)((params)=>{
        const rangeStart = Number(params.filter);
        return Promise.resolve((0, _utils.listResult)(suggestAvailablePortNumbers({
            rangeStart,
            requestedMode: portInfo.mode,
            logicalPortsOnSameNic
        })));
    }, [
        JSON.stringify(logicalPortsOnSameNic)
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
        name: name,
        label: label,
        type: 'number',
        required: required,
        groupBy: ()=>'Suggested available ports:',
        api: api,
        validators: {
            port: {
                disallowInternal: true,
                isUdp: (0, _ports.isUdpBasedProtocol)(portInfo.mode),
                even: portInfo.mode === (0, _types.IpPortMode).rist
            },
            isPortAvailable: {
                ...portInfo,
                existingLogicalPortsOnSameNic: logicalPortsOnSameNic
            }
        },
        comment: comment,
        defaultOption: selectedBasePort,
        getOptionValue: (option)=>Number(option),
        getOptionLabel: (option)=>option.toString(),
        optionComparator: (o1, o2)=>Number(o1) === Number(o2),
        autoSelect: false,
        allowCustomOptions: true,
        disableClearable: true
    });
};

},{"react/jsx-runtime":"1dlk8","./Form":"4Mui7","common/ports":"5XehL","common/api/v1/types":"3qemx","common/arrays":"8b5Z6","../../utils":"342UB","react":"9njXz","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8b5Z6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateNumericRange = generateNumericRange;
function generateNumericRange(start, end) {
    const result = [];
    for(let i = start; i <= end; i++)result.push(i);
    return result;
}

},{}],"1CwXR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RtpFields", ()=>RtpFields);
parcelHelpers.export(exports, "rtpDefaults", ()=>rtpDefaults);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _alert = require("@mui/material/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _versions = require("common/versions");
var _whitelistCidrBlockAutoComplete = require("../../../../common/WhitelistCidrBlockAutoComplete");
var _suggestedPortTextField = require("../../../../common/SuggestedPortTextField");
var _reactHookForm = require("react-hook-form");
var RtpFields = /*#__PURE__*/ function(RtpFields) {
    RtpFields["address"] = "address";
    RtpFields["port"] = "port";
    RtpFields["fec"] = "fec";
    RtpFields["multicastAddress"] = "multicastAddress";
    RtpFields["multicastSource"] = "multicastSource";
    RtpFields["whitelistCidrBlock"] = "whitelistCidrBlock";
    RtpFields["failoverPriority"] = "failoverPriority";
    return RtpFields;
}({});
const rtpDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(RtpFields), [
        "fec"
    ], {
        ["whitelistCidrBlock"]: []
    });
const RtpForm = ({ addresses, namePrefix, applianceType, applianceVersion, portIndex: _portIndex, occupiedPorts, adminStatus })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const isCoreAppliance = (0, _utils.isCoreNode)(applianceType);
    const rtpInputPort = getValues(namePrefix);
    const fecSelector = `${namePrefix}.${"fec"}`;
    const isRtcpEnabled = false // TODO: Make configurable when RTP RTCP is supported by ristserver
    ;
    const isFecEnabled = getValues(fecSelector);
    const showFecCheckbox = (0, _versions.supportsFec)(applianceType, applianceVersion);
    watch(fecSelector);
    const getMulticast = ()=>({
            address: rtpInputPort.multicastAddress,
            source: rtpInputPort.multicastSource
        });
    const { address, source } = getMulticast();
    const [isMulticast, setIsMulticast] = (0, _react.useState)(!!(address || source));
    const [multicast, setMulticast] = (0, _react.useState)(getMulticast());
    // Get all RTP ports across all appliance sections
    const getAllRtpPorts = ()=>{
        const allPorts = [];
        const formValues = getValues();
        // Check if _applianceSection exists and is an array
        if (formValues._applianceSection && Array.isArray(formValues._applianceSection)) formValues._applianceSection.forEach((section, sectionIndex)=>{
            if (section?.ports && Array.isArray(section.ports)) section.ports.forEach((p)=>{
                if (p.mode === (0, _types.IpPortMode).rtp) allPorts.push({
                    port: p,
                    sectionKey: `_applianceSection.${sectionIndex}`,
                    sectionIndex
                });
            });
        });
        return allPorts;
    };
    const allRtpPorts = getAllRtpPorts();
    // Extract section index from namePrefix (e.g., "_applianceSection.0.ports.1" -> 0)
    const currentSectionIndex = parseInt(namePrefix.match(/_applianceSection\.(\d+)/)?.[1] ?? '-1');
    // Show checkbox if this is not the first RTP port overall
    const isFirstRtpPort = ()=>{
        if (allRtpPorts.length === 0) return true;
        // Find current port in all RTP ports
        for(let i = 0; i < allRtpPorts.length; i++){
            const { port, sectionIndex } = allRtpPorts[i];
            // Check if this is an earlier section
            if (sectionIndex < currentSectionIndex) continue;
            // Same section - check port order
            if (sectionIndex === currentSectionIndex) {
                if (port === rtpInputPort) return i === 0 // First port overall
                ;
            }
        }
        return false;
    };
    const showDash7Checkbox = !isFirstRtpPort();
    const isDash7Redundant = typeof rtpInputPort.failoverPriority !== 'number';
    // Check if RTP ports are on different appliances
    const arePortsOnDifferentAppliances = allRtpPorts.length > 1 && new Set(allRtpPorts.map(({ sectionIndex })=>sectionIndex)).size > 1;
    // Check if RTP ports have different port numbers
    const havePortNumberMismatch = ()=>{
        if (!isDash7Redundant || allRtpPorts.length <= 1) return false;
        const rtpPortsWithoutFailover = allRtpPorts.filter(({ port })=>typeof port.failoverPriority !== 'number');
        if (rtpPortsWithoutFailover.length <= 1) return false;
        const portNumbers = new Set(rtpPortsWithoutFailover.map(({ port })=>port.port));
        return portNumbers.size > 1;
    };
    const addressSelector = `${namePrefix}.${"address"}`;
    const selectedSourceAddress = getValues(addressSelector);
    const portSelector = `${namePrefix}.${"port"}`;
    (0, _react.useEffect)(()=>{
        if (!isMulticast) {
            setMulticast(getMulticast());
            setValue(`${namePrefix}.${"multicastAddress"}`, '');
            setValue(`${namePrefix}.${"multicastSource"}`, '');
        } else {
            setValue(`${namePrefix}.${"multicastAddress"}`, multicast.address);
            setValue(`${namePrefix}.${"multicastSource"}`, multicast.source);
        }
    }, [
        isMulticast,
        setValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            showDash7Checkbox && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: "Identical RTP streams (SMPTE 2022-7)",
                tooltip: `Requires that all interfaces receive binary equal streams, e.g. from the same encoder. Can merge streams across different appliances.`,
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    id: `${namePrefix}.${"failoverPriority"}`,
                    name: `${namePrefix}.${"failoverPriority"}`,
                    checked: isDash7Redundant,
                    onChange: (e)=>{
                        // Update all RTP ports across all appliance sections
                        const formValues = getValues();
                        if (formValues._applianceSection && Array.isArray(formValues._applianceSection)) formValues._applianceSection.forEach((section, sectionIndex)=>{
                            if (section?.ports && Array.isArray(section.ports)) {
                                let rtpPortIndex = 0;
                                const updatedPorts = section.ports.map((port)=>{
                                    if (port.mode === (0, _types.IpPortMode).rtp) {
                                        const newPort = {
                                            ...port,
                                            ["failoverPriority"]: e.target.checked ? undefined : rtpPortIndex
                                        };
                                        rtpPortIndex++;
                                        return newPort;
                                    }
                                    return port;
                                });
                                setValue(`_applianceSection.${sectionIndex}.ports`, updatedPorts);
                            }
                        });
                    }
                })
            }),
            showDash7Checkbox && isDash7Redundant && arePortsOnDifferentAppliances && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                severity: havePortNumberMismatch() ? 'warning' : 'info',
                sx: {
                    mt: 1,
                    mb: 2
                },
                children: havePortNumberMismatch() ? "RTP streams will be merged across appliances into a single channel. Warning: Port numbers don't match - ensure streams are binary identical." : 'RTP streams will be merged across appliances into a single channel'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: addressSelector,
                label: "Address",
                required: true,
                options: (0, _utils.makeAddressOptions)(selectedSourceAddress, addresses),
                newLine: true,
                validators: {
                    addressIn: {
                        addresses
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _suggestedPortTextField.SuggestedLocalPortTextField), {
                name: portSelector,
                label: 'Port',
                namePrefix: namePrefix,
                required: true,
                portInfo: {
                    mode: (0, _types.IpPortMode).rtp,
                    isInput: true,
                    isFec: isFecEnabled,
                    isRtpRtcp: isRtcpEnabled,
                    isMulticast,
                    existingLogicalPortsOnSameNic: occupiedPorts,
                    isPortDisabled: adminStatus === (0, _types.InputAdminStatus).off
                }
            }),
            showFecCheckbox && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                name: fecSelector,
                label: "Use Forward Error Correction?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: isMulticast,
                    onChange: (e)=>setIsMulticast(e.target.checked),
                    id: `${namePrefix}.multicast`,
                    name: `${namePrefix}.multicast`
                }),
                label: "Is this port multicast?",
                newLine: true
            }),
            isMulticast && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"multicastAddress"}`,
                        label: "Multicast address",
                        validators: {
                            multicastAddress: {}
                        },
                        newLine: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"multicastSource"}`,
                        label: "Source specific multicast address",
                        validators: {
                            ip: {}
                        }
                    })
                ]
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _whitelistCidrBlockAutoComplete.WhitelistCidrBlockAutoComplete), {
                name: `${namePrefix}.${"whitelistCidrBlock"}`,
                required: isCoreAppliance
            })
        ]
    });
};
exports.default = RtpForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Checkbox":"ag1Z5","@mui/material/Alert":"8qQ0S","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","common/applianceTypeUtil":"3z9on","common/versions":"4vuwV","../../../../common/WhitelistCidrBlockAutoComplete":"91kUs","../../../../common/SuggestedPortTextField":"1iSAC","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vuwV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasSignedDownloads = hasSignedDownloads;
exports.supportsTtl = supportsTtl;
exports.supportsBufferedRtpOutput = supportsBufferedRtpOutput;
exports.supportsUdpOutputImportance = supportsUdpOutputImportance;
exports.usesMultipathPolicyFailover = usesMultipathPolicyFailover;
exports.supportsTr101290Toggling = supportsTr101290Toggling;
exports.supportsBroadcastStandard = supportsBroadcastStandard;
exports.supportsHandoverMethod = supportsHandoverMethod;
exports.supports12MTimecodeInsertion = supports12MTimecodeInsertion;
exports.supportsConfigurableGeneratorFrameRateAndResolution = supportsConfigurableGeneratorFrameRateAndResolution;
exports.supportsGeneratorPrograms = supportsGeneratorPrograms;
exports.supportsPriorityProperty = supportsPriorityProperty;
exports.supportsIndexProperty = supportsIndexProperty;
exports.supportsPIDMap = supportsPIDMap;
exports.supportsRtpForVaHandover = supportsRtpForVaHandover;
exports.supportsWhitelistCidrBlockAsArray = supportsWhitelistCidrBlockAsArray;
exports.supportsChannelGroups = supportsChannelGroups;
exports.supportsVersionMessage = supportsVersionMessage;
exports.supports400Errors = supports400Errors;
exports.supportsApplianceConfigMetaSection = supportsApplianceConfigMetaSection;
exports.supportsThumbnailingOnEdge = supportsThumbnailingOnEdge;
exports.supportsGeneratorBitrate = supportsGeneratorBitrate;
exports.supportsFec = supportsFec;
exports.supportsZixiAdaptiveFec = supportsZixiAdaptiveFec;
exports.supportsPcap = supportsPcap;
exports.supportsTranscoding = supportsTranscoding;
exports.supportsOverlays = supportsOverlays;
exports.supportsMulticastDerivedInputs = supportsMulticastDerivedInputs;
exports.supportsRtpOverSrt = supportsRtpOverSrt;
exports.supportsZixiZec = supportsZixiZec;
exports.supportsLegacyZixi = supportsLegacyZixi;
exports.supportsZixiForEdgeConnect = supportsZixiForEdgeConnect;
exports.supportsUnixSockets = supportsUnixSockets;
exports.supportsNewMulticastAddress = supportsNewMulticastAddress;
exports.supportsAdInsertion = supportsAdInsertion;
exports.supportsEphemeralTunnelSenderPorts = supportsEphemeralTunnelSenderPorts;
exports.supportsScteOnRtp = supportsScteOnRtp;
const types_1 = require("8c81337d90c21436");
const applianceTypeUtil_1 = require("aaab890b5f7f65b9");
const buildInfoUtils_1 = require("7416eb36aef8bcd2");
const vaVersion_1 = require("61cd534ef465a3ee");
function hasSignedDownloads(softwareVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.9.0', softwareVersion);
}
function supportsTtl(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.7.0', applianceVersion.dataSoftwareVersion);
}
function supportsBufferedRtpOutput(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.12.1', applianceVersion.dataSoftwareVersion);
}
function supportsUdpOutputImportance(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.11.3', applianceVersion.dataSoftwareVersion);
}
function usesMultipathPolicyFailover(applianceVersion) {
    // Between R3.11 and R3.18 'propagate' and 'failover' had the same behavior, from R3.19
    // we need to use 'failover' on output appliances to ensure inhibit is sent.
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.19.0', applianceVersion.dataSoftwareVersion);
}
function supportsTr101290Toggling(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.8.0', applianceVersion.dataSoftwareVersion || applianceVersion.controlSoftwareVersion);
}
function supportsBroadcastStandard(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.10.0', applianceVersion.dataSoftwareVersion || applianceVersion.controlSoftwareVersion);
}
function supportsHandoverMethod(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.14.0', applianceVersion.dataSoftwareVersion || applianceVersion.controlSoftwareVersion);
}
function supports12MTimecodeInsertion(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.11.0', applianceVersion.dataSoftwareVersion);
}
function supportsConfigurableGeneratorFrameRateAndResolution(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.12.0', applianceVersion.dataSoftwareVersion);
}
function supportsGeneratorPrograms(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.22.0', applianceVersion.dataSoftwareVersion);
}
function supportsPriorityProperty(applianceVersion) {
    // Return true if application expects portIndex to have been renamed to priority
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.13.0', applianceVersion.dataSoftwareVersion);
}
function supportsIndexProperty(applianceVersion) {
    // Return true if application expects priority to have been renamed to index (and removed from the appliance configuration)
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.15.0', applianceVersion.dataSoftwareVersion);
}
function supportsPIDMap(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.14.0', applianceVersion.dataSoftwareVersion);
}
function supportsRtpForVaHandover(applianceVersion) {
    if (applianceVersion.dataSoftwareVersion === 'ci-690874508') // For testing purpose, ci-690874508 is a master build > R3.13.0 and < R3.14.0
    return false;
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.14.0', applianceVersion.dataSoftwareVersion);
}
// EDGE-3392
function supportsWhitelistCidrBlockAsArray(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.15.0', applianceVersion.dataSoftwareVersion);
}
function supportsChannelGroups(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.15.0', applianceVersion.dataSoftwareVersion);
}
function supportsVersionMessage(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.16.0', applianceVersion.controlSoftwareVersion);
}
function supports400Errors(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.17.0', applianceVersion.controlSoftwareVersion);
}
function supportsApplianceConfigMetaSection(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.18.0', applianceVersion.dataSoftwareVersion);
}
function supportsThumbnailingOnEdge(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.21.0', applianceVersion.dataSoftwareVersion);
}
function supportsGeneratorBitrate(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.21.0', applianceVersion.dataSoftwareVersion);
}
function supportsFec(applianceType, applianceVersion) {
    return applianceVersion && (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.18.0', applianceVersion.dataSoftwareVersion);
}
function supportsZixiAdaptiveFec(applianceType, applianceVersion) {
    // Note: Adaptive fec is supported by
    // 1) VA pull inputs (pull sink),
    // 2) VA push outputs (push source)
    // 3) core pull inputs (zixi-receiver) - but seemingly not core push outputs (zixi-feeder)
    if (applianceType === types_1.ApplianceType.core) return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.18.0', applianceVersion.dataSoftwareVersion);
    if ((0, applianceTypeUtil_1.isVaApplianceType)(applianceType)) return (0, vaVersion_1.vaVersionSupportsAdaptiveFec)(applianceVersion.vaVersion) && (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.18.0', applianceVersion.controlSoftwareVersion);
    return false;
}
function supportsPcap(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.21.0', applianceVersion.controlImageVersion);
}
function supportsTranscoding(applianceType, applianceVersion) {
    if (!(applianceType === types_1.ApplianceType.edgeConnect || applianceType === types_1.ApplianceType.core)) return false;
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.21.0', applianceVersion.controlImageVersion);
}
function supportsOverlays(applianceType, applianceVersion) {
    if (!(applianceType === types_1.ApplianceType.edgeConnect || applianceType === types_1.ApplianceType.core)) return false;
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.22.0', applianceVersion.controlImageVersion);
}
function supportsMulticastDerivedInputs(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.22.0', applianceVersion.controlImageVersion);
}
function supportsRtpOverSrt(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.22.0', applianceVersion.dataSoftwareVersion);
}
function supportsZixiZec(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.23.0', applianceVersion.dataSoftwareVersion);
}
function supportsLegacyZixi(applianceVersion) {
    return !(0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.24.0', applianceVersion.dataSoftwareVersion);
}
function supportsZixiForEdgeConnect(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.24.0', applianceVersion.dataSoftwareVersion);
}
function supportsUnixSockets(applianceVersion) {
    if (applianceVersion.dataSoftwareVersion === 'ci-690874508') // For testing purpose, ci-690874508 is a master build > R3.13.0 and < R3.14.0
    return false;
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.14.0', applianceVersion.dataSoftwareVersion);
}
function supportsNewMulticastAddress(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.24.0', applianceVersion.dataSoftwareVersion);
}
function supportsAdInsertion(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.23.0', applianceVersion.dataSoftwareVersion);
}
function supportsEphemeralTunnelSenderPorts(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.24.0', applianceVersion?.dataSoftwareVersion);
}
function supportsScteOnRtp(applianceVersion) {
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.24.0', applianceVersion.dataSoftwareVersion);
}

},{"8c81337d90c21436":"3qemx","aaab890b5f7f65b9":"3z9on","7416eb36aef8bcd2":"7U3XK","61cd534ef465a3ee":"dfMNv"}],"dfMNv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VaVersions", ()=>VaVersions);
parcelHelpers.export(exports, "vaVersionIsGreaterOrEqual", ()=>vaVersionIsGreaterOrEqual);
parcelHelpers.export(exports, "parseVaVersion", ()=>parseVaVersion);
parcelHelpers.export(exports, "vaVersionSupportsAdaptiveFec", ()=>vaVersionSupportsAdaptiveFec);
parcelHelpers.export(exports, "vaVersionSupports12MTimeCode", ()=>vaVersionSupports12MTimeCode);
parcelHelpers.export(exports, "vaVersionSupportsEdgeLink", ()=>vaVersionSupportsEdgeLink);
const VA_VERSION_PATTERN = /^(LX-)?VA-(\d+\.\d+\.\d+\.\d+)(-[A-Za-z0-9.]+)?$/;
const VaVersions = {
    'VA-15.1.0.2': parseVaVersion('VA-15.1.0.2'),
    'VA-16.4.0.0': parseVaVersion('VA-16.4.0.0'),
    'VA-20.2.0.2': parseVaVersion('VA-20.2.0.2'),
    'LX-VA-20.2.0.1-EdgeLink.0': parseVaVersion('LX-VA-20.2.0.1-EdgeLink.0')
};
function vaVersionIsGreaterOrEqual(vaVersion, referenceVersion) {
    if (!vaVersion) return false;
    try {
        const comp = compareVaVersions(vaVersion, referenceVersion);
        return comp >= 0;
    } catch  {
        return false;
    }
}
function compareVaVersions(v1, v2) {
    const diff = v1.number - v2.number;
    return Math.min(Math.max(diff, -1), 1);
}
function parseVaVersion(vaVersionString) {
    if (!vaVersionString || typeof vaVersionString !== 'string') return undefined;
    const match = vaVersionString.match(VA_VERSION_PATTERN);
    if (!match) return undefined;
    const isLX = match[1] === 'LX-';
    const numbers = match[2].split('.').map((n)=>parseInt(n, 10));
    const suffix = match[3] ? match[3].replace(/^-/, '') : undefined;
    const versionNumber = numbers.reverse().reduce((ack, cur, i)=>{
        return ack + Math.pow(10, 3 * i) * cur;
    });
    return {
        number: versionNumber,
        lx: isLX,
        suffix
    };
}
function vaVersionSupportsAdaptiveFec(vaVersionString) {
    return vaVersionString && vaVersionIsGreaterOrEqual(parseVaVersion(vaVersionString), VaVersions['VA-15.1.0.2']);
}
function vaVersionSupports12MTimeCode(vaVersionString) {
    return vaVersionString && vaVersionIsGreaterOrEqual(parseVaVersion(vaVersionString), VaVersions['VA-16.4.0.0']);
}
function vaVersionSupportsEdgeLink(vaVersionString) {
    const version = parseVaVersion(vaVersionString);
    if (!version) return false;
    return vaVersionIsGreaterOrEqual(parseVaVersion(vaVersionString), VaVersions['VA-20.2.0.2']) || version.lx && version.suffix?.startsWith('EdgeLink');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kARbK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SrtFields", ()=>SrtFields);
parcelHelpers.export(exports, "srtDefaults", ()=>srtDefaults);
parcelHelpers.export(exports, "getSrtFieldsToSave", ()=>getSrtFieldsToSave);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _utils = require("../../../../../utils");
var _whitelistCidrBlockAutoComplete = require("../../../../common/WhitelistCidrBlockAutoComplete");
var _suggestedPortTextField = require("../../../../common/SuggestedPortTextField");
var _nmTypes = require("../../../../../api/nm-types");
var _react = require("react");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _reactHookForm = require("react-hook-form");
var _base = require("../../../../common/Interface/Base");
var _utils1 = require("common/utils");
const LATENCY_MAX = 360000;
const TTL_MAX = 255;
const MTU_MIN = 76;
var SrtFields = /*#__PURE__*/ function(SrtFields) {
    SrtFields["srtMode"] = "srtMode";
    SrtFields["remoteIp"] = "remoteIp";
    SrtFields["remotePort"] = "remotePort";
    SrtFields["localIp"] = "localIp";
    SrtFields["localPort"] = "localPort";
    SrtFields["latency"] = "latency";
    SrtFields["ipttl"] = "ipttl";
    SrtFields["mss"] = "mss";
    SrtFields["passphrase"] = "passphrase";
    SrtFields["streamId"] = "streamId";
    SrtFields["reducedBitrateDetection"] = "reducedBitrateDetection";
    SrtFields["reducedBitrateThreshold"] = "reducedBitrateThreshold";
    SrtFields["unrecoveredPacketsDetection"] = "unrecoveredPacketsDetection";
    SrtFields["unrecoveredPacketsThreshold"] = "unrecoveredPacketsThreshold";
    SrtFields["whitelistCidrBlock"] = "whitelistCidrBlock";
    SrtFields["bondingMode"] = "bondingMode";
    SrtFields["rtp"] = "rtp";
    return SrtFields;
}({});
const srtDefaults = (numDistinctFailoverPriorities)=>(0, _utils.createDefaultFiledValues)(Object.keys(SrtFields), [
        "reducedBitrateDetection",
        "unrecoveredPacketsDetection",
        "rtp"
    ], {
        ["latency"]: 120,
        ["whitelistCidrBlock"]: [],
        ["bondingMode"]: numDistinctFailoverPriorities === 0 ? (0, _nmTypes.SrtBondingMode).none : numDistinctFailoverPriorities > 1 ? (0, _nmTypes.SrtBondingMode).activeBackup : (0, _nmTypes.SrtBondingMode).activeActive
    });
const getSrtFieldsToSave = (port)=>[
        "srtMode",
        "latency",
        "ipttl",
        "mss",
        "streamId",
        "passphrase",
        "reducedBitrateDetection",
        "unrecoveredPacketsDetection",
        "rtp",
        ...port.reducedBitrateDetection ? [
            "reducedBitrateThreshold"
        ] : [],
        ...port.unrecoveredPacketsDetection ? [
            "unrecoveredPacketsThreshold"
        ] : [],
        ...function() {
            switch(port.srtMode){
                case (0, _types.SrtMode).listener:
                    return [
                        "localIp",
                        "localPort",
                        "whitelistCidrBlock"
                    ];
                case (0, _types.SrtMode).caller:
                    return [
                        "remoteIp",
                        "remotePort",
                        "localPort"
                    ];
                default:
                    return [
                        "remoteIp",
                        "remotePort",
                        "localIp",
                        "whitelistCidrBlock"
                    ];
            }
        }()
    ];
const SrtForm = ({ addresses, namePrefix, applianceId, applianceType, applianceFeatures, portIndex, occupiedPorts, adminStatus, onAddLogicalPortRequested })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    const portsNamePrefix = namePrefix.substr(0, namePrefix.length - 2);
    const appliancePorts = getValues(portsNamePrefix);
    const previousNumberOfPorts = (0, _utils.usePrevious)(appliancePorts.length);
    const firstAppliancePort = appliancePorts[0];
    const secondAppliancePort = appliancePorts[1];
    const currentPort = appliancePorts[portIndex];
    // Watch specific fields since they control conditional rendering
    watch(`${portsNamePrefix}.0.${"rtp"}`) // isRtpOverSrtEnabled
    ;
    [
        0,
        1
    ].forEach((i)=>{
        const portNamePrefix = `${portsNamePrefix}.${i}`;
        watch(`${portNamePrefix}.srtMode`);
        watch(`${portNamePrefix}.bondingMode`);
        watch(`${portNamePrefix}.reducedBitrateDetection`);
        watch(`${portNamePrefix}.unrecoveredPacketsDetection`);
    });
    const supportedModes = applianceFeatures.input?.modes.find((m)=>m.mode === (0, _types.IpPortMode).srt)?.subModes ?? [];
    const localAddressSelector = `${namePrefix}.${"localIp"}`;
    const currentPortInfo = {
        isInput: true,
        isPortDisabled: adminStatus === (0, _types.InputAdminStatus).off,
        mode: currentPort.mode,
        existingLogicalPortsOnSameNic: occupiedPorts
    };
    const allLogicalPorts = (0, _base.collectPortsFromApplianceSections)(values);
    const portsGroupedByAppliance = (0, _utils1.group)(allLogicalPorts, (p)=>(0, _base.getPortAppliance)(p)?.id ?? '');
    const isRtpOverSrtSupported = Object.values(portsGroupedByAppliance).every(// Max 1 SRT interface per appliance
    (appliancePorts)=>appliancePorts.filter((p)=>p.mode === (0, _types.IpPortMode).srt).length < 2);
    // Only show RTP-over-SRT checkbox for first logical port per appliance
    const showRtpOverSrtCheckbox = portIndex === 0;
    // isRtpOverSrtEnabled is a global/"input-wide" setting (i.e. across appliances and not per appliance)
    const isRtpOverSrtEnabled = allLogicalPorts.some((p)=>p.mode === (0, _types.IpPortMode).srt && 'rtp' in p && !!p.rtp);
    const srtModeSupportsBonding = !!firstAppliancePort.srtMode && firstAppliancePort.srtMode !== (0, _types.SrtMode).rendezvous;
    const isBondingSupported = !isRtpOverSrtEnabled && srtModeSupportsBonding && (0, _base.areMultipleLogicalPortsPerApplianceSupported)({
        isInput: true,
        appliance: {
            id: applianceId,
            type: applianceType
        },
        allLogicalPorts
    });
    const isBondingEnabled = Boolean(firstAppliancePort.bondingMode) && firstAppliancePort.bondingMode !== (0, _nmTypes.SrtBondingMode).none;
    (0, _react.useEffect)(()=>{
        if (portIndex !== 0) return;
        if (isRtpOverSrtEnabled) {
            if (!isRtpOverSrtSupported) setValue(`${portsNamePrefix}.0.${"rtp"}`, false);
            else if (!currentPort.rtp) setValue(`${portsNamePrefix}.0.${"rtp"}`, true);
        }
    }, [
        portIndex,
        isRtpOverSrtEnabled,
        isRtpOverSrtSupported,
        setValue,
        currentPort.rtp
    ]);
    (0, _react.useEffect)(()=>{
        if (portIndex === 1 && firstAppliancePort && secondAppliancePort && firstAppliancePort.mode === (0, _types.IpPortMode).srt && secondAppliancePort.mode === (0, _types.IpPortMode).srt) // Ensure that the second srt mode mirrors the first if bonding is enabled
        {
            if (firstAppliancePort.srtMode !== secondAppliancePort.srtMode && isBondingEnabled) setValue(`${portsNamePrefix}.1.srtMode`, firstAppliancePort.srtMode, {
                shouldValidate: true
            });
        }
    }, [
        portIndex,
        firstAppliancePort?.srtMode,
        secondAppliancePort?.srtMode,
        isBondingEnabled,
        setValue,
        portsNamePrefix
    ]);
    (0, _react.useEffect)(()=>{
        if (portIndex === 0 && isBondingEnabled) {
            if (!isBondingSupported) // Ensure that bonding mode is .None if bonding is not supported
            setValue(`${portsNamePrefix}.0.bondingMode`, (0, _nmTypes.SrtBondingMode).none);
            else if (firstAppliancePort.srtMode === (0, _types.SrtMode).listener && firstAppliancePort.bondingMode === (0, _nmTypes.SrtBondingMode).activeBackup) // Ensure that bonding mode is not active/backup if listener is chosen
            setValue(`${portsNamePrefix}.0.bondingMode`, (0, _nmTypes.SrtBondingMode).activeActive);
        }
    }, [
        portIndex,
        isBondingEnabled,
        isBondingSupported,
        setValue,
        portsNamePrefix,
        firstAppliancePort.srtMode,
        firstAppliancePort.bondingMode
    ]);
    (0, _react.useEffect)(()=>{
        if (isBondingEnabled && appliancePorts.length === 1) {
            // Bonding is enabled but only one logical port
            const didDeletePort = previousNumberOfPorts !== undefined ? appliancePorts.length < previousNumberOfPorts : false;
            if (didDeletePort) // User just deleted the second logical port - disable bonding
            setValue(`${portsNamePrefix}.0.bondingMode`, (0, _nmTypes.SrtBondingMode).none);
            else if (isBondingSupported) // User selected bonding - automatically add an additional logical port (two ports are required for bonding)
            onAddLogicalPortRequested();
        }
    }, [
        isBondingEnabled,
        appliancePorts,
        previousNumberOfPorts,
        setValue,
        portsNamePrefix,
        isBondingSupported,
        onAddLogicalPortRequested
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            showRtpOverSrtCheckbox && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: "RTP over SRT",
                name: `${namePrefix}.${"rtp"}`,
                disabled: !isRtpOverSrtSupported,
                tooltip: 'Enable this option if the SRT input is tunneling RTP.\n\nTo enable SMPTE 2022-7 redundancy:\n1) configure two input appliances with one SRT interface each\n2) both interfaces must receive binary equal RTP streams, e.g. from the same encoder.',
                onClick: (e)=>{
                    (function toggleAllCheckboxesInForm() {
                        const numInputAppliances = (0, _base.collectApplianceSectionEntries)(values).length;
                        for(let applianceIndex = 0; applianceIndex < numInputAppliances; applianceIndex++){
                            const portsNamePrefix = (0, _base.makeAppliancePortsNamePrefix)(applianceIndex, 0);
                            const fieldSelector = `${portsNamePrefix}.${"rtp"}`;
                            setValue(fieldSelector, e.target.checked);
                        }
                    })();
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"srtMode"}`,
                label: "Connection mode",
                newLine: true,
                disabled: portIndex !== 0 && firstAppliancePort && isBondingEnabled,
                options: supportedModes,
                required: true
            }),
            portIndex === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"bondingMode"}`,
                label: "Bonding mode",
                options: (0, _nmTypes.srtBondingOptions)(firstAppliancePort.srtMode),
                required: isBondingSupported,
                disabled: !isBondingSupported,
                tooltip: isRtpOverSrtEnabled ? 'Bonding is not supported when tunneling RTP over SRT' : undefined
            }),
            [
                (0, _types.SrtMode).caller,
                (0, _types.SrtMode).rendezvous
            ].includes(currentPort?.srtMode) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"remoteIp"}`,
                        label: "Remote host",
                        newLine: true,
                        required: true,
                        validators: {
                            ipOrHostname: {}
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"remotePort"}`,
                        label: currentPort?.srtMode === (0, _types.SrtMode).rendezvous ? 'Local and remote port' : 'Remote port',
                        required: true,
                        type: "number",
                        noNegative: true,
                        validators: {
                            port: {
                                isUdp: true
                            },
                            isPortAvailable: {
                                ...currentPortInfo,
                                existingLogicalPortsOnSameNic: currentPort.srtMode === (0, _types.SrtMode).rendezvous ? occupiedPorts : []
                            }
                        }
                    })
                ]
            }),
            [
                (0, _types.SrtMode).listener,
                (0, _types.SrtMode).rendezvous
            ].includes(currentPort?.srtMode) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: localAddressSelector,
                label: "Local address",
                options: (0, _utils.makeAddressOptions)(getValues(localAddressSelector), addresses),
                required: true,
                newLine: true,
                validators: {
                    addressIn: {
                        addresses
                    }
                }
            }),
            [
                (0, _types.SrtMode).listener,
                (0, _types.SrtMode).caller
            ].includes(currentPort?.srtMode) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    currentPort.srtMode === (0, _types.SrtMode).caller && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                        component: "div",
                        sx: {
                            width: '100%',
                            borderColor: 'transparent',
                            opacity: '0.6'
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _suggestedPortTextField.SuggestedLocalPortTextField), {
                        name: `${namePrefix}.${"localPort"}`,
                        label: currentPort.srtMode === (0, _types.SrtMode).listener ? 'Local port' : 'Local outgoing port',
                        required: currentPort.srtMode === (0, _types.SrtMode).listener,
                        namePrefix: namePrefix,
                        portInfo: currentPortInfo
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"latency"}`,
                label: "Retransmission buffer (ms)",
                type: "number",
                noNegative: true,
                required: true,
                newLine: true,
                tooltip: "The constant delay of playout of the stream that allows time for retransmissions to occur",
                validators: {
                    number: {
                        lessThanOrEqualTo: LATENCY_MAX,
                        message: `Must be no more than ${LATENCY_MAX}`
                    }
                }
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"ipttl"}`,
                label: "TTL",
                type: "number",
                noNegative: true,
                tooltip: 'Defines IP socket "time to live" option.',
                validators: {
                    number: {
                        lessThanOrEqualTo: TTL_MAX,
                        message: `Must be no more than ${TTL_MAX}`
                    }
                }
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"mss"}`,
                label: "MTU",
                type: "number",
                noNegative: true,
                newLine: true,
                tooltip: "MTU size",
                validators: {
                    number: {
                        greaterThanOrEqualTo: MTU_MIN,
                        message: `Must be more than ${MTU_MIN}`
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"passphrase"}`,
                label: "Passphrase",
                tooltip: "Same passphrase must be configured at SRT output to encrypt the stream",
                validators: {
                    noAmpersand: {},
                    len: {
                        minimum: 10,
                        maximum: 79
                    }
                }
            }),
            currentPort?.srtMode === (0, _types.SrtMode).caller && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"streamId"}`,
                label: "Stream Id",
                newLine: true,
                tooltip: "Stream ID"
            }),
            (0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                name: `${namePrefix}.${"reducedBitrateDetection"}`,
                label: "Reduced bitrate alarm",
                newLine: true,
                tooltip: "Raise alarm when bitrate is below or equal."
            }),
            currentPort.reducedBitrateDetection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"reducedBitrateThreshold"}`,
                label: "Bitrate (kbps)",
                type: "number",
                noNegative: true,
                validators: {
                    number: {
                        lessThanOrEqualTo: Math.pow(2, 64),
                        message: `Must be no more than ${Math.pow(2, 64)}`
                    }
                }
            }),
            (0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                name: `${namePrefix}.${"unrecoveredPacketsDetection"}`,
                label: "Unrecovered packets alarm",
                tooltip: "Turn detection of unrecovered packets on or off, including associated alarm. Threshold is in packets per minute. Generates an alarm if unrecovered packets per minute is higher than threshold.",
                newLine: true
            }),
            currentPort.unrecoveredPacketsDetection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"unrecoveredPacketsThreshold"}`,
                label: "Threshold (packets/min)",
                type: "number",
                noNegative: true,
                validators: {
                    number: {
                        lessThanOrEqualTo: Math.pow(2, 64),
                        message: `Must be no more than ${Math.pow(2, 64)}`
                    }
                }
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && [
                (0, _types.SrtMode).listener,
                (0, _types.SrtMode).rendezvous
            ].includes(currentPort?.srtMode) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _whitelistCidrBlockAutoComplete.WhitelistCidrBlockAutoComplete), {
                name: `${namePrefix}.${"whitelistCidrBlock"}`,
                required: (0, _utils.isCoreNode)(applianceType)
            })
        ]
    });
};
exports.default = SrtForm;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","common/applianceTypeUtil":"3z9on","../../../../../utils":"342UB","../../../../common/WhitelistCidrBlockAutoComplete":"91kUs","../../../../common/SuggestedPortTextField":"1iSAC","../../../../../api/nm-types":"bcYl5","react":"9njXz","@mui/material/Divider":"9Ul8c","react-hook-form":"8z0aI","../../../../common/Interface/Base":"gmIdH","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gmIdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styles", ()=>styles);
parcelHelpers.export(exports, "APPLIANCE_SECTION_FORM_PREFIX", ()=>APPLIANCE_SECTION_FORM_PREFIX);
parcelHelpers.export(exports, "makeApplianceNamePrefix", ()=>makeApplianceNamePrefix);
parcelHelpers.export(exports, "makeAppliancePortsNamePrefix", ()=>makeAppliancePortsNamePrefix);
parcelHelpers.export(exports, "formatInterfaceAddress", ()=>formatInterfaceAddress);
parcelHelpers.export(exports, "getPortAppliance", ()=>getPortAppliance);
parcelHelpers.export(exports, "groupPortsByApplianceOrRegion", ()=>groupPortsByApplianceOrRegion);
parcelHelpers.export(exports, "makeApplianceSection", ()=>makeApplianceSection);
parcelHelpers.export(exports, "collectPortsFromApplianceSections", ()=>collectPortsFromApplianceSections);
parcelHelpers.export(exports, "collectApplianceSectionEntries", ()=>collectApplianceSectionEntries);
parcelHelpers.export(exports, "isApplianceOrRegionSelectable", ()=>isApplianceOrRegionSelectable);
parcelHelpers.export(exports, "Loading", ()=>Loading);
parcelHelpers.export(exports, "Error", ()=>Error);
parcelHelpers.export(exports, "LogicalPortForm", ()=>LogicalPortForm);
parcelHelpers.export(exports, "isRegionalPort", ()=>isRegionalPort);
parcelHelpers.export(exports, "isAppliance", ()=>isAppliance);
parcelHelpers.export(exports, "isCoreNode", ()=>isCoreNode);
parcelHelpers.export(exports, "areMultipleLogicalPortsPerApplianceSupported", ()=>areMultipleLogicalPortsPerApplianceSupported);
parcelHelpers.export(exports, "ApplianceSection", ()=>ApplianceSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _doNotDisturbOn = require("@mui/icons-material/DoNotDisturbOn");
var _doNotDisturbOnDefault = parcelHelpers.interopDefault(_doNotDisturbOn);
var _store = require("../../../store");
var _types = require("common/api/v1/types");
var _form = require("../Form");
var _autoComplete = require("../AutoComplete");
var _regional = require("./Regional");
var _appliance = require("./Appliance");
var _utils = require("../../../utils");
var _delayedAppearance = require("../DelayedAppearance");
var _delayedAppearanceDefault = parcelHelpers.interopDefault(_delayedAppearance);
var _physicalPortUtil = require("../../../utils/physicalPortUtil");
var _portForm = require("../../inputs/Edit/PortForm");
var _portForm1 = require("../../outputs/Edit/PortForm");
var _applianceTypes = require("common/applianceTypes");
var _env = require("../../../env");
var _util = require("common/util");
var _helpers = require("common/api/v1/helpers");
var _srt = require("common/srt");
var _indicator = require("../Indicator");
const styles = {
    warningText: {
        marginLeft: (theme)=>theme.spacing(1),
        color: (theme)=>theme.palette.warning.light
    }
};
const APPLIANCE_SECTION_FORM_PREFIX = '_applianceSection';
function makeApplianceNamePrefix(applianceIndex) {
    return `${APPLIANCE_SECTION_FORM_PREFIX}.${applianceIndex}`;
}
function makeAppliancePortsNamePrefix(applianceIndex, portIndex) {
    return `${makeApplianceNamePrefix(applianceIndex)}.ports.${portIndex}`;
}
const formatInterfaceAddress = (address)=>{
    const hasPublicAddress = !!address.publicAddress;
    return `${address.address}${hasPublicAddress ? ` Public: ${address.publicAddress}` : ''}`;
};
function getPortAppliance(port) {
    return isRegionalPort(port) ? port.region.allocatedAppliance : port?._port?.appliance;
}
const groupPortsByApplianceOrRegion = (ports)=>{
    const portsGroupedByApplianceOrRegion = ports.reduce((acc, port)=>{
        const isRegion = isRegionalPort(port);
        const applianceOrRegion = isRegion ? port.region : port._port._appliance ?? port._port.appliance;
        const portApplianceId = getPortAppliance(port)?.id;
        // Find an existing entry in the array that matches the appliance ID
        const existingEntry = acc.find((entry)=>entry.ports.some((p)=>getPortAppliance(p)?.id === portApplianceId));
        if (existingEntry) existingEntry.ports.push(port);
        else {
            // Create a new entry if none exists for this appliance/region
            const entry = makeApplianceSection({
                region: isRegion ? applianceOrRegion : undefined,
                appliance: isRegion ? undefined : applianceOrRegion
            });
            entry.ports.push(port);
            acc.push(entry);
        }
        return acc;
    }, []);
    if (portsGroupedByApplianceOrRegion.length === 0) {
        // Ensure at least one empty section if no ports were grouped
        const applianceSection = makeApplianceSection({
            region: undefined,
            appliance: undefined
        });
        portsGroupedByApplianceOrRegion.push(applianceSection);
    }
    return portsGroupedByApplianceOrRegion;
};
const makeApplianceSection = ({ region, appliance })=>{
    return {
        region,
        appliance,
        ports: []
    };
};
const collectPortsFromApplianceSections = (values)=>{
    return collectApplianceSectionEntries(values).flatMap((value)=>value.ports);
};
const collectApplianceSectionEntries = (values)=>values[APPLIANCE_SECTION_FORM_PREFIX] ?? [];
const isApplianceOrRegionSelectable = (applianceOrRegion, values, isOutputForm)=>{
    const isRegion = !isAppliance(applianceOrRegion);
    const applianceSectionEntries = collectApplianceSectionEntries(values);
    const numberOfApplianceSections = applianceSectionEntries.length;
    if (numberOfApplianceSections <= 1) // Single appliance section:
    // User may or may not yet have selected an appliance or region - either way he/she is free to select/change it.
    return true;
    // Multiple appliance sections:
    const selectedAppliancesAndRegions = applianceSectionEntries.map((v)=>v.region ?? v.appliance);
    const firstSelectedApplianceOrRegion = selectedAppliancesAndRegions.find(Boolean);
    if (!firstSelectedApplianceOrRegion) {
        // User has two empty appliance sections but with no appliance or region selected (can happen if they clear the selected value)
        if (isOutputForm) // For output: Must select a region or a core appliance (multi-appliance outputs are restricted to core nodes)
        return isRegion || applianceOrRegion.type === (0, _types.ApplianceType).core;
        // For input: free to select any appliance or region
        return true;
    }
    if (isAppliance(firstSelectedApplianceOrRegion)) {
        // User has previously selected an appliance
        if (isRegion) // The second selection must also be an appliance (not a region)
        return false;
        const isApplianceAlreadySelected = !!selectedAppliancesAndRegions.find((a)=>a && isAppliance(a) && a.id === applianceOrRegion.id);
        if (isApplianceAlreadySelected) // The second appliance must be a different one
        return false;
        if (firstSelectedApplianceOrRegion.type === (0, _types.ApplianceType).core) // The second appliance must be of the same type, where type is defined to be either a "core appliance" (located in the cluster)
        // or "edge appliance" (located outside of the cluster).
        return applianceOrRegion.type === (0, _types.ApplianceType).core;
        else {
            if (isOutputForm) // For output: Multi-appliance outputs are restricted to core nodes
            return false;
            // For input: The second appliance must also be a non-core type
            return applianceOrRegion.type !== (0, _types.ApplianceType).core;
        }
    }
    // User has previously selected a region - the second selection must also be a region
    return isRegion;
};
const Loading = ({ message })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _delayedAppearanceDefault.default), {
        gracePeriodMs: 1000,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
            newLine: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "div",
                        variant: "body1",
                        children: message
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                        style: {
                            marginLeft: 20
                        }
                    })
                ]
            })
        })
    });
const Error = ({ message })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
        newLine: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "div",
                variant: "body1",
                children: message
            })
        })
    });
function LogicalPortForm({ isRegional, namePrefix, logicalPorts, fieldArray: { fields, update, remove }, isInputForm, adminStatus, appliancePhysicalPorts, isModeSelectionDisabled, enforcedPortMode, restrictPhysicalPortsToGroupId, onAddLogicalPortRequested }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: fields.map((field, portIndex)=>{
            const logicalPort = logicalPorts[portIndex];
            if (!logicalPort) return null // RHF FieldArray may not be in sync with logicalPorts
            ;
            const physicalPort = appliancePhysicalPorts.find((p)=>p.id === logicalPort.physicalPort);
            if (!physicalPort) return null;
            const isPrimaryInterface = portIndex === 0;
            const interfaceText = `${isRegional ? 'Regional ' : ''}Interface${isPrimaryInterface ? '' : `-${portIndex + 1}`}`;
            const interfaceToolTip = isPrimaryInterface ? undefined : `Additional interface to ${isInputForm ? 'receive' : 'egress'} the same stream for redundancy.`;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                sx: {
                    padding: 0,
                    boxShadow: 'none'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                        tooltip: interfaceToolTip,
                        newLine: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                            variant: "outlined",
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                    id: `select-input-interface-${portIndex}-label`,
                                    children: interfaceText
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                                    name: `${namePrefix}.ports.${portIndex}.interface`,
                                    label: interfaceText,
                                    labelId: `select-input-interface-${portIndex}-label`,
                                    disabled: logicalPort.mode === (0, _types.IpPortMode).generator,
                                    fullWidth: true,
                                    value: logicalPort.physicalPort,
                                    onChange: (event)=>{
                                        const newPhysicalPort = appliancePhysicalPorts.find((p)=>p.id === event.target.value);
                                        update(portIndex, {
                                            ...logicalPort,
                                            physicalPort: newPhysicalPort?.id,
                                            _port: newPhysicalPort
                                        });
                                    },
                                    children: appliancePhysicalPorts.map((physicalPort)=>{
                                        const disabledReason = (0, _physicalPortUtil.whyIsPhysicalPortUnavailable)({
                                            requestee: {
                                                groupId: restrictPhysicalPortsToGroupId
                                            },
                                            physicalPort
                                        });
                                        const isPhysicalPortEnabled = !disabledReason || adminStatus === 0 && disabledReason.code === (0, _physicalPortUtil.InterfaceUnavailableReason).occupied;
                                        const formattedAddress = physicalPort.addresses.map(formatInterfaceAddress)[0];
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                            value: physicalPort.id,
                                            disabled: !isPhysicalPortEnabled,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                        children: [
                                                            physicalPort.name,
                                                            disabledReason?.msg && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                                                component: 'span',
                                                                sx: styles.warningText,
                                                                children: [
                                                                    "(",
                                                                    disabledReason.msg,
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    formattedAddress && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                        component: "div",
                                                        variant: "body2",
                                                        color: "textSecondary",
                                                        children: formattedAddress
                                                    })
                                                ]
                                            })
                                        }, physicalPort.id);
                                    })
                                })
                            ]
                        })
                    }),
                    isInputForm ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portForm.PortForm), {
                        portIndex: portIndex,
                        namePrefix: `${namePrefix}.ports.${portIndex}`,
                        physicalPort: physicalPort,
                        isModeDisabled: isModeSelectionDisabled,
                        onAddLogicalPortRequested: onAddLogicalPortRequested,
                        onRemoveLogicalPortRequested: ()=>remove(portIndex)
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portForm1.PortForm), {
                        index: portIndex,
                        namePrefix: `${namePrefix}.ports.${portIndex}`,
                        physicalPort: physicalPort,
                        isModeDisabled: isModeSelectionDisabled,
                        enforcedPortMode: enforcedPortMode,
                        onAddLogicalPortRequested: onAddLogicalPortRequested,
                        onRemoveLogicalPortRequested: ()=>remove(portIndex)
                    })
                ]
            }, field.id);
        })
    });
}
const isRegionalPort = (port)=>!!port && 'region' in port && !!port.region;
const isAppliance = (applianceOrRegion)=>'type' in applianceOrRegion;
function isCoreNode(values) {
    for (const { region, appliance } of collectApplianceSectionEntries(values)){
        if (region) return true;
        if (appliance?.type === (0, _types.ApplianceType).core) return true;
    }
    return false;
}
const getApplianceSoftwareString = (version, buildInfo)=>{
    const isApplianceRunningOutdatedSoftware = (0, _utils.runningDifferentSoftwareVersion)(version.controlSoftwareVersion, buildInfo) || (0, _utils.runningDifferentSoftwareVersion)(version.dataSoftwareVersion, buildInfo);
    return isApplianceRunningOutdatedSoftware ? '(appliance software is outdated)' : undefined;
};
const areMultipleLogicalPortsPerApplianceSupported = ({ region, appliance, isInput, allLogicalPorts })=>{
    // All logical ports on same appliance have the same mode
    const logicalPortOnThisAppliance = allLogicalPorts.find((lp)=>getPortAppliance(lp)?.id === appliance?.id);
    const portMode = logicalPortOnThisAppliance?.mode;
    const supportedModes = isInput ? [
        (0, _types.IpPortMode).rtp,
        (0, _types.IpPortMode).udp,
        (0, _types.IpPortMode).srt
    ] : [
        (0, _types.IpPortMode).rtp,
        (0, _types.IpPortMode).srt
    ];
    const isModeSupported = supportedModes.includes(portMode ?? '');
    const isApplianceTypeSupported = !!region || [
        (0, _types.ApplianceType).edgeConnect,
        (0, _types.ApplianceType).core
    ].includes(appliance?.type ?? '');
    // Disable "Add interface" button for all appliances with SRT-interfaces when RTP-over-SRT is enabled
    const isRtpOverSrtEnabled = allLogicalPorts.some((lp)=>(0, _srt.isRtpOverSrt)(lp));
    const applianceHasSrtInterface = !!appliance?.id && allLogicalPorts.filter((lp)=>lp.mode === (0, _types.IpPortMode).srt).map((lp)=>getPortAppliance(lp)?.id).includes(appliance.id);
    return isModeSupported && isApplianceTypeSupported && !(isRtpOverSrtEnabled && applianceHasSrtInterface);
};
const ApplianceSection = (form)=>{
    const { applianceIndex, namePrefix, onRemove, title, isApplianceOrRegionSelectable, onApplianceOrRegionSelected, enforcedPortMode, isModeSelectionDisabled, formState, getValues, isInputForm, adminStatus } = form;
    const { buildInfo } = (0, _reactRedux.useSelector)(({ buildInfoReducer })=>({
            buildInfo: buildInfoReducer.buildInfo
        }), (0, _util.equals));
    const childRef = (0, _react.useRef)(null);
    const { region: selectedRegion, appliance: selectedAppliance, ports: logicalPorts } = getValues(namePrefix);
    const logicalPort1 = logicalPorts[0];
    const areMultipleLogicalPortsSupported = areMultipleLogicalPortsPerApplianceSupported({
        isInput: isInputForm,
        appliance: getPortAppliance(logicalPort1),
        region: selectedRegion,
        allLogicalPorts: collectPortsFromApplianceSections(getValues())
    });
    const maxNumberOfLogicalPortsAllowed = areMultipleLogicalPortsSupported ? 2 : 1;
    const canAddMoreLogicalPorts = !!(selectedRegion || selectedAppliance) && logicalPorts.length < maxNumberOfLogicalPortsAllowed;
    // Don't allow manually (using the button) adding logical ports for SRT outputs since it is handled automatically
    const canAddMoreLogicalPortsManually = canAddMoreLogicalPorts && (isInputForm || logicalPorts.every((lp)=>lp.mode !== (0, _types.IpPortMode).srt));
    const onAddLogicalPortRequested = ()=>{
        if (!canAddMoreLogicalPorts) return;
        childRef.current?.onAddInterfaceButtonClicked();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        id: `applianceSectionContainer-${applianceIndex}`,
        title: title,
        className: (0, _classnamesDefault.default)('outlined', formState.errors.ports && 'error'),
        actionsPane: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                disabled: !canAddMoreLogicalPortsManually,
                "data-test-id": `add-interface-${applianceIndex}`,
                variant: "contained",
                color: "secondary",
                onClick: onAddLogicalPortRequested,
                children: "Add interface"
            }),
            ...onRemove ? [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "outlined",
                    color: "primary",
                    onClick: ()=>onRemove(applianceIndex),
                    children: ` Remove ${isInputForm ? 'input' : 'output'} appliance `
                }, 'remote-input-appliance')
            ] : []
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                    sx: {
                        marginTop: 2
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoComplete.AutoComplete), {
                        placeholder: `${isInputForm ? 'Input' : 'Output'} appliance or region`,
                        groupBy: (option)=>isAppliance(option) ? 'Appliance' : 'Region',
                        isClearable: true,
                        initialValue: isRegionalPort(logicalPort1) ? logicalPort1.region : selectedRegion ?? selectedAppliance ?? null,
                        onValueSelected: (selected)=>{
                            const didReselectCurrentValue = selectedRegion && selected?.id === selectedRegion.id || selectedAppliance && selected?.id === selectedAppliance.id || !selected && !selectedRegion && !selectedAppliance;
                            if (didReselectCurrentValue) return;
                            onApplianceOrRegionSelected(selected);
                        },
                        getOptionLabel: (value)=>{
                            if (!isAppliance(value)) return value.name;
                            const appliance = value;
                            const applianceSoftwareOutdatedString = appliance.version && getApplianceSoftwareString(appliance.version, buildInfo);
                            return `${appliance.name}${applianceSoftwareOutdatedString ? ` ${applianceSoftwareOutdatedString}` : ''}`;
                        },
                        renderOption: ({ key, ...props }, option)=>{
                            const applianceSoftwareOutdatedString = isAppliance(option) && option.version && getApplianceSoftwareString(option.version, buildInfo);
                            const type = isAppliance(option) ? (0, _helpers.getProductName)(option.type) : null;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                ...props,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    display: "flex",
                                    alignItems: "center",
                                    children: [
                                        isAppliance(option) && option.health && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                marginRight: 12
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ApplianceIndicator, {
                                                health: option.health,
                                                softwareMismatch: !!applianceSoftwareOutdatedString,
                                                cordon: option.cordon ?? true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            display: "block",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                    component: "div",
                                                    variant: "body2",
                                                    color: "textPrimary",
                                                    children: option.name
                                                }),
                                                type && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                    component: "div",
                                                    variant: "caption",
                                                    color: "textSecondary",
                                                    children: type
                                                }),
                                                applianceSoftwareOutdatedString && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                    component: "div",
                                                    variant: "body2",
                                                    color: "warning.light",
                                                    children: applianceSoftwareOutdatedString
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, key);
                        },
                        isOptionDisabled: (option)=>!isApplianceOrRegionSelectable(option),
                        api: async (params)=>{
                            // TODO: Remove usage of static/compiled applianceTypes and add support for filtering on input/output capabilities in listAppliances instead.
                            const hasInputCapabilities = (type)=>(0, _applianceTypes.applianceTypes)[type]((0, _env.REACT_APP_EDGE_PRODUCT)).input !== undefined;
                            const hasOutputCapabilities = (type)=>(0, _applianceTypes.applianceTypes)[type]((0, _env.REACT_APP_EDGE_PRODUCT)).output !== undefined;
                            const onlyVideoRegions = true;
                            const regions = await (0, _store.Api).regionApi.getRegions(params, onlyVideoRegions);
                            const appliances = await (0, _store.Api).appliancesApi.getAppliances({
                                ...params,
                                types: Object.values((0, _types.ApplianceType)).filter(isInputForm ? hasInputCapabilities : hasOutputCapabilities).join(',')
                            });
                            return {
                                items: [
                                    ...regions.items,
                                    ...appliances.items
                                ],
                                total: regions.total + appliances.total,
                                skip: Number(params.pageNumber) * Number(params.rowsPerPage),
                                limit: Number(params.rowsPerPage)
                            };
                        },
                        dataTestId: `${applianceIndex}-appliance`
                    })
                }),
                selectedRegion && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _regional.RegionalInterfaceSection), {
                    ...form,
                    selectedRegion: selectedRegion,
                    enforcedPortMode: enforcedPortMode,
                    isModeSelectionDisabled: isModeSelectionDisabled,
                    logicalPorts: logicalPorts,
                    myRef: childRef,
                    onAddLogicalPortRequested: onAddLogicalPortRequested
                }),
                !selectedRegion && selectedAppliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appliance.ApplianceInterfaceSection), {
                    ...form,
                    adminStatus: adminStatus,
                    selectedAppliance: selectedAppliance,
                    logicalPorts: logicalPorts,
                    enforcedPortMode: enforcedPortMode,
                    isModeSelectionDisabled: isModeSelectionDisabled,
                    myRef: childRef,
                    onAddLogicalPortRequested: onAddLogicalPortRequested
                })
            ]
        })
    });
};
const ApplianceIndicator = ({ health, softwareMismatch, cordon })=>{
    if (cordon) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _doNotDisturbOnDefault.default), {});
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.ApplianceIndicatorIcon), {
        status: health,
        softwareMismatch: softwareMismatch
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","classnames":"5Een2","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/CircularProgress":"kEtIR","@mui/material/FormControl":"ioFZ4","@mui/material/InputLabel":"5EJtb","@mui/material/MenuItem":"krMs8","@mui/material/Select":"kyj0v","@mui/material/Typography":"6NtGx","@mui/icons-material/DoNotDisturbOn":"iMYSA","../../../store":"5LXiG","common/api/v1/types":"3qemx","../Form":"4Mui7","../AutoComplete":"3AK6z","./Regional":"kkeuM","./Appliance":"5mwDf","../../../utils":"342UB","../DelayedAppearance":"gsWN0","../../../utils/physicalPortUtil":"1hoFB","../../inputs/Edit/PortForm":"bMbF1","../../outputs/Edit/PortForm":"mAmIR","common/applianceTypes":"it4bJ","../../../env":"cPu8n","common/util":"jV4UZ","common/api/v1/helpers":"6jovr","common/srt":"9Ptuu","../Indicator":"hqaQa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iMYSA":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("1e33cb55116bc406").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("1ff8928740957f5f"));
var _jsxRuntime = require("663fe26476602ac9");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z"
}), 'DoNotDisturbOn');

},{"1e33cb55116bc406":"kZ6eK","1ff8928740957f5f":"2vOnF","663fe26476602ac9":"1dlk8"}],"3AK6z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoComplete", ()=>AutoComplete);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _autocomplete = require("@mui/material/Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _debounce = require("lodash/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _popper = require("@mui/material/Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
const AutoComplete = (props)=>{
    // The value selected by the user, for instance when pressing Enter.
    const [selectedValue, setSelectedValue] = (0, _react.useState)(props.initialValue);
    // The value displayed in the textbox.
    const [enteredText, setEnteredText] = (0, _react.useState)(props.initialValue?.name ?? '');
    // The list-result from the api call
    const [searchResults, setSearchResults] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const debouncedFetch = (0, _react.useCallback)((0, _debounceDefault.default)(async (request, callback)=>{
        const { items } = await props.api({
            pageNumber: '0',
            rowsPerPage: '500',
            filter: request.input
        });
        callback(items);
    }, 500), []);
    (0, _react.useEffect)(()=>{
        let isMounted = true;
        setIsLoading(true);
        const shouldShowAllOptions = enteredText === selectedValue?.name;
        debouncedFetch({
            input: shouldShowAllOptions ? '' : enteredText
        }, (results)=>{
            if (!isMounted) return;
            setSearchResults(results ?? []);
            setIsLoading(false);
        })?.catch();
        return ()=>{
            isMounted = false;
        };
    }, [
        selectedValue,
        enteredText,
        debouncedFetch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteDefault.default), {
        value: selectedValue,
        getOptionLabel: props.getOptionLabel,
        renderOption: props.renderOption,
        onChange: (_event, newValue)=>{
            setEnteredText(newValue?.name ?? '');
            setSelectedValue(newValue);
            props.onValueSelected(newValue);
        },
        inputValue: enteredText,
        onInputChange: (_event, newInputValue, reason)=>{
            // Don't update `enteredText` when reason == 'reset' since it then contains
            // the **formatted** name of the selected value, not the actual selected value.
            // E.g. "xxx (appliance software is out of date)" instead of simply "xxx".
            if ([
                'input',
                'clear'
            ].includes(reason)) setEnteredText(newInputValue);
        },
        renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                ...params,
                variant: "outlined",
                label: props.placeholder,
                slotProps: {
                    input: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    htmlInput: {
                        ...params.inputProps,
                        'data-test-id': `${props.dataTestId}-autocomplete-input`
                    }
                }
            }),
        disableClearable: !props.isClearable,
        options: searchResults,
        loading: isLoading,
        groupBy: props.groupBy,
        getOptionDisabled: props.isOptionDisabled,
        filterOptions: (x)=>x,
        autoHighlight: true,
        fullWidth: true,
        slotProps: {
            listbox: {
                component: 'ul',
                style: {
                    marginBlockStart: 0,
                    marginBlockEnd: 0
                }
            }
        },
        noOptionsText: enteredText ? 'No matching options' : 'Type to search',
        isOptionEqualToValue: (option, value)=>option.id === value.id,
        "data-test-id": `${props.dataTestId}-autocomplete`,
        PopperComponent: (p)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popperDefault.default), {
                ...p,
                "data-test-id": `${props.dataTestId}-dropdown`
            }),
        "data-num-options": searchResults.length
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Autocomplete":"avdFA","@mui/material/TextField":"l88b4","@mui/material/CircularProgress":"kEtIR","lodash/debounce":"1hVPi","@mui/material/Popper":"2EMLo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kkeuM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferencedComponent", ()=>ReferencedComponent);
parcelHelpers.export(exports, "RegionalInterfaceSection", ()=>RegionalInterfaceSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _store = require("../../../store");
var _types = require("common/api/v1/types");
var _inputForm = require("../../inputs/Edit/InputForm");
var _outputForm = require("../../outputs/Edit/OutputForm");
var _ipPortForm = require("../../inputs/Edit/PortForm/IpPortForm");
var _ipPortForm1 = require("../../outputs/Edit/PortForm/IpPortForm");
var _base = require("./Base");
var _utils = require("../../../utils");
var _types1 = require("common/types");
var _helpers = require("common/api/v1/helpers");
var _physicalPortUtil = require("../../../utils/physicalPortUtil");
var _notificationActions = require("../../../redux/actions/notificationActions");
var _reactRedux = require("react-redux");
var _reactHookForm = require("react-hook-form");
const Component = (props, ref)=>{
    const { namePrefix, isInputForm, isEditingExistingEntity, isCopyingExistingEntity, inputId, outputId, adminStatus, initialApplianceOrRegionId, selectedRegion, enforcedPortMode, isModeSelectionDisabled, logicalPorts, getValues, onAddLogicalPortRequested } = props;
    const values = getValues();
    const [allocationState, setAllocationState] = (0, _react.useState)({
        isAllocating: false,
        error: false
    });
    const dispatch = (0, _reactRedux.useDispatch)();
    const logicalPort1 = logicalPorts[0];
    const appliance = logicalPort1?._allocation?.appliance ?? logicalPort1?.region?.allocatedAppliance;
    const { result: appliancePhysicalPorts, loading: isFetchingPhysicalPorts, error: listPhysicalPortsError } = (0, _utils.useAppliancePhysicalPorts)(appliance, (0, _store.Api).appliancesApi, isInputForm ? (0, _types1.PortDirection).input : (0, _types1.PortDirection).output, isInputForm ? inputId : outputId);
    (0, _react.useEffect)(()=>{
        // This effect handles the case when "appliancePhysicalPorts" may not yet have been fetched after allocating an appliance,
        // leading to the props.logicalPort.physicalPort being undefined or belonging to a different appliance (e.g. if switching regions).
        function patchLogicalPortsWithPhysicalPort() {
            if (!logicalPorts?.[0]) return;
            if (!appliancePhysicalPorts?.[0]) return;
            for(let i = 0; i < logicalPorts.length; i++){
                const lp = logicalPorts[i];
                const hasInvalidPhysicalPort = !appliancePhysicalPorts.some((pp)=>pp.id === lp.physicalPort);
                if (hasInvalidPhysicalPort) {
                    const defaultPhysicalPort = appliancePhysicalPorts.find((physicalPort)=>(0, _physicalPortUtil.whyIsPhysicalPortUnavailable)({
                            physicalPort
                        }) === undefined) ?? appliancePhysicalPorts[0];
                    if (defaultPhysicalPort) updateLogicalPortField(i, {
                        ...lp,
                        physicalPort: defaultPhysicalPort.id,
                        _port: defaultPhysicalPort
                    });
                }
            }
        }
        patchLogicalPortsWithPhysicalPort();
    }, [
        appliancePhysicalPorts,
        logicalPorts
    ]);
    // Appliance ids of:
    // 1) all regional interfaces for this input/output and
    // 2) any allocated but not-yet-consumed ports
    const occupiedAppliances = (0, _base.collectApplianceSectionEntries)(values).flatMap(({ region, ports })=>{
        if (region) return ports.map((p)=>{
            if ((0, _base.isRegionalPort)(p)) return p.region?.allocatedAppliance?.id;
            else if ('_allocation' in p) return p._allocation.appliance.id;
        });
    }).filter((0, _helpers.notUndefinedOrNull));
    const areMultipleLogicalPortsSupported = (0, _base.areMultipleLogicalPortsPerApplianceSupported)({
        isInput: isInputForm,
        region: selectedRegion,
        appliance,
        allLogicalPorts: (0, _base.collectPortsFromApplianceSections)(getValues())
    });
    // Effect triggered when user selects a different region
    (0, _react.useEffect)(()=>{
        setAllocationState({
            isAllocating: false,
            error: false
        });
        const onRegionChanged = async (signal)=>{
            const isInitialRegion = initialApplianceOrRegionId === selectedRegion.id;
            if (isEditingExistingEntity && isInitialRegion && logicalPorts.length > 0) ;
            else if (isCopyingExistingEntity && isInitialRegion && logicalPorts.length > 0) for(let portIndex = 0; portIndex < logicalPorts.length; portIndex++)updateLogicalPortWithNewAllocatedAppliance(portIndex);
            else {
                const INITIAL_PORT_INDEX = 0;
                if (occupiedAppliances.length === 0) {
                    const allocation = await allocateArbitraryAppliance({
                        regionId: selectedRegion.id
                    }, {
                        signal
                    });
                    addNewLogicalPortToForm(INITIAL_PORT_INDEX, allocation);
                } else {
                    const allocation = await allocateDifferentAppliance({
                        regionId: selectedRegion.id,
                        excludedApplianceIds: occupiedAppliances
                    }, {
                        signal
                    });
                    addNewLogicalPortToForm(INITIAL_PORT_INDEX, allocation);
                }
            }
        };
        const controller = new AbortController();
        onRegionChanged(controller.signal).catch((e)=>void 0) // TODO: Show error message?
        ;
        return ()=>{
            controller.abort();
        };
    }, [
        selectedRegion
    ]);
    const { fields: logicalPortFields, update: updateLogicalPortField, remove: removeLogicalPortField, ...fieldArrayProps } = (0, _reactHookForm.useFieldArray)({
        name: `${namePrefix}.ports`
    });
    (0, _react.useImperativeHandle)(ref, ()=>({
            onAddInterfaceButtonClicked: allocateApplianceAndAddAdditionalLogicalPortToForm
        }));
    const allocateApplianceAndAddAdditionalLogicalPortToForm = async ()=>{
        const applianceId = logicalPort1?._allocation?.appliance.id ?? logicalPort1?.region?.allocatedAppliance?.id;
        const allocationId = logicalPort1?._allocation?.id;
        const excludedAllocationIds = allocationId ? [
            allocationId
        ] : [];
        const allocation = await (applianceId ? allocateSpecificAppliance({
            applianceId,
            excludedAllocationIds
        }) : allocateDifferentAppliance({
            regionId: selectedRegion.id,
            excludedApplianceIds: occupiedAppliances
        }));
        const nextIndex = logicalPorts.length;
        addNewLogicalPortToForm(nextIndex, allocation);
    };
    const updateLogicalPortWithNewAllocatedAppliance = (portIndex)=>{
        const portToUpdate = logicalPorts[portIndex];
        const allocatedApplianceId = portToUpdate._allocation?.appliance.id ?? portToUpdate.region?.allocatedAppliance?.id;
        if (!allocatedApplianceId) return;
        const excludedAllocationIds = logicalPorts.filter((_, i)=>i !== portIndex).map((p)=>p.applianceAllocationId).filter(nonEmptyString);
        allocateSpecificAppliance({
            applianceId: allocatedApplianceId,
            excludedAllocationIds
        }).then((allocation)=>{
            if (!allocation) return;
            updateLogicalPortField(portIndex, {
                ...portToUpdate,
                [isInputForm ? (0, _ipPortForm.CommonFields).applianceAllocationId : (0, _ipPortForm1.CommonFields).applianceAllocationId]: allocation.id,
                _allocation: allocation
            });
        });
    };
    const addNewLogicalPortToForm = (portIndex, allocation)=>{
        if (!allocation) return;
        const logicalPortInit = {
            applianceAllocationId: allocation.id,
            physicalPortId: undefined,
            enforcedMode: areMultipleLogicalPortsSupported ? logicalPort1?.mode : undefined,
            applianceType: (0, _types.ApplianceType).core
        };
        const logicalPort = {
            ...isInputForm ? (0, _inputForm.initialInputLogicalPort)(logicalPortInit) : (0, _outputForm.initialOutputLogicalPort)(logicalPortInit),
            _allocation: allocation
        };
        updateLogicalPortField(portIndex, logicalPort);
    };
    const allocateArbitraryAppliance = (params, options)=>doAllocateAppliance({
            ...params,
            inputId: isInputForm ? undefined : inputId
        }, options);
    const allocateSpecificAppliance = (params, options)=>doAllocateAppliance(params, options);
    const allocateDifferentAppliance = (params, options)=>doAllocateAppliance({
            ...params,
            inputId: isInputForm ? undefined : inputId
        }, options);
    const doAllocateAppliance = async (params, options)=>{
        setAllocationState({
            isAllocating: true,
            error: false
        });
        try {
            const allocation = await (0, _store.Api).portsApi.allocateCoreVideoAppliance({
                ...params,
                purpose: isInputForm ? 'input' : 'output'
            }, options);
            setAllocationState({
                isAllocating: false,
                error: false
            });
            return allocation;
        } catch (e) {
            if ((0, _store.Api).isAborted(e)) return;
            setAllocationState({
                isAllocating: false,
                error: true
            });
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: e,
                operation: 'Allocate appliance'
            }));
            throw e;
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            allocationState.isAllocating && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.Loading), {
                message: `Allocating appliance in region ${selectedRegion.name}...`
            }),
            !allocationState.isAllocating && appliance && isFetchingPhysicalPorts && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.Loading), {
                message: `Fetching appliance interfaces`
            }),
            allocationState.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.Error), {
                message: `Failed allocating appliance in region ${selectedRegion.name}...`
            }),
            listPhysicalPortsError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.Error), {
                message: `Failed fetching appliance interfaces`
            }),
            appliancePhysicalPorts && appliancePhysicalPorts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.LogicalPortForm), {
                isRegional: true,
                namePrefix: namePrefix,
                logicalPorts: logicalPorts,
                fieldArray: {
                    fields: logicalPortFields,
                    update: updateLogicalPortField,
                    remove: removeLogicalPortField,
                    ...fieldArrayProps
                },
                isInputForm: isInputForm,
                adminStatus: adminStatus,
                appliancePhysicalPorts: appliancePhysicalPorts,
                isModeSelectionDisabled: isModeSelectionDisabled,
                enforcedPortMode: enforcedPortMode,
                onAddLogicalPortRequested: onAddLogicalPortRequested
            })
        ]
    });
};
function nonEmptyString(s) {
    return typeof s === 'string' && !!s;
}
const ReferencedComponent = /*#__PURE__*/ (0, _react.forwardRef)(Component);
const RegionalInterfaceSection = ({ myRef, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ReferencedComponent, {
        ...rest,
        ref: myRef
    });

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../../store":"5LXiG","common/api/v1/types":"3qemx","../../inputs/Edit/InputForm":"49oSK","../../outputs/Edit/OutputForm":"btaTu","../../inputs/Edit/PortForm/IpPortForm":"mlnEQ","../../outputs/Edit/PortForm/IpPortForm":"7TpS5","./Base":"gmIdH","../../../utils":"342UB","common/types":"gDFnw","common/api/v1/helpers":"6jovr","../../../utils/physicalPortUtil":"1hoFB","../../../redux/actions/notificationActions":"7LkQg","react-redux":"l1pMU","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"49oSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_MAX_BITRATE_MBPS", ()=>MAX_MAX_BITRATE_MBPS);
parcelHelpers.export(exports, "initialInputLogicalPort", ()=>initialInputLogicalPort);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _types = require("common/api/v1/types");
var _utils = require("../../../utils");
var _store = require("../../../store");
var _form = require("../../common/Form");
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _indicator = require("../../common/Indicator");
var _link = require("../../common/Link");
var _ipPortForm = require("./PortForm/IpPortForm");
var _index = require("./index");
var _rtmpForm = require("./PortForm/IpPortForm/RtmpForm");
var _base = require("../../common/Interface/Base");
var _metadata = require("../../common/Metadata");
var _helpers = require("common/api/v1/helpers");
var _features = require("../../../utils/features");
var _inputsActions = require("../../../redux/actions/inputsActions");
var _ndiForm = require("./PortForm/NdiForm");
var _inputTransformationSection = require("../DerivedInput/InputTransformationSection");
var _notificationActions = require("../../../redux/actions/notificationActions");
var _uuid = require("uuid");
var _tagInputField = require("../../common/TagInputField");
var _srt = require("common/srt");
var _index1 = require("../../serviceOverview/Overview/index");
const { inputApi } = (0, _store.Api);
const MAX_MAX_BITRATE_MBPS = 2147;
const initialInputLogicalPort = ({ physicalPortId, port, enforcedMode, applianceAllocationId, numDistinctFailoverPriorities })=>({
        ...(0, _ipPortForm.udpDefaults)(),
        ...(0, _ipPortForm.rtpDefaults)(),
        ...(0, _ipPortForm.srtDefaults)(numDistinctFailoverPriorities || 0),
        ...(0, _ipPortForm.ristDefaults)(),
        ...(0, _ipPortForm.zixiDefaults)(),
        ...(0, _rtmpForm.rtmpDefaults)(),
        ...(0, _ipPortForm.generatorDefaults)(),
        ...(0, _ndiForm.ndiDefaults)(),
        _port: port,
        [(0, _ipPortForm.CommonFields).mode]: enforcedMode ?? '',
        [(0, _ipPortForm.CommonFields).physicalPort]: physicalPortId,
        [(0, _ipPortForm.CommonFields).applianceAllocationId]: applianceAllocationId,
        // Provide an initial id to use as 'React.key'
        id: _uuid.v4()
    });
const TsParsingMode = ({ disabled, thumbnailMode })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
        label: "Broadcast standard for transport stream analysis",
        name: "broadcastStandard",
        disabled: disabled,
        options: [
            {
                name: 'DVB',
                value: 'dvb'
            },
            {
                name: 'ATSC',
                value: 'atsc'
            },
            {
                name: 'No analysis',
                value: 'none',
                disabled: thumbnailMode === (0, _types.ThumbnailMode).edge
            }
        ],
        tooltip: "Choose broadcast standard for mpeg-ts parsing or disable analysis by choosing 'No analysis'."
    });
};
const UnhealthyAlarmLevel = (_props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
        label: "Alarm level when input is unhealthy",
        name: "unhealthyAlarm",
        options: [
            {
                name: '(No alarm)',
                value: ''
            },
            {
                name: 'Critical',
                value: 'critical'
            },
            {
                name: 'Major',
                value: 'major'
            },
            {
                name: 'Minor',
                value: 'minor'
            },
            {
                name: 'Warning',
                value: 'warning'
            }
        ],
        tooltip: "Choose what type of alarm will be triggered when the input becomes unhealthy."
    });
};
const VideoPreviewModeSelect = ({ disabled })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
        label: "Preview",
        disabled: disabled,
        name: "videoPreviewMode",
        options: Object.values((0, _types.VideoPreviewMode)),
        tooltip: "'on demand' begins generating input preview when requested and is a more efficient alternative to 'always on', which constantly generates input preview and has a faster startup-time. No preview will be available if the input contains multiple video streams. Preview can only be enabled with 'core' thumbnail mode."
    });
};
const thumbnailOptions = [
    {
        name: 'none',
        value: (0, _types.ThumbnailMode).none,
        hoverTooltip: 'thumbnail generation is disabled'
    },
    {
        name: 'core',
        value: (0, _types.ThumbnailMode).core,
        hoverTooltip: `thumbnails are generated on ${(0, _helpers.getProductName)((0, _types.ApplianceType).thumb)} appliances`
    },
    {
        name: 'edge',
        value: (0, _types.ThumbnailMode).edge,
        hoverTooltip: 'thumbnails are generated on the ingress appliance'
    }
];
const ThumbnailModeSelect = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
        label: "Thumbnail mode",
        name: "thumbnailMode",
        options: thumbnailOptions
    });
};
const DeriveFromInputSelect = ({ currentParentInput })=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const api = (0, _react.useCallback)(async (params)=>{
        // Fetch all inputs except derived ones
        const response = await inputApi.getInputs.bind(inputApi)({
            ...params,
            derived: false
        });
        // Remove current form input from response
        const itemsWithoutSelf = response.items.filter((item)=>item.id !== getValues().id);
        return {
            items: itemsWithoutSelf,
            total: itemsWithoutSelf.length
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
        required: true,
        name: "deriveFrom.parentInput",
        label: "Input to transform",
        defaultOption: currentParentInput,
        tooltip: "Search for the input to transform. Other transformed inputs are not shown here",
        api: api,
        getOptionValue: (option)=>option.id,
        getOptionLabel: (option)=>{
            return option.name;
        },
        optionComparator: (o1, o2)=>o1.id === o2.id,
        "data-test-id": "deriveFrom.parent"
    }, currentParentInput?.id);
};
const DerivedInput = ({ currentParentInput })=>{
    const { getValues, watch } = (0, _reactHookForm.useFormContext)();
    const derivedKey = '_derived';
    watch(derivedKey);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                name: derivedKey,
                label: "Transform input"
            }),
            !!getValues()._derived && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeriveFromInputSelect, {
                currentParentInput: currentParentInput
            })
        ]
    });
};
const InputForm = (form)=>{
    const routes = (0, _store.useRoutes)();
    const { getValues, setError, setFocus, setValue, formState, defaultValues, watch, trigger: validateForm, reset } = form;
    const values = getValues();
    const user = (0, _utils.useUser)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const setConfirm = (0, _utils.useConfirmationDialog)();
    const { devMode, settings } = (0, _utils.useSettingsSelector)();
    const editType = (0, _index.useEditType)();
    watch('thumbnailMode');
    const [currentParentInput, setCurrentParentInput] = (0, _react.useState)();
    const { isSaving, isRerouting, formErrors } = (0, _reactRedux.useSelector)(({ inputsReducer })=>({
            isSaving: inputsReducer.saving,
            isRerouting: inputsReducer.rerouting,
            formErrors: inputsReducer.formErrors
        }), (0, _reactRedux.shallowEqual));
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach(({ name, reason })=>{
                setError(name, {
                    type: 'manual',
                    message: reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    // reset on changed editType
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _react.useEffect)(()=>reset(defaultValues), [
        editType,
        reset
    ]);
    const selectedThumbnailMode = values.thumbnailMode;
    const thumbnailModeSupportsPreview = selectedThumbnailMode === (0, _types.ThumbnailMode).core;
    const videoPreviewMode = values.videoPreviewMode;
    (0, _react.useEffect)(()=>{
        function disablePreviewIfThumbnailingDisabled() {
            if (!thumbnailModeSupportsPreview && videoPreviewMode && videoPreviewMode !== (0, _types.VideoPreviewMode).off) setValue('videoPreviewMode', (0, _types.VideoPreviewMode).off);
        }
        disablePreviewIfThumbnailingDisabled();
    }, [
        thumbnailModeSupportsPreview,
        videoPreviewMode,
        setValue
    ]);
    const selectedBroadcastStandard = values.broadcastStandard;
    (0, _react.useEffect)(()=>{
        const shouldEnableBroadcastStandard = selectedThumbnailMode === (0, _types.ThumbnailMode).edge && selectedBroadcastStandard === 'none';
        if (shouldEnableBroadcastStandard) setValue('broadcastStandard', settings?.defaultBroadcastStandard ?? (0, _types.BroadcastStandard).dvb);
    }, [
        selectedBroadcastStandard,
        selectedThumbnailMode,
        settings
    ]);
    // Fetch current select parent input and save in local state to avoid fetching it multiple times in child components
    (0, _react.useEffect)(()=>{
        const parentInputId = values.deriveFrom?.parentInput;
        if (!parentInputId) {
            setCurrentParentInput(undefined);
            return;
        }
        let cancelled = false;
        inputApi.getInput(parentInputId).then((input)=>{
            if (cancelled) // The useEffect cleanup has run and the component may have been unmounted
            return;
            setCurrentParentInput(input);
        }).catch((err)=>{
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: err,
                operation: 'fetch input to transform'
            }));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        values.deriveFrom?.parentInput,
        setValue
    ]);
    // Switch broadcast standard to mirror the current selected parent input
    (0, _react.useEffect)(()=>{
        if (currentParentInput === undefined) return;
        setValue('broadcastStandard', currentParentInput.broadcastStandard);
        setValue('handoverMethod', currentParentInput.handoverMethod);
    }, [
        currentParentInput,
        setValue
    ]);
    const coreNodes = (0, _metadata.getCoreNodesInput)(values);
    const onRemoveInputAppliance = (index)=>removeApplianceSection(index);
    const initialApplianceSections = (0, _base.collectApplianceSectionEntries)(defaultValues);
    const applianceSectionEntries = (0, _base.collectApplianceSectionEntries)(values);
    const { fields: applianceSectionFields, append: appendApplianceSection, remove: removeApplianceSection, update: updateApplianceSection } = (0, _reactHookForm.useFieldArray)({
        name: (0, _base.APPLIANCE_SECTION_FORM_PREFIX)
    });
    const adminStatus = (0, _getDefault.default)(values, 'adminStatus') ? 1 : 0;
    const applianceSections = applianceSectionFields.map((field, applianceIndex)=>{
        const data = applianceSectionEntries[applianceIndex];
        const key = field.id;
        const isModeSelectionDisabled = data.ports.length > 1;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.ApplianceSection), {
            applianceIndex: applianceIndex,
            title: `Input appliance #${applianceIndex + 1}`,
            namePrefix: `${(0, _base.APPLIANCE_SECTION_FORM_PREFIX)}.${applianceIndex}`,
            adminStatus: adminStatus,
            initialApplianceOrRegionId: initialApplianceSections[applianceIndex]?.region?.id ?? initialApplianceSections[applianceIndex]?.appliance?.id,
            isModeSelectionDisabled: isModeSelectionDisabled,
            onRemove: applianceSectionFields.length > 1 ? onRemoveInputAppliance : undefined,
            inputId: editType.isUpdate ? values.id : undefined,
            outputId: undefined,
            groupId: values.owner ?? user.group,
            isInputForm: true,
            enforcedPortMode: undefined,
            isEditingExistingEntity: editType.isUpdate,
            isCopyingExistingEntity: editType.isCopy,
            isApplianceOrRegionSelectable: (option)=>(0, _base.isApplianceOrRegionSelectable)(option, values, false),
            onApplianceOrRegionSelected: (selected)=>{
                if (!selected) updateApplianceSection(applianceIndex, (0, _base.makeApplianceSection)({
                    region: undefined,
                    appliance: undefined
                }));
                else if ((0, _base.isAppliance)(selected)) {
                    const applianceSection = (0, _base.makeApplianceSection)({
                        region: undefined,
                        appliance: selected
                    });
                    updateApplianceSection(applianceIndex, applianceSection);
                } else {
                    const regionalSection = (0, _base.makeApplianceSection)({
                        region: selected,
                        appliance: undefined
                    });
                    updateApplianceSection(applianceIndex, regionalSection);
                }
            },
            ...form
        }, key);
    });
    const transportStreamContent = (0, _helpers.getFormattedTransportStreamContent)((values.tsInfo || [])[0]);
    const contentFormat = transportStreamContent === 'MPTS' ? 'MPTS' : `${transportStreamContent} (${(0, _helpers.tsInfoServiceName)((values.tsInfo || [])[0])})`;
    const redundancyCheckboxDisabled = (0, _base.isCoreNode)(values) || values._derived;
    const getRedundancyTooltip = ()=>{
        if (!values._redundant && redundancyCheckboxDisabled) {
            // Checkbox can be disabled but redundancy enabled "by force", e.g. RTP-over-SRT for MA-core-inputs
            if ((0, _base.isCoreNode)(values)) return 'Not possible to enable redundancy when using a core appliance for the input.';
            if (values._derived) return 'Not possible to enable redundancy for a transformation.';
            return undefined;
        }
        return "Redundancy enabled will route the input stream through an additional path in the input appliance's region(s).";
    };
    const showTransformationSection = values._derived && currentParentInput !== undefined;
    const showApplianceSections = !values._derived;
    const canAddAdditionalInputAppliance = applianceSectionEntries.length === 1;
    const allLogicalPorts = applianceSectionEntries.flatMap((s)=>s.ports);
    const isCoreVideoInput = allLogicalPorts.some((lp)=>(0, _base.getPortAppliance)(lp)?.type === (0, _types.ApplianceType).core);
    const areStreamsMergable = allLogicalPorts.every((lp)=>(0, _srt.isRtpOverSrt)(lp));
    const isMultiAppliance = new Set(allLogicalPorts.map((lp)=>(0, _base.getPortAppliance)(lp)?.id).filter((0, _helpers.notUndefinedOrNull))).size > 1;
    const isRedundant = values._redundant;
    const mustBeRedundant = isMultiAppliance && isCoreVideoInput && areStreamsMergable;
    const canBeRedundant = mustBeRedundant || !isCoreVideoInput;
    (0, _react.useEffect)(()=>{
        function ensureCorrectRedundancy() {
            if (!canBeRedundant && isRedundant) setValue('_redundant', false);
            else if (mustBeRedundant && !isRedundant) setValue('_redundant', true);
        }
        ensureCorrectRedundancy();
    }, [
        canBeRedundant,
        isRedundant,
        mustBeRedundant,
        setValue
    ]);
    (0, _reactHookForm.useWatch)({
        name: '_redundant'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                formState: formState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "input-form",
                noValidate: true,
                disableSubmitOnEnterKey: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        className: "outlined",
                        title: "Metadata",
                        collapsible: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        name: "name",
                                        label: "Input name",
                                        required: true,
                                        autoFocus: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                        name: "adminStatus",
                                        label: "Enabled",
                                        onClick: ()=>void validateForm()
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                        name: "_redundant",
                                        label: "Redundant",
                                        disabled: redundancyCheckboxDisabled,
                                        tooltip: getRedundancyTooltip()
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagInputField.TagInputField), {
                                        formName: 'tags',
                                        type: 'input'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbnailModeSelect, {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(VideoPreviewModeSelect, {
                                        disabled: !thumbnailModeSupportsPreview
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        noNegative: true,
                                        name: "maxBitrateMbps",
                                        label: "Max bitrate (Mbps)",
                                        validators: {
                                            number: {
                                                lessThanOrEqualTo: MAX_MAX_BITRATE_MBPS,
                                                greaterThan: 0,
                                                message: `Must be greater than zero and no more than ${MAX_MAX_BITRATE_MBPS}`
                                            }
                                        },
                                        type: "number",
                                        tooltip: "Maximum bitrate allowed including retransmission. Packets exceeding the maximum bitrate will be dropped."
                                    }),
                                    devMode && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        name: "bufferSize",
                                        label: "Buffer duration (ms)",
                                        required: true,
                                        type: "number"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(TsParsingMode, {
                                        disabled: values._derived,
                                        thumbnailMode: selectedThumbnailMode
                                    }),
                                    settings && (0, _features.isFeatureOn)((0, _types.ExpFeatures).ExtHealthAlarms, settings) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnhealthyAlarmLevel, {}),
                                    settings && (0, _features.isFeatureOn)((0, _types.ExpFeatures).ExtDerivedInput, settings) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DerivedInput, {
                                        currentParentInput: currentParentInput
                                    })
                                ]
                            }),
                            editType.isUpdate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                    lg: 12,
                                    xl: 12,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                                        values: {
                                            Id: values.id,
                                            Tags: (defaultValues.tags ?? []).flatMap((tag, i)=>{
                                                const defaultOrder = settings?.expFeatures?.ExtHealthAlarms ? (0, _types.ListInputSortableField).healthStatus : undefined;
                                                const link = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                                    to: routes.events({
                                                        tags: tag,
                                                        desc: defaultOrder
                                                    }),
                                                    underline: "hover",
                                                    children: tag
                                                });
                                                return i === 0 ? link : [
                                                    ', ',
                                                    link
                                                ];
                                            }),
                                            Created: (0, _dateFns.format)(new Date(values.createdAt), (0, _helpers.DATE_FORMAT_LONG)),
                                            Updated: (0, _dateFns.format)(new Date(values.updatedAt), (0, _helpers.DATE_FORMAT_LONG)),
                                            Access: values.canSubscribe ? 'Full Access' : 'Preview',
                                            Owner: !!values._owner?.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                                to: routes.groupsUpdate({
                                                    id: values._owner.id
                                                }),
                                                underline: "hover",
                                                available: (0, _utils.isEditableGroup)(values._owner.id, user),
                                                children: values._owner?.name
                                            }),
                                            Status: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AutoUpdatingInputHealthIndicator), {
                                                initialInput: values,
                                                inline: true
                                            }),
                                            Format: contentFormat,
                                            [`Input ${(0, _utils.pluralizeWord)(values.appliances?.length ?? 0, 'appliance')}`]: (0, _metadata.applianceList)(values.appliances ?? [], user),
                                            [`Core video ${(0, _utils.pluralizeWord)(coreNodes.length, 'node')}`]: (0, _metadata.applianceList)(coreNodes, user),
                                            'Service Overview': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.ServiceOverviewButton), {
                                                input: values
                                            })
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    showTransformationSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputTransformationSection.InputTransformationSection), {
                        currentParentInput: currentParentInput
                    }),
                    showApplianceSections && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            applianceSections,
                            canAddAdditionalInputAppliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                sx: {
                                    marginBottom: 2
                                },
                                variant: "contained",
                                color: "secondary",
                                onClick: ()=>{
                                    const emptySection = (0, _base.makeApplianceSection)({
                                        region: undefined,
                                        appliance: undefined
                                    });
                                    appendApplianceSection(emptySection);
                                },
                                children: "Add input appliance"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>void navigate(routes.inputs())
                            },
                            Save: {
                                savingState: isSaving,
                                primary: true,
                                type: 'submit'
                            }
                        },
                        secondary: editType.isUpdate ? {
                            'Delete input': {
                                onClick: ()=>{
                                    setConfirm(()=>void dispatch((0, _inputsActions.removeInput)({
                                            inputId: values.id,
                                            redirect: true
                                        })), `Deleting input "${values.name}". Are you sure?`);
                                }
                            },
                            DUPLICATE: {
                                onClick: ()=>void navigate(routes.inputsCopy({
                                        id: values.id
                                    }))
                            },
                            ...devMode ? {
                                Reroute: {
                                    onClick: ()=>void dispatch((0, _inputsActions.rerouteInput)({
                                            inputId: values.id
                                        })),
                                    savingState: isRerouting
                                }
                            } : {}
                        } : undefined
                    })
                ]
            })
        ]
    });
};
exports.default = InputForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","react-hook-form":"8z0aI","date-fns":"gelMX","lodash/get":"dBTJh","@mui/material/Button":"3qJY9","common/api/v1/types":"3qemx","../../../utils":"342UB","../../../store":"5LXiG","../../common/Form":"4Mui7","../../common/DataSet":"dmQXG","../../common/Indicator":"hqaQa","../../common/Link":"l3o6V","./PortForm/IpPortForm":"mlnEQ","./index":"7E6Sj","./PortForm/IpPortForm/RtmpForm":"bM9uI","../../common/Interface/Base":"gmIdH","../../common/Metadata":"bH3nG","common/api/v1/helpers":"6jovr","../../../utils/features":"iOvTk","../../../redux/actions/inputsActions":"l0Ua8","./PortForm/NdiForm":"BtS8k","../DerivedInput/InputTransformationSection":"kRU73","../../../redux/actions/notificationActions":"7LkQg","uuid":"dccyI","../../common/TagInputField":"cjjJd","common/srt":"9Ptuu","../../serviceOverview/Overview/index":"1D7NB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bM9uI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RtmpFields", ()=>RtmpFields);
parcelHelpers.export(exports, "rtmpDefaults", ()=>rtmpDefaults);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _whitelistCidrBlockAutoComplete = require("../../../../common/WhitelistCidrBlockAutoComplete");
var _suggestedPortTextField = require("../../../../common/SuggestedPortTextField");
var _reactHookForm = require("react-hook-form");
var RtmpFields = /*#__PURE__*/ function(RtmpFields) {
    RtmpFields["address"] = "address";
    RtmpFields["port"] = "port";
    RtmpFields["whitelistCidrBlock"] = "whitelistCidrBlock";
    return RtmpFields;
}({});
const rtmpDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(RtmpFields), [], {
        ["whitelistCidrBlock"]: []
    });
const RtmpForm = ({ addresses, namePrefix, occupiedPorts, adminStatus, applianceType })=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const addressSelector = `${namePrefix}.${"address"}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: addressSelector,
                label: "Address",
                required: true,
                options: (0, _utils.makeAddressOptions)(getValues(addressSelector), addresses),
                newLine: true,
                validators: {
                    addressIn: {
                        addresses
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _suggestedPortTextField.SuggestedLocalPortTextField), {
                name: `${namePrefix}.${"port"}`,
                label: 'Port',
                namePrefix: namePrefix,
                required: true,
                portInfo: {
                    mode: (0, _types.IpPortMode).rtmp,
                    isInput: true,
                    existingLogicalPortsOnSameNic: occupiedPorts,
                    isPortDisabled: adminStatus === (0, _types.InputAdminStatus).off
                }
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _whitelistCidrBlockAutoComplete.WhitelistCidrBlockAutoComplete), {
                name: `${namePrefix}.${"whitelistCidrBlock"}`,
                required: (0, _utils.isCoreNode)(applianceType)
            })
        ]
    });
};
exports.default = RtmpForm;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","common/applianceTypeUtil":"3z9on","../../../../common/WhitelistCidrBlockAutoComplete":"91kUs","../../../../common/SuggestedPortTextField":"1iSAC","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bH3nG":[function(require,module,exports,__globalThis) {
// Might want to include owner when we display appliance name,
// but since this is currently only used for linking a core node
// I'm leaving it out
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCoreNodesInput", ()=>getCoreNodesInput);
parcelHelpers.export(exports, "getCoreNodesOutput", ()=>getCoreNodesOutput);
parcelHelpers.export(exports, "applianceList", ()=>applianceList);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _link = require("./Link");
var _utils = require("../../utils");
var _store = require("../../store");
const ApplianceLink = ({ appliance })=>{
    const routes = (0, _store.useRoutes)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        to: routes.appliancesUpdate({
            id: appliance.id
        }),
        underline: "hover",
        children: appliance.name
    });
};
function getCoreNodesInput(values) {
    if (values.appliances && values.appliances[0]?.type === (0, _types.ApplianceType).core) return values.appliances;
    if (values.downstreamAppliances.length) return values.downstreamAppliances;
    return [];
}
function getCoreNodesOutput(values) {
    if (values.appliances && values.appliances[0].type === (0, _types.ApplianceType).core) return values.appliances;
    if (values.upstreamAppliances.length) return values.upstreamAppliances.filter((a)=>a.type === (0, _types.ApplianceType).core);
    return [];
}
function applianceList(appliances, user) {
    if (appliances.length === 0) return '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: appliances.map((appliance, i, arr)=>{
            const components = [
                (0, _utils.hasAccessToAppliance)(appliance, user) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ApplianceLink, {
                    appliance: appliance
                }, appliance.id) : appliance.name
            ];
            if (i !== arr.length - 1) components.push(', ');
            return components;
        }).flat()
    });
}

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","./Link":"l3o6V","../../utils":"342UB","../../store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iOvTk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getExperimentalDevFeatures", ()=>getExperimentalDevFeatures);
parcelHelpers.export(exports, "getExperimentalExternalFeatures", ()=>getExperimentalExternalFeatures);
parcelHelpers.export(exports, "isFeatureOn", ()=>isFeatureOn);
var _types = require("common/api/v1/types");
var _env = require("../env");
const featureNames = {
    ExtDerivedInput: 'Stream transformations',
    ExtSelectableDelayMode: 'Choose output delay mode',
    ExtHealthAlarms: 'Health alarms',
    AllowLegacyExternalRegions: 'Allow legacy external regions (< R3.14.0)',
    OASResponseValidation: 'OAS response validation',
    AdInsertion: 'Ad Insertion'
};
function getExperimentalDevFeatures() {
    return Object.keys((0, _types.ExpFeatures)).filter((key)=>!key.startsWith('Ext')).filter((key)=>!(key === 'AdInsertion' && (0, _env.IS_CONNECT_IT))).map((key)=>({
            name: key,
            label: featureNames[key] || key
        }));
}
function getExperimentalExternalFeatures() {
    return Object.keys((0, _types.ExpFeatures)).filter((key)=>key.startsWith('Ext')).map((key)=>({
            name: key,
            label: featureNames[key] || key.replace(/^Ext/, '')
        }));
}
function isFeatureOn(feature, settings) {
    return !!settings.expFeatures[feature];
}

},{"common/api/v1/types":"3qemx","../env":"cPu8n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"BtS8k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NdiFields", ()=>NdiFields);
parcelHelpers.export(exports, "ndiDefaults", ()=>ndiDefaults);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("../../../../utils");
var _form = require("../../../common/Form");
var _reactAsyncHook = require("react-async-hook");
var _store = require("../../../../store");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _cached = require("@mui/icons-material/Cached");
var _cachedDefault = parcelHelpers.interopDefault(_cached);
var _react = require("react");
var _common = require("../../../../Common");
var _reactHookForm = require("react-hook-form");
var NdiFields = /*#__PURE__*/ function(NdiFields) {
    NdiFields["name"] = "name";
    return NdiFields;
}({});
const ndiDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(NdiFields), []);
const { appliancesApi } = (0, _store.Api);
const emptyNdiSource = {
    name: 'No sources available',
    value: undefined,
    disabled: true
};
const NdiForm = ({ applianceId, namePrefix })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const logicalPort = getValues(namePrefix);
    const modeKey = `${namePrefix}.mode`;
    const sourceKey = `${namePrefix}.${"name"}`;
    watch(modeKey);
    watch(sourceKey);
    const selectedMode = logicalPort.mode;
    const modeOptions = (0, _react.useMemo)(()=>[
            {
                name: 'NDI',
                value: 'comprimatoNdi'
            }
        ], []);
    (0, _react.useEffect)(()=>{
        const defaultMode = modeOptions[0];
        const isValidMode = modeOptions.some((m)=>m.value === selectedMode);
        if (!isValidMode && defaultMode) setValue(modeKey, defaultMode.value);
    }, [
        modeKey,
        setValue,
        modeOptions,
        selectedMode
    ]);
    const [refreshSources, setRefreshSources] = (0, _react.useState)(false);
    const { result: ndiSourcesListResult, loading: isFetchingNdiSources } = (0, _reactAsyncHook.useAsync)(async ()=>appliancesApi.listApplianceNdiSources(applianceId), [
        applianceId,
        refreshSources
    ]);
    const sourceOptions = ndiSourcesListResult?.items.map((it)=>({
            name: it.name,
            value: it.name
        })) || [];
    const hasSelectedSource = (logicalPort.name?.length ?? 0) > 0;
    const isSelectedSourceAvailable = sourceOptions.some((s)=>s.value === logicalPort.name);
    if (hasSelectedSource && !isSelectedSourceAvailable) sourceOptions.push({
        name: `${logicalPort.name} (unavailable)`,
        value: logicalPort.name,
        disabled: true
    });
    else if (sourceOptions.length === 0) sourceOptions.push(emptyNdiSource);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Mode",
                name: modeKey,
                xs: 4,
                lg: 4,
                xl: 4,
                required: true,
                newLine: true,
                options: modeOptions,
                disabled: selectedMode && modeOptions.length === 1,
                validators: {
                    oneOf: {
                        validValues: new Set(modeOptions.filter((o)=>!o.disabled).map(({ value })=>value))
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.GridItem), {
                xs: 8,
                lg: 8,
                xl: 8,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        disabled: isFetchingNdiSources,
                        label: "Source",
                        name: sourceKey,
                        required: true,
                        options: sourceOptions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                        disabled: isFetchingNdiSources,
                        onClick: ()=>!isFetchingNdiSources && setRefreshSources((prev)=>!prev),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cachedDefault.default), {
                            sx: isFetchingNdiSources ? (0, _common.styles).rotating : {}
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = NdiForm;

},{"react/jsx-runtime":"1dlk8","../../../../utils":"342UB","../../../common/Form":"4Mui7","react-async-hook":"3D6Y9","../../../../store":"5LXiG","@mui/material/IconButton":"488As","@mui/icons-material/Cached":"k4ZaR","react":"9njXz","../../../../Common":"7DOrW","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kRU73":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputTransformationSection", ()=>InputTransformationSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _transcodingSection = require("./TranscodingSection");
var _mptsDemuxSection = require("./MptsDemuxSection");
var _form = require("../../common/Form");
var _audioReshuffling = require("./AudioReshuffling");
var _utils = require("../../../utils");
var _reactHookForm = require("react-hook-form");
const InputTransformationSection = ({ currentParentInput })=>{
    const { getValues, watch } = (0, _reactHookForm.useFormContext)();
    const { devMode } = (0, _utils.useSettingsSelector)();
    const [transformation, setTransformation] = (0, _react.useState)('');
    const values = getValues();
    // Watch specific fields that control conditional rendering
    watch('deriveFrom.ingestTransform.type');
    (0, _react.useEffect)(()=>{
        if (values.deriveFrom?.ingestTransform?.type) setTransformation(values.deriveFrom.ingestTransform.type);
    }, [
        values.deriveFrom?.ingestTransform?.type
    ]);
    const options = [
        {
            name: (0, _utils.formatTransformationType)('mpts-demux'),
            value: 'mpts-demux'
        }
    ];
    if (devMode) options.push({
        name: (0, _utils.formatTransformationType)('transcode'),
        value: 'transcode'
    }, {
        name: (0, _utils.formatTransformationType)('audio-reshuffling'),
        value: 'audio-reshuffling'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        className: "outlined",
        title: "Transformation",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                    label: "Select transformation",
                    name: "deriveFrom.ingestTransform.type",
                    options: options
                }),
                transformation === 'mpts-demux' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        xs: 12
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mptsDemuxSection.MptsDemuxSection), {
                        currentParentInput: currentParentInput
                    })
                }),
                transformation === 'transcode' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transcodingSection.TranscodingSection), {}),
                transformation === 'audio-reshuffling' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _audioReshuffling.AudioReshuffling), {
                    currentParentInput: currentParentInput
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Grid":"6iX4B","./TranscodingSection":"cXGEe","./MptsDemuxSection":"3KHhO","../../common/Form":"4Mui7","./AudioReshuffling":"7MCKI","../../../utils":"342UB","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cXGEe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TranscodingSection", ()=>TranscodingSection);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../components/common/Form");
var _store = require("../../../store");
var _inputForm = require("../Edit/InputForm");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _reactAsyncHook = require("react-async-hook");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _ffmpegParamsInputsAudio = require("./FFmpegParamsInputsAudio");
const TranscodingSection = ()=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    // Watch specific fields that control conditional rendering
    const paramsKey = 'deriveFrom.ingestTransform.ffmpegParams';
    watch(`${paramsKey}.codec`);
    watch(`${paramsKey}.overlay`);
    watch(`${paramsKey}.resolution`);
    watch(`${paramsKey}.pixelFormat`);
    watch(`${paramsKey}.bitrateMode`);
    const ffmpegParams = values?.deriveFrom?.ingestTransform?.type === 'transcode' ? values?.deriveFrom?.ingestTransform.ffmpegParams : undefined;
    const isVideoCodec = !!ffmpegParams?.codec;
    const isOverlay = !!ffmpegParams?.overlayId;
    const isResolution = !!ffmpegParams?.resolution;
    const isPixelFormat = !!ffmpegParams?.pixelFormat;
    const isDeinterlacing = !!ffmpegParams?.deinterlace;
    const isCBR = ffmpegParams?.bitrateMode === 'CBR';
    (0, _react.useEffect)(()=>{
        // If codec is not set, reset dependent fields
        if (!isVideoCodec) {
            setValue('transcodeTotalBitrateMbps', '');
            setValue('transcodeVideoBitrateMbps', '');
            setValue(`${paramsKey}.resolution`, undefined);
            setValue(`${paramsKey}.overlayId`, undefined);
            setValue(`${paramsKey}.pixelFormat`, undefined);
            setValue(`${paramsKey}.framerate`, undefined);
        }
    }, [
        isVideoCodec,
        setValue
    ]);
    (0, _react.useEffect)(()=>{
        if (values?.deriveFrom?.ingestTransform?.type === 'transcode') {
            if (values?.deriveFrom?.ingestTransform?.ffmpegParams?.type !== 'transcode') setValue(`deriveFrom.ingestTransform.ffmpegParams.type`, 'transcode');
        }
    }, [
        values?.deriveFrom?.ingestTransform
    ]);
    // Get initial overlay
    const initOverlay = (0, _reactAsyncHook.useAsync)(async ()=>{
        const transform = values.deriveFrom?.ingestTransform;
        if (!transform || transform.type !== 'transcode' || !transform.ffmpegParams.overlayId) return;
        return (0, _store.Api).overlaysApi.getOverlay(transform.ffmpegParams.overlayId);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Transcoding",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Video codec",
                name: "deriveFrom.ingestTransform.ffmpegParams.codec",
                options: [
                    {
                        name: 'Keep original',
                        value: ''
                    },
                    {
                        name: 'H.264 (AVC)',
                        value: 'h264'
                    },
                    {
                        name: 'H.265 (HEVC)',
                        value: 'h265'
                    }
                ],
                tooltip: "Change codec using hardware acceleration"
            }),
            isVideoCodec && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: 'Bitrate control mode (VBR/CBR)',
                        name: "deriveFrom.ingestTransform.ffmpegParams.bitrateMode",
                        options: [
                            {
                                name: 'VBR - Variable bitrate',
                                value: 'VBR'
                            },
                            {
                                name: 'CBR - Constant bitrate',
                                value: 'CBR'
                            }
                        ],
                        tooltip: "Choose between Variable Bitrate (VBR) or Constant Bitrate (CBR) mode"
                    }),
                    isCBR && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        label: "Total Bitrate (Mbps)",
                        name: "transcodeTotalBitrateMbps",
                        required: true,
                        noNegative: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: (0, _inputForm.MAX_MAX_BITRATE_MBPS),
                                greaterThan: 0,
                                message: `Must be greater than zero and no more than ${(0, _inputForm.MAX_MAX_BITRATE_MBPS)}`
                            }
                        },
                        type: "number",
                        tooltip: "Set the total constant bitrate for the output transport stream. Must be large enough to accommodate the video and audio streams"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        label: "Video Bitrate (Mbps)",
                        name: "transcodeVideoBitrateMbps",
                        noNegative: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: (0, _inputForm.MAX_MAX_BITRATE_MBPS),
                                greaterThan: 0,
                                message: `Must be greater than zero and no more than ${(0, _inputForm.MAX_MAX_BITRATE_MBPS)}`
                            }
                        },
                        type: "number",
                        tooltip: "Adjust the compression level by setting the target bitrate for the video encoder",
                        newLine: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "Framerate",
                        name: "deriveFrom.ingestTransform.ffmpegParams.framerate",
                        options: [
                            {
                                name: 'Keep original',
                                value: ''
                            }
                        ].concat([
                            {
                                name: '25',
                                value: '25'
                            },
                            {
                                name: '29.97',
                                value: '30000/1001'
                            },
                            {
                                name: '50',
                                value: '50'
                            },
                            {
                                name: '59.94',
                                value: '60000/1001'
                            }
                        ].map((framerate)=>({
                                name: framerate.name,
                                value: framerate.value
                            }))),
                        tooltip: "Convert framerate up or down, dropping extra frames or duplicating intermediate frames"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: !isResolution ? 'Pixel format' : 'Pixel format (cannot be used with resolution scaling)',
                        name: "deriveFrom.ingestTransform.ffmpegParams.pixelFormat",
                        options: [
                            {
                                name: 'Keep original',
                                value: ''
                            },
                            {
                                name: 'YUV 4:2:0 Progressive',
                                value: 'yuv420p'
                            },
                            {
                                name: 'YUV 4:2:2 Progressive',
                                value: 'yuv422p',
                                disabled: true
                            },
                            {
                                name: 'YUV 4:4:4 Progressive',
                                value: 'yuv444p'
                            }
                        ],
                        tooltip: "Pixel format choice depends on the hardware accelerator's capability. Cannot be used with resolution scaling",
                        disabled: isResolution
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                        pending: initOverlay.loading,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                            label: !(isResolution || isDeinterlacing) ? 'Overlay' : 'Overlay (cannot be used with resolution scaling or deinterlacing)',
                            name: "deriveFrom.ingestTransform.ffmpegParams.overlayId",
                            tooltip: "Add a channel logo or other overlays to the transformed input. Cannot be used with resolution scaling",
                            disabled: isResolution || isDeinterlacing,
                            defaultOption: initOverlay.result,
                            api: (params)=>{
                                return (0, _store.Api).overlaysApi.listOverlays(params);
                            },
                            getOptionValue: (overlay)=>overlay.id,
                            getOptionLabel: (overlay)=>overlay.name,
                            getOptionKey: (overlay)=>overlay.id,
                            optionComparator: (o1, o2)=>o1.id === o2.id
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: !(isOverlay || isPixelFormat) ? 'Resolution scaling' : 'Resolution scaling (cannot be used with overlay or pixel format)',
                        name: "deriveFrom.ingestTransform.ffmpegParams.resolution",
                        options: [
                            {
                                name: 'Keep original',
                                value: ''
                            },
                            {
                                name: '2160p',
                                value: '3840:2160'
                            },
                            {
                                name: '1080p',
                                value: '1920:1080'
                            },
                            {
                                name: '720p',
                                value: '1280:720'
                            }
                        ],
                        tooltip: "Scale the resolution of the transformed input (Only available with NVIDIA accelerators). Cannot be used with overlay or pixel format",
                        disabled: isOverlay || isPixelFormat
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: !isOverlay ? 'Deinterlace' : 'Deinterlace (cannot be used with overlay)',
                        name: "deriveFrom.ingestTransform.ffmpegParams.deinterlace",
                        options: [
                            {
                                name: 'Keep original',
                                value: ''
                            },
                            {
                                name: 'Deinterlace',
                                value: 'yadif'
                            }
                        ],
                        tooltip: "Enable or disable YADIF deinterlacing. Only enable on interlaced video inputs. Cannot be used with overlays",
                        disabled: isOverlay
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                sx: {
                    width: '100%',
                    mt: 3
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ffmpegParamsInputsAudio.FFmpegParamsInputsAudio), {})
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","../../../components/common/Form":"4Mui7","../../../store":"5LXiG","../Edit/InputForm":"49oSK","@mui/material/Divider":"9Ul8c","react":"9njXz","react-hook-form":"8z0aI","react-async-hook":"3D6Y9","../../common/Pendable":"gDN67","./FFmpegParamsInputsAudio":"8kjBL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8kjBL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FFmpegParamsInputsAudio", ()=>FFmpegParamsInputsAudio);
var _jsxRuntime = require("react/jsx-runtime");
var _reactHookForm = require("react-hook-form");
var _form = require("../../common/Form");
const MAX_MAX_BITRATE_AAC = 1000;
const FFmpegParamsInputsAudio = ({ isReshuffling })=>{
    const { getValues, watch } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    watch('deriveFrom.ingestTransform.ffmpegParams.audioCodec');
    const wantedTransformType = isReshuffling ? 'audio-reshuffling' : 'transcode';
    const ffmpegParams = values?.deriveFrom?.ingestTransform?.type === wantedTransformType ? values?.deriveFrom?.ingestTransform.ffmpegParams : undefined;
    const isAudioCodec = !!ffmpegParams?.audioCodec;
    const isAac = ffmpegParams?.audioCodec === 'aac';
    const isAacQuality = !!ffmpegParams?.audioAacQuality;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Audio codec",
                name: "deriveFrom.ingestTransform.ffmpegParams.audioCodec",
                options: [
                    ...!isReshuffling ? [
                        {
                            name: 'Keep original',
                            value: ''
                        }
                    ] : [],
                    {
                        name: 'AAC',
                        value: 'aac'
                    },
                    {
                        name: 'MP2',
                        value: 'mp2'
                    },
                    {
                        name: 'AC3',
                        value: 'ac3'
                    }
                ],
                tooltip: !isReshuffling ? 'Change audio codec' : 'Output audio codec will be applied to all reshuffled streams',
                required: isReshuffling
            }),
            isAudioCodec && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                label: "Audio Bitrate (kbps)",
                name: "transcodeAudioBitrateKbps",
                noNegative: true,
                validators: {
                    number: {
                        lessThanOrEqualTo: MAX_MAX_BITRATE_AAC,
                        greaterThan: 0,
                        message: `Must be greater than zero and no more than ${MAX_MAX_BITRATE_AAC}`
                    }
                },
                type: "number",
                disabled: isAacQuality
            }),
            isAac && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "AAC Profile",
                        name: "deriveFrom.ingestTransform.ffmpegParams.audioAacProfile",
                        options: [
                            {
                                name: 'LC',
                                value: 'LC'
                            },
                            {
                                name: 'HE',
                                value: 'HE'
                            },
                            {
                                name: 'HEv2',
                                value: 'HEv2'
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "AAC Quality",
                        name: "deriveFrom.ingestTransform.ffmpegParams.audioAacQuality",
                        options: [
                            {
                                name: 'Disable',
                                value: ''
                            },
                            {
                                name: 'Low',
                                value: 'low'
                            },
                            {
                                name: 'Medium',
                                value: 'medium'
                            },
                            {
                                name: 'High',
                                value: 'high'
                            }
                        ],
                        tooltip: "Uses a variable bitrate target. Overrides the constant bitrate setting chosen in: Audio Bitrate (kbps)"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-hook-form":"8z0aI","../../common/Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3KHhO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MptsDemuxSection", ()=>MptsDemuxSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _pendable = require("../../../components/common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _form = require("../../common/Form");
var _pidMapTable = require("./PidMapTable");
var _reactHookForm = require("react-hook-form");
const MptsDemuxSection = ({ currentParentInput })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: "Service filter",
                tooltip: "Services/programs selected here will be kept and all others will be removed.  Constant bit rate transport streams will become variable bit rate transport streams when a service filter is applied.",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ServiceFilterSection, {
                    currentParentInput: currentParentInput
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: "PID remapping",
                tooltip: "Note that PID remapping may cause constant bit rate transport streams to become variable bit rate transport streams.  Null-packets will be kept in the stream in the absence of PID deletion rules. This means a constant bit rate stream will continue having constant bit rate. Note also that if this is combined with a service filter the null-packets will still be kept but the transport stream will have variable bit rate. ",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pidMapTable.PidMapTable), {})
            })
        ]
    });
};
const ServiceFilterSection = ({ currentParentInput })=>{
    const fieldName = 'deriveFrom.ingestTransform.services';
    const { getValues, setValue } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    const [filterState, setFilterItem] = (0, _react.useState)();
    const api = (0, _react.useCallback)(()=>Promise.resolve({
            items: filterState?.items.map((x)=>x.id) ?? [],
            total: filterState?.items.length ?? 0,
            filter: undefined
        }), [
        filterState
    ]);
    (0, _react.useEffect)(()=>{
        if (!(values?.deriveFrom?.ingestTransform?.type === 'mpts-demux')) return;
        // Create options from all services currently in tsInfo
        const inputTsInfoServices = currentParentInput.tsInfo?.[0]?.services ?? [];
        const itemsInTsInfo = inputTsInfoServices.filter((x)=>x.id !== undefined).map((x)=>({
                id: x.id,
                name: x.name ?? x.id.toString()
            }));
        // Create options for saved services not in tsInfo anymore
        const savedServiceIds = values?.deriveFrom?.ingestTransform?.services ?? [];
        const itemsSavedButNotInTsInfo = savedServiceIds.filter((savedId)=>!itemsInTsInfo.some((x)=>x.id === savedId)).map((id)=>({
                id: id,
                name: `${id}`
            }));
        // ...and merge them
        const items = itemsInTsInfo.concat(itemsSavedButNotInTsInfo);
        // IDs of the currently saved services
        const defaultOptionIds = savedServiceIds;
        const tooltip = "Services to include. If a service isn't available in the current stream, it can be added by manually entering its Service ID";
        setFilterItem({
            parentId: currentParentInput.id,
            tooltip: tooltip,
            items: items,
            defaultOptionIds: defaultOptionIds
        });
    }, [
        currentParentInput,
        setValue
    ]);
    const loading = filterState === undefined;
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
        pending: loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
        required: true,
        name: fieldName,
        label: "Services",
        tooltip: filterState.tooltip,
        defaultOption: filterState.defaultOptionIds,
        api: api,
        getOptionValue: (option)=>option,
        getOptionLabel: (option)=>filterState.items.find((x)=>x.id === option)?.name ?? option.toString(),
        optionComparator: (o1, o2)=>o1 == o2,
        multiple: true,
        allowCustomOptions: true,
        filterSelectedOptions: true,
        autoSelect: true,
        validators: {
            integers: {}
        },
        xs: 4
    }, filterState.parentId);
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../../components/common/Pendable":"gDN67","../../common/Form":"4Mui7","./PidMapTable":"hPzuJ","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hPzuJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PidMapTable", ()=>PidMapTable);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _types = require("common/api/v1/types");
var _form = require("../../common/Form");
var _table = require("../../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../../common/MissingContent");
var _reactHookForm = require("react-hook-form");
const options = [
    {
        name: 'Map',
        value: (0, _types.PIDRuleAction).Map
    },
    {
        name: 'Delete',
        value: (0, _types.PIDRuleAction).Delete
    },
    {
        name: 'Set null',
        value: (0, _types.PIDRuleAction).SetNull
    }
];
const PidMapTable = ()=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const pidMapRulesPrefix = 'deriveFrom.ingestTransform.pidMap.rules';
    const { fields: rules, remove: removeRule, append: addRule, update: updateRule } = (0, _reactHookForm.useFieldArray)({
        name: pidMapRulesPrefix
    });
    const config = [
        {
            title: 'action',
            getValue: (_rule, i)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                    sx: {
                        minWidth: '100px'
                    },
                    name: `${pidMapRulesPrefix}.${i}.action`,
                    options: options,
                    variant: "standard",
                    hiddenLabel: true,
                    required: true,
                    onChange: (val)=>{
                        updateRule(i, {
                            ...getValues(`${pidMapRulesPrefix}.${i}`),
                            action: val
                        });
                    }
                });
            }
        },
        {
            title: 'Source PID',
            getValue: (_rule, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                    type: "number",
                    name: `${pidMapRulesPrefix}.${i}.pid`,
                    variant: "standard",
                    hiddenLabel: true,
                    required: true,
                    validators: {
                        pid: {}
                    }
                })
        },
        {
            title: 'Destination PID',
            getValue: (rule, i)=>{
                if (rule.action !== 'map') return 'N/A';
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                    type: "number",
                    name: `${pidMapRulesPrefix}.${i}.destPid`,
                    hiddenLabel: true,
                    variant: "standard",
                    required: true,
                    validators: {
                        pid: {}
                    }
                });
            }
        },
        {
            getValue: (_rule, i)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: 'Remove rule',
                    placement: "top",
                    style: {
                        marginRight: 16
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                        edge: "end",
                        onClick: ()=>removeRule(i),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
                    })
                });
            },
            props: {
                align: 'right'
            }
        }
    ];
    if (!getValues('_derived')) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
        config: config,
        data: rules,
        emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
            message: "No PID mapping"
        }),
        actions: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "contained",
                color: "primary",
                onClick: ()=>{
                    addRule({
                        action: (0, _types.PIDRuleAction).Map,
                        pid: 0,
                        destPid: 0
                    });
                },
                children: "Add Rule"
            }, "add-pid-rule-button")
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Button":"3qJY9","@mui/material/IconButton":"488As","@mui/material/Tooltip":"2soEB","@mui/icons-material/Delete":"69aC7","common/api/v1/types":"3qemx","../../common/Form":"4Mui7","../../common/Table":"dt9lf","../../common/MissingContent":"1LBl6","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7MCKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AudioReshuffling", ()=>AudioReshuffling);
var _jsxRuntime = require("react/jsx-runtime");
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _react = require("react");
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _arrowRight = require("@mui/icons-material/ArrowRight");
var _arrowRightDefault = parcelHelpers.interopDefault(_arrowRight);
var _arrowDropDown = require("@mui/icons-material/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _styles = require("@mui/material/styles");
var _form = require("../../common/Form");
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _arrowForward = require("@mui/icons-material/ArrowForward");
var _arrowForwardDefault = parcelHelpers.interopDefault(_arrowForward);
var _reactRedux = require("react-redux");
var _notificationActions = require("../../../redux/actions/notificationActions");
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _utils = require("common/utils");
var _shuffle = require("@mui/icons-material/Shuffle");
var _shuffleDefault = parcelHelpers.interopDefault(_shuffle);
var _cable = require("@mui/icons-material/Cable");
var _cableDefault = parcelHelpers.interopDefault(_cable);
var _reactHookForm = require("react-hook-form");
var _alert = require("@mui/material/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _clear = require("@mui/icons-material/Clear");
var _clearDefault = parcelHelpers.interopDefault(_clear);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _ffmpegParamsInputsAudio = require("./FFmpegParamsInputsAudio");
const AudioReshuffling = ({ currentParentInput })=>{
    const EMPTY_PID = 0;
    const [inputs, setInputs] = (0, _react.useState)([]);
    const [inputPids, setInputPids] = (0, _react.useState)([]);
    const [outputs, setOutputs] = (0, _react.useState)([]);
    const [outputPids, setOutputPids] = (0, _react.useState)([]);
    const [mappings, setMappings] = (0, _react.useState)([]);
    const [passthrough, _setPassthrough] = (0, _react.useState)([]);
    const [inputPassthroughPid, setInputPassthroughPid] = (0, _react.useState)('');
    const [outputPassthroughPid, setOutputPassthroughPid] = (0, _react.useState)('');
    const [arePidErrors, setArePidErrors] = (0, _react.useState)(true);
    const inputPidToLabel = new Map();
    const pidsInService = new Set(currentParentInput.tsInfo?.[0]?.services?.map((s)=>s.pids).flat().filter((p)=>p !== undefined) || []);
    const allPids = currentParentInput.tsInfo?.[0]?.pids?.filter((p)=>p?.id && pidsInService.has(p.id)) || [];
    // Channel mode is an enum value of the audio stream's speaker configuration (e.g. L+R, 5.1, etc)
    // https://android.googlesource.com/platform/external/aac/+/pie-release/libAACenc/include/aacenc_lib.h#406
    const getNumberOfChannels = (audioInfo)=>{
        const channelMode = audioInfo.channelMode?.value;
        if (!channelMode) return 0;
        if (audioInfo.aacProfile?.value) {
            if (channelMode < 7) return channelMode;
            if (channelMode === 7) return 8;
        }
        if (audioInfo.mpaVersion?.value) {
            if (channelMode < 3) return 2;
            if (channelMode === 3) return 1;
        }
        return 0;
    };
    const audioPids = allPids.map((p)=>{
        if (!(p?.streamInfo?.audio && p?.id)) return undefined;
        return {
            pid: p.id,
            channels: getNumberOfChannels(p.streamInfo.audio)
        };
    }).filter((p)=>p !== undefined);
    const passthroughPids = allPids.filter((p)=>!audioPids.find((ap)=>ap.pid === p?.id)).map((p)=>p?.id).filter((p)=>p !== undefined) ?? [];
    for (const p of allPids){
        if (!(p?.id && p?.description)) continue;
        const channels = audioPids.find((ap)=>ap.pid === p.id)?.channels || 0;
        inputPidToLabel.set(p.id, {
            label: p.description,
            channels
        });
    }
    const setPassthrough = (0, _react.useCallback)((passthrough)=>{
        _setPassthrough((0, _utils.distinct)(passthrough.toSorted((a, b)=>{
            if (a.inputPid === b.inputPid) return a.outputPid - b.outputPid;
            return a.inputPid - b.inputPid;
        }), function areEqual(a, b) {
            return a.inputPid === b.inputPid && a.outputPid === b.outputPid;
        }));
    }, [
        _setPassthrough
    ]);
    const { getValues, setValue } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    const theme = (0, _styles.useTheme)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const channelNumberingOptions = [
        'Relative',
        'Absolute'
    ];
    const sortMappingsByOptions = [
        'Input',
        'Output'
    ];
    const [selectedChannelNumbering, setSelectedChannelNumbering] = (0, _react.useState)(channelNumberingOptions[0]);
    const [selectedSortMappingsBy, setSelectedSortMappingsBy] = (0, _react.useState)(sortMappingsByOptions[0]);
    const [loading, setLoading] = (0, _react.useState)(true);
    (0, _react.useEffect)(()=>{
        setArePidErrors(outputPids.includes(EMPTY_PID) || inputPids.includes(EMPTY_PID));
    }, [
        outputPids,
        inputPids
    ]);
    (0, _react.useEffect)(()=>{
        if (loading) return;
        if (!(values?.deriveFrom?.ingestTransform?.type === 'audio-reshuffling')) return;
        values.deriveFrom.ingestTransform.ffmpegParams = {
            ...values.deriveFrom.ingestTransform.ffmpegParams,
            audioReshuffling: {
                inputs,
                outputs,
                mappings,
                passthrough
            }
        };
    }, [
        inputs,
        outputs,
        mappings,
        passthrough
    ]);
    // Apply initial state, when there are no params
    const setInitialState = ({ reset })=>{
        if (!(values?.deriveFrom?.ingestTransform?.type === 'audio-reshuffling')) return;
        if (!values.deriveFrom.ingestTransform.ffmpegParams?.audioReshuffling || reset) {
            const inputs = audioPids?.length ? audioPids : [
                {
                    pid: EMPTY_PID,
                    channels: 2
                }
            ];
            const passthrough = passthroughPids?.length ? passthroughPids.map((pid)=>({
                    inputPid: pid,
                    outputPid: pid
                })) : [];
            setValue('deriveFrom.ingestTransform.ffmpegParams', {
                type: 'audio-reshuffling',
                audioReshuffling: {
                    inputs,
                    outputs: [
                        {
                            pid: EMPTY_PID,
                            channels: 2
                        }
                    ],
                    mappings: [],
                    passthrough
                },
                audioCodec: 'aac'
            }, {
                shouldValidate: true
            });
        }
        const { inputs, outputs, mappings, passthrough } = values.deriveFrom.ingestTransform.ffmpegParams.audioReshuffling;
        setInputs(inputs);
        setOutputs(outputs);
        setMappings(mappings);
        setPassthrough(passthrough);
        setInputPids(inputs.map((i)=>i.pid));
        setOutputPids(outputs.map((i)=>i.pid));
    };
    (0, _react.useEffect)(()=>{
        if (!loading) return;
        setInitialState({
            reset: false
        });
        setLoading(false);
    });
    const pidHelperText = (pid, passthrough = false)=>{
        if ((pid === EMPTY_PID || !pid) && !passthrough) return 'Required';
        if (pid < 32) return 'Min 32';
        if (pid > 8191) return 'Max 8190';
        if (pid === 8187) return 'Reserved';
    };
    const cellBackground = (outputIndex, inputIndex)=>{
        const baseColor = (0, _styles.darken)(theme.palette.grey[900], outputIndex % 2 === 0 ? 0.1 : 0);
        if (inputIndex % 2 === 0) return {
            backgroundColor: baseColor
        };
        return {
            background: `repeating-linear-gradient(
      ${baseColor},
      ${baseColor} 2.5px,
      ${(0, _styles.lighten)(theme.palette.grey[900], 0.05)} 2.5px,
      ${(0, _styles.lighten)(theme.palette.grey[900], 0.05)} 5px
    );`
        };
    };
    const handleAddPassthrough = ()=>{
        if (isNaN(parseInt(inputPassthroughPid)) || isNaN(parseInt(outputPassthroughPid))) return;
        setPassthrough([
            ...passthrough,
            {
                inputPid: parseInt(inputPassthroughPid),
                outputPid: parseInt(outputPassthroughPid)
            }
        ]);
        setInputPassthroughPid('');
        setOutputPassthroughPid('');
    };
    const Mappings = ()=>{
        if (mappings.length === 0) return null;
        const rows = (0, _utils.group)(mappings.sort((a, b)=>{
            if (selectedSortMappingsBy === 'Input') return a.input.pid === b.input.pid ? a.input.channel - b.input.channel : a.input.pid - b.input.pid;
            return a.output.pid === b.output.pid ? a.output.channel - b.output.channel : a.output.pid - b.output.pid;
        }), (m)=>`${m.input.pid}-${m.input.channel}`);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                    direction: "column",
                    alignItems: "flex-start",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            useFlexGap: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    variant: "h5",
                                    align: "center",
                                    children: "Mappings"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                    title: "All mappings that will be applied across the audio channels of the input stream",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                                        fontSize: "small"
                                    })
                                })
                            ]
                        }),
                        Object.entries(rows).map(([row, rowMappings])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                                direction: "row",
                                spacing: 2,
                                flexWrap: "wrap",
                                alignItems: "center",
                                useFlexGap: true,
                                children: rowMappings.map((mapping, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shuffleDefault.default), {}),
                                        sx: {
                                            fontWeight: 'bolder'
                                        },
                                        variant: "outlined",
                                        label: `${mapping.input.pid} ch ${mapping.input.channel} \u{2192} ${mapping.output.pid} ch ${mapping.output.channel}`,
                                        onDelete: ()=>{
                                            setMappings(mappings.filter((m)=>m.input.pid !== mapping.input.pid || m.input.channel !== mapping.input.channel || m.output.pid !== mapping.output.pid || m.output.channel !== mapping.output.channel));
                                        }
                                    }, `${row}-${index}`))
                            }, row))
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {})
            ]
        });
    };
    const ViewOptions = ()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
            direction: "column",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "h5",
                    children: "View options"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                    direction: "row",
                    spacing: 2,
                    flexWrap: 'wrap',
                    useFlexGap: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "center",
                                    useFlexGap: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            children: "Sort mappings by"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: "Change the display order in the mappings list",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
                                    row: true,
                                    value: selectedSortMappingsBy,
                                    onChange: (e)=>setSelectedSortMappingsBy(e.target.value),
                                    children: sortMappingsByOptions.map((option, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                            value: option,
                                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                            label: option
                                        }, index))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "center",
                                    useFlexGap: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            children: "Channel numbering"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: "Count channels from the first channel of each input stream (relative) or from the first channel of the first input stream, across streams (absolute)",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
                                    row: true,
                                    value: selectedChannelNumbering,
                                    onChange: (e)=>setSelectedChannelNumbering(e.target.value),
                                    children: channelNumberingOptions.map((option, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                            value: option,
                                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                            label: option
                                        }, index))
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const getChannelNumber = (list, index, channelId)=>{
        if (selectedChannelNumbering === 'Relative') return channelId;
        let number = 0;
        for (const [i, input] of (list === 'inputs' ? inputs : outputs).entries()){
            if (i < index) number += input.channels;
            else return number + channelId;
        }
        return number;
    };
    const isCheckboxChecked = (input, inputChannel, output, outputChannel)=>{
        return mappings.find((mapping)=>mapping.input.pid === input.pid && mapping.input.channel === inputChannel && mapping.output.pid === output.pid && mapping.output.channel === outputChannel) ? true : false;
    };
    const checkboxOnChange = (input, inputChannel, output, outputChannel, checked)=>{
        if (!checked) {
            setMappings(mappings.filter((mapping)=>!(mapping.input.pid === input.pid && mapping.input.channel === inputChannel && mapping.output.pid === output.pid && mapping.output.channel === outputChannel)));
            return;
        }
        setMappings([
            ...mappings,
            {
                input: {
                    pid: input.pid,
                    channel: inputChannel
                },
                output: {
                    pid: output.pid,
                    channel: outputChannel
                }
            }
        ]);
    };
    const checkboxRow = (input, inputIndex, inputChannelId)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: outputs.map((output, outputIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                    children: [
                        Array.from({
                            length: output.channels
                        }, (_, outputChannelIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                sx: {
                                    ...cellBackground(outputIndex, inputIndex)
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                        title: arePidErrors ? 'Please enter PIDs' : `Input ${input.pid} channel ${inputChannelId} to Output ${output.pid} channel ${outputChannelIndex + 1}`,
                                        disableInteractive: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                            direction: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            children: [
                                                outputIndex === 0 && outputChannelIndex === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                    fontFamily: 'monospace',
                                                    children: getChannelNumber('inputs', inputIndex, inputChannelId)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                                    checked: isCheckboxChecked(input, inputChannelId, output, outputChannelIndex + 1),
                                                    onChange: (e)=>checkboxOnChange(input, inputChannelId, output, outputChannelIndex + 1, e.target.checked),
                                                    disabled: arePidErrors
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, outputChannelIndex)),
                        output.channels === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {})
                    ]
                }, outputIndex))
        });
    };
    const handleChangeOutputPid = (index, oldPid, newPid)=>{
        setOutputPids(outputPids.map((i, iIndex)=>iIndex === index ? newPid : i));
        if (isNaN(newPid)) return;
        if (outputs.find((out, i)=>out.pid === newPid && index !== i)) {
            dispatch((0, _notificationActions.enqueueSnackbar)({
                message: `PID ${newPid} already exists`,
                type: 'basic',
                options: {
                    variant: 'error'
                }
            }));
            return;
        }
        setOutputs(outputs.map((i)=>i.pid === oldPid ? {
                ...i,
                pid: newPid
            } : i));
        setMappings(mappings.map((m)=>{
            if (m.output.pid === oldPid) return {
                ...m,
                output: {
                    ...m.output,
                    pid: newPid
                }
            };
            return m;
        }));
    };
    const handleChangeInputPid = (index, oldPid, newPid)=>{
        setInputPids(inputPids.map((i, iIndex)=>iIndex === index ? newPid : i));
        if (isNaN(newPid)) return;
        if (inputs.find((inp, i)=>inp.pid === newPid && index !== i)) {
            dispatch((0, _notificationActions.enqueueSnackbar)({
                message: `PID ${newPid} already exists`,
                type: 'basic',
                options: {
                    variant: 'error'
                }
            }));
            return;
        }
        setInputs(inputs.map((i)=>i.pid === oldPid ? {
                ...i,
                pid: newPid
            } : i));
        setMappings(mappings.map((m)=>{
            if (m.input.pid === oldPid) return {
                ...m,
                input: {
                    ...m.input,
                    pid: newPid
                }
            };
            return m;
        }));
    };
    const handleChangeInputChannels = (index, value)=>{
        const oldValue = inputs[index].channels;
        const newValue = Math.min(parseInt(value), 8) // libfdk-aac max channels is 8 (7.1 layout)
        ;
        setInputs(inputs.map((i, iIndex)=>iIndex === index ? {
                ...i,
                channels: newValue
            } : i));
        if (newValue < oldValue) setMappings(mappings.filter((m)=>!(m.input.pid === inputs[index].pid && m.input.channel > newValue)));
    };
    const handleChangeOutputChannels = (index, value)=>{
        const oldValue = outputs[index].channels;
        const newValue = Math.min(parseInt(value), 8) // libfdk-aac max channels is 8 (7.1 layout)
        ;
        setOutputs(outputs.map((i, iIndex)=>iIndex === index ? {
                ...i,
                channels: newValue
            } : i));
        if (newValue < oldValue) setMappings(mappings.filter((m)=>!(m.output.pid === outputs[index].pid && m.output.channel > newValue)));
    };
    const renderPidWithLabelLink = (pid)=>{
        const label = inputPidToLabel.get(pid)?.label;
        return `${pid}${label ? ' (' + label + ')' : ''}`;
    };
    const isInputChannelsError = (channels, pid)=>{
        const label = inputPidToLabel.get(pid);
        if (!label) return false;
        if (label.channels === 0) return false;
        return channels !== label.channels;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
            title: loading && 'Loading',
            children: [
                !audioPids?.length && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alertDefault.default), {
                    severity: "warning",
                    variant: "outlined",
                    children: [
                        currentParentInput.name,
                        " does not contain audio pids"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
                    component: (0, _paperDefault.default),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                            sx: {
                                                borderBottom: 0
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                                direction: "row",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                        children: "Outputs"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowRightDefault.default), {})
                                                ]
                                            })
                                        }),
                                        outputs.map((output, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                colSpan: output.channels || 1,
                                                sx: {
                                                    ...cellBackground(index, 0),
                                                    borderBottom: 0
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                                    direction: "row",
                                                    spacing: 2,
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                                            type: "number",
                                                            label: `PID ${index + 1}`,
                                                            size: "small",
                                                            sx: {
                                                                width: 100
                                                            },
                                                            value: outputPids[index] === EMPTY_PID ? '' : outputPids[index],
                                                            onChange: (e)=>handleChangeOutputPid(index, output.pid, parseInt(e.target.value)),
                                                            error: pidHelperText(outputPids[index]) !== undefined,
                                                            helperText: pidHelperText(outputPids[index])
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                                            type: "number",
                                                            label: "No. channels",
                                                            size: "small",
                                                            sx: {
                                                                width: 100
                                                            },
                                                            value: output.channels,
                                                            onChange: (e)=>handleChangeOutputChannels(index, e.target.value)
                                                        })
                                                    ]
                                                })
                                            }, index)),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                            align: "right",
                                            sx: {
                                                borderBottom: 0
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                variant: "contained",
                                                onClick: ()=>{
                                                    setOutputs([
                                                        ...outputs,
                                                        {
                                                            pid: outputs[outputs.length - 1]?.pid + 1 || 32,
                                                            channels: 2
                                                        }
                                                    ]);
                                                    setOutputPids([
                                                        ...outputPids,
                                                        outputs[outputs.length - 1]?.pid + 1 || 32
                                                    ]);
                                                },
                                                sx: {
                                                    whiteSpace: 'nowrap'
                                                },
                                                disabled: arePidErrors,
                                                children: "Add output"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableBodyDefault.default), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                            children: "Inputs"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowDropDownDefault.default), {})
                                                    ]
                                                })
                                            }),
                                            outputs.map((output, outputIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                                                    children: Array.from({
                                                        length: output.channels
                                                    }, (_, outputChannelId)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                            sx: {
                                                                ...cellBackground(outputIndex, 0)
                                                            },
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                                                                direction: 'row',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                                    fontFamily: 'monospace',
                                                                    children: getChannelNumber('outputs', outputIndex, outputChannelId) + 1
                                                                })
                                                            })
                                                        }, outputChannelId))
                                                }, outputIndex)),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {})
                                        ]
                                    }),
                                    inputs.map((input, inputIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                            rowSpan: input.channels || 1,
                                                            sx: {
                                                                ...cellBackground(1, inputIndex)
                                                            },
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                                                direction: "row",
                                                                spacing: 2,
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                                                        type: "number",
                                                                        label: `PID ${inputIndex + 1}`,
                                                                        size: "small",
                                                                        sx: {
                                                                            width: 100,
                                                                            background: theme.palette.grey[900]
                                                                        },
                                                                        value: inputPids[inputIndex] === EMPTY_PID ? '' : inputPids[inputIndex],
                                                                        onChange: (e)=>handleChangeInputPid(inputIndex, input.pid, parseInt(e.target.value)),
                                                                        error: pidHelperText(inputPids[inputIndex]) !== undefined,
                                                                        helperText: pidHelperText(inputPids[inputIndex])
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                                                        type: "number",
                                                                        label: "No. channels",
                                                                        size: "small",
                                                                        sx: {
                                                                            width: 100,
                                                                            background: theme.palette.grey[900]
                                                                        },
                                                                        value: input.channels || '',
                                                                        onChange: (e)=>handleChangeInputChannels(inputIndex, e.target.value),
                                                                        error: isInputChannelsError(input.channels, input.pid),
                                                                        helperText: isInputChannelsError(input.channels, input.pid) ? `Input has ${inputPidToLabel.get(input.pid)?.channels} channels` : ''
                                                                    }),
                                                                    inputPidToLabel.get(input.pid) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                                        variant: "caption",
                                                                        fontFamily: 'monospace',
                                                                        children: inputPidToLabel.get(input.pid)?.label
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        input.channels === 0 ? outputs.map((output, outputIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                                colSpan: output.channels,
                                                                sx: {
                                                                    ...cellBackground(outputIndex, inputIndex)
                                                                }
                                                            }, outputIndex)) : checkboxRow(input, inputIndex, 1),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                            align: "right",
                                                            rowSpan: input.channels || 1,
                                                            sx: {
                                                                ...cellBackground(1, inputIndex)
                                                            },
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                                variant: "text",
                                                                color: "error",
                                                                onClick: ()=>{
                                                                    setInputs(inputs.filter((_, i)=>i !== inputIndex));
                                                                    setInputPids(inputPids.filter((_, i)=>i !== inputIndex));
                                                                    setMappings(mappings.filter((m)=>m.input.pid !== input.pid));
                                                                },
                                                                size: "small",
                                                                disabled: arePidErrors,
                                                                children: "Remove"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                Array.from({
                                                    length: input.channels - 1 || 0
                                                }, (_, inputChannelIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                                        children: checkboxRow(input, inputIndex, inputChannelIndex + 2)
                                                    }, inputChannelIndex))
                                            ]
                                        }, inputIndex)),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                sx: {
                                                    borderBottom: 0,
                                                    py: 2
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                            variant: "contained",
                                                            onClick: ()=>{
                                                                setInputs([
                                                                    ...inputs,
                                                                    {
                                                                        pid: inputs[inputs.length - 1]?.pid + 1 || 32,
                                                                        channels: 2
                                                                    }
                                                                ]);
                                                                setInputPids([
                                                                    ...inputPids,
                                                                    inputs[inputs.length - 1]?.pid + 1 || 32
                                                                ]);
                                                            },
                                                            disabled: arePidErrors,
                                                            children: "Add input"
                                                        }),
                                                        audioPids.find((p)=>!inputPids.includes(p.pid)) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                            variant: "caption",
                                                            sx: {
                                                                ml: 1
                                                            },
                                                            children: [
                                                                "Quick add",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                audioPids.filter((p)=>!inputPids.includes(p.pid)).map((p)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                                                        onClick: ()=>{
                                                                            setInputs([
                                                                                ...inputs,
                                                                                {
                                                                                    pid: p.pid,
                                                                                    channels: p.channels
                                                                                }
                                                                            ]);
                                                                            setInputPids([
                                                                                ...inputPids,
                                                                                p.pid
                                                                            ]);
                                                                        },
                                                                        component: "button",
                                                                        underline: "hover",
                                                                        color: "inherit",
                                                                        sx: {
                                                                            mr: 1,
                                                                            cursor: 'pointer'
                                                                        },
                                                                        children: renderPidWithLabelLink(p.pid)
                                                                    }, `availableInInput${p.pid}`))
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            outputs.map((output, outputIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                    colSpan: output.channels || 1,
                                                    sx: {
                                                        ...cellBackground(outputIndex, 0),
                                                        borderBottom: 0
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                                                        direction: "row",
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                            color: "error",
                                                            variant: "text",
                                                            onClick: ()=>{
                                                                setOutputs(outputs.filter((_, i)=>i !== outputIndex));
                                                                setOutputPids(outputPids.filter((_, i)=>i !== outputIndex));
                                                                setMappings(mappings.filter((m)=>m.output.pid !== output.pid));
                                                            },
                                                            size: "small",
                                                            disabled: arePidErrors,
                                                            children: "Remove"
                                                        })
                                                    })
                                                }, outputIndex)),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                sx: {
                                                    borderBottom: 0
                                                },
                                                align: "right",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                    onClick: ()=>setInitialState({
                                                            reset: true
                                                        }),
                                                    startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearDefault.default), {}),
                                                    color: "error",
                                                    children: "Clear all"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                    direction: "column",
                    spacing: 3,
                    sx: {
                        mt: 3,
                        width: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            flexWrap: 'wrap',
                            useFlexGap: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    variant: "h5",
                                    align: "center",
                                    children: "Passthrough"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                    title: "Passthrough non-audio programs you want to keep in the stream, e.g. video or subtitles",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                                        fontSize: "small",
                                        sx: {
                                            mr: 2
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                            type: "number",
                                            label: "Input PID",
                                            size: "small",
                                            sx: {
                                                width: 120
                                            },
                                            value: inputPassthroughPid,
                                            onChange: (e)=>setInputPassthroughPid(e.target.value),
                                            onKeyDown: (e)=>e.key === 'Enter' && handleAddPassthrough(),
                                            error: pidHelperText(parseInt(inputPassthroughPid), true) !== undefined,
                                            helperText: pidHelperText(parseInt(inputPassthroughPid), true)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowForwardDefault.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                            type: "number",
                                            label: "Output PID",
                                            size: "small",
                                            sx: {
                                                width: 120
                                            },
                                            value: outputPassthroughPid,
                                            onChange: (e)=>setOutputPassthroughPid(e.target.value),
                                            onKeyDown: (e)=>e.key === 'Enter' && handleAddPassthrough(),
                                            error: pidHelperText(parseInt(outputPassthroughPid), true) !== undefined,
                                            helperText: pidHelperText(parseInt(outputPassthroughPid), true)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    variant: "contained",
                                    onClick: handleAddPassthrough,
                                    disabled: pidHelperText(parseInt(outputPassthroughPid), true) !== undefined || pidHelperText(parseInt(inputPassthroughPid), true) !== undefined || isNaN(parseInt(inputPassthroughPid)) || isNaN(parseInt(outputPassthroughPid)),
                                    children: "Add"
                                }),
                                passthroughPids.find((p)=>!passthrough.map((p)=>p.inputPid).includes(p)) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                    variant: "caption",
                                    sx: {
                                        ml: 1
                                    },
                                    children: [
                                        "Quick add",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        passthroughPids.filter((p)=>!passthrough.map((p)=>p.inputPid).includes(p)).map((p)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                                onClick: ()=>{
                                                    setPassthrough([
                                                        ...passthrough,
                                                        {
                                                            inputPid: p,
                                                            outputPid: p
                                                        }
                                                    ]);
                                                },
                                                component: "button",
                                                underline: "hover",
                                                color: "inherit",
                                                sx: {
                                                    mr: 1,
                                                    cursor: 'pointer'
                                                },
                                                children: renderPidWithLabelLink(p)
                                            }, `availableInPassthrough${p}`))
                                    ]
                                })
                            ]
                        }),
                        passthrough.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                            direction: "column",
                            alignItems: "flex-start",
                            spacing: 2,
                            children: passthrough.sort((a, b)=>{
                                if (selectedSortMappingsBy === 'Input') return a.inputPid === b.inputPid ? a.outputPid - b.outputPid : a.inputPid - b.inputPid;
                                return a.outputPid === b.outputPid ? a.inputPid - b.inputPid : a.outputPid - b.outputPid;
                            }).map((p, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cableDefault.default), {}),
                                    sx: {
                                        fontWeight: 'bolder'
                                    },
                                    variant: "outlined",
                                    label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                children: p.inputPid
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    fontWeight: 'normal'
                                                },
                                                children: inputPidToLabel.get(p.inputPid)?.label ? ' (' + inputPidToLabel.get(p.inputPid)?.label + ')' : ''
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                children: ` \u{2192} ${p.outputPid}`
                                            })
                                        ]
                                    }),
                                    onDelete: ()=>{
                                        setPassthrough(passthrough.filter((p1)=>p1 !== p));
                                    }
                                }, index))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Mappings, {}),
                        !loading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "column",
                            alignItems: "flex-start",
                            spacing: 2,
                            sx: {
                                width: '100%'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    variant: "h5",
                                    align: "center",
                                    children: "Encoder settings"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                                    direction: "row",
                                    spacing: 3,
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    useFlexGap: true,
                                    sx: {
                                        width: '100%'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ffmpegParamsInputsAudio.FFmpegParamsInputsAudio), {
                                        isReshuffling: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                            direction: "row",
                            spacing: 5,
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            useFlexGap: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ViewOptions, {})
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/TextField":"l88b4","react":"9njXz","@mui/material/Paper":"aexCI","@mui/material/Table":"k4r1H","@mui/material/TableBody":"2jHBQ","@mui/material/TableCell":"6WlPV","@mui/material/TableContainer":"fJfiU","@mui/material/TableHead":"9yKSO","@mui/material/TableRow":"bLA0R","@mui/material/Stack":"6thYv","@mui/material/Typography":"6NtGx","@mui/material/Button":"3qJY9","@mui/material/Checkbox":"ag1Z5","@mui/material/Tooltip":"2soEB","@mui/icons-material/ArrowRight":"9EHup","@mui/icons-material/ArrowDropDown":"6qreH","@mui/material/styles":"2UrBk","../../common/Form":"4Mui7","@mui/material/Chip":"5cK8z","@mui/material/Divider":"9Ul8c","@mui/icons-material/ArrowForward":"jq04R","react-redux":"l1pMU","../../../redux/actions/notificationActions":"7LkQg","@mui/material/FormControlLabel":"45VZW","@mui/material/Radio":"hyH25","@mui/material/RadioGroup":"l1i9K","common/utils":"2AqiH","@mui/icons-material/Shuffle":"lrh5I","@mui/icons-material/Cable":"dBrUu","react-hook-form":"8z0aI","@mui/material/Alert":"8qQ0S","@mui/icons-material/Clear":"dyxCG","@mui/material/Link":"chNUC","@mui/icons-material/HelpOutline":"2sIqE","./FFmpegParamsInputsAudio":"8kjBL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fJfiU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("af02821960831a7a").default;
var _interopRequireDefault = require("ad5a58cb3ebec87").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    tableContainerClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _TableContainer.default;
    }
});
Object.defineProperty(exports, "tableContainerClasses", {
    enumerable: true,
    get: function() {
        return _tableContainerClasses.default;
    }
});
var _TableContainer = _interopRequireDefault(require("59bbd12c87ec07c5"));
var _tableContainerClasses = _interopRequireWildcard(require("191a87879e9a0c39"));
Object.keys(_tableContainerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _tableContainerClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _tableContainerClasses[key];
        }
    });
});

},{"af02821960831a7a":"fiRIh","ad5a58cb3ebec87":"kZ6eK","59bbd12c87ec07c5":"EPPvT","191a87879e9a0c39":"4YeGL"}],"EPPvT":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c51586e461b1439e").default;
var _interopRequireWildcard = require("82f77aa1cd9f8e2b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("dced464af46cc863"));
var _propTypes = _interopRequireDefault(require("f51bf1a475d236bc"));
var _clsx = _interopRequireDefault(require("75447129d15974cc"));
var _composeClasses = _interopRequireDefault(require("98b89b5cd23381a6"));
var _zeroStyled = require("3b33a2f1aea2eeea");
var _DefaultPropsProvider = require("fa598e016a538836");
var _tableContainerClasses = require("ddb20b4d47053db1");
var _jsxRuntime = require("bd224e860f8b534b");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _tableContainerClasses.getTableContainerUtilityClass, classes);
};
const TableContainerRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiTableContainer',
    slot: 'Root'
})({
    width: '100%',
    overflowX: 'auto'
});
const TableContainer = /*#__PURE__*/ React.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className, component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
var _default = exports.default = TableContainer;

},{"c51586e461b1439e":"kZ6eK","82f77aa1cd9f8e2b":"fiRIh","dced464af46cc863":"9njXz","f51bf1a475d236bc":"bnNSm","75447129d15974cc":"d2NWs","98b89b5cd23381a6":"59Equ","3b33a2f1aea2eeea":"hZXDo","fa598e016a538836":"9bD8g","ddb20b4d47053db1":"4YeGL","bd224e860f8b534b":"1dlk8"}],"4YeGL":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("68dbd8834d05471a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getTableContainerUtilityClass = getTableContainerUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("26d22c6a78888435"));
var _generateUtilityClass = _interopRequireDefault(require("4c812d24dea92d41"));
function getTableContainerUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTableContainer', slot);
}
const tableContainerClasses = (0, _generateUtilityClasses.default)('MuiTableContainer', [
    'root'
]);
var _default = exports.default = tableContainerClasses;

},{"68dbd8834d05471a":"kZ6eK","26d22c6a78888435":"7pSUk","4c812d24dea92d41":"jBs9M"}],"9EHup":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("17947dfdb6bfa7db").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("c8245237e078b610"));
var _jsxRuntime = require("b4d40a3272db09fa");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m10 17 5-5-5-5z"
}), 'ArrowRight');

},{"17947dfdb6bfa7db":"kZ6eK","c8245237e078b610":"2vOnF","b4d40a3272db09fa":"1dlk8"}],"6qreH":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("e08d1c8f77ec2eac").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4de2629ead76be7"));
var _jsxRuntime = require("370c36fae6895c2f");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');

},{"e08d1c8f77ec2eac":"kZ6eK","4de2629ead76be7":"2vOnF","370c36fae6895c2f":"1dlk8"}],"jq04R":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("a1f204aaf56b561b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4ee17709ef0f2985"));
var _jsxRuntime = require("2df9b1e75d4cc01d");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

},{"a1f204aaf56b561b":"kZ6eK","4ee17709ef0f2985":"2vOnF","2df9b1e75d4cc01d":"1dlk8"}],"hyH25":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("4b7476dbae7e396c").default;
var _interopRequireDefault = require("bad2783cc0f1cf16").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    radioClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Radio.default;
    }
});
Object.defineProperty(exports, "radioClasses", {
    enumerable: true,
    get: function() {
        return _radioClasses.default;
    }
});
var _Radio = _interopRequireDefault(require("c7a93bf771324d3e"));
var _radioClasses = _interopRequireWildcard(require("d6b1af2ebc7b7fd6"));
Object.keys(_radioClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _radioClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _radioClasses[key];
        }
    });
});

},{"4b7476dbae7e396c":"fiRIh","bad2783cc0f1cf16":"kZ6eK","c7a93bf771324d3e":"kBzle","d6b1af2ebc7b7fd6":"b1rQO"}],"kBzle":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e736519e3934320f").default;
var _interopRequireWildcard = require("2821ebeb65bd0586").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("7959f9b5b945f25f"));
var _propTypes = _interopRequireDefault(require("f7a204d249a86908"));
var _clsx = _interopRequireDefault(require("f8c21895bacc1d07"));
var _refType = _interopRequireDefault(require("9bf1b4b4b49c6c3b"));
var _composeClasses = _interopRequireDefault(require("658aabbb34a362e"));
var _colorManipulator = require("528ca0e9182ab717");
var _SwitchBase = _interopRequireDefault(require("bf85ef968efeff6b"));
var _RadioButtonIcon = _interopRequireDefault(require("68e28cda46d499da"));
var _capitalize = _interopRequireDefault(require("78db6585d38ccd81"));
var _createChainedFunction = _interopRequireDefault(require("41481cd2ba8fafa"));
var _useFormControl = _interopRequireDefault(require("e9c97f3eae34ad90"));
var _useRadioGroup = _interopRequireDefault(require("8299109f0977ae87"));
var _radioClasses = _interopRequireWildcard(require("d596484ec9b182ba"));
var _rootShouldForwardProp = _interopRequireDefault(require("50805583c16993e2"));
var _zeroStyled = require("722bbd8bf0629a83");
var _memoTheme = _interopRequireDefault(require("fe605f01d7094732"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("a7f2def08e756fd7"));
var _useSlot = _interopRequireDefault(require("b0d0a595858d2701"));
var _DefaultPropsProvider = require("2948edaa79dc16d5");
var _jsxRuntime = require("ef2561f0f540ab09");
const useUtilityClasses = (ownerState)=>{
    const { classes, color, size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalize.default)(color)}`,
            size !== 'medium' && `size${(0, _capitalize.default)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, _composeClasses.default)(slots, _radioClasses.getRadioUtilityClass, classes)
    };
};
const RadioRoot = (0, _zeroStyled.styled)(_SwitchBase.default, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, _capitalize.default)(ownerState.size)}`],
            styles[`color${(0, _capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${_radioClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color,
                        disabled: false
                    },
                    style: {
                        [`&.${_radioClasses.default.checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const defaultCheckedIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_RadioButtonIcon.default, {
    checked: true
});
const defaultIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_RadioButtonIcon.default, {});
const Radio = /*#__PURE__*/ React.forwardRef(function Radio(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon = defaultCheckedIcon, color = 'primary', icon = defaultIcon, name: nameProp, onChange: onChangeProp, size = 'medium', className, disabled: disabledProp, disableRipple = false, slots = {}, slotProps = {}, inputProps, ...other } = props;
    const muiFormControl = (0, _useFormControl.default)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ?? (disabled = false);
    const ownerState = {
        ...props,
        disabled,
        disableRipple,
        color,
        size
    };
    const classes = useUtilityClasses(ownerState);
    const radioGroup = (0, _useRadioGroup.default)();
    let checked = checkedProp;
    const onChange = (0, _createChainedFunction.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        ref,
        elementType: RadioRoot,
        className: (0, _clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots,
            slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ React.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ React.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled,
            name,
            checked,
            slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var _default = exports.default = Radio;

},{"e736519e3934320f":"kZ6eK","2821ebeb65bd0586":"fiRIh","7959f9b5b945f25f":"9njXz","f7a204d249a86908":"bnNSm","f8c21895bacc1d07":"d2NWs","9bf1b4b4b49c6c3b":"3TBXN","658aabbb34a362e":"59Equ","528ca0e9182ab717":"hTYBL","bf85ef968efeff6b":"2T3Xg","68e28cda46d499da":"ly8j8","78db6585d38ccd81":"eOYSA","41481cd2ba8fafa":"lSQGp","e9c97f3eae34ad90":"51J7f","8299109f0977ae87":"612XP","d596484ec9b182ba":"b1rQO","50805583c16993e2":"bTxRc","722bbd8bf0629a83":"hZXDo","fe605f01d7094732":"cJNjb","a7f2def08e756fd7":"2r5WG","b0d0a595858d2701":"h76AU","2948edaa79dc16d5":"9bD8g","ef2561f0f540ab09":"1dlk8"}],"ly8j8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("83ed0c0a3952e81b").default;
var _interopRequireWildcard = require("4c1fa10e0fc0e6d5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("93f2542a2f691947"));
var _propTypes = _interopRequireDefault(require("91cd70f9d88ac29c"));
var _RadioButtonUnchecked = _interopRequireDefault(require("6f49341365f82552"));
var _RadioButtonChecked = _interopRequireDefault(require("f1ea5921dcb9b62a"));
var _rootShouldForwardProp = _interopRequireDefault(require("919311cb4d225943"));
var _zeroStyled = require("c67ded7886f3b338");
var _memoTheme = _interopRequireDefault(require("61f58050c65d00b2"));
var _jsxRuntime = require("737746e76b7b02fc");
const RadioButtonIconRoot = (0, _zeroStyled.styled)('span', {
    shouldForwardProp: _rootShouldForwardProp.default
})({
    position: 'relative',
    display: 'flex'
});
const RadioButtonIconBackground = (0, _zeroStyled.styled)(_RadioButtonUnchecked.default)({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const RadioButtonIconDot = (0, _zeroStyled.styled)(_RadioButtonChecked.default)((0, _memoTheme.default)(({ theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function RadioButtonIcon(props) {
    const { checked = false, classes = {}, fontSize } = props;
    const ownerState = {
        ...props,
        checked
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var _default = exports.default = RadioButtonIcon;

},{"83ed0c0a3952e81b":"kZ6eK","4c1fa10e0fc0e6d5":"fiRIh","93f2542a2f691947":"9njXz","91cd70f9d88ac29c":"bnNSm","6f49341365f82552":"jf4xy","f1ea5921dcb9b62a":"k8MFu","919311cb4d225943":"bTxRc","c67ded7886f3b338":"hZXDo","61f58050c65d00b2":"cJNjb","737746e76b7b02fc":"1dlk8"}],"jf4xy":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c3b4bf2bc12d5339").default;
var _interopRequireWildcard = require("13629b744e0fb5fe").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("2743caa31d87ee35"));
var _createSvgIcon = _interopRequireDefault(require("e45c69e019f0f4ec"));
var _jsxRuntime = require("288047296abf6565");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

},{"c3b4bf2bc12d5339":"kZ6eK","13629b744e0fb5fe":"fiRIh","2743caa31d87ee35":"9njXz","e45c69e019f0f4ec":"5sni0","288047296abf6565":"1dlk8"}],"k8MFu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("be8ded289a0aae78").default;
var _interopRequireWildcard = require("eb46547f9f3431d9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("a130c361fe0976a5"));
var _createSvgIcon = _interopRequireDefault(require("4a7cb7ad0f378d8"));
var _jsxRuntime = require("3a68cf2013916fb0");
/**
 * @ignore - internal component.
 */ var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

},{"be8ded289a0aae78":"kZ6eK","eb46547f9f3431d9":"fiRIh","a130c361fe0976a5":"9njXz","4a7cb7ad0f378d8":"5sni0","3a68cf2013916fb0":"1dlk8"}],"612XP":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("9f185cefcea05af9").default;
var _interopRequireWildcard = require("ea254b7d26a2de03").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useRadioGroup;
var React = _interopRequireWildcard(require("6cf295fad1e790a2"));
var _RadioGroupContext = _interopRequireDefault(require("b3416df0bb5597f3"));
function useRadioGroup() {
    return React.useContext(_RadioGroupContext.default);
}

},{"9f185cefcea05af9":"kZ6eK","ea254b7d26a2de03":"fiRIh","6cf295fad1e790a2":"9njXz","b3416df0bb5597f3":"au82o"}],"au82o":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("1250db6b64b7e843").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("16bf6dcdb45dea"));
/**
 * @ignore - internal component.
 */ const RadioGroupContext = /*#__PURE__*/ React.createContext(undefined);
var _default = exports.default = RadioGroupContext;

},{"1250db6b64b7e843":"fiRIh","16bf6dcdb45dea":"9njXz"}],"b1rQO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("fbb1380b27cceccf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getRadioUtilityClass = getRadioUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("9dcc0d15518313db"));
var _generateUtilityClass = _interopRequireDefault(require("73c879b0b063001e"));
function getRadioUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiRadio', slot);
}
const radioClasses = (0, _generateUtilityClasses.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var _default = exports.default = radioClasses;

},{"fbb1380b27cceccf":"kZ6eK","9dcc0d15518313db":"7pSUk","73c879b0b063001e":"jBs9M"}],"l1i9K":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("fcf88570f6c8598").default;
var _interopRequireDefault = require("a825080d09f3c997").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    useRadioGroup: true,
    radioGroupClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _RadioGroup.default;
    }
});
Object.defineProperty(exports, "radioGroupClasses", {
    enumerable: true,
    get: function() {
        return _radioGroupClasses.default;
    }
});
Object.defineProperty(exports, "useRadioGroup", {
    enumerable: true,
    get: function() {
        return _useRadioGroup.default;
    }
});
var _RadioGroup = _interopRequireDefault(require("165977af7fc9e6b0"));
var _useRadioGroup = _interopRequireDefault(require("b60858039c77205b"));
var _radioGroupClasses = _interopRequireWildcard(require("a82c02615fe61807"));
Object.keys(_radioGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _radioGroupClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _radioGroupClasses[key];
        }
    });
});

},{"fcf88570f6c8598":"fiRIh","a825080d09f3c997":"kZ6eK","165977af7fc9e6b0":"cEtgD","b60858039c77205b":"612XP","a82c02615fe61807":"gehG8"}],"cEtgD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ed133d04ad46c46d").default;
var _interopRequireWildcard = require("9016d19b5c18feee").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d59685db01efb3cc"));
var _propTypes = _interopRequireDefault(require("aa30b84dee77cdc9"));
var _clsx = _interopRequireDefault(require("a5e5bbabb24a1508"));
var _composeClasses = _interopRequireDefault(require("de09ba65277c71a2"));
var _FormGroup = _interopRequireDefault(require("dc39e6c586079a1f"));
var _radioGroupClasses = require("402fd68e39ac2c93");
var _useForkRef = _interopRequireDefault(require("2c53578b5ea15a64"));
var _useControlled = _interopRequireDefault(require("13a082a39a3daec3"));
var _RadioGroupContext = _interopRequireDefault(require("e56db22a9299cee1"));
var _useId = _interopRequireDefault(require("5cade44a0c8d397f"));
var _jsxRuntime = require("96e8fd29ebc3e585");
const useUtilityClasses = (props)=>{
    const { classes, row, error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, _composeClasses.default)(slots, _radioGroupClasses.getRadioGroupUtilityClass, classes);
};
const RadioGroup = /*#__PURE__*/ React.forwardRef(function RadioGroup(props, ref) {
    const { // private
    // eslint-disable-next-line react/prop-types
    actions, children, className, defaultValue, name: nameProp, onChange, value: valueProp, ...other } = props;
    const rootRef = React.useRef(null);
    const classes = useUtilityClasses(props);
    const [value, setValueState] = (0, _useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    React.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, _useForkRef.default)(ref, rootRef);
    const name = (0, _useId.default)(nameProp);
    const contextValue = React.useMemo(()=>({
            name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_RadioGroupContext.default.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormGroup.default, {
            role: "radiogroup",
            ref: handleRef,
            className: (0, _clsx.default)(classes.root, className),
            ...other,
            children: children
        })
    });
});
var _default = exports.default = RadioGroup;

},{"ed133d04ad46c46d":"kZ6eK","9016d19b5c18feee":"fiRIh","d59685db01efb3cc":"9njXz","aa30b84dee77cdc9":"bnNSm","a5e5bbabb24a1508":"d2NWs","de09ba65277c71a2":"59Equ","dc39e6c586079a1f":"4P3FX","402fd68e39ac2c93":"gehG8","2c53578b5ea15a64":"64cM2","13a082a39a3daec3":"2pWHX","e56db22a9299cee1":"au82o","5cade44a0c8d397f":"hOkl4","96e8fd29ebc3e585":"1dlk8"}],"gehG8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("fc5d52281c12f431").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getRadioGroupUtilityClass = getRadioGroupUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("6d727ec3afa474e4"));
var _generateUtilityClass = _interopRequireDefault(require("d87e6aea1d856026"));
function getRadioGroupUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiRadioGroup', slot);
}
const radioGroupClasses = (0, _generateUtilityClasses.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var _default = exports.default = radioGroupClasses;

},{"fc5d52281c12f431":"kZ6eK","6d727ec3afa474e4":"7pSUk","d87e6aea1d856026":"jBs9M"}],"lrh5I":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("eca28aacaa773979").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4564e2e1b64a5487"));
var _jsxRuntime = require("b468af2d5db88109");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10.59 9.17 5.41 4 4 5.41l5.17 5.17zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4zm.33 9.41-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04z"
}), 'Shuffle');

},{"eca28aacaa773979":"kZ6eK","4564e2e1b64a5487":"2vOnF","b468af2d5db88109":"1dlk8"}],"dyxCG":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("d7f419fb12209552").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4990e0c19cb4d874"));
var _jsxRuntime = require("d8cc033b783f5ac3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

},{"d7f419fb12209552":"kZ6eK","4990e0c19cb4d874":"2vOnF","d8cc033b783f5ac3":"1dlk8"}],"cjjJd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagInputField", ()=>TagInputField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _form = require("./Form");
var _store = require("../../store");
var _utils = require("common/utils");
var _reactHookForm = require("react-hook-form");
const TagInputField = ({ formName, type, ...otherProps })=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const fieldValue = getValues(formName) || [];
    const api = (0, _react.useCallback)(async (params)=>{
        const listResult = await (0, _store.Api).tagApi.fetchTags(params);
        // Super user receives tags from all groups - no point in showing duplicates
        const uniqueTags = (0, _utils.distinct)(listResult.items, (a, b)=>a.name === b.name);
        return {
            items: uniqueTags.map((t)=>t.name),
            total: uniqueTags.length
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
        ...otherProps,
        name: formName,
        label: `Tags`,
        required: false,
        api: api,
        multiple: true,
        allowCustomOptions: true,
        validators: {},
        filterSelectedOptions: true,
        comment: `Assign searchable tags to this ${type}`,
        defaultOption: fieldValue,
        getOptionValue: (option)=>option,
        getOptionLabel: (option)=>option,
        optionComparator: (o1, o2)=>o1 === o2,
        autoSelect: true
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./Form":"4Mui7","../../store":"5LXiG","common/utils":"2AqiH","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btaTu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialOutputLogicalPort", ()=>initialOutputLogicalPort);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
var _features = require("../../../utils/features");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _utils = require("../../../utils");
var _form = require("../../common/Form");
var _inputPicker = require("./InputPicker");
var _inputPickerDefault = parcelHelpers.interopDefault(_inputPicker);
var _ipPortForm = require("./PortForm/IpPortForm");
var _vaSdiPortForm = require("./PortForm/CoaxPortForm/VaSdiPortForm");
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _indicator = require("../../common/Indicator");
var _link = require("../../common/Link");
var _index = require("./index");
var _base = require("../../common/Interface/Base");
var _metadata = require("../../common/Metadata");
var _outputsActions = require("../../../redux/actions/outputsActions");
var _constants = require("common/constants");
var _helpers = require("common/api/v1/helpers");
var _matroxSdiPortForm = require("./PortForm/CoaxPortForm/MatroxSdiPortForm");
var _uuid = require("uuid");
var _settingsActions = require("../../../redux/actions/settingsActions");
var _reactAsyncHook = require("react-async-hook");
var _tagInputField = require("../../common/TagInputField");
var _adServerActions = require("../../../redux/actions/adServerActions");
var _index1 = require("../../serviceOverview/Overview/index");
var _adInsertionSection = require("./AdInsertionSection");
var _adPodActions = require("../../../redux/actions/adPodActions");
const { settingsApi } = (0, _store.Api);
const initialOutputLogicalPort = ({ physicalPortId, port, enforcedMode, applianceAllocationId, numDistinctFailoverPriorities, settings, applianceType })=>({
        ...(0, _ipPortForm.srtDefaults)(numDistinctFailoverPriorities || 0),
        ...(0, _ipPortForm.udpDefaults)(),
        ...(0, _ipPortForm.zixiDefaults)(),
        ...(0, _vaSdiPortForm.vaSdiPortDefaults)(),
        ...(0, _matroxSdiPortForm.matroxSdiPortDefaults)(applianceType, settings),
        ...(0, _ipPortForm.rtpDefaults)(),
        ...(0, _ipPortForm.ristDefaults)(),
        ...(0, _ipPortForm.rtmpDefaults)(),
        _port: port,
        [(0, _ipPortForm.CommonFields).mode]: enforcedMode ?? '',
        [(0, _ipPortForm.CommonFields).physicalPort]: physicalPortId,
        [(0, _ipPortForm.CommonFields).copies]: 1,
        [(0, _ipPortForm.CommonFields).applianceAllocationId]: applianceAllocationId,
        // Provide an initial id to use as 'React.key'
        id: _uuid.v4()
    });
const delayModeDescriptors = {
    basedOnOriginTime: {
        label: 'origin time',
        description: 'delay is based on the arrival time of the packet to the input appliance (default)'
    },
    basedOnArrivalTime: {
        label: 'arrival time',
        description: 'delay is based on the arrival time of the packet to the output appliance'
    }
};
const availableDelayModes = Object.keys(delayModeDescriptors);
function makeDelayModeTooltip() {
    return availableDelayModes.map((d)=>{
        const delayModeDescriptor = delayModeDescriptors[d];
        return `${delayModeDescriptor.label}: ${delayModeDescriptor.description}`;
    }).join('\n');
}
function makeDelayModeOptions(firstPortMode) {
    if (firstPortMode === (0, _types.IpPortMode).rtp) return [
        {
            name: 'No delay',
            value: ''
        }
    ];
    return availableDelayModes.map((d)=>({
            name: delayModeDescriptors[d].label,
            value: (0, _types.DelayMode)[d]
        }));
}
const OutputForm = (propsForOutputsForm)=>{
    const { getValues, defaultValues: initialValues, setError, setFocus, formState, clearErrors, trigger: validateForm, reset } = propsForOutputsForm;
    const { formErrors } = (0, _reactRedux.useSelector)(({ outputsReducer })=>({
            formErrors: outputsReducer.formErrors
        }), (0, _reactRedux.shallowEqual));
    const isSaving = (0, _reactRedux.useSelector)(({ outputsReducer })=>outputsReducer.saving, (0, _reactRedux.shallowEqual));
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const setConfirm = (0, _utils.useConfirmationDialog)();
    const settings = (0, _reactAsyncHook.useAsync)(()=>(0, _settingsActions.getSettingsAsync)({
            dispatch,
            settingsApi
        }), []);
    const values = getValues();
    const editType = (0, _index.useEditType)();
    // reset on changed editType
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _react.useEffect)(()=>reset(initialValues), [
        editType,
        reset
    ]);
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach((item)=>{
                setError(item.name, {
                    type: 'manual',
                    message: item.reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    (0, _react.useEffect)(()=>{
        if (values.adServer) dispatch((0, _adServerActions.getAdServer)(values.adServer));
        return ()=>{
            dispatch((0, _adServerActions.clearAdServer)());
        };
    }, [
        values.adServer
    ]);
    (0, _react.useEffect)(()=>{
        if (values.adPod) dispatch((0, _adPodActions.getAdPod)(values.adPod));
        return ()=>{
            dispatch((0, _adPodActions.clearAdPod)());
        };
    }, [
        values.adPod
    ]);
    const { fields: applianceSectionFields, append: appendApplianceSection, remove: removeApplianceSection, update: updateApplianceSection } = (0, _reactHookForm.useFieldArray)({
        name: (0, _base.APPLIANCE_SECTION_FORM_PREFIX)
    });
    const coreNodes = (0, _metadata.getCoreNodesOutput)(values);
    const onRemoveInputAppliance = (index)=>removeApplianceSection(index);
    const initialApplianceSections = (0, _base.collectApplianceSectionEntries)(initialValues);
    const applianceSectionEntries = (0, _base.collectApplianceSectionEntries)(values);
    const selectedPortModes = applianceSectionEntries.flatMap((data)=>data.ports.map((p)=>p.mode)).filter(Boolean);
    const firstSelectedPortMode = selectedPortModes[0];
    const hasMultipleAppliances = applianceSectionEntries.length > 1;
    const canAddAdditionalAppliance = false // applianceSectionEntries.length === 1 // EDGE-3728: Re-enable if/when we once again support multi-appliance outputs
    ;
    const applianceSections = applianceSectionFields.map((field, applianceIndex)=>{
        const sectionData = applianceSectionEntries[applianceIndex];
        // Lock the mode-select if:
        // - Multiple interfaces have been added on a single appliance or
        // - if this is the second appliance of a multi-appliance output and the first appliance has a mode selected
        const hasMultipleLogicalPorts = sectionData.ports.length > 1;
        const isFirstAppliance = applianceIndex === 0;
        const isModeSelectionDisabled = hasMultipleLogicalPorts || !isFirstAppliance && selectedPortModes.length > 1;
        // Don't allow mixing of different port modes
        const enforcedPortMode = hasMultipleAppliances ? firstSelectedPortMode : undefined;
        const adminStatus = (0, _getDefault.default)(values, 'adminStatus') ? 1 : 0;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.ApplianceSection), {
            applianceIndex: applianceIndex,
            title: `Output appliance #${applianceIndex + 1}`,
            namePrefix: `${(0, _base.APPLIANCE_SECTION_FORM_PREFIX)}.${applianceIndex}`,
            adminStatus: adminStatus,
            isModeSelectionDisabled: isModeSelectionDisabled,
            enforcedPortMode: enforcedPortMode,
            initialApplianceOrRegionId: initialApplianceSections[applianceIndex]?.region?.id ?? initialApplianceSections[applianceIndex]?.appliance?.id,
            onRemove: hasMultipleAppliances ? onRemoveInputAppliance : undefined,
            inputId: values.input,
            outputId: editType.isUpdate ? values.id : undefined,
            groupId: values.group ?? user.group,
            isInputForm: false,
            isEditingExistingEntity: editType.isUpdate,
            isCopyingExistingEntity: editType.isCopy,
            isApplianceOrRegionSelectable: (option)=>(0, _base.isApplianceOrRegionSelectable)(option, values, true),
            onApplianceOrRegionSelected: (selected)=>{
                clearErrors();
                if (!selected) {
                    const emptySection = (0, _base.makeApplianceSection)({
                        region: undefined,
                        appliance: undefined
                    });
                    updateApplianceSection(applianceIndex, emptySection);
                } else if ((0, _base.isAppliance)(selected)) {
                    const applianceSection = (0, _base.makeApplianceSection)({
                        region: undefined,
                        appliance: selected
                    });
                    updateApplianceSection(applianceIndex, applianceSection);
                } else {
                    const regionalSection = (0, _base.makeApplianceSection)({
                        region: selected,
                        appliance: undefined
                    });
                    updateApplianceSection(applianceIndex, regionalSection);
                }
            },
            ...propsForOutputsForm
        }, field.id);
    });
    const isHealthAlarmsEnabled = settings && settings.result && (0, _features.isFeatureOn)((0, _types.ExpFeatures).ExtHealthAlarms, settings.result);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                formState: formState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "outputs-form",
                noValidate: true,
                disableSubmitOnEnterKey: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        className: "outlined",
                        title: "Metadata",
                        collapsible: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                                sx: {
                                    paddingBottom: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        name: "name",
                                        label: "Output name",
                                        required: true,
                                        autoFocus: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                        name: "adminStatus",
                                        label: "Enabled",
                                        onClick: ()=>void validateForm()
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagInputField.TagInputField), {
                                        formName: 'tags',
                                        type: 'output',
                                        newLine: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        name: "delay",
                                        label: "Delay (ms)",
                                        type: "number",
                                        tooltip: `Total end-to-end delay from the time the stream is ingested in the Edge input until it is delivered to the Edge output.`,
                                        noNegative: true,
                                        required: true,
                                        validators: {
                                            number: {
                                                greaterThanOrEqualTo: 0,
                                                lessThanOrEqualTo: (0, _constants.DEFAULT_BUFFER_DURATION),
                                                message: `Must be 0 - ${(0, _constants.DEFAULT_BUFFER_DURATION)}`
                                            }
                                        }
                                    }),
                                    isHealthAlarmsEnabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnhealthyAlarmLevel, {}),
                                    settings && settings.result && (0, _features.isFeatureOn)((0, _types.ExpFeatures).ExtSelectableDelayMode, settings.result) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                        name: "delayMode",
                                        label: "Playout delay mode",
                                        required: true,
                                        disabled: firstSelectedPortMode === (0, _types.IpPortMode).rtp,
                                        options: makeDelayModeOptions(firstSelectedPortMode),
                                        tooltip: makeDelayModeTooltip()
                                    })
                                ]
                            }),
                            !!values.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                    lg: 12,
                                    xl: 12,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                                        values: {
                                            Id: values.id,
                                            Tags: (initialValues.tags ?? []).flatMap((tag, i)=>{
                                                const defaultOrder = isHealthAlarmsEnabled ? (0, _types.ListOutputSortableField).healthStatus : undefined;
                                                const link = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                                    to: routes.events({
                                                        tags: tag,
                                                        desc: defaultOrder
                                                    }),
                                                    underline: "hover",
                                                    children: tag
                                                });
                                                return i === 0 ? link : [
                                                    ', ',
                                                    link
                                                ];
                                            }),
                                            Created: (0, _dateFns.format)(new Date(values.createdAt), (0, _helpers.DATE_FORMAT_LONG)),
                                            Updated: (0, _dateFns.format)(new Date(values.updatedAt), (0, _helpers.DATE_FORMAT_LONG)),
                                            Status: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AutoUpdatingOutputHealthIndicator), {
                                                initialOutput: values,
                                                inline: true
                                            }),
                                            Owner: !!values._group?.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                                to: routes.groupsUpdate({
                                                    id: values._group.id
                                                }),
                                                underline: "hover",
                                                available: (0, _utils.isEditableGroup)(values._group.id, user),
                                                children: values._group?.name
                                            }),
                                            [`Output ${(0, _utils.pluralizeWord)(values.appliances?.length ?? 0, 'appliance')}`]: (0, _metadata.applianceList)(values.appliances ?? [], user),
                                            [`Core video ${(0, _utils.pluralizeWord)(coreNodes.length, 'node')}`]: (0, _metadata.applianceList)(coreNodes, user),
                                            'Service Overview': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.ServiceOverviewButton), {
                                                input: values._input,
                                                outputId: values.id
                                            })
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    applianceSections,
                    canAddAdditionalAppliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "contained",
                        color: "secondary",
                        onClick: ()=>{
                            const emptySection = (0, _base.makeApplianceSection)({
                                region: undefined,
                                appliance: undefined
                            });
                            appendApplianceSection(emptySection);
                        },
                        children: "Add output appliance"
                    }),
                    settings && settings.result && (0, _features.isFeatureOn)((0, _types.ExpFeatures).AdInsertion, settings.result) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adInsertionSection.AdInsertionSection), {
                        form: propsForOutputsForm
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        id: "LinksArrayContainer"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputPickerDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>void navigate(routes.outputs())
                            },
                            Save: {
                                primary: true,
                                savingState: isSaving,
                                type: 'submit'
                            }
                        },
                        secondary: editType.isUpdate ? {
                            'Delete output': {
                                onClick: ()=>{
                                    setConfirm(()=>void dispatch((0, _outputsActions.removeOutput)({
                                            output: values,
                                            redirect: true
                                        })), `Deleting output "${values.name}". Are you sure?`);
                                }
                            },
                            DUPLICATE: {
                                onClick: ()=>void navigate(routes.outputsCopy({
                                        id: values.id
                                    }))
                            }
                        } : undefined
                    })
                ]
            })
        ]
    });
};
const UnhealthyAlarmLevel = (_props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
        label: "Alarm level when output is unhealthy",
        name: "unhealthyAlarm",
        options: [
            {
                name: '(No alarm)',
                value: ''
            },
            {
                name: 'Critical',
                value: 'critical'
            },
            {
                name: 'Major',
                value: 'major'
            },
            {
                name: 'Minor',
                value: 'minor'
            },
            {
                name: 'Warning',
                value: 'warning'
            }
        ],
        tooltip: "Choose what type of alarm will be triggered when the output becomes unhealthy."
    });
};
exports.default = OutputForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","react-hook-form":"8z0aI","date-fns":"gelMX","../../../utils/features":"iOvTk","@mui/material/Button":"3qJY9","lodash/get":"dBTJh","common/api/v1/types":"3qemx","../../../store":"5LXiG","../../../utils":"342UB","../../common/Form":"4Mui7","./InputPicker":"fVkLO","./PortForm/IpPortForm":"7TpS5","./PortForm/CoaxPortForm/VaSdiPortForm":"7KTMM","../../common/DataSet":"dmQXG","../../common/Indicator":"hqaQa","../../common/Link":"l3o6V","./index":"5vOuW","../../common/Interface/Base":"gmIdH","../../common/Metadata":"bH3nG","../../../redux/actions/outputsActions":"alMzI","common/constants":"bdiC1","common/api/v1/helpers":"6jovr","./PortForm/CoaxPortForm/MatroxSdiPortForm":"3V8zO","uuid":"dccyI","../../../redux/actions/settingsActions":"4RBnR","react-async-hook":"3D6Y9","../../common/TagInputField":"cjjJd","../../../redux/actions/adServerActions":"h89Of","../../serviceOverview/Overview/index":"1D7NB","./AdInsertionSection":"1FMDi","../../../redux/actions/adPodActions":"2olSr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fVkLO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _types = require("common/api/v1/types");
var _form = require("../../common/Form");
var _thumbnail = require("../../common/Thumbnail");
var _thumbnailDefault = parcelHelpers.interopDefault(_thumbnail);
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _link = require("../../common/Link");
var _selectInputDialog = require("../SelectInputDialog");
var _utils = require("../../../utils");
var _helpers = require("common/api/v1/helpers");
var _base = require("../../common/Interface/Base");
var _utils1 = require("common/utils");
var _store = require("../../../store");
var _reactHookForm = require("react-hook-form");
const InputPicker = ()=>{
    const { setValue, getValues } = (0, _reactHookForm.useFormContext)();
    const [showSelectInputDialog, setShowSelectInputDialog] = (0, _react.useState)(false);
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const setConfirm = (0, _utils.useConfirmationDialog)();
    const values = getValues();
    const onInputSelect = (output, input)=>{
        const didSelectDifferentInput = values.input !== input.id;
        if (!didSelectDifferentInput) return;
        const isRedundantOutput = output.redundancyMode != (0, _types.OutputRedundancyMode).none;
        const outputRedundancyNotPossible = !(0, _utils1.inputRedundancy)(input);
        const action = ()=>{
            setValue('input', input.id);
            setValue('_input', input);
        };
        if (isRedundantOutput && outputRedundancyNotPossible) {
            const callback = ()=>{
                setValue('redundancyMode', (0, _types.OutputRedundancyMode).none);
                action();
            };
            setConfirm(callback, 'You have selected a non-redundant input - output redundancy will be disabled. Proceed?');
        } else action();
    };
    const onClearInput = ()=>{
        setValue('input', undefined);
        setValue('_input', undefined);
    };
    const input = getValues('_input');
    const inputIsRedundant = !!input && (0, _utils1.inputRedundancy)(input);
    const format = (0, _helpers.getFormattedTransportStreamContent)((input?.tsInfo || [])[0]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        className: "outlined",
        title: "Input",
        collapsible: true,
        actionsPane: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                id: "select-input",
                variant: "contained",
                color: "secondary",
                onClick: ()=>setShowSelectInputDialog(true),
                children: "Switch input"
            }, "select-input")
        ],
        children: [
            !!values._input && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.GridItem), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            width: '400px',
                            marginRight: 2
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnailDefault.default), {
                            input: values._input
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                        values: {
                            Name: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                to: routes.inputsUpdate({
                                    id: values._input?.id
                                }),
                                underline: "hover",
                                available: !!values._input?.canSubscribe,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    "data-test-id": 'selected-input-name',
                                    children: values._input.name
                                })
                            }),
                            Owner: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                to: routes.groupsUpdate({
                                    id: values._input?._owner?.id
                                }),
                                underline: "hover",
                                available: !!values._input?._owner?.id && (0, _utils.isEditableGroup)(values._input?._owner?.id, user),
                                children: values._input?._owner?.name
                            }),
                            Format: format
                        }
                    })
                ]
            }),
            inputIsRedundant && !(0, _base.isCoreNode)(values) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                tooltip: "Failover: a secondary redundant path will be activated if the primary one becomes unhealthy.",
                name: "redundancyMode",
                label: "Redundancy mode",
                required: true,
                options: Object.entries((0, _types.OutputRedundancyMode)).filter(([, value])=>typeof value === 'number').map(([name, value])=>({
                        name,
                        value
                    }))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectInputDialog.SelectInputDialog), {
                show: showSelectInputDialog,
                output: values,
                closeDialog: ()=>setShowSelectInputDialog(false),
                onInputSelect: onInputSelect,
                onClearInput: onClearInput
            })
        ]
    });
};
exports.default = InputPicker;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","common/api/v1/types":"3qemx","../../common/Form":"4Mui7","../../common/Thumbnail":"5Q8KF","../../common/DataSet":"dmQXG","../../common/Link":"l3o6V","../SelectInputDialog":"eqSKz","../../../utils":"342UB","common/api/v1/helpers":"6jovr","../../common/Interface/Base":"gmIdH","common/utils":"2AqiH","../../../store":"5LXiG","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7TpS5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "srtDefaults", ()=>(0, _srtForm.srtDefaults));
parcelHelpers.export(exports, "rtpDefaults", ()=>(0, _rtpForm.rtpDefaults));
parcelHelpers.export(exports, "udpDefaults", ()=>(0, _udpForm.udpDefaults));
parcelHelpers.export(exports, "zixiDefaults", ()=>(0, _zixiForm.zixiDefaults));
parcelHelpers.export(exports, "ristDefaults", ()=>(0, _ristForm.ristDefaults));
parcelHelpers.export(exports, "rtmpDefaults", ()=>(0, _rtmpForm.rtmpDefaults));
parcelHelpers.export(exports, "CommonFields", ()=>CommonFields);
parcelHelpers.export(exports, "getIpPortFormFields", ()=>getIpPortFormFields);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _udpForm = require("./UdpForm");
var _udpFormDefault = parcelHelpers.interopDefault(_udpForm);
var _rtpForm = require("./RtpForm");
var _rtpFormDefault = parcelHelpers.interopDefault(_rtpForm);
var _srtForm = require("./SrtForm");
var _srtFormDefault = parcelHelpers.interopDefault(_srtForm);
var _zixiForm = require("./ZixiForm");
var _zixiFormDefault = parcelHelpers.interopDefault(_zixiForm);
var _ristForm = require("./RistForm");
var _ristFormDefault = parcelHelpers.interopDefault(_ristForm);
var _rtmpForm = require("./RtmpForm");
var _rtmpFormDefault = parcelHelpers.interopDefault(_rtmpForm);
var _ports = require("common/ports");
var _reactHookForm = require("react-hook-form");
var CommonFields = /*#__PURE__*/ function(CommonFields) {
    CommonFields["id"] = "id";
    CommonFields["mode"] = "mode";
    CommonFields["physicalPort"] = "physicalPort";
    CommonFields["copies"] = "copies";
    CommonFields["region"] = "region";
    CommonFields["applianceAllocationId"] = "applianceAllocationId";
    return CommonFields;
}({});
const getIpPortFormFields = (port)=>{
    const common = [
        "id",
        "mode",
        "physicalPort",
        "copies",
        "region",
        "applianceAllocationId"
    ];
    switch(port.mode){
        case (0, _types.IpPortMode).udp:
            return [
                ...common,
                ...(0, _udpForm.getUdpFieldsToSave)()
            ];
        case (0, _types.IpPortMode).rtp:
            return [
                ...common,
                ...(0, _rtpForm.getRtpFieldsToSave)()
            ];
        case (0, _types.IpPortMode).zixi:
            return [
                ...common,
                ...(0, _zixiForm.getZixiFieldsToSave)(port)
            ];
        case (0, _types.IpPortMode).rist:
            return [
                ...common,
                ...(0, _ristForm.getRistFieldsToSave)()
            ];
        case (0, _types.IpPortMode).srt:
            return [
                ...common,
                ...(0, _srtForm.getSrtFieldsToSave)(port)
            ];
        case (0, _types.IpPortMode).rtmp:
            return [
                ...common,
                ...(0, _rtmpForm.getRtmpFieldsToSave)()
            ];
    }
    return [];
};
const IpPortForm = ({ addresses, applianceId, applianceType, applianceVersion, applianceFeatures, index, namePrefix, occupiedPorts, isModeDisabled, enforcedPortMode, onAddLogicalPortRequested, onRemoveLogicalPortRequested })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const modesOptions = applianceFeatures.output?.modes.filter((m)=>m.mode in (0, _types.IpPortMode)).map((m)=>({
            name: m.prettyName ?? m.mode,
            value: m.mode
        })) ?? [];
    const modeValues = modesOptions.map((m)=>m.value);
    const adminStatus = getValues('adminStatus') ? (0, _types.OutputAdminStatus).on : (0, _types.OutputAdminStatus).off;
    const modeKey = `${namePrefix}.mode`;
    const currentIpPortMode = watch(modeKey);
    const isValidMode = enforcedPortMode ? currentIpPortMode === enforcedPortMode : modeValues.includes(currentIpPortMode);
    (0, _react.useEffect)(()=>{
        if (!isValidMode) {
            // Disallow mixing of port modes for outputs with multiple appliances
            const newMode = enforcedPortMode ?? '';
            if (currentIpPortMode !== newMode) setValue(modeKey, newMode);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidMode,
        enforcedPortMode,
        currentIpPortMode,
        modeKey
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Mode",
                name: modeKey,
                newLine: true,
                required: true,
                disabled: isModeDisabled,
                options: modesOptions,
                validators: {
                    oneOf: {
                        validValues: new Set(modeValues)
                    }
                }
            }),
            currentIpPortMode === (0, _types.IpPortMode).udp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _udpFormDefault.default), {
                namePrefix: namePrefix,
                addresses: addresses
            }),
            currentIpPortMode === (0, _types.IpPortMode).rtp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtpFormDefault.default), {
                namePrefix: namePrefix,
                applianceType: applianceType,
                applianceVersion: applianceVersion,
                addresses: addresses,
                applianceFecLimits: applianceFeatures.fec
            }),
            currentIpPortMode === (0, _types.IpPortMode).rtmp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtmpFormDefault.default), {
                namePrefix: namePrefix
            }),
            currentIpPortMode === (0, _types.IpPortMode).srt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _srtFormDefault.default), {
                namePrefix: namePrefix,
                portIndex: index,
                adminStatus: adminStatus,
                addresses: addresses,
                applianceId: applianceId,
                applianceType: applianceType,
                applianceVersion: applianceVersion,
                applianceFeatures: applianceFeatures,
                occupiedPorts: occupiedPorts.filter((o)=>(0, _ports.isUdpBasedProtocol)(o.portMode)),
                onAddLogicalPortRequested: onAddLogicalPortRequested,
                onRemoveLogicalPortRequested: onRemoveLogicalPortRequested
            }),
            currentIpPortMode === (0, _types.IpPortMode).zixi && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _zixiFormDefault.default), {
                namePrefix: namePrefix,
                addresses: addresses,
                applianceType: applianceType,
                applianceVersion: applianceVersion,
                applianceFeatures: applianceFeatures
            }),
            currentIpPortMode === (0, _types.IpPortMode).rist && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ristFormDefault.default), {
                namePrefix: namePrefix,
                addresses: addresses
            })
        ]
    });
};
exports.default = IpPortForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","./UdpForm":"3sxES","./RtpForm":"MriLK","./SrtForm":"9w6kL","./ZixiForm":"5Jn5r","./RistForm":"3WkQd","./RtmpForm":"dzZmz","common/ports":"5XehL","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3sxES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UdpFields", ()=>UdpFields);
parcelHelpers.export(exports, "udpDefaults", ()=>udpDefaults);
parcelHelpers.export(exports, "getUdpFieldsToSave", ()=>getUdpFieldsToSave);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _reactHookForm = require("react-hook-form");
var UdpFields = /*#__PURE__*/ function(UdpFields) {
    UdpFields["sourceAddress"] = "sourceAddress";
    UdpFields["address"] = "address";
    UdpFields["port"] = "port";
    UdpFields["ttl"] = "ttl";
    return UdpFields;
}({});
const udpDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(UdpFields), [], {
        ttl: 64
    });
const getUdpFieldsToSave = ()=>[
        "sourceAddress",
        "address",
        "port",
        "ttl"
    ];
const UdpForm = ({ addresses, namePrefix })=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const sourceAddressSelector = `${namePrefix}.${"sourceAddress"}`;
    const selectedSourceAddress = getValues(sourceAddressSelector);
    const addressesAndEmptyAddress = [
        {
            address: '',
            netmask: ''
        },
        ...addresses
    ];
    const addressOptions = [
        {
            name: 'any',
            value: ''
        },
        ...(0, _utils.makeAddressOptions)(selectedSourceAddress, addresses)
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: sourceAddressSelector,
                label: "Source Address",
                options: addressOptions,
                newLine: true,
                validators: {
                    addressIn: {
                        addresses: addressesAndEmptyAddress
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"address"}`,
                label: "Destination address",
                required: true,
                type: "text",
                validators: {
                    ip: {}
                },
                newLine: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"port"}`,
                label: "Destination Port",
                required: true,
                type: "number",
                noNegative: true,
                validators: {
                    port: {
                        isUdp: true
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"ttl"}`,
                label: "TTL",
                required: true,
                type: "number",
                validators: {
                    number: {
                        greaterThanOrEqualTo: 1,
                        lessThanOrEqualTo: 255
                    }
                }
            })
        ]
    });
};
exports.default = UdpForm;

},{"react/jsx-runtime":"1dlk8","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"MriLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RtpFields", ()=>RtpFields);
parcelHelpers.export(exports, "rtpDefaults", ()=>rtpDefaults);
parcelHelpers.export(exports, "getRtpFieldsToSave", ()=>getRtpFieldsToSave);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _validateJs = require("validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _versions = require("common/versions");
var _applianceTypes = require("common/applianceTypes"); // TODO: Remove usage of static/compiled applianceTypes
var _reactHookForm = require("react-hook-form");
const addFecValidator = (namePrefix, port, fecMaxSize)=>{
    (0, _validateJsDefault.default).validators[`fec-${namePrefix}`] = (value, { min, max })=>{
        if (value === '') return;
        if (value < min || value > max) return `Must be ${min} - ${max}`;
        if (port && port.fecRows && port.fecCols) {
            const val = port.fecRows * port.fecCols;
            if (val > fecMaxSize) return `FecRows multiplied by FecCols equals ${val}, which exceeds maximum value of ${fecMaxSize}`;
        }
        return undefined;
    };
};
var RtpFields = /*#__PURE__*/ function(RtpFields) {
    RtpFields["sourceAddress"] = "sourceAddress";
    RtpFields["address"] = "address";
    RtpFields["port"] = "port";
    RtpFields["fec"] = "fec";
    RtpFields["fecRows"] = "fecRows";
    RtpFields["fecCols"] = "fecCols";
    RtpFields["ttl"] = "ttl";
    return RtpFields;
}({});
const rtpDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(RtpFields), [], {
        ttl: 64
    });
const getRtpFieldsToSave = ()=>[
        "sourceAddress",
        "address",
        "port",
        "fec",
        "fecRows",
        "fecCols",
        "ttl"
    ];
const RtpForm = ({ namePrefix, addresses, applianceType, applianceVersion, applianceFecLimits })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const port = getValues(namePrefix);
    (0, _react.useEffect)(()=>{
        if (!port.fec) {
            if (port.fecCols) setValue(`${namePrefix}.fecCols`, '');
            if (port.fecRows) setValue(`${namePrefix}.fecRows`, '');
        }
    }, [
        port,
        namePrefix,
        setValue
    ]);
    const isFecSupported = (0, _versions.supportsFec)(applianceType, applianceVersion);
    const isFecEnabled = !!port.fec;
    const fecRowMin = applianceFecLimits?.rowRange.min ?? (0, _applianceTypes.standardFecSettings).rowRange.min;
    const fecRowMax = applianceFecLimits?.rowRange.max ?? (0, _applianceTypes.standardFecSettings).rowRange.max;
    const fecColMin = applianceFecLimits?.colRange.min ?? (0, _applianceTypes.standardFecSettings).colRange.min;
    const fecColMax = applianceFecLimits?.colRange.max ?? (0, _applianceTypes.standardFecSettings).colRange.max;
    const fecMaxSize = applianceFecLimits?.maxSize ?? (0, _applianceTypes.standardFecSettings).maxSize;
    const fecKey = `${namePrefix}.${"fec"}`;
    watch(fecKey);
    addFecValidator(namePrefix, port, fecMaxSize);
    const sourceAddressSelector = `${namePrefix}.${"sourceAddress"}`;
    const selectedSourceAddress = getValues(sourceAddressSelector);
    const addressesAndEmptyAddress = [
        {
            address: '',
            netmask: ''
        },
        ...addresses
    ];
    const addressOptions = [
        {
            name: 'any',
            value: ''
        },
        ...(0, _utils.makeAddressOptions)(selectedSourceAddress, addresses)
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: sourceAddressSelector,
                label: "Source Address",
                options: addressOptions,
                newLine: true,
                validators: {
                    addressIn: {
                        addresses: addressesAndEmptyAddress
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"address"}`,
                label: "Destination address",
                required: true,
                type: "text",
                newLine: true,
                validators: {
                    ip: {}
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"port"}`,
                label: "Destination Port",
                required: true,
                type: "number",
                noNegative: true,
                validators: {
                    port: {
                        isUdp: true
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"ttl"}`,
                label: "TTL",
                required: true,
                type: "number",
                validators: {
                    number: {
                        greaterThanOrEqualTo: 1,
                        lessThanOrEqualTo: 255
                    }
                }
            }),
            isFecSupported && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        newLine: true,
                        label: "Fec",
                        name: fecKey,
                        options: [
                            {
                                name: 'none',
                                value: ''
                            },
                            ...Object.values((0, _types.OutputPortFec))
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        newLine: true,
                        disabled: !isFecEnabled,
                        required: isFecEnabled,
                        name: `${namePrefix}.${"fecRows"}`,
                        label: "Fec rows",
                        type: "number",
                        validators: {
                            [`fec-${namePrefix}`]: {
                                min: fecRowMin,
                                max: fecRowMax
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        disabled: !isFecEnabled,
                        required: isFecEnabled,
                        name: `${namePrefix}.${"fecCols"}`,
                        label: "Fec cols",
                        type: "number",
                        validators: {
                            [`fec-${namePrefix}`]: {
                                min: fecColMin,
                                max: fecColMax
                            }
                        }
                    })
                ]
            })
        ]
    });
};
exports.default = RtpForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","validate.js":"emzWS","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","common/versions":"4vuwV","common/applianceTypes":"it4bJ","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"it4bJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applianceTypes = exports.emptyFeatureSet = exports.core = exports.edgeConnect = exports.Nimbra204GopStructure = exports.VaGopStructure = exports.standardFecSettings = void 0;
const types_1 = require("37f17b0e3d739ec9");
const vaVersion_1 = require("2c3a0cb527c92719");
const serialization_1 = require("d32e96d4f6b97b29");
const versions_1 = require("83966748d9315d35");
const constants_1 = require("b05a0d52fd9f52fb");
exports.standardFecSettings = {
    maxSize: 100,
    rowRange: {
        min: 4,
        max: 20
    },
    colRange: {
        min: 1,
        max: 20
    }
};
var VaGopStructure;
(function(VaGopStructure) {
    VaGopStructure["IP"] = "IP";
    VaGopStructure["IPB"] = "IPB";
    VaGopStructure["IPBB"] = "IPBB";
    VaGopStructure["IPBBB"] = "IPBBB";
    VaGopStructure["IPBBBBB"] = "IPBBBBB";
    VaGopStructure["IPBBBBBBB"] = "IPBBBBBBB";
})(VaGopStructure || (exports.VaGopStructure = VaGopStructure = {}));
var Nimbra204GopStructure;
(function(Nimbra204GopStructure) {
    Nimbra204GopStructure["IP"] = "0";
    Nimbra204GopStructure["IPB"] = "1";
    Nimbra204GopStructure["IPBB"] = "2";
    Nimbra204GopStructure["IPBBB"] = "3";
    Nimbra204GopStructure["IPBBBBB"] = "4";
    Nimbra204GopStructure["IPBBBBBBB"] = "5";
})(Nimbra204GopStructure || (exports.Nimbra204GopStructure = Nimbra204GopStructure = {}));
const nimbraVa220 = (_product, version)=>{
    const gopStructures = [
        {
            name: 'IP',
            value: VaGopStructure.IP
        },
        {
            name: 'IPB',
            value: VaGopStructure.IPB
        },
        {
            name: 'IPBB',
            value: VaGopStructure.IPBB
        },
        {
            name: 'IPBBB',
            value: VaGopStructure.IPBBB
        },
        {
            name: 'IPBBBBB',
            value: VaGopStructure.IPBBBBB
        },
        {
            name: 'IPBBBBBBB',
            value: VaGopStructure.IPBBBBBBB
        }
    ];
    const sdiInputCapabilities = {
        video: {
            customPid: true,
            codecs: [
                {
                    name: types_1.VideoCodec.h264,
                    bitrate: {
                        min: 1000000,
                        max: 30000000
                    },
                    scte35Insertion: {
                        customPid: true
                    },
                    gopStructures
                },
                {
                    name: types_1.VideoCodec.h265,
                    bitrate: {
                        min: 1000000,
                        max: 30000000
                    },
                    scte35Insertion: {
                        customPid: true
                    }
                }
            ],
            flags: [
                ...(0, vaVersion_1.vaVersionSupports12MTimeCode)(version?.vaVersion) ? [
                    {
                        name: 'SMPTE 12M timecode',
                        value: types_1.Nimbra400VideoFlags.smpte12mTimecode,
                        disabledForCodecs: [
                            types_1.VideoCodec.h265
                        ]
                    }
                ] : []
            ]
        },
        audio: {
            maxAudioStreams: 8,
            layout: [
                types_1.AudioLayout.mono,
                types_1.AudioLayout.stereo
            ],
            customPid: true,
            codecs: [
                {
                    name: types_1.AudioCodec.aes3,
                    bitratesKbps: [
                        1920
                    ]
                },
                {
                    name: types_1.AudioCodec.aacLc,
                    bitratesKbps: [
                        96,
                        128,
                        192,
                        256,
                        384
                    ]
                },
                {
                    name: types_1.AudioCodec.mpeg2,
                    bitratesKbps: [
                        96,
                        128,
                        192,
                        256,
                        384
                    ]
                },
                {
                    name: types_1.AudioCodec.heAac,
                    bitratesKbps: [
                        96,
                        128
                    ]
                }
            ].concat((0, vaVersion_1.vaVersionIsGreaterOrEqual)((0, vaVersion_1.parseVaVersion)(version && version.vaVersion), vaVersion_1.VaVersions['VA-16.4.0.0']) ? [
                {
                    name: types_1.AudioCodec.ac3pt,
                    bitratesKbps: [
                        192,
                        384,
                        448,
                        640
                    ]
                }
            ] : [])
        }
    };
    return {
        proxy: {
            enabled: true,
            forwardedCookies: [
                'token'
            ]
        },
        coaxPorts: 4,
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.listener,
                        types_1.SrtMode.rendezvous
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    mode: types_1.IpPortMode.zixi,
                    subModes: [
                        types_1.ZixiMode.pull,
                        types_1.ZixiMode.push
                    ]
                },
                {
                    mode: types_1.CoaxPortMode.sdi,
                    encoder: sdiInputCapabilities
                },
                {
                    mode: types_1.CoaxPortMode.asi
                }
            ]
        },
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.listener,
                        types_1.SrtMode.rendezvous
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    mode: types_1.IpPortMode.zixi,
                    subModes: [
                        types_1.ZixiMode.pull,
                        types_1.ZixiMode.push
                    ]
                },
                {
                    mode: types_1.CoaxPortMode.sdi
                },
                {
                    mode: types_1.CoaxPortMode.asi
                }
            ]
        },
        fec: exports.standardFecSettings
    };
};
const nimbraVa225 = patchedCopy(nimbraVa220);
const nimbraVaDocker = patchedCopy(nimbraVa220, (v)=>{
    v.coaxPorts = 0;
    v.input = {
        ...v.input,
        modes: v.input?.modes.filter((m)=>m.mode in types_1.IpPortMode) ?? []
    };
    v.output = {
        ...v.output,
        modes: v.output?.modes.filter((m)=>m.mode in types_1.IpPortMode) ?? []
    };
});
const nimbra410 = patchedCopy(nimbraVaDocker);
const nimbra412 = patchedCopy(nimbraVa220, (v)=>v.coaxPorts = 2);
const nimbra414 = patchedCopy(nimbraVa220);
function patchedCopy(factoryFn, patch) {
    return (product, applianceVersion)=>{
        const clone = (0, serialization_1.jsonParse)((0, serialization_1.jsonStringify)(factoryFn(product, applianceVersion)));
        patch?.(clone);
        return clone;
    };
}
const edgeConnect = (_product, version)=>{
    const zixiZecSupported = version ? (0, versions_1.supportsZixiForEdgeConnect)(version) : false;
    return {
        proxy: {
            enabled: false
        },
        fec: version && (0, versions_1.supportsFec)(types_1.ApplianceType.edgeConnect, version) ? exports.standardFecSettings : undefined,
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.generator
                },
                {
                    mode: types_1.IpPortMode.rist,
                    subModes: [
                        types_1.RistProfile.simple
                    ]
                },
                {
                    mode: types_1.IpPortMode.rtmp
                },
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                ...zixiZecSupported ? [
                    {
                        mode: types_1.IpPortMode.zixi,
                        subModes: [
                            types_1.ZixiMode.pull
                        ]
                    }
                ] : []
            ]
        },
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rist,
                    subModes: [
                        types_1.RistProfile.simple
                    ]
                },
                {
                    mode: types_1.IpPortMode.rtmp
                },
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                ...zixiZecSupported ? [
                    {
                        mode: types_1.IpPortMode.zixi,
                        subModes: [
                            types_1.ZixiMode.push
                        ]
                    }
                ] : []
            ]
        }
    };
};
exports.edgeConnect = edgeConnect;
const core = (product, version)=>{
    const zixiZecSupported = version ? (0, versions_1.supportsZixiZec)(version) : false;
    const zixiSupported = product === constants_1.PRODUCTS.nimbraEdge.id || zixiZecSupported;
    return {
        proxy: {
            enabled: false
        },
        fec: version && (0, versions_1.supportsFec)(types_1.ApplianceType.core, version) ? exports.standardFecSettings : undefined,
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.generator
                },
                {
                    mode: types_1.IpPortMode.rist,
                    subModes: [
                        types_1.RistProfile.simple
                    ]
                },
                {
                    mode: types_1.IpPortMode.rtmp
                },
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                ...zixiSupported ? [
                    {
                        mode: types_1.IpPortMode.zixi,
                        subModes: [
                            types_1.ZixiMode.pull
                        ]
                    }
                ] : []
            ]
        },
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rist,
                    subModes: [
                        types_1.RistProfile.simple
                    ]
                },
                {
                    mode: types_1.IpPortMode.rtmp
                },
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                ...zixiSupported ? [
                    {
                        mode: types_1.IpPortMode.zixi,
                        subModes: [
                            types_1.ZixiMode.push
                        ]
                    }
                ] : []
            ]
        }
    };
};
exports.core = core;
const emptyFeatureSet = (_product, _)=>({
        proxy: {
            enabled: false
        }
    });
exports.emptyFeatureSet = emptyFeatureSet;
const videon = (_product, _)=>{
    const inputCapabilities = {
        video: {
            latencyModes: [
                {
                    name: 'High',
                    value: 'HIGH'
                },
                {
                    name: 'Normal',
                    value: 'NORMAL'
                },
                {
                    name: 'Low',
                    value: 'LOW'
                },
                {
                    name: 'Lowest',
                    value: 'LOWEST'
                }
            ],
            scalingModes: [
                {
                    name: 'Passthrough',
                    value: 'RES_PASSTHROUGH'
                },
                {
                    name: '320X180',
                    value: 'RES_320X180'
                },
                {
                    name: '480X270',
                    value: 'RES_480X270'
                },
                {
                    name: '640X360',
                    value: 'RES_640X360'
                },
                {
                    name: '720X576',
                    value: 'RES_720X576'
                },
                {
                    name: '960X540',
                    value: 'RES_960X540'
                },
                {
                    name: '1280X720',
                    value: 'RES_1280X720'
                },
                {
                    name: '1920X1080',
                    value: 'RES_1920X1080'
                },
                {
                    name: '3840X2160',
                    value: 'RES_3840X2160'
                }
            ],
            customPid: false,
            codecs: [
                {
                    name: types_1.VideoCodec.h264,
                    profile: [
                        {
                            name: 'Baseline Profile',
                            value: 'PROFILE_BASELINE'
                        },
                        {
                            name: 'Main Profile',
                            value: 'PROFILE_MAIN'
                        },
                        {
                            name: 'High Profile',
                            value: 'PROFILE_HIGH'
                        }
                    ],
                    bitrate: {
                        min: 1000000,
                        max: 30000000
                    }
                },
                {
                    name: types_1.VideoCodec.h265,
                    bitrate: {
                        min: 1000000,
                        max: 30000000
                    },
                    profile: [
                        {
                            name: 'Main Profile',
                            value: 'PROFILE_MAIN'
                        }
                    ]
                }
            ],
            flags: [
                {
                    name: 'Limit to 30 FPS',
                    value: types_1.VideonVideoFlags.limitTo30Fps,
                    disabledForCodecs: []
                },
                {
                    name: 'Enable SCTE-104/SCTE-35 Insertion',
                    value: types_1.VideonVideoFlags.scte35Insertion,
                    disabledForCodecs: []
                },
                {
                    name: 'Enable KLV Timecode Insertion for Video Frames',
                    value: types_1.VideonVideoFlags.klvTimeCodeInsertion,
                    disabledForCodecs: []
                },
                {
                    name: 'Enable SMPTE-2038',
                    value: types_1.VideonVideoFlags.smpte2038Insertion,
                    disabledForCodecs: []
                },
                {
                    name: 'Enable CEA-708/608 captions',
                    value: types_1.VideonVideoFlags.cea708_608Captions,
                    disabledForCodecs: []
                }
            ]
        },
        audio: {
            maxAudioStreams: 1,
            layout: [
                types_1.AudioLayout.stereo
            ],
            customPid: false,
            codecs: [
                {
                    name: types_1.AudioCodec.aacLc,
                    bitratesKbps: [
                        64,
                        96,
                        128,
                        192,
                        256,
                        320,
                        384,
                        512
                    ]
                }
            ]
        }
    };
    return {
        proxy: {
            enabled: false
        },
        coaxPorts: 1,
        input: {
            modes: [
                {
                    prettyName: 'sdi',
                    mode: types_1.VideonPortMode.videonSdi,
                    encoder: inputCapabilities
                },
                {
                    prettyName: 'hdmi',
                    mode: types_1.VideonPortMode.videonHdmi,
                    encoder: inputCapabilities
                },
                {
                    prettyName: 'auto',
                    mode: types_1.VideonPortMode.videonAuto,
                    encoder: inputCapabilities
                },
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                }
            ]
        },
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                }
            ]
        }
    };
};
const dummyCapabilities = {
    video: {
        codecs: [],
        customPid: false
    },
    audio: {
        maxAudioStreams: 1,
        layout: [],
        codecs: [],
        customPid: false
    }
};
const matroxCookies = [
    'Identity.External',
    'CommandCenter',
    'AspNetCore.Mvc.CookieTempDataProvider',
    '.AspNetCore.Antiforgery.*'
];
const matroxE4 = (_product, _)=>({
        proxy: {
            enabled: true,
            forwardedCookies: matroxCookies
        },
        coaxPorts: 4,
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    prettyName: 'sdi',
                    mode: types_1.MatroxPortMode.matroxSdi,
                    encoder: dummyCapabilities
                }
            ]
        }
    });
const matroxE410Bit = (_product, _)=>{
    const isRunningMatroxV2 = false; // FIXME MG: Remove when we wish to support matrox v2 features
    return {
        proxy: {
            enabled: true,
            forwardedCookies: matroxCookies
        },
        coaxPorts: 4,
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    prettyName: 'sdi',
                    mode: types_1.MatroxPortMode.matroxSdi,
                    encoder: dummyCapabilities
                }
            ]
        },
        output: isRunningMatroxV2 ? {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    prettyName: 'sdi',
                    mode: types_1.MatroxPortMode.matroxSdi,
                    decoder: dummyCapabilities
                }
            ]
        } : undefined
    };
};
const matroxD4 = (_product, _)=>({
        proxy: {
            enabled: true,
            forwardedCookies: matroxCookies
        },
        coaxPorts: 4,
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    prettyName: 'sdi',
                    mode: types_1.MatroxPortMode.matroxSdi,
                    decoder: dummyCapabilities
                }
            ]
        }
    });
const matroxS1 = (_product, _)=>({
        proxy: {
            enabled: true,
            forwardedCookies: matroxCookies
        },
        coaxPorts: 1,
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    prettyName: 'sdi',
                    mode: types_1.MatroxPortMode.matroxSdi,
                    encoder: dummyCapabilities
                }
            ]
        },
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    prettyName: 'sdi',
                    mode: types_1.MatroxPortMode.matroxSdi,
                    decoder: dummyCapabilities
                }
            ]
        }
    });
const comprimato = (_product, _)=>{
    const inputCapabilities = {
        video: {
            codecs: [
                {
                    name: types_1.VideoCodec.h264,
                    profile: [
                        {
                            name: 'High',
                            value: 'HIGH'
                        },
                        {
                            name: 'Main',
                            value: 'MAIN'
                        },
                        {
                            name: 'Baseline (software encoder)',
                            value: 'BASELINE'
                        }
                    ],
                    colorSampling: [
                        {
                            name: '4:2:0',
                            value: '4:2:0'
                        },
                        {
                            name: '4:2:2',
                            value: '4:2:2'
                        }
                    ],
                    bitDepth: [
                        8,
                        10
                    ],
                    resolution: [
                        {
                            name: '720p',
                            value: '720p'
                        },
                        {
                            name: '1080p',
                            value: '1080p'
                        },
                        {
                            name: '480i',
                            value: '480i'
                        },
                        {
                            name: '576i',
                            value: '576i'
                        },
                        {
                            name: '1080i',
                            value: '1080i'
                        }
                    ],
                    scanRate: [
                        '23.976',
                        '24',
                        '25',
                        '29.97',
                        '30',
                        '50',
                        '59.94',
                        '60'
                    ],
                    bitrate: {
                        min: 0,
                        max: 40000000
                    },
                    restrictions: {
                        bitDepth: {
                            determinedBy: 'profile',
                            mapping: {
                                BASELINE: [
                                    8
                                ],
                                MAIN: [
                                    8
                                ],
                                HIGH: [
                                    8,
                                    10
                                ]
                            }
                        },
                        colorSampling: {
                            determinedBy: 'profile',
                            mapping: {
                                BASELINE: [
                                    '4:2:0'
                                ],
                                MAIN: [
                                    '4:2:0'
                                ],
                                HIGH: [
                                    '4:2:0',
                                    '4:2:2'
                                ]
                            }
                        }
                    }
                },
                {
                    name: types_1.VideoCodec.h265,
                    profile: [
                        {
                            name: 'Main',
                            value: 'MAIN'
                        },
                        {
                            name: 'Main10',
                            value: 'MAIN10'
                        }
                    ],
                    colorSampling: [
                        {
                            name: '4:2:0',
                            value: '4:2:0'
                        }
                    ],
                    bitDepth: [
                        8,
                        10
                    ],
                    resolution: [
                        {
                            name: '720p',
                            value: '720p'
                        },
                        {
                            name: '1080p',
                            value: '1080p'
                        }
                    ],
                    scanRate: [
                        '23.976',
                        '24',
                        '25',
                        '29.97',
                        '30',
                        '50',
                        '59.94',
                        '60'
                    ],
                    bitrate: {
                        min: 0,
                        max: 40000000
                    },
                    restrictions: {
                        bitDepth: {
                            determinedBy: 'profile',
                            mapping: {
                                MAIN: [
                                    8
                                ],
                                MAIN10: [
                                    8,
                                    10
                                ]
                            }
                        },
                        colorSampling: {
                            determinedBy: 'profile',
                            mapping: {
                                MAIN: [
                                    '4:2:0'
                                ],
                                MAIN10: [
                                    '4:2:0'
                                ]
                            }
                        }
                    }
                }
            ],
            customPid: false
        },
        audio: {
            maxAudioStreams: 1,
            layout: [
                types_1.AudioLayout.stereo
            ],
            customPid: false,
            codecs: [
                {
                    name: types_1.AudioCodec.aacAdts,
                    bitratesKbps: [
                        64,
                        96,
                        128,
                        192,
                        256,
                        320,
                        384,
                        512
                    ]
                },
                {
                    name: types_1.AudioCodec.aacLatm,
                    bitratesKbps: [
                        64,
                        96,
                        128,
                        192,
                        256,
                        320,
                        384,
                        512
                    ]
                },
                {
                    name: types_1.AudioCodec.mpeg2,
                    bitratesKbps: [
                        64,
                        96,
                        128,
                        192,
                        256,
                        320,
                        384
                    ]
                },
                {
                    name: types_1.AudioCodec.aes3,
                    bitratesKbps: [],
                    bitDepth: [
                        20,
                        24
                    ]
                },
                {
                    name: types_1.AudioCodec.ac3,
                    bitratesKbps: [
                        192,
                        384,
                        448,
                        640
                    ]
                }
            ]
        }
    };
    return {
        proxy: {
            enabled: true,
            forwardedCookies: [
                'http_auth_session'
            ]
        },
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    prettyName: 'sdi',
                    mode: types_1.ComprimatoPortMode.comprimatoSdi,
                    encoder: inputCapabilities
                },
                {
                    prettyName: 'ndi',
                    mode: types_1.ComprimatoPortMode.comprimatoNdi,
                    encoder: inputCapabilities
                }
            ]
        },
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    prettyName: 'sdi',
                    mode: types_1.ComprimatoPortMode.comprimatoSdi,
                    decoder: {
                        audio: {
                            maxAudioStreams: 1,
                            customPid: false,
                            layout: [
                                types_1.AudioLayout.stereo
                            ],
                            codecs: [
                                {
                                    name: types_1.AudioCodec.aes3,
                                    bitratesKbps: [
                                        3000
                                    ],
                                    bitDepth: [
                                        20,
                                        24
                                    ]
                                },
                                {
                                    name: types_1.AudioCodec.ac3,
                                    bitratesKbps: [
                                        192,
                                        384,
                                        448,
                                        640
                                    ]
                                }
                            ]
                        },
                        video: {
                            codecs: [
                                {
                                    name: types_1.RawVideo,
                                    colorSampling: [
                                        {
                                            name: '4:2:2',
                                            value: '4:2:2'
                                        }
                                    ],
                                    bitDepth: [
                                        10
                                    ],
                                    bitrate: {
                                        min: 0,
                                        max: 40000000
                                    },
                                    resolution: [
                                        {
                                            name: '720p',
                                            value: '720p'
                                        },
                                        {
                                            name: '1080p',
                                            value: '1080p'
                                        },
                                        {
                                            name: '480i',
                                            value: '480i'
                                        },
                                        {
                                            name: '576i',
                                            value: '576i'
                                        },
                                        {
                                            name: '1080i',
                                            value: '1080i'
                                        }
                                    ],
                                    scanRate: [
                                        '23.976',
                                        '24',
                                        '25',
                                        '29.97',
                                        '30',
                                        '50',
                                        '59.94',
                                        '60'
                                    ]
                                }
                            ],
                            customPid: false
                        }
                    }
                },
                {
                    prettyName: 'ndi',
                    mode: types_1.ComprimatoPortMode.comprimatoNdi,
                    decoder: {
                        audio: {
                            maxAudioStreams: 1,
                            layout: [
                                types_1.AudioLayout.stereo
                            ],
                            customPid: false,
                            codecs: [
                                {
                                    name: types_1.AudioCodec.raw,
                                    bitratesKbps: []
                                }
                            ]
                        },
                        video: {
                            codecs: [
                                {
                                    name: types_1.RawVideo,
                                    colorSampling: [
                                        {
                                            name: '4:2:2',
                                            value: '4:2:2'
                                        }
                                    ],
                                    bitDepth: [
                                        10
                                    ],
                                    bitrate: {
                                        min: 0,
                                        max: 40000000
                                    },
                                    resolution: [
                                        {
                                            name: '720p',
                                            value: '720p'
                                        },
                                        {
                                            name: '1080p',
                                            value: '1080p'
                                        },
                                        {
                                            name: '480i',
                                            value: '480i'
                                        },
                                        {
                                            name: '576i',
                                            value: '576i'
                                        },
                                        {
                                            name: '1080i',
                                            value: '1080i'
                                        }
                                    ],
                                    scanRate: [
                                        '23.976',
                                        '24',
                                        '25',
                                        '29.97',
                                        '30',
                                        '50',
                                        '59.94',
                                        '60'
                                    ]
                                }
                            ],
                            customPid: false
                        }
                    }
                }
            ]
        }
    };
};
const mediakindCookies = [
    'csrftoken',
    'sessionid'
];
const mediakindHeaders = [
    'x-requested-with',
    'x-csrftoken'
];
const mediakindRx1 = (_product, _)=>({
        proxy: {
            enabled: true,
            forwardedCookies: mediakindCookies,
            forwardedHeaders: mediakindHeaders
        },
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                }
            ]
        },
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                }
            ]
        }
    });
const mediakindCe1 = (_product, _)=>({
        proxy: {
            enabled: true,
            forwardedCookies: mediakindCookies,
            forwardedHeaders: mediakindHeaders
        },
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                }
            ]
        },
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                }
            ]
        }
    });
const nimbra204 = (_product, _)=>{
    const scanRates = [
        'Follow source'
    ];
    const resolutions = [
        {
            name: '1280x720',
            value: '1280x720'
        },
        {
            name: '1920x1080',
            value: '1920x1080'
        },
        {
            name: '3840x2160',
            value: '3840x2160'
        }
    ];
    const gopStructures = [
        {
            name: 'IP',
            value: Nimbra204GopStructure.IP
        },
        {
            name: 'IPB',
            value: Nimbra204GopStructure.IPB
        },
        {
            name: 'IPBB',
            value: Nimbra204GopStructure.IPBB
        },
        {
            name: 'IPBBB',
            value: Nimbra204GopStructure.IPBBB
        },
        {
            name: 'IPBBBBB',
            value: Nimbra204GopStructure.IPBBBBB
        },
        {
            name: 'IPBBBBBBB',
            value: Nimbra204GopStructure.IPBBBBBBB
        }
    ];
    const pixelFormat = [
        {
            name: 'XV20: 4:2:2 10bit',
            value: 'XV20'
        },
        {
            name: 'XV15: 4:2:0 10bit',
            value: 'XV15'
        },
        {
            name: 'NV16 4:2:2 8bit',
            value: 'NV16'
        },
        {
            name: 'NV12 4:2:0 8bit',
            value: 'NV12'
        }
    ];
    const sdiInputCapabilities = {
        video: {
            customPid: false,
            codecs: [
                {
                    name: types_1.VideoCodec.h264,
                    profile: [
                        {
                            name: 'High Profile',
                            value: 'PROFILE_HIGH'
                        }
                    ],
                    scanRate: scanRates,
                    resolution: resolutions,
                    bitrate: {
                        min: 1000000,
                        max: 30000000
                    },
                    gopStructures,
                    pixelFormat
                },
                {
                    name: types_1.VideoCodec.h265,
                    profile: [
                        {
                            name: 'Main Profile',
                            value: 'PROFILE_MAIN'
                        }
                    ],
                    scanRate: scanRates,
                    resolution: resolutions,
                    bitrate: {
                        min: 1000000,
                        max: 30000000
                    },
                    gopStructures,
                    pixelFormat
                }
            ],
            flags: []
        },
        audio: {
            maxAudioStreams: 4,
            layout: [
                types_1.AudioLayout.mono,
                types_1.AudioLayout.stereo
            ],
            customPid: false,
            codecs: [
                {
                    name: types_1.AudioCodec.aacLc,
                    bitratesKbps: [
                        32,
                        48,
                        64,
                        80,
                        96,
                        112,
                        128,
                        144,
                        160
                    ]
                },
                {
                    name: types_1.AudioCodec.mpeg2,
                    bitratesKbps: [
                        32,
                        48,
                        56,
                        64,
                        80,
                        96,
                        112,
                        128,
                        144,
                        160,
                        192,
                        224,
                        256,
                        320,
                        384
                    ],
                    disabledForStreamIndices: [
                        0
                    ]
                },
                {
                    name: types_1.AudioCodec.heAac,
                    bitratesKbps: [
                        28,
                        32,
                        48,
                        64,
                        80,
                        96,
                        112,
                        128
                    ]
                },
                {
                    name: types_1.AudioCodec.heAacV2,
                    bitratesKbps: [
                        16,
                        24,
                        32,
                        40,
                        48,
                        56,
                        64
                    ]
                },
                {
                    name: types_1.AudioCodec.ac3,
                    bitratesKbps: [
                        16,
                        24,
                        32,
                        40,
                        48,
                        56,
                        64,
                        80,
                        96,
                        112,
                        128,
                        144,
                        160,
                        180,
                        200,
                        220,
                        240,
                        260,
                        280,
                        300,
                        320,
                        360,
                        400,
                        440,
                        480,
                        520,
                        560,
                        600,
                        640
                    ],
                    disabledForStreamIndices: [
                        0
                    ]
                }
            ]
        }
    };
    return {
        proxy: {
            enabled: true,
            forwardedCookies: [
                'http_auth_session'
            ],
            forwardedHeaders: []
        },
        input: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                },
                {
                    prettyName: 'sdi',
                    mode: types_1.CoaxPortMode.sdi,
                    encoder: sdiInputCapabilities
                }
            ]
        },
        output: {
            modes: [
                {
                    mode: types_1.IpPortMode.rtp
                },
                {
                    mode: types_1.IpPortMode.srt,
                    subModes: [
                        types_1.SrtMode.caller,
                        types_1.SrtMode.rendezvous,
                        types_1.SrtMode.listener
                    ]
                },
                {
                    mode: types_1.IpPortMode.udp
                }
            ]
        }
    };
};
exports.applianceTypes = {
    [types_1.ApplianceType.nimbraVA220]: nimbraVa220,
    [types_1.ApplianceType.nimbraVA225]: nimbraVa225,
    [types_1.ApplianceType.nimbraVAdocker]: nimbraVaDocker,
    [types_1.ApplianceType.nimbra410]: nimbra410,
    [types_1.ApplianceType.nimbra412]: nimbra412,
    [types_1.ApplianceType.nimbra414]: nimbra414,
    [types_1.ApplianceType.nimbra414b]: nimbra414,
    [types_1.ApplianceType.edgeConnect]: exports.edgeConnect,
    [types_1.ApplianceType.core]: exports.core,
    [types_1.ApplianceType.thumb]: exports.emptyFeatureSet,
    [types_1.ApplianceType.videon]: videon,
    [types_1.ApplianceType.matroxMonarchEdgeE4_8Bit]: matroxE4,
    [types_1.ApplianceType.matroxMonarchEdgeE4_10Bit]: matroxE410Bit,
    [types_1.ApplianceType.matroxMonarchEdgeD4]: matroxD4,
    [types_1.ApplianceType.matroxMonarchEdgeS1]: matroxS1,
    [types_1.ApplianceType.comprimato]: comprimato,
    [types_1.ApplianceType.mediakindRx1]: mediakindRx1,
    [types_1.ApplianceType.mediakindCe1]: mediakindCe1,
    [types_1.ApplianceType.riversilica]: nimbra414,
    [types_1.ApplianceType.nimbra204]: nimbra204
};

},{"37f17b0e3d739ec9":"3qemx","2c3a0cb527c92719":"7pNzz","d32e96d4f6b97b29":"j24dT","83966748d9315d35":"4vuwV","b05a0d52fd9f52fb":"bdiC1"}],"7pNzz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VaVersions = void 0;
exports.vaVersionIsGreaterOrEqual = vaVersionIsGreaterOrEqual;
exports.parseVaVersion = parseVaVersion;
exports.vaVersionSupportsAdaptiveFec = vaVersionSupportsAdaptiveFec;
exports.vaVersionSupports12MTimeCode = vaVersionSupports12MTimeCode;
exports.vaVersionSupportsEdgeLink = vaVersionSupportsEdgeLink;
const VA_VERSION_PATTERN = /^(LX-)?VA-(\d+\.\d+\.\d+\.\d+)(-[A-Za-z0-9.]+)?$/;
exports.VaVersions = {
    'VA-15.1.0.2': parseVaVersion('VA-15.1.0.2'),
    'VA-16.4.0.0': parseVaVersion('VA-16.4.0.0'),
    'VA-20.2.0.2': parseVaVersion('VA-20.2.0.2'),
    'LX-VA-20.2.0.1-EdgeLink.0': parseVaVersion('LX-VA-20.2.0.1-EdgeLink.0')
};
function vaVersionIsGreaterOrEqual(vaVersion, referenceVersion) {
    if (!vaVersion) return false;
    try {
        const comp = compareVaVersions(vaVersion, referenceVersion);
        return comp >= 0;
    } catch  {
        return false;
    }
}
function compareVaVersions(v1, v2) {
    const diff = v1.number - v2.number;
    return Math.min(Math.max(diff, -1), 1);
}
function parseVaVersion(vaVersionString) {
    if (!vaVersionString || typeof vaVersionString !== 'string') return undefined;
    const match = vaVersionString.match(VA_VERSION_PATTERN);
    if (!match) return undefined;
    const isLX = match[1] === 'LX-';
    const numbers = match[2].split('.').map((n)=>parseInt(n, 10));
    const suffix = match[3] ? match[3].replace(/^-/, '') : undefined;
    const versionNumber = numbers.reverse().reduce((ack, cur, i)=>{
        return ack + Math.pow(10, 3 * i) * cur;
    });
    return {
        number: versionNumber,
        lx: isLX,
        suffix
    };
}
function vaVersionSupportsAdaptiveFec(vaVersionString) {
    return vaVersionString && vaVersionIsGreaterOrEqual(parseVaVersion(vaVersionString), exports.VaVersions['VA-15.1.0.2']);
}
function vaVersionSupports12MTimeCode(vaVersionString) {
    return vaVersionString && vaVersionIsGreaterOrEqual(parseVaVersion(vaVersionString), exports.VaVersions['VA-16.4.0.0']);
}
function vaVersionSupportsEdgeLink(vaVersionString) {
    const version = parseVaVersion(vaVersionString);
    if (!version) return false;
    return vaVersionIsGreaterOrEqual(parseVaVersion(vaVersionString), exports.VaVersions['VA-20.2.0.2']) || version.lx && version.suffix?.startsWith('EdgeLink');
}

},{}],"9w6kL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SrtFields", ()=>SrtFields);
parcelHelpers.export(exports, "srtDefaults", ()=>srtDefaults);
parcelHelpers.export(exports, "getSrtFieldsToSave", ()=>getSrtFieldsToSave);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _whitelistCidrBlockAutoComplete = require("../../../../common/WhitelistCidrBlockAutoComplete");
var _suggestedPortTextField = require("../../../../common/SuggestedPortTextField");
var _nmTypes = require("../../../../../api/nm-types");
var _reactHookForm = require("react-hook-form");
var _base = require("../../../../common/Interface/Base");
var _versions = require("common/versions");
var _utils1 = require("common/utils");
const LATENCY_MAX = 360000;
const TTL_MAX = 255;
const MTU_MIN = 76;
var SrtFields = /*#__PURE__*/ function(SrtFields) {
    SrtFields["srtMode"] = "srtMode";
    SrtFields["remoteIp"] = "remoteIp";
    SrtFields["remotePort"] = "remotePort";
    SrtFields["localIp"] = "localIp";
    SrtFields["localPort"] = "localPort";
    SrtFields["rateLimiting"] = "rateLimiting";
    SrtFields["maxBw"] = "maxBw";
    SrtFields["inputBw"] = "inputBw";
    SrtFields["oheadBw"] = "oheadBw";
    SrtFields["latency"] = "latency";
    SrtFields["pbkeylen"] = "pbkeylen";
    SrtFields["passphrase"] = "passphrase";
    SrtFields["ipttl"] = "ipttl";
    SrtFields["mss"] = "mss";
    SrtFields["streamId"] = "streamId";
    SrtFields["whitelistCidrBlock"] = "whitelistCidrBlock";
    SrtFields["bondingMode"] = "bondingMode";
    SrtFields["failoverPriority"] = "failoverPriority";
    SrtFields["rtp"] = "rtp";
    return SrtFields;
}({});
const srtDefaults = (numDistinctFailoverPriorities)=>(0, _utils.createDefaultFiledValues)(Object.keys(SrtFields), [
        "rtp"
    ], {
        ["latency"]: 120,
        ["pbkeylen"]: (0, _types.SrtKeylen).none,
        ["oheadBw"]: 25,
        ["rateLimiting"]: (0, _types.SrtRateLimiting).notEnforced,
        ["whitelistCidrBlock"]: [],
        ["bondingMode"]: numDistinctFailoverPriorities === 0 ? (0, _nmTypes.SrtBondingMode).none : numDistinctFailoverPriorities > 1 ? (0, _nmTypes.SrtBondingMode).activeBackup : (0, _nmTypes.SrtBondingMode).activeActive
    });
const getSrtFieldsToSave = (port)=>[
        "srtMode",
        "latency",
        "rateLimiting",
        "pbkeylen",
        "ipttl",
        "mss",
        "streamId",
        "rtp",
        ...port.pbkeylen === (0, _types.SrtKeylen).none ? [] : [
            "passphrase"
        ],
        ...function() {
            switch(port.srtMode){
                case (0, _types.SrtMode).listener:
                    return [
                        "localIp",
                        "localPort",
                        "whitelistCidrBlock",
                        "failoverPriority"
                    ];
                case (0, _types.SrtMode).caller:
                    return [
                        "remoteIp",
                        "remotePort",
                        "localPort",
                        "failoverPriority"
                    ];
                default:
                    return [
                        "remoteIp",
                        "remotePort",
                        "localIp",
                        "whitelistCidrBlock"
                    ];
            }
        }(),
        ...function() {
            switch(port.rateLimiting){
                case (0, _types.SrtRateLimiting).absolute:
                    return [
                        "maxBw"
                    ];
                case (0, _types.SrtRateLimiting).relativeToInput:
                    return [
                        "inputBw",
                        "oheadBw"
                    ];
                default:
                    return [];
            }
        }()
    ];
const SrtForm = ({ portIndex, addresses, namePrefix, occupiedPorts, adminStatus, applianceId, applianceType, applianceVersion, applianceFeatures, onAddLogicalPortRequested, onRemoveLogicalPortRequested })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const portsNamePrefix = namePrefix.substr(0, namePrefix.length - 2);
    const appliancePorts = getValues(portsNamePrefix);
    const previousNumberOfPorts = (0, _utils.usePrevious)(appliancePorts.length);
    const firstAppliancePort = appliancePorts[0];
    const secondAppliancePort = appliancePorts[1];
    const currentPort = appliancePorts[portIndex];
    // Watch specific fields since they control conditional rendering
    watch(`${portsNamePrefix}.0.${"rtp"}`) // isRtpOverSrtEnabled
    ;
    [
        0,
        1
    ].forEach((i)=>{
        const prefix = `${portsNamePrefix}.${i}`;
        watch(`${prefix}.${"srtMode"}`);
        watch(`${prefix}.${"bondingMode"}`);
        watch(`${prefix}.${"rateLimiting"}`);
        watch(`${prefix}.${"pbkeylen"}`);
    });
    const isBondingEnabled = Boolean(firstAppliancePort.bondingMode) && firstAppliancePort.bondingMode !== (0, _nmTypes.SrtBondingMode).none;
    const previousIsBondingEnabled = (0, _utils.usePrevious)(isBondingEnabled);
    const localAddressSelector = `${namePrefix}.${"localIp"}`;
    const localPortSelector = `${namePrefix}.${"localPort"}`;
    const supportedModes = applianceFeatures.output?.modes.find((m)=>m.mode === (0, _types.IpPortMode).srt)?.subModes ?? [];
    const currentPortInfo = {
        isInput: false,
        isPortDisabled: adminStatus === (0, _types.OutputAdminStatus).off,
        mode: currentPort.mode,
        existingLogicalPortsOnSameNic: occupiedPorts
    };
    (0, _react.useEffect)(()=>{
        // Ensure that the second srt mode mirrors the first if bonding is enabled
        if (portIndex === 1 && firstAppliancePort && secondAppliancePort) {
            if (firstAppliancePort.srtMode !== secondAppliancePort.srtMode && isBondingEnabled) setValue(`${portsNamePrefix}.1.srtMode`, firstAppliancePort.srtMode, {
                shouldValidate: true
            });
        }
    }, [
        portIndex,
        firstAppliancePort?.srtMode,
        secondAppliancePort?.srtMode,
        isBondingEnabled,
        setValue,
        portsNamePrefix
    ]);
    // Effect that ensures a valid bonding mode is selected
    (0, _react.useEffect)(()=>{
        if (portIndex > 0) return;
        function ensureCorrectBondingMode() {
            let newBondingMode = undefined;
            if (isBondingEnabled) {
                if (firstAppliancePort.srtMode === (0, _types.SrtMode).rendezvous) // Ensure that bonding mode is none if rendezvous is chosen
                newBondingMode = (0, _nmTypes.SrtBondingMode).none;
                else if (firstAppliancePort.srtMode === (0, _types.SrtMode).listener && firstAppliancePort.bondingMode === (0, _nmTypes.SrtBondingMode).activeBackup) // Ensure that bonding mode is not active/backup if listener is chosen
                newBondingMode = (0, _nmTypes.SrtBondingMode).activeActive;
                if (appliancePorts.length === 1) {
                    // Bonding is enabled but only one logical port
                    const didDeletePort = previousNumberOfPorts !== undefined ? appliancePorts.length < previousNumberOfPorts : false;
                    if (didDeletePort) // User just deleted the second logical port - disable bonding
                    newBondingMode = (0, _nmTypes.SrtBondingMode).none;
                }
            }
            if (newBondingMode !== undefined && firstAppliancePort.bondingMode !== newBondingMode) setValue(`${portsNamePrefix}.0.bondingMode`, newBondingMode, {
                shouldValidate: true
            });
        }
        ensureCorrectBondingMode();
    }, [
        isBondingEnabled,
        portIndex,
        firstAppliancePort.srtMode,
        firstAppliancePort.bondingMode,
        appliancePorts,
        previousNumberOfPorts,
        setValue
    ]);
    // Effect that adds/removes logical ports - triggers every time bonding mode is enabled/disabled (either by user or by another effect).
    (0, _react.useEffect)(()=>{
        if (isBondingEnabled === previousIsBondingEnabled) return;
        // User enabled/disabled bonding
        function ensureCorrectNumberLogicalPorts() {
            if (isBondingEnabled) {
                if (appliancePorts.length === 1 && portIndex === 0) // User enabled bonding, but only one logical port - automatically add a logical port (two ports are required for bonding)
                onAddLogicalPortRequested();
            } else if (portIndex > 0) // Cannot have multiple ports with bonding disabled
            onRemoveLogicalPortRequested();
        }
        ensureCorrectNumberLogicalPorts();
    }, [
        isBondingEnabled,
        previousIsBondingEnabled,
        appliancePorts,
        onAddLogicalPortRequested,
        portIndex,
        onRemoveLogicalPortRequested
    ]);
    const allLogicalPorts = (0, _base.collectPortsFromApplianceSections)(getValues());
    const portsGroupedByAppliance = (0, _utils1.group)(allLogicalPorts, (p)=>(0, _base.getPortAppliance)(p)?.id ?? '');
    const applianceSupportsRtpOverSrt = !applianceVersion || (0, _versions.supportsRtpOverSrt)(applianceVersion);
    const isRtpOverSrtSupported = applianceSupportsRtpOverSrt && Object.values(portsGroupedByAppliance).every(// Max 1 SRT interface per appliance
    (appliancePorts)=>appliancePorts.filter((p)=>p.mode === (0, _types.IpPortMode).srt).length < 2);
    // Only show RTP-over-SRT checkbox for first logical port per appliance
    const showRtpOverSrtCheckbox = portIndex === 0;
    const isRtpOverSrtEnabled = allLogicalPorts.some((p)=>p.mode === (0, _types.IpPortMode).srt && 'rtp' in p && !!p.rtp);
    const srtModeSupportsBonding = !!firstAppliancePort.srtMode && firstAppliancePort.srtMode !== (0, _types.SrtMode).rendezvous;
    const isBondingSupported = !isRtpOverSrtEnabled && srtModeSupportsBonding && (0, _base.areMultipleLogicalPortsPerApplianceSupported)({
        isInput: false,
        appliance: {
            id: applianceId,
            type: applianceType
        },
        allLogicalPorts
    });
    (0, _react.useEffect)(()=>{
        if (portIndex !== 0) return;
        if (isRtpOverSrtEnabled) {
            if (!isRtpOverSrtSupported) setValue(`${portsNamePrefix}.0.${"rtp"}`, false);
            else if (!currentPort.rtp) setValue(`${portsNamePrefix}.0.${"rtp"}`, true);
        }
    }, [
        portIndex,
        isRtpOverSrtEnabled,
        isRtpOverSrtSupported,
        setValue,
        currentPort.rtp
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            showRtpOverSrtCheckbox && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: "RTP over SRT",
                name: `${namePrefix}.${"rtp"}`,
                disabled: !isRtpOverSrtSupported,
                tooltip: isRtpOverSrtSupported ? 'Enable this option if the SRT output should carry an RTP payload.' : !applianceSupportsRtpOverSrt ? 'Appliance software does not support RTP over SRT (requires R3.22.0 or greater)' : 'RTP-over-SRT cannot be enabled together with bonding'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"srtMode"}`,
                label: "Connection mode",
                newLine: true,
                options: supportedModes,
                disabled: portIndex !== 0 && isBondingEnabled,
                required: true
            }),
            portIndex === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"bondingMode"}`,
                label: "Bonding mode",
                disabled: !isBondingSupported,
                options: (0, _nmTypes.srtBondingOptions)(firstAppliancePort.srtMode),
                tooltip: isRtpOverSrtEnabled ? 'Bonding is not supported when tunneling RTP over SRT' : undefined,
                required: true
            }),
            currentPort && [
                (0, _types.SrtMode).caller,
                (0, _types.SrtMode).rendezvous
            ].includes(currentPort.srtMode) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"remoteIp"}`,
                        label: "Remote host",
                        newLine: true,
                        required: true,
                        validators: {
                            ipOrHostname: {}
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"remotePort"}`,
                        label: currentPort?.srtMode === (0, _types.SrtMode).rendezvous ? 'Local and remote port' : 'Remote port',
                        required: true,
                        type: "number",
                        noNegative: true,
                        validators: {
                            port: {
                                isUdp: true
                            },
                            isPortAvailable: {
                                ...currentPortInfo,
                                existingLogicalPortsOnSameNic: currentPort.srtMode === (0, _types.SrtMode).rendezvous ? occupiedPorts : []
                            }
                        }
                    })
                ]
            }),
            currentPort.srtMode && [
                (0, _types.SrtMode).listener,
                (0, _types.SrtMode).rendezvous
            ].includes(currentPort.srtMode) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: localAddressSelector,
                label: "Local address",
                required: true,
                options: (0, _utils.makeAddressOptions)(getValues(localAddressSelector), addresses),
                newLine: true,
                validators: {
                    addressIn: {
                        addresses
                    }
                }
            }),
            [
                (0, _types.SrtMode).listener,
                (0, _types.SrtMode).caller
            ].includes(currentPort?.srtMode) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _suggestedPortTextField.SuggestedLocalPortTextField), {
                name: localPortSelector,
                label: currentPort.srtMode === (0, _types.SrtMode).listener ? 'Local port' : 'Local outgoing port',
                required: currentPort.srtMode === (0, _types.SrtMode).listener,
                namePrefix: namePrefix,
                portInfo: currentPortInfo
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"rateLimiting"}`,
                label: "Output rate limiting",
                options: Object.values((0, _types.SrtRateLimiting)),
                required: true,
                newLine: true
            }),
            currentPort.rateLimiting === (0, _types.SrtRateLimiting).absolute && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"maxBw"}`,
                label: "Maximum bandwidth (Mbps)",
                type: "number",
                required: true,
                noNegative: true
            }),
            currentPort.rateLimiting === (0, _types.SrtRateLimiting).relativeToInput && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"inputBw"}`,
                        label: "Input bandwidth (Mbps)",
                        required: true,
                        tooltip: "Set to '0' for automatic input bandwidth sensing",
                        type: "number",
                        noNegative: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"oheadBw"}`,
                        label: "Overhead bandwidth (%)",
                        tooltip: "The allowed overhead of output bandwidth in relation to input bandwidth. Minimum 5%",
                        required: true,
                        type: "number",
                        noNegative: true,
                        validators: {
                            number: {
                                greaterThanOrEqualTo: 5,
                                lessThanOrEqualTo: 100,
                                message: 'Must be 5 - 100'
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"latency"}`,
                label: "Retransmission buffer (ms)",
                type: "number",
                noNegative: true,
                required: true,
                newLine: true,
                tooltip: "Contains packets that may need to be retransmitted. Shall be at least the same size as the retransmission buffer on the receiver.",
                validators: {
                    number: {
                        lessThanOrEqualTo: LATENCY_MAX,
                        message: `Must be 0 - ${LATENCY_MAX}`
                    }
                }
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"ipttl"}`,
                label: "TTL",
                type: "number",
                noNegative: true,
                tooltip: 'Defines IP socket "time to live" option.',
                validators: {
                    number: {
                        lessThanOrEqualTo: TTL_MAX,
                        message: `Must be no more than ${TTL_MAX}`
                    }
                }
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"mss"}`,
                label: "MTU",
                type: "number",
                noNegative: true,
                newLine: true,
                tooltip: "MTU size",
                validators: {
                    number: {
                        greaterThanOrEqualTo: MTU_MIN,
                        message: `Must be more than ${MTU_MIN}`
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"pbkeylen"}`,
                label: "Encryption type",
                options: Object.entries((0, _types.SrtKeylen)).map(([name, value])=>({
                        name,
                        value
                    })),
                required: true,
                newLine: true
            }),
            !!currentPort.pbkeylen && currentPort.pbkeylen !== (0, _types.SrtKeylen).none && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"passphrase"}`,
                label: "Passphrase",
                tooltip: "Same passphrase must be configured at SRT Input to decrypt the stream",
                validators: {
                    noAmpersand: {},
                    len: {
                        minimum: 10,
                        maximum: 79
                    }
                }
            }),
            currentPort?.srtMode === (0, _types.SrtMode).caller && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"streamId"}`,
                label: "Stream Id",
                newLine: true,
                tooltip: "Stream ID"
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && currentPort.srtMode && [
                (0, _types.SrtMode).listener,
                (0, _types.SrtMode).rendezvous
            ].includes(currentPort.srtMode) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _whitelistCidrBlockAutoComplete.WhitelistCidrBlockAutoComplete), {
                name: `${namePrefix}.${"whitelistCidrBlock"}`,
                required: (0, _utils.isCoreNode)(applianceType)
            })
        ]
    });
};
exports.default = SrtForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","common/applianceTypeUtil":"3z9on","../../../../common/WhitelistCidrBlockAutoComplete":"91kUs","../../../../common/SuggestedPortTextField":"1iSAC","../../../../../api/nm-types":"bcYl5","react-hook-form":"8z0aI","../../../../common/Interface/Base":"gmIdH","common/versions":"4vuwV","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Jn5r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZixiFields", ()=>ZixiFields);
parcelHelpers.export(exports, "zixiDefaults", ()=>zixiDefaults);
parcelHelpers.export(exports, "getZixiFieldsToSave", ()=>getZixiFieldsToSave);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _form = require("../../../../../common/Form");
var _utils = require("../../../../../../utils");
var _linksArray = require("./LinksArray");
var _linksArrayDefault = parcelHelpers.interopDefault(_linksArray);
var _versions = require("common/versions");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _reactHookForm = require("react-hook-form");
var ZixiFields = /*#__PURE__*/ function(ZixiFields) {
    ZixiFields["zixiMode"] = "zixiMode";
    ZixiFields["localPort"] = "localPort";
    ZixiFields["streamId"] = "streamId";
    ZixiFields["password"] = "password";
    ZixiFields["fecLatency"] = "fecLatency";
    ZixiFields["optimizeFec"] = "optimizeFec";
    ZixiFields["adaptiveFec"] = "adaptiveFec";
    ZixiFields["maxFecOverhead"] = "maxFecOverhead";
    ZixiFields["pullPort"] = "pullPort";
    ZixiFields["retransmitBuf"] = "retransmitBuf";
    ZixiFields["maxBitrateMbps"] = "maxBitrateMbps";
    ZixiFields["unrecoveredPacketsDetection"] = "unrecoveredPacketsDetection";
    ZixiFields["unrecoveredPacketsThreshold"] = "unrecoveredPacketsThreshold";
    ZixiFields["linkMode"] = "linkMode";
    ZixiFields["linkSet1"] = "linkSet1";
    ZixiFields["linkSet2"] = "linkSet2";
    return ZixiFields;
}({});
const zixiDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(ZixiFields), [
        "unrecoveredPacketsDetection",
        "optimizeFec",
        "adaptiveFec"
    ], {
        ["retransmitBuf"]: 500,
        ["maxBitrateMbps"]: 20,
        ["fecLatency"]: 30,
        ["linkMode"]: (0, _types.ZixiLinkMode).single,
        ["maxFecOverhead"]: 0,
        ["linkSet1"]: [
            {
                ...(0, _linksArray.linkSetDefault)
            }
        ],
        ["linkSet2"]: [
            {
                ...(0, _linksArray.linkSetDefault)
            }
        ]
    });
const getZixiFieldsToSave = (port)=>[
        "zixiMode",
        "streamId",
        "password",
        "unrecoveredPacketsDetection",
        ...port.unrecoveredPacketsDetection ? [
            "unrecoveredPacketsThreshold"
        ] : [],
        ...port.zixiMode === (0, _types.ZixiMode).push ? [
            "fecLatency",
            "maxBitrateMbps",
            "optimizeFec",
            "adaptiveFec",
            "maxFecOverhead",
            "retransmitBuf",
            "linkMode",
            "linkSet1",
            ...port.linkMode === (0, _types.ZixiLinkMode).single ? [] : [
                "linkSet2"
            ]
        ] : []
    ];
const ZixiForm = ({ addresses, namePrefix, applianceType, applianceFeatures, applianceVersion })=>{
    const { getValues, watch } = (0, _reactHookForm.useFormContext)();
    const port = getValues(namePrefix);
    const zixiModeKey = `${namePrefix}.${"zixiMode"}`;
    const unrecoveredPacketsDetectionKey = `${namePrefix}.${"unrecoveredPacketsDetection"}`;
    const linkModeKey = `${namePrefix}.${"linkMode"}`;
    // Watch specific fields since they control conditional rendering
    watch(zixiModeKey);
    watch(unrecoveredPacketsDetectionKey);
    watch(linkModeKey);
    const isCoreAppliance = applianceType === (0, _types.ApplianceType).core;
    const isVa = (0, _applianceTypeUtil.isVaApplianceType)(applianceType);
    const localAddressSelector = `${namePrefix}.${"linkSet1"}[0].${(0, _linksArray.LinkFields).localIp}`;
    const supportedModes = applianceFeatures.output?.modes.find((m)=>m.mode === (0, _types.IpPortMode).zixi)?.subModes ?? [];
    const isAdaptiveFecSupported = (0, _versions.supportsZixiAdaptiveFec)(applianceType, applianceVersion);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: zixiModeKey,
                label: "Connection mode",
                options: supportedModes,
                required: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"streamId"}`,
                label: "Stream id",
                required: true,
                newLine: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"password"}`,
                label: "Password"
            }),
            port.zixiMode === (0, _types.ZixiMode).push && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        name: `${namePrefix}.${"linkMode"}`,
                        label: "Link mode",
                        options: isCoreAppliance ? [
                            (0, _types.ZixiLinkMode).single
                        ] : Object.values((0, _types.ZixiLinkMode)),
                        required: true
                    }),
                    port.linkMode === (0, _types.ZixiLinkMode).single && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                name: localAddressSelector,
                                label: "Local address",
                                options: (0, _utils.makeAddressOptions)(getValues(localAddressSelector), addresses),
                                newLine: true,
                                required: true,
                                validators: {
                                    addressIn: {
                                        addresses
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: `${namePrefix}.${"linkSet1"}[0].${(0, _linksArray.LinkFields).remoteIp}`,
                                label: "Remote host",
                                required: true,
                                validators: {
                                    ip: {}
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: `${namePrefix}.${"linkSet1"}[0].${(0, _linksArray.LinkFields).remotePort}`,
                                label: "Remote UDP port",
                                type: "number",
                                required: true,
                                noNegative: true,
                                validators: {
                                    port: {
                                        isUdp: true
                                    }
                                }
                            })
                        ]
                    }),
                    port.linkMode !== (0, _types.ZixiLinkMode).single && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linksArrayDefault.default), {
                        addresses: addresses,
                        namePrefix: namePrefix
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"retransmitBuf"}`,
                        label: "Retransmission buffer (ms)",
                        type: "number",
                        required: true,
                        noNegative: true,
                        newLine: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: 30000,
                                message: 'Must be no more than 30000'
                            }
                        }
                    }),
                    isCoreAppliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"maxBitrateMbps"}`,
                        label: "Max bitrate (Mbps)",
                        tooltip: 'Recommended: double the expected bitrate of the stream',
                        type: "number",
                        required: true,
                        noNegative: true,
                        validators: {
                            number: {
                                greaterThanOrEqualTo: 1,
                                message: 'Must be greater than 0'
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"maxFecOverhead"}`,
                        label: "Max fec overhead (%)",
                        type: "number",
                        noNegative: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: 100,
                                message: 'Must be no more than 100'
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"fecLatency"}`,
                        label: "Fec latency (ms)",
                        type: "number",
                        noNegative: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: Math.pow(2, 32) - 1,
                                message: `Must be no more than ${Math.pow(2, 32) - 1}`
                            }
                        }
                    }),
                    isVa && isAdaptiveFecSupported && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        name: `${namePrefix}.${"adaptiveFec"}`,
                        label: "Adaptive fec",
                        tooltip: 'Enables FEC congestion avoidance'
                    }),
                    isVa && !isAdaptiveFecSupported && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        name: `${namePrefix}.${"optimizeFec"}`,
                        label: "Optimize fec"
                    })
                ]
            }),
            isVa && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                name: unrecoveredPacketsDetectionKey,
                label: "Unrecovered packets alarm",
                tooltip: "Turn detection of unrecovered packets on or off, including associated alarm. Threshold is in packets per minute. Generates an alarm if unrecovered packets per minute is higher than the threshold.",
                newLine: true
            }),
            port.unrecoveredPacketsDetection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"unrecoveredPacketsThreshold"}`,
                label: "Threshold (packets/min)",
                type: "number",
                noNegative: true,
                validators: {
                    number: {
                        lessThanOrEqualTo: Math.pow(2, 64),
                        message: `Must be no more than ${Math.pow(2, 64)}`
                    }
                }
            })
        ]
    });
};
exports.default = ZixiForm;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../../../common/Form":"4Mui7","../../../../../../utils":"342UB","./LinksArray":"74q3Z","common/versions":"4vuwV","common/applianceTypeUtil":"3z9on","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"74q3Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkFields", ()=>LinkFields);
parcelHelpers.export(exports, "linkSetDefault", ()=>linkSetDefault);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _types = require("common/api/v1/types");
var _form = require("../../../../../common/Form");
var _utils = require("../../../../../../utils");
var _reactHookForm = require("react-hook-form");
var _gridItem = require("../../../../../common/Form/GridItem");
var _gridItemDefault = parcelHelpers.interopDefault(_gridItem);
var LinkFields = /*#__PURE__*/ function(LinkFields) {
    LinkFields["localIp"] = "localIp";
    LinkFields["remoteIp"] = "remoteIp";
    LinkFields["remotePort"] = "remotePort";
    LinkFields["rateLimit"] = "rateLimit";
    return LinkFields;
}({});
const linkSetDefault = (0, _utils.createDefaultFiledValues)(Object.keys(LinkFields), [], {
    ["remotePort"]: 2088,
    ["rateLimit"]: 1000000
});
const LinksForm = ({ namePrefix, isStandby, addresses })=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const { fields, remove } = (0, _reactHookForm.useFieldArray)({
        name: namePrefix
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        size: {
            xs: 12
        },
        children: fields && fields.length > 0 && (isStandby ? [
            fields[0]
        ] : fields).map((field, idx)=>{
            const propertyNamePrefix = `${namePrefix}.${idx}`;
            const localAddressSelector = `${propertyNamePrefix}.${"localIp"}`;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        name: localAddressSelector,
                        label: "Local address",
                        options: (0, _utils.makeAddressOptions)(getValues(localAddressSelector), addresses),
                        required: true,
                        newLine: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${propertyNamePrefix}.${"remoteIp"}`,
                        label: "Remote host",
                        required: true,
                        validators: {
                            ipOrHostname: {}
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${propertyNamePrefix}.${"remotePort"}`,
                        label: "Remote UDP port",
                        required: true,
                        type: "number",
                        validators: {
                            port: {
                                isUdp: true
                            }
                        }
                    }),
                    !isStandby && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${propertyNamePrefix}.${"rateLimit"}`,
                        label: "Rate limit (kbps)",
                        type: "number",
                        noNegative: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: Math.pow(2, 32) - 1,
                                message: `Must be no more than ${Math.pow(2, 32) - 1}`
                            }
                        }
                    }),
                    fields.length > 1 && !isStandby && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridItemDefault.default), {
                        newLine: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "outlined",
                            color: "primary",
                            onClick: ()=>remove(idx),
                            children: "Remove link"
                        })
                    })
                ]
            }, field.id);
        })
    });
};
const LinksPaper = ({ title, addresses, namePrefix, isFirstSet })=>{
    const { getValues, setValue } = (0, _reactHookForm.useFormContext)();
    const prop = `${namePrefix}.${isFirstSet ? 'linkSet1' : 'linkSet2'}`;
    (0, _reactHookForm.useWatch)({
        name: prop
    });
    const port = getValues(namePrefix);
    const isStandby = port.linkMode === (0, _types.ZixiLinkMode).standby;
    const linkSet = port[isFirstSet ? 'linkSet1' : 'linkSet2'];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        className: "outlined",
        title: title,
        actionsPane: [
            {
                id: `add-link-btn-${isFirstSet ? 1 : 2}`,
                title: 'Add link',
                onClick: ()=>setValue(prop, linkSet ? linkSet.concat({
                        ...linkSetDefault
                    }) : [
                        {
                            ...linkSetDefault
                        }
                    ]),
                props: {
                    disabled: isStandby || port.linkSet1.length > 2
                }
            }
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinksForm, {
            namePrefix: prop,
            addresses: addresses,
            isStandby: port.linkMode === (0, _types.ZixiLinkMode).standby
        })
    });
};
const LinksArray = ({ namePrefix, addresses })=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const container = document.getElementById('LinksArrayContainer');
    if (!container) return null;
    const isStandby = getValues(`${namePrefix}.linkMode`) === (0, _types.ZixiLinkMode).standby;
    return /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinksPaper, {
                title: `Primary${isStandby ? '' : ' links'}`,
                isFirstSet: true,
                addresses: addresses,
                namePrefix: namePrefix
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinksPaper, {
                title: `Standby${isStandby ? '' : ' links'}`,
                isFirstSet: false,
                addresses: addresses,
                namePrefix: namePrefix
            })
        ]
    }), container);
};
exports.default = LinksArray;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dom":"2ApDx","@mui/material/Grid":"6iX4B","@mui/material/Button":"3qJY9","common/api/v1/types":"3qemx","../../../../../common/Form":"4Mui7","../../../../../../utils":"342UB","react-hook-form":"8z0aI","../../../../../common/Form/GridItem":"hSZf2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3WkQd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RistFields", ()=>RistFields);
parcelHelpers.export(exports, "ristDefaults", ()=>ristDefaults);
parcelHelpers.export(exports, "getRistFieldsToSave", ()=>getRistFieldsToSave);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _reactHookForm = require("react-hook-form");
var RistFields = /*#__PURE__*/ function(RistFields) {
    RistFields["profile"] = "profile";
    RistFields["sourceAddress"] = "sourceAddress";
    RistFields["address"] = "address";
    RistFields["port"] = "port";
    return RistFields;
}({});
const ristDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(RistFields), []);
const getRistFieldsToSave = ()=>Object.keys(RistFields);
const RistForm = ({ namePrefix, addresses })=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const sourceAddressSelector = `${namePrefix}.${"sourceAddress"}`;
    const selectedSourceAddress = getValues(sourceAddressSelector);
    const addressesAndEmptyAddress = [
        {
            address: '',
            netmask: ''
        },
        ...addresses
    ];
    const addressOptions = [
        {
            name: 'any',
            value: ''
        },
        ...(0, _utils.makeAddressOptions)(selectedSourceAddress, addresses)
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"profile"}`,
                label: "Profile",
                options: [
                    (0, _types.RistProfile).simple
                ],
                required: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: sourceAddressSelector,
                label: "Source Address",
                options: addressOptions,
                newLine: true,
                validators: {
                    addressIn: {
                        addresses: addressesAndEmptyAddress
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"address"}`,
                label: "Destination address",
                required: true,
                validators: {
                    ip: {}
                },
                type: "text",
                newLine: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"port"}`,
                label: "Destination Port",
                required: true,
                type: "number",
                noNegative: true,
                validators: {
                    port: {
                        even: true,
                        isUdp: true
                    }
                }
            })
        ]
    });
};
exports.default = RistForm;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzZmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RtmpFields", ()=>RtmpFields);
parcelHelpers.export(exports, "rtmpDefaults", ()=>rtmpDefaults);
parcelHelpers.export(exports, "getRtmpFieldsToSave", ()=>getRtmpFieldsToSave);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var RtmpFields = /*#__PURE__*/ function(RtmpFields) {
    RtmpFields["rtmpDestinationAddress"] = "rtmpDestinationAddress";
    return RtmpFields;
}({});
const rtmpDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(RtmpFields), []);
const getRtmpFieldsToSave = ()=>Object.keys(RtmpFields);
const RtmpForm = ({ namePrefix })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
            name: `${namePrefix}.${"rtmpDestinationAddress"}`,
            label: "Destination",
            type: "text",
            tooltip: `The RTMP server to publish to. E.g: "rtmp://server:port/appName/appInstance?key1=value1&key2=value2"`,
            required: true,
            validators: {
                format: {
                    prefixes: [
                        'rtmp://',
                        'rtmps://'
                    ]
                }
            },
            newLine: true
        })
    });
};
exports.default = RtmpForm;

},{"react/jsx-runtime":"1dlk8","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7KTMM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vaSdiPortDefaults", ()=>vaSdiPortDefaults);
parcelHelpers.export(exports, "getVaSdiPortFormFields", ()=>getVaSdiPortFormFields);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var VaSdiFields = /*#__PURE__*/ function(VaSdiFields) {
    VaSdiFields["output3gLevel"] = "output3gLevel";
    return VaSdiFields;
}(VaSdiFields || {});
const vaSdiPortDefaults = ()=>({
        ["output3gLevel"]: (0, _types.Output3gLevel).B
    });
const getVaSdiPortFormFields = ()=>{
    const fields = [
        "output3gLevel"
    ];
    return fields;
};
const VaSdiPortForm = ({ namePrefix })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
        label: "Output3gLevel",
        name: `${namePrefix}.${"output3gLevel"}`,
        required: true,
        options: Object.values((0, _types.Output3gLevel))
    });
};
exports.default = VaSdiPortForm;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5vOuW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEditType", ()=>useEditType);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _mergeWith = require("lodash/mergeWith");
var _mergeWithDefault = parcelHelpers.interopDefault(_mergeWith);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _omitBy = require("lodash/omitBy");
var _omitByDefault = parcelHelpers.interopDefault(_omitBy);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _utils = require("../../../utils");
var _outputsActions = require("../../../redux/actions/outputsActions");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _ipPortForm = require("./PortForm/IpPortForm");
var _outputForm = require("./OutputForm");
var _outputFormDefault = parcelHelpers.interopDefault(_outputForm);
var _srtForm = require("./PortForm/IpPortForm/SrtForm");
var _coaxPortForm = require("./PortForm/CoaxPortForm/CoaxPortForm");
var _zixiForm = require("./PortForm/IpPortForm/ZixiForm");
var _linksArray = require("./PortForm/IpPortForm/ZixiForm/LinksArray");
var _settingsActions = require("../../../redux/actions/settingsActions");
var _nmTypes = require("../../../api/nm-types");
var _base = require("../../common/Interface/Base");
var _utils1 = require("common/utils");
var _form = require("../../common/Form");
var _reactAsyncHook = require("react-async-hook");
var _notificationActions = require("../../../redux/actions/notificationActions");
const useEditType = ()=>{
    const routes = (0, _store.useRoutes)();
    const matchNew = (0, _reactRouter.useMatch)(routes.outputsNew.route);
    const matchUpdate = (0, _reactRouter.useMatch)(routes.outputsUpdate.route);
    const matchCopy = (0, _reactRouter.useMatch)(routes.outputsCopy.route);
    const type = matchNew ? 'new' : matchUpdate ? 'update' : matchCopy ? 'copy' : null;
    if (!type) throw new Error('Invalid route');
    return (0, _react.useMemo)(()=>({
            type,
            isNew: type === 'new',
            isUpdate: type === 'update',
            isCopy: type === 'copy'
        }), [
        type
    ]);
};
const getInitialState = (selectedOutput, editType, defaultDelay)=>{
    const encoderSettings = {
        videoCodec: '',
        totalBitrate: '',
        gopSizeFrames: 150,
        audioStreams: [],
        latencyMode: '',
        scalingMode: '',
        profile: '',
        pixelFormat: '',
        colorSampling: '',
        bitDepth: '',
        resolution: '',
        scanRate: ''
    };
    const receiver = {
        name: '',
        delay: defaultDelay || '',
        delayMode: (0, _types.DelayMode).basedOnOriginTime,
        unhealthyAlarm: '',
        adminStatus: true,
        ports: [],
        upstreamAppliances: [],
        encoderSettings,
        redundancyMode: selectedOutput && 'redundancyMode' in selectedOutput ? selectedOutput.redundancyMode : selectedOutput?.ports[0]?.copies == 2 ? (0, _types.OutputRedundancyMode).active : (0, _types.OutputRedundancyMode).none,
        adInsertionEnabled: false,
        adServer: undefined,
        adUrl: '',
        adPod: undefined,
        _externalAdServer: selectedOutput ? selectedOutput.adServer != null || selectedOutput.adUrl != null : false
    };
    (0, _mergeWithDefault.default)(receiver, (0, _omitDefault.default)(selectedOutput, [
        'metrics',
        'alarms'
    ]), (_initial, existingValueForKey, key)=>{
        if ('totalBitrate' === key && existingValueForKey) return existingValueForKey / 1000000;
        if (key === 'ports') {
            const failoverPriorities = existingValueForKey.map((p)=>p.failoverPriority).filter((p)=>typeof p === 'number');
            const numDistinctFailoverPriorities = new Set(failoverPriorities).size;
            return existingValueForKey.map((item)=>(0, _mergeWithDefault.default)((0, _outputForm.initialOutputLogicalPort)({
                    physicalPortId: item.physicalPort,
                    port: item._port,
                    numDistinctFailoverPriorities,
                    settings: item._port?._appliance?.settings,
                    applianceType: item._port?.appliance?.type
                }), item, (_initial, existingValueForKey, key)=>{
                    if (((0, _srtForm.SrtFields).inputBw === key || (0, _srtForm.SrtFields).maxBw === key) && existingValueForKey !== undefined) return existingValueForKey / 1000000;
                    if ((key === (0, _zixiForm.ZixiFields).linkSet1 || key === (0, _zixiForm.ZixiFields).linkSet2) && existingValueForKey) return existingValueForKey.map((link)=>({
                            ...(0, _linksArray.linkSetDefault),
                            ...link,
                            [(0, _linksArray.LinkFields).rateLimit]: link.rateLimit ? link.rateLimit / 1000 : (0, _linksArray.linkSetDefault).rateLimit
                        }));
                }));
        }
        if (key === '_input') return existingValueForKey;
        if (key === 'adminStatus') return existingValueForKey === (0, _types.OutputAdminStatus).on;
    });
    if (editType.isCopy) receiver.name += ' (copy)';
    const portsGroupedByApplianceOrRegion = (0, _base.groupPortsByApplianceOrRegion)(receiver.ports);
    return {
        ...receiver,
        [(0, _base.APPLIANCE_SECTION_FORM_PREFIX)]: portsGroupedByApplianceOrRegion
    };
};
const Edit = ()=>{
    const { id: outputId } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const editType = useEditType();
    const { result: selectedOutput, error: fetchOutputError, loading: isFetchingOutput } = (0, _reactAsyncHook.useAsync)(()=>{
        return outputId ? (0, _store.Api).outputApi.getOutput(outputId).catch((err)=>{
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: err,
                operation: 'fetch output'
            }));
            throw err;
        }) : Promise.resolve(undefined);
    }, [
        dispatch,
        outputId
    ]);
    (0, _react.useEffect)(()=>{
        if (!outputId) dispatch((0, _settingsActions.getSettings)());
        return ()=>{
            dispatch((0, _outputsActions.clearOutputFormErrors)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch
    ]);
    const { settings, loading: settingsLoading } = (0, _utils.useSettingsSelector)();
    const initialState = getInitialState(selectedOutput, editType, settings?.defaultDelay);
    const setConfirm = (0, _utils.useConfirmationDialog)();
    const onSubmit = (output, changedPorts)=>{
        if (selectedOutput && editType.isUpdate) {
            const action = ()=>void dispatch((0, _outputsActions.updateOutput)({
                    output: output,
                    redirect: true
                }));
            if (selectedOutput && selectedOutput.input && changedPorts) setConfirm(action, 'Current output might be in use. Are you sure you want to edit it?');
            else action();
        } else dispatch((0, _outputsActions.createOutput)({
            output: (0, _omitDefault.default)(output, [
                'id'
            ]),
            redirect: true
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Outputs',
            outputId ? (0, _getDefault.default)(selectedOutput, 'name') : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: isFetchingOutput || !outputId && settingsLoading,
            children: fetchOutputError ? 'Failed fetching output' : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                component: (0, _outputFormDefault.default),
                defaultValues: initialState,
                onSubmit: (values, methods)=>{
                    values.ports = (0, _base.collectPortsFromApplianceSections)(values);
                    if (!values.ports.length) {
                        methods.setError('ports', {
                            type: 'required',
                            message: "Interface can't be blank"
                        });
                        return;
                    }
                    const hasDecoderSettings = values.ports.some((p)=>{
                        const applianceFeatures = p._port?._appliance?.features ?? p._port?.appliance?.features;
                        const modesWithDecoderSettings = applianceFeatures?.output?.modes.filter((m)=>!!m.decoder).map((m)=>m.mode) ?? [];
                        return modesWithDecoderSettings.includes(p.mode);
                    });
                    const changedPorts = !(0, _isEqualDefault.default)(initialState.ports, values.ports);
                    const transformed = (0, _utils.formTransform)(values, {
                        adminStatus: {
                            _transform: (val)=>val ? (0, _types.OutputAdminStatus).on : (0, _types.OutputAdminStatus).off
                        },
                        scteEventIdFilter: {
                            _transform: (id)=>parseInt(id)
                        },
                        sctePidFilter: {
                            _transform: (id)=>parseInt(id)
                        },
                        ports: {
                            [(0, _srtForm.SrtFields).inputBw]: {
                                _transform: (bitrate)=>bitrate === '' ? undefined : bitrate * 1000000
                            },
                            [(0, _srtForm.SrtFields).maxBw]: {
                                _transform: (bitrate)=>bitrate === '' ? undefined : bitrate * 1000000
                            },
                            [(0, _zixiForm.ZixiFields).linkSet1]: {
                                [(0, _linksArray.LinkFields).rateLimit]: {
                                    _transform: (limit)=>limit === '' ? undefined : limit * 1000
                                }
                            },
                            [(0, _zixiForm.ZixiFields).linkSet2]: {
                                [(0, _linksArray.LinkFields).rateLimit]: {
                                    _transform: (limit)=>limit === '' ? undefined : limit * 1000
                                }
                            },
                            encoderSettings: {
                                _transform: (es)=>hasDecoderSettings ? es : undefined,
                                totalBitrate: {
                                    _transform: (bitrate)=>bitrate === '' ? undefined : bitrate * 1000000
                                },
                                audioStreams: {
                                    // TODO: Codec AES3 does not support bitrate but it is a required property.
                                    _transform: (audioStream)=>({
                                            ...audioStream,
                                            bitrate: audioStream.bitrate || -1
                                        })
                                }
                            },
                            _transform: (port)=>{
                                if ('encoderSettings' in port && port.encoderSettings?.videoCodec === (0, _types.RawVideo)) delete port.encoderSettings?.totalBitrate;
                                if (port.mode === (0, _types.ComprimatoPortMode).comprimatoNdi) return (0, _pickDefault.default)(port, [
                                    'mode',
                                    'name',
                                    'physicalPort',
                                    'encoderSettings'
                                ]);
                                if (port.mode === (0, _types.IpPortMode).rtp && port.fec === 'none') // eslint-disable-next-line no-param-reassign
                                delete port.fec;
                                const coaxPortModes = [
                                    ...Object.values(Object.assign({}, (0, _types.CoaxPortMode), (0, _types.ComprimatoPortMode), (0, _types.MatroxPortMode)))
                                ];
                                const isCoaxPort = port.mode && coaxPortModes.includes(port.mode);
                                const fields = (0, _pickDefault.default)(port, isCoaxPort ? (0, _coaxPortForm.getCoaxPortFormFields)(port) : (0, _ipPortForm.getIpPortFormFields)(port));
                                return (0, _omitDefault.default)(fields, [
                                    'region.allocatedAppliance'
                                ]);
                            }
                        },
                        _transform: (output)=>{
                            const o = output;
                            if (o.redundancyMode != (0, _types.OutputRedundancyMode).none) {
                                const input = o._input;
                                const isInputRedundant = !!input && (0, _utils1.inputRedundancy)(input);
                                if (!isInputRedundant) o.redundancyMode = (0, _types.OutputRedundancyMode).none;
                            }
                            const withoutUnderscoreProps = (0, _omitByDefault.default)(o, (_value, key)=>key.startsWith('_'));
                            const isSrtOutput = withoutUnderscoreProps.ports.find((p)=>p.mode === (0, _types.IpPortMode).srt) // no support for mixed modes yet
                            ;
                            if (isSrtOutput) {
                                let failoverPriority = undefined;
                                const bondingMode = withoutUnderscoreProps.ports[0].bondingMode;
                                if (bondingMode !== (0, _nmTypes.SrtBondingMode).none) failoverPriority = 0;
                                for (const p of withoutUnderscoreProps.ports){
                                    p.failoverPriority = failoverPriority;
                                    if (bondingMode === (0, _nmTypes.SrtBondingMode).activeBackup) failoverPriority += 1;
                                }
                            }
                            return (0, _omitDefault.default)(withoutUnderscoreProps, [
                                'appliance',
                                'object',
                                'group',
                                'health'
                            ]);
                        }
                    });
                    if (!transformed.unhealthyAlarm) transformed.unhealthyAlarm = null;
                    if (!values._externalAdServer) {
                        transformed.adServer = null;
                        transformed.adUrl = null;
                    }
                    if (!transformed.adServer) transformed.adServer = null;
                    if (!transformed.adUrl) transformed.adUrl = null;
                    if (!transformed.adPod) transformed.adPod = null;
                    onSubmit(transformed, changedPorts);
                }
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","lodash/get":"dBTJh","lodash/isEqual":"3mRdp","lodash/mergeWith":"40Q54","lodash/omit":"fhxvC","lodash/omitBy":"38wzK","lodash/pick":"5kPds","common/api/v1/types":"3qemx","../../../store":"5LXiG","../../../utils":"342UB","../../../redux/actions/outputsActions":"alMzI","../../common/Pendable":"gDN67","../../common/Wrapper":"8oy7r","./PortForm/IpPortForm":"7TpS5","./OutputForm":"btaTu","./PortForm/IpPortForm/SrtForm":"9w6kL","./PortForm/CoaxPortForm/CoaxPortForm":"9uzed","./PortForm/IpPortForm/ZixiForm":"5Jn5r","./PortForm/IpPortForm/ZixiForm/LinksArray":"74q3Z","../../../redux/actions/settingsActions":"4RBnR","../../../api/nm-types":"bcYl5","../../common/Interface/Base":"gmIdH","common/utils":"2AqiH","../../common/Form":"4Mui7","react-async-hook":"3D6Y9","../../../redux/actions/notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9uzed":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCoaxPortFormFields", ()=>getCoaxPortFormFields);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _ipPortForm = require("../IpPortForm");
var _matroxSdiPortForm = require("./MatroxSdiPortForm");
var _matroxSdiPortFormDefault = parcelHelpers.interopDefault(_matroxSdiPortForm);
var _vaSdiPortForm = require("./VaSdiPortForm");
var _vaSdiPortFormDefault = parcelHelpers.interopDefault(_vaSdiPortForm);
var _utils = require("../../../../../utils");
var _reactHookForm = require("react-hook-form");
var _matrox = require("common/matrox");
const getCoaxPortFormFields = (port)=>{
    const fields = [
        (0, _ipPortForm.CommonFields).id,
        (0, _ipPortForm.CommonFields).physicalPort,
        (0, _ipPortForm.CommonFields).copies,
        (0, _ipPortForm.CommonFields).mode,
        'encoderSettings'
    ];
    if (port.mode === (0, _types.CoaxPortMode).sdi) fields.push(...(0, _vaSdiPortForm.getVaSdiPortFormFields)());
    else if (port.mode === (0, _types.MatroxPortMode).matroxSdi) fields.push(...(0, _matroxSdiPortForm.getMatroxSdiPortFormFields)());
    return fields;
};
const CoaxPortForm = ({ namePrefix, physicalPortIndex, settings, applianceFeatures, applianceType })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const logicalPort = getValues(namePrefix);
    const modeKey = `${namePrefix}.mode`;
    watch(modeKey);
    const selectedMode = logicalPort.mode;
    const modeOptions = (0, _react.useMemo)(()=>{
        const coaxModes = applianceFeatures.output?.modes.filter((m)=>(0, _utils.COAX_MODES).includes(m.mode)) ?? [];
        return coaxModes.map((m)=>({
                name: m.prettyName ?? m.mode,
                value: m.mode
            }));
    }, [
        JSON.stringify(applianceFeatures.output?.modes)
    ]);
    (0, _react.useEffect)(()=>{
        const defaultMode = modeOptions.length === 1 ? modeOptions[0].value : '';
        const isValidMode = modeOptions.some((m)=>m.value === selectedMode);
        if (!isValidMode && selectedMode !== defaultMode) setValue(modeKey, defaultMode);
    }, [
        modeKey,
        setValue,
        modeOptions,
        selectedMode
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Mode",
                name: modeKey,
                required: true,
                newLine: true,
                options: modeOptions,
                validators: {
                    oneOf: {
                        validValues: new Set(modeOptions.filter((o)=>!o.disabled).map(({ value })=>value))
                    }
                }
            }),
            selectedMode === (0, _types.CoaxPortMode).sdi && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vaSdiPortFormDefault.default), {
                namePrefix: namePrefix
            }),
            selectedMode === (0, _types.MatroxPortMode).matroxSdi && settings && (0, _matrox.isMatroxApplianceSettings)(settings) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matroxSdiPortFormDefault.default), {
                namePrefix: namePrefix,
                physicalPortIndex: physicalPortIndex,
                port: logicalPort,
                applianceType: applianceType,
                settings: settings
            })
        ]
    });
};
exports.default = CoaxPortForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../IpPortForm":"7TpS5","./MatroxSdiPortForm":"3V8zO","./VaSdiPortForm":"7KTMM","../../../../../utils":"342UB","react-hook-form":"8z0aI","common/matrox":"4mxaf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3V8zO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matroxSdiPortDefaults", ()=>matroxSdiPortDefaults);
parcelHelpers.export(exports, "getMatroxSdiPortFormFields", ()=>getMatroxSdiPortFormFields);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../../common/Form");
var _types = require("common/api/v1/types");
var _matrox = require("common/matrox");
var _reactHookForm = require("react-hook-form");
var MatroxSdiFields = /*#__PURE__*/ function(MatroxSdiFields) {
    MatroxSdiFields["decoderSettings"] = "decoderSettings";
    return MatroxSdiFields;
}(MatroxSdiFields || {});
function matroxSdiPortDefaults(applianceType, settings) {
    const currentlySelectedFamily = settings && 'genlock' in settings && 'framerateFamily' in settings.genlock ? settings.genlock.framerateFamily : (0, _types.MatroxDecoderFramerateFamily).familyThree;
    const options = getResolutionOptions(0, currentlySelectedFamily, applianceType, undefined);
    const initialOption = options.find((option)=>!option.disabled) ?? options[0];
    return {
        ["decoderSettings"]: {
            outputSettings: {
                isAncEnabled: false,
                resolution: initialOption.value
            }
        }
    };
}
const getMatroxSdiPortFormFields = ()=>{
    const fields = [
        "decoderSettings"
    ];
    return fields;
};
// Expected format '720p50', '1080i25'
const outputResolutionRegexp = /([0-9]+)([a-zA-Z])([0-9]+)/;
function compareAscendingByResolutionScanAndFramerate(a, b) {
    const [_, heightAStr, scanMethodA, frameRateAStr] = a.match(outputResolutionRegexp) ?? [];
    const [__, heightBStr, scanMethodB, frameRateBStr] = b.match(outputResolutionRegexp) ?? [];
    if (heightAStr && scanMethodA && frameRateAStr && heightBStr && scanMethodB && frameRateBStr) {
        const heightA = Number(heightAStr);
        const heightB = Number(heightBStr);
        if (heightA === heightB) {
            if (scanMethodA === scanMethodB) {
                const frameRateA = Number(frameRateAStr);
                const frameRateB = Number(frameRateBStr);
                return frameRateA - frameRateB;
            } else return scanMethodA.localeCompare(scanMethodB);
        } else return heightA - heightB;
    }
    return a.localeCompare(b);
}
function getResolutionOptions(portIndex, currentlySelectedFamilyOnDevice, applianceType, currentResolution) {
    const sdi4kTooltip = 'will disable all other SDI ports on the appliance';
    const notAvailable4kTooltip = 'only available on the D4 12G SDI-4 port';
    const allFramerateFamilies = [
        (0, _types.MatroxDecoderFramerateFamily).familyOne,
        (0, _types.MatroxDecoderFramerateFamily).familyTwo,
        (0, _types.MatroxDecoderFramerateFamily).familyThree
    ];
    function formattedFramerate(res) {
        // Convert frame rate to field rate for interlaced resolutions to be consistent with other Network Manager UI
        // (Matrox displays everything as frame rate).
        switch(res){
            case (0, _types.MatroxDecoderOutputResolutionFamilyOne)['1080i25']:
                return '1080i50';
            case (0, _types.MatroxDecoderOutputResolutionFamilyTwo)['1080i29.97']:
                return '1080i59.94';
            case (0, _types.MatroxDecoderOutputResolutionFamilyThree)['1080i30']:
                return '1080i60';
            default:
                return res;
        }
    }
    const allFramerates = allFramerateFamilies.flatMap((0, _matrox.getResolutionsInFramerateFamily));
    const isD4 = applianceType === undefined || applianceType === (0, _types.ApplianceType).matroxMonarchEdgeD4;
    const options = allFramerates.map((res)=>({
            name: formattedFramerate(res),
            value: res,
            disabled: // 4K resolution only available on 12G port on D4
            (0, _matrox.is4kResolution)(res) && (!isD4 || !(0, _matrox.isMatroxSdi12gPort)(portIndex)) || !(0, _matrox.isResolutionInFramerateFamily)(res, currentlySelectedFamilyOnDevice),
            tooltip: (0, _matrox.is4kResolution)(res) ? isD4 && (0, _matrox.isMatroxSdi12gPort)(portIndex) ? sdi4kTooltip : notAvailable4kTooltip : undefined
        }));
    if (currentResolution && !options.find((res)=>res.value === currentResolution)) options.push({
        name: currentResolution,
        value: currentResolution,
        disabled: true,
        tooltip: 'Not a member of the current framerate family on the appliance'
    });
    return options.sort((a, b)=>compareAscendingByResolutionScanAndFramerate(a.value.toString(), b.value.toString()));
}
const MatroxSdiPortForm = ({ namePrefix, physicalPortIndex, port, settings, applianceType })=>{
    const isRunningMatroxV2 = false // FIXME MG: Uncomment when we wish to support matrox v2 features: settings.apiVersion === 'v2'
    ;
    const genlock = (0, _matrox.pickDecoderGenlockFromApplianceSettings)(settings);
    const resolutionOptions = getResolutionOptions(Number(physicalPortIndex), genlock.framerateFamily, applianceType, port.decoderSettings.outputSettings.resolution);
    const useInputStreamResolutionKey = `${namePrefix}.${"decoderSettings"}.followInputStreamResolution`;
    (0, _reactHookForm.useWatch)({
        name: useInputStreamResolutionKey
    }) // Enables disables resolution select
    ;
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const decoderSettings = getValues(`${namePrefix}.${"decoderSettings"}`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Output Settings",
        children: [
            isRunningMatroxV2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: 'Follow input stream resolution',
                name: useInputStreamResolutionKey,
                tooltip: 'Will output the same resolution as the input stream if compatible with the selected framerate family device - else the nearest compatible resolution will be outputted.'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Resolution",
                name: `${namePrefix}.${"decoderSettings"}.outputSettings.resolution`,
                disabled: decoderSettings.followInputStreamResolution,
                required: true,
                tooltip: 'Only resolutions belonging to the currently selected frame rate family on the appliance are selectable.\n\nThe frame rate family of the appliance can be can be changed in the Appliance Details page.',
                options: resolutionOptions,
                validators: {
                    oneOf: {
                        validValues: new Set(resolutionOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                newLine: true,
                label: 'Include ancillary data',
                name: `${namePrefix}.${"decoderSettings"}.outputSettings.isAncEnabled`
            })
        ]
    });
};
exports.default = MatroxSdiPortForm;

},{"react/jsx-runtime":"1dlk8","../../../../common/Form":"4Mui7","common/api/v1/types":"3qemx","common/matrox":"4mxaf","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mxaf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESOLUTION_4K = void 0;
exports.isVirtualAggregatedPort = isVirtualAggregatedPort;
exports.isVirtualAggregatedLogicalPort = isVirtualAggregatedLogicalPort;
exports.is4kResolution = is4kResolution;
exports.isMatroxSdi12gPort = isMatroxSdi12gPort;
exports.isMatroxOutputPort = isMatroxOutputPort;
exports.isResolutionInFramerateFamily = isResolutionInFramerateFamily;
exports.getResolutionsInFramerateFamily = getResolutionsInFramerateFamily;
exports.getFramerateFamilyForResolution = getFramerateFamilyForResolution;
exports.getNumberOfInputSdiPortsFromIOConfig = getNumberOfInputSdiPortsFromIOConfig;
exports.determineRepurposedSdiPorts = determineRepurposedSdiPorts;
exports.getSdiPortIndexesUsedByMatroxLogicalPort = getSdiPortIndexesUsedByMatroxLogicalPort;
exports.translateRepurposedSdiPortIndex = translateRepurposedSdiPortIndex;
exports.pickDecoderGenlockFromApplianceSettings = pickDecoderGenlockFromApplianceSettings;
exports.matroxApiVersionFromSettings = matroxApiVersionFromSettings;
exports.isMatroxApplianceSettings = isMatroxApplianceSettings;
exports.isMatroxDecoderSettings = isMatroxDecoderSettings;
exports.isMatroxEncoderSettings = isMatroxEncoderSettings;
exports.isMatroxEncoderConfig = isMatroxEncoderConfig;
exports.isGeneralEncoderSettings = isGeneralEncoderSettings;
const types_1 = require("bc930a296a9a4d8a");
// A virtual interface is used to represent a grid layout matrox E4 input (receiving from multiple SDI interfaces at once.)
function isVirtualAggregatedPort(port) {
    return port.index === '0,1,2,3';
}
// A virtual interface is used to represent a grid layout matrox E4 input (receiving from multiple SDI interfaces at once.)
function isVirtualAggregatedLogicalPort(lp) {
    return lp.mode === types_1.MatroxPortMode.matroxSdi && 'encoderSettings' in lp && lp.encoderSettings.processorSettings.videoLayout === 'quad';
}
exports.RESOLUTION_4K = 2160;
function is4kResolution(resolution) {
    return resolution.includes(exports.RESOLUTION_4K.toString());
}
function isMatroxSdi12gPort(edgePortIndex) {
    // The first 3 SDI ports are 3G and the fourth is 12G (4k capabilities).
    return edgePortIndex === 3;
}
function isMatroxOutputPort(outputPort) {
    return outputPort.mode === types_1.MatroxPortMode.matroxSdi;
}
function isResolutionInFramerateFamily(resolution, framerateFamily) {
    const familyMembers = getResolutionsInFramerateFamily(framerateFamily);
    return familyMembers.includes(resolution);
}
function getResolutionsInFramerateFamily(framerateFamily) {
    switch(framerateFamily){
        case types_1.MatroxDecoderFramerateFamily.familyOne:
            return Object.values(types_1.MatroxDecoderOutputResolutionFamilyOne);
        case types_1.MatroxDecoderFramerateFamily.familyTwo:
            return Object.values(types_1.MatroxDecoderOutputResolutionFamilyTwo);
        case types_1.MatroxDecoderFramerateFamily.familyThree:
            return Object.values(types_1.MatroxDecoderOutputResolutionFamilyThree);
    }
    throw new Error(`Unknown framerate family: ${framerateFamily}`);
}
function getFramerateFamilyForResolution(resolution) {
    switch(resolution){
        // Family One
        case types_1.MatroxDecoderOutputResolutionFamilyOne['720p50']:
        case types_1.MatroxDecoderOutputResolutionFamilyOne['1080p25']:
        case types_1.MatroxDecoderOutputResolutionFamilyOne['1080p50']:
        case types_1.MatroxDecoderOutputResolutionFamilyOne['1080i25']:
        case types_1.MatroxDecoderOutputResolutionFamilyOne['2160p50']:
            return types_1.MatroxDecoderFramerateFamily.familyOne;
        // Family Two
        case types_1.MatroxDecoderOutputResolutionFamilyTwo['720p59.94']:
        case types_1.MatroxDecoderOutputResolutionFamilyTwo['1080p23.98']:
        case types_1.MatroxDecoderOutputResolutionFamilyTwo['1080p29.97']:
        case types_1.MatroxDecoderOutputResolutionFamilyTwo['1080p59.94']:
        case types_1.MatroxDecoderOutputResolutionFamilyTwo['1080i29.97']:
        case types_1.MatroxDecoderOutputResolutionFamilyTwo['2160p59.94']:
            return types_1.MatroxDecoderFramerateFamily.familyTwo;
        // Family Three
        case types_1.MatroxDecoderOutputResolutionFamilyThree['720p60']:
        case types_1.MatroxDecoderOutputResolutionFamilyThree['1080p24']:
        case types_1.MatroxDecoderOutputResolutionFamilyThree['1080p30']:
        case types_1.MatroxDecoderOutputResolutionFamilyThree['1080p60']:
        case types_1.MatroxDecoderOutputResolutionFamilyThree['1080i30']:
        case types_1.MatroxDecoderOutputResolutionFamilyThree['2160p60']:
            return types_1.MatroxDecoderFramerateFamily.familyThree;
    }
}
function getNumberOfInputSdiPortsFromIOConfig(ioConfig) {
    if (!ioConfig) return 4;
    switch(ioConfig){
        case types_1.MatroxEncoderIOConfig.fourZero:
            return 4;
        case types_1.MatroxEncoderIOConfig.threeOne:
            return 3;
        case types_1.MatroxEncoderIOConfig.twoTwo:
            return 2;
    }
}
// Determine which SDI ports are disappearing after reconfiguration.
// Returns port indexes of disappearing/repurposed ports.
function determineRepurposedSdiPorts(currentIoConfig, newIoConfig) {
    const repurposedSdiInputs = [];
    const repurposedSdiOutputs = [];
    switch(currentIoConfig){
        case types_1.MatroxEncoderIOConfig.fourZero:
            switch(newIoConfig){
                case types_1.MatroxEncoderIOConfig.threeOne:
                    // 4:0 --> 3:1
                    // inputs: [0,1,2,3] --> [0,1,2]
                    // outputs: [] --> [3]
                    repurposedSdiInputs.push(3);
                    break;
                case types_1.MatroxEncoderIOConfig.twoTwo:
                    // 4:0 --> 2:2
                    // inputs: [0,1,2,3] --> [0,1]
                    // outputs: [] --> [2,3]
                    repurposedSdiInputs.push(2, 3);
                    break;
            }
            break;
        case types_1.MatroxEncoderIOConfig.threeOne:
            switch(newIoConfig){
                case types_1.MatroxEncoderIOConfig.fourZero:
                    // 3:1 --> 4:0
                    // inputs: [0,1,2] --> [0,1,2,3]
                    // outputs: [3] --> []
                    repurposedSdiOutputs.push(3);
                    break;
                case types_1.MatroxEncoderIOConfig.twoTwo:
                    // 3:1 --> 2:2
                    // inputs: [0,1,2] --> [0,1]
                    // outputs: [3] --> [2,3]
                    repurposedSdiInputs.push(2);
                    break;
            }
            break;
        case types_1.MatroxEncoderIOConfig.twoTwo:
            switch(newIoConfig){
                case types_1.MatroxEncoderIOConfig.fourZero:
                    // 2:2 --> 4:0
                    // inputs: [0,1] --> [0,1,2,3]
                    // outputs: [2,3] --> []
                    repurposedSdiOutputs.push(2, 3);
                    break;
                case types_1.MatroxEncoderIOConfig.threeOne:
                    // 2:2 --> 3:1
                    // inputs: [0,1] --> [0,1,2]
                    // outputs: [2,3] --> [3]
                    repurposedSdiOutputs.push(2);
                    break;
            }
            break;
    }
    return {
        repurposedSdiInputs,
        repurposedSdiOutputs
    };
}
function getSdiPortIndexesUsedByMatroxLogicalPort(p) {
    const audioPort = p.encoderSettings.processorSettings.audioSourceSettings.portIndex;
    const videoPorts = p.encoderSettings.processorSettings.videoSourceSettings.map((s)=>s.portIndex);
    return [
        audioPort,
        ...videoPorts
    ];
}
function translateRepurposedSdiPortIndex(direction, portIndex, numberOfInputSdiConnectors, applianceType) {
    const isRepurposedInputSdiPort = applianceType === types_1.ApplianceType.matroxMonarchEdgeE4_10Bit;
    if (!isRepurposedInputSdiPort) return portIndex;
    // Using SetIOConfig() in Matrox api v2 on the E4-10bit, SDI input ports can be repurposed to become SDI output ports.
    // Matrox start the output SDI portIndex at 0, but Edge uses the original port index of the SDI port,
    // e.g. Edge uses [0:input,1:input,2:output,3:output], while Matrox uses input:[0,1] and output: [0,1]
    // hence we need to translate the edge portIndex --> matrox portIndex.
    const offset = numberOfInputSdiConnectors;
    return direction === 'edgeToMatrox' ? portIndex - offset : portIndex + offset;
}
function pickDecoderGenlockFromApplianceSettings(settings) {
    const isDecoderGenlock = (genlock)=>'source' in genlock && 'framerateFamily' in genlock;
    if ('decoderGenlock' in settings && settings.decoderGenlock && isDecoderGenlock(settings.decoderGenlock)) return settings.decoderGenlock;
    if ('genlock' in settings && isDecoderGenlock(settings.genlock)) return settings.genlock;
    return undefined;
}
function matroxApiVersionFromSettings(settings) {
    return settings.apiVersion ?? 'v1.4';
}
function isMatroxApplianceSettings(settings) {
    return 'genlock' in settings;
}
function isMatroxDecoderSettings(settings) {
    return 'genlock' in settings;
}
function isMatroxEncoderSettings(settings) {
    return 'sdiPortsWithPcmModeEnabled' in settings;
}
function isMatroxEncoderConfig(settings) {
    return 'type' in settings && settings.type === 'matroxEncoder';
}
function isGeneralEncoderSettings(settings) {
    return !isMatroxEncoderConfig(settings);
}

},{"bc930a296a9a4d8a":"3qemx"}],"1FMDi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdInsertionSection", ()=>AdInsertionSection);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../common/Form");
var _adInsertionCompatibility = require("../../common/AdInsertionCompatibility");
var _adPodSelector = require("./AdPodSelector");
var _adNumberFilterInputField = require("./AdNumberFilterInputField");
var _react = require("react");
var _store = require("../../../store");
var _reactRedux = require("react-redux");
var _reactHookForm = require("react-hook-form");
const AdInsertionSection = ({ form })=>{
    const { getValues } = form;
    const values = getValues();
    (0, _reactHookForm.useWatch)({
        name: 'adInsertionEnabled'
    });
    (0, _reactHookForm.useWatch)({
        name: '_externalAdServer'
    });
    const adServersApi = (0, _react.useCallback)((0, _store.Api).adServersApi.listAdServers.bind((0, _store.Api).adServersApi), []);
    const selectedAdServer = (0, _reactRedux.useSelector)(({ adInsertionReducer })=>adInsertionReducer.selectedAdServer, (0, _reactRedux.shallowEqual));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        id: "ad-insertion-section",
        className: "outlined",
        title: "Ad Insertion",
        collapsible: true,
        collapsed: !values.adInsertionEnabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
            children: [
                Array.isArray(values.tsInfo) && values.tsInfo.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adInsertionCompatibility.AdInsertionCompatibility), {
                    latestTsInfo: values.tsInfo[0]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                    name: "adInsertionEnabled",
                    label: "Enabled"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                    name: "_externalAdServer",
                    label: "Use External Ad Server"
                }),
                values._externalAdServer ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                            name: "adServer",
                            label: "Ad Server",
                            required: values.adInsertionEnabled,
                            api: adServersApi,
                            defaultOption: values.adServer && selectedAdServer ? selectedAdServer : undefined,
                            getOptionValue: (option)=>option.id,
                            getOptionLabel: (option)=>option.name,
                            optionComparator: (o1, o2)=>o1.id === o2.id,
                            disabled: !values.adInsertionEnabled,
                            xs: 4,
                            newLine: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "adUrl",
                            label: "Ad Server Template URL",
                            disabled: !values.adInsertionEnabled,
                            tooltip: 'Part of the ad server URL that is specific to this output'
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adPodSelector.AdPodSelector), {
                    formName: 'adPod',
                    required: values.adInsertionEnabled,
                    adPodId: values.adPod || undefined,
                    newLine: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adNumberFilterInputField.AdNumberFilterInputField), {
                    formName: 'scteEventIdFilter',
                    label: 'SCTE 35 Event ID Filter',
                    newLine: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adNumberFilterInputField.AdNumberFilterInputField), {
                    formName: 'sctePidFilter',
                    label: 'SCTE 35 PID Filter'
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","../../common/Form":"4Mui7","../../common/AdInsertionCompatibility":"7lx8B","./AdPodSelector":"67KKn","./AdNumberFilterInputField":"eagkV","react":"9njXz","../../../store":"5LXiG","react-redux":"l1pMU","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67KKn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdPodSelector", ()=>AdPodSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _fiberManualRecord = require("@mui/icons-material/FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _react = require("react");
var _form = require("../../common/Form");
var _reactHookForm = require("react-hook-form");
var _reactRedux = require("react-redux");
var _adPodActions = require("../../../redux/actions/adPodActions");
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
const AdPodStatusIndicator = ({ adPod })=>{
    const circle = ()=>{
        switch(adPod.status){
            case (0, _types.AdPodStatus).pending:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                    color: "warning"
                });
            case (0, _types.AdPodStatus).unhealthy:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                    color: "error"
                });
            default:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                    color: "success"
                });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        display: "flex",
        alignItems: "center",
        children: circle()
    });
};
const adPodWarning = (status)=>{
    switch(status){
        case (0, _types.AdPodStatus).pending:
            return 'Pending: Waiting for creatives to be uploaded';
        case (0, _types.AdPodStatus).unhealthy:
            return 'Unhealthy: One or more creatives are unhealthy';
        default:
            return undefined;
    }
};
const AdPodSelector = ({ formName, adPodId, newLine, required })=>{
    const adPodsApi = (0, _react.useCallback)((0, _store.Api).adPodsApi.listAdPods.bind((0, _store.Api).adPodsApi), []);
    const dispatch = (0, _reactRedux.useDispatch)();
    const { getValues, setValue } = (0, _reactHookForm.useFormContext)();
    const selectedAdPod = (0, _reactRedux.useSelector)(({ adPodReducer })=>adPodReducer.selectedAdPod, (0, _reactRedux.shallowEqual));
    (0, _react.useEffect)(()=>{
        if (adPodId) dispatch((0, _adPodActions.getAdPod)(adPodId));
    }, [
        adPodId,
        dispatch
    ]);
    if (adPodId && !selectedAdPod) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
        xs: 4,
        newLine: newLine,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
            variant: "rounded",
            sx: {
                width: '100%',
                height: '56px',
                marginTop: 2
            },
            animation: "wave"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
        name: formName,
        label: "Ad Pod",
        api: adPodsApi,
        newLine: newLine,
        required: required,
        defaultOption: selectedAdPod,
        getOptionValue: (adPod)=>adPod.id,
        getOptionLabel: (adPod)=>adPod.name,
        optionComparator: (o1, o2)=>o1.id === o2.id,
        disabled: getValues('adInsertionEnabled') === false,
        xs: 4,
        onClear: ()=>{
            setValue(formName, null);
        },
        renderOption: ({ key, ...props }, adPod)=>{
            const durationMs = adPod?.creatives.reduce((acc, creative)=>{
                if (creative.userDurationMs) return acc + creative.userDurationMs;
                if (creative.metadata?.format?.durationMs) return acc + creative.metadata.format.durationMs;
                return acc;
            }, 0);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                ...props,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    display: "flex",
                    alignItems: "center",
                    children: [
                        adPod.status && /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdPodStatusIndicator, {
                            adPod: adPod
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            display: "block",
                            sx: {
                                ml: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                    component: "div",
                                    variant: "body2",
                                    color: "textPrimary",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: adPod.name
                                        }),
                                        " ",
                                        durationMs ? ` - ${Math.round(durationMs / 1000)} sec` : ''
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    component: "div",
                                    variant: "body2",
                                    color: "warning.light",
                                    children: adPodWarning(adPod.status)
                                })
                            ]
                        })
                    ]
                })
            }, key);
        }
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../../store":"5LXiG","@mui/icons-material/FiberManualRecord":"bvXIN","react":"9njXz","../../common/Form":"4Mui7","react-hook-form":"8z0aI","react-redux":"l1pMU","../../../redux/actions/adPodActions":"2olSr","@mui/material/Skeleton":"6KYj8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6KYj8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("60437f6d844cb4e0").default;
var _interopRequireDefault = require("1556a96fcf206bf5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    skeletonClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Skeleton.default;
    }
});
Object.defineProperty(exports, "skeletonClasses", {
    enumerable: true,
    get: function() {
        return _skeletonClasses.default;
    }
});
var _Skeleton = _interopRequireDefault(require("e8a5544a36084388"));
var _skeletonClasses = _interopRequireWildcard(require("f0360715c5e45e34"));
Object.keys(_skeletonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _skeletonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _skeletonClasses[key];
        }
    });
});

},{"60437f6d844cb4e0":"fiRIh","1556a96fcf206bf5":"kZ6eK","e8a5544a36084388":"fn4uv","f0360715c5e45e34":"25emk"}],"fn4uv":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("eecb9d6010e7797b").default;
var _interopRequireWildcard = require("9e55d7fd937c4dd5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("b28b61d5d90c36ef"));
var _clsx = _interopRequireDefault(require("16aee9333c6e0507"));
var _propTypes = _interopRequireDefault(require("82c5c6644c6431c"));
var _composeClasses = _interopRequireDefault(require("63e762fb1824ff86"));
var _styles = require("69d70a6706f8cd06");
var _zeroStyled = require("e598620424831c78");
var _memoTheme = _interopRequireDefault(require("81c19f7d42fed879"));
var _DefaultPropsProvider = require("22b523da15aab9ea");
var _skeletonClasses = require("6f5d34b96a69e685");
var _jsxRuntime = require("4b2e6b8a8617f0d8");
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, animation, hasChildren, width, height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, _composeClasses.default)(slots, _skeletonClasses.getSkeletonUtilityClass, classes);
};
const pulseKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const waveKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const pulseAnimation = typeof pulseKeyframe !== 'string' ? (0, _zeroStyled.css)`
        animation: ${pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const waveAnimation = typeof waveKeyframe !== 'string' ? (0, _zeroStyled.css)`
        &::after {
          animation: ${waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const SkeletonRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const radiusUnit = (0, _styles.unstable_getUnit)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, _styles.unstable_toUnitless)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, _styles.alpha)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: pulseAnimation || {
                    animation: `${pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: waveAnimation || {
                    '&::after': {
                        animation: `${waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const Skeleton = /*#__PURE__*/ React.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation = 'pulse', className, component = 'span', height, style, variant = 'text', width, ...other } = props;
    const ownerState = {
        ...props,
        animation,
        component,
        variant,
        hasChildren: Boolean(other.children)
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width,
            height,
            ...style
        }
    });
});
var _default = exports.default = Skeleton;

},{"eecb9d6010e7797b":"kZ6eK","9e55d7fd937c4dd5":"fiRIh","b28b61d5d90c36ef":"9njXz","16aee9333c6e0507":"d2NWs","82c5c6644c6431c":"bnNSm","63e762fb1824ff86":"59Equ","69d70a6706f8cd06":"2UrBk","e598620424831c78":"hZXDo","81c19f7d42fed879":"cJNjb","22b523da15aab9ea":"9bD8g","6f5d34b96a69e685":"25emk","4b2e6b8a8617f0d8":"1dlk8"}],"25emk":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1f68fdea2794495a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getSkeletonUtilityClass = getSkeletonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("2cbbe945c4366474"));
var _generateUtilityClass = _interopRequireDefault(require("d45c81efdbe023a7"));
function getSkeletonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiSkeleton', slot);
}
const skeletonClasses = (0, _generateUtilityClasses.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var _default = exports.default = skeletonClasses;

},{"1f68fdea2794495a":"kZ6eK","2cbbe945c4366474":"7pSUk","d45c81efdbe023a7":"jBs9M"}],"eagkV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdNumberFilterInputField", ()=>AdNumberFilterInputField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactHookForm = require("react-hook-form");
var _form = require("../../common/Form");
const AdNumberFilterInputField = ({ formName, label, newLine })=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const fieldValue = getValues(formName) || [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
        name: formName,
        label: label,
        required: false,
        newLine: newLine,
        api: (params)=>new Promise((resolve)=>resolve(params.filter && !isNaN(parseInt(params.filter)) ? {
                    items: [
                        parseInt(params.filter).toString()
                    ],
                    total: 1
                } : {
                    items: [],
                    total: 0
                })),
        multiple: true,
        allowCustomOptions: false,
        validators: {
            numericality: {
                noStrings: true
            }
        },
        defaultOption: fieldValue,
        getOptionValue: (option)=>option,
        getOptionLabel: (option)=>option,
        optionComparator: (o1, o2)=>o1 === o2
    });
};

},{"react/jsx-runtime":"1dlk8","react-hook-form":"8z0aI","../../common/Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDFnw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AdErrorCode = exports.AdStage = exports.AdAuditComponent = exports.AdAuditResult = exports.AdAuditStatus = exports.AdAuditMethod = exports.AdAuditEntity = exports.JsonRpcErrorResponseCode = exports.PortDirection = exports.isSrtRendezvousInputPortDbConfiguration = exports.isSrtCallerInputPortDbConfiguration = exports.isSrtListenerInputPortDbConfiguration = exports.SrtBondingMode = exports.isSrtRendezvousOutputPortDbConfiguration = exports.isSrtCallerOutputPortDbConfiguration = exports.isSrtListenerOutputPortDbConfiguration = void 0;
const types_1 = require("626a71f10ef4eb4b");
const isSrtListenerOutputPortDbConfiguration = (cfg)=>cfg.srtMode === types_1.SrtMode.listener;
exports.isSrtListenerOutputPortDbConfiguration = isSrtListenerOutputPortDbConfiguration;
const isSrtCallerOutputPortDbConfiguration = (cfg)=>cfg.srtMode === types_1.SrtMode.caller;
exports.isSrtCallerOutputPortDbConfiguration = isSrtCallerOutputPortDbConfiguration;
const isSrtRendezvousOutputPortDbConfiguration = (cfg)=>cfg.srtMode === types_1.SrtMode.rendezvous;
exports.isSrtRendezvousOutputPortDbConfiguration = isSrtRendezvousOutputPortDbConfiguration;
var SrtBondingMode;
(function(SrtBondingMode) {
    SrtBondingMode["broadcast"] = "broadcast";
    SrtBondingMode["mainBackup"] = "main/backup";
})(SrtBondingMode || (exports.SrtBondingMode = SrtBondingMode = {}));
const isSrtListenerInputPortDbConfiguration = (cfg)=>cfg.srtMode === types_1.SrtMode.listener;
exports.isSrtListenerInputPortDbConfiguration = isSrtListenerInputPortDbConfiguration;
const isSrtCallerInputPortDbConfiguration = (cfg)=>cfg.srtMode === types_1.SrtMode.caller;
exports.isSrtCallerInputPortDbConfiguration = isSrtCallerInputPortDbConfiguration;
const isSrtRendezvousInputPortDbConfiguration = (cfg)=>cfg.srtMode === types_1.SrtMode.rendezvous;
exports.isSrtRendezvousInputPortDbConfiguration = isSrtRendezvousInputPortDbConfiguration;
var PortDirection;
(function(PortDirection) {
    PortDirection["input"] = "input";
    PortDirection["output"] = "output";
})(PortDirection || (exports.PortDirection = PortDirection = {}));
var JsonRpcErrorResponseCode;
(function(JsonRpcErrorResponseCode) {
    JsonRpcErrorResponseCode[JsonRpcErrorResponseCode["unknownMethod"] = 1] = "unknownMethod";
    JsonRpcErrorResponseCode[JsonRpcErrorResponseCode["requestError"] = 2] = "requestError";
    JsonRpcErrorResponseCode[JsonRpcErrorResponseCode["applianceNotConnected"] = 20] = "applianceNotConnected";
    JsonRpcErrorResponseCode[JsonRpcErrorResponseCode["invalidMethod"] = 10] = "invalidMethod";
    JsonRpcErrorResponseCode[JsonRpcErrorResponseCode["noSuchBrowserSession"] = 30] = "noSuchBrowserSession";
})(JsonRpcErrorResponseCode || (exports.JsonRpcErrorResponseCode = JsonRpcErrorResponseCode = {}));
var AdAuditEntity;
(function(AdAuditEntity) {
    AdAuditEntity["impressionReport"] = "impression-report";
    AdAuditEntity["impressionErrorReport"] = "impression-error-report";
    AdAuditEntity["vast"] = "vast";
    AdAuditEntity["scte35Notification"] = "scte35-notification";
    AdAuditEntity["applianceAdPlaylist"] = "appliance-ad-playlist";
    AdAuditEntity["adToTranscode"] = "ad-to-transcode";
    AdAuditEntity["transcodedFile"] = "transcoded-file";
    AdAuditEntity["mezzanineFile"] = "mezzanine-file";
    AdAuditEntity["applianceAd"] = "appliance-ad";
    AdAuditEntity["adBreak"] = "ad-break";
    AdAuditEntity["outputStream"] = "output-stream";
})(AdAuditEntity || (exports.AdAuditEntity = AdAuditEntity = {}));
var AdAuditMethod;
(function(AdAuditMethod) {
    AdAuditMethod["exists"] = "exists";
    AdAuditMethod["download"] = "download";
    AdAuditMethod["upload"] = "upload";
    AdAuditMethod["transcode"] = "transcode";
    AdAuditMethod["parse"] = "parse";
    AdAuditMethod["receive"] = "receive";
    AdAuditMethod["request"] = "request";
    AdAuditMethod["retentionDelete"] = "retention-delete";
    AdAuditMethod["play"] = "play";
    AdAuditMethod["end"] = "end";
    AdAuditMethod["scheduled"] = "scheduled";
    AdAuditMethod["canceled"] = "canceled";
    AdAuditMethod["aborted"] = "aborted";
})(AdAuditMethod || (exports.AdAuditMethod = AdAuditMethod = {}));
// A fail status is not acceptable and should be investigated
var AdAuditStatus;
(function(AdAuditStatus) {
    AdAuditStatus["start"] = "start";
    AdAuditStatus["finish"] = "finish";
    AdAuditStatus["warning"] = "warning";
    AdAuditStatus["fail"] = "fail";
})(AdAuditStatus || (exports.AdAuditStatus = AdAuditStatus = {}));
// A fail result is acceptable,
// such as a cache miss which is represented as AdAuditMethod.exists, AdAuditStatus.fail
var AdAuditResult;
(function(AdAuditResult) {
    AdAuditResult["success"] = "success";
    AdAuditResult["fail"] = "fail";
    AdAuditResult["warning"] = "warning";
})(AdAuditResult || (exports.AdAuditResult = AdAuditResult = {}));
var AdAuditComponent;
(function(AdAuditComponent) {
    AdAuditComponent["adServer"] = "ad-server";
    AdAuditComponent["adService"] = "ad-service";
    AdAuditComponent["adTranscoder"] = "ad-transcoder";
    AdAuditComponent["adProber"] = "ad-prober";
    AdAuditComponent["adRetention"] = "ad-retention";
    AdAuditComponent["vastRequester"] = "vast-requester";
    AdAuditComponent["vastReporter"] = "vast-reporter";
    AdAuditComponent["videoAppliance"] = "video-appliance";
})(AdAuditComponent || (exports.AdAuditComponent = AdAuditComponent = {}));
var AdStage;
(function(AdStage) {
    AdStage["playlist"] = "playlist";
    AdStage["firstAd"] = "first-ad";
    AdStage["allAds"] = "all-ads";
})(AdStage || (exports.AdStage = AdStage = {}));
/**
 * Error codes used in code that are translated to VAST error codes
 */ var AdErrorCode;
(function(AdErrorCode) {
    AdErrorCode[AdErrorCode["failedToPlayAd"] = 400] = "failedToPlayAd";
    AdErrorCode[AdErrorCode["failedToDownloadAd"] = 402] = "failedToDownloadAd";
    AdErrorCode[AdErrorCode["unknownError"] = 900] = "unknownError";
})(AdErrorCode || (exports.AdErrorCode = AdErrorCode = {}));

},{"626a71f10ef4eb4b":"3qemx"}],"1hoFB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InterfaceUnavailableReason", ()=>InterfaceUnavailableReason);
/**
 * Checks if the received interface is available for use by the received input/output, based on ownership, vacancy, alarm status or addresses.
 * @param physicalPort The physical port to check if it is available for use
 * @param requestee The input or output wanting to use the port
 * @return the reason why the received interface is not unavailable, or undefined if the interface is available.
 */ parcelHelpers.export(exports, "whyIsPhysicalPortUnavailable", ()=>whyIsPhysicalPortUnavailable);
var _types = require("common/api/v1/types");
var _matrox = require("common/matrox");
var InterfaceUnavailableReason = /*#__PURE__*/ function(InterfaceUnavailableReason) {
    InterfaceUnavailableReason[InterfaceUnavailableReason["wrongGroup"] = 0] = "wrongGroup";
    InterfaceUnavailableReason[InterfaceUnavailableReason["occupied"] = 1] = "occupied";
    InterfaceUnavailableReason[InterfaceUnavailableReason["noAddress"] = 2] = "noAddress";
    InterfaceUnavailableReason[InterfaceUnavailableReason["activeAlarms"] = 3] = "activeAlarms";
    InterfaceUnavailableReason[InterfaceUnavailableReason["unavailable"] = 4] = "unavailable";
    return InterfaceUnavailableReason;
}({});
function whyIsPhysicalPortUnavailable({ physicalPort, requestee }) {
    if (requestee?.groupId && requestee.groupId !== physicalPort.owner) return {
        code: 0,
        msg: 'interface belongs to another group'
    };
    const occupant = physicalPort.occupiedPorts?.[0];
    const canBeUsedByMultipleServices = physicalPort.portType !== (0, _types.PortType).coax;
    const isOccupied = occupant && !canBeUsedByMultipleServices;
    if (isOccupied) return {
        code: 1,
        msg: `interface already in use by a "${occupant.portMode}-${occupant?.inputId ? 'input' : occupant?.outputId ? 'output' : 'service'}"`
    };
    const hasNoAddresses = physicalPort.portType === (0, _types.PortType).ip && physicalPort.addresses.length === 0;
    if (hasNoAddresses) return {
        code: 2,
        msg: `interface has no addresses`
    };
    if (physicalPort.isDisabled) return {
        code: 3,
        msg: `interface has active alarms`
    };
    if ((0, _matrox.isVirtualAggregatedPort)(physicalPort) && physicalPort.appliance.type === (0, _types.ApplianceType).matroxMonarchEdgeE4_10Bit) {
        const ioConfig = physicalPort.appliance.settings.ioConfig ?? (0, _types.MatroxEncoderIOConfig).fourZero;
        if (ioConfig !== (0, _types.MatroxEncoderIOConfig).fourZero) return {
            code: 4,
            msg: `requires I/O configuration 4:0`
        };
    }
    return undefined;
}

},{"common/api/v1/types":"3qemx","common/matrox":"4mxaf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5mwDf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferencedComponent", ()=>ReferencedComponent);
parcelHelpers.export(exports, "ApplianceInterfaceSection", ()=>ApplianceInterfaceSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _utils = require("../../../utils");
var _store = require("../../../store");
var _types = require("common/api/v1/types");
var _form = require("../Form");
var _inputForm = require("../../inputs/Edit/InputForm");
var _outputForm = require("../../outputs/Edit/OutputForm");
var _base = require("./Base");
var _types1 = require("common/types");
var _physicalPortUtil = require("../../../utils/physicalPortUtil");
var _ipPortForm = require("../../inputs/Edit/PortForm/IpPortForm");
var _reactHookForm = require("react-hook-form");
const Component = (props, ref)=>{
    const { namePrefix, isInputForm, inputId, outputId, groupId, adminStatus, selectedAppliance, logicalPorts, enforcedPortMode, isModeSelectionDisabled, clearErrors, onAddLogicalPortRequested, getValues } = props;
    const areMultipleInterfacesSupported = (0, _base.areMultipleLogicalPortsPerApplianceSupported)({
        isInput: isInputForm,
        appliance: selectedAppliance,
        allLogicalPorts: (0, _base.collectPortsFromApplianceSections)(getValues())
    });
    const { result: appliancePhysicalPorts, loading: isFetchingPhysicalPorts, error: listPhysicalPortsError } = (0, _utils.useAppliancePhysicalPorts)(selectedAppliance, (0, _store.Api).appliancesApi, isInputForm ? (0, _types1.PortDirection).input : (0, _types1.PortDirection).output, isInputForm ? inputId : outputId);
    const { fields: logicalPortFields, update: updateLogicalPortField, remove: removeLogicalPortField, ...fieldArrayProps } = (0, _reactHookForm.useFieldArray)({
        name: `${namePrefix}.ports`
    });
    (0, _react.useImperativeHandle)(ref, ()=>({
            onAddInterfaceButtonClicked: ()=>{
                return addNewLogicalPortToForm();
            }
        }));
    // --> Begin hack that should be removed when the field order has been changed
    // from appliance -> interface -> mode to appliance -> mode -> interface
    // This ensures the loopback interface is always used for generators
    const logicalPort1 = logicalPorts[0];
    const mode = logicalPort1?.mode;
    (0, _react.useEffect)(()=>{
        const isEnrichedPortLocalInterface = (p)=>p?._port?.addresses?.[0]?.address === '127.0.0.1';
        const isLocalInterface = (p)=>p.addresses?.[0]?.address === '127.0.0.1';
        const localInterface = appliancePhysicalPorts?.find(isLocalInterface);
        if (mode === (0, _types.IpPortMode).generator && localInterface && !isEnrichedPortLocalInterface(logicalPort1)) {
            const generatorInputPort = {
                ...(0, _ipPortForm.generatorDefaults)(),
                physicalPort: localInterface.id,
                mode: (0, _types.IpPortMode).generator,
                address: '127.0.0.1',
                port: '',
                _port: {
                    ...localInterface,
                    _appliance: localInterface.appliance
                }
            };
            updateLogicalPortField(0, {
                ...generatorInputPort,
                id: logicalPort1.id
            });
        }
    }, [
        updateLogicalPortField,
        namePrefix,
        logicalPort1,
        mode,
        appliancePhysicalPorts
    ]);
    // <-- End hack that should be removed
    const addNewLogicalPortToForm = ()=>{
        const defaultPhysicalPort = (logicalPort1?._port || appliancePhysicalPorts?.find((physicalPort)=>{
            const occupiedReason = (0, _physicalPortUtil.whyIsPhysicalPortUnavailable)({
                physicalPort,
                requestee: {
                    groupId
                }
            });
            return occupiedReason === undefined;
        })) ?? appliancePhysicalPorts?.[0];
        if (!defaultPhysicalPort) return;
        const logicalPortInit = {
            physicalPortId: defaultPhysicalPort.id,
            port: defaultPhysicalPort,
            enforcedMode: areMultipleInterfacesSupported ? logicalPort1.mode : undefined,
            settings: selectedAppliance.settings,
            applianceType: defaultPhysicalPort.appliance.type
        };
        const nextIndex = logicalPorts.length;
        updateLogicalPortField(nextIndex, isInputForm ? (0, _inputForm.initialInputLogicalPort)(logicalPortInit) : (0, _outputForm.initialOutputLogicalPort)(logicalPortInit));
        clearErrors(`${namePrefix}.ports.${nextIndex}`);
    };
    (0, _react.useEffect)(()=>{
        const shouldAutoAddNewLogicalPortSection = logicalPorts.length === 0;
        if (shouldAutoAddNewLogicalPortSection) addNewLogicalPortToForm();
    }, [
        appliancePhysicalPorts
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetchingPhysicalPorts && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.Loading), {
                message: `Fetching interfaces...`
            }),
            listPhysicalPortsError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.Error), {
                message: `Failed fetching interfaces`
            }),
            appliancePhysicalPorts && appliancePhysicalPorts.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                newLine: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "div",
                    variant: "body1",
                    children: "The selected appliance has no available interfaces."
                })
            }),
            appliancePhysicalPorts && appliancePhysicalPorts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _base.LogicalPortForm), {
                isRegional: false,
                namePrefix: namePrefix,
                logicalPorts: logicalPorts,
                fieldArray: {
                    fields: logicalPortFields,
                    update: updateLogicalPortField,
                    remove: removeLogicalPortField,
                    ...fieldArrayProps
                },
                isInputForm: isInputForm,
                adminStatus: adminStatus,
                appliancePhysicalPorts: appliancePhysicalPorts,
                isModeSelectionDisabled: isModeSelectionDisabled,
                enforcedPortMode: enforcedPortMode,
                restrictPhysicalPortsToGroupId: groupId,
                onAddLogicalPortRequested: onAddLogicalPortRequested
            })
        ]
    });
};
const ReferencedComponent = /*#__PURE__*/ (0, _react.forwardRef)(Component);
const ApplianceInterfaceSection = ({ myRef, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ReferencedComponent, {
        ...rest,
        ref: myRef
    });

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Typography":"6NtGx","../../../utils":"342UB","../../../store":"5LXiG","common/api/v1/types":"3qemx","../Form":"4Mui7","../../inputs/Edit/InputForm":"49oSK","../../outputs/Edit/OutputForm":"btaTu","./Base":"gmIdH","common/types":"gDFnw","../../../utils/physicalPortUtil":"1hoFB","../../inputs/Edit/PortForm/IpPortForm":"mlnEQ","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gsWN0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DelayedAppearance);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function DelayedAppearance(props) {
    const [shouldRenderChildren, setShouldRenderChildren] = (0, _react.useState)(false);
    const timerRef = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        timerRef.current = setTimeout(()=>{
            setShouldRenderChildren(true);
        }, props.gracePeriodMs);
        return function onUnmount() {
            clearTimeout(timerRef.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: shouldRenderChildren ? props.children : null
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bMbF1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortForm", ()=>PortForm);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _types = require("common/api/v1/types");
var _ipPortForm = require("./IpPortForm");
var _ipPortFormDefault = parcelHelpers.interopDefault(_ipPortForm);
var _coaxPortForm = require("./CoaxPortForm");
var _coaxPortFormDefault = parcelHelpers.interopDefault(_coaxPortForm);
var _form = require("../../../common/Form");
var _videonPortForm = require("./VideonPortForm");
var _videonPortFormDefault = parcelHelpers.interopDefault(_videonPortForm);
var _ndiForm = require("./NdiForm");
var _ndiFormDefault = parcelHelpers.interopDefault(_ndiForm);
var _encoderSettings = require("../EncoderSettings/EncoderSettings");
var _encoderSettingsDefault = parcelHelpers.interopDefault(_encoderSettings);
const PortForm = ({ physicalPort, isModeDisabled, namePrefix, portIndex, onRemoveLogicalPortRequested: onRemove, onAddLogicalPortRequested })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            physicalPort.portType === (0, _types.PortType).ip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ipPortFormDefault.default), {
                portIndex: portIndex,
                namePrefix: namePrefix,
                addresses: physicalPort.addresses,
                applianceId: physicalPort.appliance.id,
                applianceType: physicalPort.appliance.type,
                applianceVersion: physicalPort.appliance.version,
                applianceFeatures: physicalPort.appliance.features,
                occupiedPorts: physicalPort.occupiedPorts,
                isModeDisabled: isModeDisabled,
                onAddLogicalPortRequested: onAddLogicalPortRequested
            }),
            physicalPort.portType === (0, _types.PortType).coax && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coaxPortFormDefault.default), {
                namePrefix: namePrefix,
                applianceFeatures: physicalPort.appliance.features
            }),
            physicalPort.portType === (0, _types.PortType).videon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videonPortFormDefault.default), {
                namePrefix: namePrefix,
                applianceFeatures: physicalPort.appliance.features,
                limitToMode: physicalPort.occupiedPorts.find((p)=>p.portMode in (0, _types.VideonPortMode) && !!p.inputId)?.portMode
            }),
            physicalPort.portType === (0, _types.PortType).ndi && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ndiFormDefault.default), {
                namePrefix: namePrefix,
                applianceId: physicalPort.appliance.id
            }),
            onRemove && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                newLine: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    style: {
                        marginTop: 12
                    },
                    variant: "outlined",
                    color: "primary",
                    onClick: ()=>onRemove(portIndex),
                    children: "Remove interface"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _encoderSettingsDefault.default), {
                namePrefix: namePrefix,
                applianceFeatures: physicalPort.appliance.features,
                applianceSettings: physicalPort.appliance.settings
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Button":"3qJY9","common/api/v1/types":"3qemx","./IpPortForm":"mlnEQ","./CoaxPortForm":"3DuO0","../../../common/Form":"4Mui7","./VideonPortForm":"cMnj2","./NdiForm":"BtS8k","../EncoderSettings/EncoderSettings":"hME3t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3DuO0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../common/Form");
var _react = require("react");
var _utils = require("../../../../utils");
var _reactHookForm = require("react-hook-form");
const CoaxPortForm = ({ namePrefix, applianceFeatures })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const logicalPort = getValues(namePrefix);
    const modeKey = `${namePrefix}.mode`;
    watch(modeKey);
    const selectedMode = logicalPort.mode;
    const modeOptions = (0, _react.useMemo)(()=>{
        const coaxModes = applianceFeatures.input?.modes.filter((m)=>(0, _utils.COAX_MODES).includes(m.mode)) ?? [];
        return coaxModes.map((m)=>({
                name: m.prettyName ?? m.mode,
                value: m.mode
            }));
    }, [
        JSON.stringify(applianceFeatures.input?.modes)
    ]);
    (0, _react.useEffect)(()=>{
        const defaultMode = modeOptions.length === 1 ? modeOptions[0].value : '';
        const isValidMode = modeOptions.some((m)=>m.value === selectedMode);
        if (!isValidMode && selectedMode !== defaultMode) setValue(modeKey, defaultMode);
    }, [
        modeKey,
        setValue,
        modeOptions,
        selectedMode
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
        label: "Mode",
        name: modeKey,
        required: true,
        newLine: true,
        options: modeOptions,
        validators: {
            oneOf: {
                validValues: new Set(modeOptions.filter((o)=>!o.disabled).map(({ value })=>value))
            }
        }
    });
};
exports.default = CoaxPortForm;

},{"react/jsx-runtime":"1dlk8","../../../common/Form":"4Mui7","react":"9njXz","../../../../utils":"342UB","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMnj2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _form = require("../../../common/Form");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
const VideonPortForm = ({ namePrefix, limitToMode, applianceFeatures })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const logicalPort = getValues(namePrefix);
    const modeKey = `${namePrefix}.mode`;
    watch(modeKey);
    const selectedMode = logicalPort.mode;
    const modeOptions = (0, _react.useMemo)(()=>{
        const videonModes = applianceFeatures.input?.modes.filter((m)=>m.mode in (0, _types.VideonPortMode)) ?? [];
        return videonModes.map((m)=>{
            const disabled = Boolean(limitToMode && limitToMode != m.mode);
            return {
                name: m.prettyName ?? m.mode,
                value: m.mode,
                disabled,
                tooltip: disabled ? 'All active inputs on a videon appliance must have the same mode' : undefined
            };
        });
    }, [
        JSON.stringify(applianceFeatures.input?.modes),
        limitToMode
    ]);
    (0, _react.useEffect)(()=>{
        const defaultMode = modeOptions.length === 1 ? modeOptions[0].value : '';
        const isValidMode = modeOptions.some((m)=>m.value === selectedMode);
        if (!isValidMode && selectedMode !== defaultMode) setValue(modeKey, defaultMode);
    }, [
        modeKey,
        setValue,
        modeOptions,
        selectedMode
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
        label: "Mode",
        name: modeKey,
        required: true,
        newLine: true,
        options: modeOptions,
        validators: {
            oneOf: {
                validValues: new Set(modeOptions.filter((o)=>!o.disabled).map((o)=>o.value))
            }
        }
    });
};
exports.default = VideonPortForm;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../common/Form":"4Mui7","react":"9njXz","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hME3t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _matroxEncoderSettings = require("./MatroxEncoderSettings");
var _matroxEncoderSettingsDefault = parcelHelpers.interopDefault(_matroxEncoderSettings);
var _generalEncoderDecoderSettings = require("../../../common/GeneralEncoderDecoderSettings");
var _generalEncoderDecoderSettingsDefault = parcelHelpers.interopDefault(_generalEncoderDecoderSettings);
var _react = require("react");
var _encoderSettingsUtil = require("common/encoderSettingsUtil");
var _reactHookForm = require("react-hook-form");
var _matrox = require("common/matrox");
function isCorrectEncoderSettingsTypeForPortMode(encoderSettings, mode, applianceFeatures) {
    if (mode === (0, _types.MatroxPortMode).matroxSdi) return encoderSettings && (0, _matrox.isMatroxEncoderConfig)(encoderSettings);
    else {
        const modesWithEncoderSettings = applianceFeatures.input?.modes.filter((m)=>!!m.encoder).map((m)=>m.mode) ?? [];
        if (modesWithEncoderSettings.includes(mode)) return encoderSettings && (0, _matrox.isGeneralEncoderSettings)(encoderSettings);
    }
    // Port mode has no support for encoder settings - should be undefined
    return encoderSettings === undefined;
}
function makeEncoderSettings(mode, applianceFeatures) {
    const isMatroxMode = mode === (0, _types.MatroxPortMode).matroxSdi;
    const modesWithEncoderSettings = applianceFeatures.input?.modes.filter((m)=>!!m.encoder).map((m)=>m.mode) ?? [];
    const hasEncoderSettings = modesWithEncoderSettings.includes(mode);
    return isMatroxMode ? (0, _encoderSettingsUtil.makeDefaultMatroxEncoderConfig)() : hasEncoderSettings ? (0, _encoderSettingsUtil.makeDefaultVaEncoderSettings)() : undefined;
}
const EncoderSettings = ({ namePrefix, applianceFeatures, applianceSettings })=>{
    const { getValues, setValue } = (0, _reactHookForm.useFormContext)();
    const logicalPort = getValues(namePrefix);
    const physicalPort = logicalPort._port;
    const encoderFeatures = applianceFeatures.input?.modes.find((m)=>m.mode === logicalPort.mode)?.encoder;
    const encoderSettings = logicalPort.encoderSettings;
    const values = getValues();
    (0, _react.useEffect)(()=>{
        if (!isCorrectEncoderSettingsTypeForPortMode(encoderSettings, logicalPort.mode, applianceFeatures)) {
            const newEncoderSettings = makeEncoderSettings(logicalPort.mode, applianceFeatures);
            setValue(`${namePrefix}.encoderSettings`, newEncoderSettings, {
                shouldValidate: true
            });
        }
    }, [
        encoderSettings,
        logicalPort.mode,
        applianceFeatures,
        setValue,
        namePrefix
    ]);
    const isDerivedInput = values._derived;
    if (isDerivedInput) return null;
    if (!encoderFeatures) return null;
    if (!encoderSettings) return null;
    if (!isCorrectEncoderSettingsTypeForPortMode(encoderSettings, logicalPort.mode, applianceFeatures)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            logicalPort.mode !== (0, _types.MatroxPortMode).matroxSdi && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalEncoderDecoderSettingsDefault.default), {
                namePrefix: `${namePrefix}.encoderSettings`,
                encoderFeatures: encoderFeatures
            }),
            logicalPort.mode === (0, _types.MatroxPortMode).matroxSdi && !!physicalPort && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matroxEncoderSettingsDefault.default), {
                namePrefix: `${namePrefix}.encoderSettings`,
                physicalPort: physicalPort,
                inputSettings: encoderSettings,
                applianceSettings: applianceSettings
            })
        ]
    });
};
exports.default = EncoderSettings;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","./MatroxEncoderSettings":"eJY5w","../../../common/GeneralEncoderDecoderSettings":"j9Iye","react":"9njXz","common/encoderSettingsUtil":"aAPl1","react-hook-form":"8z0aI","common/matrox":"4mxaf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eJY5w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../common/Form");
var _4GridPng = require("../../../../img/4Grid.png");
var _4GridPngDefault = parcelHelpers.interopDefault(_4GridPng);
var _types = require("common/api/v1/types");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _encoderSettingsUtil = require("common/encoderSettingsUtil");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _react = require("react");
var _matrox = require("common/matrox");
var _reactHookForm = require("react-hook-form");
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
const inputSourceOptions = [
    0,
    1,
    2,
    3
].map((i)=>({
        name: `SDI ${i + 1}`,
        value: i
    }));
const encoderIncludeOptions = Object.values((0, _types.MatroxEncoderIncludeOption)).map((option)=>{
    switch(option){
        case (0, _types.MatroxEncoderIncludeOption).none:
            return undefined;
        case (0, _types.MatroxEncoderIncludeOption).audioOnly:
            return {
                name: 'Audio only',
                value: option
            };
        case (0, _types.MatroxEncoderIncludeOption).videoOnly:
            return {
                name: 'Video only',
                value: option
            };
        case (0, _types.MatroxEncoderIncludeOption).audioAndVideo:
            return {
                name: 'Audio and video',
                value: option
            };
    }
}).filter(Boolean);
const encodingProfileOptions = Object.values((0, _types.MatroxEncoderVideoProfile)).map((option)=>{
    switch(option){
        case (0, _types.MatroxEncoderVideoProfile).Baseline:
            return {
                name: 'Baseline',
                value: option
            };
        case (0, _types.MatroxEncoderVideoProfile).Main:
            return {
                name: 'Main',
                value: option
            };
        case (0, _types.MatroxEncoderVideoProfile).High:
            return {
                name: 'High',
                value: option
            };
        case (0, _types.MatroxEncoderVideoProfile).High10Bit:
            return {
                name: 'High 10-bit',
                value: option
            };
        case (0, _types.MatroxEncoderVideoProfile).High422:
            return {
                name: 'High YUV 4:2:2',
                value: option
            };
    }
});
const encodingModeOptions = Object.values((0, _types.MatroxEncoderEncodingMode)).map((option)=>{
    switch(option){
        case (0, _types.MatroxEncoderEncodingMode).lowLatency:
            return {
                name: 'Optimised for low latency',
                value: option
            };
        case (0, _types.MatroxEncoderEncodingMode).highQuality:
            return {
                name: 'Favour image quality',
                value: option
            };
    }
});
const bitrateControlOptions = Object.values((0, _types.MatroxEncoderBitrateControlMode)).map((option)=>{
    switch(option){
        case (0, _types.MatroxEncoderBitrateControlMode).constant:
            return {
                name: 'Constant',
                value: option
            };
        case (0, _types.MatroxEncoderBitrateControlMode).variable:
            return {
                name: 'Variable',
                value: option
            };
    }
});
const aacEncoderOptions = Object.values((0, _types.MatroxEncoderAACEncoder)).map((option)=>{
    switch(option){
        case (0, _types.MatroxEncoderAACEncoder).lc:
            return {
                name: 'LC',
                value: option
            };
        case (0, _types.MatroxEncoderAACEncoder).hev1:
            return {
                name: 'HEV1',
                value: option
            };
        case (0, _types.MatroxEncoderAACEncoder).hev2:
            return {
                name: 'HEV2',
                value: option
            };
    }
});
const aacQualityLevelOptions = Object.values((0, _types.MatroxEncoderAACQualityLevel)).map((option)=>{
    switch(option){
        case (0, _types.MatroxEncoderAACQualityLevel).low:
            return {
                name: 'Low',
                value: option
            };
        case (0, _types.MatroxEncoderAACQualityLevel).medium:
            return {
                name: 'Medium',
                value: option
            };
        case (0, _types.MatroxEncoderAACQualityLevel).high:
            return {
                name: 'High',
                value: option
            };
        case (0, _types.MatroxEncoderAACQualityLevel).unknown:
            return undefined;
    }
}).filter(Boolean);
const aacFormatOptions = Object.values((0, _types.MatroxEncoderAACFormat)).map((option)=>{
    switch(option){
        case (0, _types.MatroxEncoderAACFormat).noContainer:
            return {
                name: 'No container/Raw',
                value: option
            };
        case (0, _types.MatroxEncoderAACFormat).adts:
            return {
                name: 'ADTS',
                value: option
            };
        case (0, _types.MatroxEncoderAACFormat).adif:
            return undefined;
        case (0, _types.MatroxEncoderAACFormat).unknown:
            return undefined;
    }
}).filter(Boolean);
function formatAudioPair(audioPair) {
    switch(audioPair){
        case (0, _types.MatroxAudioChannelPair).channel1And2:
            return '1-2';
        case (0, _types.MatroxAudioChannelPair).channel3And4:
            return '3-4';
        case (0, _types.MatroxAudioChannelPair).channel5And6:
            return '5-6';
        case (0, _types.MatroxAudioChannelPair).channel7And8:
            return '7-8';
        case (0, _types.MatroxAudioChannelPair).channel9And10:
            return '9-10';
        case (0, _types.MatroxAudioChannelPair).channel11And12:
            return '11-12';
        case (0, _types.MatroxAudioChannelPair).channel13And14:
            return '13-14';
        case (0, _types.MatroxAudioChannelPair).channel15And16:
            return '15-16';
    }
}
const MatroxEncoderSettingsComp = ({ namePrefix, physicalPort, inputSettings: { processorSettings, encoderSettings: { include, audioSettings, videoSettings }, tsOutputSettings }, applianceSettings })=>{
    const { setValue } = (0, _reactHookForm.useFormContext)();
    const isRunningMatroxV2 = false // FIXME MG: Uncomment when we wish to support matrox v2 features: applianceSettings.apiVersion === 'v2'
    ;
    const hasMultipleVideoSources = processorSettings.videoLayout !== 'single';
    const includeKey = `${namePrefix}.encoderSettings.include`;
    const forcePixelFormatKey = `${namePrefix}.encoderSettings.videoSettings.forcePixelFormat`;
    const bitrateControlKey = `${namePrefix}.encoderSettings.videoSettings.rateControl.bitrateControl`;
    const videoLayoutKey = `${namePrefix}.processorSettings.videoLayout`;
    const testModeKey = `${namePrefix}.processorSettings.enableTestMode`;
    const followSourceVideoSettingsKey = `${namePrefix}.processorSettings.followVideoSourceInput`;
    const isAncEnabledKey = `${namePrefix}.tsOutputSettings.isAncEnabled`;
    const audioInputSourceKey = `${namePrefix}.processorSettings.audioSourceSettings.portIndex`;
    // Watch fields that control the form
    (0, _reactHookForm.useWatch)({
        name: includeKey
    });
    (0, _reactHookForm.useWatch)({
        name: forcePixelFormatKey
    });
    (0, _reactHookForm.useWatch)({
        name: bitrateControlKey
    });
    (0, _reactHookForm.useWatch)({
        name: videoLayoutKey
    });
    (0, _reactHookForm.useWatch)({
        name: testModeKey
    }) // Will enable/disable followSourceVideoSettingsKey
    ;
    (0, _reactHookForm.useWatch)({
        name: followSourceVideoSettingsKey
    }) // Will enable/disable isAncEnabled
    ;
    (0, _reactHookForm.useWatch)({
        name: isAncEnabledKey
    }) // Will enable/disable enable104to35
    ;
    (0, _reactHookForm.useWatch)({
        name: audioInputSourceKey
    }) // Will re-calculate isPcmModeEnabledForSelectedAudioSdiPort
    ;
    const isVideoFormDisabled = include === (0, _types.MatroxEncoderIncludeOption).audioOnly;
    const isAudioFormDisabled = include === (0, _types.MatroxEncoderIncludeOption).videoOnly;
    const isPcmModeEnabledForSelectedAudioSdiPort = applianceSettings.sdiPortsWithPcmModeEnabled?.includes(processorSettings.audioSourceSettings.portIndex) ?? false;
    (0, _react.useEffect)(()=>{
        function ensureValidFollowVideoSourceInput() {
            // Cannot followVideoSourceInput when there are multiple video sources or if testmode is enabled
            const expectedFollowInputVideoSource = !hasMultipleVideoSources && !processorSettings.enableTestMode;
            if (processorSettings.followVideoSourceInput !== expectedFollowInputVideoSource) setValue(followSourceVideoSettingsKey, expectedFollowInputVideoSource);
        }
        ensureValidFollowVideoSourceInput();
    }, [
        hasMultipleVideoSources,
        processorSettings.enableTestMode,
        processorSettings.followVideoSourceInput
    ]);
    (0, _react.useEffect)(()=>{
        function ensureValidIsAncEnabled() {
            if (!processorSettings.followVideoSourceInput && tsOutputSettings.isAncEnabled) // isAncEnabled requires followVideoSourceInput to be true
            setValue(isAncEnabledKey, false);
        }
        ensureValidIsAncEnabled();
    }, [
        processorSettings.followVideoSourceInput,
        tsOutputSettings.isAncEnabled
    ]);
    (0, _react.useEffect)(()=>{
        function ensureValidEnable104To35() {
            const canEnable104to35 = tsOutputSettings.isAncEnabled;
            if (!canEnable104to35 && tsOutputSettings.enable104To35) // enable104To35 requires isAncEnabled to be true
            setValue(`${namePrefix}.tsOutputSettings.enable104To35`, false);
        }
        ensureValidEnable104To35();
    }, [
        tsOutputSettings.isAncEnabled,
        tsOutputSettings.enable104To35
    ]);
    (0, _react.useEffect)(()=>{
        const quantizationMax = videoSettings.rateControl.bitrateControl === (0, _types.MatroxEncoderBitrateControlMode).constant ? (0, _encoderSettingsUtil.MATROX_ENCODER_QP_CONSTANT_BITRATE_MAX) : (0, _encoderSettingsUtil.MATROX_ENCODER_QP_VARIABLE_BITRATE_MAX);
        if (videoSettings.rateControl.quantizationMax !== quantizationMax) setValue(`${namePrefix}.encoderSettings.videoSettings.rateControl.quantizationMax`, quantizationMax);
    }, [
        videoSettings.rateControl.bitrateControl
    ]);
    (0, _react.useEffect)(()=>{
        if (physicalPort.portType !== (0, _types.PortType).coax) return;
        const isVirtualQuadPortSelected = (0, _matrox.isVirtualAggregatedPort)(physicalPort);
        if (isVirtualQuadPortSelected) {
            if (processorSettings.videoLayout !== 'quad') // The virtual aggregated port only supports quad mode
            setValue(`${namePrefix}.processorSettings.videoLayout`, 'quad');
            if (processorSettings.videoSourceSettings.length !== 4) setValue(`${namePrefix}.processorSettings.videoSourceSettings`, [
                (0, _encoderSettingsUtil.makeMatroxEncoderProcessorVideoSourceSettings)(0),
                (0, _encoderSettingsUtil.makeMatroxEncoderProcessorVideoSourceSettings)(1),
                (0, _encoderSettingsUtil.makeMatroxEncoderProcessorVideoSourceSettings)(2),
                (0, _encoderSettingsUtil.makeMatroxEncoderProcessorVideoSourceSettings)(3)
            ]);
        } else {
            // Port indexes of the currently selected interfaces
            const availableInputSources = [
                physicalPort
            ].reduce((set, port)=>{
                const indexes = (port.index ?? '').split(',').map((str)=>Number(str)).filter((i)=>!isNaN(i));
                for (const i of indexes)set.add(i);
                return set;
            }, new Set());
            // Regular (non virtual-aggregated) interface:
            const physicalPortIndex = availableInputSources.values().next().value ?? 0;
            if (processorSettings.videoLayout !== 'single') {
                // Going from 'quad' --> 'single'
                setValue(`${namePrefix}.processorSettings.videoLayout`, 'single');
                setValue(`${namePrefix}.processorSettings.videoSourceSettings`, [
                    (0, _encoderSettingsUtil.makeMatroxEncoderProcessorVideoSourceSettings)(physicalPortIndex)
                ]);
            } else // Going from 'single' --> 'single', e.g. SDI 1 --> SDI 2
            if (processorSettings.videoSourceSettings[0].portIndex !== physicalPortIndex) setValue(`${namePrefix}.processorSettings.videoSourceSettings`, [
                {
                    ...processorSettings.videoSourceSettings[0],
                    portIndex: physicalPortIndex
                }
            ]);
            if (processorSettings.audioSourceSettings.portIndex !== physicalPortIndex) setValue(`${namePrefix}.processorSettings.audioSourceSettings`, (0, _encoderSettingsUtil.makeMatroxEncoderProcessorAudioSourceSettings)(physicalPortIndex));
        }
    }, [
        physicalPort,
        processorSettings,
        setValue,
        namePrefix
    ]);
    const audioBitrateConstraints = (0, _encoderSettingsUtil.getAllowedBitratesForMatroxAACEncoder)(audioSettings.aacEncoder);
    const audioCheckboxesAac = isPcmModeEnabledForSelectedAudioSdiPort ? null : Object.values((0, _types.MatroxAudioChannelPair)).filter((pair)=>!isNaN(Number(pair))).map((pair)=>{
        const currentValue = tsOutputSettings.selectedAudioPairs;
        const handleClick = ()=>{
            const newValue = currentValue.includes(pair) ? currentValue.filter((p)=>p !== pair) : [
                ...currentValue,
                pair
            ];
            setValue(`${namePrefix}.tsOutputSettings.selectedAudioPairs`, newValue, {
                shouldValidate: true
            });
        };
        const isSelected = currentValue.includes(pair);
        const canDeselect = currentValue.length > (0, _encoderSettingsUtil.MATROX_ENCODER_MIN_ALLOWED_AUDIOSTREAMS // Min 1
        );
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
            label: formatAudioPair(pair),
            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                checked: isSelected,
                disabled: isSelected && !canDeselect,
                onChange: handleClick
            })
        }, pair);
    });
    const audioCheckboxesPcm = isPcmModeEnabledForSelectedAudioSdiPort ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
            row: true,
            value: audioSettings.numAudioChannels ?? 2,
            onChange: (_event, value)=>{
                setValue(`${namePrefix}.encoderSettings.audioSettings.numAudioChannels`, parseInt(value), {
                    shouldValidate: true
                });
            },
            children: [
                2,
                4,
                6,
                8,
                16
            ].map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                    value: option,
                    control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                        disabled: isAudioFormDisabled
                    }),
                    label: `1-${option.toString()}`
                }, option))
        })
    }) : null;
    const selectedPixelFormat = videoSettings.forcePixelFormat ? videoSettings.forcedPixelFormat : processorSettings.followVideoSourceInput ? undefined : processorSettings.overriddenCanvasSettings.pixelFormat;
    const isCBR = videoSettings.rateControl.bitrateControl === (0, _types.MatroxEncoderBitrateControlMode).constant;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
        size: {
            xs: 12
        },
        children: [
            isRunningMatroxV2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: 'Test mode',
                tooltip: 'Generate audio and video instead of receiving from the SDI input',
                name: testModeKey
            }),
            hasMultipleVideoSources && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                title: "Quad View Input Sources",
                collapsible: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "Audio input source",
                        name: `${namePrefix}.processorSettings.audioSourceSettings.portIndex`,
                        disabled: !hasMultipleVideoSources,
                        required: true,
                        options: inputSourceOptions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                        lg: 12,
                        xl: 12,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                width: '100%',
                                gap: 20,
                                justifyContent: 'space-evenly',
                                display: 'flex',
                                alignItems: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: (0, _4GridPngDefault.default),
                                    alt: 'Grid'
                                }),
                                processorSettings.videoSourceSettings.map((_, index)=>{
                                    const name = `${namePrefix}.processorSettings.videoSourceSettings.${index}`;
                                    const source = [
                                        'A',
                                        'B',
                                        'C',
                                        'D'
                                    ][index];
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                        label: `Video input source ${source}`,
                                        name: `${name}.portIndex`,
                                        disabled: !hasMultipleVideoSources,
                                        required: true,
                                        options: inputSourceOptions
                                    }, name);
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                id: "matrox-encoder-settings",
                title: "Encoder Settings",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "Include",
                        name: includeKey,
                        required: true,
                        options: encoderIncludeOptions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        label: 'Enable ancillary data',
                        newLine: true,
                        tooltip: 'Insert ancillary data as SMPTE ST 2038 in the MPEG2-TS stream',
                        name: isAncEnabledKey,
                        disabled: !processorSettings.followVideoSourceInput
                    }),
                    isRunningMatroxV2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        label: 'Convert SCTE-104 to SCTE-35',
                        tooltip: 'Convert SCTE-104 to SCTE-35 instead of inserting them as SMPTE ST 2038 into the MPEG2-TS stream',
                        name: `${namePrefix}.tsOutputSettings.enable104To35`,
                        disabled: !tsOutputSettings.isAncEnabled
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: `Audio${isPcmModeEnabledForSelectedAudioSdiPort ? ' (PCM Mode)' : ''}`,
                        collapsible: true,
                        children: [
                            !isPcmModeEnabledForSelectedAudioSdiPort && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                        label: "AAC encoder",
                                        name: `${namePrefix}.encoderSettings.audioSettings.aacEncoder`,
                                        disabled: isAudioFormDisabled,
                                        required: true,
                                        options: aacEncoderOptions
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        label: "Bit rate (kb/s)",
                                        name: `${namePrefix}.encoderSettings.audioSettings.bitrateKbps`,
                                        disabled: isAudioFormDisabled,
                                        required: true,
                                        type: "number",
                                        noNegative: true,
                                        validators: audioBitrateConstraints && {
                                            numericality: {
                                                greaterThanOrEqualTo: audioBitrateConstraints.minAllowedBitrateKbps,
                                                lessThanOrEqualTo: audioBitrateConstraints.maxAllowedBitrateKbps,
                                                message: `Must be between ${audioBitrateConstraints.minAllowedBitrateKbps}-${audioBitrateConstraints.maxAllowedBitrateKbps} for the selected AAC encoder (${audioSettings.aacEncoder})`,
                                                noStrings: false
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                        label: "AAC quality",
                                        name: `${namePrefix}.encoderSettings.audioSettings.aacQuality`,
                                        disabled: isAudioFormDisabled,
                                        required: true,
                                        options: aacQualityLevelOptions
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                        label: "AAC format",
                                        name: `${namePrefix}.encoderSettings.audioSettings.aacFormat`,
                                        disabled: true,
                                        required: true,
                                        options: aacFormatOptions
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                        label: 'Use temporal noise shaping',
                                        name: `${namePrefix}.encoderSettings.audioSettings.useTemporalNoiseShaping`,
                                        disabled: isAudioFormDisabled
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                        className: "outlined",
                                        title: "Audio Pair Selection",
                                        children: audioCheckboxesAac
                                    })
                                ]
                            }),
                            isPcmModeEnabledForSelectedAudioSdiPort && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                className: "outlined",
                                title: "Audio Pair Selection",
                                children: audioCheckboxesPcm
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Video",
                        collapsible: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                name: forcePixelFormatKey,
                                label: 'Enforce a pixel format',
                                disabled: isVideoFormDisabled
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Forced pixel format",
                                name: `${namePrefix}.encoderSettings.videoSettings.forcedPixelFormat`,
                                disabled: isVideoFormDisabled || !videoSettings.forcePixelFormat,
                                required: true,
                                options: Object.values((0, _types.MatroxEncoderPixelFormat))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Encoding profile",
                                name: `${namePrefix}.encoderSettings.videoSettings.encodingProfile`,
                                disabled: isVideoFormDisabled,
                                required: true,
                                tooltip: `Must be compatible with the selected pixel format`,
                                options: encodingProfileOptions,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(selectedPixelFormat ? (0, _encoderSettingsUtil.getCompatibleMatroxVideoProfilesForPixelFormat)(selectedPixelFormat) : [
                                            (0, _types.MatroxEncoderVideoProfile).High422
                                        ])
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                                className: "outlined",
                                title: "Group Of Pictures (GOP)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        label: "GOP length",
                                        name: `${namePrefix}.encoderSettings.videoSettings.gop.iFrameInterval`,
                                        disabled: isVideoFormDisabled,
                                        required: true,
                                        tooltip: `Insert a key frame every "${videoSettings.gop.iFrameInterval}" pictures`,
                                        type: "number",
                                        noNegative: true,
                                        validators: {
                                            numericality: {
                                                greaterThanOrEqualTo: videoSettings.gop.pFrameInterval,
                                                lessThanOrEqualTo: (0, _encoderSettingsUtil.MATROX_ENCODER_IFRAME_INTERVAL_MAX),
                                                divisibleBy: (0, _encoderSettingsUtil.MATROX_ENCODER_IFRAME_INTERVAL_MULTIPLIER),
                                                message: `Must be a multiplier of ${(0, _encoderSettingsUtil.MATROX_ENCODER_IFRAME_INTERVAL_MULTIPLIER)} between ${(0, _encoderSettingsUtil.MATROX_ENCODER_IFRAME_INTERVAL_MIN)}-${(0, _encoderSettingsUtil.MATROX_ENCODER_IFRAME_INTERVAL_MAX)} and greater than or equal to the selected P-frame interval (${videoSettings.gop.pFrameInterval})`,
                                                noStrings: false
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        label: "P-frame interval",
                                        name: `${namePrefix}.encoderSettings.videoSettings.gop.pFrameInterval`,
                                        disabled: isVideoFormDisabled,
                                        required: true,
                                        tooltip: `Insert a P-frame every "${videoSettings.gop.pFrameInterval}":th frame`,
                                        type: "number",
                                        noNegative: true,
                                        validators: {
                                            numericality: {
                                                greaterThanOrEqualTo: (0, _encoderSettingsUtil.MATROX_ENCODER_PFRAME_INTERVAL_MIN),
                                                lessThanOrEqualTo: (0, _encoderSettingsUtil.MATROX_ENCODER_PFRAME_INTERVAL_MAX),
                                                message: `Must be between ${(0, _encoderSettingsUtil.MATROX_ENCODER_PFRAME_INTERVAL_MIN)}-${(0, _encoderSettingsUtil.MATROX_ENCODER_PFRAME_INTERVAL_MAX)} and less than or equal to the selected GOP length (${videoSettings.gop.iFrameInterval})`,
                                                noStrings: false
                                            }
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                                className: "outlined",
                                title: "Rate Control",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                        label: "Encoding Mode",
                                        name: `${namePrefix}.encoderSettings.videoSettings.rateControl.mode`,
                                        disabled: isVideoFormDisabled,
                                        required: true,
                                        options: encodingModeOptions
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                        label: "Bit rate control",
                                        name: bitrateControlKey,
                                        disabled: isVideoFormDisabled,
                                        required: true,
                                        options: bitrateControlOptions
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        label: "Target bitrate (Mbps)",
                                        name: `${namePrefix}.encoderSettings.videoSettings.targetBitrateMbps`,
                                        disabled: isVideoFormDisabled,
                                        required: true,
                                        type: "number",
                                        noNegative: true,
                                        validators: {
                                            numericality: {
                                                greaterThanOrEqualTo: isCBR ? (0, _encoderSettingsUtil.MATROX_ENCODER_CBR_TARGET_BITRATE_MIN) : (0, _encoderSettingsUtil.MATROX_ENCODER_VBR_TARGET_BITRATE_MIN),
                                                lessThanOrEqualTo: isCBR ? (0, _encoderSettingsUtil.MATROX_ENCODER_MAXBITRATE_MAX) : videoSettings.rateControl.maxBitrateMbps,
                                                message: isCBR ? `Must be between ${0, _encoderSettingsUtil.MATROX_ENCODER_CBR_TARGET_BITRATE_MIN}-${0, _encoderSettingsUtil.MATROX_ENCODER_MAXBITRATE_MAX}` : `Must be between ${0, _encoderSettingsUtil.MATROX_ENCODER_VBR_TARGET_BITRATE_MIN}-${0, _encoderSettingsUtil.MATROX_ENCODER_MAXBITRATE_MAX} and less than or equal to the selected max bitrate (${videoSettings.rateControl.maxBitrateMbps})`,
                                                noStrings: false
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        label: "Max bit rate (Mbps)",
                                        name: `${namePrefix}.encoderSettings.videoSettings.rateControl.maxBitrateMbps`,
                                        disabled: isVideoFormDisabled || isCBR,
                                        required: true,
                                        type: "number",
                                        noNegative: true,
                                        validators: isVideoFormDisabled || isCBR ? undefined : {
                                            numericality: {
                                                greaterThanOrEqualTo: Math.max((0, _encoderSettingsUtil.MATROX_ENCODER_MAXBITRATE_MIN), videoSettings.targetBitrateMbps),
                                                lessThanOrEqualTo: (0, _encoderSettingsUtil.MATROX_ENCODER_MAXBITRATE_MAX),
                                                message: `Must be between ${0, _encoderSettingsUtil.MATROX_ENCODER_MAXBITRATE_MIN}-${0, _encoderSettingsUtil.MATROX_ENCODER_MAXBITRATE_MAX} and greater than or equal to the selected target bitrate (${videoSettings.targetBitrateMbps})`,
                                                noStrings: false
                                            }
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = MatroxEncoderSettingsComp;

},{"react/jsx-runtime":"1dlk8","../../../common/Form":"4Mui7","../../../../img/4Grid.png":"6fZaX","common/api/v1/types":"3qemx","@mui/material/Grid":"6iX4B","common/encoderSettingsUtil":"aAPl1","@mui/material/Checkbox":"ag1Z5","react":"9njXz","common/matrox":"4mxaf","react-hook-form":"8z0aI","@mui/material/RadioGroup":"l1i9K","@mui/material/FormControlLabel":"45VZW","@mui/material/Radio":"hyH25","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fZaX":[function(require,module,exports,__globalThis) {
module.exports = require("293f3dc36237a217").getBundleURL('7YEHs') + "4Grid.4101bb9f.png";

},{"293f3dc36237a217":"a2ypy"}],"aAPl1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MATROX_ENCODER_MIN_ALLOWED_AUDIOSTREAMS = exports.MATROX_ENCODER_PFRAME_INTERVAL_MAX = exports.MATROX_ENCODER_PFRAME_INTERVAL_MIN = exports.MATROX_ENCODER_IFRAME_INTERVAL_MULTIPLIER = exports.MATROX_ENCODER_IFRAME_INTERVAL_MAX = exports.MATROX_ENCODER_IFRAME_INTERVAL_MIN = exports.MATROX_ENCODER_QP_VARIABLE_BITRATE_MAX = exports.MATROX_ENCODER_QP_CONSTANT_BITRATE_MAX = exports.MATROX_ENCODER_QP_MIN = exports.MATROX_ENCODER_MAXBITRATE_MAX = exports.MATROX_ENCODER_MAXBITRATE_MIN = exports.MATROX_ENCODER_CBR_TARGET_BITRATE_MIN = exports.MATROX_ENCODER_VBR_TARGET_BITRATE_MIN = exports.MATROX_ENCODER_FRAMEHEIGHT_MULTIPLIER = exports.MATROX_ENCODER_FRAMEWIDTH_MULTIPLIER = exports.MATROX_ENCODER_FRAMESIZE_MAX = exports.MATROX_ENCODER_FRAMESIZE_MIN = exports.MATROX_ENCODER_VIDEO_SATURATION_MAX = exports.MATROX_ENCODER_VIDEO_SATURATION_MIN = exports.MATROX_ENCODER_VIDEO_HUE_MAX = exports.MATROX_ENCODER_VIDEO_HUE_MIN = exports.MATROX_ENCODER_VIDEO_CONTRAST_MAX = exports.MATROX_ENCODER_VIDEO_CONTRAST_MIN = exports.MATROX_ENCODER_VIDEO_BRIGHTNESS_MAX = exports.MATROX_ENCODER_VIDEO_BRIGHTNESS_MIN = exports.MATROX_ENCODER_VIDEO_OPACITY_PERCENTAGE_MAX = exports.MATROX_ENCODER_VIDEO_OPACITY_PERCENTAGE_MIN = exports.MATROX_ENCODER_VIDEO_CAPTURE_RATE_MAX = exports.MATROX_ENCODER_VIDEO_CAPTURE_RATE_MIN = void 0;
exports.makeDefaultVaEncoderSettings = makeDefaultVaEncoderSettings;
exports.makeDefaultMatroxEncoderConfig = makeDefaultMatroxEncoderConfig;
exports.makeMatroxEncoderProcessorAudioSourceSettings = makeMatroxEncoderProcessorAudioSourceSettings;
exports.makeMatroxEncoderProcessorVideoSourceSettings = makeMatroxEncoderProcessorVideoSourceSettings;
exports.validateMatroxEncoderSettings = validateMatroxEncoderSettings;
exports.getCompatibleMatroxVideoProfilesForPixelFormat = getCompatibleMatroxVideoProfilesForPixelFormat;
exports.getAllowedBitratesForMatroxAACEncoder = getAllowedBitratesForMatroxAACEncoder;
exports.validateMatroxEncoderConfig = validateMatroxEncoderConfig;
exports.maxAllowedMatroxQpMaxValue = maxAllowedMatroxQpMaxValue;
exports.validateGeneralEncoderSettings = validateGeneralEncoderSettings;
const types_1 = require("5331e88b15e72453");
const errors_1 = require("64aa47dcaad7952f");
const helpers_1 = require("da87100169272835");
const matrox_1 = require("c66a9b46e4c0ac2a");
const applianceTypes_1 = require("8992e7fcac075789");
function makeDefaultVaEncoderSettings() {
    return {
        videoCodec: types_1.VideoCodec.h264,
        profile: '',
        pixelFormat: '',
        resolution: '',
        scanRate: '',
        scan: '',
        bitDepth: 8,
        colorSampling: '',
        latencyMode: '',
        scalingMode: '',
        totalBitrate: 15,
        gopSizeFrames: 150,
        videoFlags: {},
        audioStreams: [],
        enableScte35: false,
        scte35Pid: '',
        gopStructure: applianceTypes_1.VaGopStructure.IPBBB,
        enableSmpte2038: false
    };
}
function makeDefaultMatroxEncoderConfig(inputSourcePortIndex = 0) {
    return {
        type: 'matroxEncoder',
        processorSettings: {
            audioSourceSettings: {
                portIndex: inputSourcePortIndex
            },
            inputFailSafe: false,
            followVideoSourceInput: true,
            videoLayout: 'single',
            videoSourceSettings: [
                makeMatroxEncoderProcessorVideoSourceSettings(inputSourcePortIndex)
            ],
            overriddenCanvasSettings: {
                frameSize: {
                    width: 1920,
                    height: 1080
                },
                frameRate: types_1.MatroxEncoderProcessorFrameRate.sixty,
                backgroundColor: {
                    red: 0,
                    green: 0,
                    blue: 0,
                    alpha: 255
                },
                pixelFormat: types_1.MatroxEncoderPixelFormat.YUV422_10bits
            }
        },
        encoderSettings: {
            include: types_1.MatroxEncoderIncludeOption.audioAndVideo,
            videoSettings: {
                forceEncodingSize: false,
                forcedEncodingSettings: {
                    frameSize: {
                        width: 1920,
                        height: 1080
                    },
                    scaling: types_1.MatroxEncoderScalingOption.noScalingAtCenter,
                    pivot: types_1.MatroxEncoderPivotOption.none,
                    flip: types_1.MatroxEncoderFlipOption.none
                },
                forcePixelFormat: false,
                forcedPixelFormat: types_1.MatroxEncoderPixelFormat.YUV422_10bits,
                // encodingProfile must be 'High YUV 4:2:2' if processorSettings.followVideoSourceInput = true
                encodingProfile: types_1.MatroxEncoderVideoProfile.High422,
                targetBitrateMbps: 15,
                useLosslessEncoding: false,
                gop: {
                    iFrameInterval: 60,
                    pFrameInterval: 1,
                    temporalIframeInterval: 0
                },
                rateControl: {
                    mode: types_1.MatroxEncoderEncodingMode.highQuality,
                    quantizationMin: 15,
                    quantizationMax: exports.MATROX_ENCODER_QP_CONSTANT_BITRATE_MAX,
                    bitrateControl: types_1.MatroxEncoderBitrateControlMode.constant,
                    allowFrameSkipping: false,
                    maxBitrateMbps: 22.5
                },
                forceCAVLCEntropyEncoding: false
            },
            audioSettings: {
                aacEncoder: types_1.MatroxEncoderAACEncoder.lc,
                bitrateKbps: 32,
                aacQuality: types_1.MatroxEncoderAACQualityLevel.high,
                useTemporalNoiseShaping: true,
                aacFormat: types_1.MatroxEncoderAACFormat.adts
            }
        },
        tsOutputSettings: {
            isAncEnabled: false,
            selectedAudioPairs: [
                types_1.MatroxAudioChannelPair.channel1And2
            ],
            // Available in Matrox V2 API
            enable104To35: false
        }
    };
}
function makeMatroxEncoderProcessorAudioSourceSettings(portIndex) {
    return {
        portIndex
    };
}
function makeMatroxEncoderProcessorVideoSourceSettings(portIndex) {
    return {
        portIndex,
        frameCaptureRate: 1,
        scaling: types_1.MatroxEncoderScalingOption.scaleToFitAllContent,
        pivot: types_1.MatroxEncoderPivotOption.none,
        flip: types_1.MatroxEncoderFlipOption.none,
        opacityPercentage: 100,
        brightness: 500,
        contrast: 500,
        hue: 0,
        saturation: 500
    };
}
function validateMatroxEncoderSettings(encoderSettings, physicalPort) {
    const availableSources = physicalPort.index?.split(',') ?? [];
    const requestedSources = [
        encoderSettings.processorSettings.audioSourceSettings.portIndex.toString(),
        ...encoderSettings.processorSettings.videoSourceSettings.map((src)=>src.portIndex.toString())
    ];
    const isRequestingUnavailableSource = requestedSources.some((requested)=>!availableSources.includes(requested));
    if (isRequestingUnavailableSource) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Attempting to ingress from sources: '${requestedSources.join(',')}' but available sources are: '${availableSources.join(',')}'`);
    const isVirtualPort = (0, matrox_1.isVirtualAggregatedPort)(physicalPort);
    if (isVirtualPort && encoderSettings.processorSettings.videoLayout !== 'quad') throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `The received physical port only supports videoLayout 'quad'`);
    else if (!isVirtualPort && encoderSettings.processorSettings.videoLayout !== 'single') throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `The received physical port only supports videoLayout 'single'`);
    validateMatroxEncoderConfig(encoderSettings);
}
function getCompatibleMatroxVideoProfilesForPixelFormat(pixelFormat) {
    const compatibles = {
        [types_1.MatroxEncoderPixelFormat.YUV420_8bits]: [],
        [types_1.MatroxEncoderPixelFormat.YUV420_10bits]: [
            types_1.MatroxEncoderVideoProfile.High10Bit,
            types_1.MatroxEncoderVideoProfile.High422
        ],
        [types_1.MatroxEncoderPixelFormat.YUV422_8bits]: [
            types_1.MatroxEncoderVideoProfile.High422
        ],
        [types_1.MatroxEncoderPixelFormat.YUV422_10bits]: [
            types_1.MatroxEncoderVideoProfile.High422
        ]
    };
    return compatibles[pixelFormat];
}
function getAllowedBitratesForMatroxAACEncoder(aacEncoder) {
    const allowedBitratesPerEncoder = {
        [types_1.MatroxEncoderAACEncoder.lc]: {
            minAllowedBitrateKbps: 32,
            maxAllowedBitrateKbps: 576
        },
        [types_1.MatroxEncoderAACEncoder.hev1]: {
            minAllowedBitrateKbps: 32,
            maxAllowedBitrateKbps: 288
        },
        [types_1.MatroxEncoderAACEncoder.hev2]: {
            minAllowedBitrateKbps: 32,
            maxAllowedBitrateKbps: 144
        }
    };
    return allowedBitratesPerEncoder[aacEncoder];
}
exports.MATROX_ENCODER_VIDEO_CAPTURE_RATE_MIN = 1;
exports.MATROX_ENCODER_VIDEO_CAPTURE_RATE_MAX = 60;
exports.MATROX_ENCODER_VIDEO_OPACITY_PERCENTAGE_MIN = 0;
exports.MATROX_ENCODER_VIDEO_OPACITY_PERCENTAGE_MAX = 100;
exports.MATROX_ENCODER_VIDEO_BRIGHTNESS_MIN = 0;
exports.MATROX_ENCODER_VIDEO_BRIGHTNESS_MAX = 1000;
exports.MATROX_ENCODER_VIDEO_CONTRAST_MIN = 0;
exports.MATROX_ENCODER_VIDEO_CONTRAST_MAX = 1000;
exports.MATROX_ENCODER_VIDEO_HUE_MIN = 0;
exports.MATROX_ENCODER_VIDEO_HUE_MAX = 360;
exports.MATROX_ENCODER_VIDEO_SATURATION_MIN = 0;
exports.MATROX_ENCODER_VIDEO_SATURATION_MAX = 1000;
exports.MATROX_ENCODER_FRAMESIZE_MIN = 64;
exports.MATROX_ENCODER_FRAMESIZE_MAX = 4096;
exports.MATROX_ENCODER_FRAMEWIDTH_MULTIPLIER = 16;
exports.MATROX_ENCODER_FRAMEHEIGHT_MULTIPLIER = 2;
exports.MATROX_ENCODER_VBR_TARGET_BITRATE_MIN = 0.05;
exports.MATROX_ENCODER_CBR_TARGET_BITRATE_MIN = 7;
exports.MATROX_ENCODER_MAXBITRATE_MIN = 0.1;
exports.MATROX_ENCODER_MAXBITRATE_MAX = 120;
exports.MATROX_ENCODER_QP_MIN = 0;
exports.MATROX_ENCODER_QP_CONSTANT_BITRATE_MAX = 51;
exports.MATROX_ENCODER_QP_VARIABLE_BITRATE_MAX = 42;
exports.MATROX_ENCODER_IFRAME_INTERVAL_MIN = 1;
exports.MATROX_ENCODER_IFRAME_INTERVAL_MAX = 600;
exports.MATROX_ENCODER_IFRAME_INTERVAL_MULTIPLIER = 4;
exports.MATROX_ENCODER_PFRAME_INTERVAL_MIN = 1;
exports.MATROX_ENCODER_PFRAME_INTERVAL_MAX = 4;
exports.MATROX_ENCODER_MIN_ALLOWED_AUDIOSTREAMS = 1;
function validateMatroxEncoderConfig(encoderConfig) {
    function validateProcessorSettings(processorSettings) {
        function validateVideoSourceSettings({ frameCaptureRate, opacityPercentage, brightness, contrast, hue, saturation }) {
            if (frameCaptureRate < exports.MATROX_ENCODER_VIDEO_CAPTURE_RATE_MIN) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `frameCaptureRate must be greater than or equal to ${exports.MATROX_ENCODER_VIDEO_CAPTURE_RATE_MIN}`);
            if (frameCaptureRate > exports.MATROX_ENCODER_VIDEO_CAPTURE_RATE_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `frameCaptureRate must be less than or equal to ${exports.MATROX_ENCODER_VIDEO_CAPTURE_RATE_MAX}`);
            if (opacityPercentage < exports.MATROX_ENCODER_VIDEO_OPACITY_PERCENTAGE_MIN) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `opacityPercentage must be greater than or equal to ${exports.MATROX_ENCODER_VIDEO_OPACITY_PERCENTAGE_MIN}`);
            if (opacityPercentage > exports.MATROX_ENCODER_VIDEO_OPACITY_PERCENTAGE_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `opacityPercentage must be less than or equal to ${exports.MATROX_ENCODER_VIDEO_OPACITY_PERCENTAGE_MAX}`);
            if (brightness < exports.MATROX_ENCODER_VIDEO_BRIGHTNESS_MIN) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `brightness must be greater than or equal to ${exports.MATROX_ENCODER_VIDEO_BRIGHTNESS_MIN}`);
            if (brightness > exports.MATROX_ENCODER_VIDEO_BRIGHTNESS_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `brightness must be less than or equal to ${exports.MATROX_ENCODER_VIDEO_BRIGHTNESS_MAX}`);
            if (contrast < exports.MATROX_ENCODER_VIDEO_CONTRAST_MIN) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `contrast must be greater than or equal to ${exports.MATROX_ENCODER_VIDEO_CONTRAST_MIN}`);
            if (contrast > exports.MATROX_ENCODER_VIDEO_CONTRAST_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `contrast must be less than or equal to ${exports.MATROX_ENCODER_VIDEO_CONTRAST_MAX}`);
            if (hue < exports.MATROX_ENCODER_VIDEO_HUE_MIN) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `hue must be greater than or equal to ${exports.MATROX_ENCODER_VIDEO_HUE_MIN}`);
            if (hue > exports.MATROX_ENCODER_VIDEO_HUE_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `hue must be less than or equal to ${exports.MATROX_ENCODER_VIDEO_HUE_MAX}`);
            if (saturation < exports.MATROX_ENCODER_VIDEO_SATURATION_MIN) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `saturation must be greater than or equal to ${exports.MATROX_ENCODER_VIDEO_SATURATION_MIN}`);
            if (saturation > exports.MATROX_ENCODER_VIDEO_SATURATION_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `saturation must be less than or equal to ${exports.MATROX_ENCODER_VIDEO_SATURATION_MAX}`);
        }
        const { followVideoSourceInput, videoLayout, videoSourceSettings, overriddenCanvasSettings } = processorSettings;
        const canFollowVideoSourceInput = videoLayout === 'single';
        const numberOfVideoSources = videoLayout === 'single' ? 1 : 4;
        if (!canFollowVideoSourceInput && followVideoSourceInput) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `'followVideoSourceInput' cannot be true when ingesting multiple video sources`);
        if (videoSourceSettings?.length !== numberOfVideoSources) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `one videoSourceSettings-entry per video source must be supplied`);
        for (const setting of videoSourceSettings)validateVideoSourceSettings(setting);
        if (!followVideoSourceInput) {
            if (!overriddenCanvasSettings) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `overriddenCanvasSettings must be supplied when 'followVideoSourceInput' is false`);
            const { frameSize: { width, height }, backgroundColor: { red, green, blue, alpha } } = overriddenCanvasSettings;
            const minSize = exports.MATROX_ENCODER_FRAMESIZE_MIN;
            const maxSize = exports.MATROX_ENCODER_FRAMESIZE_MAX;
            if (width < minSize || width > maxSize) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Frame size width must be between ${minSize}-${maxSize}`);
            if (width % exports.MATROX_ENCODER_FRAMEWIDTH_MULTIPLIER !== 0) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Frame size width must be a multiple of ${exports.MATROX_ENCODER_FRAMEWIDTH_MULTIPLIER}`);
            if (height < minSize || height > maxSize) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Frame size height must be between ${minSize}-${maxSize}`);
            if (height % exports.MATROX_ENCODER_FRAMEHEIGHT_MULTIPLIER !== 0) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Frame size height must be a multiple of ${exports.MATROX_ENCODER_FRAMEHEIGHT_MULTIPLIER}`);
            const minRgb = 0;
            const maxRgb = 255;
            if ([
                red,
                green,
                blue,
                alpha
            ].some((rgba)=>rgba < minRgb || rgba > maxRgb)) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `backgroundColor RGBA values must be between ${minRgb}-${maxRgb}`);
        }
    }
    function validateEncoderSettings(encoderSettings, processorPixelFormat) {
        function validateVideoSettings(videoSettings, processorPixelFormat) {
            const { forceEncodingSize, forcedEncodingSettings, forcePixelFormat, forcedPixelFormat, encodingProfile, targetBitrateMbps, gop, rateControl } = videoSettings;
            if (forcePixelFormat) {
                if (!forcedPixelFormat) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `forcedPixelFormat must be provided when 'forcePixelFormat' is true`);
            }
            // pixelFormat will be 'undefined' if processor::useVideoSourceSettings == true && encoder::forcePixelFormat == false.
            // If 'undefined' the pixel format being received on the SDI port will be used - we cannot validate this during creation since
            // we don't have access to that information.
            const selectedPixelFormat = forcePixelFormat ? forcedPixelFormat : processorPixelFormat;
            if (selectedPixelFormat) {
                const allowedProfilesForPixelFormat = getCompatibleMatroxVideoProfilesForPixelFormat(selectedPixelFormat);
                if (allowedProfilesForPixelFormat.length > 0 && !allowedProfilesForPixelFormat.includes(encodingProfile)) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `The selected encoding profile '${encodingProfile}' is not compatible with the selected pixel format '${selectedPixelFormat}. Supported profiles are: ${allowedProfilesForPixelFormat.join(',')}'`);
            } else {
                const requiredEncodingProfile = types_1.MatroxEncoderVideoProfile.High422;
                if (encodingProfile !== requiredEncodingProfile) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `The encoding profile '${encodingProfile}' must be: ${requiredEncodingProfile} when pixel format is unspecified (i.e. when applying the video input source settings)`);
            }
            if (forceEncodingSize) {
                if (!forcedEncodingSettings) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `forcedEncodingSettings must be provided when 'forceEncodingSize' is true`);
                const { frameSize: { width, height } } = forcedEncodingSettings;
                if (width < exports.MATROX_ENCODER_FRAMESIZE_MIN || width > exports.MATROX_ENCODER_FRAMESIZE_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Frame size width must be between ${exports.MATROX_ENCODER_FRAMESIZE_MIN}-${exports.MATROX_ENCODER_FRAMESIZE_MAX}`);
                if (width % exports.MATROX_ENCODER_FRAMEWIDTH_MULTIPLIER !== 0) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Frame size width must be a multiple of ${exports.MATROX_ENCODER_FRAMEWIDTH_MULTIPLIER}`);
                if (height < exports.MATROX_ENCODER_FRAMESIZE_MIN || height > exports.MATROX_ENCODER_FRAMESIZE_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Frame size height must be between ${exports.MATROX_ENCODER_FRAMESIZE_MIN}-${exports.MATROX_ENCODER_FRAMESIZE_MAX}`);
                if (height % exports.MATROX_ENCODER_FRAMEHEIGHT_MULTIPLIER !== 0) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Frame size height must be a multiple of ${exports.MATROX_ENCODER_FRAMEHEIGHT_MULTIPLIER}`);
            }
            const { iFrameInterval, pFrameInterval } = gop;
            if (iFrameInterval < exports.MATROX_ENCODER_IFRAME_INTERVAL_MIN || iFrameInterval > exports.MATROX_ENCODER_IFRAME_INTERVAL_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `I-frame interval must be between ${exports.MATROX_ENCODER_IFRAME_INTERVAL_MIN}-${exports.MATROX_ENCODER_IFRAME_INTERVAL_MAX}`);
            if (iFrameInterval % exports.MATROX_ENCODER_IFRAME_INTERVAL_MULTIPLIER !== 0) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `I-frame interval must be a multiple of ${exports.MATROX_ENCODER_IFRAME_INTERVAL_MULTIPLIER}`);
            if (iFrameInterval < pFrameInterval) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `I-frame interval cannot be less than the P-frame interval`);
            if (pFrameInterval < exports.MATROX_ENCODER_PFRAME_INTERVAL_MIN || pFrameInterval > exports.MATROX_ENCODER_PFRAME_INTERVAL_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `P-frame interval must be between ${exports.MATROX_ENCODER_PFRAME_INTERVAL_MIN}-${exports.MATROX_ENCODER_PFRAME_INTERVAL_MAX}`);
            const { quantizationMin, quantizationMax, maxBitrateMbps, bitrateControl } = rateControl;
            if (quantizationMin < exports.MATROX_ENCODER_QP_MIN) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `QP-min must be larger than or equal to ${exports.MATROX_ENCODER_QP_MIN}`);
            const maxAllowedQpValue = maxAllowedMatroxQpMaxValue(bitrateControl);
            if (quantizationMax > maxAllowedQpValue) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `QP-max must be smaller than or equal to ${maxAllowedQpValue} for bitrate control mode '${bitrateControl}'`);
            if (quantizationMin > quantizationMax) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `QP-min cannot be larger than QP-max (${quantizationMax}) and QP-max cannot be smaller than QP-min (${quantizationMin})`);
            const isVBR = bitrateControl === types_1.MatroxEncoderBitrateControlMode.variable;
            const minTargetBitrate = isVBR ? exports.MATROX_ENCODER_VBR_TARGET_BITRATE_MIN : exports.MATROX_ENCODER_CBR_TARGET_BITRATE_MIN;
            if (targetBitrateMbps < minTargetBitrate || targetBitrateMbps > exports.MATROX_ENCODER_MAXBITRATE_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `targetBitrateMbps in mode ${isVBR ? 'VBR' : 'CBR'} must be between ${minTargetBitrate}-${exports.MATROX_ENCODER_MAXBITRATE_MAX}`);
            if (isVBR) {
                // maxBitrate only applicable for VBR streams
                if (maxBitrateMbps < targetBitrateMbps) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `targetBitrateMbps cannot be greater than maxBitrateMbps`);
                if (maxBitrateMbps < exports.MATROX_ENCODER_MAXBITRATE_MIN || maxBitrateMbps > exports.MATROX_ENCODER_MAXBITRATE_MAX) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `maxBitrateMbps must be between ${exports.MATROX_ENCODER_MAXBITRATE_MIN}-${exports.MATROX_ENCODER_MAXBITRATE_MAX}`);
            }
        }
        function validateAudioSettings(audioSettings) {
            const { aacEncoder, bitrateKbps } = audioSettings;
            const bitrateConstraints = getAllowedBitratesForMatroxAACEncoder(aacEncoder);
            if (bitrateConstraints) {
                const { minAllowedBitrateKbps, maxAllowedBitrateKbps } = bitrateConstraints;
                if (bitrateKbps < minAllowedBitrateKbps || bitrateKbps > maxAllowedBitrateKbps) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `bitrateKbps must be between ${minAllowedBitrateKbps}-${maxAllowedBitrateKbps} for aac encoder ${aacEncoder}`);
            }
        }
        validateVideoSettings(encoderSettings.videoSettings, processorPixelFormat);
        validateAudioSettings(encoderSettings.audioSettings);
    }
    function validateTSOutputSettings(outputStreamSettings, followVideoSourceInput) {
        if (!followVideoSourceInput && outputStreamSettings.isAncEnabled) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Can only stream ancillary data if follow video input source is enabled`);
        if (outputStreamSettings.selectedAudioPairs.length < exports.MATROX_ENCODER_MIN_ALLOWED_AUDIOSTREAMS) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Must select a minimum of one audio pair`);
    }
    validateProcessorSettings(encoderConfig.processorSettings);
    validateEncoderSettings(encoderConfig.encoderSettings, encoderConfig.processorSettings.followVideoSourceInput ? undefined : encoderConfig.processorSettings.overriddenCanvasSettings.pixelFormat);
    validateTSOutputSettings(encoderConfig.tsOutputSettings, encoderConfig.processorSettings.followVideoSourceInput);
}
function maxAllowedMatroxQpMaxValue(bitrateControl) {
    return bitrateControl === types_1.MatroxEncoderBitrateControlMode.constant ? exports.MATROX_ENCODER_QP_CONSTANT_BITRATE_MAX : exports.MATROX_ENCODER_QP_VARIABLE_BITRATE_MAX;
}
function validateGeneralEncoderSettings(encoderFeatures, encoderSettings) {
    if (!encoderFeatures) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Appliance does not have encoder support`);
    const videoCodec = encoderSettings.videoCodec;
    const supportedCodec = encoderFeatures.video.codecs.find((supportedVideoCodec)=>videoCodec == supportedVideoCodec.name);
    if (!supportedCodec) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Appliance does not support video codec ${videoCodec}`);
    if (supportedCodec.bitrate.max < encoderSettings.totalBitrate) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Appliance supports a maximum bitrate of ${(0, helpers_1.formatBitrate)(supportedCodec.bitrate.max)} when using video codec ${videoCodec}`);
    if (supportedCodec.bitrate.min > encoderSettings.totalBitrate) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Appliance supports a minimum bitrate of ${(0, helpers_1.formatBitrate)(supportedCodec.bitrate.min)} when using video codec ${videoCodec}`);
    if (encoderSettings.videoFlags) for (const [videoFlag, enabled] of Object.entries(encoderSettings.videoFlags)){
        const applianceFeatureEncoderVideoFlag = encoderFeatures.video.flags?.find((encoderVideoFlag)=>encoderVideoFlag.value === videoFlag);
        if (enabled && applianceFeatureEncoderVideoFlag?.disabledForCodecs.includes(videoCodec)) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `${videoCodec} does not support enabling ${videoFlag}.`);
    }
    if (encoderSettings.audioStreams.length > encoderFeatures.audio.maxAudioStreams) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Appliance supports a maximum of ${encoderFeatures.audio.maxAudioStreams} audio streams`);
    for (const audioStream of encoderSettings.audioStreams){
        const supportedAudioCodec = encoderFeatures.audio.codecs.find((audioCodec)=>audioCodec.name == audioStream.codec);
        if (!supportedAudioCodec) {
            const indexOfAudioStream = encoderSettings.audioStreams.indexOf(audioStream);
            throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Appliance does not support audio codec ${audioStream.codec} used by audio stream ${indexOfAudioStream + 1}`);
        }
        const supportedBitrates = supportedAudioCodec.bitratesKbps;
        if (supportedBitrates.length > 0 && !supportedBitrates.includes(audioStream.bitrate)) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Appliance only supports audio bitrates ${supportedBitrates.join(', ')} when using audio codec ${audioStream.codec}`);
        const supportedBitDepths = supportedAudioCodec.bitDepth ?? [];
        if (audioStream.bitDepth && supportedBitDepths.length > 0 && !supportedBitDepths.includes(audioStream.bitDepth)) throw new errors_1.BadRequestError(errors_1.ErrorCode.badRequest, `Appliance only supports audio bit depths ${supportedBitDepths.join(', ')} when using audio codec ${audioStream.codec}`);
    }
}

},{"5331e88b15e72453":"3qemx","64aa47dcaad7952f":"lwLel","da87100169272835":"6jovr","c66a9b46e4c0ac2a":"4mxaf","8992e7fcac075789":"it4bJ"}],"j9Iye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _types = require("common/api/v1/types");
var _form = require("./Form");
var _audioStream = require("../inputs/Edit/AudioStream");
var _audioStreamDefault = parcelHelpers.interopDefault(_audioStream);
var _util = require("common/util");
var _helpers = require("common/api/v1/helpers");
var _reactHookForm = require("react-hook-form");
const initialAudioStream = {
    codec: '',
    pair: '',
    bitrate: '',
    type: 'stereo',
    bitDepth: ''
};
const AudioStreamsPick = ({ fields, remove, update, supportedCodecs, customPid, namePrefix })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        size: {
            xs: 12
        },
        children: fields.map((field, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _audioStreamDefault.default), {
                index: index,
                audioStream: field,
                namePrefix: `${namePrefix}.audioStreams.${index}`,
                supportedCodecs: supportedCodecs,
                customPid: customPid,
                onRemove: ()=>remove(index),
                onUpdate: (value)=>update(index, value)
            }, field.id))
    });
};
function makeOptions(propertyName, codecFeatures, encoderSettings) {
    const allOptions = codecFeatures?.[propertyName];
    if (!allOptions || !Array.isArray(allOptions) || allOptions.length === 0) return [];
    const allowedOptions = (0, _helpers.applyCodecRestrictions)(allOptions, propertyName, encoderSettings, codecFeatures?.restrictions);
    return allOptions.map((o)=>{
        const hasNameAndValue = (0, _helpers.isNameValueOption)(o);
        const name = hasNameAndValue ? o.name : o.toString();
        const value = hasNameAndValue ? o.value : o;
        const disabled = !allowedOptions.some((allowed)=>value === ((0, _helpers.isNameValueOption)(allowed) ? allowed.value : allowed));
        return {
            name,
            value,
            disabled
        };
    });
}
const GeneralEncoderDecoderSettings = ({ namePrefix, encoderFeatures, decoderFeatures })=>{
    const capabilities = encoderFeatures ?? decoderFeatures;
    if (!capabilities) throw new Error(`Missing props encoderFeatures and decoderFeatures`);
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const encoderSettings = getValues(namePrefix);
    if ('type' in encoderSettings) throw new Error('Invalid encoder settings type: ' + encoderSettings.type);
    const { fields: audioStreamFields, append: appendAudioStreamField, update: updateAudioStreamField, remove: removeAudioStreamField, replace: replaceAudioStreamField } = (0, _reactHookForm.useFieldArray)({
        name: `${namePrefix}.audioStreams`
    });
    const maxNumberOfAudioStreamsAllowed = capabilities.audio.maxAudioStreams ?? 8;
    const canAddAudioStream = audioStreamFields.length < maxNumberOfAudioStreamsAllowed;
    const customVideoPid = capabilities.video.customPid;
    const codecKey = `${namePrefix}.videoCodec`;
    watch(codecKey);
    const selectedVideoCodec = encoderSettings.videoCodec;
    const codecOptions = capabilities.video.codecs?.map((c)=>({
            name: c.name == (0, _types.RawVideo) ? 'Uncompressed' : c.name,
            value: c.name
        })) ?? [];
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(codecKey, selectedVideoCodec, codecOptions), [
        selectedVideoCodec,
        codecOptions
    ]);
    const codecFeatures = capabilities.video.codecs.find((c)=>c.name == selectedVideoCodec);
    const profileKey = `${namePrefix}.profile`;
    watch(profileKey);
    const selectedProfile = encoderSettings.profile;
    const profileOptions = makeOptions('profile', codecFeatures, encoderSettings);
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(profileKey, selectedProfile, profileOptions), [
        selectedProfile,
        profileOptions
    ]);
    const pixelFormatKey = `${namePrefix}.pixelFormat`;
    const selectedPixelFormat = encoderSettings.pixelFormat;
    const pixelFormatOptions = makeOptions('pixelFormat', codecFeatures, encoderSettings);
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(pixelFormatKey, selectedPixelFormat, pixelFormatOptions), [
        selectedPixelFormat,
        pixelFormatOptions
    ]);
    const resolutionKey = `${namePrefix}.resolution`;
    const selectedResolution = encoderSettings.resolution;
    const resolutionOptions = makeOptions('resolution', codecFeatures, encoderSettings);
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(resolutionKey, selectedResolution, resolutionOptions), [
        selectedResolution,
        resolutionOptions
    ]);
    const scanRateKey = `${namePrefix}.scanRate`;
    const selectedScanRate = encoderSettings.scanRate;
    const scanRateOptions = makeOptions('scanRate', codecFeatures, encoderSettings);
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(scanRateKey, selectedScanRate, scanRateOptions), [
        selectedScanRate,
        scanRateOptions
    ]);
    const scanKey = `${namePrefix}.scan`;
    const selectedScan = encoderSettings.scan;
    const scanOptions = makeOptions('scan', codecFeatures, encoderSettings);
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(scanKey, selectedScan, scanOptions), [
        selectedScan,
        scanOptions
    ]);
    const bitDepthKey = `${namePrefix}.bitDepth`;
    const selectedBitDepth = encoderSettings.bitDepth;
    const bitDepthOptions = makeOptions('bitDepth', codecFeatures, encoderSettings);
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(bitDepthKey, selectedBitDepth, bitDepthOptions), [
        selectedBitDepth,
        bitDepthOptions
    ]);
    const colorSamplingKey = `${namePrefix}.colorSampling`;
    const selectedColorSampling = encoderSettings.colorSampling;
    const colorSamplingOptions = makeOptions('colorSampling', codecFeatures, encoderSettings);
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(colorSamplingKey, selectedColorSampling, colorSamplingOptions), [
        selectedColorSampling,
        colorSamplingOptions
    ]);
    const latencyModeKey = `${namePrefix}.latencyMode`;
    const selectedLatencyMode = encoderSettings.latencyMode;
    const latencyModeOptions = capabilities.video.latencyModes ?? [];
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(latencyModeKey, selectedLatencyMode, latencyModeOptions), [
        selectedLatencyMode,
        latencyModeOptions
    ]);
    const scalingModeKey = `${namePrefix}.scalingMode`;
    const selectedScalingMode = encoderSettings.scalingMode;
    const scalingModeOptions = capabilities.video.scalingModes ?? [];
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(scalingModeKey, selectedScalingMode, scalingModeOptions), [
        selectedScalingMode,
        scalingModeOptions
    ]);
    const gopStructureKey = `${namePrefix}.gopStructure`;
    const selectedGopStructure = encoderSettings.gopStructure;
    const gopStructureOptions = makeOptions('gopStructures', codecFeatures, encoderSettings);
    gopStructureOptions.unshift({
        name: '(Default)',
        value: '',
        disabled: false
    });
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(gopStructureKey, selectedGopStructure, gopStructureOptions), [
        selectedGopStructure,
        gopStructureOptions
    ]);
    const scte35Support = codecFeatures?.scte35Insertion;
    const videoFlags = capabilities.video.flags || [];
    const enabledVideoFlags = videoFlags.filter((flag)=>codecFeatures !== undefined && !flag.disabledForCodecs.includes((0, _util.assertExclude)(codecFeatures?.name, (0, _types.RawVideo))));
    for (const flag of videoFlags){
        if (!(flag.value in (encoderSettings?.videoFlags || {})) || !enabledVideoFlags.includes(flag)) {
            if (encoderSettings) {
                if (!encoderSettings.videoFlags) encoderSettings.videoFlags = {};
                encoderSettings.videoFlags[flag.value] = false;
            }
        }
    }
    (0, _react.useEffect)(()=>{
        const hasTooManyAudioStreams = audioStreamFields.length > maxNumberOfAudioStreamsAllowed;
        if (hasTooManyAudioStreams) replaceAudioStreamField(audioStreamFields.slice(0, maxNumberOfAudioStreamsAllowed));
    }, [
        audioStreamFields,
        maxNumberOfAudioStreamsAllowed,
        replaceAudioStreamField
    ]);
    const ensureSelectedValueIsAvailable = (0, _react.useCallback)((formDataFieldKey, currentValue, availableValues)=>{
        const isCurrentlySelectedOptionAvailable = availableValues.filter((o)=>!o.disabled).map((o)=>o.value).includes(currentValue);
        const firstAvailableValue = availableValues[0]?.value;
        if (!isCurrentlySelectedOptionAvailable && firstAvailableValue !== undefined) setValue(formDataFieldKey, firstAvailableValue, {
            shouldValidate: true
        });
    }, [
        setValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                id: "general-encoder-settings",
                className: "outlined",
                title: `${encoderFeatures ? 'Encoder' : 'Decoder'} Settings`,
                collapsible: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        xs: 12
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Video codec",
                                name: codecKey,
                                required: true,
                                options: codecOptions,
                                disabled: !!selectedVideoCodec && codecOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(codecOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            profileOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Profile",
                                name: profileKey,
                                required: true,
                                options: profileOptions,
                                disabled: !!selectedProfile && profileOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(profileOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            pixelFormatOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Pixel format",
                                name: pixelFormatKey,
                                required: true,
                                options: pixelFormatOptions,
                                disabled: !!selectedPixelFormat && pixelFormatOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(pixelFormatOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            resolutionOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Resolution",
                                name: resolutionKey,
                                required: true,
                                options: resolutionOptions,
                                disabled: !!selectedResolution && resolutionOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(resolutionOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            scanRateOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Frame rate",
                                name: scanRateKey,
                                required: true,
                                options: scanRateOptions,
                                disabled: !!selectedScanRate && scanRateOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(scanRateOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            scanOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Scan",
                                name: scanKey,
                                required: true,
                                options: scanOptions,
                                disabled: !!selectedScan && scanOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(scanOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            bitDepthOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Bit depth",
                                name: bitDepthKey,
                                required: true,
                                options: bitDepthOptions,
                                disabled: !!selectedBitDepth && bitDepthOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(bitDepthOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            colorSamplingOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Color sampling",
                                name: colorSamplingKey,
                                required: true,
                                options: colorSamplingOptions,
                                disabled: !!selectedColorSampling && colorSamplingOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(colorSamplingOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            latencyModeOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Latency mode",
                                name: latencyModeKey,
                                required: true,
                                options: latencyModeOptions,
                                disabled: !!selectedLatencyMode && latencyModeOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(latencyModeOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            scalingModeOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Scaling mode",
                                name: scalingModeKey,
                                required: true,
                                options: scalingModeOptions,
                                disabled: !!selectedScalingMode && scalingModeOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(scalingModeOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            selectedVideoCodec !== (0, _types.RawVideo) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                label: "Total bitrate (Mbps)",
                                name: `${namePrefix}.totalBitrate`,
                                required: true,
                                type: "number",
                                noNegative: true,
                                validators: {
                                    number: {
                                        greaterThanOrEqualTo: 1,
                                        lessThanOrEqualTo: 60,
                                        message: `Must be 1 - 60`,
                                        noStrings: false
                                    }
                                }
                            }),
                            selectedVideoCodec !== (0, _types.RawVideo) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: `${namePrefix}.gopSizeFrames`,
                                label: "GOP Size Frames",
                                required: true,
                                type: "number",
                                noNegative: true,
                                validators: {
                                    numericality: {
                                        greaterThanOrEqualTo: 1,
                                        lessThanOrEqualTo: 500,
                                        message: `Must be 1 - 500`,
                                        noStrings: false
                                    }
                                }
                            }),
                            customVideoPid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: `${namePrefix}.videoPid`,
                                label: "Video PID",
                                type: "number",
                                validators: {
                                    pid: {}
                                }
                            }),
                            gopStructureOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "GOP structure",
                                name: gopStructureKey,
                                options: gopStructureOptions,
                                disabled: !!selectedGopStructure && gopStructureOptions.length === 1,
                                validators: {
                                    oneOf: {
                                        validValues: new Set(gopStructureOptions.filter((o)=>!o.disabled).map((o)=>o.value))
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                disabled: !scte35Support,
                                name: `${namePrefix}.enableScte35`,
                                label: 'Enable SCTE-104/35'
                            }),
                            encoderSettings.enableScte35 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: `${namePrefix}.scte35Pid`,
                                label: "SCTE-35 PID",
                                disabled: !scte35Support?.customPid,
                                type: "number",
                                validators: {
                                    pid: {}
                                }
                            }),
                            encoderSettings?.videoFlags && enabledVideoFlags.map((flag)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                    disabled: codecFeatures !== undefined && flag.disabledForCodecs.includes((0, _util.assertExclude)(codecFeatures.name, (0, _types.RawVideo))),
                                    name: `${namePrefix}.videoFlags.${flag.value}`,
                                    label: flag.name
                                }, flag.value))
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                className: "outlined",
                title: "Audio Streams",
                collapsible: true,
                actionsPane: canAddAudioStream ? [
                    {
                        title: 'Add Audio Stream',
                        onClick: ()=>appendAudioStreamField(initialAudioStream),
                        id: 'add-audio-btn'
                    }
                ] : [],
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AudioStreamsPick, {
                    fields: audioStreamFields,
                    remove: removeAudioStreamField,
                    update: (i, data)=>{
                        updateAudioStreamField(i, data);
                    },
                    supportedCodecs: capabilities.audio.codecs || [],
                    customPid: !!capabilities.audio.customPid,
                    namePrefix: namePrefix
                })
            })
        ]
    });
};
exports.default = GeneralEncoderDecoderSettings;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Grid":"6iX4B","common/api/v1/types":"3qemx","./Form":"4Mui7","../inputs/Edit/AudioStream":"3Mmt4","common/util":"jV4UZ","common/api/v1/helpers":"6jovr","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Mmt4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _types = require("common/api/v1/types");
var _form = require("../../common/Form");
var _reactHookForm = require("react-hook-form");
const AudioStreamForm = ({ namePrefix, supportedCodecs, customPid, onRemove })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const audioCodecKey = `${namePrefix}.codec`;
    const audioBitrateKey = `${namePrefix}.bitrate`;
    const audioBitDepthKey = `${namePrefix}.bitDepth`;
    const audioPidKey = `${namePrefix}.pid`;
    const audioStream = getValues(namePrefix);
    watch(audioCodecKey);
    const selectedCodec = audioStream.codec;
    const codecFeatures = supportedCodecs.find(({ name })=>name === selectedCodec);
    const codecOptions = supportedCodecs.map((c)=>({
            name: c.name,
            value: c.name
        }));
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(audioCodecKey, selectedCodec, codecOptions), [
        selectedCodec,
        codecOptions
    ]);
    const selectedBitrate = audioStream.bitrate;
    const bitrateOptions = (codecFeatures?.bitratesKbps ?? []).map((b)=>({
            name: b.toString(),
            value: b
        }));
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(audioBitrateKey, selectedBitrate, bitrateOptions), [
        selectedBitrate,
        bitrateOptions
    ]);
    const selectedBitDepth = audioStream.bitDepth;
    const bitDepthOptions = (codecFeatures?.bitDepth ?? []).map((b)=>({
            name: b.toString(),
            value: b
        }));
    (0, _react.useEffect)(()=>ensureSelectedValueIsAvailable(audioBitDepthKey, selectedBitDepth, bitDepthOptions), [
        selectedBitDepth,
        bitDepthOptions
    ]);
    const ensureSelectedValueIsAvailable = (0, _react.useCallback)((formFieldKey, currentValue, availableValues)=>{
        const isCurrentlySelectedOptionAvailable = availableValues.filter((o)=>!o.disabled).map((o)=>o.value).includes(currentValue);
        const firstAvailableValue = availableValues[0]?.value;
        if (!isCurrentlySelectedOptionAvailable && firstAvailableValue !== undefined) setValue(formFieldKey, firstAvailableValue, {
            shouldValidate: true
        });
    }, [
        setValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        children: [
            codecOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Audio Codec",
                name: audioCodecKey,
                required: true,
                options: codecOptions,
                disabled: !!selectedCodec && codecOptions.length === 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Audio Pair",
                name: `${namePrefix}.pair`,
                required: true,
                options: (0, _types.sdiAudioPairs)
            }),
            bitrateOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Audio Bitrate (Kbps)",
                name: audioBitrateKey,
                required: true,
                options: bitrateOptions,
                disabled: !!selectedBitrate && bitrateOptions.length === 1
            }),
            bitDepthOptions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Audio Bit depth",
                name: audioBitDepthKey,
                required: true,
                options: bitDepthOptions,
                disabled: !!selectedBitDepth && bitDepthOptions.length === 1
            }),
            customPid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                label: "Audio PID",
                name: audioPidKey,
                type: "number",
                validators: {
                    pid: {}
                },
                defaultValue: audioStream.pid
            }),
            selectedCodec === (0, _types.AudioCodec).ac3pt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "System standard",
                name: `${namePrefix}.systemStandard`,
                required: true,
                options: Object.values((0, _types.AudioSystemStandard))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                newLine: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "outlined",
                    color: "primary",
                    onClick: onRemove,
                    children: "Remove Audio Stream"
                })
            })
        ]
    });
};
exports.default = AudioStreamForm;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Button":"3qJY9","common/api/v1/types":"3qemx","../../common/Form":"4Mui7","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"mAmIR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortForm", ()=>PortForm);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _types = require("common/api/v1/types");
var _ipPortForm = require("./IpPortForm");
var _ipPortFormDefault = parcelHelpers.interopDefault(_ipPortForm);
var _coaxPortForm = require("./CoaxPortForm/CoaxPortForm");
var _coaxPortFormDefault = parcelHelpers.interopDefault(_coaxPortForm);
var _ndiForm = require("./NdiForm");
var _ndiFormDefault = parcelHelpers.interopDefault(_ndiForm);
var _encoderSettings = require("../EncoderSettings");
var _encoderSettingsDefault = parcelHelpers.interopDefault(_encoderSettings);
var _form = require("../../../common/Form");
const PortForm = ({ physicalPort, isModeDisabled, namePrefix, enforcedPortMode, index, onAddLogicalPortRequested, onRemoveLogicalPortRequested })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            physicalPort.portType === (0, _types.PortType).ip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ipPortFormDefault.default), {
                namePrefix: namePrefix,
                addresses: physicalPort.addresses,
                applianceId: physicalPort.appliance.id,
                applianceType: physicalPort.appliance.type,
                applianceVersion: physicalPort.appliance.version,
                applianceFeatures: physicalPort.appliance.features,
                index: index,
                occupiedPorts: physicalPort.occupiedPorts,
                isModeDisabled: isModeDisabled,
                enforcedPortMode: enforcedPortMode,
                onAddLogicalPortRequested: onAddLogicalPortRequested,
                onRemoveLogicalPortRequested: onRemoveLogicalPortRequested
            }),
            physicalPort.portType === (0, _types.PortType).coax && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coaxPortFormDefault.default), {
                physicalPortIndex: physicalPort.index ?? 'Missing port index',
                namePrefix: namePrefix,
                settings: physicalPort.appliance.settings,
                applianceType: physicalPort.appliance.type,
                applianceFeatures: physicalPort.appliance.features
            }),
            physicalPort.portType === (0, _types.PortType).ndi && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ndiFormDefault.default), {
                namePrefix: namePrefix
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                newLine: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    style: {
                        marginTop: 12
                    },
                    variant: "outlined",
                    color: "primary",
                    onClick: onRemoveLogicalPortRequested,
                    children: "Remove interface"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _encoderSettingsDefault.default), {
                namePrefix: namePrefix,
                applianceFeatures: physicalPort.appliance.features
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Button":"3qJY9","common/api/v1/types":"3qemx","./IpPortForm":"7TpS5","./CoaxPortForm/CoaxPortForm":"9uzed","./NdiForm":"bUkOB","../EncoderSettings":"698u6","../../../common/Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bUkOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../common/Form");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
const NdiForm = ({ namePrefix })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const logicalPort = getValues(namePrefix);
    const modeKey = `${namePrefix}.mode`;
    watch(modeKey);
    const selectedMode = logicalPort.mode;
    const modeOptions = (0, _react.useMemo)(()=>[
            {
                name: 'NDI',
                value: 'comprimatoNdi'
            }
        ], []);
    (0, _react.useEffect)(()=>{
        const defaultMode = modeOptions[0];
        const isValidMode = modeOptions.some((m)=>m.value === selectedMode);
        if (!isValidMode && defaultMode) setValue(modeKey, defaultMode.value);
    }, [
        modeKey,
        setValue,
        modeOptions,
        selectedMode
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Mode",
                name: modeKey,
                xs: 4,
                lg: 4,
                xl: 4,
                required: true,
                newLine: true,
                options: modeOptions,
                disabled: selectedMode ? modeOptions.length === 1 : false,
                validators: {
                    oneOf: {
                        validValues: new Set(modeOptions.filter((o)=>!o.disabled).map(({ value })=>value))
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                xs: 8,
                lg: 8,
                xl: 8,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                    name: `${namePrefix}.name`,
                    label: "Name",
                    required: true
                })
            })
        ]
    });
};
exports.default = NdiForm;

},{"react/jsx-runtime":"1dlk8","../../../common/Form":"4Mui7","react":"9njXz","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"698u6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _generalEncoderDecoderSettings = require("../../common/GeneralEncoderDecoderSettings");
var _generalEncoderDecoderSettingsDefault = parcelHelpers.interopDefault(_generalEncoderDecoderSettings);
var _react = require("react");
var _encoderSettingsUtil = require("common/encoderSettingsUtil");
var _reactHookForm = require("react-hook-form");
var _matrox = require("common/matrox");
function isCorrectEncoderSettingsTypeForPortMode(encoderSettings, mode, applianceFeatures) {
    const isMatroxMode = mode === (0, _types.MatroxPortMode).matroxSdi;
    const modesWithDecoderSettings = applianceFeatures.output?.modes.filter((m)=>!!m.decoder).map((m)=>m.mode) ?? [];
    if (modesWithDecoderSettings.includes(mode) && !isMatroxMode) return encoderSettings && (0, _matrox.isGeneralEncoderSettings)(encoderSettings);
    // Port mode has no support for encoder settings
    // or is Matrox which has its decoder settings embedded in the MatroxSdiPortForm component, presented separately
    // - should be undefined
    return encoderSettings === undefined;
}
function makeEncoderSettings(mode, applianceFeatures) {
    const isMatroxMode = mode === (0, _types.MatroxPortMode).matroxSdi;
    const modesWithDecoderSettings = applianceFeatures.output?.modes.filter((m)=>!!m.decoder).map((m)=>m.mode) ?? [];
    const hasDecoderSettings = modesWithDecoderSettings.includes(mode);
    return isMatroxMode ? undefined // Matrox decoder settings are embedded in the MatroxSdiPortForm component, presented separately.
     : hasDecoderSettings ? (0, _encoderSettingsUtil.makeDefaultVaEncoderSettings)() : undefined;
}
const EncoderSettings = ({ namePrefix, applianceFeatures })=>{
    const { getValues, setValue } = (0, _reactHookForm.useFormContext)();
    const logicalPort = getValues(namePrefix);
    const decoderFeatures = applianceFeatures.output?.modes.find((m)=>m.mode === logicalPort.mode)?.decoder;
    const encoderSettings = logicalPort.encoderSettings;
    (0, _react.useEffect)(()=>{
        if (!isCorrectEncoderSettingsTypeForPortMode(encoderSettings, logicalPort.mode, applianceFeatures)) {
            const newEncoderSettings = makeEncoderSettings(logicalPort.mode, applianceFeatures);
            setValue(`${namePrefix}.encoderSettings`, newEncoderSettings);
        }
    }, [
        encoderSettings,
        logicalPort.mode,
        setValue,
        namePrefix
    ]);
    if (!decoderFeatures) return null;
    if (!encoderSettings) return null;
    if (!isCorrectEncoderSettingsTypeForPortMode(encoderSettings, logicalPort.mode, applianceFeatures)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalEncoderDecoderSettingsDefault.default), {
            namePrefix: `${namePrefix}.encoderSettings`,
            decoderFeatures: decoderFeatures
        })
    });
};
exports.default = EncoderSettings;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../common/GeneralEncoderDecoderSettings":"j9Iye","react":"9njXz","common/encoderSettingsUtil":"aAPl1","react-hook-form":"8z0aI","common/matrox":"4mxaf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2S94R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZixiFields", ()=>ZixiFields);
parcelHelpers.export(exports, "zixiDefaults", ()=>zixiDefaults);
parcelHelpers.export(exports, "getZixiFieldsToSave", ()=>getZixiFieldsToSave);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _versions = require("common/versions");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _reactHookForm = require("react-hook-form");
var ZixiFields = /*#__PURE__*/ function(ZixiFields) {
    ZixiFields["decryptKey"] = "decryptKey";
    ZixiFields["decryptType"] = "decryptType";
    ZixiFields["fecLatency"] = "fecLatency";
    ZixiFields["localIp"] = "localIp";
    ZixiFields["maxFecOverhead"] = "maxFecOverhead";
    ZixiFields["optimizeFec"] = "optimizeFec";
    ZixiFields["adaptiveFec"] = "adaptiveFec";
    ZixiFields["password"] = "password";
    ZixiFields["pullPort"] = "pullPort";
    ZixiFields["reducedBitrateDetection"] = "reducedBitrateDetection";
    ZixiFields["reducedBitrateThreshold"] = "reducedBitrateThreshold";
    ZixiFields["remotePrimaryIp"] = "remotePrimaryIp";
    ZixiFields["remoteSecondaryIp"] = "remoteSecondaryIp";
    ZixiFields["retransmitBuf"] = "retransmitBuf";
    ZixiFields["streamId"] = "streamId";
    ZixiFields["unrecoveredPacketsDetection"] = "unrecoveredPacketsDetection";
    ZixiFields["unrecoveredPacketsThreshold"] = "unrecoveredPacketsThreshold";
    ZixiFields["zixiMode"] = "zixiMode";
    return ZixiFields;
}({});
const zixiDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(ZixiFields), [
        "unrecoveredPacketsDetection",
        "reducedBitrateDetection",
        "optimizeFec",
        "adaptiveFec"
    ], {
        ["retransmitBuf"]: 500,
        ["fecLatency"]: 30,
        ["pullPort"]: 2077,
        ["decryptType"]: (0, _types.ZixiDecryptType).none
    });
const getZixiFieldsToSave = (port)=>[
        "zixiMode",
        "decryptType",
        "decryptKey",
        "streamId",
        "password",
        "reducedBitrateDetection",
        "unrecoveredPacketsDetection",
        ...port.reducedBitrateDetection ? [
            "reducedBitrateThreshold"
        ] : [],
        ...port.unrecoveredPacketsDetection ? [
            "unrecoveredPacketsThreshold"
        ] : [],
        ...port.zixiMode === (0, _types.ZixiMode).pull ? [
            "fecLatency",
            "localIp",
            "maxFecOverhead",
            "optimizeFec",
            "adaptiveFec",
            "pullPort",
            "remotePrimaryIp",
            "remoteSecondaryIp",
            "retransmitBuf"
        ] : []
    ];
const ZixiForm = ({ addresses, namePrefix, applianceType, applianceFeatures, applianceVersion })=>{
    const { getValues, watch } = (0, _reactHookForm.useFormContext)();
    const port = getValues(namePrefix);
    const zixiModeKey = `${namePrefix}.${"zixiMode"}`;
    const decryptTypeKey = `${namePrefix}.${"decryptType"}`;
    const reducedBitrateDetectionKey = `${namePrefix}.${"reducedBitrateDetection"}`;
    const unrecoveredPacketsDetectionKey = `${namePrefix}.${"unrecoveredPacketsDetection"}`;
    // Watch specific fields since they control conditional rendering
    watch(zixiModeKey);
    watch(decryptTypeKey);
    watch(reducedBitrateDetectionKey);
    watch(unrecoveredPacketsDetectionKey);
    const isVa = (0, _applianceTypeUtil.isVaApplianceType)(applianceType);
    const localAddressSelector = `${namePrefix}.${"localIp"}`;
    const addressesAndEmptyAddress = [
        {
            address: '',
            netmask: ''
        },
        ...addresses
    ];
    const addressOptions = [
        {
            name: 'any',
            value: ''
        },
        ...(0, _utils.makeAddressOptions)(getValues(localAddressSelector), addresses)
    ];
    const supportedModes = applianceFeatures.input?.modes.find((m)=>m.mode === (0, _types.IpPortMode).zixi)?.subModes ?? [];
    const isAdaptiveFecSupported = (0, _versions.supportsZixiAdaptiveFec)(applianceType, applianceVersion);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: zixiModeKey,
                label: "Connection mode",
                options: supportedModes,
                required: true,
                tooltip: 'Use "nimbrava" as remote id'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: decryptTypeKey,
                label: "Decryption type",
                required: true,
                options: Object.values((0, _types.ZixiDecryptType)),
                newLine: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"decryptKey"}`,
                label: "Decryption key",
                multiline: true,
                required: port.decryptType !== (0, _types.ZixiDecryptType).none,
                validators: {
                    hexadecimal: {}
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"streamId"}`,
                label: "Stream id",
                required: true,
                newLine: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                name: `${namePrefix}.${"password"}`,
                label: "Password"
            }),
            port.zixiMode === (0, _types.ZixiMode).pull && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        name: localAddressSelector,
                        label: "Local address",
                        options: addressOptions,
                        newLine: true,
                        validators: {
                            addressIn: {
                                addresses: addressesAndEmptyAddress
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"remotePrimaryIp"}`,
                        label: "Remote host (primary)",
                        required: true,
                        validators: {
                            ipOrHostname: {}
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"remoteSecondaryIp"}`,
                        label: "Remote host (secondary)",
                        validators: {
                            ipOrHostname: {}
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"pullPort"}`,
                        label: "Remote UDP port",
                        required: true,
                        type: "number",
                        validators: {
                            port: {
                                isUdp: true
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"retransmitBuf"}`,
                        label: "Retransmission buffer (ms)",
                        type: "number",
                        noNegative: true,
                        newLine: true,
                        required: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: 30000,
                                message: 'Must be no more than 30000'
                            }
                        }
                    }),
                    isVa && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"maxFecOverhead"}`,
                        label: "Max fec overhead (%)",
                        type: "number",
                        noNegative: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: 100,
                                message: 'Must be no more than 100'
                            }
                        }
                    }),
                    isVa && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"fecLatency"}`,
                        label: "Fec latency (ms)",
                        type: "number",
                        noNegative: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: Math.pow(2, 32) - 1,
                                message: `Must be no more than ${Math.pow(2, 32) - 1}`
                            }
                        }
                    }),
                    isAdaptiveFecSupported && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        name: `${namePrefix}.${"adaptiveFec"}`,
                        label: "Adaptive fec",
                        tooltip: 'Enables FEC congestion avoidance'
                    }),
                    !isAdaptiveFecSupported && isVa && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        name: `${namePrefix}.${"optimizeFec"}`,
                        label: "Optimize fec"
                    })
                ]
            }),
            isVa && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        name: reducedBitrateDetectionKey,
                        label: "Reduced bitrate alarm",
                        newLine: true,
                        tooltip: "Raise alarm when bitrate is below or equal (kbps)."
                    }),
                    port.reducedBitrateDetection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"reducedBitrateThreshold"}`,
                        label: "Bitrate (kbps)",
                        type: "number",
                        noNegative: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: Math.pow(2, 64),
                                message: `Must be no more than ${Math.pow(2, 64)}`
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        name: unrecoveredPacketsDetectionKey,
                        label: "Unrecovered packets alarm",
                        tooltip: "Turn detection of unrecovered packets on or off, including associated alarm. Threshold is in packets per minute. Generates an alarm if unrecovered packets per minute is higher than threshold.",
                        newLine: true
                    }),
                    port.unrecoveredPacketsDetection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"unrecoveredPacketsThreshold"}`,
                        label: "Threshold (packets/min)",
                        type: "number",
                        noNegative: true,
                        validators: {
                            number: {
                                lessThanOrEqualTo: Math.pow(2, 64),
                                message: `Must be no more than ${Math.pow(2, 64)}`
                            }
                        }
                    })
                ]
            })
        ]
    });
};
exports.default = ZixiForm;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","common/versions":"4vuwV","common/applianceTypeUtil":"3z9on","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aZU4b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RistFields", ()=>RistFields);
parcelHelpers.export(exports, "ristDefaults", ()=>ristDefaults);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _whitelistCidrBlockAutoComplete = require("../../../../common/WhitelistCidrBlockAutoComplete");
var _suggestedPortTextField = require("../../../../common/SuggestedPortTextField");
var _reactHookForm = require("react-hook-form");
var RistFields = /*#__PURE__*/ function(RistFields) {
    RistFields["profile"] = "profile";
    RistFields["address"] = "address";
    RistFields["port"] = "port";
    RistFields["whitelistCidrBlock"] = "whitelistCidrBlock";
    return RistFields;
}({});
const ristDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(RistFields), [], {
        ["whitelistCidrBlock"]: []
    });
const RistForm = ({ addresses, namePrefix, occupiedPorts, adminStatus, applianceType })=>{
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const addressSelector = `${namePrefix}.${"address"}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"profile"}`,
                label: "Profile",
                options: [
                    (0, _types.RistProfile).simple
                ],
                required: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: addressSelector,
                label: "Address",
                required: true,
                options: (0, _utils.makeAddressOptions)(getValues(addressSelector), addresses),
                newLine: true,
                validators: {
                    addressIn: {
                        addresses
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _suggestedPortTextField.SuggestedLocalPortTextField), {
                name: `${namePrefix}.${"port"}`,
                label: 'Port',
                namePrefix: namePrefix,
                required: true,
                portInfo: {
                    mode: (0, _types.IpPortMode).rist,
                    isInput: true,
                    existingLogicalPortsOnSameNic: occupiedPorts,
                    isPortDisabled: adminStatus === (0, _types.InputAdminStatus).off
                }
            }),
            !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _whitelistCidrBlockAutoComplete.WhitelistCidrBlockAutoComplete), {
                name: `${namePrefix}.${"whitelistCidrBlock"}`,
                required: (0, _utils.isCoreNode)(applianceType)
            })
        ]
    });
};
exports.default = RistForm;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","common/applianceTypeUtil":"3z9on","../../../../common/WhitelistCidrBlockAutoComplete":"91kUs","../../../../common/SuggestedPortTextField":"1iSAC","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bJIqn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeneratorFields", ()=>GeneratorFields);
parcelHelpers.export(exports, "generatorDefaults", ()=>generatorDefaults);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _defaults = require("common/api/defaults");
var _form = require("../../../../common/Form");
var _utils = require("../../../../../utils");
var _react = require("react");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _helpers = require("common/api/v1/helpers");
var _reactHookForm = require("react-hook-form");
var GeneratorFields = /*#__PURE__*/ function(GeneratorFields) {
    GeneratorFields["address"] = "address";
    GeneratorFields["port"] = "port";
    GeneratorFields["bitrate"] = "bitrate";
    GeneratorFields["audioOnly"] = "audioOnly";
    GeneratorFields["resolution"] = "resolution";
    GeneratorFields["scanMode"] = "scanMode";
    GeneratorFields["frameRate"] = "frameRate";
    GeneratorFields["timestampResolution"] = "timestampResolution";
    GeneratorFields["programs"] = "programs";
    return GeneratorFields;
}({});
const generatorDefaults = ()=>(0, _utils.createDefaultFiledValues)(Object.keys(GeneratorFields), [
        'audioOnly'
    ], {
        resolution: (0, _defaults.defaultResolution),
        frameRate: (0, _defaults.defaultFrameRate),
        scanMode: (0, _defaults.defaultScanMode),
        timestampResolution: (0, _defaults.defaultTimestampResolution),
        bitrate: {
            type: 'vbr',
            bitrate: ''
        },
        programs: []
    });
const allowedFrameRates = [
    {
        name: '30',
        value: '30'
    },
    {
        name: '60',
        value: '60'
    },
    {
        name: '25',
        value: '25'
    },
    {
        name: '50',
        value: '50'
    },
    {
        name: '29.97',
        value: '29.97'
    },
    {
        name: '59.94',
        value: '59.94'
    }
];
const allowedResolutions = [
    {
        name: '1280x720',
        value: '1280x720'
    },
    {
        name: '1920x1080',
        value: '1920x1080'
    }
];
const allowedScanModes = [
    {
        name: 'progressive',
        value: 'progressive'
    },
    {
        name: 'interlaced - Top Frame First (TFF)',
        value: 'interlaced_tff'
    },
    {
        name: 'interlaced - Bottom Frame First (BFF)',
        value: 'interlaced_bff'
    }
];
const allowedTimestampResolutions = [
    {
        name: 'seconds',
        value: 'seconds'
    },
    {
        name: 'milliseconds',
        value: 'milliseconds'
    }
];
const bitrateTypes = [
    {
        name: "VBR \u2013 Variable bitrate",
        value: 'vbr'
    },
    {
        name: "CBR \u2013 Constant bitrate",
        value: 'cbr'
    }
];
const allowedBitrates = [
    {
        name: '5 Mbps',
        value: 5000000
    },
    {
        name: '10 Mbps',
        value: 10000000
    },
    {
        name: '15 Mbps',
        value: 15000000
    },
    {
        name: '20 Mbps',
        value: 20000000
    },
    {
        name: '30 Mbps',
        value: 30000000
    },
    {
        name: '50 Mbps',
        value: 50000000
    },
    {
        name: '100 Mbps',
        value: 100000000
    }
];
const INTERNAL_PORT_RANGE_START = 30000;
function nextFreePid(startingPid, occupiedPids) {
    const MAX = 8190 // 8191 (0x1FFF) is Null packets
    ;
    const RESERVED = [
        8187
    ];
    for(let pid = startingPid; pid < MAX; pid++){
        if (occupiedPids.has(pid)) continue;
        if (RESERVED.includes(pid)) continue;
        return pid;
    }
    return undefined;
}
function allPidsExcept(programs, programIndexToExclude, typeToExclude) {
    const otherPids = new Set();
    for (const p of programs)if (p === programs[programIndexToExclude]) {
        if (typeToExclude === 'audio') {
            if (p.video) otherPids.add(p.video.pid);
        } else otherPids.add(p.audio.pid);
    } else {
        otherPids.add(p.audio.pid);
        if (p.video) otherPids.add(p.video.pid);
    }
    return otherPids;
}
const GeneratorForm = ({ addresses, namePrefix, occupiedPorts, adminStatus, handoverMethod })=>{
    const { getValues, setValue, watch } = (0, _reactHookForm.useFormContext)();
    const audioOnlyKey = `${namePrefix}.${"audioOnly"}`;
    const bitrateControlModeKey = `${namePrefix}.${"bitrate"}.type`;
    // Watch for changes in fields controlling dynamic fields
    watch(audioOnlyKey);
    watch(bitrateControlModeKey);
    const { devMode } = (0, _utils.useSettingsSelector)();
    const addressSelector = `${namePrefix}.${"address"}`;
    const portSelector = `${namePrefix}.${"port"}`;
    const address = getValues(addressSelector);
    const port = getValues(portSelector);
    const isCBR = getValues(`${namePrefix}.${"bitrate"}.type`) === 'cbr';
    const generator = getValues(namePrefix);
    const isAudioOnly = !!getValues(audioOnlyKey);
    const programs = generator.programs ?? [];
    const { fields: programFields, remove: removeProgramField, append: appendProgramField } = (0, _reactHookForm.useFieldArray)({
        name: `${namePrefix}.${"programs"}`
    });
    const addProgram = ()=>{
        const nextProgramIndex = programs.length;
        const pidStartRange = (nextProgramIndex + 1) * 100;
        const occupiedPids = new Set(programs.flatMap((pr)=>[
                pr.audio.pid,
                pr.video?.pid
            ]).filter((0, _helpers.notUndefined)));
        const nextAudioPid = nextFreePid(pidStartRange, occupiedPids);
        if (nextAudioPid) occupiedPids.add(nextAudioPid);
        const nextVideoPid = nextFreePid(pidStartRange, occupiedPids);
        const program = {
            title: `Program ${nextProgramIndex + 1}`,
            audio: {
                pid: nextAudioPid ?? ''
            },
            video: {
                pid: nextVideoPid ?? ''
            }
        };
        appendProgramField(program);
    };
    (0, _react.useEffect)(()=>{
        if (programs.length === 0) addProgram();
    });
    // Newer generators don't allow user to select address and port - they are always created on lo0
    const isOldGeneratorWithCustomAddressAndPort = handoverMethod === (0, _types.HandoverMethod).udp && port && port < INTERNAL_PORT_RANGE_START;
    (0, _react.useEffect)(()=>{
        if (address !== '127.0.0.1' && isOldGeneratorWithCustomAddressAndPort) setValue(addressSelector, '127.0.0.1');
    }, [
        setValue,
        addressSelector,
        address
    ]);
    // if VBR selected reset bitrate to default
    (0, _react.useEffect)(()=>{
        const bitrateField = `${namePrefix}.${"bitrate"}.bitrate`;
        const bitrateValue = getValues(bitrateField);
        if (!isCBR && bitrateValue) setValue(bitrateField, '');
    }, [
        getValues,
        setValue,
        namePrefix,
        isCBR
    ]);
    const portInfo = {
        isInput: true,
        isPortDisabled: adminStatus === (0, _types.InputAdminStatus).off,
        mode: port.mode,
        existingLogicalPortsOnSameNic: occupiedPorts
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isOldGeneratorWithCustomAddressAndPort && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        name: addressSelector,
                        label: "Address",
                        required: true,
                        options: (0, _utils.makeAddressOptions)(getValues(addressSelector), addresses).filter((a)=>a.value === '127.0.0.1'),
                        disabled: true,
                        newLine: true,
                        validators: {
                            addressIn: {
                                addresses
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `${namePrefix}.${"port"}`,
                        label: "Port",
                        type: "number",
                        disabled: true,
                        noNegative: true,
                        tooltip: "It is no longer possible to choose/edit the port for generator inputs. For new generator inputs, this port will be automatically assigned and not visible in Network Manager.",
                        validators: {
                            port: {
                                disallowInternal: false,
                                isUdp: true
                            },
                            isPortAvailable: portInfo
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                name: audioOnlyKey,
                label: "Audio only"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"resolution"}`,
                label: "Resolution",
                options: allowedResolutions,
                newLine: true,
                disabled: isAudioOnly
            }),
            devMode && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"scanMode"}`,
                label: "Scan mode",
                options: allowedScanModes,
                newLine: true,
                disabled: isAudioOnly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"frameRate"}`,
                label: "Frame rate",
                options: allowedFrameRates,
                newLine: true,
                disabled: isAudioOnly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"timestampResolution"}`,
                label: "Timestamp resolution",
                options: allowedTimestampResolutions,
                newLine: true,
                disabled: isAudioOnly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: bitrateControlModeKey,
                label: "Bitrate control mode (VBR/CBR)",
                options: bitrateTypes,
                newLine: true,
                disabled: isAudioOnly
            }),
            isCBR && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                name: `${namePrefix}.${"bitrate"}.bitrate`,
                label: "Bitrate",
                options: allowedBitrates,
                required: true,
                tooltip: "Select the bitrate when using CBR encoding. Note that CBR sets constant bitrate for the video encoder only. The transport stream will not be constant bitrate"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: 'MPEG-TS Programs',
                className: "outlined",
                actionsPane: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        sx: {
                            marginBottom: 2
                        },
                        variant: "contained",
                        color: "secondary",
                        onClick: addProgram,
                        children: "Add program"
                    })
                ],
                children: programFields.map((field, index)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: `Program #${index + 1}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                label: "Title",
                                required: true,
                                name: `${namePrefix}.${"programs"}.${index}.title`,
                                newLine: true,
                                validators: {
                                    notOneOf: {
                                        invalidValues: new Set(programs.filter((p)=>p.title !== programs[index].title).map((p)=>p.title)),
                                        errorMsg: `Title already specified`
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                type: "number",
                                label: "Audio Pid",
                                required: true,
                                name: `${namePrefix}.${"programs"}.${index}.audio.pid`,
                                newLine: true,
                                validators: {
                                    pid: {},
                                    notOneOf: {
                                        invalidValues: allPidsExcept(programs, index, 'audio'),
                                        errorMsg: `PID already specified`
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                type: "number",
                                label: "Video Pid",
                                required: true,
                                name: `${namePrefix}.${"programs"}.${index}.video.pid`,
                                validators: {
                                    pid: {},
                                    notOneOf: {
                                        invalidValues: allPidsExcept(programs, index, 'video'),
                                        errorMsg: `PID already specified`
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                newLine: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    style: {
                                        marginTop: 12
                                    },
                                    variant: "outlined",
                                    color: "primary",
                                    disabled: programs.length < 2,
                                    onClick: ()=>removeProgramField(index),
                                    children: "Remove Program"
                                })
                            })
                        ]
                    }, field.id);
                })
            })
        ]
    });
};
exports.default = GeneratorForm;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","common/api/defaults":"ibSeM","../../../../common/Form":"4Mui7","../../../../../utils":"342UB","react":"9njXz","@mui/material/Button":"3qJY9","common/api/v1/helpers":"6jovr","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ibSeM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultGeneratorBitrate = exports.defaultGeneratorAudioPid = exports.defaultGeneratorVideoPid = exports.defaultScanMode = exports.defaultResolution = exports.defaultFrameRate = exports.defaultTimestampResolution = void 0;
exports.defaultTimestampResolution = 'seconds';
exports.defaultFrameRate = '30';
exports.defaultResolution = '1280x720';
exports.defaultScanMode = 'progressive';
exports.defaultGeneratorVideoPid = 256;
exports.defaultGeneratorAudioPid = 257;
exports.defaultGeneratorBitrate = {
    type: 'vbr'
};

},{}],"5LplR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Groups", ()=>Groups);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _edit = require("./Edit");
var _list = require("./List");
var _edit1 = require("../groupLists/Edit");
var _list1 = require("../groupLists/List");
const Groups = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).UPDATE,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).NEW,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.GroupsList), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Route), {
                path: "lists",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                        index: true,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list1.ListView), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                        path: (0, _routes.SUB_PATH).NEW,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit1.Edit), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                        path: (0, _routes.SUB_PATH).UPDATE,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit1.Edit), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                        path: "*",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","./Edit":"3pimV","./List":"kEocB","../groupLists/Edit":"cPHSc","../groupLists/List":"4AwpU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3pimV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _uuid = require("uuid");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _form = require("../../common/Form");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _utils = require("../../../utils");
var _groupActions = require("../../../redux/actions/groupActions");
var _lists = require("./Lists");
var _listsDefault = parcelHelpers.interopDefault(_lists);
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _password = require("../../../utils/password");
var _rhf = require("../../common/Form/RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
const styles = {
    warning: {
        color: (theme)=>theme.palette.error.main,
        fontWeight: 'bold'
    }
};
const getInitialState = (group)=>(0, _mergeDefault.default)({
        name: '',
        applianceSecret: '',
        adminUsername: '',
        adminPassword: ''
    }, group);
const isEditing = (values)=>'id' in values && !!values.id;
const GroupForm = ({ setValue, getValues, setError, setFocus, watch, clearErrors, formState })=>{
    const values = getValues();
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const setConfirmation = (0, _utils.useConfirmationDialog)();
    const { formErrors, saving } = (0, _reactRedux.useSelector)(({ groupsReducer })=>({
            formErrors: groupsReducer.formErrors,
            saving: groupsReducer.saving
        }), (0, _reactRedux.shallowEqual));
    const user = (0, _utils.useUser)();
    const setSecret = ()=>setValue('applianceSecret', _uuid.v4());
    const [showPassword, setShowPassword] = (0, _react.useState)({
        show: false,
        id: ''
    });
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach((item)=>{
                setError(item.name, {
                    type: 'manual',
                    message: item.reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    (0, _react.useEffect)(()=>{
        if (getValues('applianceSecret') === '') setSecret();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    watch([
        'adminUsername',
        'adminPassword',
        'applianceSecret'
    ]);
    const onRefreshClick = isEditing(values) ? ()=>setConfirmation(()=>setSecret(), /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: styles.warning,
                    children: "Warning!"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        ' ',
                        "New appliances will need to use the new secret to register. Previously registered appliances can still use the secret they were originally registered with."
                    ]
                })
            ]
        }), values.name) : ()=>setSecret();
    const deleteGroup = ()=>isEditing(values) && setConfirmation(()=>void dispatch((0, _groupActions.removeGroup)(values.id)), `Are you sure you want to delete group ${values.name}?`);
    if (user.role !== (0, _types.Role).super && (user.role !== (0, _types.Role).admin || user.group !== values.id)) {
        navigate(-1);
        return null;
    }
    const onGeneratePasswordClick = ()=>{
        const adminPassword = (0, _password.generatePassword)(12, 12);
        setValue('adminPassword', adminPassword);
        setShowPassword({
            show: true,
            id: adminPassword
        });
    };
    const onAdminAccountCollapseChange = (collapsed)=>{
        if (collapsed) {
            setValue('adminPassword', '');
            setValue('adminUsername', '');
            clearErrors('adminPassword');
            clearErrors('adminUsername');
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                formState: formState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "group-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Group metadata",
                        actionsPane: [
                            getValues('applianceSecret') && navigator.clipboard ? {
                                props: {
                                    variant: 'outlined'
                                },
                                title: 'Copy secret',
                                onClick: ()=>void navigator.clipboard.writeText(getValues('applianceSecret') || '')
                            } : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
                            {
                                id: 'button-refresh-secret',
                                title: 'Generate new secret',
                                onClick: onRefreshClick
                            }
                        ],
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "name",
                                label: "Name",
                                required: true,
                                autoFocus: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "applianceSecret",
                                label: "Secret",
                                required: true,
                                disabled: true
                            })
                        ]
                    }),
                    !isEditing(values) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Create Group Admin",
                        collapsed: true,
                        collapsible: true,
                        actionsPane: [
                            {
                                id: 'button-generate-password',
                                title: 'Generate password',
                                onClick: onGeneratePasswordClick
                            }
                        ],
                        onCollapseChange: onAdminAccountCollapseChange,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "adminUsername",
                                label: "Username",
                                required: !!values.adminPassword && values.adminPassword.length > 0,
                                autoComplete: "off",
                                type: "text",
                                validators: values.adminUsername ? {
                                    username: {}
                                } : {}
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "adminPassword",
                                label: "Password",
                                autoComplete: "new-password",
                                required: !!values.adminUsername && values.adminUsername.length > 0,
                                type: "password",
                                showPassword: showPassword,
                                validators: {
                                    pwd: {}
                                }
                            })
                        ]
                    }),
                    isEditing(values) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listsDefault.default), {
                        groupId: values.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>void navigate(routes.groups())
                            },
                            Save: {
                                savingState: !!saving,
                                primary: true,
                                type: 'submit'
                            }
                        },
                        secondary: isEditing(values) && user.role === (0, _types.Role).super ? {
                            'Remove group': {
                                onClick: deleteGroup
                            }
                        } : undefined
                    })
                ]
            })
        ]
    });
};
const Edit = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        id && dispatch((0, _groupActions.getGroup)(id));
        return ()=>{
            dispatch((0, _groupActions.clearGroup)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const groupToEdit = (0, _reactRedux.useSelector)(({ groupsReducer })=>groupsReducer.group, (0, _reactRedux.shallowEqual));
    const onSubmit = (group)=>{
        if (groupToEdit) dispatch((0, _groupActions.updateGroup)(group));
        else dispatch((0, _groupActions.createGroup)(group));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Groups',
            id ? groupToEdit?.name : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: !!id && !groupToEdit,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rhfDefault.default), {
                onSubmit: (values)=>{
                    onSubmit((0, _utils.formTransform)(values));
                },
                defaultValues: getInitialState(groupToEdit),
                component: GroupForm
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","lodash/merge":"iHC1F","uuid":"dccyI","@mui/material/Box":"c4QkF","common/api/v1/types":"3qemx","../../../store":"5LXiG","../../common/Form":"4Mui7","../../common/Pendable":"gDN67","../../../utils":"342UB","../../../redux/actions/groupActions":"bqPI2","./Lists":"ktFo8","../../common/Wrapper":"8oy7r","../../../utils/password":"9HOmO","../../common/Form/RHF":"7gFt3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHC1F":[function(require,module,exports,__globalThis) {
var baseMerge = require("7b601c4be119b25d"), createAssigner = require("e87a09d93c0fc32d");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"7b601c4be119b25d":"1n4LL","e87a09d93c0fc32d":"e0xvq"}],"ktFo8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _dateFns = require("date-fns");
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _form = require("../../common/Form");
var _link = require("../../common/Link");
var _selfStatePaginatedList = require("../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _utils = require("../../../utils");
var _store = require("../../../store");
var _listItemButton = require("@mui/material/ListItemButton");
var _listItemButtonDefault = parcelHelpers.interopDefault(_listItemButton);
const styles = {
    main: {
        flexGrow: 1
    }
};
const List = ({ api, getLeftInfo, getRightInfo, name, owner, canEdit })=>{
    const routes = (0, _store.useRoutes)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: `${name[0].toUpperCase()}${name.slice(1)}s`,
        collapsible: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
            api: api,
            emptyMessage: `No ${name}s yet`,
            notFoundMessage: `No matching ${name}s`,
            otherParams: {
                owner
            },
            hideSearch: true,
            List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                    disablePadding: true,
                    sx: {
                        marginTop: 2,
                        marginX: 2
                    },
                    children: list.map((ent)=>canEdit(ent) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: routes[`${name}sUpdate`]({
                                id: ent.id
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemButtonDefault.default), {
                                disableGutters: true,
                                divider: true,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        sx: styles.main,
                                        children: getLeftInfo(ent)
                                    }),
                                    getRightInfo !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        children: getRightInfo(ent)
                                    })
                                ]
                            })
                        }, ent.id) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
                            disableGutters: true,
                            divider: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    sx: styles.main,
                                    children: getLeftInfo(ent)
                                }),
                                getRightInfo !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    children: getRightInfo(ent)
                                })
                            ]
                        }, ent.id))
                })
        })
    });
};
const { userApi, portsApi, appliancesApi } = (0, _store.Api);
const Lists = ({ groupId })=>{
    const currentUser = (0, _utils.useUser)();
    const { devMode } = (0, _utils.useSettingsSelector)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(List, {
                api: userApi.getUsers.bind(userApi),
                getLeftInfo: ({ username })=>username,
                getRightInfo: ({ role })=>role,
                name: "user",
                owner: groupId,
                canEdit: ({ role, group })=>currentUser.role === (0, _types.Role).super || currentUser.role === (0, _types.Role).admin && currentUser.group === group && role !== (0, _types.Role).super
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(List, {
                api: appliancesApi.getBareAppliances.bind(appliancesApi),
                getLeftInfo: ({ name })=>name,
                getRightInfo: ({ lastMessageAt = '' })=>lastMessageAt && `last seen ${(0, _dateFns.formatDistanceToNow)(new Date(lastMessageAt))} ago`,
                name: "appliance",
                owner: groupId,
                canEdit: ()=>true
            }),
            devMode ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(List, {
                api: portsApi.getBarePorts.bind(portsApi),
                name: "interface",
                getLeftInfo: (port)=>(0, _utils.getInterfaceName)(port),
                owner: groupId,
                canEdit: ()=>false
            }) : null
        ]
    });
};
exports.default = Lists;

},{"react/jsx-runtime":"1dlk8","date-fns":"gelMX","@mui/material/List":"a52pA","@mui/material/ListItem":"fosVg","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../common/Form":"4Mui7","../../common/Link":"l3o6V","../../common/SelfStatePaginatedList":"dLSax","../../../utils":"342UB","../../../store":"5LXiG","@mui/material/ListItemButton":"cWRPN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9HOmO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPasswordSecure", ()=>isPasswordSecure);
parcelHelpers.export(exports, "generatePassword", ()=>generatePassword);
const isPasswordSecure = (password)=>{
    if (!/\d/.test(password)) return false;
    if (!/[A-Z]/.test(password)) return false;
    if (!/[!@#$+\-*&_]/.test(password)) return false;
    return true;
};
const CHARS = '0123456789!@#$+-*&_abcdefghijknopqrstuvwxyzACDEFGHJKLMNPQRSTUVWXYZ';
const generatePassword = (minLength = 8, maxLength = 16)=>{
    let password = '';
    while(password.length < minLength || !isPasswordSecure(password)){
        password += CHARS[Math.floor(Math.random() * (CHARS.length - 1))];
        if (password.length >= maxLength) break;
    }
    return password;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kEocB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupsList", ()=>GroupsList);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../common/Link");
var _listGroupFilter = require("./listGroupFilter");
var _store = require("../../store");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _actionMenu = require("../common/Table/ActionMenu");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _groupActions = require("../../redux/actions/groupActions");
var _reactRedux = require("react-redux");
const GroupsList = ()=>{
    const { groups, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useGroupsSelector));
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const { devMode } = (0, _utils.useSettingsSelector)();
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const tableConfig = [
        {
            title: 'name',
            getValue: (group)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    available: (0, _utils.isEditableGroup)(group.id, user),
                    to: routes.groupsUpdate({
                        id: group.id
                    }),
                    underline: "hover",
                    children: group.name
                }),
            sorting: {
                byParameter: (0, _types.ListGroupSortableField).groupName
            }
        },
        {
            title: 'users',
            getValue: ({ id, userCount })=>userCount !== undefined && (0, _utils.isEditableGroup)(id, user) ? (0, _utils.pluralize)(userCount, 'user') : null,
            sorting: {
                byParameter: (0, _types.ListGroupSortableField).numberOfUsers,
                hidden: user.role !== (0, _types.Role).super
            }
        },
        {
            title: 'appliances',
            getValue: ({ id, applianceCount })=>applianceCount !== undefined && (0, _utils.isEditableGroup)(id, user) ? (0, _utils.pluralize)(applianceCount, 'appliance') : null,
            sorting: {
                byParameter: (0, _types.ListGroupSortableField).numberOfAppliances,
                hidden: user.role !== (0, _types.Role).super
            }
        },
        devMode ? {
            title: 'interfaces',
            getValue: ({ id, interfaceCount })=>interfaceCount !== undefined && (0, _utils.isEditableGroup)(id, user) ? (0, _utils.pluralize)(interfaceCount, 'interface') : null,
            sorting: {
                byParameter: (0, _types.ListGroupSortableField).numberOfPorts,
                hidden: user.role !== (0, _types.Role).super
            }
        } : null,
        {
            getValue: (group)=>(0, _utils.isEditableGroup)(group.id, user) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    options: [
                        {
                            label: 'Edit',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                            href: routes.groupsUpdate({
                                id: group.id
                            })
                        },
                        {
                            label: 'Remove',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                            isDestructive: true,
                            onClick: ()=>{
                                showConfirmation(()=>void dispatch((0, _groupActions.removeGroup)(group.id)), `Are you sure you want to remove group ${group.name}?`);
                            }
                        }
                    ]
                }),
            props: {
                align: 'right',
                noTypography: true
            }
        }
    ];
    const filters = (0, _listGroupFilter.makeListGroupsFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Groups",
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    type: "button",
                    to: routes.groupLists(),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "outlined",
                        color: "primary",
                        children: "Manage group lists"
                    })
                }, "manageGroupLists"),
                user.role === (0, _types.Role).super && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    id: "groups-table-create-button",
                    to: routes.groupsNew(),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        style: {
                            marginLeft: 8
                        },
                        variant: "contained",
                        color: "primary",
                        children: "Add group"
                    })
                }, "addGroup")
            ]
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'groups',
                        mapUrlParamToFilterFn: (0, _listGroupFilter.mapUrlParamToGroupFilter),
                        mapFilterToUrlParamFn: (0, _listGroupFilter.mapGroupFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listGroupFilter.ListGroupFilterKey).name)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No groups available",
                    buttonText: "Add group",
                    url: routes.groupsNew()
                }),
                config: tableConfig,
                data: groups,
                id: "groups-table",
                pending: loading,
                pagination: {
                    total,
                    useUrlSearchParams: true
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Button":"3qJY9","@mui/material/Toolbar":"5Kohb","common/api/v1/types":"3qemx","../../utils":"342UB","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../common/Link":"l3o6V","./listGroupFilter":"hbdUC","../../store":"5LXiG","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","../common/Table/ActionMenu":"jf6As","@mui/icons-material/Delete":"69aC7","@mui/icons-material/Settings":"jkTfg","../../redux/actions/groupActions":"bqPI2","react-redux":"l1pMU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hbdUC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListGroupFilterKey", ()=>ListGroupFilterKey);
parcelHelpers.export(exports, "mapGroupFilterToUrlParam", ()=>mapGroupFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToGroupFilter", ()=>mapUrlParamToGroupFilter);
parcelHelpers.export(exports, "makeListGroupsFilter", ()=>makeListGroupsFilter);
var ListGroupFilterKey = /*#__PURE__*/ function(ListGroupFilterKey) {
    ListGroupFilterKey["name"] = "name";
    return ListGroupFilterKey;
}({});
function mapGroupFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToGroupFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListGroupsFilter() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cPHSc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _mergeWith = require("lodash/mergeWith");
var _mergeWithDefault = parcelHelpers.interopDefault(_mergeWith);
var _store = require("../../../store");
var _utils = require("../../../utils");
var _groupListsActions = require("../../../redux/actions/groupListsActions");
var _form = require("../../common/Form");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _availableGroups = require("./AvailableGroups");
var _availableGroupsDefault = parcelHelpers.interopDefault(_availableGroups);
var _groups = require("./Groups");
var _groupsDefault = parcelHelpers.interopDefault(_groups);
var _rhf = require("../../common/Form/RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
const getInitialState = (group, selectedGroupList)=>(0, _mergeWithDefault.default)({
        name: '',
        description: '',
        group,
        addGroups: [],
        removeGroups: []
    }, selectedGroupList, (_initial, existent, key)=>{
        if ('description' === key && !existent) return '';
    });
const GroupListForm = ({ getValues, setError, setFocus, formState })=>{
    const values = getValues();
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirm = (0, _utils.useConfirmationDialog)();
    const { formErrors, saving } = (0, _reactRedux.useSelector)(({ groupListsReducer })=>({
            formErrors: groupListsReducer.formErrors,
            saving: groupListsReducer.saving
        }), (0, _reactRedux.shallowEqual));
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach((item)=>{
                setError(item.name, {
                    type: 'manual',
                    message: item.reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    const deleteGroupList = ()=>{
        showConfirm(()=>void dispatch((0, _groupListsActions.removeGroupList)(values.id)), `Are you sure you want to delete group list ${values.name}?`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                formState: formState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "group-list-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Metadata",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "name",
                                label: "Name",
                                required: true,
                                autoFocus: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "description",
                                label: "Description",
                                multiline: true
                            })
                        ]
                    }),
                    !!values.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        title: "Groups",
                        collapsible: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupsDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        title: "Select groups",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _availableGroupsDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>void navigate(routes.groupLists())
                            },
                            Save: {
                                savingState: !!saving,
                                primary: true,
                                type: 'submit'
                            }
                        },
                        secondary: values.id ? {
                            'Remove group list': {
                                onClick: deleteGroupList
                            }
                        } : undefined
                    })
                ]
            })
        ]
    });
};
const Edit = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        id && dispatch((0, _groupListsActions.getGroupList)(id));
        return ()=>{
            dispatch((0, _groupListsActions.clearGroupList)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { groupList } = (0, _reactRedux.useSelector)(({ groupListsReducer })=>({
            groupList: groupListsReducer.groupList
        }), (0, _reactRedux.shallowEqual));
    const { group } = (0, _utils.useUser)();
    const onSubmit = (draft)=>{
        if (groupList) dispatch((0, _groupListsActions.updateGroupList)({
            groupList: draft,
            withRedirection: true
        }));
        else dispatch((0, _groupListsActions.createGroupList)(draft));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Groups',
            'Lists',
            id ? groupList?.name : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: !!id && !groupList,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rhfDefault.default), {
                onSubmit: (values)=>{
                    onSubmit((0, _utils.formTransform)(values));
                },
                defaultValues: getInitialState(group, groupList),
                component: GroupListForm
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","lodash/mergeWith":"40Q54","../../../store":"5LXiG","../../../utils":"342UB","../../../redux/actions/groupListsActions":"k9GYr","../../common/Form":"4Mui7","../../common/Pendable":"gDN67","../../common/Wrapper":"8oy7r","./AvailableGroups":"fYmoj","./Groups":"luUfD","../../common/Form/RHF":"7gFt3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fYmoj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _store = require("../../../store");
var _selfStatePaginatedList = require("../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _table = require("../../common/Table");
var _utils = require("../../../utils");
var _reactHookForm = require("react-hook-form");
const { groupListsApi, groupsApi } = (0, _store.Api);
const AddRemoveButton = ({ id })=>{
    const { setValue, watch } = (0, _reactHookForm.useFormContext)();
    const currentAddGroups = watch('addGroups');
    const onAdd = (id)=>setValue('addGroups', [
            ...currentAddGroups,
            id
        ]);
    const onCancel = (id)=>{
        setValue('addGroups', currentAddGroups.filter((groupId)=>groupId !== id));
    };
    return currentAddGroups.includes(id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        color: "error",
        onClick: ()=>onCancel(id),
        variant: "outlined",
        size: "small",
        children: "Cancel"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        onClick: ()=>onAdd(id),
        variant: "outlined",
        size: "small",
        name: "add-group",
        children: "Add"
    });
};
const AvailableGroups = ()=>{
    const [hideFilter, setHideFilter] = (0, _react.useState)(true);
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    const { group } = (0, _utils.useUser)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        size: {
            xs: 12
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
            api: values.id ? function(params) {
                return groupListsApi.getGroups(values.id, false, params);
            } : groupsApi.getPureGroups.bind(groupsApi),
            emptyMessage: "no available groups",
            hideSearch: hideFilter,
            notFoundMessage: "no matching groups",
            otherParams: {
                userGroup: group
            },
            onListChange: ({ filter, total = 0 })=>setHideFilter(!filter && total < 10),
            searchPlaceholder: "Find specific group\u2026",
            List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                    id: "availablegroups-table",
                    data: list,
                    isSmall: true,
                    hasBorders: true,
                    noHeader: true,
                    config: [
                        {
                            title: 'name',
                            getValue: ({ name })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    children: name
                                })
                        },
                        {
                            title: 'add',
                            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(AddRemoveButton, {
                                    id: id
                                }),
                            props: {
                                align: 'right',
                                padding: 'normal'
                            }
                        }
                    ]
                })
        })
    });
};
exports.default = AvailableGroups;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Button":"3qJY9","@mui/material/Grid":"6iX4B","@mui/material/Typography":"6NtGx","../../../store":"5LXiG","../../common/SelfStatePaginatedList":"dLSax","../../common/Table":"dt9lf","../../../utils":"342UB","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"luUfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _highlightOff = require("@mui/icons-material/HighlightOff");
var _highlightOffDefault = parcelHelpers.interopDefault(_highlightOff);
var _store = require("../../../store");
var _selfStatePaginatedList = require("../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _table = require("../../common/Table");
var _reactHookForm = require("react-hook-form");
const groupListsApi = (0, _store.Api).groupListsApi;
const RemoveButton = ({ id })=>{
    const { setValue, watch } = (0, _reactHookForm.useFormContext)();
    const currentRemoveGroups = watch('removeGroups');
    const onRemove = (id)=>setValue('removeGroups', [
            ...currentRemoveGroups,
            id
        ]);
    const onCancel = (id)=>{
        setValue('removeGroups', currentRemoveGroups.filter((groupId)=>groupId !== id));
    };
    return currentRemoveGroups.includes(id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        color: "error",
        onClick: ()=>onCancel(id),
        variant: "outlined",
        size: "small",
        children: "Cancel"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: "Remove from list",
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
            edge: "start",
            "aria-label": "remove",
            onClick: ()=>onRemove(id),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightOffDefault.default), {})
        })
    });
};
const Groups = ()=>{
    const [hideFilter, setHideFilter] = (0, _react.useState)(true);
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        size: {
            xs: 12
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
            api: function(params) {
                return groupListsApi.getGroups(values.id, true, params);
            },
            emptyMessage: "no groups",
            hideSearch: hideFilter,
            notFoundMessage: "no matching groups",
            onListChange: ({ filter, total = 0 })=>{
                setHideFilter(!filter && total < 10);
            },
            searchPlaceholder: "Find specific group\u2026",
            List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                    id: "selectgroups-table",
                    data: list,
                    isSmall: true,
                    hasBorders: true,
                    noHeader: true,
                    config: [
                        {
                            getValue: ({ name })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    children: name
                                })
                        },
                        {
                            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RemoveButton, {
                                    id: id
                                }),
                            props: {
                                align: 'right',
                                padding: 'normal'
                            }
                        }
                    ]
                })
        })
    });
};
exports.default = Groups;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Button":"3qJY9","@mui/material/Grid":"6iX4B","@mui/material/IconButton":"488As","../../common/Tooltip":"crjvg","@mui/material/Typography":"6NtGx","@mui/icons-material/HighlightOff":"afUuo","../../../store":"5LXiG","../../common/SelfStatePaginatedList":"dLSax","../../common/Table":"dt9lf","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AwpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListView", ()=>ListView);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _utils = require("../../utils");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../common/Link");
var _store = require("../../store");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _listGroupListsFilter = require("./listGroupListsFilter");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _actionMenu = require("../common/Table/ActionMenu");
var _reactRedux = require("react-redux");
var _groupListsActions = require("../../redux/actions/groupListsActions");
const ListView = ()=>{
    const routes = (0, _store.useRoutes)();
    const { groupLists, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useGroupListsSelector));
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const tableConfig = [
        {
            title: 'name',
            getValue: (groupList)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.groupListsUpdate({
                        id: groupList.id
                    }),
                    children: groupList.name
                }),
            sorting: {
                byParameter: 'name'
            }
        },
        {
            title: 'description',
            getValue: ({ description })=>description,
            sorting: {
                byParameter: 'description'
            }
        },
        {
            getValue: (groupList)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    options: [
                        {
                            label: 'Edit',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                            href: routes.groupListsUpdate({
                                id: groupList.id
                            })
                        },
                        {
                            label: 'Remove',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                            isDestructive: true,
                            onClick: ()=>{
                                showConfirmation(()=>void dispatch((0, _groupListsActions.removeGroupList)(groupList.id)), `Are you sure you want to remove group list ${groupList.name}?`);
                            }
                        }
                    ]
                }),
            props: {
                align: 'right'
            }
        }
    ];
    const filters = (0, _listGroupListsFilter.makeListGroupListsFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: [
            'Groups',
            'Lists'
        ],
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            type: "button",
            to: routes.groupListsNew(),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "contained",
                color: "primary",
                children: "Add group list"
            })
        }, "groupListCreate"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'groupLists',
                        mapUrlParamToFilterFn: (0, _listGroupListsFilter.mapUrlParamToGroupListFilter),
                        mapFilterToUrlParamFn: (0, _listGroupListsFilter.mapGroupListFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listGroupListsFilter.ListGroupListFilterKey).name)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                id: "grouplists-table",
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No group lists",
                    buttonText: "Add group list",
                    url: routes.groupListsNew()
                }),
                config: tableConfig,
                data: groupLists,
                pending: loading,
                pagination: {
                    total,
                    useUrlSearchParams: true
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Button":"3qJY9","../../utils":"342UB","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../common/Link":"l3o6V","../../store":"5LXiG","@mui/material/Toolbar":"5Kohb","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","./listGroupListsFilter":"5ypG7","@mui/icons-material/Delete":"69aC7","@mui/icons-material/Settings":"jkTfg","../common/Table/ActionMenu":"jf6As","react-redux":"l1pMU","../../redux/actions/groupListsActions":"k9GYr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ypG7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListGroupListFilterKey", ()=>ListGroupListFilterKey);
parcelHelpers.export(exports, "mapGroupListFilterToUrlParam", ()=>mapGroupListFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToGroupListFilter", ()=>mapUrlParamToGroupListFilter);
parcelHelpers.export(exports, "makeListGroupListsFilter", ()=>makeListGroupListsFilter);
var ListGroupListFilterKey = /*#__PURE__*/ function(ListGroupListFilterKey) {
    ListGroupListFilterKey["name"] = "name";
    return ListGroupListFilterKey;
}({});
function mapGroupListFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToGroupListFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListGroupListsFilter() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eY235":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Users", ()=>Users);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _edit = require("./Edit");
var _list = require("./List");
const Users = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).UPDATE,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).NEW,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.ListView), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","./Edit":"jXqS7","./List":"4HpQC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXqS7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _reactAsyncHook = require("react-async-hook");
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
var _userActions = require("../../redux/actions/userActions");
var _types = require("common/api/v1/types");
var _store = require("../../store");
var _form = require("../common/Form");
var _pendable = require("../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _utils = require("../../utils");
var _failedFetchingContent = require("../common/FailedFetchingContent");
var _react = require("react");
var _rhf = require("../common/Form/RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
const { userApi } = (0, _store.Api);
const getInitialStateUpdating = (userToEdit)=>({
        password: '',
        ...userToEdit
    });
const getInitialStateCreating = (currentUser)=>({
        id: '',
        group: currentUser.group,
        role: '',
        username: '',
        password: '',
        _group: {
            id: '',
            name: ''
        },
        external: false
    });
const UserForm = (props, navigate, isUpdating, externalUser)=>{
    const values = props.getValues();
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirm = (0, _utils.useConfirmationDialog)();
    const { saving } = (0, _reactRedux.useSelector)(({ userReducer })=>userReducer, (0, _reactRedux.shallowEqual));
    const user = (0, _utils.useUser)();
    let roleOptions = [
        (0, _types.Role).basic
    ];
    switch(user.role){
        case (0, _types.Role).admin:
            roleOptions.push((0, _types.Role).admin);
            break;
        case (0, _types.Role).super:
            roleOptions.push((0, _types.Role).admin);
            if (user._group.id === values.group) roleOptions.push((0, _types.Role).super);
            break;
    }
    if (isUpdating && values.role) roleOptions = (0, _uniqDefault.default)([
        ...roleOptions,
        values.role
    ]);
    const deleteUser = ()=>{
        showConfirm(()=>void (0, _userActions.removeUser)(values, {
                dispatch,
                navigate,
                userApi: (0, _store.Api).userApi,
                routes
            }), `Are you sure you want to delete user ${values.username}?`);
    };
    const groupsApi = (0, _react.useCallback)((0, _store.Api).groupsApi.getPureGroups.bind((0, _store.Api).groupsApi), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                formState: props.formState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "user-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "User settings",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "username",
                                label: "Name",
                                required: true,
                                type: "text",
                                validators: props.defaultValues.username === 'admin' ? {} : {
                                    username: {}
                                },
                                autoFocus: true,
                                disabled: isUpdating,
                                autoComplete: "off"
                            }),
                            externalUser ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "password",
                                label: "Password",
                                required: !isUpdating,
                                type: "password",
                                autoComplete: "new-password",
                                validators: {
                                    pwd: {}
                                }
                            }),
                            user.role === (0, _types.Role).super ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                                name: "group",
                                api: groupsApi,
                                required: true,
                                defaultOption: isUpdating ? {
                                    id: values._group.id,
                                    name: values._group.name
                                } : undefined,
                                getOptionLabel: (option)=>option.name,
                                getOptionValue: (option)=>option.id,
                                optionComparator: (o1, o2)=>o1.id === o2.id
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                name: "group",
                                label: "Group",
                                required: true,
                                options: [
                                    {
                                        value: user._group.id,
                                        name: user._group.name
                                    }
                                ],
                                disabled: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                name: "role",
                                label: "Role",
                                required: true,
                                options: roleOptions
                            }),
                            isUpdating && !values.external ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "_mfa._totp",
                                label: "MFA",
                                type: "text",
                                disabled: true
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "accountType",
                                label: "Account type",
                                value: values.external ? 'External' : 'Internal',
                                required: false,
                                type: "text",
                                disabled: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>void navigate(routes.users())
                            },
                            Save: {
                                savingState: !!saving,
                                primary: true,
                                type: 'submit'
                            }
                        },
                        secondary: isUpdating && user.id !== values.id ? {
                            'Remove user': {
                                onClick: deleteUser
                            }
                        } : undefined
                    })
                ]
            })
        ]
    });
};
const Edit = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const user = (0, _utils.useUser)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const isUpdating = !!id;
    const { result, loading, error } = (0, _reactAsyncHook.useAsync)(async ()=>isUpdating ? userApi.getUser(id) : undefined, [
        id
    ]);
    const userToEdit = result ? {
        ...result,
        _mfa: {
            _totp: result.mfa?.totp?.enabled ? 'Configured' : 'Not configured'
        }
    } : undefined;
    const onSubmit = async (user)=>{
        if (isUpdating) dispatch((0, _userActions.updateUser)(user));
        else dispatch((0, _userActions.createUser)(user));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Users',
            id ? userToEdit?.username : 'New'
        ],
        children: error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _failedFetchingContent.FailedFetchingContent), {
            message: 'Failed to fetch user'
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: loading,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rhfDefault.default), {
                onSubmit: (values)=>{
                    return onSubmit((0, _utils.formTransform)(values));
                },
                defaultValues: isUpdating && userToEdit ? getInitialStateUpdating(userToEdit) : getInitialStateCreating(user),
                children: (props)=>UserForm(props, navigate, isUpdating, userToEdit?.external ?? false)
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","react-router":"iaz4C","react-async-hook":"3D6Y9","lodash/uniq":"6MoB8","../../redux/actions/userActions":"2tWgd","common/api/v1/types":"3qemx","../../store":"5LXiG","../common/Form":"4Mui7","../common/Pendable":"gDN67","../common/Wrapper":"8oy7r","../../utils":"342UB","../common/FailedFetchingContent":"dJi9P","react":"9njXz","../common/Form/RHF":"7gFt3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6MoB8":[function(require,module,exports,__globalThis) {
var baseUniq = require("8e268641906a92b2");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}
module.exports = uniq;

},{"8e268641906a92b2":"lImIy"}],"4HpQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListView", ()=>ListView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _reactAsyncHook = require("react-async-hook");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../common/Link");
var _userActions = require("../../redux/actions/userActions");
var _store = require("../../store");
var _failedFetchingContent = require("../common/FailedFetchingContent");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _listUserFilter = require("./listUserFilter");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _supervisorAccount = require("@mui/icons-material/SupervisorAccount");
var _supervisorAccountDefault = parcelHelpers.interopDefault(_supervisorAccount);
var _actionMenu = require("../common/Table/ActionMenu");
var _reactRouter = require("react-router");
const { userApi } = (0, _store.Api);
const RoleNum = Object.keys((0, _types.Role)).reduce((a, c, i)=>{
    return {
        ...a,
        [c]: i
    };
}, {});
const ListView = ()=>{
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const searchParams = (0, _utils.usePageParamsFiltered)();
    const { result: users, loading, error, execute: refreshUsers } = (0, _reactAsyncHook.useAsync)(()=>(0, _userActions.getUsers)(searchParams, {
            dispatch,
            userApi
        }), [
        JSON.stringify(searchParams)
    ]);
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const navigate = (0, _reactRouter.useNavigate)();
    const currentUser = (0, _utils.useUser)();
    const canEdit = (user)=>currentUser.role === (0, _types.Role).super || currentUser.role === (0, _types.Role).admin && currentUser.group === user.group && user.role !== (0, _types.Role).super;
    const canImpersonate = (userToImpersonate)=>{
        if (userToImpersonate.id === currentUser.id) return false;
        if (currentUser.role !== (0, _types.Role).super && userToImpersonate.group !== currentUser.group) return false;
        return RoleNum[userToImpersonate.role] < RoleNum[currentUser.role];
    };
    const showImpersonationDialog = (0, _utils.useConfirmationDialog)();
    const onImpersonateButtonClicked = (user)=>showImpersonationDialog(()=>void dispatch((0, _userActions.impersonateUser)(user.id)), /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "Do you want to log in as ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: user.username
                }),
                "?",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                "You will be logged out from your current session."
            ]
        }));
    const tableConfig = [
        {
            title: 'name',
            getValue: (user)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    available: canEdit(user),
                    to: routes.usersUpdate({
                        id: user.id
                    }),
                    underline: "hover",
                    children: user.username
                }),
            sorting: {
                byParameter: (0, _types.ListUserSortableField).userName
            }
        },
        {
            title: 'group',
            getValue: ({ _group })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.groupsUpdate({
                        id: _group.id
                    }),
                    underline: "hover",
                    available: (0, _utils.isEditableGroup)(_group.id, currentUser),
                    children: _group.name
                }),
            sorting: {
                byParameter: (0, _types.ListUserSortableField).groupName
            }
        },
        {
            title: 'role',
            getValue: ({ role })=>role,
            sorting: {
                byParameter: (0, _types.ListUserSortableField).role
            }
        },
        {
            title: 'MFA',
            getValue: ({ mfa, external })=>external ? '-' : mfa?.totp?.enabled ? 'Configured' : 'Not configured'
        },
        {
            title: 'Account type',
            // Checkmark
            getValue: ({ external })=>external ? 'External' : 'Internal'
        },
        {
            getValue: (user)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: canEdit(user) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                        options: [
                            {
                                label: 'Edit',
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                                onClick: ()=>{
                                    navigate(routes.usersUpdate({
                                        id: user.id
                                    }));
                                }
                            },
                            ...canImpersonate(user) ? [
                                {
                                    label: 'Impersonate',
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _supervisorAccountDefault.default), {}),
                                    onClick: ()=>{
                                        onImpersonateButtonClicked(user);
                                    }
                                }
                            ] : [],
                            ...user.id !== currentUser.id ? [
                                {
                                    label: 'Remove',
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                                    isDestructive: true,
                                    onClick: ()=>{
                                        showConfirmation(()=>void (0, _userActions.removeUser)(user, {
                                                dispatch,
                                                navigate,
                                                userApi: (0, _store.Api).userApi,
                                                routes,
                                                refreshUsers
                                            }), `Are you sure you want to remove user ${user.username}?`);
                                    }
                                }
                            ] : []
                        ]
                    })
                }),
            props: {
                align: 'right',
                noTypography: true
            }
        }
    ];
    const filters = (0, _listUserFilter.makeListUsersFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Users",
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: [
                (0, _types.Role).super,
                (0, _types.Role).admin
            ].includes(currentUser.role) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                id: "user-list-component-create-button",
                type: "button",
                to: routes.usersNew(),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    children: "Add user"
                })
            }, "addUser")
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'users',
                        mapUrlParamToFilterFn: (0, _listUserFilter.mapUrlParamToUserFilter),
                        mapFilterToUrlParamFn: (0, _listUserFilter.mapUserFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listUserFilter.ListUserFilterKey).name)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                emptyMessageComponent: error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _failedFetchingContent.FailedFetchingContent), {
                    inline: true,
                    message: 'Failed to fetch users'
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No users available",
                    buttonText: "Add user",
                    url: routes.usersNew()
                }),
                config: tableConfig,
                data: users?.items ?? [],
                id: "users-table",
                pending: loading,
                pagination: {
                    total: users?.total ?? 0,
                    useUrlSearchParams: true
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","react-async-hook":"3D6Y9","@mui/material/Button":"3qJY9","common/api/v1/types":"3qemx","../../utils":"342UB","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../common/Link":"l3o6V","../../redux/actions/userActions":"2tWgd","../../store":"5LXiG","../common/FailedFetchingContent":"dJi9P","@mui/material/Toolbar":"5Kohb","./listUserFilter":"fSTPK","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@mui/icons-material/Delete":"69aC7","@mui/icons-material/Settings":"jkTfg","@mui/icons-material/SupervisorAccount":"dzi7K","../common/Table/ActionMenu":"jf6As","react-router":"iaz4C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fSTPK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListUserFilterKey", ()=>ListUserFilterKey);
parcelHelpers.export(exports, "mapUserFilterToUrlParam", ()=>mapUserFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToUserFilter", ()=>mapUrlParamToUserFilter);
parcelHelpers.export(exports, "makeListUsersFilter", ()=>makeListUsersFilter);
var ListUserFilterKey = /*#__PURE__*/ function(ListUserFilterKey) {
    ListUserFilterKey["name"] = "name";
    return ListUserFilterKey;
}({});
function mapUserFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToUserFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListUsersFilter() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzi7K":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("4dd53762592442c5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("ff6d31ba4e4ba742"));
var _jsxRuntime = require("eabd5e0b6e005d75");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5M9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5 6 6.34 6 8s1.34 3 3 3m7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75M9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13"
}), 'SupervisorAccount');

},{"4dd53762592442c5":"kZ6eK","ff6d31ba4e4ba742":"2vOnF","eabd5e0b6e005d75":"1dlk8"}],"KziXu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Interfaces", ()=>Interfaces);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _edit = require("./Edit");
var _list = require("./List");
const Interfaces = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).UPDATE,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.ListView), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","./Edit":"aJyLz","./List":"GwOKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJyLz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _store = require("../../store");
var _pendable = require("../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _form = require("../common/Form");
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _dataSet = require("../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _link = require("../common/Link");
var _portActions = require("../../redux/actions/portActions");
var _rhf = require("../common/Form/RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
const InterfaceForm = ({ formState, getValues }, navigate, port)=>{
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const portDisabledAlarms = (0, _utils.alarmsThatDisablePort)(port._appliance, port.id);
    const values = getValues();
    const portOwnerId = values._owner.id;
    const applianceOwnerId = values._appliance?._owner.id;
    const isCoreAppliance = values._appliance?.type === (0, _types.ApplianceType).core || values._appliance?.type === (0, _types.ApplianceType).thumb;
    const isUserAllowedToEdit = applianceOwnerId && (0, _utils.isEditableInterface)(applianceOwnerId, user);
    const groupsApi = (0, _react.useCallback)((0, _store.Api).groupsApi.getPureGroups.bind((0, _store.Api).groupsApi), []);
    const networksApi = (0, _react.useCallback)((0, _store.Api).networksApi.getNetworks.bind((0, _store.Api).networksApi), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        container: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            size: {
                xs: 12
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                    formState: formState
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                    id: "interface-form",
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                            title: "Metadata",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                lg: 12,
                                xl: 12,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                                    values: {
                                        Name: values.name,
                                        Appliance: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                            to: routes.appliancesUpdate({
                                                id: values.appliance.id
                                            }),
                                            underline: "hover",
                                            available: !!values._appliance && (0, _utils.isEditableAppliance)(user, (0, _utils.getApplianceOwnerId)(values._appliance)),
                                            children: values.appliance.name
                                        }),
                                        Address: values.addresses[0]?.address,
                                        'Public address': values.addresses[0]?.publicAddress,
                                        Owner: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                            to: routes.groupsUpdate({
                                                id: portOwnerId
                                            }),
                                            underline: "hover",
                                            available: (0, _utils.isEditableGroup)(portOwnerId, user),
                                            children: values._owner.name
                                        })
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                            title: (0, _utils.getInterfaceName)(port),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                    lg: 12,
                                    xl: 12,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                                        name: "owner",
                                        api: groupsApi,
                                        defaultOption: values._owner,
                                        getOptionLabel: (option)=>option.name,
                                        getOptionValue: (option)=>option.id,
                                        optionComparator: (o1, o2)=>o1.id == o2.id,
                                        disabled: isCoreAppliance || !applianceOwnerId || !isUserAllowedToEdit,
                                        required: true
                                    })
                                }),
                                portDisabledAlarms && portDisabledAlarms.length > 0 ? portDisabledAlarms.map((portAlarm, i)=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                        xs: 12,
                                        lg: 12,
                                        xl: 12,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            component: "div",
                                            variant: "body2",
                                            color: "textSecondary",
                                            children: portAlarm.text
                                        })
                                    }, portAlarm.alarmId.concat(i.toString()));
                                }) : ''
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                            title: 'Networks',
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                lg: 12,
                                xl: 12,
                                tooltip: "Interfaces within the same network will be connected using their private IP addresses",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                                    name: "networks",
                                    label: "Networks",
                                    disabled: !isUserAllowedToEdit,
                                    api: networksApi,
                                    defaultOption: values.networks,
                                    // 'getOptionValue' is actually called with an array since 'defaultOption' provides an array (and multiple is set to true)
                                    getOptionValue: (option)=>Array.isArray(option) ? option : option.id,
                                    getOptionLabel: (option)=>option.name,
                                    optionComparator: (o1, o2)=>o1.id === o2.id,
                                    multiple: true,
                                    xs: 4
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                            main: {
                                Cancel: {
                                    onClick: ()=>navigate(routes.interfaces())
                                },
                                Save: {
                                    primary: true,
                                    type: 'submit'
                                }
                            }
                        })
                    ]
                })
            ]
        })
    });
};
const Edit = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    (0, _react.useEffect)(()=>{
        id && dispatch((0, _portActions.getPort)(id));
        return ()=>{
            dispatch((0, _portActions.clearPort)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const portToEdit = (0, _reactRedux.useSelector)(({ portsReducer })=>portsReducer.port, (0, _reactRedux.shallowEqual));
    if (!portToEdit) return null;
    const portAppliance = portToEdit._appliance;
    const onSubmit = (owner, networks)=>{
        const isChangingPortOwner = owner !== portToEdit.owner;
        const action = ()=>void dispatch((0, _portActions.updatePort)({
                appliance: portAppliance,
                sharedPorts: portAppliance.physicalPorts.map((port)=>({
                        port: port.id,
                        owner: port.id === portToEdit.id ? owner : port.owner,
                        networks: (port.id === portToEdit.id ? networks : port.networks)?.map((n)=>n.id)
                    }))
            }));
        if (isChangingPortOwner) showConfirmation(action, 'You are changing owner of an interface. All inputs and outputs on this interface will be cleared. Are you sure you want to proceed?');
        else action();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            '(Deprecated) Interfaces',
            portToEdit ? (0, _utils.getInterfaceName)(portToEdit) : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: !portToEdit,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rhfDefault.default), {
                onSubmit: (values)=>{
                    onSubmit(values.owner, values.networks);
                },
                defaultValues: {
                    ...portToEdit,
                    _owner: portToEdit._owner || ''
                },
                children: (props)=>InterfaceForm(props, navigate, portToEdit)
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","@mui/material/Grid":"6iX4B","@mui/material/Typography":"6NtGx","../../store":"5LXiG","../common/Pendable":"gDN67","../common/Form":"4Mui7","common/api/v1/types":"3qemx","../../utils":"342UB","../common/Wrapper":"8oy7r","../common/DataSet":"dmQXG","../common/Link":"l3o6V","../../redux/actions/portActions":"5YSBF","../common/Form/RHF":"7gFt3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"GwOKq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListView", ()=>ListView);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../common/Link");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _listInterfaceFilter = require("./listInterfaceFilter");
var _store = require("../../store");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
const ListView = ()=>{
    const routes = (0, _store.useRoutes)();
    const { ports: interfaces, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useInterfacesSelector));
    const user = (0, _utils.useUser)();
    const tableConfig = [
        {
            title: 'name',
            getValue: (port)=>(0, _utils.getInterfaceName)(port),
            sorting: {
                byParameter: (0, _types.ListPortSortableField).portName
            }
        },
        {
            title: 'address',
            getValue: (port)=>port.addresses[0]?.address,
            sorting: {
                byParameter: (0, _types.ListPortSortableField).address
            }
        },
        {
            title: 'public address',
            getValue: (port)=>port.addresses[0]?.publicAddress,
            sorting: {
                byParameter: (0, _types.ListPortSortableField).publicAddress
            }
        },
        {
            title: 'appliance',
            getValue: ({ appliance: { name, id }, _appliance })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.appliancesUpdate({
                        id
                    }),
                    underline: "hover",
                    available: !!_appliance && (0, _utils.isEditableAppliance)(user, (0, _utils.getApplianceOwnerId)(_appliance)),
                    children: name
                }),
            sorting: {
                byParameter: (0, _types.ListPortSortableField).applianceName
            }
        },
        {
            title: 'owner group',
            getValue: ({ _owner })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.groupsUpdate({
                        id: _owner.id
                    }),
                    available: (0, _utils.isEditableGroup)(_owner.id, user),
                    underline: "hover",
                    children: _owner.name
                }),
            sorting: {
                byParameter: (0, _types.ListPortSortableField).ownerGroupName
            }
        },
        {
            title: 'alarms',
            getValue: ({ _appliance, id: portId })=>{
                const alarms = _appliance?.alarms.filter((alarm)=>alarm.physicalPortId == portId);
                if (!alarms || alarms.length === 0) return 'no alarms';
                const portDisabledAlarms = (0, _utils.alarmsThatDisablePort)(_appliance, portId);
                if (portDisabledAlarms && portDisabledAlarms.length > 0) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        (0, _utils.pluralize)(alarms.length, 'alarm'),
                        ", interface is disabled",
                        portDisabledAlarms.map((portAlarm, i)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                component: "div",
                                variant: "body2",
                                color: "textSecondary",
                                children: portAlarm.text
                            }, portAlarm.alarmId.concat(i.toString()));
                        })
                    ]
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: (0, _utils.pluralize)(alarms.length, 'alarm')
                });
            }
        },
        {
            getValue: ({ id: portId, _appliance })=>!!_appliance && (0, _utils.isEditableInterface)((0, _utils.getApplianceOwnerId)(_appliance), user) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.MoveToEntity), {
                    url: routes.interfacesUpdate({
                        id: portId
                    }),
                    entityName: "interface",
                    dataTestId: `edit-${portId}`
                }) : null,
            props: {
                align: 'right',
                noTypography: true
            }
        }
    ];
    const filters = (0, _listInterfaceFilter.makeListInterfacesFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "(Deprecated) Interfaces",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'interfaces',
                        mapUrlParamToFilterFn: (0, _listInterfaceFilter.mapUrlParamToInterfaceFilter),
                        mapFilterToUrlParamFn: (0, _listInterfaceFilter.mapInterfaceFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listInterfaceFilter.ListInterfaceFilterKey).name)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No interfaces available"
                }),
                config: tableConfig,
                data: interfaces,
                pending: loading,
                pagination: {
                    total,
                    useUrlSearchParams: true
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../utils":"342UB","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../common/Link":"l3o6V","@mui/material/Toolbar":"5Kohb","./listInterfaceFilter":"k7wDW","../../store":"5LXiG","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k7wDW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListInterfaceFilterKey", ()=>ListInterfaceFilterKey);
parcelHelpers.export(exports, "mapInterfaceFilterToUrlParam", ()=>mapInterfaceFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToInterfaceFilter", ()=>mapUrlParamToInterfaceFilter);
parcelHelpers.export(exports, "makeListInterfacesFilter", ()=>makeListInterfacesFilter);
var ListInterfaceFilterKey = /*#__PURE__*/ function(ListInterfaceFilterKey) {
    ListInterfaceFilterKey["name"] = "name";
    return ListInterfaceFilterKey;
}({});
function mapInterfaceFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToInterfaceFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListInterfacesFilter() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bCeik":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Appliances", ()=>Appliances);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _edit = require("./Edit");
var _list = require("./List");
var _config = require("./Config");
const Appliances = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).UPDATE,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.ListView), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: ":id/config",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _config.Config), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","./Edit":"dP6FE","./List":"03vVO","./Config":"ggon3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dP6FE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _applianceActions = require("../../../redux/actions/applianceActions");
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _utils = require("../../../utils");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _confirmDialog = require("../../common/ConfirmDialog");
var _interfaces = require("./ApplianceForm/Interfaces");
var _interfacesDefault = parcelHelpers.interopDefault(_interfaces);
var _settings = require("./ApplianceForm/Settings/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _advancedSettings = require("./ApplianceForm/Settings/AdvancedSettings");
var _form = require("../../common/Form");
var _meta = require("./ApplianceForm/Meta");
var _metaDefault = parcelHelpers.interopDefault(_meta);
var _removeDialog = require("./RemoveDialog");
var _inputsOutputs = require("./ApplianceForm/InputsOutputs");
var _inputsOutputsDefault = parcelHelpers.interopDefault(_inputsOutputs);
var _applicationError = require("../../common/ApplicationError");
var _applicationErrorDefault = parcelHelpers.interopDefault(_applicationError);
var _changeRegionDialog = require("./ChangeRegionDialog");
var _notificationActions = require("../../../redux/actions/notificationActions");
var _changeSecondaryRegionDialog = require("./ChangeSecondaryRegionDialog");
var _removeSecondaryRegionDialog = require("./RemoveSecondaryRegionDialog");
var _tunnels = require("./ApplianceForm/Tunnels");
var _tunnelsDefault = parcelHelpers.interopDefault(_tunnels);
var _pcaps = require("./ApplianceForm/Pcaps");
var _versions = require("common/versions");
var _tagInputField = require("../../common/TagInputField");
var _utils1 = require("common/utils");
var _commandList = require("./CommandList");
const Edit = ()=>{
    const { id: applianceId } = (0, _reactRouter.useParams)();
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const user = (0, _utils.useUser)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const appliance = (0, _reactRedux.useSelector)(({ appliancesReducer })=>appliancesReducer.appliance, (0, _reactRedux.shallowEqual));
    const buildInfo = (0, _reactRedux.useSelector)(({ buildInfoReducer })=>buildInfoReducer.buildInfo ? (0, _utils1.pick)(buildInfoReducer.buildInfo, 'release') : undefined, (0, _reactRedux.shallowEqual));
    const releaseVersion = buildInfo?.release || 'dummy';
    const { saving, restarting, loading, error, recreatingTunnels } = (0, _reactRedux.useSelector)(({ appliancesReducer })=>({
            saving: appliancesReducer.saving,
            restarting: appliancesReducer.restarting,
            loading: appliancesReducer.loading,
            error: appliancesReducer.error,
            recreatingTunnels: appliancesReducer.recreatingTunnels
        }), (0, _reactRedux.shallowEqual));
    const { showConfirmation, showConfirmationAsync, hideConfirmation } = (0, _confirmDialog.useConfirmationDialog)();
    const { devMode } = (0, _utils.useSettingsSelector)();
    const [isFetchingOutputsAffectedByRegionChange, setIsFetchingOutputsAffectedByRegionChange] = (0, _react.useState)(false);
    const commandStatuses = useCommandStatuses(applianceId);
    const hasCommands = commandStatuses.hasResult && commandStatuses.result.length > 0;
    (0, _react.useEffect)(()=>{
        dispatch((0, _applianceActions.registerApplianceObserver)({
            applianceIds: [
                applianceId
            ]
        }));
        applianceId && dispatch((0, _applianceActions.getAppliance)(applianceId));
        return ()=>{
            dispatch((0, _applianceActions.unregisterApplianceObserver)({
                applianceIds: [
                    applianceId
                ]
            }));
            dispatch((0, _applianceActions.clearAppliance)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fetchOutputsAffectedByRegionChange = (0, _react.useCallback)(async ()=>{
        // Set high rowsPerPage because we want all affected outputs
        const outputs = await (0, _store.Api).appliancesApi.listApplianceOutputs(applianceId, {
            pageNumber: '0',
            rowsPerPage: '1000000'
        });
        // If output or its source input is disabled the output isn't considered affected
        const affectedOutputs = outputs.items.filter((x)=>x.outputAdminStatus === (0, _types.OutputAdminStatus).on && x.inputAdminStatus === (0, _types.InputAdminStatus).on).map((x)=>{
            return {
                id: x.outputId,
                name: x.outputName
            };
        });
        return affectedOutputs;
    }, [
        applianceId
    ]);
    const onSubmit = async (appliance, transformedValues)=>{
        const values = {
            ...transformedValues,
            ports: transformedValues.ports.map((port)=>({
                    ...port,
                    networks: port._networks?.map((n)=>n.id)
                }))
        };
        const region = values.region;
        if (region === undefined) // Region is required
        return;
        const hasRegionChanged = initialValues.region?.id !== region.id;
        const initSecondaryRegion = initialValues.secondaryRegion;
        const secondareRegionWasInitiallySet = initSecondaryRegion !== undefined && initSecondaryRegion !== null;
        const hasSecondaryRegionChanged = secondareRegionWasInitiallySet && initSecondaryRegion.id !== values.secondaryRegion?.id;
        // If region has changed. Fetch affected outputs and show confirmation dialog
        if (hasRegionChanged) {
            let affectedOutputs = undefined;
            try {
                setIsFetchingOutputsAffectedByRegionChange(true);
                affectedOutputs = await fetchOutputsAffectedByRegionChange();
            } catch (err) {
                dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                    error: err,
                    operation: 'Failed to fetch outputs affected by region change'
                }));
                return;
            } finally{
                setIsFetchingOutputsAffectedByRegionChange(false);
            }
            // Show confirmation dialog if any output is affected
            if (affectedOutputs.length > 0) {
                // Limit for number of outputs to show in confirm dialog
                const limit = 10;
                const result = await showConfirmationAsync(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeRegionDialog.ChangeRegionDialog), {
                    applianceName: appliance.name,
                    newRegionName: region.name,
                    affectedOutputs: affectedOutputs,
                    limit: limit
                }), undefined, {
                    ok: {
                        text: 'Accept'
                    }
                });
                if (result !== (0, _confirmDialog.ConfirmationDialogResult).OK) // Cancel submit
                return;
            }
            // Send all affected outputs in the update request to make sure conditions haven't changed
            // For example if another user creates another output on this appliance while the confirmation dialog is shown
            const acceptDisruptionsOutputIds = affectedOutputs.map((x)=>x.id);
            values.acceptDisruption = {
                outputs: acceptDisruptionsOutputIds
            };
        } else if (hasSecondaryRegionChanged) {
            // If secondary region has changed but not primary warn about reduced redundancy
            const secondaryRegionName = values.secondaryRegion?.name ?? null;
            // Different dialogs depending on change or remove
            if (secondaryRegionName !== null) {
                const result = await showConfirmationAsync(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeSecondaryRegionDialog.ChangeSecondaryRegionDialog), {
                    applianceName: appliance.name,
                    newSecondaryRegionName: secondaryRegionName
                }), undefined, {
                    ok: {
                        text: 'Change secondary region'
                    }
                });
                if (result !== (0, _confirmDialog.ConfirmationDialogResult).OK) // Cancel submit
                return;
            } else {
                const result = await showConfirmationAsync(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeSecondaryRegionDialog.RemoveSecondaryRegionDialog), {
                    applianceName: appliance.name
                }), undefined, {
                    ok: {
                        text: 'Remove secondary region',
                        color: 'error'
                    }
                });
                if (result !== (0, _confirmDialog.ConfirmationDialogResult).OK) // Cancel submit
                return;
            }
        }
        // If owner of a port has changed. Show confirmation dialog
        const hasAnyPortOwnerChanged = values.ports.some((port)=>port.owner !== port._owner.id);
        if (hasAnyPortOwnerChanged) {
            const result = await showConfirmationAsync('You are changing owner of an interface. All inputs and outputs on this interface will be cleared. Are you sure you want to proceed?', undefined);
            if (result !== (0, _confirmDialog.ConfirmationDialogResult).OK) // Cancel submit
            return;
        }
        if (appliance.type === (0, _types.ApplianceType).matroxMonarchEdgeE4_10Bit && appliance.settings.apiVersion === 'v2') {
            const applianceSettings = values.settings;
            const initialApplianceSettings = initialValues?.settings;
            const didUpdateIoConfig = applianceSettings?.ioConfig != initialApplianceSettings?.ioConfig;
            if (didUpdateIoConfig) {
                const result = await showConfirmationAsync('Updating the I/O config will reboot the Matrox system - all inputs and outputs on this appliance will be affected. Are you sure you want to proceed?', undefined);
                if (result !== (0, _confirmDialog.ConfirmationDialogResult).OK) // Cancel submit
                return;
            }
        }
        // Send request to update appliance. Redirect to appliance list
        try {
            await dispatch((0, _applianceActions.updateAppliance)({
                appliance,
                values: values,
                redirect: true
            }));
        } catch (err) {
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: err,
                operation: 'Failed to update appliance'
            }));
        }
    };
    const onDelete = (appliance)=>{
        showConfirmation(()=>performDelete(appliance), /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeDialog.RemoveDialog), {
            appliance: appliance,
            hideConfirmDialog: hideConfirmation
        }), undefined, {
            ok: {
                text: 'remove',
                color: 'error'
            }
        });
    };
    const performRestartAppliance = (appliance)=>{
        showConfirmation(()=>void dispatch((0, _applianceActions.restartAppliance)({
                id: appliance.id,
                showSuccessSnackbar: true
            })), 'Restarting will affect all video streams on the appliance. After restart the appliance will run the latest software version. Do you want to continue?', undefined, {
            ok: {
                text: 'restart'
            }
        });
    };
    const performUpgradeImage = async (appliance, imageVersion)=>{
        const result = await showConfirmationAsync('Upgrading the image will affect all video streams on the appliance. After the upgrade, the appliance will run the latest image version and software version. Do you want to continue?', appliance.name);
        if (result !== (0, _confirmDialog.ConfirmationDialogResult).OK) return;
        await (0, _store.Api).appliancesApi.upgradeImage(appliance.id, imageVersion);
        commandStatuses.trigger();
    };
    const performRecreateTunnels = (appliance)=>{
        showConfirmation(()=>void dispatch((0, _applianceActions.recreateTunnels)({
                id: appliance.id
            })), 'Recreating tunnels will affect all video streams on the appliance that involve RIST tunnels. Do you want to continue?');
    };
    const performDelete = (appliance)=>{
        dispatch((0, _applianceActions.removeAppliance)(appliance.id));
        navigate(routes.appliances());
    };
    if (appliance && user.group && appliance.owner.id !== user.group && user.role !== (0, _types.Role).super) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Navigate), {
        to: routes.appliances()
    });
    const isCoreNode = appliance?.type === (0, _types.ApplianceType).core;
    const isThumbNode = appliance?.type === (0, _types.ApplianceType).thumb;
    const isApplianceOwner = user.group === (0, _utils.getApplianceOwnerId)(appliance);
    let showDeleteButton = false;
    if (user.role === (0, _types.Role).super) showDeleteButton = true;
    else if (!isCoreNode && !isThumbNode && user.role === (0, _types.Role).admin && isApplianceOwner) showDeleteButton = true;
    const ports = (appliance?._physicalPorts || []).map(({ id: port, name, _owner, owner, addresses, networks })=>({
            port,
            name,
            owner,
            networks: networks?.map((network)=>network.id),
            _networks: networks,
            _address: addresses[0]?.address,
            _publicAddress: addresses[0]?.publicAddress,
            _interRegionPublicAddress: addresses[0]?.interRegionPublicAddress,
            _owner,
            _alarmsThatDisablePort: (0, _utils.alarmsThatDisablePort)(appliance, port)
        }));
    const restartAction = (appliance)=>({
            'Restart appliance': {
                onClick: ()=>performRestartAppliance(appliance),
                savingState: !!restarting
            }
        });
    const upgradeImageAction = (appliance)=>{
        const getState = ()=>{
            const canUpgrade = appliance?.settings.capabilities?.canUpgrade;
            const controlImageVersion = appliance?.version.controlImageVersion;
            const release = buildInfo?.release;
            if (canUpgrade === undefined || controlImageVersion === undefined || release === undefined) // If the image upgrade code is not available (for example if software upgrade needed)
            return {
                disabled: true,
                tooltip: 'Not supported. Make sure software is up-to-date'
            };
            if (canUpgrade === false) return {
                disabled: true,
                tooltip: 'Not supported for this appliance'
            };
            if (release === controlImageVersion) return {
                disabled: true,
                tooltip: 'Already up-to-date'
            };
            return {
                disabled: false
            };
        };
        return {
            'Upgrade image': {
                onClick: ()=>{
                    performUpgradeImage(appliance, releaseVersion);
                },
                ...getState()
            }
        };
    };
    const recreateTunnelsAction = (appliance)=>{
        const recreate = {
            'Recreate tunnels': {
                onClick: ()=>performRecreateTunnels(appliance),
                savingState: !!recreatingTunnels
            }
        };
        if (devMode) return recreate;
        else return {};
    };
    const initialValues = appliance ? {
        id: appliance.id,
        geoLocation: appliance.geoLocation || null,
        logLevel: appliance.logLevel,
        ristserverLogLevel: appliance.ristserverLogLevel,
        collectHostMetrics: appliance.collectHostMetrics || false,
        unhealthyAlarm: appliance.unhealthyAlarm,
        cordon: appliance.cordon,
        ports: ports,
        region: appliance.region || null,
        secondaryRegion: appliance.secondaryRegion || null,
        tags: appliance.tags,
        settings: {
            ...appliance.settings,
            useDynamicTunnelClientSourceAddress: appliance.settings.useDynamicTunnelClientSourceAddress ?? false,
            useEphemeralTunnelSenderPorts: appliance.settings.useEphemeralTunnelSenderPorts ?? false,
            proxy: Object.assign({
                ...appliance.features.proxy
            }, appliance.settings.proxy)
        }
    } : undefined;
    const savingState = saving === true || isFetchingOutputsAffectedByRegionChange;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Appliances',
            appliance?.name
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
            pending: loading,
            children: [
                initialValues && appliance && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                    onSubmit: async (values)=>{
                        const transformed = (0, _utils.formTransform)(values, {
                            secondaryRegion: {
                                _transform: (v)=>{
                                    if (v === '' || v == null) return null;
                                    return v;
                                }
                            },
                            collectHostMetrics: {
                                __transform: (v)=>{
                                    if (v === 'on') return true;
                                    return false;
                                }
                            },
                            unhealthyAlarm: {
                                _transform: (v)=>v
                            },
                            cordon: {
                                _transform: (v)=>!!v
                            }
                        });
                        if (values.geoLocation === null) transformed['geoLocation'] = null;
                        let hasNonDefaultProxySetting = false;
                        for (const key of Object.keys(transformed.settings.proxy)){
                            const defaultVal = appliance?.features?.proxy?.[key];
                            const configuredVal = transformed.settings.proxy[key];
                            const isDeepEqualToDefault = (0, _isEqualDefault.default)(configuredVal, defaultVal);
                            const configIsEmptyArrayAndDefaultIsUndefined = (0, _isEqualDefault.default)(configuredVal, []) && defaultVal === undefined;
                            const propertyHasDefaultValue = isDeepEqualToDefault || configIsEmptyArrayAndDefaultIsUndefined;
                            if (!propertyHasDefaultValue) {
                                hasNonDefaultProxySetting = true;
                                break;
                            } else transformed.settings.proxy[key] = null;
                        }
                        if (!hasNonDefaultProxySetting) transformed.settings.proxy = null;
                        await onSubmit(appliance, transformed);
                    },
                    defaultValues: initialValues,
                    children: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                                    formState: props.formState
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                                    id: "appliance-form",
                                    noValidate: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _metaDefault.default), {
                                            appliance: appliance
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                            title: "Tags",
                                            collapsible: true,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagInputField.TagInputField), {
                                                formName: 'tags',
                                                type: 'appliance',
                                                commentProps: {
                                                    paddingBottom: '20px'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {
                                            secondaryRegion: appliance.secondaryRegion,
                                            region: appliance.region,
                                            geoLocation: appliance.geoLocation,
                                            type: appliance.type,
                                            settings: props.getValues().settings
                                        }),
                                        devMode && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _advancedSettings.AdvancedSettings), {
                                            type: appliance.type,
                                            settings: props.getValues().settings
                                        }) || null,
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _interfacesDefault.default), {
                                            ports: ports,
                                            appliance: appliance
                                        }),
                                        appliance.type !== (0, _types.ApplianceType).thumb && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputsOutputsDefault.default), {
                                            appliance: appliance
                                        }),
                                        user.role === (0, _types.Role).super && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tunnelsDefault.default), {
                                            appliance: appliance
                                        }),
                                        devMode && user.role === (0, _types.Role).super && (0, _versions.supportsPcap)(appliance.version) && appliance.type !== (0, _types.ApplianceType).thumb && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pcaps.Pcaps), {
                                            appliance: appliance
                                        }),
                                        hasCommands && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandList.CommandList), {
                                            statuses: commandStatuses.result
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                                            main: {
                                                Cancel: {
                                                    onClick: ()=>navigate(routes.appliances())
                                                },
                                                Save: {
                                                    primary: true,
                                                    savingState: savingState,
                                                    type: 'submit'
                                                }
                                            },
                                            secondary: showDeleteButton ? {
                                                ...restartAction(appliance),
                                                'Remove appliance': {
                                                    onClick: ()=>onDelete(appliance)
                                                },
                                                ...upgradeImageAction(appliance),
                                                ...recreateTunnelsAction(appliance)
                                            } : restartAction(appliance)
                                        })
                                    ]
                                })
                            ]
                        })
                }),
                !appliance && error && !loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _applicationErrorDefault.default), {
                    error: error,
                    onOKButtonClicked: ()=>navigate(-1)
                })
            ]
        })
    });
};
const useCommandStatuses = (applianceId)=>{
    const longCommandPollInterval = 10000;
    const shortCommandPollInterval = 1000;
    const [commandPollInterval, setCommandPollInterval] = (0, _react.useState)(longCommandPollInterval);
    return (0, _utils.useIntervalState)(async ()=>{
        const commandInfos = await (0, _store.Api).appliancesApi.listApplianceCommands(applianceId);
        if (commandInfos.some((x)=>x.status.type === 'in-progress' || x.status.type === 'not-started')) setCommandPollInterval(shortCommandPollInterval);
        else setCommandPollInterval(longCommandPollInterval);
        return commandInfos.map((c)=>{
            const common = {
                id: c.id,
                title: mapCommandNameToTitle(c.name),
                createdAt: c.createdAt
            };
            switch(c.status.type){
                case 'not-started':
                    return (0, _commandList.commandNotStarted)({
                        ...common
                    });
                case 'in-progress':
                    return (0, _commandList.commandInProgress)({
                        ...common,
                        progressPercentage: c.status.progress,
                        message: c.status.status
                    });
                case 'error':
                    return (0, _commandList.commandFailed)({
                        ...common,
                        message: c.status.error
                    });
                case 'success':
                    return (0, _commandList.commandSuccess)({
                        ...common
                    });
            }
        });
    }, commandPollInterval);
};
const mapCommandNameToTitle = (name)=>{
    switch(name){
        case 'upgradeImage':
            return 'Upgrading container images';
        case 'upgradeEdgeOs':
            return 'Upgrading operating system';
    }
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","react-redux":"l1pMU","lodash/isEqual":"3mRdp","../../../redux/actions/applianceActions":"TaoIu","common/api/v1/types":"3qemx","../../../store":"5LXiG","../../../utils":"342UB","../../common/Pendable":"gDN67","../../common/Wrapper":"8oy7r","../../common/ConfirmDialog":"7JKPn","./ApplianceForm/Interfaces":"8fKpN","./ApplianceForm/Settings/Settings":"9AnQq","./ApplianceForm/Settings/AdvancedSettings":"6afLU","../../common/Form":"4Mui7","./ApplianceForm/Meta":"l2TT1","./RemoveDialog":"fYcBA","./ApplianceForm/InputsOutputs":"7iZcY","../../common/ApplicationError":"76l2T","./ChangeRegionDialog":"6G9xJ","../../../redux/actions/notificationActions":"7LkQg","./ChangeSecondaryRegionDialog":"85DAT","./RemoveSecondaryRegionDialog":"gHa0a","./ApplianceForm/Tunnels":"978yf","./ApplianceForm/Pcaps":"2aNMn","common/versions":"4vuwV","../../common/TagInputField":"cjjJd","common/utils":"2AqiH","./CommandList":"1MybS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8fKpN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _form = require("../../../common/Form");
var _store = require("../../../../store");
var _utils = require("../../../../utils");
const PortAlarms = ({ alarms })=>{
    if (!alarms) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: alarms.map((alarm)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                xs: 4,
                lg: 4,
                xl: 4,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "div",
                    variant: "body2",
                    color: "textSecondary",
                    children: alarm.text
                })
            }, alarm.alarmId))
    });
};
const Interfaces = ({ ports, appliance })=>{
    const isCoreNode = appliance.type === (0, _types.ApplianceType).core;
    const isThumbNode = appliance.type === (0, _types.ApplianceType).thumb;
    const user = (0, _utils.useUser)();
    const applianceOwnerId = typeof appliance.owner === 'string' ? appliance.owner : appliance.owner?.id;
    const isUserAllowedToEdit = applianceOwnerId && (0, _utils.isEditableInterface)(applianceOwnerId, user);
    const canEditInterfaceOwner = (_port)=>isUserAllowedToEdit && !isCoreNode && !isThumbNode;
    const groupsApi = (0, _react.useCallback)((0, _store.Api).groupsApi.getPureGroups.bind((0, _store.Api).groupsApi), []);
    const networksApi = (0, _react.useCallback)((0, _store.Api).networksApi.getNetworks.bind((0, _store.Api).networksApi), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Interfaces",
        collapsible: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
            style: {
                width: '100%'
            },
            children: ports.map((port, ind)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemDefault.default), {
                            sx: {
                                padding: 0
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.GridItem), {
                                        lg: 12,
                                        xl: 12,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                                disableTypography: true,
                                                primary: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                    children: (0, _utils.getInterfaceName)({
                                                        ...port,
                                                        appliance
                                                    })
                                                }),
                                                secondary: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                            component: "div",
                                                            variant: "body2",
                                                            color: "textSecondary",
                                                            children: port._address
                                                        }),
                                                        !!port._publicAddress && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                            component: "div",
                                                            variant: "body2",
                                                            color: "textSecondary",
                                                            children: [
                                                                "Public address: ",
                                                                port._publicAddress
                                                            ]
                                                        }),
                                                        !!port._interRegionPublicAddress && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                            component: "div",
                                                            variant: "body2",
                                                            color: "textSecondary",
                                                            children: [
                                                                "Inter region address: ",
                                                                port._interRegionPublicAddress
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PortAlarms, {
                                                alarms: port._alarmsThatDisablePort
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                                        name: `ports.${ind}.owner`,
                                        label: "Owner group",
                                        api: groupsApi,
                                        defaultOption: port.owner ? {
                                            id: port.owner,
                                            name: port._owner.name
                                        } : undefined,
                                        getOptionValue: (option)=>option.id,
                                        getOptionLabel: (option)=>option.name,
                                        optionComparator: (o1, o2)=>o1.id == o2.id,
                                        required: true,
                                        disabled: !canEditInterfaceOwner(port),
                                        xs: 4
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                                        name: `ports.${ind}._networks`,
                                        label: "Networks",
                                        api: networksApi,
                                        defaultOption: port._networks,
                                        getOptionValue: (option)=>option.id,
                                        getOptionLabel: (option)=>option.name,
                                        optionComparator: (o1, o2)=>o1.id == o2.id,
                                        multiple: true,
                                        xs: 4,
                                        tooltip: "Interfaces within the same network will be connected using their private IP addresses",
                                        disabled: !isUserAllowedToEdit
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {})
                    ]
                }, port.port))
        })
    });
};
exports.default = Interfaces;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Divider":"9Ul8c","@mui/material/List":"a52pA","@mui/material/ListItem":"fosVg","@mui/material/ListItemText":"1ZvGq","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../../common/Form":"4Mui7","../../../../store":"5LXiG","../../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9AnQq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _store = require("../../../../../store");
var _utils = require("../../../../../utils");
var _applianceSpecificSettings = require("./ApplianceSpecificSettings");
var _applianceSpecificSettingsDefault = parcelHelpers.interopDefault(_applianceSpecificSettings);
const Settings = ({ region, geoLocation, type, settings, secondaryRegion })=>{
    const { getValues, setValue, trigger, watch } = (0, _reactHookForm.useFormContext)();
    const { devMode } = (0, _utils.useSettingsSelector)();
    const regionApi = (0, _react.useCallback)((0, _store.Api).regionApi.getRegions.bind((0, _store.Api).regionApi), []);
    const locationApi = (0, _react.useCallback)((0, _store.Api).locationApi.searchLocation.bind((0, _store.Api).locationApi), []);
    const unhealthyAlarm = watch('unhealthyAlarm');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Settings",
        collapsible: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                name: "region",
                required: true,
                api: regionApi,
                defaultOption: region,
                disabled: type === (0, _types.ApplianceType).core || type === (0, _types.ApplianceType).thumb,
                getOptionLabel: (option)=>option.name,
                getOptionValue: (option)=>option,
                optionComparator: (o1, o2)=>o1.id === o2.id,
                onChange: ()=>void trigger('secondaryRegion')
            }),
            type !== (0, _types.ApplianceType).core && type !== (0, _types.ApplianceType).thumb && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                name: "secondaryRegion",
                api: regionApi,
                defaultOption: secondaryRegion,
                getOptionLabel: (option)=>option.name,
                getOptionValue: (option)=>option,
                optionComparator: (o1, o2)=>o1.id === o2.id,
                label: "Secondary region",
                validateFn: (value)=>{
                    const currentRegion = getValues('region');
                    if (value && value.id === currentRegion?.id) return 'Secondary region cannot be the same as the primary region';
                    return undefined;
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                name: "geoLocation",
                label: "City",
                api: locationApi,
                defaultOption: geoLocation,
                getOptionLabel: (option)=>option.location,
                getOptionValue: (option)=>option,
                optionComparator: ({ coordinates: c1 }, { coordinates: c2 })=>c1[0] === c2[0] && c1[1] === c2[1],
                comment: type === (0, _types.ApplianceType).core ? 'When changing City on a Core node, all other Core nodes in the region are updated with the same city.' : ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Log level",
                name: "logLevel",
                options: Object.entries((0, _utils.numericEnum)((0, _types.LogLevel))).map(([name, value])=>({
                        name,
                        value
                    }))
            }),
            devMode && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                label: "Log level for ristserver",
                name: "ristserverLogLevel",
                options: Object.entries((0, _types.RistserverLogLevel)).map(([name, value])=>({
                        name,
                        value
                    }))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: 'Collect Appliance Host Metrics',
                name: `collectHostMetrics`,
                tooltip: "Collect system metrics for monitoring from this Appliance if enabled."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: "Offline alarm",
                tooltip: "Alarm when this Appliance is offline.",
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    name: "offlineAlarm",
                    checked: unhealthyAlarm !== 'off',
                    onChange: (e)=>{
                        setValue('unhealthyAlarm', e.target.checked ? null : 'off');
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: 'Cordon appliance',
                name: `cordon`,
                tooltip: "When checked, this appliance will not accept new services to be scheduled on it."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _applianceSpecificSettingsDefault.default), {
                devMode: devMode,
                type: type,
                settings: settings
            })
        ]
    });
};
exports.default = Settings;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-hook-form":"8z0aI","@mui/material/Checkbox":"ag1Z5","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","../../../../../store":"5LXiG","../../../../../utils":"342UB","./ApplianceSpecificSettings":"boYkr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"boYkr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _form = require("../../../../common/Form");
var _matroxE4SettingsComp = require("./MatroxE4SettingsComp");
var _matroxE4SettingsCompDefault = parcelHelpers.interopDefault(_matroxE4SettingsComp);
var _matroxD4SettingsComp = require("./MatroxD4SettingsComp");
var _matroxD4SettingsCompDefault = parcelHelpers.interopDefault(_matroxD4SettingsComp);
var _matroxS1SettingsComp = require("./MatroxS1SettingsComp");
var _matroxS1SettingsCompDefault = parcelHelpers.interopDefault(_matroxS1SettingsComp);
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _nimbraVaSettingsComp = require("./NimbraVaSettingsComp");
var _nimbraVaSettingsCompDefault = parcelHelpers.interopDefault(_nimbraVaSettingsComp);
const ApplianceSpecificSettings = ({ type, settings })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: 'Use dynamic tunnel client source address (0.0.0.0)',
                name: `settings.useDynamicTunnelClientSourceAddress`,
                tooltip: "Enabling this setting will ensure that new tunnels are created with a source address of 0.0.0.0. Enable this on appliances where you want to use multiple NICs for the video traffic."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: 'Use ephemeral local ports for tunnels',
                name: `settings.useEphemeralTunnelSenderPorts`,
                tooltip: "Enabling this setting will make tunnels scale better over the available cores and can provide significant performance improvements for high traffic appliances. The tunnel data traffic will originate from ports in the ephemeral range. This setting should only be enabled when there are no firewall restrictions on source ports and there is no symmetric NAT in front of the edge appliance when it has Outputs configured on it. Enabling this will cause a short service disruption during reconfiguration."
            }),
            [
                (0, _types.ApplianceType).matroxMonarchEdgeD4
            ].includes(type) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matroxD4SettingsCompDefault.default), {
                settings: settings
            }),
            [
                (0, _types.ApplianceType).matroxMonarchEdgeS1
            ].includes(type) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matroxS1SettingsCompDefault.default), {
                settings: settings
            }),
            (0, _applianceTypeUtil.isVaApplianceType)(type) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nimbraVaSettingsCompDefault.default), {
                settings: settings
            }),
            [
                (0, _types.ApplianceType).matroxMonarchEdgeE4_8Bit,
                (0, _types.ApplianceType).matroxMonarchEdgeE4_10Bit
            ].includes(type) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matroxE4SettingsCompDefault.default), {
                settings: settings,
                applianceType: type
            })
        ]
    });
};
exports.default = ApplianceSpecificSettings;

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../../common/Form":"4Mui7","./MatroxE4SettingsComp":"b0XRX","./MatroxD4SettingsComp":"83XNk","./MatroxS1SettingsComp":"beKag","common/applianceTypeUtil":"3z9on","./NimbraVaSettingsComp":"7U1Ld","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b0XRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../../common/Form");
var _types = require("common/api/v1/types");
var _reactHookForm = require("react-hook-form");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _matrox = require("common/matrox");
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _react = require("react");
const resolutionOptions = Object.values((0, _types.MatroxEncoderGenlockResolution));
const ioConfigOptions = Object.values((0, _types.MatroxEncoderIOConfig));
// From Matrox: Currently in 2.0.9 there is a limitation for the E4 decoder genlock in 3:1 and 2:2 modes
// where it will only be an output physically on the connector, so it will not work in external mode
const e4DecoderGenlockSourceOptions = [
    (0, _types.MatroxDecoderGenlockSource).internal
];
const decoderGenlockFramerateFamilyOptions = Object.values((0, _types.MatroxDecoderFramerateFamily));
const MatroxE4SettingsComp = ({ settings, applianceType })=>{
    const isRunningMatroxV2 = false // FIXME MG: Uncomment when we wish to support matrox v2 features: settings.apiVersion === 'v2'
    ;
    const is10BitE4 = applianceType === (0, _types.ApplianceType).matroxMonarchEdgeE4_10Bit;
    const { setValue, watch } = (0, _reactHookForm.useFormContext)();
    const ioConfigKey = 'settings.ioConfig';
    watch(ioConfigKey) // Changing the ioConfig recalculates the numberOfInputSdiPorts
    ;
    const selectIOConfig = (value)=>{
        setValue(ioConfigKey, value);
    };
    const handlePcmModeClick = (portIndex, checked)=>{
        const currentValue = settings.sdiPortsWithPcmModeEnabled ?? [];
        const newValue = checked ? [
            ...currentValue,
            portIndex
        ].sort() : currentValue.filter((i)=>i !== portIndex);
        setValue(`settings.sdiPortsWithPcmModeEnabled`, newValue, {
            shouldValidate: true
        });
    };
    (0, _react.useEffect)(()=>{
        function setDefaultIoConfig() {
            if (!settings.ioConfig) setValue(ioConfigKey, (0, _types.MatroxEncoderIOConfig).fourZero);
        }
        setDefaultIoConfig();
    }, []);
    const numberOfInputSdiPorts = (0, _matrox.getNumberOfInputSdiPortsFromIOConfig)(settings.ioConfig);
    const pcmModeCheckboxes = [
        0,
        1,
        2,
        3
    ].map((portIndex)=>{
        const isPcmModeEnabled = settings.sdiPortsWithPcmModeEnabled?.includes(portIndex) ?? false;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
            xs: 2,
            lg: 2,
            xl: 2,
            label: `SDI-${portIndex + 1}`,
            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                checked: isPcmModeEnabled,
                disabled: portIndex >= numberOfInputSdiPorts,
                onChange: (_, checked)=>handlePcmModeClick(portIndex, checked)
            })
        }, `SDI-${portIndex}`);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Matrox E4 Settings",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                title: "Encoder Genlock",
                className: "outlined",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        label: 'Enabled',
                        name: `settings.genlock.isEnabled`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "Resolution",
                        name: `settings.genlock.resolution`,
                        required: true,
                        disabled: !settings.genlock.isEnabled,
                        options: resolutionOptions
                    })
                ]
            }),
            isRunningMatroxV2 && is10BitE4 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                title: "Decoder Genlock",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "Source",
                        name: `settings.decoderGenlock.source`,
                        required: true,
                        options: e4DecoderGenlockSourceOptions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "Framerate Family",
                        name: `settings.decoderGenlock.framerateFamily`,
                        required: true,
                        options: decoderGenlockFramerateFamilyOptions
                    })
                ]
            }),
            isRunningMatroxV2 && is10BitE4 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: "I/O Configuration",
                className: "outlined",
                tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Determines how the SDI connectors are configured:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " 4:0: 4 SDI inputs, 0 SDI outputs",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " 3:1: 3 SDI inputs, 1 SDI output",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " 2:2: 2 SDI inputs, 2 SDI outputs"
                    ]
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
                        row: true,
                        value: settings.ioConfig ?? (0, _types.MatroxEncoderIOConfig).fourZero,
                        onChange: (e)=>selectIOConfig(e.target.value),
                        children: ioConfigOptions.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: option,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                label: option.toString()
                            }, option))
                    })
                })
            }),
            isRunningMatroxV2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: "Input SDI PCM Mode",
                className: "outlined",
                tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        "Enables raw audio capture. When enabled:",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " - all processors using the SDI port will be handling PCM audio",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " - it is not possible to mix AAC and PCM at the same time",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " - only MPEG-2 TS outputs and SRT outputs are allowed, outputs of other types will not work"
                    ]
                }),
                children: pcmModeCheckboxes
            })
        ]
    });
};
exports.default = MatroxE4SettingsComp;

},{"react/jsx-runtime":"1dlk8","../../../../common/Form":"4Mui7","common/api/v1/types":"3qemx","react-hook-form":"8z0aI","@mui/material/Checkbox":"ag1Z5","common/matrox":"4mxaf","@mui/material/FormControlLabel":"45VZW","@mui/material/Radio":"hyH25","@mui/material/RadioGroup":"l1i9K","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"83XNk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../../common/Form");
var _types = require("common/api/v1/types");
const sourceOptions = Object.values((0, _types.MatroxDecoderGenlockSource));
const framerateFamilyOptions = Object.values((0, _types.MatroxDecoderFramerateFamily));
const MatroxD4SettingsComp = (_)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Matrox D4 Settings",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
            title: "Decoder Genlock",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                    label: "Source",
                    name: `settings.genlock.source`,
                    required: true,
                    options: sourceOptions
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                    label: "Framerate Family",
                    name: `settings.genlock.framerateFamily`,
                    required: true,
                    options: framerateFamilyOptions
                })
            ]
        })
    });
};
exports.default = MatroxD4SettingsComp;

},{"react/jsx-runtime":"1dlk8","../../../../common/Form":"4Mui7","common/api/v1/types":"3qemx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"beKag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../../common/Form");
var _types = require("common/api/v1/types");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _reactHookForm = require("react-hook-form");
const sourceOptions = Object.values((0, _types.MatroxDecoderGenlockSource));
const framerateFamilyOptions = Object.values((0, _types.MatroxDecoderFramerateFamily));
const MatroxS1SettingsComp = ({ settings })=>{
    const { setValue } = (0, _reactHookForm.useFormContext)();
    const isRunningMatroxV2 = false // FIXME MG: Uncomment when we wish to support matrox v2 features: settings.apiVersion === 'v2'
    ;
    const portIndex = 0;
    const handlePcmModeClick = (portIndex, checked)=>{
        const currentValue = settings.sdiPortsWithPcmModeEnabled ?? [];
        const newValue = checked ? [
            ...currentValue,
            portIndex
        ].sort() : currentValue.filter((i)=>i !== portIndex);
        setValue(`settings.sdiPortsWithPcmModeEnabled`, newValue, {
            shouldValidate: true
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Matrox S1 Settings",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                title: "Decoder Genlock",
                className: "outlined",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "Source",
                        name: `settings.genlock.source`,
                        required: true,
                        options: sourceOptions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                        label: "Framerate Family",
                        name: `settings.genlock.framerateFamily`,
                        required: true,
                        options: framerateFamilyOptions
                    })
                ]
            }),
            isRunningMatroxV2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: "Input SDI",
                className: "outlined",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                    title: "PCM Mode",
                    className: "outlined",
                    tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            "Enables raw audio capture. When enabled:",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            " - all processors using the SDI port will be handling PCM audio",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            " - it is not possible to mix AAC and PCM at the same time",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            " - only MPEG-2 TS outputs and SRT outputs are allowed, outputs of other types will not work"
                        ]
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                        xs: 2,
                        lg: 2,
                        xl: 2,
                        label: `SDI-1`,
                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                            checked: settings.sdiPortsWithPcmModeEnabled?.includes(portIndex) ?? false,
                            disabled: false,
                            onChange: (_, checked)=>handlePcmModeClick(portIndex, checked)
                        })
                    }, `SDI-1`)
                })
            })
        ]
    });
};
exports.default = MatroxS1SettingsComp;

},{"react/jsx-runtime":"1dlk8","../../../../common/Form":"4Mui7","common/api/v1/types":"3qemx","@mui/material/Checkbox":"ag1Z5","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7U1Ld":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../../common/Form");
const NimbraVaSettingsComp = (_)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
        label: "Automatically managed tunnel routes",
        name: `settings.autoRouteTunnels`,
        tooltip: "Enabling this option allows the VA to automatically manage route entries for dual ISP redundancy. Two default routes, one per network interface, must be manually added. Edge will ensure tunnel traffic is correctly routed through each ISP"
    });
};
exports.default = NimbraVaSettingsComp;

},{"react/jsx-runtime":"1dlk8","../../../../common/Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6afLU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdvancedSettings", ()=>AdvancedSettings);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../../../common/Form");
var _multiSelect = require("../../../../common/Form/MultiSelect");
const AdvancedSettings = ({ type, settings })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Advanced settings",
        collapsible: true,
        collapsed: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                label: 'Enable UI Proxy',
                name: `settings.proxy.enabled`,
                tooltip: "The UI Proxy enables access to the appliance local UI remotely through a link in the appliance list with the title 'Manage appliance'. This feature requires the EDGE_EXTERNAL_UI_ENDPOINT environment variable to be set to the url of the local web UI when starting the edge-connect."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiSelect.MultiSelect), {
                disabled: !settings?.proxy?.enabled,
                newLine: true,
                name: `settings.proxy.forwardedCookies`,
                label: `Forwarded cookies`,
                required: false,
                tooltip: "Whitelist of cookies that will be forwarded through the UI proxy. For prefix matching, add a '*' to the end of the cookie name."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiSelect.MultiSelect), {
                disabled: !settings?.proxy?.enabled,
                name: `settings.proxy.forwardedHeaders`,
                label: `Forwarded headers`,
                required: false,
                tooltip: "Whitelist of headers that will be forwarded through the UI proxy."
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","../../../../common/Form":"4Mui7","../../../../common/Form/MultiSelect":"0UoTN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0UoTN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiSelect", ()=>MultiSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _autocomplete = require("@mui/material/Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _gridItem = require("./GridItem");
var _gridItemDefault = parcelHelpers.interopDefault(_gridItem);
const MultiSelect = ({ name, label, required = false, disabled = false, comment, commentProps, xs, newLine, tooltip, ...textFieldProps })=>{
    const { getFieldState } = (0, _reactHookForm.useFormContext)();
    const hasError = Boolean(getFieldState(name)?.error);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridItemDefault.default), {
        xs: xs,
        newLine: newLine,
        tooltip: tooltip,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlDefault.default), {
            fullWidth: true,
            margin: "normal",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                name: name,
                render: ({ field })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteDefault.default), {
                        multiple: true,
                        freeSolo: true,
                        options: [],
                        disabled: disabled,
                        value: field.value,
                        onChange: (_, newValue)=>{
                            // Update react-hook-form on tag change
                            field.onChange(newValue);
                        },
                        // Render the selected tags as Chips
                        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, _react.createElement)((0, _chipDefault.default), {
                                    variant: "outlined",
                                    label: option,
                                    ...getTagProps({
                                        index
                                    }),
                                    key: option
                                })),
                        // Render the input field
                        renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                ...params,
                                ...textFieldProps,
                                label: label || name,
                                variant: "outlined",
                                required: required,
                                error: hasError,
                                helperText: hasError ? getFieldState(name)?.error?.message : comment
                            })
                    })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-hook-form":"8z0aI","@mui/material/FormControl":"ioFZ4","@mui/material/Autocomplete":"avdFA","@mui/material/TextField":"l88b4","@mui/material/Chip":"5cK8z","./GridItem":"hSZf2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l2TT1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _openInNew = require("@mui/icons-material/OpenInNew");
var _openInNewDefault = parcelHelpers.interopDefault(_openInNew);
var _errorOutline = require("@mui/icons-material/ErrorOutline");
var _errorOutlineDefault = parcelHelpers.interopDefault(_errorOutline);
var _dateFns = require("date-fns");
var _types = require("common/api/v1/types");
var _helpers = require("common/api/v1/helpers");
var _utils = require("../../../../utils");
var _routes = require("../../../../utils/routes");
var _store = require("../../../../store");
var _form = require("../../../common/Form");
var _dataSet = require("../../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _applianceTypeUtil = require("common/applianceTypeUtil");
var _link1 = require("../../../common/Link");
var _indicator = require("../../../common/Indicator");
var _constants = require("common/constants");
var _reactRedux = require("react-redux");
var _applianceProxyButton = require("../../../common/ApplianceProxyButton");
var _util = require("common/util");
var _transcode = require("common/transcode");
var _matrox = require("common/matrox");
const styles = {
    link: {
        display: 'flex',
        transition: (theme)=>theme.transitions.create('color'),
        paddingTop: (theme)=>theme.spacing(1)
    },
    text: {
        marginRight: (theme)=>theme.spacing(1)
    },
    warningIcon: {
        verticalAlign: 'top',
        marginRight: '4px'
    },
    warningText: {
        marginLeft: (theme)=>theme.spacing(1),
        color: (theme)=>theme.palette.warning.light
    },
    versionChipsContainer: {
        '& div': {
            marginRight: (theme)=>theme.spacing(1)
        }
    }
};
const ApplianceVersionInfo = (applianceType, imageVersion, softwareVersion)=>{
    const { buildInfo } = (0, _reactRedux.useSelector)(({ buildInfoReducer })=>({
            buildInfo: buildInfoReducer.buildInfo
        }), (0, _util.equals));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: styles.versionChipsContainer,
                children: [
                    !(0, _applianceTypeUtil.isVaApplianceType)(applianceType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                        size: "small",
                        label: `Image: ${imageVersion || 'N/A'}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                        size: "small",
                        label: `Software: ${softwareVersion || 'N/A'}`
                    })
                ]
            }),
            (0, _utils.runningDifferentSoftwareVersion)(softwareVersion, buildInfo) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: styles.warningText,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorOutlineDefault.default), {
                        sx: styles.warningIcon
                    }),
                    "Software version is outdated, restart appliance to update"
                ]
            })
        ]
    });
};
const ApplianceOwnerLink = (appliance, user)=>{
    const routes = (0, _store.useRoutes)();
    return typeof appliance.owner === 'string' ? '' : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link1.Link), {
        to: routes.groupsUpdate({
            id: appliance.owner.id
        }),
        available: (0, _utils.isEditableGroup)(appliance.owner.id, user),
        underline: "hover",
        children: appliance.owner.name
    });
};
const Meta = ({ appliance })=>{
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const { settings } = (0, _utils.useSettingsSelector)();
    const controlImageVersion = appliance.version.controlImageVersion;
    const controlSoftwareVersion = appliance.version.controlSoftwareVersion;
    const dataImageVersion = appliance.version.dataImageVersion;
    const dataSoftwareVersion = appliance.version.dataSoftwareVersion;
    const linkIsShown = (0, _applianceTypeUtil.isVaApplianceType)(appliance.type);
    const isSuperUser = user.role === (0, _types.Role).super;
    const showHostMetrics = isSuperUser && appliance.region.id === (0, _constants.defaultRegionId) && // External regions are not supported EDGE-2561
    [
        (0, _types.ApplianceType).core,
        (0, _types.ApplianceType).thumb
    ].includes(appliance.type);
    const metrics = isSuperUser ? {
        Metrics: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                showHostMetrics && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        marginRight: '8px'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link1.ExternalLink), {
                        underline: "always",
                        href: `/grafana/d/000000127/kubernetes-node-metrics?orgId=1&var-DS_PROMETHEUS=Prometheus&var-job=node-exporter&var-name=${appliance.hostname}`,
                        children: "Kubernetes Node Metrics"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link1.ExternalLink), {
                    href: `/grafana/d/appliance-overview/appliance-host-metrics?orgId=1&var-appliance=${appliance.name}`,
                    underline: "always",
                    children: "Appliance Host Metrics"
                })
            ]
        })
    } : {};
    const lokiLabel = 'edge_component_name';
    const links = isSuperUser ? {
        Logs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link1.ExternalLink), {
            underline: "always",
            href: `/grafana/explore?left=%7B%22datasource%22:%22loki%22,%22queries%22:%5B%7B%22refId%22:%22A%22,%22datasource%22:%7B%22type%22:%22loki%22,%22uid%22:%22loki%22%7D,%22editorMode%22:%22code%22,%22expr%22:%22%7B${lokiLabel}%3D%5C%22${appliance.name}%5C%22%7D%20%7C%20json%20%7C%20line_format%20%60%7B%7B.message%7D%7D%60%22,%22queryType%22:%22range%22%7D%5D,%22range%22:%7B%22from%22:%22now-1h%22,%22to%22:%22now%22%7D%7D&orgId=1`,
            children: "Logs"
        })
    } : {};
    const transcodeAccelerator = appliance.transcodeAccelerator?.type && appliance.transcodeAccelerator?.type !== (0, _types.TranscodeAcceleratorType).cpu ? {
        'Transcoding accelerator': (0, _transcode.transcodeAcceleratorTypeDisplayName)(appliance.transcodeAccelerator.type)
    } : {};
    const matroxApiVersion = (0, _applianceTypeUtil.isMatroxApplianceType)(appliance.type) ? {
        'Running Matrox api': (0, _matrox.matroxApiVersionFromSettings)(appliance.settings)
    } : {};
    const hasFirmwareVersion = Boolean(appliance.version.firmwareVersion);
    const meta = {
        'Node name': /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                appliance.name,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _applianceProxyButton.ApplianceProxyButton), {
                    user: user,
                    appliance: appliance,
                    iconButtonProps: {
                        height: 24
                    }
                })
            ]
        }),
        Hostname: appliance.hostname,
        Tags: (appliance.tags ?? []).flatMap((tag, i)=>{
            const defaultOrder = settings?.expFeatures?.ExtHealthAlarms ? (0, _types.ListInputSortableField).healthStatus : undefined;
            const link = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link1.Link), {
                to: routes.events({
                    tags: tag,
                    desc: defaultOrder
                }),
                underline: "hover",
                children: tag
            });
            return i === 0 ? link : [
                ', ',
                link
            ];
        }),
        ...transcodeAccelerator,
        Contact: appliance.contact,
        'Product name': (0, _helpers.getProductName)(appliance.type),
        'Node serial number': appliance.serial,
        // vaVersion is deprecated and will be removed in the future, firmwareVersion will be used instead
        ...(0, _applianceTypeUtil.isVaApplianceType)(appliance.type) ? {
            'Running VA software': appliance.version.vaVersion
        } : {},
        ...hasFirmwareVersion && !(0, _applianceTypeUtil.isVaApplianceType)(appliance.type) ? {
            'Firmware version': appliance.version.firmwareVersion
        } : undefined,
        'Running control software': ApplianceVersionInfo(appliance.type, controlImageVersion, controlSoftwareVersion),
        'Running data software': ApplianceVersionInfo(appliance.type, dataImageVersion, dataSoftwareVersion),
        ...matroxApiVersion,
        Status: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AutoUpdatingApplianceHealthIndicator), {
            applianceId: appliance.id,
            inline: true
        }),
        'Running since': appliance.lastRegisteredAt && (0, _dateFns.format)(appliance.lastRegisteredAt, (0, _helpers.DATE_FORMAT_LONG)) || 'N/A',
        ...metrics,
        Alarms: appliance.alarms.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link1.Link), {
            to: routes.alarms({
                applianceId: appliance.id,
                applianceName: appliance.name
            }),
            underline: "hover",
            children: (0, _utils.pluralize)(appliance.alarms.length, 'alarm')
        }) : 'No alarms present',
        Owner: ApplianceOwnerLink(appliance, user),
        ...links
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Metadata",
        collapsible: true,
        actionsPane: [
            ...user.role === (0, _types.Role).super ? [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "body1",
                    sx: styles.link,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link1.Link), {
                        underline: "hover",
                        to: routes.appliancesConfig({
                            id: appliance.id
                        }),
                        children: "Show configuration"
                    })
                }, "config-button")
            ] : [],
            ...linkIsShown ? [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _linkDefault.default), {
                    href: (0, _routes.api).appliance({
                        id: appliance.id
                    }),
                    sx: styles.link,
                    underline: "always",
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "body1",
                            component: "span",
                            sx: styles.text,
                            children: "Manage appliance"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInNewDefault.default), {})
                    ]
                }, "appliance-link")
            ] : []
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                lg: 12,
                xl: 12,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: meta
                })
            }),
            linkIsShown && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                style: {
                    width: '100%'
                }
            })
        ]
    });
};
exports.default = Meta;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Link":"chNUC","@mui/material/Divider":"9Ul8c","@mui/material/Typography":"6NtGx","@mui/material/Chip":"5cK8z","@mui/icons-material/OpenInNew":"3wl83","@mui/icons-material/ErrorOutline":"3q6XB","date-fns":"gelMX","common/api/v1/types":"3qemx","common/api/v1/helpers":"6jovr","../../../../utils":"342UB","../../../../utils/routes":"cqMGU","../../../../store":"5LXiG","../../../common/Form":"4Mui7","../../../common/DataSet":"dmQXG","common/applianceTypeUtil":"3z9on","../../../common/Link":"l3o6V","../../../common/Indicator":"hqaQa","common/constants":"bdiC1","react-redux":"l1pMU","../../../common/ApplianceProxyButton":"59aZo","common/util":"jV4UZ","common/transcode":"4cbXA","common/matrox":"4mxaf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3q6XB":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("385332cd697d28de").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("3d31825d92094a46"));
var _jsxRuntime = require("b4d822652ca44484");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutline');

},{"385332cd697d28de":"kZ6eK","3d31825d92094a46":"2vOnF","b4d822652ca44484":"1dlk8"}],"4cbXA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transcodeAcceleratorTypeDisplayName = void 0;
const types_1 = require("b600d1ed28f65caa");
const transcodeAcceleratorTypeDisplayName = (type)=>{
    switch(type){
        case types_1.TranscodeAcceleratorType.nvidia:
            return 'NVIDIA NVENC';
        case types_1.TranscodeAcceleratorType.netint:
            return 'NETINT Quadra';
        case types_1.TranscodeAcceleratorType.xilinx_u30:
            return 'Xilinx U30';
        case types_1.TranscodeAcceleratorType.videotoolbox:
            return 'Apple VideoToolbox';
        case types_1.TranscodeAcceleratorType.cpu:
            return 'CPU';
        default:
            return type;
    }
};
exports.transcodeAcceleratorTypeDisplayName = transcodeAcceleratorTypeDisplayName;

},{"b600d1ed28f65caa":"3qemx"}],"fYcBA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveDialog", ()=>RemoveDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAsyncHook = require("react-async-hook");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _warning = require("@mui/icons-material/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _store = require("../../../store");
var _types = require("common/api/v1/types");
var _failedFetchingContent = require("../../common/FailedFetchingContent");
var _link = require("../../common/Link");
const styles = {
    title: {
        margin: (theme)=>theme.spacing(2, 0)
    }
};
const RemoveDialog = ({ appliance, hideConfirmDialog })=>{
    const routes = (0, _store.useRoutes)();
    const { result: inputs, loading: inputsLoading, error: inputsError } = (0, _reactAsyncHook.useAsync)(async ()=>(0, _store.Api).inputApi.getInputs({
            applianceId: appliance.id,
            pageNumber: '0',
            rowsPerPage: '10'
        }), [
        appliance.id
    ]);
    const { result: outputs, loading: outputsLoading, error: outputsError } = (0, _reactAsyncHook.useAsync)(async ()=>(0, _store.Api).outputApi.getOutputs({
            applianceId: appliance.id,
            pageNumber: '0',
            rowsPerPage: '10'
        }), [
        appliance.id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                color: "textPrimary",
                sx: styles.title,
                children: `Are you sure you want to remove "${appliance.name}"?`
            }),
            appliance.type === (0, _types.ApplianceType).core && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                        direction: "row",
                        alignItems: "center",
                        gap: 1,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h3",
                                children: "Warning!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "This is a core appliance, deleting it might cause service disruptions."
                    }),
                    inputsError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _failedFetchingContent.FailedFetchingContent), {
                        message: 'Failed to fetch inputs'
                    }),
                    (inputs && inputs.total > 0 || outputs && outputs.total > 0) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "The following inputs and outputs are dependent on this core appliance and needs to be removed or reconfigured before this appliance can be deleted."
                    }),
                    inputs && inputs.total > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h4",
                                children: "Inputs:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                children: [
                                    inputs.items.map((input)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                                underline: "hover",
                                                to: routes.inputsUpdate({
                                                    id: input.id
                                                }),
                                                onClick: hideConfirmDialog,
                                                children: input.name
                                            })
                                        }, input.id)),
                                    inputs.items.length !== inputs.total && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        children: "\u22EF"
                                    })
                                ]
                            })
                        ]
                    }),
                    outputsError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _failedFetchingContent.FailedFetchingContent), {
                        message: 'Failed to fetch outputs'
                    }),
                    outputs && outputs.total > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h4",
                                children: "Outputs:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                children: [
                                    outputs.items.map((output)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                                underline: "hover",
                                                to: routes.outputsUpdate({
                                                    id: output.id
                                                }),
                                                onClick: hideConfirmDialog,
                                                children: output.name
                                            })
                                        }, output.id)),
                                    outputs.items.length !== outputs.total && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        children: "\u22EF"
                                    })
                                ]
                            })
                        ]
                    }),
                    (inputsLoading || outputsLoading) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Streams without redundancy currently routed through this appliance will experience a brief disruption while the system reconfigures."
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-async-hook":"3D6Y9","@mui/material/Typography":"6NtGx","@mui/icons-material/Warning":"eRDc8","@mui/material/Stack":"6thYv","@mui/material/CircularProgress":"kEtIR","../../../store":"5LXiG","common/api/v1/types":"3qemx","../../common/FailedFetchingContent":"dJi9P","../../common/Link":"l3o6V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7iZcY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _tooltip = require("../../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _home = require("@mui/icons-material/Home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _arrowRightAlt = require("@mui/icons-material/ArrowRightAlt");
var _arrowRightAltDefault = parcelHelpers.interopDefault(_arrowRightAlt);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _constants = require("common/constants");
var _types = require("common/api/v1/types");
var _store = require("../../../../store");
var _link = require("../../../common/Link");
var _form = require("../../../common/Form");
var _table = require("../../../common/Table");
var _selfStatePaginatedList = require("../../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _altRoute = require("@mui/icons-material/AltRoute");
var _altRouteDefault = parcelHelpers.interopDefault(_altRoute);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _inputsActions = require("../../../../redux/actions/inputsActions");
var _reactRedux = require("react-redux");
var _utils = require("../../../../utils");
var _versions = require("common/versions");
var _util = require("common/util");
const { appliancesApi } = (0, _store.Api);
const marginBetweenIconAndName = '12px';
const InputsOutputs = ({ appliance })=>{
    const theme = (0, _styles.useTheme)();
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const [updateOn, setUpdateOn] = (0, _react.useState)(false);
    const refreshLists = ()=>setUpdateOn(!updateOn);
    const navigate = (0, _reactRouter.useNavigate)();
    const { buildInfo } = (0, _reactRedux.useSelector)(({ buildInfoReducer })=>({
            buildInfo: buildInfoReducer.buildInfo
        }), (0, _util.equals));
    const { devMode } = (0, _utils.useSettingsSelector)();
    const titleComponent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: 'flex',
            paddingBottom: 16
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                sx: {
                    width: '50%'
                },
                children: "Inputs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                sx: {
                    width: '50%'
                },
                children: "Outputs"
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: titleComponent,
        collapsible: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                size: 6,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
                    api: (params)=>appliancesApi.listApplianceInputs(appliance.id, params),
                    updateOn: updateOn,
                    hideSearch: true,
                    emptyMessage: "no inputs found",
                    notFoundMessage: "no matching inputs",
                    List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                            data: list,
                            emptyMessageComponent: "no inputs found",
                            props: {
                                size: 'small'
                            },
                            noHeader: true,
                            config: [
                                {
                                    getValue: ({ inputName, inputId, inputAdminStatus, applianceName, applianceId })=>{
                                        const isUpstreamInput = applianceId !== appliance.id;
                                        const canReroute = user.role === (0, _types.Role).super && isUpstreamInput && buildInfo?.product === (0, _constants.PRODUCTS).nimbraEdge.id;
                                        const canTakePcap = devMode && user.role === (0, _types.Role).super && !isUpstreamInput && (0, _versions.supportsPcap)(appliance.version);
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            sx: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                flex: 1,
                                                height: '40px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _link.Link), {
                                                    underline: "hover",
                                                    to: routes.inputsUpdate({
                                                        id: inputId
                                                    }),
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        flex: 1
                                                    },
                                                    muiStyle: {
                                                        display: 'flex',
                                                        flex: 1,
                                                        gap: marginBetweenIconAndName,
                                                        color: inputAdminStatus ? theme.palette.text.primary : theme.palette.text.secondary
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                            disablePortal: false,
                                                            title: isUpstreamInput ? `This input is located on upstream appliance ${applianceName} (routed via this appliance)` : 'This input is located on this appliance',
                                                            children: isUpstreamInput ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowRightAltDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeDefault.default), {})
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            style: {
                                                                display: 'flex',
                                                                flex: 1
                                                            },
                                                            children: inputName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                                    "aria-label": "service overview button",
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        navigate(routes.service({
                                                            id: inputId
                                                        }));
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                        title: 'Service Overview',
                                                        disablePortal: false,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionMenu, {
                                                    inputId: inputId,
                                                    applianceId: appliance.id,
                                                    refreshList: refreshLists,
                                                    canReroute: canReroute,
                                                    canTakePcap: canTakePcap,
                                                    disabled: (!isUpstreamInput || !canReroute) && !canTakePcap
                                                })
                                            ]
                                        });
                                    }
                                }
                            ]
                        })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                size: 6,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
                    api: (params)=>appliancesApi.listApplianceOutputs(appliance.id, params),
                    updateOn: updateOn,
                    hideSearch: true,
                    emptyMessage: "no outputs found",
                    notFoundMessage: "no matching outputs",
                    List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                            data: list,
                            emptyMessageComponent: "no outputs found",
                            props: {
                                size: 'small'
                            },
                            noHeader: true,
                            config: [
                                {
                                    getValue: ({ outputName, outputId, inputId, outputAdminStatus, applianceName, applianceId })=>{
                                        const isDownstreamOutput = applianceId !== appliance.id;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            sx: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                flex: 1,
                                                height: '40px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                                    underline: "hover",
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        flex: 1
                                                    },
                                                    muiStyle: {
                                                        display: 'flex',
                                                        flex: 1,
                                                        gap: marginBetweenIconAndName,
                                                        color: outputAdminStatus ? theme.palette.text.primary : theme.palette.text.secondary
                                                    },
                                                    to: routes.outputsUpdate({
                                                        id: outputId
                                                    }),
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        style: {
                                                            display: 'flex',
                                                            justifyContent: 'flex-start',
                                                            height: '40px',
                                                            alignItems: 'center',
                                                            gap: marginBetweenIconAndName
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                                disablePortal: false,
                                                                title: isDownstreamOutput ? `This output is located on downstream appliance ${applianceName} (routed via this appliance)` : 'This output is located on this appliance',
                                                                children: isDownstreamOutput ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowRightAltDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeDefault.default), {})
                                                            }),
                                                            outputName
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                                    "aria-label": "service overview button",
                                                    disabled: !inputId,
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        navigate(routes.service({
                                                            id: inputId,
                                                            outputId
                                                        }));
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                        title: 'Service Overview',
                                                        disablePortal: false,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {})
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                }
                            ]
                        })
                })
            })
        ]
    });
};
const ActionMenu = (props)=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { inputId, applianceId, disabled } = props;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleItemClick = (event, action, shouldRefetch = true)=>{
        event.stopPropagation();
        setAnchorEl(null);
        dispatch(action).then(()=>{
            if (shouldRefetch) props.refreshList();
        }).catch(()=>void 0 /* There will be an error snackbar in this case */ );
    };
    const handleClose = (event)=>{
        event.stopPropagation();
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: 'flex',
            marginLeft: '16px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                disabled: disabled,
                "aria-label": "open appliance input action menu",
                "data-test-id": "open-appliance-input-action-menu",
                "aria-haspopup": "true",
                onClick: handleClick,
                sx: {
                    marginLeft: '-8px'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                "data-test-id": "appliance-input-action-menu",
                "data-is-open": open ? 'true' : 'false',
                keepMounted: true,
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                PaperProps: {
                    style: {
                        minWidth: '35ch'
                    }
                },
                children: [
                    props.canReroute && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuItemDefault.default), {
                        onClick: (e)=>handleItemClick(e, (0, _inputsActions.rerouteInput)({
                                inputId,
                                avoidApplianceId: applianceId
                            })),
                        "data-test-id": "reroute-away-from",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _altRouteDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                primary: "Reroute away from this appliance"
                            })
                        ]
                    }),
                    props.canTakePcap && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuItemDefault.default), {
                        onClick: (e)=>handleItemClick(e, (0, _inputsActions.pcapInput)({
                                inputId,
                                applianceId
                            }), false),
                        "data-test-id": "take-pcap-for-input",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _altRouteDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                primary: "Capture 10 seconds of the incoming stream"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = InputsOutputs;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","@mui/material/Typography":"6NtGx","../../../common/Tooltip":"crjvg","@mui/material/styles":"2UrBk","@mui/material/Box":"c4QkF","@mui/material/Grid":"6iX4B","@mui/icons-material/Info":"juq3i","@mui/icons-material/MoreVert":"22WtH","@mui/icons-material/Home":"i3v3W","@mui/icons-material/ArrowRightAlt":"lBrzV","@mui/material/IconButton":"488As","common/constants":"bdiC1","common/api/v1/types":"3qemx","../../../../store":"5LXiG","../../../common/Link":"l3o6V","../../../common/Form":"4Mui7","../../../common/Table":"dt9lf","../../../common/SelfStatePaginatedList":"dLSax","@mui/material/ListItemIcon":"2WZ7w","@mui/material/ListItemText":"1ZvGq","@mui/icons-material/AltRoute":"amYwq","@mui/material/Menu":"1ut4X","@mui/material/MenuItem":"krMs8","../../../../redux/actions/inputsActions":"l0Ua8","react-redux":"l1pMU","../../../../utils":"342UB","common/versions":"4vuwV","common/util":"jV4UZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3v3W":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("266621c45be181e2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("ae5a87afc2f25279"));
var _jsxRuntime = require("3962a098f7e3e4ef");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), 'Home');

},{"266621c45be181e2":"kZ6eK","ae5a87afc2f25279":"2vOnF","3962a098f7e3e4ef":"1dlk8"}],"lBrzV":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("1f8068387c705d15").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("d68df0c4bd1197f"));
var _jsxRuntime = require("e191a63dd55ca368");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4z"
}), 'ArrowRightAlt');

},{"1f8068387c705d15":"kZ6eK","d68df0c4bd1197f":"2vOnF","e191a63dd55ca368":"1dlk8"}],"amYwq":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("6992863ce7b907c3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("481c8dcea772189e"));
var _jsxRuntime = require("c3c412db54ae6039");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m9.78 11.16-1.42 1.42c-.68-.69-1.34-1.58-1.79-2.94l1.94-.49c.32.89.77 1.5 1.27 2.01M11 6 7 2 3 6h3.02c.02.81.08 1.54.19 2.17l1.94-.49C8.08 7.2 8.03 6.63 8.02 6zm10 0-4-4-4 4h2.99c-.1 3.68-1.28 4.75-2.54 5.88-.5.44-1.01.92-1.45 1.55-.34-.49-.73-.88-1.13-1.24L9.46 13.6c.93.85 1.54 1.54 1.54 3.4v5h2v-5c0-2.02.71-2.66 1.79-3.63 1.38-1.24 3.08-2.78 3.2-7.37z"
}), 'AltRoute');

},{"6992863ce7b907c3":"kZ6eK","481c8dcea772189e":"2vOnF","c3c412db54ae6039":"1dlk8"}],"76l2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _container = require("@mui/material/Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _form = require("./Form");
const ApplicationError = ({ error, onOKButtonClicked })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _containerDefault.default), {
        component: "main",
        maxWidth: "xs",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "h2",
                    variant: "h2",
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "h2",
                    variant: "body2",
                    children: error?.message
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: onOKButtonClicked,
                    variant: "contained",
                    color: "primary",
                    sx: (0, _form.styles).button,
                    children: "Go back"
                })
            ]
        })
    });
};
exports.default = ApplicationError;

},{"react/jsx-runtime":"1dlk8","@mui/material/Container":"376wa","@mui/material/Typography":"6NtGx","@mui/material/Button":"3qJY9","./Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6G9xJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChangeRegionDialog", ()=>ChangeRegionDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _warning = require("@mui/icons-material/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
const styles = {
    title: {
        margin: (theme)=>theme.spacing(2, 0)
    }
};
const ChangeRegionDialog = ({ applianceName, newRegionName, affectedOutputs, limit })=>{
    const limitedAffectedOutputs = affectedOutputs.slice(0, limit);
    const hasMoreOutputs = affectedOutputs.length > limitedAffectedOutputs.length;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h3",
                color: "textPrimary",
                sx: styles.title,
                children: "You are about to change region for an appliance currently in use"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                direction: "row",
                alignItems: "center",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h3",
                        children: "Warning!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                paragraph: true,
                children: [
                    "Changing region to '",
                    newRegionName,
                    "' for appliance '",
                    applianceName,
                    "' may cause disruptions on any output dependent on the appliance."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                paragraph: true,
                children: "The following outputs are affected."
            }),
            limitedAffectedOutputs && limitedAffectedOutputs.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h4",
                        children: "Outputs:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        children: [
                            limitedAffectedOutputs.map((output)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                    children: output.name
                                }, output.id)),
                            hasMoreOutputs && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                children: "\u22EF"
                            })
                        ]
                    })
                ]
            }),
            hasMoreOutputs && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                paragraph: true,
                fontStyle: "italic",
                children: "Note that there are more outputs affected than the ones listed above."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                paragraph: true,
                children: "Are you sure you accept possible disruptions on these outputs?"
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Typography":"6NtGx","@mui/icons-material/Warning":"eRDc8","@mui/material/Stack":"6thYv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"85DAT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChangeSecondaryRegionDialog", ()=>ChangeSecondaryRegionDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _warning = require("@mui/icons-material/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
const styles = {
    title: {
        margin: (theme)=>theme.spacing(2, 0)
    }
};
const ChangeSecondaryRegionDialog = ({ applianceName, newSecondaryRegionName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h3",
                color: "textPrimary",
                sx: styles.title,
                children: "You are about to change secondary region for an appliance"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                direction: "row",
                alignItems: "center",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h3",
                        children: "Warning!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                paragraph: true,
                children: [
                    "Changing secondary region to '",
                    newSecondaryRegionName,
                    "' for appliance '",
                    applianceName,
                    "' cause temporary loss of redundancy for redundant inputs on the appliance."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                paragraph: true,
                children: "Are you sure?"
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Typography":"6NtGx","@mui/icons-material/Warning":"eRDc8","@mui/material/Stack":"6thYv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHa0a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveSecondaryRegionDialog", ()=>RemoveSecondaryRegionDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _warning = require("@mui/icons-material/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
const styles = {
    title: {
        margin: (theme)=>theme.spacing(2, 0)
    }
};
const RemoveSecondaryRegionDialog = ({ applianceName })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h3",
                color: "textPrimary",
                sx: styles.title,
                children: "You are about to remove secondary region for an appliance"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                direction: "row",
                alignItems: "center",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h3",
                        children: "Warning!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                paragraph: true,
                children: [
                    "Removing secondary region for appliance '",
                    applianceName,
                    "' cause loss of multi-region redundancy for all redundant inputs on the appliance. The system will fall back to using single-region redundancy."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                paragraph: true,
                children: "Are you sure?"
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Typography":"6NtGx","@mui/icons-material/Warning":"eRDc8","@mui/material/Stack":"6thYv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"978yf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TunnelDetails", ()=>TunnelDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _store = require("../../../../store");
var _link = require("../../../common/Link");
var _form = require("../../../common/Form");
var _table = require("../../../common/Table");
var _selfStatePaginatedList = require("../../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _dataSet = require("../../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _reactAsyncHook = require("react-async-hook");
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _notificationActions = require("../../../../redux/actions/notificationActions");
var _reactRedux = require("react-redux");
var _tooltip = require("../../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _arrowRightAlt = require("@mui/icons-material/ArrowRightAlt");
var _arrowRightAltDefault = parcelHelpers.interopDefault(_arrowRightAlt);
var _home = require("@mui/icons-material/Home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
const marginBetweenIconAndName = '12px';
const { tunnelApi } = (0, _store.Api);
const Tunnels = ({ appliance })=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    const titleComponent = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            display: 'flex',
            paddingBottom: 16
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            variant: "h2",
            sx: {
                width: '100%'
            },
            children: "Tunnels"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: titleComponent,
        collapsible: true,
        collapsed: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                width: '100%'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
                api: ()=>tunnelApi.listTunnels({
                        appliance: appliance.id
                    }),
                hideSearch: true,
                emptyMessage: "no tunnels found",
                notFoundMessage: "no matching tunnels",
                List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                        data: list,
                        emptyMessageComponent: "no tunnels found",
                        rowProps: (tunnel)=>{
                            return {
                                hover: true,
                                sx: {
                                    cursor: 'pointer'
                                },
                                onClick: ()=>navigate(routes.tunnel({
                                        tunnelId: tunnel.id,
                                        applianceName: appliance.name
                                    }))
                            };
                        },
                        config: [
                            {
                                title: 'Id',
                                getValue: ({ id: tunnelId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: tunnelId
                                    })
                            },
                            {
                                title: 'Connection type',
                                getValue: ({ client })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: client === appliance.id ? 'client' : 'server'
                                    })
                            },
                            {
                                title: 'Connected to',
                                getValue: ({ client, clientName, serverName })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: client === appliance.id ? serverName : clientName
                                    })
                            },
                            {
                                title: 'Number of inputs',
                                getValue: ({ inputs })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: inputs.length
                                    })
                            }
                        ]
                    })
            })
        })
    });
};
const TunnelDetails = ()=>{
    const { tunnelId } = (0, _reactRouter.useParams)();
    const routes = (0, _store.useRoutes)();
    const location = (0, _reactRouter.useLocation)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const queryParams = new URLSearchParams(location.search);
    const applianceName = queryParams.get('applianceName');
    const { result: tunnels, loading: isFetchingTunnels, error: listTunnelsError } = (0, _reactAsyncHook.useAsync)(()=>(0, _store.Api).tunnelApi.listTunnels({
            ids: [
                tunnelId
            ]
        }), [
        tunnelId
    ]);
    const tunnel = tunnels?.items.find((t)=>t.id.toString() === tunnelId);
    (0, _react.useEffect)(()=>{
        if (listTunnelsError) dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            operation: `fetch tunnel ${tunnelId}`,
            error: listTunnelsError
        }));
    }, [
        dispatch,
        listTunnelsError,
        tunnelId
    ]);
    const metricsLink = {
        text: 'RIST Overview',
        url: `/grafana/d/rist-overview/rist-overview?orgId=1&refresh=10s&from=now-15m&to=now&var-type=tunnel&var-applianceName=${applianceName ?? 'All'}`
    };
    const titleComponent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: 'flex',
            paddingBottom: 16
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                sx: {
                    width: '50%'
                },
                children: "Inputs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                sx: {
                    width: '50%'
                },
                children: "Outputs"
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: "Tunnel",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
            cover: true,
            pending: isFetchingTunnels,
            children: [
                tunnel && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                            title: "Tunnel info",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                                values: {
                                    Id: tunnel.id,
                                    Type: (0, _types.TunnelType)[tunnel.type],
                                    'Client appliance': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                        to: routes.appliancesUpdate({
                                            id: tunnel.client
                                        }),
                                        underline: "hover",
                                        children: tunnel.clientName
                                    }),
                                    'Client local address': `${tunnel.clientLocalIp}:${tunnel.clientLocalPort}`,
                                    'Client remote address': `${tunnel.clientRemoteIp}:${tunnel.clientRemotePort}`,
                                    'Client interface': `${tunnel.clientPhysicalPort.name}`,
                                    'Server appliance': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                        to: routes.appliancesUpdate({
                                            id: tunnel.server
                                        }),
                                        underline: "hover",
                                        children: tunnel.serverName
                                    }),
                                    'Server local address': `${tunnel.serverLocalIp}:${tunnel.serverLocalPort}`,
                                    'Server public ip': `${tunnel.serverPublicIp}`,
                                    'Server interface': `${tunnel.serverPhysicalPort.name}`,
                                    Network: tunnel.network ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                        to: routes.networkUpdate({
                                            id: tunnel.network.id
                                        }),
                                        underline: "hover",
                                        children: tunnel.network.name
                                    }) : 'N/A',
                                    Metrics: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ExternalLink), {
                                        href: metricsLink.url,
                                        underline: "always",
                                        style: {
                                            marginRight: '12px'
                                        },
                                        children: metricsLink.text
                                    }, metricsLink.url)
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                            title: titleComponent,
                            collapsible: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                    size: 6,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                                        data: tunnel.inputs,
                                        emptyMessageComponent: "Tunnel is not routing any inputs",
                                        noHeader: true,
                                        rowProps: ({ id: inputId })=>{
                                            return {
                                                hover: true,
                                                sx: {
                                                    cursor: 'pointer'
                                                },
                                                onClick: ()=>void navigate(routes.inputsUpdate({
                                                        id: inputId
                                                    }))
                                            };
                                        },
                                        config: [
                                            {
                                                getValue: ({ name, id: inputId })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                                        sx: {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            flex: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                                                underline: "hover",
                                                                to: routes.inputsUpdate({
                                                                    id: inputId
                                                                }),
                                                                style: {
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    flex: 1
                                                                },
                                                                muiStyle: {
                                                                    display: 'flex',
                                                                    flex: 1,
                                                                    gap: marginBetweenIconAndName
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    style: {
                                                                        display: 'flex',
                                                                        flex: 1
                                                                    },
                                                                    children: name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                                                "aria-label": "service overview button",
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    navigate(routes.service({
                                                                        id: inputId
                                                                    }));
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                                    title: 'Service Overview',
                                                                    disablePortal: false,
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {})
                                                                })
                                                            })
                                                        ]
                                                    })
                                            }
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                    size: 6,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
                                        api: (params)=>tunnelApi.listTunnelOutputs(tunnel.id, params),
                                        hideSearch: true,
                                        emptyMessage: "Tunnel is not routing any outputs",
                                        notFoundMessage: "No matching outputs",
                                        List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                                                data: list,
                                                emptyMessageComponent: "Tunnel is not routing any outputs",
                                                noHeader: true,
                                                config: [
                                                    {
                                                        getValue: ({ outputName, outputId, inputId, finalTunnelId })=>{
                                                            const isDownstreamTunnel = tunnel.id !== finalTunnelId;
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                                                sx: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    flex: 1
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _link.Link), {
                                                                        underline: "hover",
                                                                        to: routes.outputsUpdate({
                                                                            id: outputId
                                                                        }),
                                                                        style: {
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            flex: 1
                                                                        },
                                                                        muiStyle: {
                                                                            display: 'flex',
                                                                            flex: 1,
                                                                            gap: marginBetweenIconAndName
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                                                disablePortal: false,
                                                                                title: isDownstreamTunnel ? `This output is served by downstream tunnel ${finalTunnelId} (routed via this tunnel)` : 'This output is served by this tunnel',
                                                                                children: isDownstreamTunnel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowRightAltDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeDefault.default), {})
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                style: {
                                                                                    display: 'flex',
                                                                                    flex: 1
                                                                                },
                                                                                children: outputName
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                                                        "aria-label": "service overview button",
                                                                        disabled: !inputId,
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            navigate(routes.service({
                                                                                id: inputId,
                                                                                outputId
                                                                            }));
                                                                        },
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                                            title: 'Service Overview',
                                                                            disablePortal: false,
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {})
                                                                        })
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    }
                                                ]
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                !tunnel && !isFetchingTunnels && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        children: `Could not find tunnel with id ${tunnelId}`
                    })
                })
            ]
        })
    });
};
exports.default = Tunnels;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","@mui/material/Grid":"6iX4B","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../../../store":"5LXiG","../../../common/Link":"l3o6V","../../../common/Form":"4Mui7","../../../common/Table":"dt9lf","../../../common/SelfStatePaginatedList":"dLSax","../../../common/DataSet":"dmQXG","react-async-hook":"3D6Y9","../../../common/Pendable":"gDN67","../../../common/Wrapper":"8oy7r","../../../../redux/actions/notificationActions":"7LkQg","react-redux":"l1pMU","../../../common/Tooltip":"crjvg","@mui/icons-material/ArrowRightAlt":"lBrzV","@mui/icons-material/Home":"i3v3W","@mui/icons-material/Info":"juq3i","@mui/material/Box":"c4QkF","@mui/material/IconButton":"488As","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2aNMn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pcaps", ()=>Pcaps);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _form = require("../../../common/Form");
var _table = require("../../../common/Table");
var _selfStatePaginatedList = require("../../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _store = require("../../../../store");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _cached = require("@mui/icons-material/Cached");
var _cachedDefault = parcelHelpers.interopDefault(_cached);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _saveAlt = require("@mui/icons-material/SaveAlt");
var _saveAltDefault = parcelHelpers.interopDefault(_saveAlt);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _notificationActions = require("../../../../redux/actions/notificationActions");
var _common = require("../../../../Common");
var _utils = require("../../../../utils");
function downloadPcap(applianceId, pcap) {
    document.location.href = `/api/appliance/${applianceId}/pcap/${pcap.id}`;
    return 1;
}
const { appliancesApi } = (0, _store.Api);
const Pcaps = ({ appliance })=>{
    const [updateOn, setUpdateOn] = (0, _react.useState)(false);
    const [isFetching, setIsFetching] = (0, _react.useState)(true);
    const [postFetchActions, setPostFetchActions] = (0, _react.useState)([]);
    const titleComponent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: 'flex',
            paddingBottom: 16
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h2",
                children: "Packet captures"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                disabled: isFetching,
                onClick: ()=>!isFetching && triggerFetch(),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cachedDefault.default), {
                    sx: isFetching ? (0, _common.styles).rotating : {}
                })
            })
        ]
    });
    const triggerFetch = (postFetchAction)=>{
        if (postFetchAction) setPostFetchActions((prevState)=>[
                ...prevState,
                postFetchAction
            ]);
        setUpdateOn((prevState)=>!prevState);
    };
    const onFetchComplete = ({ loading })=>{
        if (isFetching !== loading) setIsFetching(loading ?? false);
        if (!loading && postFetchActions.length > 0) {
            postFetchActions.forEach((a)=>a());
            setPostFetchActions([]);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: titleComponent,
        collapsible: true,
        collapsed: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                width: '100%'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
                api: ()=>appliancesApi.listAppliancePcaps(appliance.id).catch((_)=>{
                        // EDGE-4849 quick fix: Don't display error toast for this dev feature
                        return (0, _utils.listResult)([]);
                    }),
                updateOn: updateOn,
                onListChange: onFetchComplete,
                hideSearch: true,
                emptyMessage: "no pcaps found",
                notFoundMessage: "no matching pcaps",
                List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                        data: list,
                        rowProps: (_pcap)=>({
                                hover: true,
                                sx: {
                                    cursor: 'pointer'
                                }
                            }),
                        config: [
                            {
                                title: 'Name',
                                getValue: ({ name })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: name
                                    })
                            },
                            {
                                title: 'Start time (UTC)',
                                getValue: ({ result })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: result?.startAt.toISOString().substring(0, 19).replace('T', ' ')
                                    })
                            },
                            {
                                title: 'Result',
                                getValue: ({ result })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: result?.error ? `Error: ${result?.stderr ?? result.error.code}` : 'Success'
                                    })
                            },
                            {
                                getValue: (pcap)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-end',
                                            flex: 1,
                                            height: '40px'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionMenu, {
                                            pcap: pcap,
                                            applianceId: appliance.id,
                                            requestRefresh: triggerFetch
                                        })
                                    })
                            }
                        ]
                    })
            })
        })
    });
};
const ActionMenu = (props)=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { pcap } = props;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleItemClick = (event, action)=>{
        event.stopPropagation();
        setAnchorEl(null);
        action();
    };
    const handleClose = (event)=>{
        event.stopPropagation();
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: 'flex',
            marginLeft: '16px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "open appliance input action menu",
                "data-test-id": "open-appliance-input-action-menu",
                "aria-haspopup": "true",
                onClick: handleClick,
                sx: {
                    marginLeft: '-8px'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                "data-test-id": "appliance-input-action-menu",
                "data-is-open": open ? 'true' : 'false',
                keepMounted: true,
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                PaperProps: {
                    style: {
                        minWidth: '35ch'
                    }
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuItemDefault.default), {
                        disabled: !!pcap.result?.error,
                        "data-test-id": "download-pcap",
                        onClick: (e)=>{
                            handleItemClick(e, ()=>downloadPcap(props.applianceId, pcap));
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _saveAltDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                primary: "Download"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuItemDefault.default), {
                        "data-test-id": "delete-pcap",
                        onClick: (e)=>{
                            handleItemClick(e, ()=>(0, _store.Api).appliancesApi.deletePcap(props.applianceId, pcap.id).then(()=>{
                                    props.requestRefresh(()=>dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Pcap deleted')));
                                }).catch((error)=>{
                                    dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                                        error,
                                        operation: 'delete pcap'
                                    }));
                                }));
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                                primary: "Delete"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Typography":"6NtGx","../../../common/Form":"4Mui7","../../../common/Table":"dt9lf","../../../common/SelfStatePaginatedList":"dLSax","../../../../store":"5LXiG","@mui/material/Box":"c4QkF","@mui/icons-material/Cached":"k4ZaR","@mui/icons-material/MoreVert":"22WtH","@mui/material/ListItemIcon":"2WZ7w","@mui/material/ListItemText":"1ZvGq","@mui/material/IconButton":"488As","@mui/icons-material/SaveAlt":"ev1Ik","@mui/icons-material/Delete":"69aC7","@mui/material/Menu":"1ut4X","@mui/material/MenuItem":"krMs8","../../../../redux/actions/notificationActions":"7LkQg","../../../../Common":"7DOrW","../../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ev1Ik":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("90b7e178d1d51764").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("20c0ddb527fbc179"));
var _jsxRuntime = require("34568db3c86e3d5b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7zm-6 .67 2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), 'SaveAlt');

},{"90b7e178d1d51764":"kZ6eK","20c0ddb527fbc179":"2vOnF","34568db3c86e3d5b":"1dlk8"}],"1MybS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "commandNotStarted", ()=>commandNotStarted);
parcelHelpers.export(exports, "commandInProgress", ()=>commandInProgress);
parcelHelpers.export(exports, "commandFailed", ()=>commandFailed);
parcelHelpers.export(exports, "commandSuccess", ()=>commandSuccess);
parcelHelpers.export(exports, "CommandList", ()=>CommandList);
var _jsxRuntime = require("react/jsx-runtime");
var _linearProgress = require("@mui/material/LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _form = require("../../common/Form");
var _react = require("react");
var _styles = require("@mui/material/styles");
const commandNotStarted = (x)=>({
        ...x,
        type: 'notstarted'
    });
const commandInProgress = (x)=>({
        ...x,
        type: 'inprogress'
    });
const commandFailed = (x)=>({
        ...x,
        type: 'failed'
    });
const commandSuccess = (x)=>({
        ...x,
        type: 'success'
    });
const CommandList = ({ statuses })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Jobs",
        children: statuses.map((status)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CommandStatusItem, {
                ...status
            }, status.id))
    });
};
const CommandStatusItem = (status)=>{
    let v;
    switch(status.type){
        case 'notstarted':
            v = {
                value: 0,
                color: 'secondary',
                statusText: 'Queued'
            };
            break;
        case 'inprogress':
            v = {
                value: status.progressPercentage,
                color: 'secondary',
                statusText: status.message
            };
            break;
        case 'failed':
            v = {
                value: 100,
                color: 'error',
                statusText: status.message
            };
            break;
        case 'success':
            v = {
                value: 100,
                color: 'success'
            };
            break;
        default:
            {
                const _exhaustiveCheck = status;
                return _exhaustiveCheck;
            }
    }
    const formatter = new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            marginTop: 3,
            marginLeft: 2
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h5",
                children: status.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressWithLabel, {
                variant: "determinate",
                color: v.color,
                value: v.value
            }),
            v.statusText && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusText, {
                color: "textSecondary",
                children: v.statusText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                variant: "caption",
                color: "textSecondary  ",
                sx: {
                    fontStyle: 'italic',
                    alignSelf: 'end'
                },
                children: [
                    "Created at ",
                    formatter.format(status.createdAt)
                ]
            })
        ]
    });
};
const StatusText = ({ color, children })=>{
    const [expanded, setExpanded] = (0, _react.useState)(false);
    const maxLength = 100;
    const isLong = children.length > maxLength;
    const toggleExpanded = ()=>setExpanded((prev)=>!prev);
    const getMessage = ()=>{
        if (isLong && !expanded) return children.slice(0, maxLength) + "\u2026";
        else return children;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
            variant: "body2",
            color: color,
            children: [
                getMessage(),
                isLong && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShowMore, {
                    onClick: toggleExpanded,
                    children: expanded ? 'Show less' : 'Show more'
                })
            ]
        })
    });
};
const ShowMore = (0, _styles.styled)('span')(({ theme })=>({
        color: theme.palette.secondary.main,
        cursor: 'pointer',
        marginLeft: theme.spacing(0.5),
        fontSize: theme.typography.body2.fontSize,
        lineHeight: 1.5,
        fontStyle: 'italic',
        '&:hover': {
            textDecoration: 'underline'
        },
        '&:focus': {
            outline: `2px solid ${theme.palette.secondary.main}`,
            outlineOffset: '2px'
        }
    }));
const LinearProgressWithLabel = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linearProgressDefault.default), {
                    variant: "determinate",
                    ...props
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    minWidth: 10,
                    marginLeft: 1
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "body2",
                    color: "textPrimary",
                    children: `${Math.round(props.value)}%`
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/LinearProgress":"bh8bU","@mui/material/Typography":"6NtGx","@mui/material/Box":"c4QkF","../../common/Form":"4Mui7","react":"9njXz","@mui/material/styles":"2UrBk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bh8bU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7c6d86866cd236c7").default;
var _interopRequireDefault = require("4375361eeb06e569").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    linearProgressClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _LinearProgress.default;
    }
});
Object.defineProperty(exports, "linearProgressClasses", {
    enumerable: true,
    get: function() {
        return _linearProgressClasses.default;
    }
});
var _LinearProgress = _interopRequireDefault(require("8e9f63e51b74f32a"));
var _linearProgressClasses = _interopRequireWildcard(require("9640e107e12339be"));
Object.keys(_linearProgressClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _linearProgressClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _linearProgressClasses[key];
        }
    });
});

},{"7c6d86866cd236c7":"fiRIh","4375361eeb06e569":"kZ6eK","8e9f63e51b74f32a":"fSZOm","9640e107e12339be":"enPnq"}],"fSZOm":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5f2338453e13027c").default;
var _interopRequireWildcard = require("7578cf94897daf97").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("8a5cc8a8b3dbcff4"));
var _propTypes = _interopRequireDefault(require("aa45e25f76de539d"));
var _clsx = _interopRequireDefault(require("e3c16c671acfe5a8"));
var _composeClasses = _interopRequireDefault(require("d3bcdccd285e35fd"));
var _colorManipulator = require("aaa6a99b132c18d6");
var _RtlProvider = require("7c2038224a8a2022");
var _zeroStyled = require("58e8359c9a93209b");
var _memoTheme = _interopRequireDefault(require("95dd1ac2018b334c"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("2a20e58149780e40"));
var _DefaultPropsProvider = require("448f71fea53b6497");
var _capitalize = _interopRequireDefault(require("6b150ce068a4d106"));
var _linearProgressClasses = require("a8965b77f54863ff");
var _jsxRuntime = require("3bc0805ae59e1344");
const TRANSITION_DURATION = 4; // seconds
const indeterminate1Keyframe = (0, _zeroStyled.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const indeterminate1Animation = typeof indeterminate1Keyframe !== 'string' ? (0, _zeroStyled.css)`
        animation: ${indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const indeterminate2Keyframe = (0, _zeroStyled.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const indeterminate2Animation = typeof indeterminate2Keyframe !== 'string' ? (0, _zeroStyled.css)`
        animation: ${indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const bufferKeyframe = (0, _zeroStyled.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const bufferAnimation = typeof bufferKeyframe !== 'string' ? (0, _zeroStyled.css)`
        animation: ${bufferKeyframe} 3s infinite linear;
      ` : null;
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalize.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, _capitalize.default)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, _capitalize.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, _capitalize.default)(color)}`,
            variant === 'buffer' && `color${(0, _capitalize.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, _composeClasses.default)(slots, _linearProgressClasses.getLinearProgressUtilityClass, classes);
};
const getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62) : (0, _colorManipulator.darken)(theme.palette[color].main, 0.5);
};
const LinearProgressRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        backgroundColor: getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const LinearProgressDashed = (0, _zeroStyled.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, _capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>{
                const backgroundColor = getColorShade(theme, color);
                return {
                    props: {
                        color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${bufferKeyframe} 3s infinite linear`
});
const LinearProgressBar1 = (0, _zeroStyled.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, _capitalize.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: indeterminate1Animation || {
                    animation: `${indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const LinearProgressBar2 = (0, _zeroStyled.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, _capitalize.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: getColorShade(theme, color),
                        transition: `transform .${TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: indeterminate2Animation || {
                    animation: `${indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const LinearProgress = /*#__PURE__*/ React.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className, color = 'primary', value, valueBuffer, variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const isRtl = (0, _RtlProvider.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(LinearProgressRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var _default = exports.default = LinearProgress;

},{"5f2338453e13027c":"kZ6eK","7578cf94897daf97":"fiRIh","8a5cc8a8b3dbcff4":"9njXz","aa45e25f76de539d":"bnNSm","e3c16c671acfe5a8":"d2NWs","d3bcdccd285e35fd":"59Equ","aaa6a99b132c18d6":"hTYBL","7c2038224a8a2022":"ck9Pb","58e8359c9a93209b":"hZXDo","95dd1ac2018b334c":"cJNjb","2a20e58149780e40":"2r5WG","448f71fea53b6497":"9bD8g","6b150ce068a4d106":"eOYSA","a8965b77f54863ff":"enPnq","3bc0805ae59e1344":"1dlk8"}],"enPnq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("74ae98173165e86d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getLinearProgressUtilityClass = getLinearProgressUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("bcbaad49eb36c588"));
var _generateUtilityClass = _interopRequireDefault(require("ba27275674c675b9"));
function getLinearProgressUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiLinearProgress', slot);
}
const linearProgressClasses = (0, _generateUtilityClasses.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var _default = exports.default = linearProgressClasses;

},{"74ae98173165e86d":"kZ6eK","bcbaad49eb36c588":"7pSUk","ba27275674c675b9":"jBs9M"}],"03vVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListView", ()=>ListView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("react-router");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _visibilityOff = require("@mui/icons-material/VisibilityOff");
var _visibilityOffDefault = parcelHelpers.interopDefault(_visibilityOff);
var _doNotDisturbOn = require("@mui/icons-material/DoNotDisturbOn");
var _doNotDisturbOnDefault = parcelHelpers.interopDefault(_doNotDisturbOn);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _store = require("../../store");
var _helpers = require("common/api/v1/helpers");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../common/Link");
var _indicator = require("../common/Indicator");
var _tooltip = require("../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _commonActions = require("./CommonActions");
var _commonActionsDefault = parcelHelpers.interopDefault(_commonActions);
var _addEdgeConnectDialog = require("./AddEdgeConnectDialog");
var _applianceActions = require("../../redux/actions/applianceActions");
var _reactRedux = require("react-redux");
var _actionMenu = require("../common/Table/ActionMenu");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _restartAlt = require("@mui/icons-material/RestartAlt");
var _restartAltDefault = parcelHelpers.interopDefault(_restartAlt);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _confirmDialog = require("../common/ConfirmDialog");
var _removeDialog = require("./Edit/RemoveDialog");
var _applianceProxyButton = require("../common/ApplianceProxyButton");
const ListView = ()=>{
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const { appliances, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useApplianceSelector));
    const user = (0, _utils.useUser)();
    const navigate = (0, _reactRouter.useNavigate)();
    const [selected, setSelected] = (0, _react.useState)([]);
    const [showAddEdgeConnectDialog, setShowAddEdgeConnectDialog] = (0, _react.useState)(false);
    const { showConfirmation, hideConfirmation } = (0, _confirmDialog.useConfirmationDialog)();
    const applianceIds = appliances.map((a)=>a.id);
    (0, _react.useEffect)(()=>{
        dispatch((0, _applianceActions.registerApplianceObserver)({
            applianceIds
        }));
        return ()=>{
            dispatch((0, _applianceActions.unregisterApplianceObserver)({
                applianceIds
            }));
        };
    }, [
        JSON.stringify(applianceIds)
    ]);
    const handleSelect = (id)=>{
        if (selected.includes(id)) setSelected([
            ...selected.filter((item)=>item !== id)
        ]);
        else setSelected([
            ...selected,
            id
        ]);
    };
    const handleSelectAll = ()=>{
        if (selected.length === appliances.length) setSelected([]);
        else setSelected(appliances.reduce((acc, { id })=>acc.concat(id), []));
    };
    const tableConfig = [
        {
            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                indeterminate: selected.length > 0 && selected.length < appliances.length,
                checked: selected.length === appliances.length,
                onChange: ()=>{
                    handleSelectAll();
                },
                inputProps: {
                    'aria-label': 'select all appliances'
                },
                "data-test-id": 'select-all'
            }),
            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: selected.includes(id),
                    onChange: ()=>{
                        handleSelect(id);
                    },
                    onDoubleClick: (e)=>e.stopPropagation()
                }),
            props: {
                padding: 'checkbox',
                noTypography: true
            }
        },
        {
            title: 'status',
            getValue: ({ id, unhealthyAlarm, cordon })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.NonSubscribingAutoUpdatingApplianceHealthIndicator), {
                            applianceId: id
                        }),
                        unhealthyAlarm === 'off' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: 'Status alarms are disabled for this appliance',
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visibilityOffDefault.default), {
                                style: {
                                    marginLeft: '5px'
                                }
                            })
                        }),
                        cordon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: 'This appliance is marked as cordoned - it is not available for provisioning services.',
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _doNotDisturbOnDefault.default), {
                                style: {
                                    fontSize: '1.25em',
                                    marginLeft: unhealthyAlarm === 'off' ? '12px' : '4px'
                                }
                            })
                        })
                    ]
                }),
            sorting: {
                byParameter: (0, _types.ListApplianceSortableField).lastSeen
            },
            props: {
                noTypography: true
            }
        },
        {
            title: 'name',
            getValue: (appliance)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.appliancesUpdate({
                        id: appliance.id
                    }),
                    available: (0, _utils.isEditableAppliance)(user, (0, _utils.getApplianceOwnerId)(appliance)),
                    underline: "hover",
                    children: appliance.name
                }),
            sorting: {
                byParameter: (0, _types.ListApplianceSortableField).applianceName
            }
        },
        {
            title: 'type',
            getValue: ({ type })=>(0, _helpers.getProductName)(type),
            sorting: {
                byParameter: (0, _types.ListApplianceSortableField).applianceType
            }
        },
        {
            title: 'regions',
            getValue: (appliance)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            available: (0, _utils.isEditableRegion)(user),
                            to: routes.regionsUpdate({
                                id: appliance.region.id
                            }),
                            underline: "hover",
                            children: appliance.region.name
                        }),
                        appliance.secondaryRegion ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                ', ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                    available: (0, _utils.isEditableRegion)(user),
                                    to: routes.regionsUpdate({
                                        id: appliance.secondaryRegion.id
                                    }),
                                    underline: "hover",
                                    children: appliance.secondaryRegion.name
                                })
                            ]
                        }) : null
                    ]
                }),
            sorting: {
                byParameter: (0, _types.ListApplianceSortableField).regionName
            }
        },
        {
            title: 'owner',
            getValue: (values)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.groupsUpdate({
                        id: (0, _utils.getApplianceOwnerId)(values)
                    }),
                    underline: "hover",
                    available: values._owner && (0, _utils.isEditableGroup)(values._owner.id, user),
                    children: values._owner && values._owner.name || ''
                }),
            sorting: {
                byParameter: (0, _types.ListApplianceSortableField).ownerGroupName
            }
        },
        {
            title: 'alarms',
            getValue: ({ id, alarms, name })=>alarms.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.alarms({
                        applianceId: id,
                        applianceName: name
                    }),
                    underline: "hover",
                    children: (0, _utils.pluralize)(alarms.length, 'alarm')
                }) : 'No alarms',
            sorting: {
                byParameter: (0, _types.ListApplianceSortableField).numActiveAlarms
            }
        },
        {
            getValue: (appliance)=>{
                const hasApplianceAccess = (0, _utils.isEditableAppliance)(user, (0, _utils.getApplianceOwnerId)(appliance));
                if (!hasApplianceAccess) return null;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _applianceProxyButton.ApplianceProxyButton), {
                            user: user,
                            appliance: appliance
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                            options: [
                                {
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                                    label: 'Edit',
                                    href: routes.appliancesUpdate({
                                        id: appliance.id
                                    })
                                },
                                {
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _restartAltDefault.default), {}),
                                    label: 'Restart',
                                    onClick: ()=>{
                                        showConfirmation(()=>void dispatch((0, _applianceActions.restartAppliance)({
                                                id: appliance.id,
                                                showSuccessSnackbar: true
                                            })), 'Restarting will affect all video streams on the appliance. After restart the appliance will run the latest software version. Do you want to continue?');
                                    }
                                },
                                {
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                                    label: 'Remove',
                                    isDestructive: true,
                                    onClick: ()=>{
                                        showConfirmation(()=>void dispatch((0, _applianceActions.removeAppliance)(appliance.id)), /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeDialog.RemoveDialog), {
                                            appliance: appliance,
                                            hideConfirmDialog: hideConfirmation
                                        }), undefined, {
                                            ok: {
                                                text: 'remove'
                                            }
                                        });
                                    }
                                }
                            ]
                        })
                    ]
                });
            },
            props: {
                align: 'right',
                noTypography: true
            }
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Appliances",
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            color: "primary",
            sx: {
                marginLeft: 4
            },
            onClick: ()=>setShowAddEdgeConnectDialog(true),
            children: "Add Edge Connect"
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commonActionsDefault.default), {
                selected: selected,
                setSelected: setSelected,
                appliances: appliances,
                user: user
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                id: "appliances",
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No appliances available"
                }),
                config: tableConfig,
                data: appliances,
                pending: loading,
                pagination: {
                    total,
                    useUrlSearchParams: true
                },
                rowProps: (appliance)=>{
                    const isEditable = (0, _utils.isEditableAppliance)(user, (0, _utils.getApplianceOwnerId)(appliance));
                    const isItemSelected = Boolean(appliance.id && selected.includes(appliance.id));
                    return {
                        onDoubleClick: ()=>isEditable && void navigate(routes.appliancesUpdate({
                                id: appliance.id
                            })),
                        'aria-checked': isItemSelected,
                        tabIndex: -1,
                        selected: isItemSelected
                    };
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEdgeConnectDialog.AddEdgeConnectDialog), {
                user: user,
                open: showAddEdgeConnectDialog,
                onClose: ()=>setShowAddEdgeConnectDialog(false)
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router":"iaz4C","@mui/material/Button":"3qJY9","@mui/material/Checkbox":"ag1Z5","@mui/icons-material/VisibilityOff":"8LmfP","@mui/icons-material/DoNotDisturbOn":"iMYSA","common/api/v1/types":"3qemx","../../utils":"342UB","../../store":"5LXiG","common/api/v1/helpers":"6jovr","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../common/Link":"l3o6V","../common/Indicator":"hqaQa","../common/Tooltip":"crjvg","./CommonActions":"k0GFH","./AddEdgeConnectDialog":"bq9W1","../../redux/actions/applianceActions":"TaoIu","react-redux":"l1pMU","../common/Table/ActionMenu":"jf6As","@mui/icons-material/Delete":"69aC7","@mui/icons-material/RestartAlt":"7qyv3","@mui/icons-material/Settings":"jkTfg","../common/ConfirmDialog":"7JKPn","./Edit/RemoveDialog":"fYcBA","../common/ApplianceProxyButton":"59aZo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k0GFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _tooltip = require("../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _applianceActions = require("../../redux/actions/applianceActions");
var _store = require("../../store");
var _listApplianceFilter = require("./listApplianceFilter");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _restartAlt = require("@mui/icons-material/RestartAlt");
var _restartAltDefault = parcelHelpers.interopDefault(_restartAlt);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
const BatchRestartButton = ({ selected, setSelected, disabledMessage })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const onClick = ()=>{
        showConfirmation(()=>{
            dispatch((0, _applianceActions.restartAppliances)({
                ids: selected.map(({ id })=>id)
            }));
            setSelected([]);
        }, 'Restarting will affect all video streams on the appliances. After restart the appliances will run the latest software version. Do you want to continue?', selected.length === 1 ? selected[0].name : 'restart appliances', {
            ok: {
                text: 'restart'
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: disabledMessage ?? 'Restart selected appliances',
        disablePortal: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "batch restart",
                onClick: onClick,
                disabled: !!disabledMessage,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _restartAltDefault.default), {})
            })
        })
    });
};
const BatchRemoveButton = ({ selected, setSelected, disabledMessage })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const onClick = ()=>{
        showConfirmation(()=>{
            dispatch((0, _applianceActions.removeAppliances)(selected.map(({ id })=>id)));
            setSelected([]);
        }, 'Are you sure you want to remove the selected appliances?', selected.length === 1 ? selected[0].name : 'remove appliances', {
            ok: {
                text: 'remove',
                color: 'error'
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: disabledMessage ?? 'Remove selected appliances',
        disablePortal: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "batch delete",
                onClick: onClick,
                disabled: !!disabledMessage,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
            })
        })
    });
};
const CommonActions = ({ selected, setSelected, appliances, user })=>{
    const selectedAppliances = appliances.filter(({ id })=>selected.includes(id));
    const isOwnerOfAllSelected = selectedAppliances.every(({ _owner })=>_owner.id === user.group);
    const filters = (0, _listApplianceFilter.makeListApplianceFilter)({
        applianceApi: (0, _store.Api).appliancesApi,
        groupApi: (0, _store.Api).groupsApi,
        regionApi: (0, _store.Api).regionApi,
        tagApi: (0, _store.Api).tagApi
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
        disableGutters: true,
        style: {
            overflowX: 'clip'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>theme.transitions.create('flex-shrink', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.shortest
                        })
                },
                style: {
                    flexShrink: selected.length > 0 ? 1 : 0,
                    flexGrow: 1,
                    flexBasis: '100%'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                    urlParamCacheKey: 'appliances',
                    mapUrlParamToFilterFn: (0, _listApplianceFilter.mapUrlParamToApplianceFilter),
                    mapFilterToUrlParamFn: (0, _listApplianceFilter.mapApplianceFilterToUrlParam),
                    searchTokenFilters: filters,
                    rawTextFilter: filters.find((f)=>f.key === (0, _listApplianceFilter.ListApplianceFilterKey).name)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>// Fade out, i.e. keep visible until contents has left the screen
                        theme.transitions.create('visibility', {
                            delay: selected.length === 0 ? theme.transitions.duration.shortest : 0
                        })
                },
                style: {
                    marginLeft: 16,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    visibility: selected.length > 0 ? 'visible' : 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: 180,
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            variant: "subtitle1",
                            children: [
                                (0, _utils.pluralize)(selected.length, 'appliance'),
                                " selected"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BatchRemoveButton, {
                        selected: selectedAppliances,
                        setSelected: setSelected,
                        disabledMessage: user.role === (0, _types.Role).super || isOwnerOfAllSelected ? undefined : 'You are not the owner of a selected appliance'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(BatchRestartButton, {
                        selected: selectedAppliances,
                        setSelected: setSelected,
                        disabledMessage: user.role === (0, _types.Role).super || isOwnerOfAllSelected ? undefined : 'You are not the owner of a selected appliance'
                    })
                ]
            })
        ]
    });
};
exports.default = CommonActions;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Typography":"6NtGx","@mui/material/Toolbar":"5Kohb","../common/Tooltip":"crjvg","common/api/v1/types":"3qemx","../../utils":"342UB","../../redux/actions/applianceActions":"TaoIu","../../store":"5LXiG","./listApplianceFilter":"1UYnF","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@mui/material/Box":"c4QkF","@mui/icons-material/Delete":"69aC7","@mui/icons-material/RestartAlt":"7qyv3","@mui/material/IconButton":"488As","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1UYnF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListApplianceFilterKey", ()=>ListApplianceFilterKey);
parcelHelpers.export(exports, "makeListApplianceFilter", ()=>makeListApplianceFilter);
parcelHelpers.export(exports, "mapApplianceFilterToUrlParam", ()=>mapApplianceFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToApplianceFilter", ()=>mapUrlParamToApplianceFilter);
var _helpers = require("common/api/v1/helpers");
var _utils = require("common/utils");
var ListApplianceFilterKey = /*#__PURE__*/ function(ListApplianceFilterKey) {
    ListApplianceFilterKey["name"] = "name";
    ListApplianceFilterKey["type"] = "type";
    ListApplianceFilterKey["region"] = "region";
    ListApplianceFilterKey["groupName"] = "owner";
    ListApplianceFilterKey["tag"] = "tag";
    return ListApplianceFilterKey;
}({});
function makeListApplianceFilter({ applianceApi, groupApi, regionApi, tagApi }) {
    const requestPaging = {
        pageNumber: '0',
        rowsPerPage: '20'
    };
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        },
        {
            key: "type",
            operator: 'isOneOf',
            possibleValues: async (searchText)=>{
                const { items: applianceTypes } = await applianceApi.listRegisteredApplianceTypes();
                return applianceTypes.map((type)=>({
                        value: type,
                        displayName: (0, _helpers.getProductName)(type)
                    })).filter(({ displayName })=>displayName.toLowerCase().includes((searchText ?? '').toLowerCase()));
            }
        },
        {
            key: "owner",
            operator: 'is',
            possibleValues: async (searchText)=>{
                const result = await groupApi.getPureGroups({
                    ...requestPaging,
                    filter: searchText
                });
                return result.items.map((a)=>({
                        value: a.name,
                        displayName: a.name
                    }));
            }
        },
        {
            key: "region",
            operator: 'isOneOf',
            possibleValues: async (searchText)=>{
                const result = await regionApi.getRegions({
                    ...requestPaging,
                    filter: searchText
                });
                return result.items.map((r)=>({
                        value: r.name,
                        displayName: r.name
                    }));
            }
        },
        {
            key: "tag",
            operator: 'isOneOf',
            possibleValues: async (searchText)=>{
                const { items: tags } = await tagApi.listTags({
                    filter: {
                        searchName: searchText
                    }
                });
                // Super user receives tags from all groups - no need to display duplicates
                const uniqueTags = (0, _utils.distinct)(tags, (a, b)=>a.name === b.name);
                return uniqueTags.map(({ name })=>({
                        value: name,
                        displayName: name
                    }));
            }
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}
function mapApplianceFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
        case "owner":
            return {
                groupName: filter.value
            };
    }
    else if ('values' in filter) switch(filter.key){
        case "type":
            return {
                types: filter.values.map(({ value })=>value).join(',')
            };
        case "region":
            return {
                regions: filter.values.map(({ value })=>value).join(',')
            };
        case "tag":
            return {
                tags: filter.values.map(({ value })=>value).join(',')
            };
    }
    return {};
}
function mapUrlParamToApplianceFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
        case 'groupName':
            return {
                key: "owner",
                operator: 'is',
                value
            };
        case 'types':
            return {
                key: "type",
                operator: 'isOneOf',
                values: value.split(',').map((type)=>({
                        value: type,
                        displayName: (0, _helpers.getProductName)(type)
                    }))
            };
        case 'regions':
            return {
                key: "region",
                operator: 'isOneOf',
                values: value.split(',').map((regionName)=>({
                        value: regionName,
                        displayName: regionName
                    }))
            };
        case 'tags':
            return {
                key: "tag",
                operator: 'isOneOf',
                values: value.split(',').map((tagName)=>({
                        value: tagName,
                        displayName: tagName
                    }))
            };
    }
    return undefined;
}

},{"common/api/v1/helpers":"6jovr","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7qyv3":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("8787b8228d0f6cc6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6a9288c6c0708bb5"));
var _jsxRuntime = require("8eb03e5665d933ec");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8m-6 8c0-1.65.67-3.15 1.76-4.24L6.34 7.34C4.9 8.79 4 10.79 4 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91"
}), 'RestartAlt');

},{"8787b8228d0f6cc6":"kZ6eK","6a9288c6c0708bb5":"2vOnF","8eb03e5665d933ec":"1dlk8"}],"ggon3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Config", ()=>Config);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _applianceActions = require("../../redux/actions/applianceActions");
var _utils = require("../../utils");
var _pendable = require("../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _dataSet = require("../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _form = require("../common/Form");
var _recursiveDataSet = require("../common/RecursiveDataSet");
const ownClasses = {
    paperItem: {
        marginTop: 0,
        marginBottom: 0
    }
};
const initialState = (collapsed)=>({
        inputs: collapsed,
        outputs: collapsed,
        tunnels: collapsed,
        channels: collapsed,
        settings: collapsed,
        vaInput: collapsed,
        vaOutput: collapsed,
        commands: collapsed,
        firewallWhitelists: collapsed
    });
const Config = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        id && dispatch((0, _applianceActions.getApplianceConfig)(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { devMode } = (0, _utils.useSettingsSelector)();
    const { config, loading } = (0, _reactRedux.useSelector)((state)=>({
            config: state.appliancesReducer.config,
            loading: state.appliancesReducer.loading
        }), (0, _reactRedux.shallowEqual));
    const objects = {
        inputs: 'Inputs',
        outputs: 'Outputs',
        tunnels: 'Tunnels',
        channels: 'Channels',
        settings: 'General Settings',
        vaInput: 'VA inputs',
        vaOutput: 'VA outputs',
        commands: 'Commands'
    };
    const [collapsed, setCollapsed] = (0, _react.useState)(initialState(true));
    const bottomButtons = {
        'Regenerate config': {
            disabled: !!loading,
            onClick: ()=>{
                dispatch((0, _applianceActions.clearCachedApplianceConfig)(id));
                return;
            },
            primary: true
        }
    };
    if (navigator.clipboard) bottomButtons['Copy JSON'] = {
        onClick: ()=>{
            navigator.clipboard.writeText(JSON.stringify(config));
            return;
        },
        primary: true
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: "Appliance configuration",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
            cover: true,
            pending: !!id && loading && !!config,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                    title: "Metadata",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                        xs: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                            values: {
                                logLevel: config?.logLevel,
                                ...devMode && {
                                    ristserverLogLevel: config?.ristserverLogLevel
                                }
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                    main: Object.values(collapsed).some((c)=>c) ? {
                        'Expand all': {
                            onClick: ()=>setCollapsed(initialState(false)),
                            primary: false
                        }
                    } : {
                        'Collapse all': {
                            onClick: ()=>setCollapsed(initialState(true)),
                            primary: false
                        }
                    }
                }),
                config && Object.entries(objects).map(([key, title])=>{
                    const entry = config[key];
                    if (!entry) return null;
                    const arrayEntry = Array.isArray(entry) ? entry : [
                        entry
                    ];
                    if (arrayEntry.length === 0) return null;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        className: "outlined",
                        title: title,
                        collapsible: true,
                        collapsed: collapsed[key],
                        onCollapseChange: (c)=>setCollapsed({
                                ...collapsed,
                                [key]: c
                            }),
                        children: arrayEntry.map((object, ind)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                    sx: ownClasses.paperItem,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recursiveDataSet.RecursiveDataSet), {
                                        object: object
                                    })
                                })
                            }, `${key}-${ind}`))
                    }, key);
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                    className: "outlined",
                    title: 'Firewall whitelists',
                    collapsible: true,
                    collapsed: collapsed['firewallWhitelists'],
                    onCollapseChange: (c)=>setCollapsed({
                            ...collapsed,
                            firewallWhitelists: c
                        }),
                    children: config?.firewall.whitelists?.map((object, ind)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            xs: 12,
                            lg: 6,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                sx: ownClasses.paperItem,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recursiveDataSet.RecursiveDataSet), {
                                    object: object
                                })
                            })
                        }, `${'firewallWhitelist'}-${ind}`))
                }, 'firewallWhitelist'),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                    main: bottomButtons
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","../../redux/actions/applianceActions":"TaoIu","../../utils":"342UB","../common/Pendable":"gDN67","../common/Wrapper":"8oy7r","../common/DataSet":"dmQXG","../common/Form":"4Mui7","../common/RecursiveDataSet":"itnYL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"itnYL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RecursiveDataSet", ()=>RecursiveDataSet);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dataSet = require("./DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _collapse = require("@mui/material/Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _keyboardArrowDown = require("@mui/icons-material/KeyboardArrowDown");
var _keyboardArrowDownDefault = parcelHelpers.interopDefault(_keyboardArrowDown);
var _keyboardArrowRight = require("@mui/icons-material/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
const camelCaseToSentenceCase = (str)=>{
    return str.replace(/([A-Z])/g, ' $1').replace(/^./, (match)=>match.toUpperCase()).trim();
};
const toRenderable = (object, sentenceCase = true)=>Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [sentenceCase ? camelCaseToSentenceCase(key) : key]: /*#__PURE__*/ (0, _react.isValidElement)(value) ? value : String(value)
        }), {});
const CollapsibleSection = ({ title, children, depth = 0 })=>{
    const [expanded, setExpanded] = (0, _react.useState)(true);
    // Calculate the offset to align content with header text
    // IconButton has 2px padding + icon width (~20px) + 4px margin = ~26px
    const getContentOffset = ()=>{
        return '26px' // Approximate width of icon button + margin
        ;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            mt: depth === 0 ? 2 : 1
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: 'action.hover',
                        borderRadius: 1
                    },
                    p: 0.5,
                    ml: -0.5
                },
                onClick: ()=>setExpanded(!expanded),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                        size: "small",
                        sx: {
                            padding: '2px',
                            marginRight: '4px'
                        },
                        children: expanded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowDownDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowRightDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body1",
                        sx: {
                            fontWeight: 500
                        },
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
                in: expanded,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: {
                        ml: getContentOffset()
                    },
                    children: children
                })
            })
        ]
    });
};
const RecursiveDataSet = ({ object, style, sentenceCase = false, depth = 0 })=>{
    if (typeof object !== 'object' || object === null || /*#__PURE__*/ (0, _react.isValidElement)(object)) // Treat React elements like primitives
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
            values: {
                '': /*#__PURE__*/ (0, _react.isValidElement)(object) ? object : String(object)
            }
        })
    });
    const entries = Object.entries(object);
    const { flat, objects, arrays } = entries.reduce((acc, [key, value])=>{
        if (/*#__PURE__*/ (0, _react.isValidElement)(value)) acc.flat[key] = value;
        else if (Array.isArray(value)) acc.arrays.push([
            key,
            value
        ]);
        else if (value && typeof value === 'object') acc.objects.push([
            key,
            value
        ]);
        else acc.flat[key] = value;
        return acc;
    }, {
        flat: {},
        objects: [],
        arrays: []
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: style,
        children: [
            Object.keys(flat).length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                values: toRenderable(flat, sentenceCase)
            }),
            objects.map(([key, value], ind)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapsibleSection, {
                    title: sentenceCase ? camelCaseToSentenceCase(key) : key,
                    depth: depth,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RecursiveDataSet, {
                        object: value,
                        sentenceCase: sentenceCase,
                        depth: depth + 1
                    })
                }, `${key}-${ind}`)),
            arrays.map(([key, value], ind)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapsibleSection, {
                    title: sentenceCase ? camelCaseToSentenceCase(key) : key,
                    depth: depth,
                    children: value.map((item, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapsibleSection, {
                            title: `Item ${i + 1}`,
                            depth: depth + 1,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RecursiveDataSet, {
                                object: item,
                                sentenceCase: sentenceCase,
                                depth: depth + 2
                            })
                        }, `${key}-item-${i}`))
                }, `${key}-${ind}`))
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./DataSet":"dmQXG","@mui/material/Typography":"6NtGx","@mui/material/Box":"c4QkF","@mui/material/Collapse":"c7nwP","@mui/material/IconButton":"488As","@mui/icons-material/KeyboardArrowDown":"2TA6B","@mui/icons-material/KeyboardArrowRight":"d6UJH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYs69":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Outputs", ()=>Outputs);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _list = require("../outputLists/List");
var _edit = require("../outputLists/Edit");
var _list1 = require("./List");
var _edit1 = require("./Edit");
const Outputs = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).UPDATE,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit1.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).NEW,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit1.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).COPY,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit1.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list1.List), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Route), {
                path: "lists",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                        index: true,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.ListView), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                        path: (0, _routes.SUB_PATH).NEW,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                        path: (0, _routes.SUB_PATH).UPDATE,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                        path: "*",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","../outputLists/List":"pObDE","../outputLists/Edit":"50uBJ","./List":"lBjcz","./Edit":"5vOuW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"pObDE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListView", ()=>ListView);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _utils = require("../../utils");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../common/Link");
var _store = require("../../store");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _listOutputListsFilter = require("./listOutputListsFilter");
var _actionMenu = require("../common/Table/ActionMenu");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _reactRedux = require("react-redux");
var _outputListsActions = require("../../redux/actions/outputListsActions");
const ListView = ()=>{
    const routes = (0, _store.useRoutes)();
    const { outputLists, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useOutputListsSelector));
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const tableConfig = [
        {
            title: 'name',
            getValue: (outputList)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.outputListsUpdate({
                        id: outputList.id
                    }),
                    underline: "hover",
                    children: outputList.name
                }),
            sorting: {
                byParameter: 'name'
            }
        },
        {
            title: 'description',
            getValue: ({ description })=>description,
            sorting: {
                byParameter: 'description'
            }
        },
        {
            title: 'group',
            getValue: (groupList)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.groupsUpdate({
                        id: groupList.group
                    }),
                    underline: "hover",
                    children: groupList._group?.name
                })
        },
        {
            getValue: (outputList)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    options: [
                        {
                            label: 'Edit',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                            href: routes.outputListsUpdate({
                                id: outputList.id
                            })
                        },
                        {
                            label: 'Remove',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                            isDestructive: true,
                            onClick: ()=>{
                                showConfirmation(()=>dispatch((0, _outputListsActions.removeOutputList)(outputList.id)), `Are you sure you want to remove output list ${outputList.name}?`);
                            }
                        }
                    ]
                }),
            props: {
                align: 'right'
            }
        }
    ];
    const filters = (0, _listOutputListsFilter.makeListOutputListsFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: [
            'Outputs',
            'Lists'
        ],
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            type: "button",
            to: routes.outputListsNew(),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "contained",
                color: "primary",
                children: "Add output list"
            })
        }, "outputListCreate"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'outputLists',
                        mapUrlParamToFilterFn: (0, _listOutputListsFilter.mapUrlParamToOutputListFilter),
                        mapFilterToUrlParamFn: (0, _listOutputListsFilter.mapOutputListFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listOutputListsFilter.ListOutputListFilterKey).name)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                id: "output-lists-table",
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No output lists",
                    buttonText: "Add output list",
                    url: routes.outputListsNew()
                }),
                config: tableConfig,
                data: outputLists,
                pending: loading,
                pagination: {
                    total,
                    useUrlSearchParams: true
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Button":"3qJY9","../../utils":"342UB","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../common/Link":"l3o6V","../../store":"5LXiG","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@mui/material/Toolbar":"5Kohb","./listOutputListsFilter":"bKlmK","../common/Table/ActionMenu":"jf6As","@mui/icons-material/Delete":"69aC7","@mui/icons-material/Settings":"jkTfg","react-redux":"l1pMU","../../redux/actions/outputListsActions":"ce4Vm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bKlmK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListOutputListFilterKey", ()=>ListOutputListFilterKey);
parcelHelpers.export(exports, "mapOutputListFilterToUrlParam", ()=>mapOutputListFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToOutputListFilter", ()=>mapUrlParamToOutputListFilter);
parcelHelpers.export(exports, "makeListOutputListsFilter", ()=>makeListOutputListsFilter);
var ListOutputListFilterKey = /*#__PURE__*/ function(ListOutputListFilterKey) {
    ListOutputListFilterKey["name"] = "name";
    return ListOutputListFilterKey;
}({});
function mapOutputListFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToOutputListFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListOutputListsFilter() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"50uBJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _mergeWith = require("lodash/mergeWith");
var _mergeWithDefault = parcelHelpers.interopDefault(_mergeWith);
var _store = require("../../../store");
var _utils = require("../../../utils");
var _outputListsActions = require("../../../redux/actions/outputListsActions");
var _form = require("../../common/Form");
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _availableOutputs = require("./AvailableOutputs");
var _availableOutputsDefault = parcelHelpers.interopDefault(_availableOutputs);
var _outputs = require("./Outputs");
var _outputsDefault = parcelHelpers.interopDefault(_outputs);
var _rhf = require("../../common/Form/RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
const { outputListsApi } = (0, _store.Api);
const getInitialState = (group, selectedOutputList)=>(0, _mergeWithDefault.default)({
        name: '',
        description: '',
        group,
        addOutputs: [],
        removeOutputs: []
    }, selectedOutputList, (_initial, existent, key)=>{
        if ('description' === key && !existent) return '';
    });
const OutputListForm = ({ getValues, setError, setFocus, formState, availableOutputs })=>{
    const values = getValues();
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirm = (0, _utils.useConfirmationDialog)();
    const { formErrors, saving } = (0, _reactRedux.useSelector)(({ outputListsReducer })=>({
            formErrors: outputListsReducer.formErrors,
            saving: outputListsReducer.saving
        }), (0, _reactRedux.shallowEqual));
    const [addIsShown, setAddIsShown] = (0, _react.useState)(!values.id);
    const [outputsCollapsed, setOutputsCollapsed] = (0, _react.useState)(false);
    const deleteOutputList = ()=>{
        showConfirm(()=>{
            dispatch((0, _outputListsActions.removeOutputList)(values.id));
        }, `Are you sure you want to delete output list ${values.name}?`);
    };
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach((item)=>{
                setError(item.name, {
                    type: 'manual',
                    message: item.reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                formState: formState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "output-list-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        className: "outlined",
                        title: "Metadata",
                        collapsible: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        name: "name",
                                        label: "Name",
                                        required: true,
                                        autoFocus: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        name: "description",
                                        label: "Description",
                                        multiline: true
                                    })
                                ]
                            }),
                            !!values.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                    lg: 12,
                                    xl: 12,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                                        values: {
                                            Id: values.id,
                                            Group: values._group?.name ?? 'N/A'
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    !!values.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        title: "Outputs",
                        collapsible: true,
                        collapsed: outputsCollapsed,
                        actionsPane: !addIsShown && availableOutputs > 0 ? [
                            {
                                id: 'add-outputs',
                                title: 'Add outputs',
                                onClick: ()=>{
                                    setAddIsShown(true);
                                    setOutputsCollapsed(true);
                                }
                            }
                        ] : [],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outputsDefault.default), {})
                    }),
                    addIsShown && !saving && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        title: "Select outputs",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _availableOutputsDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>void navigate(routes.outputLists())
                            },
                            Save: {
                                savingState: !!saving,
                                primary: true,
                                type: 'submit'
                            }
                        },
                        secondary: values.id ? {
                            'Remove output list': {
                                onClick: deleteOutputList
                            }
                        } : undefined
                    })
                ]
            })
        ]
    });
};
const Edit = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const { outputList } = (0, _reactRedux.useSelector)(({ outputListsReducer })=>({
            outputList: outputListsReducer.outputList
        }), (0, _reactRedux.shallowEqual));
    const { group } = (0, _utils.useUser)();
    const [availableOutputs, setAvailableOutputs] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        let unmounted = false;
        if (id) {
            const params = {
                pageNumber: '0',
                rowsPerPage: '10'
            };
            const outputsInList = false;
            const belongsToUserGroup = (output)=>output.group === group;
            outputListsApi.getOutputs(id, outputsInList, params).then(({ items })=>{
                if (!unmounted) setAvailableOutputs(items.filter(belongsToUserGroup).length);
            });
        }
        return ()=>{
            unmounted = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, _react.useEffect)(()=>{
        id && dispatch((0, _outputListsActions.getOutputList)(id));
        return ()=>{
            dispatch((0, _outputListsActions.clearOutputList)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSubmit = (draft)=>{
        if (outputList) dispatch((0, _outputListsActions.updateOutputList)({
            outputList: draft,
            withRedirection: true
        }));
        else dispatch((0, _outputListsActions.createOutputList)(draft));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Outputs',
            'Lists',
            id ? outputList?.name : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: !!id && !outputList,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rhfDefault.default), {
                onSubmit: (values)=>{
                    onSubmit((0, _utils.formTransform)(values));
                },
                defaultValues: getInitialState(group, outputList),
                children: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputListForm, {
                        ...props,
                        availableOutputs: availableOutputs
                    })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","lodash/mergeWith":"40Q54","../../../store":"5LXiG","../../../utils":"342UB","../../../redux/actions/outputListsActions":"ce4Vm","../../common/Form":"4Mui7","../../common/DataSet":"dmQXG","../../common/Pendable":"gDN67","../../common/Wrapper":"8oy7r","./AvailableOutputs":"70FCW","./Outputs":"bZGnq","../../common/Form/RHF":"7gFt3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70FCW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _store = require("../../../store");
var _selfStatePaginatedList = require("../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _table = require("../../common/Table");
var _indicator = require("../../common/Indicator");
var _utils = require("../../../utils");
var _reactHookForm = require("react-hook-form");
const styles = {
    button: {
        color: (theme)=>theme.palette.error.main,
        borderColor: (theme)=>theme.palette.error.main,
        '&:hover': {
            borderColor: (theme)=>theme.palette.error.dark
        }
    }
};
const { outputListsApi, outputApi } = (0, _store.Api);
const AddRemoveButton = ({ id })=>{
    const { setValue, watch } = (0, _reactHookForm.useFormContext)();
    const currentAddOutputs = watch('addOutputs');
    const onAdd = (id)=>setValue('addOutputs', [
            ...currentAddOutputs,
            id
        ]);
    const onCancel = (id)=>{
        setValue('addOutputs', currentAddOutputs.filter((outputId)=>outputId !== id));
    };
    return currentAddOutputs.includes(id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        sx: styles.button,
        onClick: ()=>onCancel(id),
        variant: "outlined",
        size: "small",
        children: "Cancel"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        onClick: ()=>onAdd(id),
        variant: "outlined",
        size: "small",
        children: "Add"
    });
};
const AvailableOutputs = ()=>{
    const [hideFilter, setHideFilter] = (0, _react.useState)(true);
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    const user = (0, _utils.useUser)();
    const listGroup = values.group ?? user?.group;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        size: {
            xs: 12
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
            api: values.id ? function(params) {
                return outputListsApi.getOutputs(values.id, false, {
                    group: listGroup,
                    ...params
                });
            } : outputApi.getOutputs.bind(outputApi),
            emptyMessage: "no available outputs",
            hideSearch: hideFilter,
            notFoundMessage: "no matching outputs",
            onListChange: ({ filter, total = 0 })=>setHideFilter(!filter && total < 10),
            searchPlaceholder: "Find specific output\u2026",
            List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                    data: values.group ? list.filter((output)=>output.group === values.group) : list,
                    isSmall: true,
                    hasBorders: true,
                    noHeader: true,
                    config: [
                        {
                            getValue: ({ name })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    children: name
                                })
                        },
                        {
                            getValue: (output)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AutoUpdatingOutputHealthIndicator), {
                                    initialOutput: output
                                })
                        },
                        {
                            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(AddRemoveButton, {
                                    id: id
                                }),
                            props: {
                                align: 'right',
                                padding: 'normal'
                            }
                        }
                    ]
                })
        })
    });
};
exports.default = AvailableOutputs;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Button":"3qJY9","@mui/material/Grid":"6iX4B","@mui/material/Typography":"6NtGx","../../../store":"5LXiG","../../common/SelfStatePaginatedList":"dLSax","../../common/Table":"dt9lf","../../common/Indicator":"hqaQa","../../../utils":"342UB","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bZGnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _highlightOff = require("@mui/icons-material/HighlightOff");
var _highlightOffDefault = parcelHelpers.interopDefault(_highlightOff);
var _store = require("../../../store");
var _selfStatePaginatedList = require("../../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _table = require("../../common/Table");
var _indicator = require("../../common/Indicator");
var _reactHookForm = require("react-hook-form");
const styles = {
    button: {
        color: (theme)=>theme.palette.error.main,
        borderColor: (theme)=>theme.palette.error.main,
        '&:hover': {
            borderColor: (theme)=>theme.palette.error.dark
        }
    }
};
const outputListsApi = (0, _store.Api).outputListsApi;
const RemoveButton = ({ id })=>{
    const { setValue, watch } = (0, _reactHookForm.useFormContext)();
    const currentRemoveOutputs = watch('removeOutputs');
    const onRemove = (id)=>setValue('removeOutputs', [
            ...currentRemoveOutputs,
            id
        ]);
    const onCancel = (id)=>{
        setValue('removeOutputs', currentRemoveOutputs.filter((outputId)=>outputId !== id));
    };
    return currentRemoveOutputs.includes(id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        sx: styles.button,
        onClick: ()=>onCancel(id),
        variant: "outlined",
        size: "small",
        children: "Cancel"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: "Remove from list",
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
            edge: "start",
            "aria-label": "remove",
            onClick: ()=>onRemove(id),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightOffDefault.default), {})
        })
    });
};
const Outputs = ()=>{
    const [hideFilter, setHideFilter] = (0, _react.useState)(true);
    const { getValues } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        size: {
            xs: 12
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
            api: function(params) {
                return outputListsApi.getOutputs(values.id, true, params);
            },
            emptyMessage: "no outputs",
            hideSearch: hideFilter,
            notFoundMessage: "no matching outputs",
            onListChange: ({ filter, total = 0 })=>{
                setHideFilter(!filter && total < 10);
            },
            searchPlaceholder: "Find specific output\u2026",
            List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                    data: list,
                    isSmall: true,
                    hasBorders: true,
                    noHeader: true,
                    config: [
                        {
                            getValue: ({ name })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    children: name
                                })
                        },
                        {
                            getValue: (output)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AutoUpdatingOutputHealthIndicator), {
                                    initialOutput: output
                                })
                        },
                        {
                            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RemoveButton, {
                                    id: id
                                }),
                            props: {
                                align: 'right',
                                padding: 'normal'
                            }
                        }
                    ]
                })
        })
    });
};
exports.default = Outputs;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Button":"3qJY9","@mui/material/Grid":"6iX4B","@mui/material/IconButton":"488As","../../common/Tooltip":"crjvg","@mui/material/Typography":"6NtGx","@mui/icons-material/HighlightOff":"afUuo","../../../store":"5LXiG","../../common/SelfStatePaginatedList":"dLSax","../../common/Table":"dt9lf","../../common/Indicator":"hqaQa","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dJzk1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alarms", ()=>Alarms);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _notFound = require("../common/NotFound");
const Alarms = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","./Table":"6nggB","../common/NotFound":"1Msr5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6nggB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _alarms = require("./Alarms");
var _alarmsDefault = parcelHelpers.interopDefault(_alarms);
var _utils = require("../../../utils");
var _listAlarmFilter = require("../listAlarmFilter");
var _filteredSearchBar = require("../../common/Filters/FilterView/FilteredSearchBar");
const styles = {
    paper: {
        padding: (theme)=>theme.spacing(2)
    }
};
const AlarmsTable = ()=>{
    const { devMode } = (0, _utils.useSettingsSelector)();
    const [urlParams, setUrlParams] = (0, _utils.usePageParams)();
    const { applianceId, applianceName } = urlParams;
    (0, _react.useEffect)(()=>{
        // Remove 'applianceName' from url params if applianceId filter is removed. (applianceName is only used by frontend to display the name)
        const keepApplianceName = !!applianceId;
        if (applianceName && !keepApplianceName) setUrlParams({
            ...urlParams,
            applianceName: ''
        });
    }, [
        applianceId,
        applianceName
    ]);
    const filters = (0, _listAlarmFilter.makeListAlarmsFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: [
            'Alarms',
            applianceId ? applianceName : undefined
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'alarms',
                        mapUrlParamToFilterFn: (0, _listAlarmFilter.mapUrlParamToAlarmFilter),
                        mapFilterToUrlParamFn: (0, _listAlarmFilter.mapAlarmFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listAlarmFilter.ListAlarmFilterKey).name)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
                sx: styles.paper,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alarmsDefault.default), {
                    showTexts: true,
                    showClearButton: devMode
                })
            })
        ]
    });
};
exports.default = AlarmsTable;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Paper":"aexCI","@mui/material/Toolbar":"5Kohb","../../common/Wrapper":"8oy7r","./Alarms":"6zAIJ","../../../utils":"342UB","../listAlarmFilter":"86oFT","../../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"86oFT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAlarmFilterKey", ()=>ListAlarmFilterKey);
parcelHelpers.export(exports, "mapUrlParamToAlarmFilter", ()=>mapUrlParamToAlarmFilter);
parcelHelpers.export(exports, "mapAlarmFilterToUrlParam", ()=>mapAlarmFilterToUrlParam);
parcelHelpers.export(exports, "makeListAlarmsFilter", ()=>makeListAlarmsFilter);
var ListAlarmFilterKey = /*#__PURE__*/ function(ListAlarmFilterKey) {
    ListAlarmFilterKey["name"] = "name";
    ListAlarmFilterKey["applianceId"] = "applianceId";
    return ListAlarmFilterKey;
}({});
function mapUrlParamToAlarmFilter(key, value) {
    switch(key){
        case 'applianceId':
            return {
                key: "applianceId",
                operator: 'is',
                value
            };
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
    }
}
function mapAlarmFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
        case "applianceId":
            return {
                applianceId: filter.value
            };
    }
    return {};
}
function makeListAlarmsFilter() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d0cOl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BillingReport", ()=>BillingReport);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _notFound = require("../common/NotFound");
var _report = require("./Report");
var _reportDefault = parcelHelpers.interopDefault(_report);
const BillingReport = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../common/NotFound":"1Msr5","./Report":"78cU9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"78cU9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../common/Form");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _filter = require("./Filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _summary = require("./Summary");
var _summaryDefault = parcelHelpers.interopDefault(_summary);
const Report = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Billing",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: "Period",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: "Monthly Billing",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _summaryDefault.default), {})
            })
        ]
    });
};
exports.default = Report;

},{"react/jsx-runtime":"1dlk8","../../common/Form":"4Mui7","../../common/Wrapper":"8oy7r","./Filter":"1Ldzb","./Summary":"bXkqx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Ldzb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _getApp = require("@mui/icons-material/GetApp");
var _getAppDefault = parcelHelpers.interopDefault(_getApp);
var _xDatePickers = require("@mui/x-date-pickers");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _dateFns = require("date-fns");
var _billingActions = require("../../../redux/actions/billingActions");
var _routes = require("../../../utils/routes");
var _utils = require("../../../utils");
var _helpers = require("common/api/v1/helpers");
const styles = {
    buttonContainer: {
        margin: '0 0 0 auto'
    },
    input: {
        marginRight: 2
    },
    buttonText: (theme)=>({
            [theme.breakpoints.down('xs')]: {
                display: 'none'
            }
        }),
    icon: (theme)=>({
            marginLeft: theme.spacing(1),
            [theme.breakpoints.down('xs')]: {
                marginLeft: 0
            }
        })
};
var DateField = /*#__PURE__*/ function(DateField) {
    DateField["startDate"] = "startDate";
    DateField["endDate"] = "endDate";
    return DateField;
}(DateField || {});
const getRequestParams = (from, to)=>({
        ["startDate"]: from,
        ["endDate"]: to
    });
const PeriodFilter = ()=>{
    const [{ startDate, endDate }, setPageParams] = (0, _utils.usePageParams)();
    const [openFrom, setOpenFrom] = (0, _react.useState)(false);
    const [openTo, setOpenTo] = (0, _react.useState)(false);
    const [from, setFrom] = (0, _react.useState)(startDate ? (0, _dateFns.parseISO)(startDate) : (0, _helpers.startOfMonthUTC)(new Date()));
    const [to, setTo] = (0, _react.useState)(endDate ? (0, _dateFns.parseISO)(endDate) : new Date());
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        startDate && setFrom((0, _dateFns.parseISO)(startDate));
        endDate && setTo((0, _dateFns.parseISO)(endDate));
    }, [
        startDate,
        endDate
    ]);
    (0, _react.useEffect)(()=>{
        dispatch((0, _billingActions.readBilling)(getRequestParams(from, to)));
    }, [
        dispatch,
        to,
        from
    ]);
    const setDate = (dateField, value)=>{
        if (!value || !value.getTime()) return;
        const params = {
            ["startDate"]: dateField === "startDate" ? (0, _helpers.startOfMonthUTC)(value).toISOString() : startDate,
            ["endDate"]: dateField === "endDate" ? (0, _helpers.endOfMonthUTC)(value).toISOString() : endDate
        };
        setPageParams(params);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _xDatePickers.LocalizationProvider), {
                    dateAdapter: (0, _adapterDateFns.AdapterDateFns),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
                            open: openFrom,
                            onOpen: ()=>setOpenFrom(true),
                            onClose: ()=>setOpenFrom(false),
                            label: "From month:",
                            views: [
                                'year',
                                'month'
                            ],
                            format: "yyyy MMM",
                            value: (0, _helpers.startOfDayUTC)(from),
                            onChange: (value)=>setDate("startDate", value),
                            minDate: new Date('2020-01'),
                            maxDate: to,
                            disableFuture: true,
                            slotProps: {
                                textField: {
                                    variant: 'standard',
                                    onClick: ()=>setOpenFrom(true)
                                }
                            },
                            sx: styles.input
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
                            open: openTo,
                            onOpen: ()=>setOpenTo(true),
                            onClose: ()=>setOpenTo(false),
                            label: "To month:",
                            views: [
                                'year',
                                'month'
                            ],
                            format: "yyyy MMM",
                            value: (0, _helpers.startOfDayUTC)(to),
                            onChange: (value)=>setDate("endDate", value),
                            minDate: from,
                            maxDate: (0, _dateFns.endOfMonth)(new Date()),
                            slotProps: {
                                textField: {
                                    variant: 'standard',
                                    onClick: ()=>setOpenTo(true)
                                }
                            },
                            sx: styles.input
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                sx: styles.buttonContainer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    underline: "none",
                    href: (0, _routes.api).billing({
                        ...getRequestParams(from, to),
                        format: 'pdf'
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
                        variant: "outlined",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                sx: styles.buttonText,
                                children: "Download"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _getAppDefault.default), {
                                sx: styles.icon
                            })
                        ]
                    })
                })
            })
        ]
    });
};
exports.default = PeriodFilter;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Link":"chNUC","@mui/material/Grid":"6iX4B","@mui/icons-material/GetApp":"8q9m0","@mui/x-date-pickers":"gSoHo","@mui/x-date-pickers/AdapterDateFns":"bSwsg","date-fns":"gelMX","../../../redux/actions/billingActions":"dBFQZ","../../../utils/routes":"cqMGU","../../../utils":"342UB","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8q9m0":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("734f6742fbb1de81").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("f2c7d5d5b56e7192"));
var _jsxRuntime = require("d4a4e2a31fe70e6b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"
}), 'GetApp');

},{"734f6742fbb1de81":"kZ6eK","f2c7d5d5b56e7192":"2vOnF","d4a4e2a31fe70e6b":"1dlk8"}],"bXkqx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _collapse = require("@mui/material/Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _keyboardArrowDown = require("@mui/icons-material/KeyboardArrowDown");
var _keyboardArrowDownDefault = parcelHelpers.interopDefault(_keyboardArrowDown);
var _keyboardArrowRight = require("@mui/icons-material/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _helpers = require("common/api/v1/helpers");
const styles = {
    container: {
        flex: 1
    },
    noCreditsConsumed: {
        color: (theme)=>theme.palette.grey[600]
    },
    idData: {
        color: (theme)=>theme.palette.grey[600],
        maxWidth: '200px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    maxConcurrencyDate: {
        color: (theme)=>theme.palette.grey[600],
        marginLeft: '5px',
        fontWeight: 'normal'
    }
};
const rowStyles = {
    root: {
        cursor: 'pointer',
        '& > *': {
            borderBottom: 'unset'
        }
    }
};
const Summary = ()=>{
    const { billing } = (0, _reactRedux.useSelector)(({ billingReducer })=>({
            billing: billingReducer.billing
        }), (0, _reactRedux.shallowEqual));
    if (!billing) return null;
    const periods = billing.periods.slice();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        sx: styles.container,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
            component: (0, _paperDefault.default),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                id: "billingperiods",
                "aria-label": "collapsible table",
                size: "medium",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                    children: "from"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                    children: "to"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                    align: "right",
                                    children: "ingress stream credits"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                    align: "right",
                                    children: "egress stream credits"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                    align: "right",
                                    children: "total stream credits consumed"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableBodyDefault.default), {
                        children: [
                            periods.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Row, {
                                    row: row
                                }, row.startDate.toISOString())),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                        align: "right",
                                        colSpan: 3,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: 'h4',
                                            children: "Total"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: 'h4',
                                            children: billing.summary.ingressCredits
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: 'h4',
                                            children: billing.summary.egressCredits
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: 'h4',
                                            children: billing.summary.totalCredits
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const Row = (props)=>{
    const [open, setOpen] = (0, _react.useState)(false);
    const { row } = props;
    const { ingressCredits, egressCredits } = row;
    const creditsConsumed = ingressCredits > 0 || egressCredits > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                hover: true,
                sx: rowStyles.root,
                onClick: ()=>setOpen(!open),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            "aria-label": "expand row",
                            size: "small",
                            "data-test-id": 'expand-btn',
                            children: open ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowDownDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowRightDefault.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        component: "th",
                        scope: "row",
                        children: (0, _helpers.dateToYearMonthDayString)(row.startDate)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        component: "th",
                        scope: "row",
                        children: (0, _helpers.dateToYearMonthDayMaxNowString)(row.endDate)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "right",
                        children: row.ingressCredits
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "right",
                        children: row.egressCredits
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "right",
                        children: row.totalCredits
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    style: {
                        paddingBottom: 0,
                        paddingTop: 0
                    },
                    colSpan: 6,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
                        in: open,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                            pending: false,
                            children: !creditsConsumed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                margin: 1,
                                marginBottom: 4,
                                "data-test-id": 'detailed-report-data',
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    variant: "h6",
                                    component: "div",
                                    children: "Detailed billing report for the period is not available"
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    margin: 1,
                                    marginBottom: 4,
                                    "data-test-id": 'detailed-report-data',
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "h6",
                                            gutterBottom: true,
                                            component: "div",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                    columnGap: '8px'
                                                },
                                                children: [
                                                    "Credit Usage",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                        sx: styles.maxConcurrencyDate,
                                                        children: formatDateTime(row.maxConcurrencyDate)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                        title: 'Point in time when the max number of concurrent streams were sampled during the selected period',
                                                        placement: "top",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {})
                                                    })
                                                ]
                                            })
                                        }),
                                        !creditsConsumed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            sx: styles.noCreditsConsumed,
                                            children: "No credits consumed during this period"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(StreamCreditUsageTable, {
                                            data: row.details
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
const StreamCreditUsageTable = (props)=>{
    const { data } = props;
    const rows = data.slice() // sort((a, b) => a.streamId.localeCompare(b.streamId))
    ;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
        size: "small",
        "aria-label": "purchases",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            children: "type"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            children: "name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            children: "programs"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            children: "id"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            align: "right",
                            children: "credits"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                children: rows.map((row, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StreamCreditUsageRow, {
                        row: row
                    }, i))
            })
        ]
    });
};
function isEgressBillingDetail(d) {
    return 'outputId' in d;
}
const StreamCreditUsageRow = (props)=>{
    const { row } = props;
    const isEgress = isEgressBillingDetail(row);
    const id = isEgress ? row.outputId : row.inputId;
    const redundant = isEgress && row.outputRedundancy || !isEgress && row.inputRedundancy;
    const merge = !isEgress && row.inputMerge;
    const protection = isEgress && row.outputPortCount > 1 || !isEgress && row.inputPortCount > 1 && !merge;
    const numServices = row.inputServiceCount || 1;
    // const mpts = numServices > 1
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
        hover: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                    container: true,
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                label: isEgress ? 'egress' : 'ingress',
                                size: "small"
                            })
                        }),
                        redundant && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                label: 'redundant',
                                size: "small"
                            })
                        }),
                        merge && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                label: 'merge',
                                size: "small"
                            })
                        }),
                        protection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                label: 'protected',
                                size: "small"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                scope: "row",
                children: isEgress ? row.outputName : row.inputName
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                scope: "row",
                children: numServices
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                title: id,
                sx: styles.idData,
                children: id
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                align: "right",
                children: [
                    row.credits,
                    " "
                ]
            })
        ]
    });
};
function formatDateTime(d) {
    return d.toISOString().substring(0, 16).replace('T', ' ');
}
exports.default = Summary;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Chip":"5cK8z","@mui/material/Paper":"aexCI","@mui/material/Box":"c4QkF","@mui/material/Collapse":"c7nwP","@mui/material/Grid":"6iX4B","@mui/material/IconButton":"488As","@mui/material/Table":"k4r1H","@mui/material/TableBody":"2jHBQ","@mui/material/TableCell":"6WlPV","@mui/material/TableContainer":"fJfiU","@mui/material/TableHead":"9yKSO","@mui/material/TableRow":"bLA0R","@mui/material/Typography":"6NtGx","@mui/material/Tooltip":"2soEB","@mui/icons-material/KeyboardArrowDown":"2TA6B","@mui/icons-material/KeyboardArrowRight":"d6UJH","@mui/icons-material/Info":"juq3i","../../common/Pendable":"gDN67","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gE26Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Graphs", ()=>Graphs);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _notFound = require("../common/NotFound");
var _graph = require("./Graph");
const Graphs = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graph), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../common/NotFound":"1Msr5","./Graph":"iOzn1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iOzn1":[function(require,module,exports,__globalThis) {
/* eslint no-param-reassign: 'off' */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphType", ()=>GraphType);
parcelHelpers.export(exports, "Graph", ()=>Graph);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _d3Drag = require("d3-drag");
var _d3Force = require("d3-force");
var _d3Selection = require("d3-selection");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _utils = require("../../../utils");
var _reactRedux = require("react-redux");
var _parse = require("./parse");
var _graphActions = require("../../../redux/actions/graphActions");
const width = 1600;
const height = 1200;
let simulation;
let svg;
const dragStarted = (event, d)=>{
    if (!event.active) simulation.alphaTarget(0.3).restart();
    d.fx = Math.max(10, Math.min(width - 10, event.subject.x));
    d.fy = Math.max(10, Math.min(height - 10, event.subject.y));
    d.fixed = true;
};
const onDrag = (event, d)=>{
    d.fx = Math.max(10, Math.min(width - 10, event.x));
    d.fy = Math.max(10, Math.min(height - 10, event.y));
};
const dragEnded = (event)=>{
    if (!event.active) simulation.alphaTarget(0);
};
const doubleClick = (_event, d)=>{
    d.fixed = false;
    d.fx = null;
    d.fy = null;
};
var GraphType = /*#__PURE__*/ function(GraphType) {
    GraphType["All"] = "all";
    GraphType["Config"] = "config";
    GraphType["Tunnels"] = "tunnels";
    return GraphType;
}({});
const onDataLoad = (graphInput, inputs, outputs, selectedChannelId, selectedOutputId, graphType)=>{
    const graph = (0, _parse.createGraphNodesAndLinks)(graphInput, inputs, outputs, selectedChannelId, selectedOutputId, graphType);
    simulation.nodes(graph.nodes).on('tick', ticked);
    simulation.force('link')?.links(graph.links);
    svg.append('svg').selectAll('marker').data([
        'end'
    ]) // Different link/path types can be defined here
    .enter().append('svg:marker') // This section adds in the arrows
    .attr('id', String).attr('viewBox', '0 -5 10 10').attr('refX', 20).attr('markerUnits', 'userSpaceOnUse')// .attr("refY", -10)
    .attr('markerWidth', 20).attr('markerHeight', 20).attr('orient', 'auto').append('svg:path').attr('d', 'M0,-5L10,0L0,5');
    const link = svg.append('g').selectAll('line').data(graph.links).enter().append('line').attr('class', 'link').attr('marker-end', 'url(#end)').style('stroke', '#aaa');
    const node = svg.append('g').attr('class', 'nodes').selectAll('circle').data(graph.nodes).enter().append('circle').attr('r', 6).call(_d3Drag.drag().on('start', dragStarted).on('drag', onDrag).on('end', dragEnded));
    const label = svg.append('g').attr('class', 'labels').selectAll('text').data(graph.nodes).enter().append('text').attr('class', 'label').text(function(d) {
        let name = d.name;
        if (d.inputName) name += `: ${d.inputName}`;
        if (d.outputName) name += `\u{2192}${d.outputName}`;
        return name;
    }).attr('text-anchor', 'middle').attr('font-weight', (d)=>d.fontWeight || 'normal');
    const metadata = svg.append('g').attr('class', 'labels').selectAll('text').data(graph.nodes).enter().append('text').attr('class', 'label').attr('text-anchor', 'middle').style('visibility', 'hidden');
    metadata.selectAll('tspan').data((d)=>{
        return d && d.metadataText ? d.metadataText.split('\n') : [];
    }).enter().append('tspan').text((d)=>d).attr('dy', -22);
    function ticked() {
        const margin = 50;
        graph.nodes.forEach(function(d) {
            d.x = Math.max(margin, Math.min(width - margin, d.x || 0));
            d.y = Math.max(margin, Math.min(height - margin, d.y || 0));
        });
        link.attr('x1', function(d) {
            return d.source.x;
        }).attr('y1', function(d) {
            return d.source.y;
        }).attr('x2', function(d) {
            return d.target.x;
        }).attr('y2', function(d) {
            return d.target.y;
        }).attr('marker-end', function(d) {
            if (d.hide) return 'url()';
            return 'url(#end)';
        }).style('stroke', function(d) {
            if (d.hide) return '#fff';
            return '#aaa';
        }).attr('stroke-width', (d)=>{
            return d.width;
        });
        node.attr('r', 20).style('fill', (d)=>{
            if (d?.metadata?.type === 'va') return '#fcdfff';
            return '#d3d3d3';
        }).style('stroke', (d)=>d.fixed ? '#000000' : '#969696').style('stroke-width', (d)=>d.fixed ? '2px' : '1px').attr('cx', function(d) {
            return d.x || 0;
        }).attr('cy', function(d) {
            return d.y || 0;
        }).style('opacity', function(d) {
            if (!d.metadata) return 0;
            return 1;
        }).on('dblclick', doubleClick);
        label.attr('x', function(d) {
            return d.x || 0;
        }).attr('y', function(d) {
            return d.y || 0;
        }).style('font-size', '20px').style('fill', (d)=>{
            if (!d.metadata) return '#000';
            if (d.name === 'udp-input') return '#008000';
            else if (d.name === 'udp-output') return '#006400';
            else if (d.name && d.name.includes('tr101')) return '#6495ED';
            return '#4393c3';
        }).on('click', function(node) {
            metadata.filter(function(_d, i) {
                return i === node.index;
            }).style('visibility', (d)=>{
                if (d.hidden || d.hidden === undefined) {
                    d.hidden = false;
                    return 'visible';
                } else {
                    d.hidden = true;
                    return 'hidden';
                }
            });
        });
        metadata.attr('x', function(d) {
            return d.x || 0;
        }).attr('y', function(d) {
            return d.y || 0;
        }).style('font-size', '20px').style('fill', ()=>{
            return '#000';
        }).selectAll('tspan').attr('x', function() {
            return _d3Selection.select(this.parentNode).attr('x');
        });
    }
};
const setupGraph = (svgRef)=>{
    svg = _d3Selection.select(svgRef);
    svg.selectAll('*').remove();
    svg.append('rect').attr('width', '100%').attr('height', '100%').attr('fill', 'white');
    simulation = _d3Force.forceSimulation().force('link', _d3Force.forceLink().id((d)=>d.id).distance((d)=>d.distance)).force('charge', _d3Force.forceManyBody().strength(-300)).force('center', _d3Force.forceCenter(width / 2, height / 2));
};
const Graph = ()=>{
    const [state, setState] = (0, _react.useState)({
        selectedChannelId: -1,
        selectedOutputId: '-1',
        graphType: "config"
    });
    const ref = (0, _react.useRef)(null);
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _graphActions.readGraph)());
    }, [
        dispatch
    ]);
    const { inputs } = (0, _utils.useInputsSelector)({
        pageNumber: '0',
        rowsPerPage: '1000'
    });
    const { outputs } = (0, _utils.useOutputsSelector)({
        pageNumber: '0',
        rowsPerPage: '1000'
    });
    const graph = (0, _reactRedux.useSelector)(({ graphReducer })=>graphReducer.graph, (0, _reactRedux.shallowEqual));
    (0, _react.useEffect)(()=>{
        setupGraph(ref.current);
        if (simulation && graph && inputs.length) onDataLoad(graph, inputs, outputs, state.selectedChannelId, state.selectedOutputId, state.graphType);
    }, [
        graph,
        inputs.map((i)=>i.id).join(','),
        state
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Debug overview",
        children: [
            inputs && inputs.length && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                style: {
                    marginRight: 10
                },
                children: [
                    "Input:",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                        value: state.selectedChannelId,
                        onChange: (change)=>{
                            setState({
                                selectedChannelId: parseInt(change.target.value),
                                selectedOutputId: '-1',
                                graphType: state.graphType
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: -1,
                                children: "All"
                            }, "all"),
                            inputs.map((input)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: input.channelId,
                                    children: input.name
                                }, input.id))
                        ]
                    })
                ]
            }),
            outputs && outputs.length && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                style: {
                    marginRight: 10
                },
                children: [
                    "Output:",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                        value: state.selectedOutputId,
                        onChange: (change)=>{
                            setState({
                                selectedChannelId: change.target.value === '-1' ? state.selectedChannelId : inputs.find((input)=>input.id === outputs.find((output)=>output.id === change.target.value)?.input)?.channelId || -1,
                                selectedOutputId: change.target.value,
                                graphType: state.graphType
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: -1,
                                children: "All"
                            }, "all"),
                            outputs.map((output)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: output.id,
                                    children: output.name
                                }, output.id))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                style: {
                    marginRight: 10
                },
                children: [
                    "Type:",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        value: state.graphType,
                        onChange: (change)=>{
                            setState({
                                selectedChannelId: state.selectedChannelId,
                                selectedOutputId: state.selectedOutputId,
                                graphType: change.target.value
                            });
                        },
                        children: Object.entries(GraphType).map(([key, value])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: value,
                                children: key
                            }, key))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                ref: ref,
                style: {
                    height,
                    width
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","d3-drag":"HHNYu","d3-force":"67Mne","d3-selection":"9PvvP","../../common/Wrapper":"8oy7r","../../../utils":"342UB","react-redux":"l1pMU","./parse":"LHKUc","../../../redux/actions/graphActions":"kJItV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"HHNYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>(0, _dragJsDefault.default));
parcelHelpers.export(exports, "dragDisable", ()=>(0, _nodragJsDefault.default));
parcelHelpers.export(exports, "dragEnable", ()=>(0, _nodragJs.yesdrag));
var _dragJs = require("./drag.js");
var _dragJsDefault = parcelHelpers.interopDefault(_dragJs);
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);

},{"./drag.js":"6a3PW","./nodrag.js":"kOGkY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6a3PW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable, gestures = {}, listeners = (0, _d3Dispatch.dispatch)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, _noeventJs.nonpassive)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            (0, _d3Selection.select)(event.view).on("mousemove.drag", mousemoved, (0, _noeventJs.nonpassivecapture)).on("mouseup.drag", mouseupped, (0, _noeventJs.nonpassivecapture));
            (0, _nodragJsDefault.default)(event.view);
            (0, _noeventJs.nopropagation)(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            (0, _noeventJsDefault.default)(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            (0, _d3Selection.select)(event.view).on("mousemove.drag mouseup.drag", null);
            (0, _nodragJs.yesdrag)(event.view, mousemoving);
            (0, _noeventJsDefault.default)(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                (0, _noeventJs.nopropagation)(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJsDefault.default)(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJs.nopropagation)(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = (0, _d3Selection.pointer)(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new (0, _eventJsDefault.default)("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier,
                active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // falls through
                    case "drag":
                        p = (0, _d3Selection.pointer)(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Selection = require("d3-selection");
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultContainer() {
    return this.parentNode;
}
function defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}

},{"d3-dispatch":"2VwUr","d3-selection":"9PvvP","./nodrag.js":"kOGkY","./noevent.js":"8rhnL","./constant.js":"gczea","./event.js":"6OX4n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2VwUr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatchJsDefault.default));
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);

},{"./dispatch.js":"cWgMh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWgMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: ()=>{}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PvvP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>(0, _createJsDefault.default));
parcelHelpers.export(exports, "creator", ()=>(0, _creatorJsDefault.default));
parcelHelpers.export(exports, "local", ()=>(0, _localJsDefault.default));
parcelHelpers.export(exports, "matcher", ()=>(0, _matcherJsDefault.default));
parcelHelpers.export(exports, "namespace", ()=>(0, _namespaceJsDefault.default));
parcelHelpers.export(exports, "namespaces", ()=>(0, _namespacesJsDefault.default));
parcelHelpers.export(exports, "pointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "pointers", ()=>(0, _pointersJsDefault.default));
parcelHelpers.export(exports, "select", ()=>(0, _selectJsDefault.default));
parcelHelpers.export(exports, "selectAll", ()=>(0, _selectAllJsDefault.default));
parcelHelpers.export(exports, "selection", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "selector", ()=>(0, _selectorJsDefault.default));
parcelHelpers.export(exports, "selectorAll", ()=>(0, _selectorAllJsDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _styleJs.styleValue));
parcelHelpers.export(exports, "window", ()=>(0, _windowJsDefault.default));
var _createJs = require("./create.js");
var _createJsDefault = parcelHelpers.interopDefault(_createJs);
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _localJs = require("./local.js");
var _localJsDefault = parcelHelpers.interopDefault(_localJs);
var _matcherJs = require("./matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _pointersJs = require("./pointers.js");
var _pointersJsDefault = parcelHelpers.interopDefault(_pointersJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _indexJs = require("./selection/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _selectorJs = require("./selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
var _selectorAllJs = require("./selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
var _styleJs = require("./selection/style.js");
var _windowJs = require("./window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);

},{"./create.js":"aThp7","./creator.js":"9J1Uc","./local.js":"8V0zV","./matcher.js":"3cbxf","./namespace.js":"890X9","./namespaces.js":"1Q4PJ","./pointer.js":"3xcdW","./pointers.js":"crSlp","./select.js":"2Rc7o","./selectAll.js":"1EslL","./selection/index.js":"a5jDB","./selector.js":"hZ4f6","./selectorAll.js":"9WsMK","./selection/style.js":"4vnVK","./window.js":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aThp7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return (0, _selectJsDefault.default)((0, _creatorJsDefault.default)(name).call(document.documentElement));
    });
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);

},{"./creator.js":"9J1Uc","./select.js":"2Rc7o","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9J1Uc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    });
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
function creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, _namespacesJs.xhtml) && document.documentElement.namespaceURI === (0, _namespacesJs.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}

},{"./namespace.js":"890X9","./namespaces.js":"1Q4PJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"890X9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return (0, _namespacesJsDefault.default).hasOwnProperty(prefix) ? {
            space: (0, _namespacesJsDefault.default)[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    });
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);

},{"./namespaces.js":"1Q4PJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Q4PJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhtml", ()=>xhtml);
var xhtml = "http://www.w3.org/1999/xhtml";
exports.default = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: xhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Rc7o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            [
                selector
            ]
        ], (0, _indexJs.root));
    });
var _indexJs = require("./selection/index.js");

},{"./selection/index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a5jDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "root", ()=>root);
parcelHelpers.export(exports, "Selection", ()=>Selection);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectChildJs = require("./selectChild.js");
var _selectChildJsDefault = parcelHelpers.interopDefault(_selectChildJs);
var _selectChildrenJs = require("./selectChildren.js");
var _selectChildrenJsDefault = parcelHelpers.interopDefault(_selectChildrenJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _enterJs = require("./enter.js");
var _enterJsDefault = parcelHelpers.interopDefault(_enterJs);
var _exitJs = require("./exit.js");
var _exitJsDefault = parcelHelpers.interopDefault(_exitJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _orderJs = require("./order.js");
var _orderJsDefault = parcelHelpers.interopDefault(_orderJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _nodesJs = require("./nodes.js");
var _nodesJsDefault = parcelHelpers.interopDefault(_nodesJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
var _classedJs = require("./classed.js");
var _classedJsDefault = parcelHelpers.interopDefault(_classedJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _htmlJs = require("./html.js");
var _htmlJsDefault = parcelHelpers.interopDefault(_htmlJs);
var _raiseJs = require("./raise.js");
var _raiseJsDefault = parcelHelpers.interopDefault(_raiseJs);
var _lowerJs = require("./lower.js");
var _lowerJsDefault = parcelHelpers.interopDefault(_lowerJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _datumJs = require("./datum.js");
var _datumJsDefault = parcelHelpers.interopDefault(_datumJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
var root = [
    null
];
function Selection(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function selection() {
    return new Selection([
        [
            document.documentElement
        ]
    ], root);
}
function selection_selection() {
    return this;
}
Selection.prototype = selection.prototype = {
    constructor: Selection,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: (0, _selectChildJsDefault.default),
    selectChildren: (0, _selectChildrenJsDefault.default),
    filter: (0, _filterJsDefault.default),
    data: (0, _dataJsDefault.default),
    enter: (0, _enterJsDefault.default),
    exit: (0, _exitJsDefault.default),
    join: (0, _joinJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: selection_selection,
    order: (0, _orderJsDefault.default),
    sort: (0, _sortJsDefault.default),
    call: (0, _callJsDefault.default),
    nodes: (0, _nodesJsDefault.default),
    node: (0, _nodeJsDefault.default),
    size: (0, _sizeJsDefault.default),
    empty: (0, _emptyJsDefault.default),
    each: (0, _eachJsDefault.default),
    attr: (0, _attrJsDefault.default),
    style: (0, _styleJsDefault.default),
    property: (0, _propertyJsDefault.default),
    classed: (0, _classedJsDefault.default),
    text: (0, _textJsDefault.default),
    html: (0, _htmlJsDefault.default),
    raise: (0, _raiseJsDefault.default),
    lower: (0, _lowerJsDefault.default),
    append: (0, _appendJsDefault.default),
    insert: (0, _insertJsDefault.default),
    remove: (0, _removeJsDefault.default),
    clone: (0, _cloneJsDefault.default),
    datum: (0, _datumJsDefault.default),
    on: (0, _onJsDefault.default),
    dispatch: (0, _dispatchJsDefault.default),
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};
exports.default = selection;

},{"./select.js":"4cEkx","./selectAll.js":"kCglL","./selectChild.js":"M1ElV","./selectChildren.js":"6txEr","./filter.js":"eNhDs","./data.js":"9DDr4","./enter.js":"gP2QE","./exit.js":"jH42X","./join.js":"1AmkZ","./merge.js":"4XmUG","./order.js":"hgq2c","./sort.js":"jZWGX","./call.js":"lf3EW","./nodes.js":"j05Td","./node.js":"8ksut","./size.js":"cMqWP","./empty.js":"jngRU","./each.js":"3Fax0","./attr.js":"4sWgc","./style.js":"4vnVK","./property.js":"gUsSc","./classed.js":"7umaZ","./text.js":"8vz6Q","./html.js":"fkrCd","./raise.js":"i9fD3","./lower.js":"cy1Ek","./append.js":"dA1zq","./insert.js":"kmSFy","./remove.js":"bjetH","./clone.js":"3ll3H","./datum.js":"i9Aev","./on.js":"Lh6iE","./dispatch.js":"4tSUD","./iterator.js":"8wNwM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4cEkx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select !== "function") select = (0, _selectorJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);

},{"./index.js":"a5jDB","../selector.js":"hZ4f6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZ4f6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? none : function() {
            return this.querySelector(selector);
        };
    });
function none() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCglL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = (0, _selectorAllJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new (0, _indexJs.Selection)(subgroups, parents);
    });
var _indexJs = require("./index.js");
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _selectorAllJs = require("../selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
function arrayAll(select) {
    return function() {
        return (0, _arrayJsDefault.default)(select.apply(this, arguments));
    };
}

},{"./index.js":"a5jDB","../array.js":"jeIHr","../selectorAll.js":"9WsMK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jeIHr":[function(require,module,exports,__globalThis) {
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>array);
function array(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9WsMK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? empty : function() {
            return this.querySelectorAll(selector);
        };
    });
function empty() {
    return [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"M1ElV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var find = Array.prototype.find;
function childFind(match) {
    return function() {
        return find.call(this.children, match);
    };
}
function childFirst() {
    return this.firstElementChild;
}

},{"../matcher.js":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cbxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return function() {
            return this.matches(selector);
        };
    });
parcelHelpers.export(exports, "childMatcher", ()=>childMatcher);
function childMatcher(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6txEr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var filter = Array.prototype.filter;
function children() {
    return Array.from(this.children);
}
function childrenFilter(match) {
    return function() {
        return filter.call(this.children, match);
    };
}

},{"../matcher.js":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNhDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _matcherJsDefault.default)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _matcherJs = require("../matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);

},{"./index.js":"a5jDB","../matcher.js":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DDr4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = (0, _constantJsDefault.default)(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new (0, _indexJs.Selection)(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    });
var _indexJs = require("./index.js");
var _enterJs = require("./enter.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function datum(node) {
    return node.__data__;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

},{"./index.js":"a5jDB","./enter.js":"gP2QE","../constant.js":"c7sKD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gP2QE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._enter || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
parcelHelpers.export(exports, "EnterNode", ()=>EnterNode);
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");
function EnterNode(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
EnterNode.prototype = {
    constructor: EnterNode,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

},{"./sparse.js":"4Dzlv","./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Dzlv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(update) {
        return new Array(update.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7sKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jH42X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._exit || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");

},{"./sparse.js":"4Dzlv","./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1AmkZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        if (typeof onenter === "function") {
            enter = onenter(enter);
            if (enter) enter = enter.selection();
        } else enter = enter.append(onenter + "");
        if (onupdate != null) {
            update = onupdate(update);
            if (update) update = update.selection();
        }
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XmUG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        var selection = context.selection ? context.selection() : context;
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Selection)(merges, this._parents);
    });
var _indexJs = require("./index.js");

},{"./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgq2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jZWGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (!compare) compare = ascending;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new (0, _indexJs.Selection)(sortgroups, this._parents).order();
    });
var _indexJs = require("./index.js");
function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lf3EW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j05Td":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ksut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMqWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jngRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return !this.node();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Fax0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4sWgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
    });
var _namespaceJs = require("../namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}

},{"../namespace.js":"890X9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vnVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    });
parcelHelpers.export(exports, "styleValue", ()=>styleValue);
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function styleValue(node, name) {
    return node.style.getPropertyValue(name) || (0, _windowJsDefault.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

},{"../window.js":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aXAiN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUsSc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    });
function propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7umaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    });
function classArray(string) {
    return string.trim().split(/^|\s+/);
}
function classList(node) {
    return node.classList || new ClassList(node);
}
function ClassList(node) {
    this._node = node;
    this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function classedAdd(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function classedRemove(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function classedTrue(names) {
    return function() {
        classedAdd(this, names);
    };
}
function classedFalse(names) {
    return function() {
        classedRemove(this, names);
    };
}
function classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8vz6Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
    });
function textRemove() {
    this.textContent = "";
}
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fkrCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    });
function htmlRemove() {
    this.innerHTML = "";
}
function htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9fD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(raise);
    });
function raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cy1Ek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(lower);
    });
function lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dA1zq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);

},{"../creator.js":"9J1Uc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kmSFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, before) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name), select = before == null ? constantNull : typeof before === "function" ? before : (0, _selectorJsDefault.default)(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
function constantNull() {
    return null;
}

},{"../creator.js":"9J1Uc","../selector.js":"hZ4f6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bjetH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(remove);
    });
function remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ll3H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    });
function selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9Aev":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Lh6iE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    });
function contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4tSUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    });
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function dispatchEvent(node, type, params) {
    var window = (0, _windowJsDefault.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function dispatchConstant(type, params) {
    return function() {
        return dispatchEvent(this, type, params);
    };
}
function dispatchFunction(type, params) {
    return function() {
        return dispatchEvent(this, type, params.apply(this, arguments));
    };
}

},{"../window.js":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8wNwM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V0zV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>local);
var nextId = 0;
function local() {
    return new Local;
}
function Local() {
    this._ = "@" + (++nextId).toString(36);
}
Local.prototype = local.prototype = {
    constructor: Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xcdW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event, node) {
        event = (0, _sourceEventJsDefault.default)(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    });
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./sourceEvent.js":"fQtlW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fQtlW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"crSlp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(events, node) {
        if (events.target) {
            events = (0, _sourceEventJsDefault.default)(events);
            if (node === undefined) node = events.currentTarget;
            events = events.touches || [
                events
            ];
        }
        return Array.from(events, (event)=>(0, _pointerJsDefault.default)(event, node));
    });
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./pointer.js":"3xcdW","./sourceEvent.js":"fQtlW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1EslL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            document.querySelectorAll(selector)
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            (0, _arrayJsDefault.default)(selector)
        ], (0, _indexJs.root));
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _indexJs = require("./selection/index.js");

},{"./array.js":"jeIHr","./selection/index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOGkY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(view) {
        var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        if ("onselectstart" in root) selection.on("selectstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    });
parcelHelpers.export(exports, "yesdrag", ()=>yesdrag);
var _d3Selection = require("d3-selection");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
function yesdrag(view, noclick) {
    var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

},{"d3-selection":"9PvvP","./noevent.js":"8rhnL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8rhnL":[function(require,module,exports,__globalThis) {
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonpassive", ()=>nonpassive);
parcelHelpers.export(exports, "nonpassivecapture", ()=>nonpassivecapture);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
const nonpassive = {
    passive: false
};
const nonpassivecapture = {
    capture: true,
    passive: false
};
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gczea":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6OX4n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragEvent);
function DragEvent(type, { sourceEvent, subject, target, identifier, active, x, y, dx, dy, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
DragEvent.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67Mne":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceCenter", ()=>(0, _centerJsDefault.default));
parcelHelpers.export(exports, "forceCollide", ()=>(0, _collideJsDefault.default));
parcelHelpers.export(exports, "forceLink", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "forceManyBody", ()=>(0, _manyBodyJsDefault.default));
parcelHelpers.export(exports, "forceRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "forceSimulation", ()=>(0, _simulationJsDefault.default));
parcelHelpers.export(exports, "forceX", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "forceY", ()=>(0, _yJsDefault.default));
var _centerJs = require("./center.js");
var _centerJsDefault = parcelHelpers.interopDefault(_centerJs);
var _collideJs = require("./collide.js");
var _collideJsDefault = parcelHelpers.interopDefault(_collideJs);
var _linkJs = require("./link.js");
var _linkJsDefault = parcelHelpers.interopDefault(_linkJs);
var _manyBodyJs = require("./manyBody.js");
var _manyBodyJsDefault = parcelHelpers.interopDefault(_manyBodyJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _simulationJs = require("./simulation.js");
var _simulationJsDefault = parcelHelpers.interopDefault(_simulationJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);

},{"./center.js":"d1ShK","./collide.js":"4XlLY","./link.js":"5c9TZ","./manyBody.js":"gAD1B","./radial.js":"21kIj","./simulation.js":"3RfPP","./x.js":"kRsbd","./y.js":"d6AXc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d1ShK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var nodes, strength = 1;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        return force;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XlLY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var nodes, radii, random, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = (0, _d3Quadtree.quadtree)(nodes, x, y).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                            if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function x(d) {
    return d.x + d.vx;
}
function y(d) {
    return d.y + d.vy;
}

},{"d3-quadtree":"5yYuF","./constant.js":"2kwg2","./jiggle.js":"axE08","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5yYuF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadtree", ()=>(0, _quadtreeJsDefault.default));
var _quadtreeJs = require("./quadtree.js");
var _quadtreeJsDefault = parcelHelpers.interopDefault(_quadtreeJs);

},{"./quadtree.js":"6vDgM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6vDgM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quadtree);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _coverJs = require("./cover.js");
var _coverJsDefault = parcelHelpers.interopDefault(_coverJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _rootJs = require("./root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _visitJs = require("./visit.js");
var _visitJsDefault = parcelHelpers.interopDefault(_visitJs);
var _visitAfterJs = require("./visitAfter.js");
var _visitAfterJsDefault = parcelHelpers.interopDefault(_visitAfterJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);
function quadtree(nodes, x, y) {
    var tree = new Quadtree(x == null ? (0, _xJs.defaultX) : x, y == null ? (0, _yJs.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = leaf_copy(child);
        }
    }
    return copy;
};
treeProto.add = (0, _addJsDefault.default);
treeProto.addAll = (0, _addJs.addAll);
treeProto.cover = (0, _coverJsDefault.default);
treeProto.data = (0, _dataJsDefault.default);
treeProto.extent = (0, _extentJsDefault.default);
treeProto.find = (0, _findJsDefault.default);
treeProto.remove = (0, _removeJsDefault.default);
treeProto.removeAll = (0, _removeJs.removeAll);
treeProto.root = (0, _rootJsDefault.default);
treeProto.size = (0, _sizeJsDefault.default);
treeProto.visit = (0, _visitJsDefault.default);
treeProto.visitAfter = (0, _visitAfterJsDefault.default);
treeProto.x = (0, _xJsDefault.default);
treeProto.y = (0, _yJsDefault.default);

},{"./add.js":"7LC4G","./cover.js":"5es8I","./data.js":"8I0lM","./extent.js":"aU9hE","./find.js":"jpx7G","./remove.js":"3QFtD","./root.js":"khDrv","./size.js":"cQzYu","./visit.js":"8xbxh","./visitAfter.js":"ihORj","./x.js":"iDUW5","./y.js":"iLKgW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LC4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        const x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    });
parcelHelpers.export(exports, "addAll", ()=>addAll);
function add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function addAll(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5es8I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0 || 1, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8I0lM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aU9hE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jpx7G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new (0, _quadJsDefault.default)(node[3], xm, ym, x2, y2), new (0, _quadJsDefault.default)(node[2], x1, ym, xm, y2), new (0, _quadJsDefault.default)(node[1], xm, y1, x2, ym), new (0, _quadJsDefault.default)(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"2MGsj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2MGsj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QFtD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    });
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
function removeAll(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"khDrv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this._root;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cQzYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8xbxh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
        }
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"2MGsj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ihORj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new (0, _quadJsDefault.default)(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"2MGsj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iDUW5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultX", ()=>defaultX);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    });
function defaultX(d) {
    return d[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iLKgW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultY", ()=>defaultY);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    });
function defaultY(d) {
    return d[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2kwg2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axE08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(random) {
        return (random() - 0.5) * 1e-6;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5c9TZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(links) {
        var id = index, strength = defaultStrength, strengths, distance = (0, _constantJsDefault.default)(30), distances, nodes, count, bias, random, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || (0, _jiggleJsDefault.default)(random);
                y = target.y + target.vy - source.y - source.vy || (0, _jiggleJsDefault.default)(random);
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                    id(d, i, nodes),
                    d
                ])), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeDistance(), force) : distance;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function index(d) {
    return d.index;
}
function find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}

},{"./constant.js":"2kwg2","./jiggle.js":"axE08","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gAD1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes, node, random, alpha, strength = (0, _constantJsDefault.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = (0, _d3Quadtree.quadtree)(nodes, (0, _simulationJs.x), (0, _simulationJs.y)).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                    if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
var _simulationJs = require("./simulation.js");

},{"d3-quadtree":"5yYuF","./constant.js":"2kwg2","./jiggle.js":"axE08","./simulation.js":"3RfPP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3RfPP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
parcelHelpers.export(exports, "default", ()=>function(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, _d3Timer.timer)(step), event = (0, _d3Dispatch.dispatch)("tick", "end"), random = (0, _lcgJsDefault.default)();
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.forEach(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes, random);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            randomSource: function(_) {
                return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var _lcgJs = require("./lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function x(d) {
    return d.x;
}
function y(d) {
    return d.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));

},{"d3-dispatch":"2VwUr","d3-timer":"lpgSt","./lcg.js":"1I11x","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lpgSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>(0, _timerJs.now));
parcelHelpers.export(exports, "timer", ()=>(0, _timerJs.timer));
parcelHelpers.export(exports, "timerFlush", ()=>(0, _timerJs.timerFlush));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeoutJsDefault.default));
parcelHelpers.export(exports, "interval", ()=>(0, _intervalJsDefault.default));
var _timerJs = require("./timer.js");
var _timeoutJs = require("./timeout.js");
var _timeoutJsDefault = parcelHelpers.interopDefault(_timeoutJs);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);

},{"./timer.js":"atLFA","./timeout.js":false,"./interval.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"atLFA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1I11x":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21kIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius, x, y) {
        var nodes, strength = (0, _constantJsDefault.default)(0.1), strengths, radiuses;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(+radius);
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force(alpha) {
            for(var i = 0, n = nodes.length; i < n; ++i){
                var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
                node.vx += dx * k;
                node.vy += dy * k;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            radiuses = new Array(n);
            for(i = 0; i < n; ++i){
                radiuses[i] = +radius(nodes[i], i, nodes);
                strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
            }
        }
        force.initialize = function(_) {
            nodes = _, initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2kwg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kRsbd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = (0, _constantJsDefault.default)(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : x;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2kwg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6AXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(y) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = (0, _constantJsDefault.default)(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2kwg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LHKUc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGraphNodesAndLinks", ()=>createGraphNodesAndLinks);
var _types = require("common/api/v1/types");
var _helpers = require("common/api/v1/helpers");
var _index = require("./index");
const createGraphNodesAndLinks = (input, inputs, outputs, channelId, selectedOutputId, graphType)=>{
    let nodes = [];
    const links = [];
    const { appliances, streamIdToOutputMap } = input;
    Object.entries(appliances).forEach(([applianceName, config])=>{
        if (applianceHasObjectInChannel(config, channelId)) {
            if (graphType === (0, _index.GraphType).All || graphType === (0, _index.GraphType).Config) addApplianceNode(nodes, applianceName);
            if (graphType === (0, _index.GraphType).All || graphType === (0, _index.GraphType).Tunnels) addTunnelApplianceNode(applianceName, config, channelId, inputs, outputs, nodes);
        }
        if (graphType === (0, _index.GraphType).All || graphType === (0, _index.GraphType).Config) {
            if (includedInNodes(nodes, applianceName)) addConfigNodes(config, channelId, selectedOutputId, streamIdToOutputMap, applianceName, inputs, outputs, nodes);
        }
    });
    nodes = removeNodesWithoutRistConnections(nodes);
    if (graphType === (0, _index.GraphType).All || graphType === (0, _index.GraphType).Tunnels) Object.entries(appliances).map(([applianceName, config])=>{
        addTunnelApplianceLinks(nodes, applianceName, config, channelId, appliances, links);
    });
    if (graphType === (0, _index.GraphType).All || graphType === (0, _index.GraphType).Config) {
        addLinksForAllNodesWithTargetApplianceNames(nodes, links);
        Object.entries(appliances).map(([applianceName, config])=>{
            if (includedInNodes(nodes, applianceName)) config.inputs.forEach((input)=>{
                addLinksFromInputToOutputs(config, input, channelId, selectedOutputId, streamIdToOutputMap, nodes, links);
            });
        });
        addRistOutputToRistInputLinks(appliances, nodes, channelId, links);
    }
    // Handle vaInputs and vaOutput
    if (graphType === (0, _index.GraphType).All || graphType === (0, _index.GraphType).Config) addVaInputsAndOutputs(appliances, nodes, channelId, inputs, links, selectedOutputId, streamIdToOutputMap);
    // console.log(nodes)
    // console.log(links)
    return {
        nodes,
        links
    };
};
function addApplianceNode(nodes, nodeName) {
    nodes.push({
        id: nodeName,
        name: (nodeName || '').split('::').pop() || '',
        fontWeight: 'bold'
    });
}
function addTunnelApplianceNode(nodeName, config, channelId, inputs, outputs, nodes) {
    const node = {
        id: `${nodeName}_tunnel`,
        name: nodeName,
        metadata: {
            type: 'tunnel',
            tunnels: config.tunnels.filter((tunnel)=>channelId === -1 || [
                    ...config.inputs,
                    ...config.outputs
                ].some((obj)=>obj.channelId === channelId && (obj.type === 'push-rist-input' || obj.type === 'push-rist-output') && obj.tunnelId === tunnel.tunnelId)).sort((a, b)=>a.tunnelId <= b.tunnelId ? 1 : -1)
        },
        get metadataText () {
            return formatMetadataAsText(this.metadata, inputs, outputs);
        }
    };
    nodes.push(node);
}
function addConfigNodes(config, channelId, selectedOutputId, streamIdToOutputMap, applianceName, inputs, outputs, nodes) {
    const objects = [
        ...config.inputs,
        ...config.outputs
    ];
    objects.forEach((obj)=>{
        if (includedInChannel(channelId, obj) && isNotExcludedOutput(selectedOutputId, streamIdToOutputMap, obj)) {
            const node = {
                id: obj.streamId,
                name: `${obj.type}`,
                targetApplianceName: applianceName,
                inputName: ((obj.type === 'udp-input' || obj.type === 'udp-output') && inputs.find((input)=>input.channelId === obj.channelId) || {
                    name: ''
                }).name,
                outputName: streamIdToOutputMap[obj.streamId]?.outputName,
                metadata: obj,
                metadataText: formatMetadataAsText(obj, inputs, outputs)
            };
            nodes.push(node);
        }
    });
}
function removeNodesWithoutRistConnections(nodes) {
    return nodes.filter((outputNode)=>{
        return outputNode.metadata?.type !== 'push-rist-output' || nodes.some((inputNode)=>inputNode.metadata?.type === 'push-rist-input' && outputNode.metadata?.type === 'push-rist-output' && isRistInputAndOutputConnected(inputNode.metadata, outputNode.metadata, outputNode.metadata?.channelId, inputNode.id, outputNode.id));
    });
}
function addTunnelApplianceLinks(nodes, applianceName, config, channelId, appliances, links) {
    if (includedInNodes(nodes, `${applianceName}_tunnel`)) config.tunnels.forEach((tunnel)=>{
        if (tunnel.type === 'tunnel-client' && [
            ...config.inputs,
            ...config.outputs
        ].some((obj)=>obj.channelId === channelId && [
                'push-rist-input',
                'push-rist-output'
            ].includes(obj.type) && obj.tunnelId === tunnel.tunnelId || channelId === -1)) {
            const target = findTargetNodeOfTunnelClient(appliances, tunnel);
            if (target) links.push({
                source: `${applianceName}_tunnel`,
                target,
                distance: 200,
                width: 10,
                hide: false
            });
        }
    });
}
function addLinksForAllNodesWithTargetApplianceNames(nodes, links) {
    nodes.forEach((node)=>{
        if (node.targetApplianceName) links.push({
            source: node.id,
            target: node.targetApplianceName,
            distance: 60,
            width: 1,
            hide: true
        });
    });
}
function addLinksFromInputToOutputs(config, input, channelId, selectedOutputId, streamIdToOutputMap, nodes, links) {
    config.outputs.forEach((output)=>{
        if (input.channelId === output.channelId && includedInChannel(channelId, output) && isNotExcludedOutput(selectedOutputId, streamIdToOutputMap, output) && includedInNodes(nodes, input.streamId) && includedInNodes(nodes, output.streamId)) links.push({
            source: input.streamId,
            target: output.streamId,
            distance: 100,
            width: 1,
            hide: false
        });
    });
}
function addRistOutputToRistInputLinks(appliances, nodes, channelId, links) {
    Object.entries(appliances).map(([sourceApplianceName, sourceApplianceConfig])=>{
        if (includedInNodes(nodes, sourceApplianceName)) sourceApplianceConfig.outputs.forEach((output)=>{
            if (output.type === 'push-rist-output') Object.entries(appliances).map(([targetApplianceName, targetApplianceConfig])=>{
                if (includedInNodes(nodes, targetApplianceName)) targetApplianceConfig.inputs.forEach((input)=>{
                    if (isRistInputAndOutputConnected(input, output, channelId, sourceApplianceName, targetApplianceName)) links.push({
                        source: output.streamId,
                        target: input.streamId,
                        distance: 200,
                        width: 1,
                        hide: false
                    });
                });
            });
        });
    });
}
function addVaInputsAndOutputs(appliances, nodes, channelId, inputs, links, selectedOutputId, streamIdToOutputMap) {
    Object.entries(appliances).forEach(([applianceName, config])=>{
        if (includedInNodes(nodes, applianceName)) {
            if (config.vaInput?.length) addVaInputConfig(config, channelId, nodes, inputs, links);
            if (config.vaOutput?.length) addVaOutputConfig(config, channelId, selectedOutputId, streamIdToOutputMap, nodes, applianceName, inputs, links);
        }
    });
}
function addVaInputConfig(config, channelId, nodes, inputs, links) {
    config.vaInput?.forEach((vaInput)=>{
        const keys = Object.keys(vaInput);
        const pipelineKeys = [
            keys.find((k)=>k.includes('Input') || k.includes('Sink')),
            keys.find((k)=>k === 'encoder'),
            'edgeSource'
        ].filter((0, _helpers.notUndefined));
        const getRemoteHostAndPort = (vaInputOrLink)=>{
            if ('edgeSource' in vaInputOrLink) return {
                remoteHost: vaInputOrLink.edgeSource.remoteHost,
                remotePort: vaInputOrLink.edgeSource.remotePort
            };
            return {
                remoteHost: vaInputOrLink.edgeLink.remoteHost,
                remotePort: vaInputOrLink.edgeLink.remotePort
            };
        };
        const { remoteHost, remotePort } = getRemoteHostAndPort(vaInput);
        const ristserverInput = config.inputs.find((input)=>input.type !== 'unix-input' && input.localIp === remoteHost && input.localPort === parseInt(remotePort));
        const inputPipeChannelId = ristserverInput?.channelId;
        if (includedInChannel(channelId, ristserverInput)) for(let i = 0; i < pipelineKeys.length; i++){
            const key = pipelineKeys[i];
            const conf = vaInput[key];
            nodes.push({
                id: inputPipeChannelId + key,
                inputName: (inputs.find((input)=>input.channelId === inputPipeChannelId) || {
                    name: ''
                }).name,
                name: key,
                metadata: {
                    type: 'va'
                },
                metadataText: stringifyVaConf(conf)
            });
            if (ristserverInput) links.push({
                source: inputPipeChannelId + key,
                target: pipelineKeys[i + 1] !== undefined ? inputPipeChannelId + pipelineKeys[i + 1] : ristserverInput.streamId,
                distance: 100,
                width: 1,
                hide: false
            });
        }
    });
}
function addVaOutputConfig(config, channelId, selectedOutputId, streamIdToOutputMap, nodes, applianceName, inputs, links) {
    config.vaOutput?.forEach((vaOutput)=>{
        const keys = Object.keys(vaOutput);
        const pipelineKeys = [
            keys.find((k)=>k.includes('Output') || k.includes('Source')),
            keys.find((k)=>k === 'decoder'),
            'edgeSink'
        ].filter((0, _helpers.notUndefined));
        const ristserverOutput = config.outputs.find((output)=>output.type !== 'unix-output' && output.remoteIp === vaOutput.edgeSink.localIf && output.remotePort === parseInt(vaOutput.edgeSink.recvPort));
        const outputPipeChannelId = ristserverOutput?.channelId;
        const idForPipeObject = (applianceName, channelId, pipelineKey, edgeSink)=>applianceName + channelId + pipelineKey + edgeSink.recvPort;
        if (ristserverOutput && includedInChannel(channelId, ristserverOutput) && isNotExcludedOutput(selectedOutputId, streamIdToOutputMap, ristserverOutput)) for(let i = 0; i < pipelineKeys.length; i++){
            const key = pipelineKeys[i];
            const conf = vaOutput[key];
            nodes.push({
                id: idForPipeObject(applianceName, outputPipeChannelId, key, vaOutput.edgeSink),
                name: key,
                inputName: (inputs.find((input)=>input.channelId === outputPipeChannelId) || {
                    name: ''
                }).name,
                outputName: ristserverOutput && streamIdToOutputMap[ristserverOutput.streamId]?.outputName,
                metadata: {
                    type: 'va'
                },
                metadataText: stringifyVaConf(conf)
            });
            if (ristserverOutput) {
                const target = idForPipeObject(applianceName, outputPipeChannelId, key, vaOutput.edgeSink);
                const source = pipelineKeys[i + 1] !== undefined ? idForPipeObject(applianceName, outputPipeChannelId, pipelineKeys[i + 1], vaOutput.edgeSink) : ristserverOutput.streamId;
                links.push({
                    target,
                    source,
                    distance: 100,
                    width: 1,
                    hide: false
                });
            }
        }
    });
}
function formatMetadataAsText(metadata, inputs, outputs) {
    if (metadata) {
        if (metadata.type && metadata.type !== 'va' && metadata.type !== 'tunnel') {
            let str = `channelId: ${metadata.channelId}, streamId: ${metadata.streamId}`;
            if (metadata.type === 'udp-output' || metadata.type === 'zixi-output' || metadata.type === 'srt-output') {
                if (metadata.delayMs) str += `, delayMs: ${metadata.delayMs}`;
                if (metadata.delayMode) str += `, delayMode: ${metadata.delayMode}`;
            }
            if (metadata.type === 'push-rist-input' || metadata.type === 'push-rist-output' && metadata.tunnelId) str += `, tunnelId: ${metadata.tunnelId}`;
            if (metadata.streamId) {
                const handledMetricSet = new Set();
                const io = [
                    ...inputs,
                    ...outputs
                ];
                for (const i of io)for (const m of i.metrics?.ristMetrics || []){
                    const metricHash = `${m.type}#${m.streamId}#${m.window}`;
                    if (handledMetricSet.has(metricHash)) continue;
                    handledMetricSet.add(metricHash);
                    if (m.streamId == metadata.streamId) {
                        switch(m.type){
                            case (0, _types.RistMetricType).udpInput:
                            case (0, _types.RistMetricType).rtpInput:
                                str += `, receiveBitrate: ${m.receiveBitrate}`;
                                break;
                            case (0, _types.RistMetricType).ristOutput:
                                str += `, sendBitrate: ${m.sendBitrate}`;
                                break;
                            case (0, _types.RistMetricType).udpOutput:
                                if (metadata.type !== 'udp-output') continue;
                                switch(m.window){
                                    case (0, _types.MetricWindow).s10:
                                        str += `, sendBitrate: ${m.sendBitrate}`;
                                        break;
                                }
                                break;
                            case (0, _types.RistMetricType).ristInput:
                                switch(m.window){
                                    case (0, _types.MetricWindow).m1:
                                        break;
                                    case (0, _types.MetricWindow).s10:
                                        str += `, receiveBitrate: ${m.receiveBitrate}`;
                                        break;
                                    default:
                                }
                        }
                        break;
                    }
                }
            }
            if (metadata.type !== 'unix-output' && metadata.type !== 'unix-input') str += `, ${metadata.localIp}:${metadata.localPort}`;
            if ((0, _helpers.isOutput)(metadata) && metadata.type !== 'unix-output' && metadata.remotePort) str += `\u{2192}${metadata.remoteIp}:${metadata.remotePort}`;
            return str;
        } else if (metadata.type === 'tunnel') return metadata.tunnels.map((tunnel)=>`id: ${tunnel.tunnelId}, ${tunnel.localIp}:${tunnel.localPort}` + (tunnel.type === 'tunnel-client' && tunnel.remoteIp ? `\u{2192}${tunnel.remoteIp}:${tunnel.remotePort}` : '') + `, s: ${tunnel.secret}`).join('\n');
    }
    return 'nothing';
}
function includedInChannel(channelId, obj) {
    return obj?.channelId === channelId || channelId === -1;
}
function isNotExcludedOutput(selectedOutputId, streamIdToOutputMap, obj) {
    return selectedOutputId === '-1' || /* streamId is only set for egress sinks, so everything else should be included since it's not an output that can be filtered out */ streamIdToOutputMap[obj.streamId] === undefined || streamIdToOutputMap[obj.streamId].outputId === selectedOutputId;
}
function includedInNodes(nodes, id) {
    return nodes.map((n)=>n.id).includes(id);
}
function applianceHasObjectInChannel(config, channelId) {
    return [
        ...config.inputs,
        ...config.outputs
    ].some((obj)=>includedInChannel(channelId, obj));
}
function findTargetNodeOfTunnelClient(input, tunnelClient) {
    const target = Object.entries(input).find(([name, value])=>{
        return value.tunnels.some((tunnel)=>{
            if (tunnel.type === 'tunnel-server' && tunnel.tunnelId === tunnelClient.tunnelId) return name;
        });
    });
    if (target) return `${target[0]}_tunnel`;
}
function isRistInputAndOutputConnected(input, output, channelId, sourceName, targetName) {
    return input !== undefined && output !== undefined && input.type === 'push-rist-input' && output.type === 'push-rist-output' && input.tunnelId === output.tunnelId && input.channelId === output.channelId && includedInChannel(channelId, input) && sourceName !== targetName && output.remoteIp === input.localIp && output.remotePort === input.localPort;
}
function stringifyVaConf(conf) {
    return JSON.stringify(conf, null, 2)?.replace(/^{\n|\n}$/g, '').split('\n').reverse().join('\n');
}

},{"common/api/v1/types":"3qemx","common/api/v1/helpers":"6jovr","./index":"iOzn1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4pBqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Audit", ()=>Audit);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _notFound = require("../common/NotFound");
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
const Audit = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../common/NotFound":"1Msr5","./List":"4OUKg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4OUKg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dateFns = require("date-fns");
var _capitalize = require("lodash/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _store = require("../../store");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _filters = require("../common/Filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _helpers = require("common/api/v1/helpers");
var _indicator = require("../common/Indicator");
const { userApi } = (0, _store.Api);
const RETENTION_DAYS = 90;
const retentionPeriod = new Date();
retentionPeriod.setDate(retentionPeriod.getDate() - (RETENTION_DAYS + 10)) // margin 10d
;
const AuditList = ()=>{
    const [pageParams, setPageParams] = (0, _utils.usePageParams)();
    const { fromDate, toDate } = pageParams;
    (0, _react.useEffect)(()=>{
        if (!fromDate) setPageParams({
            fromDate: (0, _dateFns.addDays)(new Date(), -1).toISOString()
        });
    }, [
        fromDate,
        setPageParams
    ]);
    const minDate = fromDate ? new Date(fromDate) : new Date('2020-01-01');
    const maxDate = toDate ? new Date(toDate) : new Date();
    const validDateRange = (0, _dateFns.compareAsc)(minDate, maxDate) === -1;
    if (!fromDate) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Audit log",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AuditListFilter, {
                minDate: minDate,
                maxDate: maxDate
            }),
            validDateRange && /*#__PURE__*/ (0, _jsxRuntime.jsx)(AuditListTable, {})
        ]
    });
};
const AuditListFilter = ({ minDate, maxDate })=>{
    const user = (0, _utils.useUser)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filtersDefault.default), {
        filters: [
            {
                label: 'From date',
                paramName: 'fromDate',
                type: (0, _filters.FilterType).datetime,
                minDate: retentionPeriod,
                minDateMessage: 'The retention period is 90 days',
                maxDate,
                maxDateMessage: 'Cannot be after "To date"'
            },
            {
                label: 'To date',
                paramName: 'toDate',
                type: (0, _filters.FilterType).datetime,
                minDate,
                minDateMessage: 'Cannot be before "From date"'
            },
            {
                label: 'Operation',
                paramName: 'operation',
                type: (0, _filters.FilterType).select,
                options: Object.values((0, _types.AuditOperation)).map((item)=>({
                        name: auditOperationName(item),
                        value: item
                    }))
            },
            {
                label: 'Result',
                paramName: 'result',
                type: (0, _filters.FilterType).select,
                options: [
                    {
                        name: 'Success',
                        value: 'success'
                    },
                    {
                        name: 'Error',
                        value: 'error'
                    }
                ],
                hidden: user.role !== (0, _types.Role).super
            },
            {
                label: 'Entity',
                paramName: 'entity',
                type: (0, _filters.FilterType).select,
                options: Object.values((0, _pickDefault.default)((0, _types.EntityType), 'input', 'output', 'group', 'user', 'appliance', 'outputRecipientList', 'groupRecipientList', 'ipMapping')).map((item)=>({
                        name: (0, _helpers.getEntityTypeName)(item),
                        value: item
                    }))
            },
            {
                label: 'Entity name',
                paramName: 'entityName',
                type: (0, _filters.FilterType).text
            },
            {
                label: 'User',
                paramName: 'username',
                type: (0, _filters.FilterType).autocomplete,
                autocomplete: {
                    api: userApi.getUsers.bind(userApi),
                    getOptionValue: ({ username })=>username,
                    getOptionLabel: ({ username })=>username
                }
            }
        ]
    });
};
const AuditListTable = ()=>{
    const { audit, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useAuditSelector));
    const [pageParams] = (0, _utils.usePageParams)();
    const { pageNumber } = pageParams;
    const tableConfig = [
        {
            title: 'user',
            getValue: ({ username, impersonatorUsername })=>{
                if (!impersonatorUsername) return username;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        impersonatorUsername,
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            style: {
                                opacity: 0.5
                            },
                            children: [
                                "(as ",
                                username,
                                ")"
                            ]
                        })
                    ]
                });
            }
        },
        {
            title: 'action',
            getValue: formatAuditOperation
        },
        {
            title: 'result',
            getValue: ({ error })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.AuditOperationIndicator), {
                    error: error
                }),
            props: {
                noTypography: true
            }
        },
        {
            title: 'time',
            getValue: ({ createdAt })=>createdAt ? (0, _dateFns.format)(createdAt, (0, _helpers.DATE_FORMAT_LONG)) : null
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
        emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
            message: "No log available for the interval"
        }),
        config: tableConfig,
        data: audit.map((item, idx)=>({
                ...item,
                id: `${pageNumber || 0}_${idx}${item.id}`
            })),
        pending: loading,
        pagination: {
            total,
            useUrlSearchParams: true
        }
    });
};
function formatAuditOperation({ operation, entity, entityName, error, refData, entityId }) {
    let operationPastTense = formatOperationPastTense({
        operation,
        error,
        refData
    });
    let entityTypeName = (0, _helpers.getEntityTypeName)(entity);
    let entityNameString = entityName ? ` "${entityName}"` : '';
    let suffix = '';
    switch(operation){
        case (0, _types.AuditOperation).switchInput:
            if (refData && refData.inputName) suffix = ` to "${refData.inputName}"`;
            break;
        case (0, _types.AuditOperation).toggle:
            if (refData.action) operationPastTense = defaultPastTense(refData.action);
            try {
                const entityNames = JSON.parse(`[${entityName}]`);
                if (entityNames.length > 1) {
                    const pluralEntityTypeName = entityTypeName + 's';
                    entityTypeName = pluralEntityTypeName;
                }
            } catch  {
            // entityName was not parseable as a list of strings -> use singular
            }
            entityNameString = ` ${entityName}`;
            break;
        case (0, _types.AuditOperation).stopCloudApplianceInstance:
        case (0, _types.AuditOperation).startCloudApplianceInstance:
            {
                const { name = 'N/A', id = 'N/A', region = 'N/A' } = refData?.cloudApplianceInstance ?? {};
                suffix = ` for ${entityTypeName}${entityNameString}`;
                // for these cases ec2 instance is the main entity so we are changing the roles
                entityTypeName = 'cloud instance';
                entityNameString = ` "${id}" (${name}, ${region})`;
                break;
            }
        case (0, _types.AuditOperation).beginSystemUpgrade:
        case (0, _types.AuditOperation).completeSystemUpgrade:
            {
                const { fromVersion = 'N/A', toVersion = 'N/A' } = refData?.systemUpgrade ?? {};
                entityTypeName = `upgrading system from ${fromVersion} to ${toVersion}`;
                entityNameString = ` - session ${entityId ?? 'N/A'}.`;
                suffix = error ? ` Error: ${error}` : '';
                break;
            }
    }
    const auditOp = `${operationPastTense} ${entityTypeName}${entityNameString}`;
    return `${auditOp}${suffix}`;
}
function auditOperationName(operation) {
    switch(operation){
        case (0, _types.AuditOperation).switchInput:
            return 'switch input';
        case (0, _types.AuditOperation).updateInputRecipients:
            return 'update input recipients';
        case (0, _types.AuditOperation).registerAppliance:
            return 'register appliance';
        case (0, _types.AuditOperation).reregisterAppliance:
            return 'appliance restart';
        case (0, _types.AuditOperation).updateApplianceBasicInfo:
            return 'update appliance basic info';
        case (0, _types.AuditOperation).updateApplianceVersion:
            return 'update appliance version';
        default:
            return operation;
    }
}
function formatOperationPastTense({ operation, error, refData: context }) {
    let versionType = '';
    switch(operation){
        case (0, _types.AuditOperation).login:
            return !error ? 'Logged in' : 'Failed login';
        case (0, _types.AuditOperation).logout:
            return `Logged out`;
        case (0, _types.AuditOperation).switchInput:
            return `${context?.inputName ? 'Switched' : 'Cleared'} input for`;
        case (0, _types.AuditOperation).updateInputRecipients:
            return `Updated recipients for`;
        case (0, _types.AuditOperation).sendToOutputs:
            return `Updated outputs for`;
        case (0, _types.AuditOperation).registerAppliance:
            return `Registered`;
        case (0, _types.AuditOperation).reregisterAppliance:
            return `Appliance restarted`;
        case (0, _types.AuditOperation).updateApplianceVersion:
            if (context) {
                versionType = context.hasDataSoftwareVersion ? 'data' : 'control';
                versionType = `${versionType} software `;
            }
            return `Updated ${versionType}version for`;
        case (0, _types.AuditOperation).updateApplianceBasicInfo:
            return `Updated basic info for`;
        case (0, _types.AuditOperation).updateApplianceIpConfig:
            return `Updated IP config for`;
        case (0, _types.AuditOperation).restartAppliance:
            return 'Restarted';
        case (0, _types.AuditOperation).startCloudApplianceInstance:
            return 'Started';
        case (0, _types.AuditOperation).stopCloudApplianceInstance:
            return 'Stopped';
        case (0, _types.AuditOperation).beginSystemUpgrade:
            return 'Began';
        case (0, _types.AuditOperation).completeSystemUpgrade:
            return error ? 'Failed' : 'Done';
        case (0, _types.AuditOperation).create:
        case (0, _types.AuditOperation).delete:
        case (0, _types.AuditOperation).update:
        default:
            return defaultPastTense(operation);
    }
}
function defaultPastTense(verb) {
    return (0, _capitalizeDefault.default)(`${verb}d`);
}
exports.default = AuditList;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","date-fns":"gelMX","lodash/capitalize":"foBBQ","lodash/pick":"5kPds","common/api/v1/types":"3qemx","../../utils":"342UB","../../store":"5LXiG","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../common/Filters":"5hY8D","common/api/v1/helpers":"6jovr","../common/Indicator":"hqaQa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"foBBQ":[function(require,module,exports,__globalThis) {
var toString = require("94083a2fb0097719"), upperFirst = require("e8384184eda4212f");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function capitalize(string) {
    return upperFirst(toString(string).toLowerCase());
}
module.exports = capitalize;

},{"94083a2fb0097719":"iEDGT","e8384184eda4212f":"eSJZa"}],"5hY8D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _utils = require("./utils");
var _datePicker = require("./DatePicker");
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _autocomplete = require("./Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _textInput = require("./TextInput");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
parcelHelpers.exportAll(_utils, exports);
const classes = {
    container: {
        margin: (theme)=>theme.spacing(1, 0, 2),
        display: 'flex',
        gap: (theme)=>theme.spacing(2),
        flexWrap: 'wrap'
    }
};
/**
 * If we need any filter other than just name substring we can add this component (see Audit Log for example)
 * @param filters - array of filters to be added, four types are implemented so far - date, text, autocomplete and select
 */ const Filter = ({ filters })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
        disableGutters: true,
        sx: classes.container,
        children: filters.filter((f)=>!f.hidden).map((params)=>{
            if (params.type === (0, _utils.FilterType).datetime) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePicker.DateTimePicker), {
                ...params
            }, `filter-${params.paramName}`);
            if (params.type === (0, _utils.FilterType).select) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                ...params
            }, `filter-${params.paramName}`);
            if (params.type === (0, _utils.FilterType).text) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                ...params
            }, `filter-${params.paramName}`);
            if (params.type === (0, _utils.FilterType).autocomplete && !!params.autocomplete) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteDefault.default), {
                ...params
            }, `filter-${params.paramName}`);
            return null;
        })
    });
};
exports.default = Filter;

},{"react/jsx-runtime":"1dlk8","@mui/material/Toolbar":"5Kohb","./utils":"63xHG","./DatePicker":"426Do","./Select":"cxYtc","./Autocomplete":"f1jtG","./TextInput":"2qmIv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"63xHG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterType", ()=>FilterType);
var FilterType = /*#__PURE__*/ function(FilterType) {
    FilterType["datetime"] = "datetime";
    FilterType["text"] = "text";
    FilterType["select"] = "select";
    FilterType["autocomplete"] = "autocomplete";
    return FilterType;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"426Do":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimePicker", ()=>DateTimePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _xDatePickers = require("@mui/x-date-pickers");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _utils = require("../../../utils");
const DateTimePicker = ({ paramName, label, minDate = new Date('2020-01-01'), minDateMessage, maxDate = new Date(), maxDateMessage })=>{
    const [params, setPageParams] = (0, _utils.usePageParams)();
    const value = params[paramName] ?? new Date().toISOString();
    const [open, setOpen] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const handleChange = (value)=>{
        setPageParams({
            [paramName]: value?.toISOString(),
            pageNumber: undefined
        });
    };
    const errorMessage = (0, _react.useMemo)(()=>{
        switch(error){
            case 'disableFuture':
                return 'Future dates cannot be specified';
            case 'invalidDate':
                return 'Invalid date';
            case 'maxDate':
                return maxDateMessage ?? '';
            case 'minDate':
                return minDateMessage ?? '';
            default:
                return '';
        }
    }, [
        error,
        minDateMessage,
        maxDateMessage
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.LocalizationProvider), {
        dateAdapter: (0, _adapterDateFns.AdapterDateFns),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DateTimePicker), {
            open: open,
            onOpen: ()=>setOpen(true),
            onClose: ()=>setOpen(false),
            label: label,
            format: "yyyy-MM-dd hh:mm a",
            value: new Date(value),
            onChange: handleChange,
            minDate: minDate,
            maxDate: maxDate,
            disableFuture: true,
            onError: (newError)=>setError(newError),
            slotProps: {
                actionBar: {
                    actions: [
                        'clear',
                        'accept'
                    ]
                },
                textField: {
                    onClick: ()=>setOpen(true),
                    helperText: errorMessage
                }
            }
        })
    }, `filter-${paramName}`);
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/x-date-pickers":"gSoHo","@mui/x-date-pickers/AdapterDateFns":"bSwsg","../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cxYtc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _utils = require("../../../utils");
/**
 * Select filter
 * @param paramName - parameter name
 * @param label - input label
 * @param options - options to select from
 */ const Select = ({ paramName, label, options = [] })=>{
    const [params, setPageParams] = (0, _utils.usePageParams)();
    const value = params[paramName] || '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
        variant: "outlined",
        style: {
            minWidth: '150px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectDefault.default), {
                autoWidth: true,
                value: value,
                onChange: ({ target })=>setPageParams({
                        [paramName]: String(target.value) || undefined,
                        pageNumber: '0'
                    }),
                label: label,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        value: "",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: "None"
                        })
                    }),
                    options.map(({ name, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                            value: value,
                            children: name
                        }, `menu-item-${value}`))
                ]
            })
        ]
    });
};
exports.default = Select;

},{"react/jsx-runtime":"1dlk8","@mui/material/Select":"kyj0v","@mui/material/MenuItem":"krMs8","@mui/material/FormControl":"ioFZ4","@mui/material/InputLabel":"5EJtb","../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1jtG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _autocomplete = require("@mui/material/Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _debounce = require("lodash/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _utils = require("../../../../utils");
const FilterAutocomplete = (props)=>{
    const { paramName, label, autocomplete } = props;
    const { api, getOptionValue, ...restProps } = autocomplete;
    const initialized = (0, _react.useRef)(false);
    const [params, setPageParams] = (0, _utils.usePageParams)();
    const [value, setValue] = (0, _react.useState)(null);
    const [inputValue, setInputValue] = (0, _react.useState)(params[paramName] || '');
    const [options, setOptions] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [apiSearchFilter, setApiSearchFilter] = (0, _react.useState)(undefined);
    const fetch = async (filter)=>{
        const { items } = await api({
            pageNumber: '0',
            rowsPerPage: '30',
            filter
        });
        setOptions(items);
        setIsLoading(false);
        // We only know the value of the preselected option according to 'params',
        // must fetch options, find preselected option among them, then set it as current Autocomplete value
        if (!initialized.current) setValue(items.find((v)=>getOptionValue(v) === params[paramName]) || null);
        initialized.current = true;
    };
    const debouncedFetch = (0, _react.useCallback)((0, _debounceDefault.default)(fetch, 500), []);
    (0, _react.useEffect)(()=>{
        setOptions([]);
        setIsLoading(true);
        if (initialized.current) debouncedFetch(apiSearchFilter);
        else fetch(apiSearchFilter);
    }, [
        apiSearchFilter
    ]);
    (0, _react.useEffect)(()=>{
        if (initialized.current) {
            const paramValue = value ? getOptionValue(value) : undefined;
            setPageParams({
                [paramName]: paramValue,
                pageNumber: '0'
            });
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlDefault.default), {
        id: `autocomplete-${paramName}`,
        style: {
            minWidth: '240px'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteDefault.default), {
            value: value,
            inputValue: inputValue,
            options: options,
            loading: isLoading,
            fullWidth: true,
            onChange: (_, newOption)=>{
                setValue(newOption);
            },
            onInputChange: (_, newInputValue)=>{
                setInputValue(newInputValue);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                    ...params,
                    name: paramName,
                    label: label || (0, _upperFirstDefault.default)(paramName),
                    variant: "outlined",
                    onChange: (e)=>{
                        setApiSearchFilter(e.target.value);
                    },
                    slotProps: {
                        htmlInput: {
                            ...params.inputProps,
                            autoComplete: 'off'
                        }
                    }
                }),
            ...restProps
        })
    });
};
exports.default = FilterAutocomplete;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/FormControl":"ioFZ4","@mui/material/Autocomplete":"avdFA","@mui/material/TextField":"l88b4","lodash/upperFirst":"eSJZa","lodash/debounce":"1hVPi","../../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2qmIv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _utils = require("../../../utils");
/**
 * Simple text filter setting page parameters with debounce, and reseting page number
 * @param paramName - parameter to change
 * @param label - input field label to show
 */ const TextInput = ({ paramName, label })=>{
    const [params, setPageParams] = (0, _utils.usePageParams)();
    const paramValue = params[paramName] || '';
    const [value, setValue] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        setValue(paramValue);
    }, [
        paramValue
    ]);
    (0, _utils.useDebouncedFilter)(value, (debouncedValue)=>setPageParams({
            [paramName]: debouncedValue || undefined,
            pageNumber: '0'
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlDefault.default), {
        variant: "outlined",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
            variant: "outlined",
            value: value,
            onChange: ({ target })=>setValue(target.value),
            label: label
        })
    });
};
exports.default = TextInput;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/TextField":"l88b4","@mui/material/FormControl":"ioFZ4","../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Qufr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Regions", ()=>Regions);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _list = require("./List");
var _edit = require("./Edit");
const Regions = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.List), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).UPDATE,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","./List":"eGcL1","./Edit":"6ZtAX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGcL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "List", ()=>List);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _fiberManualRecord = require("@mui/icons-material/FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _store = require("../../store");
var _utils = require("../../utils");
var _link = require("../common/Link");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _listRegionFilter = require("./listRegionFilter");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _actionMenu = require("../common/Table/ActionMenu");
var _reactRedux = require("react-redux");
var _adjust = require("@mui/icons-material/Adjust");
var _adjustDefault = parcelHelpers.interopDefault(_adjust);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _regionsActions = require("../../redux/actions/regionsActions");
const styles = {
    defaultIndicatorWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    defaultIndicator: {
        marginLeft: '10px'
    }
};
const List = ()=>{
    const { regions, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useRegionsSelector));
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const tableConfig = [
        {
            title: 'name',
            getValue: (region)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    available: (0, _utils.isEditableRegion)(user),
                    to: routes.regionsUpdate({
                        id: region.id
                    }),
                    underline: "hover",
                    children: region.name
                }),
            sorting: {
                byParameter: 'name'
            }
        },
        {
            title: 'type',
            getValue: ({ _externalText })=>_externalText,
            sorting: {
                byParameter: 'external'
            }
        },
        {
            title: 'default',
            getValue: ({ default_region })=>{
                if (!default_region) return;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: styles.defaultIndicatorWrapper,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                        sx: styles.defaultIndicator
                    })
                });
            },
            sorting: {
                byParameter: 'default_region'
            },
            props: {
                noTypography: true
            }
        },
        // <ActionMenu region={row} disabled={!isEditableRegion(user)} />,
        {
            title: '',
            getValue: (region)=>(0, _utils.isEditableRegion)(user) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    options: [
                        {
                            label: 'Edit',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                            href: routes.regionsUpdate({
                                id: region.id
                            }),
                            'data-test-id': 'edit-region'
                        },
                        {
                            label: 'Set as default',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adjustDefault.default), {}),
                            onClick: ()=>{
                                dispatch((0, _regionsActions.setDefaultRegion)({
                                    regionId: region.id,
                                    regionName: region.name
                                }));
                            }
                        }
                    ]
                }),
            props: {
                noTypography: true
            }
        }
    ];
    const filters = (0, _listRegionFilter.makeListRegionsFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Regions",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'regions',
                        mapUrlParamToFilterFn: (0, _listRegionFilter.mapUrlParamToRegionFilter),
                        mapFilterToUrlParamFn: (0, _listRegionFilter.mapRegionFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listRegionFilter.ListRegionFilterKey).name)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No regions available"
                }),
                config: tableConfig,
                data: regions,
                pending: loading,
                pagination: {
                    total,
                    useUrlSearchParams: true
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","@mui/material/Toolbar":"5Kohb","@mui/icons-material/FiberManualRecord":"bvXIN","../../store":"5LXiG","../../utils":"342UB","../common/Link":"l3o6V","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","./listRegionFilter":"jWnrb","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","../common/Table/ActionMenu":"jf6As","react-redux":"l1pMU","@mui/icons-material/Adjust":"ay1JF","@mui/icons-material/Settings":"jkTfg","../../redux/actions/regionsActions":"d48MN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jWnrb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListRegionFilterKey", ()=>ListRegionFilterKey);
parcelHelpers.export(exports, "mapRegionFilterToUrlParam", ()=>mapRegionFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToRegionFilter", ()=>mapUrlParamToRegionFilter);
parcelHelpers.export(exports, "makeListRegionsFilter", ()=>makeListRegionsFilter);
var ListRegionFilterKey = /*#__PURE__*/ function(ListRegionFilterKey) {
    ListRegionFilterKey["name"] = "name";
    return ListRegionFilterKey;
}({});
function mapRegionFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToRegionFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListRegionsFilter() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ay1JF":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("9f9e62431ec31c5d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("3734a4a15f413d14"));
var _jsxRuntime = require("f3687f4f9962488");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3"
}), 'Adjust');

},{"9f9e62431ec31c5d":"kZ6eK","3734a4a15f413d14":"2vOnF","f3687f4f9962488":"1dlk8"}],"6ZtAX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _types = require("common/api/v1/types");
var _index = require("../../../utils/index");
var _form = require("../../common/Form");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _confirmDialog = require("../../common/ConfirmDialog");
var _meta = require("./meta");
var _regionsActions = require("../../../redux/actions/regionsActions");
var _store = require("../../../store");
const ScalingPane = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Scaling",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                label: "Video Scale",
                name: "videoScale.replicas",
                required: true,
                type: "number",
                noNegative: true,
                validators: {
                    number: {
                        greaterThanOrEqualTo: 0,
                        message: 'Cannot be negative'
                    }
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                label: "Thumb Scale",
                name: "thumbScale.replicas",
                required: true,
                type: "number",
                noNegative: true,
                validators: {
                    number: {
                        greaterThanOrEqualTo: 0,
                        message: 'Cannot be negative'
                    }
                }
            })
        ]
    });
};
const Edit = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _regionsActions.getRegionDetails)(id));
        return ()=>{
            dispatch((0, _regionsActions.clearRegion)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { regionDetails, loading } = (0, _reactRedux.useSelector)(({ regionsReducer })=>({
            regionDetails: regionsReducer.regionDetails,
            loading: regionsReducer.loading
        }), (0, _reactRedux.shallowEqual));
    const user = (0, _index.useUser)();
    if (user.role !== (0, _types.Role).super) {
        navigate(-1);
        return null;
    }
    const onSubmit = (regionDetails)=>{
        dispatch((0, _regionsActions.updateRegion)({
            regionId: regionDetails.region.id,
            regionName: regionDetails.region.name,
            videoScaleCount: regionDetails.videoScale.replicas,
            thumbScaleCount: regionDetails.thumbScale.replicas
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Regions',
            regionDetails?.region.name
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: loading,
            children: regionDetails ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _meta.Meta), {
                        regionDetails: regionDetails
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                        defaultValues: regionDetails,
                        onSubmit: (values)=>{
                            onSubmit((0, _index.formTransform)(values));
                        },
                        component: RegionForm
                    })
                ]
            }) : null
        })
    });
};
const RegionForm = ({ getValues, formState })=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const user = (0, _index.useUser)();
    const { showConfirmation } = (0, _confirmDialog.useConfirmationDialog)();
    const { saving, regionDetails } = (0, _reactRedux.useSelector)(({ regionsReducer })=>({
            saving: regionsReducer.saving,
            regionDetails: regionsReducer.regionDetails
        }), (0, _reactRedux.shallowEqual));
    const { devMode } = (0, _index.useSettingsSelector)();
    const isEditableRegion = [
        (0, _types.ExternalRegionMode).core,
        (0, _types.ExternalRegionMode).externalK8s
    ].includes(getValues().region.external);
    const showDeleteButton = devMode && user.role === (0, _types.Role).super;
    const handleDeleteRegion = (region)=>{
        showConfirmation(()=>{
            dispatch((0, _regionsActions.deleteRegion)(region));
            navigate(routes.regions());
        }, `Are you sure you want to delete the region "${region.name}"?`, undefined, {
            ok: {
                text: 'delete',
                color: 'error'
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                enabled: formState.isDirty && !formState.isSubmitSuccessful && Boolean(regionDetails)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "region-form",
                noValidate: true,
                children: [
                    isEditableRegion ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScalingPane, {}) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>void navigate(routes.regions())
                            },
                            Save: {
                                disabled: !isEditableRegion,
                                id: 'button-save',
                                savingState: !!saving,
                                primary: true,
                                type: 'submit'
                            }
                        },
                        secondary: regionDetails && showDeleteButton ? {
                            'DELETE REGION': {
                                onClick: ()=>handleDeleteRegion(regionDetails.region),
                                disabled: regionDetails?.region.default_region ?? undefined,
                                tooltip: regionDetails?.region.default_region ? `can't delete a default region` : ''
                            }
                        } : {}
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","common/api/v1/types":"3qemx","../../../utils/index":"342UB","../../common/Form":"4Mui7","../../common/Wrapper":"8oy7r","../../common/Pendable":"gDN67","../../common/ConfirmDialog":"7JKPn","./meta":"fiyMN","../../../redux/actions/regionsActions":"d48MN","../../../store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fiyMN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Meta", ()=>Meta);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _form = require("../../common/Form");
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _link = require("../../common/Link");
const Meta = ({ regionDetails })=>{
    const routes = (0, _store.useRoutes)();
    const name = regionDetails.region.name;
    const meta = {
        Name: name,
        Type: regionDetails.region._externalText,
        Default: regionDetails.region.default_region ? 'True' : 'False',
        'Appliances (Total)': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            to: routes.appliances({
                regions: [
                    name
                ]
            }),
            underline: "hover",
            children: regionDetails.region.appliancesTotal
        }),
        'Video Appliances': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            to: routes.appliances({
                regions: [
                    name
                ],
                types: [
                    (0, _types.ApplianceType).core
                ]
            }),
            underline: "hover",
            children: regionDetails.videoScale.currentReplicas
        }),
        'Thumb Appliances': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            to: routes.appliances({
                regions: [
                    name
                ],
                types: [
                    (0, _types.ApplianceType).thumb
                ]
            }),
            underline: "hover",
            children: regionDetails.thumbScale.currentReplicas
        })
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Metadata",
        collapsible: true,
        actionsPane: [],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
            lg: 12,
            xl: 12,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                values: meta
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","common/api/v1/types":"3qemx","../../../store":"5LXiG","../../common/Form":"4Mui7","../../common/DataSet":"dmQXG","../../common/Link":"l3o6V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jpK9z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "classes", ()=>classes);
parcelHelpers.export(exports, "Settings", ()=>Settings);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tabs = require("@mui/material/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tab = require("@mui/material/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _contentCopy = require("@mui/icons-material/ContentCopy");
var _contentCopyDefault = parcelHelpers.interopDefault(_contentCopy);
var _openInNew = require("@mui/icons-material/OpenInNew");
var _openInNewDefault = parcelHelpers.interopDefault(_openInNew);
var _env = require("../../env");
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _types = require("common/api/v1/types");
var _store = require("../../store");
var _settingsActions = require("../../redux/actions/settingsActions");
var _utils = require("../../utils");
var _features = require("../../utils/features");
var _form = require("../common/Form");
var _pendable = require("../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../common/Link");
var _fileInput = require("./FileInput");
var _fileInputDefault = parcelHelpers.interopDefault(_fileInput);
var _apiTokensActions = require("../../redux/actions/apiTokensActions");
var _reactHookForm = require("react-hook-form");
var _userActions = require("../../redux/actions/userActions");
var _tooltip = require("../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _notificationActions = require("../../redux/actions/notificationActions");
const classes = {
    container: {
        width: '100%',
        borderBottom: (theme)=>`1px solid ${theme.palette.divider}`
    },
    noMarginTop: {
        mt: 0,
        WebkitBorderTopLeftRadius: 0,
        WebkitBorderTopRightRadius: 0
    },
    noMarginBottom: {
        mb: 0,
        WebkitBorderBottomLeftRadius: 0,
        WebkitBorderBottomRightRadius: 0
    }
};
var GlobalSettingsTabs = /*#__PURE__*/ function(GlobalSettingsTabs) {
    GlobalSettingsTabs["settings"] = "settings";
    GlobalSettingsTabs["backups"] = "backups";
    GlobalSettingsTabs["customization"] = "customization";
    GlobalSettingsTabs["tls certificate"] = "tls certificate";
    GlobalSettingsTabs["licenses"] = "licenses";
    GlobalSettingsTabs["alarms"] = "alarms";
    GlobalSettingsTabs["auth provider"] = "auth provider";
    return GlobalSettingsTabs;
}(GlobalSettingsTabs || {});
const BackupSettings = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const [anchorElConfig, setAnchorElConfig] = (0, _react.useState)(null);
    const [anchorElMetrics, setAnchorElMetrics] = (0, _react.useState)(null);
    const handleOpen = (event, setAnchorEl)=>{
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (setAnchorEl)=>{
        setAnchorEl(null);
    };
    const handleCreateBackup = (type, setAnchorEl)=>{
        showConfirmation(()=>{
            dispatch((0, _settingsActions.createBackup)({
                type
            }));
            setAnchorEl(null);
        }, 'Taking backup might temporarily affect the database performance and will use additional disk space. Would you like to proceed?');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Backups",
        sx: classes.noMarginTop,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.GridItem), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "span",
                        children: "Config backups"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: "Config backups are created every 6 hours. The retention period is 7 days.",
                        sx: {
                            marginLeft: 1
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: "View config backups",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            "aria-label": "View config backups",
                            onClick: ()=>window.open('/backup/config', '_blank'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInNewDefault.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                onClick: (e)=>handleOpen(e, setAnchorElConfig),
                                "aria-label": "Show actions of config backups",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                                open: Boolean(anchorElConfig),
                                keepMounted: true,
                                anchorEl: anchorElConfig,
                                onClose: ()=>handleClose(setAnchorElConfig),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                        onClick: ()=>handleCreateBackup('config', setAnchorElConfig),
                                        children: "Take config backup"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                        onClick: ()=>handleCreateBackup('billing', setAnchorElConfig),
                                        children: "Take billing backup"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.GridItem), {
                newLine: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "span",
                        children: "Metrics backups"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: "Automatic backup is currently disabled. The retention period is 7 days."
                        }),
                        sx: {
                            marginLeft: 1
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: !(0, _env.IS_CONNECT_IT) ? 'View metrics backups' : 'Not available for this deployment',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                "aria-label": "View metrics backups",
                                disabled: (0, _env.IS_CONNECT_IT),
                                onClick: ()=>window.open('/backup/metrics', '_blank'),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInNewDefault.default), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                disabled: (0, _env.IS_CONNECT_IT),
                                onClick: (e)=>handleOpen(e, setAnchorElMetrics),
                                "aria-label": "Show actions of metrics backups",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
                                open: Boolean(anchorElMetrics),
                                keepMounted: true,
                                anchorEl: anchorElMetrics,
                                onClose: ()=>handleClose(setAnchorElMetrics),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                    onClick: ()=>handleCreateBackup('metrics', setAnchorElMetrics),
                                    children: "Take metrics backup"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const BackupForm = ()=>{
    const { formState, getValues } = (0, _reactHookForm.useFormContext)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const { saving } = (0, _utils.useSettingsSelector)();
    const extS3Name = (key)=>`backup.externalS3.${key}`;
    const { backup: { externalS3 } } = getValues();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackupSettings, {}),
            !(0, _env.IS_CONNECT_IT) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "backup-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                        enabled: formState.isDirty
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "External Backup Configuration",
                        sx: classes.noMarginTop,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                name: extS3Name('takeExternalS3Backups'),
                                label: "Persist config backups in external storage",
                                tooltip: "Manual and scheduled config backups will also be sent to the external S3 storage if enabled"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: extS3Name('objectPath'),
                                required: true,
                                label: "Object path",
                                tooltip: "Bucket name or bucket name with a subpath. Example: backups or backups/edge"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: extS3Name('endpoint'),
                                required: true,
                                label: "Endpoint",
                                tooltip: "RESTful S3 endpoint without subpath. Example: https://s3.eu-north-1.amazonaws.com",
                                validators: {
                                    format: {
                                        prefixes: [
                                            'https://'
                                        ]
                                    },
                                    urlWithoutSubpath: {}
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: extS3Name('region'),
                                label: "Region",
                                tooltip: "Leave empty if not applicable"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: extS3Name('accessKeyId'),
                                label: "Access Key"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: extS3Name('secretAccessKey'),
                                label: "Secret Access Key"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                                main: {
                                    Save: {
                                        primary: true,
                                        savingState: saving,
                                        type: 'submit'
                                    }
                                },
                                secondary: {
                                    'Test Connection': {
                                        tooltip: 'Test write access to the S3 bucket',
                                        onClick: ()=>void (0, _store.Api).settingsApi.testS3Write(externalS3).then((_)=>{
                                                dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Connection to S3 bucket successful'));
                                            }).catch((error)=>{
                                                dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                                                    error,
                                                    operation: 'connect to S3 bucket'
                                                }));
                                            })
                                    }
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const SettingsForm = ()=>{
    const { formState, getValues } = (0, _reactHookForm.useFormContext)();
    const { saving, devMode } = (0, _utils.useSettingsSelector)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const routes = (0, _store.useRoutes)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                enabled: formState.isDirty
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "settings-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Settings",
                        sx: classes.noMarginTop,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Edge API log level",
                                name: "logLevel",
                                options: Object.entries((0, _utils.numericEnum)((0, _types.LogLevel))).map(([name, value])=>({
                                        name,
                                        value
                                    }))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "defaultDelay",
                                label: "Default delay",
                                required: true,
                                type: "number",
                                noNegative: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Default broadcast standard",
                                name: "defaultBroadcastStandard",
                                options: [
                                    {
                                        name: 'DVB',
                                        value: 'dvb'
                                    },
                                    {
                                        name: 'ATSC',
                                        value: 'atsc'
                                    }
                                ]
                            }),
                            !(0, _env.IS_CONNECT_IT) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                        name: "sslRedirectEnabled",
                                        label: "SSL redirection enabled",
                                        tooltip: 'Redirect from HTTP to HTTPS (if TLS is enabled)'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                        name: "ntpEnabled",
                                        label: "NTP enabled",
                                        disabled: getValues().kubernetesProvider !== (0, _types.KubernetesProvider).metal
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        name: "ntpServer",
                                        label: "NTP server",
                                        disabled: !getValues().ntpEnabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                name: "useEphemeralTunnelSenderPortsForNewAppliances",
                                label: "Use ephemeral local ports for tunnels (new appliances)",
                                tooltip: "Enabling this setting will make tunnels scale better over the available cores and can provide significant performance improvements for high traffic appliances. The tunnel data traffic will originate from ports in the ephemeral range. This setting should only be enabled when there are no firewall restrictions on source ports and there is no symmetric NAT in front of the edge appliance when it has Outputs configured on it. This setting will be applied to newly registered appliances."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        title: "Optional features",
                        children: (0, _features.getExperimentalExternalFeatures)().map((feature)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                label: feature.label,
                                name: `expFeatures.${feature.name}`
                            }, feature.name))
                    }),
                    devMode && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Experimental features",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    onClick: ()=>dispatch((0, _settingsActions.setDevMode)(false)),
                                    id: "disable-dev-mode-button",
                                    variant: "outlined",
                                    children: "Disable dev mode"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                newLine: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    onClick: ()=>void dispatch((0, _apiTokensActions.ensureOperatorToken)()),
                                    id: "ensure-operator-token-button",
                                    variant: "contained",
                                    children: "Ensure Edge operator token"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                sx: {
                                    width: '100%'
                                }
                            }),
                            (0, _features.getExperimentalDevFeatures)().map((feature)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                    label: feature.label,
                                    name: `expFeatures.${feature.name}`
                                }, feature.name)),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                    to: routes.status(),
                                    underline: "hover",
                                    children: "Status Page"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Save: {
                                primary: true,
                                savingState: saving,
                                type: 'submit'
                            }
                        }
                    })
                ]
            })
        ]
    });
};
const TlsForm = ()=>{
    const { formState } = (0, _reactHookForm.useFormContext)();
    const { savingTls } = (0, _utils.useSettingsSelector)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                enabled: formState.isDirty
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "tls-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "TLS Certificate",
                        sx: classes.noMarginTop,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "fingerprint",
                                label: "Fingerprint",
                                disabled: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "expiresAt",
                                label: "Expires at",
                                disabled: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "key",
                                label: "Private key",
                                required: true,
                                newLine: true,
                                multiline: true,
                                tooltip: "Paste the RSA or ECC private key in PEM format here"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "cert",
                                label: "Certificate",
                                required: true,
                                multiline: true,
                                tooltip: "Paste the RSA or ECC certificate in PEM format here"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Save: {
                                primary: true,
                                savingState: savingTls,
                                type: 'submit'
                            }
                        }
                    })
                ]
            })
        ]
    });
};
const CustomizationForm = ()=>{
    const { formState } = (0, _reactHookForm.useFormContext)();
    const { saving } = (0, _utils.useSettingsSelector)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                enabled: formState.isDirty
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                title: "Customization",
                sx: {
                    ...classes.noMarginBottom,
                    ...classes.noMarginTop
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        size: {
                            xs: 12,
                            lg: 6
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileInputDefault.default), {
                            label: "Login page logo",
                            name: (0, _types.ImageName).product,
                            id: "login-page-logo-file-picker"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        size: {
                            xs: 12,
                            lg: 6
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileInputDefault.default), {
                            label: "Top left logo",
                            name: (0, _types.ImageName).serviceProvider,
                            text: "Best ratio is 5:3",
                            id: "left-corner-file-picker"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        size: {
                            xs: 12,
                            lg: 6
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileInputDefault.default), {
                            label: "Favicon",
                            name: (0, _types.ImageName).favicon,
                            id: "favicon-file-picker"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "customization-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        sx: classes.noMarginTop,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "customTabTitle",
                            label: "Tab title"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Save: {
                                primary: true,
                                savingState: saving,
                                type: 'submit'
                            }
                        }
                    })
                ]
            })
        ]
    });
};
const LicenseForm = ()=>{
    const { formState } = (0, _reactHookForm.useFormContext)();
    const { saving } = (0, _utils.useSettingsSelector)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                enabled: formState.isDirty
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "licenses-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        title: "Licenses",
                        sx: classes.noMarginTop,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "zixiZecKey",
                            label: "Custom Zixi Edge Compute license",
                            helperText: "Leave empty to use the default Zixi Edge Compute license bundled with Nimbra Edge",
                            style: {
                                marginBottom: '20px'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Save: {
                                primary: true,
                                savingState: saving,
                                type: 'submit'
                            }
                        }
                    })
                ]
            })
        ]
    });
};
const AlarmsForm = ()=>{
    const { formState } = (0, _reactHookForm.useFormContext)();
    const { saving } = (0, _utils.useSettingsSelector)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                enabled: formState.isDirty
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "alarms-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Alarms",
                        sx: classes.noMarginTop,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                                label: "Nimbra 400 alarms",
                                name: "nimbra400Alarms",
                                options: [
                                    {
                                        name: 'Show all',
                                        value: 'all'
                                    },
                                    {
                                        name: 'Show only alarms for services provisioned by Nimbra Edge',
                                        value: 'edgeManagedServices'
                                    },
                                    {
                                        name: 'Hide all',
                                        value: 'none'
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                name: "alarmNotificationsEnabled",
                                label: "Show alarm notifications \u2013 Only affects new users",
                                tooltip: "Display alarm notifications in the UI. This setting is used as a default value for new users and can be overriden on a user basis in the User Profile page."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Save: {
                                primary: true,
                                savingState: saving,
                                type: 'submit'
                            }
                        }
                    })
                ]
            })
        ]
    });
};
const OidcForm = (props)=>{
    const values = props.getValues();
    props.watch('sso.oidc.enabled');
    props.watch('sso.oidc.configSource');
    const configSource = values.sso.oidc?.configSource || (0, _types.SsoConfigSource).metadata;
    const enabled = values.sso.oidc?.enabled || false;
    const { saving } = (0, _utils.useSettingsSelector)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const [redirectUrl] = (0, _react.useState)(window.location.origin + '/api/sso/oidc/callback');
    const fetchMetadataFromUrl = (url)=>{
        try {
            new URL(url);
        } catch  {
            return;
        }
        dispatch((0, _userActions.getSsoMetadataOidc)(url))?.then((metadata)=>{
            const p = metadata.payload;
            if (p) {
                props.setValue('sso.oidc.issuer', p.issuer);
                props.setValue('sso.oidc.userInfoUrl', p.userInfoUrl);
                props.setValue('sso.oidc.authorizationUrl', p.authorizationUrl);
                props.setValue('sso.oidc.tokenUrl', p.tokenUrl, {
                    shouldValidate: true
                });
            }
        });
    };
    const product = 'Edge';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
            id: "auth-provider-oidc-form",
            noValidate: true,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                    sx: classes.noMarginTop,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                            newLine: true,
                            label: "Enabled",
                            name: "sso.oidc.enabled"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            sx: {
                                mt: 1
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h2",
                                children: "Customization"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            newLine: true,
                            name: "sso.oidc.displayName",
                            label: "Display name",
                            tooltip: "The name of the provider displayed on the login button"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.oidc.displayOrder",
                            label: "Display order",
                            type: "number",
                            tooltip: "If multiple SSO providers are enabled, this determines the order in which they are displayed on the login page"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            sx: {
                                mt: 5
                            },
                            tooltip: `Map certain fields from your IdP to ${product}. Group mappings allow a user to be assigned ${product} roles based on their groups in the IdP (This applies only the first time a user logs in)`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h2",
                                sx: {
                                    mt: 1
                                },
                                children: "Claims and Mappings"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            newLine: true,
                            name: "sso.oidc.emailClaim",
                            label: "Email claim",
                            placeholder: "email",
                            tooltip: "Optional: Field in the ID token that contains the user's email address. Default: email"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.oidc.groupsClaim",
                            label: "Groups claim",
                            placeholder: "groups",
                            tooltip: "Optional: Field in the ID token that contains the user's groups. Default: groups"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                    children: "OIDC Group"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                    children: "Edge Role"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                                        children: Object.values((0, _types.Role)).map((role, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                        width: "70%",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                                            name: `sso.oidc.groupMappings[${role}]`,
                                                            hiddenLabel: true,
                                                            xl: 12,
                                                            lg: 12,
                                                            placeholder: "Group name in the identity provider"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                        width: "30%",
                                                        children: role
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            sx: {
                                mt: 5
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h2",
                                children: "Settings"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabsDefault.default), {
                                value: configSource,
                                variant: "fullWidth",
                                sx: classes.container,
                                textColor: "inherit",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                                        label: "From Metadata",
                                        value: (0, _types.SsoConfigSource).metadata,
                                        onClick: ()=>{
                                            props.setValue('sso.oidc.configSource', (0, _types.SsoConfigSource).metadata, {
                                                shouldValidate: true
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                                        label: "Enter Manually",
                                        value: (0, _types.SsoConfigSource).manual,
                                        onClick: ()=>{
                                            props.setValue('sso.oidc.configSource', (0, _types.SsoConfigSource).manual, {
                                                shouldValidate: true
                                            });
                                        }
                                    })
                                ]
                            })
                        }),
                        configSource === (0, _types.SsoConfigSource).metadata && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            newLine: true,
                            name: "sso.oidc.metadataUrl",
                            label: "Metadata URL",
                            tooltip: "The URL of the OIDC provider's configuration. URL typically ends with .well-known/openid-configuration",
                            placeholder: "https://example.com/.well-known/openid-configuration",
                            required: enabled && configSource === (0, _types.SsoConfigSource).metadata,
                            onBlur: (e)=>fetchMetadataFromUrl(e.target.value)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            newLine: true,
                            name: "sso.oidc.clientId",
                            label: "Client ID",
                            required: enabled
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.oidc.clientSecret",
                            label: "Client secret",
                            required: enabled
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.oidc.scope",
                            label: "Scope",
                            placeholder: "openid email",
                            tooltip: "Optional: Space-separated values that define the scope of the token request. It is used to request specific claims from the OIDC provider (e.g., email, groups). Default: openid email"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            newLine: true,
                            name: "sso.oidc.issuer",
                            label: "Issuer",
                            required: enabled && configSource === (0, _types.SsoConfigSource).manual,
                            disabled: configSource === (0, _types.SsoConfigSource).metadata
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.oidc.userInfoUrl",
                            label: "User info URL",
                            required: enabled && configSource === (0, _types.SsoConfigSource).manual,
                            disabled: configSource === (0, _types.SsoConfigSource).metadata
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.oidc.authorizationUrl",
                            label: "Authorization URL",
                            required: enabled && configSource === (0, _types.SsoConfigSource).manual,
                            disabled: configSource === (0, _types.SsoConfigSource).metadata
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.oidc.tokenUrl",
                            label: "Token URL",
                            required: enabled && configSource === (0, _types.SsoConfigSource).manual,
                            disabled: configSource === (0, _types.SsoConfigSource).metadata
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.GridItem), {
                            newLine: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                    fullWidth: true,
                                    label: "Callback URL",
                                    value: redirectUrl,
                                    type: "text",
                                    disabled: true
                                }),
                                navigator.clipboard && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                    sx: {
                                        marginLeft: '3px'
                                    },
                                    onClick: ()=>void navigator.clipboard.writeText(redirectUrl),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentCopyDefault.default), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            sx: {
                                mt: 5
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h2",
                                children: "Advanced Settings"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            newLine: true,
                            name: "sso.oidc.acrValues",
                            label: "ACR values",
                            tooltip: "Specifies the required authentication level or method for the user. Use this to request a stronger authentication method, such as multi-factor authentication (MFA), from the identity provider."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Select), {
                            name: "sso.oidc.prompt",
                            label: "Prompt",
                            options: [
                                {
                                    name: 'None',
                                    value: (0, _types.OidcPrompt).none
                                },
                                {
                                    name: 'Login',
                                    value: (0, _types.OidcPrompt).login
                                },
                                {
                                    name: 'Select account',
                                    value: (0, _types.OidcPrompt).select_account
                                }
                            ],
                            tooltip: 'Specifies whether the identity provider should prompt the user for re-authentication. "None" will not prompt the user, "Login" will prompt the user to login, and "Select account" will prompt the user to select an account.'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                    main: {
                        Save: {
                            primary: true,
                            savingState: saving,
                            type: 'submit'
                        }
                    }
                })
            ]
        })
    });
};
const SamlForm = (props)=>{
    const values = props.getValues();
    const enabled = values.sso.saml?.enabled || false;
    const configSource = values.sso.saml?.configSource || (0, _types.SsoConfigSource).metadata;
    props.watch('sso.saml.enabled');
    props.watch('sso.saml.configSource');
    props.watch('sso.saml.signedAuthnRequests');
    props.watch('sso.saml.signedAssertions');
    const { saving } = (0, _utils.useSettingsSelector)();
    const [redirectUrl] = (0, _react.useState)(window.location.origin + '/api/sso/saml/callback');
    const dispatch = (0, _reactRedux.useDispatch)();
    const fetchMetadataFromUrl = (url)=>{
        try {
            new URL(url);
        } catch  {
            return;
        }
        dispatch((0, _userActions.getSsoMetadataSaml)(url))?.then((metadata)=>{
            const p = metadata.payload;
            if (p) {
                props.setValue('sso.saml.loginUrl', p.loginUrl);
                props.setValue('sso.saml.certificate', p.certificate, {
                    shouldValidate: true
                });
            }
        });
    };
    const product = 'Edge';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
            id: "auth-provider-saml-form",
            noValidate: true,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                    sx: classes.noMarginTop,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                            label: "Enabled",
                            name: "sso.saml.enabled"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            sx: {
                                mt: 1
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h2",
                                children: "Customization"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            newLine: true,
                            name: "sso.saml.displayName",
                            label: "Display name",
                            tooltip: "The name of the provider displayed on the login button"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.saml.displayOrder",
                            label: "Display order",
                            type: "number",
                            tooltip: "If multiple SSO providers are enabled, this determines the order in which they are displayed on the login page"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            tooltip: `Map certain fields from your IdP to ${product}. Group mappings allow a user to be assigned ${product} roles based on their groups in the IdP (This applies only the first time a user logs in)`,
                            sx: {
                                mt: 5
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h2",
                                sx: {
                                    mt: 1
                                },
                                children: "Claims and Mappings"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            newLine: true,
                            name: "sso.saml.emailClaim",
                            label: "Email claim",
                            placeholder: "email",
                            tooltip: "Optional: Field in the SAML response that contains the user's email address. Default: email"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.saml.groupsClaim",
                            label: "Groups claim",
                            placeholder: "groups",
                            tooltip: "Optional: Field in the SAML response that contains the user's groups. Default: groups"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                    children: "SAML Group"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                    children: "Edge Role"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                                        children: Object.values((0, _types.Role)).map((role, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                        width: "70%",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                                            name: `sso.saml.groupMappings[${role}]`,
                                                            hiddenLabel: true,
                                                            xl: 12,
                                                            lg: 12,
                                                            placeholder: "Group name in the identity provider"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                        width: "30%",
                                                        children: role
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            sx: {
                                mt: 5
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h2",
                                children: "Settings"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabsDefault.default), {
                                value: configSource,
                                variant: "fullWidth",
                                sx: classes.container,
                                textColor: "inherit",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                                        label: "From Metadata",
                                        value: (0, _types.SsoConfigSource).metadata,
                                        onClick: ()=>{
                                            props.setValue('sso.saml.configSource', (0, _types.SsoConfigSource).metadata, {
                                                shouldValidate: true
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                                        label: "Enter Manually",
                                        value: (0, _types.SsoConfigSource).manual,
                                        onClick: ()=>{
                                            props.setValue('sso.saml.configSource', (0, _types.SsoConfigSource).manual, {
                                                shouldValidate: true
                                            });
                                        }
                                    })
                                ]
                            })
                        }),
                        configSource === (0, _types.SsoConfigSource).metadata && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            newLine: true,
                            name: "sso.saml.metadataUrl",
                            label: "Metadata URL",
                            tooltip: "The URL of the SAML provider's configuration. Depending on your auth provider, this URL might not be publicly accessible. If you experience issues when using this field, please use the manual configuration option instead.",
                            placeholder: "https://example.com/saml-metadata.xml",
                            required: enabled && configSource === (0, _types.SsoConfigSource).metadata,
                            onBlur: (e)=>fetchMetadataFromUrl(e.target.value)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.saml.providerId",
                            label: "Provider ID",
                            required: enabled,
                            tooltip: "The unique identifier of the SAML provider",
                            newLine: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.saml.loginUrl",
                            label: "Login URL",
                            required: enabled && configSource === (0, _types.SsoConfigSource).manual,
                            disabled: configSource === (0, _types.SsoConfigSource).metadata
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            label: "Certificate",
                            name: "sso.saml.certificate",
                            multiline: true,
                            rows: 5,
                            variant: "outlined",
                            placeholder: "Paste the SAML certificate in PEM format here",
                            required: enabled && configSource === (0, _types.SsoConfigSource).manual,
                            disabled: configSource === (0, _types.SsoConfigSource).metadata
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                        fullWidth: true,
                                        label: "Callback URL",
                                        value: redirectUrl,
                                        type: "text",
                                        disabled: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                        sx: {
                                            marginLeft: '3px'
                                        },
                                        onClick: ()=>void navigator.clipboard.writeText(redirectUrl),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentCopyDefault.default), {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            newLine: true,
                            sx: {
                                mt: 5
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h2",
                                children: "Advanced Settings"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                            newLine: true,
                            label: "Force authentication",
                            tooltip: "Force the user to re-authenticate with the IDP on every login.",
                            name: "sso.saml.forceAuthentication"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                            name: "sso.saml.acceptedClockSkewMs",
                            label: "Accepted clock skew (ms)",
                            type: "number",
                            tooltip: "Time in milliseconds of skew that is acceptable between client and server when checking `NotOnOrAfter` assertion condition validity timestamp. Setting to `-1` will disable checking entirely. Default: 0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                    main: {
                        Save: {
                            primary: true,
                            savingState: saving,
                            type: 'submit'
                        }
                    }
                })
            ]
        })
    });
};
const AuthProviderForm = (props)=>{
    const values = props.getValues();
    const [ssoTab, setSsoTab] = (0, _react.useState)(()=>{
        if (values.sso.oidc?.enabled && !values.sso.saml?.enabled) return (0, _types.SsoStrategy).oidc;
        if (!values.sso.oidc?.enabled && values.sso.saml?.enabled) return (0, _types.SsoStrategy).saml;
        return (0, _types.SsoStrategy).saml;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                sx: {
                    ...classes.noMarginBottom,
                    ...classes.noMarginTop
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabsDefault.default), {
                        value: ssoTab,
                        variant: "fullWidth",
                        sx: classes.container,
                        textColor: "inherit",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                                label: "SAML",
                                value: (0, _types.SsoStrategy).saml,
                                onClick: ()=>setSsoTab((0, _types.SsoStrategy).saml)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                                label: "OIDC",
                                value: (0, _types.SsoStrategy).oidc,
                                onClick: ()=>setSsoTab((0, _types.SsoStrategy).oidc)
                            })
                        ]
                    })
                })
            }),
            ssoTab === (0, _types.SsoStrategy).saml && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SamlForm, {
                ...props
            }),
            ssoTab === (0, _types.SsoStrategy).oidc && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OidcForm, {
                ...props
            })
        ]
    });
};
const defaultExpFeatures = Object.keys((0, _types.ExpFeatures)).reduce((a, key)=>{
    return {
        ...a,
        [key]: false
    };
}, {});
const Settings = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [{ settingsTab = "settings" }, setPageParams] = (0, _utils.usePageParams)();
    const user = (0, _utils.useUser)();
    const { settings, tls } = (0, _utils.useSettingsSelector)();
    const handleSubmit = async (values)=>{
        dispatch((0, _settingsActions.saveSettings)(values));
    };
    const handleTlsSubmit = async (values)=>{
        dispatch((0, _settingsActions.saveTls)(values));
    };
    if (user && user.role !== (0, _types.Role).super) return null;
    const globalSettingsTabs = Object.values(GlobalSettingsTabs);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Global settings",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                sx: {
                    ...classes.noMarginBottom,
                    padding: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabsDefault.default), {
                    value: settingsTab,
                    variant: "fullWidth",
                    onChange: (_, val)=>{
                        if (val === 'doc') return;
                        setPageParams({
                            settingsTab: val
                        });
                    },
                    sx: classes.container,
                    textColor: "inherit",
                    children: [
                        globalSettingsTabs.map((v)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                                label: v,
                                value: v
                            }, `tab-${v}`)),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                            label: "Documentation",
                            value: "doc",
                            component: "a",
                            href: "/docs/",
                            target: "_blank",
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInNewDefault.default), {}),
                            iconPosition: "end"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
                pending: !settings,
                children: [
                    settingsTab === "settings" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                        onSubmit: handleSubmit,
                        defaultValues: {
                            ...settings,
                            expFeatures: Object.assign({}, defaultExpFeatures, settings?.expFeatures)
                        },
                        component: SettingsForm
                    }),
                    settingsTab === "backups" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                        onSubmit: handleSubmit,
                        defaultValues: {
                            ...settings,
                            backup: Object.assign({
                                externalS3: {
                                    takeExternalS3Backups: false,
                                    accessKeyId: '',
                                    secretAccessKey: ''
                                }
                            }, settings?.backup)
                        },
                        enableReinitialize: true,
                        component: BackupForm
                    }),
                    settingsTab === "tls certificate" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                        onSubmit: handleTlsSubmit,
                        defaultValues: {
                            ...tls,
                            cert: '',
                            key: ''
                        },
                        enableReinitialize: true,
                        component: TlsForm
                    }),
                    settingsTab === "customization" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                        onSubmit: async (values)=>{
                            dispatch((0, _settingsActions.saveImages)({
                                snackbar: false
                            }));
                            await handleSubmit(values);
                        },
                        defaultValues: settings,
                        component: CustomizationForm
                    }),
                    settingsTab === "licenses" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                        onSubmit: handleSubmit,
                        defaultValues: settings,
                        component: LicenseForm
                    }),
                    settingsTab === "alarms" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                        onSubmit: handleSubmit,
                        defaultValues: settings,
                        component: AlarmsForm
                    }),
                    settingsTab === "auth provider" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                        onSubmit: handleSubmit,
                        defaultValues: (()=>{
                            // Since SSO fields are all optional, we need to make sure they are initialized to ensure a Controlled component
                            const defaultValues = {
                                oidc: {
                                    enabled: false,
                                    displayName: '',
                                    displayOrder: undefined,
                                    emailClaim: '',
                                    groupsClaim: '',
                                    groupMappings: {},
                                    configSource: (0, _types.SsoConfigSource).metadata,
                                    metadataUrl: '',
                                    clientId: '',
                                    clientSecret: '',
                                    scope: '',
                                    issuer: '',
                                    userInfoUrl: '',
                                    authorizationUrl: '',
                                    tokenUrl: '',
                                    acrValues: '',
                                    prompt: (0, _types.OidcPrompt).login
                                },
                                saml: {
                                    enabled: false,
                                    displayName: '',
                                    displayOrder: undefined,
                                    emailClaim: '',
                                    groupsClaim: '',
                                    groupMappings: {},
                                    configSource: (0, _types.SsoConfigSource).metadata,
                                    metadataUrl: '',
                                    providerId: '',
                                    loginUrl: '',
                                    certificate: '',
                                    forceAuthentication: false,
                                    signedAuthnRequests: false,
                                    signedAssertions: false,
                                    publicCertificate: '',
                                    privateKey: '',
                                    signatureAlgorithm: '',
                                    digestAlgorithm: '',
                                    acceptedClockSkewMs: 0
                                }
                            };
                            const newSettings = {
                                ...settings,
                                sso: {
                                    ...settings?.sso
                                }
                            } // Create a shallow copy of settings and sso
                            ;
                            newSettings.sso.oidc = {
                                ...defaultValues.oidc,
                                ...settings?.sso?.oidc
                            } // Merge oidc settings with defaults
                            ;
                            newSettings.sso.saml = {
                                ...defaultValues.saml,
                                ...settings?.sso?.saml
                            } // Merge saml settings with defaults
                            ;
                            return {
                                ...newSettings
                            };
                        })(),
                        component: AuthProviderForm
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Button":"3qJY9","@mui/material/Grid":"6iX4B","@mui/material/IconButton":"488As","@mui/material/Typography":"6NtGx","@mui/material/Box":"c4QkF","@mui/material/Tabs":"26Co6","@mui/material/Tab":"aDY3J","@mui/icons-material/ContentCopy":"ivEEo","@mui/icons-material/OpenInNew":"3wl83","../../env":"cPu8n","@mui/material/Table":"k4r1H","@mui/material/TableBody":"2jHBQ","@mui/material/TableCell":"6WlPV","@mui/material/TableHead":"9yKSO","@mui/material/TableRow":"bLA0R","@mui/material/TextField":"l88b4","common/api/v1/types":"3qemx","../../store":"5LXiG","../../redux/actions/settingsActions":"4RBnR","../../utils":"342UB","../../utils/features":"iOvTk","../common/Form":"4Mui7","../common/Pendable":"gDN67","../common/Wrapper":"8oy7r","../common/Link":"l3o6V","./FileInput":"3EEuH","../../redux/actions/apiTokensActions":"cgRx6","react-hook-form":"8z0aI","../../redux/actions/userActions":"2tWgd","../common/Tooltip":"crjvg","@mui/material/MenuItem":"krMs8","@mui/icons-material/HelpOutline":"2sIqE","@mui/icons-material/MoreVert":"22WtH","@mui/material/Menu":"1ut4X","../../redux/actions/notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3EEuH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _types = require("common/api/v1/types");
var _settingsActions = require("../../redux/actions/settingsActions");
var _logoFetcher = require("../common/LogoFetcher");
var _notificationActions = require("../../redux/actions/notificationActions");
var _utils = require("../../utils");
const MAX_SIZE = 1048576;
const styles = {
    toolbar: (theme)=>({
            display: 'flex',
            alignItems: 'center',
            '& > * + *': {
                marginLeft: theme.spacing(2)
            },
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                '& > * + *': {
                    marginLeft: 0,
                    marginTop: theme.spacing(2)
                }
            }
        }),
    label: {
        flexGrow: 1
    },
    container: {
        margin: (theme)=>theme.spacing(4, 0),
        padding: (theme)=>theme.spacing(2, 2),
        border: (theme)=>`1px solid ${theme.palette.text.secondary}`,
        borderRadius: (theme)=>theme.shape.borderRadius,
        display: 'flex',
        justifyContent: 'center'
    },
    button: {
        whiteSpace: 'nowrap'
    }
};
const FileBase64 = ({ onSelect, name })=>{
    const id = `${name}-file-input`;
    const onChange = ({ target })=>{
        const file = target.files && target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = ()=>{
            const fileInfo = {
                name: file.name,
                type: file.type,
                size: file.size,
                base64: reader.result,
                file: file
            };
            onSelect(fileInfo);
        };
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
        htmlFor: id,
        style: {
            width: '122px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                sx: styles.button,
                color: "primary",
                variant: "contained",
                component: "span",
                children: "Select file"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "file",
                onChange: onChange,
                multiple: false,
                id: id,
                style: {
                    display: 'none'
                },
                accept: ".jpg, .png, .jpeg, .ico, .svg"
            })
        ]
    });
};
const FileInput = ({ name, label, text = '', id })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const settings = (0, _utils.useSettingsSelector)();
    const image = settings[name];
    const onSelect = (file)=>{
        if (file.size > MAX_SIZE) {
            dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                error: {
                    errorInfo: {
                        errorCode: '',
                        fatal: false,
                        text: 'File size is too large',
                        details: '',
                        origin: undefined
                    }
                }
            }));
            return;
        }
        dispatch((0, _settingsActions.setImage)({
            name,
            file
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
        margin: "normal",
        fullWidth: true,
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: styles.toolbar,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: styles.label,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h4",
                                children: label
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "body2",
                                color: "textSecondary",
                                children: `Max size is ${MAX_SIZE / 1024 / 1024} MB. ${text}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FileBase64, {
                        name: name,
                        onSelect: onSelect
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        sx: styles.button,
                        variant: "outlined",
                        onClick: ()=>dispatch((0, _settingsActions.setImageToDelete)(name)),
                        "data-test-id": `${id}-reset`,
                        children: "Restore default"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: styles.container,
                children: name === (0, _types.ImageName).serviceProvider ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoFetcher.TopLeftLogo), {
                    image: image?.base64,
                    isDraft: true
                }) : name === (0, _types.ImageName).product ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoFetcher.LoginLogo), {
                    image: image?.base64,
                    isDraft: true
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoFetcher.FaviconLogo), {
                    image: image?.base64,
                    isDraft: true
                })
            })
        ]
    });
};
exports.default = FileInput;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/FormControl":"ioFZ4","@mui/material/Typography":"6NtGx","common/api/v1/types":"3qemx","../../redux/actions/settingsActions":"4RBnR","../common/LogoFetcher":"e3yqy","../../redux/actions/notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cgRx6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensureOperatorToken", ()=>ensureOperatorToken);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
const ensureOperatorToken = (0, _toolkit.createAsyncThunk)('apiTokens/ensureOperatorToken', async (_, { dispatch, extra: { api } })=>{
    try {
        await api.apiTokensApi.ensureOperatorToken();
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)('Successfully ensured the Edge Operator token. You can now proceed and install the Edge Operator.'));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update tls settings'
        }));
    }
});

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"88QQ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Status", ()=>Status);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _notFound = require("../common/NotFound");
var _list = require("./List");
const Status = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.StatusList), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../common/NotFound":"1Msr5","./List":"cT3V1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cT3V1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusList", ()=>StatusList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _fiberManualRecord = require("@mui/icons-material/FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _store = require("../../store");
var _notificationActions = require("../../redux/actions/notificationActions");
const StatusIndicator = (status)=>{
    switch(status){
        case 'OK':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: {
                    color: (theme)=>theme.palette.success.main
                }
            });
        case 'WARN':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: {
                    color: (theme)=>theme.palette.warning.main
                }
            });
        case 'ERROR':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: {
                    color: (theme)=>theme.palette.error.main
                }
            });
        default:
            throw new Error('unreachable');
    }
};
const StatusList = ()=>{
    const [status, setStatus] = (0, _react.useState)(null);
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        const listStatus = async ()=>{
            try {
                const status = await (0, _store.Api).statusApi.listStatus();
                setStatus(status);
            } catch (e) {
                dispatch((0, _notificationActions.enqueueErrorSnackbar)({
                    error: e,
                    operation: 'list status'
                }));
            }
        };
        listStatus();
    }, [
        dispatch
    ]);
    const tableConfig = [
        {
            title: 'name',
            getValue: ({ name, description })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        display: 'flex',
                        whiteSpace: 'nowrap'
                    },
                    children: [
                        name,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: description,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                                sx: {
                                    marginLeft: 1
                                }
                            })
                        })
                    ]
                })
        },
        {
            title: 'status',
            getValue: ({ status })=>StatusIndicator(status)
        },
        {
            title: 'issues',
            getValue: ({ issues })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: {
                        whiteSpace: 'nowrap'
                    },
                    children: issues?.map((issue)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            children: JSON.stringify(issue)
                        }, issue.name);
                    })
                })
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: "Status",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
            emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                message: "No status available"
            }),
            config: tableConfig,
            data: status?.items ?? [],
            pending: status === null
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/Box":"c4QkF","../common/Tooltip":"crjvg","@mui/icons-material/FiberManualRecord":"bvXIN","@mui/icons-material/HelpOutline":"2sIqE","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../../store":"5LXiG","../../redux/actions/notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"exGSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressMappings", ()=>AddressMappings);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _edit = require("./Edit");
var _list = require("./List");
const AddressMappings = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "update/:region/:privateIp",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).NEW,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.ListView), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","./Edit":"7sE40","./List":"6wpv5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7sE40":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _form = require("../common/Form");
var _types = require("common/api/v1/types");
var _store = require("../../store");
var _pendable = require("../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _addressMappingActions = require("../../redux/actions/addressMappingActions");
var _utils = require("../../utils");
var _util = require("common/util");
const { regionApi } = (0, _store.Api);
const getInitialState = (ipMapping, chosenRegion)=>{
    const region = chosenRegion ? chosenRegion : {
        id: '',
        name: ''
    };
    return ipMapping || {
        privateIp: '',
        publicIp: '',
        internalIp: '',
        interRegionIp: '',
        region,
        type: (0, _types.IpMappingType).suggested,
        nics: []
    };
};
const MappingForm = (props, navigate)=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const values = props.getValues();
    const routes = (0, _store.useRoutes)();
    const { ipMapping } = (0, _reactRedux.useSelector)(({ addressMappingReducer })=>({
            ipMapping: addressMappingReducer.ipMapping,
            loading: addressMappingReducer.loading
        }), (0, _util.equals));
    const warnAboutServiceDisruptions = (callback)=>{
        showConfirmation(()=>void callback(), `This action could potentially disrupt related services that are currently active. Are you sure you want to proceed?`);
    };
    const isEditing = !!ipMapping;
    const nicIdentityString = (n)=>`${n.name} on ${n.appliance.name}`;
    const identity = ipMapping?.nics ? `(${ipMapping.nics.map(nicIdentityString).join(', ')})` : '';
    const api = (0, _react.useCallback)(regionApi.getRegions.bind(regionApi), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        container: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            size: {
                xs: 12
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                    formState: props.formState
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                    id: "user-form",
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                            title: values.privateIp ? `Address mappings for ${values.privateIp} ${identity}` : 'Create address mapping',
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Autocomplete), {
                                    name: "region",
                                    required: true,
                                    disabled: isEditing,
                                    api: api,
                                    defaultOption: isEditing ? values.region : undefined,
                                    getOptionLabel: (option)=>option.name,
                                    getOptionValue: (option)=>option,
                                    optionComparator: (o1, o2)=>o1.id === o2.id
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                    name: "privateIp",
                                    required: true,
                                    validators: {
                                        ip: {}
                                    },
                                    label: "Private address",
                                    disabled: isEditing,
                                    tooltip: "Private address of the interface (used if no other address is configured)."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                    name: "publicIp",
                                    label: "Public address",
                                    required: false,
                                    validators: {
                                        ip: {}
                                    },
                                    tooltip: "Used by appliances connecting from outside the cluster. Can be a NATed address or set to the private address."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                    name: "internalIp",
                                    label: "Internal address",
                                    validators: {
                                        ip: {}
                                    },
                                    tooltip: "Used by thumb nodes in the same region."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                    name: "interRegionIp",
                                    label: "Inter region address",
                                    validators: {
                                        ip: {}
                                    },
                                    tooltip: "Used by video nodes in other regions."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                            main: {
                                Cancel: {
                                    onClick: ()=>{
                                        navigate(routes.addressMappings());
                                    }
                                },
                                Save: {
                                    savingState: false,
                                    primary: true,
                                    onClick: ()=>warnAboutServiceDisruptions(()=>props.submitForm())
                                }
                            },
                            secondary: values.privateIp && isEditing ? {
                                'Remove mapping': {
                                    onClick: ()=>warnAboutServiceDisruptions(()=>dispatch((0, _addressMappingActions.removeIpMapping)((0, _addressMappingActions.writeModelFromReadModel)(values)))),
                                    disabled: values.type === (0, _types.IpMappingType).suggested,
                                    tooltip: values.type === (0, _types.IpMappingType).suggested ? "This is an unmapped address which can't be removed" : undefined
                                }
                            } : undefined
                        })
                    ]
                })
            ]
        })
    });
};
const Edit = ()=>{
    const { privateIp, region } = (0, _reactRouter.useParams)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const ipMapping = (0, _reactRedux.useSelector)(({ addressMappingReducer })=>addressMappingReducer.ipMapping, (0, _util.equals));
    const { regions, loading } = (0, _utils.useRegionsSelector)({
        rowsPerPage: '100',
        pageNumber: '0'
    });
    const chosenRegion = ipMapping?.region || (regions.length === 1 ? regions[0] : undefined);
    const onSubmit = (editedIpMapping)=>{
        if (ipMapping) dispatch((0, _addressMappingActions.updateIpMapping)(editedIpMapping));
        else dispatch((0, _addressMappingActions.createIpMapping)(editedIpMapping));
    };
    (0, _react.useEffect)(()=>{
        privateIp && region && dispatch((0, _addressMappingActions.getIpMapping)({
            privateIp,
            region
        }));
        return ()=>{
            dispatch((0, _addressMappingActions.clearEditMapping)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Address mappings',
            privateIp ? ipMapping?.privateIp : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: loading || !!privateIp && !ipMapping,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                onSubmit: (values)=>{
                    onSubmit((0, _addressMappingActions.writeModelFromReadModel)(values));
                },
                defaultValues: getInitialState(ipMapping, chosenRegion),
                component: (props)=>MappingForm(props, navigate)
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","@mui/material/Grid":"6iX4B","../common/Form":"4Mui7","common/api/v1/types":"3qemx","../../store":"5LXiG","../common/Pendable":"gDN67","../common/Wrapper":"8oy7r","../../redux/actions/addressMappingActions":"aRUIy","../../utils":"342UB","common/util":"jV4UZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6wpv5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListView", ()=>ListView);
var _jsxRuntime = require("react/jsx-runtime");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _types = require("common/api/v1/types");
var _link = require("../common/Link");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _utils = require("../../utils");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _listAddressMappingFilter = require("./listAddressMappingFilter");
var _store = require("../../store");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _actionMenu = require("../common/Table/ActionMenu");
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _reactRedux = require("react-redux");
var _addressMappingActions = require("../../redux/actions/addressMappingActions");
const ListView = ()=>{
    const routes = (0, _store.useRoutes)();
    const { ipMappings, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useAddressMappingSelector));
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const tableConfig = [
        {
            title: 'region',
            getValue: ({ region })=>region && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.regionsUpdate({
                        id: region.id
                    }),
                    underline: "hover",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body2",
                        color: "textSecondary",
                        children: region.name
                    })
                }) || null,
            sorting: {
                byParameter: (0, _types.ListIpMappingSortableField).regionName
            }
        },
        {
            title: 'appliance',
            getValue: ({ nics })=>nics.map((n)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                        to: routes.appliancesUpdate({
                            id: n.appliance.id
                        }),
                        underline: "hover",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "body2",
                            color: "textSecondary",
                            children: n.appliance.name
                        })
                    }, n.appliance.id)) || null,
            sorting: {
                byParameter: (0, _types.ListIpMappingSortableField).applianceName
            }
        },
        {
            title: 'interface',
            getValue: (mapping)=>mapping.nics.map((n)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body2",
                        color: "textSecondary",
                        children: n.name
                    }, n.id)) || null,
            sorting: {
                byParameter: (0, _types.ListIpMappingSortableField).interfaceName
            }
        },
        {
            title: 'private address',
            getValue: ({ privateIp, type })=>privateIp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    color: type === (0, _types.IpMappingType).suggested ? 'textSecondary' : 'textPrimary',
                    children: privateIp
                }) || null,
            sorting: {
                byParameter: (0, _types.ListIpMappingSortableField).privateAddress
            }
        },
        {
            title: 'public address',
            getValue: ({ publicIp })=>publicIp,
            sorting: {
                byParameter: (0, _types.ListIpMappingSortableField).publicAddress
            }
        },
        {
            title: 'internal address',
            getValue: ({ internalIp })=>internalIp,
            sorting: {
                byParameter: (0, _types.ListIpMappingSortableField).internalAddress
            }
        },
        {
            title: 'inter region address',
            getValue: ({ interRegionIp })=>interRegionIp,
            sorting: {
                byParameter: (0, _types.ListIpMappingSortableField).interRegionAddress
            }
        },
        {
            getValue: (mapping)=>mapping.type === (0, _types.IpMappingType).suggested ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.addressMappingsUpdate({
                        privateIp: mapping.privateIp,
                        region: mapping.region.id
                    }),
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                        "data-test-id": "edit-mapping",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {})
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    options: [
                        {
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                            label: 'Edit',
                            href: routes.addressMappingsUpdate({
                                region: mapping.region?.id,
                                privateIp: mapping.privateIp
                            }),
                            openInNewTab: false
                        },
                        {
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                            label: 'Remove',
                            isDestructive: true,
                            onClick: ()=>{
                                showConfirmation(()=>dispatch((0, _addressMappingActions.removeIpMapping)((0, _addressMappingActions.writeModelFromReadModel)(mapping))), `This action could potentially disrupt related services that are currently active. Are you sure you want to proceed?`);
                            }
                        }
                    ]
                }),
            props: {
                align: 'right',
                noTypography: true
            }
        }
    ];
    const filters = (0, _listAddressMappingFilter.makeListAddressMappingsFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Address mappings",
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
            id: "mappings-table-create-button",
            to: routes.addressMappingsNew(),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "contained",
                color: "primary",
                children: "Add mapping"
            })
        }, "addMapping"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'addressMappings',
                        mapUrlParamToFilterFn: (0, _listAddressMappingFilter.mapUrlParamToAddressMappingFilter),
                        mapFilterToUrlParamFn: (0, _listAddressMappingFilter.mapAddressMappingFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listAddressMappingFilter.ListAddressMappingFilterKey).search)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                id: "mappings",
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No addresses to map"
                }),
                config: tableConfig,
                data: ipMappings,
                pending: loading
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/IconButton":"488As","@mui/material/Typography":"6NtGx","@mui/material/Button":"3qJY9","@mui/icons-material/Add":"jrNj7","common/api/v1/types":"3qemx","../common/Link":"l3o6V","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../../utils":"342UB","@mui/material/Toolbar":"5Kohb","./listAddressMappingFilter":"jH1uf","../../store":"5LXiG","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","../common/Table/ActionMenu":"jf6As","@mui/icons-material/Settings":"jkTfg","@mui/icons-material/Delete":"69aC7","react-redux":"l1pMU","../../redux/actions/addressMappingActions":"aRUIy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jH1uf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAddressMappingFilterKey", ()=>ListAddressMappingFilterKey);
parcelHelpers.export(exports, "mapAddressMappingFilterToUrlParam", ()=>mapAddressMappingFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToAddressMappingFilter", ()=>mapUrlParamToAddressMappingFilter);
parcelHelpers.export(exports, "makeListAddressMappingsFilter", ()=>makeListAddressMappingsFilter);
var ListAddressMappingFilterKey = /*#__PURE__*/ function(ListAddressMappingFilterKey) {
    ListAddressMappingFilterKey["search"] = "search phrase";
    return ListAddressMappingFilterKey;
}({});
function mapAddressMappingFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "search phrase":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToAddressMappingFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "search phrase",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListAddressMappingsFilter() {
    const filterTemplates = [
        {
            key: "search phrase",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6sLRr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UsageReport", ()=>UsageReport);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _notFound = require("../common/NotFound");
var _report = require("./Report");
var _reportDefault = parcelHelpers.interopDefault(_report);
const UsageReport = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../common/NotFound":"1Msr5","./Report":"jS1HW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jS1HW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _dateFns = require("date-fns");
var _form = require("../../common/Form");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _filter = require("./Filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _total = require("./Total");
var _totalDefault = parcelHelpers.interopDefault(_total);
var _details = require("./Details");
var _detailsDefault = parcelHelpers.interopDefault(_details);
var _helpers = require("common/api/v1/helpers");
var _usageActions = require("../../../redux/actions/usageActions");
var _utils = require("../../../utils");
const Report = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [pageParams] = (0, _utils.usePageParams)();
    const { startDate, endDate, rowsPerPage, pageNumber, type } = pageParams;
    const { usage, loading, error } = (0, _reactRedux.useSelector)(({ usageReducer })=>({
            usage: usageReducer.usage,
            loading: usageReducer.loading,
            error: usageReducer.error
        }), (0, _reactRedux.shallowEqual));
    (0, _react.useEffect)(()=>{
        const params = {
            ...(0, _utils.withDefaultPagination)(pageParams),
            startDate: startDate ? (0, _dateFns.parseISO)(startDate) : (0, _helpers.startOfMonthUTC)(new Date()),
            endDate: endDate ? (0, _dateFns.parseISO)(endDate) : (0, _helpers.endOfDayUTC)(new Date()),
            type: type
        };
        dispatch((0, _usageActions.readUsage)(params));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        startDate,
        endDate,
        type,
        rowsPerPage,
        pageNumber,
        dispatch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Usage",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                title: "Filter",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterDefault.default), {})
            }),
            !error ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        title: "Total",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _totalDefault.default), {
                            usage: usage,
                            loading: loading
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                        title: "Details",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailsDefault.default), {
                            usage: usage,
                            loading: loading
                        })
                    })
                ]
            }) : 'Failed to load usage data'
        ]
    });
};
exports.default = Report;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","date-fns":"gelMX","../../common/Form":"4Mui7","../../common/Wrapper":"8oy7r","./Filter":"dfar0","./Total":"aqiUy","./Details":"a6Lb2","common/api/v1/helpers":"6jovr","../../../redux/actions/usageActions":"6CX5c","../../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dfar0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _getApp = require("@mui/icons-material/GetApp");
var _getAppDefault = parcelHelpers.interopDefault(_getApp);
var _xDatePickers = require("@mui/x-date-pickers");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _dateFns = require("date-fns");
var _routes = require("../../../utils/routes");
var _utils = require("../../../utils");
var _helpers = require("common/api/v1/helpers");
var _select = require("../../common/Filters/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _filters = require("../../common/Filters");
const styles = {
    buttonContainer: {
        margin: '0 0 0 auto'
    },
    input: {
        marginRight: 2
    },
    buttonText: (theme)=>({
            [theme.breakpoints.down('xs')]: {
                display: 'none'
            }
        }),
    icon: (theme)=>({
            marginLeft: theme.spacing(1),
            [theme.breakpoints.down('xs')]: {
                marginLeft: 0
            }
        })
};
var DateField = /*#__PURE__*/ function(DateField) {
    DateField["startDate"] = "startDate";
    DateField["endDate"] = "endDate";
    return DateField;
}(DateField || {});
const getRequestParams = (from, to)=>({
        ["startDate"]: from,
        ["endDate"]: to
    });
const UsageFilter = ()=>{
    const [pageParams, setPageParams] = (0, _utils.usePageParams)();
    const [openFrom, setOpenFrom] = (0, _react.useState)(false);
    const [openTo, setOpenTo] = (0, _react.useState)(false);
    const { startDate, endDate, type } = pageParams;
    const from = startDate ? (0, _dateFns.parseISO)(startDate) : (0, _helpers.startOfMonthUTC)(new Date());
    const to = endDate ? (0, _dateFns.parseISO)(endDate) : (0, _helpers.endOfDayUTC)(new Date());
    const setDate = (dateField, value)=>{
        if (!value || !value.getTime()) return;
        const params = {
            ["startDate"]: dateField === "startDate" ? (0, _helpers.startOfDayUTC)(value).toISOString() : startDate,
            ["endDate"]: dateField === "endDate" ? (0, _helpers.endOfDayUTC)(value).toISOString() : endDate,
            pageNumber: '0'
        };
        setPageParams(params);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _xDatePickers.LocalizationProvider), {
                    dateAdapter: (0, _adapterDateFns.AdapterDateFns),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
                            open: openFrom,
                            onOpen: ()=>setOpenFrom(true),
                            onClose: ()=>setOpenFrom(false),
                            label: "From date:",
                            format: "yyyy MMM dd",
                            value: (0, _helpers.startOfDayUTC)(from),
                            onChange: (value)=>setDate("startDate", value),
                            minDate: new Date('2020-01-01'),
                            maxDate: to,
                            disableFuture: true,
                            slotProps: {
                                textField: {
                                    variant: 'standard',
                                    onClick: ()=>setOpenFrom(true)
                                }
                            },
                            sx: styles.input
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
                            open: openTo,
                            onOpen: ()=>setOpenTo(true),
                            onClose: ()=>setOpenTo(false),
                            label: "To date:",
                            format: "yyyy MMM dd",
                            value: (0, _helpers.startOfDayUTC)(to),
                            onChange: (value)=>setDate("endDate", value),
                            minDate: from,
                            maxDate: new Date(),
                            disableFuture: true,
                            slotProps: {
                                textField: {
                                    variant: 'standard',
                                    onClick: ()=>setOpenTo(true)
                                }
                            },
                            sx: styles.input
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                    type: (0, _filters.FilterType).select,
                    paramName: 'type',
                    label: 'Type',
                    options: [
                        {
                            name: 'Ingress',
                            value: 'ingress'
                        },
                        {
                            name: 'Egress',
                            value: 'egress'
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                sx: styles.buttonContainer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    underline: "none",
                    href: (0, _routes.api).usage({
                        ...getRequestParams(from, to),
                        format: 'csv',
                        type: type,
                        rowsPerPage: '1',
                        pageNumber: '0'
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
                        variant: "outlined",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                sx: styles.buttonText,
                                children: "Download"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _getAppDefault.default), {
                                sx: styles.icon
                            })
                        ]
                    })
                })
            })
        ]
    });
};
exports.default = UsageFilter;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Grid":"6iX4B","@mui/material/Link":"chNUC","@mui/icons-material/GetApp":"8q9m0","@mui/x-date-pickers":"gSoHo","@mui/x-date-pickers/AdapterDateFns":"bSwsg","date-fns":"gelMX","../../../utils/routes":"cqMGU","../../../utils":"342UB","common/api/v1/helpers":"6jovr","../../common/Filters/Select":"cxYtc","../../common/Filters":"5hY8D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aqiUy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _numericalDataSet = require("../../common/NumericalDataSet");
var _numericalDataSetDefault = parcelHelpers.interopDefault(_numericalDataSet);
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _helpers = require("common/api/v1/helpers");
const styles = {
    wrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    }
};
const Total = ({ usage, loading })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
        pending: loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
            sx: styles.wrapper,
            children: usage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _numericalDataSetDefault.default), {
                values: [
                    {
                        title: 'Ingress transferred data',
                        value: (0, _helpers.getTransferredString)(usage.ingressTrafficGB)
                    },
                    {
                        title: 'Egress transferred data',
                        value: (0, _helpers.getTransferredString)(usage.egressTrafficGB)
                    }
                ]
            })
        })
    });
};
exports.default = Total;

},{"react/jsx-runtime":"1dlk8","@mui/material/Grid":"6iX4B","../../common/NumericalDataSet":"4YSqy","../../common/Pendable":"gDN67","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6Lb2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _table = require("../../common/Table");
var _helpers = require("common/api/v1/helpers");
const formatDateTime = (d)=>{
    return d.toISOString().substring(0, 19).replace('T', ' ');
};
const tableConfig = [
    {
        title: 'Start date (UTC)',
        getValue: ({ startDate })=>formatDateTime(startDate),
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'End date (UTC)',
        getValue: ({ endDate })=>endDate && formatDateTime(endDate) || '',
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Type',
        getValue: ({ type })=>type
    },
    {
        title: 'Input',
        getValue: ({ inputName })=>inputName,
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Input ID',
        getValue: ({ inputId })=>inputId,
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Input group',
        getValue: ({ inputGroup })=>inputGroup,
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Input appliance',
        getValue: ({ inputApplianceName })=>inputApplianceName,
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Input secondary appliance',
        getValue: ({ inputSecondaryApplianceName })=>inputSecondaryApplianceName || '',
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Input secondary appliance region',
        getValue: ({ inputSecondaryApplianceRegion })=>inputSecondaryApplianceRegion || ''
    },
    {
        title: 'Input region',
        getValue: ({ inputRegion })=>inputRegion
    },
    {
        title: 'Input SMPTE 2022-7 enabled',
        getValue: ({ inputIsSmpte_2022_7_Enabled })=>inputIsSmpte_2022_7_Enabled?.toString()
    },
    {
        title: 'Input Redundancy',
        getValue: ({ inputRedundancyEnabled })=>inputRedundancyEnabled?.toString()
    },
    {
        title: 'Input protocol',
        getValue: ({ inputProtocol })=>inputProtocol
    },
    {
        title: 'Programs',
        getValue: ({ inputServiceCount })=>inputServiceCount?.toString()
    },
    {
        title: 'Output',
        getValue: ({ outputName })=>outputName,
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Output ID',
        getValue: ({ outputId })=>outputId,
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Output group',
        getValue: ({ outputGroup })=>outputGroup,
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Output appliance',
        getValue: ({ outputApplianceName })=>outputApplianceName,
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Output region',
        getValue: ({ outputRegion })=>outputRegion
    },
    {
        title: 'Output SMPTE 2022-7 enabled',
        getValue: ({ outputIsSmpte_2022_7_Enabled })=>outputIsSmpte_2022_7_Enabled?.toString()
    },
    {
        title: 'Output Redundancy',
        getValue: ({ outputRedundancyEnabled })=>outputRedundancyEnabled?.toString()
    },
    {
        title: 'Output protocol',
        getValue: ({ outputProtocol })=>outputProtocol
    },
    {
        title: 'Ingress Data Transfer',
        getValue: ({ ingressTrafficGB })=>(0, _helpers.getTransferredString)(ingressTrafficGB),
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    },
    {
        title: 'Egress Data Transfer',
        getValue: ({ egressTrafficGB })=>(0, _helpers.getTransferredString)(egressTrafficGB),
        props: {
            style: {
                whiteSpace: 'nowrap'
            }
        }
    }
];
const Details = ({ usage, loading })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        style: {
            maxWidth: '100%'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
            emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "No usage details"
            }),
            props: {
                size: 'small'
            },
            config: tableConfig,
            data: usage?.details || [],
            pending: loading,
            pagination: {
                total: usage?.total || 0,
                useUrlSearchParams: true
            },
            isSmall: true
        })
    });
exports.default = Details;

},{"react/jsx-runtime":"1dlk8","@mui/material/Grid":"6iX4B","../../common/Table":"dt9lf","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"18S2x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nodes", ()=>Nodes);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _notFound = require("../common/NotFound");
var _list = require("./List");
var _edit = require("./Edit");
const Nodes = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.List), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "update/:regionId/node/:name",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../common/NotFound":"1Msr5","./List":"4MpUR","./Edit":"aXFY7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4MpUR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "List", ()=>List);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _utils = require("../../../utils");
var _table = require("../../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../../common/MissingContent");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../../common/Link");
var _notificationActions = require("../../../redux/actions/notificationActions");
var _k8SActions = require("../../../redux/actions/k8sActions");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _listK8SNodesFilter = require("./listK8sNodesFilter");
var _store = require("../../../store");
var _filteredSearchBar = require("../../common/Filters/FilterView/FilteredSearchBar");
function CircularProgressWithLabel(props) {
    const theme = (0, _styles.useTheme)();
    let styles = {};
    if (props.value > 90) styles = {
        color: theme.palette.error.main
    };
    else if (props.value > 75) styles = {
        color: theme.palette.warning.main
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        position: "relative",
        display: "inline-flex",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                variant: "determinate",
                value: props.value,
                style: styles
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "caption",
                    component: "div",
                    color: "textSecondary",
                    children: `${Math.round(props.value)}%`
                })
            })
        ]
    });
}
const List = ()=>{
    const { kubernetesNodes, total, loading: loadingNodes, errors } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useKubernetesNodesSelector));
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const { resourceUsage, loadingResourceUsage } = (0, _reactRedux.useSelector)(({ k8sReducer })=>({
            resourceUsage: k8sReducer.resourceUsage,
            loadingResourceUsage: k8sReducer.loadingResourceUsage
        }), (0, _reactRedux.shallowEqual));
    (0, _react.useEffect)(()=>{
        if (errors) {
            const details = errors.map((e)=>e.message).join('\n');
            const text = 'Failed to fetch nodes';
            dispatch((0, _notificationActions.enqueueSnackbar)({
                type: 'fatalError',
                options: {
                    variant: 'error',
                    persist: true
                },
                data: {
                    text,
                    details,
                    httpStatusCode: undefined
                }
            }));
        }
    }, [
        errors
    ]);
    (0, _react.useEffect)(()=>{
        function doRefresh() {
            dispatch((0, _k8SActions.getResourceUsage)());
        }
        doRefresh();
        const timerId = setInterval(doRefresh, 30000);
        return function stopRefresh() {
            clearInterval(timerId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getRolesString = (node)=>{
        return node.roles.join(', ');
    };
    const tableConfig = [
        {
            title: 'name',
            getValue: (node)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.kubernetesNodesUpdate({
                        regionId: node.region.id,
                        name: node.name
                    }),
                    underline: "hover",
                    children: node.name
                }),
            sorting: {
                byParameter: 'name'
            }
        },
        {
            title: 'region',
            getValue: ({ region })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.regionsUpdate({
                        id: region.id
                    }),
                    underline: "hover",
                    children: region.name
                }),
            sorting: {
                byParameter: 'region'
            }
        },
        {
            title: 'CPU',
            getValue: ({ name, region })=>{
                if (loadingResourceUsage) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {});
                const nodeResourceUsage = resourceUsage.find((node)=>node.name === name && node.region === region.id);
                return nodeResourceUsage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressWithLabel, {
                    value: nodeResourceUsage.cpu.usage / nodeResourceUsage.cpu.capacity * 100
                }) : 'N/A';
            },
            props: {
                noTypography: true
            }
        },
        {
            title: 'Memory',
            getValue: ({ name, region })=>{
                if (loadingResourceUsage) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {});
                const nodeResourceUsage = resourceUsage.find((node)=>node.name === name && node.region === region.id);
                return nodeResourceUsage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressWithLabel, {
                    value: nodeResourceUsage.memory.usage / nodeResourceUsage.memory.capacity * 100
                }) : 'N/A';
            },
            props: {
                noTypography: true
            }
        },
        {
            title: 'status',
            getValue: (node)=>node.status,
            sorting: {
                byParameter: 'status'
            }
        },
        {
            title: 'internal IP',
            getValue: (node)=>node.internalIP
        },
        {
            title: 'external IP',
            getValue: (node)=>node.externalIP
        },
        {
            title: 'kubelet version',
            getValue: (node)=>node.kubeletVersion
        },
        {
            title: 'roles',
            getValue: (node)=>getRolesString(node)
        },
        {
            title: 'actions',
            getValue: (node)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: [
                        {
                            name: 'Edit',
                            button: undefined,
                            onClick: undefined,
                            link: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                to: routes.kubernetesNodesUpdate({
                                    regionId: node.region.id,
                                    name: node.name
                                }),
                                tabIndex: -1,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                    edge: "end",
                                    "data-test-id": "edit-node",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {})
                                })
                            })
                        }
                    ].map(({ name, button, link, onClick = ()=>false })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: name,
                            placement: "top",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: button ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                    "data-test-id": 'edit-node',
                                    edge: "end",
                                    "aria-label": name,
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        onClick();
                                    },
                                    children: button
                                }) : link
                            })
                        }, node.name))
                });
            },
            props: {
                noTypography: true
            }
        }
    ];
    const filters = (0, _listK8SNodesFilter.makeListK8sNodesFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Kubernetes nodes",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'k8sNodes',
                        mapUrlParamToFilterFn: (0, _listK8SNodesFilter.mapUrlParamToK8sNodeFilter),
                        mapFilterToUrlParamFn: (0, _listK8SNodesFilter.mapK8sNodeFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listK8SNodesFilter.ListK8sNodesFilterKey).search)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                id: "nodes-table",
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No kubernetes nodes available"
                }),
                config: tableConfig,
                data: kubernetesNodes,
                pending: loadingNodes,
                pagination: {
                    total,
                    useUrlSearchParams: true
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/IconButton":"488As","@mui/icons-material/Settings":"jkTfg","../../common/Tooltip":"crjvg","@mui/material/CircularProgress":"kEtIR","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","@mui/material/styles":"2UrBk","../../../utils":"342UB","../../common/Table":"dt9lf","../../common/MissingContent":"1LBl6","../../common/Wrapper":"8oy7r","../../common/Link":"l3o6V","../../../redux/actions/notificationActions":"7LkQg","../../../redux/actions/k8sActions":"lYa8m","@mui/material/Toolbar":"5Kohb","./listK8sNodesFilter":"gJIUU","../../../store":"5LXiG","../../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gJIUU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListK8sNodesFilterKey", ()=>ListK8sNodesFilterKey);
parcelHelpers.export(exports, "mapK8sNodeFilterToUrlParam", ()=>mapK8sNodeFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToK8sNodeFilter", ()=>mapUrlParamToK8sNodeFilter);
parcelHelpers.export(exports, "makeListK8sNodesFilter", ()=>makeListK8sNodesFilter);
var ListK8sNodesFilterKey = /*#__PURE__*/ function(ListK8sNodesFilterKey) {
    ListK8sNodesFilterKey["name"] = "name";
    ListK8sNodesFilterKey["search"] = "search phrase";
    return ListK8sNodesFilterKey;
}({});
function mapK8sNodeFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                name: filter.value
            };
        case "search phrase":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToK8sNodeFilter(key, value) {
    switch(key){
        case 'name':
            return {
                key: "name",
                operator: 'matches',
                value
            };
        case 'filter':
            return {
                key: "search phrase",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListK8sNodesFilter() {
    const filterTemplates = [
        {
            key: "search phrase",
            operator: 'matches'
        },
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aXFY7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _k8SActions = require("../../../redux/actions/k8sActions");
var _form = require("../../common/Form");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _utils = require("../../../utils");
var _types = require("common/api/v1/types");
var _labels = require("common/k8s/labels");
var _meta = require("./meta");
var _metaDefault = parcelHelpers.interopDefault(_meta);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _store = require("../../../store");
const getInitialState = (n)=>(0, _mergeDefault.default)({
        name: '',
        status: '',
        externalIP: '',
        internalIP: '',
        hostname: '',
        roles: [],
        roleCore: n?.roles.includes((0, _labels.KubernetesRoles).core) || false,
        roleVideo: n?.roles.includes((0, _labels.KubernetesRoles).video) || false,
        roleVideoStandby: n?.roles.includes((0, _labels.KubernetesRoles).video_standby) || false,
        roleThumb: n?.roles.includes((0, _labels.KubernetesRoles).thumb) || false,
        roleEdgeConnect: n?.roles.includes((0, _labels.KubernetesRoles).edge_connect) || false,
        roleLoadSimulator: n?.roles.includes((0, _labels.KubernetesRoles).load_simulator) || false,
        kubeletVersion: '',
        region: {
            id: '',
            name: '',
            external: (0, _types.ExternalRegionMode).externalK8s
        }
    }, n);
const Edit = ()=>{
    const { regionId, name } = (0, _reactRouter.useParams)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _k8SActions.getKubernetesNode)({
            regionId: regionId,
            name: name
        }));
        return ()=>{
            dispatch((0, _k8SActions.clearKubernetesNode)());
        };
    }, [
        dispatch,
        name,
        regionId
    ]);
    const { node, loading } = (0, _reactRedux.useSelector)(({ k8sReducer })=>({
            node: k8sReducer.kubernetesNode,
            loading: k8sReducer.loading
        }), (0, _reactRedux.shallowEqual));
    const user = (0, _utils.useUser)();
    if (user.role !== (0, _types.Role).super) {
        navigate(-1);
        return null;
    }
    const onSubmit = (kubernetesNode)=>{
        dispatch((0, _k8SActions.updateKubernetesNode)({
            regionId: kubernetesNode.region.id,
            name: kubernetesNode.name,
            roles: kubernetesNode.roles
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Kubernetes nodes',
            node?.name
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: loading,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                onSubmit: (values)=>{
                    onSubmit((0, _utils.formTransform)(values));
                },
                defaultValues: getInitialState(node),
                component: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(KubernetesNodeForm, {
                        ...props,
                        isExternalNode: node?.region.external !== (0, _types.ExternalRegionMode).core
                    })
            })
        })
    });
};
const KubernetesNodeForm = ({ getValues, setError, setFocus, formState, setValue, watch, isExternalNode })=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    const values = getValues();
    const currentRoles = watch('roles');
    const { saving, formErrors } = (0, _reactRedux.useSelector)(({ k8sReducer })=>({
            saving: k8sReducer.saving,
            formErrors: k8sReducer.formErrors
        }), (0, _reactRedux.shallowEqual));
    const { devMode } = (0, _utils.useSettingsSelector)();
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach((item)=>{
                setError(item.name, {
                    type: 'manual',
                    message: item.reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    const onCheckboxChange = (role)=>{
        const roleIndex = currentRoles.indexOf(role);
        if (roleIndex !== -1) currentRoles.splice(roleIndex, 1);
        if (roleIndex === -1) currentRoles.push(role);
        setValue('roles', Array.from(currentRoles.values()), {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    const isChecked = (role)=>currentRoles.includes(role);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                formState: formState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "node-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _metaDefault.default), {
                        node: values
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Node roles",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                    checked: isChecked((0, _labels.KubernetesRoles).core),
                                    onChange: ()=>onCheckboxChange((0, _labels.KubernetesRoles).core)
                                }),
                                label: "Core",
                                tooltip: "The core role determines which worker nodes run the API and all the supporting central services and databases. This is the most memory-intensive role and requires a minimum of 16GB for production deployments. It is also the most storage-intensive role both in volume and IOPS.",
                                disabled: isExternalNode
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                    checked: isChecked((0, _labels.KubernetesRoles).video),
                                    onChange: ()=>onCheckboxChange((0, _labels.KubernetesRoles).video)
                                }),
                                label: "Video",
                                tooltip: "The video role is given to the worker nodes that should distribute video. This is the most bandwidth-intensive role and it requires a public ip (public as in reachable from outside the cluster) available. For each worker node with the video node there should be a public ip mapping that specifies how external appliances can reach the video node."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                    checked: isChecked((0, _labels.KubernetesRoles).video_standby),
                                    onChange: ()=>onCheckboxChange((0, _labels.KubernetesRoles).video_standby)
                                }),
                                label: "Video Standby",
                                tooltip: "The video_standby role is a specialization of the video role where no workload is scheduled unless some video worker node is unavailable. This can be used to ensure auto-recovery in case a video worker node becomes unavailable for any reason."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                    checked: isChecked((0, _labels.KubernetesRoles).thumb),
                                    onChange: ()=>onCheckboxChange((0, _labels.KubernetesRoles).thumb)
                                }),
                                label: "Thumb",
                                tooltip: "The thumb role determines where the thumbnail service should run. This is the most CPU-intensive role and for that reason, it is generally recommended to not colocate this role with the video role on the same worker."
                            }),
                            devMode && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                            checked: isChecked((0, _labels.KubernetesRoles).edge_connect),
                                            onChange: ()=>onCheckboxChange((0, _labels.KubernetesRoles).edge_connect)
                                        }),
                                        label: "Edge Connect",
                                        tooltip: "The edge_connect role is used to deploy Edge Connect instances within the Kubernetes cluster.",
                                        disabled: isExternalNode
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                            checked: isChecked((0, _labels.KubernetesRoles).load_simulator),
                                            onChange: ()=>onCheckboxChange((0, _labels.KubernetesRoles).load_simulator)
                                        }),
                                        label: "Load simulator",
                                        tooltip: "The load simulator role is used to run appliance emulators that generate control plane load.",
                                        disabled: isExternalNode
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>void navigate(routes.kubernetesNodes())
                            },
                            Save: {
                                id: 'button-save',
                                savingState: !!saving,
                                primary: true,
                                type: 'submit'
                            }
                        }
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","lodash/merge":"iHC1F","../../../redux/actions/k8sActions":"lYa8m","../../common/Form":"4Mui7","../../common/Wrapper":"8oy7r","../../common/Pendable":"gDN67","../../../utils":"342UB","common/api/v1/types":"3qemx","common/k8s/labels":"bnCGR","./meta":"hdHkr","@mui/material/Checkbox":"ag1Z5","../../../store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnCGR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoadSimulatorLabelValue = exports.ThumbLabelValue = exports.EdgeConnectLabelValue = exports.VideoLabelValue = exports.VideoStandbyLabelValue = exports.KubernetesRoles = exports.KubernetesLabels = void 0;
var KubernetesLabels;
(function(KubernetesLabels) {
    KubernetesLabels["video"] = "video";
    KubernetesLabels["video_standby"] = "video_standby";
    KubernetesLabels["region"] = "region";
    KubernetesLabels["default_region"] = "default_region";
    KubernetesLabels["core"] = "core";
    KubernetesLabels["thumb"] = "thumb";
    KubernetesLabels["edge_connect"] = "edge_connect";
    KubernetesLabels["load_simulator"] = "load_simulator";
})(KubernetesLabels || (exports.KubernetesLabels = KubernetesLabels = {}));
var KubernetesRoles;
(function(KubernetesRoles) {
    KubernetesRoles["core"] = "core";
    KubernetesRoles["thumb"] = "thumb";
    KubernetesRoles["video"] = "video";
    KubernetesRoles["video_standby"] = "video_standby";
    KubernetesRoles["edge_connect"] = "edge_connect";
    KubernetesRoles["load_simulator"] = "load_simulator";
})(KubernetesRoles || (exports.KubernetesRoles = KubernetesRoles = {}));
var VideoStandbyLabelValue;
(function(VideoStandbyLabelValue) {
    VideoStandbyLabelValue["standby"] = "standby";
})(VideoStandbyLabelValue || (exports.VideoStandbyLabelValue = VideoStandbyLabelValue = {}));
var VideoLabelValue;
(function(VideoLabelValue) {
    VideoLabelValue["enabled"] = "true";
})(VideoLabelValue || (exports.VideoLabelValue = VideoLabelValue = {}));
var EdgeConnectLabelValue;
(function(EdgeConnectLabelValue) {
    EdgeConnectLabelValue["enabled"] = "true";
})(EdgeConnectLabelValue || (exports.EdgeConnectLabelValue = EdgeConnectLabelValue = {}));
var ThumbLabelValue;
(function(ThumbLabelValue) {
    ThumbLabelValue["enabled"] = "true";
})(ThumbLabelValue || (exports.ThumbLabelValue = ThumbLabelValue = {}));
var LoadSimulatorLabelValue;
(function(LoadSimulatorLabelValue) {
    LoadSimulatorLabelValue["enabled"] = "true";
})(LoadSimulatorLabelValue || (exports.LoadSimulatorLabelValue = LoadSimulatorLabelValue = {}));

},{}],"hdHkr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _form = require("../../common/Form");
var _dataSet = require("../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _link = require("../../common/Link");
const Meta = ({ node })=>{
    const region = {
        external: false
    };
    const metrics = !region.external ? {
        Metrics: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ExternalLink), {
            underline: "always",
            href: `/grafana/d/000000127/system-resource-usage?orgId=1&var-DS_PROMETHEUS=Prometheus&var-job=node-exporter&var-name=${node.name}&from=now-15m&to=now&refresh=1m`,
            children: "Resource Usage"
        })
    } : {};
    const meta = {
        Name: node.name,
        Region: node.region.name,
        Status: node.status,
        'Internal IP': node.internalIP,
        'External IP': node.externalIP,
        'Kubelet version': node.kubeletVersion,
        ...metrics
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Metadata",
        collapsible: true,
        actionsPane: [],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
            lg: 12,
            xl: 12,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                values: meta
            })
        })
    });
};
exports.default = Meta;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../common/Form":"4Mui7","../../common/DataSet":"dmQXG","../../common/Link":"l3o6V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0HOG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Networks", ()=>Networks);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _networksList = require("./NetworksList");
var _networkForm = require("./NetworkForm");
var _networkFormDefault = parcelHelpers.interopDefault(_networkForm);
const Networks = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).UPDATE,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkFormDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networksList.NetworksList), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).NEW,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkFormDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","./NetworksList":"aiyne","./NetworkForm":"hhyWI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aiyne":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworksList", ()=>NetworksList);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _link = require("../common/Link");
var _indicator = require("../common/Indicator");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _listNetworkFilter = require("./listNetworkFilter");
var _store = require("../../store");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
const NetworksList = ()=>{
    const { networks, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useNetworksSelector));
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const tableConfig = [
        {
            title: 'name',
            getValue: (network)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.networkUpdate({
                        id: network.id
                    }),
                    underline: "hover",
                    children: network.name
                }),
            sorting: {
                byParameter: (0, _types.NetworkSortableField).name
            }
        },
        {
            title: 'enabled',
            getValue: ({ enabled })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicator.NetworkIndicator), {
                    enabled: enabled
                }),
            props: {
                noTypography: true
            }
        },
        {
            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.MoveToEntity), {
                    url: routes.networkUpdate({
                        id
                    }),
                    entityName: "network"
                }),
            props: {
                align: 'right',
                noTypography: true
            }
        }
    ];
    if (!user || user.role !== (0, _types.Role).super) return null;
    const filters = (0, _listNetworkFilter.makeListNetworksFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Networks",
        actions: user.role === (0, _types.Role).super && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                marginLeft: 'auto'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                id: "groups-table-create-button",
                to: routes.networkNew(),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    children: "Add network"
                })
            }, "addGroup")
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'networks',
                        mapUrlParamToFilterFn: (0, _listNetworkFilter.mapUrlParamToNetworkFilter),
                        mapFilterToUrlParamFn: (0, _listNetworkFilter.mapNetworkFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listNetworkFilter.ListNetworkFilterKey).name)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                    message: "No networks available",
                    buttonText: "Add network",
                    url: routes.networkNew()
                }),
                config: tableConfig,
                data: networks,
                id: "networks-table",
                pending: loading,
                pagination: {
                    total,
                    useUrlSearchParams: true
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Button":"3qJY9","common/api/v1/types":"3qemx","../../utils":"342UB","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../common/Link":"l3o6V","../common/Indicator":"hqaQa","@mui/material/Toolbar":"5Kohb","./listNetworkFilter":"grtn0","../../store":"5LXiG","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grtn0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListNetworkFilterKey", ()=>ListNetworkFilterKey);
parcelHelpers.export(exports, "mapNetworkFilterToUrlParam", ()=>mapNetworkFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToNetworkFilter", ()=>mapUrlParamToNetworkFilter);
parcelHelpers.export(exports, "makeListNetworksFilter", ()=>makeListNetworksFilter);
var ListNetworkFilterKey = /*#__PURE__*/ function(ListNetworkFilterKey) {
    ListNetworkFilterKey["name"] = "name";
    return ListNetworkFilterKey;
}({});
function mapNetworkFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToNetworkFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListNetworksFilter() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hhyWI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditNetwork);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _form = require("../common/Form");
var _pendable = require("../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _store = require("../../store");
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _networkActions = require("../../redux/actions/networkActions");
var _rhf = require("../common/Form/RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _selfStatePaginatedList = require("../common/SelfStatePaginatedList");
var _selfStatePaginatedListDefault = parcelHelpers.interopDefault(_selfStatePaginatedList);
var _table = require("../common/Table");
var _link = require("../common/Link");
const { portsApi } = (0, _store.Api);
const NetworkForm = ({ getValues, setError, setFocus, formState })=>{
    const values = getValues();
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const setConfirmation = (0, _utils.useConfirmationDialog)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const { formErrors, saving } = (0, _reactRedux.useSelector)(({ networksReducer })=>({
            formErrors: networksReducer.formErrors,
            saving: networksReducer.saving
        }), (0, _reactRedux.shallowEqual));
    const { devMode } = (0, _utils.useSettingsSelector)();
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach((item)=>{
                setError(item.name, {
                    type: 'manual',
                    message: item.reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    const deleteNetwork = ()=>'id' in values && setConfirmation(()=>void dispatch((0, _networkActions.removeNetwork)(values.id)), `Are you sure you want to remove network ${values.name}?`, undefined, {
            ok: {
                text: 'remove',
                color: 'error'
            }
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                formState: formState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "network-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Network",
                        tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "Interfaces within the same network will be connected using their private IP addresses."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "To assign networks to interfaces navigate to an appliance or a particular interface."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "Networks can be temporarily disabled to switch over to the behavior defined by address mappings."
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "name",
                                label: "Name",
                                required: true,
                                autoFocus: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                name: "enabled",
                                label: "Enable"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>void navigate(routes.networks())
                            },
                            Save: {
                                savingState: !!saving,
                                primary: true,
                                type: 'submit'
                            }
                        },
                        secondary: 'id' in values && user.role === (0, _types.Role).super ? {
                            'Remove network': {
                                onClick: deleteNetwork
                            }
                        } : undefined
                    })
                ]
            }),
            'id' in values && devMode && /*#__PURE__*/ (0, _jsxRuntime.jsx)(NetworkInterfaces, {
                network: values.id
            })
        ]
    });
};
function EditNetwork() {
    const { id } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        id && dispatch((0, _networkActions.getNetwork)(id));
        return ()=>{
            dispatch((0, _networkActions.clearNetwork)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const networkToEdit = (0, _reactRedux.useSelector)(({ networksReducer })=>networksReducer.network, (0, _reactRedux.shallowEqual));
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const onSubmit = (network)=>{
        if (networkToEdit) {
            if (network.enabled === networkToEdit.enabled) return dispatch((0, _networkActions.updateNetwork)(network));
            showConfirmation(()=>void dispatch((0, _networkActions.updateNetwork)(network)), `${network.enabled ? 'Enabling' : 'Disabling'} the network may cause disruptions in active routing services.
          Are you sure you want to proceed?`);
        } else dispatch((0, _networkActions.createNetwork)(network));
    };
    const user = (0, _utils.useUser)();
    if (!user || user.role !== (0, _types.Role).super) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Networks',
            id ? networkToEdit?.name : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: !!id && !networkToEdit,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rhfDefault.default), {
                onSubmit: (values)=>{
                    onSubmit((0, _utils.formTransform)(values));
                },
                defaultValues: networkToEdit || {
                    name: '',
                    enabled: true
                },
                component: NetworkForm
            })
        })
    });
}
const NetworkInterfaces = ({ network })=>{
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const tableConfig = [
        {
            title: 'name',
            getValue: (port)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.interfacesUpdate({
                        id: port.id
                    }),
                    available: !!port._appliance && (0, _utils.isEditableInterface)((0, _utils.getApplianceOwnerId)(port._appliance), user),
                    underline: "hover",
                    children: (0, _utils.getInterfaceName)(port)
                });
            },
            sorting: {
                byParameter: (0, _types.ListPortSortableField).portName
            }
        },
        {
            title: 'address',
            getValue: (port)=>port.addresses[0]?.address,
            sorting: {
                byParameter: (0, _types.ListPortSortableField).address
            }
        },
        {
            title: 'public address',
            getValue: (port)=>port.addresses[0]?.publicAddress,
            sorting: {
                byParameter: (0, _types.ListPortSortableField).publicAddress
            }
        },
        {
            title: 'appliance',
            getValue: ({ appliance: { name, id }, _appliance })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.appliancesUpdate({
                        id
                    }),
                    underline: "hover",
                    available: !!_appliance && (0, _utils.isEditableAppliance)(user, (0, _utils.getApplianceOwnerId)(_appliance)),
                    children: name
                }),
            sorting: {
                byParameter: (0, _types.ListPortSortableField).applianceName
            }
        },
        {
            title: 'owner group',
            getValue: ({ _owner })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.groupsUpdate({
                        id: _owner.id
                    }),
                    available: (0, _utils.isEditableGroup)(_owner.id, user),
                    underline: "hover",
                    children: _owner.name
                }),
            sorting: {
                byParameter: (0, _types.ListPortSortableField).ownerGroupName
            }
        },
        {
            title: 'alarms',
            getValue: ({ _appliance, id: portId })=>{
                const alarms = _appliance?.alarms.filter((alarm)=>alarm.physicalPortId == portId);
                if (!alarms || alarms.length === 0) return 'no alarms';
                const portDisabledAlarms = (0, _utils.alarmsThatDisablePort)(_appliance, portId);
                if (portDisabledAlarms && portDisabledAlarms.length > 0) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        (0, _utils.pluralize)(alarms.length, 'alarm'),
                        ", interface is disabled",
                        portDisabledAlarms.map((portAlarm, i)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                component: "div",
                                variant: "body2",
                                color: "textSecondary",
                                children: portAlarm.text
                            }, portAlarm.alarmId.concat(i.toString()));
                        })
                    ]
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: (0, _utils.pluralize)(alarms.length, 'alarm')
                });
            }
        },
        {
            getValue: ({ id: portId, _appliance })=>!!_appliance && (0, _utils.isEditableInterface)((0, _utils.getApplianceOwnerId)(_appliance), user) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.MoveToEntity), {
                    url: routes.interfacesUpdate({
                        id: portId
                    }),
                    entityName: "interface",
                    dataTestId: `edit-${portId}`
                }) : null,
            props: {
                align: 'right',
                noTypography: true
            }
        }
    ];
    const [sortProps, setSortProps] = (0, _react.useState)({});
    const [refreshData, setRefreshData] = (0, _react.useState)(false);
    const setNewSortProps = (newValue)=>{
        setSortProps(newValue);
        setRefreshData((prevState)=>!prevState);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Interfaces",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selfStatePaginatedListDefault.default), {
            api: (requestParams)=>portsApi.getPorts({
                    ...requestParams,
                    ...sortProps,
                    network
                }),
            emptyMessage: "no interfaces found",
            notFoundMessage: "no matching interfaces",
            updateOn: refreshData,
            List: ({ list })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                    data: list,
                    sorting: {
                        currentSortKey: sortProps,
                        onSortOrderChanged: setNewSortProps
                    },
                    emptyMessageComponent: "no interfaces found",
                    config: tableConfig
                })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","../common/Form":"4Mui7","../common/Pendable":"gDN67","../common/Wrapper":"8oy7r","../../store":"5LXiG","common/api/v1/types":"3qemx","../../utils":"342UB","../../redux/actions/networkActions":"gfZop","../common/Form/RHF":"7gFt3","@mui/material/Typography":"6NtGx","../common/SelfStatePaginatedList":"dLSax","../common/Table":"dt9lf","../common/Link":"l3o6V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l3ePJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Services", ()=>Services);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _routes = require("../../utils/routes");
var _notFound = require("../common/NotFound");
var _edit = require("./Edit/Edit");
var _list = require("./List");
const Services = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: (0, _routes.SUB_PATH).UPDATE,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.ListView), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../../utils/routes":"cqMGU","../common/NotFound":"1Msr5","./Edit/Edit":"jhpnJ","./List":"hRhwe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jhpnJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _serviceActions = require("../../../redux/actions/serviceActions");
var _store = require("../../../store");
var _form = require("../../common/Form");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _utils = require("../../../utils");
var _meta = require("../meta");
var _reactAsyncHook = require("react-async-hook");
var _failedFetchingContent = require("../../common/FailedFetchingContent");
var _storagePools = require("./StoragePools");
const { serviceApi } = (0, _store.Api);
const getInitialState = (service)=>{
    const desiredRetentionPeriod = service?.retentionPeriods?.[0].desired ?? service?.retentionPeriods?.[0].current;
    const _desiredRetentionPeriodDays = desiredRetentionPeriod ? desiredRetentionPeriod / 1000 / 60 / 60 / 24 : undefined;
    return {
        ...service,
        _desiredRetentionPeriodDays
    };
};
const ServiceForm = ({ formState, getValues })=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const values = getValues();
    const routes = (0, _store.useRoutes)();
    const product = getValues().product;
    const desiredVolumeCapacityTooltip = `Increase the volume capacity of all service instances in Kubernetes (if it's enabled by the Kubernetes provider). The volume capacity cannot be decreased.` + (product === 'Redpanda' ? `\n\nRemember to also increase the retention.bytes setting for the topics using kubectl and the rpk command or using the Redpanda Console at ${window.origin}/kafka. The retention.bytes setting applies per partition, so the total disk usage per topic and node will be retention.bytes multiplied by 8.` : '');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                enabled: formState.isDirty && !formState.isSubmitting
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                id: "service-form",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _meta.Meta), {
                        service: values
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                        title: "Settings",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                name: "collectLogs",
                                label: "Collect logs",
                                tooltip: "Enabling log collection will ensure the logs are collected, indexed and stored."
                            }),
                            values.allowEnableDisable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Checkbox), {
                                name: "enabled",
                                label: "Enable",
                                tooltip: "Enable the service"
                            }),
                            values.allowsVolumeAdministration && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "desiredVolumeCapacity",
                                label: "Desired volume capacity",
                                tooltip: desiredVolumeCapacityTooltip
                            }),
                            values.allowsRetentionPeriodAdministration && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "_desiredRetentionPeriodDays",
                                type: "number",
                                label: "Desired retention period (days)",
                                tooltip: 'Set the retention period in days. 0 means no retention.',
                                validators: {
                                    number: {
                                        onlyInteger: true,
                                        greaterThanOrEqualTo: 0,
                                        message: 'Must be a positive integer'
                                    }
                                }
                            })
                        ]
                    }),
                    values.storagePools !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _storagePools.StoragePools), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                        main: {
                            Cancel: {
                                onClick: ()=>{
                                    navigate(routes.services());
                                }
                            },
                            Save: {
                                savingState: formState.isSubmitting,
                                primary: true,
                                type: 'submit'
                            }
                        }
                    })
                ]
            })
        ]
    });
};
const Edit = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const onSubmit = async (service)=>{
        await (0, _serviceActions.updateService)(service, {
            dispatch,
            serviceApi: (0, _store.Api).serviceApi,
            navigate,
            routes
        });
    };
    const { result: serviceToEdit, loading, error } = (0, _reactAsyncHook.useAsync)(async ()=>serviceApi.getService(id), [
        id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Services',
            serviceToEdit ? serviceToEdit.purpose : ' '
        ],
        children: error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _failedFetchingContent.FailedFetchingContent), {
            message: 'Failed to fetch service'
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: loading,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
                onSubmit: (values)=>{
                    const { _desiredRetentionPeriodDays, ...body } = (0, _utils.formTransform)(values);
                    return onSubmit({
                        ...body,
                        desiredRetentionPeriod: _desiredRetentionPeriodDays ? _desiredRetentionPeriodDays * 86400000 // day to ms
                         : undefined
                    });
                },
                defaultValues: getInitialState(serviceToEdit),
                component: ServiceForm
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","react-router":"iaz4C","../../../redux/actions/serviceActions":"ieIAK","../../../store":"5LXiG","../../common/Form":"4Mui7","../../common/Pendable":"gDN67","../../common/Wrapper":"8oy7r","../../../utils":"342UB","../meta":"hb9Gg","react-async-hook":"3D6Y9","../../common/FailedFetchingContent":"dJi9P","./StoragePools":"1irZQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ieIAK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateService", ()=>updateService);
parcelHelpers.export(exports, "getServices", ()=>getServices);
var _notificationActions = require("./notificationActions");
var _utils = require("../../utils");
const updateService = async (service, { dispatch, serviceApi, navigate, routes })=>{
    try {
        await serviceApi.updateService(service);
        navigate(routes.services());
        dispatch((0, _notificationActions.enqueueSuccessSnackbar)(`Edited Service: ${service.purpose}`));
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'update service'
        }));
        throw err;
    }
};
const getServices = async (params, { dispatch, serviceApi })=>{
    try {
        return await serviceApi.getServices({
            includeHidden: params.includeHidden,
            ...(0, _utils.withDefaultPagination)(params)
        });
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'fetch services'
        }));
        throw err;
    }
};

},{"./notificationActions":"7LkQg","../../utils":"342UB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hb9Gg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Meta", ()=>Meta);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _dateFns = require("date-fns");
var _form = require("../common/Form");
var _dataSet = require("../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _link = require("../common/Link");
var _product = require("./Product");
const VolumeCapacityList = ({ currentVolumes })=>{
    if (!currentVolumes) return 'N/A';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 1
        },
        children: currentVolumes.map((volume)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                label: `${volume.name}: ${volume.currentVolumeCapacity}`,
                size: "small"
            }, volume.name))
    });
};
const RetentionPeriodList = ({ retentionPeriods })=>{
    const pretty = (ms)=>{
        if (ms < 0) return 'N/A';
        const duration = (0, _dateFns.intervalToDuration)({
            start: 0,
            end: ms
        });
        return (0, _dateFns.formatDuration)(duration);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 1
        },
        children: retentionPeriods.map((period)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                label: `${period.name}: ${pretty(period.current)}`,
                size: "small"
            }, period.name))
    });
};
const Meta = ({ service })=>{
    const logs = {
        Logs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.ExternalLink), {
            underline: "always",
            href: service.filterUrl,
            children: "Logs"
        })
    };
    const meta = {
        Purpose: service.purpose,
        Product: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                service.product,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _product.ProductLink), {
                    product: service.product,
                    enabled: service.enabled
                })
            ]
        }),
        ...logs,
        'Current volume capacity': /*#__PURE__*/ (0, _jsxRuntime.jsx)(VolumeCapacityList, {
            currentVolumes: service.currentVolumes
        }),
        ...service.retentionPeriods ? {
            'Retention period': /*#__PURE__*/ (0, _jsxRuntime.jsx)(RetentionPeriodList, {
                retentionPeriods: service.retentionPeriods
            })
        } : {}
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: "Metadata",
        collapsible: true,
        actionsPane: [],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
            lg: 12,
            xl: 12,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                values: meta
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Chip":"5cK8z","date-fns":"gelMX","../common/Form":"4Mui7","../common/DataSet":"dmQXG","../common/Link":"l3o6V","./Product":"c8L9a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c8L9a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getProductLink", ()=>getProductLink);
parcelHelpers.export(exports, "ProductLink", ()=>ProductLink);
var _jsxRuntime = require("react/jsx-runtime");
var _tooltip = require("../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _openInNew = require("@mui/icons-material/OpenInNew");
var _openInNewDefault = parcelHelpers.interopDefault(_openInNew);
function getProductLink(product) {
    switch(product){
        case 'Redpanda':
            return {
                href: '/kafka',
                tooltip: 'View Redpanda Console'
            };
        case 'LoadSimulator':
            return {
                href: '/loadsim/',
                tooltip: 'View load simulator'
            };
        case 'Grafana':
            return {
                href: '/grafana',
                tooltip: 'View Grafana dashboards'
            };
        case 'MinIO':
            return {
                href: '/minio',
                tooltip: 'View MinIO Console'
            };
        default:
            return undefined;
    }
}
const ProductLink = ({ product, enabled })=>{
    const link = getProductLink(product);
    return link ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: enabled ? link.tooltip : `${product} is not enabled`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            href: link.href,
            target: "_blank",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                edge: "end",
                "aria-label": link.tooltip,
                disabled: !enabled,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInNewDefault.default), {})
            })
        })
    }) : null;
};

},{"react/jsx-runtime":"1dlk8","../common/Tooltip":"crjvg","@mui/material/Link":"chNUC","@mui/material/IconButton":"488As","@mui/icons-material/OpenInNew":"3wl83","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1irZQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StoragePools", ()=>StoragePools);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _reactHookForm = require("react-hook-form");
var _form = require("../../../components/common/Form");
var _deleteStoragePoolDialog = require("./DeleteStoragePoolDialog");
var _addStoragePoolDialog = require("./AddStoragePoolDialog");
var _confirmDialog = require("../../common/ConfirmDialog");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
const StoragePools = ()=>{
    const { getValues, trigger, formState } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    const { fields, append: appendField, remove: removeField } = (0, _reactHookForm.useFieldArray)({
        name: 'storagePools'
    });
    const theme = (0, _styles.useTheme)();
    const { showConfirmation } = (0, _confirmDialog.useConfirmationDialog)();
    const [isAddingStoragePool, setIsAddingStoragePool] = (0, _react.useState)(false);
    const onAddStoragePool = ()=>{
        if (!values.storagePools || formState.errors.storagePools) return;
        const newPool = {
            name: values.storagePools[values.storagePools.length - 1].name,
            servers: values.storagePools[values.storagePools.length - 1].servers,
            size: values.storagePools[values.storagePools.length - 1].size
        };
        showConfirmation(()=>{
            setIsAddingStoragePool(false);
        }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addStoragePoolDialog.AddStoragePoolDialog), {
            storagePool: newPool
        }), undefined, {}, ()=>{
            trigger();
        });
    };
    const onRemoveStoragePool = (index)=>{
        showConfirmation(()=>{
            removeField(index);
        }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteStoragePoolDialog.DeleteStoragePoolDialog), {
            storagePool: values.storagePools[index]
        }), undefined, {
            ok: {
                text: 'delete',
                color: 'error'
            }
        }, ()=>{
            trigger();
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Storage pools",
        tooltip: 'Add a storage pool to increase the storage capacity of the service. Existing storage pools cannot be edited.',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                container: true,
                sx: {
                    width: '100%',
                    mt: 3
                },
                children: fields.map((field, index)=>{
                    const storagePool = values.storagePools[index];
                    if (isAddingStoragePool && index === values.storagePools.length - 1) return null;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                        size: {
                            xs: 8,
                            sm: 7,
                            lg: 5
                        },
                        sx: {
                            width: '100px',
                            m: 3,
                            mt: 0,
                            p: 3,
                            border: '2px solid',
                            borderColor: theme.palette.grey[800],
                            borderRadius: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        variant: "h3",
                                        children: storagePool.name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                        title: "Deleting the storage pool will reduce the storage capacity of the service. All volumes persist in the cluster, but they are not reusable by MinIO.",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                            onClick: ()=>onRemoveStoragePool(index),
                                            disabled: isAddingStoragePool,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1,
                                    mt: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                        children: [
                                            "Nodes: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: storagePool.servers
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                        children: [
                                            "Node volume size: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: storagePool.size
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                        children: [
                                            "Volumes per node: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: "2"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, field.id);
                })
            }),
            isAddingStoragePool && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                sx: {
                    width: '40%',
                    mr: '60%'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `storagePools[${values.storagePools.length - 1}].name`,
                        label: "Name",
                        tooltip: "The name of the new storage pool.",
                        required: true,
                        validators: {
                            k8sName: {},
                            notOneOf: {
                                invalidValues: new Set(values.storagePools.slice(0, values.storagePools.length - 1).map((pool)=>pool.name)),
                                errorMsg: 'Name must be unique'
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `storagePools[${values.storagePools.length - 1}].servers`,
                        label: "Nodes",
                        type: "number",
                        tooltip: "Number of nodes in the storage pool.",
                        required: true,
                        validators: {
                            number: {
                                onlyInteger: true,
                                greaterThanOrEqualTo: 3,
                                message: 'Must be at least 3 servers'
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        newLine: true,
                        name: `storagePools[${values.storagePools.length - 1}].size`,
                        label: "Volume size",
                        tooltip: "The size of each volume in the storage pool. Supports suffixes like G, M, Gi and Mi.",
                        required: true,
                        validators: {
                            k8sMemoryString: {
                                min: '5G',
                                message: 'Must be at least 5G'
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                        name: `_volumesPerNode`,
                        label: "Volumes per node",
                        value: "2",
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 1,
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                variant: "outlined",
                                onClick: ()=>{
                                    removeField(values.storagePools.length - 1);
                                    setIsAddingStoragePool(false);
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                variant: "contained",
                                onClick: ()=>{
                                    onAddStoragePool();
                                },
                                children: "OK"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "contained",
                onClick: ()=>{
                    appendField({
                        name: '',
                        servers: 3,
                        size: '5Gi'
                    });
                    setIsAddingStoragePool(true);
                    trigger();
                },
                disabled: isAddingStoragePool,
                children: "Add storage pool"
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/styles":"2UrBk","@mui/material/Grid":"6iX4B","react-hook-form":"8z0aI","../../../components/common/Form":"4Mui7","./DeleteStoragePoolDialog":"kXlQ9","./AddStoragePoolDialog":"4vBjy","../../common/ConfirmDialog":"7JKPn","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Divider":"9Ul8c","@mui/material/IconButton":"488As","@mui/material/Tooltip":"2soEB","@mui/material/Typography":"6NtGx","@mui/icons-material/Delete":"69aC7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kXlQ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteStoragePoolDialog", ()=>DeleteStoragePoolDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _utils = require("common/utils");
const DeleteStoragePoolDialog = ({ storagePool })=>{
    const volumesPerNode = 2;
    const totalBytes = storagePool.servers * volumesPerNode * (0, _utils.parseK8sMemoryString)(storagePool.size);
    const totalGi = totalBytes / 1024 ** 3;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: "Warning!"
                    }),
                    " You are about to delete a storage pool. Make sure you have migrated or backed up the data stored on it."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                children: "Removing storage pool with the following properties:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: 'div',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                "Name: ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: storagePool.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                "Nodes: ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: storagePool.servers
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                "Node volume size: ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: storagePool.size
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                "Volumes per node: ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: volumesPerNode
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                children: [
                    "This will shrink the service by ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                        children: [
                            totalGi.toFixed(2),
                            " Gi"
                        ]
                    }),
                    "."
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Typography":"6NtGx","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vBjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddStoragePoolDialog", ()=>AddStoragePoolDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _utils = require("common/utils");
const AddStoragePoolDialog = ({ storagePool })=>{
    const volumesPerNode = 2;
    const totalBytes = storagePool.servers * volumesPerNode * (0, _utils.parseK8sMemoryString)(storagePool.size);
    const totalGi = totalBytes / 1024 ** 3;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                children: "Adding a new storage pool with the following properties:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: 'div',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                "Name: ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: storagePool.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                "Nodes: ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: storagePool.servers
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                "Node volume size: ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: storagePool.size
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            children: [
                                "Volumes per node: ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: volumesPerNode
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                children: [
                    "This will request ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                        children: [
                            totalGi.toFixed(2),
                            " Gi"
                        ]
                    }),
                    " from your storage provider."
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Typography":"6NtGx","common/utils":"2AqiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hRhwe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListView", ()=>ListView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _reactAsyncHook = require("react-async-hook");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _tooltip = require("../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _fiberManualRecord = require("@mui/icons-material/FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _link = require("../common/Link");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _serviceActions = require("../../redux/actions/serviceActions");
var _store = require("../../store");
var _listServiceFilter = require("./listServiceFilter");
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _pendable = require("../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _dataArray = require("@mui/icons-material/DataArray");
var _dataArrayDefault = parcelHelpers.interopDefault(_dataArray);
var _openInNew = require("@mui/icons-material/OpenInNew");
var _openInNewDefault = parcelHelpers.interopDefault(_openInNew);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _product = require("./Product");
var _actionMenu = require("../common/Table/ActionMenu");
const { serviceApi } = (0, _store.Api);
const Toggle = ({ value })=>{
    return value ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {}) : null;
};
const ListView = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { devMode } = (0, _utils.useSettingsSelector)();
    const searchParams = {
        includeHidden: devMode,
        ...(0, _utils.usePageParamsFiltered)()
    };
    const { result } = (0, _reactAsyncHook.useAsync)(()=>(0, _serviceActions.getServices)(searchParams, {
            dispatch,
            serviceApi
        }), [
        JSON.stringify(searchParams)
    ]);
    const routes = (0, _store.useRoutes)();
    const tableConfig = [
        {
            title: 'product',
            getValue: (service)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.servicesUpdate({
                        id: service.id
                    }),
                    underline: "hover",
                    children: service.product
                }),
            sorting: {
                byParameter: (0, _types.ListServiceSortableField).product
            }
        },
        {
            title: 'purpose',
            getValue: ({ purpose, description })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        display: 'flex'
                    },
                    children: [
                        purpose,
                        description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: description,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                                sx: {
                                    marginLeft: 1
                                }
                            })
                        })
                    ]
                }),
            sorting: {
                byParameter: (0, _types.ListServiceSortableField).purpose
            }
        },
        {
            title: 'collect logs',
            getValue: ({ collectLogs })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Toggle, {
                    value: collectLogs
                }),
            props: {
                noTypography: true
            }
        },
        {
            getValue: (service)=>{
                const productLink = (0, _product.getProductLink)(service.product);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    options: [
                        {
                            label: 'Edit',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                            href: routes.servicesUpdate({
                                id: service.id
                            })
                        },
                        {
                            label: 'View logs',
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataArrayDefault.default), {}),
                            href: service.filterUrl,
                            openInNewTab: true
                        },
                        ...productLink ? [
                            {
                                label: productLink.tooltip,
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInNewDefault.default), {}),
                                href: productLink.href,
                                openInNewTab: true
                            }
                        ] : []
                    ]
                });
            },
            props: {
                align: 'right',
                noTypography: true
            }
        }
    ];
    const filters = (0, _listServiceFilter.makeListK8sServicesFilter)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Services",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                disableGutters: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flexShrink: 1,
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                        urlParamCacheKey: 'k8sServices',
                        mapUrlParamToFilterFn: (0, _listServiceFilter.mapUrlParamToK8sServiceFilter),
                        mapFilterToUrlParamFn: (0, _listServiceFilter.mapK8sFilterToUrlParam),
                        searchTokenFilters: filters,
                        rawTextFilter: filters.find((f)=>f.key === (0, _listServiceFilter.ListK8sServiceFilterKey).name)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                pending: !result,
                children: result && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                    emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                        message: "No services available"
                    }),
                    config: tableConfig,
                    data: result.items,
                    id: "services-table",
                    pagination: {
                        total: result.total,
                        useUrlSearchParams: true
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","react-async-hook":"3D6Y9","@mui/material/Box":"c4QkF","@mui/material/Toolbar":"5Kohb","../common/Tooltip":"crjvg","@mui/icons-material/FiberManualRecord":"bvXIN","@mui/icons-material/HelpOutline":"2sIqE","common/api/v1/types":"3qemx","../../utils":"342UB","../common/Link":"l3o6V","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../../redux/actions/serviceActions":"ieIAK","../../store":"5LXiG","./listServiceFilter":"hMoi9","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","../common/Pendable":"gDN67","@mui/icons-material/DataArray":"kjBsC","@mui/icons-material/OpenInNew":"3wl83","@mui/icons-material/Settings":"jkTfg","./Product":"c8L9a","../common/Table/ActionMenu":"jf6As","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hMoi9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListK8sServiceFilterKey", ()=>ListK8sServiceFilterKey);
parcelHelpers.export(exports, "mapK8sFilterToUrlParam", ()=>mapK8sFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToK8sServiceFilter", ()=>mapUrlParamToK8sServiceFilter);
parcelHelpers.export(exports, "makeListK8sServicesFilter", ()=>makeListK8sServicesFilter);
var ListK8sServiceFilterKey = /*#__PURE__*/ function(ListK8sServiceFilterKey) {
    ListK8sServiceFilterKey["name"] = "name";
    return ListK8sServiceFilterKey;
}({});
function mapK8sFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
    }
    return {};
}
function mapUrlParamToK8sServiceFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeListK8sServicesFilter() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kjBsC":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("41aebc3d7eba965c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("237630d49368d2db"));
var _jsxRuntime = require("76a7cd64eec4ec75");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15 4v2h3v12h-3v2h5V4zM4 20h5v-2H6V6h3V4H4z"
}), 'DataArray');

},{"41aebc3d7eba965c":"kZ6eK","237630d49368d2db":"2vOnF","76a7cd64eec4ec75":"1dlk8"}],"bIyS9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlarmLogs", ()=>AlarmLogs);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _notFound = require("../common/NotFound");
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
const AlarmLogs = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../common/NotFound":"1Msr5","./List":"fqNOY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fqNOY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dateFns = require("date-fns");
var _types = require("common/api/v1/types");
var _utils = require("../../utils");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _filters = require("../common/Filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _helpers = require("common/api/v1/helpers");
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
const RETENTION_DAYS = 90;
const retentionPeriod = new Date();
retentionPeriod.setDate(retentionPeriod.getDate() - (RETENTION_DAYS + 10)) // margin 10d
;
const AlarmLogList = ()=>{
    const [pageParams, setPageParams] = (0, _utils.usePageParams)();
    const { fromDate, toDate } = pageParams;
    (0, _react.useEffect)(()=>{
        if (!fromDate) setPageParams({
            fromDate: (0, _dateFns.addDays)(new Date(), -1).toISOString()
        });
    }, [
        fromDate
    ]);
    const minDate = fromDate ? new Date(fromDate) : new Date('1900-01-01');
    const maxDate = toDate ? new Date(toDate) : new Date();
    const validDateRange = (0, _dateFns.compareAsc)(minDate, maxDate) === -1;
    if (!fromDate) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Alarm history",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlarmLogListFilter, {
                minDate: minDate,
                maxDate: maxDate
            }),
            validDateRange && /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlarmLogListTable, {})
        ]
    });
};
const AlarmLogListFilter = ({ minDate, maxDate })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filtersDefault.default), {
        filters: [
            {
                label: 'From date',
                paramName: 'fromDate',
                type: (0, _filters.FilterType).datetime,
                minDate: retentionPeriod,
                minDateMessage: 'The retention period is 90 days',
                maxDate,
                maxDateMessage: 'Cannot be after "To date"'
            },
            {
                label: 'To date',
                paramName: 'toDate',
                type: (0, _filters.FilterType).datetime,
                minDate,
                minDateMessage: 'Cannot be before "From date"'
            },
            {
                label: 'Severity',
                paramName: 'severity',
                type: (0, _filters.FilterType).select,
                options: Object.values((0, _types.AlarmSeverityLevels)).map((item)=>({
                        name: (0, _capitalizeDefault.default)(item),
                        value: item
                    }))
            },
            {
                label: 'Search',
                paramName: 'searchName',
                type: (0, _filters.FilterType).text
            }
        ]
    });
};
const AlarmLogListTable = ()=>{
    const { alarmLogs, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useAlarmLogsSelector));
    const [pageParams] = (0, _utils.usePageParams)();
    const { pageNumber } = pageParams;
    const naText = 'N/A';
    const unicodeDownArrow = '\u2193';
    const tableConfig = [
        {
            title: 'Raised',
            getValue: ({ raisedAt })=>raisedAt ? (0, _dateFns.format)(new Date(raisedAt), (0, _helpers.DATE_FORMAT_LONG)) : naText
        },
        {
            title: `Cleared ${unicodeDownArrow}`,
            getValue: ({ clearedAt })=>clearedAt ? (0, _dateFns.format)(new Date(clearedAt), (0, _helpers.DATE_FORMAT_LONG)) : naText
        },
        {
            title: 'Appliance',
            getValue: ({ applianceName })=>applianceName || naText
        },
        {
            title: 'Alarm',
            getValue: ({ alarmCause })=>alarmCause
        },
        {
            title: 'Message',
            getValue: ({ text, object, objectName, repeatCount })=>{
                const isVALicenseAlarm = !!object?.startsWith('.license');
                const textDetails = isVALicenseAlarm ? ` - ${objectName}` : '';
                const repeatText = repeatCount > 0 ? ` (repeated ${repeatCount} times)` : '';
                return `${text}${textDetails}${repeatText}`;
            }
        },
        {
            title: 'Severity',
            getValue: ({ alarmSeverity })=>alarmSeverity !== 'cleared' ? (0, _capitalizeDefault.default)(alarmSeverity) : naText
        },
        {
            title: 'Entity',
            getValue: ({ inputId, inputName, outputId, outputName, applianceId, applianceName, alarmCause, objectName })=>{
                if (inputId) return `input "${inputName || naText}"`;
                if (outputId) return `output "${outputName || naText}"`;
                if (applianceId) return `appliance "${applianceName || naText}"`;
                if (alarmCause === (0, _types.AlarmCause).BACKUP_JOB_FAILED) return `job "${objectName || naText}"`;
                return '';
            }
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
        emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
            message: "No log available for the interval"
        }),
        config: tableConfig,
        data: alarmLogs.map((item, idx)=>({
                ...item,
                alarmId: `${pageNumber || 0}_${idx}${item.alarmId}`
            })),
        pending: loading,
        pagination: {
            total,
            useUrlSearchParams: true
        }
    });
};
exports.default = AlarmLogList;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","date-fns":"gelMX","common/api/v1/types":"3qemx","../../utils":"342UB","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../common/Wrapper":"8oy7r","../common/Filters":"5hY8D","common/api/v1/helpers":"6jovr","@mui/utils/capitalize":"5sWY4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4OX6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Production", ()=>Production);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _notFound = require("../common/NotFound");
var _productionPage = require("./ProductionPage");
var _routes = require("../../utils/routes");
var _editOverlay = require("./overlay/EditOverlay");
const Production = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `overlays/${(0, _routes.SUB_PATH).UPDATE}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editOverlay.EditOverlay), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `overlays/${(0, _routes.SUB_PATH).NEW}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editOverlay.EditOverlay), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `overlays/${(0, _routes.SUB_PATH).COPY}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editOverlay.EditOverlay), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `overlays`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Navigate), {
                    to: (0, _routes.ROUTES).production
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _productionPage.ProductionPage), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../common/NotFound":"1Msr5","./ProductionPage":"98mvQ","../../utils/routes":"cqMGU","./overlay/EditOverlay":"kAkdJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"98mvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductionPage", ()=>ProductionPage);
var _jsxRuntime = require("react/jsx-runtime");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _list = require("./overlay/List");
const ProductionPage = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: "Production tools",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.OverlaysList), {})
    });
};

},{"react/jsx-runtime":"1dlk8","../common/Wrapper":"8oy7r","./overlay/List":"hwdMM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwdMM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverlaysList", ()=>OverlaysList);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../../common/Form");
var _table = require("../../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _reactRouter = require("react-router");
var _store = require("../../../store");
var _link = require("../../common/Link");
var _reactRedux = require("react-redux");
var _overlaysActions = require("../../../redux/actions/overlaysActions");
var _deleteButton = require("../../common/DeleteButton");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _utils = require("../../../utils");
var _reactAsyncHook = require("react-async-hook");
const { overlaysApi } = (0, _store.Api);
const OverlaysList = ()=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const searchParams = (0, _utils.usePageParamsFiltered)();
    const { result, execute: refresh } = (0, _reactAsyncHook.useAsync)(()=>(0, _overlaysActions.listOverlaysHook)(searchParams, {
            dispatch,
            overlaysApi
        }), [
        JSON.stringify(searchParams)
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
        title: "Overlays",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                lg: 12,
                xl: 12,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                    pending: !result,
                    children: result && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                        emptyMessageComponent: "No overlays found",
                        data: result.items,
                        pagination: {
                            total: result.total,
                            useUrlSearchParams: true
                        },
                        config: [
                            {
                                title: 'name',
                                getValue: ({ name, id: overlayId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                        underline: "hover",
                                        to: routes.overlaysUpdate({
                                            id: overlayId
                                        }),
                                        style: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            flex: 1
                                        },
                                        muiStyle: {
                                            gap: 12
                                        },
                                        children: name
                                    })
                            },
                            {
                                getValue: ({ name, id: overlayId })=>overlayId && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteButton.DeleteButton), {
                                        callback: ()=>dispatch((0, _overlaysActions.deleteOverlay)(overlayId)).then(()=>refresh()),
                                        confirmMessage: "Are you sure you want to delete this overlay? Removing an overlay used by an active stream will cause it to glitch for a moment.",
                                        name: name
                                    }),
                                props: {
                                    align: 'right',
                                    noTypography: true
                                }
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                lg: 12,
                xl: 12,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                    main: {
                        'Create overlay': {
                            primary: true,
                            onClick: ()=>navigate(routes.overlaysNew())
                        }
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","../../common/Form":"4Mui7","../../common/Table":"dt9lf","react-router":"iaz4C","../../../store":"5LXiG","../../common/Link":"l3o6V","react-redux":"l1pMU","../../../redux/actions/overlaysActions":"ff6Jg","../../common/DeleteButton":"6bAes","../../common/Pendable":"gDN67","../../../utils":"342UB","react-async-hook":"3D6Y9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6bAes":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteButton", ()=>DeleteButton);
var _jsxRuntime = require("react/jsx-runtime");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _hooks = require("../../utils/hooks");
const DeleteButton = ({ callback, confirmMessage, name })=>{
    const setConfirm = (0, _hooks.useConfirmationDialog)();
    const handleDelete = (event)=>{
        event.stopPropagation();
        setConfirm(()=>{
            callback();
        }, confirmMessage, name);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
        direction: "row",
        justifyContent: "flex-end",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
            onClick: (e)=>{
                handleDelete(e);
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/icons-material/Delete":"69aC7","@mui/material/IconButton":"488As","@mui/material/Stack":"6thYv","../../utils/hooks":"5aY3q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kAkdJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditOverlay", ()=>EditOverlay);
var _jsxRuntime = require("react/jsx-runtime");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _reactRouter = require("react-router");
var _form = require("../../common/Form");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _addPhotoAlternate = require("@mui/icons-material/AddPhotoAlternate");
var _addPhotoAlternateDefault = parcelHelpers.interopDefault(_addPhotoAlternate);
var _save = require("@mui/icons-material/Save");
var _saveDefault = parcelHelpers.interopDefault(_save);
var _textIncrease = require("@mui/icons-material/TextIncrease");
var _textIncreaseDefault = parcelHelpers.interopDefault(_textIncrease);
var _componentEditor = require("./ComponentEditor");
var _previewCanvas = require("./PreviewCanvas");
var _reactRedux = require("react-redux");
var _overlaysActions = require("../../../redux/actions/overlaysActions");
var _routes = require("../../../utils/routes");
var _hooks = require("../../../utils/hooks");
var _util = require("common/util");
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
const EditOverlay = ()=>{
    const { id: overlayId } = (0, _reactRouter.useParams)();
    const [selectedOverlay, setSelectedOverlay] = (0, _react.useState)();
    const [originalOverlay, setOriginalOverlay] = (0, _react.useState)();
    const [saving, setSaving] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(false);
    const overlay = (0, _reactRedux.useSelector)(({ overlaysReducer })=>overlaysReducer.selectedOverlay, (0, _util.equals));
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouter.useNavigate)();
    const resolutions = [
        '720x576',
        '1280x720',
        '1920x1080',
        '3840x2160'
    ];
    const setConfirm = (0, _hooks.useConfirmationDialog)();
    (0, _react.useEffect)(()=>{
        if (overlayId) {
            setSelectedOverlay(overlay);
            setOriginalOverlay(overlay);
        } else {
            const initialState = {
                name: '',
                previewResolution: '1280x720',
                components: []
            };
            setSelectedOverlay(initialState);
            setOriginalOverlay(initialState);
        }
    }, [
        overlay
    ]);
    (0, _react.useEffect)(()=>{
        if (overlayId) dispatch((0, _overlaysActions.getOverlay)(overlayId));
    }, []);
    const handleSave = ()=>{
        setSaving(true);
        if (!selectedOverlay) return;
        if (!selectedOverlay.name || selectedOverlay.name.length === 0) {
            setError(true);
            return;
        }
        if (overlayId) setConfirm(()=>{
            dispatch((0, _overlaysActions.updateOverlay)(selectedOverlay));
            navigate((0, _routes.ROUTES).production);
        }, 'Are you sure you want to save this overlay? This will cause all streams using the overlay to glitch for a moment.', selectedOverlay.name, undefined, ()=>{
            setSaving(false);
        });
        else dispatch((0, _overlaysActions.updateOverlay)(selectedOverlay)).then(()=>{
            navigate((0, _routes.ROUTES).production);
        });
    };
    const updateComponent = (index, component)=>{
        if (!selectedOverlay) return;
        const updatedComponents = selectedOverlay.components.slice();
        if (!component) updatedComponents.splice(index, 1);
        else updatedComponents[index] = component;
        setSelectedOverlay({
            ...selectedOverlay,
            components: updatedComponents
        });
    };
    const addImage = ()=>{
        if (!selectedOverlay) return;
        const emptyImage = {
            type: 'image',
            data: '',
            x: {
                value: 0,
                baseline: 'start'
            },
            y: {
                value: 0,
                baseline: 'start'
            },
            maxWidth: 100,
            maxHeight: 100,
            opacity: 1
        };
        const firstTextIndex = selectedOverlay.components.findIndex((component)=>component.type === 'text');
        if (firstTextIndex === -1) {
            setSelectedOverlay({
                ...selectedOverlay,
                components: [
                    ...selectedOverlay.components,
                    emptyImage
                ]
            });
            return;
        }
        const updatedComponents = selectedOverlay.components.slice();
        updatedComponents.splice(firstTextIndex, 0, emptyImage);
        setSelectedOverlay({
            ...selectedOverlay,
            components: updatedComponents
        });
    };
    const addText = ()=>{
        if (!selectedOverlay) return;
        const newText = {
            type: 'text',
            text: '',
            x: {
                value: 0,
                baseline: 'start'
            },
            y: {
                value: 0,
                baseline: 'start'
            },
            color: '#000000',
            fontSize: 32
        };
        setSelectedOverlay({
            ...selectedOverlay,
            components: [
                ...selectedOverlay.components,
                newText
            ]
        });
    };
    if (!selectedOverlay) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: [
            'Production tools',
            'Overlays',
            overlayId && selectedOverlay ? selectedOverlay.name : 'New'
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                enabled: !(0, _util.equals)(originalOverlay, selectedOverlay) && !saving
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                        lg: 6,
                        xl: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "column",
                            spacing: 2,
                            sx: {
                                minWidth: '100%'
                            },
                            children: [
                                selectedOverlay && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewCanvas.PreviewCanvas), {
                                    overlay: selectedOverlay,
                                    resolution: selectedOverlay.previewResolution
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    variant: "body2",
                                    color: "textSecondary",
                                    children: "Preview may not reflect the final output perfectly. Test on a stream to evaluate the result."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                        lg: 6,
                        xl: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "column",
                            spacing: 2,
                            sx: {
                                minWidth: '100%'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                    direction: "row",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                            fullWidth: true,
                                            id: "name",
                                            label: "Name",
                                            required: true,
                                            helperText: error && (!selectedOverlay.name || selectedOverlay.name.length === 0) && 'Name is required',
                                            error: error && (!selectedOverlay.name || selectedOverlay.name.length === 0),
                                            value: selectedOverlay.name,
                                            onChange: (event)=>setSelectedOverlay({
                                                    ...selectedOverlay,
                                                    name: event.target.value
                                                })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                                    id: "resolution-label",
                                                    children: "Simulated resolution"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                                                    labelId: "resolution-label",
                                                    id: "resolution",
                                                    value: selectedOverlay.previewResolution,
                                                    label: "Simulated resolution",
                                                    onChange: (event)=>{
                                                        setSelectedOverlay({
                                                            ...selectedOverlay,
                                                            previewResolution: event.target.value
                                                        });
                                                    },
                                                    children: resolutions.map((resolution)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                                            value: resolution,
                                                            children: resolution.replace('x', ' x ')
                                                        }, 'overlay-resolution-select-' + resolution))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                    direction: "row",
                                    spacing: 2,
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "h4",
                                            children: "Components"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            sx: {
                                                flexGrow: 1
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                            variant: "outlined",
                                            color: "primary",
                                            startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addPhotoAlternateDefault.default), {}),
                                            onClick: addImage,
                                            children: "Add Image"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                            variant: "outlined",
                                            color: "primary",
                                            startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textIncreaseDefault.default), {}),
                                            onClick: addText,
                                            children: "Add Text"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                            variant: "contained",
                                            color: "primary",
                                            startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _saveDefault.default), {}),
                                            onClick: handleSave,
                                            children: "Save"
                                        })
                                    ]
                                }),
                                selectedOverlay?.components.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                    direction: "column",
                                    spacing: 1,
                                    alignItems: "center",
                                    sx: {
                                        py: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "h4",
                                            children: "No components found"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "body2",
                                            children: "Try adding some above!"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: selectedOverlay?.components.map((component, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componentEditor.ComponentEditor), {
                                            index: index,
                                            component: component,
                                            updateComponent: updateComponent
                                        }, index))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","../../common/Wrapper":"8oy7r","react-router":"iaz4C","../../common/Form":"4Mui7","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/FormControl":"ioFZ4","@mui/material/InputLabel":"5EJtb","@mui/material/MenuItem":"krMs8","@mui/material/Select":"kyj0v","@mui/material/Stack":"6thYv","@mui/material/Typography":"6NtGx","@mui/icons-material/AddPhotoAlternate":"l6ij6","@mui/icons-material/Save":"gNuIE","@mui/icons-material/TextIncrease":"hdzXl","./ComponentEditor":"iAhDW","./PreviewCanvas":"cmKSv","react-redux":"l1pMU","../../../redux/actions/overlaysActions":"ff6Jg","../../../utils/routes":"cqMGU","../../../utils/hooks":"5aY3q","common/util":"jV4UZ","@mui/material/TextField":"l88b4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l6ij6":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("992ad270411e20d4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("332fa3d60d6e396f"));
var _jsxRuntime = require("8e252d1e4e17d68f");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8zM5 19l3-4 2 3 3-4 4 5z"
}), 'AddPhotoAlternate');

},{"992ad270411e20d4":"kZ6eK","332fa3d60d6e396f":"2vOnF","8e252d1e4e17d68f":"1dlk8"}],"gNuIE":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("764c92dd119a77f8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("3d1c20e4ed1c6d6a"));
var _jsxRuntime = require("d076b77a3f3fb6b2");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), 'Save');

},{"764c92dd119a77f8":"kZ6eK","3d1c20e4ed1c6d6a":"2vOnF","d076b77a3f3fb6b2":"1dlk8"}],"hdzXl":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("3aae5a2c54e107c0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6337c765b9ab31c4"));
var _jsxRuntime = require("8886796c7cc7cb55");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5zm4.42-5.61L7.44 7.6h.12l2.03 5.79zM20 11h3v2h-3v3h-2v-3h-3v-2h3V8h2z"
}), 'TextIncrease');

},{"3aae5a2c54e107c0":"kZ6eK","6337c765b9ab31c4":"2vOnF","8886796c7cc7cb55":"1dlk8"}],"iAhDW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponentEditor", ()=>ComponentEditor);
var _jsxRuntime = require("react/jsx-runtime");
var _textEditor = require("./TextEditor");
var _imageEditor = require("./ImageEditor");
const ComponentEditor = ({ component, index, updateComponent })=>{
    if (component.type === 'image') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageEditor.ImageEditor), {
        component: component,
        index: index,
        updateComponent: updateComponent
    });
    if (component.type === 'text') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textEditor.TextEditor), {
        component: component,
        index: index,
        updateComponent: updateComponent
    });
    return null;
};

},{"react/jsx-runtime":"1dlk8","./TextEditor":"lir9C","./ImageEditor":"hJcQ9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lir9C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextEditor", ()=>TextEditor);
var _jsxRuntime = require("react/jsx-runtime");
var _accordion = require("@mui/material/Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionDetails = require("@mui/material/AccordionDetails");
var _accordionDetailsDefault = parcelHelpers.interopDefault(_accordionDetails);
var _accordionSummary = require("@mui/material/AccordionSummary");
var _accordionSummaryDefault = parcelHelpers.interopDefault(_accordionSummary);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _outlinedInput = require("@mui/material/OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _coordinateControls = require("./CoordinateControls");
var _muiColorInput = require("mui-color-input");
var _boxControls = require("./BoxControls");
var _xDatePickers = require("@mui/x-date-pickers");
var _react = require("react");
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
const validPresets = [
    'timecode',
    'datetime',
    'codec',
    'encoder'
];
const TextEditor = ({ component, index, updateComponent })=>{
    const [areYouSure, setAreYouSure] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionSummaryDefault.default), {
                expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.ArrowDropDownIcon), {}),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                    direction: "row",
                    spacing: 2,
                    alignItems: "center",
                    justifyContent: "space-between",
                    sx: {
                        minWidth: '100%',
                        pr: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "h5",
                            children: "Text"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "body1",
                            children: component.preset ? `Preset - ${component.preset.charAt(0).toUpperCase() + component.preset.slice(1)}` : component.text
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                flexGrow: 1
                            }
                        }),
                        !areYouSure && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            onClick: (e)=>{
                                e.stopPropagation();
                                setAreYouSure(true);
                                setTimeout(()=>setAreYouSure(false), 5000);
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
                        }),
                        areYouSure && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "text",
                            color: "error",
                            onClick: (e)=>{
                                e.stopPropagation();
                                setAreYouSure(false);
                                updateComponent(index, undefined);
                            },
                            children: "Are you sure?"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionDetailsDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                    direction: "column",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                                    variant: "outlined",
                                    fullWidth: true,
                                    disabled: component.preset ? true : false,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                            htmlFor: "text-label",
                                            children: "Text"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                                            id: "text",
                                            label: "Text",
                                            value: component.text,
                                            onChange: (event)=>updateComponent(index, {
                                                    ...component,
                                                    text: event.target.value
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                            id: "preset-label",
                                            children: "Preset"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectDefault.default), {
                                            labelId: "preset-label",
                                            id: "preset",
                                            value: component.preset || '',
                                            label: "Preset",
                                            onChange: (event)=>{
                                                if (!event.target.value) {
                                                    updateComponent(index, {
                                                        ...component,
                                                        preset: undefined
                                                    });
                                                    return;
                                                }
                                                if (validPresets.includes(event.target.value)) updateComponent(index, {
                                                    ...component,
                                                    preset: event.target.value,
                                                    text: ''
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                                    value: "",
                                                    children: "None"
                                                }),
                                                validPresets.map((preset)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                                        value: preset,
                                                        children: preset.charAt(0).toUpperCase() + preset.slice(1)
                                                    }, 'overlay-text-preset-select-' + preset))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coordinateControls.CoordinateControls), {
                            component: component,
                            index: index,
                            updateComponent: updateComponent
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiColorInput.MuiColorInput), {
                                    format: "hex",
                                    value: component.color,
                                    onChange: (color)=>updateComponent(index, {
                                            ...component,
                                            color
                                        }),
                                    isAlphaHidden: true,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                            htmlFor: "font-size-label",
                                            children: "Font size"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                                            id: "font-size",
                                            label: "Font size",
                                            type: "number",
                                            endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
                                                position: "end",
                                                children: "px"
                                            }),
                                            value: component.fontSize,
                                            onChange: (event)=>updateComponent(index, {
                                                    ...component,
                                                    fontSize: parseInt(event.target.value) || 0
                                                }),
                                            onWheel: (e)=>e.target.blur()
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxControls.BoxControls), {
                            component: component,
                            index: index,
                            updateComponent: updateComponent
                        })
                    ]
                })
            })
        ]
    }, index);
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Accordion":"gSEZa","@mui/material/AccordionDetails":"l0GkN","@mui/material/AccordionSummary":"a34y4","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/FormControl":"ioFZ4","@mui/material/IconButton":"488As","@mui/material/InputAdornment":"3vWJT","@mui/material/InputLabel":"5EJtb","@mui/material/OutlinedInput":"h57br","@mui/material/Stack":"6thYv","@mui/material/Typography":"6NtGx","@mui/icons-material/Delete":"69aC7","./CoordinateControls":"kyLu5","mui-color-input":"eRL6U","./BoxControls":"5YlRS","@mui/x-date-pickers":"gSoHo","react":"9njXz","@mui/material/MenuItem":"krMs8","@mui/material/Select":"kyj0v","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gSEZa":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("575ed7d67559efcb").default;
var _interopRequireDefault = require("9f70492a93af730d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    accordionClasses: true
};
Object.defineProperty(exports, "accordionClasses", {
    enumerable: true,
    get: function() {
        return _accordionClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Accordion.default;
    }
});
var _Accordion = _interopRequireDefault(require("b5907b49f9d86386"));
var _accordionClasses = _interopRequireWildcard(require("81a2333921ad9f8e"));
Object.keys(_accordionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _accordionClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _accordionClasses[key];
        }
    });
});

},{"575ed7d67559efcb":"fiRIh","9f70492a93af730d":"kZ6eK","b5907b49f9d86386":"aSG56","81a2333921ad9f8e":"lJrz3"}],"aSG56":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e0d01201155f4eba").default;
var _interopRequireWildcard = require("12be9feb72bfb191").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("89de1c3dbe2193d"));
var _reactIs = require("78210c74e8e198fc");
var _propTypes = _interopRequireDefault(require("40733a02fc947108"));
var _clsx = _interopRequireDefault(require("e22fa93457e788b8"));
var _chainPropTypes = _interopRequireDefault(require("4c4421e3dd7540f2"));
var _composeClasses = _interopRequireDefault(require("249d93a1091f776d"));
var _zeroStyled = require("94156127dba0442b");
var _memoTheme = _interopRequireDefault(require("a2ce742342f1606"));
var _DefaultPropsProvider = require("8b0f5fb7928d35a0");
var _Collapse = _interopRequireDefault(require("7c0e392ee1f17655"));
var _Paper = _interopRequireDefault(require("7a58dfd07c798d5b"));
var _AccordionContext = _interopRequireDefault(require("f1188c4787589bf3"));
var _useControlled = _interopRequireDefault(require("5b29229b7293299b"));
var _useSlot = _interopRequireDefault(require("27d5df71dbfff853"));
var _accordionClasses = _interopRequireWildcard(require("4ceeba051829ea90"));
var _jsxRuntime = require("79c27d3321c9ba8a");
const useUtilityClasses = (ownerState)=>{
    const { classes, square, expanded, disabled, disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        heading: [
            'heading'
        ],
        region: [
            'region'
        ]
    };
    return (0, _composeClasses.default)(slots, _accordionClasses.getAccordionUtilityClass, classes);
};
const AccordionRoot = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_accordionClasses.default.region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})((0, _memoTheme.default)(({ theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${_accordionClasses.default.expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${_accordionClasses.default.disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}), (0, _memoTheme.default)(({ theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${_accordionClasses.default.expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    })));
const AccordionHeading = (0, _zeroStyled.styled)('h3', {
    name: 'MuiAccordion',
    slot: 'Heading'
})({
    all: 'unset'
});
const Accordion = /*#__PURE__*/ React.forwardRef(function Accordion(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className, defaultExpanded = false, disabled = false, disableGutters = false, expanded: expandedProp, onChange, square = false, slots = {}, slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, ...other } = props;
    const [expanded, setExpandedState] = (0, _useControlled.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = React.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = React.Children.toArray(childrenProp);
    const contextValue = React.useMemo(()=>({
            expanded,
            disabled,
            disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = {
        ...props,
        square,
        disabled,
        disableGutters,
        expanded
    };
    const classes = useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, _useSlot.default)('root', {
        elementType: AccordionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        className: (0, _clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        ownerState,
        ref,
        additionalProps: {
            square
        }
    });
    const [AccordionHeadingSlot, accordionProps] = (0, _useSlot.default)('heading', {
        elementType: AccordionHeading,
        externalForwardedProps,
        className: classes.heading,
        ownerState
    });
    const [TransitionSlot, transitionProps] = (0, _useSlot.default)('transition', {
        elementType: _Collapse.default,
        externalForwardedProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccordionHeadingSlot, {
                ...accordionProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_AccordionContext.default.Provider, {
                    value: contextValue,
                    children: summary
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, {
                in: expanded,
                timeout: "auto",
                ...transitionProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            })
        ]
    });
});
var _default = exports.default = Accordion;

},{"e0d01201155f4eba":"kZ6eK","12be9feb72bfb191":"fiRIh","89de1c3dbe2193d":"9njXz","78210c74e8e198fc":"bmrco","40733a02fc947108":"bnNSm","e22fa93457e788b8":"d2NWs","4c4421e3dd7540f2":"4stnp","249d93a1091f776d":"59Equ","94156127dba0442b":"hZXDo","a2ce742342f1606":"cJNjb","8b0f5fb7928d35a0":"9bD8g","7c0e392ee1f17655":"c7nwP","7a58dfd07c798d5b":"aexCI","f1188c4787589bf3":"kgJvi","5b29229b7293299b":"2pWHX","27d5df71dbfff853":"h76AU","4ceeba051829ea90":"lJrz3","79c27d3321c9ba8a":"1dlk8"}],"kgJvi":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("2f56e44ffb5883ac").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("260ef8d2031e61e"));
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const AccordionContext = /*#__PURE__*/ React.createContext({});
var _default = exports.default = AccordionContext;

},{"2f56e44ffb5883ac":"fiRIh","260ef8d2031e61e":"9njXz"}],"lJrz3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d9cf9abda3d1c47e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getAccordionUtilityClass = getAccordionUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("241daf57ed5b05be"));
var _generateUtilityClass = _interopRequireDefault(require("59fdb78f7ae9d28f"));
function getAccordionUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiAccordion', slot);
}
const accordionClasses = (0, _generateUtilityClasses.default)('MuiAccordion', [
    'root',
    'heading',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var _default = exports.default = accordionClasses;

},{"d9cf9abda3d1c47e":"kZ6eK","241daf57ed5b05be":"7pSUk","59fdb78f7ae9d28f":"jBs9M"}],"l0GkN":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("72c9a8c43f383d7d").default;
var _interopRequireDefault = require("5ff71122dcc2f6d4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    accordionDetailsClasses: true
};
Object.defineProperty(exports, "accordionDetailsClasses", {
    enumerable: true,
    get: function() {
        return _accordionDetailsClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _AccordionDetails.default;
    }
});
var _AccordionDetails = _interopRequireDefault(require("d4b5077fd85bb826"));
var _accordionDetailsClasses = _interopRequireWildcard(require("f5419e3c986793b4"));
Object.keys(_accordionDetailsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _accordionDetailsClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _accordionDetailsClasses[key];
        }
    });
});

},{"72c9a8c43f383d7d":"fiRIh","5ff71122dcc2f6d4":"kZ6eK","d4b5077fd85bb826":"epZZc","f5419e3c986793b4":"9WVug"}],"epZZc":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e3e33065ad57d72c").default;
var _interopRequireWildcard = require("153929b781f86f5b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("408e193f03a638af"));
var _propTypes = _interopRequireDefault(require("3baa222191939a17"));
var _clsx = _interopRequireDefault(require("93b24af0f2678cb1"));
var _composeClasses = _interopRequireDefault(require("2e85f1281d7863d2"));
var _zeroStyled = require("8612a889f98607a8");
var _memoTheme = _interopRequireDefault(require("c0c892403613a92b"));
var _DefaultPropsProvider = require("a1e457bc8d847ac4");
var _accordionDetailsClasses = require("112308e1372f876");
var _jsxRuntime = require("524445851dc08b47");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _accordionDetailsClasses.getAccordionDetailsUtilityClass, classes);
};
const AccordionDetailsRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root'
})((0, _memoTheme.default)(({ theme })=>({
        padding: theme.spacing(1, 2, 2)
    })));
const AccordionDetails = /*#__PURE__*/ React.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className, ...other } = props;
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccordionDetailsRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var _default = exports.default = AccordionDetails;

},{"e3e33065ad57d72c":"kZ6eK","153929b781f86f5b":"fiRIh","408e193f03a638af":"9njXz","3baa222191939a17":"bnNSm","93b24af0f2678cb1":"d2NWs","2e85f1281d7863d2":"59Equ","8612a889f98607a8":"hZXDo","c0c892403613a92b":"cJNjb","a1e457bc8d847ac4":"9bD8g","112308e1372f876":"9WVug","524445851dc08b47":"1dlk8"}],"9WVug":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b1bfaf1ca8fd1dbc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getAccordionDetailsUtilityClass = getAccordionDetailsUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("41a61fbae9fe4bcf"));
var _generateUtilityClass = _interopRequireDefault(require("410eea59017be85e"));
function getAccordionDetailsUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiAccordionDetails', slot);
}
const accordionDetailsClasses = (0, _generateUtilityClasses.default)('MuiAccordionDetails', [
    'root'
]);
var _default = exports.default = accordionDetailsClasses;

},{"b1bfaf1ca8fd1dbc":"kZ6eK","41a61fbae9fe4bcf":"7pSUk","410eea59017be85e":"jBs9M"}],"a34y4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("8ee6475b614b784c").default;
var _interopRequireDefault = require("9b03e1c0c1c97587").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    accordionSummaryClasses: true
};
Object.defineProperty(exports, "accordionSummaryClasses", {
    enumerable: true,
    get: function() {
        return _accordionSummaryClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _AccordionSummary.default;
    }
});
var _AccordionSummary = _interopRequireDefault(require("3848c438f2f8b38"));
var _accordionSummaryClasses = _interopRequireWildcard(require("79ae58452c987121"));
Object.keys(_accordionSummaryClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _accordionSummaryClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _accordionSummaryClasses[key];
        }
    });
});

},{"8ee6475b614b784c":"fiRIh","9b03e1c0c1c97587":"kZ6eK","3848c438f2f8b38":"gzM9Z","79ae58452c987121":"8i2Xu"}],"gzM9Z":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ca12d59ce140ce2c").default;
var _interopRequireWildcard = require("e68d52eca72f0aaf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("8caa0bc2663cf1a7"));
var _propTypes = _interopRequireDefault(require("815a29c141d69e1f"));
var _clsx = _interopRequireDefault(require("4405ef886be2a447"));
var _composeClasses = _interopRequireDefault(require("d82c78c3bad912d3"));
var _zeroStyled = require("591c653db7c86c62");
var _memoTheme = _interopRequireDefault(require("dd907e14ba7dd08e"));
var _DefaultPropsProvider = require("a7c37163d7dc2998");
var _ButtonBase = _interopRequireDefault(require("6816dd2cfbd852b1"));
var _AccordionContext = _interopRequireDefault(require("75e7718a2ed1e23a"));
var _accordionSummaryClasses = _interopRequireWildcard(require("86146a10f6ccd6b1"));
var _useSlot = _interopRequireDefault(require("cd35dd609943e5a6"));
var _jsxRuntime = require("917a5db27fb0a0a5");
const useUtilityClasses = (ownerState)=>{
    const { classes, expanded, disabled, disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, _composeClasses.default)(slots, _accordionSummaryClasses.getAccordionSummaryUtilityClass, classes);
};
const AccordionSummaryRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiAccordionSummary',
    slot: 'Root'
})((0, _memoTheme.default)(({ theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        width: '100%',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${_accordionSummaryClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${_accordionSummaryClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${_accordionSummaryClasses.default.disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${_accordionSummaryClasses.default.expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
}));
const AccordionSummaryContent = (0, _zeroStyled.styled)('span', {
    name: 'MuiAccordionSummary',
    slot: 'Content'
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        textAlign: 'start',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${_accordionSummaryClasses.default.expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    })));
const AccordionSummaryExpandIconWrapper = (0, _zeroStyled.styled)('span', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper'
})((0, _memoTheme.default)(({ theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${_accordionSummaryClasses.default.expanded}`]: {
            transform: 'rotate(180deg)'
        }
    })));
const AccordionSummary = /*#__PURE__*/ React.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children, className, expandIcon, focusVisibleClassName, onClick, slots, slotProps, ...other } = props;
    const { disabled = false, disableGutters, expanded, toggle } = React.useContext(_AccordionContext.default);
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = {
        ...props,
        expanded,
        disabled,
        disableGutters
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots,
        slotProps
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        ref,
        shouldForwardComponentProp: true,
        className: (0, _clsx.default)(classes.root, className),
        elementType: AccordionSummaryRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState,
        additionalProps: {
            focusRipple: false,
            disableRipple: true,
            disabled,
            'aria-expanded': expanded,
            focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName)
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [ContentSlot, contentSlotProps] = (0, _useSlot.default)('content', {
        className: classes.content,
        elementType: AccordionSummaryContent,
        externalForwardedProps,
        ownerState
    });
    const [ExpandIconWrapperSlot, expandIconWrapperSlotProps] = (0, _useSlot.default)('expandIconWrapper', {
        className: classes.expandIconWrapper,
        elementType: AccordionSummaryExpandIconWrapper,
        externalForwardedProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContentSlot, {
                ...contentSlotProps,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandIconWrapperSlot, {
                ...expandIconWrapperSlotProps,
                children: expandIcon
            })
        ]
    });
});
var _default = exports.default = AccordionSummary;

},{"ca12d59ce140ce2c":"kZ6eK","e68d52eca72f0aaf":"fiRIh","8caa0bc2663cf1a7":"9njXz","815a29c141d69e1f":"bnNSm","4405ef886be2a447":"d2NWs","d82c78c3bad912d3":"59Equ","591c653db7c86c62":"hZXDo","dd907e14ba7dd08e":"cJNjb","a7c37163d7dc2998":"9bD8g","6816dd2cfbd852b1":"7X8rf","75e7718a2ed1e23a":"kgJvi","86146a10f6ccd6b1":"8i2Xu","cd35dd609943e5a6":"h76AU","917a5db27fb0a0a5":"1dlk8"}],"8i2Xu":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("de3f6be08155c6b3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getAccordionSummaryUtilityClass = getAccordionSummaryUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("abac0657265bed6f"));
var _generateUtilityClass = _interopRequireDefault(require("4c32999746f5c58a"));
function getAccordionSummaryUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiAccordionSummary', slot);
}
const accordionSummaryClasses = (0, _generateUtilityClasses.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var _default = exports.default = accordionSummaryClasses;

},{"de3f6be08155c6b3":"kZ6eK","abac0657265bed6f":"7pSUk","4c32999746f5c58a":"jBs9M"}],"kyLu5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoordinateControls", ()=>CoordinateControls);
var _jsxRuntime = require("react/jsx-runtime");
var _alignHorizontalLeft = require("@mui/icons-material/AlignHorizontalLeft");
var _alignHorizontalLeftDefault = parcelHelpers.interopDefault(_alignHorizontalLeft);
var _alignHorizontalRight = require("@mui/icons-material/AlignHorizontalRight");
var _alignHorizontalRightDefault = parcelHelpers.interopDefault(_alignHorizontalRight);
var _verticalAlignBottom = require("@mui/icons-material/VerticalAlignBottom");
var _verticalAlignBottomDefault = parcelHelpers.interopDefault(_verticalAlignBottom);
var _verticalAlignTop = require("@mui/icons-material/VerticalAlignTop");
var _verticalAlignTopDefault = parcelHelpers.interopDefault(_verticalAlignTop);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _outlinedInput = require("@mui/material/OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _toggleButton = require("@mui/material/ToggleButton");
var _toggleButtonDefault = parcelHelpers.interopDefault(_toggleButton);
var _toggleButtonGroup = require("@mui/material/ToggleButtonGroup");
var _toggleButtonGroupDefault = parcelHelpers.interopDefault(_toggleButtonGroup);
const CoordinateControls = ({ component, index, updateComponent })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
        direction: "row",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                variant: "outlined",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                        htmlFor: "x-pos-label",
                        children: "X Offset"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                        id: "x-pos",
                        label: "X Offset",
                        endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
                            position: "end",
                            children: "px"
                        }),
                        value: component.x.value,
                        onChange: (event)=>updateComponent(index, {
                                ...component,
                                x: {
                                    ...component.x,
                                    value: parseInt(event.target.value) || 0
                                }
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toggleButtonGroupDefault.default), {
                exclusive: true,
                value: component.x.baseline,
                onChange: (_, value)=>{
                    if (!value) return;
                    updateComponent(index, {
                        ...component,
                        x: {
                            ...component.x,
                            baseline: value
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButtonDefault.default), {
                        value: "start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alignHorizontalLeftDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButtonDefault.default), {
                        value: "end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alignHorizontalRightDefault.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                variant: "outlined",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                        htmlFor: "y-pos-label",
                        children: "Y Offset"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                        id: "y-pos",
                        label: "Y Offset",
                        endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
                            position: "end",
                            children: "px"
                        }),
                        value: component.y.value,
                        onChange: (event)=>updateComponent(index, {
                                ...component,
                                y: {
                                    ...component.y,
                                    value: parseInt(event.target.value) || 0
                                }
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toggleButtonGroupDefault.default), {
                exclusive: true,
                value: component.y.baseline,
                onChange: (_, value)=>{
                    if (!value) return;
                    updateComponent(index, {
                        ...component,
                        y: {
                            ...component.y,
                            baseline: value
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButtonDefault.default), {
                        value: "start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _verticalAlignTopDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButtonDefault.default), {
                        value: "end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _verticalAlignBottomDefault.default), {})
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/icons-material/AlignHorizontalLeft":"6Dtuy","@mui/icons-material/AlignHorizontalRight":"7LUGo","@mui/icons-material/VerticalAlignBottom":"dWbsG","@mui/icons-material/VerticalAlignTop":"k7KUn","@mui/material/FormControl":"ioFZ4","@mui/material/InputAdornment":"3vWJT","@mui/material/InputLabel":"5EJtb","@mui/material/OutlinedInput":"h57br","@mui/material/Stack":"6thYv","@mui/material/ToggleButton":"duFEX","@mui/material/ToggleButtonGroup":"fPzm8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Dtuy":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("7a109ddcc3afa2f1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("e294bedc45cae9f7"));
var _jsxRuntime = require("9e7d57eefbc5d8eb");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4 22H2V2h2zM22 7H6v3h16zm-6 7H6v3h10z"
}), 'AlignHorizontalLeft');

},{"7a109ddcc3afa2f1":"kZ6eK","e294bedc45cae9f7":"2vOnF","9e7d57eefbc5d8eb":"1dlk8"}],"7LUGo":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("6818940a13517686").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("fae9599b90b36c49"));
var _jsxRuntime = require("8a5e11037a675ae3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 2h2v20h-2zM2 10h16V7H2zm6 7h10v-3H8z"
}), 'AlignHorizontalRight');

},{"6818940a13517686":"kZ6eK","fae9599b90b36c49":"2vOnF","8a5e11037a675ae3":"1dlk8"}],"dWbsG":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("f8d98457d770fa81").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4fe58f457dc606dd"));
var _jsxRuntime = require("4fd5f8a51d63c8ad");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16 13h-3V3h-2v10H8l4 4zM4 19v2h16v-2z"
}), 'VerticalAlignBottom');

},{"f8d98457d770fa81":"kZ6eK","4fe58f457dc606dd":"2vOnF","4fd5f8a51d63c8ad":"1dlk8"}],"k7KUn":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("2a3ad25de2dfe532").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4a4dfdbcd0ad1c83"));
var _jsxRuntime = require("aabd1c55ca3a00cc");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8 11h3v10h2V11h3l-4-4zM4 3v2h16V3z"
}), 'VerticalAlignTop');

},{"2a3ad25de2dfe532":"kZ6eK","4a4dfdbcd0ad1c83":"2vOnF","aabd1c55ca3a00cc":"1dlk8"}],"duFEX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c65819579da1ad19").default;
var _interopRequireDefault = require("524090376d076b5e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    toggleButtonClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ToggleButton.default;
    }
});
Object.defineProperty(exports, "toggleButtonClasses", {
    enumerable: true,
    get: function() {
        return _toggleButtonClasses.default;
    }
});
var _ToggleButton = _interopRequireDefault(require("fbe0f76ea441b82b"));
var _toggleButtonClasses = _interopRequireWildcard(require("e8b45c8e1dbaf066"));
Object.keys(_toggleButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _toggleButtonClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _toggleButtonClasses[key];
        }
    });
});

},{"c65819579da1ad19":"fiRIh","524090376d076b5e":"kZ6eK","fbe0f76ea441b82b":"6a9TQ","e8b45c8e1dbaf066":"190uo"}],"6a9TQ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
// @inheritedComponent ButtonBase
var _interopRequireDefault = require("4d9bf846938f1b66").default;
var _interopRequireWildcard = require("a2f1b530672b31aa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("bb2b3a4ded4be2d7"));
var _propTypes = _interopRequireDefault(require("3eb6a0e1836d849f"));
var _clsx = _interopRequireDefault(require("a0ef5db53401d581"));
var _resolveProps = _interopRequireDefault(require("c2862d88cee6bf85"));
var _composeClasses = _interopRequireDefault(require("21f6f29300b51fe0"));
var _colorManipulator = require("d9ad64e16c31706f");
var _ButtonBase = _interopRequireDefault(require("5e4bc32beeb61cb6"));
var _capitalize = _interopRequireDefault(require("ce955260567c2122"));
var _zeroStyled = require("c08d658d733add5");
var _memoTheme = _interopRequireDefault(require("d33f2a5d6f03009c"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("d1b14b5cdba046f9"));
var _DefaultPropsProvider = require("6819532712a12105");
var _toggleButtonClasses = _interopRequireWildcard(require("dd36ad43da304ebb"));
var _ToggleButtonGroupContext = _interopRequireDefault(require("a6e07d9e5e236e80"));
var _ToggleButtonGroupButtonContext = _interopRequireDefault(require("3b2d16ff53321e1b"));
var _isValueSelected = _interopRequireDefault(require("516b893b784cc44d"));
var _jsxRuntime = require("1cab875d8ba548b4");
const useUtilityClasses = (ownerState)=>{
    const { classes, fullWidth, selected, disabled, size, color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, _capitalize.default)(size)}`,
            color
        ]
    };
    return (0, _composeClasses.default)(slots, _toggleButtonClasses.getToggleButtonUtilityClass, classes);
};
const ToggleButtonRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.button,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active,
        [`&.${_toggleButtonClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            {
                props: {
                    color: 'standard'
                },
                style: {
                    [`&.${_toggleButtonClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.text.primary,
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.selectedOpacity),
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.selectedOpacity)
                            }
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&.${_toggleButtonClasses.default.selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.selectedOpacity),
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.selectedOpacity)
                                }
                            }
                        }
                    }
                })),
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 7,
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 15,
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const ToggleButton = /*#__PURE__*/ React.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const { value: contextValue, ...contextProps } = React.useContext(_ToggleButtonGroupContext.default);
    const toggleButtonGroupButtonContextPositionClassName = React.useContext(_ToggleButtonGroupButtonContext.default);
    const resolvedProps = (0, _resolveProps.default)({
        ...contextProps,
        selected: (0, _isValueSelected.default)(inProps.value, contextValue)
    }, inProps);
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children, className, color = 'standard', disabled = false, disableFocusRipple = false, fullWidth = false, onChange, onClick, selected, size = 'medium', value, ...other } = props;
    const ownerState = {
        ...props,
        color,
        disabled,
        disableFocusRipple,
        fullWidth,
        size
    };
    const classes = useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToggleButtonRoot, {
        className: (0, _clsx.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected,
        ...other,
        children: children
    });
});
var _default = exports.default = ToggleButton;

},{"4d9bf846938f1b66":"kZ6eK","a2f1b530672b31aa":"fiRIh","bb2b3a4ded4be2d7":"9njXz","3eb6a0e1836d849f":"bnNSm","a0ef5db53401d581":"d2NWs","c2862d88cee6bf85":"gFBtX","21f6f29300b51fe0":"59Equ","d9ad64e16c31706f":"hTYBL","5e4bc32beeb61cb6":"7X8rf","ce955260567c2122":"eOYSA","c08d658d733add5":"hZXDo","d33f2a5d6f03009c":"cJNjb","d1b14b5cdba046f9":"2r5WG","6819532712a12105":"9bD8g","dd36ad43da304ebb":"190uo","a6e07d9e5e236e80":"80Rxt","3b2d16ff53321e1b":"kNtkz","516b893b784cc44d":"9U0Gx","1cab875d8ba548b4":"1dlk8"}],"190uo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5fce9c14b341d3a6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getToggleButtonUtilityClass = getToggleButtonUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("10609b3d00fba9ae"));
var _generateUtilityClass = _interopRequireDefault(require("2e13a7e8968ab6ce"));
function getToggleButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiToggleButton', slot);
}
const toggleButtonClasses = (0, _generateUtilityClasses.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var _default = exports.default = toggleButtonClasses;

},{"5fce9c14b341d3a6":"kZ6eK","10609b3d00fba9ae":"7pSUk","2e13a7e8968ab6ce":"jBs9M"}],"80Rxt":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("cfea24fcbe869b02").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f6a64ca7bee76d3d"));
/**
 * @ignore - internal component.
 */ const ToggleButtonGroupContext = /*#__PURE__*/ React.createContext({});
var _default = exports.default = ToggleButtonGroupContext;

},{"cfea24fcbe869b02":"fiRIh","f6a64ca7bee76d3d":"9njXz"}],"kNtkz":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("47298ef699046216").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("634c777e048443ee"));
/**
 * @ignore - internal component.
 */ const ToggleButtonGroupButtonContext = /*#__PURE__*/ React.createContext(undefined);
var _default = exports.default = ToggleButtonGroupButtonContext;

},{"47298ef699046216":"fiRIh","634c777e048443ee":"9njXz"}],"9U0Gx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isValueSelected;
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function isValueSelected(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.includes(value);
    return value === candidate;
}

},{}],"fPzm8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("cffb37ea9ddb1d9a").default;
var _interopRequireDefault = require("3b23269f0b6ee268").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    toggleButtonGroupClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ToggleButtonGroup.default;
    }
});
Object.defineProperty(exports, "toggleButtonGroupClasses", {
    enumerable: true,
    get: function() {
        return _toggleButtonGroupClasses.default;
    }
});
var _ToggleButtonGroup = _interopRequireDefault(require("626f70005e8c428"));
var _toggleButtonGroupClasses = _interopRequireWildcard(require("361184ffa82e4c9d"));
Object.keys(_toggleButtonGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _toggleButtonGroupClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _toggleButtonGroupClasses[key];
        }
    });
});

},{"cffb37ea9ddb1d9a":"fiRIh","3b23269f0b6ee268":"kZ6eK","626f70005e8c428":"kH9oi","361184ffa82e4c9d":"bM629"}],"kH9oi":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("1f2dcd582d001785").default;
var _interopRequireWildcard = require("27732767e28696d3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("b62e21b3642748cc"));
var _reactIs = require("f9a82e403b1bb5cc");
var _propTypes = _interopRequireDefault(require("2472a7b0ae233176"));
var _clsx = _interopRequireDefault(require("cbfba447a75196f5"));
var _composeClasses = _interopRequireDefault(require("7d63c47d2a80b3b0"));
var _getValidReactChildren = _interopRequireDefault(require("978111be50ee74c5"));
var _zeroStyled = require("8ede606cb68632eb");
var _memoTheme = _interopRequireDefault(require("eef14b3c7b91f728"));
var _DefaultPropsProvider = require("cde599b78b589723");
var _capitalize = _interopRequireDefault(require("3b3d2604ffc43dcd"));
var _toggleButtonGroupClasses = _interopRequireWildcard(require("a9f06627bf22e0dd"));
var _ToggleButtonGroupContext = _interopRequireDefault(require("46c715628ee3d7ba"));
var _ToggleButtonGroupButtonContext = _interopRequireDefault(require("96a57ded3354e84f"));
var _toggleButtonClasses = _interopRequireDefault(require("21bd6883accd7251"));
var _jsxRuntime = require("896a26ccd13c0ff5");
const useUtilityClasses = (ownerState)=>{
    const { classes, orientation, fullWidth, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, _capitalize.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, _composeClasses.default)(slots, _toggleButtonGroupClasses.getToggleButtonGroupUtilityClass, classes);
};
const ToggleButtonGroupRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${_toggleButtonGroupClasses.default.grouped}`]: styles.grouped
            },
            {
                [`& .${_toggleButtonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize.default)(ownerState.orientation)}`]
            },
            {
                [`& .${_toggleButtonGroupClasses.default.firstButton}`]: styles.firstButton
            },
            {
                [`& .${_toggleButtonGroupClasses.default.lastButton}`]: styles.lastButton
            },
            {
                [`& .${_toggleButtonGroupClasses.default.middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${_toggleButtonGroupClasses.default.grouped}`]: {
                        [`&.${_toggleButtonGroupClasses.default.selected} + .${_toggleButtonGroupClasses.default.grouped}.${_toggleButtonGroupClasses.default.selected}`]: {
                            borderTop: 0,
                            marginTop: 0
                        }
                    },
                    [`& .${_toggleButtonGroupClasses.default.firstButton},& .${_toggleButtonGroupClasses.default.middleButton}`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${_toggleButtonGroupClasses.default.lastButton},& .${_toggleButtonGroupClasses.default.middleButton}`]: {
                        marginTop: -1,
                        borderTop: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    },
                    [`& .${_toggleButtonGroupClasses.default.lastButton}.${_toggleButtonClasses.default.disabled},& .${_toggleButtonGroupClasses.default.middleButton}.${_toggleButtonClasses.default.disabled}`]: {
                        borderTop: '1px solid transparent'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${_toggleButtonGroupClasses.default.grouped}`]: {
                        [`&.${_toggleButtonGroupClasses.default.selected} + .${_toggleButtonGroupClasses.default.grouped}.${_toggleButtonGroupClasses.default.selected}`]: {
                            borderLeft: 0,
                            marginLeft: 0
                        }
                    },
                    [`& .${_toggleButtonGroupClasses.default.firstButton},& .${_toggleButtonGroupClasses.default.middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${_toggleButtonGroupClasses.default.lastButton},& .${_toggleButtonGroupClasses.default.middleButton}`]: {
                        marginLeft: -1,
                        borderLeft: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    },
                    [`& .${_toggleButtonGroupClasses.default.lastButton}.${_toggleButtonClasses.default.disabled},& .${_toggleButtonGroupClasses.default.middleButton}.${_toggleButtonClasses.default.disabled}`]: {
                        borderLeft: '1px solid transparent'
                    }
                }
            }
        ]
    })));
const ToggleButtonGroup = /*#__PURE__*/ React.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children, className, color = 'standard', disabled = false, exclusive = false, fullWidth = false, onChange, orientation = 'horizontal', size = 'medium', value, ...other } = props;
    const ownerState = {
        ...props,
        disabled,
        fullWidth,
        orientation,
        size
    };
    const classes = useUtilityClasses(ownerState);
    const handleChange = React.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = React.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = React.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value,
            size,
            fullWidth,
            color,
            disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, _getValidReactChildren.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToggleButtonGroupRoot, {
        role: "group",
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ToggleButtonGroupContext.default.Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ToggleButtonGroupButtonContext.default.Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var _default = exports.default = ToggleButtonGroup;

},{"1f2dcd582d001785":"kZ6eK","27732767e28696d3":"fiRIh","b62e21b3642748cc":"9njXz","f9a82e403b1bb5cc":"bmrco","2472a7b0ae233176":"bnNSm","cbfba447a75196f5":"d2NWs","7d63c47d2a80b3b0":"59Equ","978111be50ee74c5":"jAow1","8ede606cb68632eb":"hZXDo","eef14b3c7b91f728":"cJNjb","cde599b78b589723":"9bD8g","3b3d2604ffc43dcd":"eOYSA","a9f06627bf22e0dd":"bM629","46c715628ee3d7ba":"80Rxt","96a57ded3354e84f":"kNtkz","21bd6883accd7251":"190uo","896a26ccd13c0ff5":"1dlk8"}],"jAow1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e3bd2220320accba").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _getValidReactChildren.default;
    }
});
var _getValidReactChildren = _interopRequireDefault(require("5a0f8d9988cae90d"));

},{"e3bd2220320accba":"kZ6eK","5a0f8d9988cae90d":"4EE7a"}],"4EE7a":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("80f6e4e3337079ea").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getValidReactChildren;
var React = _interopRequireWildcard(require("1074f314497cf4b"));
/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 */ function getValidReactChildren(children) {
    return React.Children.toArray(children).filter((child)=>/*#__PURE__*/ React.isValidElement(child));
}

},{"80f6e4e3337079ea":"fiRIh","1074f314497cf4b":"9njXz"}],"bM629":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("bba11cb74ee75fc8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getToggleButtonGroupUtilityClass = getToggleButtonGroupUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("619ba406b85b3b16"));
var _generateUtilityClass = _interopRequireDefault(require("135346c872f2ba20"));
function getToggleButtonGroupUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiToggleButtonGroup', slot);
}
const toggleButtonGroupClasses = (0, _generateUtilityClasses.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var _default = exports.default = toggleButtonGroupClasses;

},{"bba11cb74ee75fc8":"kZ6eK","619ba406b85b3b16":"7pSUk","135346c872f2ba20":"jBs9M"}],"eRL6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiColorInput", ()=>Se);
parcelHelpers.export(exports, "MuiColorInputButton", ()=>Ft);
parcelHelpers.export(exports, "matchIsValidColor", ()=>xe);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _styles = require("@mui/material/styles");
var _popover = require("@mui/material/Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _slider = require("@mui/material/Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
const $t = "linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(135deg, transparent 75%, #ccc 75%) /*! @noflip */", It = "linear-gradient(to top, #000000, transparent), linear-gradient(to right, #ffffff, transparent) /*! @noflip */", Bt = {
    Button: (0, _styles.styled)((0, _buttonDefault.default))(()=>({
            backgroundSize: "8px 8px",
            backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
            transition: "none",
            boxShadow: "0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)",
            border: 0,
            borderRadius: 4,
            width: "24px",
            aspectRatio: "1 / 1",
            height: "24px",
            minWidth: 0
        }))
}, Ft = (r)=>{
    const { bgColor: e, className: t, disablePopover: n, isBgColorValid: i, ...s } = r;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Bt.Button, {
        disableTouchRipple: !0,
        style: {
            backgroundColor: i ? e : void 0,
            backgroundImage: i ? void 0 : $t,
            cursor: n ? "default" : void 0
        },
        className: `MuiColorInput-Button ${t || ""}`,
        variant: "text",
        disableElevation: !1,
        ...s
    });
}, Pt = {
    Container: (0, _styles.styled)("div")(()=>({
            width: 300,
            padding: 8
        }))
}, Et = ({ children: r, className: e, position: t = "start", ...n })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverDefault.default), {
        className: `MuiColorInput-Popover ${e || ""}`,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: t === "start" ? "left" : "right"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: t === "start" ? "left" : "right"
        },
        ...n,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Pt.Container, {
            children: r
        })
    }), Nt = {
    Slider: (0, _styles.styled)((0, _sliderDefault.default), {
        shouldForwardProp: (r)=>r !== "$rgbaFrom" && r !== "$rgbaTo"
    })(()=>({
            height: 8,
            "& .MuiSlider-rail": {
                opacity: 1,
                // TODO: find better way for perf
                background: "linear-gradient(to right, rgba(var(--rgb-r), var(--rgb-g), var(--rgb-b), 0) 0%, rgba(var(--rgb-r), var(--rgb-g), var(--rgb-b), 1) 100%)"
            },
            "& .MuiSlider-track": {
                color: "transparent",
                border: 0
            },
            "& .MuiSlider-thumb": {
                backgroundColor: "#ffffff",
                border: "3px solid currentColor"
            }
        }))
}, Vt = (r)=>{
    const { rgbColor: e, style: t, className: n, ...i } = r, s = {
        "--rgb-r": e.r,
        "--rgb-g": e.g,
        "--rgb-b": e.b,
        ...t
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Nt.Slider, {
        className: `MuiColorInput-AlphaSlider ${n || ""}`,
        style: s,
        ...i
    });
}, L = {
    up: "ArrowUp",
    down: "ArrowDown",
    left: "ArrowLeft",
    right: "ArrowRight"
}, Tt = {
    ArrowUp: {
        type: "hsvV",
        value: 1
    },
    ArrowDown: {
        type: "hsvV",
        value: -1
    },
    ArrowLeft: {
        type: "hsvS",
        value: -1
    },
    ArrowRight: {
        type: "hsvS",
        value: 1
    }
};
function Ot(r) {
    return r === L.up || r === L.down || r === L.left || r === L.right;
}
function W(r, e, t) {
    return Math.max(e, Math.min(r, t));
}
function et(r) {
    return typeof r == "number";
}
function rt(r, e, t) {
    const n = r.toLocaleString("en", {
        useGrouping: !1,
        minimumFractionDigits: e,
        maximumFractionDigits: t
    });
    return Number(n);
}
function Dt(r, e, t) {
    const n = r.getBoundingClientRect(), i = e - n.left, s = t - n.top;
    return {
        x: W(i / n.width, 0, 1),
        y: W(1 - s / n.height, 0, 1)
    };
}
function Lt(r) {
    const e = (0, _reactDefault.default).useRef(void 0);
    return e.current = r, (0, _reactDefault.default).useCallback((...t)=>e.current?.(...t), []);
}
const nt = {
    Space: (0, _styles.styled)("div")(()=>({
            width: "100%",
            height: "180px",
            boxSizing: "border-box",
            outline: 0,
            position: "relative",
            backgroundImage: It
        })),
    Thumb: (0, _styles.styled)("div")(()=>({
            position: "absolute",
            border: "3px solid #ffffff",
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            marginLeft: "-10px /*! @noflip */",
            marginBottom: "-10px /*! @noflip */",
            outline: 0,
            boxSizing: "border-box",
            willChange: "left, bottom",
            transition: "box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            "&:hover": {
                boxShadow: "0px 0px 0px 4px rgba(255 255 255 / 0.16)"
            },
            "&.MuiColorInput-Thumb-active": {
                boxShadow: "0px 0px 0px 8px rgba(255 255 255 / 0.16)"
            },
            "@media (hover: none)": {
                boxShadow: "none"
            }
        }))
}, jt = (r)=>{
    const { hsv: e, onChange: t, currentHue: n } = r, i = (0, _reactDefault.default).useRef(!1), s = (0, _reactDefault.default).useRef(null), [a, o] = (0, _reactDefault.default).useState(!1), u = Lt((b, k)=>{
        if (!s.current) return;
        const { x: $, y: A } = Dt(s.current, b, k);
        t({
            s: $,
            v: A
        }), s.current && document.activeElement !== s.current && s.current.focus();
    }), w = (0, _reactDefault.default).useCallback(()=>{
        i.current && (i.current = !1, o(!1));
    }, []), p = (0, _reactDefault.default).useCallback((b)=>{
        i.current && u(b.clientX, b.clientY);
    }, []);
    (0, _reactDefault.default).useEffect(()=>(document.addEventListener("pointermove", p, !1), document.addEventListener("pointerup", w, !1), ()=>{
            document.removeEventListener("pointermove", p, !1), document.removeEventListener("pointerup", w, !1);
        }), [
        w,
        p
    ]);
    const m = (b)=>{
        b.preventDefault(), i.current = !0, u(b.clientX, b.clientY), o(!0);
    }, y = (b)=>{
        if (Ot(b.key)) {
            b.preventDefault();
            const { type: k, value: $ } = Tt[b.key], A = b.shiftKey ? 10 : 1, T = k === "hsvS" ? e.s : e.v, E = W(T + $ * A * 0.01, 0, 1);
            o(!0), t({
                s: k === "hsvS" ? E : e.s,
                v: k === "hsvV" ? E : e.v
            });
        }
    }, M = e.s * 100, H = e.v * 100;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt.Space, {
        onPointerDown: m,
        ref: s,
        className: "MuiColorInput-ColorSpace",
        style: {
            backgroundColor: `hsl(${n} 100% 50%)`,
            touchAction: "none"
        },
        role: "slider",
        "aria-valuetext": `Saturation ${rt(M, 0, 0)}%, Brightness ${rt(H, 0, 0)}%`,
        onKeyDown: y,
        tabIndex: 0,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt.Thumb, {
            "aria-label": "Color space thumb",
            className: a ? "MuiColorInput-Thumb-active" : "",
            style: {
                left: `${M}%`,
                bottom: `${H}%`
            }
        })
    });
}, Gt = {
    Slider: (0, _styles.styled)((0, _sliderDefault.default))(()=>({
            height: 8,
            "& .MuiSlider-rail": {
                opacity: 1,
                background: "linear-gradient(to right, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%) /*! @noflip */"
            },
            "& .MuiSlider-track": {
                color: "transparent",
                border: 0
            },
            "& .MuiSlider-thumb": {
                backgroundColor: "#ffffff",
                border: "3px solid currentColor"
            }
        }))
}, qt = (r)=>{
    const { className: e, ...t } = r;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Gt.Slider, {
        className: `MuiColorInput-HueSlider ${e || ""}`,
        ...t
    });
};
function Wt(r) {
    return typeof r == "string";
}
function g(r, e) {
    Kt(r) && (r = "100%");
    const t = Ut(r);
    return r = e === 360 ? r : Math.min(e, Math.max(0, parseFloat(r))), t && (r = parseInt(String(r * e), 10) / 100), Math.abs(r - e) < 1e-6 ? 1 : (e === 360 ? r = (r < 0 ? r % e + e : r % e) / parseFloat(String(e)) : r = r % e / parseFloat(String(e)), r);
}
function j(r) {
    return Math.min(1, Math.max(0, r));
}
function Kt(r) {
    return typeof r == "string" && r.indexOf(".") !== -1 && parseFloat(r) === 1;
}
function Ut(r) {
    return typeof r == "string" && r.indexOf("%") !== -1;
}
function dt(r) {
    return r = parseFloat(r), (isNaN(r) || r < 0 || r > 1) && (r = 1), r;
}
function G(r) {
    return Number(r) <= 1 ? `${Number(r) * 100}%` : r;
}
function R(r) {
    return r.length === 1 ? "0" + r : String(r);
}
function zt(r, e, t) {
    return {
        r: g(r, 255) * 255,
        g: g(e, 255) * 255,
        b: g(t, 255) * 255
    };
}
function st(r, e, t) {
    r = g(r, 255), e = g(e, 255), t = g(t, 255);
    const n = Math.max(r, e, t), i = Math.min(r, e, t);
    let s = 0, a = 0;
    const o = (n + i) / 2;
    if (n === i) a = 0, s = 0;
    else {
        const u = n - i;
        switch(a = o > 0.5 ? u / (2 - n - i) : u / (n + i), n){
            case r:
                s = (e - t) / u + (e < t ? 6 : 0);
                break;
            case e:
                s = (t - r) / u + 2;
                break;
            case t:
                s = (r - e) / u + 4;
                break;
        }
        s /= 6;
    }
    return {
        h: s,
        s: a,
        l: o
    };
}
function Y(r, e, t) {
    return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? r + (e - r) * (6 * t) : t < 0.5 ? e : t < 2 / 3 ? r + (e - r) * (2 / 3 - t) * 6 : r;
}
function Yt(r, e, t) {
    let n, i, s;
    if (r = g(r, 360), e = g(e, 100), t = g(t, 100), e === 0) i = t, s = t, n = t;
    else {
        const a = t < 0.5 ? t * (1 + e) : t + e - t * e, o = 2 * t - a;
        n = Y(o, a, r + 1 / 3), i = Y(o, a, r), s = Y(o, a, r - 1 / 3);
    }
    return {
        r: n * 255,
        g: i * 255,
        b: s * 255
    };
}
function it(r, e, t) {
    r = g(r, 255), e = g(e, 255), t = g(t, 255);
    const n = Math.max(r, e, t), i = Math.min(r, e, t);
    let s = 0;
    const a = n, o = n - i, u = n === 0 ? 0 : o / n;
    if (n === i) s = 0;
    else {
        switch(n){
            case r:
                s = (e - t) / o + (e < t ? 6 : 0);
                break;
            case e:
                s = (t - r) / o + 2;
                break;
            case t:
                s = (r - e) / o + 4;
                break;
        }
        s /= 6;
    }
    return {
        h: s,
        s: u,
        v: a
    };
}
function Xt(r, e, t) {
    r = g(r, 360) * 6, e = g(e, 100), t = g(t, 100);
    const n = Math.floor(r), i = r - n, s = t * (1 - e), a = t * (1 - i * e), o = t * (1 - (1 - i) * e), u = n % 6, w = [
        t,
        a,
        s,
        s,
        o,
        t
    ][u], p = [
        o,
        t,
        t,
        a,
        s,
        s
    ][u], m = [
        s,
        s,
        o,
        t,
        t,
        a
    ][u];
    return {
        r: w * 255,
        g: p * 255,
        b: m * 255
    };
}
function at(r, e, t, n) {
    const i = [
        R(Math.round(r).toString(16)),
        R(Math.round(e).toString(16)),
        R(Math.round(t).toString(16))
    ];
    return n && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function Zt(r, e, t, n, i) {
    const s = [
        R(Math.round(r).toString(16)),
        R(Math.round(e).toString(16)),
        R(Math.round(t).toString(16)),
        R(Qt(n))
    ];
    return i && s[0].startsWith(s[0].charAt(1)) && s[1].startsWith(s[1].charAt(1)) && s[2].startsWith(s[2].charAt(1)) && s[3].startsWith(s[3].charAt(1)) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) + s[3].charAt(0) : s.join("");
}
function Jt(r, e, t, n) {
    const i = r / 100, s = e / 100, a = t / 100, o = n / 100, u = 255 * (1 - i) * (1 - o), w = 255 * (1 - s) * (1 - o), p = 255 * (1 - a) * (1 - o);
    return {
        r: u,
        g: w,
        b: p
    };
}
function ot(r, e, t) {
    let n = 1 - r / 255, i = 1 - e / 255, s = 1 - t / 255, a = Math.min(n, i, s);
    return a === 1 ? (n = 0, i = 0, s = 0) : (n = (n - a) / (1 - a) * 100, i = (i - a) / (1 - a) * 100, s = (s - a) / (1 - a) * 100), a *= 100, {
        c: Math.round(n),
        m: Math.round(i),
        y: Math.round(s),
        k: Math.round(a)
    };
}
function Qt(r) {
    return Math.round(parseFloat(r) * 255).toString(16);
}
function ht(r) {
    return S(r) / 255;
}
function S(r) {
    return parseInt(r, 16);
}
function _t(r) {
    return {
        r: r >> 16,
        g: (r & 65280) >> 8,
        b: r & 255
    };
}
const Z = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};
function te(r) {
    let e = {
        r: 0,
        g: 0,
        b: 0
    }, t = 1, n = null, i = null, s = null, a = !1, o = !1;
    return typeof r == "string" && (r = ne(r)), typeof r == "object" && (x(r.r) && x(r.g) && x(r.b) ? (e = zt(r.r, r.g, r.b), a = !0, o = String(r.r).substr(-1) === "%" ? "prgb" : "rgb") : x(r.h) && x(r.s) && x(r.v) ? (n = G(r.s), i = G(r.v), e = Xt(r.h, n, i), a = !0, o = "hsv") : x(r.h) && x(r.s) && x(r.l) ? (n = G(r.s), s = G(r.l), e = Yt(r.h, n, s), a = !0, o = "hsl") : x(r.c) && x(r.m) && x(r.y) && x(r.k) && (e = Jt(r.c, r.m, r.y, r.k), a = !0, o = "cmyk"), Object.prototype.hasOwnProperty.call(r, "a") && (t = r.a)), t = dt(t), {
        ok: a,
        format: r.format || o,
        r: Math.min(255, Math.max(e.r, 0)),
        g: Math.min(255, Math.max(e.g, 0)),
        b: Math.min(255, Math.max(e.b, 0)),
        a: t
    };
}
const ee = "[-\\+]?\\d+%?", re = "[-\\+]?\\d*\\.\\d+%?", C = "(?:" + re + ")|(?:" + ee + ")", X = "[\\s|\\(]+(" + C + ")[,|\\s]+(" + C + ")[,|\\s]+(" + C + ")\\s*\\)?", q = // eslint-disable-next-line prettier/prettier
"[\\s|\\(]+(" + C + ")[,|\\s]+(" + C + ")[,|\\s]+(" + C + ")[,|\\s]+(" + C + ")\\s*\\)?", v = {
    CSS_UNIT: new RegExp(C),
    rgb: new RegExp("rgb" + X),
    rgba: new RegExp("rgba" + q),
    hsl: new RegExp("hsl" + X),
    hsla: new RegExp("hsla" + q),
    hsv: new RegExp("hsv" + X),
    hsva: new RegExp("hsva" + q),
    cmyk: new RegExp("cmyk" + q),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function ne(r) {
    if (r = r.trim().toLowerCase(), r.length === 0) return !1;
    let e = !1;
    if (Z[r]) r = Z[r], e = !0;
    else if (r === "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    let t = v.rgb.exec(r);
    return t ? {
        r: t[1],
        g: t[2],
        b: t[3]
    } : (t = v.rgba.exec(r), t ? {
        r: t[1],
        g: t[2],
        b: t[3],
        a: t[4]
    } : (t = v.hsl.exec(r), t ? {
        h: t[1],
        s: t[2],
        l: t[3]
    } : (t = v.hsla.exec(r), t ? {
        h: t[1],
        s: t[2],
        l: t[3],
        a: t[4]
    } : (t = v.hsv.exec(r), t ? {
        h: t[1],
        s: t[2],
        v: t[3]
    } : (t = v.hsva.exec(r), t ? {
        h: t[1],
        s: t[2],
        v: t[3],
        a: t[4]
    } : (t = v.cmyk.exec(r), t ? {
        c: t[1],
        m: t[2],
        y: t[3],
        k: t[4]
    } : (t = v.hex8.exec(r), t ? {
        r: S(t[1]),
        g: S(t[2]),
        b: S(t[3]),
        a: ht(t[4]),
        format: e ? "name" : "hex8"
    } : (t = v.hex6.exec(r), t ? {
        r: S(t[1]),
        g: S(t[2]),
        b: S(t[3]),
        format: e ? "name" : "hex"
    } : (t = v.hex4.exec(r), t ? {
        r: S(t[1] + t[1]),
        g: S(t[2] + t[2]),
        b: S(t[3] + t[3]),
        a: ht(t[4] + t[4]),
        format: e ? "name" : "hex8"
    } : (t = v.hex3.exec(r), t ? {
        r: S(t[1] + t[1]),
        g: S(t[2] + t[2]),
        b: S(t[3] + t[3]),
        format: e ? "name" : "hex"
    } : !1))))))))));
}
function x(r) {
    return typeof r == "number" ? !Number.isNaN(r) : v.CSS_UNIT.test(r);
}
class h {
    constructor(e = "", t = {}){
        if (e instanceof h) return e;
        typeof e == "number" && (e = _t(e)), this.originalInput = e;
        const n = te(e);
        this.originalInput = e, this.r = n.r, this.g = n.g, this.b = n.b, this.a = n.a, this.roundA = Math.round(100 * this.a) / 100, this.format = t.format ?? n.format, this.gradientType = t.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = n.ok;
    }
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return !this.isDark();
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   */ getBrightness() {
        const e = this.toRgb();
        return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
    }
    /**
   * Returns the perceived luminance of a color, from 0-1.
   */ getLuminance() {
        const e = this.toRgb();
        let t, n, i;
        const s = e.r / 255, a = e.g / 255, o = e.b / 255;
        return s <= 0.03928 ? t = s / 12.92 : t = Math.pow((s + 0.055) / 1.055, 2.4), a <= 0.03928 ? n = a / 12.92 : n = Math.pow((a + 0.055) / 1.055, 2.4), o <= 0.03928 ? i = o / 12.92 : i = Math.pow((o + 0.055) / 1.055, 2.4), 0.2126 * t + 0.7152 * n + 0.0722 * i;
    }
    /**
   * Returns the alpha value of a color, from 0-1.
   */ getAlpha() {
        return this.a;
    }
    /**
   * Sets the alpha value on the current color.
   *
   * @param alpha - The new alpha value. The accepted range is 0-1.
   */ setAlpha(e) {
        return this.a = dt(e), this.roundA = Math.round(100 * this.a) / 100, this;
    }
    /**
   * Returns whether the color is monochrome.
   */ isMonochrome() {
        const { s: e } = this.toHsl();
        return e === 0;
    }
    /**
   * Returns the object as a HSVA object.
   */ toHsv() {
        const e = it(this.r, this.g, this.b);
        return {
            h: e.h * 360,
            s: e.s,
            v: e.v,
            a: this.a
        };
    }
    /**
   * Returns the hsva values interpolated into a string with the following format:
   * "hsva(xxx, xxx, xxx, xx)".
   */ toHsvString() {
        const e = it(this.r, this.g, this.b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), i = Math.round(e.v * 100);
        return this.a === 1 ? `hsv(${t}, ${n}%, ${i}%)` : `hsva(${t}, ${n}%, ${i}%, ${this.roundA})`;
    }
    /**
   * Returns the object as a HSLA object.
   */ toHsl() {
        const e = st(this.r, this.g, this.b);
        return {
            h: e.h * 360,
            s: e.s,
            l: e.l,
            a: this.a
        };
    }
    /**
   * Returns the hsla values interpolated into a string with the following format:
   * "hsla(xxx, xxx, xxx, xx)".
   */ toHslString() {
        const e = st(this.r, this.g, this.b), t = Math.round(e.h * 360), n = Math.round(e.s * 100), i = Math.round(e.l * 100);
        return this.a === 1 ? `hsl(${t}, ${n}%, ${i}%)` : `hsla(${t}, ${n}%, ${i}%, ${this.roundA})`;
    }
    /**
   * Returns the hex value of the color.
   * @param allow3Char will shorten hex value to 3 char if possible
   */ toHex(e = !1) {
        return at(this.r, this.g, this.b, e);
    }
    /**
   * Returns the hex value of the color -with a # prefixed.
   * @param allow3Char will shorten hex value to 3 char if possible
   */ toHexString(e = !1) {
        return "#" + this.toHex(e);
    }
    /**
   * Returns the hex 8 value of the color.
   * @param allow4Char will shorten hex value to 4 char if possible
   */ toHex8(e = !1) {
        return Zt(this.r, this.g, this.b, this.a, e);
    }
    /**
   * Returns the hex 8 value of the color -with a # prefixed.
   * @param allow4Char will shorten hex value to 4 char if possible
   */ toHex8String(e = !1) {
        return "#" + this.toHex8(e);
    }
    /**
   * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
   * @param allowShortChar will shorten hex value to 3 or 4 char if possible
   */ toHexShortString(e = !1) {
        return this.a === 1 ? this.toHexString(e) : this.toHex8String(e);
    }
    /**
   * Returns the object as a RGBA object.
   */ toRgb() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    }
    /**
   * Returns the RGBA values interpolated into a string with the following format:
   * "RGBA(xxx, xxx, xxx, xx)".
   */ toRgbString() {
        const e = Math.round(this.r), t = Math.round(this.g), n = Math.round(this.b);
        return this.a === 1 ? `rgb(${e}, ${t}, ${n})` : `rgba(${e}, ${t}, ${n}, ${this.roundA})`;
    }
    /**
   * Returns the object as a RGBA object.
   */ toPercentageRgb() {
        const e = (t)=>`${Math.round(g(t, 255) * 100)}%`;
        return {
            r: e(this.r),
            g: e(this.g),
            b: e(this.b),
            a: this.a
        };
    }
    /**
   * Returns the RGBA relative values interpolated into a string
   */ toPercentageRgbString() {
        const e = (t)=>Math.round(g(t, 255) * 100);
        return this.a === 1 ? `rgb(${e(this.r)}%, ${e(this.g)}%, ${e(this.b)}%)` : `rgba(${e(this.r)}%, ${e(this.g)}%, ${e(this.b)}%, ${this.roundA})`;
    }
    toCmyk() {
        return {
            ...ot(this.r, this.g, this.b)
        };
    }
    toCmykString() {
        const { c: e, m: t, y: n, k: i } = ot(this.r, this.g, this.b);
        return `cmyk(${e}, ${t}, ${n}, ${i})`;
    }
    /**
   * The 'real' name of the color -if there is one.
   */ toName() {
        if (this.a === 0) return "transparent";
        if (this.a < 1) return !1;
        const e = "#" + at(this.r, this.g, this.b, !1);
        for (const [t, n] of Object.entries(Z))if (e === n) return t;
        return !1;
    }
    toString(e) {
        const t = !!e;
        e = e ?? this.format;
        let n = !1;
        const i = this.a < 1 && this.a >= 0;
        return !t && i && (e.startsWith("hex") || e === "name") ? e === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (n = this.toRgbString()), e === "prgb" && (n = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (n = this.toHexString()), e === "hex3" && (n = this.toHexString(!0)), e === "hex4" && (n = this.toHex8String(!0)), e === "hex8" && (n = this.toHex8String()), e === "name" && (n = this.toName()), e === "hsl" && (n = this.toHslString()), e === "hsv" && (n = this.toHsvString()), e === "cmyk" && (n = this.toCmykString()), n || this.toHexString());
    }
    toNumber() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }
    clone() {
        return new h(this.toString());
    }
    /**
   * Lighten the color a given amount. Providing 100 will always return white.
   * @param amount - valid between 1-100
   */ lighten(e = 10) {
        const t = this.toHsl();
        return t.l += e / 100, t.l = j(t.l), new h(t);
    }
    /**
   * Brighten the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */ brighten(e = 10) {
        const t = this.toRgb();
        return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(e / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(e / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(e / 100)))), new h(t);
    }
    /**
   * Darken the color a given amount, from 0 to 100.
   * Providing 100 will always return black.
   * @param amount - valid between 1-100
   */ darken(e = 10) {
        const t = this.toHsl();
        return t.l -= e / 100, t.l = j(t.l), new h(t);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   * @param amount - valid between 1-100
   */ tint(e = 10) {
        return this.mix("white", e);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   * @param amount - valid between 1-100
   */ shade(e = 10) {
        return this.mix("black", e);
    }
    /**
   * Desaturate the color a given amount, from 0 to 100.
   * Providing 100 will is the same as calling greyscale
   * @param amount - valid between 1-100
   */ desaturate(e = 10) {
        const t = this.toHsl();
        return t.s -= e / 100, t.s = j(t.s), new h(t);
    }
    /**
   * Saturate the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */ saturate(e = 10) {
        const t = this.toHsl();
        return t.s += e / 100, t.s = j(t.s), new h(t);
    }
    /**
   * Completely desaturates a color into greyscale.
   * Same as calling `desaturate(100)`
   */ greyscale() {
        return this.desaturate(100);
    }
    /**
   * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
   * Values outside of this range will be wrapped into this range.
   */ spin(e) {
        const t = this.toHsl(), n = (t.h + e) % 360;
        return t.h = n < 0 ? 360 + n : n, new h(t);
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(e, t = 50) {
        const n = this.toRgb(), i = new h(e).toRgb(), s = t / 100, a = {
            r: (i.r - n.r) * s + n.r,
            g: (i.g - n.g) * s + n.g,
            b: (i.b - n.b) * s + n.b,
            a: (i.a - n.a) * s + n.a
        };
        return new h(a);
    }
    analogous(e = 6, t = 30) {
        const n = this.toHsl(), i = 360 / t, s = [
            this
        ];
        for(n.h = (n.h - (i * e >> 1) + 720) % 360; --e;)n.h = (n.h + i) % 360, s.push(new h(n));
        return s;
    }
    /**
   * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
   */ complement() {
        const e = this.toHsl();
        return e.h = (e.h + 180) % 360, new h(e);
    }
    monochromatic(e = 6) {
        const t = this.toHsv(), { h: n } = t, { s: i } = t;
        let { v: s } = t;
        const a = [], o = 1 / e;
        for(; e--;)a.push(new h({
            h: n,
            s: i,
            v: s
        })), s = (s + o) % 1;
        return a;
    }
    splitcomplement() {
        const e = this.toHsl(), { h: t } = e;
        return [
            this,
            new h({
                h: (t + 72) % 360,
                s: e.s,
                l: e.l
            }),
            new h({
                h: (t + 216) % 360,
                s: e.s,
                l: e.l
            })
        ];
    }
    /**
   * Compute how the color would appear on a background
   */ onBackground(e) {
        const t = this.toRgb(), n = new h(e).toRgb(), i = t.a + n.a * (1 - t.a);
        return new h({
            r: (t.r * t.a + n.r * n.a * (1 - t.a)) / i,
            g: (t.g * t.a + n.g * n.a * (1 - t.a)) / i,
            b: (t.b * t.a + n.b * n.a * (1 - t.a)) / i,
            a: i
        });
    }
    /**
   * Alias for `polyad(3)`
   */ triad() {
        return this.polyad(3);
    }
    /**
   * Alias for `polyad(4)`
   */ tetrad() {
        return this.polyad(4);
    }
    /**
   * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
   * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
   */ polyad(e) {
        const t = this.toHsl(), { h: n } = t, i = [
            this
        ], s = 360 / e;
        for(let a = 1; a < e; a++)i.push(new h({
            h: (n + a * s) % 360,
            s: t.s,
            l: t.l
        }));
        return i;
    }
    /**
   * compare color vs current color
   */ equals(e) {
        const t = new h(e);
        return this.format === "cmyk" || t.format === "cmyk" ? this.toCmykString() === t.toCmykString() : this.toRgbString() === t.toRgbString();
    }
}
function F(r, e) {
    return r.isValid ? r.toString(e) : r.originalInput.toString();
}
function ut(r, e) {
    return new h(r, e);
}
function se(r) {
    return Wt(r) ? r : new h(r).toString();
}
const ie = (r)=>{
    const { currentColor: e, format: t, onChange: n, isAlphaHidden: i } = r, [s, a] = (0, _reactDefault.default).useState(e.toHsv()), o = (p, m)=>{
        if (!et(m)) return;
        const y = W(360 * m / 100, 0, 359);
        a((H)=>({
                ...H,
                h: y
            }));
        const M = new h({
            ...s,
            a: e.toHsv().a,
            h: y
        });
        n?.(F(M, t));
    }, u = (p, m)=>{
        if (!et(m)) return;
        const y = e.clone().setAlpha(m);
        n?.(F(y, t));
    }, w = ({ s: p, v: m })=>{
        const y = new h({
            h: s.h,
            a: e.toHsv().a,
            s: p,
            v: m
        });
        a((M)=>({
                ...M,
                s: p,
                v: m
            })), n?.(F(y, t));
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: "MuiColorInput-PopoverBody",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(jt, {
                currentHue: s.h,
                hsv: s,
                onChange: w
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                mt: "10px",
                px: "3px",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(qt, {
                    min: 0,
                    max: 100,
                    step: 1,
                    onChange: o,
                    "aria-label": "hue",
                    value: s.h * 100 / 360
                })
            }),
            i ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                mt: "10px",
                px: "3px",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Vt, {
                    min: 0,
                    max: 1,
                    step: 0.01,
                    "aria-label": "alpha",
                    rgbColor: e.toRgb(),
                    onChange: u,
                    value: e.getAlpha()
                })
            })
        ]
    });
}, ae = (0, _reactDefault.default).forwardRef((r, e)=>{
    const { className: t, ...n } = r;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
        className: `MuiColorInput-TextField ${t || ""}`,
        ref: e,
        ...n
    });
}), oe = "rgb";
function he(r) {
    return typeof r == "object" && !Array.isArray(r) && r !== null;
}
function ft(r, e) {
    typeof e == "function" ? e(r) : e && he(e) && "current" in e && (e.current = r);
}
function xe(r) {
    return new h(r).isValid;
}
const Se = (0, _reactDefault.default).forwardRef(({ value: r, format: e, onChange: t, adornmentPosition: n = "start", PopoverProps: i, Adornment: s = Ft, fallbackValue: a, isAlphaHidden: o, disablePopover: u, ...w }, p)=>{
    const { onBlur: m, slotProps: y, ...M } = w, { onClose: H, ...b } = i || {}, k = M.disabled || !1, $ = (0, _reactDefault.default).useRef(null), A = (0, _reactDefault.default).useRef(null), [T, E] = (0, _reactDefault.default).useState(null), I = e || oe, K = ut(r, {
        format: I
    }), [O, N] = (0, _reactDefault.default).useState(r), [J, V] = (0, _reactDefault.default).useState(r), gt = (f)=>{
        f.preventDefault(), f.stopPropagation(), !k && !u && E($.current);
    }, D = (f)=>{
        const c = new h(f);
        t?.(f, {
            hex: c.isValid ? c.toHexString() : "",
            hsv: c.isValid ? c.toHsvString() : "",
            hsl: c.isValid ? c.toHslString() : "",
            rgb: c.isValid ? c.toRgbString() : "",
            hex8: c.isValid ? c.toHex8String() : ""
        });
    }, bt = (f)=>{
        const c = f.target.value;
        if (N(c), c === "") V(""), D("");
        else {
            const U = new h(c), B = F(U, I);
            V(B), D(B);
        }
    }, pt = (...f)=>{
        H?.(...f), E(null), queueMicrotask(()=>{
            A.current?.focus();
        });
    }, mt = (f)=>{
        m?.(f);
        const c = new h(O);
        if (c.isValid) c.format !== I && N(F(c, I));
        else {
            if (O === "") return;
            if (a) {
                const U = new h(a), B = F(U, I);
                N(B), V(B), D(B);
            }
        }
    };
    (0, _reactDefault.default).useEffect(()=>{
        if (r !== J) {
            const c = ut(r).originalInput;
            V(c), N(c);
        }
    }, [
        r,
        J
    ]);
    const xt = (f)=>{
        N(f), V(f), D(f);
    }, St = (f)=>{
        $.current = f, ft(f, p);
    }, vt = (f)=>{
        A.current = f, ft(f, A);
    }, Q = !!T, _ = Q ? "color-popover" : void 0, tt = /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
        position: n,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(s, {
            disabled: k,
            "aria-describedby": _,
            disablePopover: u || !1,
            component: u ? "span" : void 0,
            bgColor: K.toString(),
            isBgColorValid: !!(O !== "" && K.isValid),
            onClick: u ? void 0 : gt
        })
    }), { input: wt, ...yt } = y || {}, Mt = {
        startAdornment: n === "start" ? tt : void 0,
        endAdornment: n === "end" ? tt : void 0,
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...wt
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ae, {
                ref: St,
                spellCheck: "false",
                type: "text",
                autoComplete: "off",
                onChange: bt,
                value: se(O),
                onBlur: mt,
                inputRef: vt,
                disabled: k,
                slotProps: {
                    input: Mt,
                    ...yt
                },
                ...M
            }),
            u ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)(Et, {
                id: _,
                open: Q,
                position: n,
                anchorEl: T,
                onClose: pt,
                ...b,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(ie, {
                    onChange: xt,
                    currentColor: K,
                    format: I,
                    isAlphaHidden: o
                })
            })
        ]
    });
});

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Button":"c6Y0y","@mui/material/styles":"c9RfU","@mui/material/Popover":"keu0V","@mui/material/Slider":"7THut","@mui/material/Box":"73kto","@mui/material/TextField":"amnzu","@mui/material/InputAdornment":"jiJDh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7THut":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("db6fee2b97ebbdf0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    sliderClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Slider.default;
    }
});
Object.defineProperty(exports, "sliderClasses", {
    enumerable: true,
    get: function() {
        return _sliderClasses.default;
    }
});
var _Slider = _interopRequireWildcard(require("df918c293a5b1721"));
Object.keys(_Slider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _Slider[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Slider[key];
        }
    });
});
var _sliderClasses = _interopRequireWildcard(require("d3d8ba0b40cc900d"));
Object.keys(_sliderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _sliderClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _sliderClasses[key];
        }
    });
});

},{"db6fee2b97ebbdf0":"fiRIh","df918c293a5b1721":"50KcB","d3d8ba0b40cc900d":"9X9qj"}],"50KcB":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5a1fa52b00cd4c27").default;
var _interopRequireWildcard = require("b7c756bc0c76bbf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.SliderValueLabel = exports.SliderTrack = exports.SliderThumb = exports.SliderRoot = exports.SliderRail = exports.SliderMarkLabel = exports.SliderMark = void 0;
var React = _interopRequireWildcard(require("68458af0015c22c7"));
var _propTypes = _interopRequireDefault(require("ffade1dc0a7dc3f9"));
var _clsx = _interopRequireDefault(require("c2d7beee4fbb57cd"));
var _chainPropTypes = _interopRequireDefault(require("11ba2b768364fea7"));
var _composeClasses = _interopRequireDefault(require("b080d97bb6289b12"));
var _colorManipulator = require("50d0dc5b07a5641a");
var _RtlProvider = require("6acf731de115cea6");
var _useSlotProps = _interopRequireDefault(require("38e6642ae1cffb9d"));
var _useSlider = require("32518997da9d7ea6");
var _isHostComponent = _interopRequireDefault(require("b8e82a9054cd7b7b"));
var _zeroStyled = require("be05cdf53ac6915d");
var _memoTheme = _interopRequireDefault(require("3bce4ad717cd10f9"));
var _DefaultPropsProvider = require("8aadceb6f281d47b");
var _slotShouldForwardProp = _interopRequireDefault(require("8eedfccb281fba6"));
var _shouldSpreadAdditionalProps = _interopRequireDefault(require("b3af56923c30cf45"));
var _capitalize = _interopRequireDefault(require("2f9083386c3a014e"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("7cd7c7f3557ddd18"));
var _SliderValueLabel = _interopRequireDefault(require("3584c0599864e406"));
var _sliderClasses = _interopRequireWildcard(require("b51173209cba6899"));
var _jsxRuntime = require("550f387d70597e29");
function Identity(x) {
    return x;
}
const SliderRoot = exports.SliderRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, _capitalize.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${_sliderClasses.default.disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${_sliderClasses.default.dragging}`]: {
            [`& .${_sliderClasses.default.thumb}, & .${_sliderClasses.default.track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const SliderRail = exports.SliderRail = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Rail'
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const SliderTrack = exports.SliderTrack = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Track'
})((0, _memoTheme.default)(({ theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62),
                            borderColor: (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: (0, _colorManipulator.darken)(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: (0, _colorManipulator.darken)(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const SliderThumb = exports.SliderThumb = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, _capitalize.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${_sliderClasses.default.disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&:hover, &.${_sliderClasses.default.focusVisible}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 8px ${(0, _colorManipulator.alpha)(theme.palette[color].main, 0.16)}`
                            },
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${_sliderClasses.default.active}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 14px ${(0, _colorManipulator.alpha)(theme.palette[color].main, 0.16)}`
                            }
                        }
                    }
                }))
        ]
    })));
const SliderValueLabel = exports.SliderValueLabel = (0, _zeroStyled.styled)(_SliderValueLabel.default, {
    name: 'MuiSlider',
    slot: 'ValueLabel'
})((0, _memoTheme.default)(({ theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${_sliderClasses.default.valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${_sliderClasses.default.valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const SliderMark = exports.SliderMark = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, _slotShouldForwardProp.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const SliderMarkLabel = exports.SliderMarkLabel = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, _slotShouldForwardProp.default)(prop) && prop !== 'markLabelActive'
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const useUtilityClasses = (ownerState)=>{
    const { disabled, dragging, marked, orientation, track, classes, color, size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, _capitalize.default)(color)}`,
            size && `size${(0, _capitalize.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, _capitalize.default)(size)}`,
            color && `thumbColor${(0, _capitalize.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, _composeClasses.default)(slots, _sliderClasses.getSliderUtilityClass, classes);
};
const Forward = ({ children })=>children;
const Slider = /*#__PURE__*/ React.forwardRef(function Slider(inputProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, _RtlProvider.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, // eslint-disable-next-line react/prop-types
    component = 'span', components = {}, componentsProps = {}, color = 'primary', classes: classesProp, className, disableSwap = false, disabled = false, getAriaLabel, getAriaValueText, marks: marksProp = false, max = 100, min = 0, name, onChange, onChangeCommitted, orientation = 'horizontal', shiftStep = 10, size = 'medium', step = 1, scale = Identity, slotProps, slots, tabIndex, track = 'normal', value: valueProp, valueLabelDisplay = 'off', valueLabelFormat = Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl,
        max,
        min,
        classes: classesProp,
        disabled,
        disableSwap,
        orientation,
        marks: marksProp,
        color,
        size,
        step,
        shiftStep,
        scale,
        track,
        valueLabelDisplay,
        valueLabelFormat
    };
    const { axisProps, getRootProps, getHiddenInputProps, getThumbProps, open, active, axis, focusedThumbIndex, range, dragging, marks, values, trackOffset, trackLeap, getThumbStyle } = (0, _useSlider.useSlider)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? SliderRoot;
    const RailSlot = slots?.rail ?? components.Rail ?? SliderRail;
    const TrackSlot = slots?.track ?? components.Track ?? SliderTrack;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? SliderThumb;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? SliderValueLabel;
    const MarkSlot = slots?.mark ?? components.Mark ?? SliderMark;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? SliderMarkLabel;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, _useSlotProps.default)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, _shouldSpreadAdditionalProps.default)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, _useSlotProps.default)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState,
        className: classes.rail
    });
    const trackProps = (0, _useSlotProps.default)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, _useSlotProps.default)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, _useSlotProps.default)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, _useSlotProps.default)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, _useSlotProps.default)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, _useSlotProps.default)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, _useSlider.valueToPercent)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, _isHostComponent.default)(MarkSlot) && {
                                markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, _clsx.default)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, _isHostComponent.default)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, _clsx.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, _useSlider.valueToPercent)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, _jsxRuntime.jsx)(ValueLabelComponent, {
                    ...!(0, _isHostComponent.default)(ValueLabelComponent) && {
                        valueLabelFormat,
                        valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, _clsx.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var _default = exports.default = Slider;

},{"5a1fa52b00cd4c27":"kZ6eK","b7c756bc0c76bbf":"fiRIh","68458af0015c22c7":"9njXz","ffade1dc0a7dc3f9":"bnNSm","c2d7beee4fbb57cd":"d2NWs","11ba2b768364fea7":"4stnp","b080d97bb6289b12":"59Equ","50d0dc5b07a5641a":"hTYBL","6acf731de115cea6":"ck9Pb","38e6642ae1cffb9d":"kr4RG","32518997da9d7ea6":"1LFlK","b8e82a9054cd7b7b":"iMS0l","be05cdf53ac6915d":"89fxU","3bce4ad717cd10f9":"2zy52","8aadceb6f281d47b":"ff3VX","8eedfccb281fba6":"arfz9","b3af56923c30cf45":"bdtHB","2f9083386c3a014e":"hBZko","7cd7c7f3557ddd18":"yHYvD","3584c0599864e406":"2ncYO","b51173209cba6899":"9X9qj","550f387d70597e29":"1dlk8"}],"1LFlK":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("1b71586dc6f5971a").default;
var _interopRequireWildcard = require("5f55e01d423021a9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Identity = void 0;
exports.useSlider = useSlider;
exports.valueToPercent = valueToPercent;
var React = _interopRequireWildcard(require("b4e2a59f49226222"));
var _ownerDocument = _interopRequireDefault(require("7b61a181f9072bc8"));
var _useControlled = _interopRequireDefault(require("460b7896e5c62e0b"));
var _useEnhancedEffect = _interopRequireDefault(require("624cec4c98c7bb24"));
var _useEventCallback = _interopRequireDefault(require("9aa5dcc82184d443"));
var _useForkRef = _interopRequireDefault(require("639a89b8f0a7ba58"));
var _isFocusVisible = _interopRequireDefault(require("f66e28c02d877723"));
var _visuallyHidden = _interopRequireDefault(require("b2761dafb618f4bf"));
var _clamp = _interopRequireDefault(require("68ccf92857e4347b"));
var _extractEventHandlers = _interopRequireDefault(require("b75017e59870705d"));
var _areArraysEqual = _interopRequireDefault(require("8f6284bc149524ef"));
const INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function asc(a, b) {
    return a - b;
}
function findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance,
            index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed(getDecimalPrecision(step)));
}
function setValueIndex({ values, newValue, index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort(asc);
}
function focusThumb({ sliderRef, activeIndex, setActive }) {
    const doc = (0, _ownerDocument.default)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, _areArraysEqual.default)(newValue, oldValue);
    return false;
}
const axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const Identity = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
exports.Identity = Identity;
let cachedSupportsTouchActionNone;
function doesSupportTouchActionNone() {
    if (cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else cachedSupportsTouchActionNone = true;
    }
    return cachedSupportsTouchActionNone;
}
function useSlider(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue, disabled = false, disableSwap = false, isRtl = false, marks: marksProp = false, max = 100, min = 0, name, onChange, onChangeCommitted, orientation = 'horizontal', rootRef: ref, scale = Identity, step = 1, shiftStep = 10, tabIndex, value: valueProp } = parameters;
    const touchId = React.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = React.useState(-1);
    const [open, setOpen] = React.useState(-1);
    const [dragging, setDragging] = React.useState(false);
    const moveCount = React.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = React.useRef(null);
    const [valueDerived, setValueState] = (0, _useControlled.default)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value,
                name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort(asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, _clamp.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = React.useState(-1);
    const sliderRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, _isFocusVisible.default)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, _isFocusVisible.default)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, _clamp.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, _clamp.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = setValueIndex({
                values,
                newValue,
                index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            focusThumb({
                sliderRef,
                activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, _useEnhancedEffect.default)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = React.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger, move = false })=>{
        const { current: slider } = sliderRef;
        const { width, height, bottom, left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = percentToValue(percent, min, max);
        if (step) newValue = roundValueToStep(newValue, step, min);
        else {
            const closestIndex = findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, _clamp.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, _clamp.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = setValueIndex({
                values,
                newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue,
            activeIndex
        };
    };
    const handleTouchMove = (0, _useEventCallback.default)((nativeEvent)=>{
        const finger = trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue, activeIndex } = getFingerNewValue({
            finger,
            move: true
        });
        focusThumb({
            sliderRef,
            activeIndex,
            setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, _useEventCallback.default)((nativeEvent)=>{
        const finger = trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue } = getFingerNewValue({
            finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, _useEventCallback.default)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue, activeIndex } = getFingerNewValue({
                finger
            });
            focusThumb({
                sliderRef,
                activeIndex,
                setActive
            });
            setValueState(newValue);
            if (handleChange && !areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, _ownerDocument.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = React.useCallback(()=>{
        const doc = (0, _ownerDocument.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    React.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    React.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue, activeIndex } = getFingerNewValue({
                    finger
                });
                focusThumb({
                    sliderRef,
                    activeIndex,
                    setActive
                });
                setValueState(newValue);
                if (handleChange && !areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, _ownerDocument.default)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = valueToPercent(range ? values[0] : min, min, max);
    const trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, _extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, _extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, _extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ..._visuallyHidden.default,
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active,
        axis: axis,
        axisProps,
        dragging,
        focusedThumbIndex,
        getHiddenInputProps,
        getRootProps,
        getThumbProps,
        marks: marks,
        open,
        range,
        rootRef: handleRef,
        trackLeap,
        trackOffset,
        values,
        getThumbStyle
    };
}

},{"1b71586dc6f5971a":"kZ6eK","5f55e01d423021a9":"fiRIh","b4e2a59f49226222":"9njXz","7b61a181f9072bc8":"8VgUE","460b7896e5c62e0b":"jwZrv","624cec4c98c7bb24":"fIvqa","9aa5dcc82184d443":"feNJe","639a89b8f0a7ba58":"4xKTx","f66e28c02d877723":"gHKhh","b2761dafb618f4bf":"1dLhw","68ccf92857e4347b":"flxMs","b75017e59870705d":"9lxhE","8f6284bc149524ef":"4ralS"}],"4ralS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var _default = exports.default = areArraysEqual;

},{}],"bdtHB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8ade7169df2b5752").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isHostComponent = _interopRequireDefault(require("ea18d2e8866c2569"));
const shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, _isHostComponent.default)(Slot);
};
var _default = exports.default = shouldSpreadAdditionalProps;

},{"8ade7169df2b5752":"kZ6eK","ea18d2e8866c2569":"iMS0l"}],"2ncYO":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5f933f17d2d50427").default;
var _interopRequireWildcard = require("53d1dbff123c3b6c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SliderValueLabel;
var React = _interopRequireWildcard(require("78a3520e381786fc"));
var _propTypes = _interopRequireDefault(require("98be222cf13a904f"));
var _clsx = _interopRequireDefault(require("e8090534159f9237"));
var _sliderClasses = _interopRequireDefault(require("4f985b389d8206b1"));
var _jsxRuntime = require("93143eb2de78a15a");
const useValueLabelClasses = (props)=>{
    const { open } = props;
    const utilityClasses = {
        offset: (0, _clsx.default)(open && _sliderClasses.default.valueLabelOpen),
        circle: _sliderClasses.default.valueLabelCircle,
        label: _sliderClasses.default.valueLabelLabel
    };
    return utilityClasses;
};
/**
 * @ignore - internal component.
 */ function SliderValueLabel(props) {
    const { children, className, value } = props;
    const classes = useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ React.cloneElement(children, {
        className: children.props.className
    }, /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _clsx.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}

},{"5f933f17d2d50427":"kZ6eK","53d1dbff123c3b6c":"fiRIh","78a3520e381786fc":"9njXz","98be222cf13a904f":"bnNSm","e8090534159f9237":"d2NWs","4f985b389d8206b1":"9X9qj","93143eb2de78a15a":"1dlk8"}],"9X9qj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cd7d30cbb4465b15").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getSliderUtilityClass = getSliderUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("93e593e7975a0a45"));
var _generateUtilityClass = _interopRequireDefault(require("1dc68de674720b76"));
function getSliderUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiSlider', slot);
}
const sliderClasses = (0, _generateUtilityClasses.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var _default = exports.default = sliderClasses;

},{"cd7d30cbb4465b15":"kZ6eK","93e593e7975a0a45":"7pSUk","1dc68de674720b76":"jBs9M"}],"73kto":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("362fd5837bc2032d").default;
var _interopRequireDefault = require("efb845652a1d93a0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    boxClasses: true
};
Object.defineProperty(exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return _boxClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Box.default;
    }
});
var _Box = _interopRequireDefault(require("5bd40ef5d30f6fa4"));
var _boxClasses = _interopRequireWildcard(require("b5d4fb018c9241bc"));
Object.keys(_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _boxClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _boxClasses[key];
        }
    });
});

},{"362fd5837bc2032d":"fiRIh","efb845652a1d93a0":"kZ6eK","5bd40ef5d30f6fa4":"4gzkw","b5d4fb018c9241bc":"g1SKC"}],"4gzkw":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7d91b9858dccca1c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _system = require("fa9ec836b4d11154");
var _propTypes = _interopRequireDefault(require("f5aaa6dfc01dd19a"));
var _className = require("9525645ce7d4dc93");
var _styles = require("f099e4ed28ae6621");
var _identifier = _interopRequireDefault(require("decfd808fcf56b4"));
var _boxClasses = _interopRequireDefault(require("ddb4349ba28de6a8"));
const defaultTheme = (0, _styles.createTheme)();
const Box = (0, _system.createBox)({
    themeId: _identifier.default,
    defaultTheme,
    defaultClassName: _boxClasses.default.root,
    generateClassName: _className.unstable_ClassNameGenerator.generate
});
var _default = exports.default = Box;

},{"7d91b9858dccca1c":"kZ6eK","fa9ec836b4d11154":"iFfXs","f5aaa6dfc01dd19a":"bnNSm","9525645ce7d4dc93":"8MBSc","f099e4ed28ae6621":"c9RfU","decfd808fcf56b4":"asvw3","ddb4349ba28de6a8":"g1SKC"}],"8MBSc":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6ce8dcb18b732f2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "unstable_ClassNameGenerator", {
    enumerable: true,
    get: function() {
        return _ClassNameGenerator.default;
    }
});
var _ClassNameGenerator = _interopRequireDefault(require("68a60cb1c697642c"));

},{"6ce8dcb18b732f2":"kZ6eK","68a60cb1c697642c":"eyH7A"}],"g1SKC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("bcd9f5c6f00104b6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _generateUtilityClasses = _interopRequireDefault(require("52ff5b7806c5b966"));
const boxClasses = (0, _generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var _default = exports.default = boxClasses;

},{"bcd9f5c6f00104b6":"kZ6eK","52ff5b7806c5b966":"7pSUk"}],"5YlRS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BoxControls", ()=>BoxControls);
var _jsxRuntime = require("react/jsx-runtime");
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _outlinedInput = require("@mui/material/OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _switch = require("@mui/material/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _muiColorInput = require("mui-color-input");
var _react = require("react");
const BoxControls = ({ component, index, updateComponent })=>{
    const calculateHex8 = ()=>{
        if (!component.box) return '#00000080';
        const hex = component.box.color;
        const opacity = Math.round(component.box.opacity * 255).toString(16).padStart(2, '0');
        return hex + opacity;
    };
    const [colorInput, setColorInput] = (0, _react.useState)(calculateHex8());
    const handleChange = (newValue)=>{
        setColorInput(newValue);
        // Parse hex8 to hex + opacity as a number
        const hex = newValue.substring(0, 7);
        const opacity = parseInt(newValue.substring(7), 16) / 255;
        updateComponent(index, {
            ...component,
            box: {
                ...component.box,
                color: hex,
                opacity
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchDefault.default), {}),
                label: "Background",
                checked: component.box !== undefined,
                onChange: (event)=>{
                    if (event.target.checked) updateComponent(index, {
                        ...component,
                        box: {
                            color: '#000000',
                            borderWidth: 1,
                            opacity: 0.5
                        }
                    });
                    else {
                        updateComponent(index, {
                            ...component,
                            box: undefined
                        });
                        setColorInput('#00000080');
                    }
                }
            }),
            component.box !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiColorInput.MuiColorInput), {
                        format: "hex8",
                        value: colorInput,
                        onChange: handleChange,
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                        variant: "outlined",
                        fullWidth: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                htmlFor: "border-width-label",
                                children: "Border width"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                                id: "border-width",
                                label: "Border width",
                                type: "number",
                                endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
                                    position: "end",
                                    children: "px"
                                }),
                                value: component.box.borderWidth,
                                onChange: (event)=>updateComponent(index, {
                                        ...component,
                                        box: {
                                            ...component.box,
                                            borderWidth: parseInt(event.target.value) || 0
                                        }
                                    }),
                                onWheel: (e)=>e.target.blur()
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/FormControl":"ioFZ4","@mui/material/FormControlLabel":"45VZW","@mui/material/InputAdornment":"3vWJT","@mui/material/InputLabel":"5EJtb","@mui/material/OutlinedInput":"h57br","@mui/material/Stack":"6thYv","@mui/material/Switch":"d69la","mui-color-input":"eRL6U","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hJcQ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageEditor", ()=>ImageEditor);
var _jsxRuntime = require("react/jsx-runtime");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _upload = require("@mui/icons-material/Upload");
var _uploadDefault = parcelHelpers.interopDefault(_upload);
var _accordion = require("@mui/material/Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionDetails = require("@mui/material/AccordionDetails");
var _accordionDetailsDefault = parcelHelpers.interopDefault(_accordionDetails);
var _accordionSummary = require("@mui/material/AccordionSummary");
var _accordionSummaryDefault = parcelHelpers.interopDefault(_accordionSummary);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _outlinedInput = require("@mui/material/OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _xDatePickers = require("@mui/x-date-pickers");
var _coordinateControls = require("./CoordinateControls");
var _react = require("react");
var _styles = require("@mui/material/styles");
var _slider = require("@mui/material/Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
const convertBytesToMB = (bytes)=>bytes / 1024 / 1024;
const convertMBToBytes = (mb)=>mb * 1048576;
const MAX_SIZE = convertMBToBytes(1);
const VisuallyHiddenInput = (0, _styles.styled)('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
});
const ImageEditor = ({ component, index, updateComponent })=>{
    // get base64 png image
    const handleFileChange = (event)=>{
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e)=>{
                if (file.size > MAX_SIZE) {
                    alert(`File size ${convertBytesToMB(file.size).toFixed(1)} MB is too big, max size is ${convertBytesToMB(MAX_SIZE).toFixed(0)} MB`);
                    return;
                }
                if (e.target && typeof e.target.result === 'string') updateComponent(index, {
                    ...component,
                    data: e.target.result
                });
            };
            reader.readAsDataURL(file);
        }
    };
    const [areYouSure, setAreYouSure] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionSummaryDefault.default), {
                expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.ArrowDropDownIcon), {}),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                    direction: "row",
                    spacing: 2,
                    alignItems: "center",
                    justifyContent: "space-between",
                    sx: {
                        minWidth: '100%',
                        pr: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "h5",
                            children: "Image"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: component.data,
                            style: {
                                maxWidth: '100%',
                                maxHeight: '20px'
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                flexGrow: 1
                            }
                        }),
                        !areYouSure && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            onClick: (e)=>{
                                e.stopPropagation();
                                setAreYouSure(true);
                                setTimeout(()=>setAreYouSure(false), 5000);
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
                        }),
                        areYouSure && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "text",
                            color: "error",
                            onClick: (e)=>{
                                e.stopPropagation();
                                setAreYouSure(false);
                                updateComponent(index, undefined);
                            },
                            children: "Are you sure?"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionDetailsDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                    direction: "column",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "row",
                            spacing: 2,
                            alignItems: 'center',
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
                                    component: "label",
                                    role: undefined,
                                    variant: "contained",
                                    tabIndex: -1,
                                    startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadDefault.default), {}),
                                    children: [
                                        "Upload image",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(VisuallyHiddenInput, {
                                            type: "file",
                                            onChange: handleFileChange,
                                            accept: "image/png"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    variant: "body2",
                                    color: "textSecondary",
                                    children: `Max size is ${convertBytesToMB(MAX_SIZE).toFixed(0)} MB. Supported formats: PNG`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coordinateControls.CoordinateControls), {
                            component: component,
                            index: index,
                            updateComponent: updateComponent
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "row",
                            spacing: 2,
                            alignItems: 'center',
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                            htmlFor: "bound-width-label",
                                            children: "Bound width"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                                            id: "bound-width",
                                            label: "Bound width",
                                            type: "number",
                                            endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
                                                position: "end",
                                                children: "px"
                                            }),
                                            value: component.maxWidth,
                                            onChange: (event)=>updateComponent(index, {
                                                    ...component,
                                                    maxWidth: parseInt(event.target.value) || 0
                                                }),
                                            onWheel: (e)=>e.target.blur()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                            htmlFor: "bound-height-label",
                                            children: "Bound height"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                                            id: "bound-height",
                                            label: "Bound height",
                                            type: "number",
                                            endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
                                                position: "end",
                                                children: "px"
                                            }),
                                            value: component.maxHeight,
                                            onChange: (event)=>updateComponent(index, {
                                                    ...component,
                                                    maxHeight: parseInt(event.target.value) || 0
                                                }),
                                            onWheel: (e)=>e.target.blur()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    sx: {
                                        minWidth: 200
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            id: "input-slider",
                                            gutterBottom: true,
                                            children: "Opacity"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sliderDefault.default), {
                                            id: "opacity-slider",
                                            value: component.opacity,
                                            onChange: (_, newValue)=>updateComponent(index, {
                                                    ...component,
                                                    opacity: newValue
                                                }),
                                            "aria-labelledby": "opacity-slider",
                                            step: 0.1,
                                            min: 0,
                                            max: 1,
                                            valueLabelDisplay: "auto"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/icons-material/Delete":"69aC7","@mui/icons-material/Upload":"7EeDK","@mui/material/Accordion":"gSEZa","@mui/material/AccordionDetails":"l0GkN","@mui/material/AccordionSummary":"a34y4","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/FormControl":"ioFZ4","@mui/material/IconButton":"488As","@mui/material/InputAdornment":"3vWJT","@mui/material/InputLabel":"5EJtb","@mui/material/OutlinedInput":"h57br","@mui/material/Stack":"6thYv","@mui/material/Typography":"6NtGx","@mui/x-date-pickers":"gSoHo","./CoordinateControls":"kyLu5","react":"9njXz","@mui/material/styles":"2UrBk","@mui/material/Slider":"9I3ff","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7EeDK":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("3d0a4d158ce5a094").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("47a4f43a9b202cd7"));
var _jsxRuntime = require("3e9101352bbd5c73");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M5 20h14v-2H5zm0-10h4v6h6v-6h4l-7-7z"
}), 'Upload');

},{"3d0a4d158ce5a094":"kZ6eK","47a4f43a9b202cd7":"2vOnF","3e9101352bbd5c73":"1dlk8"}],"9I3ff":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("56e29563689814b0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    sliderClasses: true
};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Slider.default;
    }
});
Object.defineProperty(exports, "sliderClasses", {
    enumerable: true,
    get: function() {
        return _sliderClasses.default;
    }
});
var _Slider = _interopRequireWildcard(require("d4b219ec8a360cdf"));
Object.keys(_Slider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _Slider[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Slider[key];
        }
    });
});
var _sliderClasses = _interopRequireWildcard(require("798afda930f036ba"));
Object.keys(_sliderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _sliderClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _sliderClasses[key];
        }
    });
});

},{"56e29563689814b0":"fiRIh","d4b219ec8a360cdf":"6pHTH","798afda930f036ba":"asarV"}],"6pHTH":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a2e47f79d0f2cb1b").default;
var _interopRequireWildcard = require("f87d32b2fa34ae36").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.SliderValueLabel = exports.SliderTrack = exports.SliderThumb = exports.SliderRoot = exports.SliderRail = exports.SliderMarkLabel = exports.SliderMark = void 0;
var React = _interopRequireWildcard(require("db0a1477eb49e8a3"));
var _propTypes = _interopRequireDefault(require("58ecf7cbbedd4d3"));
var _clsx = _interopRequireDefault(require("d90b8d3c8c09c23b"));
var _chainPropTypes = _interopRequireDefault(require("94c7fc34512628c6"));
var _composeClasses = _interopRequireDefault(require("3778facf70e30abe"));
var _colorManipulator = require("4b651080860468e");
var _RtlProvider = require("74a93733692695d1");
var _useSlotProps = _interopRequireDefault(require("928936d71b73c461"));
var _useSlider = require("30f5591b4d6d589f");
var _isHostComponent = _interopRequireDefault(require("128740814aae6a9a"));
var _zeroStyled = require("8f6b532bfbc9d55e");
var _memoTheme = _interopRequireDefault(require("6e361d7a930021ea"));
var _DefaultPropsProvider = require("591b5c148cbe9e3");
var _slotShouldForwardProp = _interopRequireDefault(require("a5e1fea07a694ea8"));
var _shouldSpreadAdditionalProps = _interopRequireDefault(require("ccfcd3e891ae24c1"));
var _capitalize = _interopRequireDefault(require("b6f0428b729f54ca"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("bcc9fa50c52066b1"));
var _SliderValueLabel = _interopRequireDefault(require("53019d6cf4acbe03"));
var _sliderClasses = _interopRequireWildcard(require("50f1e461658cb47c"));
var _jsxRuntime = require("e02721ec79ee122c");
function Identity(x) {
    return x;
}
const SliderRoot = exports.SliderRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, _capitalize.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, _capitalize.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${_sliderClasses.default.disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${_sliderClasses.default.dragging}`]: {
            [`& .${_sliderClasses.default.thumb}, & .${_sliderClasses.default.track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const SliderRail = exports.SliderRail = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Rail'
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const SliderTrack = exports.SliderTrack = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Track'
})((0, _memoTheme.default)(({ theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62),
                            borderColor: (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: (0, _colorManipulator.darken)(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: (0, _colorManipulator.darken)(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const SliderThumb = exports.SliderThumb = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, _capitalize.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, _capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${_sliderClasses.default.disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&:hover, &.${_sliderClasses.default.focusVisible}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 8px ${(0, _colorManipulator.alpha)(theme.palette[color].main, 0.16)}`
                            },
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${_sliderClasses.default.active}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 14px ${(0, _colorManipulator.alpha)(theme.palette[color].main, 0.16)}`
                            }
                        }
                    }
                }))
        ]
    })));
const SliderValueLabel = exports.SliderValueLabel = (0, _zeroStyled.styled)(_SliderValueLabel.default, {
    name: 'MuiSlider',
    slot: 'ValueLabel'
})((0, _memoTheme.default)(({ theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${_sliderClasses.default.valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${_sliderClasses.default.valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const SliderMark = exports.SliderMark = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, _slotShouldForwardProp.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, _memoTheme.default)(({ theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const SliderMarkLabel = exports.SliderMarkLabel = (0, _zeroStyled.styled)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, _slotShouldForwardProp.default)(prop) && prop !== 'markLabelActive'
})((0, _memoTheme.default)(({ theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const useUtilityClasses = (ownerState)=>{
    const { disabled, dragging, marked, orientation, track, classes, color, size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, _capitalize.default)(color)}`,
            size && `size${(0, _capitalize.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, _capitalize.default)(size)}`,
            color && `thumbColor${(0, _capitalize.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, _composeClasses.default)(slots, _sliderClasses.getSliderUtilityClass, classes);
};
const Forward = ({ children })=>children;
const Slider = /*#__PURE__*/ React.forwardRef(function Slider(inputProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, _RtlProvider.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, // eslint-disable-next-line react/prop-types
    component = 'span', components = {}, componentsProps = {}, color = 'primary', classes: classesProp, className, disableSwap = false, disabled = false, getAriaLabel, getAriaValueText, marks: marksProp = false, max = 100, min = 0, name, onChange, onChangeCommitted, orientation = 'horizontal', shiftStep = 10, size = 'medium', step = 1, scale = Identity, slotProps, slots, tabIndex, track = 'normal', value: valueProp, valueLabelDisplay = 'off', valueLabelFormat = Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl,
        max,
        min,
        classes: classesProp,
        disabled,
        disableSwap,
        orientation,
        marks: marksProp,
        color,
        size,
        step,
        shiftStep,
        scale,
        track,
        valueLabelDisplay,
        valueLabelFormat
    };
    const { axisProps, getRootProps, getHiddenInputProps, getThumbProps, open, active, axis, focusedThumbIndex, range, dragging, marks, values, trackOffset, trackLeap, getThumbStyle } = (0, _useSlider.useSlider)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? SliderRoot;
    const RailSlot = slots?.rail ?? components.Rail ?? SliderRail;
    const TrackSlot = slots?.track ?? components.Track ?? SliderTrack;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? SliderThumb;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? SliderValueLabel;
    const MarkSlot = slots?.mark ?? components.Mark ?? SliderMark;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? SliderMarkLabel;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, _useSlotProps.default)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, _shouldSpreadAdditionalProps.default)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, _useSlotProps.default)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState,
        className: classes.rail
    });
    const trackProps = (0, _useSlotProps.default)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, _useSlotProps.default)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, _useSlotProps.default)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, _useSlotProps.default)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, _useSlotProps.default)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, _useSlotProps.default)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, _useSlider.valueToPercent)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, _isHostComponent.default)(MarkSlot) && {
                                markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, _clsx.default)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, _isHostComponent.default)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, _clsx.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, _useSlider.valueToPercent)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, _jsxRuntime.jsx)(ValueLabelComponent, {
                    ...!(0, _isHostComponent.default)(ValueLabelComponent) && {
                        valueLabelFormat,
                        valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, _clsx.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var _default = exports.default = Slider;

},{"a2e47f79d0f2cb1b":"kZ6eK","f87d32b2fa34ae36":"fiRIh","db0a1477eb49e8a3":"9njXz","58ecf7cbbedd4d3":"bnNSm","d90b8d3c8c09c23b":"d2NWs","94c7fc34512628c6":"4stnp","3778facf70e30abe":"59Equ","4b651080860468e":"hTYBL","74a93733692695d1":"ck9Pb","928936d71b73c461":"kr4RG","30f5591b4d6d589f":"ja9Mc","128740814aae6a9a":"19YEO","8f6b532bfbc9d55e":"hZXDo","6e361d7a930021ea":"cJNjb","591b5c148cbe9e3":"9bD8g","a5e1fea07a694ea8":"94KY1","ccfcd3e891ae24c1":"1UU5e","b6f0428b729f54ca":"eOYSA","bcc9fa50c52066b1":"2r5WG","53019d6cf4acbe03":"gHiib","50f1e461658cb47c":"asarV","e02721ec79ee122c":"1dlk8"}],"ja9Mc":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("d6296513da282cd3").default;
var _interopRequireWildcard = require("d2c448873d32debb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Identity = void 0;
exports.useSlider = useSlider;
exports.valueToPercent = valueToPercent;
var React = _interopRequireWildcard(require("64366527303db471"));
var _ownerDocument = _interopRequireDefault(require("2626c56d6d3b76b2"));
var _useControlled = _interopRequireDefault(require("4f770dec8b496709"));
var _useEnhancedEffect = _interopRequireDefault(require("3cfab1887fa42141"));
var _useEventCallback = _interopRequireDefault(require("624234d06620950f"));
var _useForkRef = _interopRequireDefault(require("1983c5db6006784e"));
var _isFocusVisible = _interopRequireDefault(require("e1407454e9bbf15"));
var _visuallyHidden = _interopRequireDefault(require("5b64a54ad4adaf15"));
var _clamp = _interopRequireDefault(require("e089efec67a5c774"));
var _extractEventHandlers = _interopRequireDefault(require("b7aafd69bd1b31a7"));
var _areArraysEqual = _interopRequireDefault(require("f52cd51c480cdeeb"));
const INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function asc(a, b) {
    return a - b;
}
function findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance,
            index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed(getDecimalPrecision(step)));
}
function setValueIndex({ values, newValue, index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort(asc);
}
function focusThumb({ sliderRef, activeIndex, setActive }) {
    const doc = (0, _ownerDocument.default)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, _areArraysEqual.default)(newValue, oldValue);
    return false;
}
const axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const Identity = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
exports.Identity = Identity;
let cachedSupportsTouchActionNone;
function doesSupportTouchActionNone() {
    if (cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else cachedSupportsTouchActionNone = true;
    }
    return cachedSupportsTouchActionNone;
}
function useSlider(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue, disabled = false, disableSwap = false, isRtl = false, marks: marksProp = false, max = 100, min = 0, name, onChange, onChangeCommitted, orientation = 'horizontal', rootRef: ref, scale = Identity, step = 1, shiftStep = 10, tabIndex, value: valueProp } = parameters;
    const touchId = React.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = React.useState(-1);
    const [open, setOpen] = React.useState(-1);
    const [dragging, setDragging] = React.useState(false);
    const moveCount = React.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = React.useRef(null);
    const [valueDerived, setValueState] = (0, _useControlled.default)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value,
                name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort(asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, _clamp.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = React.useState(-1);
    const sliderRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, _isFocusVisible.default)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, _isFocusVisible.default)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, _clamp.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, _clamp.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = setValueIndex({
                values,
                newValue,
                index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            focusThumb({
                sliderRef,
                activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, _useEnhancedEffect.default)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = React.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger, move = false })=>{
        const { current: slider } = sliderRef;
        const { width, height, bottom, left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = percentToValue(percent, min, max);
        if (step) newValue = roundValueToStep(newValue, step, min);
        else {
            const closestIndex = findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, _clamp.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, _clamp.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = setValueIndex({
                values,
                newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue,
            activeIndex
        };
    };
    const handleTouchMove = (0, _useEventCallback.default)((nativeEvent)=>{
        const finger = trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue, activeIndex } = getFingerNewValue({
            finger,
            move: true
        });
        focusThumb({
            sliderRef,
            activeIndex,
            setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, _useEventCallback.default)((nativeEvent)=>{
        const finger = trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue } = getFingerNewValue({
            finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, _useEventCallback.default)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue, activeIndex } = getFingerNewValue({
                finger
            });
            focusThumb({
                sliderRef,
                activeIndex,
                setActive
            });
            setValueState(newValue);
            if (handleChange && !areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, _ownerDocument.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = React.useCallback(()=>{
        const doc = (0, _ownerDocument.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    React.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    React.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue, activeIndex } = getFingerNewValue({
                    finger
                });
                focusThumb({
                    sliderRef,
                    activeIndex,
                    setActive
                });
                setValueState(newValue);
                if (handleChange && !areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, _ownerDocument.default)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = valueToPercent(range ? values[0] : min, min, max);
    const trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, _extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, _extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, _extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ..._visuallyHidden.default,
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active,
        axis: axis,
        axisProps,
        dragging,
        focusedThumbIndex,
        getHiddenInputProps,
        getRootProps,
        getThumbProps,
        marks: marks,
        open,
        range,
        rootRef: handleRef,
        trackLeap,
        trackOffset,
        values,
        getThumbStyle
    };
}

},{"d6296513da282cd3":"kZ6eK","d2c448873d32debb":"fiRIh","64366527303db471":"9njXz","2626c56d6d3b76b2":"8VgUE","4f770dec8b496709":"jwZrv","3cfab1887fa42141":"fIvqa","624234d06620950f":"feNJe","1983c5db6006784e":"4xKTx","e1407454e9bbf15":"gHKhh","5b64a54ad4adaf15":"1dLhw","e089efec67a5c774":"flxMs","b7aafd69bd1b31a7":"9lxhE","f52cd51c480cdeeb":"4Pdrx"}],"4Pdrx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var _default = exports.default = areArraysEqual;

},{}],"1UU5e":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("49a018e566aa4d5c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isHostComponent = _interopRequireDefault(require("ae77af6ea5d47f5"));
const shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, _isHostComponent.default)(Slot);
};
var _default = exports.default = shouldSpreadAdditionalProps;

},{"49a018e566aa4d5c":"kZ6eK","ae77af6ea5d47f5":"19YEO"}],"gHiib":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("588f643bc6429ab1").default;
var _interopRequireWildcard = require("df6ad2de13251df5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SliderValueLabel;
var React = _interopRequireWildcard(require("4ecfa42f7e4e0ba8"));
var _propTypes = _interopRequireDefault(require("52e2a4dc1d5775c9"));
var _clsx = _interopRequireDefault(require("ebf9af22f8b4dbf8"));
var _sliderClasses = _interopRequireDefault(require("f7f465f6f354d195"));
var _jsxRuntime = require("c5e2a97c8b8feac");
const useValueLabelClasses = (props)=>{
    const { open } = props;
    const utilityClasses = {
        offset: (0, _clsx.default)(open && _sliderClasses.default.valueLabelOpen),
        circle: _sliderClasses.default.valueLabelCircle,
        label: _sliderClasses.default.valueLabelLabel
    };
    return utilityClasses;
};
/**
 * @ignore - internal component.
 */ function SliderValueLabel(props) {
    const { children, className, value } = props;
    const classes = useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ React.cloneElement(children, {
        className: children.props.className
    }, /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _clsx.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}

},{"588f643bc6429ab1":"kZ6eK","df6ad2de13251df5":"fiRIh","4ecfa42f7e4e0ba8":"9njXz","52e2a4dc1d5775c9":"bnNSm","ebf9af22f8b4dbf8":"d2NWs","f7f465f6f354d195":"asarV","c5e2a97c8b8feac":"1dlk8"}],"asarV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e82a9235c211cbc5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getSliderUtilityClass = getSliderUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("21145930dcf2d025"));
var _generateUtilityClass = _interopRequireDefault(require("d18adf384953e2e1"));
function getSliderUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiSlider', slot);
}
const sliderClasses = (0, _generateUtilityClasses.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var _default = exports.default = sliderClasses;

},{"e82a9235c211cbc5":"kZ6eK","21145930dcf2d025":"7pSUk","d18adf384953e2e1":"jBs9M"}],"cmKSv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PreviewCanvas", ()=>PreviewCanvas);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const PreviewCanvas = ({ overlay, resolution })=>{
    const canvasRef = (0, _react.useRef)(null);
    // More descriptive values for the preview, to help with size estimation
    const previewExamples = {
        timecode: '00:00:00:00',
        datetime: '1970-01-01 00:00:00',
        codec: 'h264',
        encoder: 'h264_nvenc'
    };
    const hexToRgb = (hex)=>{
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    };
    (0, _react.useEffect)(()=>{
        if (overlay && canvasRef.current) {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;
            const [rw, rh] = resolution.split('x').map((value)=>parseInt(value));
            canvas.width = rw;
            canvas.height = rh;
            // Clear the canvas before rendering the overlay components
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            // Render components onto the canvas
            overlay.components.forEach((component)=>{
                switch(component.type){
                    case 'image':
                        {
                            const img = new Image();
                            img.src = component.data;
                            img.onload = ()=>{
                                const hRatio = component.maxWidth / img.width;
                                const vRatio = component.maxHeight / img.height;
                                const ratio = Math.min(hRatio, vRatio);
                                let x = component.x.value;
                                if (component.x.baseline === 'end') x = canvas.width - x - component.maxWidth;
                                let y = component.y.value;
                                if (component.y.baseline === 'end') y = canvas.height - y - component.maxHeight;
                                const centerShiftX = x + (component.maxWidth - img.width * ratio) / 2;
                                const centerShiftY = y + (component.maxHeight - img.height * ratio) / 2;
                                ctx.globalAlpha = component.opacity;
                                ctx.drawImage(img, 0, 0, img.width, img.height, centerShiftX, centerShiftY, img.width * ratio, img.height * ratio);
                                ctx.globalAlpha = 1;
                            };
                            break;
                        }
                    case 'text':
                        {
                            ctx.textBaseline = 'top';
                            ctx.font = `${component.fontSize}px sans-serif`;
                            const text = component.preset ? Object.keys(previewExamples).includes(component.preset) ? previewExamples[component.preset] : component.preset : component.text;
                            const textMeasurements = ctx.measureText(text);
                            const textWidth = textMeasurements.width;
                            const textHeight = textMeasurements.fontBoundingBoxAscent + textMeasurements.fontBoundingBoxDescent;
                            let x = component.x.value;
                            if (component.x.baseline === 'end') x = canvas.width - x - textWidth;
                            let y = component.y.value;
                            if (component.y.baseline === 'end') y = canvas.height - y - textHeight;
                            if (component.box) {
                                const c = hexToRgb(component.box.color);
                                if (c) {
                                    const rgba = `rgba(${c.r}, ${c.g}, ${c.b}, ${component.box.opacity})`;
                                    ctx.fillStyle = rgba;
                                    ctx.strokeStyle = rgba;
                                }
                                const boxX = x - component.box.borderWidth;
                                const boxY = y - component.box.borderWidth;
                                const boxWidth = textWidth + component.box.borderWidth * 2;
                                const boxHeight = textHeight + component.box.borderWidth * 2;
                                ctx.fillRect(boxX, boxY, boxWidth, boxHeight);
                                ctx.strokeRect(boxX, boxY, boxWidth, boxHeight);
                            }
                            ctx.fillStyle = component.color;
                            ctx.fillText(text, x, y);
                            break;
                        }
                }
            });
        }
    }, [
        overlay,
        resolution
    ]);
    const canvasStyles = {
        // "Transparent" checkerboard background
        backgroundColor: 'lightgray',
        backgroundImage: `
          linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc),
          linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc)
        `,
        backgroundSize: '40px 40px',
        backgroundPosition: '0 0, 20px 20px',
        // Keep the 16:9 aspect ratio
        maxWidth: '1280px',
        maxHeight: '720px',
        width: '100%',
        height: '100%'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("canvas", {
        ref: canvasRef,
        style: canvasStyles
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyMC8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdInsertion", ()=>AdInsertion);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _notFound = require("../common/NotFound");
var _routes = require("../../utils/routes");
var _adInsertionPage = require("./AdInsertionPage");
var _edit = require("./adServer/Edit");
var _demoPage = require("./demo/DemoPage");
var _adAuditLog = require("./AdAuditLog");
var _edit1 = require("./adCreative/Edit/Edit");
var _list = require("./adCreative/List");
var _list1 = require("./adPod/List");
var _edit2 = require("./adPod/Edit/Edit");
var _view = require("./adBreak/View/View");
var _list2 = require("./adBreak/List");
var _list3 = require("./adServer/List");
const AdInsertion = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Routes), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adServers/${(0, _routes.SUB_PATH).UPDATE}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.EditAdServer), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adServers/${(0, _routes.SUB_PATH).NEW}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.EditAdServer), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adServers/${(0, _routes.SUB_PATH).COPY}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.EditAdServer), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adServers`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list3.AdServerList), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adCreatives`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list.AdCreativeList), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adCreatives/${(0, _routes.SUB_PATH).UPDATE}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit1.EditAdCreative), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adCreatives/${(0, _routes.SUB_PATH).NEW}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit1.EditAdCreative), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adPods`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list1.AdPodList), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adPods/${(0, _routes.SUB_PATH).UPDATE}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit2.EditAdPod), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adPods/${(0, _routes.SUB_PATH).NEW}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit2.EditAdPod), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adBreaks`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list2.AdBreakList), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adBreaks/history`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _list2.AdBreakList), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adBreaks/${(0, _routes.SUB_PATH).VIEW}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _view.ViewAdBreak), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `demo`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _demoPage.DemoPage), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adAudit`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adAuditLog.AdAuditLog), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adServers`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Navigate), {
                    to: (0, _routes.ROUTES).adInsertion
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: `adInsertion`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Navigate), {
                    to: (0, _routes.ROUTES).adInsertion
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adInsertionPage.AdInsertionPage), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","../common/NotFound":"1Msr5","../../utils/routes":"cqMGU","./AdInsertionPage":"e3Jca","./adServer/Edit":"dE9Kn","./demo/DemoPage":"eHk6i","./AdAuditLog":"hgVg9","./adCreative/Edit/Edit":"ipHzA","./adCreative/List":"8lxdr","./adPod/List":"a4U9z","./adPod/Edit/Edit":"hL4a8","./adBreak/View/View":"cbXXQ","./adBreak/List":"7I0o7","./adServer/List":"fJaJD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e3Jca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdInsertionPage", ()=>AdInsertionPage);
var _jsxRuntime = require("react/jsx-runtime");
var _form = require("../common/Form");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _reactRouter = require("react-router");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _adInsertionSettings = require("./AdInsertionSettings");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _utils = require("../../utils");
var _styles = require("@mui/material/styles");
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _grow = require("@mui/material/Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _linearProgress = require("@mui/material/LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _types = require("common/api/v1/types");
var _helpers = require("common/api/v1/helpers");
var _dateFns = require("date-fns");
var _store = require("../../store");
var _react = require("react");
var _reactRedux = require("react-redux");
var _adBreakActions = require("../../redux/actions/adBreakActions");
var _adPodActions = require("../../redux/actions/adPodActions");
var _adCreativeActions = require("../../redux/actions/adCreativeActions");
var _tableConfig = require("./adBreak/tableConfig");
var _warningAmber = require("@mui/icons-material/WarningAmber");
var _warningAmberDefault = parcelHelpers.interopDefault(_warningAmber);
var _utils1 = require("./adBreak/utils");
const stretchedPaper = {
    margin: 0,
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column'
};
const AdInsertionPage = ()=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const { adBreaks, total: totalAdBreaks } = (0, _utils.useAdBreaksSelector)((0, _utils.withDefaultPagination)({}));
    const [failedAdBreaks, setFailedAdBreaks] = (0, _react.useState)(0);
    const { total: totalAdPods } = (0, _utils.useAdPodsSelector)((0, _utils.withDefaultPagination)({}));
    const [failedAdPods, setFailedAdPods] = (0, _react.useState)(0);
    const { total: totalAdCreatives } = (0, _utils.useAdCreativeSelector)((0, _utils.withDefaultPagination)({}));
    const [failedAdCreatives, setFailedAdCreatives] = (0, _react.useState)(0);
    const dispatch = (0, _reactRedux.useDispatch)();
    const refreshFailedAdBreaks = ()=>{
        (0, _store.Api).adBreaksApi.listAdBreaks({
            status: (0, _types.AdBreakStatus).playFailed,
            pageNumber: '0',
            rowsPerPage: '1'
        }).then((result)=>{
            const failed = result?.total ?? result?.payload?.total;
            if (!failed) return;
            setFailedAdBreaks(failed);
        }).catch(()=>{
            setFailedAdBreaks(0);
        });
    };
    const refreshFailedAdPods = ()=>{
        (0, _store.Api).adPodsApi.listAdPods({
            status: (0, _types.AdPodStatus).unhealthy,
            pageNumber: '0',
            rowsPerPage: '1'
        }).then((result)=>{
            const failed = result?.total ?? result?.payload?.total;
            if (!failed) return;
            setFailedAdPods(failed);
        }).catch(()=>{
            setFailedAdPods(0);
        });
    };
    const refreshFailedAdCreatives = ()=>{
        (0, _store.Api).adCreativesApi.listAdCreatives({
            status: (0, _types.AdCreativeStatus).probeFailed,
            pageNumber: '0',
            rowsPerPage: '1'
        }).then((result)=>{
            const failed = result?.total ?? result?.payload?.total;
            if (!failed) return;
            setFailedAdCreatives(failed);
        }).catch(()=>{
            setFailedAdCreatives(0);
        });
    };
    // Slow fetch
    (0, _react.useEffect)(()=>{
        refreshFailedAdPods();
        dispatch((0, _adPodActions.listAdPods)((0, _utils.withDefaultPagination)({})));
        refreshFailedAdCreatives();
        dispatch((0, _adCreativeActions.listAdCreatives)((0, _utils.withDefaultPagination)({})));
        const interval = setInterval(()=>{
            refreshFailedAdPods();
            dispatch((0, _adPodActions.listAdPods)((0, _utils.withDefaultPagination)({})));
            refreshFailedAdCreatives();
            dispatch((0, _adCreativeActions.listAdCreatives)((0, _utils.withDefaultPagination)({})));
        }, 5000);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        dispatch
    ]);
    // Fast fetch of ad breaks
    (0, _react.useEffect)(()=>{
        refreshFailedAdBreaks();
        dispatch((0, _adBreakActions.listAdBreaks)((0, _utils.withDefaultPagination)({})));
        const interval = setInterval(()=>{
            refreshFailedAdBreaks();
            dispatch((0, _adBreakActions.listAdBreaks)((0, _utils.withDefaultPagination)({})));
        }, 500);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: "Ad Insertion",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                className: "outlined",
                title: "Monitor",
                sx: {
                    mb: 3
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        sm: 12,
                        md: 12
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                        container: true,
                        spacing: 3,
                        alignItems: "stretch",
                        pb: 3,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                size: {
                                    sm: 12,
                                    md: 12
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                                    sx: stretchedPaper,
                                    title: "Ad Breaks",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                                            lg: 12,
                                            xl: 12
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            sx: {
                                                pb: 1,
                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                overflowX: 'auto',
                                                flexWrap: 'nowrap',
                                                gap: 2
                                            },
                                            children: adBreaks.map((adBreak)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(AdBreakCard, {
                                                    adBreak: adBreak
                                                }, adBreak.id))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            sx: {
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                width: '100%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                                    direction: "row",
                                                    spacing: 1,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                            variant: "body1",
                                                            children: [
                                                                totalAdBreaks,
                                                                " Ad Break",
                                                                totalAdBreaks === 1 ? '' : 's',
                                                                " recorded",
                                                                ' '
                                                            ]
                                                        }),
                                                        failedAdBreaks > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningAmberDefault.default), {}),
                                                            color: "warning",
                                                            size: "small",
                                                            label: `${failedAdBreaks} failed`,
                                                            sx: {
                                                                mr: 1
                                                            }
                                                        }) : undefined
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                    variant: "contained",
                                                    onClick: ()=>navigate('adBreaks'),
                                                    children: "View breaks"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                size: {
                                    sm: 12,
                                    md: 6
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                    sx: stretchedPaper,
                                    title: "Audit Log",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            width: '100%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                variant: "body1",
                                                children: "Explore logs from all Ad Insertion services"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                variant: "contained",
                                                onClick: ()=>navigate('adAudit'),
                                                children: "View logs"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                size: {
                                    sm: 12,
                                    md: 6
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                    sx: stretchedPaper,
                                    title: 'Metrics',
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            width: '100%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                variant: "body1",
                                                children: "Explore metrics from all Ad Insertion services"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                variant: "contained",
                                                href: "/grafana/d/ad-insertion/ad-insertion-metrics?orgId=1&refresh=5s",
                                                rel: "noopener noreferrer",
                                                target: "_blank",
                                                children: "View metrics"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                className: "outlined",
                title: "Configure",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        sm: 12,
                        md: 12
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                        container: true,
                        spacing: 3,
                        alignItems: "stretch",
                        pb: 3,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                size: {
                                    sm: 12,
                                    md: 6
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                    sx: stretchedPaper,
                                    title: "Creatives",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            width: '100%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                                direction: "row",
                                                spacing: 1,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                        variant: "body1",
                                                        children: [
                                                            totalAdCreatives,
                                                            " Creative",
                                                            totalAdCreatives === 1 ? '' : 's',
                                                            " available",
                                                            ' '
                                                        ]
                                                    }),
                                                    failedAdCreatives > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningAmberDefault.default), {}),
                                                        color: "warning",
                                                        size: "small",
                                                        label: `${failedAdCreatives} unhealthy`,
                                                        sx: {
                                                            mr: 1
                                                        }
                                                    }) : undefined
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                variant: "contained",
                                                onClick: ()=>navigate('adCreatives'),
                                                children: "View creatives"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                size: {
                                    sm: 12,
                                    md: 6
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                                    sx: stretchedPaper,
                                    title: "Pods",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            width: '100%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                                direction: "row",
                                                spacing: 1,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                        variant: "body1",
                                                        children: [
                                                            totalAdPods,
                                                            " Pod",
                                                            totalAdPods === 1 ? '' : 's',
                                                            " available",
                                                            ' '
                                                        ]
                                                    }),
                                                    failedAdPods > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningAmberDefault.default), {}),
                                                        color: "warning",
                                                        size: "small",
                                                        label: `${failedAdPods} unhealthy`,
                                                        sx: {
                                                            mr: 1
                                                        }
                                                    }) : undefined
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                variant: "contained",
                                                onClick: ()=>navigate('adPods'),
                                                children: "View pods"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                size: {
                                    sm: 12,
                                    md: 12
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adInsertionSettings.AdInsertionSettingsForm), {})
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const AdBreakCard = ({ adBreak })=>{
    const routes = (0, _store.useRoutes)();
    const theme = (0, _styles.useTheme)();
    const isCreativeFiller = (creativeId)=>{
        return adBreak.playlist?.ads?.some((ad)=>ad.id.endsWith(creativeId) && ad.filler);
    };
    const notFillerAdsTrackingEvents = adBreak.trackingEvents.filter((e)=>!isCreativeFiller(e.adCreativeId));
    const reportedTrackingEvents = notFillerAdsTrackingEvents.filter((e)=>e.reportCount > 0);
    const progress = adBreak?.playlist?.ads ? reportedTrackingEvents.length / notFillerAdsTrackingEvents.length * 100 : undefined;
    const statusIsPlaying = [
        (0, _types.AdBreakStatus).playing,
        (0, _types.AdBreakStatus).pending,
        (0, _types.AdBreakStatus).collectingStats
    ].includes(adBreak.status);
    const now = new Date();
    const endTime = (0, _utils1.getEndTime)(adBreak).timestamp;
    const hasEndedWithBuffer = endTime && now.getTime() > endTime.getTime() + 30000;
    const progressBarColor = ()=>{
        if (hasEndedWithBuffer && !progress) return 'error';
        if (statusIsPlaying || !progress) return 'primary';
        if (progress > 99) return 'success';
        return 'error';
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _growDefault.default), {
        in: true,
        timeout: 200,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
            to: `${routes.adBreaks()}/view/${adBreak.id}`,
            style: {
                textDecoration: 'none',
                color: 'inherit'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                sx: {
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    borderColor: theme.palette.grey[800],
                    borderWidth: 2,
                    borderStyle: 'solid',
                    minWidth: 250
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                        title: (0, _dateFns.format)(adBreak.startsAt, (0, _helpers.DATE_FORMAT_LONG)),
                        subheader: adBreak?.playlist?.ads && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                adBreak.playlist.ads.length,
                                " ad",
                                adBreak.playlist.ads.length === 1 ? '' : 's',
                                ",",
                                ' ',
                                adBreak.playlist.ads.length ? adBreak.playlist.ads.map((a)=>a.durationMs / 1000).reduce((p, c)=>p + c).toFixed(2) : 0,
                                ' ',
                                "seconds"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "column",
                            spacing: 1,
                            children: [
                                adBreak.trackingEvents.length ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linearProgressDefault.default), {
                                            value: progress,
                                            variant: hasEndedWithBuffer ? 'determinate' : statusIsPlaying || !progress ? 'indeterminate' : 'determinate',
                                            color: progressBarColor()
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                            variant: "body2",
                                            children: [
                                                hasEndedWithBuffer && !progress ? 0 : progress ? `${progress.toFixed(0)}` : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                                                    width: '1em',
                                                    sx: {
                                                        display: 'inline-block',
                                                        mr: 0.5
                                                    }
                                                }),
                                                "%"
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    variant: "body2",
                                    children: (0, _tableConfig.adBreakStatusText)(adBreak.status, adBreak.errorMessage)
                                })
                            ]
                        })
                    })
                ]
            }, adBreak.id)
        })
    });
};

},{"react/jsx-runtime":"1dlk8","../common/Form":"4Mui7","../common/Wrapper":"8oy7r","react-router":"iaz4C","@mui/material/Button":"3qJY9","@mui/material/Typography":"6NtGx","./AdInsertionSettings":"hLeEp","@mui/material/Grid":"6iX4B","@mui/material/Box":"c4QkF","@mui/material/Card":"4f45q","@mui/material/CardContent":"29GK9","@mui/material/CardHeader":"dFaD2","../../utils":"342UB","@mui/material/styles":"2UrBk","@mui/material/Chip":"5cK8z","@mui/material/Skeleton":"6KYj8","@mui/material/Grow":"do65J","@mui/material/Stack":"6thYv","@mui/material/LinearProgress":"bh8bU","common/api/v1/types":"3qemx","common/api/v1/helpers":"6jovr","date-fns":"gelMX","../../store":"5LXiG","react":"9njXz","react-redux":"l1pMU","../../redux/actions/adBreakActions":"baydX","../../redux/actions/adPodActions":"2olSr","../../redux/actions/adCreativeActions":"gzqhz","./adBreak/tableConfig":"gCXMq","@mui/icons-material/WarningAmber":"eo88y","./adBreak/utils":"azUNr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hLeEp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdInsertionSettingsForm", ()=>AdInsertionSettingsForm);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _form = require("../common/Form");
var _settingsActions = require("../../redux/actions/settingsActions");
var _utils = require("../../utils");
var _pendable = require("../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _store = require("../../store");
var _react = require("react");
var _dataSet = require("../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _helpers = require("common/api/v1/helpers");
var _linearProgress = require("@mui/material/LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _reactHookForm = require("react-hook-form");
var _utils1 = require("common/utils");
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
const AdInsertionSettings = ({ formState })=>{
    const { saving } = (0, _utils.useSettingsSelector)();
    const [storageStatus, setStorageStatus] = (0, _react.useState)(undefined);
    const { getValues, watch } = (0, _reactHookForm.useFormContext)();
    const values = getValues();
    watch('adBucketSizeThreshold');
    const bucketSizeInBytes = (0, _utils1.parseK8sMemoryString)(values.adBucketSizeThreshold || '0');
    const percentUsed = storageStatus?.total.size ? storageStatus?.total.size / bucketSizeInBytes * 100 : undefined;
    (0, _react.useEffect)(()=>{
        (0, _store.Api).adStorageApi.getAdStorageStatus().then((status)=>{
            if (status?.buckets) setStorageStatus(status);
        }).catch(()=>{
            setStorageStatus(undefined);
        });
    }, [
        formState
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                formState: formState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Form), {
                id: "ad-insertion-form",
                noValidate: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                    title: "Storage",
                    sx: {
                        margin: 0,
                        overflow: 'hidden',
                        height: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            lg: 6,
                            xl: 6,
                            children: storageStatus ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdStorageStatusDisplay, {
                                status: storageStatus
                            }) : undefined
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                            lg: 6,
                            xl: 6,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                direction: "column",
                                spacing: 2,
                                sx: {
                                    width: '100%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                        name: "adBucketSizeThreshold",
                                        label: "Ad cache size",
                                        tooltip: `The maximum size of the ad cache. 
                If the size of the ad cache exceeds this value, the retention service will start deleting least recently used ad files. Supports suffixes like G, M, Gi and Mi. 

                NB! If you are using physical storage, this value cannot exceed the combined available disk space of all worker nodes. In cloud environments, more storage can be added dynamically.
                
                Ad Server content does not count towards this limit.
                `,
                                        required: true,
                                        validators: {
                                            k8sMemoryString: {}
                                        },
                                        sx: {
                                            width: '100%'
                                        },
                                        fullWidth: true
                                    }),
                                    percentUsed ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linearProgressDefault.default), {
                                                value: percentUsed,
                                                variant: "determinate",
                                                sx: {
                                                    width: '80%',
                                                    height: 10
                                                },
                                                color: percentUsed < 70 ? 'success' : percentUsed < 80 ? 'warning' : 'error'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                variant: "body2",
                                                children: [
                                                    "Current usage: ",
                                                    percentUsed.toFixed(2),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }) : undefined
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                            main: {
                                Save: {
                                    primary: true,
                                    savingState: saving,
                                    type: 'submit'
                                }
                            }
                        })
                    ]
                })
            })
        ]
    });
};
const AdInsertionSettingsForm = ()=>{
    const { settings } = (0, _utils.useSettingsSelector)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const handleSubmit = async (data)=>{
        dispatch((0, _settingsActions.saveSettings)(data));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
        pending: !settings,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.RHF), {
            onSubmit: handleSubmit,
            defaultValues: {
                ...settings
            },
            component: AdInsertionSettings
        })
    });
};
const AdStorageStatusDisplay = ({ status })=>{
    const dataSetValues = {
        'Cached transcoded ads': `${status.buckets.ads.ads.count} files, ${(0, _helpers.formatFileSize)(status.buckets.ads.ads.size)}`,
        'Cached creatives': `${status.buckets.ads.mezzanines.count} files, ${(0, _helpers.formatFileSize)(status.buckets.ads.mezzanines.size)}`,
        'Ad Server Creatives': `${status.buckets.adServer.creatives.count} files, ${(0, _helpers.formatFileSize)(status.buckets.adServer.creatives.size)}`,
        'Ad Server Thumbnails': `${status.buckets.adServer.thumbnails.count} files, ${(0, _helpers.formatFileSize)(status.buckets.adServer.thumbnails.size)}`,
        Total: `${status.total.count} files, ${(0, _helpers.formatFileSize)(status.total.size)}`
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
        values: dataSetValues
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","../common/Form":"4Mui7","../../redux/actions/settingsActions":"4RBnR","../../utils":"342UB","../common/Pendable":"gDN67","../../store":"5LXiG","react":"9njXz","../common/DataSet":"dmQXG","common/api/v1/helpers":"6jovr","@mui/material/LinearProgress":"bh8bU","react-hook-form":"8z0aI","common/utils":"2AqiH","@mui/material/Stack":"6thYv","@mui/material/Typography":"6NtGx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gCXMq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adBreakStatusText", ()=>adBreakStatusText);
parcelHelpers.export(exports, "AdBreakStatusIcon", ()=>AdBreakStatusIcon);
parcelHelpers.export(exports, "getTableConfig", ()=>getTableConfig);
parcelHelpers.export(exports, "getSmallTableConfig", ()=>getSmallTableConfig);
var _jsxRuntime = require("react/jsx-runtime");
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _types = require("common/api/v1/types");
var _fiberManualRecord = require("@mui/icons-material/FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _actionMenu = require("./ActionMenu");
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _pendingOutlined = require("@mui/icons-material/PendingOutlined");
var _pendingOutlinedDefault = parcelHelpers.interopDefault(_pendingOutlined);
var _utils = require("./utils");
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _playArrow = require("@mui/icons-material/PlayArrow");
var _playArrowDefault = parcelHelpers.interopDefault(_playArrow);
var _fiberManualRecordOutlined = require("@mui/icons-material/FiberManualRecordOutlined");
var _fiberManualRecordOutlinedDefault = parcelHelpers.interopDefault(_fiberManualRecordOutlined);
const styles = {
    inlineWrapper: {
        display: 'flex',
        alignItems: 'center',
        '& > span': {
            marginLeft: (theme)=>theme.spacing(1)
        }
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '34px',
        height: '34px',
        pointerEvents: 'all',
        '& svg': {
            display: 'block'
        }
    },
    warning: {
        color: (theme)=>theme.palette.warning.main
    },
    error: {
        color: (theme)=>theme.palette.error.main
    },
    success: {
        color: (theme)=>theme.palette.success.main
    }
};
const adBreakStatusText = (status, errorMessage)=>{
    switch(status){
        case (0, _types.AdBreakStatus).pending:
            return 'Waiting for Ad break to start';
        case (0, _types.AdBreakStatus).playing:
            return 'Ad break is playing';
        case (0, _types.AdBreakStatus).playOk:
            return 'Ad break finished successfully';
        case (0, _types.AdBreakStatus).playFailed:
            return errorMessage || 'Ad break finished with errors';
        case (0, _types.AdBreakStatus).collectingStats:
            return 'Ad break finished, collecting stats';
        default:
            return 'Unknown';
    }
};
const AdBreakStatusIcon = ({ status })=>{
    switch(status){
        case (0, _types.AdBreakStatus).pending:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendingOutlinedDefault.default), {
                sx: styles.success
            });
        case (0, _types.AdBreakStatus).playing:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    '& svg': {
                        display: 'block'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        position: 'relative',
                        display: 'inline-flex'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                            size: 24,
                            color: "success"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playArrowDefault.default), {
                                fontSize: "small",
                                color: "success"
                            })
                        })
                    ]
                })
            });
        case (0, _types.AdBreakStatus).playOk:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: styles.success
            });
        case (0, _types.AdBreakStatus).playFailed:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: styles.error
            });
        case (0, _types.AdBreakStatus).collectingStats:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordOutlinedDefault.default), {
                sx: styles.success
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                sx: styles.warning
            });
    }
};
const status = ()=>({
        title: 'status',
        getValue: ({ status, errorMessage })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: adBreakStatusText(status, errorMessage),
                placement: "top",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: styles.container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdBreakStatusIcon, {
                            status: status
                        })
                    })
                })
            }),
        props: {
            noTypography: true
        }
    });
const duration = ()=>({
        title: 'duration',
        getValue: (adBreak)=>{
            const { duration } = (0, _utils.getDuration)(adBreak);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: `${duration} ms`,
                placement: "top",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: styles.inlineWrapper,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body2",
                        children: (0, _utils.getDurationFormatted)(adBreak)
                    })
                })
            });
        }
    });
const createdAt = ()=>({
        title: 'created',
        getValue: ({ createdAt })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_LONG)),
                placement: "top",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "body2",
                    children: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_SHORT))
                })
            }),
        sorting: {
            byParameter: (0, _types.ListAdBreakSortableField).createdAt
        }
    });
const getTableConfig = ({ dispatch })=>[
        status(),
        duration(),
        {
            title: 'start time',
            getValue: (adBreak)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: (0, _dateFns.format)(adBreak.startsAt, (0, _helpers.DATE_FORMAT_LONG)),
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        children: (0, _utils.getStartTimeFormatted)(adBreak)
                    })
                });
            },
            sorting: {
                byParameter: (0, _types.ListAdBreakSortableField).startsAt
            }
        },
        {
            title: 'end time',
            getValue: (adBreak)=>{
                const { timestamp } = (0, _utils.getEndTime)(adBreak);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: timestamp ? (0, _dateFns.format)(timestamp, (0, _helpers.DATE_FORMAT_LONG)) : '',
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        children: (0, _utils.getEndTimeFormatted)(adBreak)
                    })
                });
            }
        },
        createdAt(),
        {
            title: '',
            getValue: (adBreak)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    adBreak: adBreak,
                    dispatch: dispatch
                }),
            props: {
                noTypography: true
            }
        }
    ];
const getSmallTableConfig = ()=>[
        status(),
        duration(),
        {
            title: 'start time',
            getValue: (adBreak)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: (0, _dateFns.format)(adBreak.startsAt, (0, _helpers.DATE_FORMAT_LONG)),
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        children: (0, _utils.getStartTimeFormatted)(adBreak)
                    })
                });
            },
            sorting: {
                byParameter: (0, _types.ListAdBreakSortableField).startsAt
            }
        },
        {
            title: 'end time',
            getValue: (adBreak)=>{
                const { timestamp } = (0, _utils.getEndTime)(adBreak);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: timestamp ? (0, _dateFns.format)(timestamp, (0, _helpers.DATE_FORMAT_LONG)) : '',
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        children: (0, _utils.getEndTimeFormatted)(adBreak)
                    })
                });
            }
        }
    ];

},{"react/jsx-runtime":"1dlk8","../../common/Tooltip":"crjvg","@mui/material/Box":"c4QkF","common/api/v1/types":"3qemx","@mui/icons-material/FiberManualRecord":"bvXIN","@mui/icons-material/HelpOutline":"2sIqE","./ActionMenu":"5nVx1","date-fns":"gelMX","common/api/v1/helpers":"6jovr","@mui/material/Typography":"6NtGx","@mui/icons-material/PendingOutlined":"1z1cn","./utils":"azUNr","@mui/material/CircularProgress":"kEtIR","@mui/icons-material/PlayArrow":"4aev3","@mui/icons-material/FiberManualRecordOutlined":"Vffg8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5nVx1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _store = require("../../../store");
var _actionMenu = require("../../common/Table/ActionMenu");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _confirmDialog = require("../../common/ConfirmDialog");
var _adBreakActions = require("../../../redux/actions/adBreakActions");
var _visibility = require("@mui/icons-material/Visibility");
var _visibilityDefault = parcelHelpers.interopDefault(_visibility);
const ActionMenu = ({ adBreak, dispatch })=>{
    const routes = (0, _store.useRoutes)();
    const { showConfirmation } = (0, _confirmDialog.useConfirmationDialog)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            display: 'flex'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
            "data-test-id": "input-action-menu",
            options: [
                {
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visibilityDefault.default), {}),
                    label: 'View',
                    href: routes.adBreaksView({
                        id: adBreak.id
                    }),
                    openInNewTab: false
                },
                {
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                    label: 'Remove',
                    isDestructive: true,
                    onClick: ()=>{
                        showConfirmation(()=>dispatch((0, _adBreakActions.deleteAdBreak)(adBreak.id)), 'Are you sure you want to remove this ad creative?');
                    }
                }
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","../../../store":"5LXiG","../../common/Table/ActionMenu":"jf6As","@mui/icons-material/Delete":"69aC7","../../common/ConfirmDialog":"7JKPn","../../../redux/actions/adBreakActions":"baydX","@mui/icons-material/Visibility":"kayv0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1z1cn":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("94247bb84c568d47").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("45d8f692b93a9885"));
var _jsxRuntime = require("19392938e68da112");
var _default = exports.default = (0, _createSvgIcon.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        cx: "7",
        cy: "12",
        r: "1.5"
    }, "1"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        cx: "12",
        cy: "12",
        r: "1.5"
    }, "2"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        cx: "17",
        cy: "12",
        r: "1.5"
    }, "3")
], 'PendingOutlined');

},{"94247bb84c568d47":"kZ6eK","45d8f692b93a9885":"2vOnF","19392938e68da112":"1dlk8"}],"azUNr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndTime", ()=>getEndTime);
parcelHelpers.export(exports, "getDuration", ()=>getDuration);
parcelHelpers.export(exports, "getStartTimeFormatted", ()=>getStartTimeFormatted);
parcelHelpers.export(exports, "getEndTimeFormatted", ()=>getEndTimeFormatted);
parcelHelpers.export(exports, "getDurationFormatted", ()=>getDurationFormatted);
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
const getEndTime = (adBreak)=>{
    if (adBreak.endedAt) return {
        timestamp: new Date(adBreak.endedAt),
        estimated: false
    };
    if (adBreak.endsAt) return {
        timestamp: new Date(adBreak.endsAt),
        estimated: true
    };
    if (adBreak.playlist?.ads) {
        const totalMs = adBreak.playlist.ads.reduce((acc, ad)=>acc + ad.durationMs, 0);
        return {
            timestamp: new Date(adBreak.startsAt.getTime() + totalMs),
            estimated: true
        };
    }
    return {
        timestamp: undefined,
        estimated: false
    };
};
const getDuration = (adBreak)=>{
    const { timestamp, estimated } = getEndTime(adBreak);
    if (!timestamp) return {
        duration: undefined,
        estimated: false
    };
    return {
        duration: timestamp.getTime() - adBreak.startsAt.getTime(),
        estimated
    };
};
const getStartTimeFormatted = ({ startsAt })=>{
    const now = new Date();
    const diffMs = now.getTime() - startsAt.getTime();
    const diffMinutes = Math.abs(diffMs) / 60000;
    const isFuture = diffMs < 0;
    if (diffMinutes < 1) return isFuture ? '< 1 minute' : '< 1 minute ago';
    if (diffMinutes < 60) {
        const minutes = Math.floor(diffMinutes);
        return isFuture ? `${minutes} minute${minutes !== 1 ? 's' : ''}` : `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    }
    return (0, _dateFns.format)(startsAt, (0, _helpers.DATE_FORMAT_LONG));
};
const getEndTimeFormatted = (adBreak)=>{
    const { timestamp } = getEndTime(adBreak);
    if (!timestamp) return '-';
    const now = new Date();
    const diffMs = now.getTime() - timestamp.getTime();
    const diffMinutes = Math.abs(diffMs) / 60000;
    const isFuture = diffMs < 0;
    if (diffMinutes < 1) return isFuture ? '< 1 minute' : '< 1 minute ago';
    if (diffMinutes < 60) {
        const minutes = Math.floor(diffMinutes);
        return isFuture ? `${minutes} minute${minutes !== 1 ? 's' : ''}` : `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    }
    return (0, _dateFns.format)(timestamp, (0, _helpers.DATE_FORMAT_LONG));
};
const getDurationFormatted = (adBreak)=>{
    const { duration, estimated } = getDuration(adBreak);
    if (duration === undefined) return '-';
    return `${(0, _helpers.formatMs)(duration)}${estimated ? ' (estimated)' : ''}`;
};

},{"date-fns":"gelMX","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eo88y":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("e2e1649c3b1f56ed").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("79ef85b6b94eae2e"));
var _jsxRuntime = require("21af3f43ee2adffa");
var _default = exports.default = (0, _createSvgIcon.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], 'WarningAmber');

},{"e2e1649c3b1f56ed":"kZ6eK","79ef85b6b94eae2e":"2vOnF","21af3f43ee2adffa":"1dlk8"}],"dE9Kn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditAdServer", ()=>EditAdServer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _types = require("common/api/v1/types");
var _rhf = require("../../common/Form/RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
var _store = require("../../../store");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _utils = require("../../../utils");
var _adServerActions = require("../../../redux/actions/adServerActions");
var _form = require("../../common/Form");
var _util = require("common/util");
const getInitialState = (adServer)=>(0, _mergeDefault.default)({
        id: '',
        name: '',
        baseUrl: ''
    }, adServer);
const isEditing = (values)=>'id' in values && !!values.id;
const AdServerForm = ({ getValues, setError, setFocus, watch, formState })=>{
    const values = getValues();
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const setConfirmation = (0, _utils.useConfirmationDialog)();
    const { formErrors, saving } = (0, _reactRedux.useSelector)(({ groupsReducer })=>({
            formErrors: groupsReducer.formErrors,
            saving: groupsReducer.saving
        }), (0, _reactRedux.shallowEqual));
    const user = (0, _utils.useUser)();
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach((item)=>{
                setError(item.name, {
                    type: 'manual',
                    message: item.reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    // This will cause the form to re-render on each key press in the name and baseUrl fields
    // If this form grows in complexity, these fields should be moved to their own component (so that only
    // that component re-renders on key press), but right now the form is simple enough that it's not necessary
    watch([
        'name',
        'baseUrl'
    ]);
    if (user.role !== (0, _types.Role).super && (user.role !== (0, _types.Role).admin || user.group !== values.id)) {
        navigate(-1);
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        container: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            size: {
                xs: 12
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                    formState: formState
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                    id: "ad-server-form",
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                    name: "name",
                                    label: "Name",
                                    required: true,
                                    autoFocus: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                    name: "baseUrl",
                                    label: "Base URL",
                                    required: true,
                                    tooltip: 'Part of the ad server URL that is common to all outputs',
                                    validators: {
                                        format: {
                                            prefixes: [
                                                'http://',
                                                'https://'
                                            ]
                                        }
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                            main: {
                                Cancel: {
                                    onClick: ()=>navigate(routes.adServers())
                                },
                                Save: {
                                    savingState: !!saving,
                                    primary: true,
                                    type: 'submit'
                                }
                            },
                            secondary: isEditing(values) && user.role === (0, _types.Role).super ? {
                                Delete: {
                                    onClick: ()=>isEditing(values) && setConfirmation(()=>{
                                            dispatch((0, _adServerActions.deleteAdServer)(values.id));
                                            navigate(routes.adServers());
                                        }, 'Are you sure you want to delete this Ad Server?', values.name)
                                }
                            } : undefined
                        })
                    ]
                })
            ]
        })
    });
};
const EditAdServer = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        id && dispatch((0, _adServerActions.getAdServer)(id));
        return ()=>{
            dispatch((0, _adServerActions.clearAdServer)());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const selectedAdServer = (0, _reactRedux.useSelector)(({ adInsertionReducer })=>adInsertionReducer.selectedAdServer, (0, _util.equals));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Ad Insertion',
            'Ad Servers',
            id ? selectedAdServer?.name : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: !!id && !selectedAdServer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rhfDefault.default), {
                onSubmit: (values)=>{
                    dispatch(id ? (0, _adServerActions.updateAdServer)((0, _utils.formTransform)(values)) : (0, _adServerActions.createAdServer)((0, _utils.formTransform)(values)));
                },
                defaultValues: getInitialState(selectedAdServer),
                component: AdServerForm
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","lodash/merge":"iHC1F","@mui/material/Grid":"6iX4B","common/api/v1/types":"3qemx","../../common/Form/RHF":"7gFt3","../../../store":"5LXiG","../../common/Wrapper":"8oy7r","../../common/Pendable":"gDN67","../../../utils":"342UB","../../../redux/actions/adServerActions":"h89Of","../../common/Form":"4Mui7","common/util":"jV4UZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eHk6i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DemoPage", ()=>DemoPage);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("../../../utils");
var _preview = require("../../common/Preview");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _react = require("react");
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _check = require("@mui/icons-material/Check");
var _checkDefault = parcelHelpers.interopDefault(_check);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _hourglassEmptyOutlined = require("@mui/icons-material/HourglassEmptyOutlined");
var _hourglassEmptyOutlinedDefault = parcelHelpers.interopDefault(_hourglassEmptyOutlined);
var _buttonGroup = require("@mui/material/ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _hideImage = require("@mui/icons-material/HideImage");
var _hideImageDefault = parcelHelpers.interopDefault(_hideImage);
var _image = require("@mui/icons-material/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _visTimeline = require("vis-timeline");
var _visTimelineGraph2DMinCss = require("vis-timeline/dist/vis-timeline-graph2d.min.css");
var _visjsOverridesCss = require("./visjs-overrides.css");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _initialAdStages = require("./initialAdStages");
var _arcadeButton = require("./ArcadeButton");
var _arcadeButtonDefault = parcelHelpers.interopDefault(_arcadeButton);
var _reactRedux = require("react-redux");
var _store = require("../../../store");
var _adInsertionDemoActions = require("../../../redux/actions/adInsertionDemoActions");
var _util = require("common/util");
var _adAuditActions = require("../../../redux/actions/adAuditActions");
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _logger = require("../../../logger");
var _autocomplete = require("@mui/material/Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _constants = require("common/constants");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
const DemoPage = ()=>{
    const { inputs } = (0, _utils.useInputsSelector)({
        pageNumber: '0',
        rowsPerPage: '2',
        tags: 'ad-insertion-demo'
    });
    const log = (0, _logger.getLogger)('adInsertionDemo');
    const options = {
        width: '100%',
        height: '500px',
        showMajorLabels: true,
        showCurrentTime: true,
        zoomable: false,
        zoomMax: 30000,
        zoomMin: 30000,
        type: 'box',
        format: {
            minorLabels: {
                second: 'ss'
            }
        },
        start: Date.now() - 30000,
        end: Date.now() + 30000,
        rollingMode: {
            follow: true,
            offset: 0.5
        }
    };
    const dispatch = (0, _reactRedux.useDispatch)();
    // State
    const [previewEnabled, setPreviewEnabled] = (0, _react.useState)(false);
    const [settingsExpanded, setSettingsExpanded] = (0, _react.useState)(false);
    const [items, setItems] = (0, _react.useState)([]);
    const [stages, setStages] = (0, _react.useState)((0, _initialAdStages.initialStages));
    const [eventId, setEventId] = (0, _react.useState)(undefined);
    const [intervalRef, setIntervalRef] = (0, _react.useState)();
    const [adAuditSse, setAdAuditSse] = (0, _react.useState)([]);
    const [eventSourceRef, setEventSourceRef] = (0, _react.useState)();
    const [triggered, setTriggered] = (0, _react.useState)(false);
    const [disableArcadeButton, setDisableArcadeButton] = (0, _react.useState)(false);
    // Settings
    const [connectionMode, setConnectionMode] = (0, _react.useState)();
    const [durationMs, setDurationMs] = (0, _react.useState)();
    const [timeShiftMs, setTimeShiftMs] = (0, _react.useState)();
    const [preRollMs, setPreRollMs] = (0, _react.useState)();
    const [postInsertionMs, setPostInsertionMs] = (0, _react.useState)();
    const [applianceId, setApplianceId] = (0, _react.useState)();
    const [outputId, setOutputId] = (0, _react.useState)();
    // Load settings from local storage on mount
    (0, _react.useEffect)(()=>{
        const savedConnectionMode = localStorage.getItem('adInsertionDemo_connectionMode');
        const savedDurationMs = localStorage.getItem('adInsertionDemo_durationMs');
        const savedTimeShiftMs = localStorage.getItem('adInsertionDemo_timeShiftMs');
        const savedPreRollMs = localStorage.getItem('adInsertionDemo_preRollMs');
        const savedPostInsertionMs = localStorage.getItem('adInsertionDemo_postInsertionMs');
        const savedApplianceId = localStorage.getItem('adInsertionDemo_applianceId');
        const savedOutputId = localStorage.getItem('adInsertionDemo_outputId');
        if (savedConnectionMode) setConnectionMode(savedConnectionMode);
        else setConnectionMode('sse');
        if (savedDurationMs) setDurationMs(Number(savedDurationMs));
        else setDurationMs(30000);
        if (savedTimeShiftMs) setTimeShiftMs(Number(savedTimeShiftMs));
        else setTimeShiftMs(1000);
        if (savedPreRollMs) setPreRollMs(Number(savedPreRollMs));
        else setPreRollMs(10000);
        if (savedPostInsertionMs) setPostInsertionMs(Number(savedPostInsertionMs));
        else setPostInsertionMs(5000);
        if (savedApplianceId) setApplianceId(savedApplianceId);
        if (savedOutputId) setOutputId(savedOutputId);
    }, []);
    // Save settings to local storage when they change
    (0, _react.useEffect)(()=>{
        if (connectionMode) localStorage.setItem('adInsertionDemo_connectionMode', connectionMode);
        if (durationMs) localStorage.setItem('adInsertionDemo_durationMs', durationMs.toString());
        if (timeShiftMs) localStorage.setItem('adInsertionDemo_timeShiftMs', timeShiftMs.toString());
        if (preRollMs) localStorage.setItem('adInsertionDemo_preRollMs', preRollMs.toString());
        if (postInsertionMs) localStorage.setItem('adInsertionDemo_postInsertionMs', postInsertionMs.toString());
        if (applianceId) localStorage.setItem('adInsertionDemo_applianceId', applianceId);
        if (outputId) localStorage.setItem('adInsertionDemo_outputId', outputId);
        const handleKeyDown = (event)=>{
            if (event.code === 'Space') {
                handleExternalTrigger();
                handleArcadeButton();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        connectionMode,
        durationMs,
        preRollMs,
        postInsertionMs,
        applianceId,
        outputId,
        triggered
    ]);
    // Set mode to polling if appliance type is Videon
    (0, _react.useEffect)(()=>{
        if (!applianceId) return;
        (0, _store.Api).appliancesApi.getAppliance(applianceId).then((result)=>{
            if (result?.type === 'videon') setConnectionMode('polling');
        });
    }, [
        applianceId,
        connectionMode
    ]);
    const { adAudit } = (0, _reactRedux.useSelector)(({ adAuditReducer })=>({
            adAudit: adAuditReducer.adAudit
        }), (0, _util.equals));
    const calculateStageTime = (stage, index)=>{
        if (stage.stage === 'request' && eventId) return `Event ID: ${eventId}`;
        if (!stage.endTime) return;
        if (stage.hideTime) return;
        if (stage.previousStage) {
            const previousStage = stages.find((s)=>s.stage === stage.previousStage);
            if (!previousStage?.endTime) return;
            return `${stage.endTime - previousStage.endTime} ms`;
        }
        if (!(index > 0 && stages[index - 1].endTime)) return;
        return `${stage.endTime - stages[index - 1].endTime} ms`;
    };
    const renderStage = (stage, index)=>{
        const renderStageIcon = (stage)=>{
            let status = stage.status;
            if (stage.stage === 'request' && !eventId) status = undefined;
            if (status === 'done') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkDefault.default), {
                sx: {
                    height: 30,
                    width: 30
                }
            });
            if (status === 'progress') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                size: 30,
                thickness: 6
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hourglassEmptyOutlinedDefault.default), {
                sx: {
                    height: 30,
                    width: 30
                }
            });
        };
        const opacity = stage.status === 'progress' ? 1 : 0.6;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
                style: {
                    opacity
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                        children: renderStageIcon(stage)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                        primary: stage.displayName,
                        secondary: calculateStageTime(stage, index)
                    })
                ]
            })
        }, stage.stage);
    };
    const timelineRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!timelineRef.current) return;
        const timeline = new (0, _visTimeline.Timeline)(timelineRef.current, items, options);
        return ()=>{
            timeline.destroy();
        };
    }, [
        items,
        options
    ]);
    const setupSse = (eventId)=>{
        return new Promise((resolve)=>{
            log('Setting up SSE for event ID', eventId);
            const queryParams = {
                filter: {
                    eventId,
                    outputId
                }
            };
            const path = `/api/ad-audit-log/sse?q=${JSON.stringify(queryParams)}`;
            const eventSource = new EventSource(path);
            eventSource.onopen = ()=>{
                log('SSE connection established for event ID', eventId);
                setEventSourceRef(eventSource);
                resolve(eventSource);
            };
            eventSource.onerror = (error)=>{
                log('SSE error for event ID', eventId, error);
                resolve(eventSource);
            };
            eventSource.onmessage = (event)=>{
                log('SSE message for event ID', eventId, event.data);
                const newAuditMessage = JSON.parse(event.data);
                setAdAuditSse((prev)=>[
                        ...prev,
                        newAuditMessage
                    ]);
            };
        });
    };
    const handleArcadeButton = async ()=>{
        if (!(applianceId && preRollMs && postInsertionMs && durationMs)) return;
        if (triggered) return;
        document.cookie = `${0, _constants.COOKIE_APPLIANCE_PROXY}=${applianceId};path=/api/scte104-injection`;
        const proposedEventId = Math.floor(Math.random() * 100000);
        log('Triggering ad break', proposedEventId);
        if (connectionMode === 'sse') setEventId(proposedEventId);
        // Reset state
        setAdAuditSse([]);
        setItems([]);
        setStages((0, _initialAdStages.initialStages));
        setDisableArcadeButton(true);
        // SSE is set up prior to triggering ad break so that we don't miss any logs
        if (connectionMode === 'sse') await setupSse(proposedEventId);
        dispatch((0, _adInsertionDemoActions.triggerAdBreak)({
            eventId: proposedEventId,
            applianceId,
            preRollMs,
            durationMs
        })).then((result)=>{
            const returnedEventId = result.payload.eventId;
            log('Ad break triggered', returnedEventId);
            setEventId(returnedEventId);
            setTriggered(true);
            setTimeout(()=>{
                setDisableArcadeButton(false);
                setTriggered(false);
            }, preRollMs + durationMs + postInsertionMs);
        }).catch((error)=>{
            log('Error triggering ad break', error);
            setTriggered(false);
            setDisableArcadeButton(false);
        });
    };
    (0, _react.useEffect)(()=>{
        if (!(applianceId && preRollMs && durationMs && timeShiftMs)) return;
        if (triggered && eventId) {
            setItems([
                ...items,
                {
                    id: Math.random(),
                    content: 'Pre roll',
                    start: Date.now(),
                    end: Date.now() + preRollMs + timeShiftMs,
                    type: 'background',
                    style: 'background-color: rgba(77,80,90,0.5)'
                },
                {
                    id: Math.random(),
                    content: 'Ad break',
                    start: Date.now() + preRollMs + timeShiftMs,
                    end: Date.now() + preRollMs + durationMs + timeShiftMs,
                    type: 'background'
                }
            ]);
            log('Starting ad inseriton demo cycle');
            if (connectionMode === 'polling') {
                log('Polling mode set');
                if (intervalRef) clearInterval(intervalRef);
                const now = Date.now();
                const adBreakEnd = now + preRollMs + durationMs + (postInsertionMs || 0) + timeShiftMs;
                const interval = setInterval(()=>{
                    if (Date.now() > adBreakEnd) {
                        clearInterval(interval);
                        return;
                    }
                    dispatch((0, _adAuditActions.getAdAudit)({
                        eventId: eventId.toString(),
                        outputId,
                        fromDate: new Date(now).toISOString()
                    }));
                }, 50);
                setIntervalRef(interval);
            }
        } else {
            log('Ad insertion demo cycle finished');
            if (intervalRef) clearInterval(intervalRef);
            if (eventSourceRef) eventSourceRef.close();
            dispatch((0, _adAuditActions.getAdAudit)({
                eventId: '0'
            })) // clear ad audit
            ;
            setStages((0, _initialAdStages.initialStages));
        }
    }, [
        triggered
    ]);
    // Handle new ad audit logs arrived
    (0, _react.useEffect)(()=>{
        if (!(connectionMode === 'sse' ? adAuditSse : adAudit)) return;
        if (!triggered) return;
        // Check if any of the stage criteria are met
        const newItems = [];
        const updatedStages = stages.map((stage)=>{
            if (stage.status === 'done') return stage;
            const updatedStage = {
                ...stage
            };
            if (stage.doneCriteria && stage.doneCriteria.length > 0) {
                let finishTime;
                const isStageDone = stage.doneCriteria.every((criterion)=>{
                    return (connectionMode === 'sse' ? adAuditSse : adAudit).some((log)=>{
                        finishTime = new Date(log.timestamp).getTime();
                        let entityCheck = true;
                        if (criterion.entityName) entityCheck = log.entityName === criterion.entityName;
                        return log.entityType === criterion.entity && log.method === criterion.method && log.status === criterion.status && entityCheck;
                    });
                });
                if (isStageDone) {
                    updatedStage.status = 'done';
                    if (finishTime) {
                        updatedStage.endTime = finishTime;
                        newItems.push({
                            id: Math.random(),
                            content: updatedStage.displayName,
                            start: finishTime,
                            end: finishTime
                        });
                    }
                }
            } else if (stage.progressCriteria && stage.progressCriteria.length > 0) {
                const isStageProgress = stage.progressCriteria.every((criterion)=>{
                    return (connectionMode === 'sse' ? adAuditSse : adAudit).some((log)=>{
                        return log.entityType === criterion.entity && log.method === criterion.method && log.status === criterion.status;
                    });
                });
                if (isStageProgress) updatedStage.status = 'progress';
            }
            return updatedStage;
        });
        // ensure that all stages before a done stage are also done
        const doneIndex = updatedStages.findLastIndex((stage)=>stage.status === 'done');
        if (doneIndex > -1) updatedStages.forEach((stage, index)=>{
            if (index < doneIndex && stage.status !== 'done') updatedStages[index] = {
                ...stage,
                status: 'done'
            };
        });
        setItems([
            ...items,
            ...newItems
        ]);
        setStages(updatedStages);
    }, [
        adAuditSse,
        adAudit
    ]);
    const triggerAnimationRef = (0, _react.useRef)();
    const handleExternalTrigger = ()=>{
        if (triggered) return;
        if (triggerAnimationRef.current) triggerAnimationRef.current();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: "Ad Insertion",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            container: true,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        lg: 12,
                        xl: 12
                    },
                    sx: {
                        my: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonGroupDefault.default), {
                        children: [
                            inputs.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                variant: "outlined",
                                startIcon: previewEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hideImageDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageDefault.default), {}),
                                onClick: ()=>setPreviewEnabled(!previewEnabled),
                                children: `${previewEnabled ? 'Hide' : 'Show'} streams`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                variant: "outlined",
                                onClick: ()=>setSettingsExpanded(!settingsExpanded),
                                startIcon: settingsExpanded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                                children: `${settingsExpanded ? 'Hide' : 'Show'} settings`
                            })
                        ]
                    })
                }),
                settingsExpanded && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                    container: true,
                    spacing: 2,
                    sx: {
                        my: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            size: {
                                xs: 12,
                                lg: 4
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlDefault.default), {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScteInserterApplianceAutocomplete, {
                                    value: applianceId,
                                    onChange: (id)=>setApplianceId(id),
                                    fetchAppliances: async ()=>{
                                        const appliancesResult = await (0, _store.Api).appliancesApi.listAppliances({
                                            filter: {
                                                capabilities: {
                                                    scteInserter: true
                                                }
                                            }
                                        });
                                        return appliancesResult.items;
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            size: {
                                xs: 12,
                                lg: 4
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlDefault.default), {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutputAutoComplete, {
                                    value: outputId,
                                    onChange: (id)=>setOutputId(id),
                                    fetchOutputs: async ()=>{
                                        const outputsResult = await (0, _store.Api).outputApi.getOutputs({
                                            pageNumber: '0',
                                            rowsPerPage: '50'
                                        });
                                        return outputsResult.items;
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            size: {
                                xs: 12,
                                lg: 4
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                        id: "connection-mode-label",
                                        children: "Connection Mode"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectDefault.default), {
                                        value: connectionMode,
                                        onChange: (event)=>setConnectionMode(event.target.value),
                                        displayEmpty: true,
                                        label: "Connection Mode",
                                        labelId: "connection-mode-label",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                                value: "polling",
                                                children: "Polling"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                                value: "sse",
                                                children: "SSE"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            size: {
                                xs: 12,
                                lg: 3
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                label: "Pre-roll time (ms)",
                                value: preRollMs || '',
                                onChange: (e)=>setPreRollMs(parseInt(e.target.value)),
                                fullWidth: true,
                                error: !preRollMs
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            size: {
                                xs: 12,
                                lg: 3
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                label: "Post insertion time (ms)",
                                value: postInsertionMs || '',
                                onChange: (e)=>setPostInsertionMs(parseInt(e.target.value)),
                                fullWidth: true,
                                error: !postInsertionMs
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            size: {
                                xs: 12,
                                lg: 3
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                label: "Time shift (ms)",
                                value: timeShiftMs || '',
                                onChange: (e)=>setTimeShiftMs(parseInt(e.target.value)),
                                fullWidth: true,
                                error: !timeShiftMs
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                            size: {
                                xs: 12,
                                lg: 3
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                label: "Ad break duration (ms)",
                                value: durationMs || '',
                                onChange: (e)=>setDurationMs(parseInt(e.target.value)),
                                fullWidth: true,
                                error: !durationMs
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        lg: 12,
                        xl: 12
                    },
                    sx: {
                        my: 1
                    },
                    children: previewEnabled && inputs.map((input)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _preview.Preview), {
                            inputId: input.id,
                            isOnDemand: false,
                            isAudioOnly: false,
                            width: '50%',
                            height: "auto"
                        }, input.id))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        lg: 9,
                        xl: 8
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: '100%',
                        gap: 10,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                width: '100%',
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    ref: timelineRef
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arcadeButtonDefault.default), {
                                onClick: handleArcadeButton,
                                size: 200,
                                triggerExternalAnimation: (trigger)=>triggerAnimationRef.current = trigger,
                                disabled: !(applianceId && outputId) || disableArcadeButton
                            }),
                            !(applianceId && outputId) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                color: "red",
                                variant: "h3",
                                children: "Select an appliance and output in settings to start the demo"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        lg: 3,
                        xl: 4
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                        children: stages.map((stage, index)=>renderStage(stage, index))
                    })
                })
            ]
        })
    });
};
const ScteInserterApplianceAutocomplete = ({ value, onChange, fetchAppliances })=>{
    const [open, setOpen] = (0, _react.useState)(false);
    const [appliances, setAppliances] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [inputValue, setInputValue] = (0, _react.useState)('');
    // Load appliances initially and when dropdown opens
    const loadAppliances = (0, _react.useCallback)(async ()=>{
        if (appliances.length === 0) {
            setLoading(true);
            try {
                const fetchedAppliances = await fetchAppliances();
                setAppliances(fetchedAppliances);
            } finally{
                setLoading(false);
            }
        }
    }, [
        fetchAppliances,
        appliances.length
    ]);
    (0, _react.useEffect)(()=>{
        loadAppliances();
    }, [
        loadAppliances
    ]);
    const handleOpen = ()=>{
        setOpen(true);
        loadAppliances();
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    const selectedAppliance = appliances.find((appliance)=>appliance.id === value) || null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteDefault.default), {
        open: open,
        value: selectedAppliance,
        inputValue: inputValue,
        onInputChange: (_event, newInputValue)=>{
            setInputValue(newInputValue);
        },
        onOpen: handleOpen,
        onClose: handleClose,
        onChange: (_event, newValue)=>{
            onChange(newValue?.id || '');
        },
        isOptionEqualToValue: (option, value)=>option.id === value.id,
        getOptionLabel: (option)=>option?.name || '',
        options: appliances,
        loading: loading,
        renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                ...params,
                label: "SCTE Inserter Appliance",
                InputProps: {
                    ...params.InputProps,
                    endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                                color: "inherit",
                                size: 20
                            }) : null,
                            params.InputProps.endAdornment
                        ]
                    })
                }
            })
    });
};
const OutputAutoComplete = ({ value, onChange, fetchOutputs })=>{
    const [open, setOpen] = (0, _react.useState)(false);
    const [outputs, setOutputs] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [inputValue, setInputValue] = (0, _react.useState)('');
    // Load outputs initially and when dropdown opens
    const loadOutputs = (0, _react.useCallback)(async ()=>{
        if (outputs.length === 0) {
            setLoading(true);
            try {
                const fetchedOutputs = await fetchOutputs();
                setOutputs(fetchedOutputs);
            } finally{
                setLoading(false);
            }
        }
    }, [
        fetchOutputs,
        outputs.length
    ]);
    (0, _react.useEffect)(()=>{
        loadOutputs();
    }, [
        loadOutputs
    ]);
    const handleOpen = ()=>{
        setOpen(true);
        loadOutputs();
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    const selectedOutput = outputs.find((output)=>output.id === value) || null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteDefault.default), {
        open: open,
        value: selectedOutput,
        inputValue: inputValue,
        onInputChange: (_event, newInputValue)=>{
            setInputValue(newInputValue);
        },
        onOpen: handleOpen,
        onClose: handleClose,
        onChange: (_event, newValue)=>{
            onChange(newValue?.id || '');
        },
        isOptionEqualToValue: (option, value)=>option.id === value.id,
        getOptionLabel: (option)=>option?.name || '',
        options: outputs,
        loading: loading,
        renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                ...params,
                label: "Output",
                InputProps: {
                    ...params.InputProps,
                    endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                                color: "inherit",
                                size: 20
                            }) : null,
                            params.InputProps.endAdornment
                        ]
                    })
                }
            })
    });
};

},{"react/jsx-runtime":"1dlk8","../../../utils":"342UB","../../common/Preview":"58Cok","../../common/Wrapper":"8oy7r","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","react":"9njXz","@mui/material/List":"a52pA","@mui/material/ListItemText":"1ZvGq","@mui/material/ListItem":"fosVg","@mui/material/ListItemIcon":"2WZ7w","@mui/icons-material/Check":"hwZzP","@mui/material/CircularProgress":"kEtIR","@mui/icons-material/HourglassEmptyOutlined":"i6ndf","@mui/material/ButtonGroup":"j3Fbo","@mui/icons-material/HideImage":"57AQK","@mui/icons-material/Image":"1zQo3","vis-timeline":"anjhb","vis-timeline/dist/vis-timeline-graph2d.min.css":"13BOJ","./visjs-overrides.css":"BHFWK","@mui/material/Grid":"6iX4B","./initialAdStages":"afvNf","./ArcadeButton":"iRVQV","react-redux":"l1pMU","../../../store":"5LXiG","../../../redux/actions/adInsertionDemoActions":"6yWKU","common/util":"jV4UZ","../../../redux/actions/adAuditActions":"ddShH","@mui/material/TextField":"l88b4","@mui/icons-material/Close":"acjz6","@mui/icons-material/Settings":"jkTfg","@mui/material/FormControl":"ioFZ4","@mui/material/MenuItem":"krMs8","@mui/material/Select":"kyj0v","@mui/material/InputLabel":"5EJtb","../../../logger":"7sPvG","@mui/material/Autocomplete":"avdFA","common/constants":"bdiC1","@mui/material/Typography":"6NtGx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i6ndf":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("716b1a81e602986").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("eddf855ce7b48f78"));
var _jsxRuntime = require("b601233cb8024d82");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2zm10 14.5V20H8v-3.5l4-4zm-4-5-4-4V4h8v3.5z"
}), 'HourglassEmptyOutlined');

},{"716b1a81e602986":"kZ6eK","eddf855ce7b48f78":"2vOnF","b601233cb8024d82":"1dlk8"}],"j3Fbo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e9a070ed566c4d45").default;
var _interopRequireDefault = require("ada3617c2aaf34d0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    buttonGroupClasses: true,
    ButtonGroupContext: true,
    ButtonGroupButtonContext: true
};
Object.defineProperty(exports, "ButtonGroupButtonContext", {
    enumerable: true,
    get: function() {
        return _ButtonGroupButtonContext.default;
    }
});
Object.defineProperty(exports, "ButtonGroupContext", {
    enumerable: true,
    get: function() {
        return _ButtonGroupContext.default;
    }
});
Object.defineProperty(exports, "buttonGroupClasses", {
    enumerable: true,
    get: function() {
        return _buttonGroupClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ButtonGroup.default;
    }
});
var _ButtonGroup = _interopRequireDefault(require("4c37f635af6bb587"));
var _buttonGroupClasses = _interopRequireWildcard(require("35199087d41eb107"));
Object.keys(_buttonGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _buttonGroupClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _buttonGroupClasses[key];
        }
    });
});
var _ButtonGroupContext = _interopRequireDefault(require("126489fb4c4c120e"));
var _ButtonGroupButtonContext = _interopRequireDefault(require("32da6f72f412cf2a"));

},{"e9a070ed566c4d45":"fiRIh","ada3617c2aaf34d0":"kZ6eK","4c37f635af6bb587":"8ZZSQ","35199087d41eb107":"iknnG","126489fb4c4c120e":"fyAGU","32da6f72f412cf2a":"a118j"}],"8ZZSQ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("55e8eb070e9ec71e").default;
var _interopRequireWildcard = require("c195303bd8aee546").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("61538b298be75d3c"));
var _propTypes = _interopRequireDefault(require("230ae7bd72526253"));
var _clsx = _interopRequireDefault(require("6ce917092516614c"));
var _composeClasses = _interopRequireDefault(require("9c53080b52eb7cfa"));
var _colorManipulator = require("66997dadbad9055a");
var _getValidReactChildren = _interopRequireDefault(require("5154d45b5e61d70f"));
var _capitalize = _interopRequireDefault(require("4424087bb086764b"));
var _zeroStyled = require("f263d019b3d54a1e");
var _memoTheme = _interopRequireDefault(require("406d6bc92272fe4b"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("8b0b14a0b1da5f24"));
var _DefaultPropsProvider = require("4a14d102ab8ae3a4");
var _buttonGroupClasses = _interopRequireWildcard(require("3e3d890e62b2168"));
var _ButtonGroupContext = _interopRequireDefault(require("d513580fb21e1cd1"));
var _ButtonGroupButtonContext = _interopRequireDefault(require("7452dc2eaba483b0"));
var _jsxRuntime = require("fdd0e8a26f3bf833");
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        {
            [`& .${_buttonGroupClasses.default.grouped}`]: styles.grouped
        },
        {
            [`& .${_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize.default)(ownerState.orientation)}`]
        },
        {
            [`& .${_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize.default)(ownerState.variant)}`]
        },
        {
            [`& .${_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize.default)(ownerState.variant)}${(0, _capitalize.default)(ownerState.orientation)}`]
        },
        {
            [`& .${_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize.default)(ownerState.variant)}${(0, _capitalize.default)(ownerState.color)}`]
        },
        {
            [`& .${_buttonGroupClasses.default.firstButton}`]: styles.firstButton
        },
        {
            [`& .${_buttonGroupClasses.default.lastButton}`]: styles.lastButton
        },
        {
            [`& .${_buttonGroupClasses.default.middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, disableElevation, fullWidth, orientation, variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, _capitalize.default)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, _capitalize.default)(orientation)}`,
            `grouped${(0, _capitalize.default)(variant)}`,
            `grouped${(0, _capitalize.default)(variant)}${(0, _capitalize.default)(orientation)}`,
            `grouped${(0, _capitalize.default)(variant)}${(0, _capitalize.default)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, _composeClasses.default)(slots, _buttonGroupClasses.getButtonGroupUtilityClass, classes);
};
const ButtonGroupRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver
})((0, _memoTheme.default)(({ theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2]
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${_buttonGroupClasses.default.lastButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${_buttonGroupClasses.default.lastButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${_buttonGroupClasses.default.disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${_buttonGroupClasses.default.disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color
                        },
                        style: {
                            [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                                borderColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${_buttonGroupClasses.default.lastButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${_buttonGroupClasses.default.lastButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${_buttonGroupClasses.default.disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${_buttonGroupClasses.default.disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color
                    },
                    style: {
                        [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${_buttonGroupClasses.default.grouped}`]: {
            minWidth: 40,
            boxShadow: 'none',
            props: {
                variant: 'contained'
            },
            style: {
                '&:hover': {
                    boxShadow: 'none'
                }
            }
        }
    })));
const ButtonGroup = /*#__PURE__*/ React.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children, className, color = 'primary', component = 'div', disabled = false, disableElevation = false, disableFocusRipple = false, disableRipple = false, fullWidth = false, orientation = 'horizontal', size = 'medium', variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color,
        component,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        orientation,
        size,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const context = React.useMemo(()=>({
            className: classes.grouped,
            color,
            disabled,
            disableElevation,
            disableFocusRipple,
            disableRipple,
            fullWidth,
            size,
            variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, _getValidReactChildren.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ButtonGroupContext.default.Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ButtonGroupButtonContext.default.Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var _default = exports.default = ButtonGroup;

},{"55e8eb070e9ec71e":"kZ6eK","c195303bd8aee546":"fiRIh","61538b298be75d3c":"9njXz","230ae7bd72526253":"bnNSm","6ce917092516614c":"d2NWs","9c53080b52eb7cfa":"59Equ","66997dadbad9055a":"hTYBL","5154d45b5e61d70f":"jAow1","4424087bb086764b":"eOYSA","f263d019b3d54a1e":"hZXDo","406d6bc92272fe4b":"cJNjb","8b0b14a0b1da5f24":"2r5WG","4a14d102ab8ae3a4":"9bD8g","3e3d890e62b2168":"iknnG","d513580fb21e1cd1":"fyAGU","7452dc2eaba483b0":"a118j","fdd0e8a26f3bf833":"1dlk8"}],"iknnG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d5ae14c3227e4ce0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getButtonGroupUtilityClass = getButtonGroupUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("4df9e1d9ba086e23"));
var _generateUtilityClass = _interopRequireDefault(require("a3dbb23ee74f5b0b"));
function getButtonGroupUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiButtonGroup', slot);
}
const buttonGroupClasses = (0, _generateUtilityClasses.default)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var _default = exports.default = buttonGroupClasses;

},{"d5ae14c3227e4ce0":"kZ6eK","4df9e1d9ba086e23":"7pSUk","a3dbb23ee74f5b0b":"jBs9M"}],"57AQK":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("8de3173bc0cc25d4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b78cdc4ff0a09607"));
var _jsxRuntime = require("39241ee6fc345ab3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M21 5c0-1.1-.9-2-2-2H5.83L21 18.17zM2.81 2.81 1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.41zM6 17l3-4 2.25 3 .82-1.1 2.1 2.1z"
}), 'HideImage');

},{"8de3173bc0cc25d4":"kZ6eK","b78cdc4ff0a09607":"2vOnF","39241ee6fc345ab3":"1dlk8"}],"1zQo3":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("9bf9a2dd7f3506ec").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("f53a2430f2ed2cb6"));
var _jsxRuntime = require("3e0497455bd3d5c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z"
}), 'Image');

},{"9bf9a2dd7f3506ec":"kZ6eK","f53a2430f2ed2cb6":"2vOnF","3e0497455bd3d5c":"1dlk8"}],"anjhb":[function(require,module,exports,__globalThis) {
/**
 * vis-timeline and vis-graph2d
 * https://visjs.github.io/vis-timeline/
 *
 * Create a fully customizable, interactive timeline with items and ranges.
 *
 * @version 7.7.3
 * @date    2023-10-27T17:57:57.604Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */ var global = arguments[3];
!function(t, e) {
    e(exports, require("d5849437dec34ce2"), require("b3e91b269c1eeaa"));
}(this, function(t, e, n) {
    var o = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
    function r(t) {
        return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    }
    var s = function(t) {
        return t && t.Math === Math && t;
    }, a = s("object" == typeof globalThis && globalThis) || s("object" == typeof window && window) || s("object" == typeof self && self) || s("object" == typeof o && o) || function() {
        return this;
    }() || o || Function("return this")(), l = function(t) {
        try {
            return !!t();
        } catch (t) {
            return !0;
        }
    }, h = !l(function() {
        var t = (function() {}).bind();
        return "function" != typeof t || t.hasOwnProperty("prototype");
    }), u = h, c = Function.prototype, d = c.apply, p = c.call, m = "object" == typeof Reflect && Reflect.apply || (u ? p.bind(d) : function() {
        return p.apply(d, arguments);
    }), f = h, v = Function.prototype, g = v.call, y = f && v.bind.bind(g, g), b = f ? y : function(t) {
        return function() {
            return g.apply(t, arguments);
        };
    }, w = b, k = w({}.toString), _ = w("".slice), x = function(t) {
        return _(k(t), 8, -1);
    }, C = x, S = b, D = function(t) {
        if ("Function" === C(t)) return S(t);
    }, T = "object" == typeof document && document.all, E = {
        all: T,
        IS_HTMLDDA: void 0 === T && void 0 !== T
    }, O = E.all, A = E.IS_HTMLDDA ? function(t) {
        return "function" == typeof t || t === O;
    } : function(t) {
        return "function" == typeof t;
    }, I = {}, P = !l(function() {
        return 7 !== Object.defineProperty({}, 1, {
            get: function() {
                return 7;
            }
        })[1];
    }), M = h, N = Function.prototype.call, F = M ? N.bind(N) : function() {
        return N.apply(N, arguments);
    }, R = {}, L = {}.propertyIsEnumerable, j = Object.getOwnPropertyDescriptor, B = j && !L.call({
        1: 2
    }, 1);
    R.f = B ? function(t) {
        var e = j(this, t);
        return !!e && e.enumerable;
    } : L;
    var z, H, G = function(t, e) {
        return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: e
        };
    }, W = l, Y = x, V = Object, U = b("".split), X = W(function() {
        return !V("z").propertyIsEnumerable(0);
    }) ? function(t) {
        return "String" === Y(t) ? U(t, "") : V(t);
    } : V, q = function(t) {
        return null == t;
    }, K = q, $ = TypeError, Z = function(t) {
        if (K(t)) throw new $("Can't call method on " + t);
        return t;
    }, Q = X, J = Z, tt = function(t) {
        return Q(J(t));
    }, et = A, it = E.all, nt = E.IS_HTMLDDA ? function(t) {
        return "object" == typeof t ? null !== t : et(t) || t === it;
    } : function(t) {
        return "object" == typeof t ? null !== t : et(t);
    }, ot = {}, rt = ot, st = a, at = A, lt = function(t) {
        return at(t) ? t : void 0;
    }, ht = function(t, e) {
        return arguments.length < 2 ? lt(rt[t]) || lt(st[t]) : rt[t] && rt[t][e] || st[t] && st[t][e];
    }, ut = b({}.isPrototypeOf), ct = "undefined" != typeof navigator && String(navigator.userAgent) || "", dt = a, pt = ct, mt = dt.process, ft = dt.Deno, vt = mt && mt.versions || ft && ft.version, gt = vt && vt.v8;
    gt && (H = (z = gt.split("."))[0] > 0 && z[0] < 4 ? 1 : +(z[0] + z[1])), !H && pt && (!(z = pt.match(/Edge\/(\d+)/)) || z[1] >= 74) && (z = pt.match(/Chrome\/(\d+)/)) && (H = +z[1]);
    var yt = H, bt = yt, wt = l, kt = a.String, _t = !!Object.getOwnPropertySymbols && !wt(function() {
        var t = Symbol("symbol detection");
        return !kt(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && bt && bt < 41;
    }), xt = _t && !Symbol.sham && "symbol" == typeof Symbol.iterator, Ct = ht, St = A, Dt = ut, Tt = Object, Et = xt ? function(t) {
        return "symbol" == typeof t;
    } : function(t) {
        var e = Ct("Symbol");
        return St(e) && Dt(e.prototype, Tt(t));
    }, Ot = String, At = function(t) {
        try {
            return Ot(t);
        } catch (t) {
            return "Object";
        }
    }, It = A, Pt = At, Mt = TypeError, Nt = function(t) {
        if (It(t)) return t;
        throw new Mt(Pt(t) + " is not a function");
    }, Ft = Nt, Rt = q, Lt = function(t, e) {
        var i1 = t[e];
        return Rt(i1) ? void 0 : Ft(i1);
    }, jt = F, Bt = A, zt = nt, Ht = TypeError, Gt = {
        exports: {}
    }, Wt = a, Yt = Object.defineProperty, Vt = function(t, e) {
        try {
            Yt(Wt, t, {
                value: e,
                configurable: !0,
                writable: !0
            });
        } catch (i1) {
            Wt[t] = e;
        }
        return e;
    }, Ut = "__core-js_shared__", Xt = a[Ut] || Vt(Ut, {}), qt = Xt;
    (Gt.exports = function(t, e) {
        return qt[t] || (qt[t] = void 0 !== e ? e : {});
    })("versions", []).push({
        version: "3.33.0",
        mode: "pure",
        copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
        license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
        source: "https://github.com/zloirock/core-js"
    });
    var Kt = Gt.exports, $t = Z, Zt = Object, Qt = function(t) {
        return Zt($t(t));
    }, Jt = Qt, te = b({}.hasOwnProperty), ee = Object.hasOwn || function(t, e) {
        return te(Jt(t), e);
    }, ie = b, ne = 0, oe = Math.random(), re = ie(1..toString), se = function(t) {
        return "Symbol(" + (void 0 === t ? "" : t) + ")_" + re(++ne + oe, 36);
    }, ae = Kt, le = ee, he = se, ue = _t, ce = xt, de = a.Symbol, pe = ae("wks"), me = ce ? de.for || de : de && de.withoutSetter || he, fe = function(t) {
        return le(pe, t) || (pe[t] = ue && le(de, t) ? de[t] : me("Symbol." + t)), pe[t];
    }, ve = F, ge = nt, ye = Et, be = Lt, we = function(t, e) {
        var i1, n;
        if ("string" === e && Bt(i1 = t.toString) && !zt(n = jt(i1, t))) return n;
        if (Bt(i1 = t.valueOf) && !zt(n = jt(i1, t))) return n;
        if ("string" !== e && Bt(i1 = t.toString) && !zt(n = jt(i1, t))) return n;
        throw new Ht("Can't convert object to primitive value");
    }, ke = TypeError, _e = fe("toPrimitive"), xe = function(t, e) {
        if (!ge(t) || ye(t)) return t;
        var i1, n = be(t, _e);
        if (n) {
            if (void 0 === e && (e = "default"), i1 = ve(n, t, e), !ge(i1) || ye(i1)) return i1;
            throw new ke("Can't convert object to primitive value");
        }
        return void 0 === e && (e = "number"), we(t, e);
    }, Ce = Et, Se = function(t) {
        var e = xe(t, "string");
        return Ce(e) ? e : e + "";
    }, De = nt, Te = a.document, Ee = De(Te) && De(Te.createElement), Oe = function(t) {
        return Ee ? Te.createElement(t) : {};
    }, Ae = Oe, Ie = !P && !l(function() {
        return 7 !== Object.defineProperty(Ae("div"), "a", {
            get: function() {
                return 7;
            }
        }).a;
    }), Pe = P, Me = F, Ne = R, Fe = G, Re = tt, Le = Se, je = ee, Be = Ie, ze = Object.getOwnPropertyDescriptor;
    I.f = Pe ? ze : function(t, e) {
        if (t = Re(t), e = Le(e), Be) try {
            return ze(t, e);
        } catch (t) {}
        if (je(t, e)) return Fe(!Me(Ne.f, t, e), t[e]);
    };
    var He = l, Ge = A, We = /#|\.prototype\./, Ye = function(t, e) {
        var i1 = Ue[Ve(t)];
        return i1 === qe || i1 !== Xe && (Ge(e) ? He(e) : !!e);
    }, Ve = Ye.normalize = function(t) {
        return String(t).replace(We, ".").toLowerCase();
    }, Ue = Ye.data = {}, Xe = Ye.NATIVE = "N", qe = Ye.POLYFILL = "P", Ke = Ye, $e = Nt, Ze = h, Qe = D(D.bind), Je = function(t, e) {
        return $e(t), void 0 === e ? t : Ze ? Qe(t, e) : function() {
            return t.apply(e, arguments);
        };
    }, ti = {}, ei = P && l(function() {
        return 42 !== Object.defineProperty(function() {}, "prototype", {
            value: 42,
            writable: !1
        }).prototype;
    }), ii = nt, ni = String, oi = TypeError, ri = function(t) {
        if (ii(t)) return t;
        throw new oi(ni(t) + " is not an object");
    }, si = P, ai = Ie, li = ei, hi = ri, ui = Se, ci = TypeError, di = Object.defineProperty, pi = Object.getOwnPropertyDescriptor, mi = "enumerable", fi = "configurable", vi = "writable";
    ti.f = si ? li ? function(t, e, i1) {
        if (hi(t), e = ui(e), hi(i1), "function" == typeof t && "prototype" === e && "value" in i1 && vi in i1 && !i1[vi]) {
            var n = pi(t, e);
            n && n[vi] && (t[e] = i1.value, i1 = {
                configurable: fi in i1 ? i1[fi] : n[fi],
                enumerable: mi in i1 ? i1[mi] : n[mi],
                writable: !1
            });
        }
        return di(t, e, i1);
    } : di : function(t, e, i1) {
        if (hi(t), e = ui(e), hi(i1), ai) try {
            return di(t, e, i1);
        } catch (t) {}
        if ("get" in i1 || "set" in i1) throw new ci("Accessors not supported");
        return "value" in i1 && (t[e] = i1.value), t;
    };
    var gi = ti, yi = G, bi = P ? function(t, e, i1) {
        return gi.f(t, e, yi(1, i1));
    } : function(t, e, i1) {
        return t[e] = i1, t;
    }, wi = a, ki = m, _i = D, xi = A, Ci = I.f, Si = Ke, Di = ot, Ti = Je, Ei = bi, Oi = ee, Ai = function(t) {
        var e = function(i1, n, o) {
            if (this instanceof e) {
                switch(arguments.length){
                    case 0:
                        return new t;
                    case 1:
                        return new t(i1);
                    case 2:
                        return new t(i1, n);
                }
                return new t(i1, n, o);
            }
            return ki(t, this, arguments);
        };
        return e.prototype = t.prototype, e;
    }, Ii = function(t, e) {
        var i1, n, o, r, s, a, l, h, u, c = t.target, d = t.global, p = t.stat, m = t.proto, f = d ? wi : p ? wi[c] : (wi[c] || {}).prototype, v = d ? Di : Di[c] || Ei(Di, c, {})[c], g = v.prototype;
        for(r in e)n = !(i1 = Si(d ? r : c + (p ? "." : "#") + r, t.forced)) && f && Oi(f, r), a = v[r], n && (l = t.dontCallGetSet ? (u = Ci(f, r)) && u.value : f[r]), s = n && l ? l : e[r], n && typeof a == typeof s || (h = t.bind && n ? Ti(s, wi) : t.wrap && n ? Ai(s) : m && xi(s) ? _i(s) : s, (t.sham || s && s.sham || a && a.sham) && Ei(h, "sham", !0), Ei(v, r, h), m && (Oi(Di, o = c + "Prototype") || Ei(Di, o, {}), Ei(Di[o], r, s), t.real && g && (i1 || !g[r]) && Ei(g, r, s)));
    }, Pi = b([].slice), Mi = b, Ni = Nt, Fi = nt, Ri = ee, Li = Pi, ji = h, Bi = Function, zi = Mi([].concat), Hi = Mi([].join), Gi = {}, Wi = ji ? Bi.bind : function(t) {
        var e = Ni(this), i1 = e.prototype, n = Li(arguments, 1), o = function() {
            var i1 = zi(n, Li(arguments));
            return this instanceof o ? function(t, e, i1) {
                if (!Ri(Gi, e)) {
                    for(var n = [], o = 0; o < e; o++)n[o] = "a[" + o + "]";
                    Gi[e] = Bi("C,a", "return new C(" + Hi(n, ",") + ")");
                }
                return Gi[e](t, i1);
            }(e, i1.length, i1) : e.apply(t, i1);
        };
        return Fi(i1) && (o.prototype = i1), o;
    }, Yi = {};
    Yi[fe("toStringTag")] = "z";
    var Vi = "[object z]" === String(Yi), Ui = Vi, Xi = A, qi = x, Ki = fe("toStringTag"), $i = Object, Zi = "Arguments" === qi(function() {
        return arguments;
    }()), Qi = Ui ? qi : function(t) {
        var e, i1, n;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (i1 = function(t, e) {
            try {
                return t[e];
            } catch (t) {}
        }(e = $i(t), Ki)) ? i1 : Zi ? qi(e) : "Object" === (n = qi(e)) && Xi(e.callee) ? "Arguments" : n;
    }, Ji = A, tn = Xt, en = b(Function.toString);
    Ji(tn.inspectSource) || (tn.inspectSource = function(t) {
        return en(t);
    });
    var nn = tn.inspectSource, on = b, rn = l, sn = A, an = Qi, ln = nn, hn = function() {}, un = [], cn = ht("Reflect", "construct"), dn = /^\s*(?:class|function)\b/, pn = on(dn.exec), mn = !dn.test(hn), fn = function(t) {
        if (!sn(t)) return !1;
        try {
            return cn(hn, un, t), !0;
        } catch (t) {
            return !1;
        }
    }, vn = function(t) {
        if (!sn(t)) return !1;
        switch(an(t)){
            case "AsyncFunction":
            case "GeneratorFunction":
            case "AsyncGeneratorFunction":
                return !1;
        }
        try {
            return mn || !!pn(dn, ln(t));
        } catch (t) {
            return !0;
        }
    };
    vn.sham = !0;
    var gn = !cn || rn(function() {
        var t;
        return fn(fn.call) || !fn(Object) || !fn(function() {
            t = !0;
        }) || t;
    }) ? vn : fn, yn = gn, bn = At, wn = TypeError, kn = {}, _n = Math.ceil, xn = Math.floor, Cn = Math.trunc || function(t) {
        var e = +t;
        return (e > 0 ? xn : _n)(e);
    }, Sn = function(t) {
        var e = +t;
        return e != e || 0 === e ? 0 : Cn(e);
    }, Dn = Sn, Tn = Math.max, En = Math.min, On = function(t, e) {
        var i1 = Dn(t);
        return i1 < 0 ? Tn(i1 + e, 0) : En(i1, e);
    }, An = Sn, In = Math.min, Pn = function(t) {
        return t > 0 ? In(An(t), 9007199254740991) : 0;
    }, Mn = function(t) {
        return Pn(t.length);
    }, Nn = tt, Fn = On, Rn = Mn, Ln = function(t) {
        return function(e, i1, n) {
            var o, r = Nn(e), s = Rn(r), a = Fn(n, s);
            if (t && i1 != i1) {
                for(; s > a;)if ((o = r[a++]) != o) return !0;
            } else for(; s > a; a++)if ((t || a in r) && r[a] === i1) return t || a || 0;
            return !t && -1;
        };
    }, jn = {
        includes: Ln(!0),
        indexOf: Ln(!1)
    }, Bn = {}, zn = ee, Hn = tt, Gn = jn.indexOf, Wn = Bn, Yn = b([].push), Vn = function(t, e) {
        var i1, n = Hn(t), o = 0, r = [];
        for(i1 in n)!zn(Wn, i1) && zn(n, i1) && Yn(r, i1);
        for(; e.length > o;)zn(n, i1 = e[o++]) && (~Gn(r, i1) || Yn(r, i1));
        return r;
    }, Un = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf"
    ], Xn = Vn, qn = Un, Kn = Object.keys || function(t) {
        return Xn(t, qn);
    }, $n = P, Zn = ei, Qn = ti, Jn = ri, to = tt, eo = Kn;
    kn.f = $n && !Zn ? Object.defineProperties : function(t, e) {
        Jn(t);
        for(var i1, n = to(e), o = eo(e), r = o.length, s = 0; r > s;)Qn.f(t, i1 = o[s++], n[i1]);
        return t;
    };
    var io, no = ht("document", "documentElement"), oo = se, ro = Kt("keys"), so = function(t) {
        return ro[t] || (ro[t] = oo(t));
    }, ao = ri, lo = kn, ho = Un, uo = Bn, co = no, po = Oe, mo = "prototype", fo = "script", vo = so("IE_PROTO"), go = function() {}, yo = function(t) {
        return "<" + fo + ">" + t + "</" + fo + ">";
    }, bo = function(t) {
        t.write(yo("")), t.close();
        var e = t.parentWindow.Object;
        return t = null, e;
    }, wo = function() {
        try {
            io = new ActiveXObject("htmlfile");
        } catch (t) {}
        var t, e, i1;
        wo = "undefined" != typeof document ? document.domain && io ? bo(io) : (e = po("iframe"), i1 = "java" + fo + ":", e.style.display = "none", co.appendChild(e), e.src = String(i1), (t = e.contentWindow.document).open(), t.write(yo("document.F=Object")), t.close(), t.F) : bo(io);
        for(var n = ho.length; n--;)delete wo[mo][ho[n]];
        return wo();
    };
    uo[vo] = !0;
    var ko = Object.create || function(t, e) {
        var i1;
        return null !== t ? (go[mo] = ao(t), i1 = new go, go[mo] = null, i1[vo] = t) : i1 = wo(), void 0 === e ? i1 : lo.f(i1, e);
    }, _o = Ii, xo = m, Co = Wi, So = function(t) {
        if (yn(t)) return t;
        throw new wn(bn(t) + " is not a constructor");
    }, Do = ri, To = nt, Eo = ko, Oo = l, Ao = ht("Reflect", "construct"), Io = Object.prototype, Po = [].push, Mo = Oo(function() {
        function t() {}
        return !(Ao(function() {}, [], t) instanceof t);
    }), No = !Oo(function() {
        Ao(function() {});
    }), Fo = Mo || No;
    _o({
        target: "Reflect",
        stat: !0,
        forced: Fo,
        sham: Fo
    }, {
        construct: function(t, e) {
            So(t), Do(e);
            var i1 = arguments.length < 3 ? t : So(arguments[2]);
            if (No && !Mo) return Ao(t, e, i1);
            if (t === i1) {
                switch(e.length){
                    case 0:
                        return new t;
                    case 1:
                        return new t(e[0]);
                    case 2:
                        return new t(e[0], e[1]);
                    case 3:
                        return new t(e[0], e[1], e[2]);
                    case 4:
                        return new t(e[0], e[1], e[2], e[3]);
                }
                var n = [
                    null
                ];
                return xo(Po, n, e), new (xo(Co, t, n));
            }
            var o = i1.prototype, r = Eo(To(o) ? o : Io), s = xo(t, r, e);
            return To(s) ? s : r;
        }
    });
    var Ro = r(ot.Reflect.construct);
    function Lo(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    var jo = {
        exports: {}
    }, Bo = Ii, zo = P, Ho = ti.f;
    Bo({
        target: "Object",
        stat: !0,
        forced: Object.defineProperty !== Ho,
        sham: !zo
    }, {
        defineProperty: Ho
    });
    var Go = ot.Object, Wo = jo.exports = function(t, e, i1) {
        return Go.defineProperty(t, e, i1);
    };
    Go.defineProperty.sham && (Wo.sham = !0);
    var Yo = jo.exports, Vo = r(Yo), Uo = x, Xo = Array.isArray || function(t) {
        return "Array" === Uo(t);
    }, qo = TypeError, Ko = function(t) {
        if (t > 9007199254740991) throw qo("Maximum allowed index exceeded");
        return t;
    }, $o = Se, Zo = ti, Qo = G, Jo = function(t, e, i1) {
        var n = $o(e);
        n in t ? Zo.f(t, n, Qo(0, i1)) : t[n] = i1;
    }, tr = Xo, er = gn, ir = nt, nr = fe("species"), or = Array, rr = function(t) {
        var e;
        return tr(t) && (e = t.constructor, (er(e) && (e === or || tr(e.prototype)) || ir(e) && null === (e = e[nr])) && (e = void 0)), void 0 === e ? or : e;
    }, sr = function(t, e) {
        return new (rr(t))(0 === e ? 0 : e);
    }, ar = l, lr = yt, hr = fe("species"), ur = function(t) {
        return lr >= 51 || !ar(function() {
            var e = [];
            return (e.constructor = {})[hr] = function() {
                return {
                    foo: 1
                };
            }, 1 !== e[t](Boolean).foo;
        });
    }, cr = Ii, dr = l, pr = Xo, mr = nt, fr = Qt, vr = Mn, gr = Ko, yr = Jo, br = sr, wr = ur, kr = yt, _r = fe("isConcatSpreadable"), xr = kr >= 51 || !dr(function() {
        var t = [];
        return t[_r] = !1, t.concat()[0] !== t;
    }), Cr = function(t) {
        if (!mr(t)) return !1;
        var e = t[_r];
        return void 0 !== e ? !!e : pr(t);
    };
    cr({
        target: "Array",
        proto: !0,
        arity: 1,
        forced: !xr || !wr("concat")
    }, {
        concat: function(t) {
            var e, i1, n, o, r, s = fr(this), a = br(s, 0), l = 0;
            for(e = -1, n = arguments.length; e < n; e++)if (Cr(r = -1 === e ? s : arguments[e])) for(o = vr(r), gr(l + o), i1 = 0; i1 < o; i1++, l++)i1 in r && yr(a, l, r[i1]);
            else gr(l + 1), yr(a, l++, r);
            return a.length = l, a;
        }
    });
    var Sr = Qi, Dr = String, Tr = function(t) {
        if ("Symbol" === Sr(t)) throw new TypeError("Cannot convert a Symbol value to a string");
        return Dr(t);
    }, Er = {}, Or = Vn, Ar = Un.concat("length", "prototype");
    Er.f = Object.getOwnPropertyNames || function(t) {
        return Or(t, Ar);
    };
    var Ir = {}, Pr = On, Mr = Mn, Nr = Jo, Fr = Array, Rr = Math.max, Lr = function(t, e, i1) {
        for(var n = Mr(t), o = Pr(e, n), r = Pr(void 0 === i1 ? n : i1, n), s = Fr(Rr(r - o, 0)), a = 0; o < r; o++, a++)Nr(s, a, t[o]);
        return s.length = a, s;
    }, jr = x, Br = tt, zr = Er.f, Hr = Lr, Gr = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    Ir.f = function(t) {
        return Gr && "Window" === jr(t) ? function(t) {
            try {
                return zr(t);
            } catch (t) {
                return Hr(Gr);
            }
        }(t) : zr(Br(t));
    };
    var Wr = {};
    Wr.f = Object.getOwnPropertySymbols;
    var Yr = bi, Vr = function(t, e, i1, n) {
        return n && n.enumerable ? t[e] = i1 : Yr(t, e, i1), t;
    }, Ur = ti, Xr = function(t, e, i1) {
        return Ur.f(t, e, i1);
    }, qr = {}, Kr = fe;
    qr.f = Kr;
    var $r, Zr, Qr, Jr = ot, ts = ee, es = qr, is = ti.f, ns = function(t) {
        var e = Jr.Symbol || (Jr.Symbol = {});
        ts(e, t) || is(e, t, {
            value: es.f(t)
        });
    }, os = F, rs = ht, ss = fe, as = Vr, ls = function() {
        var t = rs("Symbol"), e = t && t.prototype, i1 = e && e.valueOf, n = ss("toPrimitive");
        e && !e[n] && as(e, n, function(t) {
            return os(i1, this);
        }, {
            arity: 1
        });
    }, hs = Qi, us = Vi ? ({}).toString : function() {
        return "[object " + hs(this) + "]";
    }, cs = Vi, ds = ti.f, ps = bi, ms = ee, fs = us, vs = fe("toStringTag"), gs = function(t, e, i1, n) {
        if (t) {
            var o = i1 ? t : t.prototype;
            ms(o, vs) || ds(o, vs, {
                configurable: !0,
                value: e
            }), n && !cs && ps(o, "toString", fs);
        }
    }, ys = A, bs = a.WeakMap, ws = ys(bs) && /native code/.test(String(bs)), ks = a, _s = nt, xs = bi, Cs = ee, Ss = Xt, Ds = so, Ts = Bn, Es = "Object already initialized", Os = ks.TypeError, As = ks.WeakMap;
    if (ws || Ss.state) {
        var Is = Ss.state || (Ss.state = new As);
        Is.get = Is.get, Is.has = Is.has, Is.set = Is.set, $r = function(t, e) {
            if (Is.has(t)) throw new Os(Es);
            return e.facade = t, Is.set(t, e), e;
        }, Zr = function(t) {
            return Is.get(t) || {};
        }, Qr = function(t) {
            return Is.has(t);
        };
    } else {
        var Ps = Ds("state");
        Ts[Ps] = !0, $r = function(t, e) {
            if (Cs(t, Ps)) throw new Os(Es);
            return e.facade = t, xs(t, Ps, e), e;
        }, Zr = function(t) {
            return Cs(t, Ps) ? t[Ps] : {};
        }, Qr = function(t) {
            return Cs(t, Ps);
        };
    }
    var Ms = {
        set: $r,
        get: Zr,
        has: Qr,
        enforce: function(t) {
            return Qr(t) ? Zr(t) : $r(t, {});
        },
        getterFor: function(t) {
            return function(e) {
                var i1;
                if (!_s(e) || (i1 = Zr(e)).type !== t) throw new Os("Incompatible receiver, " + t + " required");
                return i1;
            };
        }
    }, Ns = Je, Fs = X, Rs = Qt, Ls = Mn, js = sr, Bs = b([].push), zs = function(t) {
        var e = 1 === t, i1 = 2 === t, n = 3 === t, o = 4 === t, r = 6 === t, s = 7 === t, a = 5 === t || r;
        return function(l, h, u, c) {
            for(var d, p, m = Rs(l), f = Fs(m), v = Ns(h, u), g = Ls(f), y = 0, b = c || js, w = e ? b(l, g) : i1 || s ? b(l, 0) : void 0; g > y; y++)if ((a || y in f) && (p = v(d = f[y], y, m), t)) {
                if (e) w[y] = p;
                else if (p) switch(t){
                    case 3:
                        return !0;
                    case 5:
                        return d;
                    case 6:
                        return y;
                    case 2:
                        Bs(w, d);
                }
                else switch(t){
                    case 4:
                        return !1;
                    case 7:
                        Bs(w, d);
                }
            }
            return r ? -1 : n || o ? o : w;
        };
    }, Hs = {
        forEach: zs(0),
        map: zs(1),
        filter: zs(2),
        some: zs(3),
        every: zs(4),
        find: zs(5),
        findIndex: zs(6),
        filterReject: zs(7)
    }, Gs = Ii, Ws = a, Ys = F, Vs = b, Us = P, Xs = _t, qs = l, Ks = ee, $s = ut, Zs = ri, Qs = tt, Js = Se, ta = Tr, ea = G, ia = ko, na = Kn, oa = Er, ra = Ir, sa = Wr, aa = I, la = ti, ha = kn, ua = R, ca = Vr, da = Xr, pa = Kt, ma = Bn, fa = se, va = fe, ga = qr, ya = ns, ba = ls, wa = gs, ka = Ms, _a = Hs.forEach, xa = so("hidden"), Ca = "Symbol", Sa = "prototype", Da = ka.set, Ta = ka.getterFor(Ca), Ea = Object[Sa], Oa = Ws.Symbol, Aa = Oa && Oa[Sa], Ia = Ws.RangeError, Pa = Ws.TypeError, Ma = Ws.QObject, Na = aa.f, Fa = la.f, Ra = ra.f, La = ua.f, ja = Vs([].push), Ba = pa("symbols"), za = pa("op-symbols"), Ha = pa("wks"), Ga = !Ma || !Ma[Sa] || !Ma[Sa].findChild, Wa = function(t, e, i1) {
        var n = Na(Ea, e);
        n && delete Ea[e], Fa(t, e, i1), n && t !== Ea && Fa(Ea, e, n);
    }, Ya = Us && qs(function() {
        return 7 !== ia(Fa({}, "a", {
            get: function() {
                return Fa(this, "a", {
                    value: 7
                }).a;
            }
        })).a;
    }) ? Wa : Fa, Va = function(t, e) {
        var i1 = Ba[t] = ia(Aa);
        return Da(i1, {
            type: Ca,
            tag: t,
            description: e
        }), Us || (i1.description = e), i1;
    }, Ua = function(t, e, i1) {
        t === Ea && Ua(za, e, i1), Zs(t);
        var n = Js(e);
        return Zs(i1), Ks(Ba, n) ? (i1.enumerable ? (Ks(t, xa) && t[xa][n] && (t[xa][n] = !1), i1 = ia(i1, {
            enumerable: ea(0, !1)
        })) : (Ks(t, xa) || Fa(t, xa, ea(1, {})), t[xa][n] = !0), Ya(t, n, i1)) : Fa(t, n, i1);
    }, Xa = function(t, e) {
        Zs(t);
        var i1 = Qs(e), n = na(i1).concat(Za(i1));
        return _a(n, function(e) {
            Us && !Ys(qa, i1, e) || Ua(t, e, i1[e]);
        }), t;
    }, qa = function(t) {
        var e = Js(t), i1 = Ys(La, this, e);
        return !(this === Ea && Ks(Ba, e) && !Ks(za, e)) && (!(i1 || !Ks(this, e) || !Ks(Ba, e) || Ks(this, xa) && this[xa][e]) || i1);
    }, Ka = function(t, e) {
        var i1 = Qs(t), n = Js(e);
        if (i1 !== Ea || !Ks(Ba, n) || Ks(za, n)) {
            var o = Na(i1, n);
            return !o || !Ks(Ba, n) || Ks(i1, xa) && i1[xa][n] || (o.enumerable = !0), o;
        }
    }, $a = function(t) {
        var e = Ra(Qs(t)), i1 = [];
        return _a(e, function(t) {
            Ks(Ba, t) || Ks(ma, t) || ja(i1, t);
        }), i1;
    }, Za = function(t) {
        var e = t === Ea, i1 = Ra(e ? za : Qs(t)), n = [];
        return _a(i1, function(t) {
            !Ks(Ba, t) || e && !Ks(Ea, t) || ja(n, Ba[t]);
        }), n;
    };
    Xs || (Oa = function() {
        if ($s(Aa, this)) throw new Pa("Symbol is not a constructor");
        var t = arguments.length && void 0 !== arguments[0] ? ta(arguments[0]) : void 0, e = fa(t), i1 = function(t) {
            this === Ea && Ys(i1, za, t), Ks(this, xa) && Ks(this[xa], e) && (this[xa][e] = !1);
            var n = ea(1, t);
            try {
                Ya(this, e, n);
            } catch (t) {
                if (!(t instanceof Ia)) throw t;
                Wa(this, e, n);
            }
        };
        return Us && Ga && Ya(Ea, e, {
            configurable: !0,
            set: i1
        }), Va(e, t);
    }, ca(Aa = Oa[Sa], "toString", function() {
        return Ta(this).tag;
    }), ca(Oa, "withoutSetter", function(t) {
        return Va(fa(t), t);
    }), ua.f = qa, la.f = Ua, ha.f = Xa, aa.f = Ka, oa.f = ra.f = $a, sa.f = Za, ga.f = function(t) {
        return Va(va(t), t);
    }, Us && da(Aa, "description", {
        configurable: !0,
        get: function() {
            return Ta(this).description;
        }
    })), Gs({
        global: !0,
        constructor: !0,
        wrap: !0,
        forced: !Xs,
        sham: !Xs
    }, {
        Symbol: Oa
    }), _a(na(Ha), function(t) {
        ya(t);
    }), Gs({
        target: Ca,
        stat: !0,
        forced: !Xs
    }, {
        useSetter: function() {
            Ga = !0;
        },
        useSimple: function() {
            Ga = !1;
        }
    }), Gs({
        target: "Object",
        stat: !0,
        forced: !Xs,
        sham: !Us
    }, {
        create: function(t, e) {
            return void 0 === e ? ia(t) : Xa(ia(t), e);
        },
        defineProperty: Ua,
        defineProperties: Xa,
        getOwnPropertyDescriptor: Ka
    }), Gs({
        target: "Object",
        stat: !0,
        forced: !Xs
    }, {
        getOwnPropertyNames: $a
    }), ba(), wa(Oa, Ca), ma[xa] = !0;
    var Qa = _t && !!Symbol.for && !!Symbol.keyFor, Ja = Ii, tl = ht, el = ee, il = Tr, nl = Kt, ol = Qa, rl = nl("string-to-symbol-registry"), sl = nl("symbol-to-string-registry");
    Ja({
        target: "Symbol",
        stat: !0,
        forced: !ol
    }, {
        for: function(t) {
            var e = il(t);
            if (el(rl, e)) return rl[e];
            var i1 = tl("Symbol")(e);
            return rl[e] = i1, sl[i1] = e, i1;
        }
    });
    var al = Ii, ll = ee, hl = Et, ul = At, cl = Qa, dl = Kt("symbol-to-string-registry");
    al({
        target: "Symbol",
        stat: !0,
        forced: !cl
    }, {
        keyFor: function(t) {
            if (!hl(t)) throw new TypeError(ul(t) + " is not a symbol");
            if (ll(dl, t)) return dl[t];
        }
    });
    var pl = Xo, ml = A, fl = x, vl = Tr, gl = b([].push), yl = Ii, bl = ht, wl = m, kl = F, _l = b, xl = l, Cl = A, Sl = Et, Dl = Pi, Tl = function(t) {
        if (ml(t)) return t;
        if (pl(t)) {
            for(var e = t.length, i1 = [], n = 0; n < e; n++){
                var o = t[n];
                "string" == typeof o ? gl(i1, o) : "number" != typeof o && "Number" !== fl(o) && "String" !== fl(o) || gl(i1, vl(o));
            }
            var r = i1.length, s = !0;
            return function(t, e) {
                if (s) return s = !1, e;
                if (pl(this)) return e;
                for(var n = 0; n < r; n++)if (i1[n] === t) return e;
            };
        }
    }, El = _t, Ol = String, Al = bl("JSON", "stringify"), Il = _l(/./.exec), Pl = _l("".charAt), Ml = _l("".charCodeAt), Nl = _l("".replace), Fl = _l(1..toString), Rl = /[\uD800-\uDFFF]/g, Ll = /^[\uD800-\uDBFF]$/, jl = /^[\uDC00-\uDFFF]$/, Bl = !El || xl(function() {
        var t = bl("Symbol")("stringify detection");
        return "[null]" !== Al([
            t
        ]) || "{}" !== Al({
            a: t
        }) || "{}" !== Al(Object(t));
    }), zl = xl(function() {
        return '"\\udf06\\ud834"' !== Al("\udf06\ud834") || '"\\udead"' !== Al("\udead");
    }), Hl = function(t, e) {
        var i1 = Dl(arguments), n = Tl(e);
        if (Cl(n) || void 0 !== t && !Sl(t)) return i1[1] = function(t, e) {
            if (Cl(n) && (e = kl(n, this, Ol(t), e)), !Sl(e)) return e;
        }, wl(Al, null, i1);
    }, Gl = function(t, e, i1) {
        var n = Pl(i1, e - 1), o = Pl(i1, e + 1);
        return Il(Ll, t) && !Il(jl, o) || Il(jl, t) && !Il(Ll, n) ? "\\u" + Fl(Ml(t, 0), 16) : t;
    };
    Al && yl({
        target: "JSON",
        stat: !0,
        arity: 3,
        forced: Bl || zl
    }, {
        stringify: function(t, e, i1) {
            var n = Dl(arguments), o = wl(Bl ? Hl : Al, null, n);
            return zl && "string" == typeof o ? Nl(o, Rl, Gl) : o;
        }
    });
    var Wl = Wr, Yl = Qt;
    Ii({
        target: "Object",
        stat: !0,
        forced: !_t || l(function() {
            Wl.f(1);
        })
    }, {
        getOwnPropertySymbols: function(t) {
            var e = Wl.f;
            return e ? e(Yl(t)) : [];
        }
    }), ns("asyncIterator"), ns("hasInstance"), ns("isConcatSpreadable"), ns("iterator"), ns("match"), ns("matchAll"), ns("replace"), ns("search"), ns("species"), ns("split");
    var Vl = ls;
    ns("toPrimitive"), Vl();
    var Ul = ht, Xl = gs;
    ns("toStringTag"), Xl(Ul("Symbol"), "Symbol"), ns("unscopables"), gs(a.JSON, "JSON", !0);
    var ql, Kl, $l, Zl = ot.Symbol, Ql = {}, Jl = P, th = ee, eh = Function.prototype, ih = Jl && Object.getOwnPropertyDescriptor, nh = th(eh, "name"), oh = {
        EXISTS: nh,
        PROPER: nh && "something" === (function() {}).name,
        CONFIGURABLE: nh && (!Jl || Jl && ih(eh, "name").configurable)
    }, rh = !l(function() {
        function t() {}
        return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype;
    }), sh = ee, ah = A, lh = Qt, hh = rh, uh = so("IE_PROTO"), ch = Object, dh = ch.prototype, ph = hh ? ch.getPrototypeOf : function(t) {
        var e = lh(t);
        if (sh(e, uh)) return e[uh];
        var i1 = e.constructor;
        return ah(i1) && e instanceof i1 ? i1.prototype : e instanceof ch ? dh : null;
    }, mh = l, fh = A, vh = nt, gh = ko, yh = ph, bh = Vr, wh = fe("iterator"), kh = !1;
    [].keys && ("next" in ($l = [].keys()) ? (Kl = yh(yh($l))) !== Object.prototype && (ql = Kl) : kh = !0);
    var _h = !vh(ql) || mh(function() {
        var t = {};
        return ql[wh].call(t) !== t;
    });
    fh((ql = _h ? {} : gh(ql))[wh]) || bh(ql, wh, function() {
        return this;
    });
    var xh = {
        IteratorPrototype: ql,
        BUGGY_SAFARI_ITERATORS: kh
    }, Ch = xh.IteratorPrototype, Sh = ko, Dh = G, Th = gs, Eh = Ql, Oh = function() {
        return this;
    }, Ah = b, Ih = Nt, Ph = A, Mh = String, Nh = TypeError, Fh = function(t, e, i1) {
        try {
            return Ah(Ih(Object.getOwnPropertyDescriptor(t, e)[i1]));
        } catch (t) {}
    }, Rh = ri, Lh = function(t) {
        if ("object" == typeof t || Ph(t)) return t;
        throw new Nh("Can't set " + Mh(t) + " as a prototype");
    }, jh = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var t, e = !1, i1 = {};
        try {
            (t = Fh(Object.prototype, "__proto__", "set"))(i1, []), e = i1 instanceof Array;
        } catch (t) {}
        return function(i1, n) {
            return Rh(i1), Lh(n), e ? t(i1, n) : i1.__proto__ = n, i1;
        };
    }() : void 0), Bh = Ii, zh = F, Hh = oh, Gh = function(t, e, i1, n) {
        var o = e + " Iterator";
        return t.prototype = Sh(Ch, {
            next: Dh(+!n, i1)
        }), Th(t, o, !1, !0), Eh[o] = Oh, t;
    }, Wh = ph, Yh = gs, Vh = Vr, Uh = Ql, Xh = xh, qh = Hh.PROPER, Kh = Xh.BUGGY_SAFARI_ITERATORS, $h = fe("iterator"), Zh = "keys", Qh = "values", Jh = "entries", tu = function() {
        return this;
    }, eu = function(t, e, i1, n, o, r, s) {
        Gh(i1, e, n);
        var a, l, h, u = function(t) {
            if (t === o && f) return f;
            if (!Kh && t && t in p) return p[t];
            switch(t){
                case Zh:
                case Qh:
                case Jh:
                    return function() {
                        return new i1(this, t);
                    };
            }
            return function() {
                return new i1(this);
            };
        }, c = e + " Iterator", d = !1, p = t.prototype, m = p[$h] || p["@@iterator"] || o && p[o], f = !Kh && m || u(o), v = "Array" === e && p.entries || m;
        if (v && (a = Wh(v.call(new t))) !== Object.prototype && a.next && (Yh(a, c, !0, !0), Uh[c] = tu), qh && o === Qh && m && m.name !== Qh && (d = !0, f = function() {
            return zh(m, this);
        }), o) {
            if (l = {
                values: u(Qh),
                keys: r ? f : u(Zh),
                entries: u(Jh)
            }, s) for(h in l)(Kh || d || !(h in p)) && Vh(p, h, l[h]);
            else Bh({
                target: e,
                proto: !0,
                forced: Kh || d
            }, l);
        }
        return s && p[$h] !== f && Vh(p, $h, f, {
            name: o
        }), Uh[e] = f, l;
    }, iu = function(t, e) {
        return {
            value: t,
            done: e
        };
    }, nu = tt, ou = Ql, ru = Ms;
    ti.f;
    var su = eu, au = iu, lu = "Array Iterator", hu = ru.set, uu = ru.getterFor(lu);
    su(Array, "Array", function(t, e) {
        hu(this, {
            type: lu,
            target: nu(t),
            index: 0,
            kind: e
        });
    }, function() {
        var t = uu(this), e = t.target, i1 = t.kind, n = t.index++;
        if (!e || n >= e.length) return t.target = void 0, au(void 0, !0);
        switch(i1){
            case "keys":
                return au(n, !1);
            case "values":
                return au(e[n], !1);
        }
        return au([
            n,
            e[n]
        ], !1);
    }, "values"), ou.Arguments = ou.Array;
    var cu = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    }, du = a, pu = Qi, mu = bi, fu = Ql, vu = fe("toStringTag");
    for(var gu in cu){
        var yu = du[gu], bu = yu && yu.prototype;
        bu && pu(bu) !== vu && mu(bu, vu, gu), fu[gu] = fu.Array;
    }
    var wu = Zl, ku = fe, _u = ti.f, xu = ku("metadata"), Cu = Function.prototype;
    void 0 === Cu[xu] && _u(Cu, xu, {
        value: null
    }), ns("asyncDispose"), ns("dispose"), ns("metadata");
    var Su = wu, Du = b, Tu = ht("Symbol"), Eu = Tu.keyFor, Ou = Du(Tu.prototype.valueOf), Au = Tu.isRegisteredSymbol || function(t) {
        try {
            return void 0 !== Eu(Ou(t));
        } catch (t) {
            return !1;
        }
    };
    Ii({
        target: "Symbol",
        stat: !0
    }, {
        isRegisteredSymbol: Au
    });
    for(var Iu = Kt, Pu = ht, Mu = b, Nu = Et, Fu = fe, Ru = Pu("Symbol"), Lu = Ru.isWellKnownSymbol, ju = Pu("Object", "getOwnPropertyNames"), Bu = Mu(Ru.prototype.valueOf), zu = Iu("wks"), Hu = 0, Gu = ju(Ru), Wu = Gu.length; Hu < Wu; Hu++)try {
        var Yu = Gu[Hu];
        Nu(Ru[Yu]) && Fu(Yu);
    } catch (t) {}
    var Vu = function(t) {
        if (Lu && Lu(t)) return !0;
        try {
            for(var e = Bu(t), i1 = 0, n = ju(zu), o = n.length; i1 < o; i1++)if (zu[n[i1]] == e) return !0;
        } catch (t) {}
        return !1;
    };
    Ii({
        target: "Symbol",
        stat: !0,
        forced: !0
    }, {
        isWellKnownSymbol: Vu
    }), ns("matcher"), ns("observable"), Ii({
        target: "Symbol",
        stat: !0,
        name: "isRegisteredSymbol"
    }, {
        isRegistered: Au
    }), Ii({
        target: "Symbol",
        stat: !0,
        name: "isWellKnownSymbol",
        forced: !0
    }, {
        isWellKnown: Vu
    }), ns("metadataKey"), ns("patternMatch"), ns("replaceAll");
    var Uu = r(Su), Xu = b, qu = Sn, Ku = Tr, $u = Z, Zu = Xu("".charAt), Qu = Xu("".charCodeAt), Ju = Xu("".slice), tc = function(t) {
        return function(e, i1) {
            var n, o, r = Ku($u(e)), s = qu(i1), a = r.length;
            return s < 0 || s >= a ? t ? "" : void 0 : (n = Qu(r, s)) < 55296 || n > 56319 || s + 1 === a || (o = Qu(r, s + 1)) < 56320 || o > 57343 ? t ? Zu(r, s) : n : t ? Ju(r, s, s + 2) : o - 56320 + (n - 55296 << 10) + 65536;
        };
    }, ec = {
        codeAt: tc(!1),
        charAt: tc(!0)
    }.charAt, ic = Tr, nc = Ms, oc = eu, rc = iu, sc = "String Iterator", ac = nc.set, lc = nc.getterFor(sc);
    oc(String, "String", function(t) {
        ac(this, {
            type: sc,
            string: ic(t),
            index: 0
        });
    }, function() {
        var t, e = lc(this), i1 = e.string, n = e.index;
        return n >= i1.length ? rc(void 0, !0) : (t = ec(i1, n), e.index += t.length, rc(t, !1));
    });
    var hc = r(qr.f("iterator"));
    function uc(t) {
        return uc = "function" == typeof Uu && "symbol" == typeof hc ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Uu && t.constructor === Uu && t !== Uu.prototype ? "symbol" : typeof t;
        }, uc(t);
    }
    var cc = r(qr.f("toPrimitive"));
    function dc(t) {
        var e = function(t, e) {
            if ("object" !== uc(t) || null === t) return t;
            var i1 = t[cc];
            if (void 0 !== i1) {
                var n = i1.call(t, e || "default");
                if ("object" !== uc(n)) return n;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === e ? String : Number)(t);
        }(t, "string");
        return "symbol" === uc(e) ? e : String(e);
    }
    function pc(t, e) {
        for(var i1 = 0; i1 < e.length; i1++){
            var n = e[i1];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Vo(t, dc(n.key), n);
        }
    }
    function mc(t, e, i1) {
        return e && pc(t.prototype, e), i1 && pc(t, i1), Vo(t, "prototype", {
            writable: !1
        }), t;
    }
    function fc(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    Ii({
        target: "Object",
        stat: !0,
        sham: !P
    }, {
        create: ko
    });
    var vc = ot.Object, gc = function(t, e) {
        return vc.create(t, e);
    }, yc = r(gc);
    Ii({
        target: "Object",
        stat: !0
    }, {
        setPrototypeOf: jh
    });
    var bc = r(ot.Object.setPrototypeOf), wc = Wi;
    Ii({
        target: "Function",
        proto: !0,
        forced: Function.bind !== wc
    }, {
        bind: wc
    });
    var kc = ot, _c = function(t) {
        return kc[t + "Prototype"];
    }, xc = _c("Function").bind, Cc = ut, Sc = xc, Dc = Function.prototype, Tc = function(t) {
        var e = t.bind;
        return t === Dc || Cc(Dc, t) && e === Dc.bind ? Sc : e;
    }, Ec = Tc, Oc = r(Ec);
    function Ac(t, e) {
        var i1;
        return Ac = bc ? Oc(i1 = bc).call(i1) : function(t, e) {
            return t.__proto__ = e, t;
        }, Ac(t, e);
    }
    function Ic(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = yc(e && e.prototype, {
            constructor: {
                value: t,
                writable: !0,
                configurable: !0
            }
        }), Vo(t, "prototype", {
            writable: !1
        }), e && Ac(t, e);
    }
    function Pc(t, e) {
        if (e && ("object" === uc(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return fc(t);
    }
    var Mc = Qt, Nc = ph, Fc = rh;
    Ii({
        target: "Object",
        stat: !0,
        forced: l(function() {
            Nc(1);
        }),
        sham: !Fc
    }, {
        getPrototypeOf: function(t) {
            return Nc(Mc(t));
        }
    });
    var Rc = ot.Object.getPrototypeOf, Lc = r(Rc);
    function jc(t) {
        var e;
        return jc = bc ? Oc(e = Lc).call(e) : function(t) {
            return t.__proto__ || Lc(t);
        }, jc(t);
    }
    Ii({
        target: "Array",
        stat: !0
    }, {
        isArray: Xo
    });
    var Bc = ot.Array.isArray, zc = r(Bc), Hc = r(Ec), Gc = "function" == typeof Bun && Bun && "string" == typeof Bun.version, Wc = TypeError, Yc = a, Vc = m, Uc = A, Xc = Gc, qc = ct, Kc = Pi, $c = function(t, e) {
        if (t < e) throw new Wc("Not enough arguments");
        return t;
    }, Zc = Yc.Function, Qc = /MSIE .\./.test(qc) || Xc && function() {
        var t = Yc.Bun.version.split(".");
        return t.length < 3 || "0" === t[0] && (t[1] < 3 || "3" === t[1] && "0" === t[2]);
    }(), Jc = function(t, e) {
        var i1 = e ? 2 : 1;
        return Qc ? function(n, o) {
            var r = $c(arguments.length, 1) > i1, s = Uc(n) ? n : Zc(n), a = r ? Kc(arguments, i1) : [], l = r ? function() {
                Vc(s, this, a);
            } : s;
            return e ? t(l, o) : t(l);
        } : t;
    }, td = Ii, ed = a, id = Jc(ed.setInterval, !0);
    td({
        global: !0,
        bind: !0,
        forced: ed.setInterval !== id
    }, {
        setInterval: id
    });
    var nd = Ii, od = a, rd = Jc(od.setTimeout, !0);
    nd({
        global: !0,
        bind: !0,
        forced: od.setTimeout !== rd
    }, {
        setTimeout: rd
    });
    var sd = r(ot.setTimeout), ad = l, ld = function(t, e) {
        var i1 = [][t];
        return !!i1 && ad(function() {
            i1.call(null, e || function() {
                return 1;
            }, 1);
        });
    }, hd = Hs.forEach, ud = ld("forEach") ? [].forEach : function(t) {
        return hd(this, t, arguments.length > 1 ? arguments[1] : void 0);
    };
    Ii({
        target: "Array",
        proto: !0,
        forced: [].forEach !== ud
    }, {
        forEach: ud
    });
    var cd = _c("Array").forEach, dd = Qi, pd = ee, md = ut, fd = cd, vd = Array.prototype, gd = {
        DOMTokenList: !0,
        NodeList: !0
    }, yd = function(t) {
        var e = t.forEach;
        return t === vd || md(vd, t) && e === vd.forEach || pd(gd, dd(t)) ? fd : e;
    }, bd = r(yd), wd = r("undefined" != typeof window && window.moment || e), kd = r(ot.Object.getOwnPropertySymbols), _d = Hs.filter;
    Ii({
        target: "Array",
        proto: !0,
        forced: !ur("filter")
    }, {
        filter: function(t) {
            return _d(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var xd = _c("Array").filter, Cd = ut, Sd = xd, Dd = Array.prototype, Td = function(t) {
        var e = t.filter;
        return t === Dd || Cd(Dd, t) && e === Dd.filter ? Sd : e;
    }, Ed = r(Td), Od = {
        exports: {}
    }, Ad = Ii, Id = l, Pd = tt, Md = I.f, Nd = P;
    Ad({
        target: "Object",
        stat: !0,
        forced: !Nd || Id(function() {
            Md(1);
        }),
        sham: !Nd
    }, {
        getOwnPropertyDescriptor: function(t, e) {
            return Md(Pd(t), e);
        }
    });
    var Fd = ot.Object, Rd = Od.exports = function(t, e) {
        return Fd.getOwnPropertyDescriptor(t, e);
    };
    Fd.getOwnPropertyDescriptor.sham && (Rd.sham = !0);
    var Ld = r(Od.exports), jd = ht, Bd = Er, zd = Wr, Hd = ri, Gd = b([].concat), Wd = jd("Reflect", "ownKeys") || function(t) {
        var e = Bd.f(Hd(t)), i1 = zd.f;
        return i1 ? Gd(e, i1(t)) : e;
    }, Yd = Wd, Vd = tt, Ud = I, Xd = Jo;
    Ii({
        target: "Object",
        stat: !0,
        sham: !P
    }, {
        getOwnPropertyDescriptors: function(t) {
            for(var e, i1, n = Vd(t), o = Ud.f, r = Yd(n), s = {}, a = 0; r.length > a;)void 0 !== (i1 = o(n, e = r[a++])) && Xd(s, e, i1);
            return s;
        }
    });
    var qd = r(ot.Object.getOwnPropertyDescriptors), Kd = {
        exports: {}
    }, $d = Ii, Zd = P, Qd = kn.f;
    $d({
        target: "Object",
        stat: !0,
        forced: Object.defineProperties !== Qd,
        sham: !Zd
    }, {
        defineProperties: Qd
    });
    var Jd = ot.Object, tp = Kd.exports = function(t, e) {
        return Jd.defineProperties(t, e);
    };
    Jd.defineProperties.sham && (tp.sham = !0);
    var ep = r(Kd.exports);
    var ip = Hs.map;
    Ii({
        target: "Array",
        proto: !0,
        forced: !ur("map")
    }, {
        map: function(t) {
            return ip(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var np = _c("Array").map, op = ut, rp = np, sp = Array.prototype, ap = function(t) {
        var e = t.map;
        return t === sp || op(sp, t) && e === sp.map ? rp : e;
    }, lp = r(ap), hp = Nt, up = Qt, cp = X, dp = Mn, pp = TypeError, mp = function(t) {
        return function(e, i1, n, o) {
            hp(i1);
            var r = up(e), s = cp(r), a = dp(r), l = t ? a - 1 : 0, h = t ? -1 : 1;
            if (n < 2) for(;;){
                if (l in s) {
                    o = s[l], l += h;
                    break;
                }
                if (l += h, t ? l < 0 : a <= l) throw new pp("Reduce of empty array with no initial value");
            }
            for(; t ? l >= 0 : a > l; l += h)l in s && (o = i1(o, s[l], l, r));
            return o;
        };
    }, fp = {
        left: mp(!1),
        right: mp(!0)
    }, vp = "process" === x(a.process), gp = fp.left;
    Ii({
        target: "Array",
        proto: !0,
        forced: !vp && yt > 79 && yt < 83 || !ld("reduce")
    }, {
        reduce: function(t) {
            var e = arguments.length;
            return gp(this, t, e, e > 1 ? arguments[1] : void 0);
        }
    });
    var yp = _c("Array").reduce, bp = ut, wp = yp, kp = Array.prototype, _p = function(t) {
        var e = t.reduce;
        return t === kp || bp(kp, t) && e === kp.reduce ? wp : e;
    }, xp = r(_p), Cp = Qt, Sp = Kn;
    Ii({
        target: "Object",
        stat: !0,
        forced: l(function() {
            Sp(1);
        })
    }, {
        keys: function(t) {
            return Sp(Cp(t));
        }
    });
    var Dp = r(ot.Object.keys), Tp = r(Yo), Ep = F, Op = ri, Ap = Lt, Ip = function(t, e, i1) {
        var n, o;
        Op(t);
        try {
            if (!(n = Ap(t, "return"))) {
                if ("throw" === e) throw i1;
                return i1;
            }
            n = Ep(n, t);
        } catch (t) {
            o = !0, n = t;
        }
        if ("throw" === e) throw i1;
        if (o) throw n;
        return Op(n), i1;
    }, Pp = ri, Mp = Ip, Np = Ql, Fp = fe("iterator"), Rp = Array.prototype, Lp = function(t) {
        return void 0 !== t && (Np.Array === t || Rp[Fp] === t);
    }, jp = Qi, Bp = Lt, zp = q, Hp = Ql, Gp = fe("iterator"), Wp = function(t) {
        if (!zp(t)) return Bp(t, Gp) || Bp(t, "@@iterator") || Hp[jp(t)];
    }, Yp = F, Vp = Nt, Up = ri, Xp = At, qp = Wp, Kp = TypeError, $p = function(t, e) {
        var i1 = arguments.length < 2 ? qp(t) : e;
        if (Vp(i1)) return Up(Yp(i1, t));
        throw new Kp(Xp(t) + " is not iterable");
    }, Zp = Je, Qp = F, Jp = Qt, tm = function(t, e, i1, n) {
        try {
            return n ? e(Pp(i1)[0], i1[1]) : e(i1);
        } catch (e) {
            Mp(t, "throw", e);
        }
    }, em = Lp, im = gn, nm = Mn, om = Jo, rm = $p, sm = Wp, am = Array, lm = fe("iterator"), hm = !1;
    try {
        var um = 0, cm = {
            next: function() {
                return {
                    done: !!um++
                };
            },
            return: function() {
                hm = !0;
            }
        };
        cm[lm] = function() {
            return this;
        }, Array.from(cm, function() {
            throw 2;
        });
    } catch (t) {}
    var dm = function(t) {
        var e = Jp(t), i1 = im(this), n = arguments.length, o = n > 1 ? arguments[1] : void 0, r = void 0 !== o;
        r && (o = Zp(o, n > 2 ? arguments[2] : void 0));
        var s, a, l, h, u, c, d = sm(e), p = 0;
        if (!d || this === am && em(d)) for(s = nm(e), a = i1 ? new this(s) : am(s); s > p; p++)c = r ? o(e[p], p) : e[p], om(a, p, c);
        else for(u = (h = rm(e, d)).next, a = i1 ? new this : []; !(l = Qp(u, h)).done; p++)c = r ? tm(h, o, [
            l.value,
            p
        ], !0) : l.value, om(a, p, c);
        return a.length = p, a;
    }, pm = function(t, e) {
        try {
            if (!e && !hm) return !1;
        } catch (t) {
            return !1;
        }
        var i1 = !1;
        try {
            var n = {};
            n[lm] = function() {
                return {
                    next: function() {
                        return {
                            done: i1 = !0
                        };
                    }
                };
            }, t(n);
        } catch (t) {}
        return i1;
    };
    Ii({
        target: "Array",
        stat: !0,
        forced: !pm(function(t) {
            Array.from(t);
        })
    }, {
        from: dm
    });
    var mm = ot.Array.from, fm = r(mm), vm = Wp, gm = r(vm), ym = r(vm), bm = r(Bc);
    var wm = P, km = Xo, _m = TypeError, xm = Object.getOwnPropertyDescriptor, Cm = wm && !function() {
        if (void 0 !== this) return !0;
        try {
            Object.defineProperty([], "length", {
                writable: !1
            }).length = 1;
        } catch (t) {
            return t instanceof TypeError;
        }
    }() ? function(t, e) {
        if (km(t) && !xm(t, "length").writable) throw new _m("Cannot set read only .length");
        return t.length = e;
    } : function(t, e) {
        return t.length = e;
    }, Sm = Qt, Dm = Mn, Tm = Cm, Em = Ko;
    Ii({
        target: "Array",
        proto: !0,
        arity: 1,
        forced: l(function() {
            return 4294967297 !== [].push.call({
                length: 4294967296
            }, 1);
        }) || !function() {
            try {
                Object.defineProperty([], "length", {
                    writable: !1
                }).push();
            } catch (t) {
                return t instanceof TypeError;
            }
        }()
    }, {
        push: function(t) {
            var e = Sm(this), i1 = Dm(e), n = arguments.length;
            Em(i1 + n);
            for(var o = 0; o < n; o++)e[i1] = arguments[o], i1++;
            return Tm(e, i1), i1;
        }
    });
    var Om = _c("Array").push, Am = ut, Im = Om, Pm = Array.prototype, Mm = function(t) {
        var e = t.push;
        return t === Pm || Am(Pm, t) && e === Pm.push ? Im : e;
    }, Nm = r(Mm);
    var Fm = Ii, Rm = Xo, Lm = gn, jm = nt, Bm = On, zm = Mn, Hm = tt, Gm = Jo, Wm = fe, Ym = Pi, Vm = ur("slice"), Um = Wm("species"), Xm = Array, qm = Math.max;
    Fm({
        target: "Array",
        proto: !0,
        forced: !Vm
    }, {
        slice: function(t, e) {
            var i1, n, o, r = Hm(this), s = zm(r), a = Bm(t, s), l = Bm(void 0 === e ? s : e, s);
            if (Rm(r) && (i1 = r.constructor, (Lm(i1) && (i1 === Xm || Rm(i1.prototype)) || jm(i1) && null === (i1 = i1[Um])) && (i1 = void 0), i1 === Xm || void 0 === i1)) return Ym(r, a, l);
            for(n = new (void 0 === i1 ? Xm : i1)(qm(l - a, 0)), o = 0; a < l; a++, o++)a in r && Gm(n, o, r[a]);
            return n.length = o, n;
        }
    });
    var Km = _c("Array").slice, $m = ut, Zm = Km, Qm = Array.prototype, Jm = function(t) {
        var e = t.slice;
        return t === Qm || $m(Qm, t) && e === Qm.slice ? Zm : e;
    }, tf = Jm, ef = r(tf), nf = r(mm);
    function of(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var i1 = 0, n = new Array(e); i1 < e; i1++)n[i1] = t[i1];
        return n;
    }
    function rf(t, e) {
        var i1;
        if (t) {
            if ("string" == typeof t) return of(t, e);
            var n = ef(i1 = Object.prototype.toString.call(t)).call(i1, 8, -1);
            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? nf(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? of(t, e) : void 0;
        }
    }
    function sf(t, e) {
        return function(t) {
            if (bm(t)) return t;
        }(t) || function(t, e) {
            var i1 = null == t ? null : void 0 !== Uu && gm(t) || t["@@iterator"];
            if (null != i1) {
                var n, o, r, s, a = [], l = !0, h = !1;
                try {
                    if (r = (i1 = i1.call(t)).next, 0 === e) {
                        if (Object(i1) !== i1) return;
                        l = !1;
                    } else for(; !(l = (n = r.call(i1)).done) && (Nm(a).call(a, n.value), a.length !== e); l = !0);
                } catch (t) {
                    h = !0, o = t;
                } finally{
                    try {
                        if (!l && null != i1.return && (s = i1.return(), Object(s) !== s)) return;
                    } finally{
                        if (h) throw o;
                    }
                }
                return a;
            }
        }(t, e) || rf(t, e) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function af(t) {
        return function(t) {
            if (bm(t)) return of(t);
        }(t) || function(t) {
            if (void 0 !== Uu && null != gm(t) || null != t["@@iterator"]) return nf(t);
        }(t) || rf(t) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    var lf = r(wu), hf = _c("Array").concat, uf = ut, cf = hf, df = Array.prototype, pf = function(t) {
        var e = t.concat;
        return t === df || uf(df, t) && e === df.concat ? cf : e;
    }, mf = r(pf), ff = r(tf);
    Ii({
        target: "Reflect",
        stat: !0
    }, {
        ownKeys: Wd
    });
    var vf = r(ot.Reflect.ownKeys), gf = Ii, yf = Date, bf = b(yf.prototype.getTime);
    gf({
        target: "Date",
        stat: !0
    }, {
        now: function() {
            return bf(new yf);
        }
    });
    var wf = r(ot.Date.now), kf = Ii, _f = Xo, xf = b([].reverse), Cf = [
        1,
        2
    ];
    kf({
        target: "Array",
        proto: !0,
        forced: String(Cf) === String(Cf.reverse())
    }, {
        reverse: function() {
            return _f(this) && (this.length = this.length), xf(this);
        }
    });
    var Sf = _c("Array").reverse, Df = ut, Tf = Sf, Ef = Array.prototype, Of = function(t) {
        var e = t.reverse;
        return t === Ef || Df(Ef, t) && e === Ef.reverse ? Tf : e;
    }, Af = r(Of), If = At, Pf = TypeError, Mf = function(t, e) {
        if (!delete t[e]) throw new Pf("Cannot delete property " + If(e) + " of " + If(t));
    }, Nf = Ii, Ff = Qt, Rf = On, Lf = Sn, jf = Mn, Bf = Cm, zf = Ko, Hf = sr, Gf = Jo, Wf = Mf, Yf = ur("splice"), Vf = Math.max, Uf = Math.min;
    Nf({
        target: "Array",
        proto: !0,
        forced: !Yf
    }, {
        splice: function(t, e) {
            var i1, n, o, r, s, a, l = Ff(this), h = jf(l), u = Rf(t, h), c = arguments.length;
            for(0 === c ? i1 = n = 0 : 1 === c ? (i1 = 0, n = h - u) : (i1 = c - 2, n = Uf(Vf(Lf(e), 0), h - u)), zf(h + i1 - n), o = Hf(l, n), r = 0; r < n; r++)(s = u + r) in l && Gf(o, r, l[s]);
            if (o.length = n, i1 < n) {
                for(r = u; r < h - n; r++)a = r + i1, (s = r + n) in l ? l[a] = l[s] : Wf(l, a);
                for(r = h; r > h - n + i1; r--)Wf(l, r - 1);
            } else if (i1 > n) for(r = h - n; r > u; r--)a = r + i1 - 1, (s = r + n - 1) in l ? l[a] = l[s] : Wf(l, a);
            for(r = 0; r < i1; r++)l[r + u] = arguments[r + 2];
            return Bf(l, h - n + i1), o;
        }
    });
    var Xf = _c("Array").splice, qf = ut, Kf = Xf, $f = Array.prototype, Zf = function(t) {
        var e = t.splice;
        return t === $f || qf($f, t) && e === $f.splice ? Kf : e;
    }, Qf = r(Zf), Jf = P, tv = b, ev = F, iv = l, nv = Kn, ov = Wr, rv = R, sv = Qt, av = X, lv = Object.assign, hv = Object.defineProperty, uv = tv([].concat), cv = !lv || iv(function() {
        if (Jf && 1 !== lv({
            b: 1
        }, lv(hv({}, "a", {
            enumerable: !0,
            get: function() {
                hv(this, "b", {
                    value: 3,
                    enumerable: !1
                });
            }
        }), {
            b: 2
        })).b) return !0;
        var t = {}, e = {}, i1 = Symbol("assign detection"), n = "abcdefghijklmnopqrst";
        return t[i1] = 7, n.split("").forEach(function(t) {
            e[t] = t;
        }), 7 !== lv({}, t)[i1] || nv(lv({}, e)).join("") !== n;
    }) ? function(t, e) {
        for(var i1 = sv(t), n = arguments.length, o = 1, r = ov.f, s = rv.f; n > o;)for(var a, l = av(arguments[o++]), h = r ? uv(nv(l), r(l)) : nv(l), u = h.length, c = 0; u > c;)a = h[c++], Jf && !ev(s, l, a) || (i1[a] = l[a]);
        return i1;
    } : lv, dv = cv;
    Ii({
        target: "Object",
        stat: !0,
        arity: 2,
        forced: Object.assign !== dv
    }, {
        assign: dv
    });
    var pv = r(ot.Object.assign), mv = jn.includes;
    Ii({
        target: "Array",
        proto: !0,
        forced: l(function() {
            return !Array(1).includes();
        })
    }, {
        includes: function(t) {
            return mv(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var fv = _c("Array").includes, vv = nt, gv = x, yv = fe("match"), bv = function(t) {
        var e;
        return vv(t) && (void 0 !== (e = t[yv]) ? !!e : "RegExp" === gv(t));
    }, wv = TypeError, kv = fe("match"), _v = Ii, xv = function(t) {
        if (bv(t)) throw new wv("The method doesn't accept regular expressions");
        return t;
    }, Cv = Z, Sv = Tr, Dv = function(t) {
        var e = /./;
        try {
            "/./"[t](e);
        } catch (i1) {
            try {
                return e[kv] = !1, "/./"[t](e);
            } catch (t) {}
        }
        return !1;
    }, Tv = b("".indexOf);
    _v({
        target: "String",
        proto: !0,
        forced: !Dv("includes")
    }, {
        includes: function(t) {
            return !!~Tv(Sv(Cv(this)), Sv(xv(t)), arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var Ev = _c("String").includes, Ov = ut, Av = fv, Iv = Ev, Pv = Array.prototype, Mv = String.prototype, Nv = function(t) {
        var e = t.includes;
        return t === Pv || Ov(Pv, t) && e === Pv.includes ? Av : "string" == typeof t || t === Mv || Ov(Mv, t) && e === Mv.includes ? Iv : e;
    }, Fv = r(Nv), Rv = r(Rc), Lv = P, jv = l, Bv = b, zv = ph, Hv = Kn, Gv = tt, Wv = Bv(R.f), Yv = Bv([].push), Vv = Lv && jv(function() {
        var t = Object.create(null);
        return t[2] = 2, !Wv(t, 2);
    }), Uv = function(t) {
        return function(e) {
            for(var i1, n = Gv(e), o = Hv(n), r = Vv && null === zv(n), s = o.length, a = 0, l = []; s > a;)i1 = o[a++], Lv && !(r ? i1 in n : Wv(n, i1)) || Yv(l, t ? [
                i1,
                n[i1]
            ] : n[i1]);
            return l;
        };
    }, Xv = {
        entries: Uv(!0),
        values: Uv(!1)
    }, qv = Xv.values;
    Ii({
        target: "Object",
        stat: !0
    }, {
        values: function(t) {
            return qv(t);
        }
    });
    var Kv = r(ot.Object.values), $v = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF", Zv = Z, Qv = Tr, Jv = $v, tg = b("".replace), eg = RegExp("^[" + Jv + "]+"), ig = RegExp("(^|[^" + Jv + "])[" + Jv + "]+$"), ng = function(t) {
        return function(e) {
            var i1 = Qv(Zv(e));
            return 1 & t && (i1 = tg(i1, eg, "")), 2 & t && (i1 = tg(i1, ig, "$1")), i1;
        };
    }, og = {
        start: ng(1),
        end: ng(2),
        trim: ng(3)
    }, rg = a, sg = l, ag = b, lg = Tr, hg = og.trim, ug = $v, cg = rg.parseInt, dg = rg.Symbol, pg = dg && dg.iterator, mg = /^[+-]?0x/i, fg = ag(mg.exec), vg = 8 !== cg(ug + "08") || 22 !== cg(ug + "0x16") || pg && !sg(function() {
        cg(Object(pg));
    }) ? function(t, e) {
        var i1 = hg(lg(t));
        return cg(i1, e >>> 0 || (fg(mg, i1) ? 16 : 10));
    } : cg;
    Ii({
        global: !0,
        forced: parseInt !== vg
    }, {
        parseInt: vg
    });
    var gg = r(ot.parseInt), yg = Ii, bg = jn.indexOf, wg = ld, kg = D([].indexOf), _g = !!kg && 1 / kg([
        1
    ], 1, -0) < 0;
    yg({
        target: "Array",
        proto: !0,
        forced: _g || !wg("indexOf")
    }, {
        indexOf: function(t) {
            var e = arguments.length > 1 ? arguments[1] : void 0;
            return _g ? kg(this, t, e) || 0 : bg(this, t, e);
        }
    });
    var xg = _c("Array").indexOf, Cg = ut, Sg = xg, Dg = Array.prototype, Tg = function(t) {
        var e = t.indexOf;
        return t === Dg || Cg(Dg, t) && e === Dg.indexOf ? Sg : e;
    }, Eg = r(Tg), Og = Xv.entries;
    Ii({
        target: "Object",
        stat: !0
    }, {
        entries: function(t) {
            return Og(t);
        }
    });
    var Ag = r(ot.Object.entries), Ig = r(gc), Pg = ot, Mg = m;
    Pg.JSON || (Pg.JSON = {
        stringify: JSON.stringify
    });
    var Ng = function(t, e, i1) {
        return Mg(Pg.JSON.stringify, null, arguments);
    }, Fg = r(Ng), Rg = Qt, Lg = On, jg = Mn, Bg = function(t) {
        for(var e = Rg(this), i1 = jg(e), n = arguments.length, o = Lg(n > 1 ? arguments[1] : void 0, i1), r = n > 2 ? arguments[2] : void 0, s = void 0 === r ? i1 : Lg(r, i1); s > o;)e[o++] = t;
        return e;
    };
    Ii({
        target: "Array",
        proto: !0
    }, {
        fill: Bg
    });
    var zg = _c("Array").fill, Hg = ut, Gg = zg, Wg = Array.prototype, Yg = function(t) {
        var e = t.fill;
        return t === Wg || Hg(Wg, t) && e === Wg.fill ? Gg : e;
    }, Vg = r(Yg), Ug = {
        exports: {}
    };
    !function(t) {
        function e(t) {
            if (t) return function(t) {
                for(var i1 in e.prototype)t[i1] = e.prototype[i1];
                return t;
            }(t);
        }
        t.exports = e, e.prototype.on = e.prototype.addEventListener = function(t, e) {
            return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
        }, e.prototype.once = function(t, e) {
            function i1() {
                this.off(t, i1), e.apply(this, arguments);
            }
            return i1.fn = e, this.on(t, i1), this;
        }, e.prototype.off = e.prototype.removeListener = e.prototype.removeAllListeners = e.prototype.removeEventListener = function(t, e) {
            if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
            var i1, n = this._callbacks["$" + t];
            if (!n) return this;
            if (1 == arguments.length) return delete this._callbacks["$" + t], this;
            for(var o = 0; o < n.length; o++)if ((i1 = n[o]) === e || i1.fn === e) {
                n.splice(o, 1);
                break;
            }
            return 0 === n.length && delete this._callbacks["$" + t], this;
        }, e.prototype.emit = function(t) {
            this._callbacks = this._callbacks || {};
            for(var e = new Array(arguments.length - 1), i1 = this._callbacks["$" + t], n = 1; n < arguments.length; n++)e[n - 1] = arguments[n];
            if (i1) {
                n = 0;
                for(var o = (i1 = i1.slice(0)).length; n < o; ++n)i1[n].apply(this, e);
            }
            return this;
        }, e.prototype.listeners = function(t) {
            return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
        }, e.prototype.hasListeners = function(t) {
            return !!this.listeners(t).length;
        };
    }(Ug);
    var Xg, qg = r(Ug.exports);
    /*! Hammer.JS - v2.0.17-rc - 2019-12-16
	 * http://naver.github.io/egjs
	 *
	 * Forked By Naver egjs
	 * Copyright (c) hammerjs
	 * Licensed under the MIT license */ function Kg() {
        return Kg = Object.assign || function(t) {
            for(var e = 1; e < arguments.length; e++){
                var i1 = arguments[e];
                for(var n in i1)Object.prototype.hasOwnProperty.call(i1, n) && (t[n] = i1[n]);
            }
            return t;
        }, Kg.apply(this, arguments);
    }
    function $g(t, e) {
        t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
    }
    function Zg(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    Xg = "function" != typeof Object.assign ? function(t) {
        if (null == t) throw new TypeError("Cannot convert undefined or null to object");
        for(var e = Object(t), i1 = 1; i1 < arguments.length; i1++){
            var n = arguments[i1];
            if (null != n) for(var o in n)n.hasOwnProperty(o) && (e[o] = n[o]);
        }
        return e;
    } : Object.assign;
    var Qg, Jg = Xg, ty = [
        "",
        "webkit",
        "Moz",
        "MS",
        "ms",
        "o"
    ], ey = "undefined" == typeof document ? {
        style: {}
    } : document.createElement("div"), iy = Math.round, ny = Math.abs, oy = Date.now;
    function ry(t, e) {
        for(var i1, n, o = e[0].toUpperCase() + e.slice(1), r = 0; r < ty.length;){
            if ((n = (i1 = ty[r]) ? i1 + o : e) in t) return n;
            r++;
        }
    }
    Qg = "undefined" == typeof window ? {} : window;
    var sy = ry(ey.style, "touchAction"), ay = void 0 !== sy;
    var ly = "compute", hy = "auto", uy = "manipulation", cy = "none", dy = "pan-x", py = "pan-y", my = function() {
        if (!ay) return !1;
        var t = {}, e = Qg.CSS && Qg.CSS.supports;
        return [
            "auto",
            "manipulation",
            "pan-y",
            "pan-x",
            "pan-x pan-y",
            "none"
        ].forEach(function(i1) {
            return t[i1] = !e || Qg.CSS.supports("touch-action", i1);
        }), t;
    }(), fy = "ontouchstart" in Qg, vy = void 0 !== ry(Qg, "PointerEvent"), gy = fy && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent), yy = "touch", by = "mouse", wy = 25, ky = 1, _y = 4, xy = 8, Cy = 1, Sy = 2, Dy = 4, Ty = 8, Ey = 16, Oy = Sy | Dy, Ay = Ty | Ey, Iy = Oy | Ay, Py = [
        "x",
        "y"
    ], My = [
        "clientX",
        "clientY"
    ];
    function Ny(t, e, i1) {
        var n;
        if (t) {
            if (t.forEach) t.forEach(e, i1);
            else if (void 0 !== t.length) for(n = 0; n < t.length;)e.call(i1, t[n], n, t), n++;
            else for(n in t)t.hasOwnProperty(n) && e.call(i1, t[n], n, t);
        }
    }
    function Fy(t, e) {
        return "function" == typeof t ? t.apply(e && e[0] || void 0, e) : t;
    }
    function Ry(t, e) {
        return t.indexOf(e) > -1;
    }
    var Ly = function() {
        function t(t, e) {
            this.manager = t, this.set(e);
        }
        var e = t.prototype;
        return e.set = function(t) {
            t === ly && (t = this.compute()), ay && this.manager.element.style && my[t] && (this.manager.element.style[sy] = t), this.actions = t.toLowerCase().trim();
        }, e.update = function() {
            this.set(this.manager.options.touchAction);
        }, e.compute = function() {
            var t = [];
            return Ny(this.manager.recognizers, function(e) {
                Fy(e.options.enable, [
                    e
                ]) && (t = t.concat(e.getTouchAction()));
            }), function(t) {
                if (Ry(t, cy)) return cy;
                var e = Ry(t, dy), i1 = Ry(t, py);
                return e && i1 ? cy : e || i1 ? e ? dy : py : Ry(t, uy) ? uy : hy;
            }(t.join(" "));
        }, e.preventDefaults = function(t) {
            var e = t.srcEvent, i1 = t.offsetDirection;
            if (this.manager.session.prevented) e.preventDefault();
            else {
                var n = this.actions, o = Ry(n, cy) && !my[cy], r = Ry(n, py) && !my[py], s = Ry(n, dy) && !my[dy];
                if (o) {
                    var a = 1 === t.pointers.length, l = t.distance < 2, h = t.deltaTime < 250;
                    if (a && l && h) return;
                }
                if (!s || !r) return o || r && i1 & Oy || s && i1 & Ay ? this.preventSrc(e) : void 0;
            }
        }, e.preventSrc = function(t) {
            this.manager.session.prevented = !0, t.preventDefault();
        }, t;
    }();
    function jy(t, e) {
        for(; t;){
            if (t === e) return !0;
            t = t.parentNode;
        }
        return !1;
    }
    function By(t) {
        var e = t.length;
        if (1 === e) return {
            x: iy(t[0].clientX),
            y: iy(t[0].clientY)
        };
        for(var i1 = 0, n = 0, o = 0; o < e;)i1 += t[o].clientX, n += t[o].clientY, o++;
        return {
            x: iy(i1 / e),
            y: iy(n / e)
        };
    }
    function zy(t) {
        for(var e = [], i1 = 0; i1 < t.pointers.length;)e[i1] = {
            clientX: iy(t.pointers[i1].clientX),
            clientY: iy(t.pointers[i1].clientY)
        }, i1++;
        return {
            timeStamp: oy(),
            pointers: e,
            center: By(e),
            deltaX: t.deltaX,
            deltaY: t.deltaY
        };
    }
    function Hy(t, e, i1) {
        i1 || (i1 = Py);
        var n = e[i1[0]] - t[i1[0]], o = e[i1[1]] - t[i1[1]];
        return Math.sqrt(n * n + o * o);
    }
    function Gy(t, e, i1) {
        i1 || (i1 = Py);
        var n = e[i1[0]] - t[i1[0]], o = e[i1[1]] - t[i1[1]];
        return 180 * Math.atan2(o, n) / Math.PI;
    }
    function Wy(t, e) {
        return t === e ? Cy : ny(t) >= ny(e) ? t < 0 ? Sy : Dy : e < 0 ? Ty : Ey;
    }
    function Yy(t, e, i1) {
        return {
            x: e / t || 0,
            y: i1 / t || 0
        };
    }
    function Vy(t, e) {
        var i1 = t.session, n = e.pointers, o = n.length;
        i1.firstInput || (i1.firstInput = zy(e)), o > 1 && !i1.firstMultiple ? i1.firstMultiple = zy(e) : 1 === o && (i1.firstMultiple = !1);
        var r = i1.firstInput, s = i1.firstMultiple, a = s ? s.center : r.center, l = e.center = By(n);
        e.timeStamp = oy(), e.deltaTime = e.timeStamp - r.timeStamp, e.angle = Gy(a, l), e.distance = Hy(a, l), function(t, e) {
            var i1 = e.center, n = t.offsetDelta || {}, o = t.prevDelta || {}, r = t.prevInput || {};
            e.eventType !== ky && r.eventType !== _y || (o = t.prevDelta = {
                x: r.deltaX || 0,
                y: r.deltaY || 0
            }, n = t.offsetDelta = {
                x: i1.x,
                y: i1.y
            }), e.deltaX = o.x + (i1.x - n.x), e.deltaY = o.y + (i1.y - n.y);
        }(i1, e), e.offsetDirection = Wy(e.deltaX, e.deltaY);
        var h, u, c = Yy(e.deltaTime, e.deltaX, e.deltaY);
        e.overallVelocityX = c.x, e.overallVelocityY = c.y, e.overallVelocity = ny(c.x) > ny(c.y) ? c.x : c.y, e.scale = s ? (h = s.pointers, Hy((u = n)[0], u[1], My) / Hy(h[0], h[1], My)) : 1, e.rotation = s ? function(t, e) {
            return Gy(e[1], e[0], My) + Gy(t[1], t[0], My);
        }(s.pointers, n) : 0, e.maxPointers = i1.prevInput ? e.pointers.length > i1.prevInput.maxPointers ? e.pointers.length : i1.prevInput.maxPointers : e.pointers.length, function(t, e) {
            var i1, n, o, r, s = t.lastInterval || e, a = e.timeStamp - s.timeStamp;
            if (e.eventType !== xy && (a > wy || void 0 === s.velocity)) {
                var l = e.deltaX - s.deltaX, h = e.deltaY - s.deltaY, u = Yy(a, l, h);
                n = u.x, o = u.y, i1 = ny(u.x) > ny(u.y) ? u.x : u.y, r = Wy(l, h), t.lastInterval = e;
            } else i1 = s.velocity, n = s.velocityX, o = s.velocityY, r = s.direction;
            e.velocity = i1, e.velocityX = n, e.velocityY = o, e.direction = r;
        }(i1, e);
        var d, p = t.element, m = e.srcEvent;
        jy(d = m.composedPath ? m.composedPath()[0] : m.path ? m.path[0] : m.target, p) && (p = d), e.target = p;
    }
    function Uy(t, e, i1) {
        var n = i1.pointers.length, o = i1.changedPointers.length, r = e & ky && n - o == 0, s = e & (_y | xy) && n - o == 0;
        i1.isFirst = !!r, i1.isFinal = !!s, r && (t.session = {}), i1.eventType = e, Vy(t, i1), t.emit("hammer.input", i1), t.recognize(i1), t.session.prevInput = i1;
    }
    function Xy(t) {
        return t.trim().split(/\s+/g);
    }
    function qy(t, e, i1) {
        Ny(Xy(e), function(e) {
            t.addEventListener(e, i1, !1);
        });
    }
    function Ky(t, e, i1) {
        Ny(Xy(e), function(e) {
            t.removeEventListener(e, i1, !1);
        });
    }
    function $y(t) {
        var e = t.ownerDocument || t;
        return e.defaultView || e.parentWindow || window;
    }
    var Zy = function() {
        function t(t, e) {
            var i1 = this;
            this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function(e) {
                Fy(t.options.enable, [
                    t
                ]) && i1.handler(e);
            }, this.init();
        }
        var e = t.prototype;
        return e.handler = function() {}, e.init = function() {
            this.evEl && qy(this.element, this.evEl, this.domHandler), this.evTarget && qy(this.target, this.evTarget, this.domHandler), this.evWin && qy($y(this.element), this.evWin, this.domHandler);
        }, e.destroy = function() {
            this.evEl && Ky(this.element, this.evEl, this.domHandler), this.evTarget && Ky(this.target, this.evTarget, this.domHandler), this.evWin && Ky($y(this.element), this.evWin, this.domHandler);
        }, t;
    }();
    function Qy(t, e, i1) {
        if (t.indexOf && !i1) return t.indexOf(e);
        for(var n = 0; n < t.length;){
            if (i1 && t[n][i1] == e || !i1 && t[n] === e) return n;
            n++;
        }
        return -1;
    }
    var Jy = {
        pointerdown: ky,
        pointermove: 2,
        pointerup: _y,
        pointercancel: xy,
        pointerout: xy
    }, tb = {
        2: yy,
        3: "pen",
        4: by,
        5: "kinect"
    }, eb = "pointerdown", ib = "pointermove pointerup pointercancel";
    Qg.MSPointerEvent && !Qg.PointerEvent && (eb = "MSPointerDown", ib = "MSPointerMove MSPointerUp MSPointerCancel");
    var nb = function(t) {
        function e() {
            var i1, n = e.prototype;
            return n.evEl = eb, n.evWin = ib, (i1 = t.apply(this, arguments) || this).store = i1.manager.session.pointerEvents = [], i1;
        }
        return $g(e, t), e.prototype.handler = function(t) {
            var e = this.store, i1 = !1, n = t.type.toLowerCase().replace("ms", ""), o = Jy[n], r = tb[t.pointerType] || t.pointerType, s = r === yy, a = Qy(e, t.pointerId, "pointerId");
            o & ky && (0 === t.button || s) ? a < 0 && (e.push(t), a = e.length - 1) : o & (_y | xy) && (i1 = !0), a < 0 || (e[a] = t, this.callback(this.manager, o, {
                pointers: e,
                changedPointers: [
                    t
                ],
                pointerType: r,
                srcEvent: t
            }), i1 && e.splice(a, 1));
        }, e;
    }(Zy);
    function ob(t) {
        return Array.prototype.slice.call(t, 0);
    }
    function rb(t, e, i1) {
        for(var n = [], o = [], r = 0; r < t.length;){
            var s = e ? t[r][e] : t[r];
            Qy(o, s) < 0 && n.push(t[r]), o[r] = s, r++;
        }
        return i1 && (n = e ? n.sort(function(t, i1) {
            return t[e] > i1[e];
        }) : n.sort()), n;
    }
    var sb = {
        touchstart: ky,
        touchmove: 2,
        touchend: _y,
        touchcancel: xy
    }, ab = function(t) {
        function e() {
            var i1;
            return e.prototype.evTarget = "touchstart touchmove touchend touchcancel", (i1 = t.apply(this, arguments) || this).targetIds = {}, i1;
        }
        return $g(e, t), e.prototype.handler = function(t) {
            var e = sb[t.type], i1 = lb.call(this, t, e);
            i1 && this.callback(this.manager, e, {
                pointers: i1[0],
                changedPointers: i1[1],
                pointerType: yy,
                srcEvent: t
            });
        }, e;
    }(Zy);
    function lb(t, e) {
        var i1, n, o = ob(t.touches), r = this.targetIds;
        if (e & (2 | ky) && 1 === o.length) return r[o[0].identifier] = !0, [
            o,
            o
        ];
        var s = ob(t.changedTouches), a = [], l = this.target;
        if (n = o.filter(function(t) {
            return jy(t.target, l);
        }), e === ky) for(i1 = 0; i1 < n.length;)r[n[i1].identifier] = !0, i1++;
        for(i1 = 0; i1 < s.length;)r[s[i1].identifier] && a.push(s[i1]), e & (_y | xy) && delete r[s[i1].identifier], i1++;
        return a.length ? [
            rb(n.concat(a), "identifier", !0),
            a
        ] : void 0;
    }
    var hb = {
        mousedown: ky,
        mousemove: 2,
        mouseup: _y
    }, ub = function(t) {
        function e() {
            var i1, n = e.prototype;
            return n.evEl = "mousedown", n.evWin = "mousemove mouseup", (i1 = t.apply(this, arguments) || this).pressed = !1, i1;
        }
        return $g(e, t), e.prototype.handler = function(t) {
            var e = hb[t.type];
            e & ky && 0 === t.button && (this.pressed = !0), 2 & e && 1 !== t.which && (e = _y), this.pressed && (e & _y && (this.pressed = !1), this.callback(this.manager, e, {
                pointers: [
                    t
                ],
                changedPointers: [
                    t
                ],
                pointerType: by,
                srcEvent: t
            }));
        }, e;
    }(Zy), cb = 2500;
    function db(t) {
        var e = t.changedPointers[0];
        if (e.identifier === this.primaryTouch) {
            var i1 = {
                x: e.clientX,
                y: e.clientY
            }, n = this.lastTouches;
            this.lastTouches.push(i1);
            setTimeout(function() {
                var t = n.indexOf(i1);
                t > -1 && n.splice(t, 1);
            }, cb);
        }
    }
    function pb(t, e) {
        t & ky ? (this.primaryTouch = e.changedPointers[0].identifier, db.call(this, e)) : t & (_y | xy) && db.call(this, e);
    }
    function mb(t) {
        for(var e = t.srcEvent.clientX, i1 = t.srcEvent.clientY, n = 0; n < this.lastTouches.length; n++){
            var o = this.lastTouches[n], r = Math.abs(e - o.x), s = Math.abs(i1 - o.y);
            if (r <= 25 && s <= 25) return !0;
        }
        return !1;
    }
    var fb = function() {
        return function(t) {
            function e(e, i1) {
                var n;
                return (n = t.call(this, e, i1) || this).handler = function(t, e, i1) {
                    var o = i1.pointerType === yy, r = i1.pointerType === by;
                    if (!(r && i1.sourceCapabilities && i1.sourceCapabilities.firesTouchEvents)) {
                        if (o) pb.call(Zg(Zg(n)), e, i1);
                        else if (r && mb.call(Zg(Zg(n)), i1)) return;
                        n.callback(t, e, i1);
                    }
                }, n.touch = new ab(n.manager, n.handler), n.mouse = new ub(n.manager, n.handler), n.primaryTouch = null, n.lastTouches = [], n;
            }
            return $g(e, t), e.prototype.destroy = function() {
                this.touch.destroy(), this.mouse.destroy();
            }, e;
        }(Zy);
    }();
    function vb(t, e, i1) {
        return !!Array.isArray(t) && (Ny(t, i1[e], i1), !0);
    }
    var gb = 32, yb = 1;
    function bb(t, e) {
        var i1 = e.manager;
        return i1 ? i1.get(t) : t;
    }
    function wb(t) {
        return 16 & t ? "cancel" : 8 & t ? "end" : 4 & t ? "move" : 2 & t ? "start" : "";
    }
    var kb = function() {
        function t(t) {
            void 0 === t && (t = {}), this.options = Kg({
                enable: !0
            }, t), this.id = yb++, this.manager = null, this.state = 1, this.simultaneous = {}, this.requireFail = [];
        }
        var e = t.prototype;
        return e.set = function(t) {
            return Jg(this.options, t), this.manager && this.manager.touchAction.update(), this;
        }, e.recognizeWith = function(t) {
            if (vb(t, "recognizeWith", this)) return this;
            var e = this.simultaneous;
            return e[(t = bb(t, this)).id] || (e[t.id] = t, t.recognizeWith(this)), this;
        }, e.dropRecognizeWith = function(t) {
            return vb(t, "dropRecognizeWith", this) || (t = bb(t, this), delete this.simultaneous[t.id]), this;
        }, e.requireFailure = function(t) {
            if (vb(t, "requireFailure", this)) return this;
            var e = this.requireFail;
            return -1 === Qy(e, t = bb(t, this)) && (e.push(t), t.requireFailure(this)), this;
        }, e.dropRequireFailure = function(t) {
            if (vb(t, "dropRequireFailure", this)) return this;
            t = bb(t, this);
            var e = Qy(this.requireFail, t);
            return e > -1 && this.requireFail.splice(e, 1), this;
        }, e.hasRequireFailures = function() {
            return this.requireFail.length > 0;
        }, e.canRecognizeWith = function(t) {
            return !!this.simultaneous[t.id];
        }, e.emit = function(t) {
            var e = this, i1 = this.state;
            function n(i1) {
                e.manager.emit(i1, t);
            }
            i1 < 8 && n(e.options.event + wb(i1)), n(e.options.event), t.additionalEvent && n(t.additionalEvent), i1 >= 8 && n(e.options.event + wb(i1));
        }, e.tryEmit = function(t) {
            if (this.canEmit()) return this.emit(t);
            this.state = gb;
        }, e.canEmit = function() {
            for(var t = 0; t < this.requireFail.length;){
                if (!(33 & this.requireFail[t].state)) return !1;
                t++;
            }
            return !0;
        }, e.recognize = function(t) {
            var e = Jg({}, t);
            if (!Fy(this.options.enable, [
                this,
                e
            ])) return this.reset(), void (this.state = gb);
            56 & this.state && (this.state = 1), this.state = this.process(e), 30 & this.state && this.tryEmit(e);
        }, e.process = function(t) {}, e.getTouchAction = function() {}, e.reset = function() {}, t;
    }(), _b = function(t) {
        function e(e) {
            var i1;
            return void 0 === e && (e = {}), (i1 = t.call(this, Kg({
                event: "tap",
                pointers: 1,
                taps: 1,
                interval: 300,
                time: 250,
                threshold: 9,
                posThreshold: 10
            }, e)) || this).pTime = !1, i1.pCenter = !1, i1._timer = null, i1._input = null, i1.count = 0, i1;
        }
        $g(e, t);
        var i1 = e.prototype;
        return i1.getTouchAction = function() {
            return [
                uy
            ];
        }, i1.process = function(t) {
            var e = this, i1 = this.options, n = t.pointers.length === i1.pointers, o = t.distance < i1.threshold, r = t.deltaTime < i1.time;
            if (this.reset(), t.eventType & ky && 0 === this.count) return this.failTimeout();
            if (o && r && n) {
                if (t.eventType !== _y) return this.failTimeout();
                var s = !this.pTime || t.timeStamp - this.pTime < i1.interval, a = !this.pCenter || Hy(this.pCenter, t.center) < i1.posThreshold;
                if (this.pTime = t.timeStamp, this.pCenter = t.center, a && s ? this.count += 1 : this.count = 1, this._input = t, 0 === this.count % i1.taps) return this.hasRequireFailures() ? (this._timer = setTimeout(function() {
                    e.state = 8, e.tryEmit();
                }, i1.interval), 2) : 8;
            }
            return gb;
        }, i1.failTimeout = function() {
            var t = this;
            return this._timer = setTimeout(function() {
                t.state = gb;
            }, this.options.interval), gb;
        }, i1.reset = function() {
            clearTimeout(this._timer);
        }, i1.emit = function() {
            8 === this.state && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
        }, e;
    }(kb), xb = function(t) {
        function e(e) {
            return void 0 === e && (e = {}), t.call(this, Kg({
                pointers: 1
            }, e)) || this;
        }
        $g(e, t);
        var i1 = e.prototype;
        return i1.attrTest = function(t) {
            var e = this.options.pointers;
            return 0 === e || t.pointers.length === e;
        }, i1.process = function(t) {
            var e = this.state, i1 = t.eventType, n = 6 & e, o = this.attrTest(t);
            return n && (i1 & xy || !o) ? 16 | e : n || o ? i1 & _y ? 8 | e : 2 & e ? 4 | e : 2 : gb;
        }, e;
    }(kb);
    function Cb(t) {
        return t === Ey ? "down" : t === Ty ? "up" : t === Sy ? "left" : t === Dy ? "right" : "";
    }
    var Sb = function(t) {
        function e(e) {
            var i1;
            return void 0 === e && (e = {}), (i1 = t.call(this, Kg({
                event: "pan",
                threshold: 10,
                pointers: 1,
                direction: Iy
            }, e)) || this).pX = null, i1.pY = null, i1;
        }
        $g(e, t);
        var i1 = e.prototype;
        return i1.getTouchAction = function() {
            var t = this.options.direction, e = [];
            return t & Oy && e.push(py), t & Ay && e.push(dy), e;
        }, i1.directionTest = function(t) {
            var e = this.options, i1 = !0, n = t.distance, o = t.direction, r = t.deltaX, s = t.deltaY;
            return o & e.direction || (e.direction & Oy ? (o = 0 === r ? Cy : r < 0 ? Sy : Dy, i1 = r !== this.pX, n = Math.abs(t.deltaX)) : (o = 0 === s ? Cy : s < 0 ? Ty : Ey, i1 = s !== this.pY, n = Math.abs(t.deltaY))), t.direction = o, i1 && n > e.threshold && o & e.direction;
        }, i1.attrTest = function(t) {
            return xb.prototype.attrTest.call(this, t) && (2 & this.state || !(2 & this.state) && this.directionTest(t));
        }, i1.emit = function(e) {
            this.pX = e.deltaX, this.pY = e.deltaY;
            var i1 = Cb(e.direction);
            i1 && (e.additionalEvent = this.options.event + i1), t.prototype.emit.call(this, e);
        }, e;
    }(xb), Db = function(t) {
        function e(e) {
            return void 0 === e && (e = {}), t.call(this, Kg({
                event: "swipe",
                threshold: 10,
                velocity: .3,
                direction: Oy | Ay,
                pointers: 1
            }, e)) || this;
        }
        $g(e, t);
        var i1 = e.prototype;
        return i1.getTouchAction = function() {
            return Sb.prototype.getTouchAction.call(this);
        }, i1.attrTest = function(e) {
            var i1, n = this.options.direction;
            return n & (Oy | Ay) ? i1 = e.overallVelocity : n & Oy ? i1 = e.overallVelocityX : n & Ay && (i1 = e.overallVelocityY), t.prototype.attrTest.call(this, e) && n & e.offsetDirection && e.distance > this.options.threshold && e.maxPointers === this.options.pointers && ny(i1) > this.options.velocity && e.eventType & _y;
        }, i1.emit = function(t) {
            var e = Cb(t.offsetDirection);
            e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t);
        }, e;
    }(xb), Tb = function(t) {
        function e(e) {
            return void 0 === e && (e = {}), t.call(this, Kg({
                event: "pinch",
                threshold: 0,
                pointers: 2
            }, e)) || this;
        }
        $g(e, t);
        var i1 = e.prototype;
        return i1.getTouchAction = function() {
            return [
                cy
            ];
        }, i1.attrTest = function(e) {
            return t.prototype.attrTest.call(this, e) && (Math.abs(e.scale - 1) > this.options.threshold || 2 & this.state);
        }, i1.emit = function(e) {
            if (1 !== e.scale) {
                var i1 = e.scale < 1 ? "in" : "out";
                e.additionalEvent = this.options.event + i1;
            }
            t.prototype.emit.call(this, e);
        }, e;
    }(xb), Eb = function(t) {
        function e(e) {
            return void 0 === e && (e = {}), t.call(this, Kg({
                event: "rotate",
                threshold: 0,
                pointers: 2
            }, e)) || this;
        }
        $g(e, t);
        var i1 = e.prototype;
        return i1.getTouchAction = function() {
            return [
                cy
            ];
        }, i1.attrTest = function(e) {
            return t.prototype.attrTest.call(this, e) && (Math.abs(e.rotation) > this.options.threshold || 2 & this.state);
        }, e;
    }(xb), Ob = function(t) {
        function e(e) {
            var i1;
            return void 0 === e && (e = {}), (i1 = t.call(this, Kg({
                event: "press",
                pointers: 1,
                time: 251,
                threshold: 9
            }, e)) || this)._timer = null, i1._input = null, i1;
        }
        $g(e, t);
        var i1 = e.prototype;
        return i1.getTouchAction = function() {
            return [
                hy
            ];
        }, i1.process = function(t) {
            var e = this, i1 = this.options, n = t.pointers.length === i1.pointers, o = t.distance < i1.threshold, r = t.deltaTime > i1.time;
            if (this._input = t, !o || !n || t.eventType & (_y | xy) && !r) this.reset();
            else if (t.eventType & ky) this.reset(), this._timer = setTimeout(function() {
                e.state = 8, e.tryEmit();
            }, i1.time);
            else if (t.eventType & _y) return 8;
            return gb;
        }, i1.reset = function() {
            clearTimeout(this._timer);
        }, i1.emit = function(t) {
            8 === this.state && (t && t.eventType & _y ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = oy(), this.manager.emit(this.options.event, this._input)));
        }, e;
    }(kb), Ab = {
        domEvents: !1,
        touchAction: ly,
        enable: !0,
        inputTarget: null,
        inputClass: null,
        cssProps: {
            userSelect: "none",
            touchSelect: "none",
            touchCallout: "none",
            contentZooming: "none",
            userDrag: "none",
            tapHighlightColor: "rgba(0,0,0,0)"
        }
    }, Ib = [
        [
            Eb,
            {
                enable: !1
            }
        ],
        [
            Tb,
            {
                enable: !1
            },
            [
                "rotate"
            ]
        ],
        [
            Db,
            {
                direction: Oy
            }
        ],
        [
            Sb,
            {
                direction: Oy
            },
            [
                "swipe"
            ]
        ],
        [
            _b
        ],
        [
            _b,
            {
                event: "doubletap",
                taps: 2
            },
            [
                "tap"
            ]
        ],
        [
            Ob
        ]
    ];
    function Pb(t, e) {
        var i1, n = t.element;
        n.style && (Ny(t.options.cssProps, function(o, r) {
            i1 = ry(n.style, r), e ? (t.oldCssProps[i1] = n.style[i1], n.style[i1] = o) : n.style[i1] = t.oldCssProps[i1] || "";
        }), e || (t.oldCssProps = {}));
    }
    var Mb = function() {
        function t(t, e) {
            var i1, n = this;
            this.options = Jg({}, Ab, e || {}), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = t, this.input = new ((i1 = this).options.inputClass || (vy ? nb : gy ? ab : fy ? fb : ub))(i1, Uy), this.touchAction = new Ly(this, this.options.touchAction), Pb(this, !0), Ny(this.options.recognizers, function(t) {
                var e = n.add(new t[0](t[1]));
                t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3]);
            }, this);
        }
        var e = t.prototype;
        return e.set = function(t) {
            return Jg(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this;
        }, e.stop = function(t) {
            this.session.stopped = t ? 2 : 1;
        }, e.recognize = function(t) {
            var e = this.session;
            if (!e.stopped) {
                var i1;
                this.touchAction.preventDefaults(t);
                var n = this.recognizers, o = e.curRecognizer;
                (!o || o && 8 & o.state) && (e.curRecognizer = null, o = null);
                for(var r = 0; r < n.length;)i1 = n[r], 2 === e.stopped || o && i1 !== o && !i1.canRecognizeWith(o) ? i1.reset() : i1.recognize(t), !o && 14 & i1.state && (e.curRecognizer = i1, o = i1), r++;
            }
        }, e.get = function(t) {
            if (t instanceof kb) return t;
            for(var e = this.recognizers, i1 = 0; i1 < e.length; i1++)if (e[i1].options.event === t) return e[i1];
            return null;
        }, e.add = function(t) {
            if (vb(t, "add", this)) return this;
            var e = this.get(t.options.event);
            return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t;
        }, e.remove = function(t) {
            if (vb(t, "remove", this)) return this;
            var e = this.get(t);
            if (t) {
                var i1 = this.recognizers, n = Qy(i1, e);
                -1 !== n && (i1.splice(n, 1), this.touchAction.update());
            }
            return this;
        }, e.on = function(t, e) {
            if (void 0 === t || void 0 === e) return this;
            var i1 = this.handlers;
            return Ny(Xy(t), function(t) {
                i1[t] = i1[t] || [], i1[t].push(e);
            }), this;
        }, e.off = function(t, e) {
            if (void 0 === t) return this;
            var i1 = this.handlers;
            return Ny(Xy(t), function(t) {
                e ? i1[t] && i1[t].splice(Qy(i1[t], e), 1) : delete i1[t];
            }), this;
        }, e.emit = function(t, e) {
            this.options.domEvents && function(t, e) {
                var i1 = document.createEvent("Event");
                i1.initEvent(t, !0, !0), i1.gesture = e, e.target.dispatchEvent(i1);
            }(t, e);
            var i1 = this.handlers[t] && this.handlers[t].slice();
            if (i1 && i1.length) {
                e.type = t, e.preventDefault = function() {
                    e.srcEvent.preventDefault();
                };
                for(var n = 0; n < i1.length;)i1[n](e), n++;
            }
        }, e.destroy = function() {
            this.element && Pb(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
        }, t;
    }(), Nb = {
        touchstart: ky,
        touchmove: 2,
        touchend: _y,
        touchcancel: xy
    }, Fb = function(t) {
        function e() {
            var i1, n = e.prototype;
            return n.evTarget = "touchstart", n.evWin = "touchstart touchmove touchend touchcancel", (i1 = t.apply(this, arguments) || this).started = !1, i1;
        }
        return $g(e, t), e.prototype.handler = function(t) {
            var e = Nb[t.type];
            if (e === ky && (this.started = !0), this.started) {
                var i1 = Rb.call(this, t, e);
                e & (_y | xy) && i1[0].length - i1[1].length == 0 && (this.started = !1), this.callback(this.manager, e, {
                    pointers: i1[0],
                    changedPointers: i1[1],
                    pointerType: yy,
                    srcEvent: t
                });
            }
        }, e;
    }(Zy);
    function Rb(t, e) {
        var i1 = ob(t.touches), n = ob(t.changedTouches);
        return e & (_y | xy) && (i1 = rb(i1.concat(n), "identifier", !0)), [
            i1,
            n
        ];
    }
    function Lb(t, e, i1) {
        var n = "DEPRECATED METHOD: " + e + "\n" + i1 + " AT \n";
        return function() {
            var e = new Error("get-stack-trace"), i1 = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", o = window.console && (window.console.warn || window.console.log);
            return o && o.call(window.console, n, i1), t.apply(this, arguments);
        };
    }
    var jb = Lb(function(t, e, i1) {
        for(var n = Object.keys(e), o = 0; o < n.length;)(!i1 || i1 && void 0 === t[n[o]]) && (t[n[o]] = e[n[o]]), o++;
        return t;
    }, "extend", "Use `assign`."), Bb = Lb(function(t, e) {
        return jb(t, e, !0);
    }, "merge", "Use `assign`.");
    function zb(t, e, i1) {
        var n, o = e.prototype;
        (n = t.prototype = Object.create(o)).constructor = t, n._super = o, i1 && Jg(n, i1);
    }
    function Hb(t, e) {
        return function() {
            return t.apply(e, arguments);
        };
    }
    var Gb = function() {
        var t = function(t, e) {
            return void 0 === e && (e = {}), new Mb(t, Kg({
                recognizers: Ib.concat()
            }, e));
        };
        return t.VERSION = "2.0.17-rc", t.DIRECTION_ALL = Iy, t.DIRECTION_DOWN = Ey, t.DIRECTION_LEFT = Sy, t.DIRECTION_RIGHT = Dy, t.DIRECTION_UP = Ty, t.DIRECTION_HORIZONTAL = Oy, t.DIRECTION_VERTICAL = Ay, t.DIRECTION_NONE = Cy, t.DIRECTION_DOWN = Ey, t.INPUT_START = ky, t.INPUT_MOVE = 2, t.INPUT_END = _y, t.INPUT_CANCEL = xy, t.STATE_POSSIBLE = 1, t.STATE_BEGAN = 2, t.STATE_CHANGED = 4, t.STATE_ENDED = 8, t.STATE_RECOGNIZED = 8, t.STATE_CANCELLED = 16, t.STATE_FAILED = gb, t.Manager = Mb, t.Input = Zy, t.TouchAction = Ly, t.TouchInput = ab, t.MouseInput = ub, t.PointerEventInput = nb, t.TouchMouseInput = fb, t.SingleTouchInput = Fb, t.Recognizer = kb, t.AttrRecognizer = xb, t.Tap = _b, t.Pan = Sb, t.Swipe = Db, t.Pinch = Tb, t.Rotate = Eb, t.Press = Ob, t.on = qy, t.off = Ky, t.each = Ny, t.merge = Bb, t.extend = jb, t.bindFn = Hb, t.assign = Jg, t.inherit = zb, t.bindFn = Hb, t.prefixed = ry, t.toArray = ob, t.inArray = Qy, t.uniqueArray = rb, t.splitStr = Xy, t.boolOrFn = Fy, t.hasParent = jy, t.addEventListeners = qy, t.removeEventListeners = Ky, t.defaults = Jg({}, Ab, {
            preset: Ib
        }), t;
    }();
    Gb.defaults;
    var Wb = Gb;
    function Yb(t, e) {
        var i1 = void 0 !== lf && ym(t) || t["@@iterator"];
        if (!i1) {
            if (zc(t) || (i1 = function(t, e) {
                var i1;
                if (!t) return;
                if ("string" == typeof t) return Vb(t, e);
                var n = ff(i1 = Object.prototype.toString.call(t)).call(i1, 8, -1);
                "Object" === n && t.constructor && (n = t.constructor.name);
                if ("Map" === n || "Set" === n) return fm(t);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Vb(t, e);
            }(t)) || e && t && "number" == typeof t.length) {
                i1 && (t = i1);
                var n = 0, o = function() {};
                return {
                    s: o,
                    n: function() {
                        return n >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[n++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: o
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var r, s = !0, a = !1;
        return {
            s: function() {
                i1 = i1.call(t);
            },
            n: function() {
                var t = i1.next();
                return s = t.done, t;
            },
            e: function(t) {
                a = !0, r = t;
            },
            f: function() {
                try {
                    s || null == i1.return || i1.return();
                } finally{
                    if (a) throw r;
                }
            }
        };
    }
    function Vb(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var i1 = 0, n = new Array(e); i1 < e; i1++)n[i1] = t[i1];
        return n;
    }
    var Ub = lf("DELETE");
    function Xb() {
        var t = qb.apply(void 0, arguments);
        return $b(t), t;
    }
    function qb() {
        for(var t = arguments.length, e = new Array(t), i1 = 0; i1 < t; i1++)e[i1] = arguments[i1];
        if (e.length < 2) return e[0];
        var n;
        if (e.length > 2) return qb.apply(void 0, mf(n = [
            Xb(e[0], e[1])
        ]).call(n, af(ff(e).call(e, 2))));
        var o = e[0], r = e[1];
        if (o instanceof Date && r instanceof Date) return o.setTime(r.getTime()), o;
        var s, a = Yb(vf(r));
        try {
            for(a.s(); !(s = a.n()).done;){
                var l = s.value;
                Object.prototype.propertyIsEnumerable.call(r, l) && (r[l] === Ub ? delete o[l] : null === o[l] || null === r[l] || "object" !== uc(o[l]) || "object" !== uc(r[l]) || zc(o[l]) || zc(r[l]) ? o[l] = Kb(r[l]) : o[l] = qb(o[l], r[l]));
            }
        } catch (t) {
            a.e(t);
        } finally{
            a.f();
        }
        return o;
    }
    function Kb(t) {
        return zc(t) ? lp(t).call(t, function(t) {
            return Kb(t);
        }) : "object" === uc(t) && null !== t ? t instanceof Date ? new Date(t.getTime()) : qb({}, t) : t;
    }
    function $b(t) {
        for(var e = 0, i1 = Dp(t); e < i1.length; e++){
            var n = i1[e];
            t[n] === Ub ? delete t[n] : "object" === uc(t[n]) && null !== t[n] && $b(t[n]);
        }
    }
    var Zb = "undefined" != typeof window ? window.Hammer || Wb : function() {
        return function() {
            var t = function() {};
            return {
                on: t,
                off: t,
                destroy: t,
                emit: t,
                get: function() {
                    return {
                        set: t
                    };
                }
            };
        }();
    };
    function Qb(t) {
        var e, i1 = this;
        this._cleanupQueue = [], this.active = !1, this._dom = {
            container: t,
            overlay: document.createElement("div")
        }, this._dom.overlay.classList.add("vis-overlay"), this._dom.container.appendChild(this._dom.overlay), this._cleanupQueue.push(function() {
            i1._dom.overlay.parentNode.removeChild(i1._dom.overlay);
        });
        var n = Zb(this._dom.overlay);
        n.on("tap", Hc(e = this._onTapOverlay).call(e, this)), this._cleanupQueue.push(function() {
            n.destroy();
        });
        var o = [
            "tap",
            "doubletap",
            "press",
            "pinch",
            "pan",
            "panstart",
            "panmove",
            "panend"
        ];
        bd(o).call(o, function(t) {
            n.on(t, function(t) {
                t.srcEvent.stopPropagation();
            });
        }), document && document.body && (this._onClick = function(e) {
            (function(t, e) {
                for(; t;){
                    if (t === e) return !0;
                    t = t.parentNode;
                }
                return !1;
            })(e.target, t) || i1.deactivate();
        }, document.body.addEventListener("click", this._onClick), this._cleanupQueue.push(function() {
            document.body.removeEventListener("click", i1._onClick);
        })), this._escListener = function(t) {
            ("key" in t ? "Escape" === t.key : 27 === t.keyCode) && i1.deactivate();
        };
    }
    qg(Qb.prototype), Qb.current = null, Qb.prototype.destroy = function() {
        var t, e;
        this.deactivate();
        var i1, n = Yb(Af(t = Qf(e = this._cleanupQueue).call(e, 0)).call(t));
        try {
            for(n.s(); !(i1 = n.n()).done;)(0, i1.value)();
        } catch (t) {
            n.e(t);
        } finally{
            n.f();
        }
    }, Qb.prototype.activate = function() {
        Qb.current && Qb.current.deactivate(), Qb.current = this, this.active = !0, this._dom.overlay.style.display = "none", this._dom.container.classList.add("vis-active"), this.emit("change"), this.emit("activate"), document.body.addEventListener("keydown", this._escListener);
    }, Qb.prototype.deactivate = function() {
        this.active = !1, this._dom.overlay.style.display = "block", this._dom.container.classList.remove("vis-active"), document.body.removeEventListener("keydown", this._escListener), this.emit("change"), this.emit("deactivate");
    }, Qb.prototype._onTapOverlay = function(t) {
        this.activate(), t.srcEvent.stopPropagation();
    };
    var Jb = /^\/?Date\((-?\d+)/i, tw = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, ew = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, iw = /^rgb\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *\)$/i, nw = /^rgba\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *([01]|0?\.\d+) *\)$/i;
    function ow(t) {
        return t instanceof Number || "number" == typeof t;
    }
    function rw(t) {
        return t instanceof String || "string" == typeof t;
    }
    function sw(t) {
        return "object" === uc(t) && null !== t;
    }
    function aw(t, e, i1, n) {
        var o = !1;
        !0 === n && (o = null === e[i1] && void 0 !== t[i1]), o ? delete t[i1] : t[i1] = e[i1];
    }
    var lw = pv;
    function hw(t, e) {
        var i1 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
        for(var o in e)if (Object.prototype.hasOwnProperty.call(e, o) || !0 === i1) {
            if ("object" === uc(e[o]) && null !== e[o] && Rv(e[o]) === Object.prototype) void 0 === t[o] ? t[o] = hw({}, e[o], i1) : "object" === uc(t[o]) && null !== t[o] && Rv(t[o]) === Object.prototype ? hw(t[o], e[o], i1) : aw(t, e, o, n);
            else if (zc(e[o])) {
                var r;
                t[o] = ff(r = e[o]).call(r);
            } else aw(t, e, o, n);
        }
        return t;
    }
    function uw(t) {
        var e = uc(t);
        return "object" === e ? null === t ? "null" : t instanceof Boolean ? "Boolean" : t instanceof Number ? "Number" : t instanceof String ? "String" : zc(t) ? "Array" : t instanceof Date ? "Date" : "Object" : "number" === e ? "Number" : "boolean" === e ? "Boolean" : "string" === e ? "String" : void 0 === e ? "undefined" : e;
    }
    function cw(t, e) {
        var i1;
        return mf(i1 = []).call(i1, af(t), [
            e
        ]);
    }
    function dw(t) {
        return ff(t).call(t);
    }
    var pw = Kv;
    var mw = {
        asBoolean: function(t, e) {
            return "function" == typeof t && (t = t()), null != t ? 0 != t : e || null;
        },
        asNumber: function(t, e) {
            return "function" == typeof t && (t = t()), null != t ? Number(t) || e || null : e || null;
        },
        asString: function(t, e) {
            return "function" == typeof t && (t = t()), null != t ? String(t) : e || null;
        },
        asSize: function(t, e) {
            return "function" == typeof t && (t = t()), rw(t) ? t : ow(t) ? t + "px" : e || null;
        },
        asElement: function(t, e) {
            return "function" == typeof t && (t = t()), t || e || null;
        }
    };
    function fw(t) {
        var e;
        switch(t.length){
            case 3:
            case 4:
                return (e = ew.exec(t)) ? {
                    r: gg(e[1] + e[1], 16),
                    g: gg(e[2] + e[2], 16),
                    b: gg(e[3] + e[3], 16)
                } : null;
            case 6:
            case 7:
                return (e = tw.exec(t)) ? {
                    r: gg(e[1], 16),
                    g: gg(e[2], 16),
                    b: gg(e[3], 16)
                } : null;
            default:
                return null;
        }
    }
    function vw(t, e, i1) {
        var n;
        return "#" + ff(n = (16777216 + (t << 16) + (e << 8) + i1).toString(16)).call(n, 1);
    }
    function gw(t, e, i1) {
        t /= 255, e /= 255, i1 /= 255;
        var n = Math.min(t, Math.min(e, i1)), o = Math.max(t, Math.max(e, i1));
        return n === o ? {
            h: 0,
            s: 0,
            v: n
        } : {
            h: 60 * ((t === n ? 3 : i1 === n ? 1 : 5) - (t === n ? e - i1 : i1 === n ? t - e : i1 - t) / (o - n)) / 360,
            s: (o - n) / o,
            v: o
        };
    }
    function yw(t) {
        var e = document.createElement("div"), i1 = {};
        e.style.cssText = t;
        for(var n = 0; n < e.style.length; ++n)i1[e.style[n]] = e.style.getPropertyValue(e.style[n]);
        return i1;
    }
    function bw(t, e, i1) {
        var n, o, r, s = Math.floor(6 * t), a = 6 * t - s, l = i1 * (1 - e), h = i1 * (1 - a * e), u = i1 * (1 - (1 - a) * e);
        switch(s % 6){
            case 0:
                n = i1, o = u, r = l;
                break;
            case 1:
                n = h, o = i1, r = l;
                break;
            case 2:
                n = l, o = i1, r = u;
                break;
            case 3:
                n = l, o = h, r = i1;
                break;
            case 4:
                n = u, o = l, r = i1;
                break;
            case 5:
                n = i1, o = l, r = h;
        }
        return {
            r: Math.floor(255 * n),
            g: Math.floor(255 * o),
            b: Math.floor(255 * r)
        };
    }
    function ww(t, e, i1) {
        var n = bw(t, e, i1);
        return vw(n.r, n.g, n.b);
    }
    function kw(t) {
        var e = fw(t);
        if (!e) throw new TypeError("'".concat(t, "' is not a valid color."));
        return gw(e.r, e.g, e.b);
    }
    function _w(t) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
    }
    function xw(t) {
        return iw.test(t);
    }
    function Cw(t) {
        return nw.test(t);
    }
    function Sw(t) {
        if (null === t || "object" !== uc(t)) return null;
        if (t instanceof Element) return t;
        var e = Ig(t);
        for(var i1 in t)Object.prototype.hasOwnProperty.call(t, i1) && "object" == uc(t[i1]) && (e[i1] = Sw(t[i1]));
        return e;
    }
    var Dw = {
        black: "#000000",
        navy: "#000080",
        darkblue: "#00008B",
        mediumblue: "#0000CD",
        blue: "#0000FF",
        darkgreen: "#006400",
        green: "#008000",
        teal: "#008080",
        darkcyan: "#008B8B",
        deepskyblue: "#00BFFF",
        darkturquoise: "#00CED1",
        mediumspringgreen: "#00FA9A",
        lime: "#00FF00",
        springgreen: "#00FF7F",
        aqua: "#00FFFF",
        cyan: "#00FFFF",
        midnightblue: "#191970",
        dodgerblue: "#1E90FF",
        lightseagreen: "#20B2AA",
        forestgreen: "#228B22",
        seagreen: "#2E8B57",
        darkslategray: "#2F4F4F",
        limegreen: "#32CD32",
        mediumseagreen: "#3CB371",
        turquoise: "#40E0D0",
        royalblue: "#4169E1",
        steelblue: "#4682B4",
        darkslateblue: "#483D8B",
        mediumturquoise: "#48D1CC",
        indigo: "#4B0082",
        darkolivegreen: "#556B2F",
        cadetblue: "#5F9EA0",
        cornflowerblue: "#6495ED",
        mediumaquamarine: "#66CDAA",
        dimgray: "#696969",
        slateblue: "#6A5ACD",
        olivedrab: "#6B8E23",
        slategray: "#708090",
        lightslategray: "#778899",
        mediumslateblue: "#7B68EE",
        lawngreen: "#7CFC00",
        chartreuse: "#7FFF00",
        aquamarine: "#7FFFD4",
        maroon: "#800000",
        purple: "#800080",
        olive: "#808000",
        gray: "#808080",
        skyblue: "#87CEEB",
        lightskyblue: "#87CEFA",
        blueviolet: "#8A2BE2",
        darkred: "#8B0000",
        darkmagenta: "#8B008B",
        saddlebrown: "#8B4513",
        darkseagreen: "#8FBC8F",
        lightgreen: "#90EE90",
        mediumpurple: "#9370D8",
        darkviolet: "#9400D3",
        palegreen: "#98FB98",
        darkorchid: "#9932CC",
        yellowgreen: "#9ACD32",
        sienna: "#A0522D",
        brown: "#A52A2A",
        darkgray: "#A9A9A9",
        lightblue: "#ADD8E6",
        greenyellow: "#ADFF2F",
        paleturquoise: "#AFEEEE",
        lightsteelblue: "#B0C4DE",
        powderblue: "#B0E0E6",
        firebrick: "#B22222",
        darkgoldenrod: "#B8860B",
        mediumorchid: "#BA55D3",
        rosybrown: "#BC8F8F",
        darkkhaki: "#BDB76B",
        silver: "#C0C0C0",
        mediumvioletred: "#C71585",
        indianred: "#CD5C5C",
        peru: "#CD853F",
        chocolate: "#D2691E",
        tan: "#D2B48C",
        lightgrey: "#D3D3D3",
        palevioletred: "#D87093",
        thistle: "#D8BFD8",
        orchid: "#DA70D6",
        goldenrod: "#DAA520",
        crimson: "#DC143C",
        gainsboro: "#DCDCDC",
        plum: "#DDA0DD",
        burlywood: "#DEB887",
        lightcyan: "#E0FFFF",
        lavender: "#E6E6FA",
        darksalmon: "#E9967A",
        violet: "#EE82EE",
        palegoldenrod: "#EEE8AA",
        lightcoral: "#F08080",
        khaki: "#F0E68C",
        aliceblue: "#F0F8FF",
        honeydew: "#F0FFF0",
        azure: "#F0FFFF",
        sandybrown: "#F4A460",
        wheat: "#F5DEB3",
        beige: "#F5F5DC",
        whitesmoke: "#F5F5F5",
        mintcream: "#F5FFFA",
        ghostwhite: "#F8F8FF",
        salmon: "#FA8072",
        antiquewhite: "#FAEBD7",
        linen: "#FAF0E6",
        lightgoldenrodyellow: "#FAFAD2",
        oldlace: "#FDF5E6",
        red: "#FF0000",
        fuchsia: "#FF00FF",
        magenta: "#FF00FF",
        deeppink: "#FF1493",
        orangered: "#FF4500",
        tomato: "#FF6347",
        hotpink: "#FF69B4",
        coral: "#FF7F50",
        darkorange: "#FF8C00",
        lightsalmon: "#FFA07A",
        orange: "#FFA500",
        lightpink: "#FFB6C1",
        pink: "#FFC0CB",
        gold: "#FFD700",
        peachpuff: "#FFDAB9",
        navajowhite: "#FFDEAD",
        moccasin: "#FFE4B5",
        bisque: "#FFE4C4",
        mistyrose: "#FFE4E1",
        blanchedalmond: "#FFEBCD",
        papayawhip: "#FFEFD5",
        lavenderblush: "#FFF0F5",
        seashell: "#FFF5EE",
        cornsilk: "#FFF8DC",
        lemonchiffon: "#FFFACD",
        floralwhite: "#FFFAF0",
        snow: "#FFFAFA",
        yellow: "#FFFF00",
        lightyellow: "#FFFFE0",
        ivory: "#FFFFF0",
        white: "#FFFFFF"
    }, Tw = function() {
        function t() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
            Lo(this, t), this.pixelRatio = e, this.generated = !1, this.centerCoordinates = {
                x: 144.5,
                y: 144.5
            }, this.r = 289 * .49, this.color = {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }, this.hueCircle = void 0, this.initialColor = {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }, this.previousColor = void 0, this.applied = !1, this.updateCallback = function() {}, this.closeCallback = function() {}, this._create();
        }
        return mc(t, [
            {
                key: "insertTo",
                value: function(t) {
                    void 0 !== this.hammer && (this.hammer.destroy(), this.hammer = void 0), this.container = t, this.container.appendChild(this.frame), this._bindHammer(), this._setSize();
                }
            },
            {
                key: "setUpdateCallback",
                value: function(t) {
                    if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker update callback is not a function.");
                    this.updateCallback = t;
                }
            },
            {
                key: "setCloseCallback",
                value: function(t) {
                    if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
                    this.closeCallback = t;
                }
            },
            {
                key: "_isColorString",
                value: function(t) {
                    if ("string" == typeof t) return Dw[t];
                }
            },
            {
                key: "setColor",
                value: function(t) {
                    var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    if ("none" !== t) {
                        var i1, n = this._isColorString(t);
                        if (void 0 !== n && (t = n), !0 === rw(t)) {
                            if (!0 === xw(t)) {
                                var o = t.substr(4).substr(0, t.length - 5).split(",");
                                i1 = {
                                    r: o[0],
                                    g: o[1],
                                    b: o[2],
                                    a: 1
                                };
                            } else if (!0 === Cw(t)) {
                                var r = t.substr(5).substr(0, t.length - 6).split(",");
                                i1 = {
                                    r: r[0],
                                    g: r[1],
                                    b: r[2],
                                    a: r[3]
                                };
                            } else if (!0 === _w(t)) {
                                var s = fw(t);
                                i1 = {
                                    r: s.r,
                                    g: s.g,
                                    b: s.b,
                                    a: 1
                                };
                            }
                        } else if (t instanceof Object && void 0 !== t.r && void 0 !== t.g && void 0 !== t.b) {
                            var a = void 0 !== t.a ? t.a : "1.0";
                            i1 = {
                                r: t.r,
                                g: t.g,
                                b: t.b,
                                a: a
                            };
                        }
                        if (void 0 === i1) throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + Fg(t));
                        this._setColor(i1, e);
                    }
                }
            },
            {
                key: "show",
                value: function() {
                    void 0 !== this.closeCallback && (this.closeCallback(), this.closeCallback = void 0), this.applied = !1, this.frame.style.display = "block", this._generateHueCircle();
                }
            },
            {
                key: "_hide",
                value: function() {
                    var t = this;
                    !0 === (!(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]) && (this.previousColor = pv({}, this.color)), !0 === this.applied && this.updateCallback(this.initialColor), this.frame.style.display = "none", sd(function() {
                        void 0 !== t.closeCallback && (t.closeCallback(), t.closeCallback = void 0);
                    }, 0);
                }
            },
            {
                key: "_save",
                value: function() {
                    this.updateCallback(this.color), this.applied = !1, this._hide();
                }
            },
            {
                key: "_apply",
                value: function() {
                    this.applied = !0, this.updateCallback(this.color), this._updatePicker(this.color);
                }
            },
            {
                key: "_loadLast",
                value: function() {
                    void 0 !== this.previousColor ? this.setColor(this.previousColor, !1) : alert("There is no last color to load...");
                }
            },
            {
                key: "_setColor",
                value: function(t) {
                    !0 === (!(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]) && (this.initialColor = pv({}, t)), this.color = t;
                    var e = gw(t.r, t.g, t.b), i1 = 2 * Math.PI, n = this.r * e.s, o = this.centerCoordinates.x + n * Math.sin(i1 * e.h), r = this.centerCoordinates.y + n * Math.cos(i1 * e.h);
                    this.colorPickerSelector.style.left = o - .5 * this.colorPickerSelector.clientWidth + "px", this.colorPickerSelector.style.top = r - .5 * this.colorPickerSelector.clientHeight + "px", this._updatePicker(t);
                }
            },
            {
                key: "_setOpacity",
                value: function(t) {
                    this.color.a = t / 100, this._updatePicker(this.color);
                }
            },
            {
                key: "_setBrightness",
                value: function(t) {
                    var e = gw(this.color.r, this.color.g, this.color.b);
                    e.v = t / 100;
                    var i1 = bw(e.h, e.s, e.v);
                    i1.a = this.color.a, this.color = i1, this._updatePicker();
                }
            },
            {
                key: "_updatePicker",
                value: function() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.color, e = gw(t.r, t.g, t.b), i1 = this.colorPickerCanvas.getContext("2d");
                    void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (i1.webkitBackingStorePixelRatio || i1.mozBackingStorePixelRatio || i1.msBackingStorePixelRatio || i1.oBackingStorePixelRatio || i1.backingStorePixelRatio || 1)), i1.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                    var n = this.colorPickerCanvas.clientWidth, o = this.colorPickerCanvas.clientHeight;
                    i1.clearRect(0, 0, n, o), i1.putImageData(this.hueCircle, 0, 0), i1.fillStyle = "rgba(0,0,0," + (1 - e.v) + ")", i1.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), Vg(i1).call(i1), this.brightnessRange.value = 100 * e.v, this.opacityRange.value = 100 * t.a, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
                }
            },
            {
                key: "_setSize",
                value: function() {
                    this.colorPickerCanvas.style.width = "100%", this.colorPickerCanvas.style.height = "100%", this.colorPickerCanvas.width = 289 * this.pixelRatio, this.colorPickerCanvas.height = 289 * this.pixelRatio;
                }
            },
            {
                key: "_create",
                value: function() {
                    var t, e, i1, n;
                    if (this.frame = document.createElement("div"), this.frame.className = "vis-color-picker", this.colorPickerDiv = document.createElement("div"), this.colorPickerSelector = document.createElement("div"), this.colorPickerSelector.className = "vis-selector", this.colorPickerDiv.appendChild(this.colorPickerSelector), this.colorPickerCanvas = document.createElement("canvas"), this.colorPickerDiv.appendChild(this.colorPickerCanvas), this.colorPickerCanvas.getContext) {
                        var o = this.colorPickerCanvas.getContext("2d");
                        this.pixelRatio = (window.devicePixelRatio || 1) / (o.webkitBackingStorePixelRatio || o.mozBackingStorePixelRatio || o.msBackingStorePixelRatio || o.oBackingStorePixelRatio || o.backingStorePixelRatio || 1), this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                    } else {
                        var r = document.createElement("DIV");
                        r.style.color = "red", r.style.fontWeight = "bold", r.style.padding = "10px", r.innerText = "Error: your browser does not support HTML canvas", this.colorPickerCanvas.appendChild(r);
                    }
                    this.colorPickerDiv.className = "vis-color", this.opacityDiv = document.createElement("div"), this.opacityDiv.className = "vis-opacity", this.brightnessDiv = document.createElement("div"), this.brightnessDiv.className = "vis-brightness", this.arrowDiv = document.createElement("div"), this.arrowDiv.className = "vis-arrow", this.opacityRange = document.createElement("input");
                    try {
                        this.opacityRange.type = "range", this.opacityRange.min = "0", this.opacityRange.max = "100";
                    } catch (t) {}
                    this.opacityRange.value = "100", this.opacityRange.className = "vis-range", this.brightnessRange = document.createElement("input");
                    try {
                        this.brightnessRange.type = "range", this.brightnessRange.min = "0", this.brightnessRange.max = "100";
                    } catch (t) {}
                    this.brightnessRange.value = "100", this.brightnessRange.className = "vis-range", this.opacityDiv.appendChild(this.opacityRange), this.brightnessDiv.appendChild(this.brightnessRange);
                    var s = this;
                    this.opacityRange.onchange = function() {
                        s._setOpacity(this.value);
                    }, this.opacityRange.oninput = function() {
                        s._setOpacity(this.value);
                    }, this.brightnessRange.onchange = function() {
                        s._setBrightness(this.value);
                    }, this.brightnessRange.oninput = function() {
                        s._setBrightness(this.value);
                    }, this.brightnessLabel = document.createElement("div"), this.brightnessLabel.className = "vis-label vis-brightness", this.brightnessLabel.innerText = "brightness:", this.opacityLabel = document.createElement("div"), this.opacityLabel.className = "vis-label vis-opacity", this.opacityLabel.innerText = "opacity:", this.newColorDiv = document.createElement("div"), this.newColorDiv.className = "vis-new-color", this.newColorDiv.innerText = "new", this.initialColorDiv = document.createElement("div"), this.initialColorDiv.className = "vis-initial-color", this.initialColorDiv.innerText = "initial", this.cancelButton = document.createElement("div"), this.cancelButton.className = "vis-button vis-cancel", this.cancelButton.innerText = "cancel", this.cancelButton.onclick = Hc(t = this._hide).call(t, this, !1), this.applyButton = document.createElement("div"), this.applyButton.className = "vis-button vis-apply", this.applyButton.innerText = "apply", this.applyButton.onclick = Hc(e = this._apply).call(e, this), this.saveButton = document.createElement("div"), this.saveButton.className = "vis-button vis-save", this.saveButton.innerText = "save", this.saveButton.onclick = Hc(i1 = this._save).call(i1, this), this.loadButton = document.createElement("div"), this.loadButton.className = "vis-button vis-load", this.loadButton.innerText = "load last", this.loadButton.onclick = Hc(n = this._loadLast).call(n, this), this.frame.appendChild(this.colorPickerDiv), this.frame.appendChild(this.arrowDiv), this.frame.appendChild(this.brightnessLabel), this.frame.appendChild(this.brightnessDiv), this.frame.appendChild(this.opacityLabel), this.frame.appendChild(this.opacityDiv), this.frame.appendChild(this.newColorDiv), this.frame.appendChild(this.initialColorDiv), this.frame.appendChild(this.cancelButton), this.frame.appendChild(this.applyButton), this.frame.appendChild(this.saveButton), this.frame.appendChild(this.loadButton);
                }
            },
            {
                key: "_bindHammer",
                value: function() {
                    var t = this;
                    this.drag = {}, this.pinch = {}, this.hammer = new Zb(this.colorPickerCanvas), this.hammer.get("pinch").set({
                        enable: !0
                    }), this.hammer.on("hammer.input", function(e) {
                        e.isFirst && t._moveSelector(e);
                    }), this.hammer.on("tap", function(e) {
                        t._moveSelector(e);
                    }), this.hammer.on("panstart", function(e) {
                        t._moveSelector(e);
                    }), this.hammer.on("panmove", function(e) {
                        t._moveSelector(e);
                    }), this.hammer.on("panend", function(e) {
                        t._moveSelector(e);
                    });
                }
            },
            {
                key: "_generateHueCircle",
                value: function() {
                    if (!1 === this.generated) {
                        var t = this.colorPickerCanvas.getContext("2d");
                        void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1)), t.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                        var e, i1, n, o, r = this.colorPickerCanvas.clientWidth, s = this.colorPickerCanvas.clientHeight;
                        t.clearRect(0, 0, r, s), this.centerCoordinates = {
                            x: .5 * r,
                            y: .5 * s
                        }, this.r = .49 * r;
                        var a, l = 2 * Math.PI / 360, h = 1 / this.r;
                        for(n = 0; n < 360; n++)for(o = 0; o < this.r; o++)e = this.centerCoordinates.x + o * Math.sin(l * n), i1 = this.centerCoordinates.y + o * Math.cos(l * n), a = bw(.002777777777777778 * n, o * h, 1), t.fillStyle = "rgb(" + a.r + "," + a.g + "," + a.b + ")", t.fillRect(e - .5, i1 - .5, 2, 2);
                        t.strokeStyle = "rgba(0,0,0,1)", t.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), t.stroke(), this.hueCircle = t.getImageData(0, 0, r, s);
                    }
                    this.generated = !0;
                }
            },
            {
                key: "_moveSelector",
                value: function(t) {
                    var e = this.colorPickerDiv.getBoundingClientRect(), i1 = t.center.x - e.left, n = t.center.y - e.top, o = .5 * this.colorPickerDiv.clientHeight, r = .5 * this.colorPickerDiv.clientWidth, s = i1 - r, a = n - o, l = Math.atan2(s, a), h = .98 * Math.min(Math.sqrt(s * s + a * a), r), u = Math.cos(l) * h + o, c = Math.sin(l) * h + r;
                    this.colorPickerSelector.style.top = u - .5 * this.colorPickerSelector.clientHeight + "px", this.colorPickerSelector.style.left = c - .5 * this.colorPickerSelector.clientWidth + "px";
                    var d = l / (2 * Math.PI);
                    d = d < 0 ? d + 1 : d;
                    var p = h / this.r, m = gw(this.color.r, this.color.g, this.color.b);
                    m.h = d, m.s = p;
                    var f = bw(m.h, m.s, m.v);
                    f.a = this.color.a, this.color = f, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
                }
            }
        ]), t;
    }();
    function Ew() {
        for(var t = arguments.length, e = new Array(t), i1 = 0; i1 < t; i1++)e[i1] = arguments[i1];
        if (e.length < 1) throw new TypeError("Invalid arguments.");
        if (1 === e.length) return document.createTextNode(e[0]);
        var n = document.createElement(e[0]);
        return n.appendChild(Ew.apply(void 0, af(ff(e).call(e, 1)))), n;
    }
    var Ow, Aw = function() {
        function t(e, i1, n) {
            var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : function() {
                return !1;
            };
            Lo(this, t), this.parent = e, this.changedOptions = [], this.container = i1, this.allowCreation = !1, this.hideOption = r, this.options = {}, this.initialized = !1, this.popupCounter = 0, this.defaultOptions = {
                enabled: !1,
                filter: !0,
                container: void 0,
                showButton: !0
            }, pv(this.options, this.defaultOptions), this.configureOptions = n, this.moduleOptions = {}, this.domElements = [], this.popupDiv = {}, this.popupLimit = 5, this.popupHistory = {}, this.colorPicker = new Tw(o), this.wrapper = void 0;
        }
        return mc(t, [
            {
                key: "setOptions",
                value: function(t) {
                    if (void 0 !== t) {
                        this.popupHistory = {}, this._removePopup();
                        var e = !0;
                        if ("string" == typeof t) this.options.filter = t;
                        else if (zc(t)) this.options.filter = t.join();
                        else if ("object" === uc(t)) {
                            if (null == t) throw new TypeError("options cannot be null");
                            void 0 !== t.container && (this.options.container = t.container), void 0 !== Ed(t) && (this.options.filter = Ed(t)), void 0 !== t.showButton && (this.options.showButton = t.showButton), void 0 !== t.enabled && (e = t.enabled);
                        } else "boolean" == typeof t ? (this.options.filter = !0, e = t) : "function" == typeof t && (this.options.filter = t, e = !0);
                        !1 === Ed(this.options) && (e = !1), this.options.enabled = e;
                    }
                    this._clean();
                }
            },
            {
                key: "setModuleOptions",
                value: function(t) {
                    this.moduleOptions = t, !0 === this.options.enabled && (this._clean(), void 0 !== this.options.container && (this.container = this.options.container), this._create());
                }
            },
            {
                key: "_create",
                value: function() {
                    this._clean(), this.changedOptions = [];
                    var t = Ed(this.options), e = 0, i1 = !1;
                    for(var n in this.configureOptions)Object.prototype.hasOwnProperty.call(this.configureOptions, n) && (this.allowCreation = !1, i1 = !1, "function" == typeof t ? i1 = (i1 = t(n, [])) || this._handleObject(this.configureOptions[n], [
                        n
                    ], !0) : !0 !== t && -1 === Eg(t).call(t, n) || (i1 = !0), !1 !== i1 && (this.allowCreation = !0, e > 0 && this._makeItem([]), this._makeHeader(n), this._handleObject(this.configureOptions[n], [
                        n
                    ])), e++);
                    this._makeButton(), this._push();
                }
            },
            {
                key: "_push",
                value: function() {
                    this.wrapper = document.createElement("div"), this.wrapper.className = "vis-configuration-wrapper", this.container.appendChild(this.wrapper);
                    for(var t = 0; t < this.domElements.length; t++)this.wrapper.appendChild(this.domElements[t]);
                    this._showPopupIfNeeded();
                }
            },
            {
                key: "_clean",
                value: function() {
                    for(var t = 0; t < this.domElements.length; t++)this.wrapper.removeChild(this.domElements[t]);
                    void 0 !== this.wrapper && (this.container.removeChild(this.wrapper), this.wrapper = void 0), this.domElements = [], this._removePopup();
                }
            },
            {
                key: "_getValue",
                value: function(t) {
                    for(var e = this.moduleOptions, i1 = 0; i1 < t.length; i1++){
                        if (void 0 === e[t[i1]]) {
                            e = void 0;
                            break;
                        }
                        e = e[t[i1]];
                    }
                    return e;
                }
            },
            {
                key: "_makeItem",
                value: function(t) {
                    if (!0 === this.allowCreation) {
                        var e = document.createElement("div");
                        e.className = "vis-configuration vis-config-item vis-config-s" + t.length;
                        for(var i1 = arguments.length, n = new Array(i1 > 1 ? i1 - 1 : 0), o = 1; o < i1; o++)n[o - 1] = arguments[o];
                        return bd(n).call(n, function(t) {
                            e.appendChild(t);
                        }), this.domElements.push(e), this.domElements.length;
                    }
                    return 0;
                }
            },
            {
                key: "_makeHeader",
                value: function(t) {
                    var e = document.createElement("div");
                    e.className = "vis-configuration vis-config-header", e.innerText = t, this._makeItem([], e);
                }
            },
            {
                key: "_makeLabel",
                value: function(t, e) {
                    var i1 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = document.createElement("div");
                    if (n.className = "vis-configuration vis-config-label vis-config-s" + e.length, !0 === i1) {
                        for(; n.firstChild;)n.removeChild(n.firstChild);
                        n.appendChild(Ew("i", "b", t));
                    } else n.innerText = t + ":";
                    return n;
                }
            },
            {
                key: "_makeDropdown",
                value: function(t, e, i1) {
                    var n = document.createElement("select");
                    n.className = "vis-configuration vis-config-select";
                    var o = 0;
                    void 0 !== e && -1 !== Eg(t).call(t, e) && (o = Eg(t).call(t, e));
                    for(var r = 0; r < t.length; r++){
                        var s = document.createElement("option");
                        s.value = t[r], r === o && (s.selected = "selected"), s.innerText = t[r], n.appendChild(s);
                    }
                    var a = this;
                    n.onchange = function() {
                        a._update(this.value, i1);
                    };
                    var l = this._makeLabel(i1[i1.length - 1], i1);
                    this._makeItem(i1, l, n);
                }
            },
            {
                key: "_makeRange",
                value: function(t, e, i1) {
                    var n = t[0], o = t[1], r = t[2], s = t[3], a = document.createElement("input");
                    a.className = "vis-configuration vis-config-range";
                    try {
                        a.type = "range", a.min = o, a.max = r;
                    } catch (t) {}
                    a.step = s;
                    var l = "", h = 0;
                    if (void 0 !== e) {
                        var u = 1.2;
                        e < 0 && e * u < o ? (a.min = Math.ceil(e * u), h = a.min, l = "range increased") : e / u < o && (a.min = Math.ceil(e / u), h = a.min, l = "range increased"), e * u > r && 1 !== r && (a.max = Math.ceil(e * u), h = a.max, l = "range increased"), a.value = e;
                    } else a.value = n;
                    var c = document.createElement("input");
                    c.className = "vis-configuration vis-config-rangeinput", c.value = a.value;
                    var d = this;
                    a.onchange = function() {
                        c.value = this.value, d._update(Number(this.value), i1);
                    }, a.oninput = function() {
                        c.value = this.value;
                    };
                    var p = this._makeLabel(i1[i1.length - 1], i1), m = this._makeItem(i1, p, a, c);
                    "" !== l && this.popupHistory[m] !== h && (this.popupHistory[m] = h, this._setupPopup(l, m));
                }
            },
            {
                key: "_makeButton",
                value: function() {
                    var t = this;
                    if (!0 === this.options.showButton) {
                        var e = document.createElement("div");
                        e.className = "vis-configuration vis-config-button", e.innerText = "generate options", e.onclick = function() {
                            t._printOptions();
                        }, e.onmouseover = function() {
                            e.className = "vis-configuration vis-config-button hover";
                        }, e.onmouseout = function() {
                            e.className = "vis-configuration vis-config-button";
                        }, this.optionsContainer = document.createElement("div"), this.optionsContainer.className = "vis-configuration vis-config-option-container", this.domElements.push(this.optionsContainer), this.domElements.push(e);
                    }
                }
            },
            {
                key: "_setupPopup",
                value: function(t, e) {
                    var i1 = this;
                    if (!0 === this.initialized && !0 === this.allowCreation && this.popupCounter < this.popupLimit) {
                        var n = document.createElement("div");
                        n.id = "vis-configuration-popup", n.className = "vis-configuration-popup", n.innerText = t, n.onclick = function() {
                            i1._removePopup();
                        }, this.popupCounter += 1, this.popupDiv = {
                            html: n,
                            index: e
                        };
                    }
                }
            },
            {
                key: "_removePopup",
                value: function() {
                    void 0 !== this.popupDiv.html && (this.popupDiv.html.parentNode.removeChild(this.popupDiv.html), clearTimeout(this.popupDiv.hideTimeout), clearTimeout(this.popupDiv.deleteTimeout), this.popupDiv = {});
                }
            },
            {
                key: "_showPopupIfNeeded",
                value: function() {
                    var t = this;
                    if (void 0 !== this.popupDiv.html) {
                        var e = this.domElements[this.popupDiv.index].getBoundingClientRect();
                        this.popupDiv.html.style.left = e.left + "px", this.popupDiv.html.style.top = e.top - 30 + "px", document.body.appendChild(this.popupDiv.html), this.popupDiv.hideTimeout = sd(function() {
                            t.popupDiv.html.style.opacity = 0;
                        }, 1500), this.popupDiv.deleteTimeout = sd(function() {
                            t._removePopup();
                        }, 1800);
                    }
                }
            },
            {
                key: "_makeCheckbox",
                value: function(t, e, i1) {
                    var n = document.createElement("input");
                    n.type = "checkbox", n.className = "vis-configuration vis-config-checkbox", n.checked = t, void 0 !== e && (n.checked = e, e !== t && ("object" === uc(t) ? e !== t.enabled && this.changedOptions.push({
                        path: i1,
                        value: e
                    }) : this.changedOptions.push({
                        path: i1,
                        value: e
                    })));
                    var o = this;
                    n.onchange = function() {
                        o._update(this.checked, i1);
                    };
                    var r = this._makeLabel(i1[i1.length - 1], i1);
                    this._makeItem(i1, r, n);
                }
            },
            {
                key: "_makeTextInput",
                value: function(t, e, i1) {
                    var n = document.createElement("input");
                    n.type = "text", n.className = "vis-configuration vis-config-text", n.value = e, e !== t && this.changedOptions.push({
                        path: i1,
                        value: e
                    });
                    var o = this;
                    n.onchange = function() {
                        o._update(this.value, i1);
                    };
                    var r = this._makeLabel(i1[i1.length - 1], i1);
                    this._makeItem(i1, r, n);
                }
            },
            {
                key: "_makeColorField",
                value: function(t, e, i1) {
                    var n = this, o = t[1], r = document.createElement("div");
                    "none" !== (e = void 0 === e ? o : e) ? (r.className = "vis-configuration vis-config-colorBlock", r.style.backgroundColor = e) : r.className = "vis-configuration vis-config-colorBlock none", e = void 0 === e ? o : e, r.onclick = function() {
                        n._showColorPicker(e, r, i1);
                    };
                    var s = this._makeLabel(i1[i1.length - 1], i1);
                    this._makeItem(i1, s, r);
                }
            },
            {
                key: "_showColorPicker",
                value: function(t, e, i1) {
                    var n = this;
                    e.onclick = function() {}, this.colorPicker.insertTo(e), this.colorPicker.show(), this.colorPicker.setColor(t), this.colorPicker.setUpdateCallback(function(t) {
                        var o = "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")";
                        e.style.backgroundColor = o, n._update(o, i1);
                    }), this.colorPicker.setCloseCallback(function() {
                        e.onclick = function() {
                            n._showColorPicker(t, e, i1);
                        };
                    });
                }
            },
            {
                key: "_handleObject",
                value: function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], i1 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = !1, o = Ed(this.options), r = !1;
                    for(var s in t)if (Object.prototype.hasOwnProperty.call(t, s)) {
                        n = !0;
                        var a = t[s], l = cw(e, s);
                        if ("function" == typeof o && !1 === (n = o(s, e)) && !zc(a) && "string" != typeof a && "boolean" != typeof a && a instanceof Object && (this.allowCreation = !1, n = this._handleObject(a, l, !0), this.allowCreation = !1 === i1), !1 !== n) {
                            r = !0;
                            var h = this._getValue(l);
                            if (zc(a)) this._handleArray(a, h, l);
                            else if ("string" == typeof a) this._makeTextInput(a, h, l);
                            else if ("boolean" == typeof a) this._makeCheckbox(a, h, l);
                            else if (a instanceof Object) {
                                if (!this.hideOption(e, s, this.moduleOptions)) {
                                    if (void 0 !== a.enabled) {
                                        var u = cw(l, "enabled"), c = this._getValue(u);
                                        if (!0 === c) {
                                            var d = this._makeLabel(s, l, !0);
                                            this._makeItem(l, d), r = this._handleObject(a, l) || r;
                                        } else this._makeCheckbox(a, c, l);
                                    } else {
                                        var p = this._makeLabel(s, l, !0);
                                        this._makeItem(l, p), r = this._handleObject(a, l) || r;
                                    }
                                }
                            } else console.error("dont know how to handle", a, s, l);
                        }
                    }
                    return r;
                }
            },
            {
                key: "_handleArray",
                value: function(t, e, i1) {
                    "string" == typeof t[0] && "color" === t[0] ? (this._makeColorField(t, e, i1), t[1] !== e && this.changedOptions.push({
                        path: i1,
                        value: e
                    })) : "string" == typeof t[0] ? (this._makeDropdown(t, e, i1), t[0] !== e && this.changedOptions.push({
                        path: i1,
                        value: e
                    })) : "number" == typeof t[0] && (this._makeRange(t, e, i1), t[0] !== e && this.changedOptions.push({
                        path: i1,
                        value: Number(e)
                    }));
                }
            },
            {
                key: "_update",
                value: function(t, e) {
                    var i1 = this._constructOptions(t, e);
                    this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit && this.parent.body.emitter.emit("configChange", i1), this.initialized = !0, this.parent.setOptions(i1);
                }
            },
            {
                key: "_constructOptions",
                value: function(t, e) {
                    var i1 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = i1;
                    t = "false" !== (t = "true" === t || t) && t;
                    for(var o = 0; o < e.length; o++)"global" !== e[o] && (void 0 === n[e[o]] && (n[e[o]] = {}), o !== e.length - 1 ? n = n[e[o]] : n[e[o]] = t);
                    return i1;
                }
            },
            {
                key: "_printOptions",
                value: function() {
                    for(var t = this.getOptions(); this.optionsContainer.firstChild;)this.optionsContainer.removeChild(this.optionsContainer.firstChild);
                    this.optionsContainer.appendChild(Ew("pre", "const options = " + Fg(t, null, 2)));
                }
            },
            {
                key: "getOptions",
                value: function() {
                    for(var t = {}, e = 0; e < this.changedOptions.length; e++)this._constructOptions(this.changedOptions[e].value, this.changedOptions[e].path, t);
                    return t;
                }
            }
        ]), t;
    }(), Iw = function() {
        function t(e, i1) {
            Lo(this, t), this.container = e, this.overflowMethod = i1 || "cap", this.x = 0, this.y = 0, this.padding = 5, this.hidden = !1, this.frame = document.createElement("div"), this.frame.className = "vis-tooltip", this.container.appendChild(this.frame);
        }
        return mc(t, [
            {
                key: "setPosition",
                value: function(t, e) {
                    this.x = gg(t), this.y = gg(e);
                }
            },
            {
                key: "setText",
                value: function(t) {
                    if (t instanceof Element) {
                        for(; this.frame.firstChild;)this.frame.removeChild(this.frame.firstChild);
                        this.frame.appendChild(t);
                    } else this.frame.innerText = t;
                }
            },
            {
                key: "show",
                value: function(t) {
                    if (void 0 === t && (t = !0), !0 === t) {
                        var e = this.frame.clientHeight, i1 = this.frame.clientWidth, n = this.frame.parentNode.clientHeight, o = this.frame.parentNode.clientWidth, r = 0, s = 0;
                        if ("flip" == this.overflowMethod) {
                            var a = !1, l = !0;
                            this.y - e < this.padding && (l = !1), this.x + i1 > o - this.padding && (a = !0), r = a ? this.x - i1 : this.x, s = l ? this.y - e : this.y;
                        } else (s = this.y - e) + e + this.padding > n && (s = n - e - this.padding), s < this.padding && (s = this.padding), (r = this.x) + i1 + this.padding > o && (r = o - i1 - this.padding), r < this.padding && (r = this.padding);
                        this.frame.style.left = r + "px", this.frame.style.top = s + "px", this.frame.style.visibility = "visible", this.hidden = !1;
                    } else this.hide();
                }
            },
            {
                key: "hide",
                value: function() {
                    this.hidden = !0, this.frame.style.left = "0", this.frame.style.top = "0", this.frame.style.visibility = "hidden";
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.frame.parentNode.removeChild(this.frame);
                }
            }
        ]), t;
    }(), Pw = !1, Mw = "background: #FFeeee; color: #dd0000", Nw = function() {
        function t() {
            Lo(this, t);
        }
        return mc(t, null, [
            {
                key: "validate",
                value: function(e, i1, n) {
                    Pw = !1, Ow = i1;
                    var o = i1;
                    return void 0 !== n && (o = i1[n]), t.parse(e, o, []), Pw;
                }
            },
            {
                key: "parse",
                value: function(e, i1, n) {
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.check(o, e, i1, n);
                }
            },
            {
                key: "check",
                value: function(e, i1, n, o) {
                    if (void 0 !== n[e] || void 0 !== n.__any__) {
                        var r = e, s = !0;
                        void 0 === n[e] && void 0 !== n.__any__ && (r = "__any__", s = "object" === t.getType(i1[e]));
                        var a = n[r];
                        s && void 0 !== a.__type__ && (a = a.__type__), t.checkFields(e, i1, n, r, a, o);
                    } else t.getSuggestion(e, n, o);
                }
            },
            {
                key: "checkFields",
                value: function(e, i1, n, o, r, s) {
                    var a = function(i1) {
                        console.error("%c" + i1 + t.printLocation(s, e), Mw);
                    }, l = t.getType(i1[e]), h = r[l];
                    void 0 !== h ? "array" === t.getType(h) && -1 === Eg(h).call(h, i1[e]) ? (a('Invalid option detected in "' + e + '". Allowed values are:' + t.print(h) + ' not "' + i1[e] + '". '), Pw = !0) : "object" === l && "__any__" !== o && (s = cw(s, e), t.parse(i1[e], n[o], s)) : void 0 === r.any && (a('Invalid type received for "' + e + '". Expected: ' + t.print(Dp(r)) + ". Received [" + l + '] "' + i1[e] + '"'), Pw = !0);
                }
            },
            {
                key: "getType",
                value: function(t) {
                    var e = uc(t);
                    return "object" === e ? null === t ? "null" : t instanceof Boolean ? "boolean" : t instanceof Number ? "number" : t instanceof String ? "string" : zc(t) ? "array" : t instanceof Date ? "date" : void 0 !== t.nodeType ? "dom" : !0 === t._isAMomentObject ? "moment" : "object" : "number" === e ? "number" : "boolean" === e ? "boolean" : "string" === e ? "string" : void 0 === e ? "undefined" : e;
                }
            },
            {
                key: "getSuggestion",
                value: function(e, i1, n) {
                    var o, r = t.findInOptions(e, i1, n, !1), s = t.findInOptions(e, Ow, [], !0);
                    o = void 0 !== r.indexMatch ? " in " + t.printLocation(r.path, e, "") + 'Perhaps it was incomplete? Did you mean: "' + r.indexMatch + '"?\n\n' : s.distance <= 4 && r.distance > s.distance ? " in " + t.printLocation(r.path, e, "") + "Perhaps it was misplaced? Matching option found at: " + t.printLocation(s.path, s.closestMatch, "") : r.distance <= 8 ? '. Did you mean "' + r.closestMatch + '"?' + t.printLocation(r.path, e) : ". Did you mean one of these: " + t.print(Dp(i1)) + t.printLocation(n, e), console.error('%cUnknown option detected: "' + e + '"' + o, Mw), Pw = !0;
                }
            },
            {
                key: "findInOptions",
                value: function(e, i1, n) {
                    var o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], r = 1e9, s = "", a = [], l = e.toLowerCase(), h = void 0;
                    for(var u in i1){
                        var c = void 0;
                        if (void 0 !== i1[u].__type__ && !0 === o) {
                            var d = t.findInOptions(e, i1[u], cw(n, u));
                            r > d.distance && (s = d.closestMatch, a = d.path, r = d.distance, h = d.indexMatch);
                        } else {
                            var p;
                            -1 !== Eg(p = u.toLowerCase()).call(p, l) && (h = u), r > (c = t.levenshteinDistance(e, u)) && (s = u, a = dw(n), r = c);
                        }
                    }
                    return {
                        closestMatch: s,
                        path: a,
                        distance: r,
                        indexMatch: h
                    };
                }
            },
            {
                key: "printLocation",
                value: function(t, e) {
                    for(var i1 = "\n\n" + (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Problem value found at: \n") + "options = {\n", n = 0; n < t.length; n++){
                        for(var o = 0; o < n + 1; o++)i1 += "  ";
                        i1 += t[n] + ": {\n";
                    }
                    for(var r = 0; r < t.length + 1; r++)i1 += "  ";
                    i1 += e + "\n";
                    for(var s = 0; s < t.length + 1; s++){
                        for(var a = 0; a < t.length - s; a++)i1 += "  ";
                        i1 += "}\n";
                    }
                    return i1 + "\n\n";
                }
            },
            {
                key: "print",
                value: function(t) {
                    return Fg(t).replace(/(")|(\[)|(\])|(,"__type__")/g, "").replace(/(,)/g, ", ");
                }
            },
            {
                key: "levenshteinDistance",
                value: function(t, e) {
                    if (0 === t.length) return e.length;
                    if (0 === e.length) return t.length;
                    var i1, n, o = [];
                    for(i1 = 0; i1 <= e.length; i1++)o[i1] = [
                        i1
                    ];
                    for(n = 0; n <= t.length; n++)o[0][n] = n;
                    for(i1 = 1; i1 <= e.length; i1++)for(n = 1; n <= t.length; n++)e.charAt(i1 - 1) == t.charAt(n - 1) ? o[i1][n] = o[i1 - 1][n - 1] : o[i1][n] = Math.min(o[i1 - 1][n - 1] + 1, Math.min(o[i1][n - 1] + 1, o[i1 - 1][n] + 1));
                    return o[e.length][t.length];
                }
            }
        ]), t;
    }(), Fw = Qb, Rw = Tw, Lw = Aw, jw = Zb, Bw = Iw, zw = Mw, Hw = Nw, Gw = Object.freeze({
        __proto__: null,
        Activator: Fw,
        Alea: function() {
            for(var t = arguments.length, e = new Array(t), i1 = 0; i1 < t; i1++)e[i1] = arguments[i1];
            return function(t) {
                var e = function() {
                    for(var t = function() {
                        var t = 4022871197;
                        return function(e) {
                            for(var i1 = e.toString(), n = 0; n < i1.length; n++){
                                var o = .02519603282416938 * (t += i1.charCodeAt(n));
                                o -= t = o >>> 0, t = (o *= t) >>> 0, t += 4294967296 * (o -= t);
                            }
                            return 2.3283064365386963e-10 * (t >>> 0);
                        };
                    }(), e = t(" "), i1 = t(" "), n = t(" "), o = 0; o < arguments.length; o++)(e -= t(o < 0 || arguments.length <= o ? void 0 : arguments[o])) < 0 && (e += 1), (i1 -= t(o < 0 || arguments.length <= o ? void 0 : arguments[o])) < 0 && (i1 += 1), (n -= t(o < 0 || arguments.length <= o ? void 0 : arguments[o])) < 0 && (n += 1);
                    return [
                        e,
                        i1,
                        n
                    ];
                }(t), i1 = sf(e, 3), n = i1[0], o = i1[1], r = i1[2], s = 1, a = function() {
                    var t = 2091639 * n + 2.3283064365386963e-10 * s;
                    return n = o, o = r, r = t - (s = 0 | t);
                };
                return a.uint32 = function() {
                    return 4294967296 * a();
                }, a.fract53 = function() {
                    return a() + 11102230246251565e-32 * (2097152 * a() | 0);
                }, a.algorithm = "Alea", a.seed = t, a.version = "0.9", a;
            }(e.length ? e : [
                wf()
            ]);
        },
        ColorPicker: Rw,
        Configurator: Lw,
        DELETE: Ub,
        HSVToHex: ww,
        HSVToRGB: bw,
        Hammer: jw,
        Popup: Bw,
        RGBToHSV: gw,
        RGBToHex: vw,
        VALIDATOR_PRINT_STYLE: zw,
        Validator: Hw,
        addClassName: function(t, e) {
            var i1 = t.className.split(" "), n = e.split(" ");
            i1 = mf(i1).call(i1, Ed(n).call(n, function(t) {
                return !Fv(i1).call(i1, t);
            })), t.className = i1.join(" ");
        },
        addCssText: function(t, e) {
            for(var i1 = yw(e), n = 0, o = Ag(i1); n < o.length; n++){
                var r = sf(o[n], 2), s = r[0], a = r[1];
                t.style.setProperty(s, a);
            }
        },
        addEventListener: function(t, e, i1, n) {
            var o;
            t.addEventListener ? (void 0 === n && (n = !1), "mousewheel" === e && Fv(o = navigator.userAgent).call(o, "Firefox") && (e = "DOMMouseScroll"), t.addEventListener(e, i1, n)) : t.attachEvent("on" + e, i1);
        },
        binarySearchCustom: function(t, e, i1, n) {
            for(var o = 0, r = 0, s = t.length - 1; r <= s && o < 1e4;){
                var a = Math.floor((r + s) / 2), l = t[a], h = e(void 0 === n ? l[i1] : l[i1][n]);
                if (0 == h) return a;
                -1 == h ? r = a + 1 : s = a - 1, o++;
            }
            return -1;
        },
        binarySearchValue: function(t, e, i1, n, o) {
            var r, s, a, l, h = 0, u = 0, c = t.length - 1;
            for(o = null != o ? o : function(t, e) {
                return t == e ? 0 : t < e ? -1 : 1;
            }; u <= c && h < 1e4;){
                if (l = Math.floor(.5 * (c + u)), r = t[Math.max(0, l - 1)][i1], s = t[l][i1], a = t[Math.min(t.length - 1, l + 1)][i1], 0 == o(s, e)) return l;
                if (o(r, e) < 0 && o(s, e) > 0) return "before" == n ? Math.max(0, l - 1) : l;
                if (o(s, e) < 0 && o(a, e) > 0) return "before" == n ? l : Math.min(t.length - 1, l + 1);
                o(s, e) < 0 ? u = l + 1 : c = l - 1, h++;
            }
            return -1;
        },
        bridgeObject: Sw,
        copyAndExtendArray: cw,
        copyArray: dw,
        deepExtend: hw,
        deepObjectAssign: Xb,
        easingFunctions: {
            linear: function(t) {
                return t;
            },
            easeInQuad: function(t) {
                return t * t;
            },
            easeOutQuad: function(t) {
                return t * (2 - t);
            },
            easeInOutQuad: function(t) {
                return t < .5 ? 2 * t * t : (4 - 2 * t) * t - 1;
            },
            easeInCubic: function(t) {
                return t * t * t;
            },
            easeOutCubic: function(t) {
                return --t * t * t + 1;
            },
            easeInOutCubic: function(t) {
                return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
            },
            easeInQuart: function(t) {
                return t * t * t * t;
            },
            easeOutQuart: function(t) {
                return 1 - --t * t * t * t;
            },
            easeInOutQuart: function(t) {
                return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
            },
            easeInQuint: function(t) {
                return t * t * t * t * t;
            },
            easeOutQuint: function(t) {
                return 1 + --t * t * t * t * t;
            },
            easeInOutQuint: function(t) {
                return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
            }
        },
        equalArray: function(t, e) {
            if (t.length !== e.length) return !1;
            for(var i1 = 0, n = t.length; i1 < n; i1++)if (t[i1] != e[i1]) return !1;
            return !0;
        },
        extend: lw,
        fillIfDefined: function t(e, i1) {
            var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            for(var o in e)if (void 0 !== i1[o]) {
                if (null === i1[o] || "object" !== uc(i1[o])) aw(e, i1, o, n);
                else {
                    var r = e[o], s = i1[o];
                    sw(r) && sw(s) && t(r, s, n);
                }
            }
        },
        forEach: function(t, e) {
            if (zc(t)) for(var i1 = t.length, n = 0; n < i1; n++)e(t[n], n, t);
            else for(var o in t)Object.prototype.hasOwnProperty.call(t, o) && e(t[o], o, t);
        },
        getAbsoluteLeft: function(t) {
            return t.getBoundingClientRect().left;
        },
        getAbsoluteRight: function(t) {
            return t.getBoundingClientRect().right;
        },
        getAbsoluteTop: function(t) {
            return t.getBoundingClientRect().top;
        },
        getScrollBarWidth: function() {
            var t = document.createElement("p");
            t.style.width = "100%", t.style.height = "200px";
            var e = document.createElement("div");
            e.style.position = "absolute", e.style.top = "0px", e.style.left = "0px", e.style.visibility = "hidden", e.style.width = "200px", e.style.height = "150px", e.style.overflow = "hidden", e.appendChild(t), document.body.appendChild(e);
            var i1 = t.offsetWidth;
            e.style.overflow = "scroll";
            var n = t.offsetWidth;
            return i1 == n && (n = e.clientWidth), document.body.removeChild(e), i1 - n;
        },
        getTarget: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.event, e = null;
            return t && (t.target ? e = t.target : t.srcElement && (e = t.srcElement)), e instanceof Element && (null == e.nodeType || 3 != e.nodeType || (e = e.parentNode) instanceof Element) ? e : null;
        },
        getType: uw,
        hasParent: function(t, e) {
            for(var i1 = t; i1;){
                if (i1 === e) return !0;
                if (!i1.parentNode) return !1;
                i1 = i1.parentNode;
            }
            return !1;
        },
        hexToHSV: kw,
        hexToRGB: fw,
        insertSort: function(t, e) {
            for(var i1 = 0; i1 < t.length; i1++){
                var n = t[i1], o = void 0;
                for(o = i1; o > 0 && e(n, t[o - 1]) < 0; o--)t[o] = t[o - 1];
                t[o] = n;
            }
            return t;
        },
        isDate: function(t) {
            if (t instanceof Date) return !0;
            if (rw(t)) {
                if (Jb.exec(t)) return !0;
                if (!isNaN(Date.parse(t))) return !0;
            }
            return !1;
        },
        isNumber: ow,
        isObject: sw,
        isString: rw,
        isValidHex: _w,
        isValidRGB: xw,
        isValidRGBA: Cw,
        mergeOptions: function(t, e, i1) {
            var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, o = function(t) {
                return null != t;
            }, r = function(t) {
                return null !== t && "object" === uc(t);
            };
            if (!r(t)) throw new Error("Parameter mergeTarget must be an object");
            if (!r(e)) throw new Error("Parameter options must be an object");
            if (!o(i1)) throw new Error("Parameter option must have a value");
            if (!r(n)) throw new Error("Parameter globalOptions must be an object");
            var s = e[i1], a = r(n) && !function(t) {
                for(var e in t)if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
                return !0;
            }(n) ? n[i1] : void 0, l = a ? a.enabled : void 0;
            if (void 0 !== s) {
                if ("boolean" == typeof s) return r(t[i1]) || (t[i1] = {}), void (t[i1].enabled = s);
                if (null === s && !r(t[i1])) {
                    if (!o(a)) return;
                    t[i1] = Ig(a);
                }
                if (r(s)) {
                    var h = !0;
                    void 0 !== s.enabled ? h = s.enabled : void 0 !== l && (h = a.enabled), function(t, e, i1) {
                        r(t[i1]) || (t[i1] = {});
                        var n = e[i1], o = t[i1];
                        for(var s in n)Object.prototype.hasOwnProperty.call(n, s) && (o[s] = n[s]);
                    }(t, e, i1), t[i1].enabled = h;
                }
            }
        },
        option: mw,
        overrideOpacity: function(t, e) {
            if (Fv(t).call(t, "rgba")) return t;
            if (Fv(t).call(t, "rgb")) {
                var i1 = t.substr(Eg(t).call(t, "(") + 1).replace(")", "").split(",");
                return "rgba(" + i1[0] + "," + i1[1] + "," + i1[2] + "," + e + ")";
            }
            var n = fw(t);
            return null == n ? t : "rgba(" + n.r + "," + n.g + "," + n.b + "," + e + ")";
        },
        parseColor: function(t, e) {
            if (rw(t)) {
                var i1 = t;
                if (xw(i1)) {
                    var n, o = lp(n = i1.substr(4).substr(0, i1.length - 5).split(",")).call(n, function(t) {
                        return gg(t);
                    });
                    i1 = vw(o[0], o[1], o[2]);
                }
                if (!0 === _w(i1)) {
                    var r = kw(i1), s = {
                        h: r.h,
                        s: .8 * r.s,
                        v: Math.min(1, 1.02 * r.v)
                    }, a = {
                        h: r.h,
                        s: Math.min(1, 1.25 * r.s),
                        v: .8 * r.v
                    }, l = ww(a.h, a.s, a.v), h = ww(s.h, s.s, s.v);
                    return {
                        background: i1,
                        border: l,
                        highlight: {
                            background: h,
                            border: l
                        },
                        hover: {
                            background: h,
                            border: l
                        }
                    };
                }
                return {
                    background: i1,
                    border: i1,
                    highlight: {
                        background: i1,
                        border: i1
                    },
                    hover: {
                        background: i1,
                        border: i1
                    }
                };
            }
            return e ? {
                background: t.background || e.background,
                border: t.border || e.border,
                highlight: rw(t.highlight) ? {
                    border: t.highlight,
                    background: t.highlight
                } : {
                    background: t.highlight && t.highlight.background || e.highlight.background,
                    border: t.highlight && t.highlight.border || e.highlight.border
                },
                hover: rw(t.hover) ? {
                    border: t.hover,
                    background: t.hover
                } : {
                    border: t.hover && t.hover.border || e.hover.border,
                    background: t.hover && t.hover.background || e.hover.background
                }
            } : {
                background: t.background || void 0,
                border: t.border || void 0,
                highlight: rw(t.highlight) ? {
                    border: t.highlight,
                    background: t.highlight
                } : {
                    background: t.highlight && t.highlight.background || void 0,
                    border: t.highlight && t.highlight.border || void 0
                },
                hover: rw(t.hover) ? {
                    border: t.hover,
                    background: t.hover
                } : {
                    border: t.hover && t.hover.border || void 0,
                    background: t.hover && t.hover.background || void 0
                }
            };
        },
        preventDefault: function(t) {
            t || (t = window.event), t && (t.preventDefault ? t.preventDefault() : t.returnValue = !1);
        },
        pureDeepObjectAssign: function(t) {
            for(var e, i1 = arguments.length, n = new Array(i1 > 1 ? i1 - 1 : 0), o = 1; o < i1; o++)n[o - 1] = arguments[o];
            return Xb.apply(void 0, mf(e = [
                {},
                t
            ]).call(e, n));
        },
        recursiveDOMDelete: function t(e) {
            if (e) for(; !0 === e.hasChildNodes();){
                var i1 = e.firstChild;
                i1 && (t(i1), e.removeChild(i1));
            }
        },
        removeClassName: function(t, e) {
            var i1 = t.className.split(" "), n = e.split(" ");
            i1 = Ed(i1).call(i1, function(t) {
                return !Fv(n).call(n, t);
            }), t.className = i1.join(" ");
        },
        removeCssText: function(t, e) {
            for(var i1 = yw(e), n = 0, o = Dp(i1); n < o.length; n++){
                var r = o[n];
                t.style.removeProperty(r);
            }
        },
        removeEventListener: function(t, e, i1, n) {
            var o;
            t.removeEventListener ? (void 0 === n && (n = !1), "mousewheel" === e && Fv(o = navigator.userAgent).call(o, "Firefox") && (e = "DOMMouseScroll"), t.removeEventListener(e, i1, n)) : t.detachEvent("on" + e, i1);
        },
        selectiveBridgeObject: function(t, e) {
            if (null !== e && "object" === uc(e)) {
                for(var i1 = Ig(e), n = 0; n < t.length; n++)Object.prototype.hasOwnProperty.call(e, t[n]) && "object" == uc(e[t[n]]) && (i1[t[n]] = Sw(e[t[n]]));
                return i1;
            }
            return null;
        },
        selectiveDeepExtend: function(t, e, i1) {
            var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
            if (zc(i1)) throw new TypeError("Arrays are not supported by deepExtend");
            for(var o = 0; o < t.length; o++){
                var r = t[o];
                if (Object.prototype.hasOwnProperty.call(i1, r)) {
                    if (i1[r] && i1[r].constructor === Object) void 0 === e[r] && (e[r] = {}), e[r].constructor === Object ? hw(e[r], i1[r], !1, n) : aw(e, i1, r, n);
                    else {
                        if (zc(i1[r])) throw new TypeError("Arrays are not supported by deepExtend");
                        aw(e, i1, r, n);
                    }
                }
            }
            return e;
        },
        selectiveExtend: function(t, e) {
            if (!zc(t)) throw new Error("Array with property names expected as first argument");
            for(var i1 = arguments.length, n = new Array(i1 > 2 ? i1 - 2 : 0), o = 2; o < i1; o++)n[o - 2] = arguments[o];
            for(var r = 0, s = n; r < s.length; r++)for(var a = s[r], l = 0; l < t.length; l++){
                var h = t[l];
                a && Object.prototype.hasOwnProperty.call(a, h) && (e[h] = a[h]);
            }
            return e;
        },
        selectiveNotDeepExtend: function(t, e, i1) {
            var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
            if (zc(i1)) throw new TypeError("Arrays are not supported by deepExtend");
            for(var o in i1)if (Object.prototype.hasOwnProperty.call(i1, o) && !Fv(t).call(t, o)) {
                if (i1[o] && i1[o].constructor === Object) void 0 === e[o] && (e[o] = {}), e[o].constructor === Object ? hw(e[o], i1[o]) : aw(e, i1, o, n);
                else if (zc(i1[o])) {
                    e[o] = [];
                    for(var r = 0; r < i1[o].length; r++)e[o].push(i1[o][r]);
                } else aw(e, i1, o, n);
            }
            return e;
        },
        throttle: function(t) {
            var e = !1;
            return function() {
                e || (e = !0, requestAnimationFrame(function() {
                    e = !1, t();
                }));
            };
        },
        toArray: pw,
        topMost: function(t, e) {
            var i1;
            zc(e) || (e = [
                e
            ]);
            var n, o = Yb(t);
            try {
                for(o.s(); !(n = o.n()).done;){
                    var r = n.value;
                    if (r) {
                        i1 = r[e[0]];
                        for(var s = 1; s < e.length; s++)i1 && (i1 = i1[e[s]]);
                        if (void 0 !== i1) break;
                    }
                }
            } catch (t) {
                o.e(t);
            } finally{
                o.f();
            }
            return i1;
        },
        updateProperty: function(t, e, i1) {
            return t[e] !== i1 && (t[e] = i1, !0);
        }
    }), Ww = {
        exports: {}
    }, Yw = {}, Vw = {
        exports: {}
    }, Uw = {};
    function Xw() {
        var t = {
            "align-content": !1,
            "align-items": !1,
            "align-self": !1,
            "alignment-adjust": !1,
            "alignment-baseline": !1,
            all: !1,
            "anchor-point": !1,
            animation: !1,
            "animation-delay": !1,
            "animation-direction": !1,
            "animation-duration": !1,
            "animation-fill-mode": !1,
            "animation-iteration-count": !1,
            "animation-name": !1,
            "animation-play-state": !1,
            "animation-timing-function": !1,
            azimuth: !1,
            "backface-visibility": !1,
            background: !0,
            "background-attachment": !0,
            "background-clip": !0,
            "background-color": !0,
            "background-image": !0,
            "background-origin": !0,
            "background-position": !0,
            "background-repeat": !0,
            "background-size": !0,
            "baseline-shift": !1,
            binding: !1,
            bleed: !1,
            "bookmark-label": !1,
            "bookmark-level": !1,
            "bookmark-state": !1,
            border: !0,
            "border-bottom": !0,
            "border-bottom-color": !0,
            "border-bottom-left-radius": !0,
            "border-bottom-right-radius": !0,
            "border-bottom-style": !0,
            "border-bottom-width": !0,
            "border-collapse": !0,
            "border-color": !0,
            "border-image": !0,
            "border-image-outset": !0,
            "border-image-repeat": !0,
            "border-image-slice": !0,
            "border-image-source": !0,
            "border-image-width": !0,
            "border-left": !0,
            "border-left-color": !0,
            "border-left-style": !0,
            "border-left-width": !0,
            "border-radius": !0,
            "border-right": !0,
            "border-right-color": !0,
            "border-right-style": !0,
            "border-right-width": !0,
            "border-spacing": !0,
            "border-style": !0,
            "border-top": !0,
            "border-top-color": !0,
            "border-top-left-radius": !0,
            "border-top-right-radius": !0,
            "border-top-style": !0,
            "border-top-width": !0,
            "border-width": !0,
            bottom: !1,
            "box-decoration-break": !0,
            "box-shadow": !0,
            "box-sizing": !0,
            "box-snap": !0,
            "box-suppress": !0,
            "break-after": !0,
            "break-before": !0,
            "break-inside": !0,
            "caption-side": !1,
            chains: !1,
            clear: !0,
            clip: !1,
            "clip-path": !1,
            "clip-rule": !1,
            color: !0,
            "color-interpolation-filters": !0,
            "column-count": !1,
            "column-fill": !1,
            "column-gap": !1,
            "column-rule": !1,
            "column-rule-color": !1,
            "column-rule-style": !1,
            "column-rule-width": !1,
            "column-span": !1,
            "column-width": !1,
            columns: !1,
            contain: !1,
            content: !1,
            "counter-increment": !1,
            "counter-reset": !1,
            "counter-set": !1,
            crop: !1,
            cue: !1,
            "cue-after": !1,
            "cue-before": !1,
            cursor: !1,
            direction: !1,
            display: !0,
            "display-inside": !0,
            "display-list": !0,
            "display-outside": !0,
            "dominant-baseline": !1,
            elevation: !1,
            "empty-cells": !1,
            filter: !1,
            flex: !1,
            "flex-basis": !1,
            "flex-direction": !1,
            "flex-flow": !1,
            "flex-grow": !1,
            "flex-shrink": !1,
            "flex-wrap": !1,
            float: !1,
            "float-offset": !1,
            "flood-color": !1,
            "flood-opacity": !1,
            "flow-from": !1,
            "flow-into": !1,
            font: !0,
            "font-family": !0,
            "font-feature-settings": !0,
            "font-kerning": !0,
            "font-language-override": !0,
            "font-size": !0,
            "font-size-adjust": !0,
            "font-stretch": !0,
            "font-style": !0,
            "font-synthesis": !0,
            "font-variant": !0,
            "font-variant-alternates": !0,
            "font-variant-caps": !0,
            "font-variant-east-asian": !0,
            "font-variant-ligatures": !0,
            "font-variant-numeric": !0,
            "font-variant-position": !0,
            "font-weight": !0,
            grid: !1,
            "grid-area": !1,
            "grid-auto-columns": !1,
            "grid-auto-flow": !1,
            "grid-auto-rows": !1,
            "grid-column": !1,
            "grid-column-end": !1,
            "grid-column-start": !1,
            "grid-row": !1,
            "grid-row-end": !1,
            "grid-row-start": !1,
            "grid-template": !1,
            "grid-template-areas": !1,
            "grid-template-columns": !1,
            "grid-template-rows": !1,
            "hanging-punctuation": !1,
            height: !0,
            hyphens: !1,
            icon: !1,
            "image-orientation": !1,
            "image-resolution": !1,
            "ime-mode": !1,
            "initial-letters": !1,
            "inline-box-align": !1,
            "justify-content": !1,
            "justify-items": !1,
            "justify-self": !1,
            left: !1,
            "letter-spacing": !0,
            "lighting-color": !0,
            "line-box-contain": !1,
            "line-break": !1,
            "line-grid": !1,
            "line-height": !1,
            "line-snap": !1,
            "line-stacking": !1,
            "line-stacking-ruby": !1,
            "line-stacking-shift": !1,
            "line-stacking-strategy": !1,
            "list-style": !0,
            "list-style-image": !0,
            "list-style-position": !0,
            "list-style-type": !0,
            margin: !0,
            "margin-bottom": !0,
            "margin-left": !0,
            "margin-right": !0,
            "margin-top": !0,
            "marker-offset": !1,
            "marker-side": !1,
            marks: !1,
            mask: !1,
            "mask-box": !1,
            "mask-box-outset": !1,
            "mask-box-repeat": !1,
            "mask-box-slice": !1,
            "mask-box-source": !1,
            "mask-box-width": !1,
            "mask-clip": !1,
            "mask-image": !1,
            "mask-origin": !1,
            "mask-position": !1,
            "mask-repeat": !1,
            "mask-size": !1,
            "mask-source-type": !1,
            "mask-type": !1,
            "max-height": !0,
            "max-lines": !1,
            "max-width": !0,
            "min-height": !0,
            "min-width": !0,
            "move-to": !1,
            "nav-down": !1,
            "nav-index": !1,
            "nav-left": !1,
            "nav-right": !1,
            "nav-up": !1,
            "object-fit": !1,
            "object-position": !1,
            opacity: !1,
            order: !1,
            orphans: !1,
            outline: !1,
            "outline-color": !1,
            "outline-offset": !1,
            "outline-style": !1,
            "outline-width": !1,
            overflow: !1,
            "overflow-wrap": !1,
            "overflow-x": !1,
            "overflow-y": !1,
            padding: !0,
            "padding-bottom": !0,
            "padding-left": !0,
            "padding-right": !0,
            "padding-top": !0,
            page: !1,
            "page-break-after": !1,
            "page-break-before": !1,
            "page-break-inside": !1,
            "page-policy": !1,
            pause: !1,
            "pause-after": !1,
            "pause-before": !1,
            perspective: !1,
            "perspective-origin": !1,
            pitch: !1,
            "pitch-range": !1,
            "play-during": !1,
            position: !1,
            "presentation-level": !1,
            quotes: !1,
            "region-fragment": !1,
            resize: !1,
            rest: !1,
            "rest-after": !1,
            "rest-before": !1,
            richness: !1,
            right: !1,
            rotation: !1,
            "rotation-point": !1,
            "ruby-align": !1,
            "ruby-merge": !1,
            "ruby-position": !1,
            "shape-image-threshold": !1,
            "shape-outside": !1,
            "shape-margin": !1,
            size: !1,
            speak: !1,
            "speak-as": !1,
            "speak-header": !1,
            "speak-numeral": !1,
            "speak-punctuation": !1,
            "speech-rate": !1,
            stress: !1,
            "string-set": !1,
            "tab-size": !1,
            "table-layout": !1,
            "text-align": !0,
            "text-align-last": !0,
            "text-combine-upright": !0,
            "text-decoration": !0,
            "text-decoration-color": !0,
            "text-decoration-line": !0,
            "text-decoration-skip": !0,
            "text-decoration-style": !0,
            "text-emphasis": !0,
            "text-emphasis-color": !0,
            "text-emphasis-position": !0,
            "text-emphasis-style": !0,
            "text-height": !0,
            "text-indent": !0,
            "text-justify": !0,
            "text-orientation": !0,
            "text-overflow": !0,
            "text-shadow": !0,
            "text-space-collapse": !0,
            "text-transform": !0,
            "text-underline-position": !0,
            "text-wrap": !0,
            top: !1,
            transform: !1,
            "transform-origin": !1,
            "transform-style": !1,
            transition: !1,
            "transition-delay": !1,
            "transition-duration": !1,
            "transition-property": !1,
            "transition-timing-function": !1,
            "unicode-bidi": !1,
            "vertical-align": !1,
            visibility: !1,
            "voice-balance": !1,
            "voice-duration": !1,
            "voice-family": !1,
            "voice-pitch": !1,
            "voice-range": !1,
            "voice-rate": !1,
            "voice-stress": !1,
            "voice-volume": !1,
            volume: !1,
            "white-space": !1,
            widows: !1,
            width: !0,
            "will-change": !1,
            "word-break": !0,
            "word-spacing": !0,
            "word-wrap": !0,
            "wrap-flow": !1,
            "wrap-through": !1,
            "writing-mode": !1,
            "z-index": !1
        };
        return t;
    }
    var qw = /javascript\s*\:/gim;
    Uw.whiteList = Xw(), Uw.getDefaultWhiteList = Xw, Uw.onAttr = function(t, e, i1) {}, Uw.onIgnoreAttr = function(t, e, i1) {}, Uw.safeAttrValue = function(t, e) {
        return qw.test(e) ? "" : e;
    };
    var Kw = {
        indexOf: function(t, e) {
            var i1, n;
            if (Array.prototype.indexOf) return t.indexOf(e);
            for(i1 = 0, n = t.length; i1 < n; i1++)if (t[i1] === e) return i1;
            return -1;
        },
        forEach: function(t, e, i1) {
            var n, o;
            if (Array.prototype.forEach) return t.forEach(e, i1);
            for(n = 0, o = t.length; n < o; n++)e.call(i1, t[n], n, t);
        },
        trim: function(t) {
            return String.prototype.trim ? t.trim() : t.replace(/(^\s*)|(\s*$)/g, "");
        },
        trimRight: function(t) {
            return String.prototype.trimRight ? t.trimRight() : t.replace(/(\s*$)/g, "");
        }
    };
    var $w = function(t, e) {
        ";" !== (t = Kw.trimRight(t))[t.length - 1] && (t += ";");
        var i1 = t.length, n = !1, o = 0, r = 0, s = "";
        function a() {
            if (!n) {
                var i1 = Kw.trim(t.slice(o, r)), a = i1.indexOf(":");
                if (-1 !== a) {
                    var l = Kw.trim(i1.slice(0, a)), h = Kw.trim(i1.slice(a + 1));
                    if (l) {
                        var u = e(o, s.length, l, h, i1);
                        u && (s += u + "; ");
                    }
                }
            }
            o = r + 1;
        }
        for(; r < i1; r++){
            var l = t[r];
            if ("/" === l && "*" === t[r + 1]) {
                var h = t.indexOf("*/", r + 2);
                if (-1 === h) break;
                o = (r = h + 1) + 1, n = !1;
            } else "(" === l ? n = !0 : ")" === l ? n = !1 : ";" === l ? n || a() : "\n" === l && a();
        }
        return Kw.trim(s);
    }, Zw = Uw, Qw = $w;
    function Jw(t) {
        return null == t;
    }
    function tk(t) {
        (t = function(t) {
            var e = {};
            for(var i1 in t)e[i1] = t[i1];
            return e;
        }(t || {})).whiteList = t.whiteList || Zw.whiteList, t.onAttr = t.onAttr || Zw.onAttr, t.onIgnoreAttr = t.onIgnoreAttr || Zw.onIgnoreAttr, t.safeAttrValue = t.safeAttrValue || Zw.safeAttrValue, this.options = t;
    }
    tk.prototype.process = function(t) {
        if (!(t = (t = t || "").toString())) return "";
        var e = this.options, i1 = e.whiteList, n = e.onAttr, o = e.onIgnoreAttr, r = e.safeAttrValue, s = Qw(t, function(t, e, s, a, l) {
            var h = i1[s], u = !1;
            if (!0 === h ? u = h : "function" == typeof h ? u = h(a) : h instanceof RegExp && (u = h.test(a)), !0 !== u && (u = !1), a = r(s, a)) {
                var c, d = {
                    position: e,
                    sourcePosition: t,
                    source: l,
                    isWhite: u
                };
                return u ? Jw(c = n(s, a, d)) ? s + ":" + a : c : Jw(c = o(s, a, d)) ? void 0 : c;
            }
        });
        return s;
    };
    var ek = tk;
    !function(t, e) {
        var i1 = Uw, n = ek;
        for(var o in e = t.exports = function(t, e) {
            return new n(e).process(t);
        }, e.FilterCSS = n, i1)e[o] = i1[o];
        "undefined" != typeof window && (window.filterCSS = t.exports);
    }(Vw, Vw.exports);
    var ik = Vw.exports, nk = {
        indexOf: function(t, e) {
            var i1, n;
            if (Array.prototype.indexOf) return t.indexOf(e);
            for(i1 = 0, n = t.length; i1 < n; i1++)if (t[i1] === e) return i1;
            return -1;
        },
        forEach: function(t, e, i1) {
            var n, o;
            if (Array.prototype.forEach) return t.forEach(e, i1);
            for(n = 0, o = t.length; n < o; n++)e.call(i1, t[n], n, t);
        },
        trim: function(t) {
            return String.prototype.trim ? t.trim() : t.replace(/(^\s*)|(\s*$)/g, "");
        },
        spaceIndex: function(t) {
            var e = /\s|\n|\t/.exec(t);
            return e ? e.index : -1;
        }
    }, ok = ik.FilterCSS, rk = ik.getDefaultWhiteList, sk = nk;
    function ak() {
        return {
            a: [
                "target",
                "href",
                "title"
            ],
            abbr: [
                "title"
            ],
            address: [],
            area: [
                "shape",
                "coords",
                "href",
                "alt"
            ],
            article: [],
            aside: [],
            audio: [
                "autoplay",
                "controls",
                "crossorigin",
                "loop",
                "muted",
                "preload",
                "src"
            ],
            b: [],
            bdi: [
                "dir"
            ],
            bdo: [
                "dir"
            ],
            big: [],
            blockquote: [
                "cite"
            ],
            br: [],
            caption: [],
            center: [],
            cite: [],
            code: [],
            col: [
                "align",
                "valign",
                "span",
                "width"
            ],
            colgroup: [
                "align",
                "valign",
                "span",
                "width"
            ],
            dd: [],
            del: [
                "datetime"
            ],
            details: [
                "open"
            ],
            div: [],
            dl: [],
            dt: [],
            em: [],
            figcaption: [],
            figure: [],
            font: [
                "color",
                "size",
                "face"
            ],
            footer: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            header: [],
            hr: [],
            i: [],
            img: [
                "src",
                "alt",
                "title",
                "width",
                "height"
            ],
            ins: [
                "datetime"
            ],
            li: [],
            mark: [],
            nav: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            section: [],
            small: [],
            span: [],
            sub: [],
            summary: [],
            sup: [],
            strong: [],
            strike: [],
            table: [
                "width",
                "border",
                "align",
                "valign"
            ],
            tbody: [
                "align",
                "valign"
            ],
            td: [
                "width",
                "rowspan",
                "colspan",
                "align",
                "valign"
            ],
            tfoot: [
                "align",
                "valign"
            ],
            th: [
                "width",
                "rowspan",
                "colspan",
                "align",
                "valign"
            ],
            thead: [
                "align",
                "valign"
            ],
            tr: [
                "rowspan",
                "align",
                "valign"
            ],
            tt: [],
            u: [],
            ul: [],
            video: [
                "autoplay",
                "controls",
                "crossorigin",
                "loop",
                "muted",
                "playsinline",
                "poster",
                "preload",
                "src",
                "height",
                "width"
            ]
        };
    }
    var lk = new ok;
    function hk(t) {
        return t.replace(uk, "&lt;").replace(ck, "&gt;");
    }
    var uk = /</g, ck = />/g, dk = /"/g, pk = /&quot;/g, mk = /&#([a-zA-Z0-9]*);?/gim, fk = /&colon;?/gim, vk = /&newline;?/gim, gk = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi, yk = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi, bk = /u\s*r\s*l\s*\(.*/gi;
    function wk(t) {
        return t.replace(dk, "&quot;");
    }
    function kk(t) {
        return t.replace(pk, '"');
    }
    function _k(t) {
        return t.replace(mk, function(t, e) {
            return "x" === e[0] || "X" === e[0] ? String.fromCharCode(parseInt(e.substr(1), 16)) : String.fromCharCode(parseInt(e, 10));
        });
    }
    function xk(t) {
        return t.replace(fk, ":").replace(vk, " ");
    }
    function Ck(t) {
        for(var e = "", i1 = 0, n = t.length; i1 < n; i1++)e += t.charCodeAt(i1) < 32 ? " " : t.charAt(i1);
        return sk.trim(e);
    }
    function Sk(t) {
        return t = Ck(t = xk(t = _k(t = kk(t))));
    }
    function Dk(t) {
        return t = hk(t = wk(t));
    }
    Yw.whiteList = {
        a: [
            "target",
            "href",
            "title"
        ],
        abbr: [
            "title"
        ],
        address: [],
        area: [
            "shape",
            "coords",
            "href",
            "alt"
        ],
        article: [],
        aside: [],
        audio: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "preload",
            "src"
        ],
        b: [],
        bdi: [
            "dir"
        ],
        bdo: [
            "dir"
        ],
        big: [],
        blockquote: [
            "cite"
        ],
        br: [],
        caption: [],
        center: [],
        cite: [],
        code: [],
        col: [
            "align",
            "valign",
            "span",
            "width"
        ],
        colgroup: [
            "align",
            "valign",
            "span",
            "width"
        ],
        dd: [],
        del: [
            "datetime"
        ],
        details: [
            "open"
        ],
        div: [],
        dl: [],
        dt: [],
        em: [],
        figcaption: [],
        figure: [],
        font: [
            "color",
            "size",
            "face"
        ],
        footer: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        header: [],
        hr: [],
        i: [],
        img: [
            "src",
            "alt",
            "title",
            "width",
            "height"
        ],
        ins: [
            "datetime"
        ],
        li: [],
        mark: [],
        nav: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        section: [],
        small: [],
        span: [],
        sub: [],
        summary: [],
        sup: [],
        strong: [],
        strike: [],
        table: [
            "width",
            "border",
            "align",
            "valign"
        ],
        tbody: [
            "align",
            "valign"
        ],
        td: [
            "width",
            "rowspan",
            "colspan",
            "align",
            "valign"
        ],
        tfoot: [
            "align",
            "valign"
        ],
        th: [
            "width",
            "rowspan",
            "colspan",
            "align",
            "valign"
        ],
        thead: [
            "align",
            "valign"
        ],
        tr: [
            "rowspan",
            "align",
            "valign"
        ],
        tt: [],
        u: [],
        ul: [],
        video: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "playsinline",
            "poster",
            "preload",
            "src",
            "height",
            "width"
        ]
    }, Yw.getDefaultWhiteList = ak, Yw.onTag = function(t, e, i1) {}, Yw.onIgnoreTag = function(t, e, i1) {}, Yw.onTagAttr = function(t, e, i1) {}, Yw.onIgnoreTagAttr = function(t, e, i1) {}, Yw.safeAttrValue = function(t, e, i1, n) {
        if (i1 = Sk(i1), "href" === e || "src" === e) {
            if ("#" === (i1 = sk.trim(i1))) return "#";
            if ("http://" !== i1.substr(0, 7) && "https://" !== i1.substr(0, 8) && "mailto:" !== i1.substr(0, 7) && "tel:" !== i1.substr(0, 4) && "data:image/" !== i1.substr(0, 11) && "ftp://" !== i1.substr(0, 6) && "./" !== i1.substr(0, 2) && "../" !== i1.substr(0, 3) && "#" !== i1[0] && "/" !== i1[0]) return "";
        } else if ("background" === e) {
            if (gk.lastIndex = 0, gk.test(i1)) return "";
        } else if ("style" === e) {
            if (yk.lastIndex = 0, yk.test(i1)) return "";
            if (bk.lastIndex = 0, bk.test(i1) && (gk.lastIndex = 0, gk.test(i1))) return "";
            !1 !== n && (i1 = (n = n || lk).process(i1));
        }
        return i1 = Dk(i1);
    }, Yw.escapeHtml = hk, Yw.escapeQuote = wk, Yw.unescapeQuote = kk, Yw.escapeHtmlEntities = _k, Yw.escapeDangerHtml5Entities = xk, Yw.clearNonPrintableCharacter = Ck, Yw.friendlyAttrValue = Sk, Yw.escapeAttrValue = Dk, Yw.onIgnoreTagStripAll = function() {
        return "";
    }, Yw.StripTagBody = function(t, e) {
        "function" != typeof e && (e = function() {});
        var i1 = !Array.isArray(t), n = [], o = !1;
        return {
            onIgnoreTag: function(r, s, a) {
                if (function(e) {
                    return !!i1 || -1 !== sk.indexOf(t, e);
                }(r)) {
                    if (a.isClosing) {
                        var l = "[/removed]", h = a.position + 10;
                        return n.push([
                            !1 !== o ? o : a.position,
                            h
                        ]), o = !1, l;
                    }
                    return o || (o = a.position), "[removed]";
                }
                return e(r, s, a);
            },
            remove: function(t) {
                var e = "", i1 = 0;
                return sk.forEach(n, function(n) {
                    e += t.slice(i1, n[0]), i1 = n[1];
                }), e += t.slice(i1);
            }
        };
    }, Yw.stripCommentTag = function(t) {
        for(var e = "", i1 = 0; i1 < t.length;){
            var n = t.indexOf("\x3c!--", i1);
            if (-1 === n) {
                e += t.slice(i1);
                break;
            }
            e += t.slice(i1, n);
            var o = t.indexOf("--\x3e", n);
            if (-1 === o) break;
            i1 = o + 3;
        }
        return e;
    }, Yw.stripBlankChar = function(t) {
        var e = t.split("");
        return (e = e.filter(function(t) {
            var e = t.charCodeAt(0);
            return 127 !== e && (!(e <= 31) || 10 === e || 13 === e);
        })).join("");
    }, Yw.cssFilter = lk, Yw.getDefaultCSSWhiteList = rk;
    var Tk = {}, Ek = nk;
    function Ok(t) {
        var e, i1 = Ek.spaceIndex(t);
        return e = -1 === i1 ? t.slice(1, -1) : t.slice(1, i1 + 1), "/" === (e = Ek.trim(e).toLowerCase()).slice(0, 1) && (e = e.slice(1)), "/" === e.slice(-1) && (e = e.slice(0, -1)), e;
    }
    function Ak(t) {
        return "</" === t.slice(0, 2);
    }
    var Ik = /[^a-zA-Z0-9\\_:.-]/gim;
    function Pk(t, e) {
        for(; e < t.length; e++){
            var i1 = t[e];
            if (" " !== i1) return "=" === i1 ? e : -1;
        }
    }
    function Mk(t, e) {
        for(; e < t.length; e++){
            var i1 = t[e];
            if (" " !== i1) return "'" === i1 || '"' === i1 ? e : -1;
        }
    }
    function Nk(t, e) {
        for(; e > 0; e--){
            var i1 = t[e];
            if (" " !== i1) return "=" === i1 ? e : -1;
        }
    }
    function Fk(t) {
        return function(t) {
            return '"' === t[0] && '"' === t[t.length - 1] || "'" === t[0] && "'" === t[t.length - 1];
        }(t) ? t.substr(1, t.length - 2) : t;
    }
    Tk.parseTag = function(t, e, i1) {
        var n = "", o = 0, r = !1, s = !1, a = 0, l = t.length, h = "", u = "";
        t: for(a = 0; a < l; a++){
            var c = t.charAt(a);
            if (!1 === r) {
                if ("<" === c) {
                    r = a;
                    continue;
                }
            } else if (!1 === s) {
                if ("<" === c) {
                    n += i1(t.slice(o, a)), r = a, o = a;
                    continue;
                }
                if (">" === c || a === l - 1) {
                    n += i1(t.slice(o, r)), h = Ok(u = t.slice(r, a + 1)), n += e(r, n.length, h, u, Ak(u)), o = a + 1, r = !1;
                    continue;
                }
                if ('"' === c || "'" === c) for(var d = 1, p = t.charAt(a - d); "" === p.trim() || "=" === p;){
                    if ("=" === p) {
                        s = c;
                        continue t;
                    }
                    p = t.charAt(a - ++d);
                }
            } else if (c === s) {
                s = !1;
                continue;
            }
        }
        return o < l && (n += i1(t.substr(o))), n;
    }, Tk.parseAttr = function(t, e) {
        var i1 = 0, n = 0, o = [], r = !1, s = t.length;
        function a(t, i1) {
            if (!((t = (t = Ek.trim(t)).replace(Ik, "").toLowerCase()).length < 1)) {
                var n = e(t, i1 || "");
                n && o.push(n);
            }
        }
        for(var l = 0; l < s; l++){
            var h, u = t.charAt(l);
            if (!1 !== r || "=" !== u) {
                if (!1 === r || l !== n) {
                    if (/\s|\n|\t/.test(u)) {
                        if (t = t.replace(/\s|\n|\t/g, " "), !1 === r) {
                            if (-1 === (h = Pk(t, l))) {
                                a(Ek.trim(t.slice(i1, l))), r = !1, i1 = l + 1;
                                continue;
                            }
                            l = h - 1;
                            continue;
                        }
                        if (-1 === (h = Nk(t, l - 1))) {
                            a(r, Fk(Ek.trim(t.slice(i1, l)))), r = !1, i1 = l + 1;
                            continue;
                        }
                    }
                } else {
                    if (-1 === (h = t.indexOf(u, l + 1))) break;
                    a(r, Ek.trim(t.slice(n + 1, h))), r = !1, i1 = (l = h) + 1;
                }
            } else r = t.slice(i1, l), i1 = l + 1, n = '"' === t.charAt(i1) || "'" === t.charAt(i1) ? i1 : Mk(t, l + 1);
        }
        return i1 < t.length && (!1 === r ? a(t.slice(i1)) : a(r, Fk(Ek.trim(t.slice(i1))))), Ek.trim(o.join(" "));
    };
    var Rk = ik.FilterCSS, Lk = Yw, jk = Tk, Bk = jk.parseTag, zk = jk.parseAttr, Hk = nk;
    function Gk(t) {
        return null == t;
    }
    function Wk(t) {
        (t = function(t) {
            var e = {};
            for(var i1 in t)e[i1] = t[i1];
            return e;
        }(t || {})).stripIgnoreTag && (t.onIgnoreTag && console.error('Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'), t.onIgnoreTag = Lk.onIgnoreTagStripAll), t.whiteList || t.allowList ? t.whiteList = function(t) {
            var e = {};
            for(var i1 in t)Array.isArray(t[i1]) ? e[i1.toLowerCase()] = t[i1].map(function(t) {
                return t.toLowerCase();
            }) : e[i1.toLowerCase()] = t[i1];
            return e;
        }(t.whiteList || t.allowList) : t.whiteList = Lk.whiteList, t.onTag = t.onTag || Lk.onTag, t.onTagAttr = t.onTagAttr || Lk.onTagAttr, t.onIgnoreTag = t.onIgnoreTag || Lk.onIgnoreTag, t.onIgnoreTagAttr = t.onIgnoreTagAttr || Lk.onIgnoreTagAttr, t.safeAttrValue = t.safeAttrValue || Lk.safeAttrValue, t.escapeHtml = t.escapeHtml || Lk.escapeHtml, this.options = t, !1 === t.css ? this.cssFilter = !1 : (t.css = t.css || {}, this.cssFilter = new Rk(t.css));
    }
    Wk.prototype.process = function(t) {
        if (!(t = (t = t || "").toString())) return "";
        var e = this.options, i1 = e.whiteList, n = e.onTag, o = e.onIgnoreTag, r = e.onTagAttr, s = e.onIgnoreTagAttr, a = e.safeAttrValue, l = e.escapeHtml, h = this.cssFilter;
        e.stripBlankChar && (t = Lk.stripBlankChar(t)), e.allowCommentTag || (t = Lk.stripCommentTag(t));
        var u = !1;
        e.stripIgnoreTagBody && (u = Lk.StripTagBody(e.stripIgnoreTagBody, o), o = u.onIgnoreTag);
        var c = Bk(t, function(t, e, u, c, d) {
            var p = {
                sourcePosition: t,
                position: e,
                isClosing: d,
                isWhite: Object.prototype.hasOwnProperty.call(i1, u)
            }, m = n(u, c, p);
            if (!Gk(m)) return m;
            if (p.isWhite) {
                if (p.isClosing) return "</" + u + ">";
                var f = function(t) {
                    var e = Hk.spaceIndex(t);
                    if (-1 === e) return {
                        html: "",
                        closing: "/" === t[t.length - 2]
                    };
                    var i1 = "/" === (t = Hk.trim(t.slice(e + 1, -1)))[t.length - 1];
                    return i1 && (t = Hk.trim(t.slice(0, -1))), {
                        html: t,
                        closing: i1
                    };
                }(c), v = i1[u], g = zk(f.html, function(t, e) {
                    var i1 = -1 !== Hk.indexOf(v, t), n = r(u, t, e, i1);
                    return Gk(n) ? i1 ? (e = a(u, t, e, h)) ? t + '="' + e + '"' : t : Gk(n = s(u, t, e, i1)) ? void 0 : n : n;
                });
                return c = "<" + u, g && (c += " " + g), f.closing && (c += " /"), c += ">";
            }
            return Gk(m = o(u, c, p)) ? l(c) : m;
        }, l);
        return u && (c = u.remove(c)), c;
    };
    var Yk = Wk;
    !function(t, e) {
        var i1 = Yw, n = Tk, o = Yk;
        function r(t, e) {
            return new o(e).process(t);
        }
        (e = t.exports = r).filterXSS = r, e.FilterXSS = o, function() {
            for(var t in i1)e[t] = i1[t];
            for(var o in n)e[o] = n[o];
        }(), "undefined" != typeof window && (window.filterXSS = t.exports), "undefined" != typeof self && "undefined" != typeof DedicatedWorkerGlobalScope && self instanceof DedicatedWorkerGlobalScope && (self.filterXSS = t.exports);
    }(Ww, Ww.exports);
    var Vk = r(Ww.exports);
    let Uk;
    const Xk = new Uint8Array(16);
    function qk() {
        if (!Uk && (Uk = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Uk)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        return Uk(Xk);
    }
    const Kk = [];
    for(let t = 0; t < 256; ++t)Kk.push((t + 256).toString(16).slice(1));
    var $k = {
        randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
    };
    function Zk(t, e, i1) {
        if ($k.randomUUID && !e && !t) return $k.randomUUID();
        const n = (t = t || {}).random || (t.rng || qk)();
        if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, e) {
            i1 = i1 || 0;
            for(let t = 0; t < 16; ++t)e[i1 + t] = n[t];
            return e;
        }
        return function(t, e = 0) {
            return Kk[t[e + 0]] + Kk[t[e + 1]] + Kk[t[e + 2]] + Kk[t[e + 3]] + "-" + Kk[t[e + 4]] + Kk[t[e + 5]] + "-" + Kk[t[e + 6]] + Kk[t[e + 7]] + "-" + Kk[t[e + 8]] + Kk[t[e + 9]] + "-" + Kk[t[e + 10]] + Kk[t[e + 11]] + Kk[t[e + 12]] + Kk[t[e + 13]] + Kk[t[e + 14]] + Kk[t[e + 15]];
        }(n);
    }
    function Qk(t, e) {
        var i1 = Dp(t);
        if (kd) {
            var n = kd(t);
            e && (n = Ed(n).call(n, function(e) {
                return Ld(t, e).enumerable;
            })), i1.push.apply(i1, n);
        }
        return i1;
    }
    function Jk(t) {
        for(var e = 1; e < arguments.length; e++){
            var i1, n, o = null != arguments[e] ? arguments[e] : {};
            e % 2 ? bd(i1 = Qk(Object(o), !0)).call(i1, function(e) {
                var i1, n, r;
                i1 = t, n = e, r = o[e], (n = dc(n)) in i1 ? Vo(i1, n, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : i1[n] = r;
            }) : qd ? ep(t, qd(o)) : bd(n = Qk(Object(o))).call(n, function(e) {
                Tp(t, e, Ld(o, e));
            });
        }
        return t;
    }
    function t_(t) {
        var e;
        if (!t) return !1;
        var i1 = null !== (e = t.idProp) && void 0 !== e ? e : t._idProp;
        return !!i1 && n.isDataViewLike(i1, t);
    }
    var e_ = /^\/?Date\((-?\d+)/i, i_ = /^\d+$/;
    function n_(t, i1) {
        var n;
        if (void 0 !== t) {
            if (null === t) return null;
            if (!i1) return t;
            if ("string" != typeof i1 && !(i1 instanceof String)) throw new Error("Type must be a string");
            switch(i1){
                case "boolean":
                case "Boolean":
                    return Boolean(t);
                case "number":
                case "Number":
                    return rw(t) && !isNaN(Date.parse(t)) ? e(t).valueOf() : Number(t.valueOf());
                case "string":
                case "String":
                    return String(t);
                case "Date":
                    try {
                        return n_(t, "Moment").toDate();
                    } catch (e) {
                        throw e instanceof TypeError ? new TypeError("Cannot convert object of type " + uw(t) + " to type " + i1) : e;
                    }
                case "Moment":
                    if (ow(t)) return e(t);
                    if (t instanceof Date) return e(t.valueOf());
                    if (e.isMoment(t)) return e(t);
                    if (rw(t)) return (n = e_.exec(t)) ? e(Number(n[1])) : (n = i_.exec(t), e(n ? Number(t) : t));
                    throw new TypeError("Cannot convert object of type " + uw(t) + " to type " + i1);
                case "ISODate":
                    if (ow(t)) return new Date(t);
                    if (t instanceof Date) return t.toISOString();
                    if (e.isMoment(t)) return t.toDate().toISOString();
                    if (rw(t)) return (n = e_.exec(t)) ? new Date(Number(n[1])).toISOString() : e(t).format();
                    throw new Error("Cannot convert object of type " + uw(t) + " to type ISODate");
                case "ASPDate":
                    if (ow(t)) return "/Date(" + t + ")/";
                    if (t instanceof Date || e.isMoment(t)) return "/Date(" + t.valueOf() + ")/";
                    if (rw(t)) return "/Date(" + ((n = e_.exec(t)) ? new Date(Number(n[1])).valueOf() : new Date(t).valueOf()) + ")/";
                    throw new Error("Cannot convert object of type " + uw(t) + " to type ASPDate");
                default:
                    throw new Error("Unknown type ".concat(i1));
            }
        }
    }
    function o_(t) {
        var e, i1, o, r, s, a, l = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            start: "Date",
            end: "Date"
        }, h = t._idProp, u = new n.DataSet({
            fieldId: h
        }), c = lp(e = n.createNewDataPipeFrom(t)).call(e, function(t) {
            var e;
            return xp(e = Dp(t)).call(e, function(e, i1) {
                return e[i1] = n_(t[i1], l[i1]), e;
            }, {});
        }).to(u);
        return c.all().start(), {
            add: function() {
                var e;
                return (e = t.getDataSet()).add.apply(e, arguments);
            },
            remove: function() {
                var e;
                return (e = t.getDataSet()).remove.apply(e, arguments);
            },
            update: function() {
                var e;
                return (e = t.getDataSet()).update.apply(e, arguments);
            },
            updateOnly: function() {
                var e;
                return (e = t.getDataSet()).updateOnly.apply(e, arguments);
            },
            clear: function() {
                var e;
                return (e = t.getDataSet()).clear.apply(e, arguments);
            },
            forEach: Hc(i1 = bd(u)).call(i1, u),
            get: Hc(o = u.get).call(o, u),
            getIds: Hc(r = u.getIds).call(r, u),
            off: Hc(s = u.off).call(s, u),
            on: Hc(a = u.on).call(a, u),
            get length () {
                return u.length;
            },
            idProp: h,
            type: l,
            rawDS: t,
            coercedDS: u,
            dispose: function() {
                return c.stop();
            }
        };
    }
    var r_ = function(t) {
        var e = new Vk.FilterXSS(t);
        return function(t) {
            return e.process(t);
        };
    }, s_ = function(t) {
        return t;
    }, a_ = r_(), l_ = Jk(Jk({}, Gw), {}, {
        convert: n_,
        setupXSSProtection: function(t) {
            t && (!0 === t.disabled ? (a_ = s_, console.warn("You disabled XSS protection for vis-Timeline. I sure hope you know what you're doing!")) : t.filterOptions && (a_ = r_(t.filterOptions)));
        }
    });
    Tp(l_, "xss", {
        get: function() {
            return a_;
        }
    });
    var h_ = a, u_ = l, c_ = Tr, d_ = og.trim, p_ = $v, m_ = b("".charAt), f_ = h_.parseFloat, v_ = h_.Symbol, g_ = v_ && v_.iterator, y_ = 1 / f_(p_ + "-0") != -1 / 0 || g_ && !u_(function() {
        f_(Object(g_));
    }) ? function(t) {
        var e = d_(c_(t)), i1 = f_(e);
        return 0 === i1 && "-" === m_(e, 0) ? -0 : i1;
    } : f_;
    Ii({
        global: !0,
        forced: parseFloat !== y_
    }, {
        parseFloat: y_
    });
    var b_ = r(ot.parseFloat), w_ = function() {
        function t(e, i1) {
            Lo(this, t), this.options = null, this.props = null;
        }
        return mc(t, [
            {
                key: "setOptions",
                value: function(t) {
                    t && l_.extend(this.options, t);
                }
            },
            {
                key: "redraw",
                value: function() {
                    return !1;
                }
            },
            {
                key: "destroy",
                value: function() {}
            },
            {
                key: "_isResized",
                value: function() {
                    var t = this.props._previousWidth !== this.props.width || this.props._previousHeight !== this.props.height;
                    return this.props._previousWidth = this.props.width, this.props._previousHeight = this.props.height, t;
                }
            }
        ]), t;
    }(), k_ = Sn, __ = Tr, x_ = Z, C_ = RangeError;
    Ii({
        target: "String",
        proto: !0
    }, {
        repeat: function(t) {
            var e = __(x_(this)), i1 = "", n = k_(t);
            if (n < 0 || n === 1 / 0) throw new C_("Wrong number of repetitions");
            for(; n > 0; (n >>>= 1) && (e += e))1 & n && (i1 += e);
            return i1;
        }
    });
    var S_ = _c("String").repeat, D_ = ut, T_ = S_, E_ = String.prototype, O_ = function(t) {
        var e = t.repeat;
        return "string" == typeof t || t === E_ || D_(E_, t) && e === E_.repeat ? T_ : e;
    }, A_ = r(O_), I_ = Lr, P_ = Math.floor, M_ = function(t, e) {
        var i1 = t.length, n = P_(i1 / 2);
        return i1 < 8 ? N_(t, e) : F_(t, M_(I_(t, 0, n), e), M_(I_(t, n), e), e);
    }, N_ = function(t, e) {
        for(var i1, n, o = t.length, r = 1; r < o;){
            for(n = r, i1 = t[r]; n && e(t[n - 1], i1) > 0;)t[n] = t[--n];
            n !== r++ && (t[n] = i1);
        }
        return t;
    }, F_ = function(t, e, i1, n) {
        for(var o = e.length, r = i1.length, s = 0, a = 0; s < o || a < r;)t[s + a] = s < o && a < r ? n(e[s], i1[a]) <= 0 ? e[s++] : i1[a++] : s < o ? e[s++] : i1[a++];
        return t;
    }, R_ = M_, L_ = ct.match(/firefox\/(\d+)/i), j_ = !!L_ && +L_[1], B_ = /MSIE|Trident/.test(ct), z_ = ct.match(/AppleWebKit\/(\d+)\./), H_ = !!z_ && +z_[1], G_ = Ii, W_ = b, Y_ = Nt, V_ = Qt, U_ = Mn, X_ = Mf, q_ = Tr, K_ = l, $_ = R_, Z_ = ld, Q_ = j_, J_ = B_, tx = yt, ex = H_, ix = [], nx = W_(ix.sort), ox = W_(ix.push), rx = K_(function() {
        ix.sort(void 0);
    }), sx = K_(function() {
        ix.sort(null);
    }), ax = Z_("sort"), lx = !K_(function() {
        if (tx) return tx < 70;
        if (!(Q_ && Q_ > 3)) {
            if (J_) return !0;
            if (ex) return ex < 603;
            var t, e, i1, n, o = "";
            for(t = 65; t < 76; t++){
                switch(e = String.fromCharCode(t), t){
                    case 66:
                    case 69:
                    case 70:
                    case 72:
                        i1 = 3;
                        break;
                    case 68:
                    case 71:
                        i1 = 4;
                        break;
                    default:
                        i1 = 2;
                }
                for(n = 0; n < 47; n++)ix.push({
                    k: e + n,
                    v: i1
                });
            }
            for(ix.sort(function(t, e) {
                return e.v - t.v;
            }), n = 0; n < ix.length; n++)e = ix[n].k.charAt(0), o.charAt(o.length - 1) !== e && (o += e);
            return "DGBEFHACIJK" !== o;
        }
    });
    G_({
        target: "Array",
        proto: !0,
        forced: rx || !sx || !ax || !lx
    }, {
        sort: function(t) {
            void 0 !== t && Y_(t);
            var e = V_(this);
            if (lx) return void 0 === t ? nx(e) : nx(e, t);
            var i1, n, o = [], r = U_(e);
            for(n = 0; n < r; n++)n in e && ox(o, e[n]);
            for($_(o, function(t) {
                return function(e, i1) {
                    return void 0 === i1 ? -1 : void 0 === e ? 1 : void 0 !== t ? +t(e, i1) || 0 : q_(e) > q_(i1) ? 1 : -1;
                };
            }(t)), i1 = U_(o), n = 0; n < i1;)e[n] = o[n++];
            for(; n < r;)X_(e, n++);
            return e;
        }
    });
    var hx = _c("Array").sort, ux = ut, cx = hx, dx = Array.prototype, px = function(t) {
        var e = t.sort;
        return t === dx || ux(dx, t) && e === dx.sort ? cx : e;
    }, mx = r(px);
    function fx(t, e, i1) {
        if (i1 && !zc(i1)) return fx(t, e, [
            i1
        ]);
        if (e.hiddenDates = [], i1 && 1 == zc(i1)) {
            for(var n, o = 0; o < i1.length; o++)if (void 0 === A_(i1[o])) {
                var r = {};
                r.start = t(i1[o].start).toDate().valueOf(), r.end = t(i1[o].end).toDate().valueOf(), e.hiddenDates.push(r);
            }
            mx(n = e.hiddenDates).call(n, function(t, e) {
                return t.start - e.start;
            });
        }
    }
    function vx(t, e, i1) {
        if (i1 && !zc(i1)) return vx(t, e, [
            i1
        ]);
        if (i1 && void 0 !== e.domProps.centerContainer.width) {
            fx(t, e, i1);
            for(var n = t(e.range.start), o = t(e.range.end), r = (e.range.end - e.range.start) / e.domProps.centerContainer.width, s = 0; s < i1.length; s++)if (void 0 !== A_(i1[s])) {
                var a = t(i1[s].start), l = t(i1[s].end);
                if ("Invalid Date" == a._d) throw new Error("Supplied start date is not valid: ".concat(i1[s].start));
                if ("Invalid Date" == l._d) throw new Error("Supplied end date is not valid: ".concat(i1[s].end));
                if (l - a >= 4 * r) {
                    var h = 0, u = o.clone();
                    switch(A_(i1[s])){
                        case "daily":
                            a.day() != l.day() && (h = 1), a.dayOfYear(n.dayOfYear()), a.year(n.year()), a.subtract(7, "days"), l.dayOfYear(n.dayOfYear()), l.year(n.year()), l.subtract(7 - h, "days"), u.add(1, "weeks");
                            break;
                        case "weekly":
                            var c = l.diff(a, "days"), d = a.day();
                            a.date(n.date()), a.month(n.month()), a.year(n.year()), l = a.clone(), a.day(d), l.day(d), l.add(c, "days"), a.subtract(1, "weeks"), l.subtract(1, "weeks"), u.add(1, "weeks");
                            break;
                        case "monthly":
                            a.month() != l.month() && (h = 1), a.month(n.month()), a.year(n.year()), a.subtract(1, "months"), l.month(n.month()), l.year(n.year()), l.subtract(1, "months"), l.add(h, "months"), u.add(1, "months");
                            break;
                        case "yearly":
                            a.year() != l.year() && (h = 1), a.year(n.year()), a.subtract(1, "years"), l.year(n.year()), l.subtract(1, "years"), l.add(h, "years"), u.add(1, "years");
                            break;
                        default:
                            return void console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", A_(i1[s]));
                    }
                    for(; a < u;)switch(e.hiddenDates.push({
                        start: a.valueOf(),
                        end: l.valueOf()
                    }), A_(i1[s])){
                        case "daily":
                            a.add(1, "days"), l.add(1, "days");
                            break;
                        case "weekly":
                            a.add(1, "weeks"), l.add(1, "weeks");
                            break;
                        case "monthly":
                            a.add(1, "months"), l.add(1, "months");
                            break;
                        case "yearly":
                            a.add(1, "y"), l.add(1, "y");
                            break;
                        default:
                            return void console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", A_(i1[s]));
                    }
                    e.hiddenDates.push({
                        start: a.valueOf(),
                        end: l.valueOf()
                    });
                }
            }
            gx(e);
            var p = Tx(e.range.start, e.hiddenDates), m = Tx(e.range.end, e.hiddenDates), f = e.range.start, v = e.range.end;
            1 == p.hidden && (f = 1 == e.range.startToFront ? p.startDate - 1 : p.endDate + 1), 1 == m.hidden && (v = 1 == e.range.endToFront ? m.startDate - 1 : m.endDate + 1), 1 != p.hidden && 1 != m.hidden || e.range._applyRange(f, v);
        }
    }
    function gx(t) {
        for(var e, i1 = t.hiddenDates, n = [], o = 0; o < i1.length; o++)for(var r = 0; r < i1.length; r++)o != r && 1 != i1[r].remove && 1 != i1[o].remove && (i1[r].start >= i1[o].start && i1[r].end <= i1[o].end ? i1[r].remove = !0 : i1[r].start >= i1[o].start && i1[r].start <= i1[o].end ? (i1[o].end = i1[r].end, i1[r].remove = !0) : i1[r].end >= i1[o].start && i1[r].end <= i1[o].end && (i1[o].start = i1[r].start, i1[r].remove = !0));
        for(o = 0; o < i1.length; o++)!0 !== i1[o].remove && n.push(i1[o]);
        t.hiddenDates = n, mx(e = t.hiddenDates).call(e, function(t, e) {
            return t.start - e.start;
        });
    }
    function yx(t, e, i1) {
        for(var n = !1, o = e.current.valueOf(), r = 0; r < e.hiddenDates.length; r++){
            var s = e.hiddenDates[r].start, a = e.hiddenDates[r].end;
            if (o >= s && o < a) {
                n = !0;
                break;
            }
        }
        if (1 == n && o < e._end.valueOf() && o != i1) {
            var l = t(i1), h = t(a);
            l.year() != h.year() ? e.switchedYear = !0 : l.month() != h.month() ? e.switchedMonth = !0 : l.dayOfYear() != h.dayOfYear() && (e.switchedDay = !0), e.current = h;
        }
    }
    function bx(t, e, i1) {
        var n;
        if (0 == t.body.hiddenDates.length) return n = t.range.conversion(i1), (e.valueOf() - n.offset) * n.scale;
        var o = Tx(e, t.body.hiddenDates);
        1 == o.hidden && (e = o.startDate);
        var r = kx(t.body.hiddenDates, t.range.start, t.range.end);
        if (e < t.range.start) {
            n = t.range.conversion(i1, r);
            var s = _x(t.body.hiddenDates, e, n.offset);
            return e = t.options.moment(e).toDate().valueOf(), e += s, -(n.offset - e.valueOf()) * n.scale;
        }
        if (e > t.range.end) {
            var a = {
                start: t.range.start,
                end: e
            };
            return e = xx(t.options.moment, t.body.hiddenDates, a, e), n = t.range.conversion(i1, r), (e.valueOf() - n.offset) * n.scale;
        }
        return e = xx(t.options.moment, t.body.hiddenDates, t.range, e), n = t.range.conversion(i1, r), (e.valueOf() - n.offset) * n.scale;
    }
    function wx(t, e, i1) {
        if (0 == t.body.hiddenDates.length) {
            var n = t.range.conversion(i1);
            return new Date(e / n.scale + n.offset);
        }
        var o = kx(t.body.hiddenDates, t.range.start, t.range.end), r = (t.range.end - t.range.start - o) * e / i1, s = Sx(t.body.hiddenDates, t.range, r);
        return new Date(s + r + t.range.start);
    }
    function kx(t, e, i1) {
        for(var n = 0, o = 0; o < t.length; o++){
            var r = t[o].start, s = t[o].end;
            r >= e && s < i1 && (n += s - r);
        }
        return n;
    }
    function _x(t, e, i1) {
        for(var n = 0, o = 0; o < t.length; o++){
            var r = t[o].start, s = t[o].end;
            r >= e && s <= i1 && (n += s - r);
        }
        return n;
    }
    function xx(t, e, i1, n) {
        return n = t(n).toDate().valueOf(), n -= Cx(t, e, i1, n);
    }
    function Cx(t, e, i1, n) {
        var o = 0;
        n = t(n).toDate().valueOf();
        for(var r = 0; r < e.length; r++){
            var s = e[r].start, a = e[r].end;
            s >= i1.start && a < i1.end && n >= a && (o += a - s);
        }
        return o;
    }
    function Sx(t, e, i1) {
        for(var n = 0, o = 0, r = e.start, s = 0; s < t.length; s++){
            var a = t[s].start, l = t[s].end;
            if (a >= e.start && l < e.end) {
                if (o += a - r, r = l, o >= i1) break;
                n += l - a;
            }
        }
        return n;
    }
    function Dx(t, e, i1, n) {
        var o = Tx(e, t);
        return 1 == o.hidden ? i1 < 0 ? 1 == n ? o.startDate - (o.endDate - e) - 1 : o.startDate - 1 : 1 == n ? o.endDate + (e - o.startDate) + 1 : o.endDate + 1 : e;
    }
    function Tx(t, e) {
        for(var i1 = 0; i1 < e.length; i1++){
            var n = e[i1].start, o = e[i1].end;
            if (t >= n && t < o) return {
                hidden: !0,
                startDate: n,
                endDate: o
            };
        }
        return {
            hidden: !1,
            startDate: n,
            endDate: o
        };
    }
    var Ex = Object.freeze({
        __proto__: null,
        convertHiddenOptions: fx,
        correctTimeForHidden: xx,
        getAccumulatedHiddenDuration: Sx,
        getHiddenDurationBefore: Cx,
        getHiddenDurationBeforeStart: _x,
        getHiddenDurationBetween: kx,
        getIsHidden: Tx,
        printDates: function(t) {
            for(var e = 0; e < t.length; e++)console.log(e, new Date(t[e].start), new Date(t[e].end), t[e].start, t[e].end, t[e].remove);
        },
        removeDuplicates: gx,
        snapAwayFromHidden: Dx,
        stepOverHiddenDates: yx,
        toScreen: bx,
        toTime: wx,
        updateHiddenDates: vx
    });
    function Ox(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    var Ax = function(t) {
        Ic(i1, t);
        var e = Ox(i1);
        function i1(t, n) {
            var o, r, s, a, l, h, u, c;
            Lo(this, i1), c = e.call(this);
            var d = wd().hours(0).minutes(0).seconds(0).milliseconds(0), p = d.clone().add(-3, "days").valueOf(), m = d.clone().add(3, "days").valueOf();
            return c.millisecondsPerPixelCache = void 0, void 0 === n ? (c.start = p, c.end = m) : (c.start = n.start || p, c.end = n.end || m), c.rolling = !1, c.body = t, c.deltaDifference = 0, c.scaleOffset = 0, c.startToFront = !1, c.endToFront = !0, c.defaultOptions = {
                rtl: !1,
                start: null,
                end: null,
                moment: wd,
                direction: "horizontal",
                moveable: !0,
                zoomable: !0,
                min: null,
                max: null,
                zoomMin: 10,
                zoomMax: 31536e10,
                rollingMode: {
                    follow: !1,
                    offset: .5
                }
            }, c.options = l_.extend({}, c.defaultOptions), c.props = {
                touch: {}
            }, c.animationTimer = null, c.body.emitter.on("panstart", Hc(o = c._onDragStart).call(o, fc(c))), c.body.emitter.on("panmove", Hc(r = c._onDrag).call(r, fc(c))), c.body.emitter.on("panend", Hc(s = c._onDragEnd).call(s, fc(c))), c.body.emitter.on("mousewheel", Hc(a = c._onMouseWheel).call(a, fc(c))), c.body.emitter.on("touch", Hc(l = c._onTouch).call(l, fc(c))), c.body.emitter.on("pinch", Hc(h = c._onPinch).call(h, fc(c))), c.body.dom.rollingModeBtn.addEventListener("click", Hc(u = c.startRolling).call(u, fc(c))), c.setOptions(n), c;
        }
        return mc(i1, [
            {
                key: "setOptions",
                value: function(t) {
                    if (t) l_.selectiveExtend([
                        "animation",
                        "direction",
                        "min",
                        "max",
                        "zoomMin",
                        "zoomMax",
                        "moveable",
                        "zoomable",
                        "moment",
                        "activate",
                        "hiddenDates",
                        "zoomKey",
                        "zoomFriction",
                        "rtl",
                        "showCurrentTime",
                        "rollingMode",
                        "horizontalScroll"
                    ], this.options, t), t.rollingMode && t.rollingMode.follow && this.startRolling(), ("start" in t || "end" in t) && this.setRange(t.start, t.end);
                }
            },
            {
                key: "startRolling",
                value: function() {
                    var t = this;
                    !function e() {
                        t.stopRolling(), t.rolling = !0;
                        var i1 = t.end - t.start, n = l_.convert(new Date, "Date").valueOf(), o = t.options.rollingMode && t.options.rollingMode.offset || .5, r = n - i1 * o, s = n + i1 * (1 - o);
                        t.setRange(r, s, {
                            animation: !1
                        }), (i1 = 1 / t.conversion(t.body.domProps.center.width).scale / 10) < 30 && (i1 = 30), i1 > 1e3 && (i1 = 1e3), t.body.dom.rollingModeBtn.style.visibility = "hidden", t.currentTimeTimer = sd(e, i1);
                    }();
                }
            },
            {
                key: "stopRolling",
                value: function() {
                    void 0 !== this.currentTimeTimer && (clearTimeout(this.currentTimeTimer), this.rolling = !1, this.body.dom.rollingModeBtn.style.visibility = "visible");
                }
            },
            {
                key: "setRange",
                value: function(t, e, i1, n, o) {
                    i1 || (i1 = {}), !0 !== i1.byUser && (i1.byUser = !1);
                    var r = this, s = null != t ? l_.convert(t, "Date").valueOf() : null, a = null != e ? l_.convert(e, "Date").valueOf() : null;
                    if (this._cancelAnimation(), this.millisecondsPerPixelCache = void 0, i1.animation) {
                        var l, h = this.start, u = this.end, c = "object" === uc(i1.animation) && "duration" in i1.animation ? i1.animation.duration : 500, d = "object" === uc(i1.animation) && "easingFunction" in i1.animation ? i1.animation.easingFunction : "easeInOutQuad", p = l_.easingFunctions[d];
                        if (!p) throw new Error(mf(l = "Unknown easing function ".concat(Fg(d), ". Choose from: ")).call(l, Dp(l_.easingFunctions).join(", ")));
                        var m = wf(), f = !1;
                        return function t() {
                            if (!r.props.touch.dragging) {
                                var e = wf() - m, l = p(e / c), d = e > c, g = d || null === s ? s : h + (s - h) * l, y = d || null === a ? a : u + (a - u) * l;
                                v = r._applyRange(g, y), vx(r.options.moment, r.body, r.options.hiddenDates), f = f || v;
                                var b = {
                                    start: new Date(r.start),
                                    end: new Date(r.end),
                                    byUser: i1.byUser,
                                    event: i1.event
                                };
                                if (o && o(l, v, d), v && r.body.emitter.emit("rangechange", b), d) {
                                    if (f && (r.body.emitter.emit("rangechanged", b), n)) return n();
                                } else r.animationTimer = sd(t, 20);
                            }
                        }();
                    }
                    var v = this._applyRange(s, a);
                    if (vx(this.options.moment, this.body, this.options.hiddenDates), v) {
                        var g = {
                            start: new Date(this.start),
                            end: new Date(this.end),
                            byUser: i1.byUser,
                            event: i1.event
                        };
                        if (this.body.emitter.emit("rangechange", g), clearTimeout(r.timeoutID), r.timeoutID = sd(function() {
                            r.body.emitter.emit("rangechanged", g);
                        }, 200), n) return n();
                    }
                }
            },
            {
                key: "getMillisecondsPerPixel",
                value: function() {
                    return void 0 === this.millisecondsPerPixelCache && (this.millisecondsPerPixelCache = (this.end - this.start) / this.body.dom.center.clientWidth), this.millisecondsPerPixelCache;
                }
            },
            {
                key: "_cancelAnimation",
                value: function() {
                    this.animationTimer && (clearTimeout(this.animationTimer), this.animationTimer = null);
                }
            },
            {
                key: "_applyRange",
                value: function(t, e) {
                    var i1, n = null != t ? l_.convert(t, "Date").valueOf() : this.start, o = null != e ? l_.convert(e, "Date").valueOf() : this.end, r = null != this.options.max ? l_.convert(this.options.max, "Date").valueOf() : null, s = null != this.options.min ? l_.convert(this.options.min, "Date").valueOf() : null;
                    if (isNaN(n) || null === n) throw new Error('Invalid start "'.concat(t, '"'));
                    if (isNaN(o) || null === o) throw new Error('Invalid end "'.concat(e, '"'));
                    if (o < n && (o = n), null !== s && n < s && (n += i1 = s - n, o += i1, null != r && o > r && (o = r)), null !== r && o > r && (n -= i1 = o - r, o -= i1, null != s && n < s && (n = s)), null !== this.options.zoomMin) {
                        var a = b_(this.options.zoomMin);
                        if (a < 0 && (a = 0), o - n < a) this.end - this.start === a && n >= this.start - .5 && o <= this.end ? (n = this.start, o = this.end) : (n -= (i1 = a - (o - n)) / 2, o += i1 / 2);
                    }
                    if (null !== this.options.zoomMax) {
                        var l = b_(this.options.zoomMax);
                        l < 0 && (l = 0), o - n > l && (this.end - this.start === l && n < this.start && o > this.end ? (n = this.start, o = this.end) : (n += (i1 = o - n - l) / 2, o -= i1 / 2));
                    }
                    var h = this.start != n || this.end != o;
                    return n >= this.start && n <= this.end || o >= this.start && o <= this.end || this.start >= n && this.start <= o || this.end >= n && this.end <= o || this.body.emitter.emit("checkRangedItems"), this.start = n, this.end = o, h;
                }
            },
            {
                key: "getRange",
                value: function() {
                    return {
                        start: this.start,
                        end: this.end
                    };
                }
            },
            {
                key: "conversion",
                value: function(t, e) {
                    return i1.conversion(this.start, this.end, t, e);
                }
            },
            {
                key: "_onDragStart",
                value: function(t) {
                    this.deltaDifference = 0, this.previousDelta = 0, this.options.moveable && this._isInsideRange(t) && this.props.touch.allowDragging && (this.stopRolling(), this.props.touch.start = this.start, this.props.touch.end = this.end, this.props.touch.dragging = !0, this.body.dom.root && (this.body.dom.root.style.cursor = "move"));
                }
            },
            {
                key: "_onDrag",
                value: function(t) {
                    if (t && this.props.touch.dragging && this.options.moveable && this.props.touch.allowDragging) {
                        var e = this.options.direction;
                        Ix(e);
                        var i1 = "horizontal" == e ? t.deltaX : t.deltaY;
                        i1 -= this.deltaDifference;
                        var n = this.props.touch.end - this.props.touch.start;
                        n -= kx(this.body.hiddenDates, this.start, this.end);
                        var o, r = "horizontal" == e ? this.body.domProps.center.width : this.body.domProps.center.height;
                        o = this.options.rtl ? i1 / r * n : -i1 / r * n;
                        var s = this.props.touch.start + o, a = this.props.touch.end + o, l = Dx(this.body.hiddenDates, s, this.previousDelta - i1, !0), h = Dx(this.body.hiddenDates, a, this.previousDelta - i1, !0);
                        if (l != s || h != a) return this.deltaDifference += i1, this.props.touch.start = l, this.props.touch.end = h, void this._onDrag(t);
                        this.previousDelta = i1, this._applyRange(s, a);
                        var u = new Date(this.start), c = new Date(this.end);
                        this.body.emitter.emit("rangechange", {
                            start: u,
                            end: c,
                            byUser: !0,
                            event: t
                        }), this.body.emitter.emit("panmove");
                    }
                }
            },
            {
                key: "_onDragEnd",
                value: function(t) {
                    this.props.touch.dragging && this.options.moveable && this.props.touch.allowDragging && (this.props.touch.dragging = !1, this.body.dom.root && (this.body.dom.root.style.cursor = "auto"), this.body.emitter.emit("rangechanged", {
                        start: new Date(this.start),
                        end: new Date(this.end),
                        byUser: !0,
                        event: t
                    }));
                }
            },
            {
                key: "_onMouseWheel",
                value: function(t) {
                    var e = 0;
                    if (t.wheelDelta ? e = t.wheelDelta / 120 : t.detail ? e = -t.detail / 3 : t.deltaY && (e = -t.deltaY / 3), !(this.options.zoomKey && !t[this.options.zoomKey] && this.options.zoomable || !this.options.zoomable && this.options.moveable) && this.options.zoomable && this.options.moveable && this._isInsideRange(t) && e) {
                        var i1, n, o = this.options.zoomFriction || 5;
                        if (i1 = e < 0 ? 1 - e / o : 1 / (1 + e / o), this.rolling) {
                            var r = this.options.rollingMode && this.options.rollingMode.offset || .5;
                            n = this.start + (this.end - this.start) * r;
                        } else {
                            var s = this.getPointer({
                                x: t.clientX,
                                y: t.clientY
                            }, this.body.dom.center);
                            n = this._pointerToDate(s);
                        }
                        this.zoom(i1, n, e, t), t.preventDefault();
                    }
                }
            },
            {
                key: "_onTouch",
                value: function(t) {
                    this.props.touch.start = this.start, this.props.touch.end = this.end, this.props.touch.allowDragging = !0, this.props.touch.center = null, this.props.touch.centerDate = null, this.scaleOffset = 0, this.deltaDifference = 0, l_.preventDefault(t);
                }
            },
            {
                key: "_onPinch",
                value: function(t) {
                    if (this.options.zoomable && this.options.moveable) {
                        l_.preventDefault(t), this.props.touch.allowDragging = !1, this.props.touch.center || (this.props.touch.center = this.getPointer(t.center, this.body.dom.center), this.props.touch.centerDate = this._pointerToDate(this.props.touch.center)), this.stopRolling();
                        var e = 1 / (t.scale + this.scaleOffset), i1 = this.props.touch.centerDate, n = kx(this.body.hiddenDates, this.start, this.end), o = Cx(this.options.moment, this.body.hiddenDates, this, i1), r = n - o, s = i1 - o + (this.props.touch.start - (i1 - o)) * e, a = i1 + r + (this.props.touch.end - (i1 + r)) * e;
                        this.startToFront = 1 - e <= 0, this.endToFront = e - 1 <= 0;
                        var l = Dx(this.body.hiddenDates, s, 1 - e, !0), h = Dx(this.body.hiddenDates, a, e - 1, !0);
                        l == s && h == a || (this.props.touch.start = l, this.props.touch.end = h, this.scaleOffset = 1 - t.scale, s = l, a = h);
                        var u = {
                            animation: !1,
                            byUser: !0,
                            event: t
                        };
                        this.setRange(s, a, u), this.startToFront = !1, this.endToFront = !0;
                    }
                }
            },
            {
                key: "_isInsideRange",
                value: function(t) {
                    var e = t.center ? t.center.x : t.clientX, i1 = this.body.dom.centerContainer.getBoundingClientRect(), n = this.options.rtl ? e - i1.left : i1.right - e, o = this.body.util.toTime(n);
                    return o >= this.start && o <= this.end;
                }
            },
            {
                key: "_pointerToDate",
                value: function(t) {
                    var e, i1 = this.options.direction;
                    if (Ix(i1), "horizontal" == i1) return this.body.util.toTime(t.x).valueOf();
                    var n = this.body.domProps.center.height;
                    return e = this.conversion(n), t.y / e.scale + e.offset;
                }
            },
            {
                key: "getPointer",
                value: function(t, e) {
                    var i1 = e.getBoundingClientRect();
                    return this.options.rtl ? {
                        x: i1.right - t.x,
                        y: t.y - i1.top
                    } : {
                        x: t.x - i1.left,
                        y: t.y - i1.top
                    };
                }
            },
            {
                key: "zoom",
                value: function(t, e, i1, n) {
                    null == e && (e = (this.start + this.end) / 2);
                    var o = kx(this.body.hiddenDates, this.start, this.end), r = Cx(this.options.moment, this.body.hiddenDates, this, e), s = o - r, a = e - r + (this.start - (e - r)) * t, l = e + s + (this.end - (e + s)) * t;
                    this.startToFront = !(i1 > 0), this.endToFront = !(-i1 > 0);
                    var h = Dx(this.body.hiddenDates, a, i1, !0), u = Dx(this.body.hiddenDates, l, -i1, !0);
                    h == a && u == l || (a = h, l = u);
                    var c = {
                        animation: !1,
                        byUser: !0,
                        event: n
                    };
                    this.setRange(a, l, c), this.startToFront = !1, this.endToFront = !0;
                }
            },
            {
                key: "move",
                value: function(t) {
                    var e = this.end - this.start, i1 = this.start + e * t, n = this.end + e * t;
                    this.start = i1, this.end = n;
                }
            },
            {
                key: "moveTo",
                value: function(t) {
                    var e = (this.start + this.end) / 2 - t, i1 = this.start - e, n = this.end - e;
                    this.setRange(i1, n, {
                        animation: !1,
                        byUser: !0,
                        event: null
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.stopRolling();
                }
            }
        ], [
            {
                key: "conversion",
                value: function(t, e, i1, n) {
                    return void 0 === n && (n = 0), 0 != i1 && e - t != 0 ? {
                        offset: t,
                        scale: i1 / (e - t - n)
                    } : {
                        offset: 0,
                        scale: 1
                    };
                }
            }
        ]), i1;
    }(w_);
    function Ix(t) {
        if ("horizontal" != t && "vertical" != t) throw new TypeError('Unknown direction "'.concat(t, '". Choose "horizontal" or "vertical".'));
    }
    var Px = Hs.some;
    Ii({
        target: "Array",
        proto: !0,
        forced: !ld("some")
    }, {
        some: function(t) {
            return Px(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var Mx, Nx = _c("Array").some, Fx = ut, Rx = Nx, Lx = Array.prototype, jx = function(t) {
        var e = t.some;
        return t === Lx || Fx(Lx, t) && e === Lx.some ? Rx : e;
    }, Bx = r(jx), zx = r(ot.setInterval), Hx = null;
    "undefined" != typeof window ? Mx = function t(e, i1) {
        var n = i1 || {
            preventDefault: !1
        };
        if (e.Manager) {
            var o = e, r = function(e, i1) {
                var r = Object.create(n);
                return i1 && o.assign(r, i1), t(new o(e, r), r);
            };
            return o.assign(r, o), r.Manager = function(e, i1) {
                var r = Object.create(n);
                return i1 && o.assign(r, i1), t(new o.Manager(e, r), r);
            }, r;
        }
        var s = Object.create(e), a = e.element;
        function l(t) {
            return t.match(/[^ ]+/g);
        }
        function h(t) {
            if ("hammer.input" !== t.type) {
                if (t.srcEvent._handled || (t.srcEvent._handled = {}), t.srcEvent._handled[t.type]) return;
                t.srcEvent._handled[t.type] = !0;
            }
            var e = !1;
            t.stopPropagation = function() {
                e = !0;
            };
            var i1 = t.srcEvent.stopPropagation.bind(t.srcEvent);
            "function" == typeof i1 && (t.srcEvent.stopPropagation = function() {
                i1(), t.stopPropagation();
            }), t.firstTarget = Hx;
            for(var n = Hx; n && !e;){
                var o = n.hammer;
                if (o) {
                    for(var r, s = 0; s < o.length; s++)if (r = o[s]._handlers[t.type]) for(var a = 0; a < r.length && !e; a++)r[a](t);
                }
                n = n.parentNode;
            }
        }
        return a.hammer || (a.hammer = []), a.hammer.push(s), e.on("hammer.input", function(t) {
            !0 !== n.preventDefault && n.preventDefault !== t.pointerType || t.preventDefault(), t.isFirst && (Hx = t.target);
        }), s._handlers = {}, s.on = function(t, i1) {
            return l(t).forEach(function(t) {
                var n = s._handlers[t];
                n || (s._handlers[t] = n = [], e.on(t, h)), n.push(i1);
            }), s;
        }, s.off = function(t, i1) {
            return l(t).forEach(function(t) {
                var n = s._handlers[t];
                n && ((n = i1 ? n.filter(function(t) {
                    return t !== i1;
                }) : []).length > 0 ? s._handlers[t] = n : (e.off(t, h), delete s._handlers[t]));
            }), s;
        }, s.emit = function(_t1, i1) {
            Hx = i1.target, e.emit(_t1, i1);
        }, s.destroy = function() {
            var t = e.element.hammer, i1 = t.indexOf(s);
            -1 !== i1 && t.splice(i1, 1), t.length || delete e.element.hammer, s._handlers = {}, e.destroy();
        }, s;
    }(window.Hammer || Wb, {
        preventDefault: "mouse"
    }) : Mx = function() {
        return function() {
            var t = function() {};
            return {
                on: t,
                off: t,
                destroy: t,
                emit: t,
                get: function(e) {
                    return {
                        set: t
                    };
                }
            };
        }();
    };
    var Gx = Mx;
    function Wx(t, e) {
        e.inputHandler = function(t) {
            t.isFirst && e(t);
        }, t.on("hammer.input", e.inputHandler);
    }
    var Yx = function() {
        function t(e, i1, n, o, r) {
            Lo(this, t), this.moment = r && r.moment || wd, this.options = r || {}, this.current = this.moment(), this._start = this.moment(), this._end = this.moment(), this.autoScale = !0, this.scale = "day", this.step = 1, this.setRange(e, i1, n), this.switchedDay = !1, this.switchedMonth = !1, this.switchedYear = !1, zc(o) ? this.hiddenDates = o : this.hiddenDates = null != o ? [
                o
            ] : [], this.format = t.FORMAT;
        }
        return mc(t, [
            {
                key: "setMoment",
                value: function(t) {
                    this.moment = t, this.current = this.moment(this.current.valueOf()), this._start = this.moment(this._start.valueOf()), this._end = this.moment(this._end.valueOf());
                }
            },
            {
                key: "setFormat",
                value: function(e) {
                    var i1 = l_.deepExtend({}, t.FORMAT);
                    this.format = l_.deepExtend(i1, e);
                }
            },
            {
                key: "setRange",
                value: function(t, e, i1) {
                    if (!(t instanceof Date && e instanceof Date)) throw "No legal start or end date in method setRange";
                    this._start = null != t ? this.moment(t.valueOf()) : wf(), this._end = null != e ? this.moment(e.valueOf()) : wf(), this.autoScale && this.setMinimumStep(i1);
                }
            },
            {
                key: "start",
                value: function() {
                    this.current = this._start.clone(), this.roundToMinor();
                }
            },
            {
                key: "roundToMinor",
                value: function() {
                    switch("week" == this.scale && this.current.weekday(0), this.scale){
                        case "year":
                            this.current.year(this.step * Math.floor(this.current.year() / this.step)), this.current.month(0);
                        case "month":
                            this.current.date(1);
                        case "week":
                        case "day":
                        case "weekday":
                            this.current.hours(0);
                        case "hour":
                            this.current.minutes(0);
                        case "minute":
                            this.current.seconds(0);
                        case "second":
                            this.current.milliseconds(0);
                    }
                    if (1 != this.step) {
                        var t = this.current.clone();
                        switch(this.scale){
                            case "millisecond":
                                this.current.subtract(this.current.milliseconds() % this.step, "milliseconds");
                                break;
                            case "second":
                                this.current.subtract(this.current.seconds() % this.step, "seconds");
                                break;
                            case "minute":
                                this.current.subtract(this.current.minutes() % this.step, "minutes");
                                break;
                            case "hour":
                                this.current.subtract(this.current.hours() % this.step, "hours");
                                break;
                            case "weekday":
                            case "day":
                                this.current.subtract((this.current.date() - 1) % this.step, "day");
                                break;
                            case "week":
                                this.current.subtract(this.current.week() % this.step, "week");
                                break;
                            case "month":
                                this.current.subtract(this.current.month() % this.step, "month");
                                break;
                            case "year":
                                this.current.subtract(this.current.year() % this.step, "year");
                        }
                        t.isSame(this.current) || (this.current = this.moment(Dx(this.hiddenDates, this.current.valueOf(), -1, !0)));
                    }
                }
            },
            {
                key: "hasNext",
                value: function() {
                    return this.current.valueOf() <= this._end.valueOf();
                }
            },
            {
                key: "next",
                value: function() {
                    var t = this.current.valueOf();
                    switch(this.scale){
                        case "millisecond":
                            this.current.add(this.step, "millisecond");
                            break;
                        case "second":
                            this.current.add(this.step, "second");
                            break;
                        case "minute":
                            this.current.add(this.step, "minute");
                            break;
                        case "hour":
                            this.current.add(this.step, "hour"), this.current.month() < 6 ? this.current.subtract(this.current.hours() % this.step, "hour") : this.current.hours() % this.step != 0 && this.current.add(this.step - this.current.hours() % this.step, "hour");
                            break;
                        case "weekday":
                        case "day":
                            this.current.add(this.step, "day");
                            break;
                        case "week":
                            if (0 !== this.current.weekday()) this.current.weekday(0), this.current.add(this.step, "week");
                            else if (!1 === this.options.showMajorLabels) this.current.add(this.step, "week");
                            else {
                                var e = this.current.clone();
                                e.add(1, "week"), e.isSame(this.current, "month") ? this.current.add(this.step, "week") : (this.current.add(this.step, "week"), this.current.date(1));
                            }
                            break;
                        case "month":
                            this.current.add(this.step, "month");
                            break;
                        case "year":
                            this.current.add(this.step, "year");
                    }
                    if (1 != this.step) switch(this.scale){
                        case "millisecond":
                            this.current.milliseconds() > 0 && this.current.milliseconds() < this.step && this.current.milliseconds(0);
                            break;
                        case "second":
                            this.current.seconds() > 0 && this.current.seconds() < this.step && this.current.seconds(0);
                            break;
                        case "minute":
                            this.current.minutes() > 0 && this.current.minutes() < this.step && this.current.minutes(0);
                            break;
                        case "hour":
                            this.current.hours() > 0 && this.current.hours() < this.step && this.current.hours(0);
                            break;
                        case "weekday":
                        case "day":
                            this.current.date() < this.step + 1 && this.current.date(1);
                            break;
                        case "week":
                            this.current.week() < this.step && this.current.week(1);
                            break;
                        case "month":
                            this.current.month() < this.step && this.current.month(0);
                    }
                    this.current.valueOf() == t && (this.current = this._end.clone()), this.switchedDay = !1, this.switchedMonth = !1, this.switchedYear = !1, yx(this.moment, this, t);
                }
            },
            {
                key: "getCurrent",
                value: function() {
                    return this.current.clone();
                }
            },
            {
                key: "setScale",
                value: function(t) {
                    t && "string" == typeof t.scale && (this.scale = t.scale, this.step = t.step > 0 ? t.step : 1, this.autoScale = !1);
                }
            },
            {
                key: "setAutoScale",
                value: function(t) {
                    this.autoScale = t;
                }
            },
            {
                key: "setMinimumStep",
                value: function(t) {
                    if (null != t) {
                        var e = 31104e6, i1 = 2592e6, n = 864e5, o = 36e5, r = 6e4, s = 1e3;
                        1e3 * e > t && (this.scale = "year", this.step = 1e3), 500 * e > t && (this.scale = "year", this.step = 500), 100 * e > t && (this.scale = "year", this.step = 100), 50 * e > t && (this.scale = "year", this.step = 50), 10 * e > t && (this.scale = "year", this.step = 10), 5 * e > t && (this.scale = "year", this.step = 5), e > t && (this.scale = "year", this.step = 1), 7776e6 > t && (this.scale = "month", this.step = 3), i1 > t && (this.scale = "month", this.step = 1), 6048e5 > t && this.options.showWeekScale && (this.scale = "week", this.step = 1), 1728e5 > t && (this.scale = "day", this.step = 2), n > t && (this.scale = "day", this.step = 1), 432e5 > t && (this.scale = "weekday", this.step = 1), 144e5 > t && (this.scale = "hour", this.step = 4), o > t && (this.scale = "hour", this.step = 1), 9e5 > t && (this.scale = "minute", this.step = 15), 6e5 > t && (this.scale = "minute", this.step = 10), 3e5 > t && (this.scale = "minute", this.step = 5), r > t && (this.scale = "minute", this.step = 1), 15e3 > t && (this.scale = "second", this.step = 15), 1e4 > t && (this.scale = "second", this.step = 10), 5e3 > t && (this.scale = "second", this.step = 5), s > t && (this.scale = "second", this.step = 1), 200 > t && (this.scale = "millisecond", this.step = 200), 100 > t && (this.scale = "millisecond", this.step = 100), 50 > t && (this.scale = "millisecond", this.step = 50), 10 > t && (this.scale = "millisecond", this.step = 10), 5 > t && (this.scale = "millisecond", this.step = 5), 1 > t && (this.scale = "millisecond", this.step = 1);
                    }
                }
            },
            {
                key: "isMajor",
                value: function() {
                    if (1 == this.switchedYear) switch(this.scale){
                        case "year":
                        case "month":
                        case "week":
                        case "weekday":
                        case "day":
                        case "hour":
                        case "minute":
                        case "second":
                        case "millisecond":
                            return !0;
                        default:
                            return !1;
                    }
                    else if (1 == this.switchedMonth) switch(this.scale){
                        case "week":
                        case "weekday":
                        case "day":
                        case "hour":
                        case "minute":
                        case "second":
                        case "millisecond":
                            return !0;
                        default:
                            return !1;
                    }
                    else if (1 == this.switchedDay) switch(this.scale){
                        case "millisecond":
                        case "second":
                        case "minute":
                        case "hour":
                            return !0;
                        default:
                            return !1;
                    }
                    var t = this.moment(this.current);
                    switch(this.scale){
                        case "millisecond":
                            return 0 == t.milliseconds();
                        case "second":
                            return 0 == t.seconds();
                        case "minute":
                            return 0 == t.hours() && 0 == t.minutes();
                        case "hour":
                            return 0 == t.hours();
                        case "weekday":
                        case "day":
                            return this.options.showWeekScale ? 1 == t.isoWeekday() : 1 == t.date();
                        case "week":
                            return 1 == t.date();
                        case "month":
                            return 0 == t.month();
                        default:
                            return !1;
                    }
                }
            },
            {
                key: "getLabelMinor",
                value: function(t) {
                    if (null == t && (t = this.current), t instanceof Date && (t = this.moment(t)), "function" == typeof this.format.minorLabels) return this.format.minorLabels(t, this.scale, this.step);
                    var e = this.format.minorLabels[this.scale];
                    return "week" === this.scale && 1 === t.date() && 0 !== t.weekday() ? "" : e && e.length > 0 ? this.moment(t).format(e) : "";
                }
            },
            {
                key: "getLabelMajor",
                value: function(t) {
                    if (null == t && (t = this.current), t instanceof Date && (t = this.moment(t)), "function" == typeof this.format.majorLabels) return this.format.majorLabels(t, this.scale, this.step);
                    var e = this.format.majorLabels[this.scale];
                    return e && e.length > 0 ? this.moment(t).format(e) : "";
                }
            },
            {
                key: "getClassName",
                value: function() {
                    var t, e = this.moment, i1 = this.moment(this.current), n = i1.locale ? i1.locale("en") : i1.lang("en"), o = this.step, r = [];
                    function s(t) {
                        return t / o % 2 == 0 ? " vis-even" : " vis-odd";
                    }
                    function a(t) {
                        return t.isSame(wf(), "day") ? " vis-today" : t.isSame(e().add(1, "day"), "day") ? " vis-tomorrow" : t.isSame(e().add(-1, "day"), "day") ? " vis-yesterday" : "";
                    }
                    function l(t) {
                        return t.isSame(wf(), "week") ? " vis-current-week" : "";
                    }
                    function h(t) {
                        return t.isSame(wf(), "month") ? " vis-current-month" : "";
                    }
                    switch(this.scale){
                        case "millisecond":
                            r.push(a(n)), r.push(s(n.milliseconds()));
                            break;
                        case "second":
                            r.push(a(n)), r.push(s(n.seconds()));
                            break;
                        case "minute":
                            r.push(a(n)), r.push(s(n.minutes()));
                            break;
                        case "hour":
                            r.push(mf(t = "vis-h".concat(n.hours())).call(t, 4 == this.step ? "-h" + (n.hours() + 4) : "")), r.push(a(n)), r.push(s(n.hours()));
                            break;
                        case "weekday":
                            r.push("vis-".concat(n.format("dddd").toLowerCase())), r.push(a(n)), r.push(l(n)), r.push(s(n.date()));
                            break;
                        case "day":
                            r.push("vis-day".concat(n.date())), r.push("vis-".concat(n.format("MMMM").toLowerCase())), r.push(a(n)), r.push(h(n)), r.push(this.step <= 2 ? a(n) : ""), r.push(this.step <= 2 ? "vis-".concat(n.format("dddd").toLowerCase()) : ""), r.push(s(n.date() - 1));
                            break;
                        case "week":
                            r.push("vis-week".concat(n.format("w"))), r.push(l(n)), r.push(s(n.week()));
                            break;
                        case "month":
                            r.push("vis-".concat(n.format("MMMM").toLowerCase())), r.push(h(n)), r.push(s(n.month()));
                            break;
                        case "year":
                            r.push("vis-year".concat(n.year())), r.push(function(t) {
                                return t.isSame(wf(), "year") ? " vis-current-year" : "";
                            }(n)), r.push(s(n.year()));
                    }
                    return Ed(r).call(r, String).join(" ");
                }
            }
        ], [
            {
                key: "snap",
                value: function(t, e, i1) {
                    var n = wd(t);
                    if ("year" == e) {
                        var o = n.year() + Math.round(n.month() / 12);
                        n.year(Math.round(o / i1) * i1), n.month(0), n.date(0), n.hours(0), n.minutes(0), n.seconds(0), n.milliseconds(0);
                    } else if ("month" == e) n.date() > 15 ? (n.date(1), n.add(1, "month")) : n.date(1), n.hours(0), n.minutes(0), n.seconds(0), n.milliseconds(0);
                    else if ("week" == e) n.weekday() > 2 ? (n.weekday(0), n.add(1, "week")) : n.weekday(0), n.hours(0), n.minutes(0), n.seconds(0), n.milliseconds(0);
                    else if ("day" == e) {
                        switch(i1){
                            case 5:
                            case 2:
                                n.hours(24 * Math.round(n.hours() / 24));
                                break;
                            default:
                                n.hours(12 * Math.round(n.hours() / 12));
                        }
                        n.minutes(0), n.seconds(0), n.milliseconds(0);
                    } else if ("weekday" == e) {
                        switch(i1){
                            case 5:
                            case 2:
                                n.hours(12 * Math.round(n.hours() / 12));
                                break;
                            default:
                                n.hours(6 * Math.round(n.hours() / 6));
                        }
                        n.minutes(0), n.seconds(0), n.milliseconds(0);
                    } else if ("hour" == e) {
                        if (4 === i1) n.minutes(60 * Math.round(n.minutes() / 60));
                        else n.minutes(30 * Math.round(n.minutes() / 30));
                        n.seconds(0), n.milliseconds(0);
                    } else if ("minute" == e) {
                        switch(i1){
                            case 15:
                            case 10:
                                n.minutes(5 * Math.round(n.minutes() / 5)), n.seconds(0);
                                break;
                            case 5:
                                n.seconds(60 * Math.round(n.seconds() / 60));
                                break;
                            default:
                                n.seconds(30 * Math.round(n.seconds() / 30));
                        }
                        n.milliseconds(0);
                    } else if ("second" == e) switch(i1){
                        case 15:
                        case 10:
                            n.seconds(5 * Math.round(n.seconds() / 5)), n.milliseconds(0);
                            break;
                        case 5:
                            n.milliseconds(1e3 * Math.round(n.milliseconds() / 1e3));
                            break;
                        default:
                            n.milliseconds(500 * Math.round(n.milliseconds() / 500));
                    }
                    else if ("millisecond" == e) {
                        var r = i1 > 5 ? i1 / 2 : 1;
                        n.milliseconds(Math.round(n.milliseconds() / r) * r);
                    }
                    return n;
                }
            }
        ]), t;
    }();
    function Vx(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    Yx.FORMAT = {
        minorLabels: {
            millisecond: "SSS",
            second: "s",
            minute: "HH:mm",
            hour: "HH:mm",
            weekday: "ddd D",
            day: "D",
            week: "w",
            month: "MMM",
            year: "YYYY"
        },
        majorLabels: {
            millisecond: "HH:mm:ss",
            second: "D MMMM HH:mm",
            minute: "ddd D MMMM",
            hour: "ddd D MMMM",
            weekday: "MMMM YYYY",
            day: "MMMM YYYY",
            week: "MMMM YYYY",
            month: "YYYY",
            year: ""
        }
    };
    var Ux = function(t) {
        Ic(i1, t);
        var e = Vx(i1);
        function i1(t, n) {
            var o;
            return Lo(this, i1), (o = e.call(this)).dom = {
                foreground: null,
                lines: [],
                majorTexts: [],
                minorTexts: [],
                redundant: {
                    lines: [],
                    majorTexts: [],
                    minorTexts: []
                }
            }, o.props = {
                range: {
                    start: 0,
                    end: 0,
                    minimumStep: 0
                },
                lineTop: 0
            }, o.defaultOptions = {
                orientation: {
                    axis: "bottom"
                },
                showMinorLabels: !0,
                showMajorLabels: !0,
                showWeekScale: !1,
                maxMinorChars: 7,
                format: l_.extend({}, Yx.FORMAT),
                moment: wd,
                timeAxis: null
            }, o.options = l_.extend({}, o.defaultOptions), o.body = t, o._create(), o.setOptions(n), o;
        }
        return mc(i1, [
            {
                key: "setOptions",
                value: function(t) {
                    t && (l_.selectiveExtend([
                        "showMinorLabels",
                        "showMajorLabels",
                        "showWeekScale",
                        "maxMinorChars",
                        "hiddenDates",
                        "timeAxis",
                        "moment",
                        "rtl"
                    ], this.options, t), l_.selectiveDeepExtend([
                        "format"
                    ], this.options, t), "orientation" in t && ("string" == typeof t.orientation ? this.options.orientation.axis = t.orientation : "object" === uc(t.orientation) && "axis" in t.orientation && (this.options.orientation.axis = t.orientation.axis)), "locale" in t && ("function" == typeof wd.locale ? wd.locale(t.locale) : wd.lang(t.locale)));
                }
            },
            {
                key: "_create",
                value: function() {
                    this.dom.foreground = document.createElement("div"), this.dom.background = document.createElement("div"), this.dom.foreground.className = "vis-time-axis vis-foreground", this.dom.background.className = "vis-time-axis vis-background";
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.dom.foreground.parentNode && this.dom.foreground.parentNode.removeChild(this.dom.foreground), this.dom.background.parentNode && this.dom.background.parentNode.removeChild(this.dom.background), this.body = null;
                }
            },
            {
                key: "redraw",
                value: function() {
                    var t = this.props, e = this.dom.foreground, i1 = this.dom.background, n = "top" == this.options.orientation.axis ? this.body.dom.top : this.body.dom.bottom, o = e.parentNode !== n;
                    this._calculateCharSize();
                    var r = this.options.showMinorLabels && "none" !== this.options.orientation.axis, s = this.options.showMajorLabels && "none" !== this.options.orientation.axis;
                    t.minorLabelHeight = r ? t.minorCharHeight : 0, t.majorLabelHeight = s ? t.majorCharHeight : 0, t.height = t.minorLabelHeight + t.majorLabelHeight, t.width = e.offsetWidth, t.minorLineHeight = this.body.domProps.root.height - t.majorLabelHeight - ("top" == this.options.orientation.axis ? this.body.domProps.bottom.height : this.body.domProps.top.height), t.minorLineWidth = 1, t.majorLineHeight = t.minorLineHeight + t.majorLabelHeight, t.majorLineWidth = 1;
                    var a = e.nextSibling, l = i1.nextSibling;
                    return e.parentNode && e.parentNode.removeChild(e), i1.parentNode && i1.parentNode.removeChild(i1), e.style.height = "".concat(this.props.height, "px"), this._repaintLabels(), a ? n.insertBefore(e, a) : n.appendChild(e), l ? this.body.dom.backgroundVertical.insertBefore(i1, l) : this.body.dom.backgroundVertical.appendChild(i1), this._isResized() || o;
                }
            },
            {
                key: "_repaintLabels",
                value: function() {
                    var t = this.options.orientation.axis, e = l_.convert(this.body.range.start, "Number"), i1 = l_.convert(this.body.range.end, "Number"), n = this.body.util.toTime((this.props.minorCharWidth || 10) * this.options.maxMinorChars).valueOf(), o = n - Cx(this.options.moment, this.body.hiddenDates, this.body.range, n);
                    o -= this.body.util.toTime(0).valueOf();
                    var r = new Yx(new Date(e), new Date(i1), o, this.body.hiddenDates, this.options);
                    r.setMoment(this.options.moment), this.options.format && r.setFormat(this.options.format), this.options.timeAxis && r.setScale(this.options.timeAxis), this.step = r;
                    var s, a, l, h, u, c, d = this.dom;
                    d.redundant.lines = d.lines, d.redundant.majorTexts = d.majorTexts, d.redundant.minorTexts = d.minorTexts, d.lines = [], d.majorTexts = [], d.minorTexts = [];
                    var p, m, f, v = 0, g = void 0, y = 0, b = 1e3;
                    for(r.start(), a = r.getCurrent(), h = this.body.util.toScreen(a); r.hasNext() && y < b;){
                        if (y++, u = r.isMajor(), f = r.getClassName(), s = a, l = h, r.next(), a = r.getCurrent(), p = v, v = (h = this.body.util.toScreen(a)) - l, "week" === r.scale) c = !0;
                        else c = v >= .4 * p;
                        if (this.options.showMinorLabels && c) {
                            var w = this._repaintMinorText(l, r.getLabelMinor(s), t, f);
                            w.style.width = "".concat(v, "px");
                        }
                        u && this.options.showMajorLabels ? (l > 0 && (null == g && (g = l), w = this._repaintMajorText(l, r.getLabelMajor(s), t, f)), m = this._repaintMajorLine(l, v, t, f)) : c ? m = this._repaintMinorLine(l, v, t, f) : m && (m.style.width = "".concat(gg(m.style.width) + v, "px"));
                    }
                    if (y !== b || Xx || (console.warn("Something is wrong with the Timeline scale. Limited drawing of grid lines to ".concat(b, " lines.")), Xx = !0), this.options.showMajorLabels) {
                        var k = this.body.util.toTime(0), _ = r.getLabelMajor(k), x = _.length * (this.props.majorCharWidth || 10) + 10;
                        (null == g || x < g) && this._repaintMajorText(0, _, t, f);
                    }
                    bd(l_).call(l_, this.dom.redundant, function(t) {
                        for(; t.length;){
                            var e = t.pop();
                            e && e.parentNode && e.parentNode.removeChild(e);
                        }
                    });
                }
            },
            {
                key: "_repaintMinorText",
                value: function(t, e, i1, n) {
                    var o = this.dom.redundant.minorTexts.shift();
                    if (!o) {
                        var r = document.createTextNode("");
                        (o = document.createElement("div")).appendChild(r), this.dom.foreground.appendChild(o);
                    }
                    this.dom.minorTexts.push(o), o.innerHTML = l_.xss(e);
                    var s = "top" == i1 ? this.props.majorLabelHeight : 0;
                    return this._setXY(o, t, s), o.className = "vis-text vis-minor ".concat(n), o;
                }
            },
            {
                key: "_repaintMajorText",
                value: function(t, e, i1, n) {
                    var o = this.dom.redundant.majorTexts.shift();
                    if (!o) {
                        var r = document.createElement("div");
                        (o = document.createElement("div")).appendChild(r), this.dom.foreground.appendChild(o);
                    }
                    o.childNodes[0].innerHTML = l_.xss(e), o.className = "vis-text vis-major ".concat(n);
                    var s = "top" == i1 ? 0 : this.props.minorLabelHeight;
                    return this._setXY(o, t, s), this.dom.majorTexts.push(o), o;
                }
            },
            {
                key: "_setXY",
                value: function(t, e, i1) {
                    var n, o = this.options.rtl ? -1 * e : e;
                    t.style.transform = mf(n = "translate(".concat(o, "px, ")).call(n, i1, "px)");
                }
            },
            {
                key: "_repaintMinorLine",
                value: function(t, e, i1, n) {
                    var o, r = this.dom.redundant.lines.shift();
                    r || (r = document.createElement("div"), this.dom.background.appendChild(r)), this.dom.lines.push(r);
                    var s = this.props;
                    r.style.width = "".concat(e, "px"), r.style.height = "".concat(s.minorLineHeight, "px");
                    var a = "top" == i1 ? s.majorLabelHeight : this.body.domProps.top.height, l = t - s.minorLineWidth / 2;
                    return this._setXY(r, l, a), r.className = mf(o = "vis-grid ".concat(this.options.rtl ? "vis-vertical-rtl" : "vis-vertical", " vis-minor ")).call(o, n), r;
                }
            },
            {
                key: "_repaintMajorLine",
                value: function(t, e, i1, n) {
                    var o, r = this.dom.redundant.lines.shift();
                    r || (r = document.createElement("div"), this.dom.background.appendChild(r)), this.dom.lines.push(r);
                    var s = this.props;
                    r.style.width = "".concat(e, "px"), r.style.height = "".concat(s.majorLineHeight, "px");
                    var a = "top" == i1 ? 0 : this.body.domProps.top.height, l = t - s.majorLineWidth / 2;
                    return this._setXY(r, l, a), r.className = mf(o = "vis-grid ".concat(this.options.rtl ? "vis-vertical-rtl" : "vis-vertical", " vis-major ")).call(o, n), r;
                }
            },
            {
                key: "_calculateCharSize",
                value: function() {
                    this.dom.measureCharMinor || (this.dom.measureCharMinor = document.createElement("DIV"), this.dom.measureCharMinor.className = "vis-text vis-minor vis-measure", this.dom.measureCharMinor.style.position = "absolute", this.dom.measureCharMinor.appendChild(document.createTextNode("0")), this.dom.foreground.appendChild(this.dom.measureCharMinor)), this.props.minorCharHeight = this.dom.measureCharMinor.clientHeight, this.props.minorCharWidth = this.dom.measureCharMinor.clientWidth, this.dom.measureCharMajor || (this.dom.measureCharMajor = document.createElement("DIV"), this.dom.measureCharMajor.className = "vis-text vis-major vis-measure", this.dom.measureCharMajor.style.position = "absolute", this.dom.measureCharMajor.appendChild(document.createTextNode("0")), this.dom.foreground.appendChild(this.dom.measureCharMajor)), this.props.majorCharHeight = this.dom.measureCharMajor.clientHeight, this.props.majorCharWidth = this.dom.measureCharMajor.clientWidth;
                }
            }
        ]), i1;
    }(w_), Xx = !1;
    function qx(t) {
        var e, i1;
        this.active = !1, this.dom = {
            container: t
        }, this.dom.overlay = document.createElement("div"), this.dom.overlay.className = "vis-overlay", this.dom.container.appendChild(this.dom.overlay), this.hammer = Gx(this.dom.overlay), this.hammer.on("tap", Hc(e = this._onTapOverlay).call(e, this));
        var n = this, o = [
            "tap",
            "doubletap",
            "press",
            "pinch",
            "pan",
            "panstart",
            "panmove",
            "panend"
        ];
        bd(o).call(o, function(t) {
            n.hammer.on(t, function(t) {
                t.stopPropagation();
            });
        }), document && document.body && (this.onClick = function(e) {
            (function(t, e) {
                for(; t;){
                    if (t === e) return !0;
                    t = t.parentNode;
                }
                return !1;
            })(e.target, t) || n.deactivate();
        }, document.body.addEventListener("click", this.onClick)), void 0 !== this.keycharm && this.keycharm.destroy(), this.keycharm = function(t) {
            var e, i1 = t && t.preventDefault || !1, n = t && t.container || window, o = {}, r = {
                keydown: {},
                keyup: {}
            }, s = {};
            for(e = 97; e <= 122; e++)s[String.fromCharCode(e)] = {
                code: e - 97 + 65,
                shift: !1
            };
            for(e = 65; e <= 90; e++)s[String.fromCharCode(e)] = {
                code: e,
                shift: !0
            };
            for(e = 0; e <= 9; e++)s["" + e] = {
                code: 48 + e,
                shift: !1
            };
            for(e = 1; e <= 12; e++)s["F" + e] = {
                code: 111 + e,
                shift: !1
            };
            for(e = 0; e <= 9; e++)s["num" + e] = {
                code: 96 + e,
                shift: !1
            };
            s["num*"] = {
                code: 106,
                shift: !1
            }, s["num+"] = {
                code: 107,
                shift: !1
            }, s["num-"] = {
                code: 109,
                shift: !1
            }, s["num/"] = {
                code: 111,
                shift: !1
            }, s["num."] = {
                code: 110,
                shift: !1
            }, s.left = {
                code: 37,
                shift: !1
            }, s.up = {
                code: 38,
                shift: !1
            }, s.right = {
                code: 39,
                shift: !1
            }, s.down = {
                code: 40,
                shift: !1
            }, s.space = {
                code: 32,
                shift: !1
            }, s.enter = {
                code: 13,
                shift: !1
            }, s.shift = {
                code: 16,
                shift: void 0
            }, s.esc = {
                code: 27,
                shift: !1
            }, s.backspace = {
                code: 8,
                shift: !1
            }, s.tab = {
                code: 9,
                shift: !1
            }, s.ctrl = {
                code: 17,
                shift: !1
            }, s.alt = {
                code: 18,
                shift: !1
            }, s.delete = {
                code: 46,
                shift: !1
            }, s.pageup = {
                code: 33,
                shift: !1
            }, s.pagedown = {
                code: 34,
                shift: !1
            }, s["="] = {
                code: 187,
                shift: !1
            }, s["-"] = {
                code: 189,
                shift: !1
            }, s["]"] = {
                code: 221,
                shift: !1
            }, s["["] = {
                code: 219,
                shift: !1
            };
            var a = function(t) {
                h(t, "keydown");
            }, l = function(t) {
                h(t, "keyup");
            }, h = function(t, e) {
                if (void 0 !== r[e][t.keyCode]) {
                    for(var n = r[e][t.keyCode], o = 0; o < n.length; o++)(void 0 === n[o].shift || 1 == n[o].shift && 1 == t.shiftKey || 0 == n[o].shift && 0 == t.shiftKey) && n[o].fn(t);
                    1 == i1 && t.preventDefault();
                }
            };
            return o.bind = function(t, e, i1) {
                if (void 0 === i1 && (i1 = "keydown"), void 0 === s[t]) throw new Error("unsupported key: " + t);
                void 0 === r[i1][s[t].code] && (r[i1][s[t].code] = []), r[i1][s[t].code].push({
                    fn: e,
                    shift: s[t].shift
                });
            }, o.bindAll = function(t, e) {
                for(var i1 in void 0 === e && (e = "keydown"), s)s.hasOwnProperty(i1) && o.bind(i1, t, e);
            }, o.getKey = function(t) {
                for(var e in s)if (s.hasOwnProperty(e)) {
                    if (1 == t.shiftKey && 1 == s[e].shift && t.keyCode == s[e].code) return e;
                    if (0 == t.shiftKey && 0 == s[e].shift && t.keyCode == s[e].code) return e;
                    if (t.keyCode == s[e].code && "shift" == e) return e;
                }
                return "unknown key, currently not supported";
            }, o.unbind = function(t, e, i1) {
                if (void 0 === i1 && (i1 = "keydown"), void 0 === s[t]) throw new Error("unsupported key: " + t);
                if (void 0 !== e) {
                    var n = [], o = r[i1][s[t].code];
                    if (void 0 !== o) for(var a = 0; a < o.length; a++)o[a].fn == e && o[a].shift == s[t].shift || n.push(r[i1][s[t].code][a]);
                    r[i1][s[t].code] = n;
                } else r[i1][s[t].code] = [];
            }, o.reset = function() {
                r = {
                    keydown: {},
                    keyup: {}
                };
            }, o.destroy = function() {
                r = {
                    keydown: {},
                    keyup: {}
                }, n.removeEventListener("keydown", a, !0), n.removeEventListener("keyup", l, !0);
            }, n.addEventListener("keydown", a, !0), n.addEventListener("keyup", l, !0), o;
        }(), this.escListener = Hc(i1 = this.deactivate).call(i1, this);
    }
    qg(qx.prototype), qx.current = null, qx.prototype.destroy = function() {
        this.deactivate(), this.dom.overlay.parentNode.removeChild(this.dom.overlay), this.onClick && document.body.removeEventListener("click", this.onClick), void 0 !== this.keycharm && this.keycharm.destroy(), this.keycharm = null, this.hammer.destroy(), this.hammer = null;
    }, qx.prototype.activate = function() {
        var t;
        qx.current && qx.current.deactivate(), qx.current = this, this.active = !0, this.dom.overlay.style.display = "none", l_.addClassName(this.dom.container, "vis-active"), this.emit("change"), this.emit("activate"), Hc(t = this.keycharm).call(t, "esc", this.escListener);
    }, qx.prototype.deactivate = function() {
        qx.current === this && (qx.current = null), this.active = !1, this.dom.overlay.style.display = "", l_.removeClassName(this.dom.container, "vis-active"), this.keycharm.unbind("esc", this.escListener), this.emit("change"), this.emit("deactivate");
    }, qx.prototype._onTapOverlay = function(t) {
        this.activate(), t.stopPropagation();
    };
    var Kx = {
        current: "current",
        time: "time",
        deleteSelected: "Delete selected"
    }, $x = {
        current: "attuale",
        time: "tempo",
        deleteSelected: "Cancella la selezione"
    }, Zx = {
        current: "huidige",
        time: "tijd",
        deleteSelected: "Selectie verwijderen"
    }, Qx = {
        current: "Aktuelle",
        time: "Zeit",
        deleteSelected: "L\xf6sche Auswahl"
    }, Jx = {
        current: "actuel",
        time: "heure",
        deleteSelected: "Effacer la selection"
    }, tC = {
        current: "corriente",
        time: "hora",
        deleteSelected: "Eliminar selecci\xf3n"
    }, eC = {
        current: "\u043F\u043E\u0442\u043E\u0447\u043D\u0438\u0439",
        time: "\u0447\u0430\u0441",
        deleteSelected: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043E\u0431\u0440\u0430\u043D\u0435"
    }, iC = {
        current: "\u0442\u0435\u043A\u0443\u0449\u0435\u0435",
        time: "\u0432\u0440\u0435\u043C\u044F",
        deleteSelected: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435"
    }, nC = {
        current: "aktualny",
        time: "czas",
        deleteSelected: "Usu\u0144 wybrane"
    }, oC = {
        current: "atual",
        time: "data",
        deleteSelected: "Apagar selecionado"
    }, rC = {
        current: "\u73FE\u5728",
        time: "\u6642\u523B",
        deleteSelected: "\u9078\u629E\u3055\u308C\u305F\u3082\u306E\u3092\u524A\u9664"
    }, sC = {
        current: "nuvarande",
        time: "tid",
        deleteSelected: "Radera valda"
    }, aC = {
        current: "n\xe5v\xe6rende",
        time: "tid",
        deleteSelected: "Slett valgte"
    }, lC = {
        current: "einamas",
        time: "laikas",
        deleteSelected: "Pa\u0161alinti pasirinkt\u0105"
    }, hC = {
        en: Kx,
        en_EN: Kx,
        en_US: Kx,
        it: $x,
        it_IT: $x,
        it_CH: $x,
        nl: Zx,
        nl_NL: Zx,
        nl_BE: Zx,
        de: Qx,
        de_DE: Qx,
        fr: Jx,
        fr_FR: Jx,
        fr_CA: Jx,
        fr_BE: Jx,
        es: tC,
        es_ES: tC,
        uk: eC,
        uk_UA: eC,
        ru: iC,
        ru_RU: iC,
        pl: nC,
        pl_PL: nC,
        pt: oC,
        pt_BR: oC,
        pt_PT: oC,
        ja: rC,
        ja_JP: rC,
        lt: lC,
        lt_LT: lC,
        sv: sC,
        sv_SE: sC,
        nb: aC,
        nn: aC,
        nb_NO: aC,
        nn_NO: aC
    };
    function uC(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    var cC = function(t) {
        Ic(i1, t);
        var e = uC(i1);
        function i1(t, n) {
            var o, r;
            Lo(this, i1), (r = e.call(this)).body = t, r.defaultOptions = {
                moment: wd,
                locales: hC,
                locale: "en",
                id: void 0,
                title: void 0
            }, r.options = l_.extend({}, r.defaultOptions), r.setOptions(n), r.options.locales = l_.extend({}, hC, r.options.locales);
            var s = r.defaultOptions.locales[r.defaultOptions.locale];
            return bd(o = Dp(r.options.locales)).call(o, function(t) {
                r.options.locales[t] = l_.extend({}, s, r.options.locales[t]);
            }), n && null != n.time ? r.customTime = n.time : r.customTime = new Date, r.eventParams = {}, r._create(), r;
        }
        return mc(i1, [
            {
                key: "setOptions",
                value: function(t) {
                    t && l_.selectiveExtend([
                        "moment",
                        "locale",
                        "locales",
                        "id",
                        "title",
                        "rtl",
                        "snap"
                    ], this.options, t);
                }
            },
            {
                key: "_create",
                value: function() {
                    var t, e, i1, n = document.createElement("div");
                    n["custom-time"] = this, n.className = "vis-custom-time ".concat(this.options.id || ""), n.style.position = "absolute", n.style.top = "0px", n.style.height = "100%", this.bar = n;
                    var o = document.createElement("div");
                    function r(t) {
                        this.body.range._onMouseWheel(t);
                    }
                    o.style.position = "relative", o.style.top = "0px", this.options.rtl ? o.style.right = "-10px" : o.style.left = "-10px", o.style.height = "100%", o.style.width = "20px", o.addEventListener ? (o.addEventListener("mousewheel", Hc(r).call(r, this), !1), o.addEventListener("DOMMouseScroll", Hc(r).call(r, this), !1)) : o.attachEvent("onmousewheel", Hc(r).call(r, this)), n.appendChild(o), this.hammer = new Gx(o), this.hammer.on("panstart", Hc(t = this._onDragStart).call(t, this)), this.hammer.on("panmove", Hc(e = this._onDrag).call(e, this)), this.hammer.on("panend", Hc(i1 = this._onDragEnd).call(i1, this)), this.hammer.get("pan").set({
                        threshold: 5,
                        direction: Gx.DIRECTION_ALL
                    }), this.hammer.get("press").set({
                        time: 1e4
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.hide(), this.hammer.destroy(), this.hammer = null, this.body = null;
                }
            },
            {
                key: "redraw",
                value: function() {
                    var t = this.body.dom.backgroundVertical;
                    this.bar.parentNode != t && (this.bar.parentNode && this.bar.parentNode.removeChild(this.bar), t.appendChild(this.bar));
                    var e = this.body.util.toScreen(this.customTime), i1 = this.options.locales[this.options.locale];
                    i1 || (this.warned || (console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization")), this.warned = !0), i1 = this.options.locales.en);
                    var n, o = this.options.title;
                    void 0 === o ? o = (o = mf(n = "".concat(i1.time, ": ")).call(n, this.options.moment(this.customTime).format("dddd, MMMM Do YYYY, H:mm:ss"))).charAt(0).toUpperCase() + o.substring(1) : "function" == typeof o && (o = o.call(this, this.customTime));
                    return this.options.rtl ? this.bar.style.right = "".concat(e, "px") : this.bar.style.left = "".concat(e, "px"), this.bar.title = o, !1;
                }
            },
            {
                key: "hide",
                value: function() {
                    this.bar.parentNode && this.bar.parentNode.removeChild(this.bar);
                }
            },
            {
                key: "setCustomTime",
                value: function(t) {
                    this.customTime = l_.convert(t, "Date"), this.redraw();
                }
            },
            {
                key: "getCustomTime",
                value: function() {
                    return new Date(this.customTime.valueOf());
                }
            },
            {
                key: "setCustomMarker",
                value: function(t, e) {
                    var i1, n;
                    (this.marker && this.bar.removeChild(this.marker), this.marker = document.createElement("div"), this.marker.className = "vis-custom-time-marker", this.marker.innerHTML = l_.xss(t), this.marker.style.position = "absolute", e) && (this.marker.setAttribute("contenteditable", "true"), this.marker.addEventListener("pointerdown", function() {
                        this.marker.focus();
                    }), this.marker.addEventListener("input", Hc(i1 = this._onMarkerChange).call(i1, this)), this.marker.title = t, this.marker.addEventListener("blur", Hc(n = function(t) {
                        this.title != t.target.innerHTML && (this._onMarkerChanged(t), this.title = t.target.innerHTML);
                    }).call(n, this)));
                    this.bar.appendChild(this.marker);
                }
            },
            {
                key: "setCustomTitle",
                value: function(t) {
                    this.options.title = t;
                }
            },
            {
                key: "_onDragStart",
                value: function(t) {
                    this.eventParams.dragging = !0, this.eventParams.customTime = this.customTime, t.stopPropagation();
                }
            },
            {
                key: "_onDrag",
                value: function(t) {
                    if (this.eventParams.dragging) {
                        var e = this.options.rtl ? -1 * t.deltaX : t.deltaX, i1 = this.body.util.toScreen(this.eventParams.customTime) + e, n = this.body.util.toTime(i1), o = this.body.util.getScale(), r = this.body.util.getStep(), s = this.options.snap, a = s ? s(n, o, r) : n;
                        this.setCustomTime(a), this.body.emitter.emit("timechange", {
                            id: this.options.id,
                            time: new Date(this.customTime.valueOf()),
                            event: t
                        }), t.stopPropagation();
                    }
                }
            },
            {
                key: "_onDragEnd",
                value: function(t) {
                    this.eventParams.dragging && (this.body.emitter.emit("timechanged", {
                        id: this.options.id,
                        time: new Date(this.customTime.valueOf()),
                        event: t
                    }), t.stopPropagation());
                }
            },
            {
                key: "_onMarkerChange",
                value: function(t) {
                    this.body.emitter.emit("markerchange", {
                        id: this.options.id,
                        title: t.target.innerHTML,
                        event: t
                    }), t.stopPropagation();
                }
            },
            {
                key: "_onMarkerChanged",
                value: function(t) {
                    this.body.emitter.emit("markerchanged", {
                        id: this.options.id,
                        title: t.target.innerHTML,
                        event: t
                    }), t.stopPropagation();
                }
            }
        ], [
            {
                key: "customTimeFromTarget",
                value: function(t) {
                    for(var e = t.target; e;){
                        if (e.hasOwnProperty("custom-time")) return e["custom-time"];
                        e = e.parentNode;
                    }
                    return null;
                }
            }
        ]), i1;
    }(w_), dC = function() {
        function t() {
            Lo(this, t);
        }
        return mc(t, [
            {
                key: "_create",
                value: function(t) {
                    var e, i1, n, o = this;
                    this.dom = {}, this.dom.container = t, this.dom.container.style.position = "relative", this.dom.root = document.createElement("div"), this.dom.background = document.createElement("div"), this.dom.backgroundVertical = document.createElement("div"), this.dom.backgroundHorizontal = document.createElement("div"), this.dom.centerContainer = document.createElement("div"), this.dom.leftContainer = document.createElement("div"), this.dom.rightContainer = document.createElement("div"), this.dom.center = document.createElement("div"), this.dom.left = document.createElement("div"), this.dom.right = document.createElement("div"), this.dom.top = document.createElement("div"), this.dom.bottom = document.createElement("div"), this.dom.shadowTop = document.createElement("div"), this.dom.shadowBottom = document.createElement("div"), this.dom.shadowTopLeft = document.createElement("div"), this.dom.shadowBottomLeft = document.createElement("div"), this.dom.shadowTopRight = document.createElement("div"), this.dom.shadowBottomRight = document.createElement("div"), this.dom.rollingModeBtn = document.createElement("div"), this.dom.loadingScreen = document.createElement("div"), this.dom.root.className = "vis-timeline", this.dom.background.className = "vis-panel vis-background", this.dom.backgroundVertical.className = "vis-panel vis-background vis-vertical", this.dom.backgroundHorizontal.className = "vis-panel vis-background vis-horizontal", this.dom.centerContainer.className = "vis-panel vis-center", this.dom.leftContainer.className = "vis-panel vis-left", this.dom.rightContainer.className = "vis-panel vis-right", this.dom.top.className = "vis-panel vis-top", this.dom.bottom.className = "vis-panel vis-bottom", this.dom.left.className = "vis-content", this.dom.center.className = "vis-content", this.dom.right.className = "vis-content", this.dom.shadowTop.className = "vis-shadow vis-top", this.dom.shadowBottom.className = "vis-shadow vis-bottom", this.dom.shadowTopLeft.className = "vis-shadow vis-top", this.dom.shadowBottomLeft.className = "vis-shadow vis-bottom", this.dom.shadowTopRight.className = "vis-shadow vis-top", this.dom.shadowBottomRight.className = "vis-shadow vis-bottom", this.dom.rollingModeBtn.className = "vis-rolling-mode-btn", this.dom.loadingScreen.className = "vis-loading-screen", this.dom.root.appendChild(this.dom.background), this.dom.root.appendChild(this.dom.backgroundVertical), this.dom.root.appendChild(this.dom.backgroundHorizontal), this.dom.root.appendChild(this.dom.centerContainer), this.dom.root.appendChild(this.dom.leftContainer), this.dom.root.appendChild(this.dom.rightContainer), this.dom.root.appendChild(this.dom.top), this.dom.root.appendChild(this.dom.bottom), this.dom.root.appendChild(this.dom.rollingModeBtn), this.dom.centerContainer.appendChild(this.dom.center), this.dom.leftContainer.appendChild(this.dom.left), this.dom.rightContainer.appendChild(this.dom.right), this.dom.centerContainer.appendChild(this.dom.shadowTop), this.dom.centerContainer.appendChild(this.dom.shadowBottom), this.dom.leftContainer.appendChild(this.dom.shadowTopLeft), this.dom.leftContainer.appendChild(this.dom.shadowBottomLeft), this.dom.rightContainer.appendChild(this.dom.shadowTopRight), this.dom.rightContainer.appendChild(this.dom.shadowBottomRight), this.props = {
                        root: {},
                        background: {},
                        centerContainer: {},
                        leftContainer: {},
                        rightContainer: {},
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        border: {},
                        scrollTop: 0,
                        scrollTopMin: 0
                    }, this.on("rangechange", function() {
                        !0 === o.initialDrawDone && o._redraw();
                    }), this.on("rangechanged", function() {
                        o.initialRangeChangeDone || (o.initialRangeChangeDone = !0);
                    }), this.on("touch", Hc(e = this._onTouch).call(e, this)), this.on("panmove", Hc(i1 = this._onDrag).call(i1, this));
                    var r = this;
                    this._origRedraw = Hc(n = this._redraw).call(n, this), this._redraw = l_.throttle(this._origRedraw), this.on("_change", function(t) {
                        r.itemSet && r.itemSet.initialItemSetDrawn && t && 1 == t.queue ? r._redraw() : r._origRedraw();
                    }), this.hammer = new Gx(this.dom.root);
                    var s = this.hammer.get("pinch").set({
                        enable: !0
                    });
                    s && function(t) {
                        t.getTouchAction = function() {
                            return [
                                "pan-y"
                            ];
                        };
                    }(s), this.hammer.get("pan").set({
                        threshold: 5,
                        direction: Gx.DIRECTION_ALL
                    }), this.timelineListeners = {};
                    var a, l, h = [
                        "tap",
                        "doubletap",
                        "press",
                        "pinch",
                        "pan",
                        "panstart",
                        "panmove",
                        "panend"
                    ];
                    function u(t) {
                        this.isActive() && this.emit("mousewheel", t);
                        var e = 0, i1 = 0;
                        if ("detail" in t && (i1 = -1 * t.detail), "wheelDelta" in t && (i1 = t.wheelDelta), "wheelDeltaY" in t && (i1 = t.wheelDeltaY), "wheelDeltaX" in t && (e = -1 * t.wheelDeltaX), "axis" in t && t.axis === t.HORIZONTAL_AXIS && (e = -1 * i1, i1 = 0), "deltaY" in t && (i1 = -1 * t.deltaY), "deltaX" in t && (e = t.deltaX), t.deltaMode && (1 === t.deltaMode ? (e *= 40, i1 *= 40) : (e *= 40, i1 *= 800)), this.options.preferZoom) {
                            if (!this.options.zoomKey || t[this.options.zoomKey]) return;
                        } else if (this.options.zoomKey && t[this.options.zoomKey]) return;
                        if (this.options.verticalScroll || this.options.horizontalScroll) {
                            if (this.options.verticalScroll && Math.abs(i1) >= Math.abs(e)) {
                                var n = this.props.scrollTop, o = n + i1;
                                if (this.isActive()) this._setScrollTop(o) !== n && (this._redraw(), this.emit("scroll", t), t.preventDefault());
                            } else if (this.options.horizontalScroll) {
                                var r = (Math.abs(e) >= Math.abs(i1) ? e : i1) / 120 * (this.range.end - this.range.start) / 20, s = this.range.start + r, a = this.range.end + r, l = {
                                    animation: !1,
                                    byUser: !0,
                                    event: t
                                };
                                this.range.setRange(s, a, l), t.preventDefault();
                            }
                        }
                    }
                    bd(h).call(h, function(t) {
                        var e = function(e) {
                            r.isActive() && r.emit(t, e);
                        };
                        r.hammer.on(t, e), r.timelineListeners[t] = e;
                    }), Wx(this.hammer, function(t) {
                        r.emit("touch", t);
                    }), a = this.hammer, (l = function(t) {
                        r.emit("release", t);
                    }).inputHandler = function(t) {
                        t.isFinal && l(t);
                    }, a.on("hammer.input", l.inputHandler);
                    var c = "onwheel" in document.createElement("div") ? "wheel" : void 0 !== document.onmousewheel ? "mousewheel" : this.dom.centerContainer.addEventListener ? "DOMMouseScroll" : "onmousewheel";
                    function d(t) {
                        if (r.options.verticalScroll && (t.preventDefault(), r.isActive())) {
                            var e = -t.target.scrollTop;
                            r._setScrollTop(e), r._redraw(), r.emit("scrollSide", t);
                        }
                    }
                    this.dom.top.addEventListener, this.dom.bottom.addEventListener, this.dom.centerContainer.addEventListener(c, Hc(u).call(u, this), !1), this.dom.top.addEventListener(c, Hc(u).call(u, this), !1), this.dom.bottom.addEventListener(c, Hc(u).call(u, this), !1), this.dom.left.parentNode.addEventListener("scroll", Hc(d).call(d, this)), this.dom.right.parentNode.addEventListener("scroll", Hc(d).call(d, this));
                    var p = !1;
                    function m(t) {
                        var e;
                        if (t.preventDefault && (r.emit("dragover", r.getEventProperties(t)), t.preventDefault()), Eg(e = t.target.className).call(e, "timeline") > -1 && !p) return t.dataTransfer.dropEffect = "move", p = !0, !1;
                    }
                    function f(t) {
                        t.preventDefault && t.preventDefault(), t.stopPropagation && t.stopPropagation();
                        try {
                            var e = JSON.parse(t.dataTransfer.getData("text"));
                            if (!e || !e.content) return;
                        } catch (t) {
                            return !1;
                        }
                        return p = !1, t.center = {
                            x: t.clientX,
                            y: t.clientY
                        }, "item" !== e.target ? r.itemSet._onAddItem(t) : r.itemSet._onDropObjectOnItem(t), r.emit("drop", r.getEventProperties(t)), !1;
                    }
                    if (this.dom.center.addEventListener("dragover", Hc(m).call(m, this), !1), this.dom.center.addEventListener("drop", Hc(f).call(f, this), !1), this.customTimes = [], this.touch = {}, this.redrawCount = 0, this.initialDrawDone = !1, this.initialRangeChangeDone = !1, !t) throw new Error("No container provided");
                    t.appendChild(this.dom.root), t.appendChild(this.dom.loadingScreen);
                }
            },
            {
                key: "setOptions",
                value: function(t) {
                    var e;
                    if (t) {
                        if (l_.selectiveExtend([
                            "width",
                            "height",
                            "minHeight",
                            "maxHeight",
                            "autoResize",
                            "start",
                            "end",
                            "clickToUse",
                            "dataAttributes",
                            "hiddenDates",
                            "locale",
                            "locales",
                            "moment",
                            "preferZoom",
                            "rtl",
                            "zoomKey",
                            "horizontalScroll",
                            "verticalScroll",
                            "longSelectPressTime",
                            "snap"
                        ], this.options, t), this.dom.rollingModeBtn.style.visibility = "hidden", this.options.rtl && (this.dom.container.style.direction = "rtl", this.dom.backgroundVertical.className = "vis-panel vis-background vis-vertical-rtl"), this.options.verticalScroll && (this.options.rtl ? this.dom.rightContainer.className = "vis-panel vis-right vis-vertical-scroll" : this.dom.leftContainer.className = "vis-panel vis-left vis-vertical-scroll"), "object" !== uc(this.options.orientation) && (this.options.orientation = {
                            item: void 0,
                            axis: void 0
                        }), "orientation" in t && ("string" == typeof t.orientation ? this.options.orientation = {
                            item: t.orientation,
                            axis: t.orientation
                        } : "object" === uc(t.orientation) && ("item" in t.orientation && (this.options.orientation.item = t.orientation.item), "axis" in t.orientation && (this.options.orientation.axis = t.orientation.axis))), "both" === this.options.orientation.axis) {
                            if (!this.timeAxis2) {
                                var i1 = this.timeAxis2 = new Ux(this.body, this.options);
                                i1.setOptions = function(t) {
                                    var e = t ? l_.extend({}, t) : {};
                                    e.orientation = "top", Ux.prototype.setOptions.call(i1, e);
                                }, this.components.push(i1);
                            }
                        } else if (this.timeAxis2) {
                            var n, o, r = Eg(n = this.components).call(n, this.timeAxis2);
                            if (-1 !== r) Qf(o = this.components).call(o, r, 1);
                            this.timeAxis2.destroy(), this.timeAxis2 = null;
                        }
                        "function" == typeof t.drawPoints && (t.drawPoints = {
                            onRender: t.drawPoints
                        }), "hiddenDates" in this.options && fx(this.options.moment, this.body, this.options.hiddenDates), "clickToUse" in t && (t.clickToUse ? this.activator || (this.activator = new qx(this.dom.root)) : this.activator && (this.activator.destroy(), delete this.activator)), this._initAutoResize();
                    }
                    if (bd(e = this.components).call(e, function(e) {
                        return e.setOptions(t);
                    }), "configure" in t) {
                        var s;
                        this.configurator || (this.configurator = this._createConfigurator()), this.configurator.setOptions(t.configure);
                        var a = l_.deepExtend({}, this.options);
                        bd(s = this.components).call(s, function(t) {
                            l_.deepExtend(a, t.options);
                        }), this.configurator.setModuleOptions({
                            global: a
                        });
                    }
                    this._redraw();
                }
            },
            {
                key: "isActive",
                value: function() {
                    return !this.activator || this.activator.active;
                }
            },
            {
                key: "destroy",
                value: function() {
                    var t;
                    for(var e in this.setItems(null), this.setGroups(null), this.off(), this._stopAutoResize(), this.dom.root.parentNode && this.dom.root.parentNode.removeChild(this.dom.root), this.dom = null, this.activator && (this.activator.destroy(), delete this.activator), this.timelineListeners)this.timelineListeners.hasOwnProperty(e) && delete this.timelineListeners[e];
                    this.timelineListeners = null, this.hammer && this.hammer.destroy(), this.hammer = null, bd(t = this.components).call(t, function(t) {
                        return t.destroy();
                    }), this.body = null;
                }
            },
            {
                key: "setCustomTime",
                value: function(t, e) {
                    var i1, n = Ed(i1 = this.customTimes).call(i1, function(t) {
                        return e === t.options.id;
                    });
                    if (0 === n.length) throw new Error("No custom time bar found with id ".concat(Fg(e)));
                    n.length > 0 && n[0].setCustomTime(t);
                }
            },
            {
                key: "getCustomTime",
                value: function(t) {
                    var e, i1 = Ed(e = this.customTimes).call(e, function(e) {
                        return e.options.id === t;
                    });
                    if (0 === i1.length) throw new Error("No custom time bar found with id ".concat(Fg(t)));
                    return i1[0].getCustomTime();
                }
            },
            {
                key: "setCustomTimeMarker",
                value: function(t, e, i1) {
                    var n, o = Ed(n = this.customTimes).call(n, function(t) {
                        return t.options.id === e;
                    });
                    if (0 === o.length) throw new Error("No custom time bar found with id ".concat(Fg(e)));
                    o.length > 0 && o[0].setCustomMarker(t, i1);
                }
            },
            {
                key: "setCustomTimeTitle",
                value: function(t, e) {
                    var i1, n = Ed(i1 = this.customTimes).call(i1, function(t) {
                        return t.options.id === e;
                    });
                    if (0 === n.length) throw new Error("No custom time bar found with id ".concat(Fg(e)));
                    if (n.length > 0) return n[0].setCustomTitle(t);
                }
            },
            {
                key: "getEventProperties",
                value: function(t) {
                    return {
                        event: t
                    };
                }
            },
            {
                key: "addCustomTime",
                value: function(t, e) {
                    var i1, n = void 0 !== t ? l_.convert(t, "Date") : new Date, o = Bx(i1 = this.customTimes).call(i1, function(t) {
                        return t.options.id === e;
                    });
                    if (o) throw new Error("A custom time with id ".concat(Fg(e), " already exists"));
                    var r = new cC(this.body, l_.extend({}, this.options, {
                        time: n,
                        id: e,
                        snap: this.itemSet ? this.itemSet.options.snap : this.options.snap
                    }));
                    return this.customTimes.push(r), this.components.push(r), this._redraw(), e;
                }
            },
            {
                key: "removeCustomTime",
                value: function(t) {
                    var e, i1 = this, n = Ed(e = this.customTimes).call(e, function(e) {
                        return e.options.id === t;
                    });
                    if (0 === n.length) throw new Error("No custom time bar found with id ".concat(Fg(t)));
                    bd(n).call(n, function(t) {
                        var e, n, o, r;
                        Qf(e = i1.customTimes).call(e, Eg(n = i1.customTimes).call(n, t), 1), Qf(o = i1.components).call(o, Eg(r = i1.components).call(r, t), 1), t.destroy();
                    });
                }
            },
            {
                key: "getVisibleItems",
                value: function() {
                    return this.itemSet && this.itemSet.getVisibleItems() || [];
                }
            },
            {
                key: "getItemsAtCurrentTime",
                value: function(t) {
                    return this.time = t, this.itemSet && this.itemSet.getItemsAtCurrentTime(this.time) || [];
                }
            },
            {
                key: "getVisibleGroups",
                value: function() {
                    return this.itemSet && this.itemSet.getVisibleGroups() || [];
                }
            },
            {
                key: "fit",
                value: function(t, e) {
                    var i1 = this.getDataRange();
                    if (null !== i1.min || null !== i1.max) {
                        var n = i1.max - i1.min, o = new Date(i1.min.valueOf() - .01 * n), r = new Date(i1.max.valueOf() + .01 * n), s = !t || void 0 === t.animation || t.animation;
                        this.range.setRange(o, r, {
                            animation: s
                        }, e);
                    }
                }
            },
            {
                key: "getDataRange",
                value: function() {
                    throw new Error("Cannot invoke abstract method getDataRange");
                }
            },
            {
                key: "setWindow",
                value: function(t, e, i1, n) {
                    var o, r;
                    "function" == typeof arguments[2] && (n = arguments[2], i1 = {}), 1 == arguments.length ? (o = void 0 === (r = arguments[0]).animation || r.animation, this.range.setRange(r.start, r.end, {
                        animation: o
                    })) : 2 == arguments.length && "function" == typeof arguments[1] ? (n = arguments[1], o = void 0 === (r = arguments[0]).animation || r.animation, this.range.setRange(r.start, r.end, {
                        animation: o
                    }, n)) : (o = !i1 || void 0 === i1.animation || i1.animation, this.range.setRange(t, e, {
                        animation: o
                    }, n));
                }
            },
            {
                key: "moveTo",
                value: function(t, e, i1) {
                    "function" == typeof arguments[1] && (i1 = arguments[1], e = {});
                    var n = this.range.end - this.range.start, o = l_.convert(t, "Date").valueOf(), r = o - n / 2, s = o + n / 2, a = !e || void 0 === e.animation || e.animation;
                    this.range.setRange(r, s, {
                        animation: a
                    }, i1);
                }
            },
            {
                key: "getWindow",
                value: function() {
                    var t = this.range.getRange();
                    return {
                        start: new Date(t.start),
                        end: new Date(t.end)
                    };
                }
            },
            {
                key: "zoomIn",
                value: function(t, e, i1) {
                    if (!(!t || t < 0 || t > 1)) {
                        "function" == typeof arguments[1] && (i1 = arguments[1], e = {});
                        var n = this.getWindow(), o = n.start.valueOf(), r = n.end.valueOf(), s = r - o, a = (s - s / (1 + t)) / 2, l = o + a, h = r - a;
                        this.setWindow(l, h, e, i1);
                    }
                }
            },
            {
                key: "zoomOut",
                value: function(t, e, i1) {
                    if (!(!t || t < 0 || t > 1)) {
                        "function" == typeof arguments[1] && (i1 = arguments[1], e = {});
                        var n = this.getWindow(), o = n.start.valueOf(), r = n.end.valueOf(), s = r - o, a = o - s * t / 2, l = r + s * t / 2;
                        this.setWindow(a, l, e, i1);
                    }
                }
            },
            {
                key: "redraw",
                value: function() {
                    this._redraw();
                }
            },
            {
                key: "_redraw",
                value: function() {
                    var t;
                    this.redrawCount++;
                    var e = this.dom;
                    if (e && e.container && 0 != e.root.offsetWidth) {
                        var i1 = !1, n = this.options, o = this.props;
                        vx(this.options.moment, this.body, this.options.hiddenDates), "top" == n.orientation ? (l_.addClassName(e.root, "vis-top"), l_.removeClassName(e.root, "vis-bottom")) : (l_.removeClassName(e.root, "vis-top"), l_.addClassName(e.root, "vis-bottom")), n.rtl ? (l_.addClassName(e.root, "vis-rtl"), l_.removeClassName(e.root, "vis-ltr")) : (l_.addClassName(e.root, "vis-ltr"), l_.removeClassName(e.root, "vis-rtl")), e.root.style.maxHeight = l_.option.asSize(n.maxHeight, ""), e.root.style.minHeight = l_.option.asSize(n.minHeight, ""), e.root.style.width = l_.option.asSize(n.width, "");
                        var r = e.root.offsetWidth;
                        o.border.left = 1, o.border.right = 1, o.border.top = 1, o.border.bottom = 1, o.center.height = e.center.offsetHeight, o.left.height = e.left.offsetHeight, o.right.height = e.right.offsetHeight, o.top.height = e.top.clientHeight || -o.border.top, o.bottom.height = Math.round(e.bottom.getBoundingClientRect().height) || e.bottom.clientHeight || -o.border.bottom;
                        var s = Math.max(o.left.height, o.center.height, o.right.height), a = o.top.height + s + o.bottom.height + o.border.top + o.border.bottom;
                        e.root.style.height = l_.option.asSize(n.height, "".concat(a, "px")), o.root.height = e.root.offsetHeight, o.background.height = o.root.height;
                        var l = o.root.height - o.top.height - o.bottom.height;
                        o.centerContainer.height = l, o.leftContainer.height = l, o.rightContainer.height = o.leftContainer.height, o.root.width = r, o.background.width = o.root.width, this.initialDrawDone || (o.scrollbarWidth = l_.getScrollBarWidth());
                        var h = e.leftContainer.clientWidth, u = e.rightContainer.clientWidth;
                        n.verticalScroll ? n.rtl ? (o.left.width = h || -o.border.left, o.right.width = u + o.scrollbarWidth || -o.border.right) : (o.left.width = h + o.scrollbarWidth || -o.border.left, o.right.width = u || -o.border.right) : (o.left.width = h || -o.border.left, o.right.width = u || -o.border.right), this._setDOM();
                        var c = this._updateScrollTop();
                        "top" != n.orientation.item && (c += Math.max(o.centerContainer.height - o.center.height - o.border.top - o.border.bottom, 0)), e.center.style.transform = "translateY(".concat(c, "px)");
                        var d = 0 == o.scrollTop ? "hidden" : "", p = o.scrollTop == o.scrollTopMin ? "hidden" : "";
                        e.shadowTop.style.visibility = d, e.shadowBottom.style.visibility = p, e.shadowTopLeft.style.visibility = d, e.shadowBottomLeft.style.visibility = p, e.shadowTopRight.style.visibility = d, e.shadowBottomRight.style.visibility = p, n.verticalScroll && (e.rightContainer.className = "vis-panel vis-right vis-vertical-scroll", e.leftContainer.className = "vis-panel vis-left vis-vertical-scroll", e.shadowTopRight.style.visibility = "hidden", e.shadowBottomRight.style.visibility = "hidden", e.shadowTopLeft.style.visibility = "hidden", e.shadowBottomLeft.style.visibility = "hidden", e.left.style.top = "0px", e.right.style.top = "0px"), (!n.verticalScroll || o.center.height < o.centerContainer.height) && (e.left.style.top = "".concat(c, "px"), e.right.style.top = "".concat(c, "px"), e.rightContainer.className = e.rightContainer.className.replace(new RegExp("(?:^|\\s)vis-vertical-scroll(?:\\s|$)"), " "), e.leftContainer.className = e.leftContainer.className.replace(new RegExp("(?:^|\\s)vis-vertical-scroll(?:\\s|$)"), " "), o.left.width = h || -o.border.left, o.right.width = u || -o.border.right, this._setDOM());
                        var m = o.center.height > o.centerContainer.height;
                        this.hammer.get("pan").set({
                            direction: m ? Gx.DIRECTION_ALL : Gx.DIRECTION_HORIZONTAL
                        }), this.hammer.get("press").set({
                            time: this.options.longSelectPressTime
                        }), bd(t = this.components).call(t, function(t) {
                            i1 = t.redraw() || i1;
                        });
                        if (i1) {
                            if (this.redrawCount < 5) return void this.body.emitter.emit("_change");
                            console.log("WARNING: infinite loop in redraw?");
                        } else this.redrawCount = 0;
                        this.body.emitter.emit("changed");
                    }
                }
            },
            {
                key: "_setDOM",
                value: function() {
                    var t = this.props, e = this.dom;
                    t.leftContainer.width = t.left.width, t.rightContainer.width = t.right.width;
                    var i1 = t.root.width - t.left.width - t.right.width;
                    t.center.width = i1, t.centerContainer.width = i1, t.top.width = i1, t.bottom.width = i1, e.background.style.height = "".concat(t.background.height, "px"), e.backgroundVertical.style.height = "".concat(t.background.height, "px"), e.backgroundHorizontal.style.height = "".concat(t.centerContainer.height, "px"), e.centerContainer.style.height = "".concat(t.centerContainer.height, "px"), e.leftContainer.style.height = "".concat(t.leftContainer.height, "px"), e.rightContainer.style.height = "".concat(t.rightContainer.height, "px"), e.background.style.width = "".concat(t.background.width, "px"), e.backgroundVertical.style.width = "".concat(t.centerContainer.width, "px"), e.backgroundHorizontal.style.width = "".concat(t.background.width, "px"), e.centerContainer.style.width = "".concat(t.center.width, "px"), e.top.style.width = "".concat(t.top.width, "px"), e.bottom.style.width = "".concat(t.bottom.width, "px"), e.background.style.left = "0", e.background.style.top = "0", e.backgroundVertical.style.left = "".concat(t.left.width + t.border.left, "px"), e.backgroundVertical.style.top = "0", e.backgroundHorizontal.style.left = "0", e.backgroundHorizontal.style.top = "".concat(t.top.height, "px"), e.centerContainer.style.left = "".concat(t.left.width, "px"), e.centerContainer.style.top = "".concat(t.top.height, "px"), e.leftContainer.style.left = "0", e.leftContainer.style.top = "".concat(t.top.height, "px"), e.rightContainer.style.left = "".concat(t.left.width + t.center.width, "px"), e.rightContainer.style.top = "".concat(t.top.height, "px"), e.top.style.left = "".concat(t.left.width, "px"), e.top.style.top = "0", e.bottom.style.left = "".concat(t.left.width, "px"), e.bottom.style.top = "".concat(t.top.height + t.centerContainer.height, "px"), e.center.style.left = "0", e.left.style.left = "0", e.right.style.left = "0";
                }
            },
            {
                key: "setCurrentTime",
                value: function(t) {
                    if (!this.currentTime) throw new Error("Option showCurrentTime must be true");
                    this.currentTime.setCurrentTime(t);
                }
            },
            {
                key: "getCurrentTime",
                value: function() {
                    if (!this.currentTime) throw new Error("Option showCurrentTime must be true");
                    return this.currentTime.getCurrentTime();
                }
            },
            {
                key: "_toTime",
                value: function(t) {
                    return wx(this, t, this.props.center.width);
                }
            },
            {
                key: "_toGlobalTime",
                value: function(t) {
                    return wx(this, t, this.props.root.width);
                }
            },
            {
                key: "_toScreen",
                value: function(t) {
                    return bx(this, t, this.props.center.width);
                }
            },
            {
                key: "_toGlobalScreen",
                value: function(t) {
                    return bx(this, t, this.props.root.width);
                }
            },
            {
                key: "_initAutoResize",
                value: function() {
                    1 == this.options.autoResize ? this._startAutoResize() : this._stopAutoResize();
                }
            },
            {
                key: "_startAutoResize",
                value: function() {
                    var t = this;
                    this._stopAutoResize(), this._onResize = function() {
                        if (1 == t.options.autoResize) {
                            if (t.dom.root) {
                                var e = t.dom.root.offsetHeight, i1 = t.dom.root.offsetWidth;
                                i1 == t.props.lastWidth && e == t.props.lastHeight || (t.props.lastWidth = i1, t.props.lastHeight = e, t.props.scrollbarWidth = l_.getScrollBarWidth(), t.body.emitter.emit("_change"));
                            }
                        } else t._stopAutoResize();
                    }, window.addEventListener("resize", this._onResize), t.dom.root && (t.props.lastWidth = t.dom.root.offsetWidth, t.props.lastHeight = t.dom.root.offsetHeight), this.watchTimer = zx(this._onResize, 1e3);
                }
            },
            {
                key: "_stopAutoResize",
                value: function() {
                    this.watchTimer && (clearInterval(this.watchTimer), this.watchTimer = void 0), this._onResize && (window.removeEventListener("resize", this._onResize), this._onResize = null);
                }
            },
            {
                key: "_onTouch",
                value: function(t) {
                    this.touch.allowDragging = !0, this.touch.initialScrollTop = this.props.scrollTop;
                }
            },
            {
                key: "_onPinch",
                value: function(t) {
                    this.touch.allowDragging = !1;
                }
            },
            {
                key: "_onDrag",
                value: function(t) {
                    if (t && this.touch.allowDragging) {
                        var e = t.deltaY, i1 = this._getScrollTop(), n = this._setScrollTop(this.touch.initialScrollTop + e);
                        this.options.verticalScroll && (this.dom.left.parentNode.scrollTop = -this.props.scrollTop, this.dom.right.parentNode.scrollTop = -this.props.scrollTop), n != i1 && this.emit("verticalDrag");
                    }
                }
            },
            {
                key: "_setScrollTop",
                value: function(t) {
                    return this.props.scrollTop = t, this._updateScrollTop(), this.props.scrollTop;
                }
            },
            {
                key: "_updateScrollTop",
                value: function() {
                    var t = Math.min(this.props.centerContainer.height - this.props.border.top - this.props.border.bottom - this.props.center.height, 0);
                    return t != this.props.scrollTopMin && ("top" != this.options.orientation.item && (this.props.scrollTop += t - this.props.scrollTopMin), this.props.scrollTopMin = t), this.props.scrollTop > 0 && (this.props.scrollTop = 0), this.props.scrollTop < t && (this.props.scrollTop = t), this.options.verticalScroll && (this.dom.left.parentNode.scrollTop = -this.props.scrollTop, this.dom.right.parentNode.scrollTop = -this.props.scrollTop), this.props.scrollTop;
                }
            },
            {
                key: "_getScrollTop",
                value: function() {
                    return this.props.scrollTop;
                }
            },
            {
                key: "_createConfigurator",
                value: function() {
                    throw new Error("Cannot invoke abstract method _createConfigurator");
                }
            }
        ]), t;
    }();
    function pC(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    qg(dC.prototype);
    var mC = function(t) {
        Ic(i1, t);
        var e = pC(i1);
        function i1(t, n) {
            var o, r;
            Lo(this, i1), (r = e.call(this)).body = t, r.defaultOptions = {
                rtl: !1,
                showCurrentTime: !0,
                alignCurrentTime: void 0,
                moment: wd,
                locales: hC,
                locale: "en"
            }, r.options = l_.extend({}, r.defaultOptions), r.setOptions(n), r.options.locales = l_.extend({}, hC, r.options.locales);
            var s = r.defaultOptions.locales[r.defaultOptions.locale];
            return bd(o = Dp(r.options.locales)).call(o, function(t) {
                r.options.locales[t] = l_.extend({}, s, r.options.locales[t]);
            }), r.offset = 0, r._create(), r;
        }
        return mc(i1, [
            {
                key: "_create",
                value: function() {
                    var t = document.createElement("div");
                    t.className = "vis-current-time", t.style.position = "absolute", t.style.top = "0px", t.style.height = "100%", this.bar = t;
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.options.showCurrentTime = !1, this.redraw(), this.body = null;
                }
            },
            {
                key: "setOptions",
                value: function(t) {
                    t && l_.selectiveExtend([
                        "rtl",
                        "showCurrentTime",
                        "alignCurrentTime",
                        "moment",
                        "locale",
                        "locales"
                    ], this.options, t);
                }
            },
            {
                key: "redraw",
                value: function() {
                    if (this.options.showCurrentTime) {
                        var t, e, i1 = this.body.dom.backgroundVertical;
                        this.bar.parentNode != i1 && (this.bar.parentNode && this.bar.parentNode.removeChild(this.bar), i1.appendChild(this.bar), this.start());
                        var n = this.options.moment(wf() + this.offset);
                        this.options.alignCurrentTime && (n = n.startOf(this.options.alignCurrentTime));
                        var o = this.body.util.toScreen(n), r = this.options.locales[this.options.locale];
                        r || (this.warned || (console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization")), this.warned = !0), r = this.options.locales.en);
                        var s = mf(t = mf(e = "".concat(r.current, " ")).call(e, r.time, ": ")).call(t, n.format("dddd, MMMM Do YYYY, H:mm:ss"));
                        s = s.charAt(0).toUpperCase() + s.substring(1), this.options.rtl ? this.bar.style.transform = "translateX(".concat(-1 * o, "px)") : this.bar.style.transform = "translateX(".concat(o, "px)"), this.bar.title = s;
                    } else this.bar.parentNode && this.bar.parentNode.removeChild(this.bar), this.stop();
                    return !1;
                }
            },
            {
                key: "start",
                value: function() {
                    var t = this;
                    !function e() {
                        t.stop();
                        var i1 = 1 / t.body.range.conversion(t.body.domProps.center.width).scale / 10;
                        i1 < 30 && (i1 = 30), i1 > 1e3 && (i1 = 1e3), t.redraw(), t.body.emitter.emit("currentTimeTick"), t.currentTimeTimer = sd(e, i1);
                    }();
                }
            },
            {
                key: "stop",
                value: function() {
                    void 0 !== this.currentTimeTimer && (clearTimeout(this.currentTimeTimer), delete this.currentTimeTimer);
                }
            },
            {
                key: "setCurrentTime",
                value: function(t) {
                    var e = l_.convert(t, "Date").valueOf(), i1 = wf();
                    this.offset = e - i1, this.redraw();
                }
            },
            {
                key: "getCurrentTime",
                value: function() {
                    return new Date(wf() + this.offset);
                }
            }
        ]), i1;
    }(w_), fC = Ii, vC = Hs.find, gC = "find", yC = !0;
    gC in [] && Array(1)[gC](function() {
        yC = !1;
    }), fC({
        target: "Array",
        proto: !0,
        forced: yC
    }, {
        find: function(t) {
            return vC(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var bC = _c("Array").find, wC = ut, kC = bC, _C = Array.prototype, xC = function(t) {
        var e = t.find;
        return t === _C || wC(_C, t) && e === _C.find ? kC : e;
    }, CC = r(xC), SC = {
        exports: {}
    }, DC = l(function() {
        if ("function" == typeof ArrayBuffer) {
            var t = new ArrayBuffer(8);
            Object.isExtensible(t) && Object.defineProperty(t, "a", {
                value: 8
            });
        }
    }), TC = l, EC = nt, OC = x, AC = DC, IC = Object.isExtensible, PC = TC(function() {
        IC(1);
    }) || AC ? function(t) {
        return !!EC(t) && (!AC || "ArrayBuffer" !== OC(t)) && (!IC || IC(t));
    } : IC, MC = !l(function() {
        return Object.isExtensible(Object.preventExtensions({}));
    }), NC = Ii, FC = b, RC = Bn, LC = nt, jC = ee, BC = ti.f, zC = Er, HC = Ir, GC = PC, WC = MC, YC = !1, VC = se("meta"), UC = 0, XC = function(t) {
        BC(t, VC, {
            value: {
                objectID: "O" + UC++,
                weakData: {}
            }
        });
    }, qC = SC.exports = {
        enable: function() {
            qC.enable = function() {}, YC = !0;
            var t = zC.f, e = FC([].splice), i1 = {};
            i1[VC] = 1, t(i1).length && (zC.f = function(i1) {
                for(var n = t(i1), o = 0, r = n.length; o < r; o++)if (n[o] === VC) {
                    e(n, o, 1);
                    break;
                }
                return n;
            }, NC({
                target: "Object",
                stat: !0,
                forced: !0
            }, {
                getOwnPropertyNames: HC.f
            }));
        },
        fastKey: function(t, e) {
            if (!LC(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
            if (!jC(t, VC)) {
                if (!GC(t)) return "F";
                if (!e) return "E";
                XC(t);
            }
            return t[VC].objectID;
        },
        getWeakData: function(t, e) {
            if (!jC(t, VC)) {
                if (!GC(t)) return !0;
                if (!e) return !1;
                XC(t);
            }
            return t[VC].weakData;
        },
        onFreeze: function(t) {
            return WC && YC && GC(t) && !jC(t, VC) && XC(t), t;
        }
    };
    RC[VC] = !0;
    var KC = SC.exports, $C = Je, ZC = F, QC = ri, JC = At, tS = Lp, eS = Mn, iS = ut, nS = $p, oS = Wp, rS = Ip, sS = TypeError, aS = function(t, e) {
        this.stopped = t, this.result = e;
    }, lS = aS.prototype, hS = function(t, e, i1) {
        var n, o, r, s, a, l, h, u = i1 && i1.that, c = !(!i1 || !i1.AS_ENTRIES), d = !(!i1 || !i1.IS_RECORD), p = !(!i1 || !i1.IS_ITERATOR), m = !(!i1 || !i1.INTERRUPTED), f = $C(e, u), v = function(t) {
            return n && rS(n, "normal", t), new aS(!0, t);
        }, g = function(t) {
            return c ? (QC(t), m ? f(t[0], t[1], v) : f(t[0], t[1])) : m ? f(t, v) : f(t);
        };
        if (d) n = t.iterator;
        else if (p) n = t;
        else {
            if (!(o = oS(t))) throw new sS(JC(t) + " is not iterable");
            if (tS(o)) {
                for(r = 0, s = eS(t); s > r; r++)if ((a = g(t[r])) && iS(lS, a)) return a;
                return new aS(!1);
            }
            n = nS(t, o);
        }
        for(l = d ? t.next : n.next; !(h = ZC(l, n)).done;){
            try {
                a = g(h.value);
            } catch (t) {
                rS(n, "throw", t);
            }
            if ("object" == typeof a && a && iS(lS, a)) return a;
        }
        return new aS(!1);
    }, uS = ut, cS = TypeError, dS = function(t, e) {
        if (uS(e, t)) return t;
        throw new cS("Incorrect invocation");
    }, pS = Ii, mS = a, fS = KC, vS = l, gS = bi, yS = hS, bS = dS, wS = A, kS = nt, _S = q, xS = gs, CS = ti.f, SS = Hs.forEach, DS = P, TS = Ms.set, ES = Ms.getterFor, OS = Vr, AS = ht, IS = Xr, PS = P, MS = fe("species"), NS = ko, FS = Xr, RS = function(t, e, i1) {
        for(var n in e)i1 && i1.unsafe && t[n] ? t[n] = e[n] : OS(t, n, e[n], i1);
        return t;
    }, LS = Je, jS = dS, BS = q, zS = hS, HS = eu, GS = iu, WS = function(t) {
        var e = AS(t);
        PS && e && !e[MS] && IS(e, MS, {
            configurable: !0,
            get: function() {
                return this;
            }
        });
    }, YS = P, VS = KC.fastKey, US = Ms.set, XS = Ms.getterFor, qS = {
        getConstructor: function(t, e, i1, n) {
            var o = t(function(t, o) {
                jS(t, r), US(t, {
                    type: e,
                    index: NS(null),
                    first: void 0,
                    last: void 0,
                    size: 0
                }), YS || (t.size = 0), BS(o) || zS(o, t[n], {
                    that: t,
                    AS_ENTRIES: i1
                });
            }), r = o.prototype, s = XS(e), a = function(t, e, i1) {
                var n, o, r = s(t), a = l(t, e);
                return a ? a.value = i1 : (r.last = a = {
                    index: o = VS(e, !0),
                    key: e,
                    value: i1,
                    previous: n = r.last,
                    next: void 0,
                    removed: !1
                }, r.first || (r.first = a), n && (n.next = a), YS ? r.size++ : t.size++, "F" !== o && (r.index[o] = a)), t;
            }, l = function(t, e) {
                var i1, n = s(t), o = VS(e);
                if ("F" !== o) return n.index[o];
                for(i1 = n.first; i1; i1 = i1.next)if (i1.key === e) return i1;
            };
            return RS(r, {
                clear: function() {
                    for(var t = s(this), e = t.index, i1 = t.first; i1;)i1.removed = !0, i1.previous && (i1.previous = i1.previous.next = void 0), delete e[i1.index], i1 = i1.next;
                    t.first = t.last = void 0, YS ? t.size = 0 : this.size = 0;
                },
                delete: function(t) {
                    var e = this, i1 = s(e), n = l(e, t);
                    if (n) {
                        var o = n.next, r = n.previous;
                        delete i1.index[n.index], n.removed = !0, r && (r.next = o), o && (o.previous = r), i1.first === n && (i1.first = o), i1.last === n && (i1.last = r), YS ? i1.size-- : e.size--;
                    }
                    return !!n;
                },
                forEach: function(t) {
                    for(var e, i1 = s(this), n = LS(t, arguments.length > 1 ? arguments[1] : void 0); e = e ? e.next : i1.first;)for(n(e.value, e.key, this); e && e.removed;)e = e.previous;
                },
                has: function(t) {
                    return !!l(this, t);
                }
            }), RS(r, i1 ? {
                get: function(t) {
                    var e = l(this, t);
                    return e && e.value;
                },
                set: function(t, e) {
                    return a(this, 0 === t ? 0 : t, e);
                }
            } : {
                add: function(t) {
                    return a(this, t = 0 === t ? 0 : t, t);
                }
            }), YS && FS(r, "size", {
                configurable: !0,
                get: function() {
                    return s(this).size;
                }
            }), o;
        },
        setStrong: function(t, e, i1) {
            var n = e + " Iterator", o = XS(e), r = XS(n);
            HS(t, e, function(t, e) {
                US(this, {
                    type: n,
                    target: t,
                    state: o(t),
                    kind: e,
                    last: void 0
                });
            }, function() {
                for(var t = r(this), e = t.kind, i1 = t.last; i1 && i1.removed;)i1 = i1.previous;
                return t.target && (t.last = i1 = i1 ? i1.next : t.state.first) ? GS("keys" === e ? i1.key : "values" === e ? i1.value : [
                    i1.key,
                    i1.value
                ], !1) : (t.target = void 0, GS(void 0, !0));
            }, i1 ? "entries" : "values", !i1, !0), WS(e);
        }
    }, KS = function(t, e, i1) {
        var n, o = -1 !== t.indexOf("Map"), r = -1 !== t.indexOf("Weak"), s = o ? "set" : "add", a = mS[t], l = a && a.prototype, h = {};
        if (DS && wS(a) && (r || l.forEach && !vS(function() {
            (new a).entries().next();
        }))) {
            var u = (n = e(function(e, i1) {
                TS(bS(e, u), {
                    type: t,
                    collection: new a
                }), _S(i1) || yS(i1, e[s], {
                    that: e,
                    AS_ENTRIES: o
                });
            })).prototype, c = ES(t);
            SS([
                "add",
                "clear",
                "delete",
                "forEach",
                "get",
                "has",
                "set",
                "keys",
                "values",
                "entries"
            ], function(t) {
                var e = "add" === t || "set" === t;
                !(t in l) || r && "clear" === t || gS(u, t, function(i1, n) {
                    var o = c(this).collection;
                    if (!e && r && !kS(i1)) return "get" === t && void 0;
                    var s = o[t](0 === i1 ? 0 : i1, n);
                    return e ? this : s;
                });
            }), r || CS(u, "size", {
                configurable: !0,
                get: function() {
                    return c(this).collection.size;
                }
            });
        } else n = i1.getConstructor(e, t, o, s), fS.enable();
        return xS(n, t, !1, !0), h[t] = n, pS({
            global: !0,
            forced: !0
        }, h), r || i1.setStrong(n, t, o), n;
    };
    KS("Set", function(t) {
        return function() {
            return t(this, arguments.length ? arguments[0] : void 0);
        };
    }, qS);
    var $S = r(ot.Set), ZS = Ii, QS = Hs.findIndex, JS = "findIndex", tD = !0;
    JS in [] && Array(1)[JS](function() {
        tD = !1;
    }), ZS({
        target: "Array",
        proto: !0,
        forced: tD
    }, {
        findIndex: function(t) {
            return QS(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var eD = _c("Array").findIndex, iD = ut, nD = eD, oD = Array.prototype, rD = function(t) {
        var e = t.findIndex;
        return t === oD || iD(oD, t) && e === oD.findIndex ? nD : e;
    }, sD = r(rD);
    function aD(t, e) {
        var i1 = void 0 !== lf && ym(t) || t["@@iterator"];
        if (!i1) {
            if (zc(t) || (i1 = function(t, e) {
                var i1;
                if (!t) return;
                if ("string" == typeof t) return lD(t, e);
                var n = ff(i1 = Object.prototype.toString.call(t)).call(i1, 8, -1);
                "Object" === n && t.constructor && (n = t.constructor.name);
                if ("Map" === n || "Set" === n) return fm(t);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return lD(t, e);
            }(t)) || e && t && "number" == typeof t.length) {
                i1 && (t = i1);
                var n = 0, o = function() {};
                return {
                    s: o,
                    n: function() {
                        return n >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[n++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: o
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var r, s = !0, a = !1;
        return {
            s: function() {
                i1 = i1.call(t);
            },
            n: function() {
                var t = i1.next();
                return s = t.done, t;
            },
            e: function(t) {
                a = !0, r = t;
            },
            f: function() {
                try {
                    s || null == i1.return || i1.return();
                } finally{
                    if (a) throw r;
                }
            }
        };
    }
    function lD(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var i1 = 0, n = new Array(e); i1 < e; i1++)n[i1] = t[i1];
        return n;
    }
    var hD = .001;
    function uD(t) {
        mx(t).call(t, function(t, e) {
            return t.data.start - e.data.start;
        });
    }
    function cD(t) {
        mx(t).call(t, function(t, e) {
            return ("end" in t.data ? t.data.end : t.data.start) - ("end" in e.data ? e.data.end : e.data.start);
        });
    }
    function dD(t, e, i1, n) {
        return null === gD(t, e.item, !1, function(t) {
            return t.stack && (i1 || null === t.top);
        }, function(t) {
            return t.stack;
        }, function(t) {
            return e.axis;
        }, n);
    }
    function pD(t, e, i1) {
        var n = gD(t, e.item, !1, function(t) {
            return t.stack;
        }, function(t) {
            return !0;
        }, function(t) {
            return t.baseTop;
        });
        i1.height = n - i1.top + .5 * e.item.vertical;
    }
    function mD(t, e, i1, n) {
        for(var o = 0; o < t.length; o++)if (null == t[o].data.subgroup) t[o].top = e.item.vertical;
        else if (void 0 !== t[o].data.subgroup && n) {
            var r = 0;
            for(var s in i1)i1.hasOwnProperty(s) && 1 == i1[s].visible && i1[s].index < i1[t[o].data.subgroup].index && (r += i1[s].height, i1[t[o].data.subgroup].top = r);
            t[o].top = r + .5 * e.item.vertical;
        }
        n || fD(t, e, i1);
    }
    function fD(t, e, i1) {
        var n;
        gD(mx(n = Kv(i1)).call(n, function(t, e) {
            return t.index > e.index ? 1 : t.index < e.index ? -1 : 0;
        }), {
            vertical: 0
        }, !0, function(t) {
            return !0;
        }, function(t) {
            return !0;
        }, function(t) {
            return 0;
        });
        for(var o = 0; o < t.length; o++)void 0 !== t[o].data.subgroup && (t[o].top = i1[t[o].data.subgroup].top + .5 * e.item.vertical);
    }
    function vD(t, e, i1) {
        var n = !1, o = [];
        for(var r in i1)i1[r].hasOwnProperty("index") ? o[i1[r].index] = r : o.push(r);
        for(var s = 0; s < o.length; s++)if (r = o[s], i1.hasOwnProperty(r)) {
            for(var a in n = n || i1[r].stack, i1[r].top = 0, i1)i1[a].visible && i1[r].index > i1[a].index && (i1[r].top += i1[a].height);
            for(var l = t[r], h = 0; h < l.length; h++)void 0 !== l[h].data.subgroup && (l[h].top = i1[l[h].data.subgroup].top + .5 * e.item.vertical, i1[r].stack && (l[h].baseTop = l[h].top));
            n && i1[r].stack && pD(t[r], e, i1[r]);
        }
    }
    function gD(t, e, n, o, r, s, a) {
        var l = function(t) {
            return t.start;
        }, h = function(t) {
            return t.end;
        };
        if (!n) {
            var u = !(!t[0] || !t[0].options.rtl);
            l = u ? function(t) {
                return t.right;
            } : function(t) {
                return t.left;
            }, h = function(t) {
                return l(t) + t.width + e.horizontal;
            };
        }
        var c, d = [], p = [], m = null, f = 0, v = aD(t);
        try {
            var g = function() {
                var t = c.value;
                if (o(t)) d.push(t);
                else if (r(t)) {
                    var e = l(t);
                    null !== m && e < m - hD && (f = 0), m = e, f = yD(p, function(t) {
                        return l(t) - hD > e;
                    }, f), Qf(p).call(p, f, 0, t), f++;
                }
            };
            for(v.s(); !(c = v.n()).done;)g();
        } catch (t) {
            v.e(t);
        } finally{
            v.f();
        }
        m = null;
        var y = null;
        f = 0;
        for(var b, w = 0, k = 0, _ = 0, x = function() {
            var t, n, o = d.shift();
            o.top = s(o);
            var u = l(o), c = h(o);
            null !== m && u < m - hD && (w = 0, k = 0, f = 0, y = null), m = u, w = yD(p, function(t) {
                return u < h(t) - hD;
            }, w), (null === y || y < c - hD) && (k = yD(p, function(t) {
                return c < l(t) - hD;
            }, Math.max(w, k))), null !== y && y - hD > c && (k = function(t, e, n, o) {
                n || (n = 0);
                o || (o = t.length);
                for(i = o - 1; i >= n; i--)if (e(t[i])) return i;
                return n - 1;
            }(p, function(t) {
                return c + hD >= l(t);
            }, w, k) + 1);
            for(var v, g, b, x = mx(t = Ed(n = ff(p).call(p, w, k)).call(n, function(t) {
                return u < h(t) - hD && c - hD > l(t);
            })).call(t, function(t, e) {
                return t.top - e.top;
            }), C = 0; C < x.length; C++){
                var S = x[C];
                g = S, b = e, (v = o).top - b.vertical + hD < g.top + g.height && v.top + v.height + b.vertical - hD > g.top && (o.top = S.top + S.height + e.vertical);
            }
            r(o) && (f = yD(p, function(t) {
                return l(t) - hD > u;
            }, f), Qf(p).call(p, f, 0, o), f++);
            var D = o.top + o.height;
            if (D > _ && (_ = D), a && a()) return {
                v: null
            };
        }; d.length > 0;)if (b = x()) return b.v;
        return _;
    }
    function yD(t, e, i1) {
        var n;
        i1 || (i1 = 0);
        var o = sD(n = ff(t).call(t, i1)).call(n, e);
        return -1 === o ? t.length : o + i1;
    }
    var bD = Object.freeze({
        __proto__: null,
        nostack: mD,
        orderByEnd: cD,
        orderByStart: uD,
        stack: dD,
        stackSubgroups: fD,
        stackSubgroupsWithInnerStack: vD,
        substack: pD
    }), wD = "__background__", kD = function() {
        function t(e, i1, n) {
            var o = this;
            if (Lo(this, t), this.groupId = e, this.subgroups = {}, this.subgroupStack = {}, this.subgroupStackAll = !1, this.subgroupVisibility = {}, this.doInnerStack = !1, this.shouldBailStackItems = !1, this.subgroupIndex = 0, this.subgroupOrderer = i1 && i1.subgroupOrder, this.itemSet = n, this.isVisible = null, this.stackDirty = !0, this._disposeCallbacks = [], i1 && i1.nestedGroups && (this.nestedGroups = i1.nestedGroups, 0 == i1.showNested ? this.showNested = !1 : this.showNested = !0), i1 && i1.subgroupStack) {
                if ("boolean" == typeof i1.subgroupStack) this.doInnerStack = i1.subgroupStack, this.subgroupStackAll = i1.subgroupStack;
                else for(var r in i1.subgroupStack)this.subgroupStack[r] = i1.subgroupStack[r], this.doInnerStack = this.doInnerStack || i1.subgroupStack[r];
            }
            i1 && i1.heightMode ? this.heightMode = i1.heightMode : this.heightMode = n.options.groupHeightMode, this.nestedInGroup = null, this.dom = {}, this.props = {
                label: {
                    width: 0,
                    height: 0
                }
            }, this.className = null, this.items = {}, this.visibleItems = [], this.itemsInRange = [], this.orderedItems = {
                byStart: [],
                byEnd: []
            }, this.checkRangedItems = !1;
            var s = function() {
                o.checkRangedItems = !0;
            };
            this.itemSet.body.emitter.on("checkRangedItems", s), this._disposeCallbacks.push(function() {
                o.itemSet.body.emitter.off("checkRangedItems", s);
            }), this._create(), this.setData(i1);
        }
        return mc(t, [
            {
                key: "_create",
                value: function() {
                    var t = document.createElement("div");
                    this.itemSet.options.groupEditable.order ? t.className = "vis-label draggable" : t.className = "vis-label", this.dom.label = t;
                    var e = document.createElement("div");
                    e.className = "vis-inner", t.appendChild(e), this.dom.inner = e;
                    var i1 = document.createElement("div");
                    i1.className = "vis-group", i1["vis-group"] = this, this.dom.foreground = i1, this.dom.background = document.createElement("div"), this.dom.background.className = "vis-group", this.dom.axis = document.createElement("div"), this.dom.axis.className = "vis-group", this.dom.marker = document.createElement("div"), this.dom.marker.style.visibility = "hidden", this.dom.marker.style.position = "absolute", this.dom.marker.innerHTML = "", this.dom.background.appendChild(this.dom.marker);
                }
            },
            {
                key: "setData",
                value: function(t) {
                    if (!this.itemSet.groupTouchParams.isDragging) {
                        var e, i1, n;
                        if (t && t.subgroupVisibility) for(var o in t.subgroupVisibility)this.subgroupVisibility[o] = t.subgroupVisibility[o];
                        if (this.itemSet.options && this.itemSet.options.groupTemplate) e = (i1 = Hc(n = this.itemSet.options.groupTemplate).call(n, this))(t, this.dom.inner);
                        else e = t && t.content;
                        if (e instanceof Element) {
                            for(; this.dom.inner.firstChild;)this.dom.inner.removeChild(this.dom.inner.firstChild);
                            this.dom.inner.appendChild(e);
                        } else e instanceof Object && e.isReactComponent || (e instanceof Object ? i1(t, this.dom.inner) : this.dom.inner.innerHTML = null != e ? l_.xss(e) : l_.xss(this.groupId || ""));
                        this.dom.label.title = t && t.title || "", this.dom.inner.firstChild ? l_.removeClassName(this.dom.inner, "vis-hidden") : l_.addClassName(this.dom.inner, "vis-hidden"), t && t.nestedGroups ? (this.nestedGroups && this.nestedGroups == t.nestedGroups || (this.nestedGroups = t.nestedGroups), void 0 === t.showNested && void 0 !== this.showNested || (0 == t.showNested ? this.showNested = !1 : this.showNested = !0), l_.addClassName(this.dom.label, "vis-nesting-group"), this.showNested ? (l_.removeClassName(this.dom.label, "collapsed"), l_.addClassName(this.dom.label, "expanded")) : (l_.removeClassName(this.dom.label, "expanded"), l_.addClassName(this.dom.label, "collapsed"))) : this.nestedGroups && (this.nestedGroups = null, l_.removeClassName(this.dom.label, "collapsed"), l_.removeClassName(this.dom.label, "expanded"), l_.removeClassName(this.dom.label, "vis-nesting-group")), t && (t.treeLevel || t.nestedInGroup) ? (l_.addClassName(this.dom.label, "vis-nested-group"), t.treeLevel ? l_.addClassName(this.dom.label, "vis-group-level-" + t.treeLevel) : l_.addClassName(this.dom.label, "vis-group-level-unknown-but-gte1")) : l_.addClassName(this.dom.label, "vis-group-level-0");
                        var r = t && t.className || null;
                        r != this.className && (this.className && (l_.removeClassName(this.dom.label, this.className), l_.removeClassName(this.dom.foreground, this.className), l_.removeClassName(this.dom.background, this.className), l_.removeClassName(this.dom.axis, this.className)), l_.addClassName(this.dom.label, r), l_.addClassName(this.dom.foreground, r), l_.addClassName(this.dom.background, r), l_.addClassName(this.dom.axis, r), this.className = r), this.style && (l_.removeCssText(this.dom.label, this.style), this.style = null), t && t.style && (l_.addCssText(this.dom.label, t.style), this.style = t.style);
                    }
                }
            },
            {
                key: "getLabelWidth",
                value: function() {
                    return this.props.label.width;
                }
            },
            {
                key: "_didMarkerHeightChange",
                value: function() {
                    var t = this.dom.marker.clientHeight;
                    if (t != this.lastMarkerHeight) {
                        this.lastMarkerHeight = t;
                        var e = {}, i1 = 0;
                        if (bd(l_).call(l_, this.items, function(t, n) {
                            if (t.dirty = !0, t.displayed) e[n] = t.redraw(!0), i1 = e[n].length;
                        }), i1 > 0) for(var n = function(t) {
                            bd(l_).call(l_, e, function(e) {
                                e[t]();
                            });
                        }, o = 0; o < i1; o++)n(o);
                        return !0;
                    }
                    return !1;
                }
            },
            {
                key: "_calculateGroupSizeAndPosition",
                value: function() {
                    var t = this.dom.foreground, e = t.offsetTop, i1 = t.offsetLeft, n = t.offsetWidth;
                    this.top = e, this.right = i1, this.width = n;
                }
            },
            {
                key: "_shouldBailItemsRedraw",
                value: function() {
                    var t = this, e = this.itemSet.options.onTimeout, i1 = {
                        relativeBailingTime: this.itemSet.itemsSettingTime,
                        bailTimeMs: e && e.timeoutMs,
                        userBailFunction: e && e.callback,
                        shouldBailStackItems: this.shouldBailStackItems
                    }, n = null;
                    if (!this.itemSet.initialDrawDone) {
                        if (i1.shouldBailStackItems) return !0;
                        Math.abs(wf() - new Date(i1.relativeBailingTime)) > i1.bailTimeMs && (i1.userBailFunction && null == this.itemSet.userContinueNotBail ? i1.userBailFunction(function(e) {
                            t.itemSet.userContinueNotBail = e, n = !e;
                        }) : n = 0 == t.itemSet.userContinueNotBail);
                    }
                    return n;
                }
            },
            {
                key: "_redrawItems",
                value: function(t, e, i1, n) {
                    var o = this;
                    if (t || this.stackDirty || this.isVisible && !e) {
                        var r, s, a, l, h, u, c = {
                            byEnd: Ed(r = this.orderedItems.byEnd).call(r, function(t) {
                                return !t.isCluster;
                            }),
                            byStart: Ed(s = this.orderedItems.byStart).call(s, function(t) {
                                return !t.isCluster;
                            })
                        }, d = {
                            byEnd: af(new $S(Ed(a = lp(l = this.orderedItems.byEnd).call(l, function(t) {
                                return t.cluster;
                            })).call(a, function(t) {
                                return !!t;
                            }))),
                            byStart: af(new $S(Ed(h = lp(u = this.orderedItems.byStart).call(u, function(t) {
                                return t.cluster;
                            })).call(h, function(t) {
                                return !!t;
                            })))
                        }, p = function() {
                            var t, e, i1, r = o._updateItemsInRange(c, Ed(t = o.visibleItems).call(t, function(t) {
                                return !t.isCluster;
                            }), n), s = o._updateClustersInRange(d, Ed(e = o.visibleItems).call(e, function(t) {
                                return t.isCluster;
                            }), n);
                            return mf(i1 = []).call(i1, af(r), af(s));
                        }, m = function(t) {
                            var e = {}, i1 = function(i1) {
                                var n, r = Ed(n = o.visibleItems).call(n, function(t) {
                                    return t.data.subgroup === i1;
                                });
                                e[i1] = t ? mx(r).call(r, function(e, i1) {
                                    return t(e.data, i1.data);
                                }) : r;
                            };
                            for(var n in o.subgroups)i1(n);
                            return e;
                        };
                        if ("function" == typeof this.itemSet.options.order) {
                            var f = this;
                            if (this.doInnerStack && this.itemSet.options.stackSubgroups) vD(m(this.itemSet.options.order), i1, this.subgroups), this.visibleItems = p(), this._updateSubGroupHeights(i1);
                            else {
                                var v, g, y, b;
                                this.visibleItems = p(), this._updateSubGroupHeights(i1);
                                var w = mx(v = Ed(g = ff(y = this.visibleItems).call(y)).call(g, function(t) {
                                    return t.isCluster || !t.isCluster && !t.cluster;
                                })).call(v, function(t, e) {
                                    return f.itemSet.options.order(t.data, e.data);
                                });
                                this.shouldBailStackItems = dD(w, i1, !0, Hc(b = this._shouldBailItemsRedraw).call(b, this));
                            }
                        } else {
                            var k;
                            if (this.visibleItems = p(), this._updateSubGroupHeights(i1), this.itemSet.options.stack) {
                                if (this.doInnerStack && this.itemSet.options.stackSubgroups) vD(m(), i1, this.subgroups);
                                else this.shouldBailStackItems = dD(this.visibleItems, i1, !0, Hc(k = this._shouldBailItemsRedraw).call(k, this));
                            } else mD(this.visibleItems, i1, this.subgroups, this.itemSet.options.stackSubgroups);
                        }
                        for(var _ = 0; _ < this.visibleItems.length; _++)this.visibleItems[_].repositionX(), void 0 !== this.subgroupVisibility[this.visibleItems[_].data.subgroup] && (this.subgroupVisibility[this.visibleItems[_].data.subgroup] || this.visibleItems[_].hide());
                        this.itemSet.options.cluster && bd(l_).call(l_, this.items, function(t) {
                            t.cluster && t.displayed && t.hide();
                        }), this.shouldBailStackItems && this.itemSet.body.emitter.emit("destroyTimeline"), this.stackDirty = !1;
                    }
                }
            },
            {
                key: "_didResize",
                value: function(t, e) {
                    t = l_.updateProperty(this, "height", e) || t;
                    var i1 = this.dom.inner.clientWidth, n = this.dom.inner.clientHeight;
                    return t = l_.updateProperty(this.props.label, "width", i1) || t, t = l_.updateProperty(this.props.label, "height", n) || t;
                }
            },
            {
                key: "_applyGroupHeight",
                value: function(t) {
                    this.dom.background.style.height = "".concat(t, "px"), this.dom.foreground.style.height = "".concat(t, "px"), this.dom.label.style.height = "".concat(t, "px");
                }
            },
            {
                key: "_updateItemsVerticalPosition",
                value: function(t) {
                    for(var e = 0, i1 = this.visibleItems.length; e < i1; e++){
                        var n = this.visibleItems[e];
                        n.repositionY(t), this.isVisible || this.groupId == wD || n.displayed && n.hide();
                    }
                }
            },
            {
                key: "redraw",
                value: function(t, e, i1, n) {
                    var o, r, s, a, l, h, u, c = this, d = !1, p = this.isVisible, m = [
                        function() {
                            i1 = c._didMarkerHeightChange.call(c) || i1;
                        },
                        Hc(o = this._updateSubGroupHeights).call(o, this, e),
                        Hc(r = this._calculateGroupSizeAndPosition).call(r, this),
                        function() {
                            var i1;
                            c.isVisible = Hc(i1 = c._isGroupVisible).call(i1, c)(t, e);
                        },
                        function() {
                            var n;
                            Hc(n = c._redrawItems).call(n, c)(i1, p, e, t);
                        },
                        Hc(s = this._updateSubgroupsSizes).call(s, this),
                        function() {
                            var t;
                            h = Hc(t = c._calculateHeight).call(t, c)(e);
                        },
                        Hc(a = this._calculateGroupSizeAndPosition).call(a, this),
                        function() {
                            var t;
                            d = Hc(t = c._didResize).call(t, c)(d, h);
                        },
                        function() {
                            var t;
                            Hc(t = c._applyGroupHeight).call(t, c)(h);
                        },
                        function() {
                            var t;
                            Hc(t = c._updateItemsVerticalPosition).call(t, c)(e);
                        },
                        Hc(l = function() {
                            return !c.isVisible && c.height && (d = !1), d;
                        }).call(l, this)
                    ];
                    return n ? m : (bd(m).call(m, function(t) {
                        u = t();
                    }), u);
                }
            },
            {
                key: "_updateSubGroupHeights",
                value: function(t) {
                    var e = this;
                    if (Dp(this.subgroups).length > 0) {
                        var i1 = this;
                        this._resetSubgroups(), bd(l_).call(l_, this.visibleItems, function(n) {
                            void 0 !== n.data.subgroup && (i1.subgroups[n.data.subgroup].height = Math.max(i1.subgroups[n.data.subgroup].height, n.height + t.item.vertical), i1.subgroups[n.data.subgroup].visible = void 0 === e.subgroupVisibility[n.data.subgroup] || Boolean(e.subgroupVisibility[n.data.subgroup]));
                        });
                    }
                }
            },
            {
                key: "_isGroupVisible",
                value: function(t, e) {
                    return this.top <= t.body.domProps.centerContainer.height - t.body.domProps.scrollTop + e.axis && this.top + this.height + e.axis >= -t.body.domProps.scrollTop;
                }
            },
            {
                key: "_calculateHeight",
                value: function(t) {
                    var e, i1;
                    if ((i1 = "fixed" === this.heightMode ? l_.toArray(this.items) : this.visibleItems).length > 0) {
                        var n = i1[0].top, o = i1[0].top + i1[0].height;
                        if (bd(l_).call(l_, i1, function(t) {
                            n = Math.min(n, t.top), o = Math.max(o, t.top + t.height);
                        }), n > t.axis) {
                            var r = n - t.axis;
                            o -= r, bd(l_).call(l_, i1, function(t) {
                                t.top -= r;
                            });
                        }
                        e = Math.ceil(o + t.item.vertical / 2), "fitItems" !== this.heightMode && (e = Math.max(e, this.props.label.height));
                    } else e = this.props.label.height;
                    return e;
                }
            },
            {
                key: "show",
                value: function() {
                    this.dom.label.parentNode || this.itemSet.dom.labelSet.appendChild(this.dom.label), this.dom.foreground.parentNode || this.itemSet.dom.foreground.appendChild(this.dom.foreground), this.dom.background.parentNode || this.itemSet.dom.background.appendChild(this.dom.background), this.dom.axis.parentNode || this.itemSet.dom.axis.appendChild(this.dom.axis);
                }
            },
            {
                key: "hide",
                value: function() {
                    var t = this.dom.label;
                    t.parentNode && t.parentNode.removeChild(t);
                    var e = this.dom.foreground;
                    e.parentNode && e.parentNode.removeChild(e);
                    var i1 = this.dom.background;
                    i1.parentNode && i1.parentNode.removeChild(i1);
                    var n = this.dom.axis;
                    n.parentNode && n.parentNode.removeChild(n);
                }
            },
            {
                key: "add",
                value: function(t) {
                    var e;
                    if (this.items[t.id] = t, t.setParent(this), this.stackDirty = !0, void 0 !== t.data.subgroup && (this._addToSubgroup(t), this.orderSubgroups()), !Fv(e = this.visibleItems).call(e, t)) {
                        var i1 = this.itemSet.body.range;
                        this._checkIfVisible(t, this.visibleItems, i1);
                    }
                }
            },
            {
                key: "_addToSubgroup",
                value: function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.data.subgroup;
                    null != e && void 0 === this.subgroups[e] && (this.subgroups[e] = {
                        height: 0,
                        top: 0,
                        start: t.data.start,
                        end: t.data.end || t.data.start,
                        visible: !1,
                        index: this.subgroupIndex,
                        items: [],
                        stack: this.subgroupStackAll || this.subgroupStack[e] || !1
                    }, this.subgroupIndex++), new Date(t.data.start) < new Date(this.subgroups[e].start) && (this.subgroups[e].start = t.data.start);
                    var i1 = t.data.end || t.data.start;
                    new Date(i1) > new Date(this.subgroups[e].end) && (this.subgroups[e].end = i1), this.subgroups[e].items.push(t);
                }
            },
            {
                key: "_updateSubgroupsSizes",
                value: function() {
                    var t = this;
                    if (t.subgroups) {
                        var e = function() {
                            var e, n = t.subgroups[i1].items[0].data.end || t.subgroups[i1].items[0].data.start, o = t.subgroups[i1].items[0].data.start, r = n - 1;
                            bd(e = t.subgroups[i1].items).call(e, function(t) {
                                new Date(t.data.start) < new Date(o) && (o = t.data.start);
                                var e = t.data.end || t.data.start;
                                new Date(e) > new Date(r) && (r = e);
                            }), t.subgroups[i1].start = o, t.subgroups[i1].end = new Date(r - 1);
                        };
                        for(var i1 in t.subgroups)e();
                    }
                }
            },
            {
                key: "orderSubgroups",
                value: function() {
                    if (void 0 !== this.subgroupOrderer) {
                        var t = [];
                        if ("string" == typeof this.subgroupOrderer) {
                            for(var e in this.subgroups)t.push({
                                subgroup: e,
                                sortField: this.subgroups[e].items[0].data[this.subgroupOrderer]
                            });
                            mx(t).call(t, function(t, e) {
                                return t.sortField - e.sortField;
                            });
                        } else if ("function" == typeof this.subgroupOrderer) {
                            for(var i1 in this.subgroups)t.push(this.subgroups[i1].items[0].data);
                            mx(t).call(t, this.subgroupOrderer);
                        }
                        if (t.length > 0) for(var n = 0; n < t.length; n++)this.subgroups[t[n].subgroup].index = n;
                    }
                }
            },
            {
                key: "_resetSubgroups",
                value: function() {
                    for(var t in this.subgroups)this.subgroups.hasOwnProperty(t) && (this.subgroups[t].visible = !1, this.subgroups[t].height = 0);
                }
            },
            {
                key: "remove",
                value: function(t) {
                    var e, i1;
                    delete this.items[t.id], t.setParent(null), this.stackDirty = !0;
                    var n = Eg(e = this.visibleItems).call(e, t);
                    -1 != n && Qf(i1 = this.visibleItems).call(i1, n, 1), void 0 !== t.data.subgroup && (this._removeFromSubgroup(t), this.orderSubgroups());
                }
            },
            {
                key: "_removeFromSubgroup",
                value: function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.data.subgroup;
                    if (null != e) {
                        var i1 = this.subgroups[e];
                        if (i1) {
                            var n, o, r = Eg(n = i1.items).call(n, t);
                            if (r >= 0) Qf(o = i1.items).call(o, r, 1), i1.items.length ? this._updateSubgroupsSizes() : delete this.subgroups[e];
                        }
                    }
                }
            },
            {
                key: "removeFromDataSet",
                value: function(t) {
                    this.itemSet.removeItem(t.id);
                }
            },
            {
                key: "order",
                value: function() {
                    for(var t = l_.toArray(this.items), e = [], i1 = [], n = 0; n < t.length; n++)void 0 !== t[n].data.end && i1.push(t[n]), e.push(t[n]);
                    this.orderedItems = {
                        byStart: e,
                        byEnd: i1
                    }, uD(this.orderedItems.byStart), cD(this.orderedItems.byEnd);
                }
            },
            {
                key: "_updateItemsInRange",
                value: function(t, e, i1) {
                    var n = [], o = {};
                    if (!this.isVisible && void 0 !== this.height && this.groupId != wD) {
                        for(var r = 0; r < e.length; r++){
                            var s = e[r];
                            s.displayed && s.hide();
                        }
                        return n;
                    }
                    var a = (i1.end - i1.start) / 4, l = i1.start - a, h = i1.end + a;
                    if (e.length > 0) for(var u = 0; u < e.length; u++)this._checkIfVisibleWithReference(e[u], n, o, i1);
                    var c = l_.binarySearchCustom(t.byStart, function(t) {
                        return t < l ? -1 : t <= h ? 0 : 1;
                    }, "data", "start");
                    if (this._traceVisible(c, t.byStart, n, o, function(t) {
                        return t.data.start < l || t.data.start > h;
                    }), 1 == this.checkRangedItems) {
                        this.checkRangedItems = !1;
                        for(var d = 0; d < t.byEnd.length; d++)this._checkIfVisibleWithReference(t.byEnd[d], n, o, i1);
                    } else {
                        var p = l_.binarySearchCustom(t.byEnd, function(t) {
                            var e = t.start;
                            return t.end < l ? -1 : e <= h ? 0 : 1;
                        }, "data");
                        this._traceVisible(p, t.byEnd, n, o, function(t) {
                            return t.data.end < l || t.data.start > h;
                        });
                    }
                    for(var m = {}, f = 0, v = 0; v < n.length; v++){
                        var g = n[v];
                        if (!g.displayed) m[v] = g.redraw(!0), f = m[v].length;
                    }
                    if (f > 0) for(var y = function(t) {
                        bd(l_).call(l_, m, function(e) {
                            e[t]();
                        });
                    }, b = 0; b < f; b++)y(b);
                    for(var w = 0; w < n.length; w++)n[w].repositionX();
                    return n;
                }
            },
            {
                key: "_traceVisible",
                value: function(t, e, i1, n, o) {
                    if (-1 != t) {
                        for(var r = t; r >= 0; r--){
                            var s = e[r];
                            if (o(s)) break;
                            s.isCluster && !s.hasItems() || s.cluster || void 0 === n[s.id] && (n[s.id] = !0, i1.push(s));
                        }
                        for(var a = t + 1; a < e.length; a++){
                            var l = e[a];
                            if (o(l)) break;
                            l.isCluster && !l.hasItems() || l.cluster || void 0 === n[l.id] && (n[l.id] = !0, i1.push(l));
                        }
                    }
                }
            },
            {
                key: "_checkIfVisible",
                value: function(t, e, i1) {
                    t.isVisible(i1) ? (t.displayed || t.show(), t.repositionX(), e.push(t)) : t.displayed && t.hide();
                }
            },
            {
                key: "_checkIfVisibleWithReference",
                value: function(t, e, i1, n) {
                    t.isVisible(n) ? void 0 === i1[t.id] && (i1[t.id] = !0, e.push(t)) : t.displayed && t.hide();
                }
            },
            {
                key: "_updateClustersInRange",
                value: function(t, e, i1) {
                    var n = [], o = {};
                    if (e.length > 0) for(var r = 0; r < e.length; r++)this._checkIfVisibleWithReference(e[r], n, o, i1);
                    for(var s = 0; s < t.byStart.length; s++)this._checkIfVisibleWithReference(t.byStart[s], n, o, i1);
                    for(var a = 0; a < t.byEnd.length; a++)this._checkIfVisibleWithReference(t.byEnd[a], n, o, i1);
                    for(var l = {}, h = 0, u = 0; u < n.length; u++){
                        var c = n[u];
                        if (!c.displayed) l[u] = c.redraw(!0), h = l[u].length;
                    }
                    if (h > 0) for(var d = 0; d < h; d++)bd(l_).call(l_, l, function(t) {
                        t[d]();
                    });
                    for(var p = 0; p < n.length; p++)n[p].repositionX();
                    return n;
                }
            },
            {
                key: "changeSubgroup",
                value: function(t, e, i1) {
                    this._removeFromSubgroup(t, e), this._addToSubgroup(t, i1), this.orderSubgroups();
                }
            },
            {
                key: "dispose",
                value: function() {
                    var t;
                    for(this.hide(); t = this._disposeCallbacks.pop();)t();
                }
            }
        ]), t;
    }();
    function _D(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    var xD = function(t) {
        Ic(i1, t);
        var e = _D(i1);
        function i1(t, n, o) {
            var r;
            return Lo(this, i1), (r = e.call(this, t, n, o)).width = 0, r.height = 0, r.top = 0, r.left = 0, r;
        }
        return mc(i1, [
            {
                key: "redraw",
                value: function(t, e, i1) {
                    this.visibleItems = this._updateItemsInRange(this.orderedItems, this.visibleItems, t), this.width = this.dom.background.offsetWidth, this.dom.background.style.height = "0";
                    for(var n = 0, o = this.visibleItems.length; n < o; n++)this.visibleItems[n].repositionY(e);
                    return !1;
                }
            },
            {
                key: "show",
                value: function() {
                    this.dom.background.parentNode || this.itemSet.dom.background.appendChild(this.dom.background);
                }
            }
        ]), i1;
    }(kD);
    function CD(t, e) {
        var i1 = void 0 !== lf && ym(t) || t["@@iterator"];
        if (!i1) {
            if (zc(t) || (i1 = function(t, e) {
                var i1;
                if (!t) return;
                if ("string" == typeof t) return SD(t, e);
                var n = ff(i1 = Object.prototype.toString.call(t)).call(i1, 8, -1);
                "Object" === n && t.constructor && (n = t.constructor.name);
                if ("Map" === n || "Set" === n) return fm(t);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SD(t, e);
            }(t)) || e && t && "number" == typeof t.length) {
                i1 && (t = i1);
                var n = 0, o = function() {};
                return {
                    s: o,
                    n: function() {
                        return n >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[n++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: o
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var r, s = !0, a = !1;
        return {
            s: function() {
                i1 = i1.call(t);
            },
            n: function() {
                var t = i1.next();
                return s = t.done, t;
            },
            e: function(t) {
                a = !0, r = t;
            },
            f: function() {
                try {
                    s || null == i1.return || i1.return();
                } finally{
                    if (a) throw r;
                }
            }
        };
    }
    function SD(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var i1 = 0, n = new Array(e); i1 < e; i1++)n[i1] = t[i1];
        return n;
    }
    var DD = function() {
        function t(e, i1, n) {
            var o, r = this;
            Lo(this, t), this.id = null, this.parent = null, this.data = e, this.dom = null, this.conversion = i1 || {}, this.defaultOptions = {
                locales: hC,
                locale: "en"
            }, this.options = l_.extend({}, this.defaultOptions, n), this.options.locales = l_.extend({}, hC, this.options.locales);
            var s = this.defaultOptions.locales[this.defaultOptions.locale];
            bd(o = Dp(this.options.locales)).call(o, function(t) {
                r.options.locales[t] = l_.extend({}, s, r.options.locales[t]);
            }), this.selected = !1, this.displayed = !1, this.groupShowing = !0, this.selectable = n && n.selectable || !1, this.dirty = !0, this.top = null, this.right = null, this.left = null, this.width = null, this.height = null, this.setSelectability(e), this.editable = null, this._updateEditStatus();
        }
        return mc(t, [
            {
                key: "select",
                value: function() {
                    this.selectable && (this.selected = !0, this.dirty = !0, this.displayed && this.redraw());
                }
            },
            {
                key: "unselect",
                value: function() {
                    this.selected = !1, this.dirty = !0, this.displayed && this.redraw();
                }
            },
            {
                key: "setData",
                value: function(t) {
                    null != t.group && this.data.group != t.group && null != this.parent && this.parent.itemSet._moveToGroup(this, t.group), this.setSelectability(t), this.parent && (this.parent.stackDirty = !0), null != t.subgroup && this.data.subgroup != t.subgroup && null != this.parent && this.parent.changeSubgroup(this, this.data.subgroup, t.subgroup), this.data = t, this._updateEditStatus(), this.dirty = !0, this.displayed && this.redraw();
                }
            },
            {
                key: "setSelectability",
                value: function(t) {
                    t && (this.selectable = void 0 === t.selectable || Boolean(t.selectable));
                }
            },
            {
                key: "setParent",
                value: function(t) {
                    this.displayed ? (this.hide(), this.parent = t, this.parent && this.show()) : this.parent = t;
                }
            },
            {
                key: "isVisible",
                value: function(t) {
                    return !1;
                }
            },
            {
                key: "show",
                value: function() {
                    return !1;
                }
            },
            {
                key: "hide",
                value: function() {
                    return !1;
                }
            },
            {
                key: "redraw",
                value: function() {}
            },
            {
                key: "repositionX",
                value: function() {}
            },
            {
                key: "repositionY",
                value: function() {}
            },
            {
                key: "_repaintDragCenter",
                value: function() {
                    if (this.selected && this.editable.updateTime && !this.dom.dragCenter) {
                        var t, e, i1 = this, n = document.createElement("div");
                        n.className = "vis-drag-center", n.dragCenterItem = this, this.hammerDragCenter = new Gx(n), this.hammerDragCenter.on("tap", function(t) {
                            i1.parent.itemSet.body.emitter.emit("click", {
                                event: t,
                                item: i1.id
                            });
                        }), this.hammerDragCenter.on("doubletap", function(t) {
                            t.stopPropagation(), i1.parent.itemSet._onUpdateItem(i1), i1.parent.itemSet.body.emitter.emit("doubleClick", {
                                event: t,
                                item: i1.id
                            });
                        }), this.hammerDragCenter.on("panstart", function(t) {
                            t.stopPropagation(), i1.parent.itemSet._onDragStart(t);
                        }), this.hammerDragCenter.on("panmove", Hc(t = i1.parent.itemSet._onDrag).call(t, i1.parent.itemSet)), this.hammerDragCenter.on("panend", Hc(e = i1.parent.itemSet._onDragEnd).call(e, i1.parent.itemSet)), this.hammerDragCenter.get("press").set({
                            time: 1e4
                        }), this.dom.box ? this.dom.dragLeft ? this.dom.box.insertBefore(n, this.dom.dragLeft) : this.dom.box.appendChild(n) : this.dom.point && this.dom.point.appendChild(n), this.dom.dragCenter = n;
                    } else !this.selected && this.dom.dragCenter && (this.dom.dragCenter.parentNode && this.dom.dragCenter.parentNode.removeChild(this.dom.dragCenter), this.dom.dragCenter = null, this.hammerDragCenter && (this.hammerDragCenter.destroy(), this.hammerDragCenter = null));
                }
            },
            {
                key: "_repaintDeleteButton",
                value: function(t) {
                    var e = (this.options.editable.overrideItems || null == this.editable) && this.options.editable.remove || !this.options.editable.overrideItems && null != this.editable && this.editable.remove;
                    if (this.selected && e && !this.dom.deleteButton) {
                        var i1 = this, n = document.createElement("div");
                        this.options.rtl ? n.className = "vis-delete-rtl" : n.className = "vis-delete";
                        var o = this.options.locales[this.options.locale];
                        o || (this.warned || (console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization")), this.warned = !0), o = this.options.locales.en), n.title = o.deleteSelected, this.hammerDeleteButton = new Gx(n).on("tap", function(t) {
                            t.stopPropagation(), i1.parent.removeFromDataSet(i1);
                        }), t.appendChild(n), this.dom.deleteButton = n;
                    } else this.selected && e || !this.dom.deleteButton || (this.dom.deleteButton.parentNode && this.dom.deleteButton.parentNode.removeChild(this.dom.deleteButton), this.dom.deleteButton = null, this.hammerDeleteButton && (this.hammerDeleteButton.destroy(), this.hammerDeleteButton = null));
                }
            },
            {
                key: "_repaintOnItemUpdateTimeTooltip",
                value: function(t) {
                    if (this.options.tooltipOnItemUpdateTime) {
                        var e = (this.options.editable.updateTime || !0 === this.data.editable) && !1 !== this.data.editable;
                        if (this.selected && e && !this.dom.onItemUpdateTimeTooltip) {
                            var i1 = document.createElement("div");
                            i1.className = "vis-onUpdateTime-tooltip", t.appendChild(i1), this.dom.onItemUpdateTimeTooltip = i1;
                        } else !this.selected && this.dom.onItemUpdateTimeTooltip && (this.dom.onItemUpdateTimeTooltip.parentNode && this.dom.onItemUpdateTimeTooltip.parentNode.removeChild(this.dom.onItemUpdateTimeTooltip), this.dom.onItemUpdateTimeTooltip = null);
                        if (this.dom.onItemUpdateTimeTooltip) {
                            this.dom.onItemUpdateTimeTooltip.style.visibility = this.parent.itemSet.touchParams.itemIsDragging ? "visible" : "hidden", this.dom.onItemUpdateTimeTooltip.style.transform = "translateX(-50%)", this.dom.onItemUpdateTimeTooltip.style.left = "50%";
                            var n, o, r = this.parent.itemSet.body.domProps.scrollTop;
                            if (("top" == this.options.orientation.item ? this.top : this.parent.height - this.top - this.height) + this.parent.top - 50 < -r ? (this.dom.onItemUpdateTimeTooltip.style.bottom = "", this.dom.onItemUpdateTimeTooltip.style.top = "".concat(this.height + 2, "px")) : (this.dom.onItemUpdateTimeTooltip.style.top = "", this.dom.onItemUpdateTimeTooltip.style.bottom = "".concat(this.height + 2, "px")), this.options.tooltipOnItemUpdateTime && this.options.tooltipOnItemUpdateTime.template) n = Hc(o = this.options.tooltipOnItemUpdateTime.template).call(o, this)(this.data);
                            else n = "start: ".concat(wd(this.data.start).format("MM/DD/YYYY hh:mm")), this.data.end && (n += "<br> end: ".concat(wd(this.data.end).format("MM/DD/YYYY hh:mm")));
                            this.dom.onItemUpdateTimeTooltip.innerHTML = l_.xss(n);
                        }
                    }
                }
            },
            {
                key: "_getItemData",
                value: function() {
                    return this.parent.itemSet.itemsData.get(this.id);
                }
            },
            {
                key: "_updateContents",
                value: function(t) {
                    var e, i1, n, o, r, s, a = this._getItemData(), l = (this.dom.box || this.dom.point).getElementsByClassName("vis-item-visible-frame")[0];
                    this.options.visibleFrameTemplate ? (o = Hc(r = this.options.visibleFrameTemplate).call(r, this), n = l_.xss(o(a, l))) : n = "";
                    if (l) {
                        if (n instanceof Object && !(n instanceof Element)) o(a, l);
                        else if (this._contentToString(this.itemVisibleFrameContent) !== this._contentToString(n)) {
                            if (n instanceof Element) l.innerHTML = "", l.appendChild(n);
                            else if (null != n) l.innerHTML = l_.xss(n);
                            else if ("background" != this.data.type || void 0 !== this.data.content) throw new Error('Property "content" missing in item '.concat(this.id));
                            this.itemVisibleFrameContent = n;
                        }
                    }
                    this.options.template ? e = (i1 = Hc(s = this.options.template).call(s, this))(a, t, this.data) : e = this.data.content;
                    if (e instanceof Object && !(e instanceof Element)) i1(a, t);
                    else if (this._contentToString(this.content) !== this._contentToString(e)) {
                        if (e instanceof Element) t.innerHTML = "", t.appendChild(e);
                        else if (null != e) t.innerHTML = l_.xss(e);
                        else if ("background" != this.data.type || void 0 !== this.data.content) throw new Error('Property "content" missing in item '.concat(this.id));
                        this.content = e;
                    }
                }
            },
            {
                key: "_updateDataAttributes",
                value: function(t) {
                    if (this.options.dataAttributes && this.options.dataAttributes.length > 0) {
                        var e = [];
                        if (zc(this.options.dataAttributes)) e = this.options.dataAttributes;
                        else {
                            if ("all" != this.options.dataAttributes) return;
                            e = Dp(this.data);
                        }
                        var i1, n = CD(e);
                        try {
                            for(n.s(); !(i1 = n.n()).done;){
                                var o = i1.value, r = this.data[o];
                                null != r ? t.setAttribute("data-".concat(o), r) : t.removeAttribute("data-".concat(o));
                            }
                        } catch (t) {
                            n.e(t);
                        } finally{
                            n.f();
                        }
                    }
                }
            },
            {
                key: "_updateStyle",
                value: function(t) {
                    this.style && (l_.removeCssText(t, this.style), this.style = null), this.data.style && (l_.addCssText(t, this.data.style), this.style = this.data.style);
                }
            },
            {
                key: "_contentToString",
                value: function(t) {
                    return "string" == typeof t ? t : t && "outerHTML" in t ? t.outerHTML : t;
                }
            },
            {
                key: "_updateEditStatus",
                value: function() {
                    this.options && ("boolean" == typeof this.options.editable ? this.editable = {
                        updateTime: this.options.editable,
                        updateGroup: this.options.editable,
                        remove: this.options.editable
                    } : "object" === uc(this.options.editable) && (this.editable = {}, l_.selectiveExtend([
                        "updateTime",
                        "updateGroup",
                        "remove"
                    ], this.editable, this.options.editable))), this.options && this.options.editable && !0 === this.options.editable.overrideItems || this.data && ("boolean" == typeof this.data.editable ? this.editable = {
                        updateTime: this.data.editable,
                        updateGroup: this.data.editable,
                        remove: this.data.editable
                    } : "object" === uc(this.data.editable) && (this.editable = {}, l_.selectiveExtend([
                        "updateTime",
                        "updateGroup",
                        "remove"
                    ], this.editable, this.data.editable)));
                }
            },
            {
                key: "getWidthLeft",
                value: function() {
                    return 0;
                }
            },
            {
                key: "getWidthRight",
                value: function() {
                    return 0;
                }
            },
            {
                key: "getTitle",
                value: function() {
                    var t;
                    return this.options.tooltip && this.options.tooltip.template ? Hc(t = this.options.tooltip.template).call(t, this)(this._getItemData(), this.data) : this.data.title;
                }
            }
        ]), t;
    }();
    function TD(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    DD.prototype.stack = !0;
    var ED = function(t) {
        Ic(i1, t);
        var e = TD(i1);
        function i1(t, n, o) {
            var r;
            if (Lo(this, i1), (r = e.call(this, t, n, o)).props = {
                dot: {
                    width: 0,
                    height: 0
                },
                line: {
                    width: 0,
                    height: 0
                }
            }, t && null == t.start) throw new Error('Property "start" missing in item '.concat(t));
            return r;
        }
        return mc(i1, [
            {
                key: "isVisible",
                value: function(t) {
                    if (this.cluster) return !1;
                    var e, i1 = this.data.align || this.options.align, n = this.width * t.getMillisecondsPerPixel();
                    return e = "right" == i1 ? this.data.start.getTime() > t.start && this.data.start.getTime() - n < t.end : "left" == i1 ? this.data.start.getTime() + n > t.start && this.data.start.getTime() < t.end : this.data.start.getTime() + n / 2 > t.start && this.data.start.getTime() - n / 2 < t.end, e;
                }
            },
            {
                key: "_createDomElement",
                value: function() {
                    this.dom || (this.dom = {}, this.dom.box = document.createElement("DIV"), this.dom.content = document.createElement("DIV"), this.dom.content.className = "vis-item-content", this.dom.box.appendChild(this.dom.content), this.dom.line = document.createElement("DIV"), this.dom.line.className = "vis-line", this.dom.dot = document.createElement("DIV"), this.dom.dot.className = "vis-dot", this.dom.box["vis-item"] = this, this.dirty = !0);
                }
            },
            {
                key: "_appendDomElement",
                value: function() {
                    if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                    if (!this.dom.box.parentNode) {
                        var t = this.parent.dom.foreground;
                        if (!t) throw new Error("Cannot redraw item: parent has no foreground container element");
                        t.appendChild(this.dom.box);
                    }
                    if (!this.dom.line.parentNode) {
                        var e = this.parent.dom.background;
                        if (!e) throw new Error("Cannot redraw item: parent has no background container element");
                        e.appendChild(this.dom.line);
                    }
                    if (!this.dom.dot.parentNode) {
                        var i1 = this.parent.dom.axis;
                        if (!e) throw new Error("Cannot redraw item: parent has no axis container element");
                        i1.appendChild(this.dom.dot);
                    }
                    this.displayed = !0;
                }
            },
            {
                key: "_updateDirtyDomComponents",
                value: function() {
                    if (this.dirty) {
                        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.box), this._updateStyle(this.dom.box);
                        var t = this.editable.updateTime || this.editable.updateGroup, e = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (t ? " vis-editable" : " vis-readonly");
                        this.dom.box.className = "vis-item vis-box".concat(e), this.dom.line.className = "vis-item vis-line".concat(e), this.dom.dot.className = "vis-item vis-dot".concat(e);
                    }
                }
            },
            {
                key: "_getDomComponentsSizes",
                value: function() {
                    return {
                        previous: {
                            right: this.dom.box.style.right,
                            left: this.dom.box.style.left
                        },
                        dot: {
                            height: this.dom.dot.offsetHeight,
                            width: this.dom.dot.offsetWidth
                        },
                        line: {
                            width: this.dom.line.offsetWidth
                        },
                        box: {
                            width: this.dom.box.offsetWidth,
                            height: this.dom.box.offsetHeight
                        }
                    };
                }
            },
            {
                key: "_updateDomComponentsSizes",
                value: function(t) {
                    this.options.rtl ? this.dom.box.style.right = "0px" : this.dom.box.style.left = "0px", this.props.dot.height = t.dot.height, this.props.dot.width = t.dot.width, this.props.line.width = t.line.width, this.width = t.box.width, this.height = t.box.height, this.options.rtl ? this.dom.box.style.right = t.previous.right : this.dom.box.style.left = t.previous.left, this.dirty = !1;
                }
            },
            {
                key: "_repaintDomAdditionals",
                value: function() {
                    this._repaintOnItemUpdateTimeTooltip(this.dom.box), this._repaintDragCenter(), this._repaintDeleteButton(this.dom.box);
                }
            },
            {
                key: "redraw",
                value: function(t) {
                    var e, i1, n, o, r, s, a = this, l = [
                        Hc(e = this._createDomElement).call(e, this),
                        Hc(i1 = this._appendDomElement).call(i1, this),
                        Hc(n = this._updateDirtyDomComponents).call(n, this),
                        function() {
                            a.dirty && (r = a._getDomComponentsSizes());
                        },
                        function() {
                            var t;
                            a.dirty && Hc(t = a._updateDomComponentsSizes).call(t, a)(r);
                        },
                        Hc(o = this._repaintDomAdditionals).call(o, this)
                    ];
                    return t ? l : (bd(l).call(l, function(t) {
                        s = t();
                    }), s);
                }
            },
            {
                key: "show",
                value: function(t) {
                    if (!this.displayed) return this.redraw(t);
                }
            },
            {
                key: "hide",
                value: function() {
                    if (this.displayed) {
                        var t = this.dom;
                        t.box.remove ? t.box.remove() : t.box.parentNode && t.box.parentNode.removeChild(t.box), t.line.remove ? t.line.remove() : t.line.parentNode && t.line.parentNode.removeChild(t.line), t.dot.remove ? t.dot.remove() : t.dot.parentNode && t.dot.parentNode.removeChild(t.dot), this.displayed = !1;
                    }
                }
            },
            {
                key: "repositionXY",
                value: function() {
                    var t = this.options.rtl, e = function(t, e, i1) {
                        var n;
                        if (void 0 !== e || void 0 !== i1) {
                            var o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3] ? -1 * e : e;
                            t.style.transform = void 0 !== i1 ? void 0 !== e ? mf(n = "translate(".concat(o, "px, ")).call(n, i1, "px)") : "translateY(".concat(i1, "px)") : "translateX(".concat(o, "px)");
                        }
                    };
                    e(this.dom.box, this.boxX, this.boxY, t), e(this.dom.dot, this.dotX, this.dotY, t), e(this.dom.line, this.lineX, this.lineY, t);
                }
            },
            {
                key: "repositionX",
                value: function() {
                    var t = this.conversion.toScreen(this.data.start), e = void 0 === this.data.align ? this.options.align : this.data.align, i1 = this.props.line.width, n = this.props.dot.width;
                    "right" == e ? (this.boxX = t - this.width, this.lineX = t - i1, this.dotX = t - i1 / 2 - n / 2) : "left" == e ? (this.boxX = t, this.lineX = t, this.dotX = t + i1 / 2 - n / 2) : (this.boxX = t - this.width / 2, this.lineX = this.options.rtl ? t - i1 : t - i1 / 2, this.dotX = t - n / 2), this.options.rtl ? this.right = this.boxX : this.left = this.boxX, this.repositionXY();
                }
            },
            {
                key: "repositionY",
                value: function() {
                    var t = this.options.orientation.item, e = this.dom.line.style;
                    if ("top" == t) {
                        var i1 = this.parent.top + this.top + 1;
                        this.boxY = this.top || 0, e.height = "".concat(i1, "px"), e.bottom = "", e.top = "0";
                    } else {
                        var n = this.parent.itemSet.props.height - this.parent.top - this.parent.height + this.top;
                        this.boxY = this.parent.height - this.top - (this.height || 0), e.height = "".concat(n, "px"), e.top = "", e.bottom = "0";
                    }
                    this.dotY = -this.props.dot.height / 2, this.repositionXY();
                }
            },
            {
                key: "getWidthLeft",
                value: function() {
                    return this.width / 2;
                }
            },
            {
                key: "getWidthRight",
                value: function() {
                    return this.width / 2;
                }
            }
        ]), i1;
    }(DD);
    function OD(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    var AD = function(t) {
        Ic(i1, t);
        var e = OD(i1);
        function i1(t, n, o) {
            var r;
            if (Lo(this, i1), (r = e.call(this, t, n, o)).props = {
                dot: {
                    top: 0,
                    width: 0,
                    height: 0
                },
                content: {
                    height: 0,
                    marginLeft: 0,
                    marginRight: 0
                }
            }, t && null == t.start) throw new Error('Property "start" missing in item '.concat(t));
            return r;
        }
        return mc(i1, [
            {
                key: "isVisible",
                value: function(t) {
                    if (this.cluster) return !1;
                    var e = this.width * t.getMillisecondsPerPixel();
                    return this.data.start.getTime() + e > t.start && this.data.start < t.end;
                }
            },
            {
                key: "_createDomElement",
                value: function() {
                    this.dom || (this.dom = {}, this.dom.point = document.createElement("div"), this.dom.content = document.createElement("div"), this.dom.content.className = "vis-item-content", this.dom.point.appendChild(this.dom.content), this.dom.dot = document.createElement("div"), this.dom.point.appendChild(this.dom.dot), this.dom.point["vis-item"] = this, this.dirty = !0);
                }
            },
            {
                key: "_appendDomElement",
                value: function() {
                    if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                    if (!this.dom.point.parentNode) {
                        var t = this.parent.dom.foreground;
                        if (!t) throw new Error("Cannot redraw item: parent has no foreground container element");
                        t.appendChild(this.dom.point);
                    }
                    this.displayed = !0;
                }
            },
            {
                key: "_updateDirtyDomComponents",
                value: function() {
                    if (this.dirty) {
                        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.point), this._updateStyle(this.dom.point);
                        var t = this.editable.updateTime || this.editable.updateGroup, e = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (t ? " vis-editable" : " vis-readonly");
                        this.dom.point.className = "vis-item vis-point".concat(e), this.dom.dot.className = "vis-item vis-dot".concat(e);
                    }
                }
            },
            {
                key: "_getDomComponentsSizes",
                value: function() {
                    return {
                        dot: {
                            width: this.dom.dot.offsetWidth,
                            height: this.dom.dot.offsetHeight
                        },
                        content: {
                            width: this.dom.content.offsetWidth,
                            height: this.dom.content.offsetHeight
                        },
                        point: {
                            width: this.dom.point.offsetWidth,
                            height: this.dom.point.offsetHeight
                        }
                    };
                }
            },
            {
                key: "_updateDomComponentsSizes",
                value: function(t) {
                    this.props.dot.width = t.dot.width, this.props.dot.height = t.dot.height, this.props.content.height = t.content.height, this.options.rtl ? this.dom.content.style.marginRight = "".concat(this.props.dot.width / 2, "px") : this.dom.content.style.marginLeft = "".concat(this.props.dot.width / 2, "px"), this.width = t.point.width, this.height = t.point.height, this.dom.dot.style.top = "".concat((this.height - this.props.dot.height) / 2, "px");
                    var e = this.props.dot.width, i1 = this.options.rtl ? e / 2 : e / 2 * -1;
                    this.dom.dot.style.transform = "translateX(".concat(i1, "px"), this.dirty = !1;
                }
            },
            {
                key: "_repaintDomAdditionals",
                value: function() {
                    this._repaintOnItemUpdateTimeTooltip(this.dom.point), this._repaintDragCenter(), this._repaintDeleteButton(this.dom.point);
                }
            },
            {
                key: "redraw",
                value: function(t) {
                    var e, i1, n, o, r, s, a = this, l = [
                        Hc(e = this._createDomElement).call(e, this),
                        Hc(i1 = this._appendDomElement).call(i1, this),
                        Hc(n = this._updateDirtyDomComponents).call(n, this),
                        function() {
                            a.dirty && (r = a._getDomComponentsSizes());
                        },
                        function() {
                            var t;
                            a.dirty && Hc(t = a._updateDomComponentsSizes).call(t, a)(r);
                        },
                        Hc(o = this._repaintDomAdditionals).call(o, this)
                    ];
                    return t ? l : (bd(l).call(l, function(t) {
                        s = t();
                    }), s);
                }
            },
            {
                key: "repositionXY",
                value: function() {
                    var t = this.options.rtl, e = function(t, e, i1) {
                        var n;
                        if (void 0 !== e || void 0 !== i1) {
                            var o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3] ? -1 * e : e;
                            t.style.transform = void 0 !== i1 ? void 0 !== e ? mf(n = "translate(".concat(o, "px, ")).call(n, i1, "px)") : "translateY(".concat(i1, "px)") : "translateX(".concat(o, "px)");
                        }
                    };
                    e(this.dom.point, this.pointX, this.pointY, t);
                }
            },
            {
                key: "show",
                value: function(t) {
                    if (!this.displayed) return this.redraw(t);
                }
            },
            {
                key: "hide",
                value: function() {
                    this.displayed && (this.dom.point.parentNode && this.dom.point.parentNode.removeChild(this.dom.point), this.displayed = !1);
                }
            },
            {
                key: "repositionX",
                value: function() {
                    var t = this.conversion.toScreen(this.data.start);
                    this.pointX = t, this.options.rtl ? this.right = t - this.props.dot.width : this.left = t - this.props.dot.width, this.repositionXY();
                }
            },
            {
                key: "repositionY",
                value: function() {
                    var t = this.options.orientation.item;
                    this.pointY = "top" == t ? this.top : this.parent.height - this.top - this.height, this.repositionXY();
                }
            },
            {
                key: "getWidthLeft",
                value: function() {
                    return this.props.dot.width;
                }
            },
            {
                key: "getWidthRight",
                value: function() {
                    return this.props.dot.width;
                }
            }
        ]), i1;
    }(DD);
    function ID(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    var PD = function(t) {
        Ic(i1, t);
        var e = ID(i1);
        function i1(t, n, o) {
            var r;
            if (Lo(this, i1), (r = e.call(this, t, n, o)).props = {
                content: {
                    width: 0
                }
            }, r.overflow = !1, t) {
                if (null == t.start) throw new Error('Property "start" missing in item '.concat(t.id));
                if (null == t.end) throw new Error('Property "end" missing in item '.concat(t.id));
            }
            return r;
        }
        return mc(i1, [
            {
                key: "isVisible",
                value: function(t) {
                    return !this.cluster && this.data.start < t.end && this.data.end > t.start;
                }
            },
            {
                key: "_createDomElement",
                value: function() {
                    this.dom || (this.dom = {}, this.dom.box = document.createElement("div"), this.dom.frame = document.createElement("div"), this.dom.frame.className = "vis-item-overflow", this.dom.box.appendChild(this.dom.frame), this.dom.visibleFrame = document.createElement("div"), this.dom.visibleFrame.className = "vis-item-visible-frame", this.dom.box.appendChild(this.dom.visibleFrame), this.dom.content = document.createElement("div"), this.dom.content.className = "vis-item-content", this.dom.frame.appendChild(this.dom.content), this.dom.box["vis-item"] = this, this.dirty = !0);
                }
            },
            {
                key: "_appendDomElement",
                value: function() {
                    if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                    if (!this.dom.box.parentNode) {
                        var t = this.parent.dom.foreground;
                        if (!t) throw new Error("Cannot redraw item: parent has no foreground container element");
                        t.appendChild(this.dom.box);
                    }
                    this.displayed = !0;
                }
            },
            {
                key: "_updateDirtyDomComponents",
                value: function() {
                    if (this.dirty) {
                        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.box), this._updateStyle(this.dom.box);
                        var t = this.editable.updateTime || this.editable.updateGroup, e = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (t ? " vis-editable" : " vis-readonly");
                        this.dom.box.className = this.baseClassName + e, this.dom.content.style.maxWidth = "none";
                    }
                }
            },
            {
                key: "_getDomComponentsSizes",
                value: function() {
                    return this.overflow = "hidden" !== window.getComputedStyle(this.dom.frame).overflow, this.whiteSpace = "nowrap" !== window.getComputedStyle(this.dom.content).whiteSpace, {
                        content: {
                            width: this.dom.content.offsetWidth
                        },
                        box: {
                            height: this.dom.box.offsetHeight
                        }
                    };
                }
            },
            {
                key: "_updateDomComponentsSizes",
                value: function(t) {
                    this.props.content.width = t.content.width, this.height = t.box.height, this.dom.content.style.maxWidth = "", this.dirty = !1;
                }
            },
            {
                key: "_repaintDomAdditionals",
                value: function() {
                    this._repaintOnItemUpdateTimeTooltip(this.dom.box), this._repaintDeleteButton(this.dom.box), this._repaintDragCenter(), this._repaintDragLeft(), this._repaintDragRight();
                }
            },
            {
                key: "redraw",
                value: function(t) {
                    var e, i1, n, o, r, s, a = this, l = [
                        Hc(e = this._createDomElement).call(e, this),
                        Hc(i1 = this._appendDomElement).call(i1, this),
                        Hc(n = this._updateDirtyDomComponents).call(n, this),
                        function() {
                            var t;
                            a.dirty && (r = Hc(t = a._getDomComponentsSizes).call(t, a)());
                        },
                        function() {
                            var t;
                            a.dirty && Hc(t = a._updateDomComponentsSizes).call(t, a)(r);
                        },
                        Hc(o = this._repaintDomAdditionals).call(o, this)
                    ];
                    return t ? l : (bd(l).call(l, function(t) {
                        s = t();
                    }), s);
                }
            },
            {
                key: "show",
                value: function(t) {
                    if (!this.displayed) return this.redraw(t);
                }
            },
            {
                key: "hide",
                value: function() {
                    if (this.displayed) {
                        var t = this.dom.box;
                        t.parentNode && t.parentNode.removeChild(t), this.displayed = !1;
                    }
                }
            },
            {
                key: "repositionX",
                value: function(t) {
                    var e, i1, n = this.parent.width, o = this.conversion.toScreen(this.data.start), r = this.conversion.toScreen(this.data.end), s = void 0 === this.data.align ? this.options.align : this.data.align;
                    !1 === this.data.limitSize || void 0 !== t && !0 !== t || (o < -n && (o = -n), r > 2 * n && (r = 2 * n));
                    var a = Math.max(Math.round(1e3 * (r - o)) / 1e3, 1);
                    switch(this.overflow ? (this.options.rtl ? this.right = o : this.left = o, this.width = a + this.props.content.width, i1 = this.props.content.width) : (this.options.rtl ? this.right = o : this.left = o, this.width = a, i1 = Math.min(r - o, this.props.content.width)), this.options.rtl ? this.dom.box.style.transform = "translateX(".concat(-1 * this.right, "px)") : this.dom.box.style.transform = "translateX(".concat(this.left, "px)"), this.dom.box.style.width = "".concat(a, "px"), this.whiteSpace && (this.height = this.dom.box.offsetHeight), s){
                        case "left":
                            this.dom.content.style.transform = "translateX(0)";
                            break;
                        case "right":
                            if (this.options.rtl) {
                                var l = -1 * Math.max(a - i1, 0);
                                this.dom.content.style.transform = "translateX(".concat(l, "px)");
                            } else this.dom.content.style.transform = "translateX(".concat(Math.max(a - i1, 0), "px)");
                            break;
                        case "center":
                            if (this.options.rtl) {
                                var h = -1 * Math.max((a - i1) / 2, 0);
                                this.dom.content.style.transform = "translateX(".concat(h, "px)");
                            } else this.dom.content.style.transform = "translateX(".concat(Math.max((a - i1) / 2, 0), "px)");
                            break;
                        default:
                            if (e = this.overflow ? r > 0 ? Math.max(-o, 0) : -i1 : o < 0 ? -o : 0, this.options.rtl) {
                                var u = -1 * e;
                                this.dom.content.style.transform = "translateX(".concat(u, "px)");
                            } else this.dom.content.style.transform = "translateX(".concat(e, "px)");
                    }
                }
            },
            {
                key: "repositionY",
                value: function() {
                    var t = this.options.orientation.item, e = this.dom.box;
                    e.style.top = "".concat("top" == t ? this.top : this.parent.height - this.top - this.height, "px");
                }
            },
            {
                key: "_repaintDragLeft",
                value: function() {
                    if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.editable.updateTime && !this.dom.dragLeft) {
                        var t = document.createElement("div");
                        t.className = "vis-drag-left", t.dragLeftItem = this, this.dom.box.appendChild(t), this.dom.dragLeft = t;
                    } else this.selected || this.options.itemsAlwaysDraggable.range || !this.dom.dragLeft || (this.dom.dragLeft.parentNode && this.dom.dragLeft.parentNode.removeChild(this.dom.dragLeft), this.dom.dragLeft = null);
                }
            },
            {
                key: "_repaintDragRight",
                value: function() {
                    if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.editable.updateTime && !this.dom.dragRight) {
                        var t = document.createElement("div");
                        t.className = "vis-drag-right", t.dragRightItem = this, this.dom.box.appendChild(t), this.dom.dragRight = t;
                    } else this.selected || this.options.itemsAlwaysDraggable.range || !this.dom.dragRight || (this.dom.dragRight.parentNode && this.dom.dragRight.parentNode.removeChild(this.dom.dragRight), this.dom.dragRight = null);
                }
            }
        ]), i1;
    }(DD);
    function MD(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    PD.prototype.baseClassName = "vis-item vis-range";
    var ND = function(t) {
        Ic(i1, t);
        var e = MD(i1);
        function i1(t, n, o) {
            var r;
            if (Lo(this, i1), (r = e.call(this, t, n, o)).props = {
                content: {
                    width: 0
                }
            }, r.overflow = !1, t) {
                if (null == t.start) throw new Error('Property "start" missing in item '.concat(t.id));
                if (null == t.end) throw new Error('Property "end" missing in item '.concat(t.id));
            }
            return r;
        }
        return mc(i1, [
            {
                key: "isVisible",
                value: function(t) {
                    return this.data.start < t.end && this.data.end > t.start;
                }
            },
            {
                key: "_createDomElement",
                value: function() {
                    this.dom || (this.dom = {}, this.dom.box = document.createElement("div"), this.dom.frame = document.createElement("div"), this.dom.frame.className = "vis-item-overflow", this.dom.box.appendChild(this.dom.frame), this.dom.content = document.createElement("div"), this.dom.content.className = "vis-item-content", this.dom.frame.appendChild(this.dom.content), this.dirty = !0);
                }
            },
            {
                key: "_appendDomElement",
                value: function() {
                    if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                    if (!this.dom.box.parentNode) {
                        var t = this.parent.dom.background;
                        if (!t) throw new Error("Cannot redraw item: parent has no background container element");
                        t.appendChild(this.dom.box);
                    }
                    this.displayed = !0;
                }
            },
            {
                key: "_updateDirtyDomComponents",
                value: function() {
                    if (this.dirty) {
                        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.content), this._updateStyle(this.dom.box);
                        var t = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "");
                        this.dom.box.className = this.baseClassName + t;
                    }
                }
            },
            {
                key: "_getDomComponentsSizes",
                value: function() {
                    return this.overflow = "hidden" !== window.getComputedStyle(this.dom.content).overflow, {
                        content: {
                            width: this.dom.content.offsetWidth
                        }
                    };
                }
            },
            {
                key: "_updateDomComponentsSizes",
                value: function(t) {
                    this.props.content.width = t.content.width, this.height = 0, this.dirty = !1;
                }
            },
            {
                key: "_repaintDomAdditionals",
                value: function() {}
            },
            {
                key: "redraw",
                value: function(t) {
                    var e, i1, n, o, r, s, a = this, l = [
                        Hc(e = this._createDomElement).call(e, this),
                        Hc(i1 = this._appendDomElement).call(i1, this),
                        Hc(n = this._updateDirtyDomComponents).call(n, this),
                        function() {
                            var t;
                            a.dirty && (r = Hc(t = a._getDomComponentsSizes).call(t, a)());
                        },
                        function() {
                            var t;
                            a.dirty && Hc(t = a._updateDomComponentsSizes).call(t, a)(r);
                        },
                        Hc(o = this._repaintDomAdditionals).call(o, this)
                    ];
                    return t ? l : (bd(l).call(l, function(t) {
                        s = t();
                    }), s);
                }
            },
            {
                key: "repositionY",
                value: function(t) {
                    var e, i1 = this.options.orientation.item;
                    if (void 0 !== this.data.subgroup) {
                        var n = this.data.subgroup;
                        this.dom.box.style.height = "".concat(this.parent.subgroups[n].height, "px"), this.dom.box.style.top = "".concat("top" == i1 ? this.parent.top + this.parent.subgroups[n].top : this.parent.top + this.parent.height - this.parent.subgroups[n].top - this.parent.subgroups[n].height, "px"), this.dom.box.style.bottom = "";
                    } else this.parent instanceof xD ? (e = Math.max(this.parent.height, this.parent.itemSet.body.domProps.center.height, this.parent.itemSet.body.domProps.centerContainer.height), this.dom.box.style.bottom = "bottom" == i1 ? "0" : "", this.dom.box.style.top = "top" == i1 ? "0" : "") : (e = this.parent.height, this.dom.box.style.top = "".concat(this.parent.top, "px"), this.dom.box.style.bottom = "");
                    this.dom.box.style.height = "".concat(e, "px");
                }
            }
        ]), i1;
    }(DD);
    ND.prototype.baseClassName = "vis-item vis-background", ND.prototype.stack = !1, ND.prototype.show = PD.prototype.show, ND.prototype.hide = PD.prototype.hide, ND.prototype.repositionX = PD.prototype.repositionX;
    var FD = function() {
        function t(e, i1) {
            Lo(this, t), this.container = e, this.overflowMethod = i1 || "cap", this.x = 0, this.y = 0, this.padding = 5, this.hidden = !1, this.frame = document.createElement("div"), this.frame.className = "vis-tooltip", this.container.appendChild(this.frame);
        }
        return mc(t, [
            {
                key: "setPosition",
                value: function(t, e) {
                    this.x = gg(t), this.y = gg(e);
                }
            },
            {
                key: "setText",
                value: function(t) {
                    t instanceof Element ? (this.frame.innerHTML = "", this.frame.appendChild(t)) : this.frame.innerHTML = l_.xss(t);
                }
            },
            {
                key: "show",
                value: function(t) {
                    if (void 0 === t && (t = !0), !0 === t) {
                        var e = this.frame.clientHeight, i1 = this.frame.clientWidth, n = this.frame.parentNode.clientHeight, o = this.frame.parentNode.clientWidth, r = 0, s = 0;
                        if ("flip" == this.overflowMethod || "none" == this.overflowMethod) {
                            var a = !1, l = !0;
                            "flip" == this.overflowMethod && (this.y - e < this.padding && (l = !1), this.x + i1 > o - this.padding && (a = !0)), r = a ? this.x - i1 : this.x, s = l ? this.y - e : this.y;
                        } else (s = this.y - e) + e + this.padding > n && (s = n - e - this.padding), s < this.padding && (s = this.padding), (r = this.x) + i1 + this.padding > o && (r = o - i1 - this.padding), r < this.padding && (r = this.padding);
                        this.frame.style.left = r + "px", this.frame.style.top = s + "px", this.frame.style.visibility = "visible", this.hidden = !1;
                    } else this.hide();
                }
            },
            {
                key: "hide",
                value: function() {
                    this.hidden = !0, this.frame.style.left = "0", this.frame.style.top = "0", this.frame.style.visibility = "hidden";
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.frame.parentNode.removeChild(this.frame);
                }
            }
        ]), t;
    }(), RD = Hs.every;
    Ii({
        target: "Array",
        proto: !0,
        forced: !ld("every")
    }, {
        every: function(t) {
            return RD(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var LD = _c("Array").every, jD = ut, BD = LD, zD = Array.prototype, HD = function(t) {
        var e = t.every;
        return t === zD || jD(zD, t) && e === zD.every ? BD : e;
    }, GD = r(HD);
    function WD(t, e) {
        var i1 = void 0 !== lf && ym(t) || t["@@iterator"];
        if (!i1) {
            if (zc(t) || (i1 = function(t, e) {
                var i1;
                if (!t) return;
                if ("string" == typeof t) return YD(t, e);
                var n = ff(i1 = Object.prototype.toString.call(t)).call(i1, 8, -1);
                "Object" === n && t.constructor && (n = t.constructor.name);
                if ("Map" === n || "Set" === n) return fm(t);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return YD(t, e);
            }(t)) || e && t && "number" == typeof t.length) {
                i1 && (t = i1);
                var n = 0, o = function() {};
                return {
                    s: o,
                    n: function() {
                        return n >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[n++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: o
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var r, s = !0, a = !1;
        return {
            s: function() {
                i1 = i1.call(t);
            },
            n: function() {
                var t = i1.next();
                return s = t.done, t;
            },
            e: function(t) {
                a = !0, r = t;
            },
            f: function() {
                try {
                    s || null == i1.return || i1.return();
                } finally{
                    if (a) throw r;
                }
            }
        };
    }
    function YD(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var i1 = 0, n = new Array(e); i1 < e; i1++)n[i1] = t[i1];
        return n;
    }
    function VD(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    var UD = function(t) {
        Ic(i1, t);
        var e = VD(i1);
        function i1(t, n, o) {
            var r;
            Lo(this, i1);
            var s = pv({}, {
                fitOnDoubleClick: !0
            }, o, {
                editable: !1
            });
            if ((r = e.call(this, t, n, s)).props = {
                content: {
                    width: 0,
                    height: 0
                }
            }, !t || null == t.uiItems) throw new Error('Property "uiItems" missing in item ' + t.id);
            return r.id = Zk(), r.group = t.group, r._setupRange(), r.emitter = r.data.eventEmitter, r.range = r.data.range, r.attached = !1, r.isCluster = !0, r.data.isCluster = !0, r;
        }
        return mc(i1, [
            {
                key: "hasItems",
                value: function() {
                    return this.data.uiItems && this.data.uiItems.length && this.attached;
                }
            },
            {
                key: "setUiItems",
                value: function(t) {
                    this.detach(), this.data.uiItems = t, this._setupRange(), this.attach();
                }
            },
            {
                key: "isVisible",
                value: function(t) {
                    var e = this.data.end ? this.data.end - this.data.start : 0, i1 = this.width * t.getMillisecondsPerPixel(), n = Math.max(this.data.start.getTime() + e, this.data.start.getTime() + i1);
                    return this.data.start < t.end && n > t.start && this.hasItems();
                }
            },
            {
                key: "getData",
                value: function() {
                    return {
                        isCluster: !0,
                        id: this.id,
                        items: this.data.items || [],
                        data: this.data
                    };
                }
            },
            {
                key: "redraw",
                value: function(t) {
                    var e, i1, n, o, r, s, a, l, h = [
                        Hc(e = this._createDomElement).call(e, this),
                        Hc(i1 = this._appendDomElement).call(i1, this),
                        Hc(n = this._updateDirtyDomComponents).call(n, this),
                        Hc(o = function() {
                            this.dirty && (a = this._getDomComponentsSizes());
                        }).call(o, this),
                        Hc(r = function() {
                            var t;
                            this.dirty && Hc(t = this._updateDomComponentsSizes).call(t, this)(a);
                        }).call(r, this),
                        Hc(s = this._repaintDomAdditionals).call(s, this)
                    ];
                    return t ? h : (bd(h).call(h, function(t) {
                        l = t();
                    }), l);
                }
            },
            {
                key: "show",
                value: function() {
                    this.displayed || this.redraw();
                }
            },
            {
                key: "hide",
                value: function() {
                    if (this.displayed) {
                        var t = this.dom;
                        t.box.parentNode && t.box.parentNode.removeChild(t.box), this.options.showStipes && (t.line.parentNode && t.line.parentNode.removeChild(t.line), t.dot.parentNode && t.dot.parentNode.removeChild(t.dot)), this.displayed = !1;
                    }
                }
            },
            {
                key: "repositionX",
                value: function() {
                    var t = this.conversion.toScreen(this.data.start), e = this.data.end ? this.conversion.toScreen(this.data.end) : 0;
                    if (e) this.repositionXWithRanges(t, e);
                    else {
                        var i1 = void 0 === this.data.align ? this.options.align : this.data.align;
                        this.repositionXWithoutRanges(t, i1);
                    }
                    this.options.showStipes && (this.dom.line.style.display = this._isStipeVisible() ? "block" : "none", this.dom.dot.style.display = this._isStipeVisible() ? "block" : "none", this._isStipeVisible() && this.repositionStype(t, e));
                }
            },
            {
                key: "repositionStype",
                value: function(t, e) {
                    this.dom.line.style.display = "block", this.dom.dot.style.display = "block";
                    var i1 = this.dom.line.offsetWidth, n = this.dom.dot.offsetWidth;
                    if (e) {
                        var o = i1 + t + (e - t) / 2, r = o - n / 2, s = this.options.rtl ? -1 * o : o, a = this.options.rtl ? -1 * r : r;
                        this.dom.line.style.transform = "translateX(".concat(s, "px)"), this.dom.dot.style.transform = "translateX(".concat(a, "px)");
                    } else {
                        var l = this.options.rtl ? -1 * t : t, h = this.options.rtl ? -1 * (t - n / 2) : t - n / 2;
                        this.dom.line.style.transform = "translateX(".concat(l, "px)"), this.dom.dot.style.transform = "translateX(".concat(h, "px)");
                    }
                }
            },
            {
                key: "repositionXWithoutRanges",
                value: function(t, e) {
                    "right" == e ? this.options.rtl ? (this.right = t - this.width, this.dom.box.style.right = this.right + "px") : (this.left = t - this.width, this.dom.box.style.left = this.left + "px") : "left" == e ? this.options.rtl ? (this.right = t, this.dom.box.style.right = this.right + "px") : (this.left = t, this.dom.box.style.left = this.left + "px") : this.options.rtl ? (this.right = t - this.width / 2, this.dom.box.style.right = this.right + "px") : (this.left = t - this.width / 2, this.dom.box.style.left = this.left + "px");
                }
            },
            {
                key: "repositionXWithRanges",
                value: function(t, e) {
                    var i1 = Math.round(Math.max(e - t + .5, 1));
                    this.options.rtl ? this.right = t : this.left = t, this.width = Math.max(i1, this.minWidth || 0), this.options.rtl ? this.dom.box.style.right = this.right + "px" : this.dom.box.style.left = this.left + "px", this.dom.box.style.width = i1 + "px";
                }
            },
            {
                key: "repositionY",
                value: function() {
                    var t = this.options.orientation.item, e = this.dom.box;
                    if (e.style.top = "top" == t ? (this.top || 0) + "px" : (this.parent.height - this.top - this.height || 0) + "px", this.options.showStipes) {
                        if ("top" == t) this.dom.line.style.top = "0", this.dom.line.style.height = this.parent.top + this.top + 1 + "px", this.dom.line.style.bottom = "";
                        else {
                            var i1 = this.parent.itemSet.props.height, n = i1 - this.parent.top - this.parent.height + this.top;
                            this.dom.line.style.top = i1 - n + "px", this.dom.line.style.bottom = "0";
                        }
                        this.dom.dot.style.top = -this.dom.dot.offsetHeight / 2 + "px";
                    }
                }
            },
            {
                key: "getWidthLeft",
                value: function() {
                    return this.width / 2;
                }
            },
            {
                key: "getWidthRight",
                value: function() {
                    return this.width / 2;
                }
            },
            {
                key: "move",
                value: function() {
                    this.repositionX(), this.repositionY();
                }
            },
            {
                key: "attach",
                value: function() {
                    var t, e, i1 = WD(this.data.uiItems);
                    try {
                        for(i1.s(); !(e = i1.n()).done;)e.value.cluster = this;
                    } catch (t) {
                        i1.e(t);
                    } finally{
                        i1.f();
                    }
                    this.data.items = lp(t = this.data.uiItems).call(t, function(t) {
                        return t.data;
                    }), this.attached = !0, this.dirty = !0;
                }
            },
            {
                key: "detach",
                value: function() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    if (this.hasItems()) {
                        var e, i1 = WD(this.data.uiItems);
                        try {
                            for(i1.s(); !(e = i1.n()).done;)delete e.value.cluster;
                        } catch (t) {
                            i1.e(t);
                        } finally{
                            i1.f();
                        }
                        this.attached = !1, t && this.group && (this.group.remove(this), this.group = null), this.data.items = [], this.dirty = !0;
                    }
                }
            },
            {
                key: "_onDoubleClick",
                value: function() {
                    this._fit();
                }
            },
            {
                key: "_setupRange",
                value: function() {
                    var t, e, i1, n = lp(t = this.data.uiItems).call(t, function(t) {
                        return {
                            start: t.data.start.valueOf(),
                            end: t.data.end ? t.data.end.valueOf() : t.data.start.valueOf()
                        };
                    });
                    this.data.min = Math.min.apply(Math, af(lp(n).call(n, function(t) {
                        return Math.min(t.start, t.end || t.start);
                    }))), this.data.max = Math.max.apply(Math, af(lp(n).call(n, function(t) {
                        return Math.max(t.start, t.end || t.start);
                    })));
                    var o = lp(e = this.data.uiItems).call(e, function(t) {
                        return t.center;
                    }), r = xp(o).call(o, function(t, e) {
                        return t + e;
                    }, 0) / this.data.uiItems.length;
                    Bx(i1 = this.data.uiItems).call(i1, function(t) {
                        return t.data.end;
                    }) ? (this.data.start = new Date(this.data.min), this.data.end = new Date(this.data.max)) : (this.data.start = new Date(r), this.data.end = null);
                }
            },
            {
                key: "_getUiItems",
                value: function() {
                    var t, e = this;
                    return this.data.uiItems && this.data.uiItems.length ? Ed(t = this.data.uiItems).call(t, function(t) {
                        return t.cluster === e;
                    }) : [];
                }
            },
            {
                key: "_createDomElement",
                value: function() {
                    if (!this.dom) {
                        var t;
                        if (this.dom = {}, this.dom.box = document.createElement("DIV"), this.dom.content = document.createElement("DIV"), this.dom.content.className = "vis-item-content", this.dom.box.appendChild(this.dom.content), this.options.showStipes && (this.dom.line = document.createElement("DIV"), this.dom.line.className = "vis-cluster-line", this.dom.line.style.display = "none", this.dom.dot = document.createElement("DIV"), this.dom.dot.className = "vis-cluster-dot", this.dom.dot.style.display = "none"), this.options.fitOnDoubleClick) this.dom.box.ondblclick = Hc(t = i1.prototype._onDoubleClick).call(t, this);
                        this.dom.box["vis-item"] = this, this.dirty = !0;
                    }
                }
            },
            {
                key: "_appendDomElement",
                value: function() {
                    if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                    if (!this.dom.box.parentNode) {
                        var t = this.parent.dom.foreground;
                        if (!t) throw new Error("Cannot redraw item: parent has no foreground container element");
                        t.appendChild(this.dom.box);
                    }
                    var e = this.parent.dom.background;
                    if (this.options.showStipes) {
                        if (!this.dom.line.parentNode) {
                            if (!e) throw new Error("Cannot redraw item: parent has no background container element");
                            e.appendChild(this.dom.line);
                        }
                        if (!this.dom.dot.parentNode) {
                            var i1 = this.parent.dom.axis;
                            if (!e) throw new Error("Cannot redraw item: parent has no axis container element");
                            i1.appendChild(this.dom.dot);
                        }
                    }
                    this.displayed = !0;
                }
            },
            {
                key: "_updateDirtyDomComponents",
                value: function() {
                    if (this.dirty) {
                        this._updateContents(this.dom.content), this._updateDataAttributes(this.dom.box), this._updateStyle(this.dom.box);
                        var t = this.baseClassName + " " + (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + " vis-readonly";
                        this.dom.box.className = "vis-item " + t, this.options.showStipes && (this.dom.line.className = "vis-item vis-cluster-line " + (this.selected ? " vis-selected" : ""), this.dom.dot.className = "vis-item vis-cluster-dot " + (this.selected ? " vis-selected" : "")), this.data.end && (this.dom.content.style.maxWidth = "none");
                    }
                }
            },
            {
                key: "_getDomComponentsSizes",
                value: function() {
                    var t = {
                        previous: {
                            right: this.dom.box.style.right,
                            left: this.dom.box.style.left
                        },
                        box: {
                            width: this.dom.box.offsetWidth,
                            height: this.dom.box.offsetHeight
                        }
                    };
                    return this.options.showStipes && (t.dot = {
                        height: this.dom.dot.offsetHeight,
                        width: this.dom.dot.offsetWidth
                    }, t.line = {
                        width: this.dom.line.offsetWidth
                    }), t;
                }
            },
            {
                key: "_updateDomComponentsSizes",
                value: function(t) {
                    this.options.rtl ? this.dom.box.style.right = "0px" : this.dom.box.style.left = "0px", this.data.end ? this.minWidth = t.box.width : this.width = t.box.width, this.height = t.box.height, this.options.rtl ? this.dom.box.style.right = t.previous.right : this.dom.box.style.left = t.previous.left, this.dirty = !1;
                }
            },
            {
                key: "_repaintDomAdditionals",
                value: function() {
                    this._repaintOnItemUpdateTimeTooltip(this.dom.box);
                }
            },
            {
                key: "_isStipeVisible",
                value: function() {
                    return this.minWidth >= this.width || !this.data.end;
                }
            },
            {
                key: "_getFitRange",
                value: function() {
                    var t = .05 * (this.data.max - this.data.min) / 2;
                    return {
                        fitStart: this.data.min - t,
                        fitEnd: this.data.max + t
                    };
                }
            },
            {
                key: "_fit",
                value: function() {
                    if (this.emitter) {
                        var t = this._getFitRange(), e = t.fitStart, i1 = t.fitEnd, n = {
                            start: new Date(e),
                            end: new Date(i1),
                            animation: !0
                        };
                        this.emitter.emit("fit", n);
                    }
                }
            },
            {
                key: "_getItemData",
                value: function() {
                    return this.data;
                }
            }
        ]), i1;
    }(DD);
    function XD(t, e) {
        var i1 = void 0 !== lf && ym(t) || t["@@iterator"];
        if (!i1) {
            if (zc(t) || (i1 = function(t, e) {
                var i1;
                if (!t) return;
                if ("string" == typeof t) return qD(t, e);
                var n = ff(i1 = Object.prototype.toString.call(t)).call(i1, 8, -1);
                "Object" === n && t.constructor && (n = t.constructor.name);
                if ("Map" === n || "Set" === n) return fm(t);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return qD(t, e);
            }(t)) || e && t && "number" == typeof t.length) {
                i1 && (t = i1);
                var n = 0, o = function() {};
                return {
                    s: o,
                    n: function() {
                        return n >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[n++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: o
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var r, s = !0, a = !1;
        return {
            s: function() {
                i1 = i1.call(t);
            },
            n: function() {
                var t = i1.next();
                return s = t.done, t;
            },
            e: function(t) {
                a = !0, r = t;
            },
            f: function() {
                try {
                    s || null == i1.return || i1.return();
                } finally{
                    if (a) throw r;
                }
            }
        };
    }
    function qD(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var i1 = 0, n = new Array(e); i1 < e; i1++)n[i1] = t[i1];
        return n;
    }
    UD.prototype.baseClassName = "vis-item vis-range vis-cluster";
    var KD = "__ungrouped__", $D = function() {
        function t(e) {
            Lo(this, t), this.itemSet = e, this.groups = {}, this.cache = {}, this.cache[-1] = [];
        }
        return mc(t, [
            {
                key: "createClusterItem",
                value: function(t, e, i1) {
                    return new UD(t, e, i1);
                }
            },
            {
                key: "setItems",
                value: function(t, e) {
                    this.items = t || [], this.dataChanged = !0, this.applyOnChangedLevel = !1, e && e.applyOnChangedLevel && (this.applyOnChangedLevel = e.applyOnChangedLevel);
                }
            },
            {
                key: "updateData",
                value: function() {
                    this.dataChanged = !0, this.applyOnChangedLevel = !1;
                }
            },
            {
                key: "getClusters",
                value: function(t, e, i1) {
                    var n = "boolean" == typeof i1 ? {} : i1, o = n.maxItems, r = n.clusterCriteria;
                    r || (r = function() {
                        return !0;
                    }), o = o || 1;
                    var s = -1, a = 0;
                    if (e > 0) {
                        if (e >= 1) return [];
                        s = Math.abs(Math.round(Math.log(100 / e) / Math.log(2))), a = Math.abs(Math.pow(2, s));
                    }
                    if (this.dataChanged) {
                        var l = s != this.cacheLevel;
                        (!this.applyOnChangedLevel || l) && (this._dropLevelsCache(), this._filterData());
                    }
                    this.cacheLevel = s;
                    var h = this.cache[s];
                    if (!h) {
                        for(var u in h = [], this.groups)if (this.groups.hasOwnProperty(u)) for(var c = this.groups[u], d = c.length, p = 0; p < d;){
                            for(var m = c[p], f = 1, v = p - 1; v >= 0 && m.center - c[v].center < a / 2;)!c[v].cluster && r(m.data, c[v].data) && f++, v--;
                            for(var g = p + 1; g < c.length && c[g].center - m.center < a / 2;)r(m.data, c[g].data) && f++, g++;
                            for(var y = h.length - 1; y >= 0 && m.center - h[y].center < a;)m.group == h[y].group && r(m.data, h[y].data) && f++, y--;
                            if (f > o) {
                                for(var b = f - o + 1, w = [], k = p; w.length < b && k < c.length;)r(c[p].data, c[k].data) && w.push(c[k]), k++;
                                var _ = this.itemSet.getGroupId(m.data), x = this.itemSet.groups[_] || this.itemSet.groups[KD], C = this._getClusterForItems(w, x, t, i1);
                                h.push(C), p += b;
                            } else delete m.cluster, p += 1;
                        }
                        this.cache[s] = h;
                    }
                    return h;
                }
            },
            {
                key: "_filterData",
                value: function() {
                    var t = {};
                    this.groups = t;
                    for(var e = 0, i1 = Kv(this.items); e < i1.length; e++){
                        var n = i1[e], o = n.parent ? n.parent.groupId : "", r = t[o];
                        r || (r = [], t[o] = r), r.push(n), n.data.start && (n.data.end ? n.center = (n.data.start.valueOf() + n.data.end.valueOf()) / 2 : n.center = n.data.start.valueOf());
                    }
                    for(var s in t){
                        var a;
                        if (t.hasOwnProperty(s)) mx(a = t[s]).call(a, function(t, e) {
                            return t.center - e.center;
                        });
                    }
                    this.dataChanged = !1;
                }
            },
            {
                key: "_getClusterForItems",
                value: function(t, e, i1, n) {
                    var o, r, s = lp(o = i1 || []).call(o, function(t) {
                        var e;
                        return {
                            cluster: t,
                            itemsIds: new $S(lp(e = t.data.uiItems).call(e, function(t) {
                                return t.id;
                            }))
                        };
                    });
                    if (s.length) {
                        var a, l = XD(s);
                        try {
                            var h = function() {
                                var e = a.value;
                                if (e.itemsIds.size === t.length && GD(t).call(t, function(t) {
                                    return e.itemsIds.has(t.id);
                                })) return r = e.cluster, 1;
                            };
                            for(l.s(); !(a = l.n()).done && !h(););
                        } catch (t) {
                            l.e(t);
                        } finally{
                            l.f();
                        }
                    }
                    if (r) return r.setUiItems(t), r.group !== e && (r.group && r.group.remove(r), e && (e.add(r), r.group = e)), r;
                    var u = n.titleTemplate || "", c = {
                        toScreen: this.itemSet.body.util.toScreen,
                        toTime: this.itemSet.body.util.toTime
                    }, d = u.replace(/{count}/, t.length), p = '<div title="' + d + '">' + t.length + "</div>", m = pv({}, n, this.itemSet.options), f = {
                        content: p,
                        title: d,
                        group: e,
                        uiItems: t,
                        eventEmitter: this.itemSet.body.emitter,
                        range: this.itemSet.body.range
                    };
                    return r = this.createClusterItem(f, c, m), e && (e.add(r), r.group = e), r.attach(), r;
                }
            },
            {
                key: "_dropLevelsCache",
                value: function() {
                    this.cache = {}, this.cacheLevel = -1, this.cache[this.cacheLevel] = [];
                }
            }
        ]), t;
    }();
    function ZD(t, e) {
        var i1 = void 0 !== lf && ym(t) || t["@@iterator"];
        if (!i1) {
            if (zc(t) || (i1 = function(t, e) {
                var i1;
                if (!t) return;
                if ("string" == typeof t) return QD(t, e);
                var n = ff(i1 = Object.prototype.toString.call(t)).call(i1, 8, -1);
                "Object" === n && t.constructor && (n = t.constructor.name);
                if ("Map" === n || "Set" === n) return fm(t);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return QD(t, e);
            }(t)) || e && t && "number" == typeof t.length) {
                i1 && (t = i1);
                var n = 0, o = function() {};
                return {
                    s: o,
                    n: function() {
                        return n >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[n++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: o
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var r, s = !0, a = !1;
        return {
            s: function() {
                i1 = i1.call(t);
            },
            n: function() {
                var t = i1.next();
                return s = t.done, t;
            },
            e: function(t) {
                a = !0, r = t;
            },
            f: function() {
                try {
                    s || null == i1.return || i1.return();
                } finally{
                    if (a) throw r;
                }
            }
        };
    }
    function QD(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var i1 = 0, n = new Array(e); i1 < e; i1++)n[i1] = t[i1];
        return n;
    }
    function JD(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    var tT = "__ungrouped__", eT = "__background__", iT = function(t) {
        Ic(i1, t);
        var e = JD(i1);
        function i1(t, n) {
            var o;
            Lo(this, i1), (o = e.call(this)).body = t, o.defaultOptions = {
                type: null,
                orientation: {
                    item: "bottom"
                },
                align: "auto",
                stack: !0,
                stackSubgroups: !0,
                groupOrderSwap: function(t, e, i1) {
                    var n = e.order;
                    e.order = t.order, t.order = n;
                },
                groupOrder: "order",
                selectable: !0,
                multiselect: !1,
                longSelectPressTime: 251,
                itemsAlwaysDraggable: {
                    item: !1,
                    range: !1
                },
                editable: {
                    updateTime: !1,
                    updateGroup: !1,
                    add: !1,
                    remove: !1,
                    overrideItems: !1
                },
                groupEditable: {
                    order: !1,
                    add: !1,
                    remove: !1
                },
                snap: Yx.snap,
                onDropObjectOnItem: function(t, e, i1) {
                    i1(e);
                },
                onAdd: function(t, e) {
                    e(t);
                },
                onUpdate: function(t, e) {
                    e(t);
                },
                onMove: function(t, e) {
                    e(t);
                },
                onRemove: function(t, e) {
                    e(t);
                },
                onMoving: function(t, e) {
                    e(t);
                },
                onAddGroup: function(t, e) {
                    e(t);
                },
                onMoveGroup: function(t, e) {
                    e(t);
                },
                onRemoveGroup: function(t, e) {
                    e(t);
                },
                margin: {
                    item: {
                        horizontal: 10,
                        vertical: 10
                    },
                    axis: 20
                },
                showTooltips: !0,
                tooltip: {
                    followMouse: !1,
                    overflowMethod: "flip",
                    delay: 500
                },
                tooltipOnItemUpdateTime: !1
            }, o.options = l_.extend({}, o.defaultOptions), o.options.rtl = n.rtl, o.options.onTimeout = n.onTimeout, o.conversion = {
                toScreen: t.util.toScreen,
                toTime: t.util.toTime
            }, o.dom = {}, o.props = {}, o.hammer = null;
            var r = fc(o);
            return o.itemsData = null, o.groupsData = null, o.itemsSettingTime = null, o.initialItemSetDrawn = !1, o.userContinueNotBail = null, o.sequentialSelection = !1, o.itemListeners = {
                add: function(t, e, i1) {
                    r._onAdd(e.items), r.options.cluster && r.clusterGenerator.setItems(r.items, {
                        applyOnChangedLevel: !1
                    }), r.redraw();
                },
                update: function(t, e, i1) {
                    r._onUpdate(e.items), r.options.cluster && r.clusterGenerator.setItems(r.items, {
                        applyOnChangedLevel: !1
                    }), r.redraw();
                },
                remove: function(t, e, i1) {
                    r._onRemove(e.items), r.options.cluster && r.clusterGenerator.setItems(r.items, {
                        applyOnChangedLevel: !1
                    }), r.redraw();
                }
            }, o.groupListeners = {
                add: function(t, e, i1) {
                    if (r._onAddGroups(e.items), r.groupsData && r.groupsData.length > 0) {
                        var n, o = r.groupsData.getDataSet();
                        bd(n = o.get()).call(n, function(t) {
                            if (t.nestedGroups) {
                                var e;
                                0 != t.showNested && (t.showNested = !0);
                                var n = [];
                                bd(e = t.nestedGroups).call(e, function(e) {
                                    var i1 = o.get(e);
                                    i1 && (i1.nestedInGroup = t.id, 0 == t.showNested && (i1.visible = !1), n = mf(n).call(n, i1));
                                }), o.update(n, i1);
                            }
                        });
                    }
                },
                update: function(t, e, i1) {
                    r._onUpdateGroups(e.items);
                },
                remove: function(t, e, i1) {
                    r._onRemoveGroups(e.items);
                }
            }, o.items = {}, o.groups = {}, o.groupIds = [], o.selection = [], o.popup = null, o.popupTimer = null, o.touchParams = {}, o.groupTouchParams = {
                group: null,
                isDragging: !1
            }, o._create(), o.setOptions(n), o.clusters = [], o;
        }
        return mc(i1, [
            {
                key: "_create",
                value: function() {
                    var t, e, i1, n, o, r, s, a, l, h, u, c, d, p, m, f = this, v = document.createElement("div");
                    v.className = "vis-itemset", v["vis-itemset"] = this, this.dom.frame = v;
                    var g = document.createElement("div");
                    g.className = "vis-background", v.appendChild(g), this.dom.background = g;
                    var y = document.createElement("div");
                    y.className = "vis-foreground", v.appendChild(y), this.dom.foreground = y;
                    var b = document.createElement("div");
                    b.className = "vis-axis", this.dom.axis = b;
                    var w = document.createElement("div");
                    w.className = "vis-labelset", this.dom.labelSet = w, this._updateUngrouped();
                    var k = new xD(eT, null, this);
                    k.show(), this.groups[eT] = k, this.hammer = new Gx(this.body.dom.centerContainer), this.hammer.on("hammer.input", function(t) {
                        t.isFirst && f._onTouch(t);
                    }), this.hammer.on("panstart", Hc(t = this._onDragStart).call(t, this)), this.hammer.on("panmove", Hc(e = this._onDrag).call(e, this)), this.hammer.on("panend", Hc(i1 = this._onDragEnd).call(i1, this)), this.hammer.get("pan").set({
                        threshold: 5,
                        direction: Gx.ALL
                    }), this.hammer.get("press").set({
                        time: 1e4
                    }), this.hammer.on("tap", Hc(n = this._onSelectItem).call(n, this)), this.hammer.on("press", Hc(o = this._onMultiSelectItem).call(o, this)), this.hammer.get("press").set({
                        time: 1e4
                    }), this.hammer.on("doubletap", Hc(r = this._onAddItem).call(r, this)), this.options.rtl ? this.groupHammer = new Gx(this.body.dom.rightContainer) : this.groupHammer = new Gx(this.body.dom.leftContainer), this.groupHammer.on("tap", Hc(s = this._onGroupClick).call(s, this)), this.groupHammer.on("panstart", Hc(a = this._onGroupDragStart).call(a, this)), this.groupHammer.on("panmove", Hc(l = this._onGroupDrag).call(l, this)), this.groupHammer.on("panend", Hc(h = this._onGroupDragEnd).call(h, this)), this.groupHammer.get("pan").set({
                        threshold: 5,
                        direction: Gx.DIRECTION_VERTICAL
                    }), this.body.dom.centerContainer.addEventListener("mouseover", Hc(u = this._onMouseOver).call(u, this)), this.body.dom.centerContainer.addEventListener("mouseout", Hc(c = this._onMouseOut).call(c, this)), this.body.dom.centerContainer.addEventListener("mousemove", Hc(d = this._onMouseMove).call(d, this)), this.body.dom.centerContainer.addEventListener("contextmenu", Hc(p = this._onDragEnd).call(p, this)), this.body.dom.centerContainer.addEventListener("mousewheel", Hc(m = this._onMouseWheel).call(m, this)), this.show();
                }
            },
            {
                key: "setOptions",
                value: function(t) {
                    var e = this;
                    if (t) {
                        var i1, n;
                        l_.selectiveExtend([
                            "type",
                            "rtl",
                            "align",
                            "order",
                            "stack",
                            "stackSubgroups",
                            "selectable",
                            "multiselect",
                            "sequentialSelection",
                            "multiselectPerGroup",
                            "longSelectPressTime",
                            "groupOrder",
                            "dataAttributes",
                            "template",
                            "groupTemplate",
                            "visibleFrameTemplate",
                            "hide",
                            "snap",
                            "groupOrderSwap",
                            "showTooltips",
                            "tooltip",
                            "tooltipOnItemUpdateTime",
                            "groupHeightMode",
                            "onTimeout"
                        ], this.options, t), "itemsAlwaysDraggable" in t && ("boolean" == typeof t.itemsAlwaysDraggable ? (this.options.itemsAlwaysDraggable.item = t.itemsAlwaysDraggable, this.options.itemsAlwaysDraggable.range = !1) : "object" === uc(t.itemsAlwaysDraggable) && (l_.selectiveExtend([
                            "item",
                            "range"
                        ], this.options.itemsAlwaysDraggable, t.itemsAlwaysDraggable), this.options.itemsAlwaysDraggable.item || (this.options.itemsAlwaysDraggable.range = !1))), "sequentialSelection" in t && "boolean" == typeof t.sequentialSelection && (this.options.sequentialSelection = t.sequentialSelection), "orientation" in t && ("string" == typeof t.orientation ? this.options.orientation.item = "top" === t.orientation ? "top" : "bottom" : "object" === uc(t.orientation) && "item" in t.orientation && (this.options.orientation.item = t.orientation.item)), "margin" in t && ("number" == typeof t.margin ? (this.options.margin.axis = t.margin, this.options.margin.item.horizontal = t.margin, this.options.margin.item.vertical = t.margin) : "object" === uc(t.margin) && (l_.selectiveExtend([
                            "axis"
                        ], this.options.margin, t.margin), "item" in t.margin && ("number" == typeof t.margin.item ? (this.options.margin.item.horizontal = t.margin.item, this.options.margin.item.vertical = t.margin.item) : "object" === uc(t.margin.item) && l_.selectiveExtend([
                            "horizontal",
                            "vertical"
                        ], this.options.margin.item, t.margin.item)))), bd(i1 = [
                            "locale",
                            "locales"
                        ]).call(i1, function(i1) {
                            i1 in t && (e.options[i1] = t[i1]);
                        }), "editable" in t && ("boolean" == typeof t.editable ? (this.options.editable.updateTime = t.editable, this.options.editable.updateGroup = t.editable, this.options.editable.add = t.editable, this.options.editable.remove = t.editable, this.options.editable.overrideItems = !1) : "object" === uc(t.editable) && l_.selectiveExtend([
                            "updateTime",
                            "updateGroup",
                            "add",
                            "remove",
                            "overrideItems"
                        ], this.options.editable, t.editable)), "groupEditable" in t && ("boolean" == typeof t.groupEditable ? (this.options.groupEditable.order = t.groupEditable, this.options.groupEditable.add = t.groupEditable, this.options.groupEditable.remove = t.groupEditable) : "object" === uc(t.groupEditable) && l_.selectiveExtend([
                            "order",
                            "add",
                            "remove"
                        ], this.options.groupEditable, t.groupEditable));
                        bd(n = [
                            "onDropObjectOnItem",
                            "onAdd",
                            "onUpdate",
                            "onRemove",
                            "onMove",
                            "onMoving",
                            "onAddGroup",
                            "onMoveGroup",
                            "onRemoveGroup"
                        ]).call(n, function(i1) {
                            var n = t[i1];
                            if (n) {
                                var o;
                                if ("function" != typeof n) throw new Error(mf(o = "option ".concat(i1, " must be a function ")).call(o, i1, "(item, callback)"));
                                e.options[i1] = n;
                            }
                        }), t.cluster ? (pv(this.options, {
                            cluster: t.cluster
                        }), this.clusterGenerator || (this.clusterGenerator = new $D(this)), this.clusterGenerator.setItems(this.items, {
                            applyOnChangedLevel: !1
                        }), this.markDirty({
                            refreshItems: !0,
                            restackGroups: !0
                        }), this.redraw()) : this.clusterGenerator ? (this._detachAllClusters(), this.clusters = [], this.clusterGenerator = null, this.options.cluster = void 0, this.markDirty({
                            refreshItems: !0,
                            restackGroups: !0
                        }), this.redraw()) : this.markDirty();
                    }
                }
            },
            {
                key: "markDirty",
                value: function(t) {
                    this.groupIds = [], t && (t.refreshItems && bd(l_).call(l_, this.items, function(t) {
                        t.dirty = !0, t.displayed && t.redraw();
                    }), t.restackGroups && bd(l_).call(l_, this.groups, function(t, e) {
                        e !== eT && (t.stackDirty = !0);
                    }));
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.clearPopupTimer(), this.hide(), this.setItems(null), this.setGroups(null), this.hammer && this.hammer.destroy(), this.groupHammer && this.groupHammer.destroy(), this.hammer = null, this.body = null, this.conversion = null;
                }
            },
            {
                key: "hide",
                value: function() {
                    this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame), this.dom.axis.parentNode && this.dom.axis.parentNode.removeChild(this.dom.axis), this.dom.labelSet.parentNode && this.dom.labelSet.parentNode.removeChild(this.dom.labelSet);
                }
            },
            {
                key: "show",
                value: function() {
                    this.dom.frame.parentNode || this.body.dom.center.appendChild(this.dom.frame), this.dom.axis.parentNode || this.body.dom.backgroundVertical.appendChild(this.dom.axis), this.dom.labelSet.parentNode || (this.options.rtl ? this.body.dom.right.appendChild(this.dom.labelSet) : this.body.dom.left.appendChild(this.dom.labelSet));
                }
            },
            {
                key: "setPopupTimer",
                value: function(t) {
                    if (this.clearPopupTimer(), t) {
                        var e = this.options.tooltip.delay || "number" == typeof this.options.tooltip.delay ? this.options.tooltip.delay : 500;
                        this.popupTimer = sd(function() {
                            t.show();
                        }, e);
                    }
                }
            },
            {
                key: "clearPopupTimer",
                value: function() {
                    null != this.popupTimer && (clearTimeout(this.popupTimer), this.popupTimer = null);
                }
            },
            {
                key: "setSelection",
                value: function(t) {
                    var e;
                    null == t && (t = []), zc(t) || (t = [
                        t
                    ]);
                    var i1, n = Ed(e = this.selection).call(e, function(e) {
                        return -1 === Eg(t).call(t, e);
                    }), o = ZD(n);
                    try {
                        for(o.s(); !(i1 = o.n()).done;){
                            var r = i1.value, s = this.getItemById(r);
                            s && s.unselect();
                        }
                    } catch (t) {
                        o.e(t);
                    } finally{
                        o.f();
                    }
                    this.selection = af(t);
                    var a, l = ZD(t);
                    try {
                        for(l.s(); !(a = l.n()).done;){
                            var h = a.value, u = this.getItemById(h);
                            u && u.select();
                        }
                    } catch (t) {
                        l.e(t);
                    } finally{
                        l.f();
                    }
                }
            },
            {
                key: "getSelection",
                value: function() {
                    var t;
                    return mf(t = this.selection).call(t, []);
                }
            },
            {
                key: "getVisibleItems",
                value: function() {
                    var t, e, i1 = this.body.range.getRange();
                    this.options.rtl ? (t = this.body.util.toScreen(i1.start), e = this.body.util.toScreen(i1.end)) : (e = this.body.util.toScreen(i1.start), t = this.body.util.toScreen(i1.end));
                    var n = [];
                    for(var o in this.groups)if (this.groups.hasOwnProperty(o)) {
                        var r, s = this.groups[o], a = ZD(s.isVisible ? s.visibleItems : []);
                        try {
                            for(a.s(); !(r = a.n()).done;){
                                var l = r.value;
                                this.options.rtl ? l.right < e && l.right + l.width > t && n.push(l.id) : l.left < t && l.left + l.width > e && n.push(l.id);
                            }
                        } catch (t) {
                            a.e(t);
                        } finally{
                            a.f();
                        }
                    }
                    return n;
                }
            },
            {
                key: "getItemsAtCurrentTime",
                value: function(t) {
                    var e, i1;
                    this.options.rtl ? (e = this.body.util.toScreen(t), i1 = this.body.util.toScreen(t)) : (i1 = this.body.util.toScreen(t), e = this.body.util.toScreen(t));
                    var n = [];
                    for(var o in this.groups)if (this.groups.hasOwnProperty(o)) {
                        var r, s = this.groups[o], a = ZD(s.isVisible ? s.visibleItems : []);
                        try {
                            for(a.s(); !(r = a.n()).done;){
                                var l = r.value;
                                this.options.rtl ? l.right < i1 && l.right + l.width > e && n.push(l.id) : l.left < e && l.left + l.width > i1 && n.push(l.id);
                            }
                        } catch (t) {
                            a.e(t);
                        } finally{
                            a.f();
                        }
                    }
                    return n;
                }
            },
            {
                key: "getVisibleGroups",
                value: function() {
                    var t = [];
                    for(var e in this.groups)if (this.groups.hasOwnProperty(e)) this.groups[e].isVisible && t.push(e);
                    return t;
                }
            },
            {
                key: "getItemById",
                value: function(t) {
                    var e;
                    return this.items[t] || CC(e = this.clusters).call(e, function(e) {
                        return e.id === t;
                    });
                }
            },
            {
                key: "_deselect",
                value: function(t) {
                    for(var e = this.selection, i1 = 0, n = e.length; i1 < n; i1++)if (e[i1] == t) {
                        Qf(e).call(e, i1, 1);
                        break;
                    }
                }
            },
            {
                key: "redraw",
                value: function() {
                    var t = this.options.margin, e = this.body.range, i1 = l_.option.asSize, n = this.options, o = n.orientation.item, r = !1, s = this.dom.frame;
                    this.props.top = this.body.domProps.top.height + this.body.domProps.border.top, this.options.rtl ? this.props.right = this.body.domProps.right.width + this.body.domProps.border.right : this.props.left = this.body.domProps.left.width + this.body.domProps.border.left, s.className = "vis-itemset", this.options.cluster && this._clusterItems(), r = this._orderGroups() || r;
                    var a = e.end - e.start, l = a != this.lastVisibleInterval || this.props.width != this.props.lastWidth, h = e.start != this.lastRangeStart, u = n.stack != this.lastStack, c = n.stackSubgroups != this.lastStackSubgroups, d = l || h || u || c;
                    this.lastVisibleInterval = a, this.lastRangeStart = e.start, this.lastStack = n.stack, this.lastStackSubgroups = n.stackSubgroups, this.props.lastWidth = this.props.width;
                    var p = this._firstGroup(), m = {
                        item: t.item,
                        axis: t.axis
                    }, f = {
                        item: t.item,
                        axis: t.item.vertical / 2
                    }, v = 0, g = t.axis + t.item.vertical;
                    this.groups[eT].redraw(e, f, d);
                    var y = {}, b = 0;
                    if (bd(l_).call(l_, this.groups, function(t, i1) {
                        if (i1 !== eT) {
                            var n = t == p ? m : f;
                            y[i1] = t.redraw(e, n, d, !0), b = y[i1].length;
                        }
                    }), b > 0) {
                        for(var w = {}, k = function(t) {
                            bd(l_).call(l_, y, function(e, i1) {
                                w[i1] = e[t]();
                            });
                        }, _ = 0; _ < b; _++)k(_);
                        bd(l_).call(l_, this.groups, function(t, e) {
                            if (e !== eT) {
                                var i1 = w[e];
                                r = i1 || r, v += t.height;
                            }
                        }), v = Math.max(v, g);
                    }
                    return v = Math.max(v, g), s.style.height = i1(v), this.props.width = s.offsetWidth, this.props.height = v, this.dom.axis.style.top = i1("top" == o ? this.body.domProps.top.height + this.body.domProps.border.top : this.body.domProps.top.height + this.body.domProps.centerContainer.height), this.options.rtl ? this.dom.axis.style.right = "0" : this.dom.axis.style.left = "0", this.hammer.get("press").set({
                        time: this.options.longSelectPressTime
                    }), this.initialItemSetDrawn = !0, r = this._isResized() || r;
                }
            },
            {
                key: "_firstGroup",
                value: function() {
                    var t = "top" == this.options.orientation.item ? 0 : this.groupIds.length - 1, e = this.groupIds[t];
                    return this.groups[e] || this.groups[tT] || null;
                }
            },
            {
                key: "_updateUngrouped",
                value: function() {
                    var t, e, i1 = this.groups[tT];
                    if (this.groupsData) {
                        if (i1) {
                            for(e in i1.dispose(), delete this.groups[tT], this.items)if (this.items.hasOwnProperty(e)) {
                                (t = this.items[e]).parent && t.parent.remove(t);
                                var n = this.getGroupId(t.data), o = this.groups[n];
                                o && o.add(t) || t.hide();
                            }
                        }
                    } else if (!i1) {
                        for(e in i1 = new kD(null, null, this), this.groups[tT] = i1, this.items)this.items.hasOwnProperty(e) && (t = this.items[e], i1.add(t));
                        i1.show();
                    }
                }
            },
            {
                key: "getLabelSet",
                value: function() {
                    return this.dom.labelSet;
                }
            },
            {
                key: "setItems",
                value: function(t) {
                    this.itemsSettingTime = new Date;
                    var e, i1 = this, n = this.itemsData;
                    if (t) {
                        if (!t_(t)) throw new TypeError("Data must implement the interface of DataSet or DataView");
                        this.itemsData = o_(t);
                    } else this.itemsData = null;
                    if (n && (bd(l_).call(l_, this.itemListeners, function(t, e) {
                        n.off(e, t);
                    }), n.dispose(), e = n.getIds(), this._onRemove(e)), this.itemsData) {
                        var o = this.id;
                        bd(l_).call(l_, this.itemListeners, function(t, e) {
                            i1.itemsData.on(e, t, o);
                        }), e = this.itemsData.getIds(), this._onAdd(e), this._updateUngrouped();
                    }
                    this.body.emitter.emit("_change", {
                        queue: !0
                    });
                }
            },
            {
                key: "getItems",
                value: function() {
                    return null != this.itemsData ? this.itemsData.rawDS : null;
                }
            },
            {
                key: "setGroups",
                value: function(t) {
                    var e, i1 = this;
                    if (this.groupsData && (bd(l_).call(l_, this.groupListeners, function(t, e) {
                        i1.groupsData.off(e, t);
                    }), e = this.groupsData.getIds(), this.groupsData = null, this._onRemoveGroups(e)), t) {
                        if (!t_(t)) throw new TypeError("Data must implement the interface of DataSet or DataView");
                        this.groupsData = t;
                    } else this.groupsData = null;
                    if (this.groupsData) {
                        var n, o = this.groupsData.getDataSet();
                        bd(n = o.get()).call(n, function(t) {
                            var e;
                            t.nestedGroups && bd(e = t.nestedGroups).call(e, function(e) {
                                var i1 = o.get(e);
                                i1.nestedInGroup = t.id, 0 == t.showNested && (i1.visible = !1), o.update(i1);
                            });
                        });
                        var r = this.id;
                        bd(l_).call(l_, this.groupListeners, function(t, e) {
                            i1.groupsData.on(e, t, r);
                        }), e = this.groupsData.getIds(), this._onAddGroups(e);
                    }
                    this._updateUngrouped(), this._order(), this.options.cluster && (this.clusterGenerator.updateData(), this._clusterItems(), this.markDirty({
                        refreshItems: !0,
                        restackGroups: !0
                    })), this.body.emitter.emit("_change", {
                        queue: !0
                    });
                }
            },
            {
                key: "getGroups",
                value: function() {
                    return this.groupsData;
                }
            },
            {
                key: "removeItem",
                value: function(t) {
                    var e = this, i1 = this.itemsData.get(t);
                    i1 && this.options.onRemove(i1, function(i1) {
                        i1 && e.itemsData.remove(t);
                    });
                }
            },
            {
                key: "_getType",
                value: function(t) {
                    return t.type || this.options.type || (t.end ? "range" : "box");
                }
            },
            {
                key: "getGroupId",
                value: function(t) {
                    return "background" == this._getType(t) && null == t.group ? eT : this.groupsData ? t.group : tT;
                }
            },
            {
                key: "_onUpdate",
                value: function(t) {
                    var e = this, n = this;
                    bd(t).call(t, function(t) {
                        var o, r = n.itemsData.get(t), s = n.items[t], a = r ? n._getType(r) : null, l = i1.types[a];
                        if (s && (l && s instanceof l ? n._updateItem(s, r) : (o = s.selected, n._removeItem(s), s = null)), !s && r) {
                            if (!l) throw new TypeError('Unknown item type "'.concat(a, '"'));
                            (s = new l(r, n.conversion, n.options)).id = t, n._addItem(s), o && (e.selection.push(t), s.select());
                        }
                    }), this._order(), this.options.cluster && (this.clusterGenerator.setItems(this.items, {
                        applyOnChangedLevel: !1
                    }), this._clusterItems()), this.body.emitter.emit("_change", {
                        queue: !0
                    });
                }
            },
            {
                key: "_onRemove",
                value: function(t) {
                    var e = 0, i1 = this;
                    bd(t).call(t, function(t) {
                        var n = i1.items[t];
                        n && (e++, i1._removeItem(n));
                    }), e && (this._order(), this.body.emitter.emit("_change", {
                        queue: !0
                    }));
                }
            },
            {
                key: "_order",
                value: function() {
                    bd(l_).call(l_, this.groups, function(t) {
                        t.order();
                    });
                }
            },
            {
                key: "_onUpdateGroups",
                value: function(t) {
                    this._onAddGroups(t);
                }
            },
            {
                key: "_onAddGroups",
                value: function(t) {
                    var e = this;
                    bd(t).call(t, function(t) {
                        var i1 = e.groupsData.get(t), n = e.groups[t];
                        if (n) n.setData(i1);
                        else {
                            if (t == tT || t == eT) throw new Error("Illegal group id. ".concat(t, " is a reserved id."));
                            var o = Ig(e.options);
                            for(var r in l_.extend(o, {
                                height: null
                            }), n = new kD(t, i1, e), e.groups[t] = n, e.items)if (e.items.hasOwnProperty(r)) {
                                var s = e.items[r];
                                s.data.group == t && n.add(s);
                            }
                            n.order(), n.show();
                        }
                    }), this.body.emitter.emit("_change", {
                        queue: !0
                    });
                }
            },
            {
                key: "_onRemoveGroups",
                value: function(t) {
                    var e = this;
                    bd(t).call(t, function(t) {
                        var i1 = e.groups[t];
                        i1 && (i1.dispose(), delete e.groups[t]);
                    }), this.options.cluster && (this.clusterGenerator.updateData(), this._clusterItems()), this.markDirty({
                        restackGroups: !!this.options.cluster
                    }), this.body.emitter.emit("_change", {
                        queue: !0
                    });
                }
            },
            {
                key: "_orderGroups",
                value: function() {
                    if (this.groupsData) {
                        var t = this.groupsData.getIds({
                            order: this.options.groupOrder
                        });
                        t = this._orderNestedGroups(t);
                        var e = !l_.equalArray(t, this.groupIds);
                        if (e) {
                            var i1 = this.groups;
                            bd(t).call(t, function(t) {
                                i1[t].hide();
                            }), bd(t).call(t, function(t) {
                                i1[t].show();
                            }), this.groupIds = t;
                        }
                        return e;
                    }
                    return !1;
                }
            },
            {
                key: "_orderNestedGroups",
                value: function(t) {
                    var e = this;
                    return function t(e, i1) {
                        var n = [];
                        return bd(i1).call(i1, function(i1) {
                            if (n.push(i1), e.groupsData.get(i1).nestedGroups) {
                                var o, r = lp(o = e.groupsData.get({
                                    filter: function(t) {
                                        return t.nestedInGroup == i1;
                                    },
                                    order: e.options.groupOrder
                                })).call(o, function(_t1) {
                                    return _t1.id;
                                });
                                n = mf(n).call(n, t(e, r));
                            }
                        }), n;
                    }(this, Ed(t).call(t, function(t) {
                        return !e.groupsData.get(t).nestedInGroup;
                    }));
                }
            },
            {
                key: "_addItem",
                value: function(t) {
                    this.items[t.id] = t;
                    var e = this.getGroupId(t.data), i1 = this.groups[e];
                    i1 ? i1 && i1.data && i1.data.showNested && (t.groupShowing = !0) : t.groupShowing = !1, i1 && i1.add(t);
                }
            },
            {
                key: "_updateItem",
                value: function(t, e) {
                    t.setData(e);
                    var i1 = this.getGroupId(t.data), n = this.groups[i1];
                    n ? n && n.data && n.data.showNested && (t.groupShowing = !0) : t.groupShowing = !1;
                }
            },
            {
                key: "_removeItem",
                value: function(t) {
                    var e, i1;
                    t.hide(), delete this.items[t.id];
                    var n = Eg(e = this.selection).call(e, t.id);
                    -1 != n && Qf(i1 = this.selection).call(i1, n, 1), t.parent && t.parent.remove(t), null != this.popup && this.popup.hide();
                }
            },
            {
                key: "_constructByEndArray",
                value: function(t) {
                    for(var e = [], i1 = 0; i1 < t.length; i1++)t[i1] instanceof PD && e.push(t[i1]);
                    return e;
                }
            },
            {
                key: "_onTouch",
                value: function(t) {
                    this.touchParams.item = this.itemFromTarget(t), this.touchParams.dragLeftItem = t.target.dragLeftItem || !1, this.touchParams.dragRightItem = t.target.dragRightItem || !1, this.touchParams.itemProps = null;
                }
            },
            {
                key: "_getGroupIndex",
                value: function(t) {
                    for(var e = 0; e < this.groupIds.length; e++)if (t == this.groupIds[e]) return e;
                }
            },
            {
                key: "_onDragStart",
                value: function(t) {
                    var e = this;
                    if (!this.touchParams.itemIsDragging) {
                        var i1, n = this.touchParams.item || null, o = this;
                        if (n && (n.selected || this.options.itemsAlwaysDraggable.item)) {
                            if (this.options.editable.overrideItems && !this.options.editable.updateTime && !this.options.editable.updateGroup) return;
                            if (null != n.editable && !n.editable.updateTime && !n.editable.updateGroup && !this.options.editable.overrideItems) return;
                            var r = this.touchParams.dragLeftItem, s = this.touchParams.dragRightItem;
                            if (this.touchParams.itemIsDragging = !0, this.touchParams.selectedItem = n, r) i1 = {
                                item: r,
                                initialX: t.center.x,
                                dragLeft: !0,
                                data: this._cloneItemData(n.data)
                            }, this.touchParams.itemProps = [
                                i1
                            ];
                            else if (s) i1 = {
                                item: s,
                                initialX: t.center.x,
                                dragRight: !0,
                                data: this._cloneItemData(n.data)
                            }, this.touchParams.itemProps = [
                                i1
                            ];
                            else if (this.options.editable.add && (t.srcEvent.ctrlKey || t.srcEvent.metaKey)) this._onDragStartAddItem(t);
                            else {
                                this.groupIds.length < 1 && this.redraw();
                                var a = this._getGroupIndex(n.data.group), l = this.options.itemsAlwaysDraggable.item && !n.selected ? [
                                    n.id
                                ] : this.getSelection();
                                this.touchParams.itemProps = lp(l).call(l, function(i1) {
                                    var n = o.items[i1], r = o._getGroupIndex(n.data.group);
                                    return {
                                        item: n,
                                        initialX: t.center.x,
                                        groupOffset: a - r,
                                        data: e._cloneItemData(n.data)
                                    };
                                });
                            }
                            t.stopPropagation();
                        } else this.options.editable.add && (t.srcEvent.ctrlKey || t.srcEvent.metaKey) && this._onDragStartAddItem(t);
                    }
                }
            },
            {
                key: "_onDragStartAddItem",
                value: function(t) {
                    var e = this.options.snap || null, i1 = this.dom.frame.getBoundingClientRect(), n = this.options.rtl ? i1.right - t.center.x + 10 : t.center.x - i1.left - 10, o = this.body.util.toTime(n), r = this.body.util.getScale(), s = this.body.util.getStep(), a = e ? e(o, r, s) : o, l = {
                        type: "range",
                        start: a,
                        end: a,
                        content: "new item"
                    }, h = Zk();
                    l[this.itemsData.idProp] = h;
                    var u = this.groupFromTarget(t);
                    u && (l.group = u.groupId);
                    var c = new PD(l, this.conversion, this.options);
                    c.id = h, c.data = this._cloneItemData(l), this._addItem(c), this.touchParams.selectedItem = c;
                    var d = {
                        item: c,
                        initialX: t.center.x,
                        data: c.data
                    };
                    this.options.rtl ? d.dragLeft = !0 : d.dragRight = !0, this.touchParams.itemProps = [
                        d
                    ], t.stopPropagation();
                }
            },
            {
                key: "_onDrag",
                value: function(t) {
                    var e = this;
                    if (null != this.popup && this.options.showTooltips && !this.popup.hidden) {
                        var i1 = this.body.dom.centerContainer, n = i1.getBoundingClientRect();
                        this.popup.setPosition(t.center.x - n.left + i1.offsetLeft, t.center.y - n.top + i1.offsetTop), this.popup.show();
                    }
                    if (this.touchParams.itemProps) {
                        var o;
                        t.stopPropagation();
                        var r = this, s = this.options.snap || null, a = this.body.dom.root.offsetLeft, l = this.options.rtl ? a + this.body.domProps.right.width : a + this.body.domProps.left.width, h = this.body.util.getScale(), u = this.body.util.getStep(), c = this.touchParams.selectedItem, d = (this.options.editable.overrideItems || null == c.editable) && this.options.editable.updateGroup || !this.options.editable.overrideItems && null != c.editable && c.editable.updateGroup, p = null;
                        if (d && c && null != c.data.group) {
                            var m = r.groupFromTarget(t);
                            m && (p = this._getGroupIndex(m.groupId));
                        }
                        bd(o = this.touchParams.itemProps).call(o, function(i1) {
                            var n, o, a, m, f, v = r.body.util.toTime(t.center.x - l), g = r.body.util.toTime(i1.initialX - l);
                            n = e.options.rtl ? -(v - g) : v - g;
                            var y = e._cloneItemData(i1.item.data);
                            if (null == i1.item.editable || i1.item.editable.updateTime || i1.item.editable.updateGroup || r.options.editable.overrideItems) {
                                if ((e.options.editable.overrideItems || null == c.editable) && e.options.editable.updateTime || !e.options.editable.overrideItems && null != c.editable && c.editable.updateTime) {
                                    if (i1.dragLeft) e.options.rtl ? null != y.end && (a = l_.convert(i1.data.end, "Date"), f = new Date(a.valueOf() + n), y.end = s ? s(f, h, u) : f) : null != y.start && (o = l_.convert(i1.data.start, "Date"), m = new Date(o.valueOf() + n), y.start = s ? s(m, h, u) : m);
                                    else if (i1.dragRight) e.options.rtl ? null != y.start && (o = l_.convert(i1.data.start, "Date"), m = new Date(o.valueOf() + n), y.start = s ? s(m, h, u) : m) : null != y.end && (a = l_.convert(i1.data.end, "Date"), f = new Date(a.valueOf() + n), y.end = s ? s(f, h, u) : f);
                                    else if (null != y.start) {
                                        if (o = l_.convert(i1.data.start, "Date").valueOf(), m = new Date(o + n), null != y.end) {
                                            var b = (a = l_.convert(i1.data.end, "Date")).valueOf() - o.valueOf();
                                            y.start = s ? s(m, h, u) : m, y.end = new Date(y.start.valueOf() + b);
                                        } else y.start = s ? s(m, h, u) : m;
                                    }
                                }
                                if (d && !i1.dragLeft && !i1.dragRight && null != p && null != y.group) {
                                    var w = p - i1.groupOffset;
                                    w = Math.max(0, w), w = Math.min(r.groupIds.length - 1, w), y.group = r.groupIds[w];
                                }
                                y = e._cloneItemData(y), r.options.onMoving(y, function(t) {
                                    t && i1.item.setData(e._cloneItemData(t, "Date"));
                                });
                            }
                        }), this.body.emitter.emit("_change");
                    }
                }
            },
            {
                key: "_moveToGroup",
                value: function(t, e) {
                    var i1 = this.groups[e];
                    if (i1 && i1.groupId != t.data.group) {
                        var n = t.parent;
                        n.remove(t), n.order(), t.data.group = i1.groupId, i1.add(t), i1.order();
                    }
                }
            },
            {
                key: "_onDragEnd",
                value: function(t) {
                    var e = this;
                    if (this.touchParams.itemIsDragging = !1, this.touchParams.itemProps) {
                        t.stopPropagation();
                        var i1 = this, n = this.touchParams.itemProps;
                        this.touchParams.itemProps = null, bd(n).call(n, function(t) {
                            var n = t.item.id;
                            if (null != i1.itemsData.get(n)) {
                                var o = e._cloneItemData(t.item.data);
                                i1.options.onMove(o, function(o) {
                                    o ? (o[e.itemsData.idProp] = n, e.itemsData.update(o)) : (t.item.setData(t.data), i1.body.emitter.emit("_change"));
                                });
                            } else i1.options.onAdd(t.item.data, function(e) {
                                i1._removeItem(t.item), e && i1.itemsData.add(e), i1.body.emitter.emit("_change");
                            });
                        });
                    }
                }
            },
            {
                key: "_onGroupClick",
                value: function(t) {
                    var e = this, i1 = this.groupFromTarget(t);
                    sd(function() {
                        e.toggleGroupShowNested(i1);
                    }, 1);
                }
            },
            {
                key: "toggleGroupShowNested",
                value: function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    if (t && t.nestedGroups) {
                        var i1 = this.groupsData.getDataSet();
                        t.showNested = null != e ? !!e : !t.showNested;
                        var n = i1.get(t.groupId);
                        n.showNested = t.showNested;
                        for(var o, r = t.nestedGroups, s = r; s.length > 0;){
                            var a = s;
                            s = [];
                            for(var l = 0; l < a.length; l++){
                                var h = i1.get(a[l]);
                                h.nestedGroups && (s = mf(s).call(s, h.nestedGroups));
                            }
                            s.length > 0 && (r = mf(r).call(r, s));
                        }
                        if (n.showNested) {
                            for(var u = i1.get(n.nestedGroups), c = 0; c < u.length; c++){
                                var d = u[c];
                                d.nestedGroups && d.nestedGroups.length > 0 && (null == d.showNested || 1 == d.showNested) && u.push.apply(u, af(i1.get(d.nestedGroups)));
                            }
                            o = lp(u).call(u, function(t) {
                                return null == t.visible && (t.visible = !0), t.visible = !!n.showNested, t;
                            });
                        } else {
                            var p;
                            o = lp(p = i1.get(r)).call(p, function(t) {
                                return null == t.visible && (t.visible = !0), t.visible = !!n.showNested, t;
                            });
                        }
                        i1.update(mf(o).call(o, n)), n.showNested ? (l_.removeClassName(t.dom.label, "collapsed"), l_.addClassName(t.dom.label, "expanded")) : (l_.removeClassName(t.dom.label, "expanded"), l_.addClassName(t.dom.label, "collapsed"));
                    }
                }
            },
            {
                key: "toggleGroupDragClassName",
                value: function(t) {
                    t.dom.label.classList.toggle("vis-group-is-dragging"), t.dom.foreground.classList.toggle("vis-group-is-dragging");
                }
            },
            {
                key: "_onGroupDragStart",
                value: function(t) {
                    this.groupTouchParams.isDragging || this.options.groupEditable.order && (this.groupTouchParams.group = this.groupFromTarget(t), this.groupTouchParams.group && (t.stopPropagation(), this.groupTouchParams.isDragging = !0, this.toggleGroupDragClassName(this.groupTouchParams.group), this.groupTouchParams.originalOrder = this.groupsData.getIds({
                        order: this.options.groupOrder
                    })));
                }
            },
            {
                key: "_onGroupDrag",
                value: function(t) {
                    if (this.options.groupEditable.order && this.groupTouchParams.group) {
                        t.stopPropagation();
                        var e = this.groupsData.getDataSet(), i1 = this.groupFromTarget(t);
                        if (i1 && i1.height != this.groupTouchParams.group.height) {
                            var n = i1.top < this.groupTouchParams.group.top, o = t.center ? t.center.y : t.clientY, r = i1.dom.foreground.getBoundingClientRect(), s = this.groupTouchParams.group.height;
                            if (n) {
                                if (r.top + s < o) return;
                            } else {
                                var a = i1.height;
                                if (r.top + a - s > o) return;
                            }
                        }
                        if (i1 && i1 != this.groupTouchParams.group) {
                            var l = e.get(i1.groupId), h = e.get(this.groupTouchParams.group.groupId);
                            h && l && (this.options.groupOrderSwap(h, l, e), e.update(h), e.update(l));
                            var u = e.getIds({
                                order: this.options.groupOrder
                            });
                            if (!l_.equalArray(u, this.groupTouchParams.originalOrder)) for(var c = this.groupTouchParams.originalOrder, d = this.groupTouchParams.group.groupId, p = Math.min(c.length, u.length), m = 0, f = 0, v = 0; m < p;){
                                for(; m + f < p && m + v < p && u[m + f] == c[m + v];)m++;
                                if (m + f >= p) break;
                                if (u[m + f] == d) f = 1;
                                else if (c[m + v] == d) v = 1;
                                else {
                                    var g = Eg(u).call(u, c[m + v]), y = e.get(u[m + f]), b = e.get(c[m + v]);
                                    this.options.groupOrderSwap(y, b, e), e.update(y), e.update(b);
                                    var w = u[m + f];
                                    u[m + f] = c[m + v], u[g] = w, m++;
                                }
                            }
                        }
                    }
                }
            },
            {
                key: "_onGroupDragEnd",
                value: function(t) {
                    if (this.groupTouchParams.isDragging = !1, this.options.groupEditable.order && this.groupTouchParams.group) {
                        t.stopPropagation();
                        var e = this, i1 = e.groupTouchParams.group.groupId, n = e.groupsData.getDataSet(), o = l_.extend({}, n.get(i1));
                        e.options.onMoveGroup(o, function(t) {
                            if (t) t[n._idProp] = i1, n.update(t);
                            else {
                                var o = n.getIds({
                                    order: e.options.groupOrder
                                });
                                if (!l_.equalArray(o, e.groupTouchParams.originalOrder)) for(var r = e.groupTouchParams.originalOrder, s = Math.min(r.length, o.length), a = 0; a < s;){
                                    for(; a < s && o[a] == r[a];)a++;
                                    if (a >= s) break;
                                    var l = Eg(o).call(o, r[a]), h = n.get(o[a]), u = n.get(r[a]);
                                    e.options.groupOrderSwap(h, u, n), n.update(h), n.update(u);
                                    var c = o[a];
                                    o[a] = r[a], o[l] = c, a++;
                                }
                            }
                        }), e.body.emitter.emit("groupDragged", {
                            groupId: i1
                        }), this.toggleGroupDragClassName(this.groupTouchParams.group), this.groupTouchParams.group = null;
                    }
                }
            },
            {
                key: "_onSelectItem",
                value: function(t) {
                    if (this.options.selectable) {
                        var e = t.srcEvent && (t.srcEvent.ctrlKey || t.srcEvent.metaKey), i1 = t.srcEvent && t.srcEvent.shiftKey;
                        if (e || i1) this._onMultiSelectItem(t);
                        else {
                            var n = this.getSelection(), o = this.itemFromTarget(t), r = o && o.selectable ? [
                                o.id
                            ] : [];
                            this.setSelection(r);
                            var s = this.getSelection();
                            (s.length > 0 || n.length > 0) && this.body.emitter.emit("select", {
                                items: s,
                                event: t
                            });
                        }
                    }
                }
            },
            {
                key: "_onMouseOver",
                value: function(t) {
                    var e = this.itemFromTarget(t);
                    if (e && e !== this.itemFromRelatedTarget(t)) {
                        var i1 = e.getTitle();
                        if (this.options.showTooltips && i1) {
                            null == this.popup && (this.popup = new FD(this.body.dom.root, this.options.tooltip.overflowMethod || "flip")), this.popup.setText(i1);
                            var n = this.body.dom.centerContainer, o = n.getBoundingClientRect();
                            this.popup.setPosition(t.clientX - o.left + n.offsetLeft, t.clientY - o.top + n.offsetTop), this.setPopupTimer(this.popup);
                        } else this.clearPopupTimer(), null != this.popup && this.popup.hide();
                        this.body.emitter.emit("itemover", {
                            item: e.id,
                            event: t
                        });
                    }
                }
            },
            {
                key: "_onMouseOut",
                value: function(t) {
                    var e = this.itemFromTarget(t);
                    e && e !== this.itemFromRelatedTarget(t) && (this.clearPopupTimer(), null != this.popup && this.popup.hide(), this.body.emitter.emit("itemout", {
                        item: e.id,
                        event: t
                    }));
                }
            },
            {
                key: "_onMouseMove",
                value: function(t) {
                    if (this.itemFromTarget(t) && (null != this.popupTimer && this.setPopupTimer(this.popup), this.options.showTooltips && this.options.tooltip.followMouse && this.popup && !this.popup.hidden)) {
                        var e = this.body.dom.centerContainer, i1 = e.getBoundingClientRect();
                        this.popup.setPosition(t.clientX - i1.left + e.offsetLeft, t.clientY - i1.top + e.offsetTop), this.popup.show();
                    }
                }
            },
            {
                key: "_onMouseWheel",
                value: function(t) {
                    this.touchParams.itemIsDragging && this._onDragEnd(t);
                }
            },
            {
                key: "_onUpdateItem",
                value: function(t) {
                    if (this.options.selectable && (this.options.editable.updateTime || this.options.editable.updateGroup)) {
                        var e = this;
                        if (t) {
                            var i1 = e.itemsData.get(t.id);
                            this.options.onUpdate(i1, function(t) {
                                t && e.itemsData.update(t);
                            });
                        }
                    }
                }
            },
            {
                key: "_onDropObjectOnItem",
                value: function(t) {
                    var e = this.itemFromTarget(t), i1 = JSON.parse(t.dataTransfer.getData("text"));
                    this.options.onDropObjectOnItem(i1, e);
                }
            },
            {
                key: "_onAddItem",
                value: function(t) {
                    if (this.options.selectable && this.options.editable.add) {
                        var e, i1, n = this, o = this.options.snap || null, r = this.dom.frame.getBoundingClientRect(), s = this.options.rtl ? r.right - t.center.x : t.center.x - r.left, a = this.body.util.toTime(s), l = this.body.util.getScale(), h = this.body.util.getStep();
                        "drop" == t.type ? ((i1 = JSON.parse(t.dataTransfer.getData("text"))).content = i1.content ? i1.content : "new item", i1.start = i1.start ? i1.start : o ? o(a, l, h) : a, i1.type = i1.type || "box", i1[this.itemsData.idProp] = i1.id || Zk(), "range" != i1.type || i1.end || (e = this.body.util.toTime(s + this.props.width / 5), i1.end = o ? o(e, l, h) : e)) : ((i1 = {
                            start: o ? o(a, l, h) : a,
                            content: "new item"
                        })[this.itemsData.idProp] = Zk(), "range" === this.options.type && (e = this.body.util.toTime(s + this.props.width / 5), i1.end = o ? o(e, l, h) : e));
                        var u = this.groupFromTarget(t);
                        u && (i1.group = u.groupId), i1 = this._cloneItemData(i1), this.options.onAdd(i1, function(e) {
                            e && (n.itemsData.add(e), "drop" == t.type && n.setSelection([
                                e.id
                            ]));
                        });
                    }
                }
            },
            {
                key: "_onMultiSelectItem",
                value: function(t) {
                    var e = this;
                    if (this.options.selectable) {
                        var n = this.itemFromTarget(t);
                        if (n) {
                            var o = this.options.multiselect ? this.getSelection() : [];
                            if ((t.srcEvent && t.srcEvent.shiftKey || !1 || this.options.sequentialSelection) && this.options.multiselect) {
                                var r = this.itemsData.get(n.id).group, s = void 0;
                                this.options.multiselectPerGroup && o.length > 0 && (s = this.itemsData.get(o[0]).group), this.options.multiselectPerGroup && null != s && s != r || o.push(n.id);
                                var a = i1._getItemRange(this.itemsData.get(o));
                                if (!this.options.multiselectPerGroup || s == r) {
                                    for(var l in o = [], this.items)if (this.items.hasOwnProperty(l)) {
                                        var h = this.items[l], u = h.data.start, c = void 0 !== h.data.end ? h.data.end : u;
                                        !(u >= a.min && c <= a.max) || this.options.multiselectPerGroup && s != this.itemsData.get(h.id).group || h instanceof ND || o.push(h.id);
                                    }
                                }
                            } else {
                                var d = Eg(o).call(o, n.id);
                                -1 == d ? o.push(n.id) : Qf(o).call(o, d, 1);
                            }
                            var p = Ed(o).call(o, function(t) {
                                return e.getItemById(t).selectable;
                            });
                            this.setSelection(p), this.body.emitter.emit("select", {
                                items: this.getSelection(),
                                event: t
                            });
                        }
                    }
                }
            },
            {
                key: "itemFromElement",
                value: function(t) {
                    for(var e = t; e;){
                        if (e.hasOwnProperty("vis-item")) return e["vis-item"];
                        e = e.parentNode;
                    }
                    return null;
                }
            },
            {
                key: "itemFromTarget",
                value: function(t) {
                    return this.itemFromElement(t.target);
                }
            },
            {
                key: "itemFromRelatedTarget",
                value: function(t) {
                    return this.itemFromElement(t.relatedTarget);
                }
            },
            {
                key: "groupFromTarget",
                value: function(t) {
                    var e = t.center ? t.center.y : t.clientY, i1 = this.groupIds;
                    i1.length <= 0 && this.groupsData && (i1 = this.groupsData.getIds({
                        order: this.options.groupOrder
                    }));
                    for(var n = 0; n < i1.length; n++){
                        var o = i1[n], r = this.groups[o], s = r.dom.foreground, a = s.getBoundingClientRect();
                        if (e >= a.top && e < a.top + s.offsetHeight) return r;
                        if ("top" === this.options.orientation.item) {
                            if (n === this.groupIds.length - 1 && e > a.top) return r;
                        } else if (0 === n && e < a.top + s.offset) return r;
                    }
                    return null;
                }
            },
            {
                key: "_cloneItemData",
                value: function(t, e) {
                    var i1 = l_.extend({}, t);
                    return e || (e = this.itemsData.type), null != i1.start && (i1.start = l_.convert(i1.start, e && e.start || "Date")), null != i1.end && (i1.end = l_.convert(i1.end, e && e.end || "Date")), i1;
                }
            },
            {
                key: "_clusterItems",
                value: function() {
                    if (this.options.cluster) {
                        var t = this.body.range.conversion(this.body.domProps.center.width).scale, e = this.clusterGenerator.getClusters(this.clusters, t, this.options.cluster);
                        if (this.clusters != e) {
                            if (this._detachAllClusters(), e) {
                                var i1, n = ZD(e);
                                try {
                                    for(n.s(); !(i1 = n.n()).done;)i1.value.attach();
                                } catch (t) {
                                    n.e(t);
                                } finally{
                                    n.f();
                                }
                                this.clusters = e;
                            }
                            this._updateClusters(e);
                        }
                    }
                }
            },
            {
                key: "_detachAllClusters",
                value: function() {
                    if (this.options.cluster && this.clusters && this.clusters.length) {
                        var t, e = ZD(this.clusters);
                        try {
                            for(e.s(); !(t = e.n()).done;)t.value.detach();
                        } catch (t) {
                            e.e(t);
                        } finally{
                            e.f();
                        }
                    }
                }
            },
            {
                key: "_updateClusters",
                value: function(t) {
                    if (this.clusters && this.clusters.length) {
                        var e, i1, n = new $S(lp(t).call(t, function(t) {
                            return t.id;
                        })), o = Ed(e = this.clusters).call(e, function(t) {
                            return !n.has(t.id);
                        }), r = !1, s = ZD(o);
                        try {
                            for(s.s(); !(i1 = s.n()).done;){
                                var a, l, h = i1.value, u = Eg(a = this.selection).call(a, h.id);
                                if (-1 !== u) h.unselect(), Qf(l = this.selection).call(l, u, 1), r = !0;
                            }
                        } catch (t) {
                            s.e(t);
                        } finally{
                            s.f();
                        }
                        if (r) {
                            var c = this.getSelection();
                            this.body.emitter.emit("select", {
                                items: c,
                                event: event
                            });
                        }
                    }
                    this.clusters = t || [];
                }
            }
        ], [
            {
                key: "_getItemRange",
                value: function(t) {
                    var e = null, i1 = null;
                    return bd(t).call(t, function(t) {
                        (null == i1 || t.start < i1) && (i1 = t.start), null != t.end ? (null == e || t.end > e) && (e = t.end) : (null == e || t.start > e) && (e = t.start);
                    }), {
                        min: i1,
                        max: e
                    };
                }
            },
            {
                key: "itemSetFromTarget",
                value: function(t) {
                    for(var e = t.target; e;){
                        if (e.hasOwnProperty("vis-itemset")) return e["vis-itemset"];
                        e = e.parentNode;
                    }
                    return null;
                }
            }
        ]), i1;
    }(w_);
    iT.types = {
        background: ND,
        box: ED,
        range: PD,
        point: AD
    }, iT.prototype._onAdd = iT.prototype._onUpdate;
    var nT, oT = !1, rT = "background: #FFeeee; color: #dd0000", sT = function() {
        function t() {
            Lo(this, t);
        }
        return mc(t, null, [
            {
                key: "validate",
                value: function(e, i1, n) {
                    oT = !1, nT = i1;
                    var o = i1;
                    return void 0 !== n && (o = i1[n]), t.parse(e, o, []), oT;
                }
            },
            {
                key: "parse",
                value: function(e, i1, n) {
                    for(var o in e)e.hasOwnProperty(o) && t.check(o, e, i1, n);
                }
            },
            {
                key: "check",
                value: function(e, i1, n, o) {
                    if (void 0 !== n[e] || void 0 !== n.__any__) {
                        var r = e, s = !0;
                        void 0 === n[e] && void 0 !== n.__any__ && (r = "__any__", s = "object" === t.getType(i1[e]));
                        var a = n[r];
                        s && void 0 !== a.__type__ && (a = a.__type__), t.checkFields(e, i1, n, r, a, o);
                    } else t.getSuggestion(e, n, o);
                }
            },
            {
                key: "checkFields",
                value: function(e, i1, n, o, r, s) {
                    var a = function(i1) {
                        console.log("%c" + i1 + t.printLocation(s, e), rT);
                    }, l = t.getType(i1[e]), h = r[l];
                    void 0 !== h ? "array" === t.getType(h) && -1 === Eg(h).call(h, i1[e]) ? (a('Invalid option detected in "' + e + '". Allowed values are:' + t.print(h) + ' not "' + i1[e] + '". '), oT = !0) : "object" === l && "__any__" !== o && (s = l_.copyAndExtendArray(s, e), t.parse(i1[e], n[o], s)) : void 0 === r.any && (a('Invalid type received for "' + e + '". Expected: ' + t.print(Dp(r)) + ". Received [" + l + '] "' + i1[e] + '"'), oT = !0);
                }
            },
            {
                key: "getType",
                value: function(t) {
                    var e = uc(t);
                    return "object" === e ? null === t ? "null" : t instanceof Boolean ? "boolean" : t instanceof Number ? "number" : t instanceof String ? "string" : zc(t) ? "array" : t instanceof Date ? "date" : void 0 !== t.nodeType ? "dom" : !0 === t._isAMomentObject ? "moment" : "object" : "number" === e ? "number" : "boolean" === e ? "boolean" : "string" === e ? "string" : void 0 === e ? "undefined" : e;
                }
            },
            {
                key: "getSuggestion",
                value: function(e, i1, n) {
                    var o, r = t.findInOptions(e, i1, n, !1), s = t.findInOptions(e, nT, [], !0);
                    o = void 0 !== r.indexMatch ? " in " + t.printLocation(r.path, e, "") + 'Perhaps it was incomplete? Did you mean: "' + r.indexMatch + '"?\n\n' : s.distance <= 4 && r.distance > s.distance ? " in " + t.printLocation(r.path, e, "") + "Perhaps it was misplaced? Matching option found at: " + t.printLocation(s.path, s.closestMatch, "") : r.distance <= 8 ? '. Did you mean "' + r.closestMatch + '"?' + t.printLocation(r.path, e) : ". Did you mean one of these: " + t.print(Dp(i1)) + t.printLocation(n, e), console.log('%cUnknown option detected: "' + e + '"' + o, rT), oT = !0;
                }
            },
            {
                key: "findInOptions",
                value: function(e, i1, n) {
                    var o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], r = 1e9, s = "", a = [], l = e.toLowerCase(), h = void 0;
                    for(var u in i1){
                        var c = void 0;
                        if (void 0 !== i1[u].__type__ && !0 === o) {
                            var d = t.findInOptions(e, i1[u], l_.copyAndExtendArray(n, u));
                            r > d.distance && (s = d.closestMatch, a = d.path, r = d.distance, h = d.indexMatch);
                        } else {
                            var p;
                            -1 !== Eg(p = u.toLowerCase()).call(p, l) && (h = u), r > (c = t.levenshteinDistance(e, u)) && (s = u, a = l_.copyArray(n), r = c);
                        }
                    }
                    return {
                        closestMatch: s,
                        path: a,
                        distance: r,
                        indexMatch: h
                    };
                }
            },
            {
                key: "printLocation",
                value: function(t, e) {
                    for(var i1 = "\n\n" + (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Problem value found at: \n") + "options = {\n", n = 0; n < t.length; n++){
                        for(var o = 0; o < n + 1; o++)i1 += "  ";
                        i1 += t[n] + ": {\n";
                    }
                    for(var r = 0; r < t.length + 1; r++)i1 += "  ";
                    i1 += e + "\n";
                    for(var s = 0; s < t.length + 1; s++){
                        for(var a = 0; a < t.length - s; a++)i1 += "  ";
                        i1 += "}\n";
                    }
                    return i1 + "\n\n";
                }
            },
            {
                key: "print",
                value: function(t) {
                    return Fg(t).replace(/(\")|(\[)|(\])|(,"__type__")/g, "").replace(/(\,)/g, ", ");
                }
            },
            {
                key: "levenshteinDistance",
                value: function(t, e) {
                    if (0 === t.length) return e.length;
                    if (0 === e.length) return t.length;
                    var i1, n, o = [];
                    for(i1 = 0; i1 <= e.length; i1++)o[i1] = [
                        i1
                    ];
                    for(n = 0; n <= t.length; n++)o[0][n] = n;
                    for(i1 = 1; i1 <= e.length; i1++)for(n = 1; n <= t.length; n++)e.charAt(i1 - 1) == t.charAt(n - 1) ? o[i1][n] = o[i1 - 1][n - 1] : o[i1][n] = Math.min(o[i1 - 1][n - 1] + 1, Math.min(o[i1][n - 1] + 1, o[i1 - 1][n] + 1));
                    return o[e.length][t.length];
                }
            }
        ]), t;
    }(), aT = "string", lT = "boolean", hT = "number", uT = "array", cT = "date", dT = "object", pT = "moment", mT = {
        configure: {
            enabled: {
                boolean: lT
            },
            filter: {
                boolean: lT,
                function: "function"
            },
            container: {
                dom: "dom"
            },
            __type__: {
                object: dT,
                boolean: lT,
                function: "function"
            }
        },
        align: {
            string: aT
        },
        alignCurrentTime: {
            string: aT,
            undefined: "undefined"
        },
        rtl: {
            boolean: lT,
            undefined: "undefined"
        },
        rollingMode: {
            follow: {
                boolean: lT
            },
            offset: {
                number: hT,
                undefined: "undefined"
            },
            __type__: {
                object: dT
            }
        },
        onTimeout: {
            timeoutMs: {
                number: hT
            },
            callback: {
                function: "function"
            },
            __type__: {
                object: dT
            }
        },
        verticalScroll: {
            boolean: lT,
            undefined: "undefined"
        },
        horizontalScroll: {
            boolean: lT,
            undefined: "undefined"
        },
        autoResize: {
            boolean: lT
        },
        throttleRedraw: {
            number: hT
        },
        clickToUse: {
            boolean: lT
        },
        dataAttributes: {
            string: aT,
            array: uT
        },
        editable: {
            add: {
                boolean: lT,
                undefined: "undefined"
            },
            remove: {
                boolean: lT,
                undefined: "undefined"
            },
            updateGroup: {
                boolean: lT,
                undefined: "undefined"
            },
            updateTime: {
                boolean: lT,
                undefined: "undefined"
            },
            overrideItems: {
                boolean: lT,
                undefined: "undefined"
            },
            __type__: {
                boolean: lT,
                object: dT
            }
        },
        end: {
            number: hT,
            date: cT,
            string: aT,
            moment: pT
        },
        format: {
            minorLabels: {
                millisecond: {
                    string: aT,
                    undefined: "undefined"
                },
                second: {
                    string: aT,
                    undefined: "undefined"
                },
                minute: {
                    string: aT,
                    undefined: "undefined"
                },
                hour: {
                    string: aT,
                    undefined: "undefined"
                },
                weekday: {
                    string: aT,
                    undefined: "undefined"
                },
                day: {
                    string: aT,
                    undefined: "undefined"
                },
                week: {
                    string: aT,
                    undefined: "undefined"
                },
                month: {
                    string: aT,
                    undefined: "undefined"
                },
                year: {
                    string: aT,
                    undefined: "undefined"
                },
                __type__: {
                    object: dT,
                    function: "function"
                }
            },
            majorLabels: {
                millisecond: {
                    string: aT,
                    undefined: "undefined"
                },
                second: {
                    string: aT,
                    undefined: "undefined"
                },
                minute: {
                    string: aT,
                    undefined: "undefined"
                },
                hour: {
                    string: aT,
                    undefined: "undefined"
                },
                weekday: {
                    string: aT,
                    undefined: "undefined"
                },
                day: {
                    string: aT,
                    undefined: "undefined"
                },
                week: {
                    string: aT,
                    undefined: "undefined"
                },
                month: {
                    string: aT,
                    undefined: "undefined"
                },
                year: {
                    string: aT,
                    undefined: "undefined"
                },
                __type__: {
                    object: dT,
                    function: "function"
                }
            },
            __type__: {
                object: dT
            }
        },
        moment: {
            function: "function"
        },
        groupHeightMode: {
            string: aT
        },
        groupOrder: {
            string: aT,
            function: "function"
        },
        groupEditable: {
            add: {
                boolean: lT,
                undefined: "undefined"
            },
            remove: {
                boolean: lT,
                undefined: "undefined"
            },
            order: {
                boolean: lT,
                undefined: "undefined"
            },
            __type__: {
                boolean: lT,
                object: dT
            }
        },
        groupOrderSwap: {
            function: "function"
        },
        height: {
            string: aT,
            number: hT
        },
        hiddenDates: {
            start: {
                date: cT,
                number: hT,
                string: aT,
                moment: pT
            },
            end: {
                date: cT,
                number: hT,
                string: aT,
                moment: pT
            },
            repeat: {
                string: aT
            },
            __type__: {
                object: dT,
                array: uT
            }
        },
        itemsAlwaysDraggable: {
            item: {
                boolean: lT,
                undefined: "undefined"
            },
            range: {
                boolean: lT,
                undefined: "undefined"
            },
            __type__: {
                boolean: lT,
                object: dT
            }
        },
        limitSize: {
            boolean: lT
        },
        locale: {
            string: aT
        },
        locales: {
            __any__: {
                any: "any"
            },
            __type__: {
                object: dT
            }
        },
        longSelectPressTime: {
            number: hT
        },
        margin: {
            axis: {
                number: hT
            },
            item: {
                horizontal: {
                    number: hT,
                    undefined: "undefined"
                },
                vertical: {
                    number: hT,
                    undefined: "undefined"
                },
                __type__: {
                    object: dT,
                    number: hT
                }
            },
            __type__: {
                object: dT,
                number: hT
            }
        },
        max: {
            date: cT,
            number: hT,
            string: aT,
            moment: pT
        },
        maxHeight: {
            number: hT,
            string: aT
        },
        maxMinorChars: {
            number: hT
        },
        min: {
            date: cT,
            number: hT,
            string: aT,
            moment: pT
        },
        minHeight: {
            number: hT,
            string: aT
        },
        moveable: {
            boolean: lT
        },
        multiselect: {
            boolean: lT
        },
        multiselectPerGroup: {
            boolean: lT
        },
        onAdd: {
            function: "function"
        },
        onDropObjectOnItem: {
            function: "function"
        },
        onUpdate: {
            function: "function"
        },
        onMove: {
            function: "function"
        },
        onMoving: {
            function: "function"
        },
        onRemove: {
            function: "function"
        },
        onAddGroup: {
            function: "function"
        },
        onMoveGroup: {
            function: "function"
        },
        onRemoveGroup: {
            function: "function"
        },
        onInitialDrawComplete: {
            function: "function"
        },
        order: {
            function: "function"
        },
        orientation: {
            axis: {
                string: aT,
                undefined: "undefined"
            },
            item: {
                string: aT,
                undefined: "undefined"
            },
            __type__: {
                string: aT,
                object: dT
            }
        },
        selectable: {
            boolean: lT
        },
        sequentialSelection: {
            boolean: lT
        },
        showCurrentTime: {
            boolean: lT
        },
        showMajorLabels: {
            boolean: lT
        },
        showMinorLabels: {
            boolean: lT
        },
        showWeekScale: {
            boolean: lT
        },
        stack: {
            boolean: lT
        },
        stackSubgroups: {
            boolean: lT
        },
        cluster: {
            maxItems: {
                number: hT,
                undefined: "undefined"
            },
            titleTemplate: {
                string: aT,
                undefined: "undefined"
            },
            clusterCriteria: {
                function: "function",
                undefined: "undefined"
            },
            showStipes: {
                boolean: lT,
                undefined: "undefined"
            },
            fitOnDoubleClick: {
                boolean: lT,
                undefined: "undefined"
            },
            __type__: {
                boolean: lT,
                object: dT
            }
        },
        snap: {
            function: "function",
            null: "null"
        },
        start: {
            date: cT,
            number: hT,
            string: aT,
            moment: pT
        },
        template: {
            function: "function"
        },
        loadingScreenTemplate: {
            function: "function"
        },
        groupTemplate: {
            function: "function"
        },
        visibleFrameTemplate: {
            string: aT,
            function: "function"
        },
        showTooltips: {
            boolean: lT
        },
        tooltip: {
            followMouse: {
                boolean: lT
            },
            overflowMethod: {
                string: [
                    "cap",
                    "flip",
                    "none"
                ]
            },
            delay: {
                number: hT
            },
            template: {
                function: "function"
            },
            __type__: {
                object: dT
            }
        },
        tooltipOnItemUpdateTime: {
            template: {
                function: "function"
            },
            __type__: {
                boolean: lT,
                object: dT
            }
        },
        timeAxis: {
            scale: {
                string: aT,
                undefined: "undefined"
            },
            step: {
                number: hT,
                undefined: "undefined"
            },
            __type__: {
                object: dT
            }
        },
        type: {
            string: aT
        },
        width: {
            string: aT,
            number: hT
        },
        preferZoom: {
            boolean: lT
        },
        zoomable: {
            boolean: lT
        },
        zoomKey: {
            string: [
                "ctrlKey",
                "altKey",
                "shiftKey",
                "metaKey",
                ""
            ]
        },
        zoomFriction: {
            number: hT
        },
        zoomMax: {
            number: hT
        },
        zoomMin: {
            number: hT
        },
        xss: {
            disabled: {
                boolean: lT
            },
            filterOptions: {
                __any__: {
                    any: "any"
                },
                __type__: {
                    object: dT
                }
            },
            __type__: {
                object: dT
            }
        },
        __type__: {
            object: dT
        }
    }, fT = {
        global: {
            align: [
                "center",
                "left",
                "right"
            ],
            alignCurrentTime: [
                "none",
                "year",
                "month",
                "quarter",
                "week",
                "isoWeek",
                "day",
                "date",
                "hour",
                "minute",
                "second"
            ],
            direction: !1,
            autoResize: !0,
            clickToUse: !1,
            editable: {
                add: !1,
                remove: !1,
                updateGroup: !1,
                updateTime: !1
            },
            end: "",
            format: {
                minorLabels: {
                    millisecond: "SSS",
                    second: "s",
                    minute: "HH:mm",
                    hour: "HH:mm",
                    weekday: "ddd D",
                    day: "D",
                    week: "w",
                    month: "MMM",
                    year: "YYYY"
                },
                majorLabels: {
                    millisecond: "HH:mm:ss",
                    second: "D MMMM HH:mm",
                    minute: "ddd D MMMM",
                    hour: "ddd D MMMM",
                    weekday: "MMMM YYYY",
                    day: "MMMM YYYY",
                    week: "MMMM YYYY",
                    month: "YYYY",
                    year: ""
                }
            },
            groupHeightMode: [
                "auto",
                "fixed",
                "fitItems"
            ],
            groupsDraggable: !1,
            height: "",
            locale: "",
            longSelectPressTime: 251,
            margin: {
                axis: [
                    20,
                    0,
                    100,
                    1
                ],
                item: {
                    horizontal: [
                        10,
                        0,
                        100,
                        1
                    ],
                    vertical: [
                        10,
                        0,
                        100,
                        1
                    ]
                }
            },
            max: "",
            maxHeight: "",
            maxMinorChars: [
                7,
                0,
                20,
                1
            ],
            min: "",
            minHeight: "",
            moveable: !1,
            multiselect: !1,
            multiselectPerGroup: !1,
            orientation: {
                axis: [
                    "both",
                    "bottom",
                    "top"
                ],
                item: [
                    "bottom",
                    "top"
                ]
            },
            preferZoom: !1,
            selectable: !0,
            showCurrentTime: !1,
            showMajorLabels: !0,
            showMinorLabels: !0,
            stack: !0,
            stackSubgroups: !0,
            cluster: !1,
            start: "",
            showTooltips: !0,
            tooltip: {
                followMouse: !1,
                overflowMethod: "flip",
                delay: [
                    500,
                    0,
                    99999,
                    100
                ]
            },
            tooltipOnItemUpdateTime: !1,
            type: [
                "box",
                "point",
                "range",
                "background"
            ],
            width: "100%",
            zoomable: !0,
            zoomKey: [
                "ctrlKey",
                "altKey",
                "shiftKey",
                "metaKey",
                ""
            ],
            zoomMax: [
                31536e10,
                10,
                31536e10,
                1
            ],
            zoomMin: [
                10,
                10,
                31536e10,
                1
            ],
            xss: {
                disabled: !1
            }
        }
    }, vT = {
        black: "#000000",
        navy: "#000080",
        darkblue: "#00008B",
        mediumblue: "#0000CD",
        blue: "#0000FF",
        darkgreen: "#006400",
        green: "#008000",
        teal: "#008080",
        darkcyan: "#008B8B",
        deepskyblue: "#00BFFF",
        darkturquoise: "#00CED1",
        mediumspringgreen: "#00FA9A",
        lime: "#00FF00",
        springgreen: "#00FF7F",
        aqua: "#00FFFF",
        cyan: "#00FFFF",
        midnightblue: "#191970",
        dodgerblue: "#1E90FF",
        lightseagreen: "#20B2AA",
        forestgreen: "#228B22",
        seagreen: "#2E8B57",
        darkslategray: "#2F4F4F",
        limegreen: "#32CD32",
        mediumseagreen: "#3CB371",
        turquoise: "#40E0D0",
        royalblue: "#4169E1",
        steelblue: "#4682B4",
        darkslateblue: "#483D8B",
        mediumturquoise: "#48D1CC",
        indigo: "#4B0082",
        darkolivegreen: "#556B2F",
        cadetblue: "#5F9EA0",
        cornflowerblue: "#6495ED",
        mediumaquamarine: "#66CDAA",
        dimgray: "#696969",
        slateblue: "#6A5ACD",
        olivedrab: "#6B8E23",
        slategray: "#708090",
        lightslategray: "#778899",
        mediumslateblue: "#7B68EE",
        lawngreen: "#7CFC00",
        chartreuse: "#7FFF00",
        aquamarine: "#7FFFD4",
        maroon: "#800000",
        purple: "#800080",
        olive: "#808000",
        gray: "#808080",
        skyblue: "#87CEEB",
        lightskyblue: "#87CEFA",
        blueviolet: "#8A2BE2",
        darkred: "#8B0000",
        darkmagenta: "#8B008B",
        saddlebrown: "#8B4513",
        darkseagreen: "#8FBC8F",
        lightgreen: "#90EE90",
        mediumpurple: "#9370D8",
        darkviolet: "#9400D3",
        palegreen: "#98FB98",
        darkorchid: "#9932CC",
        yellowgreen: "#9ACD32",
        sienna: "#A0522D",
        brown: "#A52A2A",
        darkgray: "#A9A9A9",
        lightblue: "#ADD8E6",
        greenyellow: "#ADFF2F",
        paleturquoise: "#AFEEEE",
        lightsteelblue: "#B0C4DE",
        powderblue: "#B0E0E6",
        firebrick: "#B22222",
        darkgoldenrod: "#B8860B",
        mediumorchid: "#BA55D3",
        rosybrown: "#BC8F8F",
        darkkhaki: "#BDB76B",
        silver: "#C0C0C0",
        mediumvioletred: "#C71585",
        indianred: "#CD5C5C",
        peru: "#CD853F",
        chocolate: "#D2691E",
        tan: "#D2B48C",
        lightgrey: "#D3D3D3",
        palevioletred: "#D87093",
        thistle: "#D8BFD8",
        orchid: "#DA70D6",
        goldenrod: "#DAA520",
        crimson: "#DC143C",
        gainsboro: "#DCDCDC",
        plum: "#DDA0DD",
        burlywood: "#DEB887",
        lightcyan: "#E0FFFF",
        lavender: "#E6E6FA",
        darksalmon: "#E9967A",
        violet: "#EE82EE",
        palegoldenrod: "#EEE8AA",
        lightcoral: "#F08080",
        khaki: "#F0E68C",
        aliceblue: "#F0F8FF",
        honeydew: "#F0FFF0",
        azure: "#F0FFFF",
        sandybrown: "#F4A460",
        wheat: "#F5DEB3",
        beige: "#F5F5DC",
        whitesmoke: "#F5F5F5",
        mintcream: "#F5FFFA",
        ghostwhite: "#F8F8FF",
        salmon: "#FA8072",
        antiquewhite: "#FAEBD7",
        linen: "#FAF0E6",
        lightgoldenrodyellow: "#FAFAD2",
        oldlace: "#FDF5E6",
        red: "#FF0000",
        fuchsia: "#FF00FF",
        magenta: "#FF00FF",
        deeppink: "#FF1493",
        orangered: "#FF4500",
        tomato: "#FF6347",
        hotpink: "#FF69B4",
        coral: "#FF7F50",
        darkorange: "#FF8C00",
        lightsalmon: "#FFA07A",
        orange: "#FFA500",
        lightpink: "#FFB6C1",
        pink: "#FFC0CB",
        gold: "#FFD700",
        peachpuff: "#FFDAB9",
        navajowhite: "#FFDEAD",
        moccasin: "#FFE4B5",
        bisque: "#FFE4C4",
        mistyrose: "#FFE4E1",
        blanchedalmond: "#FFEBCD",
        papayawhip: "#FFEFD5",
        lavenderblush: "#FFF0F5",
        seashell: "#FFF5EE",
        cornsilk: "#FFF8DC",
        lemonchiffon: "#FFFACD",
        floralwhite: "#FFFAF0",
        snow: "#FFFAFA",
        yellow: "#FFFF00",
        lightyellow: "#FFFFE0",
        ivory: "#FFFFF0",
        white: "#FFFFFF"
    }, gT = function() {
        function t() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
            Lo(this, t), this.pixelRatio = e, this.generated = !1, this.centerCoordinates = {
                x: 144.5,
                y: 144.5
            }, this.r = 289 * .49, this.color = {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }, this.hueCircle = void 0, this.initialColor = {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }, this.previousColor = void 0, this.applied = !1, this.updateCallback = function() {}, this.closeCallback = function() {}, this._create();
        }
        return mc(t, [
            {
                key: "insertTo",
                value: function(t) {
                    void 0 !== this.hammer && (this.hammer.destroy(), this.hammer = void 0), this.container = t, this.container.appendChild(this.frame), this._bindHammer(), this._setSize();
                }
            },
            {
                key: "setUpdateCallback",
                value: function(t) {
                    if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker update callback is not a function.");
                    this.updateCallback = t;
                }
            },
            {
                key: "setCloseCallback",
                value: function(t) {
                    if ("function" != typeof t) throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
                    this.closeCallback = t;
                }
            },
            {
                key: "_isColorString",
                value: function(t) {
                    if ("string" == typeof t) return vT[t];
                }
            },
            {
                key: "setColor",
                value: function(t) {
                    var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    if ("none" !== t) {
                        var i1, n = this._isColorString(t);
                        if (void 0 !== n && (t = n), !0 === l_.isString(t)) {
                            if (!0 === l_.isValidRGB(t)) {
                                var o = t.substr(4).substr(0, t.length - 5).split(",");
                                i1 = {
                                    r: o[0],
                                    g: o[1],
                                    b: o[2],
                                    a: 1
                                };
                            } else if (!0 === l_.isValidRGBA(t)) {
                                var r = t.substr(5).substr(0, t.length - 6).split(",");
                                i1 = {
                                    r: r[0],
                                    g: r[1],
                                    b: r[2],
                                    a: r[3]
                                };
                            } else if (!0 === l_.isValidHex(t)) {
                                var s = l_.hexToRGB(t);
                                i1 = {
                                    r: s.r,
                                    g: s.g,
                                    b: s.b,
                                    a: 1
                                };
                            }
                        } else if (t instanceof Object && void 0 !== t.r && void 0 !== t.g && void 0 !== t.b) {
                            var a = void 0 !== t.a ? t.a : "1.0";
                            i1 = {
                                r: t.r,
                                g: t.g,
                                b: t.b,
                                a: a
                            };
                        }
                        if (void 0 === i1) throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + Fg(t));
                        this._setColor(i1, e);
                    }
                }
            },
            {
                key: "show",
                value: function() {
                    void 0 !== this.closeCallback && (this.closeCallback(), this.closeCallback = void 0), this.applied = !1, this.frame.style.display = "block", this._generateHueCircle();
                }
            },
            {
                key: "_hide",
                value: function() {
                    var t = this;
                    !0 === (!(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]) && (this.previousColor = l_.extend({}, this.color)), !0 === this.applied && this.updateCallback(this.initialColor), this.frame.style.display = "none", sd(function() {
                        void 0 !== t.closeCallback && (t.closeCallback(), t.closeCallback = void 0);
                    }, 0);
                }
            },
            {
                key: "_save",
                value: function() {
                    this.updateCallback(this.color), this.applied = !1, this._hide();
                }
            },
            {
                key: "_apply",
                value: function() {
                    this.applied = !0, this.updateCallback(this.color), this._updatePicker(this.color);
                }
            },
            {
                key: "_loadLast",
                value: function() {
                    void 0 !== this.previousColor ? this.setColor(this.previousColor, !1) : alert("There is no last color to load...");
                }
            },
            {
                key: "_setColor",
                value: function(t) {
                    !0 === (!(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]) && (this.initialColor = l_.extend({}, t)), this.color = t;
                    var e = l_.RGBToHSV(t.r, t.g, t.b), i1 = 2 * Math.PI, n = this.r * e.s, o = this.centerCoordinates.x + n * Math.sin(i1 * e.h), r = this.centerCoordinates.y + n * Math.cos(i1 * e.h);
                    this.colorPickerSelector.style.left = o - .5 * this.colorPickerSelector.clientWidth + "px", this.colorPickerSelector.style.top = r - .5 * this.colorPickerSelector.clientHeight + "px", this._updatePicker(t);
                }
            },
            {
                key: "_setOpacity",
                value: function(t) {
                    this.color.a = t / 100, this._updatePicker(this.color);
                }
            },
            {
                key: "_setBrightness",
                value: function(t) {
                    var e = l_.RGBToHSV(this.color.r, this.color.g, this.color.b);
                    e.v = t / 100;
                    var i1 = l_.HSVToRGB(e.h, e.s, e.v);
                    i1.a = this.color.a, this.color = i1, this._updatePicker();
                }
            },
            {
                key: "_updatePicker",
                value: function() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.color, e = l_.RGBToHSV(t.r, t.g, t.b), i1 = this.colorPickerCanvas.getContext("2d");
                    void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (i1.webkitBackingStorePixelRatio || i1.mozBackingStorePixelRatio || i1.msBackingStorePixelRatio || i1.oBackingStorePixelRatio || i1.backingStorePixelRatio || 1)), i1.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                    var n = this.colorPickerCanvas.clientWidth, o = this.colorPickerCanvas.clientHeight;
                    i1.clearRect(0, 0, n, o), i1.putImageData(this.hueCircle, 0, 0), i1.fillStyle = "rgba(0,0,0," + (1 - e.v) + ")", i1.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), Vg(i1).call(i1), this.brightnessRange.value = 100 * e.v, this.opacityRange.value = 100 * t.a, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
                }
            },
            {
                key: "_setSize",
                value: function() {
                    this.colorPickerCanvas.style.width = "100%", this.colorPickerCanvas.style.height = "100%", this.colorPickerCanvas.width = 289 * this.pixelRatio, this.colorPickerCanvas.height = 289 * this.pixelRatio;
                }
            },
            {
                key: "_create",
                value: function() {
                    var t, e, i1, n;
                    if (this.frame = document.createElement("div"), this.frame.className = "vis-color-picker", this.colorPickerDiv = document.createElement("div"), this.colorPickerSelector = document.createElement("div"), this.colorPickerSelector.className = "vis-selector", this.colorPickerDiv.appendChild(this.colorPickerSelector), this.colorPickerCanvas = document.createElement("canvas"), this.colorPickerDiv.appendChild(this.colorPickerCanvas), this.colorPickerCanvas.getContext) {
                        var o = this.colorPickerCanvas.getContext("2d");
                        this.pixelRatio = (window.devicePixelRatio || 1) / (o.webkitBackingStorePixelRatio || o.mozBackingStorePixelRatio || o.msBackingStorePixelRatio || o.oBackingStorePixelRatio || o.backingStorePixelRatio || 1), this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                    } else {
                        var r = document.createElement("DIV");
                        r.style.color = "red", r.style.fontWeight = "bold", r.style.padding = "10px", r.innerHTML = "Error: your browser does not support HTML canvas", this.colorPickerCanvas.appendChild(r);
                    }
                    this.colorPickerDiv.className = "vis-color", this.opacityDiv = document.createElement("div"), this.opacityDiv.className = "vis-opacity", this.brightnessDiv = document.createElement("div"), this.brightnessDiv.className = "vis-brightness", this.arrowDiv = document.createElement("div"), this.arrowDiv.className = "vis-arrow", this.opacityRange = document.createElement("input");
                    try {
                        this.opacityRange.type = "range", this.opacityRange.min = "0", this.opacityRange.max = "100";
                    } catch (t) {}
                    this.opacityRange.value = "100", this.opacityRange.className = "vis-range", this.brightnessRange = document.createElement("input");
                    try {
                        this.brightnessRange.type = "range", this.brightnessRange.min = "0", this.brightnessRange.max = "100";
                    } catch (t) {}
                    this.brightnessRange.value = "100", this.brightnessRange.className = "vis-range", this.opacityDiv.appendChild(this.opacityRange), this.brightnessDiv.appendChild(this.brightnessRange);
                    var s = this;
                    this.opacityRange.onchange = function() {
                        s._setOpacity(this.value);
                    }, this.opacityRange.oninput = function() {
                        s._setOpacity(this.value);
                    }, this.brightnessRange.onchange = function() {
                        s._setBrightness(this.value);
                    }, this.brightnessRange.oninput = function() {
                        s._setBrightness(this.value);
                    }, this.brightnessLabel = document.createElement("div"), this.brightnessLabel.className = "vis-label vis-brightness", this.brightnessLabel.innerHTML = "brightness:", this.opacityLabel = document.createElement("div"), this.opacityLabel.className = "vis-label vis-opacity", this.opacityLabel.innerHTML = "opacity:", this.newColorDiv = document.createElement("div"), this.newColorDiv.className = "vis-new-color", this.newColorDiv.innerHTML = "new", this.initialColorDiv = document.createElement("div"), this.initialColorDiv.className = "vis-initial-color", this.initialColorDiv.innerHTML = "initial", this.cancelButton = document.createElement("div"), this.cancelButton.className = "vis-button vis-cancel", this.cancelButton.innerHTML = "cancel", this.cancelButton.onclick = Hc(t = this._hide).call(t, this, !1), this.applyButton = document.createElement("div"), this.applyButton.className = "vis-button vis-apply", this.applyButton.innerHTML = "apply", this.applyButton.onclick = Hc(e = this._apply).call(e, this), this.saveButton = document.createElement("div"), this.saveButton.className = "vis-button vis-save", this.saveButton.innerHTML = "save", this.saveButton.onclick = Hc(i1 = this._save).call(i1, this), this.loadButton = document.createElement("div"), this.loadButton.className = "vis-button vis-load", this.loadButton.innerHTML = "load last", this.loadButton.onclick = Hc(n = this._loadLast).call(n, this), this.frame.appendChild(this.colorPickerDiv), this.frame.appendChild(this.arrowDiv), this.frame.appendChild(this.brightnessLabel), this.frame.appendChild(this.brightnessDiv), this.frame.appendChild(this.opacityLabel), this.frame.appendChild(this.opacityDiv), this.frame.appendChild(this.newColorDiv), this.frame.appendChild(this.initialColorDiv), this.frame.appendChild(this.cancelButton), this.frame.appendChild(this.applyButton), this.frame.appendChild(this.saveButton), this.frame.appendChild(this.loadButton);
                }
            },
            {
                key: "_bindHammer",
                value: function() {
                    var t = this;
                    this.drag = {}, this.pinch = {}, this.hammer = new Gx(this.colorPickerCanvas), this.hammer.get("pinch").set({
                        enable: !0
                    }), Wx(this.hammer, function(e) {
                        t._moveSelector(e);
                    }), this.hammer.on("tap", function(e) {
                        t._moveSelector(e);
                    }), this.hammer.on("panstart", function(e) {
                        t._moveSelector(e);
                    }), this.hammer.on("panmove", function(e) {
                        t._moveSelector(e);
                    }), this.hammer.on("panend", function(e) {
                        t._moveSelector(e);
                    });
                }
            },
            {
                key: "_generateHueCircle",
                value: function() {
                    if (!1 === this.generated) {
                        var t = this.colorPickerCanvas.getContext("2d");
                        void 0 === this.pixelRation && (this.pixelRatio = (window.devicePixelRatio || 1) / (t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1)), t.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                        var e, i1, n, o, r = this.colorPickerCanvas.clientWidth, s = this.colorPickerCanvas.clientHeight;
                        t.clearRect(0, 0, r, s), this.centerCoordinates = {
                            x: .5 * r,
                            y: .5 * s
                        }, this.r = .49 * r;
                        var a, l = 2 * Math.PI / 360, h = 1 / this.r;
                        for(n = 0; n < 360; n++)for(o = 0; o < this.r; o++)e = this.centerCoordinates.x + o * Math.sin(l * n), i1 = this.centerCoordinates.y + o * Math.cos(l * n), a = l_.HSVToRGB(.002777777777777778 * n, o * h, 1), t.fillStyle = "rgb(" + a.r + "," + a.g + "," + a.b + ")", t.fillRect(e - .5, i1 - .5, 2, 2);
                        t.strokeStyle = "rgba(0,0,0,1)", t.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r), t.stroke(), this.hueCircle = t.getImageData(0, 0, r, s);
                    }
                    this.generated = !0;
                }
            },
            {
                key: "_moveSelector",
                value: function(t) {
                    var e = this.colorPickerDiv.getBoundingClientRect(), i1 = t.center.x - e.left, n = t.center.y - e.top, o = .5 * this.colorPickerDiv.clientHeight, r = .5 * this.colorPickerDiv.clientWidth, s = i1 - r, a = n - o, l = Math.atan2(s, a), h = .98 * Math.min(Math.sqrt(s * s + a * a), r), u = Math.cos(l) * h + o, c = Math.sin(l) * h + r;
                    this.colorPickerSelector.style.top = u - .5 * this.colorPickerSelector.clientHeight + "px", this.colorPickerSelector.style.left = c - .5 * this.colorPickerSelector.clientWidth + "px";
                    var d = l / (2 * Math.PI);
                    d = d < 0 ? d + 1 : d;
                    var p = h / this.r, m = l_.RGBToHSV(this.color.r, this.color.g, this.color.b);
                    m.h = d, m.s = p;
                    var f = l_.HSVToRGB(m.h, m.s, m.v);
                    f.a = this.color.a, this.color = f, this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")", this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
                }
            }
        ]), t;
    }(), yT = function() {
        function t(e, i1, n) {
            var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
            Lo(this, t), this.parent = e, this.changedOptions = [], this.container = i1, this.allowCreation = !1, this.options = {}, this.initialized = !1, this.popupCounter = 0, this.defaultOptions = {
                enabled: !1,
                filter: !0,
                container: void 0,
                showButton: !0
            }, l_.extend(this.options, this.defaultOptions), this.configureOptions = n, this.moduleOptions = {}, this.domElements = [], this.popupDiv = {}, this.popupLimit = 5, this.popupHistory = {}, this.colorPicker = new gT(o), this.wrapper = void 0;
        }
        return mc(t, [
            {
                key: "setOptions",
                value: function(t) {
                    if (void 0 !== t) {
                        this.popupHistory = {}, this._removePopup();
                        var e = !0;
                        if ("string" == typeof t) this.options.filter = t;
                        else if (zc(t)) this.options.filter = t.join();
                        else if ("object" === uc(t)) {
                            if (null == t) throw new TypeError("options cannot be null");
                            void 0 !== t.container && (this.options.container = t.container), void 0 !== Ed(t) && (this.options.filter = Ed(t)), void 0 !== t.showButton && (this.options.showButton = t.showButton), void 0 !== t.enabled && (e = t.enabled);
                        } else "boolean" == typeof t ? (this.options.filter = !0, e = t) : "function" == typeof t && (this.options.filter = t, e = !0);
                        !1 === Ed(this.options) && (e = !1), this.options.enabled = e;
                    }
                    this._clean();
                }
            },
            {
                key: "setModuleOptions",
                value: function(t) {
                    this.moduleOptions = t, !0 === this.options.enabled && (this._clean(), void 0 !== this.options.container && (this.container = this.options.container), this._create());
                }
            },
            {
                key: "_create",
                value: function() {
                    this._clean(), this.changedOptions = [];
                    var t = Ed(this.options), e = 0, i1 = !1;
                    for(var n in this.configureOptions)this.configureOptions.hasOwnProperty(n) && (this.allowCreation = !1, i1 = !1, "function" == typeof t ? i1 = (i1 = t(n, [])) || this._handleObject(this.configureOptions[n], [
                        n
                    ], !0) : !0 !== t && -1 === Eg(t).call(t, n) || (i1 = !0), !1 !== i1 && (this.allowCreation = !0, e > 0 && this._makeItem([]), this._makeHeader(n), this._handleObject(this.configureOptions[n], [
                        n
                    ])), e++);
                    this._makeButton(), this._push();
                }
            },
            {
                key: "_push",
                value: function() {
                    this.wrapper = document.createElement("div"), this.wrapper.className = "vis-configuration-wrapper", this.container.appendChild(this.wrapper);
                    for(var t = 0; t < this.domElements.length; t++)this.wrapper.appendChild(this.domElements[t]);
                    this._showPopupIfNeeded();
                }
            },
            {
                key: "_clean",
                value: function() {
                    for(var t = 0; t < this.domElements.length; t++)this.wrapper.removeChild(this.domElements[t]);
                    void 0 !== this.wrapper && (this.container.removeChild(this.wrapper), this.wrapper = void 0), this.domElements = [], this._removePopup();
                }
            },
            {
                key: "_getValue",
                value: function(t) {
                    for(var e = this.moduleOptions, i1 = 0; i1 < t.length; i1++){
                        if (void 0 === e[t[i1]]) {
                            e = void 0;
                            break;
                        }
                        e = e[t[i1]];
                    }
                    return e;
                }
            },
            {
                key: "_makeItem",
                value: function(t) {
                    if (!0 === this.allowCreation) {
                        var e = document.createElement("div");
                        e.className = "vis-configuration vis-config-item vis-config-s" + t.length;
                        for(var i1 = arguments.length, n = new Array(i1 > 1 ? i1 - 1 : 0), o = 1; o < i1; o++)n[o - 1] = arguments[o];
                        return bd(n).call(n, function(t) {
                            e.appendChild(t);
                        }), this.domElements.push(e), this.domElements.length;
                    }
                    return 0;
                }
            },
            {
                key: "_makeHeader",
                value: function(t) {
                    var e = document.createElement("div");
                    e.className = "vis-configuration vis-config-header", e.innerHTML = l_.xss(t), this._makeItem([], e);
                }
            },
            {
                key: "_makeLabel",
                value: function(t, e) {
                    var i1 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = document.createElement("div");
                    return n.className = "vis-configuration vis-config-label vis-config-s" + e.length, n.innerHTML = !0 === i1 ? l_.xss("<i><b>" + t + ":</b></i>") : l_.xss(t + ":"), n;
                }
            },
            {
                key: "_makeDropdown",
                value: function(t, e, i1) {
                    var n = document.createElement("select");
                    n.className = "vis-configuration vis-config-select";
                    var o = 0;
                    void 0 !== e && -1 !== Eg(t).call(t, e) && (o = Eg(t).call(t, e));
                    for(var r = 0; r < t.length; r++){
                        var s = document.createElement("option");
                        s.value = t[r], r === o && (s.selected = "selected"), s.innerHTML = t[r], n.appendChild(s);
                    }
                    var a = this;
                    n.onchange = function() {
                        a._update(this.value, i1);
                    };
                    var l = this._makeLabel(i1[i1.length - 1], i1);
                    this._makeItem(i1, l, n);
                }
            },
            {
                key: "_makeRange",
                value: function(t, e, i1) {
                    var n = t[0], o = t[1], r = t[2], s = t[3], a = document.createElement("input");
                    a.className = "vis-configuration vis-config-range";
                    try {
                        a.type = "range", a.min = o, a.max = r;
                    } catch (t) {}
                    a.step = s;
                    var l = "", h = 0;
                    if (void 0 !== e) {
                        var u = 1.2;
                        e < 0 && e * u < o ? (a.min = Math.ceil(e * u), h = a.min, l = "range increased") : e / u < o && (a.min = Math.ceil(e / u), h = a.min, l = "range increased"), e * u > r && 1 !== r && (a.max = Math.ceil(e * u), h = a.max, l = "range increased"), a.value = e;
                    } else a.value = n;
                    var c = document.createElement("input");
                    c.className = "vis-configuration vis-config-rangeinput", c.value = Number(a.value);
                    var d = this;
                    a.onchange = function() {
                        c.value = this.value, d._update(Number(this.value), i1);
                    }, a.oninput = function() {
                        c.value = this.value;
                    };
                    var p = this._makeLabel(i1[i1.length - 1], i1), m = this._makeItem(i1, p, a, c);
                    "" !== l && this.popupHistory[m] !== h && (this.popupHistory[m] = h, this._setupPopup(l, m));
                }
            },
            {
                key: "_makeButton",
                value: function() {
                    var t = this;
                    if (!0 === this.options.showButton) {
                        var e = document.createElement("div");
                        e.className = "vis-configuration vis-config-button", e.innerHTML = "generate options", e.onclick = function() {
                            t._printOptions();
                        }, e.onmouseover = function() {
                            e.className = "vis-configuration vis-config-button hover";
                        }, e.onmouseout = function() {
                            e.className = "vis-configuration vis-config-button";
                        }, this.optionsContainer = document.createElement("div"), this.optionsContainer.className = "vis-configuration vis-config-option-container", this.domElements.push(this.optionsContainer), this.domElements.push(e);
                    }
                }
            },
            {
                key: "_setupPopup",
                value: function(t, e) {
                    var i1 = this;
                    if (!0 === this.initialized && !0 === this.allowCreation && this.popupCounter < this.popupLimit) {
                        var n = document.createElement("div");
                        n.id = "vis-configuration-popup", n.className = "vis-configuration-popup", n.innerHTML = l_.xss(t), n.onclick = function() {
                            i1._removePopup();
                        }, this.popupCounter += 1, this.popupDiv = {
                            html: n,
                            index: e
                        };
                    }
                }
            },
            {
                key: "_removePopup",
                value: function() {
                    void 0 !== this.popupDiv.html && (this.popupDiv.html.parentNode.removeChild(this.popupDiv.html), clearTimeout(this.popupDiv.hideTimeout), clearTimeout(this.popupDiv.deleteTimeout), this.popupDiv = {});
                }
            },
            {
                key: "_showPopupIfNeeded",
                value: function() {
                    var t = this;
                    if (void 0 !== this.popupDiv.html) {
                        var e = this.domElements[this.popupDiv.index].getBoundingClientRect();
                        this.popupDiv.html.style.left = e.left + "px", this.popupDiv.html.style.top = e.top - 30 + "px", document.body.appendChild(this.popupDiv.html), this.popupDiv.hideTimeout = sd(function() {
                            t.popupDiv.html.style.opacity = 0;
                        }, 1500), this.popupDiv.deleteTimeout = sd(function() {
                            t._removePopup();
                        }, 1800);
                    }
                }
            },
            {
                key: "_makeCheckbox",
                value: function(t, e, i1) {
                    var n = document.createElement("input");
                    n.type = "checkbox", n.className = "vis-configuration vis-config-checkbox", n.checked = t, void 0 !== e && (n.checked = e, e !== t && ("object" === uc(t) ? e !== t.enabled && this.changedOptions.push({
                        path: i1,
                        value: e
                    }) : this.changedOptions.push({
                        path: i1,
                        value: e
                    })));
                    var o = this;
                    n.onchange = function() {
                        o._update(this.checked, i1);
                    };
                    var r = this._makeLabel(i1[i1.length - 1], i1);
                    this._makeItem(i1, r, n);
                }
            },
            {
                key: "_makeTextInput",
                value: function(t, e, i1) {
                    var n = document.createElement("input");
                    n.type = "text", n.className = "vis-configuration vis-config-text", n.value = e, e !== t && this.changedOptions.push({
                        path: i1,
                        value: e
                    });
                    var o = this;
                    n.onchange = function() {
                        o._update(this.value, i1);
                    };
                    var r = this._makeLabel(i1[i1.length - 1], i1);
                    this._makeItem(i1, r, n);
                }
            },
            {
                key: "_makeColorField",
                value: function(t, e, i1) {
                    var n = this, o = t[1], r = document.createElement("div");
                    "none" !== (e = void 0 === e ? o : e) ? (r.className = "vis-configuration vis-config-colorBlock", r.style.backgroundColor = e) : r.className = "vis-configuration vis-config-colorBlock none", e = void 0 === e ? o : e, r.onclick = function() {
                        n._showColorPicker(e, r, i1);
                    };
                    var s = this._makeLabel(i1[i1.length - 1], i1);
                    this._makeItem(i1, s, r);
                }
            },
            {
                key: "_showColorPicker",
                value: function(t, e, i1) {
                    var n = this;
                    e.onclick = function() {}, this.colorPicker.insertTo(e), this.colorPicker.show(), this.colorPicker.setColor(t), this.colorPicker.setUpdateCallback(function(t) {
                        var o = "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")";
                        e.style.backgroundColor = o, n._update(o, i1);
                    }), this.colorPicker.setCloseCallback(function() {
                        e.onclick = function() {
                            n._showColorPicker(t, e, i1);
                        };
                    });
                }
            },
            {
                key: "_handleObject",
                value: function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], i1 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = !1, o = Ed(this.options), r = !1;
                    for(var s in t)if (t.hasOwnProperty(s)) {
                        n = !0;
                        var a = t[s], l = l_.copyAndExtendArray(e, s);
                        if ("function" == typeof o && !1 === (n = o(s, e)) && !zc(a) && "string" != typeof a && "boolean" != typeof a && a instanceof Object && (this.allowCreation = !1, n = this._handleObject(a, l, !0), this.allowCreation = !1 === i1), !1 !== n) {
                            r = !0;
                            var h = this._getValue(l);
                            if (zc(a)) this._handleArray(a, h, l);
                            else if ("string" == typeof a) this._makeTextInput(a, h, l);
                            else if ("boolean" == typeof a) this._makeCheckbox(a, h, l);
                            else if (a instanceof Object) {
                                var u = !0;
                                if (-1 !== Eg(e).call(e, "physics") && this.moduleOptions.physics.solver !== s && (u = !1), !0 === u) {
                                    if (void 0 !== a.enabled) {
                                        var c = l_.copyAndExtendArray(l, "enabled"), d = this._getValue(c);
                                        if (!0 === d) {
                                            var p = this._makeLabel(s, l, !0);
                                            this._makeItem(l, p), r = this._handleObject(a, l) || r;
                                        } else this._makeCheckbox(a, d, l);
                                    } else {
                                        var m = this._makeLabel(s, l, !0);
                                        this._makeItem(l, m), r = this._handleObject(a, l) || r;
                                    }
                                }
                            } else console.error("dont know how to handle", a, s, l);
                        }
                    }
                    return r;
                }
            },
            {
                key: "_handleArray",
                value: function(t, e, i1) {
                    "string" == typeof t[0] && "color" === t[0] ? (this._makeColorField(t, e, i1), t[1] !== e && this.changedOptions.push({
                        path: i1,
                        value: e
                    })) : "string" == typeof t[0] ? (this._makeDropdown(t, e, i1), t[0] !== e && this.changedOptions.push({
                        path: i1,
                        value: e
                    })) : "number" == typeof t[0] && (this._makeRange(t, e, i1), t[0] !== e && this.changedOptions.push({
                        path: i1,
                        value: Number(e)
                    }));
                }
            },
            {
                key: "_update",
                value: function(t, e) {
                    var i1 = this._constructOptions(t, e);
                    this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit && this.parent.body.emitter.emit("configChange", i1), this.initialized = !0, this.parent.setOptions(i1);
                }
            },
            {
                key: "_constructOptions",
                value: function(t, e) {
                    var i1 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = i1;
                    t = "false" !== (t = "true" === t || t) && t;
                    for(var o = 0; o < e.length; o++)"global" !== e[o] && (void 0 === n[e[o]] && (n[e[o]] = {}), o !== e.length - 1 ? n = n[e[o]] : n[e[o]] = t);
                    return i1;
                }
            },
            {
                key: "_printOptions",
                value: function() {
                    var t = this.getOptions();
                    this.optionsContainer.innerHTML = "<pre>var options = " + Fg(t, null, 2) + "</pre>";
                }
            },
            {
                key: "getOptions",
                value: function() {
                    for(var t = {}, e = 0; e < this.changedOptions.length; e++)this._constructOptions(this.changedOptions[e].value, this.changedOptions[e].path, t);
                    return t;
                }
            }
        ]), t;
    }();
    function bT(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    var wT = function(t) {
        Ic(i1, t);
        var e = bT(i1);
        function i1(t, n, o, r) {
            var s, a, l, h, u, c, d, p;
            if (Lo(this, i1), (p = e.call(this)).initTime = new Date, p.itemsDone = !1, !(fc(p) instanceof i1)) throw new SyntaxError("Constructor must be called with the new operator");
            if (!zc(o) && !t_(o) && o instanceof Object) {
                var m = r;
                r = o, o = m;
            }
            r && r.throttleRedraw && console.warn('Timeline option "throttleRedraw" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.');
            var f = fc(p);
            if (p.defaultOptions = {
                autoResize: !0,
                longSelectPressTime: 251,
                orientation: {
                    axis: "bottom",
                    item: "bottom"
                },
                moment: wd
            }, p.options = l_.deepExtend({}, p.defaultOptions), r && l_.setupXSSProtection(r.xss), p._create(t), !r || r && void 0 === r.rtl) {
                var v;
                p.dom.root.style.visibility = "hidden";
                for(var g = p.dom.root; !v && g;)v = window.getComputedStyle(g, null).direction, g = g.parentElement;
                p.options.rtl = v && "rtl" == v.toLowerCase();
            } else p.options.rtl = r.rtl;
            r && (r.rollingMode && (p.options.rollingMode = r.rollingMode), r.onInitialDrawComplete && (p.options.onInitialDrawComplete = r.onInitialDrawComplete), r.onTimeout && (p.options.onTimeout = r.onTimeout), r.loadingScreenTemplate && (p.options.loadingScreenTemplate = r.loadingScreenTemplate));
            var y = document.createElement("div");
            if (p.options.loadingScreenTemplate) {
                var b, w = Hc(b = p.options.loadingScreenTemplate).call(b, fc(p)), k = w(p.dom.loadingScreen);
                k instanceof Object && !(k instanceof Element) ? w(y) : k instanceof Element ? (y.innerHTML = "", y.appendChild(k)) : null != k && (y.innerHTML = l_.xss(k));
            }
            function _(t, e) {
                f.hasListeners(t) && f.emit(t, f.getEventProperties(e));
            }
            return p.dom.loadingScreen.appendChild(y), p.components = [], p.body = {
                dom: p.dom,
                domProps: p.props,
                emitter: {
                    on: Hc(s = p.on).call(s, fc(p)),
                    off: Hc(a = p.off).call(a, fc(p)),
                    emit: Hc(l = p.emit).call(l, fc(p))
                },
                hiddenDates: [],
                util: {
                    getScale: function() {
                        return f.timeAxis.step.scale;
                    },
                    getStep: function() {
                        return f.timeAxis.step.step;
                    },
                    toScreen: Hc(h = f._toScreen).call(h, f),
                    toGlobalScreen: Hc(u = f._toGlobalScreen).call(u, f),
                    toTime: Hc(c = f._toTime).call(c, f),
                    toGlobalTime: Hc(d = f._toGlobalTime).call(d, f)
                }
            }, p.range = new Ax(p.body, p.options), p.components.push(p.range), p.body.range = p.range, p.timeAxis = new Ux(p.body, p.options), p.timeAxis2 = null, p.components.push(p.timeAxis), p.currentTime = new mC(p.body, p.options), p.components.push(p.currentTime), p.itemSet = new iT(p.body, p.options), p.components.push(p.itemSet), p.itemsData = null, p.groupsData = null, p.dom.root.onclick = function(t) {
                _("click", t);
            }, p.dom.root.ondblclick = function(t) {
                _("doubleClick", t);
            }, p.dom.root.oncontextmenu = function(t) {
                _("contextmenu", t);
            }, p.dom.root.onmouseover = function(t) {
                _("mouseOver", t);
            }, window.PointerEvent ? (p.dom.root.onpointerdown = function(t) {
                _("mouseDown", t);
            }, p.dom.root.onpointermove = function(t) {
                _("mouseMove", t);
            }, p.dom.root.onpointerup = function(t) {
                _("mouseUp", t);
            }) : (p.dom.root.onmousemove = function(t) {
                _("mouseMove", t);
            }, p.dom.root.onmousedown = function(t) {
                _("mouseDown", t);
            }, p.dom.root.onmouseup = function(t) {
                _("mouseUp", t);
            }), p.initialFitDone = !1, p.on("changed", function() {
                if (null != f.itemsData) {
                    if (!f.initialFitDone && !f.options.rollingMode) {
                        if (f.initialFitDone = !0, null != f.options.start || null != f.options.end) {
                            if (null == f.options.start || null == f.options.end) var t = f.getItemRange();
                            var e = null != f.options.start ? f.options.start : t.min, i1 = null != f.options.end ? f.options.end : t.max;
                            f.setWindow(e, i1, {
                                animation: !1
                            });
                        } else f.fit({
                            animation: !1
                        });
                    }
                    f.initialDrawDone || !f.initialRangeChangeDone && (f.options.start || f.options.end) && !f.options.rollingMode || (f.initialDrawDone = !0, f.itemSet.initialDrawDone = !0, f.dom.root.style.visibility = "visible", f.dom.loadingScreen.parentNode.removeChild(f.dom.loadingScreen), f.options.onInitialDrawComplete && sd(function() {
                        return f.options.onInitialDrawComplete();
                    }, 0));
                }
            }), p.on("destroyTimeline", function() {
                f.destroy();
            }), r && p.setOptions(r), p.body.emitter.on("fit", function(t) {
                p._onFit(t), p.redraw();
            }), o && p.setGroups(o), n && p.setItems(n), p._redraw(), p;
        }
        return mc(i1, [
            {
                key: "_createConfigurator",
                value: function() {
                    return new yT(this, this.dom.container, fT);
                }
            },
            {
                key: "redraw",
                value: function() {
                    this.itemSet && this.itemSet.markDirty({
                        refreshItems: !0
                    }), this._redraw();
                }
            },
            {
                key: "setOptions",
                value: function(t) {
                    if (!0 === sT.validate(t, mT) && console.log("%cErrors have been found in the supplied options object.", rT), dC.prototype.setOptions.call(this, t), "type" in t && t.type !== this.options.type) {
                        this.options.type = t.type;
                        var e = this.itemsData;
                        if (e) {
                            var i1 = this.getSelection();
                            this.setItems(null), this.setItems(e.rawDS), this.setSelection(i1);
                        }
                    }
                }
            },
            {
                key: "setItems",
                value: function(t) {
                    var e;
                    this.itemsDone = !1, e = t ? t_(t) ? o_(t) : o_(new n.DataSet(t)) : null, this.itemsData && this.itemsData.dispose(), this.itemsData = e, this.itemSet && this.itemSet.setItems(null != e ? e.rawDS : null);
                }
            },
            {
                key: "setGroups",
                value: function(t) {
                    var e;
                    t ? (zc(t) && (t = new n.DataSet(t)), e = new n.DataView(t, {
                        filter: function(t) {
                            return !1 !== t.visible;
                        }
                    })) : e = null, null != this.groupsData && "function" == typeof this.groupsData.setData && this.groupsData.setData(null), this.groupsData = e, this.itemSet.setGroups(e);
                }
            },
            {
                key: "setData",
                value: function(t) {
                    t && t.groups && this.setGroups(t.groups), t && t.items && this.setItems(t.items);
                }
            },
            {
                key: "setSelection",
                value: function(t, e) {
                    this.itemSet && this.itemSet.setSelection(t), e && e.focus && this.focus(t, e);
                }
            },
            {
                key: "getSelection",
                value: function() {
                    return this.itemSet && this.itemSet.getSelection() || [];
                }
            },
            {
                key: "focus",
                value: function(t, e) {
                    if (this.itemsData && null != t) {
                        var i1 = zc(t) ? t : [
                            t
                        ], n = this.itemsData.get(i1), o = null, r = null;
                        if (bd(n).call(n, function(t) {
                            var e = t.start.valueOf(), i1 = "end" in t ? t.end.valueOf() : t.start.valueOf();
                            (null === o || e < o) && (o = e), (null === r || i1 > r) && (r = i1);
                        }), null !== o && null !== r) {
                            var s = this, a = this.itemSet.items[i1[0]], l = -1 * this._getScrollTop(), h = null, u = function() {
                                var t = xT(s, a);
                                t.shouldScroll && t.itemTop != h.itemTop && (s._setScrollTop(-t.scrollOffset), s._redraw());
                            }, c = !e || void 0 === e.zoom || e.zoom, d = (o + r) / 2, p = c ? 1.1 * (r - o) : Math.max(this.range.end - this.range.start, 1.1 * (r - o)), m = !e || void 0 === e.animation || e.animation;
                            m || (h = {
                                shouldScroll: !1,
                                scrollOffset: -1,
                                itemTop: -1
                            }), this.range.setRange(d - p / 2, d + p / 2, {
                                animation: m
                            }, function() {
                                u(), sd(u, 100);
                            }, function(t, e, i1) {
                                var n = xT(s, a);
                                if (!1 !== n && (h || (h = n), h.itemTop != n.itemTop || h.shouldScroll)) {
                                    h.itemTop != n.itemTop && n.shouldScroll && (h = n, l = -1 * s._getScrollTop());
                                    var o = l, r = h.scrollOffset, u = i1 ? r : o + (r - o) * t;
                                    s._setScrollTop(-u), e || s._redraw();
                                }
                            });
                        }
                    }
                }
            },
            {
                key: "fit",
                value: function(t, e) {
                    var i1, n = !t || void 0 === t.animation || t.animation;
                    1 === this.itemsData.length && void 0 === this.itemsData.get()[0].end ? (i1 = this.getDataRange(), this.moveTo(i1.min.valueOf(), {
                        animation: n
                    }, e)) : (i1 = this.getItemRange(), this.range.setRange(i1.min, i1.max, {
                        animation: n
                    }, e));
                }
            },
            {
                key: "getItemRange",
                value: function() {
                    var t = this, e = this.getDataRange(), i1 = null !== e.min ? e.min.valueOf() : null, n = null !== e.max ? e.max.valueOf() : null, o = null, r = null;
                    if (null != i1 && null != n) {
                        var s = n - i1;
                        s <= 0 && (s = 10);
                        var a = s / this.props.center.width, l = {}, h = 0;
                        if (bd(l_).call(l_, this.itemSet.items, function(t, e) {
                            if (t.groupShowing) l[e] = t.redraw(!0), h = l[e].length;
                        }), h > 0) for(var u = function(t) {
                            bd(l_).call(l_, l, function(e) {
                                e[t]();
                            });
                        }, c = 0; c < h; c++)u(c);
                        if (bd(l_).call(l_, this.itemSet.items, function(e) {
                            var s, l, h = kT(e), u = _T(e);
                            t.options.rtl ? (s = h - (e.getWidthRight() + 10) * a, l = u + (e.getWidthLeft() + 10) * a) : (s = h - (e.getWidthLeft() + 10) * a, l = u + (e.getWidthRight() + 10) * a), s < i1 && (i1 = s, o = e), l > n && (n = l, r = e);
                        }), o && r) {
                            var d = o.getWidthLeft() + 10, p = r.getWidthRight() + 10, m = this.props.center.width - d - p;
                            m > 0 && (this.options.rtl ? (i1 = kT(o) - p * s / m, n = _T(r) + d * s / m) : (i1 = kT(o) - d * s / m, n = _T(r) + p * s / m));
                        }
                    }
                    return {
                        min: null != i1 ? new Date(i1) : null,
                        max: null != n ? new Date(n) : null
                    };
                }
            },
            {
                key: "getDataRange",
                value: function() {
                    var t, e = null, i1 = null;
                    this.itemsData && bd(t = this.itemsData).call(t, function(t) {
                        var n = l_.convert(t.start, "Date").valueOf(), o = l_.convert(null != t.end ? t.end : t.start, "Date").valueOf();
                        (null === e || n < e) && (e = n), (null === i1 || o > i1) && (i1 = o);
                    });
                    return {
                        min: null != e ? new Date(e) : null,
                        max: null != i1 ? new Date(i1) : null
                    };
                }
            },
            {
                key: "getEventProperties",
                value: function(t) {
                    var e = t.center ? t.center.x : t.clientX, i1 = t.center ? t.center.y : t.clientY, n = this.dom.centerContainer.getBoundingClientRect(), o = this.options.rtl ? n.right - e : e - n.left, r = i1 - n.top, s = this.itemSet.itemFromTarget(t), a = this.itemSet.groupFromTarget(t), l = cC.customTimeFromTarget(t), h = this.itemSet.options.snap || null, u = this.body.util.getScale(), c = this.body.util.getStep(), d = this._toTime(o), p = h ? h(d, u, c) : d, m = l_.getTarget(t), f = null;
                    return null != s ? f = "item" : null != l ? f = "custom-time" : l_.hasParent(m, this.timeAxis.dom.foreground) || this.timeAxis2 && l_.hasParent(m, this.timeAxis2.dom.foreground) ? f = "axis" : l_.hasParent(m, this.itemSet.dom.labelSet) ? f = "group-label" : l_.hasParent(m, this.currentTime.bar) ? f = "current-time" : l_.hasParent(m, this.dom.center) && (f = "background"), {
                        event: t,
                        item: s ? s.id : null,
                        isCluster: !!s && !!s.isCluster,
                        items: s ? s.items || [] : null,
                        group: a ? a.groupId : null,
                        customTime: l ? l.options.id : null,
                        what: f,
                        pageX: t.srcEvent ? t.srcEvent.pageX : t.pageX,
                        pageY: t.srcEvent ? t.srcEvent.pageY : t.pageY,
                        x: o,
                        y: r,
                        time: d,
                        snappedTime: p
                    };
                }
            },
            {
                key: "toggleRollingMode",
                value: function() {
                    this.range.rolling ? this.range.stopRolling() : (null == this.options.rollingMode && this.setOptions(this.options), this.range.startRolling());
                }
            },
            {
                key: "_redraw",
                value: function() {
                    dC.prototype._redraw.call(this);
                }
            },
            {
                key: "_onFit",
                value: function(t) {
                    var e = t.start, i1 = t.end, n = t.animation;
                    i1 ? this.range.setRange(e, i1, {
                        animation: n
                    }) : this.moveTo(e.valueOf(), {
                        animation: n
                    });
                }
            }
        ]), i1;
    }(dC);
    function kT(t) {
        return l_.convert(t.data.start, "Date").valueOf();
    }
    function _T(t) {
        var e = null != t.data.end ? t.data.end : t.data.start;
        return l_.convert(e, "Date").valueOf();
    }
    function xT(t, e) {
        if (!e.parent) return !1;
        var i1 = t.options.rtl ? t.props.rightContainer.height : t.props.leftContainer.height, n = t.props.center.height, o = e.parent, r = o.top, s = !0, a = t.timeAxis.options.orientation.axis, l = function() {
            return "bottom" == a ? o.height - e.top - e.height : e.top;
        }, h = -1 * t._getScrollTop(), u = r + l(), c = e.height;
        return u < h ? r + i1 <= r + l() + c && (r += l() - t.itemSet.options.margin.item.vertical) : u + c > h + i1 ? r += l() + c - i1 + t.itemSet.options.margin.item.vertical : s = !1, {
            shouldScroll: s,
            scrollOffset: r = Math.min(r, n - i1),
            itemTop: u
        };
    }
    function CT(t) {
        for(var e in t)t.hasOwnProperty(e) && (t[e].redundant = t[e].used, t[e].used = []);
    }
    function ST(t) {
        for(var e in t)if (t.hasOwnProperty(e) && t[e].redundant) {
            for(var i1 = 0; i1 < t[e].redundant.length; i1++)t[e].redundant[i1].parentNode.removeChild(t[e].redundant[i1]);
            t[e].redundant = [];
        }
    }
    function DT(t, e, i1) {
        var n;
        return e.hasOwnProperty(t) ? e[t].redundant.length > 0 ? (n = e[t].redundant[0], e[t].redundant.shift()) : (n = document.createElementNS("http://www.w3.org/2000/svg", t), i1.appendChild(n)) : (n = document.createElementNS("http://www.w3.org/2000/svg", t), e[t] = {
            used: [],
            redundant: []
        }, i1.appendChild(n)), e[t].used.push(n), n;
    }
    function TT(t, e, i1, n) {
        var o;
        return e.hasOwnProperty(t) ? e[t].redundant.length > 0 ? (o = e[t].redundant[0], e[t].redundant.shift()) : (o = document.createElement(t), void 0 !== n ? i1.insertBefore(o, n) : i1.appendChild(o)) : (o = document.createElement(t), e[t] = {
            used: [],
            redundant: []
        }, void 0 !== n ? i1.insertBefore(o, n) : i1.appendChild(o)), e[t].used.push(o), o;
    }
    function ET(t, e, i1, n, o, r) {
        var s;
        if ("circle" == i1.style ? ((s = DT("circle", n, o)).setAttributeNS(null, "cx", t), s.setAttributeNS(null, "cy", e), s.setAttributeNS(null, "r", .5 * i1.size)) : ((s = DT("rect", n, o)).setAttributeNS(null, "x", t - .5 * i1.size), s.setAttributeNS(null, "y", e - .5 * i1.size), s.setAttributeNS(null, "width", i1.size), s.setAttributeNS(null, "height", i1.size)), void 0 !== i1.styles && s.setAttributeNS(null, "style", i1.styles), s.setAttributeNS(null, "class", i1.className + " vis-point"), r) {
            var a = DT("text", n, o);
            r.xOffset && (t += r.xOffset), r.yOffset && (e += r.yOffset), r.content && (a.textContent = r.content), r.className && a.setAttributeNS(null, "class", r.className + " vis-label"), a.setAttributeNS(null, "x", t), a.setAttributeNS(null, "y", e);
        }
        return s;
    }
    function OT(t, e, i1, n, o, r, s, a) {
        if (0 != n) {
            n < 0 && (e -= n *= -1);
            var l = DT("rect", r, s);
            l.setAttributeNS(null, "x", t - .5 * i1), l.setAttributeNS(null, "y", e), l.setAttributeNS(null, "width", i1), l.setAttributeNS(null, "height", n), l.setAttributeNS(null, "class", o), a && l.setAttributeNS(null, "style", a);
        }
    }
    var AT = function() {
        function t(e, i1, n, o, r, s) {
            var a = arguments.length > 6 && void 0 !== arguments[6] && arguments[6], l = arguments.length > 7 && void 0 !== arguments[7] && arguments[7];
            if (Lo(this, t), this.majorSteps = [
                1,
                2,
                5,
                10
            ], this.minorSteps = [
                .25,
                .5,
                1,
                2
            ], this.customLines = null, this.containerHeight = r, this.majorCharHeight = s, this._start = e, this._end = i1, this.scale = 1, this.minorStepIdx = -1, this.magnitudefactor = 1, this.determineScale(), this.zeroAlign = a, this.autoScaleStart = n, this.autoScaleEnd = o, this.formattingFunction = l, n || o) {
                var h = this, u = function(t) {
                    var e = t - t % (h.magnitudefactor * h.minorSteps[h.minorStepIdx]);
                    return t % (h.magnitudefactor * h.minorSteps[h.minorStepIdx]) > h.magnitudefactor * h.minorSteps[h.minorStepIdx] * .5 ? e + h.magnitudefactor * h.minorSteps[h.minorStepIdx] : e;
                };
                n && (this._start -= 2 * this.magnitudefactor * this.minorSteps[this.minorStepIdx], this._start = u(this._start)), o && (this._end += this.magnitudefactor * this.minorSteps[this.minorStepIdx], this._end = u(this._end)), this.determineScale();
            }
        }
        return mc(t, [
            {
                key: "setCharHeight",
                value: function(t) {
                    this.majorCharHeight = t;
                }
            },
            {
                key: "setHeight",
                value: function(t) {
                    this.containerHeight = t;
                }
            },
            {
                key: "determineScale",
                value: function() {
                    var t = this._end - this._start;
                    this.scale = this.containerHeight / t;
                    var e = this.majorCharHeight / this.scale, i1 = t > 0 ? Math.round(Math.log(t) / Math.LN10) : 0;
                    this.minorStepIdx = -1, this.magnitudefactor = Math.pow(10, i1);
                    var n = 0;
                    i1 < 0 && (n = i1);
                    for(var o = !1, r = n; Math.abs(r) <= Math.abs(i1); r++){
                        this.magnitudefactor = Math.pow(10, r);
                        for(var s = 0; s < this.minorSteps.length; s++)if (this.magnitudefactor * this.minorSteps[s] >= e) {
                            o = !0, this.minorStepIdx = s;
                            break;
                        }
                        if (!0 === o) break;
                    }
                }
            },
            {
                key: "is_major",
                value: function(t) {
                    return t % (this.magnitudefactor * this.majorSteps[this.minorStepIdx]) == 0;
                }
            },
            {
                key: "getStep",
                value: function() {
                    return this.magnitudefactor * this.minorSteps[this.minorStepIdx];
                }
            },
            {
                key: "getFirstMajor",
                value: function() {
                    var t = this.magnitudefactor * this.majorSteps[this.minorStepIdx];
                    return this.convertValue(this._start + (t - this._start % t) % t);
                }
            },
            {
                key: "formatValue",
                value: function(t) {
                    var e = t.toPrecision(5);
                    return "function" == typeof this.formattingFunction && (e = this.formattingFunction(t)), "number" == typeof e ? "".concat(e) : "string" == typeof e ? e : t.toPrecision(5);
                }
            },
            {
                key: "getLines",
                value: function() {
                    for(var t = [], e = this.getStep(), i1 = (e - this._start % e) % e, n = this._start + i1; this._end - n > 1e-5; n += e)n != this._start && t.push({
                        major: this.is_major(n),
                        y: this.convertValue(n),
                        val: this.formatValue(n)
                    });
                    return t;
                }
            },
            {
                key: "followScale",
                value: function(t) {
                    var e = this.minorStepIdx, i1 = this._start, n = this._end, o = this, r = function() {
                        o.magnitudefactor *= 2;
                    }, s = function() {
                        o.magnitudefactor /= 2;
                    };
                    t.minorStepIdx <= 1 && this.minorStepIdx <= 1 || t.minorStepIdx > 1 && this.minorStepIdx > 1 || (t.minorStepIdx < this.minorStepIdx ? (this.minorStepIdx = 1, 2 == e || r(), r()) : (this.minorStepIdx = 2, 1 == e || s(), s()));
                    for(var a = t.convertValue(0), l = t.getStep() * t.scale, h = !1, u = 0; !h && u++ < 5;){
                        this.scale = l / (this.minorSteps[this.minorStepIdx] * this.magnitudefactor);
                        var c = this.containerHeight / this.scale;
                        this._start = i1, this._end = this._start + c;
                        var d = this._end * this.scale, p = this.magnitudefactor * this.majorSteps[this.minorStepIdx], m = this.getFirstMajor() - t.getFirstMajor();
                        if (this.zeroAlign) {
                            var f = a - d;
                            this._end += f / this.scale, this._start = this._end - c;
                        } else this.autoScaleStart ? (this._start -= m / this.scale, this._end = this._start + c) : (this._start += p - m / this.scale, this._end = this._start + c);
                        if (!this.autoScaleEnd && this._end > n + 1e-5) s(), h = !1;
                        else {
                            if (!this.autoScaleStart && this._start < i1 - 1e-5) {
                                if (!(this.zeroAlign && i1 >= 0)) {
                                    s(), h = !1;
                                    continue;
                                }
                                console.warn("Can't adhere to given 'min' range, due to zeroalign");
                            }
                            this.autoScaleStart && this.autoScaleEnd && c < n - i1 ? (r(), h = !1) : h = !0;
                        }
                    }
                }
            },
            {
                key: "convertValue",
                value: function(t) {
                    return this.containerHeight - (t - this._start) * this.scale;
                }
            },
            {
                key: "screenToValue",
                value: function(t) {
                    return (this.containerHeight - t) / this.scale + this._start;
                }
            }
        ]), t;
    }();
    function IT(t, e) {
        var i1 = void 0 !== lf && ym(t) || t["@@iterator"];
        if (!i1) {
            if (zc(t) || (i1 = function(t, e) {
                var i1;
                if (!t) return;
                if ("string" == typeof t) return PT(t, e);
                var n = ff(i1 = Object.prototype.toString.call(t)).call(i1, 8, -1);
                "Object" === n && t.constructor && (n = t.constructor.name);
                if ("Map" === n || "Set" === n) return fm(t);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PT(t, e);
            }(t)) || e && t && "number" == typeof t.length) {
                i1 && (t = i1);
                var n = 0, o = function() {};
                return {
                    s: o,
                    n: function() {
                        return n >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[n++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: o
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var r, s = !0, a = !1;
        return {
            s: function() {
                i1 = i1.call(t);
            },
            n: function() {
                var t = i1.next();
                return s = t.done, t;
            },
            e: function(t) {
                a = !0, r = t;
            },
            f: function() {
                try {
                    s || null == i1.return || i1.return();
                } finally{
                    if (a) throw r;
                }
            }
        };
    }
    function PT(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var i1 = 0, n = new Array(e); i1 < e; i1++)n[i1] = t[i1];
        return n;
    }
    function MT(t) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Ro) return !1;
            if (Ro.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Ro(Boolean, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function() {
            var i1, n = jc(t);
            if (e) {
                var o = jc(this).constructor;
                i1 = Ro(n, arguments, o);
            } else i1 = n.apply(this, arguments);
            return Pc(this, i1);
        };
    }
    var NT = function(t) {
        Ic(i1, t);
        var e = MT(i1);
        function i1(t, n, o, r) {
            var s;
            Lo(this, i1), (s = e.call(this)).id = Zk(), s.body = t, s.defaultOptions = {
                orientation: "left",
                showMinorLabels: !0,
                showMajorLabels: !0,
                showWeekScale: !1,
                icons: !1,
                majorLinesOffset: 7,
                minorLinesOffset: 4,
                labelOffsetX: 10,
                labelOffsetY: 2,
                iconWidth: 20,
                width: "40px",
                visible: !0,
                alignZeros: !0,
                left: {
                    range: {
                        min: void 0,
                        max: void 0
                    },
                    format: function(t) {
                        return "".concat(b_(t.toPrecision(3)));
                    },
                    title: {
                        text: void 0,
                        style: void 0
                    }
                },
                right: {
                    range: {
                        min: void 0,
                        max: void 0
                    },
                    format: function(t) {
                        return "".concat(b_(t.toPrecision(3)));
                    },
                    title: {
                        text: void 0,
                        style: void 0
                    }
                }
            }, s.linegraphOptions = r, s.linegraphSVG = o, s.props = {}, s.DOMelements = {
                lines: {},
                labels: {},
                title: {}
            }, s.dom = {}, s.scale = void 0, s.range = {
                start: 0,
                end: 0
            }, s.options = l_.extend({}, s.defaultOptions), s.conversionFactor = 1, s.setOptions(n), s.width = Number("".concat(s.options.width).replace("px", "")), s.minWidth = s.width, s.height = s.linegraphSVG.getBoundingClientRect().height, s.hidden = !1, s.stepPixels = 25, s.zeroCrossing = -1, s.amountOfSteps = -1, s.lineOffset = 0, s.master = !0, s.masterAxis = null, s.svgElements = {}, s.iconsRemoved = !1, s.groups = {}, s.amountOfGroups = 0, s._create(), null == s.scale && s._redrawLabels(), s.framework = {
                svg: s.svg,
                svgElements: s.svgElements,
                options: s.options,
                groups: s.groups
            };
            var a = fc(s);
            return s.body.emitter.on("verticalDrag", function() {
                a.dom.lineContainer.style.top = "".concat(a.body.domProps.scrollTop, "px");
            }), s;
        }
        return mc(i1, [
            {
                key: "addGroup",
                value: function(t, e) {
                    this.groups.hasOwnProperty(t) || (this.groups[t] = e), this.amountOfGroups += 1;
                }
            },
            {
                key: "updateGroup",
                value: function(t, e) {
                    this.groups.hasOwnProperty(t) || (this.amountOfGroups += 1), this.groups[t] = e;
                }
            },
            {
                key: "removeGroup",
                value: function(t) {
                    this.groups.hasOwnProperty(t) && (delete this.groups[t], this.amountOfGroups -= 1);
                }
            },
            {
                key: "setOptions",
                value: function(t) {
                    if (t) {
                        var e = !1;
                        this.options.orientation != t.orientation && void 0 !== t.orientation && (e = !0);
                        l_.selectiveDeepExtend([
                            "orientation",
                            "showMinorLabels",
                            "showMajorLabels",
                            "icons",
                            "majorLinesOffset",
                            "minorLinesOffset",
                            "labelOffsetX",
                            "labelOffsetY",
                            "iconWidth",
                            "width",
                            "visible",
                            "left",
                            "right",
                            "alignZeros"
                        ], this.options, t), this.minWidth = Number("".concat(this.options.width).replace("px", "")), !0 === e && this.dom.frame && (this.hide(), this.show());
                    }
                }
            },
            {
                key: "_create",
                value: function() {
                    this.dom.frame = document.createElement("div"), this.dom.frame.style.width = this.options.width, this.dom.frame.style.height = this.height, this.dom.lineContainer = document.createElement("div"), this.dom.lineContainer.style.width = "100%", this.dom.lineContainer.style.height = this.height, this.dom.lineContainer.style.position = "relative", this.dom.lineContainer.style.visibility = "visible", this.dom.lineContainer.style.display = "block", this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.svg.style.position = "absolute", this.svg.style.top = "0px", this.svg.style.height = "100%", this.svg.style.width = "100%", this.svg.style.display = "block", this.dom.frame.appendChild(this.svg);
                }
            },
            {
                key: "_redrawGroupIcons",
                value: function() {
                    var t;
                    CT(this.svgElements);
                    var e = this.options.iconWidth, i1 = 11.5;
                    t = "left" === this.options.orientation ? 4 : this.width - e - 4;
                    var n = Dp(this.groups);
                    mx(n).call(n, function(t, e) {
                        return t < e ? -1 : 1;
                    });
                    var o, r = IT(n);
                    try {
                        for(r.s(); !(o = r.n()).done;){
                            var s = o.value;
                            !0 !== this.groups[s].visible || void 0 !== this.linegraphOptions.visibility[s] && !0 !== this.linegraphOptions.visibility[s] || (this.groups[s].getLegend(e, 15, this.framework, t, i1), i1 += 19);
                        }
                    } catch (t) {
                        r.e(t);
                    } finally{
                        r.f();
                    }
                    ST(this.svgElements), this.iconsRemoved = !1;
                }
            },
            {
                key: "_cleanupIcons",
                value: function() {
                    !1 === this.iconsRemoved && (CT(this.svgElements), ST(this.svgElements), this.iconsRemoved = !0);
                }
            },
            {
                key: "show",
                value: function() {
                    this.hidden = !1, this.dom.frame.parentNode || ("left" === this.options.orientation ? this.body.dom.left.appendChild(this.dom.frame) : this.body.dom.right.appendChild(this.dom.frame)), this.dom.lineContainer.parentNode || this.body.dom.backgroundHorizontal.appendChild(this.dom.lineContainer), this.dom.lineContainer.style.display = "block";
                }
            },
            {
                key: "hide",
                value: function() {
                    this.hidden = !0, this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame), this.dom.lineContainer.style.display = "none";
                }
            },
            {
                key: "setRange",
                value: function(t, e) {
                    this.range.start = t, this.range.end = e;
                }
            },
            {
                key: "redraw",
                value: function() {
                    var t = !1, e = 0;
                    for(var i1 in this.dom.lineContainer.style.top = "".concat(this.body.domProps.scrollTop, "px"), this.groups)this.groups.hasOwnProperty(i1) && (!0 !== this.groups[i1].visible || void 0 !== this.linegraphOptions.visibility[i1] && !0 !== this.linegraphOptions.visibility[i1] || e++);
                    if (0 === this.amountOfGroups || 0 === e) this.hide();
                    else {
                        this.show(), this.height = Number(this.linegraphSVG.style.height.replace("px", "")), this.dom.lineContainer.style.height = "".concat(this.height, "px"), this.width = !0 === this.options.visible ? Number("".concat(this.options.width).replace("px", "")) : 0;
                        var n = this.props, o = this.dom.frame;
                        o.className = "vis-data-axis", this._calculateCharSize();
                        var r = this.options.orientation, s = this.options.showMinorLabels, a = this.options.showMajorLabels, l = this.body.dom.backgroundHorizontal.offsetWidth;
                        n.minorLabelHeight = s ? n.minorCharHeight : 0, n.majorLabelHeight = a ? n.majorCharHeight : 0, n.minorLineWidth = l - this.lineOffset - this.width + 2 * this.options.minorLinesOffset, n.minorLineHeight = 1, n.majorLineWidth = l - this.lineOffset - this.width + 2 * this.options.majorLinesOffset, n.majorLineHeight = 1, "left" === r ? (o.style.top = "0", o.style.left = "0", o.style.bottom = "", o.style.width = "".concat(this.width, "px"), o.style.height = "".concat(this.height, "px"), this.props.width = this.body.domProps.left.width, this.props.height = this.body.domProps.left.height) : (o.style.top = "", o.style.bottom = "0", o.style.left = "0", o.style.width = "".concat(this.width, "px"), o.style.height = "".concat(this.height, "px"), this.props.width = this.body.domProps.right.width, this.props.height = this.body.domProps.right.height), t = this._redrawLabels(), t = this._isResized() || t, !0 === this.options.icons ? this._redrawGroupIcons() : this._cleanupIcons(), this._redrawTitle(r);
                    }
                    return t;
                }
            },
            {
                key: "_redrawLabels",
                value: function() {
                    var t = this, e = !1;
                    CT(this.DOMelements.lines), CT(this.DOMelements.labels);
                    var i1 = this.options.orientation, n = null != this.options[i1].range ? this.options[i1].range : {}, o = !0;
                    null != n.max && (this.range.end = n.max, o = !1);
                    var r = !0;
                    null != n.min && (this.range.start = n.min, r = !1), this.scale = new AT(this.range.start, this.range.end, r, o, this.dom.frame.offsetHeight, this.props.majorCharHeight, this.options.alignZeros, this.options[i1].format), !1 === this.master && null != this.masterAxis ? (this.scale.followScale(this.masterAxis.scale), this.dom.lineContainer.style.display = "none") : this.dom.lineContainer.style.display = "block", this.maxLabelSize = 0;
                    var s = this.scale.getLines();
                    bd(s).call(s, function(e) {
                        var n = e.y, o = e.major;
                        t.options.showMinorLabels && !1 === o && t._redrawLabel(n - 2, e.val, i1, "vis-y-axis vis-minor", t.props.minorCharHeight), o && n >= 0 && t._redrawLabel(n - 2, e.val, i1, "vis-y-axis vis-major", t.props.majorCharHeight), !0 === t.master && (o ? t._redrawLine(n, i1, "vis-grid vis-horizontal vis-major", t.options.majorLinesOffset, t.props.majorLineWidth) : t._redrawLine(n, i1, "vis-grid vis-horizontal vis-minor", t.options.minorLinesOffset, t.props.minorLineWidth));
                    });
                    var a = 0;
                    void 0 !== this.options[i1].title && void 0 !== this.options[i1].title.text && (a = this.props.titleCharHeight);
                    var l = !0 === this.options.icons ? Math.max(this.options.iconWidth, a) + this.options.labelOffsetX + 15 : a + this.options.labelOffsetX + 15;
                    return this.maxLabelSize > this.width - l && !0 === this.options.visible ? (this.width = this.maxLabelSize + l, this.options.width = "".concat(this.width, "px"), ST(this.DOMelements.lines), ST(this.DOMelements.labels), this.redraw(), e = !0) : this.maxLabelSize < this.width - l && !0 === this.options.visible && this.width > this.minWidth ? (this.width = Math.max(this.minWidth, this.maxLabelSize + l), this.options.width = "".concat(this.width, "px"), ST(this.DOMelements.lines), ST(this.DOMelements.labels), this.redraw(), e = !0) : (ST(this.DOMelements.lines), ST(this.DOMelements.labels), e = !1), e;
                }
            },
            {
                key: "convertValue",
                value: function(t) {
                    return this.scale.convertValue(t);
                }
            },
            {
                key: "screenToValue",
                value: function(t) {
                    return this.scale.screenToValue(t);
                }
            },
            {
                key: "_redrawLabel",
                value: function(t, e, i1, n, o) {
                    var r = TT("div", this.DOMelements.labels, this.dom.frame);
                    r.className = n, r.innerHTML = l_.xss(e), "left" === i1 ? (r.style.left = "-".concat(this.options.labelOffsetX, "px"), r.style.textAlign = "right") : (r.style.right = "-".concat(this.options.labelOffsetX, "px"), r.style.textAlign = "left"), r.style.top = "".concat(t - .5 * o + this.options.labelOffsetY, "px"), e += "";
                    var s = Math.max(this.props.majorCharWidth, this.props.minorCharWidth);
                    this.maxLabelSize < e.length * s && (this.maxLabelSize = e.length * s);
                }
            },
            {
                key: "_redrawLine",
                value: function(t, e, i1, n, o) {
                    if (!0 === this.master) {
                        var r = TT("div", this.DOMelements.lines, this.dom.lineContainer);
                        r.className = i1, r.innerHTML = "", "left" === e ? r.style.left = "".concat(this.width - n, "px") : r.style.right = "".concat(this.width - n, "px"), r.style.width = "".concat(o, "px"), r.style.top = "".concat(t, "px");
                    }
                }
            },
            {
                key: "_redrawTitle",
                value: function(t) {
                    if (CT(this.DOMelements.title), void 0 !== this.options[t].title && void 0 !== this.options[t].title.text) {
                        var e = TT("div", this.DOMelements.title, this.dom.frame);
                        e.className = "vis-y-axis vis-title vis-".concat(t), e.innerHTML = l_.xss(this.options[t].title.text), void 0 !== this.options[t].title.style && l_.addCssText(e, this.options[t].title.style), "left" === t ? e.style.left = "".concat(this.props.titleCharHeight, "px") : e.style.right = "".concat(this.props.titleCharHeight, "px"), e.style.width = "".concat(this.height, "px");
                    }
                    ST(this.DOMelements.title);
                }
            },
            {
                key: "_calculateCharSize",
                value: function() {
                    if (!("minorCharHeight" in this.props)) {
                        var t = document.createTextNode("0"), e = document.createElement("div");
                        e.className = "vis-y-axis vis-minor vis-measure", e.appendChild(t), this.dom.frame.appendChild(e), this.props.minorCharHeight = e.clientHeight, this.props.minorCharWidth = e.clientWidth, this.dom.frame.removeChild(e);
                    }
                    if (!("majorCharHeight" in this.props)) {
                        var i1 = document.createTextNode("0"), n = document.createElement("div");
                        n.className = "vis-y-axis vis-major vis-measure", n.appendChild(i1), this.dom.frame.appendChild(n), this.props.majorCharHeight = n.clientHeight, this.props.majorCharWidth = n.clientWidth, this.dom.frame.removeChild(n);
                    }
                    if (!("titleCharHeight" in this.props)) {
                        var o = document.createTextNode("0"), r = document.createElement("div");
                        r.className = "vis-y-axis vis-title vis-measure", r.appendChild(o), this.dom.frame.appendChild(r), this.props.titleCharHeight = r.clientHeight, this.props.titleCharWidth = r.clientWidth, this.dom.frame.removeChild(r);
                    }
                }
            }
        ]), i1;
    }(w_);
    function FT(t, e) {}
    function RT(t, e) {
        return {
            style: (e = void 0 === e ? {} : e).style || t.options.drawPoints.style,
            styles: e.styles || t.options.drawPoints.styles,
            size: e.size || t.options.drawPoints.size,
            className: e.className || t.className
        };
    }
    function LT(t, e) {}
    function jT(t, e) {}
    function BT(t, e, i1, n) {
        this.id = e;
        this.options = l_.selectiveBridgeObject([
            "sampling",
            "style",
            "sort",
            "yAxisOrientation",
            "barChart",
            "drawPoints",
            "shaded",
            "interpolation",
            "zIndex",
            "excludeFromStacking",
            "excludeFromLegend"
        ], i1), this.usingDefaultStyle = void 0 === t.className, this.groupsUsingDefaultStyles = n, this.zeroPosition = 0, this.update(t), 1 == this.usingDefaultStyle && (this.groupsUsingDefaultStyles[0] += 1), this.itemsData = [], this.visible = void 0 === t.visible || t.visible;
    }
    function zT(t, e, i1, n) {
        this.body = t, this.defaultOptions = {
            enabled: !1,
            icons: !0,
            iconSize: 20,
            iconSpacing: 6,
            left: {
                visible: !0,
                position: "top-left"
            },
            right: {
                visible: !0,
                position: "top-right"
            }
        }, this.side = i1, this.options = l_.extend({}, this.defaultOptions), this.linegraphOptions = n, this.svgElements = {}, this.dom = {}, this.groups = {}, this.amountOfGroups = 0, this._create(), this.framework = {
            svg: this.svg,
            svgElements: this.svgElements,
            options: this.options,
            groups: this.groups
        }, this.setOptions(e);
    }
    FT.draw = function(t, e, i1, n) {
        n = n || 0;
        for(var o = function(t, e) {
            var i1 = void 0;
            t.options && t.options.drawPoints && t.options.drawPoints.onRender && "function" == typeof t.options.drawPoints.onRender && (i1 = t.options.drawPoints.onRender);
            e.group.options && e.group.options.drawPoints && e.group.options.drawPoints.onRender && "function" == typeof e.group.options.drawPoints.onRender && (i1 = e.group.options.drawPoints.onRender);
            return i1;
        }(i1, e), r = 0; r < t.length; r++)if (o) {
            var s = o(t[r], e);
            !0 !== s && "object" !== uc(s) || ET(t[r].screen_x + n, t[r].screen_y, RT(e, s), i1.svgElements, i1.svg, t[r].label);
        } else ET(t[r].screen_x + n, t[r].screen_y, RT(e), i1.svgElements, i1.svg, t[r].label);
    }, FT.drawIcon = function(t, e, i1, n, o, r) {
        var s = .5 * o, a = DT("rect", r.svgElements, r.svg);
        a.setAttributeNS(null, "x", e), a.setAttributeNS(null, "y", i1 - s), a.setAttributeNS(null, "width", n), a.setAttributeNS(null, "height", 2 * s), a.setAttributeNS(null, "class", "vis-outline"), ET(e + .5 * n, i1, RT(t), r.svgElements, r.svg);
    }, LT.drawIcon = function(t, e, i1, n, o, r) {
        var s = .5 * o, a = DT("rect", r.svgElements, r.svg);
        a.setAttributeNS(null, "x", e), a.setAttributeNS(null, "y", i1 - s), a.setAttributeNS(null, "width", n), a.setAttributeNS(null, "height", 2 * s), a.setAttributeNS(null, "class", "vis-outline");
        var l = Math.round(.3 * n), h = t.options.barChart.width / l, u = Math.round(.4 * o), c = Math.round(.75 * o), d = Math.round((n - 2 * l) / 3);
        if (OT(e + .5 * l + d, i1 + s - u - 1, l, u, t.className + " vis-bar", r.svgElements, r.svg, t.style), OT(e + 1.5 * l + d + 2, i1 + s - c - 1, l, c, t.className + " vis-bar", r.svgElements, r.svg, t.style), 1 == t.options.drawPoints.enabled) {
            var p = {
                style: t.options.drawPoints.style,
                styles: t.options.drawPoints.styles,
                size: t.options.drawPoints.size / h,
                className: t.className
            };
            ET(e + .5 * l + d, i1 + s - u - 1, p, r.svgElements, r.svg), ET(e + 1.5 * l + d + 2, i1 + s - c - 1, p, r.svgElements, r.svg);
        }
    }, LT.draw = function(t, e, i1) {
        var n, o, r, s, a, l, h = [], u = {}, c = 0;
        for(a = 0; a < t.length; a++)if ("bar" === (s = i1.groups[t[a]]).options.style && !0 === s.visible && (void 0 === i1.options.groups.visibility[t[a]] || !0 === i1.options.groups.visibility[t[a]])) for(l = 0; l < e[t[a]].length; l++)h.push({
            screen_x: e[t[a]][l].screen_x,
            screen_end: e[t[a]][l].screen_end,
            screen_y: e[t[a]][l].screen_y,
            x: e[t[a]][l].x,
            end: e[t[a]][l].end,
            y: e[t[a]][l].y,
            groupId: t[a],
            label: e[t[a]][l].label
        }), c += 1;
        if (0 !== c) for(mx(h).call(h, function(t, e) {
            return t.screen_x === e.screen_x ? t.groupId < e.groupId ? -1 : 1 : t.screen_x - e.screen_x;
        }), LT._getDataIntersections(u, h), a = 0; a < h.length; a++){
            var d = null != (s = i1.groups[h[a].groupId]).options.barChart.minWidth ? s.options.barChart.minWidth : .1 * s.options.barChart.width, p = 0;
            if (void 0 === u[o = h[a].screen_x]) a + 1 < h.length && (n = Math.abs(h[a + 1].screen_x - o)), r = LT._getSafeDrawData(n, s, d);
            else {
                var m = a + (u[o].amount - u[o].resolved);
                m < h.length && (n = Math.abs(h[m].screen_x - o)), r = LT._getSafeDrawData(n, s, d), u[o].resolved += 1, !0 === s.options.stack && !0 !== s.options.excludeFromStacking ? h[a].screen_y < s.zeroPosition ? (p = u[o].accumulatedNegative, u[o].accumulatedNegative += s.zeroPosition - h[a].screen_y) : (p = u[o].accumulatedPositive, u[o].accumulatedPositive += s.zeroPosition - h[a].screen_y) : !0 === s.options.barChart.sideBySide && (r.width = r.width / u[o].amount, r.offset += u[o].resolved * r.width - .5 * r.width * (u[o].amount + 1));
            }
            var f = r.width, v = h[a].screen_x;
            if (null != h[a].screen_end ? v += .5 * (f = h[a].screen_end - h[a].screen_x) : v += r.offset, OT(v, h[a].screen_y - p, f, s.zeroPosition - h[a].screen_y, s.className + " vis-bar", i1.svgElements, i1.svg, s.style), !0 === s.options.drawPoints.enabled) {
                var g = {
                    screen_x: h[a].screen_x,
                    screen_y: h[a].screen_y - p,
                    x: h[a].x,
                    y: h[a].y,
                    groupId: h[a].groupId,
                    label: h[a].label
                };
                FT.draw([
                    g
                ], s, i1, r.offset);
            }
        }
    }, LT._getDataIntersections = function(t, e) {
        for(var i1, n = 0; n < e.length; n++)n + 1 < e.length && (i1 = Math.abs(e[n + 1].screen_x - e[n].screen_x)), n > 0 && (i1 = Math.min(i1, Math.abs(e[n - 1].screen_x - e[n].screen_x))), 0 === i1 && (void 0 === t[e[n].screen_x] && (t[e[n].screen_x] = {
            amount: 0,
            resolved: 0,
            accumulatedPositive: 0,
            accumulatedNegative: 0
        }), t[e[n].screen_x].amount += 1);
    }, LT._getSafeDrawData = function(t, e, i1) {
        var n, o;
        return t < e.options.barChart.width && t > 0 ? (n = t < i1 ? i1 : t, o = 0, "left" === e.options.barChart.align ? o -= .5 * t : "right" === e.options.barChart.align && (o += .5 * t)) : (n = e.options.barChart.width, o = 0, "left" === e.options.barChart.align ? o -= .5 * e.options.barChart.width : "right" === e.options.barChart.align && (o += .5 * e.options.barChart.width)), {
            width: n,
            offset: o
        };
    }, LT.getStackedYRange = function(t, e, i1, n, o) {
        if (t.length > 0) {
            mx(t).call(t, function(t, e) {
                return t.screen_x === e.screen_x ? t.groupId < e.groupId ? -1 : 1 : t.screen_x - e.screen_x;
            });
            var r = {};
            LT._getDataIntersections(r, t), e[n] = LT._getStackedYRange(r, t), e[n].yAxisOrientation = o, i1.push(n);
        }
    }, LT._getStackedYRange = function(t, e) {
        for(var i1, n = e[0].screen_y, o = e[0].screen_y, r = 0; r < e.length; r++)void 0 === t[i1 = e[r].screen_x] ? (n = n > e[r].screen_y ? e[r].screen_y : n, o = o < e[r].screen_y ? e[r].screen_y : o) : e[r].screen_y < 0 ? t[i1].accumulatedNegative += e[r].screen_y : t[i1].accumulatedPositive += e[r].screen_y;
        for(var s in t)t.hasOwnProperty(s) && (n = (n = n > t[s].accumulatedNegative ? t[s].accumulatedNegative : n) > t[s].accumulatedPositive ? t[s].accumulatedPositive : n, o = (o = o < t[s].accumulatedNegative ? t[s].accumulatedNegative : o) < t[s].accumulatedPositive ? t[s].accumulatedPositive : o);
        return {
            min: n,
            max: o
        };
    }, jT.calcPath = function(t, e) {
        if (null != t && t.length > 0) return 1 == e.options.interpolation.enabled ? jT._catmullRom(t, e) : jT._linear(t);
    }, jT.drawIcon = function(t, e, i1, n, o, r) {
        var s, a, l = .5 * o, h = DT("rect", r.svgElements, r.svg);
        (h.setAttributeNS(null, "x", e), h.setAttributeNS(null, "y", i1 - l), h.setAttributeNS(null, "width", n), h.setAttributeNS(null, "height", 2 * l), h.setAttributeNS(null, "class", "vis-outline"), (s = DT("path", r.svgElements, r.svg)).setAttributeNS(null, "class", t.className), void 0 !== t.style && s.setAttributeNS(null, "style", t.style), s.setAttributeNS(null, "d", "M" + e + "," + i1 + " L" + (e + n) + "," + i1), 1 == t.options.shaded.enabled && (a = DT("path", r.svgElements, r.svg), "top" == t.options.shaded.orientation ? a.setAttributeNS(null, "d", "M" + e + ", " + (i1 - l) + "L" + e + "," + i1 + " L" + (e + n) + "," + i1 + " L" + (e + n) + "," + (i1 - l)) : a.setAttributeNS(null, "d", "M" + e + "," + i1 + " L" + e + "," + (i1 + l) + " L" + (e + n) + "," + (i1 + l) + "L" + (e + n) + "," + i1), a.setAttributeNS(null, "class", t.className + " vis-icon-fill"), void 0 !== t.options.shaded.style && "" !== t.options.shaded.style && a.setAttributeNS(null, "style", t.options.shaded.style)), 1 == t.options.drawPoints.enabled) && ET(e + .5 * n, i1, {
            style: t.options.drawPoints.style,
            styles: t.options.drawPoints.styles,
            size: t.options.drawPoints.size,
            className: t.className
        }, r.svgElements, r.svg);
    }, jT.drawShading = function(t, e, i1, n) {
        if (1 == e.options.shaded.enabled) {
            var o, r = Number(n.svg.style.height.replace("px", "")), s = DT("path", n.svgElements, n.svg), a = "L";
            1 == e.options.interpolation.enabled && (a = "C");
            var l = 0;
            l = "top" == e.options.shaded.orientation ? 0 : "bottom" == e.options.shaded.orientation ? r : Math.min(Math.max(0, e.zeroPosition), r), o = "group" == e.options.shaded.orientation && null != i1 && null != i1 ? "M" + t[0][0] + "," + t[0][1] + " " + this.serializePath(t, a, !1) + " L" + i1[i1.length - 1][0] + "," + i1[i1.length - 1][1] + " " + this.serializePath(i1, a, !0) + i1[0][0] + "," + i1[0][1] + " Z" : "M" + t[0][0] + "," + t[0][1] + " " + this.serializePath(t, a, !1) + " V" + l + " H" + t[0][0] + " Z", s.setAttributeNS(null, "class", e.className + " vis-fill"), void 0 !== e.options.shaded.style && s.setAttributeNS(null, "style", e.options.shaded.style), s.setAttributeNS(null, "d", o);
        }
    }, jT.draw = function(t, e, i1) {
        if (null != t && null != t) {
            var n = DT("path", i1.svgElements, i1.svg);
            n.setAttributeNS(null, "class", e.className), void 0 !== e.style && n.setAttributeNS(null, "style", e.style);
            var o = "L";
            1 == e.options.interpolation.enabled && (o = "C"), n.setAttributeNS(null, "d", "M" + t[0][0] + "," + t[0][1] + " " + this.serializePath(t, o, !1));
        }
    }, jT.serializePath = function(t, e, i1) {
        if (t.length < 2) return "";
        var n, o = e;
        if (i1) for(n = t.length - 2; n > 0; n--)o += t[n][0] + "," + t[n][1] + " ";
        else for(n = 1; n < t.length; n++)o += t[n][0] + "," + t[n][1] + " ";
        return o;
    }, jT._catmullRomUniform = function(t) {
        var e, i1, n, o, r, s, a = [];
        a.push([
            Math.round(t[0].screen_x),
            Math.round(t[0].screen_y)
        ]);
        for(var l = 1 / 6, h = t.length, u = 0; u < h - 1; u++)e = 0 == u ? t[0] : t[u - 1], i1 = t[u], n = t[u + 1], o = u + 2 < h ? t[u + 2] : n, r = {
            screen_x: (-e.screen_x + 6 * i1.screen_x + n.screen_x) * l,
            screen_y: (-e.screen_y + 6 * i1.screen_y + n.screen_y) * l
        }, s = {
            screen_x: (i1.screen_x + 6 * n.screen_x - o.screen_x) * l,
            screen_y: (i1.screen_y + 6 * n.screen_y - o.screen_y) * l
        }, a.push([
            r.screen_x,
            r.screen_y
        ]), a.push([
            s.screen_x,
            s.screen_y
        ]), a.push([
            n.screen_x,
            n.screen_y
        ]);
        return a;
    }, jT._catmullRom = function(t, e) {
        var i1 = e.options.interpolation.alpha;
        if (0 == i1 || void 0 === i1) return this._catmullRomUniform(t);
        var n, o, r, s, a, l, h, u, c, d, p, m, f, v, g, y, b, w, k, _ = [];
        _.push([
            Math.round(t[0].screen_x),
            Math.round(t[0].screen_y)
        ]);
        for(var x = t.length, C = 0; C < x - 1; C++)n = 0 == C ? t[0] : t[C - 1], o = t[C], r = t[C + 1], s = C + 2 < x ? t[C + 2] : r, h = Math.sqrt(Math.pow(n.screen_x - o.screen_x, 2) + Math.pow(n.screen_y - o.screen_y, 2)), u = Math.sqrt(Math.pow(o.screen_x - r.screen_x, 2) + Math.pow(o.screen_y - r.screen_y, 2)), c = Math.sqrt(Math.pow(r.screen_x - s.screen_x, 2) + Math.pow(r.screen_y - s.screen_y, 2)), v = Math.pow(c, i1), y = Math.pow(c, 2 * i1), g = Math.pow(u, i1), b = Math.pow(u, 2 * i1), k = Math.pow(h, i1), d = 2 * (w = Math.pow(h, 2 * i1)) + 3 * k * g + b, p = 2 * y + 3 * v * g + b, (m = 3 * k * (k + g)) > 0 && (m = 1 / m), (f = 3 * v * (v + g)) > 0 && (f = 1 / f), a = {
            screen_x: (-b * n.screen_x + d * o.screen_x + w * r.screen_x) * m,
            screen_y: (-b * n.screen_y + d * o.screen_y + w * r.screen_y) * m
        }, l = {
            screen_x: (y * o.screen_x + p * r.screen_x - b * s.screen_x) * f,
            screen_y: (y * o.screen_y + p * r.screen_y - b * s.screen_y) * f
        }, 0 == a.screen_x && 0 == a.screen_y && (a = o), 0 == l.screen_x && 0 == l.screen_y && (l = r), _.push([
            a.screen_x,
            a.screen_y
        ]), _.push([
            l.screen_x,
            l.screen_y
        ]), _.push([
            r.screen_x,
            r.screen_y
        ]);
        return _;
    }, jT._linear = function(t) {
        for(var e = [], i1 = 0; i1 < t.length; i1++)e.push([
            t[i1].screen_x,
            t[i1].screen_y
        ]);
        return e;
    }, BT.prototype.setItems = function(t) {
        null != t ? (this.itemsData = t, 1 == mx(this.options) && l_.insertSort(this.itemsData, function(t, e) {
            return t.x > e.x ? 1 : -1;
        })) : this.itemsData = [];
    }, BT.prototype.getItems = function() {
        return this.itemsData;
    }, BT.prototype.setZeroPosition = function(t) {
        this.zeroPosition = t;
    }, BT.prototype.setOptions = function(t) {
        if (void 0 !== t) l_.selectiveDeepExtend([
            "sampling",
            "style",
            "sort",
            "yAxisOrientation",
            "barChart",
            "zIndex",
            "excludeFromStacking",
            "excludeFromLegend"
        ], this.options, t), "function" == typeof t.drawPoints && (t.drawPoints = {
            onRender: t.drawPoints
        }), l_.mergeOptions(this.options, t, "interpolation"), l_.mergeOptions(this.options, t, "drawPoints"), l_.mergeOptions(this.options, t, "shaded"), t.interpolation && "object" == uc(t.interpolation) && t.interpolation.parametrization && ("uniform" == t.interpolation.parametrization ? this.options.interpolation.alpha = 0 : "chordal" == t.interpolation.parametrization ? this.options.interpolation.alpha = 1 : (this.options.interpolation.parametrization = "centripetal", this.options.interpolation.alpha = .5));
    }, BT.prototype.update = function(t) {
        this.group = t, this.content = t.content || "graph", this.className = t.className || this.className || "vis-graph-group" + this.groupsUsingDefaultStyles[0] % 10, this.visible = void 0 === t.visible || t.visible, this.style = t.style, this.setOptions(t.options);
    }, BT.prototype.getLegend = function(t, e, i1, n, o) {
        null != i1 && null != i1 || (i1 = {
            svg: document.createElementNS("http://www.w3.org/2000/svg", "svg"),
            svgElements: {},
            options: this.options,
            groups: [
                this
            ]
        });
        switch(null != n && null != n || (n = 0), null != o && null != o || (o = .5 * e), this.options.style){
            case "line":
                jT.drawIcon(this, n, o, t, e, i1);
                break;
            case "points":
            case "point":
                FT.drawIcon(this, n, o, t, e, i1);
                break;
            case "bar":
                LT.drawIcon(this, n, o, t, e, i1);
        }
        return {
            icon: i1.svg,
            label: this.content,
            orientation: this.options.yAxisOrientation
        };
    }, BT.prototype.getYRange = function(t) {
        for(var e = t[0].y, i1 = t[0].y, n = 0; n < t.length; n++)e = e > t[n].y ? t[n].y : e, i1 = i1 < t[n].y ? t[n].y : i1;
        return {
            min: e,
            max: i1,
            yAxisOrientation: this.options.yAxisOrientation
        };
    }, zT.prototype = new w_, zT.prototype.clear = function() {
        this.groups = {}, this.amountOfGroups = 0;
    }, zT.prototype.addGroup = function(t, e) {
        1 != e.options.excludeFromLegend && (this.groups.hasOwnProperty(t) || (this.groups[t] = e), this.amountOfGroups += 1);
    }, zT.prototype.updateGroup = function(t, e) {
        this.groups[t] = e;
    }, zT.prototype.removeGroup = function(t) {
        this.groups.hasOwnProperty(t) && (delete this.groups[t], this.amountOfGroups -= 1);
    }, zT.prototype._create = function() {
        this.dom.frame = document.createElement("div"), this.dom.frame.className = "vis-legend", this.dom.frame.style.position = "absolute", this.dom.frame.style.top = "10px", this.dom.frame.style.display = "block", this.dom.textArea = document.createElement("div"), this.dom.textArea.className = "vis-legend-text", this.dom.textArea.style.position = "relative", this.dom.textArea.style.top = "0px", this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.svg.style.position = "absolute", this.svg.style.top = "0px", this.svg.style.width = this.options.iconSize + 5 + "px", this.svg.style.height = "100%", this.dom.frame.appendChild(this.svg), this.dom.frame.appendChild(this.dom.textArea);
    }, zT.prototype.hide = function() {
        this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame);
    }, zT.prototype.show = function() {
        this.dom.frame.parentNode || this.body.dom.center.appendChild(this.dom.frame);
    }, zT.prototype.setOptions = function(t) {
        l_.selectiveDeepExtend([
            "enabled",
            "orientation",
            "icons",
            "left",
            "right"
        ], this.options, t);
    }, zT.prototype.redraw = function() {
        var t = 0, e = Dp(this.groups);
        mx(e).call(e, function(t, e) {
            return t < e ? -1 : 1;
        });
        for(var i1 = 0; i1 < e.length; i1++){
            var n = e[i1];
            1 != this.groups[n].visible || void 0 !== this.linegraphOptions.visibility[n] && 1 != this.linegraphOptions.visibility[n] || t++;
        }
        if (0 == this.options[this.side].visible || 0 == this.amountOfGroups || 0 == this.options.enabled || 0 == t) this.hide();
        else {
            if (this.show(), "top-left" == this.options[this.side].position || "bottom-left" == this.options[this.side].position ? (this.dom.frame.style.left = "4px", this.dom.frame.style.textAlign = "left", this.dom.textArea.style.textAlign = "left", this.dom.textArea.style.left = this.options.iconSize + 15 + "px", this.dom.textArea.style.right = "", this.svg.style.left = "0px", this.svg.style.right = "") : (this.dom.frame.style.right = "4px", this.dom.frame.style.textAlign = "right", this.dom.textArea.style.textAlign = "right", this.dom.textArea.style.right = this.options.iconSize + 15 + "px", this.dom.textArea.style.left = "", this.svg.style.right = "0px", this.svg.style.left = ""), "top-left" == this.options[this.side].position || "top-right" == this.options[this.side].position) this.dom.frame.style.top = 4 - Number(this.body.dom.center.style.top.replace("px", "")) + "px", this.dom.frame.style.bottom = "";
            else {
                var o = this.body.domProps.center.height - this.body.domProps.centerContainer.height;
                this.dom.frame.style.bottom = 4 + o + Number(this.body.dom.center.style.top.replace("px", "")) + "px", this.dom.frame.style.top = "";
            }
            0 == this.options.icons ? (this.dom.frame.style.width = this.dom.textArea.offsetWidth + 10 + "px", this.dom.textArea.style.right = "", this.dom.textArea.style.left = "", this.svg.style.width = "0px") : (this.dom.frame.style.width = this.options.iconSize + 15 + this.dom.textArea.offsetWidth + 10 + "px", this.drawLegendIcons());
            var r = "";
            for(i1 = 0; i1 < e.length; i1++)n = e[i1], 1 != this.groups[n].visible || void 0 !== this.linegraphOptions.visibility[n] && 1 != this.linegraphOptions.visibility[n] || (r += this.groups[n].content + "<br />");
            this.dom.textArea.innerHTML = l_.xss(r), this.dom.textArea.style.lineHeight = .75 * this.options.iconSize + this.options.iconSpacing + "px";
        }
    }, zT.prototype.drawLegendIcons = function() {
        if (this.dom.frame.parentNode) {
            var t = Dp(this.groups);
            mx(t).call(t, function(t, e) {
                return t < e ? -1 : 1;
            }), CT(h = this.svgElements), ST(h), CT(h);
            var e = window.getComputedStyle(this.dom.frame).paddingTop, i1 = Number(e.replace("px", "")), n = i1, o = this.options.iconSize, r = .75 * this.options.iconSize, s = i1 + .5 * r + 3;
            this.svg.style.width = o + 5 + i1 + "px";
            for(var a = 0; a < t.length; a++){
                var l = t[a];
                1 != this.groups[l].visible || void 0 !== this.linegraphOptions.visibility[l] && 1 != this.linegraphOptions.visibility[l] || (this.groups[l].getLegend(o, r, this.framework, n, s), s += r + this.options.iconSpacing);
            }
        }
        var h;
    };
    var HT = "__ungrouped__";
    function GT(t, e) {
        this.id = Zk(), this.body = t, this.defaultOptions = {
            yAxisOrientation: "left",
            defaultGroup: "default",
            sort: !0,
            sampling: !0,
            stack: !1,
            graphHeight: "400px",
            shaded: {
                enabled: !1,
                orientation: "bottom"
            },
            style: "line",
            barChart: {
                width: 50,
                sideBySide: !1,
                align: "center"
            },
            interpolation: {
                enabled: !0,
                parametrization: "centripetal",
                alpha: .5
            },
            drawPoints: {
                enabled: !0,
                size: 6,
                style: "square"
            },
            dataAxis: {},
            legend: {},
            groups: {
                visibility: {}
            }
        }, this.options = l_.extend({}, this.defaultOptions), this.dom = {}, this.props = {}, this.hammer = null, this.groups = {}, this.abortedGraphUpdate = !1, this.updateSVGheight = !1, this.updateSVGheightOnResize = !1, this.forceGraphUpdate = !0;
        var i1 = this;
        this.itemsData = null, this.groupsData = null, this.itemListeners = {
            add: function(t, e, n) {
                i1._onAdd(e.items);
            },
            update: function(t, e, n) {
                i1._onUpdate(e.items);
            },
            remove: function(t, e, n) {
                i1._onRemove(e.items);
            }
        }, this.groupListeners = {
            add: function(t, e, n) {
                i1._onAddGroups(e.items);
            },
            update: function(t, e, n) {
                i1._onUpdateGroups(e.items);
            },
            remove: function(t, e, n) {
                i1._onRemoveGroups(e.items);
            }
        }, this.items = {}, this.selection = [], this.lastStart = this.body.range.start, this.touchParams = {}, this.svgElements = {}, this.setOptions(e), this.groupsUsingDefaultStyles = [
            0
        ], this.body.emitter.on("rangechanged", function() {
            i1.svg.style.left = l_.option.asSize(-i1.props.width), i1.forceGraphUpdate = !0, i1.redraw.call(i1);
        }), this._create(), this.framework = {
            svg: this.svg,
            svgElements: this.svgElements,
            options: this.options,
            groups: this.groups
        };
    }
    GT.prototype = new w_, GT.prototype._create = function() {
        var t = document.createElement("div");
        t.className = "vis-line-graph", this.dom.frame = t, this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.svg.style.position = "relative", this.svg.style.height = ("" + this.options.graphHeight).replace("px", "") + "px", this.svg.style.display = "block", t.appendChild(this.svg), this.options.dataAxis.orientation = "left", this.yAxisLeft = new NT(this.body, this.options.dataAxis, this.svg, this.options.groups), this.options.dataAxis.orientation = "right", this.yAxisRight = new NT(this.body, this.options.dataAxis, this.svg, this.options.groups), delete this.options.dataAxis.orientation, this.legendLeft = new zT(this.body, this.options.legend, "left", this.options.groups), this.legendRight = new zT(this.body, this.options.legend, "right", this.options.groups), this.show();
    }, GT.prototype.setOptions = function(t) {
        if (t) void 0 === t.graphHeight && void 0 !== t.height ? (this.updateSVGheight = !0, this.updateSVGheightOnResize = !0) : void 0 !== this.body.domProps.centerContainer.height && void 0 !== t.graphHeight && gg((t.graphHeight + "").replace("px", "")) < this.body.domProps.centerContainer.height && (this.updateSVGheight = !0), l_.selectiveDeepExtend([
            "sampling",
            "defaultGroup",
            "stack",
            "height",
            "graphHeight",
            "yAxisOrientation",
            "style",
            "barChart",
            "dataAxis",
            "sort",
            "groups"
        ], this.options, t), l_.mergeOptions(this.options, t, "interpolation"), l_.mergeOptions(this.options, t, "drawPoints"), l_.mergeOptions(this.options, t, "shaded"), l_.mergeOptions(this.options, t, "legend"), t.interpolation && "object" == uc(t.interpolation) && t.interpolation.parametrization && ("uniform" == t.interpolation.parametrization ? this.options.interpolation.alpha = 0 : "chordal" == t.interpolation.parametrization ? this.options.interpolation.alpha = 1 : (this.options.interpolation.parametrization = "centripetal", this.options.interpolation.alpha = .5)), this.yAxisLeft && void 0 !== t.dataAxis && (this.yAxisLeft.setOptions(this.options.dataAxis), this.yAxisRight.setOptions(this.options.dataAxis)), this.legendLeft && void 0 !== t.legend && (this.legendLeft.setOptions(this.options.legend), this.legendRight.setOptions(this.options.legend)), this.groups.hasOwnProperty(HT) && this.groups[HT].setOptions(t);
        this.dom.frame && (this.forceGraphUpdate = !0, this.body.emitter.emit("_change", {
            queue: !0
        }));
    }, GT.prototype.hide = function() {
        this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame);
    }, GT.prototype.show = function() {
        this.dom.frame.parentNode || this.body.dom.center.appendChild(this.dom.frame);
    }, GT.prototype.setItems = function(t) {
        var e, i1 = this, n = this.itemsData;
        if (t) {
            if (!t_(t)) throw new TypeError("Data must implement the interface of DataSet or DataView");
            this.itemsData = o_(t);
        } else this.itemsData = null;
        if (n && (bd(l_).call(l_, this.itemListeners, function(t, e) {
            n.off(e, t);
        }), n.dispose(), e = n.getIds(), this._onRemove(e)), this.itemsData) {
            var o = this.id;
            bd(l_).call(l_, this.itemListeners, function(t, e) {
                i1.itemsData.on(e, t, o);
            }), e = this.itemsData.getIds(), this._onAdd(e);
        }
    }, GT.prototype.setGroups = function(t) {
        var e, i1 = this;
        if (this.groupsData) {
            bd(l_).call(l_, this.groupListeners, function(t, e) {
                i1.groupsData.off(e, t);
            }), e = this.groupsData.getIds(), this.groupsData = null;
            for(var n = 0; n < e.length; n++)this._removeGroup(e[n]);
        }
        if (t) {
            if (!t_(t)) throw new TypeError("Data must implement the interface of DataSet or DataView");
            this.groupsData = t;
        } else this.groupsData = null;
        if (this.groupsData) {
            var o = this.id;
            bd(l_).call(l_, this.groupListeners, function(t, e) {
                i1.groupsData.on(e, t, o);
            }), e = this.groupsData.getIds(), this._onAddGroups(e);
        }
    }, GT.prototype._onUpdate = function(t) {
        this._updateAllGroupData(t);
    }, GT.prototype._onAdd = function(t) {
        this._onUpdate(t);
    }, GT.prototype._onRemove = function(t) {
        this._onUpdate(t);
    }, GT.prototype._onUpdateGroups = function(t) {
        this._updateAllGroupData(null, t);
    }, GT.prototype._onAddGroups = function(t) {
        this._onUpdateGroups(t);
    }, GT.prototype._onRemoveGroups = function(t) {
        for(var e = 0; e < t.length; e++)this._removeGroup(t[e]);
        this.forceGraphUpdate = !0, this.body.emitter.emit("_change", {
            queue: !0
        });
    }, GT.prototype._removeGroup = function(t) {
        this.groups.hasOwnProperty(t) && ("right" == this.groups[t].options.yAxisOrientation ? (this.yAxisRight.removeGroup(t), this.legendRight.removeGroup(t), this.legendRight.redraw()) : (this.yAxisLeft.removeGroup(t), this.legendLeft.removeGroup(t), this.legendLeft.redraw()), delete this.groups[t]);
    }, GT.prototype._updateGroup = function(t, e) {
        this.groups.hasOwnProperty(e) ? (this.groups[e].update(t), "right" == this.groups[e].options.yAxisOrientation ? (this.yAxisRight.updateGroup(e, this.groups[e]), this.legendRight.updateGroup(e, this.groups[e]), this.yAxisLeft.removeGroup(e), this.legendLeft.removeGroup(e)) : (this.yAxisLeft.updateGroup(e, this.groups[e]), this.legendLeft.updateGroup(e, this.groups[e]), this.yAxisRight.removeGroup(e), this.legendRight.removeGroup(e))) : (this.groups[e] = new BT(t, e, this.options, this.groupsUsingDefaultStyles), "right" == this.groups[e].options.yAxisOrientation ? (this.yAxisRight.addGroup(e, this.groups[e]), this.legendRight.addGroup(e, this.groups[e])) : (this.yAxisLeft.addGroup(e, this.groups[e]), this.legendLeft.addGroup(e, this.groups[e]))), this.legendLeft.redraw(), this.legendRight.redraw();
    }, GT.prototype._updateAllGroupData = function(t, e) {
        if (null != this.itemsData) {
            var i1 = {}, n = this.itemsData.get(), o = this.itemsData.idProp, r = {};
            t && lp(t).call(t, function(t) {
                r[t] = t;
            });
            for(var s = {}, a = 0; a < n.length; a++){
                var l = n[a], h = l.group;
                null == h && (h = HT), s.hasOwnProperty(h) ? s[h]++ : s[h] = 1;
            }
            var u = {};
            if (!e && t) {
                for(h in this.groups)if (this.groups.hasOwnProperty(h)) {
                    var c = (f = this.groups[h]).getItems();
                    i1[h] = Ed(c).call(c, function(t) {
                        return u[t[o]] = t[o], t[o] !== r[t[o]];
                    });
                    var d = s[h];
                    s[h] -= i1[h].length, i1[h].length < d && (i1[h][d - 1] = {});
                }
            }
            for(a = 0; a < n.length; a++)if (null == (h = (l = n[a]).group) && (h = HT), e || !t || l[o] === r[l[o]] || !u.hasOwnProperty(l[o])) {
                i1.hasOwnProperty(h) || (i1[h] = new Array(s[h]));
                var p = l_.bridgeObject(l);
                p.x = l_.convert(l.x, "Date"), p.end = l_.convert(l.end, "Date"), p.orginalY = l.y, p.y = Number(l.y), p[o] = l[o];
                var m = i1[h].length - s[h]--;
                i1[h][m] = p;
            }
            for(h in this.groups)this.groups.hasOwnProperty(h) && (i1.hasOwnProperty(h) || (i1[h] = new Array(0)));
            for(h in i1)if (i1.hasOwnProperty(h)) {
                if (0 == i1[h].length) this.groups.hasOwnProperty(h) && this._removeGroup(h);
                else {
                    var f = void 0;
                    null != this.groupsData && (f = this.groupsData.get(h)), null == f && (f = {
                        id: h,
                        content: this.options.defaultGroup + h
                    }), this._updateGroup(f, h), this.groups[h].setItems(i1[h]);
                }
            }
            this.forceGraphUpdate = !0, this.body.emitter.emit("_change", {
                queue: !0
            });
        }
    }, GT.prototype.redraw = function() {
        var t = !1;
        this.props.width = this.dom.frame.offsetWidth, this.props.height = this.body.domProps.centerContainer.height - this.body.domProps.border.top - this.body.domProps.border.bottom, t = this._isResized() || t;
        var e, i1 = this.body.range.end - this.body.range.start, n = i1 != this.lastVisibleInterval;
        (this.lastVisibleInterval = i1, 1 == t) && (this.svg.style.width = l_.option.asSize(3 * this.props.width), this.svg.style.left = l_.option.asSize(-this.props.width), -1 == Eg(e = this.options.height + "").call(e, "%") && 1 != this.updateSVGheightOnResize || (this.updateSVGheight = !0));
        if (1 == this.updateSVGheight ? (this.options.graphHeight != this.props.height + "px" && (this.options.graphHeight = this.props.height + "px", this.svg.style.height = this.props.height + "px"), this.updateSVGheight = !1) : this.svg.style.height = ("" + this.options.graphHeight).replace("px", "") + "px", 1 == t || 1 == n || 1 == this.abortedGraphUpdate || 1 == this.forceGraphUpdate) t = this._updateGraph() || t, this.forceGraphUpdate = !1, this.lastStart = this.body.range.start, this.svg.style.left = -this.props.width + "px";
        else if (0 != this.lastStart) {
            var o = this.body.range.start - this.lastStart, r = this.body.range.end - this.body.range.start;
            if (0 != this.props.width) {
                var s = o * (this.props.width / r);
                this.svg.style.left = -this.props.width - s + "px";
            }
        }
        return this.legendLeft.redraw(), this.legendRight.redraw(), t;
    }, GT.prototype._getSortedGroupIds = function() {
        var t = [];
        for(var e in this.groups)if (this.groups.hasOwnProperty(e)) {
            var i1 = this.groups[e];
            1 != i1.visible || void 0 !== this.options.groups.visibility[e] && 1 != this.options.groups.visibility[e] || t.push({
                id: e,
                zIndex: i1.options.zIndex
            });
        }
        l_.insertSort(t, function(t, e) {
            var i1 = t.zIndex, n = e.zIndex;
            return void 0 === i1 && (i1 = 0), void 0 === n && (n = 0), i1 == n ? 0 : i1 < n ? -1 : 1;
        });
        for(var n = new Array(t.length), o = 0; o < t.length; o++)n[o] = t[o].id;
        return n;
    }, GT.prototype._updateGraph = function() {
        if (CT(this.svgElements), 0 != this.props.width && null != this.itemsData) {
            var t, e, i1 = {}, n = this.body.util.toGlobalTime(-this.body.domProps.root.width), o = this.body.util.toGlobalTime(2 * this.body.domProps.root.width), r = this._getSortedGroupIds();
            if (r.length > 0) {
                var s = {};
                for(this._getRelevantData(r, s, n, o), this._applySampling(r, s), e = 0; e < r.length; e++)this._convertXcoordinates(s[r[e]]);
                if (this._getYRanges(r, s, i1), 1 == this._updateYAxis(r, i1)) return ST(this.svgElements), this.abortedGraphUpdate = !0, !0;
                this.abortedGraphUpdate = !1;
                var a = void 0;
                for(e = 0; e < r.length; e++)t = this.groups[r[e]], !0 === this.options.stack && "line" === this.options.style && (null != t.options.excludeFromStacking && t.options.excludeFromStacking || (null != a && (this._stack(s[t.id], s[a.id]), 1 == t.options.shaded.enabled && "group" !== t.options.shaded.orientation && ("top" == t.options.shaded.orientation && "group" !== a.options.shaded.orientation ? (a.options.shaded.orientation = "group", a.options.shaded.groupId = t.id) : (t.options.shaded.orientation = "group", t.options.shaded.groupId = a.id))), a = t)), this._convertYcoordinates(s[r[e]], t);
                var l = {};
                for(e = 0; e < r.length; e++)if ("line" === (t = this.groups[r[e]]).options.style && 1 == t.options.shaded.enabled) {
                    var h = s[r[e]];
                    if (null == h || 0 == h.length) continue;
                    if (l.hasOwnProperty(r[e]) || (l[r[e]] = jT.calcPath(h, t)), "group" === t.options.shaded.orientation) {
                        var u = t.options.shaded.groupId;
                        if (-1 === Eg(r).call(r, u)) {
                            console.log(t.id + ": Unknown shading group target given:" + u);
                            continue;
                        }
                        l.hasOwnProperty(u) || (l[u] = jT.calcPath(s[u], this.groups[u])), jT.drawShading(l[r[e]], t, l[u], this.framework);
                    } else jT.drawShading(l[r[e]], t, void 0, this.framework);
                }
                for(LT.draw(r, s, this.framework), e = 0; e < r.length; e++)if (t = this.groups[r[e]], s[r[e]].length > 0) switch(t.options.style){
                    case "line":
                        l.hasOwnProperty(r[e]) || (l[r[e]] = jT.calcPath(s[r[e]], t)), jT.draw(l[r[e]], t, this.framework);
                    case "point":
                    case "points":
                        "point" != t.options.style && "points" != t.options.style && 1 != t.options.drawPoints.enabled || FT.draw(s[r[e]], t, this.framework);
                }
            }
        }
        return ST(this.svgElements), !1;
    }, GT.prototype._stack = function(t, e) {
        var i1, n, o, r, s;
        i1 = 0;
        for(var a = 0; a < t.length; a++){
            r = void 0, s = void 0;
            for(var l = i1; l < e.length; l++){
                if (e[l].x === t[a].x) {
                    r = e[l], s = e[l], i1 = l;
                    break;
                }
                if (e[l].x > t[a].x) {
                    s = e[l], r = 0 == l ? s : e[l - 1], i1 = l;
                    break;
                }
            }
            void 0 === s && (r = e[e.length - 1], s = e[e.length - 1]), n = s.x - r.x, o = s.y - r.y, t[a].y = 0 == n ? t[a].orginalY + s.y : t[a].orginalY + o / n * (t[a].x - r.x) + r.y;
        }
    }, GT.prototype._getRelevantData = function(t, e, i1, n) {
        var o, r, s, a;
        if (t.length > 0) for(r = 0; r < t.length; r++){
            var l = (o = this.groups[t[r]]).getItems();
            if (1 == mx(o.options)) {
                var h = function(t, e) {
                    return t.getTime() == e.getTime() ? 0 : t < e ? -1 : 1;
                }, u = Math.max(0, l_.binarySearchValue(l, i1, "x", "before", h)), c = Math.min(l.length, l_.binarySearchValue(l, n, "x", "after", h) + 1);
                c <= 0 && (c = l.length);
                var d = new Array(c - u);
                for(s = u; s < c; s++)a = o.itemsData[s], d[s - u] = a;
                e[t[r]] = d;
            } else e[t[r]] = o.itemsData;
        }
    }, GT.prototype._applySampling = function(t, e) {
        if (t.length > 0) {
            for(var i1 = 0; i1 < t.length; i1++)if (1 == this.groups[t[i1]].options.sampling) {
                var n = e[t[i1]];
                if (n.length > 0) {
                    var o, r = n.length, s = r / (this.body.util.toGlobalScreen(n[n.length - 1].x) - this.body.util.toGlobalScreen(n[0].x));
                    o = Math.min(Math.ceil(.2 * r), Math.max(1, Math.round(s)));
                    for(var a = new Array(r), l = 0; l < r; l += o)a[Math.round(l / o)] = n[l];
                    e[t[i1]] = Qf(a).call(a, 0, Math.round(r / o));
                }
            }
        }
    }, GT.prototype._getYRanges = function(t, e, i1) {
        var n, o, r, s, a = [], l = [];
        if (t.length > 0) {
            for(r = 0; r < t.length; r++)n = e[t[r]], s = this.groups[t[r]].options, n.length > 0 && (o = this.groups[t[r]], !0 === s.stack && "bar" === s.style ? "left" === s.yAxisOrientation ? a = mf(a).call(a, n) : l = mf(l).call(l, n) : i1[t[r]] = o.getYRange(n, t[r]));
            LT.getStackedYRange(a, i1, t, "__barStackLeft", "left"), LT.getStackedYRange(l, i1, t, "__barStackRight", "right");
        }
    }, GT.prototype._updateYAxis = function(t, e) {
        var i1, n, o = !1, r = !1, s = !1, a = 1e9, l = 1e9, h = -1000000000, u = -1000000000;
        if (t.length > 0) {
            for(var c = 0; c < t.length; c++){
                var d = this.groups[t[c]];
                d && "right" != d.options.yAxisOrientation ? (r = !0, a = 1e9, h = -1000000000) : d && d.options.yAxisOrientation && (s = !0, l = 1e9, u = -1000000000);
            }
            for(c = 0; c < t.length; c++)e.hasOwnProperty(t[c]) && !0 !== e[t[c]].ignore && (i1 = e[t[c]].min, n = e[t[c]].max, "right" != e[t[c]].yAxisOrientation ? (r = !0, a = a > i1 ? i1 : a, h = h < n ? n : h) : (s = !0, l = l > i1 ? i1 : l, u = u < n ? n : u));
            1 == r && this.yAxisLeft.setRange(a, h), 1 == s && this.yAxisRight.setRange(l, u);
        }
        o = this._toggleAxisVisiblity(r, this.yAxisLeft) || o, o = this._toggleAxisVisiblity(s, this.yAxisRight) || o, 1 == s && 1 == r ? (this.yAxisLeft.drawIcons = !0, this.yAxisRight.drawIcons = !0) : (this.yAxisLeft.drawIcons = !1, this.yAxisRight.drawIcons = !1), this.yAxisRight.master = !r, this.yAxisRight.masterAxis = this.yAxisLeft, 0 == this.yAxisRight.master ? (this.yAxisLeft.lineOffset = 1 == s ? this.yAxisRight.width : 0, o = this.yAxisLeft.redraw() || o, o = this.yAxisRight.redraw() || o) : o = this.yAxisRight.redraw() || o;
        var p = [
            "__barStackLeft",
            "__barStackRight",
            "__lineStackLeft",
            "__lineStackRight"
        ];
        for(c = 0; c < p.length; c++)-1 != Eg(t).call(t, p[c]) && Qf(t).call(t, Eg(t).call(t, p[c]), 1);
        return o;
    }, GT.prototype._toggleAxisVisiblity = function(t, e) {
        var i1 = !1;
        return 0 == t ? e.dom.frame.parentNode && 0 == e.hidden && (e.hide(), i1 = !0) : e.dom.frame.parentNode || 1 != e.hidden || (e.show(), i1 = !0), i1;
    }, GT.prototype._convertXcoordinates = function(t) {
        for(var e = this.body.util.toScreen, i1 = 0; i1 < t.length; i1++)t[i1].screen_x = e(t[i1].x) + this.props.width, t[i1].screen_y = t[i1].y, null != t[i1].end ? t[i1].screen_end = e(t[i1].end) + this.props.width : t[i1].screen_end = void 0;
    }, GT.prototype._convertYcoordinates = function(t, e) {
        var i1 = this.yAxisLeft, n = Number(this.svg.style.height.replace("px", ""));
        "right" == e.options.yAxisOrientation && (i1 = this.yAxisRight);
        for(var o = 0; o < t.length; o++)t[o].screen_y = Math.round(i1.convertValue(t[o].y));
        e.setZeroPosition(Math.min(n, i1.convertValue(0)));
    };
    var WT = "string", YT = "boolean", VT = "number", UT = "date", XT = "object", qT = "moment", KT = {
        configure: {
            enabled: {
                boolean: YT
            },
            filter: {
                boolean: YT,
                function: "function"
            },
            container: {
                dom: "dom"
            },
            __type__: {
                object: XT,
                boolean: YT,
                function: "function"
            }
        },
        alignCurrentTime: {
            string: WT,
            undefined: "undefined"
        },
        yAxisOrientation: {
            string: [
                "left",
                "right"
            ]
        },
        defaultGroup: {
            string: WT
        },
        sort: {
            boolean: YT
        },
        sampling: {
            boolean: YT
        },
        stack: {
            boolean: YT
        },
        graphHeight: {
            string: WT,
            number: VT
        },
        shaded: {
            enabled: {
                boolean: YT
            },
            orientation: {
                string: [
                    "bottom",
                    "top",
                    "zero",
                    "group"
                ]
            },
            groupId: {
                object: XT
            },
            __type__: {
                boolean: YT,
                object: XT
            }
        },
        style: {
            string: [
                "line",
                "bar",
                "points"
            ]
        },
        barChart: {
            width: {
                number: VT
            },
            minWidth: {
                number: VT
            },
            sideBySide: {
                boolean: YT
            },
            align: {
                string: [
                    "left",
                    "center",
                    "right"
                ]
            },
            __type__: {
                object: XT
            }
        },
        interpolation: {
            enabled: {
                boolean: YT
            },
            parametrization: {
                string: [
                    "centripetal",
                    "chordal",
                    "uniform"
                ]
            },
            alpha: {
                number: VT
            },
            __type__: {
                object: XT,
                boolean: YT
            }
        },
        drawPoints: {
            enabled: {
                boolean: YT
            },
            onRender: {
                function: "function"
            },
            size: {
                number: VT
            },
            style: {
                string: [
                    "square",
                    "circle"
                ]
            },
            __type__: {
                object: XT,
                boolean: YT,
                function: "function"
            }
        },
        dataAxis: {
            showMinorLabels: {
                boolean: YT
            },
            showMajorLabels: {
                boolean: YT
            },
            showWeekScale: {
                boolean: YT
            },
            icons: {
                boolean: YT
            },
            width: {
                string: WT,
                number: VT
            },
            visible: {
                boolean: YT
            },
            alignZeros: {
                boolean: YT
            },
            left: {
                range: {
                    min: {
                        number: VT,
                        undefined: "undefined"
                    },
                    max: {
                        number: VT,
                        undefined: "undefined"
                    },
                    __type__: {
                        object: XT
                    }
                },
                format: {
                    function: "function"
                },
                title: {
                    text: {
                        string: WT,
                        number: VT,
                        undefined: "undefined"
                    },
                    style: {
                        string: WT,
                        undefined: "undefined"
                    },
                    __type__: {
                        object: XT
                    }
                },
                __type__: {
                    object: XT
                }
            },
            right: {
                range: {
                    min: {
                        number: VT,
                        undefined: "undefined"
                    },
                    max: {
                        number: VT,
                        undefined: "undefined"
                    },
                    __type__: {
                        object: XT
                    }
                },
                format: {
                    function: "function"
                },
                title: {
                    text: {
                        string: WT,
                        number: VT,
                        undefined: "undefined"
                    },
                    style: {
                        string: WT,
                        undefined: "undefined"
                    },
                    __type__: {
                        object: XT
                    }
                },
                __type__: {
                    object: XT
                }
            },
            __type__: {
                object: XT
            }
        },
        legend: {
            enabled: {
                boolean: YT
            },
            icons: {
                boolean: YT
            },
            left: {
                visible: {
                    boolean: YT
                },
                position: {
                    string: [
                        "top-right",
                        "bottom-right",
                        "top-left",
                        "bottom-left"
                    ]
                },
                __type__: {
                    object: XT
                }
            },
            right: {
                visible: {
                    boolean: YT
                },
                position: {
                    string: [
                        "top-right",
                        "bottom-right",
                        "top-left",
                        "bottom-left"
                    ]
                },
                __type__: {
                    object: XT
                }
            },
            __type__: {
                object: XT,
                boolean: YT
            }
        },
        groups: {
            visibility: {
                any: "any"
            },
            __type__: {
                object: XT
            }
        },
        autoResize: {
            boolean: YT
        },
        throttleRedraw: {
            number: VT
        },
        clickToUse: {
            boolean: YT
        },
        end: {
            number: VT,
            date: UT,
            string: WT,
            moment: qT
        },
        format: {
            minorLabels: {
                millisecond: {
                    string: WT,
                    undefined: "undefined"
                },
                second: {
                    string: WT,
                    undefined: "undefined"
                },
                minute: {
                    string: WT,
                    undefined: "undefined"
                },
                hour: {
                    string: WT,
                    undefined: "undefined"
                },
                weekday: {
                    string: WT,
                    undefined: "undefined"
                },
                day: {
                    string: WT,
                    undefined: "undefined"
                },
                week: {
                    string: WT,
                    undefined: "undefined"
                },
                month: {
                    string: WT,
                    undefined: "undefined"
                },
                quarter: {
                    string: WT,
                    undefined: "undefined"
                },
                year: {
                    string: WT,
                    undefined: "undefined"
                },
                __type__: {
                    object: XT
                }
            },
            majorLabels: {
                millisecond: {
                    string: WT,
                    undefined: "undefined"
                },
                second: {
                    string: WT,
                    undefined: "undefined"
                },
                minute: {
                    string: WT,
                    undefined: "undefined"
                },
                hour: {
                    string: WT,
                    undefined: "undefined"
                },
                weekday: {
                    string: WT,
                    undefined: "undefined"
                },
                day: {
                    string: WT,
                    undefined: "undefined"
                },
                week: {
                    string: WT,
                    undefined: "undefined"
                },
                month: {
                    string: WT,
                    undefined: "undefined"
                },
                quarter: {
                    string: WT,
                    undefined: "undefined"
                },
                year: {
                    string: WT,
                    undefined: "undefined"
                },
                __type__: {
                    object: XT
                }
            },
            __type__: {
                object: XT
            }
        },
        moment: {
            function: "function"
        },
        height: {
            string: WT,
            number: VT
        },
        hiddenDates: {
            start: {
                date: UT,
                number: VT,
                string: WT,
                moment: qT
            },
            end: {
                date: UT,
                number: VT,
                string: WT,
                moment: qT
            },
            repeat: {
                string: WT
            },
            __type__: {
                object: XT,
                array: "array"
            }
        },
        locale: {
            string: WT
        },
        locales: {
            __any__: {
                any: "any"
            },
            __type__: {
                object: XT
            }
        },
        max: {
            date: UT,
            number: VT,
            string: WT,
            moment: qT
        },
        maxHeight: {
            number: VT,
            string: WT
        },
        maxMinorChars: {
            number: VT
        },
        min: {
            date: UT,
            number: VT,
            string: WT,
            moment: qT
        },
        minHeight: {
            number: VT,
            string: WT
        },
        moveable: {
            boolean: YT
        },
        multiselect: {
            boolean: YT
        },
        orientation: {
            string: WT
        },
        showCurrentTime: {
            boolean: YT
        },
        showMajorLabels: {
            boolean: YT
        },
        showMinorLabels: {
            boolean: YT
        },
        showWeekScale: {
            boolean: YT
        },
        snap: {
            function: "function",
            null: "null"
        },
        start: {
            date: UT,
            number: VT,
            string: WT,
            moment: qT
        },
        timeAxis: {
            scale: {
                string: WT,
                undefined: "undefined"
            },
            step: {
                number: VT,
                undefined: "undefined"
            },
            __type__: {
                object: XT
            }
        },
        width: {
            string: WT,
            number: VT
        },
        zoomable: {
            boolean: YT
        },
        zoomKey: {
            string: [
                "ctrlKey",
                "altKey",
                "metaKey",
                ""
            ]
        },
        zoomMax: {
            number: VT
        },
        zoomMin: {
            number: VT
        },
        zIndex: {
            number: VT
        },
        __type__: {
            object: XT
        }
    }, $T = {
        global: {
            alignCurrentTime: [
                "none",
                "year",
                "month",
                "quarter",
                "week",
                "isoWeek",
                "day",
                "date",
                "hour",
                "minute",
                "second"
            ],
            sort: !0,
            sampling: !0,
            stack: !1,
            shaded: {
                enabled: !1,
                orientation: [
                    "zero",
                    "top",
                    "bottom",
                    "group"
                ]
            },
            style: [
                "line",
                "bar",
                "points"
            ],
            barChart: {
                width: [
                    50,
                    5,
                    100,
                    5
                ],
                minWidth: [
                    50,
                    5,
                    100,
                    5
                ],
                sideBySide: !1,
                align: [
                    "left",
                    "center",
                    "right"
                ]
            },
            interpolation: {
                enabled: !0,
                parametrization: [
                    "centripetal",
                    "chordal",
                    "uniform"
                ]
            },
            drawPoints: {
                enabled: !0,
                size: [
                    6,
                    2,
                    30,
                    1
                ],
                style: [
                    "square",
                    "circle"
                ]
            },
            dataAxis: {
                showMinorLabels: !0,
                showMajorLabels: !0,
                showWeekScale: !1,
                icons: !1,
                width: [
                    40,
                    0,
                    200,
                    1
                ],
                visible: !0,
                alignZeros: !0,
                left: {
                    title: {
                        text: "",
                        style: ""
                    }
                },
                right: {
                    title: {
                        text: "",
                        style: ""
                    }
                }
            },
            legend: {
                enabled: !1,
                icons: !0,
                left: {
                    visible: !0,
                    position: [
                        "top-right",
                        "bottom-right",
                        "top-left",
                        "bottom-left"
                    ]
                },
                right: {
                    visible: !0,
                    position: [
                        "top-right",
                        "bottom-right",
                        "top-left",
                        "bottom-left"
                    ]
                }
            },
            autoResize: !0,
            clickToUse: !1,
            end: "",
            format: {
                minorLabels: {
                    millisecond: "SSS",
                    second: "s",
                    minute: "HH:mm",
                    hour: "HH:mm",
                    weekday: "ddd D",
                    day: "D",
                    week: "w",
                    month: "MMM",
                    quarter: "[Q]Q",
                    year: "YYYY"
                },
                majorLabels: {
                    millisecond: "HH:mm:ss",
                    second: "D MMMM HH:mm",
                    minute: "ddd D MMMM",
                    hour: "ddd D MMMM",
                    weekday: "MMMM YYYY",
                    day: "MMMM YYYY",
                    week: "MMMM YYYY",
                    month: "YYYY",
                    quarter: "YYYY",
                    year: ""
                }
            },
            height: "",
            locale: "",
            max: "",
            maxHeight: "",
            maxMinorChars: [
                7,
                0,
                20,
                1
            ],
            min: "",
            minHeight: "",
            moveable: !0,
            orientation: [
                "both",
                "bottom",
                "top"
            ],
            showCurrentTime: !1,
            showMajorLabels: !0,
            showMinorLabels: !0,
            showWeekScale: !1,
            start: "",
            width: "100%",
            zoomable: !0,
            zoomKey: [
                "ctrlKey",
                "altKey",
                "metaKey",
                ""
            ],
            zoomMax: [
                31536e10,
                10,
                31536e10,
                1
            ],
            zoomMin: [
                10,
                10,
                31536e10,
                1
            ],
            zIndex: 0
        }
    };
    function ZT(t, e, i1, n) {
        var o, r, s, a, l, h, u;
        if (!zc(i1) && !t_(i1) && i1 instanceof Object) {
            var c = n;
            n = i1, i1 = c;
        }
        n && n.throttleRedraw && console.warn('Graph2d option "throttleRedraw" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.');
        var d = this;
        this.defaultOptions = {
            start: null,
            end: null,
            autoResize: !0,
            orientation: {
                axis: "bottom",
                item: "bottom"
            },
            moment: wd,
            width: null,
            height: null,
            maxHeight: null,
            minHeight: null
        }, this.options = l_.deepExtend({}, this.defaultOptions), this._create(t), this.components = [], this.body = {
            dom: this.dom,
            domProps: this.props,
            emitter: {
                on: Hc(o = this.on).call(o, this),
                off: Hc(r = this.off).call(r, this),
                emit: Hc(s = this.emit).call(s, this)
            },
            hiddenDates: [],
            util: {
                getScale: function() {
                    return d.timeAxis.step.scale;
                },
                getStep: function() {
                    return d.timeAxis.step.step;
                },
                toScreen: Hc(a = d._toScreen).call(a, d),
                toGlobalScreen: Hc(l = d._toGlobalScreen).call(l, d),
                toTime: Hc(h = d._toTime).call(h, d),
                toGlobalTime: Hc(u = d._toGlobalTime).call(u, d)
            }
        }, this.range = new Ax(this.body), this.components.push(this.range), this.body.range = this.range, this.timeAxis = new Ux(this.body), this.components.push(this.timeAxis), this.currentTime = new mC(this.body), this.components.push(this.currentTime), this.linegraph = new GT(this.body), this.components.push(this.linegraph), this.itemsData = null, this.groupsData = null, this.on("tap", function(t) {
            d.emit("click", d.getEventProperties(t));
        }), this.on("doubletap", function(t) {
            d.emit("doubleClick", d.getEventProperties(t));
        }), this.dom.root.oncontextmenu = function(t) {
            d.emit("contextmenu", d.getEventProperties(t));
        }, this.initialFitDone = !1, this.on("changed", function() {
            if (null != d.itemsData) {
                if (!d.initialFitDone && !d.options.rollingMode) {
                    if (d.initialFitDone = !0, null != d.options.start || null != d.options.end) {
                        if (null == d.options.start || null == d.options.end) var t = d.getItemRange();
                        var e = null != d.options.start ? d.options.start : t.min, i1 = null != d.options.end ? d.options.end : t.max;
                        d.setWindow(e, i1, {
                            animation: !1
                        });
                    } else d.fit({
                        animation: !1
                    });
                }
                d.initialDrawDone || !d.initialRangeChangeDone && (d.options.start || d.options.end) && !d.options.rollingMode || (d.initialDrawDone = !0, d.dom.root.style.visibility = "visible", d.dom.loadingScreen.parentNode.removeChild(d.dom.loadingScreen), d.options.onInitialDrawComplete && sd(function() {
                    return d.options.onInitialDrawComplete();
                }, 0));
            }
        }), n && this.setOptions(n), i1 && this.setGroups(i1), e && this.setItems(e), this._redraw();
    }
    ZT.prototype = new dC, ZT.prototype.setOptions = function(t) {
        !0 === sT.validate(t, KT) && console.log("%cErrors have been found in the supplied options object.", rT), dC.prototype.setOptions.call(this, t);
    }, ZT.prototype.setItems = function(t) {
        var e, i1 = null == this.itemsData;
        if (e = t ? t_(t) ? o_(t) : o_(new n.DataSet(t)) : null, this.itemsData && this.itemsData.dispose(), this.itemsData = e, this.linegraph && this.linegraph.setItems(null != e ? e.rawDS : null), i1) {
            if (null != this.options.start || null != this.options.end) {
                var o = null != this.options.start ? this.options.start : null, r = null != this.options.end ? this.options.end : null;
                this.setWindow(o, r, {
                    animation: !1
                });
            } else this.fit({
                animation: !1
            });
        }
    }, ZT.prototype.setGroups = function(t) {
        var e;
        e = t ? t_(t) ? t : new n.DataSet(t) : null, this.groupsData = e, this.linegraph.setGroups(e);
    }, ZT.prototype.getLegend = function(t, e, i1) {
        return void 0 === e && (e = 15), void 0 === i1 && (i1 = 15), void 0 !== this.linegraph.groups[t] ? this.linegraph.groups[t].getLegend(e, i1) : "cannot find group:'" + t + "'";
    }, ZT.prototype.isGroupVisible = function(t) {
        return void 0 !== this.linegraph.groups[t] && this.linegraph.groups[t].visible && (void 0 === this.linegraph.options.groups.visibility[t] || 1 == this.linegraph.options.groups.visibility[t]);
    }, ZT.prototype.getDataRange = function() {
        var t = null, e = null;
        for(var i1 in this.linegraph.groups)if (this.linegraph.groups.hasOwnProperty(i1) && 1 == this.linegraph.groups[i1].visible) for(var n = 0; n < this.linegraph.groups[i1].itemsData.length; n++){
            var o = this.linegraph.groups[i1].itemsData[n], r = l_.convert(o.x, "Date").valueOf();
            t = null == t || t > r ? r : t, e = null == e || e < r ? r : e;
        }
        return {
            min: null != t ? new Date(t) : null,
            max: null != e ? new Date(e) : null
        };
    }, ZT.prototype.getEventProperties = function(t) {
        var e = t.center ? t.center.x : t.clientX, i1 = t.center ? t.center.y : t.clientY, n = e - l_.getAbsoluteLeft(this.dom.centerContainer), o = i1 - l_.getAbsoluteTop(this.dom.centerContainer), r = this._toTime(n), s = cC.customTimeFromTarget(t), a = l_.getTarget(t), l = null;
        l_.hasParent(a, this.timeAxis.dom.foreground) || this.timeAxis2 && l_.hasParent(a, this.timeAxis2.dom.foreground) ? l = "axis" : l_.hasParent(a, this.linegraph.yAxisLeft.dom.frame) || l_.hasParent(a, this.linegraph.yAxisRight.dom.frame) ? l = "data-axis" : l_.hasParent(a, this.linegraph.legendLeft.dom.frame) || l_.hasParent(a, this.linegraph.legendRight.dom.frame) ? l = "legend" : null != s ? l = "custom-time" : l_.hasParent(a, this.currentTime.bar) ? l = "current-time" : l_.hasParent(a, this.dom.center) && (l = "background");
        var h = [], u = this.linegraph.yAxisLeft, c = this.linegraph.yAxisRight;
        return !u.hidden && this.itemsData.length > 0 && h.push(u.screenToValue(o)), !c.hidden && this.itemsData.length > 0 && h.push(c.screenToValue(o)), {
            event: t,
            customTime: s ? s.options.id : null,
            what: l,
            pageX: t.srcEvent ? t.srcEvent.pageX : t.pageX,
            pageY: t.srcEvent ? t.srcEvent.pageY : t.pageY,
            x: n,
            y: o,
            time: r,
            value: h
        };
    }, ZT.prototype._createConfigurator = function() {
        return new yT(this, this.dom.container, $T);
    };
    var QT = function() {
        try {
            return navigator ? navigator.languages && navigator.languages.length ? navigator.languages : navigator.userLanguage || navigator.language || navigator.browserLanguage || "en" : "en";
        } catch (t) {
            return "en";
        }
    }();
    e.locale(QT);
    var JT = {
        Core: dC,
        DateUtil: Ex,
        Range: Ax,
        stack: bD,
        TimeStep: Yx,
        components: {
            items: {
                Item: DD,
                BackgroundItem: ND,
                BoxItem: ED,
                ClusterItem: UD,
                PointItem: AD,
                RangeItem: PD
            },
            BackgroundGroup: xD,
            Component: w_,
            CurrentTime: mC,
            CustomTime: cC,
            DataAxis: NT,
            DataScale: AT,
            GraphGroup: BT,
            Group: kD,
            ItemSet: iT,
            Legend: zT,
            LineGraph: GT,
            TimeAxis: Ux
        }
    };
    t.Graph2d = ZT, t.Timeline = wT, t.timeline = JT;
});

},{"d5849437dec34ce2":"1e4qG","b3e91b269c1eeaa":"9LUKC"}],"1e4qG":[function(require,module,exports,__globalThis) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

},{}],"9LUKC":[function(require,module,exports,__globalThis) {
var global = arguments[3];
/**
 * vis-data
 * http://visjs.org/
 *
 * Manage unstructured data using DataSet. Add, update, and remove data, and listen for changes in the data.
 *
 * @version 7.1.9
 * @date    2023-11-24T17:53:34.179Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */ (function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var defineProperty$f = {
        exports: {}
    };
    var check = function(it) {
        return it && it.Math === Math && it;
    };
    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global$p = // eslint-disable-next-line es/no-global-this -- safe
    check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
    check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
    function() {
        return this;
    }() || commonjsGlobal || Function('return this')();
    var fails$u = function(exec) {
        try {
            return !!exec();
        } catch (error) {
            return true;
        }
    };
    var fails$t = fails$u;
    var functionBindNative = !fails$t(function() {
        // eslint-disable-next-line es/no-function-prototype-bind -- safe
        var test = (function() {}).bind();
        // eslint-disable-next-line no-prototype-builtins -- safe
        return typeof test != 'function' || test.hasOwnProperty('prototype');
    });
    var NATIVE_BIND$4 = functionBindNative;
    var FunctionPrototype$4 = Function.prototype;
    var apply$6 = FunctionPrototype$4.apply;
    var call$k = FunctionPrototype$4.call;
    // eslint-disable-next-line es/no-reflect -- safe
    var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$4 ? call$k.bind(apply$6) : function() {
        return call$k.apply(apply$6, arguments);
    });
    var NATIVE_BIND$3 = functionBindNative;
    var FunctionPrototype$3 = Function.prototype;
    var call$j = FunctionPrototype$3.call;
    var uncurryThisWithBind = NATIVE_BIND$3 && FunctionPrototype$3.bind.bind(call$j, call$j);
    var functionUncurryThis = NATIVE_BIND$3 ? uncurryThisWithBind : function(fn) {
        return function() {
            return call$j.apply(fn, arguments);
        };
    };
    var uncurryThis$q = functionUncurryThis;
    var toString$9 = uncurryThis$q({}.toString);
    var stringSlice$1 = uncurryThis$q(''.slice);
    var classofRaw$2 = function(it) {
        return stringSlice$1(toString$9(it), 8, -1);
    };
    var classofRaw$1 = classofRaw$2;
    var uncurryThis$p = functionUncurryThis;
    var functionUncurryThisClause = function(fn) {
        // Nashorn bug:
        //   https://github.com/zloirock/core-js/issues/1128
        //   https://github.com/zloirock/core-js/issues/1130
        if (classofRaw$1(fn) === 'Function') return uncurryThis$p(fn);
    };
    var documentAll$2 = typeof document == 'object' && document.all;
    // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
    // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
    var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;
    var documentAll_1 = {
        all: documentAll$2,
        IS_HTMLDDA: IS_HTMLDDA
    };
    var $documentAll$1 = documentAll_1;
    var documentAll$1 = $documentAll$1.all;
    // `IsCallable` abstract operation
    // https://tc39.es/ecma262/#sec-iscallable
    var isCallable$m = $documentAll$1.IS_HTMLDDA ? function(argument) {
        return typeof argument == 'function' || argument === documentAll$1;
    } : function(argument) {
        return typeof argument == 'function';
    };
    var objectGetOwnPropertyDescriptor = {};
    var fails$s = fails$u;
    // Detect IE8's incomplete defineProperty implementation
    var descriptors = !fails$s(function() {
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        return Object.defineProperty({}, 1, {
            get: function() {
                return 7;
            }
        })[1] !== 7;
    });
    var NATIVE_BIND$2 = functionBindNative;
    var call$i = Function.prototype.call;
    var functionCall = NATIVE_BIND$2 ? call$i.bind(call$i) : function() {
        return call$i.apply(call$i, arguments);
    };
    var objectPropertyIsEnumerable = {};
    var $propertyIsEnumerable$1 = {}.propertyIsEnumerable;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getOwnPropertyDescriptor$7 = Object.getOwnPropertyDescriptor;
    // Nashorn ~ JDK8 bug
    var NASHORN_BUG = getOwnPropertyDescriptor$7 && !$propertyIsEnumerable$1.call({
        1: 2
    }, 1);
    // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
    objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor$7(this, V);
        return !!descriptor && descriptor.enumerable;
    } : $propertyIsEnumerable$1;
    var createPropertyDescriptor$7 = function(bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };
    var uncurryThis$o = functionUncurryThis;
    var fails$r = fails$u;
    var classof$f = classofRaw$2;
    var $Object$4 = Object;
    var split = uncurryThis$o(''.split);
    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var indexedObject = fails$r(function() {
        // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
        // eslint-disable-next-line no-prototype-builtins -- safe
        return !$Object$4('z').propertyIsEnumerable(0);
    }) ? function(it) {
        return classof$f(it) === 'String' ? split(it, '') : $Object$4(it);
    } : $Object$4;
    // we can't use just `it == null` since of `document.all` special case
    // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
    var isNullOrUndefined$6 = function(it) {
        return it === null || it === undefined;
    };
    var isNullOrUndefined$5 = isNullOrUndefined$6;
    var $TypeError$g = TypeError;
    // `RequireObjectCoercible` abstract operation
    // https://tc39.es/ecma262/#sec-requireobjectcoercible
    var requireObjectCoercible$3 = function(it) {
        if (isNullOrUndefined$5(it)) throw new $TypeError$g("Can't call method on " + it);
        return it;
    };
    // toObject with fallback for non-array-like ES3 strings
    var IndexedObject$3 = indexedObject;
    var requireObjectCoercible$2 = requireObjectCoercible$3;
    var toIndexedObject$a = function(it) {
        return IndexedObject$3(requireObjectCoercible$2(it));
    };
    var isCallable$l = isCallable$m;
    var $documentAll = documentAll_1;
    var documentAll = $documentAll.all;
    var isObject$h = $documentAll.IS_HTMLDDA ? function(it) {
        return typeof it == 'object' ? it !== null : isCallable$l(it) || it === documentAll;
    } : function(it) {
        return typeof it == 'object' ? it !== null : isCallable$l(it);
    };
    var path$o = {};
    var path$n = path$o;
    var global$o = global$p;
    var isCallable$k = isCallable$m;
    var aFunction = function(variable) {
        return isCallable$k(variable) ? variable : undefined;
    };
    var getBuiltIn$f = function(namespace, method) {
        return arguments.length < 2 ? aFunction(path$n[namespace]) || aFunction(global$o[namespace]) : path$n[namespace] && path$n[namespace][method] || global$o[namespace] && global$o[namespace][method];
    };
    var uncurryThis$n = functionUncurryThis;
    var objectIsPrototypeOf = uncurryThis$n({}.isPrototypeOf);
    var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';
    var global$n = global$p;
    var userAgent$5 = engineUserAgent;
    var process$3 = global$n.process;
    var Deno$1 = global$n.Deno;
    var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
    var v8 = versions && versions.v8;
    var match, version;
    if (v8) {
        match = v8.split('.');
        // in old Chrome, versions of V8 isn't V8 = Chrome / 10
        // but their correct versions are not interesting for us
        version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
    }
    // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
    // so check `userAgent` even if `.v8` exists, but 0
    if (!version && userAgent$5) {
        match = userAgent$5.match(/Edge\/(\d+)/);
        if (!match || match[1] >= 74) {
            match = userAgent$5.match(/Chrome\/(\d+)/);
            if (match) version = +match[1];
        }
    }
    var engineV8Version = version;
    /* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION$3 = engineV8Version;
    var fails$q = fails$u;
    var global$m = global$p;
    var $String$5 = global$m.String;
    // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
    var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$q(function() {
        var symbol = Symbol('symbol detection');
        // Chrome 38 Symbol has incorrect toString conversion
        // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
        // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
        // of course, fail.
        return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
        !Symbol.sham && V8_VERSION$3 && V8_VERSION$3 < 41;
    });
    /* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL$5 = symbolConstructorDetection;
    var useSymbolAsUid = NATIVE_SYMBOL$5 && !Symbol.sham && typeof Symbol.iterator == 'symbol';
    var getBuiltIn$e = getBuiltIn$f;
    var isCallable$j = isCallable$m;
    var isPrototypeOf$k = objectIsPrototypeOf;
    var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
    var $Object$3 = Object;
    var isSymbol$5 = USE_SYMBOL_AS_UID$1 ? function(it) {
        return typeof it == 'symbol';
    } : function(it) {
        var $Symbol = getBuiltIn$e('Symbol');
        return isCallable$j($Symbol) && isPrototypeOf$k($Symbol.prototype, $Object$3(it));
    };
    var $String$4 = String;
    var tryToString$6 = function(argument) {
        try {
            return $String$4(argument);
        } catch (error) {
            return 'Object';
        }
    };
    var isCallable$i = isCallable$m;
    var tryToString$5 = tryToString$6;
    var $TypeError$f = TypeError;
    // `Assert: IsCallable(argument) is true`
    var aCallable$e = function(argument) {
        if (isCallable$i(argument)) return argument;
        throw new $TypeError$f(tryToString$5(argument) + ' is not a function');
    };
    var aCallable$d = aCallable$e;
    var isNullOrUndefined$4 = isNullOrUndefined$6;
    // `GetMethod` abstract operation
    // https://tc39.es/ecma262/#sec-getmethod
    var getMethod$3 = function(V, P) {
        var func = V[P];
        return isNullOrUndefined$4(func) ? undefined : aCallable$d(func);
    };
    var call$h = functionCall;
    var isCallable$h = isCallable$m;
    var isObject$g = isObject$h;
    var $TypeError$e = TypeError;
    // `OrdinaryToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-ordinarytoprimitive
    var ordinaryToPrimitive$1 = function(input, pref) {
        var fn, val;
        if (pref === 'string' && isCallable$h(fn = input.toString) && !isObject$g(val = call$h(fn, input))) return val;
        if (isCallable$h(fn = input.valueOf) && !isObject$g(val = call$h(fn, input))) return val;
        if (pref !== 'string' && isCallable$h(fn = input.toString) && !isObject$g(val = call$h(fn, input))) return val;
        throw new $TypeError$e("Can't convert object to primitive value");
    };
    var shared$7 = {
        exports: {}
    };
    var isPure = true;
    var global$l = global$p;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var defineProperty$e = Object.defineProperty;
    var defineGlobalProperty$1 = function(key, value) {
        try {
            defineProperty$e(global$l, key, {
                value: value,
                configurable: true,
                writable: true
            });
        } catch (error) {
            global$l[key] = value;
        }
        return value;
    };
    var global$k = global$p;
    var defineGlobalProperty = defineGlobalProperty$1;
    var SHARED = '__core-js_shared__';
    var store$3 = global$k[SHARED] || defineGlobalProperty(SHARED, {});
    var sharedStore = store$3;
    var store$2 = sharedStore;
    (shared$7.exports = function(key, value) {
        return store$2[key] || (store$2[key] = value !== undefined ? value : {});
    })('versions', []).push({
        version: '3.33.2',
        mode: 'pure',
        copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
        license: 'https://github.com/zloirock/core-js/blob/v3.33.2/LICENSE',
        source: 'https://github.com/zloirock/core-js'
    });
    var sharedExports = shared$7.exports;
    var requireObjectCoercible$1 = requireObjectCoercible$3;
    var $Object$2 = Object;
    // `ToObject` abstract operation
    // https://tc39.es/ecma262/#sec-toobject
    var toObject$e = function(argument) {
        return $Object$2(requireObjectCoercible$1(argument));
    };
    var uncurryThis$m = functionUncurryThis;
    var toObject$d = toObject$e;
    var hasOwnProperty = uncurryThis$m({}.hasOwnProperty);
    // `HasOwnProperty` abstract operation
    // https://tc39.es/ecma262/#sec-hasownproperty
    // eslint-disable-next-line es/no-object-hasown -- safe
    var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
        return hasOwnProperty(toObject$d(it), key);
    };
    var uncurryThis$l = functionUncurryThis;
    var id$1 = 0;
    var postfix = Math.random();
    var toString$8 = uncurryThis$l(1.0.toString);
    var uid$4 = function(key) {
        return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$8(++id$1 + postfix, 36);
    };
    var global$j = global$p;
    var shared$6 = sharedExports;
    var hasOwn$j = hasOwnProperty_1;
    var uid$3 = uid$4;
    var NATIVE_SYMBOL$4 = symbolConstructorDetection;
    var USE_SYMBOL_AS_UID = useSymbolAsUid;
    var Symbol$3 = global$j.Symbol;
    var WellKnownSymbolsStore$2 = shared$6('wks');
    var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$3['for'] || Symbol$3 : Symbol$3 && Symbol$3.withoutSetter || uid$3;
    var wellKnownSymbol$n = function(name) {
        if (!hasOwn$j(WellKnownSymbolsStore$2, name)) WellKnownSymbolsStore$2[name] = NATIVE_SYMBOL$4 && hasOwn$j(Symbol$3, name) ? Symbol$3[name] : createWellKnownSymbol('Symbol.' + name);
        return WellKnownSymbolsStore$2[name];
    };
    var call$g = functionCall;
    var isObject$f = isObject$h;
    var isSymbol$4 = isSymbol$5;
    var getMethod$2 = getMethod$3;
    var ordinaryToPrimitive = ordinaryToPrimitive$1;
    var wellKnownSymbol$m = wellKnownSymbol$n;
    var $TypeError$d = TypeError;
    var TO_PRIMITIVE = wellKnownSymbol$m('toPrimitive');
    // `ToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-toprimitive
    var toPrimitive$6 = function(input, pref) {
        if (!isObject$f(input) || isSymbol$4(input)) return input;
        var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
        var result;
        if (exoticToPrim) {
            if (pref === undefined) pref = 'default';
            result = call$g(exoticToPrim, input, pref);
            if (!isObject$f(result) || isSymbol$4(result)) return result;
            throw new $TypeError$d("Can't convert object to primitive value");
        }
        if (pref === undefined) pref = 'number';
        return ordinaryToPrimitive(input, pref);
    };
    var toPrimitive$5 = toPrimitive$6;
    var isSymbol$3 = isSymbol$5;
    // `ToPropertyKey` abstract operation
    // https://tc39.es/ecma262/#sec-topropertykey
    var toPropertyKey$4 = function(argument) {
        var key = toPrimitive$5(argument, 'string');
        return isSymbol$3(key) ? key : key + '';
    };
    var global$i = global$p;
    var isObject$e = isObject$h;
    var document$3 = global$i.document;
    // typeof document.createElement is 'object' in old IE
    var EXISTS$1 = isObject$e(document$3) && isObject$e(document$3.createElement);
    var documentCreateElement$1 = function(it) {
        return EXISTS$1 ? document$3.createElement(it) : {};
    };
    var DESCRIPTORS$h = descriptors;
    var fails$p = fails$u;
    var createElement$1 = documentCreateElement$1;
    // Thanks to IE8 for its funny defineProperty
    var ie8DomDefine = !DESCRIPTORS$h && !fails$p(function() {
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        return Object.defineProperty(createElement$1('div'), 'a', {
            get: function() {
                return 7;
            }
        }).a !== 7;
    });
    var DESCRIPTORS$g = descriptors;
    var call$f = functionCall;
    var propertyIsEnumerableModule$2 = objectPropertyIsEnumerable;
    var createPropertyDescriptor$6 = createPropertyDescriptor$7;
    var toIndexedObject$9 = toIndexedObject$a;
    var toPropertyKey$3 = toPropertyKey$4;
    var hasOwn$i = hasOwnProperty_1;
    var IE8_DOM_DEFINE$1 = ie8DomDefine;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var $getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
    objectGetOwnPropertyDescriptor.f = DESCRIPTORS$g ? $getOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject$9(O);
        P = toPropertyKey$3(P);
        if (IE8_DOM_DEFINE$1) try {
            return $getOwnPropertyDescriptor$2(O, P);
        } catch (error) {}
        if (hasOwn$i(O, P)) return createPropertyDescriptor$6(!call$f(propertyIsEnumerableModule$2.f, O, P), O[P]);
    };
    var fails$o = fails$u;
    var isCallable$g = isCallable$m;
    var replacement = /#|\.prototype\./;
    var isForced$2 = function(feature, detection) {
        var value = data[normalize(feature)];
        return value === POLYFILL ? true : value === NATIVE ? false : isCallable$g(detection) ? fails$o(detection) : !!detection;
    };
    var normalize = isForced$2.normalize = function(string) {
        return String(string).replace(replacement, '.').toLowerCase();
    };
    var data = isForced$2.data = {};
    var NATIVE = isForced$2.NATIVE = 'N';
    var POLYFILL = isForced$2.POLYFILL = 'P';
    var isForced_1 = isForced$2;
    var uncurryThis$k = functionUncurryThisClause;
    var aCallable$c = aCallable$e;
    var NATIVE_BIND$1 = functionBindNative;
    var bind$i = uncurryThis$k(uncurryThis$k.bind);
    // optional / simple context binding
    var functionBindContext = function(fn, that) {
        aCallable$c(fn);
        return that === undefined ? fn : NATIVE_BIND$1 ? bind$i(fn, that) : function() {
            return fn.apply(that, arguments);
        };
    };
    var objectDefineProperty = {};
    var DESCRIPTORS$f = descriptors;
    var fails$n = fails$u;
    // V8 ~ Chrome 36-
    // https://bugs.chromium.org/p/v8/issues/detail?id=3334
    var v8PrototypeDefineBug = DESCRIPTORS$f && fails$n(function() {
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        return Object.defineProperty(function() {}, 'prototype', {
            value: 42,
            writable: false
        }).prototype !== 42;
    });
    var isObject$d = isObject$h;
    var $String$3 = String;
    var $TypeError$c = TypeError;
    // `Assert: Type(argument) is Object`
    var anObject$d = function(argument) {
        if (isObject$d(argument)) return argument;
        throw new $TypeError$c($String$3(argument) + ' is not an object');
    };
    var DESCRIPTORS$e = descriptors;
    var IE8_DOM_DEFINE = ie8DomDefine;
    var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
    var anObject$c = anObject$d;
    var toPropertyKey$2 = toPropertyKey$4;
    var $TypeError$b = TypeError;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var $defineProperty$1 = Object.defineProperty;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
    var ENUMERABLE = 'enumerable';
    var CONFIGURABLE$1 = 'configurable';
    var WRITABLE = 'writable';
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    objectDefineProperty.f = DESCRIPTORS$e ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
        anObject$c(O);
        P = toPropertyKey$2(P);
        anObject$c(Attributes);
        if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
            var current = $getOwnPropertyDescriptor$1(O, P);
            if (current && current[WRITABLE]) {
                O[P] = Attributes.value;
                Attributes = {
                    configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
                    enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                    writable: false
                };
            }
        }
        return $defineProperty$1(O, P, Attributes);
    } : $defineProperty$1 : function defineProperty(O, P, Attributes) {
        anObject$c(O);
        P = toPropertyKey$2(P);
        anObject$c(Attributes);
        if (IE8_DOM_DEFINE) try {
            return $defineProperty$1(O, P, Attributes);
        } catch (error) {}
        if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$b('Accessors not supported');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
    };
    var DESCRIPTORS$d = descriptors;
    var definePropertyModule$4 = objectDefineProperty;
    var createPropertyDescriptor$5 = createPropertyDescriptor$7;
    var createNonEnumerableProperty$9 = DESCRIPTORS$d ? function(object, key, value) {
        return definePropertyModule$4.f(object, key, createPropertyDescriptor$5(1, value));
    } : function(object, key, value) {
        object[key] = value;
        return object;
    };
    var global$h = global$p;
    var apply$5 = functionApply;
    var uncurryThis$j = functionUncurryThisClause;
    var isCallable$f = isCallable$m;
    var getOwnPropertyDescriptor$6 = objectGetOwnPropertyDescriptor.f;
    var isForced$1 = isForced_1;
    var path$m = path$o;
    var bind$h = functionBindContext;
    var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
    var hasOwn$h = hasOwnProperty_1;
    var wrapConstructor = function(NativeConstructor) {
        var Wrapper = function(a, b, c) {
            if (this instanceof Wrapper) {
                switch(arguments.length){
                    case 0:
                        return new NativeConstructor();
                    case 1:
                        return new NativeConstructor(a);
                    case 2:
                        return new NativeConstructor(a, b);
                }
                return new NativeConstructor(a, b, c);
            }
            return apply$5(NativeConstructor, this, arguments);
        };
        Wrapper.prototype = NativeConstructor.prototype;
        return Wrapper;
    };
    /*
    options.target         - name of the target object
    options.global         - target is the global object
    options.stat           - export as static methods of target
    options.proto          - export as prototype methods of target
    options.real           - real prototype method for the `pure` version
    options.forced         - export even if the native feature is available
    options.bind           - bind methods to the target, required for the `pure` version
    options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
    options.unsafe         - use the simple assignment of property instead of delete + defineProperty
    options.sham           - add a flag to not completely full polyfills
    options.enumerable     - export as enumerable property
    options.dontCallGetSet - prevent calling a getter on target
    options.name           - the .name of the function if it does not match the key
  */ var _export = function(options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var PROTO = options.proto;
        var nativeSource = GLOBAL ? global$h : STATIC ? global$h[TARGET] : (global$h[TARGET] || {}).prototype;
        var target = GLOBAL ? path$m : path$m[TARGET] || createNonEnumerableProperty$8(path$m, TARGET, {})[TARGET];
        var targetPrototype = target.prototype;
        var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
        var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
        for(key in source){
            FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
            // contains in native
            USE_NATIVE = !FORCED && nativeSource && hasOwn$h(nativeSource, key);
            targetProperty = target[key];
            if (USE_NATIVE) {
                if (options.dontCallGetSet) {
                    descriptor = getOwnPropertyDescriptor$6(nativeSource, key);
                    nativeProperty = descriptor && descriptor.value;
                } else nativeProperty = nativeSource[key];
            }
            // export native or implementation
            sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
            if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;
            // bind methods to global for calling from export context
            if (options.bind && USE_NATIVE) resultProperty = bind$h(sourceProperty, global$h);
            else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
            else if (PROTO && isCallable$f(sourceProperty)) resultProperty = uncurryThis$j(sourceProperty);
            else resultProperty = sourceProperty;
            // add a flag to not completely full polyfills
            if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty$8(resultProperty, 'sham', true);
            createNonEnumerableProperty$8(target, key, resultProperty);
            if (PROTO) {
                VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
                if (!hasOwn$h(path$m, VIRTUAL_PROTOTYPE)) createNonEnumerableProperty$8(path$m, VIRTUAL_PROTOTYPE, {});
                // export virtual prototype methods
                createNonEnumerableProperty$8(path$m[VIRTUAL_PROTOTYPE], key, sourceProperty);
                // export real prototype methods
                if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) createNonEnumerableProperty$8(targetPrototype, key, sourceProperty);
            }
        }
    };
    var $$P = _export;
    var DESCRIPTORS$c = descriptors;
    var defineProperty$d = objectDefineProperty.f;
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    $$P({
        target: 'Object',
        stat: true,
        forced: Object.defineProperty !== defineProperty$d,
        sham: !DESCRIPTORS$c
    }, {
        defineProperty: defineProperty$d
    });
    var path$l = path$o;
    var Object$4 = path$l.Object;
    var defineProperty$c = defineProperty$f.exports = function defineProperty(it, key, desc) {
        return Object$4.defineProperty(it, key, desc);
    };
    if (Object$4.defineProperty.sham) defineProperty$c.sham = true;
    var definePropertyExports = defineProperty$f.exports;
    var parent$18 = definePropertyExports;
    var defineProperty$b = parent$18;
    var parent$17 = defineProperty$b;
    var defineProperty$a = parent$17;
    var parent$16 = defineProperty$a;
    var defineProperty$9 = parent$16;
    var defineProperty$8 = defineProperty$9;
    var _Object$defineProperty$1 = /*@__PURE__*/ getDefaultExportFromCjs(defineProperty$8);
    var classof$e = classofRaw$2;
    // `IsArray` abstract operation
    // https://tc39.es/ecma262/#sec-isarray
    // eslint-disable-next-line es/no-array-isarray -- safe
    var isArray$e = Array.isArray || function isArray(argument) {
        return classof$e(argument) === 'Array';
    };
    var ceil = Math.ceil;
    var floor$1 = Math.floor;
    // `Math.trunc` method
    // https://tc39.es/ecma262/#sec-math.trunc
    // eslint-disable-next-line es/no-math-trunc -- safe
    var mathTrunc = Math.trunc || function trunc(x) {
        var n = +x;
        return (n > 0 ? floor$1 : ceil)(n);
    };
    var trunc = mathTrunc;
    // `ToIntegerOrInfinity` abstract operation
    // https://tc39.es/ecma262/#sec-tointegerorinfinity
    var toIntegerOrInfinity$4 = function(argument) {
        var number = +argument;
        // eslint-disable-next-line no-self-compare -- NaN check
        return number !== number || number === 0 ? 0 : trunc(number);
    };
    var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;
    var min$2 = Math.min;
    // `ToLength` abstract operation
    // https://tc39.es/ecma262/#sec-tolength
    var toLength$1 = function(argument) {
        return argument > 0 ? min$2(toIntegerOrInfinity$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };
    var toLength = toLength$1;
    // `LengthOfArrayLike` abstract operation
    // https://tc39.es/ecma262/#sec-lengthofarraylike
    var lengthOfArrayLike$d = function(obj) {
        return toLength(obj.length);
    };
    var $TypeError$a = TypeError;
    var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
    var doesNotExceedSafeInteger$4 = function(it) {
        if (it > MAX_SAFE_INTEGER) throw $TypeError$a('Maximum allowed index exceeded');
        return it;
    };
    var toPropertyKey$1 = toPropertyKey$4;
    var definePropertyModule$3 = objectDefineProperty;
    var createPropertyDescriptor$4 = createPropertyDescriptor$7;
    var createProperty$6 = function(object, key, value) {
        var propertyKey = toPropertyKey$1(key);
        if (propertyKey in object) definePropertyModule$3.f(object, propertyKey, createPropertyDescriptor$4(0, value));
        else object[propertyKey] = value;
    };
    var wellKnownSymbol$l = wellKnownSymbol$n;
    var TO_STRING_TAG$4 = wellKnownSymbol$l('toStringTag');
    var test$2 = {};
    test$2[TO_STRING_TAG$4] = 'z';
    var toStringTagSupport = String(test$2) === '[object z]';
    var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
    var isCallable$e = isCallable$m;
    var classofRaw = classofRaw$2;
    var wellKnownSymbol$k = wellKnownSymbol$n;
    var TO_STRING_TAG$3 = wellKnownSymbol$k('toStringTag');
    var $Object$1 = Object;
    // ES3 wrong here
    var CORRECT_ARGUMENTS = classofRaw(function() {
        return arguments;
    }()) === 'Arguments';
    // fallback for IE11 Script Access Denied error
    var tryGet = function(it, key) {
        try {
            return it[key];
        } catch (error) {}
    };
    // getting tag from ES6+ `Object.prototype.toString`
    var classof$d = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function(it) {
        var O, tag, result;
        return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$3)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === 'Object' && isCallable$e(O.callee) ? 'Arguments' : result;
    };
    var uncurryThis$i = functionUncurryThis;
    var isCallable$d = isCallable$m;
    var store$1 = sharedStore;
    var functionToString = uncurryThis$i(Function.toString);
    // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
    if (!isCallable$d(store$1.inspectSource)) store$1.inspectSource = function(it) {
        return functionToString(it);
    };
    var inspectSource$2 = store$1.inspectSource;
    var uncurryThis$h = functionUncurryThis;
    var fails$m = fails$u;
    var isCallable$c = isCallable$m;
    var classof$c = classof$d;
    var getBuiltIn$d = getBuiltIn$f;
    var inspectSource$1 = inspectSource$2;
    var noop = function() {};
    var empty = [];
    var construct$4 = getBuiltIn$d('Reflect', 'construct');
    var constructorRegExp = /^\s*(?:class|function)\b/;
    var exec$1 = uncurryThis$h(constructorRegExp.exec);
    var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
    var isConstructorModern = function isConstructor(argument) {
        if (!isCallable$c(argument)) return false;
        try {
            construct$4(noop, empty, argument);
            return true;
        } catch (error) {
            return false;
        }
    };
    var isConstructorLegacy = function isConstructor(argument) {
        if (!isCallable$c(argument)) return false;
        switch(classof$c(argument)){
            case 'AsyncFunction':
            case 'GeneratorFunction':
            case 'AsyncGeneratorFunction':
                return false;
        }
        try {
            // we can't check .prototype since constructors produced by .bind haven't it
            // `Function#toString` throws on some built-it function in some legacy engines
            // (for example, `DOMQuad` and similar in FF41-)
            return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource$1(argument));
        } catch (error) {
            return true;
        }
    };
    isConstructorLegacy.sham = true;
    // `IsConstructor` abstract operation
    // https://tc39.es/ecma262/#sec-isconstructor
    var isConstructor$4 = !construct$4 || fails$m(function() {
        var called;
        return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
            called = true;
        }) || called;
    }) ? isConstructorLegacy : isConstructorModern;
    var isArray$d = isArray$e;
    var isConstructor$3 = isConstructor$4;
    var isObject$c = isObject$h;
    var wellKnownSymbol$j = wellKnownSymbol$n;
    var SPECIES$5 = wellKnownSymbol$j('species');
    var $Array$3 = Array;
    // a part of `ArraySpeciesCreate` abstract operation
    // https://tc39.es/ecma262/#sec-arrayspeciescreate
    var arraySpeciesConstructor$1 = function(originalArray) {
        var C;
        if (isArray$d(originalArray)) {
            C = originalArray.constructor;
            // cross-realm fallback
            if (isConstructor$3(C) && (C === $Array$3 || isArray$d(C.prototype))) C = undefined;
            else if (isObject$c(C)) {
                C = C[SPECIES$5];
                if (C === null) C = undefined;
            }
        }
        return C === undefined ? $Array$3 : C;
    };
    var arraySpeciesConstructor = arraySpeciesConstructor$1;
    // `ArraySpeciesCreate` abstract operation
    // https://tc39.es/ecma262/#sec-arrayspeciescreate
    var arraySpeciesCreate$4 = function(originalArray, length) {
        return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
    };
    var fails$l = fails$u;
    var wellKnownSymbol$i = wellKnownSymbol$n;
    var V8_VERSION$2 = engineV8Version;
    var SPECIES$4 = wellKnownSymbol$i('species');
    var arrayMethodHasSpeciesSupport$5 = function(METHOD_NAME) {
        // We can't use this feature detection in V8 since it causes
        // deoptimization and serious performance degradation
        // https://github.com/zloirock/core-js/issues/677
        return V8_VERSION$2 >= 51 || !fails$l(function() {
            var array = [];
            var constructor = array.constructor = {};
            constructor[SPECIES$4] = function() {
                return {
                    foo: 1
                };
            };
            return array[METHOD_NAME](Boolean).foo !== 1;
        });
    };
    var $$O = _export;
    var fails$k = fails$u;
    var isArray$c = isArray$e;
    var isObject$b = isObject$h;
    var toObject$c = toObject$e;
    var lengthOfArrayLike$c = lengthOfArrayLike$d;
    var doesNotExceedSafeInteger$3 = doesNotExceedSafeInteger$4;
    var createProperty$5 = createProperty$6;
    var arraySpeciesCreate$3 = arraySpeciesCreate$4;
    var arrayMethodHasSpeciesSupport$4 = arrayMethodHasSpeciesSupport$5;
    var wellKnownSymbol$h = wellKnownSymbol$n;
    var V8_VERSION$1 = engineV8Version;
    var IS_CONCAT_SPREADABLE = wellKnownSymbol$h('isConcatSpreadable');
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/679
    var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION$1 >= 51 || !fails$k(function() {
        var array = [];
        array[IS_CONCAT_SPREADABLE] = false;
        return array.concat()[0] !== array;
    });
    var isConcatSpreadable = function(O) {
        if (!isObject$b(O)) return false;
        var spreadable = O[IS_CONCAT_SPREADABLE];
        return spreadable !== undefined ? !!spreadable : isArray$c(O);
    };
    var FORCED$6 = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport$4('concat');
    // `Array.prototype.concat` method
    // https://tc39.es/ecma262/#sec-array.prototype.concat
    // with adding support of @@isConcatSpreadable and @@species
    $$O({
        target: 'Array',
        proto: true,
        arity: 1,
        forced: FORCED$6
    }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        concat: function concat(arg) {
            var O = toObject$c(this);
            var A = arraySpeciesCreate$3(O, 0);
            var n = 0;
            var i, k, length, len, E;
            for(i = -1, length = arguments.length; i < length; i++){
                E = i === -1 ? O : arguments[i];
                if (isConcatSpreadable(E)) {
                    len = lengthOfArrayLike$c(E);
                    doesNotExceedSafeInteger$3(n + len);
                    for(k = 0; k < len; k++, n++)if (k in E) createProperty$5(A, n, E[k]);
                } else {
                    doesNotExceedSafeInteger$3(n + 1);
                    createProperty$5(A, n++, E);
                }
            }
            A.length = n;
            return A;
        }
    });
    var classof$b = classof$d;
    var $String$2 = String;
    var toString$7 = function(argument) {
        if (classof$b(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
        return $String$2(argument);
    };
    var objectDefineProperties = {};
    var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;
    var max$3 = Math.max;
    var min$1 = Math.min;
    // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
    var toAbsoluteIndex$4 = function(index, length) {
        var integer = toIntegerOrInfinity$2(index);
        return integer < 0 ? max$3(integer + length, 0) : min$1(integer, length);
    };
    var toIndexedObject$8 = toIndexedObject$a;
    var toAbsoluteIndex$3 = toAbsoluteIndex$4;
    var lengthOfArrayLike$b = lengthOfArrayLike$d;
    // `Array.prototype.{ indexOf, includes }` methods implementation
    var createMethod$3 = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
            var O = toIndexedObject$8($this);
            var length = lengthOfArrayLike$b(O);
            var index = toAbsoluteIndex$3(fromIndex, length);
            var value;
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare -- NaN check
            if (IS_INCLUDES && el !== el) while(length > index){
                value = O[index++];
                // eslint-disable-next-line no-self-compare -- NaN check
                if (value !== value) return true;
            // Array#indexOf ignores holes, Array#includes - not
            }
            else for(; length > index; index++){
                if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
        };
    };
    var arrayIncludes = {
        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        includes: createMethod$3(true),
        // `Array.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-array.prototype.indexof
        indexOf: createMethod$3(false)
    };
    var hiddenKeys$6 = {};
    var uncurryThis$g = functionUncurryThis;
    var hasOwn$g = hasOwnProperty_1;
    var toIndexedObject$7 = toIndexedObject$a;
    var indexOf = arrayIncludes.indexOf;
    var hiddenKeys$5 = hiddenKeys$6;
    var push$c = uncurryThis$g([].push);
    var objectKeysInternal = function(object, names) {
        var O = toIndexedObject$7(object);
        var i = 0;
        var result = [];
        var key;
        for(key in O)!hasOwn$g(hiddenKeys$5, key) && hasOwn$g(O, key) && push$c(result, key);
        // Don't enum bug & hidden keys
        while(names.length > i)if (hasOwn$g(O, key = names[i++])) ~indexOf(result, key) || push$c(result, key);
        return result;
    };
    // IE8- don't enum bug keys
    var enumBugKeys$3 = [
        'constructor',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'toLocaleString',
        'toString',
        'valueOf'
    ];
    var internalObjectKeys$1 = objectKeysInternal;
    var enumBugKeys$2 = enumBugKeys$3;
    // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys
    // eslint-disable-next-line es/no-object-keys -- safe
    var objectKeys$3 = Object.keys || function keys(O) {
        return internalObjectKeys$1(O, enumBugKeys$2);
    };
    var DESCRIPTORS$b = descriptors;
    var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
    var definePropertyModule$2 = objectDefineProperty;
    var anObject$b = anObject$d;
    var toIndexedObject$6 = toIndexedObject$a;
    var objectKeys$2 = objectKeys$3;
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    // eslint-disable-next-line es/no-object-defineproperties -- safe
    objectDefineProperties.f = DESCRIPTORS$b && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject$b(O);
        var props = toIndexedObject$6(Properties);
        var keys = objectKeys$2(Properties);
        var length = keys.length;
        var index = 0;
        var key;
        while(length > index)definePropertyModule$2.f(O, key = keys[index++], props[key]);
        return O;
    };
    var getBuiltIn$c = getBuiltIn$f;
    var html$2 = getBuiltIn$c('document', 'documentElement');
    var shared$5 = sharedExports;
    var uid$2 = uid$4;
    var keys$7 = shared$5('keys');
    var sharedKey$4 = function(key) {
        return keys$7[key] || (keys$7[key] = uid$2(key));
    };
    /* global ActiveXObject -- old IE, WSH */ var anObject$a = anObject$d;
    var definePropertiesModule$1 = objectDefineProperties;
    var enumBugKeys$1 = enumBugKeys$3;
    var hiddenKeys$4 = hiddenKeys$6;
    var html$1 = html$2;
    var documentCreateElement = documentCreateElement$1;
    var sharedKey$3 = sharedKey$4;
    var GT = '>';
    var LT = '<';
    var PROTOTYPE$1 = 'prototype';
    var SCRIPT = 'script';
    var IE_PROTO$1 = sharedKey$3('IE_PROTO');
    var EmptyConstructor = function() {};
    var scriptTag = function(content) {
        return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
    };
    // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
    var NullProtoObjectViaActiveX = function(activeXDocument) {
        activeXDocument.write(scriptTag(''));
        activeXDocument.close();
        var temp = activeXDocument.parentWindow.Object;
        activeXDocument = null; // avoid memory leak
        return temp;
    };
    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var NullProtoObjectViaIFrame = function() {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = documentCreateElement('iframe');
        var JS = 'java' + SCRIPT + ':';
        var iframeDocument;
        iframe.style.display = 'none';
        html$1.appendChild(iframe);
        // https://github.com/zloirock/core-js/issues/475
        iframe.src = String(JS);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(scriptTag('document.F=Object'));
        iframeDocument.close();
        return iframeDocument.F;
    };
    // Check for document.domain and active x support
    // No need to use active x approach when document.domain is not set
    // see https://github.com/es-shims/es5-shim/issues/150
    // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
    // avoid IE GC bug
    var activeXDocument;
    var NullProtoObject = function() {
        try {
            activeXDocument = new ActiveXObject('htmlfile');
        } catch (error) {}
        NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
         : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
        var length = enumBugKeys$1.length;
        while(length--)delete NullProtoObject[PROTOTYPE$1][enumBugKeys$1[length]];
        return NullProtoObject();
    };
    hiddenKeys$4[IE_PROTO$1] = true;
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    // eslint-disable-next-line es/no-object-create -- safe
    var objectCreate = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
            EmptyConstructor[PROTOTYPE$1] = anObject$a(O);
            result = new EmptyConstructor();
            EmptyConstructor[PROTOTYPE$1] = null;
            // add "__proto__" for Object.getPrototypeOf polyfill
            result[IE_PROTO$1] = O;
        } else result = NullProtoObject();
        return Properties === undefined ? result : definePropertiesModule$1.f(result, Properties);
    };
    var objectGetOwnPropertyNames = {};
    var internalObjectKeys = objectKeysInternal;
    var enumBugKeys = enumBugKeys$3;
    var hiddenKeys$3 = enumBugKeys.concat('length', 'prototype');
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    // eslint-disable-next-line es/no-object-getownpropertynames -- safe
    objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return internalObjectKeys(O, hiddenKeys$3);
    };
    var objectGetOwnPropertyNamesExternal = {};
    var toAbsoluteIndex$2 = toAbsoluteIndex$4;
    var lengthOfArrayLike$a = lengthOfArrayLike$d;
    var createProperty$4 = createProperty$6;
    var $Array$2 = Array;
    var max$2 = Math.max;
    var arraySliceSimple = function(O, start, end) {
        var length = lengthOfArrayLike$a(O);
        var k = toAbsoluteIndex$2(start, length);
        var fin = toAbsoluteIndex$2(end === undefined ? length : end, length);
        var result = $Array$2(max$2(fin - k, 0));
        var n = 0;
        for(; k < fin; k++, n++)createProperty$4(result, n, O[k]);
        result.length = n;
        return result;
    };
    /* eslint-disable es/no-object-getownpropertynames -- safe */ var classof$a = classofRaw$2;
    var toIndexedObject$5 = toIndexedObject$a;
    var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
    var arraySlice$6 = arraySliceSimple;
    var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    var getWindowNames = function(it) {
        try {
            return $getOwnPropertyNames$1(it);
        } catch (error) {
            return arraySlice$6(windowNames);
        }
    };
    // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
    objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
        return windowNames && classof$a(it) === 'Window' ? getWindowNames(it) : $getOwnPropertyNames$1(toIndexedObject$5(it));
    };
    var objectGetOwnPropertySymbols = {};
    // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
    objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
    var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
    var defineBuiltIn$6 = function(target, key, value, options) {
        if (options && options.enumerable) target[key] = value;
        else createNonEnumerableProperty$7(target, key, value);
        return target;
    };
    var defineProperty$7 = objectDefineProperty;
    var defineBuiltInAccessor$3 = function(target, name, descriptor) {
        return defineProperty$7.f(target, name, descriptor);
    };
    var wellKnownSymbolWrapped = {};
    var wellKnownSymbol$g = wellKnownSymbol$n;
    wellKnownSymbolWrapped.f = wellKnownSymbol$g;
    var path$k = path$o;
    var hasOwn$f = hasOwnProperty_1;
    var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
    var defineProperty$6 = objectDefineProperty.f;
    var wellKnownSymbolDefine = function(NAME) {
        var Symbol1 = path$k.Symbol || (path$k.Symbol = {});
        if (!hasOwn$f(Symbol1, NAME)) defineProperty$6(Symbol1, NAME, {
            value: wrappedWellKnownSymbolModule$1.f(NAME)
        });
    };
    var call$e = functionCall;
    var getBuiltIn$b = getBuiltIn$f;
    var wellKnownSymbol$f = wellKnownSymbol$n;
    var defineBuiltIn$5 = defineBuiltIn$6;
    var symbolDefineToPrimitive = function() {
        var Symbol1 = getBuiltIn$b('Symbol');
        var SymbolPrototype = Symbol1 && Symbol1.prototype;
        var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
        var TO_PRIMITIVE = wellKnownSymbol$f('toPrimitive');
        if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
        // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
        // eslint-disable-next-line no-unused-vars -- required for .length
        defineBuiltIn$5(SymbolPrototype, TO_PRIMITIVE, function(hint) {
            return call$e(valueOf, this);
        }, {
            arity: 1
        });
    };
    var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
    var classof$9 = classof$d;
    // `Object.prototype.toString` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.tostring
    var objectToString = TO_STRING_TAG_SUPPORT$1 ? ({}).toString : function toString() {
        return '[object ' + classof$9(this) + ']';
    };
    var TO_STRING_TAG_SUPPORT = toStringTagSupport;
    var defineProperty$5 = objectDefineProperty.f;
    var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;
    var hasOwn$e = hasOwnProperty_1;
    var toString$6 = objectToString;
    var wellKnownSymbol$e = wellKnownSymbol$n;
    var TO_STRING_TAG$2 = wellKnownSymbol$e('toStringTag');
    var setToStringTag$7 = function(it, TAG, STATIC, SET_METHOD) {
        if (it) {
            var target = STATIC ? it : it.prototype;
            if (!hasOwn$e(target, TO_STRING_TAG$2)) defineProperty$5(target, TO_STRING_TAG$2, {
                configurable: true,
                value: TAG
            });
            if (SET_METHOD && !TO_STRING_TAG_SUPPORT) createNonEnumerableProperty$6(target, 'toString', toString$6);
        }
    };
    var global$g = global$p;
    var isCallable$b = isCallable$m;
    var WeakMap$1 = global$g.WeakMap;
    var weakMapBasicDetection = isCallable$b(WeakMap$1) && /native code/.test(String(WeakMap$1));
    var NATIVE_WEAK_MAP = weakMapBasicDetection;
    var global$f = global$p;
    var isObject$a = isObject$h;
    var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;
    var hasOwn$d = hasOwnProperty_1;
    var shared$4 = sharedStore;
    var sharedKey$2 = sharedKey$4;
    var hiddenKeys$2 = hiddenKeys$6;
    var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
    var TypeError$3 = global$f.TypeError;
    var WeakMap = global$f.WeakMap;
    var set$4, get, has;
    var enforce = function(it) {
        return has(it) ? get(it) : set$4(it, {});
    };
    var getterFor = function(TYPE) {
        return function(it) {
            var state;
            if (!isObject$a(it) || (state = get(it)).type !== TYPE) throw new TypeError$3('Incompatible receiver, ' + TYPE + ' required');
            return state;
        };
    };
    if (NATIVE_WEAK_MAP || shared$4.state) {
        var store = shared$4.state || (shared$4.state = new WeakMap());
        /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
        store.has = store.has;
        store.set = store.set;
        /* eslint-enable no-self-assign -- prototype methods protection */ set$4 = function(it, metadata) {
            if (store.has(it)) throw new TypeError$3(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            store.set(it, metadata);
            return metadata;
        };
        get = function(it) {
            return store.get(it) || {};
        };
        has = function(it) {
            return store.has(it);
        };
    } else {
        var STATE = sharedKey$2('state');
        hiddenKeys$2[STATE] = true;
        set$4 = function(it, metadata) {
            if (hasOwn$d(it, STATE)) throw new TypeError$3(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            createNonEnumerableProperty$5(it, STATE, metadata);
            return metadata;
        };
        get = function(it) {
            return hasOwn$d(it, STATE) ? it[STATE] : {};
        };
        has = function(it) {
            return hasOwn$d(it, STATE);
        };
    }
    var internalState = {
        set: set$4,
        get: get,
        has: has,
        enforce: enforce,
        getterFor: getterFor
    };
    var bind$g = functionBindContext;
    var uncurryThis$f = functionUncurryThis;
    var IndexedObject$2 = indexedObject;
    var toObject$b = toObject$e;
    var lengthOfArrayLike$9 = lengthOfArrayLike$d;
    var arraySpeciesCreate$2 = arraySpeciesCreate$4;
    var push$b = uncurryThis$f([].push);
    // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
    var createMethod$2 = function(TYPE) {
        var IS_MAP = TYPE === 1;
        var IS_FILTER = TYPE === 2;
        var IS_SOME = TYPE === 3;
        var IS_EVERY = TYPE === 4;
        var IS_FIND_INDEX = TYPE === 6;
        var IS_FILTER_REJECT = TYPE === 7;
        var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
        return function($this, callbackfn, that, specificCreate) {
            var O = toObject$b($this);
            var self1 = IndexedObject$2(O);
            var boundFunction = bind$g(callbackfn, that);
            var length = lengthOfArrayLike$9(self1);
            var index = 0;
            var create = specificCreate || arraySpeciesCreate$2;
            var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
            var value, result;
            for(; length > index; index++)if (NO_HOLES || index in self1) {
                value = self1[index];
                result = boundFunction(value, index, O);
                if (TYPE) {
                    if (IS_MAP) target[index] = result; // map
                    else if (result) switch(TYPE){
                        case 3:
                            return true; // some
                        case 5:
                            return value; // find
                        case 6:
                            return index; // findIndex
                        case 2:
                            push$b(target, value); // filter
                    }
                    else switch(TYPE){
                        case 4:
                            return false; // every
                        case 7:
                            push$b(target, value); // filterReject
                    }
                }
            }
            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
        };
    };
    var arrayIteration = {
        // `Array.prototype.forEach` method
        // https://tc39.es/ecma262/#sec-array.prototype.foreach
        forEach: createMethod$2(0),
        // `Array.prototype.map` method
        // https://tc39.es/ecma262/#sec-array.prototype.map
        map: createMethod$2(1),
        // `Array.prototype.filter` method
        // https://tc39.es/ecma262/#sec-array.prototype.filter
        filter: createMethod$2(2),
        // `Array.prototype.some` method
        // https://tc39.es/ecma262/#sec-array.prototype.some
        some: createMethod$2(3),
        // `Array.prototype.every` method
        // https://tc39.es/ecma262/#sec-array.prototype.every
        every: createMethod$2(4),
        // `Array.prototype.find` method
        // https://tc39.es/ecma262/#sec-array.prototype.find
        find: createMethod$2(5),
        // `Array.prototype.findIndex` method
        // https://tc39.es/ecma262/#sec-array.prototype.findIndex
        findIndex: createMethod$2(6),
        // `Array.prototype.filterReject` method
        // https://github.com/tc39/proposal-array-filtering
        filterReject: createMethod$2(7)
    };
    var $$N = _export;
    var global$e = global$p;
    var call$d = functionCall;
    var uncurryThis$e = functionUncurryThis;
    var DESCRIPTORS$a = descriptors;
    var NATIVE_SYMBOL$3 = symbolConstructorDetection;
    var fails$j = fails$u;
    var hasOwn$c = hasOwnProperty_1;
    var isPrototypeOf$j = objectIsPrototypeOf;
    var anObject$9 = anObject$d;
    var toIndexedObject$4 = toIndexedObject$a;
    var toPropertyKey = toPropertyKey$4;
    var $toString = toString$7;
    var createPropertyDescriptor$3 = createPropertyDescriptor$7;
    var nativeObjectCreate = objectCreate;
    var objectKeys$1 = objectKeys$3;
    var getOwnPropertyNamesModule$2 = objectGetOwnPropertyNames;
    var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
    var getOwnPropertySymbolsModule$3 = objectGetOwnPropertySymbols;
    var getOwnPropertyDescriptorModule$2 = objectGetOwnPropertyDescriptor;
    var definePropertyModule$1 = objectDefineProperty;
    var definePropertiesModule = objectDefineProperties;
    var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
    var defineBuiltIn$4 = defineBuiltIn$6;
    var defineBuiltInAccessor$2 = defineBuiltInAccessor$3;
    var shared$3 = sharedExports;
    var sharedKey$1 = sharedKey$4;
    var hiddenKeys$1 = hiddenKeys$6;
    var uid$1 = uid$4;
    var wellKnownSymbol$d = wellKnownSymbol$n;
    var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
    var defineWellKnownSymbol$l = wellKnownSymbolDefine;
    var defineSymbolToPrimitive$1 = symbolDefineToPrimitive;
    var setToStringTag$6 = setToStringTag$7;
    var InternalStateModule$5 = internalState;
    var $forEach$1 = arrayIteration.forEach;
    var HIDDEN = sharedKey$1('hidden');
    var SYMBOL = 'Symbol';
    var PROTOTYPE = 'prototype';
    var setInternalState$5 = InternalStateModule$5.set;
    var getInternalState$2 = InternalStateModule$5.getterFor(SYMBOL);
    var ObjectPrototype$2 = Object[PROTOTYPE];
    var $Symbol = global$e.Symbol;
    var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
    var RangeError = global$e.RangeError;
    var TypeError$2 = global$e.TypeError;
    var QObject = global$e.QObject;
    var nativeGetOwnPropertyDescriptor$1 = getOwnPropertyDescriptorModule$2.f;
    var nativeDefineProperty = definePropertyModule$1.f;
    var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
    var nativePropertyIsEnumerable = propertyIsEnumerableModule$1.f;
    var push$a = uncurryThis$e([].push);
    var AllSymbols = shared$3('symbols');
    var ObjectPrototypeSymbols = shared$3('op-symbols');
    var WellKnownSymbolsStore$1 = shared$3('wks');
    // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
    var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
    // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
    var fallbackDefineProperty = function(O, P, Attributes) {
        var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype$2, P);
        if (ObjectPrototypeDescriptor) delete ObjectPrototype$2[P];
        nativeDefineProperty(O, P, Attributes);
        if (ObjectPrototypeDescriptor && O !== ObjectPrototype$2) nativeDefineProperty(ObjectPrototype$2, P, ObjectPrototypeDescriptor);
    };
    var setSymbolDescriptor = DESCRIPTORS$a && fails$j(function() {
        return nativeObjectCreate(nativeDefineProperty({}, 'a', {
            get: function() {
                return nativeDefineProperty(this, 'a', {
                    value: 7
                }).a;
            }
        })).a !== 7;
    }) ? fallbackDefineProperty : nativeDefineProperty;
    var wrap = function(tag, description) {
        var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
        setInternalState$5(symbol, {
            type: SYMBOL,
            tag: tag,
            description: description
        });
        if (!DESCRIPTORS$a) symbol.description = description;
        return symbol;
    };
    var $defineProperty = function defineProperty(O, P, Attributes) {
        if (O === ObjectPrototype$2) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
        anObject$9(O);
        var key = toPropertyKey(P);
        anObject$9(Attributes);
        if (hasOwn$c(AllSymbols, key)) {
            if (!Attributes.enumerable) {
                if (!hasOwn$c(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor$3(1, {}));
                O[HIDDEN][key] = true;
            } else {
                if (hasOwn$c(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
                Attributes = nativeObjectCreate(Attributes, {
                    enumerable: createPropertyDescriptor$3(0, false)
                });
            }
            return setSymbolDescriptor(O, key, Attributes);
        }
        return nativeDefineProperty(O, key, Attributes);
    };
    var $defineProperties = function defineProperties(O, Properties) {
        anObject$9(O);
        var properties = toIndexedObject$4(Properties);
        var keys = objectKeys$1(properties).concat($getOwnPropertySymbols(properties));
        $forEach$1(keys, function(key) {
            if (!DESCRIPTORS$a || call$d($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
        });
        return O;
    };
    var $create = function create(O, Properties) {
        return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
    };
    var $propertyIsEnumerable = function propertyIsEnumerable(V) {
        var P = toPropertyKey(V);
        var enumerable = call$d(nativePropertyIsEnumerable, this, P);
        if (this === ObjectPrototype$2 && hasOwn$c(AllSymbols, P) && !hasOwn$c(ObjectPrototypeSymbols, P)) return false;
        return enumerable || !hasOwn$c(this, P) || !hasOwn$c(AllSymbols, P) || hasOwn$c(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
    };
    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
        var it = toIndexedObject$4(O);
        var key = toPropertyKey(P);
        if (it === ObjectPrototype$2 && hasOwn$c(AllSymbols, key) && !hasOwn$c(ObjectPrototypeSymbols, key)) return;
        var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);
        if (descriptor && hasOwn$c(AllSymbols, key) && !(hasOwn$c(it, HIDDEN) && it[HIDDEN][key])) descriptor.enumerable = true;
        return descriptor;
    };
    var $getOwnPropertyNames = function getOwnPropertyNames(O) {
        var names = nativeGetOwnPropertyNames(toIndexedObject$4(O));
        var result = [];
        $forEach$1(names, function(key) {
            if (!hasOwn$c(AllSymbols, key) && !hasOwn$c(hiddenKeys$1, key)) push$a(result, key);
        });
        return result;
    };
    var $getOwnPropertySymbols = function(O) {
        var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$2;
        var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$4(O));
        var result = [];
        $forEach$1(names, function(key) {
            if (hasOwn$c(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn$c(ObjectPrototype$2, key))) push$a(result, AllSymbols[key]);
        });
        return result;
    };
    // `Symbol` constructor
    // https://tc39.es/ecma262/#sec-symbol-constructor
    if (!NATIVE_SYMBOL$3) {
        $Symbol = function Symbol1() {
            if (isPrototypeOf$j(SymbolPrototype, this)) throw new TypeError$2('Symbol is not a constructor');
            var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
            var tag = uid$1(description);
            var setter = function(value) {
                var $this = this === undefined ? global$e : this;
                if ($this === ObjectPrototype$2) call$d(setter, ObjectPrototypeSymbols, value);
                if (hasOwn$c($this, HIDDEN) && hasOwn$c($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
                var descriptor = createPropertyDescriptor$3(1, value);
                try {
                    setSymbolDescriptor($this, tag, descriptor);
                } catch (error) {
                    if (!(error instanceof RangeError)) throw error;
                    fallbackDefineProperty($this, tag, descriptor);
                }
            };
            if (DESCRIPTORS$a && USE_SETTER) setSymbolDescriptor(ObjectPrototype$2, tag, {
                configurable: true,
                set: setter
            });
            return wrap(tag, description);
        };
        SymbolPrototype = $Symbol[PROTOTYPE];
        defineBuiltIn$4(SymbolPrototype, 'toString', function toString() {
            return getInternalState$2(this).tag;
        });
        defineBuiltIn$4($Symbol, 'withoutSetter', function(description) {
            return wrap(uid$1(description), description);
        });
        propertyIsEnumerableModule$1.f = $propertyIsEnumerable;
        definePropertyModule$1.f = $defineProperty;
        definePropertiesModule.f = $defineProperties;
        getOwnPropertyDescriptorModule$2.f = $getOwnPropertyDescriptor;
        getOwnPropertyNamesModule$2.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
        getOwnPropertySymbolsModule$3.f = $getOwnPropertySymbols;
        wrappedWellKnownSymbolModule.f = function(name) {
            return wrap(wellKnownSymbol$d(name), name);
        };
        if (DESCRIPTORS$a) // https://github.com/tc39/proposal-Symbol-description
        defineBuiltInAccessor$2(SymbolPrototype, 'description', {
            configurable: true,
            get: function description() {
                return getInternalState$2(this).description;
            }
        });
    }
    $$N({
        global: true,
        constructor: true,
        wrap: true,
        forced: !NATIVE_SYMBOL$3,
        sham: !NATIVE_SYMBOL$3
    }, {
        Symbol: $Symbol
    });
    $forEach$1(objectKeys$1(WellKnownSymbolsStore$1), function(name) {
        defineWellKnownSymbol$l(name);
    });
    $$N({
        target: SYMBOL,
        stat: true,
        forced: !NATIVE_SYMBOL$3
    }, {
        useSetter: function() {
            USE_SETTER = true;
        },
        useSimple: function() {
            USE_SETTER = false;
        }
    });
    $$N({
        target: 'Object',
        stat: true,
        forced: !NATIVE_SYMBOL$3,
        sham: !DESCRIPTORS$a
    }, {
        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        create: $create,
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        defineProperty: $defineProperty,
        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        defineProperties: $defineProperties,
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor
    });
    $$N({
        target: 'Object',
        stat: true,
        forced: !NATIVE_SYMBOL$3
    }, {
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        getOwnPropertyNames: $getOwnPropertyNames
    });
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    defineSymbolToPrimitive$1();
    // `Symbol.prototype[@@toStringTag]` property
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
    setToStringTag$6($Symbol, SYMBOL);
    hiddenKeys$1[HIDDEN] = true;
    var NATIVE_SYMBOL$2 = symbolConstructorDetection;
    /* eslint-disable es/no-symbol -- safe */ var symbolRegistryDetection = NATIVE_SYMBOL$2 && !!Symbol['for'] && !!Symbol.keyFor;
    var $$M = _export;
    var getBuiltIn$a = getBuiltIn$f;
    var hasOwn$b = hasOwnProperty_1;
    var toString$5 = toString$7;
    var shared$2 = sharedExports;
    var NATIVE_SYMBOL_REGISTRY$1 = symbolRegistryDetection;
    var StringToSymbolRegistry = shared$2('string-to-symbol-registry');
    var SymbolToStringRegistry$1 = shared$2('symbol-to-string-registry');
    // `Symbol.for` method
    // https://tc39.es/ecma262/#sec-symbol.for
    $$M({
        target: 'Symbol',
        stat: true,
        forced: !NATIVE_SYMBOL_REGISTRY$1
    }, {
        'for': function(key) {
            var string = toString$5(key);
            if (hasOwn$b(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
            var symbol = getBuiltIn$a('Symbol')(string);
            StringToSymbolRegistry[string] = symbol;
            SymbolToStringRegistry$1[symbol] = string;
            return symbol;
        }
    });
    var $$L = _export;
    var hasOwn$a = hasOwnProperty_1;
    var isSymbol$2 = isSymbol$5;
    var tryToString$4 = tryToString$6;
    var shared$1 = sharedExports;
    var NATIVE_SYMBOL_REGISTRY = symbolRegistryDetection;
    var SymbolToStringRegistry = shared$1('symbol-to-string-registry');
    // `Symbol.keyFor` method
    // https://tc39.es/ecma262/#sec-symbol.keyfor
    $$L({
        target: 'Symbol',
        stat: true,
        forced: !NATIVE_SYMBOL_REGISTRY
    }, {
        keyFor: function keyFor(sym) {
            if (!isSymbol$2(sym)) throw new TypeError(tryToString$4(sym) + ' is not a symbol');
            if (hasOwn$a(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
        }
    });
    var uncurryThis$d = functionUncurryThis;
    var arraySlice$5 = uncurryThis$d([].slice);
    var uncurryThis$c = functionUncurryThis;
    var isArray$b = isArray$e;
    var isCallable$a = isCallable$m;
    var classof$8 = classofRaw$2;
    var toString$4 = toString$7;
    var push$9 = uncurryThis$c([].push);
    var getJsonReplacerFunction = function(replacer) {
        if (isCallable$a(replacer)) return replacer;
        if (!isArray$b(replacer)) return;
        var rawLength = replacer.length;
        var keys = [];
        for(var i = 0; i < rawLength; i++){
            var element = replacer[i];
            if (typeof element == 'string') push$9(keys, element);
            else if (typeof element == 'number' || classof$8(element) === 'Number' || classof$8(element) === 'String') push$9(keys, toString$4(element));
        }
        var keysLength = keys.length;
        var root = true;
        return function(key, value) {
            if (root) {
                root = false;
                return value;
            }
            if (isArray$b(this)) return value;
            for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
        };
    };
    var $$K = _export;
    var getBuiltIn$9 = getBuiltIn$f;
    var apply$4 = functionApply;
    var call$c = functionCall;
    var uncurryThis$b = functionUncurryThis;
    var fails$i = fails$u;
    var isCallable$9 = isCallable$m;
    var isSymbol$1 = isSymbol$5;
    var arraySlice$4 = arraySlice$5;
    var getReplacerFunction = getJsonReplacerFunction;
    var NATIVE_SYMBOL$1 = symbolConstructorDetection;
    var $String$1 = String;
    var $stringify = getBuiltIn$9('JSON', 'stringify');
    var exec = uncurryThis$b(/./.exec);
    var charAt$2 = uncurryThis$b(''.charAt);
    var charCodeAt$1 = uncurryThis$b(''.charCodeAt);
    var replace$1 = uncurryThis$b(''.replace);
    var numberToString = uncurryThis$b(1.0.toString);
    var tester = /[\uD800-\uDFFF]/g;
    var low = /^[\uD800-\uDBFF]$/;
    var hi = /^[\uDC00-\uDFFF]$/;
    var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL$1 || fails$i(function() {
        var symbol = getBuiltIn$9('Symbol')('stringify detection');
        // MS Edge converts symbol values to JSON as {}
        return $stringify([
            symbol
        ]) !== '[null]' || $stringify({
            a: symbol
        }) !== '{}' || $stringify(Object(symbol)) !== '{}';
    });
    // https://github.com/tc39/proposal-well-formed-stringify
    var ILL_FORMED_UNICODE = fails$i(function() {
        return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
    });
    var stringifyWithSymbolsFix = function(it, replacer) {
        var args = arraySlice$4(arguments);
        var $replacer = getReplacerFunction(replacer);
        if (!isCallable$9($replacer) && (it === undefined || isSymbol$1(it))) return; // IE8 returns string on undefined
        args[1] = function(key, value) {
            // some old implementations (like WebKit) could pass numbers as keys
            if (isCallable$9($replacer)) value = call$c($replacer, this, $String$1(key), value);
            if (!isSymbol$1(value)) return value;
        };
        return apply$4($stringify, null, args);
    };
    var fixIllFormed = function(match, offset, string) {
        var prev = charAt$2(string, offset - 1);
        var next = charAt$2(string, offset + 1);
        if (exec(low, match) && !exec(hi, next) || exec(hi, match) && !exec(low, prev)) return '\\u' + numberToString(charCodeAt$1(match, 0), 16);
        return match;
    };
    if ($stringify) // `JSON.stringify` method
    // https://tc39.es/ecma262/#sec-json.stringify
    $$K({
        target: 'JSON',
        stat: true,
        arity: 3,
        forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE
    }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        stringify: function stringify(it, replacer, space) {
            var args = arraySlice$4(arguments);
            var result = apply$4(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
            return ILL_FORMED_UNICODE && typeof result == 'string' ? replace$1(result, tester, fixIllFormed) : result;
        }
    });
    var $$J = _export;
    var NATIVE_SYMBOL = symbolConstructorDetection;
    var fails$h = fails$u;
    var getOwnPropertySymbolsModule$2 = objectGetOwnPropertySymbols;
    var toObject$a = toObject$e;
    // V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
    // https://bugs.chromium.org/p/v8/issues/detail?id=3443
    var FORCED$5 = !NATIVE_SYMBOL || fails$h(function() {
        getOwnPropertySymbolsModule$2.f(1);
    });
    // `Object.getOwnPropertySymbols` method
    // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
    $$J({
        target: 'Object',
        stat: true,
        forced: FORCED$5
    }, {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
            var $getOwnPropertySymbols = getOwnPropertySymbolsModule$2.f;
            return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject$a(it)) : [];
        }
    });
    var defineWellKnownSymbol$k = wellKnownSymbolDefine;
    // `Symbol.asyncIterator` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.asynciterator
    defineWellKnownSymbol$k('asyncIterator');
    var defineWellKnownSymbol$j = wellKnownSymbolDefine;
    // `Symbol.hasInstance` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.hasinstance
    defineWellKnownSymbol$j('hasInstance');
    var defineWellKnownSymbol$i = wellKnownSymbolDefine;
    // `Symbol.isConcatSpreadable` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
    defineWellKnownSymbol$i('isConcatSpreadable');
    var defineWellKnownSymbol$h = wellKnownSymbolDefine;
    // `Symbol.iterator` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.iterator
    defineWellKnownSymbol$h('iterator');
    var defineWellKnownSymbol$g = wellKnownSymbolDefine;
    // `Symbol.match` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.match
    defineWellKnownSymbol$g('match');
    var defineWellKnownSymbol$f = wellKnownSymbolDefine;
    // `Symbol.matchAll` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.matchall
    defineWellKnownSymbol$f('matchAll');
    var defineWellKnownSymbol$e = wellKnownSymbolDefine;
    // `Symbol.replace` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.replace
    defineWellKnownSymbol$e('replace');
    var defineWellKnownSymbol$d = wellKnownSymbolDefine;
    // `Symbol.search` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.search
    defineWellKnownSymbol$d('search');
    var defineWellKnownSymbol$c = wellKnownSymbolDefine;
    // `Symbol.species` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.species
    defineWellKnownSymbol$c('species');
    var defineWellKnownSymbol$b = wellKnownSymbolDefine;
    // `Symbol.split` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.split
    defineWellKnownSymbol$b('split');
    var defineWellKnownSymbol$a = wellKnownSymbolDefine;
    var defineSymbolToPrimitive = symbolDefineToPrimitive;
    // `Symbol.toPrimitive` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.toprimitive
    defineWellKnownSymbol$a('toPrimitive');
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    defineSymbolToPrimitive();
    var getBuiltIn$8 = getBuiltIn$f;
    var defineWellKnownSymbol$9 = wellKnownSymbolDefine;
    var setToStringTag$5 = setToStringTag$7;
    // `Symbol.toStringTag` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.tostringtag
    defineWellKnownSymbol$9('toStringTag');
    // `Symbol.prototype[@@toStringTag]` property
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
    setToStringTag$5(getBuiltIn$8('Symbol'), 'Symbol');
    var defineWellKnownSymbol$8 = wellKnownSymbolDefine;
    // `Symbol.unscopables` well-known symbol
    // https://tc39.es/ecma262/#sec-symbol.unscopables
    defineWellKnownSymbol$8('unscopables');
    var global$d = global$p;
    var setToStringTag$4 = setToStringTag$7;
    // JSON[@@toStringTag] property
    // https://tc39.es/ecma262/#sec-json-@@tostringtag
    setToStringTag$4(global$d.JSON, 'JSON', true);
    var path$j = path$o;
    var symbol$5 = path$j.Symbol;
    var iterators = {};
    var DESCRIPTORS$9 = descriptors;
    var hasOwn$9 = hasOwnProperty_1;
    var FunctionPrototype$2 = Function.prototype;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getDescriptor = DESCRIPTORS$9 && Object.getOwnPropertyDescriptor;
    var EXISTS = hasOwn$9(FunctionPrototype$2, 'name');
    // additional protection from minified / mangled / dropped function names
    var PROPER = EXISTS && (function something() {}).name === 'something';
    var CONFIGURABLE = EXISTS && (!DESCRIPTORS$9 || DESCRIPTORS$9 && getDescriptor(FunctionPrototype$2, 'name').configurable);
    var functionName = {
        EXISTS: EXISTS,
        PROPER: PROPER,
        CONFIGURABLE: CONFIGURABLE
    };
    var fails$g = fails$u;
    var correctPrototypeGetter = !fails$g(function() {
        function F() {}
        F.prototype.constructor = null;
        // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
        return Object.getPrototypeOf(new F()) !== F.prototype;
    });
    var hasOwn$8 = hasOwnProperty_1;
    var isCallable$8 = isCallable$m;
    var toObject$9 = toObject$e;
    var sharedKey = sharedKey$4;
    var CORRECT_PROTOTYPE_GETTER$1 = correctPrototypeGetter;
    var IE_PROTO = sharedKey('IE_PROTO');
    var $Object = Object;
    var ObjectPrototype$1 = $Object.prototype;
    // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof
    // eslint-disable-next-line es/no-object-getprototypeof -- safe
    var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER$1 ? $Object.getPrototypeOf : function(O) {
        var object = toObject$9(O);
        if (hasOwn$8(object, IE_PROTO)) return object[IE_PROTO];
        var constructor = object.constructor;
        if (isCallable$8(constructor) && object instanceof constructor) return constructor.prototype;
        return object instanceof $Object ? ObjectPrototype$1 : null;
    };
    var fails$f = fails$u;
    var isCallable$7 = isCallable$m;
    var isObject$9 = isObject$h;
    var create$b = objectCreate;
    var getPrototypeOf$7 = objectGetPrototypeOf;
    var defineBuiltIn$3 = defineBuiltIn$6;
    var wellKnownSymbol$c = wellKnownSymbol$n;
    var ITERATOR$4 = wellKnownSymbol$c('iterator');
    var BUGGY_SAFARI_ITERATORS$1 = false;
    // `%IteratorPrototype%` object
    // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
    var IteratorPrototype$1, PrototypeOfArrayIteratorPrototype, arrayIterator;
    /* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
        arrayIterator = [].keys();
        // Safari 8 has buggy iterators w/o `next`
        if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
        else {
            PrototypeOfArrayIteratorPrototype = getPrototypeOf$7(getPrototypeOf$7(arrayIterator));
            if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$1 = PrototypeOfArrayIteratorPrototype;
        }
    }
    var NEW_ITERATOR_PROTOTYPE = !isObject$9(IteratorPrototype$1) || fails$f(function() {
        var test = {};
        // FF44- legacy iterators case
        return IteratorPrototype$1[ITERATOR$4].call(test) !== test;
    });
    if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$1 = {};
    else IteratorPrototype$1 = create$b(IteratorPrototype$1);
    // `%IteratorPrototype%[@@iterator]()` method
    // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
    if (!isCallable$7(IteratorPrototype$1[ITERATOR$4])) defineBuiltIn$3(IteratorPrototype$1, ITERATOR$4, function() {
        return this;
    });
    var iteratorsCore = {
        IteratorPrototype: IteratorPrototype$1,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
    };
    var IteratorPrototype = iteratorsCore.IteratorPrototype;
    var create$a = objectCreate;
    var createPropertyDescriptor$2 = createPropertyDescriptor$7;
    var setToStringTag$3 = setToStringTag$7;
    var Iterators$5 = iterators;
    var returnThis$1 = function() {
        return this;
    };
    var iteratorCreateConstructor = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
        var TO_STRING_TAG = NAME + ' Iterator';
        IteratorConstructor.prototype = create$a(IteratorPrototype, {
            next: createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next)
        });
        setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false, true);
        Iterators$5[TO_STRING_TAG] = returnThis$1;
        return IteratorConstructor;
    };
    var uncurryThis$a = functionUncurryThis;
    var aCallable$b = aCallable$e;
    var functionUncurryThisAccessor = function(object, key, method) {
        try {
            // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
            return uncurryThis$a(aCallable$b(Object.getOwnPropertyDescriptor(object, key)[method]));
        } catch (error) {}
    };
    var isCallable$6 = isCallable$m;
    var $String = String;
    var $TypeError$9 = TypeError;
    var aPossiblePrototype$1 = function(argument) {
        if (typeof argument == 'object' || isCallable$6(argument)) return argument;
        throw new $TypeError$9("Can't set " + $String(argument) + ' as a prototype');
    };
    /* eslint-disable no-proto -- safe */ var uncurryThisAccessor = functionUncurryThisAccessor;
    var anObject$8 = anObject$d;
    var aPossiblePrototype = aPossiblePrototype$1;
    // `Object.setPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.setprototypeof
    // Works with __proto__ only. Old v8 can't work with null proto objects.
    // eslint-disable-next-line es/no-object-setprototypeof -- safe
    var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function() {
        var CORRECT_SETTER = false;
        var test = {};
        var setter;
        try {
            setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
            setter(test, []);
            CORRECT_SETTER = test instanceof Array;
        } catch (error) {}
        return function setPrototypeOf(O, proto) {
            anObject$8(O);
            aPossiblePrototype(proto);
            if (CORRECT_SETTER) setter(O, proto);
            else O.__proto__ = proto;
            return O;
        };
    }() : undefined);
    var $$I = _export;
    var call$b = functionCall;
    var FunctionName = functionName;
    var createIteratorConstructor = iteratorCreateConstructor;
    var getPrototypeOf$6 = objectGetPrototypeOf;
    var setToStringTag$2 = setToStringTag$7;
    var defineBuiltIn$2 = defineBuiltIn$6;
    var wellKnownSymbol$b = wellKnownSymbol$n;
    var Iterators$4 = iterators;
    var IteratorsCore = iteratorsCore;
    var PROPER_FUNCTION_NAME = FunctionName.PROPER;
    FunctionName.CONFIGURABLE;
    IteratorsCore.IteratorPrototype;
    var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
    var ITERATOR$3 = wellKnownSymbol$b('iterator');
    var KEYS = 'keys';
    var VALUES = 'values';
    var ENTRIES = 'entries';
    var returnThis = function() {
        return this;
    };
    var iteratorDefine = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next);
        var getIterationMethod = function(KIND) {
            if (KIND === DEFAULT && defaultIterator) return defaultIterator;
            if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
            switch(KIND){
                case KEYS:
                    return function keys() {
                        return new IteratorConstructor(this, KIND);
                    };
                case VALUES:
                    return function values() {
                        return new IteratorConstructor(this, KIND);
                    };
                case ENTRIES:
                    return function entries() {
                        return new IteratorConstructor(this, KIND);
                    };
            }
            return function() {
                return new IteratorConstructor(this);
            };
        };
        var TO_STRING_TAG = NAME + ' Iterator';
        var INCORRECT_VALUES_NAME = false;
        var IterablePrototype = Iterable.prototype;
        var nativeIterator = IterablePrototype[ITERATOR$3] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
        var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
        var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
        var CurrentIteratorPrototype, methods, KEY;
        // fix native
        if (anyNativeIterator) {
            CurrentIteratorPrototype = getPrototypeOf$6(anyNativeIterator.call(new Iterable()));
            if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                // Set @@toStringTag to native iterators
                setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                Iterators$4[TO_STRING_TAG] = returnThis;
            }
        }
        // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
        if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return call$b(nativeIterator, this);
            };
        }
        // export additional methods
        if (DEFAULT) {
            methods = {
                values: getIterationMethod(VALUES),
                keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                entries: getIterationMethod(ENTRIES)
            };
            if (FORCED) {
                for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) defineBuiltIn$2(IterablePrototype, KEY, methods[KEY]);
            } else $$I({
                target: NAME,
                proto: true,
                forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
            }, methods);
        }
        // define iterator
        if (FORCED && IterablePrototype[ITERATOR$3] !== defaultIterator) defineBuiltIn$2(IterablePrototype, ITERATOR$3, defaultIterator, {
            name: DEFAULT
        });
        Iterators$4[NAME] = defaultIterator;
        return methods;
    };
    // `CreateIterResultObject` abstract operation
    // https://tc39.es/ecma262/#sec-createiterresultobject
    var createIterResultObject$3 = function(value, done) {
        return {
            value: value,
            done: done
        };
    };
    var toIndexedObject$3 = toIndexedObject$a;
    var Iterators$3 = iterators;
    var InternalStateModule$4 = internalState;
    objectDefineProperty.f;
    var defineIterator$2 = iteratorDefine;
    var createIterResultObject$2 = createIterResultObject$3;
    var ARRAY_ITERATOR = 'Array Iterator';
    var setInternalState$4 = InternalStateModule$4.set;
    var getInternalState$1 = InternalStateModule$4.getterFor(ARRAY_ITERATOR);
    // `Array.prototype.entries` method
    // https://tc39.es/ecma262/#sec-array.prototype.entries
    // `Array.prototype.keys` method
    // https://tc39.es/ecma262/#sec-array.prototype.keys
    // `Array.prototype.values` method
    // https://tc39.es/ecma262/#sec-array.prototype.values
    // `Array.prototype[@@iterator]` method
    // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
    // `CreateArrayIterator` internal method
    // https://tc39.es/ecma262/#sec-createarrayiterator
    defineIterator$2(Array, 'Array', function(iterated, kind) {
        setInternalState$4(this, {
            type: ARRAY_ITERATOR,
            target: toIndexedObject$3(iterated),
            index: 0,
            kind: kind // kind
        });
    // `%ArrayIteratorPrototype%.next` method
    // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
    }, function() {
        var state = getInternalState$1(this);
        var target = state.target;
        var index = state.index++;
        if (!target || index >= target.length) {
            state.target = undefined;
            return createIterResultObject$2(undefined, true);
        }
        switch(state.kind){
            case 'keys':
                return createIterResultObject$2(index, false);
            case 'values':
                return createIterResultObject$2(target[index], false);
        }
        return createIterResultObject$2([
            index,
            target[index]
        ], false);
    }, 'values');
    // argumentsList[@@iterator] is %ArrayProto_values%
    // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
    // https://tc39.es/ecma262/#sec-createmappedargumentsobject
    Iterators$3.Arguments = Iterators$3.Array;
    // iterable DOM collections
    // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
    var domIterables = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    };
    var DOMIterables$4 = domIterables;
    var global$c = global$p;
    var classof$7 = classof$d;
    var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;
    var Iterators$2 = iterators;
    var wellKnownSymbol$a = wellKnownSymbol$n;
    var TO_STRING_TAG$1 = wellKnownSymbol$a('toStringTag');
    for(var COLLECTION_NAME in DOMIterables$4){
        var Collection = global$c[COLLECTION_NAME];
        var CollectionPrototype = Collection && Collection.prototype;
        if (CollectionPrototype && classof$7(CollectionPrototype) !== TO_STRING_TAG$1) createNonEnumerableProperty$4(CollectionPrototype, TO_STRING_TAG$1, COLLECTION_NAME);
        Iterators$2[COLLECTION_NAME] = Iterators$2.Array;
    }
    var parent$15 = symbol$5;
    var symbol$4 = parent$15;
    var wellKnownSymbol$9 = wellKnownSymbol$n;
    var defineProperty$4 = objectDefineProperty.f;
    var METADATA$1 = wellKnownSymbol$9('metadata');
    var FunctionPrototype$1 = Function.prototype;
    // Function.prototype[@@metadata]
    // https://github.com/tc39/proposal-decorator-metadata
    if (FunctionPrototype$1[METADATA$1] === undefined) defineProperty$4(FunctionPrototype$1, METADATA$1, {
        value: null
    });
    var defineWellKnownSymbol$7 = wellKnownSymbolDefine;
    // `Symbol.asyncDispose` well-known symbol
    // https://github.com/tc39/proposal-async-explicit-resource-management
    defineWellKnownSymbol$7('asyncDispose');
    var defineWellKnownSymbol$6 = wellKnownSymbolDefine;
    // `Symbol.dispose` well-known symbol
    // https://github.com/tc39/proposal-explicit-resource-management
    defineWellKnownSymbol$6('dispose');
    var defineWellKnownSymbol$5 = wellKnownSymbolDefine;
    // `Symbol.metadata` well-known symbol
    // https://github.com/tc39/proposal-decorators
    defineWellKnownSymbol$5('metadata');
    var parent$14 = symbol$4;
    var symbol$3 = parent$14;
    var getBuiltIn$7 = getBuiltIn$f;
    var uncurryThis$9 = functionUncurryThis;
    var Symbol$2 = getBuiltIn$7('Symbol');
    var keyFor = Symbol$2.keyFor;
    var thisSymbolValue$1 = uncurryThis$9(Symbol$2.prototype.valueOf);
    // `Symbol.isRegisteredSymbol` method
    // https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
    var symbolIsRegistered = Symbol$2.isRegisteredSymbol || function isRegisteredSymbol(value) {
        try {
            return keyFor(thisSymbolValue$1(value)) !== undefined;
        } catch (error) {
            return false;
        }
    };
    var $$H = _export;
    var isRegisteredSymbol$1 = symbolIsRegistered;
    // `Symbol.isRegisteredSymbol` method
    // https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
    $$H({
        target: 'Symbol',
        stat: true
    }, {
        isRegisteredSymbol: isRegisteredSymbol$1
    });
    var shared = sharedExports;
    var getBuiltIn$6 = getBuiltIn$f;
    var uncurryThis$8 = functionUncurryThis;
    var isSymbol = isSymbol$5;
    var wellKnownSymbol$8 = wellKnownSymbol$n;
    var Symbol$1 = getBuiltIn$6('Symbol');
    var $isWellKnownSymbol = Symbol$1.isWellKnownSymbol;
    var getOwnPropertyNames = getBuiltIn$6('Object', 'getOwnPropertyNames');
    var thisSymbolValue = uncurryThis$8(Symbol$1.prototype.valueOf);
    var WellKnownSymbolsStore = shared('wks');
    for(var i = 0, symbolKeys = getOwnPropertyNames(Symbol$1), symbolKeysLength = symbolKeys.length; i < symbolKeysLength; i++)// some old engines throws on access to some keys like `arguments` or `caller`
    try {
        var symbolKey = symbolKeys[i];
        if (isSymbol(Symbol$1[symbolKey])) wellKnownSymbol$8(symbolKey);
    } catch (error) {}
    // `Symbol.isWellKnownSymbol` method
    // https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
    // We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
    var symbolIsWellKnown = function isWellKnownSymbol(value) {
        if ($isWellKnownSymbol && $isWellKnownSymbol(value)) return true;
        try {
            var symbol = thisSymbolValue(value);
            for(var j = 0, keys = getOwnPropertyNames(WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
                // eslint-disable-next-line eqeqeq -- polyfilled symbols case
                if (WellKnownSymbolsStore[keys[j]] == symbol) return true;
            }
        } catch (error) {}
        return false;
    };
    var $$G = _export;
    var isWellKnownSymbol$1 = symbolIsWellKnown;
    // `Symbol.isWellKnownSymbol` method
    // https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
    // We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
    $$G({
        target: 'Symbol',
        stat: true,
        forced: true
    }, {
        isWellKnownSymbol: isWellKnownSymbol$1
    });
    var defineWellKnownSymbol$4 = wellKnownSymbolDefine;
    // `Symbol.matcher` well-known symbol
    // https://github.com/tc39/proposal-pattern-matching
    defineWellKnownSymbol$4('matcher');
    var defineWellKnownSymbol$3 = wellKnownSymbolDefine;
    // `Symbol.observable` well-known symbol
    // https://github.com/tc39/proposal-observable
    defineWellKnownSymbol$3('observable');
    var $$F = _export;
    var isRegisteredSymbol = symbolIsRegistered;
    // `Symbol.isRegistered` method
    // obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
    $$F({
        target: 'Symbol',
        stat: true,
        name: 'isRegisteredSymbol'
    }, {
        isRegistered: isRegisteredSymbol
    });
    var $$E = _export;
    var isWellKnownSymbol = symbolIsWellKnown;
    // `Symbol.isWellKnown` method
    // obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
    // We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
    $$E({
        target: 'Symbol',
        stat: true,
        name: 'isWellKnownSymbol',
        forced: true
    }, {
        isWellKnown: isWellKnownSymbol
    });
    // TODO: Remove from `core-js@4`
    var defineWellKnownSymbol$2 = wellKnownSymbolDefine;
    // `Symbol.metadataKey` well-known symbol
    // https://github.com/tc39/proposal-decorator-metadata
    defineWellKnownSymbol$2('metadataKey');
    // TODO: remove from `core-js@4`
    var defineWellKnownSymbol$1 = wellKnownSymbolDefine;
    // `Symbol.patternMatch` well-known symbol
    // https://github.com/tc39/proposal-pattern-matching
    defineWellKnownSymbol$1('patternMatch');
    // TODO: remove from `core-js@4`
    var defineWellKnownSymbol = wellKnownSymbolDefine;
    defineWellKnownSymbol('replaceAll');
    var parent$13 = symbol$3;
    // TODO: Remove from `core-js@4`
    var symbol$2 = parent$13;
    var symbol$1 = symbol$2;
    var _Symbol$1 = /*@__PURE__*/ getDefaultExportFromCjs(symbol$1);
    var uncurryThis$7 = functionUncurryThis;
    var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
    var toString$3 = toString$7;
    var requireObjectCoercible = requireObjectCoercible$3;
    var charAt$1 = uncurryThis$7(''.charAt);
    var charCodeAt = uncurryThis$7(''.charCodeAt);
    var stringSlice = uncurryThis$7(''.slice);
    var createMethod$1 = function(CONVERT_TO_STRING) {
        return function($this, pos) {
            var S = toString$3(requireObjectCoercible($this));
            var position = toIntegerOrInfinity$1(pos);
            var size = S.length;
            var first, second;
            if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
            first = charCodeAt(S, position);
            return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt$1(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
        };
    };
    var stringMultibyte = {
        // `String.prototype.codePointAt` method
        // https://tc39.es/ecma262/#sec-string.prototype.codepointat
        codeAt: createMethod$1(false),
        // `String.prototype.at` method
        // https://github.com/mathiasbynens/String.prototype.at
        charAt: createMethod$1(true)
    };
    var charAt = stringMultibyte.charAt;
    var toString$2 = toString$7;
    var InternalStateModule$3 = internalState;
    var defineIterator$1 = iteratorDefine;
    var createIterResultObject$1 = createIterResultObject$3;
    var STRING_ITERATOR = 'String Iterator';
    var setInternalState$3 = InternalStateModule$3.set;
    var getInternalState = InternalStateModule$3.getterFor(STRING_ITERATOR);
    // `String.prototype[@@iterator]` method
    // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
    defineIterator$1(String, 'String', function(iterated) {
        setInternalState$3(this, {
            type: STRING_ITERATOR,
            string: toString$2(iterated),
            index: 0
        });
    // `%StringIteratorPrototype%.next` method
    // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
    }, function next() {
        var state = getInternalState(this);
        var string = state.string;
        var index = state.index;
        var point;
        if (index >= string.length) return createIterResultObject$1(undefined, true);
        point = charAt(string, index);
        state.index += point.length;
        return createIterResultObject$1(point, false);
    });
    var WrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
    var iterator$5 = WrappedWellKnownSymbolModule$1.f('iterator');
    var parent$12 = iterator$5;
    var iterator$4 = parent$12;
    var parent$11 = iterator$4;
    var iterator$3 = parent$11;
    var parent$10 = iterator$3;
    var iterator$2 = parent$10;
    var iterator$1 = iterator$2;
    var _Symbol$iterator$1 = /*@__PURE__*/ getDefaultExportFromCjs(iterator$1);
    function _typeof$1(o) {
        "@babel/helpers - typeof";
        return _typeof$1 = "function" == typeof _Symbol$1 && "symbol" == typeof _Symbol$iterator$1 ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof _Symbol$1 && o.constructor === _Symbol$1 && o !== _Symbol$1.prototype ? "symbol" : typeof o;
        }, _typeof$1(o);
    }
    var WrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
    var toPrimitive$4 = WrappedWellKnownSymbolModule.f('toPrimitive');
    var parent$$ = toPrimitive$4;
    var toPrimitive$3 = parent$$;
    var parent$_ = toPrimitive$3;
    var toPrimitive$2 = parent$_;
    var parent$Z = toPrimitive$2;
    var toPrimitive$1 = parent$Z;
    var toPrimitive = toPrimitive$1;
    var _Symbol$toPrimitive = /*@__PURE__*/ getDefaultExportFromCjs(toPrimitive);
    function _toPrimitive(input, hint) {
        if (_typeof$1(input) !== "object" || input === null) return input;
        var prim = input[_Symbol$toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof$1(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return _typeof$1(key) === "symbol" ? key : String(key);
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            _Object$defineProperty$1(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        _Object$defineProperty$1(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) _Object$defineProperty$1(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var uncurryThis$6 = functionUncurryThis;
    var aCallable$a = aCallable$e;
    var isObject$8 = isObject$h;
    var hasOwn$7 = hasOwnProperty_1;
    var arraySlice$3 = arraySlice$5;
    var NATIVE_BIND = functionBindNative;
    var $Function = Function;
    var concat$6 = uncurryThis$6([].concat);
    var join = uncurryThis$6([].join);
    var factories = {};
    var construct$3 = function(C, argsLength, args) {
        if (!hasOwn$7(factories, argsLength)) {
            var list = [];
            var i = 0;
            for(; i < argsLength; i++)list[i] = 'a[' + i + ']';
            factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
        }
        return factories[argsLength](C, args);
    };
    // `Function.prototype.bind` method implementation
    // https://tc39.es/ecma262/#sec-function.prototype.bind
    // eslint-disable-next-line es/no-function-prototype-bind -- detection
    var functionBind = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */ ) {
        var F = aCallable$a(this);
        var Prototype = F.prototype;
        var partArgs = arraySlice$3(arguments, 1);
        var boundFunction = function bound() {
            var args = concat$6(partArgs, arraySlice$3(arguments));
            return this instanceof boundFunction ? construct$3(F, args.length, args) : F.apply(that, args);
        };
        if (isObject$8(Prototype)) boundFunction.prototype = Prototype;
        return boundFunction;
    };
    // TODO: Remove from `core-js@4`
    var $$D = _export;
    var bind$f = functionBind;
    // `Function.prototype.bind` method
    // https://tc39.es/ecma262/#sec-function.prototype.bind
    // eslint-disable-next-line es/no-function-prototype-bind -- detection
    $$D({
        target: 'Function',
        proto: true,
        forced: Function.bind !== bind$f
    }, {
        bind: bind$f
    });
    var global$b = global$p;
    var path$i = path$o;
    var getBuiltInPrototypeMethod$g = function(CONSTRUCTOR, METHOD) {
        var Namespace = path$i[CONSTRUCTOR + 'Prototype'];
        var pureMethod = Namespace && Namespace[METHOD];
        if (pureMethod) return pureMethod;
        var NativeConstructor = global$b[CONSTRUCTOR];
        var NativePrototype = NativeConstructor && NativeConstructor.prototype;
        return NativePrototype && NativePrototype[METHOD];
    };
    var getBuiltInPrototypeMethod$f = getBuiltInPrototypeMethod$g;
    var bind$e = getBuiltInPrototypeMethod$f('Function', 'bind');
    var isPrototypeOf$i = objectIsPrototypeOf;
    var method$f = bind$e;
    var FunctionPrototype = Function.prototype;
    var bind$d = function(it) {
        var own = it.bind;
        return it === FunctionPrototype || isPrototypeOf$i(FunctionPrototype, it) && own === FunctionPrototype.bind ? method$f : own;
    };
    var parent$Y = bind$d;
    var bind$c = parent$Y;
    var bind$b = bind$c;
    var _bindInstanceProperty$1 = /*@__PURE__*/ getDefaultExportFromCjs(bind$b);
    var aCallable$9 = aCallable$e;
    var toObject$8 = toObject$e;
    var IndexedObject$1 = indexedObject;
    var lengthOfArrayLike$8 = lengthOfArrayLike$d;
    var $TypeError$8 = TypeError;
    // `Array.prototype.{ reduce, reduceRight }` methods implementation
    var createMethod = function(IS_RIGHT) {
        return function(that, callbackfn, argumentsLength, memo) {
            aCallable$9(callbackfn);
            var O = toObject$8(that);
            var self1 = IndexedObject$1(O);
            var length = lengthOfArrayLike$8(O);
            var index = IS_RIGHT ? length - 1 : 0;
            var i = IS_RIGHT ? -1 : 1;
            if (argumentsLength < 2) while(true){
                if (index in self1) {
                    memo = self1[index];
                    index += i;
                    break;
                }
                index += i;
                if (IS_RIGHT ? index < 0 : length <= index) throw new $TypeError$8('Reduce of empty array with no initial value');
            }
            for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
            return memo;
        };
    };
    var arrayReduce = {
        // `Array.prototype.reduce` method
        // https://tc39.es/ecma262/#sec-array.prototype.reduce
        left: createMethod(false),
        // `Array.prototype.reduceRight` method
        // https://tc39.es/ecma262/#sec-array.prototype.reduceright
        right: createMethod(true)
    };
    var fails$e = fails$u;
    var arrayMethodIsStrict$4 = function(METHOD_NAME, argument) {
        var method = [][METHOD_NAME];
        return !!method && fails$e(function() {
            // eslint-disable-next-line no-useless-call -- required for testing
            method.call(null, argument || function() {
                return 1;
            }, 1);
        });
    };
    var global$a = global$p;
    var classof$6 = classofRaw$2;
    var engineIsNode = classof$6(global$a.process) === 'process';
    var $$C = _export;
    var $reduce = arrayReduce.left;
    var arrayMethodIsStrict$3 = arrayMethodIsStrict$4;
    var CHROME_VERSION = engineV8Version;
    var IS_NODE$4 = engineIsNode;
    // Chrome 80-82 has a critical bug
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
    var CHROME_BUG = !IS_NODE$4 && CHROME_VERSION > 79 && CHROME_VERSION < 83;
    var FORCED$4 = CHROME_BUG || !arrayMethodIsStrict$3('reduce');
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    $$C({
        target: 'Array',
        proto: true,
        forced: FORCED$4
    }, {
        reduce: function reduce(callbackfn /* , initialValue */ ) {
            var length = arguments.length;
            return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
        }
    });
    var getBuiltInPrototypeMethod$e = getBuiltInPrototypeMethod$g;
    var reduce$3 = getBuiltInPrototypeMethod$e('Array', 'reduce');
    var isPrototypeOf$h = objectIsPrototypeOf;
    var method$e = reduce$3;
    var ArrayPrototype$f = Array.prototype;
    var reduce$2 = function(it) {
        var own = it.reduce;
        return it === ArrayPrototype$f || isPrototypeOf$h(ArrayPrototype$f, it) && own === ArrayPrototype$f.reduce ? method$e : own;
    };
    var parent$X = reduce$2;
    var reduce$1 = parent$X;
    var reduce = reduce$1;
    var _reduceInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(reduce);
    var $$B = _export;
    var $filter = arrayIteration.filter;
    var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$5;
    var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport$3('filter');
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    // with adding support of @@species
    $$B({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT$3
    }, {
        filter: function filter(callbackfn /* , thisArg */ ) {
            return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });
    var getBuiltInPrototypeMethod$d = getBuiltInPrototypeMethod$g;
    var filter$3 = getBuiltInPrototypeMethod$d('Array', 'filter');
    var isPrototypeOf$g = objectIsPrototypeOf;
    var method$d = filter$3;
    var ArrayPrototype$e = Array.prototype;
    var filter$2 = function(it) {
        var own = it.filter;
        return it === ArrayPrototype$e || isPrototypeOf$g(ArrayPrototype$e, it) && own === ArrayPrototype$e.filter ? method$d : own;
    };
    var parent$W = filter$2;
    var filter$1 = parent$W;
    var filter = filter$1;
    var _filterInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(filter);
    var $$A = _export;
    var $map = arrayIteration.map;
    var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$5;
    var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$2('map');
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    // with adding support of @@species
    $$A({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT$2
    }, {
        map: function map(callbackfn /* , thisArg */ ) {
            return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });
    var getBuiltInPrototypeMethod$c = getBuiltInPrototypeMethod$g;
    var map$6 = getBuiltInPrototypeMethod$c('Array', 'map');
    var isPrototypeOf$f = objectIsPrototypeOf;
    var method$c = map$6;
    var ArrayPrototype$d = Array.prototype;
    var map$5 = function(it) {
        var own = it.map;
        return it === ArrayPrototype$d || isPrototypeOf$f(ArrayPrototype$d, it) && own === ArrayPrototype$d.map ? method$c : own;
    };
    var parent$V = map$5;
    var map$4 = parent$V;
    var map$3 = map$4;
    var _mapInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(map$3);
    var isArray$a = isArray$e;
    var lengthOfArrayLike$7 = lengthOfArrayLike$d;
    var doesNotExceedSafeInteger$2 = doesNotExceedSafeInteger$4;
    var bind$a = functionBindContext;
    // `FlattenIntoArray` abstract operation
    // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
    var flattenIntoArray$1 = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
        var targetIndex = start;
        var sourceIndex = 0;
        var mapFn = mapper ? bind$a(mapper, thisArg) : false;
        var element, elementLen;
        while(sourceIndex < sourceLen){
            if (sourceIndex in source) {
                element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
                if (depth > 0 && isArray$a(element)) {
                    elementLen = lengthOfArrayLike$7(element);
                    targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
                } else {
                    doesNotExceedSafeInteger$2(targetIndex + 1);
                    target[targetIndex] = element;
                }
                targetIndex++;
            }
            sourceIndex++;
        }
        return targetIndex;
    };
    var flattenIntoArray_1 = flattenIntoArray$1;
    var $$z = _export;
    var flattenIntoArray = flattenIntoArray_1;
    var aCallable$8 = aCallable$e;
    var toObject$7 = toObject$e;
    var lengthOfArrayLike$6 = lengthOfArrayLike$d;
    var arraySpeciesCreate$1 = arraySpeciesCreate$4;
    // `Array.prototype.flatMap` method
    // https://tc39.es/ecma262/#sec-array.prototype.flatmap
    $$z({
        target: 'Array',
        proto: true
    }, {
        flatMap: function flatMap(callbackfn /* , thisArg */ ) {
            var O = toObject$7(this);
            var sourceLen = lengthOfArrayLike$6(O);
            var A;
            aCallable$8(callbackfn);
            A = arraySpeciesCreate$1(O, 0);
            A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            return A;
        }
    });
    var getBuiltInPrototypeMethod$b = getBuiltInPrototypeMethod$g;
    var flatMap$3 = getBuiltInPrototypeMethod$b('Array', 'flatMap');
    var isPrototypeOf$e = objectIsPrototypeOf;
    var method$b = flatMap$3;
    var ArrayPrototype$c = Array.prototype;
    var flatMap$2 = function(it) {
        var own = it.flatMap;
        return it === ArrayPrototype$c || isPrototypeOf$e(ArrayPrototype$c, it) && own === ArrayPrototype$c.flatMap ? method$b : own;
    };
    var parent$U = flatMap$2;
    var flatMap$1 = parent$U;
    var flatMap = flatMap$1;
    var _flatMapInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(flatMap);
    /**
   * Create new data pipe.
   *
   * @param from - The source data set or data view.
   * @remarks
   * Example usage:
   * ```typescript
   * interface AppItem {
   *   whoami: string;
   *   appData: unknown;
   *   visData: VisItem;
   * }
   * interface VisItem {
   *   id: number;
   *   label: string;
   *   color: string;
   *   x: number;
   *   y: number;
   * }
   *
   * const ds1 = new DataSet<AppItem, "whoami">([], { fieldId: "whoami" });
   * const ds2 = new DataSet<VisItem, "id">();
   *
   * const pipe = createNewDataPipeFrom(ds1)
   *   .filter((item): boolean => item.enabled === true)
   *   .map<VisItem, "id">((item): VisItem => item.visData)
   *   .to(ds2);
   *
   * pipe.start();
   * ```
   * @returns A factory whose methods can be used to configure the pipe.
   */ function createNewDataPipeFrom(from) {
        return new DataPipeUnderConstruction(from);
    }
    /**
   * Internal implementation of the pipe. This should be accessible only through
   * `createNewDataPipeFrom` from the outside.
   *
   * @typeParam SI - Source item type.
   * @typeParam SP - Source item type's id property name.
   * @typeParam TI - Target item type.
   * @typeParam TP - Target item type's id property name.
   */ var SimpleDataPipe = /*#__PURE__*/ function() {
        /**
     * Create a new data pipe.
     *
     * @param _source - The data set or data view that will be observed.
     * @param _transformers - An array of transforming functions to be used to
     * filter or transform the items in the pipe.
     * @param _target - The data set or data view that will receive the items.
     */ function SimpleDataPipe(_source, _transformers, _target) {
            var _context, _context2, _context3;
            _classCallCheck(this, SimpleDataPipe);
            /**
       * Bound listeners for use with `DataInterface['on' | 'off']`.
       */ _defineProperty(this, "_listeners", {
                add: _bindInstanceProperty$1(_context = this._add).call(_context, this),
                remove: _bindInstanceProperty$1(_context2 = this._remove).call(_context2, this),
                update: _bindInstanceProperty$1(_context3 = this._update).call(_context3, this)
            });
            this._source = _source;
            this._transformers = _transformers;
            this._target = _target;
        }
        /** @inheritDoc */ _createClass(SimpleDataPipe, [
            {
                key: "all",
                value: function all() {
                    this._target.update(this._transformItems(this._source.get()));
                    return this;
                }
            },
            {
                key: "start",
                value: function start() {
                    this._source.on("add", this._listeners.add);
                    this._source.on("remove", this._listeners.remove);
                    this._source.on("update", this._listeners.update);
                    return this;
                }
            },
            {
                key: "stop",
                value: function stop() {
                    this._source.off("add", this._listeners.add);
                    this._source.off("remove", this._listeners.remove);
                    this._source.off("update", this._listeners.update);
                    return this;
                }
            },
            {
                key: "_transformItems",
                value: function _transformItems(items) {
                    var _context4;
                    return _reduceInstanceProperty(_context4 = this._transformers).call(_context4, function(items, transform) {
                        return transform(items);
                    }, items);
                }
            },
            {
                key: "_add",
                value: function _add(_name, payload) {
                    if (payload == null) return;
                    this._target.add(this._transformItems(this._source.get(payload.items)));
                }
            },
            {
                key: "_update",
                value: function _update(_name, payload) {
                    if (payload == null) return;
                    this._target.update(this._transformItems(this._source.get(payload.items)));
                }
            },
            {
                key: "_remove",
                value: function _remove(_name, payload) {
                    if (payload == null) return;
                    this._target.remove(this._transformItems(payload.oldData));
                }
            }
        ]);
        return SimpleDataPipe;
    }();
    /**
   * Internal implementation of the pipe factory. This should be accessible
   * only through `createNewDataPipeFrom` from the outside.
   *
   * @typeParam TI - Target item type.
   * @typeParam TP - Target item type's id property name.
   */ var DataPipeUnderConstruction = /*#__PURE__*/ function() {
        /**
     * Create a new data pipe factory. This is an internal constructor that
     * should never be called from outside of this file.
     *
     * @param _source - The source data set or data view for this pipe.
     */ function DataPipeUnderConstruction(_source) {
            _classCallCheck(this, DataPipeUnderConstruction);
            /**
       * Array transformers used to transform items within the pipe. This is typed
       * as any for the sake of simplicity.
       */ _defineProperty(this, "_transformers", []);
            this._source = _source;
        }
        /**
     * Filter the items.
     *
     * @param callback - A filtering function that returns true if given item
     * should be piped and false if not.
     * @returns This factory for further configuration.
     */ _createClass(DataPipeUnderConstruction, [
            {
                key: "filter",
                value: function filter(callback) {
                    this._transformers.push(function(input) {
                        return _filterInstanceProperty(input).call(input, callback);
                    });
                    return this;
                }
            },
            {
                key: "map",
                value: function map(callback) {
                    this._transformers.push(function(input) {
                        return _mapInstanceProperty(input).call(input, callback);
                    });
                    return this;
                }
            },
            {
                key: "flatMap",
                value: function flatMap(callback) {
                    this._transformers.push(function(input) {
                        return _flatMapInstanceProperty(input).call(input, callback);
                    });
                    return this;
                }
            },
            {
                key: "to",
                value: function to(target) {
                    return new SimpleDataPipe(this._source, this._transformers, target);
                }
            }
        ]);
        return DataPipeUnderConstruction;
    }();
    var call$a = functionCall;
    var anObject$7 = anObject$d;
    var getMethod$1 = getMethod$3;
    var iteratorClose$2 = function(iterator, kind, value) {
        var innerResult, innerError;
        anObject$7(iterator);
        try {
            innerResult = getMethod$1(iterator, 'return');
            if (!innerResult) {
                if (kind === 'throw') throw value;
                return value;
            }
            innerResult = call$a(innerResult, iterator);
        } catch (error) {
            innerError = true;
            innerResult = error;
        }
        if (kind === 'throw') throw value;
        if (innerError) throw innerResult;
        anObject$7(innerResult);
        return value;
    };
    var anObject$6 = anObject$d;
    var iteratorClose$1 = iteratorClose$2;
    // call something on iterator step with safe closing on error
    var callWithSafeIterationClosing$1 = function(iterator, fn, value, ENTRIES) {
        try {
            return ENTRIES ? fn(anObject$6(value)[0], value[1]) : fn(value);
        } catch (error) {
            iteratorClose$1(iterator, 'throw', error);
        }
    };
    var wellKnownSymbol$7 = wellKnownSymbol$n;
    var Iterators$1 = iterators;
    var ITERATOR$2 = wellKnownSymbol$7('iterator');
    var ArrayPrototype$b = Array.prototype;
    // check on default Array iterator
    var isArrayIteratorMethod$2 = function(it) {
        return it !== undefined && (Iterators$1.Array === it || ArrayPrototype$b[ITERATOR$2] === it);
    };
    var classof$5 = classof$d;
    var getMethod = getMethod$3;
    var isNullOrUndefined$3 = isNullOrUndefined$6;
    var Iterators = iterators;
    var wellKnownSymbol$6 = wellKnownSymbol$n;
    var ITERATOR$1 = wellKnownSymbol$6('iterator');
    var getIteratorMethod$9 = function(it) {
        if (!isNullOrUndefined$3(it)) return getMethod(it, ITERATOR$1) || getMethod(it, '@@iterator') || Iterators[classof$5(it)];
    };
    var call$9 = functionCall;
    var aCallable$7 = aCallable$e;
    var anObject$5 = anObject$d;
    var tryToString$3 = tryToString$6;
    var getIteratorMethod$8 = getIteratorMethod$9;
    var $TypeError$7 = TypeError;
    var getIterator$8 = function(argument, usingIterator) {
        var iteratorMethod = arguments.length < 2 ? getIteratorMethod$8(argument) : usingIterator;
        if (aCallable$7(iteratorMethod)) return anObject$5(call$9(iteratorMethod, argument));
        throw new $TypeError$7(tryToString$3(argument) + ' is not iterable');
    };
    var bind$9 = functionBindContext;
    var call$8 = functionCall;
    var toObject$6 = toObject$e;
    var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
    var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
    var isConstructor$2 = isConstructor$4;
    var lengthOfArrayLike$5 = lengthOfArrayLike$d;
    var createProperty$3 = createProperty$6;
    var getIterator$7 = getIterator$8;
    var getIteratorMethod$7 = getIteratorMethod$9;
    var $Array$1 = Array;
    // `Array.from` method implementation
    // https://tc39.es/ecma262/#sec-array.from
    var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = toObject$6(arrayLike);
        var IS_CONSTRUCTOR = isConstructor$2(this);
        var argumentsLength = arguments.length;
        var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        if (mapping) mapfn = bind$9(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
        var iteratorMethod = getIteratorMethod$7(O);
        var index = 0;
        var length, result, step, iterator, next, value;
        // if the target is not iterable or it's an array with the default iterator - use a simple case
        if (iteratorMethod && !(this === $Array$1 && isArrayIteratorMethod$1(iteratorMethod))) {
            iterator = getIterator$7(O, iteratorMethod);
            next = iterator.next;
            result = IS_CONSTRUCTOR ? new this() : [];
            for(; !(step = call$8(next, iterator)).done; index++){
                value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                    step.value,
                    index
                ], true) : step.value;
                createProperty$3(result, index, value);
            }
        } else {
            length = lengthOfArrayLike$5(O);
            result = IS_CONSTRUCTOR ? new this(length) : $Array$1(length);
            for(; length > index; index++){
                value = mapping ? mapfn(O[index], index) : O[index];
                createProperty$3(result, index, value);
            }
        }
        result.length = index;
        return result;
    };
    var wellKnownSymbol$5 = wellKnownSymbol$n;
    var ITERATOR = wellKnownSymbol$5('iterator');
    var SAFE_CLOSING = false;
    try {
        var called = 0;
        var iteratorWithReturn = {
            next: function() {
                return {
                    done: !!called++
                };
            },
            'return': function() {
                SAFE_CLOSING = true;
            }
        };
        iteratorWithReturn[ITERATOR] = function() {
            return this;
        };
        // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
        Array.from(iteratorWithReturn, function() {
            throw 2;
        });
    } catch (error) {}
    var checkCorrectnessOfIteration$2 = function(exec, SKIP_CLOSING) {
        try {
            if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
        } catch (error) {
            return false;
        } // workaround of old WebKit + `eval` bug
        var ITERATION_SUPPORT = false;
        try {
            var object = {};
            object[ITERATOR] = function() {
                return {
                    next: function() {
                        return {
                            done: ITERATION_SUPPORT = true
                        };
                    }
                };
            };
            exec(object);
        } catch (error) {}
        return ITERATION_SUPPORT;
    };
    var $$y = _export;
    var from$6 = arrayFrom;
    var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$2;
    var INCORRECT_ITERATION = !checkCorrectnessOfIteration$1(function(iterable) {
        // eslint-disable-next-line es/no-array-from -- required for testing
        Array.from(iterable);
    });
    // `Array.from` method
    // https://tc39.es/ecma262/#sec-array.from
    $$y({
        target: 'Array',
        stat: true,
        forced: INCORRECT_ITERATION
    }, {
        from: from$6
    });
    var path$h = path$o;
    var from$5 = path$h.Array.from;
    var parent$T = from$5;
    var from$4 = parent$T;
    var from$3 = from$4;
    var _Array$from$1 = /*@__PURE__*/ getDefaultExportFromCjs(from$3);
    var getIteratorMethod$6 = getIteratorMethod$9;
    var getIteratorMethod_1 = getIteratorMethod$6;
    var parent$S = getIteratorMethod_1;
    var getIteratorMethod$5 = parent$S;
    var parent$R = getIteratorMethod$5;
    var getIteratorMethod$4 = parent$R;
    var parent$Q = getIteratorMethod$4;
    var getIteratorMethod$3 = parent$Q;
    var getIteratorMethod$2 = getIteratorMethod$3;
    var _getIteratorMethod$1 = /*@__PURE__*/ getDefaultExportFromCjs(getIteratorMethod$2);
    var getIteratorMethod$1 = getIteratorMethod$2;
    var _getIteratorMethod = /*@__PURE__*/ getDefaultExportFromCjs(getIteratorMethod$1);
    var $$x = _export;
    var isArray$9 = isArray$e;
    // `Array.isArray` method
    // https://tc39.es/ecma262/#sec-array.isarray
    $$x({
        target: 'Array',
        stat: true
    }, {
        isArray: isArray$9
    });
    var path$g = path$o;
    var isArray$8 = path$g.Array.isArray;
    var parent$P = isArray$8;
    var isArray$7 = parent$P;
    var parent$O = isArray$7;
    var isArray$6 = parent$O;
    var parent$N = isArray$6;
    var isArray$5 = parent$N;
    var isArray$4 = isArray$5;
    var _Array$isArray$1 = /*@__PURE__*/ getDefaultExportFromCjs(isArray$4);
    function _arrayWithHoles(arr) {
        if (_Array$isArray$1(arr)) return arr;
    }
    var DESCRIPTORS$8 = descriptors;
    var isArray$3 = isArray$e;
    var $TypeError$6 = TypeError;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor;
    // Safari < 13 does not throw an error in this case
    var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS$8 && !function() {
        // makes no sense without proper strict mode support
        if (this !== undefined) return true;
        try {
            // eslint-disable-next-line es/no-object-defineproperty -- safe
            Object.defineProperty([], 'length', {
                writable: false
            }).length = 1;
        } catch (error) {
            return error instanceof TypeError;
        }
    }();
    var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
        if (isArray$3(O) && !getOwnPropertyDescriptor$5(O, 'length').writable) throw new $TypeError$6('Cannot set read only .length');
        return O.length = length;
    } : function(O, length) {
        return O.length = length;
    };
    var $$w = _export;
    var toObject$5 = toObject$e;
    var lengthOfArrayLike$4 = lengthOfArrayLike$d;
    var setArrayLength$1 = arraySetLength;
    var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$4;
    var fails$d = fails$u;
    var INCORRECT_TO_LENGTH = fails$d(function() {
        return [].push.call({
            length: 0x100000000
        }, 1) !== 4294967297;
    });
    // V8 and Safari <= 15.4, FF < 23 throws InternalError
    // https://bugs.chromium.org/p/v8/issues/detail?id=12681
    var properErrorOnNonWritableLength = function() {
        try {
            // eslint-disable-next-line es/no-object-defineproperty -- safe
            Object.defineProperty([], 'length', {
                writable: false
            }).push();
        } catch (error) {
            return error instanceof TypeError;
        }
    };
    var FORCED$3 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();
    // `Array.prototype.push` method
    // https://tc39.es/ecma262/#sec-array.prototype.push
    $$w({
        target: 'Array',
        proto: true,
        arity: 1,
        forced: FORCED$3
    }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        push: function push(item) {
            var O = toObject$5(this);
            var len = lengthOfArrayLike$4(O);
            var argCount = arguments.length;
            doesNotExceedSafeInteger$1(len + argCount);
            for(var i = 0; i < argCount; i++){
                O[len] = arguments[i];
                len++;
            }
            setArrayLength$1(O, len);
            return len;
        }
    });
    var getBuiltInPrototypeMethod$a = getBuiltInPrototypeMethod$g;
    var push$8 = getBuiltInPrototypeMethod$a('Array', 'push');
    var isPrototypeOf$d = objectIsPrototypeOf;
    var method$a = push$8;
    var ArrayPrototype$a = Array.prototype;
    var push$7 = function(it) {
        var own = it.push;
        return it === ArrayPrototype$a || isPrototypeOf$d(ArrayPrototype$a, it) && own === ArrayPrototype$a.push ? method$a : own;
    };
    var parent$M = push$7;
    var push$6 = parent$M;
    var parent$L = push$6;
    var push$5 = parent$L;
    var parent$K = push$5;
    var push$4 = parent$K;
    var push$3 = push$4;
    var _pushInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(push$3);
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof _Symbol$1 && _getIteratorMethod$1(r) || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (_pushInstanceProperty(a).call(a, e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    var $$v = _export;
    var isArray$2 = isArray$e;
    var isConstructor$1 = isConstructor$4;
    var isObject$7 = isObject$h;
    var toAbsoluteIndex$1 = toAbsoluteIndex$4;
    var lengthOfArrayLike$3 = lengthOfArrayLike$d;
    var toIndexedObject$2 = toIndexedObject$a;
    var createProperty$2 = createProperty$6;
    var wellKnownSymbol$4 = wellKnownSymbol$n;
    var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$5;
    var nativeSlice = arraySlice$5;
    var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1('slice');
    var SPECIES$3 = wellKnownSymbol$4('species');
    var $Array = Array;
    var max$1 = Math.max;
    // `Array.prototype.slice` method
    // https://tc39.es/ecma262/#sec-array.prototype.slice
    // fallback for not array-like ES3 strings and DOM objects
    $$v({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT$1
    }, {
        slice: function slice(start, end) {
            var O = toIndexedObject$2(this);
            var length = lengthOfArrayLike$3(O);
            var k = toAbsoluteIndex$1(start, length);
            var fin = toAbsoluteIndex$1(end === undefined ? length : end, length);
            // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
            var Constructor, result, n;
            if (isArray$2(O)) {
                Constructor = O.constructor;
                // cross-realm fallback
                if (isConstructor$1(Constructor) && (Constructor === $Array || isArray$2(Constructor.prototype))) Constructor = undefined;
                else if (isObject$7(Constructor)) {
                    Constructor = Constructor[SPECIES$3];
                    if (Constructor === null) Constructor = undefined;
                }
                if (Constructor === $Array || Constructor === undefined) return nativeSlice(O, k, fin);
            }
            result = new (Constructor === undefined ? $Array : Constructor)(max$1(fin - k, 0));
            for(n = 0; k < fin; k++, n++)if (k in O) createProperty$2(result, n, O[k]);
            result.length = n;
            return result;
        }
    });
    var getBuiltInPrototypeMethod$9 = getBuiltInPrototypeMethod$g;
    var slice$6 = getBuiltInPrototypeMethod$9('Array', 'slice');
    var isPrototypeOf$c = objectIsPrototypeOf;
    var method$9 = slice$6;
    var ArrayPrototype$9 = Array.prototype;
    var slice$5 = function(it) {
        var own = it.slice;
        return it === ArrayPrototype$9 || isPrototypeOf$c(ArrayPrototype$9, it) && own === ArrayPrototype$9.slice ? method$9 : own;
    };
    var parent$J = slice$5;
    var slice$4 = parent$J;
    var parent$I = slice$4;
    var slice$3 = parent$I;
    var parent$H = slice$3;
    var slice$2 = parent$H;
    var slice$1 = slice$2;
    var _sliceInstanceProperty$1 = /*@__PURE__*/ getDefaultExportFromCjs(slice$1);
    var parent$G = from$4;
    var from$2 = parent$G;
    var parent$F = from$2;
    var from$1 = parent$F;
    var from = from$1;
    var _Array$from = /*@__PURE__*/ getDefaultExportFromCjs(from);
    function _arrayLikeToArray$4(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _unsupportedIterableToArray$4(o, minLen) {
        var _context;
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);
        var n = _sliceInstanceProperty$1(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return _Array$from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest();
    }
    function _arrayWithoutHoles(arr) {
        if (_Array$isArray$1(arr)) return _arrayLikeToArray$4(arr);
    }
    function _iterableToArray(iter) {
        if (typeof _Symbol$1 !== "undefined" && _getIteratorMethod$1(iter) != null || iter["@@iterator"] != null) return _Array$from(iter);
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread();
    }
    var symbol = symbol$4;
    var _Symbol = /*@__PURE__*/ getDefaultExportFromCjs(symbol);
    var getBuiltInPrototypeMethod$8 = getBuiltInPrototypeMethod$g;
    var concat$5 = getBuiltInPrototypeMethod$8('Array', 'concat');
    var isPrototypeOf$b = objectIsPrototypeOf;
    var method$8 = concat$5;
    var ArrayPrototype$8 = Array.prototype;
    var concat$4 = function(it) {
        var own = it.concat;
        return it === ArrayPrototype$8 || isPrototypeOf$b(ArrayPrototype$8, it) && own === ArrayPrototype$8.concat ? method$8 : own;
    };
    var parent$E = concat$4;
    var concat$3 = parent$E;
    var concat$2 = concat$3;
    var _concatInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(concat$2);
    var slice = slice$4;
    var _sliceInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(slice);
    var getBuiltIn$5 = getBuiltIn$f;
    var uncurryThis$5 = functionUncurryThis;
    var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
    var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
    var anObject$4 = anObject$d;
    var concat$1 = uncurryThis$5([].concat);
    // all object keys, includes non-enumerable and symbols
    var ownKeys$7 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
        var keys = getOwnPropertyNamesModule$1.f(anObject$4(it));
        var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
        return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
    };
    var $$u = _export;
    var ownKeys$6 = ownKeys$7;
    // `Reflect.ownKeys` method
    // https://tc39.es/ecma262/#sec-reflect.ownkeys
    $$u({
        target: 'Reflect',
        stat: true
    }, {
        ownKeys: ownKeys$6
    });
    var path$f = path$o;
    var ownKeys$5 = path$f.Reflect.ownKeys;
    var parent$D = ownKeys$5;
    var ownKeys$4 = parent$D;
    var ownKeys$3 = ownKeys$4;
    var _Reflect$ownKeys = /*@__PURE__*/ getDefaultExportFromCjs(ownKeys$3);
    var isArray$1 = isArray$7;
    var _Array$isArray = /*@__PURE__*/ getDefaultExportFromCjs(isArray$1);
    var $$t = _export;
    var toObject$4 = toObject$e;
    var nativeKeys = objectKeys$3;
    var fails$c = fails$u;
    var FAILS_ON_PRIMITIVES$2 = fails$c(function() {
        nativeKeys(1);
    });
    // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys
    $$t({
        target: 'Object',
        stat: true,
        forced: FAILS_ON_PRIMITIVES$2
    }, {
        keys: function keys(it) {
            return nativeKeys(toObject$4(it));
        }
    });
    var path$e = path$o;
    var keys$6 = path$e.Object.keys;
    var parent$C = keys$6;
    var keys$5 = parent$C;
    var keys$4 = keys$5;
    var _Object$keys = /*@__PURE__*/ getDefaultExportFromCjs(keys$4);
    var $forEach = arrayIteration.forEach;
    var arrayMethodIsStrict$2 = arrayMethodIsStrict$4;
    var STRICT_METHOD$2 = arrayMethodIsStrict$2('forEach');
    // `Array.prototype.forEach` method implementation
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    var arrayForEach = !STRICT_METHOD$2 ? function forEach(callbackfn /* , thisArg */ ) {
        return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
    } : [].forEach;
    var $$s = _export;
    var forEach$8 = arrayForEach;
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
    $$s({
        target: 'Array',
        proto: true,
        forced: [].forEach !== forEach$8
    }, {
        forEach: forEach$8
    });
    var getBuiltInPrototypeMethod$7 = getBuiltInPrototypeMethod$g;
    var forEach$7 = getBuiltInPrototypeMethod$7('Array', 'forEach');
    var parent$B = forEach$7;
    var forEach$6 = parent$B;
    var classof$4 = classof$d;
    var hasOwn$6 = hasOwnProperty_1;
    var isPrototypeOf$a = objectIsPrototypeOf;
    var method$7 = forEach$6;
    var ArrayPrototype$7 = Array.prototype;
    var DOMIterables$3 = {
        DOMTokenList: true,
        NodeList: true
    };
    var forEach$5 = function(it) {
        var own = it.forEach;
        return it === ArrayPrototype$7 || isPrototypeOf$a(ArrayPrototype$7, it) && own === ArrayPrototype$7.forEach || hasOwn$6(DOMIterables$3, classof$4(it)) ? method$7 : own;
    };
    var forEach$4 = forEach$5;
    var _forEachInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(forEach$4);
    var $$r = _export;
    var uncurryThis$4 = functionUncurryThis;
    var isArray = isArray$e;
    var nativeReverse = uncurryThis$4([].reverse);
    var test$1 = [
        1,
        2
    ];
    // `Array.prototype.reverse` method
    // https://tc39.es/ecma262/#sec-array.prototype.reverse
    // fix for Safari 12.0 bug
    // https://bugs.webkit.org/show_bug.cgi?id=188794
    $$r({
        target: 'Array',
        proto: true,
        forced: String(test$1) === String(test$1.reverse())
    }, {
        reverse: function reverse() {
            // eslint-disable-next-line no-self-assign -- dirty hack
            if (isArray(this)) this.length = this.length;
            return nativeReverse(this);
        }
    });
    var getBuiltInPrototypeMethod$6 = getBuiltInPrototypeMethod$g;
    var reverse$6 = getBuiltInPrototypeMethod$6('Array', 'reverse');
    var isPrototypeOf$9 = objectIsPrototypeOf;
    var method$6 = reverse$6;
    var ArrayPrototype$6 = Array.prototype;
    var reverse$5 = function(it) {
        var own = it.reverse;
        return it === ArrayPrototype$6 || isPrototypeOf$9(ArrayPrototype$6, it) && own === ArrayPrototype$6.reverse ? method$6 : own;
    };
    var parent$A = reverse$5;
    var reverse$4 = parent$A;
    var reverse$3 = reverse$4;
    var _reverseInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(reverse$3);
    var tryToString$2 = tryToString$6;
    var $TypeError$5 = TypeError;
    var deletePropertyOrThrow$2 = function(O, P) {
        if (!delete O[P]) throw new $TypeError$5('Cannot delete property ' + tryToString$2(P) + ' of ' + tryToString$2(O));
    };
    var $$q = _export;
    var toObject$3 = toObject$e;
    var toAbsoluteIndex = toAbsoluteIndex$4;
    var toIntegerOrInfinity = toIntegerOrInfinity$4;
    var lengthOfArrayLike$2 = lengthOfArrayLike$d;
    var setArrayLength = arraySetLength;
    var doesNotExceedSafeInteger = doesNotExceedSafeInteger$4;
    var arraySpeciesCreate = arraySpeciesCreate$4;
    var createProperty$1 = createProperty$6;
    var deletePropertyOrThrow$1 = deletePropertyOrThrow$2;
    var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$5;
    var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
    var max = Math.max;
    var min = Math.min;
    // `Array.prototype.splice` method
    // https://tc39.es/ecma262/#sec-array.prototype.splice
    // with adding support of @@species
    $$q({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT
    }, {
        splice: function splice(start, deleteCount /* , ...items */ ) {
            var O = toObject$3(this);
            var len = lengthOfArrayLike$2(O);
            var actualStart = toAbsoluteIndex(start, len);
            var argumentsLength = arguments.length;
            var insertCount, actualDeleteCount, A, k, from, to;
            if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
            else if (argumentsLength === 1) {
                insertCount = 0;
                actualDeleteCount = len - actualStart;
            } else {
                insertCount = argumentsLength - 2;
                actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
            }
            doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
            A = arraySpeciesCreate(O, actualDeleteCount);
            for(k = 0; k < actualDeleteCount; k++){
                from = actualStart + k;
                if (from in O) createProperty$1(A, k, O[from]);
            }
            A.length = actualDeleteCount;
            if (insertCount < actualDeleteCount) {
                for(k = actualStart; k < len - actualDeleteCount; k++){
                    from = k + actualDeleteCount;
                    to = k + insertCount;
                    if (from in O) O[to] = O[from];
                    else deletePropertyOrThrow$1(O, to);
                }
                for(k = len; k > len - actualDeleteCount + insertCount; k--)deletePropertyOrThrow$1(O, k - 1);
            } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
                from = k + actualDeleteCount - 1;
                to = k + insertCount - 1;
                if (from in O) O[to] = O[from];
                else deletePropertyOrThrow$1(O, to);
            }
            for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
            setArrayLength(O, len - actualDeleteCount + insertCount);
            return A;
        }
    });
    var getBuiltInPrototypeMethod$5 = getBuiltInPrototypeMethod$g;
    var splice$3 = getBuiltInPrototypeMethod$5('Array', 'splice');
    var isPrototypeOf$8 = objectIsPrototypeOf;
    var method$5 = splice$3;
    var ArrayPrototype$5 = Array.prototype;
    var splice$2 = function(it) {
        var own = it.splice;
        return it === ArrayPrototype$5 || isPrototypeOf$8(ArrayPrototype$5, it) && own === ArrayPrototype$5.splice ? method$5 : own;
    };
    var parent$z = splice$2;
    var splice$1 = parent$z;
    var splice = splice$1;
    var _spliceInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(splice);
    var DESCRIPTORS$7 = descriptors;
    var uncurryThis$3 = functionUncurryThis;
    var call$7 = functionCall;
    var fails$b = fails$u;
    var objectKeys = objectKeys$3;
    var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
    var propertyIsEnumerableModule = objectPropertyIsEnumerable;
    var toObject$2 = toObject$e;
    var IndexedObject = indexedObject;
    // eslint-disable-next-line es/no-object-assign -- safe
    var $assign = Object.assign;
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    var defineProperty$3 = Object.defineProperty;
    var concat = uncurryThis$3([].concat);
    // `Object.assign` method
    // https://tc39.es/ecma262/#sec-object.assign
    var objectAssign = !$assign || fails$b(function() {
        // should have correct order of operations (Edge bug)
        if (DESCRIPTORS$7 && $assign({
            b: 1
        }, $assign(defineProperty$3({}, 'a', {
            enumerable: true,
            get: function() {
                defineProperty$3(this, 'b', {
                    value: 3,
                    enumerable: false
                });
            }
        }), {
            b: 2
        })).b !== 1) return true;
        // should work with symbols and should have deterministic property order (V8 bug)
        var A = {};
        var B = {};
        // eslint-disable-next-line es/no-symbol -- safe
        var symbol = Symbol('assign detection');
        var alphabet = 'abcdefghijklmnopqrst';
        A[symbol] = 7;
        alphabet.split('').forEach(function(chr) {
            B[chr] = chr;
        });
        return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
    }) ? function assign(target, source) {
        var T = toObject$2(target);
        var argumentsLength = arguments.length;
        var index = 1;
        var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
        var propertyIsEnumerable = propertyIsEnumerableModule.f;
        while(argumentsLength > index){
            var S = IndexedObject(arguments[index++]);
            var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
            var length = keys.length;
            var j = 0;
            var key;
            while(length > j){
                key = keys[j++];
                if (!DESCRIPTORS$7 || call$7(propertyIsEnumerable, S, key)) T[key] = S[key];
            }
        }
        return T;
    } : $assign;
    var $$p = _export;
    var assign$5 = objectAssign;
    // `Object.assign` method
    // https://tc39.es/ecma262/#sec-object.assign
    // eslint-disable-next-line es/no-object-assign -- required for testing
    $$p({
        target: 'Object',
        stat: true,
        arity: 2,
        forced: Object.assign !== assign$5
    }, {
        assign: assign$5
    });
    var path$d = path$o;
    var assign$4 = path$d.Object.assign;
    var parent$y = assign$4;
    var assign$3 = parent$y;
    var assign$2 = assign$3;
    var _Object$assign = /*@__PURE__*/ getDefaultExportFromCjs(assign$2);
    var $$o = _export;
    var fails$a = fails$u;
    var toObject$1 = toObject$e;
    var nativeGetPrototypeOf = objectGetPrototypeOf;
    var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;
    var FAILS_ON_PRIMITIVES$1 = fails$a(function() {
        nativeGetPrototypeOf(1);
    });
    // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof
    $$o({
        target: 'Object',
        stat: true,
        forced: FAILS_ON_PRIMITIVES$1,
        sham: !CORRECT_PROTOTYPE_GETTER
    }, {
        getPrototypeOf: function getPrototypeOf(it) {
            return nativeGetPrototypeOf(toObject$1(it));
        }
    });
    var path$c = path$o;
    var getPrototypeOf$5 = path$c.Object.getPrototypeOf;
    var parent$x = getPrototypeOf$5;
    var getPrototypeOf$4 = parent$x;
    // TODO: Remove from `core-js@4`
    var $$n = _export;
    var DESCRIPTORS$6 = descriptors;
    var create$9 = objectCreate;
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    $$n({
        target: 'Object',
        stat: true,
        sham: !DESCRIPTORS$6
    }, {
        create: create$9
    });
    var path$b = path$o;
    var Object$3 = path$b.Object;
    var create$8 = function create(P, D) {
        return Object$3.create(P, D);
    };
    var parent$w = create$8;
    var create$7 = parent$w;
    var create$6 = create$7;
    var _Object$create$1 = /*@__PURE__*/ getDefaultExportFromCjs(create$6);
    var path$a = path$o;
    var apply$3 = functionApply;
    // eslint-disable-next-line es/no-json -- safe
    if (!path$a.JSON) path$a.JSON = {
        stringify: JSON.stringify
    };
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    var stringify$2 = function stringify(it, replacer, space) {
        return apply$3(path$a.JSON.stringify, null, arguments);
    };
    var parent$v = stringify$2;
    var stringify$1 = parent$v;
    var stringify = stringify$1;
    var _JSON$stringify = /*@__PURE__*/ getDefaultExportFromCjs(stringify);
    /* global Bun -- Deno case */ var engineIsBun = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';
    var $TypeError$4 = TypeError;
    var validateArgumentsLength$2 = function(passed, required) {
        if (passed < required) throw new $TypeError$4('Not enough arguments');
        return passed;
    };
    var global$9 = global$p;
    var apply$2 = functionApply;
    var isCallable$5 = isCallable$m;
    var ENGINE_IS_BUN = engineIsBun;
    var USER_AGENT = engineUserAgent;
    var arraySlice$2 = arraySlice$5;
    var validateArgumentsLength$1 = validateArgumentsLength$2;
    var Function$2 = global$9.Function;
    // dirty IE9- and Bun 0.3.0- checks
    var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && function() {
        var version = global$9.Bun.version.split('.');
        return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
    }();
    // IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
    // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
    // https://github.com/oven-sh/bun/issues/1633
    var schedulersFix$2 = function(scheduler, hasTimeArg) {
        var firstParamIndex = hasTimeArg ? 2 : 1;
        return WRAP ? function(handler, timeout /* , ...arguments */ ) {
            var boundArgs = validateArgumentsLength$1(arguments.length, 1) > firstParamIndex;
            var fn = isCallable$5(handler) ? handler : Function$2(handler);
            var params = boundArgs ? arraySlice$2(arguments, firstParamIndex) : [];
            var callback = boundArgs ? function() {
                apply$2(fn, this, params);
            } : fn;
            return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
        } : scheduler;
    };
    var $$m = _export;
    var global$8 = global$p;
    var schedulersFix$1 = schedulersFix$2;
    var setInterval = schedulersFix$1(global$8.setInterval, true);
    // Bun / IE9- setInterval additional parameters fix
    // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
    $$m({
        global: true,
        bind: true,
        forced: global$8.setInterval !== setInterval
    }, {
        setInterval: setInterval
    });
    var $$l = _export;
    var global$7 = global$p;
    var schedulersFix = schedulersFix$2;
    var setTimeout$3 = schedulersFix(global$7.setTimeout, true);
    // Bun / IE9- setTimeout additional parameters fix
    // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
    $$l({
        global: true,
        bind: true,
        forced: global$7.setTimeout !== setTimeout$3
    }, {
        setTimeout: setTimeout$3
    });
    var path$9 = path$o;
    var setTimeout$2 = path$9.setTimeout;
    var setTimeout$1 = setTimeout$2;
    var _setTimeout = /*@__PURE__*/ getDefaultExportFromCjs(setTimeout$1);
    var componentEmitter = {
        exports: {}
    };
    (function(module) {
        function Emitter(object) {
            if (object) return mixin(object);
            this._callbacks = new Map();
        }
        function mixin(object) {
            Object.assign(object, Emitter.prototype);
            object._callbacks = new Map();
            return object;
        }
        Emitter.prototype.on = function(event, listener) {
            const callbacks = this._callbacks.get(event) ?? [];
            callbacks.push(listener);
            this._callbacks.set(event, callbacks);
            return this;
        };
        Emitter.prototype.once = function(event, listener) {
            const on = (...arguments_)=>{
                this.off(event, on);
                listener.apply(this, arguments_);
            };
            on.fn = listener;
            this.on(event, on);
            return this;
        };
        Emitter.prototype.off = function(event, listener) {
            if (event === undefined && listener === undefined) {
                this._callbacks.clear();
                return this;
            }
            if (listener === undefined) {
                this._callbacks.delete(event);
                return this;
            }
            const callbacks = this._callbacks.get(event);
            if (callbacks) {
                for (const [index, callback] of callbacks.entries())if (callback === listener || callback.fn === listener) {
                    callbacks.splice(index, 1);
                    break;
                }
                if (callbacks.length === 0) this._callbacks.delete(event);
                else this._callbacks.set(event, callbacks);
            }
            return this;
        };
        Emitter.prototype.emit = function(event, ...arguments_) {
            const callbacks = this._callbacks.get(event);
            if (callbacks) {
                // Create a copy of the callbacks array to avoid issues if it's modified during iteration
                const callbacksCopy = [
                    ...callbacks
                ];
                for (const callback of callbacksCopy)callback.apply(this, arguments_);
            }
            return this;
        };
        Emitter.prototype.listeners = function(event) {
            return this._callbacks.get(event) ?? [];
        };
        Emitter.prototype.listenerCount = function(event) {
            if (event) return this.listeners(event).length;
            let totalCount = 0;
            for (const callbacks of this._callbacks.values())totalCount += callbacks.length;
            return totalCount;
        };
        Emitter.prototype.hasListeners = function(event) {
            return this.listenerCount(event) > 0;
        };
        // Aliases
        Emitter.prototype.addEventListener = Emitter.prototype.on;
        Emitter.prototype.removeListener = Emitter.prototype.off;
        Emitter.prototype.removeEventListener = Emitter.prototype.off;
        Emitter.prototype.removeAllListeners = Emitter.prototype.off;
        module.exports = Emitter;
    })(componentEmitter);
    var componentEmitterExports = componentEmitter.exports;
    var Emitter = /*@__PURE__*/ getDefaultExportFromCjs(componentEmitterExports);
    /*! Hammer.JS - v2.0.17-rc - 2019-12-16
   * http://naver.github.io/egjs
   *
   * Forked By Naver egjs
   * Copyright (c) hammerjs
   * Licensed under the MIT license */ function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    function _assertThisInitialized$1(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    /**
   * @private
   * extend object.
   * means that properties in dest will be overwritten by the ones in src.
   * @param {Object} target
   * @param {...Object} objects_to_assign
   * @returns {Object} target
   */ var assign;
    if (typeof Object.assign !== 'function') assign = function assign(target) {
        if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
            }
        }
        return output;
    };
    else assign = Object.assign;
    var assign$1 = assign;
    var VENDOR_PREFIXES = [
        '',
        'webkit',
        'Moz',
        'MS',
        'ms',
        'o'
    ];
    var TEST_ELEMENT = typeof document === "undefined" ? {
        style: {}
    } : document.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round, abs = Math.abs;
    var now = Date.now;
    /**
   * @private
   * get the prefixed property
   * @param {Object} obj
   * @param {String} property
   * @returns {String|Undefined} prefixed
   */ function prefixed(obj, property) {
        var prefix;
        var prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /* eslint-disable no-new-func, no-nested-ternary */ var win;
    if (typeof window === "undefined") // window is undefined in node.js
    win = {};
    else win = window;
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) return false;
        var touchMap = {};
        var cssSupports = win.CSS && win.CSS.supports;
        [
            'auto',
            'manipulation',
            'pan-y',
            'pan-x',
            'pan-x pan-y',
            'none'
        ].forEach(function(val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            return touchMap[val] = cssSupports ? win.CSS.supports('touch-action', val) : true;
        });
        return touchMap;
    }
    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = 'ontouchstart' in win;
    var SUPPORT_POINTER_EVENTS = prefixed(win, 'PointerEvent') !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        'x',
        'y'
    ];
    var PROPS_CLIENT_XY = [
        'clientX',
        'clientY'
    ];
    /**
   * @private
   * walk objects and arrays
   * @param {Object} obj
   * @param {Function} iterator
   * @param {Object} context
   */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
   * @private
   * let a boolean value also be a function that must return a boolean
   * this first item in args will be used as the context
   * @param {Boolean|Function} val
   * @param {Array} [args]
   * @returns {Boolean}
   */ function boolOrFn(val, args) {
        if (typeof val === TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
   * @private
   * small indexOf wrapper
   * @param {String} str
   * @param {String} find
   * @returns {Boolean} found
   */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
   * @private
   * when the touchActions are collected they are not a valid value, so we need to clean things up. *
   * @param {String} actions
   * @returns {*}
   */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y); // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
         // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
         // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    /**
   * @private
   * Touch Action
   * sets the touchAction property or uses the js alternative
   * @param {Manager} manager
   * @param {String} value
   * @constructor
   */ var TouchAction = /*#__PURE__*/ function() {
        function TouchAction(manager, value) {
            this.manager = manager;
            this.set(value);
        }
        /**
     * @private
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ var _proto = TouchAction.prototype;
        _proto.set = function set(value) {
            // find out the touch-action by the event handlers
            if (value === TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        };
        /**
     * @private
     * just re-set the touchAction value
     */ _proto.update = function update() {
            this.set(this.manager.options.touchAction);
        };
        /**
     * @private
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ _proto.compute = function compute() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(' '));
        };
        /**
     * @private
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ _proto.preventDefaults = function preventDefaults(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection; // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                // do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) return;
            }
            if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        };
        /**
     * @private
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ _proto.preventSrc = function preventSrc(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        };
        return TouchAction;
    }();
    /**
   * @private
   * find if a node is in the given parent
   * @method hasParent
   * @param {HTMLElement} node
   * @param {HTMLElement} parent
   * @return {Boolean} found
   */ function hasParent(node, parent) {
        while(node){
            if (node === parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
   * @private
   * get the center of all the pointers
   * @param {Array} pointers
   * @return {Object} center contains `x` and `y` properties
   */ function getCenter(pointers) {
        var pointersLength = pointers.length; // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0;
        var y = 0;
        var i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
   * @private
   * create a simple clone from the input used for storage of firstInput and firstMultiple
   * @param {Object} input
   * @returns {Object} clonedInputData
   */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
   * @private
   * calculate the absolute distance between two points
   * @param {Object} p1 {x, y}
   * @param {Object} p2 {x, y}
   * @param {Array} [props] containing x and y keys
   * @return {Number} distance
   */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]];
        var y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
   * @private
   * calculate the angle between two coordinates
   * @param {Object} p1
   * @param {Object} p2
   * @param {Array} [props] containing x and y keys
   * @return {Number} angle
   */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]];
        var y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
   * @private
   * get the direction between two points
   * @param {Number} x
   * @param {Number} y
   * @return {Number} direction
   */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    function computeDeltaXY(session, input) {
        var center = input.center; // let { offsetDelta:offset = {}, prevDelta = {}, prevInput = {} } = session;
        // jscs throwing error on defalut destructured values and without defaults tests fail
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
   * @private
   * calculate the velocity between two points. unit is in px per ms.
   * @param {Number} deltaTime
   * @param {Number} x
   * @param {Number} y
   * @return {Object} velocity `x` and `y`
   */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
   * @private
   * calculate the scale factor between two pointersets
   * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
   * @param {Array} start array of pointers
   * @param {Array} end array of pointers
   * @return {Number} scale
   */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    /**
   * @private
   * calculate the rotation degrees between two pointersets
   * @param {Array} start array of pointers
   * @param {Array} end array of pointers
   * @return {Number} rotation
   */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
   * @private
   * velocity is calculated every x ms
   * @param {Object} session
   * @param {Object} input
   */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input;
        var deltaTime = input.timeStamp - last.timeStamp;
        var velocity;
        var velocityX;
        var velocityY;
        var direction;
        if (input.eventType !== INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
  * @private
   * extend the data with some usable properties like scale, rotate, velocity etc
   * @param {Object} manager
   * @param {Object} input
   */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length; // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
         // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput, firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input); // find the correct target
        var target = manager.element;
        var srcEvent = input.srcEvent;
        var srcEventTarget;
        if (srcEvent.composedPath) srcEventTarget = srcEvent.composedPath()[0];
        else if (srcEvent.path) srcEventTarget = srcEvent.path[0];
        else srcEventTarget = srcEvent.target;
        if (hasParent(srcEventTarget, target)) target = srcEventTarget;
        input.target = target;
    }
    /**
   * @private
   * handle input events
   * @param {Manager} manager
   * @param {String} eventType
   * @param {Object} input
   */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
         // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType; // compute scale, rotation etc
        computeInputData(manager, input); // emit secret event
        manager.emit('hammer.input', input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
   * @private
   * split string on whitespace
   * @param {String} str
   * @returns {Array} words
   */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
   * @private
   * addEventListener with multiple events at once
   * @param {EventTarget} target
   * @param {String} types
   * @param {Function} handler
   */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
   * @private
   * removeEventListener with multiple events at once
   * @param {EventTarget} target
   * @param {String} types
   * @param {Function} handler
   */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
   * @private
   * get the window object of an element
   * @param {HTMLElement} element
   * @returns {DocumentView|Window}
   */ function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window;
    }
    /**
   * @private
   * create new input type manager
   * @param {Manager} manager
   * @param {Function} callback
   * @returns {Input}
   * @constructor
   */ var Input = /*#__PURE__*/ function() {
        function Input(manager, callback) {
            var self1 = this;
            this.manager = manager;
            this.callback = callback;
            this.element = manager.element;
            this.target = manager.options.inputTarget; // smaller wrapper around the handler, for the scope and the enabled state of the manager,
            // so when disabled the input events are completely bypassed.
            this.domHandler = function(ev) {
                if (boolOrFn(manager.options.enable, [
                    manager
                ])) self1.handler(ev);
            };
            this.init();
        }
        /**
     * @private
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ var _proto = Input.prototype;
        _proto.handler = function handler() {};
        /**
     * @private
     * bind the events
     */ _proto.init = function init() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        };
        /**
     * @private
     * unbind the events
     */ _proto.destroy = function destroy() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        };
        return Input;
    }();
    /**
   * @private
   * find if a array contains the object using indexOf or a simple polyFill
   * @param {Array} src
   * @param {String} find
   * @param {String} [findByKey]
   * @return {Boolean|Number} false when not found, or the index
   */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) // do not use === here, test fails
                return i;
                i++;
            }
            return -1;
        }
    }
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    }; // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel'; // IE10 has prefixed support, and case-sensitive
    if (win.MSPointerEvent && !win.PointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
   * @private
   * Pointer events input
   * @constructor
   * @extends Input
   */ var PointerEventInput = /*#__PURE__*/ function(_Input) {
        _inheritsLoose(PointerEventInput, _Input);
        function PointerEventInput() {
            var _this;
            var proto = PointerEventInput.prototype;
            proto.evEl = POINTER_ELEMENT_EVENTS;
            proto.evWin = POINTER_WINDOW_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.store = _this.manager.session.pointerEvents = [];
            return _this;
        }
        /**
     * @private
     * handle mouse events
     * @param {Object} ev
     */ var _proto = PointerEventInput.prototype;
        _proto.handler = function handler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType === INPUT_TYPE_TOUCH; // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, 'pointerId'); // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
             // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
             // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        };
        return PointerEventInput;
    }(Input);
    /**
   * @private
   * convert array-like objects to real arrays
   * @param {Object} obj
   * @returns {Array}
   */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
   * @private
   * unique array with objects based on a key (like 'id') or just by the array's value
   * @param {Array} src [{id:1},{id:2},{id:1}]
   * @param {String} [key]
   * @param {Boolean} [sort=False]
   * @returns {Array} [{id:1},{id:2}]
   */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
   * @private
   * Multi-user touch events input
   * @constructor
   * @extends Input
   */ var TouchInput = /*#__PURE__*/ function(_Input) {
        _inheritsLoose(TouchInput, _Input);
        function TouchInput() {
            var _this;
            TouchInput.prototype.evTarget = TOUCH_TARGET_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.targetIds = {}; // this.evTarget = TOUCH_TARGET_EVENTS;
            return _this;
        }
        var _proto = TouchInput.prototype;
        _proto.handler = function handler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        };
        return TouchInput;
    }(Input);
    function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds; // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i;
        var targetTouches;
        var changedTouches = toArray(ev.changedTouches);
        var changedTargetTouches = [];
        var target = this.target; // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        }); // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        } // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
             // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
            changedTargetTouches
        ];
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
   * @private
   * Mouse events input
   * @constructor
   * @extends Input
   */ var MouseInput = /*#__PURE__*/ function(_Input) {
        _inheritsLoose(MouseInput, _Input);
        function MouseInput() {
            var _this;
            var proto = MouseInput.prototype;
            proto.evEl = MOUSE_ELEMENT_EVENTS;
            proto.evWin = MOUSE_WINDOW_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.pressed = false; // mousedown state
            return _this;
        }
        /**
     * @private
     * handle mouse events
     * @param {Object} ev
     */ var _proto = MouseInput.prototype;
        _proto.handler = function handler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type]; // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
             // mouse must be down
            if (!this.pressed) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        };
        return MouseInput;
    }(Input);
    /**
   * @private
   * Combined touch and mouse input
   *
   * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
   * This because touch devices also emit mouse events while doing a touch.
   *
   * @constructor
   * @extends Input
   */ var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function setLastTouch(eventData) {
        var _eventData$changedPoi = eventData.changedPointers, touch = _eventData$changedPoi[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            var lts = this.lastTouches;
            this.lastTouches.push(lastTouch);
            var removeLastTouch = function removeLastTouch() {
                var i = lts.indexOf(lastTouch);
                if (i > -1) lts.splice(i, 1);
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX;
        var y = eventData.srcEvent.clientY;
        for(var i = 0; i < this.lastTouches.length; i++){
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x);
            var dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
        }
        return false;
    }
    var TouchMouseInput = /*#__PURE__*/ function() {
        var TouchMouseInput = /*#__PURE__*/ function(_Input) {
            _inheritsLoose(TouchMouseInput, _Input);
            function TouchMouseInput(_manager, callback) {
                var _this;
                _this = _Input.call(this, _manager, callback) || this;
                _this.handler = function(manager, inputEvent, inputData) {
                    var isTouch = inputData.pointerType === INPUT_TYPE_TOUCH;
                    var isMouse = inputData.pointerType === INPUT_TYPE_MOUSE;
                    if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
                     // when we're in a touch event, record touches to  de-dupe synthetic mouse event
                    if (isTouch) recordTouches.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputEvent, inputData);
                    else if (isMouse && isSyntheticEvent.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputData)) return;
                    _this.callback(manager, inputEvent, inputData);
                };
                _this.touch = new TouchInput(_this.manager, _this.handler);
                _this.mouse = new MouseInput(_this.manager, _this.handler);
                _this.primaryTouch = null;
                _this.lastTouches = [];
                return _this;
            }
            /**
       * @private
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */ var _proto = TouchMouseInput.prototype;
            /**
       * @private
       * remove the event listeners
       */ _proto.destroy = function destroy() {
                this.touch.destroy();
                this.mouse.destroy();
            };
            return TouchMouseInput;
        }(Input);
        return TouchMouseInput;
    }();
    /**
   * @private
   * create new input type manager
   * called by the Manager constructor
   * @param {Hammer} manager
   * @returns {Input}
   */ function createInputInstance(manager) {
        var Type; // let inputClass = manager.options.inputClass;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
   * @private
   * if the argument is an array, we want to execute the fn on each entry
   * if it aint an array we don't want to do a thing.
   * this is used by all the methods that accept a single and array argument.
   * @param {*|Array} arg
   * @param {String} fn
   * @param {Object} [context]
   * @returns {Boolean}
   */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
   * @private
   * get a unique id
   * @returns {number} uniqueId
   */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
   * @private
   * get a recognizer by name if it is bound to a manager
   * @param {Recognizer|String} otherRecognizer
   * @param {Recognizer} recognizer
   * @returns {Recognizer}
   */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
   * @private
   * get a usable string, used as event postfix
   * @param {constant} state
   * @returns {String} state
   */ function stateStr(state) {
        if (state & STATE_CANCELLED) return 'cancel';
        else if (state & STATE_ENDED) return 'end';
        else if (state & STATE_CHANGED) return 'move';
        else if (state & STATE_BEGAN) return 'start';
        return '';
    }
    /**
   * @private
   * Recognizer flow explained; *
   * All recognizers have the initial state of POSSIBLE when a input session starts.
   * The definition of a input session is from the first input until the last input, with all it's movement in it. *
   * Example session for mouse-input: mousedown -> mousemove -> mouseup
   *
   * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
   * which determines with state it should be.
   *
   * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
   * POSSIBLE to give it another change on the next cycle.
   *
   *               Possible
   *                  |
   *            +-----+---------------+
   *            |                     |
   *      +-----+-----+               |
   *      |           |               |
   *   Failed      Cancelled          |
   *                          +-------+------+
   *                          |              |
   *                      Recognized       Began
   *                                         |
   *                                      Changed
   *                                         |
   *                                  Ended/Recognized
   */ /**
   * @private
   * Recognizer
   * Every recognizer needs to extend from this class.
   * @constructor
   * @param {Object} options
   */ var Recognizer = /*#__PURE__*/ function() {
        function Recognizer(options) {
            if (options === void 0) options = {};
            this.options = _extends({
                enable: true
            }, options);
            this.id = uniqueId();
            this.manager = null; // default is enable true
            this.state = STATE_POSSIBLE;
            this.simultaneous = {};
            this.requireFail = [];
        }
        /**
     * @private
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ var _proto = Recognizer.prototype;
        _proto.set = function set(options) {
            assign$1(this.options, options); // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        };
        /**
     * @private
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ _proto.recognizeWith = function recognizeWith(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        };
        /**
     * @private
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ _proto.dropRecognizeWith = function dropRecognizeWith(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        };
        /**
     * @private
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ _proto.requireFailure = function requireFailure(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        };
        /**
     * @private
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ _proto.dropRequireFailure = function dropRequireFailure(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        };
        /**
     * @private
     * has require failures boolean
     * @returns {boolean}
     */ _proto.hasRequireFailures = function hasRequireFailures() {
            return this.requireFail.length > 0;
        };
        /**
     * @private
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ _proto.canRecognizeWith = function canRecognizeWith(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        };
        /**
     * @private
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ _proto.emit = function emit(input) {
            var self1 = this;
            var state = this.state;
            function emit(event) {
                self1.manager.emit(event, input);
            } // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
            emit(self1.options.event); // simple 'eventName' events
            if (input.additionalEvent) // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
             // panend and pancancel
            if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
        };
        /**
     * @private
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ _proto.tryEmit = function tryEmit(input) {
            if (this.canEmit()) return this.emit(input);
             // it's failing anyway
            this.state = STATE_FAILED;
        };
        /**
     * @private
     * can we emit?
     * @returns {boolean}
     */ _proto.canEmit = function canEmit() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        };
        /**
     * @private
     * update the recognizer
     * @param {Object} inputData
     */ _proto.recognize = function recognize(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign$1({}, inputData); // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            } // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone); // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        };
        /**
     * @private
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {constant} STATE
     */ /* jshint ignore:start */ _proto.process = function process(inputData) {};
        /* jshint ignore:end */ /**
     * @private
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ _proto.getTouchAction = function getTouchAction() {};
        /**
     * @private
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ _proto.reset = function reset() {};
        return Recognizer;
    }();
    /**
   * @private
   * A tap is recognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
   * between the given interval and position. The delay option can be used to recognize multi-taps without firing
   * a single tap.
   *
   * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
   * multi-taps being recognized.
   * @constructor
   * @extends Recognizer
   */ var TapRecognizer = /*#__PURE__*/ function(_Recognizer) {
        _inheritsLoose(TapRecognizer, _Recognizer);
        function TapRecognizer(options) {
            var _this;
            if (options === void 0) options = {};
            _this = _Recognizer.call(this, _extends({
                event: 'tap',
                pointers: 1,
                taps: 1,
                interval: 300,
                // max time between the multi-tap taps
                time: 250,
                // max time of the pointer to be down (like finger on the screen)
                threshold: 9,
                // a minimal movement is ok, but keep it low
                posThreshold: 10
            }, options)) || this; // previous time and center,
            // used for tap counting
            _this.pTime = false;
            _this.pCenter = false;
            _this._timer = null;
            _this._input = null;
            _this.count = 0;
            return _this;
        }
        var _proto = TapRecognizer.prototype;
        _proto.getTouchAction = function getTouchAction() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        };
        _proto.process = function process(input) {
            var _this2 = this;
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
             // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType !== INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input; // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeout(function() {
                            _this2.state = STATE_RECOGNIZED;
                            _this2.tryEmit();
                        }, options.interval);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        };
        _proto.failTimeout = function failTimeout() {
            var _this3 = this;
            this._timer = setTimeout(function() {
                _this3.state = STATE_FAILED;
            }, this.options.interval);
            return STATE_FAILED;
        };
        _proto.reset = function reset() {
            clearTimeout(this._timer);
        };
        _proto.emit = function emit() {
            if (this.state === STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        };
        return TapRecognizer;
    }(Recognizer);
    /**
   * @private
   * This recognizer is just used as a base for the simple attribute recognizers.
   * @constructor
   * @extends Recognizer
   */ var AttrRecognizer = /*#__PURE__*/ function(_Recognizer) {
        _inheritsLoose(AttrRecognizer, _Recognizer);
        function AttrRecognizer(options) {
            if (options === void 0) options = {};
            return _Recognizer.call(this, _extends({
                pointers: 1
            }, options)) || this;
        }
        /**
     * @private
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ var _proto = AttrRecognizer.prototype;
        _proto.attrTest = function attrTest(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        };
        /**
     * @private
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ _proto.process = function process(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input); // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        };
        return AttrRecognizer;
    }(Recognizer);
    /**
   * @private
   * direction cons to string
   * @param {constant} direction
   * @returns {String}
   */ function directionStr(direction) {
        if (direction === DIRECTION_DOWN) return 'down';
        else if (direction === DIRECTION_UP) return 'up';
        else if (direction === DIRECTION_LEFT) return 'left';
        else if (direction === DIRECTION_RIGHT) return 'right';
        return '';
    }
    /**
   * @private
   * Pan
   * Recognized when the pointer is down and moved in the allowed direction.
   * @constructor
   * @extends AttrRecognizer
   */ var PanRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
        _inheritsLoose(PanRecognizer, _AttrRecognizer);
        function PanRecognizer(options) {
            var _this;
            if (options === void 0) options = {};
            _this = _AttrRecognizer.call(this, _extends({
                event: 'pan',
                threshold: 10,
                pointers: 1,
                direction: DIRECTION_ALL
            }, options)) || this;
            _this.pX = null;
            _this.pY = null;
            return _this;
        }
        var _proto = PanRecognizer.prototype;
        _proto.getTouchAction = function getTouchAction() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        };
        _proto.directionTest = function directionTest(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY; // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x !== this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y !== this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        };
        _proto.attrTest = function attrTest(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        };
        _proto.emit = function emit(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) input.additionalEvent = this.options.event + direction;
            _AttrRecognizer.prototype.emit.call(this, input);
        };
        return PanRecognizer;
    }(AttrRecognizer);
    /**
   * @private
   * Swipe
   * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
   * @constructor
   * @extends AttrRecognizer
   */ var SwipeRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
        _inheritsLoose(SwipeRecognizer, _AttrRecognizer);
        function SwipeRecognizer(options) {
            if (options === void 0) options = {};
            return _AttrRecognizer.call(this, _extends({
                event: 'swipe',
                threshold: 10,
                velocity: 0.3,
                direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
                pointers: 1
            }, options)) || this;
        }
        var _proto = SwipeRecognizer.prototype;
        _proto.getTouchAction = function getTouchAction() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        };
        _proto.attrTest = function attrTest(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
            return _AttrRecognizer.prototype.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers === this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        };
        _proto.emit = function emit(input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        };
        return SwipeRecognizer;
    }(AttrRecognizer);
    /**
   * @private
   * Pinch
   * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
   * @constructor
   * @extends AttrRecognizer
   */ var PinchRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
        _inheritsLoose(PinchRecognizer, _AttrRecognizer);
        function PinchRecognizer(options) {
            if (options === void 0) options = {};
            return _AttrRecognizer.call(this, _extends({
                event: 'pinch',
                threshold: 0,
                pointers: 2
            }, options)) || this;
        }
        var _proto = PinchRecognizer.prototype;
        _proto.getTouchAction = function getTouchAction() {
            return [
                TOUCH_ACTION_NONE
            ];
        };
        _proto.attrTest = function attrTest(input) {
            return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        };
        _proto.emit = function emit(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? 'in' : 'out';
                input.additionalEvent = this.options.event + inOut;
            }
            _AttrRecognizer.prototype.emit.call(this, input);
        };
        return PinchRecognizer;
    }(AttrRecognizer);
    /**
   * @private
   * Rotate
   * Recognized when two or more pointer are moving in a circular motion.
   * @constructor
   * @extends AttrRecognizer
   */ var RotateRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
        _inheritsLoose(RotateRecognizer, _AttrRecognizer);
        function RotateRecognizer(options) {
            if (options === void 0) options = {};
            return _AttrRecognizer.call(this, _extends({
                event: 'rotate',
                threshold: 0,
                pointers: 2
            }, options)) || this;
        }
        var _proto = RotateRecognizer.prototype;
        _proto.getTouchAction = function getTouchAction() {
            return [
                TOUCH_ACTION_NONE
            ];
        };
        _proto.attrTest = function attrTest(input) {
            return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        };
        return RotateRecognizer;
    }(AttrRecognizer);
    /**
   * @private
   * Press
   * Recognized when the pointer is down for x ms without any movement.
   * @constructor
   * @extends Recognizer
   */ var PressRecognizer = /*#__PURE__*/ function(_Recognizer) {
        _inheritsLoose(PressRecognizer, _Recognizer);
        function PressRecognizer(options) {
            var _this;
            if (options === void 0) options = {};
            _this = _Recognizer.call(this, _extends({
                event: 'press',
                pointers: 1,
                time: 251,
                // minimal time of the pointer to be pressed
                threshold: 9
            }, options)) || this;
            _this._timer = null;
            _this._input = null;
            return _this;
        }
        var _proto = PressRecognizer.prototype;
        _proto.getTouchAction = function getTouchAction() {
            return [
                TOUCH_ACTION_AUTO
            ];
        };
        _proto.process = function process(input) {
            var _this2 = this;
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input; // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeout(function() {
                    _this2.state = STATE_RECOGNIZED;
                    _this2.tryEmit();
                }, options.time);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        };
        _proto.reset = function reset() {
            clearTimeout(this._timer);
        };
        _proto.emit = function emit(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + "up", input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        };
        return PressRecognizer;
    }(Recognizer);
    var defaults = {
        /**
     * @private
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * @private
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @private
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * @private
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * @private
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * @private
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
       * @private
       * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
       * @type {String}
       * @default 'none'
       */ userSelect: "none",
            /**
       * @private
       * Disable the Windows Phone grippers when pressing an element.
       * @type {String}
       * @default 'none'
       */ touchSelect: "none",
            /**
       * @private
       * Disables the default callout shown when you touch and hold a touch target.
       * On iOS, when you touch and hold a touch target such as a link, Safari displays
       * a callout containing information about the link. This property allows you to disable that callout.
       * @type {String}
       * @default 'none'
       */ touchCallout: "none",
            /**
       * @private
       * Specifies whether zooming is enabled. Used by IE10>
       * @type {String}
       * @default 'none'
       */ contentZooming: "none",
            /**
       * @private
       * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
       * @type {String}
       * @default 'none'
       */ userDrag: "none",
            /**
       * @private
       * Overrides the highlight color shown when the user taps a link or a JavaScript
       * clickable element in iOS. This property obeys the alpha value, if specified.
       * @type {String}
       * @default 'rgba(0,0,0,0)'
       */ tapHighlightColor: "rgba(0,0,0,0)"
        }
    };
    /**
   * @private
   * Default recognizer setup when calling `Hammer()`
   * When creating a new Manager these will be skipped.
   * This is separated with other defaults because of tree-shaking.
   * @type {Array}
   */ var preset = [
        [
            RotateRecognizer,
            {
                enable: false
            }
        ],
        [
            PinchRecognizer,
            {
                enable: false
            },
            [
                'rotate'
            ]
        ],
        [
            SwipeRecognizer,
            {
                direction: DIRECTION_HORIZONTAL
            }
        ],
        [
            PanRecognizer,
            {
                direction: DIRECTION_HORIZONTAL
            },
            [
                'swipe'
            ]
        ],
        [
            TapRecognizer
        ],
        [
            TapRecognizer,
            {
                event: 'doubletap',
                taps: 2
            },
            [
                'tap'
            ]
        ],
        [
            PressRecognizer
        ]
    ];
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
   * @private
   * add/remove the css properties as defined in manager.options.cssProps
   * @param {Manager} manager
   * @param {Boolean} add
   */ function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) return;
        var prop;
        each(manager.options.cssProps, function(value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = manager.oldCssProps[prop] || "";
        });
        if (!add) manager.oldCssProps = {};
    }
    /**
   * @private
   * trigger dom event
   * @param {String} event
   * @param {Object} data
   */ function triggerDomEvent(event, data) {
        var gestureEvent = document.createEvent("Event");
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    /**
  * @private
   * Manager
   * @param {HTMLElement} element
   * @param {Object} [options]
   * @constructor
   */ var Manager = /*#__PURE__*/ function() {
        function Manager(element, options) {
            var _this = this;
            this.options = assign$1({}, defaults, options || {});
            this.options.inputTarget = this.options.inputTarget || element;
            this.handlers = {};
            this.session = {};
            this.recognizers = [];
            this.oldCssProps = {};
            this.element = element;
            this.input = createInputInstance(this);
            this.touchAction = new TouchAction(this, this.options.touchAction);
            toggleCssProps(this, true);
            each(this.options.recognizers, function(item) {
                var recognizer = _this.add(new item[0](item[1]));
                item[2] && recognizer.recognizeWith(item[2]);
                item[3] && recognizer.requireFailure(item[3]);
            }, this);
        }
        /**
     * @private
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ var _proto = Manager.prototype;
        _proto.set = function set(options) {
            assign$1(this.options, options); // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        };
        /**
     * @private
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ _proto.stop = function stop(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        };
        /**
     * @private
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ _proto.recognize = function recognize(inputData) {
            var session = this.session;
            if (session.stopped) return;
             // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers; // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer; // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) {
                session.curRecognizer = null;
                curRecognizer = null;
            }
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i]; // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer === curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) // 3
                recognizer.recognize(inputData);
                else recognizer.reset();
                 // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                    session.curRecognizer = recognizer;
                    curRecognizer = recognizer;
                }
                i++;
            }
        };
        /**
     * @private
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ _proto.get = function get(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event === recognizer) return recognizers[i];
            }
            return null;
        };
        /**
     * @private add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ _proto.add = function add(recognizer) {
            if (invokeArrayArg(recognizer, "add", this)) return this;
             // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        };
        /**
     * @private
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ _proto.remove = function remove(recognizer) {
            if (invokeArrayArg(recognizer, "remove", this)) return this;
            var targetRecognizer = this.get(recognizer); // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, targetRecognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        };
        /**
     * @private
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ _proto.on = function on(events, handler) {
            if (events === undefined || handler === undefined) return this;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        };
        /**
     * @private unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ _proto.off = function off(events, handler) {
            if (events === undefined) return this;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        };
        /**
     * @private emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ _proto.emit = function emit(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
             // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        };
        /**
     * @private
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ _proto.destroy = function destroy() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        };
        return Manager;
    }();
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
   * @private
   * Touch events input
   * @constructor
   * @extends Input
   */ var SingleTouchInput = /*#__PURE__*/ function(_Input) {
        _inheritsLoose(SingleTouchInput, _Input);
        function SingleTouchInput() {
            var _this;
            var proto = SingleTouchInput.prototype;
            proto.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
            proto.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.started = false;
            return _this;
        }
        var _proto = SingleTouchInput.prototype;
        _proto.handler = function handler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type]; // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type); // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        };
        return SingleTouchInput;
    }(Input);
    function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), 'identifier', true);
        return [
            all,
            changed
        ];
    }
    /**
   * @private
   * wrap a method with a deprecation warning and stack trace
   * @param {Function} method
   * @param {String} name
   * @param {String} message
   * @returns {Function} A new function wrapping the supplied method.
   */ function deprecate(method, name, message) {
        var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
        return function() {
            var e = new Error('get-stack-trace');
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
            var log = window.console && (window.console.warn || window.console.log);
            if (log) log.call(window.console, deprecationMessage, stack);
            return method.apply(this, arguments);
        };
    }
    /**
   * @private
   * extend object.
   * means that properties in dest will be overwritten by the ones in src.
   * @param {Object} dest
   * @param {Object} src
   * @param {Boolean} [merge=false]
   * @returns {Object} dest
   */ var extend = deprecate(function(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }, 'extend', 'Use `assign`.');
    /**
   * @private
   * merge the values from src in the dest.
   * means that properties that exist in dest will not be overwritten by src
   * @param {Object} dest
   * @param {Object} src
   * @returns {Object} dest
   */ var merge$1 = deprecate(function(dest, src) {
        return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
   * @private
   * simple class inheritance
   * @param {Function} child
   * @param {Function} base
   * @param {Object} [properties]
   */ function inherit(child, base, properties) {
        var baseP = base.prototype;
        var childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) assign$1(childP, properties);
    }
    /**
   * @private
   * simple function bind
   * @param {Function} fn
   * @param {Object} context
   * @returns {Function}
   */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
   * @private
   * Simple way to create a manager with a default set of recognizers.
   * @param {HTMLElement} element
   * @param {Object} [options]
   * @constructor
   */ var Hammer = /*#__PURE__*/ function() {
        var Hammer = /**
      * @private
      * @const {string}
      */ function Hammer(element, options) {
            if (options === void 0) options = {};
            return new Manager(element, _extends({
                recognizers: preset.concat()
            }, options));
        };
        Hammer.VERSION = "2.0.17-rc";
        Hammer.DIRECTION_ALL = DIRECTION_ALL;
        Hammer.DIRECTION_DOWN = DIRECTION_DOWN;
        Hammer.DIRECTION_LEFT = DIRECTION_LEFT;
        Hammer.DIRECTION_RIGHT = DIRECTION_RIGHT;
        Hammer.DIRECTION_UP = DIRECTION_UP;
        Hammer.DIRECTION_HORIZONTAL = DIRECTION_HORIZONTAL;
        Hammer.DIRECTION_VERTICAL = DIRECTION_VERTICAL;
        Hammer.DIRECTION_NONE = DIRECTION_NONE;
        Hammer.DIRECTION_DOWN = DIRECTION_DOWN;
        Hammer.INPUT_START = INPUT_START;
        Hammer.INPUT_MOVE = INPUT_MOVE;
        Hammer.INPUT_END = INPUT_END;
        Hammer.INPUT_CANCEL = INPUT_CANCEL;
        Hammer.STATE_POSSIBLE = STATE_POSSIBLE;
        Hammer.STATE_BEGAN = STATE_BEGAN;
        Hammer.STATE_CHANGED = STATE_CHANGED;
        Hammer.STATE_ENDED = STATE_ENDED;
        Hammer.STATE_RECOGNIZED = STATE_RECOGNIZED;
        Hammer.STATE_CANCELLED = STATE_CANCELLED;
        Hammer.STATE_FAILED = STATE_FAILED;
        Hammer.Manager = Manager;
        Hammer.Input = Input;
        Hammer.TouchAction = TouchAction;
        Hammer.TouchInput = TouchInput;
        Hammer.MouseInput = MouseInput;
        Hammer.PointerEventInput = PointerEventInput;
        Hammer.TouchMouseInput = TouchMouseInput;
        Hammer.SingleTouchInput = SingleTouchInput;
        Hammer.Recognizer = Recognizer;
        Hammer.AttrRecognizer = AttrRecognizer;
        Hammer.Tap = TapRecognizer;
        Hammer.Pan = PanRecognizer;
        Hammer.Swipe = SwipeRecognizer;
        Hammer.Pinch = PinchRecognizer;
        Hammer.Rotate = RotateRecognizer;
        Hammer.Press = PressRecognizer;
        Hammer.on = addEventListeners;
        Hammer.off = removeEventListeners;
        Hammer.each = each;
        Hammer.merge = merge$1;
        Hammer.extend = extend;
        Hammer.bindFn = bindFn;
        Hammer.assign = assign$1;
        Hammer.inherit = inherit;
        Hammer.bindFn = bindFn;
        Hammer.prefixed = prefixed;
        Hammer.toArray = toArray;
        Hammer.inArray = inArray;
        Hammer.uniqueArray = uniqueArray;
        Hammer.splitStr = splitStr;
        Hammer.boolOrFn = boolOrFn;
        Hammer.hasParent = hasParent;
        Hammer.addEventListeners = addEventListeners;
        Hammer.removeEventListeners = removeEventListeners;
        Hammer.defaults = assign$1({}, defaults, {
            preset: preset
        });
        return Hammer;
    }();
    var RealHammer = Hammer;
    function _createForOfIteratorHelper$3(o, allowArrayLike) {
        var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
        if (!it) {
            if (_Array$isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;
                var F = function F() {};
                return {
                    s: F,
                    n: function n() {
                        if (i >= o.length) return {
                            done: true
                        };
                        return {
                            done: false,
                            value: o[i++]
                        };
                    },
                    e: function e(_e) {
                        throw _e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var normalCompletion = true, didErr = false, err;
        return {
            s: function s() {
                it = it.call(o);
            },
            n: function n() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
            },
            e: function e(_e2) {
                didErr = true;
                err = _e2;
            },
            f: function f() {
                try {
                    if (!normalCompletion && it.return != null) it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    function _unsupportedIterableToArray$3(o, minLen) {
        var _context15;
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
        var n = _sliceInstanceProperty(_context15 = Object.prototype.toString.call(o)).call(_context15, 8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return _Array$from$1(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
    }
    function _arrayLikeToArray$3(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    /**
   * Use this symbol to delete properies in deepObjectAssign.
   */ var DELETE = _Symbol("DELETE");
    /**
   * Pure version of deepObjectAssign, it doesn't modify any of it's arguments.
   *
   * @param base - The base object that fullfils the whole interface T.
   * @param updates - Updates that may change or delete props.
   * @returns A brand new instance with all the supplied objects deeply merged.
   */ function pureDeepObjectAssign(base) {
        var _context;
        for(var _len = arguments.length, updates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)updates[_key - 1] = arguments[_key];
        return deepObjectAssign.apply(void 0, _concatInstanceProperty(_context = [
            {},
            base
        ]).call(_context, updates));
    }
    /**
   * Deep version of object assign with additional deleting by the DELETE symbol.
   *
   * @param values - Objects to be deeply merged.
   * @returns The first object from values.
   */ function deepObjectAssign() {
        var merged = deepObjectAssignNonentry.apply(void 0, arguments);
        stripDelete(merged);
        return merged;
    }
    /**
   * Deep version of object assign with additional deleting by the DELETE symbol.
   *
   * @remarks
   * This doesn't strip the DELETE symbols so they may end up in the final object.
   * @param values - Objects to be deeply merged.
   * @returns The first object from values.
   */ function deepObjectAssignNonentry() {
        for(var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)values[_key2] = arguments[_key2];
        if (values.length < 2) return values[0];
        else if (values.length > 2) {
            var _context2;
            return deepObjectAssignNonentry.apply(void 0, _concatInstanceProperty(_context2 = [
                deepObjectAssign(values[0], values[1])
            ]).call(_context2, _toConsumableArray(_sliceInstanceProperty(values).call(values, 2))));
        }
        var a = values[0];
        var b = values[1];
        if (a instanceof Date && b instanceof Date) {
            a.setTime(b.getTime());
            return a;
        }
        var _iterator = _createForOfIteratorHelper$3(_Reflect$ownKeys(b)), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var prop = _step.value;
                if (!Object.prototype.propertyIsEnumerable.call(b, prop)) ;
                else if (b[prop] === DELETE) delete a[prop];
                else if (a[prop] !== null && b[prop] !== null && typeof a[prop] === "object" && typeof b[prop] === "object" && !_Array$isArray(a[prop]) && !_Array$isArray(b[prop])) a[prop] = deepObjectAssignNonentry(a[prop], b[prop]);
                else a[prop] = clone(b[prop]);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return a;
    }
    /**
   * Deep clone given object or array. In case of primitive simply return.
   *
   * @param a - Anything.
   * @returns Deep cloned object/array or unchanged a.
   */ function clone(a) {
        if (_Array$isArray(a)) return _mapInstanceProperty(a).call(a, function(value) {
            return clone(value);
        });
        else if (typeof a === "object" && a !== null) {
            if (a instanceof Date) return new Date(a.getTime());
            return deepObjectAssignNonentry({}, a);
        } else return a;
    }
    /**
   * Strip DELETE from given object.
   *
   * @param a - Object which may contain DELETE but won't after this is executed.
   */ function stripDelete(a) {
        for(var _i = 0, _Object$keys$1 = _Object$keys(a); _i < _Object$keys$1.length; _i++){
            var prop = _Object$keys$1[_i];
            if (a[prop] === DELETE) delete a[prop];
            else if (typeof a[prop] === "object" && a[prop] !== null) stripDelete(a[prop]);
        }
    }
    /**
   * Setup a mock hammer.js object, for unit testing.
   *
   * Inspiration: https://github.com/uber/deck.gl/pull/658
   *
   * @returns {{on: noop, off: noop, destroy: noop, emit: noop, get: get}}
   */ function hammerMock() {
        var noop = function noop() {};
        return {
            on: noop,
            off: noop,
            destroy: noop,
            emit: noop,
            get () {
                return {
                    set: noop
                };
            }
        };
    }
    var Hammer$1 = typeof window !== "undefined" ? window.Hammer || RealHammer : function() {
        // hammer.js is only available in a browser, not in node.js. Replacing it with a mock object.
        return hammerMock();
    };
    /**
   * Turn an element into an clickToUse element.
   * When not active, the element has a transparent overlay. When the overlay is
   * clicked, the mode is changed to active.
   * When active, the element is displayed with a blue border around it, and
   * the interactive contents of the element can be used. When clicked outside
   * the element, the elements mode is changed to inactive.
   *
   * @param {Element} container
   * @class Activator
   */ function Activator$1(container) {
        var _this = this, _context3;
        this._cleanupQueue = [];
        this.active = false;
        this._dom = {
            container,
            overlay: document.createElement("div")
        };
        this._dom.overlay.classList.add("vis-overlay");
        this._dom.container.appendChild(this._dom.overlay);
        this._cleanupQueue.push(function() {
            _this._dom.overlay.parentNode.removeChild(_this._dom.overlay);
        });
        var hammer = Hammer$1(this._dom.overlay);
        hammer.on("tap", _bindInstanceProperty$1(_context3 = this._onTapOverlay).call(_context3, this));
        this._cleanupQueue.push(function() {
            hammer.destroy();
        // FIXME: cleaning up hammer instances doesn't work (Timeline not removed
        // from memory)
        });
        // block all touch events (except tap)
        var events = [
            "tap",
            "doubletap",
            "press",
            "pinch",
            "pan",
            "panstart",
            "panmove",
            "panend"
        ];
        _forEachInstanceProperty(events).call(events, function(event) {
            hammer.on(event, function(event) {
                event.srcEvent.stopPropagation();
            });
        });
        // attach a click event to the window, in order to deactivate when clicking outside the timeline
        if (document && document.body) {
            this._onClick = function(event) {
                if (!_hasParent(event.target, container)) _this.deactivate();
            };
            document.body.addEventListener("click", this._onClick);
            this._cleanupQueue.push(function() {
                document.body.removeEventListener("click", _this._onClick);
            });
        }
        // prepare escape key listener for deactivating when active
        this._escListener = function(event) {
            if ("key" in event ? event.key === "Escape" : event.keyCode === 27 /* the keyCode is for IE11 */ ) _this.deactivate();
        };
    }
    // turn into an event emitter
    Emitter(Activator$1.prototype);
    // The currently active activator
    Activator$1.current = null;
    /**
   * Destroy the activator. Cleans up all created DOM and event listeners
   */ Activator$1.prototype.destroy = function() {
        var _context4, _context5;
        this.deactivate();
        var _iterator2 = _createForOfIteratorHelper$3(_reverseInstanceProperty(_context4 = _spliceInstanceProperty(_context5 = this._cleanupQueue).call(_context5, 0)).call(_context4)), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var callback = _step2.value;
                callback();
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
    /**
   * Activate the element
   * Overlay is hidden, element is decorated with a blue shadow border
   */ Activator$1.prototype.activate = function() {
        // we allow only one active activator at a time
        if (Activator$1.current) Activator$1.current.deactivate();
        Activator$1.current = this;
        this.active = true;
        this._dom.overlay.style.display = "none";
        this._dom.container.classList.add("vis-active");
        this.emit("change");
        this.emit("activate");
        // ugly hack: bind ESC after emitting the events, as the Network rebinds all
        // keyboard events on a 'change' event
        document.body.addEventListener("keydown", this._escListener);
    };
    /**
   * Deactivate the element
   * Overlay is displayed on top of the element
   */ Activator$1.prototype.deactivate = function() {
        this.active = false;
        this._dom.overlay.style.display = "block";
        this._dom.container.classList.remove("vis-active");
        document.body.removeEventListener("keydown", this._escListener);
        this.emit("change");
        this.emit("deactivate");
    };
    /**
   * Handle a tap event: activate the container
   *
   * @param {Event}  event   The event
   * @private
   */ Activator$1.prototype._onTapOverlay = function(event) {
        // activate the container
        this.activate();
        event.srcEvent.stopPropagation();
    };
    /**
   * Test whether the element has the requested parent element somewhere in
   * its chain of parent nodes.
   *
   * @param {HTMLElement} element
   * @param {HTMLElement} parent
   * @returns {boolean} Returns true when the parent is found somewhere in the
   *                    chain of parent nodes.
   * @private
   */ function _hasParent(element, parent) {
        while(element){
            if (element === parent) return true;
            element = element.parentNode;
        }
        return false;
    }
    var isConstructor = isConstructor$4;
    var tryToString$1 = tryToString$6;
    var $TypeError$3 = TypeError;
    // `Assert: IsConstructor(argument) is true`
    var aConstructor$2 = function(argument) {
        if (isConstructor(argument)) return argument;
        throw new $TypeError$3(tryToString$1(argument) + ' is not a constructor');
    };
    var $$k = _export;
    var getBuiltIn$4 = getBuiltIn$f;
    var apply$1 = functionApply;
    var bind$8 = functionBind;
    var aConstructor$1 = aConstructor$2;
    var anObject$3 = anObject$d;
    var isObject$6 = isObject$h;
    var create$5 = objectCreate;
    var fails$9 = fails$u;
    var nativeConstruct = getBuiltIn$4('Reflect', 'construct');
    var ObjectPrototype = Object.prototype;
    var push$2 = [].push;
    // `Reflect.construct` method
    // https://tc39.es/ecma262/#sec-reflect.construct
    // MS Edge supports only 2 arguments and argumentsList argument is optional
    // FF Nightly sets third argument as `new.target`, but does not create `this` from it
    var NEW_TARGET_BUG = fails$9(function() {
        function F() {}
        return !(nativeConstruct(function() {}, [], F) instanceof F);
    });
    var ARGS_BUG = !fails$9(function() {
        nativeConstruct(function() {});
    });
    var FORCED$2 = NEW_TARGET_BUG || ARGS_BUG;
    $$k({
        target: 'Reflect',
        stat: true,
        forced: FORCED$2,
        sham: FORCED$2
    }, {
        construct: function construct(Target, args /* , newTarget */ ) {
            aConstructor$1(Target);
            anObject$3(args);
            var newTarget = arguments.length < 3 ? Target : aConstructor$1(arguments[2]);
            if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
            if (Target === newTarget) {
                // w/o altered newTarget, optimization for 0-4 arguments
                switch(args.length){
                    case 0:
                        return new Target();
                    case 1:
                        return new Target(args[0]);
                    case 2:
                        return new Target(args[0], args[1]);
                    case 3:
                        return new Target(args[0], args[1], args[2]);
                    case 4:
                        return new Target(args[0], args[1], args[2], args[3]);
                }
                // w/o altered newTarget, lot of arguments case
                var $args = [
                    null
                ];
                apply$1(push$2, $args, args);
                return new (apply$1(bind$8, Target, $args))();
            }
            // with altered newTarget, not support built-in constructors
            var proto = newTarget.prototype;
            var instance = create$5(isObject$6(proto) ? proto : ObjectPrototype);
            var result = apply$1(Target, instance, args);
            return isObject$6(result) ? result : instance;
        }
    });
    var path$8 = path$o;
    var construct$2 = path$8.Reflect.construct;
    var parent$u = construct$2;
    var construct$1 = parent$u;
    var construct = construct$1;
    var _Reflect$construct = /*@__PURE__*/ getDefaultExportFromCjs(construct);
    var path$7 = path$o;
    var getOwnPropertySymbols$2 = path$7.Object.getOwnPropertySymbols;
    var parent$t = getOwnPropertySymbols$2;
    var getOwnPropertySymbols$1 = parent$t;
    var getOwnPropertySymbols = getOwnPropertySymbols$1;
    var _Object$getOwnPropertySymbols = /*@__PURE__*/ getDefaultExportFromCjs(getOwnPropertySymbols);
    var getOwnPropertyDescriptor$4 = {
        exports: {}
    };
    var $$j = _export;
    var fails$8 = fails$u;
    var toIndexedObject$1 = toIndexedObject$a;
    var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var DESCRIPTORS$5 = descriptors;
    var FORCED$1 = !DESCRIPTORS$5 || fails$8(function() {
        nativeGetOwnPropertyDescriptor(1);
    });
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
    $$j({
        target: 'Object',
        stat: true,
        forced: FORCED$1,
        sham: !DESCRIPTORS$5
    }, {
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
            return nativeGetOwnPropertyDescriptor(toIndexedObject$1(it), key);
        }
    });
    var path$6 = path$o;
    var Object$2 = path$6.Object;
    var getOwnPropertyDescriptor$3 = getOwnPropertyDescriptor$4.exports = function getOwnPropertyDescriptor(it, key) {
        return Object$2.getOwnPropertyDescriptor(it, key);
    };
    if (Object$2.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor$3.sham = true;
    var getOwnPropertyDescriptorExports = getOwnPropertyDescriptor$4.exports;
    var parent$s = getOwnPropertyDescriptorExports;
    var getOwnPropertyDescriptor$2 = parent$s;
    var getOwnPropertyDescriptor$1 = getOwnPropertyDescriptor$2;
    var _Object$getOwnPropertyDescriptor = /*@__PURE__*/ getDefaultExportFromCjs(getOwnPropertyDescriptor$1);
    var $$i = _export;
    var DESCRIPTORS$4 = descriptors;
    var ownKeys$2 = ownKeys$7;
    var toIndexedObject = toIndexedObject$a;
    var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
    var createProperty = createProperty$6;
    // `Object.getOwnPropertyDescriptors` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    $$i({
        target: 'Object',
        stat: true,
        sham: !DESCRIPTORS$4
    }, {
        getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
            var O = toIndexedObject(object);
            var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$1.f;
            var keys = ownKeys$2(O);
            var result = {};
            var index = 0;
            var key, descriptor;
            while(keys.length > index){
                descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
                if (descriptor !== undefined) createProperty(result, key, descriptor);
            }
            return result;
        }
    });
    var path$5 = path$o;
    var getOwnPropertyDescriptors$2 = path$5.Object.getOwnPropertyDescriptors;
    var parent$r = getOwnPropertyDescriptors$2;
    var getOwnPropertyDescriptors$1 = parent$r;
    var getOwnPropertyDescriptors = getOwnPropertyDescriptors$1;
    var _Object$getOwnPropertyDescriptors = /*@__PURE__*/ getDefaultExportFromCjs(getOwnPropertyDescriptors);
    var defineProperties$4 = {
        exports: {}
    };
    var $$h = _export;
    var DESCRIPTORS$3 = descriptors;
    var defineProperties$3 = objectDefineProperties.f;
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    // eslint-disable-next-line es/no-object-defineproperties -- safe
    $$h({
        target: 'Object',
        stat: true,
        forced: Object.defineProperties !== defineProperties$3,
        sham: !DESCRIPTORS$3
    }, {
        defineProperties: defineProperties$3
    });
    var path$4 = path$o;
    var Object$1 = path$4.Object;
    var defineProperties$2 = defineProperties$4.exports = function defineProperties(T, D) {
        return Object$1.defineProperties(T, D);
    };
    if (Object$1.defineProperties.sham) defineProperties$2.sham = true;
    var definePropertiesExports = defineProperties$4.exports;
    var parent$q = definePropertiesExports;
    var defineProperties$1 = parent$q;
    var defineProperties = defineProperties$1;
    var _Object$defineProperties = /*@__PURE__*/ getDefaultExportFromCjs(defineProperties);
    var defineProperty$2 = defineProperty$b;
    var _Object$defineProperty = /*@__PURE__*/ getDefaultExportFromCjs(defineProperty$2);
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    var parent$p = create$7;
    var create$4 = parent$p;
    var parent$o = create$4;
    var create$3 = parent$o;
    var create$2 = create$3;
    var _Object$create = /*@__PURE__*/ getDefaultExportFromCjs(create$2);
    var $$g = _export;
    var setPrototypeOf$6 = objectSetPrototypeOf;
    // `Object.setPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.setprototypeof
    $$g({
        target: 'Object',
        stat: true
    }, {
        setPrototypeOf: setPrototypeOf$6
    });
    var path$3 = path$o;
    var setPrototypeOf$5 = path$3.Object.setPrototypeOf;
    var parent$n = setPrototypeOf$5;
    var setPrototypeOf$4 = parent$n;
    var parent$m = setPrototypeOf$4;
    var setPrototypeOf$3 = parent$m;
    var parent$l = setPrototypeOf$3;
    var setPrototypeOf$2 = parent$l;
    var setPrototypeOf$1 = setPrototypeOf$2;
    var _Object$setPrototypeOf = /*@__PURE__*/ getDefaultExportFromCjs(setPrototypeOf$1);
    var parent$k = bind$c;
    var bind$7 = parent$k;
    var parent$j = bind$7;
    var bind$6 = parent$j;
    var bind$5 = bind$6;
    var _bindInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(bind$5);
    function _setPrototypeOf(o, p) {
        var _context;
        _setPrototypeOf = _Object$setPrototypeOf ? _bindInstanceProperty(_context = _Object$setPrototypeOf).call(_context) : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = _Object$create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        _Object$defineProperty$1(subClass, "prototype", {
            writable: false
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (_typeof$1(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(self1);
    }
    var parent$i = getPrototypeOf$4;
    var getPrototypeOf$3 = parent$i;
    var parent$h = getPrototypeOf$3;
    var getPrototypeOf$2 = parent$h;
    var getPrototypeOf$1 = getPrototypeOf$2;
    var _Object$getPrototypeOf = /*@__PURE__*/ getDefaultExportFromCjs(getPrototypeOf$1);
    function _getPrototypeOf(o) {
        var _context;
        _getPrototypeOf = _Object$setPrototypeOf ? _bindInstanceProperty(_context = _Object$getPrototypeOf).call(_context) : function _getPrototypeOf(o) {
            return o.__proto__ || _Object$getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    var regeneratorRuntime$1 = {
        exports: {}
    };
    var _typeof = {
        exports: {}
    };
    (function(module) {
        var _Symbol = symbol$1;
        var _Symbol$iterator = iterator$1;
        function _typeof(o) {
            "@babel/helpers - typeof";
            return module.exports = _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function(o) {
                return typeof o;
            } : function(o) {
                return o && "function" == typeof _Symbol && o.constructor === _Symbol && o !== _Symbol.prototype ? "symbol" : typeof o;
            }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
        }
        module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(_typeof);
    var _typeofExports = _typeof.exports;
    var parent$g = forEach$5;
    var forEach$3 = parent$g;
    var parent$f = forEach$3;
    var forEach$2 = parent$f;
    var forEach$1 = forEach$2;
    var hasOwn$5 = hasOwnProperty_1;
    var ownKeys$1 = ownKeys$7;
    var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
    var definePropertyModule = objectDefineProperty;
    var copyConstructorProperties$1 = function(target, source, exceptions) {
        var keys = ownKeys$1(source);
        var defineProperty = definePropertyModule.f;
        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        }
    };
    var isObject$5 = isObject$h;
    var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;
    // `InstallErrorCause` abstract operation
    // https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
    var installErrorCause$1 = function(O, options) {
        if (isObject$5(options) && 'cause' in options) createNonEnumerableProperty$3(O, 'cause', options.cause);
    };
    var uncurryThis$2 = functionUncurryThis;
    var $Error$1 = Error;
    var replace = uncurryThis$2(''.replace);
    var TEST = function(arg) {
        return String(new $Error$1(arg).stack);
    }('zxcasd');
    // eslint-disable-next-line redos/no-vulnerable -- safe
    var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
    var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
    var errorStackClear = function(stack, dropEntries) {
        if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error$1.prepareStackTrace) while(dropEntries--)stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
        return stack;
    };
    var fails$7 = fails$u;
    var createPropertyDescriptor$1 = createPropertyDescriptor$7;
    var errorStackInstallable = !fails$7(function() {
        var error = new Error('a');
        if (!('stack' in error)) return true;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(error, 'stack', createPropertyDescriptor$1(1, 7));
        return error.stack !== 7;
    });
    var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;
    var clearErrorStack = errorStackClear;
    var ERROR_STACK_INSTALLABLE = errorStackInstallable;
    // non-standard V8
    var captureStackTrace = Error.captureStackTrace;
    var errorStackInstall = function(error, C, stack, dropEntries) {
        if (ERROR_STACK_INSTALLABLE) {
            if (captureStackTrace) captureStackTrace(error, C);
            else createNonEnumerableProperty$2(error, 'stack', clearErrorStack(stack, dropEntries));
        }
    };
    var bind$4 = functionBindContext;
    var call$6 = functionCall;
    var anObject$2 = anObject$d;
    var tryToString = tryToString$6;
    var isArrayIteratorMethod = isArrayIteratorMethod$2;
    var lengthOfArrayLike$1 = lengthOfArrayLike$d;
    var isPrototypeOf$7 = objectIsPrototypeOf;
    var getIterator$6 = getIterator$8;
    var getIteratorMethod = getIteratorMethod$9;
    var iteratorClose = iteratorClose$2;
    var $TypeError$2 = TypeError;
    var Result = function(stopped, result) {
        this.stopped = stopped;
        this.result = result;
    };
    var ResultPrototype = Result.prototype;
    var iterate$7 = function(iterable, unboundFunction, options) {
        var that = options && options.that;
        var AS_ENTRIES = !!(options && options.AS_ENTRIES);
        var IS_RECORD = !!(options && options.IS_RECORD);
        var IS_ITERATOR = !!(options && options.IS_ITERATOR);
        var INTERRUPTED = !!(options && options.INTERRUPTED);
        var fn = bind$4(unboundFunction, that);
        var iterator, iterFn, index, length, result, next, step;
        var stop = function(condition) {
            if (iterator) iteratorClose(iterator, 'normal', condition);
            return new Result(true, condition);
        };
        var callFn = function(value) {
            if (AS_ENTRIES) {
                anObject$2(value);
                return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
            }
            return INTERRUPTED ? fn(value, stop) : fn(value);
        };
        if (IS_RECORD) iterator = iterable.iterator;
        else if (IS_ITERATOR) iterator = iterable;
        else {
            iterFn = getIteratorMethod(iterable);
            if (!iterFn) throw new $TypeError$2(tryToString(iterable) + ' is not iterable');
            // optimisation for array iterators
            if (isArrayIteratorMethod(iterFn)) {
                for(index = 0, length = lengthOfArrayLike$1(iterable); length > index; index++){
                    result = callFn(iterable[index]);
                    if (result && isPrototypeOf$7(ResultPrototype, result)) return result;
                }
                return new Result(false);
            }
            iterator = getIterator$6(iterable, iterFn);
        }
        next = IS_RECORD ? iterable.next : iterator.next;
        while(!(step = call$6(next, iterator)).done){
            try {
                result = callFn(step.value);
            } catch (error) {
                iteratorClose(iterator, 'throw', error);
            }
            if (typeof result == 'object' && result && isPrototypeOf$7(ResultPrototype, result)) return result;
        }
        return new Result(false);
    };
    var toString$1 = toString$7;
    var normalizeStringArgument$1 = function(argument, $default) {
        return argument === undefined ? arguments.length < 2 ? '' : $default : toString$1(argument);
    };
    var $$f = _export;
    var isPrototypeOf$6 = objectIsPrototypeOf;
    var getPrototypeOf = objectGetPrototypeOf;
    var setPrototypeOf = objectSetPrototypeOf;
    var copyConstructorProperties = copyConstructorProperties$1;
    var create$1 = objectCreate;
    var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
    var createPropertyDescriptor = createPropertyDescriptor$7;
    var installErrorCause = installErrorCause$1;
    var installErrorStack = errorStackInstall;
    var iterate$6 = iterate$7;
    var normalizeStringArgument = normalizeStringArgument$1;
    var wellKnownSymbol$3 = wellKnownSymbol$n;
    var TO_STRING_TAG = wellKnownSymbol$3('toStringTag');
    var $Error = Error;
    var push$1 = [].push;
    var $AggregateError = function AggregateError(errors, message /* , options */ ) {
        var isInstance = isPrototypeOf$6(AggregateErrorPrototype, this);
        var that;
        if (setPrototypeOf) that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
        else {
            that = isInstance ? this : create$1(AggregateErrorPrototype);
            createNonEnumerableProperty$1(that, TO_STRING_TAG, 'Error');
        }
        if (message !== undefined) createNonEnumerableProperty$1(that, 'message', normalizeStringArgument(message));
        installErrorStack(that, $AggregateError, that.stack, 1);
        if (arguments.length > 2) installErrorCause(that, arguments[2]);
        var errorsArray = [];
        iterate$6(errors, push$1, {
            that: errorsArray
        });
        createNonEnumerableProperty$1(that, 'errors', errorsArray);
        return that;
    };
    if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
    else copyConstructorProperties($AggregateError, $Error, {
        name: true
    });
    var AggregateErrorPrototype = $AggregateError.prototype = create$1($Error.prototype, {
        constructor: createPropertyDescriptor(1, $AggregateError),
        message: createPropertyDescriptor(1, ''),
        name: createPropertyDescriptor(1, 'AggregateError')
    });
    // `AggregateError` constructor
    // https://tc39.es/ecma262/#sec-aggregate-error-constructor
    $$f({
        global: true,
        constructor: true,
        arity: 2
    }, {
        AggregateError: $AggregateError
    });
    var getBuiltIn$3 = getBuiltIn$f;
    var defineBuiltInAccessor$1 = defineBuiltInAccessor$3;
    var wellKnownSymbol$2 = wellKnownSymbol$n;
    var DESCRIPTORS$2 = descriptors;
    var SPECIES$2 = wellKnownSymbol$2('species');
    var setSpecies$2 = function(CONSTRUCTOR_NAME) {
        var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);
        if (DESCRIPTORS$2 && Constructor && !Constructor[SPECIES$2]) defineBuiltInAccessor$1(Constructor, SPECIES$2, {
            configurable: true,
            get: function() {
                return this;
            }
        });
    };
    var isPrototypeOf$5 = objectIsPrototypeOf;
    var $TypeError$1 = TypeError;
    var anInstance$3 = function(it, Prototype) {
        if (isPrototypeOf$5(Prototype, it)) return it;
        throw new $TypeError$1('Incorrect invocation');
    };
    var anObject$1 = anObject$d;
    var aConstructor = aConstructor$2;
    var isNullOrUndefined$2 = isNullOrUndefined$6;
    var wellKnownSymbol$1 = wellKnownSymbol$n;
    var SPECIES$1 = wellKnownSymbol$1('species');
    // `SpeciesConstructor` abstract operation
    // https://tc39.es/ecma262/#sec-speciesconstructor
    var speciesConstructor$2 = function(O, defaultConstructor) {
        var C = anObject$1(O).constructor;
        var S;
        return C === undefined || isNullOrUndefined$2(S = anObject$1(C)[SPECIES$1]) ? defaultConstructor : aConstructor(S);
    };
    var userAgent$4 = engineUserAgent;
    // eslint-disable-next-line redos/no-vulnerable -- safe
    var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);
    var global$6 = global$p;
    var apply = functionApply;
    var bind$3 = functionBindContext;
    var isCallable$4 = isCallable$m;
    var hasOwn$4 = hasOwnProperty_1;
    var fails$6 = fails$u;
    var html = html$2;
    var arraySlice$1 = arraySlice$5;
    var createElement = documentCreateElement$1;
    var validateArgumentsLength = validateArgumentsLength$2;
    var IS_IOS$1 = engineIsIos;
    var IS_NODE$3 = engineIsNode;
    var set$3 = global$6.setImmediate;
    var clear = global$6.clearImmediate;
    var process$2 = global$6.process;
    var Dispatch = global$6.Dispatch;
    var Function$1 = global$6.Function;
    var MessageChannel = global$6.MessageChannel;
    var String$1 = global$6.String;
    var counter = 0;
    var queue$2 = {};
    var ONREADYSTATECHANGE = 'onreadystatechange';
    var $location, defer, channel, port;
    fails$6(function() {
        // Deno throws a ReferenceError on `location` access without `--location` flag
        $location = global$6.location;
    });
    var run = function(id) {
        if (hasOwn$4(queue$2, id)) {
            var fn = queue$2[id];
            delete queue$2[id];
            fn();
        }
    };
    var runner = function(id) {
        return function() {
            run(id);
        };
    };
    var eventListener = function(event) {
        run(event.data);
    };
    var globalPostMessageDefer = function(id) {
        // old engines have not location.origin
        global$6.postMessage(String$1(id), $location.protocol + '//' + $location.host);
    };
    // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
    if (!set$3 || !clear) {
        set$3 = function setImmediate(handler) {
            validateArgumentsLength(arguments.length, 1);
            var fn = isCallable$4(handler) ? handler : Function$1(handler);
            var args = arraySlice$1(arguments, 1);
            queue$2[++counter] = function() {
                apply(fn, undefined, args);
            };
            defer(counter);
            return counter;
        };
        clear = function clearImmediate(id) {
            delete queue$2[id];
        };
        // Node.js 0.8-
        if (IS_NODE$3) defer = function(id) {
            process$2.nextTick(runner(id));
        };
        else if (Dispatch && Dispatch.now) defer = function(id) {
            Dispatch.now(runner(id));
        };
        else if (MessageChannel && !IS_IOS$1) {
            channel = new MessageChannel();
            port = channel.port2;
            channel.port1.onmessage = eventListener;
            defer = bind$3(port.postMessage, port);
        // Browsers with postMessage, skip WebWorkers
        // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
        } else if (global$6.addEventListener && isCallable$4(global$6.postMessage) && !global$6.importScripts && $location && $location.protocol !== 'file:' && !fails$6(globalPostMessageDefer)) {
            defer = globalPostMessageDefer;
            global$6.addEventListener('message', eventListener, false);
        // IE8-
        } else if (ONREADYSTATECHANGE in createElement('script')) defer = function(id) {
            html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function() {
                html.removeChild(this);
                run(id);
            };
        };
        else defer = function(id) {
            setTimeout(runner(id), 0);
        };
    }
    var task$1 = {
        set: set$3,
        clear: clear
    };
    var Queue$3 = function() {
        this.head = null;
        this.tail = null;
    };
    Queue$3.prototype = {
        add: function(item) {
            var entry = {
                item: item,
                next: null
            };
            var tail = this.tail;
            if (tail) tail.next = entry;
            else this.head = entry;
            this.tail = entry;
        },
        get: function() {
            var entry = this.head;
            if (entry) {
                var next = this.head = entry.next;
                if (next === null) this.tail = null;
                return entry.item;
            }
        }
    };
    var queue$1 = Queue$3;
    var userAgent$3 = engineUserAgent;
    var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && typeof Pebble != 'undefined';
    var userAgent$2 = engineUserAgent;
    var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);
    var global$5 = global$p;
    var bind$2 = functionBindContext;
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var macrotask = task$1.set;
    var Queue$2 = queue$1;
    var IS_IOS = engineIsIos;
    var IS_IOS_PEBBLE = engineIsIosPebble;
    var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
    var IS_NODE$2 = engineIsNode;
    var MutationObserver = global$5.MutationObserver || global$5.WebKitMutationObserver;
    var document$2 = global$5.document;
    var process$1 = global$5.process;
    var Promise$1 = global$5.Promise;
    // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
    var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$5, 'queueMicrotask');
    var microtask$1 = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
    var notify$1, toggle, node, promise$5, then;
    // modern engines have queueMicrotask method
    if (!microtask$1) {
        var queue = new Queue$2();
        var flush = function() {
            var parent, fn;
            if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
            while(fn = queue.get())try {
                fn();
            } catch (error) {
                if (queue.head) notify$1();
                throw error;
            }
            if (parent) parent.enter();
        };
        // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
        // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
        if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
            toggle = true;
            node = document$2.createTextNode('');
            new MutationObserver(flush).observe(node, {
                characterData: true
            });
            notify$1 = function() {
                node.data = toggle = !toggle;
            };
        // environments with maybe non-completely correct, but existent Promise
        } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
            // Promise.resolve without an argument throws an error in LG WebOS 2
            promise$5 = Promise$1.resolve(undefined);
            // workaround of WebKit ~ iOS Safari 10.1 bug
            promise$5.constructor = Promise$1;
            then = bind$2(promise$5.then, promise$5);
            notify$1 = function() {
                then(flush);
            };
        // Node.js without promises
        } else if (IS_NODE$2) notify$1 = function() {
            process$1.nextTick(flush);
        };
        else {
            // `webpack` dev server bug on IE global methods - use bind(fn, global)
            macrotask = bind$2(macrotask, global$5);
            notify$1 = function() {
                macrotask(flush);
            };
        }
        microtask$1 = function(fn) {
            if (!queue.head) notify$1();
            queue.add(fn);
        };
    }
    var microtask_1 = microtask$1;
    var hostReportErrors$1 = function(a, b) {
        try {
            // eslint-disable-next-line no-console -- safe
            arguments.length === 1 ? console.error(a) : console.error(a, b);
        } catch (error) {}
    };
    var perform$6 = function(exec) {
        try {
            return {
                error: false,
                value: exec()
            };
        } catch (error) {
            return {
                error: true,
                value: error
            };
        }
    };
    var global$4 = global$p;
    var promiseNativeConstructor = global$4.Promise;
    /* global Deno -- Deno case */ var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';
    var IS_DENO$1 = engineIsDeno;
    var IS_NODE$1 = engineIsNode;
    var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1 && typeof window == 'object' && typeof document == 'object';
    var global$3 = global$p;
    var NativePromiseConstructor$5 = promiseNativeConstructor;
    var isCallable$3 = isCallable$m;
    var isForced = isForced_1;
    var inspectSource = inspectSource$2;
    var wellKnownSymbol = wellKnownSymbol$n;
    var IS_BROWSER = engineIsBrowser;
    var IS_DENO = engineIsDeno;
    var V8_VERSION = engineV8Version;
    var NativePromisePrototype$2 = NativePromiseConstructor$5 && NativePromiseConstructor$5.prototype;
    var SPECIES = wellKnownSymbol('species');
    var SUBCLASSING = false;
    var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$3(global$3.PromiseRejectionEvent);
    var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function() {
        var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$5);
        var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$5);
        // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
        // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
        // We can't detect it synchronously, so just check versions
        if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
        // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
        if (!(NativePromisePrototype$2['catch'] && NativePromisePrototype$2['finally'])) return true;
        // We can't use @@species feature detection in V8 since it causes
        // deoptimization and performance degradation
        // https://github.com/zloirock/core-js/issues/679
        if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
            // Detect correctness of subclassing with @@species support
            var promise = new NativePromiseConstructor$5(function(resolve) {
                resolve(1);
            });
            var FakePromise = function(exec) {
                exec(function() {}, function() {});
            };
            var constructor = promise.constructor = {};
            constructor[SPECIES] = FakePromise;
            SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
            if (!SUBCLASSING) return true;
        // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        }
        return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
    });
    var promiseConstructorDetection = {
        CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
        REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
        SUBCLASSING: SUBCLASSING
    };
    var newPromiseCapability$2 = {};
    var aCallable$6 = aCallable$e;
    var $TypeError = TypeError;
    var PromiseCapability = function(C) {
        var resolve, reject;
        this.promise = new C(function($$resolve, $$reject) {
            if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
            resolve = $$resolve;
            reject = $$reject;
        });
        this.resolve = aCallable$6(resolve);
        this.reject = aCallable$6(reject);
    };
    // `NewPromiseCapability` abstract operation
    // https://tc39.es/ecma262/#sec-newpromisecapability
    newPromiseCapability$2.f = function(C) {
        return new PromiseCapability(C);
    };
    var $$e = _export;
    var IS_NODE = engineIsNode;
    var global$2 = global$p;
    var call$5 = functionCall;
    var defineBuiltIn$1 = defineBuiltIn$6;
    var setToStringTag$1 = setToStringTag$7;
    var setSpecies$1 = setSpecies$2;
    var aCallable$5 = aCallable$e;
    var isCallable$2 = isCallable$m;
    var isObject$4 = isObject$h;
    var anInstance$2 = anInstance$3;
    var speciesConstructor$1 = speciesConstructor$2;
    var task = task$1.set;
    var microtask = microtask_1;
    var hostReportErrors = hostReportErrors$1;
    var perform$5 = perform$6;
    var Queue$1 = queue$1;
    var InternalStateModule$2 = internalState;
    var NativePromiseConstructor$4 = promiseNativeConstructor;
    var PromiseConstructorDetection = promiseConstructorDetection;
    var newPromiseCapabilityModule$7 = newPromiseCapability$2;
    var PROMISE = 'Promise';
    var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
    var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
    PromiseConstructorDetection.SUBCLASSING;
    var getInternalPromiseState = InternalStateModule$2.getterFor(PROMISE);
    var setInternalState$2 = InternalStateModule$2.set;
    var NativePromisePrototype$1 = NativePromiseConstructor$4 && NativePromiseConstructor$4.prototype;
    var PromiseConstructor = NativePromiseConstructor$4;
    var PromisePrototype = NativePromisePrototype$1;
    var TypeError$1 = global$2.TypeError;
    var document$1 = global$2.document;
    var process = global$2.process;
    var newPromiseCapability$1 = newPromiseCapabilityModule$7.f;
    var newGenericPromiseCapability = newPromiseCapability$1;
    var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
    var UNHANDLED_REJECTION = 'unhandledrejection';
    var REJECTION_HANDLED = 'rejectionhandled';
    var PENDING = 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    var HANDLED = 1;
    var UNHANDLED = 2;
    var Internal, OwnPromiseCapability, PromiseWrapper;
    // helpers
    var isThenable = function(it) {
        var then;
        return isObject$4(it) && isCallable$2(then = it.then) ? then : false;
    };
    var callReaction = function(reaction, state) {
        var value = state.value;
        var ok = state.state === FULFILLED;
        var handler = ok ? reaction.ok : reaction.fail;
        var resolve = reaction.resolve;
        var reject = reaction.reject;
        var domain = reaction.domain;
        var result, then, exited;
        try {
            if (handler) {
                if (!ok) {
                    if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                    state.rejection = HANDLED;
                }
                if (handler === true) result = value;
                else {
                    if (domain) domain.enter();
                    result = handler(value); // can throw
                    if (domain) {
                        domain.exit();
                        exited = true;
                    }
                }
                if (result === reaction.promise) reject(new TypeError$1('Promise-chain cycle'));
                else if (then = isThenable(result)) call$5(then, result, resolve, reject);
                else resolve(result);
            } else reject(value);
        } catch (error) {
            if (domain && !exited) domain.exit();
            reject(error);
        }
    };
    var notify = function(state, isReject) {
        if (state.notified) return;
        state.notified = true;
        microtask(function() {
            var reactions = state.reactions;
            var reaction;
            while(reaction = reactions.get())callReaction(reaction, state);
            state.notified = false;
            if (isReject && !state.rejection) onUnhandled(state);
        });
    };
    var dispatchEvent = function(name, promise, reason) {
        var event, handler;
        if (DISPATCH_EVENT) {
            event = document$1.createEvent('Event');
            event.promise = promise;
            event.reason = reason;
            event.initEvent(name, false, true);
            global$2.dispatchEvent(event);
        } else event = {
            promise: promise,
            reason: reason
        };
        if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$2['on' + name])) handler(event);
        else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
    };
    var onUnhandled = function(state) {
        call$5(task, global$2, function() {
            var promise = state.facade;
            var value = state.value;
            var IS_UNHANDLED = isUnhandled(state);
            var result;
            if (IS_UNHANDLED) {
                result = perform$5(function() {
                    if (IS_NODE) process.emit('unhandledRejection', value, promise);
                    else dispatchEvent(UNHANDLED_REJECTION, promise, value);
                });
                // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
                state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
                if (result.error) throw result.value;
            }
        });
    };
    var isUnhandled = function(state) {
        return state.rejection !== HANDLED && !state.parent;
    };
    var onHandleUnhandled = function(state) {
        call$5(task, global$2, function() {
            var promise = state.facade;
            if (IS_NODE) process.emit('rejectionHandled', promise);
            else dispatchEvent(REJECTION_HANDLED, promise, state.value);
        });
    };
    var bind$1 = function(fn, state, unwrap) {
        return function(value) {
            fn(state, value, unwrap);
        };
    };
    var internalReject = function(state, value, unwrap) {
        if (state.done) return;
        state.done = true;
        if (unwrap) state = unwrap;
        state.value = value;
        state.state = REJECTED;
        notify(state, true);
    };
    var internalResolve = function(state, value, unwrap) {
        if (state.done) return;
        state.done = true;
        if (unwrap) state = unwrap;
        try {
            if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
            var then = isThenable(value);
            if (then) microtask(function() {
                var wrapper = {
                    done: false
                };
                try {
                    call$5(then, value, bind$1(internalResolve, wrapper, state), bind$1(internalReject, wrapper, state));
                } catch (error) {
                    internalReject(wrapper, error, state);
                }
            });
            else {
                state.value = value;
                state.state = FULFILLED;
                notify(state, false);
            }
        } catch (error) {
            internalReject({
                done: false
            }, error, state);
        }
    };
    // constructor polyfill
    if (FORCED_PROMISE_CONSTRUCTOR$4) {
        // 25.4.3.1 Promise(executor)
        PromiseConstructor = function Promise(executor) {
            anInstance$2(this, PromisePrototype);
            aCallable$5(executor);
            call$5(Internal, this);
            var state = getInternalPromiseState(this);
            try {
                executor(bind$1(internalResolve, state), bind$1(internalReject, state));
            } catch (error) {
                internalReject(state, error);
            }
        };
        PromisePrototype = PromiseConstructor.prototype;
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        Internal = function Promise(executor) {
            setInternalState$2(this, {
                type: PROMISE,
                done: false,
                notified: false,
                parent: false,
                reactions: new Queue$1(),
                rejection: false,
                state: PENDING,
                value: undefined
            });
        };
        // `Promise.prototype.then` method
        // https://tc39.es/ecma262/#sec-promise.prototype.then
        Internal.prototype = defineBuiltIn$1(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
            var state = getInternalPromiseState(this);
            var reaction = newPromiseCapability$1(speciesConstructor$1(this, PromiseConstructor));
            state.parent = true;
            reaction.ok = isCallable$2(onFulfilled) ? onFulfilled : true;
            reaction.fail = isCallable$2(onRejected) && onRejected;
            reaction.domain = IS_NODE ? process.domain : undefined;
            if (state.state === PENDING) state.reactions.add(reaction);
            else microtask(function() {
                callReaction(reaction, state);
            });
            return reaction.promise;
        });
        OwnPromiseCapability = function() {
            var promise = new Internal();
            var state = getInternalPromiseState(promise);
            this.promise = promise;
            this.resolve = bind$1(internalResolve, state);
            this.reject = bind$1(internalReject, state);
        };
        newPromiseCapabilityModule$7.f = newPromiseCapability$1 = function(C) {
            return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
        };
    }
    $$e({
        global: true,
        constructor: true,
        wrap: true,
        forced: FORCED_PROMISE_CONSTRUCTOR$4
    }, {
        Promise: PromiseConstructor
    });
    setToStringTag$1(PromiseConstructor, PROMISE, false, true);
    setSpecies$1(PROMISE);
    var NativePromiseConstructor$3 = promiseNativeConstructor;
    var checkCorrectnessOfIteration = checkCorrectnessOfIteration$2;
    var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;
    var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function(iterable) {
        NativePromiseConstructor$3.all(iterable).then(undefined, function() {});
    });
    var $$d = _export;
    var call$4 = functionCall;
    var aCallable$4 = aCallable$e;
    var newPromiseCapabilityModule$6 = newPromiseCapability$2;
    var perform$4 = perform$6;
    var iterate$5 = iterate$7;
    var PROMISE_STATICS_INCORRECT_ITERATION$3 = promiseStaticsIncorrectIteration;
    // `Promise.all` method
    // https://tc39.es/ecma262/#sec-promise.all
    $$d({
        target: 'Promise',
        stat: true,
        forced: PROMISE_STATICS_INCORRECT_ITERATION$3
    }, {
        all: function all(iterable) {
            var C = this;
            var capability = newPromiseCapabilityModule$6.f(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = perform$4(function() {
                var $promiseResolve = aCallable$4(C.resolve);
                var values = [];
                var counter = 0;
                var remaining = 1;
                iterate$5(iterable, function(promise) {
                    var index = counter++;
                    var alreadyCalled = false;
                    remaining++;
                    call$4($promiseResolve, C, promise).then(function(value) {
                        if (alreadyCalled) return;
                        alreadyCalled = true;
                        values[index] = value;
                        --remaining || resolve(values);
                    }, reject);
                });
                --remaining || resolve(values);
            });
            if (result.error) reject(result.value);
            return capability.promise;
        }
    });
    var $$c = _export;
    var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
    var NativePromiseConstructor$2 = promiseNativeConstructor;
    NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    $$c({
        target: 'Promise',
        proto: true,
        forced: FORCED_PROMISE_CONSTRUCTOR$2,
        real: true
    }, {
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    var $$b = _export;
    var call$3 = functionCall;
    var aCallable$3 = aCallable$e;
    var newPromiseCapabilityModule$5 = newPromiseCapability$2;
    var perform$3 = perform$6;
    var iterate$4 = iterate$7;
    var PROMISE_STATICS_INCORRECT_ITERATION$2 = promiseStaticsIncorrectIteration;
    // `Promise.race` method
    // https://tc39.es/ecma262/#sec-promise.race
    $$b({
        target: 'Promise',
        stat: true,
        forced: PROMISE_STATICS_INCORRECT_ITERATION$2
    }, {
        race: function race(iterable) {
            var C = this;
            var capability = newPromiseCapabilityModule$5.f(C);
            var reject = capability.reject;
            var result = perform$3(function() {
                var $promiseResolve = aCallable$3(C.resolve);
                iterate$4(iterable, function(promise) {
                    call$3($promiseResolve, C, promise).then(capability.resolve, reject);
                });
            });
            if (result.error) reject(result.value);
            return capability.promise;
        }
    });
    var $$a = _export;
    var call$2 = functionCall;
    var newPromiseCapabilityModule$4 = newPromiseCapability$2;
    var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;
    // `Promise.reject` method
    // https://tc39.es/ecma262/#sec-promise.reject
    $$a({
        target: 'Promise',
        stat: true,
        forced: FORCED_PROMISE_CONSTRUCTOR$1
    }, {
        reject: function reject(r) {
            var capability = newPromiseCapabilityModule$4.f(this);
            call$2(capability.reject, undefined, r);
            return capability.promise;
        }
    });
    var anObject = anObject$d;
    var isObject$3 = isObject$h;
    var newPromiseCapability = newPromiseCapability$2;
    var promiseResolve$2 = function(C, x) {
        anObject(C);
        if (isObject$3(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
    };
    var $$9 = _export;
    var getBuiltIn$2 = getBuiltIn$f;
    var IS_PURE = isPure;
    var NativePromiseConstructor$1 = promiseNativeConstructor;
    var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
    var promiseResolve$1 = promiseResolve$2;
    var PromiseConstructorWrapper = getBuiltIn$2('Promise');
    var CHECK_WRAPPER = !FORCED_PROMISE_CONSTRUCTOR;
    // `Promise.resolve` method
    // https://tc39.es/ecma262/#sec-promise.resolve
    $$9({
        target: 'Promise',
        stat: true,
        forced: IS_PURE
    }, {
        resolve: function resolve(x) {
            return promiseResolve$1(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor$1 : this, x);
        }
    });
    var $$8 = _export;
    var call$1 = functionCall;
    var aCallable$2 = aCallable$e;
    var newPromiseCapabilityModule$3 = newPromiseCapability$2;
    var perform$2 = perform$6;
    var iterate$3 = iterate$7;
    var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;
    // `Promise.allSettled` method
    // https://tc39.es/ecma262/#sec-promise.allsettled
    $$8({
        target: 'Promise',
        stat: true,
        forced: PROMISE_STATICS_INCORRECT_ITERATION$1
    }, {
        allSettled: function allSettled(iterable) {
            var C = this;
            var capability = newPromiseCapabilityModule$3.f(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = perform$2(function() {
                var promiseResolve = aCallable$2(C.resolve);
                var values = [];
                var counter = 0;
                var remaining = 1;
                iterate$3(iterable, function(promise) {
                    var index = counter++;
                    var alreadyCalled = false;
                    remaining++;
                    call$1(promiseResolve, C, promise).then(function(value) {
                        if (alreadyCalled) return;
                        alreadyCalled = true;
                        values[index] = {
                            status: 'fulfilled',
                            value: value
                        };
                        --remaining || resolve(values);
                    }, function(error) {
                        if (alreadyCalled) return;
                        alreadyCalled = true;
                        values[index] = {
                            status: 'rejected',
                            reason: error
                        };
                        --remaining || resolve(values);
                    });
                });
                --remaining || resolve(values);
            });
            if (result.error) reject(result.value);
            return capability.promise;
        }
    });
    var $$7 = _export;
    var call = functionCall;
    var aCallable$1 = aCallable$e;
    var getBuiltIn$1 = getBuiltIn$f;
    var newPromiseCapabilityModule$2 = newPromiseCapability$2;
    var perform$1 = perform$6;
    var iterate$2 = iterate$7;
    var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;
    var PROMISE_ANY_ERROR = 'No one promise resolved';
    // `Promise.any` method
    // https://tc39.es/ecma262/#sec-promise.any
    $$7({
        target: 'Promise',
        stat: true,
        forced: PROMISE_STATICS_INCORRECT_ITERATION
    }, {
        any: function any(iterable) {
            var C = this;
            var AggregateError = getBuiltIn$1('AggregateError');
            var capability = newPromiseCapabilityModule$2.f(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = perform$1(function() {
                var promiseResolve = aCallable$1(C.resolve);
                var errors = [];
                var counter = 0;
                var remaining = 1;
                var alreadyResolved = false;
                iterate$2(iterable, function(promise) {
                    var index = counter++;
                    var alreadyRejected = false;
                    remaining++;
                    call(promiseResolve, C, promise).then(function(value) {
                        if (alreadyRejected || alreadyResolved) return;
                        alreadyResolved = true;
                        resolve(value);
                    }, function(error) {
                        if (alreadyRejected || alreadyResolved) return;
                        alreadyRejected = true;
                        errors[index] = error;
                        --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
                    });
                });
                --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
            });
            if (result.error) reject(result.value);
            return capability.promise;
        }
    });
    var $$6 = _export;
    var NativePromiseConstructor = promiseNativeConstructor;
    var fails$5 = fails$u;
    var getBuiltIn = getBuiltIn$f;
    var isCallable$1 = isCallable$m;
    var speciesConstructor = speciesConstructor$2;
    var promiseResolve = promiseResolve$2;
    var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
    // Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
    var NON_GENERIC = !!NativePromiseConstructor && fails$5(function() {
        // eslint-disable-next-line unicorn/no-thenable -- required for testing
        NativePromisePrototype['finally'].call({
            then: function() {}
        }, function() {});
    });
    // `Promise.prototype.finally` method
    // https://tc39.es/ecma262/#sec-promise.prototype.finally
    $$6({
        target: 'Promise',
        proto: true,
        real: true,
        forced: NON_GENERIC
    }, {
        'finally': function(onFinally) {
            var C = speciesConstructor(this, getBuiltIn('Promise'));
            var isFunction = isCallable$1(onFinally);
            return this.then(isFunction ? function(x) {
                return promiseResolve(C, onFinally()).then(function() {
                    return x;
                });
            } : onFinally, isFunction ? function(e) {
                return promiseResolve(C, onFinally()).then(function() {
                    throw e;
                });
            } : onFinally);
        }
    });
    var path$2 = path$o;
    var promise$4 = path$2.Promise;
    var parent$e = promise$4;
    var promise$3 = parent$e;
    var $$5 = _export;
    var newPromiseCapabilityModule$1 = newPromiseCapability$2;
    // `Promise.withResolvers` method
    // https://github.com/tc39/proposal-promise-with-resolvers
    $$5({
        target: 'Promise',
        stat: true
    }, {
        withResolvers: function withResolvers() {
            var promiseCapability = newPromiseCapabilityModule$1.f(this);
            return {
                promise: promiseCapability.promise,
                resolve: promiseCapability.resolve,
                reject: promiseCapability.reject
            };
        }
    });
    var parent$d = promise$3;
    var promise$2 = parent$d;
    // TODO: Remove from `core-js@4`
    var $$4 = _export;
    var newPromiseCapabilityModule = newPromiseCapability$2;
    var perform = perform$6;
    // `Promise.try` method
    // https://github.com/tc39/proposal-promise-try
    $$4({
        target: 'Promise',
        stat: true,
        forced: true
    }, {
        'try': function(callbackfn) {
            var promiseCapability = newPromiseCapabilityModule.f(this);
            var result = perform(callbackfn);
            (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
            return promiseCapability.promise;
        }
    });
    var parent$c = promise$2;
    // TODO: Remove from `core-js@4`
    var promise$1 = parent$c;
    var promise = promise$1;
    var parent$b = reverse$4;
    var reverse$2 = parent$b;
    var parent$a = reverse$2;
    var reverse$1 = parent$a;
    var reverse = reverse$1;
    (function(module) {
        var _typeof = _typeofExports["default"];
        var _Object$defineProperty = defineProperty$8;
        var _Symbol = symbol$1;
        var _Object$create = create$2;
        var _Object$getPrototypeOf = getPrototypeOf$1;
        var _forEachInstanceProperty = forEach$1;
        var _pushInstanceProperty = push$3;
        var _Object$setPrototypeOf = setPrototypeOf$1;
        var _Promise = promise;
        var _reverseInstanceProperty = reverse;
        var _sliceInstanceProperty = slice$1;
        function _regeneratorRuntime() {
            module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
                return e;
            }, module.exports.__esModule = true, module.exports["default"] = module.exports;
            var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = _Object$defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof _Symbol ? _Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
            function define(t, e, r) {
                return _Object$defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                define({}, "");
            } catch (t) {
                define = function define(t, e, r) {
                    return t[e] = r;
                };
            }
            function wrap(t, e, r, n) {
                var i = e && e.prototype instanceof Generator ? e : Generator, a = _Object$create(i.prototype), c = new Context(n || []);
                return o(a, "_invoke", {
                    value: makeInvokeMethod(t, r, c)
                }), a;
            }
            function tryCatch(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            e.wrap = wrap;
            var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
            function Generator() {}
            function GeneratorFunction() {}
            function GeneratorFunctionPrototype() {}
            var p = {};
            define(p, a, function() {
                return this;
            });
            var d = _Object$getPrototypeOf, v = d && d(d(values([])));
            v && v !== r && n.call(v, a) && (p = v);
            var g = GeneratorFunctionPrototype.prototype = Generator.prototype = _Object$create(p);
            function defineIteratorMethods(t) {
                var _context;
                _forEachInstanceProperty(_context = [
                    "next",
                    "throw",
                    "return"
                ]).call(_context, function(e) {
                    define(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function AsyncIterator(t, e) {
                function invoke(r, o, i, a) {
                    var c = tryCatch(t[r], t, o);
                    if ("throw" !== c.type) {
                        var u = c.arg, h = u.value;
                        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                            invoke("next", t, i, a);
                        }, function(t) {
                            invoke("throw", t, i, a);
                        }) : e.resolve(h).then(function(t) {
                            u.value = t, i(u);
                        }, function(t) {
                            return invoke("throw", t, i, a);
                        });
                    }
                    a(c.arg);
                }
                var r;
                o(this, "_invoke", {
                    value: function value(t, n) {
                        function callInvokeWithMethodAndArg() {
                            return new e(function(e, r) {
                                invoke(t, n, e, r);
                            });
                        }
                        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                    }
                });
            }
            function makeInvokeMethod(e, r, n) {
                var o = h;
                return function(i, a) {
                    if (o === f) throw new Error("Generator is already running");
                    if (o === s) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var u = maybeInvokeDelegate(c, n);
                            if (u) {
                                if (u === y) continue;
                                return u;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (o === h) throw o = s, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        o = f;
                        var p = tryCatch(e, r, n);
                        if ("normal" === p.type) {
                            if (o = n.done ? s : l, p.arg === y) continue;
                            return {
                                value: p.arg,
                                done: n.done
                            };
                        }
                        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
                    }
                };
            }
            function maybeInvokeDelegate(e, r) {
                var n = r.method, o = e.iterator[n];
                if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = tryCatch(o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function pushTryEntry(t) {
                var _context2;
                var e = {
                    tryLoc: t[0]
                };
                1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), _pushInstanceProperty(_context2 = this.tryEntries).call(_context2, e);
            }
            function resetTryEntry(t) {
                var e = t.completion || {};
                e.type = "normal", delete e.arg, t.completion = e;
            }
            function Context(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], _forEachInstanceProperty(t).call(t, pushTryEntry, this), this.reset(!0);
            }
            function values(e) {
                if (e || "" === e) {
                    var r = e[a];
                    if (r) return r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var o = -1, i = function next() {
                            for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                            return next.value = t, next.done = !0, next;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(_typeof(e) + " is not iterable");
            }
            return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
                value: GeneratorFunctionPrototype,
                configurable: !0
            }), o(GeneratorFunctionPrototype, "constructor", {
                value: GeneratorFunction,
                configurable: !0
            }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
                var e = "function" == typeof t && t.constructor;
                return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
            }, e.mark = function(t) {
                return _Object$setPrototypeOf ? _Object$setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = _Object$create(g), t;
            }, e.awrap = function(t) {
                return {
                    __await: t
                };
            }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
                return this;
            }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
                void 0 === i && (i = _Promise);
                var a = new AsyncIterator(wrap(t, r, n, o), i);
                return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
                return this;
            }), define(g, "toString", function() {
                return "[object Generator]";
            }), e.keys = function(t) {
                var e = Object(t), r = [];
                for(var n in e)_pushInstanceProperty(r).call(r, n);
                return _reverseInstanceProperty(r).call(r), function next() {
                    for(; r.length;){
                        var t = r.pop();
                        if (t in e) return next.value = t, next.done = !1, next;
                    }
                    return next.done = !0, next;
                };
            }, e.values = values, Context.prototype = {
                constructor: Context,
                reset: function reset(e) {
                    var _context3;
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, _forEachInstanceProperty(_context3 = this.tryEntries).call(_context3, resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+_sliceInstanceProperty(r).call(r, 1)) && (this[r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var r = this;
                    function handle(n, o) {
                        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
                    }
                    for(var o = this.tryEntries.length - 1; o >= 0; --o){
                        var i = this.tryEntries[o], a = i.completion;
                        if ("root" === i.tryLoc) return handle("end");
                        if (i.tryLoc <= this.prev) {
                            var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                            if (c && u) {
                                if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                            } else if (c) {
                                if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                            } else {
                                if (!u) throw new Error("try statement without catch or finally");
                                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var r = this.tryEntries.length - 1; r >= 0; --r){
                        var o = this.tryEntries[r];
                        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                            var i = o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var e = this.tryEntries.length - 1; e >= 0; --e){
                        var r = this.tryEntries[e];
                        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var e = this.tryEntries.length - 1; e >= 0; --e){
                        var r = this.tryEntries[e];
                        if (r.tryLoc === t) {
                            var n = r.completion;
                            if ("throw" === n.type) {
                                var o = n.arg;
                                resetTryEntry(r);
                            }
                            return o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: values(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, e;
        }
        module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(regeneratorRuntime$1);
    var regeneratorRuntimeExports = regeneratorRuntime$1.exports;
    // TODO(Babel 8): Remove this file.
    var runtime = regeneratorRuntimeExports();
    var regenerator = runtime;
    // Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
    try {
        regeneratorRuntime = runtime;
    } catch (accidentalStrictMode) {
        if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
        else Function("r", "regeneratorRuntime = r")(runtime);
    }
    var _regeneratorRuntime = /*@__PURE__*/ getDefaultExportFromCjs(regenerator);
    var internalMetadata = {
        exports: {}
    };
    // FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
    var fails$4 = fails$u;
    var arrayBufferNonExtensible = fails$4(function() {
        if (typeof ArrayBuffer == 'function') {
            var buffer = new ArrayBuffer(8);
            // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
            if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
                value: 8
            });
        }
    });
    var fails$3 = fails$u;
    var isObject$2 = isObject$h;
    var classof$3 = classofRaw$2;
    var ARRAY_BUFFER_NON_EXTENSIBLE = arrayBufferNonExtensible;
    // eslint-disable-next-line es/no-object-isextensible -- safe
    var $isExtensible = Object.isExtensible;
    var FAILS_ON_PRIMITIVES = fails$3(function() {
        $isExtensible(1);
    });
    // `Object.isExtensible` method
    // https://tc39.es/ecma262/#sec-object.isextensible
    var objectIsExtensible = FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
        if (!isObject$2(it)) return false;
        if (ARRAY_BUFFER_NON_EXTENSIBLE && classof$3(it) === 'ArrayBuffer') return false;
        return $isExtensible ? $isExtensible(it) : true;
    } : $isExtensible;
    var fails$2 = fails$u;
    var freezing = !fails$2(function() {
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
        return Object.isExtensible(Object.preventExtensions({}));
    });
    var $$3 = _export;
    var uncurryThis$1 = functionUncurryThis;
    var hiddenKeys = hiddenKeys$6;
    var isObject$1 = isObject$h;
    var hasOwn$3 = hasOwnProperty_1;
    var defineProperty$1 = objectDefineProperty.f;
    var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
    var getOwnPropertyNamesExternalModule = objectGetOwnPropertyNamesExternal;
    var isExtensible = objectIsExtensible;
    var uid = uid$4;
    var FREEZING = freezing;
    var REQUIRED = false;
    var METADATA = uid('meta');
    var id = 0;
    var setMetadata = function(it) {
        defineProperty$1(it, METADATA, {
            value: {
                objectID: 'O' + id++,
                weakData: {} // weak collections IDs
            }
        });
    };
    var fastKey$1 = function(it, create) {
        // return a primitive with prefix
        if (!isObject$1(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
        if (!hasOwn$3(it, METADATA)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return 'F';
            // not necessary to add metadata
            if (!create) return 'E';
            // add missing metadata
            setMetadata(it);
        // return object ID
        }
        return it[METADATA].objectID;
    };
    var getWeakData = function(it, create) {
        if (!hasOwn$3(it, METADATA)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return true;
            // not necessary to add metadata
            if (!create) return false;
            // add missing metadata
            setMetadata(it);
        // return the store of weak collections IDs
        }
        return it[METADATA].weakData;
    };
    // add metadata on freeze-family methods calling
    var onFreeze = function(it) {
        if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn$3(it, METADATA)) setMetadata(it);
        return it;
    };
    var enable = function() {
        meta.enable = function() {};
        REQUIRED = true;
        var getOwnPropertyNames = getOwnPropertyNamesModule.f;
        var splice = uncurryThis$1([].splice);
        var test = {};
        test[METADATA] = 1;
        // prevent exposing of metadata key
        if (getOwnPropertyNames(test).length) {
            getOwnPropertyNamesModule.f = function(it) {
                var result = getOwnPropertyNames(it);
                for(var i = 0, length = result.length; i < length; i++)if (result[i] === METADATA) {
                    splice(result, i, 1);
                    break;
                }
                return result;
            };
            $$3({
                target: 'Object',
                stat: true,
                forced: true
            }, {
                getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
            });
        }
    };
    var meta = internalMetadata.exports = {
        enable: enable,
        fastKey: fastKey$1,
        getWeakData: getWeakData,
        onFreeze: onFreeze
    };
    hiddenKeys[METADATA] = true;
    var internalMetadataExports = internalMetadata.exports;
    var $$2 = _export;
    var global$1 = global$p;
    var InternalMetadataModule = internalMetadataExports;
    var fails$1 = fails$u;
    var createNonEnumerableProperty = createNonEnumerableProperty$9;
    var iterate$1 = iterate$7;
    var anInstance$1 = anInstance$3;
    var isCallable = isCallable$m;
    var isObject = isObject$h;
    var isNullOrUndefined$1 = isNullOrUndefined$6;
    var setToStringTag = setToStringTag$7;
    var defineProperty = objectDefineProperty.f;
    var forEach = arrayIteration.forEach;
    var DESCRIPTORS$1 = descriptors;
    var InternalStateModule$1 = internalState;
    var setInternalState$1 = InternalStateModule$1.set;
    var internalStateGetterFor$1 = InternalStateModule$1.getterFor;
    var collection$2 = function(CONSTRUCTOR_NAME, wrapper, common) {
        var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
        var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
        var ADDER = IS_MAP ? 'set' : 'add';
        var NativeConstructor = global$1[CONSTRUCTOR_NAME];
        var NativePrototype = NativeConstructor && NativeConstructor.prototype;
        var exported = {};
        var Constructor;
        if (!DESCRIPTORS$1 || !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails$1(function() {
            new NativeConstructor().entries().next();
        }))) {
            // create collection constructor
            Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
            InternalMetadataModule.enable();
        } else {
            Constructor = wrapper(function(target, iterable) {
                setInternalState$1(anInstance$1(target, Prototype), {
                    type: CONSTRUCTOR_NAME,
                    collection: new NativeConstructor()
                });
                if (!isNullOrUndefined$1(iterable)) iterate$1(iterable, target[ADDER], {
                    that: target,
                    AS_ENTRIES: IS_MAP
                });
            });
            var Prototype = Constructor.prototype;
            var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
            forEach([
                'add',
                'clear',
                'delete',
                'forEach',
                'get',
                'has',
                'set',
                'keys',
                'values',
                'entries'
            ], function(KEY) {
                var IS_ADDER = KEY === 'add' || KEY === 'set';
                if (KEY in NativePrototype && !(IS_WEAK && KEY === 'clear')) createNonEnumerableProperty(Prototype, KEY, function(a, b) {
                    var collection = getInternalState(this).collection;
                    if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY === 'get' ? undefined : false;
                    var result = collection[KEY](a === 0 ? 0 : a, b);
                    return IS_ADDER ? this : result;
                });
            });
            IS_WEAK || defineProperty(Prototype, 'size', {
                configurable: true,
                get: function() {
                    return getInternalState(this).collection.size;
                }
            });
        }
        setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);
        exported[CONSTRUCTOR_NAME] = Constructor;
        $$2({
            global: true,
            forced: true
        }, exported);
        if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
        return Constructor;
    };
    var defineBuiltIn = defineBuiltIn$6;
    var defineBuiltIns$1 = function(target, src, options) {
        for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
        else defineBuiltIn(target, key, src[key], options);
        return target;
    };
    var create = objectCreate;
    var defineBuiltInAccessor = defineBuiltInAccessor$3;
    var defineBuiltIns = defineBuiltIns$1;
    var bind = functionBindContext;
    var anInstance = anInstance$3;
    var isNullOrUndefined = isNullOrUndefined$6;
    var iterate = iterate$7;
    var defineIterator = iteratorDefine;
    var createIterResultObject = createIterResultObject$3;
    var setSpecies = setSpecies$2;
    var DESCRIPTORS = descriptors;
    var fastKey = internalMetadataExports.fastKey;
    var InternalStateModule = internalState;
    var setInternalState = InternalStateModule.set;
    var internalStateGetterFor = InternalStateModule.getterFor;
    var collectionStrong$2 = {
        getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
            var Constructor = wrapper(function(that, iterable) {
                anInstance(that, Prototype);
                setInternalState(that, {
                    type: CONSTRUCTOR_NAME,
                    index: create(null),
                    first: undefined,
                    last: undefined,
                    size: 0
                });
                if (!DESCRIPTORS) that.size = 0;
                if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
            });
            var Prototype = Constructor.prototype;
            var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
            var define = function(that, key, value) {
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                var previous, index;
                // change existing entry
                if (entry) entry.value = value;
                else {
                    state.last = entry = {
                        index: index = fastKey(key, true),
                        key: key,
                        value: value,
                        previous: previous = state.last,
                        next: undefined,
                        removed: false
                    };
                    if (!state.first) state.first = entry;
                    if (previous) previous.next = entry;
                    if (DESCRIPTORS) state.size++;
                    else that.size++;
                    // add to index
                    if (index !== 'F') state.index[index] = entry;
                }
                return that;
            };
            var getEntry = function(that, key) {
                var state = getInternalState(that);
                // fast case
                var index = fastKey(key);
                var entry;
                if (index !== 'F') return state.index[index];
                // frozen object case
                for(entry = state.first; entry; entry = entry.next){
                    if (entry.key === key) return entry;
                }
            };
            defineBuiltIns(Prototype, {
                // `{ Map, Set }.prototype.clear()` methods
                // https://tc39.es/ecma262/#sec-map.prototype.clear
                // https://tc39.es/ecma262/#sec-set.prototype.clear
                clear: function clear() {
                    var that = this;
                    var state = getInternalState(that);
                    var data = state.index;
                    var entry = state.first;
                    while(entry){
                        entry.removed = true;
                        if (entry.previous) entry.previous = entry.previous.next = undefined;
                        delete data[entry.index];
                        entry = entry.next;
                    }
                    state.first = state.last = undefined;
                    if (DESCRIPTORS) state.size = 0;
                    else that.size = 0;
                },
                // `{ Map, Set }.prototype.delete(key)` methods
                // https://tc39.es/ecma262/#sec-map.prototype.delete
                // https://tc39.es/ecma262/#sec-set.prototype.delete
                'delete': function(key) {
                    var that = this;
                    var state = getInternalState(that);
                    var entry = getEntry(that, key);
                    if (entry) {
                        var next = entry.next;
                        var prev = entry.previous;
                        delete state.index[entry.index];
                        entry.removed = true;
                        if (prev) prev.next = next;
                        if (next) next.previous = prev;
                        if (state.first === entry) state.first = next;
                        if (state.last === entry) state.last = prev;
                        if (DESCRIPTORS) state.size--;
                        else that.size--;
                    }
                    return !!entry;
                },
                // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
                // https://tc39.es/ecma262/#sec-map.prototype.foreach
                // https://tc39.es/ecma262/#sec-set.prototype.foreach
                forEach: function forEach(callbackfn /* , that = undefined */ ) {
                    var state = getInternalState(this);
                    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    var entry;
                    while(entry = entry ? entry.next : state.first){
                        boundFunction(entry.value, entry.key, this);
                        // revert to the last existing entry
                        while(entry && entry.removed)entry = entry.previous;
                    }
                },
                // `{ Map, Set}.prototype.has(key)` methods
                // https://tc39.es/ecma262/#sec-map.prototype.has
                // https://tc39.es/ecma262/#sec-set.prototype.has
                has: function has(key) {
                    return !!getEntry(this, key);
                }
            });
            defineBuiltIns(Prototype, IS_MAP ? {
                // `Map.prototype.get(key)` method
                // https://tc39.es/ecma262/#sec-map.prototype.get
                get: function get(key) {
                    var entry = getEntry(this, key);
                    return entry && entry.value;
                },
                // `Map.prototype.set(key, value)` method
                // https://tc39.es/ecma262/#sec-map.prototype.set
                set: function set(key, value) {
                    return define(this, key === 0 ? 0 : key, value);
                }
            } : {
                // `Set.prototype.add(value)` method
                // https://tc39.es/ecma262/#sec-set.prototype.add
                add: function add(value) {
                    return define(this, value = value === 0 ? 0 : value, value);
                }
            });
            if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
                configurable: true,
                get: function() {
                    return getInternalState(this).size;
                }
            });
            return Constructor;
        },
        setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
            var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
            var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
            var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
            // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.entries
            // https://tc39.es/ecma262/#sec-map.prototype.keys
            // https://tc39.es/ecma262/#sec-map.prototype.values
            // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
            // https://tc39.es/ecma262/#sec-set.prototype.entries
            // https://tc39.es/ecma262/#sec-set.prototype.keys
            // https://tc39.es/ecma262/#sec-set.prototype.values
            // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
            defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
                setInternalState(this, {
                    type: ITERATOR_NAME,
                    target: iterated,
                    state: getInternalCollectionState(iterated),
                    kind: kind,
                    last: undefined
                });
            }, function() {
                var state = getInternalIteratorState(this);
                var kind = state.kind;
                var entry = state.last;
                // revert to the last existing entry
                while(entry && entry.removed)entry = entry.previous;
                // get next entry
                if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                    // or finish the iteration
                    state.target = undefined;
                    return createIterResultObject(undefined, true);
                }
                // return step by kind
                if (kind === 'keys') return createIterResultObject(entry.key, false);
                if (kind === 'values') return createIterResultObject(entry.value, false);
                return createIterResultObject([
                    entry.key,
                    entry.value
                ], false);
            }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
            // `{ Map, Set }.prototype[@@species]` accessors
            // https://tc39.es/ecma262/#sec-get-map-@@species
            // https://tc39.es/ecma262/#sec-get-set-@@species
            setSpecies(CONSTRUCTOR_NAME);
        }
    };
    var collection$1 = collection$2;
    var collectionStrong$1 = collectionStrong$2;
    // `Map` constructor
    // https://tc39.es/ecma262/#sec-map-objects
    collection$1('Map', function(init) {
        return function Map1() {
            return init(this, arguments.length ? arguments[0] : undefined);
        };
    }, collectionStrong$1);
    var path$1 = path$o;
    var map$2 = path$1.Map;
    var parent$9 = map$2;
    var map$1 = parent$9;
    var map = map$1;
    var _Map = /*@__PURE__*/ getDefaultExportFromCjs(map);
    var $$1 = _export;
    var $some = arrayIteration.some;
    var arrayMethodIsStrict$1 = arrayMethodIsStrict$4;
    var STRICT_METHOD$1 = arrayMethodIsStrict$1('some');
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    $$1({
        target: 'Array',
        proto: true,
        forced: !STRICT_METHOD$1
    }, {
        some: function some(callbackfn /* , thisArg */ ) {
            return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });
    var getBuiltInPrototypeMethod$4 = getBuiltInPrototypeMethod$g;
    var some$3 = getBuiltInPrototypeMethod$4('Array', 'some');
    var isPrototypeOf$4 = objectIsPrototypeOf;
    var method$4 = some$3;
    var ArrayPrototype$4 = Array.prototype;
    var some$2 = function(it) {
        var own = it.some;
        return it === ArrayPrototype$4 || isPrototypeOf$4(ArrayPrototype$4, it) && own === ArrayPrototype$4.some ? method$4 : own;
    };
    var parent$8 = some$2;
    var some$1 = parent$8;
    var some = some$1;
    var _someInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(some);
    var getBuiltInPrototypeMethod$3 = getBuiltInPrototypeMethod$g;
    var keys$3 = getBuiltInPrototypeMethod$3('Array', 'keys');
    var parent$7 = keys$3;
    var keys$2 = parent$7;
    var classof$2 = classof$d;
    var hasOwn$2 = hasOwnProperty_1;
    var isPrototypeOf$3 = objectIsPrototypeOf;
    var method$3 = keys$2;
    var ArrayPrototype$3 = Array.prototype;
    var DOMIterables$2 = {
        DOMTokenList: true,
        NodeList: true
    };
    var keys$1 = function(it) {
        var own = it.keys;
        return it === ArrayPrototype$3 || isPrototypeOf$3(ArrayPrototype$3, it) && own === ArrayPrototype$3.keys || hasOwn$2(DOMIterables$2, classof$2(it)) ? method$3 : own;
    };
    var keys = keys$1;
    var _keysInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(keys);
    var arraySlice = arraySliceSimple;
    var floor = Math.floor;
    var mergeSort = function(array, comparefn) {
        var length = array.length;
        var middle = floor(length / 2);
        return length < 8 ? insertionSort(array, comparefn) : merge(array, mergeSort(arraySlice(array, 0, middle), comparefn), mergeSort(arraySlice(array, middle), comparefn), comparefn);
    };
    var insertionSort = function(array, comparefn) {
        var length = array.length;
        var i = 1;
        var element, j;
        while(i < length){
            j = i;
            element = array[i];
            while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
            if (j !== i++) array[j] = element;
        }
        return array;
    };
    var merge = function(array, left, right, comparefn) {
        var llength = left.length;
        var rlength = right.length;
        var lindex = 0;
        var rindex = 0;
        while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
        return array;
    };
    var arraySort = mergeSort;
    var userAgent$1 = engineUserAgent;
    var firefox = userAgent$1.match(/firefox\/(\d+)/i);
    var engineFfVersion = !!firefox && +firefox[1];
    var UA = engineUserAgent;
    var engineIsIeOrEdge = /MSIE|Trident/.test(UA);
    var userAgent = engineUserAgent;
    var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
    var engineWebkitVersion = !!webkit && +webkit[1];
    var $ = _export;
    var uncurryThis = functionUncurryThis;
    var aCallable = aCallable$e;
    var toObject = toObject$e;
    var lengthOfArrayLike = lengthOfArrayLike$d;
    var deletePropertyOrThrow = deletePropertyOrThrow$2;
    var toString = toString$7;
    var fails = fails$u;
    var internalSort = arraySort;
    var arrayMethodIsStrict = arrayMethodIsStrict$4;
    var FF = engineFfVersion;
    var IE_OR_EDGE = engineIsIeOrEdge;
    var V8 = engineV8Version;
    var WEBKIT = engineWebkitVersion;
    var test = [];
    var nativeSort = uncurryThis(test.sort);
    var push = uncurryThis(test.push);
    // IE8-
    var FAILS_ON_UNDEFINED = fails(function() {
        test.sort(undefined);
    });
    // V8 bug
    var FAILS_ON_NULL = fails(function() {
        test.sort(null);
    });
    // Old WebKit
    var STRICT_METHOD = arrayMethodIsStrict('sort');
    var STABLE_SORT = !fails(function() {
        // feature detection can be too slow, so check engines versions
        if (V8) return V8 < 70;
        if (FF && FF > 3) return;
        if (IE_OR_EDGE) return true;
        if (WEBKIT) return WEBKIT < 603;
        var result = '';
        var code, chr, value, index;
        // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
        for(code = 65; code < 76; code++){
            chr = String.fromCharCode(code);
            switch(code){
                case 66:
                case 69:
                case 70:
                case 72:
                    value = 3;
                    break;
                case 68:
                case 71:
                    value = 4;
                    break;
                default:
                    value = 2;
            }
            for(index = 0; index < 47; index++)test.push({
                k: chr + index,
                v: value
            });
        }
        test.sort(function(a, b) {
            return b.v - a.v;
        });
        for(index = 0; index < test.length; index++){
            chr = test[index].k.charAt(0);
            if (result.charAt(result.length - 1) !== chr) result += chr;
        }
        return result !== 'DGBEFHACIJK';
    });
    var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
    var getSortCompare = function(comparefn) {
        return function(x, y) {
            if (y === undefined) return -1;
            if (x === undefined) return 1;
            if (comparefn !== undefined) return +comparefn(x, y) || 0;
            return toString(x) > toString(y) ? 1 : -1;
        };
    };
    // `Array.prototype.sort` method
    // https://tc39.es/ecma262/#sec-array.prototype.sort
    $({
        target: 'Array',
        proto: true,
        forced: FORCED
    }, {
        sort: function sort(comparefn) {
            if (comparefn !== undefined) aCallable(comparefn);
            var array = toObject(this);
            if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
            var items = [];
            var arrayLength = lengthOfArrayLike(array);
            var itemsLength, index;
            for(index = 0; index < arrayLength; index++)if (index in array) push(items, array[index]);
            internalSort(items, getSortCompare(comparefn));
            itemsLength = lengthOfArrayLike(items);
            index = 0;
            while(index < itemsLength)array[index] = items[index++];
            while(index < arrayLength)deletePropertyOrThrow(array, index++);
            return array;
        }
    });
    var getBuiltInPrototypeMethod$2 = getBuiltInPrototypeMethod$g;
    var sort$3 = getBuiltInPrototypeMethod$2('Array', 'sort');
    var isPrototypeOf$2 = objectIsPrototypeOf;
    var method$2 = sort$3;
    var ArrayPrototype$2 = Array.prototype;
    var sort$2 = function(it) {
        var own = it.sort;
        return it === ArrayPrototype$2 || isPrototypeOf$2(ArrayPrototype$2, it) && own === ArrayPrototype$2.sort ? method$2 : own;
    };
    var parent$6 = sort$2;
    var sort$1 = parent$6;
    var sort = sort$1;
    var _sortInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(sort);
    var getBuiltInPrototypeMethod$1 = getBuiltInPrototypeMethod$g;
    var values$3 = getBuiltInPrototypeMethod$1('Array', 'values');
    var parent$5 = values$3;
    var values$2 = parent$5;
    var classof$1 = classof$d;
    var hasOwn$1 = hasOwnProperty_1;
    var isPrototypeOf$1 = objectIsPrototypeOf;
    var method$1 = values$2;
    var ArrayPrototype$1 = Array.prototype;
    var DOMIterables$1 = {
        DOMTokenList: true,
        NodeList: true
    };
    var values$1 = function(it) {
        var own = it.values;
        return it === ArrayPrototype$1 || isPrototypeOf$1(ArrayPrototype$1, it) && own === ArrayPrototype$1.values || hasOwn$1(DOMIterables$1, classof$1(it)) ? method$1 : own;
    };
    var values = values$1;
    var _valuesInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(values);
    var iterator = iterator$4;
    var _Symbol$iterator = /*@__PURE__*/ getDefaultExportFromCjs(iterator);
    var getBuiltInPrototypeMethod = getBuiltInPrototypeMethod$g;
    var entries$3 = getBuiltInPrototypeMethod('Array', 'entries');
    var parent$4 = entries$3;
    var entries$2 = parent$4;
    var classof = classof$d;
    var hasOwn = hasOwnProperty_1;
    var isPrototypeOf = objectIsPrototypeOf;
    var method = entries$2;
    var ArrayPrototype = Array.prototype;
    var DOMIterables = {
        DOMTokenList: true,
        NodeList: true
    };
    var entries$1 = function(it) {
        var own = it.entries;
        return it === ArrayPrototype || isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.entries || hasOwn(DOMIterables, classof(it)) ? method : own;
    };
    var entries = entries$1;
    var _entriesInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(entries);
    // Unique ID creation requires a high quality random # generator. In the browser we therefore
    // require the crypto API and do not support built-in fallback to lower quality random number
    // generators (like Math.random()).
    let getRandomValues;
    const rnds8 = new Uint8Array(16);
    function rng() {
        // lazy load so that environments that need to polyfill have a chance to do so
        if (!getRandomValues) {
            // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
            getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
            if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
        return getRandomValues(rnds8);
    }
    /**
   * Convert array of 16 byte values to UUID string format of the form:
   * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
   */ const byteToHex = [];
    for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
    function unsafeStringify(arr, offset = 0) {
        // Note: Be careful editing this code!  It's been tuned for performance
        // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
        return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
    }
    const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
    var native = {
        randomUUID
    };
    function v4(options, buf, offset) {
        if (native.randomUUID && !buf && !options) return native.randomUUID();
        options = options || {};
        const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
        rnds[6] = rnds[6] & 0x0f | 0x40;
        rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
        if (buf) {
            offset = offset || 0;
            for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
            return buf;
        }
        return unsafeStringify(rnds);
    }
    /**
   * Determine whether a value can be used as an id.
   *
   * @param value - Input value of unknown type.
   * @returns True if the value is valid id, false otherwise.
   */ function isId(value) {
        return typeof value === "string" || typeof value === "number";
    }
    /**
   * A queue.
   *
   * @typeParam T - The type of method names to be replaced by queued versions.
   */ var Queue = /*#__PURE__*/ function() {
        /**
     * Construct a new Queue.
     *
     * @param options - Queue configuration.
     */ function Queue(options) {
            _classCallCheck(this, Queue);
            /** Delay in milliseconds. If defined the queue will be periodically flushed. */ /** Maximum number of entries in the queue before it will be flushed. */ _defineProperty(this, "_queue", []);
            _defineProperty(this, "_timeout", null);
            _defineProperty(this, "_extended", null);
            // options
            this.delay = null;
            this.max = Infinity;
            this.setOptions(options);
        }
        /**
     * Update the configuration of the queue.
     *
     * @param options - Queue configuration.
     */ _createClass(Queue, [
            {
                key: "setOptions",
                value: function setOptions(options) {
                    if (options && typeof options.delay !== "undefined") this.delay = options.delay;
                    if (options && typeof options.max !== "undefined") this.max = options.max;
                    this._flushIfNeeded();
                }
            },
            {
                key: "destroy",
                value: /**
       * Destroy the queue. The queue will first flush all queued actions, and in case it has extended an object, will restore the original object.
       */ function destroy() {
                    this.flush();
                    if (this._extended) {
                        var object = this._extended.object;
                        var methods = this._extended.methods;
                        for(var i = 0; i < methods.length; i++){
                            var method = methods[i];
                            if (method.original) // @TODO: better solution?
                            object[method.name] = method.original;
                            else // @TODO: better solution?
                            delete object[method.name];
                        }
                        this._extended = null;
                    }
                }
            },
            {
                key: "replace",
                value: function replace(object, method) {
                    /* eslint-disable-next-line @typescript-eslint/no-this-alias -- Function this is necessary in the function bellow, so class this has to be saved into a variable here. */ var me = this;
                    var original = object[method];
                    if (!original) throw new Error("Method " + method + " undefined");
                    object[method] = function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        // add this call to the queue
                        me.queue({
                            args: args,
                            fn: original,
                            context: this
                        });
                    };
                }
            },
            {
                key: "queue",
                value: function queue(entry) {
                    if (typeof entry === "function") this._queue.push({
                        fn: entry
                    });
                    else this._queue.push(entry);
                    this._flushIfNeeded();
                }
            },
            {
                key: "_flushIfNeeded",
                value: function _flushIfNeeded() {
                    var _this = this;
                    // flush when the maximum is exceeded.
                    if (this._queue.length > this.max) this.flush();
                    // flush after a period of inactivity when a delay is configured
                    if (this._timeout != null) {
                        clearTimeout(this._timeout);
                        this._timeout = null;
                    }
                    if (this.queue.length > 0 && typeof this.delay === "number") this._timeout = _setTimeout(function() {
                        _this.flush();
                    }, this.delay);
                }
            },
            {
                key: "flush",
                value: function flush() {
                    var _context, _context2;
                    _forEachInstanceProperty(_context = _spliceInstanceProperty(_context2 = this._queue).call(_context2, 0)).call(_context, function(entry) {
                        entry.fn.apply(entry.context || entry.fn, entry.args || []);
                    });
                }
            }
        ], [
            {
                key: "extend",
                value: function extend(object, options) {
                    var queue = new Queue(options);
                    if (object.flush !== undefined) throw new Error("Target object already has a property flush");
                    object.flush = function() {
                        queue.flush();
                    };
                    var methods = [
                        {
                            name: "flush",
                            original: undefined
                        }
                    ];
                    if (options && options.replace) for(var i = 0; i < options.replace.length; i++){
                        var name = options.replace[i];
                        methods.push({
                            name: name,
                            // @TODO: better solution?
                            original: object[name]
                        });
                        // @TODO: better solution?
                        queue.replace(object, name);
                    }
                    queue._extended = {
                        object: object,
                        methods: methods
                    };
                    return queue;
                }
            }
        ]);
        return Queue;
    }();
    /**
   * {@link DataSet} code that can be reused in {@link DataView} or other similar implementations of {@link DataInterface}.
   *
   * @typeParam Item - Item type that may or may not have an id.
   * @typeParam IdProp - Name of the property that contains the id.
   */ var DataSetPart = /*#__PURE__*/ function() {
        function DataSetPart() {
            _classCallCheck(this, DataSetPart);
            _defineProperty(this, "_subscribers", {
                "*": [],
                add: [],
                remove: [],
                update: []
            });
            /**
       * @deprecated Use on instead (PS: DataView.subscribe === DataView.on).
       */ _defineProperty(this, "subscribe", DataSetPart.prototype.on);
            /**
       * @deprecated Use off instead (PS: DataView.unsubscribe === DataView.off).
       */ _defineProperty(this, "unsubscribe", DataSetPart.prototype.off);
        }
        _createClass(DataSetPart, [
            {
                key: "_trigger",
                value: /**
       * Trigger an event
       *
       * @param event - Event name.
       * @param payload - Event payload.
       * @param senderId - Id of the sender.
       */ function _trigger(event, payload, senderId) {
                    var _context, _context2;
                    if (event === "*") throw new Error("Cannot trigger event *");
                    _forEachInstanceProperty(_context = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(this._subscribers[event]), _toConsumableArray(this._subscribers["*"]))).call(_context, function(subscriber) {
                        subscriber(event, payload, senderId != null ? senderId : null);
                    });
                }
            },
            {
                key: "on",
                value: function on(event, callback) {
                    if (typeof callback === "function") this._subscribers[event].push(callback);
                // @TODO: Maybe throw for invalid callbacks?
                }
            },
            {
                key: "off",
                value: function off(event, callback) {
                    var _context3;
                    this._subscribers[event] = _filterInstanceProperty(_context3 = this._subscribers[event]).call(_context3, function(subscriber) {
                        return subscriber !== callback;
                    });
                }
            }
        ]);
        return DataSetPart;
    }();
    var collection = collection$2;
    var collectionStrong = collectionStrong$2;
    // `Set` constructor
    // https://tc39.es/ecma262/#sec-set-objects
    collection('Set', function(init) {
        return function Set() {
            return init(this, arguments.length ? arguments[0] : undefined);
        };
    }, collectionStrong);
    var path = path$o;
    var set$2 = path.Set;
    var parent$3 = set$2;
    var set$1 = parent$3;
    var set = set$1;
    var _Set = /*@__PURE__*/ getDefaultExportFromCjs(set);
    var getIterator$5 = getIterator$8;
    var getIterator_1 = getIterator$5;
    var parent$2 = getIterator_1;
    var getIterator$4 = parent$2;
    var parent$1 = getIterator$4;
    var getIterator$3 = parent$1;
    var parent = getIterator$3;
    var getIterator$2 = parent;
    var getIterator$1 = getIterator$2;
    var getIterator = getIterator$1;
    var _getIterator = /*@__PURE__*/ getDefaultExportFromCjs(getIterator);
    function _createForOfIteratorHelper$2(o, allowArrayLike) {
        var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
        if (!it) {
            if (_Array$isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;
                var F = function F() {};
                return {
                    s: F,
                    n: function n() {
                        if (i >= o.length) return {
                            done: true
                        };
                        return {
                            done: false,
                            value: o[i++]
                        };
                    },
                    e: function e(_e) {
                        throw _e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var normalCompletion = true, didErr = false, err;
        return {
            s: function s() {
                it = it.call(o);
            },
            n: function n() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
            },
            e: function e(_e2) {
                didErr = true;
                err = _e2;
            },
            f: function f() {
                try {
                    if (!normalCompletion && it.return != null) it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    function _unsupportedIterableToArray$2(o, minLen) {
        var _context10;
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
        var n = _sliceInstanceProperty(_context10 = Object.prototype.toString.call(o)).call(_context10, 8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return _Array$from$1(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
    }
    function _arrayLikeToArray$2(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    /**
   * Data stream
   *
   * @remarks
   * {@link DataStream} offers an always up to date stream of items from a {@link DataSet} or {@link DataView}.
   * That means that the stream is evaluated at the time of iteration, conversion to another data type or when {@link cache} is called, not when the {@link DataStream} was created.
   * Multiple invocations of for example {@link toItemArray} may yield different results (if the data source like for example {@link DataSet} gets modified).
   * @typeParam Item - The item type this stream is going to work with.
   */ var DataStream = /*#__PURE__*/ function(_Symbol$iterator$1) {
        /**
     * Create a new data stream.
     *
     * @param pairs - The id, item pairs.
     */ function DataStream(pairs) {
            _classCallCheck(this, DataStream);
            this._pairs = pairs;
        }
        /**
     * Return an iterable of key, value pairs for every entry in the stream.
     */ _createClass(DataStream, [
            {
                key: _Symbol$iterator$1,
                value: /*#__PURE__*/ _regeneratorRuntime.mark(function value() {
                    var _iterator, _step, _step$value, id, item;
                    return _regeneratorRuntime.wrap(function value$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _iterator = _createForOfIteratorHelper$2(this._pairs);
                                _context.prev = 1;
                                _iterator.s();
                            case 3:
                                if ((_step = _iterator.n()).done) {
                                    _context.next = 9;
                                    break;
                                }
                                _step$value = _slicedToArray(_step.value, 2), id = _step$value[0], item = _step$value[1];
                                _context.next = 7;
                                return [
                                    id,
                                    item
                                ];
                            case 7:
                                _context.next = 3;
                                break;
                            case 9:
                                _context.next = 14;
                                break;
                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context["catch"](1);
                                _iterator.e(_context.t0);
                            case 14:
                                _context.prev = 14;
                                _iterator.f();
                                return _context.finish(14);
                            case 17:
                            case "end":
                                return _context.stop();
                        }
                    }, value, this, [
                        [
                            1,
                            11,
                            14,
                            17
                        ]
                    ]);
                })
            },
            {
                key: "entries",
                value: /*#__PURE__*/ _regeneratorRuntime.mark(function entries() {
                    var _iterator2, _step2, _step2$value, id, item;
                    return _regeneratorRuntime.wrap(function entries$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _iterator2 = _createForOfIteratorHelper$2(this._pairs);
                                _context2.prev = 1;
                                _iterator2.s();
                            case 3:
                                if ((_step2 = _iterator2.n()).done) {
                                    _context2.next = 9;
                                    break;
                                }
                                _step2$value = _slicedToArray(_step2.value, 2), id = _step2$value[0], item = _step2$value[1];
                                _context2.next = 7;
                                return [
                                    id,
                                    item
                                ];
                            case 7:
                                _context2.next = 3;
                                break;
                            case 9:
                                _context2.next = 14;
                                break;
                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2["catch"](1);
                                _iterator2.e(_context2.t0);
                            case 14:
                                _context2.prev = 14;
                                _iterator2.f();
                                return _context2.finish(14);
                            case 17:
                            case "end":
                                return _context2.stop();
                        }
                    }, entries, this, [
                        [
                            1,
                            11,
                            14,
                            17
                        ]
                    ]);
                })
            },
            {
                key: "keys",
                value: /*#__PURE__*/ _regeneratorRuntime.mark(function keys() {
                    var _iterator3, _step3, _step3$value, id;
                    return _regeneratorRuntime.wrap(function keys$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _iterator3 = _createForOfIteratorHelper$2(this._pairs);
                                _context3.prev = 1;
                                _iterator3.s();
                            case 3:
                                if ((_step3 = _iterator3.n()).done) {
                                    _context3.next = 9;
                                    break;
                                }
                                _step3$value = _slicedToArray(_step3.value, 1), id = _step3$value[0];
                                _context3.next = 7;
                                return id;
                            case 7:
                                _context3.next = 3;
                                break;
                            case 9:
                                _context3.next = 14;
                                break;
                            case 11:
                                _context3.prev = 11;
                                _context3.t0 = _context3["catch"](1);
                                _iterator3.e(_context3.t0);
                            case 14:
                                _context3.prev = 14;
                                _iterator3.f();
                                return _context3.finish(14);
                            case 17:
                            case "end":
                                return _context3.stop();
                        }
                    }, keys, this, [
                        [
                            1,
                            11,
                            14,
                            17
                        ]
                    ]);
                })
            },
            {
                key: "values",
                value: /*#__PURE__*/ _regeneratorRuntime.mark(function values() {
                    var _iterator4, _step4, _step4$value, item;
                    return _regeneratorRuntime.wrap(function values$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _iterator4 = _createForOfIteratorHelper$2(this._pairs);
                                _context4.prev = 1;
                                _iterator4.s();
                            case 3:
                                if ((_step4 = _iterator4.n()).done) {
                                    _context4.next = 9;
                                    break;
                                }
                                _step4$value = _slicedToArray(_step4.value, 2), item = _step4$value[1];
                                _context4.next = 7;
                                return item;
                            case 7:
                                _context4.next = 3;
                                break;
                            case 9:
                                _context4.next = 14;
                                break;
                            case 11:
                                _context4.prev = 11;
                                _context4.t0 = _context4["catch"](1);
                                _iterator4.e(_context4.t0);
                            case 14:
                                _context4.prev = 14;
                                _iterator4.f();
                                return _context4.finish(14);
                            case 17:
                            case "end":
                                return _context4.stop();
                        }
                    }, values, this, [
                        [
                            1,
                            11,
                            14,
                            17
                        ]
                    ]);
                })
            },
            {
                key: "toIdArray",
                value: function toIdArray() {
                    var _context5;
                    return _mapInstanceProperty(_context5 = _toConsumableArray(this._pairs)).call(_context5, function(pair) {
                        return pair[0];
                    });
                }
            },
            {
                key: "toItemArray",
                value: function toItemArray() {
                    var _context6;
                    return _mapInstanceProperty(_context6 = _toConsumableArray(this._pairs)).call(_context6, function(pair) {
                        return pair[1];
                    });
                }
            },
            {
                key: "toEntryArray",
                value: function toEntryArray() {
                    return _toConsumableArray(this._pairs);
                }
            },
            {
                key: "toObjectMap",
                value: function toObjectMap() {
                    var map = _Object$create$1(null);
                    var _iterator5 = _createForOfIteratorHelper$2(this._pairs), _step5;
                    try {
                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                            var _step5$value = _slicedToArray(_step5.value, 2), id = _step5$value[0], item = _step5$value[1];
                            map[id] = item;
                        }
                    } catch (err) {
                        _iterator5.e(err);
                    } finally{
                        _iterator5.f();
                    }
                    return map;
                }
            },
            {
                key: "toMap",
                value: function toMap() {
                    return new _Map(this._pairs);
                }
            },
            {
                key: "toIdSet",
                value: function toIdSet() {
                    return new _Set(this.toIdArray());
                }
            },
            {
                key: "toItemSet",
                value: function toItemSet() {
                    return new _Set(this.toItemArray());
                }
            },
            {
                key: "cache",
                value: function cache() {
                    return new DataStream(_toConsumableArray(this._pairs));
                }
            },
            {
                key: "distinct",
                value: function distinct(callback) {
                    var set = new _Set();
                    var _iterator6 = _createForOfIteratorHelper$2(this._pairs), _step6;
                    try {
                        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                            var _step6$value = _slicedToArray(_step6.value, 2), id = _step6$value[0], item = _step6$value[1];
                            set.add(callback(item, id));
                        }
                    } catch (err) {
                        _iterator6.e(err);
                    } finally{
                        _iterator6.f();
                    }
                    return set;
                }
            },
            {
                key: "filter",
                value: function filter(callback) {
                    var pairs = this._pairs;
                    return new DataStream({
                        [_Symbol$iterator] () {
                            return /*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
                                var _iterator7, _step7, _step7$value, id, item;
                                return _regeneratorRuntime.wrap(function _callee$(_context7) {
                                    while(true)switch(_context7.prev = _context7.next){
                                        case 0:
                                            _iterator7 = _createForOfIteratorHelper$2(pairs);
                                            _context7.prev = 1;
                                            _iterator7.s();
                                        case 3:
                                            if ((_step7 = _iterator7.n()).done) {
                                                _context7.next = 10;
                                                break;
                                            }
                                            _step7$value = _slicedToArray(_step7.value, 2), id = _step7$value[0], item = _step7$value[1];
                                            if (!callback(item, id)) {
                                                _context7.next = 8;
                                                break;
                                            }
                                            _context7.next = 8;
                                            return [
                                                id,
                                                item
                                            ];
                                        case 8:
                                            _context7.next = 3;
                                            break;
                                        case 10:
                                            _context7.next = 15;
                                            break;
                                        case 12:
                                            _context7.prev = 12;
                                            _context7.t0 = _context7["catch"](1);
                                            _iterator7.e(_context7.t0);
                                        case 15:
                                            _context7.prev = 15;
                                            _iterator7.f();
                                            return _context7.finish(15);
                                        case 18:
                                        case "end":
                                            return _context7.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        1,
                                        12,
                                        15,
                                        18
                                    ]
                                ]);
                            })();
                        }
                    });
                }
            },
            {
                key: "forEach",
                value: function forEach(callback) {
                    var _iterator8 = _createForOfIteratorHelper$2(this._pairs), _step8;
                    try {
                        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                            var _step8$value = _slicedToArray(_step8.value, 2), id = _step8$value[0], item = _step8$value[1];
                            callback(item, id);
                        }
                    } catch (err) {
                        _iterator8.e(err);
                    } finally{
                        _iterator8.f();
                    }
                }
            },
            {
                key: "map",
                value: function map(callback) {
                    var pairs = this._pairs;
                    return new DataStream({
                        [_Symbol$iterator] () {
                            return /*#__PURE__*/ _regeneratorRuntime.mark(function _callee2() {
                                var _iterator9, _step9, _step9$value, id, item;
                                return _regeneratorRuntime.wrap(function _callee2$(_context8) {
                                    while(true)switch(_context8.prev = _context8.next){
                                        case 0:
                                            _iterator9 = _createForOfIteratorHelper$2(pairs);
                                            _context8.prev = 1;
                                            _iterator9.s();
                                        case 3:
                                            if ((_step9 = _iterator9.n()).done) {
                                                _context8.next = 9;
                                                break;
                                            }
                                            _step9$value = _slicedToArray(_step9.value, 2), id = _step9$value[0], item = _step9$value[1];
                                            _context8.next = 7;
                                            return [
                                                id,
                                                callback(item, id)
                                            ];
                                        case 7:
                                            _context8.next = 3;
                                            break;
                                        case 9:
                                            _context8.next = 14;
                                            break;
                                        case 11:
                                            _context8.prev = 11;
                                            _context8.t0 = _context8["catch"](1);
                                            _iterator9.e(_context8.t0);
                                        case 14:
                                            _context8.prev = 14;
                                            _iterator9.f();
                                            return _context8.finish(14);
                                        case 17:
                                        case "end":
                                            return _context8.stop();
                                    }
                                }, _callee2, null, [
                                    [
                                        1,
                                        11,
                                        14,
                                        17
                                    ]
                                ]);
                            })();
                        }
                    });
                }
            },
            {
                key: "max",
                value: function max(callback) {
                    var iter = _getIterator(this._pairs);
                    var curr = iter.next();
                    if (curr.done) return null;
                    var maxItem = curr.value[1];
                    var maxValue = callback(curr.value[1], curr.value[0]);
                    while(!(curr = iter.next()).done){
                        var _curr$value = _slicedToArray(curr.value, 2), id = _curr$value[0], item = _curr$value[1];
                        var _value = callback(item, id);
                        if (_value > maxValue) {
                            maxValue = _value;
                            maxItem = item;
                        }
                    }
                    return maxItem;
                }
            },
            {
                key: "min",
                value: function min(callback) {
                    var iter = _getIterator(this._pairs);
                    var curr = iter.next();
                    if (curr.done) return null;
                    var minItem = curr.value[1];
                    var minValue = callback(curr.value[1], curr.value[0]);
                    while(!(curr = iter.next()).done){
                        var _curr$value2 = _slicedToArray(curr.value, 2), id = _curr$value2[0], item = _curr$value2[1];
                        var _value2 = callback(item, id);
                        if (_value2 < minValue) {
                            minValue = _value2;
                            minItem = item;
                        }
                    }
                    return minItem;
                }
            },
            {
                key: "reduce",
                value: function reduce(callback, accumulator) {
                    var _iterator10 = _createForOfIteratorHelper$2(this._pairs), _step10;
                    try {
                        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
                            var _step10$value = _slicedToArray(_step10.value, 2), id = _step10$value[0], item = _step10$value[1];
                            accumulator = callback(accumulator, item, id);
                        }
                    } catch (err) {
                        _iterator10.e(err);
                    } finally{
                        _iterator10.f();
                    }
                    return accumulator;
                }
            },
            {
                key: "sort",
                value: function sort(callback) {
                    var _this = this;
                    return new DataStream({
                        [_Symbol$iterator]: function() {
                            var _context9;
                            return _getIterator(_sortInstanceProperty(_context9 = _toConsumableArray(_this._pairs)).call(_context9, function(_ref, _ref2) {
                                var _ref3 = _slicedToArray(_ref, 2), idA = _ref3[0], itemA = _ref3[1];
                                var _ref4 = _slicedToArray(_ref2, 2), idB = _ref4[0], itemB = _ref4[1];
                                return callback(itemA, itemB, idA, idB);
                            }));
                        }
                    });
                }
            }
        ]);
        return DataStream;
    }(_Symbol$iterator);
    function ownKeys(e, r) {
        var t = _Object$keys(e);
        if (_Object$getOwnPropertySymbols) {
            var o = _Object$getOwnPropertySymbols(e);
            r && (o = _filterInstanceProperty(o).call(o, function(r) {
                return _Object$getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread(e) {
        for(var r = 1; r < arguments.length; r++){
            var _context10, _context11;
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? _forEachInstanceProperty(_context10 = ownKeys(Object(t), !0)).call(_context10, function(r) {
                _defineProperty(e, r, t[r]);
            }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context11 = ownKeys(Object(t))).call(_context11, function(r) {
                _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _createForOfIteratorHelper$1(o, allowArrayLike) {
        var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
        if (!it) {
            if (_Array$isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;
                var F = function F() {};
                return {
                    s: F,
                    n: function n() {
                        if (i >= o.length) return {
                            done: true
                        };
                        return {
                            done: false,
                            value: o[i++]
                        };
                    },
                    e: function e(_e) {
                        throw _e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var normalCompletion = true, didErr = false, err;
        return {
            s: function s() {
                it = it.call(o);
            },
            n: function n() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
            },
            e: function e(_e2) {
                didErr = true;
                err = _e2;
            },
            f: function f() {
                try {
                    if (!normalCompletion && it.return != null) it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    function _unsupportedIterableToArray$1(o, minLen) {
        var _context9;
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
        var n = _sliceInstanceProperty(_context9 = Object.prototype.toString.call(o)).call(_context9, 8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return _Array$from$1(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
    }
    function _arrayLikeToArray$1(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createSuper$1(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = _Reflect$construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _isNativeReflectConstruct$1() {
        if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
        if (_Reflect$construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * Add an id to given item if it doesn't have one already.
   *
   * @remarks
   * The item will be modified.
   * @param item - The item that will have an id after a call to this function.
   * @param idProp - The key of the id property.
   * @typeParam Item - Item type that may or may not have an id.
   * @typeParam IdProp - Name of the property that contains the id.
   * @returns true
   */ function ensureFullItem(item, idProp) {
        if (item[idProp] == null) // generate an id
        item[idProp] = v4();
        return item;
    }
    /**
   * # DataSet
   *
   * Vis.js comes with a flexible DataSet, which can be used to hold and
   * manipulate unstructured data and listen for changes in the data. The DataSet
   * is key/value based. Data items can be added, updated and removed from the
   * DataSet, and one can subscribe to changes in the DataSet. The data in the
   * DataSet can be filtered and ordered. Data can be normalized when appending it
   * to the DataSet as well.
   *
   * ## Example
   *
   * The following example shows how to use a DataSet.
   *
   * ```javascript
   * // create a DataSet
   * var options = {};
   * var data = new vis.DataSet(options);
   *
   * // add items
   * // note that the data items can contain different properties and data formats
   * data.add([
   *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
   *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
   *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
   *   {id: 4, text: 'item 4'}
   * ]);
   *
   * // subscribe to any change in the DataSet
   * data.on('*', function (event, properties, senderId) {
   *   console.log('event', event, properties);
   * });
   *
   * // update an existing item
   * data.update({id: 2, group: 1});
   *
   * // remove an item
   * data.remove(4);
   *
   * // get all ids
   * var ids = data.getIds();
   * console.log('ids', ids);
   *
   * // get a specific item
   * var item1 = data.get(1);
   * console.log('item1', item1);
   *
   * // retrieve a filtered subset of the data
   * var items = data.get({
   *   filter: function (item) {
   *     return item.group == 1;
   *   }
   * });
   * console.log('filtered items', items);
   * ```
   *
   * @typeParam Item - Item type that may or may not have an id.
   * @typeParam IdProp - Name of the property that contains the id.
   */ var DataSet = /*#__PURE__*/ function(_DataSetPart) {
        _inherits(DataSet, _DataSetPart);
        var _super = _createSuper$1(DataSet);
        /**
     * Construct a new DataSet.
     *
     * @param data - Initial data or options.
     * @param options - Options (type error if data is also options).
     */ function DataSet(data, options) {
            var _this;
            _classCallCheck(this, DataSet);
            _this = _super.call(this);
            // correctly read optional arguments
            _defineProperty(_assertThisInitialized(_this), "_queue", null);
            if (data && !_Array$isArray(data)) {
                options = data;
                data = [];
            }
            _this._options = options || {};
            _this._data = new _Map(); // map with data indexed by id
            _this.length = 0; // number of items in the DataSet
            _this._idProp = _this._options.fieldId || "id"; // name of the field containing id
            // add initial data when provided
            if (data && data.length) _this.add(data);
            _this.setOptions(options);
            return _this;
        }
        /**
     * Set new options.
     *
     * @param options - The new options.
     */ _createClass(DataSet, [
            {
                key: "idProp",
                get: /** Flush all queued calls. */ /** @inheritDoc */ /** @inheritDoc */ function get() {
                    return this._idProp;
                }
            },
            {
                key: "setOptions",
                value: function setOptions(options) {
                    if (options && options.queue !== undefined) {
                        if (options.queue === false) // delete queue if loaded
                        {
                            if (this._queue) {
                                this._queue.destroy();
                                this._queue = null;
                            }
                        } else {
                            // create queue and update its options
                            if (!this._queue) this._queue = Queue.extend(this, {
                                replace: [
                                    "add",
                                    "update",
                                    "remove"
                                ]
                            });
                            if (options.queue && typeof options.queue === "object") this._queue.setOptions(options.queue);
                        }
                    }
                }
            },
            {
                key: "add",
                value: function add(data, senderId) {
                    var _this2 = this;
                    var addedIds = [];
                    var id;
                    if (_Array$isArray(data)) {
                        // Array
                        var idsToAdd = _mapInstanceProperty(data).call(data, function(d) {
                            return d[_this2._idProp];
                        });
                        if (_someInstanceProperty(idsToAdd).call(idsToAdd, function(id) {
                            return _this2._data.has(id);
                        })) throw new Error("A duplicate id was found in the parameter array.");
                        for(var i = 0, len = data.length; i < len; i++){
                            id = this._addItem(data[i]);
                            addedIds.push(id);
                        }
                    } else if (data && typeof data === "object") {
                        // Single item
                        id = this._addItem(data);
                        addedIds.push(id);
                    } else throw new Error("Unknown dataType");
                    if (addedIds.length) this._trigger("add", {
                        items: addedIds
                    }, senderId);
                    return addedIds;
                }
            },
            {
                key: "update",
                value: function update(data, senderId) {
                    var _this3 = this;
                    var addedIds = [];
                    var updatedIds = [];
                    var oldData = [];
                    var updatedData = [];
                    var idProp = this._idProp;
                    var addOrUpdate = function addOrUpdate(item) {
                        var origId = item[idProp];
                        if (origId != null && _this3._data.has(origId)) {
                            var fullItem = item; // it has an id, therefore it is a fullitem
                            var oldItem = _Object$assign({}, _this3._data.get(origId));
                            // update item
                            var id = _this3._updateItem(fullItem);
                            updatedIds.push(id);
                            updatedData.push(fullItem);
                            oldData.push(oldItem);
                        } else {
                            // add new item
                            var _id = _this3._addItem(item);
                            addedIds.push(_id);
                        }
                    };
                    if (_Array$isArray(data)) {
                        // Array
                        for(var i = 0, len = data.length; i < len; i++)if (data[i] && typeof data[i] === "object") addOrUpdate(data[i]);
                        else console.warn("Ignoring input item, which is not an object at index " + i);
                    } else if (data && typeof data === "object") // Single item
                    addOrUpdate(data);
                    else throw new Error("Unknown dataType");
                    if (addedIds.length) this._trigger("add", {
                        items: addedIds
                    }, senderId);
                    if (updatedIds.length) {
                        var props = {
                            items: updatedIds,
                            oldData: oldData,
                            data: updatedData
                        };
                        // TODO: remove deprecated property 'data' some day
                        //Object.defineProperty(props, 'data', {
                        //  'get': (function() {
                        //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                        //    return updatedData;
                        //  }).bind(this)
                        //});
                        this._trigger("update", props, senderId);
                    }
                    return _concatInstanceProperty(addedIds).call(addedIds, updatedIds);
                }
            },
            {
                key: "updateOnly",
                value: function updateOnly(data, senderId) {
                    var _context, _this4 = this;
                    if (!_Array$isArray(data)) data = [
                        data
                    ];
                    var updateEventData = _mapInstanceProperty(_context = _mapInstanceProperty(data).call(data, function(update) {
                        var oldData = _this4._data.get(update[_this4._idProp]);
                        if (oldData == null) throw new Error("Updating non-existent items is not allowed.");
                        return {
                            oldData,
                            update
                        };
                    })).call(_context, function(_ref) {
                        var oldData = _ref.oldData, update = _ref.update;
                        var id = oldData[_this4._idProp];
                        var updatedData = pureDeepObjectAssign(oldData, update);
                        _this4._data.set(id, updatedData);
                        return {
                            id,
                            oldData: oldData,
                            updatedData
                        };
                    });
                    if (updateEventData.length) {
                        var props = {
                            items: _mapInstanceProperty(updateEventData).call(updateEventData, function(value) {
                                return value.id;
                            }),
                            oldData: _mapInstanceProperty(updateEventData).call(updateEventData, function(value) {
                                return value.oldData;
                            }),
                            data: _mapInstanceProperty(updateEventData).call(updateEventData, function(value) {
                                return value.updatedData;
                            })
                        };
                        // TODO: remove deprecated property 'data' some day
                        //Object.defineProperty(props, 'data', {
                        //  'get': (function() {
                        //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                        //    return updatedData;
                        //  }).bind(this)
                        //});
                        this._trigger("update", props, senderId);
                        return props.items;
                    } else return [];
                }
            },
            {
                key: "get",
                value: function get(first, second) {
                    // @TODO: Woudn't it be better to split this into multiple methods?
                    // parse the arguments
                    var id = undefined;
                    var ids = undefined;
                    var options = undefined;
                    if (isId(first)) {
                        // get(id [, options])
                        id = first;
                        options = second;
                    } else if (_Array$isArray(first)) {
                        // get(ids [, options])
                        ids = first;
                        options = second;
                    } else // get([, options])
                    options = first;
                    // determine the return type
                    var returnType = options && options.returnType === "Object" ? "Object" : "Array";
                    // @TODO: WTF is this? Or am I missing something?
                    // var returnType
                    // if (options && options.returnType) {
                    //   var allowedValues = ['Array', 'Object']
                    //   returnType =
                    //     allowedValues.indexOf(options.returnType) == -1
                    //       ? 'Array'
                    //       : options.returnType
                    // } else {
                    //   returnType = 'Array'
                    // }
                    // build options
                    var filter = options && _filterInstanceProperty(options);
                    var items = [];
                    var item = undefined;
                    var itemIds = undefined;
                    var itemId = undefined;
                    // convert items
                    if (id != null) {
                        // return a single item
                        item = this._data.get(id);
                        if (item && filter && !filter(item)) item = undefined;
                    } else if (ids != null) // return a subset of items
                    for(var i = 0, len = ids.length; i < len; i++){
                        item = this._data.get(ids[i]);
                        if (item != null && (!filter || filter(item))) items.push(item);
                    }
                    else {
                        var _context2;
                        // return all items
                        itemIds = _toConsumableArray(_keysInstanceProperty(_context2 = this._data).call(_context2));
                        for(var _i = 0, _len = itemIds.length; _i < _len; _i++){
                            itemId = itemIds[_i];
                            item = this._data.get(itemId);
                            if (item != null && (!filter || filter(item))) items.push(item);
                        }
                    }
                    // order the results
                    if (options && options.order && id == undefined) this._sort(items, options.order);
                    // filter fields of the items
                    if (options && options.fields) {
                        var fields = options.fields;
                        if (id != undefined && item != null) item = this._filterFields(item, fields);
                        else for(var _i2 = 0, _len2 = items.length; _i2 < _len2; _i2++)items[_i2] = this._filterFields(items[_i2], fields);
                    }
                    // return the results
                    if (returnType == "Object") {
                        var result = {};
                        for(var _i3 = 0, _len3 = items.length; _i3 < _len3; _i3++){
                            var resultant = items[_i3];
                            // @TODO: Shoudn't this be this._fieldId?
                            // result[resultant.id] = resultant
                            var _id2 = resultant[this._idProp];
                            result[_id2] = resultant;
                        }
                        return result;
                    } else {
                        if (id != null) {
                            var _item;
                            // a single item
                            return (_item = item) !== null && _item !== void 0 ? _item : null;
                        } else // just return our array
                        return items;
                    }
                }
            },
            {
                key: "getIds",
                value: function getIds(options) {
                    var data = this._data;
                    var filter = options && _filterInstanceProperty(options);
                    var order = options && options.order;
                    var itemIds = _toConsumableArray(_keysInstanceProperty(data).call(data));
                    var ids = [];
                    if (filter) {
                        // get filtered items
                        if (order) {
                            // create ordered list
                            var items = [];
                            for(var i = 0, len = itemIds.length; i < len; i++){
                                var id = itemIds[i];
                                var item = this._data.get(id);
                                if (item != null && filter(item)) items.push(item);
                            }
                            this._sort(items, order);
                            for(var _i4 = 0, _len4 = items.length; _i4 < _len4; _i4++)ids.push(items[_i4][this._idProp]);
                        } else // create unordered list
                        for(var _i5 = 0, _len5 = itemIds.length; _i5 < _len5; _i5++){
                            var _id3 = itemIds[_i5];
                            var _item2 = this._data.get(_id3);
                            if (_item2 != null && filter(_item2)) ids.push(_item2[this._idProp]);
                        }
                    } else {
                        // get all items
                        if (order) {
                            // create an ordered list
                            var _items = [];
                            for(var _i6 = 0, _len6 = itemIds.length; _i6 < _len6; _i6++){
                                var _id4 = itemIds[_i6];
                                _items.push(data.get(_id4));
                            }
                            this._sort(_items, order);
                            for(var _i7 = 0, _len7 = _items.length; _i7 < _len7; _i7++)ids.push(_items[_i7][this._idProp]);
                        } else // create unordered list
                        for(var _i8 = 0, _len8 = itemIds.length; _i8 < _len8; _i8++){
                            var _id5 = itemIds[_i8];
                            var _item3 = data.get(_id5);
                            if (_item3 != null) ids.push(_item3[this._idProp]);
                        }
                    }
                    return ids;
                }
            },
            {
                key: "getDataSet",
                value: function getDataSet() {
                    return this;
                }
            },
            {
                key: "forEach",
                value: function forEach(callback, options) {
                    var filter = options && _filterInstanceProperty(options);
                    var data = this._data;
                    var itemIds = _toConsumableArray(_keysInstanceProperty(data).call(data));
                    if (options && options.order) {
                        // execute forEach on ordered list
                        var items = this.get(options);
                        for(var i = 0, len = items.length; i < len; i++){
                            var item = items[i];
                            var id = item[this._idProp];
                            callback(item, id);
                        }
                    } else // unordered
                    for(var _i9 = 0, _len9 = itemIds.length; _i9 < _len9; _i9++){
                        var _id6 = itemIds[_i9];
                        var _item4 = this._data.get(_id6);
                        if (_item4 != null && (!filter || filter(_item4))) callback(_item4, _id6);
                    }
                }
            },
            {
                key: "map",
                value: function map(callback, options) {
                    var filter = options && _filterInstanceProperty(options);
                    var mappedItems = [];
                    var data = this._data;
                    var itemIds = _toConsumableArray(_keysInstanceProperty(data).call(data));
                    // convert and filter items
                    for(var i = 0, len = itemIds.length; i < len; i++){
                        var id = itemIds[i];
                        var item = this._data.get(id);
                        if (item != null && (!filter || filter(item))) mappedItems.push(callback(item, id));
                    }
                    // order items
                    if (options && options.order) this._sort(mappedItems, options.order);
                    return mappedItems;
                }
            },
            {
                key: "_filterFields",
                value: function _filterFields(item, fields) {
                    var _context3;
                    if (!item) // item is null
                    return item;
                    return _reduceInstanceProperty(_context3 = _Array$isArray(fields) ? // Use the supplied array
                    fields : // Use the keys of the supplied object
                    _Object$keys(fields)).call(_context3, function(filteredItem, field) {
                        filteredItem[field] = item[field];
                        return filteredItem;
                    }, {});
                }
            },
            {
                key: "_sort",
                value: function _sort(items, order) {
                    if (typeof order === "string") {
                        // order by provided field name
                        var name = order; // field name
                        _sortInstanceProperty(items).call(items, function(a, b) {
                            // @TODO: How to treat missing properties?
                            var av = a[name];
                            var bv = b[name];
                            return av > bv ? 1 : av < bv ? -1 : 0;
                        });
                    } else if (typeof order === "function") // order by sort function
                    _sortInstanceProperty(items).call(items, order);
                    else // TODO: extend order by an Object {field:string, direction:string}
                    //       where direction can be 'asc' or 'desc'
                    throw new TypeError("Order must be a function or a string");
                }
            },
            {
                key: "remove",
                value: function remove(id, senderId) {
                    var removedIds = [];
                    var removedItems = [];
                    // force everything to be an array for simplicity
                    var ids = _Array$isArray(id) ? id : [
                        id
                    ];
                    for(var i = 0, len = ids.length; i < len; i++){
                        var item = this._remove(ids[i]);
                        if (item) {
                            var itemId = item[this._idProp];
                            if (itemId != null) {
                                removedIds.push(itemId);
                                removedItems.push(item);
                            }
                        }
                    }
                    if (removedIds.length) this._trigger("remove", {
                        items: removedIds,
                        oldData: removedItems
                    }, senderId);
                    return removedIds;
                }
            },
            {
                key: "_remove",
                value: function _remove(id) {
                    // @TODO: It origianlly returned the item although the docs say id.
                    // The code expects the item, so probably an error in the docs.
                    var ident;
                    // confirm the id to use based on the args type
                    if (isId(id)) ident = id;
                    else if (id && typeof id === "object") ident = id[this._idProp]; // look for the identifier field using ._idProp
                    // do the removing if the item is found
                    if (ident != null && this._data.has(ident)) {
                        var item = this._data.get(ident) || null;
                        this._data.delete(ident);
                        --this.length;
                        return item;
                    }
                    return null;
                }
            },
            {
                key: "clear",
                value: function clear(senderId) {
                    var _context4;
                    var ids = _toConsumableArray(_keysInstanceProperty(_context4 = this._data).call(_context4));
                    var items = [];
                    for(var i = 0, len = ids.length; i < len; i++)items.push(this._data.get(ids[i]));
                    this._data.clear();
                    this.length = 0;
                    this._trigger("remove", {
                        items: ids,
                        oldData: items
                    }, senderId);
                    return ids;
                }
            },
            {
                key: "max",
                value: function max(field) {
                    var _context5;
                    var max = null;
                    var maxField = null;
                    var _iterator = _createForOfIteratorHelper$1(_valuesInstanceProperty(_context5 = this._data).call(_context5)), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var item = _step.value;
                            var itemField = item[field];
                            if (typeof itemField === "number" && (maxField == null || itemField > maxField)) {
                                max = item;
                                maxField = itemField;
                            }
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    return max || null;
                }
            },
            {
                key: "min",
                value: function min(field) {
                    var _context6;
                    var min = null;
                    var minField = null;
                    var _iterator2 = _createForOfIteratorHelper$1(_valuesInstanceProperty(_context6 = this._data).call(_context6)), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var item = _step2.value;
                            var itemField = item[field];
                            if (typeof itemField === "number" && (minField == null || itemField < minField)) {
                                min = item;
                                minField = itemField;
                            }
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    return min || null;
                }
            },
            {
                key: "distinct",
                value: function distinct(prop) {
                    var data = this._data;
                    var itemIds = _toConsumableArray(_keysInstanceProperty(data).call(data));
                    var values = [];
                    var count = 0;
                    for(var i = 0, len = itemIds.length; i < len; i++){
                        var id = itemIds[i];
                        var item = data.get(id);
                        var value = item[prop];
                        var exists = false;
                        for(var j = 0; j < count; j++)if (values[j] == value) {
                            exists = true;
                            break;
                        }
                        if (!exists && value !== undefined) {
                            values[count] = value;
                            count++;
                        }
                    }
                    return values;
                }
            },
            {
                key: "_addItem",
                value: function _addItem(item) {
                    var fullItem = ensureFullItem(item, this._idProp);
                    var id = fullItem[this._idProp];
                    // check whether this id is already taken
                    if (this._data.has(id)) // item already exists
                    throw new Error("Cannot add item: item with id " + id + " already exists");
                    this._data.set(id, fullItem);
                    ++this.length;
                    return id;
                }
            },
            {
                key: "_updateItem",
                value: function _updateItem(update) {
                    var id = update[this._idProp];
                    if (id == null) throw new Error("Cannot update item: item has no id (item: " + _JSON$stringify(update) + ")");
                    var item = this._data.get(id);
                    if (!item) // item doesn't exist
                    throw new Error("Cannot update item: no item with id " + id + " found");
                    this._data.set(id, _objectSpread(_objectSpread({}, item), update));
                    return id;
                }
            },
            {
                key: "stream",
                value: function stream(ids) {
                    if (ids) {
                        var data = this._data;
                        return new DataStream({
                            [_Symbol$iterator] () {
                                return /*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
                                    var _iterator3, _step3, id, item;
                                    return _regeneratorRuntime.wrap(function _callee$(_context7) {
                                        while(true)switch(_context7.prev = _context7.next){
                                            case 0:
                                                _iterator3 = _createForOfIteratorHelper$1(ids);
                                                _context7.prev = 1;
                                                _iterator3.s();
                                            case 3:
                                                if ((_step3 = _iterator3.n()).done) {
                                                    _context7.next = 11;
                                                    break;
                                                }
                                                id = _step3.value;
                                                item = data.get(id);
                                                if (!(item != null)) {
                                                    _context7.next = 9;
                                                    break;
                                                }
                                                _context7.next = 9;
                                                return [
                                                    id,
                                                    item
                                                ];
                                            case 9:
                                                _context7.next = 3;
                                                break;
                                            case 11:
                                                _context7.next = 16;
                                                break;
                                            case 13:
                                                _context7.prev = 13;
                                                _context7.t0 = _context7["catch"](1);
                                                _iterator3.e(_context7.t0);
                                            case 16:
                                                _context7.prev = 16;
                                                _iterator3.f();
                                                return _context7.finish(16);
                                            case 19:
                                            case "end":
                                                return _context7.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            1,
                                            13,
                                            16,
                                            19
                                        ]
                                    ]);
                                })();
                            }
                        });
                    } else {
                        var _context8;
                        return new DataStream({
                            [_Symbol$iterator]: _bindInstanceProperty$1(_context8 = _entriesInstanceProperty(this._data)).call(_context8, this._data)
                        });
                    }
                }
            }
        ]);
        return DataSet;
    }(DataSetPart);
    function _createForOfIteratorHelper(o, allowArrayLike) {
        var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
        if (!it) {
            if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;
                var F = function F() {};
                return {
                    s: F,
                    n: function n() {
                        if (i >= o.length) return {
                            done: true
                        };
                        return {
                            done: false,
                            value: o[i++]
                        };
                    },
                    e: function e(_e) {
                        throw _e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var normalCompletion = true, didErr = false, err;
        return {
            s: function s() {
                it = it.call(o);
            },
            n: function n() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
            },
            e: function e(_e2) {
                didErr = true;
                err = _e2;
            },
            f: function f() {
                try {
                    if (!normalCompletion && it.return != null) it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    function _unsupportedIterableToArray(o, minLen) {
        var _context5;
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = _sliceInstanceProperty(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return _Array$from$1(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = _Reflect$construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
        if (_Reflect$construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * DataView
   *
   * A DataView offers a filtered and/or formatted view on a DataSet. One can subscribe to changes in a DataView, and easily get filtered or formatted data without having to specify filters and field types all the time.
   *
   * ## Example
   * ```javascript
   * // create a DataSet
   * var data = new vis.DataSet();
   * data.add([
   *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
   *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
   *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
   *   {id: 4, text: 'item 4'}
   * ]);
   *
   * // create a DataView
   * // the view will only contain items having a property group with value 1,
   * // and will only output fields id, text, and date.
   * var view = new vis.DataView(data, {
   *   filter: function (item) {
   *     return (item.group == 1);
   *   },
   *   fields: ['id', 'text', 'date']
   * });
   *
   * // subscribe to any change in the DataView
   * view.on('*', function (event, properties, senderId) {
   *   console.log('event', event, properties);
   * });
   *
   * // update an item in the data set
   * data.update({id: 2, group: 1});
   *
   * // get all ids in the view
   * var ids = view.getIds();
   * console.log('ids', ids); // will output [1, 2]
   *
   * // get all items in the view
   * var items = view.get();
   * ```
   *
   * @typeParam Item - Item type that may or may not have an id.
   * @typeParam IdProp - Name of the property that contains the id.
   */ var DataView = /*#__PURE__*/ function(_DataSetPart) {
        _inherits(DataView, _DataSetPart);
        var _super = _createSuper(DataView);
        // ids of the items currently in memory (just contains a boolean true)
        /**
     * Create a DataView.
     *
     * @param data - The instance containing data (directly or indirectly).
     * @param options - Options to configure this data view.
     */ function DataView(data, options) {
            var _context;
            var _this;
            _classCallCheck(this, DataView);
            _this = _super.call(this);
            /** @inheritDoc */ _defineProperty(_assertThisInitialized(_this), "length", 0);
            // constructor → setData
            _defineProperty(_assertThisInitialized(_this), "_ids", new _Set());
            _this._options = options || {};
            _this._listener = _bindInstanceProperty$1(_context = _this._onEvent).call(_context, _assertThisInitialized(_this));
            _this.setData(data);
            return _this;
        }
        // TODO: implement a function .config() to dynamically update things like configured filter
        // and trigger changes accordingly
        /**
     * Set a data source for the view.
     *
     * @param data - The instance containing data (directly or indirectly).
     * @remarks
     * Note that when the data view is bound to a data set it won't be garbage
     * collected unless the data set is too. Use `dataView.setData(null)` or
     * `dataView.dispose()` to enable garbage collection before you lose the last
     * reference.
     */ _createClass(DataView, [
            {
                key: "idProp",
                get: /** @inheritDoc */ function get() {
                    return this.getDataSet().idProp;
                }
            },
            {
                key: "setData",
                value: function setData(data) {
                    if (this._data) {
                        // unsubscribe from current dataset
                        if (this._data.off) this._data.off("*", this._listener);
                        // trigger a remove of all items in memory
                        var ids = this._data.getIds({
                            filter: _filterInstanceProperty(this._options)
                        });
                        var items = this._data.get(ids);
                        this._ids.clear();
                        this.length = 0;
                        this._trigger("remove", {
                            items: ids,
                            oldData: items
                        });
                    }
                    if (data != null) {
                        this._data = data;
                        // trigger an add of all added items
                        var _ids = this._data.getIds({
                            filter: _filterInstanceProperty(this._options)
                        });
                        for(var i = 0, len = _ids.length; i < len; i++){
                            var id = _ids[i];
                            this._ids.add(id);
                        }
                        this.length = _ids.length;
                        this._trigger("add", {
                            items: _ids
                        });
                    } else this._data = new DataSet();
                    // subscribe to new dataset
                    if (this._data.on) this._data.on("*", this._listener);
                }
            },
            {
                key: "refresh",
                value: function refresh() {
                    var ids = this._data.getIds({
                        filter: _filterInstanceProperty(this._options)
                    });
                    var oldIds = _toConsumableArray(this._ids);
                    var newIds = {};
                    var addedIds = [];
                    var removedIds = [];
                    var removedItems = [];
                    // check for additions
                    for(var i = 0, len = ids.length; i < len; i++){
                        var id = ids[i];
                        newIds[id] = true;
                        if (!this._ids.has(id)) {
                            addedIds.push(id);
                            this._ids.add(id);
                        }
                    }
                    // check for removals
                    for(var _i = 0, _len = oldIds.length; _i < _len; _i++){
                        var _id = oldIds[_i];
                        var item = this._data.get(_id);
                        if (item == null) // @TODO: Investigate.
                        // Doesn't happen during tests or examples.
                        // Is it really impossible or could it eventually happen?
                        // How to handle it if it does? The types guarantee non-nullable items.
                        console.error("If you see this, report it please.");
                        else if (!newIds[_id]) {
                            removedIds.push(_id);
                            removedItems.push(item);
                            this._ids.delete(_id);
                        }
                    }
                    this.length += addedIds.length - removedIds.length;
                    // trigger events
                    if (addedIds.length) this._trigger("add", {
                        items: addedIds
                    });
                    if (removedIds.length) this._trigger("remove", {
                        items: removedIds,
                        oldData: removedItems
                    });
                }
            },
            {
                key: "get",
                value: function get(first, second) {
                    if (this._data == null) return null;
                    // parse the arguments
                    var ids = null;
                    var options;
                    if (isId(first) || _Array$isArray(first)) {
                        ids = first;
                        options = second;
                    } else options = first;
                    // extend the options with the default options and provided options
                    var viewOptions = _Object$assign({}, this._options, options);
                    // create a combined filter method when needed
                    var thisFilter = _filterInstanceProperty(this._options);
                    var optionsFilter = options && _filterInstanceProperty(options);
                    if (thisFilter && optionsFilter) viewOptions.filter = function(item) {
                        return thisFilter(item) && optionsFilter(item);
                    };
                    if (ids == null) return this._data.get(viewOptions);
                    else return this._data.get(ids, viewOptions);
                }
            },
            {
                key: "getIds",
                value: function getIds(options) {
                    if (this._data.length) {
                        var defaultFilter = _filterInstanceProperty(this._options);
                        var optionsFilter = options != null ? _filterInstanceProperty(options) : null;
                        var filter;
                        if (optionsFilter) {
                            if (defaultFilter) filter = function filter(item) {
                                return defaultFilter(item) && optionsFilter(item);
                            };
                            else filter = optionsFilter;
                        } else filter = defaultFilter;
                        return this._data.getIds({
                            filter: filter,
                            order: options && options.order
                        });
                    } else return [];
                }
            },
            {
                key: "forEach",
                value: function forEach(callback, options) {
                    if (this._data) {
                        var _context2;
                        var defaultFilter = _filterInstanceProperty(this._options);
                        var optionsFilter = options && _filterInstanceProperty(options);
                        var filter;
                        if (optionsFilter) {
                            if (defaultFilter) filter = function filter(item) {
                                return defaultFilter(item) && optionsFilter(item);
                            };
                            else filter = optionsFilter;
                        } else filter = defaultFilter;
                        _forEachInstanceProperty(_context2 = this._data).call(_context2, callback, {
                            filter: filter,
                            order: options && options.order
                        });
                    }
                }
            },
            {
                key: "map",
                value: function map(callback, options) {
                    if (this._data) {
                        var _context3;
                        var defaultFilter = _filterInstanceProperty(this._options);
                        var optionsFilter = options && _filterInstanceProperty(options);
                        var filter;
                        if (optionsFilter) {
                            if (defaultFilter) filter = function filter(item) {
                                return defaultFilter(item) && optionsFilter(item);
                            };
                            else filter = optionsFilter;
                        } else filter = defaultFilter;
                        return _mapInstanceProperty(_context3 = this._data).call(_context3, callback, {
                            filter: filter,
                            order: options && options.order
                        });
                    } else return [];
                }
            },
            {
                key: "getDataSet",
                value: function getDataSet() {
                    return this._data.getDataSet();
                }
            },
            {
                key: "stream",
                value: function stream(ids) {
                    var _context4;
                    return this._data.stream(ids || {
                        [_Symbol$iterator]: _bindInstanceProperty$1(_context4 = _keysInstanceProperty(this._ids)).call(_context4, this._ids)
                    });
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    var _this$_data;
                    if ((_this$_data = this._data) !== null && _this$_data !== void 0 && _this$_data.off) this._data.off("*", this._listener);
                    var message = "This data view has already been disposed of.";
                    var replacement = {
                        get: function get() {
                            throw new Error(message);
                        },
                        set: function set() {
                            throw new Error(message);
                        },
                        configurable: false
                    };
                    var _iterator = _createForOfIteratorHelper(_Reflect$ownKeys(DataView.prototype)), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var key = _step.value;
                            _Object$defineProperty(this, key, replacement);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            },
            {
                key: "_onEvent",
                value: function _onEvent(event, params, senderId) {
                    if (!params || !params.items || !this._data) return;
                    var ids = params.items;
                    var addedIds = [];
                    var updatedIds = [];
                    var removedIds = [];
                    var oldItems = [];
                    var updatedItems = [];
                    var removedItems = [];
                    switch(event){
                        case "add":
                            // filter the ids of the added items
                            for(var i = 0, len = ids.length; i < len; i++){
                                var id = ids[i];
                                var item = this.get(id);
                                if (item) {
                                    this._ids.add(id);
                                    addedIds.push(id);
                                }
                            }
                            break;
                        case "update":
                            // determine the event from the views viewpoint: an updated
                            // item can be added, updated, or removed from this view.
                            for(var _i2 = 0, _len2 = ids.length; _i2 < _len2; _i2++){
                                var _id2 = ids[_i2];
                                var _item = this.get(_id2);
                                if (_item) {
                                    if (this._ids.has(_id2)) {
                                        updatedIds.push(_id2);
                                        updatedItems.push(params.data[_i2]);
                                        oldItems.push(params.oldData[_i2]);
                                    } else {
                                        this._ids.add(_id2);
                                        addedIds.push(_id2);
                                    }
                                } else if (this._ids.has(_id2)) {
                                    this._ids.delete(_id2);
                                    removedIds.push(_id2);
                                    removedItems.push(params.oldData[_i2]);
                                }
                            }
                            break;
                        case "remove":
                            // filter the ids of the removed items
                            for(var _i3 = 0, _len3 = ids.length; _i3 < _len3; _i3++){
                                var _id3 = ids[_i3];
                                if (this._ids.has(_id3)) {
                                    this._ids.delete(_id3);
                                    removedIds.push(_id3);
                                    removedItems.push(params.oldData[_i3]);
                                }
                            }
                            break;
                    }
                    this.length += addedIds.length - removedIds.length;
                    if (addedIds.length) this._trigger("add", {
                        items: addedIds
                    }, senderId);
                    if (updatedIds.length) this._trigger("update", {
                        items: updatedIds,
                        oldData: oldItems,
                        data: updatedItems
                    }, senderId);
                    if (removedIds.length) this._trigger("remove", {
                        items: removedIds,
                        oldData: removedItems
                    }, senderId);
                }
            }
        ]);
        return DataView;
    }(DataSetPart);
    /**
   * Check that given value is compatible with Vis Data Set interface.
   *
   * @param idProp - The expected property to contain item id.
   * @param v - The value to be tested.
   * @returns True if all expected values and methods match, false otherwise.
   */ function isDataSetLike(idProp, v) {
        return typeof v === "object" && v !== null && idProp === v.idProp && typeof v.add === "function" && typeof v.clear === "function" && typeof v.distinct === "function" && typeof _forEachInstanceProperty(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof _mapInstanceProperty(v) === "function" && typeof v.max === "function" && typeof v.min === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.remove === "function" && typeof v.setOptions === "function" && typeof v.stream === "function" && typeof v.update === "function" && typeof v.updateOnly === "function";
    }
    /**
   * Check that given value is compatible with Vis Data View interface.
   *
   * @param idProp - The expected property to contain item id.
   * @param v - The value to be tested.
   * @returns True if all expected values and methods match, false otherwise.
   */ function isDataViewLike(idProp, v) {
        return typeof v === "object" && v !== null && idProp === v.idProp && typeof _forEachInstanceProperty(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof _mapInstanceProperty(v) === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.stream === "function" && isDataSetLike(idProp, v.getDataSet());
    }
    exports1.DELETE = DELETE;
    exports1.DataSet = DataSet;
    exports1.DataStream = DataStream;
    exports1.DataView = DataView;
    exports1.Queue = Queue;
    exports1.createNewDataPipeFrom = createNewDataPipeFrom;
    exports1.isDataSetLike = isDataSetLike;
    exports1.isDataViewLike = isDataViewLike;
});

},{}],"13BOJ":[function() {},{}],"BHFWK":[function() {},{}],"afvNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialStages", ()=>initialStages);
var _types = require("common/types");
const initialStages = [
    {
        stage: 'request',
        displayName: 'Request',
        status: 'done'
    },
    {
        stage: 'scte35',
        displayName: 'SCTE 35 cue received',
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).scte35Notification,
                method: (0, _types.AdAuditMethod).receive,
                status: (0, _types.AdAuditStatus).finish
            }
        ]
    },
    {
        stage: 'got-vast',
        displayName: 'VAST received',
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).vast,
                method: (0, _types.AdAuditMethod).parse,
                status: (0, _types.AdAuditStatus).finish
            }
        ]
    },
    {
        stage: 'download',
        displayName: 'Download mezzanine',
        progressCriteria: [
            {
                entity: (0, _types.AdAuditEntity).mezzanineFile,
                method: (0, _types.AdAuditMethod).download,
                status: (0, _types.AdAuditStatus).start
            }
        ],
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).mezzanineFile,
                method: (0, _types.AdAuditMethod).download,
                status: (0, _types.AdAuditStatus).finish
            }
        ]
    },
    {
        stage: 'upload-mezzanine',
        displayName: 'Cache mezzanine',
        progressCriteria: [
            {
                entity: (0, _types.AdAuditEntity).mezzanineFile,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).start
            }
        ],
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).mezzanineFile,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).finish
            }
        ],
        previousStage: 'download'
    },
    {
        stage: 'transcode',
        displayName: 'Transcode',
        progressCriteria: [
            {
                entity: (0, _types.AdAuditEntity).transcodedFile,
                method: (0, _types.AdAuditMethod).transcode,
                status: (0, _types.AdAuditStatus).start
            }
        ],
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).transcodedFile,
                method: (0, _types.AdAuditMethod).transcode,
                status: (0, _types.AdAuditStatus).finish
            }
        ],
        previousStage: 'download'
    },
    {
        stage: 'upload-transcoded',
        displayName: 'Cache ad',
        progressCriteria: [
            {
                entity: (0, _types.AdAuditEntity).transcodedFile,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).start
            }
        ],
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).transcodedFile,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).finish
            }
        ],
        previousStage: 'transcode'
    },
    // FIXME: Add these when they are added to the ad audit log
    // { stage: 'available-on-node', displayName: 'Available on node', doneCriteria: [] },
    // { stage: 'break-start', displayName: 'Ad break start', doneCriteria: [], hideTime: true },
    {
        stage: 'impression',
        displayName: 'Report: Impression',
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).impressionReport,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).finish,
                entityName: 'impression'
            }
        ],
        hideTime: true
    },
    {
        stage: 'start',
        displayName: 'Report: 0/4',
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).impressionReport,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).finish,
                entityName: 'start'
            }
        ],
        hideTime: true
    },
    {
        stage: 'first-quartile',
        displayName: 'Report: 1/4',
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).impressionReport,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).finish,
                entityName: 'firstQuartile'
            }
        ],
        hideTime: true
    },
    {
        stage: 'second-quartile',
        displayName: 'Report: 2/4',
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).impressionReport,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).finish,
                entityName: 'midpoint'
            }
        ],
        hideTime: true
    },
    {
        stage: 'third-quartile',
        displayName: 'Report: 3/4',
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).impressionReport,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).finish,
                entityName: 'thirdQuartile'
            }
        ],
        hideTime: true
    },
    {
        stage: 'finish',
        displayName: 'Report: 4/4',
        doneCriteria: [
            {
                entity: (0, _types.AdAuditEntity).impressionReport,
                method: (0, _types.AdAuditMethod).upload,
                status: (0, _types.AdAuditStatus).finish,
                entityName: 'complete'
            }
        ],
        hideTime: true
    }
];

},{"common/types":"gDFnw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iRVQV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ArcadeButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
function ArcadeButton({ onClick, size = 120, triggerExternalAnimation, disabled = false }) {
    const [isAnimating, setIsAnimating] = (0, _react.useState)(false);
    const triggerAnimation = ()=>{
        setIsAnimating(true);
    };
    (0, _react.useEffect)(()=>{
        if (isAnimating) {
            const timer = setTimeout(()=>{
                setIsAnimating(false);
            }, 200);
            return ()=>clearTimeout(timer);
        }
    }, [
        isAnimating
    ]);
    (0, _react.useEffect)(()=>{
        if (triggerExternalAnimation) triggerExternalAnimation(triggerAnimation);
    }, [
        triggerExternalAnimation
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        onClick: onClick,
        onMouseDown: triggerAnimation,
        disabled: disabled,
        sx: {
            width: size,
            height: size,
            borderRadius: '50%',
            background: disabled ? '#212531' : isAnimating ? 'radial-gradient(circle, #ff4d4d 0%, #cc0000 100%)' : 'radial-gradient(circle, #ff0000 0%, #990000 100%)',
            color: 'white',
            fontSize: size / 6,
            fontWeight: 'bold',
            boxShadow: disabled ? 'none' : isAnimating ? '0px 7px 20px rgba(255, 0, 0, 0.9)' : '0px 5px 15px rgba(255, 0, 0, 0.7)',
            transform: isAnimating ? 'scale(1.1)' : 'none',
            transition: 'transform 0.1s, box-shadow 0.1s',
            '&:hover': {
                background: disabled ? '#212531' : 'radial-gradient(circle, #ff4d4d 0%, #cc0000 100%)',
                transform: disabled ? 'none' : 'scale(1.1)',
                boxShadow: disabled ? 'none' : '0px 7px 20px rgba(255, 0, 0, 0.9)'
            },
            '&:active': {
                transform: disabled ? 'none' : 'scale(0.95)'
            }
        },
        children: "INSERT AD"
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Button":"3qJY9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6yWKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "triggerAdBreak", ()=>triggerAdBreak);
var _toolkit = require("@reduxjs/toolkit");
var _notificationActions = require("./notificationActions");
const triggerAdBreak = (0, _toolkit.createAsyncThunk)('audit/getAdAudit', async (params, { dispatch, extra: { api } })=>{
    try {
        return await api.adInsertionDemoApi.triggerAdBreak(params);
    } catch (err) {
        dispatch((0, _notificationActions.enqueueErrorSnackbar)({
            error: err,
            operation: 'trigger ad break'
        }));
        throw err;
    }
});

},{"@reduxjs/toolkit":"8ces8","./notificationActions":"7LkQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgVg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdAuditLog", ()=>AdAuditLog);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("../../utils");
var _wrapper = require("../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _react = require("react");
var _reactRedux = require("react-redux");
var _util = require("common/util");
var _dateFns = require("date-fns");
var _table = require("../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _missingContent = require("../common/MissingContent");
var _adAuditActions = require("../../redux/actions/adAuditActions");
var _helpers = require("common/api/v1/helpers");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _filteredSearchBar = require("../common/Filters/FilterView/FilteredSearchBar");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _adAuditLogFilter = require("./demo/adAuditLogFilter");
var _form = require("../common/Form");
const AdAuditLog = ()=>{
    const [pageParams] = (0, _utils.usePageParams)();
    const { fromDate, toDate } = pageParams;
    const minDate = fromDate ? new Date(fromDate) : new Date('2025-01-01');
    const maxDate = toDate ? new Date(toDate) : new Date();
    const validDateRange = (0, _dateFns.compareAsc)(minDate, maxDate) === -1;
    const dispatch = (0, _reactRedux.useDispatch)();
    const refreshAdAuditLogs = async ()=>{
        dispatch((0, _adAuditActions.getAdAudit)(pageParams));
    };
    (0, _react.useEffect)(()=>{
        refreshAdAuditLogs();
    }, [
        pageParams
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
        name: [
            'Ad Insertion',
            'Ad Audit Log'
        ],
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdAuditListFilter, {}),
            validDateRange ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdAuditListTable, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
                    lg: 12,
                    xl: 12,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h2",
                        margin: 'auto',
                        children: "Invalid date range"
                    })
                })
            })
        ]
    });
};
const AdAuditListFilter = ()=>{
    const filters = (0, _adAuditLogFilter.makeAdAuditLogFilters)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
            disableGutters: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flexShrink: 1,
                    flexGrow: 1
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                    urlParamCacheKey: 'adAuditLog',
                    mapUrlParamToFilterFn: (0, _adAuditLogFilter.mapUrlParamToAdAuditLogFilter),
                    mapFilterToUrlParamFn: (0, _adAuditLogFilter.mapAdAuditLogFilterToUrlParam),
                    searchTokenFilters: filters,
                    rawTextFilter: filters.find((f)=>f.key === (0, _adAuditLogFilter.AdAuditLogFilterKey).any)
                })
            })
        })
    });
};
const AdAuditListTable = ()=>{
    const { adAudit, total, loading } = (0, _reactRedux.useSelector)(({ adAuditReducer })=>({
            adAudit: adAuditReducer.adAudit,
            total: adAuditReducer.total,
            loading: adAuditReducer.loading
        }), (0, _util.equals));
    const [pageParams] = (0, _utils.usePageParams)();
    const { pageNumber } = pageParams;
    const formatEntity = (entity)=>{
        try {
            return JSON.stringify(JSON.parse(entity), null, 2);
        } catch (_) {
            return entity;
        }
    };
    const tableConfig = [
        {
            title: 'Entity Type',
            getValue: ({ entityType })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    flex: 1,
                    gap: '12px',
                    children: entityType
                }),
            props: {
                padding: 'normal'
            }
        },
        {
            title: 'method',
            getValue: ({ method })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: method
                })
        },
        {
            title: 'status',
            getValue: ({ status })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: status
                })
        },
        {
            title: 'result',
            getValue: ({ result })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: result
                })
        },
        {
            title: 'entity',
            getValue: ({ entity })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                    style: {
                        fontSize: '.85rem'
                    },
                    children: formatEntity(entity)
                })
        },
        {
            title: 'component',
            getValue: ({ component })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: component
                })
        },
        {
            title: 'entity name',
            getValue: ({ entityName })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: entityName
                })
        },
        {
            title: 'entity id',
            getValue: ({ entityId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: entityId
                })
        },
        {
            title: 'message',
            getValue: ({ message })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: message
                })
        },
        {
            title: 'event id',
            getValue: ({ eventId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: eventId
                })
        },
        {
            title: 'output id',
            getValue: ({ outputId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: outputId
                })
        },
        {
            title: 'stream id',
            getValue: ({ streamId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: streamId
                })
        },
        {
            title: 'channel id',
            getValue: ({ channelId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: channelId
                })
        },
        {
            title: 'pod',
            getValue: ({ pod })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: pod
                })
        },
        {
            title: 'source',
            getValue: ({ source })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: source
                })
        },
        {
            title: 'target',
            getValue: ({ target })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: target
                })
        },
        {
            title: 'trace id',
            getValue: ({ traceId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: traceId
                })
        },
        {
            title: 'time',
            getValue: ({ timestamp })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    whiteSpace: 'nowrap',
                    children: timestamp ? (0, _dateFns.format)(timestamp, (0, _helpers.DATE_FORMAT_LONGER)) : null
                }),
            props: {
                padding: 'normal'
            }
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
        emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
            message: "No logs available for the interval"
        }),
        config: tableConfig,
        data: adAudit.map((item, idx)=>({
                ...item,
                id: `${pageNumber || 0}_${idx}`
            })),
        pending: loading,
        pagination: {
            total,
            useUrlSearchParams: true
        },
        isSmall: true
    });
};

},{"react/jsx-runtime":"1dlk8","../../utils":"342UB","../common/Wrapper":"8oy7r","react":"9njXz","react-redux":"l1pMU","common/util":"jV4UZ","date-fns":"gelMX","../common/Table":"dt9lf","../common/MissingContent":"1LBl6","../../redux/actions/adAuditActions":"ddShH","common/api/v1/helpers":"6jovr","@mui/material/Typography":"6NtGx","../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@mui/material/Toolbar":"5Kohb","./demo/adAuditLogFilter":"jogr7","../common/Form":"4Mui7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jogr7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdAuditLogFilterKey", ()=>AdAuditLogFilterKey);
parcelHelpers.export(exports, "mapAdAuditLogFilterToUrlParam", ()=>mapAdAuditLogFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToAdAuditLogFilter", ()=>mapUrlParamToAdAuditLogFilter);
parcelHelpers.export(exports, "makeAdAuditLogFilters", ()=>makeAdAuditLogFilters);
var _types = require("common/types");
var _dateFilter = require("../../../components/common/Filters/FilterView/dateFilter");
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var AdAuditLogFilterKey = /*#__PURE__*/ function(AdAuditLogFilterKey) {
    AdAuditLogFilterKey["any"] = "any";
    AdAuditLogFilterKey["timestamp"] = "timestamp";
    AdAuditLogFilterKey["entityType"] = "entity type";
    AdAuditLogFilterKey["method"] = "method";
    AdAuditLogFilterKey["status"] = "status";
    AdAuditLogFilterKey["result"] = "result";
    AdAuditLogFilterKey["eventId"] = "event id";
    AdAuditLogFilterKey["outputId"] = "output id";
    AdAuditLogFilterKey["streamId"] = "stream id";
    AdAuditLogFilterKey["channelId"] = "channel id";
    AdAuditLogFilterKey["component"] = "component";
    AdAuditLogFilterKey["pod"] = "pod";
    AdAuditLogFilterKey["entity"] = "entity";
    AdAuditLogFilterKey["entityId"] = "entity id";
    AdAuditLogFilterKey["entityName"] = "entity name";
    AdAuditLogFilterKey["message"] = "message";
    AdAuditLogFilterKey["source"] = "source";
    AdAuditLogFilterKey["target"] = "target";
    AdAuditLogFilterKey["traceId"] = "trace id";
    return AdAuditLogFilterKey;
}({});
function mapAdAuditLogFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "any":
            return {
                filter: filter.value
            };
        case "timestamp":
            return filter.operator === 'after' ? {
                fromDate: new Date(filter.value).toISOString()
            } : {
                toDate: new Date(filter.value).toISOString()
            };
        case "entity type":
            return {
                entityType: filter.value
            };
        case "method":
            return {
                method: filter.value
            };
        case "status":
            return {
                status: filter.value
            };
        case "result":
            return {
                result: filter.value
            };
        case "event id":
            return {
                eventId: filter.value
            };
        case "output id":
            return {
                outputId: filter.value
            };
        case "stream id":
            return {
                streamId: filter.value
            };
        case "channel id":
            return {
                channelId: filter.value
            };
        case "component":
            return {
                component: filter.value
            };
        case "pod":
            return {
                pod: filter.value
            };
        case "entity":
            return {
                entity: filter.value
            };
        case "entity id":
            return {
                entityId: filter.value
            };
        case "entity name":
            return {
                entityName: filter.value
            };
        case "message":
            return {
                message: filter.value
            };
        case "source":
            return {
                source: filter.value
            };
        case "target":
            return {
                target: filter.value
            };
        case "trace id":
            return {
                traceId: filter.value
            };
    }
    return {};
}
function mapUrlParamToAdAuditLogFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "any",
                operator: 'matches',
                value
            };
        case 'fromDate':
            return {
                key: "timestamp",
                operator: 'after',
                value: (0, _dateFns.format)(new Date(value), (0, _helpers.DATE_FORMAT_LONGER))
            };
        case 'toDate':
            return {
                key: "timestamp",
                operator: 'before',
                value: (0, _dateFns.format)(new Date(value), (0, _helpers.DATE_FORMAT_LONGER))
            };
        case 'entityType':
            return {
                key: "entity type",
                operator: 'is',
                value
            };
        case 'method':
            return {
                key: "method",
                operator: 'is',
                value
            };
        case 'status':
            return {
                key: "status",
                operator: 'is',
                value
            };
        case 'result':
            return {
                key: "result",
                operator: 'is',
                value
            };
        case 'eventId':
            return {
                key: "event id",
                operator: 'matches',
                value
            };
        case 'outputId':
            return {
                key: "output id",
                operator: 'matches',
                value
            };
        case 'streamId':
            return {
                key: "stream id",
                operator: 'matches',
                value
            };
        case 'channelId':
            return {
                key: "channel id",
                operator: 'matches',
                value
            };
        case 'component':
            return {
                key: "component",
                operator: 'is',
                value
            };
        case 'pod':
            return {
                key: "pod",
                operator: 'matches',
                value
            };
        case 'entity':
            return {
                key: "entity",
                operator: 'matches',
                value
            };
        case 'entityId':
            return {
                key: "entity id",
                operator: 'matches',
                value
            };
        case 'entityName':
            return {
                key: "entity name",
                operator: 'matches',
                value
            };
        case 'message':
            return {
                key: "message",
                operator: 'matches',
                value
            };
        case 'source':
            return {
                key: "source",
                operator: 'matches',
                value
            };
        case 'target':
            return {
                key: "target",
                operator: 'matches',
                value
            };
        case 'traceId':
            return {
                key: "trace id",
                operator: 'matches',
                value
            };
    }
    return undefined;
}
function makeAdAuditLogFilters() {
    const filterTemplates = [
        {
            key: "any",
            operator: 'matches'
        },
        {
            key: "timestamp",
            operator: 'after',
            possibleValuesSync: (s)=>(0, _dateFilter.dateFilterPossibleValues)(s)
        },
        {
            key: "timestamp",
            operator: 'before',
            possibleValuesSync: (s)=>(0, _dateFilter.dateFilterPossibleValues)(s)
        },
        {
            key: "entity type",
            operator: 'is',
            possibleValuesSync: ()=>Object.values((0, _types.AdAuditEntity)).map((v)=>({
                        value: v,
                        displayName: v
                    }))
        },
        {
            key: "method",
            operator: 'is',
            possibleValuesSync: ()=>Object.values((0, _types.AdAuditMethod)).map((v)=>({
                        value: v,
                        displayName: v
                    }))
        },
        {
            key: "status",
            operator: 'is',
            possibleValuesSync: ()=>Object.values((0, _types.AdAuditStatus)).map((v)=>({
                        value: v,
                        displayName: v
                    }))
        },
        {
            key: "result",
            operator: 'matches',
            possibleValuesSync: ()=>Object.values((0, _types.AdAuditResult)).map((v)=>({
                        value: v,
                        displayName: v
                    }))
        },
        {
            key: "event id",
            operator: 'matches'
        },
        {
            key: "output id",
            operator: 'matches'
        },
        {
            key: "stream id",
            operator: 'matches'
        },
        {
            key: "channel id",
            operator: 'matches'
        },
        {
            key: "component",
            operator: 'matches'
        },
        {
            key: "pod",
            operator: 'matches'
        },
        {
            key: "entity",
            operator: 'matches'
        },
        {
            key: "entity id",
            operator: 'matches'
        },
        {
            key: "entity name",
            operator: 'matches'
        },
        {
            key: "message",
            operator: 'matches'
        },
        {
            key: "source",
            operator: 'matches'
        },
        {
            key: "target",
            operator: 'matches'
        },
        {
            key: "trace id",
            operator: 'matches'
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"common/types":"gDFnw","../../../components/common/Filters/FilterView/dateFilter":"dRpLd","date-fns":"gelMX","common/api/v1/helpers":"6jovr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dRpLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateFilterPossibleValues", ()=>dateFilterPossibleValues);
var _helpers = require("common/api/v1/helpers");
var _dateFns = require("date-fns");
const dateFilterPossibleValues = (s)=>{
    let now = new Date();
    now.setMinutes(0, 0, 0);
    now = (0, _dateFns.subDays)(now, 1);
    const options = [];
    let maxValue = 24;
    let stride = 1;
    let dateFormat = (0, _helpers.DATE_FORMAT_LONG);
    let dateAdderFn = (0, _dateFns.addHours);
    if (s) {
        now = new Date(s.replace('T', ' ').replace('Z', ' '));
        if (s.length <= 6) {
            // 2025XXX
            maxValue = 12;
            dateAdderFn = (0, _dateFns.addMonths);
        } else if (s.length >= 7 && s.length <= 9) {
            // 2025-02XXX
            maxValue = 31;
            dateAdderFn = (0, _dateFns.addDays);
        } else if (s.length >= 10 && s.length <= 12) {
            // 2025-02-11XXX
            maxValue = 24;
            dateAdderFn = (0, _dateFns.addHours);
        } else if (s.length >= 13 && s.length <= 15) {
            // 2025-02-11T12XXX
            maxValue = 60;
            stride = 5;
            dateAdderFn = (0, _dateFns.addMinutes);
        } else if (s.length >= 16 && s.length <= 18) {
            // 2025-02-11T12:00XXX
            maxValue = 60;
            stride = 5;
            dateAdderFn = (0, _dateFns.addSeconds);
        } else if (s.length >= 19 && s.length <= 23) {
            // 2025-02-11T12:00:00XXXXX
            maxValue = 1000;
            stride = 100;
            dateFormat = (0, _helpers.DATE_FORMAT_LONGER);
            dateAdderFn = (0, _dateFns.addMilliseconds);
        }
    }
    for(let i = 0; i < maxValue; i += stride){
        const date = dateAdderFn(now, i);
        let displayName = (0, _dateFns.format)(date, dateFormat);
        if (s?.includes('T')) displayName = displayName.replace(' ', 'T');
        if (s?.includes('Z')) displayName = displayName + 'Z';
        options.push({
            value: date.toISOString(),
            displayName
        });
    }
    return options;
};

},{"common/api/v1/helpers":"6jovr","date-fns":"gelMX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ipHzA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditAdCreative", ()=>EditAdCreative);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _types = require("common/api/v1/types");
var _rhf = require("../../../common/Form/RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
var _store = require("../../../../store");
var _wrapper = require("../../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _utils = require("../../../../utils");
var _adCreativeActions = require("../../../../redux/actions/adCreativeActions");
var _form = require("../../../common/Form");
var _util = require("common/util");
var _metadata = require("./Metadata");
var _adPodTable = require("./AdPodTable");
var _adBreakTable = require("./AdBreakTable");
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
const getInitialState = (adCreative)=>({
        id: adCreative?.id || '',
        name: adCreative?.name,
        durationMs: adCreative?.userDurationMs || '',
        adCreative: adCreative
    });
const AdCreativeForm = ({ getValues, setError, setFocus, formState })=>{
    const values = getValues();
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const setConfirmation = (0, _utils.useConfirmationDialog)();
    const user = (0, _utils.useUser)();
    const { formErrors, saving } = (0, _reactRedux.useSelector)(({ adCreativeReducer })=>({
            formErrors: adCreativeReducer.formErrors,
            saving: adCreativeReducer.saving
        }), (0, _reactRedux.shallowEqual));
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach((item)=>{
                setError(item.name, {
                    type: 'manual',
                    message: item.reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    if (values.adCreative && user.role !== (0, _types.Role).super && (user.role !== (0, _types.Role).admin || user.group !== values.adCreative.groupId)) {
        navigate(-1);
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        container: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            size: {
                xs: 12
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                    formState: formState
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                    id: "ad-creative-form",
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Paper), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                    name: "name",
                                    label: "Name",
                                    required: true,
                                    autoFocus: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                    name: "durationMs",
                                    label: "Duration (ms)",
                                    tooltip: "Override the probed duration",
                                    type: "number",
                                    validators: {
                                        number: {
                                            greaterThanOrEqualTo: 0,
                                            message: `Must be greater than or equal to 0`
                                        }
                                    }
                                })
                            ]
                        }),
                        values.adCreative && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _metadata.Metadata), {
                                    adCreative: values.adCreative,
                                    sx: {
                                        mt: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                    direction: 'row',
                                    spacing: 2,
                                    sx: {
                                        mt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adPodTable.AdPodTable), {
                                            adCreative: values.adCreative
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adBreakTable.AdBreakTable), {
                                            adCreative: values.adCreative
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                            main: {
                                Cancel: {
                                    onClick: ()=>navigate(routes.adCreatives())
                                },
                                Save: {
                                    savingState: !!saving,
                                    primary: true,
                                    type: 'submit'
                                }
                            },
                            secondary: user.role === (0, _types.Role).super ? {
                                Delete: {
                                    onClick: ()=>setConfirmation(()=>{
                                            dispatch((0, _adCreativeActions.deleteAdCreative)(values.id));
                                            navigate(routes.adCreatives());
                                        }, 'Are you sure you want to delete this Ad Creative?', values.name)
                                }
                            } : undefined
                        })
                    ]
                })
            ]
        })
    });
};
const EditAdCreative = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        id && dispatch((0, _adCreativeActions.getAdCreative)(id));
        return ()=>{
            dispatch((0, _adCreativeActions.clearAdCreative)());
        };
    }, []);
    const selectedAdCreative = (0, _reactRedux.useSelector)(({ adCreativeReducer })=>adCreativeReducer.selectedAdCreative, (0, _util.equals));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Ad Insertion',
            'Ad Creatives',
            selectedAdCreative?.name
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: !!id && !selectedAdCreative,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rhfDefault.default), {
                onSubmit: (values)=>{
                    const { adCreative, ...update } = values;
                    if (update.durationMs === '') update.durationMs = -1;
                    dispatch((0, _adCreativeActions.updateAdCreative)((0, _utils.formTransform)(update)));
                },
                defaultValues: getInitialState(selectedAdCreative),
                component: AdCreativeForm
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","@mui/material/Grid":"6iX4B","common/api/v1/types":"3qemx","../../../common/Form/RHF":"7gFt3","../../../../store":"5LXiG","../../../common/Wrapper":"8oy7r","../../../common/Pendable":"gDN67","../../../../utils":"342UB","../../../../redux/actions/adCreativeActions":"gzqhz","../../../common/Form":"4Mui7","common/util":"jV4UZ","./Metadata":"30RPP","./AdPodTable":"A87P4","./AdBreakTable":"dz8jw","@mui/material/Stack":"6thYv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"30RPP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Metadata", ()=>Metadata);
parcelHelpers.export(exports, "VideoMetadata", ()=>VideoMetadata);
parcelHelpers.export(exports, "AudioMetadata", ()=>AudioMetadata);
var _jsxRuntime = require("react/jsx-runtime");
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _errorOutline = require("@mui/icons-material/ErrorOutline");
var _errorOutlineDefault = parcelHelpers.interopDefault(_errorOutline);
var _helpers = require("common/api/v1/helpers");
var _dataSet = require("../../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _dateFns = require("date-fns");
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _thumbnail = require("../../../common/Thumbnail");
var _statusIndicator = require("../StatusIndicator");
var _styles = require("../styles");
const Metadata = ({ adCreative, sx })=>{
    const data = {
        Id: adCreative.id,
        Created: (0, _dateFns.format)(new Date(adCreative.createdAt), (0, _helpers.DATE_FORMAT_LONG)),
        Owner: adCreative.createdBy,
        Status: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
            direction: 'row',
            spacing: 0.5,
            sx: (0, _styles.styles).inlineWrapper,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIndicator.AdCreativeIndicatorIcon), {
                    status: adCreative.status
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: (0, _statusIndicator.adCreativeIndicateStatusText)(adCreative.status)
                })
            ]
        })
    };
    const meta = adCreative.metadata;
    if (meta) {
        if (meta.format?.durationMs) data['Duration'] = (0, _helpers.formatMs)(meta.format.durationMs);
        if (meta.format?.bitrate) data['Bitrate'] = (0, _helpers.formatBitrate)(meta.format.bitrate);
        if (meta.format?.fileSize) data['Size'] = (0, _helpers.formatFileSize)(meta.format.fileSize);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
        sx: sx,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
            direction: "row",
            sx: {
                p: 1,
                width: '100%'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                    direction: "column",
                    spacing: 2,
                    sx: {
                        width: '100%',
                        m: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                width: '100%',
                                pl: 3,
                                pt: 2
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                                values: data
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: "row",
                            spacing: 15,
                            sx: {
                                width: '70%',
                                pl: 3,
                                pt: 2,
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(VideoMetadata, {
                                    metadata: adCreative.metadata,
                                    sx: {
                                        border: 'none'
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AudioMetadata, {
                                    metadata: adCreative.metadata,
                                    sx: {
                                        border: 'none'
                                    }
                                })
                            ]
                        })
                    ]
                }),
                adCreative?.thumbnailUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    overflow: "hidden",
                    sx: {
                        width: '70%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        pr: 10,
                        pl: 10
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnail.AdCreativeThumbnail), {
                        adCreative: adCreative
                    })
                })
            ]
        })
    });
};
const VideoMetadata = ({ metadata, sx })=>{
    const data = {
        Codec: metadata?.video?.codec,
        Profile: metadata?.video?.profile,
        Resolution: `${metadata?.video?.width}x${metadata?.video?.height}`,
        Framerate: metadata?.video?.framerate ? metadata.video.framerate.toFixed(2) : undefined,
        Bitrate: (0, _helpers.formatBitrate)(metadata?.video?.bitrate)
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: metadata?.video ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
            variant: "outlined",
            sx: [
                {
                    borderColor: 'primary.main'
                },
                sx
            ],
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "h4",
                    gutterBottom: true,
                    children: "Video"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: data
                })
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
            variant: "outlined",
            sx: [
                {
                    borderColor: 'primary.main'
                },
                sx
            ],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                display: "flex",
                alignItems: "center",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorOutlineDefault.default), {
                        color: "error"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h6",
                        color: "error",
                        children: "Video"
                    })
                ]
            })
        })
    });
};
const AudioMetadata = ({ metadata, sx })=>{
    const data = {
        Codec: metadata?.audio?.codec,
        Profile: metadata?.audio?.profile,
        Channels: metadata?.audio?.channels,
        Layout: metadata?.audio?.channelLayout,
        Bitrate: (0, _helpers.formatBitrate)(metadata?.audio?.bitrate)
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: metadata?.audio ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
            variant: "outlined",
            sx: [
                {
                    bgcolor: 'background.paper',
                    borderColor: 'secondary.main'
                },
                sx
            ],
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "h3",
                    gutterBottom: true,
                    children: "Audio"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                    values: data
                })
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
            variant: "outlined",
            sx: [
                {
                    bgcolor: 'background.paper',
                    borderColor: 'error.main'
                },
                sx
            ],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                display: "flex",
                alignItems: "center",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorOutlineDefault.default), {
                        color: "error"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h6",
                        color: "error",
                        children: "Audio"
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Paper":"aexCI","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","@mui/icons-material/ErrorOutline":"3q6XB","common/api/v1/helpers":"6jovr","../../../common/DataSet":"dmQXG","date-fns":"gelMX","@mui/material/Stack":"6thYv","@mui/material/Divider":"9Ul8c","../../../common/Thumbnail":"5Q8KF","../StatusIndicator":"aGfYm","../styles":"7hi9I","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aGfYm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adCreativeIndicateStatusText", ()=>adCreativeIndicateStatusText);
parcelHelpers.export(exports, "AdCreativeIndicatorIcon", ()=>AdCreativeIndicatorIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("./styles");
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _linkOff = require("@mui/icons-material/LinkOff");
var _linkOffDefault = parcelHelpers.interopDefault(_linkOff);
var _fiberManualRecord = require("@mui/icons-material/FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _types = require("common/api/v1/types");
var _fiberManualRecordOutlined = require("@mui/icons-material/FiberManualRecordOutlined");
var _fiberManualRecordOutlinedDefault = parcelHelpers.interopDefault(_fiberManualRecordOutlined);
const adCreativeIndicateStatusText = (status)=>{
    if (status === undefined) return 'Unknown';
    switch(status){
        case (0, _types.AdCreativeStatus).active:
            return 'Active';
        case (0, _types.AdCreativeStatus).pending:
            return 'Pending';
        case (0, _types.AdCreativeStatus).probeFailed:
            return 'Probe Failed';
        case (0, _types.AdCreativeStatus).thumbnailFailed:
            return 'Thumbnail Failed';
        case (0, _types.AdCreativeStatus).uploadFailed:
            return 'Upload Failed';
        default:
            return 'Unknown';
    }
};
const AdCreativeIndicatorIcon = ({ status })=>{
    if (status === undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordOutlinedDefault.default), {
        sx: (0, _styles.styles).success
    });
    switch(status){
        case (0, _types.AdCreativeStatus).active:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: (0, _styles.styles).success
            });
        case (0, _types.AdCreativeStatus).pending:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordOutlinedDefault.default), {
                sx: (0, _styles.styles).success
            });
        case (0, _types.AdCreativeStatus).probeFailed:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: (0, _styles.styles).error
            });
        case (0, _types.AdCreativeStatus).thumbnailFailed:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: (0, _styles.styles).warning
            });
        case (0, _types.AdCreativeStatus).uploadFailed:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkOffDefault.default), {
                sx: (0, _styles.styles).error
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                sx: {
                    ...(0, _styles.styles).warning
                }
            });
    }
};

},{"react/jsx-runtime":"1dlk8","./styles":"7hi9I","@mui/icons-material/HelpOutline":"2sIqE","@mui/icons-material/LinkOff":"lwjKU","@mui/icons-material/FiberManualRecord":"bvXIN","common/api/v1/types":"3qemx","@mui/icons-material/FiberManualRecordOutlined":"Vffg8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7hi9I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styles", ()=>styles);
parcelHelpers.export(exports, "classes", ()=>classes);
const styles = {
    inlineWrapper: {
        display: 'flex',
        alignItems: 'center',
        '& > span': {
            marginLeft: (theme)=>theme.spacing(1)
        }
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '34px',
        height: '34px',
        pointerEvents: 'all',
        '& svg': {
            display: 'block'
        }
    },
    warning: {
        color: (theme)=>theme.palette.warning.main
    },
    error: {
        color: (theme)=>theme.palette.error.main
    },
    success: {
        color: (theme)=>theme.palette.success.main
    },
    cell: {
        borderBottom: 'none'
    }
};
const classes = {
    columnHeader: {
        fontWeight: 'bold',
        textTransform: 'capitalize'
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"A87P4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdPodTable", ()=>AdPodTable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("../../../../utils");
var _store = require("../../../../store");
var _tableConfig = require("../../adPod/tableConfig");
var _reactRedux = require("react-redux");
var _adPodActions = require("../../../../redux/actions/adPodActions");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _helpers = require("common/api/v1/helpers");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _styles = require("../styles");
var _omit = require("lodash/fp/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _table1 = require("../../../common/Table");
var _form = require("../../../common/Form");
var _list = require("../../adPod/List");
var _reactRouter = require("react-router");
const AdPodTable = ({ adCreative })=>{
    const [searchParams, setSearchParams] = (0, _react.useState)((0, _utils.withDefaultPagination)({}));
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const user = (0, _utils.useUser)();
    const tableConfig = (0, _tableConfig.getSmallConfig)({
        user,
        routes
    }).filter((c)=>c !== null);
    const dispatch = (0, _reactRedux.useDispatch)();
    const { adPods, loading, total } = (0, _reactRedux.useSelector)(({ adPodReducer })=>({
            adPods: adPodReducer.adPods,
            loading: adPodReducer.loading,
            total: adPodReducer.total
        }), (0, _reactRedux.shallowEqual));
    (0, _react.useEffect)(()=>{
        dispatch((0, _adPodActions.listAdPods)({
            ...searchParams,
            adCreativeId: adCreative.id
        }));
    }, [
        searchParams
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: 'Ad Pods',
        className: "outlined",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                height: '35vh',
                width: '100%',
                mt: 2,
                display: 'flex'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                container: true,
                spacing: 2,
                sx: {
                    height: '100%',
                    flexGrow: 1
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                    size: {
                        xs: 12
                    },
                    sx: {
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'background.paper',
                        borderRadius: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                flexGrow: 1,
                                overflowY: 'auto',
                                borderRadius: '4px'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                                pending: loading,
                                cover: !!adPods.length,
                                id: "ad-pods-table",
                                children: adPods.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                                    id: "ad-pods-table",
                                    stickyHeader: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                                            sx: {
                                                '& .MuiTableCell-head': {
                                                    backgroundColor: 'background.paper'
                                                }
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                                children: tableConfig.filter((0, _helpers.notUndefinedOrNull)).map(({ title = '', props, headerProps }, ind)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                        sx: {
                                                            root: (0, _styles.styles).cell
                                                        },
                                                        padding: undefined,
                                                        "data-table-column": title,
                                                        ...headerProps ? headerProps : (0, _omitDefault.default)([
                                                            'noTypography'
                                                        ], props),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                            variant: "body2",
                                                            sx: (0, _styles.classes).columnHeader,
                                                            children: title
                                                        })
                                                    }, ind))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                                            children: adPods.map((item, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                                    hover: true,
                                                    onDoubleClick: ()=>(0, _list.canEditAdPod)(user, item.createdBy) ? void navigate(routes.adPodsUpdate({
                                                            id: item.id
                                                        })) : null,
                                                    children: tableConfig.filter((0, _helpers.notUndefinedOrNull)).map(({ getValue, props, title })=>/*#__PURE__*/ (0, _react.createElement)((0, _tableCellDefault.default), {
                                                            ...(0, _omitDefault.default)([
                                                                'noTypography'
                                                            ], props),
                                                            "data-cell-name": `${title}-cell`,
                                                            key: `${item.id}-${title}`
                                                        }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                            component: "div",
                                                            variant: "body2",
                                                            children: getValue(item, i)
                                                        })))
                                                }, item.id))
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    sx: {
                                        p: 2,
                                        textAlign: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        children: "No pods."
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                flexShrink: 0,
                                mt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table1.Pagination), {
                                    id: "ad-pods-table-pagination",
                                    total: total,
                                    page: searchParams.pageNumber || '0',
                                    perPage: searchParams.rowsPerPage || '10',
                                    changePageCallback: (page)=>{
                                        setSearchParams((prev)=>({
                                                ...prev,
                                                pageNumber: page
                                            }));
                                    },
                                    changeRowsPerPageCallback: (rowsPerPage)=>{
                                        setSearchParams((prev)=>({
                                                ...prev,
                                                pageNumber: '0',
                                                rowsPerPage
                                            }));
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../../../utils":"342UB","../../../../store":"5LXiG","../../adPod/tableConfig":"4xS7S","react-redux":"l1pMU","../../../../redux/actions/adPodActions":"2olSr","@mui/material/Box":"c4QkF","@mui/material/Grid":"6iX4B","../../../common/Pendable":"gDN67","@mui/material/Table":"k4r1H","@mui/material/TableHead":"9yKSO","@mui/material/TableRow":"bLA0R","common/api/v1/helpers":"6jovr","@mui/material/TableCell":"6WlPV","../styles":"7hi9I","lodash/fp/omit":"lRr4P","@mui/material/Typography":"6NtGx","@mui/material/TableBody":"2jHBQ","@mui/material/Divider":"9Ul8c","../../../common/Table":"dt9lf","../../../common/Form":"4Mui7","../../adPod/List":"a4U9z","react-router":"iaz4C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4xS7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getConfig", ()=>getConfig);
parcelHelpers.export(exports, "getSmallConfig", ()=>getSmallConfig);
var _jsxRuntime = require("react/jsx-runtime");
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _types = require("common/api/v1/types");
var _fiberManualRecord = require("@mui/icons-material/FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _fiberManualRecordOutlined = require("@mui/icons-material/FiberManualRecordOutlined");
var _fiberManualRecordOutlinedDefault = parcelHelpers.interopDefault(_fiberManualRecordOutlined);
var _helpOutline = require("@mui/icons-material/HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _actionMenu = require("./ActionMenu");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _pendingOutlined = require("@mui/icons-material/PendingOutlined");
var _pendingOutlinedDefault = parcelHelpers.interopDefault(_pendingOutlined);
var _link = require("../../common/Link");
var _list = require("./List");
const styles = {
    inlineWrapper: {
        display: 'flex',
        alignItems: 'center',
        '& > span': {
            marginLeft: (theme)=>theme.spacing(1)
        }
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '34px',
        height: '34px',
        pointerEvents: 'all',
        '& svg': {
            display: 'block'
        }
    },
    warning: {
        color: (theme)=>theme.palette.warning.main
    },
    error: {
        color: (theme)=>theme.palette.error.main
    },
    success: {
        color: (theme)=>theme.palette.success.main
    }
};
const statusText = (status)=>{
    switch(status){
        case (0, _types.AdPodStatus).pending:
            return 'Pending: Waiting for creatives to be uploaded';
        case (0, _types.AdPodStatus).healthy:
            return 'Healthy';
        case (0, _types.AdPodStatus).unhealthy:
            return 'Unhealthy: One or more creatives are unhealthy';
        case (0, _types.AdPodStatus).inactive:
            return 'Inactive: No outputs are using this ad pod';
        default:
            return 'Unknown';
    }
};
const StatusIcon = ({ status })=>{
    switch(status){
        case (0, _types.AdPodStatus).pending:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendingOutlinedDefault.default), {
                sx: styles.success
            });
        case (0, _types.AdPodStatus).healthy:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: styles.success
            });
        case (0, _types.AdPodStatus).unhealthy:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                sx: styles.warning
            });
        case (0, _types.AdPodStatus).inactive:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordOutlinedDefault.default), {
                sx: styles.success
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpOutlineDefault.default), {
                sx: styles.warning
            });
    }
};
const status = ()=>({
        title: 'status',
        getValue: ({ status })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: statusText(status),
                placement: "top",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: styles.container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusIcon, {
                            status: status
                        })
                    })
                })
            })
    });
const name = ({ availableFn, toFn }, override)=>({
        title: 'name',
        getValue: (adPod)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                available: availableFn(adPod),
                to: toFn(adPod),
                underline: "hover",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    "data-test-id": "ad-pod-name",
                    children: adPod.name
                })
            }),
        sorting: {
            byParameter: (0, _types.ListAdPodSortableField).name
        },
        props: {
            ...override?.props
        }
    });
const duration = ()=>({
        title: 'duration',
        getValue: ({ creatives })=>{
            if (creatives.length > 0) {
                const totalDurationMs = creatives.reduce((acc, creative)=>{
                    if (creative.userDurationMs) return acc + creative.userDurationMs;
                    if (creative.metadata?.format?.durationMs) return acc + creative.metadata.format.durationMs;
                    return acc;
                }, 0);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: `${totalDurationMs} ms`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body2",
                        children: (0, _helpers.formatMs)(totalDurationMs)
                    })
                });
            }
            return `-`;
        }
    });
const fileSize = ()=>({
        title: 'file size',
        getValue: ({ creatives })=>{
            if (creatives.length > 0) {
                const totalSize = creatives.reduce((acc, creative)=>{
                    if (creative.metadata?.format?.fileSize) return acc + creative.metadata.format.fileSize;
                    return acc;
                }, 0);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: `${Math.round(totalSize)} bytes`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body2",
                        children: (0, _helpers.formatFileSize)(totalSize)
                    })
                });
            }
            return `-`;
        }
    });
const createdAt = ()=>({
        title: 'created',
        getValue: ({ createdAt })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_LONG)),
                placement: "top",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "body2",
                    children: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_SHORT))
                })
            }),
        sorting: {
            byParameter: (0, _types.ListAdPodSortableField).createdAt
        }
    });
const getConfig = ({ adPods, dispatch, selected, handleSelect, handleSelectAll, routes, user })=>[
        {
            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                indeterminate: selected.length > 0 && selected.length < adPods.length,
                checked: selected.length === adPods.length,
                onChange: handleSelectAll,
                inputProps: {
                    'aria-label': 'select all inputs'
                },
                "data-test-id": 'select-all'
            }),
            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: selected.includes(id),
                    onChange: ()=>{
                        handleSelect(id);
                    },
                    onDoubleClick: (e)=>e.stopPropagation()
                }),
            props: {
                padding: 'checkbox'
            }
        },
        status(),
        name({
            toFn: (adPod)=>routes.adPodsUpdate({
                    id: adPod.id
                }),
            availableFn: (adPod)=>(0, _list.canEditAdPod)(user, adPod.createdBy)
        }),
        duration(),
        fileSize(),
        createdAt(),
        {
            title: '',
            getValue: (adPod)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    adPod: adPod,
                    dispatch: dispatch
                })
        }
    ];
const getSmallConfig = ({ routes, user })=>[
        status(),
        name({
            toFn: (adPod)=>routes.adPodsUpdate({
                    id: adPod.id
                }),
            availableFn: (adPod)=>(0, _list.canEditAdPod)(user, adPod.createdBy)
        }),
        duration(),
        fileSize()
    ];

},{"react/jsx-runtime":"1dlk8","../../common/Tooltip":"crjvg","@mui/material/Box":"c4QkF","common/api/v1/types":"3qemx","@mui/icons-material/FiberManualRecord":"bvXIN","@mui/icons-material/FiberManualRecordOutlined":"Vffg8","@mui/icons-material/HelpOutline":"2sIqE","./ActionMenu":"3olzC","@mui/material/Checkbox":"ag1Z5","date-fns":"gelMX","common/api/v1/helpers":"6jovr","@mui/material/Typography":"6NtGx","@mui/icons-material/PendingOutlined":"1z1cn","../../common/Link":"l3o6V","./List":"a4U9z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3olzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _store = require("../../../store");
var _actionMenu = require("../../common/Table/ActionMenu");
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _confirmDialog = require("../../common/ConfirmDialog");
var _adPodActions = require("../../../redux/actions/adPodActions");
const ActionMenu = ({ adPod, dispatch })=>{
    const routes = (0, _store.useRoutes)();
    const { showConfirmation } = (0, _confirmDialog.useConfirmationDialog)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            display: 'flex'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
            "data-test-id": "input-action-menu",
            options: [
                {
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                    label: 'Edit',
                    href: routes.adPodsUpdate({
                        id: adPod.id
                    }),
                    openInNewTab: false
                },
                {
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                    label: 'Remove',
                    isDestructive: true,
                    onClick: ()=>{
                        showConfirmation(()=>dispatch((0, _adPodActions.deleteAdPod)(adPod.id)), 'Are you sure you want to remove this ad creative?');
                    }
                }
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","../../../store":"5LXiG","../../common/Table/ActionMenu":"jf6As","@mui/icons-material/Settings":"jkTfg","@mui/icons-material/Delete":"69aC7","../../common/ConfirmDialog":"7JKPn","../../../redux/actions/adPodActions":"2olSr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a4U9z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canEditAdPod", ()=>canEditAdPod);
parcelHelpers.export(exports, "AdPodList", ()=>AdPodList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _store = require("../../../store");
var _table = require("../../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _utils = require("../../../utils");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _tableConfig = require("./tableConfig");
var _react = require("react");
var _types = require("common/api/v1/types");
var _commonActions = require("./CommonActions");
var _commonActionsDefault = parcelHelpers.interopDefault(_commonActions);
var _reactRouter = require("react-router");
var _missingContent = require("../../common/MissingContent");
const canEditAdPod = (user, createdBy)=>{
    return user.role === (0, _types.Role).admin && user.group === createdBy || user.role === (0, _types.Role).super;
};
const AdPodList = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouter.useNavigate)();
    const [selected, setSelected] = (0, _react.useState)([]);
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const { adPods, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useAdPodsSelector));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
            name: [
                'Ad Insertion',
                'Ad Pods'
            ],
            actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                id: 'button-add',
                variant: "contained",
                color: "primary",
                onClick: ()=>navigate(routes.adPodsNew()),
                children: "Add"
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commonActionsDefault.default), {
                    selected: selected,
                    setSelected: setSelected,
                    adPods: adPods,
                    user: user
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                    id: 'ad-pods-table',
                    emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                        message: "No ad pods",
                        buttonText: "Add",
                        url: routes.adPodsNew()
                    }),
                    data: adPods,
                    pagination: {
                        total: total,
                        useUrlSearchParams: true
                    },
                    config: (0, _tableConfig.getConfig)({
                        adPods,
                        dispatch,
                        selected,
                        handleSelect: (id)=>{
                            setSelected((prev)=>prev.includes(id) ? prev.filter((s)=>s !== id) : [
                                    ...prev,
                                    id
                                ]);
                        },
                        handleSelectAll: ()=>{
                            setSelected((prev)=>prev.length === adPods.length ? [] : adPods.map((adPod)=>adPod.id));
                        },
                        user,
                        routes
                    }),
                    rowProps: ({ id, createdBy })=>{
                        const isItemSelected = Boolean(id && selected.includes(id));
                        return {
                            onDoubleClick: ()=>canEditAdPod(user, createdBy) ? void navigate(routes.adPodsUpdate({
                                    id
                                })) : null,
                            'aria-checked': isItemSelected,
                            tabIndex: -1,
                            selected: isItemSelected
                        };
                    },
                    pending: loading
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","../../../store":"5LXiG","../../common/Table":"dt9lf","@mui/material/Button":"3qJY9","../../../utils":"342UB","../../common/Wrapper":"8oy7r","./tableConfig":"4xS7S","react":"9njXz","common/api/v1/types":"3qemx","./CommonActions":"3E7mH","react-router":"iaz4C","../../common/MissingContent":"1LBl6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3E7mH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _types = require("common/api/v1/types");
var _utils = require("../../../utils");
var _filteredSearchBar = require("../../common/Filters/FilterView/FilteredSearchBar");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _adPodActions = require("../../../redux/actions/adPodActions");
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _dateFilter = require("../../common/Filters/FilterView/dateFilter");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
const BatchDeleteButton = ({ selected, setSelected, disabledMessage })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const onClick = ()=>{
        showConfirmation(()=>{
            dispatch((0, _adPodActions.deleteAdPods)(selected.map(({ id })=>id)));
            setSelected([]);
        }, 'Are you sure you want to remove the selected ad pods?', selected.length === 1 ? selected[0].name : 'remove ad pods', {
            ok: {
                text: 'remove',
                color: 'error'
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: disabledMessage ?? 'Remove selected ad pods',
        disablePortal: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "batch delete",
                onClick: onClick,
                disabled: !!disabledMessage,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
            })
        })
    });
};
const CommonActions = ({ adPods, selected, setSelected, user })=>{
    const { group } = (0, _utils.useUser)();
    const adPodsMaps = adPods.reduce((acc, item)=>({
            ...acc,
            [item.id]: item
        }), {});
    const showButtons = user.role === (0, _types.Role).super || selected.every((id)=>adPodsMaps[id]?.groupId === group);
    const isOwnerOfAllSelected = selected.every((id)=>adPodsMaps[id]?.createdBy === user.id);
    const filters = makeAdPodFilters();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
        disableGutters: true,
        style: {
            overflowX: 'clip'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>theme.transitions.create('flex-shrink', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.shortest
                        })
                },
                style: {
                    flexShrink: selected.length > 0 ? 1 : 0,
                    flexGrow: 1,
                    flexBasis: '100%'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                    urlParamCacheKey: 'adPods',
                    mapFilterToUrlParamFn: mapAdPodFilterToUrlParam,
                    mapUrlParamToFilterFn: mapUrlParamToAdPodFilter,
                    searchTokenFilters: filters,
                    rawTextFilter: filters.find((f)=>f.key === "name")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>// Fade out, i.e. keep visible until contents has left the screen
                        theme.transitions.create('visibility', {
                            delay: selected.length === 0 ? theme.transitions.duration.shortest : 0
                        })
                },
                style: {
                    marginLeft: 16,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    visibility: selected.length > 0 ? 'visible' : 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: 180,
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            variant: "subtitle1",
                            children: [
                                (0, _utils.pluralize)(selected.length, 'ad pod'),
                                " selected"
                            ]
                        })
                    }),
                    showButtons && /*#__PURE__*/ (0, _jsxRuntime.jsx)(BatchDeleteButton, {
                        selected: adPods.filter((d)=>selected.includes(d.id)),
                        setSelected: setSelected,
                        disabledMessage: user.role === (0, _types.Role).super || isOwnerOfAllSelected ? undefined : 'You are not the owner of a selected ad pod'
                    })
                ]
            })
        ]
    });
};
var AdPodFilterKey = /*#__PURE__*/ function(AdPodFilterKey) {
    AdPodFilterKey["name"] = "name";
    AdPodFilterKey["timestamp"] = "timestamp";
    AdPodFilterKey["status"] = "status";
    return AdPodFilterKey;
}(AdPodFilterKey || {});
function mapAdPodFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
        case "timestamp":
            return filter.operator === 'after' ? {
                fromDate: new Date(filter.value).toISOString()
            } : {
                toDate: new Date(filter.value).toISOString()
            };
        case "status":
            return {
                status: filter.value
            };
    }
    return {};
}
function mapUrlParamToAdPodFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
        case 'fromDate':
            return {
                key: "timestamp",
                operator: 'after',
                value: (0, _dateFns.format)(new Date(value), (0, _helpers.DATE_FORMAT_LONGER))
            };
        case 'toDate':
            return {
                key: "timestamp",
                operator: 'before',
                value: (0, _dateFns.format)(new Date(value), (0, _helpers.DATE_FORMAT_LONGER))
            };
        case 'status':
            return {
                key: "status",
                operator: 'is',
                value: value,
                displayName: (0, _helpers.sentenceCase)(value)
            };
    }
    return undefined;
}
function makeAdPodFilters() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        },
        {
            key: "timestamp",
            operator: 'after',
            possibleValuesSync: (s)=>(0, _dateFilter.dateFilterPossibleValues)(s)
        },
        {
            key: "timestamp",
            operator: 'before',
            possibleValuesSync: (s)=>(0, _dateFilter.dateFilterPossibleValues)(s)
        },
        {
            key: "status",
            operator: 'is',
            possibleValuesSync: ()=>Object.values((0, _types.AdPodStatus)).map((status)=>({
                        value: status,
                        displayName: (0, _helpers.sentenceCase)(status)
                    }))
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}
exports.default = CommonActions;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/IconButton":"488As","@mui/material/Typography":"6NtGx","@mui/material/Toolbar":"5Kohb","../../common/Tooltip":"crjvg","common/api/v1/types":"3qemx","../../../utils":"342UB","../../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@mui/material/Box":"c4QkF","../../../redux/actions/adPodActions":"2olSr","date-fns":"gelMX","common/api/v1/helpers":"6jovr","../../common/Filters/FilterView/dateFilter":"dRpLd","@mui/icons-material/Delete":"69aC7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dz8jw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdBreakTable", ()=>AdBreakTable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("../../../../utils");
var _store = require("../../../../store");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _helpers = require("common/api/v1/helpers");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _styles = require("../styles");
var _omit = require("lodash/fp/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _table1 = require("../../../common/Table");
var _adBreakActions = require("../../../../redux/actions/adBreakActions");
var _form = require("../../../common/Form");
var _tableConfig = require("../../adBreak/tableConfig");
var _list = require("../../adBreak/List");
var _reactRouter = require("react-router");
const AdBreakTable = ({ adCreative })=>{
    const [searchParams, setSearchParams] = (0, _react.useState)((0, _utils.withDefaultPagination)({}));
    const tableConfig = (0, _tableConfig.getSmallTableConfig)().filter((c)=>c !== null);
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const user = (0, _utils.useUser)();
    const { adBreaks, loading, total } = (0, _reactRedux.useSelector)(({ adBreakReducer })=>({
            adBreaks: adBreakReducer.adBreaks,
            loading: adBreakReducer.loading,
            total: adBreakReducer.total
        }), (0, _reactRedux.shallowEqual));
    (0, _react.useEffect)(()=>{
        dispatch((0, _adBreakActions.listAdBreaks)({
            ...searchParams,
            adId: adCreative.id
        }));
    }, [
        searchParams
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: 'Ad Breaks',
        className: "outlined",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                height: '35vh',
                width: '100%',
                mt: 2,
                display: 'flex'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                container: true,
                spacing: 2,
                sx: {
                    height: '100%',
                    flexGrow: 1
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                    size: {
                        xs: 12
                    },
                    sx: {
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'background.paper',
                        borderRadius: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                flexGrow: 1,
                                overflowY: 'auto',
                                borderRadius: '4px'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                                pending: loading,
                                cover: !!adBreaks.length,
                                id: "ad-breaks-table",
                                children: adBreaks.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                                    id: "ad-breaks-table",
                                    stickyHeader: true,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                                            sx: {
                                                '& .MuiTableCell-head': {
                                                    backgroundColor: 'background.paper'
                                                }
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                                children: tableConfig.filter((0, _helpers.notUndefinedOrNull)).map(({ title = '', props, headerProps }, ind)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                        sx: {
                                                            root: (0, _styles.styles).cell
                                                        },
                                                        padding: undefined,
                                                        "data-table-column": title,
                                                        ...headerProps ? headerProps : (0, _omitDefault.default)([
                                                            'noTypography'
                                                        ], props),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                            variant: "body2",
                                                            sx: (0, _styles.classes).columnHeader,
                                                            children: title
                                                        })
                                                    }, ind))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                                            children: adBreaks.map((item, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                                    hover: true,
                                                    onDoubleClick: ()=>(0, _list.canViewAdBreak)(item.groupId, user) ? void navigate(routes.adBreaksView({
                                                            id: item.id
                                                        })) : null,
                                                    children: tableConfig.filter((0, _helpers.notUndefinedOrNull)).map(({ getValue, props, title })=>/*#__PURE__*/ (0, _react.createElement)((0, _tableCellDefault.default), {
                                                            ...(0, _omitDefault.default)([
                                                                'noTypography'
                                                            ], props),
                                                            "data-cell-name": `${title}-cell`,
                                                            key: `${item.id}-${title}`
                                                        }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                            component: "div",
                                                            variant: "body2",
                                                            children: getValue(item, i)
                                                        })))
                                                }, item.id))
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    sx: {
                                        p: 2,
                                        textAlign: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        children: "No ad breaks."
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                flexShrink: 0,
                                mt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table1.Pagination), {
                                    id: "ad-breaks-table-pagination",
                                    total: total,
                                    page: searchParams.pageNumber || '0',
                                    perPage: searchParams.rowsPerPage || '10',
                                    changePageCallback: (page)=>{
                                        setSearchParams((prev)=>({
                                                ...prev,
                                                pageNumber: page
                                            }));
                                    },
                                    changeRowsPerPageCallback: (rowsPerPage)=>{
                                        setSearchParams((prev)=>({
                                                ...prev,
                                                pageNumber: '0',
                                                rowsPerPage
                                            }));
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../../../utils":"342UB","../../../../store":"5LXiG","react-redux":"l1pMU","@mui/material/Box":"c4QkF","@mui/material/Grid":"6iX4B","../../../common/Pendable":"gDN67","@mui/material/Table":"k4r1H","@mui/material/TableHead":"9yKSO","@mui/material/TableRow":"bLA0R","common/api/v1/helpers":"6jovr","@mui/material/TableCell":"6WlPV","../styles":"7hi9I","lodash/fp/omit":"lRr4P","@mui/material/Typography":"6NtGx","@mui/material/TableBody":"2jHBQ","@mui/material/Divider":"9Ul8c","../../../common/Table":"dt9lf","../../../../redux/actions/adBreakActions":"baydX","../../../common/Form":"4Mui7","../../adBreak/tableConfig":"gCXMq","../../adBreak/List":"7I0o7","react-router":"iaz4C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7I0o7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canViewAdBreak", ()=>canViewAdBreak);
parcelHelpers.export(exports, "AdBreakList", ()=>AdBreakList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _store = require("../../../store");
var _table = require("../../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _tableConfig = require("./tableConfig");
var _types = require("common/api/v1/types");
var _commonActions = require("./CommonActions");
var _commonActionsDefault = parcelHelpers.interopDefault(_commonActions);
var _missingContent = require("../../common/MissingContent");
var _utils = require("../../../utils");
var _reactRouter = require("react-router");
const canViewAdBreak = (groupId, user)=>{
    return user.role === (0, _types.Role).admin && groupId === user.group || user.role === (0, _types.Role).super;
};
const AdBreakList = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [params] = (0, _utils.usePageParams)();
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    const user = (0, _utils.useUser)();
    const { adBreaks, total, loading } = (0, _utils.useAdBreaksSelector)((0, _utils.withDefaultPagination)(params));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
            name: [
                'Ad Insertion',
                'Ad Breaks'
            ],
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commonActionsDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                    id: 'ad-breaks-table',
                    emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                        message: "No ad breaks"
                    }),
                    data: adBreaks,
                    pagination: {
                        total: total,
                        useUrlSearchParams: true
                    },
                    config: (0, _tableConfig.getTableConfig)({
                        dispatch
                    }),
                    pending: loading,
                    rowProps: ({ id, groupId })=>{
                        return {
                            onDoubleClick: ()=>canViewAdBreak(groupId, user) ? void navigate(routes.adBreaksView({
                                    id
                                })) : null,
                            tabIndex: -1
                        };
                    }
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","../../../store":"5LXiG","../../common/Table":"dt9lf","../../common/Wrapper":"8oy7r","./tableConfig":"gCXMq","common/api/v1/types":"3qemx","./CommonActions":"k5BUe","../../common/MissingContent":"1LBl6","../../../utils":"342UB","react-router":"iaz4C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k5BUe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _filteredSearchBar = require("../../common/Filters/FilterView/FilteredSearchBar");
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _dateFilter = require("../../common/Filters/FilterView/dateFilter");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _types = require("common/api/v1/types");
const CommonActions = ()=>{
    const filters = makeAdBreakFilters();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
        disableGutters: true,
        style: {
            overflowX: 'clip'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                width: '100%'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                urlParamCacheKey: 'adBreaks',
                mapFilterToUrlParamFn: mapAdBreakFilterToUrlParam,
                mapUrlParamToFilterFn: mapUrlParamToAdBreakFilter,
                searchTokenFilters: filters,
                rawTextFilter: filters.find((f)=>f.key === "timestamp")
            })
        })
    });
};
var AdBreakFilterKey = /*#__PURE__*/ function(AdBreakFilterKey) {
    AdBreakFilterKey["timestamp"] = "timestamp";
    AdBreakFilterKey["status"] = "status";
    return AdBreakFilterKey;
}(AdBreakFilterKey || {});
function mapAdBreakFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "timestamp":
            return filter.operator === 'after' ? {
                fromDate: new Date(filter.value).toISOString()
            } : {
                toDate: new Date(filter.value).toISOString()
            };
        case "status":
            return {
                status: filter.value
            };
    }
    return {};
}
function mapUrlParamToAdBreakFilter(key, value) {
    switch(key){
        case 'fromDate':
            return {
                key: "timestamp",
                operator: 'after',
                value: (0, _dateFns.format)(new Date(value), (0, _helpers.DATE_FORMAT_LONGER))
            };
        case 'toDate':
            return {
                key: "timestamp",
                operator: 'before',
                value: (0, _dateFns.format)(new Date(value), (0, _helpers.DATE_FORMAT_LONGER))
            };
        case 'status':
            return {
                key: "status",
                operator: 'is',
                value: value,
                displayName: (0, _helpers.sentenceCase)(value)
            };
    }
    return undefined;
}
function makeAdBreakFilters() {
    const filterTemplates = [
        {
            key: "timestamp",
            operator: 'after',
            possibleValuesSync: (s)=>(0, _dateFilter.dateFilterPossibleValues)(s)
        },
        {
            key: "timestamp",
            operator: 'before',
            possibleValuesSync: (s)=>(0, _dateFilter.dateFilterPossibleValues)(s)
        },
        {
            key: "status",
            operator: 'is',
            possibleValuesSync: ()=>Object.values((0, _types.AdBreakStatus)).map((status)=>({
                        value: status,
                        displayName: (0, _helpers.sentenceCase)(status)
                    }))
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}
exports.default = CommonActions;

},{"react/jsx-runtime":"1dlk8","@mui/material/Toolbar":"5Kohb","../../common/Filters/FilterView/FilteredSearchBar":"eEpmv","date-fns":"gelMX","common/api/v1/helpers":"6jovr","../../common/Filters/FilterView/dateFilter":"dRpLd","@mui/material/Box":"c4QkF","common/api/v1/types":"3qemx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8lxdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canEditAdCreative", ()=>canEditAdCreative);
parcelHelpers.export(exports, "AdCreativeList", ()=>AdCreativeList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _store = require("../../../store");
var _table = require("../../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _utils = require("../../../utils");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _tableConfig = require("./tableConfig");
var _react = require("react");
var _types = require("common/api/v1/types");
var _uploadDialog = require("./UploadDialog");
var _uploadDialogDefault = parcelHelpers.interopDefault(_uploadDialog);
var _commonActions = require("./CommonActions");
var _commonActionsDefault = parcelHelpers.interopDefault(_commonActions);
var _adCreativeActions = require("../../../redux/actions/adCreativeActions");
var _params = require("../../../utils/params");
var _createDialog = require("./CreateDialog");
var _createDialogDefault = parcelHelpers.interopDefault(_createDialog);
var _missingContent = require("../../common/MissingContent");
var _reactRouter = require("react-router");
const canEditAdCreative = (user, createdBy)=>{
    return user.role === (0, _types.Role).admin && user.group === createdBy || user.role === (0, _types.Role).super;
};
const AdCreativeList = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [uploadTo, setUploadTo] = (0, _react.useState)(undefined);
    const [selected, setSelected] = (0, _react.useState)([]);
    const [openCreateDialog, setOpenCreateDialog] = (0, _react.useState)(false);
    const navigate = (0, _reactRouter.useNavigate)();
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const { adCreatives, total, loading } = (0, _utils.usePageParamsFilteredSelector)((0, _utils.useAdCreativeSelector));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadDialogDefault.default), {
                adCreative: uploadTo,
                onClose: ()=>{
                    setUploadTo(undefined);
                    dispatch((0, _adCreativeActions.listAdCreatives)((0, _utils.withDefaultPagination)((0, _params.getLocationParams)())));
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createDialogDefault.default), {
                open: openCreateDialog,
                onCreate: (adCreativeInit)=>{
                    dispatch((0, _adCreativeActions.createAdCreative)(adCreativeInit)).then((res)=>{
                        dispatch((0, _adCreativeActions.listAdCreatives)((0, _utils.withDefaultPagination)((0, _params.getLocationParams)())));
                        setOpenCreateDialog(false);
                        setUploadTo(res.payload);
                    });
                },
                onClose: ()=>{
                    setOpenCreateDialog(false);
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperDefault.default), {
                name: [
                    'Ad Insertion',
                    'Ad Creatives'
                ],
                actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    id: 'button-add',
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>setOpenCreateDialog(true),
                    children: "Add"
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commonActionsDefault.default), {
                        selected: selected,
                        setSelected: setSelected,
                        adCreatives: adCreatives,
                        user: user
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                        id: "ad-creatives-table",
                        emptyMessageComponent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingContent.MissingContent), {
                            message: "No ad creatives",
                            buttonText: "Add",
                            onClick: ()=>setOpenCreateDialog(true)
                        }),
                        data: adCreatives,
                        pagination: {
                            total: total,
                            useUrlSearchParams: true
                        },
                        config: (0, _tableConfig.getConfig)({
                            adCreatives,
                            dispatch,
                            onUpload: (adCreative)=>{
                                setUploadTo(adCreative);
                            },
                            selected,
                            handleSelect: (id)=>{
                                setSelected((prev)=>prev.includes(id) ? prev.filter((s)=>s !== id) : [
                                        ...prev,
                                        id
                                    ]);
                            },
                            handleSelectAll: ()=>{
                                setSelected((prev)=>prev.length === adCreatives.length ? [] : adCreatives.map((adCreative)=>adCreative.id));
                            },
                            user,
                            routes
                        }),
                        rowProps: ({ id, createdBy })=>{
                            const isItemSelected = Boolean(id && selected.includes(id));
                            return {
                                onDoubleClick: ()=>canEditAdCreative(user, createdBy) ? void navigate(routes.adCreativesUpdate({
                                        id
                                    })) : null,
                                'aria-checked': isItemSelected,
                                tabIndex: -1,
                                selected: isItemSelected
                            };
                        },
                        pending: loading
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","../../../store":"5LXiG","../../common/Table":"dt9lf","@mui/material/Button":"3qJY9","../../../utils":"342UB","../../common/Wrapper":"8oy7r","./tableConfig":"G6Vjg","react":"9njXz","common/api/v1/types":"3qemx","./UploadDialog":"iCdKe","./CommonActions":"jh1Eq","../../../redux/actions/adCreativeActions":"gzqhz","../../../utils/params":"5D6YE","./CreateDialog":"jOfY5","../../common/MissingContent":"1LBl6","react-router":"iaz4C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"G6Vjg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getConfig", ()=>getConfig);
parcelHelpers.export(exports, "getTransferTableConfig", ()=>getTransferTableConfig);
var _jsxRuntime = require("react/jsx-runtime");
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _thumbnail = require("../../common/Thumbnail");
var _types = require("common/api/v1/types");
var _actionMenu = require("./ActionMenu");
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _dragIndicator = require("@mui/icons-material/DragIndicator");
var _dragIndicatorDefault = parcelHelpers.interopDefault(_dragIndicator);
var _link = require("../../common/Link");
var _list = require("./List");
var _styles = require("./styles");
var _statusIndicator = require("./StatusIndicator");
const status = ()=>({
        title: 'status',
        getValue: ({ status, errorMessage })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: errorMessage || (0, _statusIndicator.adCreativeIndicateStatusText)(status),
                placement: "top",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: (0, _styles.styles).inlineWrapper,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIndicator.AdCreativeIndicatorIcon), {
                        status: status
                    })
                })
            }),
        props: {
            width: '34px'
        }
    });
const preview = ()=>({
        title: 'preview',
        getValue: (adCreative)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnail.AdCreativeThumbnail), {
                adCreative: adCreative
            }),
        props: {
            sx: {
                padding: 1,
                width: '100px'
            }
        },
        headerProps: {}
    });
const name = ({ availableFn, toFn, onClickName }, override)=>({
        title: 'name',
        getValue: (adCreative)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                available: availableFn(adCreative),
                onClick: onClickName ? (e)=>onClickName(e, adCreative) : undefined,
                to: toFn(adCreative),
                underline: "hover",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    "data-test-id": "ad-creative-name",
                    children: adCreative.name
                })
            }),
        sorting: {
            byParameter: (0, _types.ListAdCreativeSortableField).name
        },
        props: {
            ...override?.props
        }
    });
const duration = ()=>({
        title: 'duration',
        getValue: ({ userDurationMs, metadata })=>{
            if (userDurationMs) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: `${userDurationMs} ms`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "body2",
                    children: (0, _helpers.formatMs)(userDurationMs)
                })
            });
            if (metadata?.format?.durationMs) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: `${metadata.format.durationMs} ms`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "body2",
                    children: `${(0, _helpers.formatMs)(metadata.format.durationMs)}`
                })
            });
            return `-`;
        },
        sorting: {
            byParameter: (0, _types.ListAdCreativeSortableField).duration
        }
    });
const mediaFormat = ()=>({
        title: 'media format',
        getValue: ({ metadata })=>{
            const videoCodec = metadata?.video?.codec;
            const audioCodec = metadata?.audio?.codec;
            if (videoCodec || audioCodec) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                direction: "row",
                spacing: 1,
                sx: {
                    padding: 1
                },
                children: [
                    videoCodec && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                        label: videoCodec,
                        size: "small"
                    }),
                    audioCodec && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                        label: audioCodec,
                        size: "small"
                    })
                ]
            });
            return `-`;
        }
    });
const resolution = ()=>({
        title: 'resolution',
        getValue: ({ metadata })=>{
            const width = metadata?.video?.width;
            const height = metadata?.video?.height;
            if (width && height) return `${width}x${height}`;
            return `-`;
        }
    });
const fileSize = ()=>({
        title: 'file Size',
        getValue: ({ metadata })=>{
            const fileSize = metadata?.format?.fileSize;
            if (fileSize) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: `${Math.round(fileSize)} bytes`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "body2",
                    children: (0, _helpers.formatFileSize)(fileSize)
                })
            });
            return `-`;
        },
        sorting: {
            byParameter: (0, _types.ListAdCreativeSortableField).fileSize
        }
    });
const filler = ()=>({
        title: 'filler',
        getValue: ({ filler })=>{
            if (filler) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: `A filler ad creative is used to fill gaps in ad pods and is not required to be tracked`,
                placement: "top",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                    label: "Filler",
                    size: "small",
                    color: "warning"
                })
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
        },
        props: {
            align: 'left',
            width: '100px'
        }
    });
const createdAt = ()=>({
        title: 'created',
        getValue: ({ createdAt })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                title: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_LONG)),
                placement: "top",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "body2",
                    children: (0, _dateFns.format)(new Date(createdAt), (0, _helpers.DATE_FORMAT_SHORT))
                })
            }),
        sorting: {
            byParameter: (0, _types.ListAdCreativeSortableField).createdAt
        }
    });
const getConfig = ({ adCreatives, dispatch, onUpload, selected, handleSelect, handleSelectAll, user, routes })=>[
        {
            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                indeterminate: selected.length > 0 && selected.length < adCreatives.length,
                checked: selected.length === adCreatives.length,
                onChange: handleSelectAll,
                inputProps: {
                    'aria-label': 'select all inputs'
                },
                "data-test-id": 'select-all'
            }),
            getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: selected.includes(id),
                    onChange: ()=>{
                        handleSelect(id);
                    },
                    onDoubleClick: (e)=>e.stopPropagation()
                }),
            props: {
                padding: 'checkbox'
            }
        },
        status(),
        preview(),
        name({
            toFn: (adCreative)=>routes.adCreativesUpdate({
                    id: adCreative.id
                }),
            availableFn: (adCreative)=>(0, _list.canEditAdCreative)(user, adCreative.createdBy),
            onClickName: (e, adCreative)=>{
                const pendingOrOnlyUpload = adCreative.status === (0, _types.AdCreativeStatus).pending || adCreative.events.length === 1 && (adCreative.events[0] === (0, _types.AdCreativeEvent).uploadOk || adCreative.events[0] === (0, _types.AdCreativeEvent).uploadFailed);
                if (pendingOrOnlyUpload) {
                    onUpload(adCreative);
                    e.preventDefault();
                }
            }
        }),
        duration(),
        mediaFormat(),
        resolution(),
        fileSize(),
        createdAt(),
        {
            title: '',
            getValue: (adCreative)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
                    adCreative: adCreative,
                    dispatch: dispatch,
                    onUpload: onUpload
                })
        }
    ];
const getTransferTableConfig = ({ adCreatives, selected, handleSelect, handleSelectAll, dragable, side, user, routes })=>[
        {
            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                indeterminate: selected.length > 0 && selected.length < adCreatives.length,
                checked: selected.length === adCreatives.length,
                onChange: handleSelectAll,
                inputProps: {
                    'aria-label': 'select all inputs'
                },
                "data-test-id": 'select-all'
            }),
            getValue: ({ id, locId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: selected.includes(side == 'left' ? id : locId),
                    onChange: ()=>{
                        handleSelect(side == 'left' ? id : locId);
                    },
                    onDoubleClick: (e)=>e.stopPropagation()
                }),
            props: {
                padding: 'checkbox'
            }
        },
        status(),
        filler(),
        name({
            availableFn: (adCreative)=>(0, _list.canEditAdCreative)(user, adCreative.createdBy) && adCreative.status !== 'pending',
            toFn: (adCreative)=>routes.adCreativesUpdate({
                    id: adCreative.id
                })
        }),
        duration(),
        ...dragable ? [
            {
                title: '',
                getValue: ({ id })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            cursor: 'grab',
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        "data-drag-handle-id": id,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dragIndicatorDefault.default), {
                            fontSize: "small"
                        })
                    }),
                props: {
                    width: '32px',
                    padding: 'none'
                }
            }
        ] : []
    ];

},{"react/jsx-runtime":"1dlk8","../../common/Tooltip":"crjvg","@mui/material/Box":"c4QkF","../../common/Thumbnail":"5Q8KF","common/api/v1/types":"3qemx","./ActionMenu":"aDVp0","@mui/material/Checkbox":"ag1Z5","date-fns":"gelMX","common/api/v1/helpers":"6jovr","@mui/material/Typography":"6NtGx","@mui/material/Chip":"5cK8z","@mui/material/Stack":"6thYv","@mui/icons-material/DragIndicator":"51iqm","../../common/Link":"l3o6V","./List":"8lxdr","./styles":"7hi9I","./StatusIndicator":"aGfYm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDVp0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _store = require("../../../store");
var _types = require("common/api/v1/types");
var _actionMenu = require("../../common/Table/ActionMenu");
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _confirmDialog = require("../../common/ConfirmDialog");
var _adCreativeActions = require("../../../redux/actions/adCreativeActions");
var _uploadFile = require("@mui/icons-material/UploadFile");
var _uploadFileDefault = parcelHelpers.interopDefault(_uploadFile);
const ActionMenu = ({ adCreative, dispatch, onUpload })=>{
    const routes = (0, _store.useRoutes)();
    const { showConfirmation } = (0, _confirmDialog.useConfirmationDialog)();
    const pendingOrOnlyUpload = adCreative.status === (0, _types.AdCreativeStatus).pending || adCreative.events.length === 1 && (adCreative.events[0] === (0, _types.AdCreativeEvent).uploadOk || adCreative.events[0] === (0, _types.AdCreativeEvent).uploadFailed);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            display: 'flex'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionMenu.ActionMenu), {
            "data-test-id": "input-action-menu",
            options: [
                ...pendingOrOnlyUpload ? [
                    {
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadFileDefault.default), {}),
                        label: 'Upload File',
                        onClick: ()=>onUpload(adCreative)
                    }
                ] : [
                    {
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                        label: 'Edit',
                        href: routes.adCreativesUpdate({
                            id: adCreative.id
                        }),
                        openInNewTab: false
                    }
                ],
                {
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                    label: 'Remove',
                    isDestructive: true,
                    onClick: ()=>{
                        showConfirmation(()=>dispatch((0, _adCreativeActions.deleteAdCreative)(adCreative.id)), 'Are you sure you want to remove this ad creative?');
                    },
                    'data-test-id': 'button-delete'
                }
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","@mui/material/Box":"c4QkF","../../../store":"5LXiG","common/api/v1/types":"3qemx","../../common/Table/ActionMenu":"jf6As","@mui/icons-material/Settings":"jkTfg","@mui/icons-material/Delete":"69aC7","../../common/ConfirmDialog":"7JKPn","../../../redux/actions/adCreativeActions":"gzqhz","@mui/icons-material/UploadFile":"jwBU0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jwBU0":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("9268e67bf3848882").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b8152b6dcf0a0dc4"));
var _jsxRuntime = require("d94b2abba974fe7a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
}), 'UploadFile');

},{"9268e67bf3848882":"kZ6eK","b8152b6dcf0a0dc4":"2vOnF","d94b2abba974fe7a":"1dlk8"}],"51iqm":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("60aa0a2fbae3e59c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b0dc0c45d47f0988"));
var _jsxRuntime = require("ed9e3b0ff3b6a2e6");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'DragIndicator');

},{"60aa0a2fbae3e59c":"kZ6eK","b0dc0c45d47f0988":"2vOnF","ed9e3b0ff3b6a2e6":"1dlk8"}],"iCdKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _collapse = require("@mui/material/Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _cloudUpload = require("@mui/icons-material/CloudUpload");
var _cloudUploadDefault = parcelHelpers.interopDefault(_cloudUpload);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _error = require("@mui/icons-material/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _radioButtonUnchecked = require("@mui/icons-material/RadioButtonUnchecked");
var _radioButtonUncheckedDefault = parcelHelpers.interopDefault(_radioButtonUnchecked);
var _types = require("common/api/v1/types");
var _store = require("../../../store");
var _reactRedux = require("react-redux");
var _adCreativeActions = require("../../../redux/actions/adCreativeActions");
var _thumbnail = require("../../common/Thumbnail");
var _errorOutline = require("@mui/icons-material/ErrorOutline");
var _errorOutlineDefault = parcelHelpers.interopDefault(_errorOutline);
var _metadata = require("./Edit/Metadata");
var _helpers = require("common/api/v1/helpers");
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _form = require("../../common/Form");
var _reactRouter = require("react-router");
const REQUIRED_EVENTS = [
    (0, _types.AdCreativeEvent).uploadOk,
    (0, _types.AdCreativeEvent).thumbnailOk,
    (0, _types.AdCreativeEvent).probeOk
];
const refreshAdCreative = async (id)=>{
    return (0, _store.Api).adCreativesApi.getAdCreative(id);
};
const UploadDialog = ({ adCreative: initialAdCreative, onClose })=>{
    const [adCreative, setAdCreative] = (0, _react.useState)(initialAdCreative);
    const [uploading, setUploading] = (0, _react.useState)(false);
    const [uploadStarted, setUploadStarted] = (0, _react.useState)(false);
    const [uploadError, setUploadError] = (0, _react.useState)(null);
    const pollingRef = (0, _react.useRef)(null);
    const POLLING_INTERVAL_MS = 100;
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    (0, _react.useEffect)(()=>{
        setAdCreative(initialAdCreative);
        // If this creative started its upload process, start polling to check its status
        if (initialAdCreative?.events.includes((0, _types.AdCreativeEvent).uploadOk)) {
            startPolling(initialAdCreative.id);
            setUploadStarted(true);
        }
    }, [
        initialAdCreative
    ]);
    const startPolling = (id)=>{
        if (pollingRef.current) return;
        pollingRef.current = setInterval(async ()=>{
            try {
                const updated = await refreshAdCreative(id);
                if (pollingRef.current) {
                    setAdCreative(updated);
                    const allOk = REQUIRED_EVENTS.every((event)=>updated.events.includes(event));
                    const anyFail = updated.events.some((e)=>[
                            (0, _types.AdCreativeEvent).thumbnailFailed,
                            (0, _types.AdCreativeEvent).probeFailed
                        ].includes(e));
                    if (allOk || anyFail) stopPolling();
                }
            } catch (err) {
                setUploadError('Failed to refresh ad creative');
                stopPolling();
            }
        }, POLLING_INTERVAL_MS);
    };
    const stopPolling = ()=>{
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }
        setUploadStarted(false);
    };
    (0, _react.useEffect)(()=>{
        return stopPolling // cleanup on unmount
        ;
    }, []);
    if (!adCreative) return null;
    const handleFileDrop = async (e)=>{
        const file = 'files' in e.target ? e.target.files?.[0] : 'dataTransfer' in e ? e.dataTransfer.files?.[0] : undefined;
        if (!file) return;
        setUploading(true);
        setUploadError(null);
        setUploadStarted(true);
        try {
            await fetch(adCreative.uploadUrl, {
                method: 'PUT',
                body: file
            });
            startPolling(adCreative.id);
            dispatch((0, _adCreativeActions.createAdCreativeEvent)({
                id: adCreative.id,
                type: (0, _types.AdCreativeEvent).uploadOk
            }));
        } catch (err) {
            dispatch((0, _adCreativeActions.createAdCreativeEvent)({
                id: adCreative.id,
                type: (0, _types.AdCreativeEvent).uploadFailed
            }));
            setAdCreative({
                ...adCreative,
                events: [
                    ...adCreative.events,
                    (0, _types.AdCreativeEvent).uploadFailed
                ]
            });
            setUploadError('Upload failed');
            setUploadStarted(false);
        } finally{
            setUploading(false);
        }
    };
    const renderStatusIcon = (status, showSpinner = false)=>{
        if (status === 'ok') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {
            color: "success"
        });
        if (status === 'fail') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
            color: "error"
        });
        if (showSpinner) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
            size: 20
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioButtonUncheckedDefault.default), {
            color: "disabled"
        });
    };
    const getEventStatus = (eventOk, eventFail)=>{
        if (adCreative.events.includes(eventOk)) return 'ok';
        if (adCreative.events.includes(eventFail)) return 'fail';
        return 'pending';
    };
    const hasUploaded = adCreative.events.includes((0, _types.AdCreativeEvent).uploadOk);
    const { metadata } = adCreative;
    const formatDuration = (ms)=>typeof ms === 'number' ? `${(ms / 1000).toFixed(3)} s` : "\u2014";
    const handleClose = ()=>{
        setAdCreative(undefined);
        stopPolling();
        onClose();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        "data-test-id": 'ad-creative-upload-dialog',
        open: true,
        onClose: handleClose,
        maxWidth: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogTitleDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                    variant: "h2",
                    component: "div",
                    sx: {
                        fontWeight: 'normal'
                    },
                    children: [
                        "Upload media file for",
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            component: "span",
                            sx: {
                                fontWeight: 700
                            },
                            children: adCreative.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        display: "flex",
                        gap: 2,
                        mt: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                flex: 1,
                                sx: {
                                    border: '2px dashed grey',
                                    borderRadius: 2,
                                    p: 2,
                                    textAlign: 'center',
                                    cursor: hasUploaded ? 'default' : 'pointer',
                                    position: 'relative',
                                    opacity: hasUploaded ? 0.5 : 1
                                },
                                onClick: ()=>{
                                    if (!hasUploaded) document.getElementById('fileInput')?.click();
                                },
                                onDragOver: (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                onDrop: (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (hasUploaded) return;
                                    handleFileDrop(e);
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        id: "fileInput",
                                        type: "file",
                                        hidden: true,
                                        onChange: handleFileDrop,
                                        disabled: hasUploaded
                                    }),
                                    uploading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cloudUploadDefault.default), {
                                                fontSize: "large"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                mt: 1,
                                                children: "Click or drop file to upload"
                                            }),
                                            uploadError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                color: "error",
                                                children: uploadError
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                spacing: 1,
                                width: 200,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        children: [
                                            renderStatusIcon(getEventStatus((0, _types.AdCreativeEvent).uploadOk, (0, _types.AdCreativeEvent).uploadFailed), uploadStarted),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                children: "Upload"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        children: [
                                            renderStatusIcon(getEventStatus((0, _types.AdCreativeEvent).probeOk, (0, _types.AdCreativeEvent).probeFailed), uploadStarted),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                children: "Probe"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        children: [
                                            renderStatusIcon(getEventStatus((0, _types.AdCreativeEvent).thumbnailOk, (0, _types.AdCreativeEvent).thumbnailFailed), uploadStarted),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                children: "Thumbnail"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
                        in: !!metadata,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            mt: 3,
                            p: 2,
                            borderTop: "1px solid #ccc",
                            children: [
                                adCreative.errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    mb: 2,
                                    px: 1.5,
                                    py: 1,
                                    bgcolor: "error.main",
                                    color: "error.contrastText",
                                    borderRadius: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    maxWidth: "fit-content",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorOutlineDefault.default), {
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "body2",
                                            sx: {
                                                lineHeight: 1.2
                                            },
                                            children: adCreative.errorMessage
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    display: "flex",
                                    gap: 3,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                            spacing: 1,
                                            flex: 1,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                            children: "Duration:"
                                                        }),
                                                        ' ',
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                            component: "span",
                                                            color: "text.secondary",
                                                            children: formatDuration(metadata?.format?.durationMs)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                            children: "Bitrate:"
                                                        }),
                                                        ' ',
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                            component: "span",
                                                            color: "text.secondary",
                                                            children: (0, _helpers.formatBitrate)(metadata?.format?.bitrate)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _metadata.VideoMetadata), {
                                                    metadata: metadata,
                                                    sx: {
                                                        mt: 2,
                                                        p: 2
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _metadata.AudioMetadata), {
                                                    metadata: metadata,
                                                    sx: {
                                                        mt: 2,
                                                        p: 2
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            width: "50%",
                                            overflow: "hidden",
                                            sx: {
                                                mt: 'auto',
                                                mb: 'auto'
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnail.AdCreativeThumbnail), {
                                                adCreative: adCreative
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogActionsDefault.default), {
                sx: {
                    justifyContent: 'flex-end',
                    px: 3,
                    pb: 2
                },
                children: !hasUploaded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                    main: {
                        Cancel: {
                            onClick: onClose
                        }
                    }
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                    main: {
                        Dismiss: {
                            onClick: handleClose
                        },
                        Edit: {
                            onClick: ()=>navigate(routes.adCreativesUpdate({
                                    id: adCreative.id
                                })),
                            primary: true
                        }
                    }
                })
            })
        ]
    });
};
exports.default = UploadDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/CircularProgress":"kEtIR","@mui/material/Collapse":"c7nwP","@mui/material/Dialog":"aOxpM","@mui/material/DialogContent":"l4i9c","@mui/material/DialogTitle":"5aNce","@mui/material/Stack":"6thYv","@mui/material/Typography":"6NtGx","@mui/icons-material/CloudUpload":"aChp1","@mui/icons-material/CheckCircle":"crtKq","@mui/icons-material/Error":"4XfdO","@mui/icons-material/RadioButtonUnchecked":"eQ0Pf","common/api/v1/types":"3qemx","../../../store":"5LXiG","react-redux":"l1pMU","../../../redux/actions/adCreativeActions":"gzqhz","../../common/Thumbnail":"5Q8KF","@mui/icons-material/ErrorOutline":"3q6XB","./Edit/Metadata":"30RPP","common/api/v1/helpers":"6jovr","@mui/material/DialogActions":"h1RVn","../../common/Form":"4Mui7","react-router":"iaz4C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aChp1":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("6340cc84c42c5113").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("2ff6b93338e1ff49"));
var _jsxRuntime = require("51ce388355f027e4");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), 'CloudUpload');

},{"6340cc84c42c5113":"kZ6eK","2ff6b93338e1ff49":"2vOnF","51ce388355f027e4":"1dlk8"}],"eQ0Pf":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("cbba1c848ac3d4eb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("2f17715f7d7d0a6a"));
var _jsxRuntime = require("7226bd1d3eff549b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'RadioButtonUnchecked');

},{"cbba1c848ac3d4eb":"kZ6eK","2f17715f7d7d0a6a":"2vOnF","7226bd1d3eff549b":"1dlk8"}],"jh1Eq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _tooltip = require("../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _types = require("common/api/v1/types");
var _utils = require("../../../utils");
var _filteredSearchBar = require("../../common/Filters/FilterView/FilteredSearchBar");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _adCreativeActions = require("../../../redux/actions/adCreativeActions");
var _delete = require("@mui/icons-material/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _adCreativeFilter = require("./adCreativeFilter");
const BatchDeleteButton = ({ selected, setSelected, disabledMessage })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const showConfirmation = (0, _utils.useConfirmationDialog)();
    const onClick = ()=>{
        showConfirmation(()=>{
            dispatch((0, _adCreativeActions.deleteAdCreatives)(selected.map(({ id })=>id)));
            setSelected([]);
        }, 'Are you sure you want to remove the selected ad creatives?', selected.length === 1 ? selected[0].name : 'remove ad creatives', {
            ok: {
                text: 'remove',
                color: 'error'
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: disabledMessage ?? 'Remove selected ad creatives',
        disablePortal: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                "aria-label": "batch delete",
                onClick: onClick,
                disabled: !!disabledMessage,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {})
            })
        })
    });
};
const CommonActions = ({ adCreatives, selected, setSelected, user })=>{
    const { group } = (0, _utils.useUser)();
    const adCreativesMap = adCreatives.reduce((acc, item)=>({
            ...acc,
            [item.id]: item
        }), {});
    const showButtons = user.role === (0, _types.Role).super || selected.every((id)=>adCreativesMap[id]?.groupId === group);
    const isOwnerOfAllSelected = selected.every((id)=>adCreativesMap[id]?.createdBy === user.id);
    const filters = (0, _adCreativeFilter.makeAdCreativeFilters)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
        disableGutters: true,
        style: {
            overflowX: 'clip'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>theme.transitions.create('flex-shrink', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.shortest
                        })
                },
                style: {
                    flexShrink: selected.length > 0 ? 1 : 0,
                    flexGrow: 1,
                    flexBasis: '100%'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.UrlParamFilteredSearchBar), {
                    urlParamCacheKey: 'adCreatives',
                    mapFilterToUrlParamFn: (0, _adCreativeFilter.mapAdCreativeFilterToUrlParam),
                    mapUrlParamToFilterFn: (0, _adCreativeFilter.mapUrlParamToAdCreativeFilter),
                    searchTokenFilters: filters,
                    rawTextFilter: filters.find((f)=>f.key === (0, _adCreativeFilter.AdCreativeFilterKey).name)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    transition: (theme)=>// Fade out, i.e. keep visible until contents has left the screen
                        theme.transitions.create('visibility', {
                            delay: selected.length === 0 ? theme.transitions.duration.shortest : 0
                        })
                },
                style: {
                    marginLeft: 16,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    visibility: selected.length > 0 ? 'visible' : 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: 180,
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            variant: "subtitle1",
                            children: [
                                (0, _utils.pluralize)(selected.length, 'ad creative'),
                                " selected"
                            ]
                        })
                    }),
                    showButtons && /*#__PURE__*/ (0, _jsxRuntime.jsx)(BatchDeleteButton, {
                        selected: adCreatives.filter((d)=>selected.includes(d.id)),
                        setSelected: setSelected,
                        disabledMessage: user.role === (0, _types.Role).super || isOwnerOfAllSelected ? undefined : 'You are not the owner of a selected ad creative'
                    })
                ]
            })
        ]
    });
};
exports.default = CommonActions;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","@mui/material/IconButton":"488As","@mui/material/Typography":"6NtGx","@mui/material/Toolbar":"5Kohb","../../common/Tooltip":"crjvg","common/api/v1/types":"3qemx","../../../utils":"342UB","../../common/Filters/FilterView/FilteredSearchBar":"eEpmv","@mui/material/Box":"c4QkF","../../../redux/actions/adCreativeActions":"gzqhz","@mui/icons-material/Delete":"69aC7","./adCreativeFilter":"fetg1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fetg1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdCreativeFilterKey", ()=>AdCreativeFilterKey);
parcelHelpers.export(exports, "mapAdCreativeFilterToUrlParam", ()=>mapAdCreativeFilterToUrlParam);
parcelHelpers.export(exports, "mapUrlParamToAdCreativeFilter", ()=>mapUrlParamToAdCreativeFilter);
parcelHelpers.export(exports, "makeAdCreativeFilters", ()=>makeAdCreativeFilters);
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _dateFilter = require("../../common/Filters/FilterView/dateFilter");
var _types = require("common/api/v1/types");
var AdCreativeFilterKey = /*#__PURE__*/ function(AdCreativeFilterKey) {
    AdCreativeFilterKey["name"] = "name";
    AdCreativeFilterKey["created"] = "created";
    AdCreativeFilterKey["status"] = "status";
    return AdCreativeFilterKey;
}({});
function mapAdCreativeFilterToUrlParam(filter) {
    if ('value' in filter) switch(filter.key){
        case "name":
            return {
                filter: filter.value
            };
        case "created":
            return filter.operator === 'after' ? {
                fromDate: new Date(filter.value).toISOString()
            } : {
                toDate: new Date(filter.value).toISOString()
            };
        case "status":
            return {
                status: filter.value
            };
    }
    return {};
}
function mapUrlParamToAdCreativeFilter(key, value) {
    switch(key){
        case 'filter':
            return {
                key: "name",
                operator: 'matches',
                value
            };
        case 'fromDate':
            return {
                key: "created",
                operator: 'after',
                value: (0, _dateFns.format)(new Date(value), (0, _helpers.DATE_FORMAT_LONGER))
            };
        case 'toDate':
            return {
                key: "created",
                operator: 'before',
                value: (0, _dateFns.format)(new Date(value), (0, _helpers.DATE_FORMAT_LONGER))
            };
        case 'status':
            return {
                key: "status",
                operator: 'is',
                value: value,
                displayName: (0, _helpers.sentenceCase)(value)
            };
    }
    return undefined;
}
function makeAdCreativeFilters() {
    const filterTemplates = [
        {
            key: "name",
            operator: 'matches'
        },
        {
            key: "created",
            operator: 'after',
            possibleValuesSync: (s)=>(0, _dateFilter.dateFilterPossibleValues)(s)
        },
        {
            key: "created",
            operator: 'before',
            possibleValuesSync: (s)=>(0, _dateFilter.dateFilterPossibleValues)(s)
        },
        {
            key: "status",
            operator: 'is',
            possibleValuesSync: ()=>Object.values((0, _types.AdCreativeStatus)).map((status)=>({
                        value: status,
                        displayName: (0, _helpers.sentenceCase)(status)
                    }))
        }
    ];
    return filterTemplates.sort((a, b)=>a.key.localeCompare(b.key));
}

},{"date-fns":"gelMX","common/api/v1/helpers":"6jovr","../../common/Filters/FilterView/dateFilter":"dRpLd","common/api/v1/types":"3qemx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jOfY5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
const CreateDialog = ({ open, onClose, onCreate })=>{
    const [name, setName] = (0, _react.useState)('');
    const handleNext = ()=>{
        if (name.trim()) onCreate({
            name: name.trim()
        });
    };
    (0, _react.useEffect)(()=>{
        if (open) setName('');
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        "data-test-id": 'ad-creative-create-dialog',
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogTitleDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "h2",
                    component: "div",
                    sx: {
                        fontWeight: 'normal'
                    },
                    children: "Create new ad creative"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                        name: "name",
                        fullWidth: true,
                        label: "Name",
                        value: name,
                        onChange: (e)=>setName(e.target.value),
                        autoFocus: true,
                        margin: "normal"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            mt: 1
                        },
                        children: "You will upload your file in the next step."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogActionsDefault.default), {
                sx: {
                    px: 3,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        id: 'button-cancel',
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        id: 'button-next',
                        onClick: handleNext,
                        variant: "contained",
                        disabled: !name.trim(),
                        children: "Next"
                    })
                ]
            })
        ]
    });
};
exports.default = CreateDialog;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Button":"3qJY9","@mui/material/Dialog":"aOxpM","@mui/material/DialogActions":"h1RVn","@mui/material/DialogContent":"l4i9c","@mui/material/DialogTitle":"5aNce","@mui/material/TextField":"l88b4","@mui/material/Typography":"6NtGx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hL4a8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditAdPod", ()=>EditAdPod);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _types = require("common/api/v1/types");
var _rhf = require("../../../common/Form/RHF");
var _rhfDefault = parcelHelpers.interopDefault(_rhf);
var _store = require("../../../../store");
var _wrapper = require("../../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _utils = require("../../../../utils");
var _adCreativeActions = require("../../../../redux/actions/adCreativeActions");
var _form = require("../../../common/Form");
var _util = require("common/util");
var _adPodActions = require("../../../../redux/actions/adPodActions");
var _transferList = require("./TransferList");
var _transferListDefault = parcelHelpers.interopDefault(_transferList);
var _reactHookForm = require("react-hook-form");
const getInitialState = (adPod)=>({
        id: adPod?.id || '',
        name: adPod?.name || '',
        outputIds: adPod?.outputIds || [],
        creatives: adPod?.creatives || [],
        adPod: adPod
    });
const isEditing = (values)=>values?.adPod?.id !== undefined;
const AdPodForm = ({ getValues, setError, setFocus, formState })=>{
    const values = getValues();
    const routes = (0, _store.useRoutes)();
    const navigate = (0, _reactRouter.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const setConfirmation = (0, _utils.useConfirmationDialog)();
    const { formErrors, saving } = (0, _reactRedux.useSelector)(({ groupsReducer })=>({
            formErrors: groupsReducer.formErrors,
            saving: groupsReducer.saving
        }), (0, _reactRedux.shallowEqual));
    const { fields: selectedAdCreatives, replace, append } = (0, _reactHookForm.useFieldArray)({
        name: 'creatives',
        keyName: 'fieldId'
    });
    (0, _react.useEffect)(()=>{
        if (Array.isArray(selectedAdCreatives) && selectedAdCreatives.length > 0) {
            const newSelectedAdCreatives = selectedAdCreatives.map((item, index)=>({
                    ...item,
                    locId: `${index}`
                }));
            replace(newSelectedAdCreatives);
        }
    }, [
        selectedAdCreatives.length
    ]);
    const user = (0, _utils.useUser)();
    (0, _react.useEffect)(()=>{
        if (Array.isArray(formErrors)) {
            formErrors.forEach((item)=>{
                setError(item.name, {
                    type: 'manual',
                    message: item.reason
                });
            });
            if (formErrors[0]) setFocus(formErrors[0].name);
        }
    }, [
        formErrors,
        setError,
        setFocus
    ]);
    if (user.role !== (0, _types.Role).super && (user.role !== (0, _types.Role).admin || user.group !== values.id)) {
        navigate(-1);
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        container: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            size: {
                xs: 12
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.SafeRouting), {
                    formState: formState
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                    id: "ad-creative-form",
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                            sx: {
                                p: 2
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.TextInput), {
                                name: "name",
                                label: "Name",
                                required: true,
                                autoFocus: true
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                            title: "Creatives",
                            className: "outlined",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transferListDefault.default), {
                                adCreatives: selectedAdCreatives,
                                onAdd: (adCreatives)=>{
                                    append(adCreatives);
                                },
                                onRemove: (adCreatives)=>{
                                    const newAdCreatives = selectedAdCreatives.filter((item)=>!adCreatives.find((i)=>i.locId === item.locId));
                                    replace(newAdCreatives);
                                },
                                onToggleFiller: (adCreatives)=>{
                                    const anyNotFiller = adCreatives.some((c)=>!c.filler);
                                    const newAdCreatives = selectedAdCreatives.map((item)=>({
                                            ...item,
                                            filler: adCreatives.find((ad)=>ad.locId == item.locId) ? anyNotFiller : item.filler
                                        }));
                                    replace(newAdCreatives);
                                },
                                onReorder: (item, from, to)=>{
                                    const newAdCreatives = [
                                        ...selectedAdCreatives
                                    ];
                                    newAdCreatives.splice(from, 1);
                                    newAdCreatives.splice(to, 0, item);
                                    newAdCreatives.forEach((creative, index)=>{
                                        creative.locId = `${index}`;
                                    });
                                    replace(newAdCreatives);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.ButtonsPane), {
                            main: {
                                Cancel: {
                                    onClick: ()=>navigate(routes.adCreatives())
                                },
                                Save: {
                                    savingState: !!saving,
                                    primary: true,
                                    type: 'submit'
                                }
                            },
                            secondary: user.role === (0, _types.Role).super ? {
                                Delete: {
                                    onClick: ()=>setConfirmation(()=>{
                                            dispatch((0, _adCreativeActions.deleteAdCreative)(values.id));
                                            navigate(routes.adCreatives());
                                        }, 'Are you sure you want to delete this Ad Pod?', values.name)
                                }
                            } : undefined
                        })
                    ]
                })
            ]
        })
    });
};
const EditAdPod = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        id && dispatch((0, _adPodActions.getAdPod)(id));
        return ()=>{
            dispatch((0, _adPodActions.clearAdPod)());
        };
    }, []);
    const selectedAdPod = (0, _reactRedux.useSelector)(({ adPodReducer })=>adPodReducer.selectedAdPod, (0, _util.equals));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Ad Insertion',
            'Ad Pods',
            id ? selectedAdPod?.name : 'New'
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
            pending: !!id && !selectedAdPod,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rhfDefault.default), {
                onSubmit: (values)=>{
                    const { adPod, ...updateOrCreate } = values;
                    if (isEditing(values)) dispatch((0, _adPodActions.updateAdPod)((0, _utils.formTransform)(updateOrCreate)));
                    else dispatch((0, _adPodActions.createAdPod)((0, _utils.formTransform)(updateOrCreate)));
                },
                defaultValues: getInitialState(selectedAdPod),
                component: AdPodForm
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","@mui/material/Grid":"6iX4B","common/api/v1/types":"3qemx","../../../common/Form/RHF":"7gFt3","../../../../store":"5LXiG","../../../common/Wrapper":"8oy7r","../../../common/Pendable":"gDN67","../../../../utils":"342UB","../../../../redux/actions/adCreativeActions":"gzqhz","../../../common/Form":"4Mui7","common/util":"jV4UZ","../../../../redux/actions/adPodActions":"2olSr","./TransferList":"9FB8s","react-hook-form":"8z0aI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9FB8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _adCreativeActions = require("../../../../redux/actions/adCreativeActions");
var _store = require("../../../../store");
var _reactRedux = require("react-redux");
var _tableConfig = require("../../adCreative/tableConfig");
var _utils = require("../../../../utils");
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _table1 = require("../../../common/Table");
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _draggableAdCreativeRow = require("./DraggableAdCreativeRow");
var _draggableAdCreativeRowDefault = parcelHelpers.interopDefault(_draggableAdCreativeRow);
var _filteredSearchBar = require("../../../common/Filters/FilterView/FilteredSearchBar");
var _adCreativeFilter = require("../../adCreative/adCreativeFilter");
var _filterTemplate = require("../../../common/Filters/FilterView/FilterTemplate");
const TransferList = ({ adCreatives, onAdd, onRemove, onToggleFiller, onReorder })=>{
    const [checkedLeft, setCheckedLeft] = (0, _react.useState)([]) // ID for the left panel
    ;
    const [checkedRight, setCheckedRight] = (0, _react.useState)([]) // _locId for the right panel
    ;
    const [searchParams, setSearchParams] = (0, _react.useState)((0, _utils.withDefaultPagination)({}));
    const [appliedFilters, setAppliedFilters] = (0, _react.useState)([]);
    const user = (0, _utils.useUser)();
    const routes = (0, _store.useRoutes)();
    const [selectedPagination, setSelectedPagination] = (0, _react.useState)({
        pageNumber: '0',
        rowsPerPage: '10'
    });
    const dispatch = (0, _reactRedux.useDispatch)();
    const { fetchedAdCreatives, totalFetched, loading } = (0, _reactRedux.useSelector)(({ adCreativeReducer })=>({
            fetchedAdCreatives: adCreativeReducer.adCreatives,
            totalFetched: adCreativeReducer.total,
            loading: adCreativeReducer.loading
        }), (0, _reactRedux.shallowEqual));
    if (fetchedAdCreatives) {
        const withLocId = fetchedAdCreatives;
        withLocId.forEach((item, index)=>{
            item.locId = item.locId || `${index}` // Ensure locId is set for each item
            ;
        });
    }
    const refreshAdCreatives = ()=>{
        dispatch((0, _adCreativeActions.listAdCreatives)(searchParams));
    };
    (0, _react.useEffect)(()=>{
        refreshAdCreatives();
    }, [
        dispatch,
        searchParams
    ]);
    const handleToggle = (id, side)=>{
        const setChecked = side === 'left' ? setCheckedLeft : setCheckedRight;
        const checked = side === 'left' ? checkedLeft : checkedRight;
        setChecked(checked.includes(id) ? checked.filter((i)=>i !== id) : [
            ...checked,
            id
        ]);
    };
    const handleSelectAll = (items, side)=>{
        const allIds = items.map((i)=>i.id);
        const checked = side === 'left' ? checkedLeft : checkedRight;
        const setChecked = side === 'left' ? setCheckedLeft : setCheckedRight;
        const allSelected = allIds.every((id)=>checked.includes(id));
        setChecked(allSelected ? checked.filter((id)=>!allIds.includes(id)) : [
            ...checked,
            ...allIds.filter((id)=>!checked.includes(id))
        ]);
    };
    const handleAdd = ()=>{
        if (!fetchedAdCreatives) return;
        const itemsToAdd = fetchedAdCreatives.filter((item)=>checkedLeft.includes(item.id));
        onAdd(itemsToAdd);
        setCheckedLeft([]);
    };
    const handleRemove = ()=>{
        const itemsToRemove = adCreatives.filter((item)=>checkedRight.includes(item.locId));
        onRemove(itemsToRemove);
        setCheckedRight([]);
    };
    const getSlicedAdCreatives = (page, rowsPerPage)=>{
        const start = parseInt(page) * parseInt(rowsPerPage);
        const end = start + parseInt(rowsPerPage);
        return adCreatives.slice(start, end);
    };
    const dataLeft = fetchedAdCreatives || [];
    const dataRight = getSlicedAdCreatives(selectedPagination.pageNumber, selectedPagination.rowsPerPage);
    const configLeft = (0, _tableConfig.getTransferTableConfig)({
        adCreatives: dataLeft,
        selected: checkedLeft,
        handleSelect: (id)=>handleToggle(id, 'left'),
        handleSelectAll: ()=>handleSelectAll(dataLeft, 'left'),
        dragable: false,
        side: 'left',
        user,
        routes
    }).filter((c)=>c !== null);
    const configRight = (0, _tableConfig.getTransferTableConfig)({
        adCreatives: dataRight,
        selected: checkedRight,
        handleSelect: (id)=>handleToggle(id, 'right'),
        handleSelectAll: ()=>handleSelectAll(dataRight, 'right'),
        dragable: true,
        side: 'right',
        user,
        routes
    }).filter((c)=>c !== null);
    const filters = (0, _adCreativeFilter.makeAdCreativeFilters)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            height: '50vh',
            width: '100%',
            mt: 2,
            display: 'flex'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            container: true,
            spacing: 2,
            sx: {
                height: '100%',
                flexGrow: 1
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                    size: {
                        xs: 5.5
                    },
                    sx: {
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'background.paper',
                        borderRadius: 1,
                        p: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "h6",
                            sx: {
                                p: 1,
                                flexShrink: 0
                            },
                            children: "Available"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                mt: 1,
                                mb: 1
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filteredSearchBar.FilteredSearchBar), {
                                appliedFilters: appliedFilters,
                                onFiltersApplied: (filters)=>{
                                    setSearchParams((prev)=>({
                                            ...(0, _filterTemplate.filtersToUrlParams)(filters, appliedFilters, (0, _adCreativeFilter.mapAdCreativeFilterToUrlParam)),
                                            pageNumber: '0',
                                            rowsPerPage: prev.rowsPerPage
                                        }));
                                    setAppliedFilters(filters);
                                },
                                searchTokenFilters: filters,
                                rawTextFilter: filters.find((f)=>f.key === (0, _adCreativeFilter.AdCreativeFilterKey).name)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                flexGrow: 1,
                                overflowY: 'auto',
                                borderRadius: '4px'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                                pending: loading,
                                cover: !!dataLeft.length,
                                id: "available-ad-creatives-table",
                                children: dataLeft.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                                    id: "available-ad-creatives-table",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                                        children: dataLeft.map((item, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                                hover: true,
                                                children: configLeft.map(({ getValue, props, title })=>/*#__PURE__*/ (0, _react.createElement)((0, _tableCellDefault.default), {
                                                        ...props,
                                                        "data-cell-name": `${title}-cell`,
                                                        key: `${item.id}-${title}`
                                                    }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                        component: "div",
                                                        variant: "body2",
                                                        children: getValue(item, i)
                                                    })))
                                            }, item.id))
                                    })
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    sx: {
                                        p: 2,
                                        textAlign: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        children: "No available creatives."
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                flexShrink: 0,
                                mt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table1.Pagination), {
                                    id: "available-ad-creatives-pagination",
                                    total: totalFetched,
                                    page: searchParams.pageNumber || '0',
                                    perPage: searchParams.rowsPerPage || '10',
                                    changePageCallback: (page)=>{
                                        setSearchParams((prev)=>({
                                                ...prev,
                                                pageNumber: page
                                            }));
                                    },
                                    changeRowsPerPageCallback: (rowsPerPage)=>{
                                        setSearchParams((prev)=>({
                                                ...prev,
                                                pageNumber: '0',
                                                rowsPerPage
                                            }));
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    size: {
                        xs: 1
                    },
                    sx: {
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                id: "button-transfer-add",
                                variant: "outlined",
                                size: "small",
                                onClick: handleAdd,
                                disabled: !fetchedAdCreatives || checkedLeft.length === 0,
                                "aria-label": "move selected right",
                                children: "Add >"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                id: "button-transfer-remove",
                                variant: "outlined",
                                size: "small",
                                onClick: handleRemove,
                                disabled: checkedRight.length === 0,
                                "aria-label": "move selected left",
                                children: "< Remove"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                    size: {
                        xs: 5.5
                    },
                    sx: {
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'background.paper',
                        borderRadius: 1,
                        p: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "h6",
                            sx: {
                                p: 1,
                                flexShrink: 0
                            },
                            children: "Selected"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                flexGrow: 1,
                                overflowY: 'auto',
                                borderRadius: '4px'
                            },
                            children: dataRight.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                                id: "selected-ad-creatives-table",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                                    children: dataRight.map((item, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableAdCreativeRowDefault.default), {
                                            id: item.id,
                                            index: i,
                                            moveRow: (fromLocal, toLocal)=>{
                                                const pageOffset = parseInt(selectedPagination.pageNumber) * parseInt(selectedPagination.rowsPerPage);
                                                const from = fromLocal + pageOffset;
                                                const to = toLocal + pageOffset;
                                                const updated = [
                                                    ...adCreatives
                                                ];
                                                const [movedItem] = updated.splice(from, 1);
                                                updated.splice(to, 0, movedItem);
                                                const updatedCheckedRight = checkedRight.map((locId)=>{
                                                    const index = parseInt(locId);
                                                    if (index === from) return `${to}`;
                                                    if (from > to && index >= to && index < from) return `${index + 1}`;
                                                    if (from < to && index > from && index <= to) return `${index - 1}`;
                                                    return locId;
                                                });
                                                setCheckedRight(updatedCheckedRight);
                                                onReorder(movedItem, from, to);
                                            },
                                            children: configRight.map(({ getValue, props, title })=>/*#__PURE__*/ (0, _react.createElement)((0, _tableCellDefault.default), {
                                                    ...props,
                                                    "data-cell-name": `${title}-cell`,
                                                    key: `${item.id}-${title}`
                                                }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                    component: "div",
                                                    variant: "body2",
                                                    children: getValue(item, i)
                                                })))
                                        }, `${item.id}-${i}`))
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                sx: {
                                    p: 2,
                                    textAlign: 'center'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    children: "No selected creatives."
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                            direction: 'row',
                            sx: {
                                flexShrink: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    sx: {
                                        flexShrink: 0,
                                        flexGrow: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        ml: 2
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        disabled: checkedRight.length === 0,
                                        variant: 'outlined',
                                        onClick: ()=>{
                                            onToggleFiller(adCreatives.filter((item)=>checkedRight.includes(item.locId)));
                                        },
                                        children: "Toggle Filler"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table1.Pagination), {
                                    total: adCreatives.length,
                                    page: selectedPagination.pageNumber,
                                    perPage: selectedPagination.rowsPerPage,
                                    changePageCallback: (page)=>{
                                        setSelectedPagination((prev)=>({
                                                ...prev,
                                                pageNumber: page
                                            }));
                                    },
                                    changeRowsPerPageCallback: (rowsPerPage)=>{
                                        setSelectedPagination((prev)=>({
                                                ...prev,
                                                pageNumber: '0',
                                                rowsPerPage
                                            }));
                                    },
                                    id: "selected-ad-creatives-pagination"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = TransferList;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","@mui/material/Stack":"6thYv","@mui/material/Grid":"6iX4B","../../../../redux/actions/adCreativeActions":"gzqhz","../../../../store":"5LXiG","react-redux":"l1pMU","../../adCreative/tableConfig":"G6Vjg","../../../../utils":"342UB","@mui/material/Table":"k4r1H","@mui/material/TableRow":"bLA0R","@mui/material/TableCell":"6WlPV","@mui/material/TableBody":"2jHBQ","@mui/material/Typography":"6NtGx","@mui/material/Divider":"9Ul8c","../../../common/Table":"dt9lf","../../../common/Pendable":"gDN67","./DraggableAdCreativeRow":"bmmzW","../../../common/Filters/FilterView/FilteredSearchBar":"eEpmv","../../adCreative/adCreativeFilter":"fetg1","../../../common/Filters/FilterView/FilterTemplate":"hhlHk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bmmzW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDnd = require("react-dnd");
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
const ItemType = 'AD_CREATIVE';
const DraggableAdCreativeRow = ({ id, index, moveRow, children })=>{
    const ref = (0, _react.useRef)(null);
    const dragRef = (0, _react.useRef)(null);
    const [, drop] = (0, _reactDnd.useDrop)({
        accept: ItemType,
        drop (item) {
            if (!ref.current || item.index === index) return;
            moveRow(item.index, index);
            item.index = index;
        }
    });
    const [{ isDragging }, drag] = (0, _reactDnd.useDrag)({
        type: ItemType,
        item: {
            id,
            index
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            })
    });
    (0, _react.useEffect)(()=>{
        if (dragRef.current) drag(dragRef);
    }, [
        dragRef
    ]);
    drag(drop(ref));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
        ref: ref,
        hover: true,
        sx: {
            opacity: isDragging ? 0.5 : 1
        },
        children: (0, _reactDefault.default).Children.map(children, (child)=>{
            if (child?.props?.children?.props?.['data-drag-handle-id'] === id) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
                ref: dragRef
            });
            return child;
        })
    });
};
exports.default = DraggableAdCreativeRow;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dnd":"aAvQg","@mui/material/TableRow":"bLA0R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cbXXQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewAdBreak", ()=>ViewAdBreak);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _store = require("../../../../store");
var _wrapper = require("../../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _pendable = require("../../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _form = require("../../../common/Form");
var _util = require("common/util");
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _adBreakActions = require("../../../../redux/actions/adBreakActions");
var _adPodActions = require("../../../../redux/actions/adPodActions");
var _types = require("common/api/v1/types");
var _dataSet = require("../../../common/DataSet");
var _dataSetDefault = parcelHelpers.interopDefault(_dataSet);
var _tooltip = require("../../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tableConfig = require("../tableConfig");
var _styles = require("../styles");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _link = require("../../../common/Link");
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _utils = require("../utils");
var _utils1 = require("../../../../utils");
var _trackingSection = require("./TrackingSection");
var _auditSection = require("./AuditSection");
var _adCreativeActions = require("../../../../redux/actions/adCreativeActions");
var _adServerActions = require("../../../../redux/actions/adServerActions");
var _adInsertion = require("common/adInsertion");
const { outputApi } = (0, _store.Api);
const ViewAdBreak = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const [output, setOutput] = (0, _react.useState)(null);
    const [refreshTimestamp, setRefreshTimestamp] = (0, _react.useState)(Date.now());
    const dispatch = (0, _reactRedux.useDispatch)();
    const user = (0, _utils1.useUser)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { adBreak, adPod, adServer } = (0, _reactRedux.useSelector)(({ adBreakReducer, adPodReducer, adInsertionReducer })=>({
            adBreak: adBreakReducer.selectedAdBreak,
            adPod: adPodReducer.selectedAdPod,
            adServer: adInsertionReducer.selectedAdServer
        }), (0, _util.equals));
    const { adCreatives } = (0, _reactRedux.useSelector)(({ adCreativeReducer })=>({
            adCreatives: adCreativeReducer.adCreatives
        }), (0, _util.equals));
    const [openVast, setOpenVast] = (0, _react.useState)(false);
    const routes = (0, _store.useRoutes)();
    (0, _react.useEffect)(()=>{
        if (!id) return;
        const fetchAdBreak = ()=>{
            dispatch((0, _adBreakActions.getAdBreak)(id));
            setRefreshTimestamp(Date.now());
        };
        fetchAdBreak() // Initial fetch
        ;
        const interval = setInterval(fetchAdBreak, 500);
        return ()=>{
            clearInterval(interval);
            dispatch((0, _adBreakActions.clearAdBreak)());
        };
    }, [
        id,
        dispatch
    ]);
    (0, _react.useEffect)(()=>{
        if (adBreak) dispatch((0, _adCreativeActions.listAdCreatives)({
            adBreakId: adBreak.id,
            pageNumber: '0',
            rowsPerPage: '1000'
        }));
    }, [
        dispatch,
        adBreak
    ]);
    (0, _react.useEffect)(()=>{
        if (adBreak?.adPodId) dispatch((0, _adPodActions.getAdPod)(adBreak.adPodId));
        return ()=>{
            if (adBreak?.adPodId) dispatch((0, _adPodActions.clearAdPod)());
        };
    }, [
        adBreak?.adPodId,
        dispatch
    ]);
    (0, _react.useEffect)(()=>{
        const ads = adBreak?.playlist?.ads;
        if (ads && ads.length > 0) {
            const splits = (0, _adInsertion.splitPlaylistAdId)(ads[0].id);
            if (splits) {
                const { adServerId, isBuiltIn } = splits;
                if (!isBuiltIn) dispatch((0, _adServerActions.getAdServer)(adServerId));
            }
        }
    }, [
        adBreak?.playlist,
        dispatch
    ]);
    (0, _react.useEffect)(()=>{
        if (adBreak?.outputId) outputApi.getOutput(adBreak.outputId).then((res)=>setOutput(res)).catch(()=>setOutput(null));
    }, [
        adBreak?.outputId
    ]);
    if (!adBreak) return null;
    if (user.role !== (0, _types.Role).super && (user.role !== (0, _types.Role).admin || user.group !== adBreak.groupId)) {
        navigate(-1);
        return null;
    }
    const dataset = (adBreak)=>{
        return {
            Created: (0, _dateFns.format)(new Date(adBreak.createdAt), (0, _helpers.DATE_FORMAT_LONG)),
            Status: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                direction: 'row',
                spacing: 2,
                sx: (0, _styles.styles).inlineWrapper,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableConfig.AdBreakStatusIcon), {
                        status: adBreak.status
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "div",
                        children: (0, _tableConfig.adBreakStatusText)(adBreak.status, adBreak.errorMessage)
                    })
                ]
            }),
            Duration: (()=>{
                const { duration } = (0, _utils.getDuration)(adBreak);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: `${duration ? `${duration} ms` : '-'}`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: (0, _utils.getDurationFormatted)(adBreak)
                    })
                });
            })(),
            'Event ID': adBreak.eventId,
            'Start Time': (0, _utils.getStartTimeFormatted)(adBreak),
            'End Time': (0, _utils.getEndTimeFormatted)(adBreak),
            VAST: (()=>{
                if (adBreak.vastXml) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    color: "secondary.main",
                    sx: {
                        cursor: 'pointer',
                        userSelect: 'none'
                    },
                    onClick: ()=>setOpenVast(true),
                    children: "View XML"
                });
                return '-';
            })(),
            Output: (()=>{
                if (output) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.outputsUpdate({
                        id: output.id
                    }),
                    underline: "hover",
                    available: !!output.id,
                    children: output.name
                });
                return '-';
            })(),
            'Ad Pod': (()=>{
                if (adPod) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                    to: routes.adPodsUpdate({
                        id: adPod.id
                    }),
                    underline: "hover",
                    available: !!adPod.id,
                    children: adPod.name
                });
                return '-';
            })()
        };
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(VastDialog, {
                vastXml: adBreak.vastXml,
                onClose: ()=>setOpenVast(false),
                open: openVast
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
                name: [
                    'Ad Insertion',
                    'Ad Breaks',
                    (0, _dateFns.format)(new Date(adBreak.createdAt), (0, _helpers.DATE_FORMAT_LONG))
                ],
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pendableDefault.default), {
                    pending: !!id && !adBreak,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
                            title: 'Metadata',
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataSetDefault.default), {
                                values: dataset(adBreak)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trackingSection.TrackingSection), {
                            adBreak: adBreak,
                            adCreatives: adCreatives
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _auditSection.AuditSection), {
                            dispatch: dispatch,
                            adBreak: adBreak,
                            adCreatives: adCreatives,
                            adPod: adPod,
                            adServer: adServer,
                            refreshTrigger: refreshTimestamp
                        })
                    ]
                })
            })
        ]
    });
};
const VastDialog = ({ open, onClose, vastXml })=>{
    if (!vastXml) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        open: open,
        onClose: onClose,
        maxWidth: "xl",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogTitleDefault.default), {
                children: "VAST XML"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                    style: {
                        wordBreak: 'break-word',
                        fontFamily: 'monospace',
                        fontSize: '0.9rem',
                        margin: 0
                    },
                    children: vastXml
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogActionsDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: onClose,
                    children: "Close"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-redux":"l1pMU","react-router":"iaz4C","../../../../store":"5LXiG","../../../common/Wrapper":"8oy7r","../../../common/Pendable":"gDN67","../../../common/Form":"4Mui7","common/util":"jV4UZ","date-fns":"gelMX","common/api/v1/helpers":"6jovr","../../../../redux/actions/adBreakActions":"baydX","../../../../redux/actions/adPodActions":"2olSr","common/api/v1/types":"3qemx","../../../common/DataSet":"dmQXG","../../../common/Tooltip":"crjvg","../tableConfig":"gCXMq","../styles":"9xVZT","@mui/material/Typography":"6NtGx","@mui/material/Stack":"6thYv","../../../common/Link":"l3o6V","@mui/material/Dialog":"aOxpM","@mui/material/DialogTitle":"5aNce","@mui/material/DialogContent":"l4i9c","@mui/material/DialogActions":"h1RVn","@mui/material/Button":"3qJY9","../utils":"azUNr","../../../../utils":"342UB","./TrackingSection":"aCaOt","./AuditSection":"7R9a8","../../../../redux/actions/adCreativeActions":"gzqhz","../../../../redux/actions/adServerActions":"h89Of","common/adInsertion":"02Gqt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9xVZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styles", ()=>styles);
const styles = {
    inlineWrapper: {
        display: 'flex',
        alignItems: 'center',
        '& > span': {
            marginLeft: (theme)=>theme.spacing(1)
        }
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '34px',
        height: '34px',
        pointerEvents: 'all',
        '& svg': {
            display: 'block'
        }
    },
    warning: {
        color: (theme)=>theme.palette.warning.main
    },
    error: {
        color: (theme)=>theme.palette.error.main
    },
    success: {
        color: (theme)=>theme.palette.success.main
    },
    cell: {
        borderBottom: 'none'
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCaOt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrackingSection", ()=>TrackingSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _store = require("../../../../store");
var _form = require("../../../common/Form");
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _tooltip = require("../../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("../styles");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _columnHeader = require("../../../common/Table/ColumnHeader");
var _columnHeaderDefault = parcelHelpers.interopDefault(_columnHeader);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _fiberManualRecord = require("@mui/icons-material/FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _link = require("../../../common/Link");
var _thumbnail = require("../../../common/Thumbnail");
var _error = require("@mui/icons-material/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
const TrackingSection = ({ adBreak, adCreatives })=>{
    const routes = (0, _store.useRoutes)();
    const trackingGroups = adBreak.trackingEvents?.reduce((acc, event)=>{
        const { adCreativeId, podIndex } = event;
        const trackingGroupId = `${adCreativeId}-${podIndex}`;
        if (!acc[trackingGroupId]) {
            const applianceAd = adBreak.playlist?.ads?.find((ad)=>ad.id.endsWith(adCreativeId));
            const adCreative = adCreatives.find((creative)=>creative.id === adCreativeId);
            acc[trackingGroupId] = {
                adCreativeId,
                podIndex,
                events: [],
                applianceAd,
                adCreative
            };
        }
        acc[trackingGroupId].events.push(event);
        return acc;
    }, {}) ?? {};
    const flattenedTrackingGroups = Object.values(trackingGroups).map((group)=>({
            ...group,
            events: group.events.map((event)=>({
                    ...event
                }))
        }));
    const tableConfig = [
        {
            title: 'Tracking Events',
            getValue: ({ events })=>{
                const statusMessage = (event)=>{
                    if (event.eventType === 'error') {
                        if ('errorCode' in event && event.errorCode !== '[ERRORCODE]') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                `${event.errorMessage || 'Unknown error'} (VAST error code:`,
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: event.errorCode
                                }),
                                ")"
                            ]
                        });
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Unknown error"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                event.reportedAt ? `Reported: ${(0, _dateFns.format)(event.reportedAt, (0, _helpers.DATE_FORMAT_LONG))}` : ``
                            ]
                        });
                    }
                    if (event.reportCount > 1) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: event.eventType
                            }),
                            " reported ",
                            event.reportCount,
                            " times",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            event.reportedAt ? `Last reported: ${(0, _dateFns.format)(event.reportedAt, (0, _helpers.DATE_FORMAT_LONG))}` : ``
                        ]
                    });
                    if (event.reportedAt) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: event.eventType
                            }),
                            " successfully reported",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            event.reportedAt ? `Reported: ${(0, _dateFns.format)(event.reportedAt, (0, _helpers.DATE_FORMAT_LONG))}` : ``
                        ]
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: event.eventType
                            }),
                            " pending"
                        ]
                    });
                };
                const Icon = ({ event })=>{
                    if (event.eventType === 'error') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                        sx: {
                            color: 'error.main'
                        }
                    });
                    if (event.reportCount > 1) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                        sx: {
                            color: 'warning.main'
                        }
                    });
                    if (event.reportedAt) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {
                        sx: {
                            color: 'success.main'
                        }
                    });
                    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiberManualRecordDefault.default), {
                        fontSize: "small",
                        sx: {
                            color: 'grey'
                        }
                    });
                };
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                    direction: 'row',
                    spacing: 1,
                    children: events.map((event)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: statusMessage(event),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                sx: {
                                    ...(0, _styles.styles).container,
                                    width: 20,
                                    height: 20
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                                    event: event
                                })
                            }, event.eventType)
                        });
                    })
                });
            },
            props: {
                align: 'left',
                width: '100px'
            }
        },
        {
            title: '',
            getValue: ({ applianceAd })=>{
                if (applianceAd?.filler) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: `A filler ad creative is used to fill gaps in ad pods and is not required to be tracked`,
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                        label: "Filler",
                        size: "small",
                        color: "warning"
                    })
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
            }
        },
        {
            title: 'Thumbnail',
            getValue: ({ adCreative })=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: 150
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _thumbnail.AdCreativeThumbnail), {
                        adCreative: adCreative
                    })
                });
            }
        },
        {
            title: 'Ad Creative',
            getValue: ({ adCreative })=>{
                if (!adCreative) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: 'Ad Creative not found. It might have been deleted',
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "div",
                        variant: "body2",
                        children: "-"
                    })
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: adCreative.status === 'active' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                        underline: "hover",
                        to: routes.adCreativesUpdate({
                            id: adCreative.id
                        }),
                        children: adCreative.name
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "div",
                        variant: "body2",
                        children: adCreative.name
                    })
                });
            }
        },
        {
            title: 'Duration',
            getValue: ({ applianceAd })=>{
                if (!applianceAd) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: 'Ad not found. It might have been deleted',
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "div",
                        variant: "body2",
                        children: "-"
                    })
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: `${applianceAd.durationMs} ms`,
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "div",
                        variant: "body2",
                        children: (0, _helpers.formatMs)(applianceAd.durationMs)
                    })
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: 'Tracking',
        children: adBreak.trackingEvents?.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                p: 2,
                textAlign: 'center'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                children: "No registered tracking events."
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                        children: tableConfig.filter((c)=>c !== null).map(({ title }, ind, { length })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                sx: (0, _styles.styles).cell,
                                padding: ind === length - 1 ? 'none' : undefined,
                                "data-table-column": title,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnHeaderDefault.default), {
                                    title: title
                                })
                            }, ind))
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                    children: flattenedTrackingGroups.map((event, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                            hover: true,
                            children: tableConfig.filter((c)=>c !== null).map(({ getValue, props, title })=>/*#__PURE__*/ (0, _react.createElement)((0, _tableCellDefault.default), {
                                    ...props,
                                    "data-cell-name": `${title}-cell`,
                                    key: `${event.adCreativeId}-${title}`
                                }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    component: "div",
                                    variant: "body2",
                                    children: getValue(event, i)
                                })))
                        }, event.adCreativeId))
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../../../store":"5LXiG","../../../common/Form":"4Mui7","date-fns":"gelMX","common/api/v1/helpers":"6jovr","../../../common/Tooltip":"crjvg","@mui/material/Box":"c4QkF","../styles":"9xVZT","@mui/material/Typography":"6NtGx","@mui/material/Stack":"6thYv","@mui/icons-material/CheckCircle":"crtKq","@mui/material/Table":"k4r1H","@mui/material/TableRow":"bLA0R","@mui/material/TableHead":"9yKSO","@mui/material/TableCell":"6WlPV","../../../common/Table/ColumnHeader":"5BE9S","@mui/material/TableBody":"2jHBQ","@mui/icons-material/FiberManualRecord":"bvXIN","../../../common/Link":"l3o6V","../../../common/Thumbnail":"5Q8KF","@mui/icons-material/Error":"4XfdO","@mui/material/Chip":"5cK8z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7R9a8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuditSection", ()=>AuditSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _form = require("../../../common/Form");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _table = require("../../../common/Table");
var _table1 = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table1);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _reactRedux = require("react-redux");
var _util = require("common/util");
var _adAuditActions = require("../../../../redux/actions/adAuditActions");
var _types = require("common/types");
var _dateFns = require("date-fns");
var _helpers = require("common/api/v1/helpers");
var _error = require("@mui/icons-material/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _utils = require("../../../../utils");
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _collapse = require("@mui/material/Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _keyboardArrowDown = require("@mui/icons-material/KeyboardArrowDown");
var _keyboardArrowDownDefault = parcelHelpers.interopDefault(_keyboardArrowDown);
var _keyboardArrowRight = require("@mui/icons-material/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _reactSyntaxHighlighter = require("react-syntax-highlighter");
var _code = require("../../../../themes/code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _recursiveDataSet = require("../../../common/RecursiveDataSet");
var _link = require("../../../common/Link");
var _tooltip = require("../../../common/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _adInsertion = require("common/adInsertion");
const AuditSection = ({ dispatch, adBreak, adCreatives, adPod, adServer, refreshTrigger })=>{
    const { adAudit, total } = (0, _reactRedux.useSelector)(({ adAuditReducer })=>({
            adAudit: adAuditReducer.adAudit,
            total: adAuditReducer.total
        }), (0, _util.equals));
    const [searchParams, setSearchParams] = (0, _react.useState)((0, _utils.withDefaultPagination)({
        rowsPerPage: '30'
    }));
    const [expandedRows, setExpandedRows] = (0, _react.useState)(new Set());
    const [expandedRawJson, setExpandedRawJson] = (0, _react.useState)(new Set());
    (0, _react.useEffect)(()=>{
        dispatch((0, _adAuditActions.getAdAudit)({
            ...searchParams,
            adBreakId: adBreak.id
        }));
    }, [
        dispatch,
        searchParams,
        adBreak.id,
        refreshTrigger
    ]);
    (0, _react.useEffect)(()=>{
        setExpandedRows(new Set());
        setExpandedRawJson(new Set());
    }, [
        searchParams.pageNumber
    ]);
    const handleExpandClick = (rowIdx)=>{
        setExpandedRows((prev)=>{
            const next = new Set(prev);
            next.has(rowIdx) ? next.delete(rowIdx) : next.add(rowIdx);
            return next;
        });
    };
    const handleRawJsonExpandClick = (rowIdx)=>{
        setExpandedRawJson((prev)=>{
            const next = new Set(prev);
            next.has(rowIdx) ? next.delete(rowIdx) : next.add(rowIdx);
            return next;
        });
    };
    const getAdCreative = (creativeId)=>{
        return adCreatives.find((creative)=>creative.id === creativeId);
    };
    const getAdPod = ()=>{
        return adPod;
    };
    const getAdServerById = ()=>{
        return adServer;
    };
    const isEntityObject = (entity)=>{
        if (!entity) return false;
        try {
            const parsed = JSON.parse(entity);
            return typeof parsed === 'object' && parsed !== null;
        } catch  {
            return false;
        }
    };
    const tableConfig = [
        {
            title: '',
            getValue: (adAudit, i)=>{
                if (!adAudit.entity && !adAudit.message) return null;
                const enrichedEntity = enrichEntity(adAudit, getAdCreative, getAdPod, getAdServerById);
                if (!enrichedEntity) return null;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                    size: "small",
                    onClick: (e)=>{
                        e.stopPropagation();
                        handleExpandClick(i);
                    },
                    "aria-label": "expand row",
                    // Add custom styling to make it more compact
                    sx: {
                        padding: '2px',
                        margin: '-6px'
                    },
                    children: expandedRows.has(i) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowDownDefault.default), {
                        fontSize: "small"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowRightDefault.default), {
                        fontSize: "small"
                    })
                });
            },
            props: {
                sx: {
                    width: 36,
                    padding: 'none'
                },
                align: 'center'
            }
        },
        {
            title: 'status',
            getValue: statusFromAudit,
            props: {
                sx: {
                    width: '30px'
                }
            }
        },
        {
            title: 'entityType',
            getValue: (adAudit)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "div",
                    variant: "body2",
                    "data-cell-name": "entityType-cell",
                    children: (0, _capitalizeDefault.default)(entityTypeToNoun(adAudit.entityType))
                });
            }
        },
        {
            title: 'message',
            getValue: readableFromAudit
        },
        {
            title: 'context',
            getValue: (adAudit)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "div",
                    variant: "body2",
                    sx: {
                        maxWidth: '30vw',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    },
                    children: adAudit.message
                }),
            props: {
                sx: {
                    maxWidth: '32vw'
                }
            }
        },
        {
            title: 'component',
            getValue: (adAudit)=>adAudit.component
        },
        {
            title: 'timestamp',
            getValue: (adAudit)=>(0, _dateFns.format)(adAudit.timestamp, (0, _helpers.DATE_FORMAT_LONG))
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Paper), {
        title: 'Audit',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
            direction: 'column',
            sx: {
                height: '50vh',
                flexGrow: 1,
                display: 'flex'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: {
                        flexGrow: 1,
                        overflowY: 'auto',
                        borderRadius: '4px'
                    },
                    children: adAudit?.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            p: 2,
                            textAlign: 'center'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            children: "No audit events."
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                        size: "small",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                            children: adAudit.map((adAudit, i)=>{
                                const enrichedEntity = enrichEntity(adAudit, getAdCreative, getAdPod, getAdServerById);
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                            hover: true,
                                            children: tableConfig.filter((c)=>c !== null).map(({ getValue, props, title })=>/*#__PURE__*/ (0, _react.createElement)((0, _tableCellDefault.default), {
                                                    ...props,
                                                    "data-cell-name": `${title}-cell`,
                                                    key: `${i}-${title}`
                                                }, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                    component: "div",
                                                    variant: "body2",
                                                    children: getValue(adAudit, i)
                                                })))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                colSpan: tableConfig.length,
                                                sx: {
                                                    p: 0,
                                                    border: 0
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
                                                    in: expandedRows.has(i),
                                                    timeout: "auto",
                                                    unmountOnExit: true,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                                        sx: {
                                                            p: 2
                                                        },
                                                        children: [
                                                            enrichedEntity && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recursiveDataSet.RecursiveDataSet), {
                                                                object: enrichedEntity,
                                                                sentenceCase: true
                                                            }),
                                                            isEntityObject(adAudit.entity) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                                                        sx: {
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            cursor: 'pointer',
                                                                            mt: 2,
                                                                            ml: -1,
                                                                            borderRadius: 1
                                                                        },
                                                                        onClick: ()=>handleRawJsonExpandClick(i),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                                                                size: "small",
                                                                                "aria-label": "expand raw json",
                                                                                sx: {
                                                                                    padding: '2px',
                                                                                    marginRight: '4px'
                                                                                },
                                                                                children: expandedRawJson.has(i) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowDownDefault.default), {
                                                                                    fontSize: "small"
                                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowRightDefault.default), {
                                                                                    fontSize: "small"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                                                                variant: "body1",
                                                                                children: "View raw (JSON)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
                                                                        in: expandedRawJson.has(i),
                                                                        timeout: "auto",
                                                                        unmountOnExit: true,
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                                            sx: {},
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSyntaxHighlighter.Prism), {
                                                                                language: "json",
                                                                                style: (0, _codeDefault.default),
                                                                                lineProps: {
                                                                                    style: {
                                                                                        wordBreak: 'break-all',
                                                                                        whiteSpace: 'pre-wrap'
                                                                                    }
                                                                                },
                                                                                codeTagProps: {
                                                                                    style: {
                                                                                        backgroundColor: 'transparent'
                                                                                    }
                                                                                },
                                                                                wrapLines: true,
                                                                                customStyle: {
                                                                                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                                                                    border: '1px solid transparent',
                                                                                    maxWidth: '100%'
                                                                                },
                                                                                children: formatEntity(adAudit.entity)
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }, i);
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        flexShrink: 0,
                        mt: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Pagination), {
                            id: "ad-audit-pagination",
                            total: total,
                            page: searchParams.pageNumber || '0',
                            perPage: searchParams.rowsPerPage || '30',
                            changePageCallback: (page)=>{
                                setSearchParams((prev)=>({
                                        ...prev,
                                        pageNumber: page
                                    }));
                            },
                            changeRowsPerPageCallback: (rowsPerPage)=>{
                                setSearchParams((prev)=>({
                                        ...prev,
                                        pageNumber: '0',
                                        rowsPerPage
                                    }));
                            }
                        })
                    ]
                })
            ]
        })
    });
};
const statusFromAudit = (adAudit)=>{
    switch(adAudit.status){
        case 'start':
            return null;
        case 'finish':
            // If "finish" but result is "fail" or "warning", it means the operation probably led to extra work, such as transcoding
            if (adAudit.result === 'fail' || adAudit.result === 'warning') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                    sx: {
                        color: 'white',
                        ml: 0.5
                    }
                })
            });
            return null;
        case 'fail':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                    sx: {
                        color: 'error.main'
                    }
                })
            });
        case 'warning':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                    sx: {
                        color: 'warning.main'
                    }
                })
            });
        default:
            return null;
    }
};
/**
 * Enriches the entity of AdAuditLogMessage with additional properties, such as links instead of IDs for certain
 * entity types. It is used before displaying the audit log to provide more context.
 *
 * Returns undefined if the entity is empty or does not match any known entity type.
 */ const enrichEntity = (adAuditIn, getCreative, getPod, getAdServer)=>{
    if (!adAuditIn.entity) return adAuditIn.entity;
    const tryJson = (value)=>{
        try {
            return JSON.parse(value);
        } catch (e) {
            return {
                context: value
            };
        }
    };
    let adAuditOut = tryJson(adAuditIn.entity);
    if (adAuditIn.message) adAuditOut = {
        message: adAuditIn.message,
        ...adAuditOut
    };
    // Ad break ID does not make sense to show here, since we are in the ad break already
    delete adAuditOut.adBreakId;
    // Stream ID and channel ID are internal IDs
    delete adAuditOut.streamId;
    delete adAuditOut.channelId;
    switch(adAuditIn.entityType){
        case (0, _types.AdAuditEntity).impressionErrorReport:
        case (0, _types.AdAuditEntity).impressionReport:
            {
                const splits = (0, _adInsertion.splitPlaylistAdId)(adAuditOut.creativeId);
                if (splits) {
                    const { adServerId, isBuiltIn, creativeId } = splits;
                    if (isBuiltIn) {
                        const creative = getCreative(creativeId);
                        adAuditOut.creative = creative ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: `/adInsertion/adCreatives/update/${creativeId}`,
                            underline: "hover",
                            children: creative.name
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                            variant: "text",
                            width: 100,
                            height: 20
                        });
                        adAuditOut.adServer = 'Built-in';
                        delete adAuditOut.creativeId;
                    } else {
                        const adServer = getAdServer(adServerId);
                        adAuditOut.creativeId = creativeId;
                        adAuditOut.adServer = adServer ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: `/adInsertion/adServers/update/${adServerId}`,
                            underline: "hover",
                            children: adServer.name
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                            variant: "text",
                            width: 100,
                            height: 20
                        });
                    }
                    adAuditOut.timestamp = (0, _dateFns.format)(adAuditOut.timestamp, (0, _helpers.DATE_FORMAT_LONG));
                    delete adAuditOut.url;
                }
                break;
            }
        case (0, _types.AdAuditEntity).adToTranscode:
            switch(adAuditIn.method){
                case (0, _types.AdAuditMethod).receive:
                    adAuditOut.duration = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: `${adAuditOut.durationMs} ms`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "body2",
                            children: (0, _helpers.formatMs)(adAuditOut.durationMs)
                        })
                    });
                    delete adAuditOut.durationMs;
                    delete adAuditOut.errorUrl;
                    break;
                case (0, _types.AdAuditMethod).parse:
                    adAuditOut.fileName = adAuditOut.context;
                    delete adAuditOut.context;
                    break;
            }
            break;
        case (0, _types.AdAuditEntity).mezzanineFile:
        case (0, _types.AdAuditEntity).transcodedFile:
            switch(adAuditIn.method){
                case (0, _types.AdAuditMethod).transcode:
                case (0, _types.AdAuditMethod).upload:
                case (0, _types.AdAuditMethod).download:
                case (0, _types.AdAuditMethod).exists:
                case (0, _types.AdAuditMethod).retentionDelete:
                    adAuditOut.fileName = adAuditOut.context;
                    delete adAuditOut.context;
                    break;
            }
            break;
        case (0, _types.AdAuditEntity).scte35Notification:
            switch(adAuditIn.method){
                case 'receive':
                    adAuditOut.duration = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: `${adAuditOut.durationMs} ms`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "body2",
                            children: (0, _helpers.formatMs)(adAuditOut.durationMs)
                        })
                    });
                    adAuditOut.startsAt = (0, _dateFns.format)(adAuditOut.startsAt, (0, _helpers.DATE_FORMAT_LONG));
                    delete adAuditOut.durationMs;
                    break;
            }
            break;
        case (0, _types.AdAuditEntity).vast:
            switch(adAuditIn.method){
                case (0, _types.AdAuditMethod).parse:
                case (0, _types.AdAuditMethod).download:
                    {
                        const pod = getPod(adAuditOut.adPod);
                        adAuditOut.adPod = pod ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                            to: `/adInsertion/adPods/update/${pod.id}`,
                            underline: "hover",
                            children: pod.name
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                            variant: "text",
                            width: 100,
                            height: 20
                        });
                        delete adAuditOut.adPodId;
                        break;
                    }
            }
            break;
    }
    if (Object.keys(adAuditOut).length === 0) return undefined;
    return adAuditOut;
};
/**
 * Convert AdAuditLogMessage to a human-readable string.
 * For most audit entries, this is auto-generated based on the entity type and method in {@link readableFallback}.
 * But this method has some overrides for specific entity types to provide more meaningful messages.
 */ const readableFromAudit = (adAudit)=>{
    switch(adAudit.entityType){
        case (0, _types.AdAuditEntity).adBreak:
            switch(adAudit.method){
                case (0, _types.AdAuditMethod).scheduled:
                    return `Ad break scheduled`;
                case (0, _types.AdAuditMethod).canceled:
                    return `Ad break canceled`;
                case (0, _types.AdAuditMethod).aborted:
                    return `Ad break aborted`;
                case (0, _types.AdAuditMethod).play:
                    return `Ad break started`;
                case (0, _types.AdAuditMethod).end:
                    return `Ad break ended`;
            }
        case (0, _types.AdAuditEntity).applianceAd:
            switch(adAudit.method){
                case (0, _types.AdAuditMethod).play:
                    switch(adAudit.status){
                        case (0, _types.AdAuditStatus).start:
                            return `Started to play ad`;
                        case (0, _types.AdAuditStatus).finish:
                            return `Finished playing ad`;
                        case (0, _types.AdAuditStatus).fail:
                            return `Failed to play ad`;
                    }
            }
        case (0, _types.AdAuditEntity).transcodedFile:
            switch(adAudit.method){
                case (0, _types.AdAuditMethod).exists:
                    return `Checked S3 storage for transcoded file`;
            }
    }
    return readableFallback(adAudit);
};
const readableFallback = (adAudit)=>{
    const noun = entityTypeToNoun(adAudit.entityType);
    if (adAudit.status === (0, _types.AdAuditStatus).fail) {
        const verb = methodToInfinitive(adAudit.method);
        return `Failed to ${verb}`;
    }
    if (adAudit.status === (0, _types.AdAuditStatus).warning) {
        const verb = methodToPastTense(adAudit.method);
        return `${(0, _capitalizeDefault.default)(noun)} ${verb}`;
    }
    if (adAudit.status === (0, _types.AdAuditStatus).start) {
        const verb = methodToInfinitive(adAudit.method);
        return `Started to ${verb} ${noun}`;
    }
    const verb = methodToPastTense(adAudit.method);
    return `${(0, _capitalizeDefault.default)(verb)} ${noun}`;
};
const entityTypeToNoun = (entityType)=>{
    switch(entityType){
        case (0, _types.AdAuditEntity).impressionReport:
            return 'impression report';
        case (0, _types.AdAuditEntity).impressionErrorReport:
            return 'impression error report';
        case (0, _types.AdAuditEntity).vast:
            return 'VAST';
        case (0, _types.AdAuditEntity).scte35Notification:
            return 'SCTE-35 notification';
        case (0, _types.AdAuditEntity).applianceAdPlaylist:
            return 'appliance ad playlist';
        case (0, _types.AdAuditEntity).adToTranscode:
            return 'ad to transcode';
        case (0, _types.AdAuditEntity).transcodedFile:
            return 'transcoded file';
        case (0, _types.AdAuditEntity).mezzanineFile:
            return 'mezzanine file';
        case (0, _types.AdAuditEntity).applianceAd:
            return 'appliance ad';
        case (0, _types.AdAuditEntity).adBreak:
            return 'ad break';
        case (0, _types.AdAuditEntity).outputStream:
            return 'output stream';
        default:
            return 'unknown entity';
    }
};
const methodToPastTense = (method)=>{
    if (!method) return '';
    switch(method){
        case (0, _types.AdAuditMethod).receive:
            return 'received';
        case (0, _types.AdAuditMethod).download:
            return 'downloaded';
        case (0, _types.AdAuditMethod).upload:
            return 'uploaded';
        case (0, _types.AdAuditMethod).transcode:
            return 'transcoded';
        case (0, _types.AdAuditMethod).parse:
            return 'parsed';
        case (0, _types.AdAuditMethod).request:
            return 'requested';
        case (0, _types.AdAuditMethod).retentionDelete:
            return 'deleted';
        case (0, _types.AdAuditMethod).play:
            return 'played';
        case (0, _types.AdAuditMethod).end:
            return 'ended';
        case (0, _types.AdAuditMethod).scheduled:
            return 'scheduled';
        case (0, _types.AdAuditMethod).canceled:
            return 'canceled';
        case (0, _types.AdAuditMethod).aborted:
            return 'aborted';
        case (0, _types.AdAuditMethod).exists:
            return 'checked';
        default:
            return '';
    }
};
const methodToInfinitive = (method)=>{
    if (!method) return '';
    switch(method){
        case (0, _types.AdAuditMethod).receive:
            return 'receive';
        case (0, _types.AdAuditMethod).download:
            return 'download';
        case (0, _types.AdAuditMethod).upload:
            return 'upload';
        case (0, _types.AdAuditMethod).transcode:
            return 'transcode';
        case (0, _types.AdAuditMethod).parse:
            return 'parse';
        case (0, _types.AdAuditMethod).request:
            return 'request';
        case (0, _types.AdAuditMethod).retentionDelete:
            return 'delete';
        case (0, _types.AdAuditMethod).play:
            return 'play';
        case (0, _types.AdAuditMethod).end:
            return 'end';
        case (0, _types.AdAuditMethod).scheduled:
            return 'schedule';
        case (0, _types.AdAuditMethod).canceled:
            return 'cancel';
        case (0, _types.AdAuditMethod).aborted:
            return 'abort';
        case (0, _types.AdAuditMethod).exists:
            return 'check';
        default:
            return '';
    }
};
const formatEntity = (entity)=>{
    try {
        return JSON.stringify(JSON.parse(entity), null, 2);
    } catch (_) {
        return entity;
    }
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../../common/Form":"4Mui7","@mui/material/Box":"c4QkF","@mui/material/Typography":"6NtGx","../../../common/Table":"dt9lf","@mui/material/Table":"k4r1H","@mui/material/TableRow":"bLA0R","@mui/material/TableCell":"6WlPV","@mui/material/TableBody":"2jHBQ","react-redux":"l1pMU","common/util":"jV4UZ","../../../../redux/actions/adAuditActions":"ddShH","common/types":"gDFnw","date-fns":"gelMX","common/api/v1/helpers":"6jovr","@mui/icons-material/Error":"4XfdO","@mui/utils/capitalize":"5sWY4","@mui/material/Divider":"9Ul8c","../../../../utils":"342UB","@mui/material/Stack":"6thYv","@mui/material/Collapse":"c7nwP","@mui/icons-material/KeyboardArrowDown":"2TA6B","@mui/icons-material/KeyboardArrowRight":"d6UJH","@mui/material/IconButton":"488As","react-syntax-highlighter":"jg2jw","../../../../themes/code":"goW8x","../../../common/RecursiveDataSet":"itnYL","../../../common/Link":"l3o6V","../../../common/Tooltip":"crjvg","@mui/material/Skeleton":"6KYj8","common/adInsertion":"02Gqt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"02Gqt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.splitPlaylistAdId = void 0;
/**
 * An ad ID in a playlist is a composite ID of ad server ID and creative ID, separated by `::`.
 * This helper splits the ad ID into its components.
 */ const splitPlaylistAdId = (playlistAdId)=>{
    const separatorIndex = playlistAdId.indexOf('::');
    if (separatorIndex === -1) return undefined;
    const adServerId = playlistAdId.substring(0, separatorIndex);
    const creativeId = playlistAdId.substring(separatorIndex + 2);
    const isBuiltIn = adServerId === 'edge-built-in';
    return {
        adServerId,
        isBuiltIn,
        creativeId
    };
};
exports.splitPlaylistAdId = splitPlaylistAdId;

},{}],"fJaJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdServerList", ()=>AdServerList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _adServerActions = require("../../../redux/actions/adServerActions");
var _store = require("../../../store");
var _form = require("../../common/Form");
var _pendable = require("../../common/Pendable");
var _pendableDefault = parcelHelpers.interopDefault(_pendable);
var _table = require("../../common/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _link = require("../../common/Link");
var _deleteButton = require("../../common/DeleteButton");
var _utils = require("../../../utils");
var _reactAsyncHook = require("react-async-hook");
var _wrapper = require("../../common/Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
const { adServersApi } = (0, _store.Api);
const marginBetweenIconAndName = '12px';
const AdServerList = ()=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const routes = (0, _store.useRoutes)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const searchParams = (0, _utils.usePageParamsFiltered)();
    const { result, execute } = (0, _reactAsyncHook.useAsync)(()=>(0, _adServerActions.listAdServersHook)(searchParams, {
            dispatch,
            adServersApi
        }), [
        JSON.stringify(searchParams)
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wrapperDefault.default), {
        name: [
            'Ad Insertion',
            'Ad Servers'
        ],
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            onClick: ()=>navigate(routes.adServersNew()),
            children: "Add Ad Server"
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.GridItem), {
            lg: 12,
            xl: 12,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendableDefault.default), {
                pending: !result,
                children: result && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                    emptyMessageComponent: "No Ad Servers found",
                    data: result.items,
                    pagination: {
                        total: result.total,
                        useUrlSearchParams: true
                    },
                    config: [
                        {
                            title: 'name',
                            getValue: ({ name, id: adServersId })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        flex: 1
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                        underline: "hover",
                                        to: routes.adServersUpdate({
                                            id: adServersId
                                        }),
                                        style: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            flex: 1
                                        },
                                        muiStyle: {
                                            display: 'flex',
                                            flex: 1,
                                            gap: marginBetweenIconAndName
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                display: 'flex',
                                                flex: 1
                                            },
                                            children: name
                                        })
                                    })
                                })
                        },
                        {
                            getValue: ({ name, id: adServerId })=>adServerId && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteButton.DeleteButton), {
                                    callback: ()=>{
                                        dispatch((0, _adServerActions.deleteAdServer)(adServerId)).then(()=>{
                                            execute();
                                        });
                                    },
                                    confirmMessage: "Are you sure you want to delete this ad server?",
                                    name: name
                                }),
                            props: {
                                align: 'right',
                                noTypography: true
                            }
                        }
                    ]
                })
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react-redux":"l1pMU","react-router":"iaz4C","../../../redux/actions/adServerActions":"h89Of","../../../store":"5LXiG","../../common/Form":"4Mui7","../../common/Pendable":"gDN67","../../common/Table":"dt9lf","@mui/material/Box":"c4QkF","@mui/material/Button":"3qJY9","../../common/Link":"l3o6V","../../common/DeleteButton":"6bAes","../../../utils":"342UB","react-async-hook":"3D6Y9","../../common/Wrapper":"8oy7r","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7t0FU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeSwitcher", ()=>ThemeSwitcher);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("react-router");
var _cssBaseline = require("@mui/material/CssBaseline");
var _cssBaselineDefault = parcelHelpers.interopDefault(_cssBaseline);
var _styles = require("@mui/material/styles");
var _defaultDark = require("./themes/defaultDark");
var _defaultLight = require("./themes/defaultLight");
var _utils = require("./utils");
var _store = require("./store");
const ThemeSwitcher = ({ children })=>{
    const { pathname } = (0, _reactRouter.useLocation)();
    const routes = (0, _store.useRoutes)();
    const currentTheme = (0, _utils.getIsStreamManager)(pathname, routes) ? (0, _defaultLight.defaultThemeLight) : (0, _defaultDark.defaultThemeDark);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styles.ThemeProvider), {
        theme: currentTheme,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cssBaselineDefault.default), {
                enableColorScheme: true
            }),
            children
        ]
    });
};
exports.default = ThemeSwitcher;

},{"react/jsx-runtime":"1dlk8","react-router":"iaz4C","@mui/material/CssBaseline":"armer","@mui/material/styles":"2UrBk","./themes/defaultDark":"d8ZGE","./themes/defaultLight":"l3iN6","./utils":"342UB","./store":"5LXiG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d8ZGE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NimbraBlue", ()=>(0, _common.NimbraBlue));
parcelHelpers.export(exports, "NimbraGrey", ()=>(0, _common.NimbraGrey));
parcelHelpers.export(exports, "defaultThemeDark", ()=>defaultThemeDark);
var _merge = require("lodash/fp/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _styles = require("@mui/material/styles");
var _common = require("./common");
const darkThemeOptions = {
    palette: {
        mode: 'dark',
        background: {
            default: (0, _common.NimbraGrey)[1000],
            paper: (0, _common.NimbraGrey)[900]
        }
    },
    components: {
        MuiToolbar: {
            styleOverrides: {
                regular: {
                    backgroundColor: (0, _common.NimbraGrey)[1000],
                    color: '#ffffff'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                outlinedPrimary: {
                    color: '#ffffff'
                },
                outlinedSecondary: {
                    color: '#ffffff'
                }
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#ffffff'
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    // Use existing space for helper text like validation errors to prevent shifting content below field
                    marginTop: 0,
                    height: 0
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                popper: {
                    border: `1px solid ${(0, _common.NimbraGrey)[800]}`
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    border: `1px solid ${(0, _common.NimbraGrey)[800]}`
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none'
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    backgroundColor: (0, _common.NimbraGrey)[900]
                }
            }
        }
    }
};
const defaultThemeDark = (0, _styles.createTheme)((0, _mergeDefault.default)((0, _common.defaultCommon), darkThemeOptions));

},{"lodash/fp/merge":"ge9hu","@mui/material/styles":"2UrBk","./common":"e6yiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ge9hu":[function(require,module,exports,__globalThis) {
var convert = require("183e056d07055917"), func = convert('merge', require("1b9ce35a5f814d60"));
func.placeholder = require("e8649fabe7138821");
module.exports = func;

},{"183e056d07055917":"8yrvu","1b9ce35a5f814d60":"iHC1F","e8649fabe7138821":"6JeHm"}],"l3iN6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NimbraBlue", ()=>(0, _common.NimbraBlue));
parcelHelpers.export(exports, "NimbraGrey", ()=>(0, _common.NimbraGrey));
parcelHelpers.export(exports, "defaultThemeLight", ()=>defaultThemeLight);
var _merge = require("lodash/fp/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _styles = require("@mui/material/styles");
var _common = require("./common");
const lightThemeOptions = {
    palette: {
        mode: 'light',
        background: {
            default: '#F5F5F5',
            paper: '#E8E8E8'
        }
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: '#ffffff',
                    color: '#757575'
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                regular: {
                    backgroundColor: 'transparent',
                    color: '#000000'
                }
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#757575'
                }
            }
        }
    }
};
const defaultThemeLight = (0, _styles.createTheme)((0, _mergeDefault.default)((0, _common.defaultCommon), lightThemeOptions));

},{"lodash/fp/merge":"ge9hu","@mui/material/styles":"2UrBk","./common":"e6yiH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9AiUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEmptyImage", ()=>(0, _getEmptyImageJs.getEmptyImage));
parcelHelpers.export(exports, "NativeTypes", ()=>_nativeTypesJs);
parcelHelpers.export(exports, "HTML5Backend", ()=>HTML5Backend);
var _html5BackendImplJs = require("./HTML5BackendImpl.js");
var _nativeTypesJs = require("./NativeTypes.js");
var _getEmptyImageJs = require("./getEmptyImage.js");
const HTML5Backend = function createBackend(manager, context, options) {
    return new (0, _html5BackendImplJs.HTML5BackendImpl)(manager, context, options);
};

},{"./HTML5BackendImpl.js":"hnitg","./NativeTypes.js":false,"./getEmptyImage.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnitg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTML5BackendImpl", ()=>HTML5BackendImpl);
var _enterLeaveCounterJs = require("./EnterLeaveCounter.js");
var _indexJs = require("./NativeDragSources/index.js");
var _nativeTypesJs = require("./NativeTypes.js");
var _offsetUtilsJs = require("./OffsetUtils.js");
var _optionsReaderJs = require("./OptionsReader.js");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class HTML5BackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) return;
        if (root.__isReactDndBackendSetUp) throw new Error('Cannot have two HTML5 backends at the same time.');
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) return;
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 || ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId);
        const handleSelectStart = (e)=>this.handleSelectStart(e);
        node.setAttribute('draggable', 'true');
        node.addEventListener('dragstart', handleDragStart);
        node.addEventListener('selectstart', handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener('dragstart', handleDragStart);
            node.removeEventListener('selectstart', handleSelectStart);
            node.setAttribute('draggable', 'false');
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId);
        const handleDragOver = (e)=>this.handleDragOver(e, targetId);
        const handleDrop = (e)=>this.handleDrop(e, targetId);
        node.addEventListener('dragenter', handleDragEnter);
        node.addEventListener('dragover', handleDragOver);
        node.addEventListener('drop', handleDrop);
        return ()=>{
            node.removeEventListener('dragenter', handleDragEnter);
            node.removeEventListener('dragover', handleDragOver);
            node.removeEventListener('drop', handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) return;
        target.addEventListener('dragstart', this.handleTopDragStart);
        target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.addEventListener('dragend', this.handleTopDragEndCapture, true);
        target.addEventListener('dragenter', this.handleTopDragEnter);
        target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.addEventListener('dragover', this.handleTopDragOver);
        target.addEventListener('dragover', this.handleTopDragOverCapture, true);
        target.addEventListener('drop', this.handleTopDrop);
        target.addEventListener('drop', this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) return;
        target.removeEventListener('dragstart', this.handleTopDragStart);
        target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
        target.removeEventListener('dragenter', this.handleTopDragEnter);
        target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.removeEventListener('dragover', this.handleTopDragOver);
        target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
        target.removeEventListener('drop', this.handleTopDrop);
        target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return _objectSpread({
            dropEffect: this.altKeyPressed ? 'copy' : 'move'
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
        return 'copy';
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return _objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys(_nativeTypesJs).some((key)=>_nativeTypesJs[key] === itemType);
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = (0, _indexJs.createNativeDragSource)(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 || ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) return;
        if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && (0, _offsetUtilsJs.getNodeClientOffset)(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) return;
            this.actions.endDrag();
            if (this.currentNativeHandle) this.registry.removeSource(this.currentNativeHandle);
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) return;
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== 'undefined') this.hoverRafId = requestAnimationFrame(()=>{
                if (this.monitor.isDragging()) this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: this.lastClientOffset
                });
                this.hoverRafId = null;
            });
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== 'undefined') {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) return;
            const { dragStartSourceIds } = this;
            this.dragStartSourceIds = null;
            const clientOffset = (0, _offsetUtilsJs.getEventClientOffset)(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset
            });
            const { dataTransfer } = e;
            const nativeType = (0, _indexJs.matchNativeItemType)(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX, anchorY, offsetX, offsetY } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX,
                            anchorY
                        };
                        const offsetPoint = {
                            offsetX,
                            offsetY
                        };
                        const dragPreviewOffset = (0, _offsetUtilsJs.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData('application/json', {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(()=>this.actions.publishDragSource(), 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            this.actions.endDrag();
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) return;
            const { dataTransfer } = e;
            const nativeType = (0, _indexJs.matchNativeItemType)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, _offsetUtilsJs.getEventClientOffset)(e)
            });
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'none';
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = (0, _offsetUtilsJs.getEventClientOffset)(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            } else if (this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'none';
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) e.preventDefault();
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (this.isDraggingNativeItem()) setTimeout(()=>this.endDragNativeItem(), 0);
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            } else if ((0, _indexJs.matchNativeItemType)(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: (0, _offsetUtilsJs.getEventClientOffset)(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) this.endDragNativeItem();
            else if (this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== 'function') return;
            // Inputs and textareas should be selectable
            if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new (0, _optionsReaderJs.OptionsReader)(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, _enterLeaveCounterJs.EnterLeaveCounter)(this.isNodeInDocument);
    }
}

},{"./EnterLeaveCounter.js":"4m4uB","./NativeDragSources/index.js":"2oWu8","./NativeTypes.js":"EsY1b","./OffsetUtils.js":"bhd23","./OptionsReader.js":"eGkeC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4m4uB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnterLeaveCounter", ()=>EnterLeaveCounter);
var _jsUtilsJs = require("./utils/js_utils.js");
class EnterLeaveCounter {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
        this.entered = (0, _jsUtilsJs.union)(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = (0, _jsUtilsJs.without)(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}

},{"./utils/js_utils.js":"4bZFI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4bZFI":[function(require,module,exports,__globalThis) {
// cheap lodash replacements
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
/**
 * drop-in replacement for _.without
 */ parcelHelpers.export(exports, "without", ()=>without);
parcelHelpers.export(exports, "union", ()=>union);
function memoize(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function without(items, item) {
    return items.filter((i)=>i !== item);
}
function union(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item);
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key));
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2oWu8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNativeDragSource", ()=>createNativeDragSource);
parcelHelpers.export(exports, "matchNativeItemType", ()=>matchNativeItemType);
var _nativeDragSourceJs = require("./NativeDragSource.js");
var _nativeTypesConfigJs = require("./nativeTypesConfig.js");
function createNativeDragSource(type, dataTransfer) {
    const config = (0, _nativeTypesConfigJs.nativeTypesConfig)[type];
    if (!config) throw new Error(`native type ${type} has no configuration`);
    const result = new (0, _nativeDragSourceJs.NativeDragSource)(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function matchNativeItemType(dataTransfer) {
    if (!dataTransfer) return null;
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, _nativeTypesConfigJs.nativeTypesConfig)).filter((nativeItemType)=>{
        const typeConfig = (0, _nativeTypesConfigJs.nativeTypesConfig)[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) return false;
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1);
    })[0] || null;
}

},{"./NativeDragSource.js":"399d8","./nativeTypesConfig.js":"cnZgR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"399d8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeDragSource", ()=>NativeDragSource);
class NativeDragSource {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) newProperties[property] = {
                    value: propertyFn(dataTransfer, this.config.matchesTypes),
                    configurable: true,
                    enumerable: true
                };
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnZgR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nativeTypesConfig", ()=>nativeTypesConfig);
var _nativeTypesJs = require("../NativeTypes.js");
var _getDataFromDataTransferJs = require("./getDataFromDataTransfer.js");
const nativeTypesConfig = {
    [_nativeTypesJs.FILE]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files),
            items: (dataTransfer)=>dataTransfer.items,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Files'
        ]
    },
    [_nativeTypesJs.HTML]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>(0, _getDataFromDataTransferJs.getDataFromDataTransfer)(dataTransfer, matchesTypes, ''),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Html',
            'text/html'
        ]
    },
    [_nativeTypesJs.URL]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>(0, _getDataFromDataTransferJs.getDataFromDataTransfer)(dataTransfer, matchesTypes, '').split('\n'),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Url',
            'text/uri-list'
        ]
    },
    [_nativeTypesJs.TEXT]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>(0, _getDataFromDataTransferJs.getDataFromDataTransfer)(dataTransfer, matchesTypes, ''),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Text',
            'text/plain'
        ]
    }
};

},{"../NativeTypes.js":"EsY1b","./getDataFromDataTransfer.js":"3tZFb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"EsY1b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FILE", ()=>FILE);
parcelHelpers.export(exports, "URL", ()=>URL);
parcelHelpers.export(exports, "TEXT", ()=>TEXT);
parcelHelpers.export(exports, "HTML", ()=>HTML);
const FILE = '__NATIVE_FILE__';
const URL = '__NATIVE_URL__';
const TEXT = '__NATIVE_TEXT__';
const HTML = '__NATIVE_HTML__';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3tZFb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDataFromDataTransfer", ()=>getDataFromDataTransfer);
function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry), '');
    return result != null ? result : defaultValue;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bhd23":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNodeClientOffset", ()=>getNodeClientOffset);
parcelHelpers.export(exports, "getEventClientOffset", ()=>getEventClientOffset);
parcelHelpers.export(exports, "getDragPreviewOffset", ()=>getDragPreviewOffset);
var _browserDetectorJs = require("./BrowserDetector.js");
var _monotonicInterpolantJs = require("./MonotonicInterpolant.js");
const ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
    const el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    const { top, left } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function getEventClientOffset(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function isImageNode(node) {
    var ref;
    return node.nodeName === 'IMG' && ((0, _browserDetectorJs.isFirefox)() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ((0, _browserDetectorJs.isSafari)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth,
        dragPreviewHeight
    };
}
function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth, offsetHeight: sourceHeight } = sourceNode;
    const { anchorX, anchorY } = anchorPoint;
    const { dragPreviewWidth, dragPreviewHeight } = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new (0, _monotonicInterpolantJs.MonotonicInterpolant)([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ((0, _browserDetectorJs.isSafari)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new (0, _monotonicInterpolantJs.MonotonicInterpolant)([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX, offsetY } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}

},{"./BrowserDetector.js":"c5rkW","./MonotonicInterpolant.js":"2E7ue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5rkW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFirefox", ()=>isFirefox);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
var _jsUtilsJs = require("./utils/js_utils.js");
const isFirefox = (0, _jsUtilsJs.memoize)(()=>/firefox/i.test(navigator.userAgent));
const isSafari = (0, _jsUtilsJs.memoize)(()=>Boolean(window.safari));

},{"./utils/js_utils.js":"4bZFI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2E7ue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonotonicInterpolant", ()=>MonotonicInterpolant);
class MonotonicInterpolant {
    interpolate(x) {
        const { xs, ys, c1s, c2s, c3s } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) return ys[i];
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) low = mid + 1;
            else if (xHere > x) high = mid - 1;
            else return ys[mid];
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++)indexes.push(i);
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1);
        // Get consecutive differences and slopes
        const dys = [];
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGkeC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OptionsReader", ()=>OptionsReader);
class OptionsReader {
    get window() {
        if (this.globalContext) return this.globalContext;
        else if (typeof window !== 'undefined') return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) return this.globalContext.document;
        else if (this.window) return this.window.document;
        else return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}]},["9ZVxM","EdkZp"], "EdkZp", "parcelRequire94c2")

//# sourceMappingURL=index.7d76a13e.js.map
